
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("h1Y8a", function(module, exports) {
/**
 * @generated SignedSource<<935fb30c6a6b90abf5dd217fcfe9a8f1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c51db01a6bc02cc7$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "css"
        },
        {
            "kind": "ScalarField",
            "name": "data"
        },
        {
            "kind": "ScalarField",
            "name": "js"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "FullPageEditorComponentReadFragmentWithAppKey",
        "selections": [
            {
                "concreteType": "Macro",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "macroId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "contentId"
                    },
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "mode",
                                "value": "EDITOR"
                            }
                        ],
                        "concreteType": "RenderedMacro",
                        "kind": "LinkedField",
                        "name": "renderedMacro",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "appKey"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "macroRenderedRepresentation"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "macroBodyStorage"
                            },
                            {
                                "concreteType": "WebResourceDependenciesV2",
                                "kind": "LinkedField",
                                "name": "webResource",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "contexts"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "keys"
                                    },
                                    {
                                        "concreteType": "SuperBatchWebResourcesV2",
                                        "kind": "LinkedField",
                                        "name": "superbatch",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "metatags"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "WebResourceTagsV2",
                                        "kind": "LinkedField",
                                        "name": "tags",
                                        "plural": false,
                                        "selections": v0 /*: any*/ 
                                    },
                                    {
                                        "concreteType": "WebResourceUrisV2",
                                        "kind": "LinkedField",
                                        "name": "uris",
                                        "plural": false,
                                        "selections": v0 /*: any*/ 
                                    }
                                ]
                            },
                            {
                                "concreteType": "EmbeddedMediaTokenV2",
                                "kind": "LinkedField",
                                "name": "mediaToken",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "token"
                                    }
                                ]
                            }
                        ],
                        "storageKey": "renderedMacro(mode:\"EDITOR\")"
                    }
                ]
            },
            {
                "concreteType": "PageInfoV2",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "endCursor"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                    }
                ]
            }
        ],
        "type": "MacroConnection"
    };
}();
$c51db01a6bc02cc7$var$node.hash = "408702134304d89a181c7bc6576d7cb4";
var $c51db01a6bc02cc7$export$2e2bcd8739ae039 = $c51db01a6bc02cc7$var$node;



var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $dOBRD = parcelRequire("dOBRD");


var $3u5lg = parcelRequire("3u5lg");


var $kwzZh = parcelRequire("kwzZh");


var $eFgM7 = parcelRequire("eFgM7");


var $3d3WW = parcelRequire("3d3WW");


var $9DHhW = parcelRequire("9DHhW");


var $3k5Tv = parcelRequire("3k5Tv");


var $bdpeX = parcelRequire("bdpeX");


var $fqVYq = parcelRequire("fqVYq");


var $6H0Pg = parcelRequire("6H0Pg");


var $jb2gB = parcelRequire("jb2gB");


var $hRcC4 = parcelRequire("hRcC4");


var $dPoYT = parcelRequire("dPoYT");


var $gzMZq = parcelRequire("gzMZq");


var $4tOXV = parcelRequire("4tOXV");


var $3mVfX = parcelRequire("3mVfX");


var $5fMeR = parcelRequire("5fMeR");


var $bDgLe = parcelRequire("bDgLe");





var $dPJCf = parcelRequire("dPJCf");


var $lJDEI = parcelRequire("lJDEI");





var $8aF6s = parcelRequire("8aF6s");


var $3jwuS = parcelRequire("3jwuS");


var $hPTbh = parcelRequire("hPTbh");


var $bUH8D = parcelRequire("bUH8D");


var $jxXkP = parcelRequire("jxXkP");

const $59950bb13ffc10fc$export$88533b05a0c6a0b9 = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { contentId: contentId, spaceId: spaceId, spaceKey: spaceKey, editorAPIRef: editorAPIRef } = t0;
    const { fireButtonClickedAnalytic: fireButtonClickedAnalytic } = (0, $jxXkP.useSnippetAnalytics)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    let t1;
    if ($[0] !== contentId || $[1] !== editorAPIRef || $[2] !== fireButtonClickedAnalytic || $[3] !== isLivePage || $[4] !== showModal || $[5] !== spaceId || $[6] !== spaceKey) {
        t1 = (origin)=>{
            const editorAPI = editorAPIRef?.current;
            if (!editorAPI) return;
            const actions = editorAPI.selectionExtension?.actions;
            const document = actions?.getDocumentFromSelection?.();
            const docAdf = document?.selectedNodeAdf;
            const adfContent = docAdf?.content?.filter($59950bb13ffc10fc$var$_temp);
            if (!adfContent || adfContent.length === 0) return;
            fireButtonClickedAnalytic((0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).CREATE_SNIPPET, {
                origin: origin,
                pageMode: isLivePage ? (0, $hPTbh.ANALYTICS_PAGE_MODE).LIVE : (0, $hPTbh.ANALYTICS_PAGE_MODE).EDIT,
                selectionLength: JSON.stringify(adfContent)?.length
            });
            showModal((0, $bUH8D.CreateSnippetModal), {
                adf: docAdf,
                contentId: contentId,
                spaceId: spaceId,
                spaceKey: spaceKey,
                editorAPI: editorAPI,
                analyticsOrigin: origin
            });
        };
        $[0] = contentId;
        $[1] = editorAPIRef;
        $[2] = fireButtonClickedAnalytic;
        $[3] = isLivePage;
        $[4] = showModal;
        $[5] = spaceId;
        $[6] = spaceKey;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
};
function $59950bb13ffc10fc$var$_temp(content) {
    return content !== undefined;
}



var $cYuYM = parcelRequire("cYuYM");





var $8i6M6 = parcelRequire("8i6M6");


var $dm1IX = parcelRequire("dm1IX");


var $ivert = parcelRequire("ivert");


var $gDx2k = parcelRequire("gDx2k");


var $hAgam = parcelRequire("hAgam");


var $eYo03 = parcelRequire("eYo03");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");




const $3e829d70fd4a50e0$var$messages = (0, $kSwu1.defineMessages)({
    blockTemplates: {
        id: "snippets.blockTemplates",
        defaultMessage: "Block templates"
    },
    createBlockTemplate: {
        id: "snippets.createBlockTemplate",
        defaultMessage: "Create block template"
    },
    browseTemplates: {
        id: "snippets.browseTemplates",
        defaultMessage: "Browse templates"
    },
    createBlockTemplateMenuItem: {
        id: "snippets.createBlockTemplateMenuItem",
        defaultMessage: "Save block template"
    },
    browseTemplatesMenuItem: {
        id: "snippets.browseTemplatesMenuItem",
        defaultMessage: "Browse all templates"
    },
    createBlockTemplateLozenge: {
        id: "snippets.createBlockTemplateLozenge",
        defaultMessage: "New"
    }
});
const $3e829d70fd4a50e0$var$isAgentManagedBlockMenuTrigger = (context)=>{
    return context?.blockMenuTriggerExtensionKey === (0, $eYo03.AGENT_MANAGED_EXTENSION_KEY);
};
const $3e829d70fd4a50e0$export$be35007b21bd127c = ({ formatMessage: formatMessage, onCreateSnippet: onCreateSnippet, onOpenTemplatePanel: onOpenTemplatePanel })=>{
    if (!(0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false)) return [];
    const toolbarConfiguration = {
        getMenuItems: ()=>{
            return [
                {
                    label: formatMessage($3e829d70fd4a50e0$var$messages.createBlockTemplate),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($ivert))),
                    onClick: ()=>onCreateSnippet((0, $hPTbh.ANALYTICS_ORIGIN).CONTEXTUAL_TOOLBAR)
                }
            ];
        }
    };
    /**
   * placement: 'featured' allows the button to show up on the top level of the
   * block menu, instead of under the Turn Into -> Create subsection
   */ const blockMenuConfiguration = {
        ...(0, $9wGTI.fg)('platform_editor_block_menu_v2_patch_2') ? {
            placement: 'featured-section',
            sectionKey: (0, $8i6M6.BLOCK_ACTIONS_TEMPLATE_SECTION).key
        } : {
            placement: 'featured'
        },
        getMenuItems: (context)=>{
            if ($3e829d70fd4a50e0$var$isAgentManagedBlockMenuTrigger(context)) return [];
            if ((0, $9wGTI.fg)('platform_editor_block_menu_v2_patch_2')) return [
                {
                    key: 'block-templates',
                    label: formatMessage($3e829d70fd4a50e0$var$messages.blockTemplates),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($ivert))),
                    lozenge: {
                        label: formatMessage($3e829d70fd4a50e0$var$messages.createBlockTemplateLozenge)
                    },
                    getMenuItems: ()=>[
                            {
                                key: 'create-block-template',
                                label: formatMessage($3e829d70fd4a50e0$var$messages.createBlockTemplateMenuItem),
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($dm1IX))),
                                onClick: ()=>onCreateSnippet((0, $hPTbh.ANALYTICS_ORIGIN).BLOCK_MENU)
                            },
                            {
                                key: 'browse-templates',
                                label: formatMessage($3e829d70fd4a50e0$var$messages.browseTemplatesMenuItem),
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($hAgam))),
                                onClick: onOpenTemplatePanel
                            }
                        ]
                }
            ];
            return [
                {
                    key: 'block-templates',
                    label: formatMessage($3e829d70fd4a50e0$var$messages.blockTemplates),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($ivert))),
                    getMenuItems: ()=>[
                            {
                                key: 'create-block-template',
                                label: formatMessage($3e829d70fd4a50e0$var$messages.createBlockTemplate),
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($ivert))),
                                onClick: ()=>onCreateSnippet((0, $hPTbh.ANALYTICS_ORIGIN).BLOCK_MENU)
                            },
                            {
                                key: 'browse-templates',
                                label: formatMessage($3e829d70fd4a50e0$var$messages.browseTemplates),
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($gDx2k))),
                                onClick: onOpenTemplatePanel
                            }
                        ]
                }
            ];
        }
    };
    return [
        {
            key: 'create-snippet',
            source: 'first-party',
            inlineToolbar: toolbarConfiguration,
            blockMenu: blockMenuConfiguration
        }
    ];
};


const $0e1c17ea1b1a2ab6$export$94cce102debd6a0e = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { contentId: contentId, spaceId: spaceId, spaceKey: spaceKey, editorAPIRef: editorAPIRef } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const isCreateEnabled = (0, $cYuYM.useIsSnippetCreateEnabled)();
    let t1;
    if ($[0] !== contentId || $[1] !== editorAPIRef || $[2] !== spaceId || $[3] !== spaceKey) {
        t1 = {
            contentId: contentId,
            spaceId: spaceId,
            spaceKey: spaceKey,
            editorAPIRef: editorAPIRef
        };
        $[0] = contentId;
        $[1] = editorAPIRef;
        $[2] = spaceId;
        $[3] = spaceKey;
        $[4] = t1;
    } else t1 = $[4];
    const handleCreateSnippet = (0, $59950bb13ffc10fc$export$88533b05a0c6a0b9)(t1);
    let t2;
    if ($[5] !== setQueryParams) {
        t2 = ()=>{
            (0, $lJDEI.setInEditorTemplatesPanelQueryParam)(setQueryParams, (0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_KEEP_OPEN), (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_BLOCK));
        };
        $[5] = setQueryParams;
        $[6] = t2;
    } else t2 = $[6];
    const handleOpenTemplatePanel = t2;
    if (!isCreateEnabled) {
        let t3;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = [];
            $[7] = t3;
        } else t3 = $[7];
        return t3;
    }
    let t3;
    if ($[8] !== formatMessage || $[9] !== handleCreateSnippet || $[10] !== handleOpenTemplatePanel) {
        t3 = (0, $3e829d70fd4a50e0$export$be35007b21bd127c)({
            formatMessage: formatMessage,
            onCreateSnippet: handleCreateSnippet,
            onOpenTemplatePanel: handleOpenTemplatePanel
        });
        $[8] = formatMessage;
        $[9] = handleCreateSnippet;
        $[10] = handleOpenTemplatePanel;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
};












var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");





var $dZUkS = parcelRequire("dZUkS");


var $b5pIV = parcelRequire("b5pIV");

const $cc1bbf004a9546e5$export$93b2b3f00466b2a0 = (editorPresetAPI, collabEditInitialized)=>{
    const $ = (0, $bDgLe.c)(9);
    const insertSnippet = (0, $b5pIV.useInsertSnippet)(editorPresetAPI);
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const hasInsertedRef = (0, $cozmU.useRef)(false);
    const { snippets: snippets, isLoaded: isLoaded } = (0, $dZUkS.useSnippetsState)();
    let t0;
    let t1;
    if ($[0] !== collabEditInitialized || $[1] !== editorPresetAPI || $[2] !== getQueryParams || $[3] !== insertSnippet || $[4] !== isLoaded || $[5] !== setQueryParams || $[6] !== snippets) {
        t0 = ()=>{
            if (!(0, $6mKj3.expVal)("platform_editor_blocks_conf", "isEnabled", false)) return;
            const insertSnippetId = (0, $c3Qwv.getSingleParam)(getQueryParams(), "insertSnippetId");
            if (!insertSnippetId || !editorPresetAPI || !collabEditInitialized || !isLoaded || hasInsertedRef.current) return;
            const snippet = snippets.find((s)=>s.snippetId === insertSnippetId);
            if (!snippet) return;
            const result = insertSnippet(snippet);
            if (result.status !== "not-ready") {
                hasInsertedRef.current = true;
                setQueryParams({
                    insertSnippetId: null
                }, true);
            }
        };
        t1 = [
            editorPresetAPI,
            collabEditInitialized,
            isLoaded,
            snippets,
            getQueryParams,
            setQueryParams,
            insertSnippet
        ];
        $[0] = collabEditInitialized;
        $[1] = editorPresetAPI;
        $[2] = getQueryParams;
        $[3] = insertSnippet;
        $[4] = isLoaded;
        $[5] = setQueryParams;
        $[6] = snippets;
        $[7] = t0;
        $[8] = t1;
    } else {
        t0 = $[7];
        t1 = $[8];
    }
    (0, $cozmU.useEffect)(t0, t1);
};





var $dLc9m = parcelRequire("dLc9m");




var $fNzRA = parcelRequire("fNzRA");


var $9jl6v = parcelRequire("9jl6v");


var $8SCD6 = parcelRequire("8SCD6");


var $fIKxq = parcelRequire("fIKxq");


var $5vi32 = parcelRequire("5vi32");





var $jmjWc = parcelRequire("jmjWc");


const $2543a86ff2c253ce$export$ac98ab11e0df3bec = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "dqKn1",
    name: "AgenticEditorBannerLoader",
    loader: async ()=>(await (parcelRequire("3UatB"))).AgenticEditorBanner
});



var $iNYtG = parcelRequire("iNYtG");


var $euL71 = parcelRequire("euL71");


var $bQm3c = parcelRequire("bQm3c");

function $9747c27e818a1963$export$a9e17b56b1093c49() {
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPaidEdition = edition !== (0, $euL71.ConfluenceEdition).FREE;
    // Must be paid edition
    if (!isPaidEdition) return false;
    return true;
}






const $c201c0cab0d4ebd5$export$8fed2fc2ec67a868 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Fw4tb",
    name: "EditorInlineReactionsPubSubHandler",
    loader: async ()=>(await (parcelRequire("5Xv1X"))).EditorInlineReactionsPubSubHandler
});






var $2JYae = parcelRequire("2JYae");


var $8i27m = parcelRequire("8i27m");


var $gGHFp = parcelRequire("gGHFp");


var $lfmjq = parcelRequire("lfmjq");


var $ecUYt = parcelRequire("ecUYt");


var $hd53J = parcelRequire("hd53J");


var $NYiei = parcelRequire("NYiei");


var $8S5Nq = parcelRequire("8S5Nq");


var $iz4WO = parcelRequire("iz4WO");


var $jOYfu = parcelRequire("jOYfu");


var $jXhAV = parcelRequire("jXhAV");


var $fSC8h = parcelRequire("fSC8h");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $3d5UI = parcelRequire("3d5UI");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");

var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $iWI3x = parcelRequire("iWI3x");


var $6OEkb = parcelRequire("6OEkb");


var $bRTjQ = parcelRequire("bRTjQ");


var $foQ4a = parcelRequire("foQ4a");





var $7mpOv = parcelRequire("7mpOv");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $7aRa9 = parcelRequire("7aRa9");


var $inDu6 = parcelRequire("inDu6");


var $55fM8 = parcelRequire("55fM8");





var $1KOhB = parcelRequire("1KOhB");


var $hYoU4 = parcelRequire("hYoU4");

const $f9dc71ade1ee2d5f$export$9745d8c24b40881d = /*#__PURE__*/ (0, $cozmU.createContext)({
    isSaving: false,
    savedTime: new Date()
});
const $f9dc71ade1ee2d5f$export$df7407750199bb6d = /*#__PURE__*/ (0, $cozmU.createContext)({
    triggerSaveIndicator: ()=>{}
});
const $f9dc71ade1ee2d5f$var$DEBOUNCE_SAVE_PERIOD = 1200;
const $f9dc71ade1ee2d5f$var$COMMIT_STATUS_DEBOUNCE = 500;
const $f9dc71ade1ee2d5f$var$NCS_POLLING_INTERVAL = 500;
const $f9dc71ade1ee2d5f$export$b5e4a2fe6178c584 = ({ editorApi: editorApi, children: children })=>{
    const [isSaving, setIsSaving] = (0, $cozmU.useState)(false);
    const [savedTime, setSavedTime] = (0, $cozmU.useState)(new Date());
    const saveAttemptCallbackId = (0, $cozmU.useRef)(0);
    const saveCompleteCallbackId = (0, $cozmU.useRef)(0);
    const pollIntervalId = (0, $cozmU.useRef)(0);
    const [{ collabEditProvider: collabEditProvider }] = (0, $hYoU4.useNativeCollabState)();
    const previousBodyChangeTimeRef = (0, $cozmU.useRef)(undefined);
    // These window functions are used here as performance efficient callback throttlers
    // requestIdleCallback is not supported by all browsers, hence fallback to requestAnimationFrame
    const throttledCallback = window.requestIdleCallback || window.requestAnimationFrame;
    const cancelThrottle = (0, $cozmU.useCallback)((id)=>{
        if (throttledCallback === window.requestIdleCallback) window.cancelIdleCallback(id);
        else window.cancelAnimationFrame(id);
    }, [
        throttledCallback
    ]);
    const onSaveSuccess = (0, $cozmU.useCallback)(()=>{
        if (saveCompleteCallbackId.current) cancelThrottle(saveCompleteCallbackId.current);
        const id = throttledCallback(()=>{
            setSavedTime(new Date());
            setIsSaving(false);
            clearInterval(pollIntervalId.current);
            pollIntervalId.current = 0;
            saveCompleteCallbackId.current = 0;
        });
        saveCompleteCallbackId.current = id;
    }, [
        cancelThrottle,
        throttledCallback
    ]);
    const pollForStepsSaved = (0, $cozmU.useCallback)(()=>{
        if (!collabEditProvider) return;
        const unconfirmedSteps = collabEditProvider.getUnconfirmedSteps();
        if (!unconfirmedSteps || unconfirmedSteps.length === 0) onSaveSuccess();
    }, [
        collabEditProvider,
        onSaveSuccess
    ]);
    const onSaveAttempt = (0, $cozmU.useCallback)(()=>{
        if (saveAttemptCallbackId.current) cancelThrottle(saveAttemptCallbackId.current);
        if (pollIntervalId.current) clearInterval(pollIntervalId.current);
        const attemptId = throttledCallback(()=>{
            setIsSaving(true);
            saveAttemptCallbackId.current = 0;
            const id = setInterval(pollForStepsSaved, $f9dc71ade1ee2d5f$var$NCS_POLLING_INTERVAL);
            pollIntervalId.current = id;
        });
        saveAttemptCallbackId.current = attemptId;
    }, [
        throttledCallback,
        cancelThrottle,
        pollForStepsSaved
    ]);
    // Update polling interval callback with new poll() whenever it updates
    // Because setInterval callback does not track state changes (i.e. isSaving)
    (0, $cozmU.useEffect)(()=>{
        if (pollIntervalId.current) {
            clearInterval(pollIntervalId.current);
            pollIntervalId.current = setInterval(pollForStepsSaved, $f9dc71ade1ee2d5f$var$NCS_POLLING_INTERVAL);
        }
    }, [
        pollForStepsSaved
    ]);
    const debouncedOnChange = (0, $cozmU.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(onSaveAttempt, $f9dc71ade1ee2d5f$var$COMMIT_STATUS_DEBOUNCE, {
            leading: true,
            trailing: false
        }), [
        onSaveAttempt
    ]);
    (0, $1KOhB.usePluginStateEffect)(editorApi, [
        'collabEdit'
    ], ({ collabEditState: collabEditState })=>{
        const lastChangeTime = collabEditState?.initialised?.lastLocalOrganicBodyChangeAt;
        if (!collabEditState?.initialised || !lastChangeTime) return;
        if (lastChangeTime !== previousBodyChangeTimeRef.current) {
            previousBodyChangeTimeRef.current = lastChangeTime;
            debouncedOnChange();
        }
    });
    // Cancel any awaiting callbacks on unmount
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (pollIntervalId.current) clearInterval(pollIntervalId.current);
            if (saveAttemptCallbackId.current) cancelThrottle(saveAttemptCallbackId.current);
            if (saveCompleteCallbackId.current) cancelThrottle(saveCompleteCallbackId.current);
        };
    // eslint-disable-next-line
    }, []);
    // display save indicator with auto resolve to saved, for changes outside document body
    const triggerSaving = (0, $cozmU.useCallback)(()=>{
        let autoSuccessTimeoutId;
        if (!isSaving) {
            if (saveAttemptCallbackId.current) cancelThrottle(saveAttemptCallbackId.current);
            const attemptId = throttledCallback(()=>{
                setIsSaving(true);
                saveAttemptCallbackId.current = 0;
                autoSuccessTimeoutId = setTimeout(onSaveSuccess, $f9dc71ade1ee2d5f$var$DEBOUNCE_SAVE_PERIOD);
            });
            saveAttemptCallbackId.current = attemptId;
        }
        return ()=>{
            if (autoSuccessTimeoutId) clearTimeout(autoSuccessTimeoutId);
        };
    }, [
        isSaving,
        throttledCallback,
        cancelThrottle,
        onSaveSuccess
    ]);
    const saveIndicatorContextValue = (0, $cozmU.useMemo)(()=>({
            isSaving: isSaving,
            savedTime: savedTime
        }), [
        isSaving,
        savedTime
    ]);
    const saveIndicatorTriggerContextValue = (0, $cozmU.useMemo)(()=>({
            triggerSaveIndicator: triggerSaving
        }), [
        triggerSaving
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f9dc71ade1ee2d5f$export$9745d8c24b40881d.Provider, {
        value: saveIndicatorContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f9dc71ade1ee2d5f$export$df7407750199bb6d.Provider, {
        value: saveIndicatorTriggerContextValue
    }, children));
};



var $edEsl = parcelRequire("edEsl");





var $l6Cdg = parcelRequire("l6Cdg");





var $aJv6Q = parcelRequire("aJv6Q");

const $f793b569ac081794$var$PageLoadMarkComponent = ({ name: name })=>{
    (0, $cozmU.useEffect)(()=>{
        (0, $l6Cdg.addUFOCustomMark)(name);
    }, [
        name
    ]);
    return null;
};
const $f793b569ac081794$export$60e4773fef02e3c = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($f793b569ac081794$var$PageLoadMarkComponent);



var $2xS8W = parcelRequire("2xS8W");


var $70pcM = parcelRequire("70pcM");


var $cEgMD = parcelRequire("cEgMD");


var $85rxh = parcelRequire("85rxh");


var $59NtD = parcelRequire("59NtD");


var $6Trhx = parcelRequire("6Trhx");


var $fjhaB = parcelRequire("fjhaB");


var $9EvUR = parcelRequire("9EvUR");


var $98Cy1 = parcelRequire("98Cy1");


var $l3Dp5 = parcelRequire("l3Dp5");


var $e9owJ = parcelRequire("e9owJ");


var $7BsWq = parcelRequire("7BsWq");


var $1NbQn = parcelRequire("1NbQn");




const $0642f0591024f070$export$f31ae08e8dcbd049 = (0, $dOBRD.default)(()=>{
    return {
        allowMatchCase: true
    };
});



var $fBnV3 = parcelRequire("fBnV3");

/**
 * @generated SignedSource<<909e495eb0d23117be31e4fec906f5b6>>
 * @relayHash ee79f0b035646a81a51ce55b170adc14
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8612a596bb7980422cb34932d5fffbf145a512fc8013ef9d7bca17d608208dd7
const $080e9111fe6dad1a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "alias": "appearanceDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "content-appearance-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "number"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(key:\"content-appearance-draft\")"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useInjectDraftContentgetDraftContentAppearancePropertyQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useInjectDraftContentgetDraftContentAppearancePropertyQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ee79f0b035646a81a51ce55b170adc14",
            "id": "8612a596bb7980422cb34932d5fffbf145a512fc8013ef9d7bca17d608208dd7",
            "metadata": {},
            "name": "useInjectDraftContentgetDraftContentAppearancePropertyQuery",
            "operationKind": "query",
            "text": "query useInjectDraftContentgetDraftContentAppearancePropertyQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,appearanceDraft:properties(key:\"content-appearance-draft\"){nodes{id,key,value,version{number}}}}}}"
        }
    };
}();
$080e9111fe6dad1a$var$node.hash = "a656f76b91560e5a2b68c51b9c99aa0c";
var $080e9111fe6dad1a$export$2e2bcd8739ae039 = $080e9111fe6dad1a$var$node;


/**
 * @generated SignedSource<<39e0fd2b8ddf140933902a028eedc3ff>>
 * @relayHash bf6325c2edd11bd3321be86df9129cf8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3aafa734739fbf9b352677446fd07dae3aa7a5c110d707c67e99502394997b8c
const $08991ec04a9e77c1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "value"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "alias": "appearanceDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "content-appearance-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        v2 /*: any*/ ,
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "number"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(key:\"content-appearance-draft\")"
                        },
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "concreteType": "ContentBodyPerRepresentation",
                            "kind": "LinkedField",
                            "name": "body",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentBody",
                                    "kind": "LinkedField",
                                    "name": "atlas_doc_format",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useInjectDraftContentConfluenceDraftQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useInjectDraftContentConfluenceDraftQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "bf6325c2edd11bd3321be86df9129cf8",
            "id": "3aafa734739fbf9b352677446fd07dae3aa7a5c110d707c67e99502394997b8c",
            "metadata": {},
            "name": "useInjectDraftContentConfluenceDraftQuery",
            "operationKind": "query",
            "text": "query useInjectDraftContentConfluenceDraftQuery($contentId:ID!,$status:[String]!){content(id:$contentId,status:$status){nodes{appearanceDraft:properties(key:\"content-appearance-draft\"){nodes{id,key,value,version{number}}},id,type,status,title,body{atlas_doc_format{value}}}}}"
        }
    };
}();
$08991ec04a9e77c1$var$node.hash = "532dc301ea1496d62e464496efa31b13";
var $08991ec04a9e77c1$export$2e2bcd8739ae039 = $08991ec04a9e77c1$var$node;









var $7W8i8 = parcelRequire("7W8i8");








var $nIvaQ = parcelRequire("nIvaQ");





var $fqIt3 = parcelRequire("fqIt3");


var $jMyy4 = parcelRequire("jMyy4");


var $lvOsp = parcelRequire("lvOsp");


var $3gyyc = parcelRequire("3gyyc");

const $9a6aed826f4ffb4d$var$logger = (0, $7W8i8.getLogger)('native-collab');
const $9a6aed826f4ffb4d$var$parseMonolithContent = (data, editorActions)=>{
    const content = data?.content?.nodes?.[0];
    const contentBody = content?.body?.atlas_doc_format?.value;
    const contentTitle = content?.title;
    let contentAppearance = null;
    try {
        const appearance = content?.appearanceDraft?.nodes?.[0]?.value;
        if (appearance) contentAppearance = JSON.parse(appearance);
    } catch (e) {
        $9a6aed826f4ffb4d$var$logger.error`Error parsing content appearance: ${e}`;
    }
    // at this point since we are getting data after the editor has mounted we need to
    // set the content in the editor through editorActions
    if (contentBody && editorActions) editorActions.replaceDocument(contentBody);
    return {
        draftBody: contentBody ?? null,
        draftTitle: contentTitle ?? null,
        draftAppearance: contentAppearance
    };
};
const $9a6aed826f4ffb4d$var$parseCollabDraftBody = (draftData, appearanceData)=>{
    const draft = draftData?.collabDraft;
    const appearanceContent = appearanceData?.content?.nodes?.[0];
    const draftAppearance = appearanceContent?.appearanceDraft?.nodes?.[0]?.value;
    return {
        draftBody: draft?.document ?? null,
        draftTitle: draft?.metadata?.title ?? null,
        draftAppearance: draftAppearance ? JSON.parse(draftAppearance) : null
    };
};
const $9a6aed826f4ffb4d$export$48c0f85d55b51110 = ({ contentId: contentId, draftShareId: draftShareId, collabEditInitialized: collabEditInitialized, editorActions: editorActions, isUnrecoverableCollabEditError: isUnrecoverableCollabEditError })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const transitionId = (0, $dPJCf.useTransitionId)();
    const isInitialLoad = !transitionId;
    const shouldPreloadForSSR = isInitialLoad;
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // Determine if we should bypass cache and fetch fresh data.
    // Cache is considered stale when its timestamp has been cleared (e.g., after adding a comment).
    // This ensures the editor fetches fresh content with comment annotations if the user
    // hovers the edit button (preloading the draft), adds a comment, then clicks edit.
    const shouldBypassCache = contentId && (!(0, $3gyyc.isSSRStreaming)() || !isInitialLoad) && (0, $fqIt3.isCollabDraftCacheStale)(contentId, draftShareId);
    const bodyPreloadingEnabled = shouldPreloadForSSR || isLivePage;
    const draftLoadTime = (0, $cozmU.useRef)(null);
    const getMonolithContentTimeout = (0, $cozmU.useRef)(null);
    let initialDraft = {
        draftBody: null,
        draftTitle: null,
        draftAppearance: null
    };
    const [getMonolithContent, { data: monolithDraftData, loading: monolithContentLoading, error: monolithContentError }] = (0, $lvOsp.useLazyQueryInterop)((0, $08991ec04a9e77c1$export$2e2bcd8739ae039), {
        variables: {
            contentId: contentId,
            status: [
                'draft',
                'current'
            ]
        },
        __callerPackage__: "editor-features"
    });
    const hasConfluenceDraftQueryLoaded = !monolithContentLoading && !monolithContentError && !!monolithDraftData;
    const { data: collabDraftData, loading: collabDraftLoading, error: collabDraftError } = (0, $jMyy4.useQueryInterop)((0, $nIvaQ.getCollabDraftQuery)(), {
        fetchPolicy: shouldBypassCache ? 'network-only' : 'cache-first',
        variables: {
            id: contentId,
            ...draftShareId ? {
                draftShareId: draftShareId
            } : undefined,
            hydrateAdf: true
        },
        skip: !bodyPreloadingEnabled,
        __callerPackage__: "editor-features"
    });
    const { data: appearanceData, loading: appearanceLoading, error: appearanceError } = (0, $jMyy4.useQueryInterop)((0, $080e9111fe6dad1a$export$2e2bcd8739ae039), {
        fetchPolicy: shouldBypassCache ? 'network-only' : 'cache-first',
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ]
        },
        skip: !bodyPreloadingEnabled,
        __callerPackage__: "editor-features"
    });
    const hasCollabDraftQueryLoaded = !collabDraftLoading && !!collabDraftData?.collabDraft && !!appearanceData && !appearanceLoading;
    initialDraft = (0, $cozmU.useMemo)(()=>{
        return hasConfluenceDraftQueryLoaded ? $9a6aed826f4ffb4d$var$parseMonolithContent(monolithDraftData, editorActions) : $9a6aed826f4ffb4d$var$parseCollabDraftBody(collabDraftData, appearanceData);
    }, [
        collabDraftData,
        appearanceData,
        monolithDraftData,
        hasConfluenceDraftQueryLoaded,
        editorActions
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isUnrecoverableCollabEditError) {
            if (getMonolithContentTimeout.current) clearTimeout(getMonolithContentTimeout.current);
            getMonolithContent();
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'monolithFallback',
                    actionSubject: 'nativeEditor',
                    source: 'confluenceFrontend',
                    objectId: contentId,
                    attributes: {
                        timeout: 0
                    }
                }
            }).fire();
        }
    }, [
        isUnrecoverableCollabEditError,
        getMonolithContentTimeout,
        getMonolithContent,
        createAnalyticsEvent,
        contentId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!getMonolithContentTimeout.current && !hasCollabDraftQueryLoaded) getMonolithContentTimeout.current = window.setTimeout(()=>{
            getMonolithContent();
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'monolithFallback',
                    actionSubject: 'nativeEditor',
                    source: 'confluenceFrontend',
                    objectId: contentId,
                    attributes: {
                        timeout: (0, $6mKj3.expVal)('confluence_editor_monolith_fallback_timer', 'value', 10000)
                    }
                }
            }).fire();
        }, (0, $6mKj3.expVal)('confluence_editor_monolith_fallback_timer', 'value', 10000));
    }, [
        hasCollabDraftQueryLoaded,
        getMonolithContentTimeout,
        getMonolithContent,
        createAnalyticsEvent,
        contentId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (getMonolithContentTimeout.current && (hasCollabDraftQueryLoaded || collabEditInitialized)) {
            clearTimeout(getMonolithContentTimeout.current);
            getMonolithContentTimeout.current = null;
        }
    }, [
        getMonolithContentTimeout,
        hasCollabDraftQueryLoaded,
        collabEditInitialized
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (getMonolithContentTimeout.current) clearTimeout(getMonolithContentTimeout.current);
        };
    }, [
        getMonolithContentTimeout
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!bodyPreloadingEnabled) return;
        if (!collabDraftError && hasCollabDraftQueryLoaded && !appearanceError) {
            draftLoadTime.current = performance.now();
            $9a6aed826f4ffb4d$var$logger.debug`Draft content retrieved from CollabDraftQuery at ${performance.now() / 1000}`;
        }
    }, [
        hasCollabDraftQueryLoaded,
        collabDraftError,
        appearanceError,
        bodyPreloadingEnabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (collabEditInitialized && !!draftLoadTime.current) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'editorContentVisibleDisabledTime',
                actionSubject: 'nativeEditor',
                source: 'confluenceFrontend',
                objectId: contentId,
                attributes: {
                    timeDiff: performance.now() - draftLoadTime.current
                }
            }
        }).fire();
    // don't depend on createAnalyticsEvent to avoid unnecessary re-triggers of this effect
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collabEditInitialized,
        contentId
    ]);
    return initialDraft;
};



var $bjxK7 = parcelRequire("bjxK7");


var $aIZFY = parcelRequire("aIZFY");


var $hfIjM = parcelRequire("hfIjM");


var $3W9OD = parcelRequire("3W9OD");


var $beK3g = parcelRequire("beK3g");


var $foVrt = parcelRequire("foVrt");


var $f6GmT = parcelRequire("f6GmT");







const $349687d7e88d726e$export$f95232bf2d33b362 = ()=>{
    const [{ collabEditConnected: collabEditConnected }] = (0, $hYoU4.useNativeCollabConnected)();
    const [{ collabEditProvider: collabEditProvider }] = (0, $hYoU4.useNativeCollabState)();
    const aiProviders = (0, $cozmU.useRef)({});
    const onAIProviderChanged = (0, $cozmU.useCallback)((source, provider)=>{
        if (!collabEditConnected || !collabEditProvider) return;
        let agentId = provider?.agent?.id;
        const agentIdPrefix = 'agent:';
        const action = agentId ? 'add' : 'remove';
        // Fetch the previously enabled provider's ID as it isn't provided
        // when unsetting the selected provider
        if (aiProviders.current[source]) agentId = aiProviders.current[source];
        aiProviders.current[source] = provider?.agent?.id;
        if (agentId) {
            const providerId = `${agentIdPrefix}${agentId}`;
            collabEditProvider.sendMessage({
                type: 'ai-provider:change',
                action: action,
                providerId: providerId
            });
        }
        collabEditProvider.setAIProviderActiveIds(Object.values(aiProviders.current).filter((id)=>!!id).map((id)=>`${agentIdPrefix}${id}`));
    }, [
        collabEditConnected,
        collabEditProvider
    ]);
    return {
        onAIProviderChanged: onAIProviderChanged
    };
};





const $92561710d62f83c7$export$4e0e446ffa50ddc0 = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const [isActive, setIsActive] = (0, $cozmU.useState)(document?.visibilityState === 'visible');
    const delay = 2000; // 2 seconds delay
    (0, $cozmU.useEffect)(()=>{
        let timer;
        const handleVisibilityChange = ()=>{
            clearTimeout(timer);
            if (document?.visibilityState === 'visible') timer = setTimeout(()=>{
                setIsActive(true);
            }, delay);
            else setIsActive(false);
        };
        document?.addEventListener('visibilitychange', handleVisibilityChange);
        return ()=>{
            clearTimeout(timer);
            document?.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);
    return isActive;
};


/**
 * @generated SignedSource<<7bed00dfcdb0a11f00e44b2550683baa>>
 * @relayHash 427b91af5539a42807aedc698e06b0b0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4036680aedddf3d43be10fb7f19ed27fa860e3e3584ff02d8f8163fc2ccbc766
const $589d588e480a1981$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEditorDraftSyncActionEditorDraftSyncActionMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "EditorDraftSyncPayload",
                    "kind": "LinkedField",
                    "name": "editorDraftSyncAction",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEditorDraftSyncActionEditorDraftSyncActionMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "EditorDraftSyncPayload",
                    "kind": "LinkedField",
                    "name": "editorDraftSyncAction",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "427b91af5539a42807aedc698e06b0b0",
            "id": "4036680aedddf3d43be10fb7f19ed27fa860e3e3584ff02d8f8163fc2ccbc766",
            "metadata": {},
            "name": "useEditorDraftSyncActionEditorDraftSyncActionMutation",
            "operationKind": "mutation",
            "text": "mutation useEditorDraftSyncActionEditorDraftSyncActionMutation($input:EditorDraftSyncInput!){editorDraftSyncAction(input:$input){success,errors{message,extensions{__typename,errorType,statusCode,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$589d588e480a1981$var$node.hash = "714c0f41fd977a5eb40bd778315e24d8";
var $589d588e480a1981$export$2e2bcd8739ae039 = $589d588e480a1981$var$node;












var $6Ixg8 = parcelRequire("6Ixg8");








var $1xpoY = parcelRequire("1xpoY");








var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");





var $7Sm4c = parcelRequire("7Sm4c");


var $aMcHK = parcelRequire("aMcHK");


var $bMmYR = parcelRequire("bMmYR");


var $308Wd = parcelRequire("308Wd");


var $gxtki = parcelRequire("gxtki");


var $b4kc6 = parcelRequire("b4kc6");


var $9F9dn = parcelRequire("9F9dn");

const $a59bf23b6ef769dd$var$UNKNOWN_ERROR_STR = 'Unknown Error from useEditorDraftSyncAction Mutation';
const $a59bf23b6ef769dd$var$DRAFT_SYNC_DEBOUNCE_TIME = 2500;
const $a59bf23b6ef769dd$var$parseSyncStatus = (syncStatus)=>{
    // syncStatus is expected to follow this pattern: pending-{stepVersionNumber} | synced-{stepVersionNumber}
    if (typeof syncStatus !== 'string') return undefined;
    const parsed = syncStatus.split('-');
    return {
        status: parsed[0],
        version: Number(parsed[1])
    };
};
const $a59bf23b6ef769dd$export$7a6d63ee0185f0fd = ({ contentId: contentId, editorPresetAPI: editorPresetAPI, editorActions: editorActions, isFirstParticipant: isFirstParticipant, onDraftSyncSuccess: onDraftSyncSuccess, flags: flags })=>{
    const intl = (0, $kSwu1.useIntl)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ collabEditProvider: collabEditProvider, collabEditInitialized: collabEditInitialized }, { setIsDraftSyncPending: setIsDraftSyncPending }] = (0, $hYoU4.useNativeCollabState)();
    const draftSyncDebounceMaxWait = (0, $1xpoY.default).getNumber('draft_sync_debounce_max_wait', 0);
    const [draftSyncActionError, setDraftSyncActionError] = (0, $cozmU.useState)(null);
    const previousLocalChangeTimeRef = (0, $cozmU.useRef)(undefined);
    const previousOfflineStatusRef = (0, $cozmU.useRef)(false);
    const submitErrorToMonitoringSystem = (0, $cozmU.useCallback)((error)=>{
        (0, $fJlJm.setContentErrorAttributes)(error, {
            objectId: contentId
        });
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
    }, [
        contentId
    ]);
    const [editorDraftSyncActionMutation] = (0, $308Wd.useMutationInterop)((0, $589d588e480a1981$export$2e2bcd8739ae039), {
        __callerPackage__: "editor-features"
    });
    const executeDraftSyncActionMutation = (0, $cozmU.useCallback)(async ()=>{
        const currentStep = collabEditProvider?.getCurrentPmVersion();
        // Fallback adf should only be sent by a single user to avoid conflict errors on the BE
        const latestAdf = isFirstParticipant ? await editorActions.getValue() : null;
        const { data: data } = await editorDraftSyncActionMutation({
            variables: {
                input: {
                    contentId: contentId,
                    ncsStepVersion: currentStep,
                    doSetRelations: true,
                    // Collaborator relation is an entity on the backend used to indicate if a user made changes to that version
                    latestAdf: latestAdf && JSON.stringify(latestAdf)
                }
            }
        });
        return data;
    }, [
        contentId,
        editorDraftSyncActionMutation,
        collabEditProvider,
        editorActions,
        isFirstParticipant
    ]);
    const saveDraft = (0, $cozmU.useCallback)(async ()=>{
        setIsDraftSyncPending(true);
        try {
            const data = await (0, $bMmYR.retry)(executeDraftSyncActionMutation, {
                maxAttempts: 2,
                timeout: 2000
            });
            const result = data?.editorDraftSyncAction;
            if (result?.success) {
                // After draft is saved, save source sync blocks and reference synced blocks on the document
                if (editorPresetAPI?.syncedBlock && (0, $6mKj3.expValEquals)('platform_synced_block', 'isEnabled', true)) {
                    const { flushBodiedSyncBlocks: flushBodiedSyncBlocks, flushSyncedBlocks: flushSyncedBlocks } = editorPresetAPI.syncedBlock.actions;
                    const [bodiedSuccess, referenceSuccess] = await Promise.all([
                        flushBodiedSyncBlocks(),
                        flushSyncedBlocks()
                    ]);
                    if (flags && (!bodiedSuccess || !referenceSuccess)) {
                        const retryFlush = async ()=>{
                            const [retryBodied, retryReference] = await Promise.all([
                                bodiedSuccess ? Promise.resolve(true) : flushBodiedSyncBlocks(),
                                referenceSuccess ? Promise.resolve(true) : flushSyncedBlocks()
                            ]);
                            return retryBodied && retryReference;
                        };
                        (0, $b4kc6.showFlushSyncBlockErrorFlag)(flags, intl, retryFlush);
                    }
                }
                setDraftSyncActionError(null);
                setIsDraftSyncPending(false);
                onDraftSyncSuccess?.();
                return;
            }
            if (result?.errors?.length && result?.errors?.length > 0) {
                const errors = (0, $gxtki.mutationErrorExtensionsAggCompat)((result.errors ?? []).map((error)=>({
                        ...error,
                        __typename: 'MutationError'
                    })));
                errors.forEach((error, index)=>{
                    const originalError = result.errors?.[index];
                    const typedError = error;
                    const errorExtensionData = typedError?.extensions?.[0];
                    const errorMessage = originalError?.message ?? typedError?.message;
                    if (errorMessage && errorExtensionData?.statusCode) setDraftSyncActionError(new (0, $9F9dn.DraftSyncResponseError)(errorMessage, errorExtensionData.statusCode));
                    else setDraftSyncActionError(new (0, $9F9dn.DraftSyncResponseError)(errorMessage || $a59bf23b6ef769dd$var$UNKNOWN_ERROR_STR, undefined));
                    submitErrorToMonitoringSystem(originalError || typedError);
                });
                return;
            }
        } catch (error) {
            setDraftSyncActionError(new (0, $9F9dn.DraftSyncResponseError)(error?.message || $a59bf23b6ef769dd$var$UNKNOWN_ERROR_STR, Number((0, $aMcHK.getStatusCode)(error))));
            submitErrorToMonitoringSystem(error);
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        editorPresetAPI,
        submitErrorToMonitoringSystem,
        setIsDraftSyncPending,
        executeDraftSyncActionMutation,
        onDraftSyncSuccess,
        flags,
        intl
    ]);
    const onUpdate = (0, $cozmU.useCallback)(()=>{
        if (!isLivePage || !collabEditProvider || !collabEditInitialized) return;
        const metadata = collabEditProvider.getMetadata();
        const collabSyncStatus = $a59bf23b6ef769dd$var$parseSyncStatus(metadata['syncStatus']);
        if (collabSyncStatus) {
            const currentStatus = collabSyncStatus['status'];
            if (currentStatus === 'synced') // BE is not currently saving, so send request
            saveDraft();
            if (currentStatus === 'pending') // implies BE is already saving, so we don't send a new request
            return;
        } else // collabSyncStatus is set by the BE as a result of draft sync. If it doesn't exist, BE needs to save and set it.
        saveDraft();
    }, [
        isLivePage,
        collabEditProvider,
        collabEditInitialized,
        saveDraft
    ]);
    const debouncedOnUpdate = (0, $cozmU.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(onUpdate, $a59bf23b6ef769dd$var$DRAFT_SYNC_DEBOUNCE_TIME, {
            trailing: true,
            ...draftSyncDebounceMaxWait > 0 && {
                maxWait: draftSyncDebounceMaxWait
            }
        }), [
        onUpdate,
        draftSyncDebounceMaxWait
    ]);
    const triggerUpdate = (0, $cozmU.useCallback)(()=>{
        if (isLivePage) debouncedOnUpdate();
    }, [
        debouncedOnUpdate,
        isLivePage
    ]);
    const cancelUpdate = (0, $cozmU.useCallback)(()=>debouncedOnUpdate.cancel(), [
        debouncedOnUpdate
    ]);
    const flushUpdate = (0, $cozmU.useCallback)(()=>{
        debouncedOnUpdate.flush();
    }, [
        debouncedOnUpdate
    ]);
    const previousRemoteChangeTimeRef = (0, $cozmU.useRef)(undefined);
    const handlePluginStateEffect = (0, $cozmU.useCallback)(({ collabEditState: collabEditState, connectivityState: connectivityState })=>{
        if (!isLivePage) return;
        if ((0, $6Ixg8.isOfflineMode)(connectivityState?.mode)) {
            previousOfflineStatusRef.current = true;
            return;
        } else if (connectivityState?.mode === 'online') {
            // reset any draft sync errors upon coming back online
            if (previousOfflineStatusRef.current === true) setDraftSyncActionError(null);
            previousOfflineStatusRef.current = false;
        }
        const currentBodyChangeAt = collabEditState?.initialised?.lastLocalOrganicBodyChangeAt;
        const prevBodyChangeAt = previousLocalChangeTimeRef.current;
        if (currentBodyChangeAt && currentBodyChangeAt !== prevBodyChangeAt) {
            previousLocalChangeTimeRef.current = currentBodyChangeAt;
            triggerUpdate();
            return;
        }
        // When a synced block is edited inside an embed of the same page, the edit arrives
        // in the outer editor as a remote change (via NativeCollab). The iframe that
        // processed the edit gets destroyed before its debounced flush can fire.
        // To handle this, we flush synced blocks when remote organic body changes arrive,
        // since updateSyncBlockData marks blocks as dirty in the outer editor's store too.
        if ((0, $6mKj3.expValEquals)('platform_synced_block', 'isEnabled', true)) {
            const currentRemoteBodyChangeAt = collabEditState?.initialised?.lastRemoteOrganicBodyChangeAt;
            const prevRemoteBodyChangeAt = previousRemoteChangeTimeRef.current;
            if (currentRemoteBodyChangeAt && currentRemoteBodyChangeAt !== prevRemoteBodyChangeAt) {
                previousRemoteChangeTimeRef.current = currentRemoteBodyChangeAt;
                editorPresetAPI?.syncedBlock?.actions.flushBodiedSyncBlocks();
            }
        }
    }, [
        isLivePage,
        triggerUpdate,
        editorPresetAPI
    ]);
    (0, $1KOhB.usePluginStateEffect)(editorPresetAPI, [
        'collabEdit',
        'connectivity'
    ], handlePluginStateEffect);
    (0, $cozmU.useEffect)(()=>{
        if (!isLivePage || !collabEditProvider || !collabEditInitialized) return;
        window.addEventListener('beforeunload', flushUpdate);
        return ()=>{
            window.removeEventListener('beforeunload', flushUpdate);
        };
    }, [
        collabEditInitialized,
        collabEditProvider,
        isLivePage,
        flushUpdate
    ]);
    return {
        triggerUpdate: triggerUpdate,
        cancelUpdate: cancelUpdate,
        flushUpdate: flushUpdate,
        draftSyncActionError: draftSyncActionError
    };
};








const $83a5ab04c7ded94b$export$f6774c6023dca75e = (fetchNativeCollab)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hasPreloadedResult = (0, $cozmU.useRef)(false);
    // Fetch native collab data into cache
    const preloadNativeCollabRefetch = (0, $cozmU.useCallback)(async ()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'preloaded',
                actionSubject: 'refetchNativeCollab',
                source: 'useRefetchNativeCollab'
            }
        }).fire();
        try {
            const data = await fetchNativeCollab(false);
            hasPreloadedResult.current = true;
            return data;
        } catch (error) {
            hasPreloadedResult.current = false;
            throw error;
        }
    }, [
        createAnalyticsEvent,
        fetchNativeCollab
    ]);
    const refetchNativeCollab = (0, $cozmU.useCallback)(async (shouldCheckCache)=>{
        // Use cache if preloaded, otherwise use the provided value
        const checkCache = hasPreloadedResult.current || !!shouldCheckCache;
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'fetched',
                actionSubject: 'refetchNativeCollab',
                source: 'useRefetchNativeCollab',
                attributes: {
                    checkCache: checkCache,
                    hasPreloadedResult: hasPreloadedResult.current
                }
            }
        }).fire();
        try {
            return await fetchNativeCollab(checkCache);
        } catch (error) {
            hasPreloadedResult.current = false;
            throw error;
        }
    }, [
        createAnalyticsEvent,
        fetchNativeCollab
    ]);
    return {
        refetchNativeCollab: refetchNativeCollab,
        preloadNativeCollabRefetch: preloadNativeCollabRefetch
    };
};



var $btQhd = parcelRequire("btQhd");


var $8uySb = parcelRequire("8uySb");


var $lmEhP = parcelRequire("lmEhP");


var $cvzKy = parcelRequire("cvzKy");


var $2dIEg = parcelRequire("2dIEg");


var $i8Ylv = parcelRequire("i8Ylv");


var $3plmx = parcelRequire("3plmx");


var $3IZob = parcelRequire("3IZob");


var $awIbt = parcelRequire("awIbt");


var $dWbBL = parcelRequire("dWbBL");


var $dE9mB = parcelRequire("dE9mB");


var $2KWDO = parcelRequire("2KWDO");


var $bAGpj = parcelRequire("bAGpj");


var $5IgBW = parcelRequire("5IgBW");


var $aUU0C = parcelRequire("aUU0C");


var $k8e76 = parcelRequire("k8e76");


var $WheoQ = parcelRequire("WheoQ");


var $OCz5m = parcelRequire("OCz5m");


var $aPQsP = parcelRequire("aPQsP");


var $bcv7k = parcelRequire("bcv7k");


var $32x2E = parcelRequire("32x2E");


var $brsfB = parcelRequire("brsfB");








var $kyKWe = parcelRequire("kyKWe");


var $24dy7 = parcelRequire("24dy7");





var $hMv2K = parcelRequire("hMv2K");


var $arQY7 = parcelRequire("arQY7");


var $b3j2Y = parcelRequire("b3j2Y");











var $a7SsH = parcelRequire("a7SsH");

/**
 * @generated SignedSource<<0c37ab55ff788d3a5cc8c19adf9a52bb>>
 * @relayHash 682006a4717140cff09b61df1192c4ea
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 83c9bb559f2ee12740a46e0dc8d69d0dc2ebd36452507787134a290ae0257b2a
const $46e0cf9c3dce3323$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ContentPermissionsPayload",
            "kind": "LinkedField",
            "name": "updateContentPermissions",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "status"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useUsersContentPermissionsUpdateContentPermissionsMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useUsersContentPermissionsUpdateContentPermissionsMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "682006a4717140cff09b61df1192c4ea",
            "id": "83c9bb559f2ee12740a46e0dc8d69d0dc2ebd36452507787134a290ae0257b2a",
            "metadata": {},
            "name": "useUsersContentPermissionsUpdateContentPermissionsMutation",
            "operationKind": "mutation",
            "text": "mutation useUsersContentPermissionsUpdateContentPermissionsMutation($contentId:ID!,$input:[UpdateContentPermissionsInput]!){updateContentPermissions(contentId:$contentId,input:$input){status}}"
        }
    };
}();
$46e0cf9c3dce3323$var$node.hash = "69f9fc40c10deb46af31d8102cad6d9e";
var $46e0cf9c3dce3323$export$2e2bcd8739ae039 = $46e0cf9c3dce3323$var$node;


/**
 * @generated SignedSource<<c0a25ca7db1aa6fbb2466e5807029eb6>>
 * @relayHash 1f8968d814ecf9ca0dc936ee80d421ff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e045e26a8668ba5a7a377f709fbc209c3901d0a44e48c18a533b066fcb360c56
const $22ddb50ea6694114$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accountIds"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "permission"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "resourceId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "resourceType"
    }, v5 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "permission",
                "variableName": "permission"
            },
            {
                "kind": "Variable",
                "name": "principalIds",
                "variableName": "accountIds"
            },
            {
                "kind": "Variable",
                "name": "resourceId",
                "variableName": "resourceId"
            },
            {
                "kind": "Variable",
                "name": "resourceType",
                "variableName": "resourceType"
            }
        ],
        "concreteType": "ConfluenceUsersHavePermissionList",
        "kind": "LinkedField",
        "name": "confluence_usersHavePermission",
        "plural": false,
        "selections": [
            {
                "concreteType": "ConfluenceUserHasPermission",
                "kind": "LinkedField",
                "name": "usersHavePermissionList",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "principalId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "hasPermission"
                    }
                ]
            }
        ]
    }, v6 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useUsersContentPermissionsNewUserHasRestrictionsQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "PaginatedPersonList",
                    "kind": "LinkedField",
                    "name": "confluenceUsers",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useUsersContentPermissionsNewUserHasRestrictionsQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "PaginatedPersonList",
                    "kind": "LinkedField",
                    "name": "confluenceUsers",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "1f8968d814ecf9ca0dc936ee80d421ff",
            "id": "e045e26a8668ba5a7a377f709fbc209c3901d0a44e48c18a533b066fcb360c56",
            "metadata": {},
            "name": "useUsersContentPermissionsNewUserHasRestrictionsQuery",
            "operationKind": "query",
            "text": "query useUsersContentPermissionsNewUserHasRestrictionsQuery($cloudId:ID!,$accountIds:[String]!,$resourceId:ID!,$resourceType:String!,$permission:String!){confluence_usersHavePermission(cloudId:$cloudId,principalIds:$accountIds,resourceId:$resourceId,resourceType:$resourceType,permission:$permission){usersHavePermissionList{principalId,hasPermission}},confluenceUsers(accountIds:$accountIds){nodes{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}"
        }
    };
}();
$22ddb50ea6694114$var$node.hash = "574ff7b442e7a8af2643d4ece91556c9";
var $22ddb50ea6694114$export$2e2bcd8739ae039 = $22ddb50ea6694114$var$node;


/**
 * @generated SignedSource<<e0f6d4ee2b68fa00fcc06e3c69f2e00e>>
 * @relayHash 1e11714ae08776671ab5c43bd95e63c2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7796a686a40381dc088a041f5845ef2b6be6d6e42cfc99dcf5219f541bd9ecec
const $f6e8679dfbb7a153$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v4 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v5 = [
        {
            "args": [
                v1 /*: any*/ 
            ],
            "concreteType": "ContentPermissions",
            "kind": "LinkedField",
            "name": "contentPermissions",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "contentAccess"
                },
                {
                    "concreteType": "PaginatedSubjectUserOrGroupList",
                    "kind": "LinkedField",
                    "name": "subjectsWithEffectiveContentPermissions",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SubjectUserOrGroup",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "UserWithRestrictions",
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accountIds",
                    "variableName": "accountIds"
                },
                v1 /*: any*/ 
            ],
            "concreteType": "UserWithRestrictions",
            "kind": "LinkedField",
            "name": "usersWithContentRestrictions",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "hasSpaceViewPermission"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "restrictingContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "hasRestrictions"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "accountId"
                },
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useUsersContentPermissionsContentPermissionsQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useUsersContentPermissionsContentPermissionsQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "1e11714ae08776671ab5c43bd95e63c2",
            "id": "7796a686a40381dc088a041f5845ef2b6be6d6e42cfc99dcf5219f541bd9ecec",
            "metadata": {},
            "name": "useUsersContentPermissionsContentPermissionsQuery",
            "operationKind": "query",
            "text": "query useUsersContentPermissionsContentPermissionsQuery($accountIds:[String]!,$contentId:ID!){contentPermissions(contentId:$contentId){contentAccess,subjectsWithEffectiveContentPermissions{nodes{id,displayName,user{profilePicture{path}}}}},usersWithContentRestrictions(accountIds:$accountIds,contentId:$contentId){hasSpaceViewPermission,restrictingContent{id,hasRestrictions},accountId,displayName,profilePicture{path}}}"
        }
    };
}();
$f6e8679dfbb7a153$var$node.hash = "17ce6feb201fcfab95a8a2ed98133b5c";
var $f6e8679dfbb7a153$export$2e2bcd8739ae039 = $f6e8679dfbb7a153$var$node;


















var $c0rhi = parcelRequire("c0rhi");


var $hdxAi = parcelRequire("hdxAi");

const $a429a791ecef3570$var$useUsersContentPermissionsContentPermissionsQuery = (0, $f6e8679dfbb7a153$export$2e2bcd8739ae039);
const $a429a791ecef3570$var$useUsersContentPermissionsNewUserHasRestrictionsQuery = (0, $22ddb50ea6694114$export$2e2bcd8739ae039);
const $a429a791ecef3570$var$useUsersContentPermissionsUpdateContentPermissionsMutation = (0, $46e0cf9c3dce3323$export$2e2bcd8739ae039);
const $a429a791ecef3570$export$d525ee52d361179f = async ({ accountIds: accountIds, contentId: contentId, cloudId: cloudId, setAddedMentions: setAddedMentions, setAddedTasks: setAddedTasks })=>{
    try {
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: $a429a791ecef3570$var$useUsersContentPermissionsNewUserHasRestrictionsQuery,
            variables: {
                cloudId: cloudId,
                accountIds: accountIds,
                resourceId: contentId,
                resourceType: 'PAGE',
                permission: 'VIEW'
            },
            fetchPolicy: 'network-only' // we'll need to check user's permissions everytime to correctly display the correct flag contents in case the user's permission changed
            ,
            __callerPackage__: "mentions-notifications"
        });
        const usersWithViewPermissions = new Set(data?.confluence_usersHavePermission?.usersHavePermissionList?.filter((user)=>user?.hasPermission).map((user)=>user?.principalId));
        return data?.confluenceUsers?.nodes?.reduce((acc, user)=>{
            const accountId = user?.accountId;
            if (user && accountId && usersWithViewPermissions.has(accountId)) acc.push({
                id: accountId,
                hasViewRestrictions: false,
                displayName: user?.displayName ?? '',
                userPhoto: user?.profilePicture?.path ?? ''
            });
            return acc;
        }, []);
    } catch  {
        //reset state so query won't keep erroring out on same data
        setAddedMentions([]);
        setAddedTasks([]);
        return [];
    }
};
const $a429a791ecef3570$export$a5b8a857cb669f1f = ({ contentId: contentId, isUpdatedMentionsInLivePagesEnabled: isUpdatedMentionsInLivePagesEnabled, isLivePage: isLivePage, currentUserId: currentUserId, mentionsToDisplay: mentionsToDisplay, source: source })=>{
    //TODO: save the permissions of users in a separate state if it's already available, so that we don't have to query forit again
    // The suppression flag is set by the gated editor mention path; keep those mentions out of
    // notification/access-warning permission work while preserving general mention tracking.
    const mentionsToNotify = (0, $cozmU.useMemo)(()=>mentionsToDisplay.filter((mention)=>!mention.shouldSuppressMentionNotification), [
        mentionsToDisplay
    ]);
    const mentionedUserIds = (0, $cozmU.useMemo)(()=>{
        const allUniqueMentionedUserIds = new Set(mentionsToNotify.map((mention)=>mention.id));
        return Array.from(allUniqueMentionedUserIds);
    }, [
        mentionsToNotify
    ]);
    const [unrestrictedUsers, setUnrestrictedUsers] = (0, $cozmU.useState)([]);
    const [isUnrestrictedUsersLoading, setIsUnrestrictedUsersLoading] = (0, $cozmU.useState)(false);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { setAddedMentions: setAddedMentions, setAddedTasks: setAddedTasks, addUnrestrictedMentions: addUnrestrictedMentions, addParentSpaceRestrictedMentions: addParentSpaceRestrictedMentions, addPageRestrictedMentions: addPageRestrictedMentions, addParentSpaceRestrictedTasks: addParentSpaceRestrictedTasks, addPageRestrictedTasks: addPageRestrictedTasks, addUnrestrictedTasks: addUnrestrictedTasks } = (0, $hdxAi.useMentionsNotificationsActions)();
    //useLazyQuery is being used here because skip was not being respected in useQuery. Known issue in react-apollo: https://github.com/apollographql/react-apollo/issues/3492
    const [getContentPermissions, { data: updatedContentPermissionsData, error: updatedUsersContentPermissionsError, loading: updatedUsersContentPermissionsLoading }] = (0, $lvOsp.useLazyQueryInterop)($a429a791ecef3570$var$useUsersContentPermissionsContentPermissionsQuery, {
        variables: {
            contentId: contentId,
            accountIds: mentionedUserIds
        },
        fetchPolicy: 'network-only',
        // we'll need to check user's permissions everytime to correctly display the correct flag contents in case the user's permission changed
        onError: ()=>{
            //reset state so query won't keep erroring out on same data
            setAddedMentions([]);
            setAddedTasks([]);
        },
        __callerPackage__: "mentions-notifications"
    });
    (0, $cozmU.useEffect)(()=>{
        if (isUpdatedMentionsInLivePagesEnabled && mentionedUserIds.length) getContentPermissions({
            variables: {
                contentId: contentId,
                accountIds: mentionedUserIds
            }
        });
    }, [
        contentId,
        isUpdatedMentionsInLivePagesEnabled,
        mentionedUserIds,
        getContentPermissions
    ]);
    (0, $cozmU.useEffect)(()=>{
        const fetchUnrestrictedUsers = async ()=>{
            if (isUpdatedMentionsInLivePagesEnabled && mentionedUserIds.length) {
                setIsUnrestrictedUsersLoading(true);
                try {
                    const usersWithViewPermissions = await $a429a791ecef3570$export$d525ee52d361179f({
                        accountIds: mentionedUserIds,
                        contentId: contentId,
                        cloudId: cloudId,
                        setAddedMentions: setAddedMentions,
                        setAddedTasks: setAddedTasks
                    });
                    setUnrestrictedUsers(usersWithViewPermissions ?? []);
                } finally{
                    setIsUnrestrictedUsersLoading(false);
                }
            }
        };
        fetchUnrestrictedUsers();
    }, [
        contentId,
        isUpdatedMentionsInLivePagesEnabled,
        mentionedUserIds,
        cloudId,
        setAddedMentions,
        setAddedTasks
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [updateUsersContentPermissionMutation] = (0, $308Wd.useMutationInterop)($a429a791ecef3570$var$useUsersContentPermissionsUpdateContentPermissionsMutation, {
        onCompleted: ()=>{
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    actionSubject: 'updateContentPermissions',
                    action: 'succeeded',
                    source: source,
                    attributes: {
                        contentId: contentId,
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        },
        onError: (error)=>{
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    actionSubject: 'updateContentPermissions',
                    action: 'failed',
                    source: source,
                    attributes: {
                        contentId: contentId,
                        error: error.message,
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        },
        __callerPackage__: "mentions-notifications"
    });
    const mentionsWithSpaceRestrictions = [];
    const usersWithSpaceRestrictionsIds = new Set();
    const mentionsWithParentPageRestrictions = [];
    const usersWithParentPageRestrictionsIds = new Set();
    const usersWithSpaceOrParentRestrictionsIds = new Set();
    const usersWithCurrentPageRestrictionsIds = new Set();
    const usersWithUnrestrictedPageAccessIds = new Set();
    const accountIdToDisplayNameMap = new Map();
    (0, $cozmU.useEffect)(()=>{
        if (updatedContentPermissionsData && mentionsToNotify.length && !isUnrestrictedUsersLoading) {
            const { contentPermissions: contentPermissions, usersWithContentRestrictions: contentRestrictions } = updatedContentPermissionsData;
            if (contentPermissions?.contentAccess === 'EVERYONE_NO_ACCESS') {
                contentPermissions?.subjectsWithEffectiveContentPermissions?.nodes?.forEach((user)=>{
                    if (!user?.id || user.id === currentUserId) return;
                    usersWithUnrestrictedPageAccessIds.add(user.id);
                    accountIdToDisplayNameMap.set(user.id, {
                        displayName: user.displayName ?? '',
                        userPhoto: user?.user?.profilePicture?.path ?? ''
                    });
                });
                unrestrictedUsers.forEach((user)=>{
                    usersWithUnrestrictedPageAccessIds.add(user.id);
                    accountIdToDisplayNameMap.set(user.id, {
                        displayName: user.displayName ?? '',
                        userPhoto: user.userPhoto ?? ''
                    });
                });
            }
            contentRestrictions?.forEach((user)=>{
                if (!user?.accountId) return;
                accountIdToDisplayNameMap.set(user.accountId, {
                    displayName: user.displayName ?? '',
                    userPhoto: user?.profilePicture?.path ?? ''
                });
                if (!user.hasSpaceViewPermission) {
                    //has space level restriction
                    usersWithSpaceRestrictionsIds.add(user.accountId);
                    usersWithSpaceOrParentRestrictionsIds.add(user.accountId);
                } else if (user.restrictingContent?.hasRestrictions) {
                    //has parent page level restriction
                    usersWithParentPageRestrictionsIds.add(user.accountId);
                    usersWithSpaceOrParentRestrictionsIds.add(user.accountId);
                } else if (contentPermissions?.contentAccess === 'EVERYONE_NO_ACCESS') //might have page level restriction
                {
                    if (!usersWithUnrestrictedPageAccessIds.has(user.accountId)) usersWithCurrentPageRestrictionsIds.add(user.accountId);
                }
            });
            mentionsToNotify.forEach((mention)=>{
                const mentionToAdd = {
                    ...mention,
                    displayName: accountIdToDisplayNameMap.get(mention.id)?.displayName ?? '',
                    userPhoto: accountIdToDisplayNameMap.get(mention.id)?.userPhoto ?? ''
                };
                if (mention?.taskLocalId) {
                    //Buckets added task mentions into different permission groups
                    if (usersWithSpaceRestrictionsIds.has(mention.id)) //Users who dont have access to the page due to space restrictions
                    addParentSpaceRestrictedTasks([
                        mentionToAdd
                    ]);
                    else if (usersWithParentPageRestrictionsIds.has(mention.id)) //Users who don't have access to the page due to parent page restrictions
                    addParentSpaceRestrictedTasks([
                        mentionToAdd
                    ]);
                    else if (usersWithCurrentPageRestrictionsIds.has(mention.id)) //Users who don't have access to the page due to current page restrictions
                    addPageRestrictedTasks([
                        mentionToAdd
                    ]);
                    else //Users who have access to the page
                    addUnrestrictedTasks([
                        mentionToAdd
                    ]);
                } else {
                    //Buckets added general mentions into different permission groups
                    if (usersWithSpaceRestrictionsIds.has(mention.id)) {
                        //Users who dont have access to the page due to space restrictions
                        mentionsWithSpaceRestrictions.push(mentionToAdd);
                        addParentSpaceRestrictedMentions([
                            mentionToAdd
                        ]);
                    } else if (usersWithParentPageRestrictionsIds.has(mention.id)) {
                        //Users who don't have access to the page due to parent page restrictions
                        mentionsWithParentPageRestrictions.push(mentionToAdd);
                        addParentSpaceRestrictedMentions([
                            mentionToAdd
                        ]);
                    } else if (usersWithCurrentPageRestrictionsIds.has(mention.id)) //Users who don't have access to the page due to current page restrictions
                    addPageRestrictedMentions([
                        mentionToAdd
                    ]);
                    else //Users who have access to the page
                    addUnrestrictedMentions([
                        mentionToAdd
                    ]);
                }
            });
            setAddedMentions([]);
            setAddedTasks([]);
            setUnrestrictedUsers([]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        updatedContentPermissionsData,
        isUnrestrictedUsersLoading,
        unrestrictedUsers
    ]);
    return {
        updatedUsersContentPermissionsError: updatedUsersContentPermissionsError,
        updatedUsersContentPermissionsLoading: updatedUsersContentPermissionsLoading,
        updateUsersContentPermissionMutation: updateUsersContentPermissionMutation
    };
};


/**
 * @generated SignedSource<<34a43fbceae2db6a500232402e20fe47>>
 * @relayHash 325893057a9ae854264a36ff297497e4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7a892b2c57a89b01f2776ec740d6ff77b66ea51267eda656a864b2dae081cd69
const $6e80834bd13fce7f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "mentions"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "mentions",
                            "variableName": "mentions"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "CreateContentMentionNotificationActionPayload",
            "kind": "LinkedField",
            "name": "createContentMentionNotificationAction",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "contentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useMentionNotificationMutationCreateContentMentionNotificationActionMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useMentionNotificationMutationCreateContentMentionNotificationActionMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "325893057a9ae854264a36ff297497e4",
            "id": "7a892b2c57a89b01f2776ec740d6ff77b66ea51267eda656a864b2dae081cd69",
            "metadata": {},
            "name": "useMentionNotificationMutationCreateContentMentionNotificationActionMutation",
            "operationKind": "mutation",
            "text": "mutation useMentionNotificationMutationCreateContentMentionNotificationActionMutation($contentId:ID!,$mentions:[ContentMention]!){createContentMentionNotificationAction(input:{contentId:$contentId,mentions:$mentions}){contentId,success,errors{message}}}"
        }
    };
}();
$6e80834bd13fce7f$var$node.hash = "d2cb21a69b28359ca54e883cea95094b";
var $6e80834bd13fce7f$export$2e2bcd8739ae039 = $6e80834bd13fce7f$var$node;











const $05c7f8c23696cebd$var$useMentionNotificationMutationCreateContentMentionNotificationActionMutation = (0, $6e80834bd13fce7f$export$2e2bcd8739ae039);
const $05c7f8c23696cebd$export$82f89b951e37c769 = ({ contentId: contentId, setError: setError, showDontNotifyFailedFlag: showDontNotifyFailedFlag })=>{
    const [createContentMentionNotificationAction, { error: contentMentionNotificationError }] = (0, $308Wd.useMutationInterop)($05c7f8c23696cebd$var$useMentionNotificationMutationCreateContentMentionNotificationActionMutation, {
        __callerPackage__: "mentions-notifications"
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const sendMentionNotification = (0, $cozmU.useCallback)(({ mentions: mentions })=>{
        const fireAnalyticsEvent = (action)=>{
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'mentionsNotifications',
                    action: action,
                    actionSubject: 'mentionInputMutation',
                    attributes: {
                        mentions: mentions.map((mention)=>({
                                mentionedUserId: mention.mentionedUserAccountId,
                                mentionId: mention.mentionLocalId
                            })),
                        contentId: contentId
                    }
                }
            }).fire();
        };
        // NCS draft syncs need to happen prior to mutation in order for
        // email content to show up. A 15 second buffer after user closes
        // the flag notification will give draft syncs a chance to happen.
        setTimeout(()=>{
            // tells backend to send notificiation for the list of mention IDs
            createContentMentionNotificationAction({
                variables: {
                    contentId: contentId,
                    mentions: mentions
                }
            }).then(()=>{
                fireAnalyticsEvent('succeeded');
            }).catch(()=>{
                //TODO: create new error flag that handles multiple names
                fireAnalyticsEvent('failed');
            });
        }, 15000);
    }, [
        contentId,
        createAnalyticsEvent,
        createContentMentionNotificationAction
    ]);
    const sendCancelMentionNotification = (0, $cozmU.useCallback)(({ mentions: mentions })=>{
        createContentMentionNotificationAction({
            variables: {
                contentId: contentId,
                mentions: mentions
            }
        }).catch((error)=>{
            setError(error);
            showDontNotifyFailedFlag();
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        contentId,
        createContentMentionNotificationAction
    ]);
    return {
        sendMentionNotification: sendMentionNotification,
        sendCancelMentionNotification: sendCancelMentionNotification,
        contentMentionNotificationError: contentMentionNotificationError
    };
};


/**
 * @generated SignedSource<<1d97bcdf0bc2c62b704eb9288873de55>>
 * @relayHash 029e76bfcd70279acd22d488125dc454
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 936914f8502bab28553df0f472fa4f87cbb23cb871cb9a825222f522face951d
const $5360cbc6d166638c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "tasks"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "tasks",
                            "variableName": "tasks"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "CreateInlineTaskNotificationPayload",
            "kind": "LinkedField",
            "name": "createInlineTaskNotification",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "contentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "029e76bfcd70279acd22d488125dc454",
            "id": "936914f8502bab28553df0f472fa4f87cbb23cb871cb9a825222f522face951d",
            "metadata": {},
            "name": "useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation",
            "operationKind": "mutation",
            "text": "mutation useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation($contentId:ID!,$tasks:[IndividualInlineTaskNotificationInput]!){createInlineTaskNotification(input:{contentId:$contentId,tasks:$tasks}){contentId,success,errors{message}}}"
        }
    };
}();
$5360cbc6d166638c$var$node.hash = "fca74fc99391b016271338a6b81b557d";
var $5360cbc6d166638c$export$2e2bcd8739ae039 = $5360cbc6d166638c$var$node;











const $204e1c50e8dfb669$var$useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation = (0, $5360cbc6d166638c$export$2e2bcd8739ae039);
const $204e1c50e8dfb669$export$bb50e46e1081bc7f = ({ contentId: contentId, setError: setError, showDontNotifyFailedFlag: showDontNotifyFailedFlag })=>{
    const [createInlineTaskNotificationMutation, { error: createTaskNotificationError }] = (0, $308Wd.useMutationInterop)($204e1c50e8dfb669$var$useCreateInlineTaskNotificationMutationCreateInlineTaskNotificationMutation, {
        __callerPackage__: "mentions-notifications"
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const sendCreateInlineTaskNotifications = (0, $cozmU.useCallback)(({ tasks: tasks })=>{
        const fireAnalyticsEvent = (action)=>{
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'mentionsNotifications',
                    action: action,
                    actionSubject: 'createInlineTaskMention',
                    attributes: {
                        contentId: contentId,
                        mentions: tasks?.map((task)=>({
                                taskId: task.taskId,
                                mentionId: task.recipientMentionLocalId,
                                mentionedUserId: task.recipientAccountId
                            }))
                    }
                }
            }).fire();
        };
        // NCS draft syncs need to happen prior to mutation in order for
        // email content to show up. A 15 second buffer after user closes
        // the flag notification will give draft syncs a chance to happen.
        setTimeout(()=>{
            createInlineTaskNotificationMutation({
                variables: {
                    contentId: contentId,
                    tasks: tasks ?? []
                }
            }).then(()=>{
                fireAnalyticsEvent('succeeded');
            }).catch((error)=>{
                fireAnalyticsEvent('failed');
                setError(error);
            });
        }, 15000);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        contentId,
        createAnalyticsEvent,
        createInlineTaskNotificationMutation
    ]);
    const cancelInlineTaskNotifications = (0, $cozmU.useCallback)(({ tasks: tasks })=>{
        createInlineTaskNotificationMutation({
            variables: {
                contentId: contentId,
                tasks: tasks ?? []
            }
        }).catch(()=>{
            showDontNotifyFailedFlag();
        });
    }, [
        contentId,
        createInlineTaskNotificationMutation,
        showDontNotifyFailedFlag
    ]);
    return {
        sendCreateInlineTaskNotifications: sendCreateInlineTaskNotifications,
        cancelInlineTaskNotifications: cancelInlineTaskNotifications,
        createTaskNotificationError: createTaskNotificationError
    };
};


/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $55e2d13107c6bf2d$export$4fd34ed002cf6bfb = /*#__PURE__*/ function(ContentRole) {
    ContentRole["DEFAULT"] = "DEFAULT";
    ContentRole["EDITOR"] = "EDITOR";
    ContentRole["VIEWER"] = "VIEWER";
    return ContentRole;
}({});
var $55e2d13107c6bf2d$export$aa5f3445d469c06b = /*#__PURE__*/ function(ConfluencePrincipalType) {
    ConfluencePrincipalType["GROUP"] = "GROUP";
    ConfluencePrincipalType["USER"] = "USER";
    return ConfluencePrincipalType;
}({});


/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $1acca270709c231c$export$ab5aad00225c5662 = /*#__PURE__*/ function(Operation) {
    Operation["ASSIGNED"] = "ASSIGNED";
    Operation["COMPLETE"] = "COMPLETE";
    Operation["DELETED"] = "DELETED";
    Operation["IN_COMPLETE"] = "IN_COMPLETE";
    Operation["REWORDED"] = "REWORDED";
    Operation["UNASSIGNED"] = "UNASSIGNED";
    return Operation;
}({});





const $7af36150ec4f5d3b$export$b059320aeb0e91e6 = (0, $kSwu1.defineMessages)({
    mentionFlagTitle: {
        id: "mentions-notifications.mention.flag.title",
        defaultMessage: "{displayName} will be notified"
    },
    mentionFlagTitleTwoMentions: {
        id: "mentions-notifications.mention.flag.title.two.mentions",
        defaultMessage: "{displayName} and {somebodyElse} will be notified"
    },
    mentionFlagTitleMultipleMentions: {
        id: "mentions-notifications.mention.flag.title.multiple.mentions",
        defaultMessage: "{displayName}, {somebodyElse}, and {numOthers, plural, one {# other} other {# others}} will be notified"
    },
    mentionFlagDescription: {
        id: "mentions-notifications.mention.flag.description",
        defaultMessage: "We\u2019ll let them know you mentioned them."
    },
    taskMentionFlagTitle: {
        id: "mentions-notifications.task.mention.flag.title",
        defaultMessage: "We\u2019ll notify {displayName}"
    },
    taskMentionFlagDescription: {
        id: "mentions-notifications.task.mention.flag.description",
        defaultMessage: "We\u2019ll let them know you assigned them a task."
    },
    mentionFlagFailedTitle: {
        id: "mentions-notifications.mention.flag.failed.title",
        defaultMessage: "We weren\u2019t able to notify {displayName}"
    },
    mentionFlagFailedTitleWithoutDisplayName: {
        id: "mentions-notifications.mention.flag.failed.generic.title",
        defaultMessage: "We weren\u2019t able to notify the user"
    },
    mentionFlagFailedDescription: {
        id: "mentions-notifications.mention.flag.failed.description",
        defaultMessage: "In order to notify them, you\u2019ll need to @ mention them again."
    },
    mentionFlagDoNotNotifyButton: {
        id: "mentions-notifications.mention.flag.do.not.notify.button",
        defaultMessage: "Don\u2019t notify"
    },
    mentionFlagAcknowledgeButton: {
        id: "mentions-notifications.mention.flag.acknowledge.button",
        defaultMessage: "OK"
    },
    mentionFlagNoPermissionsTitle: {
        id: "mentions-notifications.mention.flag.no.permissions.title",
        defaultMessage: "Share with {displayName}?"
    },
    mentionFlagTwoNoPermissionsTitle: {
        id: "mentions-notifications.mention.flag.no.permissions.two.mentions.title",
        defaultMessage: "Share with {displayName} and {somebodyElse}?"
    },
    mentionFlagMultipleNoPermissionsTitle: {
        id: "mentions-notifications.mention.flag.no.permissions.multiple.mentions.title",
        defaultMessage: "Share with {displayName}, {somebodyElse}, and {numOthers, plural, one {# other} other {# others}}"
    },
    mentionFlagNoSpaceOrParentPermissionsTitle: {
        id: "mentions-notifications.mention.flag.no.space.parent.permissions.title",
        defaultMessage: "{displayName} won\u2019t be notified"
    },
    mentionFlagTwoNoSpaceOrParentPermissionsTitle: {
        id: "mentions-notifications.mention.flag.no.space.parent.permissions.two.mentions.title",
        defaultMessage: "{displayName} and {somebodyElse} won\u2019t be notified"
    },
    mentionFlagMultipleNoSpaceOrParentPermissionsTitle: {
        id: "mentions-notifications.mention.flag.no.space.parent.permissions.multiple.mentions.title",
        defaultMessage: "{displayName}, {somebodyElse}, and {numOthers, plural, one {# other} other {# others}} won\u2019t be notified"
    },
    taskMentionFlagNoPermissionsTitle: {
        id: "mentions-notifications.task.mention.flag.no.permissions.title",
        defaultMessage: "Share with {displayName}?"
    },
    mentionFlagNoSpaceOrParentPermissionsDescription: {
        id: "mentions-notifications.mention.flag.no.space.parent.permissions.description",
        defaultMessage: "They need space or parent access, so we can\u2019t let them know you mentioned them."
    },
    mentionFlagNoPermissionsDescription: {
        id: "mentions-notifications.mention.flag.no.permissions.description",
        defaultMessage: "They don\u2019t have access to this content, so we can\u2019t let them know you mentioned them."
    },
    taskMentionFlagNoPermissionsDescription: {
        id: "mentions-notifications.task.mention.flag.no.permissions.description",
        defaultMessage: "They don\u2019t have access to this content, so we can\u2019t assign them a task or notify them."
    },
    mentionFlagNoPermissionsParentRestrictionsDescription: {
        id: "mentions-notifications.mention.flag.no.permissions.parent.restrictions.description",
        defaultMessage: "They don\u2019t have access to a parent item, so we can\u2019t let them know you mentioned them."
    },
    taskMentionFlagNoPermissionsParentRestrictionsDescription: {
        id: "mentions-notifications.task.mention.flag.no.permissions.parent.restrictions.description",
        defaultMessage: "They don\u2019t have access to a parent item, so we can\u2019t assign them a task or notify them."
    },
    mentionFlagNoPermissionsSpaceRestrictionsDescription: {
        id: "mentions-notifications.mention.flag.no.permissions.space.restrictions.description",
        defaultMessage: "They don\u2019t have access to the space, so we can\u2019t let them know you mentioned them."
    },
    taskMentionFlagNoPermissionsSpaceRestrictionsDescription: {
        id: "mentions-notifications.task.mention.flag.no.permissions.space.restrictions.description",
        defaultMessage: "They don\u2019t have access to the space, so we can\u2019t assign them a task or notify them."
    },
    taskMentionFlagNoPermissionsParentSpaceRestrictionsDescription: {
        id: "mentions-notifications.task.mention.flag.no.permissions.parent.space.restrictions.description",
        defaultMessage: "They don\u2019t have access to a parent item or space, so we can\u2019t assign them this task or notify them."
    },
    mentionFlagShareNowButton: {
        id: "mentions-notifications.mention.flag.share.now.button",
        defaultMessage: "Share now"
    },
    mentionFlagDontShareButton: {
        id: "mentions-notifications.mention.flag.dont.share.button",
        defaultMessage: "Don\u2019t share"
    },
    mentionFlagShareFailedTitle: {
        id: "mentions-notifications.mention.flag.share.failed.title",
        defaultMessage: "We weren\u2019t able to share this content with {displayName}"
    },
    mentionFlagShareFailedDescription: {
        id: "mentions-notifications.mention.flag.share.failed.description",
        defaultMessage: "Please try again later."
    },
    deletedMentionFlagTitle: {
        id: "mentions-notifications.mention.flag.deleted.title",
        defaultMessage: "You just removed an @ mention"
    },
    deletedMentionFlagDescription: {
        id: "mentions-notifications.mention.flag.deleted.description",
        defaultMessage: "{name} won\u2019t be notified anymore"
    },
    deletedMentionFlagConfirmation: {
        id: "mentions-notifications.mention.flag.deleted.confirmation",
        defaultMessage: "Got it"
    },
    dontNotifyFailureTitle: {
        id: "mentions-notifications.mention.flag.do.not.notify.failure.title",
        defaultMessage: "Something went wrong"
    },
    dontNotifyFailureDescription: {
        id: "mentions-notifications.mention.flag.do.not.notify.failure.description",
        defaultMessage: "Due to an error, we weren\u2019t able to cancel this notification. "
    }
});






var $cAdj8 = parcelRequire("cAdj8");

const $4363b504cf9a037b$export$d8cade7866e82605 = ()=>{
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)();
    const canEditPageRestrictions = (0, $cozmU.useMemo)(()=>{
        if (pageInfo) {
            const pageType = pageInfo.type ?? '';
            const operations = pageInfo.operations || [];
            const userCanEditRestrictions = operations.some((o)=>o?.operation === 'restrict_content' && o?.targetType === pageType);
            return userCanEditRestrictions;
        }
        return false;
    }, [
        pageInfo
    ]);
    return canEditPageRestrictions;
};





const $2b2a9498abd1ee19$export$406377d40397a2f7 = (startTime)=>{
    const endTime = Date.now();
    let elapsedTimeInSeconds = 0;
    if (startTime.current !== null) elapsedTimeInSeconds = (endTime - startTime.current) / 1000; // Convert to seconds
    return elapsedTimeInSeconds;
};


const $36be47a9ed41f8db$var$getDisplayNames = (mentions)=>{
    const displayNames = new Set(mentions.map((mention)=>mention.displayName));
    const iterator = displayNames.values();
    const displayName = iterator.next().value ?? '';
    const somebodyElse = iterator.next().value ?? '';
    return {
        displayNames: displayNames,
        displayName: displayName,
        somebodyElse: somebodyElse
    };
};
const $36be47a9ed41f8db$export$fdb0a5f78dc34be6 = ({ flags: flags, contentId: contentId, isLivePage: isLivePage, isMentionsNotificationsEnabled: isMentionsNotificationsEnabled, editorActions: editorActions })=>{
    const [{ addedMentions: addedMentions, deletedMentions: deletedMentions, addedTasks: addedTasks, unrestrictedMentions: unrestrictedMentions, parentSpaceRestrictedMentions: parentSpaceRestrictedMentions, pageRestrictedMentions: pageRestrictedMentions, unrestrictedTasks: unrestrictedTasks, pageRestrictedTasks: pageRestrictedTasks, parentSpaceRestrictedTasks: parentSpaceRestrictedTasks, deletedTasks: deletedTasks, mentionsAdded: mentionsAdded, tasksAdded: tasksAdded }, { setAddedMentions: setAddedMentions, setDeletedMentions: setDeletedMentions, setUnrestrictedMentions: setUnrestrictedMentions, setParentSpaceRestrictedMentions: setParentSpaceRestrictedMentions, setPageRestrictedMentions: setPageRestrictedMentions, setUnrestrictedTasks: setUnrestrictedTasks, setPageRestrictedTasks: setPageRestrictedTasks, setParentSpaceRestrictedTasks: setParentSpaceRestrictedTasks, setDeletedTasks: setDeletedTasks, setMentionsAdded: setMentionsAdded, setTasksAdded: setTasksAdded }] = (0, $hdxAi.useMentionsNotifications)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { userId: currentUserId } = (0, $bQm3c.useSessionData)();
    //General Mention Flag IDs
    const [currentAddedMentionFlagId, setCurrentAddedMentionFlagId] = (0, $cozmU.useState)('');
    const [currentSpaceOrParentRestrictionMentionFlagId, setCurrentSpaceOrParentRestrictionMentionFlagId] = (0, $cozmU.useState)('');
    const [currentPageRestrictionMentionFlagId, setCurrentPageRestrictionMentionFlagId] = (0, $cozmU.useState)('');
    //Task Mentions Flag IDs
    const [currentAddedTaskFlagId, setCurrentAddedTaskFlagId] = (0, $cozmU.useState)('');
    const [currentPageRestrictionTaskFlagId, setCurrentPageRestrictionTaskFlagId] = (0, $cozmU.useState)('');
    const [currentSpaceOrParentRestrictionTaskFlagId, setCurrentSpaceOrParentRestrictionTaskFlagId] = (0, $cozmU.useState)('');
    //General Mention Timeouts
    const addedUnrestrictedMentionFlagTimeout = (0, $cozmU.useRef)();
    const pageRestrictedMentionFlagTimeout = (0, $cozmU.useRef)();
    const spaceParentRestrictedMentionFlagTimeout = (0, $cozmU.useRef)();
    //Task Mention Timeouts
    const addedUnrestrictedTaskFlagTimeout = (0, $cozmU.useRef)();
    const pageRestrictedTaskFlagTimeout = (0, $cozmU.useRef)();
    const spaceParentRestrictedTaskFlagTimeout = (0, $cozmU.useRef)();
    const [error, setError] = (0, $cozmU.useState)(null);
    const mentionsToDisplay = (0, $cozmU.useMemo)(()=>[
            ...addedMentions,
            ...addedTasks
        ], [
        addedMentions,
        addedTasks
    ]);
    const { updatedUsersContentPermissionsError: updatedUsersContentPermissionsError, updatedUsersContentPermissionsLoading: updatedUsersContentPermissionsLoading, updateUsersContentPermissionMutation: updateUsersContentPermissionMutation } = (0, $a429a791ecef3570$export$a5b8a857cb669f1f)({
        contentId: contentId,
        isUpdatedMentionsInLivePagesEnabled: isMentionsNotificationsEnabled,
        isLivePage: isLivePage,
        currentUserId: currentUserId,
        mentionsToDisplay: mentionsToDisplay,
        source: 'mentionNoAccessFlag'
    });
    const canEditPageRestrictions = (0, $4363b504cf9a037b$export$d8cade7866e82605)();
    (0, $cozmU.useEffect)(()=>{
        const getDuplicateMentions = async (mentions)=>{
            const duplicateMentions = new Set();
            if (mentions.length > 0) {
                const mentionCounts = new Map();
                const editorContent = await editorActions?.getValue();
                editorContent?.content?.forEach((node)=>{
                    node?.content?.forEach((content)=>{
                        if (content.type === 'mention') {
                            if (mentionCounts.has(content.attrs.id)) mentionCounts.set(content.attrs.id, mentionCounts.get(content.attrs.id) + 1);
                            else mentionCounts.set(content.attrs.id, 1);
                        }
                    });
                });
                mentions.forEach((mention)=>{
                    if (mentionCounts.get(mention.id) > 1) duplicateMentions.add(mention.id);
                });
            }
            return duplicateMentions;
        };
        getDuplicateMentions(mentionsToDisplay).then((duplicateMentions)=>{
            if (duplicateMentions.size > 0) createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: 'mentionsNotifications',
                    action: 'created',
                    actionSubject: 'mention',
                    attributes: {
                        isDuplicate: true
                    }
                }
            }).fire();
        }).catch((e)=>{
            setError(e);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mentionsToDisplay
    ]);
    const mentionsFlagStartTime = (0, $cozmU.useRef)(null);
    const tasksFlagStartTime = (0, $cozmU.useRef)(null);
    // `showCustomFlag` for confirmation flags without CTA
    const showCustomFlag = (0, $cozmU.useCallback)(({ title: title, description: description, userPhoto: userPhoto, autoDismiss: autoDismiss = true, id: id, handleOnClose: handleOnClose })=>{
        flags.showCustomFlag({
            id: id ?? undefined,
            title: title,
            description: description,
            isAutoDismiss: autoDismiss,
            customIcon: userPhoto ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
                src: userPhoto,
                label: "mention"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMv2K))), {
                spacing: "spacious",
                label: "mention"
            }),
            onClose: handleOnClose
        });
    }, [
        flags
    ]);
    const showDontNotifyFailedFlag = (0, $cozmU.useCallback)(()=>{
        flags.showCustomFlag({
            title: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).dontNotifyFailureTitle),
            description: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).dontNotifyFailureDescription),
            customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                spacing: "spacious",
                label: "error"
            }),
            isAutoDismiss: true
        });
    }, [
        flags,
        formatMessage
    ]);
    const { sendMentionNotification: sendMentionNotification, sendCancelMentionNotification: sendCancelMentionNotification, contentMentionNotificationError: contentMentionNotificationError } = (0, $05c7f8c23696cebd$export$82f89b951e37c769)({
        contentId: contentId,
        setError: setError,
        showDontNotifyFailedFlag: showDontNotifyFailedFlag
    });
    const { sendCreateInlineTaskNotifications: sendCreateInlineTaskNotifications, cancelInlineTaskNotifications: cancelInlineTaskNotifications, createTaskNotificationError: createTaskNotificationError } = (0, $204e1c50e8dfb669$export$bb50e46e1081bc7f)({
        contentId: contentId,
        setError: setError,
        showDontNotifyFailedFlag: showDontNotifyFailedFlag
    });
    // `showCustomFlagWithAction` for:
    // - unrestricted users with "do not notify" CTA
    // - share now for restricted users
    // - deleted mention flag
    const showCustomFlagWithActions = (0, $cozmU.useCallback)(({ title: title, description: description, userPhoto: userPhoto, actions: actions, handleOnClose: handleOnClose, autoDismiss: autoDismiss = true, id: id })=>{
        flags.showCustomFlag({
            title: title,
            description: description,
            isAutoDismiss: autoDismiss,
            customIcon: userPhoto ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
                src: userPhoto,
                label: "mention"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMv2K))), {
                spacing: "spacious",
                label: "mention"
            }),
            onClose: handleOnClose && handleOnClose,
            actions: actions,
            id: id ?? undefined
        });
    }, [
        flags
    ]);
    const displayNoPermissionsFlag = (0, $cozmU.useCallback)(({ displayNames: displayNames, flagFields: flagFields, displayName: displayName, somebodyElse: somebodyElse, flagId: flagId, restrictedLevel: restrictedLevel = 'page', hasAction: hasAction = false, userPhoto: userPhoto })=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'triggered',
                actionSubject: 'mentionNoAccessFlag',
                source: 'page',
                attributes: {
                    restrictedLevel: restrictedLevel,
                    isLivePage: isLivePage
                }
            }
        }).fire();
        const hasPageRestrictionsAndCanEdit = restrictedLevel === 'page' && canEditPageRestrictions;
        const showFlagFn = hasAction ? showCustomFlagWithActions : showCustomFlag;
        if (displayNames.size === 1) showFlagFn({
            ...flagFields,
            title: hasPageRestrictionsAndCanEdit ? formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagNoPermissionsTitle, {
                displayName: displayName
            }) : formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagNoSpaceOrParentPermissionsTitle, {
                displayName: displayName
            }),
            id: flagId,
            userPhoto: userPhoto
        });
        else if (displayNames.size === 2) showFlagFn({
            ...flagFields,
            title: hasPageRestrictionsAndCanEdit ? formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagTwoNoPermissionsTitle, {
                displayName: displayName,
                somebodyElse: somebodyElse
            }) : formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagTwoNoSpaceOrParentPermissionsTitle, {
                displayName: displayName,
                somebodyElse: somebodyElse
            }),
            id: flagId
        });
        else //3 or more mentioned users
        showFlagFn({
            ...flagFields,
            title: hasPageRestrictionsAndCanEdit ? formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagMultipleNoPermissionsTitle, {
                displayName: displayName,
                somebodyElse: somebodyElse,
                numOthers: displayNames.size - 2
            }) : formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagMultipleNoSpaceOrParentPermissionsTitle, {
                displayName: displayName,
                somebodyElse: somebodyElse,
                numOthers: displayNames.size - 2
            }),
            id: flagId
        });
    }, [
        createAnalyticsEvent,
        formatMessage,
        showCustomFlag,
        showCustomFlagWithActions,
        isLivePage,
        canEditPageRestrictions
    ]);
    const getNotificationPayload = (notifyAction, mentions, type)=>{
        const mentionsWithNotificationAction = [];
        const tasksWithNotificationAction = [];
        mentions.forEach((mention)=>{
            if (type === 'standard') mentionsWithNotificationAction.push({
                mentionedUserAccountId: mention.id,
                mentionLocalId: mention.localId,
                notificationAction: notifyAction
            });
            else if (type === 'task') tasksWithNotificationAction.push({
                notificationAction: notifyAction,
                operation: (0, $1acca270709c231c$export$ab5aad00225c5662).ASSIGNED,
                recipientAccountId: mention.id,
                recipientMentionLocalId: mention.localId,
                taskId: mention.taskLocalId ?? ''
            });
        });
        return {
            mentionsWithNotificationAction: mentionsWithNotificationAction,
            tasksWithNotificationAction: tasksWithNotificationAction
        };
    };
    const sendNotificationFn = (mentions, type, closeFlagFn)=>{
        const { mentionsWithNotificationAction: mentionsWithNotificationAction, tasksWithNotificationAction: tasksWithNotificationAction } = getNotificationPayload((0, $a7SsH.NotificationAction).NOTIFY, mentions, type);
        if (type === 'standard') sendMentionNotification({
            mentions: mentionsWithNotificationAction
        });
        else if (type === 'task') sendCreateInlineTaskNotifications({
            tasks: tasksWithNotificationAction
        });
        closeFlagFn?.();
    };
    const showUnrestrictedPageAccessFlag = (0, $cozmU.useCallback)(({ type: type, mentions: mentions, userPhoto: userPhoto })=>{
        const analyticsPayload = mentions.map((mention)=>{
            if (type === 'standard') return {
                mentionedUserId: mention.id,
                mentionId: mention.localId
            };
            else if (type === 'task') return {
                taskId: mention.taskLocalId,
                mentionId: mention.localId,
                mentionedUserId: mention.id
            };
        });
        let addedMentionFlagId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        const handleFlag = (currentFlagId, setCurrentFlagId, flagStartTime)=>{
            if (currentFlagId) addedMentionFlagId = currentFlagId;
            else {
                setCurrentFlagId(addedMentionFlagId);
                flagStartTime.current = Date.now();
            }
        };
        if (type === 'standard') handleFlag(currentAddedMentionFlagId, setCurrentAddedMentionFlagId, mentionsFlagStartTime);
        else if (type === 'task') handleFlag(currentAddedTaskFlagId, setCurrentAddedTaskFlagId, tasksFlagStartTime);
        const { displayNames: displayNames, displayName: displayName, somebodyElse: somebodyElse } = $36be47a9ed41f8db$var$getDisplayNames(mentions);
        const closeFlag = ()=>{
            flags.hideFlag(addedMentionFlagId);
            if (type === 'standard') {
                setCurrentAddedMentionFlagId('');
                setUnrestrictedMentions([]);
                mentionsFlagStartTime.current = null;
            } else if (type === 'task') {
                setCurrentAddedTaskFlagId('');
                setUnrestrictedTasks([]);
                tasksFlagStartTime.current = null;
            }
        };
        const sendDontNotifyFn = ()=>{
            const { mentionsWithNotificationAction: mentionsWithNotificationAction, tasksWithNotificationAction: tasksWithNotificationAction } = getNotificationPayload((0, $a7SsH.NotificationAction).DONT_NOTIFY, mentions, type);
            if (type === 'standard') {
                sendCancelMentionNotification({
                    mentions: mentionsWithNotificationAction
                });
                clearTimeout(addedUnrestrictedMentionFlagTimeout.current);
            } else if (type === 'task') {
                cancelInlineTaskNotifications({
                    tasks: tasksWithNotificationAction
                });
                clearTimeout(addedUnrestrictedTaskFlagTimeout.current);
            }
        };
        const handleClose = ()=>{
            //when "X" is clicked, or user acknowledges the flag
            const elapsedTimeInSeconds = type === 'standard' ? (0, $2b2a9498abd1ee19$export$406377d40397a2f7)(mentionsFlagStartTime) : (0, $2b2a9498abd1ee19$export$406377d40397a2f7)(tasksFlagStartTime);
            closeFlag();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: 'mentionsNotifications',
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: type === 'standard' ? 'dismissMentionsNotifications' : 'dismissTaskMentionsNotifications',
                    attributes: {
                        contentId: contentId,
                        elapsedTimeInSeconds: elapsedTimeInSeconds,
                        mentions: analyticsPayload
                    }
                }
            }).fire();
        };
        //When there is a flag currently open when a new mention is added, we want to reset the timer for the flag to be open, i.e. persist the flag to be open for another 8 seconds
        if (type === 'standard') {
            clearTimeout(addedUnrestrictedMentionFlagTimeout.current);
            addedUnrestrictedMentionFlagTimeout.current = setTimeout(()=>{
                sendNotificationFn(mentions, type, closeFlag);
            }, 8000);
        } else if (type === 'task') {
            clearTimeout(addedUnrestrictedTaskFlagTimeout.current);
            addedUnrestrictedTaskFlagTimeout.current = setTimeout(()=>{
                sendNotificationFn(mentions, type, closeFlag);
            }, 8000);
        }
        const sharedFlagFields = {
            description: type === 'standard' ? formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagDescription) : formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).taskMentionFlagDescription),
            actions: [
                {
                    content: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagAcknowledgeButton),
                    onClick: handleClose
                },
                {
                    content: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagDoNotNotifyButton),
                    onClick: ()=>{
                        //On clicking "don't notify"
                        const elapsedTimeInSeconds = type === 'standard' ? (0, $2b2a9498abd1ee19$export$406377d40397a2f7)(mentionsFlagStartTime) : (0, $2b2a9498abd1ee19$export$406377d40397a2f7)(tasksFlagStartTime);
                        sendDontNotifyFn();
                        closeFlag();
                        createAnalyticsEvent({
                            type: 'sendUIEvent',
                            data: {
                                source: 'mentionsNotifications',
                                action: 'clicked',
                                actionSubject: 'button',
                                actionSubjectId: type === 'standard' ? 'doNotNotify' : 'doNotAssign',
                                attributes: {
                                    contentId: contentId,
                                    mentions: analyticsPayload,
                                    elapsedTimeInSeconds: elapsedTimeInSeconds
                                }
                            }
                        }).fire();
                    }
                }
            ],
            handleOnClose: handleClose,
            autoDismiss: false
        };
        if (displayNames.size === 1) showCustomFlagWithActions({
            ...sharedFlagFields,
            title: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagTitle, {
                displayName: displayName
            }),
            id: addedMentionFlagId,
            userPhoto: userPhoto
        });
        else if (displayNames.size === 2) showCustomFlagWithActions({
            ...sharedFlagFields,
            title: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagTitleTwoMentions, {
                displayName: displayName,
                somebodyElse: somebodyElse
            }),
            id: addedMentionFlagId
        });
        else //3 or more mentioned users
        showCustomFlagWithActions({
            ...sharedFlagFields,
            title: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagTitleMultipleMentions, {
                displayName: displayName,
                somebodyElse: somebodyElse,
                numOthers: displayNames.size - 2
            }),
            id: addedMentionFlagId
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        contentId,
        createAnalyticsEvent,
        currentAddedMentionFlagId,
        flags,
        formatMessage,
        sendCancelMentionNotification,
        sendMentionNotification,
        setUnrestrictedMentions,
        showCustomFlagWithActions,
        currentAddedTaskFlagId,
        sendCreateInlineTaskNotifications,
        setUnrestrictedTasks,
        cancelInlineTaskNotifications,
        mentionsFlagStartTime,
        tasksFlagStartTime
    ]);
    const showPageRestrictionsFlag = (0, $cozmU.useCallback)(({ type: type, mentions: mentions })=>{
        let addedMentionFlagId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        //If a flag ID is already in local state, that means the respective flag is currently open. If not, we generate a uuid to set on the flag which is about to be opened. Having a uuid on the flag allows us to update the content without closing the flag
        if (type === 'standard' && currentPageRestrictionMentionFlagId) addedMentionFlagId = currentPageRestrictionMentionFlagId;
        else if (type === 'task' && currentPageRestrictionTaskFlagId) addedMentionFlagId = currentPageRestrictionTaskFlagId;
        if (type === 'standard' && !currentPageRestrictionMentionFlagId) setCurrentPageRestrictionMentionFlagId(addedMentionFlagId);
        if (type === 'task' && !currentPageRestrictionTaskFlagId) setCurrentPageRestrictionTaskFlagId(addedMentionFlagId);
        const { displayNames: displayNames, displayName: displayName, somebodyElse: somebodyElse } = $36be47a9ed41f8db$var$getDisplayNames(mentions);
        const closeFlag = ()=>{
            flags.hideFlag(addedMentionFlagId);
            if (type === 'standard') {
                clearTimeout(pageRestrictedMentionFlagTimeout.current);
                setCurrentPageRestrictionMentionFlagId('');
                setPageRestrictedMentions([]);
            } else if (type === 'task') {
                clearTimeout(pageRestrictedTaskFlagTimeout.current);
                setCurrentPageRestrictionTaskFlagId('');
                setPageRestrictedTasks([]);
            }
        };
        //When there is a flag currently open when a new mention is added, we want to reset the timer for the flag to be open, i.e. persist the flag to be open for another 8 seconds
        if (type === 'standard') {
            clearTimeout(pageRestrictedMentionFlagTimeout.current);
            pageRestrictedMentionFlagTimeout.current = setTimeout(()=>{
                closeFlag();
            }, 8000);
        } else if (type === 'task') {
            clearTimeout(pageRestrictedTaskFlagTimeout.current);
            pageRestrictedTaskFlagTimeout.current = setTimeout(()=>{
                closeFlag();
            }, 8000);
        }
        const flagActions = [
            {
                content: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagShareNowButton),
                onClick: ()=>{
                    //On clicking "share now" - Update page permissions
                    closeFlag();
                    createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            source: 'mentionNoAccessFlag',
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'shareNowButton',
                            attributes: {
                                mentionType: type,
                                isLivePage: isLivePage
                            }
                        }
                    }).fire();
                    updateUsersContentPermissionMutation({
                        variables: {
                            contentId: contentId,
                            input: mentions?.map((user)=>({
                                    contentRole: (0, $55e2d13107c6bf2d$export$4fd34ed002cf6bfb).VIEWER,
                                    principalId: user.id,
                                    confluencePrincipalType: (0, $55e2d13107c6bf2d$export$aa5f3445d469c06b).USER
                                }))
                        }
                    }).then(()=>{
                        // Only send immediate notification for Live Pages
                        if (isLivePage) sendNotificationFn(mentions, type, closeFlag);
                    }).catch((e)=>{
                        setError(e);
                        showCustomFlag({
                            title: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagShareFailedTitle),
                            description: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagShareFailedDescription)
                        });
                    });
                }
            },
            {
                content: formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagDontShareButton),
                onClick: ()=>{
                    closeFlag();
                    createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            source: 'mentionNoAccessFlag',
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'dontShareButton',
                            attributes: {
                                mentionType: type,
                                isLivePage: isLivePage
                            }
                        }
                    }).fire();
                }
            }
        ];
        const sharedFlagFields = {
            description: type === 'standard' ? formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagNoPermissionsDescription) : formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).taskMentionFlagNoPermissionsDescription),
            actions: canEditPageRestrictions ? flagActions : undefined,
            handleOnClose: ()=>{
                closeFlag();
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        source: 'mentionNoAccessFlag',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'dismissButton',
                        attributes: {
                            mentionType: type,
                            restrictedLevel: 'page',
                            isLivePage: isLivePage
                        }
                    }
                }).fire();
            },
            autoDismiss: false
        };
        displayNoPermissionsFlag({
            displayNames: displayNames,
            flagFields: {
                ...sharedFlagFields,
                title: ''
            },
            displayName: displayName,
            somebodyElse: somebodyElse,
            flagId: addedMentionFlagId,
            restrictedLevel: 'page',
            hasAction: true,
            userPhoto: mentions[0]?.userPhoto
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        canEditPageRestrictions,
        contentId,
        createAnalyticsEvent,
        currentPageRestrictionMentionFlagId,
        currentPageRestrictionTaskFlagId,
        displayNoPermissionsFlag,
        flags,
        formatMessage,
        setPageRestrictedMentions,
        setPageRestrictedTasks,
        showCustomFlag,
        updateUsersContentPermissionMutation
    ]);
    const showParentSpaceRestrictedFlag = (0, $cozmU.useCallback)(({ type: type, mentions: mentions })=>{
        let addedMentionFlagId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        //If a flag ID is already in local state, that means the respective flag is currently open. If not, we generate a uuid to set on the flag which is about to be opened. Having a uuid on the flag allows us to update the content without closing the flag
        if (type === 'standard' && currentSpaceOrParentRestrictionMentionFlagId) addedMentionFlagId = currentSpaceOrParentRestrictionMentionFlagId;
        else if (type === 'task' && currentSpaceOrParentRestrictionTaskFlagId) addedMentionFlagId = currentSpaceOrParentRestrictionTaskFlagId;
        if (type === 'standard' && !currentSpaceOrParentRestrictionMentionFlagId) setCurrentSpaceOrParentRestrictionMentionFlagId(addedMentionFlagId);
        if (type === 'task' && !currentSpaceOrParentRestrictionTaskFlagId) setCurrentSpaceOrParentRestrictionTaskFlagId(addedMentionFlagId);
        const { displayNames: displayNames, displayName: displayName, somebodyElse: somebodyElse } = $36be47a9ed41f8db$var$getDisplayNames(mentions);
        const closeFlag = ()=>{
            flags.hideFlag(addedMentionFlagId);
            if (type === 'standard') {
                clearTimeout(spaceParentRestrictedMentionFlagTimeout.current);
                setCurrentSpaceOrParentRestrictionMentionFlagId('');
                setParentSpaceRestrictedMentions([]);
            } else if (type === 'task') {
                clearTimeout(spaceParentRestrictedTaskFlagTimeout.current);
                setCurrentSpaceOrParentRestrictionTaskFlagId('');
                setParentSpaceRestrictedTasks([]);
            }
        };
        //When there is a flag currently open when a new mention is added, we want to reset the timer for the flag to be open, i.e. persist the flag to be open for another 8 seconds
        if (type === 'standard') {
            clearTimeout(spaceParentRestrictedMentionFlagTimeout.current);
            spaceParentRestrictedMentionFlagTimeout.current = setTimeout(()=>{
                closeFlag();
            }, 8000);
        } else if (type === 'task') {
            clearTimeout(spaceParentRestrictedTaskFlagTimeout.current);
            spaceParentRestrictedTaskFlagTimeout.current = setTimeout(()=>{
                closeFlag();
            }, 8000);
        }
        const sharedFlagFields = {
            description: type === 'standard' ? formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).mentionFlagNoSpaceOrParentPermissionsDescription) : formatMessage((0, $7af36150ec4f5d3b$export$b059320aeb0e91e6).taskMentionFlagNoPermissionsParentSpaceRestrictionsDescription),
            handleOnClose: ()=>{
                closeFlag();
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        source: 'mentionNoAccessFlag',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'dismissButton',
                        attributes: {
                            mentionType: type,
                            restrictedLevel: 'parent',
                            isLivePage: isLivePage
                        }
                    }
                }).fire();
            },
            autoDismiss: false
        };
        displayNoPermissionsFlag({
            displayNames: displayNames,
            flagFields: {
                ...sharedFlagFields,
                title: '',
                actionContent: '',
                actionOnClick: ()=>{}
            },
            displayName: displayName,
            somebodyElse: somebodyElse,
            restrictedLevel: 'parent',
            flagId: addedMentionFlagId,
            userPhoto: mentions[0]?.userPhoto
        });
    }, [
        createAnalyticsEvent,
        currentSpaceOrParentRestrictionMentionFlagId,
        currentSpaceOrParentRestrictionTaskFlagId,
        formatMessage,
        displayNoPermissionsFlag,
        flags,
        setParentSpaceRestrictedMentions,
        setParentSpaceRestrictedTasks,
        isLivePage
    ]);
    (0, $cozmU.useEffect)(()=>{
        //Handling deleted mentions
        if (deletedMentions.length > 0) {
            //Handles updating content of current open mention flags
            const deletedMentionsLocalIds = new Set(deletedMentions.map((mention)=>mention.localId));
            //Filter out deleted mentions from current open general mention flag
            const remainingUnrestrictedStandardMentions = unrestrictedMentions.filter((unrestrictedMention)=>!deletedMentionsLocalIds.has(unrestrictedMention.localId));
            const remainingParentSpaceRestrictedStandardMentions = parentSpaceRestrictedMentions.filter((parentSpaceRestrictedMention)=>!deletedMentionsLocalIds.has(parentSpaceRestrictedMention.localId));
            const remainingPageRestrictedStandardMentions = pageRestrictedMentions.filter((pageRestrictedMention)=>!deletedMentionsLocalIds.has(pageRestrictedMention.localId));
            //Close general mention flag if none remain
            if (remainingUnrestrictedStandardMentions?.length === 0) {
                clearTimeout(addedUnrestrictedMentionFlagTimeout.current);
                flags.hideFlag(currentAddedMentionFlagId);
                setCurrentAddedMentionFlagId('');
            }
            if (remainingParentSpaceRestrictedStandardMentions?.length === 0) {
                clearTimeout(spaceParentRestrictedMentionFlagTimeout.current);
                flags.hideFlag(currentSpaceOrParentRestrictionMentionFlagId);
                setCurrentSpaceOrParentRestrictionMentionFlagId('');
            }
            if (remainingPageRestrictedStandardMentions?.length === 0) {
                clearTimeout(pageRestrictedMentionFlagTimeout.current);
                flags.hideFlag(currentPageRestrictionMentionFlagId);
                setCurrentPageRestrictionMentionFlagId('');
            }
            setUnrestrictedMentions(remainingUnrestrictedStandardMentions);
            setParentSpaceRestrictedMentions(remainingParentSpaceRestrictedStandardMentions);
            setPageRestrictedMentions(remainingPageRestrictedStandardMentions);
            setDeletedMentions([]);
        }
        if (deletedTasks.length > 0) {
            //Handles updating content of current open task flags
            const deletedTasksLocalIds = new Set(deletedTasks.map((mention)=>mention.localId));
            //Filter out deleted mentions from current open task mention flag
            const remainingUnrestrictedTasks = unrestrictedTasks.filter((unrestrictedTask)=>!deletedTasksLocalIds.has(unrestrictedTask.localId));
            const remainingParentSpaceRestrictedTasks = parentSpaceRestrictedTasks.filter((parentSpaceRestrictedTask)=>!deletedTasksLocalIds.has(parentSpaceRestrictedTask.localId));
            const remainingPageRestrictedTasks = pageRestrictedTasks.filter((pageRestrictedTask)=>!deletedTasksLocalIds.has(pageRestrictedTask.localId));
            //Close task mention flag if none remain
            if (remainingUnrestrictedTasks?.length === 0) {
                clearTimeout(addedUnrestrictedTaskFlagTimeout.current);
                flags.hideFlag(currentAddedTaskFlagId);
                setCurrentAddedTaskFlagId('');
            }
            if (remainingParentSpaceRestrictedTasks?.length === 0) {
                clearTimeout(spaceParentRestrictedTaskFlagTimeout.current);
                flags.hideFlag(currentSpaceOrParentRestrictionTaskFlagId);
                setCurrentSpaceOrParentRestrictionTaskFlagId('');
            }
            if (remainingPageRestrictedTasks?.length === 0) {
                clearTimeout(pageRestrictedTaskFlagTimeout.current);
                flags.hideFlag(currentPageRestrictionTaskFlagId);
                setCurrentPageRestrictionTaskFlagId('');
            }
            setUnrestrictedTasks(remainingUnrestrictedTasks);
            setParentSpaceRestrictedTasks(remainingParentSpaceRestrictedTasks);
            setPageRestrictedTasks(remainingPageRestrictedTasks);
            setDeletedTasks([]);
        }
    //leaving addedMentions out of the dependency array otherwise the deleted flag will be displayed twice
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        setDeletedMentions,
        flags,
        showCustomFlagWithActions,
        formatMessage,
        setAddedMentions,
        deletedMentions,
        setDeletedTasks,
        deletedTasks
    ]);
    const checkPastedMentions = (mentions)=>{
        return mentions.some((mention)=>mention.method === 'pasted');
    };
    (0, $cozmU.useEffect)(()=>{
        if (!updatedUsersContentPermissionsLoading && unrestrictedMentions?.length) {
            if (isLivePage) {
                if (checkPastedMentions(unrestrictedMentions)) // When mention is pasted, show flag
                showUnrestrictedPageAccessFlag({
                    type: 'standard',
                    mentions: unrestrictedMentions,
                    userPhoto: unrestrictedMentions[0]?.userPhoto
                });
                else {
                    // When mention is typed, only send notification
                    sendNotificationFn(unrestrictedMentions, 'standard');
                    setUnrestrictedMentions([]);
                }
            } else setUnrestrictedMentions([]);
        }
    // removing variables from dependency array which cause duplicate flags
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        unrestrictedMentions,
        updatedUsersContentPermissionsLoading,
        isLivePage
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!updatedUsersContentPermissionsLoading && unrestrictedTasks?.length) {
            if (isLivePage) {
                if (checkPastedMentions(unrestrictedTasks)) // When mention is pasted, show flag
                showUnrestrictedPageAccessFlag({
                    type: 'task',
                    mentions: unrestrictedTasks,
                    userPhoto: unrestrictedTasks[0]?.userPhoto
                });
                else {
                    // When mention is typed, only send notification
                    sendNotificationFn(unrestrictedTasks, 'task');
                    setUnrestrictedTasks([]);
                }
            } else setUnrestrictedTasks([]);
        }
    // removing variables from dependency array which cause duplicate flags
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        unrestrictedTasks,
        updatedUsersContentPermissionsLoading,
        isLivePage
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!updatedUsersContentPermissionsLoading && parentSpaceRestrictedMentions?.length) showParentSpaceRestrictedFlag({
            type: 'standard',
            mentions: parentSpaceRestrictedMentions
        });
    // removing variables from dependency array which cause duplicate flags
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        flags,
        parentSpaceRestrictedMentions,
        updatedUsersContentPermissionsLoading
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!updatedUsersContentPermissionsLoading && parentSpaceRestrictedTasks?.length) showParentSpaceRestrictedFlag({
            type: 'task',
            mentions: parentSpaceRestrictedTasks
        });
    // removing variables from dependency array which cause duplicate flags
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        flags,
        parentSpaceRestrictedTasks,
        updatedUsersContentPermissionsLoading
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!updatedUsersContentPermissionsLoading && pageRestrictedMentions?.length) showPageRestrictionsFlag({
            type: 'standard',
            mentions: pageRestrictedMentions
        });
    // removing variables from dependency array which cause duplicate flags
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        canEditPageRestrictions,
        flags,
        pageRestrictedMentions,
        updatedUsersContentPermissionsLoading
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!updatedUsersContentPermissionsLoading && pageRestrictedTasks?.length) showPageRestrictionsFlag({
            type: 'task',
            mentions: pageRestrictedTasks
        });
    // removing variables from dependency array which cause duplicate flags
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        canEditPageRestrictions,
        flags,
        pageRestrictedTasks,
        updatedUsersContentPermissionsLoading
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (mentionsAdded.currentUser.length > 0) {
            if (isLivePage) {
                const { mentionsWithNotificationAction: mentionsWithNotificationAction } = getNotificationPayload((0, $a7SsH.NotificationAction).DONT_NOTIFY, mentionsAdded.currentUser, 'standard');
                sendCancelMentionNotification({
                    mentions: mentionsWithNotificationAction
                });
            }
            setMentionsAdded({
                currentUser: []
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mentionsAdded.currentUser
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (tasksAdded.currentUser.length > 0) {
            if (isLivePage) {
                const { tasksWithNotificationAction: tasksWithNotificationAction } = getNotificationPayload((0, $a7SsH.NotificationAction).DONT_NOTIFY, tasksAdded.currentUser, 'task');
                cancelInlineTaskNotifications({
                    tasks: tasksWithNotificationAction
                });
            }
            setTasksAdded({
                currentUser: []
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tasksAdded.currentUser
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }), createTaskNotificationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: createTaskNotificationError
    }), contentMentionNotificationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: contentMentionNotificationError
    }), updatedUsersContentPermissionsError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: updatedUsersContentPermissionsError
    }));
};
const $36be47a9ed41f8db$export$6124ca97c5c9fe4d = ({ children: children, flags: flags, contentId: contentId, isLivePage: isLivePage, isMentionsNotificationsEnabled: isMentionsNotificationsEnabled, editorActions: editorActions })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COMMENTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($36be47a9ed41f8db$export$fdb0a5f78dc34be6, {
        flags: flags,
        contentId: contentId,
        isLivePage: isLivePage,
        isMentionsNotificationsEnabled: isMentionsNotificationsEnabled,
        editorActions: editorActions
    })), children);
};



var $hwk5r = parcelRequire("hwk5r");

parcelRequire("kGaEh");
var $lWVgZ = parcelRequire("lWVgZ");
var $kGaEh = parcelRequire("kGaEh");


var $2HGN8 = parcelRequire("2HGN8");


var $c4PY4 = parcelRequire("c4PY4");


var $e8Lxy = parcelRequire("e8Lxy");


var $hMRhJ = parcelRequire("hMRhJ");


var $gKaeO = parcelRequire("gKaeO");


var $fE1Ao = parcelRequire("fE1Ao");


var $a1uFh = parcelRequire("a1uFh");


var $5cryL = parcelRequire("5cryL");


var $ivb8S = parcelRequire("ivb8S");

/* ApprovalInProgressEditorBlocker.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $4ez2K = parcelRequire("4ez2K");


var $4aRua = parcelRequire("4aRua");


var $2QUbq = parcelRequire("2QUbq");


var $laFNM = parcelRequire("laFNM");


var $akN4j = parcelRequire("akN4j");


var $6zK0v = parcelRequire("6zK0v");

const $79befcd2c8d3c320$var$i18n = (0, $kSwu1.defineMessages)({
    approvalInProgressBannerPrefixImproved: {
        id: "approvals.editor.approval-in-progress.banner.prefix.improved",
        defaultMessage: "Editing is locked while an approval is pending."
    },
    approvalInProgressCancelCta: {
        id: "approvals.editor.approval-in-progress.banner.cancel-cta",
        defaultMessage: "Cancel approval"
    },
    approvedBannerPrefixImproved: {
        id: "approvals.editor.approved.banner.prefix.improved",
        defaultMessage: "You cannot edit an approved page without clearing the approval."
    },
    approvedClearCta: {
        id: "approvals.editor.approved.banner.clear-cta",
        defaultMessage: "Clear approval"
    }
});
const $79befcd2c8d3c320$var$styles = {
    banner: "_1rjc1b66 _18zrv47k _4t3i1ylp _bfhkhfxm"
};
const $79befcd2c8d3c320$var$TRIGGER = 'banner'; /**
                           * When approval is in progress (isDraftLockedForEditing), shows a banner explaining that editing
                           * is not allowed. Renders nothing when there is no approval in progress or when changes are
                           * requested (DENIED status) — in that case editing is permitted.
                           *
                           * - PENDING: "Editing is locked while an approval is pending. Cancel approval"
                           * - APPROVED: "You cannot edit an approved page without clearing the approval. Clear approval."
                           * - DENIED / no lock: renders nothing
                           */ 
const $79befcd2c8d3c320$export$8626b7a3aacc0076 = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { isDraftLockedForEditing: isDraftLockedForEditing, approvalRequest: approvalRequest, isCurrentUserRequestor: isCurrentUserRequestor, isCurrentUserApprover: isCurrentUserApprover, contentId: contentId } = (0, $laFNM.useApprovals)();
    const { cancelWorkflowApplication: cancelWorkflowApplication } = (0, $laFNM.useApprovalsDispatch)();
    const [isConfirmModalOpen, setIsConfirmModalOpen] = (0, $cozmU.useState)(false);
    const analyticsAttributes = (0, $cozmU.useMemo)(()=>{
        const approvers = approvalRequest?.review?.approvers ?? [];
        return {
            reviewId: approvalRequest?.review?.reviewId,
            applicationId: approvalRequest?.application?.applicationId,
            contentId: contentId,
            isRequestor: isCurrentUserRequestor,
            isApprover: isCurrentUserApprover,
            isReviewPending: approvalRequest?.review?.reviewStatus === 'PENDING',
            currentReviewStatus: (0, $2QUbq.computeReviewStatusCounts)(approvers),
            trigger: $79befcd2c8d3c320$var$TRIGGER
        };
    }, [
        approvalRequest,
        contentId,
        isCurrentUserApprover,
        isCurrentUserRequestor
    ]);
    const reviewStatus = approvalRequest?.review?.reviewStatus;
    const isPending = reviewStatus === 'PENDING';
    const modalVariant = isPending ? 'cancelApproval' : 'clearApproval';
    const handleOpenConfirmModal = (0, $cozmU.useCallback)(()=>{
        setIsConfirmModalOpen(true);
    }, []);
    const handleConfirm = (0, $cozmU.useCallback)(async ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'cancelApproval',
                source: (0, $2QUbq.APPROVALS_ANALYTICS_SOURCE),
                attributes: analyticsAttributes
            }
        }).fire();
        setIsConfirmModalOpen(false);
        try {
            await cancelWorkflowApplication();
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'canceled',
                    actionSubject: 'approvalWorkflowReview',
                    source: (0, $2QUbq.APPROVALS_ANALYTICS_SOURCE),
                    attributes: analyticsAttributes
                }
            }).fire();
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'approvalWorkflowReview',
                    source: (0, $2QUbq.APPROVALS_ANALYTICS_SOURCE),
                    attributes: {
                        ...analyticsAttributes,
                        failureStatusCode: (0, $2QUbq.getFailureStatusCode)(error)
                    }
                }
            }).fire();
        }
    }, [
        analyticsAttributes,
        cancelWorkflowApplication,
        createAnalyticsEvent
    ]);
    const handleClose = (0, $cozmU.useCallback)(()=>{
        setIsConfirmModalOpen(false);
    }, []);
    if (!isDraftLockedForEditing) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, reviewStatus === 'APPROVED' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
        xcss: $79befcd2c8d3c320$var$styles.banner,
        alignItems: "center",
        justifyContent: "center",
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, formatMessage($79befcd2c8d3c320$var$i18n.approvedBannerPrefixImproved)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6zK0v.PressableLink), {
        onClick: handleOpenConfirmModal
    }, formatMessage($79befcd2c8d3c320$var$i18n.approvedClearCta))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
        xcss: $79befcd2c8d3c320$var$styles.banner,
        alignItems: "center",
        justifyContent: "center",
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, formatMessage($79befcd2c8d3c320$var$i18n.approvalInProgressBannerPrefixImproved)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6zK0v.PressableLink), {
        onClick: handleOpenConfirmModal
    }, formatMessage($79befcd2c8d3c320$var$i18n.approvalInProgressCancelCta))), isConfirmModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $akN4j.ApprovalActionConfirmationModal), {
        variant: modalVariant,
        onConfirm: handleConfirm,
        onClose: handleClose
    }));
};






var $aRGok = parcelRequire("aRGok");





const $e48f7422194c5f7f$var$ApprovalRequiredBeforePublishModalContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "GQYm9",
    name: "ApprovalRequiredBeforePublishModalContent",
    loader: async ()=>(await (parcelRequire("lpuNH"))).ApprovalRequiredBeforePublishModal
});
const $e48f7422194c5f7f$export$39e2ccf4b3f86676 = ({ isOpen: isOpen, onClose: onClose })=>{
    (0, $cozmU.useEffect)(()=>{
        $e48f7422194c5f7f$var$ApprovalRequiredBeforePublishModalContent.preload();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e48f7422194c5f7f$var$ApprovalRequiredBeforePublishModalContent, {
        onClose: onClose
    }) : null);
};



var $bc1oR = parcelRequire("bc1oR");








var $lEVfb = parcelRequire("lEVfb");





var $3wSkK = parcelRequire("3wSkK");

/* EditorConnectionBannerOfflineMode.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $4Qu9h = parcelRequire("4Qu9h");





var $in5dT = parcelRequire("in5dT");


var $hBYtq = parcelRequire("hBYtq");








var $bT0se = parcelRequire("bT0se");


var $g01A4 = parcelRequire("g01A4");











var $18HQ4 = parcelRequire("18HQ4");

/* CreateOfflineCopy.tsx generated by @compiled/babel-plugin v0.36.1 */ // TODO: Remove entire file when platform_editor_offline_editing_web_ga_fixes is cleaned up
// This component is only used in the old conflict message (with saveCopy parameter)




var $kNIYN = parcelRequire("kNIYN");











var $3xuv0 = parcelRequire("3xuv0");





var $7xVCs = parcelRequire("7xVCs");




const $129ea4f2daae19f3$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    errorFlagTitle: {
        id: "browser-status-indicator.conflict-resolution-plugin.copy-page.error-flag.title",
        defaultMessage: "We failed to create a copy"
    },
    errorFlagDescription: {
        id: "browser-status-indicator.conflict-resolution-plugin.copy-page.error-flag.description",
        defaultMessage: "Check your network connection or try again."
    },
    copyCreatedFlagTitle: {
        id: "browser-status-indicator.conflict-resolution-plugin.copy-page.copy-created-flag.title",
        defaultMessage: "Copy created"
    },
    copyCreatedFlagDescription: {
        id: "browser-status-indicator.conflict-resolution-plugin.copy-page.copy-created-flag.description",
        defaultMessage: "We copied your offline edits into a new page. All changes were saved."
    },
    copyCreatedFlagViewPage: {
        id: "browser-status-indicator.conflict-resolution-plugin.copy-page.copy-created-flag.view-page-link",
        defaultMessage: "View page"
    },
    createCopyFlagTitle: {
        id: "browser-status-indicator.conflict-resolution-plugin.copy-page.create-copy-flag.title",
        defaultMessage: "Issue syncing offline edits"
    },
    createCopyFlagDescription: {
        id: "browser-status-indicator.conflict-resolution-plugin.copy-page.create-copy-flag.description",
        defaultMessage: "We found conflicting edits when syncing to the cloud. View merged edits here or create a copy of your offline changes."
    },
    createCopyFlagCreateAction: {
        id: "browser-status-indicator.conflict-resolution-plugin.copy-page.create-copy-flag.create-action",
        defaultMessage: "Create copy"
    },
    createCopyFlagNoAction: {
        id: "browser-status-indicator.conflict-resolution-plugin.copy-page.create-copy-flag.no-action",
        defaultMessage: "I don\u2019t need a copy"
    }
});



var $f7B1p = parcelRequire("f7B1p");

const $0045511f0064ab73$export$eea1b38e4aaafc7d = (spaceId, contentId, adf, isLivePage = false)=>{
    return (0, $f7B1p.cfetch)('/wiki/api/v2/pages', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            spaceId: spaceId,
            parentId: contentId,
            status: 'draft',
            body: {
                representation: 'atlas_doc_format',
                value: JSON.stringify(adf)
            },
            ...isLivePage && {
                subtype: 'live'
            }
        })
    });
};


const $f917592567f31a69$var$styles = {
    saveCopyLink: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11c8wadc _4bfu1r31 _1hms8stv _ajmmnqa1 _bfhk1j28 _k48pwu06 _syazazsu _irr319yr"
};
const $f917592567f31a69$export$3e0f67bf0e97b95a = (0, $7aRa9.withFlags)(({ flags: flags, chunks: chunks, api: api, contentId: contentId, spaceId: spaceId, setIsLoading: setIsLoading, isLivePage: isLivePage = false })=>{
    const isCreatingPage = (0, $cozmU.useRef)(false);
    const offlineDoc = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'collabEdit.lastReconnectionConflictMetadata')?.offlineDoc;
    const [shouldUpdatePageTree, setShouldUpdatePageTree] = (0, $cozmU.useState)(false);
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
        testId: "offline-conflict-create-page-copy",
        onClick: async ()=>{
            if (isCreatingPage.current || !offlineDoc || !spaceId) return;
            isCreatingPage.current = true;
            setIsLoading(true);
            try {
                const response = await (0, $0045511f0064ab73$export$eea1b38e4aaafc7d)(spaceId, contentId, new (0, $3xuv0.JSONTransformer)().encode(offlineDoc), isLivePage);
                if (!response.ok) {
                    flags.showFlag($f917592567f31a69$var$createErrorFlag(intl));
                    return;
                }
                setShouldUpdatePageTree(true);
                flags.hideFlag('editor_reconnection_conflict');
                const data = await response.json();
                flags.showFlag($f917592567f31a69$var$createCopySuccessFlag(`${data._links.base}${data._links.edituiv2}`, intl));
            } catch  {
                flags.showFlag($f917592567f31a69$var$createErrorFlag(intl));
            } finally{
                isCreatingPage.current = false;
                setIsLoading(false);
            }
        },
        xcss: $f917592567f31a69$var$styles.saveCopyLink
    }, chunks), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $7xVCs.PageTreeStateUpdater)
        ]
    }, (pageStateUpdater)=>{
        // Make sure we only push the update once
        if (shouldUpdatePageTree && contentId) {
            // Requests that we fetch the page tree with the newly restored page.
            pageStateUpdater.setForceFetchPageId(contentId);
            setShouldUpdatePageTree(false);
        }
        return null;
    }));
});
const $f917592567f31a69$var$createErrorFlag = (intl)=>({
        id: 'editor-reconnection-conflict-copy-failed',
        type: 'error',
        title: intl.formatMessage((0, $129ea4f2daae19f3$export$defe85febe8b728c).errorFlagTitle),
        description: intl.formatMessage((0, $129ea4f2daae19f3$export$defe85febe8b728c).errorFlagDescription),
        close: 'auto'
    });
const $f917592567f31a69$var$createCopySuccessFlag = (href, intl)=>({
        id: 'editor-reconnection-conflict-copy-created',
        type: 'success',
        title: intl.formatMessage((0, $129ea4f2daae19f3$export$defe85febe8b728c).copyCreatedFlagTitle),
        description: intl.formatMessage((0, $129ea4f2daae19f3$export$defe85febe8b728c).copyCreatedFlagDescription),
        close: 'auto',
        actions: [
            {
                content: intl.formatMessage((0, $129ea4f2daae19f3$export$defe85febe8b728c).copyCreatedFlagViewPage),
                href: href
            }
        ]
    });



var $kVuKK = parcelRequire("kVuKK");




function $8f9742f0ad2c6b9c$export$22acf644c7b26688(initialValue, risingEdgeDelay, fallingEdgeDelay) {
    const [value, setValue] = (0, $cozmU.useState)(initialValue);
    const risingEdgeTimeout = (0, $cozmU.useRef)(null);
    const fallingEdgeTimeout = (0, $cozmU.useRef)(null);
    const updateValue = (0, $cozmU.useCallback)((newValue)=>{
        if (newValue === true) {
            // Clear any pending falling edge timeout
            if (fallingEdgeTimeout.current !== null) {
                clearTimeout(fallingEdgeTimeout.current);
                fallingEdgeTimeout.current = null;
            }
            // If there is a rising edge pending already, or the value is already true, do nothing
            if (risingEdgeTimeout.current !== null || value === true) return;
            // If there is no delay, update the value immediately
            if (risingEdgeDelay === 0) setValue(true);
            else // Otherwise set a new rising edge timeout
            risingEdgeTimeout.current = window.setTimeout(()=>{
                risingEdgeTimeout.current = null;
                setValue(true);
            }, risingEdgeDelay);
        } else {
            // Clear any pending rising edge timeout
            if (risingEdgeTimeout.current !== null) {
                clearTimeout(risingEdgeTimeout.current);
                risingEdgeTimeout.current = null;
            }
            // If there is a falling edge pending already, or the value is already false, do nothing
            if (fallingEdgeTimeout.current !== null || value === false) return;
            // If there is no delay, update the value immediately
            if (fallingEdgeDelay === 0) setValue(false);
            else // Otherwise set a new falling edge timeout
            fallingEdgeTimeout.current = window.setTimeout(()=>{
                fallingEdgeTimeout.current = null;
                setValue(false);
            }, fallingEdgeDelay);
        }
    }, [
        fallingEdgeDelay,
        risingEdgeDelay,
        value
    ]);
    return [
        value,
        updateValue
    ];
}
function $8f9742f0ad2c6b9c$export$c40112cb03d4ce32(value, risingEdgeDelay, fallingEdgeDelay) {
    const [delayedValue, setDelayedValue] = $8f9742f0ad2c6b9c$export$22acf644c7b26688(value, risingEdgeDelay, fallingEdgeDelay);
    (0, $cozmU.useEffect)(()=>{
        setDelayedValue(value);
    }, [
        value,
        setDelayedValue
    ]);
    return delayedValue;
}


const $ceee0e5a959b634f$var$AnimatedEllipsis = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $18HQ4.EllipsisContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $18HQ4.AnimatedDot), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $18HQ4.AnimatedDot), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $18HQ4.AnimatedDot), null)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ceee0e5a959b634f$export$884d2f68355ca9c8 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { toolbarHidden: toolbarHidden, show: show, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_v564gu18 _1e0c11p5 _kqswstnw _1bsb1osq _1bah1h6o _4cvr1h6o _y3gn1h6o _1ltvze3t _ca0q12x7 _n3td12x7 _bfhkysee _8hrzjp4b _1pby1nn1",
            __cmplp.toolbarHidden ? "_154iidpf" : "_154i1ady",
            __cmplp.show ? "_t9ecp8ia" : "_t9ecdgp5",
            __cmplp.toolbarHidden ? "_1911idpf" : "_19111ady",
            __cmplp.className
        ])
    });
});
const $ceee0e5a959b634f$export$31ea92f3997410dd = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11c8wadc _1reo15vq _18m915vq _ect41kw7 _k48pwu06 _syaz1rpy _o5724jg8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ceee0e5a959b634f$export$bb5d4b172e6970cd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ceee0e5a959b634f$var$FadingSpanInternal, {
        "aria-hidden": !props?.show,
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $ceee0e5a959b634f$var$FadingSpanInternal = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { show: show, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_zulpu2gc _v564ayzn _nd5l1ekt _1e0c1txw _4cvr1h6o _1bah1h6o _18u0u2gc _2hwxu2gc",
            __cmplp.show ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.className
        ])
    });
});
const $ceee0e5a959b634f$var$backgroundColor = {
    online: "_v564glyw _bfhk1y9u _t9ecp8ia",
    offline: "_bfhkysee",
    conflicts: "_bfhkysee"
};
const $ceee0e5a959b634f$var$styles = {
    conflictLink: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11c8wadc _bfhk1j28 _k48pwu06 _syazazsu _1doce4h9 _1o3i1b2s _1il9gq9o _irr319yr",
    placeholder: "_1bsbdlk8"
};
const $ceee0e5a959b634f$var$isMessageDescriptor = (msg)=>{
    return !!msg && typeof msg === 'object' && msg.id !== undefined && msg.defaultMessage !== undefined;
}; /**
    * Custom hook to manage the state of banner variants and provide a consistent interface for their usage.
    * @param variant - The variant definition to use. This should ideally be a constant defined outside of the component to prevent re-renders.
    * @param props - The props to pass to the variant condition function. This should be treated as a dependency array, and values should be kept in the same order.
    * @returns The current state of the banner variant.
    *
    * @privateRemarks
    *
    * Within this hook, the react-hooks/exhaustive-deps rule is disabled in a few places.
    * This is because we track the dependencies provided by the props argument as their values instead of the overall reference.
    * This is done to prevent the need to memoize the props object without causing unnecessary re-renders.
    * By directly depending on the values in this array, we can ensure that the hook will only re-run when the values change, not the array itself.
    *
    * This does however have the caveat that we lose static analysis of the dependencies, so extra care should be taken when working in this function.
    */ 
function $ceee0e5a959b634f$export$dd92d6ba26bc2ad5(variant, props, triggerAnalyticsEvent) {
    const { condition: conditionFn, onConditionChange: onConditionChange, onVisibilityChange: onVisibilityChange, message: message } = variant;
    const [condition, setCondition] = (0, $cozmU.useState)(conditionFn(...props));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const lastConditionChange = (0, $cozmU.useRef)(performance.now());
    const lastVisibilityChange = (0, $cozmU.useRef)(performance.now());
    const fireConditionChange = (0, $cozmU.useCallback)((newConditionValue)=>{
        if (onConditionChange) {
            const timing = {
                startTime: lastConditionChange.current,
                endTime: performance.now(),
                duration: performance.now() - lastConditionChange.current
            };
            lastConditionChange.current = performance.now();
            onConditionChange(newConditionValue, timing, triggerAnalyticsEvent, ...props);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- Refer to private remarks in the function description
    [
        onConditionChange,
        triggerAnalyticsEvent,
        ...props
    ]);
    (0, $cozmU.useEffect)(()=>{
        const newConditionValue = conditionFn(...props);
        if (condition !== newConditionValue) {
            setCondition(newConditionValue);
            fireConditionChange(newConditionValue);
        } // eslint-disable-next-line react-hooks/exhaustive-deps -- Refer to private remarks in the function description
    }, [
        conditionFn,
        onConditionChange,
        condition,
        triggerAnalyticsEvent,
        ...props
    ]); // Fire condition change event on the first render to maintain consistency with previous behaviour for analytics
    const hasExecutedFirstRender = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!hasExecutedFirstRender.current) {
            hasExecutedFirstRender.current = true;
            fireConditionChange(condition);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- Refer to private remarks in the function description
    [
        fireConditionChange,
        condition
    ]);
    const wrappedOnVisibilityChange = (0, $cozmU.useCallback)((visibilityValue)=>{
        if (onVisibilityChange) {
            const timing = {
                startTime: lastVisibilityChange.current,
                endTime: performance.now(),
                duration: performance.now() - lastVisibilityChange.current
            };
            lastVisibilityChange.current = performance.now();
            onVisibilityChange(visibilityValue, timing, triggerAnalyticsEvent, ...props);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- Refer to private remarks in the function description
    [
        onVisibilityChange,
        triggerAnalyticsEvent,
        ...props
    ]);
    const messageValue = (0, $cozmU.useMemo)(()=>{
        if (typeof message === 'function') return message(...props);
        else if ($ceee0e5a959b634f$var$isMessageDescriptor(message)) return formatMessage(message);
        return null; // eslint-disable-next-line react-hooks/exhaustive-deps -- Refer to private remarks in the function description
    }, [
        message,
        ...props
    ]);
    return {
        id: variant.id,
        condition: condition,
        message: messageValue,
        wrapperStyleKey: variant.wrapperStyleKey,
        onVisibilityChange: wrappedOnVisibilityChange
    };
}
const $ceee0e5a959b634f$export$6484431ecffbb42d = {
    id: 'back-online-banner',
    condition: (isBackOnline)=>isBackOnline,
    message: (0, $kVuKK.i18n).editorEnabledOfflineMode,
    wrapperStyleKey: 'online'
};
const $ceee0e5a959b634f$export$fdc43f78fadf92e6 = {
    id: 'offline-disabled-banner',
    condition: (isOfflineStorageUnavailable)=>isOfflineStorageUnavailable,
    message: (0, $kVuKK.i18n).editorDisabled,
    wrapperStyleKey: 'offline'
};
const $ceee0e5a959b634f$export$e3d57ca72010d8b5 = {
    id: 'offline-banner',
    condition: (isOffline)=>isOffline,
    message: (0, $kVuKK.i18n).editorDisabledOfflineMode,
    wrapperStyleKey: 'offline',
    onConditionChange: (newCondition, _timing, triggerAnalyticsEvent, _isOffline, offlineData, editorType, restrictionUpdate)=>{
        if (newCondition) {
            // Save browser network status and document visibility state when the user goes offline
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            offlineData.current.browserNetworkStatus = navigator.onLine; // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            offlineData.current.documentVisibilityState = document.visibilityState; // Fire analytics event when the offline banner is now active (though it may not be visible yet)
            triggerAnalyticsEvent('offline.banner.show.indicator', {
                editorType: editorType,
                restrictionUpdate: restrictionUpdate
            });
        }
    },
    onVisibilityChange: (isVisible, timing, triggerAnalyticsEvent, _isOffline, onlineData, editorType, _restrictionUpdate)=>{
        if (!isVisible) // Fire analytics event when the offline banner has been displayed
        triggerAnalyticsEvent('offline.banner.displayed', {
            browserNetworkStatus: onlineData.current.browserNetworkStatus,
            editorType: editorType,
            documentVisibilityState: onlineData.current.documentVisibilityState,
            duration: timing.duration
        });
    }
};
const $ceee0e5a959b634f$export$5b93469ec56d27bf = {
    id: 'connection-timeout-banner',
    condition: (connectionTimedOut)=>connectionTimedOut,
    message: (0, $kVuKK.i18n).collabEditConnectionTimeout,
    wrapperStyleKey: 'offline',
    onConditionChange: (newCondition, _timing, triggerAnalyticsEvent, _connectionTimedOut, offlineData, { contentId: contentId, contentType: contentType })=>{
        if (newCondition) {
            // Save browser network status and document visibility state when the user goes offline
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            offlineData.current.browserNetworkStatus = navigator.onLine; // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            offlineData.current.documentVisibilityState = document.visibilityState; // Fire analytics event when the connection timeout banner is now active (though it may not be visible yet)
            triggerAnalyticsEvent('collab.edit.connection.timeout.show.indicator', {
                contentId: contentId,
                contentType: contentType
            });
        }
    },
    onVisibilityChange: (isVisible, timing, triggerAnalyticsEvent, _connectionTimedOut, offlineData, { editorType: editorType })=>{
        if (!isVisible) // Fire analytics event when the connection timeout banner has been displayed
        triggerAnalyticsEvent('connection.timeout.banner.displayed', {
            browserNetworkStatus: offlineData.current.browserNetworkStatus,
            editorType: editorType,
            documentVisibilityState: offlineData.current.documentVisibilityState,
            duration: timing.duration
        });
    }
};
const $ceee0e5a959b634f$export$865dd254943cb7d0 = {
    id: 'restriction-update-banner',
    condition: (restrictionUpdate, willEditorDisable)=>restrictionUpdate && willEditorDisable,
    message: (0, $kVuKK.i18n).editorDisabledDueToPermissionChange,
    wrapperStyleKey: 'offline'
};
const $ceee0e5a959b634f$export$d8b1b94ede519079 = {
    id: 'conflict-banner',
    condition: (conflicts)=>conflicts !== undefined && (conflicts.deleted.length > 0 || conflicts.inserted.length > 0),
    wrapperStyleKey: 'conflicts',
    message: (conflicts, formatMessage, fullPageEditorPresetAPI, contentId, spaceId, setIsLoading, isLivePage)=>{
        const messageKey = (0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes') ? (0, $kVuKK.i18n).editorSyncFailedDueToConflictsUpdated : (0, $kVuKK.i18n).editorSyncFailedDueToConflicts;
        const conflictCount = conflicts !== undefined ? conflicts.deleted.length + conflicts.inserted.length : 0;
        let saveCopy;
        if (!(0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) saveCopy = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f917592567f31a69$export$3e0f67bf0e97b95a), {
                api: fullPageEditorPresetAPI,
                chunks: chunks,
                contentId: contentId,
                spaceId: spaceId,
                setIsLoading: setIsLoading,
                isLivePage: isLivePage
            });
        return formatMessage(messageKey, {
            conflictIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($in5dT))), {
                label: "",
                color: "var(--ds-icon-accent-orange, #E06C00)"
            }),
            conflictLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
                    onClick: ()=>{
                        if ((0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes')) fullPageEditorPresetAPI?.core?.actions.execute(fullPageEditorPresetAPI?.conflictResolutionUI?.commands.startResolvingConflicts);
                        else fullPageEditorPresetAPI?.core?.actions.execute(fullPageEditorPresetAPI?.conflictResolutionUI?.commands.navigateToFirstConflict);
                    },
                    xcss: $ceee0e5a959b634f$var$styles.conflictLink,
                    testId: "offline-conflict-navigate-to-first-conflict"
                }, chunks),
            saveCopy: saveCopy,
            conflictCount: conflictCount
        });
    }
};
const $ceee0e5a959b634f$export$989f13cb92705548 = {
    id: 'resyncing-editor-disabled-banner',
    condition: (resyncingEditorDisabled)=>resyncingEditorDisabled,
    message: (0, $kVuKK.i18n).resyncingEditorDisabled,
    wrapperStyleKey: 'offline'
};
const $ceee0e5a959b634f$var$EditorConnectionBannerComponent = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
})((0, $kSwu1.injectIntl)(({ editorType: editorType, contentType: contentType, contentId: contentId, spaceId: spaceId, triggerAnalyticsEvent: triggerAnalyticsEvent, collabEditState: collabEditState, willEditorDisable: willEditorDisable = false, fullPageEditorPresetAPI: fullPageEditorPresetAPI, intl: { formatMessage: formatMessage }, isLivePage: isLivePage, isEditorToolbarHidden: isEditorToolbarHidden })=>{
    const [isFirstRender, setIsFirstRender] = (0, $cozmU.useState)(true); // Timeout values for showing and hiding the banners
    const SHOW_TIMEOUT = 3000;
    const HIDE_TIMEOUT = 3000; // Track conflict state
    const conflicts = (0, $4Qu9h.useSharedPluginStateSelector)(fullPageEditorPresetAPI, 'conflictResolutionUI.conflicts');
    const isOfflineStorageDisabled = Boolean((0, $4Qu9h.useSharedPluginStateSelector)(fullPageEditorPresetAPI, 'editorOfflineStorage.disabled'));
    const offlineStorageIsInactiveSyncing = (0, $4Qu9h.useSharedPluginStateSelector)(fullPageEditorPresetAPI, 'editorOfflineStorage.inactiveSyncing') ?? false;
    const connectivityMode = (0, $4Qu9h.useSharedPluginStateSelector)(fullPageEditorPresetAPI, 'connectivity.mode');
    const internetLost = connectivityMode !== undefined && (0, $6Ixg8.isOfflineMode)(connectivityMode); // Track if the user is online
    const hasInternet = (0, $8f9742f0ad2c6b9c$export$c40112cb03d4ce32)(isFirstRender ? true : !(internetLost && willEditorDisable), SHOW_TIMEOUT, HIDE_TIMEOUT);
    const connectionTimedOut = (0, $8f9742f0ad2c6b9c$export$c40112cb03d4ce32)(isFirstRender ? false : collabEditState.collabEditConnectionTimedOut && willEditorDisable, SHOW_TIMEOUT, HIDE_TIMEOUT);
    const isOfflineStorageUnavailable = (0, $8f9742f0ad2c6b9c$export$c40112cb03d4ce32)(isFirstRender ? false : isOfflineStorageDisabled && !willEditorDisable && internetLost, 0, 0);
    const isOnline = !isOfflineStorageDisabled ? hasInternet && !connectionTimedOut : !internetLost && !connectionTimedOut; // Track when the user goes back online
    const [isBackOnline, setIsBackOnline] = (0, $cozmU.useState)(false);
    const lastOnlineState = (0, $cozmU.useRef)(isOnline);
    const backOnlineBannerTimeout = (0, $cozmU.useRef)(null);
    const SHOW_BACK_ONLINE_TIMEOUT = 3000; // Show the back online banner for 3 seconds
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false); // Track restriction updates (permission changes)
    const [restrictionUpdate, setRestrictionUpdate] = (0, $8f9742f0ad2c6b9c$export$22acf644c7b26688)(false, 0, // Restriction updates should be shown immediately
    HIDE_TIMEOUT);
    const onRestrictionUpdatedEvent = (0, $cozmU.useCallback)(()=>{
        triggerAnalyticsEvent('offline.banner.restriction.updated', {
            editorType: editorType,
            restrictionUpdate: restrictionUpdate
        });
        if (editorType === 'classic') setRestrictionUpdate(true);
    }, [
        editorType,
        restrictionUpdate,
        setRestrictionUpdate,
        triggerAnalyticsEvent
    ]);
    const onRestrictionUpdatedPubSubEvent = (0, $cozmU.useCallback)(()=>{
        if (![
            'DUAL',
            'GRAPHQL'
        ].includes((0, $1xpoY.default).getString('confluence-migrate-fps-to-graphql-subscription', '')) || !(0, $6mKj3.expVal)('cc_fps_migration_content-restriction-updated', 'isEnabled', false)) onRestrictionUpdatedEvent();
    }, [
        onRestrictionUpdatedEvent
    ]); // Listen for restriction update events (permission changes)
    (0, $bT0se.usePubSubEvent)({
        contentId: contentId,
        contentType: contentType,
        eventName: `restrictionUpdated:${contentType}`,
        onEvent: onRestrictionUpdatedPubSubEvent,
        skip: // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expVal)('cc_fps_migration_content-restriction-updated', 'isEnabled', false) && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider') && (0, $1xpoY.default).getString('confluence-migrate-fps-to-graphql-subscription', '') === 'GRAPHQL'
    });
    (0, $g01A4.useContentRestrictionSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType,
        callback: onRestrictionUpdatedEvent,
        subscriberId: 'EditorConnectionBannerOfflineModeSubscription'
    }); // Reset restriction update when editor reconnects so the default message is shown next time the editor goes offline
    (0, $cozmU.useEffect)(()=>{
        if (!willEditorDisable) setRestrictionUpdate(false);
    }, [
        setRestrictionUpdate,
        willEditorDisable
    ]);
    (0, $cozmU.useEffect)(()=>{
        // If the user has gone back online after being offline, show the banner for a short time
        if (!lastOnlineState.current && isOnline) {
            setIsBackOnline(true); // Clear any existing timeout to avoid hiding the banner too early
            if (backOnlineBannerTimeout.current) clearTimeout(backOnlineBannerTimeout.current);
            backOnlineBannerTimeout.current = window.setTimeout(()=>{
                setIsBackOnline(false);
                backOnlineBannerTimeout.current = null;
            }, SHOW_BACK_ONLINE_TIMEOUT);
        } else if (lastOnlineState.current && !isOnline) {
            setIsBackOnline(false); // Strictly speaking this isn't necessary, the callback now has no effect, but I figure it's good to clean the timeout up anyway
            if (backOnlineBannerTimeout.current) clearTimeout(backOnlineBannerTimeout.current);
        }
        lastOnlineState.current = isOnline;
    }, [
        isOnline,
        setIsBackOnline
    ]); // Create the banner variant states and manage their visibility
    const backOnlineBanner = $ceee0e5a959b634f$export$dd92d6ba26bc2ad5($ceee0e5a959b634f$export$6484431ecffbb42d, [
        isBackOnline
    ], triggerAnalyticsEvent);
    const offlineData = (0, $cozmU.useRef)({
        browserNetworkStatus: true,
        documentVisibilityState: ''
    });
    const offlineBanner = $ceee0e5a959b634f$export$dd92d6ba26bc2ad5($ceee0e5a959b634f$export$e3d57ca72010d8b5, [
        !hasInternet,
        offlineData,
        editorType,
        restrictionUpdate
    ], triggerAnalyticsEvent); // Use a memoized editor info object to avoid unnecessary re-renders
    const editorInfo = (0, $cozmU.useMemo)(()=>({
            contentId: contentId,
            contentType: contentType,
            editorType: editorType
        }), [
        contentId,
        contentType,
        editorType
    ]);
    const connectionTimeoutBanner = $ceee0e5a959b634f$export$dd92d6ba26bc2ad5($ceee0e5a959b634f$export$5b93469ec56d27bf, [
        connectionTimedOut,
        offlineData,
        editorInfo
    ], triggerAnalyticsEvent);
    const restrictionUpdateBanner = $ceee0e5a959b634f$export$dd92d6ba26bc2ad5($ceee0e5a959b634f$export$865dd254943cb7d0, [
        restrictionUpdate,
        willEditorDisable
    ], triggerAnalyticsEvent);
    const disabledOfflineBanner = $ceee0e5a959b634f$export$dd92d6ba26bc2ad5($ceee0e5a959b634f$export$fdc43f78fadf92e6, [
        isOfflineStorageUnavailable
    ], triggerAnalyticsEvent);
    const conflictBanner = $ceee0e5a959b634f$export$dd92d6ba26bc2ad5($ceee0e5a959b634f$export$d8b1b94ede519079, [
        conflicts,
        formatMessage,
        fullPageEditorPresetAPI,
        contentId,
        spaceId,
        setIsLoading,
        isLivePage
    ], triggerAnalyticsEvent);
    const resyncingEditorDisabledBanner = $ceee0e5a959b634f$export$dd92d6ba26bc2ad5($ceee0e5a959b634f$export$989f13cb92705548, [
        offlineStorageIsInactiveSyncing
    ], triggerAnalyticsEvent); // Banner list is ordered by priority, so the first valid banner will be shown
    const banners = [
        conflictBanner,
        disabledOfflineBanner,
        resyncingEditorDisabledBanner,
        backOnlineBanner,
        restrictionUpdateBanner,
        offlineBanner,
        connectionTimeoutBanner
    ]; // Track the most recent banner to detect changes in visibility (separately from tracking if each banner's condition has changed)
    const lastBanner = (0, $cozmU.useRef)(undefined);
    const currentBanner = banners.find((banner)=>banner.condition);
    if (currentBanner?.id !== lastBanner.current) {
        // Fire a visibility change event for the banner that was previously visible
        if (lastBanner.current !== undefined) {
            // We can assume that the last ID is in the list of banners, as the banner list is constant, so we'll mark the result type as non-null
            const lastBannerInstance = banners.find((banner)=>banner.id === lastBanner.current);
            if (lastBannerInstance.onVisibilityChange !== undefined) lastBannerInstance.onVisibilityChange(false);
        } // Fire a visibility change event for the banner that is now visible (if any)
        if (currentBanner?.onVisibilityChange !== undefined) currentBanner.onVisibilityChange(true);
        lastBanner.current = currentBanner?.id;
    }
    (0, $cozmU.useEffect)(()=>{
        if (isFirstRender) setIsFirstRender(false);
    }, [
        isFirstRender
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ceee0e5a959b634f$export$26d1be1a3667a472, {
        isLoading: isLoading,
        currentBanner: currentBanner,
        isEditorToolbarHidden: isEditorToolbarHidden
    });
}));
const $ceee0e5a959b634f$export$26d1be1a3667a472 = ({ currentBanner: currentBanner, isLoading: isLoading, isEditorToolbarHidden: isEditorToolbarHidden })=>{
    // Get the message to display in the banner (if any) and format it if necessary
    const CurrentMessage = (0, $cozmU.useMemo)(()=>currentBanner?.message, [
        currentBanner
    ]);
    const LoadingIndicator = (0, $cozmU.useMemo)(()=>{
        if (currentBanner?.wrapperStyleKey !== 'conflicts') return null;
         // Show loading ellipsis for conflicts only for now
        // Show a placeholder when not loading to avoid layout shift
        return isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ceee0e5a959b634f$var$AnimatedEllipsis, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                $ceee0e5a959b634f$var$styles.placeholder
            ])
        });
    }, [
        isLoading,
        currentBanner
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ceee0e5a959b634f$export$884d2f68355ca9c8, {
        "data-testid": "status-indicator",
        show: currentBanner !== undefined,
        toolbarHidden: isEditorToolbarHidden,
        className: (0, $hekY6.default)([
            currentBanner?.wrapperStyleKey === 'online' && $ceee0e5a959b634f$var$backgroundColor['online'],
            currentBanner?.wrapperStyleKey === 'offline' && $ceee0e5a959b634f$var$backgroundColor['offline'],
            currentBanner?.wrapperStyleKey === 'conflicts' && $ceee0e5a959b634f$var$backgroundColor['conflicts']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ceee0e5a959b634f$export$bb5d4b172e6970cd, {
        "data-testid": "status-indicator-text",
        role: "alert",
        show: currentBanner !== undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ceee0e5a959b634f$export$31ea92f3997410dd, {
        "data-testid": "status-text"
    }, CurrentMessage), LoadingIndicator));
};
const $ceee0e5a959b634f$export$2d7f5da98593df5c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo($ceee0e5a959b634f$var$EditorConnectionBannerComponent);


const $5b566a57f88868ac$export$6d9f0d80d291faa5 = ({ triggerAnalyticsEvent: triggerAnalyticsEvent, collabEditInternetLost: collabEditInternetLost, collabEditConnectionTimedOut: collabEditConnectionTimedOut, willEditorDisable: willEditorDisable, contentType: contentType, contentId: contentId, spaceId: spaceId, fullPageEditorPresetAPI: fullPageEditorPresetAPI, collabEditState: collabEditState, isDesktop: isDesktop, isLivePage: isLivePage, isViewMode: isViewMode })=>{
    const isEditorToolbarDockedAtTop = (0, $lEVfb.useIsEditorToolbarDockedAtTop)({
        defaultDockedAtTop: !isLivePage
    });
    const isEditorToolbarHidden = isViewMode || !isEditorToolbarDockedAtTop;
    if (isDesktop || (0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ceee0e5a959b634f$export$2d7f5da98593df5c), {
        editorType: "next",
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        collabEditState: collabEditState,
        willEditorDisable: willEditorDisable,
        contentType: contentType,
        contentId: contentId,
        spaceId: spaceId,
        fullPageEditorPresetAPI: fullPageEditorPresetAPI,
        isEditorToolbarHidden: isEditorToolbarHidden
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3wSkK.EditorConnectionBanner), {
        editorType: "next",
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        collabEditInternetLost: collabEditInternetLost,
        collabEditConnectionTimedOut: collabEditConnectionTimedOut,
        willEditorDisable: willEditorDisable,
        contentType: contentType,
        contentId: contentId,
        isEditorToolbarHidden: isEditorToolbarHidden
    });
};



var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");





var $6LguK = parcelRequire("6LguK");


var $e6u60 = parcelRequire("e6u60");

const $6eee7623ad82c8da$export$386b0ae74d3f86a0 = (triggerAnalyticsEvent)=>{
    // log time of keypress
    const now = performance?.now();
    // grab the array of fmp & tti metrics
    const fmpMetrics = performance?.getEntriesByName('browser-metric:fmp');
    const ttiMetrics = performance?.getEntriesByName('browser-metric:tti');
    // grab the most recently added fmp & tti metrics
    const fmpEnd = fmpMetrics[fmpMetrics.length - 1]?.startTime + fmpMetrics[fmpMetrics.length - 1]?.duration;
    const ttiEnd = ttiMetrics[ttiMetrics.length - 1]?.startTime + ttiMetrics[ttiMetrics.length - 1]?.duration;
    // if now (keypress time), fmp, and tti all exist, fire the measure time to edit analytics event
    if (now && fmpEnd && ttiEnd) triggerAnalyticsEvent('measure.time.to.edit', {
        keypressTime: now,
        fmpTimeToEdit: now - fmpEnd,
        ttiTimeToEdit: now - ttiEnd,
        fmpEnd: fmpEnd,
        ttiEnd: ttiEnd
    });
};






var $1gh0Q = parcelRequire("1gh0Q");


var $gkIgp = parcelRequire("gkIgp");


var $S6mif = parcelRequire("S6mif");


var $kXAjP = parcelRequire("kXAjP");
var $39X8O = parcelRequire("39X8O");


var $6dTPw = parcelRequire("6dTPw");








const $5fed17fe09649c6f$export$be5a95ae7f8387c0 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "k58TW",
    name: "MarketplaceAppsContainer",
    loader: async ()=>(await (parcelRequire("eHpfp"))).MarketplaceAppsContainer
});


const $f9a65503f42ecec3$export$bc75c05af9bceb4a = ({ searchTerm: searchTerm, mode: mode })=>{
    if (!searchTerm) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5fed17fe09649c6f$export$be5a95ae7f8387c0), {
        searchTerm: searchTerm,
        mode: mode
    });
};



var $4ri4I = parcelRequire("4ri4I");





const $11b8024921ea2f1a$export$a1cd66d9f8e156b1 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "gzpgy",
    name: "ConditionalPublish",
    loader: async ()=>(await (parcelRequire("lm6tr"))).ConditionalPublish
});



var $9sGCn = parcelRequire("9sGCn");





var $cmBjr = parcelRequire("cmBjr");


var $LSims = parcelRequire("LSims");











var $i9VoI = parcelRequire("i9VoI");


var $ep3mz = parcelRequire("ep3mz");


var $5zmqi = parcelRequire("5zmqi");


var $hTLSK = parcelRequire("hTLSK");

const $28307a730c3d5a3b$export$756c5857647e0244 = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const onDataReceived = (0, $cozmU.useCallback)((_event, response)=>{
        const isMarkdownMode = response?.markdownModeUpdated?.isMarkdownMode;
        if (!contentId || typeof isMarkdownMode !== 'boolean') return;
        // Always act on the hook's `contentId`, not `response.id`. The
        // subscription is server-side filtered to `contentId` already, so a
        // divergent `response.id` would mean a misdirected event or a stale
        // closure — either way we should not patch a different page's cache.
        //
        // Order matters: body first, then mode. A mode flip ahead of the
        // refetch remounts the editor (cache-first) onto stale body and
        // reintroduces the empty-editor window.
        //
        // Patch unconditionally once the refetch settles. `refetchPageContent`
        // swallows network errors and always resolves, so a silent body-fetch
        // failure still flips the mode — preferable to leaving the mode out
        // of sync with the BE, since NCS will stream the converted body in
        // shortly after.
        (0, $5zmqi.refetchPageContent)(contentId).then(()=>(0, $hTLSK.patchIsMarkdownModeCache)(contentId, isMarkdownMode, (0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true)));
    }, [
        contentId
    ]);
    (0, $i9VoI.useSubscriptionEvent)({
        subscriberId: 'markdownModeUpdateSubscriber',
        contentId: contentId,
        contentType: 'page',
        delta: 'markdownModeUpdated',
        skip: !contentId || !(0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true) || !(0, $9wGTI.fg)('cc-markdown-mode-pubsub'),
        onDataReceived: onDataReceived
    });
    return null;
};



var $kXsBa = parcelRequire("kXsBa");


var $1B6Lx = parcelRequire("1B6Lx");


var $14ugT = parcelRequire("14ugT");


var $3o3i5 = parcelRequire("3o3i5");


var $kSPGK = parcelRequire("kSPGK");








var $bAIqi = parcelRequire("bAIqi");





const $ee7c889194e6f932$export$c43bb192f22b2458 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "8Gtxn",
    name: "LazyEditorContextCustomSitesConfigPanel",
    loader: async ()=>(await (parcelRequire("iVSl1"))).EditorContextCustomSitesConfigPanel
});


const $f04c510354797dd3$export$7a4297a73e39e6ad = /*#__PURE__*/ (0, $cozmU.memo)(({ localId: localId, closeSelf: closeSelf, editorApi: editorApi, contentId: contentId, upsellModalSource: upsellModalSource, setUpsellModalSource: setUpsellModalSource })=>{
    if (upsellModalSource) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bAIqi.ExtensionInsertUpsellLoader), {
        setUpsellModalSource: setUpsellModalSource,
        feature: upsellModalSource
    });
    if (localId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ee7c889194e6f932$export$c43bb192f22b2458), {
        localId: localId,
        closeSelf: closeSelf,
        editorApi: editorApi,
        contentId: contentId
    });
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));





var $kCECX = parcelRequire("kCECX");





var $dBD3L = parcelRequire("dBD3L");


var $gXR7h = parcelRequire("gXR7h");


var $hjUDQ = parcelRequire("hjUDQ");


var $5KWZf = parcelRequire("5KWZf");


var $KDPGa = parcelRequire("KDPGa");


var $bQmwQ = parcelRequire("bQmwQ");


var $9MYUp = parcelRequire("9MYUp");

const $b5ea4fb4260f4ec5$var$ALLOWED_EXTENSIONS = [
    (0, $5KWZf.SPOTLIGHT_EXTENSION_TYPE),
    (0, $gXR7h.carouselExtensionType),
    (0, $dBD3L.CARDS_EXTENSION_TYPE),
    (0, $bQmwQ.LINKS_MENU_EXTENSION_TYPE),
    (0, $5KWZf.SECTION_EXTENSION_TYPE),
    (0, $9MYUp.HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE),
    (0, $KDPGa.SEARCH_EXTENSION_TYPE)
];
const $b5ea4fb4260f4ec5$export$bdd538c0d43098c3 = (editorActions)=>{
    const [activeNodeLocalId, setActiveNodeLocalId] = (0, $cozmU.useState)(null);
    // when upsellModalSource is undefined, we use it to close the upsell modal in ModalUpsellWrapper.
    const [upsellModalSource, setUpsellModalSource] = (0, $cozmU.useState)(undefined);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const openConfigPanel = (0, $cozmU.useCallback)((localId)=>{
        if (!localId) return;
        const { attrs: attrs, type: type } = editorActions?.getNodeByLocalId(localId)?.toJSON() || {};
        const { extensionType: extensionType, extensionKey: extensionKey } = attrs || {};
        const editorView = editorActions._privateGetEditorView();
        const selection = editorView?.state?.selection;
        if (selection instanceof (0, $kCECX.NodeSelection)) {
            if ($b5ea4fb4260f4ec5$var$ALLOWED_EXTENSIONS.includes(extensionType)) setActiveNodeLocalId(localId);
        } else {
            if (type !== 'multiBodiedExtension' || !editorView?.state) return;
            // Handle MultiBodiedExtension config panel
            let multiBodiedExtensionPosition = editorView.state.selection.from;
            editorView.state.tr.doc.descendants((node, pos)=>{
                if (node.attrs?.localId === localId) {
                    multiBodiedExtensionPosition = pos;
                    return;
                }
            });
            editorView.dispatch(editorView.state.tr?.setSelection?.((0, $kCECX.NodeSelection).create(editorView.state.tr.doc, multiBodiedExtensionPosition)));
            if ($b5ea4fb4260f4ec5$var$ALLOWED_EXTENSIONS.includes(extensionType)) setActiveNodeLocalId(localId);
        }
        if (!!extensionKey && !!extensionType) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'editExtension',
                source: `${extensionKey}ExtensionConfig`,
                attributes: {
                    extensionType: extensionType
                }
            }
        }).fire();
    }, [
        setActiveNodeLocalId,
        createAnalyticsEvent,
        editorActions
    ]);
    const closeConfigPanel = (0, $cozmU.useCallback)(()=>{
        const selectedNode = editorActions.getSelectedNode()?.toJSON();
        if (activeNodeLocalId && selectedNode?.attrs?.localId === activeNodeLocalId && selectedNode?.attrs?.extensionType === (0, $dBD3L.CARDS_EXTENSION_TYPE)) {
            const parameters = selectedNode.attrs.parameters || {};
            if (parameters.renderVariant === (0, $hjUDQ.RenderVariant).MANUAL) {
                delete parameters.filters;
                delete parameters.cardCount;
            }
            if (parameters.renderVariant === (0, $hjUDQ.RenderVariant).DYNAMIC) parameters.cards = [];
            editorActions.replaceSelection({
                ...selectedNode,
                attrs: {
                    ...selectedNode.attrs,
                    parameters: {
                        ...parameters
                    }
                }
            }, true);
        }
        setActiveNodeLocalId(null);
    }, [
        activeNodeLocalId,
        editorActions,
        setActiveNodeLocalId
    ]);
    return (0, $cozmU.useMemo)(()=>({
            activeNodeLocalId: activeNodeLocalId,
            openConfigPanel: openConfigPanel,
            closeConfigPanel: closeConfigPanel,
            upsellModalSource: upsellModalSource,
            setUpsellModalSource: setUpsellModalSource
        }), [
        activeNodeLocalId,
        openConfigPanel,
        closeConfigPanel,
        upsellModalSource,
        setUpsellModalSource
    ]);
};



var $cQhbe = parcelRequire("cQhbe");


var $sLZsl = parcelRequire("sLZsl");










const $6b433f129bb94645$var$PrimaryToolbarContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $6b433f129bb94645$var$memoizeDeepEq = (0, $dOBRD.default)((obj)=>obj, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
function $6b433f129bb94645$export$5acade271146d69c({ children: children, value: value }) {
    const memoizedValue = $6b433f129bb94645$var$memoizeDeepEq(value);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6b433f129bb94645$var$PrimaryToolbarContext.Provider, {
        value: memoizedValue
    }, children);
}
function $6b433f129bb94645$export$87f05b83083ffee2() {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($6b433f129bb94645$var$PrimaryToolbarContext);
    if (!context) throw new Error('usePrimaryToolbarContext must be used within a PrimaryToolbarContextProvider');
    return context;
}


/**
 * @generated SignedSource<<140dfd06cdb8837fbf5e59652b8f3486>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ab1e224d72963101$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "EditorPrimaryToolbarComponentsGetDraftParentFragment",
        "selections": [
            v0 /*: any*/ ,
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "ancestors",
                "plural": true,
                "selections": [
                    v0 /*: any*/ 
                ]
            },
            {
                "kind": "ScalarField",
                "name": "__typename"
            }
        ],
        "type": "Content"
    };
}();
$ab1e224d72963101$var$node.hash = "8d1e74aac7d44af0e715791d1017e102";
var $ab1e224d72963101$export$2e2bcd8739ae039 = $ab1e224d72963101$var$node;









var $gabmL = parcelRequire("gabmL");





var $1Vx7O = parcelRequire("1Vx7O");


var $1ch0f = parcelRequire("1ch0f");


var $2unW6 = parcelRequire("2unW6");


var $6yCgm = parcelRequire("6yCgm");

parcelRequire("aYZaZ");
var $iQb1R = parcelRequire("iQb1R");
var $aYZaZ = parcelRequire("aYZaZ");





var $6tSjb = parcelRequire("6tSjb");


const $088b8a15e556cc8e$export$ad9980f718bbeeb6 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "TEbaC",
    name: "LivePagesEllipsisDropdownComponent",
    loader: async ()=>(await (parcelRequire("kATGJ"))).LivePagesEllipsisDropdownComponent,
    loading: (0, $6tSjb.EllipsisPlaceholder)
});





















var $1C3B1 = parcelRequire("1C3B1");


var $lXYVJ = parcelRequire("lXYVJ");





var $jacyh = parcelRequire("jacyh");


var $5rEAe = parcelRequire("5rEAe");


var $3mmDo = parcelRequire("3mmDo");


var $lHzSp = parcelRequire("lHzSp");


var $atF9V = parcelRequire("atF9V");


var $fFmJj = parcelRequire("fFmJj");

const $02a52aafb1fafdd7$var$EditorPrimaryToolbarComponentsFunction = ({ forceDisabled: forceDisabled, userOffline: userOffline, collabLimitReached: collabLimitReached, contentId: contentId, contentType: contentType, isContentCreationPanelOpen: isContentCreationPanelOpen, isUnpublishedDraft: isUnpublishedDraft, onClickPublish: onClickPublish, onClickOpenContentCreationPanel: onClickOpenContentCreationPanel, onPreviewClicked: onPreviewClicked, saveDraft: saveDraft, spaceKey: spaceKey, title: title, showRevertDialog: showRevertDialog, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, isPublishingContent: isPublishingContent, editorActions: editorActions, isSingleUserSession: isSingleUserSession, navigateOnClose: navigateOnClose, triggerAnalyticsEvent: triggerAnalyticsEvent, shouldRenderPreview: shouldRenderPreview, shouldShowRecentSpotlight: shouldShowRecentSpotlight, checkIfConditionPreventingPublish: checkIfConditionPreventingPublish, flags: flags, viewMode: viewMode, pageTreeStateUpdater: pageTreeStateUpdater, hasEditPermission: hasEditPermission, ellipsisEditorActions: ellipsisEditorActions, allowInlineComments: allowInlineComments = true, allowPageComments: allowPageComments = true })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $ab1e224d72963101$export$2e2bcd8739ae039),
        __callerPackage__: "editor-primary-toolbar-components"
    });
    const { emojiCoverPictureAndContentStateSubscription: emojiCoverPictureAndContentStateSubscription, hasEmoji: hasEmoji, hasCoverPicture: hasCoverPicture, hasContentState: hasContentState } = (0, $lHzSp.useEmojiTitleCoverPictureAndContentState)();
    const { hasRestrictionsSubscription: hasRestrictionsSubscription, hasRestrictions: hasRestrictions } = (0, $atF9V.useRestrictions)();
    const publicLinkData = (0, $gabmL.usePublicLinkPageDataProvider)({
        pageId: contentId,
        fetchPolicy: 'cache-and-network'
    });
    const hasLabels = (0, $2unW6.useLabels)(contentId);
    const [{ collabEditConnected: collabEditConnected }] = (0, $hYoU4.useNativeCollabConnected)();
    const shouldDisableActions = isPublishingContent || userOffline || !!forceDisabled;
    const areMainButtonsDisabled = shouldDisableActions || publicLinkData.isLoading;
    const isPublishDisabledForPublishModal = shouldDisableActions || Boolean(collabLimitReached);
    const hasTitle = Boolean(title);
    const hasBody = !editorActions.isDocumentEmpty();
    const { forceRefetchBlogTree: forceRefetchBlogTree } = (0, $jacyh.useBlogTreeActions)();
    const willDeleteBlankDraftOnClose = (0, $3mmDo.useWillDeleteBlankDraftOnClose)({
        isUnpublishedDraft: isUnpublishedDraft,
        isSingleUserSession: isSingleUserSession,
        hasTitle: hasTitle,
        hasBody: hasBody,
        hasEmoji: hasEmoji,
        hasCoverPicture: hasCoverPicture,
        hasContentState: hasContentState,
        hasRestrictions: hasRestrictions,
        hasLabels: hasLabels
    });
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    // Data is not used so we don't worry about errors here
    (0, $cozmU.useEffect)(()=>{
        for (const error of publicLinkData.errors)(0, $7Sm4c.markErrorAsHandled)(error);
    }, [
        publicLinkData.errors
    ]);
    const publishButtonDisabledReason = (0, $1Vx7O.getPublishButtonDisabledReason)({
        title: title,
        isPublishingContent: isPublishingContent,
        userOffline: userOffline,
        forceDisabled: forceDisabled
    });
    const onClose = async ()=>{
        if (contentType === 'page') (0, $lXYVJ.setViewTransitionSource)((0, $1C3B1.EDITOR_CLOSE_BUTTON_CLICK));
        if (shouldShowRecentSpotlight) setOnboardingState({
            key: (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).RECENT_SPOTLIGHT_OPEN,
            value: 'true'
        });
        if (willDeleteBlankDraftOnClose) {
            triggerAnalyticsEvent('close', {
                discarded: true
            });
            (0, $1ch0f.deleteDraft)({
                contentId: contentId,
                deleteOnlyIfBlank: true
            }).then(async ({ data: data })=>{
                if (contentType === 'blogpost') // refreshes blog tree on discard close of blog draft
                forceRefetchBlogTree();
                triggerAnalyticsEvent('draftDiscarded', {
                    wasDeleted: !!data?.deleteContent?.wasDeleted
                });
                const parentId = await (0, $5rEAe.getParentOfDraft)(contentId, readFragmentInterop);
                if (parentId) pageTreeStateUpdater.setForceFetchPageId(parentId);
                else createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'notFound',
                        actionSubject: 'discardedDraftParent',
                        objectType: contentType,
                        objectId: contentId
                    }
                }).fire();
            });
            navigateOnClose({
                isDiscarding: true
            });
        } else {
            triggerAnalyticsEvent('close');
            saveDraft({
                isOnClose: true
            }).then(()=>navigateOnClose());
        }
    };
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const allowedEllipsisButtons = !isCompanyHub ? [
        (0, $iQb1R.Buttons).PUBLISH_WITHOUT_NOTIFY,
        (0, $iQb1R.Buttons).DELETE_DRAFT,
        (0, $iQb1R.Buttons).EDIT_LABELS,
        (0, $iQb1R.Buttons).MOVE_PAGE,
        (0, $iQb1R.Buttons).PREVIEW,
        (0, $iQb1R.Buttons).RESOLVED_COMMENTS,
        (0, $iQb1R.Buttons).TEMPLATE_BROWSER,
        (0, $iQb1R.Buttons).VIEW_CHANGES,
        (0, $iQb1R.Buttons).SWITCH_TO_LIVE_EDIT,
        (0, $iQb1R.Buttons).CLASSIFY_CONTENT
    ] : [
        (0, $iQb1R.Buttons).DELETE_DRAFT,
        (0, $iQb1R.Buttons).PREVIEW,
        (0, $iQb1R.Buttons).RESOLVED_COMMENTS,
        (0, $iQb1R.Buttons).VIEW_CHANGES
    ];
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEmbedded = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const showEllipsisDropdown = !isEmbedded;
    const ellipsisDropdownProps = {
        contentId: contentId,
        contentType: contentType,
        isDisabled: areMainButtonsDisabled || userOffline || collabLimitReached,
        isUnpublishedDraft: isUnpublishedDraft,
        isShowingLabelsDialog: false,
        onPreviewClicked: onPreviewClicked,
        onClickPublish: onClickPublish,
        retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
        saveDraft: saveDraft,
        tooltipDisabledState: publishButtonDisabledReason,
        spaceKey: spaceKey,
        isContentCreationPanelShown: isContentCreationPanelOpen,
        onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
        showRevertDialog: showRevertDialog,
        allowedEllipsisButtons: allowedEllipsisButtons,
        hasEditPermission: hasEditPermission,
        editorActions: ellipsisEditorActions
    };
    // allowCopyLink and allowRestrictions are contingent on if user is not in Company hub space
    // Only inline comments button is whitelisted for Company hub editors to remain consistent with whitelisted actions in the EllipsisDropdown
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, emojiCoverPictureAndContentStateSubscription, hasRestrictionsSubscription, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6yCgm.MainButtons), {
        allowWebItems: true,
        allowCopyLink: !isCompanyHub && !isEmbedded,
        allowInlineComments: allowInlineComments,
        allowPageComments: allowPageComments,
        allowRestrictions: !isCompanyHub && !isEmbedded,
        allowStar: isLivePage && !isEmbedded,
        allowWatch: isLivePage && !isEmbedded,
        areMainButtonsDisabled: areMainButtonsDisabled,
        contentId: contentId,
        contentType: contentType,
        isPublishDisabled: !title || !title?.trim() || areMainButtonsDisabled || collabLimitReached || !collabEditConnected,
        isCloseButtonDisabled: shouldDisableActions,
        isPublishDisabledForPublishModal: isPublishDisabledForPublishModal,
        isUnpublishedDraft: isUnpublishedDraft,
        discardOnCloseEnabled: willDeleteBlankDraftOnClose,
        onClose: onClose,
        onClickPreview: onPreviewClicked,
        onClickPublish: onClickPublish,
        checkIfConditionPreventingPublish: checkIfConditionPreventingPublish,
        publishButtonDisabledReason: publishButtonDisabledReason,
        isPublishingContent: isPublishingContent,
        retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
        shouldRenderPreview: shouldRenderPreview,
        flags: flags,
        saveDraft: saveDraft,
        title: title,
        subsequentNode: showEllipsisDropdown && (isLivePage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $088b8a15e556cc8e$export$ad9980f718bbeeb6), {
            contentId: contentId,
            spaceKey: spaceKey,
            retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
            onClickPublish: onClickPublish,
            saveDraft: saveDraft,
            isViewMode: viewMode && !hasEditPermission,
            onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
            isDisabled: areMainButtonsDisabled || userOffline || collabLimitReached
        }) : //@ts-ignore
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aYZaZ.EllipsisDropdownComponent), ellipsisDropdownProps)),
        spaceKey: spaceKey,
        editorActions: editorActions,
        viewMode: viewMode
    }));
};
const $02a52aafb1fafdd7$export$170e4ca3217957a2 = (0, $ecUYt.withPageTreeStateUpdater)($02a52aafb1fafdd7$var$EditorPrimaryToolbarComponentsFunction);











const $82bb8752b1a17b39$export$3bc2a95151a4db09 = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $82bb8752b1a17b39$var$memoizeDeepEq = (0, $dOBRD.default)((obj)=>obj, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
function $82bb8752b1a17b39$export$f7b2b60e23c443f6({ children: children, value: value }) {
    const memoizedValue = $82bb8752b1a17b39$var$memoizeDeepEq(value);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($82bb8752b1a17b39$export$3bc2a95151a4db09.Provider, {
        value: memoizedValue
    }, children);
}
function $82bb8752b1a17b39$export$69a815b52f63537() {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($82bb8752b1a17b39$export$3bc2a95151a4db09);
    if (!context) throw new Error('useContentComponentsContext must be used within a ContentComponentsContextProvider');
    return context;
}



var $fwwrH = parcelRequire("fwwrH");


var $JJ6wk = parcelRequire("JJ6wk");


var $7QM6o = parcelRequire("7QM6o");


var $eD8ha = parcelRequire("eD8ha");

/* ImportedPagePolishBanner.tsx generated by @compiled/babel-plugin v0.36.1 */ 












var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $7Jde4 = parcelRequire("7Jde4");


var $l3wuH = parcelRequire("l3wuH");


var $fodiz = parcelRequire("fodiz");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");


var $j2p1x = parcelRequire("j2p1x");





var $lsxnT = parcelRequire("lsxnT");





var $ckmNl = parcelRequire("ckmNl");

var $6828bd2e8aa8f411$exports = {};
$6828bd2e8aa8f411$exports = new URL("polish-hover-card-illustration.a4499422.png", import.meta.url).toString();



var $1FxtB = parcelRequire("1FxtB");

/**
 * @generated SignedSource<<987059704f54cb5757ebc75d22cb5cc2>>
 * @relayHash cc577d3f855af6bfb6475749f0910565
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4c6fdb04257953e54a3fbe49f98181b7f2f2706468871df43dc9b49a2fd48855
const $5fb2938d2444436f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "concreteType": "History",
        "kind": "LinkedField",
        "name": "history",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "createdDate"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsImportedPageQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "ancestors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ 
                            ]
                        },
                        v4 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsImportedPageQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "ancestors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        },
                        v4 /*: any*/ ,
                        v5 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "cc577d3f855af6bfb6475749f0910565",
            "id": "4c6fdb04257953e54a3fbe49f98181b7f2f2706468871df43dc9b49a2fd48855",
            "metadata": {},
            "name": "useIsImportedPageQuery",
            "operationKind": "query",
            "text": "query useIsImportedPageQuery($contentId:ID){singleContent(id:$contentId){subType,ancestors{title,id},history{createdDate},id}}"
        }
    };
}();
$5fb2938d2444436f$var$node.hash = "068e36719373d2dbc7edbdc9d8ab7a73";
var $5fb2938d2444436f$export$2e2bcd8739ae039 = $5fb2938d2444436f$var$node;








/* eslint-disable check-i18n-id-prefix/i18n-id-prefix-with-package-name-defineMessages */ // The message IDs below intentionally use the import-from-sources package prefix so that



// These message IDs are intentionally kept in sync with the ones in
// @confluence/import-from-sources so that locale-aware folder-name comparisons
// remain accurate. See useIsImportedPage.ts for usage.
const $a484e7a8f7a89c6f$var$i18n = (0, $kSwu1.defineMessages)({
    msWordFolderName: {
        id: "import-from-sources.sources-list.msWordFolderName",
        defaultMessage: "Word Documents"
    },
    gdocFolderName: {
        id: "import-from-sources.sources-list.gdocFolderName",
        defaultMessage: "Google Drive"
    },
    oneDriveFolderName: {
        id: "import-from-sources.sources-list.oneDriveFolderName",
        defaultMessage: "OneDrive"
    }
});
const $a484e7a8f7a89c6f$export$70ef76381365ea9 = {
    wordDoc: $a484e7a8f7a89c6f$var$i18n.msWordFolderName,
    gDoc: $a484e7a8f7a89c6f$var$i18n.gdocFolderName,
    office365Doc: $a484e7a8f7a89c6f$var$i18n.oneDriveFolderName
};


// Show the banner if the page was created within this many milliseconds.
const $0302b0604428dd22$var$RECENCY_WINDOW_MS = 86400000; // 24 hours
const $0302b0604428dd22$var$UseIsImportedPageQuery = (0, $5fb2938d2444436f$export$2e2bcd8739ae039);
const $0302b0604428dd22$export$9e6be16130c27d8c = (contentId)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    // Resolve folder names in the current locale so we match translated titles correctly.
    const importFolderTitles = new Set(Object.values((0, $a484e7a8f7a89c6f$export$70ef76381365ea9)).map((descriptor)=>formatMessage(descriptor)));
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($0302b0604428dd22$var$UseIsImportedPageQuery, {
        variables: {
            contentId: contentId
        },
        skip: !contentId,
        __callerPackage__: "experiment-cfind-5926-upload-in-onboarding"
    });
    if (loading || !data?.singleContent) return {
        isImported: false,
        isLivePage: false
    };
    const { ancestors: ancestors, history: history, subType: subType } = data.singleContent;
    const isLivePage = subType === 'live';
    // Check if any ancestor is an import folder (locale-aware comparison)
    const hasImportFolderAncestor = ancestors?.some((ancestor)=>ancestor?.title && importFolderTitles.has(ancestor.title));
    if (!hasImportFolderAncestor) return {
        isImported: false,
        isLivePage: isLivePage
    };
    // Check if page was created recently
    const createdDate = history?.createdDate;
    if (!createdDate) return {
        isImported: false,
        isLivePage: isLivePage
    };
    const ageMs = Date.now() - new Date(createdDate).getTime();
    return {
        isImported: ageMs <= $0302b0604428dd22$var$RECENCY_WINDOW_MS,
        isLivePage: isLivePage
    };
};














const $527a7bc266c01552$var$DISMISS_KEY = (pageId)=>`${pageId}${(0, $1UApO.keys).CFIND_POLISH_BANNER_DISMISSED}`;
const $527a7bc266c01552$export$163e4107990c3d52 = (pageId)=>{
    const [dismissed, setDismissed] = (0, $cozmU.useState)(()=>{
        return (0, $17wUi.confluenceLocalStorageInstance)?.getItemAsBoolean($527a7bc266c01552$var$DISMISS_KEY(pageId)) ?? false;
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const dismiss = (0, $cozmU.useCallback)((fireAnalytic = true)=>{
        if (fireAnalytic) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                source: 'cfind-5926-upload-in-onboarding-use-polish-banner-dismiss-button'
            }
        }).fire();
        (0, $17wUi.confluenceLocalStorageInstance)?.setItem($527a7bc266c01552$var$DISMISS_KEY(pageId), true);
        setDismissed(true);
    }, [
        pageId,
        createAnalyticsEvent
    ]);
    return {
        dismissed: dismissed,
        dismiss: dismiss
    };
};


const $25ae8a0e0879b1fe$var$hoverCardStyles = {
    wrapper: "_2rko12b0 _1reo15vq _18m915vq _1bsbnklw _bfhk1bhr _16qs130s",
    content: "_1rjcutpp _18zrpxbi",
    footer: "_1rjcu2gc _18zrpxbi",
    footerText: "_11c8wadc _syaz1rpy",
    title: "_11c81e3o _syazi7uo",
    description: "_11c8wadc _syazazsu"
};
const $25ae8a0e0879b1fe$var$bannerStyles = {
    wrapper: "_zulpu2gc _2rko1qi0 _1rjcu2gc _1e0c1txw _2lx2vrvc _4cvr1h6o _1bsb1osq _vchhusvi _bozgv47k _y4tipxbi _6rthu2gc",
    content: "_16jlkb7n _1o9zkb7n _i0dlf1ug _zulpu2gc _1e0c1txw _2lx2vrvc _4cvr1h6o _1ul9idpf",
    text: "_11c8fhey _1reo15vq _18m915vq _syazi7uo _1o9zkb7n _1ul9idpf _1bto1l2s _o5721q9c"
};
const $25ae8a0e0879b1fe$var$hoverCardFooterBorderStyles = null;
const $25ae8a0e0879b1fe$var$illustrationStyles = null;
const $25ae8a0e0879b1fe$var$i18n = (0, $kSwu1.defineMessages)({
    bannerText: {
        id: "experiment-cfind-5926-upload-in-onboarding.banner.text",
        defaultMessage: "Automatically format content without changing what you wrote."
    },
    addPolishButton: {
        id: "experiment-cfind-5926-upload-in-onboarding.banner.add-polish-button",
        defaultMessage: "Improve formatting"
    },
    dismissButton: {
        id: "experiment-cfind-5926-upload-in-onboarding.banner.dismiss-button",
        defaultMessage: "Dismiss"
    },
    hoverCardTitle: {
        id: "experiment-cfind-5926-upload-in-onboarding.hover-card.title",
        defaultMessage: "Get a polished doc in one click"
    },
    hoverCardDescription: {
        id: "experiment-cfind-5926-upload-in-onboarding.hover-card.description",
        defaultMessage: "Use Rovo to restructure headings, lists, and more. It won\u2019t undo any of your work."
    },
    hoverCardFooter: {
        id: "experiment-cfind-5926-upload-in-onboarding.hover-card.footer",
        defaultMessage: "Uses AI. Verify results."
    }
});
const $25ae8a0e0879b1fe$var$PolishHoverCard = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $25ae8a0e0879b1fe$var$hoverCardStyles.wrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6828bd2e8aa8f411$exports))),
        alt: "",
        role: "presentation",
        className: (0, $hekY6.default)([
            "_195gutpp _1e0c1ule _1bsboskh _4t3i1qr7 _5ral1dfr _13li12b0 _qrwq12b0 _1pfhutpp"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        xcss: $25ae8a0e0879b1fe$var$hoverCardStyles.content,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        as: "span",
        xcss: $25ae8a0e0879b1fe$var$hoverCardStyles.title
    }, intl.formatMessage($25ae8a0e0879b1fe$var$i18n.hoverCardTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        as: "span",
        xcss: $25ae8a0e0879b1fe$var$hoverCardStyles.description
    }, intl.formatMessage($25ae8a0e0879b1fe$var$i18n.hoverCardDescription)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_x3doj0fz"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        xcss: $25ae8a0e0879b1fe$var$hoverCardStyles.footer,
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
        label: "",
        color: "var(--ds-icon-subtlest, #6B6E76)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        as: "span",
        xcss: $25ae8a0e0879b1fe$var$hoverCardStyles.footerText
    }, intl.formatMessage($25ae8a0e0879b1fe$var$i18n.hoverCardFooter)))));
};
const $25ae8a0e0879b1fe$var$BannerContentComponent = ({ editorActions: editorActions, dismiss: dismiss })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    const [isHoverCardOpen, setIsHoverCardOpen] = (0, $cozmU.useState)(false);
    const hoverTimerRef = (0, $cozmU.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleAddPolish = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                source: 'cfind-5926-upload-in-onboarding-use-polish-button'
            }
        }).fire();
        const editorView = editorActions._privateGetEditorView();
        if (!editorView) return;
        (0, $j2p1x.UNSTABLE_DO_NOT_USE_ONLY_FOR_CONFLUENCE_triggerConfigItem)({
            configItem: (0, $j2p1x.UNSTABLE_configItems).addPolishConfigItem(),
            editorView: editorView
        }); // Clicking "Add Polish" is also a form of dismissal, passing false for it to not fire button clicked analytics on dismiss
        dismiss(false);
    }, [
        editorActions,
        dismiss,
        createAnalyticsEvent
    ]);
    const handleButtonMouseEnter = (0, $cozmU.useCallback)(()=>{
        hoverTimerRef.current = setTimeout(()=>setIsHoverCardOpen(true), 300);
    }, []);
    const handleButtonMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (hoverTimerRef.current) {
            clearTimeout(hoverTimerRef.current);
            hoverTimerRef.current = null;
        }
        setIsHoverCardOpen(false);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $25ae8a0e0879b1fe$var$bannerStyles.wrapper,
        backgroundColor: "color.background.accent.purple.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $25ae8a0e0879b1fe$var$bannerStyles.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        as: "span",
        xcss: $25ae8a0e0879b1fe$var$bannerStyles.text
    }, intl.formatMessage($25ae8a0e0879b1fe$var$i18n.bannerText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Popup, {
        isOpen: isHoverCardOpen,
        onClose: ()=>setIsHoverCardOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($25ae8a0e0879b1fe$var$PolishHoverCard, null),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                ...triggerProps,
                onMouseEnter: handleButtonMouseEnter,
                onFocus: handleButtonMouseEnter,
                onMouseLeave: handleButtonMouseLeave,
                onBlur: handleButtonMouseLeave
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                onClick: handleAddPolish,
                iconBefore: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Jde4))), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)"
                    })
            }, intl.formatMessage($25ae8a0e0879b1fe$var$i18n.addPolishButton)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                label: intl.formatMessage($25ae8a0e0879b1fe$var$i18n.dismissButton)
            }),
        label: intl.formatMessage($25ae8a0e0879b1fe$var$i18n.dismissButton),
        onClick: ()=>dismiss()
    }));
};
const $25ae8a0e0879b1fe$export$8a0839b0c4b155bf = ({ editorActions: editorActions })=>{
    const rawContentId = (0, $ckmNl.useContentId)();
    const contentId = typeof rawContentId === 'string' ? rawContentId : undefined;
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { isEnabled: isEnabled, loading: loading } = (0, $1FxtB.useCfind5926UploadInOnboarding)();
    const { isImported: isImported, isLivePage: isLivePageFromQuery } = (0, $0302b0604428dd22$export$9e6be16130c27d8c)(contentId ?? '');
    const { dismissed: dismissed, dismiss: dismiss } = (0, $527a7bc266c01552$export$163e4107990c3d52)(contentId ?? '');
    const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId ?? ''
    }); // Use isLivePage from the query result rather than LivePagesStore to avoid a timing
    // issue where the store hasn't been updated yet on first SPA navigation to the imported page.
    const isPageLive = isLivePage || isLivePageFromQuery;
    if (!contentId || !isPageLive || loading || !isEnabled || !isImported || !isAIEnabledForContent || !isRovoEnabledForContent || dismissed) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($25ae8a0e0879b1fe$var$BannerContentComponent, {
        editorActions: editorActions,
        dismiss: dismiss
    });
};






var $hV9Q1 = parcelRequire("hV9Q1");


var $bUiJC = parcelRequire("bUiJC");


var $ixblh = parcelRequire("ixblh");


var $c06us = parcelRequire("c06us");

const $ccf3ae46461db7a4$export$5690797982203811 = ({ spaceKey: spaceKey })=>{
    const [previewHovered, setPreviewHovered] = (0, $cozmU.useState)(false);
    const { templates: templates, templateIndex: templateIndex, buttonHovered: buttonHovered } = (0, $c06us.useBlankPageQuickActionsContext)();
    const shouldShowTemplatePreview = buttonHovered || previewHovered;
    const { width: width } = (0, $bUiJC.useEditorWidthObserver)({});
    (0, $cozmU.useEffect)(()=>{
        // we need to preload the TemplatePreview
        // component or the rendering will flicker between
        // skeleton & loaded states
        (0, $hV9Q1.TemplatePreview).preload();
    }, []);
    return shouldShowTemplatePreview ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ixblh.BlankPageQuickActionsTemplatePreviewWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ixblh.BlankPageQuickActionsTemplatePreviewContainer), {
        editorWidth: width,
        shouldShowTemplatePreview: shouldShowTemplatePreview,
        onMouseEnter: ()=>{
            setPreviewHovered(true);
        },
        onMouseLeave: ()=>{
            setPreviewHovered(false);
        },
        "data-testid": "bpqa-full-size-template-preview-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hV9Q1.TemplatePreview), {
        spaceKey: spaceKey,
        templates: templates.map((template)=>({
                name: template.name ?? null,
                contentBlueprintId: template.contentBlueprintId ?? null,
                templateId: template.templateId ?? null,
                blueprintModuleCompleteKey: template.blueprintModuleCompleteKey ?? null,
                itemModuleCompleteKey: template.itemModuleCompleteKey ?? null,
                iconURL: template.iconURL ?? null,
                darkModeIconURL: template.darkModeIconURL,
                styleClass: template.styleClass ?? null
            })),
        currentTemplateIndex: templateIndex,
        numPreviewsToFetchAtOnce: 3
    }))) : null;
};












var $krYZG = parcelRequire("krYZG");











var $gFEZF = parcelRequire("gFEZF");





var $9V507 = parcelRequire("9V507");


var $bh4C9 = parcelRequire("bh4C9");








var $bxEVw = parcelRequire("bxEVw");




/* BOEQuickActionButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $w6R6I = parcelRequire("w6R6I");




/* ShortcutLozenge.tsx generated by @compiled/babel-plugin v0.36.1 */ 





const $1f065e260c5902bd$var$styles = {
    lozenge: "_2rko12b0 _11c8wadc _bozg12x7 _y4ti12x7 _1q51v77o _85i5v77o _bfhki8nm _syazazsu _k48pi7a9"
};
const $1f065e260c5902bd$export$992dee387d429413 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        xcss: $1f065e260c5902bd$var$styles.lozenge
    }, children);


const $10905f5372d5a787$var$styles = {
    button: "_zulp1b66 _2rko1qi0 _1e0c1txw _4cvr1h6o _bozgu2gc _y4tiu2gc _1q5112x7 _85i512x7 _bfhkvuon _80omtlke _1dbz130s",
    active: "_bfhkfcek"
};
const $10905f5372d5a787$export$b7c8aa160ad6fd8c = ({ children: children, shortcut: shortcut, icon: icon, onClick: onClick, onMouseEnter: onMouseEnter, isDisabled: isDisabled, isActive: isActive, testId: testId, analyticsButtonType: analyticsButtonType, isLivePage: isLivePage })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleClick = (0, $cozmU.useCallback)(()=>{
        if (analyticsButtonType) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'BlankObjectExperienceButtons',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'createWithRovoBlankObject',
                attributes: {
                    variant: 'variant1',
                    contentType: isLivePage ? 'liveDoc' : 'page',
                    buttonType: analyticsButtonType
                }
            }
        }).fire();
        onClick?.();
    }, [
        onClick,
        createAnalyticsEvent,
        analyticsButtonType,
        isLivePage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
        testId: testId,
        onClick: handleClick,
        onMouseEnter: onMouseEnter,
        isDisabled: isDisabled,
        xcss: (0, $w6R6I.cx)($10905f5372d5a787$var$styles.button, isActive && $10905f5372d5a787$var$styles.active),
        style: {
            border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
        }
    }, icon?.(), children, shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1f065e260c5902bd$export$992dee387d429413), null, shortcut));
};


// Icon components hoisted outside to avoid recreating on every render
const $1441818b1f852262$var$CreateWithRovoIcon = ({ disabled: disabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9V507))), {
        label: "Create with Rovo",
        color: disabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon-subtle, #505258)"
    });
const $1441818b1f852262$var$AllTemplatesIcon = ({ disabled: disabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ivert))), {
        label: "All templates",
        color: disabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon-subtle, #505258)"
    });
const $1441818b1f852262$var$MoreElementsIcon = ({ disabled: disabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
        size: "medium",
        label: "",
        color: disabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon-subtle, #505258)"
    });
const $1441818b1f852262$var$ImportIcon = ({ disabled: disabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh4C9))), {
        label: "Import",
        color: disabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon-subtle, #505258)"
    });
// Create hooks for our query params
const $1441818b1f852262$var$useInEditorTemplatesPanelParam = (0, $dPJCf.createSingleQueryParamHook)((0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_PARAM_NAME));
const $1441818b1f852262$var$useContextPanelTabTargetParam = (0, $dPJCf.createSingleQueryParamHook)((0, $lJDEI.CONTEXT_PANEL_TAB_TARGET));
const $1441818b1f852262$export$5b6edddf72525f99 = ({ disabled: disabled, editorPresetAPI: editorPresetAPI, isTitleFocused: isTitleFocused, focusEditor: focusEditor, isAIEnabled: isAIEnabled, isLivePage: isLivePage, isPublishedPage: isPublishedPage, onCreateWithRovoClick: onCreateWithRovoClick, onCreateWithRovoHover: onCreateWithRovoHover })=>{
    const [isOnImportTab, setIsOnImportTab] = (0, $cozmU.useState)(false);
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hasTrackedInitialRenderRef = (0, $cozmU.useRef)(false);
    // Fire analytics on first render only (initial page load)
    (0, $cozmU.useEffect)(()=>{
        if (!hasTrackedInitialRenderRef.current) {
            hasTrackedInitialRenderRef.current = true;
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'blankObjectExperienceButtons',
                    attributes: {
                        contentType: isLivePage ? 'liveDoc' : 'page'
                    }
                }
            }).fire();
        }
    }, [
        createAnalyticsEvent,
        isLivePage
    ]);
    // Get query param values for the templates panel
    const inEditorTemplatesPanelValue = $1441818b1f852262$var$useInEditorTemplatesPanelParam();
    const contextPanelTabTargetValue = $1441818b1f852262$var$useContextPanelTabTargetParam();
    // Helper to get all query params (for compatibility with isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpen)
    const getQueryParams = (0, $cozmU.useCallback)(()=>({
            [(0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_PARAM_NAME)]: inEditorTemplatesPanelValue,
            [(0, $lJDEI.CONTEXT_PANEL_TAB_TARGET)]: contextPanelTabTargetValue
        }), [
        inEditorTemplatesPanelValue,
        contextPanelTabTargetValue
    ]);
    // Add elements slash menu active state
    const isTypeAheadOpen = (0, $4Qu9h.useSharedPluginStateSelector)(editorPresetAPI, 'typeAhead.isOpen') ?? false;
    // Templates panel active state
    const isPanelOpen = (0, $lJDEI.isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpen)(getQueryParams);
    // Templates button is active when panel is open but NOT on import tab
    const isAllTemplatesLinkActive = isPanelOpen && !isOnImportTab;
    // Import button is active when panel is open AND on import tab
    const isImportActive = isPanelOpen && isOnImportTab;
    // Handle create with rovo click
    const handleCreateWithRovoClick = (0, $cozmU.useCallback)(()=>{
        onCreateWithRovoClick();
    }, [
        onCreateWithRovoClick
    ]);
    // Handle all templates click
    const handleAllTemplatesClick = (0, $cozmU.useCallback)(async ()=>{
        if (isAllTemplatesLinkActive) // Close panel if templates panel is already open
        (0, $lJDEI.removeInEditorTemplatesQueryParam)(setQueryParams, isAIEnabled);
        else {
            // Open templates tab (panel will reactively update to templates mode)
            // Clear the contextPanelTabTarget so it defaults to templates
            setQueryParams({
                [(0, $lJDEI.CONTEXT_PANEL_TAB_TARGET)]: null
            }, true);
            (0, $lJDEI.setInEditorTemplatesPanelQueryParam)(setQueryParams, (0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_OPEN), undefined, isAIEnabled);
        }
        setIsOnImportTab(false);
    }, [
        setQueryParams,
        isAllTemplatesLinkActive,
        isAIEnabled
    ]);
    // Handle import click
    const handleImportClick = (0, $cozmU.useCallback)(()=>{
        if (isImportActive) // Close panel if already on import tab
        (0, $lJDEI.removeInEditorTemplatesQueryParam)(setQueryParams, isAIEnabled);
        else // Open import tab (panel will reactively update)
        (0, $lJDEI.setInEditorTemplatesPanelQueryParam)(setQueryParams, (0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_OPEN), 'import', isAIEnabled);
        setIsOnImportTab(!isImportActive);
    }, [
        setQueryParams,
        isImportActive,
        isAIEnabled
    ]);
    // Handle more elements click
    const handleMoreElementsClick = (0, $cozmU.useCallback)(async ()=>{
        if (isTitleFocused) await focusEditor();
        if (isTypeAheadOpen) editorPresetAPI?.typeAhead.actions.close({
            insertCurrentQueryAsRawText: true
        });
        else editorPresetAPI?.quickInsert.actions.openTypeAhead((0, $krYZG.INPUT_METHOD).QUICK_INSERT);
    }, [
        editorPresetAPI,
        isTitleFocused,
        focusEditor,
        isTypeAheadOpen
    ]);
    // Hide the entire BPQA when the slash command menu (typeahead) is open
    if (isTypeAheadOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
        gap: "space.100"
    }, isAIEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $10905f5372d5a787$export$b7c8aa160ad6fd8c), {
        testId: "create-with-rovo-button",
        onClick: handleCreateWithRovoClick,
        onMouseEnter: onCreateWithRovoHover,
        isDisabled: disabled,
        analyticsButtonType: "cwr",
        isLivePage: isLivePage,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1441818b1f852262$var$CreateWithRovoIcon, {
                disabled: disabled
            }),
        shortcut: "Space"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ixblh.ButtonText), {
        isDisabled: disabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $bxEVw.i18n).createWithRovo))), !isPublishedPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $10905f5372d5a787$export$b7c8aa160ad6fd8c), {
        testId: "blank-page-quick-actions-all-templates-link",
        onClick: handleAllTemplatesClick,
        isDisabled: disabled,
        analyticsButtonType: "template",
        isLivePage: isLivePage,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1441818b1f852262$var$AllTemplatesIcon, {
                disabled: disabled
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ixblh.ButtonText), {
        isDisabled: disabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $bxEVw.i18n).chooseATemplate))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $10905f5372d5a787$export$b7c8aa160ad6fd8c), {
        testId: "blank-page-quick-actions-more-elements-link",
        onClick: handleMoreElementsClick,
        isDisabled: disabled,
        isActive: !!isTypeAheadOpen,
        analyticsButtonType: "pageElements",
        isLivePage: isLivePage,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1441818b1f852262$var$MoreElementsIcon, {
                disabled: disabled
            }),
        shortcut: "/"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ixblh.ButtonText), {
        isDisabled: disabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $bxEVw.i18n).addElements))), !isAIEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $10905f5372d5a787$export$b7c8aa160ad6fd8c), {
        testId: "import-button",
        isDisabled: disabled,
        isActive: isImportActive,
        analyticsButtonType: "import",
        isLivePage: isLivePage,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1441818b1f852262$var$ImportIcon, {
                disabled: disabled
            }),
        onClick: handleImportClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ixblh.ButtonText), {
        isDisabled: disabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $bxEVw.i18n).import))));
};



var $99ISI = parcelRequire("99ISI");


var $lG7DR = parcelRequire("lG7DR");


var $bFMG7 = parcelRequire("bFMG7");


var $l2hqi = parcelRequire("l2hqi");


var $liGyh = parcelRequire("liGyh");


var $6tkbf = parcelRequire("6tkbf");


var $aHcFH = parcelRequire("aHcFH");





var $cb6fO = parcelRequire("cb6fO");


var $1NBp8 = parcelRequire("1NBp8");




const $5c5c39eb3a311fda$export$5972bbfae42d8829 = ({ contentId: contentId, spaceKey: spaceKey, contentType: contentType, title: title, createdDate: createdDate, isUnpublishedDraft: isUnpublishedDraft })=>{
    const titleRef = (0, $cozmU.useRef)(title);
    const createdDateRef = (0, $cozmU.useRef)(createdDate);
    (0, $cozmU.useEffect)(()=>{
        titleRef.current = title;
    }, [
        title
    ]);
    (0, $cozmU.useEffect)(()=>{
        createdDateRef.current = createdDate;
    }, [
        createdDate
    ]);
    const getHeadingLinkPath = (0, $cozmU.useCallback)(()=>{
        const isUnpublishedPage = contentType === 'page' && isUnpublishedDraft;
        const isUnpublishedBlog = contentType === 'blogpost' && isUnpublishedDraft;
        const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
        if (isUnpublishedPage) return (0, $1NBp8.EDIT_PAGE_V2).toUrl({
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: 'pages'
        });
        if (isUnpublishedBlog) return (0, $1NBp8.EDIT_BLOG_V2).toUrl({
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: 'blog'
        });
        if (contentType === 'blogpost' && !createdDateRef.current) return (0, $1NBp8.VIEW_BLOG).toUrl({
            contentId: contentId,
            spaceKey: spaceKey,
            slug: (0, $cb6fO.generateSlug)(titleRef.current)
        });
        if (isCompanyHub) return (0, $1NBp8.COMPANY_HUB).toUrl();
        return (0, $cb6fO.buildContentPath)(spaceKey, contentId, contentType, createdDateRef.current ?? '', (0, $cb6fO.generateSlug)(titleRef.current));
    }, [
        contentId,
        spaceKey,
        contentType,
        isUnpublishedDraft
    ]);
    return {
        getHeadingLinkPath: getHeadingLinkPath
    };
};



var $7f6xB = parcelRequire("7f6xB");


var $fMO7O = parcelRequire("fMO7O");


var $6gbpH = parcelRequire("6gbpH");


var $iKSlH = parcelRequire("iKSlH");







var $1l6y9 = parcelRequire("1l6y9");




var $ewVsQ = parcelRequire("ewVsQ");


var $kRAnY = parcelRequire("kRAnY");


var $kDhla = parcelRequire("kDhla");


var $k31VO = parcelRequire("k31VO");


var $eu3xH = parcelRequire("eu3xH");


var $1N2OF = parcelRequire("1N2OF");


var $6pob4 = parcelRequire("6pob4");


var $9bL1w = parcelRequire("9bL1w");


var $cxu5H = parcelRequire("cxu5H");


var $jARmo = parcelRequire("jARmo");


var $40pD8 = parcelRequire("40pD8");


var $8uM2K = parcelRequire("8uM2K");


var $jFkNO = parcelRequire("jFkNO");


var $26Yfd = parcelRequire("26Yfd");


var $bK3oZ = parcelRequire("bK3oZ");


var $88Nzy = parcelRequire("88Nzy");


var $dA1Sn = parcelRequire("dA1Sn");


var $8HrX3 = parcelRequire("8HrX3");


var $lmNXu = parcelRequire("lmNXu");


var $1AJi3 = parcelRequire("1AJi3");


var $fGDv8 = parcelRequire("fGDv8");


var $aXWtB = parcelRequire("aXWtB");

function $6c1b53bbc75abbea$export$c16a810a4a1be6ba() {
    (0, $aXWtB.ConfluenceConversationAssistant).preload();
    (0, $fGDv8.default).preload();
}






const $44282712d6713830$export$895eee10ef701154 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "kOmOd",
    name: "CreateWithRovoExperience",
    loader: async ()=>(await (parcelRequire("hQaiX"))).CreateWithRovoExperience
});






const $badeeeba932732aa$export$1683fadeb44552c5 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "0-DzZ",
    name: "CreateWithRovoExperienceDismissText",
    loader: async ()=>(await (parcelRequire("l7WpP"))).CreateWithRovoExperienceDismissText
});



var $BjpgS = parcelRequire("BjpgS");











var $amg3z = parcelRequire("amg3z");


var $eWgCZ = parcelRequire("eWgCZ");

const $2a156e74b04ef78c$export$122559bc1a8888a4 = (editorAPI)=>{
    const { detectedLinks: detectedLinks, newLinkTypes: newLinkTypes, newLinks: newLinks, shouldShowSpotlight: shouldShowSpotlight, closeSpotlight: closeSpotlight, setInitialContent: setInitialContent, handlePastedLinks: handlePastedLinks } = (0, $eWgCZ.useIntegrationLinkSpotlight)();
    const hasSetBaselineRef = (0, $cozmU.useRef)(false);
    const editorAPIRef = (0, $cozmU.useRef)(editorAPI);
    // Reset baseline flag when editorAPI changes
    (0, $cozmU.useEffect)(()=>{
        if (editorAPIRef.current !== editorAPI) {
            editorAPIRef.current = editorAPI;
            hasSetBaselineRef.current = false;
        }
    }, [
        editorAPI
    ]);
    // Baseline: when editor is ready, capture initial document so we can compute delta later.
    (0, $cozmU.useEffect)(()=>{
        if (!editorAPI?.core?.actions?.requestDocument || !(0, $9wGTI.fg)('link-paste-spotlight-experiment-gate')) return;
        editorAPI.core.actions.requestDocument((doc)=>{
            if (hasSetBaselineRef.current) return;
            hasSetBaselineRef.current = true;
            setInitialContent(doc);
        }, {
            alwaysFire: true
        });
    }, [
        editorAPI,
        setInitialContent
    ]);
    // On paste: extract links from pasted slice only (efficient - no full doc traversal).
    (0, $1KOhB.usePluginStateEffect)(editorAPI, [
        'paste'
    ], ({ pasteState: pasteState })=>{
        const lastPasted = pasteState?.lastContentPasted;
        if (!lastPasted?.pastedSlice || !(0, $9wGTI.fg)('link-paste-spotlight-experiment-gate')) return;
        // Extract links from ONLY the pasted slice (not entire document)
        const pastedUrls = (0, $amg3z.extractLinksFromSlice)(lastPasted.pastedSlice);
        const pastedLinks = (0, $amg3z.getDetectedLinksFromUrls)(pastedUrls);
        // Use handlePastedLinks to process just the pasted links
        handlePastedLinks(pastedLinks);
    });
    return {
        detectedLinks: detectedLinks,
        newLinkTypes: newLinkTypes,
        newLinks: newLinks,
        shouldShowSpotlight: shouldShowSpotlight,
        closeSpotlight: closeSpotlight
    };
};















var $fvl6L = parcelRequire("fvl6L");

const $800766a5932539c2$export$83107a72a22797f3 = (editorAPI, isLivePage, flags)=>{
    const { handlePastedLinks: handlePastedLinks, handleSave: handleSave, setInitialLinks: setInitialLinks } = (0, $fvl6L.useDetectPastedThirdPartyLinks)(flags);
    const hasSetBaselineRef = (0, $cozmU.useRef)(false);
    // Capture starting links for the full page editor
    (0, $cozmU.useEffect)(()=>{
        if (!editorAPI?.core?.actions?.requestDocument || !(0, $9wGTI.fg)('twcg-853-3p-in-1p-aa-test-gate')) return;
        editorAPI.core.actions.requestDocument((doc)=>{
            if (hasSetBaselineRef.current) return;
            hasSetBaselineRef.current = true;
            setInitialLinks(doc);
        }, {
            alwaysFire: true
        });
    }, [
        editorAPI,
        setInitialLinks
    ]);
    // On paste: extract links from ONLY the pasted slice (not the entire document).
    // Returns early for non-live pages — those use the publish-time handleSave path
    // in usePublish instead.
    (0, $1KOhB.usePluginStateEffect)(editorAPI, [
        'paste'
    ], ({ pasteState: pasteState })=>{
        if (!isLivePage) return;
        const lastPasted = pasteState?.lastContentPasted;
        if (!lastPasted?.pastedSlice || !(0, $9wGTI.fg)('twcg-853-3p-in-1p-aa-test-gate')) return;
        const pastedUrls = (0, $amg3z.extractLinksFromSlice)(lastPasted.pastedSlice);
        handlePastedLinks(pastedUrls);
    });
    return {
        handleSave: handleSave
    };
};






const $46e670f6dbd146ec$export$83ad660b287906ed = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Ls2sx",
    name: "IntegrationLinkSpotlightLoadable",
    loader: async ()=>(await (parcelRequire("ltwhQ"))).IntegrationLinkSpotlight,
    loading: ()=>null
});












var $jyA9t = parcelRequire("jyA9t");

const $d255586da55d4698$export$f34b0c6dc5eb5a35 = (editorActions)=>{
    const [{ fullPageEditorPresetAPI: fullPageEditorPresetAPI }] = (0, $kDhla.useFullPageEditorApi)();
    // Use a ref so the submit callback always reads the latest API value at invocation time,
    // rather than the stale value captured when the useCallback was last created.
    const fullPageEditorPresetAPIRef = (0, $cozmU.useRef)(fullPageEditorPresetAPI);
    (0, $cozmU.useEffect)(()=>{
        fullPageEditorPresetAPIRef.current = fullPageEditorPresetAPI;
    }, [
        fullPageEditorPresetAPI
    ]);
    const { openModal: openSmartCreationModalBase } = (0, $jyA9t.useSmartCreationModalActions)();
    return (0, $cozmU.useCallback)(({ entryPoint: entryPoint, spaceKey: spaceKey, parentContent: parentContent, content: content })=>{
        if (entryPoint === 'editorQuickInsert') {
            const submitWithInsertLink = async ({ baseUrl: baseUrl, path: path })=>{
                const fullUrl = baseUrl + path;
                const view = editorActions._privateGetEditorView?.();
                // insert hyperlink at the current cursor position
                if (view && fullPageEditorPresetAPIRef.current?.hyperlink?.actions?.insertLink) {
                    const { from: from } = view.state.selection;
                    const cmd = fullPageEditorPresetAPIRef.current.hyperlink.actions.insertLink((0, $krYZG.INPUT_METHOD).TYPEAHEAD, from, from, fullUrl, undefined, fullUrl, true);
                    cmd(view.state, view.dispatch);
                }
                window.open(fullUrl, '_blank', 'noopener,noreferrer');
            };
            openSmartCreationModalBase({
                entryPoint: entryPoint,
                spaceKey: spaceKey,
                parentContent: parentContent,
                content: content,
                submitCallback: submitWithInsertLink
            });
        }
    }, [
        openSmartCreationModalBase,
        editorActions
    ]);
};






const $b606f9cd4d9e530a$export$a9a9aa46de7c9f45 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "69wzr",
    name: 'LargePageSplitCandidateDetector',
    loader: async ()=>(await (parcelRequire("i7PFh"))).LargePageSplitCandidateDetector
});



var $fzhfU = parcelRequire("fzhfU");







const $376e585e26b85ad9$var$AI_PLANNER_PARENT_PRODUCT = 'ai-planner';
const $376e585e26b85ad9$var$useParentProductQueryParam = (0, $dPJCf.createSingleQueryParamHook)('parentProduct');
function $376e585e26b85ad9$export$c593e0767868f5d7() {
    const parentProduct = $376e585e26b85ad9$var$useParentProductQueryParam();
    return parentProduct === $376e585e26b85ad9$var$AI_PLANNER_PARENT_PRODUCT && (0, $9wGTI.fg)('confluence_ai_planner_rovo_bridge_streaming');
}









var $fWGpT = parcelRequire("fWGpT");


var $5Za2S = parcelRequire("5Za2S");


var $j7xMJ = parcelRequire("j7xMJ");


var $cLo2u = parcelRequire("cLo2u");


var $39rFu = parcelRequire("39rFu");


var $2VZOl = parcelRequire("2VZOl");





var $8KbKw = parcelRequire("8KbKw");

var $1sAC2 = parcelRequire("1sAC2");





var $ek3aD = parcelRequire("ek3aD");











var $iUV81 = parcelRequire("iUV81");


var $7PuC4 = parcelRequire("7PuC4");




















var $7sfG4 = parcelRequire("7sfG4");





var $2ZJmt = parcelRequire("2ZJmt");





var $9ohnn = parcelRequire("9ohnn");


var $16o3K = parcelRequire("16o3K");





var $d5Ozc = parcelRequire("d5Ozc");







const $c907e804706c3ad7$export$34125ddc34657a7f = (0, $d5Ozc.conditionalHooksFactory)(()=>(0, $9wGTI.fg)('aifc_create_enabled'), (api)=>{
    const aiIsStreaming = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'aiExperience.isStreaming', {
        disabled: !api
    }) ?? false;
    return {
        aiIsStreaming: aiIsStreaming
    };
}, (_api)=>{
    return {
        aiIsStreaming: false
    };
});











const $3c299c6e2ce2bea1$export$31b32c1906537e24 = (0, $d5Ozc.conditionalHooksFactory)(()=>(0, $6mKj3.expValEquals)('platform_synced_block', 'isEnabled', true), (api)=>{
    const hasUnsavedBodiedSyncBlockChanges = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'syncedBlock.hasUnsavedBodiedSyncBlockChanges', {
        disabled: !api
    }) ?? false;
    return {
        hasUnsavedBodiedSyncBlockChanges: hasUnsavedBodiedSyncBlockChanges
    };
}, (_api)=>{
    return {
        hasUnsavedBodiedSyncBlockChanges: false
    };
});


const $f8ea506e3a40865e$var$i18n = (0, $kSwu1.defineMessages)({
    lockoutMessage: {
        id: "full-page-editor.navigation-lockout-message",
        defaultMessage: "Changes made just now may not be saved."
    }
});
const $f8ea506e3a40865e$var$DEBOUNCE_TIMEOUT = 1000;
const $f8ea506e3a40865e$export$d85ed874af6294e9 = ({ contentId: contentId, isPublishingContent: isPublishingContent, isFirstParticipant: isFirstParticipant, editorPresetAPI: editorPresetAPI })=>{
    const [unsavedChanges, setUnsavedChanges] = (0, $cozmU.useState)(false);
    const [{ isDraftSyncPending: isDraftSyncPending }] = (0, $hYoU4.useNativeCollabDraftSync)();
    const [{ collabEditProvider: collabEditProvider, collabEditInitialized: collabEditInitialized }] = (0, $hYoU4.useNativeCollabState)();
    const [{ isPageBeingRemoved: isPageBeingRemoved }] = (0, $7sfG4.usePageRemovalState)();
    const { hasEditorContentChangedByAnyUser: hasEditorContentChangedByAnyUser } = (0, $16o3K.useHasEditorContentChanged)({
        editorPresetAPI: editorPresetAPI
    });
    const { isCollabProviderConnected: isCollabProviderConnected } = (0, $9ohnn.useConnected)(collabEditProvider, contentId);
    /**
   * - Draft sync is handled by first participant, so leaving should not be prevented for subsequent participants
   * - Publishing is an exception because it handles syncing on its own before transition
   * - The editor content has to have changed for unsaved changes to exist
   * - Page removal is an exception because the page is being intentionally removed
   */ const isExceptionConditionMet = !isFirstParticipant || isPublishingContent || !hasEditorContentChangedByAnyUser || isPageBeingRemoved && (0, $6mKj3.expValEquals)('confluence_page_removal_nav_lockout_exception', 'isEnabled', true);
    const checkCollabProviderSteps = (0, $cozmU.useCallback)(({ status: status })=>{
        if (!collabEditProvider || !collabEditInitialized) {
            setUnsavedChanges(false);
            return;
        }
        if (status === 'attempt' || status === 'success') {
            const unconfirmedSteps = collabEditProvider.getUnconfirmedSteps();
            setUnsavedChanges(!!(unconfirmedSteps && unconfirmedSteps.length > 0));
        } else // implies status === "failure"
        setUnsavedChanges(true);
    }, [
        collabEditProvider,
        collabEditInitialized
    ]);
    const debouncedCheckCollabProviderSteps = (0, $cozmU.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(checkCollabProviderSteps, $f8ea506e3a40865e$var$DEBOUNCE_TIMEOUT), [
        checkCollabProviderSteps
    ]);
    // Collab provider commit listener
    (0, $cozmU.useEffect)(()=>{
        if (isExceptionConditionMet || !collabEditProvider || !collabEditInitialized) {
            setUnsavedChanges(false);
            return;
        }
        collabEditProvider.on('commit-status', debouncedCheckCollabProviderSteps);
        return ()=>{
            collabEditProvider.off('commit-status', debouncedCheckCollabProviderSteps);
        };
    }, [
        collabEditProvider,
        collabEditInitialized,
        isExceptionConditionMet,
        debouncedCheckCollabProviderSteps
    ]);
    const [hasOfflineConflicts, setHasOfflineConflicts] = (0, $cozmU.useState)(false);
    (0, $1KOhB.usePluginStateEffect)(editorPresetAPI, [
        'collabEdit',
        'connectivity',
        'conflictResolutionUI'
    ], ({ collabEditState: collabEditState, connectivityState: connectivityState, conflictResolutionUIState: conflictResolutionUIState })=>{
        if (!isCollabProviderConnected && !!collabEditState?.initialised?.lastLocalOrganicBodyChangeAt) setUnsavedChanges(!!collabEditProvider?.getUnconfirmedSteps()?.length);
        if ((0, $6Ixg8.isOfflineMode)(connectivityState?.mode)) setUnsavedChanges(!!collabEditProvider?.getUnconfirmedSteps()?.length);
        if ((0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)) {
            const hasConflicts = conflictResolutionUIState?.conflicts && (conflictResolutionUIState?.conflicts.inserted?.length > 0 || conflictResolutionUIState?.conflicts.deleted?.length > 0);
            if (hasConflicts) setHasOfflineConflicts(true);
            else if (hasOfflineConflicts && !hasConflicts) setHasOfflineConflicts(false);
        }
    });
    const { aiIsStreaming: aiIsStreaming } = (0, $c907e804706c3ad7$export$34125ddc34657a7f)(editorPresetAPI);
    const { hasUnsavedBodiedSyncBlockChanges: hasUnsavedBodiedSyncBlockChanges } = (0, $3c299c6e2ce2bea1$export$31b32c1906537e24)(editorPresetAPI);
    /*
   * unsavedChanges is an internal state controlled by listening to collab provider commmit events while isDraftSyncPending is a separate state controlled by draft sync hooks
   */ const shouldRenderLockout = unsavedChanges || isDraftSyncPending;
    return !isExceptionConditionMet && shouldRenderLockout || hasOfflineConflicts || aiIsStreaming || hasUnsavedBodiedSyncBlockChanges && (0, $6mKj3.expValEquals)('platform_synced_block', 'isEnabled', true);
};
const $f8ea506e3a40865e$export$28f25e906763db1e = ({ contentId: contentId, isPublishingContent: isPublishingContent, isFirstParticipant: isFirstParticipant, editorPresetAPI: editorPresetAPI })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    // TODO do we want this in the hook or in this component?
    (0, $cozmU.useEffect)(()=>{
        const deferIdle = (cb)=>{
            if ('requestIdleCallback' in window) requestIdleCallback(cb, {
                timeout: 5000
            });
            else requestAnimationFrame(cb);
        };
        // force load of NavigationLockout on idle so it's available if the
        // connection goes offline
        deferIdle(()=>{
            (0, $2ZJmt.NavigationLockout).preload();
        });
    }, []);
    const hasUnsavedChanges = $f8ea506e3a40865e$export$d85ed874af6294e9({
        contentId: contentId,
        isPublishingContent: isPublishingContent,
        isFirstParticipant: isFirstParticipant,
        editorPresetAPI: editorPresetAPI
    });
    const isSeamlessTransition = (transitionCallbackIds)=>{
        return (0, $9wGTI.fg)('confluence_frontend_transition_preloading_system') ? transitionCallbackIds.includes('live_doc_preloading_transition_callback_id') : false;
    };
    /**
   * We do not want to trigger the lockout if the upcoming location is the same route with the same contentId
   * If the above conditions are true, the user is still editing the page, but the url has changed
   * Which implies the user is not exiting the editor, so we shouldn't block navigation.
   */ const isSameRoute = (currentRoute, nextRoute)=>{
        const contentIdMatch = 'contentId' in nextRoute.params && nextRoute.params['contentId'] === contentId;
        const routeNameMatch = currentRoute.name === nextRoute.name;
        return contentIdMatch && routeNameMatch;
    };
    const isSafeTransition = ({ currentRoute: currentRoute, nextRoute: nextRoute, transitionCallbackIds: transitionCallbackIds })=>{
        return isSameRoute(currentRoute, nextRoute) || transitionCallbackIds && transitionCallbackIds.length > 0 && isSeamlessTransition(transitionCallbackIds);
    };
    return hasUnsavedChanges ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2ZJmt.NavigationLockout), {
        message: intl.formatMessage($f8ea506e3a40865e$var$i18n.lockoutMessage),
        isSafeTransition: isSafeTransition,
        onActivate: (message, currentRoute, nextRoute)=>{
            // message===true tells react-router not to block the transition.
            // We only want to fire an event when a transition was blocked, so we make sure message !== true
            if (message !== true) createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    actionSubject: 'navigationLockoutPrompt',
                    action: 'shown',
                    source: 'NavigationLockout',
                    attributes: {
                        nextRoute: nextRoute?.name ?? '',
                        currentRoute: currentRoute?.name ?? '',
                        contentId: contentId
                    }
                }
            }).fire();
        }
    }) : null;
};


const $d2e739e403a90913$export$1da4922e40f79365 = ({ contentId: contentId, collabEditProvider: collabEditProvider, isPublishingContent: isPublishingContent, isFirstParticipant: isFirstParticipant, editorPresetAPI: editorPresetAPI, isLivePage: isLivePage, hasEditPermission: hasEditPermission, isFastLoadedLiveDoc: isFastLoadedLiveDoc })=>{
    const hasUnsavedChanges = (0, $f8ea506e3a40865e$export$d85ed874af6294e9)({
        contentId: contentId,
        isPublishingContent: isPublishingContent,
        isFirstParticipant: isFirstParticipant,
        editorPresetAPI: editorPresetAPI
    });
    // Create a promise that resolves when we're no longer waiting for unsaved changes. The latest promise will always be used by the transition callback when it's invoked, to ensure we don't transition until there are no unsaved changes.
    // Holds the resolve function for the current pending promise, so we can resolve it from the useEffect when hasUnsavedChanges becomes false.
    const isWaitingForUnsavedChangesPromiseResolveRef = (0, $cozmU.useRef)(null);
    // Holds the promise itself, which the transition callback awaits. Resolved when there are no unsaved changes.
    const isWaitingForUnsavedChangesPromiseRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        // Resolve the promise once hasUnsavedChanges is false if it didn't immediately resolve
        if (!hasUnsavedChanges && isWaitingForUnsavedChangesPromiseResolveRef.current) {
            isWaitingForUnsavedChangesPromiseResolveRef.current();
            isWaitingForUnsavedChangesPromiseResolveRef.current = null;
        }
        // Every time hasUnsavedChanges changes to true, we need to update
        // isWaitingForUnsavedChangesPromiseRef.current in order to ensure
        // we wait for these unsaved changes.
        // Without updating isWaitingForUnsavedChangesPromiseRef, the promise ref
        // may think there are no unsaved changes if `hasUnsavedChanges` was originally `false`
        // but has since changed to `true`.
        if (hasUnsavedChanges && (0, $6mKj3.expValEquals)('platform_synced_block', 'isEnabled', true)) isWaitingForUnsavedChangesPromiseRef.current = new Promise((resolve)=>{
            isWaitingForUnsavedChangesPromiseResolveRef.current = resolve;
        });
    }, [
        hasUnsavedChanges
    ]);
    if (!isWaitingForUnsavedChangesPromiseRef.current) isWaitingForUnsavedChangesPromiseRef.current = new Promise((resolve)=>{
        if (!hasUnsavedChanges) resolve();
        else isWaitingForUnsavedChangesPromiseResolveRef.current = resolve;
    });
    const { client: fetchUsersClient } = (0, $j7xMJ.useFetchUsersClient)();
    const { setCollabEditProvider: setCollabEditProvider, setHasInitialDraft: setHasInitialDraft, resetNativeCollabState: resetNativeCollabState } = (0, $hYoU4.useNativeCollabActions)();
    const { nativeEditorComponentsPreloader: nativeEditorComponentsPreloader } = (0, $39rFu.useEditPageLoadingActions)();
    const { userId: userId, cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const [{ presenceId: presenceId }] = (0, $2VZOl.useNativeCollabPresenceState)();
    const presenceIdRef = (0, $cozmU.useRef)(presenceId);
    presenceIdRef.current = presenceId;
    const [isTransitionPreloading, setIsTransitionPreloading] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!isLivePage || !(0, $9wGTI.fg)('confluence_frontend_transition_preloading_system')) return;
        (0, $ek3aD.getGlobalTransitionPreloader)().registerTransitionCallback({
            id: 'live_doc_preloading_transition_callback_id',
            callback: ({ match: match })=>new Promise(async (resolve)=>{
                    setIsTransitionPreloading(true);
                    try {
                        if (match?.params?.contentId) {
                            // TODO When updating this preloading callback to run on non-livedoc routes as we transition into a live doc:
                            //      Also preload the live doc components. Reference how LivePagePreloader.tsx does this
                            // We destroy collab provider as early as possible to reduce the risk of rare race conditions where
                            //    we end up on a different page than expected after awaiting below promises, and then problematically destroy collab edit provider
                            if (collabEditProvider) {
                                collabEditProvider?.destroy?.();
                                // Clear the memoized function. If the user goes back to editing the same page,
                                // then we don't run into problem trying to talk to the old (destroyed) collab provider.
                                if ((0, $fWGpT.getCollabEditProvider)?.cache?.clear) (0, $fWGpT.getCollabEditProvider).cache.clear();
                            }
                            resetNativeCollabState();
                            (0, $1sAC2.nativeCollabPermissionsTokenState).clearPermissionsTokenState(contentId);
                            const preloadLivePageRoutePromise = (0, $iUV81.preloadLivePageRoute)(match, match.url);
                            await Promise.all([
                                preloadLivePageRoutePromise,
                                nativeEditorComponentsPreloader()
                            ]);
                            // Ensure we're not waiting for unsaved changes before unblocking transition
                            if (isWaitingForUnsavedChangesPromiseRef.current) await isWaitingForUnsavedChangesPromiseRef.current;
                        }
                    } catch (err) {
                        (0, $7W8i8.getLogger)('useLiveDocTransitionCallback').error`Error preloading live doc: ${err}`;
                    }
                    setIsTransitionPreloading(false);
                    resolve();
                }),
            onlyCalledIfFunc: ({ match: match })=>{
                // Don't seamlessly transition if the current live doc is not fast loaded, as non-fast-loaded -> fast-loaded live docs
                //   trigger a remount that breaks NCS on seamless transition
                if (match?.params?.contentId && isFastLoadedLiveDoc) {
                    const { subType: subType } = (0, $9sGCn.getCachedPageData)(match.params.contentId);
                    if (subType === 'live') {
                        // EDITOR-7879: A seamless transition reuses the same editor instance
                        // (NativeCollabLoader holds its key constant), but markdown mode keeps
                        // state outside the React/preset layer that the reuse doesn't reset:
                        // the markdown-mode ProseMirror plugin state and the imperative
                        // `editorView.dom.style.display = 'none'` it applies to hide the WYSIWYG
                        // layer. Reusing the editor across the markdown↔rich boundary leaks that
                        // state onto the destination page — a blank destination (leaving a
                        // markdown page) or markdown/annotation state from the previous page
                        // bleeding onto the next (entering one).
                        //
                        // Ideally we'd disable seamless only for transitions that actually touch
                        // markdown, but the DESTINATION page's markdown status is not knowable
                        // here: its flag is only populated by `preloadContentHeader` inside the
                        // transition callback (which runs *after* this check), and pages reached
                        // via the page-tree sidebar are cached as `PTPage` nodes that carry no
                        // markdown status at all. Until the backend exposes markdown status on
                        // `PTPage` (see EDITOR-7879 follow-up — then this can become a per-page
                        // check on `contentId`/`nextContentId`), we conservatively fall back to a
                        // non-seamless transition — which remounts the editor via the loading
                        // screen and resets it cleanly — for ALL live-doc navigations whenever
                        // this gate is enabled.
                        //
                        // This is a temporary kill switch to disable seamless when markdown mode is enabled.
                        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
                        (0, $9wGTI.fg)('confluence_md_mode_disable_seamless_transition') && (0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true)) return false;
                        return true;
                    }
                }
                return false;
            },
            onPerformanceMetricStart: ({ match: match })=>{
                if (match?.params?.contentId) (0, $7PuC4.startLivePageLoadMetrics)({
                    userId: userId ?? undefined
                });
            },
            onRouteContinueCallback: ({ match: match })=>new Promise(async (resolve)=>{
                    const nextContentId = match?.params?.contentId;
                    const { subType: subType } = (0, $9sGCn.getCachedPageData)(nextContentId);
                    if (subType !== 'live') return;
                    const draft = await (0, $5Za2S.getDraft)(nextContentId); // This is performant as it's already cached because our callback promise retrieved CollabDraftQuery in `preloadLivePageRoute`
                    const ncsProvider = (0, $fWGpT.getCollabEditProvider)({
                        contentId: nextContentId,
                        cloudId: cloudId,
                        activationId: activationId,
                        contentType: 'page',
                        permissionTokenRefresh: (0, $8KbKw.fetchCollabPermissionToken)(nextContentId, undefined),
                        initialDraft: draft,
                        isLivePage: true,
                        presenceId: presenceIdRef.current,
                        presenceActivity: hasEditPermission ? 'editor' : 'viewer',
                        userId: userId,
                        fetchUsersClient: fetchUsersClient
                    });
                    setCollabEditProvider(ncsProvider);
                    // @ts-ignore
                    const hasInitialDraft = Boolean(ncsProvider?.initialDraft);
                    setHasInitialDraft(hasInitialDraft);
                    resolve();
                })
        });
    }, [
        activationId,
        contentId,
        isLivePage,
        collabEditProvider,
        setCollabEditProvider,
        setHasInitialDraft,
        cloudId,
        nativeEditorComponentsPreloader,
        spaceKey,
        userId,
        hasEditPermission,
        presenceIdRef,
        fetchUsersClient,
        resetNativeCollabState,
        isFastLoadedLiveDoc
    ]);
    return {
        isTransitionPreloading: isTransitionPreloading
    };
};






var $bn20W = parcelRequire("bn20W");














var $dVPAB = parcelRequire("dVPAB");


var $2InGJ = parcelRequire("2InGJ");





var $cMyWi = parcelRequire("cMyWi");


var $93Gae = parcelRequire("93Gae");

/**
 * `useFileMediaUrlSerializer(contentId)` — produces a sync `serializeFileMedia`
 * callback for `MarkdownSourceView` / `markdownModePlugin`.
 *
 * Strategy: avoid embedding any media tokens / signed URLs in the markdown
 * by routing every `media (type: "file")` reference through Confluence's
 * tenant-wide attachment proxy:
 *
 *   /wiki/download/attachments/{contentId}/{filename}
 *
 * The proxy authenticates with the viewer's Confluence session cookie, so
 * the markdown text stays credential-free and external markdown clients
 * (VS Code preview, GitHub, Obsidian, …) render the image as long as the
 * viewer has read access to the page in their browser.
 *
 * The proxy URL needs the attachment **filename**, but the ADF media node
 * only carries an opaque media-service `id`. We resolve `id → filename` by
 * paginating through the page's attachments via the same GraphQL query
 * `editor-features`'s `createFallbackMediaNameFetcher` uses (Apollo
 * dedupes). The lookup is async; we eagerly populate a sync map on mount
 * so the returned `serializeFileMedia` is a pure map lookup.
 *
 * v1 caveats (deliberate):
 *  - Files added during the markdown-mode session aren't in the map until
 *    the next mount. The serialiser falls back to alt-text-only for
 *    unknown ids — never a `blob:` / token URL.
 *  - DSP-blocked spaces (which require the `/wiki/download/legacy/...`
 *    variant — see `confluence/next/packages/data-security/src/`) are not
 *    yet handled; v1 will produce a URL that 403s for those tenants. A
 *    follow-up should accept a "legacy" mode flag.
 */ 





/**
 * @generated SignedSource<<fa5585bc348a0692ae1b0e617d6f66e9>>
 * @relayHash ca5a1cd6fb4c79c298f1d89fd7aa89a8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5c8cfa631ca619371657853b90772f5dee375aa019a514adaa267c3ffcf47ed2
const $6a682a3e52537365$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "offset"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "status",
            "value": [
                "current",
                "draft"
            ]
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "offset",
            "variableName": "offset"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "title"
    }, v6 = {
        "concreteType": "KeyValueHierarchyMap",
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    }, v7 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useFileMediaUrlSerializerQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v4 /*: any*/ ,
                                            "concreteType": "PaginatedContentList",
                                            "kind": "LinkedField",
                                            "name": "attachments",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Content",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                },
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useFileMediaUrlSerializerQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v4 /*: any*/ ,
                                            "concreteType": "PaginatedContentList",
                                            "kind": "LinkedField",
                                            "name": "attachments",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Content",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                },
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "ca5a1cd6fb4c79c298f1d89fd7aa89a8",
            "id": "5c8cfa631ca619371657853b90772f5dee375aa019a514adaa267c3ffcf47ed2",
            "metadata": {},
            "name": "useFileMediaUrlSerializerQuery",
            "operationKind": "query",
            "text": "query useFileMediaUrlSerializerQuery($contentId:ID!,$offset:Int,$first:Int){content(id:$contentId,status:[\"current\",\"draft\"]){edges{node{attachments(first:$first,offset:$offset){nodes{title,extensions{key,value},id},pageInfo{hasNextPage}},id}}}}"
        }
    };
}();
$6a682a3e52537365$var$node.hash = "20dfe3cceb5bc1949a2662ec2e65be52";
var $6a682a3e52537365$export$2e2bcd8739ae039 = $6a682a3e52537365$var$node;


const $794fa08d21c76c29$export$6a0c4b58270c439e = (0, $6a682a3e52537365$export$2e2bcd8739ae039);


const $b3fc8b60d65ac60d$var$PAGE_SIZE = 50;
const $b3fc8b60d65ac60d$var$MAX_ITERATIONS = 50;
const $b3fc8b60d65ac60d$var$buildAttachmentMap = async (contentId)=>{
    const map = new Map();
    let offset = 0;
    let iterations = 0;
    let hasNextPage = true;
    while(hasNextPage && iterations < $b3fc8b60d65ac60d$var$MAX_ITERATIONS){
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: (0, $794fa08d21c76c29$export$6a0c4b58270c439e),
            variables: {
                contentId: contentId,
                offset: offset,
                first: $b3fc8b60d65ac60d$var$PAGE_SIZE
            },
            fetchPolicy: 'cache-first',
            __callerPackage__: "content-markdown-mode"
        }).catch(()=>({
                data: null
            }));
        const attachments = data?.content?.edges?.[0]?.node?.attachments;
        const nodes = attachments?.nodes ?? [];
        // Process each attachment and pull out its `fileId` extension.
        //
        // The lint rule (`@atlassian/perf-linting/no-quadratic-complexity`)
        // flags any nested iteration as a potential O(n²) hot spot. In this
        // case the outer loop is bounded by attachments-per-page (a real but
        // modest number — typically dozens, capped at PAGE_SIZE × MAX_ITERATIONS
        // = 2500) and the inner loop is bounded by extensions-per-attachment
        // (a small fixed schema field set, ~4-6 entries in practice — NOT
        // scaled by attachment count). So the actual complexity is O(N × k)
        // with k constant, i.e. linear. The lint rule cannot infer this.
        //
        // Disabling the rule locally with the rationale above rather than
        // reshaping the code into a less-readable form just to satisfy the
        // heuristic.
        // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
        for (const node of nodes){
            if (!node?.title || !node?.extensions) continue;
            let fileId;
            // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
            for (const ext of node.extensions)if (ext?.key === 'fileId' && ext?.value) {
                fileId = ext.value;
                break;
            }
            if (fileId) map.set(fileId, node.title);
        }
        hasNextPage = attachments?.pageInfo?.hasNextPage ?? false;
        offset += $b3fc8b60d65ac60d$var$PAGE_SIZE;
        iterations += 1;
    }
    return map;
};
/** URL-encode but keep `/` so a filename like `images/foo.png` still works. */ const $b3fc8b60d65ac60d$var$encodeFilename = (filename)=>filename.split('/').map((segment)=>encodeURIComponent(segment)).join('/');
/**
 * Returns the tenant base URL (scheme + host) for the current Confluence
 * instance. Using `window.location.origin` is the canonical pattern across
 * confluence-next packages (see e.g. `attachments-page/AttachmentActions.tsx`
 * and `audio/src/utils/getContentUrl.ts`).
 *
 * Falls back to an empty string during SSR / test environments where
 * `window` may not be defined — in that context the URL degrades to a
 * relative path, which is still resolvable for in-browser rendering.
 */ const $b3fc8b60d65ac60d$var$getOrigin = ()=>typeof window !== 'undefined' && window.location ? window.location.origin : '';
const $b3fc8b60d65ac60d$export$9176907a1a866976 = (contentId)=>{
    const [filenameMap, setFilenameMap] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!contentId) {
            setFilenameMap(null);
            return undefined;
        }
        let cancelled = false;
        $b3fc8b60d65ac60d$var$buildAttachmentMap(contentId).then((map)=>{
            if (!cancelled) setFilenameMap(map);
        }).catch(()=>{
            if (!cancelled) setFilenameMap(new Map());
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        contentId
    ]);
    return (0, $cozmU.useMemo)(()=>{
        if (!contentId) return undefined;
        const map = filenameMap;
        const serializer = ({ id: id, alt: alt })=>{
            const origin = $b3fc8b60d65ac60d$var$getOrigin();
            const base = `${origin}/wiki/download/attachments/${encodeURIComponent(contentId)}`;
            // 1. Try the pre-fetched id→filename map first (covers existing media).
            const mappedFilename = map?.get(id);
            if (mappedFilename) return `${base}/${$b3fc8b60d65ac60d$var$encodeFilename(mappedFilename)}`;
            // 2. Fall back to `attrs.alt` as filename for newly uploaded files.
            //    `editor-plugin-media-insert` sets `alt: fileName` on the media
            //    node immediately at insert time, so we have the real filename even
            //    before the attachment list is re-fetched. This means freshly
            //    uploaded media round-trips correctly in the same session without
            //    needing to invalidate and refetch the attachment map.
            //
            //    This is safe to use as the filename because:
            //    a) We set it from `fileName` in the upload response, which IS
            //       the canonical attachment filename in Confluence's media service.
            //    b) Even if `alt` was manually edited by the user after insert, the
            //       worst outcome is a 404 on the proxy URL — not a credential leak.
            if (alt) return `${base}/${$b3fc8b60d65ac60d$var$encodeFilename(alt)}`;
            // 3. No filename available — return undefined so the caller emits
            //    alt-text-only rather than a broken empty URL.
            return undefined;
        };
        return serializer;
    }, [
        contentId,
        filenameMap
    ]);
};



















var $9uAPw = parcelRequire("9uAPw");




const $04e4e4b928c4520b$export$9ac42f814ec8d6c6 = ({ mentionChanges: mentionChanges, deletedMentions: deletedMentions, addedMentions: addedMentions, setDeletedMentions: setDeletedMentions, setAddedMentions: setAddedMentions, userId: userId, unrestrictedMentions: unrestrictedMentions, parentSpaceRestrictedMentions: parentSpaceRestrictedMentions, pageRestrictedMentions: pageRestrictedMentions, unrestrictedTasks: unrestrictedTasks, addedTasks: addedTasks, deletedTasks: deletedTasks, setAddedTasks: setAddedTasks, setDeletedTasks: setDeletedTasks, pageRestrictedTasks: pageRestrictedTasks, parentSpaceRestrictedTasks: parentSpaceRestrictedTasks, setMentionsAdded: setMentionsAdded, setTasksAdded: setTasksAdded })=>{
    // Process added mentions first
    const addedMentionsExcludingCurrentUser = [];
    const addedTasksExcludingCurrentUser = [];
    const currentUserAddedMentions = []; // user mentioned themselves
    const currentUserAddedTasks = [];
    mentionChanges.forEach((mentionChange)=>{
        // we add user mentioning themselves so that we let backend know not to notify them
        if (mentionChange.id === userId) {
            if (mentionChange.type === 'added') {
                if (mentionChange?.taskLocalId) currentUserAddedTasks.push(mentionChange);
                else currentUserAddedMentions.push(mentionChange);
            }
        } else if (mentionChange.type === 'added') {
            if (mentionChange?.taskLocalId) addedTasksExcludingCurrentUser.push(mentionChange);
            else addedMentionsExcludingCurrentUser.push(mentionChange);
        }
    });
    if (currentUserAddedMentions.length > 0) setMentionsAdded({
        currentUser: currentUserAddedMentions
    });
    if (currentUserAddedTasks.length > 0) setTasksAdded({
        currentUser: currentUserAddedTasks
    });
    const currentAndNewAddedMentions = [
        ...addedMentions,
        ...addedMentionsExcludingCurrentUser
    ];
    const currentAndNewAddedTasks = [
        ...addedTasks,
        ...addedTasksExcludingCurrentUser
    ];
    if (addedMentionsExcludingCurrentUser.length > 0) setAddedMentions(currentAndNewAddedMentions);
    if (addedTasksExcludingCurrentUser.length > 0) setAddedTasks(currentAndNewAddedTasks);
    const currentAddedMentionsLocalIds = new Set([
        ...unrestrictedMentions.map((mention)=>mention.localId),
        ...parentSpaceRestrictedMentions.map((mention)=>mention.localId),
        ...pageRestrictedMentions.map((mention)=>mention.localId)
    ]);
    const currentAddedTasksLocalIds = new Set([
        ...unrestrictedTasks.map((mention)=>mention.localId),
        ...parentSpaceRestrictedTasks.map((mention)=>mention.localId),
        ...pageRestrictedTasks.map((mention)=>mention.localId)
    ]);
    // Process deleted mentions next, but only if they exist in the added mentions
    const validDeletedMentions = [];
    const validDeletedTasks = [];
    mentionChanges.forEach((mentionChange)=>{
        if (mentionChange.id !== userId) {
            if (mentionChange.type === 'deleted') {
                if (currentAddedMentionsLocalIds.has(mentionChange.localId)) validDeletedMentions.push(mentionChange);
                else if (currentAddedTasksLocalIds.has(mentionChange.localId)) validDeletedTasks.push(mentionChange);
            }
        }
    });
    if (validDeletedMentions.length > 0) setDeletedMentions([
        ...deletedMentions,
        ...validDeletedMentions
    ]);
    if (validDeletedTasks.length > 0) setDeletedTasks([
        ...deletedTasks,
        ...validDeletedTasks
    ]);
};



var $aWwYt = parcelRequire("aWwYt");





var $9Zt9E = parcelRequire("9Zt9E");


var $3GtBN = parcelRequire("3GtBN");


var $ijGoX = parcelRequire("ijGoX");


var $bDgLc = parcelRequire("bDgLc");








var $yuV6Z = parcelRequire("yuV6Z");







function $78d13d0c9995dbf8$export$7274b8e5fdf0c8bf() {
    const { userId: userId, cloudId: cloudId, isLicensed: isLicensed, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    // We need a special emoji parameters that supports SSR load optimization here.
    const emojiResourceParams = (0, $cozmU.useMemo)(()=>{
        return (0, $yuV6Z.createEmojiProviderParameters)({
            cloudId: cloudId,
            userId: userId,
            isLicensed: isLicensed,
            isLoggedIn: isLoggedIn
        });
    }, [
        cloudId,
        userId,
        isLicensed,
        isLoggedIn
    ]);
    const emojiNodeDataProvider = (0, $32x2E.getEmojiNodeDataProvider)((0, $kwzZh.default), {
        ...emojiResourceParams,
        allowAnonymousAccess: true
    });
    if (emojiNodeDataProvider) {
        const ssrProvidersData = window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] || {};
        const ssrData = ssrProvidersData['emojiNodeDataProvider'];
        emojiNodeDataProvider.setSSRData(ssrData);
    }
    return emojiNodeDataProvider;
}









var $3u0dr = parcelRequire("3u0dr");











var $6Ec6w = parcelRequire("6Ec6w");


var $cJ0FD = parcelRequire("cJ0FD");


var $7Ndnw = parcelRequire("7Ndnw");


var $3b6WO = parcelRequire("3b6WO");


var $9fBoq = parcelRequire("9fBoq");


var $eSLr0 = parcelRequire("eSLr0");


var $6ld6a = parcelRequire("6ld6a");


var $2Awp2 = parcelRequire("2Awp2");




















var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");





var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");








var $6uUjl = parcelRequire("6uUjl");











var $i5zxs = parcelRequire("i5zxs");

// I'm optimizing for single byline as most instances have an average of 2 - 3 apps in the byline and shouldn't be multiline
const $b54e9ea534ca36ea$var$PAGE_PADDING_TOP = 135; // Rough estimate for cover picture avg height - doesn't need to be exact since the popup will float in editor
const $b54e9ea534ca36ea$var$COVER_PICTURE_PADDING_TOP = 275;
const $b54e9ea534ca36ea$var$popupWrapperStyle = (0, $buxP3.xcss)({
    padding: 'space.250',
    maxWidth: '500px',
    maxHeight: '500px'
});
const $b54e9ea534ca36ea$var$triggerStyles = null;
const $b54e9ea534ca36ea$export$8b1e2d0f3ad73269 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { contentId: contentId, forgeExtension: forgeExtension, onClose: onClose, selection: selection } = t0;
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t2;
    if ($[0] !== contentId || $[1] !== createAnalyticsEvent || $[2] !== forgeExtension?.appId || $[3] !== forgeExtension?.appOwner || $[4] !== forgeExtension?.appVersion || $[5] !== forgeExtension?.id || $[6] !== forgeExtension?.key || $[7] !== isLivePage) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    source: "editorActionsToolbarMenu",
                    action: "shown",
                    actionSubject: "forgeApp",
                    actionSubjectId: "editorActionsMenuForgeApp",
                    attributes: {
                        contentId: contentId,
                        isLivePage: isLivePage,
                        appInfo: {
                            id: forgeExtension?.id,
                            appId: forgeExtension?.appId,
                            key: forgeExtension?.key,
                            appVersion: forgeExtension?.appVersion,
                            appOwner: forgeExtension?.appOwner
                        }
                    }
                }
            }).fire();
        };
        $[0] = contentId;
        $[1] = createAnalyticsEvent;
        $[2] = forgeExtension?.appId;
        $[3] = forgeExtension?.appOwner;
        $[4] = forgeExtension?.appVersion;
        $[5] = forgeExtension?.id;
        $[6] = forgeExtension?.key;
        $[7] = isLivePage;
        $[8] = t2;
    } else t2 = $[8];
    const handleInitialRender = t2;
    let t3;
    if ($[9] !== onClose) {
        t3 = {
            close: onClose
        };
        $[9] = onClose;
        $[10] = t3;
    } else t3 = $[10];
    const memoedBridge = t3;
    let t4;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = [
            (0, $i5zxs.CoverPictureStateContainer)
        ];
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== Popup || $[13] !== contentId || $[14] !== forgeExtension || $[15] !== handleInitialRender || $[16] !== isLivePage || $[17] !== memoedBridge || $[18] !== onClose || $[19] !== routeName || $[20] !== selection.coords.bottom || $[21] !== selection.coords.left || $[22] !== selection.coords.right || $[23] !== selection.coords.top || $[24] !== selection.text || $[25] !== spaceId || $[26] !== spaceKey) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: t4
        }, (coverPictureState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Popup, {
                content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                        xcss: $b54e9ea534ca36ea$var$popupWrapperStyle,
                        testId: "forge-editor-popup-content"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
                        attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7QUD1.ContextMenuForgeApp), {
                        app: forgeExtension,
                        extensionData: {
                            type: (0, $7Ndnw.FORGE_MODULE_CONTEXT_MENU),
                            selectedText: selection.text,
                            content: {
                                id: contentId || "",
                                type: (0, $hIaUw.getContentType)(routeName),
                                subtype: isLivePage ? "live" : null
                            },
                            space: {
                                key: spaceKey,
                                id: spaceId
                            }
                        },
                        onInitialRender: handleInitialRender,
                        onTearDown: onClose,
                        bridge: memoedBridge
                    }))),
                trigger: (t6)=>{
                    const { ref: ref } = t6;
                    const sideNavWidth = document.getElementById("side-navigation")?.offsetWidth || 0;
                    const leftCoords = selection.coords.left - sideNavWidth;
                    const topCoords = coverPictureState.state.hasCoverPicture ? selection.coords.top + $b54e9ea534ca36ea$var$COVER_PICTURE_PADDING_TOP - $b54e9ea534ca36ea$var$PAGE_PADDING_TOP : selection.coords.top - $b54e9ea534ca36ea$var$PAGE_PADDING_TOP;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                        "data-testid": "forge-editor-action-selection",
                        ref: ref,
                        style: {
                            top: topCoords,
                            left: leftCoords,
                            width: selection.coords.right - selection.coords.left,
                            height: selection.coords.bottom - selection.coords.top
                        },
                        className: (0, $hekY6.default)([
                            "_kqswstnw _lcxvglyw"
                        ])
                    });
                },
                isOpen: true,
                placement: "bottom"
            }));
        $[12] = Popup;
        $[13] = contentId;
        $[14] = forgeExtension;
        $[15] = handleInitialRender;
        $[16] = isLivePage;
        $[17] = memoedBridge;
        $[18] = onClose;
        $[19] = routeName;
        $[20] = selection.coords.bottom;
        $[21] = selection.coords.left;
        $[22] = selection.coords.right;
        $[23] = selection.coords.top;
        $[24] = selection.text;
        $[25] = spaceId;
        $[26] = spaceKey;
        $[27] = t5;
    } else t5 = $[27];
    return t5;
} : ({ contentId: contentId, forgeExtension: forgeExtension, onClose: onClose, selection: selection })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleInitialRender = ()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'editorActionsToolbarMenu',
                action: 'shown',
                actionSubject: 'forgeApp',
                actionSubjectId: 'editorActionsMenuForgeApp',
                attributes: {
                    contentId: contentId,
                    isLivePage: isLivePage,
                    appInfo: {
                        id: forgeExtension?.id,
                        appId: forgeExtension?.appId,
                        key: forgeExtension?.key,
                        appVersion: forgeExtension?.appVersion,
                        appOwner: forgeExtension?.appOwner
                    }
                }
            }
        }).fire();
    };
    // Bridge needs to be memoised here.
    // Otherwise the useMemo hook in NativeUIRenderer will trigger an infinite rerender loop on ContextMenuForgeApp when using the Frame component.
    const memoedBridge = (0, $cozmU.useMemo)(()=>({
            close: onClose
        }), [
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $i5zxs.CoverPictureStateContainer)
        ]
    }, (coverPictureState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Popup, {
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                    xcss: $b54e9ea534ca36ea$var$popupWrapperStyle,
                    testId: "forge-editor-popup-content"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
                    attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7QUD1.ContextMenuForgeApp), {
                    app: forgeExtension,
                    extensionData: {
                        type: (0, $7Ndnw.FORGE_MODULE_CONTEXT_MENU),
                        selectedText: selection.text,
                        content: {
                            id: contentId || '',
                            type: (0, $hIaUw.getContentType)(routeName),
                            subtype: isLivePage ? 'live' : null
                        },
                        space: {
                            key: spaceKey,
                            id: spaceId
                        }
                    },
                    onInitialRender: handleInitialRender,
                    onTearDown: onClose,
                    bridge: memoedBridge
                }))),
            trigger: ({ ref: ref })=>{
                // Adjust left position based on if side nav is open or not - it will push the content too left if we don't check
                // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                const sideNavWidth = document.getElementById('side-navigation')?.offsetWidth || 0;
                const leftCoords = selection.coords.left - sideNavWidth; // Adjust top position based on if cover picture is present or not - it will be too high otherwise
                const topCoords = coverPictureState.state.hasCoverPicture ? selection.coords.top + $b54e9ea534ca36ea$var$COVER_PICTURE_PADDING_TOP - $b54e9ea534ca36ea$var$PAGE_PADDING_TOP : selection.coords.top - $b54e9ea534ca36ea$var$PAGE_PADDING_TOP;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                    "data-testid": "forge-editor-action-selection",
                    ref: ref,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Dynamic positioning based on selection coordinates
                        top: topCoords,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Dynamic positioning based on selection coordinates
                        left: leftCoords,
                        width: selection.coords.right - selection.coords.left,
                        height: selection.coords.bottom - selection.coords.top
                    },
                    className: (0, $hekY6.default)([
                        "_kqswstnw _lcxvglyw"
                    ])
                });
            },
            isOpen: true,
            placement: "bottom"
        }));
};


const $263e225aef982cc6$var$iconImageStyle = null; // Need this to satisfy the toolbar extension API which expects a label prop type
const $263e225aef982cc6$var$ImageIcon = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { label: label, src: src } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_4t3i1tcg _1bsb1tcg"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== label || $[2] !== src) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: src,
            alt: label,
            className: t1
        }));
        $[1] = label;
        $[2] = src;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ label: label, src: src })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: src,
        alt: label,
        className: (0, $hekY6.default)([
            "_4t3i1tcg _1bsb1tcg"
        ])
    }));
const $263e225aef982cc6$export$a3c406cbb96a0e18 = (contentId, shouldFetch = false)=>{
    // Need ref since these are fetched and updated asynchronously so the API uses a ref to track this
    const extensionsRef = (0, $cozmU.useRef)([]); // Forge items
    const { extensions: extensions } = (0, $3b6WO.useExtensionList)({
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTEXT_MENU),
        queryOptions: {
            fetchPolicy: 'cache-first'
        },
        skipQuery: !shouldFetch
    });
    // Connect items
    const { webItems: webItems } = (0, $6ld6a.useWebItemLocation)({
        contentId: contentId,
        location: (0, $eSLr0.ACTION_PANEL),
        skipQuery: !shouldFetch
    });
    const filteredWebItems = webItems.filter((item)=>!(0, $2Awp2.DROPDOWN_EXCLUDED_ITEMS).includes(item.completeKey || ''));
    const connectItems = filteredWebItems.map((item_0)=>({
            label: item_0?.label,
            icon: item_0?.icon?.path ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($263e225aef982cc6$var$ImageIcon, {
                    label: item_0?.label || '',
                    src: item_0?.icon?.path
                }) : (0, (/*@__PURE__*/$parcel$interopDefault($6Ec6w))),
            onClick: ()=>{
                if (item_0?.url) window.open(item_0.url, '_blank');
            }
        }));
    const forgeItems = extensions.map((extension)=>({
            label: (0, $9fBoq.extensionTitle)(extension),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6Ec6w))),
            contentComponent: ({ selection: selection, closeExtension: closeExtension })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b54e9ea534ca36ea$export$8b1e2d0f3ad73269), {
                    key: extension.key,
                    contentId: contentId,
                    forgeExtension: extension,
                    onClose: closeExtension,
                    selection: selection
                });
            }
        }));
    extensionsRef.current = [
        ...connectItems,
        ...forgeItems
    ];
    return [
        {
            key: 'external-extensions',
            source: 'external',
            inlineToolbar: {
                getMenuItems: ()=>{
                    return [
                        ...extensionsRef.current
                    ];
                }
            }
        }
    ];
};









var $iRFKG = parcelRequire("iRFKG");





var $1mDVg = parcelRequire("1mDVg");

parcelRequire("aiS08");
var $1L1jV = parcelRequire("1L1jV");







const $304811a46258dbff$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    singleCreateWorkItemNameUpdated: {
        id: "jira-work-create-extension.single-create-work-item.name.updated",
        defaultMessage: "Jira work item"
    },
    bulkCreateWorkItemNameUpdated: {
        id: "jira-work-create-extension.bulk-create-work-item.name.updated",
        defaultMessage: "Jira work items"
    }
});



var $aUTn5 = parcelRequire("aUTn5");


var $UNr39 = parcelRequire("UNr39");


var $3TWPv = parcelRequire("3TWPv");

const $7a3ce11c17355349$export$5e8df502ba998c83 = ({ rightSidebarContext: rightSidebarContext, actions: actions, activeSelection: activeSelection, selectionAdfResult: selectionAdfResult, contentId: contentId, contentType: contentType, container: container, lastModified: lastModified, isActionItemInSelection: isActionItemInSelection, pageMode: pageMode, editorAPI: editorAPI })=>{
    if (!contentId) return;
    if (editorAPI !== null && editorAPI !== undefined) {
        actions.setEditorAPI(editorAPI);
        const selectionResult = editorAPI.selectionExtension?.actions?.getSelectionAdf?.();
        actions.setSelectedAdf(selectionResult?.selectedNodeAdf ?? undefined);
    }
    (0, $3TWPv.openSingleIssueSidePanelWithSelection)({
        actions: actions,
        rightSidebarContext: rightSidebarContext,
        activeSelection: activeSelection,
        selectionAdfResult: selectionAdfResult,
        contentId: contentId,
        contentType: contentType,
        container: container,
        lastModified: lastModified,
        pageMode: pageMode,
        isActionItemInSelection: isActionItemInSelection,
        convertSelectionToLegacyFormat: $aUTn5.convertSelectionToLegacyFormat
    });
};
const $7a3ce11c17355349$export$494c35a67fd7a49e = ({ rightSidebarContext: rightSidebarContext, actions: actions, editorAPI: editorAPI })=>{
    if (editorAPI !== null && editorAPI !== undefined) actions.setEditorAPI(editorAPI);
    rightSidebarContext.open((0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_ID), (0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH));
};


const $dc24c60db4dc9ba4$var$WorkItemCreationType = {
    SINGLE_WORK_ITEM: 'SINGLE_ISSUE',
    MULTIPLE_WORK_ITEM: 'MULTIPLE_ISSUE',
    AI_WORK_ITEM: 'AI_ISSUE'
};
const $dc24c60db4dc9ba4$export$d32eae3898223fdf = ({ rightSidebarContextRef: rightSidebarContextRef, pageModeRef: pageModeRef, hasEditPermissionRef: hasEditPermissionRef })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [, actions] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireCreateWorkItemButtonClickedAnalytics = (0, $cozmU.useCallback)((workItemCreationType, isCreatedFromTable)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'confluenceHighlightActionsMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'jiraIssueLink',
                type: 'ui',
                attributes: {
                    issueCreationType: workItemCreationType,
                    // Set to false because a dropdown or flyout is not implemented at this entry point.
                    // TODO: Update this value if a dropdown or flyout is added in the future.
                    isDropdownItem: false,
                    isCreatedFromTable: isCreatedFromTable,
                    pageMode: pageModeRef.current,
                    hasEditPermission: hasEditPermissionRef.current
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        pageModeRef,
        hasEditPermissionRef
    ]);
    const handleSingleCreateClick = (0, $cozmU.useCallback)(async ()=>{
        actions.setHasEditPermission(hasEditPermissionRef.current);
        const activeSelection = window.getSelection();
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const container = document.querySelector('div#ak-editor-textarea');
        fireCreateWorkItemButtonClickedAnalytics($dc24c60db4dc9ba4$var$WorkItemCreationType.SINGLE_WORK_ITEM, // Set to false because bulk creation from the table is not yet available at this entry point.
        // TODO: Update this value if bulk creation functionality is added in the future.
        false);
        (0, $7a3ce11c17355349$export$5e8df502ba998c83)({
            activeSelection: activeSelection,
            container: container,
            contentId: contentId,
            contentType: contentType,
            rightSidebarContext: rightSidebarContextRef?.current,
            actions: actions,
            pageMode: pageModeRef.current,
            editorAPI: undefined
        });
    }, [
        fireCreateWorkItemButtonClickedAnalytics,
        contentId,
        contentType,
        rightSidebarContextRef,
        actions,
        pageModeRef,
        hasEditPermissionRef
    ]);
    return {
        name: formatMessage((0, $304811a46258dbff$export$defe85febe8b728c).singleCreateWorkItemNameUpdated),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
        onClick: ()=>{
            handleSingleCreateClick();
        },
        isDisabled: ()=>{
            const currentSidebar = rightSidebarContextRef?.current?.getCurrent();
            return currentSidebar?.panelId === (0, $1L1jV.ISSUE_CREATE_SIDE_PANEL_ID);
        }
    };
};












var $f1iv3 = parcelRequire("f1iv3");










parcelRequire("aiS08");












var $2ViZo = parcelRequire("2ViZo");


var $hq2Sz = parcelRequire("hq2Sz");


var $cSSgB = parcelRequire("cSSgB");



const $a8cc1d5c0eec455b$export$ccdc6b8dc23bf978 = (editorAPI)=>{
    if (!editorAPI?.selectionExtension?.actions?.getSelectionAdf) return false;
    const selectionResult = editorAPI.selectionExtension.actions.getSelectionAdf();
    // Determine if multiple table rows are selected
    return selectionResult?.selectedNodeAdf?.type === 'table' && !!selectionResult?.selectionRanges && selectionResult.selectionRanges.length > 1;
};


const $8055735e114abbc3$var$WorkItemCreationType = {
    SINGLE_WORK_ITEM: 'SINGLE_ISSUE',
    MULTIPLE_WORK_ITEM: 'MULTIPLE_ISSUE',
    AI_WORK_ITEM: 'AI_ISSUE'
};
const $8055735e114abbc3$export$f0c80e15dd78dd09 = ({ rightSidebarContextRef: rightSidebarContextRef, pageModeRef: pageModeRef, hasEditPermissionRef: hasEditPermissionRef, editorAPIRef: editorAPIRef })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const actions = (0, $1mDVg.useIssueCreateSidePanelActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const setIsCreatedFromTable = (0, $hq2Sz.useSetIsCreatedFromTable)();
    const setIsCreatedFromActionItems = (0, $hq2Sz.useSetIsCreatedFromActionItems)();
    const lastModified = (0, $hq2Sz.useGetContentLastModifiedTimestamp)();
    const setSelectedTableAdf = (0, $hq2Sz.useSetSelectedTableAdf)();
    const fireCreateWorkItemButtonClickedAnalytics = (0, $cozmU.useCallback)((workItemCreationType, isCreatedFromTable, isCreatedFromActionItems)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'confluenceHighlightActionsMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'jiraIssueLink',
                type: 'ui',
                attributes: {
                    issueCreationType: workItemCreationType,
                    isDropdownItem: false,
                    isCreatedFromTable: isCreatedFromTable,
                    isCreatedFromActionItems: isCreatedFromActionItems,
                    pageMode: pageModeRef.current,
                    hasEditPermission: hasEditPermissionRef.current
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        pageModeRef,
        hasEditPermissionRef
    ]);
    const initializeCreateState = (0, $cozmU.useCallback)(()=>{
        actions.setHasEditPermission(hasEditPermissionRef.current);
        const activeSelection = window.getSelection();
        const selectionAdfResult = editorAPIRef.current?.selectionExtension?.actions?.getSelectionAdf?.();
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const container = document.querySelector('div#ak-editor-textarea');
        return {
            activeSelection: activeSelection,
            selectionAdfResult: selectionAdfResult,
            container: container
        };
    }, [
        actions,
        hasEditPermissionRef,
        editorAPIRef
    ]);
    const handleSingleCreateClick = (0, $cozmU.useCallback)(()=>{
        const { activeSelection: activeSelection, selectionAdfResult: selectionAdfResult, container: container } = initializeCreateState();
        const actionItemSelectionIfPresent = (0, $cSSgB.getClosestActionListFromSelection)(activeSelection, pageModeRef.current);
        fireCreateWorkItemButtonClickedAnalytics($8055735e114abbc3$var$WorkItemCreationType.SINGLE_WORK_ITEM, false, !!actionItemSelectionIfPresent);
        (0, $7a3ce11c17355349$export$5e8df502ba998c83)({
            activeSelection: activeSelection,
            container: container,
            contentId: contentId,
            contentType: contentType,
            rightSidebarContext: rightSidebarContextRef?.current,
            actions: actions,
            isActionItemInSelection: !!actionItemSelectionIfPresent,
            pageMode: pageModeRef.current,
            editorAPI: editorAPIRef.current,
            selectionAdfResult: selectionAdfResult
        });
    }, [
        initializeCreateState,
        contentId,
        actions,
        pageModeRef,
        rightSidebarContextRef,
        fireCreateWorkItemButtonClickedAnalytics,
        contentType,
        editorAPIRef
    ]);
    const handleBulkCreateClick = (0, $cozmU.useCallback)(()=>{
        const { activeSelection: activeSelection, selectionAdfResult: selectionAdfResult, container: container } = initializeCreateState();
        if (!contentId) //We'd always expect a contentId to be returned from the page context.
        //In the unexpected case where it is not, the button press will be a no-op and the user can try clicking again,
        //upon which the contentId should hopefully be populated.
        return;
        const result = (0, $2ViZo.prepareBulkCreateFromSelection)({
            actions: actions,
            activeSelection: activeSelection,
            contentId: contentId,
            container: container,
            lastModified: lastModified,
            pageMode: pageModeRef.current,
            hasEditPermission: hasEditPermissionRef.current,
            setIsCreatedFromTable: setIsCreatedFromTable,
            setIsCreatedFromActionItems: setIsCreatedFromActionItems,
            convertSelectionToLegacyFormat: $aUTn5.convertSelectionToLegacyFormat,
            selectionAdfResult: selectionAdfResult
        });
        if (result === (0, $2ViZo.BulkSelectionResult).Table) {
            const tableAdf = selectionAdfResult?.selectedNodeAdf;
            setSelectedTableAdf(tableAdf ?? undefined);
        }
        if (result === (0, $2ViZo.BulkSelectionResult).None) {
            //In the unexpected case where the selection cannot be prepared for bulk create, we fall back to the single create experience
            handleSingleCreateClick();
            return;
        }
        fireCreateWorkItemButtonClickedAnalytics($8055735e114abbc3$var$WorkItemCreationType.MULTIPLE_WORK_ITEM, result === (0, $2ViZo.BulkSelectionResult).Table, result === (0, $2ViZo.BulkSelectionResult).ActionItems);
        (0, $7a3ce11c17355349$export$494c35a67fd7a49e)({
            rightSidebarContext: rightSidebarContextRef?.current,
            actions: actions,
            editorAPI: editorAPIRef.current
        });
    }, [
        initializeCreateState,
        actions,
        contentId,
        lastModified,
        pageModeRef,
        hasEditPermissionRef,
        rightSidebarContextRef,
        setIsCreatedFromTable,
        setIsCreatedFromActionItems,
        setSelectedTableAdf,
        editorAPIRef,
        handleSingleCreateClick,
        fireCreateWorkItemButtonClickedAnalytics
    ]);
    if (!(0, $6mKj3.expVal)('confluence-bulk-work-create-editor', 'isEnabled', false)) return [];
    const getMenuItemsFactory = (keyPrefix)=>()=>{
            const currentSidebar = rightSidebarContextRef?.current?.getCurrent();
            const isDisabled = currentSidebar?.panelId === (0, $1L1jV.ISSUE_CREATE_SIDE_PANEL_ID) || currentSidebar?.panelId === (0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_ID);
            const makeBulkCreateMenuItem = ()=>({
                    key: `${keyPrefix}-bulk-create`,
                    label: formatMessage((0, $304811a46258dbff$export$defe85febe8b728c).bulkCreateWorkItemNameUpdated),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($f1iv3))),
                    onClick: ()=>handleBulkCreateClick(),
                    isDisabled: isDisabled
                });
            const makeSingleCreateMenuItem = ()=>({
                    key: `${keyPrefix}-single-create`,
                    label: formatMessage((0, $304811a46258dbff$export$defe85febe8b728c).singleCreateWorkItemNameUpdated),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
                    onClick: ()=>handleSingleCreateClick(),
                    isDisabled: isDisabled
                });
            return (0, $a8cc1d5c0eec455b$export$ccdc6b8dc23bf978)(editorAPIRef?.current) ? [
                makeBulkCreateMenuItem()
            ] : [
                makeSingleCreateMenuItem()
            ];
        };
    const blockMenuConfiguration = {
        getMenuItems: getMenuItemsFactory('jira-work-create-block-menu')
    };
    const toolbarConfiguration = {
        getMenuItems: getMenuItemsFactory('jira-work-create-toolbar')
    };
    return [
        {
            key: 'jira-work-create',
            source: 'first-party',
            inlineToolbar: toolbarConfiguration,
            blockMenu: blockMenuConfiguration
        }
    ];
};











const $35edf49399d0e0f7$var$hasMeaningfulSelection = (selectionState, editorApi)=>{
    const selection = selectionState?.selection ?? editorApi?.selection?.sharedState?.currentState?.()?.selection;
    return Boolean(selection && !selection.empty);
};
const $35edf49399d0e0f7$export$f3934d75c6e134b7 = ({ contentId: contentId, editorAPIRef: editorAPIRef })=>{
    const [shouldFetchExternalExtensions, setShouldFetchExternalExtensions] = (0, $cozmU.useState)(false);
    const [subscriptionRetryCount, setSubscriptionRetryCount] = (0, $cozmU.useState)(0);
    const previousContentIdRef = (0, $cozmU.useRef)(contentId);
    // Reset the fetch gate when contentId changes (e.g. page transition).
    // This allows the query to run once after first selection on the new page.
    (0, $cozmU.useEffect)(()=>{
        if (previousContentIdRef.current !== contentId) {
            setShouldFetchExternalExtensions(false);
            previousContentIdRef.current = contentId;
        }
    }, [
        contentId
    ]);
    // Wait for editor API, then set the fetch gate to true once: either immediately if there is
    // already a meaningful selection, or on first selection change. Early-return when the gate is
    // already true so repeated selections do not re-fire the external extensions query.
    (0, $cozmU.useEffect)(()=>{
        if (shouldFetchExternalExtensions) return;
        const resolvedEditorApi = editorAPIRef.current;
        if (!resolvedEditorApi) {
            // The editor ref can still be null/undefined while the editor is mounting, so we retry on
            // the next tick to give the ref a chance to be populated and the selection subscription to attach.
            const retryTimer = setTimeout(()=>{
                setSubscriptionRetryCount((currentRetryCount)=>currentRetryCount + 1);
            }, 0);
            return ()=>{
                clearTimeout(retryTimer);
            };
        }
        if ($35edf49399d0e0f7$var$hasMeaningfulSelection(undefined, resolvedEditorApi)) {
            setShouldFetchExternalExtensions(true);
            return;
        }
        // Return the unsubscribe from onChange so React runs it on cleanup (unmount or deps change).
        return resolvedEditorApi.selection?.sharedState?.onChange?.(({ nextSharedState: nextSharedState })=>{
            if ($35edf49399d0e0f7$var$hasMeaningfulSelection(nextSharedState, resolvedEditorApi)) setShouldFetchExternalExtensions(true);
        });
    }, [
        editorAPIRef,
        contentId,
        shouldFetchExternalExtensions,
        subscriptionRetryCount
    ]);
    return shouldFetchExternalExtensions;
};












var $lpGuF = parcelRequire("lpGuF");


var $dMbwP = parcelRequire("dMbwP");




const $e9e6a29a0deabfc6$export$1a972864ed9252e6 = (0, $kSwu1.defineMessages)({
    successTitle: {
        id: "highlight-actions.trello.create.success",
        defaultMessage: "Trello card created"
    },
    errorTitle: {
        id: "highlight-actions.trello.create.error",
        defaultMessage: "Couldn't create Trello card. Try again later."
    },
    openCard: {
        id: "highlight-actions.trello.openCard",
        defaultMessage: "Open card"
    }
});



var $9ujb2 = parcelRequire("9ujb2");

const $32f76a2196ddc2ab$var$messages = (0, $kSwu1.defineMessages)({
    menuItemLabel: {
        id: "editor-features.trello-inbox.create-card",
        defaultMessage: "Send to your Trello Inbox"
    }
});
const $32f76a2196ddc2ab$var$handleCreateTrelloCard = async (contentId, flags, formatMessage)=>{
    if (!flags) return;
    try {
        const selection = window.getSelection();
        if (!selection || selection.rangeCount === 0) return;
        const selectedText = selection.toString().trim();
        if (!selectedText) return;
        const result = await (0, $lpGuF.createTrelloCardHandle)({
            text: selectedText,
            contentId: contentId
        });
        if (result?.cardUrl) {
            const titleNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, formatMessage((0, $e9e6a29a0deabfc6$export$1a972864ed9252e6).successTitle));
            flags.showFlag({
                id: `trello-inbox-create-success-${Date.now()}`,
                title: titleNode,
                appearance: 'success',
                actions: [
                    {
                        content: formatMessage((0, $e9e6a29a0deabfc6$export$1a972864ed9252e6).openCard),
                        href: result.cardUrl,
                        target: '_blank'
                    }
                ]
            });
        } else flags.showFlag({
            id: `trello-inbox-create-error-${Date.now()}`,
            title: formatMessage((0, $e9e6a29a0deabfc6$export$1a972864ed9252e6).errorTitle),
            appearance: 'error'
        });
    } catch  {
        flags.showFlag({
            id: `trello-inbox-create-error-${Date.now()}`,
            title: formatMessage((0, $e9e6a29a0deabfc6$export$1a972864ed9252e6).errorTitle),
            appearance: 'error'
        });
    }
};
const $32f76a2196ddc2ab$export$b4751a4560935df = (contentId, _editorAPIRef, flags)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { hasTrelloAccess: hasTrelloAccess, loading: loading } = (0, $9ujb2.useTrelloAccess)();
    const accessRef = (0, $cozmU.useRef)({
        hasTrelloAccess: hasTrelloAccess,
        loading: loading
    });
    accessRef.current = {
        hasTrelloAccess: hasTrelloAccess,
        loading: loading
    };
    return {
        key: 'trello-inbox',
        source: 'first-party',
        inlineToolbar: {
            getMenuItems: ()=>{
                if (!flags || accessRef.current.loading || !accessRef.current.hasTrelloAccess) return [];
                const label = formatMessage($32f76a2196ddc2ab$var$messages.menuItemLabel);
                return [
                    {
                        label: label,
                        icon: (0, $dMbwP.TrelloInboxIcon),
                        onClick: ()=>$32f76a2196ddc2ab$var$handleCreateTrelloCard(contentId || '', flags, formatMessage)
                    }
                ];
            }
        }
    };
};


const $0826d4545dd61f1d$export$69326c9b91111e89 = ({ isSidePanelOpenRef: isSidePanelOpenRef, rightSidebarContextRef: rightSidebarContextRef, pageModeRef: pageModeRef, hasEditPermissionRef: hasEditPermissionRef, contentId: contentId, editorAPIRef: editorAPIRef, flags: flags, snippetExtensionList: snippetExtensionList = [] })=>{
    const jiraWorkCreateSelectionExtension = (0, $dc24c60db4dc9ba4$export$d32eae3898223fdf)({
        isSidePanelOpenRef: isSidePanelOpenRef,
        rightSidebarContextRef: rightSidebarContextRef,
        pageModeRef: pageModeRef,
        hasEditPermissionRef: hasEditPermissionRef
    });
    const useJiraWorkCreateV2Extension = ()=>(0, $8055735e114abbc3$export$f0c80e15dd78dd09)({
            rightSidebarContextRef: rightSidebarContextRef,
            pageModeRef: pageModeRef,
            hasEditPermissionRef: hasEditPermissionRef,
            editorAPIRef: editorAPIRef
        });
    // V2 only owns the "Create" section when the bulk work-create experiment is enabled.
    const useConditionalJiraWorkCreateV2Extension = (0, $d5Ozc.conditionalHooksFactory)(()=>(0, $6mKj3.expVal)('confluence-bulk-work-create-editor', 'isEnabled', false), useJiraWorkCreateV2Extension, ()=>[]);
    const jiraWorkCreateV2Extension = useConditionalJiraWorkCreateV2Extension();
    // During MAUI phase 3, hide Jira work-create only from the block menu while keeping it
    // available in the contextual toolbar.
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning -- MAUI removal requires both the experiment and phase gate to be enabled.
    const shouldHideJiraWorkCreateBlockMenu = (0, $6mKj3.isExperimentEnabled)('cc-maui-experiment') && (0, $9wGTI.fg)('cc-maui-phase-3');
    const jiraWorkCreateV2ExtensionList = shouldHideJiraWorkCreateBlockMenu ? jiraWorkCreateV2Extension.map((extension)=>({
            ...extension,
            blockMenu: undefined
        })) : jiraWorkCreateV2Extension;
    const shouldFetchExternalExtensions = (0, $35edf49399d0e0f7$export$f3934d75c6e134b7)({
        contentId: contentId,
        editorAPIRef: editorAPIRef
    });
    const externalExtensions = (0, $263e225aef982cc6$export$a3c406cbb96a0e18)(contentId, shouldFetchExternalExtensions);
    const useTrelloExtensionWithArgs = ()=>[
            (0, $32f76a2196ddc2ab$export$b4751a4560935df)(contentId, editorAPIRef, flags)
        ];
    const useConditionalTrelloExtension = (0, $d5Ozc.conditionalHooksFactory)(()=>(0, $9wGTI.fg)('quick_capture_trello_inbox'), useTrelloExtensionWithArgs, ()=>[]);
    const trelloExtensionList = useConditionalTrelloExtension();
    const extensionList = [
        ...snippetExtensionList,
        ...externalExtensions,
        ...jiraWorkCreateV2ExtensionList,
        ...trelloExtensionList
    ];
    // The legacy first-party extension is used only while the bulk work-create experiment is off.
    const extensions = (0, $6mKj3.expVal)('confluence-bulk-work-create-editor', 'isEnabled', false) ? {} : {
        firstParty: [
            jiraWorkCreateSelectionExtension
        ]
    };
    return {
        extensions: extensions,
        extensionList: extensionList
    };
};






var $ai7NK = parcelRequire("ai7NK");




const $9d48445854f70eb8$export$8b02a744327cd19 = (viewMode, isLivePage, hasEditPermission)=>{
    if (isLivePage) {
        if (viewMode === 'edit' && hasEditPermission) return (0, $1mDVg.PageMode).LIVE_EDIT;
        return (0, $1mDVg.PageMode).LIVE_VIEW;
    }
    if (viewMode === 'edit' && hasEditPermission) return (0, $1mDVg.PageMode).EDIT;
    return (0, $1mDVg.PageMode).VIEW;
};



var $jln20 = parcelRequire("jln20");


var $a37Yb = parcelRequire("a37Yb");








var $jO6sX = parcelRequire("jO6sX");








var $aiL0G = parcelRequire("aiL0G");


var $2pBiX = parcelRequire("2pBiX");


var $4R3wx = parcelRequire("4R3wx");


var $hMfsx = parcelRequire("hMfsx");


var $8Q0mA = parcelRequire("8Q0mA");


var $6T0Pj = parcelRequire("6T0Pj");


var $5i3ci = parcelRequire("5i3ci");










const $6c1b58cebd0e5cea$var$ENTRYPOINT_ID = 'loom-confluence-page-editor-toolbar';
const $6c1b58cebd0e5cea$var$SOURCE_COMPONENT = 'loomConfluencePageEditorToolbar';
const $6c1b58cebd0e5cea$var$SOURCE_CONTEXT = 'confluencePageEditorToolbarRecordAVideo';
const $6c1b58cebd0e5cea$var$i18n = (0, $kSwu1.defineMessages)({
    crossSellPopupCardDescription: {
        id: "editor-presets.full-page-editor.crossSellPopupCardDescription",
        defaultMessage: "Save time and engage your team with a video walkthrough of this page."
    },
    crossSellPopupCardTitle: {
        id: "editor-presets.full-page-editor.crossSellPopupCardTitle",
        defaultMessage: "Share your work with video"
    }
});
const $6c1b58cebd0e5cea$var$EditorLoomButtonComponent = ({ buttonComponent: ButtonComponent, flags: flags })=>{
    const isNewToolbarEnabled = (0, $9wGTI.fg)('aifc_create_enabled') || (0, $6mKj3.expVal)('platform_editor_toolbar_aifc_confluence', 'isEnabled', false);
    const intl = (0, $kSwu1.useIntl)();
    const { entryPointVariant: entryPointVariant, error: error, loading: loading } = (0, $4R3wx.useLoomEntryPointVariant)();
    const loomEntryPointErrorCallback = (0, $2pBiX.useLoomEntryPointErrorCallback)({
        flags: flags
    });
    if (entryPointVariant === 'BETA' || isNewToolbarEnabled && entryPointVariant === 'CO_USE') // Fall back to the plugin's default behavior when in a recorder-eligible state
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ButtonComponent, null);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ButtonComponent, {
        onClickBeforeInit: loomEntryPointErrorCallback
    });
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ButtonComponent, {
        isDisabled: true
    });
    if (entryPointVariant === 'CROSS_FLOW') {
        if (isNewToolbarEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMfsx.CrossFlowMenuItem), {
            buttonComponent: ButtonComponent,
            sourceActionSubjectId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).RECORD_VIDEO,
            entryPointId: $6c1b58cebd0e5cea$var$ENTRYPOINT_ID,
            sourceComponent: $6c1b58cebd0e5cea$var$SOURCE_COMPONENT,
            sourceContext: $6c1b58cebd0e5cea$var$SOURCE_CONTEXT
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6T0Pj.LoomCrossFlowPopupCard), {
            description: intl.formatMessage($6c1b58cebd0e5cea$var$i18n.crossSellPopupCardDescription),
            entryPointId: $6c1b58cebd0e5cea$var$ENTRYPOINT_ID,
            spotlightPlacement: "bottom-start",
            sourceActionSubjectId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).RECORD_VIDEO,
            sourceComponent: $6c1b58cebd0e5cea$var$SOURCE_COMPONENT,
            sourceContext: $6c1b58cebd0e5cea$var$SOURCE_CONTEXT,
            title: intl.formatMessage($6c1b58cebd0e5cea$var$i18n.crossSellPopupCardTitle),
            trigger: ({ isSelected: isSelected, onClick: onClick, ...otherTriggerProps })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5i3ci.DiscoverabilityPulse), {
                    entryPointId: $6c1b58cebd0e5cea$var$ENTRYPOINT_ID
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ButtonComponent, {
                    onClickBeforeInit: onClick,
                    selected: isSelected,
                    ...otherTriggerProps
                }));
            }
        });
    }
    if (entryPointVariant === 'CROSS_JOIN') {
        if (isNewToolbarEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMfsx.CrossJoinMenuItem), {
            buttonComponent: ButtonComponent,
            sourceActionSubjectId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).RECORD_VIDEO,
            entryPointId: $6c1b58cebd0e5cea$var$ENTRYPOINT_ID
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Q0mA.LoomCrossJoinPopupCard), {
            description: intl.formatMessage($6c1b58cebd0e5cea$var$i18n.crossSellPopupCardDescription),
            entryPointId: $6c1b58cebd0e5cea$var$ENTRYPOINT_ID,
            placement: "bottom-end",
            // Render in a Portal to isolate from conflicts caused by editor-based CSS + keyboard & focus behavior
            shouldRenderToParent: false,
            sourceActionSubjectId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).RECORD_VIDEO,
            title: intl.formatMessage($6c1b58cebd0e5cea$var$i18n.crossSellPopupCardTitle),
            triggerLink: (href, { onClick: onClick, ...otherTriggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5i3ci.DiscoverabilityPulse), {
                    entryPointId: $6c1b58cebd0e5cea$var$ENTRYPOINT_ID
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ButtonComponent, {
                    ...otherTriggerProps,
                    href: href,
                    onClickBeforeInit: onClick,
                    rel: "noreferrer",
                    target: "_blank"
                })),
            flags: flags
        });
    }
    if (entryPointVariant === 'CO_USE') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ButtonComponent, null);
    return null;
};
const $6c1b58cebd0e5cea$export$6aeb215a2a3b0ff0 = (0, $7aRa9.withFlags)($6c1b58cebd0e5cea$var$EditorLoomButtonComponent);



var $diJQD = parcelRequire("diJQD");


var $3ricL = parcelRequire("3ricL");


var $eYg5X = parcelRequire("eYg5X");


var $sqzF4 = parcelRequire("sqzF4");








var $dXIrr = parcelRequire("dXIrr");


var $3YBks = parcelRequire("3YBks");


var $4EKKB = parcelRequire("4EKKB");


var $2x28u = parcelRequire("2x28u");


var $4vxk6 = parcelRequire("4vxk6");





var $6xiPL = parcelRequire("6xiPL");


var $5wfVt = parcelRequire("5wfVt");


var $iVURp = parcelRequire("iVURp");


var $eF5Eg = parcelRequire("eF5Eg");

const $65c4f66814fbd5c1$var$allowFormatCodeProvider = (providers)=>providers;
function $65c4f66814fbd5c1$export$406fe8471885263f(options) {
    const { intl: intl, appearance: appearance, prevAppearance: prevAppearance } = options;
    const isEditorAIPluginEnabled = Boolean(options.editorPluginAIOptions);
    return (0, $sqzF4.markdownPreset)({
        intl: intl,
        markdownMode: {
            contentId: options.contentId ?? '',
            isMarkdownMode: true,
            // Required for file media to round-trip through GFM as `![alt](url)`
            // instead of being dropped on serialise. Mirrors `createFullPageEditorPresetNext.ts`.
            serializeFileMedia: options.serializeFileMediaForMarkdown,
            onSourceWritebackError: options.onSourceWritebackError,
            viewModePersistence: {
                getInitialView: (0, $2x28u.readStoredMarkdownViewMode),
                onViewChange: (0, $2x28u.writeStoredMarkdownViewMode)
            }
        },
        pluginOptions: {
            annotation: {
                annotationManager: options.annotationProviders?.annotationManager,
                createCommentExperience: (0, $9wGTI.fg)('confluence_fe_create_inline_comment_exp_coverage_2') ? (0, $3YBks.createInlineCommentCompoundExperience) : undefined,
                selectCommentExperience: (0, $4EKKB.selectInlineCommentCompoundExperience),
                viewInlineCommentTraceUFOPress: ()=>(0, $eYg5X.default)('view-inline-comment-action')
            },
            ...options.editorPluginAIOptions ? {
                ai: options.editorPluginAIOptions
            } : {},
            aiDefinitions: options.editorPluginAIDefinitionsConfig,
            aiSuggestions: {
                contentAri: `ari:cloud:confluence:${options.cloudId ?? ''}:page/${options.contentId ?? ''}`
            },
            avatarGroup: {
                collabEdit: options.collabEdit
            },
            base: {
                __livePage: options.__livePage
            },
            blockMenu: {
                getLinkPath: options.getHeadingLinkPath,
                blockLinkHashPrefix: options.blockLinkHashPrefix
            },
            // Inline smart links in markdown mode. The markdown preset adds
            // cardPlugin with `onlyInlineCards: true`, so blockCard/embedCard
            // stay out of the schema even if the underlying CardPluginOptions
            // would otherwise enable them (allowBlockCards defaults to true).
            // Shape mirrors createFullPageEditorPresetNext so the two presets
            // share a single source of truth at the call site.
            card: {
                smartCardContext: (0, $3gyyc.isSSRStreaming)() ? options.smartCardContext : undefined,
                editorAppearance: appearance,
                linkPicker: options.linking?.linkPicker,
                onClickCallback: options.linking?.smartLinks?.onClickCallback,
                __livePage: options.__livePage,
                CompetitorPrompt: $dXIrr.PromptPopupContainer
            },
            codeBidiWarning: {
                editorAppearance: appearance
            },
            collabEdit: {
                collabEdit: options.collabEdit,
                __livePage: options.__livePage
            },
            contentFormat: {
                initialContentMode: options.contentMode ?? 'standard'
            },
            contextPanel: options.contextPanelOptions ? {
                objectSideBar: options.contextPanelOptions.objectSideBar
            } : undefined,
            editorDisabled: {
                disabled: options.disabled
            },
            editorViewMode: {
                viewMode: options.viewMode
            },
            engagementPlatform: {
                coordinationClient: options.editorEngagementPlatformPluginConfig.coordinationClient
            },
            helpDialog: {
                imageUploadProviderExists: false,
                aiEnabled: options.isAIEnabledForContent ?? false
            },
            hyperlink: {
                editorAppearance: appearance,
                linkPicker: options.linking?.linkPicker,
                onClickCallback: options.linking?.smartLinks?.onClickCallback
            },
            insertBlock: {
                editorAppearance: appearance,
                toolbarButtons: {
                    insert: {
                        enabled: true,
                        showAt: 'lg'
                    },
                    media: {
                        enabled: true,
                        showAt: 'lg'
                    },
                    table: {
                        enabled: true,
                        showAt: 'md'
                    },
                    taskList: {
                        enabled: true,
                        showAt: 'lg'
                    }
                }
            },
            limitedMode: options.limitedModePluginOptions || {},
            media: {
                createCommentExperience: (0, $9wGTI.fg)('confluence_fe_create_inline_comment_exp_coverage_2') ? (0, $3YBks.createInlineCommentCompoundExperience) : undefined,
                editorAppearance: appearance,
                mediaViewerExtensions: options.media?.mediaViewerExtensions,
                fallbackMediaNameFetcher: options.media?.fallbackMediaNameFetcher,
                // Captions have no clean GFM representation and the `caption` schema
                // node isn't registered in the markdown preset, so the caption button
                // would throw `Cannot read properties of undefined (reading 'create')`
                // when clicked. Hide the affordance entirely in markdown mode.
                allowCaptions: false,
                // GFM image syntax has no way to express dimensions, so resizing
                // would be silently lost on save. Hide the resize handles entirely.
                allowResizing: false
            },
            metrics: // eslint-disable-next-line confluence-feature-gating/no-preconditioning
            (0, $6mKj3.expValEquals)('platform_editor_controls', 'cohort', 'variant1') ? {
                userPreferencesProvider: options.userPreferencesProvider
            } : undefined,
            placeholder: {
                viewMode: options.viewMode,
                isAIEnabled: options.isAIEnabledForContent ?? false,
                isMarkdownMode: true,
                isLivePage: options.__livePage ?? false,
                isPlaceholderHidden: false,
                enableLoadingSpinner: options.enablePlaceholderLoadingSpinner,
                isRovoLLMEnabled: options.isRovoLLMEnabled
            },
            primaryToolbar: {
                contextualFormattingEnabled: options.contextualFormattingEnabled
            },
            quickInsert: {
                emptyStateHandler: options.elementBrowser?.emptyStateHandler,
                quickInsert: options.quickInsert
            },
            referentiality: {
                referentialityContext: options.referentialityContext
            },
            selection: {
                __livePage: options.__livePage
            },
            selectionExtension: options.selectionExtensionPluginOptions,
            selectionMarker: {
                __livePage: options.__livePage ?? false
            },
            selectionToolbar: {
                contextualFormattingEnabled: options.contextualFormattingEnabled
            },
            showDiff: options.showDiffPluginParams,
            table: {
                editorAppearance: appearance,
                prevEditorAppearance: prevAppearance
            },
            tasksAndDecisions: {
                hasEditPermission: options.hasEditPermission,
                requestToEditContent: options.requestToEditContent,
                hasRequestedEditPermission: options.hasRequestedEditPermission
            },
            toolbar: {
                contextualFormattingEnabled: options.contextualFormattingMode ?? 'controlled'
            },
            userPreferencesPlugin: {}
        },
        providers: $65c4f66814fbd5c1$var$allowFormatCodeProvider({
            autoformattingProvider: options.autoformattingProvider,
            cardProvider: options.linking?.smartLinks?.provider,
            collabEditProvider: options.collabEdit?.provider,
            contextIdentifierProvider: options.contextIdentifierProvider,
            formatCodeProvider: (0, $6xiPL.getCodeBlockFormatProvider)(),
            inlineCommentAnnotationProvider: options.annotationProviders?.inlineComment,
            mediaProvider: options.media?.provider,
            syncMediaProvider: options.media?.syncProvider,
            taskDecisionProvider: options.taskDecisionProvider,
            userPreferencesProvider: options.userPreferencesProvider,
            userPreferencesProviderNext: options.userPreferencesProviderNext
        }),
        enabledOptionalPlugins: {
            aiDefinitions: isEditorAIPluginEnabled && options.editorPluginAIDefinitionsEnabled,
            aiExperience: Boolean(isEditorAIPluginEnabled && options.editorPluginAIOptions?.aiGlobalOptIn.status !== 'disabled'),
            aiImageGeneration: isEditorAIPluginEnabled && (0, $6mKj3.expValEquals)('cc_page_experiences_editor_image_generation', 'isEnabled', true) && (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-ai'),
            aiSpeechToText: isEditorAIPluginEnabled && (0, $6mKj3.expValEquals)('ai_speech_to_text_in_editor', 'isEnabled', true),
            aiStreamingOrchestrator: (0, $9wGTI.fg)('aifc_create_enabled'),
            aiSuggestions: isEditorAIPluginEnabled && options.isRovoLLMEnabled && (0, $6mKj3.expVal)('platform_editor_ai_content_suggested_edits', 'isEnabled', false),
            connectivity: options.isDesktop || (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false),
            contentFormat: true,
            floatingToolbar: !options?.disableFloatingToolbar,
            interaction: Boolean(options?.__livePage) || (0, $6mKj3.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true),
            localId: (0, $9wGTI.fg)('platform_editor_adf_with_localid'),
            metrics: (0, $9wGTI.fg)('platform_editor_ease_of_use_metrics'),
            referentiality: Boolean(options.referentialityContext.plugin),
            selectionExtension: (0, $6mKj3.expValEquals)('platform_editor_controls', 'cohort', 'variant1'),
            showDiff: Boolean(options?.showDiffPluginParams) || (0, $9wGTI.fg)('aifc_create_enabled'),
            toolbar: !options?.disableToolbar && ((0, $9wGTI.fg)('aifc_create_enabled') || isEditorAIPluginEnabled && options.editorPluginAIOptions?.aiGlobalOptIn.status !== 'enabled' && (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_confluence', 'isEnabled', true)),
            userPreferences: (0, $9wGTI.fg)('platform_editor_use_preferences_plugin')
        }
    }).add((0, $eF5Eg.ssrPlugin))// When hiding content titles in URLs, skip the heading anchor links plugin to prevent generating anchor URLs that expose UGC.
    .maybeAdd([
        (0, $4vxk6.EditorHeadingLinksPlugin),
        {
            getHeadingLinkPath: options.getHeadingLinkPath
        }
    ], !options.shouldHideHeadingAnchorLinks).add((0, $iVURp.pageTitleUtilsPlugin)).add((0, $5wfVt.emptyStatePlugin));
}





const $09d2835e14fbd0ba$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    markdownSourceWritebackErrorTitle: {
        id: "editor-presets.fullPage.markdownSourceWritebackErrorTitle",
        defaultMessage: "Changes can\u2019t be saved"
    },
    markdownSourceWritebackErrorDescription: {
        id: "editor-presets.fullPage.markdownSourceWritebackErrorDescription",
        defaultMessage: "Something went wrong while saving your changes. Try reloading the page."
    }
});









var $3nacY = parcelRequire("3nacY");


var $dVKvM = parcelRequire("dVKvM");


var $fayTW = parcelRequire("fayTW");


var $anBbz = parcelRequire("anBbz");


var $cS4kb = parcelRequire("cS4kb");


var $Wsgbu = parcelRequire("Wsgbu");





var $dncjA = parcelRequire("dncjA");




const $99a71e560bd55930$var$ADD_LINK_TO_CONTENT_TREE_KEY = 'confluence-paste-menu-add-link-to-content-tree';
const $99a71e560bd55930$var$getHostnameFromUrl = (url)=>{
    try {
        return new URL(url).hostname || url;
    } catch  {
        return url;
    }
};
const $99a71e560bd55930$var$i18n = (0, $kSwu1.defineMessages)({
    addLinkToContentTree: {
        id: "editor-presets.fullPage.pasteOptionsToolbar.addLinkToContentTree",
        defaultMessage: "Add link to content tree"
    },
    addLinkSuccessTitle: {
        id: "editor-presets.fullPage.pasteOptionsToolbar.addLinkSuccessTitle",
        defaultMessage: "\"{smartlinkName}\" added"
    },
    addLinkSuccessDescription: {
        id: "editor-presets.fullPage.pasteOptionsToolbar.addLinkSuccessDescription",
        defaultMessage: "This smart link is now available in the content tree. Move it or change permissions here."
    },
    goToSmartLink: {
        id: "editor-presets.fullPage.pasteOptionsToolbar.goToSmartLink",
        defaultMessage: "Go to smart link"
    },
    addLinkFailureTitle: {
        id: "editor-presets.fullPage.pasteOptionsToolbar.addLinkFailureTitle",
        defaultMessage: "Smart link could not be added to the content tree"
    },
    addLinkFailureDescription: {
        id: "editor-presets.fullPage.pasteOptionsToolbar.addLinkFailureDescription",
        defaultMessage: "Try again."
    }
});
const $99a71e560bd55930$var$AddLinkToContentTreeItemWithFlags = ({ createAnalyticsEvent: createAnalyticsEvent, flags: flags, parentId: parentId, pageTreeStateUpdater: pageTreeStateUpdater, pasteMenuContext: pasteMenuContext, spaceKey: spaceKey })=>{
    const intl = (0, $kSwu1.useIntl)();
    const publishContentUpdated = (0, $dncjA.useOutboundPageTreeUpdatePublisher)((0, $dncjA.OutboundPageTreeMessage).ContentUpdated);
    const isCreatingSmartLinkEmbedRef = (0, $cozmU.useRef)(false);
    const currentPastedUrl = pasteMenuContext.getCurrentPastedUrl();
    const handleClick = (0, $cozmU.useCallback)(async ()=>{
        if (isCreatingSmartLinkEmbedRef.current || !currentPastedUrl) return;
        const flagId = $99a71e560bd55930$var$ADD_LINK_TO_CONTENT_TREE_KEY;
        isCreatingSmartLinkEmbedRef.current = true;
        try {
            const response = await (0, $Wsgbu.createSmartLinkEmbedContent)({
                createAnalyticsEvent: createAnalyticsEvent,
                embedUrl: currentPastedUrl,
                parentId: parentId,
                spaceKey: spaceKey
            });
            const actions = response.url ? [
                {
                    content: intl.formatMessage($99a71e560bd55930$var$i18n.goToSmartLink),
                    href: response.url,
                    onClick: ()=>{
                        flags.hideFlag(flagId);
                    }
                }
            ] : undefined;
            if (response.contentId) {
                publishContentUpdated({
                    contentId: response.contentId,
                    parentId: parentId
                });
                const forceFetchPageId = parentId || response.contentId;
                pageTreeStateUpdater.setForceFetchPageId(forceFetchPageId);
            }
            flags.showSuccessFlag({
                id: flagId,
                title: intl.formatMessage($99a71e560bd55930$var$i18n.addLinkSuccessTitle, {
                    smartlinkName: $99a71e560bd55930$var$getHostnameFromUrl(currentPastedUrl)
                }),
                description: intl.formatMessage($99a71e560bd55930$var$i18n.addLinkSuccessDescription),
                isAutoDismiss: true,
                actions: actions
            });
        } catch  {
            flags.showErrorFlag({
                id: flagId,
                title: intl.formatMessage($99a71e560bd55930$var$i18n.addLinkFailureTitle),
                description: intl.formatMessage($99a71e560bd55930$var$i18n.addLinkFailureDescription),
                isAutoDismiss: true
            });
        } finally{
            isCreatingSmartLinkEmbedRef.current = false;
        }
    }, [
        createAnalyticsEvent,
        currentPastedUrl,
        flags,
        intl,
        parentId,
        pageTreeStateUpdater,
        publishContentUpdated,
        spaceKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        testId: "confluence-paste-menu__add-link-to-content-tree",
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fayTW))), {
            size: "medium",
            label: ""
        }),
        onClick: handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $99a71e560bd55930$var$i18n.addLinkToContentTree));
};
const $99a71e560bd55930$var$AddLinkToContentTreeItem = (0, $7aRa9.withFlags)((0, $ecUYt.withPageTreeStateUpdater)($99a71e560bd55930$var$AddLinkToContentTreeItemWithFlags));
const $99a71e560bd55930$export$50628eee93102a3b = ({ createAnalyticsEvent: createAnalyticsEvent, parentId: parentId, smartCardClient: smartCardClient, spaceKey: spaceKey })=>({
        pasteMenuButtonsFactory: (rules, pasteMenuContext)=>{
            if (!pasteMenuContext) return [];
            return [
                {
                    type: 'menu-item',
                    key: $99a71e560bd55930$var$ADD_LINK_TO_CONTENT_TREE_KEY,
                    parents: [
                        {
                            type: (0, $3nacY.AI_PASTE_MENU_SECTION).type,
                            key: (0, $3nacY.AI_PASTE_MENU_SECTION).key,
                            // Rank 8 — shown after Ask Rovo (rank 7) at the bottom of the paste actions menu.
                            rank: 8
                        }
                    ],
                    isHidden: ()=>{
                        if (!(0, $anBbz.expValEqualsNoExposure)('confluence_editor_paste_3p_link_actions_menu', 'isEnabled', true)) return true;
                        const url = pasteMenuContext.getCurrentPastedUrl();
                        if (rules.notSingleLinkRule() || !url) return true;
                        // Only show for third-party links; 1P (Atlassian) links already live
                        // elsewhere in the product surface and don't belong in the content tree.
                        return (0, $cS4kb.isFirstPartyLink)(url);
                    },
                    isAsyncHidden: async ({ pastedUrl: pastedUrl })=>{
                        if (!pastedUrl) return false;
                        if (!(0, $anBbz.expValEqualsNoExposure)('confluence_editor_paste_3p_link_actions_menu', 'isEnabled', true) || !smartCardClient) return true;
                        try {
                            const response = await smartCardClient.fetchData(pastedUrl);
                            return response.meta?.access !== 'granted';
                        } catch  {
                            // Network / auth errors should hide the action.
                            return true;
                        }
                    },
                    component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($99a71e560bd55930$var$AddLinkToContentTreeItem, {
                            createAnalyticsEvent: createAnalyticsEvent,
                            parentId: parentId,
                            pasteMenuContext: pasteMenuContext,
                            spaceKey: spaceKey
                        })
                }
            ];
        }
    });


/**
 * @generated SignedSource<<9b043079926cd73b11ac25901b88509f>>
 * @relayHash 5a1d2a8721165ce24041feea77ad6191
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 493421411c87b8da0a902f2fd0fdaf1aa02d7a6c53b445cd55daa0b7d60b52cd
const $536f6d43a856cca5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "parentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "pageId"
                        },
                        {
                            "kind": "Variable",
                            "name": "parentId",
                            "variableName": "parentId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "MovePagePayload",
            "kind": "LinkedField",
            "name": "movePageAppend",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Page",
                    "kind": "LinkedField",
                    "name": "page",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "Map_LinkType_String",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "editui"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useMauiMoveMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useMauiMoveMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5a1d2a8721165ce24041feea77ad6191",
            "id": "493421411c87b8da0a902f2fd0fdaf1aa02d7a6c53b445cd55daa0b7d60b52cd",
            "metadata": {},
            "name": "useMauiMoveMutation",
            "operationKind": "mutation",
            "text": "mutation useMauiMoveMutation($pageId:ID!,$parentId:ID!){movePageAppend(input:{pageId:$pageId,parentId:$parentId}){page{id,links{webui,editui}}}}"
        }
    };
}();
$536f6d43a856cca5$var$node.hash = "842e5a7eb645f50ae941c352d1aa0834";
var $536f6d43a856cca5$export$2e2bcd8739ae039 = $536f6d43a856cca5$var$node;


/**
 * @generated SignedSource<<ba454891f9e432ad56e5d48431496546>>
 * @relayHash b6049b445825365ddab1e4c53fe645b5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e5885f319bdb44acd258139bdd3bf49e62421b9eea5c5941f6ce559adf0e60c1
const $781229575c51b3d0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "pageId"
                        },
                        {
                            "kind": "Variable",
                            "name": "targetSpaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "MovePagePayload",
            "kind": "LinkedField",
            "name": "movePageTopLevel",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Page",
                    "kind": "LinkedField",
                    "name": "page",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "Map_LinkType_String",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "editui"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useMauiMoveTopLevelMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useMauiMoveTopLevelMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "b6049b445825365ddab1e4c53fe645b5",
            "id": "e5885f319bdb44acd258139bdd3bf49e62421b9eea5c5941f6ce559adf0e60c1",
            "metadata": {},
            "name": "useMauiMoveTopLevelMutation",
            "operationKind": "mutation",
            "text": "mutation useMauiMoveTopLevelMutation($pageId:ID!,$spaceKey:String!){movePageTopLevel(input:{pageId:$pageId,targetSpaceKey:$spaceKey}){page{id,links{webui,editui}}}}"
        }
    };
}();
$781229575c51b3d0$var$node.hash = "40a91a5003b294a2f81375f46e2a6f63";
var $781229575c51b3d0$export$2e2bcd8739ae039 = $781229575c51b3d0$var$node;









var $6IQoR = parcelRequire("6IQoR");

function $5a41b21aa32f6f22$export$89a6bfbee9f0e814(targetSpaceKey, cloudId, contentType) {
    const [commitMoveTopLevel] = (0, $308Wd.useMutationInterop)((0, $781229575c51b3d0$export$2e2bcd8739ae039), {
        __callerPackage__: "editor-presets"
    });
    const [commitMoveAppend] = (0, $308Wd.useMutationInterop)((0, $536f6d43a856cca5$export$2e2bcd8739ae039), {
        __callerPackage__: "editor-presets"
    });
    const moveWhiteboardToPage = (0, $cozmU.useCallback)(async (whiteboardContentId, targetParentPageId)=>{
        if (!targetSpaceKey) throw new Error('Target space key is not available.');
        // Step 1: Move whiteboard to the top level of the target space.
        // This avoids the "only space admins can move content to another space"
        // permission error that movePageAppend alone would throw for cross-space moves.
        const topLevelResult = await commitMoveTopLevel({
            variables: {
                pageId: whiteboardContentId,
                spaceKey: targetSpaceKey
            }
        });
        if (!topLevelResult.data?.movePageTopLevel?.page) throw new Error("We couldn't move this diagram to your page. It won't be visible to other users until it's moved out of its temporary space.");
        // Step 2: Reparent whiteboard under the target page (now within the same space).
        const appendResult = await commitMoveAppend({
            variables: {
                pageId: whiteboardContentId,
                parentId: targetParentPageId
            }
        });
        if (!appendResult.data?.movePageAppend?.page) throw new Error("We couldn't move this diagram to your page. It won't be visible to other users until it's moved out of its temporary space.");
    }, [
        commitMoveAppend,
        commitMoveTopLevel,
        targetSpaceKey
    ]);
    // Pass through full `DuplicateMauiAppSuccess` so consumers can forward analytics fields.
    const duplicateMauiApp = (0, $cozmU.useCallback)((appId, containerContentId, overrideContentType)=>{
        return (0, $6IQoR.duplicateMauiApp)(appId, {
            containerContentId: containerContentId,
            cloudId: cloudId,
            contentType: overrideContentType ?? contentType
        });
    }, [
        cloudId,
        contentType
    ]);
    return {
        moveWhiteboardToPage: moveWhiteboardToPage,
        duplicateMauiApp: duplicateMauiApp
    };
}


const $9661ce7f5a08c58b$var$MARKDOWN_SOURCE_WRITEBACK_ERROR_FLAG_ID = 'confluence-markdown-source-writeback-error';
function $9661ce7f5a08c58b$export$6b54c99bfbb93576() {
    if (!(0, $6mKj3.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true)) return undefined;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { mode: rovoMode } = (0, $93Gae.useRovoExperienceAPIStore)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isRovoPanelOpenRef = (0, $cozmU.useRef)(rovoMode !== undefined);
    isRovoPanelOpenRef.current = rovoMode !== undefined;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $cozmU.useCallback)(()=>isRovoPanelOpenRef.current, []);
}
function $9661ce7f5a08c58b$export$2272e89b7d3ccec0(props) {
    const { showObjectSidebar: showObjectSidebar, hideObjectSidebar: hideObjectSidebar, hideObjectSidebarByPanelId: hideObjectSidebarByPanelId } = (0, $aWwYt.useObjectSidebarActions)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { isDesktop: isDesktop } = (0, $2JYae.useIsDesktop)();
    const { userId: userId, cloudId: cloudId, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const [{ deletedMentions: deletedMentions, addedMentions: addedMentions, unrestrictedMentions: unrestrictedMentions, parentSpaceRestrictedMentions: parentSpaceRestrictedMentions, pageRestrictedMentions: pageRestrictedMentions, unrestrictedTasks: unrestrictedTasks, addedTasks: addedTasks, deletedTasks: deletedTasks, pageRestrictedTasks: pageRestrictedTasks, parentSpaceRestrictedTasks: parentSpaceRestrictedTasks }, { setDeletedMentions: setDeletedMentions, setAddedMentions: setAddedMentions, setAddedTasks: setAddedTasks, setDeletedTasks: setDeletedTasks, setMentionsAdded: setMentionsAdded, setTasksAdded: setTasksAdded }] = (0, $hdxAi.useMentionsNotifications)();
    const [mentionChanges, setMentionChanges] = (0, $cozmU.useState)([]);
    const previousEditorProps = (0, $2InGJ.default)(props);
    const isClassicMentionsNotificationsEnrolled = (0, $9747c27e818a1963$export$a9e17b56b1093c49)();
    const isLivePageRef = (0, $cozmU.useRef)(isLivePage);
    isLivePageRef.current = isLivePage;
    const getCurrentIsLivePage = (0, $cozmU.useCallback)(()=>{
        return isLivePageRef.current;
    }, []);
    const { confluenceEditorPreferencesProvider: confluenceEditorPreferencesProvider, editorPreferencesProvider: editorPreferencesProvider } = (0, $jO6sX.useEditorPreferencesProvider)({
        getCurrentIsLivePage: getCurrentIsLivePage
    });
    const isSidePanelOpen = (0, $ai7NK.useIsSidePanelOpen)();
    const isSidePanelOpenRef = (0, $cozmU.useRef)(isSidePanelOpen);
    isSidePanelOpenRef.current = isSidePanelOpen;
    const getIsRovoPanelOpen = $9661ce7f5a08c58b$export$6b54c99bfbb93576();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const rightSidebarContextRef = (0, $cozmU.useRef)(rightSidebarContext);
    rightSidebarContextRef.current = rightSidebarContext;
    const hasEditPermission = props.hasEditPermission || false;
    const hasEditPermissionRef = (0, $cozmU.useRef)(hasEditPermission);
    hasEditPermissionRef.current = hasEditPermission;
    const pageMode = (0, $9d48445854f70eb8$export$8b02a744327cd19)(props.viewMode, props.__livePage, props.hasEditPermission);
    const pageModeRef = (0, $cozmU.useRef)(pageMode);
    pageModeRef.current = pageMode;
    (0, $cozmU.useEffect)(()=>{
        const isMentionNotificationsEnabled = isLivePage || !isLivePage && isClassicMentionsNotificationsEnrolled;
        if (mentionChanges.length && isMentionNotificationsEnabled) {
            (0, $04e4e4b928c4520b$export$9ac42f814ec8d6c6)({
                mentionChanges: mentionChanges,
                deletedMentions: deletedMentions,
                addedMentions: addedMentions,
                setDeletedMentions: setDeletedMentions,
                setAddedMentions: setAddedMentions,
                userId: userId,
                unrestrictedMentions: unrestrictedMentions,
                parentSpaceRestrictedMentions: parentSpaceRestrictedMentions,
                pageRestrictedMentions: pageRestrictedMentions,
                unrestrictedTasks: unrestrictedTasks,
                addedTasks: addedTasks,
                deletedTasks: deletedTasks,
                setAddedTasks: setAddedTasks,
                setDeletedTasks: setDeletedTasks,
                pageRestrictedTasks: pageRestrictedTasks,
                parentSpaceRestrictedTasks: parentSpaceRestrictedTasks,
                setMentionsAdded: setMentionsAdded,
                setTasksAdded: setTasksAdded
            });
            setMentionChanges([]);
        }
    // We only need to trigger the handler function when mentionChanges gets updated
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mentionChanges
    ]);
    const editorAPIRef = (0, $cozmU.useRef)(null);
    const { isPluginEnabled: isLoomPluginEnabled, pluginOptions: loomPluginOptions } = (0, $9Zt9E.useLoomPluginOptions)({
        EditorButtonComponent: (0, $6c1b58cebd0e5cea$export$6aeb215a2a3b0ff0),
        editorAPIRef: editorAPIRef,
        // [ED-27497] IMPORTANT: If you change the code below, please also update the
        // platform/packages/editor/editor-presets-confluence/src/presets/full-page/loomPluginOptions.ts
        ...(0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? {
            editorShouldShowToolbarLoomButton: false
        } : {}
    });
    const { pluginOptions: trackChangesPluginOptions } = (0, $a37Yb.useTrackChangesPlugin)({
        editorAPIRef: editorAPIRef
    });
    // `moveWhiteboardToPage` from `useMauiMove` is intentionally NOT consumed:
    // the backend (monolith `/smart-create/finalize` or convo-ai `/conversation/{id}/action`)
    // handles the cross-space reparent itself, so a frontend GraphQL move is redundant.
    const { duplicateMauiApp: duplicateMauiApp } = (0, $5a41b21aa32f6f22$export$89a6bfbee9f0e814)(props.spaceKey, cloudId, props.contentType);
    const { config: editorEngagementPlatformPluginConfig } = (0, $ijGoX.useEditorEngagementPlatform)();
    const editorPluginAIDefinitionsEnabled = (0, $bDgLc.useEditorPluginAIDefinitionsEnabled)();
    const editorPluginAIDefinitionsConfig = (0, $bDgLc.useEditorPluginAIDefinitionsConfig)();
    const selectionExtensionPluginOptions = (0, $0826d4545dd61f1d$export$69326c9b91111e89)({
        isSidePanelOpenRef: isSidePanelOpenRef,
        rightSidebarContextRef: rightSidebarContextRef,
        pageModeRef: pageModeRef,
        hasEditPermissionRef: hasEditPermissionRef,
        contentId: props.contentId,
        editorAPIRef: editorAPIRef,
        flags: props.flags,
        snippetExtensionList: props.snippetExtensionList
    });
    const limitedModePluginOptions = {
        contentId: props.contentId,
        showFlag: props.flags.showFlag,
        killSwitchEnabled: (0, $1xpoY.default).isKillSwitchOn('cc_editor_perf_mode_kill_switch')
    };
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const showMarkdownSourceWritebackErrorFlag = (0, $cozmU.useCallback)(({ reason: reason, source: source })=>{
        if (source === 'live' && reason === 'parse-error') return;
        props.flags.showErrorFlag({
            id: $9661ce7f5a08c58b$var$MARKDOWN_SOURCE_WRITEBACK_ERROR_FLAG_ID,
            title: intl.formatMessage((0, $09d2835e14fbd0ba$export$a7357cdd1f0b0168).markdownSourceWritebackErrorTitle),
            description: intl.formatMessage((0, $09d2835e14fbd0ba$export$a7357cdd1f0b0168).markdownSourceWritebackErrorDescription),
            isAutoDismiss: false
        });
    }, [
        intl,
        props.flags
    ]);
    const emojiNodeDataProvider = (0, $78d13d0c9995dbf8$export$7274b8e5fdf0c8bf)();
    // EDITOR-6558: resolve markdown-mode state at the preset layer so the
    // preset can configure the markdown plugin and downstream filters
    // (toolbar `+` insert, `/` quick-insert) accordingly. The hook reads
    // from the cache populated by `ContentHeaderUnifiedQuery` and is also
    // gated by the `cc-markdown-mode` experiment, so it returns `false`
    // for non-markdown pages and when the experiment is off.
    const isMarkdownMode = (0, $LSims.useIsMarkdownMode)(isLivePage ? props.contentId : undefined);
    const contextSmartCardClient = (0, $cozmU.useContext)((0, $cMyWi.SmartCardContext))?.connections?.client;
    const smartCardClient = props.smartCardContext?.connections?.client ?? contextSmartCardClient;
    const pasteOptionsToolbarPluginOptions = (0, $cozmU.useMemo)(()=>{
        return (0, $6mKj3.expValEquals)('confluence_editor_paste_3p_link_actions_menu', 'isEnabled', true) ? (0, $99a71e560bd55930$export$50628eee93102a3b)({
            createAnalyticsEvent: createAnalyticsEvent,
            parentId: props.contentId,
            smartCardClient: smartCardClient,
            spaceKey: props.spaceKey
        }) : undefined;
    }, [
        createAnalyticsEvent,
        props.contentId,
        props.spaceKey,
        smartCardClient
    ]);
    // EDITOR-6636 — sync `serializeFileMedia` for the markdown-mode source view.
    // Resolves `media (type: "file")` ids to filenames so we can emit
    // `/wiki/download/attachments/{contentId}/{filename}` proxy URLs that the
    // renderer can serve via the viewer's session cookie. No tokens / signed
    // URLs ever land in the markdown text. Returns `undefined` when contentId
    // isn't ready or markdown mode isn't enabled — in either case file media
    // gracefully degrades to alt-text-only.
    const serializeFileMediaForMarkdown = (0, $b3fc8b60d65ac60d$export$9176907a1a866976)(isMarkdownMode ? props.contentId : undefined);
    const aiSuggestionsPluginOptions = (0, $cozmU.useMemo)(()=>{
        return {
            contentAri: `ari:cloud:confluence:${cloudId}:page/${props.contentId}`,
            onShowSidebar: props.onShowSuggestionsSidebar,
            ConversationAssistant: (0, $aXWtB.ConfluenceConversationAssistant)
        };
    }, [
        cloudId,
        props.contentId,
        props.onShowSuggestionsSidebar
    ]);
    const presetFunction = (0, $cozmU.useCallback)(()=>{
        const { __livePage: __livePage, __rendererExtensionOptions: __rendererExtensionOptions, allowFindReplace: allowFindReplace, annotationProviders: annotationProviders, appearance: appearance, autoformattingProvider: autoformattingProvider, editorPluginAIOptions: editorPluginAIOptions, collabEdit: collabEdit, contextIdentifierProvider: contextIdentifierProvider, elementBrowser: elementBrowser, emojiProvider: emojiProvider, extensionHandlers: extensionHandlers, getExtensionHeight: getExtensionHeight, getHeadingLinkPath: getHeadingLinkPath, shouldHideHeadingAnchorLinks: shouldHideHeadingAnchorLinks, hasRequestedEditPermission: hasRequestedEditPermission, isAIEnabledForContent: isAIEnabledForContent, smartCardContext: smartCardContext, linking: linking, media: media, mention: mention, mentionProvider: mentionProvider, quickInsert: quickInsert, referentialityContext: referentialityContext, requestToEditContent: requestToEditContent, taskDecisionProvider: taskDecisionProvider, viewMode: viewMode, disabled: disabled, blockLinkHashPrefix: blockLinkHashPrefix, showDiffPluginParams: showDiffPluginParams, syncedBlockProvider: syncedBlockProvider, syncedBlockEventHandlers: syncedBlockEventHandlers, disableFloatingToolbar: disableFloatingToolbar, disableToolbar: disableToolbar, contentId: contentId, spaceKey: spaceKey, contentMode: contentMode } = props;
        // IMPORTANT: Don't add spread operator (`...props`) here because it will make impossible to
        //            understand which props are used in the preset.
        const presetOptions = {
            __isRemixHidden: props.__isRemixHidden,
            // @ts-expect-error — property should be __isRovoLLMEnabled in CreateFullPageEditorPresetProps
            __isRovoLLMEnabled: props.__isRovoLLMEnabled,
            __remixDisabledReason: props.__remixDisabledReason,
            __livePage: __livePage,
            __rendererExtensionOptions: __rendererExtensionOptions,
            allowFindReplace: allowFindReplace,
            annotationProviders: annotationProviders,
            appearance: appearance,
            autoformattingProvider: autoformattingProvider,
            collabEdit: collabEdit,
            contextIdentifierProvider: contextIdentifierProvider,
            contextPanelOptions: {
                objectSideBar: {
                    showPanel: showObjectSidebar,
                    closePanel: hideObjectSidebar,
                    closePanelById: hideObjectSidebarByPanelId
                }
            },
            contentId: contentId,
            isMarkdownMode: isMarkdownMode,
            pasteOptionsToolbarPluginOptions: pasteOptionsToolbarPluginOptions,
            spaceKey: spaceKey,
            contentMode: contentMode,
            editorEngagementPlatformPluginConfig: editorEngagementPlatformPluginConfig,
            editorPluginAIDefinitionsConfig: editorPluginAIDefinitionsConfig,
            editorPluginAIDefinitionsEnabled: editorPluginAIDefinitionsEnabled,
            editorPluginAIOptions: editorPluginAIOptions,
            elementBrowser: elementBrowser,
            emojiProvider: emojiProvider,
            emojiNodeDataProvider: emojiNodeDataProvider,
            extensionHandlers: extensionHandlers,
            flags: props.flags,
            getExtensionHeight: getExtensionHeight,
            getHeadingLinkPath: getHeadingLinkPath,
            shouldHideHeadingAnchorLinks: shouldHideHeadingAnchorLinks,
            handleMentionsChanged: (changes)=>{
                if (changes.length) setMentionChanges(changes);
            },
            currentUserId: userId || undefined,
            getIsRovoPanelOpen: getIsRovoPanelOpen,
            hasEditPermission: props.hasEditPermission,
            hasRequestedEditPermission: hasRequestedEditPermission,
            intl: intl,
            isAIEnabledForContent: isAIEnabledForContent,
            isCompanyHub: props.isCompanyHub || false,
            isDesktop: isDesktop,
            isLoomPluginEnabled: isLoomPluginEnabled,
            limitedModePluginOptions: limitedModePluginOptions,
            smartCardContext: (0, $3gyyc.isSSRStreaming)() ? smartCardContext : undefined,
            linking: linking,
            loomPluginOptions: loomPluginOptions,
            media: media,
            mention: mention,
            mentionProvider: mentionProvider,
            prevAppearance: previousEditorProps?.appearance,
            quickInsert: quickInsert,
            referentialityContext: referentialityContext,
            requestToEditContent: requestToEditContent,
            selectionExtensionPluginOptions: selectionExtensionPluginOptions,
            taskDecisionProvider: taskDecisionProvider,
            userPreferencesProvider: confluenceEditorPreferencesProvider,
            userPreferencesProviderNext: editorPreferencesProvider,
            viewMode: viewMode,
            contextualFormattingEnabled: props.contextualFormattingEnabled,
            contextualFormattingMode: props.contextualFormattingMode,
            enableAIPlannerRemoteTextHighlight: props.enableAIPlannerRemoteTextHighlight,
            disabled: disabled,
            blockLinkHashPrefix: blockLinkHashPrefix,
            showDiffPluginParams: showDiffPluginParams,
            syncedBlockProvider: syncedBlockProvider,
            syncedBlockEventHandlers: syncedBlockEventHandlers,
            disableFloatingToolbar: disableFloatingToolbar,
            disableToolbar: disableToolbar,
            trackChangesPluginOptions: trackChangesPluginOptions,
            isEmbeddedConfluence: props.isEmbeddedConfluence ?? false,
            duplicateMauiApp: duplicateMauiApp,
            cloudId: cloudId,
            contentType: props.contentType,
            isRovoLLMEnabled: isRovoLLMEnabled,
            serializeFileMediaForMarkdown: serializeFileMediaForMarkdown,
            onSourceWritebackError: showMarkdownSourceWritebackErrorFlag,
            aiSuggestionsPluginOptions: aiSuggestionsPluginOptions
        };
        // In markdown mode, build a dedicated preset containing only the
        // curated set of plugins that round-trip cleanly through GFM. Both
        // presets accept the same `presetOptions` shape — the markdown
        // variant just consumes the subset of fields that are meaningful in
        // markdown mode.
        if (isMarkdownMode) return (0, $65c4f66814fbd5c1$export$406fe8471885263f)(presetOptions);
        return (0, $diJQD.createFullPageEditorPreset)({
            ...presetOptions,
            enableAgentSectioning: (0, $6mKj3.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true)
        });
    // The dependency array should mirror the dependencies we pass to usePreset.
    // Refactor this to only use one usePreset when cleaning up confluence_frontend_transition_preloading_system FG
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.appearance,
        props.contentId,
        isMarkdownMode,
        isRovoLLMEnabled,
        serializeFileMediaForMarkdown
    ]);
    const { preset: presetStandard, editorApi: editorApiStandard } = (0, $dVPAB.usePreset)(presetFunction, [
        // WARNING: Adding this dependency array causes the editor plugins to all recreate
        // This can be very expensive. Be very careful adding to this, avoid if possible!
        // Generally we can update props via their plugin APIs (see `placeholder` as an example)
        // update preset based on props change, originally from packages/editor/editor-core/src/create-editor/preset-utils.ts
        // persistScrollGutter not used, allowUndoRedoButtons and sanitizePrivateContent always true
        props.appearance,
        isMarkdownMode,
        isRovoLLMEnabled,
        serializeFileMediaForMarkdown
    ]);
    const { preset: presetSmootherTransitionsFG, editorApi: editorApiSmootherTransitionsFG } = (0, $dVPAB.usePreset)(presetFunction, [
        props.appearance,
        props.contentId,
        isMarkdownMode,
        isRovoLLMEnabled,
        serializeFileMediaForMarkdown
    ]);
    const isPresetRerunningOnTransition = (0, $9wGTI.fg)('confluence_frontend_transition_preloading_system') && isLivePage;
    const editorApi = isPresetRerunningOnTransition ? editorApiSmootherTransitionsFG : editorApiStandard;
    const preset = isPresetRerunningOnTransition ? presetSmootherTransitionsFG : presetStandard;
    (0, $cozmU.useEffect)(()=>{
        editorApi?.core?.actions.execute(editorApi?.placeholder?.commands.setPlaceholder(props.placeholder ?? ''));
    }, [
        editorApi,
        props.placeholder
    ]);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_transition_preloading_system')) editorApi?.media?.actions.setProvider(props.media?.provider);
    }, [
        editorApi,
        props.media?.provider
    ]);
    const { setEditorAPI: setEditorAPI } = props;
    (0, $cozmU.useEffect)(()=>{
        if (!setEditorAPI) return;
        editorAPIRef.current = editorApi;
        setEditorAPI(editorApi);
    }, [
        editorApi,
        setEditorAPI
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (props.viewMode === undefined) return;
        editorApi?.core?.actions?.execute(editorApi?.editorViewMode?.commands?.updateViewMode(props.viewMode));
    }, [
        props.viewMode,
        editorApi
    ]);
    (0, $cozmU.useEffect)(()=>{
        editorApi?.core?.actions?.execute(editorApi?.taskDecision?.commands?.updateEditPermission(props.hasEditPermission));
    }, [
        props.hasEditPermission,
        editorApi
    ]);
    (0, $cozmU.useEffect)(()=>{
        editorApi?.core?.actions?.execute(editorApi?.taskDecision?.commands?.updateHasRequestedEditPermission(props.hasRequestedEditPermission || false));
    }, [
        props.hasRequestedEditPermission,
        editorApi
    ]);
    // Register callback to capture limited mode status in INSM events
    (0, $cozmU.useEffect)(()=>{
        if (editorApi && (0, $eFgM7.insm).session) (0, $eFgM7.insm).session.addProperties(()=>({
                limitedModeEnabled: editorApi?.limitedMode?.sharedState.currentState()?.enabled ?? false
            }));
    }, [
        editorApi
    ]);
    const { openLoomRecorder: openLoomRecorder } = (0, $9uAPw.useLoomRecorderEntryPoint)({
        flags: props.flags,
        entryPointLocation: 'editor-toolbar',
        resetInsertFunctionOnUnmount: true
    });
    const loomProviderConfig = (0, $cozmU.useMemo)(()=>({
            openLoomRecorder: openLoomRecorder
        }), [
        openLoomRecorder
    ]);
    (0, $3GtBN.useInitializeLoomPlugin)({
        loomPlugin: editorApi?.loom,
        providerConfig: loomProviderConfig
    });
    return preset;
}


function $639a5b7d5146574b$export$3b07c6dfbdf7e5bd({ ...props }) {
    const fullPagePreset = (0, $9661ce7f5a08c58b$export$2272e89b7d3ccec0)({
        appearance: props.appearance,
        featureFlags: props.featureFlags,
        onSave: props.onSave,
        smartCardContext: (0, $3gyyc.isSSRStreaming)() ? props.smartCardContext : undefined,
        linking: props.linking,
        contextIdentifierProvider: props.contextIdentifierProvider,
        media: props.media,
        placeholder: props.placeholder,
        collabEdit: props.collabEdit,
        primaryToolbarComponents: props.primaryToolbarComponents,
        waitForMediaUpload: props.waitForMediaUpload,
        mention: props.mention,
        allowFindReplace: props.allowFindReplace,
        allowExtension: props.allowExtension,
        extensionHandlers: props.extensionHandlers,
        referentialityContext: props.referentialityContext,
        emojiProvider: props.emojiProvider,
        mentionProvider: props.mentionProvider,
        annotationProviders: props.annotationProviders,
        autoformattingProvider: props.autoformattingProvider,
        taskDecisionProvider: props.taskDecisionProvider,
        editorPluginAIOptions: props.editorPluginAIOptions,
        aiGlobalOptIn: props.aiGlobalOptIn,
        editorPluginAIFeedbackHandlers: props.editorPluginAIFeedbackHandlers,
        elementBrowser: props.elementBrowser,
        setEditorAPI: props.setEditorAPI,
        viewMode: props.viewMode,
        hasEditPermission: props.hasEditPermission,
        requestToEditContent: props.requestToEditContent,
        hasRequestedEditPermission: props.hasRequestedEditPermission,
        getHeadingLinkPath: props.getHeadingLinkPath,
        shouldHideHeadingAnchorLinks: props.shouldHideHeadingAnchorLinks,
        __rendererExtensionOptions: props.__rendererExtensionOptions,
        __isRemixHidden: props.__isRemixHidden,
        __isRovoLLMEnabled: props.__isRovoLLMEnabled,
        __remixDisabledReason: props.__remixDisabledReason,
        __livePage: props.__livePage,
        flags: props.flags,
        quickInsert: props.quickInsert,
        contextPanelOptions: props.contextPanelOptions,
        spaceId: props.spaceId,
        spaceKey: props.spaceKey,
        contentId: props.contentId,
        isAIEnabledForContent: props.isAIEnabledForContent,
        getExtensionHeight: props.getExtensionHeight,
        collabEditProvider: props.collabEditProvider,
        disabled: props.disabled,
        contextualFormattingEnabled: !!props.showEmbeddedModernHeader || !!props.contextualFormattingMode,
        contextualFormattingMode: props.contextualFormattingMode,
        enableAIPlannerRemoteTextHighlight: props.enableAIPlannerRemoteTextHighlight,
        isCompanyHub: props.isCompanyHub,
        syncedBlockProvider: props.syncedBlockProvider,
        contentMode: props.contentMode,
        snippetExtensionList: props.snippetExtensionList,
        syncedBlockEventHandlers: props.syncedBlockEventHandlers,
        isEmbeddedConfluence: props.isEmbeddedConfluence,
        contentType: props.contentType,
        onShowSuggestionsSidebar: props.onShowSuggestionsSidebar
    });
    const editorProps = {
        preset: fullPagePreset,
        defaultValue: props.defaultValue,
        disabled: props.disabled,
        // Providers
        mentionProvider: props.mentionProvider,
        contextIdentifierProvider: props.contextIdentifierProvider,
        searchProvider: props.searchProvider,
        activityProvider: props.activityProvider,
        annotationProviders: props.annotationProviders,
        collabEditProvider: props.collabEditProvider,
        collabEdit: props.collabEdit,
        extensionProviders: props.extensionProviders,
        // Other props
        shouldFocus: props.shouldFocus,
        quickInsert: props.quickInsert,
        secondaryToolbarComponents: props.secondaryToolbarComponents,
        featureFlags: props.featureFlags,
        primaryToolbarComponents: props.primaryToolbarComponents,
        contextPanel: props.contextPanel,
        contentComponents: props.contentComponents,
        primaryToolbarIconBefore: props.primaryToolbarIconBefore,
        sanitizePrivateContent: props.sanitizePrivateContent,
        __livePage: props.__livePage,
        // Callbacks
        // @ts-expect-error - We don't allow `EditorView` to be passed in the new API
        onChange: props.onChange,
        onEditorReady: props.onEditorReady,
        onSSRMeasure: props.onSSRMeasure,
        appearance: props.appearance,
        contentMode: props.contentMode,
        getExtensionHeight: props.getExtensionHeight
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bn20W.FullPageEditor), editorProps);
}






var $cauOq = parcelRequire("cauOq");

var $7WFax = parcelRequire("7WFax");


var $hQDqA = parcelRequire("hQDqA");








var $u7mpJ = parcelRequire("u7mpJ");


var $41KFX = parcelRequire("41KFX");




const $022566d7a48da434$export$4d07d1c131526670 = ({ contentId: contentId, version: version, spaceKey: spaceKey, editorApi: editorApi, isContentCreationPanelOpen: isContentCreationPanelOpen, isShowingOfflineBanner: isShowingOfflineBanner, editorActions: editorActions, onClickOpenContentCreationPanel: onClickOpenContentCreationPanel, handleTitleChange: handleTitleChange, isMarkdownMode: isMarkdownMode, isMarkdownModeSyntaxViewToggled: isMarkdownModeSyntaxViewToggled })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isInCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const { areBannersHidden: areBannersHiddenForLandSimplifyNav } = (0, $u7mpJ.useCreationFocusedNavLand)();
    const { navStyle: navStyle, source: source } = (0, $41KFX.useSimplifiedNavNewUsers)();
    const areBannersHidden = areBannersHiddenForLandSimplifyNav || source === 'xflow' && (0, $41KFX.TREATMENT_COHORTS).has(navStyle);
    /**
   * Editor Help Center conflicts with the OnboardingEditorBanner and should be suppressed when the banner is shown
   * The banner has queries that need to fully resolve before the banner knows if it should render itself
   * To prevent the help center from flashing on the screen, we hide it until the banner queries and logic are complete
   *
   * Since we don't render the OnboardingEditorBanner on live pages, loaded state should always be true for live pages to render the Help Manager.
   */ const [isOnboardingBannerDataLoaded, setIsOnboardingBannerDataLoaded] = (0, $cozmU.useState)(isLivePage);
    const [isHelpMenuOpen, setIsHelpMenuOpen] = (0, $cozmU.useState)(false);
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const openHelpDialog = ()=>{
        editorApi?.helpDialog?.actions.openHelp();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, !areBannersHidden ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WFax.HelpWidget), {
        contentId: contentId,
        openHelpDialog: openHelpDialog,
        isNCSEditor: true,
        isCompanyHub: isCompanyHub,
        isContentCreationPanelOpen: isContentCreationPanelOpen,
        isOpen: isHelpMenuOpen,
        setIsOpen: setIsHelpMenuOpen,
        isMarkdownMode: isMarkdownMode,
        isMarkdownModeSyntaxViewToggled: isMarkdownModeSyntaxViewToggled
    }), isOnboardingBannerDataLoaded && !(0, $6mKj3.expVal)('cc_fd_help_center_no_changeboarding', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cauOq.EditorHelpCenter), {
        contentId: contentId,
        isContentCreationPanelOpen: isContentCreationPanelOpen,
        isCompanyHub: isCompanyHub,
        setIsOpen: setIsHelpMenuOpen
    }), !isLivePage && !isInCompanyHub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hQDqA.OnboardingEditorBanner), {
        contentId: contentId,
        isContentCreationPanelOpen: isContentCreationPanelOpen,
        isShowingOfflineBanner: isShowingOfflineBanner,
        version: version,
        spaceKey: spaceKey,
        editorActions: editorActions,
        setIsOnboardingBannerDataLoaded: setIsOnboardingBannerDataLoaded,
        onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
        handleTitleChange: handleTitleChange
    })) : null);
};



var $9WAeG = parcelRequire("9WAeG");

/**
 * Handler for recording SSR measurements in confluence.
 * This is the SSR implementation that writes to SSRMeasures.
 */ function $1fcefd278c33801b$var$recordSSRMeasureImpl(measure) {
    // Only record on server-side and during SSR
    (0, $9WAeG.SSRMeasures).addMeasureWithData(measure.segmentName, {
        startTime: measure.startTimestamp,
        duration: measure.endTimestamp - measure.startTimestamp
    });
}
/**
 * No-op handler for client builds.
 * This version does nothing and is tree-shakeable.
 */ function $1fcefd278c33801b$var$recordSSRMeasureNoOp() {
// No-op on client
}
const $1fcefd278c33801b$export$5dc6b08aaa4bcf54 = $1fcefd278c33801b$var$recordSSRMeasureNoOp;


const $9b9cd112fc8297b9$export$2319941692274211 = 'editor.content.placeholder.11';
const $9b9cd112fc8297b9$export$f7109619a5e9e0d6 = 'next-FullPageEditorComponent';
const $9b9cd112fc8297b9$export$b7b0d81eceb7980e = 'editor.content.placeholder.easy.mentions';
const $9b9cd112fc8297b9$export$a86989c71e454d74 = 'Type / for all elements or @ to mention someone.';
const $9b9cd112fc8297b9$export$7f03b831e2e40b16 = 'editor.content.placeholder.ai';
const $9b9cd112fc8297b9$export$b24394dc8739ac79 = 'editor.content.placeholder.controls';
const $9b9cd112fc8297b9$export$6a44b93c4f739392 = "Type /ai for Atlassian Intelligence, / to add elements, or @ to mention someone (we\u2019ll let them know).";
const $9b9cd112fc8297b9$export$e57dbc13424cb25a = 'Select + or type / to insert elements';


/* eslint-disable check-file/filename-blocklist */ 


const $48dba10f6de5f65d$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    placeholderBracketHint: {
        id: "full-page-editor.place.holder.bracket.hint",
        defaultMessage: "Any element can be quickly inserted by typing /"
    },
    blogpostPermissionsNotice: {
        id: "full-page-editor.permissions.blogpost-access",
        defaultMessage: "Default access to this blog is now in effect."
    },
    editorEmptyDocumentPlaceholder: {
        id: "full-page-editor.content.placeholder.empty.doc",
        defaultMessage: "Type / to insert elements"
    },
    editorEmptyDocumentPlaceholderAI: {
        id: "full-page-editor.content.placeholder.empty.doc.ai",
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "Use {key}+' to ask AI, or type / to insert elements"
    },
    editorEmptyDocumentSpaceShortcutPlaceholder: {
        id: "full-page-editor.content.placeholder.space-shortcut",
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "Press space to Ask Rovo or / to insert elements"
    },
    editorEmptyDocumentMarkdownPlaceholder: {
        id: "full-page-editor.content.placeholder.markdown-mode",
        defaultMessage: "Type or paste markdown"
    },
    commentLinkNotFoundFlagTitle: {
        id: "full-page-editor.comment-link-not-found.flag.title",
        defaultMessage: "This comment is not available"
    },
    commentLinkNotFoundFlagDescription: {
        id: "full-page-editor.comment-link-not-found.flag.description",
        defaultMessage: "It may be deleted."
    },
    commentRemovedByRovoTitle: {
        id: "full-page-editor.rovo.removed.flag.title",
        defaultMessage: "Comments deleted"
    },
    commentRemovedByRovoDescription: {
        id: "full-page-editor.rovo.removed.flag.description",
        defaultMessage: "One or more comments were deleted in your latest edit with Rovo."
    },
    commentRemovedByRovoViewCommentCTA: {
        id: "full-page-editor.rovo.removed.flag.cta.view-comment",
        defaultMessage: "Go to comment"
    }
});









var $6TaGl = parcelRequire("6TaGl");





var $j0gZR = parcelRequire("j0gZR");




const $8dcb77f48242281e$var$i18n = (0, $kSwu1.defineMessages)({
    fallbackFlagTitle: {
        id: "full-page-editor.unsupported-macro.fallback-flag.title",
        defaultMessage: "This element may require you to publish"
    },
    fallbackFlagDescription: {
        id: "full-page-editor.unsupported-macro.fallback-flag.description",
        defaultMessage: "To fully display and use this element, publish your page via the <menuIcon></menuIcon> menu on the toolbar."
    },
    fallbackFlagLivePageDescription: {
        id: "full-page-editor.unsupported-macro.fallback-flag.live-page.description",
        defaultMessage: "The results of this element aren\u2019t visible when editing a live doc. Convert this doc to a page and publish it via the <menuIcon></menuIcon> menu to display it fully."
    },
    fallbackFlagLearnMoreAction: {
        id: "full-page-editor.unsupported-macro.fallback-flag.action",
        defaultMessage: "Learn more about this EAP"
    }
});
const $8dcb77f48242281e$export$210750141a74fdf7 = (flags, isLivePage)=>{
    const intl = (0, $kSwu1.useIntl)();
    const macroFallbackUiAllowlist = (0, $cozmU.useMemo)(()=>{
        const allowlist = (0, $1xpoY.default).getStringList('confluence_frontend_macro_fallback_ui_allowlist', []);
        return allowlist.map((m)=>m.trim().toLowerCase());
    }, []);
    const showMacroFallbackFlag = (0, $cozmU.useCallback)(async ({ macro: macro, isBodiedExtension: isBodiedExtension })=>{
        if (!macroFallbackUiAllowlist || !macro || !isLivePage || macroFallbackUiAllowlist[0] === 'allow_all') return;
        const macroKey = macro.toLowerCase();
        const is2PNonBodied = !(0, $j0gZR.is1PMacro)(macroKey) && !isBodiedExtension;
        if (is2PNonBodied || isBodiedExtension) return;
        // If macro is in the allowlist don't show the warning
        if (macroFallbackUiAllowlist.includes(macroKey)) return;
        await flags.showFlag({
            type: 'warning',
            close: 'auto',
            title: intl.formatMessage($8dcb77f48242281e$var$i18n.fallbackFlagTitle),
            description: intl.formatMessage(isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? $8dcb77f48242281e$var$i18n.fallbackFlagLivePageDescription : $8dcb77f48242281e$var$i18n.fallbackFlagDescription, {
                menuIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
                        label: "Icon for publish menu"
                    })
            }),
            messageType: 'transactional',
            messageId: 'editor-macro-fallback-flag'
        });
    }, [
        flags,
        macroFallbackUiAllowlist,
        intl,
        isLivePage
    ]);
    return {
        showMacroFallbackFlag: showMacroFallbackFlag
    };
};



var $eLnQS = parcelRequire("eLnQS");


/* TitleAreaContentComponentsWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $7vJCW = parcelRequire("7vJCW");


var $5RPbY = parcelRequire("5RPbY");


var $fY437 = parcelRequire("fY437");


var $9iTNj = parcelRequire("9iTNj");












var $gjEAi = parcelRequire("gjEAi");



var $38qvz = parcelRequire("38qvz");








var $bMPhU = parcelRequire("bMPhU");




const $08a4a4f0ffa330f8$var$styles = {
    bannerSpacing: "_1q51v47k"
};
const $08a4a4f0ffa330f8$export$4907a23e9e92d796 = ({ contentId: contentId, cloudId: cloudId, linkCreation: linkCreation, focusEditor: focusEditor, onFocusChanged: onFocusChanged, debounceOnChange: debounceOnChange, userOffline: userOffline, templateSuggestionsRef: templateSuggestionsRef, templateButtonRef: templateButtonRef, viewMode: viewMode, contentClassificationMetadata: contentClassificationMetadata, version: version, isEditorEmpty: isEditorEmpty, collabEditInitialized: collabEditInitialized, editorApi: editorApi, editorActions: editorActions, editorSessionId: editorSessionId, isSeamlessTransitionInProgress: isSeamlessTransitionInProgress = false, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, hasReactions: hasReactions, customPlaceholderOverride: customPlaceholderOverride })=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const [{ collabEditConnected: collabEditConnected }] = (0, $hYoU4.useNativeCollabConnected)();
    const { collabEditState: collabEditState, contentType: contentType, shouldRenderPreview: shouldRenderPreview, isPublishingContent: isPublishingContent, isUnpublishedDraft: isUnpublishedDraft, spaceKey: spaceKey } = (0, $6b433f129bb94645$export$87f05b83083ffee2)();
    const { contentComponentsTitle: contentComponentsTitle, contentComponentsDisabled: contentComponentsDisabled, isDraftLockedForEditing: isDraftLockedForEditing, handleTitleChange: handleTitleChange, breadcrumbsClickHandler: breadcrumbsClickHandler } = (0, $82bb8752b1a17b39$export$69a815b52f63537)();
    const { isKnowledgeBaseSpace: isKnowledgeBaseSpace } = (0, $38qvz.useSpaceType)({
        spaceKey: spaceKey
    });
    const homepageId = (0, $bMPhU.useSpaceHomepageId)(spaceKey);
    const isSpaceOverview = homepageId === contentId;
    const transitionId = (0, $dPJCf.useTransitionId)();
    const isInitialLoad = !transitionId; // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const ssrOrInitial = isInitialLoad && window.__SSR_RENDERED__; // For Live Pages, title component doesn't send metadata to NCS via client websocket message broadcast, hence is not dependent on collab being connected
    const disableTitleAsNotConnected = contentComponentsDisabled || !isLivePage && !collabEditConnected;
    const isTitleDisabled = !ssrOrInitial && (disableTitleAsNotConnected || linkCreation);
    const [isTitleGenerating, setIsTitleGenerating] = (0, $cozmU.useState)(false);
    const handleTitleGeneratingChange = (0, $cozmU.useCallback)((isGenerating)=>{
        setIsTitleGenerating(isGenerating);
    }, []);
    const EditorAppearanceButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5RPbY.EditorAppearanceButtonNext), {
        contentId: contentId,
        disabled: contentComponentsDisabled || !collabEditConnected,
        isStatusDisconnected: collabEditState.collabEditInternetLost
    });
    const breadcrumbsComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vJCW.EditorBreadcrumbs), {
        key: "breadcrumbs-line",
        contentId: contentId,
        contentType: contentType,
        EditContentAppearanceButton: EditorAppearanceButton,
        breadcrumbsClickHandler: breadcrumbsClickHandler,
        isPublishingContent: isPublishingContent,
        userOffline: userOffline,
        collabEditInitialized: collabEditState.collabEditInitialized,
        moveLocationConfig: {
            spaceKey: spaceKey,
            isUnpublishedDraft: isUnpublishedDraft
        },
        isKnowledgeBaseSpace: isKnowledgeBaseSpace
    });
    const shouldShowEditorByLine = isEmbeddedConfluence ? hasByLineContributors || hasByLineExtensions || hasReactions : true;
    const editorByLineComponent = shouldShowEditorByLine ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fY437.EditorByLineArea), {
        contentId: contentId,
        contentType: contentType,
        isPublishingContent: isPublishingContent,
        userOffline: userOffline,
        isKnowledgeBaseSpace: isKnowledgeBaseSpace,
        viewMode: viewMode,
        editorApi: editorApi,
        isUnpublishedDraft: isUnpublishedDraft,
        isSpaceOverview: isSpaceOverview,
        hasByLineContributors: hasByLineContributors,
        hasByLineExtensions: hasByLineExtensions,
        hasReactions: hasReactions
    }), (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $08a4a4f0ffa330f8$var$styles.bannerSpacing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gjEAi.ApprovalBanner), null)))) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9iTNj.TitleAreaContentComponents), {
        key: "title-area-content-components",
        title: contentComponentsTitle,
        breadcrumbsComponent: breadcrumbsComponent,
        contentId: contentId,
        cloudId: cloudId,
        isDisabled: isTitleDisabled,
        onChange: handleTitleChange,
        focusEditor: focusEditor,
        onFocusChanged: onFocusChanged,
        debounceOnChange: debounceOnChange,
        contentType: contentType,
        userOffline: userOffline,
        isInPreview: shouldRenderPreview,
        isPublishingContent: isPublishingContent,
        isUnpublishedDraft: isUnpublishedDraft,
        templateSuggestionsRef: templateSuggestionsRef,
        templateButtonRef: templateButtonRef,
        contentTopperComponent: editorByLineComponent,
        linkCreation: linkCreation,
        viewMode: viewMode,
        contentClassificationMetadata: contentClassificationMetadata,
        version: version,
        isEditorEmpty: isEditorEmpty,
        collabEditInitialized: collabEditInitialized,
        contentComponentsDisabled: contentComponentsDisabled,
        isDraftLockedForEditing: isDraftLockedForEditing,
        isStatusDisconnected: collabEditState.collabEditInternetLost,
        editorApi: editorApi,
        editorActions: editorActions,
        editorSessionId: editorSessionId,
        isSeamlessTransitionInProgress: isSeamlessTransitionInProgress,
        isTitleGenerating: isTitleGenerating,
        onTitleGeneratingChange: handleTitleGeneratingChange,
        isEmbeddedConfluence: isEmbeddedConfluence,
        customPlaceholderOverride: customPlaceholderOverride,
        isDisabledTextBlack: isDraftLockedForEditing
    });
};




















const $df142c0f7d22fd62$export$f08b3cfa3cbddb9c = ({ contentId: contentId })=>{
    const wasStartedRef = (0, $cozmU.useRef)(false);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    return (0, $cozmU.useCallback)(()=>{
        if (!wasStartedRef.current && isLivePage) {
            experienceTracker.start({
                name: (0, $irVI7.EDIT_PAGE_EXPERIENCE),
                attributes: {
                    contentId: contentId,
                    isLivePage: isLivePage
                }
            });
            wasStartedRef.current = true;
        }
    }, [
        wasStartedRef,
        experienceTracker,
        isLivePage,
        contentId
    ]);
};





function $b3e3043e802ac415$export$befb12a9d0ae7ad9({ editorApi: editorApi, contentId: contentId }) {
    const startLivePageEditExperience = (0, $df142c0f7d22fd62$export$f08b3cfa3cbddb9c)({
        contentId: contentId
    });
    const { hasEditorContentChangedByLocalUserExcludingComments: hasEditorContentChangedByLocalUserExcludingComments } = (0, $16o3K.useHasEditorContentChanged)({
        editorPresetAPI: editorApi
    });
    const { setEditorApi: setEditorApi } = (0, $kDhla.useFullPageEditorApiActions)();
    (0, $cozmU.useEffect)(()=>{
        if (editorApi) // FIXME: https://product-fabric.atlassian.net/browse/ED-25722
        // @ts-expect-error
        setEditorApi(editorApi);
    }, [
        editorApi,
        setEditorApi
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (editorApi && hasEditorContentChangedByLocalUserExcludingComments) startLivePageEditExperience();
    }, [
        editorApi,
        startLivePageEditExperience,
        hasEditorContentChangedByLocalUserExcludingComments
    ]);
}














const $aa4689242ad06a0b$export$dc599391a17e1b5b = ({ disabled: disabled, collabEditInternetLost: collabEditInternetLost, internetDisconnected: internetDisconnected, api: api })=>{
    const { isDesktop: isDesktop } = (0, $2JYae.useIsDesktop)();
    const isOfflineStorageDisabled = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'editorOfflineStorage.disabled', {
        disabled: !(isDesktop || (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false))
    }) ?? false;
    const inactiveSyncing = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'editorOfflineStorage.inactiveSyncing', {
        disabled: !(isDesktop || (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false))
    }) ?? false;
    return (0, $cozmU.useMemo)(()=>{
        if (isDesktop || (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)) {
            if (inactiveSyncing) return true;
            if (isOfflineStorageDisabled) return disabled;
            return disabled && !(collabEditInternetLost || internetDisconnected);
        }
        return disabled;
    }, [
        isDesktop,
        collabEditInternetLost,
        internetDisconnected,
        disabled,
        isOfflineStorageDisabled,
        inactiveSyncing
    ]);
};








const $767f50cadbc92220$export$4da6e3f66c58b328 = (editorFullPagePresetAPI)=>{
    const historyCanUndo = (0, $4Qu9h.useSharedPluginStateSelector)(editorFullPagePresetAPI, 'history.canUndo');
    const historyCanRedo = (0, $4Qu9h.useSharedPluginStateSelector)(editorFullPagePresetAPI, 'history.canRedo');
    const canUndo = editorFullPagePresetAPI?.undoRedoPlugin?.actions.undo && historyCanUndo || false;
    const canRedo = editorFullPagePresetAPI?.undoRedoPlugin?.actions.redo && historyCanRedo || false;
    const undo = (0, $cozmU.useCallback)(()=>{
        if (!editorFullPagePresetAPI?.undoRedoPlugin?.actions) return false;
        return editorFullPagePresetAPI.undoRedoPlugin.actions.undo();
    }, [
        editorFullPagePresetAPI
    ]);
    const redo = (0, $cozmU.useCallback)(()=>{
        if (!editorFullPagePresetAPI?.undoRedoPlugin?.actions) return false;
        return editorFullPagePresetAPI.undoRedoPlugin.actions.redo();
    }, [
        editorFullPagePresetAPI
    ]);
    const activateFindReplace = (0, $cozmU.useCallback)(()=>{
        if (!editorFullPagePresetAPI?.findReplace?.actions) return false;
        return editorFullPagePresetAPI.findReplace.actions.activateFindReplace();
    }, [
        editorFullPagePresetAPI
    ]);
    return {
        canUndo: canUndo,
        canRedo: canRedo,
        undo: undo,
        redo: redo,
        activateFindReplace: activateFindReplace
    };
};






/* EditorControlsBanner.tsx generated by @compiled/babel-plugin v0.36.1 */ 















var $9KSWX = parcelRequire("9KSWX");


var $i1t43 = parcelRequire("i1t43");


var $l8Rhq = parcelRequire("l8Rhq");





var $kA6Zo = parcelRequire("kA6Zo");


var $9iaFM = parcelRequire("9iaFM");


var $6Pqow = parcelRequire("6Pqow");





var $i3jcY = parcelRequire("i3jcY");


var $luv00 = parcelRequire("luv00");


var $j5cB3 = parcelRequire("j5cB3");


var $dcvq8 = parcelRequire("dcvq8");


var $lx6jn = parcelRequire("lx6jn");













const $3faf0024169aae07$var$BannerImageLight = ({ title: title, titleId: titleId, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "auto",
        height: "56px",
        viewBox: "0 0 477 81",
        fill: "none",
        "aria-labelledby": titleId,
        ...props
    }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#b)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#EED7FC",
        d: "M-68.35-87.55c.706 3.65 1.105 7.55 1.162 11.67.057 4.072-.228 7.922-.826 11.544-3.285 19.991-16.117 33.138-34.55 38.086-.142.036-.292.079-.434.114-.613.157-1.226.307-1.853.45-.192.042-.392.092-.584.135-.769.164-1.546.32-2.337.463a68.966 68.966 0 0 1-8.422.949c-.969.05-1.945.085-2.935.1a74.01 74.01 0 0 1-5.059-.115c-.427-.021-.855-.042-1.282-.07a71.101 71.101 0 0 1-5.508-.607 56.036 56.036 0 0 1-2.23-.385 15.078 15.078 0 0 1-.549-.114 66.927 66.927 0 0 1-1.717-.364 11.145 11.145 0 0 1-.47-.114 41.712 41.712 0 0 1-1.91-.492c-.057-.014-.114-.028-.164-.042-12.141-3.366-21.823-10.374-27.88-20.67-4.125 6.98-9.953 12.47-17.114 16.32l.406.15a50.29 50.29 0 0 1-2.323 1.198c-.149-.05-.306-.107-.456-.157l-.52.243c.193.07.335.135.414.178-.008 0-.015.007-.029.014l-.463-.157a53.928 53.928 0 0 1-8.322 2.966c-.142.036-.292.079-.435.114a70.62 70.62 0 0 1-1.852.45c-.193.042-.392.092-.584.135-.77.164-1.547.32-2.337.463a68.969 68.969 0 0 1-8.422.948c-.969.05-1.945.086-2.936.1a73.98 73.98 0 0 1-5.058-.114 76.37 76.37 0 0 1-1.311-.071 70.424 70.424 0 0 1-5.48-.606c-.256-.036-.505-.086-.755-.128l.107.356a62.432 62.432 0 0 1-2.601-.485c-.035-.12-.078-.235-.114-.356a64.599 64.599 0 0 1-1.132-.25 10.069 10.069 0 0 1-.471-.114 41.67 41.67 0 0 1-1.909-.492c-.057-.014-.114-.028-.164-.043-13.096-3.607-23.32-11.457-29.241-23.092v315.949h36.416c-2.009-6.438-3.135-13.739-3.135-21.788 0-5.069.449-9.775 1.275-14.138.285-1.497.613-2.945.983-4.363a61.02 61.02 0 0 1 2.679-8.007 56.391 56.391 0 0 1 1.482-3.23l.129-.249c.064-.121.128-.236.192-.364.335-.649.67-1.305 1.026-1.932a50.705 50.705 0 0 1 12.262-14.452 54.475 54.475 0 0 1 5.052-3.629 59.73 59.73 0 0 1 6.484-3.55 58.52 58.52 0 0 1 2.472-1.112 71.218 71.218 0 0 1 8.564-2.988c.114-.035.235-.057.349-.092l.727-.193c.228-.057.449-.121.677-.178.406-.107.805-.221 1.211-.314 6.961-1.69 14.215-2.495 22.323-2.495 1.161 0 2.308.014 3.455.05.342.007.677.028 1.019.042 1.112.043 2.223.1 3.321.179 6.462.435 12.682 1.433 18.51 3.058.606.171 1.197.357 1.789.542v-.007c.178.057.356.107.534.157h-.014c.092-.029.185-.057.285-.079l.256.086c8.479-2.246 17.82-3.358 27.738-3.358v.064c14.87 0 28.607 2.446 40.12 7.593 6.385 2.816 12.028 6.431 16.816 10.958 10.26 9.796 16.416 23.143 16.416 41.994 0 8.099-1.183 15.35-3.363 21.774H71.579c5.45-6.83 8.208-17.639 8.393-33.075l40.391-.114v.007h.221c.271 15.55 3.007 26.387 8.458 33.175h43.498c5.593-6.816 8.414-17.703 8.607-33.346h.491v-.007l40.392-.114c.278 15.764 3.078 26.693 8.678 33.46h63.904c-6.897-11.893-11.863-24.505-11.863-36.069 0-2.346.086-4.663.25-6.959.498-6.873 2.073-12.997 4.496-18.38.313-.699.641-1.376.983-2.046.1-.2.206-.399.306-.599.185-.349.378-.699.57-1.041 6.562-11.771 17.428-19.485 29.647-23.121a56.626 56.626 0 0 1 3.912-1.006 59.845 59.845 0 0 1 11.151-1.397c.427-.014.862-.036 1.289-.036v-.043c.086 0 .164.022.25.022.085 0 .163-.022.249-.022v.043c.292 0 .584.022.869.029a59.49 59.49 0 0 1 11.792 1.461 54.24 54.24 0 0 1 1.532.364c.199.05.392.107.591.164 1.069.285 2.124.599 3.171.941 6.192 2.046 11.998 5.155 17.022 9.333a46.662 46.662 0 0 1 7.003 7.222c5.722 7.315 9.548 16.683 10.382 28.126.163 2.296.249 4.62.249 6.959 0 2.203-.185 4.442-.52 6.709-.036.242-.079.485-.121.72-.036.235-.079.463-.121.699-.079.449-.164.891-.257 1.34-1.788 8.791-5.8 17.888-10.851 26.601H425v-292.23c-3.142 2.788-6.548 5.234-10.175 7.372-19.173 11.294-44.36 14.01-67.787 14.01h-65.001c-14.592 0-24.646 6.039-24.646 21.646 0 4.534 1.005 11.578 1.504 17.11h-59.359c-.684-5.154-1.603-11.478-2.123-20.418h-39.829c-.627-4.72-1.453-10.424-1.98-18.217a224.095 224.095 0 0 1-.492-11.885 325.16 325.16 0 0 1-.036-4.627c0-2.388.072-4.72.2-7.001 0-.071.007-.136.014-.207.007-.17.022-.342.036-.506.028-.392.05-.784.078-1.17.107-1.44.242-2.851.406-4.241.727-6.267 1.988-12.078 3.791-17.418a69.698 69.698 0 0 1 2.707-6.852c.25-.549.513-1.09.777-1.625a60.153 60.153 0 0 1 2.558-4.67 54.424 54.424 0 0 1 1.902-2.938 57.44 57.44 0 0 1 4.254-5.454c.157-.178.328-.356.484-.534.221-.25.449-.5.677-.742a57.671 57.671 0 0 1 7.759-6.901c9.377-6.945 21.261-11.486 35.554-13.518 4.289-.606 8.785-.991 13.502-1.14 1.575-.05 3.171-.08 4.788-.08h74.442c1.211 0 2.38-.035 3.527-.1l.648-.042c13.039-.87 21.881-6.01 25.771-16.961.043-.122.093-.243.136-.364.164-.478.32-.97.463-1.476.035-.114.064-.235.092-.349.307-1.098.563-2.246.777-3.451H101.425c-4.51 20.719-12.005 37.659-23.056 50.635a292.48 292.48 0 0 1 21.24 2.467l-9.59 63.396C43.434-8.347 21.482 3.46 16.687 35.151l-61.952-9.383c4.018-26.55 12.155-47.74 25.372-63.261a292.481 292.481 0 0 1-21.24-2.467l9.59-63.397c33.51 4.57 54.279-.256 65.073-15.122H-88.826c10.502 6.531 17.79 16.976 20.498 30.936l-.021-.007Zm171.407 305.704c-1.61.264-3.299.406-5.059.414a32.17 32.17 0 0 1-5.265-.414c-9.47-1.554-16.21-7.508-17.97-17.133a29.37 29.37 0 0 1-.456-5.126c0-1.839.143-3.572.435-5.197 1.717-9.647 8.422-15.628 17.862-17.233a32.23 32.23 0 0 1 5.266-.442c1.76 0 3.448.129 5.059.385 9.447 1.512 16.195 7.472 17.962 17.161.299 1.626.456 3.366.456 5.198 0 1.811-.143 3.522-.421 5.133-1.703 9.689-8.421 15.7-17.876 17.261l.007-.007Zm121.524-17.546c-1.703 9.689-8.422 15.699-17.877 17.261-1.61.264-3.299.406-5.059.413-1.831 0-3.591-.135-5.265-.413-9.469-1.554-16.209-7.508-17.969-17.133a29.37 29.37 0 0 1-.456-5.126c0-1.832.142-3.572.434-5.197 1.718-9.647 8.422-15.629 17.863-17.233a32.112 32.112 0 0 1 5.265-.442c1.76 0 3.449.129 5.059.385 9.448 1.512 16.195 7.472 17.962 17.161.299 1.626.456 3.365.456 5.198a30.17 30.17 0 0 1-.42 5.133l.007-.007Zm20.748-40.953c.499.421 0-65.421 0-65.421 31.592 11.001 68.5.563 68.5.563v64.58c-23.278 6.488-68.5.286-68.5.286v-.008ZM362.065 16.371v35.905c18.161-.463 32.183-4.428 32.183-4.428v64.581c-23.277 6.488-68.499.285-68.499.285.228.192.249-13.81.199-28.91-17.257-.493-32.383-2.575-32.383-2.575.499.421 0-65.421 0-65.421 31.592 11.001 68.5.563 68.5.563Zm-401.572 98.154c.498-9.982 2.707-18.416 6.198-25.517 7.646-15.55 21.668-24.533 38.825-28.24 8.172-1.769 17.035-2.36 26.255-1.897 8.244.413 16.174 1.725 23.498 3.964l.022-.078h.014a57.887 57.887 0 0 1 3.534-9.133c.036-.079.078-.15.121-.221a46.87 46.87 0 0 1 1.226-2.296c7.951-14.088 21.439-22.316 37.463-25.795.94-.207 1.888-.392 2.843-.564.926-.163 1.859-.313 2.807-.456 6.27-.92 12.846-1.198 19.565-.855 6.213.313 12.213 1.098 17.898 2.352 1.233.271 2.459.57 3.663.892l.733.192c.086.022.179.043.271.072.114.028.228.056.342.092.755.214 1.504.45 2.252.678.256.078.52.15.776.235 7.667 2.48 14.557 6.01 20.356 10.659a52.094 52.094 0 0 1 3.078 2.673 48.977 48.977 0 0 1 3.67 3.836c.292.342.577.691.862 1.04.192.236.378.478.57.714.556.713 1.09 1.44 1.61 2.181a49.36 49.36 0 0 1 5.665 10.887c2.764 7.415 4.111 16.028 3.612 26.01-.492 9.838-2.672 18.151-6.12 25.174-3.228 6.566-7.61 11.956-12.882 16.284-.563.463-1.14.906-1.725 1.348-.22.164-.434.328-.655.492-.257 13.41 5.65 25.224 5.65 25.224l-37.606 5.412c-2.429-4.906-3.691-12.185-4.346-18.744-3.719.264-7.545.321-11.429.192-.691-.021-1.382-.043-2.073-.071h-.071l-.684-.043c-.185-.007-.364-.021-.549-.035-7.787-.478-15.283-1.754-22.237-3.872-.955 3.28-2.137 6.353-3.541 9.197-7.695 15.621-21.852 24.626-38.86 28.319-7.923 1.718-16.444 2.31-25.215 1.868-4.631-.235-9.142-.72-13.495-1.476-1.304 6.46-3.292 13.575-6.199 18.209l-36.871-9.154s7.053-11.151 8.143-24.519c-5.856-5.219-10.445-11.7-13.373-19.571-2.73-7.336-4.062-15.827-3.57-25.666l-.021.007Zm-79.829 28.19 7.802-6.174c-.506-.192-1.026-.371-1.368-.428.014-.121-.185-.185-.228-.242v.107c-5.272-4.378-14.856-8.741-21.425-13.047-4.268 5.404-9.526 8.89-15.354 10.516.235.199.456.399.677.585-.727.213-1.461.406-2.202.563-.242-.207-.484-.414-.719-.621-5.045.97-10.46.628-16.01-1.019a45.598 45.598 0 0 1-6.926-2.695 46.789 46.789 0 0 1-6.683-3.914c-3.933-2.781-7.118-6.032-9.448-9.668l-.235-.043-.121-.021a29.164 29.164 0 0 1-1.347-2.51c.086.014.171.029.257.05-1.96-3.836-3.021-8.028-3.093-12.491-4.075-.307-7.98-.592-11.528-.82l.449-.228c-.969.107-1.852.121-2.707.1-.072.313-.136.62-.221.934a22.197 22.197 0 0 1-1.411 3.721 22.65 22.65 0 0 1-1.995 3.38c-4.389 6.081-11.001 7.964-18.005 5.889a24.096 24.096 0 0 1-3.605-1.405 24.154 24.154 0 0 1-3.477-2.039c-5.978-4.22-8.621-10.544-6.626-17.738a22.485 22.485 0 0 1 1.396-3.672 22.022 22.022 0 0 1 2.024-3.422c4.389-6.046 10.972-7.914 17.983-5.875 1.24.364 2.501.841 3.755 1.454a24.473 24.473 0 0 1 3.342 1.947c5.03 3.522 7.687 8.57 7.21 14.395 1.845.163 3.171.313 3.171.313l5.4.05s2.722.079 4.938.057a34.23 34.23 0 0 1 1.161-6.438c.642-2.31 1.532-4.663 2.679-7.051a43.12 43.12 0 0 1 3.898-6.58c5.885-8.107 13.822-12.3 22.664-12.77.492-8.17.948-16.398 2.231-22.059.748 2.638.071-6.46.591-6.973l.199.364c.364-.585-.235-2.431.542-2.574.014-.114.014-.306.014-.563l-13.78 1.982-5.122-35.584 35.568-5.126 5.122 35.584-20.206 2.909c-.549 6.901-1.225 13.51-1.468 14.23-.064-.12.121-.706-.292-.734-.085 1.034-.071 2.125-.15 3.223.649-.286.321-1.64.528-1.74.071 4.1-.584 12.42-1.233 17.018 3.043.086 6.177.585 9.355 1.512a47.373 47.373 0 0 1 7.218 2.787 45.491 45.491 0 0 1 6.419 3.744c3.912 2.737 7.076 5.946 9.398 9.546.164-.107.335-.214.499-.32a5.88 5.88 0 0 0-.392.491.854.854 0 0 1 .079.136c1.218-.685 8.949-7.593 9.796-7.743-.035.057-.292.47-.334.542 1.018-.371 2.999-2.802 3.726-2.396.185-.128.506-.392.919-.748-3.049-3.865-4.104-8.691-2.636-13.989a22.577 22.577 0 0 1 1.396-3.672 22.022 22.022 0 0 1 2.024-3.422c4.389-6.046 10.972-7.914 17.983-5.874 1.24.363 2.501.84 3.755 1.454a24.462 24.462 0 0 1 3.342 1.946c5.978 4.185 8.628 10.517 6.612 17.753a22.221 22.221 0 0 1-1.41 3.722 22.698 22.698 0 0 1-1.996 3.38c-4.389 6.08-11 7.963-18.005 5.888a24.072 24.072 0 0 1-3.605-1.404 24.246 24.246 0 0 1-3.477-2.04 20.03 20.03 0 0 1-2.971-2.552 1165.843 1165.843 0 0 1-14.272 10.623 29.08 29.08 0 0 1 1.397 2.902c.114.264.228.528.335.791v.03c2.166 5.738 2.451 12.198.534 19.085-.648 2.339-1.553 4.72-2.714 7.144-.015.029-.036.064-.05.093.149.092.299.178.449.271-.05.107-.093.213-.143.313a46.63 46.63 0 0 1-1.054 2.047c-.157-.093-.321-.186-.478-.286a42.937 42.937 0 0 1-1.966 3.187c3.021 1.512 7.303 4.107 9.497 5.725-.335-.071-1.083-.37-1.859-.834l-.143.214c1.824 1.012 3.249 2.995 5.422 3.151 0 0-2.109-1.561-2.486-2.003l.028-.014-.014-.043c4.261 2.189 9.17 5.183 13.416 7.65l17.97-14.224 22.294 28.198-28.18 22.309-22.294-28.198v.021Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#F8EEFE",
        d: "M197.242 10.71a493.5 493.5 0 0 1-.064-1.547v-.17a227.753 227.753 0 0 1-.1-3.416c0-.121 0-.242-.007-.37l-.022-1.32c0-.2 0-.399-.007-.599 0-.399-.007-.798-.014-1.204V-.333c0-.92.014-1.826.036-2.731a40.67 40.67 0 0 1-4.696 1.362c-2.75.599-5.643 1.005-8.678 1.247l.37-.228h.015c-1.119-.007-2.323.136-1.846.285h-.249c1.347 1.348 2.273 2.282 2.608 2.688-.264-.228-2.316-1.989-2.644-2.267 2.038 2.239 6.391 6.324 10.488 9.91 1.66 1.469 3.278 2.86 4.653 4.043h.321a311.046 311.046 0 0 1-.164-3.202v-.07.006ZM178.96-.348c-7.944-.014-15.689-1.098-23.256-2.445a667.71 667.71 0 0 1-.107-1.448c.535 7.793 1.354 13.497 1.981 18.217h36.658c-.634-.55-1.275-1.098-1.902-1.655A311.884 311.884 0 0 1 178.96-.348Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#EED7FC",
        d: "M181.946.023c.327.278 2.379 2.039 2.643 2.267-.342-.406-1.268-1.333-2.608-2.688h.25c-.478-.15.726-.292 1.845-.285h-.014l-.371.228c3.036-.242 5.921-.649 8.678-1.247a40.672 40.672 0 0 0 4.696-1.362c.021-.877.05-1.74.085-2.602l-.484.192c-.477.185-.976.32-1.454.478-.962.335-1.952.57-2.921.805-3.911.927-7.788 1.29-11.329 1.412-.434.014-.869.029-1.296.036a421.776 421.776 0 0 1-6.726-6.916c-5.601-5.882-12.163-13.425-17.435-21.11-.029.37-.064.74-.093 1.118-.028.386-.05.785-.078 1.17.242.335.47.656.684.94.954 1.327 1.703 2.368 2.315 3.138-.755-.656-1.831-1.932-3.028-3.572 0 .071-.007.135-.014.207 4.489 6.43 9.783 12.783 15.582 19.014a409.898 409.898 0 0 0 5.757 6.01c-1.859-.02-3.583-.092-5.144-.156-5.336-.456-10.638-1.234-15.917-2.182.021.285.035.563.057.841.035.492.071.97.107 1.448 7.567 1.34 15.311 2.424 23.256 2.445a312.468 312.468 0 0 0 13.373 12.67c.627.556 1.269 1.105 1.903 1.654h2.857c-1.375-1.191-2.993-2.574-4.653-4.043-4.104-3.586-8.45-7.671-10.488-9.91h-.035Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#F8EEFE",
        d: "M197.05 3.887c0 .45.015.884.022 1.32l-.022-1.32Zm.028 1.69c.029 1.176.057 2.31.1 3.415-.043-1.098-.071-2.239-.1-3.415Zm-.05-3.494c0 .407.007.806.014 1.205 0-.399-.007-.798-.014-1.205ZM372.866-38.79c-19.173 11.293-44.36 14.009-67.787 14.009h-65.002c-.912 0-1.802.021-2.679.071-13.124.72-21.966 6.945-21.966 21.575 0 4.534 1.005 11.578 1.503 17.11h-19.522a321.858 321.858 0 0 1-.164-3.2c.05 1.104.1 2.167.164 3.2.513 8.934 1.439 15.265 2.123 20.42h59.359c-.499-5.54-1.504-12.584-1.504-17.111 0-15.607 10.061-21.646 24.646-21.646h65.001c23.42 0 48.607-2.716 67.787-14.01A64.662 64.662 0 0 0 425-25.744v-92.749h-20.435v16.634c0 32.86-12.989 52.046-31.692 63.068h-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#EED7FC",
        d: "M383.126-107.549c0 9.411-1.909 16.491-5.557 21.582-3.086 4.306-7.425 7.193-12.904 8.855-.178.056-.37.1-.556.156-.826.236-1.667.45-2.543.635a48.078 48.078 0 0 1-6.876.884c-.605.036-1.225.064-1.852.078-.627.022-1.261.029-1.91.029h-74.599c-1.567 0-3.106.028-4.631.078-1.574.05-3.121.129-4.645.228-.763.05-1.518.107-2.266.172-.399.035-.798.07-1.197.114-.342.035-.691.064-1.04.1-.043 0-.079.007-.121.014l-.357.042-.791.086c-1.04.121-2.073.25-3.092.392a95.256 95.256 0 0 0-6.619 1.162 87.502 87.502 0 0 0-3.256.742 86.423 86.423 0 0 0-7.317 2.146c-4.204 1.44-8.116 3.18-11.728 5.204a63.718 63.718 0 0 0-5.201 3.244 58.442 58.442 0 0 0-2.815 2.082 36.5 36.5 0 0 0-.805.656 60.45 60.45 0 0 0-2.173 1.861c-4.631 4.178-8.522 9.048-11.657 14.609-.106.185-.206.378-.313.57-.093.171-.192.342-.285.513-.257.47-.506.956-.748 1.433-3.064 6.068-5.294 12.884-6.655 20.434a94.997 94.997 0 0 0-.527 3.294 105.5 105.5 0 0 0-.962 10.509c-.036.863-.064 1.725-.086 2.602a117.4 117.4 0 0 0-.035 2.73v2.418c0 .406.007.805.014 1.205 0 .2 0 .399.007.599 0 .449.014.884.022 1.319a242.213 242.213 0 0 0 .106 3.786v.17l.065 1.548v.071c.049 1.105.099 2.167.163 3.201h19.523c-.499-5.54-1.503-12.584-1.503-17.11 0-14.63 8.842-20.855 21.966-21.575.876-.05 1.767-.072 2.679-.072h65.001c23.42 0 48.607-2.716 67.788-14.01 18.703-11.015 31.692-30.2 31.692-63.068v-16.662h-21.432v10.944h.028Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#F8EEFE",
        d: "M78.347-67.858C58.354-44.373 26.719-33.878-19.921-37.5a90.81 90.81 0 0 1 1.895-2.153 93.243 93.243 0 0 0-1.902 2.153C-33.145-21.98-41.282-.79-45.3 25.76l61.952 9.384C21.447 3.459 43.399-8.354 89.982-2.002l9.59-63.396c-7.403-1.12-14.478-1.94-21.24-2.467a220.48 220.48 0 0 0-4.167-.286c1.375.086 2.764.179 4.168.286l.014.007Zm215.217 83.666s.499 65.85 0 65.422c0 0 15.127 2.074 32.384 2.573v-3.437l-.043-9.646v-.02c0-.52 0-1.04-.007-1.554v-5.27c-.057-9.504-.107-16.584-.107-16.584.677.236 1.354.457 2.03.67l.485.15a67.963 67.963 0 0 0 2.202.65 90.53 90.53 0 0 0 1.909.505c.157.043.314.079.47.121.677.172 1.361.329 2.038.485.093.022.178.036.271.057a82.64 82.64 0 0 0 2.28.471c.691.135 1.375.257 2.066.378.1.014.2.035.299.05a94.24 94.24 0 0 0 1.896.3c.106.013.213.035.32.05.698.099 1.397.192 2.102.284.093.014.192.022.285.036.67.078 1.332.157 1.995.22.057 0 .114.015.171.022.713.072 1.432.136 2.138.193.078 0 .163.014.242.021 1.446.114 2.878.2 4.303.264h.164c1.454.057 2.886.093 4.304.1h.064c1.446.007 2.871 0 4.275-.043V16.371s-36.908 10.43-68.5-.563h-.036Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#F8EEFE",
        d: "M348.713 51.934c.078 0 .164.014.242.021-.078 0-.164-.014-.242-.021Zm-22.757 31.869c.05 15.1.029 29.104-.199 28.911 0 0 45.222 6.203 68.5-.285v-64.58s-14.03 3.964-32.184 4.427v28.668c-9.811 2.738-23.527 3.216-36.11 2.852l-.007.007Zm-.199-36.518s.057 7.08.107 16.584c-.057-9.504-.107-16.584-.107-16.584Zm11.264 3.037c.135.029.27.058.413.079a7.366 7.366 0 0 0-.413-.079Zm9.375 1.398c.057 0 .114.014.171.021-.057 0-.114-.014-.171-.021Zm-14.021-2.453c.157.043.313.079.47.121-.157-.035-.313-.078-.47-.12Zm-2.08-.556c.057.014.114.029.178.05-.057-.014-.114-.028-.178-.05Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#EED7FC",
        d: "M357.727 52.319c-1.418-.007-2.85-.043-4.304-.1h-.164c-1.425-.057-2.857-.15-4.303-.264-.079 0-.164-.014-.242-.021-.713-.057-1.425-.121-2.138-.193-.057 0-.114-.014-.171-.021-.663-.071-1.332-.143-1.995-.221-.093-.014-.192-.021-.285-.036a74.149 74.149 0 0 1-2.102-.285c-.107-.014-.214-.035-.32-.05a86.6 86.6 0 0 1-1.896-.3c-.099-.014-.199-.035-.299-.05a99.632 99.632 0 0 1-2.066-.377 6.563 6.563 0 0 0-.413-.078 78.608 78.608 0 0 1-1.867-.393c-.093-.02-.178-.035-.271-.057a70.267 70.267 0 0 1-2.508-.606c-.634-.164-1.275-.328-1.909-.506-.057-.014-.114-.028-.179-.05-.676-.192-1.346-.392-2.023-.599l-.485-.15a68.617 68.617 0 0 1-2.03-.67s.057 7.087.107 16.584v5.269c0 .513 0 1.034.007 1.554v.022l.043 9.646v3.436c12.582.364 26.298-.12 36.109-2.852V52.283c-1.404.036-2.829.05-4.275.043h-.064l.043-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#F8EEFE",
        d: "M66.278 67.07c-2.536-4.534-4.945-9.097-7.317-13.66-.036.078-.079.15-.121.22-1.397 2.824-2.58 5.868-3.534 9.134.463.142.919.285 1.375.427a73.413 73.413 0 0 1 9.604 3.872l-.007.007Zm93.473 9.204c-2.807 4.264-5.978 8.185-9.362 11.757-3.356 3.586-7.09 6.802-11.023 9.461.022-.021.464-.4.962-.82.25-.214.499-.42.677-.592a27.2 27.2 0 0 0 .314-.292 59.792 59.792 0 0 1-4.788 3.365c.171.378.342.763.506 1.141a65.376 65.376 0 0 0 2.565 4.734c3.683 6.082 8.407 11.172 13.594 14.901a43.937 43.937 0 0 0 3.584 2.317c.228-.035.463-.071.691-.1.812-.121 1.589-.235 2.344-.349.499-.071.984-.15 1.447-.214.27-.043.527-.078.783-.114.399-.791.77-1.604 1.162-2.396 1.047-2.074 1.874-4.249 2.786-6.388.427-1.076.805-2.181 1.211-3.265l.598-1.633c.193-.549.357-1.105.535-1.654l1.054-3.315.919-3.351.456-1.675.399-1.69.791-3.373.677-3.393.335-1.697.285-1.704c.192-1.134.378-2.274.57-3.408.157-1.14.314-2.274.47-3.415l.235-1.704.186-1.711c.128-1.14.249-2.275.377-3.408.798-9.098 1.361-18.188.813-27.022 0-.042-.008-.085-.008-.128a48.965 48.965 0 0 0-3.669-3.836 40.232 40.232 0 0 1-.556 5.968c-1.938 10.701-6.284 20.512-11.906 29.025l-.014-.022Zm-58.638-49.066c.342-.663.513-.962.484-.97-.021-.006-.242.279-.591.835-.342.563-.87 1.369-1.46 2.424-1.226 2.096-2.808 5.169-4.425 8.905-1.61 3.743-3.2 8.178-4.568 12.926-2.743 9.51-4.374 20.276-5.272 28.953a439.59 439.59 0 0 1-.171 1.697c3.042 3.872 5.536 8.263 7.374 13.204.4 1.077.77 2.182 1.112 3.308.035.029.071.05.1.079.812.584 1.631 1.183 2.515 1.704.434.263.855.556 1.31.798.45.243.906.478 1.361.72.45.257.92.464 1.397.663l1.418.614 1.468.499.733.249.749.186 1.503.37h.007c0-1.091 0-2.189.043-3.287.335-11.15 2.786-22.322 6.868-32.853 4.083-10.545 9.776-20.448 16.431-29.51a165.508 165.508 0 0 1 5.187-6.651c1.809-2.168 3.74-4.285 5.942-6.16l.128-.107c-5.693-1.262-11.685-2.046-17.898-2.353-6.719-.335-13.295-.064-19.565.855a84.868 84.868 0 0 0-3.798 5.975c.706-1.419 1.276-2.403 1.618-3.066v-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#F8EEFE",
        d: "M176.851 52.989c-.05 5.255-.428 10.901-.884 16.427-.869 11.072-2.75 21.574-3.747 27.834.513-2.26 1.054-4.549 1.475-6.895.484-2.331.84-4.712 1.246-7.115.699-4.813 1.333-9.732 1.71-14.73.392-4.998.727-10.06.77-15.136.028-2.16-.014-4.328-.107-6.488-.185-.242-.378-.478-.57-.713.1 2.167.135 4.449.107 6.823v-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#F8EEFE",
        d: "M178.738 61.324c-.826 16.583-3.37 33.288-8.528 47.832a111.022 111.022 0 0 1-4.96 11.828l2.679-.399a37.628 37.628 0 0 0-.427 1.961c-.036.178-.064.356-.1.527a42.736 42.736 0 0 0-.249 1.612c-.014.121-.036.242-.05.37-.057.485-.1.97-.142 1.455a44.29 44.29 0 0 0 2.422.599c-2.636-.271-2.337-.129-.342.285.05.007.107.021.157.028 5.272-4.327 9.661-9.71 12.882-16.284 3.448-7.022 5.629-15.343 6.12-25.174.499-9.982-.848-18.594-3.612-26.01a49.36 49.36 0 0 0-5.665-10.886c.114 4.085.022 8.185-.185 12.263v-.007Zm-16.75 10.786a37.13 37.13 0 0 0 1.617-3.13c-1.689 2.19-5.472 9.34-1.617 3.13ZM86.99 59.598c.192-.97.491-2.21.883-3.8.499-2.281 1.653-6.032 2.807-9.333 1.155-3.308 2.26-6.188 2.202-6.958-1.097 2.873-2.7 6.987-3.883 10.873-1.204 3.878-2.002 7.507-2.01 9.225v-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#F8EEFE",
        d: "M69.933 69.016c5.038 2.91 9.505 6.46 13.267 10.688l.043-.4c1.104-9.667 2.771-18.936 5.215-27.427 2.409-8.499 5.658-16.177 9.355-22.715a86.122 86.122 0 0 1 2.672-4.406 72.13 72.13 0 0 0-2.843.563c-16.017 3.486-29.511 11.714-37.463 25.795 2.658 5.07 5.337 10.117 8.144 15.093.527.942 1.076 1.868 1.618 2.802l-.008.007Zm61.14 17.233c.755 3.885 1.866 7.785 3.355 11.521.157-.085.307-.178.464-.264-1.219-3.065-2.501-7.436-3.285-11.763-.898-4.55-1.211-8.998-1.817-11.643.15 3.9.506 8.014 1.283 12.156v-.007Zm14.178-58.706.05-.057c.163-.157.313-.306.456-.442a5.425 5.425 0 0 1-.342-.093 12.67 12.67 0 0 0-.35.414l.179.178h.007ZM129.042 66.6c-.064.37-.135.463-.164.826-.035.528.164 1.355.221 1.804 0-.314.078-1.02.107-1.625.028-.6.057-1.098-.157-1.006h-.007Zm2.308-6.246c-.342 1.29-.862 3.187-1.125 5.183-.357 1.99-.414 4.064-.407 5.618l.25.05.192-3.28c.029-.784.157-1.554.221-2.131.071-.578.128-.963.15-.97l-.05-.035c.1-.079.306-.065.299-.528.663-3.33 1.019-4.934 1.09-5.397.064-.464-.256.192-.62 1.476v.014ZM110.367 78.57l.2.228c1.332-4.898 3.177-9.91 5.108-14.387l-.178-.221c-1.995 4.605-3.769 9.39-5.13 14.38Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#F8EEFE",
        d: "M145.885 29.953c-2.472 2.816-4.56 6.039-6.369 9.44-3.577 6.837-6.171 14.33-7.439 22.023-.142.963-.342 1.918-.435 2.888l-.313 2.901c-.114 1.94-.278 3.872-.242 5.804-.05 1.932.107 3.85.199 5.76.221 1.904.378 3.8.741 5.662.271 1.875.763 3.7 1.183 5.518.541 1.79 1.026 3.586 1.71 5.297.207.62.449 1.227.698 1.826.15-.093.307-.186.456-.279 2.302-1.397 4.054-2.723 5.273-3.621.591-.47 1.054-.842 1.368-1.091.313-.25.47-.385.47-.385 1.974-1.676 3.798-3.53 5.572-5.433 1.788-1.89 3.434-3.907 5.03-5.953 1.589-2.054 3.049-4.2 4.453-6.388 1.361-2.21 2.651-4.456 3.805-6.78 0 0 .214-.4.563-1.148.349-.742.876-1.804 1.432-3.145a73.816 73.816 0 0 0 3.641-10.616c1.111-4.178 1.845-8.798 1.532-12.926-.015-.235-.05-.463-.072-.698-5.799-4.656-12.696-8.178-20.356-10.66-.256-.085-.52-.156-.776-.235a36.996 36.996 0 0 0-2.124 2.232v.007Zm-25.656 23.913c-1.832 3.244-3.164 6.132-2.843 6.203l.114-.236c1.503-2.866 2.743-5.104 3.968-7.329 1.247-2.21 2.494-4.413 4.204-7.072l-.178-.193c-1.126 1.804-3.463 5.376-5.273 8.634l.008-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#F8EEFE",
        d: "M137.314 33.418a141.537 141.537 0 0 0-7.353 9.468c-4.695 6.61-8.949 13.825-12.404 21.596-3.456 7.771-6.099 16.106-7.539 24.804a90.711 90.711 0 0 0-1.232 15.457c.135.007.271.014.406.029l1.532.092c.513.007 1.019-.028 1.524-.035.506-.029 1.012 0 1.518-.093 1.005-.136 1.995-.214 2.985-.435 6.384-1.184 12.028-3.479 16.367-5.803-.52-1.227-.962-2.496-1.433-3.758-.313-.827-.527-1.69-.79-2.538-.25-.856-.528-1.697-.706-2.574l-.598-2.602c-.186-.87-.307-1.754-.456-2.624-.335-1.74-.442-3.508-.642-5.24-.213-3.48-.299-6.902-.021-10.16.435-6.523 1.746-12.355 3.199-16.854-.399 1.84-1.596 6.374-2.28 11.592l.242.122c.763-6.025 2.63-12.07 5.002-17.739 2.394-5.675 5.23-11.015 8.408-15.8 0 0-.62.735-1.504 1.926a56.993 56.993 0 0 0-3.092 4.663c-1.076 1.81-2.145 3.736-2.928 5.447-.414.848-.784 1.618-1.105 2.267l-.691 1.569v-.079l-.085.15c1.539-4.021 3.398-8.078 5.835-11.957 1.617-2.595 3.498-5.111 5.686-7.407-.242-.064-.485-.129-.734-.193-2.586 1.818-4.909 4.171-7.104 6.73l-.007-.02ZM62.78 58.436c.74 1.355 2.43 4.164 3.028 4.791-.72-1.647-4.774-8.384-3.028-4.79Zm106.789-9.539c.285-1.255.492-2.802.627-3.594.086-1.554.021-2.139-.043-2.103-.078.036-.149.692-.292 1.611-.235 1.84-.812 4.727-1.019 5.946.136.35.449-.606.727-1.86Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#EED7FC",
        d: "M69.933 69.016a567.385 567.385 0 0 1-1.617-2.802c-2.808-4.976-5.487-10.03-8.144-15.093-.42.749-.834 1.512-1.226 2.296 2.373 4.563 4.788 9.126 7.318 13.66a64.022 64.022 0 0 1 3.662 1.947l.007-.008Zm-4.118-5.796c-.606-.627-2.294-3.436-3.028-4.791-1.746-3.593 2.315 3.137 3.028 4.791Zm109.268 9.047c-.128 1.134-.249 2.275-.377 3.409l-.185 1.71-.236 1.705-.47 3.415c-.192 1.133-.377 2.267-.57 3.408l-.285 1.704-.335 1.697-.677 3.393-.79 3.373-.399 1.69-.456 1.675-.92 3.351-1.054 3.315c-.178.549-.342 1.112-.534 1.654l-.599 1.633c-.406 1.09-.784 2.188-1.211 3.265-.912 2.139-1.739 4.313-2.786 6.388-.392.799-.762 1.604-1.161 2.396.285-.043.555-.086.826-.122.349-.663.72-1.361 1.097-2.117.414-1.005.613-.934.784-1.098.029-.093.021-.135-.021-.078 0 0 .035-.057.085-.15.05-.1.121-.243.214-.421.164-.37.392-.905.663-1.54.527-1.283 1.303-2.959 1.909-4.727 1.347-3.479 2.394-7.136 2.515-7.4l.214.171c-.52 1.775-1.083 3.857-1.91 5.996-.399 1.069-.783 2.189-1.246 3.287-.478 1.09-.955 2.196-1.433 3.294-.456 1.105-1.033 2.153-1.546 3.186-.263.507-.513 1.013-.769 1.512.37-.057.719-.107 1.054-.157.129-.257.257-.513.378-.77l.142.292-.213.428c.156-.021.299-.043.449-.064a109.76 109.76 0 0 0 4.959-11.828c5.158-14.544 7.702-31.25 8.528-47.833.2-4.078.299-8.177.185-12.263a45.124 45.124 0 0 0-1.61-2.181c.093 2.16.136 4.327.107 6.488-.043 5.083-.37 10.145-.769 15.136-.385 4.998-1.012 9.917-1.71 14.73-.399 2.395-.763 4.784-1.247 7.115-.421 2.346-.969 4.634-1.475 6.894.997-6.26 2.878-16.768 3.748-27.834.463-5.525.833-11.172.883-16.426.029-2.375 0-4.663-.107-6.823-.285-.35-.57-.7-.862-1.041 0 .042.007.085.007.128.549 8.834-.014 17.917-.812 27.021l.028.014Zm-6.462 40.311c-.292.813-.442.999-.812 1.804-.299.157.164-.919.62-2.274.484-1.34 1.097-2.902 1.332-3.608-.285 1.02-.72 2.916-1.147 4.078h.007Zm-33.937-80.515c-1.803 2.168-3.505 4.392-5.187 6.652-6.662 9.07-12.347 18.965-16.43 29.51-4.083 10.53-6.534 21.703-6.869 32.853a83.783 83.783 0 0 0-.042 3.287h-.008l-1.503-.371-.748-.185-.734-.25-1.468-.499-1.418-.613a12.374 12.374 0 0 1-1.396-.663l-1.36-.72c-.45-.242-.877-.535-1.312-.798-.876-.514-1.696-1.113-2.515-1.704-.036-.029-.071-.05-.1-.079.357 1.17.67 2.367.955 3.593 1.41.899 2.85 1.704 4.31 2.403 2.373 1.148 4.86 1.882 7.332 2.374.285 9.183 1.988 18.217 5.294 26.594 1.112 2.702 2.508 5.34 4.232 7.735.186.015.364.029.549.036a37.958 37.958 0 0 1-1.382-2.06c-2.622-4.357-4.111-8.941-5.023-12.313l-.599-2.303c-.171-.684-.285-1.283-.399-1.775l-.335-1.533c.428 1.64.841 3.287 1.361 4.926a60.26 60.26 0 0 0 1.66 4.913c1.24 3.251 2.8 6.466 4.881 9.382.192.271.392.535.598.799.691.035 1.383.05 2.074.071-.064-.078-.136-.143-.193-.221-2.835-3.458-4.788-7.614-6.227-11.914a78.003 78.003 0 0 1-3.071-13.239c-.42-2.916-.655-5.839-.762-8.755.399.028.791.057 1.183.078.313.014.627.05.94.043l.933-.029c.62-.028 1.247-.014 1.86-.078 2.494-.25 4.817-.72 7.161-1.312 2.337-.599 4.638-1.383 6.932-2.303a53.42 53.42 0 0 0 6.228-3.001c-.15-.336-.314-.656-.456-.991a19.15 19.15 0 0 1-.506-1.134c-4.339 2.324-9.99 4.62-16.366 5.803-.991.221-1.981.3-2.986.435-.499.086-1.004.064-1.517.093-.506.007-1.019.05-1.525.036l-1.532-.093c-.135-.007-.271-.021-.406-.029a90.711 90.711 0 0 1 1.232-15.457c1.433-8.698 4.083-17.032 7.539-24.804 3.455-7.77 7.709-14.986 12.404-21.595a141.92 141.92 0 0 1 7.353-9.468c2.188-2.56 4.518-4.905 7.104-6.73a94.78 94.78 0 0 0-3.662-.892l-.128.107c-2.209 1.875-4.133 4-5.943 6.16l-.007.029Zm-32.141 72.274c-.37-.114-.577-.214-.705-.314-.257-.207-.235-.371-.677-.72.72.392 3.527 1.304 2.878 1.29l.236.1c-.827-.064-1.354-.249-1.732-.349v-.007Zm4.347 8.683c-.264-1.803-.321-3.222-.378-4.192-.007-.977.021-1.518.078-1.583.114-.128.235 1.64.527 5.576l.022.178-.249.014v.007Zm3.676-34.222-.2-.228c1.361-4.99 3.135-9.775 5.13-14.38l.179.22c-1.931 4.478-3.777 9.49-5.109 14.388Zm10.908-26.301c-1.225 2.224-2.465 4.463-3.968 7.33l-.114.235c-.314-.072 1.012-2.96 2.843-6.203 1.809-3.251 4.146-6.83 5.272-8.634l.178.192c-1.71 2.66-2.957 4.863-4.203 7.073l-.008.007Zm46.206-.257a74.31 74.31 0 0 1-3.641 10.616c-.563 1.34-1.083 2.403-1.432 3.145a21.583 21.583 0 0 1-.563 1.147c-1.154 2.318-2.451 4.57-3.804 6.78-1.404 2.182-2.865 4.328-4.454 6.389-1.596 2.046-3.249 4.057-5.03 5.953-1.774 1.904-3.598 3.757-5.572 5.433 0 0-.156.142-.47.385-.313.25-.776.613-1.368 1.09-1.218.906-2.964 2.225-5.272 3.623-.15.092-.307.185-.456.278.292.706.605 1.397.912 2.089a59.741 59.741 0 0 0 4.788-3.366s-.136.122-.314.293c-.178.17-.434.378-.677.591-.491.421-.94.799-.962.82 3.933-2.659 7.674-5.874 11.023-9.46a84.977 84.977 0 0 0 9.362-11.757c5.622-8.513 9.975-18.316 11.906-29.025a38.45 38.45 0 0 0 .556-5.968 55.617 55.617 0 0 0-3.078-2.673c.021.235.057.463.071.699.313 4.128-.42 8.748-1.532 12.925l.007-.007Zm-5.693 19.87c-3.854 6.21-.064-.94 1.618-3.13a38.878 38.878 0 0 1-1.618 3.13Zm8.173-28.91c.057-.036.128.542.042 2.103-.135.792-.349 2.346-.627 3.594-.277 1.254-.584 2.21-.726 1.86.206-1.226.783-4.106 1.019-5.946.142-.92.213-1.575.292-1.611Zm-81.703 8.677c-2.443 8.491-4.11 17.76-5.215 27.428l-.043.399c.656.741 1.29 1.497 1.903 2.281.057-.556.114-1.12.17-1.697.898-8.676 2.53-19.45 5.273-28.953 1.368-4.748 2.95-9.183 4.567-12.926 1.618-3.736 3.2-6.809 4.425-8.905.591-1.062 1.118-1.868 1.46-2.424.35-.563.57-.841.592-.834.028.007-.143.306-.485.97-.342.662-.912 1.646-1.617 3.065a86.22 86.22 0 0 1 3.798-5.974c-.941.135-1.874.285-2.808.456a86.09 86.09 0 0 0-2.672 4.406c-3.697 6.538-6.946 14.216-9.355 22.715l.007-.007Zm2.224-5.412c-1.155 3.309-2.309 7.052-2.808 9.333-.392 1.59-.69 2.83-.883 3.8.007-1.718.812-5.347 2.009-9.225 1.183-3.886 2.786-7.993 3.883-10.873.057.763-1.054 3.65-2.202 6.958v.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#EED7FC",
        d: "m133.631 46.251.093-.15v.08c.164-.364.399-.906.691-1.57.313-.648.691-1.418 1.104-2.267.784-1.704 1.853-3.636 2.929-5.447a56.7 56.7 0 0 1 3.092-4.662c.883-1.191 1.503-1.925 1.503-1.925-3.177 4.784-6.013 10.124-8.407 15.799-2.373 5.668-4.24 11.714-5.002 17.738l-.242-.12c.684-5.22 1.881-9.754 2.28-11.594-1.454 4.5-2.758 10.331-3.199 16.855-.278 3.258-.193 6.68.021 10.16.2 1.732.306 3.493.641 5.24.157.87.271 1.754.456 2.623l.599 2.603c.178.87.456 1.718.705 2.574.264.848.478 1.71.791 2.538.47 1.262.912 2.53 1.432 3.757.164.378.328.763.506 1.134.15.335.306.663.456.991a42.843 42.843 0 0 0 1.824 3.614 54.512 54.512 0 0 0 2.608 4.221c1.824 2.667 3.79 5.055 5.771 7.087a47.549 47.549 0 0 0 5.828 5.069c-.128-.228-1.389-1.112-2.622-2.21-.634-.535-1.225-1.148-1.731-1.69-.485-.563-.855-1.069-.99-1.426 2.764 2.895 5.928 5.369 9.184 7.387.969-.143 1.916-.286 2.835-.421a40.901 40.901 0 0 1-3.583-2.317c-5.187-3.729-9.911-8.819-13.595-14.901a61.437 61.437 0 0 1-2.565-4.734 55.475 55.475 0 0 0-.506-1.14c-.306-.692-.62-1.384-.912-2.09a27.164 27.164 0 0 1-.698-1.825c-.684-1.711-1.169-3.508-1.71-5.297-.42-1.826-.912-3.644-1.183-5.519-.363-1.86-.527-3.764-.741-5.66-.092-1.911-.249-3.83-.199-5.761-.043-1.933.128-3.865.242-5.804l.313-2.902c.093-.97.293-1.925.435-2.887 1.268-7.693 3.855-15.186 7.439-22.023 1.809-3.401 3.897-6.624 6.369-9.44a36.996 36.996 0 0 1 2.124-2.232 76.062 76.062 0 0 0-2.252-.677c-.142.135-.285.285-.456.442l-.05.057-.178-.178c.121-.15.235-.285.349-.414-.085-.021-.178-.043-.271-.071-2.187 2.296-4.068 4.813-5.685 7.408-2.437 3.885-4.297 7.935-5.836 11.956l-.007.021Zm-4.424 21.36c-.029.6-.107 1.305-.107 1.626-.057-.449-.25-1.283-.221-1.803.028-.364.1-.457.164-.828.221-.092.185.407.156 1.006h.008Zm10.466 41.973c-.399-.349-.791-.92-1.161-1.512-.356-.598-.67-1.219-.955-1.654.164-.092.834.799 1.418 1.647.584.849 1.054 1.669.698 1.519Zm-8.065-23.849c.783 4.328 2.066 8.698 3.284 11.764.064.164.129.335.193.492.242.52.498 1.055.755 1.59 1.247 2.567 2.679 5.205 4.275 7.693.955 1.504 1.988 2.93 3.007 4.271 1.047 1.319 2.08 2.566 3.113 3.643.357.392.756.784 1.176 1.183.413.414.855.827 1.339 1.248-5.279-4.057-10.217-10.402-13.444-17.724-.207-.47-.407-.941-.599-1.419-.1-.235-.192-.478-.285-.713-1.489-3.729-2.601-7.636-3.356-11.522-.776-4.142-1.133-8.256-1.282-12.156.598 2.646.912 7.095 1.817 11.643l.007.007Zm.363-26.857c-.071.463-.42 2.068-1.09 5.397.007.464-.2.442-.299.528l.05.035s-.079.385-.15.97c-.057.577-.192 1.347-.221 2.132-.093 1.561-.185 3.158-.192 3.28l-.25-.05c-.007-1.555.05-3.637.406-5.619.264-1.996.784-3.9 1.126-5.183.364-1.283.684-1.94.62-1.476v-.014Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#F8EEFE",
        d: "M-22.564 159.762c0-.078.014-.156.022-.235a42.24 42.24 0 0 0 .092-1.654c0-.121.014-.235.014-.356.022-.656.022-1.312.008-1.975 0-.122-.008-.25-.015-.371a31.618 31.618 0 0 0-.085-1.633l-.043-.542a31.502 31.502 0 0 0-.228-1.989l7.959 2.025c1.225.314 2.536.642 3.911.991.549.143 1.105.278 1.675.421.57.142 1.14.285 1.71.435 1.154.292 2.322.584 3.491.877 1.168.292 2.337.591 3.491.876.577.143 1.147.286 1.71.428 2.537.635 4.93 1.234 6.983 1.733.228.057.449.114.67.164.876.214 1.674.406 2.38.577.527.129 1.011.243 1.424.342.42.1.777.179 1.069.243.584.128.898.185.883.157v.071c0 .043-.007.1-.014.171v.029c0 .071-.014.164-.021.263 0 .029 0 .05-.007.079-.007.107-.022.221-.036.349 0 .029 0 .057-.007.086-.014.142-.028.299-.05.47v.022c-.021.178-.036.363-.064.57 0 .029 0 .05-.007.071-.022.193-.043.407-.071.621 0 .05-.015.092-.015.142-.028.221-.05.449-.078.685 0 .05-.014.1-.021.149-.029.243-.065.492-.093.756l-.021.178a86.63 86.63 0 0 0-.107.842.35.35 0 0 1-.015.085c-.035.293-.078.592-.12.899 0 .035-.015.078-.015.114-.043.313-.093.627-.135.955-.007.064-.022.128-.029.193l-.15.969c-.014.079-.02.15-.035.228-.05.335-.107.67-.164 1.02-.014.071-.021.142-.036.214-.056.356-.12.72-.185 1.083-.007.05-.021.1-.028.15a59.38 59.38 0 0 1-.2 1.112c0 .036-.014.065-.021.1-.071.385-.143.777-.221 1.177-.014.064-.021.128-.036.192l-.17.856c4.353.755 8.87 1.24 13.494 1.475 8.77.443 17.293-.149 25.215-1.867 17.008-3.686 31.165-12.691 38.86-28.319 1.404-2.845 2.58-5.911 3.541-9.198.328-1.133.627-2.302.905-3.493a63.012 63.012 0 0 1-.912 3.508 51.202 51.202 0 0 1-1.425-.449 70.453 70.453 0 0 1-8.927-3.558c-.47-.228-.94-.464-1.411-.699a58.693 58.693 0 0 1-9.141-5.746 78.108 78.108 0 0 1-1.198-.949 50.902 50.902 0 0 1-5.507-5.211 44.277 44.277 0 0 1-1.974-2.317 49.002 49.002 0 0 1-4.318-6.367 47.006 47.006 0 0 1-1.46-2.781 51.454 51.454 0 0 1-.67-1.44 55.956 55.956 0 0 1-1.225-2.987 56.355 56.355 0 0 1-1.789-5.718 60.546 60.546 0 0 1-1.439-7.786 70.579 70.579 0 0 1-.463-6.759c-.036-1.754 0-3.55.085-5.39.3-5.982 1.219-11.4 2.658-16.312-7.332-2.239-15.255-3.55-23.498-3.964-9.22-.464-18.084.128-26.256 1.896-17.157 3.708-31.179 12.698-38.824 28.24-3.491 7.102-5.7 15.529-6.199 25.518-.491 9.838.84 18.33 3.57 25.666 2.928 7.871 7.517 14.352 13.373 19.571l-.014.021Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#EED7FC",
        d: "M52.612 79.148a76.4 76.4 0 0 0-.086 5.39c.043 2.331.2 4.584.463 6.758a59.35 59.35 0 0 0 1.44 7.786 55.746 55.746 0 0 0 1.788 5.718 48.21 48.21 0 0 0 1.225 2.987 48.458 48.458 0 0 0 2.13 4.221 48.245 48.245 0 0 0 4.318 6.367 51.701 51.701 0 0 0 1.974 2.317 51.018 51.018 0 0 0 6.705 6.16c2.821 2.174 5.878 4.085 9.141 5.746.463.236.933.471 1.41.699 2.844 1.369 5.83 2.545 8.928 3.558.47.157.948.299 1.425.449.335-1.141.635-2.31.912-3.508.05-.214.1-.435.143-.656.192-.884.37-1.782.534-2.695.072-.392.136-.784.2-1.183a64.732 64.732 0 0 0 .513-3.929c.035-.342.064-.698.092-1.041.079-.912.15-1.832.2-2.773 0-.093.014-.185.021-.278v-.064c.357-7.03-.213-13.383-1.546-19.115a60.208 60.208 0 0 0-.955-3.593 52.976 52.976 0 0 0-1.111-3.308 48.869 48.869 0 0 0-9.277-15.486c-3.762-4.228-8.23-7.778-13.267-10.687a61.548 61.548 0 0 0-3.662-1.947 70.724 70.724 0 0 0-9.604-3.87c-.456-.15-.912-.293-1.375-.429h-.015l-.021.079c-1.44 4.912-2.358 10.33-2.658 16.312l.015.015Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#c)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#fff",
        d: "M58.287-54H477.02v400.9H58.287z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        fill: "#F0F1F2",
        clipPath: "url(#d)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M101 31h342v8H101zM91 51h352v8H91zm0 21h161v8H91z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        filter: "url(#e)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#f)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: 313.252,
        height: 18.265,
        x: 40,
        y: 23.171,
        fill: "#fff",
        rx: 2.74
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        fill: "#505258",
        fillRule: "evenodd",
        clipPath: "url(#g)",
        clipRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M49.537 28.762a.792.792 0 0 0-.809.001.824.824 0 0 0-.403.715v1.095l1.337.79c.329.194.53.552.53.94v2.825a1.1 1.1 0 0 1-.062.366l1.795-1.062a.83.83 0 0 0 .404-.717v-2.824a.833.833 0 0 0-.404-.717l-2.388-1.412Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M49.94 35.13a.824.824 0 0 1-.404.715h.001a.792.792 0 0 1-.809.002l-2.387-1.413a.833.833 0 0 1-.405-.717v-2.825a.83.83 0 0 1 .404-.716l1.795-1.062c-.04.116-.062.24-.062.366v2.825c0 .388.201.745.53.939l1.337.791v1.094Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M49.537 28.762a.792.792 0 0 0-.809.001.824.824 0 0 0-.403.715v1.095l1.337.79c.329.194.53.552.53.94v2.825a1.1 1.1 0 0 1-.062.366l1.795-1.062a.83.83 0 0 0 .404-.717v-2.824a.833.833 0 0 0-.404-.717l-2.388-1.412Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M49.94 35.13a.824.824 0 0 1-.404.715h.001a.792.792 0 0 1-.809.002l-2.387-1.413a.833.833 0 0 1-.405-.717v-2.825a.83.83 0 0 1 .404-.716l1.795-1.062c-.04.116-.062.24-.062.366v2.825c0 .388.201.745.53.939l1.337.791v1.094Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#B3B9C4",
        d: "M55.525 29.792h21.919v5.023H55.525z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.14,
        d: "M82.924 27.738h.457v9.133h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#44546F",
        d: "M89.545 31.961h2.969v-2.853h.684V35.5h-.684v-2.853h-2.97V35.5h-.684v-6.392h.685v2.853Zm5.465.721c.213 0 .399.031.555.093a.822.822 0 0 1 .363.259c.085.11.128.239.128.388v.004a.559.559 0 0 1-.278.496.809.809 0 0 1-.27.108v.014a.837.837 0 0 1 .481.189.53.53 0 0 1 .177.417v.003a.741.741 0 0 1-.14.452.882.882 0 0 1-.396.294 1.672 1.672 0 0 1-.614.101 1.44 1.44 0 0 1-.577-.107.935.935 0 0 1-.391-.303.877.877 0 0 1-.165-.463l-.002-.024h.748l.003.022a.27.27 0 0 0 .06.135c.032.04.075.073.13.097a.483.483 0 0 0 .192.035.45.45 0 0 0 .19-.037.3.3 0 0 0 .122-.104.278.278 0 0 0 .043-.152v-.003a.233.233 0 0 0-.107-.208.56.56 0 0 0-.312-.072h-.275V33.8h.275c.082 0 .151-.01.208-.031a.289.289 0 0 0 .13-.09.231.231 0 0 0 .046-.144v-.003a.25.25 0 0 0-.152-.242.389.389 0 0 0-.172-.036c-.07 0-.13.013-.182.037a.286.286 0 0 0-.12.102.325.325 0 0 0-.054.151l-.002.017h-.707l.002-.027a.858.858 0 0 1 .153-.452.879.879 0 0 1 .366-.294 1.31 1.31 0 0 1 .544-.106Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#44546F",
        fillRule: "evenodd",
        d: "m99.834 31.377 1.812 1.813 1.813-1.813.484.484-2.055 2.055a.342.342 0 0 1-.484 0l-2.055-2.055.484-.484Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.14,
        d: "M109.865 27.738h.457v9.133h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        stroke: "#44546F",
        strokeLinejoin: "round",
        strokeWidth: 1.027,
        d: "M119.797 32.304c.788 0 1.427-.553 1.427-1.341 0-.789-.639-1.342-1.427-1.342h-2.112v2.683m2.112 0h.457c.788 0 1.427.553 1.427 1.341 0 .788-.639 1.342-1.427 1.342h-2.569v-2.683m2.112 0h-2.112"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#44546F",
        fillRule: "evenodd",
        d: "M133.154 29.108h2.968v.684h-1.1l-1.205 5.023h1.163v.685h-2.968v-.684h1.1l1.206-5.024h-1.164v-.684Zm8.233 2.269 1.813 1.813 1.813-1.813.484.484-2.055 2.055a.342.342 0 0 1-.484 0l-2.055-2.055.484-.484Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.14,
        d: "M151.419 27.738h.457v9.133h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        stroke: "#44546F",
        strokeLinejoin: "round",
        strokeWidth: 0.685,
        d: "M159.067 33.674v-.171l.586-1.541m3.296 1.712v-.171l-.583-1.541m0 0-1.121-2.969h-.465l-1.127 2.969m2.713 0h-2.713"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        stroke: "#44546F",
        strokeWidth: 1.37,
        d: "M164.662 35.272h-7.307"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#44546F",
        fillRule: "evenodd",
        d: "m168.329 31.377 1.812 1.813 1.813-1.813.484.484-2.055 2.055a.342.342 0 0 1-.484 0l-2.055-2.055.485-.484Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        stroke: "#44546F",
        strokeLinejoin: "round",
        strokeWidth: 0.685,
        d: "m183.269 31.048-.57 1.598.285.286m.285-1.884 2.829-1.975a.286.286 0 0 1 .366.032l.575.575a.285.285 0 0 1 .032.366l-1.975 2.829m-1.827-1.827 1.827 1.827m0 0-1.598.57-.286-.285m-.228-.228-.514.514.229.228.513-.514m-.228-.228.228.228"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        stroke: "#172B4D",
        strokeWidth: 1.37,
        d: "M188.407 35.272h-7.306"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#44546F",
        fillRule: "evenodd",
        d: "m192.074 31.377 1.812 1.813 1.813-1.813.484.484-2.054 2.055a.343.343 0 0 1-.485 0l-2.055-2.055.485-.484Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.14,
        d: "M202.105 27.738h.457v9.133h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#44546F",
        fillRule: "evenodd",
        d: "M214.891 30.25h-6.392v-.686h6.392v.685Zm0 2.397h-6.392v-.685h6.392v.685Zm-3.196 2.397h-3.196v-.685h3.196v.685Zm7.32-3.667 1.813 1.813 1.812-1.813.485.484-2.055 2.055a.342.342 0 0 1-.484 0l-2.055-2.055.484-.484Zm14.142-1.47a.57.57 0 1 1 1.141-.001.57.57 0 0 1-1.141 0Zm6.393.342h-4.567v-.685h4.567v.685Zm-6.393 2.055a.57.57 0 1 1 1.141 0 .57.57 0 0 1-1.141 0Zm6.393.342h-4.567v-.684h4.567v.684Zm-6.393 2.055a.57.57 0 1 1 1.14 0 .57.57 0 0 1-1.14 0Zm6.393.343h-4.567v-.685h4.567v.685Zm4.123-3.667 1.813 1.813 1.813-1.813.484.484-2.055 2.055a.342.342 0 0 1-.484 0l-2.055-2.055.484-.484Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.14,
        d: "M253.705 27.738h.457v9.133h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#44546F",
        fillRule: "evenodd",
        d: "M263.396 29.664a1.795 1.795 0 1 1 2.539 2.54l-1.028 1.027-.484-.484 1.027-1.028a1.11 1.11 0 1 0-1.57-1.57l-1.028 1.027-.484-.484 1.028-1.028Zm1.397 1.626-2.511 2.512-.485-.484 2.512-2.512.484.484Zm-4.137 1.114 1.027-1.027.485.484-1.028 1.028a1.11 1.11 0 1 0 1.571 1.57l1.027-1.027.484.484-1.027 1.027a1.795 1.795 0 1 1-2.539-2.539Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.14,
        d: "M272.427 23.171h.457v18.265h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#44546F",
        fillRule: "evenodd",
        d: "M278.364 30.078c0-.662.536-1.199 1.198-1.199h4.909a1.2 1.2 0 0 1 1.199 1.199v3.767a1.2 1.2 0 0 1-1.199 1.199h-4.076l-1.519.868a.343.343 0 0 1-.512-.297v-5.537Zm1.198-.514a.514.514 0 0 0-.513.514v4.946l1.165-.665h4.257c.284 0 .514-.23.514-.514v-3.767a.514.514 0 0 0-.514-.514h-4.909Zm4.282 2.055h-3.654v-.685h3.654v.685Zm-1.37 1.37h-2.284v-.685h2.284v.685Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#B3B9C4",
        d: "M288.41 29.793h21.919v5.023H288.41z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.14,
        d: "M315.808 23.171h.457v18.265h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#44546F",
        fillRule: "evenodd",
        d: "M321.744 32.304a.685.685 0 1 1 1.37 0 .685.685 0 0 1-1.37 0Zm2.968 0a.685.685 0 1 1 1.37 0 .685.685 0 0 1-1.37 0Zm2.968 0a.685.685 0 1 1 1.37 0 .685.685 0 0 1-1.37 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#091E42",
        fillOpacity: 0.14,
        d: "M334.529 23.171h.457v18.265h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#44546F",
        d: "M342.91 28.65a.628.628 0 0 0-.579.872l.041.08.377.628v1.587a2.22 2.22 0 0 0-.541.279c-.419.297-.829.823-.829 1.692 0 .19.153.343.342.343h2.055v1.826h.685V34.13h2.055a.343.343 0 0 0 .343-.342c0-.869-.411-1.395-.83-1.692a2.25 2.25 0 0 0-.54-.28V30.23l.376-.628a.628.628 0 0 0-.538-.951h-2.417Zm1.942 1.309a.34.34 0 0 0-.048.176v1.94c0 .168.121.311.286.339h.004l.03.007a1.552 1.552 0 0 1 .509.234c.211.15.428.39.508.79h-4.045c.08-.4.297-.64.508-.79a1.556 1.556 0 0 1 .51-.234l.03-.007h.003a.342.342 0 0 0 .287-.338v-1.941a.342.342 0 0 0-.049-.176l-.374-.623h2.215l-.374.623Z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#292A2E",
        d: "M143.186 68.735c.141 0 .586 3.665.305 5.157.482.302.897 1.064.875 1.858 2.034 1.56.772-2.411.352-3.645-.342.828-.07-1.266-.333-1.589.016.178-.352-3.375-1.016-2.393-.085-.11-.354.712-.185.61l.002.002Zm-7.937 3.73c.135.784-.204 1.446-.751 2.075.334 2.71 2.44-1.575 2.936-2.62 0 0 .912-1.817.922-1.593.352-.138 2.323-2.659 1.016-2.603-.373.393-.718 1.363-1.123 1.35-.904.194-1.934 2.682-2.999 3.395l-.001-.004Zm-6.428-7.115c-.435 1.7 2.805.443 4.076.388 0 0 1.318.014 1.68-.215-.191-.002 4.487-.226 2.034-1.145-.066.023-1.686.097-1.686.097-2.117-.528-4.351.11-6.106.877l.002-.002Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#0C66E4",
        fillOpacity: 0.14,
        d: "M314 47.745H147.042v14.637H314z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M137.436 45h17.153v18.297h-17.153z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        filter: "url(#h)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#fff",
        d: "M149.798 43.71a6.006 6.006 0 0 0-3.969 1.339 6.026 6.026 0 0 0-3.968-1.338h-1.143v3.43h1.143c1.613 0 2.116.801 2.287 1.144v4.506h-1.143v3.43h1.143v3.431c-.148.343-.651 1.143-2.287 1.143h-1.143v3.431h1.143a6.026 6.026 0 0 0 3.968-1.338 5.965 5.965 0 0 0 3.969 1.338h1.143v-3.43h-1.143c-1.613 0-2.116-.8-2.288-1.144v-3.43h1.213V52.79h-1.144v-4.506c.149-.343.652-1.143 2.287-1.143h1.144V43.71h-1.212Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#000",
        d: "M149.798 45.998v-1.143a4.574 4.574 0 0 0-3.969 1.875 4.574 4.574 0 0 0-3.968-1.875v1.143a3.213 3.213 0 0 1 3.431 2.104v5.832h-1.144v1.144h1.144v4.757a3.234 3.234 0 0 1-3.431 2.104v1.144a4.635 4.635 0 0 0 3.968-1.864 4.636 4.636 0 0 0 3.969 1.864v-1.144a3.225 3.225 0 0 1-3.362-2.104v-4.769h1.143v-1.143h-1.143v-5.81a3.211 3.211 0 0 1 3.362-2.115Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#fff",
        d: "M0 0h477v81H0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "b"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#fff",
        d: "M-259-118.5h684v385h-684z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "c"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: 419.213,
        height: 220.555,
        x: 58.287,
        y: -54,
        fill: "#fff",
        rx: 5.243
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "d"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#fff",
        d: "M31.03-25.464a3.932 3.932 0 0 1 3.932-3.932h487.581v374.861H31.03V-25.464Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "f"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: 313.252,
        height: 18.265,
        x: 40,
        y: 23.171,
        fill: "#fff",
        rx: 2.74
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "g"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#fff",
        d: "M45.48 28.65h7.306v7.307H45.48z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("filter", {
        id: "e",
        width: 324.211,
        height: 29.225,
        x: 34.52,
        y: 21.345,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", {
        dy: 3.653
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
        stdDeviation: 2.74
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.15 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_13247_133684"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
        stdDeviation: 0.228
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
        in2: "effect1_dropShadow_13247_133684",
        result: "effect2_dropShadow_13247_133684"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_13247_133684",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("filter", {
        id: "h",
        width: 14.866,
        height: 25.095,
        x: 138.431,
        y: 42.565,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", {
        dy: 1.144
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
        stdDeviation: 1.144
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_13247_133684"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect1_dropShadow_13247_133684",
        result: "shape"
    }))));
};
const $3faf0024169aae07$var$BannerImageDark = ({ title: title, titleId: titleId, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "auto",
        height: "56px",
        viewBox: "0 0 477 81",
        fill: "none",
        "aria-labelledby": titleId,
        ...props
    }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#b)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
        id: "c",
        width: 686,
        height: 389,
        x: -260,
        y: -119.5,
        fill: "#000",
        maskUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#fff",
        d: "M-260-119.5h686v389h-686z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M294.605 266.507c-6.897-11.892-11.863-24.504-11.863-36.069 0-2.345.086-4.662.25-6.958.498-6.873 2.073-12.997 4.495-18.38.314-.699.642-1.376.984-2.047.099-.199.206-.399.306-.598.185-.35.378-.699.57-1.041 6.562-11.771 17.428-19.479 29.647-23.122a56.055 56.055 0 0 1 3.912-1.005 59.762 59.762 0 0 1 11.15-1.397c.428-.015.863-.036 1.29-.036v-.043c.086 0 .164.022.249.022.086 0 .164-.022.25-.022v.043c.292 0 .577.021.869.028 3.976.093 7.93.585 11.792 1.462.513.114 1.026.235 1.532.364.199.05.392.107.591.164 1.069.285 2.123.598 3.171.941 6.191 2.046 11.998 5.154 17.021 9.332a46.673 46.673 0 0 1 7.004 7.223c5.722 7.315 9.548 16.683 10.381 28.126.164 2.296.25 4.62.25 6.959 0 2.203-.185 4.441-.52 6.709-.036.242-.079.484-.121.72-.036.235-.079.463-.122.698-.078.45-.163.892-.256 1.341-1.788 8.791-5.8 17.888-10.851 26.6h48.407V-25.743c-3.142 2.787-6.548 5.233-10.175 7.371-19.173 11.294-44.36 14.01-67.787 14.01H282.03c-14.592 0-24.646 6.039-24.646 21.646 0 4.534 1.005 11.578 1.504 17.11h-59.359c-.684-5.154-1.603-11.478-2.123-20.418h-39.829c-.627-4.72-1.453-10.424-1.98-18.217a223.037 223.037 0 0 1-.492-11.885 238.289 238.289 0 0 1-.036-4.627c0-2.388.072-4.72.2-7.001 0-.071.007-.136.014-.207.007-.17.021-.342.036-.506.028-.392.05-.784.078-1.17.164-2.152.385-4.263.663-6.316.377-2.738.855-5.39 1.446-7.95a79.954 79.954 0 0 1 2.081-7.408c8.785-26.137 30.252-41.173 63.263-43.968a137.79 137.79 0 0 1 11.699-.478h74.442a62.92 62.92 0 0 0 3.527-.1l.648-.042c13.039-.87 21.888-6.01 25.771-16.961.043-.122.093-.243.135-.364.164-.485.321-.977.464-1.476.035-.114.057-.228.092-.342a38.98 38.98 0 0 0 .784-3.458H101.418c-4.51 20.719-12.006 37.659-23.056 50.635 6.761.527 13.836 1.34 21.24 2.466L90.01-2.002C43.427-8.354 21.475 3.452 16.68 35.144l-61.952-9.383C-41.253-.79-33.116-21.98-19.9-37.5a292.483 292.483 0 0 1-21.24-2.467l9.59-63.397c33.51 4.57 54.279-.256 65.073-15.122H-88.834c10.503 6.531 17.791 16.976 20.499 30.936.705 3.65 1.104 7.55 1.161 11.67.057 4.072-.228 7.922-.826 11.544-3.285 19.991-16.117 33.138-34.556 38.086-.143.036-.293.079-.435.114-.613.157-1.226.307-1.853.45-.192.042-.384.092-.584.135-.769.164-1.546.32-2.337.463-3.014.535-6.156.856-9.398.984a59 59 0 0 1-1.952.064 80.363 80.363 0 0 1-4.56-.085c-.598-.029-1.19-.05-1.781-.093a71.106 71.106 0 0 1-5.508-.606 56.036 56.036 0 0 1-2.23-.385c-.185-.035-.363-.071-.549-.107a66.504 66.504 0 0 1-1.717-.363c-.156-.036-.313-.072-.47-.114a41.541 41.541 0 0 1-1.909-.492 5.423 5.423 0 0 1-.164-.043c-12.141-3.365-21.824-10.374-27.88-20.669-4.126 6.98-9.954 12.463-17.115 16.32l.406.15a50.24 50.24 0 0 1-2.322 1.197c-.15-.05-.307-.107-.456-.157-.171.079-.349.164-.528.243.193.071.335.135.414.178-.007 0-.015.007-.029.014-.149-.05-.313-.107-.47-.157a54.023 54.023 0 0 1-8.329 2.966c-.143.036-.292.079-.435.114-.613.157-1.225.307-1.852.45-.193.042-.385.092-.585.135-.769.164-1.546.32-2.336.463-3.014.535-6.157.856-9.398.984-.649.029-1.297.058-1.953.065a76.937 76.937 0 0 1-6.056-.157 68.182 68.182 0 0 1-5.793-.635c-.256-.035-.505-.085-.755-.128l.107.356a62.105 62.105 0 0 1-2.601-.485c-.035-.12-.078-.235-.114-.356a53.066 53.066 0 0 1-1.132-.25 11.189 11.189 0 0 1-.471-.114 41.67 41.67 0 0 1-1.909-.492c-.057-.014-.114-.028-.164-.042-13.103-3.622-23.32-11.472-29.241-23.107v315.949h36.416c-2.009-6.438-3.135-13.739-3.135-21.788 0-5.069.449-9.775 1.275-14.138a63.596 63.596 0 0 1 .983-4.363 61.02 61.02 0 0 1 2.679-8.007 56.391 56.391 0 0 1 1.482-3.23l.129-.249c.064-.121.128-.235.192-.357.335-.648.67-1.304 1.026-1.932a50.705 50.705 0 0 1 12.262-14.452 54.475 54.475 0 0 1 5.052-3.629 57.83 57.83 0 0 1 5.472-3.08c.335-.164.677-.313 1.012-.47a58.52 58.52 0 0 1 2.472-1.112 71.392 71.392 0 0 1 8.564-2.988c7.88-2.217 16.024-3.272 25.294-3.272 1.503 0 2.992.035 4.474.093 1.112.042 2.223.099 3.321.178 6.462.435 12.682 1.433 18.51 3.058.606.171 1.197.357 1.789.542.178.043.356.093.534.15h-.014c.093-.029.185-.057.285-.078l.256.085c8.479-2.246 17.82-3.358 27.738-3.358v.064c14.87 0 28.607 2.446 40.121 7.593 6.384 2.816 12.027 6.431 16.815 10.958 10.26 9.797 16.416 23.143 16.416 41.994 0 8.099-1.183 15.35-3.363 21.774H71.586c5.45-6.83 8.208-17.639 8.393-33.074l40.392-.115h.22c.271 15.55 3.007 26.387 8.458 33.175h43.498c5.593-6.816 8.415-17.703 8.607-33.346h.492l40.391-.121c.278 15.764 3.078 26.693 8.678 33.46h63.905l-.015.035Zm-413.948-123.792 7.802-6.174c-.506-.192-1.026-.371-1.368-.428.014-.121-.185-.185-.228-.242v.107c-5.273-4.378-14.856-8.741-21.425-13.047-4.268 5.404-9.526 8.89-15.354 10.516.235.199.456.399.677.584-.727.214-1.461.407-2.202.564l-.727-.621c-5.044.977-10.466.628-16.01-1.019a45.588 45.588 0 0 1-6.925-2.695 46.678 46.678 0 0 1-6.683-3.914c-3.933-2.781-7.118-6.032-9.448-9.668-.079-.014-.15-.029-.228-.036a3.667 3.667 0 0 1-.121-.021 29.164 29.164 0 0 1-1.347-2.51c.086.015.171.029.257.05-1.96-3.836-3.021-8.028-3.093-12.491-4.075-.306-7.98-.592-11.528-.82l.449-.228c-.969.107-1.853.121-2.708.1-.071.314-.135.62-.22.934a22.293 22.293 0 0 1-1.411 3.722 22.724 22.724 0 0 1-1.995 3.379c-4.389 6.082-11.001 7.964-18.005 5.889a23.988 23.988 0 0 1-3.605-1.405 24.154 24.154 0 0 1-3.477-2.039c-5.978-4.22-8.622-10.544-6.627-17.738a22.488 22.488 0 0 1 1.397-3.672 22.02 22.02 0 0 1 2.023-3.422c4.389-6.046 10.973-7.914 17.984-5.875 1.24.364 2.501.841 3.755 1.455a24.4 24.4 0 0 1 3.341 1.946c5.031 3.522 7.688 8.57 7.211 14.395 1.845.164 3.163.313 3.163.313l5.401.05s2.722.079 4.938.057a34.154 34.154 0 0 1 1.161-6.438c.641-2.31 1.532-4.662 2.679-7.05a43.121 43.121 0 0 1 3.898-6.582c5.885-8.106 13.822-12.298 22.664-12.769.492-8.17.948-16.398 2.23-22.059.748 2.638.072-6.46.592-6.973l.199.364c.364-.585-.235-2.431.542-2.574.014-.114.014-.306.014-.563l-13.78 1.982-5.123-35.584 35.568-5.126 5.123 35.584-20.206 2.909c-.549 6.901-1.226 13.51-1.468 14.23-.064-.12.121-.705-.292-.734-.086 1.034-.071 2.125-.15 3.223.649-.285.321-1.64.527-1.74.072 4.1-.584 12.42-1.232 17.018 3.042.086 6.177.585 9.355 1.512a47.373 47.373 0 0 1 7.218 2.788 45.558 45.558 0 0 1 6.419 3.743c3.912 2.737 7.075 5.946 9.398 9.546.164-.107.335-.214.499-.32a5.465 5.465 0 0 0-.392.491c.028.043.057.086.078.136 1.219-.685 8.949-7.593 9.797-7.743-.035.057-.292.47-.335.542 1.019-.37 3-2.802 3.727-2.396.185-.128.506-.392.919-.748-3.05-3.864-4.104-8.691-2.636-13.989a22.485 22.485 0 0 1 1.396-3.671 22.022 22.022 0 0 1 2.024-3.423c4.389-6.045 10.972-7.913 17.983-5.874 1.24.363 2.501.84 3.755 1.454a24.467 24.467 0 0 1 3.342 1.946c5.977 4.185 8.628 10.517 6.612 17.753a22.22 22.22 0 0 1-1.411 3.722 22.707 22.707 0 0 1-1.995 3.38c-4.39 6.08-11.001 7.963-18.005 5.888a24.082 24.082 0 0 1-3.605-1.404 24.192 24.192 0 0 1-3.477-2.04 19.98 19.98 0 0 1-2.971-2.552 1165.843 1165.843 0 0 1-14.272 10.624c.52.94.983 1.91 1.397 2.901.114.264.228.528.335.792v.028c2.166 5.74 2.451 12.199.534 19.086-.648 2.339-1.553 4.72-2.715 7.144-.014.029-.035.064-.049.093.149.092.299.178.448.271-.05.107-.092.214-.142.313a45.036 45.036 0 0 1-1.055 2.047c-.156-.093-.32-.186-.477-.286a42.943 42.943 0 0 1-1.967 3.187c3.021 1.512 7.304 4.107 9.498 5.725-.335-.071-1.083-.37-1.86-.834l-.142.214c1.824 1.013 3.249 2.995 5.422 3.152 0 0-2.109-1.562-2.487-2.004l.029-.014-.014-.043c4.26 2.189 9.17 5.183 13.409 7.65l17.97-14.223 22.293 28.197-28.179 22.309-22.294-28.198.014.014Zm364.665 16.94c.498.421 0-65.421 0-65.421 31.592 11.001 68.499.563 68.499.563v64.58c-23.277 6.488-68.499.286-68.499.286v-.008ZM362.058 16.371v35.905c18.161-.463 32.183-4.428 32.183-4.428v64.581c-23.277 6.488-68.499.285-68.499.285.228.192.249-13.81.199-28.91-17.257-.493-32.383-2.575-32.383-2.575.499.421 0-65.421 0-65.421 31.592 11.001 68.5.563 68.5.563ZM103.05 218.154a32.17 32.17 0 0 1-5.059.414 32.17 32.17 0 0 1-5.265-.414c-9.47-1.554-16.21-7.508-17.97-17.133a29.36 29.36 0 0 1-.456-5.126c0-1.839.143-3.572.435-5.197 1.717-9.647 8.422-15.628 17.862-17.233a32.228 32.228 0 0 1 5.266-.442c1.76 0 3.448.129 5.058.385 9.448 1.512 16.196 7.472 17.963 17.161.299 1.626.456 3.366.456 5.198 0 1.811-.143 3.522-.421 5.133-1.703 9.689-8.422 15.7-17.876 17.261l.007-.007Zm31.813-58.263c-2.43-4.906-3.691-12.185-4.346-18.744-3.72.264-7.546.321-11.429.192-.691-.021-1.375-.042-2.073-.071h-.072l-.684-.043c-.185-.007-.363-.021-.548-.035-7.788-.478-15.283-1.754-22.237-3.872-.955 3.28-2.138 6.353-3.541 9.197-7.695 15.622-21.86 24.626-38.86 28.319-7.923 1.719-16.445 2.31-25.215 1.868-4.632-.235-9.142-.72-13.495-1.476-1.304 6.46-3.292 13.575-6.199 18.21l-36.872-9.155s7.061-11.151 8.144-24.519c-5.857-5.219-10.445-11.699-13.374-19.571-2.728-7.336-4.06-15.827-3.57-25.666.5-9.982 2.708-18.416 6.2-25.517 7.645-15.55 21.667-24.533 38.824-28.24 8.172-1.769 17.035-2.36 26.255-1.897 8.244.413 16.174 1.725 23.498 3.964l.022-.078h.014a57.883 57.883 0 0 1 3.534-9.133c.036-.079.078-.15.121-.221.392-.785.798-1.548 1.226-2.296 7.951-14.088 21.439-22.316 37.463-25.795.94-.207 1.888-.392 2.843-.564.926-.164 1.859-.313 2.807-.456 6.27-.92 12.846-1.198 19.565-.855 6.213.313 12.213 1.098 17.898 2.352 1.233.271 2.459.57 3.663.892l.733.192c.086.021.179.043.271.071.114.029.228.058.342.093.755.214 1.504.45 2.252.678.256.078.52.15.776.235 7.667 2.48 14.557 6.01 20.356 10.659a52.13 52.13 0 0 1 3.078 2.673 48.996 48.996 0 0 1 3.67 3.836c.292.342.577.684.862 1.04.192.236.378.478.57.714a53.34 53.34 0 0 1 1.61 2.181 49.357 49.357 0 0 1 5.665 10.887c2.764 7.415 4.111 16.028 3.612 26.01-.492 9.838-2.672 18.151-6.12 25.174-3.228 6.566-7.61 11.956-12.882 16.284-.563.463-1.14.906-1.725 1.348-.22.164-.434.328-.655.492-.257 13.41 5.65 25.224 5.65 25.224l-37.606 5.412-.021.007Zm89.718 40.717c-1.703 9.689-8.422 15.699-17.877 17.261-1.61.264-3.299.406-5.059.413-1.831 0-3.591-.135-5.265-.413-9.469-1.554-16.209-7.508-17.969-17.133a29.37 29.37 0 0 1-.456-5.126c0-1.832.142-3.572.434-5.197 1.718-9.647 8.422-15.629 17.863-17.233a32.112 32.112 0 0 1 5.265-.442c1.76 0 3.449.129 5.059.385 9.448 1.512 16.195 7.472 17.962 17.161.299 1.626.456 3.365.456 5.198a30.17 30.17 0 0 1-.42 5.133l.007-.007Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#48245D",
        d: "M294.605 266.507c-6.897-11.892-11.863-24.504-11.863-36.069 0-2.345.086-4.662.25-6.958.498-6.873 2.073-12.997 4.495-18.38.314-.699.642-1.376.984-2.047.099-.199.206-.399.306-.598.185-.35.378-.699.57-1.041 6.562-11.771 17.428-19.479 29.647-23.122a56.055 56.055 0 0 1 3.912-1.005 59.762 59.762 0 0 1 11.15-1.397c.428-.015.863-.036 1.29-.036v-.043c.086 0 .164.022.249.022.086 0 .164-.022.25-.022v.043c.292 0 .577.021.869.028 3.976.093 7.93.585 11.792 1.462.513.114 1.026.235 1.532.364.199.05.392.107.591.164 1.069.285 2.123.598 3.171.941 6.191 2.046 11.998 5.154 17.021 9.332a46.673 46.673 0 0 1 7.004 7.223c5.722 7.315 9.548 16.683 10.381 28.126.164 2.296.25 4.62.25 6.959 0 2.203-.185 4.441-.52 6.709-.036.242-.079.484-.121.72-.036.235-.079.463-.122.698-.078.45-.163.892-.256 1.341-1.788 8.791-5.8 17.888-10.851 26.6h48.407V-25.743c-3.142 2.787-6.548 5.233-10.175 7.371-19.173 11.294-44.36 14.01-67.787 14.01H282.03c-14.592 0-24.646 6.039-24.646 21.646 0 4.534 1.005 11.578 1.504 17.11h-59.359c-.684-5.154-1.603-11.478-2.123-20.418h-39.829c-.627-4.72-1.453-10.424-1.98-18.217a223.037 223.037 0 0 1-.492-11.885 238.289 238.289 0 0 1-.036-4.627c0-2.388.072-4.72.2-7.001 0-.071.007-.136.014-.207.007-.17.021-.342.036-.506.028-.392.05-.784.078-1.17.164-2.152.385-4.263.663-6.316.377-2.738.855-5.39 1.446-7.95a79.954 79.954 0 0 1 2.081-7.408c8.785-26.137 30.252-41.173 63.263-43.968a137.79 137.79 0 0 1 11.699-.478h74.442a62.92 62.92 0 0 0 3.527-.1l.648-.042c13.039-.87 21.888-6.01 25.771-16.961.043-.122.093-.243.135-.364.164-.485.321-.977.464-1.476.035-.114.057-.228.092-.342a38.98 38.98 0 0 0 .784-3.458H101.418c-4.51 20.719-12.006 37.659-23.056 50.635 6.761.527 13.836 1.34 21.24 2.466L90.01-2.002C43.427-8.354 21.475 3.452 16.68 35.144l-61.952-9.383C-41.253-.79-33.116-21.98-19.9-37.5a292.483 292.483 0 0 1-21.24-2.467l9.59-63.397c33.51 4.57 54.279-.256 65.073-15.122H-88.834c10.503 6.531 17.791 16.976 20.499 30.936.705 3.65 1.104 7.55 1.161 11.67.057 4.072-.228 7.922-.826 11.544-3.285 19.991-16.117 33.138-34.556 38.086-.143.036-.293.079-.435.114-.613.157-1.226.307-1.853.45-.192.042-.384.092-.584.135-.769.164-1.546.32-2.337.463-3.014.535-6.156.856-9.398.984a59 59 0 0 1-1.952.064 80.363 80.363 0 0 1-4.56-.085c-.598-.029-1.19-.05-1.781-.093a71.106 71.106 0 0 1-5.508-.606 56.036 56.036 0 0 1-2.23-.385c-.185-.035-.363-.071-.549-.107a66.504 66.504 0 0 1-1.717-.363c-.156-.036-.313-.072-.47-.114a41.541 41.541 0 0 1-1.909-.492 5.423 5.423 0 0 1-.164-.043c-12.141-3.365-21.824-10.374-27.88-20.669-4.126 6.98-9.954 12.463-17.115 16.32l.406.15a50.24 50.24 0 0 1-2.322 1.197c-.15-.05-.307-.107-.456-.157-.171.079-.349.164-.528.243.193.071.335.135.414.178-.007 0-.015.007-.029.014-.149-.05-.313-.107-.47-.157a54.023 54.023 0 0 1-8.329 2.966c-.143.036-.292.079-.435.114-.613.157-1.225.307-1.852.45-.193.042-.385.092-.585.135-.769.164-1.546.32-2.336.463-3.014.535-6.157.856-9.398.984-.649.029-1.297.058-1.953.065a76.937 76.937 0 0 1-6.056-.157 68.182 68.182 0 0 1-5.793-.635c-.256-.035-.505-.085-.755-.128l.107.356a62.105 62.105 0 0 1-2.601-.485c-.035-.12-.078-.235-.114-.356a53.066 53.066 0 0 1-1.132-.25 11.189 11.189 0 0 1-.471-.114 41.67 41.67 0 0 1-1.909-.492c-.057-.014-.114-.028-.164-.042-13.103-3.622-23.32-11.472-29.241-23.107v315.949h36.416c-2.009-6.438-3.135-13.739-3.135-21.788 0-5.069.449-9.775 1.275-14.138a63.596 63.596 0 0 1 .983-4.363 61.02 61.02 0 0 1 2.679-8.007 56.391 56.391 0 0 1 1.482-3.23l.129-.249c.064-.121.128-.235.192-.357.335-.648.67-1.304 1.026-1.932a50.705 50.705 0 0 1 12.262-14.452 54.475 54.475 0 0 1 5.052-3.629 57.83 57.83 0 0 1 5.472-3.08c.335-.164.677-.313 1.012-.47a58.52 58.52 0 0 1 2.472-1.112 71.392 71.392 0 0 1 8.564-2.988c7.88-2.217 16.024-3.272 25.294-3.272 1.503 0 2.992.035 4.474.093 1.112.042 2.223.099 3.321.178 6.462.435 12.682 1.433 18.51 3.058.606.171 1.197.357 1.789.542.178.043.356.093.534.15h-.014c.093-.029.185-.057.285-.078l.256.085c8.479-2.246 17.82-3.358 27.738-3.358v.064c14.87 0 28.607 2.446 40.121 7.593 6.384 2.816 12.027 6.431 16.815 10.958 10.26 9.797 16.416 23.143 16.416 41.994 0 8.099-1.183 15.35-3.363 21.774H71.586c5.45-6.83 8.208-17.639 8.393-33.074l40.392-.115h.22c.271 15.55 3.007 26.387 8.458 33.175h43.498c5.593-6.816 8.415-17.703 8.607-33.346h.492l40.391-.121c.278 15.764 3.078 26.693 8.678 33.46h63.905l-.015.035Zm-413.948-123.792 7.802-6.174c-.506-.192-1.026-.371-1.368-.428.014-.121-.185-.185-.228-.242v.107c-5.273-4.378-14.856-8.741-21.425-13.047-4.268 5.404-9.526 8.89-15.354 10.516.235.199.456.399.677.584-.727.214-1.461.407-2.202.564l-.727-.621c-5.044.977-10.466.628-16.01-1.019a45.588 45.588 0 0 1-6.925-2.695 46.678 46.678 0 0 1-6.683-3.914c-3.933-2.781-7.118-6.032-9.448-9.668-.079-.014-.15-.029-.228-.036a3.667 3.667 0 0 1-.121-.021 29.164 29.164 0 0 1-1.347-2.51c.086.015.171.029.257.05-1.96-3.836-3.021-8.028-3.093-12.491-4.075-.306-7.98-.592-11.528-.82l.449-.228c-.969.107-1.853.121-2.708.1-.071.314-.135.62-.22.934a22.293 22.293 0 0 1-1.411 3.722 22.724 22.724 0 0 1-1.995 3.379c-4.389 6.082-11.001 7.964-18.005 5.889a23.988 23.988 0 0 1-3.605-1.405 24.154 24.154 0 0 1-3.477-2.039c-5.978-4.22-8.622-10.544-6.627-17.738a22.488 22.488 0 0 1 1.397-3.672 22.02 22.02 0 0 1 2.023-3.422c4.389-6.046 10.973-7.914 17.984-5.875 1.24.364 2.501.841 3.755 1.455a24.4 24.4 0 0 1 3.341 1.946c5.031 3.522 7.688 8.57 7.211 14.395 1.845.164 3.163.313 3.163.313l5.401.05s2.722.079 4.938.057a34.154 34.154 0 0 1 1.161-6.438c.641-2.31 1.532-4.662 2.679-7.05a43.121 43.121 0 0 1 3.898-6.582c5.885-8.106 13.822-12.298 22.664-12.769.492-8.17.948-16.398 2.23-22.059.748 2.638.072-6.46.592-6.973l.199.364c.364-.585-.235-2.431.542-2.574.014-.114.014-.306.014-.563l-13.78 1.982-5.123-35.584 35.568-5.126 5.123 35.584-20.206 2.909c-.549 6.901-1.226 13.51-1.468 14.23-.064-.12.121-.705-.292-.734-.086 1.034-.071 2.125-.15 3.223.649-.285.321-1.64.527-1.74.072 4.1-.584 12.42-1.232 17.018 3.042.086 6.177.585 9.355 1.512a47.373 47.373 0 0 1 7.218 2.788 45.558 45.558 0 0 1 6.419 3.743c3.912 2.737 7.075 5.946 9.398 9.546.164-.107.335-.214.499-.32a5.465 5.465 0 0 0-.392.491c.028.043.057.086.078.136 1.219-.685 8.949-7.593 9.797-7.743-.035.057-.292.47-.335.542 1.019-.37 3-2.802 3.727-2.396.185-.128.506-.392.919-.748-3.05-3.864-4.104-8.691-2.636-13.989a22.485 22.485 0 0 1 1.396-3.671 22.022 22.022 0 0 1 2.024-3.423c4.389-6.045 10.972-7.913 17.983-5.874 1.24.363 2.501.84 3.755 1.454a24.467 24.467 0 0 1 3.342 1.946c5.977 4.185 8.628 10.517 6.612 17.753a22.22 22.22 0 0 1-1.411 3.722 22.707 22.707 0 0 1-1.995 3.38c-4.39 6.08-11.001 7.963-18.005 5.888a24.082 24.082 0 0 1-3.605-1.404 24.192 24.192 0 0 1-3.477-2.04 19.98 19.98 0 0 1-2.971-2.552 1165.843 1165.843 0 0 1-14.272 10.624c.52.94.983 1.91 1.397 2.901.114.264.228.528.335.792v.028c2.166 5.74 2.451 12.199.534 19.086-.648 2.339-1.553 4.72-2.715 7.144-.014.029-.035.064-.049.093.149.092.299.178.448.271-.05.107-.092.214-.142.313a45.036 45.036 0 0 1-1.055 2.047c-.156-.093-.32-.186-.477-.286a42.943 42.943 0 0 1-1.967 3.187c3.021 1.512 7.304 4.107 9.498 5.725-.335-.071-1.083-.37-1.86-.834l-.142.214c1.824 1.013 3.249 2.995 5.422 3.152 0 0-2.109-1.562-2.487-2.004l.029-.014-.014-.043c4.26 2.189 9.17 5.183 13.409 7.65l17.97-14.223 22.293 28.197-28.179 22.309-22.294-28.198.014.014Zm364.665 16.94c.498.421 0-65.421 0-65.421 31.592 11.001 68.499.563 68.499.563v64.58c-23.277 6.488-68.499.286-68.499.286v-.008ZM362.058 16.371v35.905c18.161-.463 32.183-4.428 32.183-4.428v64.581c-23.277 6.488-68.499.285-68.499.285.228.192.249-13.81.199-28.91-17.257-.493-32.383-2.575-32.383-2.575.499.421 0-65.421 0-65.421 31.592 11.001 68.5.563 68.5.563ZM103.05 218.154a32.17 32.17 0 0 1-5.059.414 32.17 32.17 0 0 1-5.265-.414c-9.47-1.554-16.21-7.508-17.97-17.133a29.36 29.36 0 0 1-.456-5.126c0-1.839.143-3.572.435-5.197 1.717-9.647 8.422-15.628 17.862-17.233a32.228 32.228 0 0 1 5.266-.442c1.76 0 3.448.129 5.058.385 9.448 1.512 16.196 7.472 17.963 17.161.299 1.626.456 3.366.456 5.198 0 1.811-.143 3.522-.421 5.133-1.703 9.689-8.422 15.7-17.876 17.261l.007-.007Zm31.813-58.263c-2.43-4.906-3.691-12.185-4.346-18.744-3.72.264-7.546.321-11.429.192-.691-.021-1.375-.042-2.073-.071h-.072l-.684-.043c-.185-.007-.363-.021-.548-.035-7.788-.478-15.283-1.754-22.237-3.872-.955 3.28-2.138 6.353-3.541 9.197-7.695 15.622-21.86 24.626-38.86 28.319-7.923 1.719-16.445 2.31-25.215 1.868-4.632-.235-9.142-.72-13.495-1.476-1.304 6.46-3.292 13.575-6.199 18.21l-36.872-9.155s7.061-11.151 8.144-24.519c-5.857-5.219-10.445-11.699-13.374-19.571-2.728-7.336-4.06-15.827-3.57-25.666.5-9.982 2.708-18.416 6.2-25.517 7.645-15.55 21.667-24.533 38.824-28.24 8.172-1.769 17.035-2.36 26.255-1.897 8.244.413 16.174 1.725 23.498 3.964l.022-.078h.014a57.883 57.883 0 0 1 3.534-9.133c.036-.079.078-.15.121-.221.392-.785.798-1.548 1.226-2.296 7.951-14.088 21.439-22.316 37.463-25.795.94-.207 1.888-.392 2.843-.564.926-.164 1.859-.313 2.807-.456 6.27-.92 12.846-1.198 19.565-.855 6.213.313 12.213 1.098 17.898 2.352 1.233.271 2.459.57 3.663.892l.733.192c.086.021.179.043.271.071.114.029.228.058.342.093.755.214 1.504.45 2.252.678.256.078.52.15.776.235 7.667 2.48 14.557 6.01 20.356 10.659a52.13 52.13 0 0 1 3.078 2.673 48.996 48.996 0 0 1 3.67 3.836c.292.342.577.684.862 1.04.192.236.378.478.57.714a53.34 53.34 0 0 1 1.61 2.181 49.357 49.357 0 0 1 5.665 10.887c2.764 7.415 4.111 16.028 3.612 26.01-.492 9.838-2.672 18.151-6.12 25.174-3.228 6.566-7.61 11.956-12.882 16.284-.563.463-1.14.906-1.725 1.348-.22.164-.434.328-.655.492-.257 13.41 5.65 25.224 5.65 25.224l-37.606 5.412-.021.007Zm89.718 40.717c-1.703 9.689-8.422 15.699-17.877 17.261-1.61.264-3.299.406-5.059.413-1.831 0-3.591-.135-5.265-.413-9.469-1.554-16.209-7.508-17.969-17.133a29.37 29.37 0 0 1-.456-5.126c0-1.832.142-3.572.434-5.197 1.718-9.647 8.422-15.629 17.863-17.233a32.112 32.112 0 0 1 5.265-.442c1.76 0 3.449.129 5.059.385 9.448 1.512 16.195 7.472 17.962 17.161.299 1.626.456 3.365.456 5.198a30.17 30.17 0 0 1-.42 5.133l.007-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        stroke: "#48245D",
        strokeWidth: 2,
        d: "M294.605 266.507c-6.897-11.892-11.863-24.504-11.863-36.069 0-2.345.086-4.662.25-6.958.498-6.873 2.073-12.997 4.495-18.38.314-.699.642-1.376.984-2.047.099-.199.206-.399.306-.598.185-.35.378-.699.57-1.041 6.562-11.771 17.428-19.479 29.647-23.122a56.055 56.055 0 0 1 3.912-1.005 59.762 59.762 0 0 1 11.15-1.397c.428-.015.863-.036 1.29-.036v-.043c.086 0 .164.022.249.022.086 0 .164-.022.25-.022v.043c.292 0 .577.021.869.028 3.976.093 7.93.585 11.792 1.462.513.114 1.026.235 1.532.364.199.05.392.107.591.164 1.069.285 2.123.598 3.171.941 6.191 2.046 11.998 5.154 17.021 9.332a46.673 46.673 0 0 1 7.004 7.223c5.722 7.315 9.548 16.683 10.381 28.126.164 2.296.25 4.62.25 6.959 0 2.203-.185 4.441-.52 6.709-.036.242-.079.484-.121.72-.036.235-.079.463-.122.698-.078.45-.163.892-.256 1.341-1.788 8.791-5.8 17.888-10.851 26.6h48.407V-25.743c-3.142 2.787-6.548 5.233-10.175 7.371-19.173 11.294-44.36 14.01-67.787 14.01H282.03c-14.592 0-24.646 6.039-24.646 21.646 0 4.534 1.005 11.578 1.504 17.11h-59.359c-.684-5.154-1.603-11.478-2.123-20.418h-39.829c-.627-4.72-1.453-10.424-1.98-18.217a223.037 223.037 0 0 1-.492-11.885 238.289 238.289 0 0 1-.036-4.627c0-2.388.072-4.72.2-7.001 0-.071.007-.136.014-.207.007-.17.021-.342.036-.506.028-.392.05-.784.078-1.17.164-2.152.385-4.263.663-6.316.377-2.738.855-5.39 1.446-7.95a79.954 79.954 0 0 1 2.081-7.408c8.785-26.137 30.252-41.173 63.263-43.968a137.79 137.79 0 0 1 11.699-.478h74.442a62.92 62.92 0 0 0 3.527-.1l.648-.042c13.039-.87 21.888-6.01 25.771-16.961.043-.122.093-.243.135-.364.164-.485.321-.977.464-1.476.035-.114.057-.228.092-.342a38.98 38.98 0 0 0 .784-3.458H101.418c-4.51 20.719-12.006 37.659-23.056 50.635 6.761.527 13.836 1.34 21.24 2.466L90.01-2.002C43.427-8.354 21.475 3.452 16.68 35.144l-61.952-9.383C-41.253-.79-33.116-21.98-19.9-37.5a292.483 292.483 0 0 1-21.24-2.467l9.59-63.397c33.51 4.57 54.279-.256 65.073-15.122H-88.834c10.503 6.531 17.791 16.976 20.499 30.936.705 3.65 1.104 7.55 1.161 11.67.057 4.072-.228 7.922-.826 11.544-3.285 19.991-16.117 33.138-34.556 38.086-.143.036-.293.079-.435.114-.613.157-1.226.307-1.853.45-.192.042-.384.092-.584.135-.769.164-1.546.32-2.337.463-3.014.535-6.156.856-9.398.984a59 59 0 0 1-1.952.064 80.363 80.363 0 0 1-4.56-.085c-.598-.029-1.19-.05-1.781-.093a71.106 71.106 0 0 1-5.508-.606 56.036 56.036 0 0 1-2.23-.385c-.185-.035-.363-.071-.549-.107a66.504 66.504 0 0 1-1.717-.363c-.156-.036-.313-.072-.47-.114a41.541 41.541 0 0 1-1.909-.492 5.423 5.423 0 0 1-.164-.043c-12.141-3.365-21.824-10.374-27.88-20.669-4.126 6.98-9.954 12.463-17.115 16.32l.406.15a50.24 50.24 0 0 1-2.322 1.197c-.15-.05-.307-.107-.456-.157-.171.079-.349.164-.528.243.193.071.335.135.414.178-.007 0-.015.007-.029.014-.149-.05-.313-.107-.47-.157a54.023 54.023 0 0 1-8.329 2.966c-.143.036-.292.079-.435.114-.613.157-1.225.307-1.852.45-.193.042-.385.092-.585.135-.769.164-1.546.32-2.336.463-3.014.535-6.157.856-9.398.984-.649.029-1.297.058-1.953.065a76.937 76.937 0 0 1-6.056-.157 68.182 68.182 0 0 1-5.793-.635c-.256-.035-.505-.085-.755-.128l.107.356a62.105 62.105 0 0 1-2.601-.485c-.035-.12-.078-.235-.114-.356a53.066 53.066 0 0 1-1.132-.25 11.189 11.189 0 0 1-.471-.114 41.67 41.67 0 0 1-1.909-.492c-.057-.014-.114-.028-.164-.042-13.103-3.622-23.32-11.472-29.241-23.107v315.949h36.416c-2.009-6.438-3.135-13.739-3.135-21.788 0-5.069.449-9.775 1.275-14.138a63.596 63.596 0 0 1 .983-4.363 61.02 61.02 0 0 1 2.679-8.007 56.391 56.391 0 0 1 1.482-3.23l.129-.249c.064-.121.128-.235.192-.357.335-.648.67-1.304 1.026-1.932a50.705 50.705 0 0 1 12.262-14.452 54.475 54.475 0 0 1 5.052-3.629 57.83 57.83 0 0 1 5.472-3.08c.335-.164.677-.313 1.012-.47a58.52 58.52 0 0 1 2.472-1.112 71.392 71.392 0 0 1 8.564-2.988c7.88-2.217 16.024-3.272 25.294-3.272 1.503 0 2.992.035 4.474.093 1.112.042 2.223.099 3.321.178 6.462.435 12.682 1.433 18.51 3.058.606.171 1.197.357 1.789.542.178.043.356.093.534.15h-.014c.093-.029.185-.057.285-.078l.256.085c8.479-2.246 17.82-3.358 27.738-3.358v.064c14.87 0 28.607 2.446 40.121 7.593 6.384 2.816 12.027 6.431 16.815 10.958 10.26 9.797 16.416 23.143 16.416 41.994 0 8.099-1.183 15.35-3.363 21.774H71.586c5.45-6.83 8.208-17.639 8.393-33.074l40.392-.115h.22c.271 15.55 3.007 26.387 8.458 33.175h43.498c5.593-6.816 8.415-17.703 8.607-33.346h.492l40.391-.121c.278 15.764 3.078 26.693 8.678 33.46h63.905l-.015.035Zm-413.948-123.792 7.802-6.174c-.506-.192-1.026-.371-1.368-.428.014-.121-.185-.185-.228-.242v.107c-5.273-4.378-14.856-8.741-21.425-13.047-4.268 5.404-9.526 8.89-15.354 10.516.235.199.456.399.677.584-.727.214-1.461.407-2.202.564l-.727-.621c-5.044.977-10.466.628-16.01-1.019a45.588 45.588 0 0 1-6.925-2.695 46.678 46.678 0 0 1-6.683-3.914c-3.933-2.781-7.118-6.032-9.448-9.668-.079-.014-.15-.029-.228-.036a3.667 3.667 0 0 1-.121-.021 29.164 29.164 0 0 1-1.347-2.51c.086.015.171.029.257.05-1.96-3.836-3.021-8.028-3.093-12.491-4.075-.306-7.98-.592-11.528-.82l.449-.228c-.969.107-1.853.121-2.708.1-.071.314-.135.62-.22.934a22.293 22.293 0 0 1-1.411 3.722 22.724 22.724 0 0 1-1.995 3.379c-4.389 6.082-11.001 7.964-18.005 5.889a23.988 23.988 0 0 1-3.605-1.405 24.154 24.154 0 0 1-3.477-2.039c-5.978-4.22-8.622-10.544-6.627-17.738a22.488 22.488 0 0 1 1.397-3.672 22.02 22.02 0 0 1 2.023-3.422c4.389-6.046 10.973-7.914 17.984-5.875 1.24.364 2.501.841 3.755 1.455a24.4 24.4 0 0 1 3.341 1.946c5.031 3.522 7.688 8.57 7.211 14.395 1.845.164 3.163.313 3.163.313l5.401.05s2.722.079 4.938.057a34.154 34.154 0 0 1 1.161-6.438c.641-2.31 1.532-4.662 2.679-7.05a43.121 43.121 0 0 1 3.898-6.582c5.885-8.106 13.822-12.298 22.664-12.769.492-8.17.948-16.398 2.23-22.059.748 2.638.072-6.46.592-6.973l.199.364c.364-.585-.235-2.431.542-2.574.014-.114.014-.306.014-.563l-13.78 1.982-5.123-35.584 35.568-5.126 5.123 35.584-20.206 2.909c-.549 6.901-1.226 13.51-1.468 14.23-.064-.12.121-.705-.292-.734-.086 1.034-.071 2.125-.15 3.223.649-.285.321-1.64.527-1.74.072 4.1-.584 12.42-1.232 17.018 3.042.086 6.177.585 9.355 1.512a47.373 47.373 0 0 1 7.218 2.788 45.558 45.558 0 0 1 6.419 3.743c3.912 2.737 7.075 5.946 9.398 9.546.164-.107.335-.214.499-.32a5.465 5.465 0 0 0-.392.491c.028.043.057.086.078.136 1.219-.685 8.949-7.593 9.797-7.743-.035.057-.292.47-.335.542 1.019-.37 3-2.802 3.727-2.396.185-.128.506-.392.919-.748-3.05-3.864-4.104-8.691-2.636-13.989a22.485 22.485 0 0 1 1.396-3.671 22.022 22.022 0 0 1 2.024-3.423c4.389-6.045 10.972-7.913 17.983-5.874 1.24.363 2.501.84 3.755 1.454a24.467 24.467 0 0 1 3.342 1.946c5.977 4.185 8.628 10.517 6.612 17.753a22.22 22.22 0 0 1-1.411 3.722 22.707 22.707 0 0 1-1.995 3.38c-4.39 6.08-11.001 7.963-18.005 5.888a24.082 24.082 0 0 1-3.605-1.404 24.192 24.192 0 0 1-3.477-2.04 19.98 19.98 0 0 1-2.971-2.552 1165.843 1165.843 0 0 1-14.272 10.624c.52.94.983 1.91 1.397 2.901.114.264.228.528.335.792v.028c2.166 5.74 2.451 12.199.534 19.086-.648 2.339-1.553 4.72-2.715 7.144-.014.029-.035.064-.049.093.149.092.299.178.448.271-.05.107-.092.214-.142.313a45.036 45.036 0 0 1-1.055 2.047c-.156-.093-.32-.186-.477-.286a42.943 42.943 0 0 1-1.967 3.187c3.021 1.512 7.304 4.107 9.498 5.725-.335-.071-1.083-.37-1.86-.834l-.142.214c1.824 1.013 3.249 2.995 5.422 3.152 0 0-2.109-1.562-2.487-2.004l.029-.014-.014-.043c4.26 2.189 9.17 5.183 13.409 7.65l17.97-14.223 22.293 28.197-28.179 22.309-22.294-28.198.014.014Zm364.665 16.94c.498.421 0-65.421 0-65.421 31.592 11.001 68.499.563 68.499.563v64.58c-23.277 6.488-68.499.286-68.499.286v-.008ZM362.058 16.371v35.905c18.161-.463 32.183-4.428 32.183-4.428v64.581c-23.277 6.488-68.499.285-68.499.285.228.192.249-13.81.199-28.91-17.257-.493-32.383-2.575-32.383-2.575.499.421 0-65.421 0-65.421 31.592 11.001 68.5.563 68.5.563ZM103.05 218.154a32.17 32.17 0 0 1-5.059.414 32.17 32.17 0 0 1-5.265-.414c-9.47-1.554-16.21-7.508-17.97-17.133a29.36 29.36 0 0 1-.456-5.126c0-1.839.143-3.572.435-5.197 1.717-9.647 8.422-15.628 17.862-17.233a32.228 32.228 0 0 1 5.266-.442c1.76 0 3.448.129 5.058.385 9.448 1.512 16.196 7.472 17.963 17.161.299 1.626.456 3.366.456 5.198 0 1.811-.143 3.522-.421 5.133-1.703 9.689-8.422 15.7-17.876 17.261l.007-.007Zm31.813-58.263c-2.43-4.906-3.691-12.185-4.346-18.744-3.72.264-7.546.321-11.429.192-.691-.021-1.375-.042-2.073-.071h-.072l-.684-.043c-.185-.007-.363-.021-.548-.035-7.788-.478-15.283-1.754-22.237-3.872-.955 3.28-2.138 6.353-3.541 9.197-7.695 15.622-21.86 24.626-38.86 28.319-7.923 1.719-16.445 2.31-25.215 1.868-4.632-.235-9.142-.72-13.495-1.476-1.304 6.46-3.292 13.575-6.199 18.21l-36.872-9.155s7.061-11.151 8.144-24.519c-5.857-5.219-10.445-11.699-13.374-19.571-2.728-7.336-4.06-15.827-3.57-25.666.5-9.982 2.708-18.416 6.2-25.517 7.645-15.55 21.667-24.533 38.824-28.24 8.172-1.769 17.035-2.36 26.255-1.897 8.244.413 16.174 1.725 23.498 3.964l.022-.078h.014a57.883 57.883 0 0 1 3.534-9.133c.036-.079.078-.15.121-.221.392-.785.798-1.548 1.226-2.296 7.951-14.088 21.439-22.316 37.463-25.795.94-.207 1.888-.392 2.843-.564.926-.164 1.859-.313 2.807-.456 6.27-.92 12.846-1.198 19.565-.855 6.213.313 12.213 1.098 17.898 2.352 1.233.271 2.459.57 3.663.892l.733.192c.086.021.179.043.271.071.114.029.228.058.342.093.755.214 1.504.45 2.252.678.256.078.52.15.776.235 7.667 2.48 14.557 6.01 20.356 10.659a52.13 52.13 0 0 1 3.078 2.673 48.996 48.996 0 0 1 3.67 3.836c.292.342.577.684.862 1.04.192.236.378.478.57.714a53.34 53.34 0 0 1 1.61 2.181 49.357 49.357 0 0 1 5.665 10.887c2.764 7.415 4.111 16.028 3.612 26.01-.492 9.838-2.672 18.151-6.12 25.174-3.228 6.566-7.61 11.956-12.882 16.284-.563.463-1.14.906-1.725 1.348-.22.164-.434.328-.655.492-.257 13.41 5.65 25.224 5.65 25.224l-37.606 5.412-.021.007Zm89.718 40.717c-1.703 9.689-8.422 15.699-17.877 17.261-1.61.264-3.299.406-5.059.413-1.831 0-3.591-.135-5.265-.413-9.469-1.554-16.209-7.508-17.969-17.133a29.37 29.37 0 0 1-.456-5.126c0-1.832.142-3.572.434-5.197 1.718-9.647 8.422-15.629 17.863-17.233a32.112 32.112 0 0 1 5.265-.442c1.76 0 3.449.129 5.059.385 9.448 1.512 16.195 7.472 17.962 17.161.299 1.626.456 3.365.456 5.198a30.17 30.17 0 0 1-.42 5.133l.007-.007Z",
        mask: "url(#c)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#35243F",
        d: "M178.953-.348c-7.944-.014-15.689-1.098-23.256-2.445l-.107-1.448c.535 7.793 1.354 13.497 1.981 18.217h36.658c-.634-.55-1.275-1.098-1.902-1.655A311.884 311.884 0 0 1 178.953-.348Zm18.289 11.129v-.07c-.022-.507-.043-1.027-.064-1.548v-.171a227.748 227.748 0 0 1-.1-3.415c0-.121 0-.242-.007-.37l-.022-1.32c0-.2 0-.4-.007-.599 0-.399-.007-.798-.014-1.205V-.333c0-.92.014-1.826.036-2.731a40.672 40.672 0 0 1-4.696 1.362c-2.75.598-5.643 1.005-8.678 1.247l.37-.228h.015c-1.119-.007-2.323.136-1.846.285h-.249c1.347 1.348 2.273 2.282 2.608 2.688-.264-.228-2.316-1.989-2.644-2.267 2.038 2.239 6.391 6.324 10.488 9.91 1.66 1.469 3.278 2.86 4.653 4.043h.321a311.19 311.19 0 0 1-.164-3.202v.008Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#48245D",
        d: "M181.937.023c.328.278 2.38 2.039 2.644 2.267-.342-.406-1.269-1.333-2.608-2.688h.249c-.477-.15.727-.292 1.846-.285h-.015l-.37.228c3.035-.242 5.921-.649 8.678-1.247a40.67 40.67 0 0 0 4.696-1.362c.021-.877.049-1.74.085-2.602l-.484.192c-.478.185-.969.32-1.454.478-.962.335-1.952.57-2.921.805-3.912.927-7.788 1.29-11.329 1.412-.435.014-.869.029-1.297.036a430.203 430.203 0 0 1-6.726-6.916c-5.6-5.882-12.162-13.425-17.435-21.11-.028.37-.064.74-.092 1.118-.029.386-.05.785-.079 1.17.243.335.471.656.684.94.955 1.327 1.703 2.368 2.316 3.138-.755-.656-1.831-1.932-3.028-3.572 0 .071-.007.135-.014.207 4.488 6.43 9.782 12.783 15.582 19.014a409.898 409.898 0 0 0 5.757 6.01c-1.86-.02-3.584-.092-5.144-.156-5.337-.456-10.638-1.234-15.917-2.182.021.285.035.563.057.841.035.492.071.97.106 1.448 7.567 1.34 15.312 2.424 23.256 2.445a311.916 311.916 0 0 0 13.374 12.67c.627.556 1.268 1.105 1.902 1.654h2.858c-1.376-1.191-2.993-2.574-4.653-4.043-4.104-3.586-8.45-7.671-10.488-9.91h-.036Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#35243F",
        d: "M197.171 8.985c-.022-.556-.036-1.112-.057-1.69l-.043-1.725c.028 1.176.057 2.31.1 3.415Zm-.15-6.902c0 .407.007.806.014 1.205 0-.399-.007-.798-.014-1.204ZM372.866-38.79c-19.173 11.293-44.36 14.009-67.787 14.009h-65.001c-8.208 0-14.977 1.91-19.338 6.36-.484.491-.94 1.02-1.36 1.575-.214.278-.414.563-.613.863-2.152 3.244-3.342 7.479-3.342 12.847 0 4.25.884 10.702 1.404 16.056.035.357.071.706.1 1.056h-19.523a321.835 321.835 0 0 1-.164-3.202c.05 1.106.1 2.168.164 3.202.513 8.933 1.439 15.264 2.123 20.419h59.359c-.499-5.54-1.504-12.584-1.504-17.111 0-15.607 10.061-21.646 24.646-21.646h65.001c23.42 0 48.607-2.716 67.787-14.01a64.67 64.67 0 0 0 10.175-7.372v-92.749h-20.435v16.634c0 32.86-12.989 52.046-31.692 63.068ZM197.043 3.887c0 .45.014.884.021 1.32l-.021-1.32Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#48245D",
        d: "M383.126-107.549c0 8.691-1.632 15.386-4.752 20.37-1.561 2.488-3.492 4.555-5.786 6.216a23.495 23.495 0 0 1-3.705 2.203c-1.482.72-3.078 1.305-4.781 1.79-.869.25-1.767.47-2.693.663-3.178.649-6.676.963-10.481.963h-74.599c-.755 0-1.51 0-2.251.021-3.62.057-7.111.25-10.488.57-.385.036-.777.072-1.154.114l-.357.043-.79.086c-3.235.37-6.363.855-9.363 1.469-4.068.834-7.923 1.889-11.556 3.172-.513.178-1.019.37-1.525.556-.1.036-.207.079-.307.114-.306.114-.605.243-.912.364-6.483 2.567-12.219 5.889-17.178 9.939a60.552 60.552 0 0 0-2.173 1.86c-4.631 4.178-8.522 9.048-11.657 14.61-.106.184-.206.377-.313.57-.093.17-.192.342-.285.513-.257.47-.506.955-.748 1.433-3.064 6.067-5.294 12.883-6.655 20.433a94.92 94.92 0 0 0-.527 3.294c-.029.214-.064.42-.093.628a107.939 107.939 0 0 0-.869 9.874 156.42 156.42 0 0 0-.086 2.603c-.021.905-.035 1.81-.035 2.73V2.07c0 .406.007.806.014 1.205 0 .2 0 .4.007.599 0 .45.014.884.022 1.319a1907.277 1907.277 0 0 0 .049 2.096c.015.57.036 1.134.057 1.69v.17l.065 1.548v.071c.049 1.105.099 2.168.163 3.202h19.523c-.029-.35-.064-.7-.1-1.056-.52-5.354-1.403-11.814-1.403-16.056 0-5.361 1.189-9.596 3.341-12.847.193-.293.399-.585.613-.863a15.88 15.88 0 0 1 1.361-1.576c4.353-4.449 11.129-6.36 19.337-6.36h65.001c23.42 0 48.607-2.716 67.788-14.009 18.703-11.015 31.692-30.201 31.692-63.069v-16.626h-21.432v10.944h.021Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#35243F",
        stroke: "#35243F",
        d: "M78.564-67.346c6.518.516 13.329 1.303 20.446 2.368L89.568-2.562C66.492-5.657 49.39-4.285 37.425 1.862 25.46 8.01 18.722 18.886 16.243 34.575l-60.965-9.233c4.02-26.155 12.06-47.013 25.019-62.325 46.462 3.56 78.159-6.886 98.267-30.363Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#35243F",
        d: "M293.564 15.808s.499 65.85 0 65.422c0 0 15.127 2.074 32.384 2.573-.05-15.749-.171-32.675-.193-35.94v-.57a75.38 75.38 0 0 0 2.515.82 66.27 66.27 0 0 0 2.202.648c.634.178 1.268.35 1.909.506.157.043.314.079.471.122.677.17 1.361.328 2.037.484.093.022.179.036.271.058.627.135 1.247.27 1.874.392.135.028.271.057.406.078.691.135 1.382.257 2.066.378.1.014.2.036.3.05.634.107 1.268.207 1.895.3.107.014.214.035.321.05.698.099 1.403.192 2.101.284.093.015.193.022.285.036.67.078 1.333.157 1.995.221.057 0 .114.014.171.021.713.072 1.433.136 2.138.193.078 0 .164.014.242.021 1.447.114 2.879.2 4.304.264h.164c1.453.057 2.885.093 4.303.1h.064c1.447.007 2.872 0 4.275-.043V16.371s-36.907 10.431-68.5-.563Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#35243F",
        d: "M348.705 51.934c.078 0 .164.014.242.021-.078 0-.164-.014-.242-.021Zm-11.691-1.612c.135.029.27.058.406.079a8.538 8.538 0 0 0-.406-.079Zm-4.646-1.055c.157.043.314.079.47.121a11.683 11.683 0 0 1-.47-.12Zm-4.588-1.304c.164.05.328.1.485.15-.164-.05-.328-.1-.485-.15Zm2.507.748c.057.014.114.029.178.05-.057-.014-.114-.028-.178-.05Zm16.109 3.009c.057 0 .114.014.171.021-.057 0-.114-.014-.171-.021Zm-20.448 32.083c.049 15.1.028 29.104-.2 28.911 0 0 45.222 6.203 68.5-.285v-64.58s-14.029 3.964-32.184 4.427v28.668c-9.811 2.738-23.527 3.216-36.109 2.852l-.007.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#48245D",
        d: "M357.718 52.319c-1.418-.007-2.85-.043-4.304-.1h-.163a111.47 111.47 0 0 1-4.304-.264c-.078 0-.164-.014-.242-.021-.713-.057-1.425-.121-2.138-.193-.057 0-.114-.014-.171-.021a196.13 196.13 0 0 1-1.995-.221c-.092-.014-.192-.021-.285-.036a74.149 74.149 0 0 1-2.102-.285c-.106-.014-.213-.035-.32-.05a87.475 87.475 0 0 1-1.895-.3c-.1-.014-.2-.035-.3-.05a95.943 95.943 0 0 1-2.472-.455c-.627-.122-1.247-.257-1.874-.393-.093-.02-.178-.035-.271-.057a69.432 69.432 0 0 1-2.508-.606c-.634-.164-1.275-.328-1.909-.506-.057-.014-.114-.028-.178-.05-.677-.192-1.347-.392-2.024-.599-.164-.05-.328-.1-.484-.15a75.03 75.03 0 0 1-2.031-.67v.571c.021 3.265.143 20.198.192 35.94 12.583.364 26.299-.12 36.11-2.852V52.283c-1.404.036-2.829.05-4.275.043h-.064l.007-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#35243F",
        d: "M86.99 59.598c.192-.97.491-2.21.883-3.8.499-2.281 1.653-6.032 2.807-9.333 1.155-3.308 2.26-6.188 2.202-6.958-1.097 2.873-2.7 6.987-3.883 10.873-1.204 3.878-2.002 7.507-2.01 9.225v-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#35243F",
        d: "M69.927 69.016c5.037 2.91 9.504 6.46 13.266 10.688l.043-.4c1.104-9.667 2.772-18.936 5.215-27.427 2.409-8.499 5.658-16.177 9.356-22.715a86.304 86.304 0 0 1 2.671-4.406c-.954.17-1.902.356-2.842.563-16.017 3.486-29.512 11.714-37.464 25.795 2.658 5.069 5.337 10.117 8.144 15.093.528.941 1.076 1.868 1.618 2.802l-.007.007Zm61.146 17.233c.755 3.885 1.866 7.785 3.355 11.521.157-.085.307-.178.464-.264-1.219-3.065-2.501-7.436-3.285-11.764-.898-4.548-1.211-8.997-1.817-11.642.15 3.9.506 8.013 1.283 12.156v-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#35243F",
        d: "M137.307 33.418a141.891 141.891 0 0 0-7.353 9.468c-4.695 6.61-8.949 13.825-12.404 21.596-3.456 7.771-6.099 16.106-7.538 24.804a90.61 90.61 0 0 0-1.233 15.457c.135.007.271.014.406.028l1.532.093c.513.007 1.019-.028 1.525-.036.506-.028 1.011 0 1.51-.092 1.005-.136 1.995-.214 2.986-.435 6.384-1.184 12.027-3.479 16.366-5.804-.52-1.226-.962-2.495-1.432-3.757-.314-.827-.528-1.69-.791-2.538-.25-.856-.528-1.697-.706-2.574l-.598-2.602c-.185-.87-.307-1.754-.456-2.624-.335-1.74-.442-3.508-.641-5.24-.214-3.48-.3-6.902-.022-10.16.435-6.523 1.746-12.356 3.199-16.854-.399 1.84-1.596 6.373-2.28 11.592l.243.122c.762-6.025 2.629-12.07 5.001-17.739 2.394-5.675 5.23-11.015 8.408-15.8 0 0-.62.735-1.504 1.926a56.993 56.993 0 0 0-3.092 4.663c-1.076 1.81-2.144 3.736-2.928 5.447-.413.848-.791 1.618-1.105 2.267l-.691 1.568v-.078l-.085.15c1.539-4.021 3.398-8.078 5.835-11.957 1.618-2.595 3.499-5.112 5.686-7.407a69.887 69.887 0 0 0-.734-.193c-2.586 1.818-4.909 4.17-7.104 6.73v-.02Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#35243F",
        d: "M131.343 60.354c-.342 1.29-.862 3.187-1.126 5.183-.356 1.99-.413 4.064-.406 5.618l.249.05.193-3.28c.028-.784.157-1.554.221-2.131.071-.578.128-.963.149-.97l-.05-.035c.1-.079.307-.065.3-.528.662-3.33 1.019-4.934 1.09-5.397.064-.464-.257.192-.62 1.476v.014ZM66.27 67.07c-2.537-4.534-4.945-9.097-7.317-13.66a2.11 2.11 0 0 1-.122.22c-1.396 2.824-2.572 5.868-3.534 9.134.464.142.92.285 1.376.427a73.399 73.399 0 0 1 9.604 3.872l-.007.007Zm-3.49-8.634c.74 1.355 2.43 4.164 3.028 4.791-.72-1.647-4.774-8.384-3.028-4.79Zm54.72 1.397c1.503-2.866 2.743-5.105 3.969-7.329 1.246-2.21 2.493-4.413 4.203-7.072l-.178-.193c-1.126 1.804-3.463 5.376-5.272 8.634-1.831 3.244-3.164 6.132-2.843 6.203l.114-.236.007-.007Zm-1.825 4.577-.178-.22c-1.995 4.605-3.769 9.39-5.13 14.38l.2.228c1.332-4.898 3.177-9.91 5.108-14.387Zm29.569-36.867.05-.057c.164-.157.313-.306.456-.442a5.425 5.425 0 0 1-.342-.093c-.114.129-.228.264-.349.414l.178.178h.007Zm31.607 25.446c-.05 5.255-.428 10.901-.884 16.427-.869 11.072-2.75 21.574-3.747 27.834.513-2.26 1.054-4.549 1.475-6.895.484-2.331.847-4.712 1.246-7.115.699-4.813 1.333-9.732 1.71-14.73.392-4.998.727-10.06.77-15.136.028-2.16-.014-4.328-.107-6.488-.185-.242-.378-.478-.57-.713.1 2.167.135 4.449.107 6.823v-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#35243F",
        d: "M178.738 61.324c-.826 16.583-3.37 33.288-8.528 47.832a111.022 111.022 0 0 1-4.96 11.828l2.679-.399a37.628 37.628 0 0 0-.427 1.961c-.036.178-.064.356-.1.527a45.054 45.054 0 0 0-.249 1.612c-.014.121-.036.242-.05.363-.057.485-.1.97-.142 1.455.812.221 1.617.427 2.422.598-2.636-.27-2.337-.128-.342.286.05.007.107.021.157.028 5.272-4.327 9.661-9.71 12.882-16.284 3.448-7.023 5.629-15.343 6.12-25.175.499-9.981-.848-18.594-3.612-26.009a49.36 49.36 0 0 0-5.665-10.887c.114 4.086.022 8.185-.185 12.264Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#35243F",
        d: "M159.743 76.274c-2.807 4.264-5.978 8.185-9.362 11.757-3.356 3.586-7.09 6.802-11.023 9.461.022-.021.463-.4.962-.82.249-.214.499-.42.677-.592.185-.17.306-.285.313-.292a59.435 59.435 0 0 1-4.788 3.365c.171.378.342.763.506 1.141a65.376 65.376 0 0 0 2.565 4.734c3.684 6.082 8.408 11.172 13.595 14.901a43.595 43.595 0 0 0 3.584 2.317c.228-.035.463-.071.691-.1.812-.121 1.589-.235 2.344-.349.499-.071.983-.15 1.446-.214.271-.043.528-.078.784-.114.399-.791.77-1.604 1.161-2.396 1.048-2.074 1.874-4.249 2.786-6.388.428-1.076.805-2.181 1.212-3.265l.598-1.633c.192-.549.356-1.105.534-1.654l1.055-3.315.919-3.351.456-1.675.399-1.69.791-3.373.677-3.393.335-1.697.285-1.704c.192-1.134.377-2.274.57-3.408l.47-3.415.235-1.704.185-1.711c.129-1.14.25-2.275.378-3.408.798-9.098 1.361-18.188.812-27.022 0-.042-.007-.085-.007-.128a49.15 49.15 0 0 0-3.669-3.836c-.022 2.025-.235 4.022-.556 5.968-1.938 10.701-6.284 20.512-11.906 29.025l-.014-.022ZM129.035 66.6c-.064.37-.135.463-.164.826-.035.528.164 1.355.221 1.804 0-.314.079-1.02.107-1.625.029-.6.057-1.098-.157-1.006h-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#35243F",
        d: "M161.988 72.11a37.13 37.13 0 0 0 1.617-3.13c-1.689 2.19-5.472 9.34-1.617 3.13Zm-16.109-42.157c-2.473 2.816-4.56 6.039-6.37 9.44-3.577 6.837-6.17 14.33-7.439 22.023-.142.963-.342 1.918-.434 2.888l-.314 2.901c-.114 1.94-.278 3.872-.242 5.804-.05 1.932.107 3.85.199 5.76.221 1.904.378 3.8.741 5.662.271 1.875.763 3.7 1.183 5.518.535 1.79 1.026 3.586 1.71 5.297.207.62.449 1.227.698 1.826.15-.093.307-.186.456-.279 2.302-1.397 4.055-2.723 5.273-3.621.591-.47 1.054-.842 1.368-1.091.313-.25.47-.385.47-.385 1.974-1.676 3.798-3.53 5.572-5.433 1.788-1.89 3.434-3.907 5.03-5.953 1.589-2.054 3.05-4.2 4.453-6.388 1.361-2.21 2.651-4.456 3.805-6.78 0 0 .214-.4.563-1.148.349-.742.876-1.804 1.432-3.145a73.816 73.816 0 0 0 3.641-10.616c1.111-4.178 1.845-8.798 1.532-12.926-.014-.235-.05-.463-.071-.698-5.8-4.656-12.697-8.178-20.357-10.66-.256-.085-.52-.156-.776-.235a36.67 36.67 0 0 0-2.123 2.232v.007Zm23.683 18.944c.285-1.255.492-2.802.627-3.594.086-1.554.022-2.139-.043-2.103-.078.036-.149.692-.292 1.611-.235 1.84-.812 4.727-1.019 5.946.136.35.449-.606.72-1.86h.007Zm-68.458-21.689c.342-.663.513-.962.485-.97-.022-.007-.242.279-.592.835-.342.563-.869 1.369-1.46 2.424-1.226 2.096-2.807 5.169-4.425 8.905-1.61 3.743-3.199 8.177-4.567 12.926-2.743 9.51-4.375 20.276-5.272 28.953-.057.578-.114 1.14-.171 1.697 3.042 3.871 5.536 8.263 7.374 13.204a57.52 57.52 0 0 1 1.111 3.308c.036.029.072.05.1.079.812.584 1.632 1.183 2.515 1.704.435.263.855.556 1.311.798.45.243.905.478 1.361.72.45.257.92.464 1.397.663l1.418.613 1.467.499.734.25.748.185 1.504.371h.007c0-1.091 0-2.189.043-3.287.334-11.15 2.785-22.322 6.868-32.853 4.083-10.545 9.776-20.448 16.43-29.51 1.682-2.26 3.385-4.477 5.187-6.651 1.81-2.168 3.741-4.285 5.943-6.16l.128-.107c-5.693-1.262-11.685-2.047-17.898-2.353-6.719-.335-13.295-.064-19.565.855a84.573 84.573 0 0 0-3.798 5.975c.705-1.419 1.275-2.403 1.617-3.066v-.007Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#48245D",
        d: "M175.076 72.267c-.128 1.134-.249 2.275-.377 3.409l-.186 1.71-.235 1.705c-.157 1.133-.313 2.274-.47 3.415-.185 1.133-.378 2.267-.57 3.408l-.285 1.704-.335 1.697-.677 3.393-.791 3.373-.399 1.69-.456 1.675-.919 3.351-1.054 3.315c-.178.549-.342 1.112-.535 1.654l-.598 1.633c-.406 1.09-.784 2.188-1.211 3.265-.912 2.139-1.739 4.313-2.786 6.388-.392.799-.763 1.604-1.162 2.396.285-.043.556-.086.827-.122.349-.663.719-1.361 1.097-2.117.413-1.005.613-.934.784-1.098.028-.093.021-.135-.022-.078 0 0 .036-.057.086-.15.05-.1.121-.243.214-.421.164-.37.392-.905.662-1.54.528-1.283 1.304-2.959 1.91-4.727 1.346-3.479 2.394-7.136 2.515-7.4l.214.171c-.52 1.775-1.083 3.857-1.91 5.996-.399 1.069-.784 2.189-1.247 3.287-.477 1.09-.954 2.196-1.432 3.294-.456 1.105-1.033 2.153-1.546 3.186-.264.507-.513 1.013-.769 1.512.37-.057.719-.107 1.054-.157.128-.257.257-.513.378-.77l.142.292-.214.428c.157-.021.3-.043.449-.064a109.559 109.559 0 0 0 4.959-11.828c5.159-14.544 7.702-31.25 8.529-47.833.199-4.078.299-8.177.185-12.263a45.124 45.124 0 0 0-1.61-2.181c.093 2.16.135 4.327.107 6.488-.043 5.083-.371 10.145-.77 15.136-.384 4.998-1.011 9.917-1.71 14.73-.399 2.395-.762 4.784-1.247 7.115-.42 2.346-.969 4.634-1.474 6.894.997-6.26 2.878-16.768 3.747-27.834.463-5.525.834-11.172.884-16.426a118.14 118.14 0 0 0-.107-6.823c-.285-.35-.57-.7-.862-1.041 0 .042.007.085.007.128.549 8.834-.014 17.917-.812 27.021l.028.014Zm-6.462 40.311c-.292.813-.442.999-.812 1.804-.3.157.163-.919.627-2.274.484-1.34 1.097-2.902 1.332-3.608-.285 1.02-.72 2.916-1.147 4.078Zm-.941-60.338a74.31 74.31 0 0 1-3.641 10.616c-.562 1.34-1.083 2.403-1.432 3.145-.342.741-.563 1.147-.563 1.147-1.154 2.318-2.451 4.57-3.804 6.78-1.404 2.182-2.865 4.328-4.453 6.389-1.596 2.046-3.249 4.057-5.031 5.953-1.774 1.904-3.598 3.757-5.571 5.433 0 0-.157.142-.471.385-.313.25-.776.613-1.368 1.09-1.218.906-2.964 2.225-5.272 3.623-.15.092-.307.185-.456.278.292.706.605 1.397.912 2.089a59.741 59.741 0 0 0 4.788-3.366s-.136.122-.314.293c-.178.17-.434.378-.677.591-.491.421-.933.799-.961.82 3.933-2.659 7.673-5.874 11.022-9.46a84.976 84.976 0 0 0 9.362-11.757c5.622-8.513 9.975-18.316 11.906-29.025a38.45 38.45 0 0 0 .556-5.968 55.617 55.617 0 0 0-3.078-2.673c.021.235.057.463.071.699.314 4.128-.42 8.748-1.532 12.925l.007-.007Zm-5.685 19.87c-3.855 6.21-.065-.94 1.617-3.13a38.858 38.858 0 0 1-1.617 3.13Zm8.165-28.91c.057-.036.128.542.043 2.103-.136.792-.35 2.346-.627 3.594-.278 1.254-.585 2.21-.72 1.86.207-1.226.784-4.106 1.019-5.946.142-.92.214-1.575.292-1.611h-.007ZM88.45 51.877c-2.444 8.491-4.111 17.76-5.215 27.428l-.043.399a48.92 48.92 0 0 1 1.902 2.281c.057-.556.114-1.12.171-1.697.898-8.676 2.53-19.45 5.273-28.953 1.368-4.748 2.95-9.183 4.567-12.926 1.617-3.736 3.199-6.809 4.424-8.905.592-1.062 1.119-1.868 1.461-2.424.349-.563.57-.841.592-.834.028.007-.143.306-.485.97-.342.662-.912 1.646-1.617 3.065a86.36 86.36 0 0 1 3.797-5.974 74.35 74.35 0 0 0-2.807.456 85.949 85.949 0 0 0-2.672 4.406c-3.698 6.538-6.947 14.216-9.355 22.715l.007-.007Zm2.23-5.412c-1.154 3.309-2.308 7.052-2.807 9.333-.392 1.59-.691 2.83-.883 3.8.007-1.718.812-5.347 2.009-9.225 1.183-3.886 2.786-7.993 3.883-10.873.057.763-1.055 3.65-2.202 6.958v.007Zm21.988 82.747a78.014 78.014 0 0 1-3.071-13.24 82.354 82.354 0 0 1-.762-8.755c.399.029.79.057 1.182.078.314.015.627.05.941.043l.933-.028c.62-.029 1.247-.015 1.86-.079 2.494-.249 4.816-.72 7.161-1.312 2.337-.598 4.638-1.383 6.932-2.302a53.578 53.578 0 0 0 6.227-3.002c-.149-.335-.313-.656-.456-.991-.178-.37-.349-.749-.506-1.134-4.339 2.325-9.989 4.62-16.366 5.804-.99.221-1.98.299-2.985.435-.499.085-1.005.064-1.511.092-.505.008-1.018.05-1.524.036l-1.532-.093c-.136-.007-.271-.021-.406-.028a90.712 90.712 0 0 1 1.232-15.457c1.432-8.698 4.083-17.033 7.539-24.804 3.455-7.771 7.709-14.987 12.404-21.596a141.563 141.563 0 0 1 7.353-9.468c2.188-2.56 4.517-4.905 7.104-6.73a94.78 94.78 0 0 0-3.662-.891c-.043.035-.086.07-.129.107-2.208 1.875-4.132 4-5.942 6.16-1.803 2.167-3.505 4.391-5.187 6.651-6.662 9.07-12.348 18.965-16.43 29.51-4.083 10.53-6.534 21.703-6.869 32.853a83.783 83.783 0 0 0-.042 3.287h-.008l-1.503-.371-.748-.185-.734-.25-1.468-.499-1.418-.613a12.374 12.374 0 0 1-1.396-.663l-1.36-.72c-.45-.242-.877-.535-1.312-.798-.876-.514-1.696-1.113-2.515-1.704-.036-.029-.071-.05-.1-.079.357 1.17.67 2.367.955 3.593 1.41.899 2.85 1.704 4.31 2.403 2.373 1.148 4.86 1.882 7.332 2.374.285 9.183 1.988 18.217 5.294 26.594 1.112 2.702 2.508 5.34 4.232 7.735.186.015.364.029.549.036a37.958 37.958 0 0 1-1.382-2.06c-2.622-4.357-4.111-8.941-5.023-12.313l-.599-2.303c-.171-.685-.285-1.283-.399-1.775l-.335-1.533c.428 1.64.841 3.287 1.361 4.926a60.26 60.26 0 0 0 1.66 4.913c1.24 3.251 2.8 6.466 4.881 9.382.192.271.392.535.598.799.691.035 1.383.05 2.074.071-.064-.078-.136-.143-.193-.221-2.835-3.458-4.788-7.614-6.227-11.914l-.014.029Zm7.559-75.346c1.81-3.251 4.147-6.83 5.273-8.634l.178.193c-1.71 2.659-2.957 4.862-4.204 7.072-1.225 2.225-2.465 4.463-3.968 7.33l-.114.235c-.314-.072 1.011-2.96 2.843-6.203l-.008.007Zm-4.738 10.324.178.22c-1.93 4.478-3.776 9.49-5.108 14.388l-.2-.228c1.361-4.99 3.135-9.774 5.13-14.38Zm-12.953 40.147c-.37-.114-.577-.214-.705-.314-.257-.207-.235-.371-.677-.72.719.392 3.527 1.305 2.878 1.29l.235.1c-.826-.064-1.353-.249-1.731-.349v-.007Zm4.346 8.684c-.263-1.804-.32-3.223-.377-4.193-.007-.976.021-1.518.078-1.582.114-.129.235 1.639.527 5.575l.022.178-.25.014v.008ZM69.926 69.016a562.81 562.81 0 0 1-1.617-2.802c-2.807-4.976-5.486-10.031-8.144-15.093a53.76 53.76 0 0 0-1.225 2.296c2.372 4.563 4.787 9.126 7.317 13.66a63.866 63.866 0 0 1 3.662 1.947l.007-.008Zm-4.118-5.796c-.606-.627-2.294-3.437-3.028-4.791-1.746-3.593 2.315 3.137 3.028 4.791Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#48245D",
        d: "m133.622 46.251.093-.15v.08c.164-.364.399-.906.691-1.57.314-.648.691-1.418 1.105-2.267.783-1.704 1.852-3.636 2.928-5.447a56.958 56.958 0 0 1 3.092-4.662c.884-1.191 1.504-1.925 1.504-1.925-3.178 4.784-6.014 10.124-8.408 15.799-2.373 5.668-4.239 11.714-5.002 17.738l-.242-.12c.684-5.22 1.881-9.754 2.28-11.594-1.453 4.5-2.757 10.331-3.199 16.855-.278 3.258-.192 6.68.021 10.16.2 1.732.307 3.493.642 5.24.156.87.27 1.754.456 2.623l.598 2.603c.178.87.456 1.718.705 2.574.264.848.478 1.71.791 2.538.471 1.262.912 2.53 1.432 3.757.164.378.328.763.506 1.134.15.335.307.663.456.991a43.144 43.144 0 0 0 1.824 3.614 54.821 54.821 0 0 0 2.608 4.221 53.39 53.39 0 0 0 5.771 7.087 47.479 47.479 0 0 0 5.829 5.069c-.129-.228-1.39-1.112-2.622-2.21-.635-.535-1.226-1.148-1.732-1.69-.484-.563-.855-1.069-.99-1.426 2.764 2.895 5.928 5.369 9.184 7.387.969-.143 1.917-.286 2.836-.421a40.767 40.767 0 0 1-3.584-2.317c-5.187-3.729-9.911-8.819-13.595-14.901a61.437 61.437 0 0 1-2.565-4.734 55.475 55.475 0 0 0-.506-1.14c-.306-.692-.619-1.384-.912-2.09a27.164 27.164 0 0 1-.698-1.825c-.684-1.711-1.168-3.508-1.71-5.297-.42-1.826-.912-3.644-1.183-5.519-.363-1.86-.527-3.764-.741-5.66-.092-1.911-.249-3.83-.199-5.761-.043-1.933.128-3.865.242-5.804l.314-2.902c.092-.97.299-1.925.434-2.887 1.269-7.693 3.855-15.186 7.439-22.023 1.81-3.401 3.897-6.624 6.37-9.44a36.67 36.67 0 0 1 2.123-2.232 74.296 74.296 0 0 0-2.252-.677 13.84 13.84 0 0 1-.456.442l-.05.057-.178-.178c.121-.15.235-.285.349-.414-.085-.021-.178-.043-.27-.071-2.181 2.296-4.069 4.813-5.686 7.408-2.437 3.885-4.296 7.935-5.835 11.956l-.008.021Zm-4.424 21.36c-.029.6-.107 1.305-.107 1.626-.057-.449-.249-1.283-.221-1.803.029-.364.1-.457.164-.828.221-.092.185.407.157 1.006h.007Zm10.466 41.973c-.399-.349-.79-.92-1.161-1.512-.356-.598-.67-1.219-.955-1.654.164-.092.834.799 1.418 1.647.584.849 1.055 1.669.698 1.519Zm-8.065-23.849c.784 4.328 2.066 8.698 3.285 11.764.064.164.128.335.192.492.242.52.499 1.055.755 1.59 1.247 2.567 2.679 5.205 4.275 7.693.955 1.504 1.988 2.93 3.007 4.271 1.047 1.319 2.08 2.566 3.114 3.643.356.392.755.784 1.175 1.183.413.414.855.827 1.34 1.248-5.28-4.057-10.218-10.402-13.445-17.724a50.49 50.49 0 0 1-.599-1.419c-.099-.235-.192-.478-.285-.713-1.489-3.729-2.6-7.636-3.356-11.522-.776-4.142-1.132-8.256-1.282-12.156.598 2.646.912 7.095 1.817 11.643l.007.007Zm.363-26.857c-.071.463-.42 2.068-1.09 5.397.007.464-.199.442-.299.528l.05.035s-.079.385-.15.97c-.057.577-.192 1.347-.221 2.132l-.192 3.28-.249-.05c-.008-1.555.049-3.637.406-5.619.263-1.996.783-3.9 1.125-5.183.364-1.283.684-1.94.62-1.476v-.014Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#35243F",
        d: "M93.459 137.325a45.18 45.18 0 0 1-1.425-.449 72.597 72.597 0 0 1-6.042-2.253 62.083 62.083 0 0 1-2.886-1.304 69.158 69.158 0 0 1-2.793-1.426c-10.523-5.704-18.824-14.11-23.52-25.574-.206-.499-.398-1.006-.59-1.512a56.423 56.423 0 0 1-2.473-8.748 60.143 60.143 0 0 1-.755-4.763c-.456-3.807-.592-7.85-.378-12.156.3-5.981 1.218-11.4 2.658-16.312-7.332-2.239-15.255-3.55-23.499-3.964-9.22-.464-18.083.128-26.255 1.896C-11.656 64.468-25.68 73.458-33.323 89c-3.492 7.102-5.7 15.529-6.2 25.518-.49 9.839.842 18.33 3.57 25.666 2.929 7.871 7.517 14.352 13.374 19.571 0-.078.014-.157.021-.235.043-.549.072-1.098.093-1.654 0-.121.014-.235.014-.357.022-.656.022-1.311.008-1.975 0-.121-.008-.249-.015-.37a31.844 31.844 0 0 0-.085-1.633l-.043-.542a31.428 31.428 0 0 0-.228-1.989s37.542 9.575 37.356 9.276v.071c0 .043-.007.1-.014.171v.029c0 .071-.014.164-.021.263 0 .029 0 .05-.007.079-.008.107-.022.221-.036.349 0 .029 0 .057-.007.086-.014.142-.029.299-.05.47v.029c-.021.171-.036.356-.057.556 0 .028 0 .057-.007.085-.021.2-.043.407-.071.628 0 .043-.008.085-.015.135-.028.221-.05.449-.078.685 0 .057-.014.107-.021.164-.029.242-.064.499-.093.755 0 .05-.014.1-.021.157-.036.278-.072.556-.114.849a.637.637 0 0 1-.015.114c-.035.285-.078.577-.12.877 0 .043-.015.078-.015.121-.043.314-.093.627-.135.955-.008.065-.022.129-.029.193-.05.321-.1.649-.15.984-.014.071-.02.142-.035.214-.05.335-.107.677-.164 1.026a1.84 1.84 0 0 1-.036.193c-.057.363-.12.727-.185 1.098-.007.05-.021.107-.028.157-.065.363-.129.734-.2 1.105 0 .035-.014.071-.021.1-.072.392-.15.784-.221 1.183-.014.057-.021.121-.036.178l-.17.863c4.353.756 8.87 1.241 13.494 1.476 8.77.442 17.292-.15 25.215-1.868 17.008-3.686 31.165-12.691 38.86-28.319 1.404-2.845 2.58-5.911 3.541-9.197.328-1.134.627-2.303.905-3.494a62.925 62.925 0 0 1-.912 3.508l-.014.021Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#48245D",
        d: "M52.605 79.147c-.214 4.307-.078 8.35.378 12.157a60.226 60.226 0 0 0 .755 4.763 56.211 56.211 0 0 0 2.472 8.747c.193.514.385 1.013.591 1.512 4.696 11.464 12.996 19.87 23.52 25.574A65.93 65.93 0 0 0 86 134.63a75.19 75.19 0 0 0 6.042 2.253c.47.157.947.3 1.425.449.335-1.14.634-2.31.912-3.507.05-.214.1-.435.142-.656a72.775 72.775 0 0 0 .734-3.886 64.059 64.059 0 0 0 .513-3.928c.036-.35.064-.699.1-1.056.078-.905.15-1.818.2-2.752 0-.099.014-.199.02-.306v-.057c.357-7.03-.213-13.382-1.545-19.115a60.129 60.129 0 0 0-.955-3.593 52.91 52.91 0 0 0-1.112-3.308c-1.838-4.941-4.332-9.326-7.374-13.204a48.92 48.92 0 0 0-1.902-2.282c-3.762-4.228-8.23-7.778-13.267-10.687a61.698 61.698 0 0 0-3.662-1.947 70.724 70.724 0 0 0-9.605-3.87c-.456-.15-.912-.293-1.375-.429h-.014c-.007.029-.014.05-.022.079-1.439 4.912-2.358 10.33-2.657 16.312l.007.007Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#d)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#1D2125",
        d: "M58.287-54H477.02v400.9H58.287z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        fill: "#303134",
        clipPath: "url(#e)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M101 31h342v8H101zM91 51h352v8H91zm0 21h161v8H91z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        filter: "url(#f)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#g)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: 313.252,
        height: 18.265,
        x: 40,
        y: 23.171,
        fill: "#22272B",
        rx: 2.74
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        fill: "#505258",
        fillRule: "evenodd",
        clipPath: "url(#h)",
        clipRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M49.537 28.762a.792.792 0 0 0-.809.001.824.824 0 0 0-.403.715v1.095l1.337.79c.329.194.53.552.53.94v2.825a1.1 1.1 0 0 1-.062.366l1.795-1.062a.83.83 0 0 0 .404-.717v-2.824a.833.833 0 0 0-.404-.717l-2.388-1.412Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M49.94 35.13a.824.824 0 0 1-.404.715h.001a.792.792 0 0 1-.809.002l-2.387-1.413a.833.833 0 0 1-.405-.717v-2.825a.83.83 0 0 1 .404-.716l1.795-1.062c-.04.116-.062.24-.062.366v2.825c0 .388.201.745.53.939l1.337.791v1.094Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M49.537 28.762a.792.792 0 0 0-.809.001.824.824 0 0 0-.403.715v1.095l1.337.79c.329.194.53.552.53.94v2.825a1.1 1.1 0 0 1-.062.366l1.795-1.062a.83.83 0 0 0 .404-.717v-2.824a.833.833 0 0 0-.404-.717l-2.388-1.412Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M49.94 35.13a.824.824 0 0 1-.404.715h.001a.792.792 0 0 1-.809.002l-2.387-1.413a.833.833 0 0 1-.405-.717v-2.825a.83.83 0 0 1 .404-.716l1.795-1.062c-.04.116-.062.24-.062.366v2.825c0 .388.201.745.53.939l1.337.791v1.094Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#454F59",
        d: "M55.525 29.792h21.919v5.023H55.525z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#A6C5E2",
        fillOpacity: 0.16,
        d: "M82.924 27.738h.457v9.133h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#9FADBC",
        d: "M89.545 31.961h2.969v-2.853h.684V35.5h-.684v-2.853h-2.97V35.5h-.684v-6.392h.685v2.853Zm5.465.721c.213 0 .399.031.555.093a.822.822 0 0 1 .363.259c.085.11.128.239.128.388v.004a.559.559 0 0 1-.278.496.809.809 0 0 1-.27.108v.014a.837.837 0 0 1 .481.189.53.53 0 0 1 .177.417v.003a.741.741 0 0 1-.14.452.882.882 0 0 1-.396.294 1.672 1.672 0 0 1-.614.101 1.44 1.44 0 0 1-.577-.107.935.935 0 0 1-.391-.303.877.877 0 0 1-.165-.463l-.002-.024h.748l.003.022a.27.27 0 0 0 .06.135c.032.04.075.073.13.097a.483.483 0 0 0 .192.035.45.45 0 0 0 .19-.037.3.3 0 0 0 .122-.104.278.278 0 0 0 .043-.152v-.003a.233.233 0 0 0-.107-.208.56.56 0 0 0-.312-.072h-.275V33.8h.275c.082 0 .151-.01.208-.031a.289.289 0 0 0 .13-.09.231.231 0 0 0 .046-.144v-.003a.25.25 0 0 0-.152-.242.389.389 0 0 0-.172-.036c-.07 0-.13.013-.182.037a.286.286 0 0 0-.12.102.325.325 0 0 0-.054.151l-.002.017h-.707l.002-.027a.858.858 0 0 1 .153-.452.879.879 0 0 1 .366-.294 1.31 1.31 0 0 1 .544-.106Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#9FADBC",
        fillRule: "evenodd",
        d: "m99.834 31.377 1.812 1.813 1.813-1.813.484.484-2.055 2.055a.342.342 0 0 1-.484 0l-2.055-2.055.484-.484Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#A6C5E2",
        fillOpacity: 0.16,
        d: "M109.865 27.738h.457v9.133h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        stroke: "#9FADBC",
        strokeLinejoin: "round",
        strokeWidth: 1.027,
        d: "M119.797 32.304c.788 0 1.427-.553 1.427-1.341 0-.789-.639-1.342-1.427-1.342h-2.112v2.683m2.112 0h.457c.788 0 1.427.553 1.427 1.341 0 .788-.639 1.342-1.427 1.342h-2.569v-2.683m2.112 0h-2.112"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#9FADBC",
        fillRule: "evenodd",
        d: "M133.154 29.108h2.968v.684h-1.1l-1.205 5.023h1.163v.685h-2.968v-.684h1.1l1.206-5.024h-1.164v-.684Zm8.233 2.269 1.813 1.813 1.813-1.813.484.484-2.055 2.055a.342.342 0 0 1-.484 0l-2.055-2.055.484-.484Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#A6C5E2",
        fillOpacity: 0.16,
        d: "M151.419 27.738h.457v9.133h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        stroke: "#9FADBC",
        strokeLinejoin: "round",
        strokeWidth: 0.685,
        d: "M159.067 33.674v-.171l.586-1.541m3.296 1.712v-.171l-.583-1.541m0 0-1.121-2.969h-.465l-1.127 2.969m2.713 0h-2.713"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        stroke: "#9FADBC",
        strokeWidth: 1.37,
        d: "M164.662 35.272h-7.307"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#9FADBC",
        fillRule: "evenodd",
        d: "m168.329 31.377 1.812 1.813 1.813-1.813.484.484-2.055 2.055a.342.342 0 0 1-.484 0l-2.055-2.055.485-.484Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        stroke: "#9FADBC",
        strokeLinejoin: "round",
        strokeWidth: 0.685,
        d: "m183.269 31.048-.57 1.598.285.286m.285-1.884 2.829-1.975a.286.286 0 0 1 .366.032l.575.575a.285.285 0 0 1 .032.366l-1.975 2.829m-1.827-1.827 1.827 1.827m0 0-1.598.57-.286-.285m-.228-.228-.514.514.229.228.513-.514m-.228-.228.228.228"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        stroke: "#B6C2CF",
        strokeWidth: 1.37,
        d: "M188.407 35.272h-7.306"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#9FADBC",
        fillRule: "evenodd",
        d: "m192.074 31.377 1.812 1.813 1.813-1.813.484.484-2.054 2.055a.343.343 0 0 1-.485 0l-2.055-2.055.485-.484Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#A6C5E2",
        fillOpacity: 0.16,
        d: "M202.105 27.738h.457v9.133h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#9FADBC",
        fillRule: "evenodd",
        d: "M214.891 30.25h-6.392v-.686h6.392v.685Zm0 2.397h-6.392v-.685h6.392v.685Zm-3.196 2.397h-3.196v-.685h3.196v.685Zm7.32-3.667 1.813 1.813 1.812-1.813.485.484-2.055 2.055a.342.342 0 0 1-.484 0l-2.055-2.055.484-.484Zm14.142-1.47a.57.57 0 1 1 1.141-.001.57.57 0 0 1-1.141 0Zm6.393.342h-4.567v-.685h4.567v.685Zm-6.393 2.055a.57.57 0 1 1 1.141 0 .57.57 0 0 1-1.141 0Zm6.393.342h-4.567v-.684h4.567v.684Zm-6.393 2.055a.57.57 0 1 1 1.14 0 .57.57 0 0 1-1.14 0Zm6.393.343h-4.567v-.685h4.567v.685Zm4.123-3.667 1.813 1.813 1.813-1.813.484.484-2.055 2.055a.342.342 0 0 1-.484 0l-2.055-2.055.484-.484Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#A6C5E2",
        fillOpacity: 0.16,
        d: "M253.705 27.738h.457v9.133h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#9FADBC",
        fillRule: "evenodd",
        d: "M263.395 29.664a1.795 1.795 0 1 1 2.539 2.54l-1.028 1.027-.484-.484 1.027-1.028a1.11 1.11 0 1 0-1.57-1.57l-1.027 1.027-.485-.484 1.028-1.028Zm1.397 1.626-2.511 2.512-.485-.484 2.512-2.512.484.484Zm-4.137 1.114 1.027-1.027.485.484-1.028 1.028a1.11 1.11 0 1 0 1.571 1.57l1.027-1.027.484.484-1.027 1.027a1.795 1.795 0 1 1-2.539-2.539Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#A6C5E2",
        fillOpacity: 0.16,
        d: "M272.427 23.171h.457v18.265h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#9FADBC",
        fillRule: "evenodd",
        d: "M278.364 30.078c0-.662.536-1.199 1.198-1.199h4.909a1.2 1.2 0 0 1 1.199 1.199v3.767a1.2 1.2 0 0 1-1.199 1.199h-4.076l-1.519.868a.343.343 0 0 1-.512-.297v-5.537Zm1.198-.514a.514.514 0 0 0-.513.514v4.946l1.165-.665h4.257c.284 0 .514-.23.514-.514v-3.767a.514.514 0 0 0-.514-.514h-4.909Zm4.282 2.055h-3.654v-.685h3.654v.685Zm-1.37 1.37h-2.284v-.685h2.284v.685Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#454F59",
        d: "M288.41 29.793h21.919v5.023H288.41z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#A6C5E2",
        fillOpacity: 0.16,
        d: "M315.808 23.171h.457v18.265h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#9FADBC",
        fillRule: "evenodd",
        d: "M321.744 32.304a.685.685 0 1 1 1.37 0 .685.685 0 0 1-1.37 0Zm2.968 0a.685.685 0 1 1 1.37 0 .685.685 0 0 1-1.37 0Zm2.968 0a.685.685 0 1 1 1.37 0 .685.685 0 0 1-1.37 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#A6C5E2",
        fillOpacity: 0.16,
        d: "M334.529 23.171h.457v18.265h-.457z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#9FADBC",
        d: "M342.91 28.65a.628.628 0 0 0-.579.872l.041.08.377.628v1.587a2.22 2.22 0 0 0-.541.279c-.419.297-.829.823-.829 1.692 0 .19.153.343.342.343h2.055v1.826h.685V34.13h2.055a.343.343 0 0 0 .343-.342c0-.869-.411-1.395-.83-1.692a2.25 2.25 0 0 0-.54-.28V30.23l.376-.628a.628.628 0 0 0-.538-.951h-2.417Zm1.942 1.309a.34.34 0 0 0-.048.176v1.94c0 .168.121.311.286.339h.004l.03.007a1.552 1.552 0 0 1 .509.234c.211.15.428.39.508.79h-4.045c.08-.4.297-.64.508-.79a1.556 1.556 0 0 1 .51-.234l.03-.007h.003a.342.342 0 0 0 .287-.338v-1.941a.342.342 0 0 0-.049-.176l-.374-.623h2.215l-.374.623Z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#CECFD2",
        d: "M143.186 68.735c.141 0 .586 3.665.305 5.157.482.302.897 1.064.875 1.858 2.034 1.56.772-2.411.352-3.645-.342.828-.07-1.266-.333-1.589.016.178-.352-3.375-1.016-2.393-.085-.11-.354.712-.185.61l.002.002Zm-7.937 3.73c.135.784-.204 1.446-.751 2.075.334 2.71 2.44-1.575 2.936-2.62 0 0 .912-1.817.922-1.593.352-.138 2.323-2.659 1.016-2.603-.373.393-.718 1.363-1.123 1.35-.904.194-1.934 2.682-2.999 3.395l-.001-.004Zm-6.428-7.115c-.435 1.7 2.805.443 4.076.388 0 0 1.318.014 1.68-.215-.191-.002 4.487-.226 2.034-1.145-.066.023-1.686.097-1.686.097-2.117-.528-4.351.11-6.106.877l.002-.002Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#669DF1",
        fillOpacity: 0.14,
        d: "M314 47.745H147.042v14.637H314z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M137.436 45h17.153v18.297h-17.153z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        filter: "url(#i)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#1F1F21",
        d: "M149.798 43.71a6.006 6.006 0 0 0-3.969 1.339 6.026 6.026 0 0 0-3.968-1.338h-1.143v3.43h1.143c1.613 0 2.116.801 2.287 1.144v4.506h-1.143v3.43h1.143v3.431c-.148.343-.651 1.143-2.287 1.143h-1.143v3.431h1.143a6.026 6.026 0 0 0 3.968-1.338 5.965 5.965 0 0 0 3.969 1.338h1.143v-3.43h-1.143c-1.613 0-2.116-.8-2.288-1.144v-3.43h1.213V52.79h-1.144v-4.506c.149-.343.652-1.143 2.287-1.143h1.144V43.71h-1.212Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#CECFD2",
        d: "M149.798 45.998v-1.143a4.574 4.574 0 0 0-3.969 1.875 4.574 4.574 0 0 0-3.968-1.875v1.143a3.213 3.213 0 0 1 3.431 2.104v5.832h-1.144v1.144h1.144v4.757a3.234 3.234 0 0 1-3.431 2.104v1.144a4.635 4.635 0 0 0 3.968-1.864 4.636 4.636 0 0 0 3.969 1.864v-1.144a3.225 3.225 0 0 1-3.362-2.104v-4.769h1.143v-1.143h-1.143v-5.81a3.211 3.211 0 0 1 3.362-2.115Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#fff",
        d: "M0 0h477v81H0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "b"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#fff",
        d: "M-259-118.5h684v385h-684z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "d"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: 419.213,
        height: 220.555,
        x: 58.287,
        y: -54,
        fill: "#fff",
        rx: 5.243
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "e"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#fff",
        d: "M31.03-25.464a3.932 3.932 0 0 1 3.932-3.932h487.581v374.861H31.03V-25.464Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "g"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: 313.252,
        height: 18.265,
        x: 40,
        y: 23.171,
        fill: "#fff",
        rx: 2.74
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "h"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#fff",
        d: "M45.48 28.65h7.306v7.307H45.48z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("filter", {
        id: "f",
        width: 324.211,
        height: 29.225,
        x: 34.52,
        y: 21.345,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", {
        dy: 3.653
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
        stdDeviation: 2.74
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0156863 0 0 0 0.36 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_13247_134475"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
        stdDeviation: 0.228
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0156863 0 0 0 0.5 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
        in2: "effect1_dropShadow_13247_134475",
        result: "effect2_dropShadow_13247_134475"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_13247_134475",
        result: "shape"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feMorphology", {
        in: "SourceAlpha",
        radius: 0.457,
        result: "effect3_innerShadow_13247_134475"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feComposite", {
        in2: "hardAlpha",
        k2: -1,
        k3: 1,
        operator: "arithmetic"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.737255 0 0 0 0 0.839216 0 0 0 0 0.941176 0 0 0 0.12 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
        in2: "shape",
        result: "effect3_innerShadow_13247_134475"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("filter", {
        id: "i",
        width: 14.866,
        height: 25.095,
        x: 138.431,
        y: 42.565,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", {
        dy: 1.144
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
        stdDeviation: 1.144
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_13247_134475"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect1_dropShadow_13247_134475",
        result: "shape"
    }))));
const $3faf0024169aae07$var$NewToolbarBannerImageLight = ({ title: title, titleId: titleId, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "auto",
        height: "56px",
        viewBox: "0 0 477 56",
        fill: "none",
        "aria-labelledby": titleId,
        ...props
    }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#eed7fc",
        d: "M-68.35-100.55c.706 3.65 1.105 7.55 1.162 11.67.057 4.072-.228 7.922-.826 11.544-3.285 19.991-16.117 33.138-34.55 38.086-.142.036-.292.079-.434.114-.613.157-1.226.307-1.853.45-.192.042-.392.092-.584.135q-1.152.247-2.337.463a69 69 0 0 1-8.422.949q-1.452.076-2.935.1a74 74 0 0 1-5.059-.115q-.641-.03-1.282-.07a71 71 0 0 1-5.508-.607 56 56 0 0 1-2.23-.385 15 15 0 0 1-.549-.114 67 67 0 0 1-1.717-.364 11 11 0 0 1-.47-.114 42 42 0 0 1-1.91-.492q-.087-.021-.164-.042c-12.141-3.366-21.823-10.374-27.88-20.67-4.125 6.98-9.953 12.47-17.114 16.32l.406.15a50.29 50.29 0 0 1-2.323 1.198c-.149-.05-.306-.107-.456-.157l-.52.243c.193.07.335.135.414.178-.008 0-.015.007-.029.014l-.463-.157a54 54 0 0 1-8.322 2.966c-.143.036-.292.079-.435.114a70.62 70.62 0 0 1-1.852.45c-.193.042-.392.092-.584.135q-1.154.247-2.337.463a69 69 0 0 1-8.422.948q-1.452.077-2.936.1a74 74 0 0 1-5.058-.114 76 76 0 0 1-1.311-.071 70 70 0 0 1-5.48-.606c-.256-.036-.505-.086-.755-.128l.107.356a62 62 0 0 1-2.601-.485c-.035-.12-.078-.235-.114-.356a65 65 0 0 1-1.132-.25q-.235-.051-.471-.114a42 42 0 0 1-1.909-.492q-.087-.021-.164-.042c-13.096-3.608-23.32-11.458-29.241-23.093v315.949h36.416c-2.009-6.438-3.135-13.739-3.135-21.788 0-5.069.449-9.775 1.275-14.138.285-1.497.613-2.945.984-4.363a61 61 0 0 1 2.678-8.007 56 56 0 0 1 1.483-3.23c.042-.085.085-.164.128-.249.064-.121.128-.236.192-.364.335-.649.67-1.305 1.026-1.932a50.7 50.7 0 0 1 12.262-14.452 55 55 0 0 1 5.052-3.629 60 60 0 0 1 6.484-3.55 59 59 0 0 1 2.472-1.112 71 71 0 0 1 8.564-2.988c.114-.035.235-.057.349-.092l.727-.193c.228-.057.449-.121.677-.178.406-.107.805-.221 1.211-.314 6.961-1.69 14.215-2.495 22.323-2.495 1.161 0 2.308.014 3.455.05.342.007.677.028 1.019.042 1.112.043 2.223.1 3.321.179 6.462.435 12.682 1.433 18.51 3.058.606.171 1.197.357 1.789.542v-.007q.267.084.534.157h-.014q.137-.045.285-.079l.256.086c8.479-2.246 17.82-3.358 27.738-3.358v.064c14.87 0 28.607 2.446 40.12 7.593 6.385 2.816 12.028 6.431 16.816 10.958 10.26 9.796 16.416 23.143 16.416 41.994 0 8.099-1.183 15.35-3.363 21.774H71.579c5.45-6.83 8.208-17.639 8.393-33.075l40.391-.114v.007h.221c.271 15.55 3.007 26.387 8.458 33.175h43.498c5.593-6.816 8.414-17.703 8.607-33.346h.491v-.007l40.392-.114c.278 15.764 3.078 26.694 8.678 33.46h63.904c-6.897-11.893-11.863-24.505-11.863-36.069 0-2.346.086-4.663.25-6.959.498-6.873 2.073-12.997 4.496-18.38.313-.699.641-1.376.983-2.046.1-.2.207-.399.306-.599.185-.349.378-.699.57-1.041 6.562-11.771 17.428-19.485 29.647-23.121a57 57 0 0 1 3.912-1.006 60 60 0 0 1 11.151-1.397c.427-.014.862-.036 1.289-.036v-.043c.086 0 .164.022.25.022s.163-.022.249-.022v.043c.292 0 .584.022.869.029a59.5 59.5 0 0 1 11.792 1.461 54 54 0 0 1 1.532.364c.199.05.392.107.591.164q1.602.428 3.171.941c6.192 2.046 11.998 5.155 17.022 9.333a46.7 46.7 0 0 1 7.003 7.222c5.722 7.315 9.548 16.683 10.382 28.126.164 2.296.249 4.62.249 6.959 0 2.203-.185 4.442-.52 6.709-.036.242-.078.485-.121.72-.036.235-.079.463-.121.699-.079.449-.164.891-.257 1.34-1.788 8.791-5.8 17.888-10.851 26.601H425v-292.23c-3.142 2.788-6.548 5.234-10.175 7.372-19.173 11.294-44.36 14.01-67.787 14.01h-65.001c-14.592 0-24.646 6.04-24.646 21.646 0 4.534 1.005 11.578 1.504 17.11h-59.359c-.684-5.154-1.603-11.478-2.123-20.418h-39.829c-.627-4.72-1.453-10.424-1.98-18.216a224 224 0 0 1-.492-11.886 325 325 0 0 1-.036-4.627c0-2.388.072-4.72.2-7.001 0-.071.007-.136.014-.207.007-.17.022-.342.036-.506.028-.392.05-.784.078-1.17q.16-2.158.406-4.241c.727-6.267 1.988-12.078 3.791-17.418a70 70 0 0 1 2.707-6.852c.25-.549.513-1.09.777-1.625a60 60 0 0 1 2.558-4.67 54 54 0 0 1 1.902-2.937q.492-.715 1.005-1.42a57 57 0 0 1 3.249-4.035c.157-.178.328-.356.484-.534q.333-.377.677-.742a57.7 57.7 0 0 1 7.759-6.901c9.377-6.945 21.261-11.486 35.554-13.518a125 125 0 0 1 13.502-1.141q2.362-.076 4.788-.078h74.442c1.211 0 2.38-.036 3.527-.1l.648-.043c13.039-.87 21.881-6.01 25.771-16.961.043-.122.093-.243.136-.364q.247-.717.463-1.476c.036-.114.064-.235.093-.349a37 37 0 0 0 .776-3.451H101.425c-4.51 20.719-12.005 37.659-23.056 50.635a293 293 0 0 1 21.24 2.467l-9.59 63.396C43.434-21.347 21.482-9.54 16.687 22.151l-61.952-9.383c4.018-26.55 12.155-47.74 25.372-63.261a293 293 0 0 1-21.24-2.467l9.59-63.397c33.51 4.57 54.279-.256 65.073-15.122H-88.826c10.502 6.531 17.79 16.976 20.498 30.936zm171.407 305.704c-1.61.264-3.299.406-5.059.414a32 32 0 0 1-5.265-.414c-9.47-1.554-16.21-7.508-17.97-17.133a29.4 29.4 0 0 1-.456-5.126q-.001-2.759.435-5.197c1.717-9.647 8.422-15.628 17.862-17.233a32 32 0 0 1 5.266-.442q2.641 0 5.059.385c9.447 1.512 16.195 7.472 17.962 17.161.299 1.626.456 3.366.456 5.198 0 1.811-.143 3.522-.421 5.133-1.703 9.689-8.421 15.7-17.876 17.261zm121.524-17.546c-1.703 9.689-8.422 15.699-17.877 17.261-1.61.264-3.299.406-5.058.413-1.832 0-3.592-.135-5.266-.413-9.469-1.554-16.209-7.508-17.969-17.133a29.4 29.4 0 0 1-.456-5.126c0-1.832.142-3.572.434-5.197 1.718-9.647 8.422-15.629 17.863-17.233a32 32 0 0 1 5.265-.442c1.76 0 3.449.129 5.059.385 9.448 1.512 16.195 7.472 17.962 17.161.299 1.626.456 3.365.456 5.198a30 30 0 0 1-.42 5.133zm20.748-40.953c.499.421 0-65.421 0-65.421 31.592 11 68.5.563 68.5.563v64.58c-23.278 6.488-68.5.286-68.5.286zM362.065 3.371v35.905c18.161-.463 32.183-4.428 32.183-4.428v64.58c-23.277 6.489-68.499.286-68.499.286.228.192.249-13.81.199-28.91-17.257-.493-32.383-2.575-32.383-2.575.499.421 0-65.421 0-65.421 31.592 11.001 68.5.563 68.5.563m-401.572 98.154c.498-9.982 2.707-18.416 6.198-25.517 7.646-15.55 21.668-24.533 38.825-28.24 8.172-1.769 17.036-2.36 26.255-1.897 8.244.413 16.174 1.725 23.499 3.964.007-.029.014-.05.02-.078h.015a58 58 0 0 1 3.534-9.133c.036-.079.078-.15.121-.221q.586-1.176 1.226-2.296c7.951-14.088 21.439-22.316 37.463-25.795.94-.207 1.888-.392 2.843-.563.926-.165 1.859-.314 2.807-.457 6.27-.92 12.847-1.197 19.565-.855 6.213.313 12.213 1.098 17.898 2.353 1.233.27 2.458.57 3.663.89.242.065.491.129.733.193.086.022.179.043.271.072.114.028.228.056.342.092.755.214 1.504.45 2.252.677.256.079.52.15.776.236 7.667 2.48 14.557 6.01 20.356 10.659a52 52 0 0 1 3.078 2.673 49 49 0 0 1 3.67 3.836q.436.515.862 1.04c.192.236.378.478.57.714q.832 1.07 1.61 2.181a49.4 49.4 0 0 1 5.665 10.887c2.764 7.415 4.111 16.028 3.612 26.01-.492 9.838-2.672 18.151-6.12 25.174-3.228 6.566-7.61 11.956-12.882 16.284-.563.463-1.14.906-1.725 1.348-.22.164-.434.328-.655.492-.257 13.41 5.65 25.224 5.65 25.224l-37.606 5.412c-2.429-4.906-3.691-12.185-4.346-18.744-3.719.264-7.545.321-11.429.192q-1.037-.03-2.073-.071h-.071l-.684-.043c-.185-.007-.364-.021-.549-.035-7.787-.478-15.283-1.754-22.237-3.872-.955 3.28-2.137 6.353-3.541 9.197-7.695 15.621-21.852 24.626-38.86 28.319-7.923 1.718-16.444 2.31-25.215 1.868-4.631-.235-9.141-.72-13.495-1.476-1.304 6.46-3.292 13.575-6.199 18.209l-36.871-9.154s7.053-11.151 8.143-24.519c-5.856-5.219-10.445-11.7-13.373-19.571-2.73-7.336-4.062-15.827-3.57-25.666zm-79.829 28.19 7.802-6.174c-.506-.192-1.026-.371-1.368-.428.014-.121-.185-.185-.228-.242v.107c-5.272-4.378-14.856-8.741-21.425-13.047-4.268 5.404-9.526 8.89-15.354 10.516.235.199.456.399.677.585-.727.213-1.461.406-2.202.563q-.365-.31-.719-.621c-5.045.97-10.46.628-16.01-1.019a45.6 45.6 0 0 1-6.926-2.695 47 47 0 0 1-6.683-3.914c-3.933-2.781-7.118-6.032-9.448-9.668l-.235-.043-.121-.021a29 29 0 0 1-1.347-2.51q.128.02.257.05c-1.96-3.836-3.021-8.028-3.092-12.491-4.076-.307-7.98-.592-11.529-.82l.449-.228a20 20 0 0 1-2.707.1c-.072.313-.136.62-.221.934a22 22 0 0 1-1.411 3.721 22.7 22.7 0 0 1-1.995 3.38c-4.389 6.081-11.001 7.964-18.005 5.889a24 24 0 0 1-3.605-1.405 24 24 0 0 1-3.477-2.039c-5.978-4.22-8.621-10.544-6.626-17.738a22.5 22.5 0 0 1 1.396-3.672 22 22 0 0 1 2.024-3.422c4.389-6.046 10.972-7.914 17.983-5.875 1.24.364 2.501.841 3.755 1.454a24.5 24.5 0 0 1 3.342 1.947c5.03 3.522 7.687 8.57 7.21 14.395 1.845.163 3.171.313 3.171.313l5.4.05s2.722.079 4.938.057a34.2 34.2 0 0 1 1.161-6.438c.642-2.31 1.532-4.663 2.679-7.051a43 43 0 0 1 3.898-6.58c5.885-8.107 13.822-12.3 22.664-12.77.492-8.17.948-16.398 2.231-22.059.748 2.638.071-6.46.591-6.973l.199.364c.364-.585-.235-2.431.542-2.574.014-.114.014-.306.014-.563l-13.78 1.982-5.122-35.584 35.568-5.126 5.123 35.584-20.207 2.909c-.549 6.901-1.225 13.51-1.468 14.23-.064-.12.121-.706-.292-.734-.085 1.034-.071 2.125-.15 3.223.649-.286.321-1.64.528-1.74.071 4.1-.585 12.42-1.233 17.018 3.043.086 6.177.585 9.355 1.512a47.4 47.4 0 0 1 7.218 2.787 45.5 45.5 0 0 1 6.419 3.743c3.912 2.738 7.076 5.947 9.398 9.547.164-.107.335-.214.499-.32a6 6 0 0 0-.392.491 1 1 0 0 1 .079.136c1.218-.685 8.949-7.593 9.796-7.743-.035.057-.292.47-.334.542 1.019-.371 2.999-2.802 3.726-2.396.185-.128.506-.392.919-.748-3.049-3.865-4.104-8.691-2.636-13.989a22.6 22.6 0 0 1 1.396-3.672 22 22 0 0 1 2.024-3.422c4.389-6.046 10.972-7.914 17.983-5.874 1.24.363 2.501.84 3.755 1.454a24.4 24.4 0 0 1 3.342 1.946c5.978 4.185 8.628 10.517 6.612 17.753a22 22 0 0 1-1.41 3.722 22.7 22.7 0 0 1-1.996 3.38c-4.389 6.08-11 7.963-18.005 5.888a24 24 0 0 1-3.605-1.404 24 24 0 0 1-3.477-2.04 20 20 0 0 1-2.971-2.552 1166 1166 0 0 1-14.272 10.623 29.08 29.08 0 0 1 1.397 2.902q.173.396.335.791v.03c2.166 5.738 2.451 12.198.534 19.085q-.972 3.508-2.714 7.144c-.015.029-.036.064-.05.093.149.092.299.178.449.271-.05.107-.093.213-.143.313a47 47 0 0 1-1.054 2.047c-.157-.093-.321-.186-.478-.286a43 43 0 0 1-1.966 3.187c3.021 1.512 7.303 4.107 9.497 5.725-.335-.071-1.083-.37-1.859-.834l-.143.214c1.824 1.012 3.249 2.995 5.422 3.151 0 0-2.109-1.561-2.486-2.003l.028-.014-.014-.043c4.261 2.189 9.17 5.183 13.416 7.65l17.97-14.224 22.294 28.198-28.18 22.309-22.294-28.198z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#f8eefe",
        d: "M197.242-2.29a493.5 493.5 0 0 1-.064-1.547v-.17a228 228 0 0 1-.1-3.416q.002-.18-.007-.37l-.022-1.32q.002-.3-.007-.599-.002-.597-.014-1.205v-2.416c0-.92.014-1.826.036-2.731a41 41 0 0 1-4.696 1.362c-2.75.598-5.643 1.005-8.678 1.247l.37-.228h.015c-1.119-.007-2.323.136-1.846.285h-.249c1.347 1.348 2.273 2.282 2.608 2.688-.264-.228-2.316-1.989-2.644-2.267 2.038 2.239 6.391 6.324 10.488 9.91 1.66 1.469 3.278 2.86 4.653 4.043h.321a311 311 0 0 1-.164-3.202v-.07zM178.96-13.348c-7.945-.014-15.69-1.098-23.256-2.445-.036-.478-.072-.956-.107-1.448.534 7.793 1.353 13.497 1.98 18.217h36.659c-.635-.55-1.276-1.098-1.903-1.654a311 311 0 0 1-13.373-12.67"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#eed7fc",
        d: "M181.946-12.977c.327.278 2.379 2.039 2.643 2.267-.342-.406-1.268-1.333-2.608-2.688h.25c-.478-.15.726-.292 1.845-.285h-.014l-.371.228c3.036-.242 5.921-.649 8.678-1.247a41 41 0 0 0 4.696-1.362c.021-.877.05-1.74.085-2.602l-.484.192c-.477.185-.976.32-1.454.478-.962.335-1.952.57-2.921.805-3.911.927-7.788 1.29-11.329 1.412a80 80 0 0 1-1.296.036 422 422 0 0 1-6.726-6.916c-5.601-5.882-12.163-13.425-17.435-21.11-.029.37-.064.74-.093 1.118-.028.386-.05.785-.078 1.17.242.335.47.656.684.94.954 1.327 1.703 2.368 2.315 3.138-.755-.656-1.831-1.932-3.028-3.572 0 .071-.007.135-.014.207 4.489 6.43 9.783 12.783 15.582 19.014a410 410 0 0 0 5.757 6.01c-1.859-.02-3.583-.092-5.144-.156-5.336-.457-10.638-1.234-15.917-2.182.021.285.035.563.057.841.035.492.071.97.107 1.448 7.567 1.34 15.311 2.424 23.256 2.445a312 312 0 0 0 13.373 12.67c.627.556 1.269 1.105 1.903 1.654h2.857c-1.375-1.191-2.993-2.574-4.653-4.043-4.104-3.586-8.45-7.671-10.488-9.91z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#f8eefe",
        d: "M372.866-51.79c-19.173 11.293-44.36 14.009-67.787 14.009h-65.002c-.912 0-1.802.021-2.679.071-13.124.72-21.966 6.945-21.966 21.575 0 4.534 1.005 11.578 1.503 17.11h-19.522a322 322 0 0 1-.164-3.2c.05 1.105.1 2.167.164 3.2.513 8.934 1.439 15.265 2.123 20.42h59.359c-.499-5.54-1.504-12.584-1.504-17.111 0-15.607 10.061-21.646 24.646-21.646h65.001c23.42 0 48.607-2.716 67.787-14.01A64.7 64.7 0 0 0 425-38.742v-92.75h-20.435v16.634c0 32.86-12.989 52.046-31.692 63.068z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#eed7fc",
        d: "M383.126-120.549c0 9.411-1.909 16.491-5.557 21.582-3.086 4.306-7.425 7.193-12.904 8.855-.178.056-.37.1-.556.156-.826.236-1.667.45-2.543.635q-.075.009-.15.028a48 48 0 0 1-6.726.856q-.91.055-1.852.078-.939.031-1.91.029h-74.599c-1.567 0-3.106.028-4.631.078-1.574.05-3.121.129-4.645.228q-1.144.075-2.266.172c-.399.035-.798.07-1.197.114-.342.035-.691.064-1.04.1-.043 0-.079.007-.121.014l-.357.042-.791.086q-1.562.18-3.092.392a95 95 0 0 0-6.619 1.162 88 88 0 0 0-3.256.742 86 86 0 0 0-7.317 2.146c-4.204 1.44-8.116 3.18-11.728 5.204a64 64 0 0 0-5.201 3.244 58 58 0 0 0-2.815 2.082q-.408.323-.805.656a61 61 0 0 0-2.173 1.861c-4.631 4.178-8.522 9.048-11.657 14.609-.106.185-.206.378-.313.57-.093.171-.192.342-.285.513-.257.47-.506.956-.748 1.433-3.064 6.068-5.294 12.884-6.655 20.434a95 95 0 0 0-.527 3.294 106 106 0 0 0-.962 10.509c-.036.863-.064 1.725-.086 2.602a117.4 117.4 0 0 0-.035 2.73v2.418q.002.608.014 1.205-.002.3.007.599c0 .449.014.884.022 1.319a242.218 242.218 0 0 0 .106 3.786v.17l.065 1.548v.071c.049 1.105.099 2.167.163 3.201h19.523c-.499-5.54-1.503-12.584-1.503-17.11 0-14.63 8.842-20.855 21.966-21.575q1.313-.074 2.679-.072h65.001c23.42 0 48.607-2.716 67.788-14.01 18.703-11.015 31.692-30.2 31.692-63.068v-16.662h-21.432v10.944z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#f8eefe",
        d: "M78.348-80.858C58.355-57.373 26.72-46.878-19.922-50.5a91 91 0 0 1 1.896-2.153 93 93 0 0 0-1.903 2.153C-33.144-34.98-41.28-13.79-45.3 12.76l61.952 9.384C21.447-9.541 43.4-21.354 89.982-15.003l9.59-63.396c-7.402-1.12-14.477-1.94-21.239-2.467a221 221 0 0 0-4.168-.286q2.063.127 4.168.286zM293.564 2.808s.499 65.85 0 65.421c0 0 15.127 2.075 32.384 2.574v-3.437l-.043-9.646v-.02q.002-.782-.007-1.554v-5.27c-.057-9.503-.107-16.583-.107-16.583q1.016.352 2.03.67l.485.15a67.963 67.963 0 0 0 2.202.65 90.53 90.53 0 0 0 1.909.505c.157.043.314.079.47.121.677.172 1.361.329 2.038.485.093.022.178.036.271.057a82.64 82.64 0 0 0 2.28.471c.691.135 1.375.257 2.066.378.1.014.2.035.299.05a94 94 0 0 0 1.896.3c.106.013.213.035.32.05q1.046.147 2.102.284c.093.014.192.022.285.036.67.078 1.332.157 1.995.22.057 0 .114.015.171.022.713.072 1.432.136 2.138.193.078 0 .163.014.242.021q2.167.17 4.303.264h.164q2.179.087 4.304.1h.064c1.446.007 2.871 0 4.275-.043V3.371s-36.908 10.43-68.5-.563z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#f8eefe",
        d: "M348.713 38.934c.078 0 .164.014.242.021-.078 0-.164-.014-.242-.021m-22.757 31.869c.05 15.1.029 29.103-.199 28.91 0 0 45.222 6.204 68.5-.284v-64.58s-14.03 3.964-32.184 4.427v28.668c-9.811 2.738-23.527 3.216-36.11 2.852zm-.199-36.518s.057 7.08.107 16.584c-.057-9.504-.107-16.584-.107-16.584m11.264 3.038c.135.028.27.057.413.078a7.366 7.366 0 0 0-.413-.079m9.375 1.398c.057 0 .114.014.171.021-.057 0-.114-.014-.171-.021m-14.021-2.453c.157.043.313.079.47.121-.157-.035-.313-.078-.47-.12m-2.08-.557q.084.02.178.05a2 2 0 0 1-.178-.05"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#eed7fc",
        d: "M357.727 39.319q-2.125-.012-4.304-.1h-.164c-1.425-.057-2.857-.15-4.303-.264-.079 0-.164-.014-.242-.021q-1.069-.085-2.138-.193c-.057 0-.114-.014-.171-.021-.663-.071-1.332-.143-1.995-.221-.093-.014-.192-.022-.285-.036a75 75 0 0 1-2.102-.285c-.107-.014-.214-.036-.32-.05a86 86 0 0 1-1.896-.3c-.099-.014-.199-.035-.299-.05a99.632 99.632 0 0 1-2.479-.456 70.958 70.958 0 0 1-1.867-.392c-.093-.021-.178-.035-.271-.057a70 70 0 0 1-2.038-.484q-.234-.056-.47-.122c-.634-.164-1.275-.328-1.909-.506a110.499 110.499 0 0 1-2.202-.649l-.485-.15a69 69 0 0 1-2.03-.67s.057 7.087.107 16.584v5.269q-.002.771.007 1.554v.021l.043 9.647v3.436c12.582.364 26.298-.121 36.109-2.852V39.283q-2.106.054-4.275.043h-.064z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#f8eefe",
        d: "M66.278 54.07c-2.536-4.535-4.945-9.097-7.317-13.66q-.056.116-.121.22c-1.397 2.824-2.58 5.868-3.534 9.134q.693.214 1.375.427a73.4 73.4 0 0 1 9.604 3.872zm93.473 9.204c-2.808 4.264-5.978 8.185-9.363 11.757-3.355 3.586-7.089 6.802-11.022 9.461.021-.021.463-.4.962-.82.249-.214.499-.42.677-.591l.313-.293a59 59 0 0 1-4.788 3.365c.171.378.342.763.506 1.141a65 65 0 0 0 2.565 4.734c3.684 6.082 8.408 11.172 13.595 14.901a43 43 0 0 0 3.584 2.317c.228-.035.463-.071.691-.1.812-.121 1.589-.235 2.344-.349.499-.071.983-.15 1.446-.214.271-.043.527-.078.784-.114.399-.791.769-1.604 1.161-2.395 1.048-2.075 1.874-4.25 2.786-6.389.428-1.076.805-2.181 1.211-3.265l.599-1.633c.192-.549.356-1.105.534-1.654l1.055-3.315.919-3.351.456-1.675.399-1.69.791-3.372.677-3.394.335-1.697.285-1.704c.192-1.134.377-2.274.569-3.408l.471-3.415.235-1.704.185-1.711c.128-1.14.25-2.275.378-3.408.798-9.098 1.361-18.188.812-27.021 0-.043-.007-.086-.007-.129a49 49 0 0 0-3.669-3.836 40.4 40.4 0 0 1-.556 5.968c-1.938 10.702-6.284 20.512-11.906 29.025zm-58.639-49.066c.342-.663.513-.962.485-.97-.022-.006-.243.279-.592.835-.342.563-.869 1.369-1.46 2.424-1.226 2.096-2.808 5.169-4.425 8.905-1.61 3.743-3.2 8.178-4.567 12.926-2.743 9.51-4.375 20.277-5.273 28.953l-.17 1.697c3.042 3.872 5.535 8.263 7.374 13.204q.599 1.617 1.111 3.308c.036.029.072.05.1.079.812.584 1.632 1.183 2.515 1.704.435.264.855.556 1.311.798.449.243.905.478 1.361.72.449.257.92.464 1.397.663l1.417.614 1.468.499.734.25.748.184 1.503.371h.008c0-1.09 0-2.189.042-3.287.335-11.15 2.786-22.322 6.869-32.853 4.083-10.545 9.775-20.448 16.43-29.51a167 167 0 0 1 5.187-6.651c1.81-2.168 3.741-4.285 5.942-6.16l.129-.107c-5.693-1.262-11.685-2.046-17.898-2.353-6.719-.335-13.296-.064-19.566.855a85 85 0 0 0-3.797 5.975c.705-1.419 1.275-2.403 1.617-3.066z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#f8eefe",
        d: "M176.851 39.989c-.05 5.255-.428 10.901-.884 16.427-.869 11.072-2.75 21.574-3.747 27.834.513-2.26 1.054-4.549 1.475-6.895.484-2.331.84-4.712 1.246-7.115.699-4.812 1.333-9.732 1.71-14.73.392-4.998.727-10.06.77-15.136.028-2.16-.014-4.328-.107-6.488-.185-.242-.378-.478-.57-.713.1 2.167.135 4.449.107 6.823z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#f8eefe",
        d: "M178.739 48.324c-.827 16.583-3.371 33.288-8.529 47.832a111 111 0 0 1-4.959 11.828l2.679-.399a38 38 0 0 0-.428 1.961c-.035.178-.064.356-.099.527a43 43 0 0 0-.25 1.612c-.014.121-.035.242-.05.37-.057.485-.099.97-.142 1.455a44 44 0 0 0 2.422.599c-2.636-.271-2.337-.129-.342.285.05.007.107.021.157.028 5.273-4.327 9.662-9.71 12.882-16.284 3.449-7.022 5.629-15.343 6.121-25.175.498-9.981-.848-18.594-3.613-26.008a49.4 49.4 0 0 0-5.664-10.887c.114 4.085.021 8.185-.185 12.263zM161.988 59.11a37.13 37.13 0 0 0 1.617-3.13c-1.689 2.19-5.472 9.34-1.617 3.13M86.99 46.598c.192-.97.49-2.21.883-3.8.498-2.281 1.653-6.032 2.807-9.333 1.154-3.308 2.259-6.188 2.202-6.958-1.098 2.873-2.7 6.987-3.883 10.872-1.205 3.879-2.003 7.508-2.01 9.226z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#f8eefe",
        d: "M69.933 56.016c5.037 2.91 9.505 6.46 13.267 10.688l.042-.4c1.105-9.667 2.772-18.936 5.216-27.427 2.408-8.499 5.657-16.177 9.355-22.715a86 86 0 0 1 2.672-4.406q-1.433.254-2.843.563C81.625 15.805 68.13 24.033 60.179 38.114c2.657 5.07 5.336 10.117 8.144 15.093.527.941 1.076 1.868 1.617 2.802zm75.318-41.473.05-.057q.243-.237.456-.442a6 6 0 0 1-.342-.092q-.169.19-.35.413l.179.178zM129.042 53.6c-.064.37-.135.463-.164.826-.035.528.164 1.355.221 1.804 0-.313.078-1.02.107-1.625.028-.6.057-1.098-.157-1.005zm2.308-6.246c-.342 1.29-.862 3.187-1.126 5.183-.356 1.99-.413 4.064-.406 5.618l.249.05.193-3.28c.028-.784.156-1.554.221-2.131.071-.578.128-.963.149-.97l-.05-.035c.1-.079.307-.065.3-.528.662-3.33 1.018-4.934 1.09-5.397.064-.464-.257.192-.62 1.476zM110.367 65.57l.2.228c1.332-4.898 3.177-9.91 5.108-14.387l-.178-.221c-1.995 4.605-3.769 9.39-5.13 14.38m35.518-48.617c-2.472 2.816-4.56 6.039-6.369 9.44-3.577 6.837-6.171 14.33-7.439 22.023-.142.963-.342 1.918-.435 2.888l-.313 2.901c-.114 1.94-.278 3.872-.242 5.804-.05 1.932.107 3.85.199 5.76.221 1.904.378 3.8.741 5.662.271 1.875.763 3.7 1.183 5.518.541 1.79 1.026 3.586 1.71 5.297.207.62.449 1.227.698 1.826.15-.093.307-.186.456-.279 2.302-1.397 4.054-2.723 5.273-3.621.591-.471 1.054-.842 1.368-1.091.313-.25.47-.385.47-.385 1.974-1.676 3.798-3.53 5.572-5.433 1.788-1.89 3.434-3.907 5.03-5.953 1.589-2.054 3.049-4.2 4.453-6.388 1.361-2.21 2.651-4.456 3.805-6.78 0 0 .214-.4.563-1.149.349-.741.876-1.803 1.432-3.144a74 74 0 0 0 3.641-10.616c1.111-4.178 1.845-8.798 1.532-12.926-.015-.235-.05-.463-.072-.698-5.799-4.656-12.696-8.178-20.356-10.66-.256-.085-.52-.156-.776-.235a37 37 0 0 0-2.124 2.232zm-25.656 23.913c-1.832 3.244-3.164 6.132-2.843 6.203l.114-.236c1.503-2.866 2.743-5.104 3.968-7.329 1.247-2.21 2.494-4.413 4.204-7.072l-.178-.193c-1.126 1.804-3.463 5.376-5.273 8.634z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#f8eefe",
        d: "M137.314 20.418a141 141 0 0 0-7.353 9.468c-4.696 6.61-8.949 13.825-12.405 21.596s-6.099 16.106-7.538 24.804a90.7 90.7 0 0 0-1.233 15.457c.136.007.271.014.406.029l1.532.092c.513.007 1.019-.028 1.525-.035.506-.029 1.012 0 1.518-.093 1.004-.136 1.995-.214 2.985-.435 6.384-1.183 12.027-3.48 16.366-5.803-.52-1.227-.962-2.496-1.432-3.758-.313-.827-.527-1.69-.791-2.538-.249-.856-.527-1.697-.705-2.574l-.599-2.602c-.185-.87-.306-1.754-.456-2.624-.335-1.74-.442-3.508-.641-5.24-.214-3.48-.299-6.902-.021-10.16.434-6.523 1.745-12.355 3.199-16.854-.399 1.84-1.596 6.374-2.28 11.592l.242.122c.762-6.025 2.629-12.07 5.002-17.739 2.394-5.675 5.23-11.015 8.407-15.8 0 0-.62.735-1.503 1.926a57 57 0 0 0-3.092 4.663c-1.076 1.81-2.145 3.736-2.929 5.447-.413.848-.784 1.618-1.104 2.267l-.691 1.568v-.078l-.086.15c1.539-4.021 3.399-8.078 5.836-11.957 1.617-2.595 3.498-5.111 5.685-7.407l-.733-.193c-2.587 1.818-4.91 4.171-7.104 6.73zM62.78 45.436c.741 1.355 2.43 4.164 3.028 4.791-.72-1.647-4.773-8.384-3.028-4.79m106.79-9.54c.285-1.255.491-2.802.627-3.594.085-1.554.021-2.139-.043-2.103-.079.036-.15.692-.292 1.611-.235 1.84-.813 4.727-1.019 5.946.135.35.449-.606.727-1.86"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#eed7fc",
        d: "M69.933 56.016a567 567 0 0 1-1.617-2.801c-2.808-4.977-5.487-10.032-8.144-15.094-.42.749-.834 1.511-1.226 2.296 2.373 4.563 4.788 9.126 7.318 13.66a64 64 0 0 1 3.662 1.947zm-4.118-5.796c-.606-.627-2.294-3.437-3.028-4.791-1.746-3.593 2.315 3.137 3.028 4.791m109.268 9.048c-.128 1.133-.249 2.274-.378 3.407l-.185 1.712-.235 1.704c-.157 1.133-.313 2.274-.47 3.415-.193 1.133-.378 2.267-.57 3.408l-.285 1.704-.335 1.696-.677 3.394-.791 3.372-.399 1.69-.456 1.676-.919 3.35-1.055 3.316c-.178.549-.342 1.112-.534 1.654l-.598 1.633c-.407 1.09-.784 2.188-1.212 3.265-.912 2.139-1.738 4.313-2.786 6.388-.391.799-.762 1.604-1.161 2.396.285-.043.556-.086.827-.122.349-.663.719-1.361 1.097-2.117.413-1.005.613-.934.784-1.098.028-.093.021-.135-.022-.078 0 0 .036-.057.086-.15q.075-.152.213-.421c.164-.371.392-.905.663-1.54.527-1.283 1.304-2.959 1.91-4.727 1.346-3.479 2.394-7.136 2.515-7.4l.213.17c-.52 1.776-1.083 3.858-1.909 5.997-.399 1.07-.784 2.189-1.247 3.287-.477 1.09-.955 2.195-1.432 3.293-.456 1.106-1.033 2.154-1.546 3.187-.264.507-.513 1.013-.77 1.512.371-.057.72-.107 1.055-.157q.194-.385.377-.77l.143.292-.214.428c.157-.021.299-.043.449-.064a110 110 0 0 0 4.959-11.828c5.159-14.544 7.702-31.25 8.529-47.833.199-4.078.299-8.177.185-12.263a45 45 0 0 0-1.61-2.181c.092 2.16.135 4.327.107 6.488-.043 5.083-.371 10.145-.77 15.136-.385 4.998-1.012 9.917-1.71 14.73-.399 2.395-.762 4.784-1.247 7.115-.42 2.346-.969 4.634-1.475 6.894.998-6.26 2.879-16.769 3.748-27.834.463-5.525.834-11.172.884-16.426.028-2.375 0-4.663-.107-6.824q-.426-.525-.862-1.04c0 .042.007.085.007.128.548 8.834-.015 17.917-.813 27.021zm-6.462 40.31c-.293.813-.442.999-.813 1.804-.299.157.164-.92.62-2.274.485-1.34 1.098-2.902 1.333-3.608-.285 1.02-.72 2.916-1.148 4.078zm-33.936-80.514c-1.803 2.167-3.506 4.391-5.187 6.651-6.662 9.07-12.348 18.965-16.431 29.51-4.082 10.53-6.533 21.703-6.868 32.853a84 84 0 0 0-.043 3.287h-.007l-1.503-.37-.749-.186-.733-.25-1.468-.499-1.418-.613c-.477-.2-.948-.406-1.397-.663l-1.36-.72c-.45-.242-.877-.535-1.311-.798-.877-.514-1.696-1.113-2.515-1.704-.036-.029-.072-.05-.1-.079.356 1.17.67 2.367.954 3.593a40.651 40.651 0 0 0 4.311 2.403c2.373 1.148 4.859 1.882 7.332 2.374.285 9.183 1.988 18.217 5.294 26.594 1.111 2.702 2.508 5.34 4.232 7.735.185.015.363.029.548.036a39 39 0 0 1-1.382-2.06c-2.622-4.357-4.111-8.941-5.023-12.313l-.598-2.303c-.171-.684-.285-1.283-.399-1.775l-.335-1.533c.427 1.64.84 3.287 1.361 4.926a60 60 0 0 0 1.66 4.913c1.239 3.251 2.8 6.466 4.88 9.382q.289.405.599.799c.691.035 1.382.05 2.073.071-.064-.078-.135-.143-.192-.221-2.836-3.458-4.788-7.614-6.227-11.914a78 78 0 0 1-3.071-13.239c-.421-2.916-.656-5.84-.763-8.755.399.028.791.057 1.183.078.314.014.627.05.941.043l.933-.029c.62-.028 1.247-.014 1.86-.078 2.493-.25 4.816-.72 7.16-1.312 2.337-.599 4.639-1.383 6.933-2.303a53.5 53.5 0 0 0 6.227-3.001c-.15-.336-.313-.656-.456-.991q-.269-.557-.506-1.134c-4.339 2.324-9.989 4.62-16.366 5.803-.99.221-1.981.3-2.985.435-.499.086-1.005.065-1.518.093-.506.007-1.019.05-1.525.036l-1.532-.093c-.135-.007-.27-.021-.406-.028a90.7 90.7 0 0 1 1.233-15.458c1.432-8.698 4.083-17.032 7.538-24.804 3.456-7.77 7.709-14.986 12.405-21.595a141 141 0 0 1 7.353-9.468c2.187-2.56 4.517-4.905 7.103-6.73a94 94 0 0 0-3.662-.892l-.128.107c-2.209 1.875-4.133 4-5.942 6.16zm-32.141 72.273c-.371-.115-.577-.214-.706-.314-.256-.207-.235-.37-.677-.72.72.392 3.527 1.305 2.879 1.29l.235.1c-.826-.064-1.354-.25-1.731-.35zm4.346 8.683c-.264-1.803-.321-3.222-.378-4.192-.007-.977.022-1.518.079-1.582.114-.129.235 1.64.527 5.575l.021.178-.249.014zm3.676-34.222-.199-.228c1.361-4.99 3.135-9.775 5.13-14.38l.178.22c-1.931 4.478-3.776 9.49-5.109 14.388m10.909-26.301c-1.226 2.224-2.465 4.463-3.969 7.33l-.114.235c-.313-.072 1.012-2.96 2.843-6.203 1.81-3.251 4.147-6.83 5.273-8.634l.178.192c-1.71 2.66-2.957 4.863-4.204 7.073zm46.206-.257a74.4 74.4 0 0 1-3.641 10.616c-.563 1.34-1.083 2.403-1.432 3.145a22 22 0 0 1-.563 1.148c-1.154 2.317-2.451 4.57-3.805 6.78-1.404 2.181-2.864 4.327-4.453 6.388-1.596 2.046-3.249 4.057-5.03 5.953-1.774 1.904-3.598 3.757-5.572 5.433 0 0-.157.142-.47.385-.314.25-.777.613-1.368 1.09-1.219.906-2.964 2.225-5.273 3.623-.149.092-.306.185-.456.278.292.706.606 1.397.912 2.089a60 60 0 0 0 4.788-3.366s-.135.122-.313.293-.435.378-.677.591c-.492.421-.941.799-.962.82 3.933-2.659 7.674-5.874 11.022-9.46a85 85 0 0 0 9.363-11.757c5.621-8.513 9.975-18.316 11.905-29.025.328-1.947.535-3.943.556-5.968a55 55 0 0 0-3.078-2.673c.022.235.057.463.071.698.314 4.129-.42 8.749-1.531 12.927zm-5.693 19.87c-3.855 6.21-.064-.94 1.617-3.13a39 39 0 0 1-1.617 3.13m8.172-28.91c.057-.036.128.542.043 2.103-.135.792-.349 2.346-.627 3.594-.278 1.254-.584 2.21-.727 1.86.207-1.226.784-4.106 1.019-5.946.143-.92.214-1.575.292-1.611m-81.702 8.677c-2.444 8.491-4.112 17.76-5.216 27.428l-.043.399c.656.741 1.29 1.497 1.903 2.281q.086-.833.17-1.697c.898-8.676 2.53-19.45 5.273-28.953 1.368-4.748 2.95-9.183 4.567-12.926 1.618-3.736 3.2-6.809 4.425-8.905.591-1.062 1.118-1.868 1.46-2.424.35-.563.57-.841.592-.834.028.007-.143.306-.485.97s-.912 1.646-1.617 3.065a86 86 0 0 1 3.798-5.974c-.941.135-1.874.285-2.808.456a86 86 0 0 0-2.672 4.406c-3.697 6.538-6.946 14.216-9.355 22.715zm2.222-5.412c-1.154 3.309-2.308 7.052-2.807 9.333-.392 1.59-.69 2.83-.883 3.8.007-1.718.812-5.347 2.009-9.225 1.183-3.886 2.786-7.993 3.883-10.873.057.763-1.054 3.65-2.202 6.958z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#eed7fc",
        d: "m133.631 33.252.093-.15v.078c.164-.363.399-.905.691-1.568.313-.65.691-1.42 1.104-2.268.784-1.704 1.853-3.636 2.929-5.447a57 57 0 0 1 3.092-4.662c.883-1.191 1.503-1.925 1.503-1.925-3.177 4.784-6.013 10.124-8.407 15.799-2.373 5.668-4.24 11.714-5.002 17.738l-.242-.12c.684-5.22 1.881-9.754 2.28-11.594-1.454 4.5-2.758 10.331-3.199 16.855-.278 3.258-.193 6.68.021 10.16.2 1.732.306 3.493.641 5.24.157.87.271 1.754.456 2.624l.599 2.602c.178.87.456 1.718.705 2.574.264.848.478 1.71.791 2.538.47 1.262.912 2.53 1.432 3.757.164.378.328.763.506 1.134.15.335.306.663.456.99a43 43 0 0 0 1.824 3.615 55 55 0 0 0 2.608 4.221c1.824 2.667 3.79 5.055 5.771 7.087a47.6 47.6 0 0 0 5.828 5.069c-.128-.228-1.389-1.112-2.622-2.21-.634-.535-1.225-1.148-1.731-1.69-.485-.563-.855-1.069-.99-1.426 2.764 2.895 5.928 5.369 9.184 7.387l2.835-.421a41 41 0 0 1-3.583-2.317c-5.187-3.729-9.911-8.82-13.595-14.901a61 61 0 0 1-2.565-4.734q-.248-.576-.506-1.14c-.306-.692-.62-1.384-.912-2.09a27 27 0 0 1-.698-1.825c-.684-1.711-1.169-3.508-1.71-5.297-.42-1.826-.912-3.644-1.183-5.519-.363-1.86-.527-3.764-.741-5.66-.092-1.911-.249-3.83-.199-5.761-.043-1.932.128-3.864.242-5.804l.313-2.902c.093-.97.293-1.925.435-2.887 1.268-7.693 3.855-15.186 7.439-22.024 1.809-3.4 3.897-6.623 6.369-9.44a37 37 0 0 1 2.124-2.23 76 76 0 0 0-2.252-.678c-.142.136-.285.285-.456.442l-.05.057-.178-.178c.121-.15.235-.285.349-.414-.085-.021-.178-.042-.271-.071-2.187 2.296-4.068 4.813-5.685 7.408-2.437 3.885-4.297 7.935-5.836 11.956zm-4.424 21.36c-.029.599-.107 1.305-.107 1.625-.057-.449-.25-1.283-.221-1.803.028-.364.1-.457.164-.827.221-.093.185.406.156 1.005zm10.466 41.972c-.399-.35-.791-.92-1.161-1.511-.356-.6-.67-1.22-.955-1.655.164-.092.834.799 1.418 1.647.584.849 1.054 1.669.698 1.519m-8.065-23.849c.783 4.328 2.066 8.698 3.284 11.764.064.164.129.335.193.492.242.52.498 1.055.755 1.59 1.247 2.567 2.679 5.205 4.275 7.693.955 1.504 1.988 2.93 3.007 4.27 1.047 1.32 2.08 2.567 3.113 3.644.357.392.756.784 1.176 1.183.413.414.855.827 1.339 1.248-5.279-4.057-10.217-10.402-13.444-17.724q-.31-.703-.599-1.419c-.1-.235-.192-.478-.285-.713-1.489-3.729-2.601-7.636-3.356-11.521-.776-4.143-1.133-8.257-1.282-12.156.598 2.645.912 7.094 1.817 11.642zm.363-26.857c-.071.464-.42 2.068-1.09 5.397.007.464-.2.442-.299.528l.05.035s-.079.385-.15.97c-.057.578-.192 1.348-.221 2.132-.093 1.561-.185 3.158-.192 3.28l-.25-.05c-.007-1.555.05-3.637.406-5.619.264-1.996.784-3.9 1.126-5.183.364-1.283.684-1.94.62-1.476z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#f8eefe",
        d: "M-22.563 146.762c0-.078.014-.157.021-.235a42 42 0 0 0 .093-1.654c0-.121.014-.235.014-.356q.03-.982.007-1.975c0-.122-.007-.25-.014-.371a32 32 0 0 0-.086-1.633l-.042-.542a32 32 0 0 0-.228-1.989l7.958 2.025c1.226.314 2.537.642 3.912.991.549.143 1.104.278 1.674.421q.855.212 1.71.435c1.154.292 2.323.584 3.491.876s2.337.592 3.492.877q.865.215 1.71.428c2.536.635 4.93 1.234 6.982 1.733q.341.087.67.164c.876.214 1.674.406 2.38.577.527.129 1.011.243 1.425.342q.63.149 1.068.243c.585.128.898.185.884.157v.071q-.002.065-.014.171v.029c0 .071-.015.164-.022.263 0 .029 0 .05-.007.079q-.012.159-.035.349.002.043-.008.086-.019.213-.05.47v.022c-.02.178-.035.363-.064.57 0 .029 0 .05-.007.071-.021.193-.042.407-.07.621 0 .05-.015.092-.015.142-.029.221-.05.449-.079.685 0 .05-.014.099-.02.149-.03.243-.065.492-.094.756l-.02.178q-.055.404-.108.842a.4.4 0 0 1-.014.085q-.055.439-.121.899c0 .035-.014.078-.014.114-.043.313-.093.627-.136.955-.007.064-.021.128-.028.192l-.15.97c-.014.079-.021.15-.036.228-.05.335-.106.67-.163 1.02-.015.071-.022.142-.036.214-.057.356-.121.72-.185 1.083-.007.05-.022.1-.029.15a59 59 0 0 1-.2 1.112c0 .036-.014.064-.02.1-.072.385-.143.777-.222 1.177-.014.064-.02.128-.035.192l-.171.856c4.353.755 8.87 1.24 13.495 1.475 8.77.442 17.292-.149 25.215-1.868 17.007-3.686 31.165-12.69 38.86-28.318 1.403-2.845 2.579-5.911 3.54-9.198a63.012 63.012 0 0 1-.007.015 48 48 0 0 1-1.424-.45 70 70 0 0 1-8.928-3.557c-.47-.228-.94-.464-1.41-.699a58.7 58.7 0 0 1-9.142-5.746 78 78 0 0 1-1.197-.949 51 51 0 0 1-5.508-5.211 44 44 0 0 1-1.973-2.318 49 49 0 0 1-4.318-6.366 47 47 0 0 1-1.46-2.78 49.41 49.41 0 0 1-.67-1.441 56 56 0 0 1-1.226-2.987 56 56 0 0 1-1.788-5.718 61 61 0 0 1-1.44-7.786 71 71 0 0 1-.463-6.759c-.035-1.754 0-3.55.086-5.39.3-5.982 1.218-11.4 2.657-16.312-7.331-2.24-15.254-3.55-23.498-3.964-9.22-.464-18.083.128-26.255 1.896-17.157 3.707-31.18 12.698-38.825 28.24-3.49 7.102-5.7 15.529-6.198 25.517-.492 9.839.84 18.331 3.57 25.667 2.928 7.871 7.516 14.352 13.373 19.571z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#eed7fc",
        d: "M52.612 66.148a76 76 0 0 0-.085 5.39c.042 2.331.2 4.584.463 6.758a59 59 0 0 0 1.439 7.786 56 56 0 0 0 1.788 5.718c.378 1.02.791 2.018 1.226 2.987a48.81 48.81 0 0 0 2.13 4.22 48 48 0 0 0 4.318 6.368 52 52 0 0 0 1.974 2.317 50.993 50.993 0 0 0 6.705 6.16c2.82 2.174 5.877 4.085 9.14 5.746q.696.355 1.411.699c2.843 1.369 5.829 2.545 8.928 3.558.47.157.948.299 1.425.449.335-1.141.634-2.31.912-3.508q.077-.323.142-.656.288-1.326.535-2.695c.071-.392.135-.784.2-1.183q.115-.73.22-1.469c.114-.806.207-1.626.292-2.46.036-.342.064-.698.093-1.041.078-.912.15-1.832.2-2.773 0-.093.014-.185.02-.278v-.064c.357-7.03-.213-13.383-1.545-19.115a60 60 0 0 0-.955-3.593 53 53 0 0 0-1.112-3.308A48.869 48.869 0 0 0 83.2 66.675c-3.761-4.228-8.229-7.778-13.266-10.687a62 62 0 0 0-3.662-1.947 71 71 0 0 0-9.605-3.87q-.682-.225-1.375-.429h-.014c-.007.029-.014.05-.022.079-1.439 4.912-2.358 10.33-2.657 16.312z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#b)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#fff",
        d: "M58.287-67h418.734v400.9H58.287z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        fill: "#f0f1f2",
        clipPath: "url(#c)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M101 18h342v8H101zM91 38h352v8H91z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        filter: "url(#d)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: 299.5,
        height: 18,
        x: 40,
        y: 10.171,
        fill: "#fff",
        rx: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#e)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#bf63f3",
        d: "M47.69 16.256a.68.68 0 0 1 .669.006l1.625.938.385.222a.68.68 0 0 1 .34.588v2.32a.677.677 0 0 1-.34.588l-1.51.872a1 1 0 0 0 .052-.3v-2.32a.89.89 0 0 0-.447-.771l-.279-.161-.847-.489v-.898a.68.68 0 0 1 .34-.587z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#bf63f3",
        d: "m47.178 16.553-1.51.871a.68.68 0 0 0-.34.589v2.319c0 .242.13.467.34.589l.358.206 1.652.953a.682.682 0 0 0 1.02-.588v-.899l-.874-.504-.252-.145a.89.89 0 0 1-.446-.772v-2.319a.9.9 0 0 1 .052-.3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#1868db",
        fillRule: "evenodd",
        d: "m47.824 20.09-1.798 1.037-.358-.206a.68.68 0 0 1-.34-.589v-2.32c0-.243.129-.467.34-.588l1.51-.872-.01.029a.9.9 0 0 0-.042.272v2.32c0 .318.17.612.446.77z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#bf63f3",
        fillRule: "evenodd",
        d: "m48.185 18.238-.847-.489v-.898a.68.68 0 0 1 .34-.587l.012-.008a.68.68 0 0 1 .669.006l1.625.938z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#fca700",
        fillRule: "evenodd",
        d: "m50.369 17.422-.385-.222-1.799 1.038.28.16a.89.89 0 0 1 .446.772v2.32a.9.9 0 0 1-.053.3l1.511-.872a.68.68 0 0 0 .34-.588v-2.32a.68.68 0 0 0-.34-.588",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#82b536",
        fillRule: "evenodd",
        d: "m47.824 20.09-1.798 1.037 1.652.953a.682.682 0 0 0 1.02-.588v-.899z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: 31,
        height: 5,
        x: 54,
        y: 16.671,
        fill: "#dddee1",
        rx: 1.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#6b6e76",
        d: "m94.337 18.617-1.687 1.688a.21.21 0 0 1-.282.014l-.016-.014-1.688-1.688.298-.298 1.539 1.538 1.538-1.538z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#505258",
        fillRule: "evenodd",
        d: "M106.501 16.398a.75.75 0 0 1 1.061 0l.462.462a.75.75 0 0 1 0 1.06l-3.037 3.037a.75.75 0 0 1-.383.205l-1.268.254a.282.282 0 0 1-.331-.331l.254-1.267a.75.75 0 0 1 .205-.384zm.663.397a.187.187 0 0 0-.265 0l-.36.36.727.728.36-.36a.186.186 0 0 0 0-.266zm-.296 1.486-.727-.728-2.279 2.28a.2.2 0 0 0-.052.095l-.17.854.853-.171a.2.2 0 0 0 .096-.051zm.555 1.45a.282.282 0 0 1 .529 0l.231.633.632.23a.281.281 0 0 1 0 .53l-.632.23-.231.632a.282.282 0 0 1-.529 0l-.23-.632-.633-.23a.281.281 0 0 1 0-.53l.633-.23z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: 38.5,
        height: 5,
        x: 112,
        y: 16.671,
        fill: "#dddee1",
        rx: 1.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#0b1228",
        fillOpacity: 0.06,
        d: "M156.5 10.171h.5v18h-.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#505258",
        fillRule: "evenodd",
        d: "M166.805 17.109H165v-.563h4.125v.563h-1.758v4.687h-.562zm2.695 1.5v-.938h.562v.938H171v.562h-.938v1.875c0 .104.084.188.188.188h.75v.562h-.75a.75.75 0 0 1-.75-.75v-1.875h-.75v-.562z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#f)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#505258",
        fillRule: "evenodd",
        d: "M181.125 16.968c0-.233.189-.422.422-.422h1.734c.845 0 1.594.61 1.594 1.524 0 .367-.121.685-.321.934.414.261.696.708.696 1.269 0 .914-.749 1.523-1.594 1.523h-2.109a.42.42 0 0 1-.422-.422zm2.156 1.781c.45 0 .75-.299.75-.68 0-.38-.3-.679-.75-.679h-1.312v1.36zm-1.312.844h1.687c.45 0 .75.3.75.68s-.3.68-.75.68h-1.687z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#6b6e76",
        d: "m196.837 18.617-1.687 1.688a.21.21 0 0 1-.283.014l-.015-.014-1.688-1.688.298-.298 1.539 1.538 1.538-1.538z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#g)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#505258",
        fillRule: "evenodd",
        d: "M206.188 17.765a.562.562 0 1 1 1.124-.001.562.562 0 0 1-1.124.001m0 2.813a.562.562 0 1 1 1.124-.002.562.562 0 0 1-1.124.002M212 18.046h-3.75v-.562H212zm0 2.813h-3.75v-.563H212z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#6b6e76",
        d: "m222.837 18.617-1.687 1.688a.21.21 0 0 1-.283.014l-.015-.014-1.688-1.688.298-.298 1.539 1.538 1.538-1.538z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#505258",
        fillRule: "evenodd",
        d: "M238.625 17.484h-5.25v-.563h5.25zm0 1.968h-5.25v-.562h5.25zM236 21.423h-2.625v-.563H236z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: 10.135,
        height: 10.135,
        x: 246.932,
        y: 14.104,
        stroke: "#0b1228",
        strokeOpacity: 0.14,
        strokeWidth: 0.365,
        rx: 2.068
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        stroke: "#505258",
        strokeLinejoin: "round",
        strokeWidth: 0.637,
        d: "M249.938 21.609v-.179l.609-1.605m3.433 1.784v-.179l-.606-1.605m0 0-1.169-3.091h-.484l-1.174 3.091m2.827 0h-2.827"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#505258",
        fillRule: "evenodd",
        d: "M268.082 17.004a1.475 1.475 0 0 1 2.086 2.085l-.844.844-.398-.398.844-.844a.912.912 0 0 0-1.29-1.29l-.844.844-.397-.398zm1.148 1.335-2.062 2.062-.398-.397 2.062-2.063zm-3.398.915.844-.844.398.398-.844.843a.912.912 0 0 0 1.29 1.29l.844-.844.397.398-.843.844a1.475 1.475 0 0 1-2.086-2.085M280 17.343c0-.544.441-.984.984-.984h4.032c.543 0 .984.44.984.984v3.094a.985.985 0 0 1-.984.984h-3.348l-1.247.713a.282.282 0 0 1-.421-.244zm.984-.422a.42.42 0 0 0-.422.422v4.062l.957-.546h3.497a.42.42 0 0 0 .422-.422v-3.094a.42.42 0 0 0-.422-.422zm3.516 1.688h-3v-.563h3zm-1.125 1.125H281.5v-.563h1.875z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: 29.5,
        height: 5,
        x: 289,
        y: 16.671,
        fill: "#dddee1",
        rx: 1.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#505258",
        fillRule: "evenodd",
        d: "M327.5 19.171a.562.562 0 1 1 1.125 0 .562.562 0 0 1-1.125 0m2.438 0a.562.562 0 1 1 1.124-.001.562.562 0 0 1-1.124.001m2.437 0a.563.563 0 1 1 1.125 0 .563.563 0 0 1-1.125 0",
        clipRule: "evenodd"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#0c66e4",
        fillOpacity: 0.14,
        d: "M314 34.745H147.042v14.637H314z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M137.436 32h17.153v18.297h-17.153z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        filter: "url(#h)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#fff",
        d: "M149.798 30.711a6 6 0 0 0-3.969 1.338 6.03 6.03 0 0 0-3.968-1.338h-1.143v3.43h1.143c1.613 0 2.116.801 2.287 1.144v4.506h-1.143v3.43h1.143v3.431c-.148.343-.651 1.144-2.287 1.144h-1.143v3.43h1.143a6.03 6.03 0 0 0 3.968-1.338 5.97 5.97 0 0 0 3.969 1.338h1.143v-3.43h-1.143c-1.613 0-2.116-.8-2.288-1.144v-3.43h1.213V39.79h-1.144v-4.506c.149-.343.652-1.143 2.287-1.143h1.144V30.71z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#000",
        d: "M149.798 32.998v-1.143a4.57 4.57 0 0 0-3.969 1.875 4.57 4.57 0 0 0-3.968-1.875v1.143a3.21 3.21 0 0 1 3.431 2.104v5.832h-1.144v1.144h1.144v4.757a3.234 3.234 0 0 1-3.431 2.104v1.144a4.64 4.64 0 0 0 3.968-1.864 4.64 4.64 0 0 0 3.969 1.864v-1.144a3.225 3.225 0 0 1-3.362-2.104v-4.769h1.143v-1.143h-1.143v-5.81a3.21 3.21 0 0 1 3.362-2.115"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#fff",
        d: "M-259-131.5h684v385h-684z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "b"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: 419.213,
        height: 220.555,
        x: 58.287,
        y: -67,
        fill: "#fff",
        rx: 5.243
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "c"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#fff",
        d: "M31.03-38.464a3.93 3.93 0 0 1 3.932-3.932h487.582v374.861H31.03z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "e"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: 57,
        height: 14,
        x: 42,
        y: 12.171,
        fill: "#fff",
        rx: 2
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "f"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#fff",
        d: "M177 14.171a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-20a2 2 0 0 1-2-2z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "g"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#fff",
        d: "M203 14.171a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-20a2 2 0 0 1-2-2z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("filter", {
        id: "d",
        width: 311.5,
        height: 30,
        x: 34,
        y: 8.171,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", {
        dy: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
        stdDeviation: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.15 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_13945_18711"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
        stdDeviation: 0.25
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
        in2: "effect1_dropShadow_13945_18711",
        result: "effect2_dropShadow_13945_18711"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_13945_18711",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("filter", {
        id: "h",
        width: 14.292,
        height: 24.521,
        x: 138.718,
        y: 29.708,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", {
        dy: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
        stdDeviation: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_13945_18711"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect1_dropShadow_13945_18711",
        result: "shape"
    }))));
const $3faf0024169aae07$var$NewToolbarBannerImageDark = ({ title: title, titleId: titleId, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "auto",
        height: "56px",
        viewBox: "0 0 477 56",
        fill: "none",
        "aria-labelledby": titleId,
        ...props
    }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("title", {
        id: titleId
    }, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
        id: "b",
        width: 686,
        height: 389,
        x: -260,
        y: -132.5,
        fill: "#000",
        maskUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#fff",
        d: "M-260-132.5h686v389h-686z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M294.605 253.507c-6.897-11.892-11.863-24.504-11.863-36.069 0-2.345.086-4.662.25-6.958.498-6.873 2.073-12.997 4.495-18.38.314-.699.642-1.376.984-2.047.099-.199.206-.399.306-.598.185-.35.378-.699.57-1.041 6.562-11.771 17.428-19.479 29.647-23.122a56 56 0 0 1 3.912-1.005 59.8 59.8 0 0 1 11.15-1.397c.428-.015.863-.036 1.29-.036v-.043c.086 0 .164.022.25.022s.163-.022.249-.022v.043c.292 0 .577.021.869.028 3.976.093 7.93.585 11.792 1.462q.771.17 1.532.364c.199.05.392.107.591.164q1.602.427 3.171.941c6.191 2.046 11.998 5.154 17.021 9.332a46.7 46.7 0 0 1 7.004 7.223c5.722 7.315 9.548 16.683 10.381 28.126.164 2.296.25 4.62.25 6.959 0 2.203-.185 4.441-.52 6.709-.036.242-.079.484-.121.72-.036.235-.079.463-.122.698-.078.45-.163.892-.256 1.341-1.788 8.791-5.8 17.888-10.851 26.6h48.407V-38.743c-3.142 2.787-6.548 5.233-10.175 7.372-19.173 11.293-44.36 14.01-67.787 14.01H282.03c-14.592 0-24.646 6.038-24.646 21.645 0 4.534 1.005 11.578 1.504 17.11h-59.359c-.684-5.154-1.603-11.478-2.123-20.418h-39.829c-.627-4.72-1.453-10.424-1.98-18.217a223 223 0 0 1-.492-11.885 247 247 0 0 1-.036-4.627c0-2.388.072-4.72.2-7.001 0-.071.007-.136.014-.207.007-.17.021-.342.036-.506.028-.392.05-.784.078-1.17.164-2.152.385-4.263.663-6.316.377-2.738.855-5.39 1.446-7.95a79.954 79.954 0 0 1 2.081-7.408c8.785-26.137 30.252-41.173 63.263-43.968 3.754-.321 7.652-.477 11.699-.477h74.442c1.211 0 2.379-.036 3.527-.1l.648-.043c13.039-.87 21.888-6.01 25.771-16.961.043-.122.093-.243.136-.364q.246-.728.463-1.476c.035-.114.057-.228.092-.342a39 39 0 0 0 .784-3.458H101.418c-4.51 20.719-12.006 37.659-23.056 50.635 6.761.527 13.836 1.34 21.24 2.466L90.01-15.001c-46.583-6.352-68.535 5.454-73.33 37.146l-61.952-9.383C-41.253-13.79-33.116-34.98-19.9-50.5a293 293 0 0 1-21.24-2.467l9.59-63.397c33.51 4.57 54.279-.256 65.073-15.122H-88.834c10.503 6.531 17.792 16.976 20.499 30.936.705 3.65 1.104 7.55 1.161 11.67.057 4.072-.228 7.922-.826 11.544-3.285 19.991-16.117 33.138-34.556 38.086-.143.036-.292.079-.435.114-.613.157-1.226.307-1.853.45-.192.042-.384.092-.584.135q-1.152.247-2.337.463c-3.014.535-6.156.856-9.398.984-.648.029-1.296.057-1.952.065a80 80 0 0 1-4.56-.086c-.598-.029-1.19-.05-1.781-.093a71 71 0 0 1-5.508-.606 56 56 0 0 1-2.23-.385c-.185-.035-.363-.071-.549-.107a67 67 0 0 1-1.717-.363q-.234-.053-.47-.114a42 42 0 0 1-1.909-.492l-.164-.043c-12.141-3.365-21.824-10.374-27.88-20.669-4.126 6.98-9.954 12.463-17.115 16.32l.406.15a50.24 50.24 0 0 1-2.322 1.197c-.15-.05-.307-.107-.456-.157-.171.079-.349.164-.528.243.193.071.335.135.414.178q-.01.002-.029.014c-.149-.05-.313-.107-.47-.157a54 54 0 0 1-8.329 2.966c-.143.036-.292.079-.435.114-.613.157-1.225.307-1.852.45-.193.042-.385.092-.585.135q-1.152.247-2.337.463c-3.013.535-6.156.856-9.397.984-.649.029-1.297.058-1.953.065a77 77 0 0 1-6.056-.157 68 68 0 0 1-5.793-.635c-.256-.035-.505-.085-.755-.128l.107.356a62 62 0 0 1-2.601-.485c-.035-.12-.078-.235-.114-.356a53 53 0 0 1-1.132-.25 11 11 0 0 1-.471-.114 42 42 0 0 1-1.909-.491l-.164-.043c-13.103-3.622-23.32-11.472-29.241-23.107v315.949h36.416c-2.009-6.438-3.135-13.739-3.135-21.788 0-5.069.449-9.775 1.275-14.138a64 64 0 0 1 .984-4.363 61 61 0 0 1 2.678-8.007 56 56 0 0 1 1.483-3.23c.042-.085.085-.164.128-.249l.192-.357c.335-.648.67-1.304 1.026-1.932a50.7 50.7 0 0 1 12.262-14.452 55 55 0 0 1 5.052-3.629 58 58 0 0 1 5.472-3.08c.335-.164.677-.313 1.012-.47a59 59 0 0 1 2.472-1.112 71 71 0 0 1 8.564-2.988c7.88-2.217 16.024-3.272 25.294-3.272 1.503 0 2.992.035 4.474.093 1.112.042 2.223.099 3.321.178 6.462.435 12.682 1.433 18.51 3.058.606.171 1.197.357 1.789.542q.267.064.534.15h-.014c.093-.029.185-.057.285-.078l.256.085c8.479-2.246 17.82-3.358 27.738-3.358v.064c14.87 0 28.607 2.446 40.121 7.593 6.384 2.816 12.027 6.431 16.815 10.958 10.26 9.797 16.416 23.143 16.416 41.994 0 8.099-1.183 15.35-3.363 21.774H71.586c5.45-6.83 8.208-17.639 8.393-33.074l40.392-.115h.22c.271 15.55 3.007 26.387 8.458 33.175h43.498c5.593-6.816 8.415-17.703 8.607-33.346h.492l40.391-.121c.278 15.764 3.078 26.694 8.678 33.459h63.905zm-413.948-123.792 7.802-6.174c-.506-.192-1.026-.371-1.368-.428.014-.121-.185-.185-.228-.242v.107c-5.273-4.378-14.856-8.741-21.425-13.047-4.268 5.404-9.526 8.89-15.354 10.516.235.199.456.399.677.584-.727.214-1.461.407-2.202.564l-.727-.621c-5.044.977-10.466.628-16.01-1.019a45.6 45.6 0 0 1-6.925-2.695 46.7 46.7 0 0 1-6.683-3.914c-3.933-2.781-7.118-6.032-9.448-9.668-.078-.014-.15-.029-.228-.036l-.121-.021a29 29 0 0 1-1.347-2.51c.086.015.171.029.257.05-1.96-3.835-3.021-8.028-3.093-12.49-4.075-.308-7.98-.593-11.528-.82l.449-.229c-.969.107-1.853.121-2.708.1-.071.314-.135.62-.22.934a22.3 22.3 0 0 1-1.411 3.721 22.7 22.7 0 0 1-1.995 3.38c-4.389 6.082-11.001 7.964-18.005 5.889a24 24 0 0 1-3.605-1.404 24 24 0 0 1-3.477-2.04c-5.978-4.22-8.622-10.544-6.627-17.738a22.5 22.5 0 0 1 1.397-3.672 22 22 0 0 1 2.024-3.422c4.389-6.046 10.972-7.914 17.983-5.875 1.24.364 2.501.841 3.755 1.455a24.4 24.4 0 0 1 3.341 1.946c5.031 3.522 7.688 8.57 7.211 14.395 1.845.164 3.163.313 3.163.313l5.401.05s2.722.079 4.938.057a34 34 0 0 1 1.161-6.438q.96-3.467 2.679-7.05a43 43 0 0 1 3.898-6.582c5.885-8.106 13.822-12.298 22.664-12.769.492-8.17.948-16.398 2.23-22.059.748 2.638.072-6.46.592-6.973l.199.364c.364-.585-.235-2.431.542-2.574.014-.114.014-.306.014-.563l-13.78 1.982-5.123-35.584 35.568-5.126 5.123 35.584-20.206 2.909c-.549 6.901-1.226 13.51-1.468 14.23-.064-.12.121-.705-.292-.734-.086 1.034-.071 2.125-.15 3.223.649-.285.321-1.64.527-1.74.072 4.1-.584 12.42-1.232 17.019 3.042.085 6.177.584 9.355 1.51a47.4 47.4 0 0 1 7.218 2.789 45.6 45.6 0 0 1 6.419 3.743c3.912 2.737 7.075 5.946 9.398 9.546.164-.107.335-.214.499-.32a6 6 0 0 0-.392.491 1 1 0 0 1 .078.136c1.219-.685 8.949-7.593 9.797-7.743-.035.057-.292.47-.335.542 1.019-.37 3-2.802 3.727-2.396.185-.128.506-.392.919-.748-3.05-3.864-4.104-8.691-2.636-13.989a22.5 22.5 0 0 1 1.396-3.671 22 22 0 0 1 2.024-3.423c4.389-6.045 10.972-7.913 17.983-5.874 1.24.363 2.501.84 3.755 1.454a24.5 24.5 0 0 1 3.342 1.946c5.977 4.185 8.628 10.517 6.612 17.753a22 22 0 0 1-1.411 3.722 22.7 22.7 0 0 1-1.995 3.38c-4.39 6.08-11.001 7.963-18.005 5.888a24 24 0 0 1-3.605-1.404 24 24 0 0 1-3.477-2.04 20 20 0 0 1-2.971-2.552 1166 1166 0 0 1-14.272 10.624c.52.94.983 1.91 1.397 2.901q.173.396.335.792v.028c2.166 5.74 2.451 12.199.534 19.086q-.972 3.508-2.715 7.144c-.014.029-.035.064-.049.093.149.092.299.178.448.271-.05.107-.092.214-.142.313a45 45 0 0 1-1.055 2.047c-.156-.093-.32-.186-.477-.286a43 43 0 0 1-1.967 3.187c3.021 1.512 7.304 4.107 9.498 5.725-.335-.071-1.083-.37-1.86-.834l-.142.214c1.824 1.013 3.249 2.995 5.422 3.152 0 0-2.109-1.562-2.487-2.004l.029-.014-.014-.043c4.26 2.189 9.17 5.183 13.409 7.65l17.97-14.223 22.293 28.197-28.179 22.309-22.294-28.198zm364.665 16.94c.498.421 0-65.421 0-65.421 31.592 11 68.499.563 68.499.563v64.58c-23.277 6.488-68.499.286-68.499.286zM362.058 3.371v35.905c18.161-.463 32.183-4.428 32.183-4.428v64.58c-23.277 6.489-68.499.286-68.499.286.228.192.249-13.81.199-28.91-17.257-.493-32.383-2.575-32.383-2.575.499.421 0-65.421 0-65.421 31.592 11.001 68.5.563 68.5.563M103.05 205.154a32 32 0 0 1-5.059.414 32 32 0 0 1-5.265-.414c-9.47-1.554-16.21-7.508-17.97-17.133a29.4 29.4 0 0 1-.456-5.126q-.001-2.759.435-5.197c1.717-9.647 8.422-15.628 17.862-17.233a32 32 0 0 1 5.266-.442q2.641 0 5.058.385c9.448 1.512 16.196 7.472 17.963 17.161.299 1.626.456 3.366.456 5.198q-.002 2.716-.421 5.133c-1.703 9.689-8.422 15.7-17.876 17.261zm31.813-58.263c-2.43-4.906-3.691-12.185-4.346-18.744-3.72.264-7.546.321-11.429.192-.691-.021-1.375-.042-2.073-.071h-.071l-.685-.043c-.185-.007-.363-.021-.548-.035-7.788-.478-15.283-1.754-22.237-3.872-.955 3.28-2.138 6.353-3.541 9.197-7.695 15.622-21.86 24.626-38.86 28.319-7.923 1.719-16.445 2.31-25.215 1.868-4.632-.235-9.142-.72-13.495-1.475-1.304 6.459-3.292 13.574-6.199 18.209l-36.872-9.155s7.061-11.151 8.144-24.519c-5.857-5.219-10.445-11.699-13.374-19.571-2.728-7.336-4.06-15.827-3.57-25.666.5-9.982 2.708-18.416 6.2-25.517 7.645-15.55 21.667-24.533 38.824-28.24 8.172-1.769 17.036-2.36 26.255-1.897 8.244.413 16.174 1.725 23.499 3.964.007-.029.014-.05.02-.078h.015a58 58 0 0 1 3.534-9.133c.036-.079.078-.15.121-.221a47 47 0 0 1 1.226-2.296c7.951-14.088 21.439-22.316 37.463-25.795.94-.207 1.888-.392 2.843-.563.926-.165 1.859-.314 2.807-.457 6.27-.92 12.847-1.197 19.565-.855 6.213.313 12.213 1.098 17.898 2.352a86 86 0 0 1 3.663.892l.733.192c.086.022.179.043.271.071.114.029.228.057.342.093.755.214 1.504.45 2.252.677.256.079.52.15.776.236 7.667 2.48 14.557 6.01 20.356 10.659a52 52 0 0 1 3.078 2.673 49 49 0 0 1 3.67 3.836c.292.342.577.684.862 1.04.192.236.378.478.57.714q.832 1.07 1.61 2.181a49.4 49.4 0 0 1 5.665 10.887c2.764 7.415 4.111 16.028 3.612 26.01-.492 9.838-2.672 18.151-6.12 25.174-3.228 6.566-7.61 11.956-12.882 16.284-.563.463-1.14.906-1.725 1.348-.22.164-.434.328-.655.492-.257 13.41 5.65 25.224 5.65 25.224l-37.606 5.412zm89.718 40.717c-1.703 9.689-8.422 15.699-17.877 17.261-1.61.264-3.299.406-5.058.413-1.832 0-3.592-.135-5.266-.413-9.469-1.554-16.209-7.508-17.969-17.133a29.4 29.4 0 0 1-.456-5.126c0-1.832.142-3.572.434-5.197 1.718-9.647 8.422-15.629 17.863-17.233a32 32 0 0 1 5.265-.442c1.76 0 3.449.129 5.059.385 9.448 1.512 16.195 7.472 17.962 17.161.299 1.626.456 3.365.456 5.198a30 30 0 0 1-.42 5.133z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#48245d",
        d: "M294.605 253.507c-6.897-11.892-11.863-24.504-11.863-36.069 0-2.345.086-4.662.25-6.958.498-6.873 2.073-12.997 4.495-18.38.314-.699.642-1.376.984-2.047.099-.199.206-.399.306-.598.185-.35.378-.699.57-1.041 6.562-11.771 17.428-19.479 29.647-23.122a56 56 0 0 1 3.912-1.005 59.8 59.8 0 0 1 11.15-1.397c.428-.015.863-.036 1.29-.036v-.043c.086 0 .164.022.25.022s.163-.022.249-.022v.043c.292 0 .577.021.869.028 3.976.093 7.93.585 11.792 1.462q.771.17 1.532.364c.199.05.392.107.591.164q1.602.427 3.171.941c6.191 2.046 11.998 5.154 17.021 9.332a46.7 46.7 0 0 1 7.004 7.223c5.722 7.315 9.548 16.683 10.381 28.126.164 2.296.25 4.62.25 6.959 0 2.203-.185 4.441-.52 6.709-.036.242-.079.484-.121.72-.036.235-.079.463-.122.698-.078.45-.163.892-.256 1.341-1.788 8.791-5.8 17.888-10.851 26.6h48.407V-38.743c-3.142 2.787-6.548 5.233-10.175 7.372-19.173 11.293-44.36 14.01-67.787 14.01H282.03c-14.592 0-24.646 6.038-24.646 21.645 0 4.534 1.005 11.578 1.504 17.11h-59.359c-.684-5.154-1.603-11.478-2.123-20.418h-39.829c-.627-4.72-1.453-10.424-1.98-18.217a223 223 0 0 1-.492-11.885 247 247 0 0 1-.036-4.627c0-2.388.072-4.72.2-7.001 0-.071.007-.136.014-.207.007-.17.021-.342.036-.506.028-.392.05-.784.078-1.17.164-2.152.385-4.263.663-6.316.377-2.738.855-5.39 1.446-7.95a79.954 79.954 0 0 1 2.081-7.408c8.785-26.137 30.252-41.173 63.263-43.968 3.754-.321 7.652-.477 11.699-.477h74.442c1.211 0 2.379-.036 3.527-.1l.648-.043c13.039-.87 21.888-6.01 25.771-16.961.043-.122.093-.243.136-.364q.246-.728.463-1.476c.035-.114.057-.228.092-.342a39 39 0 0 0 .784-3.458H101.418c-4.51 20.719-12.006 37.659-23.056 50.635 6.761.527 13.836 1.34 21.24 2.466L90.01-15.001c-46.583-6.352-68.535 5.454-73.33 37.146l-61.952-9.383C-41.253-13.79-33.116-34.98-19.9-50.5a293 293 0 0 1-21.24-2.467l9.59-63.397c33.51 4.57 54.279-.256 65.073-15.122H-88.834c10.503 6.531 17.792 16.976 20.499 30.936.705 3.65 1.104 7.55 1.161 11.67.057 4.072-.228 7.922-.826 11.544-3.285 19.991-16.117 33.138-34.556 38.086-.143.036-.292.079-.435.114-.613.157-1.226.307-1.853.45-.192.042-.384.092-.584.135q-1.152.247-2.337.463c-3.014.535-6.156.856-9.398.984-.648.029-1.296.057-1.952.065a80 80 0 0 1-4.56-.086c-.598-.029-1.19-.05-1.781-.093a71 71 0 0 1-5.508-.606 56 56 0 0 1-2.23-.385c-.185-.035-.363-.071-.549-.107a67 67 0 0 1-1.717-.363q-.234-.053-.47-.114a42 42 0 0 1-1.909-.492l-.164-.043c-12.141-3.365-21.824-10.374-27.88-20.669-4.126 6.98-9.954 12.463-17.115 16.32l.406.15a50.24 50.24 0 0 1-2.322 1.197c-.15-.05-.307-.107-.456-.157-.171.079-.349.164-.528.243.193.071.335.135.414.178q-.01.002-.029.014c-.149-.05-.313-.107-.47-.157a54 54 0 0 1-8.329 2.966c-.143.036-.292.079-.435.114-.613.157-1.225.307-1.852.45-.193.042-.385.092-.585.135q-1.152.247-2.337.463c-3.013.535-6.156.856-9.397.984-.649.029-1.297.058-1.953.065a77 77 0 0 1-6.056-.157 68 68 0 0 1-5.793-.635c-.256-.035-.505-.085-.755-.128l.107.356a62 62 0 0 1-2.601-.485c-.035-.12-.078-.235-.114-.356a53 53 0 0 1-1.132-.25 11 11 0 0 1-.471-.114 42 42 0 0 1-1.909-.491l-.164-.043c-13.103-3.622-23.32-11.472-29.241-23.107v315.949h36.416c-2.009-6.438-3.135-13.739-3.135-21.788 0-5.069.449-9.775 1.275-14.138a64 64 0 0 1 .984-4.363 61 61 0 0 1 2.678-8.007 56 56 0 0 1 1.483-3.23c.042-.085.085-.164.128-.249l.192-.357c.335-.648.67-1.304 1.026-1.932a50.7 50.7 0 0 1 12.262-14.452 55 55 0 0 1 5.052-3.629 58 58 0 0 1 5.472-3.08c.335-.164.677-.313 1.012-.47a59 59 0 0 1 2.472-1.112 71 71 0 0 1 8.564-2.988c7.88-2.217 16.024-3.272 25.294-3.272 1.503 0 2.992.035 4.474.093 1.112.042 2.223.099 3.321.178 6.462.435 12.682 1.433 18.51 3.058.606.171 1.197.357 1.789.542q.267.064.534.15h-.014c.093-.029.185-.057.285-.078l.256.085c8.479-2.246 17.82-3.358 27.738-3.358v.064c14.87 0 28.607 2.446 40.121 7.593 6.384 2.816 12.027 6.431 16.815 10.958 10.26 9.797 16.416 23.143 16.416 41.994 0 8.099-1.183 15.35-3.363 21.774H71.586c5.45-6.83 8.208-17.639 8.393-33.074l40.392-.115h.22c.271 15.55 3.007 26.387 8.458 33.175h43.498c5.593-6.816 8.415-17.703 8.607-33.346h.492l40.391-.121c.278 15.764 3.078 26.694 8.678 33.459h63.905zm-413.948-123.792 7.802-6.174c-.506-.192-1.026-.371-1.368-.428.014-.121-.185-.185-.228-.242v.107c-5.273-4.378-14.856-8.741-21.425-13.047-4.268 5.404-9.526 8.89-15.354 10.516.235.199.456.399.677.584-.727.214-1.461.407-2.202.564l-.727-.621c-5.044.977-10.466.628-16.01-1.019a45.6 45.6 0 0 1-6.925-2.695 46.7 46.7 0 0 1-6.683-3.914c-3.933-2.781-7.118-6.032-9.448-9.668-.078-.014-.15-.029-.228-.036l-.121-.021a29 29 0 0 1-1.347-2.51c.086.015.171.029.257.05-1.96-3.835-3.021-8.028-3.093-12.49-4.075-.308-7.98-.593-11.528-.82l.449-.229c-.969.107-1.853.121-2.708.1-.071.314-.135.62-.22.934a22.3 22.3 0 0 1-1.411 3.721 22.7 22.7 0 0 1-1.995 3.38c-4.389 6.082-11.001 7.964-18.005 5.889a24 24 0 0 1-3.605-1.404 24 24 0 0 1-3.477-2.04c-5.978-4.22-8.622-10.544-6.627-17.738a22.5 22.5 0 0 1 1.397-3.672 22 22 0 0 1 2.024-3.422c4.389-6.046 10.972-7.914 17.983-5.875 1.24.364 2.501.841 3.755 1.455a24.4 24.4 0 0 1 3.341 1.946c5.031 3.522 7.688 8.57 7.211 14.395 1.845.164 3.163.313 3.163.313l5.401.05s2.722.079 4.938.057a34 34 0 0 1 1.161-6.438q.96-3.467 2.679-7.05a43 43 0 0 1 3.898-6.582c5.885-8.106 13.822-12.298 22.664-12.769.492-8.17.948-16.398 2.23-22.059.748 2.638.072-6.46.592-6.973l.199.364c.364-.585-.235-2.431.542-2.574.014-.114.014-.306.014-.563l-13.78 1.982-5.123-35.584 35.568-5.126 5.123 35.584-20.206 2.909c-.549 6.901-1.226 13.51-1.468 14.23-.064-.12.121-.705-.292-.734-.086 1.034-.071 2.125-.15 3.223.649-.285.321-1.64.527-1.74.072 4.1-.584 12.42-1.232 17.019 3.042.085 6.177.584 9.355 1.51a47.4 47.4 0 0 1 7.218 2.789 45.6 45.6 0 0 1 6.419 3.743c3.912 2.737 7.075 5.946 9.398 9.546.164-.107.335-.214.499-.32a6 6 0 0 0-.392.491 1 1 0 0 1 .078.136c1.219-.685 8.949-7.593 9.797-7.743-.035.057-.292.47-.335.542 1.019-.37 3-2.802 3.727-2.396.185-.128.506-.392.919-.748-3.05-3.864-4.104-8.691-2.636-13.989a22.5 22.5 0 0 1 1.396-3.671 22 22 0 0 1 2.024-3.423c4.389-6.045 10.972-7.913 17.983-5.874 1.24.363 2.501.84 3.755 1.454a24.5 24.5 0 0 1 3.342 1.946c5.977 4.185 8.628 10.517 6.612 17.753a22 22 0 0 1-1.411 3.722 22.7 22.7 0 0 1-1.995 3.38c-4.39 6.08-11.001 7.963-18.005 5.888a24 24 0 0 1-3.605-1.404 24 24 0 0 1-3.477-2.04 20 20 0 0 1-2.971-2.552 1166 1166 0 0 1-14.272 10.624c.52.94.983 1.91 1.397 2.901q.173.396.335.792v.028c2.166 5.74 2.451 12.199.534 19.086q-.972 3.508-2.715 7.144c-.014.029-.035.064-.049.093.149.092.299.178.448.271-.05.107-.092.214-.142.313a45 45 0 0 1-1.055 2.047c-.156-.093-.32-.186-.477-.286a43 43 0 0 1-1.967 3.187c3.021 1.512 7.304 4.107 9.498 5.725-.335-.071-1.083-.37-1.86-.834l-.142.214c1.824 1.013 3.249 2.995 5.422 3.152 0 0-2.109-1.562-2.487-2.004l.029-.014-.014-.043c4.26 2.189 9.17 5.183 13.409 7.65l17.97-14.223 22.293 28.197-28.179 22.309-22.294-28.198zm364.665 16.94c.498.421 0-65.421 0-65.421 31.592 11 68.499.563 68.499.563v64.58c-23.277 6.488-68.499.286-68.499.286zM362.058 3.371v35.905c18.161-.463 32.183-4.428 32.183-4.428v64.58c-23.277 6.489-68.499.286-68.499.286.228.192.249-13.81.199-28.91-17.257-.493-32.383-2.575-32.383-2.575.499.421 0-65.421 0-65.421 31.592 11.001 68.5.563 68.5.563M103.05 205.154a32 32 0 0 1-5.059.414 32 32 0 0 1-5.265-.414c-9.47-1.554-16.21-7.508-17.97-17.133a29.4 29.4 0 0 1-.456-5.126q-.001-2.759.435-5.197c1.717-9.647 8.422-15.628 17.862-17.233a32 32 0 0 1 5.266-.442q2.641 0 5.058.385c9.448 1.512 16.196 7.472 17.963 17.161.299 1.626.456 3.366.456 5.198q-.002 2.716-.421 5.133c-1.703 9.689-8.422 15.7-17.876 17.261zm31.813-58.263c-2.43-4.906-3.691-12.185-4.346-18.744-3.72.264-7.546.321-11.429.192-.691-.021-1.375-.042-2.073-.071h-.071l-.685-.043c-.185-.007-.363-.021-.548-.035-7.788-.478-15.283-1.754-22.237-3.872-.955 3.28-2.138 6.353-3.541 9.197-7.695 15.622-21.86 24.626-38.86 28.319-7.923 1.719-16.445 2.31-25.215 1.868-4.632-.235-9.142-.72-13.495-1.475-1.304 6.459-3.292 13.574-6.199 18.209l-36.872-9.155s7.061-11.151 8.144-24.519c-5.857-5.219-10.445-11.699-13.374-19.571-2.728-7.336-4.06-15.827-3.57-25.666.5-9.982 2.708-18.416 6.2-25.517 7.645-15.55 21.667-24.533 38.824-28.24 8.172-1.769 17.036-2.36 26.255-1.897 8.244.413 16.174 1.725 23.499 3.964.007-.029.014-.05.02-.078h.015a58 58 0 0 1 3.534-9.133c.036-.079.078-.15.121-.221a47 47 0 0 1 1.226-2.296c7.951-14.088 21.439-22.316 37.463-25.795.94-.207 1.888-.392 2.843-.563.926-.165 1.859-.314 2.807-.457 6.27-.92 12.847-1.197 19.565-.855 6.213.313 12.213 1.098 17.898 2.352a86 86 0 0 1 3.663.892l.733.192c.086.022.179.043.271.071.114.029.228.057.342.093.755.214 1.504.45 2.252.677.256.079.52.15.776.236 7.667 2.48 14.557 6.01 20.356 10.659a52 52 0 0 1 3.078 2.673 49 49 0 0 1 3.67 3.836c.292.342.577.684.862 1.04.192.236.378.478.57.714q.832 1.07 1.61 2.181a49.4 49.4 0 0 1 5.665 10.887c2.764 7.415 4.111 16.028 3.612 26.01-.492 9.838-2.672 18.151-6.12 25.174-3.228 6.566-7.61 11.956-12.882 16.284-.563.463-1.14.906-1.725 1.348-.22.164-.434.328-.655.492-.257 13.41 5.65 25.224 5.65 25.224l-37.606 5.412zm89.718 40.717c-1.703 9.689-8.422 15.699-17.877 17.261-1.61.264-3.299.406-5.058.413-1.832 0-3.592-.135-5.266-.413-9.469-1.554-16.209-7.508-17.969-17.133a29.4 29.4 0 0 1-.456-5.126c0-1.832.142-3.572.434-5.197 1.718-9.647 8.422-15.629 17.863-17.233a32 32 0 0 1 5.265-.442c1.76 0 3.449.129 5.059.385 9.448 1.512 16.195 7.472 17.962 17.161.299 1.626.456 3.365.456 5.198a30 30 0 0 1-.42 5.133z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        stroke: "#48245d",
        strokeWidth: 2,
        d: "M294.605 253.507c-6.897-11.892-11.863-24.504-11.863-36.069 0-2.345.086-4.662.25-6.958.498-6.873 2.073-12.997 4.495-18.38.314-.699.642-1.376.984-2.047.099-.199.206-.399.306-.598.185-.35.378-.699.57-1.041 6.562-11.771 17.428-19.479 29.647-23.122a56 56 0 0 1 3.912-1.005 59.8 59.8 0 0 1 11.15-1.397c.428-.015.863-.036 1.29-.036v-.043c.086 0 .164.022.25.022s.163-.022.249-.022v.043c.292 0 .577.021.869.028 3.976.093 7.93.585 11.792 1.462q.771.17 1.532.364c.199.05.392.107.591.164q1.602.427 3.171.941c6.191 2.046 11.998 5.154 17.021 9.332a46.7 46.7 0 0 1 7.004 7.223c5.722 7.315 9.548 16.683 10.381 28.126.164 2.296.25 4.62.25 6.959 0 2.203-.185 4.441-.52 6.709-.036.242-.079.484-.121.72-.036.235-.079.463-.122.698-.078.45-.163.892-.256 1.341-1.788 8.791-5.8 17.888-10.851 26.6h48.407V-38.743c-3.142 2.787-6.548 5.233-10.175 7.372-19.173 11.293-44.36 14.01-67.787 14.01H282.03c-14.592 0-24.646 6.038-24.646 21.645 0 4.534 1.005 11.578 1.504 17.11h-59.359c-.684-5.154-1.603-11.478-2.123-20.418h-39.829c-.627-4.72-1.453-10.424-1.98-18.217a223 223 0 0 1-.492-11.885 247 247 0 0 1-.036-4.627c0-2.388.072-4.72.2-7.001 0-.071.007-.136.014-.207.007-.17.021-.342.036-.506.028-.392.05-.784.078-1.17.164-2.152.385-4.263.663-6.316.377-2.738.855-5.39 1.446-7.95a79.954 79.954 0 0 1 2.081-7.408c8.785-26.137 30.252-41.173 63.263-43.968 3.754-.321 7.652-.477 11.699-.477h74.442c1.211 0 2.379-.036 3.527-.1l.648-.043c13.039-.87 21.888-6.01 25.771-16.961.043-.122.093-.243.136-.364q.246-.728.463-1.476c.035-.114.057-.228.092-.342a39 39 0 0 0 .784-3.458H101.418c-4.51 20.719-12.006 37.659-23.056 50.635 6.761.527 13.836 1.34 21.24 2.466L90.01-15.001c-46.583-6.352-68.535 5.454-73.33 37.146l-61.952-9.383C-41.253-13.79-33.116-34.98-19.9-50.5a293 293 0 0 1-21.24-2.467l9.59-63.397c33.51 4.57 54.279-.256 65.073-15.122H-88.834c10.503 6.531 17.792 16.976 20.499 30.936.705 3.65 1.104 7.55 1.161 11.67.057 4.072-.228 7.922-.826 11.544-3.285 19.991-16.117 33.138-34.556 38.086-.143.036-.292.079-.435.114-.613.157-1.226.307-1.853.45-.192.042-.384.092-.584.135q-1.152.247-2.337.463c-3.014.535-6.156.856-9.398.984-.648.029-1.296.057-1.952.065a80 80 0 0 1-4.56-.086c-.598-.029-1.19-.05-1.781-.093a71 71 0 0 1-5.508-.606 56 56 0 0 1-2.23-.385c-.185-.035-.363-.071-.549-.107a67 67 0 0 1-1.717-.363q-.234-.053-.47-.114a42 42 0 0 1-1.909-.492l-.164-.043c-12.141-3.365-21.824-10.374-27.88-20.669-4.126 6.98-9.954 12.463-17.115 16.32l.406.15a50.24 50.24 0 0 1-2.322 1.197c-.15-.05-.307-.107-.456-.157-.171.079-.349.164-.528.243.193.071.335.135.414.178q-.01.002-.029.014c-.149-.05-.313-.107-.47-.157a54 54 0 0 1-8.329 2.966c-.143.036-.292.079-.435.114-.613.157-1.225.307-1.852.45-.193.042-.385.092-.585.135q-1.152.247-2.337.463c-3.013.535-6.156.856-9.397.984-.649.029-1.297.058-1.953.065a77 77 0 0 1-6.056-.157 68 68 0 0 1-5.793-.635c-.256-.035-.505-.085-.755-.128l.107.356a62 62 0 0 1-2.601-.485c-.035-.12-.078-.235-.114-.356a53 53 0 0 1-1.132-.25 11 11 0 0 1-.471-.114 42 42 0 0 1-1.909-.491l-.164-.043c-13.103-3.622-23.32-11.472-29.241-23.107v315.949h36.416c-2.009-6.438-3.135-13.739-3.135-21.788 0-5.069.449-9.775 1.275-14.138a64 64 0 0 1 .984-4.363 61 61 0 0 1 2.678-8.007 56 56 0 0 1 1.483-3.23c.042-.085.085-.164.128-.249l.192-.357c.335-.648.67-1.304 1.026-1.932a50.7 50.7 0 0 1 12.262-14.452 55 55 0 0 1 5.052-3.629 58 58 0 0 1 5.472-3.08c.335-.164.677-.313 1.012-.47a59 59 0 0 1 2.472-1.112 71 71 0 0 1 8.564-2.988c7.88-2.217 16.024-3.272 25.294-3.272 1.503 0 2.992.035 4.474.093 1.112.042 2.223.099 3.321.178 6.462.435 12.682 1.433 18.51 3.058.606.171 1.197.357 1.789.542q.267.064.534.15h-.014c.093-.029.185-.057.285-.078l.256.085c8.479-2.246 17.82-3.358 27.738-3.358v.064c14.87 0 28.607 2.446 40.121 7.593 6.384 2.816 12.027 6.431 16.815 10.958 10.26 9.797 16.416 23.143 16.416 41.994 0 8.099-1.183 15.35-3.363 21.774H71.586c5.45-6.83 8.208-17.639 8.393-33.074l40.392-.115h.22c.271 15.55 3.007 26.387 8.458 33.175h43.498c5.593-6.816 8.415-17.703 8.607-33.346h.492l40.391-.121c.278 15.764 3.078 26.694 8.678 33.459h63.905zm-413.948-123.792 7.802-6.174c-.506-.192-1.026-.371-1.368-.428.014-.121-.185-.185-.228-.242v.107c-5.273-4.378-14.856-8.741-21.425-13.047-4.268 5.404-9.526 8.89-15.354 10.516.235.199.456.399.677.584-.727.214-1.461.407-2.202.564l-.727-.621c-5.044.977-10.466.628-16.01-1.019a45.6 45.6 0 0 1-6.925-2.695 46.7 46.7 0 0 1-6.683-3.914c-3.933-2.781-7.118-6.032-9.448-9.668-.078-.014-.15-.029-.228-.036l-.121-.021a29 29 0 0 1-1.347-2.51c.086.015.171.029.257.05-1.96-3.835-3.021-8.028-3.093-12.49-4.075-.308-7.98-.593-11.528-.82l.449-.229c-.969.107-1.853.121-2.708.1-.071.314-.135.62-.22.934a22.3 22.3 0 0 1-1.411 3.721 22.7 22.7 0 0 1-1.995 3.38c-4.389 6.082-11.001 7.964-18.005 5.889a24 24 0 0 1-3.605-1.404 24 24 0 0 1-3.477-2.04c-5.978-4.22-8.622-10.544-6.627-17.738a22.5 22.5 0 0 1 1.397-3.672 22 22 0 0 1 2.024-3.422c4.389-6.046 10.972-7.914 17.983-5.875 1.24.364 2.501.841 3.755 1.455a24.4 24.4 0 0 1 3.341 1.946c5.031 3.522 7.688 8.57 7.211 14.395 1.845.164 3.163.313 3.163.313l5.401.05s2.722.079 4.938.057a34 34 0 0 1 1.161-6.438q.96-3.467 2.679-7.05a43 43 0 0 1 3.898-6.582c5.885-8.106 13.822-12.298 22.664-12.769.492-8.17.948-16.398 2.23-22.059.748 2.638.072-6.46.592-6.973l.199.364c.364-.585-.235-2.431.542-2.574.014-.114.014-.306.014-.563l-13.78 1.982-5.123-35.584 35.568-5.126 5.123 35.584-20.206 2.909c-.549 6.901-1.226 13.51-1.468 14.23-.064-.12.121-.705-.292-.734-.086 1.034-.071 2.125-.15 3.223.649-.285.321-1.64.527-1.74.072 4.1-.584 12.42-1.232 17.019 3.042.085 6.177.584 9.355 1.51a47.4 47.4 0 0 1 7.218 2.789 45.6 45.6 0 0 1 6.419 3.743c3.912 2.737 7.075 5.946 9.398 9.546.164-.107.335-.214.499-.32a6 6 0 0 0-.392.491 1 1 0 0 1 .078.136c1.219-.685 8.949-7.593 9.797-7.743-.035.057-.292.47-.335.542 1.019-.37 3-2.802 3.727-2.396.185-.128.506-.392.919-.748-3.05-3.864-4.104-8.691-2.636-13.989a22.5 22.5 0 0 1 1.396-3.671 22 22 0 0 1 2.024-3.423c4.389-6.045 10.972-7.913 17.983-5.874 1.24.363 2.501.84 3.755 1.454a24.5 24.5 0 0 1 3.342 1.946c5.977 4.185 8.628 10.517 6.612 17.753a22 22 0 0 1-1.411 3.722 22.7 22.7 0 0 1-1.995 3.38c-4.39 6.08-11.001 7.963-18.005 5.888a24 24 0 0 1-3.605-1.404 24 24 0 0 1-3.477-2.04 20 20 0 0 1-2.971-2.552 1166 1166 0 0 1-14.272 10.624c.52.94.983 1.91 1.397 2.901q.173.396.335.792v.028c2.166 5.74 2.451 12.199.534 19.086q-.972 3.508-2.715 7.144c-.014.029-.035.064-.049.093.149.092.299.178.448.271-.05.107-.092.214-.142.313a45 45 0 0 1-1.055 2.047c-.156-.093-.32-.186-.477-.286a43 43 0 0 1-1.967 3.187c3.021 1.512 7.304 4.107 9.498 5.725-.335-.071-1.083-.37-1.86-.834l-.142.214c1.824 1.013 3.249 2.995 5.422 3.152 0 0-2.109-1.562-2.487-2.004l.029-.014-.014-.043c4.26 2.189 9.17 5.183 13.409 7.65l17.97-14.223 22.293 28.197-28.179 22.309-22.294-28.198zm364.665 16.94c.498.421 0-65.421 0-65.421 31.592 11 68.499.563 68.499.563v64.58c-23.277 6.488-68.499.286-68.499.286zM362.058 3.371v35.905c18.161-.463 32.183-4.428 32.183-4.428v64.58c-23.277 6.489-68.499.286-68.499.286.228.192.249-13.81.199-28.91-17.257-.493-32.383-2.575-32.383-2.575.499.421 0-65.421 0-65.421 31.592 11.001 68.5.563 68.5.563ZM103.05 205.154a32 32 0 0 1-5.059.414 32 32 0 0 1-5.265-.414c-9.47-1.554-16.21-7.508-17.97-17.133a29.4 29.4 0 0 1-.456-5.126q-.001-2.759.435-5.197c1.717-9.647 8.422-15.628 17.862-17.233a32 32 0 0 1 5.266-.442q2.641 0 5.058.385c9.448 1.512 16.196 7.472 17.963 17.161.299 1.626.456 3.366.456 5.198q-.002 2.716-.421 5.133c-1.703 9.689-8.422 15.7-17.876 17.261zm31.813-58.263c-2.43-4.906-3.691-12.185-4.346-18.744-3.72.264-7.546.321-11.429.192-.691-.021-1.375-.042-2.073-.071h-.071l-.685-.043c-.185-.007-.363-.021-.548-.035-7.788-.478-15.283-1.754-22.237-3.872-.955 3.28-2.138 6.353-3.541 9.197-7.695 15.622-21.86 24.626-38.86 28.319-7.923 1.719-16.445 2.31-25.215 1.868-4.632-.235-9.142-.72-13.495-1.475-1.304 6.459-3.292 13.574-6.199 18.209l-36.872-9.155s7.061-11.151 8.144-24.519c-5.857-5.219-10.445-11.699-13.374-19.571-2.728-7.336-4.06-15.827-3.57-25.666.5-9.982 2.708-18.416 6.2-25.517 7.645-15.55 21.667-24.533 38.824-28.24 8.172-1.769 17.036-2.36 26.255-1.897 8.244.413 16.174 1.725 23.499 3.964.007-.029.014-.05.02-.078h.015a58 58 0 0 1 3.534-9.133c.036-.079.078-.15.121-.221a47 47 0 0 1 1.226-2.296c7.951-14.088 21.439-22.316 37.463-25.795.94-.207 1.888-.392 2.843-.563.926-.165 1.859-.314 2.807-.457 6.27-.92 12.847-1.197 19.565-.855 6.213.313 12.213 1.098 17.898 2.352a86 86 0 0 1 3.663.892l.733.192c.086.022.179.043.271.071.114.029.228.057.342.093.755.214 1.504.45 2.252.677.256.079.52.15.776.236 7.667 2.48 14.557 6.01 20.356 10.659a52 52 0 0 1 3.078 2.673 49 49 0 0 1 3.67 3.836c.292.342.577.684.862 1.04.192.236.378.478.57.714q.832 1.07 1.61 2.181a49.4 49.4 0 0 1 5.665 10.887c2.764 7.415 4.111 16.028 3.612 26.01-.492 9.838-2.672 18.151-6.12 25.174-3.228 6.566-7.61 11.956-12.882 16.284-.563.463-1.14.906-1.725 1.348-.22.164-.434.328-.655.492-.257 13.41 5.65 25.224 5.65 25.224l-37.606 5.412zm89.718 40.717c-1.703 9.689-8.422 15.699-17.877 17.261-1.61.264-3.299.406-5.058.413-1.832 0-3.592-.135-5.266-.413-9.469-1.554-16.209-7.508-17.969-17.133a29.4 29.4 0 0 1-.456-5.126c0-1.832.142-3.572.434-5.197 1.718-9.647 8.422-15.629 17.863-17.233a32 32 0 0 1 5.265-.442c1.76 0 3.449.129 5.059.385 9.448 1.512 16.195 7.472 17.962 17.161.299 1.626.456 3.365.456 5.198a30 30 0 0 1-.42 5.133z",
        mask: "url(#b)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#35243f",
        d: "M178.953-13.348c-7.945-.014-15.69-1.098-23.256-2.445-.036-.478-.072-.956-.107-1.448.534 7.793 1.354 13.497 1.981 18.217h36.658c-.634-.55-1.276-1.098-1.903-1.654a312 312 0 0 1-13.373-12.67m18.289 11.13v-.072a493.5 493.5 0 0 1-.064-1.547v-.171a228 228 0 0 1-.1-3.415q.002-.18-.007-.37l-.022-1.32q.002-.3-.007-.599c0-.399-.007-.798-.014-1.205v-2.416c0-.92.014-1.826.036-2.731a41 41 0 0 1-4.696 1.362c-2.75.598-5.643 1.005-8.678 1.247l.37-.228h.015c-1.119-.007-2.323.136-1.846.285h-.249c1.347 1.348 2.273 2.282 2.608 2.688-.264-.228-2.316-1.989-2.644-2.267 2.038 2.239 6.391 6.324 10.488 9.91 1.66 1.469 3.278 2.86 4.653 4.043h.321a311 311 0 0 1-.164-3.202z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#48245d",
        d: "M181.937-12.977c.328.278 2.38 2.039 2.643 2.267-.342-.406-1.268-1.333-2.608-2.688h.25c-.478-.15.727-.292 1.845-.285h-.014l-.371.228c3.036-.242 5.921-.649 8.679-1.247a41 41 0 0 0 4.695-1.362c.021-.877.05-1.74.086-2.602l-.485.192c-.477.185-.969.32-1.453.478-.962.335-1.953.57-2.922.805-3.911.927-7.787 1.29-11.328 1.412-.435.014-.87.028-1.297.036a426 426 0 0 1-6.726-6.916c-5.6-5.882-12.163-13.425-17.435-21.11-.029.37-.064.74-.093 1.118-.028.386-.05.785-.078 1.17.242.335.47.656.684.94.955 1.327 1.703 2.368 2.316 3.138-.756-.656-1.832-1.932-3.029-3.572 0 .071-.007.135-.014.207 4.489 6.43 9.783 12.783 15.583 19.014a405 405 0 0 0 5.757 6.01c-1.86-.02-3.584-.092-5.145-.156-5.336-.457-10.637-1.234-15.917-2.182.021.285.036.563.057.841l.107 1.448c7.567 1.34 15.312 2.424 23.256 2.445a312 312 0 0 0 13.374 12.67c.627.556 1.268 1.105 1.902 1.654h2.857c-1.375-1.191-2.992-2.574-4.653-4.043-4.104-3.586-8.45-7.671-10.488-9.91z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#35243f",
        d: "M372.866-51.79c-19.173 11.293-44.36 14.009-67.787 14.009h-65.001c-8.208 0-14.977 1.91-19.338 6.36-.484.492-.94 1.02-1.36 1.575a15 15 0 0 0-.613.863c-2.152 3.244-3.342 7.479-3.342 12.848 0 4.249.884 10.701 1.404 16.055.035.357.071.706.1 1.056h-19.523a322 322 0 0 1-.164-3.202c.05 1.106.1 2.168.164 3.202.513 8.933 1.439 15.264 2.123 20.419h59.359c-.499-5.54-1.504-12.584-1.504-17.111 0-15.607 10.061-21.646 24.646-21.646h65.001c23.42 0 48.607-2.716 67.787-14.01a64.7 64.7 0 0 0 10.175-7.371v-92.75h-20.435v16.634c0 32.86-12.989 52.046-31.692 63.068"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#48245d",
        d: "M383.126-120.549c0 8.691-1.632 15.386-4.752 20.369-1.561 2.489-3.492 4.556-5.786 6.218a23.62 23.62 0 0 1-3.705 2.203c-1.482.72-3.078 1.304-4.781 1.79q-1.304.374-2.693.662c-3.178.649-6.676.963-10.481.963h-74.599c-.755 0-1.51 0-2.251.021-3.62.057-7.111.25-10.488.57-.385.036-.777.072-1.154.115l-.357.042-.79.086c-3.235.37-6.363.855-9.363 1.469-4.068.834-7.923 1.889-11.556 3.172-.513.178-1.019.371-1.525.556-.1.036-.207.079-.307.114-.306.114-.605.243-.912.364-6.483 2.567-12.219 5.89-17.178 9.939a61 61 0 0 0-2.173 1.86c-4.631 4.179-8.522 9.048-11.657 14.61-.106.184-.206.377-.313.57-.093.17-.192.342-.285.513-.257.47-.506.955-.748 1.433-3.064 6.067-5.294 12.883-6.655 20.433a95 95 0 0 0-.527 3.294c-.029.214-.064.421-.093.628a108 108 0 0 0-.869 9.874 156.42 156.42 0 0 0-.086 2.603c-.021.905-.035 1.81-.035 2.73v2.417c0 .407.007.806.014 1.205q-.002.3.007.599c0 .45.014.884.022 1.319a1907.277 1907.277 0 0 0 .049 2.096q.024.856.057 1.69v.17l.065 1.548v.071c.049 1.105.099 2.168.163 3.202h19.523q-.045-.523-.1-1.056c-.52-5.354-1.403-11.813-1.403-16.056 0-5.361 1.189-9.596 3.341-12.847.193-.293.399-.585.613-.863a15.77 15.77 0 0 1 1.361-1.575c4.353-4.45 11.129-6.36 19.337-6.36h65.001c23.42 0 48.607-2.717 67.788-14.01 18.703-11.015 31.692-30.201 31.692-63.069v-16.626h-21.432v10.944z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#35243f",
        stroke: "#35243f",
        d: "M78.564-80.346c6.518.516 13.329 1.303 20.446 2.368l-9.442 62.416c-23.076-3.095-40.179-1.723-52.143 4.424C25.46-4.99 18.722 5.886 16.243 21.575l-60.965-9.233c4.02-26.155 12.06-47.013 25.019-62.325 46.462 3.56 78.159-6.886 98.267-30.363Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#35243f",
        d: "M293.564 2.808s.499 65.85 0 65.421c0 0 15.127 2.075 32.384 2.574-.05-15.749-.171-32.675-.193-35.94v-.571a75 75 0 0 0 2.515.82 66 66 0 0 0 2.202.65c.634.177 1.268.349 1.909.505.157.043.314.079.471.122.677.17 1.361.328 2.037.484.093.022.179.036.271.058.627.135 1.247.27 1.874.392.135.028.271.057.406.078.691.135 1.382.257 2.066.378.1.014.2.035.3.05q.953.16 1.895.3c.107.014.214.035.321.05.698.099 1.403.192 2.101.284.093.015.193.022.285.036.67.078 1.333.157 1.995.221.057 0 .114.014.171.021.713.072 1.433.136 2.138.193.078 0 .164.014.242.021 1.447.114 2.879.2 4.304.264h.164q2.178.088 4.303.1h.064c1.447.007 2.872 0 4.275-.043V3.371s-36.907 10.43-68.5-.563"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#35243f",
        d: "M348.705 38.934c.078 0 .164.014.242.021-.078 0-.164-.014-.242-.021m-11.691-1.611c.135.028.27.057.406.078q-.204-.045-.406-.079m-4.646-1.055c.157.043.314.079.47.121a12 12 0 0 1-.47-.12m-4.588-1.305q.248.075.485.15-.248-.075-.485-.15m2.507.748q.084.02.178.05a2 2 0 0 1-.178-.05m16.109 3.009c.057 0 .114.014.171.021-.057 0-.114-.014-.171-.021m-20.448 32.083c.049 15.1.028 29.103-.2 28.91 0 0 45.222 6.204 68.5-.284v-64.58s-14.029 3.964-32.184 4.427v28.668c-9.811 2.738-23.527 3.216-36.109 2.852z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#48245d",
        d: "M357.718 39.319c-1.418-.007-2.85-.043-4.304-.1h-.163a111.47 111.47 0 0 1-4.304-.264c-.078 0-.164-.014-.242-.021q-1.069-.085-2.138-.193c-.057 0-.114-.014-.171-.021a196.13 196.13 0 0 1-1.995-.221c-.092-.014-.192-.022-.285-.036a75 75 0 0 1-2.102-.285c-.106-.014-.213-.036-.32-.05a87 87 0 0 1-1.895-.3c-.1-.014-.2-.035-.3-.05a96 96 0 0 1-2.472-.456c-.627-.12-1.247-.256-1.874-.392-.093-.021-.178-.035-.271-.057a69 69 0 0 1-2.037-.484q-.236-.056-.471-.122c-.634-.164-1.275-.328-1.909-.506a108.306 108.306 0 0 1-2.202-.649c-.164-.05-.328-.1-.484-.15a75 75 0 0 1-2.031-.67v.571c.021 3.265.143 20.198.192 35.94 12.583.364 26.299-.121 36.11-2.852V39.283q-2.106.054-4.275.043h-.064z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#35243f",
        d: "M86.99 46.598c.192-.97.49-2.21.883-3.8.498-2.281 1.653-6.032 2.807-9.333 1.154-3.308 2.259-6.188 2.202-6.958-1.098 2.873-2.7 6.987-3.883 10.873-1.205 3.878-2.003 7.507-2.01 9.225z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#35243f",
        d: "M69.926 56.016c5.037 2.91 9.505 6.46 13.267 10.688q.02-.205.043-.4c1.104-9.667 2.771-18.936 5.215-27.427 2.408-8.499 5.657-16.177 9.355-22.715a86 86 0 0 1 2.672-4.406q-1.432.254-2.843.563c-16.017 3.486-29.512 11.714-37.463 25.795 2.658 5.069 5.337 10.117 8.144 15.093.527.941 1.076 1.868 1.617 2.802zm67.381-35.598a141 141 0 0 0-7.353 9.468c-4.695 6.61-8.949 13.825-12.405 21.596s-6.099 16.106-7.538 24.804a90.7 90.7 0 0 0-1.233 15.457q.204.009.407.028l1.531.093c.513.007 1.019-.028 1.525-.035.506-.03 1.012 0 1.511-.093 1.004-.136 1.995-.214 2.985-.435 6.384-1.184 12.027-3.48 16.366-5.804-.52-1.226-.962-2.495-1.432-3.757-.313-.827-.527-1.69-.791-2.538-.249-.856-.527-1.697-.705-2.574l-.599-2.602c-.185-.87-.306-1.754-.456-2.624-.335-1.74-.441-3.508-.641-5.24-.214-3.48-.299-6.902-.021-10.16.434-6.524 1.745-12.356 3.199-16.854-.399 1.84-1.596 6.374-2.28 11.592l.242.122c.762-6.025 2.629-12.07 5.002-17.739 2.394-5.675 5.23-11.015 8.407-15.8 0 0-.62.735-1.503 1.926a57 57 0 0 0-3.092 4.663c-1.076 1.81-2.145 3.736-2.929 5.447-.413.848-.791 1.618-1.104 2.267l-.691 1.568v-.078l-.086.15c1.539-4.021 3.399-8.078 5.836-11.957 1.617-2.595 3.498-5.112 5.685-7.407l-.733-.193c-2.587 1.818-4.91 4.17-7.104 6.73z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#35243f",
        d: "M131.343 47.354c-.342 1.29-.862 3.187-1.126 5.183-.356 1.99-.413 4.064-.406 5.618l.249.05.193-3.28c.028-.784.157-1.554.221-2.131.071-.578.128-.963.149-.97l-.05-.035c.1-.079.307-.065.3-.528.662-3.33 1.019-4.934 1.09-5.397.064-.464-.257.192-.62 1.476zM66.27 54.07c-2.536-4.534-4.944-9.097-7.317-13.66q-.055.116-.121.22c-1.397 2.824-2.572 5.868-3.534 9.134q.693.213 1.375.428a73.4 73.4 0 0 1 9.605 3.871zm-3.49-8.634c.741 1.355 2.43 4.164 3.028 4.791-.72-1.647-4.773-8.384-3.028-4.79m54.72 1.396c1.503-2.866 2.743-5.105 3.969-7.329 1.246-2.21 2.493-4.413 4.203-7.072l-.178-.193c-1.126 1.804-3.463 5.376-5.272 8.634-1.831 3.244-3.164 6.132-2.843 6.203l.114-.236zm-1.825 4.577-.178-.22c-1.995 4.605-3.769 9.39-5.13 14.38l.2.228c1.332-4.898 3.177-9.91 5.108-14.387m29.569-36.868.05-.057c.164-.157.313-.306.456-.442a6 6 0 0 1-.342-.092q-.17.19-.349.413l.178.178zm31.607 25.446c-.05 5.255-.428 10.901-.884 16.427-.869 11.072-2.75 21.574-3.747 27.834.513-2.26 1.054-4.549 1.475-6.895.484-2.331.847-4.712 1.246-7.115.699-4.812 1.333-9.732 1.71-14.73.392-4.998.727-10.06.77-15.136.028-2.16-.014-4.328-.107-6.488-.185-.242-.378-.478-.57-.713.1 2.167.135 4.449.107 6.823z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#35243f",
        d: "M178.739 48.324c-.827 16.583-3.371 33.288-8.529 47.832a111 111 0 0 1-4.959 11.828l2.679-.399a38 38 0 0 0-.428 1.961c-.035.178-.064.356-.099.527a45 45 0 0 0-.25 1.612c-.014.121-.035.242-.05.363-.057.485-.099.97-.142 1.455.812.221 1.617.427 2.422.598-2.636-.27-2.337-.128-.342.286.05.007.107.021.157.028 5.273-4.327 9.662-9.71 12.882-16.284 3.449-7.023 5.629-15.343 6.121-25.175.498-9.981-.848-18.594-3.613-26.009a49.4 49.4 0 0 0-5.664-10.887c.114 4.086.021 8.185-.185 12.264"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#35243f",
        d: "M159.743 63.274c-2.807 4.264-5.978 8.185-9.362 11.757-3.356 3.586-7.09 6.802-11.023 9.461.022-.021.463-.4.962-.82.249-.214.499-.42.677-.592.185-.17.306-.285.313-.292a59 59 0 0 1-4.788 3.365c.171.378.342.763.506 1.141a65 65 0 0 0 2.565 4.734c3.684 6.082 8.408 11.172 13.595 14.901a44 44 0 0 0 3.584 2.317c.228-.035.463-.071.691-.1.812-.121 1.589-.235 2.344-.349.499-.071.983-.15 1.446-.214.271-.043.528-.078.784-.114.399-.791.77-1.604 1.161-2.396 1.048-2.074 1.874-4.249 2.786-6.388.428-1.076.805-2.181 1.212-3.265l.598-1.633c.192-.549.356-1.105.534-1.654l1.055-3.315.919-3.351.456-1.675.399-1.69.791-3.373.677-3.393.335-1.697.285-1.704c.192-1.134.377-2.274.57-3.408l.47-3.415.235-1.704.185-1.711c.129-1.14.25-2.275.378-3.408.798-9.098 1.361-18.188.812-27.022 0-.042-.007-.085-.007-.128a49 49 0 0 0-3.669-3.836c-.022 2.025-.235 4.022-.556 5.968-1.938 10.701-6.284 20.512-11.906 29.025zM129.035 53.6c-.064.37-.135.463-.164.826-.035.528.164 1.355.221 1.804 0-.313.079-1.02.107-1.625.029-.6.057-1.098-.157-1.006z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#35243f",
        d: "M161.988 59.11a37.13 37.13 0 0 0 1.617-3.13c-1.689 2.19-5.472 9.34-1.617 3.13m-16.109-42.157c-2.473 2.816-4.56 6.039-6.37 9.44-3.577 6.837-6.17 14.33-7.439 22.023-.142.963-.342 1.918-.434 2.888l-.314 2.901c-.114 1.94-.278 3.872-.242 5.804-.05 1.932.107 3.85.199 5.76.221 1.904.378 3.8.741 5.662.271 1.875.763 3.7 1.183 5.518.535 1.79 1.026 3.586 1.71 5.297.207.62.449 1.227.698 1.826.15-.093.307-.186.456-.279 2.302-1.397 4.055-2.723 5.273-3.621.591-.471 1.054-.842 1.368-1.091.313-.25.47-.385.47-.385 1.974-1.676 3.798-3.53 5.572-5.433 1.788-1.89 3.434-3.907 5.03-5.953 1.589-2.054 3.05-4.2 4.453-6.388 1.361-2.21 2.651-4.456 3.805-6.78 0 0 .214-.4.563-1.149.349-.741.876-1.803 1.432-3.144a74 74 0 0 0 3.641-10.616c1.111-4.178 1.845-8.798 1.532-12.926-.014-.235-.05-.463-.071-.698-5.8-4.656-12.697-8.178-20.357-10.66-.256-.085-.52-.156-.776-.235a37 37 0 0 0-2.123 2.232zm23.683 18.944c.285-1.255.491-2.802.627-3.594.085-1.554.021-2.139-.043-2.103-.078.036-.15.692-.292 1.611-.235 1.84-.812 4.727-1.019 5.946.135.35.449-.606.72-1.86zm-68.458-21.689c.342-.663.513-.962.485-.97-.022-.007-.242.279-.592.835-.342.563-.869 1.369-1.46 2.424-1.226 2.096-2.807 5.169-4.425 8.905-1.61 3.743-3.199 8.177-4.567 12.926-2.743 9.51-4.375 20.276-5.272 28.953-.057.578-.114 1.14-.171 1.697 3.042 3.871 5.536 8.263 7.374 13.204q.599 1.617 1.111 3.308c.036.029.072.05.1.079.812.584 1.632 1.183 2.515 1.704.435.263.855.556 1.311.798.45.243.905.478 1.361.72.45.257.92.464 1.397.663l1.418.614 1.467.499.734.25.748.184 1.504.371h.007c0-1.09 0-2.189.043-3.287.334-11.15 2.785-22.322 6.868-32.853 4.083-10.545 9.776-20.448 16.43-29.51 1.682-2.26 3.385-4.477 5.187-6.651 1.81-2.168 3.741-4.285 5.943-6.16l.128-.107c-5.693-1.262-11.685-2.046-17.898-2.353-6.719-.335-13.295-.064-19.565.855a85 85 0 0 0-3.798 5.975c.705-1.419 1.275-2.403 1.617-3.066z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#48245d",
        d: "M175.076 59.268c-.128 1.133-.249 2.274-.377 3.407l-.186 1.712-.235 1.704c-.157 1.133-.313 2.274-.47 3.415-.185 1.133-.378 2.267-.57 3.408l-.285 1.704-.335 1.696-.677 3.394-.791 3.372-.399 1.69-.456 1.676-.919 3.35-1.054 3.316c-.178.549-.342 1.112-.535 1.654l-.598 1.633c-.406 1.09-.784 2.188-1.211 3.265-.912 2.139-1.739 4.313-2.786 6.388-.392.799-.763 1.604-1.162 2.396.285-.043.556-.086.827-.122.349-.663.719-1.361 1.097-2.117.413-1.005.613-.934.784-1.098.028-.093.021-.135-.022-.078 0 0 .036-.057.086-.15q.075-.152.214-.421c.164-.371.392-.905.662-1.54.528-1.283 1.304-2.959 1.91-4.727 1.346-3.479 2.394-7.136 2.515-7.4l.214.17c-.52 1.776-1.083 3.858-1.91 5.997-.399 1.07-.784 2.189-1.247 3.287-.477 1.09-.954 2.195-1.432 3.293-.456 1.106-1.033 2.154-1.546 3.187-.264.507-.513 1.013-.769 1.512q.553-.084 1.054-.157c.128-.257.257-.513.378-.77l.142.292-.214.428c.157-.021.3-.043.449-.064a110 110 0 0 0 4.959-11.828c5.159-14.544 7.702-31.25 8.529-47.833.199-4.078.299-8.177.185-12.263a45 45 0 0 0-1.61-2.181c.093 2.16.135 4.327.107 6.488-.043 5.083-.371 10.145-.77 15.136-.384 4.998-1.011 9.917-1.71 14.73-.399 2.395-.762 4.784-1.247 7.115-.42 2.346-.969 4.634-1.474 6.894.997-6.26 2.878-16.769 3.747-27.834.463-5.525.834-11.172.884-16.426.028-2.375-.007-4.663-.107-6.824q-.426-.525-.862-1.04c0 .042.007.085.007.128.549 8.834-.014 17.917-.812 27.021zm-6.462 40.31c-.292.813-.442.999-.812 1.804-.3.157.163-.92.627-2.274.484-1.34 1.097-2.902 1.332-3.608-.285 1.02-.72 2.916-1.147 4.078m-.94-60.338a74.4 74.4 0 0 1-3.641 10.616c-.563 1.34-1.083 2.403-1.432 3.145-.342.741-.563 1.148-.563 1.148-1.154 2.317-2.451 4.57-3.805 6.78-1.403 2.182-2.864 4.328-4.453 6.388-1.596 2.046-3.249 4.057-5.03 5.953-1.774 1.904-3.598 3.758-5.572 5.433 0 0-.157.142-.47.385-.314.25-.777.613-1.368 1.09-1.219.906-2.964 2.225-5.273 3.623-.149.092-.306.185-.456.278.292.706.606 1.397.912 2.089a59 59 0 0 0 4.788-3.366s-.135.122-.313.293-.435.378-.677.592c-.492.42-.933.798-.962.82 3.933-2.66 7.674-5.875 11.022-9.461a85 85 0 0 0 9.363-11.757c5.621-8.513 9.975-18.316 11.906-29.025.327-1.946.534-3.943.555-5.968a55 55 0 0 0-3.078-2.673c.022.235.057.463.072.699.313 4.128-.421 8.748-1.532 12.926zm-5.686 19.87c-3.855 6.21-.064-.94 1.617-3.13a39 39 0 0 1-1.617 3.13m8.165-28.91c.057-.036.129.542.043 2.103-.135.792-.349 2.346-.627 3.594-.278 1.255-.584 2.21-.72 1.86.207-1.226.784-4.106 1.019-5.946.143-.92.214-1.575.292-1.61zM88.45 38.877c-2.443 8.491-4.11 17.76-5.215 27.428q-.02.204-.043.399a49 49 0 0 1 1.903 2.281q.086-.833.17-1.697c.898-8.676 2.53-19.45 5.273-28.953 1.368-4.748 2.95-9.183 4.567-12.926 1.618-3.736 3.2-6.809 4.425-8.905.591-1.062 1.119-1.868 1.461-2.424.349-.563.57-.841.591-.834.028.007-.143.306-.485.97s-.911 1.646-1.617 3.065a87 87 0 0 1 3.798-5.974c-.941.135-1.874.285-2.808.456a86 86 0 0 0-2.671 4.406c-3.698 6.538-6.947 14.216-9.356 22.715zm2.23-5.412c-1.154 3.309-2.308 7.052-2.806 9.333-.392 1.59-.692 2.83-.884 3.8.007-1.718.812-5.347 2.01-9.225 1.182-3.886 2.785-7.993 3.882-10.873.057.763-1.054 3.65-2.201 6.958zm21.988 82.747a78 78 0 0 1-3.071-13.24c-.42-2.916-.655-5.839-.762-8.755q.597.045 1.183.079c.313.014.627.05.94.042l.934-.028c.62-.029 1.247-.014 1.859-.079 2.494-.25 4.817-.72 7.161-1.311 2.337-.6 4.638-1.384 6.933-2.303a54 54 0 0 0 6.227-3.002c-.15-.335-.314-.656-.456-.991q-.269-.556-.506-1.134c-4.339 2.325-9.989 4.62-16.366 5.804-.991.22-1.981.3-2.986.435-.498.085-1.004.064-1.51.093-.506.007-1.019.05-1.525.035l-1.532-.093c-.135-.007-.27-.02-.406-.028a90.7 90.7 0 0 1 1.233-15.457c1.432-8.698 4.082-17.033 7.538-24.804s7.709-14.987 12.405-21.596a141 141 0 0 1 7.353-9.468c2.187-2.56 4.517-4.905 7.103-6.73a94 94 0 0 0-3.662-.891l-.128.107c-2.209 1.875-4.133 4-5.942 6.16-1.803 2.167-3.506 4.391-5.187 6.651-6.662 9.07-12.348 18.965-16.431 29.51-4.082 10.53-6.533 21.703-6.868 32.853a84 84 0 0 0-.043 3.287h-.007l-1.503-.37-.749-.186-.733-.25-1.468-.499-1.418-.613c-.477-.2-.948-.406-1.397-.663l-1.36-.72c-.45-.242-.877-.535-1.311-.799-.877-.513-1.696-1.112-2.515-1.703-.036-.029-.072-.05-.1-.079.356 1.17.67 2.367.954 3.594a41 41 0 0 0 4.311 2.402c2.373 1.148 4.859 1.882 7.332 2.374.285 9.183 1.988 18.216 5.294 26.594 1.111 2.702 2.508 5.34 4.232 7.735.185.015.363.029.548.036a39 39 0 0 1-1.382-2.06c-2.622-4.357-4.111-8.941-5.023-12.313l-.598-2.303c-.171-.685-.285-1.283-.399-1.775l-.335-1.533c.427 1.64.84 3.287 1.361 4.926a60 60 0 0 0 1.66 4.913c1.239 3.251 2.8 6.466 4.88 9.382q.289.405.599.799c.691.035 1.382.05 2.073.071-.064-.078-.135-.143-.192-.221-2.836-3.458-4.788-7.614-6.227-11.914zm7.56-75.346c1.81-3.251 4.147-6.83 5.272-8.634l.179.193c-1.71 2.659-2.957 4.862-4.204 7.072-1.226 2.225-2.465 4.463-3.969 7.33l-.114.235c-.313-.072 1.012-2.96 2.843-6.203zM115.49 51.19l.178.22c-1.931 4.478-3.776 9.49-5.109 14.388l-.199-.228c1.361-4.99 3.135-9.774 5.13-14.38m-12.953 40.147c-.371-.114-.578-.214-.706-.314-.256-.207-.235-.37-.677-.72.72.392 3.527 1.305 2.879 1.29l.235.1c-.827-.064-1.354-.25-1.731-.35zm4.346 8.684c-.264-1.804-.321-3.223-.378-4.193-.007-.976.022-1.518.079-1.582.114-.129.235 1.64.527 5.575l.021.178-.249.014zM69.926 56.016a563 563 0 0 1-1.617-2.802c-2.807-4.976-5.486-10.031-8.144-15.093a54 54 0 0 0-1.225 2.296c2.372 4.563 4.787 9.126 7.317 13.66a64 64 0 0 1 3.662 1.947zm-4.118-5.796c-.606-.627-2.294-3.437-3.028-4.791-1.746-3.593 2.315 3.137 3.028 4.791"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#48245d",
        d: "m133.622 33.251.093-.15v.08c.164-.364.399-.906.691-1.57.314-.648.691-1.418 1.105-2.267.783-1.704 1.852-3.636 2.928-5.447a57 57 0 0 1 3.092-4.662c.884-1.191 1.504-1.925 1.504-1.925-3.178 4.784-6.014 10.124-8.408 15.799-2.373 5.668-4.239 11.714-5.002 17.738l-.242-.12c.684-5.22 1.881-9.754 2.28-11.594-1.453 4.5-2.757 10.331-3.199 16.855-.278 3.258-.192 6.68.021 10.16.2 1.732.307 3.493.642 5.24.156.87.27 1.754.456 2.623l.598 2.603c.178.87.456 1.718.705 2.574.264.848.478 1.71.791 2.538.471 1.262.912 2.53 1.432 3.757.164.378.328.763.506 1.134.15.335.307.663.456.99a43 43 0 0 0 1.824 3.615 55 55 0 0 0 2.608 4.221 53.39 53.39 0 0 0 5.771 7.087 47.5 47.5 0 0 0 5.829 5.069c-.129-.228-1.39-1.112-2.622-2.21-.635-.535-1.226-1.148-1.732-1.69-.484-.563-.855-1.069-.99-1.426 2.764 2.895 5.928 5.369 9.184 7.387.969-.143 1.917-.286 2.836-.421a41 41 0 0 1-3.584-2.317c-5.187-3.729-9.911-8.82-13.595-14.901a62 62 0 0 1-2.565-4.734 56 56 0 0 0-.506-1.14c-.306-.692-.619-1.384-.912-2.09a27 27 0 0 1-.698-1.825c-.684-1.711-1.168-3.508-1.71-5.297-.42-1.826-.912-3.644-1.183-5.519-.363-1.86-.527-3.764-.741-5.66-.092-1.911-.249-3.83-.199-5.761-.043-1.932.128-3.865.242-5.804l.314-2.902c.092-.97.299-1.925.434-2.887 1.269-7.693 3.855-15.186 7.439-22.024 1.81-3.4 3.897-6.623 6.37-9.44a37 37 0 0 1 2.123-2.23 74 74 0 0 0-2.252-.678 14 14 0 0 1-.456.442l-.05.057-.178-.178c.121-.15.235-.285.349-.414-.085-.021-.178-.042-.27-.071-2.181 2.296-4.069 4.813-5.686 7.408-2.437 3.885-4.296 7.935-5.835 11.956zm-4.424 21.36c-.029.6-.107 1.306-.107 1.626-.057-.449-.249-1.283-.221-1.803.029-.364.1-.457.164-.828.221-.092.185.407.157 1.006zm10.466 41.973c-.399-.35-.79-.92-1.161-1.511-.356-.6-.67-1.22-.955-1.655.164-.092.834.799 1.418 1.647.584.849 1.055 1.669.698 1.519m-8.065-23.849c.784 4.328 2.066 8.698 3.285 11.764.064.164.128.335.192.492.242.52.499 1.055.755 1.59 1.247 2.567 2.679 5.205 4.275 7.693.955 1.504 1.988 2.93 3.007 4.27 1.047 1.32 2.08 2.567 3.114 3.644.356.392.755.784 1.175 1.183.413.414.855.827 1.34 1.248-5.28-4.057-10.218-10.402-13.445-17.724a51 51 0 0 1-.599-1.419c-.099-.235-.192-.478-.285-.713-1.489-3.729-2.6-7.636-3.356-11.522-.776-4.142-1.132-8.256-1.282-12.155.598 2.645.912 7.094 1.817 11.642zm.363-26.857c-.071.463-.42 2.068-1.09 5.397.007.464-.199.442-.299.528l.05.035s-.079.385-.15.97c-.057.578-.192 1.348-.221 2.132l-.192 3.28-.249-.05c-.008-1.555.049-3.637.406-5.619.263-1.996.783-3.9 1.125-5.183.364-1.283.684-1.94.62-1.476z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#35243f",
        d: "M93.46 124.325a45 45 0 0 1-1.426-.449 73 73 0 0 1-6.042-2.253 62 62 0 0 1-2.885-1.304 69 69 0 0 1-2.793-1.426c-10.524-5.704-18.824-14.11-23.52-25.574-.206-.5-.399-1.006-.591-1.512a56.4 56.4 0 0 1-2.473-8.748 60 60 0 0 1-.755-4.763c-.456-3.807-.591-7.85-.378-12.156.3-5.981 1.219-11.4 2.658-16.312-7.332-2.239-15.254-3.55-23.498-3.964-9.22-.464-18.083.128-26.256 1.896C-11.656 51.468-25.678 60.458-33.323 76c-3.491 7.102-5.7 15.53-6.199 25.518-.491 9.839.841 18.33 3.57 25.666 2.928 7.871 7.517 14.352 13.374 19.571 0-.078.014-.157.021-.235.043-.549.071-1.098.093-1.654 0-.121.014-.235.014-.357.021-.656.021-1.311.007-1.975 0-.121-.007-.249-.014-.37a32 32 0 0 0-.086-1.633l-.043-.542a32 32 0 0 0-.228-1.989s37.542 9.575 37.357 9.276v.071q-.002.065-.014.171v.029c0 .071-.015.164-.022.263 0 .029 0 .05-.007.079q-.012.159-.036.349.002.043-.007.086-.019.213-.05.47v.029c-.02.171-.035.356-.056.556q.002.042-.008.085-.03.298-.07.628c0 .043-.008.085-.015.135-.029.221-.05.449-.078.685 0 .057-.015.107-.022.164-.028.242-.064.499-.092.755 0 .05-.015.1-.022.157-.036.278-.071.556-.114.849a1 1 0 0 1-.014.114c-.036.285-.079.577-.121.877 0 .043-.014.078-.014.121-.043.314-.093.627-.136.955-.007.065-.021.129-.028.193q-.075.482-.15.984c-.014.071-.021.142-.036.214q-.076.502-.163 1.026a2 2 0 0 1-.036.193q-.087.543-.185 1.098c-.008.05-.022.107-.029.157q-.094.546-.2 1.105c0 .035-.014.071-.02.1-.072.392-.15.784-.222 1.183-.014.057-.021.121-.035.178l-.171.863c4.353.756 8.87 1.241 13.495 1.476 8.77.442 17.292-.15 25.215-1.868 17.007-3.686 31.165-12.691 38.86-28.319 1.403-2.845 2.579-5.911 3.54-9.197a62.925 62.925 0 0 1-.007.014z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#48245d",
        d: "M52.605 66.148c-.214 4.306-.078 8.348.378 12.156a60.226 60.226 0 0 0 .755 4.763 56 56 0 0 0 2.472 8.747c.193.514.385 1.013.591 1.512 4.696 11.464 12.996 19.87 23.52 25.574.912.499 1.846.969 2.793 1.426q1.422.684 2.886 1.304a75 75 0 0 0 6.042 2.253c.47.157.947.3 1.425.449.335-1.14.634-2.31.912-3.507q.077-.323.142-.656a73 73 0 0 0 .734-3.886q.117-.728.221-1.476c.114-.805.207-1.618.292-2.452.036-.35.064-.699.1-1.056.078-.905.15-1.818.2-2.752 0-.099.014-.199.02-.306v-.057c.357-7.03-.213-13.382-1.545-19.115a60 60 0 0 0-.955-3.593 53 53 0 0 0-1.112-3.308c-1.838-4.941-4.332-9.326-7.374-13.204a49 49 0 0 0-1.902-2.282c-3.762-4.228-8.23-7.778-13.267-10.687a62 62 0 0 0-3.662-1.947 71 71 0 0 0-9.605-3.87q-.682-.225-1.375-.429h-.014c-.007.029-.014.05-.022.079-1.439 4.912-2.358 10.33-2.657 16.312z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#c)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#1d2125",
        d: "M58.287-67h418.734v400.9H58.287z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        fill: "#303134",
        clipPath: "url(#d)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M101 18h342v8H101zM91 38h352v8H91z"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        filter: "url(#e)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: 299.5,
        height: 18,
        x: 40,
        y: 9.271,
        fill: "#2b2c2f",
        rx: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#f)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#bf63f3",
        d: "M47.69 15.356a.68.68 0 0 1 .669.006l1.625.937.385.223a.68.68 0 0 1 .34.588v2.32a.677.677 0 0 1-.34.588l-1.51.872.009-.028a.9.9 0 0 0 .043-.273V18.27a.89.89 0 0 0-.447-.771l-.279-.161-.847-.489v-.898a.68.68 0 0 1 .34-.587z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#bf63f3",
        d: "m47.178 15.652-1.51.872a.68.68 0 0 0-.34.589v2.319c0 .242.13.467.34.589l.358.206 1.652.953a.682.682 0 0 0 1.02-.588v-.899l-.874-.504-.252-.145a.89.89 0 0 1-.446-.772v-2.319a.9.9 0 0 1 .052-.3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#1868db",
        fillRule: "evenodd",
        d: "m47.824 19.19-1.798 1.037-.358-.206a.68.68 0 0 1-.34-.589v-2.32c0-.243.129-.467.34-.588l1.51-.872-.01.029a.9.9 0 0 0-.042.272v2.32c0 .318.17.612.446.77z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#bf63f3",
        fillRule: "evenodd",
        d: "m48.185 17.338-.847-.489v-.898a.68.68 0 0 1 .34-.587l.012-.008a.68.68 0 0 1 .669.006l1.625.937z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#fca700",
        fillRule: "evenodd",
        d: "m50.369 16.522-.385-.223-1.799 1.039.28.16a.89.89 0 0 1 .446.772v2.32a.9.9 0 0 1-.053.3l1.511-.872a.68.68 0 0 0 .34-.588v-2.32a.68.68 0 0 0-.34-.588",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#82b536",
        fillRule: "evenodd",
        d: "m47.824 19.19-1.798 1.037 1.652.953a.682.682 0 0 0 1.02-.588v-.899z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: 31,
        height: 5,
        x: 54,
        y: 15.771,
        fill: "#3d3f43",
        rx: 1.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#96999e",
        d: "m94.337 17.717-1.687 1.688a.21.21 0 0 1-.282.014l-.016-.014-1.688-1.688.298-.298 1.539 1.538 1.538-1.538z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#a9abaf",
        fillRule: "evenodd",
        d: "M106.501 15.498a.75.75 0 0 1 1.061 0l.462.462a.75.75 0 0 1 0 1.06l-3.037 3.037a.75.75 0 0 1-.383.205l-1.268.254a.282.282 0 0 1-.331-.331l.254-1.267a.75.75 0 0 1 .205-.383zm.663.397a.187.187 0 0 0-.265 0l-.36.36.727.728.36-.36a.186.186 0 0 0 0-.266zm-.296 1.486-.727-.728-2.279 2.28a.2.2 0 0 0-.052.095l-.17.854.853-.171a.2.2 0 0 0 .096-.051zm.555 1.45a.282.282 0 0 1 .529 0l.231.633.632.23a.281.281 0 0 1 0 .53l-.632.23-.231.632a.282.282 0 0 1-.529 0l-.23-.632-.633-.23a.281.281 0 0 1 0-.53l.633-.23z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: 38.5,
        height: 5,
        x: 112,
        y: 15.771,
        fill: "#3d3f43",
        rx: 1.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#0b1228",
        fillOpacity: 0.06,
        d: "M156.5 9.271h.5v18h-.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#a9abaf",
        fillRule: "evenodd",
        d: "M166.805 16.209H165v-.563h4.125v.563h-1.758v4.687h-.562zm2.695 1.5v-.938h.562v.938H171v.562h-.938v1.875c0 .104.084.188.188.188h.75v.562h-.75a.75.75 0 0 1-.75-.75v-1.875h-.75v-.562z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#g)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#a9abaf",
        fillRule: "evenodd",
        d: "M181.125 16.068c0-.233.189-.422.422-.422h1.734c.845 0 1.594.61 1.594 1.524 0 .367-.121.685-.321.934.414.261.696.708.696 1.269 0 .914-.749 1.523-1.594 1.523h-2.109a.42.42 0 0 1-.422-.422zm2.156 1.781c.45 0 .75-.299.75-.68 0-.38-.3-.679-.75-.679h-1.312v1.36zm-1.312.844h1.687c.45 0 .75.3.75.68s-.3.68-.75.68h-1.687z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#96999e",
        d: "m196.837 17.717-1.687 1.688a.21.21 0 0 1-.283.014l-.015-.014-1.688-1.688.298-.298 1.539 1.538 1.538-1.538z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#h)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#a9abaf",
        fillRule: "evenodd",
        d: "M206.188 16.865a.562.562 0 1 1 1.124-.001.562.562 0 0 1-1.124.001m0 2.813a.562.562 0 1 1 1.124-.002.562.562 0 0 1-1.124.002M212 17.146h-3.75v-.562H212zm0 2.813h-3.75v-.563H212z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#96999e",
        d: "m222.837 17.717-1.687 1.688a.21.21 0 0 1-.283.014l-.015-.014-1.688-1.688.298-.298 1.539 1.538 1.538-1.538z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#a9abaf",
        fillRule: "evenodd",
        d: "M238.625 16.584h-5.25v-.563h5.25zm0 1.968h-5.25v-.562h5.25zM236 20.522h-2.625v-.563H236z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: 10.135,
        height: 10.135,
        x: 246.932,
        y: 13.204,
        stroke: "#e3e4f2",
        strokeOpacity: 0.12,
        strokeWidth: 0.365,
        rx: 2.068
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        stroke: "#a9abaf",
        strokeLinejoin: "round",
        strokeWidth: 0.637,
        d: "M249.938 20.709v-.179l.609-1.605m3.433 1.784v-.179l-.606-1.605m0 0-1.169-3.091h-.484l-1.174 3.091m2.827 0h-2.827"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#a9abaf",
        fillRule: "evenodd",
        d: "M268.082 16.104a1.475 1.475 0 0 1 2.086 2.085l-.844.844-.398-.398.844-.844a.912.912 0 0 0-1.29-1.29l-.844.844-.397-.398zm1.148 1.335-2.062 2.062-.398-.397 2.062-2.063zm-3.398.915.844-.844.398.398-.844.843a.912.912 0 0 0 1.29 1.29l.844-.844.397.398-.843.844a1.475 1.475 0 0 1-2.086-2.085M280 16.443c0-.544.441-.984.984-.984h4.032c.543 0 .984.44.984.984v3.094a.984.984 0 0 1-.984.984h-3.348l-1.247.713a.282.282 0 0 1-.421-.244zm.984-.422a.42.42 0 0 0-.422.422v4.062l.957-.546h3.497a.42.42 0 0 0 .422-.422v-3.094a.42.42 0 0 0-.422-.422zm3.516 1.688h-3v-.563h3zm-1.125 1.125H281.5v-.563h1.875z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: 29.5,
        height: 5,
        x: 289,
        y: 15.771,
        fill: "#3d3f43",
        rx: 1.5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#a9abaf",
        fillRule: "evenodd",
        d: "M327.5 18.271a.563.563 0 1 1 1.125 0 .563.563 0 0 1-1.125 0m2.438 0a.562.562 0 1 1 1.124-.001.562.562 0 0 1-1.124.001m2.437 0a.563.563 0 1 1 1.125 0 .563.563 0 0 1-1.125 0",
        clipRule: "evenodd"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#669df1",
        fillOpacity: 0.14,
        d: "M314 34.745H147.042v14.637H314z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M137.436 32h17.153v18.297h-17.153z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        filter: "url(#i)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#1f1f21",
        d: "M149.798 30.711a6 6 0 0 0-3.969 1.338 6.03 6.03 0 0 0-3.968-1.338h-1.143v3.43h1.143c1.613 0 2.116.801 2.287 1.144v4.506h-1.143v3.43h1.143v3.431c-.148.343-.651 1.144-2.287 1.144h-1.143v3.43h1.143a6.03 6.03 0 0 0 3.968-1.338 5.97 5.97 0 0 0 3.969 1.338h1.143v-3.43h-1.143c-1.613 0-2.116-.8-2.288-1.144v-3.43h1.213V39.79h-1.144v-4.506c.149-.343.652-1.143 2.287-1.143h1.144V30.71z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#cecfd2",
        d: "M149.798 32.998v-1.143a4.57 4.57 0 0 0-3.969 1.875 4.57 4.57 0 0 0-3.968-1.875v1.143a3.21 3.21 0 0 1 3.431 2.104v5.832h-1.144v1.144h1.144v4.757a3.234 3.234 0 0 1-3.431 2.104v1.144a4.64 4.64 0 0 0 3.968-1.864 4.64 4.64 0 0 0 3.969 1.864v-1.144a3.225 3.225 0 0 1-3.362-2.104v-4.769h1.143v-1.143h-1.143v-5.81a3.21 3.21 0 0 1 3.362-2.115"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#fff",
        d: "M-259-131.5h684v385h-684z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "c"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: 419.213,
        height: 220.555,
        x: 58.287,
        y: -67,
        fill: "#fff",
        rx: 5.243
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "d"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#fff",
        d: "M31.03-38.464a3.93 3.93 0 0 1 3.932-3.932h487.582v374.861H31.03z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "f"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: 57,
        height: 14,
        x: 42,
        y: 11.271,
        fill: "#fff",
        rx: 2
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "g"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#fff",
        d: "M177 13.271a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-20a2 2 0 0 1-2-2z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "h"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#fff",
        d: "M203 13.271a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-20a2 2 0 0 1-2-2z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("filter", {
        id: "e",
        width: 311.5,
        height: 30,
        x: 34,
        y: 7.271,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", {
        dy: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
        stdDeviation: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.15 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_13945_18829"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
        stdDeviation: 0.25
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
        in2: "effect1_dropShadow_13945_18829",
        result: "effect2_dropShadow_13945_18829"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_13945_18829",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("filter", {
        id: "i",
        width: 14.292,
        height: 24.521,
        x: 138.718,
        y: 29.708,
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feFlood", {
        floodOpacity: 0,
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feOffset", {
        dy: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feGaussianBlur", {
        stdDeviation: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feColorMatrix", {
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_13945_18829"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect1_dropShadow_13945_18829",
        result: "shape"
    }))));
const $3faf0024169aae07$export$6196548d78d8d0b4 = /*#__PURE__*/ (0, $cozmU.memo)($3faf0024169aae07$var$BannerImageLight);
const $3faf0024169aae07$export$b164ab6127963004 = /*#__PURE__*/ (0, $cozmU.memo)($3faf0024169aae07$var$BannerImageDark);
const $3faf0024169aae07$export$79b5c2b53f30d5cc = /*#__PURE__*/ (0, $cozmU.memo)($3faf0024169aae07$var$NewToolbarBannerImageLight);
const $3faf0024169aae07$export$c074d09e35c0419e = /*#__PURE__*/ (0, $cozmU.memo)($3faf0024169aae07$var$NewToolbarBannerImageDark);


const $17ecc52f8acaba5c$var$layoutArea = 'editor-controls-changeboarding-layout-area';
const $17ecc52f8acaba5c$var$feedbackBannerStyles = (0, $buxP3.xcss)({
    borderBottom: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    color: 'color.text.subtle',
    padding: 'space.150',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    backgroundColor: 'color.background.accent.purple.subtlest',
    alignItems: 'center',
    justifyItems: 'end'
});
const $17ecc52f8acaba5c$var$breakpointContainerQuery = `@container ${$17ecc52f8acaba5c$var$layoutArea} (min-width: 67.5rem)`;
const $17ecc52f8acaba5c$var$shortChangeBoardingImageAddStyles = null;
const $17ecc52f8acaba5c$var$feedbackBannerNewPinningStyles = (0, $buxP3.xcss)({
    containerType: 'inline-size',
    containerName: $17ecc52f8acaba5c$var$layoutArea,
    padding: 'space.0'
});
const $17ecc52f8acaba5c$var$feedbackBannerLayerStyles = (0, $buxP3.xcss)({
    zIndex: 'modal'
});
const $17ecc52f8acaba5c$var$feedbackBannerMessageStyles = (0, $buxP3.xcss)({
    gridArea: 'message',
    textAlign: 'center',
    display: 'inline-block',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 'space.100',
    wordBreak: 'break-word'
});
const $17ecc52f8acaba5c$var$shortFeedbackBannerMessagePinningStyles = null;
const $17ecc52f8acaba5c$var$closeButtonStyles = (0, $buxP3.xcss)({
    display: 'flex',
    justifySelf: 'end',
    gridArea: 'close',
    paddingRight: 'space.150'
});
const $17ecc52f8acaba5c$var$i18n = (0, $kSwu1.defineMessages)({
    bannerClose: {
        id: "editor-action-bar.editor-controls-onboarding.close",
        defaultMessage: "Close"
    },
    lozengeMessage: {
        id: "editor-action-bar.editor-controls-onboarding.lozenge",
        defaultMessage: "New"
    },
    lozengeMessageUpdated: {
        id: "editor-action-bar.editor-controls-onboarding.lozenge.updated",
        defaultMessage: "New"
    },
    collectorCommunityGroup: {
        id: "editor-action-bar.feedback-collector.community-group",
        defaultMessage: "Community group"
    },
    imageAltText: {
        id: "editor-action-bar.editor-controls-onboarding.image-alt-text",
        defaultMessage: "New formatting toolbar button"
    },
    bannerMessageForPinningTopToolbarShort: {
        id: "editor-action-bar.editor-controls-onboarding.message-pinning-inline-toolbar-short",
        defaultMessage: "Try the <link>inline toolbar</link>. Unpin it. Select text to edit."
    },
    bannerMessageForPinningInlineToolbarShort: {
        id: "editor-action-bar.editor-controls-onboarding.message-pinning-top-toolbar-short",
        defaultMessage: "<link>Inline toolbar</link>. Select text to edit. Or pin back to the top."
    },
    shareYourFeedbackShort: {
        id: "editor-action-bar.editor-controls-onboarding.share-your-feedback-short",
        defaultMessage: "<feedback>Feedback</feedback>"
    }
});
const $17ecc52f8acaba5c$export$1666b5647a488a02 = 'https://support.atlassian.com/confluence-cloud/docs/how-to-use-the-new-toolbar-and-insert-elements/';
const $17ecc52f8acaba5c$export$101e4e78d861fa81 = 'https://community.atlassian.com/forums/Confluence-articles/Live-Docs-Beta-update-Control-where-the-edit-tool-bar-lives/ba-p/3005144#M13863';
const $17ecc52f8acaba5c$var$getShortPinningBannerMessage = (bannerType)=>{
    if (bannerType === 'toolbar-inline') return $17ecc52f8acaba5c$var$i18n.bannerMessageForPinningInlineToolbarShort;
    return $17ecc52f8acaba5c$var$i18n.bannerMessageForPinningTopToolbarShort;
};
const $17ecc52f8acaba5c$var$BannerStyleWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_nd5l13um _1yt4utpp _1e0c116y _4cvr1h6o _1bah1h6o _1nmz1hna _1n261g80 _12qsutpp _o5amu2gc"
        ])
    }, children);
const $17ecc52f8acaba5c$var$BannerImageStyleWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_nd5l1sq2 _10fpv2br _1e0cglyw _17vm11p5"
        ])
    }, children);
const $17ecc52f8acaba5c$export$e465eaad07815d4e = ({ onDismiss: onDismiss, triggerAnalyticsEvent: triggerAnalyticsEvent, isLivePage: isLivePage, isEmbeddedConfluence: isEmbeddedConfluence, bannerType: bannerType })=>{
    const isDarkMode = (0, $j5cB3.useIsDarkMode)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [showFeedbackCollector, setShowFeedbackCollector] = (0, $cozmU.useState)(false);
    const { areBannersHidden: areBannersHiddenForLandSimplifyNav } = (0, $u7mpJ.useCreationFocusedNavLand)();
    const { navStyle: navStyle, source: source } = (0, $41KFX.useSimplifiedNavNewUsers)();
    const areBannersHidden = areBannersHiddenForLandSimplifyNav || source === 'xflow' && (0, $41KFX.TREATMENT_COHORTS).has(navStyle);
    (0, $cozmU.useEffect)(()=>{
        if (triggerAnalyticsEvent) triggerAnalyticsEvent('controls.banner.displayed', {
            isLivePage: isLivePage
        });
    }, [
        triggerAnalyticsEvent,
        isLivePage
    ]);
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const handleOnClickClose = ()=>{
        if (triggerAnalyticsEvent) triggerAnalyticsEvent('controls.banner.dismissed', {
            isLivePage: isLivePage
        });
        onDismiss();
    };
    const handleOnClickFeedbackButton = ()=>{
        setShowFeedbackCollector(true);
    };
    const handleSubmitFeedback = ()=>{
        handleOnClickClose();
        setShowFeedbackCollector(false);
    };
    if (isEmbeddedConfluence) return null;
    if ((0, $i3jcY.isStableUIEnabledForTests)() && (0, $6mKj3.expValEquals)('platform_editor_stabilise_ssr_vr_tests', 'isEnabled', true)) return null;
    const isNewToolbarEnabled = true;
    const NewToolbarBannerImage = isDarkMode ? (0, $3faf0024169aae07$export$c074d09e35c0419e) : (0, $3faf0024169aae07$export$79b5c2b53f30d5cc);
    const ChangeBoardingImage = isDarkMode ? (0, $3faf0024169aae07$export$b164ab6127963004) : (0, $3faf0024169aae07$export$6196548d78d8d0b4);
    const BannerImage = isNewToolbarEnabled ? NewToolbarBannerImage : ChangeBoardingImage;
    if (areBannersHidden) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-vc": "editor-controls-onboarding-banner",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9iaFM.default), {
        templateAreas: [
            'image message close'
        ],
        templateColumns: "minmax(max-content, 1fr) auto 1fr",
        xcss: [
            $17ecc52f8acaba5c$var$feedbackBannerStyles,
            $17ecc52f8acaba5c$var$feedbackBannerLayerStyles,
            $17ecc52f8acaba5c$var$feedbackBannerNewPinningStyles
        ],
        testId: "editor-controls-onboarding-banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($17ecc52f8acaba5c$var$BannerImageStyleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BannerImage, {
        title: formatMessage($17ecc52f8acaba5c$var$i18n.imageAltText),
        titleId: `onboarding-banner-image-${isDarkMode ? 'dark' : 'light'}`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($17ecc52f8acaba5c$var$BannerStyleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        xcss: $17ecc52f8acaba5c$var$feedbackBannerMessageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: "new",
        isBold: true
    }, formatMessage($17ecc52f8acaba5c$var$i18n.lozengeMessageUpdated)), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$17ecc52f8acaba5c$var$getShortPinningBannerMessage(bannerType),
        values: {
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8Rhq.default), {
                    href: $17ecc52f8acaba5c$export$1666b5647a488a02,
                    target: "_blank"
                }, chunks),
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
                    weight: "bold"
                }, chunks)
        }
    }), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$17ecc52f8acaba5c$var$i18n.shareYourFeedbackShort,
        values: {
            feedback: (chunks)=>// eslint-disable-next-line @atlassian/a11y/anchor-is-valid
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: "#",
                    onClick: handleOnClickFeedbackButton
                }, chunks)
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $17ecc52f8acaba5c$var$closeButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage($17ecc52f8acaba5c$var$i18n.bannerClose),
        onClick: handleOnClickClose
    }))), showFeedbackCollector && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dcvq8.LazyGlobalFeedbackCollector), {
        onClose: ()=>setShowFeedbackCollector(false),
        onCloseComplete: ()=>{},
        onSubmit: handleSubmitFeedback,
        feedbackSource: (0, $lx6jn.FeedbackSource).EDITOR_CONTROLS,
        additionalFields: {
            source: 'editor-controls-feedback-banner'
        }
    }));
};












var $lmtWR = parcelRequire("lmtWR");

const $3b7f1197d4985005$export$e3fd0f06dd598301 = (isLivePage)=>{
    const isEditorToolbarDockedAtTop = (0, $lEVfb.useIsEditorToolbarDockedAtTop)({
        defaultDockedAtTop: !isLivePage
    });
    const bannerType = (0, $lmtWR.getBannerType)(isEditorToolbarDockedAtTop);
    const [isControlsBannerDismissed, setIsControlsBannerDismissed] = (0, $cozmU.useState)(()=>(0, $lmtWR.isBannerDismissedInLocalStorage)(bannerType));
    (0, $cozmU.useEffect)(()=>{
        setIsControlsBannerDismissed((0, $lmtWR.isBannerDismissedInLocalStorage)(bannerType));
    }, [
        bannerType
    ]);
    const onDismiss = (0, $cozmU.useCallback)(()=>{
        setIsControlsBannerDismissed(true);
        (0, $lmtWR.persistBannerDismissalNewPinning)(bannerType);
    }, [
        bannerType
    ]);
    return {
        isControlsBannerDismissed: isControlsBannerDismissed,
        onDismiss: onDismiss,
        bannerType: bannerType
    };
};



var $1wNUR = parcelRequire("1wNUR");








var $mr7nI = parcelRequire("mr7nI");

var $esV19 = parcelRequire("esV19");





var $1uFM6 = parcelRequire("1uFM6");


var $7LI3Q = parcelRequire("7LI3Q");





var $f7MuR = parcelRequire("f7MuR");


var $6vgLy = parcelRequire("6vgLy");




const $f7052e6541e23622$export$efe806c5aa871995 = ({ onExclude: onExclude })=>{
    const hasFiredRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!hasFiredRef.current) {
            hasFiredRef.current = true;
            onExclude?.();
        }
    }, [
        onExclude
    ]);
    return null;
};


const $f70a72dbc1235d39$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $f70a72dbc1235d39$var$EMBEDDED_CONFLUENCE_FIRST_ACTIVE_TRAIT = 'embedded_confluence_user_first_active';
const $f70a72dbc1235d39$export$7baca885d79a7d1e = ({ children: children, activeDaysThreshold: activeDaysThreshold = 28, activeUserCutoffDate: activeUserCutoffDate, excludeEmbeddedConfluence: excludeEmbeddedConfluence = false, onExclude: onExclude })=>{
    const { data: data, loading: loading, error: error } = (0, $f7MuR.useSiteUserTraits)();
    const attributes = data?.attributes ?? null;
    const confluenceFirstActive = attributes?.find(({ name: name })=>name === $f70a72dbc1235d39$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const embeddedConfluenceFirstActive = attributes?.find(({ name: name })=>name === $f70a72dbc1235d39$var$EMBEDDED_CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const firstActive = excludeEmbeddedConfluence ? confluenceFirstActive : $f70a72dbc1235d39$var$getEarliestDate(confluenceFirstActive, embeddedConfluenceFirstActive);
    const firstActiveDate = firstActive ? new Date(firstActive) : null;
    const { shouldExclude: shouldExclude } = (0, $6vgLy.useShouldExcludeUser)({
        checkDate: firstActiveDate,
        daysThreshold: activeDaysThreshold,
        cutoffDate: activeUserCutoffDate
    });
    if (loading) return null;
    if (error) {
        if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $7LI3Q.isUnauthorizedError)(error)) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
    }
    if (shouldExclude) return onExclude ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f7052e6541e23622$export$efe806c5aa871995), {
        onExclude: onExclude
    }) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
/**
 * Returns the earliest valid date from two date strings, or null if neither is valid
 */ const $f70a72dbc1235d39$var$getEarliestDate = (date1, date2)=>{
    const validDates = [
        date1,
        date2
    ].filter(Boolean).map((date)=>new Date(date || '')).filter((0, $esV19.default));
    if (validDates.length === 0) return null;
    if (validDates.length === 1) return validDates[0].toISOString();
    return (0, $mr7nI.default)(validDates[0], validDates[1]) ? validDates[0].toISOString() : validDates[1].toISOString();
};


const $642dd5941c63cbaa$var$StandardBannerWrapper = ({ isLivePage: isLivePage, isEmbeddedConfluence: isEmbeddedConfluence, viewMode: viewMode, spaceKey: spaceKey, triggerAnalyticsEvent: triggerAnalyticsEvent, contentId: contentId, version: version, isShowingOfflineBanner: isShowingOfflineBanner })=>{
    const { isControlsBannerDismissed: isControlsBannerDismissed, onDismiss: onDismiss, bannerType: bannerType } = (0, $3b7f1197d4985005$export$e3fd0f06dd598301)(isLivePage);
    const { isVisible: isOnboardingEditorDraftBannerVisible } = (0, $1wNUR.useOnboardingBannerLogic)({
        contentId: contentId,
        version: version,
        isShowingOfflineBanner: isShowingOfflineBanner,
        spaceKey: spaceKey,
        setIsOnboardingBannerDataLoaded: ()=>{}
    });
    const shouldShowControlsBanner = !viewMode && !isControlsBannerDismissed && spaceKey !== 'XFLOW' && !isOnboardingEditorDraftBannerVisible && !(0, $9wGTI.fg)('platform_editor_control_remove_banner'); // remove change boarding banner for all customers. Remove the EditorControlsBanner completely when cleaning up the flag.
    if (shouldShowControlsBanner) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f70a72dbc1235d39$export$7baca885d79a7d1e), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $17ecc52f8acaba5c$export$e465eaad07815d4e), {
        onDismiss: onDismiss,
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        isLivePage: isLivePage,
        isEmbeddedConfluence: isEmbeddedConfluence,
        bannerType: bannerType
    }));
    if (spaceKey !== 'XFLOW' && !isLivePage && (0, $9wGTI.fg)('aifc_create_enabled')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fwwrH.SmartCreateFeedbackBannerLoader), {
        contentType: "page"
    });
    return null;
};
const $642dd5941c63cbaa$export$4a2ff2a211b229b0 = /*#__PURE__*/ (0, $cozmU.memo)(({ isAgenticMode: isAgenticMode, onExitAgenticMode: onExitAgenticMode, onDismissAgenticMode: onDismissAgenticMode, agenticModeStartTime: agenticModeStartTime, aiInvocationCountRef: aiInvocationCountRef, aiInvocationSurfacesRef: aiInvocationSurfacesRef, contentId: contentId, spaceKey: spaceKey, ...standardProps })=>{
    if (isAgenticMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2543a86ff2c253ce$export$ac98ab11e0df3bec), {
        onExitAgenticMode: onExitAgenticMode,
        onDismiss: onDismissAgenticMode,
        agenticModeStartTime: agenticModeStartTime,
        aiInvocationCountRef: aiInvocationCountRef,
        aiInvocationSurfacesRef: aiInvocationSurfacesRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($642dd5941c63cbaa$var$StandardBannerWrapper, {
        contentId: contentId,
        spaceKey: spaceKey,
        ...standardProps
    });
});






var $04e9M = parcelRequire("04e9M");


var $68uaC = parcelRequire("68uaC");




const $8a1b04980773868e$var$AGENTIC_MODE_CSS = `
/* ===== AGENTIC EDITOR MODE STYLES ===== */
/* Disable all toolbar buttons */
[data-agentic-mode="true"] [data-testid="ak-editor-main-toolbar"] button { pointer-events: none !important; opacity: 0.3 !important; }
/* Re-enable: Undo button */
[data-agentic-mode="true"] [data-testid="ak-editor-main-toolbar"] button[data-testid="ak-editor-toolbar-button-undo"] { pointer-events: auto !important; opacity: 1 !important; }
/* Re-enable: Redo button */
[data-agentic-mode="true"] [data-testid="ak-editor-main-toolbar"] button[data-testid="ak-editor-toolbar-button-redo"] { pointer-events: auto !important; opacity: 1 !important; }
/* Re-enable: Write (Ask Rovo) button + glow */
[data-agentic-mode="true"] [data-testid="ak-editor-main-toolbar"] button[data-testid="editor-toolbar__ask-rovo"],
[data-agentic-mode="true"] [data-testid="ak-editor-main-toolbar"] [data-testid="editor-toolbar__ask-rovo"] { pointer-events: auto !important; opacity: 1 !important; animation: agenticButtonGlow 3s ease-in-out infinite !important; border-radius: 4px !important; }
/* Re-enable: Ask Rovo dropdown menu */
[data-agentic-mode="true"] [data-testid="ak-editor-main-toolbar"] button[data-testid="editor-toolbar__ask-rovo-menu"],
[data-agentic-mode="true"] [data-testid="ak-editor-main-toolbar"] button[data-testid="editor-toolbar__ask-rovo-menu-display-small"] { pointer-events: auto !important; opacity: 1 !important; }
/* Re-enable: Review (AI suggestions) button + glow */
[data-agentic-mode="true"] [data-testid="ak-editor-main-toolbar"] button[data-testid="editor-toolbar__ai-suggestions-button"],
[data-agentic-mode="true"] [data-testid="ak-editor-main-toolbar"] [data-testid="editor-toolbar__ai-suggestions-button"] { pointer-events: auto !important; opacity: 1 !important; animation: agenticButtonGlow 3s ease-in-out infinite !important; border-radius: 4px !important; }
/* Re-enable: Improve formatting (add-polish) button + glow */
[data-agentic-mode="true"] [data-testid="ak-editor-main-toolbar"] button[data-testid="editor-toolbar__add-polish"],
[data-agentic-mode="true"] [data-testid="ak-editor-main-toolbar"] [data-testid="editor-toolbar__add-polish"] { pointer-events: auto !important; opacity: 1 !important; animation: agenticButtonGlow 3s ease-in-out infinite !important; border-radius: 4px !important; }
/* Re-enable: Improve writing */
[data-agentic-mode="true"] [data-testid="ak-editor-main-toolbar"] button[data-testid="editor-toolbar__improve-writing"] { pointer-events: auto !important; opacity: 1 !important; }
/* Re-enable: Remix */
[data-agentic-mode="true"] [data-testid="ak-editor-main-toolbar"] button[data-testid="editor-toolbar__remix-button"] { pointer-events: auto !important; opacity: 1 !important; }
/* Re-enable: Comment button */
[data-agentic-mode="true"] [data-testid="ak-editor-main-toolbar"] button[data-testid="ak-editor-annotation-toolbar-create-button"] { pointer-events: auto !important; opacity: 1 !important; }
/* Re-enable: AI/Rovo buttons by aria-label pattern */
[data-agentic-mode="true"] [data-testid="ak-editor-main-toolbar"] button[data-testid^="ak-editor-ai-"],
[data-agentic-mode="true"] [data-testid="ak-editor-main-toolbar"] button[aria-label*="Rovo"],
[data-agentic-mode="true"] [data-testid="ak-editor-main-toolbar"] button[aria-label*="AI"] { pointer-events: auto !important; opacity: 1 !important; }
/* Re-enable: AI/Rovo buttons in floating toolbar (portals render outside wrapper \u{2014} scoped via body:has) */
body:has([data-agentic-mode="true"]) [data-testid="editor-toolbar__ask-rovo"],
body:has([data-agentic-mode="true"]) [data-testid="editor-toolbar__ask-rovo"] *,
body:has([data-agentic-mode="true"]) [data-testid="editor-toolbar__ask-rovo-menu"],
body:has([data-agentic-mode="true"]) [data-testid="editor-toolbar__ask-rovo-menu"] *,
body:has([data-agentic-mode="true"]) [data-testid="editor-toolbar__ask-rovo-menu-display-small"],
body:has([data-agentic-mode="true"]) [data-testid="editor-toolbar__ask-rovo-menu-display-small"] *,
body:has([data-agentic-mode="true"]) [data-testid="editor-toolbar__ai-suggestions-button"],
body:has([data-agentic-mode="true"]) [data-testid="editor-toolbar__ai-suggestions-button"] *,
body:has([data-agentic-mode="true"]) [data-testid="editor-toolbar__improve-writing"],
body:has([data-agentic-mode="true"]) [data-testid="editor-toolbar__improve-writing"] *,
body:has([data-agentic-mode="true"]) [data-testid="editor-toolbar__add-polish"],
body:has([data-agentic-mode="true"]) [data-testid="editor-toolbar__add-polish"] *,
body:has([data-agentic-mode="true"]) [data-testid="editor-toolbar__remix-button"],
body:has([data-agentic-mode="true"]) [data-testid="editor-toolbar__remix-button"] *,
body:has([data-agentic-mode="true"]) [data-testid="ak-editor-annotation-toolbar-create-button"],
body:has([data-agentic-mode="true"]) [data-testid="ak-editor-annotation-toolbar-create-button"] *,
body:has([data-agentic-mode="true"]) [data-testid="atlassian-intelligence-toolbar-button"],
body:has([data-agentic-mode="true"]) [data-testid="atlassian-intelligence-toolbar-button"] *,
body:has([data-agentic-mode="true"]) button[data-testid="editor-toolbar__ask-rovo"],
body:has([data-agentic-mode="true"]) button[data-testid="editor-toolbar__ai-suggestions-button"],
body:has([data-agentic-mode="true"]) button[data-testid="atlassian-intelligence-toolbar-button"] { pointer-events: auto !important; opacity: 1 !important; }
/* Glow animation - solid purple pulse */
@keyframes agenticButtonGlow {
0%, 100% { box-shadow: 0 0 6px 2px rgba(130, 112, 219, 0.3), 0 0 12px 4px rgba(130, 112, 219, 0.15); }
50% { box-shadow: 0 0 12px 4px rgba(130, 112, 219, 0.5), 0 0 24px 8px rgba(130, 112, 219, 0.25); }
}
/* Accessibility: respect prefers-reduced-motion (WCAG 2.1 SC 2.3.3) \u{2014} suppress animation entirely */
@media (prefers-reduced-motion: reduce) {
[data-agentic-mode="true"] [data-testid="ak-editor-main-toolbar"] [data-testid="editor-toolbar__ask-rovo"],
[data-agentic-mode="true"] [data-testid="ak-editor-main-toolbar"] [data-testid="editor-toolbar__ai-suggestions-button"],
[data-agentic-mode="true"] [data-testid="ak-editor-main-toolbar"] [data-testid="editor-toolbar__add-polish"],
body:has([data-agentic-mode="true"]) button:has(span[aria-label="Rovo"]) { animation: none !important; }
}
/* Glow the whole selection floating toolbar (portalled outside editor wrapper \u{2014} scoped via body:has) */
body:has([data-agentic-mode="true"]) [data-testid="editor-floating-toolbar"][aria-label="Selection toolbar"] { box-shadow: 0 0 12px 4px rgba(130, 112, 219, 0.4), 0 0 24px 8px rgba(130, 112, 219, 0.2); border-radius: 8px; }
/* Ask Rovo button glow (top-right page button \u{2014} outside editor wrapper, scoped via body:has) */
body:has([data-agentic-mode="true"]) button:has(span[aria-label="Rovo"]) { animation: agenticButtonGlow 3s ease-in-out infinite !important; border-radius: 4px !important; }
/* Hide quick insert (+) button */
[data-agentic-mode="true"] [data-testid="block-ctrl-quick-insert-button"], [data-agentic-mode="true"] button[data-testid="editor-quick-insert-button"] { display: none !important; }
/* Remove glow from inline AI button in selection toolbar (whole toolbar already glows \u{2014} portalled, scoped via body:has) */
body:has([data-agentic-mode="true"]) button[data-testid="ak-editor-ai-selection-toolbar-ai-button"] { animation: none !important; box-shadow: none !important; }
/* Hide drag handle */
[data-agentic-mode="true"] [data-testid="block-ctrl-drag-handle-container"] { display: none !important; }
`;
const $8a1b04980773868e$export$2b2210c14699d354 = (target)=>{
    if (!(target instanceof HTMLElement)) return false;
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') return false;
    if (target.closest('[data-testid="ak-editor-plugin-ai-modal"]')) return false;
    if (target.closest('[data-testid^="ak-editor-ai"]')) return false;
    if (target.closest('[data-testid="rovo-prompt-session-screen"]')) return false;
    if (target.closest('[data-testid="chromeless-editor"]')) return false;
    return target.closest('.ProseMirror') !== null;
};
// Cookie name for the dismiss cooldown. We use @confluence/cookies with CookieLevel.NECESSARY
// because window.localStorage is proxied by SSRStorage which blocks unregistered keys.
// This is an internal-only experiment (hello.atlassian.net).
// TODO: migrate to registered storage-manager key if experiment graduates to GA.
const $8a1b04980773868e$var$DISMISS_COOKIE_NAME = 'agentic-editor-mode-dismissed';
// True while the dismiss cooldown is active (the cookie auto-expires 1hr after dismiss).
const $8a1b04980773868e$var$isWithinDismissCooldown = ()=>(0, $68uaC.Cookies).get($8a1b04980773868e$var$DISMISS_COOKIE_NAME) === '1';
// Set the dismiss cookie with a fixed 1hr expiry from the moment of dismissal.
const $8a1b04980773868e$var$setDismissCooldown = ()=>{
    (0, $68uaC.Cookies).set($8a1b04980773868e$var$DISMISS_COOKIE_NAME, '1', {
        expires: 1 / 24
    }, (0, $68uaC.CookieLevel).NECESSARY);
};
// Cap the surfaces serialised into analytics to the top-N by count, keeping the
// telemetry payload bounded even if many distinct surfaces accumulate.
const $8a1b04980773868e$var$MAX_TRACKED_SURFACES = 10;
const $8a1b04980773868e$var$serializeTopSurfaces = (surfaces)=>JSON.stringify(Object.fromEntries(Object.entries(surfaces).sort(([, a], [, b])=>b - a).slice(0, $8a1b04980773868e$var$MAX_TRACKED_SURFACES)));
const $8a1b04980773868e$export$813250ab9f37732b = ({ isMarkdownMode: isMarkdownMode = false } = {})=>{
    const [isAgenticMode, setIsAgenticMode] = (0, $cozmU.useState)(false);
    const agenticEditorRef = (0, $cozmU.useRef)(null);
    const agenticModeStartTime = (0, $cozmU.useRef)(0);
    // Per-session AI usage counters, reset on entry and read at submit time.
    const aiInvocationCount = (0, $cozmU.useRef)(0);
    const aiInvocationSurfaces = (0, $cozmU.useRef)({});
    // Dedupe AI events so a single user prompt only increments the counter once.
    const countedInteractionIds = (0, $cozmU.useRef)(new Set());
    // Fire `entered` analytics on mount via GAS web client. Context-based analytics
    // (useAnalyticsEvents) won't work — this hook sits above EditorAnalyticsListener.
    // `cancelled` guards against React 18 Strict Mode double-mount in dev.
    (0, $cozmU.useEffect)(()=>{
        let cancelled = false;
        if (isMarkdownMode) return;
        if ((0, $6mKj3.expValEquals)('confluence_agentic_editor_mode', 'isEnabled', true)) {
            // Within the dismiss cooldown: stay hidden until the cookie expires (fixed 1hr from dismiss).
            if ($8a1b04980773868e$var$isWithinDismissCooldown()) return;
            agenticModeStartTime.current = Date.now();
            setIsAgenticMode(true);
            (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                if (cancelled) return;
                client.sendTrackEvent({
                    action: 'entered',
                    actionSubject: 'agenticEditorMode',
                    source: 'agenticEditorMode',
                    // 'editor' tag required by the analytics registry (platform team).
                    tags: [
                        'editor'
                    ],
                    attributes: {
                        experimentName: 'confluence_agentic_editor_mode'
                    }
                });
            }).catch(()=>{
            // Swallow analytics errors — agentic mode should still work.
            });
        }
        return ()=>{
            cancelled = true;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleExitAgenticMode = (0, $cozmU.useCallback)(()=>{
        setIsAgenticMode(false);
        agenticModeStartTime.current = 0;
        aiInvocationCount.current = 0;
        countedInteractionIds.current.clear();
        aiInvocationSurfaces.current = {};
    }, []);
    // Tear down if the page becomes Markdown after activation (e.g. live page converted to Markdown).
    (0, $cozmU.useEffect)(()=>{
        if (isMarkdownMode && isAgenticMode) handleExitAgenticMode();
    }, [
        isMarkdownMode,
        isAgenticMode,
        handleExitAgenticMode
    ]);
    // Dismiss (X) — exits without the feedback modal, silences the banner for the cooldown, and fires a `dismissed` event.
    const handleDismissAgenticMode = (0, $cozmU.useCallback)(()=>{
        const startTime = agenticModeStartTime.current;
        const invocationCount = aiInvocationCount.current;
        const surfaces = aiInvocationSurfaces.current;
        $8a1b04980773868e$var$setDismissCooldown();
        (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
            client.sendTrackEvent({
                action: 'dismissed',
                actionSubject: 'agenticEditorMode',
                source: 'agenticEditorMode',
                // 'editor' tag required by the analytics registry (platform team).
                tags: [
                    'editor'
                ],
                attributes: {
                    experimentName: 'confluence_agentic_editor_mode',
                    ...startTime ? {
                        timeInAgenticModeMs: Date.now() - startTime
                    } : {},
                    aiInvocationCount: invocationCount,
                    ...Object.keys(surfaces).length > 0 ? {
                        aiInvocationSurfaces: $8a1b04980773868e$var$serializeTopSurfaces(surfaces)
                    } : {}
                }
            });
        }).catch(()=>{
        // Swallow analytics errors — user should still be exited from agentic mode.
        });
        handleExitAgenticMode();
    }, [
        handleExitAgenticMode
    ]);
    // Count distinct AI invocations during agentic mode. Editor AI fires different
    // events on different surfaces (floatingToolbar fires aiInteraction:initiated
    // + aiResult:viewed; streamingApi only aiResult:actioned), so we match all of
    // them and dedupe on singleInstrumentationID to count each prompt once.
    const onEditorAnalyticsEvent = (0, $cozmU.useCallback)((event)=>{
        if (!isAgenticMode) return;
        const { actionSubject: actionSubject, action: action, attributes: attributes } = event.payload ?? {};
        const isAiInvocation = actionSubject === 'aiInteraction' && action === 'initiated' || actionSubject === 'aiResult' && (action === 'viewed' || action === 'actioned' || action === 'error');
        if (!isAiInvocation) return;
        const interactionId = attributes && typeof attributes.singleInstrumentationID === 'string' ? attributes.singleInstrumentationID : undefined;
        if (interactionId) {
            if (countedInteractionIds.current.has(interactionId)) return;
            countedInteractionIds.current.add(interactionId);
        }
        aiInvocationCount.current += 1;
        const surface = (attributes && typeof attributes.invokedFrom === 'string' ? attributes.invokedFrom : undefined) ?? 'unknown';
        aiInvocationSurfaces.current[surface] = (aiInvocationSurfaces.current[surface] || 0) + 1;
    }, [
        isAgenticMode
    ]);
    // Inject agentic mode CSS into document head
    (0, $cozmU.useEffect)(()=>{
        if (!isAgenticMode) return;
        const style = document.createElement('style');
        style.setAttribute('data-agentic-mode-styles', '');
        style.textContent = $8a1b04980773868e$var$AGENTIC_MODE_CSS;
        document.head.appendChild(style);
        return ()=>{
            style.remove();
        };
    }, [
        isAgenticMode
    ]);
    // Block keyboard/input/clipboard/drag events in the main editor
    (0, $cozmU.useEffect)(()=>{
        if (!isAgenticMode) return;
        const container = agenticEditorRef.current;
        if (!container) return;
        const handleKeyDown = (e)=>{
            if (!$8a1b04980773868e$export$2b2210c14699d354(e.target)) return;
            // Allow: Ctrl/Cmd+C (copy), +A (select all), +Z (undo), +Y (redo), +F (browser find)
            const allowedKeys = [
                'c',
                'a',
                'z',
                'y',
                'f'
            ];
            const isModifierCombo = (e.ctrlKey || e.metaKey) && allowedKeys.includes(e.key.toLowerCase());
            const isNavigationKey = [
                'ArrowUp',
                'ArrowDown',
                'ArrowLeft',
                'ArrowRight',
                'Home',
                'End',
                'PageUp',
                'PageDown',
                'Escape'
            ].includes(e.key);
            const isModifierOnly = [
                'Shift',
                'Control',
                'Alt',
                'Meta'
            ].includes(e.key);
            const isFunctionKey = e.key.length >= 2 && e.key.length <= 3 && e.key.startsWith('F') && !isNaN(Number(e.key.slice(1)));
            if (!isModifierCombo && !isNavigationKey && !isModifierOnly && !isFunctionKey) {
                e.preventDefault();
                e.stopPropagation();
            }
        };
        // Shared handler for beforeinput/paste/cut/drop/dragstart/compositionstart — all block input in main editor
        const blockIfMainEditor = (e)=>{
            if ($8a1b04980773868e$export$2b2210c14699d354(e.target)) {
                e.preventDefault();
                e.stopPropagation();
            }
        };
        container.addEventListener('keydown', handleKeyDown, true);
        container.addEventListener('beforeinput', blockIfMainEditor, true);
        container.addEventListener('paste', blockIfMainEditor, true);
        container.addEventListener('cut', blockIfMainEditor, true);
        // Block IME composition (CJK keyboards bypass keydown/beforeinput via composition events)
        container.addEventListener('compositionstart', blockIfMainEditor, true);
        // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop -- blocking drag in agentic mode requires native event listeners
        container.addEventListener('drop', blockIfMainEditor, true);
        // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop -- blocking drag in agentic mode requires native event listeners
        container.addEventListener('dragstart', blockIfMainEditor, true);
        return ()=>{
            container.removeEventListener('keydown', handleKeyDown, true);
            container.removeEventListener('beforeinput', blockIfMainEditor, true);
            container.removeEventListener('paste', blockIfMainEditor, true);
            container.removeEventListener('cut', blockIfMainEditor, true);
            container.removeEventListener('compositionstart', blockIfMainEditor, true);
            container.removeEventListener('drop', blockIfMainEditor, true);
            container.removeEventListener('dragstart', blockIfMainEditor, true);
        };
    }, [
        isAgenticMode
    ]);
    return {
        isAgenticMode: isAgenticMode,
        handleExitAgenticMode: handleExitAgenticMode,
        handleDismissAgenticMode: handleDismissAgenticMode,
        agenticEditorRef: agenticEditorRef,
        agenticModeStartTime: agenticModeStartTime.current || undefined,
        // Expose refs (not snapshots) so consumers see live increments at submit time.
        aiInvocationCountRef: aiInvocationCount,
        aiInvocationSurfacesRef: aiInvocationSurfaces,
        onEditorAnalyticsEvent: onEditorAnalyticsEvent
    };
};






var $lrMxq = parcelRequire("lrMxq");


function $1e65a39b95334039$export$7d2a7d16db4db259({ editorApi: editorApi, hasAiButton: hasAiButton, hasAudioButton: hasAudioButton, contentId: contentId, spaceKey: spaceKey, contentType: contentType, contentTitle: contentTitle, isUnpublishedDraft: isUnpublishedDraft, disabled: disabled, isEditorEmpty: isEditorEmpty, isMarkdownMode: isMarkdownMode, isMarkdownModeSyntaxViewToggled: isMarkdownModeSyntaxViewToggled }) {
    const { aiIsStreaming: aiIsStreaming } = (0, $c907e804706c3ad7$export$34125ddc34657a7f)(editorApi);
    const getAdfDocument = (0, $cozmU.useCallback)(()=>{
        return new Promise((resolve)=>{
            if (editorApi?.core?.actions?.requestDocument) editorApi.core.actions.requestDocument((doc)=>{
                resolve(doc);
            });
            else resolve(null);
        });
    }, [
        editorApi
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lrMxq.ObjectSidebarControl), {
        key: "object-sidebar-control",
        hasCommentsButton: true,
        hasDetailsButton: true,
        hasLoomButton: true,
        hasAiButton: hasAiButton,
        hasRemixButton: true,
        hasAudioButton: hasAudioButton,
        aiIsStreaming: aiIsStreaming,
        contentId: contentId,
        spaceKey: spaceKey,
        contentType: contentType,
        contentTitle: contentTitle,
        isUnpublishedDraft: isUnpublishedDraft,
        disabled: disabled,
        isEditorEmpty: isEditorEmpty,
        isMarkdownMode: isMarkdownMode,
        isMarkdownModeSyntaxViewToggled: isMarkdownModeSyntaxViewToggled,
        getAdfDocument: getAdfDocument
    });
}









var $gAcLU = parcelRequire("gAcLU");


var $8Psje = parcelRequire("8Psje");


var $de2j9 = parcelRequire("de2j9");


var $wtSEP = parcelRequire("wtSEP");




const $ea0f0e1bfeeed9fe$export$72f7c3354b160bdb = (Component)=>{
    return (props)=>{
        const { location: location } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $7zgzO.RoutesContext));
        const isEditorPage = (0, $de2j9.useIsEditorPage)();
        const isEmbeddedRovoSystemSpaceAllowed = (0, $gAcLU.isEmbeddedRovoSystemSpaceAccessAllowed)({
            isEditorPage: isEditorPage,
            location: location
        });
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        if ((0, $8Psje.isRovoSystemSpaceKey)(props.spaceKey) && !isEmbeddedRovoSystemSpaceAllowed && (0, $9wGTI.fg)('aifc_create_enabled')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $wtSEP.NotFound), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props);
    };
};

























var $j8hiR = parcelRequire("j8hiR");


var $9137z = parcelRequire("9137z");

const $455b0e3615badc4d$export$257c6c9e28c0ad4b = (collabEditProvider)=>{
    const handleConnecting = ()=>{
        // tracking time between when provider is created in the FE and when channel initialization starts
        (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_PRE_CONNECTED);
        // tracking time between when provider's channel is initialized and when connected event is fired
        (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_CONNECTED);
    };
    (0, $cozmU.useEffect)(()=>{
        if (!collabEditProvider) return;
        // @ts-ignore
        collabEditProvider.on('connecting', handleConnecting);
        return ()=>{
            // @ts-ignore
            collabEditProvider.off('connecting', handleConnecting);
        };
    }, [
        collabEditProvider
    ]);
};









var $f6RxU = parcelRequire("f6RxU");


var $8qyRg = parcelRequire("8qyRg");


var $duCvb = parcelRequire("duCvb");


var $ge2sX = parcelRequire("ge2sX");







/**
 * @generated SignedSource<<d3f3e2f7d286a58ab668fe6b7df43471>>
 * @relayHash 03e3dbfe626dfb1a261be6353a81c32c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 50e03e82c9f8e6fb9d603fc0cfdc43bd1b639e1540416b979719945a94563a0d
const $f79e9585268baf8c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "schedulePublishDate"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentSchedulePublishQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentSchedulePublishQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "03e3dbfe626dfb1a261be6353a81c32c",
            "id": "50e03e82c9f8e6fb9d603fc0cfdc43bd1b639e1540416b979719945a94563a0d",
            "metadata": {},
            "name": "ContentSchedulePublishQuery",
            "operationKind": "query",
            "text": "query ContentSchedulePublishQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,schedulePublishDate}}}"
        }
    };
}();
$f79e9585268baf8c$var$node.hash = "f718f8310d58df9ba0bc961934043932";
var $f79e9585268baf8c$export$2e2bcd8739ae039 = $f79e9585268baf8c$var$node;


const $f9205d97e0969451$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    rescheduleUpdateWithSpaceName: {
        id: "editor-schedule-publish.success.reschedule.update.with.space.name",
        defaultMessage: "{pageTitle} has been rescheduled to update on {date} at {time} in the {spaceName} space"
    },
    rescheduleUpdate: {
        id: "editor-schedule-publish.success.reschedule.update",
        defaultMessage: "{pageTitle} has been rescheduled to update on {date} at {time}"
    },
    reschedulePublishWithSpaceName: {
        id: "editor-schedule-publish.success.reschedule.publish.with.space.name",
        defaultMessage: "{pageTitle} has been rescheduled to publish on {date} at {time} in the {spaceName} space"
    },
    reschedulePublish: {
        id: "editor-schedule-publish.success.reschedule.publish",
        defaultMessage: "{pageTitle} has been rescheduled to publish on {date} at {time}"
    },
    scheduleUpdateWithSpaceName: {
        id: "editor-schedule-publish.success.schedule.update.message.with.space.name",
        defaultMessage: "{pageTitle} will be updated on {date} at {time} in the {spaceName} space"
    },
    scheduleUpdate: {
        id: "editor-schedule-publish.success.schedule.update.message",
        defaultMessage: "{pageTitle} will be updated on {date} at {time}"
    },
    schedulePublishWithSpaceName: {
        id: "editor-schedule-publish.success.schedule.publish.message.with.space.name",
        defaultMessage: "{pageTitle} will be published on {date} at {time} in the {spaceName} space"
    },
    schedulePublish: {
        id: "editor-schedule-publish.success.schedule.publish.message",
        defaultMessage: "{pageTitle} will be published on {date} at {time}"
    },
    scheduleUpdateTitle: {
        id: "editor-schedule-publish.success.schedule.update.title",
        defaultMessage: "Update scheduled"
    },
    schedulePublishTitle: {
        id: "editor-schedule-publish.success.schedule.publish.title",
        defaultMessage: "Publish scheduled"
    }
});
const $f9205d97e0969451$export$206997a838ea4b9d = ({ contentId: contentId, contentType: contentType, title: title, isUnpublishedDraft: isUnpublishedDraft, flags: flags, isSchedulePublishEnabled: // TODO MODES-3970 isSchedulePublishEnabled should be removed when when its consumer(FullPageEditorComponent) doesn't have to support the use case of schedule publish being disabled.
// This is set to true when on a live page. Live pages currently use FullPageEditorComponent and do not support scheduling publishes.
isSchedulePublishEnabled = true })=>{
    const [currentlyScheduledPublishDate, setCurrentlyScheduledPublishDate] = (0, $cozmU.useState)(null);
    const [spaceName] = (0, $cozmU.useState)();
    const intl = (0, $kSwu1.useIntl)();
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const [getContent, { data: contentData }] = (0, $lvOsp.useLazyQueryInterop)((0, $f79e9585268baf8c$export$2e2bcd8739ae039), {
        fetchPolicy: 'network-only',
        __callerPackage__: "editor-schedule-publish"
    });
    /**
   * Store refs to state values used in handleSchedulePublish, because putting them
   * directly into the callback causes the memoized function to be recreated several
   * times rapidly, resulting in issues with PubSub subscribe/unsubscribing properly
   */ const flagDataRef = (0, $cozmU.useRef)({
        spaceName: spaceName,
        title: title,
        isUnpublishedDraft: isUnpublishedDraft,
        currentlyScheduledPublishDate: currentlyScheduledPublishDate
    });
    /**
   * Returns the object received by intl.formatMessage for the schedule publish success flag's content
   */ const getFlagMessage = (0, $cozmU.useCallback)(()=>{
        const updating = !flagDataRef.current.isUnpublishedDraft;
        if (flagDataRef.current.currentlyScheduledPublishDate) {
            // Rescheduling
            if (updating) {
                if (flagDataRef.current.spaceName) return $f9205d97e0969451$export$a7357cdd1f0b0168.rescheduleUpdateWithSpaceName;
                return $f9205d97e0969451$export$a7357cdd1f0b0168.rescheduleUpdate;
            } else {
                // Publishing
                if (flagDataRef.current.spaceName) return $f9205d97e0969451$export$a7357cdd1f0b0168.reschedulePublishWithSpaceName;
                return $f9205d97e0969451$export$a7357cdd1f0b0168.reschedulePublish;
            }
        } else // Scheduling (for first time)
        if (updating) {
            if (flagDataRef.current.spaceName) return $f9205d97e0969451$export$a7357cdd1f0b0168.scheduleUpdateWithSpaceName;
            return $f9205d97e0969451$export$a7357cdd1f0b0168.scheduleUpdate;
        } else {
            // Publishing
            if (flagDataRef.current.spaceName) return $f9205d97e0969451$export$a7357cdd1f0b0168.schedulePublishWithSpaceName;
            return $f9205d97e0969451$export$a7357cdd1f0b0168.schedulePublish;
        }
    }, []);
    const handleSchedulePublish = (0, $cozmU.useCallback)((_delta, response)=>{
        const { eventType: eventType, publishTime: publishTime } = response?.schedulePublished || {};
        const { accountId: accountId } = response;
        if (!isSchedulePublishEnabled) return;
        switch(eventType){
            case 'scheduled':
                const scheduledPublishDate = new Date(publishTime);
                const monthDayRegex = /[^,]*$/g; // selects everything after comma ","
                const updating = !flagDataRef.current.isUnpublishedDraft;
                flags.showFlag({
                    type: 'success-circle',
                    close: 'auto',
                    title: intl.formatMessage(updating ? $f9205d97e0969451$export$a7357cdd1f0b0168.scheduleUpdateTitle : $f9205d97e0969451$export$a7357cdd1f0b0168.schedulePublishTitle),
                    description: intl.formatMessage(getFlagMessage(), {
                        pageTitle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, flagDataRef.current.title),
                        date: (0, $f6RxU.default)(scheduledPublishDate, 'PP').replace(monthDayRegex, ''),
                        time: (0, $8qyRg.format)(scheduledPublishDate, 'h:mm aaaa z'),
                        spaceName: flagDataRef.current.spaceName
                    })
                }).finally(()=>{
                    setCurrentlyScheduledPublishDate(scheduledPublishDate);
                });
                break;
            case 'unscheduled':
                setCurrentlyScheduledPublishDate(null);
                break;
            case 'published':
                (0, $ge2sX.getSessionData)().then(({ userId: userId })=>{
                    if (accountId === userId) (0, $duCvb.showPublishSuccessFlags)({
                        isFirstTimePublish: isUnpublishedDraft,
                        shouldTimeout: false,
                        spaceName: flagDataRef.current.spaceName,
                        flags: flags,
                        title: flagDataRef.current.title,
                        intl: intl
                    });
                });
        }
    }, [
        getFlagMessage,
        isUnpublishedDraft,
        intl,
        flags,
        isSchedulePublishEnabled
    ]);
    (0, $i9VoI.useSubscriptionEvent)({
        contentId: contentId,
        contentType: contentType,
        subscriberId: 'useSchedulePublishFlagsWatcher',
        delta: 'schedulePublished',
        onDataReceived: handleSchedulePublish
    });
    (0, $cozmU.useEffect)(()=>{
        if (!isSchedulePublishEnabled) return;
        const params = {
            contentId: contentId,
            status: [
                isUnpublishedDraft ? 'draft' : 'current'
            ]
        };
        getContent({
            variables: params
        });
    }, [
        getContent,
        contentId,
        isUnpublishedDraft,
        isSchedulePublishEnabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isSchedulePublishEnabled) return;
        const contentSchedulePublishDate = contentData?.content?.nodes?.[0]?.schedulePublishDate;
        const date = contentSchedulePublishDate ? new Date(contentSchedulePublishDate) : null;
        setCurrentlyScheduledPublishDate(date);
    // The spaceName used to be set here, but it was sometimes invalid.
    // Please re-add calling `setSpaceName` here after GENI-2960 is completed.
    }, [
        contentData,
        isSchedulePublishEnabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        flagDataRef.current = {
            spaceName: spaceName,
            title: title,
            isUnpublishedDraft: isUnpublishedDraft,
            currentlyScheduledPublishDate: currentlyScheduledPublishDate
        };
    }, [
        spaceName,
        title,
        isUnpublishedDraft,
        currentlyScheduledPublishDate
    ]);
};



var $9ovft = parcelRequire("9ovft");

/**
 * @generated SignedSource<<069c67ccded678ecb42a0ce2fd470e73>>
 * @relayHash 8bfbe169b389a1e7204587b320193865
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 84bda087bbcb85556c465b27fc25c3d45b4dc9a60e60182e59bd0ba208af3063
const $3e37adb324f46f61$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSuggestedEditsUpdatedSubscription",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceSuggestedEditsUpdated",
                    "kind": "LinkedField",
                    "name": "confluence_onSuggestedEditsUpdated",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSuggestedEditsUpdatedSubscription",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceSuggestedEditsUpdated",
                    "kind": "LinkedField",
                    "name": "confluence_onSuggestedEditsUpdated",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "8bfbe169b389a1e7204587b320193865",
            "id": "84bda087bbcb85556c465b27fc25c3d45b4dc9a60e60182e59bd0ba208af3063",
            "metadata": {},
            "name": "useSuggestedEditsUpdatedSubscription",
            "operationKind": "subscription",
            "text": "subscription useSuggestedEditsUpdatedSubscription($id:ID!){confluence_onSuggestedEditsUpdated(id:$id){accountId,__typename,id}}"
        }
    };
}();
$3e37adb324f46f61$var$node.hash = "8cd3bcd75594209560875934278358ea";
var $3e37adb324f46f61$export$2e2bcd8739ae039 = $3e37adb324f46f61$var$node;






var $fD0Uz = parcelRequire("fD0Uz");


var $3vc4U = parcelRequire("3vc4U");























var $d9tcB = parcelRequire("d9tcB");

const $16c571a0db84530f$var$errorStringsToIgnore = [
    '401',
    'Failed to fetch',
    'Load Failed',
    'Network error',
    'GraphQL error: undefined'
];
const $16c571a0db84530f$export$6a826f71c6c5469c = ({ contentId: contentId, contentType: contentType, onSuggestedEditsUpdated: onSuggestedEditsUpdated, skip: skip = false })=>{
    const { id: id, onSubscriptionComplete: onSubscriptionComplete, extensions: extensions, onSubscriptionData: onSubscriptionData } = (0, $3vc4U.useSubscriptionValues)({
        contentType: contentType,
        contentId: contentId
    });
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const skipSubscriptionForAnonUsers = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS;
    const { error: error } = (0, $fD0Uz.useSubscriptionInterop)((0, $3e37adb324f46f61$export$2e2bcd8739ae039), {
        variables: {
            id: id
        },
        extensions: extensions,
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData (response) {
            if (response?.subscriptionData?.data?.confluence_onSuggestedEditsUpdated) onSuggestedEditsUpdated();
            onSubscriptionData(response);
        },
        skip: skip || !id || skipSubscriptionForAnonUsers,
        interopApolloAggClient: true,
        __callerPackage__: "editor-features"
    });
    (0, $cozmU.useEffect)(()=>{
        if (error) {
            const errorMessage = error?.message || error?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.message || error?.graphQLErrors?.[0]?.originalError?.message || error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.extensions?.message;
            // When graphql-subscriptions rate-limits us it returns an HTML page (eg a 429),
            // which graphql-ws feeds into JSON.parse and throws a SyntaxError. In V8 the
            // thrown message embeds the offending token, eg:
            //   Unexpected token '<', "<!DOCTYPE "... is not valid JSON
            // We match on the HTML markers rather than the generic "Unexpected token" so we
            // only suppress HTML payloads and not unrelated malformed-JSON bugs.
            const isHtmlRateLimitError = (0, $1xpoY.default).getBoolean('confluence_html_error_catching', false) && Boolean(errorMessage && /Unexpected token '<'|<!DOCTYPE|<html/.test(errorMessage));
            const isIgnoredError = $16c571a0db84530f$var$errorStringsToIgnore.some((errorString)=>error?.message.includes(errorString)) || !errorMessage || isHtmlRateLimitError;
            const statusCode = (0, $aMcHK.getStatusCode)(error) || error?.errors?.[0]?.extensions?.statusCode;
            if (statusCode !== 403 && !isIgnoredError) {
                const e = new Error(`Subscription Error - useSuggestedEditsUpdatedSubscription:${errorMessage}`);
                (0, $fJlJm.setContentErrorAttributes)(e, {
                    objectId: contentId,
                    objectType: contentType
                });
                (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                    attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
                });
            }
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error,
        contentId,
        contentType
    ]);
};



var $essql = parcelRequire("essql");


var $hycHC = parcelRequire("hycHC");

/**
 * @generated SignedSource<<8d9952586880ccd9a27f1488767df058>>
 * @relayHash a9cd468cc7d0e510656c933a0f5cfc19
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9fa48921cef6083855f0594c590f0a4623a1bf99ebe36fdf36903e4ee8b64caf
const $ccdedf646f6a728d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "current",
                        "draft"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "createdDate"
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "when"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "sendContentAgeAnalyticsGetContentAgeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "sendContentAgeAnalyticsGetContentAgeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "a9cd468cc7d0e510656c933a0f5cfc19",
            "id": "9fa48921cef6083855f0594c590f0a4623a1bf99ebe36fdf36903e4ee8b64caf",
            "metadata": {},
            "name": "sendContentAgeAnalyticsGetContentAgeQuery",
            "operationKind": "query",
            "text": "query sendContentAgeAnalyticsGetContentAgeQuery($contentId:ID!){content(id:$contentId,status:[\"current\",\"draft\"]){nodes{id,history{createdDate},version{when}}}}"
        }
    };
}();
$ccdedf646f6a728d$var$node.hash = "b714b9334919637eb6a47f1f5260ef2d";
var $ccdedf646f6a728d$export$2e2bcd8739ae039 = $ccdedf646f6a728d$var$node;














const $6fc6623dec610eba$export$ea50f0fba62a9f14 = async (createAnalyticsEvent, { contentId: contentId, collabService: collabService })=>{
    if (!createAnalyticsEvent || !contentId) return;
    try {
        const result = await (0, $c0rhi.queryInterop)({
            query: (0, $ccdedf646f6a728d$export$2e2bcd8739ae039),
            variables: {
                contentId: contentId
            },
            fetchPolicy: 'cache-first',
            __callerPackage__: "editor-features"
        });
        let utcCreatedDate = result.data?.content?.nodes?.[0]?.history?.createdDate;
        let isUnpublishedDraft = false;
        if (!utcCreatedDate) {
            if (!!result.data?.content?.nodes?.[0]?.version?.when) {
                // unpublished draft, so use draft creation date
                utcCreatedDate = result.data?.content?.nodes?.[0]?.version?.when;
                isUnpublishedDraft = true;
            } else return;
        }
        const { shard: shard, edition: edition } = await (0, $ge2sX.getSessionData)();
        // get created and current date in UTC ms time
        const createdDate = new Date(utcCreatedDate).getTime();
        const currentDate = Date.now();
        // number of days between this (latest) edit and page creation
        const daysSinceCreated = Math.floor((currentDate - createdDate) / 86400000);
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                actionSubject: 'editor',
                action: 'trackPageLifetime',
                source: 'editorComponent',
                attributes: {
                    contentId: contentId,
                    daysSinceCreated: daysSinceCreated,
                    collabService: collabService,
                    isUnpublishedDraft: isUnpublishedDraft,
                    shard: shard,
                    edition: edition
                }
            }
        }).fire();
    } catch  {
        return;
    }
};
const $6fc6623dec610eba$export$f46ffb959d708168 = ({ contentId: contentId, collabService: collabService })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        $6fc6623dec610eba$export$ea50f0fba62a9f14(createAnalyticsEvent, {
            contentId: contentId,
            collabService: collabService
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
};














const $30f609f1a737209e$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $cozmU.useRef)();
    (0, $cozmU.useEffect)(()=>{
        // Only re-run if value is updated
        ref.current = value;
    }, [
        value
    ]);
    // Return previous value (happens before the update in useEffect)
    return ref.current;
};


const $b332f5d2fa8005d6$var$getDisabledReason = ({ shouldRenderPreview: shouldRenderPreview, isTitleFocused: isTitleFocused, collabEditError: collabEditError, collabLimitReached: collabLimitReached, heartbeatError: heartbeatError, saveDraftError: saveDraftError })=>{
    if (shouldRenderPreview) return 'should-render-preview';
    else if (isTitleFocused) return 'title-focused';
    else if (collabLimitReached) return 'collab-limit-reached';
    else if (collabEditError) return collabEditError.code;
    else if (heartbeatError) return heartbeatError.reason;
    else if (saveDraftError) return `Draft sync returned status ${saveDraftError?.statusCode}`;
    return '';
};
const $b332f5d2fa8005d6$export$d2b5179b7b1bfa0e = ({ contentId: contentId, disabled: disabled, shouldRenderPreview: shouldRenderPreview, isTitleFocused: isTitleFocused, collabEditError: collabEditError, collabLimitReached: collabLimitReached, heartbeatError: heartbeatError, saveDraftError: saveDraftError })=>{
    // Navigator.onLine: https://developer.mozilla.org/en-US/docs/Web/API/NavigatorOnLine/onLine
    // Document.visibilityState: https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilityState
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const onLine = navigator.onLine;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const visibilityState = document.visibilityState;
    const disabledReason = $b332f5d2fa8005d6$var$getDisabledReason({
        shouldRenderPreview: shouldRenderPreview,
        isTitleFocused: isTitleFocused,
        collabEditError: collabEditError,
        collabLimitReached: collabLimitReached,
        heartbeatError: heartbeatError,
        saveDraftError: saveDraftError
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const prevDisabled = (0, $30f609f1a737209e$export$5cae361ad82dce8b)(disabled);
    // Ref to keep track of enabled/disabled transition start/end and duration
    const enabledTransitionStart = (0, $cozmU.useRef)();
    const disabledTransitionStart = (0, $cozmU.useRef)();
    const disabledTransitionId = (0, $cozmU.useRef)();
    const sinceDisabled = ()=>{
        return !disabled && typeof disabledTransitionStart.current === 'number' ? performance.now() - disabledTransitionStart.current : undefined;
    };
    const sinceEnabled = ()=>{
        return disabled && typeof enabledTransitionStart.current === 'number' ? performance.now() - enabledTransitionStart.current : undefined;
    };
    const disabledChanged = typeof disabled === 'boolean' && typeof prevDisabled === 'boolean' && disabled !== prevDisabled;
    (0, $cozmU.useEffect)(()=>{
        if (disabledChanged) {
            // fire analytics event
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    actionSubject: 'editor',
                    action: disabled ? 'disabled' : 'enabled',
                    source: 'editorComponent',
                    attributes: {
                        contentId: contentId,
                        transitionId: disabledTransitionId.current,
                        visibilityState: visibilityState,
                        onLine: onLine,
                        disabledReason: disabledReason,
                        disabledDuration: sinceDisabled(),
                        enabledDuration: sinceEnabled()
                    }
                }
            }).fire();
            // transition from enabled -> disabled
            if (!prevDisabled && disabled) {
                disabledTransitionStart.current = performance.now();
                enabledTransitionStart.current = undefined;
            // transition from disabled -> enabled
            } else {
                disabledTransitionId.current = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
                enabledTransitionStart.current = performance.now();
                disabledTransitionStart.current = undefined;
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        disabledChanged,
        disabled
    ]);
};






var $KDAt0 = parcelRequire("KDAt0");





var $cwk3g = parcelRequire("cwk3g");


var $3iED4 = parcelRequire("3iED4");


var $fHjdT = parcelRequire("fHjdT");


var $ieeJu = parcelRequire("ieeJu");








var $202oG = parcelRequire("202oG");

const $6424f127b1220946$export$dd44f1f1b7b8d6af = (editorAPI, blockId)=>{
    if (!editorAPI?.core?.actions?.execute) return;
    // Catch the following potential errors when trying to set selection on the synced block:
    // tr.doc.resolve(...) - Can throw throw a RangeError
    // tr.setSelection(...) - Can throw
    try {
        editorAPI.core.actions.execute(({ tr: tr })=>{
            const doc = tr.doc;
            // Find first top-level node matching the block ID and of type 'bodiedSyncBlock'.
            let syncedBlockPos = -1;
            doc.descendants((node, pos, parent)=>{
                if (syncedBlockPos < 0 && // already found the block or not a top-level node, skip further checks
                parent?.type.name === 'doc' && node.attrs?.localId === blockId && node.type?.name === 'bodiedSyncBlock') syncedBlockPos = pos;
                // Don't descend into this node's children
                // as synced blocks cannot be nested and we only want the first match at the top level.
                return false;
            });
            if (syncedBlockPos >= 0) {
                const safePos = Math.max(0, Math.min(syncedBlockPos + 1, tr.doc.content.size));
                // Set selection to the first position inside the synced block node.
                const $pos = tr.doc.resolve(safePos);
                editorAPI.core?.actions?.focus();
                tr.setSelection((0, $kCECX.Selection).near($pos));
                return tr;
            }
            return null;
        });
    } catch  {
    // Silently fail if selection cannot be set
    }
};
/**
 * Scrolls the heading element into view within the editor's scroll container.
 * Calculates the scroll position relative to the container and smoothly scrolls to it.
 */ const $6424f127b1220946$var$scrollHeadingIntoView = (headingElement)=>{
    // This function is only called in browser-execution contexts (directly from useEffect or via async callbacks initiated from useEffect), so document is guaranteed to exist.
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const scrollContainer = document.getElementsByClassName('fabric-editor-popup-scroll-parent')?.[0];
    const headingTop = headingElement.getBoundingClientRect()?.top;
    const scrollContainerTop = scrollContainer?.getBoundingClientRect()?.top;
    const offset = scrollContainer?.scrollTop;
    if (headingTop === undefined || scrollContainerTop === undefined || offset === undefined) return;
    // Subtract the scroll container position from the heading position to get the scroll distance
    // and add the offset to account for current scroll position.
    const scrollToY = headingTop - scrollContainerTop + offset;
    scrollContainer?.scrollTo({
        left: 0,
        top: scrollToY,
        behavior: 'smooth'
    });
};
const $6424f127b1220946$export$3873199fd2fe1b43 = (hasProseMirrorRendered, blockLinkHashPrefix = (0, $cwk3g.DEFAULT_BLOCK_LINK_HASH_PREFIX), editorAPI)=>{
    const { hash: hash } = (0, $KDAt0.useLocation)();
    (0, $cozmU.useEffect)(()=>{
        if (!hasProseMirrorRendered || !hash) return;
        // Store cleanup function to cancel pending operations on unmount or hash change.
        let cancelExpandAndScroll = null;
        let selectionTimeoutId = null;
        // Handle block links when block menu feature is enabled.
        if ((0, $ieeJu.expValEquals)('platform_editor_block_menu', 'isEnabled', true)) {
            const blockId = (0, $cwk3g.extractBlockIdFromLinkHash)(hash, blockLinkHashPrefix);
            if (blockId) {
                const element = (0, $fHjdT.getLocalIdSelector)(blockId, document.body);
                if (element) {
                    // Handle block links with expand support.
                    // Capture cleanup function to cancel pending timeouts on unmount/hash change.
                    if ((0, $9wGTI.fg)('platform_editor_block_menu_v2_patch_4')) cancelExpandAndScroll = (0, $3iED4.expandAllParentsThenScroll)(element, 0, (el)=>{
                        el.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });
                    });
                    else cancelExpandAndScroll = (0, $3iED4.expandAllParentsThenScroll)(element);
                    // Set selection on synced block if editor API is available
                    // Small delay to ensure scroll/expand completes before setting selection
                    if ((0, $ieeJu.expValEquals)('platform_synced_block', 'isEnabled', true)) selectionTimeoutId = setTimeout(()=>{
                        $6424f127b1220946$export$dd44f1f1b7b8d6af(editorAPI, blockId);
                    }, 100); // Delay to ensure scroll completes
                }
                // Return cleanup function to cancel pending operations.
                return ()=>{
                    if (cancelExpandAndScroll) cancelExpandAndScroll();
                    if (selectionTimeoutId) clearTimeout(selectionTimeoutId);
                };
            }
        }
        // Handle regular anchor links and heading links.
        const id = hash.slice(1);
        const anchorElement = document.getElementById(id);
        // Indicates anchor.
        if (anchorElement) anchorElement.scrollIntoView();
        const headingIdToElement = (0, $202oG.getHeadingIdsToElements)();
        const headingElement = headingIdToElement.get(id);
        // When the heading is inside a collapsed expand, expand parent elements first then scroll.
        if (headingElement instanceof HTMLElement && (0, $6mKj3.expVal)('platform_editor_fix_copy_link_heading_in_expand', 'isEnabled', false)) {
            cancelExpandAndScroll = (0, $3iED4.expandAllParentsThenScroll)(headingElement, 0, (el)=>{
                $6424f127b1220946$var$scrollHeadingIntoView(el);
            });
            return ()=>{
                if (cancelExpandAndScroll) cancelExpandAndScroll();
            };
        }
        if (headingElement) $6424f127b1220946$var$scrollHeadingIntoView(headingElement);
    }, [
        hash,
        blockLinkHashPrefix,
        hasProseMirrorRendered,
        editorAPI
    ]);
};











function $6941dd20a463270a$export$7d308a2b14d43346({ isActive: isActive, isTypeAheadOpen: isTypeAheadOpen, isRovoLLMEnabled: isRovoLLMEnabled, onSpaceKeyPressed: onSpaceKeyPressed, isLivePage: isLivePage, editorAPI: editorAPI }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const onSpaceKeyPressedRef = (0, $cozmU.useRef)(onSpaceKeyPressed);
    onSpaceKeyPressedRef.current = onSpaceKeyPressed;
    // Store editorAPI in a ref so the listener always reads the latest
    // reference without having to be torn down and re-registered every time
    // the editorAPI identity changes.
    const editorAPIRef = (0, $cozmU.useRef)(editorAPI);
    editorAPIRef.current = editorAPI;
    (0, $cozmU.useEffect)(()=>{
        if (!isActive || isTypeAheadOpen || !isRovoLLMEnabled || !(0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant1') && !(0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant2')) return;
        const handleSpaceKeyCapture = (e)=>{
            // Only intercept the bare space key (no modifiers)
            if (e.key !== ' ' || e.metaKey || e.ctrlKey || e.altKey || e.shiftKey) return;
            const target = e.target;
            if (!target?.closest?.('.ProseMirror')) return;
            // When we have access to the editor's focus shared state, only
            // intercept if the FullPageEditor itself currently has focus. This
            // prevents the override from firing for other ProseMirror editors
            // on the page (e.g. the Rovo chat sidebar input) which also match
            // the `.ProseMirror` selector above.
            const currentEditorAPI = editorAPIRef.current;
            const focusSharedState = currentEditorAPI?.focus?.sharedState?.currentState?.();
            if (currentEditorAPI && !focusSharedState?.hasFocus) return;
            // Prevent ProseMirror from handling the space key (which would open inline Rovo)
            e.preventDefault();
            e.stopPropagation();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: 'BlankObjectExperienceButtons',
                    action: 'used',
                    actionSubject: 'shortcut',
                    actionSubjectId: 'createWithRovoBlankObject',
                    attributes: {
                        variant: (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant1') ? 'variant1' : 'variant2',
                        contentType: isLivePage ? 'liveDoc' : 'page',
                        buttonType: 'cwr'
                    }
                }
            }).fire();
            // Delegate to the caller. In variant1 this shows the CWR experience;
            // in variant2 it focuses the already-rendered CreateWithRovoExperience input.
            onSpaceKeyPressedRef.current();
        };
        // Use capture phase to intercept before ProseMirror's keymap handler
        document.addEventListener('keydown', handleSpaceKeyCapture, true);
        return ()=>{
            document.removeEventListener('keydown', handleSpaceKeyCapture, true);
        };
    }, [
        isActive,
        isTypeAheadOpen,
        isRovoLLMEnabled,
        createAnalyticsEvent,
        isLivePage
    ]);
}



var $iwNka = parcelRequire("iwNka");


var $7oCdN = parcelRequire("7oCdN");





var $4L9ve = parcelRequire("4L9ve");














var $cZa7r = parcelRequire("cZa7r");








var $02cx8 = parcelRequire("02cx8");







const $7a7bf08f4d7f088e$export$c06e63272903d81b = (fullPageEditorPresetAPI)=>{
    const agentMentionId = (0, $4Qu9h.useSharedPluginStateSelector)(fullPageEditorPresetAPI, 'mention.lastInsertedAgentMentionId') ?? null;
    const agentMentionContext = (0, $4Qu9h.useSharedPluginStateSelector)(fullPageEditorPresetAPI, 'mention.lastInsertedAgentMentionContext') ?? null;
    const agentMentionPrompt = (0, $4Qu9h.useSharedPluginStateSelector)(fullPageEditorPresetAPI, 'mention.lastInsertedAgentMentionPrompt') ?? null;
    const agentMentionName = (0, $4Qu9h.useSharedPluginStateSelector)(fullPageEditorPresetAPI, 'mention.lastInsertedAgentMentionName') ?? null;
    const agentMentionParentNodeType = (0, $4Qu9h.useSharedPluginStateSelector)(fullPageEditorPresetAPI, 'mention.lastInsertedAgentMentionParentNodeType') ?? null;
    const agentMentionInsertionCount = (0, $4Qu9h.useSharedPluginStateSelector)(fullPageEditorPresetAPI, 'mention.lastAgentMentionInsertionCount') ?? 0;
    const { setAgentMentionState: setAgentMentionState, setResolvedAgentMentionId: setResolvedAgentMentionId } = (0, $02cx8.useEditorRovoButtonActions)();
    // expValEquals is intentionally inlined (not stored in a variable) to satisfy the
    // confluence-feature-gating/inline-usage lint rule, and intentionally omitted from
    // the dep array (static gate value — not reactive) to satisfy exhaustive-deps.
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $6mKj3.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true)) return;
        setAgentMentionState({
            agentMentionId: agentMentionId,
            agentMentionInsertionCount: agentMentionInsertionCount,
            agentMentionContext: agentMentionContext,
            agentMentionPrompt: agentMentionPrompt,
            agentMentionName: agentMentionName,
            agentMentionParentNodeType: agentMentionParentNodeType
        });
    }, [
        agentMentionId,
        agentMentionInsertionCount,
        agentMentionContext,
        agentMentionPrompt,
        agentMentionName,
        agentMentionParentNodeType,
        setAgentMentionState
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $6mKj3.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true)) return;
        if (!agentMentionId) {
            setResolvedAgentMentionId(null);
            return;
        }
        // Resolve the AAID (from ADF mention node) to the Rovo Agent Studio UUID.
        // The ADF mention node's `id` is the Atlassian Account ID, but Rovo chat's
        // `agentId` expects the Agent Studio UUID. We resolve via the assistance API.
        let isCancelled = false;
        const controller = new AbortController();
        fetch(`/gateway/api/assist/rovo/v1/agents/accountid/${encodeURIComponent(agentMentionId)}`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'x-product': 'confluence',
                'x-experience-id': 'ai-mate'
            },
            signal: controller.signal
        }).then((res)=>{
            if (!res.ok) throw new Error(res.statusText);
            return res.json();
        }).then((agent)=>{
            // Guard against a stale .then() microtask resolving after the effect cleaned up.
            if (!isCancelled) setResolvedAgentMentionId(agent?.id ?? null);
        }).catch((err)=>{
            // Ignore AbortError — thrown when the controller aborts on cleanup/unmount.
            if (err instanceof Error && err.name === 'AbortError') return;
            (0, $7W8i8.getLogger)('useAgentMentionBridge').error`Failed to resolve agent UUID: ${err}`;
            if (!isCancelled) setResolvedAgentMentionId(null);
        });
        return ()=>{
            isCancelled = true;
            controller.abort();
        };
    }, [
        agentMentionId,
        agentMentionInsertionCount,
        // agentMentionContext, agentMentionName and agentMentionParentNodeType intentionally omitted —
        // UUID resolution only needs to follow mention identity changes.
        // expValEquals('platform_editor_agent_mentions'...) intentionally omitted — static
        // gate value, not reactive. Inlined in the guard above per lint rules.
        setResolvedAgentMentionId
    ]);
};






var $cbY7C = parcelRequire("cbY7C");




const $7aceeeaf0148bdde$export$166cbf4b2438db83 = (isLivePage)=>{
    (0, $cozmU.useEffect)(()=>{
        if (isLivePage || (0, $6mKj3.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)) {
            const mainContent = document.getElementById('AkMainContent');
            // If the main content area is not found, or it already has a tabIndex set,
            // don't mess with tabIndex at all.
            if (!mainContent || mainContent.hasAttribute('tabIndex')) return;
            // Two-stage hydration previously masked a React execution order bug by causing this to be rendered and fired
            //  before the title component was mounted. With two-stage hydration removed, we now need to ensure that
            //  we correctly handle focus. React will fire the title component's useEffect before this one as it is on
            //  a child component of the editor. Therefore, we check here if the title is focused already, and if so,
            //  we do not steal focus away.
            if (document.activeElement?.getAttribute?.('name') === 'livepages-title') return;
            mainContent.setAttribute('tabIndex', '-1');
            const unbind = (0, $cbY7C.bind)(mainContent, {
                type: 'blur',
                listener: ()=>{
                    mainContent.removeAttribute('tabIndex');
                    unbind();
                }
            });
            mainContent.focus();
            return unbind;
        }
    }, [
        isLivePage
    ]);
};


/**
 * @generated SignedSource<<6a393b9dd9899728657f6bae60d46d9b>>
 * @relayHash 19a2aaea42b714d4f81bf3d604f72d4e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 491bc15e31302bd420a899fe66c2ab1547ea1c7385af20eb6ee9b1e853966382
const $e0f5427e497a408c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        },
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "pageId"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "resolved"
                    }
                ]
            }
        ],
        "type": "InlineComment"
    }, v7 = {
        "kind": "ScalarField",
        "name": "parentId"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useFocusedCommentInlineCommentMarkerRefQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                },
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useFocusedCommentInlineCommentMarkerRefQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                },
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "19a2aaea42b714d4f81bf3d604f72d4e",
            "id": "491bc15e31302bd420a899fe66c2ab1547ea1c7385af20eb6ee9b1e853966382",
            "metadata": {},
            "name": "useFocusedCommentInlineCommentMarkerRefQuery",
            "operationKind": "query",
            "text": "query useFocusedCommentInlineCommentMarkerRefQuery($commentId:ID!,$pageId:ID!,$contentStatus:[GraphQLContentStatus]){comments(commentId:$commentId,pageId:$pageId,contentStatus:$contentStatus){nodes{id,location{__typename,type,...on InlineComment{inlineMarkerRef,inlineResolveProperties{resolved}}},parentId}}}"
        }
    };
}();
$e0f5427e497a408c$var$node.hash = "25e1e3d1246a3773d89cc2d9ec5e9520";
var $e0f5427e497a408c$export$2e2bcd8739ae039 = $e0f5427e497a408c$var$node;









var $9FoVw = parcelRequire("9FoVw");














var $lb2Lp = parcelRequire("lb2Lp");

const $39cea118bb4c75f1$var$useFocusedCommentInlineCommentMarkerRefQuery = (0, $e0f5427e497a408c$export$2e2bcd8739ae039);
const $39cea118bb4c75f1$var$focusedCommentContentStatus = [
    'DRAFT',
    'CURRENT'
];
function $39cea118bb4c75f1$export$1a19d181d558cc48({ commentId: commentId, contentId: contentId, annotationState: annotationState, handleGqlError: handleGqlError }) {
    // New comments data manager hook - only used when experiment is enabled
    const newCommentsDataResult = (0, $lb2Lp.useCommentById)({
        commentId: commentId || '',
        contentId: contentId,
        options: {
            skip: !commentId || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false),
            onError: handleGqlError
        }
    });
    // Legacy query - only used when experiment is disabled
    const { data: legacyData } = (0, $jMyy4.useQueryInterop)($39cea118bb4c75f1$var$useFocusedCommentInlineCommentMarkerRefQuery, {
        variables: {
            commentId: commentId || '',
            pageId: contentId,
            contentStatus: $39cea118bb4c75f1$var$focusedCommentContentStatus
        },
        skip: !commentId || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false),
        onError: handleGqlError,
        fetchPolicy: 'cache-first',
        __callerPackage__: "full-page-editor"
    });
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setCommentContainerToFocus: setCommentContainerToFocus } = (0, $3mVfX.useCommentsPanelActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const hasOpenedFocusedComment = (0, $cozmU.useRef)(false);
    // Reset hasOpenedFocusedComment when commentId changes
    (0, $cozmU.useEffect)(()=>{
        if (hasOpenedFocusedComment.current) hasOpenedFocusedComment.current = false;
    }, [
        commentId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (hasOpenedFocusedComment.current) return;
        // Pull from comments_data_manager when experiment is enabled
        const focusedComment = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? newCommentsDataResult.comment ?? null : legacyData?.comments?.nodes?.[0] ?? null;
        if (commentId && focusedComment) {
            const markerRef = focusedComment.location.inlineMarkerRef ?? '';
            const isResolved = Boolean(focusedComment.location.inlineResolveProperties?.resolved);
            if (isResolved) {
                showCommentsPanel({
                    openWithView: (0, $3mVfX.ViewValues).RESOLVED
                });
                if (markerRef) {
                    setCurrentlySelectedThreadKey(markerRef);
                    setCommentContainerToFocus(commentId); // we'll be using this to scroll to it using data-comment-id
                    hasOpenedFocusedComment.current = true;
                }
            } else if (// dangling comment
            markerRef && annotationState?.annotationsLoaded && // On live docs annotationsLoaded can flip to true before the collab
            // provider has synced the document, so `annotations` is briefly {}
            // and a valid markerRef gets misclassified as dangling. Requiring
            // at least one annotation closes that race; truly dangling cases
            // always have other annotations present in the document. Gated for
            // safe rollout — gate OFF preserves the prior (buggy) behavior.
            // See bug 19 in https://hello.atlassian.net/wiki/spaces/SCE/pages/7070032438
            (!(0, $9wGTI.fg)('confluence_focused_comment_empty_annotation_check') || Object.keys(annotationState.annotations).length > 0) && !(markerRef in annotationState.annotations) && (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux')) {
                setCurrentlySelectedThreadKey(markerRef);
                setCommentContainerToFocus(commentId); // we'll be using this to scroll to it using data-comment-id
                showCommentsPanel({
                    openWithView: (0, $3mVfX.ViewValues).DELETED_CONTENT
                });
                hasOpenedFocusedComment.current = true; // to prevent focused comment from being opened again. We may need a better way to handle this
            } else {
                const commentElement = document.getElementById(markerRef);
                if (commentElement && markerRef !== '') {
                    // Use unified navigation for deep linking
                    const success = (0, $9FoVw.handleDeepLinkNavigation)({
                        scrollBehavior: (0, $9FoVw.ScrollBehavior).INSTANT,
                        context: (0, $9FoVw.NavigationContext).EDITOR,
                        block: 'center',
                        inline: 'nearest',
                        markElement: commentElement,
                        commentId: commentId
                    });
                    if (success) hasOpenedFocusedComment.current = true;
                }
            }
        }
        return ()=>{
            hasOpenedFocusedComment.current = false;
        };
    }, [
        commentId,
        newCommentsDataResult.comment,
        annotationState?.annotations,
        annotationState?.annotationsLoaded,
        showCommentsPanel,
        setCurrentlySelectedThreadKey,
        setCommentContainerToFocus,
        legacyData
    ]);
}





const $e5418cfc53a98775$export$c0a34c12e787105e = ({ collabEditInternetLost: collabEditInternetLost, internetDisconnected: internetDisconnected, editorFullPagePresetAPI: editorFullPagePresetAPI })=>{
    (0, $cozmU.useEffect)(()=>{
        if (internetDisconnected) // Internet is actually disconnected (network issue)
        editorFullPagePresetAPI?.core.actions.execute(editorFullPagePresetAPI?.connectivity?.commands.setMode('internet-offline'));
        else if (collabEditInternetLost) // Collaboration connection lost but internet might be available
        editorFullPagePresetAPI?.core.actions.execute(editorFullPagePresetAPI?.connectivity?.commands.setMode('collab-offline'));
        else // Both are false, we're online
        editorFullPagePresetAPI?.core.actions.execute(editorFullPagePresetAPI?.connectivity?.commands.setMode('online'));
    }, [
        collabEditInternetLost,
        internetDisconnected,
        editorFullPagePresetAPI
    ]);
};












var $ikPi2 = parcelRequire("ikPi2");




const $57b1365ec21ea4d6$export$12026d53c57123e6 = (editorPresetAPI)=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [{ collabEditInitialized: collabEditInitialized }] = (0, $hYoU4.useNativeCollabState)();
    // FIXME: https://product-fabric.atlassian.net/browse/ED-25722
    const [loomInsertUrlState, loomInsertUrlActions] = (0, $ikPi2.useLoomInsertUrlState)();
    (0, $cozmU.useEffect)(()=>{
        try {
            /**
			 * Insert Loom video at the top of the editor.
			 * Ensure the collab service plugin and editorPresetAPI have been initialized
			 * and the Loom video is present, to prevent premature Loom video insertion.
			 * After insertion, delete the Loom video to ensure no more insertions occur.
			 */ if (collabEditInitialized && editorPresetAPI && loomInsertUrlState.fullPageEditorLoomUrl) {
                editorPresetAPI?.loom?.actions.insertLoom({
                    sharedUrl: loomInsertUrlState.fullPageEditorLoomUrl.sharedUrl,
                    title: loomInsertUrlState.fullPageEditorLoomUrl.title || ''
                }, 'start');
                loomInsertUrlActions.updateFullPageEditorLoomUrl(undefined);
                experienceTracker.succeed({
                    name: (0, $irVI7.LOOM_PAGE_HEADER_CONTENT_INSERTION),
                    attributes: {
                        inserted: true
                    }
                });
            }
        } catch (error) {
            loomInsertUrlActions.updateFullPageEditorLoomUrl(undefined);
            experienceTracker.fail({
                name: (0, $irVI7.LOOM_PAGE_HEADER_CONTENT_INSERTION),
                error: error
            });
        }
    }, [
        collabEditInitialized,
        editorPresetAPI,
        experienceTracker,
        loomInsertUrlActions,
        loomInsertUrlState.fullPageEditorLoomUrl
    ]);
};


























// Persisted per-contentId so the mini-modal auto-opens at most once per page and stays dismissed
// if the user closes it (see the localStorage usage in `useOpenRovoOnEditPageReady` below).
// Key shape: `${contentId}:rovo-auto-opened-new-page` — the dynamic contentId is the PREFIX and the
// static name is the literal TAIL. This ordering matters when `confluence_browser_storage_controls`
// is enabled: the browser-storage-controls consent layer matches keys via an ENDS_WITH registration
// on the static suffix. If a dynamic value (the contentId) were the tail instead, no static
// ENDS_WITH registration could match it, so the write would be BLOCKED and the flag never persists.
const $12f1960214886fe9$var$ROVO_AUTO_OPENED_KEY_SUFFIX = ':rovo-auto-opened-new-page';
const $12f1960214886fe9$var$getRovoAutoOpenedKey = (contentId)=>`${contentId}${$12f1960214886fe9$var$ROVO_AUTO_OPENED_KEY_SUFFIX}`;
const $12f1960214886fe9$var$normalizeDraftShareId = (draftShareId)=>typeof draftShareId === 'string' ? draftShareId : undefined;
const $12f1960214886fe9$var$AUTO_OPEN_DELAY_MS = 500;
// 14 days, in seconds — after this window the Rovo mini-modal may auto-open again.
const $12f1960214886fe9$var$ROVO_AUTO_OPENED_TTL_SECONDS = 1209600; // 1209600
const $12f1960214886fe9$export$1127938f4b2e0531 = ({ contentId: contentId, draftShareId: draftShareId, isEnabled: isEnabled, isEmptyLivePage: isEmptyLivePage })=>isEnabled && (!!draftShareId || isEmptyLivePage) && !(0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean($12f1960214886fe9$var$getRovoAutoOpenedKey(contentId));
const $12f1960214886fe9$var$isAutoOpenTriggerReady = ({ draftShareId: draftShareId, isEditPageReady: isEditPageReady, isEmptyLivePage: isEmptyLivePage, shouldObserveLiveEmptyPage: shouldObserveLiveEmptyPage, isLivePageReady: isLivePageReady })=>!!draftShareId && isEditPageReady || shouldObserveLiveEmptyPage && isEmptyLivePage && isLivePageReady === true;
const $12f1960214886fe9$export$2fa5069da57097b = ({ contentId: contentId, isEnabled: isEnabled, isEmptyLivePage: isEmptyLivePage, shouldObserveLiveEmptyPage: shouldObserveLiveEmptyPage, isLivePageReady: isLivePageReady })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { openConversationAssistant: openConversationAssistant } = (0, $1AJi3.useToggleConversationAssistant)();
    const { setWasAutoOpened: setWasAutoOpened, mode: mode } = (0, $93Gae.useRovoExperienceAPIStore)();
    // Capture at mount whether this is a newly-created page (draftShareId in URL).
    // Using a ref ensures this trigger is immune to URL/state changes after initial mount.
    const { draftShareId: draftShareId } = getQueryParams();
    const draftShareIdRef = (0, $cozmU.useRef)($12f1960214886fe9$var$normalizeDraftShareId(draftShareId));
    const isEmptyLivePageRef = (0, $cozmU.useRef)(isEmptyLivePage);
    const isLivePageReadyRef = (0, $cozmU.useRef)(isLivePageReady);
    const isEditPageReadyRef = (0, $cozmU.useRef)(false);
    // Read the current mode via a ref inside the delayed timeout to avoid a stale closure and to
    // keep `mode` out of tryOpenRovo's deps (which would re-create the callback on every mode change).
    const modeRef = (0, $cozmU.useRef)(mode);
    // Guard: only open once, even across re-renders.
    const hasOpenedRef = (0, $cozmU.useRef)(false);
    // One-shot buffer timer for the delayed auto-open; armed once by the first eligible trigger and
    // cleared only when it fires or on unmount.
    const openTimerRef = (0, $cozmU.useRef)(undefined);
    const tryOpenRovo = (0, $cozmU.useCallback)(()=>{
        if (hasOpenedRef.current || !$12f1960214886fe9$var$isAutoOpenTriggerReady({
            draftShareId: draftShareIdRef.current,
            isEditPageReady: isEditPageReadyRef.current,
            isEmptyLivePage: isEmptyLivePageRef.current,
            shouldObserveLiveEmptyPage: shouldObserveLiveEmptyPage,
            isLivePageReady: isLivePageReadyRef.current
        }) || !$12f1960214886fe9$export$1127938f4b2e0531({
            contentId: contentId,
            draftShareId: draftShareIdRef.current,
            isEnabled: isEnabled,
            isEmptyLivePage: isEmptyLivePageRef.current
        })) return;
        // One-shot buffer: the first eligible trigger arms a one-time timer so the mini-modal surface has
        // time to mount/register before we open it (avoids a mount-order race). While a timer is already
        // pending, subsequent triggers are no-ops — we never clear or reschedule, so rapid repeated
        // triggers cannot starve the open. The one-shot is consumed only when the timer actually fires.
        if (openTimerRef.current !== undefined) return;
        openTimerRef.current = setTimeout(()=>{
            openTimerRef.current = undefined;
            hasOpenedRef.current = true;
            // Persist that we've auto-opened for this content so we don't re-open if the user dismisses
            // and navigates back to the same draft/live doc. Remembered for 14 days (see
            // ROVO_AUTO_OPENED_TTL_SECONDS); after that the mini-modal may auto-open again.
            (0, $17wUi.confluenceLocalStorageInstance).setItem($12f1960214886fe9$var$getRovoAutoOpenedKey(contentId), true, $12f1960214886fe9$var$ROVO_AUTO_OPENED_TTL_SECONDS);
            // Guard: modal already open — skip setWasAutoOpened/open here (the store's open path
            // would no-op and could leave a stale wasAutoOpened). NOTE: the localStorage auto-open
            // key is already written unconditionally above, so revisits won't re-trigger regardless.
            if (modeRef.current === (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL) return;
            // Mark this open as programmatic so the mini-modal suppresses the chat input's initial focus.
            setWasAutoOpened?.(true);
            openConversationAssistant('mini-modal');
        }, $12f1960214886fe9$var$AUTO_OPEN_DELAY_MS);
    }, [
        contentId,
        isEnabled,
        openConversationAssistant,
        setWasAutoOpened,
        shouldObserveLiveEmptyPage
    ]);
    (0, $cozmU.useEffect)(()=>{
        isEmptyLivePageRef.current = isEmptyLivePage;
        tryOpenRovo();
    }, [
        isEmptyLivePage,
        tryOpenRovo
    ]);
    (0, $cozmU.useEffect)(()=>{
        isLivePageReadyRef.current = isLivePageReady;
        tryOpenRovo();
    }, [
        isLivePageReady,
        tryOpenRovo
    ]);
    // Keep the mode ref in sync so the delayed timeout reads the latest value without re-creating
    // tryOpenRovo on every mode change.
    (0, $cozmU.useEffect)(()=>{
        modeRef.current = mode;
    }, [
        mode
    ]);
    (0, $cozmU.useEffect)(()=>{
        const shouldSubscribe = isEnabled && !!draftShareIdRef.current && !(0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean($12f1960214886fe9$var$getRovoAutoOpenedKey(contentId));
        if (!shouldSubscribe) return;
        // Draft/new pages open after edit-page/load succeeds; live docs use collab readiness instead.
        return experienceTracker.subscribe((event)=>{
            if (event.name === (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE) && event.action === 'taskSuccess') {
                isEditPageReadyRef.current = true;
                tryOpenRovo();
            }
        });
    }, [
        experienceTracker,
        contentId,
        isEnabled,
        tryOpenRovo
    ]);
    (0, $cozmU.useEffect)(()=>()=>{
            if (openTimerRef.current !== undefined) clearTimeout(openTimerRef.current);
        }, []);
};









var $ixfCV = parcelRequire("ixfCV");


var $hOQ2V = parcelRequire("hOQ2V");


var $lJgYU = parcelRequire("lJgYU");

const $1b7cd68724bb368d$var$AI_PLANNER_EMBEDDED_CONFLUENCE_SOURCE = 'ai-planner';
const $1b7cd68724bb368d$var$PARENT_PRODUCT_MODULE_NAME = 'parentProduct';
const $1b7cd68724bb368d$export$16b8a2e6c07454ad = 20000;
const $1b7cd68724bb368d$var$isRecord = (payload)=>typeof payload === 'object' && payload !== null && !Array.isArray(payload);
const $1b7cd68724bb368d$var$isSupportedEventType = (eventType)=>eventType === 'embedded-confluence.text-selection.changed' || eventType === 'embedded-confluence.text-selection.cleared';
const $1b7cd68724bb368d$var$readRequiredString = (payload, key)=>{
    const value = payload[key];
    return typeof value === 'string' && value.trim() ? value : null;
};
const $1b7cd68724bb368d$var$readOptionalString = (payload, key)=>{
    const value = payload[key];
    if (value === undefined) return undefined;
    if (typeof value !== 'string') return 'invalid';
    const trimmed = value.trim();
    return trimmed ? trimmed : undefined;
};
const $1b7cd68724bb368d$var$readOptionalStringArray = (payload)=>{
    const value = payload.selectionLocalIds;
    if (value === undefined) return undefined;
    if (!Array.isArray(value) || value.some((localId)=>typeof localId !== 'string')) return 'invalid';
    return value.filter((localId)=>localId.trim());
};
const $1b7cd68724bb368d$var$readOptionalContentType = (payload)=>{
    const value = payload.contentType;
    if (value === undefined) return undefined;
    if (value === 'page' || value === 'blogpost' || value === 'whiteboard') return value;
    return 'invalid';
};
const $1b7cd68724bb368d$export$9dcd030536ffc7e3 = (payload)=>{
    if (!$1b7cd68724bb368d$var$isRecord(payload)) return {
        status: 'invalid'
    };
    if (!$1b7cd68724bb368d$var$isSupportedEventType(payload.eventType)) return {
        status: 'invalid'
    };
    const contentId = $1b7cd68724bb368d$var$readRequiredString(payload, 'contentId');
    if (!contentId) return {
        status: 'invalid'
    };
    if (payload.eventType === 'embedded-confluence.text-selection.cleared') return {
        payload: {
            eventType: 'embedded-confluence.text-selection.cleared',
            contentId: contentId
        },
        status: 'valid'
    };
    const selectedText = $1b7cd68724bb368d$var$readRequiredString(payload, 'selectedText');
    if (!selectedText) return {
        status: 'invalid'
    };
    const selectionLocalIds = $1b7cd68724bb368d$var$readOptionalStringArray(payload);
    if (selectionLocalIds === 'invalid') return {
        status: 'invalid'
    };
    const sourceTitle = $1b7cd68724bb368d$var$readOptionalString(payload, 'sourceTitle');
    if (sourceTitle === 'invalid') return {
        status: 'invalid'
    };
    const sourceUrl = $1b7cd68724bb368d$var$readOptionalString(payload, 'sourceUrl');
    if (sourceUrl === 'invalid') return {
        status: 'invalid'
    };
    const contentType = $1b7cd68724bb368d$var$readOptionalContentType(payload);
    if (contentType === 'invalid') return {
        status: 'invalid'
    };
    return {
        payload: {
            eventType: 'embedded-confluence.text-selection.changed',
            contentId: contentId,
            selectedText: selectedText.slice(0, $1b7cd68724bb368d$export$16b8a2e6c07454ad),
            ...selectionLocalIds?.length ? {
                selectionLocalIds: selectionLocalIds
            } : {},
            ...sourceTitle ? {
                sourceTitle: sourceTitle
            } : {},
            ...sourceUrl ? {
                sourceUrl: sourceUrl
            } : {},
            ...contentType ? {
                contentType: contentType
            } : {}
        },
        status: 'valid'
    };
};
const $1b7cd68724bb368d$var$getEmbeddedConfluenceSource = ()=>{
    try {
        return new URL(window.location.href).searchParams.get('embeddedConfluenceSource') ?? undefined;
    } catch  {
        return undefined;
    }
};
const $1b7cd68724bb368d$export$aa228adcf031c9f5 = async (payload)=>{
    const gateEnabled = (0, $ixfCV.fg)('embedded_confluence_parent_product_sender');
    if (!gateEnabled) return false;
    const isEmbeddedInIframe = (0, $hOQ2V.isEmbeddedConfluenceInIframe_DO_NOT_USE)();
    if (!isEmbeddedInIframe) return false;
    const embeddedConfluenceSource = $1b7cd68724bb368d$var$getEmbeddedConfluenceSource();
    if (embeddedConfluenceSource !== $1b7cd68724bb368d$var$AI_PLANNER_EMBEDDED_CONFLUENCE_SOURCE) return false;
    const parseResult = $1b7cd68724bb368d$export$9dcd030536ffc7e3(payload);
    if (parseResult.status !== 'valid') return false;
    const module = (0, $lJgYU.requireModule)($1b7cd68724bb368d$var$PARENT_PRODUCT_MODULE_NAME);
    if (!module?.sendToParentProduct) return false;
    try {
        await module.sendToParentProduct(parseResult.payload);
        return true;
    } catch  {
        return false;
    }
};





const $75b881d479cc3f18$var$DEFAULT_SELECTION_SEND_DEBOUNCE_MS = 150;
const $75b881d479cc3f18$var$SIGNATURE_HASH_MODULUS = 2147483647;
const $75b881d479cc3f18$var$getSourceUrl = ()=>{
    return typeof window !== 'undefined' ? window.location.href : undefined;
};
const $75b881d479cc3f18$var$createClearedPayload = (contentId)=>({
        eventType: 'embedded-confluence.text-selection.cleared',
        contentId: contentId
    });
const $75b881d479cc3f18$export$ac95945de39d5470 = ({ contentId: contentId, selectionMarkdown: selectionMarkdown, selectionLocalIds: selectionLocalIds, sourceTitle: sourceTitle })=>{
    const selectedText = selectionMarkdown?.trim().slice(0, (0, $1b7cd68724bb368d$export$16b8a2e6c07454ad));
    if (!selectedText) return $75b881d479cc3f18$var$createClearedPayload(contentId);
    const sourceUrl = $75b881d479cc3f18$var$getSourceUrl();
    const payload = {
        eventType: 'embedded-confluence.text-selection.changed',
        contentId: contentId,
        selectedText: selectedText,
        ...selectionLocalIds?.length ? {
            selectionLocalIds: selectionLocalIds
        } : {},
        ...sourceTitle ? {
            sourceTitle: sourceTitle
        } : {},
        ...sourceUrl ? {
            sourceUrl: sourceUrl
        } : {}
    };
    return payload;
};
const $75b881d479cc3f18$export$1cfb36fca65c3633 = ({ contentId: contentId, enabled: enabled, fullPageEditorPresetAPI: fullPageEditorPresetAPI, isEmbeddedConfluence: isEmbeddedConfluence, sourceTitle: sourceTitle, debounceMs: debounceMs = $75b881d479cc3f18$var$DEFAULT_SELECTION_SEND_DEBOUNCE_MS })=>{
    const timerRef = (0, $cozmU.useRef)(null);
    const pendingPayloadKeyRef = (0, $cozmU.useRef)(null);
    const lastSentPayloadKeyRef = (0, $cozmU.useRef)(null);
    const isBridgeEnabled = enabled && isEmbeddedConfluence && (0, $9wGTI.fg)('embedded_confluence_parent_product_sender');
    const clearPendingSend = (0, $cozmU.useCallback)(()=>{
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        pendingPayloadKeyRef.current = null;
    }, []);
    const createPayloadSignature = (0, $cozmU.useCallback)((payload)=>{
        if (payload.eventType === 'embedded-confluence.text-selection.cleared') return `${payload.eventType}:${payload.contentId}`;
        return [
            payload.eventType,
            payload.contentId,
            payload.contentType ?? '',
            $75b881d479cc3f18$var$createStringSignature(payload.selectedText),
            $75b881d479cc3f18$var$createStringSignature(payload.sourceTitle),
            $75b881d479cc3f18$var$createStringSignature(payload.sourceUrl),
            payload.selectionLocalIds?.join('\u001f') ?? ''
        ].join('\u001e');
    }, []);
    const scheduleSend = (0, $cozmU.useCallback)((payload)=>{
        const payloadKey = createPayloadSignature(payload);
        if (payloadKey === lastSentPayloadKeyRef.current || payloadKey === pendingPayloadKeyRef.current) return;
        clearPendingSend();
        pendingPayloadKeyRef.current = payloadKey;
        timerRef.current = setTimeout(()=>{
            timerRef.current = null;
            pendingPayloadKeyRef.current = null;
            (0, $1b7cd68724bb368d$export$aa228adcf031c9f5)(payload).then((wasSent)=>{
                if (wasSent) lastSentPayloadKeyRef.current = payloadKey;
            }).catch(()=>undefined);
        }, debounceMs);
    }, [
        clearPendingSend,
        createPayloadSignature,
        debounceMs
    ]);
    (0, $1KOhB.usePluginStateEffect)(fullPageEditorPresetAPI, [
        'aiExperience'
    ], ({ aiExperienceState: aiExperienceState })=>{
        const payload = $75b881d479cc3f18$export$ac95945de39d5470({
            contentId: contentId,
            selectionMarkdown: aiExperienceState?.selectionContext?.selectionMarkdown,
            selectionLocalIds: aiExperienceState?.selectionContext?.localIds,
            sourceTitle: sourceTitle
        });
        if (payload.eventType === 'embedded-confluence.text-selection.cleared' && lastSentPayloadKeyRef.current === null) {
            clearPendingSend();
            return;
        }
        scheduleSend(payload);
    }, {
        disabled: !isBridgeEnabled
    });
    (0, $cozmU.useEffect)(()=>{
        if (!isBridgeEnabled) {
            clearPendingSend();
            lastSentPayloadKeyRef.current = null;
            return;
        }
        return ()=>{
            clearPendingSend();
            if (lastSentPayloadKeyRef.current !== null) {
                const payload = $75b881d479cc3f18$var$createClearedPayload(contentId);
                (0, $1b7cd68724bb368d$export$aa228adcf031c9f5)(payload);
            }
            lastSentPayloadKeyRef.current = null;
        };
    }, [
        clearPendingSend,
        contentId,
        isBridgeEnabled
    ]);
};
const $75b881d479cc3f18$var$createStringSignature = (value)=>{
    if (!value) return '';
    let hash = 0;
    for(let index = 0; index < value.length; index += 1)hash = (hash * 31 + value.charCodeAt(index)) % $75b881d479cc3f18$var$SIGNATURE_HASH_MODULUS;
    return `${value.length}:${hash.toString(36)}`;
};


const $310b15d05f913bec$export$c2c72aeadce38f04 = ({ contentId: contentId, contentType: contentType, isEmbeddedConfluence: isEmbeddedConfluence, isLivePage: isLivePage, isUnpublishedDraft: isUnpublishedDraft, isEditorEmpty: isEditorEmpty, title: title, draftTitle: draftTitle, isAIEnabledForContent: isAIEnabledForContent, handleTitleChange: handleTitleChange, collabEditInitialized: collabEditInitialized, collabEditInternetLost: collabEditInternetLost, internetDisconnected: internetDisconnected, extractedCollabEditProvider: extractedCollabEditProvider, fullPageEditorPresetAPI: fullPageEditorPresetAPI, isDocumentActive: isDocumentActive, focusedCommentId: focusedCommentId, replyToCommentId: replyToCommentId, handleUseFocusedCommentGQLError: handleUseFocusedCommentGQLError, annotationStateRef: annotationStateRef, addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache, updateUnresolvedInlineCommentFn: updateUnresolvedInlineCommentFn, triggerAnalyticsEvent: triggerAnalyticsEvent, proseMirrorRenderedData: proseMirrorRenderedData, showBlankPageQuickActions: showBlankPageQuickActions, hasSubmittedCwrPrompt: hasSubmittedCwrPrompt, shouldShowCreateWithRovoExperience: shouldShowCreateWithRovoExperience, isRovoLLMEnabled: isRovoLLMEnabled, isMarkdownMode: isMarkdownMode, onSpaceKeyPressed: onSpaceKeyPressed, flags: flags, intl: intl, disabled: disabled, isTitleFocused: isTitleFocused, shouldRenderPreview: shouldRenderPreview, collabEditError: collabEditError, collabLimitReached: collabLimitReached, heartbeatError: heartbeatError, removeCommentQueryParams: removeCommentQueryParams, setEditorAnnotations: setEditorAnnotations, getSortedMarkerRefs: getSortedMarkerRefs, setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList, editorAnnotationsRef: editorAnnotationsRef })=>{
    // Get locally-scoped actions from their respective contexts/stores
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { resetInitialDataLoadedMap: resetInitialDataLoadedMap } = (0, $3mVfX.useCommentsPanelActions)();
    const { clearCommentsData: clearCommentsData } = (0, $8i27m.useCommentsDataActions)();
    const { clearProcessedData: clearProcessedData } = (0, $4L9ve.useProcessedCommentsDataActions)();
    const { clearMentionsFlags: clearMentionsFlags } = (0, $hdxAi.useMentionsNotificationsActions)();
    const { setActiveHighlight: setActiveHighlight } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { storedCommentData: storedCommentData } = (0, $cZa7r.useAnnotations)();
    const { setStoredCommentData: setStoredCommentData } = (0, $cZa7r.useAnnotationsDispatch)();
    // Side effect: Setup native embed client
    (0, $jARmo.usePageNativeEmbedClient)();
    // Side effect: Notify the embedding parent product about live-doc text selection context
    (0, $75b881d479cc3f18$export$1cfb36fca65c3633)({
        contentId: contentId,
        enabled: isLivePage,
        fullPageEditorPresetAPI: fullPageEditorPresetAPI,
        isEmbeddedConfluence: isEmbeddedConfluence,
        sourceTitle: title ?? draftTitle
    });
    // Side effect: Space key shortcut override for CWR
    // Cast preset API to EditorInjectionAPI — useSharedPluginStateSelector expects injection-shaped APIs.
    const isTypeAheadOpen = (0, $4Qu9h.useSharedPluginStateSelector)(fullPageEditorPresetAPI, 'typeAhead.isOpen') ?? false;
    const isInlineAIOpen = (0, $4Qu9h.useSharedPluginStateSelector)(fullPageEditorPresetAPI, 'aiExperience.aiDecorationExperiencePluginState.isRunning') ?? false;
    (0, $6941dd20a463270a$export$7d308a2b14d43346)({
        isActive: showBlankPageQuickActions && !hasSubmittedCwrPrompt && !shouldShowCreateWithRovoExperience && !isMarkdownMode && !isInlineAIOpen,
        isTypeAheadOpen: isTypeAheadOpen,
        isRovoLLMEnabled: isRovoLLMEnabled,
        onSpaceKeyPressed: onSpaceKeyPressed,
        isLivePage: isLivePage,
        editorAPI: fullPageEditorPresetAPI
    });
    // Side effect: Expose Google Meet screen share
    (0, $iwNka.useExposeGoogleMeetScreenShare)();
    // Side effect: Scroll on URL change
    (0, $6424f127b1220946$export$3873199fd2fe1b43)(proseMirrorRenderedData !== null, undefined, fullPageEditorPresetAPI);
    // Side effect: Print cover injector
    (0, $7oCdN.usePrintCoverInjector)((0, $6mKj3.expValEquals)('afm-enable-command-p-reroute', 'isEnabled', true), intl);
    // Side effect: Focused comment handling
    (0, $39cea118bb4c75f1$export$1a19d181d558cc48)({
        commentId: focusedCommentId || replyToCommentId,
        contentId: contentId,
        handleGqlError: handleUseFocusedCommentGQLError,
        annotationState: annotationStateRef.current
    });
    // Side effect: Inline comments PubSub
    (0, $9ovft.useEditorInlineCommentsPubSub)({
        contentId: contentId,
        contentType: contentType,
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        updateUnresolvedInlineComment: updateUnresolvedInlineCommentFn,
        isDocumentActive: isDocumentActive,
        storedCommentData: storedCommentData,
        setStoredCommentData: setStoredCommentData,
        addCommentInCache: addCommentInCache,
        deleteCommentInCache: deleteCommentInCache
    });
    // Side effect: Refresh AI suggestions when AGG publishes
    // `confluence_onSuggestedEditsUpdated` for the active document.
    const onSuggestedEditsUpdated = (0, $cozmU.useCallback)(()=>{
        fullPageEditorPresetAPI?.aiSuggestions?.actions.refreshSuggestions(false);
    }, [
        fullPageEditorPresetAPI
    ]);
    (0, $16c571a0db84530f$export$6a826f71c6c5469c)({
        contentId: contentId,
        contentType: contentType === 'blogpost' ? 'blogpost' : 'page',
        onSuggestedEditsUpdated: onSuggestedEditsUpdated,
        skip: !(isRovoLLMEnabled && (0, $6mKj3.expValEquals)('platform_editor_ai_content_suggested_edits', 'isEnabled', true))
    });
    // Side effect: Unread comments setup
    (0, $essql.useUnreadCommentsSetup)({
        pageId: contentId,
        pageContentTypeProps: {
            pageMode: 'edit'
        }
    });
    // Side effect: Collab edit connectivity sync
    (0, $e5418cfc53a98775$export$c0a34c12e787105e)({
        collabEditInternetLost: collabEditInternetLost,
        internetDisconnected: internetDisconnected,
        editorFullPagePresetAPI: fullPageEditorPresetAPI
    });
    // Side effect: Native collab connecting state
    (0, $455b0e3615badc4d$export$257c6c9e28c0ad4b)(extractedCollabEditProvider);
    // Side effect: Auto-open Rovo chat mini-modal for new content or empty live docs.
    // Draft/new pages wait for edit-page/load; live docs use collab readiness plus empty editor state.
    (0, $12f1960214886fe9$export$2fa5069da57097b)({
        contentId: contentId,
        isEnabled: (0, $6mKj3.expVal)('rovo_button_mau_maxxed_minimodal_default', 'isEnabled', false),
        isEmptyLivePage: isLivePage && isEditorEmpty,
        shouldObserveLiveEmptyPage: isLivePage,
        isLivePageReady: isLivePage && collabEditInitialized
    });
    // Side effect: Full page auto focus
    (0, $7aceeeaf0148bdde$export$166cbf4b2438db83)(isLivePage);
    // Side effect: AI replacing title
    (0, $hycHC.useEditorAIReplacingTitle)({
        enabled: isAIEnabledForContent,
        title: title || draftTitle || '',
        handleNewTitle: handleTitleChange,
        canFireUnifiedAIAnalyticsEvent: true
    });
    // Side effect: Send content age analytics
    (0, $6fc6623dec610eba$export$f46ffb959d708168)({
        contentId: contentId,
        collabService: 'ncs'
    });
    // Side effect: Disabled analytics
    (0, $b332f5d2fa8005d6$export$d2b5179b7b1bfa0e)({
        contentId: contentId,
        disabled: isTitleFocused || disabled,
        shouldRenderPreview: shouldRenderPreview,
        isTitleFocused: isTitleFocused,
        collabEditError: collabEditError,
        collabLimitReached: collabLimitReached,
        heartbeatError: heartbeatError
    });
    // Side effect: Schedule publish flags watcher
    (0, $f9205d97e0969451$export$206997a838ea4b9d)({
        contentId: contentId,
        contentType: contentType,
        isUnpublishedDraft: isUnpublishedDraft,
        title: title ?? draftTitle,
        flags: flags,
        isSchedulePublishEnabled: !isLivePage
    });
    // Side effect: Full page editor loom insertion
    (0, $57b1365ec21ea4d6$export$12026d53c57123e6)(fullPageEditorPresetAPI);
    // Side effect: Agent mention bridge — reads agent mention plugin state and writes to
    // EditorRovoButtonActionsStore, resolving AAID → Agent Studio UUID via the assistance API.
    (0, $7a7bf08f4d7f088e$export$c06e63272903d81b)(fullPageEditorPresetAPI);
    // Side effect: Plugin state effect for annotations
    (0, $1KOhB.usePluginStateEffect)(fullPageEditorPresetAPI, [
        'annotation'
    ], ({ annotationState: annotationState })=>{
        const annotations = annotationState?.annotations;
        const { selectedAnnotations: selectedAnnotations, mouseData: mouseData } = annotationState || {};
        annotationStateRef.current = annotationState;
        const handleCommentQueryParams = ()=>{
            if (selectedAnnotations && selectedAnnotations.length > 0 && mouseData?.isSelecting && (focusedCommentId || replyToCommentId)) removeCommentQueryParams();
        };
        const setAnnotations = ()=>{
            const editorAnnotationsToSet = annotations ? Object.keys(annotations) : [];
            setEditorAnnotations(getSortedMarkerRefs(editorAnnotationsToSet, 'edit'), contentId);
            editorAnnotationsRef.current = editorAnnotationsToSet;
            const activeEditorAnnotationsToSet = annotations ? Object.keys(annotations).filter((key)=>annotations[key] === false) : [];
            setOrderedActiveAnnotationIdList(getSortedMarkerRefs(activeEditorAnnotationsToSet, 'edit'));
        };
        handleCommentQueryParams();
        setAnnotations();
    });
    // Side effect: Hide object sidebar on content change
    (0, $cozmU.useEffect)(()=>{
        hideObjectSidebar();
    }, [
        contentId,
        hideObjectSidebar
    ]);
    // Side effect: Comments cleanup on unmount or content change when side effects are isolated
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            resetInitialDataLoadedMap();
            clearCommentsData();
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) clearProcessedData();
            clearMentionsFlags();
            setActiveHighlight(null);
        };
    }, [
        contentId,
        resetInitialDataLoadedMap,
        clearCommentsData,
        clearProcessedData,
        clearMentionsFlags,
        setActiveHighlight
    ]);
    return null;
};


const $a00e1ed200f6db86$export$d1f7cc0755451204 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $310b15d05f913bec$export$c2c72aeadce38f04), props);
};









var $dNj8O = parcelRequire("dNj8O");







const $f170940358b92700$export$ddf22c5071815a12 = ({ approvalRequestLoading: approvalRequestLoading = false, approvalReviewStatus: approvalReviewStatus = null, contentId: contentId, disallowFirstPublish: disallowFirstPublish = false, isUnpublishedDraft: isUnpublishedDraft, onPublishBlocked: onPublishBlocked, spaceKey: spaceKey, shouldPreventPublish: shouldPreventPublish = false })=>(0, $cozmU.useCallback)(async ()=>{
        if (!contentId || !spaceKey) return false;
        if (shouldPreventPublish) {
            onPublishBlocked?.();
            return true;
        }
        if (!(0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) return false;
        if (!isUnpublishedDraft) return false;
        if (approvalRequestLoading && disallowFirstPublish) {
            onPublishBlocked?.();
            return true;
        }
        if (!disallowFirstPublish && !shouldPreventPublish) return false;
        if (disallowFirstPublish && approvalReviewStatus === 'APPROVED') return false;
        onPublishBlocked?.();
        return true;
    }, [
        approvalRequestLoading,
        approvalReviewStatus,
        contentId,
        disallowFirstPublish,
        isUnpublishedDraft,
        onPublishBlocked,
        shouldPreventPublish,
        spaceKey
    ]);


const $800213025128bc4b$var$isApprovalReviewStatus = (reviewStatus)=>reviewStatus === 'APPROVED' || reviewStatus === 'CANCELED' || reviewStatus === 'DENIED' || reviewStatus === 'PENDING';
const $800213025128bc4b$export$14f40bebf39ab793 = ({ approvalRequestLoading: approvalRequestLoading, approvalReviewStatus: approvalReviewStatus, contentId: contentId, contentType: contentType, createAnalyticsEvent: createAnalyticsEvent, disallowFirstPublish: disallowFirstPublish, isLivePage: isLivePage, isUnpublishedDraft: isUnpublishedDraft, spaceKey: spaceKey })=>{
    const [isFirstPublishBlockedModalOpen, setIsFirstPublishBlockedModalOpen] = (0, $cozmU.useState)(false);
    const isFirstPublishBlockedModalOpenRef = (0, $cozmU.useRef)(false);
    const { handleCloseLiveDocConversionBlockedModal: handleCloseLiveDocConversionBlockedModal, handleLiveDocConversionBlockedByApproval: handleLiveDocConversionBlockedByApproval, isLiveDocConversionBlockedModalOpen: isLiveDocConversionBlockedModalOpen, shouldBlockLiveDocConversion: shouldBlockLiveDocConversion } = (0, $dNj8O.useLiveDocConversionBlockedModal)({
        contentId: contentId,
        contentType: contentType,
        createAnalyticsEvent: createAnalyticsEvent,
        disallowFirstPublish: disallowFirstPublish,
        isLivePage: isLivePage
    });
    const approvalPublishBlockedModal = isLiveDocConversionBlockedModalOpen ? 'liveDocConversion' : isFirstPublishBlockedModalOpen ? 'firstPublish' : null;
    const handleCloseApprovalPublishBlockedModal = (0, $cozmU.useCallback)(()=>{
        if (approvalPublishBlockedModal === 'firstPublish') {
            isFirstPublishBlockedModalOpenRef.current = false;
            setIsFirstPublishBlockedModalOpen(false);
            return;
        }
        if (approvalPublishBlockedModal === 'liveDocConversion') handleCloseLiveDocConversionBlockedModal();
    }, [
        approvalPublishBlockedModal,
        handleCloseLiveDocConversionBlockedModal
    ]);
    const handleFirstPublishBlockedByApproval = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'blocked',
                actionSubject: 'publish',
                actionSubjectId: 'blockedByApprovalPolicy',
                source: (0, $2QUbq.APPROVALS_ANALYTICS_SOURCE),
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    isUnpublishedDraft: isUnpublishedDraft
                }
            }
        }).fire();
        if (!isFirstPublishBlockedModalOpenRef.current) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'shown',
                actionSubject: 'modal',
                actionSubjectId: 'approvalRequiredBeforePublishing',
                source: (0, $2QUbq.APPROVALS_ANALYTICS_SOURCE),
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    isUnpublishedDraft: isUnpublishedDraft
                }
            }
        }).fire();
        isFirstPublishBlockedModalOpenRef.current = true;
        setIsFirstPublishBlockedModalOpen(true);
    }, [
        contentId,
        contentType,
        createAnalyticsEvent,
        isUnpublishedDraft
    ]);
    const handlePublishBlockedByApproval = (0, $cozmU.useCallback)(()=>{
        if (shouldBlockLiveDocConversion) {
            handleLiveDocConversionBlockedByApproval();
            return;
        }
        handleFirstPublishBlockedByApproval();
    }, [
        handleFirstPublishBlockedByApproval,
        handleLiveDocConversionBlockedByApproval,
        shouldBlockLiveDocConversion
    ]);
    const preventFirstPublishWithoutApproval = (0, $f170940358b92700$export$ddf22c5071815a12)({
        approvalRequestLoading: approvalRequestLoading,
        approvalReviewStatus: $800213025128bc4b$var$isApprovalReviewStatus(approvalReviewStatus) ? approvalReviewStatus : undefined,
        contentId: contentId,
        disallowFirstPublish: disallowFirstPublish,
        isUnpublishedDraft: isUnpublishedDraft,
        onPublishBlocked: handlePublishBlockedByApproval,
        shouldPreventPublish: shouldBlockLiveDocConversion,
        spaceKey: spaceKey
    });
    return {
        approvalPublishBlockedModal: approvalPublishBlockedModal,
        handlePublishBlockedByApproval: handlePublishBlockedByApproval,
        handleCloseApprovalPublishBlockedModal: handleCloseApprovalPublishBlockedModal,
        preventFirstPublishWithoutApproval: preventFirstPublishWithoutApproval,
        shouldBlockLiveDocConversion: shouldBlockLiveDocConversion
    };
};


const $b56facd6a98e9621$var$ConditionalTwoStageHydration = ({ children: children })=>{
    // cc_editor_two_stage_hydration_removal - When cleaning up this experiment, also remove the related TwoStageHydration component
    if ((0, $6mKj3.expValEquals)('cc_editor_two_stage_hydration_removal', 'fullPageEditorComponentContentComponentsAfter', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dA1Sn.TwoStageHydration), {
        name: "full-page-editor-contentcomponents-after"
    }, children);
};
const $b56facd6a98e9621$var$SSR_TRACE_SEGMENT_NAME = 'ssr-app/render/fullPageEditor';
const $b56facd6a98e9621$var$recordSSRMeasureWithPrefix = ({ segmentName: segmentName, ...rest })=>(0, $1fcefd278c33801b$export$5dc6b08aaa4bcf54)({
        segmentName: `${$b56facd6a98e9621$var$SSR_TRACE_SEGMENT_NAME}/${segmentName}`,
        ...rest
    });
const $b56facd6a98e9621$var$FullPageEditorWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_19121cl4",
            __cmplp.className
        ])
    });
}); // IMPORTANT: If you change the code below, please also update the
const $b56facd6a98e9621$var$CARD_OPTIONS = {
    allowDatasource: true
};
const $b56facd6a98e9621$var$useLinkCreationQueryParam = (0, $dPJCf.createSingleQueryParamHook)('linkCreation');
const $b56facd6a98e9621$var$useFocusedCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('focusedCommentId');
const $b56facd6a98e9621$var$useFocusedMentionIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('focusedMentionId');
const $b56facd6a98e9621$var$useReplyToCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('replyToComment');
const $b56facd6a98e9621$var$useVersionOverrideQueryParam = (0, $dPJCf.createSingleQueryParamHook)('versionOverride');
const $b56facd6a98e9621$var$usePageVersionQueryParam = (0, $dPJCf.createSingleQueryParamHook)('pageVersion'); // Content components are displayed below the editor tool bar
const $b56facd6a98e9621$var$_getContentComponents = (0, $dOBRD.default)(({ contentId: contentId, cloudId: cloudId, debounceTitleChangeUpdates: debounceTitleChangeUpdates, focusEditor: focusEditor, onFocusChanged: onFocusChanged, userOffline: userOffline, linkCreation: linkCreation, editorPluginAIFeedbackHandlers: editorPluginAIFeedbackHandlers, isAdminHubAIEnabled: isAdminHubAIEnabled, hasAudioButton: hasAudioButton, hideSpinner: hideSpinner, templateSuggestionsRef: templateSuggestionsRef, templateButtonRef: templateButtonRef, viewMode: viewMode, contentClassificationMetadata: contentClassificationMetadata, spaceKey: spaceKey, isUnpublishedDraft: isUnpublishedDraft, showBlankPageQuickActions: showBlankPageQuickActions, isLivePage: isLivePage, version: version, isEditorEmpty: isEditorEmpty, collabEditInitialized: collabEditInitialized, shouldRenderPreview: shouldRenderPreview, isEditorAnnotationProviderManagersEnabled: isEditorAnnotationProviderManagersEnabled, editorApi: editorApi, contentType: contentType, editorActions: editorActions, disabled: disabled, isTitleFocused: isTitleFocused, appearance: appearance, title: title, onTitleChange: onTitleChange, cancelDebouncedSaveDraft: cancelDebouncedSaveDraft, showSpinner: showSpinner, isRovoButtonEnabled: isRovoButtonEnabled, editorSessionId: editorSessionId, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, hasReactions: hasReactions, hasCommentSessions: hasCommentSessions, hasPageComments: hasPageComments, isEmbeddedConfluence: isEmbeddedConfluence, isTemplateBrowserEnabled: isTemplateBrowserEnabled, isTemplateBrowserPanelEnabled: isTemplateBrowserPanelEnabled, isBlankPageQuickActionsEnabled: isBlankPageQuickActionsEnabled, isSeamlessTransitionInProgress: isSeamlessTransitionInProgress = false, isRovoLLMEnabled: isRovoLLMEnabled, isMarkdownMode: isMarkdownMode, isMarkdownModeSyntaxViewToggled: isMarkdownModeSyntaxViewToggled, customPlaceholderOverride: customPlaceholderOverride, onCreateWithRovoClick: onCreateWithRovoClick, shouldShowCreateWithRovoExperience: shouldShowCreateWithRovoExperience, onPromptMouseEnter: onPromptMouseEnter, onPromptMouseLeave: onPromptMouseLeave, onPromptClick: onPromptClick, onPromptSubmit: onPromptSubmit, onDismissCwr: onDismissCwr, hasSubmittedCwrPrompt: hasSubmittedCwrPrompt, onInputEmpty: onInputEmpty, onCwrInputContentChange: onCwrInputContentChange, hasCwrPromptInputContent: hasCwrPromptInputContent, orgId: orgId, isInlineAIOpen: isInlineAIOpen, cwrPromptInputRef: cwrPromptInputRef })=>{
    const shouldHideTitleAreaInMarkdownMode = isLivePage && isMarkdownMode;
    const titleAreaContentComponents = shouldHideTitleAreaInMarkdownMode ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8SCD6.ReactionsProvider), {
        key: "reactions-provider",
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $08a4a4f0ffa330f8$export$4907a23e9e92d796), {
        isEditorEmpty: isEditorEmpty,
        collabEditInitialized: collabEditInitialized,
        contentId: contentId,
        cloudId: cloudId,
        focusEditor: focusEditor,
        onFocusChanged: onFocusChanged,
        debounceOnChange: debounceTitleChangeUpdates,
        userOffline: userOffline,
        templateSuggestionsRef: templateSuggestionsRef,
        templateButtonRef: templateButtonRef,
        linkCreation: linkCreation,
        hideSpinner: hideSpinner,
        viewMode: viewMode,
        contentClassificationMetadata: contentClassificationMetadata,
        version: version,
        editorApi: editorApi,
        editorActions: editorActions,
        editorSessionId: editorSessionId,
        isSeamlessTransitionInProgress: isSeamlessTransitionInProgress,
        hasByLineContributors: hasByLineContributors,
        hasByLineExtensions: hasByLineExtensions,
        hasReactions: hasReactions,
        customPlaceholderOverride: customPlaceholderOverride
    }));
    let blankPageQuickActionsTemplatePreview;
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey); // show BPQA full size template preview when we
    // are not previewing the editor, BPQA should show and it's either
    // an unpublished draft or a live page
    const shouldShowFullPageTemplatePreview = !shouldRenderPreview && showBlankPageQuickActions && (isUnpublishedDraft || isLivePage);
    if (shouldShowFullPageTemplatePreview) blankPageQuickActionsTemplatePreview = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ccf3ae46461db7a4$export$5690797982203811), {
        key: "blank-page-quick-actions-template-preview",
        spaceKey: spaceKey
    });
    const isEmbeddedBpqaEnabled = isEmbeddedConfluence ? (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') ? isBlankPageQuickActionsEnabled || isTemplateBrowserEnabled : isTemplateBrowserEnabled : true;
    const shouldHideRenderPageFooterCommentsInMarkdownMode = isLivePage && isMarkdownMode && isMarkdownModeSyntaxViewToggled;
    const shouldRenderBPQA = isEmbeddedBpqaEnabled && !shouldRenderPreview && showBlankPageQuickActions && !isCompanyHub && !shouldHideRenderPageFooterCommentsInMarkdownMode;
    const shouldRenderPageFooterComments = !shouldHideRenderPageFooterCommentsInMarkdownMode && (isEmbeddedConfluence ? hasPageComments : true); // The footer is pinned to the bottom on small live pages (see ObjectCommentContainer)
    // However, this can only happen on first paint in SPA (useEffect + the DOM aren't available in SSR), so the SSR'd version doesn't match the SPA version
    // Until we have a styling only fix, we should prevent rendering this in SSR (but keep preloading, etc to improve TTVC)
    const shouldRenderObjectCommentWrapper = // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    true;
    const shouldShowEOPRecommendations = contentType === 'page' && (0, $6mKj3.expValEquals)('confluence_ai_related_content_for_live_pages', 'isEnabled', true) && // Hide Related content / Send feedback (EOP recommendations) for embedded pages
    // when cc-maui-experiment is enabled.
    !(isEmbeddedConfluence && ((0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) || (0, $9wGTI.fg)('platform_native_embeds_rollout_non_maui_experience'))); // On markdown pages the Related content section is hidden once the editor enters
    // markdown syntax view (see shouldHideRenderPageFooterCommentsInMarkdownMode). That hide
    // relies on `isMarkdownModeSyntaxViewToggled`, which is derived from editor plugin state
    // that doesn't exist during SSR, so the section would render server-side and flash before
    // being hidden on hydration. Suppress it in SSR for markdown pages only; normal pages
    // still render Related content in SSR, and on the client this is always false.
    const shouldHideEOPRecommendationsInSSR = isMarkdownMode && // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    Boolean(undefined);
    return {
        before: [
            !isCompanyHub && titleAreaContentComponents,
            isLivePage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $25ae8a0e0879b1fe$export$8a0839b0c4b155bf), {
                key: "imported-page-polish-banner",
                editorActions: editorActions
            }),
            isAdminHubAIEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2dIEg.EditorPluginAIWithFeedback), {
                key: "editor-ai-feedback-collector",
                editorPluginAIFeedbackHandlers: editorPluginAIFeedbackHandlers
            }),
            isEditorAnnotationProviderManagersEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5IgBW.EditorAnnotationProviderComponents), {
                key: "editorAnnotationProviderComponents"
            }),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hRcC4.EditorForgeExtensionConfigHelperRenderer), {
                key: "editorForgeExtensionConfigHelperRenderer"
            }),
            !isCompanyHub && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dA1Sn.TwoStageHydration), {
                key: "object-sidebar-control-full-page-editor",
                name: "object-sidebar-control-full-page-editor",
                enabled: !(0, $6mKj3.expValEquals)('cc_editor_two_stage_hydration_removal', 'fullPageEditorComponentObjectSidebarControl', true),
                ssrPlaceholder: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1e65a39b95334039$export$7d2a7d16db4db259), {
                hasAiButton: isLivePage || isRovoButtonEnabled,
                hasAudioButton: hasAudioButton,
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: contentType,
                contentTitle: title,
                editorApi: editorApi,
                isUnpublishedDraft: isUnpublishedDraft,
                disabled: disabled,
                isEditorEmpty: isEditorEmpty,
                isMarkdownMode: isMarkdownMode,
                isMarkdownModeSyntaxViewToggled: isMarkdownModeSyntaxViewToggled
            })),
            shouldRenderBPQA && !isMarkdownMode && shouldShowCreateWithRovoExperience && isRovoLLMEnabled && (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant1') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $badeeeba932732aa$export$1683fadeb44552c5), {
                key: "create-with-rovo-experience-dismiss-text"
            }),
            shouldRenderBPQA && (!isRovoLLMEnabled || !(0, $6mKj3.isExperimentEnabled)('cwr_blank_object_experiment')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eD8ha.BlankPageQuickActions), {
                key: "blank-page-quick-actions",
                editorActions: editorActions,
                disabled: disabled,
                isTitleFocused: isTitleFocused,
                focusEditor: focusEditor,
                appearance: appearance,
                spaceKey: spaceKey,
                isUnpublishedDraft: isUnpublishedDraft,
                title: title,
                onTitleChange: onTitleChange,
                contentId: contentId,
                cancelDebouncedSaveDraft: cancelDebouncedSaveDraft,
                showSpinner: showSpinner,
                hideSpinner: hideSpinner,
                isAIEnabled: isAdminHubAIEnabled,
                editorPresetAPI: editorApi,
                isTemplateBrowserEnabled: !isEmbeddedConfluence || isTemplateBrowserEnabled || isTemplateBrowserPanelEnabled
            }),
            // Variant2: show CreateWithRovoExperience in place of the old BPQA
            shouldRenderBPQA && !isMarkdownMode && !hasSubmittedCwrPrompt && isRovoLLMEnabled && (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant2') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $44282712d6713830$export$895eee10ef701154), {
                key: "create-with-rovo-experience-variant2",
                cloudId: cloudId,
                orgId: orgId,
                contentId: contentId,
                editorApi: editorApi,
                onPromptMouseEnter: onPromptMouseEnter,
                onPromptMouseLeave: onPromptMouseLeave,
                onPromptClick: onPromptClick,
                onPromptSubmit: onPromptSubmit,
                onInputEmpty: onInputEmpty,
                smartPromptsPosition: "above",
                placement: "bottom",
                contentType: isLivePage ? 'liveDoc' : 'page',
                variant: "variant2",
                isPublishedPage: !isUnpublishedDraft && !isLivePage,
                promptInputRef: cwrPromptInputRef,
                initialHasInputContent: hasCwrPromptInputContent,
                onInputContentChange: onCwrInputContentChange
            })
        ],
        after: [
            shouldRenderBPQA && !isMarkdownMode && !hasSubmittedCwrPrompt && !isInlineAIOpen && isRovoLLMEnabled && (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant1') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1441818b1f852262$export$5b6edddf72525f99), {
                key: "create-with-rovo-buttons",
                disabled: disabled,
                editorPresetAPI: editorApi,
                isTitleFocused: isTitleFocused,
                focusEditor: focusEditor,
                isAIEnabled: isAdminHubAIEnabled,
                isLivePage: isLivePage,
                isPublishedPage: !isUnpublishedDraft && !isLivePage,
                onCreateWithRovoClick: onCreateWithRovoClick
            }),
            // Variant1: show CreateWithRovoExperience after clicking the CWR button
            shouldRenderBPQA && !isMarkdownMode && shouldShowCreateWithRovoExperience && !hasSubmittedCwrPrompt && isRovoLLMEnabled && (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant1') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $44282712d6713830$export$895eee10ef701154), {
                key: "create-with-rovo-experience",
                cloudId: cloudId,
                orgId: orgId,
                contentId: contentId,
                editorApi: editorApi,
                onPromptMouseEnter: onPromptMouseEnter,
                onPromptMouseLeave: onPromptMouseLeave,
                onPromptClick: onPromptClick,
                onPromptSubmit: onPromptSubmit,
                onDismiss: onDismissCwr,
                onInputEmpty: onInputEmpty,
                contentType: isLivePage ? 'liveDoc' : 'page',
                variant: "variant1",
                initialHasInputContent: hasCwrPromptInputContent,
                onInputContentChange: onCwrInputContentChange
            }),
            blankPageQuickActionsTemplatePreview,
            shouldRenderPageFooterComments && !shouldRenderBPQA && isLivePage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b56facd6a98e9621$var$ConditionalTwoStageHydration, {
                key: "conditional-two-stage-hydration"
            }, shouldShowEOPRecommendations && !shouldHideEOPRecommendationsInSSR && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6H0Pg.default), {
                name: "end-of-page-recommendation-loader"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fIKxq.EndOfPageRecommendationLoader), {
                entityType: contentType,
                entityId: contentId,
                spaceKey: spaceKey ?? '',
                pageWidthType: `"max-width"`,
                isLivePage: isLivePage
            })), shouldRenderObjectCommentWrapper && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6H0Pg.default), {
                name: "editor-footer-comments"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $70pcM.ObjectCommentWrapper), {
                showGeneralComment: true,
                showLabels: true,
                key: `ObjectCommentWrapper-${contentId}`,
                hasReactions: hasReactions,
                hasCommentSessions: hasCommentSessions,
                editorIsUserOffline: userOffline
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2xS8W.StickyDraftCommentContainer), null)))
        ]
    };
}, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
const $b56facd6a98e9621$var$_getContextPanelComponent = (0, $dOBRD.default)(()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2KWDO.EditorContextPanelView), null);
});
const $b56facd6a98e9621$var$_getEditorContextConnectionsPanel = (0, $dOBRD.default)(({ referentialityContext: referentialityContext, connectionsPanelActiveNodeLocalId: connectionsPanelActiveNodeLocalId, setConnectionsPanelActiveNodeLocalId: setConnectionsPanelActiveNodeLocalId, closeConnectionsPanel: closeConnectionsPanel })=>{
    if (connectionsPanelActiveNodeLocalId && referentialityContext?.api) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kXAjP.EditorContextConnectionsPanel), {
        api: referentialityContext.api,
        activeNodeLocalId: connectionsPanelActiveNodeLocalId,
        setActiveNodeLocalId: setConnectionsPanelActiveNodeLocalId,
        closeConnectionsPanel: closeConnectionsPanel
    });
    return null;
});
const $b56facd6a98e9621$var$_getEditorContextSmartButtonConfigPanel = (0, $dOBRD.default)(({ smartButtonActiveNodeLocalId: smartButtonActiveNodeLocalId, closeSmartButtonConfigPanel: closeSmartButtonConfigPanel, fullPageEditorPresetAPI: fullPageEditorPresetAPI })=>{
    if (smartButtonActiveNodeLocalId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8S5Nq.SmartButtonConfigPanel), {
        localId: smartButtonActiveNodeLocalId,
        closeSelf: closeSmartButtonConfigPanel,
        editorApi: fullPageEditorPresetAPI
    });
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
// platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/placeholderPluginOptions/placeholderPluginOptions.ts
const $b56facd6a98e9621$var$_getPlaceholderText = (0, $dOBRD.default)((placeholderTextParam)=>{
    const isAIEnabledForContent = placeholderTextParam.isAIEnabledForContent;
    if (isAIEnabledForContent && (0, $9wGTI.fg)('aifc_create_enabled')) return (0, $48dba10f6de5f65d$export$a7357cdd1f0b0168).editorEmptyDocumentSpaceShortcutPlaceholder;
    if (isAIEnabledForContent) return (0, $48dba10f6de5f65d$export$a7357cdd1f0b0168).editorEmptyDocumentPlaceholderAI;
    if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) return (0, $48dba10f6de5f65d$export$a7357cdd1f0b0168).editorEmptyDocumentPlaceholder;
    const key = `${isAIEnabledForContent ? 'AI' : 'noAI'}`;
    const placeholders = {
        AI: {
            //  Placeholder text when AI is enabled
            id: (0, $9b9cd112fc8297b9$export$7f03b831e2e40b16),
            defaultMessage: (0, $9b9cd112fc8297b9$export$6a44b93c4f739392)
        },
        noAI: {
            //  Placeholder text when AI is not enabled
            id: (0, $9b9cd112fc8297b9$export$b7b0d81eceb7980e),
            defaultMessage: (0, $9b9cd112fc8297b9$export$a86989c71e454d74)
        }
    };
    return placeholders[key];
});
const $b56facd6a98e9621$var$withEditorContext = (component)=>(0, $3plmx.withSmartCardProviderContext)((0, $gKaeO.withRevertContext)((0, $6LguK.withEditorModalContext)(component)));
const $b56facd6a98e9621$var$getContentAppearance = (0, $dOBRD.default)((appearance, draftAppearance)=>{
    // if the appearance is default value (version 0), reference the draftAppearance if it exists; otherwise, use appearance
    const contentAppearance = appearance.version === 0 && draftAppearance ? draftAppearance : appearance.appearance;
    return (0, $c4PY4.getContentAppearanceForAtlaskit)(contentAppearance);
}); // If updating please update in DiffEditor.tsx as well

const $b56facd6a98e9621$var$_createLCMExtensionProvider = async (outerEditorView, outerEditorApi, propOverrides)=>{
    const { createManifest: createManifest } = await (parcelRequire("3jM74"));
    return new (0, $bdpeX.default)([
        createManifest(outerEditorView, outerEditorApi, propOverrides)
    ]);
};
const $b56facd6a98e9621$var$FullPageEditorComponentImpl = (props)=>{
    // Should be always the first statement in the component
    const firstRenderStartTimestampRef = (0, $cozmU.useRef)(performance.now());
    const { contentId: // Props from Loader
    contentId, spaceKey: spaceKey, collabEditProvider: collabEditProvider, collabEdit: collabEdit, collabEditState: collabEditState, heartbeatData: heartbeatData, contentType: contentType, disabled: disabled, setForceDisabled: setForceDisabled, internetDisconnected: internetDisconnected, forceDisabled: forceDisabled, draftShareId: draftShareId, refetchNativeCollab: refetchNativeCollab, isFirstParticipant: isFirstParticipant, isSingleUserSession: isSingleUserSession, isUnpublishedDraft: isUnpublishedDraft, isOverviewPage: isOverviewPage, onTitleChange: onTitleChange, title: title, version: version, viewMode: viewMode, onPublishUpdateTitleInPageTree: onPublishUpdateTitleInPageTree, optimisticDeleteItemInTree: optimisticDeleteItemInTree, customPerfData: customPerfData, editorActions: // Props from editor-core
    editorActions, extensionContextProvider: // Context Provider for macro
    extensionContextProvider, flags: flags, dialogs: dialogs, handleDocChange: handleDocChange, pageTreeStateUpdater: pageTreeStateUpdater, hasEditPermission: /**
     * defaults to true
     * used by live pages as live pages render editor on view only mode
     */ hasEditPermission = true, createdDate: createdDate, onDraftSyncSuccess: onDraftSyncSuccess, loadingPriority: loadingPriority, isFastLoadedLiveDoc: isFastLoadedLiveDoc, enableAIPlannerBridgeRouteEditorOverrides: enableAIPlannerBridgeRouteEditorOverrides, contextualFormattingMode: contextualFormattingMode, disableEditorAI: disableEditorAI, disablePrimaryToolbar: disablePrimaryToolbar, hasByLineContributors: hasByLineContributors = true, hasByLineExtensions: hasByLineExtensions = true, hasReactions: hasReactions = true, hasPageComments: hasPageComments = true, hasInlineComments: hasInlineComments = true, hasCommentSessions: hasCommentSessions = false } = props;
    const [{ fullPageEditorPresetAPI: fullPageEditorPresetAPI }, { setEditorApi: setEditorApi, resetEditorApi: resetEditorApi }] = (0, $kDhla.useFullPageEditorApi)(); // Computed early so agentic mode can skip activation on Markdown pages.
    const isLivePageForAgentic = (0, $3jwuS.useIsCurrentPageLive)();
    const isMarkdownModeForAgentic = (0, $LSims.useIsMarkdownMode)(isLivePageForAgentic ? contentId : undefined); // Agentic editor mode — locks editor to AI-only editing
    const { isAgenticMode: isAgenticMode, handleExitAgenticMode: handleExitAgenticMode, handleDismissAgenticMode: handleDismissAgenticMode, agenticEditorRef: agenticEditorRef, agenticModeStartTime: agenticModeStartTime, aiInvocationCountRef: aiInvocationCountRef, aiInvocationSurfacesRef: aiInvocationSurfacesRef, onEditorAnalyticsEvent: onEditorAnalyticsEvent } = (0, $8a1b04980773868e$export$813250ab9f37732b)({
        isMarkdownMode: isMarkdownModeForAgentic
    });
    const { detectedLinks: detectedLinks, newLinkTypes: newLinkTypes, newLinks: newLinks, shouldShowSpotlight: shouldShowSpotlight, closeSpotlight: closeSpotlight } = (0, $2a156e74b04ef78c$export$122559bc1a8888a4)(fullPageEditorPresetAPI); // Ensures editorApi sweet state is cleared on unmount
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            resetEditorApi();
        };
    }, [
        resetEditorApi
    ]); // Track media viewed while editing, mirroring the view-mode ADFRendererComponent. The listener is
    // reference-counted, so it coexists safely with comment ADFRenderers that also register it.
    (0, $cozmU.useEffect)(()=>{
        (0, $edEsl.registerGlobalMediaViewedListener)({
            contentType: contentType
        });
        return ()=>{
            (0, $edEsl.removeGlobalMediaViewedListener)();
        };
    }, [
        contentId,
        contentType
    ]); // Recommended way of accessing collabEditProvider without promise wrapper.
    const [{ collabEditProvider: extractedCollabEditProvider }] = (0, $hYoU4.useNativeCollabState)();
    const [{ collabEditConnected: collabEditConnected }] = (0, $hYoU4.useNativeCollabConnected)();
    const { approvalRequest: approvalRequest, approvalRequestLoading: approvalRequestLoading, disallowFirstPublish: disallowFirstPublish, isDraftLockedForEditing: isDraftLockedForEditing } = (0, $laFNM.useApprovals)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const editorAPIRef = (0, $cozmU.useRef)(fullPageEditorPresetAPI);
    (0, $cozmU.useEffect)(()=>{
        editorAPIRef.current = fullPageEditorPresetAPI;
    }, [
        fullPageEditorPresetAPI
    ]);
    const snippetExtensionList = (0, $0e1c17ea1b1a2ab6$export$94cce102debd6a0e)({
        contentId: contentId,
        spaceId: spaceId ?? '',
        spaceKey: spaceKey,
        editorAPIRef: editorAPIRef
    });
    const { triggerAnalyticsEvent: triggerAnalyticsEvent } = (0, $e9owJ.useEditorAnalyticsEvent)({
        contentId: contentId,
        contentType: contentType,
        subject: 'editPage',
        source: (0, $9b9cd112fc8297b9$export$f7109619a5e9e0d6),
        version: version,
        collabService: 'ncs'
    });
    const { requestToEditContent: requestToEditContent, hasRequestedEditPermission: hasRequestedEditPermission } = (0, $ewVsQ.useRequestToEditContent)({
        contentId: contentId,
        flags: flags,
        triggerAnalyticsEvent: triggerAnalyticsEvent
    });
    const isClassicMentionsNotificationsEnrolled = (0, $9747c27e818a1963$export$a9e17b56b1093c49)();
    const { setEditorAnnotations: setEditorAnnotations } = (0, $aUU0C.useEditorAnnotationsActions)();
    const isDocumentActive = (0, $92561710d62f83c7$export$4e0e446ffa50ddc0)();
    const { isSmartButtonAllowed: isSmartButtonAllowed } = (0, $iz4WO.useSmartButtonPremiumGate)();
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $c51db01a6bc02cc7$export$2e2bcd8739ae039),
        __callerPackage__: "full-page-editor"
    });
    const { updateTitle: updateContentTypesTitle } = (0, $kXsBa.useContentTypesTitleUpdate)(contentId, title || '');
    const { collabEditInitialized: collabEditInitialized, collabEditError: collabEditError, collabEditInternetLost: collabEditInternetLost, collabEditConnectionTimedOut: collabEditConnectionTimedOut } = collabEditState;
    const intl = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId, userId: userId, featureFlags: featureFlags, isAdminHubAIEnabled: isAdminHubAIEnabled, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled, isHideTitleInUrl: isHideTitleInUrl, edition: edition, orgId: orgId, environment: environment, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const { push: push, overrideUFORouteName: overrideUFORouteName } = (0, $dPJCf.useRouteActions)();
    const linkCreation = $b56facd6a98e9621$var$useLinkCreationQueryParam();
    const focusedCommentId = $b56facd6a98e9621$var$useFocusedCommentIdQueryParam();
    const replyToCommentId = $b56facd6a98e9621$var$useReplyToCommentIdQueryParam();
    const focusedMentionId = $b56facd6a98e9621$var$useFocusedMentionIdQueryParam();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { triggerSaveIndicator: triggerSaveIndicator } = (0, $cozmU.useContext)((0, $f9dc71ade1ee2d5f$export$df7407750199bb6d));
    const isEditorEmpty = (0, $3k5Tv.useSharedPluginStateWithSelector)(fullPageEditorPresetAPI, // @ts-ignore @ts-expect-error
    [
        'empty'
    ], // @ts-ignore @ts-expect-error
    (states)=>!!states?.emptyState?.editorIsEmpty) ?? editorActions?.isDocumentEmpty() ?? false;
    const showBlankPageQuickActions = (0, $99ISI.useShouldShowBlankPageQuickActions)({
        contentType: contentType,
        collabEditInitialized: collabEditInitialized,
        isEditorEmpty: isEditorEmpty,
        viewMode: viewMode
    });
    const isInlineAIOpen = (0, $3k5Tv.useSharedPluginStateWithSelector)(fullPageEditorPresetAPI, // @ts-ignore @ts-expect-error
    [
        'aiExperience'
    ], // @ts-ignore @ts-expect-error
    (states)=>!!states?.aiExperienceState?.aiDecorationExperiencePluginState?.isRunning) ?? false;
    const isMarkdownModeSyntaxViewToggled = (0, $3k5Tv.useSharedPluginStateWithSelector)(fullPageEditorPresetAPI, // @ts-ignore @ts-expect-error
    [
        'markdownMode'
    ], // @ts-ignore @ts-expect-error
    (states)=>states?.markdownModeState?.view === 'syntax') ?? false;
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const shouldRegisterAIPlannerRovoBridge = (0, $376e585e26b85ad9$export$c593e0767868f5d7)(); // Reuse the values computed earlier (above the agentic hook) to avoid
    // subscribing to these hooks twice.
    const isLivePage = isLivePageForAgentic;
    const isMarkdownMode = isMarkdownModeForAgentic;
    const versionOverride = $b56facd6a98e9621$var$useVersionOverrideQueryParam();
    const pageVersion = $b56facd6a98e9621$var$usePageVersionQueryParam();
    const isVersionHistoryView = versionOverride != null || pageVersion != null;
    const isArchived = (0, $9sGCn.getCachedPageData)(contentId)?.isArchived ?? false;
    const remixDisabledReason = isArchived ? 'archived' : isVersionHistoryView ? 'version-history' : undefined; // Uses optional chaining (not destructuring) because the module may return
    // undefined in test environments where it is not mocked.
    const nativeEmbedClient = (0, $jARmo.usePageNativeEmbedClient)();
    const sendNativeEmbedChildCommand = (0, $9wGTI.fg)('cc-maui-phase-2') || (0, $9wGTI.fg)('platform_native_embeds_rollout_non_maui_experience') ? nativeEmbedClient?.sendChildCommand : undefined;
    const isNativeEmbed = nativeEmbedClient?.isNativeEmbed ?? false;
    const templateSuggestionsRef = (0, $cozmU.useRef)(null);
    const templateButtonRef = (0, $cozmU.useRef)(null);
    const [{ editSource: editSource }] = (0, $4ri4I.useEditSource)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const rovoSkillsConfig = (0, $59NtD.useRovoSkillsConfig)({
        cloudId: cloudId,
        isRovoEnabled: isRovoButtonEnabled,
        editorAPI: fullPageEditorPresetAPI ?? undefined,
        contentId: contentId
    }); // State for Create with Rovo experience
    const [shouldShowCreateWithRovoExperience, setShouldShowCreateWithRovoExperience] = (0, $cozmU.useState)(false);
    const [hasSubmittedCwrPrompt, setHasSubmittedCwrPrompt] = (0, $cozmU.useState)(false);
    const [hasCwrPromptInputContent, setHasCwrPromptInputContent] = (0, $cozmU.useState)(false);
    const [customPlaceholderOverride, setCustomPlaceholderOverride] = (0, $cozmU.useState)(undefined); // Ref to the variant2 CreateWithRovoExperience prompt input so the space-key
    // shortcut handler can shift focus into it instead of opening inline Rovo.
    const cwrPromptInputRef = (0, $cozmU.useRef)(null); // Handler for Create with Rovo button click / space-key shortcut.
    // Variant1: open the CWR experience. Variant2: focus the already-visible CWR input.
    const handleCreateWithRovo = (0, $cozmU.useCallback)(()=>{
        if ((0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant2')) {
            cwrPromptInputRef.current?.focus();
            return;
        }
        setShouldShowCreateWithRovoExperience(true);
    }, []); // open "Create with Rovo" modal via quick insert
    const openSmartCreationModalFromQuickInsert = (0, $d255586da55d4698$export$f34b0c6dc5eb5a35)(editorActions); // Track whether a prompt has been clicked so hover-off doesn't clear it
    const isPromptSelectedRef = (0, $cozmU.useRef)(false); // Handlers for smart prompt hover to update title placeholder
    const onPromptMouseEnter = (0, $cozmU.useCallback)((prompt)=>{
        if (!isPromptSelectedRef.current) setCustomPlaceholderOverride(prompt.label);
    }, []);
    const onPromptMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (!isPromptSelectedRef.current) setCustomPlaceholderOverride(undefined);
    }, []); // When a prompt is clicked, persist its label as the title placeholder
    const onPromptClick = (0, $cozmU.useCallback)((prompt)=>{
        isPromptSelectedRef.current = true;
        setCustomPlaceholderOverride(prompt.label);
    }, []); // When a prompt is submitted, hide and reset the CWR experience and the buttons.
    const onPromptSubmit = (0, $cozmU.useCallback)(()=>{
        setShouldShowCreateWithRovoExperience(false);
        setHasSubmittedCwrPrompt(true);
        setHasCwrPromptInputContent(false);
        setCustomPlaceholderOverride(undefined);
        isPromptSelectedRef.current = false; // Warm the Rovo chat sidebar during CWR streaming so the stream-end
        // auto-open mounts without a cold bundle load.
        if ((0, $6mKj3.expValEquals)('cwr_boe_preload_chat_on_submit', 'isEnabled', true)) (0, $6c1b53bbc75abbea$export$c16a810a4a1be6ba)();
    }, []); // Open Rovo chat sidebar when CWR streaming completes.
    const { openConversationAssistant: openConversationAssistant, mode: conversationAssistantMode } = (0, $1AJi3.useToggleConversationAssistant)(); // Holds the pending deferred-open timer so it can be cancelled on unmount.
    const cwrOpenChatTimerRef = (0, $cozmU.useRef)(null);
    const onCwrStreamEnd = (0, $cozmU.useCallback)(()=>{
        if (hasSubmittedCwrPrompt && conversationAssistantMode !== (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR && ((0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant1') || (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant2'))) {
            // Defer the open so the chat appears as a clean, isolated step once the
            // stream-end layout has settled and page has scrolled to the top.
            if (cwrOpenChatTimerRef.current) clearTimeout(cwrOpenChatTimerRef.current);
            cwrOpenChatTimerRef.current = setTimeout(()=>{
                cwrOpenChatTimerRef.current = null;
                openConversationAssistant('sidebar');
            }, 500);
        }
    }, [
        hasSubmittedCwrPrompt,
        openConversationAssistant,
        conversationAssistantMode
    ]); // Cancel any pending deferred chat-open if the editor unmounts first.
    (0, $cozmU.useEffect)(()=>()=>{
            if (cwrOpenChatTimerRef.current) clearTimeout(cwrOpenChatTimerRef.current);
        }, []); // Reset hasSubmittedCwrPrompt when the editor transitions from non-empty → empty
    // (user deleted Rovo-generated content), so BOE buttons reappear.
    const prevIsEditorEmptyRef = (0, $cozmU.useRef)(isEditorEmpty);
    (0, $cozmU.useEffect)(()=>{
        const wasEmpty = prevIsEditorEmptyRef.current;
        prevIsEditorEmptyRef.current = isEditorEmpty;
        if (!wasEmpty && isEditorEmpty && hasSubmittedCwrPrompt) setHasSubmittedCwrPrompt(false);
    }, [
        isEditorEmpty,
        hasSubmittedCwrPrompt
    ]); // If the CWR prompt starts inline AI but the user cancels and discards the response
    // before any generated content is inserted, the editor remains empty. Reset the submitted
    // state when the inline AI experience closes so the BOE buttons can reappear.
    const previousInlineAIOpenStateRef = (0, $cozmU.useRef)(isInlineAIOpen);
    (0, $cozmU.useEffect)(()=>{
        const wasInlineAIOpenOnPreviousRender = previousInlineAIOpenStateRef.current;
        previousInlineAIOpenStateRef.current = isInlineAIOpen;
        const didInlineAIClose = wasInlineAIOpenOnPreviousRender && !isInlineAIOpen;
        const shouldRestoreBoeAfterCancelledCwr = didInlineAIClose && isEditorEmpty && hasSubmittedCwrPrompt;
        if (shouldRestoreBoeAfterCancelledCwr) setHasSubmittedCwrPrompt(false);
    }, [
        isInlineAIOpen,
        isEditorEmpty,
        hasSubmittedCwrPrompt
    ]); // AIFC-1794: own the 'staging-area' chat-context target for the in-flight CWR session so
    // abort routing survives BOE unmounting on prompt submit.
    const { setTarget: setChatContextTarget, clearTarget: clearChatContextTarget } = (0, $gzMZq.useChatContextStoreActions)();
    const isCwrSessionOwnedTargetRef = (0, $cozmU.useRef)(false);
    const ownedContentIdRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (hasSubmittedCwrPrompt && !isCwrSessionOwnedTargetRef.current && contentId) {
            setChatContextTarget('staging-area', {
                id: contentId,
                type: 'page',
                canProvideContext: true
            });
            isCwrSessionOwnedTargetRef.current = true;
            ownedContentIdRef.current = contentId;
            return;
        }
        if (isCwrSessionOwnedTargetRef.current && !isInlineAIOpen && ownedContentIdRef.current) {
            clearChatContextTarget('staging-area', ownedContentIdRef.current);
            isCwrSessionOwnedTargetRef.current = false;
            ownedContentIdRef.current = null;
        }
    }, [
        hasSubmittedCwrPrompt,
        isInlineAIOpen,
        contentId,
        setChatContextTarget,
        clearChatContextTarget
    ]); // Release the target if the component unmounts while a CWR session is still in flight
    // (e.g. user navigates away mid-stream) so we don't leak stale state into the store.
    const clearChatContextTargetRef = (0, $cozmU.useRef)(clearChatContextTarget);
    clearChatContextTargetRef.current = clearChatContextTarget;
    (0, $cozmU.useEffect)(()=>()=>{
            if (isCwrSessionOwnedTargetRef.current && ownedContentIdRef.current) {
                clearChatContextTargetRef.current('staging-area', ownedContentIdRef.current);
                isCwrSessionOwnedTargetRef.current = false;
                ownedContentIdRef.current = null;
            }
        }, // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally unmount-only; clearChatContextTarget accessed via ref
    []); // When the user clicks outside the CWR experience, dismiss it and reset the title placeholder
    const onDismissCwr = (0, $cozmU.useCallback)(()=>{
        setShouldShowCreateWithRovoExperience(false);
        setCustomPlaceholderOverride(undefined);
        isPromptSelectedRef.current = false;
        requestAnimationFrame(()=>{
            editorActions?.focus({
                scrollIntoView: false
            });
        });
    }, [
        editorActions
    ]); // When the user clears the prompt input, reset the title placeholder
    const onInputEmpty = (0, $cozmU.useCallback)(()=>{
        isPromptSelectedRef.current = false;
        setCustomPlaceholderOverride(undefined);
        setHasCwrPromptInputContent(false);
    }, []);
    const onCwrInputContentChange = (0, $cozmU.useCallback)((hasContent)=>{
        setHasCwrPromptInputContent(hasContent);
    }, []);
    const handleGqlError = (0, $cozmU.useCallback)((error, isCommentNotFound = false)=>{
        experienceTracker.stopOnError({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            error: error,
            attributes: {
                mode: isLivePage ? (0, $l2hqi.InlineCommentMode).LIVE : (0, $l2hqi.InlineCommentMode).EDIT,
                stopPoint: 'full-page-editor/FullPageEditorComponent',
                commentNotFound: isCommentNotFound
            }
        });
    }, [
        experienceTracker,
        isLivePage
    ]); // Note that this will detect missing inline and footer comments because the query will
    // find either type of comment - so if the comment doesn't exist, we will get the "not
    // found" error
    const handleUseFocusedCommentGQLError = (0, $cozmU.useCallback)((error)=>{
        const isCommentNotFound = error ? (0, $6tkbf.isCommentNotFoundError)(error.message) : false;
        if (flags && isCommentNotFound) {
            const commentId = focusedCommentId || replyToCommentId;
            const FULLPAGEEDITOR_COMMMENT_LINK_NOT_FOUND_FLAG_ID = `fullpageeditor-comment-link-not-found-${commentId}`;
            flags.showWarningFlag({
                id: FULLPAGEEDITOR_COMMMENT_LINK_NOT_FOUND_FLAG_ID,
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $48dba10f6de5f65d$export$a7357cdd1f0b0168).commentLinkNotFoundFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $48dba10f6de5f65d$export$a7357cdd1f0b0168).commentLinkNotFoundFlagDescription)
            });
        }
        handleGqlError(error, isCommentNotFound);
    }, [
        flags,
        focusedCommentId,
        handleGqlError,
        replyToCommentId
    ]); // === Editor State ===
    const [shouldRenderPreview, setShouldRenderPreview] = (0, $cozmU.useState)(false);
    const [previewAsBlog, setPreviewAsBlog] = (0, $cozmU.useState)(false);
    const [stagedContentId, setStagedContentId] = (0, $cozmU.useState)();
    const [stagedSpaceKey, setStagedSpaceKey] = (0, $cozmU.useState)();
    const [proseMirrorRenderedData, setProseMirrorRenderedData] = (0, $cozmU.useState)(null);
    const [conditionalPublishCheck, setConditionalPublishCheck] = (0, $cozmU.useState)();
    const assignConditionalFunction = (0, $cozmU.useCallback)((conditionalFunction)=>setConditionalPublishCheck(()=>conditionalFunction), []);
    const approvalReviewStatus = approvalRequest?.review?.reviewStatus;
    const { approvalPublishBlockedModal: approvalPublishBlockedModal, handleCloseApprovalPublishBlockedModal: handleCloseApprovalPublishBlockedModal, handlePublishBlockedByApproval: handlePublishBlockedByApproval, preventFirstPublishWithoutApproval: preventFirstPublishWithoutApproval, shouldBlockLiveDocConversion: shouldBlockLiveDocConversion } = (0, $800213025128bc4b$export$14f40bebf39ab793)({
        approvalRequestLoading: approvalRequestLoading,
        approvalReviewStatus: approvalReviewStatus,
        contentId: contentId,
        contentType: contentType,
        createAnalyticsEvent: createAnalyticsEvent,
        disallowFirstPublish: disallowFirstPublish,
        isLivePage: isLivePage,
        isUnpublishedDraft: isUnpublishedDraft,
        spaceKey: spaceKey
    });
    const checkIfConditionPreventingPublish = (0, $cozmU.useCallback)(async ()=>{
        if (conditionalPublishCheck && await conditionalPublishCheck()) return true;
        return preventFirstPublishWithoutApproval();
    }, [
        conditionalPublishCheck,
        preventFirstPublishWithoutApproval
    ]);
    const { updateUnresolvedInlineComment: updateUnresolvedInlineComment } = (0, $k8e76.useInlineCommentsActions)(); // importing the comments data states here as a temporary workaround to fix circular dependency, we need these states to handle dangling and unread from unread-comments package
    // unread-comments package is using comments-data package so we can't import comments-data into unread-comments package
    const { setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList } = (0, $8i27m.useCommentsDataActions)();
    const { setCurrentView: setCurrentView } = (0, $3mVfX.useCommentsPanelActions)();
    const handleCollabError = (0, $fBnV3.useHandleCollabError)(flags);
    const { data: onboardingStateData, loading: onboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)(Object.values((0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS)), !(0, $9wGTI.fg)('cc_onboarding_experience') || version !== 1); // when a user is eligible for contextual invite nudge, tag them before they publish
    (0, $lG7DR.useContextualInviteNudge)();
    const { editorOnboardingEligiblity: editorOnboardingEligiblity, recentSpotlightCompleted: recentSpotlightCompleted } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const shouldShowRecentSpotlight = !onboardingStateLoading && editorOnboardingEligiblity && !recentSpotlightCompleted; // Makes sure recentSpotlightCompleted is not undefined
    const { onEditorReady: onEditorReady, startingLinks: startingLinks } = (0, $1l6y9.useInviteFromLinkExperimentEditor)();
    const { handleSave: handleSaveThirdPartyLinks } = (0, $800766a5932539c2$export$83107a72a22797f3)(fullPageEditorPresetAPI ?? undefined, isLivePage, flags); // === Editor common functionalities and providers ===
    const { collabLimitReached: collabLimitReached, heartbeatError: heartbeatError, stopHeartbeatCallback: stopHeartbeatCallback, editorSessionId: editorSessionId } = heartbeatData; // Preloading native collab data for faster refetch when publishing
    const { refetchNativeCollab: refetchNativeCollabWithPreloading, preloadNativeCollabRefetch: preloadNativeCollabRefetch } = (0, $83a5ab04c7ded94b$export$f6774c6023dca75e)(refetchNativeCollab); // Edit page draft syncing
    const { cancelDebouncedSaveDraft: cancelDebouncedSaveDraft, triggerSaveDraft: triggerSaveDraft, navigateOnClose: navigateOnClose, onPublish: onPublish, isPublishingContent: isPublishingContent, saveDraft: saveDraft, saveDraftError: saveDraftError } = (0, $l3Dp5.useDraftSyncAndPublish)({
        contentId: contentId,
        contentType: contentType,
        refetchNativeCollab: (0, $6mKj3.expValEquals)('confluence_publish_ivc_native_collab_query', 'isEnabled', true) ? refetchNativeCollabWithPreloading : refetchNativeCollab,
        isFirstParticipant: isFirstParticipant,
        isUnpublishedDraft: isUnpublishedDraft,
        spaceKey: spaceKey,
        title: title,
        version: version,
        onCollabError: handleCollabError,
        editorActions: editorActions,
        checkIfConditionPreventingPublish: checkIfConditionPreventingPublish,
        flags: flags,
        dialogs: dialogs,
        editorPresetAPI: fullPageEditorPresetAPI,
        editorSessionId: editorSessionId,
        onPublishUpdateTitleInPageTree: onPublishUpdateTitleInPageTree,
        optimisticDeleteItemInTree: optimisticDeleteItemInTree,
        startingLinks: startingLinks,
        handleSaveThirdPartyLinks: handleSaveThirdPartyLinks,
        sendNativeEmbedChildCommand: sendNativeEmbedChildCommand
    }); // Live doc draft syncing
    const { draftSyncActionError: draftSyncActionError } = (0, $a59bf23b6ef769dd$export$7a6d63ee0185f0fd)({
        contentId: contentId,
        editorPresetAPI: fullPageEditorPresetAPI,
        editorActions: editorActions,
        onDraftSyncSuccess: onDraftSyncSuccess,
        isFirstParticipant: isFirstParticipant,
        flags: flags
    });
    const hasUnsavedChanges = (0, $f8ea506e3a40865e$export$d85ed874af6294e9)({
        contentId: contentId,
        isPublishingContent: isPublishingContent,
        isFirstParticipant: isFirstParticipant,
        editorPresetAPI: fullPageEditorPresetAPI
    });
    const printLockout = (0, $88Nzy.usePrintIntercept)({
        enabled: (0, $6mKj3.expValEquals)('afm-enable-command-p-reroute', 'isEnabled', true),
        shouldBlockPrint: ()=>hasUnsavedChanges
    });
    const { isTransitionPreloading: isLiveDocSeamlessTransitionPreloading } = (0, $d2e739e403a90913$export$1da4922e40f79365)({
        contentId: contentId,
        collabEditProvider: extractedCollabEditProvider,
        isPublishingContent: isPublishingContent,
        isFirstParticipant: isFirstParticipant,
        editorPresetAPI: fullPageEditorPresetAPI,
        isLivePage: isLivePage,
        hasEditPermission: hasEditPermission,
        isFastLoadedLiveDoc: isFastLoadedLiveDoc
    });
    const [isLiveDocSeamlessTransitioning, setIsLiveDocSeamlessTransitioning] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        let newTransitioningState;
        if (isLivePage) {
            if (!isLiveDocSeamlessTransitioning && isLiveDocSeamlessTransitionPreloading) newTransitioningState = true;
            else if (isLiveDocSeamlessTransitioning && !disabled && !isLiveDocSeamlessTransitionPreloading) newTransitioningState = false;
        } else if (isLiveDocSeamlessTransitioning) newTransitioningState = false;
        if (newTransitioningState !== undefined && newTransitioningState !== isLiveDocSeamlessTransitioning) setIsLiveDocSeamlessTransitioning(newTransitioningState);
    }, [
        contentId,
        disabled,
        isLiveDocSeamlessTransitionPreloading,
        isLivePage,
        isLiveDocSeamlessTransitioning
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isLivePage && isOverviewPage && // exposure will only fire for overview pages
        (0, $6mKj3.expValEquals)('cc_editor_ttvc_split_space_overview_edit_page', 'isEnabled', true)) overrideUFORouteName('space-overview-edit-page');
    }, [
        overrideUFORouteName,
        isLivePage,
        isOverviewPage
    ]);
    const [isAutoConverted] = (0, $sLZsl.useAutoConvertState)();
    const { draftTitle: draftTitle, draftBody: draftBody, draftAppearance: draftAppearance } = (0, $9a6aed826f4ffb4d$export$48c0f85d55b51110)({
        contentId: contentId,
        draftShareId: draftShareId,
        collabEditInitialized: collabEditInitialized,
        editorActions: editorActions,
        isUnrecoverableCollabEditError: !!collabEditError && (0, $S6mif.isUnrecoverableError)(collabEditError)
    }); // Get cached title from Apollo cache (e.g., from page tree) to use as initial value
    // while waiting for collab to initialize. This prevents the "Give this page a title"
    // placeholder from flashing during transitional loads.
    const cachedTitle = (0, $cozmU.useMemo)(()=>{
        // Skip cache lookup if we already have a title from collab or draft
        if (title || draftTitle) return null;
        const { title: cached } = (0, $6OEkb.getCachedPageTitle)(contentId); // For cwr_blank_object_experiment variant1 and variant2 on live docs,
        // do not use the cached title if it matches the auto-generated default format
        // "Untitled live doc YYYY-MM-DD" and the editor is empty (BOE is visible).
        if (isLivePage && isRovoLLMEnabled && isEditorEmpty && (0, $1gh0Q.isDefaultLiveDocTitle)(cached) && ((0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant1') || (0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'cohort', 'variant2'))) return null;
        return cached ?? null;
    }, [
        contentId,
        title,
        draftTitle,
        isLivePage,
        isRovoLLMEnabled,
        isEditorEmpty
    ]);
    const { connectionsPanelActiveNodeLocalId: connectionsPanelActiveNodeLocalId, setConnectionsPanelActiveNodeLocalId: setConnectionsPanelActiveNodeLocalId, openConnectionsPanel: openConnectionsPanel, closeConnectionsPanel: closeConnectionsPanel } = (0, $39X8O.useConnectionsPanel)();
    const { activeNodeLocalId: activeNodeLocalId, openConfigPanel: openConfigPanel, closeConfigPanel: closeConfigPanel, upsellModalSource: upsellModalSource, setUpsellModalSource: setUpsellModalSource } = (0, $b5ea4fb4260f4ec5$export$bdd538c0d43098c3)(editorActions);
    const { smartButtonActiveNodeLocalId: smartButtonActiveNodeLocalId, openSmartButtonConfigPanel: openSmartButtonConfigPanel, closeSmartButtonConfigPanel: closeSmartButtonConfigPanel } = (0, $jOYfu.useSmartButtonConfigPanel)();
    const { isAIEnabledForContent: isAIEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const { optInStatus: optInStatus, triggerOptInFlow: triggerOptInFlow, AIOptInModal: AIOptInModal } = (0, $i8Ylv.useEditorAIOptIn)({
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        isAIEnabledForContent: isAIEnabledForContent,
        edition: edition,
        orgId: orgId,
        environment: environment,
        isRovoLLMEnabled: isRovoLLMEnabled
    });
    const aiGlobalOptIn = (0, $cozmU.useMemo)(()=>({
            status: optInStatus,
            triggerOptInFlow: triggerOptInFlow
        }), [
        optInStatus,
        triggerOptInFlow
    ]);
    const { editorPluginAIFeedbackHandlers: editorPluginAIFeedbackHandlers } = (0, $f6GmT.useEditorPluginAIFeedbackHandlers)();
    const { onAIProviderChanged: onAIProviderChanged } = (0, $349687d7e88d726e$export$f95232bf2d33b362)();
    const getChannelVariables = (0, $85rxh.useGetChannelVariables)(cloudId, userId || 'anonymous', orgId); // Build media viewer extensions to add the comments button to the preview header
    const mediaViewerExtensions = (0, $BjpgS.useMediaCommentExtensions)({
        isViewPage: false,
        analyticsSource: isLivePage ? 'livePage' : 'editPageScreen',
        flags: flags
    });
    const fallbackMediaNameFetcher = (0, $cozmU.useMemo)(()=>(0, $6Trhx.createFallbackMediaNameFetcher)(contentId), [
        contentId
    ]);
    const mediaOptions = (0, $bjxK7.useMediaOptions)({
        contentId: contentId,
        contentType: contentType,
        flags: flags,
        viewMode: viewMode,
        editorAPI: fullPageEditorPresetAPI ?? undefined,
        mediaViewerExtensions: mediaViewerExtensions,
        fallbackMediaNameFetcher: (0, $6mKj3.expVal)('platform_editor_media_name_fallback', 'isEnabled', false) ? fallbackMediaNameFetcher : undefined
    });
    const handleFeedbackClicked = (0, $cozmU.useCallback)((feedbackProps)=>{
        editorPluginAIFeedbackHandlers.current.handleFeedbackClicked(feedbackProps);
    }, [
        editorPluginAIFeedbackHandlers
    ]);
    const handleReviewStateEntered = (0, $cozmU.useCallback)(()=>{
        editorPluginAIFeedbackHandlers.current.handleReviewStateEntered();
    }, [
        editorPluginAIFeedbackHandlers
    ]);
    const handleExperienceEnded = (0, $cozmU.useCallback)(()=>{
        editorPluginAIFeedbackHandlers.current.handleExperienceEnded();
    }, [
        editorPluginAIFeedbackHandlers
    ]);
    const editorPluginAIProviders = (0, $cozmU.useMemo)(()=>({
            mediaProvider: mediaOptions.provider
        }), [
        mediaOptions.provider
    ]);
    const { isCommentsPanelShown: isCommentsPanelShown, showCommentsPanel: showCommentsPanel, hideCommentsPanel: hideCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const onShowSuggestionsSidebar = (0, $cozmU.useCallback)(()=>{
        showCommentsPanel({
            openWithTab: (0, $3mVfX.SidebarTabValues).SUGGESTIONS
        });
    }, [
        showCommentsPanel
    ]);
    const handleAnnotationsRemovedByAI = (0, $26Yfd.useStableCallback)((ids)=>{
        if (!ids?.length) return;
        if (ids.length) flags?.showInfoFlag({
            id: ids[0],
            title: intl.formatMessage((0, $48dba10f6de5f65d$export$a7357cdd1f0b0168).commentRemovedByRovoTitle, {
                count: ids.length
            }),
            description: intl.formatMessage((0, $48dba10f6de5f65d$export$a7357cdd1f0b0168).commentRemovedByRovoDescription, {
                count: ids.length
            }),
            isAutoDismiss: true,
            actions: [
                {
                    content: intl.formatMessage((0, $48dba10f6de5f65d$export$a7357cdd1f0b0168).commentRemovedByRovoViewCommentCTA, {
                        count: ids.length
                    }),
                    onClick: ()=>{
                        const openWithView = (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux') ? (0, $3mVfX.ViewValues).DELETED_CONTENT : (0, $3mVfX.ViewValues).OPEN;
                        if (!isCommentsPanelShown) showCommentsPanel({
                            openWithView: openWithView
                        });
                        else setCurrentView(openWithView);
                        flags.hideFlag(flags.state.flags[0]?.id);
                    }
                }
            ]
        });
    });
    const editorPluginAIOptionsBuilt = (0, $foVrt.useEditorPluginAIOptions)({
        aiGlobalOptIn: aiGlobalOptIn,
        appearance: 'full-page',
        onFeedbackClicked: handleFeedbackClicked,
        onReviewStateEntered: handleReviewStateEntered,
        onExperienceComplete: handleExperienceEnded,
        onAIProviderChanged: onAIProviderChanged,
        getChannelVariables: getChannelVariables,
        providers: editorPluginAIProviders,
        contentId: contentId,
        onAnnotationsRemoved: handleAnnotationsRemovedByAI,
        usePlatformPrompt: (0, $9wGTI.fg)('aifc_create_enabled')
    }); // When Rovo Access is blocked, pass undefined so the AI plugin is excluded from the preset entirely.
    const editorPluginAIOptions = !isRovoLLMEnabled && (0, $6mKj3.expVal)('platform_editor_rovo_access_ai_opt_in', 'isEnabled', false) ? undefined : editorPluginAIOptionsBuilt;
    const { isTitleFocused: isTitleFocused, shouldFocusEditor: shouldFocusEditor, debounceTitleChangeUpdates: debounceTitleChangeUpdates, focusEditor: focusEditor, onFocusChanged: onFocusChanged } = (0, $1NbQn.useEditorTitleFocus)({
        contentType: contentType,
        editorActions: editorActions,
        isUnpublishedDraft: isUnpublishedDraft
    });
    const updateUnresolvedInlineCommentFn = (0, $WheoQ.useUpdateAnnotations)([
        updateUnresolvedInlineComment,
        setOrderedActiveAnnotationIdList
    ]);
    const annotationProviderOptions = (0, $bAGpj.useEditorAnnotationProviderOptions)({
        pageId: contentId,
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        editorActions: editorActions,
        updateUnresolvedInlineComment: updateUnresolvedInlineCommentFn
    });
    const activityProvider = (0, $fjhaB.useActivityProvider)();
    const isAIPolicyEnabled = isAdminHubAIEnabled && // AdminHub AI is enabled
    isAIEarlyAccessEnabled; // AI Early Access is enabled
    const mentionProvider = (0, $hfIjM.useMentionProvider)(spaceId, undefined, focusedMentionId, {
        includeAgents: isAIPolicyEnabled && (0, $6mKj3.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true)
    });
    const profilecardProvider = (0, $brsfB.useProfilecardProvider)({
        push: push,
        cloudId: cloudId,
        featureFlags: featureFlags,
        userId: userId
    });
    const mentionProps = (0, $cozmU.useMemo)(()=>{
        return {
            profilecardProvider: profilecardProvider
        };
    }, [
        profilecardProvider
    ]);
    const searchProvider = (0, $3W9OD.useSearchProvider)();
    const findReplaceOptions = (0, $0642f0591024f070$export$f31ae08e8dcbd049)();
    const taskDecisionProvider = (0, $bcv7k.getTaskDecisionProvider)();
    const autoformattingProvider = (0, $9EvUR.useAutoformattingProvider)({
        contentId: contentId,
        spaceKey: spaceKey,
        source: (0, $9b9cd112fc8297b9$export$f7109619a5e9e0d6)
    });
    const emojiProvider = (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
        cloudId: cloudId,
        userId: userId || undefined,
        allowAnonymousAccess: true
    });
    const contextIdentifierProvider = (0, $98Cy1.useContextIdentifierProvider)(spaceId, contentId);
    const syncedBlockProvider = (0, $aIZFY.useMemoizedSyncedBlockProviderForEditor)({
        contentId: contentId,
        contentType: contentType,
        focusedMentionId: focusedMentionId,
        spaceId: spaceId,
        editorActions: editorActions
    });
    const matchRoute = (0, $dPJCf.useMatchRoute)();
    const syncedBlockEventHandlers = (0, $cozmU.useMemo)(()=>{
        return (0, $lmNXu.createSmartCardEventHandler)({
            matchRoute: matchRoute,
            push: push
        }, true);
    }, [
        matchRoute,
        push
    ]);
    const { showMacroFallbackFlag: showMacroFallbackFlag } = (0, $8dcb77f48242281e$export$210750141a74fdf7)(flags, isLivePage);
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const { mode: editorContentMode } = (0, $gGHFp.useEditorContentModeValue)({
        contentId: contentId
    });
    const allowCreateWithRovoExtension = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    isRovoButtonEnabled && contentType === 'page' && !isEmbeddedConfluence && (0, $9wGTI.fg)('aifc_create_enabled') && (0, $9wGTI.fg)('cc_fd_cwr_quick_insert_gate'); // Extension V2 API props
    const { extensionOptions: extensionOptions, rendererExtensionOptions: rendererExtensionOptions } = (0, $aPQsP.useExtensionOptions)({
        contentId: contentId,
        contentTitle: title ?? undefined,
        contentType: contentType,
        contentVersion: version,
        contentMode: editorContentMode,
        editorActions: editorActions,
        mentionProvider: mentionProvider,
        spaceKey: spaceKey,
        spaceId: spaceId,
        extensionContextProvider: extensionContextProvider,
        openConnectionsPanel: openConnectionsPanel,
        openConfigPanel: openConfigPanel,
        openSmartButtonConfigPanel: openSmartButtonConfigPanel,
        onCompleteCallback: showMacroFallbackFlag,
        isLivePage: isLivePage,
        allowCreateDatabaseExtension: true,
        allowDatabaseQuickInsert: true,
        allowCreateWhiteboardExtension: true,
        allowCreateWithRovoExtension: allowCreateWithRovoExtension,
        openSmartCreationModal: openSmartCreationModalFromQuickInsert,
        rovoSkillsConfig: rovoSkillsConfig,
        flags: flags,
        aiOptInStatus: optInStatus,
        editorAPI: fullPageEditorPresetAPI ?? undefined,
        setUpsellModalSource: setUpsellModalSource,
        isFullPageEditor: true,
        allowCompanyHubExclusiveExtensions: isCompanyHub,
        allowLegacyMacros: true,
        isCollabEditForLiveUpdatesEnabled: true,
        pageTreeStateUpdater: pageTreeStateUpdater
    });
    const extensionProvidersWithLCM = (0, $cozmU.useMemo)(()=>{
        const outerEditorView = editorActions._privateGetEditorView();
        const LCMExtension = $b56facd6a98e9621$var$_createLCMExtensionProvider(outerEditorView, fullPageEditorPresetAPI, {
            contentMode: editorContentMode
        });
        return [
            ...extensionOptions.extensionProviders,
            LCMExtension
        ];
    }, [
        editorActions,
        fullPageEditorPresetAPI,
        extensionOptions.extensionProviders,
        editorContentMode
    ]);
    const { showRevertDialog: showRevertDialog } = (0, $gKaeO.useEditorRevertDialogContext)();
    const { showSpinner: showSpinner, hideSpinner: hideSpinner, shouldShowSpinner: shouldShowSpinner } = (0, $beK3g.useSpinner)();
    const editorAnnotationsRef = (0, $cozmU.useRef)([]);
    const annotationStateRef = (0, $cozmU.useRef)();
    const { removeCommentQueryParams: removeCommentQueryParams } = (0, $liGyh.useInlineCommentQueryParams)();
    const { addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: true
        }
    });
    const { retrieveEditorTitleAndContent: retrieveEditorTitleAndContent } = (0, $iWI3x.useRetrieveEditorTitleAndContent)({
        onCollabError: handleCollabError,
        editorActions: editorActions
    }); // TODO: add missing configs/providers (possibly not all):
    // presenceProvider
    // legacyImageUploadProvider
    // placeholderBracketHint
    // allowAnalyticsGASV3
    // onDestroy
    const wrapperProps = {
        attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS,
        collabEditState: collabEditState,
        contentId: contentId,
        forceDisableEditor: setForceDisabled,
        isUnpublishedDraft: isUnpublishedDraft,
        contentType: contentType,
        editorActions: editorActions,
        heartbeatError: heartbeatError,
        saveDraftError: isLivePage ? draftSyncActionError : saveDraftError,
        stopHeartbeatCallback: stopHeartbeatCallback,
        isLivePage: isLivePage,
        editorDisabled: disabled
    };
    const performanceTrackingOptions = undefined;
    const editorFeatureFlags = (0, $7BsWq.useEditorFeatureFlags)();
    const editorExperiments = (0, $eLnQS.useEditorFullPageExperiments)(); // Fetch content's classification data
    const contentClassificationMetadata = (0, $bFMG7.useContentClassification)({
        contentId: contentId,
        spaceKeyOverride: spaceKey,
        contentStatusContext: isLivePage ? 'current-and-draft' : 'draft-only'
    });
    (0, $cozmU.useEffect)(()=>{
        // Wait for both collab to be initialized AND ProseMirror DOM to be rendered
        // before attempting to scroll. If we scroll before ProseMirror renders,
        // querySelectorAll('.ProseMirror > *') returns empty and scroll is a no-op.
        if (collabEditInitialized && !disabled && proseMirrorRenderedData !== null) (0, $e6u60.scrollToLastViewedPosition)(contentId);
    }, [
        collabEditInitialized,
        disabled,
        contentId,
        proseMirrorRenderedData
    ]);
    (0, $cozmU.useEffect)(()=>{
        // DTR-1401-CFE
        // HOT-103036
        // If a blogpost is selected from in-editor templates panel, any preset restrictions are lost.
        // This lets the user know to update their blog restrictions.
        const showBlogpostAccessFlag = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).BLOGPOST_PERMISSIONS_NOTICE);
        if (flags && showBlogpostAccessFlag === 'true') {
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $48dba10f6de5f65d$export$a7357cdd1f0b0168).blogpostPermissionsNotice)
            });
            (0, $17wUi.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).BLOGPOST_PERMISSIONS_NOTICE);
        }
    }, [
        flags
    ]);
    (0, $cozmU.useEffect)(()=>{
        document.addEventListener('keydown', ()=>(0, $6eee7623ad82c8da$export$386b0ae74d3f86a0)(triggerAnalyticsEvent), {
            once: true
        });
    }, [
        triggerAnalyticsEvent
    ]);
    const onProseMirrorRendered = (proseMirrorRenderedAttributes)=>{
        proseMirrorRenderedAttributes = proseMirrorRenderedAttributes || {}; // "distortedDuration" gets a true value if page was loaded in the background
        // in a non-visible tab which can lead to inaccurate duration numbers,
        // this can help us to capture only legitimate durations in our metric dashboards.
        // See https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/editor/editor-common/src/utils/performance/measure-render.ts
        const { proseMirrorRenderedFMP: proseMirrorRenderedFMP, proseMirrorRenderedTimestamp: proseMirrorRenderedTimestamp, startTime: startTime, duration: duration, nodes: nodes, nodeSize: nodeSize, nodeSizeBucket: nodeSizeBucket, totalNodes: totalNodes, nodesInViewport: nodesInViewport, distortedDuration: distortedDuration } = proseMirrorRenderedAttributes;
        const topLevelNodeCount = (0, $9wGTI.fg)('analytics_for_large_candidate_pages') ? editorActions._privateGetEditorView()?.state.doc.childCount : undefined;
        setProseMirrorRenderedData({
            proseMirrorRenderedFMP: proseMirrorRenderedFMP,
            proseMirrorRenderedTimestamp: proseMirrorRenderedTimestamp,
            startTime: startTime,
            duration: duration,
            nodes: nodes,
            nodeSize: nodeSize,
            totalNodes: totalNodes,
            topLevelNodeCount: topLevelNodeCount,
            nodesInViewport: nodesInViewport,
            distortedDuration: distortedDuration
        });
        (0, $eFgM7.insm).endHeavyTask('PageLoad');
        if ((0, $6mKj3.expValEquals)('cc_editor_insm_doc_size_stats', 'isEnabled', true)) (0, $eFgM7.insm).session?.addProperties({
            'initial:totalNodes': totalNodes,
            'initial:nodeSize': nodeSize,
            'initial:nodes': nodes,
            'initial:nodesInViewport': nodesInViewport,
            'initial:renderDuration': duration,
            'initial:nodeSizeBucket': nodeSizeBucket
        });
    };
    (0, $cozmU.useEffect)(()=>{
        (0, $3d5UI.waitForGlobal)({
            listener: 'FullPageEditorComponent',
            globalProperty: 'AJS.bind'
        }, ()=>{
            window.AJS.bind('createGASv3Event', (_, data)=>{
                createAnalyticsEvent(data).fire();
            });
        });
        return ()=>{
            (0, $3d5UI.waitForGlobal)({
                listener: 'FullPageEditorComponent',
                globalProperty: 'AJS.unbind'
            }, ()=>{
                window.AJS.unbind('createGASv3Event');
            });
        };
    }, [
        createAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        isAutoConverted && (0, $cQhbe.sendEditorConversionAnalyticsPageEvent)(createAnalyticsEvent, {
            pageAction: (0, $cQhbe.AutoConvertEvent).EDITED,
            source: 'FullPageEditorComponent-Next'
        }, (0, $cQhbe.AutoConvertActionSubject).AUTO_CONVERSION);
    }, [
        isAutoConverted,
        createAnalyticsEvent
    ]);
    const { setOptimisticTitle: setOptimisticTitle, optimisticTitle: optimisticTitle } = (0, $kSPGK.useOptimisticTitleChange)(contentId, title);
    const updateTimestampCache = (0, $1B6Lx.useUpdateLastEditedTimestampVersionCache)();
    const userOffline = collabEditInternetLost || collabEditConnectionTimedOut;
    const handleTitleChange = (0, $26Yfd.useStableCallback)((newTitle)=>{
        if (isLivePage) {
            /*
      	Live pages immediately persist title changes to the backend and change the page title in the UI,
      	unlike regular pages where changing the title only alters the draft version of the page and
      	it is not fully persisted until the user saves the draft.
      	*/ updateContentTypesTitle(newTitle);
            return;
        }
        setOptimisticTitle(newTitle);
        triggerSaveIndicator();
        onTitleChange(newTitle);
        triggerSaveDraft(); // Update timestamp cache so that Last Edited in object header responsively updates
        updateTimestampCache({
            contentId: contentId
        });
    });
    (0, $b3e3043e802ac415$export$befb12a9d0ae7ad9)({
        editorApi: fullPageEditorPresetAPI || undefined,
        contentId: contentId
    });
    const { openPublishModal: openPublishModal } = (0, $6pob4.usePublishModalMountActions)();
    const validatePageAndOpenModal = (0, $1N2OF.usePrePublishTitleValidation)({
        contentId: contentId,
        contentType: contentType,
        isUnpublishedDraft: isUnpublishedDraft,
        flags: flags,
        retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
        onBeforeValidation: (0, $cozmU.useCallback)(()=>{
            saveDraft?.();
        }, [
            saveDraft
        ]),
        onValidationSuccess: openPublishModal,
        analyticsSource: 'LivePagesDetailsPanel',
        optimisticTitle: optimisticTitle,
        checkIfConditionPreventingPublish: checkIfConditionPreventingPublish
    });
    const handleBreadcrumbsClick = (0, $cozmU.useCallback)((destinationUrl)=>{
        // https://product-fabric.atlassian.net/browse/CEMS-2479
        // sync draft and content title with NCS
        // when user click on breadcrumbs to exit the editor
        // so title is up-to-date in page tree
        return new Promise((resolve)=>{
            saveDraft({
                isOnClose: true
            }).then(()=>{
                push(destinationUrl);
                resolve();
            });
        });
    }, [
        push,
        saveDraft
    ]); // [ED-27497] IMPORTANT: This has been moved to the below function. If you add anything here, also add it to the new function.
    // `quickInsertPluginOptions` function in 'packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/quickInsertPluginOptions.ts'.
    const elementBrowser = (0, $cozmU.useMemo)(()=>({
            showModal: true,
            replacePlusMenu: true,
            emptyStateHandler: (0, $f9a65503f42ecec3$export$bc75c05af9bceb4a)
        }), []); // IMPORTANT: If you add a new feature flag here, please make sure to add it to the
    // `featureFlagsPluginOptions` function in 'packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/featureFlagsPluginOptions.ts`.
    const fullPageEditorFeatureFlags = (0, $cozmU.useMemo)(()=>({
            ...editorFeatureFlags,
            ...editorExperiments,
            'basic-text-transformations': // utilise this flag as part of eligibility check to avoid passing AI enablement status as editor prop
            aiGlobalOptIn.status === 'disabled'
        }), [
        editorFeatureFlags,
        editorExperiments,
        aiGlobalOptIn.status
    ]);
    const onPreviewClicked = (0, $cozmU.useCallback)((requestingPreviewAsBlog, stagedMoveParams)=>{
        setPreviewAsBlog(requestingPreviewAsBlog === true);
        setShouldRenderPreview(true);
        setStagedContentId(stagedMoveParams?.newParentPageId);
        setStagedSpaceKey(stagedMoveParams?.newSpaceKey);
    }, [
        setPreviewAsBlog,
        setShouldRenderPreview,
        setStagedContentId,
        setStagedSpaceKey
    ]);
    const onHoverPublish = (0, $cozmU.useCallback)(()=>{
        if (preloadNativeCollabRefetch && (0, $6mKj3.expValEquals)('confluence_publish_ivc_native_collab_query', 'isEnabled', true)) preloadNativeCollabRefetch();
    }, [
        preloadNativeCollabRefetch
    ]);
    const onClickPublish = (0, $26Yfd.useStableCallback)((publishProps)=>{
        if (shouldBlockLiveDocConversion) {
            handlePublishBlockedByApproval();
            return ()=>{};
        }
        if (isLivePage && isCommentsPanelShown && (0, $9wGTI.fg)('confluence_comments_close_panel_on_convert')) hideCommentsPanel();
        return onPublish(publishProps);
    });
    const navigateOnCloseStable = (0, $26Yfd.useStableCallback)(navigateOnClose); // Insert a snippet's contents if there is a snippet id in the url
    (0, $cc1bbf004a9546e5$export$93b2b3f00466b2a0)(fullPageEditorPresetAPI, collabEditInitialized);
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    const { getHeadingLinkPath: getHeadingLinkPath } = (0, $5c5c39eb3a311fda$export$5972bbfae42d8829)({
        contentId: contentId,
        spaceKey: spaceKey,
        contentType: contentType,
        title: title,
        createdDate: createdDate,
        isUnpublishedDraft: isUnpublishedDraft
    }); // When hiding content titles in URLs, also disable heading anchor links to prevent exposing UGC in generated anchor URLs.
    const shouldHideHeadingAnchorLinks = isHideTitleInUrl && (0, $6mKj3.expValEquals)('confluence_hide_content_title_in_url', 'isEnabled', true);
    const editorDisabled = (0, $aa4689242ad06a0b$export$dc599391a17e1b5b)({
        disabled: disabled,
        collabEditInternetLost: collabEditInternetLost,
        internetDisconnected: internetDisconnected,
        api: fullPageEditorPresetAPI
    });
    const extensionRendererViewOptions = (0, $kRAnY.useExtensionRendererViewOptions)({
        getExtensionHandlers: rendererExtensionOptions?.getExtensionHandlers,
        isLivePage: isLivePage,
        contentId: contentId,
        spaceKey: spaceKey
    });
    const getExtensionHeight = (0, $jFkNO.useExtensionNodeParams)();
    const { isDesktop: isDesktop } = (0, $2JYae.useIsDesktop)();
    const finalExtensionProviders = extensionProvidersWithLCM;
    const ssrExtensionHandlers = (0, $OCz5m.useEditorSSRExtensionHandlers)(contentId, spaceKey, finalExtensionProviders);
    const FullPageEditorComponentWrapper = isCompanyHub ? (0, $6gbpH.HubEditorWrapper) : $b56facd6a98e9621$var$FullPageEditorWrapper;
    const { canUndo: canUndo, canRedo: canRedo, undo: undo, redo: redo, activateFindReplace: activateFindReplace } = (0, $767f50cadbc92220$export$4da6e3f66c58b328)(fullPageEditorPresetAPI);
    const editorActionsProps = (0, $9wGTI.fg)('aifc_create_enabled') || (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? {
        canUndo: canUndo,
        canRedo: canRedo,
        undo: undo,
        redo: redo,
        activateFindReplace: activateFindReplace
    } : undefined;
    const allowInlineComments = isEmbeddedConfluence ? hasInlineComments : true;
    const shouldHideCommentsInEmbeddedLivePage = isLivePage && isNativeEmbed && ((0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) || (0, $9wGTI.fg)('platform_native_embeds_rollout_non_maui_experience'));
    const allowPageComments = !isEmbeddedConfluence || hasPageComments && !shouldHideCommentsInEmbeddedLivePage;
    const shouldApplyAIPlannerBridgeRouteEditorOverrides = !!enableAIPlannerBridgeRouteEditorOverrides && (0, $9wGTI.fg)('confluence_ai_planner_bridge_route');
    const contextualFormattingModeForEditor = shouldApplyAIPlannerBridgeRouteEditorOverrides ? contextualFormattingMode : undefined;
    const { isTemplateBrowserEnabled: isTemplateBrowserEnabled, isTemplateBrowserPanelEnabled: isTemplateBrowserPanelEnabled, isBlankPageQuickActionsEnabled: isBlankPageQuickActionsEnabled } = (0, $9bL1w.useEmbeddedEditPageFeatures)();
    const { hasModernHeader: hasModernHeader, hideHelpButton: hideHelpButton } = (0, $cxu5H.useEmbeddedViewPageFeatures)();
    const showEmbeddedModernHeader = isEmbeddedConfluence ? hasModernHeader : !isEmbeddedConfluence;
    const shouldHideHelpWidget = isEmbeddedConfluence && (hideHelpButton || isLivePage && isNativeEmbed && ((0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) || (0, $9wGTI.fg)('platform_native_embeds_rollout_non_maui_experience')));
    const showHelpWidget = !shouldHideHelpWidget;
    const shouldHideLiveDocEmbeddedEditorToolbar = isLivePage && isEmbeddedConfluence && isNativeEmbed && ((0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) || (0, $9wGTI.fg)('platform_native_embeds_rollout_non_maui_experience'));
    const setSsrRenderMark = (0, $cozmU.useCallback)(()=>{
        (0, $1fcefd278c33801b$export$5dc6b08aaa4bcf54)({
            segmentName: $b56facd6a98e9621$var$SSR_TRACE_SEGMENT_NAME,
            startTimestamp: firstRenderStartTimestampRef.current,
            endTimestamp: performance.now()
        });
    }, []);
    const hasAudioButton = (0, $fzhfU.useHasAudioButton)(isAIEnabledForContent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6H0Pg.default), {
        name: "full-page-editor-component"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f9dc71ade1ee2d5f$export$b5e4a2fe6178c584), {
        editorApi: fullPageEditorPresetAPI
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dE9mB.EditorContextPanelContextProvider), {
        editorAPI: fullPageEditorPresetAPI
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $40pD8.ClassificationModalContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dWbBL.EditorContextContentCreationPanelWrapper), {
        cancelDebouncedSaveDraft: cancelDebouncedSaveDraft,
        collabEditInitialized: collabEditInitialized,
        contentId: contentId,
        contentType: contentType,
        draftShareId: draftShareId,
        editorActions: editorActions,
        hideSpinner: hideSpinner,
        isUnpublishedDraft: isUnpublishedDraft,
        renderPanel: !shouldRenderPreview,
        showSpinner: showSpinner,
        title: title
    }, ({ isContentCreationPanelOpen: isContentCreationPanelOpen, contentCreationPanelMode: contentCreationPanelMode, onClickOpenContentCreationPanel: onClickOpenContentCreationPanel, beforeUpdateRequest: beforeUpdateRequest, postUpdateRequest: postUpdateRequest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2HGN8.ContentAppearanceContextProvider), {
            contentId: contentId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2HGN8.ContentAppearanceContextConsumer), null, ({ contentAppearance: contentAppearance })=>{
            let appearance = $b56facd6a98e9621$var$getContentAppearance(contentAppearance, draftAppearance);
            if (isCompanyHub) // Company Hub editors no longer have the option of changing page width,
            // as content topper is removed. For users who had previously set Company
            // Hub page to 'full-width' and can no longer change it back, we force it to
            // 'full-page' to fix unexpected layout issues and allow editors to
            // set the width on individual extension instances.
            appearance = 'full-page';
            const referentialityContext = (0, $6dTPw.getReferentialityContext)(createAnalyticsEvent, contentId, appearance, ssrExtensionHandlers, extensionRendererViewOptions, getExtensionHeight); // IMPORTANT: If you change the code below, please also update the
            // platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/placeholderPluginOptions/placeholderPluginOptions.ts
            const placeholderText = !viewMode && (isLivePage && isMarkdownMode ? (0, $48dba10f6de5f65d$export$a7357cdd1f0b0168).editorEmptyDocumentMarkdownPlaceholder : $b56facd6a98e9621$var$_getPlaceholderText({
                featureFlags: featureFlags,
                isAIEnabledForContent: isAIEnabledForContent
            }));
            const metaKey = (0, $4tOXV.isMac)() ? "\u2318" : 'Ctrl';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(FullPageEditorComponentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                ref: agenticEditorRef,
                "data-agentic-mode": isAgenticMode
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c06us.BlankPageQuickActionsProvider), {
                spaceKey: spaceKey
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7f6xB.HeadingLinksStyleWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $btQhd.EditorWrapper), wrapperProps, isLivePage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eu3xH.PublishModalMountPoint), {
                onClickPublish: onClickPublish,
                onClickPreview: onPreviewClicked,
                retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
                publishButtonDisabled: false,
                title: title ?? draftTitle,
                userViewingPreview: false,
                isUnpublishedDraft: false,
                contentType: contentType,
                shouldShowWorldIcon: false,
                shouldShowFooterButtons: false,
                isConvertToPageDialog: true,
                isMarkdownMode: isMarkdownMode,
                onHoverPublish: onHoverPublish
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k31VO.PublishModalKeyboardShortcuts), {
                contentId: contentId,
                contentType: contentType,
                isUnpublishedDraft: isUnpublishedDraft,
                hasEditPermission: hasEditPermission,
                flags: flags,
                retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
                saveDraft: saveDraft,
                checkIfConditionPreventingPublish: checkIfConditionPreventingPublish
            })), (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $642dd5941c63cbaa$export$4a2ff2a211b229b0), {
                isLivePage: isLivePage,
                isEmbeddedConfluence: isEmbeddedConfluence,
                viewMode: viewMode,
                spaceKey: spaceKey,
                editorFullPagePresetAPI: fullPageEditorPresetAPI,
                triggerAnalyticsEvent: triggerAnalyticsEvent,
                contentId: contentId,
                version: version,
                isShowingOfflineBanner: collabEditInternetLost,
                isAgenticMode: isAgenticMode,
                onExitAgenticMode: handleExitAgenticMode,
                onDismissAgenticMode: handleDismissAgenticMode,
                agenticModeStartTime: agenticModeStartTime,
                aiInvocationCountRef: aiInvocationCountRef,
                aiInvocationSurfacesRef: aiInvocationSurfacesRef
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isAgenticMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2543a86ff2c253ce$export$ac98ab11e0df3bec), {
                onExitAgenticMode: handleExitAgenticMode,
                onDismiss: handleDismissAgenticMode,
                agenticModeStartTime: agenticModeStartTime,
                aiInvocationCountRef: aiInvocationCountRef,
                aiInvocationSurfacesRef: aiInvocationSurfacesRef
            }) : /* eslint-disable-next-line confluence-feature-gating/no-preconditioning -- pre-existing pattern, isLivePage check required before gate */ !isLivePage && (0, $9wGTI.fg)('aifc_create_enabled') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fwwrH.SmartCreateFeedbackBannerLoader), {
                contentType: "page"
            })), !isLivePage && (0, $9wGTI.fg)('analytics_for_large_candidate_pages') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b606f9cd4d9e530a$export$a9a9aa46de7c9f45), {
                contentId: contentId,
                spaceKey: spaceKey,
                flags: flags,
                draftBody: draftBody ?? null,
                proseMirrorRenderedData: proseMirrorRenderedData
            }), showEmbeddedModernHeader && !shouldHideLiveDocEmbeddedEditorToolbar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3o3i5.EditorObjectHeaderContextProvider), {
                value: {
                    saveDraft: saveDraft,
                    navigateOnClose: navigateOnClose,
                    triggerAnalyticsEvent: triggerAnalyticsEvent,
                    version: version,
                    editorActions: editorActions,
                    title: title,
                    onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
                    isContentCreationPanelOpen: isContentCreationPanelOpen,
                    contentCreationPanelMode: contentCreationPanelMode,
                    retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
                    showRevertDialog: showRevertDialog,
                    onPreviewClicked: onPreviewClicked,
                    hasEditPermission: hasEditPermission,
                    isPublishingContent: isPublishingContent,
                    userOffline: userOffline,
                    forceDisabled: forceDisabled,
                    editorTitle: title ?? draftTitle,
                    collabLimitReached: collabLimitReached,
                    collabEditConnected: collabEditConnected,
                    onClickPublish: onClickPublish,
                    shouldRenderPreview: shouldRenderPreview,
                    isUnpublishedDraft: isUnpublishedDraft,
                    validatePageAndOpenModal: validatePageAndOpenModal,
                    checkIfConditionPreventingPublish: checkIfConditionPreventingPublish,
                    ...editorActionsProps,
                    viewMode: viewMode,
                    onHoverPublish: onHoverPublish
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
                name: (0, $irVI7.OBJECT_HEADER_EXPERIENCE)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JJ6wk.ContentTypesHeader), {
                contentId: contentId
            }), isLivePage && (0, $9wGTI.fg)('aifc_create_enabled') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fwwrH.SmartCreateFeedbackBannerLoader), {
                contentType: "page"
            })), !shouldRenderPreview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $79befcd2c8d3c320$export$8626b7a3aacc0076), null), disallowFirstPublish && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e48f7422194c5f7f$export$39e2ccf4b3f86676), {
                isOpen: approvalPublishBlockedModal === 'firstPublish',
                onClose: handleCloseApprovalPublishBlockedModal
            }), shouldBlockLiveDocConversion && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bc1oR.LiveDocConversionBlockedModal), {
                isOpen: approvalPublishBlockedModal === 'liveDocConversion',
                onClose: handleCloseApprovalPublishBlockedModal
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8uySb.EditorDisplayWrapper), {
                "data-testid": "full-page-editor-style",
                isHidden: shouldRenderPreview,
                isEditorActionBarRendered: true,
                isToolbarAifcEnabled: (0, $9wGTI.fg)('aifc_create_enabled')
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5b566a57f88868ac$export$6d9f0d80d291faa5), {
                editorType: "next",
                triggerAnalyticsEvent: triggerAnalyticsEvent,
                collabEditState: collabEditState,
                collabEditInternetLost: collabEditInternetLost,
                collabEditConnectionTimedOut: collabEditConnectionTimedOut,
                willEditorDisable: !editorDisabled,
                contentType: contentType,
                contentId: contentId,
                spaceId: spaceId,
                fullPageEditorPresetAPI: fullPageEditorPresetAPI,
                isViewMode: viewMode || false,
                isLivePage: isLivePage,
                isDesktop: isDesktop
            }), showHelpWidget && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $022566d7a48da434$export$4d07d1c131526670), {
                contentId: contentId,
                isContentCreationPanelOpen: isContentCreationPanelOpen,
                onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
                editorActions: editorActions,
                isShowingOfflineBanner: collabEditInternetLost,
                version: version,
                spaceKey: spaceKey,
                editorApi: fullPageEditorPresetAPI,
                handleTitleChange: handleTitleChange,
                isMarkdownMode: isMarkdownMode,
                isMarkdownModeSyntaxViewToggled: isMarkdownModeSyntaxViewToggled
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f793b569ac081794$export$60e4773fef02e3c), {
                name: "onBeforeEditor"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4KFTW.MacroExperienceStart), {
                contentId: contentId,
                mode: (0, $5kjCz.EDITOR),
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iNYtG.PageCommentsPubSubHandler), {
                contentId: contentId,
                contentType: contentType
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
                channel: "*",
                onEvent: onEditorAnalyticsEvent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bRTjQ.EditorAnalyticsListener), {
                contentId: contentId,
                contentType: contentType,
                source: "pageAndBlogEditor",
                collabService: (0, $gkIgp.CollabServiceProperty).NCS,
                onProseMirrorRendered: onProseMirrorRendered,
                isGuest: isExternalCollaborator
            }, // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            proseMirrorRenderedData && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) && // UFOInteractionIgnore prevents the useAllCommentsDataQuery hold
            // registered by CommentsDataBackgroundLoader from blocking the
            // parent full-page-editor-component TTAI measurement. This
            // component is designed to load in the background and should
            // not gate page interactivity.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jb2gB.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hd53J.CommentsDataBackgroundLoader), {
                key: `CommentsDataBackgroundLoader-${contentId}`,
                contentId: contentId
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6b433f129bb94645$export$5acade271146d69c), {
                value: {
                    forceDisabled: forceDisabled,
                    userOffline: userOffline,
                    collabLimitReached: collabLimitReached,
                    contentId: contentId,
                    contentType: contentType,
                    isContentCreationPanelOpen: isContentCreationPanelOpen,
                    isUnpublishedDraft: isUnpublishedDraft,
                    onClickPublish: onClickPublish,
                    onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
                    onPreviewClicked: onPreviewClicked,
                    saveDraft: saveDraft,
                    spaceKey: spaceKey,
                    showRevertDialog: showRevertDialog,
                    retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
                    isPublishingContent: isPublishingContent,
                    isSingleUserSession: isSingleUserSession,
                    triggerAnalyticsEvent: triggerAnalyticsEvent,
                    navigateOnClose: navigateOnCloseStable,
                    title: title,
                    editorActions: editorActions,
                    disabled: disabled || collabLimitReached,
                    isTitleFocused: isTitleFocused,
                    collabEditState: collabEditState,
                    shouldRenderPreview: shouldRenderPreview,
                    shouldShowRecentSpotlight: shouldShowRecentSpotlight,
                    checkIfConditionPreventingPublish: checkIfConditionPreventingPublish,
                    flags: flags,
                    createAnalyticsEvent: createAnalyticsEvent,
                    hasEditPermission: hasEditPermission,
                    ellipsisEditorActions: editorActionsProps
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $82bb8752b1a17b39$export$f7b2b60e23c443f6), {
                value: {
                    contentComponentsTitle: title ?? draftTitle ?? cachedTitle,
                    contentComponentsDisabled: disabled || collabLimitReached || !collabEditInitialized || isDraftLockedForEditing,
                    isDraftLockedForEditing: isDraftLockedForEditing,
                    handleTitleChange: handleTitleChange,
                    breadcrumbsClickHandler: handleBreadcrumbsClick,
                    beforeUpdateRequest: beforeUpdateRequest,
                    postUpdateRequest: postUpdateRequest
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKSlH.MultiMacroQueryContainer), {
                contentId: contentId,
                featureFlags: featureFlags,
                readFragmentInterop: readFragmentInterop,
                contentRendererMode: (0, $5kjCz.EDITOR)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $36be47a9ed41f8db$export$6124ca97c5c9fe4d), {
                contentId: contentId,
                flags: flags,
                isLivePage: isLivePage,
                isMentionsNotificationsEnabled: isLivePage || isClassicMentionsNotificationsEnrolled,
                editorActions: editorActions
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9jl6v.InlineCommentsProvider), null, (0, $6mKj3.expValEquals)('confluence_inline_reactions', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c201c0cab0d4ebd5$export$8fed2fc2ec67a868), {
                contentId: contentId,
                contentType: contentType === 'blogpost' ? 'blogpost' : 'page',
                editorActions: editorActions,
                pageMode: isLivePage ? 'live' : 'edit',
                triggerAnalyticsEvent: triggerAnalyticsEvent,
                updateUnresolvedInlineComment: updateUnresolvedInlineCommentFn
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fNzRA.ObjectCommentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fMO7O.GuestMentionsNotificationsWrapper), {
                dialogs: dialogs,
                flags: flags
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lmEhP.EditorLinkingFeatures), {
                options: $b56facd6a98e9621$var$CARD_OPTIONS,
                viewMode: viewMode,
                isLivePage: isLivePage
            }, (editorLinkingProps)=>{
                // TODO: fix me. ignored to get an unrelated refactor in: React Hooks must be called in a React function component or a custom React Hook function
                /* eslint-disable react-hooks/rules-of-hooks */ const mainButtonsContext = (0, $6b433f129bb94645$export$87f05b83083ffee2)(); /* eslint-enable react-hooks/rules-of-hooks */ 
                const primaryToolBarComponent = !(shouldApplyAIPlannerBridgeRouteEditorOverrides && disablePrimaryToolbar) && !showEmbeddedModernHeader && !shouldHideLiveDocEmbeddedEditorToolbar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $02a52aafb1fafdd7$export$170e4ca3217957a2), {
                    ...mainButtonsContext,
                    allowInlineComments: allowInlineComments,
                    allowPageComments: allowPageComments
                }) : undefined;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXhAV.QuickReload), {
                    contentId: contentId,
                    contentType: contentType,
                    // package on what a more correct lastPollTime value would be.
                    // eslint-disable-next-line check-react-ssr-usage/no-nondeterministic-jsx-values
                    lastPollTime: Date.now(),
                    pageMode: isLivePage ? (0, $fSC8h.PageMode).LIVE : (0, $fSC8h.PageMode).EDITOR,
                    showCommentsPanel: showCommentsPanel
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
                    markErrorCriticalInSSR: true,
                    attribution: (0, $3IBnw.Attribution).EDITOR_CORE
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $639a5b7d5146574b$export$3b07c6dfbdf7e5bd), {
                    onSSRMeasure: $b56facd6a98e9621$var$recordSSRMeasureWithPrefix,
                    setEditorAPI: setEditorApi,
                    onShowSuggestionsSidebar: onShowSuggestionsSidebar,
                    // ComposableEditor
                    referentialityContext: referentialityContext,
                    editorPluginAIOptions: shouldApplyAIPlannerBridgeRouteEditorOverrides && disableEditorAI ? undefined : editorPluginAIOptions,
                    aiGlobalOptIn: aiGlobalOptIn,
                    editorPluginAIFeedbackHandlers: editorPluginAIFeedbackHandlers,
                    ...extensionOptions,
                    extensionProviders: extensionProvidersWithLCM,
                    getExtensionHeight: getExtensionHeight,
                    allowConfluenceInlineComment: allowInlineComments,
                    allowFindReplace: !collabEditInternetLost && findReplaceOptions,
                    defaultValue: draftBody ?? undefined,
                    elementBrowser: elementBrowser,
                    media: mediaOptions,
                    mention: mentionProps,
                    placeholder: placeholderText && intl.formatMessage(placeholderText, {
                        key: metaKey
                    }),
                    waitForMediaUpload: true,
                    __rendererExtensionOptions: extensionRendererViewOptions,
                    appearance: appearance ?? 'full-page',
                    contentMode: (0, $6mKj3.expValEquals)('cc_editor_ai_content_mode', 'forceAll', true) ? 'compact' : editorContentMode,
                    disabled: isTitleFocused || editorDisabled || collabLimitReached,
                    onChange: handleDocChange,
                    shouldFocus: !!title && shouldFocusEditor,
                    onEditorReady: onEditorReady,
                    activityProvider: activityProvider,
                    annotationProviders: allowInlineComments ? annotationProviderOptions : undefined,
                    autoformattingProvider: autoformattingProvider,
                    collabEditProvider: collabEditProvider,
                    collabEdit: collabEdit,
                    contextIdentifierProvider: contextIdentifierProvider,
                    emojiProvider: emojiProvider,
                    mentionProvider: mentionProvider,
                    searchProvider: searchProvider,
                    taskDecisionProvider: taskDecisionProvider,
                    syncedBlockProvider: syncedBlockProvider,
                    contentComponents: $b56facd6a98e9621$var$_getContentComponents({
                        contentId: contentId,
                        debounceTitleChangeUpdates: debounceTitleChangeUpdates,
                        focusEditor: focusEditor,
                        onFocusChanged: onFocusChanged,
                        userOffline: userOffline,
                        linkCreation: linkCreation === 'true',
                        editorPluginAIFeedbackHandlers: editorPluginAIFeedbackHandlers,
                        isAdminHubAIEnabled: isAdminHubAIEnabled,
                        hasAudioButton: hasAudioButton,
                        hideSpinner: hideSpinner,
                        templateSuggestionsRef: templateSuggestionsRef,
                        templateButtonRef: templateButtonRef,
                        editorActions: editorActions,
                        isTitleFocused: isTitleFocused,
                        disabled: disabled,
                        viewMode: viewMode,
                        contentClassificationMetadata: contentClassificationMetadata,
                        appearance: appearance,
                        spaceKey: spaceKey,
                        title: title,
                        cancelDebouncedSaveDraft: cancelDebouncedSaveDraft,
                        showSpinner: showSpinner,
                        onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
                        isUnpublishedDraft: isUnpublishedDraft,
                        featureFlags: featureFlags,
                        fullPageEditorPresetAPI: fullPageEditorPresetAPI,
                        showBlankPageQuickActions: showBlankPageQuickActions,
                        isLivePage: isLivePage,
                        version: version,
                        isEditorEmpty: isEditorEmpty,
                        collabEditInitialized: collabEditInitialized,
                        shouldRenderPreview: shouldRenderPreview,
                        isEditorAnnotationProviderManagersEnabled: (0, $9wGTI.fg)('confluence_frontend_editor_annotation_manager'),
                        editorApi: fullPageEditorPresetAPI,
                        contentType: contentType,
                        onTitleChange: onTitleChange,
                        loadingPriority: loadingPriority,
                        isRovoButtonEnabled: isRovoButtonEnabled,
                        editorSessionId: editorSessionId,
                        editorActionsProps: editorActionsProps,
                        isSeamlessTransitionInProgress: (0, $9wGTI.fg)('confluence_frontend_transition_preloading_system') && isLiveDocSeamlessTransitioning,
                        hasByLineContributors: hasByLineContributors,
                        hasByLineExtensions: hasByLineExtensions,
                        hasReactions: hasReactions,
                        hasCommentSessions: hasCommentSessions,
                        hasPageComments: hasPageComments,
                        isEmbeddedConfluence: isEmbeddedConfluence,
                        isTemplateBrowserEnabled: isTemplateBrowserEnabled,
                        isTemplateBrowserPanelEnabled: isTemplateBrowserPanelEnabled,
                        isBlankPageQuickActionsEnabled: isBlankPageQuickActionsEnabled,
                        isRovoLLMEnabled: isRovoLLMEnabled,
                        isMarkdownMode: isMarkdownMode,
                        isMarkdownModeSyntaxViewToggled: isMarkdownModeSyntaxViewToggled,
                        ...isRovoLLMEnabled && (0, $6mKj3.isExperimentEnabled)('cwr_blank_object_experiment') && {
                            customPlaceholderOverride: customPlaceholderOverride,
                            onCreateWithRovoClick: handleCreateWithRovo,
                            shouldShowCreateWithRovoExperience: shouldShowCreateWithRovoExperience,
                            onPromptMouseEnter: onPromptMouseEnter,
                            onPromptMouseLeave: onPromptMouseLeave,
                            onPromptClick: onPromptClick,
                            onPromptSubmit: onPromptSubmit,
                            onDismissCwr: onDismissCwr,
                            hasSubmittedCwrPrompt: hasSubmittedCwrPrompt,
                            onInputEmpty: onInputEmpty,
                            onCwrInputContentChange: onCwrInputContentChange,
                            hasCwrPromptInputContent: hasCwrPromptInputContent,
                            orgId: orgId,
                            cwrPromptInputRef: cwrPromptInputRef,
                            isInlineAIOpen: isInlineAIOpen
                        }
                    }),
                    contextPanel: $b56facd6a98e9621$var$_getContextPanelComponent(),
                    featureFlags: fullPageEditorFeatureFlags,
                    performanceTracking: performanceTrackingOptions,
                    ...editorLinkingProps,
                    viewMode: viewMode || isDraftLockedForEditing ? 'view' : 'edit',
                    __isRemixHidden: !isRovoLLMEnabled,
                    __isRovoLLMEnabled: isRovoLLMEnabled,
                    __remixDisabledReason: remixDisabledReason,
                    __livePage: isLivePage,
                    isEmbeddedConfluence: isEmbeddedConfluence,
                    flags: flags,
                    primaryToolbarComponents: primaryToolBarComponent,
                    hasEditPermission: hasEditPermission,
                    requestToEditContent: requestToEditContent,
                    hasRequestedEditPermission: hasRequestedEditPermission,
                    getHeadingLinkPath: getHeadingLinkPath,
                    shouldHideHeadingAnchorLinks: shouldHideHeadingAnchorLinks,
                    contentId: contentId,
                    spaceId: spaceId,
                    spaceKey: spaceKey,
                    contentType: contentType,
                    snippetExtensionList: snippetExtensionList,
                    isAIEnabledForContent: isAIEnabledForContent,
                    showEmbeddedModernHeader: showEmbeddedModernHeader,
                    contextualFormattingMode: contextualFormattingModeForEditor,
                    enableAIPlannerRemoteTextHighlight: shouldApplyAIPlannerBridgeRouteEditorOverrides && (0, $9wGTI.fg)('confluence_ai_planner_diff_highlight'),
                    isCompanyHub: isCompanyHub,
                    syncedBlockEventHandlers: syncedBlockEventHandlers
                })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dLc9m.EditorCommentShortcutListener), {
                    contentId: contentId,
                    viewMode: viewMode,
                    editorApi: fullPageEditorPresetAPI
                }), proseMirrorRenderedData !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8HrX3.TaskScrollComponent), null));
            })))))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $beK3g.Spinner), {
                shouldShowSpinner: shouldShowSpinner || // eslint-disable-next-line confluence-feature-gating/no-preconditioning
                (0, $9wGTI.fg)('confluence_frontend_transition_preloading_system') && isLiveDocSeamlessTransitioning,
                isOverlayTransparent: !shouldShowSpinner && (0, $9wGTI.fg)('confluence_frontend_transition_preloading_system') && isLiveDocSeamlessTransitioning
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(AIOptInModal, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fE1Ao.EditorRevertDialog), {
                contentId: contentId,
                spaceKey: spaceKey,
                isUnpublishedDraft: isUnpublishedDraft,
                cancelDebouncedSaveDraft: cancelDebouncedSaveDraft
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1uFh.OnboardingEditorModalPrompt), {
                onTitleChange: onTitleChange,
                handlePublish: ()=>onPublish({
                        suppressNotifyWatchers: false
                    })()
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $11b8024921ea2f1a$export$a1cd66d9f8e156b1), {
                contentId: contentId,
                spaceKey: spaceKey,
                setCheckIfConditionPreventingPublish: assignConditionalFunction
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cvzKy.PageLoadWrapper), {
                disabled: disabled,
                contentId: contentId,
                isCreate: isUnpublishedDraft,
                proseMirrorRenderedData: proseMirrorRenderedData,
                editSource: editSource,
                extractedCollabEditProvider: extractedCollabEditProvider,
                isLivePage: isLivePage,
                customPerfData: customPerfData,
                draftBody: draftBody
            }), shouldRenderPreview ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMRhJ.RendererExtensionContext).Provider, {
                value: rendererExtensionOptions
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kGaEh.PreviewPageComponent), {
                contentId: contentId,
                spaceKey: spaceKey,
                stagedContentId: stagedContentId,
                stagedSpaceKey: stagedSpaceKey,
                contentType: contentType,
                contentAppearance: contentAppearance,
                title: title,
                editorActions: editorActions,
                showTemplateVariablesInPreview: true,
                changeEditorMode: ()=>setShouldRenderPreview(false),
                Renderer: (0, $e8Lxy.PageContentRenderer),
                isPageContentRenderer: true,
                editorType: (0, $lWVgZ.EditorTypes).NCS,
                previewAsBlog: previewAsBlog,
                contentClassificationMetadata: contentClassificationMetadata
            })) : null, contentType === 'page' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cmBjr.ConvertToLivePageFlag), null), isLivePage && (0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $28307a730c3d5a3b$export$756c5857647e0244), null), (0, $6mKj3.expVal)('confluence_modernized_move_dialog', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfmjq.MovePageSuccessFlag), null), (!isEmbeddedConfluence || shouldRegisterAIPlannerRovoBridge) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bK3oZ.RovoBridgeCommandListener), {
                contentId: contentId,
                contentLocation: "global",
                editorAPI: fullPageEditorPresetAPI,
                setEditorDisabled: setForceDisabled,
                mediaProvider: mediaOptions?.provider,
                onTitleChange: hasSubmittedCwrPrompt ? handleTitleChange : undefined,
                onStreamEnd: onCwrStreamEnd,
                isPreviewMode: shouldRenderPreview,
                skipAiExperienceRequirement: shouldRegisterAIPlannerRovoBridge
            }))), $b56facd6a98e9621$var$_getEditorContextConnectionsPanel({
                referentialityContext: referentialityContext,
                connectionsPanelActiveNodeLocalId: connectionsPanelActiveNodeLocalId,
                setConnectionsPanelActiveNodeLocalId: setConnectionsPanelActiveNodeLocalId,
                closeConnectionsPanel: closeConnectionsPanel
            }), // This FF controls if the right rail config panel is available in when editing a page
            isSmartButtonAllowed ? $b56facd6a98e9621$var$_getEditorContextSmartButtonConfigPanel({
                smartButtonActiveNodeLocalId: smartButtonActiveNodeLocalId,
                closeSmartButtonConfigPanel: closeSmartButtonConfigPanel,
                fullPageEditorPresetAPI: fullPageEditorPresetAPI
            }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f04c510354797dd3$export$7a4297a73e39e6ad), {
                localId: activeNodeLocalId || '',
                closeSelf: closeConfigPanel,
                editorApi: fullPageEditorPresetAPI || undefined,
                contentId: contentId,
                upsellModalSource: upsellModalSource,
                setUpsellModalSource: setUpsellModalSource
            }))));
        })))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a00e1ed200f6db86$export$d1f7cc0755451204), {
        contentId: contentId,
        contentType: contentType,
        isEmbeddedConfluence: isEmbeddedConfluence,
        isLivePage: isLivePage,
        isUnpublishedDraft: isUnpublishedDraft,
        isEditorEmpty: isEditorEmpty,
        title: title,
        draftTitle: draftTitle,
        isAIEnabledForContent: isAIEnabledForContent,
        handleTitleChange: handleTitleChange,
        collabEditInitialized: collabEditInitialized,
        collabEditInternetLost: collabEditInternetLost,
        internetDisconnected: internetDisconnected,
        extractedCollabEditProvider: extractedCollabEditProvider,
        fullPageEditorPresetAPI: fullPageEditorPresetAPI,
        isDocumentActive: isDocumentActive,
        focusedCommentId: focusedCommentId,
        replyToCommentId: replyToCommentId,
        handleUseFocusedCommentGQLError: handleUseFocusedCommentGQLError,
        annotationStateRef: annotationStateRef,
        addCommentInCache: addCommentInCache,
        deleteCommentInCache: deleteCommentInCache,
        updateUnresolvedInlineCommentFn: updateUnresolvedInlineCommentFn,
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        proseMirrorRenderedData: proseMirrorRenderedData,
        showBlankPageQuickActions: showBlankPageQuickActions,
        hasSubmittedCwrPrompt: hasSubmittedCwrPrompt,
        shouldShowCreateWithRovoExperience: shouldShowCreateWithRovoExperience,
        isRovoLLMEnabled: isRovoLLMEnabled,
        isMarkdownMode: isMarkdownMode,
        onSpaceKeyPressed: handleCreateWithRovo,
        flags: flags,
        intl: intl,
        disabled: disabled,
        isTitleFocused: isTitleFocused,
        shouldRenderPreview: shouldRenderPreview,
        collabEditError: collabEditError,
        collabLimitReached: collabLimitReached,
        heartbeatError: heartbeatError,
        removeCommentQueryParams: removeCommentQueryParams,
        setEditorAnnotations: setEditorAnnotations,
        getSortedMarkerRefs: (0, $aHcFH.getSortedMarkerRefs),
        setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList,
        editorAnnotationsRef: editorAnnotationsRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hwk5r.DocumentEditPageTitle), {
        contentType: contentType,
        isCreatingNew: isUnpublishedDraft,
        spaceKey: spaceKey,
        title: title,
        isLivePage: isLivePage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f8ea506e3a40865e$export$28f25e906763db1e), {
        contentId: contentId,
        isPublishingContent: isPublishingContent,
        isFirstParticipant: isFirstParticipant,
        editorPresetAPI: fullPageEditorPresetAPI
    }), printLockout, undefined, shouldShowSpotlight && newLinkTypes.length > 0 && (0, $9wGTI.fg)('link-paste-spotlight-experiment-gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $46e670f6dbd146ec$export$83ad660b287906ed), {
        detectedLinks: detectedLinks,
        newLinkTypes: newLinkTypes,
        newLinks: newLinks,
        onClose: closeSpotlight,
        cloudId: cloudId,
        atlassianAccountId: userId ?? null,
        analyticsContext: "editor"
    }), (0, $6mKj3.expValEquals)('confluence_move_to_personal_space_nudge', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $14ugT.MoveToPersonalSpaceFlagTrigger), {
        contentId: contentId,
        contentType: contentType,
        isLivePage: isLivePage,
        spaceKey: spaceKey
    }));
};
const $b56facd6a98e9621$export$63318eb7b01b69fa = (0, $ea0f0e1bfeeed9fe$export$72f7c3354b160bdb)((0, $3IZob.withDocChangeContext)($b56facd6a98e9621$var$withEditorContext((0, $awIbt.withEditorActions)((0, $7aRa9.withFlags)((0, $inDu6.withDialogs)((0, $ecUYt.withPageTreeStateUpdater)($b56facd6a98e9621$var$FullPageEditorComponentImpl)))))));
module.exports["FullPageEditorComponent"] = $b56facd6a98e9621$export$63318eb7b01b69fa;

});

parcelRegister("bdpeX", function(module, exports) {

var $54Kws = parcelRequire("54Kws");

class $88516670672fc955$export$2e2bcd8739ae039 {
    getExtensions() {
        return this.manifestsPromise;
    }
    async preload() {
        this.manifestsCache = await this.getExtensions();
        const preloadCalls = [];
        for (const manifest of this.manifestsCache){
            const nodes = manifest?.modules?.nodes;
            if (nodes) Object.values(nodes).forEach((node)=>{
                preloadCalls.push(node?.preloadRender?.());
            });
        }
        await Promise.allSettled(preloadCalls);
    }
    getPreloadedExtension(type, key) {
        if (!this.manifestsCache) return;
        return this.getExtensionFromManifest(this.manifestsCache, type, key);
    }
    async getExtension(type, key) {
        return this.getExtensionFromManifest(await this.manifestsPromise, type, key);
    }
    getExtensionFromManifest(manifests, type, key) {
        const extension = manifests.find((manifest)=>manifest.type === type && manifest.key === key);
        if (!extension) throw new Error(`Extension with type "${type}" and key "${key}" not found!`);
        return extension;
    }
    async search(keyword) {
        const extensions = (await this.manifestsPromise).filter((manifest)=>manifest.title.toLowerCase().includes(keyword.toLowerCase()));
        return extensions;
    }
    async getAutoConverter() {
        if (this.autoConvertHandlers) return this.autoConvertHandlers;
        const autoConverters = (0, $54Kws.getAutoConvertPatternsFromModule)(await this.manifestsPromise);
        return autoConverters;
    }
    constructor(manifests, /**
   * Allows for an optional list of pre compiled auto convert handlers to be passed.
   * Useful for performance improvements or to support legacy converters.
   *
   * Warning: If this attribute is passed, this provider will ignore auto convert patterns from the manifests.
   */ autoConvertHandlers){
        this.manifestsPromise = void 0;
        this.manifestsCache = [];
        this.autoConvertHandlers = void 0;
        this.manifestsPromise = Promise.resolve(manifests);
        this.autoConvertHandlers = autoConvertHandlers;
    }
}
module.exports["default"] = $88516670672fc955$export$2e2bcd8739ae039;

});

parcelRegister("54Kws", function(module, exports) {
async function $4782fc034cf1736f$export$60407594ea5edd1c(extensions) {
    const items = await Promise.all(extensions.map((manifest)=>{
        if (manifest.modules.autoConvert && manifest.modules.autoConvert.url) return manifest.modules.autoConvert.url;
        return [];
    }));
    return [].concat(...items);
}
module.exports["getAutoConvertPatternsFromModule"] = $4782fc034cf1736f$export$60407594ea5edd1c;

});

parcelRegister("dPoYT", function(module, exports) {
const $8dbc220cf14fe789$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal',
    FULL_SCREEN_MODAL: 'full-screen-modal'
};
module.exports["ConversationAssistantUIModes"] = $8dbc220cf14fe789$export$bc36ebf73899a71d;

});

parcelRegister("gzMZq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $cXtTj = parcelRequire("cXtTj");


var $ixfCV = parcelRequire("ixfCV");

const $2a83073b2ae5e0c1$export$6f57813fe9f31bf9 = (0, $8s9DV.createStore)({
    initialState: {
        editorContext: undefined,
        whiteboardContext: undefined,
        slidesContext: undefined,
        databaseContext: undefined,
        browserContext: undefined,
        dashboardContext: undefined,
        jiraWorkflowContext: undefined,
        aiFeatureContext: {},
        isAIFeatureContextDismissed: false,
        contentTargets: {},
        currentTargetId: undefined,
        pageSmartLinks: undefined
    },
    actions: {
        getAllContext: ()=>({ getState: getState })=>getState(),
        getAIFeatureContext: ()=>({ getState: getState })=>{
                const currentState = getState().aiFeatureContext;
                // Delete all properties that are undefined
                Object.keys(currentState).forEach((key)=>currentState[key] === undefined && delete currentState[key]);
                // Avoid sending an empty object
                return Object.keys(currentState).length ? currentState : undefined;
            },
        setAIFeatureContext: (chatContextData)=>({ getState: getState, setState: setState })=>{
                const state = getState();
                // Honour the user's explicit "Remove context" action
                if (state.isAIFeatureContextDismissed) return;
                const currentAIFeatureContextState = state.aiFeatureContext;
                const { contextKey: contextKey, setContext: setContext } = chatContextData;
                if (contextKey) {
                    const contextUpdated = setContext(currentAIFeatureContextState[contextKey]);
                    setState({
                        aiFeatureContext: {
                            ...currentAIFeatureContextState,
                            [contextKey]: contextUpdated
                        }
                    });
                }
            },
        setAIFeatureContextDismissed: (isDismissed)=>({ setState: setState })=>{
                setState(isDismissed ? {
                    aiFeatureContext: {},
                    isAIFeatureContextDismissed: true
                } : {
                    isAIFeatureContextDismissed: false
                });
            },
        getDashboardContext: ()=>({ getState: getState })=>getState().dashboardContext,
        setDashboardContext: (dashboardContext)=>({ setState: setState })=>{
                setState({
                    dashboardContext: dashboardContext
                });
            },
        getJiraWorkflowContext: ()=>({ getState: getState })=>getState().jiraWorkflowContext,
        setJiraWorkflowContext: (jiraWorkflowContext)=>({ setState: setState })=>{
                setState({
                    jiraWorkflowContext: jiraWorkflowContext
                });
            },
        getJiraCreateContext: ()=>({ getState: getState })=>getState().jiraCreateContext,
        setJiraCreateContext: (jiraCreateContext)=>({ setState: setState })=>{
                setState({
                    jiraCreateContext: jiraCreateContext
                });
            },
        getEditorContext: ()=>({ getState: getState })=>getState().editorContext,
        setEditorContext: (editorContext)=>({ setState: setState })=>{
                setState({
                    editorContext: editorContext
                });
            },
        updateEditorContextIsViewMode: (isViewMode)=>({ setState: setState, getState: getState })=>{
                const { editorContext: editorContext } = getState();
                if (editorContext) setState({
                    editorContext: {
                        ...editorContext,
                        isViewMode: isViewMode
                    }
                });
            },
        getWhiteboardContext: ()=>({ getState: getState })=>getState().whiteboardContext,
        setWhiteboardContext: (whiteboardContext)=>({ setState: setState })=>{
                setState({
                    whiteboardContext: whiteboardContext
                });
            },
        getSlidesContext: ()=>({ getState: getState })=>getState().slidesContext,
        setSlidesContext: (slidesContext)=>({ setState: setState })=>{
                setState({
                    slidesContext: slidesContext
                });
            },
        getDatabaseContext: ()=>({ getState: getState })=>getState().databaseContext,
        setDatabaseContext: (databaseContext)=>({ setState: setState })=>{
                setState({
                    databaseContext: databaseContext
                });
            },
        mergeDatabaseContext: (partial)=>({ getState: getState, setState: setState })=>{
                // If no selected elements published, clean up the database context
                if (!partial?.selectedElementIds) {
                    setState({
                        databaseContext: undefined
                    });
                    return;
                }
                const current = getState().databaseContext;
                setState({
                    databaseContext: current ? {
                        ...current,
                        ...partial
                    } : partial
                });
            },
        getBrowserContext: ()=>({ getState: getState })=>getState().browserContext,
        setBrowserContext: (browserContext)=>({ setState: setState })=>{
                setState({
                    browserContext: browserContext
                });
            },
        setPageSmartLinks: (pageSmartLinks)=>({ setState: setState })=>{
                setState({
                    pageSmartLinks: pageSmartLinks
                });
            },
        getTarget: (contentContext, activeTargetId)=>({ getState: getState })=>{
                const targets = getState().contentTargets[contentContext];
                if (!targets) return undefined;
                // targets is always an array
                const targetList = targets;
                // If activeTargetId provided, find it; otherwise return first target
                if (activeTargetId) return targetList.find((t)=>t.id === activeTargetId);
                return targetList[0];
            },
        getContentContext: (contentId)=>({ getState: getState })=>{
                const entries = Object.entries(getState().contentTargets);
                for (const [context, targets] of entries){
                    const targetList = targets;
                    if (targetList.some((t)=>t.id === contentId)) return context;
                }
                return undefined;
            },
        getActiveContext: ()=>({ getState: getState })=>{
                const entries = getState().contentTargets;
                // The rules here determine the 'rank' in which Rovo layers are resolved into "which layer is currently active".
                // They map to intended UX - in AIFC, the staging area is a modal-powered experience, on top of global experiences.
                // Consider the scenario of sending a message - the user will be interacting with the topmost layer.
                if (entries['staging-area']) return 'staging-area';
                return 'global';
            },
        hasTarget: (contentContext)=>({ getState: getState })=>!!getState().contentTargets[contentContext],
        setTarget: (toAdd, target)=>({ getState: getState, setState: setState })=>{
                const currentTargets = getState().contentTargets;
                // Store as array, append if not already present
                const existing = currentTargets[toAdd];
                const targetList = existing ?? [];
                // Avoid duplicates by checking if target with same id exists
                // & filter out any targets with empty IDs to avoid stale targets
                const filtered = targetList.filter((t)=>t.id !== '' && t.id !== target.id);
                filtered.push(target);
                setState({
                    contentTargets: {
                        ...currentTargets,
                        [toAdd]: filtered
                    }
                });
            },
        clearTarget: (toRemove, targetId)=>({ getState: getState, setState: setState })=>{
                const currentState = getState().contentTargets;
                const nextState = {};
                for (const key of Object.keys(currentState)){
                    const k = key;
                    if (k !== toRemove) nextState[k] = currentState[k];
                    else if (targetId) {
                        // If a specific targetId is provided, filter out that target
                        const targetList = currentState[k];
                        const filtered = targetList.filter((t)=>t.id !== targetId);
                        if (filtered.length > 0) nextState[k] = filtered;
                    }
                }
                setState({
                    contentTargets: nextState
                });
            },
        setCurrentTargetId: (targetId)=>({ setState: setState })=>{
                setState({
                    currentTargetId: targetId
                });
            },
        getCurrentTargetId: ()=>({ getState: getState })=>getState().currentTargetId
    }
});
const $2a83073b2ae5e0c1$export$53bf948a400e8426 = (0, $kBr4q.createActionsHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9);
const $2a83073b2ae5e0c1$export$9465f65715425f1b = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.editorContext
});
const $2a83073b2ae5e0c1$export$eea520981851a092 = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.whiteboardContext
});
const $2a83073b2ae5e0c1$export$c517e9a5e436c401 = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.slidesContext
});
const $2a83073b2ae5e0c1$export$debe3dc2612d2a8e = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.databaseContext
});
const $2a83073b2ae5e0c1$export$376b2a7bf70dad8 = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.browserContext
});
const $2a83073b2ae5e0c1$export$6280f21050465fe4 = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.pageSmartLinks
});
const $2a83073b2ae5e0c1$export$3794ec8d9f571031 = (0, $kBr4q.createHook)($2a83073b2ae5e0c1$export$6f57813fe9f31bf9, {
    selector: (state)=>state.aiFeatureContext
});
const $2a83073b2ae5e0c1$export$904052abb7b98535 = ({ requestBrowserContent: requestBrowserContent, getContentBody: getContentBody, getStagingSpace: getStagingSpace, useCurrentNonEditingPageAsContext: useCurrentNonEditingPageAsContext, requestJiraContext: requestJiraContext })=>{
    const actions = $2a83073b2ae5e0c1$export$53bf948a400e8426();
    const { getTarget: getTarget, getCurrentTargetId: getCurrentTargetId } = actions;
    const fetchContent = (0, $cozmU.useCallback)(async (type, contentContext, activeTargetId)=>{
        const currentTargetId = getCurrentTargetId();
        const contentTarget = getTarget(contentContext, activeTargetId);
        if (!contentTarget) return undefined;
        // Only use currentTargetId when staging-area doesn't exist
        // to avoid changing any content open behind the staging
        // area modal
        const shouldUseCurrentTargetId = type === 'page' && !getTarget('staging-area');
        const selectedTargetId = shouldUseCurrentTargetId ? currentTargetId || contentTarget.id : contentTarget.id;
        const contentBody = await getContentBody(type, selectedTargetId);
        if (!contentBody || contentBody.contentType !== type) return undefined;
        switch(contentBody.contentType){
            case 'page':
                if (!contentBody.pageBody) return undefined;
                return {
                    contentId: contentBody.contentId,
                    editorStreamingContractVersion: contentBody.editorStreamingContractVersion,
                    document: {
                        type: 'text/adf',
                        content: contentBody.pageBody
                    },
                    selection: {
                        type: 'text/markdown',
                        content: contentBody.selectionMarkdown || ''
                    },
                    selectionFragment: contentBody.selectionFragment,
                    selectionLocalIds: contentBody.selectionLocalIds,
                    contentMauiId: contentBody.contentMauiId,
                    dynamicUiSource: contentBody.dynamicUiSource,
                    dynamicUiType: contentBody.dynamicUiType,
                    mediaFileId: contentBody.mediaFileId,
                    isViewMode: contentBody.isViewMode,
                    isDraftLockedForEditing: contentBody.isDraftLockedForEditing,
                    useGenericEditorSkill: contentBody.useGenericEditorSkill,
                    additionalContext: contentBody.additionalContext
                };
            case 'whiteboard':
                if (!contentBody.svg || !contentBody.wdf) return undefined;
                return {
                    contentId: contentBody.contentId,
                    type: 'image/svg+xml',
                    svg: contentBody.svg,
                    title: contentBody.title ?? null,
                    url: contentBody.url ?? null,
                    wdf: contentBody.wdf,
                    selectedElementIds: contentBody.selectedElementIds,
                    isViewMode: contentBody.isViewMode
                };
            case 'slide':
                if (!contentBody.xml) return undefined;
                return {
                    contentId: contentBody.contentId,
                    xml: contentBody.xml,
                    title: contentBody.title,
                    url: contentBody.url,
                    selectedSlideIndex: contentBody.selectedSlideIndex,
                    selectedElementIds: contentBody.selectedElementIds,
                    isViewMode: contentBody.isViewMode
                };
            case 'database':
                if (!contentBody.csv) return undefined;
                return {
                    contentId: contentBody.contentId,
                    csv: contentBody.csv,
                    title: contentBody.title,
                    url: contentBody.url,
                    isViewMode: contentBody.isViewMode
                };
            case 'dashboard':
                if (!contentBody.content) return undefined;
                return {
                    content: contentBody.content,
                    dashboardAri: contentBody.dashboardAri,
                    isEditing: contentBody.isEditing,
                    chartResponseData: contentBody.chartResponseData,
                    location: contentBody.location,
                    products: contentBody.products,
                    subProducts: contentBody.subProducts
                };
            default:
                return undefined;
        }
    }, [
        getContentBody,
        getTarget,
        getCurrentTargetId
    ]);
    /**
   * Fetches the context of a currently live page with Rovo chat open.
   *
   * @description see full list of cases to consider in {@link getContextRequirements}
   */ const getEditorContext = (0, $cozmU.useCallback)(async ({ source: source, contentContext: contentContext_0, isFirstPrompt: isFirstPrompt, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference, activeTargetId: activeTargetId_0 })=>{
        const isAifcEnabled = (0, $ixfCV.fg)('aifc_create_enabled');
        const shouldProvideContext = $2a83073b2ae5e0c1$export$86d7678a1db25436({
            contentContext: contentContext_0,
            source: source,
            isFirstPrompt: isFirstPrompt,
            isAifcEnabled: isAifcEnabled,
            userPreference: addCurrentPageAsContextUserPreference
        });
        if (!shouldProvideContext) return undefined;
        return isAifcEnabled ? await fetchContent('page', contentContext_0, activeTargetId_0) : actions.getEditorContext();
    }, [
        actions,
        fetchContent
    ]);
    /**
   * Fetches the context of a currently live page with Rovo chat open.
   *
   * @description see full list of cases to consider in {@link getContextRequirements}
   */ const getWhiteboardContext = (0, $cozmU.useCallback)(async ({ source: source_0, contentContext: contentContext_1, isFirstPrompt: isFirstPrompt_0, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference_0, activeTargetId: activeTargetId_1 })=>{
        const isAifcEnabled_0 = (0, $ixfCV.fg)('aifc_create_enabled');
        const shouldProvideContext_0 = $2a83073b2ae5e0c1$export$86d7678a1db25436({
            contentContext: contentContext_1,
            source: source_0,
            isFirstPrompt: isFirstPrompt_0,
            isAifcEnabled: isAifcEnabled_0,
            userPreference: addCurrentPageAsContextUserPreference_0
        });
        if (!shouldProvideContext_0) return undefined;
        return isAifcEnabled_0 ? await fetchContent('whiteboard', contentContext_1, activeTargetId_1) : actions.getWhiteboardContext();
    }, [
        actions,
        fetchContent
    ]);
    const getSlidesContext = (0, $cozmU.useCallback)(async ({ source: source_1, contentContext: contentContext_2, isFirstPrompt: isFirstPrompt_1, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference_1, activeTargetId: activeTargetId_2 })=>{
        const isAifcEnabled_1 = (0, $cXtTj.default).getExperimentValue('cc-mui-slides-experiment', 'isEnabled', false);
        const shouldProvideContext_1 = $2a83073b2ae5e0c1$export$86d7678a1db25436({
            contentContext: contentContext_2,
            source: source_1,
            isFirstPrompt: isFirstPrompt_1,
            isAifcEnabled: isAifcEnabled_1,
            userPreference: addCurrentPageAsContextUserPreference_1
        });
        if (!shouldProvideContext_1) return undefined;
        return isAifcEnabled_1 ? await fetchContent('slide', contentContext_2, activeTargetId_2) : actions.getSlidesContext();
    }, [
        actions,
        fetchContent
    ]);
    const getDatabaseContext = (0, $cozmU.useCallback)(async ({ source: source_2, contentContext: contentContext_3, isFirstPrompt: isFirstPrompt_2, addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference_2, activeTargetId: activeTargetId_3 })=>{
        const isAifcEnabled_2 = (0, $ixfCV.fg)('aifc_create_enabled');
        const shouldProvideContext_2 = $2a83073b2ae5e0c1$export$86d7678a1db25436({
            contentContext: contentContext_3,
            source: source_2,
            isFirstPrompt: isFirstPrompt_2,
            isAifcEnabled: isAifcEnabled_2,
            userPreference: addCurrentPageAsContextUserPreference_2
        });
        if (!shouldProvideContext_2) return undefined;
        return isAifcEnabled_2 ? await fetchContent('database', contentContext_3, activeTargetId_3) : actions.getDatabaseContext();
    }, [
        actions,
        fetchContent
    ]);
    const getDashboardEditorContext = (0, $cozmU.useCallback)(async ({ contentContext: contentContext_4, activeTargetId: activeTargetId_4 })=>{
        if (!(0, $ixfCV.fg)('platform_avp_aifc_enabled')) return undefined;
        return await fetchContent('dashboard', contentContext_4, activeTargetId_4);
    }, [
        fetchContent
    ]);
    const getSpaceCreateContext = (0, $cozmU.useCallback)(({ contentContext: contentContext_5, isFirstPrompt: isFirstPrompt_3 })=>{
        if (contentContext_5 === 'staging-area' && !isFirstPrompt_3 && (0, $ixfCV.fg)('aifc_space_creation_enabled')) return getStagingSpace(String(getTarget(contentContext_5)?.id));
    }, [
        getStagingSpace,
        getTarget
    ]);
    const getIsStagingArea = (0, $cozmU.useCallback)(()=>actions.getActiveContext() === 'staging-area', [
        actions
    ]);
    const useCurrentBrowsingContext = (0, $cozmU.useCallback)((addCurrentPageAsContextUserPreference_3)=>{
        // If the user has explicitly turned off "use current page as context" (e.g.
        // by dismissing the context banner), send false rather than undefined so the
        // backend is explicitly told not to use the browserUrl as context. This is
        // required in edit mode, where useCurrentNonEditingPageAsContext is undefined
        // but the user preference is set to false on dismiss. the value is sent as true
        // when the context is enabled in the chat banner.
        if (addCurrentPageAsContextUserPreference_3) return addCurrentPageAsContextUserPreference_3;
        // undefined means don't send useCurrentBrowsingContext at all. false tells backend to explicitly not use the browserUrl as context.
        if (useCurrentNonEditingPageAsContext === undefined) return undefined;
        const stagingAreaEnabled = getIsStagingArea();
        return !stagingAreaEnabled && addCurrentPageAsContextUserPreference_3 && useCurrentNonEditingPageAsContext;
    }, [
        useCurrentNonEditingPageAsContext,
        getIsStagingArea
    ]);
    const getBrowserContext = (0, $cozmU.useCallback)(async ({ addCurrentPageAsContextUserPreference: addCurrentPageAsContextUserPreference_4, enabled: enabled })=>{
        // if the feature is not enabled, we return the original context resolution.
        if (!enabled && !(0, $cXtTj.default).getExperimentValue('jira_free_gen_editor', 'isEnabled', false)) return actions.getBrowserContext();
        if (!addCurrentPageAsContextUserPreference_4) return undefined;
        // Request browser content from the extension
        const browserContextResult = await requestBrowserContent();
        const browserContext = browserContextResult ? {
            context: browserContextResult
        } : actions.getBrowserContext();
        return browserContext;
    }, [
        requestBrowserContent,
        actions
    ]);
    const getJiraContext = (0, $cozmU.useCallback)(async ()=>{
        const isStagingArea = getIsStagingArea();
        if (!isStagingArea) {
            const jiraCreateContext = actions.getJiraCreateContext();
            if (jiraCreateContext?.draftWorkItems) return jiraCreateContext;
        }
        // Fallback to bridge API if available (staging area doesn't have the state in sync with the chat store)
        if (!requestJiraContext) return undefined;
        try {
            const result = await requestJiraContext();
            return result?.success ? result.context : undefined;
        // eslint-disable-next-line no-unused-vars
        } catch (error) {
            return undefined;
        }
    }, [
        requestJiraContext,
        actions,
        getIsStagingArea
    ]);
    return {
        ...actions,
        getEditorContext: getEditorContext,
        getWhiteboardContext: getWhiteboardContext,
        getSlidesContext: getSlidesContext,
        getSpaceCreateContext: getSpaceCreateContext,
        getIsStagingArea: getIsStagingArea,
        useCurrentBrowsingContext: useCurrentBrowsingContext,
        getDatabaseContext: getDatabaseContext,
        getDashboardEditorContext: getDashboardEditorContext,
        getBrowserContext: getBrowserContext,
        getJiraContext: getJiraContext
    };
};
function $2a83073b2ae5e0c1$export$86d7678a1db25436({ contentContext: contentContext, source: source, isFirstPrompt: isFirstPrompt, isAifcEnabled: isAifcEnabled, userPreference: userPreference }) {
    /**
   * If AIFC is not enabled, we default to the user's preference.
   */ if (!isAifcEnabled) return userPreference;
    /**
   * In the staging area, we always want to provide context if the source is the
   * inline editor, from the blank object experience, or if the prompt is not the
   * first in a new conversation.
   */ const sourceEligible = source === 'CONFLUENCE_INLINE_EDITOR' || source === 'INLINE_EDITOR' || source === 'CONFLUENCE_MAUI_INLINE_EDITOR' || source === 'CONFLUENCE_WHITEBOARD_TO_PAGE_BUTTON' || source === 'CONFLUENCE_WHITEBOARD_BRAINSTORMING_FOLLOW_UP' || source === 'CONFLUENCE_CWR_TEMPLATE' || source === 'CONFLUENCE_CWR_BLANK_OBJECT';
    if (contentContext === 'staging-area') return sourceEligible || !isFirstPrompt;
    else /**
     * On real content when AIFC is enabled, we only want to default to true
     * if the source of the content is the inline editing experience. Otherwise,
     * we want to respect the preference chosen by the user.
     */ return sourceEligible || userPreference;
}
module.exports["useChatContextStoreActions"] = $2a83073b2ae5e0c1$export$53bf948a400e8426;
module.exports["useChatContextEditorContext"] = $2a83073b2ae5e0c1$export$9465f65715425f1b;
module.exports["useChatContextDatabaseContext"] = $2a83073b2ae5e0c1$export$debe3dc2612d2a8e;
module.exports["useChatContextBrowserContext"] = $2a83073b2ae5e0c1$export$376b2a7bf70dad8;
module.exports["useChatContextPageSmartLinks"] = $2a83073b2ae5e0c1$export$6280f21050465fe4;
module.exports["useChatContextAIFeatureContext"] = $2a83073b2ae5e0c1$export$3794ec8d9f571031;
module.exports["useChatContextProvider"] = $2a83073b2ae5e0c1$export$904052abb7b98535;

});

parcelRegister("4tOXV", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $w6R6I = parcelRequire("w6R6I");


var $fZAJP = parcelRequire("fZAJP");

const $05ef07480c610d29$export$9ac100e40613ea10 = ()=>{
    let userAgent = '';
    if (window?.__SSR_USER_AGENT__) userAgent = window.__SSR_USER_AGENT__;
    else userAgent = window?.navigator?.userAgent ?? '';
    return userAgent.indexOf('Mac') > -1;
};
const $05ef07480c610d29$var$styles = {
    flexCenter: "_1rjcv77o _1e0c1txw _4cvr1h6o",
    base: "_2rko12b0 _1rjcv77o _18zru2gc _1e0c1o8l _18u0v77o _2hwxv77o",
    contentBefore: "_18u01b66 _2hwxze3t",
    darkBackground: "_bfhk18j9",
    lightBackground: "_bfhkysee"
};
const $05ef07480c610d29$var$i18n = (0, $kSwu1.defineMessages)({
    keyboardShortcutShift: {
        id: "shortcuts.shift",
        defaultMessage: "Shift"
    },
    keyboardShortcutCtrl: {
        id: "shortcuts.ctrl",
        defaultMessage: "Ctrl"
    },
    keyboardShortcutCommandWin: {
        id: "shortcuts.cmd.win",
        defaultMessage: "Ctrl"
    },
    keyboardShortcutCommandMac: {
        id: "shortcuts.cmd.mac",
        defaultMessage: "Cmd"
    },
    keyboardShortcutOptionMac: {
        id: "shortcuts.opt.mac",
        defaultMessage: "Opt"
    },
    keyboardShortcutOptionWin: {
        id: "shortcuts.opt.win",
        defaultMessage: "Alt"
    },
    keyboardShortcutPlus: {
        id: "shortcuts.plus",
        defaultMessage: "+"
    },
    keyboardShortcutMinus: {
        id: "shortcuts.minus",
        defaultMessage: "-"
    },
    keyboardShortcutEnter: {
        id: "shortcuts.enter",
        defaultMessage: "Enter"
    },
    keyboardShortcutMeta: {
        id: "shortcuts.meta",
        defaultMessage: "Meta"
    }
});
const $05ef07480c610d29$var$processKey = (key, formatMessage)=>{
    const mac = $05ef07480c610d29$export$9ac100e40613ea10();
    const lowerCaseKey = key.toLowerCase();
    switch(lowerCaseKey){
        case 'shift':
            return '\u21E7';
        // ⇧
        case 'cmd':
        case 'mod':
            return mac ? '\u2318' // ⌘
             : formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutCommandWin);
        case 'ctrl':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutCtrl);
        case 'opt':
        case 'option':
            return mac ? formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutOptionMac) : formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutOptionWin);
        case 'enter':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutEnter);
        case 'meta':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutMeta);
        case 'uparrow':
            return '\u2191';
        // ↑
        case 'downarrow':
            return '\u2193';
        // ↓
        case 'leftarrow':
            return '\u2190';
        // ←
        case 'rightarrow':
            return '\u2192';
        // →
        case 'plus':
            return '+';
        case 'minus':
            return '-';
        default:
            return key;
    }
};
const $05ef07480c610d29$var$getShortcutStrings = (accelerator, formatMessage)=>{
    const shortcutKeys = accelerator.includes(' ') ? accelerator.split(' ') : accelerator.split('+');
    return shortcutKeys.map((key)=>{
        const processedKey = $05ef07480c610d29$var$processKey(key, formatMessage);
        if (processedKey.length === 1) return processedKey.toUpperCase();
        else return processedKey;
    });
};
const $05ef07480c610d29$export$7571b974b8c6ca70 = (accelerator, formatMessage)=>{
    return $05ef07480c610d29$var$getShortcutStrings(accelerator, formatMessage).join(' ');
};
const $05ef07480c610d29$export$7005a48098466b5d = (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { shortcut: shortcut, contentBefore: contentBefore, isEditorShortcut: isEditorShortcut, isTooltip: t1 } = t0;
    const isTooltip = t1 === undefined ? false : t1;
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    const intl = (0, $kSwu1.useIntl)();
    let T0;
    let t2;
    let t3;
    let t4;
    let t5;
    if ($[0] !== areKeyboardShortcutsEnabled || $[1] !== contentBefore || $[2] !== intl.formatMessage || $[3] !== isEditorShortcut || $[4] !== isTooltip || $[5] !== shortcut) {
        const shortcutStrings = $05ef07480c610d29$var$getShortcutStrings(shortcut, intl.formatMessage);
        const shouldRenderShortcutSegment = areKeyboardShortcutsEnabled || isEditorShortcut;
        T0 = (0, $iMnC5.default);
        t2 = "span";
        t3 = $05ef07480c610d29$var$styles.flexCenter;
        t4 = contentBefore;
        t5 = shouldRenderShortcutSegment && shortcutStrings.map((shortcutSegment, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                as: "span",
                key: `${shortcutSegment}-${index}`,
                xcss: (0, $w6R6I.cx)($05ef07480c610d29$var$styles.base, Boolean(contentBefore) && $05ef07480c610d29$var$styles.contentBefore, isTooltip ? $05ef07480c610d29$var$styles.darkBackground : $05ef07480c610d29$var$styles.lightBackground)
            }, shortcutSegment));
        $[0] = areKeyboardShortcutsEnabled;
        $[1] = contentBefore;
        $[2] = intl.formatMessage;
        $[3] = isEditorShortcut;
        $[4] = isTooltip;
        $[5] = shortcut;
        $[6] = T0;
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else {
        T0 = $[6];
        t2 = $[7];
        t3 = $[8];
        t4 = $[9];
        t5 = $[10];
    }
    let t6;
    if ($[11] !== T0 || $[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            as: t2,
            xcss: t3
        }, t4, t5);
        $[11] = T0;
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
}; /**
    * Converts shortcut strings like "ctrl+[" to an array of strings like ["Ctrl", "["].
    *
    * This is used for mapping the shortcut constants in `confluence-shortcuts.ts` to the
    * format expected by the ADS Tooltip `shortcut` prop.
    *
    * It checks if keyboard shortcuts are enabled and returns undefined if they are not.
    *
    * @example
    * ```
    * const shortcut = useShortcutStrings({ shortcut: 'ctrl+[' });
    * <Tooltip content="My tooltip" shortcut={shortcut} />
    * ```
    */ 
const $05ef07480c610d29$export$e84ae736f9706c5d = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { shortcut: shortcut, isEditorShortcut: t1 } = t0;
    const isEditorShortcut = t1 === undefined ? false : t1;
    const intl = (0, $kSwu1.useIntl)();
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    if (!shortcut) return;
    let t2;
    if ($[0] !== intl.formatMessage || $[1] !== shortcut) {
        t2 = $05ef07480c610d29$var$getShortcutStrings(shortcut, intl.formatMessage);
        $[0] = intl.formatMessage;
        $[1] = shortcut;
        $[2] = t2;
    } else t2 = $[2];
    const shortcutStrings = t2;
    const shouldDisplayShortcut = areKeyboardShortcutsEnabled || isEditorShortcut;
    if (!shouldDisplayShortcut) return;
    return shortcutStrings;
};
module.exports["isMac"] = $05ef07480c610d29$export$9ac100e40613ea10;
module.exports["getShortcutString"] = $05ef07480c610d29$export$7571b974b8c6ca70;
module.exports["ShortcutVisualizer"] = $05ef07480c610d29$export$7005a48098466b5d;
module.exports["useShortcutStrings"] = $05ef07480c610d29$export$e84ae736f9706c5d;

});

parcelRegister("fZAJP", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $3y1ko = parcelRequire("3y1ko");

let $640354b193201be7$var$inflightPromise = null;
const $640354b193201be7$var$updaters = new Set();
const $640354b193201be7$export$130f87a5d53e682d = ()=>{
    const $ = (0, $bDgLe.c)(6);
    const { isLoggedIn: isLoggedIn, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const [enabled, setEnabled] = (0, $cozmU.useState)(window.__SHORTCUT_ENABLED__ ?? false);
    let t0;
    let t1;
    if ($[0] !== isLicensed || $[1] !== isLoggedIn) {
        t0 = ()=>{
            if (typeof window.__SHORTCUT_ENABLED__ !== "boolean") {
                if (!$640354b193201be7$var$inflightPromise) $640354b193201be7$var$inflightPromise = isLoggedIn && isLicensed ? (0, $3y1ko.fetchShortcutEnabledState)() : Promise.resolve(false);
                $640354b193201be7$var$inflightPromise.then(setEnabled);
            }
            $640354b193201be7$var$updaters.add(setEnabled);
            return ()=>{
                $640354b193201be7$var$updaters.delete(setEnabled);
            };
        };
        t1 = [
            isLoggedIn,
            isLicensed
        ];
        $[0] = isLicensed;
        $[1] = isLoggedIn;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    const notify = $640354b193201be7$var$_temp;
    const t2 = Boolean(enabled);
    let t3;
    if ($[4] !== t2) {
        t3 = [
            t2,
            notify
        ];
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
};
async function $640354b193201be7$var$_temp(enabled_0) {
    try {
        const res = await (0, $f7B1p.cfetch)("/wiki/rest/confluenceshortcuts/latest/enabled", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                enabled: enabled_0
            })
        });
        if (res.ok) {
            const newEnabled = await res.text() === "true";
            window.__SHORTCUT_ENABLED__ = newEnabled;
            $640354b193201be7$var$updaters.forEach((updater)=>updater(newEnabled));
        }
    } catch (t0) {
        const e = t0;
        (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Error updating keyboard shortcuts enabled state: ${e.message}`), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        });
    }
}
module.exports["useKeyboardShortcutsEnabled"] = $640354b193201be7$export$130f87a5d53e682d;

});

parcelRegister("3y1ko", function(module, exports) {

var $xwvlW = parcelRequire("xwvlW");


var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");


var $f7B1p = parcelRequire("f7B1p");

async function $4c06255176f911bc$export$632d1cf1f5c6210f() {
    let enabled = false;
    try {
        const res = await (0, $f7B1p.cfetch)('/wiki/rest/confluenceshortcuts/latest/enabled');
        if (res.ok) enabled = await res.text() === 'true';
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Error fetching keyboard shortcuts enabled state: ${e.message}`), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        });
    }
    return window.__SHORTCUT_ENABLED__ = enabled;
}
async function $4c06255176f911bc$export$abcdd924245fc03a() {
    const { isLoggedIn: isLoggedIn, isLicensed: isLicensed } = (0, $xwvlW.getPreloaderFnContext)();
    if (isLoggedIn && isLicensed) return await $4c06255176f911bc$export$632d1cf1f5c6210f();
    return false;
}
module.exports["fetchShortcutEnabledState"] = $4c06255176f911bc$export$632d1cf1f5c6210f;
module.exports["preloadShortcutEnabledState"] = $4c06255176f911bc$export$abcdd924245fc03a;

});

parcelRegister("3mVfX", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $8i27m = parcelRequire("8i27m");


var $kgNLQ = parcelRequire("kgNLQ");

var $4440a0699c7a4c4d$export$ca559f4ef107f965 = /*#__PURE__*/ function(ViewValues) {
    ViewValues["OPEN"] = "OPEN";
    ViewValues["UNREAD"] = "UNREAD";
    ViewValues["DELETED_CONTENT"] = "DELETED_CONTENT";
    ViewValues["RESOLVED"] = "RESOLVED";
    ViewValues["MENTIONS_ME"] = "MENTIONS_ME";
    return ViewValues;
}({});
var $4440a0699c7a4c4d$export$edda0a7e0ba757fd = /*#__PURE__*/ function(SortValues) {
    SortValues["PAGE_ORDER"] = "PAGE_ORDER";
    SortValues["MOST_RECENT"] = "MOST_RECENT";
    return SortValues;
}({});
var $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c = /*#__PURE__*/ function(CommentMode) {
    CommentMode["VIEW"] = "view";
    CommentMode["ADD"] = "add";
    return CommentMode;
}({});
var $4440a0699c7a4c4d$export$94f8d08c2312472b = /*#__PURE__*/ function(AddFooterCommentMode) {
    AddFooterCommentMode["FOOTER"] = "footer";
    AddFooterCommentMode["STICKY_DRAFT"] = "sticky_draft";
    AddFooterCommentMode["STICKY_FOOTER"] = "sticky_footer";
    return AddFooterCommentMode;
}({});
var $4440a0699c7a4c4d$export$6a393d893fab1730 = /*#__PURE__*/ function(SidebarTabValues) {
    SidebarTabValues["COMMENTS"] = "COMMENTS";
    SidebarTabValues["SUGGESTIONS"] = "SUGGESTIONS";
    return SidebarTabValues;
}({});
const $4440a0699c7a4c4d$var$getInitialState = ()=>({
        currentView: undefined,
        currentSort: "PAGE_ORDER",
        showInlineComments: true,
        showGeneralComments: true,
        currentlySelectedThreadKey: undefined,
        isCurrentlySelectedThreadOptimisticallyAdded: false,
        initialDataLoadedForViewMap: {
            ["UNREAD"]: false,
            ["OPEN"]: false,
            ["DELETED_CONTENT"]: false,
            ["RESOLVED"]: false,
            ["MENTIONS_ME"]: false
        },
        replyToCommentId: undefined,
        replyToCommentUser: undefined,
        replyToContributorUsers: undefined,
        footerEditCommentIds: new Set(),
        currentlyRenderedThreads: [],
        location: undefined,
        commentType: undefined,
        commentMode: "view",
        isCommentAddPromptFocused: false,
        commentContainerToFocus: undefined,
        addFooterCommentAdf: undefined,
        cachedSummary: null,
        currentSidebarTab: "COMMENTS",
        triggerOnDemandSummary: false,
        isSummaryDismissedByUser: false,
        automaticSummariesPreference: undefined
    });
// Actions for managing the comments state in the comments panel
const $4440a0699c7a4c4d$var$actions = {
    getCommentsPanelState: ()=>({ getState: getState })=>{
            return getState();
        },
    setCurrentView: (view)=>({ setState: setState })=>{
            setState({
                currentView: view
            });
        },
    setCurrentSort: (sort)=>({ setState: setState })=>{
            setState({
                currentSort: sort
            });
        },
    setShowInlineComments: (showInline)=>({ setState: setState })=>{
            setState({
                showInlineComments: showInline
            });
        },
    setShowGeneralComments: (showGeneral)=>({ setState: setState })=>{
            setState({
                showGeneralComments: showGeneral
            });
        },
    setCurrentlySelectedThreadKey: (threadKey, commentType, isOptimisticAddSuccess)=>({ getState: getState, setState: setState })=>{
            const { currentlySelectedThreadKey: currentlySelectedThreadKey } = getState();
            if (!!isOptimisticAddSuccess && commentType === (0, $8i27m.CommentType).GENERAL && currentlySelectedThreadKey !== (0, $kgNLQ.OPTIMISTIC_SAVE_COMMENT_ID)) // This means that user has selected a different comment thread
            // after new comment was optimistically added on UI but before
            // the GQL mutation succeeded. In this case, we shouldn't set
            // currentlySelectedThreadKey to the new comment.
            return;
            setState({
                currentlySelectedThreadKey: threadKey,
                commentType: commentType,
                // Note: Added for COMMENTS-6792: Optimistically adding a footer comment.
                // When adding a footer comment optimistically, setCurrentlySelectedThreadKey is
                // called twice: once when the comment is added to UI optimistically with a fake id,
                // and once more when the mutation succeeds and UI is updated with the actual id.
                // The effect of the second call is rendered on UI before the updated comment list
                // is rendered, which causes a visible flicker, where the new comment goes from
                // "selected" -> "unselected" (for an instant) -> "selected" again.
                // To fix this flicker, we keep showing the comment with fake id as "selected" when
                // this flag is true, even if value of `currentlySelectedThreadKey` has changed.
                isCurrentlySelectedThreadOptimisticallyAdded: commentType === (0, $8i27m.CommentType).GENERAL && !!isOptimisticAddSuccess
            });
        },
    setInitialDataLoadedForView: ({ viewToSetLoaded: viewToSetLoaded })=>({ getState: getState, setState: setState })=>{
            const { initialDataLoadedForViewMap: initialDataLoadedForViewMap } = getState();
            initialDataLoadedForViewMap[viewToSetLoaded] = true;
            setState({
                initialDataLoadedForViewMap: initialDataLoadedForViewMap
            });
        },
    setReplyToCommentId: ({ parentCommentId: parentCommentId, location: location, user: user, contributorUsers: contributorUsers } = {})=>({ setState: setState })=>{
            setState({
                replyToCommentId: parentCommentId,
                location: location,
                replyToCommentUser: user,
                replyToContributorUsers: contributorUsers
            });
        },
    setReplyToContributorUsers: (users)=>({ setState: setState })=>{
            setState({
                replyToContributorUsers: users
            });
        },
    resetInitialDataLoadedMap: ()=>({ setState: setState })=>{
            setState($4440a0699c7a4c4d$var$getInitialState());
        },
    setCurrentlyRenderedThreads: (threads)=>({ setState: setState })=>{
            setState({
                currentlyRenderedThreads: threads
            });
        },
    addFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.add(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    removeFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.delete(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    setCommentMode: (mode)=>({ setState: setState })=>{
            setState({
                commentMode: mode
            });
        },
    setIsCommentAddPromptFocused: (isFocused)=>({ setState: setState })=>{
            setState({
                isCommentAddPromptFocused: isFocused
            });
        },
    resetCommentMode: ()=>({ setState: setState })=>{
            setState({
                commentMode: "view",
                isCommentAddPromptFocused: false
            });
        },
    setCommentContainerToFocus: (commentContainerToFocus)=>({ setState: setState })=>{
            setState({
                commentContainerToFocus: commentContainerToFocus
            });
        },
    setAddFooterCommentAdf: (addFooterCommentAdf)=>({ setState: setState })=>{
            setState({
                addFooterCommentAdf: addFooterCommentAdf
            });
        },
    setCachedSummary: (cachedSummary)=>({ setState: setState })=>{
            setState({
                cachedSummary: cachedSummary
            });
        },
    setCurrentSidebarTab: (tab)=>({ setState: setState })=>{
            setState({
                currentSidebarTab: tab
            });
        },
    setTriggerOnDemandSummary: (triggerOnDemandSummary)=>({ setState: setState })=>{
            setState({
                triggerOnDemandSummary: triggerOnDemandSummary
            });
        },
    setIsSummaryDismissedByUser: (isSummaryDismissedByUser)=>({ setState: setState })=>{
            setState({
                isSummaryDismissedByUser: isSummaryDismissedByUser
            });
        },
    setAutomaticSummariesPreference: (automaticSummariesPreference)=>({ setState: setState })=>{
            setState({
                automaticSummariesPreference: automaticSummariesPreference
            });
        }
};
const $4440a0699c7a4c4d$var$CommentsStore = (0, $8s9DV.createStore)({
    initialState: $4440a0699c7a4c4d$var$getInitialState(),
    actions: $4440a0699c7a4c4d$var$actions,
    name: 'CommentsStore'
});
const $4440a0699c7a4c4d$export$8607294e360a4610 = (0, $kBr4q.createHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$1719a5796ebd8e85 = (0, $kBr4q.createActionsHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb = (0, $kBr4q.createStateHook)($4440a0699c7a4c4d$var$CommentsStore);
module.exports["ViewValues"] = $4440a0699c7a4c4d$export$ca559f4ef107f965;
module.exports["SortValues"] = $4440a0699c7a4c4d$export$edda0a7e0ba757fd;
module.exports["CommentMode"] = $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c;
module.exports["AddFooterCommentMode"] = $4440a0699c7a4c4d$export$94f8d08c2312472b;
module.exports["SidebarTabValues"] = $4440a0699c7a4c4d$export$6a393d893fab1730;
module.exports["useCommentsPanel"] = $4440a0699c7a4c4d$export$8607294e360a4610;
module.exports["useCommentsPanelActions"] = $4440a0699c7a4c4d$export$1719a5796ebd8e85;
module.exports["useCommentsPanelState"] = $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb;

});

parcelRegister("8i27m", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $3u5lg = parcelRequire("3u5lg");


var $6mKj3 = parcelRequire("6mKj3");


var $7W8i8 = parcelRequire("7W8i8");


var $3ZsvI = parcelRequire("3ZsvI");

const $33a0cfbfba499043$var$logger = (0, $7W8i8.getLogger)('comments-data');
var $33a0cfbfba499043$export$ffa1150e6a48f9cd = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    return CommentType;
}({});
var $33a0cfbfba499043$export$74159dff405238c0 = /*#__PURE__*/ function(CommentActionType) {
    CommentActionType["CREATE_COMMENT"] = "created";
    CommentActionType["DELETE_COMMENT"] = "deleted";
    // If you ever update this, please also update commentsNavigationUtils, which relies on the string to avoid circular deps
    CommentActionType["RESOLVE_COMMENT_THREAD"] = "resolved";
    CommentActionType["REOPEN_COMMENT_THREAD"] = "reopened";
    CommentActionType["REATTACH_COMMENT"] = "reattach";
    return CommentActionType;
}({});
var $33a0cfbfba499043$export$2021eb0669e47276 = /*#__PURE__*/ function(FooterCommentsLoadingStateType) {
    FooterCommentsLoadingStateType["NOT_LOADED"] = "not_loaded";
    FooterCommentsLoadingStateType["PRELOADING"] = "preloading";
    FooterCommentsLoadingStateType["PARTIALLY_LOADED"] = "partially_loaded";
    FooterCommentsLoadingStateType["FULLY_LOADED"] = "fully_loaded";
    return FooterCommentsLoadingStateType;
}({});
const $33a0cfbfba499043$export$53ac33307b5acee9 = ()=>({
        orderedActiveAnnotationIdList: [],
        commentsDataMap: {
            inline: {},
            general: {}
        },
        removedThreadsMap: {
            inline: {},
            general: {}
        },
        commentThreadsRemovedByOtherUsers: {},
        hasNestedComments: false,
        cacheUpdateFailed: false,
        footerCommentsLoadingState: "not_loaded"
    });
const $33a0cfbfba499043$export$e324594224ef24da = {
    setCommentsDataMap: (newCommentsDataMap)=>({ getState: getState, setState: setState })=>{
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return;
            const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = getState();
            const parentCommentThreadKeys = new Set(Object.keys(newCommentsDataMap.inline));
            // Update the loaded status of annotations based on newCommentsDataMap
            const updatedAnnotationList = orderedActiveAnnotationIdList.map((annotation)=>({
                    ...annotation,
                    isLoaded: parentCommentThreadKeys.has(annotation.threadKey)
                }));
            const hasNestedComments = (0, $3ZsvI.parseHasNestedComments)(newCommentsDataMap);
            setState({
                commentsDataMap: newCommentsDataMap,
                orderedActiveAnnotationIdList: updatedAnnotationList,
                hasNestedComments: hasNestedComments
            });
        },
    setOrderedActiveAnnotationIdList: (newCommentsList)=>({ getState: getState, setState: setState })=>{
            const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = getState();
            if (!newCommentsList || newCommentsList.length === 0) {
                // Only update state if the current list is not already empty
                if (orderedActiveAnnotationIdList.length > 0) setState({
                    orderedActiveAnnotationIdList: []
                });
                return;
            }
            // Create a map of existing annotationId to their isLoaded states for quick lookup
            const existingAnnotationsMap = new Map(orderedActiveAnnotationIdList.map(({ threadKey: threadKey, isLoaded: isLoaded })=>[
                    threadKey,
                    isLoaded
                ]));
            // Use a Set to ensure unique annotation IDs
            const uniqueCommentsSet = new Set(newCommentsList);
            // Map the unique comments set to the new state, preserving isLoaded where possible
            const updatedAnnotationList = Array.from(uniqueCommentsSet).map((threadKey)=>({
                    threadKey: threadKey,
                    isLoaded: existingAnnotationsMap.get(threadKey) ?? false // Preserve existing isLoaded or default to false
                }));
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(orderedActiveAnnotationIdList, updatedAnnotationList)) setState({
                orderedActiveAnnotationIdList: updatedAnnotationList
            });
        },
    updateReactionsSummary: (emojiId, actionType, commentId, commentType, readReactionsSummaryFragment, writeReactionsSummaryFragment, pageId, threadKey)=>({ setState: setState, getState: getState })=>{
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return;
            const updateReactionsForComment = (commentData, emojiId, actionType)=>{
                let { reactionsSummary: reactionsSummary } = commentData || {};
                // COMMENTS-6745: When a comment/reply is created from the Comments panel, the
                // create-comment mutation excludes reactions (`includeReactions: false`), so the
                // new entry in this sweet-state datasource has no `reactionsSummary`. Previously
                // this function bailed out for such comments, leaving the optimistic reaction
                // update silently dropped — and because the surrounding action still calls
                // `setState`, the panel re-rendered which reset the AkReactions internal
                // optimistic state, so the new emoji vanished from BOTH the panel AND the footer
                // view (which both render from this sweet-state via `inheritedReactionsData`).
                // Behind `confluence_comments_comments_6745`, lazily initialize an empty summary
                // so the optimistic add can actually be applied, mirroring what the footer
                // (object-comments) flow does for newly created comments.
                if (!reactionsSummary && commentData && (0, $6mKj3.expValEquals)('confluence_comments_comments_6745', 'isEnabled', true)) reactionsSummary = {
                    ari: '',
                    containerAri: '',
                    reactionsCount: 0,
                    reactionsSummaryForEmoji: [],
                    __typename: 'ReactionsSummaryResponse'
                };
                if (!reactionsSummary) return;
                const reactionsAri = reactionsSummary?.ari || '';
                const reactionsContainerAri = reactionsSummary?.containerAri || '';
                const reactionsNodes = reactionsSummary?.reactionsSummaryForEmoji || [];
                let updatedReactionsNodes = reactionsNodes.map((item)=>item ? {
                        ...item
                    } : item);
                const updatedReactionsSummary = {
                    ...reactionsSummary
                };
                if (actionType === 'add') {
                    const reactionIdx = updatedReactionsNodes.findIndex((item)=>item?.emojiId === emojiId);
                    // If the reaction exists and the user has not reacted, add the user and increment the count
                    if (reactionIdx !== -1 && updatedReactionsNodes[reactionIdx] && !updatedReactionsNodes[reactionIdx].reacted) updatedReactionsNodes[reactionIdx] = {
                        ...updatedReactionsNodes[reactionIdx],
                        count: updatedReactionsNodes[reactionIdx].count + 1,
                        reacted: true
                    };
                    else if (reactionIdx === -1) // If the reaction does not exist, create a new reaction
                    updatedReactionsNodes.push({
                        emojiId: emojiId,
                        count: 1,
                        reacted: true,
                        id: `${reactionsContainerAri}|${reactionsAri}|${emojiId}`
                    });
                } else if (actionType === 'delete') {
                    const reactionIdx = updatedReactionsNodes.findIndex((item)=>item?.emojiId === emojiId);
                    // If the reaction exists, update its attributes
                    if (reactionIdx !== -1) {
                        const reaction = updatedReactionsNodes[reactionIdx];
                        // If the reaction exists and the user has reacted, remove the user and decrement the count
                        if (reaction && reaction.reacted) updatedReactionsNodes[reactionIdx] = {
                            ...reaction,
                            count: reaction.count - 1,
                            reacted: false
                        };
                        // If the reaction exists and has no reactions, remove the reaction
                        if (updatedReactionsNodes[reactionIdx] && updatedReactionsNodes[reactionIdx].count <= 0) updatedReactionsNodes = [
                            ...updatedReactionsNodes.slice(0, reactionIdx),
                            ...updatedReactionsNodes.slice(reactionIdx + 1)
                        ];
                    }
                }
                updatedReactionsSummary.reactionsSummaryForEmoji = updatedReactionsNodes;
                updatedReactionsSummary.reactionsCount = updatedReactionsNodes.reduce((total, reaction)=>total + (reaction?.count || 0), 0);
                if (commentData) commentData.reactionsSummary = updatedReactionsSummary;
            };
            try {
                const reactionsSummaryId = `$Comment:${commentId}.reactionsSummary(${JSON.stringify({
                    childType: 'comment',
                    contentType: 'page',
                    pageId: pageId
                })})`;
                const reactionsSummary = readReactionsSummaryFragment({
                    id: reactionsSummaryId
                });
                if (reactionsSummary) {
                    const commentReactionsSummary = {
                        ...reactionsSummary
                    };
                    updateReactionsForComment(commentReactionsSummary, emojiId, actionType);
                    writeReactionsSummaryFragment({
                        fragmentId: reactionsSummaryId,
                        data: commentReactionsSummary
                    });
                }
                const repliesReactionsSummaryId = `$Comment:${commentId}.replies.reactionsSummary(${JSON.stringify({
                    childType: 'comment',
                    contentType: 'page',
                    pageId: pageId
                })})`;
                const repliesReactionsSummary = readReactionsSummaryFragment({
                    id: repliesReactionsSummaryId
                });
                if (repliesReactionsSummary) {
                    const updatedRepliesReactionsSummary = {
                        reactionsSummary: repliesReactionsSummary
                    };
                    updateReactionsForComment(repliesReactionsSummary, emojiId, actionType);
                    writeReactionsSummaryFragment({
                        fragmentId: repliesReactionsSummaryId,
                        data: updatedRepliesReactionsSummary
                    });
                }
            } catch (err) {
                $33a0cfbfba499043$var$logger.error`An error occurred when updating comments panel cache - ${err}`;
            }
            // Update the comment datasource
            const { commentsDataMap: commentsDataMap } = getState();
            const updatedMap = {
                ...commentsDataMap
            };
            if (!threadKey) return;
            const comment = updatedMap[commentType][threadKey];
            let reply;
            // If the comment doesn't exist in the map, just return
            if (!comment) return;
            // If the comment IDs don't match, this is a reply, find it and use that
            if (comment.id !== commentId) {
                reply = comment.replies.find((r)=>r.id === commentId);
                // If we don't find the reply after that, just return
                if (!reply) return;
            }
            updateReactionsForComment(reply || comment, emojiId, actionType);
            setState({
                commentsDataMap: updatedMap
            });
        },
    addNewCommentThreads: (newCommentThreads)=>({ setState: setState, getState: getState })=>{
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return;
            const { commentsDataMap: commentsDataMap, orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, hasNestedComments: hasNestedComments } = getState();
            const updatedCommentsDataMap = {
                ...commentsDataMap
            };
            // Add the comment threads for inline
            for(const threadKey in newCommentThreads.inline){
                const newCommentThread = newCommentThreads.inline[threadKey];
                updatedCommentsDataMap.inline[threadKey] = newCommentThread;
            }
            // Add the comment threads for general
            for(const threadKey in newCommentThreads.general){
                const newCommentThread = newCommentThreads.general[threadKey];
                updatedCommentsDataMap.general[threadKey] = newCommentThread;
            }
            // Update the loaded status of annotations
            const updatedAnnotationList = orderedActiveAnnotationIdList.map((annotation)=>({
                    ...annotation,
                    isLoaded: Object.keys(newCommentThreads).includes(annotation.threadKey) ? true : annotation.isLoaded
                }));
            // No need to reparse if we've already found a case
            const newHasNestedComments = hasNestedComments || (0, $3ZsvI.parseHasNestedComments)(updatedCommentsDataMap);
            setState({
                commentsDataMap: updatedCommentsDataMap,
                orderedActiveAnnotationIdList: updatedAnnotationList,
                hasNestedComments: newHasNestedComments
            });
        },
    addReplyToCommentThread: (threadKey, reply, commentType, sortReplies = false)=>({ setState: setState, getState: getState })=>{
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return;
            const { commentsDataMap: commentsDataMap } = getState();
            const updatedCommentsDataMap = {
                ...commentsDataMap
            };
            const parentCommentThread = updatedCommentsDataMap[commentType][threadKey];
            if (parentCommentThread) {
                // Ensure replies array exists
                const existingReplies = parentCommentThread.replies || [];
                // due to the nature of how we are sending multiple pubsub events are being sent for comment creation, we have to check for a duplicate before adding a reply
                const replyExists = existingReplies.some((existingReply)=>existingReply.id === reply.id);
                if (!replyExists) {
                    const updatedReplies = [
                        ...existingReplies,
                        reply
                    ];
                    if (sortReplies && (0, $6mKj3.expVal)('confluence_fe_delete_comment_optimistic', 'isEnabled', false)) // sort replies by createdAtNonLocalized in ascending order
                    // each createdAtNonLocalized is a string in ISO format, e.g. "2026-01-02T03:45:67.890Z"
                    updatedReplies.sort((a, b)=>a.createdAtNonLocalized.localeCompare(b.createdAtNonLocalized));
                    const updatedParentCommentThread = {
                        ...parentCommentThread,
                        replies: updatedReplies
                    };
                    updatedCommentsDataMap[commentType][threadKey] = updatedParentCommentThread;
                    setState({
                        commentsDataMap: updatedCommentsDataMap
                    });
                }
            }
        },
    getCurrentCommentsPanelState: ()=>({ getState: getState })=>{
            return getState();
        },
    setFooterCommentsLoadingState: (footerCommentsLoadingState)=>({ setState: setState })=>{
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return;
            setState({
                footerCommentsLoadingState: footerCommentsLoadingState
            });
        },
    updateCommentBody: (commentId, threadKey, newBodyValue, commentType, displayName = null // Ensure displayName is not undefined for typechecking
    )=>({ setState: setState, getState: getState })=>{
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return;
            // Find the comment in the map
            const { commentsDataMap: commentsDataMap } = getState();
            // Make a copy of the map so if looks like a new object in shallow comparisons and also
            // avoids mutating the original map
            const updatedMap = {
                ...commentsDataMap
            };
            // The "parentComment" is either the comment itself (if a top-level comment) or the parent of
            // the reply thread
            const parentComment = updatedMap[commentType][threadKey];
            if (parentComment) {
                // If the modified comment is a top-level comment, update the body value
                if (parentComment.id === commentId) {
                    // Make a copy of the comment and update the body value, then put it back into the map
                    const updatedComment = {
                        ...parentComment,
                        body: {
                            value: newBodyValue
                        },
                        version: {
                            ...parentComment.version,
                            by: {
                                ...parentComment.version?.by,
                                displayName: displayName
                            },
                            number: (parentComment.version?.number ?? 0) + 1,
                            when: new Date().toISOString()
                        }
                    };
                    updatedMap[commentType][threadKey] = updatedComment;
                    setState({
                        commentsDataMap: updatedMap
                    });
                } else // Else we didn't find the comment at the top-level, check the replies
                for(let replyIndex = 0; replyIndex < parentComment.replies.length; replyIndex++){
                    const reply = parentComment.replies[replyIndex];
                    if (reply.id === commentId) {
                        // Make a copy of the comment and update the reply's body value, then put it back into the map
                        const updatedReply = {
                            ...reply,
                            body: {
                                value: newBodyValue
                            },
                            version: {
                                ...reply.version,
                                by: {
                                    ...reply.version?.by,
                                    displayName: displayName
                                },
                                number: (reply.version?.number ?? 0) + 1,
                                when: new Date().toISOString()
                            }
                        };
                        // (A reminder that ... does a shallow copy, so we need to copy the replies array as well)
                        const updatedComment = {
                            ...parentComment,
                            replies: [
                                ...parentComment.replies
                            ]
                        };
                        updatedComment.replies[replyIndex] = updatedReply;
                        updatedMap[commentType][threadKey] = updatedComment;
                        setState({
                            commentsDataMap: updatedMap
                        });
                        break;
                    }
                }
            }
        },
    // keep track of removed annotations as well as update removed comments with wasRemovedByAnotherUser
    updateRemovedCommentIdsMap: ({ threadKey: threadKey, commentId: commentId, commentActionType: commentActionType, isReply: isReply, commentType: commentType, resolvedProperties: resolvedProperties })=>({ setState: setState, getState: getState })=>{
            const { commentThreadsRemovedByOtherUsers: commentThreadsRemovedByOtherUsers } = getState();
            if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                const { commentsDataMap: commentsDataMap, orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, removedThreadsMap: removedThreadsMap } = getState();
                const updatedCommentsDataMap = {
                    ...commentsDataMap
                };
                const commentThread = updatedCommentsDataMap[commentType][threadKey];
                if (commentThread) {
                    if (isReply) {
                        const updatedCommentThreadReplies = commentThread.replies.map((r)=>{
                            if (r.id === commentId) return {
                                ...r,
                                wasRemovedByAnotherUser: commentActionType
                            };
                            return r;
                        });
                        updatedCommentsDataMap[commentType][threadKey] = {
                            ...commentThread,
                            replies: updatedCommentThreadReplies
                        };
                    } else if (resolvedProperties) {
                        if (commentType === "inline" && resolvedProperties.inlineResolveProperties) updatedCommentsDataMap[commentType][threadKey] = {
                            ...commentThread,
                            location: {
                                type: 'INLINE',
                                inlineMarkerRef: threadKey,
                                inlineResolveProperties: resolvedProperties.inlineResolveProperties,
                                inlineText: resolvedProperties.inlineText || ''
                            },
                            isOpen: false,
                            wasRemovedByAnotherUser: commentActionType
                        };
                        else updatedCommentsDataMap[commentType][threadKey] = {
                            ...commentThread,
                            location: {
                                commentResolveProperties: {
                                    resolved: resolvedProperties.resolved || false,
                                    resolvedFriendlyDate: resolvedProperties.resolvedFriendlyDate || '',
                                    resolvedTime: resolvedProperties.resolvedTime || 0,
                                    resolvedUser: resolvedProperties.resolvedUser || ''
                                },
                                type: 'GENERAL'
                            },
                            isOpen: false,
                            wasRemovedByAnotherUser: commentActionType
                        };
                    } else updatedCommentsDataMap[commentType][threadKey] = {
                        ...commentThread,
                        isOpen: false,
                        wasRemovedByAnotherUser: commentActionType
                    };
                    const updatedRemovedThreadsMap = {
                        ...removedThreadsMap
                    };
                    let threadKeyId = -1;
                    if (commentType === "inline") {
                        // since orderedActiveAnnotationIdList will not include previously removed annotations, we need to add in annotations in removedThreadsMap
                        // so that we can correctly find the index of the removed annotation
                        const inlineThreadKeyList = orderedActiveAnnotationIdList.map((a)=>a.threadKey);
                        Object.entries(updatedRemovedThreadsMap.inline).forEach(([index, key])=>{
                            const position = parseInt(index, 10); // Ensure the index is treated as a number
                            inlineThreadKeyList.splice(position, 0, key);
                        });
                        threadKeyId = inlineThreadKeyList.findIndex((key)=>key === threadKey);
                    } else {
                        // General comments are ordered correctly in the map by timestamp
                        const orderedGeneralThreadKeyList = Object.keys(commentsDataMap.general);
                        threadKeyId = orderedGeneralThreadKeyList.findIndex((key)=>key === threadKey);
                    }
                    if (threadKeyId !== -1) updatedRemovedThreadsMap[commentType][threadKeyId] = threadKey;
                    setState({
                        commentsDataMap: updatedCommentsDataMap,
                        removedThreadsMap: updatedRemovedThreadsMap
                    });
                }
            }
            // Update commentThreadsRemovedByOtherUsers map
            const updatedRemovedComments = {
                ...commentThreadsRemovedByOtherUsers
            };
            updatedRemovedComments[commentId] = commentActionType;
            // Internally, this will be batched with the other state updates when cc_comments_new_comments_data_manager is disabled
            setState({
                commentThreadsRemovedByOtherUsers: updatedRemovedComments
            });
        },
    handleRemovingComments: ({ threadKey: threadKey, commentId: commentId, action: action, commentType: commentType })=>({ setState: setState, getState: getState })=>{
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return;
            const { commentsDataMap: commentsDataMap } = getState();
            const updatedCommentsDataMap = {
                ...commentsDataMap
            };
            const parentCommentThread = updatedCommentsDataMap[commentType][threadKey];
            if (parentCommentThread) {
                if (action === "resolved" && parentCommentThread.id === commentId) {
                    // If the action is to resolve the thread and the commentId matches the parent, remove the thread
                    delete updatedCommentsDataMap[commentType][threadKey];
                    setState({
                        commentsDataMap: updatedCommentsDataMap
                    });
                } else if (action === "deleted") {
                    // If the action is to delete a reply, filter out the reply with the specified commentId
                    const updatedReplies = parentCommentThread.replies.filter((reply)=>reply.id !== commentId);
                    updatedCommentsDataMap[commentType][threadKey] = {
                        ...parentCommentThread,
                        replies: updatedReplies
                    };
                    // Update the parent comment thread with the filtered replies
                    setState({
                        commentsDataMap: updatedCommentsDataMap
                    });
                }
            }
        },
    resolveParentComment: ({ threadKey: threadKey, commentType: commentType })=>({ setState: setState, getState: getState })=>{
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return;
            const { commentsDataMap: commentsDataMap } = getState();
            const updatedCommentsDataMap = {
                ...commentsDataMap
            };
            const parentCommentThread = updatedCommentsDataMap[commentType][threadKey];
            if (parentCommentThread) {
                parentCommentThread.isOpen = false;
                setState({
                    commentsDataMap: updatedCommentsDataMap
                });
            }
        },
    reopenParentComment: ({ threadKey: threadKey, commentType: commentType, parentCommentId: parentCommentId })=>({ setState: setState, getState: getState })=>{
            // With new data manager enabled we ONLY update commentThreadsRemovedByOtherUsers.
            // Once the experiment is out, we should probably rename this function
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                if (!parentCommentId) return;
                const { commentThreadsRemovedByOtherUsers: currentRemovedComments } = getState();
                const updatedRemovedComments = {
                    ...currentRemovedComments
                };
                delete updatedRemovedComments[parentCommentId];
                setState({
                    commentThreadsRemovedByOtherUsers: updatedRemovedComments
                });
                return;
            }
            const { commentsDataMap: commentsDataMap, commentThreadsRemovedByOtherUsers: commentThreadsRemovedByOtherUsers } = getState();
            const updatedCommentsDataMap = {
                ...commentsDataMap
            };
            const parentCommentThread = updatedCommentsDataMap[commentType][threadKey];
            if (parentCommentThread) {
                parentCommentThread.isOpen = true;
                // Remove from commentThreadsRemovedByOtherUsers when reopened
                const updatedRemovedComments = {
                    ...commentThreadsRemovedByOtherUsers
                };
                delete updatedRemovedComments[parentCommentThread.id];
                setState({
                    commentsDataMap: updatedCommentsDataMap,
                    commentThreadsRemovedByOtherUsers: updatedRemovedComments
                });
            }
        },
    deleteParentComment: ({ threadKey: threadKey, commentType: commentType })=>({ setState: setState, getState: getState })=>{
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return;
            const { commentsDataMap: commentsDataMap } = getState();
            const updatedCommentsDataMap = {
                ...commentsDataMap
            };
            const parentCommentThread = updatedCommentsDataMap[commentType][threadKey];
            if (parentCommentThread) {
                delete updatedCommentsDataMap[commentType][threadKey];
                setState({
                    commentsDataMap: updatedCommentsDataMap
                });
            }
        },
    clearRemovedComments: ()=>({ getState: getState, setState: setState })=>{
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                setState({
                    commentThreadsRemovedByOtherUsers: {}
                });
                return;
            }
            const { commentsDataMap: commentsDataMap } = getState();
            const commentsDataMapCopy = {
                ...commentsDataMap
            };
            // Filter out deleted / resolved comments for the legacy comments data map
            const updatedInlineCommentsDataMap = Object.fromEntries(Object.entries(commentsDataMapCopy.inline).filter(([_, commentData])=>!commentData.wasRemovedByAnotherUser).map(([key, commentData])=>[
                    key,
                    {
                        ...commentData,
                        replies: (commentData.replies || []).filter((reply)=>!reply.wasRemovedByAnotherUser)
                    }
                ]));
            const updatedGeneralCommentsDataMap = Object.fromEntries(Object.entries(commentsDataMapCopy.general).filter(([_, commentData])=>!commentData.wasRemovedByAnotherUser).map(([key, commentData])=>[
                    key,
                    {
                        ...commentData,
                        replies: (commentData.replies || []).filter((reply)=>!reply.wasRemovedByAnotherUser)
                    }
                ]));
            setState({
                removedThreadsMap: {
                    inline: {},
                    general: {}
                },
                commentThreadsRemovedByOtherUsers: {},
                commentsDataMap: {
                    inline: updatedInlineCommentsDataMap,
                    general: updatedGeneralCommentsDataMap
                }
            });
        },
    clearCommentsData: ()=>({ setState: setState })=>{
            setState($33a0cfbfba499043$export$53ac33307b5acee9());
        },
    setCacheUpdateFailed: (failed)=>({ setState: setState })=>{
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return;
            setState({
                cacheUpdateFailed: failed
            });
        }
};
const $33a0cfbfba499043$export$13b7c646235a7fd4 = (0, $8s9DV.createStore)({
    initialState: $33a0cfbfba499043$export$53ac33307b5acee9(),
    actions: $33a0cfbfba499043$export$e324594224ef24da,
    name: 'CommentsDataStore'
});
const $33a0cfbfba499043$export$80f09eb388fa70f9 = (0, $kBr4q.createHook)($33a0cfbfba499043$export$13b7c646235a7fd4);
const $33a0cfbfba499043$export$b5e3986841a4e13f = (0, $kBr4q.createActionsHook)($33a0cfbfba499043$export$13b7c646235a7fd4);
const $33a0cfbfba499043$export$c14a8182bd597724 = (0, $kBr4q.createStateHook)($33a0cfbfba499043$export$13b7c646235a7fd4);
module.exports["CommentType"] = $33a0cfbfba499043$export$ffa1150e6a48f9cd;
module.exports["CommentActionType"] = $33a0cfbfba499043$export$74159dff405238c0;
module.exports["FooterCommentsLoadingStateType"] = $33a0cfbfba499043$export$2021eb0669e47276;
module.exports["useCommentsData"] = $33a0cfbfba499043$export$80f09eb388fa70f9;
module.exports["useCommentsDataActions"] = $33a0cfbfba499043$export$b5e3986841a4e13f;
module.exports["useCommentsDataState"] = $33a0cfbfba499043$export$c14a8182bd597724;

});

parcelRegister("3ZsvI", function(module, exports) {

var $86okN = parcelRequire("86okN");


var $6mKj3 = parcelRequire("6mKj3");


var $cD1qu = parcelRequire("cD1qu");


var $8i27m = parcelRequire("8i27m");

const $d2d2318c0a6737a0$export$c616a7cf09d59df6 = ({ comment: comment, isOpen: isOpen, type: type })=>{
    return {
        ...comment,
        wasRemovedByAnotherUser: false,
        isOpen: isOpen,
        type: type,
        replies: comment.replies?.map((reply)=>{
            return {
                ...reply,
                reactionsSummary: reply.reactionsSummary ?? null,
                type: type,
                wasRemovedByAnotherUser: false
            };
        })
    };
};
const $d2d2318c0a6737a0$export$e8d1c15bdf6a3ce8 = ({ data: data, pageMode: pageMode, currentUserId: currentUserId, updateData: updateData, isOpen: isOpen = true })=>{
    const inlineCommentThreadsToAdd = {};
    const generalCommentThreadsToAdd = {};
    const loadFooterComments = pageMode !== (0, $cD1qu.PageMode).EDIT;
    data?.comments?.nodes?.forEach((commentNode)=>{
        // Filter out null values
        if (!commentNode) return;
        const comment = {
            ...commentNode,
            reactionsSummary: commentNode?.reactionsSummary ?? null
        };
        // We only want top level comments
        if (comment && !comment.parentId) {
            if (comment.contentStatus === (0, $cD1qu.ContentStatus).DRAFT && pageMode === (0, $cD1qu.PageMode).VIEW) return;
            const commentType = comment.location.type;
            if (commentType === 'INLINE') {
                const threadKey = comment.location.inlineMarkerRef;
                if (threadKey) inlineCommentThreadsToAdd[threadKey] = $d2d2318c0a6737a0$export$c616a7cf09d59df6({
                    comment: comment,
                    currentUserId: currentUserId,
                    isOpen: isOpen,
                    type: (0, $8i27m.CommentType).INLINE
                });
            } else if (commentType === 'FOOTER' && loadFooterComments) {
                const threadKey = comment.id;
                generalCommentThreadsToAdd[threadKey] = $d2d2318c0a6737a0$export$c616a7cf09d59df6({
                    comment: comment,
                    currentUserId: currentUserId,
                    isOpen: isOpen,
                    type: (0, $8i27m.CommentType).GENERAL
                });
            }
        }
    });
    updateData({
        inline: inlineCommentThreadsToAdd,
        general: generalCommentThreadsToAdd
    });
};
const $d2d2318c0a6737a0$export$6036c2c532b2fa41 = (commentsDataMap)=>{
    try {
        const allGeneralComments = Object.values(commentsDataMap.general);
        // To see if there are nested comments, we need to check whether there are any replies whose parentID is not equal to the parent Comment's ID
        // This is because commentsDataMap.general is a flat map of parent comment --> everything below it
        // But each comment has it's own parent id which may be different from it's top level parent
        return allGeneralComments.some((comment)=>{
            return comment?.replies?.some((reply)=>reply.parentId !== comment.id);
        });
    } catch  {
        // Default to false if somehow something goes wrong
        return false;
    }
};
const $d2d2318c0a6737a0$export$f60efc56f0412906 = (activeCommentsQueryResult, updateFn)=>{
    // This should only ever be called with data - however if it isn't we should update state to NOT_LOADED
    if (activeCommentsQueryResult?.comments?.totalCount === undefined) {
        updateFn((0, $8i27m.FooterCommentsLoadingStateType).NOT_LOADED);
        return;
    }
    const loadedCommentCount = activeCommentsQueryResult?.comments?.nodes?.reduce((acc, comment)=>{
        return acc + (comment?.replies?.length || 0) + 1; // return parent + reply count
    }, 0) ?? 0;
    // The BE sometimes will give us mismatched numbers for complex nested scenarios, as long as > 0 call it good
    // This case is super rare (should be <<1% of pages), but if it significantly affects metrics will need another special case
    const allLoaded = loadedCommentCount === activeCommentsQueryResult?.comments?.totalCount;
    if (allLoaded) updateFn((0, $8i27m.FooterCommentsLoadingStateType).FULLY_LOADED);
    else updateFn((0, $8i27m.FooterCommentsLoadingStateType).PARTIALLY_LOADED);
};
const $d2d2318c0a6737a0$export$74e9552da989b708 = (commentsDataMap, commentId)=>{
    // Check if our ID is one of the parent comments, if so return the parent comment
    const findParent = Object.values(commentsDataMap.general).find((comment)=>comment.id === commentId || comment.replies?.some((reply)=>reply.id === commentId));
    if (!findParent) return null;
    if (findParent?.id === commentId) return findParent;
    else return findParent.replies?.find((reply)=>reply.id === commentId);
};
const $d2d2318c0a6737a0$export$92c95f9748a31706 = (commentsDataMap, commentId)=>{
    return Object.values(commentsDataMap.general).find((comment)=>comment.id === commentId || comment.replies?.some((reply)=>reply.id === commentId));
};
const $d2d2318c0a6737a0$export$f41a637cf0ebe6d7 = (commentsDataMap, commentType, threadKey, addNewCommentThreads)=>{
    $d2d2318c0a6737a0$var$setCommentIsOpenInDataMap(false, commentsDataMap, commentType, threadKey, addNewCommentThreads);
};
const $d2d2318c0a6737a0$export$906b5ebcd439e0e3 = (commentsDataMap, commentType, threadKey, addNewCommentThreads)=>{
    $d2d2318c0a6737a0$var$setCommentIsOpenInDataMap(true, commentsDataMap, commentType, threadKey, addNewCommentThreads);
};
const $d2d2318c0a6737a0$var$setCommentIsOpenInDataMap = (isOpen, commentsDataMap, commentType, threadKey, addNewCommentThreads)=>{
    const commentsDataMapClone = {
        ...commentsDataMap
    };
    const commentInMap = commentsDataMapClone[commentType][threadKey];
    if (commentInMap) {
        commentInMap.isOpen = isOpen;
        if (isOpen) commentInMap.wasRemovedByAnotherUser = false;
        // Handle both cases of when comment is Inline or General.
        // Only one of the following two properties will be present.
        const commentLocation = commentInMap.location;
        if (commentLocation && 'commentResolveProperties' in commentLocation && commentLocation.commentResolveProperties) commentLocation.commentResolveProperties.resolved = !isOpen;
        if (commentLocation && 'inlineResolveProperties' in commentLocation && commentLocation.inlineResolveProperties) commentLocation.inlineResolveProperties.resolved = !isOpen;
        addNewCommentThreads(commentsDataMapClone);
    }
};
const $d2d2318c0a6737a0$export$fa74ef5ad1b77480 = ({ cache: cache, commentId: commentId, query: query, queryVariables: queryVariables, cacheUpdateFailed: cacheUpdateFailed, setCacheUpdateFailed: setCacheUpdateFailed, source: source, logger: logger })=>{
    // readQuery can still return null which complicates TS lint errors with optional chaining
    // once we move to v3 of the apollo client we can move to cache.modify
    try {
        let dataProxy = undefined;
        try {
            dataProxy = cache.readQuery({
                query: (0, $86okN.toDocumentNode)(query),
                variables: queryVariables
            });
        } catch (err) {
            // It's possible that the cache does not contain a matchign entry for `query`.
            // In this case, an error "Invariant Violation: Invariant Violation: 8"
            // is thrown, which we can safely ignore and skip this cache update.
            if ((0, $6mKj3.expVal)('confluence_fe_resolve_comment_optimistic', 'isEnabled', false)) {
                logger.warn`Unable to read cache for ${source} resolve - ${err}`;
                return;
            } else throw err;
        }
        const commentsToWrite = Object.assign({}, dataProxy?.comments);
        let totalCount = commentsToWrite.totalCount || 0;
        const commentsList = commentsToWrite.nodes?.filter((n)=>n !== null);
        const idxToRemove = commentsList.findIndex((c)=>c.id === commentId);
        // Remove the newly resolved comment from the list if we can find it.
        if (idxToRemove !== -1) {
            commentsList.splice(idxToRemove, 1);
            totalCount--;
        }
        // Otherwise, no need to update the cache.
        // Merge with if block above after shipping this experiment.
        if (idxToRemove !== -1 || !(0, $6mKj3.expVal)('confluence_fe_resolve_comment_optimistic', 'isEnabled', false)) cache.writeQuery({
            query: (0, $86okN.toDocumentNode)(query),
            variables: queryVariables,
            data: {
                comments: {
                    nodes: commentsList,
                    totalCount: totalCount,
                    __typename: 'PaginatedCommentList'
                }
            }
        });
        // cache updated successfuly
        // now check if previous cache update was failed
        if (cacheUpdateFailed) setCacheUpdateFailed(false);
    } catch (err) {
        logger.error`An error occurred when updating cache for ${source} resolve - ${err}`;
        setCacheUpdateFailed(true);
    }
};
module.exports["normalizeCommentData"] = $d2d2318c0a6737a0$export$c616a7cf09d59df6;
module.exports["updateCommentsDataState"] = $d2d2318c0a6737a0$export$e8d1c15bdf6a3ce8;
module.exports["parseHasNestedComments"] = $d2d2318c0a6737a0$export$6036c2c532b2fa41;
module.exports["updateFooterCommentsLoadingState"] = $d2d2318c0a6737a0$export$f60efc56f0412906;
module.exports["resolveCommentInDataMap"] = $d2d2318c0a6737a0$export$f41a637cf0ebe6d7;
module.exports["reopenCommentInDataMap"] = $d2d2318c0a6737a0$export$906b5ebcd439e0e3;
module.exports["updateCommentsQueryCacheForResolve"] = $d2d2318c0a6737a0$export$fa74ef5ad1b77480;

});

parcelRegister("cD1qu", function(module, exports) {
var $7825447594ee3eb0$export$6ea4b0c62affbe44 = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}({});
var $7825447594ee3eb0$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "current";
    ContentStatus["DRAFT"] = "draft";
    ContentStatus["ARCHIVED"] = "archived";
    return ContentStatus;
}({});
const $7825447594ee3eb0$export$5d7c5e13dde1e9b8 = [
    "draft"
];
const $7825447594ee3eb0$export$c75005e52070dee = [
    "current"
];
module.exports["PageMode"] = $7825447594ee3eb0$export$6ea4b0c62affbe44;
module.exports["ContentStatus"] = $7825447594ee3eb0$export$b2be22e9d5dd3927;
module.exports["DRAFT_STATUS"] = $7825447594ee3eb0$export$5d7c5e13dde1e9b8;
module.exports["CURRENT_STATUS"] = $7825447594ee3eb0$export$c75005e52070dee;

});

parcelRegister("kgNLQ", function(module, exports) {

var $cD1qu = parcelRequire("cD1qu");


var $6mKj3 = parcelRequire("6mKj3");


var $jbF1h = parcelRequire("jbF1h");

var $344a24116515d334$export$ffa1150e6a48f9cd = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    return CommentType;
}({});
const $344a24116515d334$export$4883f94fcd5fa7aa = {
    ari: '',
    containerAri: '',
    reactionsCount: 0,
    reactionsSummaryForEmoji: [],
    __typename: 'ReactionsSummaryResponse'
};
const $344a24116515d334$export$99a332599a946905 = '998765432100';
const $344a24116515d334$export$c6a7031105fdebc = (commentData, commentId)=>{
    // Search in retreived comments and their replies
    for (const comment of commentData){
        // Check if this is the comment we're looking for
        if (comment?.id === commentId) return comment;
        // Check if it's in the replies
        if (comment?.replies) {
            const foundReply = comment.replies.find((reply)=>reply?.id === commentId);
            if (foundReply) return foundReply;
        }
    }
    // else comment not found
    return undefined;
};
const $344a24116515d334$export$fb9051669482cbe0 = (condition, trueFn, falseFn)=>condition ? trueFn : falseFn;
const $344a24116515d334$export$6ba3a6375d12d24f = (commentData, replyParentId)=>{
    // Search through each root level comment's replies
    for (const comment of commentData){
        // Return this comment if it is the parent of the reply, else check if this comment has replies
        // and if any of them have the matching parentId
        if (comment?.id === replyParentId || comment?.replies.find((reply)=>reply?.id === replyParentId)) return comment;
    }
    // else comment not found
    return undefined;
};
const $344a24116515d334$export$3e4a472ec0de2dc6 = (commentData, markerRef)=>{
    // Search in retrieved comments and their replies
    for (const comment of commentData){
        // Check if this comment's marker ref matches
        const location = comment?.location;
        if (location?.inlineMarkerRef === markerRef) return comment;
    }
    return undefined;
};
const $344a24116515d334$export$499492f953d5abba = (comments, commentId, markerRef, contentStatus)=>{
    if (comments.length === 0) return undefined;
    let foundComment;
    if (commentId) foundComment = $344a24116515d334$export$c6a7031105fdebc(comments, commentId);
    else if (markerRef) foundComment = $344a24116515d334$export$3e4a472ec0de2dc6(comments, markerRef);
    if (!foundComment) return undefined;
    // Filter by contentStatus before returning
    const matchesContentStatusFilter = (comment)=>{
        if (!comment || !comment.contentStatus) return false;
        // Convert comment's contentStatus to uppercase to match GraphQLContentStatus format
        const commentStatus = comment.contentStatus.toUpperCase();
        return contentStatus.includes(commentStatus);
    };
    if (matchesContentStatusFilter(foundComment)) return foundComment;
    return undefined;
};
const $344a24116515d334$export$4d95f4b945556294 = (comment, mutationResult)=>{
    const resolveInlineComment = mutationResult?.data?.resolveInlineComment;
    const mutationStatus = resolveInlineComment?.status ?? false;
    const resolveProperties = resolveInlineComment?.resolveProperties ?? undefined;
    return (0, $jbF1h.resolveCommentInCache)({
        comment: comment,
        mutationStatus: mutationStatus,
        resolveProperties: resolveProperties
    });
};
const $344a24116515d334$export$d81a62b32f0e420f = (comment, mutationResult)=>{
    const commentResolutionStates = mutationResult?.data?.confluence_resolveComments?.commentResolutionStates;
    if ((commentResolutionStates?.length ?? 0) > 1) throw new Error('resolveCommentInCacheCallback() only supports one comment resolution state per mutation call');
    const firstResolutionState = commentResolutionStates?.[0] ?? undefined;
    const mutationStatus = firstResolutionState?.status ?? false;
    const partialResolveProperties = firstResolutionState?.resolveProperties ?? undefined;
    // We need to ensure that resolveProperties contains all non-optional properties so we can safely
    // spread it into the comment location resolve properties, so choose defaults for any missing
    // ones.  This is needed because some of the mutations don't request all the properties in their
    // responses.
    const resolveProperties = partialResolveProperties ? {
        resolved: true,
        // This mutation only resolves comments
        isDangling: false,
        // Assumes resolved comments are never dangling
        // These are nullable in the schema, but included to make Typescript happy
        resolvedUser: undefined,
        resolvedFriendlyDate: undefined,
        resolvedTime: undefined,
        // Add any non-null/undefined properties from the mutation result
        ...partialResolveProperties
    } : undefined;
    return (0, $jbF1h.resolveCommentInCache)({
        comment: comment,
        mutationStatus: mutationStatus,
        resolveProperties: resolveProperties
    });
};
const $344a24116515d334$export$aa65246494e3c3e0 = (comment, mutationResult)=>{
    // (The property is called "commentResolutionStates" but there is only one item per mutation call)
    const commentResolutionStates = mutationResult?.data?.confluence_reopenComment?.commentResolutionStates;
    if (commentResolutionStates) {
        const mutationStatus = commentResolutionStates.status ?? false;
        const partialResolveProperties = commentResolutionStates.resolveProperties ?? undefined;
        // We need to ensure that resolveProperties contains all non-optional properties so we can safely
        // spread it into the comment location resolve properties, so choose defaults for any missing
        // ones. This is needed because some of the mutations don't request all the properties - or even
        // the commentResolutionStates property at all in their responses.
        const resolveProperties = {
            resolved: false,
            // This mutation only reopens comments
            isDangling: false,
            // Assumes reopened comments are never dangling
            // These are nullable in the schema, but included to make Typescript happy
            resolvedUser: undefined,
            resolvedFriendlyDate: undefined,
            resolvedTime: undefined,
            // Add any non-null/undefined properties from the mutation result
            ...partialResolveProperties
        };
        return (0, $jbF1h.resolveCommentInCache)({
            comment: comment,
            mutationStatus: mutationStatus,
            resolveProperties: resolveProperties
        });
    }
    // Else commentResolutionStates wasn't returned - assume failure to reopen
    return (0, $jbF1h.resolveCommentInCache)({
        comment: comment,
        mutationStatus: false,
        resolveProperties: undefined
    });
};
const $344a24116515d334$export$e237bdee87974d46 = (pageMode)=>{
    // On view pages, exclude draft comments
    if (pageMode === (0, $cD1qu.PageMode).VIEW) return [
        'CURRENT',
        'ARCHIVED'
    ];
    // On edit and live pages, include all statuses
    return [
        'CURRENT',
        'ARCHIVED',
        'DRAFT'
    ];
};
const $344a24116515d334$export$70df9f207ee9869d = (comment)=>{
    const location = comment?.location;
    if (location) {
        if ('inlineResolveProperties' in location) return location.inlineResolveProperties?.resolved ?? false;
        else if ('commentResolveProperties' in location) return location.commentResolveProperties?.resolved ?? false;
    }
    return false;
};
const $344a24116515d334$export$6036c2c532b2fa41 = (commentsDataMap)=>{
    try {
        const allGeneralComments = Object.values(commentsDataMap.general);
        // To see if there are nested comments, we need to check whether there are any replies whose parentID is not equal to the parent Comment's ID
        // This is because commentsDataMap.general is a flat map of parent comment --> everything below it
        // But each comment has it's own parent id which may be different from it's top level parent
        return allGeneralComments.some((comment)=>{
            return comment?.replies?.some((reply)=>reply && reply.parentId !== comment.id);
        });
    } catch  {
        // Default to false if somehow something goes wrong
        return false;
    }
};
const $344a24116515d334$export$2fa0b601110c277b = (comments, contentStatusFilters)=>{
    const allFilteredComments = [];
    const openComments = [];
    const openInlineComments = [];
    const openFooterComments = [];
    const resolvedComments = [];
    // Transform array-based data to map structure for legacy compatibility
    const commentsDataMap = {
        inline: {},
        general: {}
    };
    // Build flat map of all comments (including replies) for O(1) lookup by commentId
    const flatCommentsMap = {};
    // Build flat map of inline comments keyed by markerRef for O(1) lookup
    const flatMarkerRefMap = {};
    for (const comment of comments)// Filter by content status, which is a string literal type (that is, a set of allowed
    // strings), so be cautious if the definitions or schema change
    if (comment && contentStatusFilters.includes(comment.contentStatus?.toUpperCase())) {
        allFilteredComments.push(comment);
        // Add comment to flat map by commentId
        if (comment?.id) flatCommentsMap[comment.id] = comment;
        // Add inline parent comment to flatMarkerRefMap by markerRef (only parent comments, not replies)
        if (comment?.location?.type === 'INLINE' && !comment?.parentId) {
            const location = comment.location;
            if (location?.inlineMarkerRef) flatMarkerRefMap[location.inlineMarkerRef] = comment;
        }
        // Add all replies to flat map
        if (comment?.replies) {
            for (const reply of comment.replies)if (reply?.id) flatCommentsMap[reply.id] = reply;
        }
        const isOpen = !$344a24116515d334$export$70df9f207ee9869d(comment);
        const commentType = comment.location?.type === 'INLINE' ? "inline" : "general";
        const commentWithProperties = {
            ...comment,
            type: commentType,
            isOpen: isOpen,
            wasRemovedByAnotherUser: false,
            replies: comment.replies?.filter((reply)=>reply !== null && reply !== undefined).map((reply)=>({
                    ...reply,
                    wasRemovedByAnotherUser: false
                }))
        };
        if (isOpen) {
            openComments.push(comment);
            if (comment?.location?.type === 'INLINE') openInlineComments.push(comment);
            else if (comment?.location?.type === 'FOOTER') openFooterComments.push(comment);
        // else unknown or missing location type, do nothing
        } else resolvedComments.push(comment);
        if (comment.location?.type === 'INLINE') {
            const threadKey = 'inlineMarkerRef' in comment.location ? comment.location.inlineMarkerRef || comment.id : comment.id;
            commentsDataMap.inline[threadKey] = commentWithProperties;
        } else if (comment.location?.type === 'FOOTER') commentsDataMap.general[comment.id] = commentWithProperties;
    }
    const hasNestedComments = $344a24116515d334$export$6036c2c532b2fa41(commentsDataMap);
    const commentCount = allFilteredComments.length;
    const hasAnyComments = commentCount > 0;
    return {
        allFilteredComments: allFilteredComments,
        openComments: openComments,
        openInlineComments: openInlineComments,
        openFooterComments: openFooterComments,
        resolvedComments: resolvedComments,
        commentsDataMap: commentsDataMap,
        flatCommentsMap: flatCommentsMap,
        flatMarkerRefMap: flatMarkerRefMap,
        hasNestedComments: hasNestedComments,
        commentCount: commentCount,
        hasAnyComments: hasAnyComments
    };
};
const $344a24116515d334$export$5c24224d7e29c719 = ()=>{
    return {
        context: {
            fetchOptions: {
                ignoreNoNetworkError: (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_offline_fix', 'isEnabled', true)
            }
        }
    };
};
module.exports["emptyReactionsSummary"] = $344a24116515d334$export$4883f94fcd5fa7aa;
module.exports["OPTIMISTIC_SAVE_COMMENT_ID"] = $344a24116515d334$export$99a332599a946905;
module.exports["findCommentInData"] = $344a24116515d334$export$c6a7031105fdebc;
module.exports["selectUpdateFunction"] = $344a24116515d334$export$fb9051669482cbe0;
module.exports["findRootCommentForReply"] = $344a24116515d334$export$6ba3a6375d12d24f;
module.exports["findAndFilterComment"] = $344a24116515d334$export$499492f953d5abba;
module.exports["resolveInlineCommentInCacheCallback"] = $344a24116515d334$export$4d95f4b945556294;
module.exports["resolveCommentInCacheCallback"] = $344a24116515d334$export$d81a62b32f0e420f;
module.exports["reopenCommentInCacheCallback"] = $344a24116515d334$export$aa65246494e3c3e0;
module.exports["buildDefaultCommentsContentStatusFilters"] = $344a24116515d334$export$e237bdee87974d46;
module.exports["isCommentResolved"] = $344a24116515d334$export$70df9f207ee9869d;
module.exports["categorizeComments"] = $344a24116515d334$export$2fa0b601110c277b;
module.exports["buildMutationContextForNoNetworkError"] = $344a24116515d334$export$5c24224d7e29c719;

});

parcelRegister("jbF1h", function(module, exports) {

var $82R8R = parcelRequire("82R8R");


var $6nYhN = parcelRequire("6nYhN");


var $cozmU = parcelRequire("cozmU");


var $ij4CE = parcelRequire("ij4CE");


var $fFmJj = parcelRequire("fFmJj");







// Unfortunately our Relay-friendly type generation tools don't support GQL fragments yet - but in
// order to keep the definition of the comment fields in sync (so the cache update fragment is
// always in sync with the full query) we will need to manually make any changes to one definition
// in any others as well, until our tooling supports fragments and then we move to a more
// fragmented-based approach.  Note there are also comment queries or fragments in the following
// files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data-manager/src/useCommentById.ts
// - next/packages/comments-data-manager/src/useCreateObjectCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineReplyMutation.ts
// - next/packages/object-comments/src/components/ObjectCommentContainer.tsx
// TODO: Replace with the exported fragment from useAllCommentsData.ts when our tooling supports
// it, if we are allowed to share fragments between packages/files.  If we are not allowed to share
// fragments, we should move this function - or at least the cache updating parts for the function
// - into the useAllCommentsData.ts file.
const $bd790562493588ff$var$updateCommentInCacheFragment = (0, $6nYhN.default);
// Fragment for reply comments (matches the replies schema from the main fragment)
const $bd790562493588ff$var$updateReplyInCacheFragment = (0, $82R8R.default);
// Type guard to check if a comment is a top-level comment (has replies field)
const $bd790562493588ff$var$isTopLevelComment = (comment)=>{
    return 'replies' in comment;
};
const $bd790562493588ff$export$8ce65958c48a9ac3 = ()=>{
    const readFragment = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: $bd790562493588ff$var$updateCommentInCacheFragment,
        __callerPackage__: "comments-data-manager"
    });
    const writeFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $6nYhN.default),
        fragmentSpec: $bd790562493588ff$var$updateCommentInCacheFragment,
        __callerPackage__: "comments-data-manager"
    });
    const readReplyFragment = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: $bd790562493588ff$var$updateReplyInCacheFragment,
        __callerPackage__: "comments-data-manager"
    });
    const writeReplyFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $82R8R.default),
        fragmentSpec: $bd790562493588ff$var$updateReplyInCacheFragment,
        __callerPackage__: "comments-data-manager"
    });
    /**
   * Function to update a comment in the Apollo cache.
   * @param mutationResult - The result of the mutation that triggered the cache update
   * @param commentId - ID of the comment to update
   * @param updateCallback - Callback function that receives the current comment data
   *                         and returns the updated comment data
   * @param onError - Optional error callback to handle errors during the update process
   * @param isReply - Whether this comment is a reply (true) or top-level comment (false)
   */ const updateCommentInCache = (0, $cozmU.useCallback)(({ mutationResult: mutationResult, commentId: commentId, updateCallback: updateCallback, onError: onError, isReply: isReply = false })=>{
        if (!commentId) {
            onError?.(new Error('Cannot update comment in cache: comment ID is missing'));
            return;
        }
        try {
            // The fragment ID format for Apollo cache
            const fragmentId = `Comment:${commentId}`;
            let cachedComment = null;
            if (isReply) cachedComment = readReplyFragment({
                id: fragmentId
            });
            else cachedComment = readFragment({
                id: fragmentId
            });
            if (!cachedComment) {
                // (There is a slight chance the comment is not in cache - but the mutation that calls
                // this function would have to completed successfully to call us, so presumably the
                // comment existed then. Thus the only legit reason for it to be missing from the cache
                // now is if another user deleted the comment in between the mutation and this cache
                // update call. That is unlikely, so let's log this as an error and return. If in
                // the future we find the legit use case is happening more often, we can change to a
                // warning instead.)
                onError?.(new Error(`Cannot update comment in cache: comment with ID ${commentId} not found in cache`));
                return;
            }
            // Apply the update callback on a copy of the cached comment
            // (Note that the updateCallback should return a new object, not mutate the original - so
            //  make copies of any nested objects you need to change also)
            const updatedComment = updateCallback({
                ...cachedComment
            }, mutationResult);
            // Write the updated comment back to cache using appropriate fragment
            if (isReply) writeReplyFragment({
                fragmentId: fragmentId,
                data: updatedComment
            });
            else writeFragment({
                fragmentId: fragmentId,
                data: updatedComment
            });
        } catch (err) {
            onError?.(new Error(`An error occurred when updating cached comment data: ${err}`));
            return;
        }
    }, [
        readFragment,
        writeFragment,
        readReplyFragment,
        writeReplyFragment
    ]);
    return {
        updateCommentInCache: updateCommentInCache
    };
};
const $bd790562493588ff$export$9e04af313e7174f4 = ({ comment: comment, mutationStatus: mutationStatus, resolveProperties: resolveProperties })=>{
    if (!mutationStatus || !resolveProperties) // Mutation result is missing or incomplete - so just return the comment unchanged
    return comment;
    // Extract isDangling separately since it is handled differently, and exclude __typename since we
    // don't need it and Typescript would complain about it being included in the spread below.
    const { __typename: __typename, isDangling: isDangling, ...otherResolveProperties } = resolveProperties;
    // Mark the comment as resolved in the cache, but how to do that depends on the comment type
    const location = comment.location;
    const newLocation = {
        ...location,
        ...'commentResolveProperties' in location ? {
            commentResolveProperties: {
                ...location.commentResolveProperties,
                ...otherResolveProperties
            }
        } : {},
        ...'inlineResolveProperties' in location ? {
            inlineResolveProperties: {
                ...location.inlineResolveProperties,
                ...otherResolveProperties,
                isDangling: isDangling
            }
        } : {}
    };
    // @ts-expect-error - FIXME: This error was surfaced after enabling the `typescriptExcludeUndefinedFromNullableUnion`
    // Relay compiler option. Previously, `undefined` was incorrectly included in nullable unions in generated types; this option removes it. The owning team should fix this properly.
    return {
        ...comment,
        location: newLocation
    };
};
const $bd790562493588ff$export$df3d27666bd765d5 = (comment, mutationResult)=>{
    const newBodyValue = mutationResult?.data?.updateComment?.body?.value;
    const updatedBody = {
        ...comment.body,
        // Remember that an empty string is a valid body value, so only skip updating if newBodyValue
        // is null or undefined
        ...newBodyValue || newBodyValue === '' ? {
            value: newBodyValue
        } : {}
    };
    const newVersion = mutationResult?.data?.updateComment?.version;
    const newDisplayName = newVersion?.by?.displayName;
    // If the existing comment's version doesn't have a "by" field, we don't want to add just part
    // of it - so set it to undefined so it won't be included in the updated comment. This probably
    // won't actually ever happen, but it makes Typescript happy just in case.
    const updatedBy = comment.version?.by ? {
        ...comment.version?.by,
        ...newDisplayName ? {
            displayName: newDisplayName
        } : {}
    } : undefined;
    const updatedVersion = {
        ...comment.version,
        ...newVersion?.number ? {
            number: newVersion.number
        } : {},
        ...newVersion?.when ? {
            when: newVersion.when
        } : {},
        ...updatedBy ? {
            by: {
                ...updatedBy
            }
        } : {}
    };
    const baseUpdatedComment = {
        ...comment,
        body: updatedBody,
        version: {
            ...updatedVersion
        }
    };
    // Return with appropriate type casting based on comment type
    return $bd790562493588ff$var$isTopLevelComment(comment) ? baseUpdatedComment : baseUpdatedComment;
};
module.exports["useUpdateCommentInCache"] = $bd790562493588ff$export$8ce65958c48a9ac3;
module.exports["resolveCommentInCache"] = $bd790562493588ff$export$9e04af313e7174f4;
module.exports["updateCommentBodyInCacheCallback"] = $bd790562493588ff$export$df3d27666bd765d5;

});

parcelRegister("82R8R", function(module, exports) {
/**
 * @generated SignedSource<<b6af2e5e8b1c672924f300605e9d9ac3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6ee66e0478f0211a$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v2 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v4 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v5 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v6 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useUpdateCommentInCacheReplyFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "permissionType"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "accountId"
                            }
                        ],
                        "type": "KnownUser"
                    },
                    {
                        "concreteType": "Icon",
                        "kind": "LinkedField",
                        "name": "profilePicture",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "path"
                            }
                        ]
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "representation",
                        "value": "ATLAS_DOC_FORMAT"
                    }
                ],
                "concreteType": "DocumentBody",
                "kind": "LinkedField",
                "name": "body",
                "plural": false,
                "selections": v2 /*: any*/ ,
                "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
            },
            {
                "kind": "ScalarField",
                "name": "contentStatus"
            },
            {
                "concreteType": "ConfluenceDate",
                "kind": "LinkedField",
                "name": "createdAt",
                "plural": false,
                "selections": v2 /*: any*/ 
            },
            {
                "kind": "ScalarField",
                "name": "createdAtNonLocalized"
            },
            {
                "concreteType": "Map_LinkType_String",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "editui"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "webui"
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "name": "location",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "InlineCommentResolveProperties",
                                "kind": "LinkedField",
                                "name": "commentResolveProperties",
                                "plural": false,
                                "selections": [
                                    v3 /*: any*/ ,
                                    v4 /*: any*/ ,
                                    v5 /*: any*/ ,
                                    v6 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "FooterComment"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "inlineMarkerRef"
                            },
                            {
                                "concreteType": "InlineCommentResolveProperties",
                                "kind": "LinkedField",
                                "name": "inlineResolveProperties",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "isDangling"
                                    },
                                    v3 /*: any*/ ,
                                    v4 /*: any*/ ,
                                    v5 /*: any*/ ,
                                    v6 /*: any*/ 
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "inlineText"
                            }
                        ],
                        "type": "InlineComment"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "parentId"
            },
            {
                "concreteType": "CommentPermissions",
                "kind": "LinkedField",
                "name": "permissions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isEditable"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isRemovable"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isResolvable"
                    }
                ]
            },
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            v1 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "number"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "when"
                    }
                ]
            }
        ],
        "type": "Comment"
    };
}();
$6ee66e0478f0211a$var$node.hash = "d793bb57d64855b11bf515ef7082e802";
var $6ee66e0478f0211a$export$2e2bcd8739ae039 = $6ee66e0478f0211a$var$node;
module.exports["default"] = $6ee66e0478f0211a$export$2e2bcd8739ae039;

});

parcelRegister("6nYhN", function(module, exports) {
/**
 * @generated SignedSource<<776c1b585ba7040195aa55b4ce020277>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1d633d5b65e9f4e8$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v3 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v4 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v8 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v7 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v9 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v10 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v11 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v12 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v14 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v17 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v1 /*: any*/ ,
            v5 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v13 /*: any*/ ,
                            v14 /*: any*/ ,
                            v15 /*: any*/ ,
                            v16 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v13 /*: any*/ ,
                            v14 /*: any*/ ,
                            v15 /*: any*/ ,
                            v16 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v19 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v20 = {
        "kind": "LinkedField",
        "name": "contributors",
        "plural": true,
        "selections": [
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            v4 /*: any*/ ,
            v6 /*: any*/ 
        ]
    }, v21 = {
        "kind": "ScalarField",
        "name": "number"
    }, v22 = {
        "kind": "ScalarField",
        "name": "when"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useUpdateCommentInCacheFragment",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    v3 /*: any*/ ,
                    v4 /*: any*/ ,
                    v5 /*: any*/ ,
                    v6 /*: any*/ 
                ]
            },
            v8 /*: any*/ ,
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "container",
                "plural": false,
                "selections": [
                    v0 /*: any*/ 
                ]
            },
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ ,
            v20 /*: any*/ ,
            {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "replies",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v2 /*: any*/ ,
                            v3 /*: any*/ ,
                            v6 /*: any*/ ,
                            v4 /*: any*/ 
                        ]
                    },
                    v8 /*: any*/ ,
                    v9 /*: any*/ ,
                    v10 /*: any*/ ,
                    v11 /*: any*/ ,
                    v12 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ ,
                    v19 /*: any*/ ,
                    v20 /*: any*/ ,
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "by",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ ,
                                    v2 /*: any*/ 
                                ]
                            },
                            v21 /*: any*/ ,
                            v22 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v5 /*: any*/ ,
                            v2 /*: any*/ ,
                            v6 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "friendlyWhen"
                    },
                    v21 /*: any*/ ,
                    v22 /*: any*/ 
                ]
            }
        ],
        "type": "Comment"
    };
}();
$1d633d5b65e9f4e8$var$node.hash = "3eaa0227f14e77a83748a865f02fa321";
var $1d633d5b65e9f4e8$export$2e2bcd8739ae039 = $1d633d5b65e9f4e8$var$node;
module.exports["default"] = $1d633d5b65e9f4e8$export$2e2bcd8739ae039;

});

parcelRegister("5fMeR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fJCU9 = parcelRequire("fJCU9");


var $7aw3q = parcelRequire("7aw3q");


var $9wGTI = parcelRequire("9wGTI");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $htsj6 = parcelRequire("htsj6");


var $cZa7r = parcelRequire("cZa7r");


var $3mVfX = parcelRequire("3mVfX");


var $ep3mz = parcelRequire("ep3mz");


var $dANtQ = parcelRequire("dANtQ");


var $gEtAQ = parcelRequire("gEtAQ");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $gtj7V = parcelRequire("gtj7V");


var $cMvMc = parcelRequire("cMvMc");


var $8aF6s = parcelRequire("8aF6s");


var $bSvtO = parcelRequire("bSvtO");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $jmjWc = parcelRequire("jmjWc");


var $kDhla = parcelRequire("kDhla");


const $3b7f940e5fdc8097$var$CommentsPanelFilterMenu = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Cp4VO",
    name: "CommentsPanelFilterMenu",
    loader: async ()=>(await (parcelRequire("eh1vA"))).CommentsPanelFilterMenu
});

const $3b7f940e5fdc8097$var$CommentsPanelFooter = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "V6uhH",
    name: "CommentsPanelFooter",
    loader: async ()=>(await (parcelRequire("1K8rh"))).CommentsPanelFooter
});

const $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EqpEC",
    name: "CommentsPanelHeaderIcon",
    loader: async ()=>(await (parcelRequire("60ddt"))).CommentsPanelHeaderIcon
});

const $3b7f940e5fdc8097$var$CommentsPanelWrapper = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "r3W5r",
    name: "CommentsPanelWrapper",
    loader: async ()=>(await (parcelRequire("9dtiO"))).CommentsPanelWrapper
});

const $3b7f940e5fdc8097$var$CommentsPanelFooterWrapper = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "uSRQM",
    name: "CommentsPanelFooterWrapper",
    loader: async ()=>(await (parcelRequire("75EWd"))).CommentsPanelFooterWrapper
});

const $3b7f940e5fdc8097$var$CommentsPanelHeaderActions = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "4wZwH",
    name: "CommentsPanelHeaderActions",
    loader: async ()=>(await (parcelRequire("hOAjl"))).CommentsPanelHeaderActions
});
const $3b7f940e5fdc8097$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    commentsPanelHeaderLabel: {
        id: "comments-panel.panel.header.label",
        defaultMessage: "Comments"
    },
    discussionsPanelHeaderLabel: {
        id: "comments-panel.panel.header.discussions.label",
        defaultMessage: "Discussions"
    }
});
const $3b7f940e5fdc8097$export$b215887829902b28 = (pageMode)=>{
    // Always preload the core components
    $3b7f940e5fdc8097$var$CommentsPanelWrapper.preload();
    $3b7f940e5fdc8097$var$CommentsPanelFilterMenu.preload();
    $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon.preload();
    $3b7f940e5fdc8097$var$CommentsPanelHeaderActions.preload();
    // Only preload footer in view mode (not edit mode)
    if (pageMode !== (0, $cD1qu.PageMode).EDIT) $3b7f940e5fdc8097$var$CommentsPanelFooter.preload();
};
const $3b7f940e5fdc8097$export$833f9a16214bbf3d = ()=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const isSpaceOverviewPage = (0, $gEtAQ.isSpaceOverview)();
    const isDatabaseView = (0, $gEtAQ.isDatabase)();
    const isWhiteboardView = (0, $gEtAQ.isWhiteboard)();
    const isSlidesView = (0, $gEtAQ.isSlides)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const { showObjectSidebar: showObjectSidebar, hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setViewProps: setViewProps, setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const { currentSidebarTab: currentSidebarTab } = (0, $3mVfX.useCommentsPanelState)();
    const { setCurrentView: setCurrentView, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId, setCurrentSidebarTab: setCurrentSidebarTab } = (0, $3mVfX.useCommentsPanelActions)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId ?? '', true);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    // a ref is needed here because of a closure issue with canClosePanel
    const hasContentChangedRef = (0, $cozmU.useRef)(hasContentChanged);
    (0, $cozmU.useEffect)(()=>{
        hasContentChangedRef.current = hasContentChanged;
    }, [
        hasContentChanged
    ]);
    const { fullPageEditorPresetAPI: fullPageEditorPresetAPI } = (0, $kDhla.useFullPageEditorApiState)();
    (0, $cozmU.useEffect)(()=>{
        fullPageEditorPresetAPI?.aiSuggestions?.actions.setUIVisibility(isObjectSidebarShown);
    }, [
        isObjectSidebarShown,
        fullPageEditorPresetAPI
    ]);
    // Track whether the Suggestions tab was visited during this sidebar session,
    // so we can keep the suggestion node selected in the editor after close
    // (regardless of which tab is active when the panel is dismissed).
    const hadSuggestionsTabRef = (0, $cozmU.useRef)(false);
    // Track the previous value of currentSidebarTab so we can detect when the
    // user actively switches *away from* the Suggestions tab (as opposed to
    // the tab simply being COMMENTS when the sidebar first opens).
    const prevSidebarTabRef = (0, $cozmU.useRef)(currentSidebarTab);
    // When the sidebar finishes closing, reset the session flag and the tab
    // back to COMMENTS so subsequent non-suggestion opens start clean.
    (0, $cozmU.useEffect)(()=>{
        if (!isObjectSidebarShown) {
            hadSuggestionsTabRef.current = false;
            setCurrentSidebarTab?.((0, $3mVfX.SidebarTabValues).COMMENTS);
        }
    }, [
        isObjectSidebarShown,
        setCurrentSidebarTab
    ]);
    (0, $cozmU.useEffect)(()=>{
        const prevTab = prevSidebarTabRef.current;
        if (currentSidebarTab === (0, $3mVfX.SidebarTabValues).SUGGESTIONS) hadSuggestionsTabRef.current = true;
        // Only deselect the suggestion when the user actively switches away
        // from the Suggestions tab (prev was SUGGESTIONS, now it is not).
        // This avoids deselecting on initial sidebar open (where prev and
        // current are both COMMENTS) and on sidebar close.
        if (prevTab === (0, $3mVfX.SidebarTabValues).SUGGESTIONS && currentSidebarTab !== (0, $3mVfX.SidebarTabValues).SUGGESTIONS && isObjectSidebarShown) fullPageEditorPresetAPI?.aiSuggestions?.actions.selectSuggestion(null, {
            interactionPoint: 'sidebar'
        });
        // Update prev ref *after* checking it
        prevSidebarTabRef.current = currentSidebarTab;
    }, [
        currentSidebarTab,
        fullPageEditorPresetAPI,
        isObjectSidebarShown
    ]);
    const onPanelCloseFunction = ()=>{
        const closingFromSuggestions = hadSuggestionsTabRef.current;
        setCurrentView(undefined);
        // When closing from a suggestions session, skip resetting the tab to
        // COMMENTS so the useEffect that watches currentSidebarTab does not
        // fire selectSuggestion(null) during the close transition.
        if (!closingFromSuggestions) {
            setCurrentSidebarTab((0, $3mVfX.SidebarTabValues).COMMENTS);
            // Unselect active annotations on the page
            if (pageMode === (0, $cD1qu.PageMode).VIEW) {
                eventEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
                eventEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
                setViewProps(null);
            } else {
                eventEmitter.emit('setselectedannotation', '');
                setEditorViewProps(null);
            }
        }
        // clear selected comment thread in the comments panel
        setCurrentlySelectedThreadKey('');
        setReplyToCommentId();
    };
    const onPanelClose = (0, $cozmU.useCallback)(onPanelCloseFunction, [
        setCurrentView,
        pageMode,
        eventEmitter,
        setViewProps,
        setEditorViewProps,
        setCurrentlySelectedThreadKey,
        setReplyToCommentId,
        setCurrentSidebarTab
    ]);
    const canClosePanel = (0, $cozmU.useCallback)(async ()=>{
        if (hasContentChangedRef.current && !(0, $9wGTI.fg)('confluence_comments_fix_duplicate_modal')) return new Promise((resolve)=>{
            showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged && resetContentChanged();
                    resolve(true);
                },
                onCancel: ()=>{
                    resolve(false);
                }
            });
        });
        else return true;
    }, [
        resetContentChanged,
        showModal
    ]);
    const showCommentsPanelFunction = ({ openWithView: openWithView, openWithTab: openWithTab } = {})=>{
        if (!allowComments) return;
        experienceTracker.start({
            name: (0, $irVI7.SIDEBAR_COMMENTS_PANEL_LOAD_EXPERIENCE),
            attributes: {
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                openWithView: openWithView,
                ...isRovoLLMEnabled && (0, $6mKj3.expValEquals)('platform_editor_ai_content_suggested_edits', 'isEnabled', true) && {
                    openWithTab: openWithTab
                },
                contentId: contentId,
                pageMode: pageMode
            }
        });
        const loadFooterComments = pageMode !== (0, $cD1qu.PageMode).EDIT;
        // Drag-to-resize on page surfaces only (same exclusions as the panel
        // itself). `expValEquals` is the LAST clause per
        // `confluence-feature-gating/no-preconditioning` so exposure is only
        // recorded for users who actually meet the surface preconditions.
        const isResizableSurface = !isSpaceOverviewPage && !isDatabaseView && !isWhiteboardView && !isSlidesView && (0, $6mKj3.expValEquals)('confluence_fe_comments_panel_resize', 'isEnabled', true);
        const showFooter = canAddComments && contentStatus !== (0, $cD1qu.ContentStatus).DRAFT && loadFooterComments && !isSpaceOverviewPage && !isDatabaseView && !isWhiteboardView && !isSlidesView;
        /**
     * Logic for showing the footer for platform_editor_ai_content_suggested_edits
     * There is additional logic for comments vs. suggestions inside CommentsPanelFooterWrapper
     */ const showFooterCommon = !isSpaceOverviewPage && !isDatabaseView && !isWhiteboardView && !isSlidesView;
        const showDiscussionLabel = !isDatabaseView && !isWhiteboardView && !isSlidesView;
        // When the gate is on, use CommentsPanelFooterWrapper which reactively
        // switches between SuggestionsFooter and CommentsPanelFooter based on
        // the current tab — without needing to re-open the sidebar.
        // When the gate is off, fall back to the original CommentsPanelFooter.
        const FooterComponent = showFooterCommon ? $3b7f940e5fdc8097$var$CommentsPanelFooterWrapper : undefined;
        const OldFooterComponent = showFooter ? $3b7f940e5fdc8097$var$CommentsPanelFooter : undefined;
        showObjectSidebar({
            id: (0, $jvYFk.PanelName).CommentsPanel,
            headerComponentElements: {
                HeaderIcon: $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon,
                headerLabel: showDiscussionLabel && isRovoLLMEnabled && (0, $6mKj3.expValEquals)('platform_editor_ai_content_suggested_edits', 'isEnabled', true) ? $3b7f940e5fdc8097$export$a7357cdd1f0b0168.discussionsPanelHeaderLabel : $3b7f940e5fdc8097$export$a7357cdd1f0b0168.commentsPanelHeaderLabel,
                HeaderRightAlignedElement: $3b7f940e5fdc8097$var$CommentsPanelHeaderActions
            },
            BodyComponent: ()=>$3b7f940e5fdc8097$var$CommentsPanelWrapper({
                    openWithView: openWithView,
                    openWithTab: openWithTab
                }),
            FooterComponent: isRovoLLMEnabled && (0, $6mKj3.expValEquals)('platform_editor_ai_content_suggested_edits', 'isEnabled', true) ? FooterComponent : OldFooterComponent,
            closeOptions: {
                canClosePanel: canClosePanel,
                onPanelClose: onPanelClose
            },
            isResizable: isResizableSurface
        }, 'push');
    };
    const showCommentsPanel = (0, $cozmU.useCallback)(showCommentsPanelFunction, [
        allowComments,
        canAddComments,
        canClosePanel,
        contentId,
        contentStatus,
        experienceTracker,
        isDatabaseView,
        isRovoLLMEnabled,
        isSpaceOverviewPage,
        isWhiteboardView,
        isSlidesView,
        onPanelClose,
        pageMode,
        showObjectSidebar
    ]);
    // NOTE: Exposing the hide function for now while we have the CommentButton
    return {
        isCommentsPanelShown: isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel,
        showCommentsPanel: showCommentsPanel,
        hideCommentsPanel: hideObjectSidebar
    };
};
module.exports["preloadCommentsPanel"] = $3b7f940e5fdc8097$export$b215887829902b28;
module.exports["useShowCommentsPanel"] = $3b7f940e5fdc8097$export$833f9a16214bbf3d;

});

parcelRegister("7aw3q", function(module, exports) {

var $lTECB = parcelRequire("lTECB");


var $9bL1w = parcelRequire("9bL1w");


var $cxu5H = parcelRequire("cxu5H");

const $440129e2f2e8f952$export$d22f0c9bbe97be97 = ()=>{
    const isEmbeddedConfluence = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    const { hasComments: hasPageComments, hasInlineCommentsAndHighlightActions: hasViewInlineComments } = (0, $cxu5H.useEmbeddedViewPageFeatures)();
    const { hasInlineCommentsAndHighlightActions: hasEditInlineComments } = (0, $9bL1w.useEmbeddedEditPageFeatures)();
    if (!isEmbeddedConfluence) return true;
    const allowPageCommentsInEmbeddedMode = hasPageComments;
    const allowInlineCommentsInEmbeddedMode = hasViewInlineComments || hasEditInlineComments;
    return allowPageCommentsInEmbeddedMode && allowInlineCommentsInEmbeddedMode;
};
module.exports["useEmbeddedComments"] = $440129e2f2e8f952$export$d22f0c9bbe97be97;

});

parcelRegister("9bL1w", function(module, exports) {

var $36Uax = parcelRequire("36Uax");

var $4PNpW = parcelRequire("4PNpW");


var $9wGTI = parcelRequire("9wGTI");


var $gyiJY = parcelRequire("gyiJY");

const { edit: $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $36Uax.DEFAULT_ALLOWED_FEATURES);
var $30ba1cd08ee89eb0$export$36621fa7e88734f8 = /*#__PURE__*/ function(EmbeddedEditPageButtons) {
    EmbeddedEditPageButtons["DELETE_DRAFT"] = "delete-draft";
    EmbeddedEditPageButtons["TEMPLATE_BROWSER"] = "template-browser";
    return EmbeddedEditPageButtons;
}({});
const $30ba1cd08ee89eb0$export$3f18272ea50bc7e1 = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)() || $30ba1cd08ee89eb0$var$EDIT_PAGE_DEFAULT_ALLOWED_FEATURES;
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-publish-close-buttons" out of allowedEditPageFeatures,
	 * so that the Publish and Close buttons won't be hidden when allowedFeatures is "all".
	 * Similarly, "enable-share" is an opt-in feature and should not be enabled when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-publish-close-buttons',
        'disable-close-button',
        'enable-share'
    ];
    const allAllowedFeaturesEnabled = allowedFeatures === 'all';
    const allowedEditPageFeatures = allAllowedFeaturesEnabled ? (0, $4PNpW.EDIT_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const allowedEllipsisButtons = [];
    const isDeleteDraftEnabled = allowedEditPageFeatures?.includes("delete-draft");
    if (isDeleteDraftEnabled) allowedEllipsisButtons.push("delete-draft");
    const templateBrowserConfig = !allAllowedFeaturesEnabled ? allowedFeatures?.find((x)=>typeof x === 'object' && x !== null && 'template-browser' in x) : undefined;
    const templateBrowserPanelConfig = !allAllowedFeaturesEnabled && (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') ? allowedFeatures?.find((x)=>typeof x === 'object' && x !== null && 'template-browser-panel' in x) : undefined;
    const isTemplateBrowserEnabled = allowedEditPageFeatures?.includes("template-browser") || !!templateBrowserConfig;
    const isTemplateBrowserPanelEnabled = (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') && (allowedEditPageFeatures?.includes('template-browser-panel') || !!templateBrowserPanelConfig);
    if (isTemplateBrowserEnabled || isTemplateBrowserPanelEnabled) allowedEllipsisButtons.push("template-browser");
    const spacePickerDisabledByTemplateBrowserPanel = templateBrowserPanelConfig?.['template-browser-panel']?.['space-picker-disabled'];
    const spacePickerDisabledByLegacyTemplateBrowser = templateBrowserConfig?.['template-browser']?.['space-picker-disabled'];
    const isSpacePickerDisabled = (0, $9wGTI.fg)('confluence_embedded_decouple_template_browser_bpqa') ? spacePickerDisabledByTemplateBrowserPanel ?? spacePickerDisabledByLegacyTemplateBrowser ?? false : spacePickerDisabledByLegacyTemplateBrowser ?? false;
    const isBlankPageQuickActionsEnabled = allowedEditPageFeatures?.includes('blank-page-quick-actions');
    const hasInlineCommentsAndHighlightActions = allowedEditPageFeatures?.includes('inline-comments');
    const isPublishModalEnabled = allowedEditPageFeatures?.includes('publish-modal');
    const hidePublishCloseButtons = allowedEditPageFeatures?.includes('disable-publish-close-buttons');
    const hideCloseButton = allowedEditPageFeatures?.includes('disable-close-button');
    const loomExternalOpenRoute = allowedEditPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route;
    /**
	 * Rovo chat is enabled only when:
	 * - The platform AI feature flag is on, and
	 * - The host explicitly allows it via the 'rovo' feature in allowedFeatures.
	 * We require explicit opt-in (not when allowedFeatures === 'all') so hosts
	 * must intentionally enable AI in the embedded context.
	 */ const isRovoEditEnabled = !allAllowedFeaturesEnabled && !!allowedEditPageFeatures?.includes('rovo');
    const showShare = (0, $9wGTI.fg)('csm_ai_enable_share_feature') && allowedEditPageFeatures?.includes('enable-share');
    return {
        allowedEllipsisButtons: allowedEllipsisButtons,
        isTemplateBrowserEnabled: // @Depracated: This is deprecated, but we need to keep it for backward compatibility.
        // Please use isTemplateBrowserPanelEnabled instead.
        isTemplateBrowserEnabled,
        isTemplateBrowserPanelEnabled: isTemplateBrowserPanelEnabled,
        isBlankPageQuickActionsEnabled: isBlankPageQuickActionsEnabled,
        isSpacePickerDisabled: isSpacePickerDisabled,
        hasInlineCommentsAndHighlightActions: hasInlineCommentsAndHighlightActions,
        isPublishModalEnabled: isPublishModalEnabled,
        hidePublishCloseButtons: hidePublishCloseButtons,
        hideCloseButton: hideCloseButton,
        loomExternalOpenRoute: loomExternalOpenRoute,
        isRovoAllowed: isRovoEditEnabled,
        showShare: showShare
    };
};
module.exports["useEmbeddedEditPageFeatures"] = $30ba1cd08ee89eb0$export$3f18272ea50bc7e1;

});

parcelRegister("36Uax", function(module, exports) {

var $bVevd = parcelRequire("bVevd");


var $kTPbu = parcelRequire("kTPbu");

var $dcf2160d889b63fd$export$241b9888a4d565c9 = /*#__PURE__*/ function(ALLOWED_FEATURES_TYPE) {
    ALLOWED_FEATURES_TYPE["VIEW"] = "view";
    ALLOWED_FEATURES_TYPE["EDIT"] = "edit";
    ALLOWED_FEATURES_TYPE["WHITEBOARD"] = "whiteboard";
    return ALLOWED_FEATURES_TYPE;
}({});
const $dcf2160d889b63fd$export$a3fda3dcee62e1cc = {
    // Since view and edit is a public API already, changing this would break parent products
    // hence we could update it separately as a breaking change later. With more content types which could
    // have edit, view, the suggested patter to follow: <contentType>-<mode> e.g., database-view
    view: [
        'byline-contributors',
        'byline-extensions',
        'delete',
        'edit',
        'inline-comments',
        'page-comments',
        'page-reactions',
        'sticky-header',
        'disable-login-flow',
        'disable-share',
        'non-licensed-share',
        'enable-redirection',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar',
        'loom-external-open'
    ],
    edit: [
        'delete-draft',
        'disable-login-flow',
        // @deprecated: use template-browser-panel instead.
        'template-browser',
        'template-browser-panel',
        'blank-page-quick-actions',
        'inline-comments',
        'disable-publish-close-buttons',
        'disable-close-button',
        'loom-external-open',
        'rovo',
        'enable-share'
    ],
    whiteboard: [
        'disable-login-flow',
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $dcf2160d889b63fd$export$a33327ada3a6ee4a = {
    view: [
        'byline-contributors',
        'byline-extensions',
        'page-comments',
        'page-reactions',
        'inline-comments'
    ],
    edit: [
        'inline-comments'
    ],
    whiteboard: [
        'copy',
        'favorite',
        'restrictions',
        'more-actions'
    ]
};
const $dcf2160d889b63fd$var$pageAllowedFeatures = {
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.edit,
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.view
};
const $dcf2160d889b63fd$var$blogPostAllowedFeatures = {
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.edit,
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.view
};
const $dcf2160d889b63fd$var$whiteboardAllowedFeatures = {
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.whiteboard,
    [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: $dcf2160d889b63fd$export$a3fda3dcee62e1cc.whiteboard
};
const $dcf2160d889b63fd$var$contentTypeAllowedFeatures = {
    [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: $dcf2160d889b63fd$var$pageAllowedFeatures,
    [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: $dcf2160d889b63fd$var$blogPostAllowedFeatures,
    [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: $dcf2160d889b63fd$var$whiteboardAllowedFeatures
};
const $dcf2160d889b63fd$export$3207c60940c4a9b0 = ({ contentType: contentType, mode: mode = (0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE })=>$dcf2160d889b63fd$var$contentTypeAllowedFeatures[contentType]?.[mode] ?? [];
module.exports["ALLOWED_FEATURES"] = $dcf2160d889b63fd$export$a3fda3dcee62e1cc;
module.exports["DEFAULT_ALLOWED_FEATURES"] = $dcf2160d889b63fd$export$a33327ada3a6ee4a;
module.exports["getAllowedFeatures"] = $dcf2160d889b63fd$export$3207c60940c4a9b0;

});

parcelRegister("bVevd", function(module, exports) {
var $3914485ee940289d$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
module.exports["EMBEDDED_CONFLUENCE_MODE"] = $3914485ee940289d$export$816ef638e478449a;

});

parcelRegister("kTPbu", function(module, exports) {
var $eaa06f5f4964dde1$export$942a5fac9b8c9dc2 = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_CONTENT_TYPE) {
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["PAGE"] = "page";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["BLOGPOST"] = "blogpost";
    EMBEDDED_CONFLUENCE_CONTENT_TYPE["WHITEBOARD"] = "whiteboard";
    return EMBEDDED_CONFLUENCE_CONTENT_TYPE;
}({});
module.exports["EMBEDDED_CONFLUENCE_CONTENT_TYPE"] = $eaa06f5f4964dde1$export$942a5fac9b8c9dc2;

});

parcelRegister("4PNpW", function(module, exports) {

var $36Uax = parcelRequire("36Uax");

const $ff056bb0ad02bd7c$export$1acbaeb6a9a6bc40 = (0, $36Uax.ALLOWED_FEATURES).view;
const $ff056bb0ad02bd7c$export$2c7469b01e61fde2 = (0, $36Uax.ALLOWED_FEATURES).edit;
const $ff056bb0ad02bd7c$export$72afc086e90eb0bf = (0, $36Uax.ALLOWED_FEATURES).whiteboard;
module.exports["VIEW_PAGE_FEATURES"] = $ff056bb0ad02bd7c$export$1acbaeb6a9a6bc40;
module.exports["EDIT_PAGE_FEATURES"] = $ff056bb0ad02bd7c$export$2c7469b01e61fde2;
module.exports["WHITEBOARD_FEATURES"] = $ff056bb0ad02bd7c$export$72afc086e90eb0bf;

});

parcelRegister("gyiJY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1eD4P = parcelRequire("1eD4P");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");

const $b2e9e223d7519ab7$var$QUERY_NAME = 'initialAllowedFeatures';
var $b2e9e223d7519ab7$export$2ba0e67b02c658ce = /*#__PURE__*/ function(FeatureMode) {
    FeatureMode["VIEW"] = "view";
    FeatureMode["EDIT"] = "edit";
    FeatureMode["WHITEBOARD"] = "whiteboard";
    return FeatureMode;
}({});
function $b2e9e223d7519ab7$export$745a9b66a8f1814a() {
    const { allowedFeatures: allowedFeatures } = (0, $1eD4P.useReactProps_DO_NOT_USE)() || {};
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    /**
	 * When allowedFeatures passthrough props not available but query param `initialAllowedFeatures` available, we resolve allowedFeatures from this query param
	 * After allowedFeatures passthrough props become available again at SPA, the allowedFeatures should be resolved by passthrough props
	 * This is needed for rendering consistent features between SSR and SPA phases, as SSR phase cannot resolve passthrough props through `window.postMessage`
	 *
	 * E.g.
	 * - `?embedded=true&initialAllowedFeatures=edit,delete` should only enable Edit and Delete features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=all` should enable all features in SSR phase
	 * - `?embedded=true&initialAllowedFeatures=` should enable no features in SSR phase
	 */ const queriedAllowedFeatures = (0, $cozmU.useMemo)(()=>(0, $c3Qwv.getSingleParam)(getQueryParams(), $b2e9e223d7519ab7$var$QUERY_NAME), [
        getQueryParams
    ]);
    const initialAllowedFeatures = (0, $cozmU.useMemo)(()=>{
        let features;
        if (queriedAllowedFeatures === '') features = [];
        else if (queriedAllowedFeatures === 'all') features = 'all';
        else // There is a bug to be fixed where comma "," in query param will break view page SSR https://product-fabric.atlassian.net/browse/SCALE-5274
        // Workaround is to allow "." as query param separator instead of comma ",". Use regex here to support both characters.
        features = queriedAllowedFeatures?.split(/[\s,.]+/).map((feature)=>{
            try {
                return JSON.parse(feature);
            } catch (error) {
                return feature;
            }
        }) ?? undefined;
        return features;
    }, [
        queriedAllowedFeatures
    ]);
    // Ensure the return type matches UseAllowedFeaturesType<T>
    if (!allowedFeatures && initialAllowedFeatures !== undefined) return initialAllowedFeatures;
    return allowedFeatures;
}
module.exports["useAllowedFeatures"] = $b2e9e223d7519ab7$export$745a9b66a8f1814a;

});

parcelRegister("cxu5H", function(module, exports) {

var $36Uax = parcelRequire("36Uax");

var $4PNpW = parcelRequire("4PNpW");


var $gyiJY = parcelRequire("gyiJY");

const { view: $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES } = (0, $36Uax.DEFAULT_ALLOWED_FEATURES);
const $9b72a1c744147957$export$f9f73b7eca94463f = ()=>{
    const allowedFeatures = (0, $gyiJY.useAllowedFeatures)();
    /**
	 * When allowedFeatures === all, we don't want to enable features that are suppose to disable features.
	 * For example, we want to keep "disable-share" out of allowedViewPageFeatures,
	 * so that the Share button won't be disable when allowedFeatures is "all".
	 */ const disableFeatures = [
        'disable-share',
        'modern-header',
        'disable-help-button',
        'disable-title-toolbar'
    ];
    const allowedViewPageFeatures = allowedFeatures === 'all' ? (0, $4PNpW.VIEW_PAGE_FEATURES).filter((feature)=>!disableFeatures.includes(feature)) : allowedFeatures;
    const showShare = !(allowedViewPageFeatures?.includes('disable-share') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-share'));
    return {
        showShare: showShare,
        hasByLineContributors: allowedViewPageFeatures?.includes('byline-contributors') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('byline-contributors'),
        hasByLineExtensions: allowedViewPageFeatures?.includes('byline-extensions') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('byline-extensions'),
        hasPageReactions: allowedViewPageFeatures?.includes('page-reactions') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('page-reactions'),
        hasStickyHeader: allowedViewPageFeatures?.includes('sticky-header') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('sticky-header'),
        showEdit: allowedViewPageFeatures?.includes('edit') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('edit'),
        showDelete: allowedViewPageFeatures?.includes('delete') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('delete'),
        hasComments: allowedViewPageFeatures?.includes('page-comments') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('page-comments'),
        hasInlineCommentsAndHighlightActions: allowedViewPageFeatures?.includes('inline-comments') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('inline-comments'),
        includeNonLicensedUsersToShare: showShare && (allowedViewPageFeatures?.includes('non-licensed-share') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('non-licensed-share')),
        hasModernHeader: allowedViewPageFeatures?.includes('modern-header') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('modern-header'),
        hideHelpButton: allowedViewPageFeatures?.includes('disable-help-button') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-help-button'),
        hideTitleToolbar: allowedViewPageFeatures?.includes('disable-title-toolbar') ?? $9b72a1c744147957$var$VIEW_PAGE_DEFAULT_ALLOWED_FEATURES.includes('disable-title-toolbar'),
        loomExternalOpenRoute: allowedViewPageFeatures?.find((x)=>typeof x === 'object' && x !== null && 'loom-external-open' in x)?.['loom-external-open']?.route
    };
};
module.exports["useEmbeddedViewPageFeatures"] = $9b72a1c744147957$export$f9f73b7eca94463f;

});

parcelRegister("aWwYt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $lRhY3 = parcelRequire("lRhY3");

const $5371993c50b87836$export$c0cd7aea5be0e780 = 40;
const $5371993c50b87836$export$9e0a6941e0e87c97 = 400;
const $5371993c50b87836$export$21f0d255469350e0 = 3840;
const $5371993c50b87836$export$70e5631b7ec2f387 = Math.max($5371993c50b87836$export$9e0a6941e0e87c97, 368) + $5371993c50b87836$export$c0cd7aea5be0e780;
const $5371993c50b87836$export$d4c72bab9d6cc13a = {
    isPanelScrolled: false,
    isObjectSidebarShown: false,
    behavior: 'push',
    panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
    panel: undefined,
    updatedPanelHeaderComponentElements: undefined,
    sidebarControlState: window.__SSR_RENDERED__ ? 'shown' : 'hidden',
    sidebarControlExpandCollapsedState: window.__SSR_RENDERED__ ? 'expanded' : 'collapsed',
    activeActionInPanel: undefined
};
const $5371993c50b87836$export$e324594224ef24da = {
    setIsPanelScrolled: (isPanelScrolled)=>({ setState: setState })=>{
            setState({
                isPanelScrolled: isPanelScrolled
            });
        },
    setSidebarControlState: (sidebarControlState)=>({ setState: setState })=>{
            setState({
                sidebarControlState: sidebarControlState
            });
        },
    setSidebarControlExpandCollapsedState: (sidebarControlExpandCollapsedState)=>({ setState: setState })=>{
            setState({
                sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState
            });
        },
    toggleObjectSidebarControl: ()=>({ setState: setState, getState: getState })=>{
            const { sidebarControlExpandCollapsedState: sidebarControlExpandCollapsedState } = getState();
            if (sidebarControlExpandCollapsedState === 'collapsed') setState({
                sidebarControlExpandCollapsedState: 'expanded'
            });
            else setState({
                sidebarControlExpandCollapsedState: 'collapsed'
            });
        },
    showObjectSidebar: (panel, behavior, panelWidth)=>({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: currentPanel, behavior: currentBehavior, panelWidth: currentPanelWidth } = getState();
            // Check if panel is open
            if (isObjectSidebarShown) {
                // If it's the same panel do nothing
                if (currentPanel?.id === panel.id) return;
                // Otherwise change it
                setState({
                    panel: panel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: behavior ?? currentBehavior,
                    panelWidth: panelWidth ?? currentPanelWidth,
                    isPanelScrolled: false
                });
            }
            // Set the panel to be open
            setState({
                isObjectSidebarShown: true,
                panel: panel,
                updatedPanelHeaderComponentElements: undefined,
                behavior: behavior ?? currentBehavior,
                panelWidth: panelWidth ?? currentPanelWidth,
                sidebarControlState: 'hidden',
                isPanelScrolled: false
            });
            // Close the global panel
            window.dispatchEvent(new Event('closeGlobalSidebar'));
        },
    hideObjectSidebar: (afterCloseCallback)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            // If we're not showing a panel, don't do anything
            if (!isObjectSidebarShown || !panel) return;
            // If the user has provided closeOptions check them
            if (panel.closeOptions) {
                const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                // If the panel closing check returns false, do nothing
                if (canClosePanel) {
                    const panelCanClose = await canClosePanel();
                    if (!panelCanClose) return;
                }
                // Call the onClose callback
                onPanelClose && onPanelClose();
            }
            // Close the panel
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
            if (afterCloseCallback) afterCloseCallback();
        },
    hideObjectSidebarByPanelId: (id)=>({ getState: getState, dispatch: dispatch })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) dispatch($5371993c50b87836$export$e324594224ef24da.hideObjectSidebar());
        },
    /**
   * Hide the sidebar immediately, bypassing the canClosePanel guard.
   * Use only when the caller has already confirmed with the user that it is
   * safe to discard any draft (e.g. after showing their own warning dialog).
   */ hideObjectSidebarForce: ()=>({ getState: getState, setState: setState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = getState();
            if (!isObjectSidebarShown || !panel) return;
            panel.closeOptions?.onPanelClose?.();
            setState({
                isObjectSidebarShown: false,
                panel: undefined,
                updatedPanelHeaderComponentElements: undefined,
                panelWidth: $5371993c50b87836$export$70e5631b7ec2f387,
                sidebarControlState: 'shown',
                isPanelScrolled: false
            });
        },
    /**
   * Legacy writer used by `ObjectSidebarPushPlaceholder`'s ResizeObserver
   * loop, which reports the inner content width (without push padding).
   * Prefer `setVisiblePanelWidth` from drag-resize call sites.
   */ setPanelWidth: (newPanelWidth)=>({ setState: setState })=>{
            const clamped = Math.min(Math.max(newPanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97), $5371993c50b87836$export$21f0d255469350e0);
            setState({
                panelWidth: clamped + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    /**
   * Drag-resize writer. Takes the *visible* panel width directly (no
   * `−CONTENT_RIGHT_PADDING` at the call site). Same encoding as
   * `setPanelWidth`, so `panelWidth` consistently represents
   * "visible + push padding" regardless of which writer set it.
   */ setVisiblePanelWidth: (visiblePanelWidth)=>({ setState: setState })=>{
            const clamped = Math.min(Math.max(visiblePanelWidth, $5371993c50b87836$export$9e0a6941e0e87c97), $5371993c50b87836$export$21f0d255469350e0);
            setState({
                panelWidth: clamped + $5371993c50b87836$export$c0cd7aea5be0e780
            });
        },
    changePanelBehavior: (newBehavior)=>({ setState: setState, getState: getState })=>{
            const { panelWidth: panelWidth } = getState();
            // When we set the new state, if it's set to cover, we no longer have a
            // component that will size the panel accordingly so we just use the default
            setState({
                behavior: newBehavior,
                panelWidth: newBehavior === 'cover' ? $5371993c50b87836$export$70e5631b7ec2f387 : panelWidth
            });
        },
    changePanel: (newPanel, newBehavior, newPanelWidth)=>async ({ setState: setState, getState: getState })=>{
            const { isObjectSidebarShown: isObjectSidebarShown, panel: panel, behavior: behavior, panelWidth: panelWidth } = getState();
            // Only change panels if the panel is open
            if (isObjectSidebarShown && panel) {
                // If it's the same panel do nothing
                if (panel.id === newPanel.id) return;
                // If the user has provided closeOptions check them
                if (panel.closeOptions) {
                    const { canClosePanel: canClosePanel, onPanelClose: onPanelClose } = panel.closeOptions;
                    // If the panel closing check returns false, do nothing
                    if (canClosePanel) {
                        const panelCanClose = await canClosePanel();
                        if (!panelCanClose) return;
                    }
                    // Call the onClose callback
                    onPanelClose && onPanelClose();
                }
                setState({
                    panel: newPanel,
                    updatedPanelHeaderComponentElements: undefined,
                    behavior: newBehavior ?? behavior,
                    panelWidth: newPanelWidth ?? panelWidth,
                    isPanelScrolled: false
                });
            }
        // Otherwise do nothing
        },
    changeHeaderElements: (id, headerComponentElements)=>({ setState: setState, getState: getState })=>{
            const { panel: panel } = getState();
            if (panel?.id === id) setState({
                updatedPanelHeaderComponentElements: headerComponentElements
            });
        },
    setActiveActionInPanel: (activeActionInPanel)=>({ setState: setState, getState: getState })=>{
            const { activeActionInPanel: currentActiveAction } = getState();
            // If the active action is the same, do nothing
            if (currentActiveAction?.title === activeActionInPanel?.title) return;
            setState({
                activeActionInPanel: activeActionInPanel
            });
        }
};
const $5371993c50b87836$export$8930ecd60eb3f136 = (0, $8s9DV.createStore)({
    initialState: $5371993c50b87836$export$d4c72bab9d6cc13a,
    actions: $5371993c50b87836$export$e324594224ef24da,
    name: 'ObjectSidebarStore'
});
const $5371993c50b87836$var$useObjectSidebarActionsInternal = (0, $kBr4q.createActionsHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$export$332594c77a860a26 = ()=>{
    const internalActions = $5371993c50b87836$var$useObjectSidebarActionsInternal();
    const { close: close } = (0, $lRhY3.usePreviewPanelsActions)();
    const showObjectSidebarWrapper = (0, $cozmU.useCallback)((panel, behavior, panelWidth)=>{
        internalActions.showObjectSidebar(panel, behavior, panelWidth);
        close();
    }, [
        internalActions,
        close
    ]);
    const showObjectSidebar = showObjectSidebarWrapper;
    const memoizedActions = (0, $cozmU.useMemo)(()=>({
            ...internalActions,
            showObjectSidebar: showObjectSidebar
        }), [
        internalActions,
        showObjectSidebar
    ]);
    return (0, $cozmU.useMemo)(()=>memoizedActions, [
        memoizedActions
    ]);
};
const $5371993c50b87836$export$41c5dcc793387db5 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136);
const $5371993c50b87836$var$getIsObjectSidebarShown = (state)=>state.isObjectSidebarShown;
const $5371993c50b87836$var$getPanel = (state)=>state.panel;
const $5371993c50b87836$var$getBehavior = (state)=>state.behavior;
const $5371993c50b87836$var$isPanelScrolled = (state)=>state.isPanelScrolled;
const $5371993c50b87836$var$getPanelWidth = (state)=>state.panelWidth;
const $5371993c50b87836$var$getUpdatedHeaderComponentElements = (state)=>state.updatedPanelHeaderComponentElements;
const $5371993c50b87836$var$getSidebarControlState = (state)=>state.sidebarControlState;
const $5371993c50b87836$var$getSidebarControlExpandCollapsedState = (state)=>state.sidebarControlExpandCollapsedState;
const $5371993c50b87836$var$getActiveAction = (state)=>state.activeActionInPanel;
const $5371993c50b87836$export$a572d51222d5ea45 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getIsObjectSidebarShown
});
const $5371993c50b87836$export$9168a42f32e3d071 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanel
});
const $5371993c50b87836$export$8b43142d6fd506da = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getBehavior
});
const $5371993c50b87836$export$ec8631e69ae8c803 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$isPanelScrolled
});
const $5371993c50b87836$export$82b270f291af5a5 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getPanelWidth
});
const $5371993c50b87836$export$bc4f8f2fe52e3d40 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getUpdatedHeaderComponentElements
});
const $5371993c50b87836$export$d4d7180dad517777 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlState
});
const $5371993c50b87836$export$b00fb66a9723fc58 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getSidebarControlExpandCollapsedState
});
const $5371993c50b87836$export$8ae0b1fffb30adb6 = (0, $kBr4q.createStateHook)($5371993c50b87836$export$8930ecd60eb3f136, {
    selector: $5371993c50b87836$var$getActiveAction
});
module.exports["CONTENT_RIGHT_PADDING"] = $5371993c50b87836$export$c0cd7aea5be0e780;
module.exports["MIN_PANEL_WIDTH"] = $5371993c50b87836$export$9e0a6941e0e87c97;
module.exports["useObjectSidebarActions"] = $5371993c50b87836$export$332594c77a860a26;
module.exports["useObjectSidebarState"] = $5371993c50b87836$export$41c5dcc793387db5;
module.exports["useIsObjectSidebarShown"] = $5371993c50b87836$export$a572d51222d5ea45;
module.exports["usePanel"] = $5371993c50b87836$export$9168a42f32e3d071;
module.exports["useBehavior"] = $5371993c50b87836$export$8b43142d6fd506da;
module.exports["useIsPanelScrolled"] = $5371993c50b87836$export$ec8631e69ae8c803;
module.exports["usePanelWidth"] = $5371993c50b87836$export$82b270f291af5a5;
module.exports["useUpdatedHeaderComponentElements"] = $5371993c50b87836$export$bc4f8f2fe52e3d40;
module.exports["useSidebarControlState"] = $5371993c50b87836$export$d4d7180dad517777;
module.exports["useSidebarControlExpandCollapsedState"] = $5371993c50b87836$export$b00fb66a9723fc58;
module.exports["useActiveActionInPanel"] = $5371993c50b87836$export$8ae0b1fffb30adb6;

});

parcelRegister("lRhY3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $3Ap09 = parcelRequire("3Ap09");

const $bc35f8d5f81a3a68$var$noop = (props)=>{};
const $bc35f8d5f81a3a68$export$5f5debba1692bf40 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (!context) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                open: $bc35f8d5f81a3a68$var$noop,
                close: $bc35f8d5f81a3a68$var$noop,
                setPanelWidth: $bc35f8d5f81a3a68$var$noop
            };
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    let t0;
    if ($[1] !== context.close || $[2] !== context.open || $[3] !== context.setPanelWidth) {
        t0 = {
            open: context.open,
            close: context.close,
            setPanelWidth: context.setPanelWidth
        };
        $[1] = context.close;
        $[2] = context.open;
        $[3] = context.setPanelWidth;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : ()=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (!context) return {
        open: $bc35f8d5f81a3a68$var$noop,
        close: $bc35f8d5f81a3a68$var$noop,
        setPanelWidth: $bc35f8d5f81a3a68$var$noop
    };
    return {
        open: context.open,
        close: context.close,
        setPanelWidth: context.setPanelWidth
    };
};
module.exports["usePreviewPanelsActions"] = $bc35f8d5f81a3a68$export$5f5debba1692bf40;

});

parcelRegister("3Ap09", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ixfCV = parcelRequire("ixfCV");


var $63gyv = parcelRequire("63gyv");


var $7ssWV = parcelRequire("7ssWV");

const $4db84584556d15be$var$noop = ()=>{};
const $4db84584556d15be$var$initialState = {
    // Configured when opening a panel.
    panel: null,
    onOpen: $4db84584556d15be$var$noop,
    onClose: $4db84584556d15be$var$noop
};
const $4db84584556d15be$export$f473d225913e225d = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $4db84584556d15be$var$previewPanelsReducer = (state, action)=>{
    switch(action.type){
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.panel && state?.onPreviewPanelClose?.(state.panel);
            return {
                ...state,
                panel: null,
                onOpen: $4db84584556d15be$var$noop,
                onClose: $4db84584556d15be$var$noop
            };
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel?.id === params.panel.id) return state;
            /*
      	When opening a new preview panel, if the current panel is of the same type we don't
      	want to close the panel, but rather swap out the content. If the panel types don't match
      	we close the current panel and open the new one.
      	ex: A Goals panel is already open, and user tries to open a different Goals panel.
      	Parent Products must pass their preview panel close functions to the Preview Panel provider
      	via the `onPreviewPanelClose` prop.
      */ if (state.panel && !(0, $7ssWV.doPreviewPanelTypesMatch)(state.panel, params.panel)) // Close the active panel.
            state.onPreviewPanelClose?.(state.panel);
            state.panel && state.onClose();
            // Open the new panel.
            params.onOpen?.();
            state?.onPreviewPanelOpen?.(params.panel);
            return {
                ...state,
                panel: params.panel,
                onOpen: params.onOpen || $4db84584556d15be$var$initialState.onOpen,
                onClose: params.onClose || $4db84584556d15be$var$initialState.onClose
            };
        default:
            return state;
    }
};
const $4db84584556d15be$export$65ae37e9c61321f9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel, initialWidth: initialWidth } = t0;
    let t1;
    if ($[0] !== initialWidth) {
        t1 = (0, $ixfCV.fg)("nin_glance_panel_initial_width_ssr") ? {
            initialWidth: initialWidth
        } : undefined;
        $[0] = initialWidth;
        $[1] = t1;
    } else t1 = $[1];
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $63gyv.usePanelWidth)(t1);
    let t2;
    if ($[2] !== initialPanel) {
        t2 = initialPanel && (0, $ixfCV.fg)("preview_panel_initial_state") ? {
            panel: initialPanel
        } : {};
        $[2] = initialPanel;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== onPreviewPanelClose || $[5] !== onPreviewPanelOpen || $[6] !== t2) {
        t3 = {
            ...$4db84584556d15be$var$initialState,
            ...t2,
            onPreviewPanelOpen: onPreviewPanelOpen,
            onPreviewPanelClose: onPreviewPanelClose
        };
        $[4] = onPreviewPanelClose;
        $[5] = onPreviewPanelOpen;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    const [state, dispatch] = (0, $cozmU.useReducer)($4db84584556d15be$var$previewPanelsReducer, t3);
    let t4;
    if ($[8] !== onPanelWidthChanged || $[9] !== parentProduct || $[10] !== state) {
        t4 = (width)=>{
            onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
        };
        $[8] = onPanelWidthChanged;
        $[9] = parentProduct;
        $[10] = state;
        $[11] = t4;
    } else t4 = $[11];
    const setPanelWidth = t4;
    let t5;
    if ($[12] !== onPanelClosed) {
        t5 = (onClose)=>{
            dispatch?.({
                type: "CLOSE",
                onClose: onClose
            });
            onPanelClosed();
        };
        $[12] = onPanelClosed;
        $[13] = t5;
    } else t5 = $[13];
    const close = t5;
    let t6;
    if ($[14] !== onPanelOpened) {
        t6 = (params)=>{
            dispatch?.({
                type: "OPEN",
                params: params
            });
            onPanelOpened(params.width);
        };
        $[14] = onPanelOpened;
        $[15] = t6;
    } else t6 = $[15];
    const open = t6;
    let t7;
    if ($[16] !== close || $[17] !== open || $[18] !== panelWidth || $[19] !== setPanelWidth || $[20] !== state) {
        t7 = {
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        };
        $[16] = close;
        $[17] = open;
        $[18] = panelWidth;
        $[19] = setPanelWidth;
        $[20] = state;
        $[21] = t7;
    } else t7 = $[21];
    const context = t7;
    let t8;
    if ($[22] !== children || $[23] !== context) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4db84584556d15be$export$f473d225913e225d.Provider, {
            value: context
        }, children);
        $[22] = children;
        $[23] = context;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
} : ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel, initialWidth: initialWidth })=>{
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $63gyv.usePanelWidth)((0, $ixfCV.fg)('nin_glance_panel_initial_width_ssr') ? {
        initialWidth: initialWidth
    } : undefined);
    const [state, dispatch] = (0, $cozmU.useReducer)($4db84584556d15be$var$previewPanelsReducer, {
        ...$4db84584556d15be$var$initialState,
        ...initialPanel && (0, $ixfCV.fg)('preview_panel_initial_state') ? {
            panel: initialPanel
        } : {},
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose
    });
    const setPanelWidth = (0, $cozmU.useCallback)((width)=>{
        onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
    }, [
        onPanelWidthChanged,
        parentProduct,
        state
    ]);
    const close = (0, $cozmU.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
        onPanelClosed();
    }, [
        dispatch,
        onPanelClosed
    ]);
    const open = (0, $cozmU.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
        onPanelOpened(params.width);
    }, [
        dispatch,
        onPanelOpened
    ]);
    const context = (0, $cozmU.useMemo)(()=>({
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        }), [
        close,
        panelWidth,
        open,
        setPanelWidth,
        state
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4db84584556d15be$export$f473d225913e225d.Provider, {
        value: context
    }, children);
};
const $4db84584556d15be$export$609db4be92d0fad8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($4db84584556d15be$export$f473d225913e225d);
} : ()=>{
    return (0, $cozmU.useContext)($4db84584556d15be$export$f473d225913e225d);
};
module.exports["PreviewPanelsProvider"] = $4db84584556d15be$export$65ae37e9c61321f9;
module.exports["usePreviewPanelsContext"] = $4db84584556d15be$export$609db4be92d0fad8;

});

parcelRegister("63gyv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $55fM8 = parcelRequire("55fM8");


var $9DHhW = parcelRequire("9DHhW");


var $7y9ez = parcelRequire("7y9ez");

const $4ad8ebf5df3a3b12$export$82b270f291af5a5 = ({ initialWidth: initialWidth } = {})=>{
    const [defaultWidth, setDefaultWidth] = (0, $cozmU.useState)((0, $7y9ez.getDefaultPanelWidth));
    const [panelWidth, setPanelWidth] = (0, $cozmU.useState)(initialWidth ?? defaultWidth);
    const [manuallyResized, setManuallyResized] = (0, $cozmU.useState)(false);
    const [panelOpen, setPanelOpen] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const onPanelWidthChanged = (0, $cozmU.useCallback)((newPanelWidth, panelProduct, panelType, parentProduct)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                product: panelProduct,
                source: 'preview-panel',
                action: 'resize',
                actionSubject: 'resizer',
                actionSubjectId: 'previewPanelResizer',
                attributes: {
                    initialPanelWidth: panelWidth,
                    newPanelWidth: newPanelWidth,
                    newWidthSmaller: newPanelWidth < panelWidth,
                    parentProduct: parentProduct,
                    panelType: panelType,
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight
                }
            }
        }).fire();
        setPanelWidth(newPanelWidth);
        setManuallyResized(true);
    }, [
        createAnalyticsEvent,
        panelWidth
    ]);
    const onPanelOpened = (0, $cozmU.useCallback)((openWidth)=>{
        const width = openWidth ?? (manuallyResized ? panelWidth : defaultWidth);
        setPanelWidth(width);
        setPanelOpen(true);
    }, [
        defaultWidth,
        manuallyResized,
        panelWidth
    ]);
    const onPanelClosed = (0, $cozmU.useCallback)(()=>{
        setPanelOpen(false);
    }, []);
    // getDefaultPanelWidth does not dependencies related to this hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const windowResizeListener = (0, $cozmU.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
        if (!panelOpen) {
            setDefaultWidth((0, $7y9ez.getDefaultPanelWidth)());
            setManuallyResized(false);
        }
    }, 500), [
        panelOpen
    ]);
    (0, $cozmU.useEffect)(()=>{
        const unbind = (0, $cbY7C.bind)(window, {
            type: 'resize',
            listener: windowResizeListener
        });
        return ()=>{
            unbind();
        };
    }, [
        windowResizeListener
    ]);
    return {
        panelWidth: panelWidth,
        onPanelWidthChanged: onPanelWidthChanged,
        onPanelOpened: onPanelOpened,
        onPanelClosed: onPanelClosed
    };
};
module.exports["usePanelWidth"] = $4ad8ebf5df3a3b12$export$82b270f291af5a5;

});

parcelRegister("7y9ez", function(module, exports) {
const $c1ed100d044a4357$var$PANEL_DEFAULT_WIDTH = 400;
const $c1ed100d044a4357$var$PANEL_MAX_WIDTH = 1000;
const $c1ed100d044a4357$var$MINIMUM_WIDTH = 1800;
const $c1ed100d044a4357$var$PANEL_TO_WINDOW_WITH_RATIO = 0.3;
const $c1ed100d044a4357$export$29ceecbfeef33bfc = ()=>{
    const windowWidth = window.innerWidth;
    let width = $c1ed100d044a4357$var$PANEL_DEFAULT_WIDTH;
    if (windowWidth >= $c1ed100d044a4357$var$MINIMUM_WIDTH) {
        const proposedPanelWidth = Math.round(windowWidth * $c1ed100d044a4357$var$PANEL_TO_WINDOW_WITH_RATIO);
        width = proposedPanelWidth < $c1ed100d044a4357$var$PANEL_MAX_WIDTH ? proposedPanelWidth : $c1ed100d044a4357$var$PANEL_MAX_WIDTH;
    }
    return width;
};
module.exports["getDefaultPanelWidth"] = $c1ed100d044a4357$export$29ceecbfeef33bfc;

});

parcelRegister("7ssWV", function(module, exports) {

var $7avaU = parcelRequire("7avaU");

const $2fea0aef81deca52$export$eb89e687f2b278d7 = (currPanel, nextPanel)=>{
    // if both panels have their types set, we will check if they match
    if (currPanel?.type && nextPanel?.type) return currPanel.type === nextPanel.type;
    // else check against both panels' ari values
    if (currPanel?.ari && nextPanel?.ari) try {
        const currAri = (0, $7avaU.AnyAri).parse(currPanel.ari);
        const nextAri = (0, $7avaU.AnyAri).parse(nextPanel.ari);
        // ex: `${'confluence'}-${'page'}`, `${'confluence'}-${'blogpost'}`, `${'jira'}-${'project'}`, etc.
        return `${currAri.resourceOwner}-${currAri.resourceType}` === `${nextAri.resourceOwner}-${nextAri.resourceType}`;
    } catch (error) {
        // If parsing fails, we assume the ARI values do not match.
        return false;
    }
    // If neither panel has a type or ari, we assume they do not match.
    return false;
};
module.exports["doPreviewPanelTypesMatch"] = $2fea0aef81deca52$export$eb89e687f2b278d7;

});

parcelRegister("jvYFk", function(module, exports) {
var $d9aaea339f75cad2$export$328a8baf694e5d32 = /*#__PURE__*/ function(PanelName) {
    PanelName["CommentsPanel"] = "commentsPanel";
    PanelName["DetailsPanel"] = "detailsPanel";
    PanelName["AgentReceiptPanel"] = "agentReceiptPanel";
    PanelName["WorkflowsPanel"] = "workflowsPanel";
    PanelName["SpaceSuggestionReviewPanel"] = "space-suggestion-review-panel";
    return PanelName;
}({});
const $d9aaea339f75cad2$var$MIGRATED_PANEL_IDS = new Set([
    "commentsPanel",
    "detailsPanel",
    "agentReceiptPanel",
    "space-suggestion-review-panel",
    'jiraWorkItemsPanel'
]);
function $d9aaea339f75cad2$export$a9799883e6d611cc(panelId) {
    return !!panelId && $d9aaea339f75cad2$var$MIGRATED_PANEL_IDS.has(panelId);
}
module.exports["PanelName"] = $d9aaea339f75cad2$export$328a8baf694e5d32;
module.exports["isMigratedToPanelSystem"] = $d9aaea339f75cad2$export$a9799883e6d611cc;

});

parcelRegister("gczDe", function(module, exports) {

var $cz6eP = parcelRequire("cz6eP");

let $d31fe98ca852fa54$var$rendererEmitter = undefined;
const $d31fe98ca852fa54$export$894d051c63add88c = ()=>{
    if (!$d31fe98ca852fa54$var$rendererEmitter) $d31fe98ca852fa54$var$rendererEmitter = new (0, $cz6eP.AnnotationUpdateEmitter)();
    return $d31fe98ca852fa54$var$rendererEmitter;
};
module.exports["getRendererAnnotationEventEmitter"] = $d31fe98ca852fa54$export$894d051c63add88c;

});

parcelRegister("cz6eP", function(module, exports) {

var $eSa5t = parcelRequire("eSa5t");


var $5uEm7 = parcelRequire("5uEm7");

class $91ffffc20e95f4c4$export$7cc60aa9ef845515 extends (0, $eSa5t.EventEmitter) {
    on(event, listener) {
        return super.on(event, listener);
    }
    off(event, listener) {
        return super.removeListener(event, listener);
    }
}
function $91ffffc20e95f4c4$export$3238f27f6e07aed2() {
    return new (0, $5uEm7.SharedAnnotationManager)();
}
module.exports["AnnotationUpdateEmitter"] = $91ffffc20e95f4c4$export$7cc60aa9ef845515;
module.exports["createAnnotationManager"] = $91ffffc20e95f4c4$export$3238f27f6e07aed2;

});

parcelRegister("5uEm7", function(module, exports) {

var $eSa5t = parcelRequire("eSa5t");

class $ca65321d79324be4$export$c7aecf09b7cf478f {
    setPreemptiveGate(handler) {
        this.preemptiveGate = handler;
        return this;
    }
    checkPreemptiveGate() {
        if (this.activePreemptiveGate) // If the preemptive gate check already in flight then just return the promise
        // and don't call the preemptive gate again.
        // This is to prevent multiple calls to the preemptive gate creating multiple
        // promises that will resolve at different times.
        return Promise.resolve(this.activePreemptiveGate);
        const gate = this.activePreemptiveGate = this.preemptiveGate().then((result)=>{
            this.activePreemptiveGate = undefined;
            return result;
        });
        return gate;
    }
    onDraftAnnotationStarted(handler) {
        this.emitter.on('draftAnnotationStarted', handler);
        return this;
    }
    offDraftAnnotationStarted(handler) {
        this.emitter.off('draftAnnotationStarted', handler);
        return this;
    }
    onAnnotationSelectionChange(handler) {
        this.emitter.on('annotationSelectionChanged', handler);
        return this;
    }
    offAnnotationSelectionChange(handler) {
        this.emitter.off('annotationSelectionChanged', handler);
        return this;
    }
    emit(event) {
        this.emitter.emit(event.name, 'data' in event ? event.data : undefined);
        return this;
    }
    hook(method, handler) {
        this.hooks.set(method, handler);
        return this;
    }
    unhook(method, handler) {
        if (!this.hooks.has(method) || this.hooks.get(method) !== handler) return this;
        this.hooks.delete(method);
        return this;
    }
    allowAnnotation() {
        const fn = this.hooks.get('allowAnnotation');
        if (!fn) return false;
        try {
            return fn();
        } catch  {
            return false;
        }
    }
    startDraft() {
        const fn = this.hooks.get('startDraft');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn();
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    clearDraft() {
        const fn = this.hooks.get('clearDraft');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn();
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    applyDraft(id) {
        const fn = this.hooks.get('applyDraft');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn(id);
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    getDraft() {
        const fn = this.hooks.get('getDraft');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn();
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    setIsAnnotationSelected(id, isSelected) {
        const fn = this.hooks.get('setIsAnnotationSelected');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            // NOTE: The hook needs to manage the firing the annotationSelectionChanged event when a change is made. This is
            // because the hook is responsible for the state of the selection. The manager is not responsible for the state of
            // the selection.
            return fn(id, isSelected);
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    setIsAnnotationHovered(id, isHovered) {
        const fn = this.hooks.get('setIsAnnotationHovered');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn(id, isHovered);
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    clearAnnotation(id) {
        const fn = this.hooks.get('clearAnnotation');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn(id);
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    constructor(){
        /**
     * This is the event emitter that is used to emit events from the manager. It is used to communicate with
     * other parts of the application.
     */ this.emitter = new (0, $eSa5t.EventEmitter)();
        /**
     * This is the map of hooks that can be added to the manager. Hooks are a 1:1 mapping of methods that can be
     * called on the manager. They are used to extend the functionality of the manager.
     */ this.hooks = new Map();
        this.preemptiveGate = ()=>Promise.resolve(true);
        this.activePreemptiveGate = undefined;
    }
}
module.exports["SharedAnnotationManager"] = $ca65321d79324be4$export$c7aecf09b7cf478f;

});

parcelRegister("gfqXk", function(module, exports) {

var $cz6eP = parcelRequire("cz6eP");

let $d97010bba34874b5$var$editorEmitter = undefined;
const $d97010bba34874b5$export$60921b94e11f8e19 = ()=>{
    if (!$d97010bba34874b5$var$editorEmitter) $d97010bba34874b5$var$editorEmitter = new (0, $cz6eP.AnnotationUpdateEmitter)();
    return $d97010bba34874b5$var$editorEmitter;
};
module.exports["getEditorAnnotationEventEmitter"] = $d97010bba34874b5$export$60921b94e11f8e19;

});

parcelRegister("aSsfA", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $cD1qu = parcelRequire("cD1qu");

const $1874c19402f3b5d2$export$da5a0d0942eec3a4 = ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    let pageMode = (0, $cD1qu.PageMode).VIEW;
    if (isLivePage) pageMode = (0, $cD1qu.PageMode).LIVE;
    else if (isEditorPage) pageMode = (0, $cD1qu.PageMode).EDIT;
    return pageMode;
};
module.exports["useGetPageMode"] = $1874c19402f3b5d2$export$da5a0d0942eec3a4;

});

parcelRegister("de2j9", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name || routeName === (0, $1NBp8.SPACE_SETTINGS_AGENT_CONTEXT).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
};
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("htsj6", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $2PDpU = parcelRequire("2PDpU");


var $jMyy4 = parcelRequire("jMyy4");


var $jtuBN = parcelRequire("jtuBN");


var $ep3mz = parcelRequire("ep3mz");

const $feac3235d890b171$export$50af12b79850199d = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const props = t1;
    return $feac3235d890b171$export$689c7050603c5c14(props, false);
};
const $feac3235d890b171$export$689c7050603c5c14 = ({ skip: skip = false } = {}, returnRefreshFunction = true)=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const query = (0, $2PDpU.default);
    const options = {
        skip: skip || !contentId,
        variables: {
            contentId: contentId ?? ''
        }
    };
    let result;
    if (returnRefreshFunction) // eslint-disable-next-line react-hooks/rules-of-hooks
    result = (0, $jMyy4.useQueryInterop)(query, {
        ...options,
        __callerPackage__: "page-utils"
    });
    else // eslint-disable-next-line react-hooks/rules-of-hooks
    result = (0, $jtuBN.useQueryNoFurtherUpdateInterop)(query, {
        ...options,
        __callerPackage__: "page-utils"
    });
    const { data: data, loading: loading, error: error } = result;
    const contentNode = data?.content?.nodes?.[0];
    return {
        contentStatus: contentNode?.status,
        loading: loading,
        error: error,
        refetch: result.refetch,
        type: contentNode?.type
    };
};
module.exports["useContentStatus"] = $feac3235d890b171$export$50af12b79850199d;
module.exports["useContentStatusWithRefetch"] = $feac3235d890b171$export$689c7050603c5c14;

});

parcelRegister("2PDpU", function(module, exports) {
/**
 * @generated SignedSource<<46aaf98c7fe5f9fcbf890b27644f6f9d>>
 * @relayHash 11ef6cf70fe5a26f89cf732fe25cb27f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3f9fb295906ce3d568914d192655c22003c1f01326d83359089f2ceb66026cc5
const $ac2eaa9e4c9bbbba$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "current",
                        "draft",
                        "archived"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentStatusContentStatusQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentStatusContentStatusQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "11ef6cf70fe5a26f89cf732fe25cb27f",
            "id": "3f9fb295906ce3d568914d192655c22003c1f01326d83359089f2ceb66026cc5",
            "metadata": {},
            "name": "useContentStatusContentStatusQuery",
            "operationKind": "query",
            "text": "query useContentStatusContentStatusQuery($contentId:ID!){content(id:$contentId,status:[\"current\",\"draft\",\"archived\"]){nodes{id,status,type}}}"
        }
    };
}();
$ac2eaa9e4c9bbbba$var$node.hash = "42fd7c46b2fddcc220c48467ae805b6e";
var $ac2eaa9e4c9bbbba$export$2e2bcd8739ae039 = $ac2eaa9e4c9bbbba$var$node;
module.exports["default"] = $ac2eaa9e4c9bbbba$export$2e2bcd8739ae039;

});

parcelRegister("cZa7r", function(module, exports) {

var $9HkI0 = parcelRequire("9HkI0");


var $cozmU = parcelRequire("cozmU");


var $cz6eP = parcelRequire("cz6eP");


var $fJCU9 = parcelRequire("fJCU9");


var $epbW8 = parcelRequire("epbW8");


var $afGoD = parcelRequire("afGoD");


var $9QIM2 = parcelRequire("9QIM2");


var $gczDe = parcelRequire("gczDe");


var $4EKKB = parcelRequire("4EKKB");


var $3YBks = parcelRequire("3YBks");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $8WQTF = parcelRequire("8WQTF");

const $d99a6317060f344e$export$4162754b616020bc = 2000;
const $d99a6317060f344e$export$39085f26fb4d6afa = /*#__PURE__*/ (0, $cozmU.createContext)({
    selectionProps: null,
    hoverProps: null,
    viewProps: null,
    editorCreateProps: null,
    editorViewProps: null,
    showCreateComponent: false,
    showHighlightActions: false,
    selectionOptions: undefined,
    stepGenerationError: false,
    newlyCreatedAnnotationId: undefined,
    commentSidebarContext: null,
    isOffline: false,
    storedCommentData: null
});
$d99a6317060f344e$export$39085f26fb4d6afa.displayName = 'AnnotationsContext';
const $d99a6317060f344e$export$57d1b2fe9544d93c = /*#__PURE__*/ (0, $cozmU.createContext)(false);
$d99a6317060f344e$export$57d1b2fe9544d93c.displayName = 'AnnotationsOfflineContext';
const $d99a6317060f344e$var$ConditionalAnnotationsOfflineContextProvider = ({ children: children, value: value })=>{
    if ((0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d99a6317060f344e$export$57d1b2fe9544d93c.Provider, {
        value: value
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
const $d99a6317060f344e$export$6e641cb791644965 = /*#__PURE__*/ (0, $cozmU.createContext)({
    setSelectionProps: ()=>{},
    setHoverProps: ()=>{},
    setViewProps: ()=>{},
    setEditorCreateProps: ()=>{},
    setEditorViewProps: ()=>{},
    setShowCreateComponent: ()=>{},
    setShowHighlightActions: ()=>{},
    setSelectionOptions: ()=>{},
    setStepGenerationError: ()=>{},
    setSelectionOptionsForCreateEditor: ()=>{},
    setNewlyCreatedAnnotationId: ()=>{},
    setCommentSidebarContext: ()=>{},
    handleSaveSuccess: ()=>{},
    handleClose: ()=>{},
    setIsOffline: ()=>{},
    setStoredCommentData: ()=>{},
    clearStoredCommentData: ()=>{},
    waitForAnnotationElementAndEmit: ()=>{},
    applyDraftModeRef: {
        current: null
    }
});
$d99a6317060f344e$export$6e641cb791644965.displayName = 'AnnotationDispatchContext';
const $d99a6317060f344e$export$567c82ef93e7d5a1 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
$d99a6317060f344e$export$567c82ef93e7d5a1.displayName = 'AnnotationManagerContext';
const $d99a6317060f344e$export$22e6290b4a8e41d3 = ({ children: children })=>{
    const [selectionProps, setSelectionProps] = (0, $cozmU.useState)(null);
    const selectionPropsRef = (0, $cozmU.useRef)(null);
    /** Stable ref to applyDraftMode — never cleared, so nudge click can call it synchronously
   *  without waiting for the 100ms selectionchange debounce. */ const applyDraftModeRef = (0, $cozmU.useRef)(null);
    // Keep refs in sync with state — useEffect so it never runs during render
    (0, $cozmU.useEffect)(()=>{
        selectionPropsRef.current = selectionProps;
        if (selectionProps?.applyDraftMode) applyDraftModeRef.current = selectionProps.applyDraftMode;
    }, [
        selectionProps
    ]);
    const [hoverProps, setHoverProps] = (0, $cozmU.useState)(null);
    const [viewProps, setViewProps] = (0, $cozmU.useState)(null);
    const [editorCreateProps, setEditorCreateProps] = (0, $cozmU.useState)(null);
    const [editorViewProps, setEditorViewProps] = (0, $cozmU.useState)(null);
    const [showCreateComponent, setShowCreateComponent] = (0, $cozmU.useState)(false);
    const [showHighlightActions, setShowHighlightActions] = (0, $cozmU.useState)(false);
    const [selectionOptions, setSelectionOptions] = (0, $cozmU.useState)();
    const [stepGenerationError, setStepGenerationError] = (0, $cozmU.useState)(false);
    const [newlyCreatedAnnotationId, setNewlyCreatedAnnotationId] = (0, $cozmU.useState)();
    const [commentSidebarContext, setCommentSidebarContext] = (0, $cozmU.useState)(null);
    const [prevContentId, setPrevContentId] = (0, $cozmU.useState)(null);
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const pageClass = (0, $9QIM2.usePageClass)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const annotationManager = (0, $cozmU.useMemo)(()=>(0, $9wGTI.fg)('platform_editor_comments_api_manager') ? (0, $cz6eP.createAnnotationManager)() : undefined, []);
    // This is effectively used with editorCreateProps and editorViewProps but we're tracking it independently as it doesn't really tie into the same lifecycle events
    const [isOffline, setIsOffline] = (0, $cozmU.useState)(false);
    // Stored comment data for direct data flow
    const [storedCommentData, setStoredCommentData] = (0, $cozmU.useState)(null);
    // Track active MutationObserver and timeout for cleanup on unmount
    const activeObserverRef = (0, $cozmU.useRef)(null);
    const activeTimeoutRef = (0, $cozmU.useRef)(null);
    /**
   * Waits for an annotation element to appear in the DOM using MutationObserver,
   * then emits annotation selection events. If element doesn't appear within 2 seconds,
   * fails the VIEW_INLINE_COMMENT_EXPERIENCE.
   */ const waitForAnnotationElementAndEmit = (0, $cozmU.useCallback)((annotationId, emitter)=>{
        // Clean up any existing observer/timeout before creating new ones
        if (activeObserverRef.current) activeObserverRef.current.disconnect();
        if (activeTimeoutRef.current) clearTimeout(activeTimeoutRef.current);
        // Use MutationObserver to wait for element to appear in DOM
        activeObserverRef.current = new MutationObserver(()=>{
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const element = document.getElementById(annotationId);
            if (element) {
                if (activeObserverRef.current) activeObserverRef.current.disconnect();
                if (activeTimeoutRef.current) clearTimeout(activeTimeoutRef.current);
                activeObserverRef.current = null;
                activeTimeoutRef.current = null;
                // Emit annotation events and check if listeners exist
                if (emitter.emit((0, $fJCU9.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                    annotationIds: [
                        annotationId
                    ],
                    eventTarget: element
                })) {
                    emitter.emit((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                        annotationId: annotationId
                    });
                    setNewlyCreatedAnnotationId(annotationId);
                } else // No listeners registered - fail the experience
                experienceTracker.fail({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    error: new Error('Failed to emit annotation click')
                });
            }
        });
        // Observe the renderer wrapper for child additions (fallback to document.body for safety)
        const rendererWrapper = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.querySelector('#content .ak-renderer-wrapper') || document.body;
        activeObserverRef.current.observe(rendererWrapper, {
            childList: true,
            subtree: true
        });
        // Fallback: If element doesn't appear within timeout, fail the experience
        // This almost always happens due to super slow re-renders (slow client on large page)
        activeTimeoutRef.current = setTimeout(()=>{
            if (activeObserverRef.current) activeObserverRef.current.disconnect();
            activeObserverRef.current = null;
            activeTimeoutRef.current = null;
            experienceTracker.fail({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                error: new Error(`Annotation element not found in DOM after ${$d99a6317060f344e$export$4162754b616020bc}ms`)
            });
        }, $d99a6317060f344e$export$4162754b616020bc);
    }, [
        experienceTracker,
        setNewlyCreatedAnnotationId
    ]);
    // Cleanup observer and timeout on unmount
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (activeObserverRef.current) {
                activeObserverRef.current.disconnect();
                activeObserverRef.current = null;
            }
            if (activeTimeoutRef.current) {
                clearTimeout(activeTimeoutRef.current);
                activeTimeoutRef.current = null;
            }
        };
    }, []);
    // Get rendererActions for renderer mode (always call hook, but only use when feature gate is enabled)
    const rendererActionsHook = (0, $8WQTF.useRendererActions)();
    const rendererActions = rendererActionsHook?.rendererActions;
    (0, $cozmU.useEffect)(()=>{
        const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
        function handleAnnotationFocus({ annotationId: annotationId }) {
            // The fact annotations is an array here is meaningless at this time - Confluence
            // always picks the top annotation
            const focusedAnnotation = annotationId;
            if (!focusedAnnotation) {
                // If there is no running experience -- then this is a noop.
                (0, $4EKKB.selectInlineComment).debug('Renderer emitted event indicating no focused annotation.');
                return;
            }
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.complete({
                pageClass: pageClass,
                entryPoint: 'unknown:RendererFocus',
                annotationId: focusedAnnotation
            });
        }
        // Fired when an annotation is focused (ie. comment navigation, comment click)
        emitter.on((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, handleAnnotationFocus);
        return ()=>{
            emitter.off((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, handleAnnotationFocus);
        };
    }, [
        pageClass
    ]);
    const resetProviderState = (0, $cozmU.useCallback)(()=>{
        setSelectionProps(null);
        setHoverProps(null);
        setViewProps(null);
        setEditorCreateProps(null);
        setEditorViewProps(null);
        setShowCreateComponent(false);
        setShowHighlightActions(false);
        setSelectionOptions(undefined);
        setStepGenerationError(false);
        setNewlyCreatedAnnotationId(undefined);
        setCommentSidebarContext(null);
        setStoredCommentData(null);
    }, []);
    // When the content ID changes, reset the provider state
    (0, $cozmU.useEffect)(()=>{
        if (!contentId) return;
        if (prevContentId && contentId !== prevContentId) {
            resetProviderState();
            // Deselect any currently selected annotations
            (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
        }
        setPrevContentId(contentId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
    const handleClose = (0, $cozmU.useCallback)(()=>{
        setShowCreateComponent(false);
        setStepGenerationError(false);
        setSelectionOptions(undefined);
        if (annotationManager) annotationManager.clearDraft();
        else selectionProps && selectionProps.onClose();
        setSelectionProps(null);
    }, [
        setShowCreateComponent,
        setStepGenerationError,
        setSelectionOptions,
        selectionProps,
        annotationManager
    ]);
    /*
   * NOTE: This function will not be calling setShowCreateComponent because it's
   *       consumers will not be refreshing themselves with new selectionOptions.
   *       It will now be the responsibility of the consumers of this function to call
   *       setShowCreateComponent(true). See SelectionComponent.tsx (~line 132)
   */ const setSelectionOptionsForCreateEditor = (0, $cozmU.useCallback)(({ experienceAttributes: experienceAttributes } = {})=>{
        setShowCreateComponent(false); // Hide an existing create component if it exists
        const annotationId = (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
        // Narrow pageClass to 'renderer' | 'editor' for the experience attributes
        const pageClassAttr = pageClass === 'renderer' ? 'renderer' : 'editor';
        (0, $3YBks.createInlineCommentCompoundExperience).start({
            attributes: {
                pageClass: pageClassAttr,
                commentType: 'inline',
                annotationId: annotationId,
                ...experienceAttributes
            }
        });
        (0, $3YBks.createInlineCommentCompoundExperience).initExperience.start();
        let result = undefined;
        if (annotationManager) {
            const startDraftResult = annotationManager.startDraft();
            if (startDraftResult.success) result = startDraftResult.actionResult;
        } else {
            /* selectionPropsRef fallback: selectionProps (React state) may be null immediately
         after a sidebar close due to a render-cycle gap, while the ref holds the last-known
         value. Prefer the ref (updated synchronously) so nudge click always gets the freshest
         value. For experiment-OFF callers, selectionProps is non-null so ref vs state is moot. */ const currentSelectionProps = selectionPropsRef.current ?? selectionProps;
            if (!currentSelectionProps) {
                // selectionProps is not defined. This may occur if a comment sidebar box was just closed, which
                // unsets selectionProps. In this case, we treat this as no-op, and unselect any annotation.
                (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
                // We soft-fail create-inline-comment/init experience here to track how often this occurs.
                (0, $3YBks.createInlineCommentCompoundExperience).initExperience.softFail(new Error('Attempted to create inline comment when no selection was present'));
                return;
            }
            result = currentSelectionProps.applyDraftMode({
                annotationId: annotationId,
                keepNativeSelection: false
            });
        }
        const ancestorNodeTypes = result?.ancestorNodeTypes ?? [];
        const alphabeticalAncestorNodeTypes = [
            ...ancestorNodeTypes
        ].sort();
        (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
            inlineNodeTypes: result?.inlineNodeTypes ?? [],
            ancestorNodeTypes: ancestorNodeTypes,
            alphabeticalAncestorNodeTypes: alphabeticalAncestorNodeTypes,
            // @ts-ignore
            initialPosition: [
                result?.step?.from,
                result?.step?.to
            ]
        });
        if (result) {
            setSelectionOptions({
                step: result.step,
                inlineNodeTypes: result.inlineNodeTypes,
                originalSelection: result.originalSelection,
                numMatches: result.numMatches,
                matchIndex: result.matchIndex,
                createdFrom: (0, $afGoD.CommentCreationLocation).RENDERER,
                pos: result.pos,
                targetNodeType: result.targetNodeType
            });
            // Tell the renderer to close any currently-open comments
            (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            setShowHighlightActions(false);
        } else {
            setStepGenerationError(true);
            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.fail(new Error('Failed to generate step'));
        }
    }, [
        selectionProps,
        setShowCreateComponent,
        setShowHighlightActions,
        setStepGenerationError,
        annotationManager,
        pageClass
    ]);
    const handleSaveSuccess = (0, $cozmU.useCallback)((annotationId, commentData)=>{
        setStepGenerationError(false);
        setCommentSidebarContext('create');
        // Set stored comment data for direct data flow when experiment is enabled
        if (commentData) setStoredCommentData(commentData);
        let result = false;
        if (annotationManager) {
            const result = annotationManager.applyDraft(annotationId);
            if (result.success && !!result.actionResult?.doc) {
                selectionProps.updateDocument && selectionProps.updateDocument(result.actionResult.doc);
                setNewlyCreatedAnnotationId(annotationId);
            } else throw new Error('Error ocurred when applying the step to the active document');
        } else // Renderer mode: Try using rendererActions.applyAnnotation() first (similar to editor's annotationManager.applyDraft())
        // This provides more reliable annotation application, matching the editor implementation
        if (rendererActions && selectionOptions?.step) {
            const step = selectionOptions.step;
            // Extract position from step - use pos if available, otherwise use from/to
            const position = selectionOptions.pos ? {
                to: selectionOptions.pos,
                from: selectionOptions.pos
            } : {
                to: step.to,
                from: step.from
            };
            const annotationResult = rendererActions.applyAnnotation(position, {
                annotationId: annotationId,
                annotationType: (0, $epbW8.AnnotationTypes).INLINE_COMMENT
            });
            if (annotationResult && annotationResult.doc) {
                const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                if (!storedCommentData) selectionProps.removeDraftMode();
                selectionProps.updateDocument && selectionProps.updateDocument(annotationResult.doc);
                waitForAnnotationElementAndEmit(annotationId, emitter);
            } else throw new Error('Error ocurred when applying the step to the active document');
        } else {
            // Fallback to original onCreate method
            // Since we generated the uuid ourselves, we need to replace the document generated with
            // the annotationId that we received from the backend so things line up correctly
            result = selectionProps.onCreate(annotationId);
            if (result) {
                const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                if (!storedCommentData) selectionProps.removeDraftMode();
                selectionProps.updateDocument && selectionProps.updateDocument(result.doc);
                waitForAnnotationElementAndEmit(annotationId, emitter);
            } else throw new Error('Error ocurred when applying the step to the active document');
        }
    }, [
        annotationManager,
        setStepGenerationError,
        setNewlyCreatedAnnotationId,
        selectionProps,
        setStoredCommentData,
        storedCommentData,
        rendererActions,
        selectionOptions,
        waitForAnnotationElementAndEmit
    ]);
    const providerValue = (0, $cozmU.useMemo)(()=>({
            selectionProps: selectionProps,
            hoverProps: hoverProps,
            viewProps: viewProps,
            editorCreateProps: editorCreateProps,
            editorViewProps: editorViewProps,
            showCreateComponent: showCreateComponent,
            showHighlightActions: showHighlightActions,
            selectionOptions: selectionOptions,
            stepGenerationError: stepGenerationError,
            newlyCreatedAnnotationId: newlyCreatedAnnotationId,
            commentSidebarContext: commentSidebarContext,
            isOffline: isOffline,
            storedCommentData: storedCommentData
        }), [
        selectionProps,
        hoverProps,
        viewProps,
        editorCreateProps,
        editorViewProps,
        showCreateComponent,
        showHighlightActions,
        selectionOptions,
        stepGenerationError,
        newlyCreatedAnnotationId,
        commentSidebarContext,
        isOffline,
        storedCommentData
    ]);
    const dispatchProviderValue = (0, $cozmU.useMemo)(()=>({
            setSelectionProps: setSelectionProps,
            setHoverProps: setHoverProps,
            setViewProps: setViewProps,
            setEditorCreateProps: setEditorCreateProps,
            setEditorViewProps: setEditorViewProps,
            setShowCreateComponent: setShowCreateComponent,
            setShowHighlightActions: setShowHighlightActions,
            setSelectionOptions: setSelectionOptions,
            setStepGenerationError: setStepGenerationError,
            setSelectionOptionsForCreateEditor: setSelectionOptionsForCreateEditor,
            setNewlyCreatedAnnotationId: setNewlyCreatedAnnotationId,
            setCommentSidebarContext: setCommentSidebarContext,
            handleSaveSuccess: handleSaveSuccess,
            handleClose: handleClose,
            setIsOffline: setIsOffline,
            // Stored comment data management functions
            setStoredCommentData: (commentData)=>setStoredCommentData(commentData ?? null),
            clearStoredCommentData: ()=>setStoredCommentData(null),
            waitForAnnotationElementAndEmit: waitForAnnotationElementAndEmit,
            applyDraftModeRef: applyDraftModeRef
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        setSelectionProps,
        setHoverProps,
        setViewProps,
        setEditorCreateProps,
        setEditorViewProps,
        setShowCreateComponent,
        setShowHighlightActions,
        setSelectionOptions,
        setStepGenerationError,
        setSelectionOptionsForCreateEditor,
        setNewlyCreatedAnnotationId,
        setCommentSidebarContext,
        handleSaveSuccess,
        handleClose,
        setIsOffline,
        // Stored comment data management functions
        setStoredCommentData,
        waitForAnnotationElementAndEmit
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d99a6317060f344e$export$567c82ef93e7d5a1.Provider, {
        value: annotationManager
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d99a6317060f344e$export$39085f26fb4d6afa.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d99a6317060f344e$export$6e641cb791644965.Provider, {
        value: dispatchProviderValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d99a6317060f344e$var$ConditionalAnnotationsOfflineContextProvider, {
        value: isOffline
    }, children))));
};
const $d99a6317060f344e$export$ede9be424e8ef89a = ()=>{
    return (0, $cozmU.useContext)($d99a6317060f344e$export$39085f26fb4d6afa);
};
const $d99a6317060f344e$export$3be336e5c3e78567 = ()=>{
    return (0, $cozmU.useContext)($d99a6317060f344e$export$6e641cb791644965);
};
const $d99a6317060f344e$export$3998d49469d13f97 = ()=>{
    return (0, $cozmU.useContext)($d99a6317060f344e$export$567c82ef93e7d5a1);
};
const $d99a6317060f344e$export$3757730e05e42ee2 = ()=>{
    return (0, $cozmU.useContext)($d99a6317060f344e$export$57d1b2fe9544d93c);
};
module.exports["AnnotationsProvider"] = $d99a6317060f344e$export$22e6290b4a8e41d3;
module.exports["useAnnotations"] = $d99a6317060f344e$export$ede9be424e8ef89a;
module.exports["useAnnotationsDispatch"] = $d99a6317060f344e$export$3be336e5c3e78567;
module.exports["useAnnotationManager"] = $d99a6317060f344e$export$3998d49469d13f97;
module.exports["useAnnotationsIsOffline"] = $d99a6317060f344e$export$3757730e05e42ee2;

});

parcelRegister("afGoD", function(module, exports) {
/**
 * @generated SignedSource<<71be4194137313c8ff0872a3df259dda>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $f8b43d46712cd783$export$cdccd0683766be81 = /*#__PURE__*/ function(CommentCreationLocation) {
    CommentCreationLocation["DATABASE"] = "DATABASE";
    CommentCreationLocation["EDITOR"] = "EDITOR";
    CommentCreationLocation["LIVE"] = "LIVE";
    CommentCreationLocation["RENDERER"] = "RENDERER";
    CommentCreationLocation["WHITEBOARD"] = "WHITEBOARD";
    return CommentCreationLocation;
}({});
var $f8b43d46712cd783$export$f4016897b165b6d5 = /*#__PURE__*/ function(ContentRepresentation) {
    ContentRepresentation["ATLAS_DOC_FORMAT"] = "ATLAS_DOC_FORMAT";
    ContentRepresentation["EDITOR"] = "EDITOR";
    ContentRepresentation["EDITOR2"] = "EDITOR2";
    ContentRepresentation["EXPORT_VIEW"] = "EXPORT_VIEW";
    ContentRepresentation["PLAIN"] = "PLAIN";
    ContentRepresentation["RAW"] = "RAW";
    ContentRepresentation["STORAGE"] = "STORAGE";
    ContentRepresentation["STYLED_VIEW"] = "STYLED_VIEW";
    ContentRepresentation["VIEW"] = "VIEW";
    ContentRepresentation["WIKI"] = "WIKI";
    return ContentRepresentation;
}({});
var $f8b43d46712cd783$export$2dffd0b5373a4389 = /*#__PURE__*/ function(Platform) {
    Platform["ANDROID"] = "ANDROID";
    Platform["IOS"] = "IOS";
    Platform["WEB"] = "WEB";
    return Platform;
}({});
var $f8b43d46712cd783$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["CommentCreationLocation"] = $f8b43d46712cd783$export$cdccd0683766be81;

});

parcelRegister("9QIM2", function(module, exports) {

var $de2j9 = parcelRequire("de2j9");


var $3jwuS = parcelRequire("3jwuS");


var $dPJCf = parcelRequire("dPJCf");


var $gEtAQ = parcelRequire("gEtAQ");

function $06d23c10422abe2f$export$d9ae12e82c9f2aba() {
    // Note -- this hook does not inform the consumer if they are on a live doc page which
    // is using the editor.
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const isCurrentPageLive = (0, $3jwuS.useIsCurrentPageLive)();
    // useRouteName use RoutesContext which is more reliable than reading window.location.pathname directly.
    const routeName = (0, $dPJCf.useRouteName)({
        selector: (name)=>name
    });
    if (isEditorPage) return 'editor';
    if (isCurrentPageLive) return 'editor';
    const isTinyMCEPage = $06d23c10422abe2f$var$__checkIfTinyMCEEditorPage();
    if (isTinyMCEPage) // TinyMCE pages are not considered editor pages or docs in the context of this hook
    return 'tinyMCE';
    // Pass routeName to isDatabase/isWhiteboard - they will use it to avoid race conditions during SPA transitions
    if ((0, $gEtAQ.isDatabase)(routeName)) return 'database';
    if ((0, $gEtAQ.isWhiteboard)(routeName)) return 'whiteboard';
    if ((0, $gEtAQ.isSlides)(routeName)) return 'slide';
    return 'renderer';
}
function $06d23c10422abe2f$var$__checkIfTinyMCEEditorPage() {
    const possibleTinyMCESelectors = [
        `[data-testid="TinyMCERendererTestId"]`,
        '.tinymce-editor'
    ];
    // This check is only relevant in the context of comment experiences
    // and so if we are in an environment without a document -- we
    // can safely treat it as not a tinymce page.
    if (typeof document === 'undefined') return false;
    const isTinyMCEPage = possibleTinyMCESelectors.some(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    (selector)=>document.querySelector(selector) !== null);
    return isTinyMCEPage;
}
module.exports["usePageClass"] = $06d23c10422abe2f$export$d9ae12e82c9f2aba;

});

parcelRegister("gEtAQ", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $b5832a8b6d0203e7$export$d9797e3a42403d0f = ()=>Boolean((0, $1NBp8.VIEW_PAGE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$b6ab121b23baa35 = ()=>Boolean((0, $1NBp8.VIEW_BLOG).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_MOBILE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$99418391c9d4edd1 = ()=>Boolean((0, $1NBp8.HOME).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3b7cd9ec7876f958 = ()=>Boolean((0, $1NBp8.EDIT_PAGE_EMBED).match(window.location.pathname) || (0, $1NBp8.EDIT_PAGE_V2).match(window.location.pathname) || (0, $1NBp8.EDIT_BLOG_V2).match(window.location.pathname) || (0, $1NBp8.EDIT_PAGE).match(window.location.pathname) || (0, $1NBp8.EDIT_BLOG).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3ea67fa37c59fc23 = ()=>Boolean((0, $1NBp8.SPACE_OVERVIEW).match(window.location.pathname));
const $b5832a8b6d0203e7$export$ea39914fa18450ef = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.DATABASE_VIEW).name;
    return Boolean((0, $1NBp8.DATABASE_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$3a15fff847513284 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.WHITEBOARD_BOARD).name;
    return Boolean((0, $1NBp8.WHITEBOARD_BOARD).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$e40fec4aab490836 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.SLIDES_VIEW).name;
    return Boolean((0, $1NBp8.SLIDES_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$49ce8db5bd2e4087 = (routeName)=>{
    if (!routeName) return false;
    const editRoutes = [
        (0, $1NBp8.EDIT_PAGE_EMBED).name,
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name
    ];
    return editRoutes.includes(routeName);
};
module.exports["isViewPage"] = $b5832a8b6d0203e7$export$d9797e3a42403d0f;
module.exports["isBlogPage"] = $b5832a8b6d0203e7$export$b6ab121b23baa35;
module.exports["isHomePage"] = $b5832a8b6d0203e7$export$99418391c9d4edd1;
module.exports["isSpaceOverview"] = $b5832a8b6d0203e7$export$3ea67fa37c59fc23;
module.exports["isDatabase"] = $b5832a8b6d0203e7$export$ea39914fa18450ef;
module.exports["isWhiteboard"] = $b5832a8b6d0203e7$export$3a15fff847513284;
module.exports["isSlides"] = $b5832a8b6d0203e7$export$e40fec4aab490836;
module.exports["isEditPage"] = $b5832a8b6d0203e7$export$49ce8db5bd2e4087;

});

parcelRegister("4EKKB", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $gykrH = parcelRequire("gykrH");


var $irVI7 = parcelRequire("irVI7");


var $aJPUt = parcelRequire("aJPUt");


var $fGzMp = parcelRequire("fGzMp");


var $8Ss4E = parcelRequire("8Ss4E");


var $gtj7V = parcelRequire("gtj7V");

let $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
function $d671aa981fcb4da6$var$getSelectInlineCommentExperienceDebug(_experienceName, experienceStage) {
    function createInlineCommentExperienceDebug({ error: error, extraAttributes: extraAttributes }) {
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `Legacy select debug message: ${error.message || String(error)}`,
            attributes: {
                ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes,
                ...extraAttributes,
                experienceStage: experienceStage
            }
        });
    }
    return createInlineCommentExperienceDebug;
}
var $d671aa981fcb4da6$var$ExperienceType = /*#__PURE__*/ function(ExperienceType) {
    ExperienceType["DOCUMENT"] = "document";
    ExperienceType["DOCUMENT_WITH_PANEL"] = "documentWithPanel";
    ExperienceType["PANEL"] = "panel";
    return ExperienceType;
}($d671aa981fcb4da6$var$ExperienceType || {});
function $d671aa981fcb4da6$var$getExperienceType(entryPoint, sidebarOpenAtStart) {
    switch(entryPoint){
        case 'create-comment':
        case 'comment-navigation':
        case 'unknown:InlineComment':
            return "document";
        case 'annotation-change':
        case 'keyboard-navigation':
        case 'unknown:RendererFocus':
            return sidebarOpenAtStart ? "documentWithPanel" : "document";
        case 'sidebar':
        case 'unknown:CommentsPanelList':
            return "panel";
        default:
            return "document";
    }
}
const $d671aa981fcb4da6$export$e2b3aff7888f2745 = {
    _start: (startAttributes, _options)=>{
        if (startAttributes.pageClass === 'tinyMCE' || startAttributes.pageClass === 'database' || startAttributes.pageClass === 'whiteboard' || startAttributes.pageClass === 'slide') return;
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        const experienceState = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE));
        const runningExperienceAttributes = experienceState?.attributes;
        if (!experienceState?.hasStopped && runningExperienceAttributes?.annotationId !== undefined && runningExperienceAttributes?.annotationId === startAttributes.annotationId) {
            // If there is an existing (unstopped) experience
            // - and that experience has an annotationId
            //   - keyboard and comment navigation will start experiences without an annotationId -- and these should be restarted on an new start
            // - and that annotationId matches the one in the startAttributes
            // we assume the experience is still active, and don't start a new one.
            // the reason we can hit this is because the selectInlineCommentCompoundExperience._start is called when there is a "select inline comment"
            // signal, and individual signals fire in different orders (sometimes they are the first signal, sometimes they are later).
            // However -- if the second signal has a clearer entry point
            // we update the entry point attribute of the existing experience.
            if (runningExperienceAttributes?.entryPoint?.startsWith('unknown') && !startAttributes.entryPoint.startsWith('unknown')) {
                $d671aa981fcb4da6$export$e2b3aff7888f2745.addCommonAttributes({
                    entryPoint: startAttributes.entryPoint
                });
                experienceTracker.attachDebugPoint({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    message: `After starting from ${runningExperienceAttributes.entryPoint}, received signal from ${startAttributes.entryPoint}`
                });
            }
            return;
        }
        if (// When the side bar is open, and the user selects a comment using the keyboard,
        // the keyboard navigation triggers a select annotation first (without an annotationId),
        // followed by the show comment start or select annotation complete (with an annotationId.
        startAttributes.entryPoint === 'unknown:CommentsPanelList' && runningExperienceAttributes?.entryPoint === 'keyboard-navigation' && runningExperienceAttributes?.annotationId === undefined) {
            $d671aa981fcb4da6$export$e2b3aff7888f2745.addCommonAttributes({
                annotationId: startAttributes.annotationId
            });
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: `After starting from ${runningExperienceAttributes.entryPoint}, received signal from ${startAttributes.entryPoint} with annotationId ${startAttributes.annotationId}`
            });
            return;
        }
        // First prepare the new attributes without modifying the global state
        // This ensures that any abort of current experiences will use their original attributes
        const newAttributes = {
            pageClass: startAttributes.pageClass,
            commentType: startAttributes.commentType,
            annotationId: 'annotationId' in startAttributes ? startAttributes.annotationId : undefined,
            entryPoint: startAttributes.entryPoint,
            version: 'single-experience'
        };
        // We check if there is a dom element with a testId of "object-sidebar-panel-body" and if so mark the
        // experience as being during a sidebar open experience.
        newAttributes.sidebarOpenAtStart = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.querySelector('[data-testid="object-sidebar-panel-body"]') !== null;
        newAttributes.experienceType = $d671aa981fcb4da6$var$getExperienceType(startAttributes.entryPoint, newAttributes.sidebarOpenAtStart);
        // If the create inline comment experience is running, we want to link the two experiences
        const createInlineCommentExperienceState = experienceTracker.getExperienceState((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE));
        if (createInlineCommentExperienceState && !createInlineCommentExperienceState.hasStopped) newAttributes.linkedCompoundTaskId = createInlineCommentExperienceState.attributes?.compoundTaskId;
        // Adds a debug point to the last running experience (debug points are only added if there is a running experience)
        // Note:
        // A new experience is followed after this is fired -- so this should always be the last debug point (as the new experience will trigger a fail or abort).
        // In the case there is no running experience, the experience tracker will discard the debugPoint.
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `Restarted from ${startAttributes.entryPoint} with annotationId: ${startAttributes.annotationId} (sidebarOpenAtStart: ${newAttributes.sidebarOpenAtStart})`
        });
        // Start press trace if no trace is currently active
        (0, $8Ss4E.startUFOPressTrace)((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE));
        // Then start a new compound experience with the new attributes
        // This will abort any running experiences with the same name, but they'll keep their original attributes
        experienceTracker.start({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                ...newAttributes,
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)()
            },
            // If the annotation is not selected and comment shown to the user within 12 seconds -- we assume there has been a failure to select the inline comment
            timeout: (0, $aJPUt.ExperienceTimeout).SELECT_INLINE_COMMMENT,
            collect: (events)=>{
                const isThisCommentBeingResolved = (event)=>{
                    return event.name === (0, $irVI7.RESOLVE_INLINE_COMMENT_EXPERIENCE) && event.action === 'taskStart' && (0, $gykrH.hasAttribute)(event, 'annotationId', $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId);
                };
                events.forEach((event)=>{
                    if (isThisCommentBeingResolved(event)) $d671aa981fcb4da6$export$e2b3aff7888f2745.abort({
                        abortReason: 'Comment being resolved'
                    });
                });
            }
        });
        if (startAttributes.annotationId === undefined) experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `selectInlineCommentCompoundExperience._start started from ${startAttributes.entryPoint} with unknown annotationId`
        });
        else experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `selectInlineCommentCompoundExperience._start started from ${startAttributes.entryPoint} with annotationId ${startAttributes.annotationId}`
        });
        // Now it's safe to update the global state since any aborts have already happened
        // We reset experience state if we are starting a new experience
        $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {
            ...newAttributes,
            ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)()
        };
        // By the time we get a task fail (particularly for timeout aborts) -- the contentId may have changed
        const originalContentId = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE))?.attributes?.contentId;
        $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.originalContentId = originalContentId;
        experienceTracker.updateAttributes({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                originalContentId: originalContentId
            }
        });
    },
    debugPoint: (message, attributes)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: message,
            attributes: attributes
        });
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            message: message,
            attributes: attributes
        });
    },
    addCommonAttributes: (additionalCommonAttributes)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {
            ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes,
            ...additionalCommonAttributes
        };
        experienceTracker.updateAttributes({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            attributes: additionalCommonAttributes
        });
    },
    abort: ({ abortReason: abortReason })=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.abort({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            reason: abortReason,
            checkForTimeout: true
        });
        $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
    },
    selectAnnotation: {
        debug: $d671aa981fcb4da6$var$getSelectInlineCommentExperienceDebug((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE), 'selectAnnotation'),
        /**
     * This is currently used to start from
     * - annotationId unknown
     *   - comment navigation
     *   - keyboard navigation
     * - annotationId known
     *   - create comment
     *   - comment sidebar comment selection
     *
     * These should be separate signals once the multi experience is deprecated.
     */ start: (startAttributes)=>{
            function isUnknownAnnotationId(startAttributes) {
                return startAttributes.entryPoint === 'keyboard-navigation' || startAttributes.entryPoint === 'comment-navigation';
            }
            if (isUnknownAnnotationId(startAttributes)) {
                $d671aa981fcb4da6$export$e2b3aff7888f2745._start(startAttributes, {
                    annotationUnknown: true
                });
                return;
            }
            $d671aa981fcb4da6$export$e2b3aff7888f2745._start(startAttributes);
        },
        abort: ({ abortReason: abortReason })=>{
            $d671aa981fcb4da6$export$e2b3aff7888f2745.abort({
                abortReason: // @ts-ignore the abort reasons have mismatch due to type from the old multi experience. and once that is removed we can remove this cast
                abortReason
            });
            $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
        },
        /**
     * Note -- the selectAnnotation does not trigger a completion of the selectInlineComment experience.
     * Instead -- the selectInlineComment experience is completed when the showComment experience completes
     * (which looks for the selected annotation as part of its completion logic).
     *
     * With the single experience -- this is less a complete and rather just an indirect signal that a selection has been made (in case it's not detected by the showComment experience).
     * When the multi selectInlineCommentCompoundExperience is deprecated, this can be renamed to indicate it's a "annotationSelection" signal rather than a "completed" signal.
     */ complete: (startAttributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            const experienceState = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE));
            // There can be cases where no start has been called for the select experience.
            // - When a product consumer of the editor setselectedannotation api calls the select experience
            //   and has not been instrumented.
            // - When the annotation selection is via editor logic (ie. editor selection being moved onto
            //   an annotation).
            if (experienceState === null) {
                experienceTracker.attachDebugPoint({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    message: 'selectAnnotation completed from no experience - no explicit start point',
                    attributes: startAttributes
                });
                $d671aa981fcb4da6$export$e2b3aff7888f2745._start(startAttributes);
            }
        }
    },
    showComment: {
        debug: $d671aa981fcb4da6$var$getSelectInlineCommentExperienceDebug((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE), 'showComment'),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        },
        start: (startAttributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            $d671aa981fcb4da6$export$e2b3aff7888f2745._start(startAttributes);
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: 'showComment start triggered',
                attributes: startAttributes
            });
        },
        abort: ({ abortReason: abortReason })=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.abort({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                reason: abortReason
            });
            $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
        },
        fail: (error, extraAttributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                error: error,
                attributes: {
                    ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes,
                    ...extraAttributes
                }
            });
            $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
        },
        complete: (completedFrom)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.succeed({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                attributes: {
                    completedFrom: completedFrom,
                    ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                }
            });
            $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
        },
        standaloneSidebarComplete: (commentUIVerticalDistanceFromAnnotation)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: `standaloneSidebarComplete triggered`
            });
            if (commentUIVerticalDistanceFromAnnotation > 40) experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: `Comment UI is misaligned by >40px pixels`,
                attributes: {
                    misalignedBy: commentUIVerticalDistanceFromAnnotation
                }
            });
            if (typeof $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId !== 'string') {
                experienceTracker.fail({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    error: new Error('selectInlineCommentCompoundExperience.standaloneSidebarComplete called when no annotationId was known'),
                    attributes: $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                });
                return;
            }
            if (!$d671aa981fcb4da6$var$__checkAnnotationVisibleAndFocused($d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId)) experienceTracker.fail({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                error: new Error(`selectInlineCommentCompoundExperience.standaloneSidebarComplete ended without a focused and in viewport annotation.`),
                attributes: $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
            });
            experienceTracker.succeed({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                attributes: {
                    completedFrom: 'Standalone sidebar inline comment selection completed',
                    ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                }
            });
        },
        sidePanelComplete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: `sidePanelComplete triggered`
            });
            if (typeof $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId !== 'string') {
                experienceTracker.fail({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    error: new Error('selectInlineCommentCompoundExperience.sidePanelComplete called when no annotationId was known'),
                    attributes: $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                });
                return;
            }
            if (!$d671aa981fcb4da6$var$__checkAnnotationVisibleAndFocused($d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId)) experienceTracker.fail({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                error: new Error('selectInlineCommentCompoundExperience.sidePanelComplete did not result in a visible and focused annotation'),
                attributes: $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
            });
            experienceTracker.succeed({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                attributes: {
                    completedFrom: 'Side Panel inline comment selection completed',
                    ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                }
            });
        }
    }
};
/**
 *
 * Checks if there is an annotation currently visible in the document.
 *
 * The comment UI is currently opinionated about the comment UI being attached to the first instance of the focused annotation element.
 *
 * So we can safely skip checking if the initial focused annotation is not visible
 *
 * Note: this method causes reflow, and should not be used in performance sensitive code.
 *
 */ function $d671aa981fcb4da6$var$__checkAnnotationVisibleAndFocused(annotationId) {
    const experienceTracker = (0, $fGzMp.getExperienceTracker)();
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const possibleFocusedAnnotationElements = document.querySelectorAll(// This will match the annotation id in either the Editor or Renderer
    `[data-id="${annotationId}"][data-mark-annotation-type="inlineComment"][data-has-focus="true"],
		[data-id="${annotationId}"][data-mark-annotation-type="inlineComment"] .ak-editor-annotation-focus`);
    if (possibleFocusedAnnotationElements.length === 0) {
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `No annotation element found`
        });
        return false;
    }
    /**
   * Annotations can have multiple elements in the dom, with each of the elements having the focus state set to true.
   * Ie. Comments spanning multiple lines will have multiple elements with the focus state set to true.
   *
   * In addition to this -- sometimes there will be "hidden" focused annotation elements where the dom is duplicated
   * such as for annotations on table header cells in the renderer.
   *
   * If the first element is not visible due to being hidden, we continue checking until we reach a visible element, and then check whether it is in the viewport.
   *
   */ for(let i = 0; i < possibleFocusedAnnotationElements.length; i++){
        const element = possibleFocusedAnnotationElements[i];
        if (element instanceof HTMLElement) {
            if (!element.checkVisibility()) {
                // Skip to the next element if the current one is not visible
                // This can happen in scenarios where the dom is duplicated, such as for annotations on table header cells in the renderer.
                experienceTracker.attachDebugPoint({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    message: `Annotation element had a hidden focused element, skipping to next element`
                });
                continue;
            }
            const rect = element.getBoundingClientRect();
            const isVisible = rect.top >= 0 && rect.left >= 0 && // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            rect.right <= (window.innerWidth || document.documentElement.clientWidth);
            // This is the first visible element -- which should be focused and
            // in the viewport
            if (isVisible) return true;
            else {
                experienceTracker.attachDebugPoint({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    message: `Annotation element found - but not in viewport`
                });
                return false;
            }
        }
    }
    return false;
}
const $d671aa981fcb4da6$export$b65d55854b7eb069 = {
    debug: $d671aa981fcb4da6$export$e2b3aff7888f2745.debugPoint
};
module.exports["selectInlineCommentCompoundExperience"] = $d671aa981fcb4da6$export$e2b3aff7888f2745;
module.exports["selectInlineComment"] = $d671aa981fcb4da6$export$b65d55854b7eb069;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 45000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_PAGE_COMMENT"] = 30000] = "VIEW_PAGE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("8Ss4E", function(module, exports) {

var $3AVOh = parcelRequire("3AVOh");


var $kyKWe = parcelRequire("kyKWe");


var $c9IWh = parcelRequire("c9IWh");


var $eYg5X = parcelRequire("eYg5X");


var $lTECB = parcelRequire("lTECB");


var $hukUK = parcelRequire("hukUK");


var $c3Qwv = parcelRequire("c3Qwv");


var $1NBp8 = parcelRequire("1NBp8");


var $cEgMD = parcelRequire("cEgMD");


var $irVI7 = parcelRequire("irVI7");


var $gykrH = parcelRequire("gykrH");


var $aJPUt = parcelRequire("aJPUt");


var $fGzMp = parcelRequire("fGzMp");


var $1A7bE = parcelRequire("1A7bE");


var $7v9li = parcelRequire("7v9li");


var $949zl = parcelRequire("949zl");


var $h10mo = parcelRequire("h10mo");

const $8c50530bac3b9ba1$var$noPermissionOrNotFoundExperiences = [
    (0, $irVI7.NOT_FOUND_EXPERIENCE),
    (0, $irVI7.RESTRICTED_PAGE_EXPERIENCE),
    (0, $irVI7.RESTRICTED_SPACE_EXPERIENCE),
    (0, $irVI7.RESTRICTED_SPACE_FOR_GUEST_EXPERIENCE)
];
const $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound = (0, $1A7bE.collectAny)($8c50530bac3b9ba1$var$noPermissionOrNotFoundExperiences);
const $8c50530bac3b9ba1$var$stopOnConnectAddon = (0, $1A7bE.collectAny)([
    (0, $irVI7.CONNECT_ADDON_EXPERIENCE)
]);
/**
 * Stores the new experiences started due to SPA transition
 */ const $8c50530bac3b9ba1$var$namesStartedInPreviousRoute = [];
/**
 *  Specifies routes that signify completion for each experience.
 *  Used with experienceTracker's collect function to monitor progress of experiences.
 *  For example, 'create page' experience is considered complete when it leads to 'edit page'.
 */ const $8c50530bac3b9ba1$var$redirectRoutesForExperiences = {
    [(0, $irVI7.CREATE_PAGE_EXPERIENCE)]: [
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name,
        (0, $1NBp8.VIEW_PAGE).name // CREATE_PAGE_EXPERIENCE -> VIEW_PAGE means a live page was created
    ],
    [(0, $irVI7.CREATE_WHITEBOARD_EXPERIENCE)]: [
        (0, $1NBp8.WHITEBOARD_BOARD).name
    ],
    [(0, $irVI7.CREATE_SLIDE_EXPERIENCE)]: [
        (0, $1NBp8.SLIDES_VIEW).name
    ],
    [(0, $irVI7.CREATE_DATABASE_EXPERIENCE)]: [
        (0, $1NBp8.DATABASE_VIEW).name
    ],
    [(0, $irVI7.CREATE_EMBED_EXPERIENCE)]: [
        (0, $1NBp8.EMBED_VIEW).name
    ]
};
const $8c50530bac3b9ba1$var$EXPERIENCES_TO_ABORT_ON_ROUTE_CHANGE = [
    (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE)
];
const $8c50530bac3b9ba1$export$4b786e0ae0cc0857 = {
    [(0, $1NBp8.SPACE_OVERVIEW).name]: 'space',
    [(0, $1NBp8.COMPANY_HUB).name]: 'space',
    [(0, $1NBp8.EDIT_PAGE_EMBED).name]: 'page',
    [(0, $1NBp8.EDIT_PAGE_V2).name]: 'page',
    [(0, $1NBp8.EDIT_BLOG_V2).name]: 'blog',
    [(0, $1NBp8.VIEW_PAGE).name]: 'page',
    [(0, $1NBp8.VIEW_BLOG).name]: 'blog',
    [(0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name]: 'blog'
};
const $8c50530bac3b9ba1$export$5396770e9da36673 = (routeName)=>{
    switch(routeName){
        case (0, $1NBp8.EDIT_BLOG).name:
        case (0, $1NBp8.EDIT_PAGE).name:
        case (0, $1NBp8.CREATE_PAGE).name:
            return 'TINY';
        default:
            return 'FABRIC';
    }
};
function $8c50530bac3b9ba1$export$cac1117e2433d80e(match, transitionId, sessionData) {
    if (!match) return;
    const tracker = (0, $fGzMp.getExperienceTracker)();
    // Moves current route data to previous route data to ensure `getExperienceTracker.ts getPreviousRouteExperienceData()` works correctly
    (0, $fGzMp.captureRouteChange)(match.name);
    // Live page's edit-page and session experience starts after the route has finished loading and unsubscribed from the tracker, so it's not in the `startExperienceForRoute` function's namesStartedInPreviousRoute array. We will handle finishing it separately in `finishLivePageExperiences`.
    // It's important that `finishLivePageExperiences` is invoked before we attempt to succeed EDIT_PAGE_EXPERIENCE below, as `finishLivePageExperiences` is responsible for succeeding EDIT_PAGE_EXPERIENCE on live pages while setting the experience attribute `isLivePage
    $8c50530bac3b9ba1$var$finishLivePageExperiences();
    $8c50530bac3b9ba1$var$namesStartedInPreviousRoute.forEach((name)=>{
        const allowedRoutes = $8c50530bac3b9ba1$var$redirectRoutesForExperiences[name];
        // For create content routes, we do not want to abort if it is routing to correct page.
        // But, if it is a create experience and routing to a page is is not supposed to be going to,
        // we can assume something is wrong and we abort it.
        if (allowedRoutes && allowedRoutes.includes(match.name)) return;
        if (// If we were on edit-page or view-page/session experience and leave to another route, we should succeed that experience, not abort it.
        name === (0, $irVI7.EDIT_PAGE_EXPERIENCE) && (0, $7v9li.hasHealthyRunningEditPageExperience)() || name === (0, $irVI7.COMPANY_HUB_EDITOR_EXPERIENCE) && (0, $7v9li.hasHealthyRunningCompanyHubEditExperience)() || name === (0, $irVI7.VIEW_PAGE_SESSION_EXPERIENCE) && (0, $949zl.hasHealthyRunningViewPageExperience)()) {
            tracker.succeed({
                name: name
            });
            return;
        }
        // For all other situations, we still abort.
        tracker.abort({
            name: name,
            reason: 'Aborted due to SPA started a new experience'
        });
    });
    $8c50530bac3b9ba1$var$namesStartedInPreviousRoute.length = 0;
    const unsubscribe = tracker.subscribe((e)=>{
        if (e.action === 'taskStart') $8c50530bac3b9ba1$var$namesStartedInPreviousRoute.push(e.name);
    });
    $8c50530bac3b9ba1$var$EXPERIENCES_TO_ABORT_ON_ROUTE_CHANGE.forEach((name)=>{
        $8c50530bac3b9ba1$var$namesStartedInPreviousRoute.push(name);
    });
    switch(match.name){
        case (0, $1NBp8.COMPANY_HUB_EDIT).name:
            $8c50530bac3b9ba1$var$startCompanyHubEditor(transitionId, sessionData);
            break;
        case (0, $1NBp8.EDIT_PAGE_EMBED).name:
        case (0, $1NBp8.EDIT_PAGE_V2).name:
        case (0, $1NBp8.EDIT_BLOG_V2).name:
        case (0, $1NBp8.EDIT_PAGE).name:
        case (0, $1NBp8.EDIT_BLOG).name:
        case (0, $1NBp8.CREATE_PAGE).name:
        case (0, $1NBp8.HUB_EDIT).name:
            $8c50530bac3b9ba1$var$startEditPage(match, transitionId, sessionData);
            break;
        case (0, $1NBp8.VIEW_PAGE).name:
        case (0, $1NBp8.VIEW_BLOG).name:
        case (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name:
            $8c50530bac3b9ba1$var$startViewContent(match.params.contentId, transitionId, $8c50530bac3b9ba1$export$4b786e0ae0cc0857[match.name], match.query, sessionData);
            break;
        case (0, $1NBp8.PAGE_SPLIT).name:
            $8c50530bac3b9ba1$var$startSplitPageLoad(match.params.contentId, transitionId);
            break;
        case (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name:
            $8c50530bac3b9ba1$var$startEditPageSmartCreate(match);
            break;
        case (0, $1NBp8.ADMIN_NEW_GLOBAL_PERMISSIONS).name:
            $8c50530bac3b9ba1$var$startViewPublicLinkGlobalSettings(match.query.tab, match.query.space, transitionId);
            break;
        case (0, $1NBp8.EXTERNAL_SHARE).name:
            $8c50530bac3b9ba1$var$startViewPublicLinkSharedPage(match.params.id, transitionId);
            break;
        case (0, $1NBp8.SPACE_OVERVIEW).name:
            $8c50530bac3b9ba1$var$startViewContent(match.params.spaceKey, transitionId, $8c50530bac3b9ba1$export$4b786e0ae0cc0857[match.name], match.query, sessionData, {
                spaceKey: match.params.spaceKey,
                isLandingPage: match.search === '?mode=global'
            });
            break;
        case (0, $1NBp8.COMPANY_HUB).name:
            const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)(sessionData) || '';
            $8c50530bac3b9ba1$var$startViewContent(spaceKey, transitionId, $8c50530bac3b9ba1$export$4b786e0ae0cc0857[match.name], match.query, sessionData, {
                spaceKey: spaceKey
            });
            break;
        case (0, $1NBp8.HOME).name:
            (0, $h10mo.startHome)();
            break;
        case (0, $1NBp8.EDIT_TEMPLATE_SPACE).name:
        case (0, $1NBp8.EDIT_TEMPLATE).name:
            $8c50530bac3b9ba1$var$startTemplateEditPage(match.params.contentId, transitionId);
            break;
        case (0, $1NBp8.CREATE_TEMPLATE_SPACE).name:
        case (0, $1NBp8.CREATE_TEMPLATE).name:
            $8c50530bac3b9ba1$var$startTemplateEditPage(/* id */ undefined, transitionId);
            break;
        case (0, $1NBp8.ADVANCED_SEARCH).name:
            $8c50530bac3b9ba1$var$startAdvancedSearch(match);
            break;
        case (0, $1NBp8.SPACE_ARCHIVED_PAGES).name:
            $8c50530bac3b9ba1$var$startArchivedPagesList();
            break;
        case (0, $1NBp8.SPACE_BULK_TOOLS).name:
            $8c50530bac3b9ba1$var$startContentManager();
            break;
        case (0, $1NBp8.SPACE_DIRECTORY).name:
            $8c50530bac3b9ba1$var$startSpaceDirectory();
            break;
        case (0, $1NBp8.TEMPLATE_GALLERY).name:
            $8c50530bac3b9ba1$var$startTemplateGallery();
            break;
        case (0, $1NBp8.SPACE_PAGES).name:
            $8c50530bac3b9ba1$var$startSpacePages();
            break;
        case (0, $1NBp8.WHITEBOARD_BOARD).name:
            $8c50530bac3b9ba1$var$startWhiteboardBoard(match);
            break;
        case (0, $1NBp8.SLIDES_VIEW).name:
            $8c50530bac3b9ba1$var$startSlideView(match.params.contentId);
            break;
        case (0, $1NBp8.DATABASE_VIEW).name:
            $8c50530bac3b9ba1$var$startDatabaseView(match.params.contentId);
            break;
        case (0, $1NBp8.EMBED_VIEW).name:
            $8c50530bac3b9ba1$var$startEmbedPageView(match.params.contentId);
            break;
        case (0, $1NBp8.FOLDER_VIEW).name:
            $8c50530bac3b9ba1$var$startFolderView(match.params.contentId);
            break;
        case (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).name:
            //Adding the other space perms uplift tabs at a later date.
            if (match.params.tab === 'public-links') $8c50530bac3b9ba1$var$startViewPublicLinksSpaceSettings();
            break;
        case (0, $1NBp8.ADMIN_ANNOUNCEMENT_BANNER_RENDERER).name:
            $8c50530bac3b9ba1$var$startViewAdminAnnouncementBannerSettings();
            break;
        case (0, $1NBp8.SPACE_MANAGER).name:
            $8c50530bac3b9ba1$var$startSpaceManager();
            break;
        case (0, $1NBp8.ADMIN_COMPANY_HOME_BUILDER).name:
        case (0, $1NBp8.ADMIN_CUSTOMIZE_NAVIGATION).name:
            $8c50530bac3b9ba1$var$startCompanyHomeBuilderLoad();
            break;
    }
    const startCreateOperations = ()=>{
        const subType = typeof match?.query?.subType === 'string' ? match.query.subType : null;
        if (match.name === (0, $1NBp8.CREATE_CONTENT).name) $8c50530bac3b9ba1$var$startCreateContent(match, sessionData, subType);
        else if (match.query.createDialog) {
            $8c50530bac3b9ba1$var$startCreatePage(String(transitionId), transitionId, subType);
            (0, $7v9li.startCreateAndEditPage)();
        }
    };
    startCreateOperations();
    unsubscribe();
}
function $8c50530bac3b9ba1$var$startSplitPageLoad(contentId, transitionId) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPLIT_PAGE_LOAD_EXPERIENCE),
        id: contentId,
        startTime: transitionId === 0 ? 0 : undefined
    });
}
function $8c50530bac3b9ba1$var$startCreatePage(id, transitionId, subType) {
    const experienceTracker = (0, $fGzMp.getExperienceTracker)();
    experienceTracker.start({
        name: (0, $irVI7.CREATE_PAGE_EXPERIENCE),
        id: id,
        attributes: {
            isLivePage: subType?.toLowerCase() === 'live'
        },
        startTime: transitionId === 0 ? 0 : undefined,
        collect (events, experience) {
            experience.stopOn(events.find((event)=>event.action === 'taskFail' && (0, $gykrH.hasName)(event, (0, $irVI7.CREATE_PAGE_LOAD_DIALOG_EXPERIENCE), (0, $irVI7.CREATE_PAGE_TEMPLATE_VARIABLES_EXPERIENCE))));
            experience.stopOn(events.find((event)=>event.action === 'taskSuccess' && (0, $gykrH.hasName)(event, (0, $irVI7.CREATE_PAGE_TEMPLATE_VARIABLES_EXPERIENCE))));
            experience.stopOn(events.find((event)=>event.action === 'taskAbort' && (0, $gykrH.hasName)(event, (0, $irVI7.CREATE_PAGE_TEMPLATE_VARIABLES_EXPERIENCE))));
        }
    });
    experienceTracker.start({
        name: (0, $irVI7.CREATE_PAGE_LOAD_DIALOG_EXPERIENCE),
        id: id,
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_DIALOG_LOAD
    });
}
function $8c50530bac3b9ba1$export$b9a409823a06b924(experienceName) {
    const activeTrace = (0, $c9IWh.getActiveTrace)();
    if (!activeTrace) (0, $eYg5X.default)(experienceName.replace(/\//g, '-'));
}
function $8c50530bac3b9ba1$export$478e84e2cc5ff22d(compoundExperience, editorLoadExperience, editorPublishExperience) {
    const experienceTracker = (0, $fGzMp.getExperienceTracker)();
    const compoundTaskId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
    const compoundExperienceAttributes = {
        ...compoundExperience.attributes,
        compoundTaskId: compoundTaskId
    };
    experienceTracker.start({
        ...compoundExperience,
        id: compoundTaskId,
        attributes: compoundExperienceAttributes,
        collect: (events, experience)=>{
            experience.stopOn(events.find(({ action: action, name: name })=>action === 'taskFail' && name === editorLoadExperience.name));
            experience.stopOn(events.find(({ action: action, name: name })=>(action === 'taskSuccess' || action === 'taskFail') && name === editorPublishExperience.name));
            if (compoundExperience.collect) compoundExperience.collect(events, experience);
        }
    });
    experienceTracker.start({
        ...editorLoadExperience,
        id: editorLoadExperience.id || compoundExperience.id,
        timeout: editorLoadExperience.timeout || (0, $aJPUt.ExperienceTimeout).EDITOR_LOAD,
        attributes: compoundExperienceAttributes,
        collect: editorLoadExperience.collect
    });
}
function $8c50530bac3b9ba1$export$7df6656d8508e8da(subExperience) {
    const experienceTracker = (0, $fGzMp.getExperienceTracker)();
    // Initialize attributes from the original subExperience
    const attributes = {
        ...subExperience.attributes
    };
    // Extract the compound experience name from the sub-experience name if it follows
    // the naming convention "<compound_experience_name>/<sub_experience>"
    const subExperienceName = subExperience.name;
    const nameParts = subExperienceName.split('/');
    // Only attempt to get compound experience if the name includes a separator
    if (nameParts.length > 1) {
        const compoundExperienceName = nameParts[0];
        const compoundExperienceState = experienceTracker.getExperienceState(compoundExperienceName);
        // If compound experience exists, inherit its compoundTaskId
        if (compoundExperienceState) // Link the compound experience's compoundTaskId if available
        {
            if (compoundExperienceState.attributes?.compoundTaskId) attributes.compoundTaskId = compoundExperienceState.attributes.compoundTaskId;
        }
    }
    // Start the sub-experience with the attributes (original or enhanced with compoundTaskId)
    experienceTracker.start({
        ...subExperience,
        attributes: attributes
    });
}
const $8c50530bac3b9ba1$var$stopOnCloseForEditPage = (events, experience, loadExperienceName, closeExperienceName)=>{
    const loadStopExperience = events.find((event)=>event.name === loadExperienceName && (0, $gykrH.isStop)(event));
    const closeStopExperience = events.find((event)=>event.name === closeExperienceName && (0, $gykrH.isStop)(event));
    if (!closeStopExperience) return;
    // prettier-ignore
    if ((!loadStopExperience || loadStopExperience.action !== "taskSuccess") && closeStopExperience.action === "taskSuccess") // loading incomplete or failed, therefore editing session was broken and close doesn't indicate a success
    experience.abort({
        reason: "Editor closed before load completed",
        attributes: {
            loadExperienceState: loadStopExperience?.action ?? "incomplete"
        }
    });
    else experience.stopOn(closeStopExperience);
};
function $8c50530bac3b9ba1$var$startEditPageSmartCreate(match) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.EDIT_PAGE_SMART_CREATE_LOAD_EXPERIENCE),
        id: match.params.contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT,
        collect: (events, experience)=>{
            const hasNoPermissionOrNotFoundEvent = events.find((event)=>(0, $gykrH.isStop)(event) && (0, $gykrH.hasName)(event, ...$8c50530bac3b9ba1$var$noPermissionOrNotFoundExperiences));
            if (hasNoPermissionOrNotFoundEvent) experience.fail({
                error: new Error(`${hasNoPermissionOrNotFoundEvent.name} experience resulted in ${hasNoPermissionOrNotFoundEvent.action} - unexpected for the smart create editor`)
            });
        }
    });
}
function $8c50530bac3b9ba1$var$startEditPage(match, transitionId, sessionData) {
    const isLegacyEditor = $8c50530bac3b9ba1$export$5396770e9da36673(match?.name ?? '') === 'TINY';
    let editPageExperienceName = (0, $irVI7.EDIT_PAGE_EXPERIENCE);
    if (match.name === (0, $1NBp8.EDIT_PAGE_EMBED).name) editPageExperienceName = (0, $irVI7.EDIT_PAGE_EMBED_EXPERIENCE);
    else if (isLegacyEditor) editPageExperienceName = (0, $irVI7.EDIT_LEGACY_PAGE_EXPERIENCE);
    $8c50530bac3b9ba1$export$478e84e2cc5ff22d(/* compoundExperience */ {
        name: editPageExperienceName,
        id: match.params.contentId,
        startTime: transitionId === 0 ? 0 : undefined,
        attributes: {
            editor: $8c50530bac3b9ba1$export$5396770e9da36673(match.name),
            contentType: $8c50530bac3b9ba1$export$4b786e0ae0cc0857[match.name],
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            isCompanyHub: match?.name === (0, $1NBp8.COMPANY_HUB_EDIT).name || match?.name === (0, $1NBp8.HUB_EDIT).name,
            contentId: match.params.contentId
        },
        // override with full-page-editor specific stop/collect behaviour
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
            const loadExperienceName = isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_LOAD_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE);
            const closeExperienceName = isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_CLOSE_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_CLOSE_EXPERIENCE);
            $8c50530bac3b9ba1$var$stopOnCloseForEditPage(events, experience, loadExperienceName, closeExperienceName);
        }
    }, /* editorLoadExperience */ {
        name: isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_LOAD_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE),
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
            const closeExperienceName = isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_CLOSE_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_CLOSE_EXPERIENCE);
            const closeExperience = events.find((event)=>(0, $gykrH.isStop)(event) && event.name === closeExperienceName);
            if (closeExperience) experience.abort({
                reason: 'Editor closed before load completed',
                attributes: {
                    closeExperienceState: closeExperience?.action ?? 'incomplete'
                }
            });
        }
    }, /* editorPublishExperience */ {
        name: isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_PUBLISH_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_PUBLISH_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startCompanyHubEditor(transitionId, sessionData) {
    $8c50530bac3b9ba1$export$478e84e2cc5ff22d(/* compoundExperience */ {
        name: (0, $irVI7.COMPANY_HUB_EDITOR_EXPERIENCE),
        startTime: transitionId === 0 ? 0 : undefined,
        attributes: {
            editor: 'FABRIC',
            contentType: 'space',
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            isCompanyHub: true
        },
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
            $8c50530bac3b9ba1$var$stopOnCloseForEditPage(events, experience, (0, $irVI7.COMPANY_HUB_EDITOR_LOAD_EXPERIENCE), (0, $irVI7.COMPANY_HUB_EDITOR_CLOSE_EXPERIENCE));
        }
    }, /* editorLoadExperience */ {
        name: (0, $irVI7.COMPANY_HUB_EDITOR_LOAD_EXPERIENCE),
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
        }
    }, /* editorPublishExperience */ {
        name: (0, $irVI7.FRONT_COVER_PUBLISH_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startViewContent(id, transitionId, contentType, query, sessionData, attributes) {
    // WS-3261 - We need to track if the view is coming from an external source (email notification, Slack, etc.)
    const isFromExternal = Boolean(query && query.atlOrigin);
    // Track APDEX part of the content (title and content itself)
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.VIEW_CONTENT_EXPERIENCE),
        id: id,
        startTime: transitionId === 0 ? 0 : undefined,
        timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD,
        attributes: {
            contentType: contentType,
            isFromExternal: isFromExternal,
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            ...attributes
        },
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
            $8c50530bac3b9ba1$var$stopOnConnectAddon(events, experience);
        }
    });
}
function $8c50530bac3b9ba1$var$startViewPublicLinkGlobalSettings(tab, space, transitionId) {
    if (tab === 'public-links' && !space) (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.VIEW_PUBLIC_LINK_SITE_SETTINGS_EXPERIENCE),
        id: 'public-links',
        startTime: transitionId === 0 ? 0 : undefined,
        timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD
    });
}
function $8c50530bac3b9ba1$var$startViewPublicLinksSpaceSettings() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.VIEW_PUBLIC_LINKS_SPACE_SETTINGS_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD
    });
}
function $8c50530bac3b9ba1$var$startViewPublicLinkSharedPage(id, transitionId) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.VIEW_PUBLIC_LINK_SHARED_PAGE_EXPERIENCE),
        id: id,
        startTime: transitionId === 0 ? 0 : undefined,
        timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD
    });
}
function $8c50530bac3b9ba1$var$startTemplateEditPage(id, transitionId) {
    $8c50530bac3b9ba1$export$478e84e2cc5ff22d(/* compoundExperience */ {
        name: (0, $irVI7.TEMPLATE_EDIT_PAGE_EXPERIENCE),
        id: id,
        startTime: transitionId === 0 ? 0 : undefined,
        collect: (events, experience)=>{
            experience.stopOn(events.find((event)=>(0, $gykrH.isStop)(event) && event.name === (0, $irVI7.TEMPLATE_EDIT_PAGE_CLOSE_EXPERIENCE)));
        }
    }, /* editorLoadExperience */ {
        name: (0, $irVI7.TEMPLATE_EDIT_PAGE_LOAD_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).TEMPLATE_EDITOR_LOAD
    }, /* editorPublishExperience */ {
        name: (0, $irVI7.TEMPLATE_EDIT_PAGE_PUBLISH_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startAdvancedSearch(match) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE),
        id: (0, $hukUK.objectHash)((0, (/*@__PURE__*/$parcel$interopDefault($3AVOh)))(match.query, [
            'search_id'
        ]))
    });
}
function $8c50530bac3b9ba1$var$startArchivedPagesList() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPACE_ARCHIVED_PAGES_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startContentManager() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CONTENT_MANAGER_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startSpaceDirectory() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPACE_DIRECTORY_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).SPACE_DIRECTORY
    });
}
function $8c50530bac3b9ba1$var$startTemplateGallery() {
    const TemplateGallerySubExperiences = [
        (0, $irVI7.TEMPLATE_GALLERY_CATEGORIES_EXPERIENCE),
        (0, $irVI7.TEMPLATE_GALLERY_SPACE_SELECTOR_EXPERIENCE),
        (0, $irVI7.TEMPLATE_GALLERY_CARDS_EXPERIENCE),
        (0, $irVI7.TEMPLATE_GALLERY_TEMPLATE_DETAIL_EXPERIENCE)
    ];
    const collectTemplateGalleryLoadExperiences = (events, experience)=>{
        (0, $1A7bE.collectAll)(TemplateGallerySubExperiences)(events, experience);
    };
    const stopOnRestrictedPage = (0, $1A7bE.collectAll)([
        (0, $irVI7.RESTRICTED_PAGE_EXPERIENCE)
    ]);
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.TEMPLATE_GALLERY_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT,
        collect: (events, experience)=>{
            collectTemplateGalleryLoadExperiences(events, experience);
            stopOnRestrictedPage(events, experience);
        }
    });
}
function $8c50530bac3b9ba1$var$startSpacePages() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPACE_PAGES_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startCreateContent(match, sessionData, subType) {
    const queryParams = match.query;
    const isPersonalSpace = queryParams.spaceKey?.[0] !== undefined ? (queryParams.spaceKey[0] === '~').toString() : 'unknown';
    const flow = (0, $c3Qwv.getSingleParam)(queryParams, 'source') || 'createContentRoute';
    if (match.params.contentType === 'whiteboard') (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_WHITEBOARD_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const whiteboardExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $irVI7.WHITEBOARD_EXPERIENCE));
            if (whiteboardExperienceStart) experience.succeed();
        }
    });
    else if (match.params.contentType === 'slide') (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_SLIDE_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const slideExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $irVI7.SLIDE_EXPERIENCE));
            if (slideExperienceStart) experience.succeed();
        }
    });
    else if (match.params.contentType === 'database') (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_DATABASE_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const databaseExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $irVI7.DATABASE_EXPERIENCE));
            if (databaseExperienceStart) experience.succeed();
        }
    });
    else if (match.params.contentType === 'smartLinkEmbed') (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_EMBED_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const smartLinkEmbedExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $irVI7.EMBED_EXPERIENCE));
            if (smartLinkEmbedExperienceStart) experience.succeed();
        }
    });
    else if ([
        'page',
        'blog'
    ].includes(match.params.contentType)) (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_PAGE_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
        attributes: {
            contentType: match.params.contentType,
            flow: flow,
            isCreateContentRoute: true,
            isPersonalSpace: isPersonalSpace,
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            isLivePage: subType?.toLowerCase() === 'live'
        },
        collect: (events, experience)=>{
            const editPageStarted = events.find((event)=>event.action === 'taskStart' && (event.name === (0, $irVI7.EDIT_PAGE_EXPERIENCE) || event.name === (0, $irVI7.EDIT_LEGACY_PAGE_EXPERIENCE)));
            if (editPageStarted) experience.succeed();
        }
    });
}
function $8c50530bac3b9ba1$var$startWhiteboardBoard(match) {
    const embeddedWhiteboardSubExperiences = [
        (0, $irVI7.WHITEBOARD_CONTENT_EXPERIENCE)
    ];
    const subExperiences = [
        (0, $irVI7.WHITEBOARD_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE)
    ];
    const isEmbedded = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    const contentId = match.params.contentId;
    $8c50530bac3b9ba1$var$startSubExperiencesForMainExperience(contentId, (0, $irVI7.WHITEBOARD_EXPERIENCE), isEmbedded ? embeddedWhiteboardSubExperiences : subExperiences);
}
function $8c50530bac3b9ba1$var$startSlideView(contentId) {
    const subExperiences = [
        (0, $irVI7.SLIDE_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE)
    ];
    const embeddedSlideSubExperiences = [
        (0, $irVI7.SLIDE_CONTENT_EXPERIENCE)
    ];
    const isEmbedded = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    $8c50530bac3b9ba1$var$startSubExperiencesForMainExperience(contentId, (0, $irVI7.SLIDE_EXPERIENCE), isEmbedded ? embeddedSlideSubExperiences : subExperiences);
}
function $8c50530bac3b9ba1$var$startDatabaseView(contentId) {
    const subExperiences = [
        (0, $irVI7.DATABASE_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE)
    ];
    const embeddedDatabaseSubExperiences = [
        (0, $irVI7.DATABASE_CONTENT_EXPERIENCE)
    ];
    const isEmbedded = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    $8c50530bac3b9ba1$var$startSubExperiencesForMainExperience(contentId, (0, $irVI7.DATABASE_EXPERIENCE), isEmbedded ? embeddedDatabaseSubExperiences : subExperiences);
}
function $8c50530bac3b9ba1$var$startSubExperiencesForMainExperience(contentId, mainExperience, subExperiences) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: mainExperience,
        collect: (events, experience)=>{
            (0, $1A7bE.collectAll)(subExperiences)(events, experience);
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
        },
        id: contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
    subExperiences.forEach((name)=>{
        (0, $fGzMp.getExperienceTracker)().start({
            name: name,
            id: contentId
        });
    });
}
function $8c50530bac3b9ba1$var$startEmbedPageView(contentId) {
    const embedPageSubExperiences = [
        (0, $irVI7.EMBED_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE),
        (0, $irVI7.VIEW_PAGE_FAVORITE_BUTTON_EXPERIENCE)
    ];
    const subExperiences = [
        (0, $irVI7.EMBED_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE)
    ];
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.EMBED_EXPERIENCE),
        collect: (events, experience)=>{
            (0, $1A7bE.collectAll)(subExperiences)(events, experience);
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
        },
        id: contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
    embedPageSubExperiences.forEach((name)=>{
        (0, $fGzMp.getExperienceTracker)().start({
            name: name,
            id: contentId
        });
    });
}
function $8c50530bac3b9ba1$var$startFolderView(contentId) {
    const folderSubExperiences = [
        (0, $irVI7.FOLDER_CONTENT_EXPERIENCE)
    ];
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.FOLDER_EXPERIENCE),
        collect: (events, experience)=>{
            (0, $1A7bE.collectAll)(folderSubExperiences)(events, experience);
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
        },
        id: contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
    folderSubExperiences.forEach((name)=>{
        (0, $fGzMp.getExperienceTracker)().start({
            name: name,
            id: contentId
        });
    });
}
function $8c50530bac3b9ba1$var$startViewAdminAnnouncementBannerSettings() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.ADMIN_ANNOUNCEMENT_BANNER_SETTINGS_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
}
function $8c50530bac3b9ba1$var$startSpaceManager() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPACE_MANAGER_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
}
function $8c50530bac3b9ba1$var$startCompanyHomeBuilderLoad() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.COMPANY_HOME_BUILDER_LOAD_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
}
function $8c50530bac3b9ba1$var$finishLivePageExperiences() {
    const tracker = (0, $fGzMp.getExperienceTracker)();
    const livePageExperiencesToSucceed = [
        (0, $irVI7.EDIT_PAGE_EXPERIENCE),
        (0, $irVI7.LIVE_PAGE_SESSION_EXPERIENCE)
    ];
    livePageExperiencesToSucceed.forEach((experience)=>{
        const experienceState = tracker.getExperienceState(experience);
        // We want to identify if it's actively running, and if so, succeed it. This aligns with how we succeed non-live-page experiences on transition.
        // We validate the `isLivePage` attribute is `true` before succeeding, to avoid undesirably succeeding edit-page here when it's not a live page
        if (experienceState && !experienceState?.hasStopped && experienceState?.attributes?.isLivePage) tracker.succeed({
            name: experience
        });
    });
}
module.exports["routeNameToContentTypeMap"] = $8c50530bac3b9ba1$export$4b786e0ae0cc0857;
module.exports["startExperienceForRoute"] = $8c50530bac3b9ba1$export$cac1117e2433d80e;
module.exports["startUFOPressTrace"] = $8c50530bac3b9ba1$export$b9a409823a06b924;
module.exports["startEditorExperiences"] = $8c50530bac3b9ba1$export$478e84e2cc5ff22d;
module.exports["startEditorSubExperience"] = $8c50530bac3b9ba1$export$7df6656d8508e8da;

});

parcelRegister("3AVOh", function(module, exports) {

var $79D42 = parcelRequire("79D42");


var $hGc5T = parcelRequire("hGc5T");


var $hcV0q = parcelRequire("hcV0q");


var $aI4Cx = parcelRequire("aI4Cx");


var $bk5x8 = parcelRequire("bk5x8");


var $ezTcL = parcelRequire("ezTcL");


var $jPzTX = parcelRequire("jPzTX");


var $14dnq = parcelRequire("14dnq");

/** Used to compose bitmasks for cloning. */ var $29e193b87644e449$var$CLONE_DEEP_FLAG = 1, $29e193b87644e449$var$CLONE_FLAT_FLAG = 2, $29e193b87644e449$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $29e193b87644e449$var$omit = $jPzTX(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $79D42(paths, function(path) {
        path = $aI4Cx(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $bk5x8(object, $14dnq(object), result);
    if (isDeep) result = $hGc5T(result, $29e193b87644e449$var$CLONE_DEEP_FLAG | $29e193b87644e449$var$CLONE_FLAT_FLAG | $29e193b87644e449$var$CLONE_SYMBOLS_FLAG, $ezTcL);
    var length = paths.length;
    while(length--)$hcV0q(result, paths[length]);
    return result;
});
module.exports = $29e193b87644e449$var$omit;

});

parcelRegister("hGc5T", function(module, exports) {

var $1tgXD = parcelRequire("1tgXD");


var $7aPLP = parcelRequire("7aPLP");


var $aDCaS = parcelRequire("aDCaS");


var $e8WyO = parcelRequire("e8WyO");


var $lunGb = parcelRequire("lunGb");


var $19mn0 = parcelRequire("19mn0");


var $7WBxT = parcelRequire("7WBxT");


var $gwj3d = parcelRequire("gwj3d");


var $j60dZ = parcelRequire("j60dZ");


var $cTBpe = parcelRequire("cTBpe");


var $14dnq = parcelRequire("14dnq");


var $jOCrv = parcelRequire("jOCrv");


var $kGJE1 = parcelRequire("kGJE1");


var $cZmfO = parcelRequire("cZmfO");


var $jFqhM = parcelRequire("jFqhM");


var $1ScXu = parcelRequire("1ScXu");


var $6DVFM = parcelRequire("6DVFM");


var $aBDCC = parcelRequire("aBDCC");


var $izVFW = parcelRequire("izVFW");


var $1ji1e = parcelRequire("1ji1e");


var $f14Rr = parcelRequire("f14Rr");


var $dNyAN = parcelRequire("dNyAN");

/** Used to compose bitmasks for cloning. */ var $cdefbd8efe913551$var$CLONE_DEEP_FLAG = 1, $cdefbd8efe913551$var$CLONE_FLAT_FLAG = 2, $cdefbd8efe913551$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $cdefbd8efe913551$var$argsTag = '[object Arguments]', $cdefbd8efe913551$var$arrayTag = '[object Array]', $cdefbd8efe913551$var$boolTag = '[object Boolean]', $cdefbd8efe913551$var$dateTag = '[object Date]', $cdefbd8efe913551$var$errorTag = '[object Error]', $cdefbd8efe913551$var$funcTag = '[object Function]', $cdefbd8efe913551$var$genTag = '[object GeneratorFunction]', $cdefbd8efe913551$var$mapTag = '[object Map]', $cdefbd8efe913551$var$numberTag = '[object Number]', $cdefbd8efe913551$var$objectTag = '[object Object]', $cdefbd8efe913551$var$regexpTag = '[object RegExp]', $cdefbd8efe913551$var$setTag = '[object Set]', $cdefbd8efe913551$var$stringTag = '[object String]', $cdefbd8efe913551$var$symbolTag = '[object Symbol]', $cdefbd8efe913551$var$weakMapTag = '[object WeakMap]';
var $cdefbd8efe913551$var$arrayBufferTag = '[object ArrayBuffer]', $cdefbd8efe913551$var$dataViewTag = '[object DataView]', $cdefbd8efe913551$var$float32Tag = '[object Float32Array]', $cdefbd8efe913551$var$float64Tag = '[object Float64Array]', $cdefbd8efe913551$var$int8Tag = '[object Int8Array]', $cdefbd8efe913551$var$int16Tag = '[object Int16Array]', $cdefbd8efe913551$var$int32Tag = '[object Int32Array]', $cdefbd8efe913551$var$uint8Tag = '[object Uint8Array]', $cdefbd8efe913551$var$uint8ClampedTag = '[object Uint8ClampedArray]', $cdefbd8efe913551$var$uint16Tag = '[object Uint16Array]', $cdefbd8efe913551$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $cdefbd8efe913551$var$cloneableTags = {};
$cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$argsTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$arrayTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$arrayBufferTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$dataViewTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$boolTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$dateTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$float32Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$float64Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$int8Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$int16Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$int32Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$mapTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$numberTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$objectTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$regexpTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$setTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$stringTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$symbolTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$uint8Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$uint8ClampedTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$uint16Tag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$uint32Tag] = true;
$cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$errorTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$funcTag] = $cdefbd8efe913551$var$cloneableTags[$cdefbd8efe913551$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $cdefbd8efe913551$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $cdefbd8efe913551$var$CLONE_DEEP_FLAG, isFlat = bitmask & $cdefbd8efe913551$var$CLONE_FLAT_FLAG, isFull = bitmask & $cdefbd8efe913551$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$izVFW(value)) return value;
    var isArr = $1ScXu(value);
    if (isArr) {
        result = $kGJE1(value);
        if (!isDeep) return $7WBxT(value, result);
    } else {
        var tag = $jOCrv(value), isFunc = tag == $cdefbd8efe913551$var$funcTag || tag == $cdefbd8efe913551$var$genTag;
        if ($6DVFM(value)) return $19mn0(value, isDeep);
        if (tag == $cdefbd8efe913551$var$objectTag || tag == $cdefbd8efe913551$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $jFqhM(value);
            if (!isDeep) return isFlat ? $j60dZ(value, $lunGb(result, value)) : $gwj3d(value, $e8WyO(result, value));
        } else {
            if (!$cdefbd8efe913551$var$cloneableTags[tag]) return object ? value : {};
            result = $cZmfO(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $1tgXD);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($1ji1e(value)) value.forEach(function(subValue) {
        result.add($cdefbd8efe913551$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($aBDCC(value)) value.forEach(function(subValue, key) {
        result.set(key, $cdefbd8efe913551$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $14dnq : $cTBpe : isFlat ? $dNyAN : $f14Rr;
    var props = isArr ? undefined : keysFunc(value);
    $7aPLP(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $aDCaS(result, key, $cdefbd8efe913551$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $cdefbd8efe913551$var$baseClone;

});

parcelRegister("7aPLP", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $5391a0175a1872c4$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $5391a0175a1872c4$var$arrayEach;

});

parcelRegister("e8WyO", function(module, exports) {

var $bk5x8 = parcelRequire("bk5x8");


var $f14Rr = parcelRequire("f14Rr");

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $a4bf3cec5f860948$var$baseAssign(object, source) {
    return object && $bk5x8(source, $f14Rr(source), object);
}
module.exports = $a4bf3cec5f860948$var$baseAssign;

});

parcelRegister("lunGb", function(module, exports) {

var $bk5x8 = parcelRequire("bk5x8");


var $dNyAN = parcelRequire("dNyAN");

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $fa4ec48e79e3b749$var$baseAssignIn(object, source) {
    return object && $bk5x8(source, $dNyAN(source), object);
}
module.exports = $fa4ec48e79e3b749$var$baseAssignIn;

});

parcelRegister("gwj3d", function(module, exports) {

var $bk5x8 = parcelRequire("bk5x8");


var $j1qF4 = parcelRequire("j1qF4");

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $c06e699caf978d13$var$copySymbols(source, object) {
    return $bk5x8(source, $j1qF4(source), object);
}
module.exports = $c06e699caf978d13$var$copySymbols;

});

parcelRegister("j60dZ", function(module, exports) {

var $bk5x8 = parcelRequire("bk5x8");


var $ahKsp = parcelRequire("ahKsp");

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $de6ec073df6f66ec$var$copySymbolsIn(source, object) {
    return $bk5x8(source, $ahKsp(source), object);
}
module.exports = $de6ec073df6f66ec$var$copySymbolsIn;

});

parcelRegister("kGJE1", function(module, exports) {
/** Used for built-in method references. */ var $f0fb22f60689ed3d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f0fb22f60689ed3d$var$hasOwnProperty = $f0fb22f60689ed3d$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $f0fb22f60689ed3d$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $f0fb22f60689ed3d$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $f0fb22f60689ed3d$var$initCloneArray;

});

parcelRegister("cZmfO", function(module, exports) {

var $bAYSF = parcelRequire("bAYSF");


var $2nf4s = parcelRequire("2nf4s");


var $aOXy4 = parcelRequire("aOXy4");


var $cPFvk = parcelRequire("cPFvk");


var $39R3S = parcelRequire("39R3S");

/** `Object#toString` result references. */ var $974c71bfd764326f$var$boolTag = '[object Boolean]', $974c71bfd764326f$var$dateTag = '[object Date]', $974c71bfd764326f$var$mapTag = '[object Map]', $974c71bfd764326f$var$numberTag = '[object Number]', $974c71bfd764326f$var$regexpTag = '[object RegExp]', $974c71bfd764326f$var$setTag = '[object Set]', $974c71bfd764326f$var$stringTag = '[object String]', $974c71bfd764326f$var$symbolTag = '[object Symbol]';
var $974c71bfd764326f$var$arrayBufferTag = '[object ArrayBuffer]', $974c71bfd764326f$var$dataViewTag = '[object DataView]', $974c71bfd764326f$var$float32Tag = '[object Float32Array]', $974c71bfd764326f$var$float64Tag = '[object Float64Array]', $974c71bfd764326f$var$int8Tag = '[object Int8Array]', $974c71bfd764326f$var$int16Tag = '[object Int16Array]', $974c71bfd764326f$var$int32Tag = '[object Int32Array]', $974c71bfd764326f$var$uint8Tag = '[object Uint8Array]', $974c71bfd764326f$var$uint8ClampedTag = '[object Uint8ClampedArray]', $974c71bfd764326f$var$uint16Tag = '[object Uint16Array]', $974c71bfd764326f$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $974c71bfd764326f$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $974c71bfd764326f$var$arrayBufferTag:
            return $bAYSF(object);
        case $974c71bfd764326f$var$boolTag:
        case $974c71bfd764326f$var$dateTag:
            return new Ctor(+object);
        case $974c71bfd764326f$var$dataViewTag:
            return $2nf4s(object, isDeep);
        case $974c71bfd764326f$var$float32Tag:
        case $974c71bfd764326f$var$float64Tag:
        case $974c71bfd764326f$var$int8Tag:
        case $974c71bfd764326f$var$int16Tag:
        case $974c71bfd764326f$var$int32Tag:
        case $974c71bfd764326f$var$uint8Tag:
        case $974c71bfd764326f$var$uint8ClampedTag:
        case $974c71bfd764326f$var$uint16Tag:
        case $974c71bfd764326f$var$uint32Tag:
            return $39R3S(object, isDeep);
        case $974c71bfd764326f$var$mapTag:
            return new Ctor;
        case $974c71bfd764326f$var$numberTag:
        case $974c71bfd764326f$var$stringTag:
            return new Ctor(object);
        case $974c71bfd764326f$var$regexpTag:
            return $aOXy4(object);
        case $974c71bfd764326f$var$setTag:
            return new Ctor;
        case $974c71bfd764326f$var$symbolTag:
            return $cPFvk(object);
    }
}
module.exports = $974c71bfd764326f$var$initCloneByTag;

});

parcelRegister("2nf4s", function(module, exports) {

var $bAYSF = parcelRequire("bAYSF");

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $1ba96b89566301a8$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $bAYSF(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $1ba96b89566301a8$var$cloneDataView;

});

parcelRegister("aOXy4", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $7e0cc3fe33183417$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $7e0cc3fe33183417$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $7e0cc3fe33183417$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $7e0cc3fe33183417$var$cloneRegExp;

});

parcelRegister("cPFvk", function(module, exports) {

var $2v1OR = parcelRequire("2v1OR");

/** Used to convert symbols to primitives and strings. */ var $957a7155a4d05ec8$var$symbolProto = $2v1OR ? $2v1OR.prototype : undefined, $957a7155a4d05ec8$var$symbolValueOf = $957a7155a4d05ec8$var$symbolProto ? $957a7155a4d05ec8$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $957a7155a4d05ec8$var$cloneSymbol(symbol) {
    return $957a7155a4d05ec8$var$symbolValueOf ? Object($957a7155a4d05ec8$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $957a7155a4d05ec8$var$cloneSymbol;

});

parcelRegister("aBDCC", function(module, exports) {

var $aPSWx = parcelRequire("aPSWx");


var $gGzL7 = parcelRequire("gGzL7");


var $izBVL = parcelRequire("izBVL");

/* Node.js helper references. */ var $7b8c182c149a3e72$var$nodeIsMap = $izBVL && $izBVL.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $7b8c182c149a3e72$var$isMap = $7b8c182c149a3e72$var$nodeIsMap ? $gGzL7($7b8c182c149a3e72$var$nodeIsMap) : $aPSWx;
module.exports = $7b8c182c149a3e72$var$isMap;

});

parcelRegister("aPSWx", function(module, exports) {

var $jOCrv = parcelRequire("jOCrv");


var $7WFUU = parcelRequire("7WFUU");

/** `Object#toString` result references. */ var $7e3949613e91b78e$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $7e3949613e91b78e$var$baseIsMap(value) {
    return $7WFUU(value) && $jOCrv(value) == $7e3949613e91b78e$var$mapTag;
}
module.exports = $7e3949613e91b78e$var$baseIsMap;

});

parcelRegister("1ji1e", function(module, exports) {

var $l6Y5L = parcelRequire("l6Y5L");


var $gGzL7 = parcelRequire("gGzL7");


var $izBVL = parcelRequire("izBVL");

/* Node.js helper references. */ var $0f458af8916b54b7$var$nodeIsSet = $izBVL && $izBVL.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $0f458af8916b54b7$var$isSet = $0f458af8916b54b7$var$nodeIsSet ? $gGzL7($0f458af8916b54b7$var$nodeIsSet) : $l6Y5L;
module.exports = $0f458af8916b54b7$var$isSet;

});

parcelRegister("l6Y5L", function(module, exports) {

var $jOCrv = parcelRequire("jOCrv");


var $7WFUU = parcelRequire("7WFUU");

/** `Object#toString` result references. */ var $f5e8c58b63155910$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $f5e8c58b63155910$var$baseIsSet(value) {
    return $7WFUU(value) && $jOCrv(value) == $f5e8c58b63155910$var$setTag;
}
module.exports = $f5e8c58b63155910$var$baseIsSet;

});

parcelRegister("hcV0q", function(module, exports) {

var $aI4Cx = parcelRequire("aI4Cx");


var $gO1os = parcelRequire("gO1os");


var $3ye78 = parcelRequire("3ye78");


var $4yN45 = parcelRequire("4yN45");

/** Used for built-in method references. */ var $c86fc6d9079351ab$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c86fc6d9079351ab$var$hasOwnProperty = $c86fc6d9079351ab$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $c86fc6d9079351ab$var$baseUnset(object, path) {
    path = $aI4Cx(path, object);
    // Prevent prototype pollution:
    // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
    // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
    var index = -1, length = path.length;
    if (!length) return true;
    while(++index < length){
        var key = $4yN45(path[index]);
        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !$c86fc6d9079351ab$var$hasOwnProperty.call(object, '__proto__')) return false;
        // Block constructor/prototype as non-terminal traversal keys to prevent
        // escaping the object graph into built-in constructors and prototypes.
        if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
    }
    var obj = $3ye78(object, path);
    return obj == null || delete obj[$4yN45($gO1os(path))];
}
module.exports = $c86fc6d9079351ab$var$baseUnset;

});

parcelRegister("3ye78", function(module, exports) {

var $5g03W = parcelRequire("5g03W");


var $dAhdV = parcelRequire("dAhdV");

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $295f7eda793e290e$var$parent(object, path) {
    return path.length < 2 ? object : $5g03W(object, $dAhdV(path, 0, -1));
}
module.exports = $295f7eda793e290e$var$parent;

});

parcelRegister("ezTcL", function(module, exports) {

var $etJuK = parcelRequire("etJuK");

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $a9cf2821aeb590cb$var$customOmitClone(value) {
    return $etJuK(value) ? undefined : value;
}
module.exports = $a9cf2821aeb590cb$var$customOmitClone;

});

parcelRegister("jPzTX", function(module, exports) {

var $lyW2B = parcelRequire("lyW2B");


var $e7pPJ = parcelRequire("e7pPJ");


var $d246i = parcelRequire("d246i");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $e6fea10dbb684687$var$flatRest(func) {
    return $d246i($e7pPJ(func, undefined, $lyW2B), func + '');
}
module.exports = $e6fea10dbb684687$var$flatRest;

});

parcelRegister("lyW2B", function(module, exports) {

var $avFJ9 = parcelRequire("avFJ9");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $fb29cba7dcd09042$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $avFJ9(array, 1) : [];
}
module.exports = $fb29cba7dcd09042$var$flatten;

});

parcelRegister("avFJ9", function(module, exports) {

var $8kPaX = parcelRequire("8kPaX");


var $eED1E = parcelRequire("eED1E");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $7a6d2ac83094702e$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $eED1E);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $7a6d2ac83094702e$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $8kPaX(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $7a6d2ac83094702e$var$baseFlatten;

});

parcelRegister("eED1E", function(module, exports) {

var $2v1OR = parcelRequire("2v1OR");


var $bZ5J1 = parcelRequire("bZ5J1");


var $1ScXu = parcelRequire("1ScXu");

/** Built-in value references. */ var $aab312c604d1130a$var$spreadableSymbol = $2v1OR ? $2v1OR.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $aab312c604d1130a$var$isFlattenable(value) {
    return $1ScXu(value) || $bZ5J1(value) || !!($aab312c604d1130a$var$spreadableSymbol && value && value[$aab312c604d1130a$var$spreadableSymbol]);
}
module.exports = $aab312c604d1130a$var$isFlattenable;

});

parcelRegister("hukUK", function(module, exports) {

var $9HkI0 = parcelRequire("9HkI0");


var $1AV5C = parcelRequire("1AV5C");

let $ad68a267ac2e31a8$var$SESSION_SALT;
const $ad68a267ac2e31a8$export$237ebf1f4974c28e = ()=>{
    $ad68a267ac2e31a8$var$SESSION_SALT = (0, (/*@__PURE__*/$parcel$interopDefault($9HkI0)))();
};
const $ad68a267ac2e31a8$var$toStringArray = (arr)=>`[${arr.map((item)=>$ad68a267ac2e31a8$var$toString(item)).join(',')}]`;
const $ad68a267ac2e31a8$var$toString = (o)=>{
    if (o === null) return 'null';
    if (Array.isArray(o)) return $ad68a267ac2e31a8$var$toStringArray(o);
    if (typeof o == 'object') return $ad68a267ac2e31a8$export$66b1d6a1029e925d(o);
    if (typeof o == 'string') return `"${o}"`;
    return `${o.toString()}`;
};
const $ad68a267ac2e31a8$export$66b1d6a1029e925d = (o)=>{
    if (!$ad68a267ac2e31a8$var$SESSION_SALT) $ad68a267ac2e31a8$export$237ebf1f4974c28e();
    const strToHash = `${Object.entries(o).filter(([_, value])=>typeof value !== 'undefined').sort((a, b)=>a[0].localeCompare(b[0])).map(([key, value])=>`${key}:${$ad68a267ac2e31a8$var$toString(value)}`).join()},${$ad68a267ac2e31a8$var$SESSION_SALT}`;
    return (0, $1AV5C.hashData)(strToHash);
};
module.exports["objectHash"] = $ad68a267ac2e31a8$export$66b1d6a1029e925d;

});

parcelRegister("1A7bE", function(module, exports) {

var $gykrH = parcelRequire("gykrH");

const $812facbbd37978f7$export$feb7963ae429f97f = (experienceNames)=>{
    const experienceNameSet = new Set(experienceNames);
    return (events, experience)=>{
        // Fail as soon as any sub-experience is failed or aborted
        experience.stopOn(events.find((event)=>experienceNameSet.has(event.name) && (event.action === 'taskFail' || event.action === 'taskAbort')), {
            incompleteSubExperiences: [
                ...experienceNameSet
            ].join(', ')
        });
        // If there's a success remove the experience from the set
        // of experiences we're waiting for.
        events.forEach((event)=>{
            if ((0, $gykrH.isStop)(event)) experienceNameSet.delete(event.name);
        });
        // Experience is considered complete if all sub-experiences
        // are complete.
        if (experienceNameSet.size === 0) experience.succeed();
    };
};
const $812facbbd37978f7$export$79dbdd3e43727beb = (experienceNames)=>(events, experience)=>experience.stopOn(events.find((event)=>(0, $gykrH.isStop)(event) && (0, $gykrH.hasName)(event, ...experienceNames)));
module.exports["collectAll"] = $812facbbd37978f7$export$feb7963ae429f97f;
module.exports["collectAny"] = $812facbbd37978f7$export$79dbdd3e43727beb;

});

parcelRegister("h10mo", function(module, exports) {

var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");


var $1A7bE = parcelRequire("1A7bE");

const $49be9d39a158f0e7$var$homeSubExperiences = [
    (0, $irVI7.HOME_OVERVIEW_EXPERIENCE),
    (0, $irVI7.HOME_RECENT_EXPERIENCE),
    (0, $irVI7.HOME_STARRED_EXPERIENCE),
    (0, $irVI7.HOME_WATCHING_EXPERIENCE),
    (0, $irVI7.HOME_DRAFTS_EXPERIENCE)
];
function $49be9d39a158f0e7$export$4278268ff5675d74() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.HOME_EXPERIENCE),
        collect: (0, $1A7bE.collectAny)($49be9d39a158f0e7$var$homeSubExperiences)
    });
}
module.exports["startHome"] = $49be9d39a158f0e7$export$4278268ff5675d74;

});

parcelRegister("gtj7V", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");

const $da3ef500cf6996c4$export$eb5d3a5abb22f159 = ()=>{
    return {
        newDataManagerEnabled: (0, $6mKj3.UNSAFE_expValNoExposure)('cc_comments_new_comments_data_manager', 'isEnabled', false)
    };
};
module.exports["getCommentsDataManagerExperimentAttributes"] = $da3ef500cf6996c4$export$eb5d3a5abb22f159;

});

parcelRegister("3YBks", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");


var $1A7bE = parcelRequire("1A7bE");


var $gtj7V = parcelRequire("gtj7V");

let $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {};
let $3ac00da98b683ca3$var$runningExperiences = [];
// Note: The soft failure is set on the first soft failure not updated following
let $3ac00da98b683ca3$var$softFailure = undefined;
let $3ac00da98b683ca3$var$publishFailed = false;
let $3ac00da98b683ca3$var$publishSuccessCount = 0;
function $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug(experienceName) {
    function createInlineCommentExperienceDebug({ error: error, createAnalyticsEvent: createAnalyticsEvent, extraAttributes: extraAttributes }) {
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        const experienceAttributes = experienceTracker.getExperienceState((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE));
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'error',
                actionSubject: (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE),
                source: experienceName,
                attributes: {
                    ...experienceAttributes,
                    ...$3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes,
                    ...extraAttributes,
                    error: error.message || String(error),
                    stack: error.stack
                }
            }
        }).fire();
    }
    return createInlineCommentExperienceDebug;
}
const $3ac00da98b683ca3$export$90894e50be2305e9 = {
    start: function createInlineCommentCompoundExperience({ attributes: attributes }) {
        // reset common experience state when starting a new parent experience
        $3ac00da98b683ca3$var$runningExperiences = [
            (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE)
        ];
        $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {};
        $3ac00da98b683ca3$var$softFailure = undefined;
        $3ac00da98b683ca3$var$publishFailed = false;
        $3ac00da98b683ca3$var$publishSuccessCount = 0;
        const compoundTaskId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.start({
            name: (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE),
            id: compoundTaskId,
            attributes: {
                ...attributes,
                compoundTaskId: compoundTaskId,
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)()
            },
            collect: (events, experience)=>{
                (0, $1A7bE.collectAll)([
                    (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                    (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)
                ])(events, experience);
            }
        });
        $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {
            compoundTaskId: compoundTaskId,
            annotationId: attributes.annotationId,
            pageClass: attributes.pageClass,
            entryPoint: attributes.entryPoint,
            edition: attributes.edition,
            ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)()
        };
    },
    debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE)),
    addCommonAttributes: (commonAttributes)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {
            ...$3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes,
            ...commonAttributes
        };
        for (const runningExperience of $3ac00da98b683ca3$var$runningExperiences)experienceTracker.updateAttributes({
            name: runningExperience,
            attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
        });
    },
    attachCommonAttributes: (experienceName)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.updateAttributes({
            name: experienceName,
            attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
        });
    },
    initExperience: {
        start: ()=>{
            $3ac00da98b683ca3$var$runningExperiences.push((0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE));
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.start({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                timeout: 5000,
                attributes: {
                    ...$3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
                }
            });
            $3ac00da98b683ca3$export$90894e50be2305e9.attachCommonAttributes((0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE));
        },
        fail: (error)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                error: error
            });
        },
        softFail: (error)=>{
            if (!$3ac00da98b683ca3$var$softFailure) $3ac00da98b683ca3$var$softFailure = {
                error: error,
                pointOfFailure: 'init'
            };
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                attributes: {
                    softFailure: error.message
                }
            });
        },
        abort: ({ abortReason: abortReason, attributes: attributes })=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.abort({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                reason: abortReason,
                attributes: attributes
            });
        },
        /**
     * This completes the init experience and starts the draft to publish experience.
     */ complete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE)
            });
        },
        debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE)),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        }
    },
    draftToPublishExperience: {
        start: ()=>{
            $3ac00da98b683ca3$var$runningExperiences.push((0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE));
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.start({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
            });
            $3ac00da98b683ca3$export$90894e50be2305e9.attachCommonAttributes((0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE));
        },
        publishFailed: (error)=>{
            $3ac00da98b683ca3$var$publishFailed = true;
            if (!$3ac00da98b683ca3$var$softFailure) $3ac00da98b683ca3$var$softFailure = {
                error: error,
                pointOfFailure: 'publish-failed'
            };
        },
        publishSucceeded: ()=>{
            $3ac00da98b683ca3$var$publishSuccessCount += 1;
        },
        abort: ({ abortReason: abortReason, attributes: attributes })=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.abort({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                reason: abortReason,
                attributes: attributes
            });
        },
        fail: (error, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: error,
                attributes: attributes
            });
        },
        stopOnError: (error, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.stopOnError({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: error,
                attributes: attributes
            });
        },
        dismissed: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if ($3ac00da98b683ca3$var$publishSuccessCount > 0) experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: new Error('Draft comment dismissed after publish success')
            });
            else if ($3ac00da98b683ca3$var$publishFailed) experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: new Error('Draft comment dismissed after publish attempt')
            });
            else experienceTracker.abort({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                reason: 'Draft comment dismissed'
            });
        },
        softFail: (error)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if (!$3ac00da98b683ca3$var$softFailure) $3ac00da98b683ca3$var$softFailure = {
                error: error,
                pointOfFailure: 'multiple-saves-without-error'
            };
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                attributes: {
                    softFailure: error.message
                }
            });
        },
        complete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if ($3ac00da98b683ca3$var$softFailure) {
                experienceTracker.succeed({
                    name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                    attributes: {
                        softFailure: $3ac00da98b683ca3$var$softFailure.error.message,
                        pointOfFailure: $3ac00da98b683ca3$var$softFailure.pointOfFailure
                    }
                });
                return;
            }
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)
            });
        },
        debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        }
    },
    attachCommentExperience: {
        start: ()=>{
            $3ac00da98b683ca3$var$runningExperiences.push((0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE));
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.start({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                // If the view comment does not load in 6 seconds, it's
                // an indicator something has gone wrong.
                timeout: 6000,
                attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
            });
            $3ac00da98b683ca3$export$90894e50be2305e9.attachCommonAttributes((0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE));
        },
        fail: (error, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                error: error,
                attributes: attributes
            });
        },
        complete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if ($3ac00da98b683ca3$var$softFailure) {
                experienceTracker.succeed({
                    name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                    attributes: {
                        softFailure: $3ac00da98b683ca3$var$softFailure.error.message,
                        pointOfFailure: $3ac00da98b683ca3$var$softFailure.pointOfFailure
                    }
                });
                return;
            }
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE)
            });
        },
        debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE)),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        }
    }
};
module.exports["createInlineCommentCompoundExperience"] = $3ac00da98b683ca3$export$90894e50be2305e9;

});

parcelRegister("8WQTF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $4677820b18a14e4d$export$66feffbad722f9d4 = /*#__PURE__*/ (0, $cozmU.createContext)({
    rendererActions: null,
    pageId: undefined,
    pageAdf: undefined
});
$4677820b18a14e4d$export$66feffbad722f9d4.displayName = 'RendererActionsContext';
const $4677820b18a14e4d$export$c7c5640cf8aff722 = /*#__PURE__*/ (0, $cozmU.createContext)({
    setRendererActions: ()=>{},
    setPageAdf: ()=>{}
});
$4677820b18a14e4d$export$c7c5640cf8aff722.displayName = 'RendererActionsDispatchContext';
const $4677820b18a14e4d$export$a41bfe8d4028fb59 = ({ children: children })=>{
    const [rendererActions, setRendererActions] = (0, $cozmU.useState)(null);
    const [pageId, setPageId] = (0, $cozmU.useState)(undefined);
    const [pageAdf, setPageAdf] = (0, $cozmU.useState)(undefined);
    const providerValue = (0, $cozmU.useMemo)(()=>({
            rendererActions: rendererActions,
            pageId: pageId,
            pageAdf: pageAdf
        }), [
        rendererActions,
        pageId,
        pageAdf
    ]);
    const dispatchProviderValue = (0, $cozmU.useMemo)(()=>({
            setRendererActions: (actions, newPageId)=>{
                setRendererActions(actions);
                setPageId(newPageId);
            },
            setPageAdf: (newPageAdf)=>{
                setPageAdf(newPageAdf);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4677820b18a14e4d$export$66feffbad722f9d4.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4677820b18a14e4d$export$c7c5640cf8aff722.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $4677820b18a14e4d$export$55249bdd00e8a5d6 = ()=>{
    return (0, $cozmU.useContext)($4677820b18a14e4d$export$66feffbad722f9d4);
};
const $4677820b18a14e4d$export$6e9863dfedeaae60 = ()=>{
    return (0, $cozmU.useContext)($4677820b18a14e4d$export$c7c5640cf8aff722);
};
module.exports["RendererActionsProvider"] = $4677820b18a14e4d$export$a41bfe8d4028fb59;
module.exports["useRendererActions"] = $4677820b18a14e4d$export$55249bdd00e8a5d6;
module.exports["useRendererActionsDispatch"] = $4677820b18a14e4d$export$6e9863dfedeaae60;

});

parcelRegister("dANtQ", function(module, exports) {

var $i1slQ = parcelRequire("i1slQ");


var $5T18X = parcelRequire("5T18X");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $jMyy4 = parcelRequire("jMyy4");

const $be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery = (0, $i1slQ.default);
const $be6154107952d370$var$noOpRefetch = ()=>Promise.resolve();
const $be6154107952d370$export$4cae5d8963399c48 = (contentId, cacheOnly = false)=>{
    const baseOptions = {
        variables: {
            contentId: contentId
        },
        skip: !contentId
    };
    const queryResult = (0, $6mKj3.expValEquals)('confluence_frontend_stop_watching_queries', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)($be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery, {
        ...baseOptions,
        __callerPackage__: "comments-hooks"
    }) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)($be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery, {
        ...baseOptions,
        notifyOnNetworkStatusChange: true,
        fetchPolicy: cacheOnly ? 'cache-only' : 'cache-and-network',
        __callerPackage__: "comments-hooks"
    });
    const { data: data, loading: loading, error: error } = queryResult;
    const networkStatus = 'networkStatus' in queryResult && queryResult.networkStatus !== undefined ? queryResult.networkStatus : (0, $5T18X.NetworkStatus).ready;
    const refetch = 'refetch' in queryResult && typeof queryResult.refetch === 'function' ? queryResult.refetch : $be6154107952d370$var$noOpRefetch;
    const contentNode = data?.content?.nodes?.[0];
    const operations = contentNode?.operations ?? [];
    const createPermission = operations.some((operationResults)=>operationResults?.operation === 'create' && operationResults?.targetType === 'comment');
    return {
        canAddComments: createPermission,
        loading: loading,
        contentQueryError: error,
        refetch: refetch,
        networkStatus: networkStatus
    };
};
module.exports["useAddCommentPermissionCheck"] = $be6154107952d370$export$4cae5d8963399c48;

});

parcelRegister("i1slQ", function(module, exports) {
/**
 * @generated SignedSource<<57f5dc3732e3b478e212a6d8f6a9bb34>>
 * @relayHash 5b33d38d543554afec98c6d129862ca0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c0666e4aa67b4630a3145d746b836d11857cbed57f80ba27619146d9e2fc51f9
const $fc06507f37418bb6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "draft",
                        "current"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5b33d38d543554afec98c6d129862ca0",
            "id": "c0666e4aa67b4630a3145d746b836d11857cbed57f80ba27619146d9e2fc51f9",
            "metadata": {},
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "operationKind": "query",
            "text": "query useAddCommentPermissionCheckPermissionCheckAddCommentQuery($contentId:ID!){content(id:$contentId,status:[\"draft\",\"current\"]){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$fc06507f37418bb6$var$node.hash = "aad09466db1f47073b1a0249e54dc3a4";
var $fc06507f37418bb6$export$2e2bcd8739ae039 = $fc06507f37418bb6$var$node;
module.exports["default"] = $fc06507f37418bb6$export$2e2bcd8739ae039;

});

parcelRegister("cMvMc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f2899d935411e961$export$fb31a121515f224d = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "_Vqh0",
    name: "CommentWarningDialog",
    loader: async ()=>(await (parcelRequire("7NKS7"))).CommentWarningDialog
});
module.exports["CommentWarningDialog"] = $f2899d935411e961$export$fb31a121515f224d;

});

parcelRegister("7NKS7", function(module, exports) {

let $5ae177c72d819b7b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5ae177c72d819b7b$var$load("hhss7"),
    $5ae177c72d819b7b$var$load("cqNU4")
]).then(()=>parcelRequire('9c4UU'));

});

parcelRegister("8aF6s", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $cozmU = parcelRequire("cozmU");


var $2BAFx = parcelRequire("2BAFx");

const $ff30daea9524db5f$var$onChildClose = (key, ...args)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        setState({
            stack: state.stack.map((frame)=>frame === childFrame ? {
                    ...frame,
                    alive: false
                } : frame)
        });
    };
const $ff30daea9524db5f$var$onChildCloseComplete = (key, ...args)=>({ getState: getState, setState: setState })=>{
        // A child dialog called its onCloseComplete prop
        const state = getState();
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        setState({
            stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
        });
    };
const $ff30daea9524db5f$var$actions = {
    showModal: (componentClass, originalProps, children)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const onClose = (...args)=>dispatch($ff30daea9524db5f$var$onChildClose(key, ...args));
            const onCloseComplete = (...args)=>dispatch($ff30daea9524db5f$var$onChildCloseComplete(key, ...args));
            const component = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(componentClass, {
                ...props,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, children);
            const state = getState();
            setState({
                stack: [
                    ...state.stack,
                    {
                        key: key,
                        component: component,
                        alive: true,
                        originalProps: {
                            onClose: props?.onClose,
                            onCloseComplete: props?.onCloseComplete
                        }
                    }
                ]
            });
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return onClose;
        }
};
const $ff30daea9524db5f$var$store = (0, $8s9DV.createStore)({
    initialState: {
        stack: []
    },
    actions: $ff30daea9524db5f$var$actions,
    name: 'DialogsStore'
});
/**
 * This is a work around to enforce the type requirement for the modal component.
 * For some reason the types don't resolve correctly in the bound actions
 */ const $ff30daea9524db5f$var$getTypedActions = (actions)=>{
    const showModal = (component, originalProps)=>{
        actions.showModal(component, originalProps);
    };
    return {
        showModal: showModal
    };
};
const $ff30daea9524db5f$var$useDialogActions = (0, $kBr4q.createActionsHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$f3af872d774d3d3f = ()=>{
    const actions = $ff30daea9524db5f$var$useDialogActions();
    return (0, $cozmU.useMemo)(()=>$ff30daea9524db5f$var$getTypedActions(actions), [
        actions
    ]);
};
const $ff30daea9524db5f$var$useDialogsStore = (0, $kBr4q.createHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$ecef86e74aed0d6b = ()=>{
    const [state, actions] = $ff30daea9524db5f$var$useDialogsStore();
    return (0, $cozmU.useMemo)(()=>({
            state: state,
            ...$ff30daea9524db5f$var$getTypedActions(actions)
        }), [
        actions,
        state
    ]);
};
module.exports["useDialogs"] = $ff30daea9524db5f$export$f3af872d774d3d3f;
module.exports["useDialogsState"] = $ff30daea9524db5f$export$ecef86e74aed0d6b;

});

parcelRegister("2BAFx", function(module, exports) {
class $d32907502a426d2e$var$DialogKeyState {
    get nextKey() {
        return this._nextKey++;
    }
    set nextKey(newKey) {
        if (newKey > this._nextKey) this._nextKey = newKey;
    }
    constructor(){
        this._nextKey = 0;
    }
}
const $d32907502a426d2e$export$2e170616461fb3b6 = new $d32907502a426d2e$var$DialogKeyState();
module.exports["dialogKeyState"] = $d32907502a426d2e$export$2e170616461fb3b6;

});

parcelRegister("bSvtO", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $45ca38ec521afdf7$var$initialState = {
    hasContentChanged: false,
    isCommentContentReady: false
};
const $45ca38ec521afdf7$export$53ac33307b5acee9 = ()=>({
        hasContentChanged: false,
        isCommentContentReady: false
    });
const $45ca38ec521afdf7$export$e324594224ef24da = {
    onChange: (hasChanges)=>({ setState: setState })=>{
            setState({
                hasContentChanged: hasChanges
            });
        },
    resetContentChanged: ()=>({ setState: setState })=>{
            setState({
                hasContentChanged: false
            });
        },
    onCommentContentReady: ()=>({ setState: setState })=>{
            setState({
                isCommentContentReady: true
            });
        }
};
const $45ca38ec521afdf7$var$CommentsContentStore = (0, $8s9DV.createStore)({
    initialState: $45ca38ec521afdf7$var$initialState,
    actions: $45ca38ec521afdf7$export$e324594224ef24da,
    name: 'CommentsContentStore'
});
const $45ca38ec521afdf7$export$ef1bfc0b6758ca67 = (0, $kBr4q.createHook)($45ca38ec521afdf7$var$CommentsContentStore);
const $45ca38ec521afdf7$export$e2038e591f93e866 = (0, $kBr4q.createActionsHook)($45ca38ec521afdf7$var$CommentsContentStore);
const $45ca38ec521afdf7$export$1756d05b0495e6b = (0, $kBr4q.createStateHook)($45ca38ec521afdf7$var$CommentsContentStore);
module.exports["useCommentsContentActions"] = $45ca38ec521afdf7$export$e2038e591f93e866;
module.exports["useCommentsContentState"] = $45ca38ec521afdf7$export$1756d05b0495e6b;

});

parcelRegister("kDhla", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $9a24de4c41696be8$export$d4c72bab9d6cc13a = {
    fullPageEditorPresetAPI: undefined
};
const $9a24de4c41696be8$export$e324594224ef24da = {
    setEditorApi: (fullPageEditorPresetAPI)=>({ setState: setState })=>{
            setState({
                fullPageEditorPresetAPI: fullPageEditorPresetAPI
            });
        },
    resetEditorApi: ()=>({ setState: setState })=>{
            setState($9a24de4c41696be8$export$d4c72bab9d6cc13a);
        }
};
const $9a24de4c41696be8$var$FullPageEditorApiStore = (0, $8s9DV.createStore)({
    initialState: $9a24de4c41696be8$export$d4c72bab9d6cc13a,
    actions: $9a24de4c41696be8$export$e324594224ef24da,
    name: 'FullPageEditorApiStore'
});
const $9a24de4c41696be8$export$dc2b462ca736d2cc = (0, $kBr4q.createHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$6e619048e155ac67 = (0, $kBr4q.createActionsHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
const $9a24de4c41696be8$export$4875e84e17c56c5c = (0, $kBr4q.createStateHook)($9a24de4c41696be8$var$FullPageEditorApiStore);
module.exports["useFullPageEditorApi"] = $9a24de4c41696be8$export$dc2b462ca736d2cc;
module.exports["useFullPageEditorApiActions"] = $9a24de4c41696be8$export$6e619048e155ac67;
module.exports["useFullPageEditorApiState"] = $9a24de4c41696be8$export$4875e84e17c56c5c;

});

parcelRegister("eh1vA", function(module, exports) {

let $a643d2c54f82fd85$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a643d2c54f82fd85$var$load("ddvkk"),
    $a643d2c54f82fd85$var$load("3upHR"),
    $a643d2c54f82fd85$var$load("HaNwW"),
    $a643d2c54f82fd85$var$load("lgIhe"),
    $a643d2c54f82fd85$var$load("w3Gc8"),
    $a643d2c54f82fd85$var$load("bZz7X")
]).then(()=>parcelRequire('g9dNl'));

});

parcelRegister("1K8rh", function(module, exports) {

let $1450a21ec097041a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1450a21ec097041a$var$load("ig9dh"),
    $1450a21ec097041a$var$load("hA8hA"),
    $1450a21ec097041a$var$load("iWnyc"),
    $1450a21ec097041a$var$load("7TnhR"),
    $1450a21ec097041a$var$load("ddvkk"),
    $1450a21ec097041a$var$load("3upHR"),
    $1450a21ec097041a$var$load("6wr18"),
    $1450a21ec097041a$var$load("l1HBI"),
    $1450a21ec097041a$var$load("ffEVr"),
    $1450a21ec097041a$var$load("gYeBT"),
    $1450a21ec097041a$var$load("4W6oq"),
    $1450a21ec097041a$var$load("8LtYa"),
    $1450a21ec097041a$var$load("jXA76"),
    $1450a21ec097041a$var$load("HaNwW"),
    $1450a21ec097041a$var$load("eCXJR"),
    $1450a21ec097041a$var$load("1VTX2"),
    $1450a21ec097041a$var$load("ghNAx"),
    $1450a21ec097041a$var$load("hZ2FX"),
    $1450a21ec097041a$var$load("kT6dz"),
    $1450a21ec097041a$var$load("aAWLw"),
    $1450a21ec097041a$var$load("6q8Rl")
]).then(()=>parcelRequire('gFN6K'));

});

parcelRegister("60ddt", function(module, exports) {

let $45ecfea625e292e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $45ecfea625e292e8$var$load("6wr18"),
    $45ecfea625e292e8$var$load("ffEVr"),
    $45ecfea625e292e8$var$load("jtuzz")
]).then(()=>parcelRequire('ioFqb'));

});

parcelRegister("9dtiO", function(module, exports) {

let $6b5c0ecf2cf7eda6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6b5c0ecf2cf7eda6$var$load("kT6dz"),
    $6b5c0ecf2cf7eda6$var$load("ipIDQ"),
    $6b5c0ecf2cf7eda6$var$load("ig9dh"),
    $6b5c0ecf2cf7eda6$var$load("hA8hA"),
    $6b5c0ecf2cf7eda6$var$load("el56J"),
    $6b5c0ecf2cf7eda6$var$load("iUXaE"),
    $6b5c0ecf2cf7eda6$var$load("lTkx9"),
    $6b5c0ecf2cf7eda6$var$load("6wr18"),
    $6b5c0ecf2cf7eda6$var$load("cJsay"),
    $6b5c0ecf2cf7eda6$var$load("agdLZ"),
    $6b5c0ecf2cf7eda6$var$load("kxG0W"),
    $6b5c0ecf2cf7eda6$var$load("dpC8y"),
    $6b5c0ecf2cf7eda6$var$load("byAMe"),
    $6b5c0ecf2cf7eda6$var$load("dzUzj"),
    $6b5c0ecf2cf7eda6$var$load("l1HBI"),
    $6b5c0ecf2cf7eda6$var$load("gYeBT"),
    $6b5c0ecf2cf7eda6$var$load("HaNwW"),
    $6b5c0ecf2cf7eda6$var$load("b0ARW"),
    $6b5c0ecf2cf7eda6$var$load("RylUf"),
    $6b5c0ecf2cf7eda6$var$load("cIET7"),
    $6b5c0ecf2cf7eda6$var$load("jgxNN"),
    $6b5c0ecf2cf7eda6$var$load("ariuh"),
    $6b5c0ecf2cf7eda6$var$load("jzUgs"),
    $6b5c0ecf2cf7eda6$var$load("1GCFv"),
    $6b5c0ecf2cf7eda6$var$load("7oAXW"),
    $6b5c0ecf2cf7eda6$var$load("dxcsb"),
    $6b5c0ecf2cf7eda6$var$load("gbejv"),
    $6b5c0ecf2cf7eda6$var$load("GD9EA"),
    $6b5c0ecf2cf7eda6$var$load("7gL7H"),
    $6b5c0ecf2cf7eda6$var$load("cmmpX"),
    $6b5c0ecf2cf7eda6$var$load("ekVH8"),
    $6b5c0ecf2cf7eda6$var$load("7EorR"),
    $6b5c0ecf2cf7eda6$var$load("jqoep"),
    $6b5c0ecf2cf7eda6$var$load("hhss7"),
    $6b5c0ecf2cf7eda6$var$load("ffEVr"),
    $6b5c0ecf2cf7eda6$var$load("Wowvf"),
    $6b5c0ecf2cf7eda6$var$load("ezm4t"),
    $6b5c0ecf2cf7eda6$var$load("h9ofP"),
    $6b5c0ecf2cf7eda6$var$load("4JSav"),
    $6b5c0ecf2cf7eda6$var$load("eCXJR"),
    $6b5c0ecf2cf7eda6$var$load("1VTX2"),
    $6b5c0ecf2cf7eda6$var$load("cHcD4"),
    $6b5c0ecf2cf7eda6$var$load("2m65P"),
    $6b5c0ecf2cf7eda6$var$load("he34V"),
    $6b5c0ecf2cf7eda6$var$load("dEUQZ"),
    $6b5c0ecf2cf7eda6$var$load("gzrfp"),
    $6b5c0ecf2cf7eda6$var$load("80Yra"),
    $6b5c0ecf2cf7eda6$var$load("1NGPq"),
    $6b5c0ecf2cf7eda6$var$load("7TnhR"),
    $6b5c0ecf2cf7eda6$var$load("houtd"),
    $6b5c0ecf2cf7eda6$var$load("ddvkk"),
    $6b5c0ecf2cf7eda6$var$load("3upHR"),
    $6b5c0ecf2cf7eda6$var$load("bjimZ"),
    $6b5c0ecf2cf7eda6$var$load("kUfAt"),
    $6b5c0ecf2cf7eda6$var$load("79Tk4"),
    $6b5c0ecf2cf7eda6$var$load("hZ2FX"),
    $6b5c0ecf2cf7eda6$var$load("gVVrO"),
    $6b5c0ecf2cf7eda6$var$load("6KRyd"),
    $6b5c0ecf2cf7eda6$var$load("gd3iv")
]).then(()=>parcelRequire('5hqV2'));

});

parcelRegister("75EWd", function(module, exports) {

let $5298c17b33853337$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5298c17b33853337$var$load("ig9dh"),
    $5298c17b33853337$var$load("hA8hA"),
    $5298c17b33853337$var$load("iWnyc"),
    $5298c17b33853337$var$load("7TnhR"),
    $5298c17b33853337$var$load("ddvkk"),
    $5298c17b33853337$var$load("3upHR"),
    $5298c17b33853337$var$load("6wr18"),
    $5298c17b33853337$var$load("l1HBI"),
    $5298c17b33853337$var$load("ffEVr"),
    $5298c17b33853337$var$load("gYeBT"),
    $5298c17b33853337$var$load("4W6oq"),
    $5298c17b33853337$var$load("8LtYa"),
    $5298c17b33853337$var$load("jXA76"),
    $5298c17b33853337$var$load("HaNwW"),
    $5298c17b33853337$var$load("eCXJR"),
    $5298c17b33853337$var$load("1VTX2"),
    $5298c17b33853337$var$load("ghNAx"),
    $5298c17b33853337$var$load("hZ2FX"),
    $5298c17b33853337$var$load("6q8Rl"),
    $5298c17b33853337$var$load("kT6dz"),
    $5298c17b33853337$var$load("aAWLw"),
    $5298c17b33853337$var$load("ioZhb")
]).then(()=>parcelRequire('eBrKE'));

});

parcelRegister("hOAjl", function(module, exports) {

let $cf8345c59f411095$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cf8345c59f411095$var$load("ddvkk"),
    $cf8345c59f411095$var$load("3upHR"),
    $cf8345c59f411095$var$load("HaNwW"),
    $cf8345c59f411095$var$load("lgIhe"),
    $cf8345c59f411095$var$load("w3Gc8"),
    $cf8345c59f411095$var$load("bZz7X"),
    $cf8345c59f411095$var$load("9izCO")
]).then(()=>parcelRequire('gDZxl'));

});

parcelRegister("lJDEI", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $6mKj3 = parcelRequire("6mKj3");

const $4a3de077c1d50444$export$339879d9e7e1b505 = 'inEditorTemplatesPanel';
const $4a3de077c1d50444$export$a957a3414f664a78 = 'open';
const $4a3de077c1d50444$export$5f52a3f66b36af8a = 'keep_open';
const $4a3de077c1d50444$export$3077ff8b594d6ef8 = 'auto_closed';
const $4a3de077c1d50444$export$e03fa63b521a0c2 = 'createdWithTemplate';
const $4a3de077c1d50444$export$79a38b1b3ee7546f = 'contextPanelTabTarget';
const $4a3de077c1d50444$export$d3c15ca89bcfbca6 = 'templates';
const $4a3de077c1d50444$export$9d622978cb62b57d = 'block';
const $4a3de077c1d50444$export$3059f9ac1064e696 = 'import';
const $4a3de077c1d50444$export$ccd8928f1e8269de = 'templates';
const $4a3de077c1d50444$export$2f49124c0813d6f9 = 'import';
const $4a3de077c1d50444$export$5a50171a4c5c3a34 = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$e03fa63b521a0c2] === 'true';
};
const $4a3de077c1d50444$export$944cd488c360bc7a = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$339879d9e7e1b505];
};
const $4a3de077c1d50444$export$c1ea49786444cf5a = (getQueryParams)=>{
    return getQueryParams()[$4a3de077c1d50444$export$79a38b1b3ee7546f];
};
const $4a3de077c1d50444$export$e991edcb7a1d128f = (getQueryParams)=>{
    return $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams) === $4a3de077c1d50444$export$a957a3414f664a78;
};
const $4a3de077c1d50444$export$835e1f3b6fb2ce1a = (getQueryParams)=>{
    const queryParamValue = $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams);
    return queryParamValue === $4a3de077c1d50444$export$a957a3414f664a78 || queryParamValue === $4a3de077c1d50444$export$5f52a3f66b36af8a;
};
const $4a3de077c1d50444$export$242446a58b76be13 = (getQueryParams)=>{
    const queryParamValue = $4a3de077c1d50444$export$944cd488c360bc7a(getQueryParams);
    const tabTarget = $4a3de077c1d50444$export$c1ea49786444cf5a(getQueryParams);
    return (queryParamValue === $4a3de077c1d50444$export$a957a3414f664a78 || queryParamValue === $4a3de077c1d50444$export$5f52a3f66b36af8a) && (tabTarget === $4a3de077c1d50444$export$d3c15ca89bcfbca6 || tabTarget === $4a3de077c1d50444$export$9d622978cb62b57d);
};
const $4a3de077c1d50444$export$56073af4e8655248 = (setQueryParams, isRovoLLMEnabled = false)=>{
    const paramsToRemove = {
        [$4a3de077c1d50444$export$339879d9e7e1b505]: null
    };
    // Clear contextPanelTabTarget when either platform_editor_blocks_conf or cwr_blank_object_experiment is enabled
    if (isRovoLLMEnabled && (0, $6mKj3.expVal)('cwr_blank_object_experiment', 'isEnabled', false) || (0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false)) paramsToRemove[$4a3de077c1d50444$export$79a38b1b3ee7546f] = null;
    setQueryParams(paramsToRemove, true);
};
const $4a3de077c1d50444$export$90fd502a25d2c01 = (setQueryParams, inEditorTemplatesPanel, tabTarget, isRovoLLMEnabled = false)=>{
    const params = {
        [$4a3de077c1d50444$export$339879d9e7e1b505]: inEditorTemplatesPanel
    };
    // Set contextPanelTabTarget when either platform_editor_blocks_conf or cwr_blank_object_experiment is enabled
    if (tabTarget && (isRovoLLMEnabled && (0, $6mKj3.expVal)('cwr_blank_object_experiment', 'isEnabled', false) || (0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false))) params[$4a3de077c1d50444$export$79a38b1b3ee7546f] = tabTarget;
    setQueryParams(params, true);
};
const $4a3de077c1d50444$export$828af32839880b11 = (spaceKey)=>{
    if (spaceKey) return (0, $1NBp8.SPACE_SETTINGS_TEMPLATES).toUrl({
        spaceKey: spaceKey
    });
    return (0, $1NBp8.ADMIN_TEMPLATES_AND_BLUEPRINTS).toUrl();
};
module.exports["IN_EDITOR_TEMPLATES_QUERY_PARAM_NAME"] = $4a3de077c1d50444$export$339879d9e7e1b505;
module.exports["IN_EDITOR_TEMPLATES_QUERY_OPEN"] = $4a3de077c1d50444$export$a957a3414f664a78;
module.exports["IN_EDITOR_TEMPLATES_QUERY_KEEP_OPEN"] = $4a3de077c1d50444$export$5f52a3f66b36af8a;
module.exports["IN_EDITOR_TEMPLATES_QUERY_AUTO_CLOSED"] = $4a3de077c1d50444$export$3077ff8b594d6ef8;
module.exports["CREATED_WITH_TEMPLATE_QUERY_PARAM_NAME"] = $4a3de077c1d50444$export$e03fa63b521a0c2;
module.exports["CONTEXT_PANEL_TAB_TARGET"] = $4a3de077c1d50444$export$79a38b1b3ee7546f;
module.exports["CONTEXT_PANEL_TAB_TARGET_TEMPLATES"] = $4a3de077c1d50444$export$d3c15ca89bcfbca6;
module.exports["CONTEXT_PANEL_TAB_TARGET_BLOCK"] = $4a3de077c1d50444$export$9d622978cb62b57d;
module.exports["CONTEXT_PANEL_TAB_TARGET_IMPORT"] = $4a3de077c1d50444$export$3059f9ac1064e696;
module.exports["PANEL_MODE_TEMPLATES"] = $4a3de077c1d50444$export$ccd8928f1e8269de;
module.exports["PANEL_MODE_IMPORT"] = $4a3de077c1d50444$export$2f49124c0813d6f9;
module.exports["getCreatedWithTemplateQueryParamValue"] = $4a3de077c1d50444$export$5a50171a4c5c3a34;
module.exports["getInEditorTemplatesPanelQueryParamValue"] = $4a3de077c1d50444$export$944cd488c360bc7a;
module.exports["isInEditorTemplatesPanelQueryParamValueOpen"] = $4a3de077c1d50444$export$e991edcb7a1d128f;
module.exports["isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpen"] = $4a3de077c1d50444$export$835e1f3b6fb2ce1a;
module.exports["isInEditorTemplatesPanelQueryParamValueOpenOrKeepOpenWithTemplatesPanelMode"] = $4a3de077c1d50444$export$242446a58b76be13;
module.exports["removeInEditorTemplatesQueryParam"] = $4a3de077c1d50444$export$56073af4e8655248;
module.exports["setInEditorTemplatesPanelQueryParam"] = $4a3de077c1d50444$export$90fd502a25d2c01;
module.exports["getTemplateListPage"] = $4a3de077c1d50444$export$828af32839880b11;

});

parcelRegister("hPTbh", function(module, exports) {
/**
 * Centralized analytics constants for the snippets package.
 *
 * Organized into three sections:
 *   1. Shared    – source, event types, origins, page modes (used by all events)
 *   2. UI        – subjects, actions, subject IDs, modal outcomes (sendUIEvent)
 *   3. Operational – subjects, actions (sendOperationalEvent)
 */ // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
//  Shared
// ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
/** Event type used to dispatch analytics events */ var $2394c5239b489cef$export$a0913705d36eb84c = /*#__PURE__*/ function(ANALYTICS_EVENT_TYPE) {
    ANALYTICS_EVENT_TYPE["SEND_UI_EVENT"] = "sendUIEvent";
    ANALYTICS_EVENT_TYPE["SEND_OPERATIONAL_EVENT"] = "sendOperationalEvent";
    ANALYTICS_EVENT_TYPE["SEND_TRACK_EVENT"] = "sendTrackEvent";
    return ANALYTICS_EVENT_TYPE;
}({});
var $2394c5239b489cef$export$17897eee0c3e7eb1 = /*#__PURE__*/ function(ANALYTICS_TYPE) {
    ANALYTICS_TYPE["UI"] = "ui";
    ANALYTICS_TYPE["OPERATIONAL"] = "operational";
    return ANALYTICS_TYPE;
}({});
const $2394c5239b489cef$export$f7109619a5e9e0d6 = 'confluenceSnippets';
var $2394c5239b489cef$export$8dd55f56fde129aa = /*#__PURE__*/ function(ANALYTICS_ORIGIN) {
    // snippet CRUD modals
    ANALYTICS_ORIGIN["CREATE_SNIPPET_MODAL"] = "createSnippetModal";
    ANALYTICS_ORIGIN["EDIT_SNIPPET_MODAL"] = "editSnippetModal";
    ANALYTICS_ORIGIN["DUPLICATE_SNIPPET_MODAL"] = "duplicateSnippetModal";
    ANALYTICS_ORIGIN["DELETE_SNIPPET_MODAL"] = "deleteSnippetModal";
    // onboarding
    ANALYTICS_ORIGIN["FIRST_SNIPPET_CREATED_MODAL"] = "firstSnippetCreatedModal";
    // surfaces
    ANALYTICS_ORIGIN["SNIPPET_PANEL"] = "snippetPanel";
    ANALYTICS_ORIGIN["SNIPPET_GALLERY"] = "snippetGallery";
    // toolbars / menus
    ANALYTICS_ORIGIN["CONTEXTUAL_TOOLBAR"] = "contextualToolbar";
    ANALYTICS_ORIGIN["BLOCK_MENU"] = "blockMenu";
    ANALYTICS_ORIGIN["QUICK_INSERT"] = "quickInsert";
    return ANALYTICS_ORIGIN;
}({});
var $2394c5239b489cef$export$b397791890e3384b = /*#__PURE__*/ function(ANALYTICS_CREATE_SOURCE) {
    ANALYTICS_CREATE_SOURCE["EMPTY_PANEL"] = "snippetPanelEmpty";
    ANALYTICS_CREATE_SOURCE["SNIPPET_PANEL_LIST"] = "snippetPanelCreateItem";
    ANALYTICS_CREATE_SOURCE["HIGHLIGHT_VIEW"] = "snippetHighlightView";
    ANALYTICS_CREATE_SOURCE["HIGHLIGHT_EDIT"] = "snippetHighlightEdit";
    return ANALYTICS_CREATE_SOURCE;
}({});
var $2394c5239b489cef$export$a23e6d34a2dcf281 = /*#__PURE__*/ function(ANALYTICS_PAGE_MODE) {
    ANALYTICS_PAGE_MODE["VIEW"] = "view";
    ANALYTICS_PAGE_MODE["EDIT"] = "edit";
    ANALYTICS_PAGE_MODE["LIVE"] = "live";
    return ANALYTICS_PAGE_MODE;
}({});
var $2394c5239b489cef$export$eeb695ba3667fc27 = /*#__PURE__*/ function(ANALYTICS_UI_SUBJECT) {
    ANALYTICS_UI_SUBJECT["BUTTON"] = "button";
    ANALYTICS_UI_SUBJECT["MODAL"] = "modal";
    ANALYTICS_UI_SUBJECT["TEXT_FIELD"] = "textField";
    ANALYTICS_UI_SUBJECT["DROPDOWN_ITEM"] = "dropdownItem";
    ANALYTICS_UI_SUBJECT["SNIPPETS"] = "snippets";
    return ANALYTICS_UI_SUBJECT;
}({});
var $2394c5239b489cef$export$2fdff18978b1ec73 = /*#__PURE__*/ function(ANALYTICS_UI_ACTION) {
    ANALYTICS_UI_ACTION["CLICKED"] = "clicked";
    ANALYTICS_UI_ACTION["CLOSED"] = "closed";
    ANALYTICS_UI_ACTION["TYPED"] = "typed";
    ANALYTICS_UI_ACTION["VIEWED"] = "viewed";
    return ANALYTICS_UI_ACTION;
}({});
var $2394c5239b489cef$export$f6034aaa561169a2 = /*#__PURE__*/ function(ANALYTICS_UI_SUBJECT_ID) {
    // awareness / screen-viewed (impression)
    ANALYTICS_UI_SUBJECT_ID["SNIPPETS"] = "snippets";
    // button
    ANALYTICS_UI_SUBJECT_ID["CREATE_SNIPPET"] = "createSnippet";
    ANALYTICS_UI_SUBJECT_ID["DELETE_SNIPPET"] = "deleteSnippet";
    ANALYTICS_UI_SUBJECT_ID["EDIT_SNIPPET"] = "editSnippet";
    ANALYTICS_UI_SUBJECT_ID["DUPLICATE_SNIPPET"] = "duplicateSnippet";
    ANALYTICS_UI_SUBJECT_ID["INSERT_SNIPPET"] = "insertSnippet";
    ANALYTICS_UI_SUBJECT_ID["COPY_SNIPPET_LINK"] = "copySnippetLink";
    ANALYTICS_UI_SUBJECT_ID["USE_SNIPPET_DETAIL_PANEL"] = "useSnippetDetailPanel";
    ANALYTICS_UI_SUBJECT_ID["SNIPPET_FAVORITE_TOGGLED"] = "snippetFavoriteToggled";
    // textField / button / dropdownItem (filter-related)
    ANALYTICS_UI_SUBJECT_ID["SNIPPET_CATEGORY_FILTER"] = "snippetCategoryFilter";
    ANALYTICS_UI_SUBJECT_ID["SNIPPET_SEARCH"] = "snippetSearch";
    ANALYTICS_UI_SUBJECT_ID["SNIPPET_SORT_ORDER"] = "snippetSortOrder";
    // FirstSnippetCreatedModal (use attributes for viewed vs dismissed and dismissalAction)
    ANALYTICS_UI_SUBJECT_ID["FIRST_SNIPPET_CREATED_MODAL"] = "firstSnippetCreatedModal";
    // Empty state primary actions
    ANALYTICS_UI_SUBJECT_ID["EMPTY_MY_TEMPLATES_CALL_TO_ACTION"] = "emptyMyTemplatesCallToAction";
    ANALYTICS_UI_SUBJECT_ID["EMPTY_FAVORITES_CALL_TO_ACTION"] = "emptyFavoritesCallToAction";
    return ANALYTICS_UI_SUBJECT_ID;
}({});
var $2394c5239b489cef$export$4d76a1418128341e = /*#__PURE__*/ function(MODAL_TYPE) {
    MODAL_TYPE["CREATE"] = "CREATE";
    MODAL_TYPE["EDIT"] = "EDIT";
    MODAL_TYPE["DUPLICATE"] = "DUPLICATE";
    return MODAL_TYPE;
}({});
var $2394c5239b489cef$export$42a4ee1a85ef55d2 = /*#__PURE__*/ function(MODAL_OUTCOME) {
    MODAL_OUTCOME["CREATED"] = "created";
    MODAL_OUTCOME["EDITED"] = "edited";
    MODAL_OUTCOME["DUPLICATED"] = "duplicated";
    MODAL_OUTCOME["DELETED"] = "deleted";
    MODAL_OUTCOME["CANCELLED"] = "cancelled";
    MODAL_OUTCOME["CLOSED"] = "closed";
    return MODAL_OUTCOME;
}({});
var $2394c5239b489cef$export$3c94fecf7ead2464 = /*#__PURE__*/ function(ANALYTICS_OPERATIONAL_SUBJECT) {
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_FAVORITE_TOGGLED"] = "snippetFavoriteToggled";
    // API failures
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_INSERT"] = "snippetApiInsert";
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_CREATE"] = "snippetApiCreate";
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_DUPLICATE"] = "snippetApiDuplicate";
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_UPDATE"] = "snippetApiUpdate";
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_DELETE"] = "snippetApiDelete";
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_FETCH"] = "snippetApiFetch";
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_SHARE"] = "snippetApiShare";
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_UNSHARE"] = "snippetApiUnshare";
    // API successes
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_SAVE_SUCCESS"] = "snippetApiSaveSuccess";
    // AI metadata
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_API_AI_METADATA"] = "snippetApiAiMetadata";
    // Client-side errors
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_ADF_SERIALIZATION"] = "snippetAdfSerialization";
    ANALYTICS_OPERATIONAL_SUBJECT["SNIPPET_PREVIEW_RENDER"] = "snippetPreviewRender";
    return ANALYTICS_OPERATIONAL_SUBJECT;
}({});
var $2394c5239b489cef$export$2fd2c1b71075f9e9 = /*#__PURE__*/ function(ANALYTICS_OPERATIONAL_ACTION) {
    ANALYTICS_OPERATIONAL_ACTION["FAILED"] = "failed";
    ANALYTICS_OPERATIONAL_ACTION["SUCCEEDED"] = "succeeded";
    ANALYTICS_OPERATIONAL_ACTION["FETCHED"] = "fetched";
    return ANALYTICS_OPERATIONAL_ACTION;
}({});
var $2394c5239b489cef$export$335c9007c17c491f = /*#__PURE__*/ function(INSERT_SNIPPET_FAILURE_REASON) {
    /** An exception was thrown while executing the editor insert transaction. */ INSERT_SNIPPET_FAILURE_REASON["INSERT_EXCEPTION"] = "insertException";
    return INSERT_SNIPPET_FAILURE_REASON;
}({});
var $2394c5239b489cef$export$83cc695078256a23 = /*#__PURE__*/ function(CREATE_SNIPPET_FAILURE_REASON) {
    /** The create request was rejected because the body exceeded the size limit (HTTP 400). */ CREATE_SNIPPET_FAILURE_REASON["BODY_TOO_LARGE"] = "bodyTooLarge";
    /** The create succeeded server-side but the returned payload could not be transformed. */ CREATE_SNIPPET_FAILURE_REASON["TRANSFORM_FAILED"] = "transformFailed";
    /** The Block Service rejected the create request with an HTTP error status. */ CREATE_SNIPPET_FAILURE_REASON["CREATE_EXCEPTION"] = "createException";
    /** Any other / unclassified create failure (e.g. a non-HTTP runtime error). */ CREATE_SNIPPET_FAILURE_REASON["UNKNOWN"] = "unknown";
    return CREATE_SNIPPET_FAILURE_REASON;
}({});
var $2394c5239b489cef$export$e064e1caab5da8a2 = /*#__PURE__*/ function(FETCH_SNIPPET_FAILURE_REASON) {
    /** The requested snippet resource was not found (HTTP 404). */ FETCH_SNIPPET_FAILURE_REASON["NOT_FOUND"] = "notFound";
    /** The caller was not authorised to read the scope (HTTP 401 / 403). */ FETCH_SNIPPET_FAILURE_REASON["FORBIDDEN"] = "forbidden";
    /** The fetch timed out or was aborted (HTTP 408 or an abort/timeout error). */ FETCH_SNIPPET_FAILURE_REASON["TIMEOUT"] = "timeout";
    /** Any other HTTP error status (e.g. 5xx, 400) returned by the Block Service. */ FETCH_SNIPPET_FAILURE_REASON["FETCH_EXCEPTION"] = "fetchException";
    /** A non-HTTP / unclassified fetch failure (e.g. a runtime error with no status). */ FETCH_SNIPPET_FAILURE_REASON["UNKNOWN"] = "unknown";
    return FETCH_SNIPPET_FAILURE_REASON;
}({});
var $2394c5239b489cef$export$81f6ba2af7de9934 = /*#__PURE__*/ function(ANALYTICS_TRACK_SUBJECT) {
    ANALYTICS_TRACK_SUBJECT["SNIPPET_API_SHARE_CLAIM"] = "snippetApiShareClaim";
    return ANALYTICS_TRACK_SUBJECT;
}({});
var $2394c5239b489cef$export$986b2565e3fbcaf4 = /*#__PURE__*/ function(ANALYTICS_TRACK_ACTION) {
    ANALYTICS_TRACK_ACTION["CLAIMED"] = "claimed";
    return ANALYTICS_TRACK_ACTION;
}({});
module.exports["ANALYTICS_EVENT_TYPE"] = $2394c5239b489cef$export$a0913705d36eb84c;
module.exports["ANALYTICS_TYPE"] = $2394c5239b489cef$export$17897eee0c3e7eb1;
module.exports["ANALYTICS_SOURCE"] = $2394c5239b489cef$export$f7109619a5e9e0d6;
module.exports["ANALYTICS_ORIGIN"] = $2394c5239b489cef$export$8dd55f56fde129aa;
module.exports["ANALYTICS_CREATE_SOURCE"] = $2394c5239b489cef$export$b397791890e3384b;
module.exports["ANALYTICS_PAGE_MODE"] = $2394c5239b489cef$export$a23e6d34a2dcf281;
module.exports["ANALYTICS_UI_SUBJECT"] = $2394c5239b489cef$export$eeb695ba3667fc27;
module.exports["ANALYTICS_UI_ACTION"] = $2394c5239b489cef$export$2fdff18978b1ec73;
module.exports["ANALYTICS_UI_SUBJECT_ID"] = $2394c5239b489cef$export$f6034aaa561169a2;
module.exports["MODAL_TYPE"] = $2394c5239b489cef$export$4d76a1418128341e;
module.exports["MODAL_OUTCOME"] = $2394c5239b489cef$export$42a4ee1a85ef55d2;
module.exports["ANALYTICS_OPERATIONAL_SUBJECT"] = $2394c5239b489cef$export$3c94fecf7ead2464;
module.exports["ANALYTICS_OPERATIONAL_ACTION"] = $2394c5239b489cef$export$2fd2c1b71075f9e9;
module.exports["INSERT_SNIPPET_FAILURE_REASON"] = $2394c5239b489cef$export$335c9007c17c491f;
module.exports["CREATE_SNIPPET_FAILURE_REASON"] = $2394c5239b489cef$export$83cc695078256a23;
module.exports["FETCH_SNIPPET_FAILURE_REASON"] = $2394c5239b489cef$export$e064e1caab5da8a2;
module.exports["ANALYTICS_TRACK_SUBJECT"] = $2394c5239b489cef$export$81f6ba2af7de9934;
module.exports["ANALYTICS_TRACK_ACTION"] = $2394c5239b489cef$export$986b2565e3fbcaf4;

});

parcelRegister("bUH8D", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1VhsF = parcelRequire("1VhsF");


var $8aF6s = parcelRequire("8aF6s");


var $7aRa9 = parcelRequire("7aRa9");


var $5vi32 = parcelRequire("5vi32");


var $ivb8S = parcelRequire("ivb8S");


var $bEwOV = parcelRequire("bEwOV");


var $hPTbh = parcelRequire("hPTbh");


var $cgy0A = parcelRequire("cgy0A");


var $jxXkP = parcelRequire("jxXkP");


var $8JRDD = parcelRequire("8JRDD");


var $8yRiX = parcelRequire("8yRiX");


var $eWCeD = parcelRequire("eWCeD");


var $dZUkS = parcelRequire("dZUkS");


var $ies1q = parcelRequire("ies1q");


var $2u5FB = parcelRequire("2u5FB");


var $6K2yS = parcelRequire("6K2yS");


var $aNHzZ = parcelRequire("aNHzZ");


var $d3Wxa = parcelRequire("d3Wxa");


var $jU9SA = parcelRequire("jU9SA");

const $e0d6fa0d5e247589$var$FORM_KEY = 'create-snippet';
const $e0d6fa0d5e247589$var$CreateSnippetModalWithFlags = (t0)=>{
    const $ = (0, $bDgLe.c)(37);
    const { onClose: onClose, onCloseComplete: onCloseComplete, adf: adf, contentId: contentId, spaceId: spaceId, spaceKey: spaceKey, flags: flags, editorAPI: editorAPI, analyticsOrigin: analyticsOrigin, createSource: createSource } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const openSnippetPanel = (0, $8yRiX.useOpenSnippetPanel)();
    const { isSnippetSharingForSiteEnabled: t1 } = (0, $dZUkS.useSnippetsState)();
    const isSnippetSharingForSiteEnabled = t1 === undefined ? false : t1;
    const snippetsActions = (0, $dZUkS.useSnippetsActions)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { fireFailedAnalytic: fireFailedAnalytic, fireSuccessAnalytic: fireSuccessAnalytic } = (0, $jxXkP.useSnippetAnalytics)((0, $hPTbh.ANALYTICS_ORIGIN).CREATE_SNIPPET_MODAL);
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const handleCloseBase = (0, $8JRDD.useSnippetModalClose)(onClose, (0, $hPTbh.ANALYTICS_ORIGIN).CREATE_SNIPPET_MODAL, (0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).CREATE_SNIPPET);
    let t2;
    if ($[0] !== createSource || $[1] !== handleCloseBase) {
        t2 = (attrs)=>{
            handleCloseBase({
                ...attrs,
                createSource: createSource
            });
        };
        $[0] = createSource;
        $[1] = handleCloseBase;
        $[2] = t2;
    } else t2 = $[2];
    const handleClose = t2;
    const { isAiSuggestionLoading: isAiSuggestionLoading, aiSuggestedName: aiSuggestedName, aiSuggestedDescription: aiSuggestedDescription } = (0, $cgy0A.useAiSuggestions)(adf, (0, $hPTbh.ANALYTICS_ORIGIN).CREATE_SNIPPET_MODAL);
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [
            (0, $bEwOV.SNIPPETS_ONBOARDING).HAS_SEEN_FIRST_SNIPPET_CREATED_MODAL
        ];
        $[3] = t3;
    } else t3 = $[3];
    const { data: onboardingData, loading: onboardingLoading, error: onboardingError } = (0, $ivb8S.useGetOnboardingState)(t3, false);
    let t4;
    if ($[4] !== onboardingData) {
        t4 = (0, $ivb8S.deserializeState)(onboardingData);
        $[4] = onboardingData;
        $[5] = t4;
    } else t4 = $[5];
    const { hasSeenFirstSnippetCreatedModal: hasSeenFirstSnippetCreatedModal } = t4;
    let T0;
    let t5;
    if ($[6] !== adf || $[7] !== aiSuggestedDescription || $[8] !== aiSuggestedName || $[9] !== analyticsOrigin || $[10] !== contentId || $[11] !== createSource || $[12] !== editorAPI || $[13] !== fireFailedAnalytic || $[14] !== fireSuccessAnalytic || $[15] !== flags || $[16] !== handleClose || $[17] !== hasSeenFirstSnippetCreatedModal || $[18] !== intl || $[19] !== isAiSuggestionLoading || $[20] !== isEmbeddedConfluence || $[21] !== isSnippetSharingForSiteEnabled || $[22] !== onCloseComplete || $[23] !== onboardingError || $[24] !== onboardingLoading || $[25] !== openSnippetPanel || $[26] !== showModal || $[27] !== snippetsActions || $[28] !== spaceId || $[29] !== spaceKey) {
        const baseDefaultValues = (0, $aNHzZ.getDefaultFormValues)(isSnippetSharingForSiteEnabled);
        const defaultValues = {
            ...baseDefaultValues,
            snippetName: aiSuggestedName ?? baseDefaultValues.snippetName,
            snippetDescription: aiSuggestedDescription ?? baseDefaultValues.snippetDescription
        };
        const initialAdf = (0, $ies1q.wrapAdfWithDocNode)(adf);
        const isSyncBlockSource = (0, $ies1q.adfContainsNodeType)(initialAdf, "bodiedSyncBlock");
        let t6;
        if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $jU9SA.createSnippetModalMessages).titleCreate);
            $[32] = t6;
        } else t6 = $[32];
        const title = t6;
        let t7;
        if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $jU9SA.createSnippetModalMessages).createButton);
            $[33] = t7;
        } else t7 = $[33];
        const submitLabel = t7;
        const successFlagActions = analyticsOrigin === (0, $hPTbh.ANALYTICS_ORIGIN).SNIPPET_GALLERY ? undefined : [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6K2yS.messages).successFlagViewTemplateAction),
                onClick: openSnippetPanel
            }
        ];
        const onSubmit = async (values, currentAdf)=>{
            const bodySize = JSON.stringify(currentAdf).length;
            const isOnboardingStateReady = !onboardingLoading && !onboardingError;
            const shouldShowFirstSnippetCreatedModal = !isEmbeddedConfluence && isOnboardingStateReady && !hasSeenFirstSnippetCreatedModal;
            const newSnippet = await snippetsActions.createSnippet(values.snippetName, currentAdf, values.snippetDescription, {
                flags: flags,
                intl: intl,
                editorAPI: editorAPI ?? undefined,
                isShared: values.isShared,
                successFlagActions: successFlagActions,
                showSuccessFlag: !shouldShowFirstSnippetCreatedModal,
                onShareFailure: (snippetId)=>fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_SHARE, {
                        snippetId: snippetId
                    }),
                onSaveFailure: (error)=>{
                    const isBodyTooLarge = (0, $eWCeD.isBodyTooLargeError)(error);
                    fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_CREATE, {
                        ...isBodyTooLarge && {
                            isBodyTooLarge: true,
                            bodySize: bodySize
                        }
                    });
                },
                messages: {
                    successFlagTitle: (0, $jU9SA.createSnippetModalMessages).successFlagTitle,
                    errorFlagTitle: (0, $jU9SA.createSnippetModalMessages).errorFlagTitle,
                    errorFlagDescription: (0, $jU9SA.createSnippetModalMessages).errorFlagDescription
                }
            });
            if (newSnippet) {
                const wasNameSuggestedByAi = aiSuggestedName !== null;
                const wasDescriptionSuggestedByAi = aiSuggestedDescription !== null;
                fireSuccessAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_SAVE_SUCCESS, {
                    snippetId: newSnippet.snippetId,
                    bodySize: bodySize,
                    modalType: (0, $hPTbh.MODAL_TYPE).CREATE,
                    templateType: newSnippet.templateType,
                    createSource: createSource
                });
                handleClose({
                    outcome: (0, $hPTbh.MODAL_OUTCOME).CREATED,
                    snippetId: newSnippet.snippetId,
                    bodySize: bodySize,
                    templateType: newSnippet.templateType,
                    wasNameSuggestedByAi: wasNameSuggestedByAi,
                    ...wasNameSuggestedByAi && {
                        nameKeptAsSuggested: values.snippetName === aiSuggestedName
                    },
                    wasDescriptionSuggestedByAi: wasDescriptionSuggestedByAi,
                    ...wasDescriptionSuggestedByAi && {
                        descriptionKeptAsSuggested: values.snippetDescription === aiSuggestedDescription
                    },
                    createSource: createSource
                });
                if (shouldShowFirstSnippetCreatedModal) showModal((0, $d3Wxa.FirstSnippetCreatedModal), {});
            }
        };
        const formWarning = isSyncBlockSource ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
            appearance: "warning"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $jU9SA.createSnippetModalMessages).syncBlockSourceWarning)) : undefined;
        T0 = (0, $2u5FB.SnippetBaseModal);
        t5 = (0, $2u5FB.getSnippetBaseModalProps)({
            title: title,
            submitLabel: submitLabel,
            formKey: $e0d6fa0d5e247589$var$FORM_KEY,
            defaultValues: defaultValues,
            initialAdf: initialAdf,
            onSubmit: onSubmit,
            handleClose: handleClose,
            fireFailedAnalytic: fireFailedAnalytic,
            onCloseComplete: onCloseComplete,
            contentId: contentId,
            spaceId: spaceId,
            spaceKey: spaceKey,
            isSnippetSharingForSiteEnabled: isSnippetSharingForSiteEnabled,
            isAiSuggestionLoading: isAiSuggestionLoading,
            formWarning: formWarning
        });
        $[6] = adf;
        $[7] = aiSuggestedDescription;
        $[8] = aiSuggestedName;
        $[9] = analyticsOrigin;
        $[10] = contentId;
        $[11] = createSource;
        $[12] = editorAPI;
        $[13] = fireFailedAnalytic;
        $[14] = fireSuccessAnalytic;
        $[15] = flags;
        $[16] = handleClose;
        $[17] = hasSeenFirstSnippetCreatedModal;
        $[18] = intl;
        $[19] = isAiSuggestionLoading;
        $[20] = isEmbeddedConfluence;
        $[21] = isSnippetSharingForSiteEnabled;
        $[22] = onCloseComplete;
        $[23] = onboardingError;
        $[24] = onboardingLoading;
        $[25] = openSnippetPanel;
        $[26] = showModal;
        $[27] = snippetsActions;
        $[28] = spaceId;
        $[29] = spaceKey;
        $[30] = T0;
        $[31] = t5;
    } else {
        T0 = $[30];
        t5 = $[31];
    }
    let t6;
    if ($[34] !== T0 || $[35] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, t5);
        $[34] = T0;
        $[35] = t5;
        $[36] = t6;
    } else t6 = $[36];
    return t6;
};
const $e0d6fa0d5e247589$export$3336f6e2bcd88a3e = (0, $7aRa9.withFlags)($e0d6fa0d5e247589$var$CreateSnippetModalWithFlags);
module.exports["CreateSnippetModal"] = $e0d6fa0d5e247589$export$3336f6e2bcd88a3e;

});

parcelRegister("7aRa9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $cozmU.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("5vi32", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lTECB = parcelRequire("lTECB");


var $7zgzO = parcelRequire("7zgzO");

function $36802f16e927d19b$export$c850f609dc850980() {
    const { location: location } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    return (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)(location || window.location);
}
module.exports["useIsEmbeddedConfluence_DO_NOT_USE"] = $36802f16e927d19b$export$c850f609dc850980;

});

parcelRegister("ivb8S", function(module, exports) {

var $209pV = parcelRequire("209pV");


var $cozmU = parcelRequire("cozmU");


var $7Sm4c = parcelRequire("7Sm4c");


var $8Lx5S = parcelRequire("8Lx5S");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $cbOce = parcelRequire("cbOce");


var $1cHqV = parcelRequire("1cHqV");


var $8Z78B = parcelRequire("8Z78B");


var $308Wd = parcelRequire("308Wd");


var $ij4CE = parcelRequire("ij4CE");

const $6fc4b7bb962289cc$var$isOnboardingStateEqual = (a, b)=>{
    if (a === b) return true;
    if (!a || !b) return !a && !b;
    if (a.length !== b.length) return false;
    return a.every((item, i)=>item.key === b[i].key && item.value === b[i].value);
};
// Hook to check if we're on a view page route
const $6fc4b7bb962289cc$var$useIsViewPageRoute = ()=>(0, $dPJCf.useRouteName)({
        selector: (routeName)=>routeName === (0, $1NBp8.VIEW_PAGE).name || routeName === (0, $1NBp8.VIEW_BLOG).name || routeName === (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name
    });
// Get the combined onboarding state from cache, returns null if not cached
const $6fc4b7bb962289cc$var$getCombinedQueryFromCache = ()=>{
    try {
        return (0, $l1uFv.readQueryInterop)({
            query: (0, $8Z78B.default),
            variables: {
                key: []
            },
            __callerPackage__: "onboarding-helpers"
        });
    } catch  {
        return null;
    }
};
// Updates the combined query cache with new onboarding state values.
// This ensures components using the centralized cache see updates on next mount/navigation.
const $6fc4b7bb962289cc$var$updateCombinedQueryCache = (updatedStates)=>{
    if (!(0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false)) return;
    const currentData = $6fc4b7bb962289cc$var$getCombinedQueryFromCache();
    if (!currentData?.onboardingState) return;
    const updatedMap = new Map(updatedStates.map((s)=>[
            s.key,
            s.value
        ]));
    const newOnboardingState = currentData.onboardingState.map((item)=>updatedMap.has(item.key) ? {
            ...item,
            value: updatedMap.get(item.key) ?? item.value
        } : item);
    (0, $fEmGS.writeQueryInterop)({
        query: (0, $8Z78B.default),
        variables: {
            key: []
        },
        data: {
            onboardingState: newOnboardingState
        },
        __callerPackage__: "onboarding-helpers"
    });
};
const $6fc4b7bb962289cc$export$7ca8667598519375 = (data)=>{
    const state = {};
    // new graphQL call returns onboardingState array
    const { onboardingState: onboardingState } = data || {};
    // parse data and populate state accordingly
    if (onboardingState !== undefined && onboardingState !== null) for (const { key: key, value: value } of onboardingState){
        // key comes back as "{prefix}:{property}" format
        // split by ':' to get parsed {property}
        // some keys don't have a prefix, which is why we have the ||
        const parsedKey = key.split(':')[1] || key;
        if (!value) continue;
        if (/(true|false)/g.test(value)) state[parsedKey] = value === 'true';
        else state[parsedKey] = value;
    }
    return state;
};
const $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf = ()=>{
    const [setState, { error: error, called: called }] = (0, $308Wd.useMutationInterop)((0, $209pV.default), {
        update (_cache, { data: data }) {
            const states = data.setOnboardingState;
            (states ?? []).forEach(({ key: key, value: value })=>{
                // writeFragment can only handle a single data item at a time
                (0, $ij4CE.writeFragmentInterop)({
                    fragmentId: `OnboardingState:${key}`,
                    data: {
                        key: key,
                        value: value ?? null,
                        __typename: 'OnboardingState'
                    },
                    __callerPackage__: "onboarding-helpers"
                });
            });
            // Update the combined query cache for centralized onboarding state
            $6fc4b7bb962289cc$var$updateCombinedQueryCache(states ?? []);
        },
        onError: (error)=>{
            if ((0, $cbOce.isExpectedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "onboarding-helpers"
    });
    const setOnboardingState = (0, $cozmU.useCallback)((newOnboardingState)=>{
        let states;
        if (Array.isArray(newOnboardingState)) // supports batch updates
        states = newOnboardingState;
        else // backwards compability for single key-value pair
        states = [
            newOnboardingState
        ];
        setState({
            variables: {
                states: states
            },
            optimisticResponse: {
                setOnboardingState: states.map(({ key: key, value: value })=>({
                        key: key,
                        value: value,
                        __typename: 'OnboardingState'
                    }))
            }
        });
    }, [
        setState
    ]);
    return {
        setOnboardingState: setOnboardingState,
        error: error,
        called: called
    };
};
// safeguards against empty arrays or strings
const $6fc4b7bb962289cc$var$hasValidKeysToFetch = (key)=>{
    if (Array.isArray(key)) return key.length > 0;
    if (typeof key === 'string') return key.length > 0;
    return false;
};
const $6fc4b7bb962289cc$export$d5e7611ac338ec84 = (key, skip = false, reactive = true)=>{
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const isAllowed = isLicensed || isGuest;
    const isViewPageRoute = $6fc4b7bb962289cc$var$useIsViewPageRoute();
    const hasKeysToFetch = $6fc4b7bb962289cc$var$hasValidKeysToFetch(key);
    const skipQuery = skip || !isAllowed || !hasKeysToFetch;
    // Check if centralized cache should be used (experiment enabled + on view page route)
    const useCentralizedCache = isViewPageRoute && (0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false);
    // For non-reactive mode: read from cache once (no subscription)
    // This is a one-time synchronous read that doesn't trigger re-renders on cache changes
    const cachedCombinedData = !reactive && useCentralizedCache ? $6fc4b7bb962289cc$var$getCombinedQueryFromCache() : null;
    const hasCachedCombinedData = cachedCombinedData !== null;
    // For reactive mode: use useQueryInterop with cache-only to subscribe to cache changes
    // This subscribes to the centralized cache and re-renders when it changes (no network requests)
    const { data: reactiveCacheData, error: reactiveCacheError, loading: reactiveCacheLoading } = (0, $jMyy4.useQueryInterop)((0, $8Z78B.default), {
        variables: {
            key: []
        },
        skip: skipQuery || !reactive || !useCentralizedCache,
        fetchPolicy: 'cache-only',
        __callerPackage__: "onboarding-helpers"
    });
    // Memoize the filtered reactive cache result so filterOnboardingState is only called
    // when reactiveCacheData or key actually changes — not on every render.
    //
    // We must not skip the fallback just because reactiveCacheData is truthy — the centralized
    // cache may not contain the specific keys this consumer requested (e.g. the preload fetched
    // a different set of keys). We only skip the fallback when the filtered reactive cache data
    // actually has entries for the requested keys.
    const { reactiveFilteredData: reactiveFilteredData, reactiveFilteredHasData: reactiveFilteredHasData } = (0, $cozmU.useMemo)(()=>{
        if (!(reactive && useCentralizedCache && reactiveCacheData)) return {
            reactiveFilteredData: null,
            reactiveFilteredHasData: false
        };
        const filtered = (0, $1cHqV.filterOnboardingState)(reactiveCacheData, key);
        return {
            reactiveFilteredData: filtered,
            reactiveFilteredHasData: (filtered?.onboardingState?.length ?? 0) > 0
        };
    }, [
        reactive,
        useCentralizedCache,
        reactiveCacheData,
        key
    ]);
    const { data: fallbackQueryData, error: fallbackError, loading: fallbackLoading, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $8Z78B.default), {
        variables: {
            key: key
        },
        skip: skipQuery || hasCachedCombinedData || reactiveFilteredHasData,
        __callerPackage__: "onboarding-helpers"
    });
    // Determine which data source to use:
    // 1. Non-reactive with cached data: use cachedCombinedData (filtered)
    // 2. Reactive with centralized cache and keys found: use reactiveFilteredData
    // 3. Fallback: use fallbackQueryData
    // For reactive path: skip re-render if filtered data for our keys hasn't changed
    const prevFilteredDataRef = (0, $cozmU.useRef)(undefined);
    const data = (0, $cozmU.useMemo)(()=>{
        if (hasCachedCombinedData) return (0, $1cHqV.filterOnboardingState)(cachedCombinedData, key);
        if (reactiveFilteredHasData && reactiveFilteredData) {
            if (prevFilteredDataRef.current && $6fc4b7bb962289cc$var$isOnboardingStateEqual(prevFilteredDataRef.current.onboardingState, reactiveFilteredData.onboardingState)) return prevFilteredDataRef.current;
            prevFilteredDataRef.current = reactiveFilteredData;
            return reactiveFilteredData;
        }
        return fallbackQueryData;
    }, [
        hasCachedCombinedData,
        cachedCombinedData,
        reactiveFilteredHasData,
        reactiveFilteredData,
        fallbackQueryData,
        key
    ]);
    // Combine error and loading states from both queries
    const error = reactiveCacheError || fallbackError;
    // When centralized cache is enabled in reactive mode but the preload hasn't populated
    // the cache yet, cache-only returns loading: false with data: undefined. Without this
    // guard, consumers interpret undefined data as "user never saw this onboarding" and
    // incorrectly show spotlights/changeboarding that was already dismissed.
    // We report loading: true until either the reactive cache or fallback has actual data.
    //
    // Also guard the case where the reactive cache is populated but doesn't contain the
    // specific keys this consumer requested (reactiveFilteredHasData is false). In that
    // scenario the fallback query has been allowed to run — keep loading: true until it
    // either returns data or an error, so consumers don't prematurely see empty state.
    const isCentralizedCacheWaitingForPreload = reactive && useCentralizedCache && (!reactiveCacheData || !reactiveFilteredHasData) && !fallbackQueryData && !skipQuery && !reactiveCacheError && !fallbackError;
    const loading = isCentralizedCacheWaitingForPreload || (reactive && useCentralizedCache ? reactiveCacheLoading : false) || fallbackLoading;
    return {
        data: data,
        error: error,
        loading: loading,
        refetch: refetch
    };
};
module.exports["deserializeState"] = $6fc4b7bb962289cc$export$7ca8667598519375;
module.exports["useSetOnboardingState"] = $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf;
module.exports["useGetOnboardingState"] = $6fc4b7bb962289cc$export$d5e7611ac338ec84;

});

parcelRegister("209pV", function(module, exports) {
/**
 * @generated SignedSource<<a83598c413cebc1d8cb2388f4b0ca41c>>
 * @relayHash 3faa5f50f8c511a1bae008881ee58062
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed
const $4f605ad876f6c5d9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "states"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "states",
                    "variableName": "states"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "setOnboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3faa5f50f8c511a1bae008881ee58062",
            "id": "1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed",
            "metadata": {},
            "name": "onboardingStateSetOnboardingStateMutation",
            "operationKind": "mutation",
            "text": "mutation onboardingStateSetOnboardingStateMutation($states:[OnboardingStateInput!]!){setOnboardingState(states:$states){key,value}}"
        }
    };
}();
$4f605ad876f6c5d9$var$node.hash = "90b0af82da00eefb44f28228419e7c9e";
var $4f605ad876f6c5d9$export$2e2bcd8739ae039 = $4f605ad876f6c5d9$var$node;
module.exports["default"] = $4f605ad876f6c5d9$export$2e2bcd8739ae039;

});

parcelRegister("8Lx5S", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

/**
 * Checks if the user has any licensed access (either admin or use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin or use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensed = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user has licensed admin access.
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin access, otherwise false.
 */ const $30f02aa82d7102bc$var$isAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
};
/**
 * Checks if the user has licensed non-admin access (use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensedNonAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user is a guest (external collaborator).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user is an external collaborator, otherwise false.
 */ const $30f02aa82d7102bc$var$isGuest = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
};
const $30f02aa82d7102bc$export$ac4f65b11c57a33b = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensed(accessStatus);
};
const $30f02aa82d7102bc$export$99a5e4bc80d231ca = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$a67466804611d2db = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$f9ffae90e66d63e = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isGuest(accessStatus);
};
const $30f02aa82d7102bc$export$41f8700aabec6a40 = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isGuest: $30f02aa82d7102bc$var$isGuest(accessStatus),
        isLicensed: $30f02aa82d7102bc$var$isLicensed(accessStatus),
        isAdmin: $30f02aa82d7102bc$var$isAdmin(accessStatus),
        isLicensedNonAdmin: $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus)
    };
};
module.exports["useIsLicensed"] = $30f02aa82d7102bc$export$ac4f65b11c57a33b;
module.exports["useIsAdmin"] = $30f02aa82d7102bc$export$99a5e4bc80d231ca;
module.exports["useIsGuest"] = $30f02aa82d7102bc$export$f9ffae90e66d63e;
module.exports["useAccessStatus"] = $30f02aa82d7102bc$export$41f8700aabec6a40;

});

parcelRegister("cbOce", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $1uFM6 = parcelRequire("1uFM6");

function $2f49c1e50cca9335$export$8715824c16ceeca0(error) {
    const isUnauthorized = error?.graphQLErrors?.[0]?.message === 'unauthorized' || (0, $1uFM6.isUnauthorizedError)(error);
    return isUnauthorized || (0, $6fil2.containsNetworkError)(error);
}
module.exports["isExpectedError"] = $2f49c1e50cca9335$export$8715824c16ceeca0;

});

parcelRegister("1cHqV", function(module, exports) {
// Cache for filtered onboarding state results.
// Uses WeakMap keyed by data object (auto-clears when data is garbage collected),
// with nested Map keyed by keys string for O(1) lookup.
const $e7b7b792910c4288$var$filteredStateCache = new WeakMap();
/**
 * Creates a cache key from the requested keys.
 */ const $e7b7b792910c4288$var$createCacheKey = (keys)=>{
    return Array.isArray(keys) ? keys.join(',') : keys;
};
/**
 * Performs the actual filtering of onboarding state data.
 */ const $e7b7b792910c4288$var$filterData = (data, requestedKeys)=>{
    const keysArray = Array.isArray(requestedKeys) ? requestedKeys : [
        requestedKeys
    ];
    const keySet = new Set(keysArray);
    return {
        ...data,
        onboardingState: data.onboardingState?.filter(({ key: key })=>{
            // Check both the full key and the parsed key (without prefix)
            // Keys come back as "{prefix}:{property}" format
            const parsedKey = key.split(':')[1] || key;
            return keySet.has(key) || keySet.has(parsedKey);
        })
    };
};
const $e7b7b792910c4288$export$c1dd389f39afa62f = (data, requestedKeys)=>{
    if (!data?.onboardingState) // Convert null to undefined to maintain backward compatibility with consumers
    // that expect `T | undefined` rather than `T | null | undefined`
    return data ?? undefined;
    const cacheKey = $e7b7b792910c4288$var$createCacheKey(requestedKeys);
    let dataCache = $e7b7b792910c4288$var$filteredStateCache.get(data);
    if (!dataCache) {
        dataCache = new Map();
        $e7b7b792910c4288$var$filteredStateCache.set(data, dataCache);
    }
    if (dataCache.has(cacheKey)) return dataCache.get(cacheKey);
    const filteredResult = $e7b7b792910c4288$var$filterData(data, requestedKeys);
    dataCache.set(cacheKey, filteredResult);
    return filteredResult;
};
module.exports["filterOnboardingState"] = $e7b7b792910c4288$export$c1dd389f39afa62f;

});

parcelRegister("8Z78B", function(module, exports) {
/**
 * @generated SignedSource<<abe1bfe242e74d4385961078bad185f8>>
 * @relayHash 56e1784a86c45537dbf4ab9c8bb1ffba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7
const $38160060fa19c5ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "key"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "key"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "onboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "56e1784a86c45537dbf4ab9c8bb1ffba",
            "id": "3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7",
            "metadata": {},
            "name": "onboardingStateGetOnboardingStateQuery",
            "operationKind": "query",
            "text": "query onboardingStateGetOnboardingStateQuery($key:[String]){onboardingState(key:$key){key,value}}"
        }
    };
}();
$38160060fa19c5ea$var$node.hash = "201bff99b2bdca3d23c658876502ced3";
var $38160060fa19c5ea$export$2e2bcd8739ae039 = $38160060fa19c5ea$var$node;
module.exports["default"] = $38160060fa19c5ea$export$2e2bcd8739ae039;

});

parcelRegister("bEwOV", function(module, exports) {
const $91bce0a19c17c87b$export$608e762b0e8c3e5d = {
    HAS_SEEN_FIRST_SNIPPET_CREATED_MODAL: 'snippets:hasSeenFirstSnippetCreatedModal',
    HAS_SEEN_SNIPPETS_TAB_SPOTLIGHT: 'snippets:hasSeenSnippetsTabSpotlight'
};
const $91bce0a19c17c87b$export$cf7ec9d4d7075704 = [
    ...Object.values($91bce0a19c17c87b$export$608e762b0e8c3e5d)
];
module.exports["SNIPPETS_ONBOARDING"] = $91bce0a19c17c87b$export$608e762b0e8c3e5d;
module.exports["SnippetsOnboardingKeys"] = $91bce0a19c17c87b$export$cf7ec9d4d7075704;

});

parcelRegister("cgy0A", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $hPTbh = parcelRequire("hPTbh");


var $jxXkP = parcelRequire("jxXkP");


var $7u3UL = parcelRequire("7u3UL");


var $ies1q = parcelRequire("ies1q");


var $aUBmi = parcelRequire("aUBmi");

function $4d538ba06d23224f$var$pickBestSuggestion(suggestions) {
    return suggestions.reduce((a, b)=>a.confidence >= b.confidence ? a : b);
}
function $4d538ba06d23224f$var$serializeAdf(adf) {
    return JSON.stringify((0, $ies1q.wrapAdfWithDocNode)(adf));
}
function $4d538ba06d23224f$export$fbb5229d7f17a968(adf, origin) {
    const $ = (0, $bDgLe.c)(10);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { fireFailedAnalytic: fireFailedAnalytic, fireSuccessAnalytic: fireSuccessAnalytic } = (0, $jxXkP.useSnippetAnalytics)(origin);
    const [isAiSuggestionLoading, setIsAiSuggestionLoading] = (0, $cozmU.useState)(false);
    const [aiSuggestedName, setAiSuggestedName] = (0, $cozmU.useState)(null);
    const [aiSuggestedDescription, setAiSuggestedDescription] = (0, $cozmU.useState)(null);
    let t0;
    let t1;
    if ($[0] !== adf || $[1] !== cloudId || $[2] !== fireFailedAnalytic || $[3] !== fireSuccessAnalytic) {
        t0 = ()=>{
            let isStale = false;
            if (!(0, $9wGTI.fg)("platform_editor_blocks_ai_metadata_enabled")) return;
            if (!adf || !cloudId) {
                setIsAiSuggestionLoading(false);
                return;
            }
            setIsAiSuggestionLoading(true);
            const startTime = performance.now();
            const adfContent = $4d538ba06d23224f$var$serializeAdf(adf);
            const adfBodySize = adfContent.length;
            $7u3UL.fetchSnippetMetadata({
                adfContent: adfContent
            }, cloudId).then((response)=>{
                const durationMs = Math.round(performance.now() - startTime);
                const suggestionCount = response.suggestions?.length ?? 0;
                if (!suggestionCount) {
                    fireSuccessAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_AI_METADATA, {
                        suggestionCount: 0,
                        adfBodySize: adfBodySize,
                        durationMs: durationMs
                    });
                    return;
                }
                const bestSuggestion = $4d538ba06d23224f$var$pickBestSuggestion(response.suggestions);
                fireSuccessAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_AI_METADATA, {
                    suggestionCount: suggestionCount,
                    confidences: response.suggestions.map($4d538ba06d23224f$var$_temp),
                    suggestedNameLength: bestSuggestion.name?.length ?? 0,
                    suggestedDescriptionLength: bestSuggestion.description?.length ?? 0,
                    adfBodySize: adfBodySize,
                    durationMs: durationMs
                });
                if (isStale) return;
                setAiSuggestedName(bestSuggestion.name ?? "");
                setAiSuggestedDescription(bestSuggestion.description ?? "");
            }).catch((error)=>{
                const durationMs_0 = Math.round(performance.now() - startTime);
                fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_AI_METADATA, {
                    error: error instanceof Error ? error.message : "Unknown error",
                    ...error instanceof (0, $7u3UL.SnippetMetadataError) && {
                        statusCode: error.statusCode
                    },
                    adfBodySize: adfBodySize,
                    durationMs: durationMs_0
                });
                (0, $aUBmi.reportError)(error);
            }).finally(()=>{
                if (isStale) return;
                setIsAiSuggestionLoading(false);
            });
            return ()=>{
                isStale = true;
            };
        };
        t1 = [
            adf,
            cloudId,
            fireFailedAnalytic,
            fireSuccessAnalytic
        ];
        $[0] = adf;
        $[1] = cloudId;
        $[2] = fireFailedAnalytic;
        $[3] = fireSuccessAnalytic;
        $[4] = t0;
        $[5] = t1;
    } else {
        t0 = $[4];
        t1 = $[5];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[6] !== aiSuggestedDescription || $[7] !== aiSuggestedName || $[8] !== isAiSuggestionLoading) {
        t2 = {
            isAiSuggestionLoading: isAiSuggestionLoading,
            aiSuggestedName: aiSuggestedName,
            aiSuggestedDescription: aiSuggestedDescription
        };
        $[6] = aiSuggestedDescription;
        $[7] = aiSuggestedName;
        $[8] = isAiSuggestionLoading;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
}
function $4d538ba06d23224f$var$_temp(s) {
    return s.confidence;
}
module.exports["useAiSuggestions"] = $4d538ba06d23224f$export$fbb5229d7f17a968;

});

parcelRegister("jxXkP", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $9DHhW = parcelRequire("9DHhW");


var $hPTbh = parcelRequire("hPTbh");


var $4uowN = parcelRequire("4uowN");

const $5d19246504a43db4$export$8076fd3f013c4bb9 = (origin)=>{
    const $ = (0, $bDgLe.c)(34);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== origin) {
        t0 = (data)=>{
            createAnalyticsEvent((0, $4uowN.buildSnippetUIEvent)(data, origin)).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = origin;
        $[2] = t0;
    } else t0 = $[2];
    const fireUIAnalytic = t0;
    let t1;
    if ($[3] !== createAnalyticsEvent || $[4] !== origin) {
        t1 = (data_0)=>{
            createAnalyticsEvent({
                type: (0, $hPTbh.ANALYTICS_EVENT_TYPE).SEND_OPERATIONAL_EVENT,
                data: {
                    source: (0, $hPTbh.ANALYTICS_SOURCE),
                    type: (0, $hPTbh.ANALYTICS_TYPE).OPERATIONAL,
                    ...data_0,
                    attributes: (0, $4uowN.mergeOriginIntoAttributes)(origin, data_0.attributes)
                }
            }).fire();
        };
        $[3] = createAnalyticsEvent;
        $[4] = origin;
        $[5] = t1;
    } else t1 = $[5];
    const fireOperationalAnalytic = t1;
    let t2;
    if ($[6] !== createAnalyticsEvent || $[7] !== origin) {
        t2 = (data_1)=>{
            createAnalyticsEvent({
                type: (0, $hPTbh.ANALYTICS_EVENT_TYPE).SEND_TRACK_EVENT,
                data: {
                    source: (0, $hPTbh.ANALYTICS_SOURCE),
                    ...data_1,
                    attributes: (0, $4uowN.mergeOriginIntoAttributes)(origin, data_1.attributes)
                }
            }).fire();
        };
        $[6] = createAnalyticsEvent;
        $[7] = origin;
        $[8] = t2;
    } else t2 = $[8];
    const fireTrackAnalytic = t2;
    let t3;
    if ($[9] !== fireUIAnalytic) {
        t3 = (actionSubjectId, attributes)=>{
            fireUIAnalytic({
                actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).BUTTON,
                action: (0, $hPTbh.ANALYTICS_UI_ACTION).CLICKED,
                actionSubjectId: actionSubjectId,
                attributes: attributes
            });
        };
        $[9] = fireUIAnalytic;
        $[10] = t3;
    } else t3 = $[10];
    const fireButtonClickedAnalytic = t3;
    let t4;
    if ($[11] !== createAnalyticsEvent || $[12] !== origin) {
        t4 = (attributes_0)=>{
            createAnalyticsEvent((0, $4uowN.buildSnippetUIEvent)({
                actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).SNIPPETS,
                action: (0, $hPTbh.ANALYTICS_UI_ACTION).VIEWED,
                actionSubjectId: (0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).SNIPPETS,
                attributes: attributes_0
            }, origin)).fire();
        };
        $[11] = createAnalyticsEvent;
        $[12] = origin;
        $[13] = t4;
    } else t4 = $[13];
    const fireScreenViewedAnalytic = t4;
    let t5;
    if ($[14] !== fireUIAnalytic) {
        t5 = (actionSubjectId_0, attributes_1)=>{
            fireUIAnalytic({
                actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).MODAL,
                action: (0, $hPTbh.ANALYTICS_UI_ACTION).CLOSED,
                actionSubjectId: actionSubjectId_0,
                attributes: attributes_1
            });
        };
        $[14] = fireUIAnalytic;
        $[15] = t5;
    } else t5 = $[15];
    const fireModalClosedAnalytic = t5;
    let t6;
    if ($[16] !== fireUIAnalytic) {
        t6 = (actionSubjectId_1, attributes_2)=>{
            fireUIAnalytic({
                actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).TEXT_FIELD,
                action: (0, $hPTbh.ANALYTICS_UI_ACTION).TYPED,
                actionSubjectId: actionSubjectId_1,
                attributes: attributes_2
            });
        };
        $[16] = fireUIAnalytic;
        $[17] = t6;
    } else t6 = $[17];
    const fireTextFieldTypedAnalytic = t6;
    let t7;
    if ($[18] !== fireUIAnalytic) {
        t7 = (actionSubjectId_2, attributes_3)=>{
            fireUIAnalytic({
                actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).DROPDOWN_ITEM,
                action: (0, $hPTbh.ANALYTICS_UI_ACTION).CLICKED,
                actionSubjectId: actionSubjectId_2,
                attributes: attributes_3
            });
        };
        $[18] = fireUIAnalytic;
        $[19] = t7;
    } else t7 = $[19];
    const fireDropdownItemClickedAnalytic = t7;
    let t8;
    if ($[20] !== fireOperationalAnalytic) {
        t8 = (actionSubject, attributes_4)=>{
            fireOperationalAnalytic({
                actionSubject: actionSubject,
                action: (0, $hPTbh.ANALYTICS_OPERATIONAL_ACTION).FAILED,
                attributes: attributes_4
            });
        };
        $[20] = fireOperationalAnalytic;
        $[21] = t8;
    } else t8 = $[21];
    const fireFailedAnalytic = t8;
    let t9;
    if ($[22] !== fireOperationalAnalytic) {
        t9 = (actionSubject_0, attributes_5)=>{
            fireOperationalAnalytic({
                actionSubject: actionSubject_0,
                action: (0, $hPTbh.ANALYTICS_OPERATIONAL_ACTION).SUCCEEDED,
                attributes: attributes_5
            });
        };
        $[22] = fireOperationalAnalytic;
        $[23] = t9;
    } else t9 = $[23];
    const fireSuccessAnalytic = t9;
    let t10;
    if ($[24] !== fireButtonClickedAnalytic || $[25] !== fireDropdownItemClickedAnalytic || $[26] !== fireFailedAnalytic || $[27] !== fireModalClosedAnalytic || $[28] !== fireOperationalAnalytic || $[29] !== fireScreenViewedAnalytic || $[30] !== fireSuccessAnalytic || $[31] !== fireTextFieldTypedAnalytic || $[32] !== fireTrackAnalytic) {
        t10 = {
            fireOperationalAnalytic: fireOperationalAnalytic,
            fireTrackAnalytic: fireTrackAnalytic,
            fireButtonClickedAnalytic: fireButtonClickedAnalytic,
            fireScreenViewedAnalytic: fireScreenViewedAnalytic,
            fireModalClosedAnalytic: fireModalClosedAnalytic,
            fireTextFieldTypedAnalytic: fireTextFieldTypedAnalytic,
            fireDropdownItemClickedAnalytic: fireDropdownItemClickedAnalytic,
            fireFailedAnalytic: fireFailedAnalytic,
            fireSuccessAnalytic: fireSuccessAnalytic
        };
        $[24] = fireButtonClickedAnalytic;
        $[25] = fireDropdownItemClickedAnalytic;
        $[26] = fireFailedAnalytic;
        $[27] = fireModalClosedAnalytic;
        $[28] = fireOperationalAnalytic;
        $[29] = fireScreenViewedAnalytic;
        $[30] = fireSuccessAnalytic;
        $[31] = fireTextFieldTypedAnalytic;
        $[32] = fireTrackAnalytic;
        $[33] = t10;
    } else t10 = $[33];
    return t10;
};
module.exports["useSnippetAnalytics"] = $5d19246504a43db4$export$8076fd3f013c4bb9;

});

parcelRegister("4uowN", function(module, exports) {

var $hPTbh = parcelRequire("hPTbh");

const $c57debba295826e3$export$7866120ea20cad41 = (origin, attributes)=>{
    if (!origin) return attributes;
    return {
        origin: origin,
        ...attributes
    };
};
const $c57debba295826e3$export$1ed6f7103d93d2a6 = (data, origin)=>({
        type: (0, $hPTbh.ANALYTICS_EVENT_TYPE).SEND_UI_EVENT,
        data: {
            source: (0, $hPTbh.ANALYTICS_SOURCE),
            type: (0, $hPTbh.ANALYTICS_TYPE).UI,
            ...data,
            attributes: $c57debba295826e3$export$7866120ea20cad41(origin, data.attributes)
        }
    });
const $c57debba295826e3$export$1a7d04e7638f44c9 = (createAnalyticsEvent, data, origin)=>{
    if (!createAnalyticsEvent) return;
    createAnalyticsEvent($c57debba295826e3$export$1ed6f7103d93d2a6(data, origin)).fire();
};
const $c57debba295826e3$export$10fcba9a216b9ac3 = (snippet)=>({
        actionSubject: (0, $hPTbh.ANALYTICS_UI_SUBJECT).BUTTON,
        action: (0, $hPTbh.ANALYTICS_UI_ACTION).CLICKED,
        actionSubjectId: (0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).INSERT_SNIPPET,
        attributes: {
            scope: snippet.scope,
            snippetId: snippet.snippetId,
            isShared: snippet.isShared,
            ...snippet.templateType !== undefined && {
                templateType: snippet.templateType
            }
        }
    });
module.exports["mergeOriginIntoAttributes"] = $c57debba295826e3$export$7866120ea20cad41;
module.exports["buildSnippetUIEvent"] = $c57debba295826e3$export$1ed6f7103d93d2a6;
module.exports["fireSnippetUIEvent"] = $c57debba295826e3$export$1a7d04e7638f44c9;
module.exports["buildInsertSnippetEventData"] = $c57debba295826e3$export$10fcba9a216b9ac3;

});

parcelRegister("7u3UL", function(module, exports) {

var $hBkCm = parcelRequire("hBkCm");

var $f7B1p = parcelRequire("f7B1p");


var $6mKj3 = parcelRequire("6mKj3");


var $lLaHL = parcelRequire("lLaHL");

const $e8d3a8559be06eee$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-Experience-Id': 'confluence-snippets-metadata',
    'X-Product': 'confluence'
};
// Convo-AI path (current source of truth, served by conversational-ai-platform).
const $e8d3a8559be06eee$var$CONVO_AI_URL = '/gateway/api/assist/api/confluence/v1/snippets/metadata';
// Cc-smarts path (new home, served by cc-smarts). Reached via the
// cc-smarts-ai-feature stargate route, which strips /gateway/api and
// prepends /api before forwarding to cc-smarts.
const $e8d3a8559be06eee$var$CC_SMARTS_URL = '/gateway/api/ai/v2/ai-feature/snippets/metadata';
class $e8d3a8559be06eee$export$1945c41c4351e1ba extends Error {
    constructor(message, statusCode){
        super(message);
        this.statusCode = void 0;
        this.name = 'SnippetMetadataError';
        this.statusCode = statusCode;
    }
}
const $e8d3a8559be06eee$export$9a61bf75a3648739 = async (snippetMetadataPayload, cloudId)=>{
    const url = (0, $6mKj3.expValEquals)('cc_smarts_snippet_metadata_migration', 'useCcSmarts', true) ? $e8d3a8559be06eee$var$CC_SMARTS_URL : $e8d3a8559be06eee$var$CONVO_AI_URL;
    let response;
    try {
        response = await (0, $f7B1p.cfetch)(url, {
            method: 'POST',
            headers: {
                ...$e8d3a8559be06eee$var$COMMON_HEADERS,
                'X-Cloudid': cloudId
            },
            body: JSON.stringify(snippetMetadataPayload)
        });
    } catch (err) {
        if ((0, $hBkCm.BadStatusError).isBadStatusError(err)) throw new $e8d3a8559be06eee$export$1945c41c4351e1ba(`Snippet metadata request failed: ${err.response.statusText}`, err.response.status);
        throw err;
    }
    const data = await response.json();
    if (!(0, $lLaHL.isValidSnippetMetadataResponse)(data)) throw new $e8d3a8559be06eee$export$1945c41c4351e1ba('Snippet metadata request failed: Invalid response');
    return data;
};
module.exports["SnippetMetadataError"] = $e8d3a8559be06eee$export$1945c41c4351e1ba;
module.exports["fetchSnippetMetadata"] = $e8d3a8559be06eee$export$9a61bf75a3648739;

});

parcelRegister("lLaHL", function(module, exports) {
function $af3686d25f9c79c6$export$96ab9a725de80077(value) {
    return !!value && typeof value === 'object' && 'suggestions' in value && Array.isArray(value.suggestions);
}
module.exports["isValidSnippetMetadataResponse"] = $af3686d25f9c79c6$export$96ab9a725de80077;

});

parcelRegister("ies1q", function(module, exports) {
function $fde34fcb96f8fe70$var$filterValidAdfNodes(nodes) {
    return nodes.filter((node)=>node !== undefined && node !== null);
}
const $fde34fcb96f8fe70$export$4cb5aec6fe7a20df = (content)=>{
    try {
        const parsedContent = JSON.parse(content);
        // Handle fragment (array of nodes without doc wrapper)
        if (Array.isArray(parsedContent)) return $fde34fcb96f8fe70$var$filterValidAdfNodes(parsedContent);
        // Handle single node or doc node
        const adfContent = parsedContent;
        if (adfContent.type === 'doc' && Array.isArray(adfContent.content)) return $fde34fcb96f8fe70$var$filterValidAdfNodes(adfContent.content);
        return adfContent;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error processing snippet ADF:', error);
        return undefined;
    }
};
const $fde34fcb96f8fe70$var$EMPTY_ADF = {
    type: 'doc',
    version: 1,
    content: []
};
const $fde34fcb96f8fe70$export$690e6d741f8e0cc0 = (node, nodeType)=>{
    if (node.type === nodeType) return true;
    const children = node.content;
    if (Array.isArray(children)) return children.some((child)=>child != null && $fde34fcb96f8fe70$export$690e6d741f8e0cc0(child, nodeType));
    return false;
};
const $fde34fcb96f8fe70$export$edf10108714aeccb = (doc)=>{
    if (!doc.content?.length) return true;
    return Boolean(doc.content.every((node)=>node.type === 'paragraph' && !node.content?.length));
};
const $fde34fcb96f8fe70$export$12649e099d1966de = (adf)=>{
    if (!adf) return $fde34fcb96f8fe70$var$EMPTY_ADF;
    const docType = 'doc';
    const isArray = Array.isArray(adf);
    if (!isArray && adf.type === docType) return adf;
    const content = isArray ? adf : [
        adf
    ];
    return {
        version: 1,
        type: docType,
        content: content
    };
};
module.exports["parseSnippetContent"] = $fde34fcb96f8fe70$export$4cb5aec6fe7a20df;
module.exports["adfContainsNodeType"] = $fde34fcb96f8fe70$export$690e6d741f8e0cc0;
module.exports["isAdfBodyEmpty"] = $fde34fcb96f8fe70$export$edf10108714aeccb;
module.exports["wrapAdfWithDocNode"] = $fde34fcb96f8fe70$export$12649e099d1966de;

});

parcelRegister("aUBmi", function(module, exports) {

var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $29dc66e92b22c80c$export$b33b857ad1d9900e = (error)=>{
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).INTEGRATIONS
    });
};
module.exports["reportError"] = $29dc66e92b22c80c$export$b33b857ad1d9900e;

});

parcelRegister("8JRDD", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $bQm3c = parcelRequire("bQm3c");


var $jxXkP = parcelRequire("jxXkP");


var $cga1x = parcelRequire("cga1x");

function $4fa818aead1a2cbf$export$bad2cf1fdd3f2020(onClose, origin, actionSubjectId) {
    const $ = (0, $bDgLe.c)(12);
    const { fireModalClosedAnalytic: fireModalClosedAnalytic } = (0, $jxXkP.useSnippetAnalytics)(origin);
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== userId) {
        t0 = userId != null && {
            userId: userId
        };
        $[0] = userId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== cloudId) {
        t1 = cloudId != null && {
            cloudId: cloudId
        };
        $[2] = cloudId;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = {
            ...t0,
            ...t1,
            scope: (0, $cga1x.SnippetScope).USER
        };
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    const baseAnalyticsAttributes = t2;
    let t3;
    if ($[7] !== actionSubjectId || $[8] !== baseAnalyticsAttributes || $[9] !== fireModalClosedAnalytic || $[10] !== onClose) {
        t3 = (attributes)=>{
            fireModalClosedAnalytic(actionSubjectId, {
                ...baseAnalyticsAttributes,
                ...attributes
            });
            onClose();
        };
        $[7] = actionSubjectId;
        $[8] = baseAnalyticsAttributes;
        $[9] = fireModalClosedAnalytic;
        $[10] = onClose;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
}
module.exports["useSnippetModalClose"] = $4fa818aead1a2cbf$export$bad2cf1fdd3f2020;

});

parcelRegister("cga1x", function(module, exports) {
/** Define the source of the snippets */ var $bd320fc30ef678ce$export$100829e61c5df591 = /*#__PURE__*/ function(SnippetScope) {
    SnippetScope["GLOBAL"] = "GLOBAL";
    SnippetScope["USER"] = "USER";
    SnippetScope["SITE"] = "SITE";
    return SnippetScope;
}({});
module.exports["SnippetScope"] = $bd320fc30ef678ce$export$100829e61c5df591;

});

parcelRegister("8yRiX", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $dPJCf = parcelRequire("dPJCf");


var $lJDEI = parcelRequire("lJDEI");

const $629d08bce85f57d1$export$93be0369e955d1c = ()=>{
    const $ = (0, $bDgLe.c)(2);
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    let t0;
    if ($[0] !== setQueryParams) {
        t0 = ()=>{
            (0, $lJDEI.setInEditorTemplatesPanelQueryParam)(setQueryParams, (0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_KEEP_OPEN), (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_BLOCK));
        };
        $[0] = setQueryParams;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
module.exports["useOpenSnippetPanel"] = $629d08bce85f57d1$export$93be0369e955d1c;

});

parcelRegister("eWCeD", function(module, exports) {

var $hBkCm = parcelRequire("hBkCm");


var $hPTbh = parcelRequire("hPTbh");

class $6ad5f72792cdeefd$export$e48d728925b396bf extends Error {
    constructor(message){
        super(`Snippet error: ${message}`);
        this.statusCode = void 0;
    }
}
const $6ad5f72792cdeefd$var$BODY_TOO_LARGE_PATTERN = /body must be \d+\s*KB or less/i;
const $6ad5f72792cdeefd$export$47a2671a68c2a605 = 'Unable to transform snippet data after creation';
const $6ad5f72792cdeefd$export$c09a7180561ac878 = (err)=>err instanceof $6ad5f72792cdeefd$export$e48d728925b396bf && err.statusCode === 400 && $6ad5f72792cdeefd$var$BODY_TOO_LARGE_PATTERN.test(err.message);
const $6ad5f72792cdeefd$export$fdde500cb4c8cd41 = (err)=>{
    if ($6ad5f72792cdeefd$export$c09a7180561ac878(err)) return {
        reason: (0, $hPTbh.CREATE_SNIPPET_FAILURE_REASON).BODY_TOO_LARGE,
        statusCode: err.statusCode
    };
    if (err instanceof $6ad5f72792cdeefd$export$e48d728925b396bf) return {
        reason: (0, $hPTbh.CREATE_SNIPPET_FAILURE_REASON).CREATE_EXCEPTION,
        ...err.statusCode !== undefined && {
            statusCode: err.statusCode
        }
    };
    if (err instanceof Error && err.message === $6ad5f72792cdeefd$export$47a2671a68c2a605) return {
        reason: (0, $hPTbh.CREATE_SNIPPET_FAILURE_REASON).TRANSFORM_FAILED
    };
    return {
        reason: (0, $hPTbh.CREATE_SNIPPET_FAILURE_REASON).UNKNOWN
    };
};
const $6ad5f72792cdeefd$export$7686cbf11523eb4d = (reason)=>{
    let statusCode;
    if ((0, $hBkCm.BadStatusError).isBadStatusError(reason)) statusCode = reason.response.status;
    else if (reason instanceof $6ad5f72792cdeefd$export$e48d728925b396bf) statusCode = reason.statusCode;
    if (statusCode !== undefined) {
        if (statusCode === 404) return {
            reason: (0, $hPTbh.FETCH_SNIPPET_FAILURE_REASON).NOT_FOUND,
            statusCode: statusCode
        };
        if (statusCode === 401 || statusCode === 403) return {
            reason: (0, $hPTbh.FETCH_SNIPPET_FAILURE_REASON).FORBIDDEN,
            statusCode: statusCode
        };
        if (statusCode === 408) return {
            reason: (0, $hPTbh.FETCH_SNIPPET_FAILURE_REASON).TIMEOUT,
            statusCode: statusCode
        };
        return {
            reason: (0, $hPTbh.FETCH_SNIPPET_FAILURE_REASON).FETCH_EXCEPTION,
            statusCode: statusCode
        };
    }
    if (reason instanceof Error && (reason.name === 'AbortError' || reason.name === 'TimeoutError')) return {
        reason: (0, $hPTbh.FETCH_SNIPPET_FAILURE_REASON).TIMEOUT
    };
    return {
        reason: (0, $hPTbh.FETCH_SNIPPET_FAILURE_REASON).UNKNOWN
    };
};
module.exports["SnippetError"] = $6ad5f72792cdeefd$export$e48d728925b396bf;
module.exports["CREATE_TRANSFORM_FAILED_MESSAGE"] = $6ad5f72792cdeefd$export$47a2671a68c2a605;
module.exports["isBodyTooLargeError"] = $6ad5f72792cdeefd$export$c09a7180561ac878;
module.exports["classifyCreateError"] = $6ad5f72792cdeefd$export$fdde500cb4c8cd41;
module.exports["classifyFetchError"] = $6ad5f72792cdeefd$export$7686cbf11523eb4d;

});

parcelRegister("dZUkS", function(module, exports) {
/**
 * Snippets Store - Centralized State Management
 *
 * This module provides a centralized store for managing snippets data
 * using react-sweet-state. This replaces the previous pattern of individual hooks
 * (useCreateSnippet, useFetchSnippets) with a single source of truth.
 *
 * Usage:
 * - Wrap your app with <SnippetsProvider> to trigger initial fetch
 * - Use useSnippetsState() for read-only state access
 * - Use useSnippetsActions() when you need to dispatch actions
 * - Use useSnippets() when you need both state and actions
 */ 
var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");


var $7DXt6 = parcelRequire("7DXt6");


var $ebSlI = parcelRequire("ebSlI");


var $a6kUr = parcelRequire("a6kUr");

const $bc4bb1bc094c1f8d$export$a693d5f2dbb6b76e = (0, $8s9DV.createStore)({
    initialState: (0, $ebSlI.getInitialState)(),
    actions: $a6kUr.actions,
    name: 'SnippetsStore'
});
const $bc4bb1bc094c1f8d$export$f6df4e69084aa09f = (0, $kBr4q.createHook)($bc4bb1bc094c1f8d$export$a693d5f2dbb6b76e);
const $bc4bb1bc094c1f8d$export$bc515607f82ac38d = (0, $kBr4q.createActionsHook)($bc4bb1bc094c1f8d$export$a693d5f2dbb6b76e);
const $bc4bb1bc094c1f8d$export$d2573ca28cf6a6de = (0, $kBr4q.createStateHook)($bc4bb1bc094c1f8d$export$a693d5f2dbb6b76e);
const $bc4bb1bc094c1f8d$export$9211bc7cf74ad61b = ()=>{
    const storeInstance = (0, $c6StJ.defaultRegistry).getStore($bc4bb1bc094c1f8d$export$a693d5f2dbb6b76e);
    return storeInstance.storeState.getState();
};
const $bc4bb1bc094c1f8d$export$cf5f21fefd1a9a8a = (0, $7DXt6.onCurrentFetchComplete);
module.exports["useSnippets"] = $bc4bb1bc094c1f8d$export$f6df4e69084aa09f;
module.exports["useSnippetsActions"] = $bc4bb1bc094c1f8d$export$bc515607f82ac38d;
module.exports["useSnippetsState"] = $bc4bb1bc094c1f8d$export$d2573ca28cf6a6de;
module.exports["getSnippetsStateSnapshot"] = $bc4bb1bc094c1f8d$export$9211bc7cf74ad61b;
module.exports["onCurrentFetchComplete"] = $bc4bb1bc094c1f8d$export$cf5f21fefd1a9a8a;

});

parcelRegister("7DXt6", function(module, exports) {
/**
 * Module-level registry for one-time callbacks that fire when the current in-flight fetch completes.
 * These callbacks are cleared after each fetch completes and are NOT triggered by future fetches.
 */ let $840c51e2f085aaa9$var$pendingLoadCallbacks = [];
const $840c51e2f085aaa9$export$cf5f21fefd1a9a8a = (callback)=>{
    $840c51e2f085aaa9$var$pendingLoadCallbacks.push(callback);
};
const $840c51e2f085aaa9$export$3ce7f1b7cae8932a = (snippets)=>{
    const callbacks = $840c51e2f085aaa9$var$pendingLoadCallbacks;
    $840c51e2f085aaa9$var$pendingLoadCallbacks = []; // Clear before invoking to prevent re-registration issues
    callbacks.forEach((cb)=>cb(snippets));
};
module.exports["onCurrentFetchComplete"] = $840c51e2f085aaa9$export$cf5f21fefd1a9a8a;
module.exports["invokePendingLoadCallbacks"] = $840c51e2f085aaa9$export$3ce7f1b7cae8932a;

});

parcelRegister("ebSlI", function(module, exports) {
/**
 * Snippets Store Types
 *
 * Defines the shape of the centralized snippets state for managing snippets data.
 * The `isLoaded` flag is crucial for preventing duplicate fetch requests -
 * once snippets are loaded, subsequent calls to fetchSnippets() will return
 * the cached data immediately.
 *
 * Site configuration:
 * - `isSnippetSharingForSiteEnabled`: Set once on first fetch from site config; used for Access field and refetches.
 *
 * Error state:
 * - `fetchError`: Set when fetching snippets fails
 */ 
var $kBRLU = parcelRequire("kBRLU");


var $gPFNt = parcelRequire("gPFNt");

const $523eaf9335c60db8$export$e88dfa32f0f8be4a = ()=>({
        selectedSnippetId: null,
        selectedCategoryId: (0, $kBRLU.DEFAULT_CATEGORY_ID),
        searchQuery: '',
        sortOrder: (0, $gPFNt.DEFAULT_SNIPPET_SORT_ORDER)
    });
const $523eaf9335c60db8$export$53ac33307b5acee9 = ()=>({
        snippets: [],
        isLoading: false,
        isClaimingShare: false,
        fetchError: null,
        isLoaded: false,
        templateGallery: $523eaf9335c60db8$export$e88dfa32f0f8be4a()
    });
module.exports["getInitialTemplateGalleryState"] = $523eaf9335c60db8$export$e88dfa32f0f8be4a;
module.exports["getInitialState"] = $523eaf9335c60db8$export$53ac33307b5acee9;

});

parcelRegister("kBRLU", function(module, exports) {
/**
 * Snippet Category Constants
 *
 * Defines the available category filter IDs for snippets. Category labels
 * are provided by useSnippetFilterCategories. Categories are used by the
 * SnippetTabContent component and the useSnippetFilterAndSort hook.
 *
 * Category filtering logic:
 * - ALL: Shows all snippets (no filtering)
 * - MY_TEMPLATES: Shows only snippets created by the current user
 * - FAVORITES: Shows only snippets marked as favorites
 */ /** Constant IDs for snippet category filters - used as keys in state and filter logic */ var $9fd8f8887cf22774$export$83f66926d5f092b5 = /*#__PURE__*/ function(SNIPPET_CATEGORY_IDS) {
    SNIPPET_CATEGORY_IDS["ALL"] = "snippets.all";
    SNIPPET_CATEGORY_IDS["MY_TEMPLATES"] = "snippets.my-templates";
    SNIPPET_CATEGORY_IDS["FAVORITES"] = "snippets.favorites";
    return SNIPPET_CATEGORY_IDS;
}({});
const $9fd8f8887cf22774$export$5b046c946c4ab60f = "snippets.all";
module.exports["SNIPPET_CATEGORY_IDS"] = $9fd8f8887cf22774$export$83f66926d5f092b5;
module.exports["DEFAULT_CATEGORY_ID"] = $9fd8f8887cf22774$export$5b046c946c4ab60f;

});

parcelRegister("gPFNt", function(module, exports) {
/**
 * Sort order options for snippet lists.
 *
 * Used by the SnippetSortDropdown and useSnippetFilterAndSort to determine
 * how snippets are ordered in the panel.
 */ var $f130004a9fad02a7$export$1fbcbf3366f925b0 = /*#__PURE__*/ function(SnippetSortOrder) {
    SnippetSortOrder["CREATED_AT"] = "CREATED_AT";
    SnippetSortOrder["LAST_UPDATED"] = "LAST_UPDATED";
    SnippetSortOrder["POPULARITY"] = "POPULARITY";
    SnippetSortOrder["ALPHABETICAL"] = "ALPHABETICAL";
    return SnippetSortOrder;
}({});
const $f130004a9fad02a7$export$c135813ba1be028a = "CREATED_AT";
module.exports["SnippetSortOrder"] = $f130004a9fad02a7$export$1fbcbf3366f925b0;
module.exports["DEFAULT_SNIPPET_SORT_ORDER"] = $f130004a9fad02a7$export$c135813ba1be028a;

});

parcelRegister("a6kUr", function(module, exports) {

var $5NAso = parcelRequire("5NAso");


var $kZ6BG = parcelRequire("kZ6BG");


var $5ogZS = parcelRequire("5ogZS");


var $2Qxf3 = parcelRequire("2Qxf3");


var $adRf2 = parcelRequire("adRf2");


var $gdHn1 = parcelRequire("gdHn1");


var $kvZfs = parcelRequire("kvZfs");


var $cfxyE = parcelRequire("cfxyE");

const $211e3bb4477563d9$export$e324594224ef24da = {
    ...(0, $2Qxf3.fetchActions),
    ...(0, $5NAso.createActions),
    ...(0, $kZ6BG.deleteActions),
    ...(0, $cfxyE.updateActions),
    ...(0, $5ogZS.favoriteActions),
    ...(0, $gdHn1.shareActions),
    ...(0, $adRf2.insertCountActions),
    ...(0, $kvZfs.templateGalleryActions)
};
module.exports["actions"] = $211e3bb4477563d9$export$e324594224ef24da;

});

parcelRegister("5NAso", function(module, exports) {
/**
 * Create Actions - Snippet creation with UI integration
 *
 * This action handles snippet creation (and duplication) with full UI integration:
 * - Creates the snippet via the API
 * - Shows success/error flags
 * - Adds the snippet to the editor's quick insert menu
 * - Refreshes the snippets list
 *
 * Both CreateSnippetModal and DuplicateSnippetModal call createSnippet, each
 * passing their own i18n messages via options.messages.
 */ 
var $jU9SA = parcelRequire("jU9SA");


var $6K2yS = parcelRequire("6K2yS");


var $aUBmi = parcelRequire("aUBmi");


var $3e10B = parcelRequire("3e10B");


var $lIx1f = parcelRequire("lIx1f");


var $eWCeD = parcelRequire("eWCeD");


var $eDBud = parcelRequire("eDBud");


var $9gUQP = parcelRequire("9gUQP");

// Module-level create-failure callback, registered by the React analytics layer
// (mirrors fetchActions.ts) so the store stays free of React/analytics deps.
let $d34b4d835ec45f27$var$onCreateErrorCallback = null;
const $d34b4d835ec45f27$export$e603e8a20760b9a4 = (callback)=>{
    $d34b4d835ec45f27$var$onCreateErrorCallback = callback;
};
const $d34b4d835ec45f27$var$invokeCreateErrorCallback = (info)=>{
    $d34b4d835ec45f27$var$onCreateErrorCallback?.(info);
};
const $d34b4d835ec45f27$export$aad2e27b28b19174 = {
    /**
   * Creates a new snippet and refreshes the snippets list.
   *
   * After successful creation:
   * - Clears the service cache and fetches the updated list
   * - Shows a success flag (if options provided)
   * - Adds the snippet to the quick insert menu
   *
   * On error:
   * - Reports to monitoring
   * - Shows an error flag (if options provided)
   * - Keeps existing snippets visible (doesn't reset isLoaded)
   *
   * @param name - The snippet name (required)
   * @param body - The ADF content body
   * @param description - Optional description text
   * @param options - UI options including flags, intl, editor API ref, and i18n messages
   * @returns Promise resolving to the newly created snippet, or null on failure
   */ createSnippet: (name, body, description, options)=>async (storeApi)=>{
            const { getState: getState, setState: setState } = storeApi;
            const messages = options?.messages ?? (0, $jU9SA.createSnippetModalMessages);
            const params = (0, $9gUQP.buildCreatePayload)(name, body, description);
            setState({
                isLoading: true
            });
            try {
                const snippet = await $3e10B.createSnippet(params);
                const { isSnippetSharingForSiteEnabled: isSnippetSharingForSiteEnabled, snippetsLocale: snippetsLocale } = getState();
                (0, $lIx1f.clearSnippetsCache)();
                const updatedSnippets = await $3e10B.fetchSnippets({
                    isSnippetSharingForSiteEnabled: isSnippetSharingForSiteEnabled,
                    locale: snippetsLocale
                });
                setState({
                    snippets: updatedSnippets,
                    isLoading: false,
                    isLoaded: true
                });
                if (options) {
                    const { flags: flags, intl: intl, editorAPI: editorAPI, isShared: isShared, onShareFailure: onShareFailure, successFlagActions: successFlagActions, showSuccessFlag: showSuccessFlag = true } = options;
                    if (showSuccessFlag) (0, $eDBud.showSnippetSuccessFlag)(flags, intl.formatMessage(messages.successFlagTitle, {
                        snippetName: snippet.name
                    }), intl.formatMessage((0, $6K2yS.messages).successFlagDescription), successFlagActions);
                    await (0, $9gUQP.addSnippetToQuickInsertAndShare)({
                        snippet: snippet,
                        options: {
                            flags: flags,
                            intl: intl,
                            editorAPI: editorAPI,
                            isShared: isShared
                        },
                        storeApi: storeApi,
                        onShareFailure: onShareFailure
                    });
                }
                return snippet;
            } catch (thrownError) {
                const err = thrownError instanceof Error ? thrownError : new Error(String(thrownError));
                setState({
                    isLoading: false
                });
                (0, $aUBmi.reportError)(err);
                // Surface a PII-safe, classified failure to the analytics layer
                // (gating/firing handled by useSnippetsCreateAnalytics).
                $d34b4d835ec45f27$var$invokeCreateErrorCallback((0, $eWCeD.classifyCreateError)(err));
                if (options) {
                    options.onSaveFailure?.(err);
                    const { flagTitle: flagTitle, flagDescription: flagDescription } = (0, $9gUQP.getSnippetErrorFlagMessages)(err, messages.errorFlagTitle, messages.errorFlagDescription);
                    (0, $eDBud.showSnippetErrorFlag)(options.flags, options.intl.formatMessage(flagTitle), options.intl.formatMessage(flagDescription));
                    return null;
                }
                throw err;
            }
        }
};
module.exports["setOnCreateError"] = $d34b4d835ec45f27$export$e603e8a20760b9a4;
module.exports["createActions"] = $d34b4d835ec45f27$export$aad2e27b28b19174;

});

parcelRegister("jU9SA", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $9c872498afbde1b3$export$14b1a9d585ebb136 = (0, $kSwu1.defineMessages)({
    titleCreate: {
        id: "snippets.snippetEditorModal.titleCreate",
        defaultMessage: "Create block template"
    },
    createButton: {
        id: "snippets.snippetEditorModal.createButton",
        defaultMessage: "Create"
    },
    successFlagTitle: {
        id: "snippets.snippetEditorModal.successFlagTitle",
        defaultMessage: "Template \"{snippetName}\" created"
    },
    errorFlagTitle: {
        id: "snippets.snippetEditorModal.errorFlagTitle",
        defaultMessage: "Could not create template"
    },
    errorFlagDescription: {
        id: "snippets.snippetEditorModal.errorFlagDescription",
        defaultMessage: "Please try again"
    },
    syncBlockSourceWarning: {
        id: "snippets.snippetEditorModal.syncBlockSourceWarning",
        defaultMessage: "This will create a new block template. If you want to reference the existing content, insert a sync block reference instead."
    }
});
module.exports["createSnippetModalMessages"] = $9c872498afbde1b3$export$14b1a9d585ebb136;

});

parcelRegister("6K2yS", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $e858a4f8aa1513e4$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    nameLabel: {
        id: "snippets.snippetEditorModal.nameLabel",
        defaultMessage: "Template name"
    },
    namePlaceholder: {
        id: "snippets.snippetEditorModal.namePlaceholder",
        defaultMessage: "Enter template name"
    },
    nameError: {
        id: "snippets.snippetEditorModal.nameError",
        defaultMessage: "Name is required"
    },
    descriptionLabel: {
        id: "snippets.snippetEditorModal.descriptionLabel",
        defaultMessage: "Description"
    },
    descriptionPlaceholder: {
        id: "snippets.snippetEditorModal.descriptionPlaceholder",
        defaultMessage: "Enter template description"
    },
    saveToLabel: {
        id: "snippets.snippetEditorModal.saveToLabel",
        defaultMessage: "Save to"
    },
    adfError: {
        id: "snippets.snippetEditorModal.adfError",
        defaultMessage: "Something went wrong, please make a new content selection"
    },
    emptyBodyError: {
        id: "snippets.snippetEditorModal.emptyBodyError",
        defaultMessage: "Template content cannot be empty"
    },
    cancelButton: {
        id: "snippets.snippetEditorModal.cancelButton",
        defaultMessage: "Cancel"
    },
    contentTooLargeFlagTitle: {
        id: "snippets.snippetEditorModal.contentTooLargeFlagTitle",
        defaultMessage: "Template content is too large"
    },
    contentTooLargeFlagDescription: {
        id: "snippets.snippetEditorModal.contentTooLargeFlagDescription",
        defaultMessage: "Reduce the content size and try again"
    },
    successFlagViewTemplateAction: {
        id: "snippets.snippetEditorModal.successFlagViewTemplateAction",
        defaultMessage: "View template"
    },
    successFlagDescription: {
        id: "snippets.snippetEditorModal.successFlagDescription",
        defaultMessage: "You can now use it from the / menu"
    }
});
module.exports["messages"] = $e858a4f8aa1513e4$export$defe85febe8b728c;

});

parcelRegister("3e10B", function(module, exports) {

var $fu7bs = parcelRequire("fu7bs");


var $hBkCm = parcelRequire("hBkCm");

var $f7B1p = parcelRequire("f7B1p");


var $2Qxf3 = parcelRequire("2Qxf3");


var $77Hid = parcelRequire("77Hid");


var $aUBmi = parcelRequire("aUBmi");


var $eWCeD = parcelRequire("eWCeD");


var $lIx1f = parcelRequire("lIx1f");


var $5ra2J = parcelRequire("5ra2J");


var $doyqd = parcelRequire("doyqd");

const $08eb629ddb2e8bad$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $08eb629ddb2e8bad$var$cfetchSnippet = async (...args)=>{
    try {
        return await (0, $f7B1p.cfetch)(...args);
    } catch (err) {
        if ((0, $hBkCm.BadStatusError).isBadStatusError(err)) {
            const body = await err.response.json().catch(()=>({}));
            const snippetErr = new (0, $eWCeD.SnippetError)(body?.error ?? err.response.statusText);
            snippetErr.statusCode = err.response.status;
            throw snippetErr;
        }
        throw err;
    }
};
const $08eb629ddb2e8bad$var$BLOCK_SERVICE_API_URL = '/gateway/api/blocks/v1';
const $08eb629ddb2e8bad$var$SNIPPETS_PATH = '/snippets';
const $08eb629ddb2e8bad$var$normalizeLocale = (locale)=>locale.split('_').join('-');
const $08eb629ddb2e8bad$export$a891d387a4e7ba6f = async ()=>{
    try {
        const response = await $08eb629ddb2e8bad$var$cfetchSnippet(`${$08eb629ddb2e8bad$var$BLOCK_SERVICE_API_URL}${$08eb629ddb2e8bad$var$SNIPPETS_PATH}/settings`, {
            method: 'GET',
            headers: $08eb629ddb2e8bad$var$COMMON_HEADERS
        });
        const data = await response.json();
        return data.sharingEnabled;
    } catch (error) {
        (0, $aUBmi.reportError)(error instanceof Error ? error : new (0, $eWCeD.SnippetError)(String(error)));
        return false;
    }
};
const $08eb629ddb2e8bad$export$424a614da735364c = (options)=>{
    const locale = options?.locale;
    return (0, $lIx1f.withSnippetsCache)(async ()=>{
        const isSnippetSharingForSiteEnabled = options?.isSnippetSharingForSiteEnabled !== undefined ? options.isSnippetSharingForSiteEnabled : await $08eb629ddb2e8bad$export$a891d387a4e7ba6f();
        const [userSnippetsResult, globalSnippetsResult, siteSnippetsResult] = await Promise.allSettled([
            $08eb629ddb2e8bad$var$fetchSnippetData((0, $doyqd.SnippetScope).USER),
            $08eb629ddb2e8bad$var$fetchSnippetData((0, $doyqd.SnippetScope).GLOBAL, locale),
            isSnippetSharingForSiteEnabled ? $08eb629ddb2e8bad$var$fetchSnippetData((0, $doyqd.SnippetScope).SITE) : Promise.resolve([])
        ]);
        // Success is only counted after `transformSnippets` resolves for each
        // scope. If the raw payload is malformed and transform throws, the
        // resulting rejection propagates (rather than being swallowed as a
        // success), so the fetch success denominator is never inflated.
        const userSnippets = userSnippetsResult.status === 'fulfilled' ? await (0, $5ra2J.transformSnippets)(userSnippetsResult.value).then((result)=>{
            $08eb629ddb2e8bad$var$logResultSuccess((0, $doyqd.SnippetScope).USER);
            return result;
        }) : ($08eb629ddb2e8bad$var$logResultError(userSnippetsResult.reason, (0, $doyqd.SnippetScope).USER), []);
        const globalSnippets = globalSnippetsResult.status === 'fulfilled' ? await (0, $5ra2J.transformSnippets)(globalSnippetsResult.value).then((result)=>{
            $08eb629ddb2e8bad$var$logResultSuccess((0, $doyqd.SnippetScope).GLOBAL);
            return result;
        }) : ($08eb629ddb2e8bad$var$logResultError(globalSnippetsResult.reason, (0, $doyqd.SnippetScope).GLOBAL), []);
        const siteSnippets = siteSnippetsResult.status === 'fulfilled' ? await (0, $5ra2J.transformSnippets)(siteSnippetsResult.value).then((result)=>{
            // Only count a SITE success when sharing is enabled and an actual
            // fetch was performed. When disabled, the SITE slot resolves to a
            // synthetic empty array (Promise.resolve([])) that never hit the
            // network, so firing a success there would skew the fetch rate.
            if (isSnippetSharingForSiteEnabled) $08eb629ddb2e8bad$var$logResultSuccess((0, $doyqd.SnippetScope).SITE);
            return result;
        }) : ($08eb629ddb2e8bad$var$logResultError(siteSnippetsResult.reason, (0, $doyqd.SnippetScope).SITE), []);
        return [
            ...userSnippets,
            ...globalSnippets,
            ...siteSnippets
        ];
    }, locale ? $08eb629ddb2e8bad$var$normalizeLocale(locale) : undefined);
};
const $08eb629ddb2e8bad$var$fetchSnippetData = async (scope, locale)=>{
    const responseData = await (0, $fu7bs.fetchSnippetsData)({
        format: (0, $77Hid.SnippetBodyFormat).ADF,
        ...locale ? {
            locale: locale
        } : {},
        product: (0, $doyqd.SnippetProduct).CONFLUENCE,
        scope: scope
    });
    if (!responseData.success) return [];
    // Success and error can both be present, so we need to log the error if it is present
    if (Array.isArray(responseData.error) && responseData.error.length > 0) responseData.error.forEach((error)=>{
        $08eb629ddb2e8bad$var$logResultError(error, scope);
    });
    return responseData.success;
};
const $08eb629ddb2e8bad$export$f7bed3a90241a88a = async (params)=>{
    const response = await $08eb629ddb2e8bad$var$cfetchSnippet(`${$08eb629ddb2e8bad$var$BLOCK_SERVICE_API_URL + $08eb629ddb2e8bad$var$SNIPPETS_PATH}`, {
        method: 'POST',
        headers: $08eb629ddb2e8bad$var$COMMON_HEADERS,
        body: JSON.stringify(params)
    });
    const responseData = await response.json();
    const snippet = await (0, $5ra2J.transformSnippet)(responseData);
    // Clear the cache so the newly created snippet appears when fetching snippets again
    // (e.g., when navigating to a different page or when the extension provider rebuilds)
    // Quick insert only adds the new snippet to the current editor instance's menu
    // navigating to a new edit page the extension providers rebuilds and call fetchSnippets which will return the cached data.
    (0, $lIx1f.clearSnippetsCache)();
    if (snippet) return snippet;
    else throw new Error((0, $eWCeD.CREATE_TRANSFORM_FAILED_MESSAGE));
};
const $08eb629ddb2e8bad$export$ba93a91dd8596775 = async (snippetId)=>{
    await $08eb629ddb2e8bad$var$cfetchSnippet(`${$08eb629ddb2e8bad$var$BLOCK_SERVICE_API_URL + $08eb629ddb2e8bad$var$SNIPPETS_PATH}/${snippetId}`, {
        method: 'DELETE',
        headers: $08eb629ddb2e8bad$var$COMMON_HEADERS
    });
};
const $08eb629ddb2e8bad$export$23a793f970583236 = async (snippetId, snippetPayload)=>{
    const response = await $08eb629ddb2e8bad$var$cfetchSnippet(`${$08eb629ddb2e8bad$var$BLOCK_SERVICE_API_URL + $08eb629ddb2e8bad$var$SNIPPETS_PATH}/${snippetId}`, {
        method: 'PUT',
        headers: $08eb629ddb2e8bad$var$COMMON_HEADERS,
        body: JSON.stringify(snippetPayload)
    });
    const responseData = await response.json();
    const snippet = await (0, $5ra2J.transformSnippet)(responseData);
    // Clear the cache so the updated snippet appears when fetching snippets again
    // (e.g., when navigating to a different page or when the extension provider rebuilds)
    (0, $lIx1f.clearSnippetsCache)();
    if (snippet) return snippet;
    else throw new Error('Unable to transform snippet data after update');
};
const $08eb629ddb2e8bad$export$d8ad364ff92072df = async (snippetId)=>{
    const response = await $08eb629ddb2e8bad$var$cfetchSnippet(`${$08eb629ddb2e8bad$var$BLOCK_SERVICE_API_URL + $08eb629ddb2e8bad$var$SNIPPETS_PATH}/${snippetId}/favorite`, {
        method: 'POST',
        headers: $08eb629ddb2e8bad$var$COMMON_HEADERS
    });
    return response.json();
};
const $08eb629ddb2e8bad$export$8fa65d63d256253e = async (snippetId)=>{
    await $08eb629ddb2e8bad$var$cfetchSnippet(`${$08eb629ddb2e8bad$var$BLOCK_SERVICE_API_URL + $08eb629ddb2e8bad$var$SNIPPETS_PATH}/${snippetId}/favorite`, {
        method: 'DELETE',
        headers: $08eb629ddb2e8bad$var$COMMON_HEADERS
    });
};
const $08eb629ddb2e8bad$export$d055ce15e6ca2d50 = async (snippetId)=>{
    try {
        await $08eb629ddb2e8bad$var$cfetchSnippet(`${$08eb629ddb2e8bad$var$BLOCK_SERVICE_API_URL + $08eb629ddb2e8bad$var$SNIPPETS_PATH}/${snippetId}/insertCount`, {
            method: 'PUT',
            headers: $08eb629ddb2e8bad$var$COMMON_HEADERS
        });
    } catch (error) {
        (0, $aUBmi.reportError)(error instanceof Error ? error : new (0, $eWCeD.SnippetError)(String(error)));
    }
};
const $08eb629ddb2e8bad$export$694c1dfa19cf1dd0 = async (snippetId)=>{
    await $08eb629ddb2e8bad$var$cfetchSnippet(`${$08eb629ddb2e8bad$var$BLOCK_SERVICE_API_URL + $08eb629ddb2e8bad$var$SNIPPETS_PATH}/${snippetId}/share`, {
        method: 'POST',
        headers: $08eb629ddb2e8bad$var$COMMON_HEADERS
    });
    // Clear the cache so the newly created snippet appears when fetching snippets again
    // (e.g., when navigating to a different page or when the extension provider rebuilds)
    // Quick insert only adds the new snippet to the current editor instance's menu
    // navigating to a new edit page the extension providers rebuilds and call fetchSnippets which will return the cached data.
    // TODO: revisit if clearSnippetsCache is needed for create, update, duplicate, etc.
    (0, $lIx1f.clearSnippetsCache)();
};
const $08eb629ddb2e8bad$export$47e429919a88c99 = async (snippetId, shareId)=>{
    const response = await $08eb629ddb2e8bad$var$cfetchSnippet(`${$08eb629ddb2e8bad$var$BLOCK_SERVICE_API_URL}${$08eb629ddb2e8bad$var$SNIPPETS_PATH}/${snippetId}/share/claim`, {
        method: 'POST',
        headers: $08eb629ddb2e8bad$var$COMMON_HEADERS,
        body: JSON.stringify({
            shareId: shareId
        })
    });
    return response.json();
};
const $08eb629ddb2e8bad$export$c0ff842d3c1f78b9 = async (snippetId)=>{
    await $08eb629ddb2e8bad$var$cfetchSnippet(`${$08eb629ddb2e8bad$var$BLOCK_SERVICE_API_URL + $08eb629ddb2e8bad$var$SNIPPETS_PATH}/${snippetId}/share`, {
        method: 'DELETE',
        headers: $08eb629ddb2e8bad$var$COMMON_HEADERS
    });
    (0, $lIx1f.clearSnippetsCache)();
};
/**
 * Fires a per-scope fetch-success operational event so a genuine fetch error
 * rate = failures / (successes + failures) can be computed at the same
 * granularity as the per-scope failure event. Only called for scopes that were
 * actually fetched (see the SITE caveat at the call site).
 */ const $08eb629ddb2e8bad$var$logResultSuccess = (scope)=>{
    (0, $2Qxf3.invokeFetchScopeSuccessCallback)({
        scope: scope
    });
};
const $08eb629ddb2e8bad$var$logResultError = (reason, scope)=>{
    const reasonString = reason instanceof Error ? reason.message : JSON.stringify(reason);
    const errorToLog = new Error(`Error when fetching ${scope} scoped snippets: ${reasonString}`);
    (0, $aUBmi.reportError)(errorToLog);
    // Fire an analytics operational event so per-scope fetch failures are countable
    // in dashboards (closes the measurement gap where swallowed errors were invisible).
    //
    // A structured `reason` (+ numeric `statusCode` for HTTP errors) is derived via
    // `classifyFetchError`, so genuine fetch failures can be grouped by cause and
    // separated from harmless localization/scope no-ops. We deliberately do NOT
    // forward the raw error message, since for HTTP failures it can embed the server
    // response body (potential PII/UGC) which must never be sent in analytics
    // operational events.
    (0, $2Qxf3.invokeFetchScopeErrorCallback)({
        scope: scope,
        ...(0, $eWCeD.classifyFetchError)(reason)
    });
};
module.exports["getIsSnippetSharingForSiteEnabled"] = $08eb629ddb2e8bad$export$a891d387a4e7ba6f;
module.exports["fetchSnippets"] = $08eb629ddb2e8bad$export$424a614da735364c;
module.exports["createSnippet"] = $08eb629ddb2e8bad$export$f7bed3a90241a88a;
module.exports["deleteSnippet"] = $08eb629ddb2e8bad$export$ba93a91dd8596775;
module.exports["updateSnippet"] = $08eb629ddb2e8bad$export$23a793f970583236;
module.exports["favoriteSnippet"] = $08eb629ddb2e8bad$export$d8ad364ff92072df;
module.exports["unfavoriteSnippet"] = $08eb629ddb2e8bad$export$8fa65d63d256253e;
module.exports["incrementSnippetInsertCount"] = $08eb629ddb2e8bad$export$d055ce15e6ca2d50;
module.exports["shareSnippet"] = $08eb629ddb2e8bad$export$694c1dfa19cf1dd0;
module.exports["claimSnippetShare"] = $08eb629ddb2e8bad$export$47e429919a88c99;
module.exports["unshareSnippet"] = $08eb629ddb2e8bad$export$c0ff842d3c1f78b9;

});

parcelRegister("fu7bs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jv11C = parcelRequire("jv11C");


var $c2ece = parcelRequire("c2ece");


var $doyqd = parcelRequire("doyqd");


var $akQCd = parcelRequire("akQCd");


var $6KLYS = parcelRequire("6KLYS");

const $bab9c284649130fd$var$SNIPPETS_PATH = '/snippets';
const $bab9c284649130fd$var$AGG_PATH = '/gateway/api/graphql';
const $bab9c284649130fd$var$normalizeLocale = (locale)=>locale.split('_').join('-');
const $bab9c284649130fd$var$NO_PRODUCT_CACHE_KEY = '__no-product__';
const $bab9c284649130fd$var$getSnippetsCacheKey = (params)=>params.locale ? [
        params.format,
        params.product ?? $bab9c284649130fd$var$NO_PRODUCT_CACHE_KEY,
        $bab9c284649130fd$var$normalizeLocale(params.locale)
    ].join(':') : undefined;
const $bab9c284649130fd$export$a891d387a4e7ba6f = async ()=>{
    try {
        const response = await fetch(`${(0, $c2ece.BLOCK_SERVICE_API_URL)}${$bab9c284649130fd$var$SNIPPETS_PATH}/settings`, {
            method: 'GET'
        });
        const data = await response.json();
        return data.sharingEnabled;
    } catch (error) {
        (0, $jv11C.logException)(error, {
            location: 'editor-snippets-provider/getIsSnippetSharingForSiteEnabled'
        });
        return false;
    }
};
const $bab9c284649130fd$export$424a614da735364c = async (params)=>{
    const isSnippetSharingForSiteEnabled = await $bab9c284649130fd$export$a891d387a4e7ba6f();
    const [globalSnippetsResponse, siteSnippetsResponse, userSnippetsResponse] = await Promise.allSettled([
        $bab9c284649130fd$export$cf060afb8b9f33e4({
            ...params,
            scope: (0, $doyqd.SnippetScope).GLOBAL
        }),
        isSnippetSharingForSiteEnabled ? $bab9c284649130fd$export$cf060afb8b9f33e4({
            format: params.format,
            product: params.product,
            scope: (0, $doyqd.SnippetScope).SITE
        }) : Promise.resolve({
            success: []
        }),
        $bab9c284649130fd$export$cf060afb8b9f33e4({
            format: params.format,
            scope: (0, $doyqd.SnippetScope).USER
        })
    ]);
    const globalSnippets = globalSnippetsResponse.status === 'fulfilled' ? globalSnippetsResponse.value : {
        success: []
    };
    const siteSnippets = siteSnippetsResponse.status === 'fulfilled' ? siteSnippetsResponse.value : {
        success: []
    };
    const userSnippets = userSnippetsResponse.status === 'fulfilled' ? userSnippetsResponse.value : {
        success: []
    };
    return [
        ...globalSnippets.success,
        ...siteSnippets.success,
        ...userSnippets.success
    ];
};
const $bab9c284649130fd$export$cf060afb8b9f33e4 = async (params)=>{
    const queryParams = new URLSearchParams({
        format: params.format,
        scope: params.scope
    });
    if (params.product) queryParams.set('product', params.product);
    if (params.scope === (0, $doyqd.SnippetScope).GLOBAL && params.locale) queryParams.set('locale', $bab9c284649130fd$var$normalizeLocale(params.locale));
    const response = await fetch(`${(0, $c2ece.BLOCK_SERVICE_API_URL) + $bab9c284649130fd$var$SNIPPETS_PATH}?${queryParams.toString()}`, {
        method: 'GET'
    });
    if (!response.ok) {
        const error = new Error(`Failed to fetch snippets for scope: ${params.scope}`);
        (0, $jv11C.logException)(error, {
            location: 'editor-snippets-provider/fetchSnippetsData'
        });
        throw error;
    }
    return await response.json();
};
const $bab9c284649130fd$export$1bea0d9a88a56139 = async (accountIds)=>{
    const USERS_OPERATION_NAME = 'SnippetsProviderUsersQuery';
    const USERS_QUERY = `
	query ${USERS_OPERATION_NAME}($accountIds: [ID!]!) {
		users(accountIds: $accountIds) {
			accountId
			name
		}
	}
`;
    try {
        const response = await fetch($bab9c284649130fd$var$AGG_PATH, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                operationName: USERS_OPERATION_NAME,
                query: USERS_QUERY,
                variables: {
                    accountIds: accountIds
                }
            })
        });
        const json = await response.json();
        return (json?.data?.users ?? []).map((u)=>({
                accountId: u.accountId ?? '',
                name: u.name ?? ''
            }));
    } catch (error) {
        (0, $jv11C.logException)(error, {
            location: 'editor-snippets-provider/fetchUsersFromAgg'
        });
        throw error;
    }
};
const $bab9c284649130fd$export$f1c9901b889f5301 = (params)=>({
        getSnippets: ()=>(0, $6KLYS.withSnippetsCache)(async ()=>{
                let snippets = await $bab9c284649130fd$export$424a614da735364c(params);
                if (!snippets) return [];
                if (!Array.isArray(snippets)) snippets = [
                    snippets
                ];
                const parsedSnippets = snippets.map((snippet)=>{
                    const snippetBody = $bab9c284649130fd$var$parseSnippetContent(snippet.body);
                    if (snippetBody === undefined) return undefined;
                    return {
                        ...snippet,
                        body: snippetBody,
                        templateType: snippet.templateType ?? (0, $doyqd.getTemplateTypeFromScope)(snippet.scope)
                    };
                }).filter((snippet)=>snippet !== undefined);
                if (parsedSnippets.length === 0) return parsedSnippets;
                const accountIds = parsedSnippets.map((s)=>s.createdBy);
                let userNameMap = {};
                try {
                    const users = await (0, $akQCd.batchFetchUsers)(accountIds, $bab9c284649130fd$export$1bea0d9a88a56139);
                    userNameMap = Object.fromEntries(users.map((u)=>[
                            u.accountId,
                            u.name
                        ]));
                } catch  {
                // fetchUsers failure is non-fatal — fall back to raw account IDs
                }
                return parsedSnippets.map((snippet)=>({
                        ...snippet,
                        createdBy: userNameMap[snippet.createdBy] ?? snippet.createdBy
                    }));
            }, $bab9c284649130fd$var$getSnippetsCacheKey(params))
    });
function $bab9c284649130fd$var$filterValidAdfNodes(nodes) {
    return nodes.filter((node)=>node !== undefined && node !== null);
}
const $bab9c284649130fd$var$parseSnippetContent = (content)=>{
    try {
        const parsedContent = JSON.parse(content);
        // Handle fragment (array of nodes without doc wrapper)
        if (Array.isArray(parsedContent)) return $bab9c284649130fd$var$wrapAdfWithDocNode($bab9c284649130fd$var$filterValidAdfNodes(parsedContent));
        const adfContent = parsedContent;
        if (adfContent.type === 'doc' && Array.isArray(adfContent.content)) return {
            ...adfContent,
            content: $bab9c284649130fd$var$filterValidAdfNodes(adfContent.content)
        };
        return $bab9c284649130fd$var$wrapAdfWithDocNode(adfContent);
    } catch (error) {
        (0, $jv11C.logException)(error, {
            location: 'editor-snippets-provider/parseSnippetContent'
        });
        return undefined;
    }
};
const $bab9c284649130fd$var$wrapAdfWithDocNode = (adf)=>{
    const docType = 'doc';
    const isArray = Array.isArray(adf);
    if (!isArray && adf.type === docType) return adf;
    const content = isArray ? adf : [
        adf
    ];
    return {
        version: 1,
        type: docType,
        content: content
    };
};
const $bab9c284649130fd$export$43bdc2e83cb3f88b = ({ locale: locale, product: product })=>(0, $cozmU.useMemo)(()=>({
            snippetsProvider: $bab9c284649130fd$export$f1c9901b889f5301({
                format: (0, $doyqd.SnippetBodyFormat).ADF,
                locale: locale,
                product: product
            })
        }), [
        locale,
        product
    ]);
module.exports["fetchSnippetsData"] = $bab9c284649130fd$export$cf060afb8b9f33e4;

});

parcelRegister("c2ece", function(module, exports) {

var $jv11C = parcelRequire("jv11C");

const $0ff9afec90b4860d$export$733c2045843b0072 = '/gateway/api/blocks/v1';
const $0ff9afec90b4860d$export$73c71f9590626082 = async (snippetId)=>{
    const response = await fetch(`${$0ff9afec90b4860d$export$733c2045843b0072}/snippets/${encodeURIComponent(snippetId)}/media-token`, {
        method: 'GET'
    });
    if (!response.ok) {
        const error = new Error(`Failed to fetch snippet media token for snippet ${snippetId}`);
        (0, $jv11C.logException)(error, {
            location: 'editor-snippets-provider/fetchSnippetMediaToken'
        });
        throw error;
    }
    const data = await response.json();
    return {
        clientId: data.config.clientId,
        token: data.token,
        baseUrl: data.config.fileStoreUrl,
        collectionName: data.collectionNames?.[snippetId] ?? `snippet-${snippetId}`
    };
};
const $0ff9afec90b4860d$export$43d25102300e787d = (contextId)=>{
    try {
        const { snippetId: snippetId, scope: scope } = JSON.parse(contextId);
        return typeof snippetId === 'string' && snippetId ? {
            snippetId: snippetId,
            scope: scope
        } : undefined;
    } catch  {
        (0, $jv11C.logException)(new Error('Failed to parse snippet context id'), {
            location: 'editor-snippets-provider/parseSnippetContextId'
        });
        return undefined;
    }
};
module.exports["BLOCK_SERVICE_API_URL"] = $0ff9afec90b4860d$export$733c2045843b0072;

});

parcelRegister("doyqd", function(module, exports) {
var $ff0b2232d9ba5732$export$4b7b09c17f5ba341 = /*#__PURE__*/ function(SnippetBodyFormat) {
    SnippetBodyFormat["ADF"] = "ADF";
    return SnippetBodyFormat;
}({});
var $ff0b2232d9ba5732$export$e6769779009a1fa2 = /*#__PURE__*/ function(SnippetProduct) {
    SnippetProduct["CONFLUENCE"] = "CONFLUENCE";
    SnippetProduct["JIRA"] = "JIRA";
    return SnippetProduct;
}({});
var $ff0b2232d9ba5732$export$100829e61c5df591 = /*#__PURE__*/ function(SnippetScope) {
    SnippetScope["GLOBAL"] = "GLOBAL";
    SnippetScope["SITE"] = "SITE";
    SnippetScope["USER"] = "USER";
    return SnippetScope;
}({});
var $ff0b2232d9ba5732$export$9826bdf5a11e7016 = /*#__PURE__*/ function(SnippetStatus) {
    SnippetStatus["ACTIVE"] = "active";
    SnippetStatus["DELETED"] = "deleted";
    return SnippetStatus;
}({});
var $ff0b2232d9ba5732$export$fd0446c06165ed92 = /*#__PURE__*/ function(TemplateType) {
    TemplateType["ATLASSIAN"] = "atlassian";
    TemplateType["USER"] = "user";
    return TemplateType;
}({});
const $ff0b2232d9ba5732$export$cd9a3fdeddd74923 = (scope)=>scope === "GLOBAL" ? "atlassian" : "user";
module.exports["SnippetBodyFormat"] = $ff0b2232d9ba5732$export$4b7b09c17f5ba341;
module.exports["SnippetProduct"] = $ff0b2232d9ba5732$export$e6769779009a1fa2;
module.exports["SnippetScope"] = $ff0b2232d9ba5732$export$100829e61c5df591;
module.exports["getTemplateTypeFromScope"] = $ff0b2232d9ba5732$export$cd9a3fdeddd74923;

});

parcelRegister("akQCd", function(module, exports) {
const $ffcbd784c4ceb085$export$3577ba943a5537ec = 90;
const $ffcbd784c4ceb085$export$9e6bcd01103e07f = async (accountIds, fetchBatch)=>{
    const unique = [
        ...new Set(accountIds)
    ];
    if (unique.length === 0) return [];
    const chunks = [];
    for(let i = 0; i < unique.length; i += $ffcbd784c4ceb085$export$3577ba943a5537ec)chunks.push(unique.slice(i, i + $ffcbd784c4ceb085$export$3577ba943a5537ec));
    const results = await Promise.all(chunks.map((chunk)=>fetchBatch(chunk)));
    return results.flat();
};
module.exports["batchFetchUsers"] = $ffcbd784c4ceb085$export$9e6bcd01103e07f;

});

parcelRegister("6KLYS", function(module, exports) {
let $1945d6de5da3143f$var$fetchSnippetsPromise = null;
let $1945d6de5da3143f$var$cachedSnippets = null;
const $1945d6de5da3143f$var$keyedFetchSnippetsPromises = new Map();
const $1945d6de5da3143f$var$keyedCachedSnippets = new Map();
const $1945d6de5da3143f$export$cf490a717245d06 = (fetcher, cacheKey)=>{
    if (!cacheKey) {
        if ($1945d6de5da3143f$var$fetchSnippetsPromise) return $1945d6de5da3143f$var$fetchSnippetsPromise;
        if ($1945d6de5da3143f$var$cachedSnippets !== null) return Promise.resolve($1945d6de5da3143f$var$cachedSnippets);
        $1945d6de5da3143f$var$fetchSnippetsPromise = (async ()=>{
            try {
                const result = await fetcher();
                $1945d6de5da3143f$var$cachedSnippets = result;
                return result;
            } finally{
                $1945d6de5da3143f$var$fetchSnippetsPromise = null;
            }
        })();
        return $1945d6de5da3143f$var$fetchSnippetsPromise;
    }
    const existingPromise = $1945d6de5da3143f$var$keyedFetchSnippetsPromises.get(cacheKey);
    if (existingPromise) return existingPromise;
    const cachedValue = $1945d6de5da3143f$var$keyedCachedSnippets.get(cacheKey);
    if (cachedValue !== undefined) return Promise.resolve(cachedValue);
    const keyedFetchSnippetsPromise = (async ()=>{
        try {
            const result = await fetcher();
            $1945d6de5da3143f$var$keyedCachedSnippets.set(cacheKey, result);
            return result;
        } finally{
            $1945d6de5da3143f$var$keyedFetchSnippetsPromises.delete(cacheKey);
        }
    })();
    $1945d6de5da3143f$var$keyedFetchSnippetsPromises.set(cacheKey, keyedFetchSnippetsPromise);
    return keyedFetchSnippetsPromise;
};
const $1945d6de5da3143f$export$88e3986896305eb8 = ()=>{
    $1945d6de5da3143f$var$cachedSnippets = null;
    $1945d6de5da3143f$var$fetchSnippetsPromise = null;
    $1945d6de5da3143f$var$keyedCachedSnippets.clear();
    $1945d6de5da3143f$var$keyedFetchSnippetsPromises.clear();
};
module.exports["withSnippetsCache"] = $1945d6de5da3143f$export$cf490a717245d06;

});

parcelRegister("2Qxf3", function(module, exports) {
/**
 * Fetch Actions - Data fetching and cache management for snippets
 *
 * These actions handle data fetching and cache management.
 * They interact with the blockServiceClient to make API calls and update the store.
 *
 * Key behaviors:
 * - fetchSnippets: Implements request deduplication via isLoaded/isLoading flags
 * - clearCache: Resets the store to allow fresh data on next fetch
 *
 * For snippet creation with UI feedback, see createActions.ts
 */ 
var $3e10B = parcelRequire("3e10B");


var $lIx1f = parcelRequire("lIx1f");


var $aUBmi = parcelRequire("aUBmi");


var $cga1x = parcelRequire("cga1x");


var $7DXt6 = parcelRequire("7DXt6");

/**
 * Module-level callback for fetch performance metrics.
 * The host (React layer with analytics) can register a callback via setOnFetchComplete
 * to receive performance data after each successful fetch.
 */ let $bd8808f2d9e2200a$var$onFetchCompleteCallback = null;
const $bd8808f2d9e2200a$export$19bcef6f062e1ea9 = (callback)=>{
    $bd8808f2d9e2200a$var$onFetchCompleteCallback = callback;
};
/**
 * Module-level callback for per-scope fetch errors.
 * The host (React layer with analytics) can register a callback via setOnFetchScopeError
 * to fire analytics events when an individual scope fetch fails.
 */ let $bd8808f2d9e2200a$var$onFetchScopeErrorCallback = null;
const $bd8808f2d9e2200a$export$17d06ca3d49567b6 = (callback)=>{
    $bd8808f2d9e2200a$var$onFetchScopeErrorCallback = callback;
};
const $bd8808f2d9e2200a$export$c7148b1001bcf505 = (info)=>{
    $bd8808f2d9e2200a$var$onFetchScopeErrorCallback?.(info);
};
/**
 * Module-level callback for per-scope fetch successes.
 *
 * Fires once per scope that resolves successfully, mirroring the per-scope
 * failure callback. This lets analytics compute a genuine fetch error rate
 * (failures / (successes + failures)) at the same granularity as the failure
 * event, rather than comparing per-scope failures against a single per-fetch
 * success signal.
 */ let $bd8808f2d9e2200a$var$onFetchScopeSuccessCallback = null;
const $bd8808f2d9e2200a$export$4785ee3a2c9609c = (callback)=>{
    $bd8808f2d9e2200a$var$onFetchScopeSuccessCallback = callback;
};
const $bd8808f2d9e2200a$export$95468e56264584e8 = (info)=>{
    $bd8808f2d9e2200a$var$onFetchScopeSuccessCallback?.(info);
};
/**
 * Handles error reporting for fetch actions.
 * Sets fetchError state, reports to monitoring, and re-throws.
 */ const $bd8808f2d9e2200a$var$handleError = (error, setState, resetIsLoaded = true)=>{
    const err = error instanceof Error ? error : new Error(String(error));
    setState({
        isLoading: false,
        fetchError: err,
        ...resetIsLoaded && {
            isLoaded: false
        }
    });
    (0, $aUBmi.reportError)(err);
    throw err;
};
const $bd8808f2d9e2200a$export$4286ff85d0f23d31 = {
    /**
   * Fetches snippets from the server.
   *
   * Implements request deduplication: if snippets are already loaded (isLoaded=true)
   * or a request is in progress (isLoading=true), returns cached data immediately.
   * This allows multiple components to call fetchSnippets() without causing
   * redundant API requests.
   *
   * Resolves site config (isSnippetSharingForSiteEnabled) and fetches user, global,
   * and optionally site-scoped snippets; stores the config in state for later use.
   *
   * @returns Promise resolving to the snippets array
   */ fetchSnippets: (locale)=>async ({ getState: getState, setState: setState })=>{
            const { isLoaded: isLoaded, isLoading: isLoading, snippetsLocale: snippetsLocale } = getState();
            const isLoadedForRequestedLocale = isLoaded && snippetsLocale === locale;
            const isLoadingForRequestedLocale = isLoading && snippetsLocale === locale;
            // Request deduplication: return cached data if already loaded or loading for the requested locale
            if (isLoadedForRequestedLocale || isLoadingForRequestedLocale) return getState().snippets;
            setState({
                isLoading: true,
                fetchError: null,
                snippetsLocale: locale
            });
            try {
                const fetchStart = performance.now();
                const isSnippetSharingForSiteEnabled = await $3e10B.getIsSnippetSharingForSiteEnabled();
                const snippets = await $3e10B.fetchSnippets({
                    isSnippetSharingForSiteEnabled: isSnippetSharingForSiteEnabled,
                    locale: locale
                });
                const durationMs = Math.round(performance.now() - fetchStart);
                setState({
                    snippets: snippets,
                    isLoading: false,
                    fetchError: null,
                    isLoaded: true,
                    isSnippetSharingForSiteEnabled: isSnippetSharingForSiteEnabled,
                    snippetsLocale: locale
                });
                // Fire performance metrics callback if registered
                if ($bd8808f2d9e2200a$var$onFetchCompleteCallback) {
                    const siteScopeCount = snippets.filter((s)=>s.scope === (0, $cga1x.SnippetScope).SITE).length;
                    const globalScopeCount = snippets.filter((s)=>s.scope === (0, $cga1x.SnippetScope).GLOBAL).length;
                    $bd8808f2d9e2200a$var$onFetchCompleteCallback({
                        snippetCount: snippets.length,
                        userScopeCount: snippets.length - globalScopeCount - siteScopeCount,
                        siteScopeCount: siteScopeCount,
                        globalScopeCount: globalScopeCount,
                        payloadSizeBytes: new Blob([
                            JSON.stringify(snippets)
                        ]).size,
                        durationMs: durationMs
                    });
                }
                // Invoke any one-time callbacks registered while this fetch was in progress
                (0, $7DXt6.invokePendingLoadCallbacks)(snippets);
                return snippets;
            } catch (thrownError) {
                return $bd8808f2d9e2200a$var$handleError(thrownError, setState, true);
            }
        },
    /**
   * Clears both the service cache and store state.
   *
   * Use this when you need to force a fresh fetch on the next request,
   * such as after external changes to snippets data.
   */ clearCache: ()=>({ setState: setState })=>{
            (0, $lIx1f.clearSnippetsCache)();
            setState({
                snippets: [],
                isLoaded: false
            });
        }
};
module.exports["setOnFetchComplete"] = $bd8808f2d9e2200a$export$19bcef6f062e1ea9;
module.exports["setOnFetchScopeError"] = $bd8808f2d9e2200a$export$17d06ca3d49567b6;
module.exports["invokeFetchScopeErrorCallback"] = $bd8808f2d9e2200a$export$c7148b1001bcf505;
module.exports["setOnFetchScopeSuccess"] = $bd8808f2d9e2200a$export$4785ee3a2c9609c;
module.exports["invokeFetchScopeSuccessCallback"] = $bd8808f2d9e2200a$export$95468e56264584e8;
module.exports["fetchActions"] = $bd8808f2d9e2200a$export$4286ff85d0f23d31;

});

parcelRegister("lIx1f", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

let $df86535d196acbcf$var$fetchSnippetsPromise = null;
let $df86535d196acbcf$var$cachedSnippets = null;
const $df86535d196acbcf$var$keyedFetchSnippetsPromises = new Map();
const $df86535d196acbcf$var$keyedCachedSnippets = new Map();
const $df86535d196acbcf$export$cf490a717245d06 = (fetcher, cacheKey)=>{
    if (!cacheKey || !(0, $9wGTI.fg)('platform_editor_block_template_i18n')) {
        if ($df86535d196acbcf$var$fetchSnippetsPromise) return $df86535d196acbcf$var$fetchSnippetsPromise;
        if ($df86535d196acbcf$var$cachedSnippets !== null) return Promise.resolve($df86535d196acbcf$var$cachedSnippets);
        $df86535d196acbcf$var$fetchSnippetsPromise = (async ()=>{
            try {
                const result = await fetcher();
                $df86535d196acbcf$var$cachedSnippets = result;
                return result;
            } finally{
                $df86535d196acbcf$var$fetchSnippetsPromise = null;
            }
        })();
        return $df86535d196acbcf$var$fetchSnippetsPromise;
    }
    const existingPromise = $df86535d196acbcf$var$keyedFetchSnippetsPromises.get(cacheKey);
    if (existingPromise) return existingPromise;
    const cachedValue = $df86535d196acbcf$var$keyedCachedSnippets.get(cacheKey);
    if (cachedValue !== undefined) return Promise.resolve(cachedValue);
    const keyedFetchSnippetsPromise = (async ()=>{
        try {
            const result = await fetcher();
            $df86535d196acbcf$var$keyedCachedSnippets.set(cacheKey, result);
            return result;
        } finally{
            $df86535d196acbcf$var$keyedFetchSnippetsPromises.delete(cacheKey);
        }
    })();
    $df86535d196acbcf$var$keyedFetchSnippetsPromises.set(cacheKey, keyedFetchSnippetsPromise);
    return keyedFetchSnippetsPromise;
};
const $df86535d196acbcf$export$88e3986896305eb8 = ()=>{
    $df86535d196acbcf$var$cachedSnippets = null;
    $df86535d196acbcf$var$fetchSnippetsPromise = null;
    $df86535d196acbcf$var$keyedCachedSnippets.clear();
    $df86535d196acbcf$var$keyedFetchSnippetsPromises.clear();
};
module.exports["withSnippetsCache"] = $df86535d196acbcf$export$cf490a717245d06;
module.exports["clearSnippetsCache"] = $df86535d196acbcf$export$88e3986896305eb8;

});

parcelRegister("77Hid", function(module, exports) {
var $0b7d55ca130debf0$export$4b7b09c17f5ba341 = /*#__PURE__*/ function(SnippetBodyFormat) {
    // Only ADF is allowed currently but more will be added:
    // 		https://bitbucket.org/atlassian/block-service/src/main/nebulae/seeding/ers/schemas
    SnippetBodyFormat["ADF"] = "ADF";
    return SnippetBodyFormat;
}({});
module.exports["SnippetBodyFormat"] = $0b7d55ca130debf0$export$4b7b09c17f5ba341;

});

parcelRegister("5ra2J", function(module, exports) {

var $awkhV = parcelRequire("awkhV");


var $aUBmi = parcelRequire("aUBmi");


var $9Gk5O = parcelRequire("9Gk5O");


var $ies1q = parcelRequire("ies1q");


var $kVh3A = parcelRequire("kVh3A");


var $doyqd = parcelRequire("doyqd");

const $4006419802f3d045$export$e7219ab2842dfbd2 = async (snippets)=>{
    const creatorAccountIds = snippets.map((s)=>s.createdBy).filter(Boolean);
    const creatorMap = await (0, $kVh3A.getCachedOrFetchUserInfos)(creatorAccountIds);
    return snippets.map((snippet)=>$4006419802f3d045$var$transformSnippetData(snippet, creatorMap)).filter((snippet)=>snippet !== undefined);
};
const $4006419802f3d045$export$27f6ce18fbe7c295 = async (snippet)=>{
    const creatorMap = await (0, $kVh3A.getCachedOrFetchUserInfos)([
        snippet.createdBy
    ]);
    return $4006419802f3d045$var$transformSnippetData(snippet, creatorMap);
};
const $4006419802f3d045$var$transformSnippetData = (snippet, creatorMap)=>{
    try {
        const parsedBody = (0, $ies1q.parseSnippetContent)(snippet.body);
        if (parsedBody === undefined) return undefined;
        const createdBy = creatorMap.get(snippet.createdBy) ?? (0, $kVh3A.getDefaultUserInfo)(snippet.createdBy, null);
        // BE returns isShared for USER and SITE scope; fallback when missing (e.g. SITE => true).
        const isShared = snippet.isShared ?? false;
        return {
            ari: (0, $awkhV.BlocksSnippetAri).parse(snippet.resourceId),
            snippetId: snippet.snippetId,
            name: snippet.name,
            description: snippet.description,
            bodyFormat: snippet.bodyFormat,
            body: parsedBody,
            product: snippet.product,
            isFavorite: Boolean(snippet.isFavorite),
            status: snippet.status,
            scope: snippet.scope,
            isShared: isShared,
            templateType: snippet.templateType ?? (0, $doyqd.getTemplateTypeFromScope)(snippet.scope),
            createdBy: createdBy,
            createdAt: new Date(Number(snippet.createdAt)),
            updatedAt: new Date(Number(snippet.updatedAt)),
            insertCount: snippet.insertCount,
            shareUrl: (0, $9Gk5O.getSnippetShareUrl)(snippet.snippetId, snippet.shareId)
        };
    } catch (error) {
        (0, $aUBmi.reportError)(error instanceof Error ? error : new Error(`Failed to transform snippet ${snippet.snippetId}: ${String(error)}`));
        return undefined;
    }
};
module.exports["transformSnippets"] = $4006419802f3d045$export$e7219ab2842dfbd2;
module.exports["transformSnippet"] = $4006419802f3d045$export$27f6ce18fbe7c295;

});

parcelRegister("awkhV", function(module, exports) {

var $koEca = parcelRequire("koEca");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/blocks/snippet/manifest.ts
var $7a8ca150e56bf301$var$blocksSnippetAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $koEca.BlocksSnippetAriResourceOwner),
    resourceType: (0, $koEca.BlocksSnippetAriResourceType),
    resourceIdSlug: "workspace/{workspaceId}/{snippetId}",
    resourceIdSegmentFormats: {
        workspaceId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        snippetId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-7][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/blocks/snippet/index.ts
var $7a8ca150e56bf301$export$7140b52dd9778730 = class _BlocksSnippetAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get workspaceId() {
        return this._workspaceId;
    }
    get snippetId() {
        return this._snippetId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7a8ca150e56bf301$var$blocksSnippetAriStaticOpts.qualifier,
            platformQualifier: $7a8ca150e56bf301$var$blocksSnippetAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $7a8ca150e56bf301$var$blocksSnippetAriStaticOpts.resourceOwner,
            resourceType: $7a8ca150e56bf301$var$blocksSnippetAriStaticOpts.resourceType,
            resourceId: `workspace/${opts.workspaceId}/${opts.snippetId}`,
            resourceIdSegmentValues: {
                workspaceId: opts.workspaceId,
                snippetId: opts.snippetId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $7a8ca150e56bf301$var$blocksSnippetAriStaticOpts);
        return new _BlocksSnippetAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $7a8ca150e56bf301$var$blocksSnippetAriStaticOpts);
        return new _BlocksSnippetAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            workspaceId: this.workspaceId,
            snippetId: this.snippetId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._workspaceId = opts.resourceIdSegmentValues.workspaceId, this._snippetId = opts.resourceIdSegmentValues.snippetId;
    }
};
module.exports["BlocksSnippetAri"] = $7a8ca150e56bf301$export$7140b52dd9778730;

});

parcelRegister("koEca", function(module, exports) {
// src/blocks/snippet/types.ts
var $ed953a75475563ad$export$c5a78d3da90ef749 = "blocks", $ed953a75475563ad$export$38b3a184e1acf0da = "snippet";
module.exports["BlocksSnippetAriResourceOwner"] = $ed953a75475563ad$export$c5a78d3da90ef749;
module.exports["BlocksSnippetAriResourceType"] = $ed953a75475563ad$export$38b3a184e1acf0da;

});

parcelRegister("9Gk5O", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $1bbe7085ffc2b656$var$TEMPLATE_GALLERY_TAB_BLOCK = 'block';
const $1bbe7085ffc2b656$export$db5a6d7adf00bf9c = (snippetId, shareId)=>{
    const query = {
        tab: $1bbe7085ffc2b656$var$TEMPLATE_GALLERY_TAB_BLOCK,
        snippetId: snippetId
    };
    if (shareId) query.shareId = shareId;
    return (0, $1NBp8.TEMPLATE_GALLERY).toUrl({}, {
        query: query
    });
};
module.exports["getSnippetShareUrl"] = $1bbe7085ffc2b656$export$db5a6d7adf00bf9c;

});

parcelRegister("kVh3A", function(module, exports) {

var $buwvF = parcelRequire("buwvF");


var $7yBUT = parcelRequire("7yBUT");


var $2uxuh = parcelRequire("2uxuh");

const $43931bab9ad90905$var$ATLASSIAN_SNIPPET_OWNER = {
    accountId: (0, $buwvF.ATLASSIAN_ACCOUNT_ID),
    displayName: 'Atlassian'
};
const $43931bab9ad90905$export$c93a1f4a0896e9e1 = (userId)=>{
    return `/wiki/aa-avatar/${encodeURIComponent(userId)}`;
};
const $43931bab9ad90905$export$8cbbf176c5a0d090 = (userId, displayName)=>{
    return {
        accountId: userId,
        displayName: displayName ?? userId,
        avatarUrl: $43931bab9ad90905$export$c93a1f4a0896e9e1(userId)
    };
};
const $43931bab9ad90905$export$f4dafa0b5f6b7602 = async (accountIds)=>{
    const resultMap = new Map();
    const uniqueAccountIds = [
        ...new Set(accountIds.filter(Boolean))
    ];
    const uncachedAccountIds = [];
    for (const id of uniqueAccountIds){
        if (id.toLowerCase() === (0, $buwvF.ATLASSIAN_ACCOUNT_ID).toLowerCase()) {
            resultMap.set(id, $43931bab9ad90905$var$ATLASSIAN_SNIPPET_OWNER);
            continue;
        }
        const cachedSnippetOwner = (0, $2uxuh.USER_CACHE).get(id.toLowerCase());
        if (cachedSnippetOwner) {
            resultMap.set(id, cachedSnippetOwner);
            continue;
        }
        uncachedAccountIds.push(id);
    }
    if (uncachedAccountIds.length > 0) {
        const batchUserData = await (0, $7yBUT.fetchUsersBatch)(uncachedAccountIds);
        for (const userData of batchUserData){
            const owner = {
                accountId: userData.accountId,
                displayName: userData.displayName ?? userData.accountId,
                avatarUrl: userData.avatarUrl ?? $43931bab9ad90905$export$c93a1f4a0896e9e1(userData.accountId)
            };
            (0, $2uxuh.USER_CACHE).set(userData.accountId.toLowerCase(), owner);
        }
        for (const id of uncachedAccountIds){
            const owner = (0, $2uxuh.USER_CACHE).get(id.toLowerCase()) ?? $43931bab9ad90905$export$8cbbf176c5a0d090(id, null);
            resultMap.set(id, owner);
        }
    }
    return resultMap;
};
module.exports["getDefaultUserInfo"] = $43931bab9ad90905$export$8cbbf176c5a0d090;
module.exports["getCachedOrFetchUserInfos"] = $43931bab9ad90905$export$f4dafa0b5f6b7602;

});

parcelRegister("buwvF", function(module, exports) {
const $36c35f590e2b0286$export$7f38f8cc01c20d32 = 'atlassian';
module.exports["ATLASSIAN_ACCOUNT_ID"] = $36c35f590e2b0286$export$7f38f8cc01c20d32;

});

parcelRegister("7yBUT", function(module, exports) {
/**
 * @graphql agg
 *
 * AGG (Atlassian GraphQL Gateway) batch user query.
 */ 
var $iLX84 = parcelRequire("iLX84");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $aUBmi = parcelRequire("aUBmi");

const $50afcdaae69a1b61$var$BlockServiceAggUserQueryFetchUsersBatchQuery = (0, $iLX84.default)`query blockServiceAggUserQueryFetchUsersBatchQuery($accountIds:[ID!]!){users(accountIds:$accountIds){accountId name picture}}`;
/** Maximum number of account IDs per AGG users batch request. */ const $50afcdaae69a1b61$var$AGG_USERS_BATCH_LIMIT = 90;
function $50afcdaae69a1b61$var$chunk(array, size) {
    const chunks = [];
    for(let i = 0; i < array.length; i += size)chunks.push(array.slice(i, i + size));
    return chunks;
}
function $50afcdaae69a1b61$var$mapUsersToBatchUserInfo(users) {
    if (!users || !Array.isArray(users)) return [];
    return users.filter((user)=>user != null && Boolean(user.accountId)).map((user)=>({
            accountId: user.accountId,
            displayName: user.name ?? user.accountId,
            avatarUrl: user.picture ?? undefined
        }));
}
async function $50afcdaae69a1b61$var$fetchUsersBatchSingle(batchAccountIds) {
    const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
        query: $50afcdaae69a1b61$var$BlockServiceAggUserQueryFetchUsersBatchQuery,
        variables: {
            accountIds: batchAccountIds
        },
        interopApolloAggClient: true,
        __callerPackage__: "snippets"
    });
    error?.graphQLErrors?.forEach((graphQLError)=>{
        $50afcdaae69a1b61$var$logFetchError(graphQLError);
        (0, $7Sm4c.markErrorAsHandled)(graphQLError);
    });
    return $50afcdaae69a1b61$var$mapUsersToBatchUserInfo(data?.users);
}
const $50afcdaae69a1b61$export$f79927f290b67443 = async (accountIds)=>{
    if (accountIds.length === 0) return [];
    try {
        const batches = $50afcdaae69a1b61$var$chunk(accountIds, $50afcdaae69a1b61$var$AGG_USERS_BATCH_LIMIT);
        const results = await Promise.all(batches.map($50afcdaae69a1b61$var$fetchUsersBatchSingle));
        return results.flat();
    } catch (error) {
        $50afcdaae69a1b61$var$logFetchError(error);
        (0, $7Sm4c.markErrorAsHandled)(error);
        return [];
    }
};
const $50afcdaae69a1b61$var$logFetchError = (maybeError)=>{
    const error = maybeError instanceof Error ? maybeError : new Error(String(maybeError));
    const errorToLog = new Error(`Error when fetching Snippet owner user details: ${error?.message || JSON.stringify(error)}`);
    (0, $aUBmi.reportError)(errorToLog);
};
module.exports["fetchUsersBatch"] = $50afcdaae69a1b61$export$f79927f290b67443;

});

parcelRegister("2uxuh", function(module, exports) {
const $feaa4bed83d900b4$export$1102191c744ab479 = new Map();
const $feaa4bed83d900b4$export$c93af146ba17833f = ()=>{
    $feaa4bed83d900b4$export$1102191c744ab479.clear();
};
module.exports["USER_CACHE"] = $feaa4bed83d900b4$export$1102191c744ab479;

});

parcelRegister("eDBud", function(module, exports) {
const $441c04495869cf24$export$f215cb69de957178 = (flags, title, description, actions)=>{
    if (!flags) return;
    flags.showSuccessFlag({
        title: title,
        description: description ?? '',
        isAutoDismiss: true,
        ...actions && {
            actions: actions
        }
    });
};
const $441c04495869cf24$export$41b17d176beb3ddb = (flags, title, description)=>{
    if (!flags) return;
    flags.showErrorFlag({
        title: title,
        description: description ?? '',
        isAutoDismiss: true
    });
};
module.exports["showSnippetSuccessFlag"] = $441c04495869cf24$export$f215cb69de957178;
module.exports["showSnippetErrorFlag"] = $441c04495869cf24$export$41b17d176beb3ddb;

});

parcelRegister("9gUQP", function(module, exports) {

var $eWCeD = parcelRequire("eWCeD");


var $6K2yS = parcelRequire("6K2yS");


var $5OfFS = parcelRequire("5OfFS");


var $77Hid = parcelRequire("77Hid");


var $lGxKg = parcelRequire("lGxKg");


var $gdHn1 = parcelRequire("gdHn1");

const $83472051e80c3ce9$export$8a3e92c118401aaf = (error, actionErrorFlagTitle, actionErrorFlagDescription)=>{
    const isBodyTooLarge = (0, $eWCeD.isBodyTooLargeError)(error);
    return {
        flagTitle: isBodyTooLarge ? (0, $6K2yS.messages).contentTooLargeFlagTitle : actionErrorFlagTitle,
        flagDescription: isBodyTooLarge ? (0, $6K2yS.messages).contentTooLargeFlagDescription : actionErrorFlagDescription
    };
};
function $83472051e80c3ce9$export$d592730130067dd1(name, body, description) {
    const descriptionValue = description?.trim();
    return {
        name: name,
        ...descriptionValue && {
            description: descriptionValue
        },
        body: JSON.stringify(body),
        bodyFormat: (0, $77Hid.SnippetBodyFormat).ADF,
        product: (0, $lGxKg.SnippetProduct).CONFLUENCE
    };
}
async function $83472051e80c3ce9$export$4badc9912ee9505f({ snippet: snippet, options: options, storeApi: storeApi, onShareFailure: onShareFailure }) {
    const { getState: getState, dispatch: dispatch } = storeApi;
    const { flags: flags, intl: intl, editorAPI: editorAPI, isShared: isShared } = options;
    if (editorAPI) (0, $5OfFS.addSnippetQuickInsertItem)({
        snippet: snippet,
        editorAPI: editorAPI
    });
    if (getState().isSnippetSharingForSiteEnabled && isShared) await dispatch((0, $gdHn1.shareActions).shareSnippet(snippet.snippetId, {
        flags: flags,
        intl: intl,
        editorAPI: editorAPI ?? undefined,
        onShareFailure: onShareFailure
    }));
}
module.exports["getSnippetErrorFlagMessages"] = $83472051e80c3ce9$export$8a3e92c118401aaf;
module.exports["buildCreatePayload"] = $83472051e80c3ce9$export$d592730130067dd1;
module.exports["addSnippetToQuickInsertAndShare"] = $83472051e80c3ce9$export$4badc9912ee9505f;

});

parcelRegister("5OfFS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aPdNQ = parcelRequire("aPdNQ");


var $ivert = parcelRequire("ivert");


var $hPTbh = parcelRequire("hPTbh");


var $4uowN = parcelRequire("4uowN");


var $lCB0R = parcelRequire("lCB0R");

/**
 * Fires an `insertSnippet` UI event with `origin=quickInsert` using the
 * editor's analytics plugin. No-op if the analytics plugin or its
 * `createAnalyticsEvent` factory is unavailable.
 *
 * `PublicPluginAPI` exposes optional plugin dependencies (such as analytics)
 * as optional properties, so the analytics plugin can be read defensively via
 * optional chaining without a type assertion.
 */ const $e4e416e4fc84d656$var$fireQuickInsertSnippetInsertedAnalytic = (editorAPI, snippet)=>{
    const analyticsApi = editorAPI?.analytics;
    const createAnalyticsEvent = analyticsApi?.sharedState.currentState()?.createAnalyticsEvent;
    (0, $4uowN.fireSnippetUIEvent)(createAnalyticsEvent, (0, $4uowN.buildInsertSnippetEventData)(snippet), (0, $hPTbh.ANALYTICS_ORIGIN).QUICK_INSERT);
};
const $e4e416e4fc84d656$export$a72e587fbb595114 = ({ snippet: snippet, editorAPI: editorAPI })=>{
    if (!editorAPI) return;
    const addQuickInsertItem = editorAPI?.quickInsert?.commands?.addQuickInsertItem;
    if (addQuickInsertItem === undefined) return;
    editorAPI.core?.actions.execute(addQuickInsertItem((intl)=>[
            $e4e416e4fc84d656$export$bf974db7a6bf9b4b({
                snippet: snippet,
                intl: intl,
                editorAPI: editorAPI
            })
        ]));
};
const $e4e416e4fc84d656$export$942aea5178818d5f = ({ snippet: snippet, editorAPI: editorAPI })=>{
    if (!editorAPI) return;
    const updateQuickInsertItem = editorAPI?.quickInsert?.commands?.updateQuickInsertItem ?? null;
    if (!updateQuickInsertItem) return;
    editorAPI.core?.actions.execute(updateQuickInsertItem((0, $lCB0R.getSnippetQuickInsertKey)(snippet.snippetId), (intl)=>[
            $e4e416e4fc84d656$export$bf974db7a6bf9b4b({
                snippet: snippet,
                intl: intl,
                editorAPI: editorAPI
            })
        ]));
};
const $e4e416e4fc84d656$export$bf974db7a6bf9b4b = ({ snippet: snippet, intl: intl, editorAPI: editorAPI })=>{
    return {
        key: (0, $lCB0R.getSnippetQuickInsertKey)(snippet.snippetId),
        title: snippet.name,
        description: (0, $lCB0R.createSnippetDescription)(snippet.createdBy, intl, snippet.description),
        keywords: (0, $lCB0R.extractSnippetKeywords)(snippet.name, intl),
        isDisabledOffline: true,
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ivert))), {
                label: "Snippet"
            }),
        action: (insert, state)=>{
            const body = snippet.body;
            if (!body) return false;
            const result = Array.isArray(body) ? insert((0, $aPdNQ.Fragment).fromJSON(state.schema, body)) : insert(body);
            if (result) $e4e416e4fc84d656$var$fireQuickInsertSnippetInsertedAnalytic(editorAPI, snippet);
            return result;
        }
    };
};
module.exports["addSnippetQuickInsertItem"] = $e4e416e4fc84d656$export$a72e587fbb595114;
module.exports["updateSnippetInQuickInsertItem"] = $e4e416e4fc84d656$export$942aea5178818d5f;

});

parcelRegister("ivert", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0cdccba3d7742a12d1dd259bf333308d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d78653211ce9e783$var$_react = $d78653211ce9e783$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d78653211ce9e783$var$_baseNew = $d78653211ce9e783$var$_interopRequireDefault((parcelRequire("gElAV")));
function $d78653211ce9e783$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Template".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved fore templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d78653211ce9e783$var$TemplateIcon = (props)=>/*#__PURE__*/ $d78653211ce9e783$var$_react.default.createElement($d78653211ce9e783$var$_baseNew.default, Object.assign({
        name: "TemplateIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 6h-7v7.5H13a.5.5 0 0 0 .5-.5zm-11 7a.5.5 0 0 0 .5.5h2V6H2.5zm11-10a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v1.5h11zM15 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$d78653211ce9e783$var$TemplateIcon.displayName = 'TemplateIcon';
var $d78653211ce9e783$var$_default = module.exports.default = $d78653211ce9e783$var$TemplateIcon;

});

parcelRegister("lCB0R", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $9wGTI = parcelRequire("9wGTI");


var $buwvF = parcelRequire("buwvF");

const $9362cb4ff6d42180$var$messages = (0, $kSwu1.defineMessages)({
    snippetBy: {
        id: "snippets.quick-insert.by",
        defaultMessage: "by {name}"
    },
    template: {
        id: "snippets.quick-insert.template",
        defaultMessage: "template"
    },
    block: {
        id: "snippets.quick-insert.block",
        defaultMessage: "block"
    }
});
/** Prefix for snippet quick insert item keys in the editor. */ const $9362cb4ff6d42180$var$SNIPPET_QUICK_INSERT_KEY_PREFIX = 'snippet-extension:snippet-';
const $9362cb4ff6d42180$export$695a8bc53bbc641e = (snippetId)=>`${$9362cb4ff6d42180$var$SNIPPET_QUICK_INSERT_KEY_PREFIX}${snippetId}`;
const $9362cb4ff6d42180$export$fefb8fa12cc0572f = (name, intl)=>{
    const nameKeywords = name.split(/\s+/).map((word)=>word.toLowerCase().trim()).filter((word)=>word.length > 0);
    const templateKeyword = intl.formatMessage($9362cb4ff6d42180$var$messages.template).toLowerCase();
    const blockKeyword = intl.formatMessage($9362cb4ff6d42180$var$messages.block).toLowerCase();
    const allKeywords = (0, $9wGTI.fg)('platform_synced_block_patch_13') ? [
        templateKeyword,
        blockKeyword
    ] : [
        ...nameKeywords,
        templateKeyword
    ];
    return Array.from(new Set(allKeywords));
};
const $9362cb4ff6d42180$export$4a4fbbff52147a2b = (createdBy, intl, description)=>{
    if (description && (0, $9wGTI.fg)('platform_synced_block_patch_13')) return description;
    const name = createdBy.displayName || createdBy.accountId;
    return intl.formatMessage($9362cb4ff6d42180$var$messages.snippetBy, {
        name: name
    });
};
const $9362cb4ff6d42180$var$isValidQuickInsertSnippet = (snippet, userId)=>snippet.createdBy.accountId === userId || snippet.createdBy.accountId === (0, $buwvF.ATLASSIAN_ACCOUNT_ID) || snippet.isFavorite;
const $9362cb4ff6d42180$var$getSortPriority = (snippet, userId)=>{
    // 1st: created by the current user
    if (snippet.createdBy.accountId === userId) return 0;
    // 2nd: favorited (but not created by the current user)
    if (snippet.isFavorite) return 1;
    // 3rd: Atlassian-created (GLOBAL scope) / others that already passed the previous filter
    return 2;
};
const $9362cb4ff6d42180$export$d0e0de50c701304c = (snippets, userId)=>{
    return snippets.filter((snippet)=>$9362cb4ff6d42180$var$isValidQuickInsertSnippet(snippet, userId)).sort((a, b)=>$9362cb4ff6d42180$var$getSortPriority(a, userId) - $9362cb4ff6d42180$var$getSortPriority(b, userId));
};
module.exports["getSnippetQuickInsertKey"] = $9362cb4ff6d42180$export$695a8bc53bbc641e;
module.exports["extractSnippetKeywords"] = $9362cb4ff6d42180$export$fefb8fa12cc0572f;
module.exports["createSnippetDescription"] = $9362cb4ff6d42180$export$4a4fbbff52147a2b;
module.exports["filterAndSort"] = $9362cb4ff6d42180$export$d0e0de50c701304c;

});

parcelRegister("lGxKg", function(module, exports) {
var $ffe8f943ede6b1fa$export$e6769779009a1fa2 = /*#__PURE__*/ function(SnippetProduct) {
    // Only Confluence is allowed currently but more will be added:
    // 		https://bitbucket.org/atlassian/block-service/src/main/nebulae/seeding/ers/schemas
    SnippetProduct["CONFLUENCE"] = "CONFLUENCE";
    return SnippetProduct;
}({});
module.exports["SnippetProduct"] = $ffe8f943ede6b1fa$export$e6769779009a1fa2;

});

parcelRegister("gdHn1", function(module, exports) {
/**
 * Share Actions - Share/unshare snippets with UI integration
 *
 * Handles POST/DELETE on v1/snippets/{snippetId}/share for setting isShared to true (shared)
 * or back to false (private). On success: updates the snippet in store (isShared) and
 * in the editor quick insert when editorAPI is passed. On error: shows error flag and
 * reports to monitoring.
 *
 * Call these after create/update/duplicate succeeds when the user's isShared differs
 * from the snippet's current value.
 */ 
var $kSwu1 = parcelRequire("kSwu1");


var $3e10B = parcelRequire("3e10B");


var $aUBmi = parcelRequire("aUBmi");


var $5OfFS = parcelRequire("5OfFS");


var $eDBud = parcelRequire("eDBud");


var $5ra2J = parcelRequire("5ra2J");


var $7DXt6 = parcelRequire("7DXt6");

const $6ee676e3d95c77de$var$shareActionsMessages = (0, $kSwu1.defineMessages)({
    claimShareErrorFlagTitle: {
        id: "snippets.shareActions.claimShareErrorFlagTitle",
        defaultMessage: "Could not access template"
    },
    claimShareErrorFlagDescription: {
        id: "snippets.shareActions.claimShareErrorFlagDescription",
        defaultMessage: "The share link may be invalid."
    },
    shareErrorFlagTitle: {
        id: "snippets.shareActions.shareErrorFlagTitle",
        defaultMessage: "Could not set template to shared"
    },
    shareErrorFlagDescription: {
        id: "snippets.shareActions.shareErrorFlagDescription",
        defaultMessage: "The template was saved but access update failed. Please try again."
    },
    unshareErrorFlagTitle: {
        id: "snippets.shareActions.unshareErrorFlagTitle",
        defaultMessage: "Could not set template to private"
    },
    unshareErrorFlagDescription: {
        id: "snippets.shareActions.unshareErrorFlagDescription",
        defaultMessage: "The template was saved but access update failed. Please try again."
    }
});
function $6ee676e3d95c77de$var$updateSnippetStoreAndQuickInsert(params) {
    const { getState: getState, setState: setState, snippetId: snippetId, isShared: isShared, options: options } = params;
    const { snippets: snippets } = getState();
    const updatedSnippets = snippets.map((snippet)=>snippet.snippetId === snippetId ? {
            ...snippet,
            isShared: isShared
        } : snippet);
    setState({
        snippets: updatedSnippets
    });
    if (options?.editorAPI) {
        const updatedSnippet = updatedSnippets.find((s)=>s.snippetId === snippetId);
        if (updatedSnippet) (0, $5OfFS.updateSnippetInQuickInsertItem)({
            snippet: updatedSnippet,
            editorAPI: options.editorAPI
        });
    }
}
const $6ee676e3d95c77de$export$d441f4747313fe61 = {
    /**
   * Claims a snippet via a share link. POSTs to the claim endpoint with the shareId.
   * On success: adds the snippet to the store (if not already present) and opens the detail panel.
   * On error: reports to monitoring and shows an error flag when options provided. Does not throw.
   *
   * @param snippetId - The snippet ID from the share URL
   * @param shareId - The share token from the share URL
   * @param options - Optional flags and intl for error flag display, plus success handling
   */ claimSnippetShare: (snippetId, shareId, options)=>async ({ getState: getState, setState: setState })=>{
            setState({
                isClaimingShare: true
            });
            try {
                const snippetData = await $3e10B.claimSnippetShare(snippetId, shareId);
                options?.onClaimSuccess?.(snippetData.snippetId);
                const snippet = await (0, $5ra2J.transformSnippet)(snippetData);
                if (snippet) {
                    const applyToStore = (currentSnippets)=>{
                        const { templateGallery: templateGallery } = getState();
                        const alreadyExists = currentSnippets.some((s)=>s.snippetId === snippet.snippetId);
                        setState({
                            isClaimingShare: false,
                            snippets: alreadyExists ? currentSnippets : [
                                ...currentSnippets,
                                snippet
                            ],
                            templateGallery: {
                                ...templateGallery,
                                selectedSnippetId: snippet.snippetId
                            }
                        });
                    };
                    if (getState().isLoading) // fetchSnippets is still in flight — defer until it settles so the fetch
                    // result doesn't overwrite the claimed snippet
                    (0, $7DXt6.onCurrentFetchComplete)(applyToStore);
                    else applyToStore(getState().snippets);
                } else setState({
                    isClaimingShare: false
                });
            } catch (error) {
                const err = error instanceof Error ? error : new Error(String(error));
                (0, $aUBmi.reportError)(err);
                setState({
                    isClaimingShare: false
                });
                if (options) (0, $eDBud.showSnippetErrorFlag)(options.flags, options.intl.formatMessage($6ee676e3d95c77de$var$shareActionsMessages.claimShareErrorFlagTitle), options.intl.formatMessage($6ee676e3d95c77de$var$shareActionsMessages.claimShareErrorFlagDescription));
            }
        },
    /**
   * Shares a snippet with the site.
   * On success: updates the snippet in store (isShared: true) and in quick insert when editorAPI provided.
   * On error: reports to monitoring and shows error flag when options provided. Does not throw.
   *
   * @param snippetId - The snippet ID to share
   * @param options - Optional flags, intl, and editorAPI for UI feedback and quick insert update
   */ shareSnippet: (snippetId, options)=>async ({ getState: getState, setState: setState })=>{
            try {
                await $3e10B.shareSnippet(snippetId);
                $6ee676e3d95c77de$var$updateSnippetStoreAndQuickInsert({
                    getState: getState,
                    setState: setState,
                    snippetId: snippetId,
                    isShared: true,
                    options: options
                });
            } catch (error) {
                const err = error instanceof Error ? error : new Error(String(error));
                (0, $aUBmi.reportError)(err);
                if (options) {
                    (0, $eDBud.showSnippetErrorFlag)(options.flags, options.intl.formatMessage($6ee676e3d95c77de$var$shareActionsMessages.shareErrorFlagTitle), options.intl.formatMessage($6ee676e3d95c77de$var$shareActionsMessages.shareErrorFlagDescription));
                    options.onShareFailure?.(snippetId, err);
                }
            }
        },
    /**
   * Unshares a snippet.
   * On success: updates the snippet in store (isShared: false) and in quick insert when editorAPI provided.
   * On error: reports to monitoring and shows error flag when options provided. Does not throw.
   *
   * @param snippetId - The snippet ID to unshare
   * @param options - Optional flags, intl, and editorAPI for UI feedback and quick insert update
   */ unshareSnippet: (snippetId, options)=>async ({ getState: getState, setState: setState })=>{
            try {
                await $3e10B.unshareSnippet(snippetId);
                $6ee676e3d95c77de$var$updateSnippetStoreAndQuickInsert({
                    getState: getState,
                    setState: setState,
                    snippetId: snippetId,
                    isShared: false,
                    options: options
                });
            } catch (error) {
                const err = error instanceof Error ? error : new Error(String(error));
                (0, $aUBmi.reportError)(err);
                if (options) {
                    (0, $eDBud.showSnippetErrorFlag)(options.flags, options.intl.formatMessage($6ee676e3d95c77de$var$shareActionsMessages.unshareErrorFlagTitle), options.intl.formatMessage($6ee676e3d95c77de$var$shareActionsMessages.unshareErrorFlagDescription));
                    options.onUnshareFailure?.(snippetId, err);
                }
            }
        }
};
module.exports["shareActions"] = $6ee676e3d95c77de$export$d441f4747313fe61;

});

parcelRegister("kZ6BG", function(module, exports) {
/**
 * Delete Actions - Snippet deletion with local state update
 *
 * Calls the Block Service API to delete the snippet, then removes it from
 * the react-sweet-state store so the UI updates immediately, and from the
 * quick insert menu when editor API is provided in options. When options (flags, intl)
 * are provided, shows success/error flags like createActions and updateActions.
 */ 
var $3e10B = parcelRequire("3e10B");


var $64ncc = parcelRequire("64ncc");


var $aUBmi = parcelRequire("aUBmi");


var $lCB0R = parcelRequire("lCB0R");


var $eDBud = parcelRequire("eDBud");

const $182883078d656055$export$78632900ecc05c19 = {
    /**
   * Deletes a snippet by ID.
   *
   * - Calls the Block Service API with DELETE
   * - On success: removes the snippet from local state and from quick insert menu; shows success flag if options provided
   * - On error: reports to monitoring, shows error flag if options provided, then re-throws
   *
   * @param snippetId - The snippet ID (uuidv7) to delete
   * @param options - Optional flags and intl for success/error UI feedback
   */ deleteSnippet: (snippetId, options)=>async ({ getState: getState, setState: setState })=>{
            try {
                await $3e10B.deleteSnippet(snippetId);
                const { snippets: snippets } = getState();
                const deletedSnippet = snippets.find((s)=>s.snippetId === snippetId);
                setState({
                    snippets: snippets.filter((s)=>s.snippetId !== snippetId)
                });
                if (options && deletedSnippet) (0, $eDBud.showSnippetSuccessFlag)(options.flags, options.intl.formatMessage((0, $64ncc.messages).deleteTemplateModalSuccessFlagTitle, {
                    snippetName: deletedSnippet.name
                }), options.intl.formatMessage((0, $64ncc.messages).deleteTemplateModalSuccessFlagDescription));
                const editorAPI = options?.editorAPI ?? null;
                const removeQuickInsertItem = editorAPI?.quickInsert?.commands?.removeQuickInsertItem ?? null;
                if (removeQuickInsertItem) editorAPI?.core?.actions.execute(removeQuickInsertItem((0, $lCB0R.getSnippetQuickInsertKey)(snippetId)));
            } catch (thrownError) {
                const err = thrownError instanceof Error ? thrownError : new Error(String(thrownError));
                (0, $aUBmi.reportError)(err);
                if (options) (0, $eDBud.showSnippetErrorFlag)(options.flags, options.intl.formatMessage((0, $64ncc.messages).deleteTemplateModalErrorFlagTitle), options.intl.formatMessage((0, $64ncc.messages).deleteTemplateModalErrorFlagDescription));
                throw err;
            }
        }
};
module.exports["deleteActions"] = $182883078d656055$export$78632900ecc05c19;

});

parcelRegister("64ncc", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $162407a1315c44c9$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    deleteTemplateModalTitle: {
        id: "snippets.deleteTemplateModalTitle",
        defaultMessage: "Delete this template?"
    },
    deleteTemplateModalBody: {
        id: "snippets.deleteTemplateModalBody",
        defaultMessage: "It will no longer appear in search or My templates"
    },
    deleteTemplateModalCancelButton: {
        id: "snippets.deleteTemplateModalCancelButton",
        defaultMessage: "Cancel"
    },
    deleteTemplateModalConfirmButton: {
        id: "snippets.deleteTemplateModalConfirmButton",
        defaultMessage: "Confirm"
    },
    deleteTemplateModalSuccessFlagTitle: {
        id: "snippets.deleteTemplateModalSuccessFlagTitle",
        defaultMessage: "Template \"{snippetName}\" deleted"
    },
    deleteTemplateModalSuccessFlagDescription: {
        id: "snippets.deleteTemplateModalSuccessFlagDescription",
        defaultMessage: "The template has been removed"
    },
    deleteTemplateModalErrorFlagTitle: {
        id: "snippets.deleteTemplateModalErrorFlagTitle",
        defaultMessage: "Could not delete template"
    },
    deleteTemplateModalErrorFlagDescription: {
        id: "snippets.deleteTemplateModalErrorFlagDescription",
        defaultMessage: "Please try again"
    }
});
module.exports["messages"] = $162407a1315c44c9$export$defe85febe8b728c;

});

parcelRegister("5ogZS", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $3e10B = parcelRequire("3e10B");


var $aUBmi = parcelRequire("aUBmi");


var $eDBud = parcelRequire("eDBud");

const $370debea7e17b5a6$var$messages = (0, $kSwu1.defineMessages)({
    favoriteErrorFlagTitle: {
        id: "snippets.favoriteActions.favoriteErrorFlagTitle",
        defaultMessage: "Unable to favorite snippet"
    },
    favoriteErrorFlagDescription: {
        id: "snippets.favoriteActions.favoriteErrorFlagDescription",
        defaultMessage: "Please try again later."
    },
    unfavoriteErrorFlagTitle: {
        id: "snippets.favoriteActions.unfavoriteErrorFlagTitle",
        defaultMessage: "Unable to unfavorite snippet"
    },
    unfavoriteErrorFlagDescription: {
        id: "snippets.favoriteActions.unfavoriteErrorFlagDescription",
        defaultMessage: "Please try again later."
    }
});
const $370debea7e17b5a6$export$5ea490dff3e61674 = {
    favoriteSnippet: (snippetId, options)=>async ({ setState: setState, getState: getState })=>{
            const { snippets: previousSnippets } = getState();
            const newSnippetsState = previousSnippets.map((snippet)=>snippet.snippetId === snippetId ? {
                    ...snippet,
                    isFavorite: true
                } : snippet);
            setState({
                snippets: newSnippetsState
            });
            try {
                await $3e10B.favoriteSnippet(snippetId);
                return true;
            } catch (error) {
                setState({
                    snippets: previousSnippets
                });
                const err = error instanceof Error ? error : new Error(String(error));
                (0, $aUBmi.reportError)(err);
                if (options) (0, $eDBud.showSnippetErrorFlag)(options.flags, options.intl.formatMessage($370debea7e17b5a6$var$messages.favoriteErrorFlagTitle), options.intl.formatMessage($370debea7e17b5a6$var$messages.favoriteErrorFlagDescription));
                return false;
            }
        },
    unfavoriteSnippet: (snippetId, options)=>async ({ setState: setState, getState: getState })=>{
            const { snippets: previousSnippets } = getState();
            const newSnippetsState = previousSnippets.map((snippet)=>snippet.snippetId === snippetId ? {
                    ...snippet,
                    isFavorite: false
                } : snippet);
            setState({
                snippets: newSnippetsState
            });
            try {
                await $3e10B.unfavoriteSnippet(snippetId);
                return true;
            } catch (error) {
                setState({
                    snippets: previousSnippets
                });
                const err = error instanceof Error ? error : new Error(String(error));
                (0, $aUBmi.reportError)(err);
                if (options) (0, $eDBud.showSnippetErrorFlag)(options.flags, options.intl.formatMessage($370debea7e17b5a6$var$messages.unfavoriteErrorFlagTitle), options.intl.formatMessage($370debea7e17b5a6$var$messages.unfavoriteErrorFlagDescription));
                return false;
            }
        }
};
module.exports["favoriteActions"] = $370debea7e17b5a6$export$5ea490dff3e61674;

});

parcelRegister("adRf2", function(module, exports) {
/**
 * Insert count actions - record snippet insert (API + local state)
 *
 * When a user inserts a snippet, we call the block service to increment insertCount
 * and optimistically update the snippet's insertCount in the store. The API call is
 * fire-and-forget; we do not await it.
 */ 
var $3e10B = parcelRequire("3e10B");

const $0d3ff23b1ebce84c$export$9ca6d5c974158b4f = {
    /**
   * Records that a snippet was inserted: increments insertCount in the store immediately
   * and calls the block service in the background (fire-and-forget).
   */ recordSnippetInsert: (snippetId)=>({ setState: setState, getState: getState })=>{
            const { snippets: snippets } = getState();
            const updatedSnippets = snippets.map((s)=>s.snippetId === snippetId ? {
                    ...s,
                    insertCount: (s.insertCount ?? 0) + 1
                } : s);
            setState({
                snippets: updatedSnippets
            });
            $3e10B.incrementSnippetInsertCount(snippetId);
        }
};
module.exports["insertCountActions"] = $0d3ff23b1ebce84c$export$9ca6d5c974158b4f;

});

parcelRegister("kvZfs", function(module, exports) {

var $ebSlI = parcelRequire("ebSlI");

let $58a5e61b68092aa3$var$urlSyncHandler = null;
const $58a5e61b68092aa3$export$783efc75f48cc7cc = (handler)=>{
    $58a5e61b68092aa3$var$urlSyncHandler = handler;
};
const $58a5e61b68092aa3$export$fade6508a7236815 = {
    setTemplateGallerySelectedSnippetId: (id)=>({ getState: getState, setState: setState })=>{
            setState({
                templateGallery: {
                    ...getState().templateGallery,
                    selectedSnippetId: id
                }
            });
            $58a5e61b68092aa3$var$urlSyncHandler?.(id);
        },
    setTemplateGalleryCategoryFilter: (selectedCategoryId)=>({ getState: getState, setState: setState })=>{
            setState({
                templateGallery: {
                    ...getState().templateGallery,
                    selectedCategoryId: selectedCategoryId
                }
            });
        },
    setTemplateGallerySearchQuery: (searchQuery)=>({ getState: getState, setState: setState })=>{
            setState({
                templateGallery: {
                    ...getState().templateGallery,
                    searchQuery: searchQuery
                }
            });
        },
    setTemplateGallerySortOrder: (sortOrder)=>({ getState: getState, setState: setState })=>{
            setState({
                templateGallery: {
                    ...getState().templateGallery,
                    sortOrder: sortOrder
                }
            });
        },
    resetTemplateGalleryFilters: ()=>({ getState: getState, setState: setState })=>{
            const { selectedSnippetId: selectedSnippetId } = getState().templateGallery;
            setState({
                templateGallery: {
                    ...(0, $ebSlI.getInitialTemplateGalleryState)(),
                    selectedSnippetId: selectedSnippetId
                }
            });
        }
};
module.exports["setUrlSyncHandler"] = $58a5e61b68092aa3$export$783efc75f48cc7cc;
module.exports["templateGalleryActions"] = $58a5e61b68092aa3$export$fade6508a7236815;

});

parcelRegister("cfxyE", function(module, exports) {
/**
 * Update Actions - Snippet editing with UI integration
 *
 * This action handles snippet updates with full UI integration:
 * - Updates the snippet via the API
 * - Shows success/error flags
 * - Updates the snippet in the editor's quick insert menu
 * - Updates the snippet in the store in place (preserves list order)
 *
 * Separated from fetchActions because it has UI dependencies (flags, intl, editor API)
 * that the pure data operations don't need.
 */ 
var $8pLNp = parcelRequire("8pLNp");


var $5OfFS = parcelRequire("5OfFS");


var $3e10B = parcelRequire("3e10B");


var $aUBmi = parcelRequire("aUBmi");


var $eDBud = parcelRequire("eDBud");


var $gdHn1 = parcelRequire("gdHn1");


var $9gUQP = parcelRequire("9gUQP");

const $ee05d86412439e5a$export$17a216d338159b9 = {
    /**
   * Updates an existing snippet and updates the store in place (preserves list order).
   *
   * On success:
   * - Replaces the snippet in the store with the API response
   * - Shows a success flag (if options provided)
   * - Adds/updates the snippet in the quick insert menu
   *
   * On error:
   * - Reports to monitoring
   * - Shows an error flag (if options provided)
   * - Keeps existing snippets visible (doesn't reset isLoaded)
   *
   * @param snippetId - The ID of the snippet to update
   * @param name - The name of the snippet
   * @param body - The body of the snippet
   * @param description - Optional description text
   * @param options - UI options including flags, intl, and editor API
   * @returns Promise resolving to the updated snippet, or null on failure
   */ updateSnippet: (snippetId, name, body, description, options)=>async (storeApi)=>{
            const { getState: getState, setState: setState, dispatch: dispatch } = storeApi;
            const descriptionValue = description?.trim();
            const params = {
                name: name,
                ...descriptionValue ? {
                    description: descriptionValue
                } : {
                    description: null
                },
                body: JSON.stringify(body)
            };
            try {
                const snippet = await $3e10B.updateSnippet(snippetId, params);
                const currentSnippets = getState().snippets;
                const updatedSnippets = currentSnippets.map((s)=>s.snippetId === snippet.snippetId ? snippet : s);
                setState({
                    snippets: updatedSnippets
                });
                if (options) {
                    const { flags: flags, intl: intl, editorAPI: editorAPI, isShared: isShared } = options;
                    (0, $eDBud.showSnippetSuccessFlag)(flags, intl.formatMessage((0, $8pLNp.editSnippetModalMessages).editSuccessFlagTitle, {
                        snippetName: snippet.name
                    }), '');
                    if (editorAPI) (0, $5OfFS.updateSnippetInQuickInsertItem)({
                        snippet: snippet,
                        editorAPI: editorAPI
                    });
                    if (getState().isSnippetSharingForSiteEnabled) {
                        const hasSharedChanged = isShared != options.previousIsShared;
                        const shareOrUnshare = isShared && !options.previousIsShared ? (0, $gdHn1.shareActions).shareSnippet : (0, $gdHn1.shareActions).unshareSnippet;
                        if (hasSharedChanged) await dispatch(shareOrUnshare(snippetId, {
                            flags: flags,
                            intl: intl,
                            editorAPI: editorAPI ?? undefined,
                            onShareFailure: options.onShareFailure,
                            onUnshareFailure: options.onUnshareFailure
                        }));
                    }
                }
                return snippet;
            } catch (thrownError) {
                const err = thrownError instanceof Error ? thrownError : new Error(String(thrownError));
                (0, $aUBmi.reportError)(err);
                if (options) {
                    options.onSaveFailure?.(err);
                    const { flagTitle: flagTitle, flagDescription: flagDescription } = (0, $9gUQP.getSnippetErrorFlagMessages)(err, (0, $8pLNp.editSnippetModalMessages).editErrorFlagTitle, (0, $8pLNp.editSnippetModalMessages).editErrorFlagDescription);
                    (0, $eDBud.showSnippetErrorFlag)(options.flags, options.intl.formatMessage(flagTitle), options.intl.formatMessage(flagDescription));
                    return null;
                }
                throw err;
            }
        }
};
module.exports["updateActions"] = $ee05d86412439e5a$export$17a216d338159b9;

});

parcelRegister("8pLNp", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $be403b9494ea3648$export$b61e52cb99dfc21a = (0, $kSwu1.defineMessages)({
    titleEdit: {
        id: "snippets.snippetEditorModal.titleEdit",
        defaultMessage: "Edit block template"
    },
    saveButton: {
        id: "snippets.snippetEditorModal.saveButton",
        defaultMessage: "Save"
    },
    editSuccessFlagTitle: {
        id: "snippets.snippetEditorModal.editSuccessFlagTitle",
        defaultMessage: "Template \"{snippetName}\" updated"
    },
    editErrorFlagTitle: {
        id: "snippets.snippetEditorModal.editErrorFlagTitle",
        defaultMessage: "Could not update the template"
    },
    editErrorFlagDescription: {
        id: "snippets.snippetEditorModal.editErrorFlagDescription",
        defaultMessage: "Please try again"
    }
});
module.exports["editSnippetModalMessages"] = $be403b9494ea3648$export$b61e52cb99dfc21a;

});

parcelRegister("2u5FB", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7joZr = parcelRequire("7joZr");


var $ad7Ou = parcelRequire("ad7Ou");


var $dTHYM = parcelRequire("dTHYM");


var $dUI0h = parcelRequire("dUI0h");


var $j7cLK = parcelRequire("j7cLK");


var $7BfeF = parcelRequire("7BfeF");

var $dQLwo = parcelRequire("dQLwo");


var $I7hWB = parcelRequire("I7hWB");


var $cDs9S = parcelRequire("cDs9S");


var $fEPJS = parcelRequire("fEPJS");


var $aGB72 = parcelRequire("aGB72");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");


var $4yg9g = parcelRequire("4yg9g");


var $e3Wrf = parcelRequire("e3Wrf");


var $lsxnT = parcelRequire("lsxnT");


var $3IYF2 = parcelRequire("3IYF2");


var $6K2yS = parcelRequire("6K2yS");


var $hPTbh = parcelRequire("hPTbh");


var $aNHzZ = parcelRequire("aNHzZ");


var $7rMlZ = parcelRequire("7rMlZ");


var $ag32C = parcelRequire("ag32C");


var $cqjzX = parcelRequire("cqjzX");


var $ies1q = parcelRequire("ies1q");

function $5ddadcaed0e11aa6$export$b312cabc15c7d859(args) {
    const { handleClose: handleClose, fireFailedAnalytic: fireFailedAnalytic, ...rest } = args;
    return {
        ...rest,
        onClose: ()=>handleClose({
                outcome: (0, $hPTbh.MODAL_OUTCOME).CLOSED
            }),
        onCancel: ()=>handleClose({
                outcome: (0, $hPTbh.MODAL_OUTCOME).CANCELLED
            }),
        onADFError: (error)=>{
            if (error) fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_ADF_SERIALIZATION, {
                error: error?.message ?? 'Unknown error'
            });
        }
    };
}
const $5ddadcaed0e11aa6$export$b1d51570d1105ba4 = 'empty_adf';
const $5ddadcaed0e11aa6$var$styles = {
    modalContent: "_2rkopb1k _bfhkhfxm",
    bodyWrapper: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1e0c1txw _4t3i1us8",
    bodyContainer: "_zulppxbi _16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _18zr1b66 _1e0c1txw _2lx2vrvc _ca0qutpp _n3tdpxbi _vchhusvi",
    headerContainer: "_ca0qutpp _19bvxy5q _u5f31ejb _1o9zidpf",
    previewColumn: "_16jlkb7n _1o9zkb7n _i0dlf1ug _2rkopb1k _v5641kuu _1reo1wug _18m91wug _4t3i1osq _bfhkvuon _16qst7xp",
    formColumn: "_2rkopb1k _v5641kuu _1yt41ejb _1reo15vq _18m915vq _1bsbnklw _1ul9nklw _1o9zidpf _bfhkvuon _16qst7xp _1e0c1txw _2lx21bp4",
    formContainer: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4",
    formFields: "_16jlkb7n _1o9zkb7n _i0dlf1ug",
    formActions: "_1o9zidpf _ca0qpxbi"
};
const $5ddadcaed0e11aa6$var$SnippetBaseModalHeader = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { title: title, onClose: onClose } = t0;
    const { titleId: titleId } = (0, $aGB72.useModal)();
    let t1;
    if ($[0] !== title || $[1] !== titleId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "small",
            id: titleId
        }, title);
        $[0] = title;
        $[1] = titleId;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== onClose) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cDs9S.CloseButton), {
            onClick: onClose
        });
        $[3] = onClose;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            alignInline: "center",
            spread: "space-between",
            alignBlock: "center",
            xcss: $5ddadcaed0e11aa6$var$styles.headerContainer
        }, t1, t2);
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
const $5ddadcaed0e11aa6$export$796e5e9e507bafba = (t0)=>{
    const $ = (0, $bDgLe.c)(43);
    const { title: title, submitLabel: submitLabel, formKey: formKey, defaultValues: defaultValues, initialAdf: initialAdf, onSubmit: onSubmit, onClose: onClose, onCancel: onCancel, onCloseComplete: onCloseComplete, contentId: contentId, spaceId: spaceId, spaceKey: spaceKey, snippetId: snippetId, snippetScope: snippetScope, isSnippetSharingForSiteEnabled: isSnippetSharingForSiteEnabled, onADFError: onADFError, isAiSuggestionLoading: t1, extraActions: extraActions, formWarning: formWarning } = t0;
    const isAiSuggestionLoading = t1 === undefined ? false : t1;
    const intl = (0, $kSwu1.useIntl)();
    const [currentAdf, setCurrentAdf] = (0, $cozmU.useState)(initialAdf);
    const [adfError, setADFError] = (0, $cozmU.useState)(null);
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (doc)=>{
            setCurrentAdf(doc);
        };
        $[0] = t2;
    } else t2 = $[0];
    const handleDocumentChange = t2;
    let t3;
    if ($[1] !== onADFError) {
        t3 = (error)=>{
            setADFError(error);
            onADFError?.(error);
        };
        $[1] = onADFError;
        $[2] = t3;
    } else t3 = $[2];
    const handleADFError = t3;
    let t4;
    if ($[3] !== currentAdf || $[4] !== onSubmit) {
        t4 = async (values)=>{
            await onSubmit(values, currentAdf);
        };
        $[3] = currentAdf;
        $[4] = onSubmit;
        $[5] = t4;
    } else t4 = $[5];
    const handleSubmit = t4;
    let t5;
    let t6;
    if ($[6] !== currentAdf) {
        t5 = ()=>{
            if ((0, $ies1q.isAdfBodyEmpty)(currentAdf)) setADFError($5ddadcaed0e11aa6$export$b1d51570d1105ba4);
            else setADFError(null);
        };
        t6 = [
            currentAdf
        ];
        $[6] = currentAdf;
        $[7] = t5;
        $[8] = t6;
    } else {
        t5 = $[7];
        t6 = $[8];
    }
    (0, $cozmU.useEffect)(t5, t6);
    const handleCancel = onCancel ?? onClose;
    let t7;
    if ($[9] !== onClose || $[10] !== title) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5ddadcaed0e11aa6$var$SnippetBaseModalHeader, {
            title: title,
            onClose: onClose
        });
        $[9] = onClose;
        $[10] = title;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== adfError || $[13] !== contentId || $[14] !== defaultValues.isShared || $[15] !== defaultValues.snippetDescription || $[16] !== defaultValues.snippetName || $[17] !== extraActions || $[18] !== formWarning || $[19] !== handleADFError || $[20] !== handleCancel || $[21] !== initialAdf || $[22] !== intl || $[23] !== isAiSuggestionLoading || $[24] !== isSnippetSharingForSiteEnabled || $[25] !== snippetId || $[26] !== snippetScope || $[27] !== spaceId || $[28] !== spaceKey || $[29] !== submitLabel) {
        t8 = (t9)=>{
            const { submitting: submitting, formProps: formProps } = t9;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("form", {
                ...formProps,
                className: (0, $hekY6.default)([
                    $5ddadcaed0e11aa6$var$styles.formContainer
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                xcss: $5ddadcaed0e11aa6$var$styles.bodyWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                xcss: $5ddadcaed0e11aa6$var$styles.bodyContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                xcss: $5ddadcaed0e11aa6$var$styles.previewColumn
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3IYF2.SnippetEditor), {
                defaultValue: initialAdf,
                onDocumentChange: handleDocumentChange,
                onError: handleADFError,
                contentId: contentId,
                spaceId: spaceId,
                spaceKey: spaceKey,
                snippetId: snippetId,
                snippetScope: snippetScope
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                xcss: $5ddadcaed0e11aa6$var$styles.formColumn
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
                space: "space.300",
                xcss: $5ddadcaed0e11aa6$var$styles.formFields
            }, formWarning, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ag32C.SnippetCharacterCounterField), {
                name: "snippetName",
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6K2yS.messages).nameLabel),
                defaultValue: defaultValues.snippetName,
                maxCharacters: (0, $aNHzZ.MAX_SNIPPET_NAME_LENGTH),
                cutoff: (0, $aNHzZ.SNIPPET_NAME_CUTOFF_LENGTH),
                validate: (value)=>value ? undefined : intl.formatMessage((0, $6K2yS.messages).nameError),
                isRequired: true
            }, (t10)=>{
                const { fieldProps: fieldProps } = t10;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7rMlZ.AIInputField), {
                    isLoading: isAiSuggestionLoading
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
                    ...fieldProps,
                    placeholder: intl.formatMessage((0, $6K2yS.messages).namePlaceholder),
                    appearance: isAiSuggestionLoading ? "subtle" : "standard",
                    isDisabled: isAiSuggestionLoading
                }));
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ag32C.SnippetCharacterCounterField), {
                name: "snippetDescription",
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6K2yS.messages).descriptionLabel),
                defaultValue: defaultValues.snippetDescription,
                maxCharacters: (0, $aNHzZ.MAX_SNIPPET_DESCRIPTION_LENGTH),
                cutoff: (0, $aNHzZ.SNIPPET_DESCRIPTION_CUTOFF_LENGTH)
            }, (t11)=>{
                const { fieldProps: fieldProps_0 } = t11;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7rMlZ.AIInputField), {
                    isLoading: isAiSuggestionLoading
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
                    ...fieldProps_0,
                    minimumRows: 5,
                    placeholder: intl.formatMessage((0, $6K2yS.messages).descriptionPlaceholder),
                    appearance: isAiSuggestionLoading ? "subtle" : "standard",
                    isDisabled: isAiSuggestionLoading
                }));
            }), isSnippetSharingForSiteEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cqjzX.SnippetSharingField), {
                name: "isShared",
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6K2yS.messages).saveToLabel),
                defaultValue: defaultValues.isShared
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
                name: "snippetBody",
                defaultValue: adfError,
                validate: ()=>{
                    if (adfError === $5ddadcaed0e11aa6$export$b1d51570d1105ba4) return intl.formatMessage((0, $6K2yS.messages).emptyBodyError);
                    if (adfError) return intl.formatMessage((0, $6K2yS.messages).adfError);
                }
            }, $5ddadcaed0e11aa6$var$_temp)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                xcss: $5ddadcaed0e11aa6$var$styles.formActions
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j7cLK.default), {
                align: "end"
            }, extraActions, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7joZr.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                appearance: "subtle",
                onClick: handleCancel
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6K2yS.messages).cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                type: "submit",
                appearance: "primary",
                isLoading: submitting
            }, submitLabel)))))))));
        };
        $[12] = adfError;
        $[13] = contentId;
        $[14] = defaultValues.isShared;
        $[15] = defaultValues.snippetDescription;
        $[16] = defaultValues.snippetName;
        $[17] = extraActions;
        $[18] = formWarning;
        $[19] = handleADFError;
        $[20] = handleCancel;
        $[21] = initialAdf;
        $[22] = intl;
        $[23] = isAiSuggestionLoading;
        $[24] = isSnippetSharingForSiteEnabled;
        $[25] = snippetId;
        $[26] = snippetScope;
        $[27] = spaceId;
        $[28] = spaceKey;
        $[29] = submitLabel;
        $[30] = t8;
    } else t8 = $[30];
    let t9;
    if ($[31] !== formKey || $[32] !== handleSubmit || $[33] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
            key: formKey,
            noValidate: true,
            onSubmit: handleSubmit
        }, t8);
        $[31] = formKey;
        $[32] = handleSubmit;
        $[33] = t8;
        $[34] = t9;
    } else t9 = $[34];
    let t10;
    if ($[35] !== t7 || $[36] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $5ddadcaed0e11aa6$var$styles.modalContent
        }, t7, t9);
        $[35] = t7;
        $[36] = t9;
        $[37] = t10;
    } else t10 = $[37];
    let t11;
    if ($[38] !== Modal || $[39] !== onClose || $[40] !== onCloseComplete || $[41] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
            width: "95vw",
            shouldScrollInViewport: true,
            onClose: onClose,
            onCloseComplete: onCloseComplete
        }, t10);
        $[38] = Modal;
        $[39] = onClose;
        $[40] = onCloseComplete;
        $[41] = t10;
        $[42] = t11;
    } else t11 = $[42];
    return t11;
};
function $5ddadcaed0e11aa6$var$_temp(t0) {
    const { error: error_0 } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, error_0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, error_0));
}
module.exports["getSnippetBaseModalProps"] = $5ddadcaed0e11aa6$export$b312cabc15c7d859;
module.exports["SnippetBaseModal"] = $5ddadcaed0e11aa6$export$796e5e9e507bafba;

});

parcelRegister("e3Wrf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $cozmU = parcelRequire("cozmU");


var $7r5Hr = parcelRequire("7r5Hr");


var $ixfCV = parcelRequire("ixfCV");

const $f7ddda300dd34381$var$packageName = "platform-pkg";
const $f7ddda300dd34381$var$packageVersion = "0.0.0-use.local";
const $f7ddda300dd34381$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $f7ddda300dd34381$var$packageName,
    packageVersion: $f7ddda300dd34381$var$packageVersion
};
const $f7ddda300dd34381$var$lineHeightBase = 20;
const $f7ddda300dd34381$var$lineHeightCompact = 16;
const $f7ddda300dd34381$var$compactVerticalPadding = 2;
const $f7ddda300dd34381$var$verticalPadding = 6;
const $f7ddda300dd34381$var$transitionDuration = '0.2s';
const $f7ddda300dd34381$var$borderWidth = 2;
const $f7ddda300dd34381$var$baseStyles = null;
const $f7ddda300dd34381$var$baseStylesT26Shape = null;
const $f7ddda300dd34381$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp82rsbi _1ltx1j9a _1bqsbk0g _z1pv187o _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _7ba01v6z _1kod1v6z _858u1v1w _jomrr01l _7ehivyy1 _186j1v1w _qu18187o",
    subtle: "_1dqonqa1 _kp821j28 _1ltx1j28 _19wtrsbi _12yml4ek _1l02v77o _11zpv77o _141f1v6z _daj71v6z _olc612x7 _14ji12x7 _1kod1v6z _7ba01v6z _858u1v1w _jomrr01l _7ehivyy1",
    none: "_1dqoglyw _kp821j28 _1ltx1j28 _19wt1j28 _12ym1j28 _1l02v77o _daj712x7 _11zpv77o _141f12x7 _olc612x7 _1kod12x7 _14ji12x7 _7ba012x7 _858u1j28 _jomr1j28 _7ehi3sij"
}; // iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on mobile devices, the textarea uses font.body.large (16px) by default,
// then switches to the smaller font.body on screens wider than 30rem (desktop).
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $f7ddda300dd34381$var$fontStyles = {
    default: "_11c81d4k _1tn2fhey",
    monospace: "_11c81d4k _ect4zzfg _1tn2fhey _14md1vhz"
};
const $f7ddda300dd34381$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $f7ddda300dd34381$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $f7ddda300dd34381$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $f7ddda300dd34381$var$InnerTextArea = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(63);
    const ourRef = (0, $cozmU.useRef)(null);
    let onBlur;
    let onChange;
    let onFocus;
    let rest;
    let style;
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    let testId;
    let value;
    if ($[0] !== props) {
        ({ resize: t0, appearance: t1, isCompact: t2, isRequired: t3, isReadOnly: t4, isDisabled: t5, isInvalid: t6, isMonospaced: t7, minimumRows: t8, testId: testId, maxHeight: t9, onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props);
        $[0] = props;
        $[1] = onBlur;
        $[2] = onChange;
        $[3] = onFocus;
        $[4] = rest;
        $[5] = style;
        $[6] = t0;
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
        $[14] = t8;
        $[15] = t9;
        $[16] = testId;
        $[17] = value;
    } else {
        onBlur = $[1];
        onChange = $[2];
        onFocus = $[3];
        rest = $[4];
        style = $[5];
        t0 = $[6];
        t1 = $[7];
        t2 = $[8];
        t3 = $[9];
        t4 = $[10];
        t5 = $[11];
        t6 = $[12];
        t7 = $[13];
        t8 = $[14];
        t9 = $[15];
        testId = $[16];
        value = $[17];
    }
    const resize = t0 === undefined ? "smart" : t0;
    const appearance = t1 === undefined ? "standard" : t1;
    const isCompact = t2 === undefined ? false : t2;
    const isRequired = t3 === undefined ? false : t3;
    const isReadOnly = t4 === undefined ? false : t4;
    const isDisabled = t5 === undefined ? false : t5;
    const isInvalid = t6 === undefined ? false : t6;
    const isMonospaced = t7 === undefined ? false : t7;
    const minimumRows = t8 === undefined ? 2 : t8;
    const maxHeight = t9 === undefined ? "50vh" : t9;
    const borderHeight = appearance === "none" ? 2 : 1;
    let t10;
    if ($[18] !== resize) {
        t10 = ()=>{
            const el = ourRef.current;
            if (resize === "smart" && el) $f7ddda300dd34381$var$setSmartHeight(el);
        };
        $[18] = resize;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== resize || $[21] !== value) {
        t11 = [
            resize,
            value
        ];
        $[20] = resize;
        $[21] = value;
        $[22] = t11;
    } else t11 = $[22];
    (0, $cozmU.useEffect)(t10, t11);
    let t12;
    if ($[23] !== onBlur) {
        t12 = {
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: "blurred",
            ...$f7ddda300dd34381$var$analyticsParams
        };
        $[23] = onBlur;
        $[24] = t12;
    } else t12 = $[24];
    const onBlurWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t12);
    let t13;
    if ($[25] !== onFocus) {
        t13 = {
            fn: (event_0)=>{
                onFocus && onFocus(event_0);
            },
            action: "focused",
            ...$f7ddda300dd34381$var$analyticsParams
        };
        $[25] = onFocus;
        $[26] = t13;
    } else t13 = $[26];
    const onFocusWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t13);
    let t14;
    if ($[27] !== ref) {
        t14 = (elementRef)=>{
            ourRef.current = elementRef;
            if (ref && typeof ref === "object") ref.current = elementRef;
            if (ref && typeof ref === "function") ref(elementRef);
        };
        $[27] = ref;
        $[28] = t14;
    } else t14 = $[28];
    const getTextAreaRef = t14;
    let t15;
    if ($[29] !== onChange || $[30] !== resize) {
        t15 = (e)=>{
            const el_0 = ourRef.current;
            if (resize === "smart" && el_0) $f7ddda300dd34381$var$setSmartHeight(el_0);
            onChange && onChange(e);
        };
        $[29] = onChange;
        $[30] = resize;
        $[31] = t15;
    } else t15 = $[31];
    const handleOnChange = t15;
    const t16 = isInvalid ? isInvalid : undefined;
    const t17 = isCompact ? isCompact : undefined;
    const t18 = testId ? testId : undefined;
    let t19;
    if ($[32] !== t16 || $[33] !== t17 || $[34] !== t18) {
        t19 = {
            "data-invalid": t16,
            "data-compact": t17,
            "data-testid": t18
        };
        $[32] = t16;
        $[33] = t17;
        $[34] = t18;
        $[35] = t19;
    } else t19 = $[35];
    const controlProps = t19;
    let t20;
    if ($[36] !== appearance || $[37] !== isMonospaced || $[38] !== resize) {
        t20 = (0, $hekY6.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rkofajl _11c8fhey _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazi7uo _slp31hna _153g1bqt _usy41j9a _1a2sizbr _vbqb1gmx _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra1bqt _ibjdl4ek _6zpvizbr _19k0187o _1idr1rpy _1lep1gmx _nmhq1fiz _1n388sxn _1luh1v1w _ndzbr01l _1vj0vyy1",
            (0, $ixfCV.fg)("platform-dst-shape-theme-default") && "_2rko1qi0",
            $f7ddda300dd34381$var$appearanceStyles[appearance],
            $f7ddda300dd34381$var$fontStyles[isMonospaced ? "monospace" : "default"],
            $f7ddda300dd34381$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]);
        $[36] = appearance;
        $[37] = isMonospaced;
        $[38] = resize;
        $[39] = t20;
    } else t20 = $[39];
    const t21 = $f7ddda300dd34381$var$lineHeightCompact * minimumRows + $f7ddda300dd34381$var$compactVerticalPadding * 2 + borderHeight * 2;
    let t22;
    if ($[40] !== t21) {
        t22 = (0, $9aYkv.default)(t21, "px");
        $[40] = t21;
        $[41] = t22;
    } else t22 = $[41];
    const t23 = $f7ddda300dd34381$var$lineHeightBase * minimumRows + $f7ddda300dd34381$var$verticalPadding * 2 + borderHeight * 2;
    let t24;
    if ($[42] !== t23) {
        t24 = (0, $9aYkv.default)(t23, "px");
        $[42] = t23;
        $[43] = t24;
    } else t24 = $[43];
    let t25;
    if ($[44] !== maxHeight || $[45] !== style || $[46] !== t22 || $[47] !== t24) {
        t25 = {
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": t22,
            "--_eorxnz": t24
        };
        $[44] = maxHeight;
        $[45] = style;
        $[46] = t22;
        $[47] = t24;
        $[48] = t25;
    } else t25 = $[48];
    let t26;
    if ($[49] !== controlProps || $[50] !== getTextAreaRef || $[51] !== handleOnChange || $[52] !== isDisabled || $[53] !== isReadOnly || $[54] !== isRequired || $[55] !== minimumRows || $[56] !== onBlurWithAnalytics || $[57] !== onFocusWithAnalytics || $[58] !== rest || $[59] !== t20 || $[60] !== t25 || $[61] !== value) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("textarea", {
            ...controlProps,
            value: value,
            disabled: isDisabled,
            readOnly: isReadOnly,
            required: isRequired,
            ref: getTextAreaRef,
            onChange: handleOnChange,
            onBlur: onBlurWithAnalytics,
            onFocus: onFocusWithAnalytics,
            rows: minimumRows,
            ...rest,
            className: t20,
            style: t25
        });
        $[49] = controlProps;
        $[50] = getTextAreaRef;
        $[51] = handleOnChange;
        $[52] = isDisabled;
        $[53] = isReadOnly;
        $[54] = isRequired;
        $[55] = minimumRows;
        $[56] = onBlurWithAnalytics;
        $[57] = onFocusWithAnalytics;
        $[58] = rest;
        $[59] = t20;
        $[60] = t25;
        $[61] = value;
        $[62] = t26;
    } else t26 = $[62];
    return t26;
} : (props, ref)=>{
    const ourRef = (0, $cozmU.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $cozmU.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $cozmU.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $f7ddda300dd34381$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$f7ddda300dd34381$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: (event_0)=>{
            onFocus && onFocus(event_0);
        },
        action: 'focused',
        ...$f7ddda300dd34381$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $cozmU.useCallback)((e)=>{
        const el_0 = ourRef.current;
        if (resize === 'smart' && el_0) $f7ddda300dd34381$var$setSmartHeight(el_0);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $hekY6.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rkofajl _11c8fhey _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazi7uo _slp31hna _153g1bqt _usy41j9a _1a2sizbr _vbqb1gmx _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra1bqt _ibjdl4ek _6zpvizbr _19k0187o _1idr1rpy _1lep1gmx _nmhq1fiz _1n388sxn _1luh1v1w _ndzbr01l _1vj0vyy1",
            (0, $ixfCV.fg)('platform-dst-shape-theme-default') && "_2rko1qi0",
            $f7ddda300dd34381$var$appearanceStyles[appearance],
            $f7ddda300dd34381$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $f7ddda300dd34381$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $9aYkv.default)($f7ddda300dd34381$var$lineHeightCompact * minimumRows + $f7ddda300dd34381$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $9aYkv.default)($f7ddda300dd34381$var$lineHeightBase * minimumRows + $f7ddda300dd34381$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $f7ddda300dd34381$var$TextArea = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function TextArea(props, ref) {
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f7ddda300dd34381$var$InnerTextArea, {
            ref: ref,
            ...props
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : function TextArea(props, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f7ddda300dd34381$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$f7ddda300dd34381$var$TextArea.displayName = 'TextArea';
var $f7ddda300dd34381$export$2e2bcd8739ae039 = $f7ddda300dd34381$var$TextArea;
module.exports["default"] = $f7ddda300dd34381$export$2e2bcd8739ae039;

});

parcelRegister("lsxnT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $cozmU.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    const plugin = ctx?.plugin;
    const isDisplayed = Boolean(plugin?.state?.isDisplayingMessage);
    (0, $cozmU.useEffect)(()=>{
        window.__PO_ASSET_DISPLAYED__ = window.__PO_ASSET_DISPLAYED__ || isDisplayed;
    }, [
        isDisplayed
    ]);
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $cozmU.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("i3jcY", function(module, exports) {

const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return (window.location.search ?? '').includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("3KdFR", function(module, exports) {
const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return null;
};
const $d24b02c281555a47$var$withChoreographerStub = ()=>{
    return ()=>null;
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    ChoreographedComponent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightTarget: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$withChoreographerStub,
    withChoreographedToggle: $d24b02c281555a47$var$withChoreographerStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("3IYF2", function(module, exports) {
/* SnippetEditor.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $jlRK6 = parcelRequire("jlRK6");


var $5HApy = parcelRequire("5HApy");


var $44G3d = parcelRequire("44G3d");


var $3plmx = parcelRequire("3plmx");


var $awIbt = parcelRequire("awIbt");


var $6mKj3 = parcelRequire("6mKj3");

const $bd56e2c6f8990f8d$var$messages = (0, $kSwu1.defineMessages)({
    editorPlaceholder: {
        id: "snippets.snippetEditor.placeholder",
        defaultMessage: "Edit your template content"
    }
});
const $bd56e2c6f8990f8d$var$styles = {
    editorWrapper: "_4t3i1osq _18m915vq _a5o91bu2"
};
const $bd56e2c6f8990f8d$var$SnippetEditorComponent = ({ defaultValue: defaultValue, onDocumentChange: onDocumentChange, onError: onError, contentId: contentId, spaceId: spaceId, spaceKey: spaceKey, snippetId: snippetId, snippetScope: snippetScope, editorActions: editorActions })=>{
    const intl = (0, $kSwu1.useIntl)();
    const placeholder = intl.formatMessage($bd56e2c6f8990f8d$var$messages.editorPlaceholder);
    const { preset: preset, editorApi: editorApi, mentionProvider: mentionProvider, contextIdentifierProvider: contextIdentifierProvider, activityProvider: activityProvider, searchProvider: searchProvider, featureFlags: featureFlags } = (0, $44G3d.useSnippetEditorPreset)({
        placeholder: placeholder,
        contentId: contentId,
        spaceId: spaceId,
        spaceKey: spaceKey,
        snippetId: snippetId,
        snippetScope: snippetScope,
        editorActions: editorActions
    });
    const handleChange = (0, $cozmU.useCallback)((editorView)=>{
        if ((0, $6mKj3.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) editorApi?.core?.actions.requestDocument((doc)=>{
            if (doc) {
                onDocumentChange(doc);
                onError?.(null);
            } else onError?.(new Error('No adf document returned from editor'));
        });
        else try {
            const doc_0 = editorView.state.doc.toJSON();
            onDocumentChange({
                ...doc_0,
                version: 1
            });
            onError?.(null);
        } catch (error) {
            onError?.(error);
        }
    }, [
        editorApi,
        onDocumentChange,
        onError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $bd56e2c6f8990f8d$var$styles.editorWrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jlRK6.ComposableEditor), {
        preset: preset,
        defaultValue: defaultValue,
        appearance: "full-page",
        mentionProvider: mentionProvider,
        contextIdentifierProvider: contextIdentifierProvider,
        activityProvider: activityProvider,
        searchProvider: searchProvider,
        onChange: handleChange,
        featureFlags: featureFlags,
        contentComponents: undefined,
        disabled: false,
        shouldFocus: false,
        contextPanel: undefined
    })));
};
const $bd56e2c6f8990f8d$var$SnippetEditorWithEditorActions = (0, $awIbt.withEditorActions)($bd56e2c6f8990f8d$var$SnippetEditorComponent);
const $bd56e2c6f8990f8d$export$f00be50f07653725 = (0, $3plmx.withSmartCardProviderContext)($bd56e2c6f8990f8d$var$SnippetEditorWithEditorActions);
module.exports["SnippetEditor"] = $bd56e2c6f8990f8d$export$f00be50f07653725;

});

parcelRegister("44G3d", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kwzZh = parcelRequire("kwzZh");


var $dVPAB = parcelRequire("dVPAB");


var $bQm3c = parcelRequire("bQm3c");


var $aIZFY = parcelRequire("aIZFY");


var $fjhaB = parcelRequire("fjhaB");


var $9EvUR = parcelRequire("9EvUR");


var $98Cy1 = parcelRequire("98Cy1");


var $7BsWq = parcelRequire("7BsWq");


var $e2Vf0 = parcelRequire("e2Vf0");


var $hfIjM = parcelRequire("hfIjM");


var $bKBay = parcelRequire("bKBay");


var $cga1x = parcelRequire("cga1x");


var $4IoVL = parcelRequire("4IoVL");


var $3W9OD = parcelRequire("3W9OD");


var $dkDqz = parcelRequire("dkDqz");


var $bY24B = parcelRequire("bY24B");


var $jvzGU = parcelRequire("jvzGU");


var $lmEhP = parcelRequire("lmEhP");


var $i8Ylv = parcelRequire("i8Ylv");


var $foVrt = parcelRequire("foVrt");


var $7mpOv = parcelRequire("7mpOv");


var $lmNXu = parcelRequire("lmNXu");


var $dPJCf = parcelRequire("dPJCf");


var $a37Yb = parcelRequire("a37Yb");


var $bcv7k = parcelRequire("bcv7k");


var $32x2E = parcelRequire("32x2E");


var $jO6sX = parcelRequire("jO6sX");


var $5xrDe = parcelRequire("5xrDe");


var $anvR9 = parcelRequire("anvR9");

const $f0584aa693e1c48d$var$ANALYTICS_SOURCE = 'create-snippet-editor';
const $f0584aa693e1c48d$var$EDITOR_APPEARANCE = 'full-page';
/**
 * Builds all provider and plugin options for the snippet editor preset.
 * Extracted so useSnippetEditorPreset can follow the same thin "options → preset → return" pattern as useEmbeddedEditorPreset.
 */ function $f0584aa693e1c48d$var$useSnippetEditorPresetOptions({ placeholder: placeholder, contentId: contentId, spaceId: spaceId, spaceKey: spaceKey, editorActions: editorActions }) {
    const { cloudId: cloudId, userId: userId, isAdminHubAIEnabled: isAdminHubAIEnabled, edition: edition, orgId: orgId, environment: environment } = (0, $bQm3c.useSessionData)();
    const intl = (0, $kSwu1.useIntl)();
    const mediaOptions = (0, $e2Vf0.getMediaOptions)({
        mediaProvider: undefined,
        intl: intl,
        featureFlags: {}
    });
    const mentionProvider = (0, $hfIjM.useMentionProvider)(spaceId);
    const contextIdentifierProvider = (0, $98Cy1.useContextIdentifierProvider)(spaceId, contentId);
    const autoformattingProvider = (0, $9EvUR.useAutoformattingProvider)({
        contentId: contentId,
        spaceKey: spaceKey,
        source: $f0584aa693e1c48d$var$ANALYTICS_SOURCE
    });
    const tableOptions = (0, $jvzGU.useTableOptions)();
    const expandOptions = (0, $bY24B.useExpandOptions)();
    const layoutOptions = (0, $dkDqz.getLayoutOptions)();
    const searchProvider = (0, $3W9OD.useSearchProvider)();
    const taskDecisionProvider = (0, $bcv7k.getTaskDecisionProvider)();
    const emojiProvider = (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
        cloudId: cloudId,
        userId: userId || undefined
    });
    const activityProvider = (0, $fjhaB.useActivityProvider)();
    const linkingFeatures = (0, $lmEhP.useLinkingFeatures)({
        allowDatasource: true
    });
    const featureFlags = (0, $7BsWq.useEditorFeatureFlags)();
    const { isAIEnabledForContent: isAIEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const { optInStatus: optInStatus, triggerOptInFlow: triggerOptInFlow } = (0, $i8Ylv.useEditorAIOptIn)({
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        isAIEnabledForContent: isAIEnabledForContent,
        edition: edition,
        orgId: orgId,
        environment: environment
    });
    const editorPluginAIOptions = (0, $foVrt.useEditorPluginAIOptions)({
        aiGlobalOptIn: {
            status: optInStatus,
            triggerOptInFlow: triggerOptInFlow
        },
        contentId: contentId
    });
    const syncedBlockProvider = (0, $aIZFY.useMemoizedSyncedBlockProviderForEditor)({
        contentId: contentId,
        contentType: 'page',
        focusedMentionId: undefined,
        spaceId: spaceId,
        editorActions: editorActions
    });
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const matchRoute = (0, $dPJCf.useMatchRoute)();
    const syncedBlockEventHandlers = (0, $cozmU.useMemo)(()=>(0, $lmNXu.createSmartCardEventHandler)({
            matchRoute: matchRoute,
            push: push
        }, true), [
        matchRoute,
        push
    ]);
    const smartCreateProps = {
        appearance: $f0584aa693e1c48d$var$EDITOR_APPEARANCE,
        media: mediaOptions,
        placeholder: placeholder,
        tableOptions: tableOptions,
        expandOptions: expandOptions,
        layoutOptions: layoutOptions,
        emojiProvider: emojiProvider,
        mentionProvider: mentionProvider,
        featureFlags: featureFlags,
        linking: linkingFeatures.linking,
        autoformattingProvider: autoformattingProvider,
        taskDecisionProvider: taskDecisionProvider,
        contextIdentifierProvider: contextIdentifierProvider,
        editorPluginAIOptions: editorPluginAIOptions,
        syncedBlockProvider: syncedBlockProvider,
        syncedBlockEventHandlers: syncedBlockEventHandlers
    };
    return {
        smartCreateProps: smartCreateProps,
        extra: {
            mentionProvider: mentionProvider,
            contextIdentifierProvider: contextIdentifierProvider,
            activityProvider: activityProvider,
            searchProvider: searchProvider,
            featureFlags: featureFlags
        }
    };
}
function $f0584aa693e1c48d$export$879111968cad76c6({ placeholder: placeholder, contentId: contentId, spaceId: spaceId, spaceKey: spaceKey, snippetId: snippetId, snippetScope: snippetScope, editorActions: editorActions }) {
    const options = $f0584aa693e1c48d$var$useSnippetEditorPresetOptions({
        placeholder: placeholder,
        contentId: contentId,
        spaceId: spaceId,
        spaceKey: spaceKey,
        editorActions: editorActions
    });
    const contextIdentifierProvider = (0, $anvR9.useSnippetEditorContextIdentifierProvider)(options.extra.contextIdentifierProvider, snippetId, snippetScope);
    const { editorPreferencesProvider: editorPreferencesProvider } = (0, $jO6sX.useEditorPreferencesProvider)();
    const editorAPIRef = (0, $cozmU.useRef)(null);
    const { pluginOptions: trackChangesPluginOptions } = (0, $a37Yb.useTrackChangesPlugin)({
        editorAPIRef: editorAPIRef
    });
    const { preset: preset, editorApi: editorApi } = (0, $dVPAB.usePreset)(()=>{
        return (0, $5xrDe.createSnippetEditorPreset)({
            ...options.smartCreateProps,
            contextIdentifierProvider: contextIdentifierProvider,
            trackChangesPluginOptions: trackChangesPluginOptions,
            editorPreferencesProvider: editorPreferencesProvider
        });
    // WARNING: Adding a dependency array here causes the editor plugins to all recreate
    // This can be very expensive. Be very careful adding to this, avoid if possible!
    });
    (0, $cozmU.useEffect)(()=>{
        editorAPIRef.current = editorApi;
    }, [
        editorApi
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!editorApi) return;
        const useSnippetMediaProvider = snippetId && snippetScope !== (0, $cga1x.SnippetScope).GLOBAL;
        const provider = useSnippetMediaProvider ? (0, $bKBay.createSnippetsEditorMediaProvider)({
            snippetId: snippetId,
            scope: snippetScope
        }) : (0, $4IoVL.createEditorMediaProvider)({
            contentId: contentId,
            contentType: 'page',
            isExternalShare: false
        });
        editorApi.media?.actions.setProvider(provider);
    }, [
        editorApi,
        snippetId,
        snippetScope,
        contentId
    ]);
    return {
        preset: preset,
        editorApi: editorApi,
        ...options.extra,
        contextIdentifierProvider: contextIdentifierProvider
    };
}
module.exports["useSnippetEditorPreset"] = $f0584aa693e1c48d$export$879111968cad76c6;

});

parcelRegister("aIZFY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $a4skX = parcelRequire("a4skX");


var $i3S9F = parcelRequire("i3S9F");


var $6oMcp = parcelRequire("6oMcp");


var $8Pm8w = parcelRequire("8Pm8w");


var $kyaLk = parcelRequire("kyaLk");


var $d5Ozc = parcelRequire("d5Ozc");


var $bQm3c = parcelRequire("bQm3c");


var $dPJCf = parcelRequire("dPJCf");


var $hYoU4 = parcelRequire("hYoU4");


var $lmNXu = parcelRequire("lmNXu");


var $gsPOZ = parcelRequire("gsPOZ");


var $bcv7k = parcelRequire("bcv7k");


var $brsfB = parcelRequire("brsfB");


var $9Eka4 = parcelRequire("9Eka4");


var $6mKj3 = parcelRequire("6mKj3");


var $epn2u = parcelRequire("epn2u");


var $hfIjM = parcelRequire("hfIjM");

const $d76dfa6a91167ca3$export$a8d5017f08e89fae = ({ contentId: confluencePageId, contentType: contentType, focusedMentionId: focusedMentionId, spaceId: spaceId, editorActions: editorActions })=>{
    const { cloudId: cloudId, userId: userId, featureFlags: featureFlags } = (0, $bQm3c.useSessionData)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const confluencePageAri = (0, $cozmU.useMemo)(()=>(0, $6oMcp.getConfluencePageAri)({
            pageId: confluencePageId ?? '',
            cloudId: cloudId,
            pageType: contentType === 'page' ? 'page' : 'blogpost'
        }), [
        cloudId,
        confluencePageId,
        contentType
    ]);
    const [{ collabEditProvider: extractedCollabEditProvider }] = (0, $hYoU4.useNativeCollabState)();
    const getCollabVersion = (0, $cozmU.useCallback)(async ()=>{
        try {
            const ackState = await editorActions.getResolvedEditorState('publish');
            return ackState?.stepVersion;
        } catch  {
            return extractedCollabEditProvider?.getCurrentPmVersion();
        }
    }, [
        extractedCollabEditProvider,
        editorActions
    ]);
    const { fetchProvider: blockServiceFetchProvider, writeProvider: blockServiceWriteProvider } = (0, $8Pm8w.useMemoizedBlockServiceAPIProviders)({
        parentAri: confluencePageAri ?? '',
        parentId: confluencePageId ?? '',
        product: 'confluence-page',
        cloudId: cloudId,
        getVersion: getCollabVersion
    });
    const syncedBlockNestedRendererProviderCreator = (0, $9Eka4.useMemoizedSyncedBlockNestedRendererProviderCreator)(cloudId, userId);
    const mentionProvider = (0, $hfIjM.useMentionProvider)(spaceId, undefined, focusedMentionId);
    const profilecardProvider = (0, $brsfB.useProfilecardProvider)({
        push: push,
        cloudId: cloudId,
        featureFlags: featureFlags,
        userId: userId
    });
    const taskDecisionProvider = (0, $bcv7k.getTaskDecisionProvider)();
    const providerOptions = (0, $cozmU.useMemo)(()=>{
        return {
            parentDataProviders: {
                mentionProvider: mentionProvider,
                profilecardProvider: profilecardProvider,
                taskDecisionProvider: taskDecisionProvider
            },
            providerCreator: syncedBlockNestedRendererProviderCreator
        };
    }, [
        mentionProvider,
        profilecardProvider,
        taskDecisionProvider,
        syncedBlockNestedRendererProviderCreator
    ]);
    // Wrap the fetch provider with Relay subscription support
    const relayFetchProvider = (0, $cozmU.useMemo)(()=>(0, $gsPOZ.createRelaySyncBlockFetchProvider)(blockServiceFetchProvider, cloudId), [
        blockServiceFetchProvider,
        cloudId
    ]);
    const syncedBlockProvider = (0, $kyaLk.useMemoizedSyncedBlockProvider)({
        fetchProvider: relayFetchProvider,
        writeProvider: blockServiceWriteProvider,
        providerOptions: providerOptions,
        getSSRData: (0, $epn2u.syncedBlockLoadSSRData)
    });
    return confluencePageId ? syncedBlockProvider : undefined;
};
const $d76dfa6a91167ca3$export$7ca4b457497916fd = (_props)=>{
    return undefined;
};
const $d76dfa6a91167ca3$var$isFedrampOrIsolatedCloud = ()=>{
    return (0, $a4skX.isFedrampModerate)() || (0, $i3S9F.isIsolatedCloud)();
};
const $d76dfa6a91167ca3$export$f25db4ac921df51 = (0, $d5Ozc.conditionalHooksFactory)(()=>!$d76dfa6a91167ca3$var$isFedrampOrIsolatedCloud() && (0, $6mKj3.isExperimentEnabled)('platform_synced_block'), $d76dfa6a91167ca3$export$a8d5017f08e89fae, $d76dfa6a91167ca3$export$7ca4b457497916fd);
const $d76dfa6a91167ca3$var$useSyncedBlockForEmbeddedEditorEnabled = ({ contentId: contentId, contentType: contentType, spaceId: spaceId, editorActions: editorActions })=>{
    const syncedBlockProvider = $d76dfa6a91167ca3$export$a8d5017f08e89fae({
        contentId: contentId,
        contentType: contentType,
        spaceId: spaceId,
        editorActions: editorActions
    });
    const matchRoute = (0, $dPJCf.useMatchRoute)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const syncedBlockEventHandlers = (0, $cozmU.useMemo)(()=>(0, $lmNXu.createSmartCardEventHandler)({
            matchRoute: matchRoute,
            push: push
        }, true), [
        matchRoute,
        push
    ]);
    return {
        syncedBlockProvider: syncedBlockProvider,
        syncedBlockEventHandlers: syncedBlockEventHandlers
    };
};
const $d76dfa6a91167ca3$var$useSyncedBlockForEmbeddedEditorDisabled = ()=>({
        syncedBlockProvider: undefined,
        syncedBlockEventHandlers: undefined
    });
const $d76dfa6a91167ca3$export$827c611ac239e3f6 = (0, $d5Ozc.conditionalHooksFactory)(()=>(0, $6mKj3.isExperimentEnabled)('platform_synced_block'), $d76dfa6a91167ca3$var$useSyncedBlockForEmbeddedEditorEnabled, $d76dfa6a91167ca3$var$useSyncedBlockForEmbeddedEditorDisabled);
module.exports["useMemoizedSyncedBlockProviderForEditor"] = $d76dfa6a91167ca3$export$f25db4ac921df51;
module.exports["useSyncedBlockForEmbeddedEditor"] = $d76dfa6a91167ca3$export$827c611ac239e3f6;

});

parcelRegister("6oMcp", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ const $0dfedb71521ac678$var$CONFLUENCE_PAGE_ARI_REGEX = /ari:cloud:confluence:[^:]+:(page|blogpost)\/(\d+)/;
const $0dfedb71521ac678$export$3c54cf45dfed84ea = ({ pageId: pageId, cloudId: cloudId, pageType: pageType })=>{
    return `ari:cloud:confluence:${cloudId}:${pageType}/${pageId}`;
};
const $0dfedb71521ac678$export$2ee4e689bde04de2 = ({ ari: ari })=>{
    const match = ari.match($0dfedb71521ac678$var$CONFLUENCE_PAGE_ARI_REGEX);
    if (match?.[2]) return {
        type: match[1],
        id: match[2]
    };
    throw new Error(`Invalid page ARI: ${ari}`);
};
module.exports["getConfluencePageAri"] = $0dfedb71521ac678$export$3c54cf45dfed84ea;
module.exports["getPageIdAndTypeFromConfluencePageAri"] = $0dfedb71521ac678$export$2ee4e689bde04de2;

});

parcelRegister("8Pm8w", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ 
var $cozmU = parcelRequire("cozmU");


var $ieeJu = parcelRequire("ieeJu");


var $3xsB6 = parcelRequire("3xsB6");


var $05aaK = parcelRequire("05aaK");


var $79ir6 = parcelRequire("79ir6");


var $916Gd = parcelRequire("916Gd");


var $cuwGS = parcelRequire("cuwGS");


var $d04Ge = parcelRequire("d04Ge");

const $9b0c4608cd445e14$var$BLOCK_ARI_TO_RESOURCE_ID_REGEX = /^ari:cloud:blocks:.*:synced-block\/(.+)$/;
const $9b0c4608cd445e14$var$EXTRACT_RESOURCE_ID_FROM_BLOCK_ARI_REGEX = /ari:cloud:blocks:[^:]+:synced-block\/(.+)$/;
const $9b0c4608cd445e14$var$mapBlockError = (error)=>{
    switch(error.status){
        case 400:
        case 401:
            return (0, $79ir6.SyncBlockError).InvalidRequest;
        case 403:
            return (0, $79ir6.SyncBlockError).Forbidden;
        case 404:
            return (0, $79ir6.SyncBlockError).NotFound;
        case 409:
            return (0, $79ir6.SyncBlockError).Conflict;
        case 429:
            return (0, $79ir6.SyncBlockError).RateLimited;
        case 500:
        case 503:
        case 504:
            return (0, $79ir6.SyncBlockError).ServerError;
    }
    return (0, $79ir6.SyncBlockError).Errored;
};
const $9b0c4608cd445e14$var$mapErrorResponseCode = (errorCode)=>{
    switch(errorCode){
        case 'FORBIDDEN':
            return (0, $79ir6.SyncBlockError).Forbidden;
        case 'RESOURCE_NOT_FOUND':
        case 'NOT_FOUND':
            return (0, $79ir6.SyncBlockError).NotFound;
        case 'EntityNotFound':
            return (0, $79ir6.SyncBlockError).EntityNotFound;
        case 'INVALID_REQUEST':
            return (0, $79ir6.SyncBlockError).InvalidRequest;
        case 'CONFLICT':
            return (0, $79ir6.SyncBlockError).Conflict;
        case 'RATE_LIMITED':
            return (0, $79ir6.SyncBlockError).RateLimited;
        case 'SERVER_ERROR':
            return (0, $79ir6.SyncBlockError).ServerError;
        case 'INVALID_CONTENT':
            return (0, $79ir6.SyncBlockError).InvalidContent;
        default:
            return (0, $79ir6.SyncBlockError).Errored;
    }
};
const $9b0c4608cd445e14$export$7a367d6c9621d11 = (blockAri)=>{
    // Validate ARI format and extract resourceId using regex
    // Format: ari:cloud:blocks:{uuid}:synced-block/{product}/{parentId}/{resourceId}
    // The regex captures the full path after synced-block/
    // e.g. ari:cloud:blocks:DUMMY-a5a01d21-1cc3-4f29-9565-f2bb8cd969f5:synced-block/confluence-page/455232061495/e8cf64e3-1b6e-489b-ad86-8465b0905bb4
    // should return confluence-page/455232061495/e8cf64e3-1b6e-489b-ad86-8465b0905bb4
    const match = blockAri.match($9b0c4608cd445e14$var$BLOCK_ARI_TO_RESOURCE_ID_REGEX);
    return match?.[1] || null;
};
const $9b0c4608cd445e14$export$bba762cb095b2f42 = (data, resourceId)=>{
    let createdAt;
    if (data.createdAt !== undefined && data.createdAt !== null) try {
        createdAt = new Date(data.createdAt).toISOString();
    } catch  {
        // fallback to undefined
        // as we don't want to block the whole process due to invalid date
        createdAt = undefined;
    }
    return {
        blockInstanceId: data.blockInstanceId,
        content: JSON.parse(data.content),
        contentUpdatedAt: (0, $d04Ge.convertContentUpdatedAt)(data.contentUpdatedAt),
        createdAt: createdAt,
        createdBy: data.createdBy,
        product: data.product,
        resourceId: resourceId,
        sourceAri: data.sourceAri,
        status: data.status
    };
};
const $9b0c4608cd445e14$export$17132bdfdc28611c = async (documentAri)=>{
    let response;
    try {
        response = await (0, $05aaK.getReferenceSyncedBlocks)(documentAri);
    } catch (error) {
        if (error instanceof (0, $05aaK.BlockError)) return $9b0c4608cd445e14$var$mapBlockError(error);
        return (0, $79ir6.SyncBlockError).Errored;
    }
    const { blocks: blocks, errors: errors } = response || {};
    const blocksInstances = (blocks || []).map((blockContentResponse)=>{
        try {
            const resourceId = $9b0c4608cd445e14$export$7a367d6c9621d11(blockContentResponse.blockAri);
            if (!resourceId) // could not extract resourceId from blockAri, return InvalidContent error
            return {
                error: {
                    type: (0, $79ir6.SyncBlockError).InvalidContent
                },
                resourceId: blockContentResponse.blockAri
            };
            return {
                data: $9b0c4608cd445e14$export$bba762cb095b2f42(blockContentResponse, resourceId),
                resourceId: resourceId
            };
        } catch  {
            // JSON parsing error, return InvalidContent error
            return {
                error: {
                    type: (0, $79ir6.SyncBlockError).InvalidContent
                },
                resourceId: blockContentResponse.blockAri
            };
        }
    });
    const errorInstances = (errors || []).map((errorBlock)=>({
            error: {
                type: (0, $79ir6.SyncBlockError).Errored
            },
            resourceId: errorBlock.blockAri
        }));
    return [
        ...blocksInstances,
        ...errorInstances
    ];
};
const $9b0c4608cd445e14$export$2837853885c81488 = (blockAri)=>{
    const match = blockAri.match($9b0c4608cd445e14$var$EXTRACT_RESOURCE_ID_FROM_BLOCK_ARI_REGEX);
    return match?.[1];
};
const $9b0c4608cd445e14$export$abdcb5d4d6767e73 = async (cloudId, parentAri, blockNodeIdentifiers, config)=>{
    const blockIdentifiers = blockNodeIdentifiers.map((blockIdentifier)=>({
            blockAri: (0, $3xsB6.generateBlockAriFromReference)({
                cloudId: cloudId,
                resourceId: blockIdentifier.resourceId
            }),
            blockInstanceId: blockIdentifier.blockInstanceId
        }));
    // Create a set of valid resourceIds for validation
    const validResourceIds = new Set(blockNodeIdentifiers.map((blockNodeIdentifier)=>blockNodeIdentifier.resourceId));
    // Track which resourceIds have been processed
    const processedResourceIds = new Set();
    if (!parentAri) return blockNodeIdentifiers.map((blockNodeIdentifier)=>({
            error: {
                type: (0, $79ir6.SyncBlockError).Errored
            },
            resourceId: blockNodeIdentifier.resourceId
        }));
    try {
        const response = await (0, $05aaK.batchRetrieveSyncedBlocks)({
            blockIdentifiers: blockIdentifiers,
            config: config
        });
        const results = [];
        // Process successful blocks
        if (response.success) for (const blockContentResponse of response.success){
            // Extract resourceId from the returned blockAri
            const resourceId = $9b0c4608cd445e14$export$2837853885c81488(blockContentResponse.blockAri);
            if (!resourceId || !validResourceIds.has(resourceId)) continue;
            processedResourceIds.add(resourceId);
            const { content: content, deletionReason: deletionReason, sourceAri: sourceAri, blockAri: blockAri, contentUpdatedAt: contentUpdatedAt, blockInstanceId: blockInstanceId, product: product, status: status } = blockContentResponse;
            if (!content) {
                results.push({
                    error: {
                        type: (0, $79ir6.SyncBlockError).NotFound,
                        reason: deletionReason,
                        sourceAri: sourceAri
                    },
                    resourceId: resourceId
                });
                continue;
            }
            try {
                const syncedBlockData = JSON.parse(content);
                results.push({
                    data: {
                        content: syncedBlockData,
                        resourceId: blockAri,
                        contentUpdatedAt: (0, $d04Ge.convertContentUpdatedAt)(contentUpdatedAt),
                        blockInstanceId: blockInstanceId,
                        sourceAri: sourceAri,
                        product: product,
                        status: status,
                        deletionReason: deletionReason
                    },
                    resourceId: resourceId
                });
            } catch  {
                results.push({
                    error: {
                        type: (0, $79ir6.SyncBlockError).Errored,
                        reason: `parsing JSON content response failed for resourceId: ${resourceId} localId: ${blockAri}`
                    },
                    resourceId: resourceId
                });
            }
        }
        // Process errors
        if (response.error) for (const errorResponse of response.error){
            // Extract resourceId from the returned blockAri
            const resourceId = $9b0c4608cd445e14$export$2837853885c81488(errorResponse.blockAri);
            if (!resourceId || !validResourceIds.has(resourceId)) continue;
            processedResourceIds.add(resourceId);
            results.push({
                error: {
                    type: $9b0c4608cd445e14$var$mapErrorResponseCode(errorResponse.code),
                    reason: errorResponse.reason
                },
                resourceId: resourceId
            });
        }
        // Ensure all resourceIds have a result - return NotFound for any missing ones
        for (const blockNodeIdentifier of blockNodeIdentifiers)if (!processedResourceIds.has(blockNodeIdentifier.resourceId)) results.push({
            error: {
                type: (0, $79ir6.SyncBlockError).NotFound
            },
            resourceId: blockNodeIdentifier.resourceId
        });
        return results;
    } catch (error) {
        if (error instanceof (0, $05aaK.BlockTimeoutError) && (0, $ieeJu.expValEquals)('platform_editor_sync_block_ssr_config', 'isEnabled', true)) return blockNodeIdentifiers.map((blockNodeIdentifier)=>({
                error: {
                    type: (0, $79ir6.SyncBlockError).Aborted,
                    reason: error.message
                },
                resourceId: blockNodeIdentifier.resourceId
            }));
        // If batch request fails, return error for all resourceIds. Capture the HTTP
        // status from `BlockError` so fetch analytics can break failures down by
        // statusCode (EDITOR-7862); undefined for non-HTTP failures. Thread the PII-safe
        // original message/name so the renderer can de-opaque the `errored` bucket.
        return blockNodeIdentifiers.map((blockNodeIdentifier)=>({
                error: {
                    type: error instanceof (0, $05aaK.BlockError) ? $9b0c4608cd445e14$var$mapBlockError(error) : (0, $79ir6.SyncBlockError).Errored,
                    reason: error.message,
                    ...error instanceof (0, $05aaK.BlockError) && {
                        statusCode: error.status
                    },
                    ...(0, $916Gd.getPiiSafeOriginalError)(error)
                },
                resourceId: blockNodeIdentifier.resourceId
            }));
    }
};
const $9b0c4608cd445e14$export$13b682467148f88a = async (cloudId, parentAri, parentId, product, data, stepVersion)=>{
    if (!parentAri || !parentId) return data.map((block)=>({
            error: (0, $79ir6.SyncBlockError).Errored,
            resourceId: block.resourceId
        }));
    try {
        // Create a map from blockAri to original resourceId for matching responses
        const blockAriToResourceIdMap = new Map();
        const blocks = data.map((block)=>{
            const blockAri = (0, $3xsB6.generateBlockAri)({
                cloudId: cloudId,
                parentId: parentId,
                product: product,
                resourceId: block.resourceId
            });
            blockAriToResourceIdMap.set(blockAri, block.resourceId);
            return {
                blockAri: blockAri,
                content: JSON.stringify(block.content),
                status: block.status,
                stepVersion: stepVersion
            };
        });
        const response = await (0, $05aaK.updateSyncedBlocks)({
            blocks: blocks
        });
        const results = [];
        // Process successful updates
        if (response.success) {
            const successResourceIds = new Set(response.success.map((block)=>blockAriToResourceIdMap.get(block.blockAri)));
            for (const block of data)if (successResourceIds.has(block.resourceId)) results.push({
                resourceId: block.resourceId
            });
        }
        if (response.error) {
            const errorResourceIds = new Map(response.error.map((err)=>[
                    // Use the map to get the original resourceId
                    blockAriToResourceIdMap.get(err.blockAri) || '',
                    $9b0c4608cd445e14$var$mapErrorResponseCode(err.code)
                ]));
            for (const block of data){
                const error = errorResourceIds.get(block.resourceId);
                if (error) results.push({
                    error: error,
                    resourceId: block.resourceId
                });
                else if (!results.some((r)=>r.resourceId === block.resourceId)) // If not in success or error lists, mark as errored
                results.push({
                    error: (0, $79ir6.SyncBlockError).Errored,
                    resourceId: block.resourceId
                });
            }
        }
        return results;
    } catch (error) {
        if (error instanceof (0, $05aaK.BlockError)) return data.map((block)=>({
                error: $9b0c4608cd445e14$var$mapBlockError(error),
                resourceId: block.resourceId,
                statusCode: error.status
            }));
        return data.map((block)=>({
                error: (0, $916Gd.stringifyError)(error),
                resourceId: block.resourceId
            }));
    }
};

/**
 * ADFFetchProvider implementation that fetches synced block data from Block Service API
 */ class $9b0c4608cd445e14$var$BlockServiceADFFetchProvider {
    // resourceId of the reference synced block.
    // the ARI must be constructed to call the block service API
    async fetchData(resourceId) {
        const blockAri = (0, $3xsB6.generateBlockAriFromReference)({
            cloudId: this.cloudId,
            resourceId: resourceId
        });
        try {
            const blockContentResponse = await (0, $05aaK.getSyncedBlockContent)({
                blockAri: blockAri
            });
            const { content: content, sourceAri: sourceAri, deletionReason: deletionReason, blockInstanceId: blockInstanceId, contentUpdatedAt: contentUpdatedAt, product: product, status: status } = blockContentResponse;
            if (!content) return {
                error: {
                    type: (0, $79ir6.SyncBlockError).NotFound,
                    reason: deletionReason,
                    sourceAri: sourceAri
                },
                resourceId: resourceId
            };
            // Parse the synced block content from the response's content
            const syncedBlockData = JSON.parse(content);
            return {
                data: {
                    content: syncedBlockData,
                    resourceId: blockAri,
                    blockInstanceId: blockInstanceId,
                    // this was the node's localId, but has become the resourceId.
                    contentUpdatedAt: (0, $d04Ge.convertContentUpdatedAt)(contentUpdatedAt),
                    sourceAri: sourceAri,
                    product: product,
                    status: status,
                    deletionReason: deletionReason
                },
                resourceId: resourceId
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) // Capture the HTTP status so fetch analytics can break failures down by
            // statusCode (EDITOR-7862). Thread the PII-safe original message/name so
            // the renderer can de-opaque failures.
            return {
                error: {
                    type: $9b0c4608cd445e14$var$mapBlockError(error),
                    reason: error.message,
                    statusCode: error.status,
                    ...(0, $916Gd.getPiiSafeOriginalError)(error)
                },
                resourceId: resourceId
            };
            return {
                error: {
                    type: (0, $79ir6.SyncBlockError).Errored,
                    reason: error.message,
                    ...(0, $916Gd.getPiiSafeOriginalError)(error)
                },
                resourceId: resourceId
            };
        }
    }
    async fetchReferences(referenceResourceId) {
        try {
            const blockAri = (0, $3xsB6.generateBlockAriFromReference)({
                cloudId: this.cloudId,
                resourceId: referenceResourceId
            });
            const response = await (0, $05aaK.getReferenceSyncedBlocksByBlockAri)({
                blockAri: blockAri
            });
            const references = [];
            response.references.forEach((reference)=>{
                references.push({
                    ...reference,
                    hasAccess: true,
                    onSameDocument: this.parentAri === reference.documentAri
                });
            });
            response.errors.forEach((reference)=>{
                if (reference.code === 'FORBIDDEN') references.push({
                    blockAri: reference.blockAri,
                    documentAri: reference.documentAri,
                    hasAccess: false,
                    onSameDocument: false
                });
            });
            return {
                references: references
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return {
                error: $9b0c4608cd445e14$var$mapBlockError(error)
            };
            return {
                error: (0, $79ir6.SyncBlockError).Errored
            };
        }
    }
    /**
   * Batch fetches multiple synced blocks by their resource IDs.
   * @param blockNodeIdentifiers - Array of block node identifiers to fetch
   * @param config - Optional batch fetch configuration
   * @returns Array of SyncBlockInstance results
   */ async batchFetchData(blockNodeIdentifiers, config) {
        return await $9b0c4608cd445e14$export$abdcb5d4d6767e73(this.cloudId, this.parentAri, blockNodeIdentifiers, config);
    }
    /**
   * Subscribes to real-time updates for a specific block using GraphQL WebSocket subscriptions.
   * @param resourceId - The resource ID of the block to subscribe to
   * @param onUpdate - Callback function invoked when the block is updated
   * @param onError - Optional callback function invoked on subscription errors
   * @returns Unsubscribe function to stop receiving updates
   */ subscribeToBlockUpdates(resourceId, onUpdate, onError, onComplete) {
        const blockAri = (0, $3xsB6.generateBlockAriFromReference)({
            cloudId: this.cloudId,
            resourceId: resourceId
        });
        // Track the real unsubscribe fn once the dynamic import resolves
        let unsubscribe;
        let cancelled = false;
        // Dynamically import blockSubscription so that graphql-ws is NOT pulled
        // into the SSR/preload bundle that imports this subpath.
        (parcelRequire("4KByH")).then(({ subscribeToBlockUpdates: subscribeToBlockUpdatesWS })=>{
            if (cancelled) return;
            unsubscribe = subscribeToBlockUpdatesWS(blockAri, (parsedData)=>{
                // Convert ParsedBlockSubscriptionData to SyncBlockInstance
                const syncBlockInstance = {
                    data: {
                        content: parsedData.content,
                        resourceId: parsedData.blockAri,
                        blockInstanceId: parsedData.blockInstanceId,
                        sourceAri: parsedData.sourceAri,
                        product: parsedData.product,
                        createdAt: parsedData.createdAt,
                        contentUpdatedAt: parsedData.contentUpdatedAt,
                        createdBy: parsedData.createdBy,
                        status: parsedData.status
                    },
                    resourceId: parsedData.resourceId
                };
                onUpdate(syncBlockInstance);
            }, onError, onComplete);
        }).catch((err)=>{
            if (cancelled) return;
            onError?.(err instanceof Error ? err : new Error('Failed to load subscription module'));
        });
        // Return an unsubscribe fn that works whether the import has resolved or not
        return ()=>{
            cancelled = true;
            unsubscribe?.();
        };
    }
    constructor({ cloudId: cloudId, parentAri: parentAri }){
        this.cloudId = void 0;
        this.parentAri = void 0;
        this.cloudId = cloudId;
        this.parentAri = parentAri;
    }
}
/**
 * ADFWriteProvider implementation that writes synced block data to Block Service API
 */ class $9b0c4608cd445e14$var$BlockServiceADFWriteProvider {
    async writeData(data) {
        if (!this.parentAri || !this.parentId) return {
            error: (0, $79ir6.SyncBlockError).Errored
        };
        const { resourceId: resourceId } = data;
        const blockAri = (0, $3xsB6.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId,
            product: this.product,
            resourceId: resourceId
        });
        const stepVersion = this.getVersion ? await this.getVersion() : undefined;
        try {
            const status = data.status;
            await (0, $05aaK.updateSyncedBlock)({
                blockAri: blockAri,
                content: JSON.stringify(data.content),
                stepVersion: stepVersion,
                status: status
            });
            return {
                resourceId: resourceId
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return {
                error: $9b0c4608cd445e14$var$mapBlockError(error),
                resourceId: resourceId,
                statusCode: error.status
            };
            return {
                error: (0, $916Gd.stringifyError)(error),
                resourceId: resourceId
            };
        }
    }
    async createData(data) {
        if (!this.parentAri || !this.parentId) return {
            error: (0, $79ir6.SyncBlockError).Errored
        };
        const { resourceId: resourceId } = data;
        const blockAri = (0, $3xsB6.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId,
            product: this.product,
            resourceId: resourceId
        });
        const stepVersion = this.getVersion ? await this.getVersion() : undefined;
        const status = 'unpublished';
        try {
            await (0, $05aaK.createSyncedBlock)({
                blockAri: blockAri,
                blockInstanceId: data.blockInstanceId,
                sourceAri: this.parentAri,
                product: this.product,
                content: JSON.stringify(data.content),
                stepVersion: stepVersion,
                status: status
            });
            return {
                resourceId: resourceId
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return {
                error: $9b0c4608cd445e14$var$mapBlockError(error),
                resourceId: resourceId,
                statusCode: error.status
            };
            return {
                error: (0, $916Gd.stringifyError)(error),
                resourceId: resourceId
            };
        }
    }
    // soft deletes the source synced block
    async deleteData(resourceId, deleteReason) {
        if (!this.parentId) return {
            resourceId: resourceId,
            success: false,
            error: (0, $79ir6.SyncBlockError).Errored
        };
        const blockAri = (0, $3xsB6.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId,
            product: this.product,
            resourceId: resourceId
        });
        try {
            await (0, $05aaK.deleteSyncedBlock)({
                blockAri: blockAri,
                deleteReason: deleteReason
            });
            return {
                resourceId: resourceId,
                success: true,
                error: undefined
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockNotFoundError) && this.parentAri) return this.deleteOrphanBlock({
                blockAri: blockAri,
                resourceId: resourceId,
                parentAri: this.parentAri,
                deleteReason: deleteReason
            });
            if (error instanceof (0, $05aaK.BlockError)) {
                if (error.status === 404) // User should not be blocked by not_found error when deleting,
                // hence returns successful result for 404 error
                return {
                    resourceId: resourceId,
                    success: true
                };
                return {
                    resourceId: resourceId,
                    success: false,
                    error: $9b0c4608cd445e14$var$mapBlockError(error),
                    statusCode: error.status
                };
            }
            return {
                resourceId: resourceId,
                success: false,
                error: (0, $916Gd.stringifyError)(error)
            };
        }
    }
    // The block is an orphan (e.g. from a copied page) — it doesn't exist in Block Service.
    // Block Service uses soft-deletes, so we must first create the block then delete it,
    // ensuring a deletion-reason record is stored (used to display errors in reference blocks).
    async deleteOrphanBlock({ blockAri: blockAri, resourceId: resourceId, parentAri: parentAri, deleteReason: deleteReason }) {
        try {
            const stepVersion = this.getVersion ? await this.getVersion() : undefined;
            try {
                await (0, $05aaK.createSyncedBlock)({
                    blockAri: blockAri,
                    blockInstanceId: resourceId,
                    sourceAri: parentAri,
                    product: this.product,
                    content: '[]',
                    stepVersion: stepVersion
                });
            } catch (createError) {
                // "Conditional check failed" means the block already exists in Block Service.
                // This can happen when an orphan block is copied and pasted — a reference block repair
                // in the backend may have already created it. We can proceed directly to delete it.
                if (createError instanceof Error && createError.message.includes('Conditional check failed')) ;
                else if (createError instanceof (0, $05aaK.BlockError)) return {
                    resourceId: resourceId,
                    success: false,
                    error: $9b0c4608cd445e14$var$mapBlockError(createError),
                    statusCode: createError.status
                };
                else return {
                    resourceId: resourceId,
                    success: false,
                    error: (0, $916Gd.stringifyError)(createError)
                };
            }
            await (0, $05aaK.deleteSyncedBlock)({
                blockAri: blockAri,
                deleteReason: deleteReason
            });
            return {
                resourceId: resourceId,
                success: true,
                error: undefined
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return {
                resourceId: resourceId,
                success: false,
                error: $9b0c4608cd445e14$var$mapBlockError(error),
                statusCode: error.status
            };
            return {
                resourceId: resourceId,
                success: false,
                error: (0, $916Gd.stringifyError)(error)
            };
        }
    }
    // the sourceId is the resourceId of the source synced block.
    generateResourceIdForReference(sourceId) {
        return (0, $cuwGS.createResourceIdForReference)(this.product, this.parentId || '', sourceId);
    }
    generateResourceId() {
        return crypto.randomUUID();
    }
    generateBlockAri(resourceId) {
        return (0, $3xsB6.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId || '',
            product: this.product,
            resourceId: resourceId
        });
    }
    async updateReferenceData(blocks, noContent) {
        if (!this.parentAri) return {
            success: false,
            error: (0, $79ir6.SyncBlockError).Errored
        };
        try {
            await (0, $05aaK.updateReferenceSyncedBlockOnDocument)({
                documentAri: this.parentAri,
                blocks: blocks.map((block)=>({
                        blockAri: (0, $3xsB6.generateBlockAriFromReference)({
                            cloudId: this.cloudId,
                            resourceId: block.resourceId
                        }),
                        blockInstanceId: block.localId
                    })),
                noContent: noContent
            });
            return {
                success: true
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return {
                success: false,
                error: $9b0c4608cd445e14$var$mapBlockError(error),
                statusCode: error.status
            };
            return {
                success: false,
                error: (0, $916Gd.stringifyError)(error)
            };
        }
    }
    async writeDataBatch(data) {
        if (!this.parentAri || !this.parentId) return data.map((block)=>({
                error: (0, $79ir6.SyncBlockError).Errored,
                resourceId: block.resourceId
            }));
        const stepVersion = this.getVersion ? await this.getVersion() : undefined;
        try {
            // Create a map from blockAri to original resourceId for matching responses
            const blockAriToResourceIdMap = new Map();
            const blocks = data.map((block)=>{
                const blockAri = this.generateBlockAri(block.resourceId);
                blockAriToResourceIdMap.set(blockAri, block.resourceId);
                return {
                    blockAri: blockAri,
                    content: JSON.stringify(block.content),
                    status: block.status,
                    stepVersion: stepVersion
                };
            });
            const response = await (0, $05aaK.updateSyncedBlocks)({
                blocks: blocks
            });
            const results = [];
            // Process successful updates
            if (response.success) {
                const successBlocks = new Map(response.success.map((block)=>[
                        blockAriToResourceIdMap.get(block.blockAri),
                        block
                    ]));
                for (const block of data){
                    const successBlock = successBlocks.get(block.resourceId);
                    if (successBlock) results.push({
                        resourceId: block.resourceId,
                        status: successBlock.status
                    });
                }
            }
            if (response.error) {
                const errorResourceIds = new Map(response.error.map((err)=>[
                        // Use the map to get the original resourceId
                        blockAriToResourceIdMap.get(err.blockAri) || '',
                        $9b0c4608cd445e14$var$mapErrorResponseCode(err.code)
                    ]));
                for (const block of data){
                    const error = errorResourceIds.get(block.resourceId);
                    if (error) {
                        if (error !== (0, $79ir6.SyncBlockError).NotFound) results.push({
                            error: error,
                            resourceId: block.resourceId
                        });
                    } else if (!results.some((r)=>r.resourceId === block.resourceId)) // If not in success or error lists, mark as errored
                    results.push({
                        error: (0, $79ir6.SyncBlockError).Errored,
                        resourceId: block.resourceId
                    });
                }
            }
            return results;
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return data.map((block)=>({
                    error: $9b0c4608cd445e14$var$mapBlockError(error),
                    resourceId: block.resourceId,
                    statusCode: error.status
                }));
            return data.map((block)=>({
                    error: (0, $916Gd.stringifyError)(error),
                    resourceId: block.resourceId
                }));
        }
    }
    constructor({ cloudId: cloudId, parentAri: parentAri, parentId: parentId, product: product, getVersion: getVersion }){
        this.cloudId = void 0;
        this.parentId = void 0;
        this.getVersion = void 0;
        this.product = void 0;
        this.parentAri = void 0;
        this.cloudId = cloudId;
        this.parentAri = parentAri;
        this.parentId = parentId;
        this.product = product;
        this.getVersion = getVersion;
    }
}
const $9b0c4608cd445e14$var$createBlockServiceAPIProviders = ({ cloudId: cloudId, parentAri: parentAri, parentId: parentId, product: product, getVersion: getVersion })=>{
    return {
        fetchProvider: new $9b0c4608cd445e14$var$BlockServiceADFFetchProvider({
            cloudId: cloudId,
            parentAri: parentAri
        }),
        writeProvider: new $9b0c4608cd445e14$var$BlockServiceADFWriteProvider({
            cloudId: cloudId,
            parentAri: parentAri,
            parentId: parentId,
            product: product,
            getVersion: getVersion
        })
    };
};
const $9b0c4608cd445e14$export$ec654f5ac7e6d976 = ({ cloudId: cloudId, parentAri: parentAri, parentId: parentId, product: product, getVersion: getVersion })=>{
    return (0, $cozmU.useMemo)(()=>{
        return $9b0c4608cd445e14$var$createBlockServiceAPIProviders({
            cloudId: cloudId,
            parentAri: parentAri,
            parentId: parentId,
            product: product,
            getVersion: getVersion
        });
    }, [
        cloudId,
        parentAri,
        parentId,
        product,
        getVersion
    ]);
};
const $9b0c4608cd445e14$var$createBlockServiceFetchOnlyAPIProvider = ({ cloudId: cloudId, parentAri: parentAri })=>{
    return {
        fetchProvider: new $9b0c4608cd445e14$var$BlockServiceADFFetchProvider({
            cloudId: cloudId,
            parentAri: parentAri
        }),
        writeProvider: undefined
    };
};
const $9b0c4608cd445e14$export$1e67317f82b65067 = ({ cloudId: cloudId, parentAri: parentAri })=>(0, $cozmU.useMemo)(()=>$9b0c4608cd445e14$var$createBlockServiceFetchOnlyAPIProvider({
            cloudId: cloudId,
            parentAri: parentAri
        }), [
        cloudId,
        parentAri
    ]);
module.exports["batchFetchData"] = $9b0c4608cd445e14$export$abdcb5d4d6767e73;
module.exports["useMemoizedBlockServiceAPIProviders"] = $9b0c4608cd445e14$export$ec654f5ac7e6d976;

});

parcelRegister("3xsB6", function(module, exports) {
/* eslint-disable require-unicode-regexp */ const $a2c616dead6b3b85$var$GET_LOCAL_ID_FROM_BLOCK_RESOURCE_ID_REGEX = /ari:cloud:blocks:[^:]+:synced-block\/([a-zA-Z0-9-]+)/;
const $a2c616dead6b3b85$var$JIRA_SOURCE_ARI_REGEX = /ari:cloud:jira:.*/;
const $a2c616dead6b3b85$var$CONFLUENCE_SOURCE_ARI_REGEX = /ari:cloud:confluence:.*/;
const $a2c616dead6b3b85$export$e79189cdb9940bc5 = ({ cloudId: cloudId, parentId: parentId, product: product, resourceId: resourceId })=>{
    return `ari:cloud:blocks:${cloudId}:synced-block/${product}/${parentId}/${resourceId}`;
};
const $a2c616dead6b3b85$export$92a2331f8a9ed841 = ({ cloudId: cloudId, resourceId: resourceId })=>{
    return `ari:cloud:blocks:${cloudId}:synced-block/${resourceId}`;
};
const $a2c616dead6b3b85$export$3f0878b0afe5a2c0 = (ari)=>{
    const match = ari.match($a2c616dead6b3b85$var$GET_LOCAL_ID_FROM_BLOCK_RESOURCE_ID_REGEX);
    if (match?.[1]) return match[1];
    throw new Error(`Invalid block ARI: ${ari}`);
};
const $a2c616dead6b3b85$export$c10656f449ea0fb5 = (ari)=>{
    const jiraMatch = ari?.search($a2c616dead6b3b85$var$JIRA_SOURCE_ARI_REGEX);
    if (jiraMatch !== -1) return 'jira-work-item';
    const confluenceMatch = ari?.search($a2c616dead6b3b85$var$CONFLUENCE_SOURCE_ARI_REGEX);
    if (confluenceMatch !== -1) return 'confluence-page';
    return undefined;
};
module.exports["generateBlockAri"] = $a2c616dead6b3b85$export$e79189cdb9940bc5;
module.exports["generateBlockAriFromReference"] = $a2c616dead6b3b85$export$92a2331f8a9ed841;
module.exports["getProductFromSourceAri"] = $a2c616dead6b3b85$export$c10656f449ea0fb5;

});

parcelRegister("05aaK", function(module, exports) {

var $48FpT = parcelRequire("48FpT");

const $59e004c7d849e8bb$export$f426a9918d7f49b3 = (response)=>{
    const content = response.content;
    return typeof content === 'string';
};
const $59e004c7d849e8bb$export$571f6abc3f4e5951 = async (documentAri)=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildGetDocumentReferenceBlocksQuery(documentAri),
        operationName: $59e004c7d849e8bb$var$GET_DOCUMENT_REFERENCE_BLOCKS_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockGetDocumentReferenceBlocks`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data) throw new Error('No data returned from GraphQL query');
    return result.data.blockService_getDocumentReferenceBlocks;
};
const $59e004c7d849e8bb$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $59e004c7d849e8bb$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $59e004c7d849e8bb$var$GET_DOCUMENT_REFERENCE_BLOCKS_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_DOCUMENT_REFERENCE_BLOCKS';
const $59e004c7d849e8bb$var$UPDATE_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_UPDATE_BLOCK';
const $59e004c7d849e8bb$var$DELETE_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_DELETE_BLOCK';
const $59e004c7d849e8bb$var$CREATE_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_CREATE_BLOCK';
const $59e004c7d849e8bb$var$UPDATE_DOCUMENT_REFERENCES_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_UPDATE_DOCUMENT_REFERENCES';
const $59e004c7d849e8bb$var$BATCH_RETRIEVE_BLOCKS_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_BATCH_RETRIEVE_BLOCKS';
const $59e004c7d849e8bb$var$GET_BLOCK_REFERENCES_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_REFERENCES';
const $59e004c7d849e8bb$var$GET_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_BLOCK';
const $59e004c7d849e8bb$var$BATCH_UPDATE_BLOCKS_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_BATCH_UPDATE_BLOCKS';
const $59e004c7d849e8bb$var$buildGetDocumentReferenceBlocksQuery = (documentAri)=>`query ${$59e004c7d849e8bb$var$GET_DOCUMENT_REFERENCE_BLOCKS_OPERATION_NAME} {
	blockService_getDocumentReferenceBlocks(documentAri: ${JSON.stringify(documentAri)}) {
		blocks {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			product
			sourceAri
			status
			version
		}
		errors {
			blockAri
			code
			reason
		}
	}
}`;
const $59e004c7d849e8bb$var$buildGetBlockQuery = (blockAri)=>`query ${$59e004c7d849e8bb$var$GET_BLOCK_OPERATION_NAME} {
	blockService_getBlock(blockAri: ${JSON.stringify(blockAri)}) {
		blockAri
		blockInstanceId
		content
		contentUpdatedAt
		createdAt
		createdBy
		deletionReason
		product
		sourceAri
		status
		version
	}
}`;
const $59e004c7d849e8bb$var$buildUpdateBlockMutation = (blockAri, content, stepVersion, status)=>{
    const inputParts = [
        `blockAri: ${JSON.stringify(blockAri)}`,
        `content: ${JSON.stringify(content)}`
    ];
    if (stepVersion !== undefined) inputParts.push(`stepVersion: ${stepVersion}`);
    if (status !== undefined) inputParts.push(`status: ${JSON.stringify(status)}`);
    const inputArgs = inputParts.join(', ');
    return `mutation ${$59e004c7d849e8bb$var$UPDATE_BLOCK_OPERATION_NAME} {
	blockService_updateBlock(input: { ${inputArgs} }) {
		__typename
	}
}`;
};
const $59e004c7d849e8bb$var$buildDeleteBlockMutation = (blockAri, deletionReason)=>{
    const inputParts = [
        `blockAri: ${JSON.stringify(blockAri)}`
    ];
    if (deletionReason !== undefined) inputParts.push(`deletionReason: ${JSON.stringify(deletionReason)}`);
    const inputArgs = inputParts.join(', ');
    return `mutation ${$59e004c7d849e8bb$var$DELETE_BLOCK_OPERATION_NAME} {
	blockService_deleteBlock(input: { ${inputArgs} }) {
		deleted
	}
}`;
};
/**
 * Converts product string to GraphQL enum format
 * 'confluence-page' -> 'CONFLUENCE_PAGE'
 * 'jira-work-item' -> 'JIRA_WORK_ITEM'
 */ const $59e004c7d849e8bb$var$convertProductToGraphQLEnum = (product)=>{
    switch(product){
        case 'confluence-page':
            return 'CONFLUENCE_PAGE';
        case 'jira-work-item':
            return 'JIRA_WORK_ITEM';
        default:
            {
                const exhaustiveCheck = product;
                throw new Error(`Unsupported product: ${exhaustiveCheck}`);
            }
    }
};
const $59e004c7d849e8bb$var$buildCreateBlockMutation = (blockAri, blockInstanceId, content, product, sourceAri, stepVersion, status)=>{
    const inputParts = [
        `blockAri: ${JSON.stringify(blockAri)}`,
        `blockInstanceId: ${JSON.stringify(blockInstanceId)}`,
        `content: ${JSON.stringify(content)}`,
        `product: ${$59e004c7d849e8bb$var$convertProductToGraphQLEnum(product)}`,
        `sourceAri: ${JSON.stringify(sourceAri)}`
    ];
    if (stepVersion !== undefined) inputParts.push(`stepVersion: ${stepVersion}`);
    if (status !== undefined) inputParts.push(`status: ${JSON.stringify(status)}`);
    const inputArgs = inputParts.join(', ');
    return `mutation ${$59e004c7d849e8bb$var$CREATE_BLOCK_OPERATION_NAME} {
	blockService_createBlock(input: { ${inputArgs} }) {
		blockAri
		blockInstanceId
		content
		contentUpdatedAt
		createdAt
		createdBy
		deletionReason
		product
		sourceAri
		status
		version
	}
}`;
};
const $59e004c7d849e8bb$var$buildUpdateDocumentReferencesMutation = (documentAri, blocks, noContent)=>{
    const blocksArray = blocks.map((block)=>`{ blockAri: ${JSON.stringify(block.blockAri)}, blockInstanceId: ${JSON.stringify(block.blockInstanceId)} }`).join(', ');
    const inputArgs = `documentAri: ${JSON.stringify(documentAri)}, blocks: [${blocksArray}], noContent: ${noContent}`;
    return `mutation ${$59e004c7d849e8bb$var$UPDATE_DOCUMENT_REFERENCES_OPERATION_NAME} {
	blockService_updateDocumentReferences(input: { ${inputArgs} }) {
		blocks {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			product
			sourceAri
			status
			version
		}
		errors {
			blockAri
			code
			reason
		}
	}
}`;
};
const $59e004c7d849e8bb$var$buildBatchRetrieveBlocksQuery = (blockAris)=>{
    const blockArisArray = blockAris.map((ari)=>JSON.stringify(ari)).join(', ');
    const inputArgs = `blockAris: [${blockArisArray}]`;
    return `query ${$59e004c7d849e8bb$var$BATCH_RETRIEVE_BLOCKS_OPERATION_NAME} {
	blockService_batchRetrieveBlocks(input: { ${inputArgs} }) {
		success {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			deletionReason
			product
			sourceAri
			status
			version
		}
		error {
			blockAri
			code
			reason
		}
	}
}`;
};
const $59e004c7d849e8bb$var$buildGetBlockReferencesQuery = (blockAri)=>{
    return `query ${$59e004c7d849e8bb$var$GET_BLOCK_REFERENCES_OPERATION_NAME} {
	blockService_getReferences(blockAri: ${JSON.stringify(blockAri)}) {
		references {
			blockAri
			blockInstanceId
			createdAt
			createdBy
			documentAri
		}
		errors {
			blockAri
			code
			reason
		}
	}
}`;
};
const $59e004c7d849e8bb$var$buildBatchUpdateBlocksMutation = (blocks)=>{
    const blocksArray = blocks.map((block)=>{
        const inputParts = [
            `blockAri: ${JSON.stringify(block.blockAri)}`,
            `content: ${JSON.stringify(block.content)}`
        ];
        if (block.stepVersion !== undefined) inputParts.push(`stepVersion: ${block.stepVersion}`);
        if (block.status !== undefined) inputParts.push(`status: ${JSON.stringify(block.status)}`);
        return `{ ${inputParts.join(', ')} }`;
    }).join(', ');
    return `mutation ${$59e004c7d849e8bb$var$BATCH_UPDATE_BLOCKS_OPERATION_NAME} {
	blockService_batchUpdateBlocks(input: { blocks: [${blocksArray}] }) {
		success {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			deletionReason
			product
			sourceAri
			status
			version
		}
		error {
			blockAri
			code
			reason
		}
	}
}`;
};
class $59e004c7d849e8bb$export$e47a0a94b0998697 extends Error {
    constructor(status){
        super(`Block error`), this.status = status;
    }
}
class $59e004c7d849e8bb$export$f5a00468af285e38 extends Error {
    constructor(){
        super('Block not found in Block Service');
        this.name = 'BlockNotFoundError';
    }
}
class $59e004c7d849e8bb$export$b5687000eb0902be extends Error {
    constructor(){
        super('Block request timed out');
        this.name = 'BlockTimeoutError';
    }
}
const $59e004c7d849e8bb$export$fab66d51cc0c1a7 = async ({ blockAri: blockAri })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildGetBlockQuery(blockAri),
        operationName: $59e004c7d849e8bb$var$GET_BLOCK_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockGetBlock`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_getBlock) throw new Error('No data returned from GraphQL query');
    return result.data.blockService_getBlock;
};
const $59e004c7d849e8bb$export$48a4f565308f4741 = async ({ blockIdentifiers: blockIdentifiers, config: config })=>{
    const blockAris = blockIdentifiers.map((blockIdentifier)=>blockIdentifier.blockAri);
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildBatchRetrieveBlocksQuery(blockAris),
        operationName: $59e004c7d849e8bb$var$BATCH_RETRIEVE_BLOCKS_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockBatchRetrieveBlocks`;
    // undefined or 0 or negative means no timeout,
    // We don't enforce a minimum timeout for simplicity
    const fetchPromise = (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    const timeoutMs = config?.timeoutMs ?? 0;
    const response = await (timeoutMs > 0 ? Promise.race([
        fetchPromise,
        new Promise((_, reject)=>setTimeout(()=>reject(new $59e004c7d849e8bb$export$b5687000eb0902be()), timeoutMs))
    ]) : fetchPromise);
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_batchRetrieveBlocks) throw new Error('No data returned from GraphQL query');
    const graphqlResponse = result.data.blockService_batchRetrieveBlocks;
    return {
        success: graphqlResponse.success,
        error: graphqlResponse.error
    };
};
const $59e004c7d849e8bb$export$cbbc86409cac3ee5 = async ({ blockAri: blockAri, deleteReason: deleteReason })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildDeleteBlockMutation(blockAri, deleteReason),
        operationName: $59e004c7d849e8bb$var$DELETE_BLOCK_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockDeleteBlock`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) {
        const allNotFound = result.errors.every((e)=>e.extensions?.errorType === 'RESOURCE_NOT_FOUND');
        if (allNotFound) // Throw BlockNotFoundError so the caller can create the block first then retry the delete.
        // Block Service uses soft-deletes: the entry must exist before deletion so a deletion-reason
        // is stored (used to display errors in reference blocks).
        throw new $59e004c7d849e8bb$export$f5a00468af285e38();
        throw new Error(result.errors.map((e)=>e.message).join(', '));
    }
    const isDeleted = result.data?.blockService_deleteBlock?.deleted;
    if (!isDeleted) throw new Error('Block deletion failed; deleted flag is false');
};
const $59e004c7d849e8bb$export$d5bf0c5618431e5e = async ({ blockAri: blockAri, content: content, stepVersion: stepVersion, status: status })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildUpdateBlockMutation(blockAri, content, stepVersion, status),
        operationName: $59e004c7d849e8bb$var$UPDATE_BLOCK_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockUpdateBlock`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
};
const $59e004c7d849e8bb$export$fbc30658d812c800 = async ({ blockAri: blockAri, blockInstanceId: blockInstanceId, sourceAri: sourceAri, product: product, content: content, stepVersion: stepVersion, status: status })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildCreateBlockMutation(blockAri, blockInstanceId, content, product, sourceAri, stepVersion, status),
        operationName: $59e004c7d849e8bb$var$CREATE_BLOCK_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockCreateBlock`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_createBlock) throw new Error('No data returned from GraphQL mutation');
    return result.data.blockService_createBlock;
};
const $59e004c7d849e8bb$export$59c7369fa04bcba1 = async ({ documentAri: documentAri, blocks: blocks, noContent: noContent = true })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildUpdateDocumentReferencesMutation(documentAri, blocks, noContent),
        operationName: $59e004c7d849e8bb$var$UPDATE_DOCUMENT_REFERENCES_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockUpdateDocumentReferences`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData),
        keepalive: true
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!noContent) {
        if (!result.data?.blockService_updateDocumentReferences) throw new Error('No data returned from GraphQL mutation');
        return result.data.blockService_updateDocumentReferences;
    }
};
const $59e004c7d849e8bb$export$75f5aeff9ce22a33 = async ({ blockAri: blockAri })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildGetBlockReferencesQuery(blockAri),
        operationName: $59e004c7d849e8bb$var$GET_BLOCK_REFERENCES_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockGetReferences`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_getReferences) throw new Error('No data returned from GraphQL query');
    const graphqlResponse = result.data.blockService_getReferences;
    return {
        blockAri: blockAri,
        references: graphqlResponse.references || [],
        errors: graphqlResponse.errors || []
    };
};
const $59e004c7d849e8bb$export$a9e53fa4329b5ed2 = async ({ blocks: blocks })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildBatchUpdateBlocksMutation(blocks),
        operationName: $59e004c7d849e8bb$var$BATCH_UPDATE_BLOCKS_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockBatchUpdateBlocks`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_batchUpdateBlocks) throw new Error('No data returned from GraphQL mutation');
    const graphqlResponse = result.data.blockService_batchUpdateBlocks;
    return {
        success: graphqlResponse.success,
        error: graphqlResponse.error
    };
};
module.exports["getReferenceSyncedBlocks"] = $59e004c7d849e8bb$export$571f6abc3f4e5951;
module.exports["BlockError"] = $59e004c7d849e8bb$export$e47a0a94b0998697;
module.exports["BlockNotFoundError"] = $59e004c7d849e8bb$export$f5a00468af285e38;
module.exports["BlockTimeoutError"] = $59e004c7d849e8bb$export$b5687000eb0902be;
module.exports["getSyncedBlockContent"] = $59e004c7d849e8bb$export$fab66d51cc0c1a7;
module.exports["batchRetrieveSyncedBlocks"] = $59e004c7d849e8bb$export$48a4f565308f4741;
module.exports["deleteSyncedBlock"] = $59e004c7d849e8bb$export$cbbc86409cac3ee5;
module.exports["updateSyncedBlock"] = $59e004c7d849e8bb$export$d5bf0c5618431e5e;
module.exports["createSyncedBlock"] = $59e004c7d849e8bb$export$fbc30658d812c800;
module.exports["updateReferenceSyncedBlockOnDocument"] = $59e004c7d849e8bb$export$59c7369fa04bcba1;
module.exports["getReferenceSyncedBlocksByBlockAri"] = $59e004c7d849e8bb$export$75f5aeff9ce22a33;
module.exports["updateSyncedBlocks"] = $59e004c7d849e8bb$export$a9e53fa4329b5ed2;

});

parcelRegister("48FpT", function(module, exports) {
const $fc075454b76b2577$var$MAX_RETRY_DELAY = 30000;
const $fc075454b76b2577$var$parseRetryAfter = (retryAfter)=>{
    // retryAfter can either be in seconds or HTTP date
    const parsedRetryAfter = parseInt(retryAfter, 10);
    if (!isNaN(parsedRetryAfter) && parsedRetryAfter > 0) return parsedRetryAfter * 1000;
    const retryDate = new Date(retryAfter);
    if (isNaN(retryDate.getTime())) return undefined;
    const delayFromDate = retryDate.getTime() - Date.now();
    if (delayFromDate > 0) return delayFromDate;
    return undefined;
};
const $fc075454b76b2577$export$cffaac380b94df26 = async (url, options, retriesRemaining = 3, delay = 1000)=>{
    const response = await fetch(url, options);
    const shouldRetry = !response.ok && response.status === 429 && retriesRemaining > 1;
    if (!shouldRetry) return response;
    const retryAfter = response.headers.get('Retry-After');
    const parsedDelay = (retryAfter ? $fc075454b76b2577$var$parseRetryAfter(retryAfter) : undefined) ?? delay;
    const retryDelay = Math.min(parsedDelay, $fc075454b76b2577$var$MAX_RETRY_DELAY);
    await new Promise((resolve)=>setTimeout(resolve, retryDelay));
    return $fc075454b76b2577$export$cffaac380b94df26(url, options, retriesRemaining - 1, delay * 2);
};
module.exports["fetchWithRetry"] = $fc075454b76b2577$export$cffaac380b94df26;

});

parcelRegister("79ir6", function(module, exports) {
var $2ca041ce04439e9b$export$686dd843fdf311d4 = /*#__PURE__*/ function(SyncBlockError) {
    SyncBlockError["Errored"] = "errored";
    SyncBlockError["NotFound"] = "not_found";
    SyncBlockError["Forbidden"] = "forbidden";
    SyncBlockError["InvalidRequest"] = "invalid_request";
    SyncBlockError["RateLimited"] = "rate_limited";
    SyncBlockError["Conflict"] = "conflict";
    // attempt to create block that already exists
    SyncBlockError["ServerError"] = "server_error";
    SyncBlockError["InvalidContent"] = "invalid_content";
    // content is not a valid JSON
    SyncBlockError["Offline"] = "offline";
    SyncBlockError["Unpublished"] = "unpublished";
    // request was aborted, typically due to client timeout
    SyncBlockError["Aborted"] = "aborted";
    // block does not exist on this site (e.g. cross-site reference or hard deleted)
    SyncBlockError["EntityNotFound"] = "entity_not_found";
    return SyncBlockError;
}({});
const $2ca041ce04439e9b$export$7486a7adf8b0d591 = 'Data provider not set';
class $2ca041ce04439e9b$export$ca0858d4f5eeeac extends Error {
    constructor(message = $2ca041ce04439e9b$export$7486a7adf8b0d591){
        super(message);
        this.isProviderNotReadyError = true;
        this.name = 'ProviderNotReadyError';
        // Restore prototype chain so instanceof works after transpilation.
        Object.setPrototypeOf(this, $2ca041ce04439e9b$export$ca0858d4f5eeeac.prototype);
    }
}
const $2ca041ce04439e9b$export$7ba508051f94701f = (error)=>{
    if (error instanceof $2ca041ce04439e9b$export$ca0858d4f5eeeac) return true;
    if (typeof error === 'object' && error !== null && error.isProviderNotReadyError === true) return true;
    return error instanceof Error && error.message === $2ca041ce04439e9b$export$7486a7adf8b0d591;
};
module.exports["SyncBlockError"] = $2ca041ce04439e9b$export$686dd843fdf311d4;
module.exports["ProviderNotReadyError"] = $2ca041ce04439e9b$export$ca0858d4f5eeeac;
module.exports["isProviderNotReadyError"] = $2ca041ce04439e9b$export$7ba508051f94701f;

});

parcelRegister("916Gd", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $79ir6 = parcelRequire("79ir6");

const $5f570f8dd9ccb4e4$export$7fc2c997455452c8 = (error)=>{
    try {
        return JSON.stringify(error);
    } catch  {
        return undefined;
    }
};
const $5f570f8dd9ccb4e4$export$74ce7fda6da1109 = (error)=>{
    if (error instanceof Error) return {
        ...error.message && {
            originalMessage: error.message
        },
        ...error.name && {
            originalName: error.name
        }
    };
    return {};
};
const $5f570f8dd9ccb4e4$var$SYNC_BLOCK_ERROR_REASONS = new Set(Object.values((0, $79ir6.SyncBlockError)));
const $5f570f8dd9ccb4e4$export$3bf11deac13e0617 = (error)=>{
    if (error && $5f570f8dd9ccb4e4$var$SYNC_BLOCK_ERROR_REASONS.has(error)) return error;
    return 'unknown';
};
const $5f570f8dd9ccb4e4$export$78792f4ddc3998e8 = (gateEnabled, error, statusCode)=>{
    if (!gateEnabled) return undefined;
    return {
        reason: $5f570f8dd9ccb4e4$export$3bf11deac13e0617(error),
        ...statusCode !== undefined && {
            statusCode: statusCode
        }
    };
};
const $5f570f8dd9ccb4e4$export$9bd766f5cc31fe3b = new Set([
    'source_deleted',
    'source_unpublished',
    'source_unsynced',
    'source_not_found',
    'permission_denied',
    'unauthenticated',
    // Mirror the benign write-path enum equivalents so already-classified errors are
    // treated consistently.
    'not_found',
    'forbidden',
    'unpublished',
    // `offline` is an expected client connectivity state, not a read-path system failure:
    // the error component is rendered for the offline experience, so it should not inflate
    // the true error rate. It still emits `reason` (so its volume can be inspected) but is
    // excluded from true-error counts.
    'offline'
]);
/**
 * Ordered list of substring matchers mapping known free-text fetch/subscribe error
 * strings to a categorical {@link SyncBlockFetchErrorReason}. Each entry is a list of
 * lowercase needles; if ANY needle is found (case-insensitively) in the raw `error`
 * string, the entry's reason is used. Order matters: more specific entries must precede
 * more general ones.
 *
 * Plain `String.includes` substring matching is used deliberately instead of `RegExp`:
 * it sidesteps the `require-unicode-regexp` lint rule AND the declaration build's lower
 * compile target (which rejects the regex `u` flag with TS1501), while being faster and
 * easier to read. Doing this classification in code (rather than in dashboard SQL) keeps
 * the buckets versioned with the source strings that produce them (EDITOR-7862).
 */ const $5f570f8dd9ccb4e4$var$FETCH_REASON_MATCHERS = [
    // Benign: source-state transitions (deletionReason values + free text).
    [
        [
            'source-document-deleted'
        ],
        'source_deleted'
    ],
    [
        [
            'source-block-deleted'
        ],
        'source_deleted'
    ],
    [
        [
            'source-block-unpublished'
        ],
        'source_unpublished'
    ],
    [
        [
            'source-block-unsynced'
        ],
        'source_unsynced'
    ],
    [
        [
            'does not exist'
        ],
        'source_not_found'
    ],
    [
        [
            'unpublished'
        ],
        'source_unpublished'
    ],
    // Working-as-designed permission outcomes.
    [
        [
            'unauthenticated'
        ],
        'unauthenticated'
    ],
    [
        [
            'not permitted to read synced block'
        ],
        'permission_denied'
    ],
    [
        [
            'bulk permission check failed'
        ],
        'permission_denied'
    ],
    [
        [
            'permission denied'
        ],
        'permission_denied'
    ],
    // Genuine system failures.
    [
        [
            'reconnection failed after'
        ],
        'websocket_exhausted'
    ],
    // `reconnect to the subscription` (not a bare `reconnect`) avoids false positives on
    // unrelated DB/GraphQL "reconnect" messages while still matching the WS-drop string.
    [
        [
            'websocket',
            'reconnect to the subscription',
            'subscription terminated'
        ],
        'websocket_drop'
    ],
    [
        [
            '429',
            'rate limit',
            'rate-limit',
            'ratelimit'
        ],
        'rate_limited'
    ],
    // `econnrefused`/`econnreset` (not a bare `econn`, which would also match `reconnect`).
    [
        [
            'network',
            'failed to fetch',
            'econnrefused',
            'econnreset',
            'timed out',
            'timeout'
        ],
        'network'
    ],
    [
        [
            'data provider not set'
        ],
        'data_provider_not_ready'
    ]
];
const $5f570f8dd9ccb4e4$export$b7fb09a58aa76c55 = (error)=>{
    const enumReason = $5f570f8dd9ccb4e4$export$3bf11deac13e0617(error);
    if (enumReason !== 'unknown') return enumReason;
    if (error) {
        const haystack = error.toLowerCase();
        for (const [needles, reason] of $5f570f8dd9ccb4e4$var$FETCH_REASON_MATCHERS){
            if (needles.some((needle)=>haystack.includes(needle))) return reason;
        }
    }
    return 'unknown';
};
const $5f570f8dd9ccb4e4$export$4ae89cef01c11c46 = (gateEnabled, error, statusCode, deferred)=>{
    if (!gateEnabled) return undefined;
    const reason = $5f570f8dd9ccb4e4$export$b7fb09a58aa76c55(error);
    return {
        reason: reason,
        // A deferred (tab-hidden) exhaustion is benign regardless of reason bucket.
        benign: deferred === true || $5f570f8dd9ccb4e4$export$9bd766f5cc31fe3b.has(reason),
        ...statusCode !== undefined && {
            statusCode: statusCode
        },
        ...deferred === true && {
            deferred: true
        }
    };
};
function $5f570f8dd9ccb4e4$export$999ed1af1b20ac2d(actionSubjectId, error, resourceId, sourceProduct, attribution) {
    return {
        action: (0, $krYZG.ACTION).ERROR,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: actionSubjectId,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            error: error,
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...attribution?.reason && {
                reason: attribution.reason
            },
            ...attribution?.statusCode !== undefined && {
                statusCode: attribution.statusCode
            },
            // `benign` is only present on fetch/subscribe attribution (EDITOR-7862). It is a
            // boolean (never UGC); the `'benign' in attribution` check both guards the
            // write-path attribution (which has no `benign`) and narrows the union so
            // `attribution.benign` is accessible.
            ...attribution && 'benign' in attribution && {
                benign: attribution.benign
            },
            // `deferred` is only present on fetch/subscribe attribution, and only when a
            // tab-hidden exhaustion was deferred rather than surfaced. Boolean, never UGC.
            ...attribution && 'deferred' in attribution && attribution.deferred === true && {
                deferred: true
            }
        }
    };
}
const $5f570f8dd9ccb4e4$export$94dcd08406353dba = (error, resourceId, sourceProduct, attribution)=>// Branch on attribution presence so each call resolves to a concrete overload: with
    // attribution it hits the fetch overload (wider `reason`); without it (gate OFF) it
    // hits the no-attribution overload. Both produce a fetch event regardless.
    attribution ? $5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH, error, resourceId, sourceProduct, attribution) : $5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$c5131f589148b9d3 = (error, resourceId, sourceProduct)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_GET_SOURCE_INFO, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$adc2363832f8735d = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$154595d209a77913 = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).REFERENCE_SYNCED_BLOCK_UPDATE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$5d2f0c264cf49280 = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$cd0aaab38ff32ec2 = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_DELETE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$e40ed1768baf5d1e = (error, resourceId, sourceProduct)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE_CACHE, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$5665a31a69693485 = (resourceId, sourceProduct, context)=>({
        action: (0, $krYZG.ACTION).ERROR,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_SOURCE_INFO_ORPHANED,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...context?.hasPendingDeletion !== undefined && {
                hasPendingDeletion: context.hasPendingDeletion
            },
            ...context?.hasSubscribers !== undefined && {
                hasSubscribers: context.hasSubscribers
            }
        }
    });
const $5f570f8dd9ccb4e4$export$82f9608c8438ecb2 = (rescheduleCount, resourceId, sourceProduct)=>({
        action: (0, $krYZG.ACTION).ERROR,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CACHE_DELETION_FORCED,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            rescheduleCount: rescheduleCount,
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$ebf3ba305f3f0e1a = (error, resourceId, sourceProduct)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH_REFERENCES, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$b20c56c32ea6ad76 = (resourceId, blockInstanceId, sourceProduct)=>({
        action: (0, $krYZG.ACTION).FETCHED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            blockInstanceId: blockInstanceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$5b8e0915870366d0 = (resourceId, sourceProduct)=>{
    return {
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).BODIED_SYNCED_BLOCK,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            resourceId: resourceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    };
};
const $5f570f8dd9ccb4e4$export$23e42fbf8039414c = (resourceId, blockInstanceId, sourceProduct, enrichment)=>({
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...blockInstanceId && {
                blockInstanceId: blockInstanceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...enrichment?.inputMethod && {
                inputMethod: enrichment.inputMethod
            },
            ...enrichment?.createdEmpty !== undefined && {
                createdEmpty: enrichment.createdEmpty
            }
        }
    });
const $5f570f8dd9ccb4e4$export$c76f6dd50db89cda = (resourceId, blockInstanceId, sourceProduct)=>({
        action: (0, $krYZG.ACTION).ADDED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_ADD_CONTENT,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...blockInstanceId && {
                blockInstanceId: blockInstanceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$f2b4214fae56af83 = (resourceId, hasReference, sourceProduct)=>({
        action: (0, $krYZG.ACTION).UPDATED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...hasReference !== undefined && {
                hasReference: hasReference
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$2283f5d682476cde = (resourceId, sourceProduct, enrichment)=>({
        action: (0, $krYZG.ACTION).DELETED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_DELETE,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...enrichment?.blockInstanceId && {
                blockInstanceId: enrichment.blockInstanceId
            },
            ...enrichment?.deletionReason && {
                deletionReason: enrichment.deletionReason
            },
            ...enrichment?.mechanism && {
                mechanism: enrichment.mechanism
            }
        }
    });
module.exports["stringifyError"] = $5f570f8dd9ccb4e4$export$7fc2c997455452c8;
module.exports["getPiiSafeOriginalError"] = $5f570f8dd9ccb4e4$export$74ce7fda6da1109;
module.exports["buildErrorAttribution"] = $5f570f8dd9ccb4e4$export$78792f4ddc3998e8;
module.exports["buildFetchErrorAttribution"] = $5f570f8dd9ccb4e4$export$4ae89cef01c11c46;
module.exports["fetchErrorPayload"] = $5f570f8dd9ccb4e4$export$94dcd08406353dba;
module.exports["getSourceInfoErrorPayload"] = $5f570f8dd9ccb4e4$export$c5131f589148b9d3;
module.exports["updateErrorPayload"] = $5f570f8dd9ccb4e4$export$adc2363832f8735d;
module.exports["updateReferenceErrorPayload"] = $5f570f8dd9ccb4e4$export$154595d209a77913;
module.exports["createErrorPayload"] = $5f570f8dd9ccb4e4$export$5d2f0c264cf49280;
module.exports["deleteErrorPayload"] = $5f570f8dd9ccb4e4$export$cd0aaab38ff32ec2;
module.exports["updateCacheErrorPayload"] = $5f570f8dd9ccb4e4$export$e40ed1768baf5d1e;
module.exports["sourceInfoOrphanedPayload"] = $5f570f8dd9ccb4e4$export$5665a31a69693485;
module.exports["cacheDeletionForcedPayload"] = $5f570f8dd9ccb4e4$export$82f9608c8438ecb2;
module.exports["fetchReferencesErrorPayload"] = $5f570f8dd9ccb4e4$export$ebf3ba305f3f0e1a;
module.exports["fetchSuccessPayload"] = $5f570f8dd9ccb4e4$export$b20c56c32ea6ad76;
module.exports["createSuccessPayload"] = $5f570f8dd9ccb4e4$export$5b8e0915870366d0;
module.exports["createSuccessOperationalPayload"] = $5f570f8dd9ccb4e4$export$23e42fbf8039414c;
module.exports["addContentSuccessPayload"] = $5f570f8dd9ccb4e4$export$c76f6dd50db89cda;
module.exports["updateSuccessPayload"] = $5f570f8dd9ccb4e4$export$f2b4214fae56af83;
module.exports["deleteSuccessPayload"] = $5f570f8dd9ccb4e4$export$2283f5d682476cde;

});

parcelRegister("cuwGS", function(module, exports) {

var $kcJaM = parcelRequire("kcJaM");

const $dfc9aeca876e07dc$var$isSyncBlockProduct = (product)=>{
    return (0, $kcJaM.SYNC_BLOCK_PRODUCTS).includes(product);
};
const $dfc9aeca876e07dc$export$8aafdd7901afa57f = (resourceId)=>{
    if (!resourceId) return undefined;
    const [product, contentId, uuid, ...rest] = resourceId.split('/');
    // invalid if any part is missing or there are extra parts
    if (!product || !contentId || !uuid || rest.length > 0) return undefined;
    // invalid if product is not recognized
    if (!$dfc9aeca876e07dc$var$isSyncBlockProduct(product)) return undefined;
    return {
        product: product,
        contentId: contentId,
        uuid: uuid
    };
};
const $dfc9aeca876e07dc$export$cf5895b3b46faf63 = (product, contentId, uuid)=>{
    return `${product}/${contentId}/${uuid}`;
};
module.exports["parseResourceId"] = $dfc9aeca876e07dc$export$8aafdd7901afa57f;
module.exports["createResourceIdForReference"] = $dfc9aeca876e07dc$export$cf5895b3b46faf63;

});

parcelRegister("kcJaM", function(module, exports) {
const $d6e2f975e4365dc3$export$c05408ef703373ad = [
    'confluence-page',
    'jira-work-item'
];
module.exports["SYNC_BLOCK_PRODUCTS"] = $d6e2f975e4365dc3$export$c05408ef703373ad;

});

parcelRegister("d04Ge", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ const $acebaa6737646e6e$var$GET_CONTENT_ID_AND_PRODUCT_REGEX = /^(confluence-page|jira-work-item)\/([^/]+)/;
const $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal = (content, options)=>{
    let normalizedContent;
    content.forEach((contentNode, index)=>{
        if (!contentNode) {
            normalizedContent?.push(contentNode);
            return;
        }
        const hasAnnotationMark = contentNode.marks?.some((mark)=>mark.type === 'annotation');
        const shouldConvertPanelC1 = options.convertPanelC1ToPanel && contentNode.type === 'panel_c1';
        const childContent = contentNode.content ? $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal(contentNode.content, options) : undefined;
        const hasContentChanged = childContent !== undefined && childContent !== contentNode.content;
        if (!hasAnnotationMark && !shouldConvertPanelC1 && !hasContentChanged) {
            normalizedContent?.push(contentNode);
            return;
        }
        if (!normalizedContent) normalizedContent = content.slice(0, index);
        const normalizedNode = {
            ...contentNode
        };
        if (shouldConvertPanelC1) normalizedNode.type = 'panel';
        if (hasAnnotationMark) {
            const marks = contentNode.marks?.filter((mark)=>mark.type !== 'annotation');
            if (marks && marks.length > 0) normalizedNode.marks = marks;
            else delete normalizedNode.marks;
        }
        if (hasContentChanged && childContent) normalizedNode.content = childContent;
        normalizedContent.push(normalizedNode);
    });
    return normalizedContent ?? content;
};
const $acebaa6737646e6e$export$19bb1d88f473b9c5 = (content)=>{
    return $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal(content, {
        convertPanelC1ToPanel: false
    });
};
const $acebaa6737646e6e$export$b223a7607ed061dc = (content)=>{
    return $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal(content, {
        convertPanelC1ToPanel: true
    });
};
const $acebaa6737646e6e$export$aafb32b192c8228c = (node)=>{
    const content = node.content.toJSON();
    return {
        blockInstanceId: node.attrs.localId,
        content: content ? $acebaa6737646e6e$export$b223a7607ed061dc(content) : content,
        resourceId: node.attrs.resourceId
    };
};
const $acebaa6737646e6e$export$c5b34fb9069ebb1d = (localId, resourceId)=>{
    return {
        type: 'syncBlock',
        attrs: {
            localId: localId,
            resourceId: resourceId
        }
    };
};
const $acebaa6737646e6e$export$cd9b0caaea319019 = (node)=>{
    if (node.type !== 'syncBlock' || !node.attrs || !('localId' in node.attrs) || !('resourceId' in node.attrs) || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $acebaa6737646e6e$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $acebaa6737646e6e$export$648ff8dd259e0d9c = (node)=>{
    if (node.type.name !== 'syncBlock' || !node.attrs?.localId || !node.attrs?.resourceId || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $acebaa6737646e6e$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $acebaa6737646e6e$export$18b85168a73dad03 = (nodes)=>{
    return nodes.map((node)=>$acebaa6737646e6e$export$648ff8dd259e0d9c(node)).filter((node)=>node !== undefined);
};
const $acebaa6737646e6e$export$2cf4a74c3e18f31a = (resourceId)=>{
    const match = resourceId.match($acebaa6737646e6e$var$GET_CONTENT_ID_AND_PRODUCT_REGEX);
    if (match?.[2]) return {
        sourceProduct: match[1],
        sourceContentId: match[2]
    };
    throw new Error(`Invalid resourceId: ${resourceId}`);
};
const $acebaa6737646e6e$export$31cbe0bed21e05b1 = (resourceId)=>{
    if (!resourceId) return undefined;
    try {
        return $acebaa6737646e6e$export$2cf4a74c3e18f31a(resourceId).sourceProduct;
    } catch  {
        return undefined;
    }
};
const $acebaa6737646e6e$export$4c6687d128f55da5 = (contentUpdatedAt)=>{
    if (typeof contentUpdatedAt === 'number') try {
        return new Date(contentUpdatedAt).toISOString();
    } catch  {
        return undefined;
    }
    return undefined;
};
module.exports["normalizeSyncBlockJSONContent"] = $acebaa6737646e6e$export$b223a7607ed061dc;
module.exports["convertSyncBlockPMNodeToSyncBlockData"] = $acebaa6737646e6e$export$aafb32b192c8228c;
module.exports["createSyncBlockNode"] = $acebaa6737646e6e$export$c5b34fb9069ebb1d;
module.exports["convertSyncBlockJSONNodeToSyncBlockNode"] = $acebaa6737646e6e$export$cd9b0caaea319019;
module.exports["convertPMNodesToSyncBlockNodes"] = $acebaa6737646e6e$export$18b85168a73dad03;
module.exports["getContentIdAndProductFromResourceId"] = $acebaa6737646e6e$export$2cf4a74c3e18f31a;
module.exports["getSourceProductFromResourceIdSafe"] = $acebaa6737646e6e$export$31cbe0bed21e05b1;
module.exports["convertContentUpdatedAt"] = $acebaa6737646e6e$export$4c6687d128f55da5;

});

parcelRegister("4KByH", function(module, exports) {

let $375897ae4a238d6d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $375897ae4a238d6d$var$load("iUXaE"),
    $375897ae4a238d6d$var$load("lTkx9"),
    $375897ae4a238d6d$var$load("cp9QV")
]).then(()=>parcelRequire('kRm6Y'));

});

parcelRegister("d5Ozc", function(module, exports) {
// Shorthand alias for the global cache map key because it's (intentionally) a long name
const $dacf5aee5e6a9a5a$var$CACHE_MAP_KEY = '__conditionalHooksFactory_conditionCacheMap_dont_modify_this_manually_unless_you_want_react_to_blow_up';
// Initialize the global cache map once
globalThis[$dacf5aee5e6a9a5a$var$CACHE_MAP_KEY] = globalThis[$dacf5aee5e6a9a5a$var$CACHE_MAP_KEY] || new WeakMap();
function $dacf5aee5e6a9a5a$export$e328888e5cffce88() {
    globalThis[$dacf5aee5e6a9a5a$var$CACHE_MAP_KEY] = new WeakMap();
}
function $dacf5aee5e6a9a5a$export$691e93bad45e6f07(condition, newHook, oldHook) {
    const hookFn = (...args)=>{
        // call each time so we can track exposures
        const conditionResult = condition();
        const cache = globalThis[$dacf5aee5e6a9a5a$var$CACHE_MAP_KEY];
        if (!cache.has(hookFn)) cache.set(hookFn, conditionResult);
        if (cache.get(hookFn)) return newHook(...args);
        else return oldHook(...args);
    };
    return hookFn;
}
module.exports["conditionalHooksFactory"] = $dacf5aee5e6a9a5a$export$691e93bad45e6f07;

});

parcelRegister("hYoU4", function(module, exports) {

var $nStJY = parcelRequire("nStJY");


var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");

const $cf3a2c4e252823d7$export$79b973328ab6a08a = {
    collabEditProvider: null,
    collabEditInitialized: false,
    hasInitialDraft: false,
    isDraftSyncPending: false,
    collabEditConnected: false
};
const $cf3a2c4e252823d7$export$e324594224ef24da = {
    setCollabEditProvider: (collabEditProvider)=>({ setState: setState })=>{
            setState({
                collabEditProvider: collabEditProvider
            });
        },
    setCollabEditInitialized: (collabEditInitialized)=>({ setState: setState })=>{
            setState({
                collabEditInitialized: collabEditInitialized
            });
        },
    setHasInitialDraft: (hasInitialDraft)=>({ setState: setState })=>{
            setState({
                hasInitialDraft: hasInitialDraft
            });
        },
    setIsDraftSyncPending: // PGXT-3849 Remove this if we update lodash to 5.0+ and use debounce.pending() instead
    (isDraftSyncPending)=>({ setState: setState })=>{
            setState({
                isDraftSyncPending: isDraftSyncPending
            });
        },
    setCollabEditConnected: (collabEditConnected)=>({ setState: setState })=>{
            setState({
                collabEditConnected: collabEditConnected
            });
        },
    resetNativeCollabState: ()=>({ setState: setState })=>{
            setState({
                collabEditProvider: null,
                collabEditInitialized: false,
                hasInitialDraft: false,
                isDraftSyncPending: false,
                collabEditConnected: false
            });
        }
};
const $cf3a2c4e252823d7$export$a3d4598f4626641c = (0, $8s9DV.createStore)({
    initialState: {
        ...$cf3a2c4e252823d7$export$79b973328ab6a08a
    },
    actions: $cf3a2c4e252823d7$export$e324594224ef24da,
    name: 'nativeCollabState'
});
const $cf3a2c4e252823d7$export$8af37259b4604092 = (0, $j8on0.createContainer)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    onInit: ()=>async ({ dispatch: dispatch }, { initialCollabState: initialCollabState })=>{
            initialCollabState?.collabEditProvider && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditProvider(initialCollabState?.collabEditProvider));
            initialCollabState?.collabEditInitialized && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditInitialized(initialCollabState?.collabEditInitialized));
            initialCollabState?.hasInitialDraft && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setHasInitialDraft(initialCollabState?.hasInitialDraft));
            initialCollabState?.isDraftSyncPending && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setIsDraftSyncPending(initialCollabState?.isDraftSyncPending));
            initialCollabState?.collabEditConnected && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditConnected(initialCollabState?.collabEditConnected));
        }
});
const $cf3a2c4e252823d7$export$b01c6ac62a4aed2c = (0, $kBr4q.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(state, 'collabEditProvider', 'collabEditInitialized', 'hasInitialDraft')
});
const $cf3a2c4e252823d7$export$3f0287ea828df991 = (0, $kBr4q.createActionsHook)($cf3a2c4e252823d7$export$a3d4598f4626641c);
const $cf3a2c4e252823d7$export$31e00ebc52451b8e = (0, $kBr4q.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(state, 'isDraftSyncPending')
});
const $cf3a2c4e252823d7$export$4bfbf4dd405bc207 = (0, $kBr4q.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(state, 'collabEditConnected')
});
module.exports["useNativeCollabState"] = $cf3a2c4e252823d7$export$b01c6ac62a4aed2c;
module.exports["useNativeCollabActions"] = $cf3a2c4e252823d7$export$3f0287ea828df991;
module.exports["useNativeCollabDraftSync"] = $cf3a2c4e252823d7$export$31e00ebc52451b8e;
module.exports["useNativeCollabConnected"] = $cf3a2c4e252823d7$export$4bfbf4dd405bc207;

});

parcelRegister("nStJY", function(module, exports) {

var $gO7n9 = parcelRequire("gO7n9");


var $jPzTX = parcelRequire("jPzTX");

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $047c686ddfb588a6$var$pick = $jPzTX(function(object, paths) {
    return object == null ? {} : $gO7n9(object, paths);
});
module.exports = $047c686ddfb588a6$var$pick;

});

parcelRegister("gO7n9", function(module, exports) {

var $3Bix5 = parcelRequire("3Bix5");


var $h7loT = parcelRequire("h7loT");

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $c3c708e20cb40f59$var$basePick(object, paths) {
    return $3Bix5(object, paths, function(value, path) {
        return $h7loT(object, path);
    });
}
module.exports = $c3c708e20cb40f59$var$basePick;

});

parcelRegister("lmNXu", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $vLw8x = parcelRequire("vLw8x");

const $cdf0b5cb977c302e$export$f996105bf70a5c25 = (0, $dOBRD.default)((routesContext, handleLinks)=>routesContext && typeof routesContext.push === 'function' ? {
        smartCard: {
            onClick: (e, url)=>(0, $vLw8x.smartCardEventHandler)(routesContext, e, url)
        },
        ...handleLinks ? {
            link: {
                onClick: (e, url)=>(0, $vLw8x.smartCardEventHandler)(routesContext, e, url)
            }
        } : {}
    } : undefined);
module.exports["createSmartCardEventHandler"] = $cdf0b5cb977c302e$export$f996105bf70a5c25;

});

parcelRegister("vLw8x", function(module, exports) {

var $6S5EB = parcelRequire("6S5EB");


var $dHSeC = parcelRequire("dHSeC");


var $icKZN = parcelRequire("icKZN");


var $jibmA = parcelRequire("jibmA");

const $fbd8de70e694fd11$export$71eec072841e6b90 = (routesContext, e, url)=>{
    const details = (0, $dHSeC.getSpaTransitionDetails)(e, routesContext);
    if ((0, $jibmA.isExternalLink)(url)) {
        e.preventDefault();
        window.open(url, '_blank', 'noopener, noreferrer');
    } else if (details?.href && details.href === url) {
        e.preventDefault();
        routesContext.push(details.href, (0, $6S5EB.isExternalShareRequest)());
    } else $fbd8de70e694fd11$var$handleClick(e, url);
};
/**
 * Copied from @atlaskit/smart-card and
 * packages/media/smart-card/src/view/CardWithUrl/component.tsx to handle click
 * on a smart card with a URL because @atlaskit/smart-card expects
 * SmartCardEventClickHandler to handle the event fully, doesn't allow the
 * SmartCardEventClickHandler to fall back to the default @atlaskit/smart-card
 * click handler.
 */ const $fbd8de70e694fd11$var$handleClick = (e, url)=>{
    (0, $icKZN.isClickEventToOpenNewTab)(e, {
        shouldCheckIframe: true
    }) ? window.open(url, '_blank') : window.open(url, '_self');
};
module.exports["smartCardEventHandler"] = $fbd8de70e694fd11$export$71eec072841e6b90;

});

parcelRegister("6S5EB", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $6mKj3 = parcelRequire("6mKj3");

const $d5074feaeb7f756a$export$50d92d69a5c05c70 = ()=>{
    if ((0, $6mKj3.expVal)('shareable_links_m0', 'isEnabled', false)) return !!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname) || !!(0, $1NBp8.ACCESS_LINK).match(window.location.pathname);
    return !!(0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname);
};
module.exports["isExternalShareRequest"] = $d5074feaeb7f756a$export$50d92d69a5c05c70;

});

parcelRegister("icKZN", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $76c86d96bcffdba9$export$4128d9964cdd56b5 = (event, options)=>{
    return event?.isDefaultPrevented() && (Boolean(options?.shouldCheckIframe) && $76c86d96bcffdba9$var$isIframe() || $76c86d96bcffdba9$var$isCtrlOrCommandClick(event) || $76c86d96bcffdba9$var$isMiddleClick(event));
};
const $76c86d96bcffdba9$var$isIframe = ()=>window.parent !== parent;
const $76c86d96bcffdba9$var$isMiddleClick = (event)=>{
    const nativeEvent = event?.nativeEvent;
    return nativeEvent.button === 1;
};
const $76c86d96bcffdba9$var$isCtrlOrCommandClick = (event)=>{
    const nativeEvent = event?.nativeEvent;
    return (0, $9wGTI.fg)('platform-smart-card-shift-key') ? nativeEvent.ctrlKey || nativeEvent.metaKey || nativeEvent.shiftKey : nativeEvent.ctrlKey || nativeEvent.metaKey;
};
module.exports["isClickEventToOpenNewTab"] = $76c86d96bcffdba9$export$4128d9964cdd56b5;

});

parcelRegister("jibmA", function(module, exports) {

var $60cDW = parcelRequire("60cDW");

const $005667118ff06aa5$export$b98882f166bb7ce2 = (url)=>{
    const windowHostname = typeof window !== 'undefined' && window.location ? window.location.hostname : (0, $60cDW.getSSRRenderInputs)().host;
    // Only including support for certain Jira paths to minimise hardcoding
    const linkClickExceptionPaths = [
        '/browse',
        '/jira'
    ];
    let urlObject;
    try {
        // Resolve against the current host so relative URLs (e.g. /browse/ABC-1) parse correctly.
        urlObject = url && new URL(url, windowHostname ? `https://${windowHostname}` : undefined);
    } catch  {}
    const { hostname: hostname, pathname: pathname } = urlObject || {};
    return hostname && windowHostname && hostname !== windowHostname || linkClickExceptionPaths.some((exceptionPath)=>pathname?.startsWith(exceptionPath));
};
module.exports["isExternalLink"] = $005667118ff06aa5$export$b98882f166bb7ce2;

});

parcelRegister("bcv7k", function(module, exports) {
/**
 * We shouldn't really need this file, as the editor shouldn't require us to pass in
 * a task and decision provider. But for now it does. So this whole thing is a stub.
 */ 
var $dOBRD = parcelRequire("dOBRD");

class $eaaab3ad8fc788e2$var$Provider {
    notifyRecentUpdates(_updateContext) {}
    subscribe(_objectKey, _handler) {}
    toggleTask(objectKey, state) {
        if (this._toggleTaskCallback) this._toggleTaskCallback(objectKey, state);
        return Promise.resolve(state);
    }
    unsubscribe(_objectKey, _handler) {}
    unsubscribeRecentUpdates(_id) {}
    constructor(toggleTask){
        this._toggleTaskCallback = void 0;
        this._toggleTaskCallback = toggleTask;
    }
}
const $eaaab3ad8fc788e2$export$5405ecb032439dfe = (0, $dOBRD.default)(async (toggleTaskCallback)=>{
    return new $eaaab3ad8fc788e2$var$Provider(toggleTaskCallback);
});
module.exports["getTaskDecisionProvider"] = $eaaab3ad8fc788e2$export$5405ecb032439dfe;

});

parcelRegister("hfIjM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bQm3c = parcelRequire("bQm3c");


var $8uM2K = parcelRequire("8uM2K");


var $jubk3 = parcelRequire("jubk3");

var $fN9wG = parcelRequire("fN9wG");


var $hSHWm = parcelRequire("hSHWm");


var $5UhfH = parcelRequire("5UhfH");

function $cb04a18914327c7b$export$601d5e9e674a7c4a(spaceId, withAnalyticsEventProps, focusedMentionId, options) {
    const { cloudId: cloudId, userId: userId, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled } = (0, $bQm3c.useSessionData)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { openCoreInvites: openCoreInvites, userRole: userRole } = (0, $cozmU.useContext)((0, $hSHWm.CoreInvitesContext));
    const { isEligibleXProductUserInvite: isEligibleXProductUserInvite, onXProductUserInviteClick: onXProductUserInviteClick } = (0, $cozmU.useContext)((0, $fN9wG.XProductUserInviteContext)); // check if user is eligible for XProductUserInvite
    const spaceIdPromise = (0, $5UhfH.useSpaceIdPromise)(spaceId);
    return (0, $cozmU.useMemo)(()=>{
        return spaceIdPromise.then((resolvedSpaceId)=>{
            return (0, $jubk3.createFabricMentionResource)(cloudId, resolvedSpaceId, userId, withAnalyticsEventProps, openCoreInvites, userRole, focusedMentionId, isEligibleXProductUserInvite, onXProductUserInviteClick, // Include agent mentions — gated on the AI-disable check (isRovoButtonEnabled,
            // which covers isAdminHubAIEnabled) and AI early access (Labs), since agent
            // mentions are a beta AI feature.
            Boolean(options?.includeAgents && isRovoButtonEnabled && isAIEarlyAccessEnabled));
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        cloudId,
        userId,
        withAnalyticsEventProps,
        openCoreInvites,
        userRole,
        isEligibleXProductUserInvite,
        onXProductUserInviteClick,
        options?.includeAgents,
        isRovoButtonEnabled,
        isAIEarlyAccessEnabled
    ]);
}
module.exports["useMentionProvider"] = $cb04a18914327c7b$export$601d5e9e674a7c4a;

});

parcelRegister("8uM2K", function(module, exports) {

var $3ricL = parcelRequire("3ricL");


var $bQm3c = parcelRequire("bQm3c");

const $214157f3efbb250b$export$dcc461521a57aee7 = ()=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    // environment-aware enablement via feature encoding
    const isAIFeatureEnabled = (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-ai');
    return isAIFeatureEnabled && isAdminHubAIEnabled && isRovoLLMEnabled;
};
module.exports["useAIRovoButtonEnablement"] = $214157f3efbb250b$export$dcc461521a57aee7;

});

parcelRegister("fN9wG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4aRua = parcelRequire("4aRua");


var $9DHhW = parcelRequire("9DHhW");


var $7aRa9 = parcelRequire("7aRa9");


var $9wGTI = parcelRequire("9wGTI");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $17wUi = parcelRequire("17wUi");


var $b5SMr = parcelRequire("b5SMr");


var $elPdM = parcelRequire("elPdM");


var $c0rhi = parcelRequire("c0rhi");

const $bd929afc952baa40$var$INVITE_CAPABILITIES_URL = '/gateway/api/v3/invitations/capabilities';
const $bd929afc952baa40$var$INVITE_CAPABILITIES_DIRECT_INVITE_MODE_KEY = 'confluence_invite_capabilities_direct_invite_mode';
const $bd929afc952baa40$var$i18n = (0, $kSwu1.defineMessages)({
    inviteSuccessTitle: {
        id: "fabric-media-support.mentions-provider.x-product-user-invite.success.title",
        defaultMessage: "Successfully added"
    },
    inviteSuccessDescription: {
        id: "fabric-media-support.mentions-provider.x-product-user-invite.success.description",
        defaultMessage: "We sent an email to <b>{name}</b> confirming you added them to Confluence."
    }
});
const $bd929afc952baa40$export$3bdfaf8c811be72d = /*#__PURE__*/ (0, $cozmU.createContext)({});
const $bd929afc952baa40$var$hasDirectInviteCapabilities = async (cloudId, createAnalyticsEvent)=>{
    try {
        const canUserAccessJira = await $bd929afc952baa40$var$hasJiraSoftwareAccess(cloudId) ?? false;
        let directInviteMode;
        let invitePendingApprovalMode;
        if (canUserAccessJira) {
            //Call invite capabilities endpoint only if directInviteMode value is not available from local storage
            directInviteMode = (0, $17wUi.confluenceLocalStorageInstance).getItem($bd929afc952baa40$var$INVITE_CAPABILITIES_DIRECT_INVITE_MODE_KEY);
            if (!directInviteMode) {
                const response = await (0, $f7B1p.cfetch)(`${$bd929afc952baa40$var$INVITE_CAPABILITIES_URL}?resource=ari:cloud:platform::site/${cloudId}`, {
                    method: 'GET',
                    headers: {
                        ACCEPT: 'application/json'
                    }
                });
                if (!response.ok) throw new Error(`Network response error.  HTTP status: ${response.status}`);
                const data = await response.json();
                for (const item of data)if (item?.resourceARI?.includes('confluence')) {
                    directInviteMode = item?.directInvite?.mode;
                    invitePendingApprovalMode = item?.invitePendingApproval?.mode;
                    break;
                }
                createAnalyticsEvent && createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        source: 'editor',
                        action: 'fetched',
                        actionSubject: 'inviteCapabilitiesForXProductUserInvite',
                        attributes: {
                            directInviteMode: directInviteMode,
                            invitePendingApprovalMode: invitePendingApprovalMode
                        }
                    }
                }).fire();
                if (!!directInviteMode) (0, $17wUi.confluenceLocalStorageInstance).setItem($bd929afc952baa40$var$INVITE_CAPABILITIES_DIRECT_INVITE_MODE_KEY, directInviteMode, 86400);
            }
        }
        return directInviteMode === 'ANYONE';
    } catch (error) {
        const errorMessage = error instanceof Error ? error.message : String(error);
        createAnalyticsEvent && createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: 'editor',
                action: 'errored',
                actionSubject: 'inviteCapabilitiesForXProductUserInvite',
                attributes: {
                    errorMessage: errorMessage
                }
            }
        }).fire();
        return false;
    }
};
const $bd929afc952baa40$var$hasJiraSoftwareAccess = async (cloudId)=>{
    return (0, $c0rhi.queryInterop)({
        query: (0, $b5SMr.default),
        variables: {
            resourceId: `ari:cloud:jira::site/${cloudId}`,
            permissionId: 'write'
        },
        __callerPackage__: "fabric-media-support"
    }).then(({ data: data })=>{
        const hasJira = data?.confluence_tenantContext?.licensedProducts.some((product)=>product?.productKey?.toLowerCase().includes('jira-software') && product?.licenseStatus === (0, $elPdM.LicenseStatus).ACTIVE);
        return !!hasJira && data?.permitted;
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).FLYWHEEL_ENGAGEMENT
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return false;
    });
};
const $bd929afc952baa40$export$266d732058715003 = ({ children: children, flags: flags })=>{
    const { accessStatus: accessStatus, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const promiseRef = (0, $cozmU.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isEligibleXProductUserInvite = (0, $cozmU.useCallback)(()=>{
        //check the eligibility criteria only once per SPA
        if (promiseRef.current) return promiseRef.current;
        promiseRef.current = (async ()=>{
            try {
                if (!(0, $9wGTI.fg)('cc_virality_x_product_user_invite_kill_switch') || !(accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS)) return false;
                return await $bd929afc952baa40$var$hasDirectInviteCapabilities(cloudId, createAnalyticsEvent);
            } catch  {
                return false;
            }
        })();
        return promiseRef.current;
    }, [
        accessStatus,
        cloudId,
        createAnalyticsEvent
    ]);
    const showSuccessFlag = (0, $cozmU.useCallback)((name, isSuccess)=>{
        if (isSuccess) flags.showFlag({
            id: `x-product-user-invite-success`,
            title: formatMessage($bd929afc952baa40$var$i18n.inviteSuccessTitle),
            description: formatMessage($bd929afc952baa40$var$i18n.inviteSuccessDescription, {
                name: name,
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
                        weight: "bold"
                    }, chunks)
            }),
            type: 'success-circle'
        });
    }, [
        flags,
        formatMessage
    ]);
    const value = (0, $cozmU.useMemo)(()=>({
            isEligibleXProductUserInvite: isEligibleXProductUserInvite,
            onXProductUserInviteClick: (name, isSuccess)=>{
                showSuccessFlag(name, isSuccess);
            }
        }), [
        isEligibleXProductUserInvite,
        showSuccessFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bd929afc952baa40$export$3bdfaf8c811be72d.Provider, {
        value: value
    }, children);
};
const $bd929afc952baa40$export$363c701b8b10381c = (0, $7aRa9.withFlags)($bd929afc952baa40$export$266d732058715003);
module.exports["XProductUserInviteContext"] = $bd929afc952baa40$export$3bdfaf8c811be72d;
module.exports["XProductUserInviteProvider"] = $bd929afc952baa40$export$363c701b8b10381c;

});

parcelRegister("b5SMr", function(module, exports) {
/**
 * @generated SignedSource<<6d920e0b0bb587b6b159e40c1bffaa50>>
 * @relayHash 0799e7283121eb71f27f154269c35d2f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f082ceabb2a22dad1af827fe35d8b92c3abbe18d26f157a4497a988561a8d8ff
const $0dd0647641a6eb7a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "permissionId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "resourceId"
    }, v2 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "permissionId",
                    "variableName": "permissionId"
                },
                {
                    "kind": "Variable",
                    "name": "resourceId",
                    "variableName": "resourceId"
                }
            ],
            "kind": "ScalarField",
            "name": "permitted"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "GetUserAccessQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "GetUserAccessQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "0799e7283121eb71f27f154269c35d2f",
            "id": "f082ceabb2a22dad1af827fe35d8b92c3abbe18d26f157a4497a988561a8d8ff",
            "metadata": {},
            "name": "GetUserAccessQuery",
            "operationKind": "query",
            "text": "query GetUserAccessQuery($resourceId:String!,$permissionId:String!){confluence_tenantContext{licensedProducts{licenseStatus,productKey}},permitted(resourceId:$resourceId,permissionId:$permissionId)}"
        }
    };
}();
$0dd0647641a6eb7a$var$node.hash = "32bb5d7171ecf6d04700c4e127e76256";
var $0dd0647641a6eb7a$export$2e2bcd8739ae039 = $0dd0647641a6eb7a$var$node;
module.exports["default"] = $0dd0647641a6eb7a$export$2e2bcd8739ae039;

});

parcelRegister("elPdM", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $ad8e722f7df5268a$export$902181cb056f3d0b = /*#__PURE__*/ function(LicenseStatus) {
    LicenseStatus["ACTIVE"] = "ACTIVE";
    LicenseStatus["SUSPENDED"] = "SUSPENDED";
    LicenseStatus["UNLICENSED"] = "UNLICENSED";
    return LicenseStatus;
}({});
module.exports["LicenseStatus"] = $ad8e722f7df5268a$export$902181cb056f3d0b;

});

parcelRegister("hSHWm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $d1e7679282bf3961$export$8b4809eaf655f286 = /*#__PURE__*/ (0, $cozmU.createContext)({});
module.exports["CoreInvitesContext"] = $d1e7679282bf3961$export$8b4809eaf655f286;

});

parcelRegister("5UhfH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $6f81802f32398f24$export$49fef1783eef7e2a(spaceId) {
    const resolveFnRef = (0, $cozmU.useRef)(null);
    const spaceIdPromiseRef = (0, $cozmU.useRef)(null);
    if (!spaceIdPromiseRef.current) spaceIdPromiseRef.current = new Promise((resolve)=>{
        resolveFnRef.current = resolve;
    });
    (0, $cozmU.useEffect)(()=>{
        if (spaceId || spaceId === '') resolveFnRef.current(spaceId);
    }, [
        spaceId
    ]);
    return spaceIdPromiseRef.current;
}
module.exports["useSpaceIdPromise"] = $6f81802f32398f24$export$49fef1783eef7e2a;

});

parcelRegister("fjhaB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bQm3c = parcelRequire("bQm3c");


var $7Ryt2 = parcelRequire("7Ryt2");

function $cb89921c47be68ab$export$78c2bbd50206cc7f() {
    const [activityProvider, setActivityProvider] = (0, $cozmU.useState)(undefined);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    (0, $cozmU.useEffect)(()=>{
        setActivityProvider((0, $7Ryt2.getActivityProvider)(cloudId));
    }, [
        cloudId
    ]);
    return activityProvider;
}
module.exports["useActivityProvider"] = $cb89921c47be68ab$export$78c2bbd50206cc7f;

});

parcelRegister("7Ryt2", function(module, exports) {

var $9bEtA = parcelRequire("9bEtA");

const $7a079a70f1242941$var$ACTIVITY_URL = '/gateway/api/graphql';
async function $7a079a70f1242941$export$a2b55b950e46bdd9(cloudId) {
    return Promise.resolve(new (0, $9bEtA.default)($7a079a70f1242941$var$ACTIVITY_URL, cloudId));
}
module.exports["getActivityProvider"] = $7a079a70f1242941$export$a2b55b950e46bdd9;

});

parcelRegister("9bEtA", function(module, exports) {

var $DdJXy = parcelRequire("DdJXy");


var $aLADI = parcelRequire("aLADI");

/**
 * Currently the underlying FE service can only retrieve the first page of results, which is limited at 100 results.
 * See ACT-3418 for upcoming fix.
 */ const $284d31c82e7ca85e$var$DEFAULT_ACTIVITY_COUNT = 100;
class $284d31c82e7ca85e$export$2e2bcd8739ae039 {
    async getRecentItems(limit = $284d31c82e7ca85e$var$DEFAULT_ACTIVITY_COUNT) {
        if (!this.recentPromise) this.recentPromise = this.client.fetchActivities([
            50
        ], {
            rootContainerIds: [
                this.cloudId
            ],
            limit: limit
        }, [
            'viewed'
        ]);
        try {
            const response = await this.recentPromise;
            return response.viewed.map((node)=>({
                    objectId: node.object.id,
                    name: node.object.name || '',
                    container: this.getContainerName(node.containers),
                    url: node.object.url,
                    iconUrl: node.object.icon?.type === 'EMOJI' && node.object.icon.fallback ? node.object.icon.fallback : node.object.icon?.value || '',
                    type: node.object.type,
                    viewedTimestamp: node.timestamp
                })).filter((item)=>Boolean(item.name));
        } catch (err) {
            throw new (0, $aLADI.ActivityError)(err.message, err.code);
        }
    }
    async searchRecent(query) {
        const items = await this.getRecentItems();
        return this.filterItems(items, query);
    }
    /**
   * It should return the closet container's name
   */ getContainerName(containers) {
        for(let i = containers.length - 1; i >= 0; --i){
            const containerName = containers[i].name;
            if (containerName) return containerName;
        }
        return '';
    }
    filterItems(items, searchTerm) {
        if (!searchTerm) return [];
        return items.filter((item)=>{
            return item.name?.toLowerCase()?.includes(searchTerm.toLowerCase());
        });
    }
    /**
   *
   * @param url
   * @param cloudId - this will be transformed into an ARI
   * @param options - @deprecated this is no longer used
   */ constructor(url, cloudId, options = {}){
        this.cloudId = void 0;
        this.client = void 0;
        this.recentPromise = void 0;
        this.cloudId = `ari:cloud:platform::site/${cloudId}`;
        this.client = (0, $DdJXy.createActivityClient)('v3', 'editor', undefined, url);
    }
}
module.exports["default"] = $284d31c82e7ca85e$export$2e2bcd8739ae039;

});

parcelRegister("DdJXy", function(module, exports) {

var $eW8fM = parcelRequire("eW8fM");


var $6vFZD = parcelRequire("6vFZD");

let $6a112a84062a731f$var$previousClientVersion;
const $6a112a84062a731f$export$224367b01f71f2aa = (version, product, logger, baseUrl, configFetch, collabContextId)=>{
    if ($6a112a84062a731f$var$previousClientVersion && $6a112a84062a731f$var$previousClientVersion !== version && logger?.captureWarning) logger.captureWarning(`ActivityClient version has changed, is this intentional?`);
    $6a112a84062a731f$var$previousClientVersion = version || 'v3';
    if (version === 'v2') return new (0, $eW8fM.ActivityClientV2)(product, baseUrl, collabContextId);
    return new (0, $6vFZD.ActivityClientV3)(product, baseUrl, logger, configFetch, collabContextId);
};
module.exports["createActivityClient"] = $6a112a84062a731f$export$224367b01f71f2aa;

});

parcelRegister("eW8fM", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $71leB = parcelRequire("71leB");


var $7azIf = parcelRequire("7azIf");


var $1Zjzt = parcelRequire("1Zjzt");

class $5109c156c1c5c718$export$330ab0047f2fb745 extends (0, $7azIf.ActivityClient) {
    constructor(_product, baseUrl, collabContextId){
        super('v2', _product, undefined, baseUrl, collabContextId);
        this.fetchActivities = async (retryMS, filters, activityQueries)=>{
            const filtersWithCollabContext = this.collabContextId && (0, $ixfCV.fg)('platform_recent_work_collab_context_id') ? {
                ...filters,
                collabContextId: this.collabContextId
            } : filters;
            return (0, $71leB.fetchActivitiesWithExperience)((experience)=>(0, $1Zjzt.fetchActivitiesV2)({
                    experience: experience,
                    product: this.product,
                    retryMS: retryMS,
                    filters: filtersWithCollabContext,
                    activityQueries: activityQueries,
                    baseUrl: this.baseUrl
                }), 'v2');
        };
        this.setProduct = (product)=>{
            this.product = product;
        };
    }
}
module.exports["ActivityClientV2"] = $5109c156c1c5c718$export$330ab0047f2fb745;

});

parcelRegister("71leB", function(module, exports) {

var $3pZ7I = parcelRequire("3pZ7I");


var $bXw81 = parcelRequire("bXw81");


var $hOkJN = parcelRequire("hOkJN");

async function $1396df9d82dfd491$export$4a906f16800734f3(fetchActivities, clientVersion) {
    const experience = clientVersion === 'v2' ? (0, $hOkJN.recentWorkClientExperienceV2)() : (0, $hOkJN.recentWorkClientExperienceV3)();
    try {
        experience.start();
        experience.addMetadata({
            clientVersion: clientVersion,
            packageName: $bXw81.packageName,
            packageVersion: $bXw81.packageVersion
        });
        const data = await fetchActivities(experience);
        experience.success();
        return data;
    } catch (e) {
        experience.failure({
            metadata: {
                error: $1396df9d82dfd491$export$f33622abb5224195(e)
            }
        });
        throw e;
    }
}
const $1396df9d82dfd491$export$f33622abb5224195 = (e)=>{
    if (e instanceof (0, $3pZ7I.default)) return {
        ...e,
        xRequestId: e.xRequestId ?? undefined,
        cause: undefined
    };
    return e instanceof Error ? {
        ...e,
        cause: undefined
    } : 'unknown';
};
module.exports["fetchActivitiesWithExperience"] = $1396df9d82dfd491$export$4a906f16800734f3;

});

parcelRegister("3pZ7I", function(module, exports) {
class $8998fedd348b763f$export$2e2bcd8739ae039 extends Error {
    constructor({ message: message, statusCode: statusCode, path: path, method: method, xRequestId: xRequestId, headers: headers }){
        super();
        this.message = void 0;
        this.method = void 0;
        this.path = void 0;
        this.statusCode = void 0;
        this.xRequestId = void 0;
        this.headers = void 0;
        this.name = 'HttpError';
        this.message = message;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
        this.method = method;
        this.statusCode = statusCode;
        this.xRequestId = xRequestId;
        // @ts-ignore - Property 'entries' does not exist on type 'Headers'.
        // This was added when enrolling `@atlassian/recent-work-client` into JFE local consumption
        this.headers = Array.from(headers.entries()).map((value, key)=>`${key}:${value}`).sort().join(',');
    }
}
const $8998fedd348b763f$export$97b788730ba59845 = (e)=>e instanceof $8998fedd348b763f$export$2e2bcd8739ae039;
module.exports["default"] = $8998fedd348b763f$export$2e2bcd8739ae039;

});

parcelRegister("bXw81", function(module, exports) {
const $284d8e69d74c83d5$export$9345d7360ffe0722 = "platform-pkg";
const $284d8e69d74c83d5$export$91546b032799aa40 = "0.0.0-use.local";
module.exports["packageName"] = $284d8e69d74c83d5$export$9345d7360ffe0722;
module.exports["packageVersion"] = $284d8e69d74c83d5$export$91546b032799aa40;

});

parcelRegister("hOkJN", function(module, exports) {

var $gZFfs = parcelRequire("gZFfs");

var $34VCg = parcelRequire("34VCg");

const $0ea055bec2445b3a$var$keyToTiming = (key)=>({
        key: key,
        startMark: `${key}_start`,
        endMark: `${key}_end`
    });
const $0ea055bec2445b3a$var$timings = [
    'FetchedActivities',
    'TransformedActivityItems',
    'GeneratedQueryWithFilters'
].map($0ea055bec2445b3a$var$keyToTiming);
const $0ea055bec2445b3a$export$d7769758f5eaa63b = ()=>{
    return new (0, $34VCg.UFOExperience)('client', {
        type: (0, $gZFfs.ExperienceTypes).Load,
        performanceType: (0, $gZFfs.ExperiencePerformanceTypes).Custom,
        platform: {
            component: 'recent-work'
        },
        timings: $0ea055bec2445b3a$var$timings
    });
};
const $0ea055bec2445b3a$export$9e32a4ed888f4717 = ()=>new (0, $34VCg.UFOExperience)('client-v3', {
        type: (0, $gZFfs.ExperienceTypes).Load,
        performanceType: (0, $gZFfs.ExperiencePerformanceTypes).Custom,
        platform: {
            component: 'recent-work'
        },
        timings: $0ea055bec2445b3a$var$timings
    });
module.exports["recentWorkClientExperienceV2"] = $0ea055bec2445b3a$export$d7769758f5eaa63b;
module.exports["recentWorkClientExperienceV3"] = $0ea055bec2445b3a$export$9e32a4ed888f4717;

});

parcelRegister("7azIf", function(module, exports) {

var $kRg7a = parcelRequire("kRg7a");

class $2f9626706315fea1$export$157740f5433f3dbe {
    constructor(clientVersion, product, headers, baseUrl, collabContextId){
        this.clientVersion = void 0;
        this.product = 'unknown';
        this.headers = void 0;
        this.baseUrl = (0, $kRg7a.GRAPHQL_GATEWAY_PATH);
        /**
     * An opaque collaboration context identifier that is forwarded as a
     * top-level field on every request body sent to the activity service.
     * Set once at construction time.
     */ this.collabContextId = void 0;
        this.fetchActivities = void 0;
        this.setProduct = void 0;
        if (product) this.product = product;
        this.clientVersion = clientVersion;
        this.headers = headers ?? {};
        if (baseUrl) this.baseUrl = baseUrl;
        this.collabContextId = collabContextId;
    }
}
module.exports["ActivityClient"] = $2f9626706315fea1$export$157740f5433f3dbe;

});

parcelRegister("kRg7a", function(module, exports) {
const $63a633f8d6f90ec2$export$851c5df667ca24c8 = '/gateway/api/graphql';
var $63a633f8d6f90ec2$export$d245b105c09339d8 = /*#__PURE__*/ function(VIEWED_EVENT) {
    VIEWED_EVENT["VIEWED"] = "viewed";
    VIEWED_EVENT["SMARTLINK_VIEWED"] = "sl-viewed";
    VIEWED_EVENT["SMARTLINK_CLICKED"] = "sl-clicked";
    return VIEWED_EVENT;
}({});
var $63a633f8d6f90ec2$export$eb4e9f525aef1cc3 = /*#__PURE__*/ function(WORKED_EVENT) {
    WORKED_EVENT["COMMENTED"] = "commented";
    WORKED_EVENT["CREATED"] = "created";
    WORKED_EVENT["EDITED"] = "edited";
    WORKED_EVENT["PUBLISHED"] = "published";
    WORKED_EVENT["UPDATED"] = "updated";
    return WORKED_EVENT;
}({});
var $63a633f8d6f90ec2$export$d02a56686be43f69 = /*#__PURE__*/ function(ActivityObjectType) {
    ActivityObjectType["BLOGPOST"] = "BLOGPOST";
    ActivityObjectType["COMMENT"] = "COMMENT";
    ActivityObjectType["ISSUE"] = "ISSUE";
    ActivityObjectType["PAGE"] = "PAGE";
    ActivityObjectType["PROJECT"] = "PROJECT";
    ActivityObjectType["SITE"] = "SITE";
    ActivityObjectType["SPACE"] = "SPACE";
    ActivityObjectType["TASK"] = "TASK";
    // 3P Graph types below
    ActivityObjectType["DOCUMENT"] = "document";
    ActivityObjectType["PULL_REQUEST"] = "pull-request";
    ActivityObjectType["REMOTE_LINK"] = "remote-link";
    return ActivityObjectType;
}({});
module.exports["GRAPHQL_GATEWAY_PATH"] = $63a633f8d6f90ec2$export$851c5df667ca24c8;
module.exports["VIEWED_EVENT"] = $63a633f8d6f90ec2$export$d245b105c09339d8;
module.exports["WORKED_EVENT"] = $63a633f8d6f90ec2$export$eb4e9f525aef1cc3;
module.exports["ActivityObjectType"] = $63a633f8d6f90ec2$export$d02a56686be43f69;

});

parcelRegister("1Zjzt", function(module, exports) {

var $barCt = parcelRequire("barCt");


var $5qNjK = parcelRequire("5qNjK");


var $j34b5 = parcelRequire("j34b5");


var $fKvhW = parcelRequire("fKvhW");

const $4126b524e6cacb9f$var$ACTIVITIES_LIMIT = 50;
// typescript guard for validating the activities connection type
const $4126b524e6cacb9f$var$isMyActivitiesConnection = (activities)=>{
    return activities.myActivities !== undefined;
};
const $4126b524e6cacb9f$var$V2_AVAILABLE_PRODUCTS = [
    'teamCentral',
    'editor',
    'people',
    'jira',
    'townsquare',
    'apOnboarding',
    'worklens',
    'confluence',
    'start'
];
const $4126b524e6cacb9f$export$750ec7816fdd2f9e = async ({ experience: experience, product: product, retryMS: retryMS, filters: filters = {}, activityQueries: activityQueries, baseUrl: baseUrl })=>{
    const { limit: // we want to default limit if not applied
    limit = $4126b524e6cacb9f$var$ACTIVITIES_LIMIT, ...restFilters } = filters;
    experience.mark('GeneratedQueryWithFilters_start');
    const { query: query, queryFilters: queryFilters } = (0, $j34b5.generateActivityQueryWithFilters)(product, restFilters, activityQueries);
    experience.mark('GeneratedQueryWithFilters_end');
    // This is to make v2 forwards compatible. Defaulting to start as the product
    const operationProduct = $4126b524e6cacb9f$var$V2_AVAILABLE_PRODUCTS.includes(product) ? product : 'start';
    experience.mark('FetchedActivities_start');
    let response;
    try {
        response = await (0, $5qNjK.postResource)(baseUrl, {
            operationName: (0, $barCt.getOperationName)(operationProduct),
            query: query,
            variables: {
                first: limit,
                filters: queryFilters
            }
        }, retryMS);
    } catch (error) {
        if (!error || error.statusCode !== 401 && error.message !== 'The operation was aborted.') throw error;
    }
    experience.mark('FetchedActivities_end');
    let workedOn = [], viewed = [], all = [];
    if (!response || !response.data?.activities) return {
        all: all,
        workedOn: workedOn,
        viewed: viewed
    };
    experience.mark('TransformedActivityItems_start');
    if ($4126b524e6cacb9f$var$isMyActivitiesConnection(response.data.activities)) {
        if (response.data.activities.myActivities.workedOn && activityQueries.includes('workedOn')) workedOn = (0, $fKvhW.transformActivitiesItems)('workedOn', response.data.activities.myActivities.workedOn);
        if (response.data.activities.myActivities.viewed && activityQueries.includes('viewed')) viewed = (0, $fKvhW.transformActivitiesItems)('viewed', response.data.activities.myActivities.viewed);
        if (response.data.activities.myActivities.all && activityQueries.includes('all')) all = (0, $fKvhW.transformActivitiesItems)('all', response.data.activities.myActivities.all);
    } else {
        if (response.data.activities.workedOn && activityQueries.includes('workedOn')) workedOn = (0, $fKvhW.transformActivitiesItems)('workedOn', response.data.activities.workedOn);
        if (response.data.activities.all && activityQueries.includes('all')) all = (0, $fKvhW.transformActivitiesItems)('all', response.data.activities.all);
    }
    experience.mark('TransformedActivityItems_end');
    return {
        all: all,
        viewed: viewed,
        workedOn: workedOn
    };
};
module.exports["fetchActivitiesV2"] = $4126b524e6cacb9f$export$750ec7816fdd2f9e;

});

parcelRegister("barCt", function(module, exports) {

var $j4yZr = parcelRequire("j4yZr");

const $dba663cba8374ee1$export$ad1e21d37f385bcb = (product)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($j4yZr)))(product);
};
const $dba663cba8374ee1$export$41bca9dc6871dd4e = (product)=>{
    return `${$dba663cba8374ee1$export$ad1e21d37f385bcb(product)}_activity_recentWorkClient`;
};
module.exports["getOperationName"] = $dba663cba8374ee1$export$41bca9dc6871dd4e;

});

parcelRegister("5qNjK", function(module, exports) {
parcelRequire("aotCl");
var $4ewfC = parcelRequire("4ewfC");
var $aotCl = parcelRequire("aotCl");


var $9didM = parcelRequire("9didM");


var $3pZ7I = parcelRequire("3pZ7I");

const $77ae2bc04c6c17cd$var$fetchResource = async (path, method, options = {})=>{
    const url = (0, $9didM.getFullUrl)(path);
    const response = await fetch(url, {
        credentials: 'include',
        method: method,
        ...options
    }).catch((error)=>{
        throw new (0, $4ewfC.default)({
            error: error,
            path: path,
            method: method
        });
    });
    const statusCode = response.status;
    if (!response.ok) {
        statusCode;
        const text = $77ae2bc04c6c17cd$var$scrubTimestampFromErrorBody(await response.text());
        const httpError = new (0, $3pZ7I.default)({
            message: text,
            method: method,
            path: path,
            statusCode: statusCode,
            xRequestId: response.headers.get('x-request-id'),
            headers: response.headers
        });
        throw httpError;
    }
    return response;
};
const $77ae2bc04c6c17cd$var$makeJsonRquest = async (path, method, additionalFetchOptions = {})=>{
    const response = await $77ae2bc04c6c17cd$var$fetchResource(path, method, additionalFetchOptions);
    const text = await response.text();
    // trying to parse empty response as JSON throws an error, but endpoints can return empty response in case of success
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return text ? JSON.parse(text) : {};
};
const $77ae2bc04c6c17cd$export$2ff3e1f219ccfad6 = async (path, data, retryMS, extraHeaders)=>(0, $aotCl.retryOnException)(()=>$77ae2bc04c6c17cd$var$makeJsonRquest(path, 'POST', {
            body: JSON.stringify(data),
            headers: {
                'content-type': 'application/json',
                ...extraHeaders
            }
        }), {
        intervalsMS: retryMS ?? []
    });
// to dedup sentry, scrub non-unique 'timestamp' field from the error body
function $77ae2bc04c6c17cd$var$scrubTimestampFromErrorBody(text) {
    let json;
    try {
        json = JSON.parse(text);
    } catch (err) {
        return text;
    }
    delete json.timestamp;
    return JSON.stringify(json);
}
module.exports["postResource"] = $77ae2bc04c6c17cd$export$2ff3e1f219ccfad6;

});

parcelRegister("aotCl", function(module, exports) {
$parcel$export(module.exports, "FailedFetchError", () => (parcelRequire("4ewfC")).default);

var $1HD0w = parcelRequire("1HD0w");


var $40S6S = parcelRequire("40S6S");


var $4ewfC = parcelRequire("4ewfC");

const $fc8c651681b8647e$export$5c069c93d2b7493f = (ms)=>new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
const $fc8c651681b8647e$var$NO_CALLS_ERROR = 'No calls made';
const $fc8c651681b8647e$export$1d94629c94e7a17f = async (invokeOperation, { intervalsMS: intervalsMS = (0, $40S6S.NO_RETRIES), retryOn: retryOn = [
    (0, $4ewfC.default)
], captureException: captureException, onRetry: onRetry })=>{
    const intervals = [
        ...intervalsMS
    ];
    let nextMSInterval = 0;
    let error = new Error($fc8c651681b8647e$var$NO_CALLS_ERROR);
    while(nextMSInterval !== undefined)try {
        if (nextMSInterval > 0) await $fc8c651681b8647e$export$5c069c93d2b7493f(nextMSInterval);
        if (onRetry && error.message !== $fc8c651681b8647e$var$NO_CALLS_ERROR) onRetry(error);
        return await invokeOperation();
    } catch (e) {
        error = (0, $1HD0w.default)(e);
        if (captureException) captureException(error);
        // Retry ONLY when the error is an instance of one of the provided `retryOn` errors, or passes the `retryOn` test.
        // You need to ensure you are throwing one of the `retryOn` errors if that is the method you are using.
        if (typeof retryOn === 'function' ? retryOn(error) : retryOn.some((err)=>error instanceof err)) nextMSInterval = intervals.shift();
        else nextMSInterval = undefined;
    }
    throw error;
};
module.exports["retryOnException"] = $fc8c651681b8647e$export$1d94629c94e7a17f;

});

parcelRegister("1HD0w", function(module, exports) {
const $13c736d6b866110a$var$convertToError = (e)=>{
    let error;
    if (e instanceof Error) error = e;
    else if (typeof e === 'string') error = new Error(e);
    else if (typeof e === 'object') try {
        error = new Error('Object error instance thrown for operation: ' + JSON.stringify(e));
    } catch (jsonError) {
        error = new Error('Object serialisation error thrown during operation: ' + String(e));
    }
    else error = new Error('No error instance thrown for operation: ' + String(e));
    return error;
};
var $13c736d6b866110a$export$2e2bcd8739ae039 = $13c736d6b866110a$var$convertToError;
module.exports["default"] = $13c736d6b866110a$export$2e2bcd8739ae039;

});

parcelRegister("40S6S", function(module, exports) {
const $fb23f31c5ca203e1$export$a0a1c8f90becc136 = [];
const $fb23f31c5ca203e1$export$972171517b12aa4 = [
    0,
    0
];
const $fb23f31c5ca203e1$export$746d2203ed8cdc40 = [
    0,
    50,
    100
];
const $fb23f31c5ca203e1$export$f6858378b665f957 = [
    100,
    500,
    1000
];
module.exports["NO_RETRIES"] = $fb23f31c5ca203e1$export$a0a1c8f90becc136;

});

parcelRegister("4ewfC", function(module, exports) {
class $2e21f428048470ea$export$2e2bcd8739ae039 extends Error {
    constructor({ error: error, path: path, method: method }){
        super();
        this.method = void 0;
        this.originalName = void 0;
        this.path = void 0;
        this.stack = void 0;
        this.name = 'FailedFetchError';
        this.message = error.message || 'Unknown fetch error';
        this.stack = error.stack;
        this.originalName = error.name;
        this.method = method;
        const p = path.split('?')[0];
        this.path = /^[/-a-z]+$/i.test(p) ? p : '';
    }
}
module.exports["default"] = $2e21f428048470ea$export$2e2bcd8739ae039;

});

parcelRegister("9didM", function(module, exports) {
const $87132959cf1a7345$var$urlRegex = new RegExp(/^https?:\/\//);
function $87132959cf1a7345$export$2414511207262909(path, // Add this param so we can test this function better
hostConfig = {
    host: window.location.hostname,
    port: window.location.port
}) {
    // always return a just the URL if one is provided
    if ($87132959cf1a7345$var$urlRegex.test(path)) return path;
    return hostConfig.host === 'localhost' ? `http://${hostConfig.host}:${hostConfig.port}${path}` : path;
}
module.exports["getFullUrl"] = $87132959cf1a7345$export$2414511207262909;

});

parcelRegister("j34b5", function(module, exports) {

var $barCt = parcelRequire("barCt");


var $oLeaD = parcelRequire("oLeaD");

const $4117f82aca55ea3d$var$ACTIVITIES = `
  nodes {
    id
    timestamp
    object {
      id
      name
      cloudId
      localResourceId
      product
      type
      url
      iconUrl
      containers {
        name
      }
      contributors {
        profile {
          accountId
          name
          picture
        }
      }
      events {
        eventType
      }
      extension {
        ... on ActivitiesJiraIssue {
          issueKey
        }
      }
    }
  }
`;
const $4117f82aca55ea3d$var$WORKED_ON_QUERY = `
   workedOn(first: $first, filters: $filters) {
     ${$4117f82aca55ea3d$var$ACTIVITIES}
   }
`;
const $4117f82aca55ea3d$var$VIEWED__QUERY = `
   viewed(first: $first, filters: $filters) {
     ${$4117f82aca55ea3d$var$ACTIVITIES}
   }
`;
const $4117f82aca55ea3d$var$ALL__QUERY = `
    all(first: $first, filters: $filters) {
      ${$4117f82aca55ea3d$var$ACTIVITIES}
    }
`;
const $4117f82aca55ea3d$var$activityQueryMap = new Map([
    [
        'workedOn',
        $4117f82aca55ea3d$var$WORKED_ON_QUERY
    ],
    [
        'viewed',
        $4117f82aca55ea3d$var$VIEWED__QUERY
    ],
    [
        'all',
        $4117f82aca55ea3d$var$ALL__QUERY
    ]
]);
const $4117f82aca55ea3d$var$getMyActivitiesQuery = (queries)=>`
      myActivities {
        ${queries.join('\n')}
      }
`;
const $4117f82aca55ea3d$var$getActivitiesQuery = (product, content)=>`
    query ${(0, $barCt.getOperationName)(product)}($first: Int, $filters: [ActivitiesFilter!]) {
      activities {
        ${content}
      }
    }
`;
const $4117f82aca55ea3d$export$855cd08371c65b8c = (product, filters, activityQueries)=>{
    /**
   * If we are filtering by `accountIds` then we can't use the `myActivity` query.
   */ if (Array.isArray(filters.actors)) {
        // you can't view `viewed` events for other accounts
        const filteredAccountQueries = activityQueries.filter((query)=>query !== 'viewed');
        return {
            query: $4117f82aca55ea3d$var$getActivitiesQuery(product, filteredAccountQueries.map((query)=>$4117f82aca55ea3d$var$activityQueryMap.get(query)).join('\n')),
            queryFilters: (0, $oLeaD.ACTIVITY_FILTER_COLLECTION).v2.get('activities')(filters)
        };
    } else return {
        query: $4117f82aca55ea3d$var$getActivitiesQuery(product, $4117f82aca55ea3d$var$getMyActivitiesQuery(activityQueries.map((query)=>$4117f82aca55ea3d$var$activityQueryMap.get(query)))),
        queryFilters: (0, $oLeaD.ACTIVITY_FILTER_COLLECTION).v2.get('myActivity')(filters)
    };
};
module.exports["generateActivityQueryWithFilters"] = $4117f82aca55ea3d$export$855cd08371c65b8c;

});

parcelRegister("oLeaD", function(module, exports) {

var $5VeWw = parcelRequire("5VeWw");


var $fwe17 = parcelRequire("fwe17");

const $cbd198d3254213f2$export$5201d39848130041 = {
    v2: (0, $5VeWw.ACTIVITY_FILTER_V2_MAP),
    v3: (0, $fwe17.ACTIVITY_FILTER_V3_MAP)
};
module.exports["ACTIVITY_FILTER_COLLECTION"] = $cbd198d3254213f2$export$5201d39848130041;

});

parcelRegister("5VeWw", function(module, exports) {

var $aTo36 = parcelRequire("aTo36");


var $dfp5E = parcelRequire("dfp5E");

const $dd1d1c00ac927853$export$1dca7bc1ec360897 = new Map([
    [
        'myActivity',
        (0, $dfp5E.default)
    ],
    [
        'activities',
        (0, $aTo36.default)
    ]
]);
module.exports["ACTIVITY_FILTER_V2_MAP"] = $dd1d1c00ac927853$export$1dca7bc1ec360897;

});

parcelRegister("aTo36", function(module, exports) {

var $aRf77 = parcelRequire("aRf77");

/**
 * This is the query builder for the v2 - activities API
 *
 * @param filters
 */ const $aed8fa79eb92573e$var$generateV2ActivitiesFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, // TODO: Enable the below code as we support multi-user queries and enable them in the main ActivityFilters interface
    // actors,
    // rootContainerIds,
    ...restFilters } = filters;
    return (0, $aRf77.generateActivityFiltersV2)(restFilters);
};
var $aed8fa79eb92573e$export$2e2bcd8739ae039 = $aed8fa79eb92573e$var$generateV2ActivitiesFilters;
module.exports["default"] = $aed8fa79eb92573e$export$2e2bcd8739ae039;

});

parcelRegister("aRf77", function(module, exports) {

var $3JrJF = parcelRequire("3JrJF");

// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
const $d39b965b3bbf9d59$var$FILTERS_TO_TRANSFORM__UPPERCASE = [
    'products',
    'eventTypes',
    'objectTypes'
];
const $d39b965b3bbf9d59$var$KEYS_TO_TRANSFROM = new Map([
    [
        'actors',
        'accountIds'
    ]
]);
const $d39b965b3bbf9d59$export$ebef9c1f1e15c057 = (filters = {})=>(0, $3JrJF.generateActivityFilters)(filters, (originalkey, originalFilter)=>{
        const filter = Array.isArray(originalFilter) && $d39b965b3bbf9d59$var$FILTERS_TO_TRANSFORM__UPPERCASE.includes(originalkey) ? originalFilter.map((f)=>f.toUpperCase()) : originalFilter;
        const key = $d39b965b3bbf9d59$var$KEYS_TO_TRANSFROM.has(originalkey) ? $d39b965b3bbf9d59$var$KEYS_TO_TRANSFROM.get(originalkey) : originalkey;
        return {
            [key]: filter
        };
    });
module.exports["generateActivityFiltersV2"] = $d39b965b3bbf9d59$export$ebef9c1f1e15c057;

});

parcelRegister("3JrJF", function(module, exports) {
const $feda494bd73f070f$export$23c75313f46dd54e = (filters = {}, transform, rootLevelFilters)=>{
    return Object.entries(filters).reduce((acc, [key, filter])=>{
        const entry = transform ? transform(key, filter) : {
            [key]: filter
        };
        return rootLevelFilters?.includes(key) ? {
            ...acc,
            ...entry
        } : {
            ...acc,
            arguments: {
                ...acc.arguments,
                ...entry
            }
        };
    }, {
        type: 'AND',
        arguments: {}
    });
};
module.exports["generateActivityFilters"] = $feda494bd73f070f$export$23c75313f46dd54e;

});

parcelRegister("dfp5E", function(module, exports) {

var $aRf77 = parcelRequire("aRf77");

/**
 * This is the query builder for the v2 - myActivity API
 *
 * @param filters
 */ const $a72cc322841ef9e0$var$generateV2MyActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, actors: actors, // TODO: Enable the below code as we support multi-user queries and enable them in the main ActivityFilters interface
    // actors,
    // rootContainerIds,
    ...restFilters } = filters;
    return (0, $aRf77.generateActivityFiltersV2)(restFilters);
};
var $a72cc322841ef9e0$export$2e2bcd8739ae039 = $a72cc322841ef9e0$var$generateV2MyActivityFilters;
module.exports["default"] = $a72cc322841ef9e0$export$2e2bcd8739ae039;

});

parcelRegister("fwe17", function(module, exports) {

var $4yd2C = parcelRequire("4yd2C");


var $9nmYv = parcelRequire("9nmYv");

const $5c2d14baa4c9c645$export$9a1782843b6e99d2 = new Map([
    [
        'myActivity',
        (0, $9nmYv.default)
    ],
    [
        'activities',
        (0, $4yd2C.default)
    ]
]);
module.exports["ACTIVITY_FILTER_V3_MAP"] = $5c2d14baa4c9c645$export$9a1782843b6e99d2;

});

parcelRegister("4yd2C", function(module, exports) {

var $4MKl9 = parcelRequire("4MKl9");

/**
 * This is the query builder for the v3 - activities API
 *
 * @param filters
 */ const $8c0616ed2bef08db$var$generateV3ActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, ...restFilters } = filters;
    return (0, $4MKl9.generateActivityFiltersV3)(restFilters);
};
var $8c0616ed2bef08db$export$2e2bcd8739ae039 = $8c0616ed2bef08db$var$generateV3ActivityFilters;
module.exports["default"] = $8c0616ed2bef08db$export$2e2bcd8739ae039;

});

parcelRegister("4MKl9", function(module, exports) {

var $3JrJF = parcelRequire("3JrJF");

// in V2 API the values for certain filters should be in UPPERCASE as are ENUMs in the GraphQL
// likewise for the V3 handler we should ensure we do appropriate lowercase conversion
const $817dbd89421fbc4e$var$FILTERS_TO_TRANSFORM__LOWERCASE = [
    'products',
    'eventTypes',
    'objectTypes'
];
const $817dbd89421fbc4e$var$ROOT_LEVEL_FILTERS = [
    'actors',
    'rootContainerIds',
    'collabContextId'
];
const $817dbd89421fbc4e$export$e73fe7ded3fe2664 = (filters = {})=>(0, $3JrJF.generateActivityFilters)(filters, (key, filter)=>Array.isArray(filter) && $817dbd89421fbc4e$var$FILTERS_TO_TRANSFORM__LOWERCASE.includes(key) ? {
            [key]: filter.map((f)=>f.toLowerCase())
        } : {
            [key]: filter
        }, $817dbd89421fbc4e$var$ROOT_LEVEL_FILTERS);
module.exports["generateActivityFiltersV3"] = $817dbd89421fbc4e$export$e73fe7ded3fe2664;

});

parcelRegister("9nmYv", function(module, exports) {

var $4MKl9 = parcelRequire("4MKl9");

/**
 * This is the query builder for the v3 - myActivity API
 *
 * @param filters
 */ const $5e1aa0cbd8c0075b$var$generateV3MyActivityFilters = (filters = {})=>{
    const { limit: // discard as these aren't supported by this query
    limit, actors: actors, ...restFilters } = filters;
    return (0, $4MKl9.generateActivityFiltersV3)(restFilters);
};
var $5e1aa0cbd8c0075b$export$2e2bcd8739ae039 = $5e1aa0cbd8c0075b$var$generateV3MyActivityFilters;
module.exports["default"] = $5e1aa0cbd8c0075b$export$2e2bcd8739ae039;

});

parcelRegister("fKvhW", function(module, exports) {
const $0c995db33b07948e$var$SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
function $0c995db33b07948e$export$306a8b649360ca6f(query, activities = {}) {
    if (!activities || !activities.nodes) return [];
    return activities.nodes.map((item)=>{
        const { object: object, timestamp: timestamp } = item;
        const { cloudId: cloudId, events: events, extension: extension, iconUrl: iconUrl, id: id, localResourceId: localResourceId, name: name, product: product, url: url, type: type } = object;
        // V2 returns eventType captilised, V3 returns lowercase
        const eventType = events[0].eventType.toLowerCase();
        const issueKey = extension && extension.issueKey;
        let containers = [];
        if (issueKey) containers.push({
            name: issueKey
        });
        if (Array.isArray(object.containers)) containers = containers.concat(object.containers);
        containers = containers.filter((container)=>!!container.name);
        return {
            query: query,
            containers: containers,
            contributors: (object.contributors || []).reduce((contributors, contributor)=>{
                if (contributor.profile) {
                    const { accountId: accountId, picture: picture } = contributor.profile;
                    contributors.push({
                        accountId: accountId,
                        name: contributor.profile.name,
                        picture: picture
                    });
                }
                return contributors;
            }, []),
            eventType: eventType,
            object: {
                rootContainerIdentifier: {
                    id: cloudId,
                    type: 'SITE',
                    ari: `${$0c995db33b07948e$var$SITE_ARI_PREFIX}${cloudId}`
                },
                deduplicateId: id,
                icon: {
                    type: 'URL',
                    value: iconUrl
                },
                id: id,
                localResourceId: localResourceId,
                name: name,
                product: product,
                subProduct: null,
                type: type,
                url: url
            },
            timestamp: timestamp
        };
    });
}
module.exports["transformActivitiesItems"] = $0c995db33b07948e$export$306a8b649360ca6f;

});

parcelRegister("6vFZD", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $aotCl = parcelRequire("aotCl");


var $ixfCV = parcelRequire("ixfCV");


var $kRg7a = parcelRequire("kRg7a");


var $bXw81 = parcelRequire("bXw81");


var $71leB = parcelRequire("71leB");


var $5qNjK = parcelRequire("5qNjK");


var $4vnKy = parcelRequire("4vnKy");


var $dN8zB = parcelRequire("dN8zB");


var $389Lj = parcelRequire("389Lj");


var $bBnDU = parcelRequire("bBnDU");


var $9vnYD = parcelRequire("9vnYD");


var $2YNjC = parcelRequire("2YNjC");


var $7azIf = parcelRequire("7azIf");


var $iCy8k = parcelRequire("iCy8k");


var $k4jq6 = parcelRequire("k4jq6");


var $2aFdM = parcelRequire("2aFdM");

const $60eeb98ff0f0ced5$var$CONFLUENCE_COMMENT_TYPENAMES = [
    'ConfluenceComment',
    'ConfluenceFooterComment',
    'ConfluenceInlineComment'
];
const $60eeb98ff0f0ced5$var$IGNORED_HTTP_ERRORS = new Map([
    // ignore all 401 errors
    [
        401,
        [
            /.*/
        ]
    ],
    [
        403,
        [
            /Invalid CORS request/
        ]
    ]
]);
const $60eeb98ff0f0ced5$var$IGNORED_ERROR_MESSAGES = [
    'The operation was aborted.'
];
const $60eeb98ff0f0ced5$var$DEFAULT_TAGS = {
    source: (0, $bXw81.packageName),
    sourcePackageVersion: (0, $bXw81.packageVersion)
};
class $60eeb98ff0f0ced5$export$3c3c237c92ca1fb9 extends (0, $7azIf.ActivityClient) {
    constructor(_product, baseUrl, logger, configFetch, collabContextId){
        super('v3', _product, {
            'X-ExperimentalApi': 'ActivityV3Api'
        }, baseUrl, collabContextId);
        this.hydratorConfigClient = void 0;
        this.clientHandlers = void 0;
        this.setProduct = (product)=>{
            this.product = product;
        };
        this.captureException = (error, tags)=>{
            if (this.clientHandlers) this.clientHandlers.captureException(error, {
                ...$60eeb98ff0f0ced5$var$DEFAULT_TAGS,
                ...tags
            });
        };
        this.captureWarning = (message, tags)=>{
            if (this.clientHandlers) this.clientHandlers.captureWarning(message, {
                ...$60eeb98ff0f0ced5$var$DEFAULT_TAGS,
                ...tags
            });
        };
        this.fetchHydratorConfig = async ()=>await this.hydratorConfigClient.fetchConfig();
        this.handleGraphQLErrors = (errors)=>{
            const invalidFragments = [];
            if (Array.isArray(errors)) {
                for (const err of errors){
                    this.captureException(new (0, $dN8zB.GraphQLJSError)(err));
                    const invalidFragment = (0, $iCy8k.default)(err);
                    if (invalidFragment) invalidFragments.push(invalidFragment);
                }
                return invalidFragments;
            }
            return [];
        };
        this.fetchActivitiesV3 = async (experience, retryMS, filters, activityQueries, deduplicateActivities = true)=>{
            let { fragments: fragments, hydrators: hydrators } = await this.fetchHydratorConfig();
            experience.mark('GeneratedQueryWithFilters_start');
            let response;
            try {
                response = await (0, $aotCl.retryOnException)(async ()=>{
                    const request = (0, $k4jq6.generateGraphQLRequest)(this.product, filters, activityQueries, fragments);
                    experience.mark('GeneratedQueryWithFilters_end');
                    experience.mark('FetchedActivities_start');
                    experience.addMetadata({
                        filters: (0, $2aFdM.filtersToMetadata)(filters)
                    });
                    const res = await (0, $5qNjK.postResource)(this.baseUrl, request, retryMS, {
                        ...this.headers
                    });
                    experience.mark('FetchedActivities_end');
                    const invalidFragments = this.handleGraphQLErrors(res?.errors);
                    if (invalidFragments.length > 0) {
                        fragments = (0, $2aFdM.filterInvalidFragments)(invalidFragments, fragments);
                        throw new (0, $4vnKy.GraphQLFragmentError)(`Missing fragments: [${invalidFragments.toString()}]`);
                    }
                    return res;
                }, {
                    intervalsMS: [
                        0,
                        0,
                        0
                    ],
                    retryOn: (err)=>[
                            (0, $4vnKy.GraphQLFragmentError)
                        ].some((retriableErr)=>err instanceof retriableErr),
                    captureException: this.captureException
                });
            } catch (error) {
                if (!error || !$60eeb98ff0f0ced5$var$IGNORED_HTTP_ERRORS.get(error.statusCode)?.some((regExp)=>regExp.test(error.message)) && !$60eeb98ff0f0ced5$var$IGNORED_ERROR_MESSAGES.includes(error.message)) throw error;
            }
            if ((0, $2aFdM.isEmptyActivitiesWithErrorsResponse)(response)) throw new (0, $389Lj.GraphQLNoResultsError)(response.errors);
            if (!response || !response.data?.activity) return {
                workedOn: [],
                viewed: [],
                all: []
            };
            experience.mark('TransformedActivityItems_start');
            const workedOn = $60eeb98ff0f0ced5$var$transformActivityItem('workedOn', (0, $2aFdM.activityRoot)(response.data.activity)?.workedOn?.edges || [], hydrators, this.captureException);
            // We don't need the activity root function here as viewed only exists on myActivity
            const viewed = $60eeb98ff0f0ced5$var$transformActivityItem('viewed', response.data.activity?.myActivity?.viewed?.edges || [], hydrators, this.captureException);
            const all = $60eeb98ff0f0ced5$var$transformActivityItem('all', (0, $2aFdM.activityRoot)(response.data.activity)?.all?.edges || [], hydrators, this.captureException);
            experience.mark('TransformedActivityItems_end');
            const activities = {
                viewed: viewed,
                workedOn: workedOn,
                all: all
            };
            return deduplicateActivities ? (0, $2aFdM.rollupActivitiesData)(activities) : activities;
        };
        this.fetchActivities = async (retryMS, filters, activityQueries, deduplicateActivities = true)=>{
            const filtersWithCollabContext = this.collabContextId && (0, $ixfCV.fg)('platform_recent_work_collab_context_id') ? {
                ...filters,
                collabContextId: this.collabContextId
            } : filters;
            return (0, $71leB.fetchActivitiesWithExperience)((experience)=>this.fetchActivitiesV3(experience, retryMS, filtersWithCollabContext, activityQueries, deduplicateActivities), 'v3');
        };
        this.clientHandlers = logger;
        this.hydratorConfigClient = new (0, $2YNjC.default)({
            captureException: this.captureException,
            captureWarning: this.captureWarning
        }, _product, configFetch);
    }
}
const $60eeb98ff0f0ced5$var$setIconHydration = (object, hydratedData)=>{
    const isLiveDoc = object.data.__typename === 'ConfluencePage' && (0, $9vnYD.hydratedValueToString)(hydratedData.subtype) === 'LIVE';
    if (isLiveDoc) return (0, $9vnYD.hydrateIcon)(hydratedData.icon, hydratedData.staticFallbacks, 'confluenceLiveDocIcon');
    if (object.product === 'graph' && (0, $9vnYD.isThirdPartyARI)(object.id)) {
        const product = (0, $9vnYD.parseThirdPartyProduct)(object.id).split('.').at(1);
        return (0, $9vnYD.hydrate3pIcon)(product, hydratedData.icon, hydratedData.staticFallbacks);
    }
    return $60eeb98ff0f0ced5$var$CONFLUENCE_COMMENT_TYPENAMES.includes(object.data.__typename) ? (0, $9vnYD.hydrateConfluenceIcon)(object.data?.container?.__typename || object.data.__typename, hydratedData.icon, hydratedData.staticFallbacks) : (0, $9vnYD.hydrateIcon)(hydratedData.icon, hydratedData.staticFallbacks);
};
const $60eeb98ff0f0ced5$var$setStatusHydration = (hydratedData)=>{
    const value = (0, $9vnYD.hydratedValueToString)(hydratedData.statusValue);
    const score = (0, $9vnYD.hydratedValueToString)(hydratedData.statusScore);
    const color = (0, $9vnYD.hydratedValueToString)(hydratedData.statusColor);
    return value || score || color ? {
        value: value,
        score: score,
        color: color
    } : undefined;
};
function $60eeb98ff0f0ced5$var$transformActivityItem(query, activities, hydrators, captureException) {
    return activities.reduce((acc, item)=>{
        if (item && item.node && item.node.object && item.node.event) {
            const { object: object, event: event } = item.node;
            if (!object.product || !object.type) return acc;
            let product = object.product;
            if (object.product === 'graph' || object.id.startsWith('ari:cloud:graph::pull-request')) product = (0, $2aFdM.getThirdPartyGraphProvider)(object);
            const isSmartlinkViewedType = item.node.event.eventType === (0, $kRg7a.VIEWED_EVENT).SMARTLINK_VIEWED;
            const isSmartlinkViewedGateEnabled = (0, $ixfCV.fg)('platform_recent_work_enable_sl-viewed_results');
            const isExternalPullRequest = item.node.object.data?.__typename === 'ExternalPullRequest';
            const isGithubRecentsEnabled = (0, $cXtTj.default).getExperimentValue('add-github-activityplatform-recentworkitem', 'isEnabled', false);
            if (isSmartlinkViewedType && !isSmartlinkViewedGateEnabled) // Don't return any `sl-viewed` event results
            return acc;
            if (isExternalPullRequest && product === 'github' && !isGithubRecentsEnabled) // Don't return GitHub pull request results until the feature gate is enabled
            return acc;
            const containers = [];
            let c = object.contributors || [];
            const contributors = c.reduce((contributors, contributor)=>{
                if (contributor.profile) {
                    const { accountId: accountId, picture: picture } = contributor.profile;
                    contributors.push({
                        accountId: accountId,
                        name: contributor.profile.name,
                        picture: picture
                    });
                }
                return contributors;
            }, []);
            const hydratedData = (0, $bBnDU.hydratePolymorphicData)(hydrators, object.data, captureException);
            if (hydratedData) {
                if (hydratedData.key) containers.push({
                    name: (0, $9vnYD.hydratedValueToString)(hydratedData.key, ' ')
                });
                const displayNameEnabledForAssets = product === 'assets' && (0, $ixfCV.fg)('cdm_display_name');
                const containersValue = displayNameEnabledForAssets ? hydratedData.containersWithDisplayName : hydratedData.containers;
                if (containersValue) containers.push({
                    name: (0, $9vnYD.hydratedValueToString)(containersValue, ' ')
                });
                const actor = event.actor ? {
                    name: event.actor.name,
                    picture: event.actor.picture,
                    accountId: event.actor.accountId
                } : undefined;
                // The V3 API returns "Created" for a new comment, we want this to display as "Commented"
                const eventType = object.type === 'comment' && event.eventType === (0, $kRg7a.WORKED_EVENT).CREATED ? (0, $kRg7a.WORKED_EVENT).COMMENTED : event.eventType;
                acc.push({
                    actor: actor,
                    query: query,
                    containers: containers,
                    contributors: contributors,
                    eventType: eventType,
                    object: {
                        rootContainerIdentifier: (0, $2aFdM.parseRootContainerARI)(object.rootContainerId),
                        icon: $60eeb98ff0f0ced5$var$setIconHydration(object, hydratedData),
                        id: object.id,
                        deduplicateId: (0, $9vnYD.hydratedValueToString)(hydratedData.deduplicateId) || object.id,
                        localResourceId: (0, $9vnYD.hydratedValueToString)(hydratedData.localResourceId),
                        name: (0, $9vnYD.hydratedValueToString)(hydratedData.name, ' '),
                        displayName: product === 'assets' && (0, $ixfCV.fg)('cdm_display_name') ? (0, $9vnYD.hydratedValueToString)(hydratedData.displayName, ' ') : undefined,
                        product: product,
                        subProduct: object.subProduct,
                        type: object.type,
                        subtype: (0, $9vnYD.hydratedValueToString)(hydratedData.subtype) || object.data.subtype,
                        url: (0, $9vnYD.hydratedValueToString)(hydratedData.url),
                        objectTypeName: (0, $9vnYD.hydratedValueToString)(hydratedData.objectTypeName),
                        creator: (0, $9vnYD.hydratedValueToString)(hydratedData.creator),
                        providerId: (0, $9vnYD.hydratedValueToString)(hydratedData.providerId),
                        status: $60eeb98ff0f0ced5$var$setStatusHydration(hydratedData),
                        __typename: object.data.__typename
                    },
                    timestamp: event.timestamp
                });
            }
        }
        return acc;
    }, []);
}
module.exports["ActivityClientV3"] = $60eeb98ff0f0ced5$export$3c3c237c92ca1fb9;

});

parcelRegister("4vnKy", function(module, exports) {
class $7fa32eb1d6399f85$export$2d1b192199788179 extends Error {
    constructor(message){
        super(message);
        this.name = 'GraphQLFragmentError';
        this.message = message;
    }
}
module.exports["GraphQLFragmentError"] = $7fa32eb1d6399f85$export$2d1b192199788179;

});

parcelRegister("dN8zB", function(module, exports) {
class $606f617edf3be1cb$export$8d4af49ee2a0fbe2 extends Error {
    constructor(graphQLError){
        super(graphQLError.message);
        this.error = void 0;
        this.name = 'GraphQLJSError';
        this.error = graphQLError;
        this.message = graphQLError.message;
    }
}
module.exports["GraphQLJSError"] = $606f617edf3be1cb$export$8d4af49ee2a0fbe2;

});

parcelRegister("389Lj", function(module, exports) {
class $7e2b6bcb7f402b78$export$3f19ff30d409b70 extends Error {
    constructor(graphQLErrors){
        super();
        this.errors = void 0;
        this.errorMessages = void 0;
        this.name = 'GraphQLNoResultsError';
        this.errors = graphQLErrors;
        this.message = 'GraphQL returned errors & no results';
        this.errorMessages = graphQLErrors.map((error)=>error.message);
    }
}
module.exports["GraphQLNoResultsError"] = $7e2b6bcb7f402b78$export$3f19ff30d409b70;

});

parcelRegister("bBnDU", function(module, exports) {

var $6QC2Y = parcelRequire("6QC2Y");


var $6uL6y = parcelRequire("6uL6y");

const $79d7a50bad301f11$export$d658049bf1a63492 = (hydrators, data, captureException)=>{
    if (data) {
        if ('__typename' in data) {
            const hydrator = hydrators[data.__typename];
            if (hydrator) try {
                return $79d7a50bad301f11$var$hydrateData(data, hydrator);
            } catch (error) {
                captureException && captureException(new (0, $6uL6y.default)({
                    error: error,
                    message: `Hydrator failed for [${data.__typename}].`
                }));
            }
            else captureException && captureException(new (0, $6uL6y.default)({
                message: `Missing hydrator for [${data.__typename}].`
            }));
        } else captureException && captureException(new (0, $6uL6y.default)({
            message: `Missing [__typename] field from data.`
        }));
    }
    return null;
};
function $79d7a50bad301f11$var$getOrSearch(object, path) {
    if (!object) return object;
    if (path.includes(':')) {
        const [searchField, searchValue] = path.split(':');
        return $79d7a50bad301f11$var$findNodeByField(object, searchField.trim(), searchValue.trim().replace(/"/g, '') // Strip any preceding whitesepace and quotes
        );
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($6QC2Y)))(object, path);
}
function $79d7a50bad301f11$var$resolvePath(object, path) {
    // Split the path on each bracket
    const splitPath = path.split(/\(|\)./);
    // Traverse the split path as a tree, resolving as we go
    let current = object;
    for (const split of splitPath)current = $79d7a50bad301f11$var$getOrSearch(current, split);
    return current;
}
function $79d7a50bad301f11$var$findNodeByField(edges, fieldId, searchValue) {
    return edges.find((edge)=>(0, (/*@__PURE__*/$parcel$interopDefault($6QC2Y)))(edge, fieldId) === searchValue);
}
function $79d7a50bad301f11$export$a5c4301012ad6f07(object, paths) {
    return paths.map((path)=>$79d7a50bad301f11$var$resolvePath(object, path));
}
const $79d7a50bad301f11$var$hydrateData = (data, hydrator)=>{
    const { hydratorPaths: hydratorPaths, staticFallbacks: staticFallbacks } = hydrator;
    return {
        staticFallbacks: staticFallbacks,
        ...Object.entries(hydratorPaths).reduce((acc, [key, dataValue])=>{
            const item = $79d7a50bad301f11$export$a5c4301012ad6f07(data, dataValue);
            if (item) acc[key] = item;
            else throw new Error(`Bad hydrator path: ${key}`);
            return acc;
        }, {})
    };
};
module.exports["hydratePolymorphicData"] = $79d7a50bad301f11$export$d658049bf1a63492;

});

parcelRegister("6uL6y", function(module, exports) {
class $409b0e64cf76bdf6$export$2e2bcd8739ae039 extends Error {
    constructor({ error: error, message: message }){
        super();
        this.originalName = void 0;
        this.originalMessage = void 0;
        this.stack = void 0;
        const err = error instanceof Error ? error : new Error();
        this.name = 'HydratorError';
        this.message = message;
        this.originalMessage = err.message;
        this.stack = err.stack;
        this.originalName = err.name;
    }
}
module.exports["default"] = $409b0e64cf76bdf6$export$2e2bcd8739ae039;

});

parcelRegister("9vnYD", function(module, exports) {
const $8e8e08359d6f51e4$export$c5cea44a1f75b431 = (value, separator = '')=>{
    if (!value) return null;
    return Array.isArray(value) ? value.join(separator) : value;
};
function $8e8e08359d6f51e4$var$isURL(icon) {
    return typeof icon === 'string';
}
function $8e8e08359d6f51e4$var$isValidEmoji(icon) {
    return typeof icon === 'object' && icon.value !== undefined && !!icon.value;
}
const $8e8e08359d6f51e4$var$thirdPartyRegex = new RegExp('^ari:third-party:(\\S+)::(\\S+)\\/(\\S+)$');
const $8e8e08359d6f51e4$export$4578ef3572b21f34 = (ari)=>{
    const result = $8e8e08359d6f51e4$var$thirdPartyRegex.exec(ari);
    if (!result) throw new Error(`Invalid third party ARI. Use ${$8e8e08359d6f51e4$export$fccbae65febb6fd4.name} to check before calling this function.`);
    const [_, resourceOwner] = result;
    return resourceOwner;
};
const $8e8e08359d6f51e4$export$fccbae65febb6fd4 = (ari)=>$8e8e08359d6f51e4$var$thirdPartyRegex.test(ari);
const $8e8e08359d6f51e4$export$c60ec7b3c8b44fe1 = (product, icons, fallbacks, fallbackKey = 'icon')=>{
    if (fallbacks?.[fallbackKey] && product) {
        const thirdPartyLogo = fallbacks['thirdPartyIconPath']?.replace('{replaceProductName}', product) ?? fallbacks[fallbackKey];
        return {
            type: 'URL',
            value: thirdPartyLogo,
            fallbackIcon: fallbacks[fallbackKey]
        };
    }
    return $8e8e08359d6f51e4$export$a328b2bb0d21d984(icons, fallbacks);
};
const $8e8e08359d6f51e4$export$86b9f44277b105a6 = (confluenceContainerType, icons, fallbacks)=>{
    switch(confluenceContainerType){
        case 'ConfluenceBlogPost':
            return $8e8e08359d6f51e4$export$a328b2bb0d21d984(icons, fallbacks, 'confluenceBlogIcon') || $8e8e08359d6f51e4$export$a328b2bb0d21d984(icons, fallbacks);
        case 'ConfluencePage':
            return $8e8e08359d6f51e4$export$a328b2bb0d21d984(icons, fallbacks, 'confluencePageIcon') || $8e8e08359d6f51e4$export$a328b2bb0d21d984(icons, fallbacks);
        default:
            return $8e8e08359d6f51e4$export$a328b2bb0d21d984(icons, fallbacks);
    }
};
const $8e8e08359d6f51e4$export$a328b2bb0d21d984 = (icons, fallbacks, fallbackKey = 'icon')=>{
    if (Array.isArray(icons) && icons.length > 0) {
        const emojiIcons = icons.filter($8e8e08359d6f51e4$var$isValidEmoji);
        if (emojiIcons.length > 0) return {
            type: 'EMOJI',
            value: emojiIcons[0].value,
            // return the first emoji
            fallback: fallbacks?.[fallbackKey]
        };
        const urlIcons = icons.filter($8e8e08359d6f51e4$var$isURL);
        if (urlIcons.length > 0) {
            const hydratedIcons = $8e8e08359d6f51e4$export$c5cea44a1f75b431(urlIcons);
            if (hydratedIcons !== null) return {
                type: 'URL',
                value: hydratedIcons
            };
        }
    }
    if (fallbacks?.[fallbackKey]) return {
        type: 'URL',
        value: fallbacks[fallbackKey]
    };
    return null;
};
module.exports["hydratedValueToString"] = $8e8e08359d6f51e4$export$c5cea44a1f75b431;
module.exports["parseThirdPartyProduct"] = $8e8e08359d6f51e4$export$4578ef3572b21f34;
module.exports["isThirdPartyARI"] = $8e8e08359d6f51e4$export$fccbae65febb6fd4;
module.exports["hydrate3pIcon"] = $8e8e08359d6f51e4$export$c60ec7b3c8b44fe1;
module.exports["hydrateIcon"] = $8e8e08359d6f51e4$export$a328b2bb0d21d984;
module.exports["hydrateConfluenceIcon"] = $8e8e08359d6f51e4$export$86b9f44277b105a6;

});

parcelRegister("2YNjC", function(module, exports) {

var $hp074 = parcelRequire("hp074");


var $daPrQ = parcelRequire("daPrQ");

const $e9e5d234b62d5830$var$RECENT_WORK_ARTIFACT = 'recent-work-service';
const $e9e5d234b62d5830$var$FD_ENVIRONMENT = 'prod';
const $e9e5d234b62d5830$export$c270c412a04ff3e6 = {
    name: $e9e5d234b62d5830$var$RECENT_WORK_ARTIFACT,
    dimensions: {
        environmentType: $e9e5d234b62d5830$var$FD_ENVIRONMENT
    }
};
class $e9e5d234b62d5830$export$2e2bcd8739ae039 {
    async fetchArtifact() {
        if (this.artifactFetch) return 0, $daPrQ.default;
        // We're using the bundled artifact temporarily as FD caching is broken and does not expire for 365 days
        // https://atlassian.slack.com/archives/C01UV3QT21F/p1753393679628199
        return 0, $daPrQ.default;
    }
    constructor(handlers, product, artifactFetch){
        this.artifactFetch = artifactFetch;
        this.fetchConfig = async ()=>{
            const artifact = await this.fetchArtifact();
            const { queryFragments: fragments, hydrators: hydrators } = artifact;
            return {
                fragments: fragments,
                hydrators: hydrators
            };
        };
        new (0, $hp074.default)(product || 'recent-work-client', {
            handlers: handlers
        }, [
            {
                name: 'recent-work-service',
                dimensions: {
                    environmentType: $e9e5d234b62d5830$var$FD_ENVIRONMENT
                },
                value: (0, $daPrQ.default)
            }
        ]);
        this.artifactFetch = artifactFetch;
    }
}
module.exports["FD_CLIENT_FETCH_PROPS"] = $e9e5d234b62d5830$export$c270c412a04ff3e6;
module.exports["default"] = $e9e5d234b62d5830$export$2e2bcd8739ae039;

});

parcelRegister("hp074", function(module, exports) {

var $ccS36 = parcelRequire("ccS36");


var $aotCl = parcelRequire("aotCl");


var $6YrB3 = parcelRequire("6YrB3");


var $5zSfh = parcelRequire("5zSfh");

var $4fKuX = parcelRequire("4fKuX");


var $gdsgI = parcelRequire("gdsgI");


var $2yexq = parcelRequire("2yexq");


var $jAdLj = parcelRequire("jAdLj");

function $cab4dbef42072eb7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cab4dbef42072eb7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cab4dbef42072eb7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $ccS36.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cab4dbef42072eb7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $cab4dbef42072eb7$var$STORAGE_KEY_BASE = "@atlassiansox/flight-deck-frontend-client";
const $cab4dbef42072eb7$var$RETRIABLE_FD_ERROR_MESSAGES = [
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "Load failed"
];
class $cab4dbef42072eb7$export$2e2bcd8739ae039 {
    captureException(e, tags) {
        if (this.handlers.captureException) this.handlers.captureException(e, tags);
    }
    async fetchAndCacheArtifact(artifact, retryConfig) {
        const response = await (0, $aotCl.retryOnException)(async ()=>{
            try {
                // await the result here so that we capture any errors
                const result = await (0, $5zSfh.fetchFlightDeckConfiguration)(artifact.name, artifact.dimensions);
                return result;
            } catch (error) {
                throw new (0, $gdsgI.default)({
                    artifact: artifact.key,
                    dimensions: artifact.dimensions,
                    error: error
                });
            }
        }, {
            captureException: this.captureException,
            retryOn: (err)=>$cab4dbef42072eb7$var$RETRIABLE_FD_ERROR_MESSAGES.includes(err.message),
            intervalsMS: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.intervalsMS,
            onRetry: retryConfig === null || retryConfig === void 0 ? void 0 : retryConfig.onRetry
        });
        if (!response) {
            const missingArtifactError = new Error(`Missing artifact: ${artifact.key}`);
            this.captureException(missingArtifactError);
            throw missingArtifactError;
        }
        this.storageClient.setItemWithExpiry(artifact.key, response, this.expiryMS);
        // Clear the in-flight check
        this.fetchFromFlightDeckPromises.delete(artifact.key);
        return response;
    }
    async fetchArtifactPromise(artifact, retryConfig) {
        // Check for in-flight requests for this artifact
        if (this.fetchFromFlightDeckPromises.has(artifact.key)) return this.fetchFromFlightDeckPromises.get(artifact.key);
        const fetchPromise = this.fetchAndCacheArtifact(artifact, retryConfig);
        this.fetchFromFlightDeckPromises.set(artifact.key, fetchPromise);
        return fetchPromise;
    }
    async fetchConfigFromFlightDeck(artifact, retryConfig) {
        const experience = Math.random() < 0.001 ? (0, $jAdLj.flightDeckClientExperience)() : new (0, $4fKuX.MockExperience)();
        experience.start();
        try {
            const artifactWithKey = $cab4dbef42072eb7$var$_objectSpread($cab4dbef42072eb7$var$_objectSpread({}, artifact), {}, {
                key: (0, $2yexq.artifactKey)(artifact.name, artifact.dimensions)
            });
            experience.addMetadata({
                key: artifactWithKey.key,
                product: this.product
            });
            // Create the promise to fetch the config, we only need to await this if we don't have local config
            const artifactPromise = this.fetchArtifactPromise(artifactWithKey, retryConfig);
            // Check local storage for the artifact
            const localConfig = this.storageClient.getItem(artifactWithKey.key);
            if (localConfig) {
                experience.addMetadata({
                    configSource: "localStorage"
                });
                return localConfig;
            }
            // Was a fallback config provided?
            if (this.fallbackArtifactMap.has(artifactWithKey.key)) {
                experience.addMetadata({
                    configSource: "fallback"
                });
                return this.fallbackArtifactMap.get(artifactWithKey.key);
            }
            experience.addMetadata({
                configSource: "fetch"
            });
            // No local copies of config, await FD fetch promise here so that we can capture any errors & fail the experience
            const result = await artifactPromise;
            return result;
        } catch (e) {
            experience.failure({
                metadata: {
                    error: (0, $jAdLj.exceptionToMetadata)(e)
                }
            });
            throw e;
        } finally{
            // if the experience has been failed in the "catch" block, calling "success" will have no effect
            experience.success();
        }
    }
    constructor(product, options = {
        handlers: {}
    }, fallbackArtifacts = []){
        (0, $ccS36.default)(this, "fallbackArtifactMap", new Map());
        (0, $ccS36.default)(this, "fetchFromFlightDeckPromises", new Map());
        this.expiryMS = options.expiryMS;
        this.handlers = options.handlers;
        this.product = product;
        this.storageClient = new (0, $6YrB3.default)($cab4dbef42072eb7$var$STORAGE_KEY_BASE, options);
        fallbackArtifacts.forEach((artifact)=>this.fallbackArtifactMap.set((0, $2yexq.artifactKey)(artifact.name, artifact.dimensions), artifact.value));
        this.captureException = this.captureException.bind(this);
    }
}
module.exports["default"] = $cab4dbef42072eb7$export$2e2bcd8739ae039;

});

parcelRegister("6YrB3", function(module, exports) {

var $fmV2n = parcelRequire("fmV2n");

const $293056f9068f55f6$var$DEFAULT_STORAGE_ENGINE = 'localStorage';
class $293056f9068f55f6$export$2e2bcd8739ae039 {
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
    constructor(clientKey, options){
        this.client = void 0;
        this.clientKey = void 0;
        this.handlers = void 0;
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
                return undefined; // Return undefined on parsing error
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || $293056f9068f55f6$var$DEFAULT_STORAGE_ENGINE;
        if (typeof window === 'undefined' || !Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $fmV2n.mockWindowStorage)([
            storageEngine
        ]);
        // Get window reference after mockWindowStorage has potentially created it
        const windowRef = typeof window !== 'undefined' ? window : $parcel$global.window;
        this.client = windowRef[storageEngine];
    }
}
module.exports["default"] = $293056f9068f55f6$export$2e2bcd8739ae039;

});

parcelRegister("fmV2n", function(module, exports) {
/**
 * This can be used to mock local storage for Edge and other browsers
 * that have disabled local storage setting
 */ const $a61ea4cfed034b37$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        const keys = Object.keys(this._data);
        return keys[index] || null;
    }
};
const $a61ea4cfed034b37$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    // Handle SSR environment where window is undefined
    let windowRef;
    let replacedWindowRef = false;
    if (typeof window === 'undefined') {
        // Ensure global exists and create window if needed
        if (typeof $parcel$global !== 'undefined') {
            $parcel$global.window = $parcel$global.window || {};
            windowRef = $parcel$global.window;
        } else {
            // Fallback for environments where global might not exist
            windowRef = {};
            replacedWindowRef = true;
        }
    } else windowRef = window;
    // Ensure windowRef is always defined and is an object
    if (!windowRef || typeof windowRef !== 'object') {
        windowRef = {};
        replacedWindowRef = true;
    }
    // If we had to replace the window reference, reflect it back to global.window
    if (replacedWindowRef && typeof $parcel$global !== 'undefined') $parcel$global.window = windowRef;
    for (const storageToMockElement of storageToMock)Object.defineProperty(windowRef, storageToMockElement, {
        value: {
            ...$a61ea4cfed034b37$export$c65e688d8b365035
        },
        configurable: true,
        writable: true
    });
};
module.exports["mockWindowStorage"] = $a61ea4cfed034b37$export$efebfe7859cae3c7;

});

parcelRegister("5zSfh", function(module, exports) {

var $cUcPn = parcelRequire("cUcPn");


var $aeWVV = parcelRequire("aeWVV");


var $8aTXy = parcelRequire("8aTXy");


var $bMJ95 = parcelRequire("bMJ95");


var $bQyPO = parcelRequire("bQyPO");


var $4fKuX = parcelRequire("4fKuX");


var $9SlG7 = parcelRequire("9SlG7");

/**
 * Arguments for passing in dimensions that the artifact might vary on.
 * For more details see: https://developer.atlassian.com/platform/flight-deck/getting-your-capability-onto-flight-deck/dimensions/
 */ /**
 * default to using prod instance since artifacts that don't depend on environment should be using the prod instance.
 */ const $40fa4ca95a1436e3$var$defaultEnvType = "prod";
/**
 * default to using commercial instance.
 */ const $40fa4ca95a1436e3$var$defaultPerimeter = "commercial";
async function $40fa4ca95a1436e3$export$6026918e023c9101(artifactName, dim = {}) {
    var _dim$environmentType, _dim$perimeter, _dim$impactLevel;
    const environmentType = (_dim$environmentType = dim.environmentType) !== null && _dim$environmentType !== void 0 ? _dim$environmentType : $40fa4ca95a1436e3$var$defaultEnvType;
    const perimeter = (_dim$perimeter = dim.perimeter) !== null && _dim$perimeter !== void 0 ? _dim$perimeter : $40fa4ca95a1436e3$var$defaultPerimeter;
    // Needed for backwards compatibility with Flight Deck core, reference perimeter
    const impactLevel = (_dim$impactLevel = dim.impactLevel) !== null && _dim$impactLevel !== void 0 ? _dim$impactLevel : perimeter;
    const environment = $40fa4ca95a1436e3$var$getEnvFromEnvType(environmentType);
    const locale = dim.locale && (0, $cUcPn.default)(dim.locale);
    const artifactDimensions = {
        perimeter: perimeter,
        impactLevel: impactLevel,
        environment: environment,
        locale: locale
    };
    const client = await $40fa4ca95a1436e3$var$getConfigClient(environmentType, perimeter);
    return client.getArtifact(artifactName, artifactDimensions);
}
async function $40fa4ca95a1436e3$export$4abbe3ae0811355(dim = {}) {
    var _dim$environmentType2, _dim$perimeter2;
    const client = await $40fa4ca95a1436e3$var$getConfigClient((_dim$environmentType2 = dim.environmentType) !== null && _dim$environmentType2 !== void 0 ? _dim$environmentType2 : $40fa4ca95a1436e3$var$defaultEnvType, (_dim$perimeter2 = dim.perimeter) !== null && _dim$perimeter2 !== void 0 ? _dim$perimeter2 : $40fa4ca95a1436e3$var$defaultPerimeter);
    return client.getLatestVersionMetadata();
}
async function $40fa4ca95a1436e3$var$getConfigClient(env, perimeter) {
    const fetchArtifactExperience = await (0, $4fKuX.getFlightDeckFetchExperience)();
    const fetchVersionMetadataExperience = await (0, $4fKuX.getVersionMetadataFetchExperience)();
    return new (0, $bQyPO.ConfigClient)(new (0, $8aTXy.BifrostDataSource)(new (0, $bMJ95.BifrostHttpClientImpl)(env, perimeter), (0, $aeWVV.Versions).ManifestVersion), "Bifrost", fetchArtifactExperience, fetchVersionMetadataExperience);
}
/**
 *
 * This function is necessary since all artifacts are tagged using an environment,
 * so to get an artifact we need to specify an environment. However, users only
 * specify an environmentType since that's all that matters to them. Flight Deck
 * ensures that frontend artifacts don't vary based on region so this is safe to do.
 *
 * @param environmentDependentDimensions
 * @returns a specific environment that has that envtype
 */ function $40fa4ca95a1436e3$var$getEnvFromEnvType(environment) {
    if (environment === undefined || environment === "prod") return "prod-west";
    switch(environment){
        case "stg":
            return "stg-west";
        case "adev":
            return "adev";
        case "ddev":
            return "ddev";
        case "pdev":
            return "pdev-apse2";
        case "fedex":
            return "stg-apse";
    }
}
module.exports["fetchFlightDeckConfiguration"] = $40fa4ca95a1436e3$export$6026918e023c9101;

});

parcelRegister("cUcPn", function(module, exports) {
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $cfc2cb470fbdc4fd$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $cfc2cb470fbdc4fd$export$2e2bcd8739ae039 = $cfc2cb470fbdc4fd$export$852ff24d0930c62f;
module.exports["default"] = $cfc2cb470fbdc4fd$export$2e2bcd8739ae039;

});

parcelRegister("aeWVV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = module.exports.ConfigRegistryDataSource = module.exports.checkManifest = module.exports.parseVersionMetadata = module.exports.parseArtifactManifest = module.exports.tryGetArtifactData = module.exports.getArtifactFromSource = module.exports.Either = void 0;

var $7eeoB = parcelRequire("7eeoB");

Object.defineProperty(module.exports, "Either", {
    enumerable: true,
    get: function() {
        return $7eeoB.Either;
    }
});

var $jQrBD = parcelRequire("jQrBD");

Object.defineProperty(module.exports, "getArtifactFromSource", {
    enumerable: true,
    get: function() {
        return $jQrBD.getArtifactFromSource;
    }
});
Object.defineProperty(module.exports, "tryGetArtifactData", {
    enumerable: true,
    get: function() {
        return $jQrBD.tryGetArtifactData;
    }
});

var $dyTdO = parcelRequire("dyTdO");

Object.defineProperty(module.exports, "parseArtifactManifest", {
    enumerable: true,
    get: function() {
        return $dyTdO.parseArtifactManifest;
    }
});

var $gjGlh = parcelRequire("gjGlh");

Object.defineProperty(module.exports, "parseVersionMetadata", {
    enumerable: true,
    get: function() {
        return $gjGlh.parseVersionMetadata;
    }
});

var $gT9Gg = parcelRequire("gT9Gg");

Object.defineProperty(module.exports, "checkManifest", {
    enumerable: true,
    get: function() {
        return $gT9Gg.checkManifest;
    }
});

var $guUcw = parcelRequire("guUcw");

Object.defineProperty(module.exports, "ConfigRegistryDataSource", {
    enumerable: true,
    get: function() {
        return $guUcw.ConfigRegistryDataSource;
    }
});

var $k5C8f = parcelRequire("k5C8f");

Object.defineProperty(module.exports, "BaseUrls", {
    enumerable: true,
    get: function() {
        return $k5C8f.BaseUrls;
    }
});
Object.defineProperty(module.exports, "Versions", {
    enumerable: true,
    get: function() {
        return $k5C8f.Versions;
    }
});

});

parcelRegister("7eeoB", function(module, exports) {
"use strict";
var $543501ed1db8f46e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Either = void 0;
var $543501ed1db8f46e$var$Either = /** @class */ function() {
    function Either() {}
    Either.prototype.map = function(f) {
        return this.flatMap(function(a) {
            return Either.right(f(a));
        });
    };
    Either.right = function(value) {
        return new $543501ed1db8f46e$var$Right(value);
    };
    Either.left = function(error) {
        return new $543501ed1db8f46e$var$Left(error);
    };
    return Either;
}();
module.exports.Either = $543501ed1db8f46e$var$Either;
var $543501ed1db8f46e$var$Right = /** @class */ function(_super) {
    $543501ed1db8f46e$var$__extends(Right, _super);
    function Right(r) {
        var _this = _super.call(this) || this;
        _this.right = r;
        return _this;
    }
    Right.prototype.bimap = function(_f, g) {
        return $543501ed1db8f46e$var$Either.right(g(this.right));
    };
    Right.prototype.flatMap = function(f) {
        return f(this.right);
    };
    Right.prototype.fold = function(_onLeft, onRight) {
        return onRight(this.right);
    };
    Right.prototype.leftMap = function(_f) {
        return $543501ed1db8f46e$var$Either.right(this.right);
    };
    return Right;
}($543501ed1db8f46e$var$Either);
var $543501ed1db8f46e$var$Left = /** @class */ function(_super) {
    $543501ed1db8f46e$var$__extends(Left, _super);
    function Left(e) {
        var _this = _super.call(this) || this;
        _this.left = e;
        return _this;
    }
    Left.prototype.bimap = function(f, _g) {
        return $543501ed1db8f46e$var$Either.left(f(this.left));
    };
    Left.prototype.flatMap = function(_f) {
        return $543501ed1db8f46e$var$Either.left(this.left);
    };
    Left.prototype.fold = function(onLeft, _onRight) {
        return onLeft(this.left);
    };
    Left.prototype.leftMap = function(f) {
        return $543501ed1db8f46e$var$Either.left(f(this.left));
    };
    return Left;
}($543501ed1db8f46e$var$Either);

});

parcelRegister("jQrBD", function(module, exports) {
"use strict";
var $e728499c70b77bcb$var$__assign = module.exports && module.exports.__assign || function() {
    $e728499c70b77bcb$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e728499c70b77bcb$var$__assign.apply(this, arguments);
};
var $e728499c70b77bcb$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e728499c70b77bcb$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getArtifactFromSource = $e728499c70b77bcb$var$getArtifactFromSource;
module.exports.tryGetArtifactData = $e728499c70b77bcb$var$tryGetArtifactData;

var $jgJJ5 = parcelRequire("jgJJ5");


var $aeWVV = parcelRequire("aeWVV");


var $cMB7J = parcelRequire("cMB7J");


var $2zHJj = parcelRequire("2zHJj");


var $hXkGE = parcelRequire("hXkGE");

function $e728499c70b77bcb$var$getArtifactFromSource(dataSource, specifiedDimensions, deniedArtifactType) {
    return $e728499c70b77bcb$var$__awaiter(this, void 0, void 0, function() {
        var manifestResult;
        var _this = this;
        return $e728499c70b77bcb$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        dataSource.getManifest(specifiedDimensions.name, specifiedDimensions.version)
                    ];
                case 1:
                    manifestResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        manifestResult.fold(function(error) {
                            return Promise.resolve({
                                type: "manifest-fetch-error",
                                error: error
                            });
                        }, function(manifest) {
                            return $e728499c70b77bcb$var$__awaiter(_this, void 0, void 0, function() {
                                var manifestCheckResult, publishMetadata, dimensionContextResult;
                                return $e728499c70b77bcb$var$__generator(this, function(_a) {
                                    manifestCheckResult = (0, $aeWVV.checkManifest)(manifest, {
                                        name: specifiedDimensions.name,
                                        version: specifiedDimensions.version
                                    });
                                    if (manifestCheckResult.key !== "success") return [
                                        2 /*return*/ ,
                                        {
                                            type: manifestCheckResult.key
                                        }
                                    ];
                                    publishMetadata = manifest.publishMetadata;
                                    if (manifest.frontend && deniedArtifactType === "frontend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "frontend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    else if (!manifest.frontend && deniedArtifactType === "backend") return [
                                        2 /*return*/ ,
                                        {
                                            type: "denied-artifact-type",
                                            deniedType: "backend",
                                            publishMetadata: publishMetadata
                                        }
                                    ];
                                    dimensionContextResult = (0, $cMB7J.getDimensionContext)(specifiedDimensions, manifest);
                                    switch(dimensionContextResult.type){
                                        case "missing-dimension-specification":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "missing-dimension-specification",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "unsupported-value-specified-for-supported-dimension":
                                            return [
                                                2 /*return*/ ,
                                                {
                                                    type: "unsupported-value-specified-for-supported-dimension",
                                                    publishMetadata: publishMetadata
                                                }
                                            ];
                                        case "success":
                                            return [
                                                2 /*return*/ ,
                                                $e728499c70b77bcb$var$getArtifact(dataSource, manifest, dimensionContextResult.dimensionContext)
                                            ];
                                        default:
                                            (0, $2zHJj.assertUnreachable)(dimensionContextResult);
                                    }
                                    return [
                                        2 /*return*/ 
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $e728499c70b77bcb$var$getArtifact(dataSource, manifest, dimensionContext) {
    return $e728499c70b77bcb$var$__awaiter(this, void 0, void 0, function() {
        var publishMetadata, tag, artifactResult;
        var _this = this;
        return $e728499c70b77bcb$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    publishMetadata = manifest.publishMetadata;
                    try {
                        tag = (0, $jgJJ5.interpolateTagScheme)(manifest.tagScheme, $e728499c70b77bcb$var$__assign($e728499c70b77bcb$var$__assign({}, dimensionContext), {
                            name: manifest.name
                        }));
                    } catch (e) {
                        return [
                            2 /*return*/ ,
                            {
                                type: "tag-scheme-interpolation-error",
                                publishMetadata: publishMetadata
                            }
                        ];
                    }
                    return [
                        4 /*yield*/ ,
                        dataSource.getArtifact(manifest.name, tag)
                    ];
                case 1:
                    artifactResult = _a.sent();
                    return [
                        2 /*return*/ ,
                        artifactResult.fold(function(error) {
                            return Promise.resolve({
                                type: "artifact-fetch-error",
                                error: error,
                                publishMetadata: publishMetadata
                            });
                        }, function(data) {
                            return $e728499c70b77bcb$var$__awaiter(_this, void 0, void 0, function() {
                                return $e728499c70b77bcb$var$__generator(this, function(_a) {
                                    return [
                                        2 /*return*/ ,
                                        {
                                            type: "success",
                                            data: data,
                                            publishMetadata: publishMetadata,
                                            artifactVersion: dimensionContext["version"]
                                        }
                                    ];
                                });
                            });
                        })
                    ];
            }
        });
    });
}
function $e728499c70b77bcb$var$tryGetArtifactData(artifact, dataSourceName) {
    switch(artifact.type){
        case "manifest-fetch-error":
            throw new Error("Unable to fetch manifest due to ".concat(dataSourceName, " response error: ").concat((0, $hXkGE.toPrettyJson)(artifact.error)));
        case "artifact-fetch-error":
            throw new Error("Unable to fetch artifact due to ".concat(dataSourceName, " response error: ").concat((0, $hXkGE.toPrettyJson)(artifact.error)));
        case "denied-artifact-type":
            throw new Error("No artifacts should be denied, but type ".concat(artifact.deniedType, " was denied."));
        case "unsupported-value-specified-for-supported-dimension":
            throw new Error("An unsupported value was specified for a supported dimension");
        case "missing-dimension-specification":
            throw new Error("A required dimension specification was missing");
        case "tag-scheme-interpolation-error":
            throw new Error("Ran into failure when trying to interpolate tag scheme");
        case "mismatched-manifest-name":
            throw new Error("Manifest has been corrupted. Manifest name is mismatched.");
        case "mismatched-manifest-version":
            throw new Error("Manifest has been corrupted. Manifest version is mismatched.");
        case "success":
            return artifact.data;
        default:
            (0, $2zHJj.assertUnreachable)(artifact);
    }
}

});

parcelRegister("jgJJ5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTagScheme = $e072fb35963a4646$var$interpolateTagScheme;
module.exports.generateTagScheme = $e072fb35963a4646$var$generateTagScheme;
module.exports.getDimensionsFromTagScheme = $e072fb35963a4646$var$getDimensionsFromTagScheme;
module.exports.getDataTagForManifest = $e072fb35963a4646$var$getDataTagForManifest;
module.exports.getVersionMetadataTag = $e072fb35963a4646$var$getVersionMetadataTag;
const $e072fb35963a4646$var$TAG_SCHEME_VERSION = 2;
function $e072fb35963a4646$var$interpolateTagScheme(tagSchema, context) {
    const dimensions = Array.from($e072fb35963a4646$var$getDimensionsFromTagScheme(tagSchema));
    return dimensions.reduce((interpolatedTagScheme, dimension)=>{
        if (context.hasOwnProperty(dimension)) return interpolatedTagScheme.replace(new RegExp(`\\$${dimension}\\$`, "g"), context[dimension]);
        else {
            const contextAsJson = $e072fb35963a4646$var$toPrettyJson(context);
            throw new Error(`Bad variable "${dimension}" found enclosed in '$', so cannot infer
                     filename for artifact from tag schema: was expecting that
                     '${dimension}' would be a known dimension passed in context. This
                     is most likely a bug in Flight Deck. To help you debug, the Context
                     received was:\n"${contextAsJson}"\nOne of the keys in that object should
                     have been '${contextAsJson}'.`);
        }
    }, tagSchema);
}
/**
 *
 * @param dimensions - the dimensions that this tag scheme needs to use
 *
 * @param supportedDimensionPrefixes - a map of those dimensions to
 * shortened versions (ie name to n)
 *
 *  @param effectiveContextDimension - maps dimensions down into dimensions supported
 *  by original context. NOTE:
 *
 *  There is only 1 correct implementation of this function, but
 *  it is not defined in this module because the most typesafe
 *  (least error prone) definition of this function requires referencing
 *  the specific dimension types (specific available dimensions), and
 *  we are intentionally keeping this module unaware of the specific
 *  dimensions to enable adding/changing dimensions easily in consumers
 *  which use this tags library. So therefore we define effectiveContextDimension
 *  outside of this package, but accept it as an argument. Note that in this
 *  package we redefine the meaning of common Flight Deck types (e.g.
 *  Dimension == string, rather than the specific subset of supported
 *  dimension strings), so when generateTagScheme is called then effectiveContextDimension
 *  needs to be cast (using `as`) in order to have the types
 *
 * @returns a generated schema
 */ function $e072fb35963a4646$var$generateTagScheme(dimensions, supportedDimensionPrefixes, effectiveContextDimension = (d)=>d) {
    const effectiveDimensions = new Set([
        ...dimensions
    ].map(effectiveContextDimension));
    for (const dimensionToInclude of effectiveDimensions){
        if (!supportedDimensionPrefixes.has(effectiveContextDimension(dimensionToInclude))) throw new Error([
            `Building a tag scheme failed! The dimension '${dimensionToInclude}' is not `,
            `recognized as a dimension (known dimensions are ${[
                ...supportedDimensionPrefixes.keys()
            ].join(", ")}!`
        ].join(" "));
    }
    // pad the version number to 3 digits (e.g. 001, 002, 003, etc) so that artifacts will sort by
    // version when sorted lexicographically (helpful for debugging)
    const padded_version = $e072fb35963a4646$var$TAG_SCHEME_VERSION.toString().padStart(3, "0");
    // IMPORTANT! Update {@link TAG_SCHEME_VERSION} if you change the tagging scheme logic!
    let tagScheme = `v${padded_version}`;
    for (const entry of supportedDimensionPrefixes.entries()){
        const [dimension, prefix] = entry;
        if (effectiveDimensions.has(dimension)) // We avoid using `:` or `/` or `\` as separator characters because these characters have
        // meaning on certain filesystems that make them painful to work with; we also don't use
        // ` ` or similar because whitespace characters are the default values used by shells
        // to word-split, which makes scripting harder (see https://bash.cyberciti.biz/guide/$IFS ).
        tagScheme += `-${prefix}_$${dimension}$`;
    }
    return tagScheme;
}
// Important! Context: Front end client will be using old version of tags.When we make changes to this function
// we need to be extra cautious that it will be compatible with older versions
// Step -1
// we have test in frontend package :integration-test/frontend/frontend-fetch.spec.ts to test oldest front end client
// make sure we add sample artifact to the test which will test newest functionality against oldest client
// Step-2
// Update manifest version across flight-deck
// step-3
// update manifest version in poop-deck repo
// step-4
// communicate with external customers and #flight-deck channel announcements
// step-5
// Update oldest supported version in integration-test/frontend/frontend-fetch.spec.ts and the test will be passed
function $e072fb35963a4646$var$getDimensionsFromTagScheme(tagSchema) {
    // regex to get all dimensions
    // for a dimension:
    // \$ means the expression starts with a `$` sign
    // [A-Za-z]+ means dollar sign is followed by one or more alphabetical chars
    // \$ means the dimension ends with a `$` sign
    const dimensionsFormat = /\$([A-Za-z]+)\$/g;
    // regex to ensure that we have the right format
    // for the dimension format:
    // ^v means it must start with a v
    // \d{3} means it is followed by three digits
    // ?: tries to match the expression without capturing the group
    // -[a-z]_ means expression starts with `-<single lowercase a-z char>_`
    // (\$[A-Za-z]+\$) defines that a dimension is in the format `<one or more alphabetical chars>` and this group is captured.
    // + means we could have one or more dimensions.
    // $ means we must end at the end of a dimension.
    const tagSchemeFormat = /^v\d{3}(?:-[a-z]_(\$[A-Za-z]+\$))+$/;
    const isValidTag = tagSchemeFormat.test(tagSchema);
    if (!isValidTag) throw new Error(`The provided tag scheme: "${tagSchema}" is invalid.
                Tag schemes must have the following format:
                v<3 digit number>-<letter>$<dimension_name>$
                where -<letter>$<dimension_name>$ can be repeated
                and all characters of <letter> and <dimension_name>
                must be alphabetical characters
                e.g "v001-n_$name$-d_$dimension$" is a valid tag scheme`);
    const allDim = Array.from(tagSchema.matchAll(dimensionsFormat));
    try {
        // Grab the second element of each element in matches
        const captures = allDim.map(([_, capture])=>capture);
        const dimensions = new Set(captures);
        return dimensions;
    } catch (e) {
        throw new Error(`Could not capture dimensions. Expected dimension format to look like 
             ${dimensionsFormat}`);
    }
}
function $e072fb35963a4646$var$getDataTagForManifest(artifactName, manifestVersion, artifactVersion) {
    return artifactVersion === undefined ? `${artifactName}_manifest_${manifestVersion}` : `${artifactName}_${artifactVersion}_manifest_${manifestVersion}`;
}
function $e072fb35963a4646$var$getVersionMetadataTag(version) {
    return version ? `version_metadata_${version}` : "version_metadata";
}
function $e072fb35963a4646$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});

parcelRegister("cMB7J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDimensionContext = $94e6c3b42757e5ce$var$getDimensionContext;
/**
 * Resolves a record of Dimensions and their values based on the manifest
 * and the user specified dimensions values.
 *
 * If a dimension is not specified by the user, then the fallback value
 * will be used as the value for that dimension. If the fallback value
 * does not exist in this case, then a "missing-dimension-specification"
 * result will be reported.
 *
 * If a dimension value specified by the user is not part of the list
 * of supported values, then the dimension value will be the fallback
 * value defined. If a fallback value does not exist for that dimension,
 * then an "unsupported-value-specified-for-supported-dimension" result
 * will be reported.
 *
 * Otherwise, a "success" result will be reported on a valid context
 * resolution.
 *
 * @param specifiedDimensions the dimensions the user specified
 * @param manifest the manifest to validate and fallback user specifications
 * @returns a record of Dimensions and their valid values, or an error type
 *      if a record of valid values could not be derived from the user input
 */ function $94e6c3b42757e5ce$var$getDimensionContext(specifiedDimensions, manifest) {
    var dimensionToValues = {};
    for(var dimension in manifest.dimensions){
        var manifestDimensionSpecs = manifest.dimensions[dimension];
        var dimensionValue = specifiedDimensions[dimension];
        var fallback = manifestDimensionSpecs.fallback;
        if (dimensionValue === undefined) {
            if (fallback === undefined) return {
                type: "missing-dimension-specification"
            };
            else dimensionValue = fallback;
        }
        if (!manifestDimensionSpecs.supported.includes(dimensionValue)) {
            if (fallback === undefined) return {
                type: "unsupported-value-specified-for-supported-dimension"
            };
            else dimensionValue = fallback;
        }
        dimensionToValues[dimension] = dimensionValue;
    }
    return {
        type: "success",
        dimensionContext: dimensionToValues
    };
}

});

parcelRegister("2zHJj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertUnreachable = $1e00c5830a29dfbb$var$assertUnreachable;
function $1e00c5830a29dfbb$var$assertUnreachable(_x) {
    throw new Error("This function should never be called. This is for yielding compile errors on non-exhaustive case checking.");
}

});

parcelRegister("hXkGE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toJson = $d127fe55f4fdd4b4$var$toJson;
module.exports.toPrettyJson = $d127fe55f4fdd4b4$var$toPrettyJson;
function $d127fe55f4fdd4b4$var$toJson(buffer) {
    return JSON.parse(buffer.toString());
}
function $d127fe55f4fdd4b4$var$toPrettyJson(obj) {
    return JSON.stringify(obj, null, 2);
}

});

parcelRegister("dyTdO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseArtifactManifest = $9df9493c8454073d$var$parseArtifactManifest;

var $ly54O = parcelRequire("ly54O");

function $9df9493c8454073d$var$parseMetricTags(metricTags) {
    var unparsedMetricTags = (0, $ly54O.parseUnknownObject)(metricTags);
    var parsedMetricTags = {};
    for(var _i = 0, _a = Object.keys(unparsedMetricTags); _i < _a.length; _i++){
        var key = _a[_i];
        var tag = (0, $ly54O.parseString)(unparsedMetricTags[key]);
        parsedMetricTags[key] = tag;
    }
    return parsedMetricTags;
}
function $9df9493c8454073d$var$parsePublishMetadata(publishMetadata) {
    var unparsedPublishMetadata = (0, $ly54O.parseUnknownObject)(publishMetadata);
    var metricTags = "metricTags" in unparsedPublishMetadata ? $9df9493c8454073d$var$parseMetricTags(unparsedPublishMetadata.metricTags) : undefined;
    return {
        metricTags: metricTags
    };
}
function $9df9493c8454073d$var$parseDimensions(dimensions) {
    var unparsedDimensions = (0, $ly54O.parseUnknownObject)(dimensions);
    var supported = (0, $ly54O.parseArray)(unparsedDimensions.supported).map($ly54O.parseString);
    var fallback = (0, $ly54O.parseUndefinedOr)($ly54O.parseString, unparsedDimensions.fallback);
    return {
        fallback: fallback,
        supported: supported
    };
}
function $9df9493c8454073d$var$parseDimensionsRecord(dimensionRecord) {
    var parsedDimensionRecord = {};
    var unparsedDimensionRecord = (0, $ly54O.parseUnknownObject)(dimensionRecord);
    for(var _i = 0, _a = Object.keys(unparsedDimensionRecord); _i < _a.length; _i++){
        var key = _a[_i];
        var dimensionsSpec = $9df9493c8454073d$var$parseDimensions(unparsedDimensionRecord[key]);
        parsedDimensionRecord[key] = dimensionsSpec;
    }
    return parsedDimensionRecord;
}
function $9df9493c8454073d$var$parseArtifactManifest(potentialArtifactManifest) {
    var unparsedArtifactManifest = (0, $ly54O.parseUnknownObject)(potentialArtifactManifest);
    var name = (0, $ly54O.parseString)(unparsedArtifactManifest.name);
    var tagScheme = (0, $ly54O.parseString)(unparsedArtifactManifest.tagScheme);
    var frontend = (0, $ly54O.parseUndefinedOr)($ly54O.parseBoolean, unparsedArtifactManifest.frontend);
    var dimensions = $9df9493c8454073d$var$parseDimensionsRecord(unparsedArtifactManifest.dimensions);
    var publishMetadata = $9df9493c8454073d$var$parsePublishMetadata(unparsedArtifactManifest.publishMetadata);
    return {
        name: name,
        frontend: frontend,
        tagScheme: tagScheme,
        dimensions: dimensions,
        publishMetadata: publishMetadata
    };
}

});

parcelRegister("ly54O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseString = $fb00b60bef1337cc$var$parseString;
module.exports.parseArray = $fb00b60bef1337cc$var$parseArray;
module.exports.parseBoolean = $fb00b60bef1337cc$var$parseBoolean;
module.exports.parseUnknownObject = $fb00b60bef1337cc$var$parseUnknownObject;
module.exports.parseUndefinedOr = $fb00b60bef1337cc$var$parseUndefinedOr;
function $fb00b60bef1337cc$var$parseString(string) {
    if (typeof string === "string") return string;
    throw new Error("Couldn't parse String");
}
function $fb00b60bef1337cc$var$parseArray(array) {
    if (Array.isArray(array)) return array;
    throw new Error("Couldn't parse List or Undefined");
}
function $fb00b60bef1337cc$var$parseBoolean(boolean) {
    if (typeof boolean === "boolean") return boolean;
    throw new Error("Couldn't parse Boolean or undefined");
}
function $fb00b60bef1337cc$var$parseUnknownObject(object) {
    if (typeof object === "object") return object;
    throw new Error("Couldn't parse object");
}
function $fb00b60bef1337cc$var$parseUndefinedOr(parse, thing) {
    if (typeof thing === "undefined") return thing;
    else return parse(thing);
}

});

parcelRegister("gjGlh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseVersionMetadata = $be0f43fd800fa9b6$var$parseVersionMetadata;

var $ly54O = parcelRequire("ly54O");

function $be0f43fd800fa9b6$var$parseVersionMetadata(possiblyVersionMetadata) {
    var unknownObject = (0, $ly54O.parseUnknownObject)(possiblyVersionMetadata);
    var version = (0, $ly54O.parseString)(unknownObject.version);
    var publishTime = new Date((0, $ly54O.parseString)(unknownObject.publishTime));
    var sidecarImageDigestVersion = (0, $ly54O.parseString)(unknownObject.sidecarImageDigestVersion);
    return {
        version: version,
        publishTime: publishTime,
        sidecarImageDigestVersion: sidecarImageDigestVersion
    };
}

});

parcelRegister("gT9Gg", function(module, exports) {
"use strict";
var $c4b94ac600725ff5$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkManifest = $c4b94ac600725ff5$var$checkManifest;
/**
 * @param manifest manifest retrieved from data source
 * @param request request used to retrieve manifest (ie the artifact name and version specified)
 * @returns the manifest, but now it is guaranteed that the manifest name is the same as the requested name,
 * the version is the same as the requested version (if one is requested) and the version dimension (if it exists)
 * specifies exactly one version
 */ function $c4b94ac600725ff5$var$checkManifest(manifest, request) {
    if (manifest.name !== request.name) return {
        key: "mismatched-manifest-name"
    };
    var manifestVersionDimension = manifest.dimensions.version;
    if (request.version) {
        var manifestVersions = manifestVersionDimension ? $c4b94ac600725ff5$var$__spreadArray([
            manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.fallback
        ], manifestVersionDimension === null || manifestVersionDimension === void 0 ? void 0 : manifestVersionDimension.supported, true).filter(function(s) {
            return !!s;
        }) : [];
        var allVersionsMatch = manifestVersions.every(function(v) {
            return v === request.version;
        });
        if (!allVersionsMatch || manifestVersions.length === 0) return {
            key: "mismatched-manifest-version"
        };
    }
    return {
        key: "success"
    };
}

});

parcelRegister("guUcw", function(module, exports) {
"use strict";
var $c02b0b04c20c8875$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c02b0b04c20c8875$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConfigRegistryDataSource = void 0;

var $jgJJ5 = parcelRequire("jgJJ5");


var $7eeoB = parcelRequire("7eeoB");


var $dyTdO = parcelRequire("dyTdO");


var $gjGlh = parcelRequire("gjGlh");

var $c02b0b04c20c8875$var$ConfigRegistryDataSource = /** @class */ function() {
    function ConfigRegistryDataSource(manifestVersion, configRegistryHttpClient) {
        this.manifestVersion = manifestVersion;
        this.configRegistryHttpClient = configRegistryHttpClient;
    }
    ConfigRegistryDataSource.prototype.getManifest = function(artifactName, artifactVersion) {
        return $c02b0b04c20c8875$var$__awaiter(this, void 0, void 0, function() {
            var tag, configRegistryResponse, e_1;
            return $c02b0b04c20c8875$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        tag = (0, $jgJJ5.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 2:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.leftMap(function(e) {
                                return e;
                            }).map($dyTdO.parseArtifactManifest)
                        ];
                    case 3:
                        e_1 = _a.sent();
                        return [
                            2 /*return*/ ,
                            $7eeoB.Either.left({
                                key: "config-registry-error",
                                error: e_1
                            })
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getArtifact = function(_artifactName, tag) {
        return $c02b0b04c20c8875$var$__awaiter(this, void 0, void 0, function() {
            return $c02b0b04c20c8875$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(tag)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    ConfigRegistryDataSource.prototype.getLatestVersionMetadata = function() {
        return $c02b0b04c20c8875$var$__awaiter(this, void 0, void 0, function() {
            var dataTag, configRegistryResponse;
            return $c02b0b04c20c8875$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        dataTag = (0, $jgJJ5.getVersionMetadataTag)();
                        return [
                            4 /*yield*/ ,
                            this.configRegistryHttpClient.getBlob(dataTag)
                        ];
                    case 1:
                        configRegistryResponse = _a.sent();
                        return [
                            2 /*return*/ ,
                            configRegistryResponse.bimap(function(error) {
                                return error;
                            }, function(response) {
                                return (0, $gjGlh.parseVersionMetadata)(response);
                            })
                        ];
                }
            });
        });
    };
    return ConfigRegistryDataSource;
}();
module.exports.ConfigRegistryDataSource = $c02b0b04c20c8875$var$ConfigRegistryDataSource;

});

parcelRegister("k5C8f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Versions = module.exports.BaseUrls = void 0;
var $ea01da83580d84b4$var$BaseUrls = /** @class */ function() {
    function BaseUrls() {}
    BaseUrls.ConfigRegistryProd = "https://config-registry.prod.atl-paas.net";
    return BaseUrls;
}();
module.exports.BaseUrls = $ea01da83580d84b4$var$BaseUrls;
var $ea01da83580d84b4$var$Versions = /** @class */ function() {
    function Versions() {}
    Versions.ManifestVersion = "v1";
    return Versions;
}();
module.exports.Versions = $ea01da83580d84b4$var$Versions;

});

parcelRegister("8aTXy", function(module, exports) {

var $aeWVV = parcelRequire("aeWVV");


var $jgJJ5 = parcelRequire("jgJJ5");

class $5f3aaa4ea8255d74$export$2cb8d79200775058 {
    async getLatestVersionMetadata() {
        const tag = (0, $jgJJ5.getVersionMetadataTag)();
        const bifrostResponse = await this.bifrostClient.getBlob(`${tag}.json`);
        return bifrostResponse.fold((error)=>{
            return (0, $aeWVV.Either).left(error);
        }, (response)=>{
            try {
                const parsedVersionMetadata = (0, $aeWVV.parseVersionMetadata)(response);
                return (0, $aeWVV.Either).right(parsedVersionMetadata);
            } catch (e) {
                const error = {
                    key: "invalid-version-metadata"
                };
                return (0, $aeWVV.Either).left(error);
            }
        });
    }
    async getManifest(artifactName, artifactVersion) {
        const manifestTag = (0, $jgJJ5.getDataTagForManifest)(artifactName, this.manifestVersion, artifactVersion);
        const bifrostResponse = await this.bifrostClient.getBlob(`${manifestTag}.json`, artifactName);
        return bifrostResponse.fold((error)=>{
            return (0, $aeWVV.Either).left(error);
        }, (response)=>{
            try {
                const parsedArtifact = (0, $aeWVV.parseArtifactManifest)(response);
                return (0, $aeWVV.Either).right(parsedArtifact);
            } catch (e) {
                const error = {
                    key: "invalid-manifest"
                };
                return (0, $aeWVV.Either).left(error);
            }
        });
    }
    async getArtifact(artifactName, tag) {
        return this.bifrostClient.getBlob(`${tag}.json`, artifactName);
    }
    constructor(bifrostClient, manifestVersion){
        this.bifrostClient = bifrostClient;
        this.manifestVersion = manifestVersion;
    }
}
module.exports["BifrostDataSource"] = $5f3aaa4ea8255d74$export$2cb8d79200775058;

});

parcelRegister("bMJ95", function(module, exports) {

var $aeWVV = parcelRequire("aeWVV");

function $8947325f8c19bf7a$export$f654b28f82155665(env, perimeter) {
    if (perimeter === "commercial") switch(env){
        case "adev":
        case "ddev":
        case "pdev":
        case "stg":
            return "https://fd-config-bifrost.stg-east.frontend.public.atl-paas.net";
        case "prod":
            return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
    }
    else if (perimeter === "fedramp-moderate") switch(env){
        case "stg":
            return "https://fd-config-bifrost.stg.frontend.cdn.atlassian-us-gov-mod.com";
        case "prod":
            return "https://fd-config-bifrost.frontend.cdn.atlassian-us-gov-mod.com";
    }
    return "https://fd-config-bifrost.prod-east.frontend.public.atl-paas.net";
}
class $8947325f8c19bf7a$export$45c6d12ca9c14f83 {
    async getBlob(tag) {
        const endpoint = `${this.baseUrl}/assets/${tag}`;
        return new Promise((resolve)=>fetch(endpoint).then((response)=>{
                if (!response.ok) resolve((0, $aeWVV.Either).left({
                    key: "unexpected-response-code",
                    httpResponseCode: response.status,
                    httpResponseStatusText: response.statusText
                }));
                response.json().then((json)=>resolve((0, $aeWVV.Either).right(json)));
            }).catch((error)=>resolve((0, $aeWVV.Either).left({
                    key: "failed-fetch",
                    error: "message" in error ? error.message : "unknown error"
                }))));
    }
    constructor(env, perimeter){
        this.baseUrl = $8947325f8c19bf7a$export$f654b28f82155665(env, perimeter);
    }
}
module.exports["BifrostHttpClientImpl"] = $8947325f8c19bf7a$export$45c6d12ca9c14f83;

});

parcelRegister("bQyPO", function(module, exports) {

var $ccS36 = parcelRequire("ccS36");


var $aeWVV = parcelRequire("aeWVV");


var $bwFbe = parcelRequire("bwFbe");

function $89ff9275db847904$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $89ff9275db847904$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $89ff9275db847904$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $ccS36.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $89ff9275db847904$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $89ff9275db847904$export$8489e2f039bfcc4c {
    async getArtifact(artifactName, dimensions) {
        this.fetchArtifactExperience.addMetadata(dimensions);
        this.fetchArtifactExperience.start();
        const specifiedDimensions = $89ff9275db847904$var$_objectSpread($89ff9275db847904$var$_objectSpread({}, dimensions), {}, {
            name: artifactName
        });
        const artifact = await (0, $aeWVV.getArtifactFromSource)(this.dataSource, specifiedDimensions, "backend").catch((e)=>({
                type: "artifact-fetch-error",
                publishMetadata: {},
                error: {
                    key: "unexpected-error",
                    error: e
                }
            }));
        if (artifact.type === "success") this.fetchArtifactExperience.success();
        else {
            this.fetchArtifactExperience.addMetadata({
                errorType: artifact.type,
                error: "error" in artifact ? artifact.error.key : undefined
            });
            this.fetchArtifactExperience.failure();
        }
        return (0, $aeWVV.tryGetArtifactData)(artifact, this.dataSourceName);
    }
    async getLatestVersionMetadata() {
        this.versionMetadataExperience.start();
        const getVersionMetadataResult = await this.dataSource.getLatestVersionMetadata();
        return getVersionMetadataResult.fold((error)=>{
            this.versionMetadataExperience.addMetadata({
                error: error.key
            });
            this.versionMetadataExperience.failure();
            throw new Error(`Unable to get latest version metadata from ${this.dataSourceName} due to error: ${error.key}`);
        }, (data)=>{
            this.versionMetadataExperience.success();
            return data;
        });
    }
    constructor(dataSource, dataSourceName, fetchArtifactExperience, versionMetadataExperience){
        this.fetchArtifactExperience = fetchArtifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
        this.dataSource = new (0, $bwFbe.ExperienceDataSourceWrapper)(dataSource, this.fetchArtifactExperience, this.versionMetadataExperience);
        this.dataSourceName = dataSourceName;
    }
}
module.exports["ConfigClient"] = $89ff9275db847904$export$8489e2f039bfcc4c;

});

parcelRegister("bwFbe", function(module, exports) {
/**
 * Wraps a standard Datasource as defined by @atlassiansox/flight-deck-core && uses
 * the experience to mark when events happen.
 */ class $8642a06690dbc6ec$export$1cc944571619e6e8 {
    getLatestVersionMetadata() {
        this.versionMetadataExperience.mark("start-fetch-metadata");
        const result = this.dataSource.getLatestVersionMetadata();
        this.versionMetadataExperience.mark("end-fetch-metadata");
        return result;
    }
    async getManifest(artifactName, artifactVersion) {
        this.artifactExperience.mark("start-fetch-artifact");
        const result = await this.dataSource.getManifest(artifactName, artifactVersion);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getManifestError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-artifact");
        return result;
    }
    async getArtifact(artifactName, tag) {
        this.artifactExperience.mark("start-fetch-manifest");
        const result = await this.dataSource.getArtifact(artifactName, tag);
        result.leftMap((error)=>{
            this.artifactExperience.addMetadata({
                getArtifactError: error
            });
            return error;
        });
        this.artifactExperience.mark("end-fetch-manifest");
        return result;
    }
    constructor(dataSource, artifactExperience, versionMetadataExperience){
        this.dataSource = dataSource;
        this.artifactExperience = artifactExperience;
        this.versionMetadataExperience = versionMetadataExperience;
    }
}
module.exports["ExperienceDataSourceWrapper"] = $8642a06690dbc6ec$export$1cc944571619e6e8;

});

parcelRegister("4fKuX", function(module, exports) {
const $318ca1bf2a2009e5$var$SAMPLING_RATE = 10;
class $318ca1bf2a2009e5$var$UFOExperienceWrapper {
    start(startTime) {
        return this.experience.start(startTime);
    }
    success() {
        return this.experience.success();
    }
    failure() {
        return this.experience.failure();
    }
    addMetadata(data) {
        return this.experience.addMetadata(data);
    }
    mark(mark) {
        return this.experience.mark(mark);
    }
    constructor(experience){
        this.experience = experience;
    }
}
class $318ca1bf2a2009e5$export$5e7536cf7bc56fee {
    start() {
        return Promise.resolve();
    }
    success() {
        return Promise.resolve(null);
    }
    failure() {
        return Promise.resolve(null);
    }
    mark() {
        return;
    }
    addMetadata() {
        return;
    }
}

async function $318ca1bf2a2009e5$var$flightDeckSDKOperationExperience(id, timings, metadata) {
    try {
        // only emit metrics 1 in every 10 times a Flight Deck Configuration is fetched
        // to not flood Perf Portal with logs.
        if (Math.random() * 100 > $318ca1bf2a2009e5$var$SAMPLING_RATE) return new $318ca1bf2a2009e5$export$5e7536cf7bc56fee();
        const { UFOExperience: UFOExperience, ExperienceTypes: ExperienceTypes, ExperiencePerformanceTypes: ExperiencePerformanceTypes } = await (parcelRequire("3XCN6"));
        const ufoExperience = new UFOExperience(id, {
            type: ExperienceTypes.Operation,
            performanceType: ExperiencePerformanceTypes.Custom,
            platform: {
                component: "flight-deck-client"
            },
            timings: timings
        });
        ufoExperience.addMetadata(metadata);
        return new $318ca1bf2a2009e5$var$UFOExperienceWrapper(ufoExperience);
    } catch (_unused) {
        return new $318ca1bf2a2009e5$export$5e7536cf7bc56fee();
    }
}
const $318ca1bf2a2009e5$export$a3006f8f221c0a3b = ()=>$318ca1bf2a2009e5$var$flightDeckSDKOperationExperience("fetch", [
        {
            key: "fetch-artifact",
            endMark: "end-fetch-artifact",
            startMark: "start-fetch-artifact"
        },
        {
            key: "fetch-manifest",
            endMark: "end-fetch-manifest",
            startMark: "start-fetch-manifest"
        }
    ], {});
const $318ca1bf2a2009e5$export$c3ac7702bfd47c1b = ()=>$318ca1bf2a2009e5$var$flightDeckSDKOperationExperience("fetch-version-metadata", [
        {
            key: "fetch-metadata",
            startMark: "start-fetch-metadata",
            endMark: "end-fetch-metadata"
        }
    ], {});
module.exports["MockExperience"] = $318ca1bf2a2009e5$export$5e7536cf7bc56fee;
module.exports["getFlightDeckFetchExperience"] = $318ca1bf2a2009e5$export$a3006f8f221c0a3b;
module.exports["getVersionMetadataFetchExperience"] = $318ca1bf2a2009e5$export$c3ac7702bfd47c1b;

});

parcelRegister("3XCN6", function(module, exports) {

let $2e24f8dbeddacf9a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2e24f8dbeddacf9a$var$load("bB7PO").then(()=>parcelRequire('97TvQ'));

});

parcelRegister("9SlG7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = module.exports.parseConfigWithTargeting = void 0;

var $8atO2 = parcelRequire("8atO2");

Object.defineProperty(module.exports, "parseConfigWithTargeting", {
    enumerable: true,
    get: function() {
        return $8atO2.parseConfigWithTargeting;
    }
});

var $8kx9w = parcelRequire("8kx9w");

Object.defineProperty(module.exports, "TargetedConfig", {
    enumerable: true,
    get: function() {
        return $8kx9w.TargetedConfig;
    }
});

});

parcelRegister("8atO2", function(module, exports) {
"use strict";
var $0188e0873c702cc6$var$__assign = module.exports && module.exports.__assign || function() {
    $0188e0873c702cc6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0188e0873c702cc6$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseConfigWithTargeting = $0188e0873c702cc6$var$parseConfigWithTargeting;

var $8kx9w = parcelRequire("8kx9w");

/**
 * For a given configuration, return the same configuration back
 * with {@link TargetedConfig} substituted where applicable.
 *
 * So anywhere in the JSON that has the objects:
 * ```
 * {
 *   "defaultConfig": ...
 * }
 * ```
 *
 * OR
 *
 * ```
 * {
 *   "defaultConfig": ...
 *   "targeting": {
 *     "targets": [...]
 *     "targetedConfig": ...
 *   }
 * }
 * ```
 *
 * become an instance of {@link TargetedConfig}.
 *
 * @param config configuration that may contain unparsed {@link TargetedConfig}
 * @returns the same configuration with targeted config sub-objects transformed
 *     into {@link TargetedConfig}
 */ function $0188e0873c702cc6$var$parseConfigWithTargeting(data) {
    // All "object" types will also need to have a null check because null is an "object", but an
    // invalid one for this use case.
    if (typeof data === "object") {
        if (Array.isArray(data)) return data.map(function(element) {
            return $0188e0873c702cc6$var$parseConfigWithTargeting(element);
        });
        else if (data) {
            var parsedObject_1 = data;
            var keys = Object.keys(parsedObject_1);
            if (keys.length === 1 && parsedObject_1.defaultConfig) return new $8kx9w.TargetedConfig({
                defaultConfig: $0188e0873c702cc6$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
            });
            else if (keys.length === 2 && parsedObject_1.defaultConfig && parsedObject_1.targeting) {
                var parseResult = $0188e0873c702cc6$var$parseTargeting(parsedObject_1.targeting);
                if (parseResult.type === "match") return new $8kx9w.TargetedConfig({
                    targeting: parseResult.result,
                    defaultConfig: $0188e0873c702cc6$var$parseConfigWithTargeting(parsedObject_1.defaultConfig)
                });
            }
            return keys.reduce(function(accObject, key) {
                var _a;
                return $0188e0873c702cc6$var$__assign($0188e0873c702cc6$var$__assign({}, accObject), (_a = {}, _a[key] = $0188e0873c702cc6$var$parseConfigWithTargeting(parsedObject_1[key]), _a));
            }, {});
        } else return null;
    } else return data;
}
function $0188e0873c702cc6$var$parseTargeting(targeting) {
    if (typeof targeting === "object" && targeting && !Array.isArray(targeting)) {
        var targetingKeyValue = targeting;
        var targetingKeys = Object.keys(targetingKeyValue);
        if (targetingKeys.length == 2 && targetingKeyValue.targets && targetingKeyValue.targetedConfig) return {
            type: "match",
            result: {
                targets: $0188e0873c702cc6$var$parseTargets(targetingKeyValue.targets),
                targetedConfig: $0188e0873c702cc6$var$parseConfigWithTargeting(targetingKeyValue.targetedConfig)
            }
        };
    }
    return {
        type: "no-match"
    };
}
function $0188e0873c702cc6$var$parseTargets(targets) {
    if (Array.isArray(targets)) return targets.map(function(target) {
        return {
            orgIds: $0188e0873c702cc6$var$parseIdentifierList(target.orgIds),
            siteIds: $0188e0873c702cc6$var$parseIdentifierList(target.siteIds),
            userIds: $0188e0873c702cc6$var$parseIdentifierList(target.userIds)
        };
    });
    else throw new Error("The targets for Flight Deck targeted configuration must come in an array.");
}
function $0188e0873c702cc6$var$parseIdentifierList(identifierList) {
    if (identifierList === undefined) return undefined;
    if (Array.isArray(identifierList)) return identifierList.map(function(id) {
        if (typeof id === "string") return id;
        else throw new Error("Identifiers for targets must be strings!");
    });
    else throw new Error("Identifier list must be an array!");
}

});

parcelRegister("8kx9w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TargetedConfig = void 0;
/**
 * Defines a part of the overall configuration that has different
 * values based on the intended target. The target is a specification
 * of a combination of site id, user id and org id.
 */ var $6109e865af3fd97d$var$TargetedConfig = /** @class */ function() {
    function TargetedConfig(targetedConfigDefinition) {
        this.targetedConfigDefinition = targetedConfigDefinition;
    }
    /**
   * Determines whether to use the targeted configuration value or the default value
   * depending on whether the specified values match any of the target's rules.
   *
   * @param target the values to use to evaluate the config
   * @returns the {@link TargetingResult}, which would be the default value
   *     if the specified target did not match, or the targeted value if there
   *     was a match
   */ TargetedConfig.prototype.resolve = function(target) {
        var targeting = this.targetedConfigDefinition.targeting;
        if (targeting) {
            var targeted = targeting.targets.some(function(configuredTarget) {
                var criteria = [];
                if (configuredTarget.orgIds) criteria.push({
                    allowList: configuredTarget.orgIds,
                    identifier: target.orgId
                });
                if (configuredTarget.siteIds) criteria.push({
                    allowList: configuredTarget.siteIds,
                    identifier: target.siteId
                });
                if (configuredTarget.userIds) criteria.push({
                    allowList: configuredTarget.userIds,
                    identifier: target.userId
                });
                if (criteria.length === 0) return false;
                else return criteria.every(function(criteria) {
                    return $6109e865af3fd97d$var$resolveForTargetCriteria(criteria);
                });
            });
            if (targeted) return {
                type: "targeted",
                value: targeting.targetedConfig
            };
        }
        return {
            type: "default",
            value: this.targetedConfigDefinition.defaultConfig
        };
    };
    return TargetedConfig;
}();
module.exports.TargetedConfig = $6109e865af3fd97d$var$TargetedConfig;
function $6109e865af3fd97d$var$resolveForTargetCriteria(criteria) {
    return !!criteria.identifier && criteria.allowList.includes(criteria.identifier);
}

});

parcelRegister("gdsgI", function(module, exports) {
class $bce3c9ca5adb9c28$export$2e2bcd8739ae039 extends Error {
    constructor({ artifact: artifact, dimensions: dimensions, error: error }){
        super(error instanceof Error && error.message ? error.message : "Unknown Flight Deck SDK error");
        this.name = "FlightDeckSDKError";
        this.error = error;
        this.artifact = artifact;
        this.environmentType = dimensions === null || dimensions === void 0 ? void 0 : dimensions.environmentType;
        this.locale = dimensions === null || dimensions === void 0 ? void 0 : dimensions.locale;
        this.perimeter = dimensions === null || dimensions === void 0 ? void 0 : dimensions.perimeter;
    }
}
const $bce3c9ca5adb9c28$export$1d76d155060824c9 = (e)=>e instanceof $bce3c9ca5adb9c28$export$2e2bcd8739ae039;
module.exports["default"] = $bce3c9ca5adb9c28$export$2e2bcd8739ae039;

});

parcelRegister("2yexq", function(module, exports) {
const $1dba08b64c057f56$export$e3553dc63541d477 = (artifactName, dimensions)=>{
    return `${artifactName}${dimensions ? "_" + Object.keys(dimensions).sort().map((key)=>dimensions[key]).filter(Boolean).join("_") : ""}`;
};
module.exports["artifactKey"] = $1dba08b64c057f56$export$e3553dc63541d477;

});

parcelRegister("jAdLj", function(module, exports) {

var $ccS36 = parcelRequire("ccS36");


var $gZFfs = parcelRequire("gZFfs");

var $34VCg = parcelRequire("34VCg");

function $e41c0dfe29a2cae9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e41c0dfe29a2cae9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e41c0dfe29a2cae9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $ccS36.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e41c0dfe29a2cae9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $e41c0dfe29a2cae9$export$1e3a41a51f6457c5 = ()=>new (0, $34VCg.UFOExperience)("retrieve-artifact", {
        type: (0, $gZFfs.ExperienceTypes).Operation,
        performanceType: (0, $gZFfs.ExperiencePerformanceTypes).Custom,
        platform: {
            component: "flight-deck-client"
        }
    });
const $e41c0dfe29a2cae9$export$f33622abb5224195 = (e)=>{
    return e instanceof Error ? $e41c0dfe29a2cae9$var$_objectSpread($e41c0dfe29a2cae9$var$_objectSpread({}, e), {}, {
        cause: undefined
    }) : "unknown";
};
module.exports["flightDeckClientExperience"] = $e41c0dfe29a2cae9$export$1e3a41a51f6457c5;
module.exports["exceptionToMetadata"] = $e41c0dfe29a2cae9$export$f33622abb5224195;

});

parcelRegister("daPrQ", function(module, exports) {
// This file is auto-generated. Do not edit manually.
/* Update via: cd platform/packages/activity-platform/recent-work-client && yarn update:bundled:config */ const $747d6020adabb978$var$_default_1 = {
    localization: {
        eventTypes: {
            commented: {
                absolute: 'You commented on {absoluteTime}',
                relative: 'You commented {relativeTime}',
                standalone: 'You commented',
                multiAbsolute: 'Commented on {absoluteTime}',
                multiRelative: 'Commented {relativeTime}',
                multiStandalone: 'Commented'
            },
            created: {
                absolute: 'You created on {absoluteTime}',
                relative: 'You created {relativeTime}',
                standalone: 'You created',
                multiAbsolute: 'Created on {absoluteTime}',
                multiRelative: 'Created {relativeTime}',
                multiStandalone: 'Created'
            },
            edited: {
                absolute: 'You edited on {absoluteTime}',
                relative: 'You edited {relativeTime}',
                standalone: 'You edited',
                multiAbsolute: 'Edited on {absoluteTime}',
                multiRelative: 'Edited {relativeTime}',
                multiStandalone: 'Edited'
            },
            published: {
                absolute: 'You published on {absoluteTime}',
                relative: 'You published {relativeTime}',
                standalone: 'You published',
                multiAbsolute: 'Published on {absoluteTime}',
                multiRelative: 'Published {relativeTime}',
                multiStandalone: 'Published'
            },
            updated: {
                absolute: 'You updated on {absoluteTime}',
                relative: 'You updated {relativeTime}',
                standalone: 'You updated',
                multiAbsolute: 'Updated on {absoluteTime}',
                multiRelative: 'Updated {relativeTime}',
                multiStandalone: 'Updated'
            },
            viewed: {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            },
            'sl-viewed': {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            },
            clicked: {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            },
            'sl-clicked': {
                absolute: 'You viewed on {absoluteTime}',
                relative: 'You viewed {relativeTime}',
                standalone: 'You viewed',
                multiAbsolute: 'Viewed on {absoluteTime}',
                multiRelative: 'Viewed {relativeTime}',
                multiStandalone: 'Viewed'
            }
        }
    },
    hydrators: {
        TownsquareGoal: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'key'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'iconData'
                ],
                statusValue: [
                    'status.value'
                ],
                statusScore: [
                    'status.score'
                ]
            }
        },
        TownsquareProject: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'key'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'iconData'
                ],
                statusValue: [
                    'state.value'
                ]
            }
        },
        TownsquareComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                key: [
                    'container.key'
                ],
                name: [
                    'container.name'
                ],
                url: [
                    'container.url'
                ],
                icon: [
                    'container.iconData'
                ],
                deduplicateId: [
                    'container.id'
                ]
            }
        },
        ConfluencePage: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'pageId'
                ],
                subtype: [
                    'subtype'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceLiveDocIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/live-doc.svg'
            }
        },
        ConfluenceBlogPost: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'blogPostId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/blogpost.svg'
            }
        },
        ConfluenceWhiteboard: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'whiteboardId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/whiteboard.svg'
            }
        },
        ConfluenceDatabase: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'databaseId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/database.svg'
            }
        },
        ConfluenceEmbed: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                localResourceId: [
                    'embedId'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'space.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/embed.svg'
            }
        },
        ConfluenceComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceWhiteboardIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/whiteboard.svg'
            }
        },
        ConfluenceFooterComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceWhiteboardIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/whiteboard.svg'
            }
        },
        ConfluenceInlineComment: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'container.title'
                ],
                url: [
                    'links.base',
                    'links.webUi'
                ],
                containers: [
                    'container.space.name'
                ],
                deduplicateId: [
                    'container.id'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceBlogIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/blogpost.svg',
                confluencePageIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/page.svg',
                confluenceWhiteboardIcon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/confluence/whiteboard.svg'
            }
        },
        JiraIssue: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                objectTypeName: [
                    'fieldsById.edges(node.fieldId: "issuetype").node.issueType.name'
                ],
                icon: [
                    'fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.medium'
                ],
                key: [
                    'key'
                ],
                statusValue: [
                    'fieldsByIdOrAlias(fieldId: "status").status.name'
                ],
                statusColor: [
                    'fieldsByIdOrAlias(fieldId: "status").status.statusCategory.colorName'
                ]
            }
        },
        JiraPlatformComment: {
            hydratorPaths: {
                id: [
                    'commentId'
                ],
                name: [
                    'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                objectTypeName: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.name'
                ],
                icon: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.medium'
                ],
                key: [
                    'issue.key'
                ],
                deduplicateId: [
                    'issue.id'
                ]
            }
        },
        JiraServiceManagementComment: {
            hydratorPaths: {
                id: [
                    'commentId'
                ],
                name: [
                    'issue.fieldsById.edges(node.fieldId: "summary").node.text'
                ],
                url: [
                    'webUrl'
                ],
                containers: [
                    'issue.fieldsById.edges(node.fieldId: "project").node.project.name'
                ],
                objectTypeName: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.name'
                ],
                icon: [
                    'issue.fieldsById.edges(node.fieldId: "issuetype").node.issueType.avatar.medium'
                ],
                key: [
                    'issue.key'
                ],
                deduplicateId: [
                    'issue.id'
                ]
            }
        },
        TrelloBoard: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'boardName'
                ],
                url: [
                    'boardUrl'
                ],
                containers: [
                    'workspace.displayName'
                ],
                deduplicateId: [
                    'objectId'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/trello/board.svg'
            }
        },
        TrelloCard: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'cardName'
                ],
                url: [
                    'cardUrl'
                ],
                containers: [
                    'list.name',
                    'list.board.name'
                ],
                deduplicateId: [
                    'objectId'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/trello/card.svg'
            }
        },
        DevOpsDocument: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'displayName'
                ],
                url: [
                    'webUrl'
                ],
                icon: [
                    'type.iconUrl'
                ]
            }
        },
        DevOpsPullRequestDetails: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'title'
                ],
                url: [
                    'url'
                ],
                containers: [
                    'repositoryName'
                ],
                key: [
                    'providerName'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/pull-request.svg'
            }
        },
        DevOpsDesign: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'displayName'
                ],
                url: [
                    'webUrl'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/design.svg'
            }
        },
        ExternalDocument: {
            hydratorPaths: {
                id: [
                    'thirdPartyId'
                ],
                name: [
                    'displayName'
                ],
                url: [
                    'url'
                ],
                subtype: [
                    'type.category'
                ],
                key: [
                    'parent.displayName'
                ],
                containers: [
                    'createdBy.thirdPartyUser.name'
                ],
                creator: [
                    'createdBy.thirdPartyUser.name'
                ],
                providerId: [
                    'provider.providerId'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/document.svg',
                thirdPartyIconPath: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/third-party-logos/{replaceProductName}/default.svg'
            }
        },
        ExternalPullRequest: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'displayName'
                ],
                url: [
                    'url'
                ],
                providerId: [
                    'provider.providerId'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/pull-request.svg',
                thirdPartyIconPath: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/third-party-logos/{replaceProductName}/default.svg'
            }
        },
        ExternalRemoteLink: {
            hydratorPaths: {
                id: [
                    'thirdPartyId'
                ],
                name: [
                    'displayName'
                ],
                url: [
                    'url'
                ],
                subtype: [
                    'category'
                ],
                containers: [
                    'createdBy.thirdPartyUser.name'
                ],
                creator: [
                    'createdBy.thirdPartyUser.name'
                ],
                providerId: [
                    'provider.providerId'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/graph/document.svg',
                thirdPartyIconPath: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/third-party-logos/{replaceProductName}/default.svg'
            }
        },
        MercuryFocusArea: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                key: [
                    'focusAreaType.name'
                ],
                icon: [
                    'icon.url'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/mercury/focus-area.svg'
            }
        },
        MercuryPortfolio: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                key: [
                    'label'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/mercury/view.svg'
            }
        },
        RadarPosition: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'worker.preferredName'
                ],
                url: [
                    'url'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/talent/position.svg'
            }
        },
        RadarView: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'viewName'
                ],
                url: [
                    'url'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/talent/view.svg'
            }
        },
        CompassComponent: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'name'
                ],
                url: [
                    'url'
                ],
                icon: [
                    'typeMetadata.iconUrl'
                ],
                key: [
                    'typeMetadata.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/compass/logo.svg'
            }
        },
        BitbucketPullRequest: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'pullRequestTitle'
                ],
                url: [
                    'href'
                ],
                key: [
                    'pullRequestTitle'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/bitbucket/logo.svg'
            }
        },
        LoomVideo: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'name'
                ],
                url: [
                    'loomUrl'
                ],
                key: [
                    'owner.name'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/loom/logo.svg'
            }
        },
        AssetsObject: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'label'
                ],
                key: [
                    'displayTypename'
                ],
                url: [
                    'links.web'
                ],
                icon: [
                    'avatar.url48'
                ],
                containers: [
                    'objectType.schema.name'
                ],
                containersWithDisplayName: [
                    'objectType.schema.displayName'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/assets/logo.svg'
            }
        },
        AssetsObjectType: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'assetsObjectTypeName'
                ],
                displayName: [
                    'assetsObjectTypeDisplayName'
                ],
                key: [
                    'displayTypename'
                ],
                url: [
                    'links.web'
                ],
                icon: [
                    'assetsObjectTypeIcon.url48'
                ],
                containers: [
                    'schema.assetsSchemaName'
                ],
                containersWithDisplayName: [
                    'schema.assetsSchemaDisplayName'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/assets/logo.svg'
            }
        },
        AssetsSchema: {
            hydratorPaths: {
                id: [
                    'id'
                ],
                name: [
                    'assetsSchemaName'
                ],
                displayName: [
                    'assetsSchemaDisplayName'
                ],
                key: [
                    'displayTypename'
                ],
                url: [
                    'links.web'
                ]
            },
            staticFallbacks: {
                icon: 'https://flight-deck-assets-bifrost.prod-east.frontend.public.atl-paas.net/assets/image/misc-icons/assets/logo.svg'
            }
        }
    },
    queryFragments: '\n\n  fragment townsquareGoal on TownsquareGoal {\n    id\n    key\n    name\n    url\n    iconData\n    status {\n      value\n      score\n    }\n  }\n\n\n  fragment townsquareProject on TownsquareProject {\n    id\n    key\n    name\n    url\n    iconData\n    state {\n      value\n    }\n  }\n\n\n  fragment townsquareComment on TownsquareComment {\n    id\n    url\n    container {\n      __typename\n      ...townsquareGoal\n      ...townsquareProject\n    }\n  }\n\n\n  fragment confluencePage on ConfluencePage {\n    id\n    title\n    pageId\n    subtype\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceBlogPost on ConfluenceBlogPost {\n    id\n    title\n    blogPostId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceWhiteboard on ConfluenceWhiteboard {\n    id\n    title\n    whiteboardId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceDatabase on ConfluenceDatabase {\n    id\n    title\n    databaseId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceEmbed on ConfluenceEmbed {\n    id\n    title\n    embedId\n    links {\n      base\n      webUi\n    }\n    space {\n      name\n    }\n  }\n\n\n  fragment confluenceComment on ConfluenceComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n      ...confluenceWhiteboard\n    }\n  }\n\n\n  fragment confluenceFooterComment on ConfluenceFooterComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n      ...confluenceWhiteboard\n    }\n  }\n\n\n  fragment confluenceInlineComment on ConfluenceInlineComment {\n    id\n    links {\n      base\n      webUi\n    }\n    container {\n      __typename\n      ...confluenceBlogPost\n      ...confluencePage\n      ...confluenceWhiteboard\n    }\n  }\n\n\nfragment jiraIssue on JiraIssue {\n  id\n  key\n  webUrl\n  fieldsById(ids: ["summary", "issuetype", "project"]) {\n    edges {\n      node {\n        __typename\n        fieldId\n        ...jiraSingleLineTextField\n        ...jiraIssueTypeField\n        ...jiraProjectField\n      }\n    }\n  }\n  fieldsByIdOrAlias(idsOrAliases: ["status"]) @optIn(to: "JiraIssueFieldsByIdOrAlias") {\n    __typename\n    fieldId\n    ...jiraStatusField\n  }\n}\nfragment jiraSingleLineTextField on JiraSingleLineTextField {\n  text\n}\nfragment jiraIssueTypeField on JiraIssueTypeField {\n  issueType {\n    name\n    avatar {\n      medium\n    }\n  }\n}\nfragment jiraProjectField on JiraProjectField {\n  project {\n    name\n  }\n}\nfragment jiraStatusField on JiraStatusField {\n  status {\n    name\n    statusCategory {\n      colorName\n    }\n  }\n}\n\n\nfragment jiraPlatformComment on JiraPlatformComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\n\nfragment jiraServiceManagementComment on JiraServiceManagementComment {\n  commentId\n  webUrl\n  issue {\n    ...jiraIssue\n  }\n}\n\n\nfragment trelloBoard on TrelloBoard {\n  id\n  objectId\n  boardName: name\n  boardUrl: url\n  workspace {\n    id\n    displayName\n  }\n}\n\n\nfragment trelloCard on TrelloCard {\n  id\n  objectId\n  cardName: name\n  cardUrl: url\n  list {\n    id\n    name\n    board @optIn(to: "TrelloListBoard") {\n      id\n      name\n    }\n  }\n}\n\n\n        fragment graphDevOpsDocument on DevOpsDocument {\n          id\n          displayName\n          webUrl: url\n          type {\n            iconUrl\n          }\n        }\n    \n\n        fragment graphExternalDocument on ExternalDocument {\n            id\n            type {\n                category\n            }\n            displayName\n            parent @optIn(to: "ExternalDataDepotQueryV2"){\n                ...on ExternalDocument {\n                    displayName\n                }\n            }\n            url\n            provider {\n                providerId\n            }\n            createdBy {\n                thirdPartyUser {\n                    name\n                }\n            }\n            thirdPartyId\n        }\n    \n\nfragment graphPullRequest on DevOpsPullRequestDetails {\n  id\n  title\n  url\n  repositoryName\n  providerName\n}\n\n\nfragment graphExternalPullRequest on ExternalPullRequest {\n  id\n  displayName\n  url\n  pullRequestStatus: status\n  provider {\n    providerId\n  }\n}\n\n\nfragment graphDesign on DevOpsDesign {\n  id\n  displayName\n  webUrl: url\n}\n\n\n        fragment graphExternalRemoteLink on ExternalRemoteLink {\n            id\n            displayName\n            category\n            createdBy {\n                thirdPartyUser {\n                    name\n                }\n            }\n            url\n            provider {\n                providerId\n            }\n            thirdPartyId\n        }\n    \n\n    fragment mercuryFocusArea on MercuryFocusArea {\n        id\n        name\n        url\n        focusAreaType {\n            name\n        }\n        icon {\n            url\n        }\n    }\n    \n\n    fragment mercuryPortfolio on MercuryPortfolio {\n        id\n        name\n        url\n        label\n    }\n    \n\n    fragment radarPosition on RadarPosition {\n        id\n        worker {\n            preferredName\n        }\n        url\n    }\n    \n\n    fragment radarView on RadarView {\n        id\n        viewName\n        url\n    }\n    \n\nfragment compassComponent on CompassComponent {\n  id\n  name\n  url\n  typeMetadata {\n    iconUrl\n    name\n  }\n}\n\n\nfragment bitbucketPullRequest on BitbucketPullRequest {\n  id\n  pullRequestTitle: title\n  href\n  author {\n    picture\n  }\n}\n\n\nfragment loomVideo on LoomVideo {\n  id\n  name\n  loomUrl: url\n  owner {\n    name\n    picture\n  }\n}\n\n\n    fragment assetsObject on AssetsObject {\n      id\n      label\n      objectKey\n      links {\n        web\n      }\n      avatar {\n        url48\n      }\n      objectType {\n        name\n        displayName\n        schema {\n          name\n          displayName\n        }\n      }\n      displayTypename @optIn(to: "AssetsApFields")\n    }\n\n\n    fragment assetsObjectType on AssetsObjectType {\n      id\n      assetsObjectTypeName: name\n      assetsObjectTypeDisplayName: displayName\n      links {\n        web\n      }\n      assetsObjectTypeIcon: icon {\n        url48\n      }\n      schema {\n        id\n        assetsSchemaName: name\n        assetsSchemaDisplayName: displayName\n      }\n      displayTypename @optIn(to: "AssetsApFields")\n    }\n\n\n    fragment assetsSchema on AssetsSchema {\n      id\n      assetsSchemaKey: key\n      assetsSchemaName: name\n      assetsSchemaDisplayName: displayName\n      links {\n        web\n      }\n      displayTypename @optIn(to: "AssetsApFields")\n    }\n\nfragment activityItemEdge on ActivityItemEdge {\n  cursor\n  node {\n    id\n    object {\n      id\n      type\n      product\n      subProduct\n      rootContainerId\n      contributors {\n        profile {\n          name\n          picture\n          accountId\n        }\n      }\n      data {\n        __typename\n\t...townsquareGoal\n\t...townsquareProject\n\t...townsquareComment\n\t...confluencePage\n\t...confluenceBlogPost\n\t...confluenceWhiteboard\n\t...confluenceDatabase\n\t...confluenceEmbed\n\t...confluenceComment\n\t...confluenceFooterComment\n\t...confluenceInlineComment\n\t...jiraIssue\n\t...jiraPlatformComment\n\t...jiraServiceManagementComment\n\t...trelloBoard\n\t...trelloCard\n\t...graphDevOpsDocument\n\t...graphExternalDocument\n\t...graphPullRequest\n\t...graphExternalPullRequest\n\t...graphDesign\n\t...graphExternalRemoteLink\n\t...mercuryFocusArea\n\t...mercuryPortfolio\n\t...radarPosition\n\t...radarView\n\t...compassComponent\n\t...bitbucketPullRequest\n\t...loomVideo\n\t...assetsObject\n\t...assetsObjectType\n\t...assetsSchema\n      }\n    }\n    event {\n      id\n      timestamp\n      eventType\n      actor {\n        name\n        picture\n        accountId\n      }\n    }\n  }\n}\nfragment activityItemConnection on ActivityConnection {\n  edges {\n    ...activityItemEdge\n  }\n}\n\n'
};
var $747d6020adabb978$export$2e2bcd8739ae039 = $747d6020adabb978$var$_default_1;
module.exports["default"] = $747d6020adabb978$export$2e2bcd8739ae039;

});

parcelRegister("iCy8k", function(module, exports) {

var $fBnBW = parcelRequire("fBnBW");

const $cd82f408e3d8050c$var$errorHandlerMap = new Map([
    [
        'ValidationError',
        (0, $fBnBW.default)
    ]
]);
const $cd82f408e3d8050c$var$graphQLErrorHandler = (err)=>{
    const errorHandler = $cd82f408e3d8050c$var$errorHandlerMap.get(err.extensions.classification);
    if (typeof errorHandler === 'function') return errorHandler(err);
    return null;
};
var $cd82f408e3d8050c$export$2e2bcd8739ae039 = $cd82f408e3d8050c$var$graphQLErrorHandler;
module.exports["default"] = $cd82f408e3d8050c$export$2e2bcd8739ae039;

});

parcelRegister("fBnBW", function(module, exports) {
/**
 * ^Validation error - look for validation errors from the start
 * .*?@ ' - look through everything up to the first instance of "@ '"
 * (\w+) - capture the first word, that's our invalid fragment
 */ const $d1e1dc0434ef6f24$var$captureRegex = new RegExp(/^Validation error.*?@ '(\w+)/);
const $d1e1dc0434ef6f24$var$validationErrorHandler = (graphQLError)=>{
    const invalidFragmentMatch = $d1e1dc0434ef6f24$var$captureRegex.exec(graphQLError.message);
    if (Array.isArray(invalidFragmentMatch)) {
        const invalidFragment = invalidFragmentMatch[1];
        if (invalidFragment) return invalidFragment;
    }
    return null;
};
var $d1e1dc0434ef6f24$export$2e2bcd8739ae039 = $d1e1dc0434ef6f24$var$validationErrorHandler;
module.exports["default"] = $d1e1dc0434ef6f24$export$2e2bcd8739ae039;

});

parcelRegister("k4jq6", function(module, exports) {

var $barCt = parcelRequire("barCt");


var $oLeaD = parcelRequire("oLeaD");

const $4b8cb14a4fd64650$var$ACTIVITIES_LIMIT = 50;
const $4b8cb14a4fd64650$var$WORKED_ON_QUERY = `
   workedOn(first: $first, filter: $filter) {
     ...activityItemConnection
   }
`;
const $4b8cb14a4fd64650$var$VIEWED__QUERY = `
   viewed(first: $first, filter: $filter) {
     ...activityItemConnection
   }
`;
const $4b8cb14a4fd64650$var$ALL__QUERY = `
    all(first: $first, filter: $filter) {
      ...activityItemConnection
    }
`;
const $4b8cb14a4fd64650$var$activityQueryMap = new Map([
    [
        'workedOn',
        $4b8cb14a4fd64650$var$WORKED_ON_QUERY
    ],
    [
        'viewed',
        $4b8cb14a4fd64650$var$VIEWED__QUERY
    ],
    [
        'all',
        $4b8cb14a4fd64650$var$ALL__QUERY
    ]
]);
const $4b8cb14a4fd64650$var$getMyActivitiesQuery = (queries)=>`
      myActivity {
        ${queries.join('\n')}
      }
`;
const $4b8cb14a4fd64650$var$getActivitiesQuery = (product, content, fragments, activityFilterType = 'ActivityFilter')=>`
    query ${(0, $barCt.getOperationName)(product)}($first: Int, $filter: ${activityFilterType}) {
      activity {
        ${content}
      }
    }
${fragments}
`;
const $4b8cb14a4fd64650$export$855cd08371c65b8c = (product, filters, activityQueries, fragments)=>{
    /**
   * If we are filtering by `actors` then we can't use the `myActivity` query.
   */ if (Array.isArray(filters.actors)) {
        // you can't view `viewed` events for other accounts
        const filteredAccountQueries = activityQueries.filter((query)=>query !== 'viewed');
        return {
            query: $4b8cb14a4fd64650$var$getActivitiesQuery(product, filteredAccountQueries.map((query)=>$4b8cb14a4fd64650$var$activityQueryMap.get(query)).join('\n'), fragments, 'ActivityFilter'),
            queryFilters: (0, $oLeaD.ACTIVITY_FILTER_COLLECTION).v3.get('activities')(filters)
        };
    } else return {
        query: $4b8cb14a4fd64650$var$getActivitiesQuery(product, $4b8cb14a4fd64650$var$getMyActivitiesQuery(activityQueries.map((query)=>$4b8cb14a4fd64650$var$activityQueryMap.get(query))), fragments, 'MyActivityFilter'),
        queryFilters: (0, $oLeaD.ACTIVITY_FILTER_COLLECTION).v3.get('myActivity')(filters)
    };
};
const $4b8cb14a4fd64650$export$7489a6ef09862e48 = (product, filters, activityQueries, fragments)=>{
    const { limit: // we want to default limit if not applied
    limit = $4b8cb14a4fd64650$var$ACTIVITIES_LIMIT, ...restFilters } = filters;
    const { query: query, queryFilters: queryFilters } = $4b8cb14a4fd64650$export$855cd08371c65b8c(product, restFilters, activityQueries, fragments);
    return {
        operationName: (0, $barCt.getOperationName)(product),
        query: query,
        variables: {
            first: limit,
            filter: queryFilters
        }
    };
};
module.exports["generateGraphQLRequest"] = $4b8cb14a4fd64650$export$7489a6ef09862e48;

});

parcelRegister("2aFdM", function(module, exports) {

var $eYVId = parcelRequire("eYVId");

function $d3ba7dec68c331b0$export$750d93207e30f59a(activitiesData) {
    const { all: all, viewed: viewed, workedOn: workedOn } = activitiesData;
    return {
        all: $d3ba7dec68c331b0$var$rollUpActivityItems(all),
        viewed: $d3ba7dec68c331b0$var$rollUpActivityItems(viewed),
        workedOn: $d3ba7dec68c331b0$var$rollUpActivityItems(workedOn)
    };
}
function $d3ba7dec68c331b0$var$rollUpActivityItems(activityItems) {
    // https://stackoverflow.com/a/49460534
    // creates an ordered 'hashmap' containing unique ids in the same order that the activity items appear
    const latestActivityItemsObjectWithLatestTimestamp = activityItems.reduce((acc, activityItem)=>{
        const deduplicateId = activityItem.object.deduplicateId || activityItem.object.id;
        const existingItem = acc[deduplicateId];
        if (existingItem) {
            const aggregatedItems = existingItem.aggregatedActivityItems || [];
            if (Date.parse(existingItem.timestamp) < Date.parse(activityItem.timestamp)) {
                activityItem.aggregatedActivityItems = [
                    ...aggregatedItems,
                    existingItem
                ];
                // remove the current activity for that id so when we add the more recent activity it is in the order that it appears
                delete acc[deduplicateId];
                acc[deduplicateId] = activityItem;
            } else acc[deduplicateId].aggregatedActivityItems = [
                ...aggregatedItems,
                activityItem
            ];
        } else acc[deduplicateId] = activityItem;
        return acc;
    }, {});
    return Object.values(latestActivityItemsObjectWithLatestTimestamp);
}
const $d3ba7dec68c331b0$export$213ba2e9f2d143b9 = (key)=>{
    return new RegExp(`fragment ${$d3ba7dec68c331b0$var$fragmentName(key)} on ${$d3ba7dec68c331b0$var$fragmentType(key)} ({(.|\\n)+?(?=fragment))`, 'gm');
};
const $d3ba7dec68c331b0$var$fragmentName = (key)=>key.charAt(0).toLowerCase() + key.slice(1);
const $d3ba7dec68c331b0$var$fragmentType = (key)=>key.charAt(0).toUpperCase() + key.slice(1);
const $d3ba7dec68c331b0$export$ea55e8e0446efa94 = (activity)=>{
    if (activity.myActivity) return activity.myActivity;
    return activity;
};
const $d3ba7dec68c331b0$var$SITE_ARI_PREFIX = 'ari:cloud:platform::site/';
const $d3ba7dec68c331b0$var$containerMapTypes = new Map([
    [
        $d3ba7dec68c331b0$var$SITE_ARI_PREFIX,
        'SITE'
    ]
]);
function $d3ba7dec68c331b0$export$788e6013936a6bb4(rootContainerARI) {
    // the "ID" portion of the ARI begins after the first '/'
    const ariSplitIndex = rootContainerARI.indexOf('/');
    return {
        ari: rootContainerARI,
        id: rootContainerARI.slice(ariSplitIndex + 1),
        type: $d3ba7dec68c331b0$var$containerMapTypes.get(rootContainerARI.slice(0, ariSplitIndex + 1)) || 'OTHER'
    };
}
function $d3ba7dec68c331b0$export$e8f56bed6776c7ea(filters) {
    return {
        ...filters,
        // These have V high cardinality, so using a length
        actors: filters.actors?.length,
        containerIds: filters.containerIds?.length,
        // comma separated lists
        products: filters.products?.join(','),
        eventTypes: filters.eventTypes?.join(','),
        objectTypes: filters.objectTypes?.join(','),
        rootContainerIds: filters.rootContainerIds?.join(',')
    };
}
/**
 * These fragments are the core of our query, without them it will always fail,
 * so we shouldn't remove them. It is possible that removing other offending fragments
 * will fix the error in these core fragments. (e.g. Field conflict)
 */ const $d3ba7dec68c331b0$var$RESTRICTED_FRAGMENTS = [
    'activity',
    'all',
    'myActivity',
    'workedOn',
    'viewed',
    'activityItemConnection',
    'activityItemEdge'
];
function $d3ba7dec68c331b0$export$e22863ec502608d2(invalidFragments, allFragments) {
    return invalidFragments.filter((fragment)=>!$d3ba7dec68c331b0$var$RESTRICTED_FRAGMENTS.includes(fragment)).reduce((acc, invalidFragment)=>{
        return acc.replace(new RegExp(`...${invalidFragment}\n`, 'g'), '').replace($d3ba7dec68c331b0$export$213ba2e9f2d143b9(invalidFragment), '');
    }, allFragments);
}
const $d3ba7dec68c331b0$var$IGNORED_ERROR_CLASSIFICATIONS = [
    'IncorrectAuthException'
];
function $d3ba7dec68c331b0$export$c939d6148e47244a(response) {
    if (!response?.data || !Array.isArray(response.errors)) return false;
    const filteredAggErrors = response.errors.filter((e)=>!e.extensions.classification || !$d3ba7dec68c331b0$var$IGNORED_ERROR_CLASSIFICATIONS.includes(e.extensions.classification));
    return filteredAggErrors.length > 0 && $d3ba7dec68c331b0$export$884573c560ed3600(response.data);
}
function $d3ba7dec68c331b0$export$884573c560ed3600(queryData) {
    return !queryData.activity || $d3ba7dec68c331b0$export$ea55e8e0446efa94(queryData.activity).all?.edges?.length === 0 && $d3ba7dec68c331b0$export$ea55e8e0446efa94(queryData.activity).workedOn?.edges?.length === 0 && queryData.activity?.myActivity?.viewed?.edges?.length === 0;
}
function $d3ba7dec68c331b0$export$618af76292d5645c(object) {
    const ari = object.id;
    let product = 'graph';
    if (ari.startsWith('ari:cloud:graph::pull-request') && object.data?.providerName) product = object.data?.providerName || 'graph';
    else if ((0, $eYVId.isThirdPartyARI)(ari)) product = (0, $eYVId.parseThirdPartyProduct)(ari).split('.')[1];
    return product.toLowerCase();
}
module.exports["rollupActivitiesData"] = $d3ba7dec68c331b0$export$750d93207e30f59a;
module.exports["activityRoot"] = $d3ba7dec68c331b0$export$ea55e8e0446efa94;
module.exports["parseRootContainerARI"] = $d3ba7dec68c331b0$export$788e6013936a6bb4;
module.exports["filtersToMetadata"] = $d3ba7dec68c331b0$export$e8f56bed6776c7ea;
module.exports["filterInvalidFragments"] = $d3ba7dec68c331b0$export$e22863ec502608d2;
module.exports["isEmptyActivitiesWithErrorsResponse"] = $d3ba7dec68c331b0$export$c939d6148e47244a;
module.exports["getThirdPartyGraphProvider"] = $d3ba7dec68c331b0$export$618af76292d5645c;

});

parcelRegister("eYVId", function(module, exports) {
const $e92e795e072a2a50$var$thirdPartyRegex = new RegExp('^ari:third-party:(\\S+)::(\\S+)\\/(\\S+)$');
const $e92e795e072a2a50$export$4578ef3572b21f34 = (ari)=>{
    const result = $e92e795e072a2a50$var$thirdPartyRegex.exec(ari);
    if (!result) throw new Error(`Invalid third party ARI. Use ${$e92e795e072a2a50$export$fccbae65febb6fd4.name} to check before calling this function.`);
    const [_, resourceOwner] = result;
    return resourceOwner;
};
const $e92e795e072a2a50$export$fccbae65febb6fd4 = (ari)=>$e92e795e072a2a50$var$thirdPartyRegex.test(ari);
module.exports["parseThirdPartyProduct"] = $e92e795e072a2a50$export$4578ef3572b21f34;
module.exports["isThirdPartyARI"] = $e92e795e072a2a50$export$fccbae65febb6fd4;

});

parcelRegister("aLADI", function(module, exports) {
class $ac5ec249a3491591$export$16bbef74695765fd extends Error {
    constructor(message, status){
        super(message);
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        this.status = void 0;
        Object.setPrototypeOf(this, $ac5ec249a3491591$export$16bbef74695765fd.prototype);
        this.status = status;
        this.name = this.constructor.name;
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(message).stack;
    }
}
module.exports["ActivityError"] = $ac5ec249a3491591$export$16bbef74695765fd;

});

parcelRegister("9EvUR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $dJyLC = parcelRequire("dJyLC");

function $9c03756095734add$export$e412939fa65e9b05({ contentId: contentId, spaceKey: spaceKey, source: source }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    return (0, $cozmU.useMemo)(()=>Promise.resolve((0, $dJyLC.createConfluenceAutoformattingProvider)(spaceKey, contentId, createAnalyticsEvent, source)), [
        contentId,
        createAnalyticsEvent,
        spaceKey,
        source
    ]);
}
module.exports["useAutoformattingProvider"] = $9c03756095734add$export$e412939fa65e9b05;

});

parcelRegister("dJyLC", function(module, exports) {
const $80210b0d46d06b49$var$_isBlankOrEmpty = (str)=>!str || /^\s*$/.test(str);
const $80210b0d46d06b49$var$_sendAnalyticsEvent = (site, contentId, action, reason, createAnalyticsEvent, caller)=>{
    if (createAnalyticsEvent) createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'autoformat',
            actionSubjectId: 'undefinedLink autoformat',
            source: 'AutoformattingProvider',
            attributes: {
                site: site,
                contentId: contentId,
                reason: reason,
                caller: caller
            }
        }
    }).fire();
};
const $80210b0d46d06b49$export$79f57d12dd4f5b6b = (spaceKey, contentId, createAnalyticsEvent, caller)=>({
        '\\[(.*?)\\]\\(\\)': (match)=>{
            // If testing locally, you will need to set 'site' to an actual server such as "https://pug.jira-dev.com". Smart cards don't work with "localhost:8080".
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const site = location.origin;
            const title = match[1];
            if ($80210b0d46d06b49$var$_isBlankOrEmpty(title)) {
                $80210b0d46d06b49$var$_sendAnalyticsEvent(site, contentId, 'failed', 'empty title', createAnalyticsEvent, caller);
                return Promise.resolve({
                    type: ''
                });
            }
            if (!site || !spaceKey || !contentId) {
                $80210b0d46d06b49$var$_sendAnalyticsEvent(site, contentId, 'failed', 'missing site name, spaceKey or contentId', createAnalyticsEvent, caller);
                return Promise.resolve({
                    type: ''
                });
            }
            const encodedTitle = encodeURIComponent(title);
            const url = `${site}/wiki/pages/createpage.action?spaceKey=${spaceKey}&title=${encodedTitle}&linkCreation=true&fromPageId=${contentId}`;
            $80210b0d46d06b49$var$_sendAnalyticsEvent(site, contentId, 'success', 'autoformat succeeded', createAnalyticsEvent, caller);
            return Promise.resolve({
                type: 'inlineCard',
                attrs: {
                    url: url
                }
            });
        }
    });
const $80210b0d46d06b49$export$56f76dd14b7b11cc = (spaceKey, contentId, createAnalyticsEvent, caller)=>({
        getRules: ()=>Promise.resolve({
                ...$80210b0d46d06b49$export$79f57d12dd4f5b6b(spaceKey, contentId, createAnalyticsEvent, caller)
            })
    });
module.exports["createConfluenceAutoformattingProvider"] = $80210b0d46d06b49$export$56f76dd14b7b11cc;

});

parcelRegister("98Cy1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5UhfH = parcelRequire("5UhfH");

function $c1b5771e8fcb5e0a$export$de773409fd90c392(spaceId, objectId, product = 'confluence') {
    const [contextIdentProvider, setContextIdentProvider] = (0, $cozmU.useState)(undefined);
    const spaceIdPromise = (0, $5UhfH.useSpaceIdPromise)(spaceId);
    (0, $cozmU.useEffect)(()=>{
        setContextIdentProvider(spaceIdPromise.then((containerId)=>{
            return {
                containerId: containerId,
                objectId: objectId,
                product: product
            };
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        spaceId,
        objectId,
        product
    ]);
    return contextIdentProvider;
}
module.exports["useContextIdentifierProvider"] = $c1b5771e8fcb5e0a$export$de773409fd90c392;

});

parcelRegister("e2Vf0", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $dOBRD = parcelRequire("dOBRD");


var $kBU5m = parcelRequire("kBU5m");

const $ec33dccf9bb2dcb4$var$i18n = (0, $kSwu1.defineMessages)({
    invalidAltText: {
        id: "editor-features.alt-text.invalid",
        defaultMessage: "We aren\u2019t able to accept every possible character in Alt text. All Unicode letters and numbers are OK, but these are the only acceptable symbols: , ' . - _ ( )."
    }
});
const $ec33dccf9bb2dcb4$export$cbb71ca960bf2b80 = (0, $dOBRD.default)(({ mediaProvider: mediaProvider, ssrMediaProvider: ssrMediaProvider, intl: intl, featureFlags: featureFlags, mediaViewerExtensions: mediaViewerExtensions, fallbackMediaNameFetcher: fallbackMediaNameFetcher })=>{
    // IMPORTANT: If you change the code below, please also update the
    // platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/mediaPluginOptions/mediaPluginOptions.ts
    return {
        provider: mediaProvider,
        syncProvider: ssrMediaProvider,
        allowMediaSingle: true,
        allowResizing: true,
        allowResizingInTables: true,
        allowLinking: true,
        allowAltTextOnImages: true,
        allowCaptions: true,
        allowMediaInlineImages: true,
        allowPixelResizing: true,
        altTextValidator: (text)=>{
            const storageSupports = RegExp("^([\\p{L}\\p{N},'.\\s\\-_()]|&amp;[0-9]{2};)*$", "u");
            if (!storageSupports.test(text)) return [
                intl.formatMessage($ec33dccf9bb2dcb4$var$i18n.invalidAltText)
            ];
            return [];
        },
        featureFlags: (0, $kBU5m.getMediaFeatureFlags)(featureFlags),
        mediaViewerExtensions: mediaViewerExtensions,
        fallbackMediaNameFetcher: fallbackMediaNameFetcher
    };
});
module.exports["getMediaOptions"] = $ec33dccf9bb2dcb4$export$cbb71ca960bf2b80;

});

parcelRegister("kBU5m", function(module, exports) {
// featureFlags should come from getSessionData in @confluence/session-data
// IMPORTANT: If you change the code below, please also update the
// platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/mediaPluginOptions/mediaPluginOptions.ts
function $d887a76516ca8f8c$export$88f94a4dc797781a(featureFlags) {
    return featureFlags ? {
        mediaInline: true
    } : {};
}
module.exports["getMediaFeatureFlags"] = $d887a76516ca8f8c$export$88f94a4dc797781a;

});

parcelRegister("bKBay", function(module, exports) {

var $kzNtP = parcelRequire("kzNtP");


var $4IoVL = parcelRequire("4IoVL");


var $9wGTI = parcelRequire("9wGTI");


var $2TuWI = parcelRequire("2TuWI");


var $cga1x = parcelRequire("cga1x");

const $c8e2a8c8f6a050b8$var$cachedFetchSnippetMediaToken = (0, $kzNtP.cacheWithExp)((snippetId)=>(0, $2TuWI.fetchSnippetMediaToken)(snippetId), (auth)=>auth.token);
const $c8e2a8c8f6a050b8$var$createSnippetsAuthProvider = (snippetMediaAuth)=>async ()=>{
        return {
            token: snippetMediaAuth.token,
            clientId: snippetMediaAuth.clientId,
            baseUrl: snippetMediaAuth.baseUrl
        };
    };
const $c8e2a8c8f6a050b8$export$afd8d8bcda77bba6 = async (options)=>{
    const { snippetId: snippetId, scope: scope } = options;
    if (scope === (0, $cga1x.SnippetScope).GLOBAL) return {
        viewMediaClientConfig: {
            authProvider: (0, $4IoVL.getAuthFromContext),
            getAuthFromContext: $4IoVL.getAuthFromContext
        }
    };
    const snippetMediaAuth = await $c8e2a8c8f6a050b8$var$cachedFetchSnippetMediaToken.getValue(snippetId);
    const authProvider = $c8e2a8c8f6a050b8$var$createSnippetsAuthProvider(snippetMediaAuth);
    return {
        viewMediaClientConfig: {
            authProvider: authProvider,
            getAuthFromContext: $4IoVL.getAuthFromContext
        }
    };
};
const $c8e2a8c8f6a050b8$export$8618bed7f03db96e = async (options)=>{
    const { snippetId: snippetId } = options;
    const snippetMediaAuth = await $c8e2a8c8f6a050b8$var$cachedFetchSnippetMediaToken.getValue(snippetId);
    const authProvider = $c8e2a8c8f6a050b8$var$createSnippetsAuthProvider(snippetMediaAuth);
    return {
        viewMediaClientConfig: {
            authProvider: authProvider,
            getAuthFromContext: $4IoVL.getAuthFromContext
        },
        uploadMediaClientConfig: {
            authProvider: authProvider,
            getAuthFromContext: $4IoVL.getAuthFromContext,
            useSha256ForUploads: true
        },
        viewAndUploadMediaClientConfig: (0, $9wGTI.fg)('platform_media_video_captions') ? {
            authProvider: authProvider,
            getAuthFromContext: $4IoVL.getAuthFromContext
        } : undefined,
        uploadParams: {
            collection: snippetMediaAuth.collectionId
        }
    };
};
module.exports["createSnippetsRendererMediaProvider"] = $c8e2a8c8f6a050b8$export$afd8d8bcda77bba6;
module.exports["createSnippetsEditorMediaProvider"] = $c8e2a8c8f6a050b8$export$8618bed7f03db96e;

});

parcelRegister("kzNtP", function(module, exports) {

var $6AroL = parcelRequire("6AroL");


var $3u5lg = parcelRequire("3u5lg");

const $852f3734fd3706d8$var$BUFFER_MS = 60000; // refresh token 60 seconds before it expires
const $852f3734fd3706d8$var$EMPTY = [
    -Infinity,
    null,
    null
];
function $852f3734fd3706d8$export$d18015d30d3c28a4(asyncFunction, tokenOrExpInMsAccessor, tokenExpBufferInMs = $852f3734fd3706d8$var$BUFFER_MS) {
    const cache = {};
    async function getValue(arg, force) {
        // It is ok to have clashing hash because we are going to check args anyway
        // Worse case is calling fn() more often than it should
        let hash = '';
        try {
            hash = JSON.stringify(arg);
        } catch  {}
        const [exp, lastArg, lastValue] = cache[hash] || $852f3734fd3706d8$var$EMPTY;
        if (force || exp <= Date.now() || !(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(lastArg, arg)) {
            const value = await asyncFunction(arg);
            let tokenOrExp = null;
            try {
                tokenOrExp = tokenOrExpInMsAccessor(value);
            } catch (e) {}
            let exp = null;
            if (tokenOrExp) {
                if (!isNaN(tokenOrExp)) exp = Number(tokenOrExp);
                else if (typeof tokenOrExp === 'string') try {
                    exp = (0, $6AroL.default)(tokenOrExp).exp * 1000 - tokenExpBufferInMs;
                } catch (e) {}
            }
            cache[hash] = exp === null ? $852f3734fd3706d8$var$EMPTY : [
                exp,
                arg,
                value
            ];
            return value;
        }
        return lastValue;
    }
    return {
        forceGetValue: (arg)=>{
            return getValue(arg, true);
        },
        getValue: (arg)=>{
            return getValue(arg, false);
        }
    };
}
module.exports["cacheWithExp"] = $852f3734fd3706d8$export$d18015d30d3c28a4;

});

parcelRegister("6AroL", function(module, exports) {
function $4cbb5ba451601f11$var$e(e) {
    this.message = e;
}
$4cbb5ba451601f11$var$e.prototype = new Error, $4cbb5ba451601f11$var$e.prototype.name = "InvalidCharacterError";
var $4cbb5ba451601f11$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $4cbb5ba451601f11$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $4cbb5ba451601f11$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($4cbb5ba451601f11$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $4cbb5ba451601f11$var$r(t);
    }
}
function $4cbb5ba451601f11$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $4cbb5ba451601f11$var$o(e, r) {
    if ("string" != typeof e) throw new $4cbb5ba451601f11$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($4cbb5ba451601f11$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $4cbb5ba451601f11$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$4cbb5ba451601f11$export$b9721ef022f71a68.prototype = new Error, $4cbb5ba451601f11$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $4cbb5ba451601f11$export$2e2bcd8739ae039 = $4cbb5ba451601f11$var$o;
module.exports["default"] = $4cbb5ba451601f11$export$2e2bcd8739ae039;

});

parcelRegister("4IoVL", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $hfrng = parcelRequire("hfrng");


var $3kI72 = parcelRequire("3kI72");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $1NBp8 = parcelRequire("1NBp8");


var $2TuWI = parcelRequire("2TuWI");


var $cga1x = parcelRequire("cga1x");


var $kzNtP = parcelRequire("kzNtP");


var $c4QoG = parcelRequire("c4QoG");


var $I0A3i = parcelRequire("I0A3i");


var $kQiXs = parcelRequire("kQiXs");

const $17b0f8a5b73de479$var$DEFAULT_CONFIG = {
    clientId: '',
    fileStoreUrl: ''
};
const $17b0f8a5b73de479$var$cachedGetDownloadData = (0, $kzNtP.cacheWithExp)(async ({ contentId: contentId, contentAri: contentAri, contentProduct: contentProduct, isExternalShare: isExternalShare, shareToken: shareToken })=>{
    if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $3kI72.requiresCrossProductAuth)({
        hostProduct: 'confluence-page',
        sourceProduct: contentProduct
    }) && // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $6mKj3.expVal)('platform_synced_block', 'isEnabled', false)) return (0, $3kI72.fetchTokenForSourceProduct)({
        contentAri: contentAri ?? contentId,
        contentId: contentId,
        sourceProduct: contentProduct
    });
    if (isExternalShare && shareToken && (0, $6mKj3.expValEquals)('add_anonid_in_media_token', 'cohort', 'test')) {
        const tokenResponse = await (0, $I0A3i.fetchExternalContentMediaSessionToken)(shareToken);
        const tokenData = tokenResponse?.data;
        return {
            token: tokenData?.externalContentMediaSession?.accessTokens?.readOnlyToken?.value || '',
            config: tokenData?.externalContentMediaSession?.configuration || $17b0f8a5b73de479$var$DEFAULT_CONFIG
        };
    }
    // Fallback to existing logic for backward compatibility
    const response = await (isExternalShare ? (0, $I0A3i.fetchExternalShareMediaToken) : (0, $I0A3i.fetchMediaToken))(contentId);
    const data = response?.data;
    const externalData = data?.['singleContent'];
    const content = isExternalShare ? externalData : data?.['content']?.nodes?.[0];
    return {
        token: content?.body?.atlas_doc_format?.mediaToken?.token || '',
        config: data?.mediaConfiguration || $17b0f8a5b73de479$var$DEFAULT_CONFIG
    };
}, (json)=>json.token);
const $17b0f8a5b73de479$export$6176af039388fdbf = (dataGetter)=>async ()=>{
        const data = await dataGetter();
        return {
            token: data?.token || '',
            clientId: data?.config?.clientId || '',
            baseUrl: data?.config?.fileStoreUrl || ''
        };
    };
const $17b0f8a5b73de479$export$da46cefd33160c4d = (viewDataGetter, uploadDataGetter)=>async (params)=>{
        // Currently, supplying upload token only for file and collection update action.
        // If no params are provided, the view token is returned.
        const isUpdateAction = !!params?.access?.find(({ type: type, actions: actions })=>(type === 'file' || type == 'collection') && actions.includes('update'));
        const data = await (isUpdateAction ? uploadDataGetter() : viewDataGetter());
        return {
            token: data?.token || '',
            clientId: data?.config?.clientId || '',
            baseUrl: data?.config?.fileStoreUrl || ''
        };
    };
const $17b0f8a5b73de479$export$6cb774192b5cd093 = (contextId)=>{
    try {
        const { snippetId: snippetId, scope: scope } = JSON.parse(contextId);
        return snippetId ? {
            snippetId: snippetId,
            scope: scope
        } : undefined;
    } catch  {} // not JSON or not a SnippetContextId.
};
const $17b0f8a5b73de479$export$724cb324eb7535cd = async (contextId, contentProduct, contentAri)=>{
    if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $3kI72.requiresCrossProductAuth)({
        hostProduct: 'confluence-page',
        sourceProduct: contentProduct
    }) && // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $6mKj3.expVal)('platform_synced_block', 'isEnabled', false)) {
        const auth = await (0, $3kI72.fetchTokenForSourceProduct)({
            contentAri: contentAri ?? contextId,
            contentId: contextId,
            sourceProduct: contentProduct
        });
        return {
            clientId: auth.config.clientId || '',
            token: auth.token || '',
            baseUrl: auth.config.fileStoreUrl || ''
        };
    }
    if ((0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false)) {
        const snippetContext = $17b0f8a5b73de479$export$6cb774192b5cd093(contextId);
        if (snippetContext && snippetContext.scope !== (0, $cga1x.SnippetScope).GLOBAL) {
            const auth = await (0, $2TuWI.fetchSnippetMediaToken)(snippetContext.snippetId);
            return {
                clientId: auth.clientId,
                token: auth.token,
                baseUrl: auth.baseUrl
            };
        }
    }
    const { collectionId: collectionId, templateId: templateId, spaceKey: spaceKey } = (0, $c4QoG.getTemplateMediaContextValues)(contextId);
    // template media informtion is stored slightly different in the context
    // to be able to discern which call to make
    if (collectionId || templateId) return (0, $c4QoG.getTemplateMediaAuth)({
        collectionId: collectionId,
        spaceKey: spaceKey,
        templateId: templateId
    });
    const response = await (0, $I0A3i.fetchMediaToken)(contextId);
    const { clientId: clientId = '', fileStoreUrl: fileStoreUrl = '' } = response?.data?.mediaConfiguration || {};
    return {
        clientId: clientId,
        token: response?.data?.content?.nodes?.[0]?.body?.atlas_doc_format?.mediaToken?.token || '',
        baseUrl: fileStoreUrl || ''
    };
};
const $17b0f8a5b73de479$var$cachedGetUploadData = (0, $kzNtP.cacheWithExp)(async (options)=>{
    const response = options.contentType === 'comment' && options.cloudId ? await (0, $I0A3i.getCommentUploadToken)(options.contentId, options.cloudId) : await (0, $I0A3i.getUploadToken)(options.contentId);
    const session = response?.data?.contentMediaSession;
    return {
        token: session?.token?.value || '',
        config: session?.configuration || $17b0f8a5b73de479$var$DEFAULT_CONFIG,
        collectionId: session?.collection || ''
    };
}, (json)=>json.token);
const $17b0f8a5b73de479$var$getUploadCollectionId = async (options)=>{
    const uploadData = await $17b0f8a5b73de479$var$cachedGetUploadData.getValue(options);
    return uploadData.collectionId;
};
const $17b0f8a5b73de479$var$createUploadAuthProviderDataGetter = (options)=>()=>$17b0f8a5b73de479$var$cachedGetUploadData.getValue(options);
const $17b0f8a5b73de479$var$getUploadMediaClientConfig = async (options)=>({
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf($17b0f8a5b73de479$var$createUploadAuthProviderDataGetter(options)),
        getAuthFromContext: $17b0f8a5b73de479$export$724cb324eb7535cd,
        useSha256ForUploads: true
    });
const $17b0f8a5b73de479$var$cachedGetExportDspData = (0, $kzNtP.cacheWithExp)(async ({ contentId: contentId, spaceKey: spaceKey })=>{
    const response = await (0, $I0A3i.getIsExportEnabledForContent)(contentId, spaceKey);
    const isExportAllowed = response?.data?.dataSecurityPolicy?.isActionEnabledForContent?.allowed;
    return {
        isExportAllowed: isExportAllowed,
        exp: Date.now() + 60000
    };
}, (json)=>json.exp);
const $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy = async (options)=>{
    if (!(0, $9wGTI.fg)('dlp_attachment_download_respects_data_export_dsp')) return false;
    const { contentId: contentId, spaceKey: spaceKey, mediaDspContentId: mediaDspContentId } = options;
    if (!(0, $9wGTI.fg)('dlp_allow_content_dsp_check_without_space_details')) {
        // Note: If you can't provide spaceKey, you can't enable downloads in media viewer
        if (!spaceKey) return true;
    }
    try {
        const relevantContentId = mediaDspContentId || contentId;
        const response = await $17b0f8a5b73de479$var$cachedGetExportDspData.getValue({
            contentId: relevantContentId,
            spaceKey: spaceKey
        });
        const isExportAllowed = response?.isExportAllowed;
        return !isExportAllowed;
    } catch  {
        // Fails CLOSED
        return true;
    }
};
const $17b0f8a5b73de479$var$createViewAuthProviderDataGetter = (options)=>async ()=>{
        // Only pass contentId, isExternalShare, and shareToken to the cacheWithExp function
        // to avoid unnecessary re-fetching of the token if other options differ
        const authQueryOptions = {
            contentId: options.contentId,
            contentAri: options.contentAri,
            contentProduct: options.contentProduct,
            isExternalShare: options.isExternalShare,
            shareToken: options.shareToken
        };
        let data = await $17b0f8a5b73de479$var$cachedGetDownloadData.getValue(authQueryOptions);
        if (options.mediaToken) data = {
            ...data,
            token: options.mediaToken
        };
        // For drafts mediaToken by default is null and created once any media added to them
        // So, once publishing draft that just got media but token was cached before as `null`
        // we need to re-fetch the token without the cache
        if (!data.token) data = await $17b0f8a5b73de479$var$cachedGetDownloadData.forceGetValue(authQueryOptions);
        return data;
    };
const $17b0f8a5b73de479$export$9891be2d4fea1436 = async (options)=>{
    return {
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf($17b0f8a5b73de479$var$createViewAuthProviderDataGetter(options)),
        getAuthFromContext: (contextId)=>$17b0f8a5b73de479$export$724cb324eb7535cd(contextId, options.contentProduct, options.contentAri)
    };
};
const $17b0f8a5b73de479$export$e43b4f8676d4deae = async (options)=>({
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$da46cefd33160c4d($17b0f8a5b73de479$var$createViewAuthProviderDataGetter(options), $17b0f8a5b73de479$var$createUploadAuthProviderDataGetter(options)),
        getAuthFromContext: (contextId)=>$17b0f8a5b73de479$export$724cb324eb7535cd(contextId, options.contentProduct, options.contentAri)
    });
const $17b0f8a5b73de479$export$39c5d94533971b79 = async (options)=>({
        viewMediaClientConfig: await $17b0f8a5b73de479$export$9891be2d4fea1436(options)
    });
const $17b0f8a5b73de479$export$4887a1cde0f552dc = async (options)=>{
    $17b0f8a5b73de479$var$registerGlobalFileAddedListener(options);
    const [viewMediaClientConfig, uploadMediaClientConfig, viewAndUploadMediaClientConfig, collection] = await Promise.all([
        $17b0f8a5b73de479$export$9891be2d4fea1436(options),
        $17b0f8a5b73de479$var$getUploadMediaClientConfig(options),
        (0, $9wGTI.fg)('platform_media_video_captions') ? $17b0f8a5b73de479$export$e43b4f8676d4deae(options) : undefined,
        $17b0f8a5b73de479$var$getUploadCollectionId(options)
    ]);
    return {
        viewMediaClientConfig: viewMediaClientConfig,
        uploadParams: {
            collection: collection,
            onUploadRejection: options.onUploadRejection
        },
        uploadMediaClientConfig: uploadMediaClientConfig,
        viewAndUploadMediaClientConfig: viewAndUploadMediaClientConfig
    };
};
const $17b0f8a5b73de479$export$c64cc28e06e9eda = (pathname)=>{
    return !!(0, $1NBp8.PDF_EXPORT_PAGE).match(pathname);
};
let $17b0f8a5b73de479$var$previousAttachUploadedMediaListener;
const $17b0f8a5b73de479$var$registerGlobalFileAddedListener = (options)=>{
    if ($17b0f8a5b73de479$var$previousAttachUploadedMediaListener) (0, $hfrng.globalMediaEventEmitter).off('file-added', $17b0f8a5b73de479$var$previousAttachUploadedMediaListener);
    $17b0f8a5b73de479$var$previousAttachUploadedMediaListener = (0, $kQiXs.attachUploadedMedia)(options);
    (0, $hfrng.globalMediaEventEmitter).on('file-added', $17b0f8a5b73de479$var$previousAttachUploadedMediaListener);
};
const $17b0f8a5b73de479$var$createViewAuthProviderDataGetterDynamic = (getOptions)=>async ()=>{
        const options = getOptions();
        return $17b0f8a5b73de479$var$createViewAuthProviderDataGetter(options)();
    };
const $17b0f8a5b73de479$var$createUploadAuthProviderDataGetterDynamic = (getOptions)=>async ()=>{
        const options = getOptions();
        return $17b0f8a5b73de479$var$createUploadAuthProviderDataGetter(options)();
    };
const $17b0f8a5b73de479$export$af68076132bb2083 = async (getOptions)=>{
    const options = getOptions();
    return {
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf($17b0f8a5b73de479$var$createViewAuthProviderDataGetterDynamic(getOptions)),
        getAuthFromContext: (contextId)=>$17b0f8a5b73de479$export$724cb324eb7535cd(contextId, getOptions().contentProduct, getOptions().contentAri)
    };
};
const $17b0f8a5b73de479$export$de798661504725b9 = async (getOptions)=>{
    const options = getOptions();
    return {
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$da46cefd33160c4d($17b0f8a5b73de479$var$createViewAuthProviderDataGetterDynamic(getOptions), $17b0f8a5b73de479$var$createUploadAuthProviderDataGetterDynamic(getOptions)),
        getAuthFromContext: (contextId)=>$17b0f8a5b73de479$export$724cb324eb7535cd(contextId, getOptions().contentProduct, getOptions().contentAri)
    };
};
const $17b0f8a5b73de479$export$221251ab27f63f41 = async (getOptions)=>({
        viewMediaClientConfig: await $17b0f8a5b73de479$export$af68076132bb2083(getOptions)
    });
const $17b0f8a5b73de479$export$e6a9b44aa174a3d4 = async (getOptions)=>{
    const initialOptions = getOptions();
    $17b0f8a5b73de479$var$registerGlobalFileAddedListener(initialOptions);
    if ((0, $9wGTI.fg)('confluence_frontend_fix_stale_media_collection')) {
        // Fix for stale media collection bug when the provider is reused across SPA navigations
        // (confluence_frontend_transition_preloading_system). Without this fix, uploadParams.collection
        // and the file-added listener remain frozen to the page active at provider creation time.
        // Register the global file-added listener dynamically so that SPA navigations always
        // register the attachment callback against the current page's contentId.
        const registerDynamicFileAddedListener = ()=>{
            $17b0f8a5b73de479$var$registerGlobalFileAddedListener(getOptions());
        };
        // Track the last contentId we fetched upload data for, and the cached result.
        // This lets us detect a contentId change and eagerly re-fetch before any upload.
        let lastFetchedContentId = initialOptions.contentId;
        let latestUploadData;
        // Deduplicate concurrent calls to refreshUploadDataIfNeeded — if a refresh is already
        // in-flight (e.g. from useMediaOptions and authProvider both calling simultaneously),
        // subsequent callers share the same promise rather than racing to write latestUploadData.
        let inFlightRefresh;
        // Refresh upload data for the current options if contentId has changed since the
        // last fetch. Concurrent calls are deduplicated via inFlightRefresh.
        // Called by useMediaOptions on navigation so all uploadParams.collection read sites
        // get the correct collection without needing to do anything special themselves.
        const refreshUploadDataIfNeeded = async ()=>{
            const currentOptions = getOptions();
            if (currentOptions.contentId !== lastFetchedContentId) {
                if (inFlightRefresh) return inFlightRefresh;
                inFlightRefresh = (async ()=>{
                    registerDynamicFileAddedListener();
                    latestUploadData = await $17b0f8a5b73de479$var$cachedGetUploadData.getValue(currentOptions);
                    lastFetchedContentId = currentOptions.contentId;
                    inFlightRefresh = undefined;
                })();
                return inFlightRefresh;
            }
        };
        // Build a fully-dynamic uploadMediaClientConfig whose authProvider always fetches
        // upload data for the CURRENT options so tokens stay correct across SPA navigations.
        // Note: we do NOT call registerDynamicFileAddedListener here — the listener is only
        // re-registered in refreshUploadDataIfNeeded (on actual navigation), not on every
        // token fetch, to avoid unnecessary teardown/rebuild of the module-level singleton.
        const dynamicUploadMediaClientConfig = {
            authProvider: $17b0f8a5b73de479$export$6176af039388fdbf(async ()=>{
                const currentOptions = getOptions();
                const uploadData = await $17b0f8a5b73de479$var$cachedGetUploadData.getValue(currentOptions);
                latestUploadData = uploadData;
                lastFetchedContentId = currentOptions.contentId;
                return uploadData;
            }),
            getAuthFromContext: $17b0f8a5b73de479$export$724cb324eb7535cd,
            useSha256ForUploads: true
        };
        // Fetch all async dependencies in parallel — no waterfall.
        const [viewMediaClientConfig, viewAndUploadMediaClientConfig, initialUploadData] = await Promise.all([
            $17b0f8a5b73de479$export$af68076132bb2083(()=>getOptions()),
            (0, $9wGTI.fg)('platform_media_video_captions') ? $17b0f8a5b73de479$export$de798661504725b9(()=>getOptions()) : undefined,
            $17b0f8a5b73de479$var$cachedGetUploadData.getValue(getOptions())
        ]);
        latestUploadData = initialUploadData;
        return {
            viewMediaClientConfig: viewMediaClientConfig,
            // uploadParams is resolved via a getter so SPA navigations don't leave the collection
            // frozen to the page that was active when this provider was first created.
            get uploadParams () {
                return {
                    collection: latestUploadData.collectionId,
                    onUploadRejection: getOptions().onUploadRejection
                };
            },
            refreshUploadDataIfNeeded: refreshUploadDataIfNeeded,
            uploadMediaClientConfig: dynamicUploadMediaClientConfig,
            viewAndUploadMediaClientConfig: viewAndUploadMediaClientConfig
        };
    }
    // Original (pre-fix) implementation: upload params and file-added listener are
    // frozen at creation time. Used when confluence_frontend_fix_stale_media_collection is off.
    const [viewMediaClientConfig, uploadMediaClientConfig, viewAndUploadMediaClientConfig, collection] = await Promise.all([
        $17b0f8a5b73de479$export$af68076132bb2083(()=>getOptions()),
        (async ()=>{
            const opts = getOptions();
            return $17b0f8a5b73de479$var$getUploadMediaClientConfig(opts);
        })(),
        (0, $9wGTI.fg)('platform_media_video_captions') ? $17b0f8a5b73de479$export$de798661504725b9(()=>getOptions()) : undefined,
        (async ()=>{
            const opts = getOptions();
            return $17b0f8a5b73de479$var$getUploadCollectionId(opts);
        })()
    ]);
    return {
        viewMediaClientConfig: viewMediaClientConfig,
        uploadParams: {
            collection: collection,
            onUploadRejection: initialOptions.onUploadRejection
        },
        uploadMediaClientConfig: uploadMediaClientConfig,
        viewAndUploadMediaClientConfig: viewAndUploadMediaClientConfig
    };
}; /**
 * Usage sketch (React):
 * const liveOptionsRef = useRef(currentOptions);
 * liveOptionsRef.current = currentOptions; // update on changes
 * const providerPromise = useMemo(() => createEditorMediaProviderDynamic(() => liveOptionsRef.current), []);
 * editorApi.media.actions.setProvider(providerPromise);
 */ 
module.exports["createAuthProvider"] = $17b0f8a5b73de479$export$6176af039388fdbf;
module.exports["getAuthFromContext"] = $17b0f8a5b73de479$export$724cb324eb7535cd;
module.exports["getViewMediaClientConfig"] = $17b0f8a5b73de479$export$9891be2d4fea1436;
module.exports["createRendererMediaProvider"] = $17b0f8a5b73de479$export$39c5d94533971b79;
module.exports["createEditorMediaProvider"] = $17b0f8a5b73de479$export$4887a1cde0f552dc;
module.exports["controlDataExportOnCertainFeatures"] = $17b0f8a5b73de479$export$c64cc28e06e9eda;
module.exports["createRendererMediaProviderDynamic"] = $17b0f8a5b73de479$export$221251ab27f63f41;
module.exports["createEditorMediaProviderDynamic"] = $17b0f8a5b73de479$export$e6a9b44aa174a3d4;

});

parcelRegister("3kI72", function(module, exports) {

var $oWJUu = parcelRequire("oWJUu");


var $55mlV = parcelRequire("55mlV");

const $515968ab7e772985$export$8953ee4427cc19a2 = ({ hostProduct: hostProduct, sourceProduct: sourceProduct })=>{
    return !!sourceProduct && sourceProduct !== hostProduct;
};
const $515968ab7e772985$export$9f88fc74c33fbfe = ({ contentAri: contentAri, contentId: contentId, sourceProduct: sourceProduct })=>{
    switch(sourceProduct){
        case 'confluence-page':
            return (0, $oWJUu.fetchMediaToken)(contentId);
        case 'jira-work-item':
            return (0, $55mlV.fetchJiraMediaToken)(contentAri);
        default:
            throw new Error(`Unsupported source product for token fetch: ${sourceProduct}`);
    }
};
module.exports["requiresCrossProductAuth"] = $515968ab7e772985$export$8953ee4427cc19a2;
module.exports["fetchTokenForSourceProduct"] = $515968ab7e772985$export$9f88fc74c33fbfe;

});

parcelRegister("oWJUu", function(module, exports) {

var $jv11C = parcelRequire("jv11C");


var $48FpT = parcelRequire("48FpT");

const $61ef070287c5800f$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $61ef070287c5800f$var$AGG_HEADERS = {
    'X-ExperimentalApi': 'confluence-agg-beta'
};
const $61ef070287c5800f$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $61ef070287c5800f$var$GET_CONTENT_MEDIA_SESSION_OPERATION_NAME = 'MediaUploadTokenQuery';
const $61ef070287c5800f$var$GET_CONTENT_MEDIA_SESSION_QUERY = `query ${$61ef070287c5800f$var$GET_CONTENT_MEDIA_SESSION_OPERATION_NAME}($contentId: ID!) {
	contentMediaSession(contentId: $contentId) {
		token {
			value
		}
		configuration {
			clientId
			fileStoreUrl
		}
		collection
	}
}`;
const $61ef070287c5800f$var$getContentMediaSession = async (contentId)=>{
    const bodyData = {
        query: $61ef070287c5800f$var$GET_CONTENT_MEDIA_SESSION_QUERY,
        operationName: $61ef070287c5800f$var$GET_CONTENT_MEDIA_SESSION_OPERATION_NAME,
        variables: {
            contentId: contentId
        }
    };
    const response = await (0, $48FpT.fetchWithRetry)($61ef070287c5800f$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            ...$61ef070287c5800f$var$COMMON_HEADERS,
            ...$61ef070287c5800f$var$AGG_HEADERS
        },
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new Error(`Failed to get content media session: ${response.statusText}`);
    const result = await response.json();
    return result;
};
const $61ef070287c5800f$export$2b7fb70f168591f8 = async (contentId)=>{
    try {
        const response = await $61ef070287c5800f$var$getContentMediaSession(contentId);
        const contentData = response.data?.contentMediaSession;
        const token = contentData?.token?.value;
        const configuration = contentData?.configuration;
        const collection = contentData?.collection;
        if (!token || !configuration || !collection) throw new Error('Failed to get content media session data');
        return {
            config: configuration,
            token: token,
            collectionId: collection
        };
    } catch (error) {
        (0, $jv11C.logException)(error, {
            location: 'editor-synced-block-provider/fetchMediaToken'
        });
        const errorMsg = error instanceof Error ? error.message : String(error);
        throw new Error(`Failed to get content media session: ${errorMsg}`);
    }
};
module.exports["fetchMediaToken"] = $61ef070287c5800f$export$2b7fb70f168591f8;

});

parcelRegister("55mlV", function(module, exports) {

var $jv11C = parcelRequire("jv11C");


var $48FpT = parcelRequire("48FpT");

const $05854aa166d857a3$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $05854aa166d857a3$var$AGG_HEADERS = {
    'X-ExperimentalApi': 'confluence-agg-beta'
};
const $05854aa166d857a3$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $05854aa166d857a3$var$JIRA_MEDIA_READ_TOKEN_MAX_TOKEN_LENGTH = 2048;
const $05854aa166d857a3$var$GET_JIRA_MEDIA_READ_TOKEN_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_JIRA_MEDIA_TOKEN';
const $05854aa166d857a3$var$GET_JIRA_MEDIA_READ_TOKEN_QUERY = `query ${$05854aa166d857a3$var$GET_JIRA_MEDIA_READ_TOKEN_OPERATION_NAME}($issueAri: ID!, $maxTokenLength: Int!) {
  jira {
    issueById(id: $issueAri) {
      mediaReadToken(maxTokenLength: $maxTokenLength) @optIn(to: "JiraMediaReadTokenInIssue") {
        clientId
        endpointUrl
        tokenLifespanInSeconds
        tokensWithFiles {
          edges {
            node {
              token
            }
          }
        }
      }
    }
  }
}`;
const $05854aa166d857a3$var$getJiraMediaReadToken = async (issueAri)=>{
    const bodyData = {
        query: $05854aa166d857a3$var$GET_JIRA_MEDIA_READ_TOKEN_QUERY,
        operationName: $05854aa166d857a3$var$GET_JIRA_MEDIA_READ_TOKEN_OPERATION_NAME,
        variables: {
            issueAri: issueAri,
            maxTokenLength: $05854aa166d857a3$var$JIRA_MEDIA_READ_TOKEN_MAX_TOKEN_LENGTH
        }
    };
    const response = await (0, $48FpT.fetchWithRetry)($05854aa166d857a3$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            ...$05854aa166d857a3$var$COMMON_HEADERS,
            ...$05854aa166d857a3$var$AGG_HEADERS
        },
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new Error(`Failed to get Jira media read token: ${response.statusText}`);
    return await response.json();
};
const $05854aa166d857a3$export$5bc7dcc953e26849 = async (issueAri)=>{
    try {
        const response = await $05854aa166d857a3$var$getJiraMediaReadToken(issueAri);
        const mediaReadToken = response.data?.jira?.issueById?.mediaReadToken;
        const clientId = mediaReadToken?.clientId;
        const endpointUrl = mediaReadToken?.endpointUrl;
        // Use the first available token from tokensWithFiles, or fall back to empty string.
        // A generic read token (without specific file IDs) is sufficient for rendering.
        const token = mediaReadToken?.tokensWithFiles?.edges?.[0]?.node?.token ?? '';
        if (!clientId || !endpointUrl) throw new Error('Missing clientId or endpointUrl');
        return {
            config: {
                clientId: clientId,
                fileStoreUrl: endpointUrl
            },
            token: token
        };
    } catch (error) {
        (0, $jv11C.logException)(error, {
            location: 'editor-synced-block-provider/fetchJiraMediaToken'
        });
        const errorMsg = error instanceof Error ? error.message : String(error);
        throw new Error(`Failed to get Jira media read token: ${errorMsg}`);
    }
};
module.exports["fetchJiraMediaToken"] = $05854aa166d857a3$export$5bc7dcc953e26849;

});

parcelRegister("2TuWI", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $15f98e0699368f56$var$BLOCK_SERVICE_SNIPPETS_MEDIA_TOKEN_URL = '/gateway/api/blocks/v1/snippets';
const $15f98e0699368f56$export$73c71f9590626082 = async (snippetId)=>{
    try {
        const response = await (0, $f7B1p.cfetch)(`${$15f98e0699368f56$var$BLOCK_SERVICE_SNIPPETS_MEDIA_TOKEN_URL}/${snippetId}/media-token`, {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        });
        const data = await response.json();
        const collectionId = data.collectionNames?.[snippetId];
        return {
            clientId: data.config.clientId,
            token: data.token,
            baseUrl: data.config.fileStoreUrl,
            ...collectionId !== undefined && {
                collectionId: collectionId
            }
        };
    } catch (error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).INTEGRATIONS
        });
        throw error;
    }
};
module.exports["fetchSnippetMediaToken"] = $15f98e0699368f56$export$73c71f9590626082;

});

parcelRegister("c4QoG", function(module, exports) {

var $kzNtP = parcelRequire("kzNtP");


var $4IoVL = parcelRequire("4IoVL");


var $7EQEd = parcelRequire("7EQEd");

// blueprints/templates in uuid form are technically a new template
const $30f3da79b755ac50$var$isBlueprint = (templateId)=>!/^[0-9]+$/.test(templateId);
const $30f3da79b755ac50$var$isNewTemplate = (templateId)=>!templateId || templateId === '';
const $30f3da79b755ac50$var$shouldUseTemplateId = (templateIds)=>templateIds.length;
const $30f3da79b755ac50$var$formatTemplateId = (templateId, isFirstLoad, isUpload)=>{
    if ($30f3da79b755ac50$var$isNewTemplate(templateId) || $30f3da79b755ac50$var$isBlueprint(templateId) && isUpload || !isFirstLoad) return [];
    else return [
        templateId
    ];
};
const $30f3da79b755ac50$var$cachedGetTemplateUploadData = (0, $kzNtP.cacheWithExp)(async (options)=>{
    const response = await (0, $7EQEd.getTemplateUploadToken)({
        spaceKey: options.spaceKey,
        templateIds: options.templateIds,
        collectionId: options.collectionId
    });
    const session = response?.data?.templateMediaSession;
    const collectionId = session?.collections?.[0]?.value || '';
    return {
        token: session?.uploadToken?.value || '',
        config: session?.configuration || {
            fileStoreUrl: '',
            clientId: ''
        },
        collectionId: collectionId
    };
}, (json)=>json.token);
const $30f3da79b755ac50$var$cachedGetTemplateDownloadData = (0, $kzNtP.cacheWithExp)(async (options)=>{
    const response = await (0, $7EQEd.getTemplateDownloadToken)({
        spaceKey: options.spaceKey,
        templateIds: options.templateIds,
        collectionId: options.collectionId
    });
    return {
        token: response?.data?.templateMediaSession?.downloadToken?.value || '',
        config: response?.data?.templateMediaSession?.configuration || {
            fileStoreUrl: '',
            clientId: ''
        }
    };
}, (json)=>json.token);
const $30f3da79b755ac50$export$ea5d75839efa2930 = async (editorOptions)=>{
    const templateIds = $30f3da79b755ac50$var$formatTemplateId(editorOptions.templateId, !editorOptions.collectionId, true);
    const uploadData = await $30f3da79b755ac50$var$cachedGetTemplateUploadData.getValue({
        ...editorOptions,
        templateIds: templateIds,
        collectionId: $30f3da79b755ac50$var$shouldUseTemplateId(templateIds) ? null : editorOptions.collectionId
    });
    return uploadData.collectionId;
};
const $30f3da79b755ac50$export$8867d7a854cea94a = (contextId)=>{
    let collectionId, templateId, spaceKey = null;
    try {
        ({ collectionId: collectionId, templateId: templateId, spaceKey: spaceKey } = JSON.parse(contextId));
    } catch (_) {}
    return {
        collectionId: collectionId,
        templateId: templateId,
        spaceKey: spaceKey
    };
};
const $30f3da79b755ac50$export$c52d46b5239d3052 = async ({ templateId: templateId, collectionId: collectionId, spaceKey: spaceKey })=>{
    // if given a templateId the source is the renderer, otherwise it's the editor
    const response = await (0, $7EQEd.getTemplateDownloadToken)({
        templateIds: templateId ? [
            templateId
        ] : [],
        collectionId: templateId ? null : collectionId,
        spaceKey: spaceKey
    });
    const { clientId: clientId = '', fileStoreUrl: fileStoreUrl = '' } = response?.data?.templateMediaSession?.configuration || {};
    return {
        clientId: clientId,
        token: response?.data?.templateMediaSession?.downloadToken?.value || '',
        baseUrl: fileStoreUrl
    };
};
const $30f3da79b755ac50$var$getAuthFromContext = async (contextId)=>{
    const { collectionId: collectionId, templateId: templateId, spaceKey: spaceKey } = $30f3da79b755ac50$export$8867d7a854cea94a(contextId);
    // templateID = null/undefined -> not template type
    // templateId = "" -> new template
    // templateId = "2394234324" -> user modified template
    // templateId = "23j4h-23jk4h-kj2h34-kj23h4" -> new template
    if (typeof collectionId !== 'string' && typeof templateId !== 'string') // copy source is page contentType
    return (0, $4IoVL.getAuthFromContext)(contextId);
    return $30f3da79b755ac50$export$c52d46b5239d3052({
        collectionId: collectionId,
        spaceKey: spaceKey,
        templateId: templateId
    });
};
const $30f3da79b755ac50$export$e7a68a11bc740f17 = (options)=>{
    return {
        authProvider: (0, $4IoVL.createAuthProvider)(async ()=>$30f3da79b755ac50$var$cachedGetTemplateDownloadData.getValue(options)),
        getAuthFromContext: $30f3da79b755ac50$var$getAuthFromContext
    };
};
const $30f3da79b755ac50$export$4f3a63958bc8e871 = (options)=>{
    return Promise.resolve({
        viewMediaClientConfig: $30f3da79b755ac50$export$e7a68a11bc740f17(options)
    });
};
const $30f3da79b755ac50$export$582e7673a587f23a = async (options)=>{
    let isFirstDownload = true;
    let collectionId = options.collectionId;
    const getEditorViewTemplateMediaClientConfig = (editorOptions)=>{
        return {
            authProvider: (0, $4IoVL.createAuthProvider)(async ()=>{
                const templateIds = $30f3da79b755ac50$var$formatTemplateId(editorOptions.templateId, isFirstDownload, false);
                isFirstDownload = false;
                return $30f3da79b755ac50$var$cachedGetTemplateDownloadData.getValue({
                    ...editorOptions,
                    templateIds: templateIds,
                    collectionId: $30f3da79b755ac50$var$shouldUseTemplateId(templateIds) ? null : collectionId
                });
            }),
            getAuthFromContext: (context)=>{
                isFirstDownload = false;
                return $30f3da79b755ac50$var$getAuthFromContext(context);
            }
        };
    };
    const getTemplateMediaUploadMediaClientConfig = (editorOptions)=>{
        return {
            authProvider: (0, $4IoVL.createAuthProvider)(()=>{
                const templateIds = $30f3da79b755ac50$var$formatTemplateId(editorOptions.templateId, !collectionId, true);
                return $30f3da79b755ac50$var$cachedGetTemplateUploadData.getValue({
                    ...editorOptions,
                    templateIds: templateIds,
                    collectionId: $30f3da79b755ac50$var$shouldUseTemplateId(templateIds) ? null : collectionId
                });
            }),
            getAuthFromContext: (context)=>{
                return $30f3da79b755ac50$var$getAuthFromContext(context);
            }
        };
    };
    const viewMediaClientConfig = getEditorViewTemplateMediaClientConfig(options);
    const uploadMediaClientConfig = getTemplateMediaUploadMediaClientConfig(options);
    const collection = await $30f3da79b755ac50$export$ea5d75839efa2930(options);
    collectionId = collection || null;
    return {
        viewMediaClientConfig: viewMediaClientConfig,
        uploadParams: {
            collection: collection,
            onUploadRejection: options.onUploadRejection
        },
        uploadMediaClientConfig: uploadMediaClientConfig
    };
};
module.exports["getTemplateUploadCollectionId"] = $30f3da79b755ac50$export$ea5d75839efa2930;
module.exports["getTemplateMediaContextValues"] = $30f3da79b755ac50$export$8867d7a854cea94a;
module.exports["getTemplateMediaAuth"] = $30f3da79b755ac50$export$c52d46b5239d3052;
module.exports["createRendererTemplateMediaProvider"] = $30f3da79b755ac50$export$4f3a63958bc8e871;
module.exports["createTemplateEditorMediaProvider"] = $30f3da79b755ac50$export$582e7673a587f23a;

});

parcelRegister("7EQEd", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $6UhpO = parcelRequire("6UhpO");


var $23pnW = parcelRequire("23pnW");


var $c0rhi = parcelRequire("c0rhi");

const $bced78bb0973f66e$export$852d9acd488f2352 = async ({ spaceKey: spaceKey, templateIds: templateIds, collectionId: collectionId = null })=>{
    return (0, $c0rhi.queryInterop)({
        query: (0, $6UhpO.default),
        variables: {
            spaceKey: spaceKey || null,
            templateIds: templateIds,
            collectionId: collectionId
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "fabric-media-support"
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
const $bced78bb0973f66e$export$779a7b38112a4dbb = async ({ spaceKey: spaceKey, templateIds: templateIds, collectionId: collectionId = null })=>{
    return (0, $c0rhi.queryInterop)({
        query: (0, $23pnW.default),
        variables: {
            spaceKey: spaceKey || null,
            templateIds: templateIds,
            collectionId: collectionId
        },
        fetchPolicy: 'no-cache',
        __callerPackage__: "fabric-media-support"
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
module.exports["getTemplateDownloadToken"] = $bced78bb0973f66e$export$852d9acd488f2352;
module.exports["getTemplateUploadToken"] = $bced78bb0973f66e$export$779a7b38112a4dbb;

});

parcelRegister("6UhpO", function(module, exports) {
/**
 * @generated SignedSource<<6f71e30a6f3ff9ae17bdb70469621c47>>
 * @relayHash 7da80c4186ab379cb41cda405bebee65
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b087f1d76c63fdcc9767cdf0710dfa4efaf3f7db7a96f39d1b7b4eef575b40c1
const $ba0dcc1d393f4102$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "collectionId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "templateIds"
    }, v3 = {
        "kind": "ScalarField",
        "name": "value"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "collectionId",
                    "variableName": "collectionId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "templateIds",
                    "variableName": "templateIds"
                }
            ],
            "concreteType": "TemplateMediaSession",
            "kind": "LinkedField",
            "name": "templateMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MapOfStringToString",
                    "kind": "LinkedField",
                    "name": "collections",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        }
                    ]
                },
                {
                    "concreteType": "TemplateMediaToken",
                    "kind": "LinkedField",
                    "name": "downloadToken",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "duration"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "TemplateMediaSessionDownloadQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "TemplateMediaSessionDownloadQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "7da80c4186ab379cb41cda405bebee65",
            "id": "b087f1d76c63fdcc9767cdf0710dfa4efaf3f7db7a96f39d1b7b4eef575b40c1",
            "metadata": {},
            "name": "TemplateMediaSessionDownloadQuery",
            "operationKind": "query",
            "text": "query TemplateMediaSessionDownloadQuery($spaceKey:String,$templateIds:[String]!,$collectionId:String){templateMediaSession(spaceKey:$spaceKey,templateIds:$templateIds,collectionId:$collectionId){collections{key,value},configuration{fileStoreUrl,clientId},downloadToken{value,duration}}}"
        }
    };
}();
$ba0dcc1d393f4102$var$node.hash = "cb69ec0c674b12c3415c2289771f970f";
var $ba0dcc1d393f4102$export$2e2bcd8739ae039 = $ba0dcc1d393f4102$var$node;
module.exports["default"] = $ba0dcc1d393f4102$export$2e2bcd8739ae039;

});

parcelRegister("23pnW", function(module, exports) {
/**
 * @generated SignedSource<<d8493d612cba7ab67c2663a1ef2f2968>>
 * @relayHash f5528f55bdab5a02587ef6cd5262334d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7ce5237137eaa73015ff248d0a763c44e037f18ed58c1bb4ff3b73e41cc13059
const $d22835c5674bcb0e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "collectionId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "templateIds"
    }, v3 = {
        "kind": "ScalarField",
        "name": "value"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "collectionId",
                    "variableName": "collectionId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "templateIds",
                    "variableName": "templateIds"
                }
            ],
            "concreteType": "TemplateMediaSession",
            "kind": "LinkedField",
            "name": "templateMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MapOfStringToString",
                    "kind": "LinkedField",
                    "name": "collections",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        }
                    ]
                },
                {
                    "concreteType": "TemplateMediaToken",
                    "kind": "LinkedField",
                    "name": "uploadToken",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "duration"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "TemplateMediaSessionUploadQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "TemplateMediaSessionUploadQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "f5528f55bdab5a02587ef6cd5262334d",
            "id": "7ce5237137eaa73015ff248d0a763c44e037f18ed58c1bb4ff3b73e41cc13059",
            "metadata": {},
            "name": "TemplateMediaSessionUploadQuery",
            "operationKind": "query",
            "text": "query TemplateMediaSessionUploadQuery($spaceKey:String,$templateIds:[String]!,$collectionId:String){templateMediaSession(spaceKey:$spaceKey,templateIds:$templateIds,collectionId:$collectionId){collections{key,value},configuration{fileStoreUrl,clientId},uploadToken{value,duration}}}"
        }
    };
}();
$d22835c5674bcb0e$var$node.hash = "1d0108dcbf48addfcc8b1c4145c7178d";
var $d22835c5674bcb0e$export$2e2bcd8739ae039 = $d22835c5674bcb0e$var$node;
module.exports["default"] = $d22835c5674bcb0e$export$2e2bcd8739ae039;

});

parcelRegister("I0A3i", function(module, exports) {

var $6IsMq = parcelRequire("6IsMq");


var $iTcHJ = parcelRequire("iTcHJ");


var $bS81H = parcelRequire("bS81H");


var $1UWNP = parcelRequire("1UWNP");


var $6AroL = parcelRequire("6AroL");


var $7Sm4c = parcelRequire("7Sm4c");


var $aMcHK = parcelRequire("aMcHK");


var $9wGTI = parcelRequire("9wGTI");


var $c0rhi = parcelRequire("c0rhi");


var $lUobS = parcelRequire("lUobS");


var $62FVQ = parcelRequire("62FVQ");


var $6mmMU = parcelRequire("6mmMU");


var $egLSs = parcelRequire("egLSs");


var $dqLCu = parcelRequire("dqLCu");

const $1fd47ba2b01e31e6$var$DSPIsActionEnabledForContentQuery = (0, $bS81H.default);
const $1fd47ba2b01e31e6$var$FetchMediaTokenQuery = (0, $iTcHJ.default);
const $1fd47ba2b01e31e6$var$JiraFetchMediaTokenQuery = (0, $6IsMq.default);
let $1fd47ba2b01e31e6$var$isFirstLoad = true;
const $1fd47ba2b01e31e6$export$f3bf3f7b03608218 = (requestBody)=>{
    if (requestBody.contentType === 'comment') // Hard disable drag-and-drop upload functionality for comments
    return;
    // Use regular mutation for normal uploads (file browser, copy-paste, etc.)
    return (0, $egLSs.experimentalFileUploadMutate)({
        variables: requestBody
    });
};
const $1fd47ba2b01e31e6$export$2b7fb70f168591f8 = (contentId)=>(0, $c0rhi.queryInterop)({
        query: $1fd47ba2b01e31e6$var$FetchMediaTokenQuery,
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft',
                'archived'
            ],
            missingContentId: !contentId
        },
        context: {
            allowOnExternalPage: true
        },
        // If SSR has populated the cache then we want to use the cache when rendering SPA-over-SSR
        fetchPolicy: $1fd47ba2b01e31e6$var$isFirstLoad ? 'cache-first' : 'network-only',
        __callerPackage__: "fabric-media-support"
    }).then(/* onFulfilled */ (value)=>{
        $1fd47ba2b01e31e6$var$isFirstLoad = false;
        try {
            $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors(contentId)(value?.error?.graphQLErrors);
        } catch  {}
        return value;
    }, /* onRejected */ (reason)=>{
        try {
            $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors(contentId)(reason?.graphQLErrors, reason?.networkError);
        } catch  {}
        throw reason;
    });
let $1fd47ba2b01e31e6$var$isFirstLoadJira = true;
const $1fd47ba2b01e31e6$export$5bc7dcc953e26849 = (issueAri)=>(0, $c0rhi.queryInterop)({
        query: $1fd47ba2b01e31e6$var$JiraFetchMediaTokenQuery,
        variables: {
            issueAri: issueAri,
            maxTokenLength: 65536
        },
        context: {
            allowOnExternalPage: true
        },
        // If SSR has populated the cache then we want to use the cache when rendering SPA-over-SSR
        fetchPolicy: $1fd47ba2b01e31e6$var$isFirstLoadJira ? 'cache-first' : 'network-only',
        __callerPackage__: "fabric-media-support"
    }).then(/* onFulfilled */ (value)=>{
        $1fd47ba2b01e31e6$var$isFirstLoadJira = false;
        try {
            $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors(issueAri)(value?.error?.graphQLErrors);
        } catch  {}
        return value;
    }, /* onRejected */ (reason)=>{
        try {
            $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors(issueAri)(reason?.graphQLErrors, reason?.networkError);
        } catch  {}
        throw reason;
    });
/**
 * `fetchMediaToken` is called repetitively to renew the token before it
 * expires. If an error condition arises (because of frontend or backend), the
 * same error(s) may be reported as unhandled to our analytics and monitoring at
 * a very high rate/volume. Such repetitive reporting fron one user in one tab
 * is noisy. `throttleFetchMediaTokenErrors` attempts to reduce the noise.
 */ const $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((_cacheKey)=>{
    /**
   * The errors that happened last time. The `GraphQLError` instances are big
   * and are not trivial to compare so `prevErrors` caches partial info.
   */ let prevErrors = undefined;
    return (graphQLErrors, networkError)=>{
        // Each of `graphQLErrors` and `networkError` are reported to analytics and
        // monitoring so type of `Error` does not matter to what follows and
        // `GraphQLError` is the most convenient TypeScript type to deal with.
        if (networkError) graphQLErrors = (graphQLErrors || []).concat(networkError);
        if (graphQLErrors) {
            /**
       * The new/current errors which will become `prevErrors` at the end of
       * this iteration.
       */ const nextErrors = {};
            for (const graphQLError of graphQLErrors){
                // Extract the partial, easy-to-compare, cachable info from the big
                // `GraphQLError` instance:
                const message = graphQLError.message || String(graphQLError) || graphQLError.originalError?.message || String(graphQLError.originalError);
                const { path: path } = graphQLError;
                const key = Array.isArray(path) && path.join('.') || message;
                if (key) {
                    const value = (0, $aMcHK.getStatusCode)(graphQLError) || message;
                    if (value) {
                        nextErrors[key] = value;
                        // If a similar error happened in the previous iteration, do not
                        // report it to analytics and monitoring again:
                        if (prevErrors?.[key] === value) (0, $7Sm4c.markErrorAsHandled)(graphQLError);
                    }
                }
            }
            prevErrors = nextErrors;
        } else // If `MediaDownloadTokenQuery` succeeds, report subsequent/future errors
        // even if similar ones occurred and were reported before the current
        // success - there is a meaningful change in state and it may be useful in
        // debugging.
        prevErrors = undefined;
    };
});
const $1fd47ba2b01e31e6$export$e5e77dc812ab6e52 = (contentId)=>(0, $c0rhi.queryInterop)({
        query: (0, $lUobS.default),
        variables: {
            contentId: contentId
        },
        context: {
            allowOnExternalPage: true
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "fabric-media-support"
    });
const $1fd47ba2b01e31e6$export$db4c125247d46dd = (shareToken)=>(0, $c0rhi.queryInterop)({
        query: (0, $dqLCu.default),
        variables: {
            shareToken: shareToken
        },
        context: {
            allowOnExternalPage: true
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "fabric-media-support"
    });
const $1fd47ba2b01e31e6$export$2b96f2ad626f63d2 = (contentId)=>(0, $c0rhi.queryInterop)({
        query: (0, $62FVQ.default),
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'no-cache',
        __callerPackage__: "fabric-media-support"
    });
const $1fd47ba2b01e31e6$export$de87322aceb1e609 = async (contentId)=>{
    if (!(0, $9wGTI.fg)('confluence-media-upload-token-cache')) return $1fd47ba2b01e31e6$export$2b96f2ad626f63d2(contentId);
    try {
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: (0, $62FVQ.default),
            variables: {
                contentId: contentId
            },
            fetchPolicy: 'cache-first',
            __callerPackage__: "fabric-media-support"
        });
        const token = data?.contentMediaSession?.token?.value;
        if (token) {
            const { exp: exp } = (0, $6AroL.default)(token);
            const currentTime = Math.floor(Date.now() / 1000);
            // Check if the token has not expired
            if (exp > currentTime) return {
                data: data
            };
        }
    } catch  {
    // Fall through to refetch on decode failure
    }
    // Refetch with network-only policy if token is expired, or invalid
    return (0, $c0rhi.queryInterop)({
        query: (0, $62FVQ.default),
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "fabric-media-support"
    });
};
const $1fd47ba2b01e31e6$export$4205291ac54c446e = async (contentId, cloudId)=>{
    try {
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: (0, $6mmMU.default),
            variables: {
                cloudId: cloudId,
                contentId: contentId
            },
            fetchPolicy: 'cache-first',
            __callerPackage__: "fabric-media-support"
        });
        const token = data?.contentMediaSession?.token?.value;
        if (token) {
            const { exp: exp } = (0, $6AroL.default)(token);
            const currentTime = Math.floor(Date.now() / 1000);
            // Check if the token has not expired
            if (exp > currentTime) return {
                data: data
            };
        }
    } catch  {
    // Fall through to refetch on decode failure
    }
    // Refetch with network-only policy if token is expired, or invalid
    return (0, $c0rhi.queryInterop)({
        query: (0, $6mmMU.default),
        variables: {
            cloudId: cloudId,
            contentId: contentId
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "fabric-media-support"
    });
};
const $1fd47ba2b01e31e6$export$4777fc7c5d601381 = (contentId, spaceKey)=>{
    const action = (0, $9wGTI.fg)('cc-dlp_split-attachment-dl-from-export-dsp') ? 'ATTACHMENT_DOWNLOAD' : 'PAGE_EXPORT';
    const variables = {
        action: action,
        contentId: contentId,
        contentStatus: 'CURRENT',
        contentVersion: 1,
        ...spaceKey && {
            spaceKey: spaceKey
        }
    };
    /* Note -> relay compatible query replacement available, in @confluence/data-security package.
   * Using queryInterop for compatibility with Relay migration
   */ return (0, $c0rhi.queryInterop)({
        query: $1fd47ba2b01e31e6$var$DSPIsActionEnabledForContentQuery,
        variables: variables,
        context: {
            allowOnExternalPage: true
        },
        fetchPolicy: 'cache-first',
        __callerPackage__: "fabric-media-support"
    });
};
module.exports["setAttachment"] = $1fd47ba2b01e31e6$export$f3bf3f7b03608218;
module.exports["fetchMediaToken"] = $1fd47ba2b01e31e6$export$2b7fb70f168591f8;
module.exports["fetchExternalShareMediaToken"] = $1fd47ba2b01e31e6$export$e5e77dc812ab6e52;
module.exports["fetchExternalContentMediaSessionToken"] = $1fd47ba2b01e31e6$export$db4c125247d46dd;
module.exports["getUploadToken"] = $1fd47ba2b01e31e6$export$de87322aceb1e609;
module.exports["getCommentUploadToken"] = $1fd47ba2b01e31e6$export$4205291ac54c446e;
module.exports["getIsExportEnabledForContent"] = $1fd47ba2b01e31e6$export$4777fc7c5d601381;

});

parcelRegister("6IsMq", function(module, exports) {
/**
 * @generated SignedSource<<d76d95039bbf9cae17d368276aebc792>>
 * @relayHash b0b89409f45955f1d6631ca601f67f8b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 916fc9c88cdf0763a685d23187d4deb77c6c3625098021bbc28d6dba182b8d9b
const $684f397ef7ad0ae2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueAri"
        },
        {
            "defaultValue": 65536,
            "kind": "LocalArgument",
            "name": "maxTokenLength"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "issueAri"
        }
    ], v2 = {
        "args": [
            {
                "kind": "Variable",
                "name": "maxTokenLength",
                "variableName": "maxTokenLength"
            }
        ],
        "concreteType": "JiraMediaReadToken",
        "kind": "LinkedField",
        "name": "mediaReadToken",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "clientId"
            },
            {
                "kind": "ScalarField",
                "name": "endpointUrl"
            },
            {
                "kind": "ScalarField",
                "name": "tokenLifespanInSeconds"
            },
            {
                "concreteType": "JiraMediaTokenWithFilesConnection",
                "kind": "LinkedField",
                "name": "tokensWithFiles",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraMediaTokenWithFilesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraMediaTokenWithFiles",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "token"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b0b89409f45955f1d6631ca601f67f8b",
            "id": "916fc9c88cdf0763a685d23187d4deb77c6c3625098021bbc28d6dba182b8d9b",
            "metadata": {},
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersFetchJiraMediaTokenQuery($issueAri:ID!,$maxTokenLength:Int=65536){jira{issueById(id:$issueAri){mediaReadToken(maxTokenLength:$maxTokenLength)@optIn(to:\"JiraMediaReadTokenInIssue\"){clientId,endpointUrl,tokenLifespanInSeconds,tokensWithFiles{edges{node{token}}}},id}}}"
        }
    };
}();
$684f397ef7ad0ae2$var$node.hash = "7036cf95096a08504e6375127746a507";
var $684f397ef7ad0ae2$export$2e2bcd8739ae039 = $684f397ef7ad0ae2$var$node;
module.exports["default"] = $684f397ef7ad0ae2$export$2e2bcd8739ae039;

});

parcelRegister("iTcHJ", function(module, exports) {
/**
 * @generated SignedSource<<5e736080ce8c5ab015a5851e0537f7fa>>
 * @relayHash 60dcb7a4a06a5eaa2ddb4f4df7437c8c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da295508da11933cde6015c5899a2dae3ede521437117bf85391f779f362e076
const $cd49b7baa8bd0c54$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "missingContentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = [
        {
            "condition": "missingContentId",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "status",
                            "variableName": "status"
                        }
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "atlas_doc_format",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "EmbeddedMediaToken",
                                                    "kind": "LinkedField",
                                                    "name": "mediaToken",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "token"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "MediaConfiguration",
            "kind": "LinkedField",
            "name": "mediaConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientId"
                },
                {
                    "kind": "ScalarField",
                    "name": "fileStoreUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "60dcb7a4a06a5eaa2ddb4f4df7437c8c",
            "id": "da295508da11933cde6015c5899a2dae3ede521437117bf85391f779f362e076",
            "metadata": {},
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersFetchMediaTokenQuery($contentId:ID,$status:[String],$missingContentId:Boolean=false){content(id:$contentId,status:$status)@skip(if:$missingContentId){nodes{id,body{atlas_doc_format{mediaToken{token}}}}},mediaConfiguration{clientId,fileStoreUrl}}"
        }
    };
}();
$cd49b7baa8bd0c54$var$node.hash = "c53e0852d23c6b17549e89592c16b84c";
var $cd49b7baa8bd0c54$export$2e2bcd8739ae039 = $cd49b7baa8bd0c54$var$node;
module.exports["default"] = $cd49b7baa8bd0c54$export$2e2bcd8739ae039;

});

parcelRegister("bS81H", function(module, exports) {
/**
 * @generated SignedSource<<523aa3ee46c59d410bd7627eb0f987ce>>
 * @relayHash 611f36fd3ab140915814f503f8503110
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 97be9875eda07a3755479859d908d73b01a8526a1d7d39ebe7c437e3317987f8
const $5a2ebb253ede159a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "action"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentStatus"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentVersion"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "concreteType": "Confluence_dataSecurityPolicy",
            "kind": "LinkedField",
            "name": "dataSecurityPolicy",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "action",
                            "variableName": "action"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentStatus",
                            "variableName": "contentStatus"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentVersion",
                            "variableName": "contentVersion"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "DataSecurityPolicyDecision",
                    "kind": "LinkedField",
                    "name": "isActionEnabledForContent",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "action"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "allowed"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "graphqlHelpersDSPIsActionEnabledForContentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "graphqlHelpersDSPIsActionEnabledForContentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "611f36fd3ab140915814f503f8503110",
            "id": "97be9875eda07a3755479859d908d73b01a8526a1d7d39ebe7c437e3317987f8",
            "metadata": {},
            "name": "graphqlHelpersDSPIsActionEnabledForContentQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersDSPIsActionEnabledForContentQuery($action:DataSecurityPolicyAction!,$contentId:ID!,$contentStatus:DataSecurityPolicyDecidableContentStatus!,$contentVersion:Int!,$spaceKey:String){dataSecurityPolicy{isActionEnabledForContent(action:$action,contentId:$contentId,contentStatus:$contentStatus,contentVersion:$contentVersion,spaceKey:$spaceKey){action,allowed}}}"
        }
    };
}();
$5a2ebb253ede159a$var$node.hash = "c488c053b9896d7e6d5b6c4474dd396b";
var $5a2ebb253ede159a$export$2e2bcd8739ae039 = $5a2ebb253ede159a$var$node;
module.exports["default"] = $5a2ebb253ede159a$export$2e2bcd8739ae039;

});

parcelRegister("lUobS", function(module, exports) {
/**
 * @generated SignedSource<<57e8668d9fe3c9f67ee75bb15b6e474f>>
 * @relayHash ea7172d4f00c5846ec23ab207abff057
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID def5df9707285fd6e6ce8403c4b6e14be14ec1bc83092c3a8315bd1cae3d8b6e
const $2624e38a54eebf0f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ContentBodyPerRepresentation",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentBody",
                            "kind": "LinkedField",
                            "name": "atlas_doc_format",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "EmbeddedMediaToken",
                                    "kind": "LinkedField",
                                    "name": "mediaToken",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "token"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "MediaConfiguration",
            "kind": "LinkedField",
            "name": "mediaConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientId"
                },
                {
                    "kind": "ScalarField",
                    "name": "fileStoreUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ExternalShareMediaDownloadTokenQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ExternalShareMediaDownloadTokenQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "ea7172d4f00c5846ec23ab207abff057",
            "id": "def5df9707285fd6e6ce8403c4b6e14be14ec1bc83092c3a8315bd1cae3d8b6e",
            "metadata": {},
            "name": "ExternalShareMediaDownloadTokenQuery",
            "operationKind": "query",
            "text": "query ExternalShareMediaDownloadTokenQuery($contentId:ID!){singleContent(id:$contentId){id,body{atlas_doc_format{mediaToken{token}}}},mediaConfiguration{clientId,fileStoreUrl}}"
        }
    };
}();
$2624e38a54eebf0f$var$node.hash = "3592e1b2dcd3aa2c38a177d9b363dafe";
var $2624e38a54eebf0f$export$2e2bcd8739ae039 = $2624e38a54eebf0f$var$node;
module.exports["default"] = $2624e38a54eebf0f$export$2e2bcd8739ae039;

});

parcelRegister("62FVQ", function(module, exports) {
/**
 * @generated SignedSource<<025b00e9b31b73f237130d2a69699587>>
 * @relayHash 20688ce23e5e858cfc82d72bb57f43b8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6675bb1797e9ac9206231ded11f5893e0128fe48eaeb5c3ee4b3024ed69be54c
const $15e95f80a91466f9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "contentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaToken",
                    "kind": "LinkedField",
                    "name": "token",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "collection"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MediaUploadTokenQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MediaUploadTokenQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "20688ce23e5e858cfc82d72bb57f43b8",
            "id": "6675bb1797e9ac9206231ded11f5893e0128fe48eaeb5c3ee4b3024ed69be54c",
            "metadata": {},
            "name": "MediaUploadTokenQuery",
            "operationKind": "query",
            "text": "query MediaUploadTokenQuery($contentId:ID!){contentMediaSession(contentId:$contentId){token{value},configuration{clientId,fileStoreUrl},collection}}"
        }
    };
}();
$15e95f80a91466f9$var$node.hash = "1f89a4aaada59e040e6317ae1cdc704c";
var $15e95f80a91466f9$export$2e2bcd8739ae039 = $15e95f80a91466f9$var$node;
module.exports["default"] = $15e95f80a91466f9$export$2e2bcd8739ae039;

});

parcelRegister("6mmMU", function(module, exports) {
/**
 * @generated SignedSource<<daf984ad5eaae28ba5768f141c1480ac>>
 * @relayHash c06482aa2ab100620d21019ae889668d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6f18fbd3655dc7d982b17a901a58731161062354f5b6b10a2c133f035fcb7e37
const $39c17bb60e74ced3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "alias": "contentMediaSession",
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "confluence_commentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaToken",
                    "kind": "LinkedField",
                    "name": "token",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "collection"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MediaUploadTokenQueryCommentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MediaUploadTokenQueryCommentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c06482aa2ab100620d21019ae889668d",
            "id": "6f18fbd3655dc7d982b17a901a58731161062354f5b6b10a2c133f035fcb7e37",
            "metadata": {},
            "name": "MediaUploadTokenQueryCommentQuery",
            "operationKind": "query",
            "text": "query MediaUploadTokenQueryCommentQuery($cloudId:ID!,$contentId:ID!){contentMediaSession:confluence_commentMediaSession(cloudId:$cloudId,contentId:$contentId){token{value},configuration{clientId,fileStoreUrl},collection}}"
        }
    };
}();
$39c17bb60e74ced3$var$node.hash = "ecbc3538cd4e4434bac2e03ab7969cd8";
var $39c17bb60e74ced3$export$2e2bcd8739ae039 = $39c17bb60e74ced3$var$node;
module.exports["default"] = $39c17bb60e74ced3$export$2e2bcd8739ae039;

});

parcelRegister("egLSs", function(module, exports) {

var $4GGNn = parcelRequire("4GGNn");


var $aBfpe = parcelRequire("aBfpe");

const $7fce44bdcdfe3fe8$export$1b01a64a392afa44 = ({ variables: variables })=>{
    return (0, $4GGNn.experimentalMutate)({
        url: `/wiki/rest/drag-and-drop/1/filestore/upload`,
        method: 'POST',
        body: JSON.stringify(variables),
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        variables: variables,
        parseResult: ()=>({
                experimentalFileUpload: true
            })
    });
};
module.exports["experimentalFileUploadMutate"] = $7fce44bdcdfe3fe8$export$1b01a64a392afa44;

});

parcelRegister("4GGNn", function(module, exports) {

var $jhbO3 = parcelRequire("jhbO3");


var $GLgaM = parcelRequire("GLgaM");


var $bjeS8 = parcelRequire("bjeS8");

async function $aeaa62655b9da260$export$4199ef03ec2aea3f({ url: url, method: method, headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError }) {
    const fetchData = async ()=>{
        const json = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, variables);
        return await parseResult(json, variables);
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $jhbO3.apolloCompatibleMutation)({
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalMutate"] = $aeaa62655b9da260$export$4199ef03ec2aea3f;

});

parcelRegister("GLgaM", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $c9IWh = parcelRequire("c9IWh");


var $3FAG5 = parcelRequire("3FAG5");

async function $2229ddfbe95e9ad1$export$4b00e7449e7c9147(fetchOptions, variables) {
    const { url: url, method: method, body: body, headers: headers, credentials: credentials, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError } = fetchOptions;
    try {
        const resolvedMethod = typeof method === 'function' ? method(variables) : method;
        const defaultBody = resolvedMethod === 'GET' ? undefined : JSON.stringify(variables);
        // Tesseract instruments the outgoing http requests automatically, no need to pass tracing headers when running in SSR.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const tracingHeaders = (0, $c9IWh.getActiveTraceHttpRequestHeaders)('' /* url, not used */ );
        const enhancedHeaders = {
            ...headers,
            ...tracingHeaders
        };
        const response = await (0, $f7B1p.cfetch)(typeof url === 'function' ? url(variables) : url, {
            method: resolvedMethod,
            body: typeof body === 'function' ? body(variables) : body || defaultBody,
            headers: enhancedHeaders,
            credentials: credentials
        });
        if (parseResponseOnSuccess) return parseResponseOnSuccess(response);
        return await $2229ddfbe95e9ad1$var$parseResponse(response);
    } catch (error) {
        if (parseResponseOnError) return parseResponseOnError(error, variables);
        throw error;
    }
}
async function $2229ddfbe95e9ad1$var$parseResponse(response) {
    if (response.status === 204) return {};
    // In case a service happens to return a 200 instead of 204 with no content
    if (response.headers?.get('content-length') === '0') return {};
    try {
        return await response.json();
    } catch (error) {
        throw (0, $3FAG5.throwErrorWithResponse)(error, response);
    }
}
module.exports["fetchResponse"] = $2229ddfbe95e9ad1$export$4b00e7449e7c9147;

});

parcelRegister("3FAG5", function(module, exports) {
// copied from next/packages/graphql/src/resolvers/throwErrorWithResponse.ts b/c of circ dep
function $6c7ad22961ce35d0$export$8a24908f7aac7ac7(error, response) {
    // Don't swallow the Response object, attach it to the error so the rest of
    // the app has a chance to see it e.g. OnErrorLink:
    if (typeof error === 'object' && error) {
        // At times our various resolver implementations interpret the JSON body of
        // non-OK responses as errors. And sometimes these errors contain a response
        // property (which may be an empty object) that leads to the loss of
        // Response information such as trace ID.
        if ('response' in error) {
            const existingErrorResponse = error.response;
            // Try to attach at least the trace ID to the existing error response:
            if (typeof existingErrorResponse === 'object' && existingErrorResponse) {
                // OnError's getResponseFromError needs the status property:
                if (!('status' in existingErrorResponse)) existingErrorResponse.status = response.status;
                // getTraceIdFromResponse needs the headers property:
                if (!('headers' in existingErrorResponse)) existingErrorResponse.headers = response.headers;
            }
        } else error.response = response;
    }
    throw error;
}
module.exports["throwErrorWithResponse"] = $6c7ad22961ce35d0$export$8a24908f7aac7ac7;

});

parcelRegister("bjeS8", function(module, exports) {

var $krgsn = parcelRequire("krgsn");


var $422HI = parcelRequire("422HI");

const $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a = (error)=>{
    const message = error.message || 'Unknown error';
    const status = 'response' in error ? error.response?.status : undefined;
    return new (0, $422HI.ApolloErrorInterop)({
        graphQLErrors: [
            $79bfccd7ee2a0d89$var$createGraphQLError({
                message: message,
                status: status,
                originalError: error
            })
        ]
    });
};
const $79bfccd7ee2a0d89$var$createGraphQLError = ({ message: message, status: status, originalError: originalError })=>{
    const extensions = status ? {
        statusCode: status,
        http: {
            status: status
        }
    } : undefined;
    return new (0, $krgsn.GraphQLError)(message, null, // nodes - no GraphQL query AST
    null, // source - no GraphQL query text
    null, // positions - no GraphQL query positions
    null, // path - not executing GraphQL schema fields
    originalError, extensions);
};
module.exports["convertToApolloError"] = $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a;

});

parcelRegister("aBfpe", function(module, exports) {
/**
 * https://www.iana.org/assignments/media-types/media-types.xhtml
 */ var $c27c52d002752847$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $c27c52d002752847$export$483c11740a902fcd;

});

parcelRegister("dqLCu", function(module, exports) {
/**
 * @generated SignedSource<<4edd735d079b37bb48067afaa74a4066>>
 * @relayHash c64eff3bdc2352e89d29fc9d40e39f79
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0383b95992e0b08fce6e9726b252b827c2a925f54a0ef8d6bdc7d88c65deb255
const $b85e553ccc70de04$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shareToken"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "shareToken",
                    "variableName": "shareToken"
                }
            ],
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "externalContentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaAccessTokens",
                    "kind": "LinkedField",
                    "name": "accessTokens",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MediaToken",
                            "kind": "LinkedField",
                            "name": "readOnlyToken",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        },
                        {
                            "concreteType": "MediaToken",
                            "kind": "LinkedField",
                            "name": "readWriteToken",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ExternalContentMediaSessionQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ExternalContentMediaSessionQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "c64eff3bdc2352e89d29fc9d40e39f79",
            "id": "0383b95992e0b08fce6e9726b252b827c2a925f54a0ef8d6bdc7d88c65deb255",
            "metadata": {},
            "name": "ExternalContentMediaSessionQuery",
            "operationKind": "query",
            "text": "query ExternalContentMediaSessionQuery($shareToken:String!){externalContentMediaSession(shareToken:$shareToken){accessTokens{readOnlyToken{value},readWriteToken{value}},configuration{fileStoreUrl,clientId}}}"
        }
    };
}();
$b85e553ccc70de04$var$node.hash = "73d645a33a55cbb7625d57b6d5cf2a1a";
var $b85e553ccc70de04$export$2e2bcd8739ae039 = $b85e553ccc70de04$var$node;
module.exports["default"] = $b85e553ccc70de04$export$2e2bcd8739ae039;

});

parcelRegister("kQiXs", function(module, exports) {

var $I0A3i = parcelRequire("I0A3i");

const $c59debd6932d7898$var$noop = ()=>{};
const $c59debd6932d7898$export$ad897c91dfb246e9 = (options)=>{
    if (options.contentId && options.contentType) return (file)=>{
        const { id: id, name: name, size: size, mimeType: mimeType } = file;
        const { contentId: contentId, contentType: contentType } = options;
        const requestBody = {
            size: size,
            contentType: contentType,
            mimeType: mimeType,
            fileName: name,
            pageId: contentId,
            fileStoreId: id,
            minorEdit: true,
            renderEditorHTML: false,
            collectionName: `contentId-${contentId}`,
            uploadSource: 'fabric-editor'
        };
        (0, $I0A3i.setAttachment)(requestBody);
    };
    else return $c59debd6932d7898$var$noop;
};
module.exports["attachUploadedMedia"] = $c59debd6932d7898$export$ad897c91dfb246e9;

});

parcelRegister("3W9OD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $b4vCW = parcelRequire("b4vCW");


var $aXmxE = parcelRequire("aXmxE");


var $bQm3c = parcelRequire("bQm3c");

function $267ba6a0568e3ab0$export$ffe8c124580b6e44() {
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    return (0, $cozmU.useMemo)(()=>Promise.resolve((0, $aXmxE.createSearchProvider)(cloudId, (0, $b4vCW.Scope).ConfluencePageBlog, undefined, undefined, true)), [
        cloudId
    ]);
}
module.exports["useSearchProvider"] = $267ba6a0568e3ab0$export$ffe8c124580b6e44;

});

parcelRegister("b4vCW", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $6BYyi = parcelRequire("6BYyi");


var $6Zvcd = parcelRequire("6Zvcd");


var $fJfKO = parcelRequire("fJfKO");


var $7Cfp7 = parcelRequire("7Cfp7");

var $2103cf628600479a$export$92e44ea1079b9ec6 = /*#__PURE__*/ function(Products) {
    Products["jira"] = "JIRA";
    Products["confluence"] = "CONFLUENCE";
    Products["townsquare"] = "TOWNSQUARE";
    Products["trello"] = "TRELLO";
    Products["bitbucket"] = "BITBUCKET";
    Products["other"] = "OTHER";
    return Products;
}({});
const $2103cf628600479a$export$775b6bb06e53a214 = {
    ...(0, $6BYyi.Scope),
    ...(0, $6Zvcd.Scope),
    ...(0, $7Cfp7.TownsquareScope),
    ...(0, $fJfKO.Scope)
};
module.exports["Scope"] = $2103cf628600479a$export$775b6bb06e53a214;

});

parcelRegister("6BYyi", function(module, exports) {
/**
 * Instead of enum types for ResultType, AnalyticsType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $14f7537098ab5b98$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["ConfluencePageBlogAttachment"] = "confluence.page,blogpost,attachment";
    Scope["ConfluencePageBlog"] = "confluence.page,blogpost";
    Scope["ConfluenceExperimentsPageBlogAttachment"] = "confluence_experiments.page,blogpost,attachment";
    Scope["ConfluenceSpace"] = "confluence.space";
    Scope["UserConfluence"] = "urs.user-confluence";
    Scope["ConfluencePageBlogWhiteboard"] = "confluence.page,blogpost,whiteboard";
    Scope["ConfluenceContentType"] = "confluence.page,blogpost,whiteboard,database,embed";
    return Scope;
}({});
const $14f7537098ab5b98$export$b6316c73fe562220 = 'confluence.page,blogpost,attachment';
const $14f7537098ab5b98$export$da1906f69c8621ca = 'confluence.page,blogpost';
const $14f7537098ab5b98$export$a300dffead5808fd = 'confluence_experiments.page,blogpost,attachment';
const $14f7537098ab5b98$export$7694915d49dbf79 = 'confluence_experiments.page,blogpost,whiteboard';
const $14f7537098ab5b98$export$2d908678acc2f256 = 'confluence_experiments.page,blogpost,whiteboard,database,embed';
const $14f7537098ab5b98$export$80a5be864676016b = 'confluence.space';
const $14f7537098ab5b98$export$70542451ad6057d2 = 'urs.user-confluence';
const $14f7537098ab5b98$export$6ec00f56b27cdc1d = 'generic-container-result';
const $14f7537098ab5b98$export$ca1a50bc869949e = 'person-result';
const $14f7537098ab5b98$export$a99961038e9d5471 = 'confluence-object-result';
const $14f7537098ab5b98$export$18c69de2b4aa679c = 'recent-confluence';
const $14f7537098ab5b98$export$dc31f0db54ab1a30 = 'result-confluence';
const $14f7537098ab5b98$export$cb8b6c470492bee8 = 'recent-person';
const $14f7537098ab5b98$export$ebb42dafe7a39a20 = 'result-person';
const $14f7537098ab5b98$export$602b44a55c824e30 = 'advanced-search-confluence';
const $14f7537098ab5b98$export$3eb1eaefdca3e463 = 'advanced-search-people';
const $14f7537098ab5b98$export$bbd1709e62826142 = 'confluence-page';
const $14f7537098ab5b98$export$4a1ec8cc030bc82a = 'confluence-blogpost';
const $14f7537098ab5b98$export$b441f0c13fd510b9 = 'confluence-attachment';
const $14f7537098ab5b98$export$8ee8726ca4e2f8bd = 'confluence-space';
const $14f7537098ab5b98$export$d0e824889e01c751 = 'person';
const $14f7537098ab5b98$export$b0c74445b9c9b57 = 'confluence-app';
module.exports["Scope"] = $14f7537098ab5b98$export$775b6bb06e53a214;

});

parcelRegister("6Zvcd", function(module, exports) {
/**
 * Instead of enum types for ResultType and ContentType we use a list of typed strings.
 * Typescript has issues when using types that require specific enum values (https://github.com/microsoft/TypeScript/issues/28102).
 *
 * There doesn't appear to be a working solution soon and as such we will manually type each value separately using strings.
 */ var $2f98cc823dddcacd$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["JiraIssue"] = "jira.issue";
    Scope["JiraPlan"] = "jira.plan";
    Scope["JiraDashboard"] = "jira.dashboard";
    Scope["JiraIssueDashboardBoardProjectFilter"] = "jira.issue,dashboard,board,project,filter";
    Scope["JiraBoardProjectFilter"] = "jira.board,project,filter";
    Scope["JiraBoardProjectFilterPlan"] = "jira.board,project,filter,plan";
    Scope["JiraProject"] = "jira.project";
    Scope["People"] = "urs.user-jira";
    return Scope;
}({});
var $2f98cc823dddcacd$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["JiraIssue"] = "jira-issue";
    ContentType["JiraDashboard"] = "jira-dashboard";
    ContentType["JiraBoard"] = "jira-board";
    ContentType["JiraProject"] = "jira-project";
    ContentType["JiraFilter"] = "jira-filter";
    ContentType["JiraPlan"] = "jira-plan";
    ContentType["JiraPeople"] = "jira-people";
    return ContentType;
}({});
function $2f98cc823dddcacd$export$b3b8cefe01df28d2(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'url');
}
function $2f98cc823dddcacd$export$496f9fe01bbac92b(avatar) {
    return Object.prototype.hasOwnProperty.call(avatar, 'urls');
}
var $2f98cc823dddcacd$export$d31c6c64cddbeeac = /*#__PURE__*/ function(AttributeType) {
    AttributeType["issue"] = "issue";
    AttributeType["dashboard"] = "dashboard";
    AttributeType["board"] = "board";
    AttributeType["project"] = "project";
    AttributeType["filter"] = "filter";
    AttributeType["plan"] = "plan";
    AttributeType["people"] = "people";
    return AttributeType;
}({});
module.exports["Scope"] = $2f98cc823dddcacd$export$775b6bb06e53a214;

});

parcelRegister("fJfKO", function(module, exports) {
var $1d3fb901b1492caa$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["Loom"] = "loom.loom";
    return Scope;
}({});
module.exports["Scope"] = $1d3fb901b1492caa$export$775b6bb06e53a214;

});

parcelRegister("7Cfp7", function(module, exports) {
var $7ab467722a6086d5$export$fca43c5c12a4e3fa = /*#__PURE__*/ function(TownsquareScope) {
    TownsquareScope["TownsquareProject"] = "townsquare.project";
    TownsquareScope["TownsquareGoal"] = "townsquare.goal";
    TownsquareScope["TownsquareHelpLink"] = "townsquare.help-pointer";
    TownsquareScope["TownsquareQuestion"] = "townsquare.question";
    TownsquareScope["TownsquareTag"] = "townsquare.tag";
    TownsquareScope["TownsquareLearning"] = "townsquare.learning";
    TownsquareScope["People"] = "townsquare.people";
    TownsquareScope["Teams"] = "townsquare.teams";
    return TownsquareScope;
}({});
 // End of copied code.
module.exports["TownsquareScope"] = $7ab467722a6086d5$export$fca43c5c12a4e3fa;

});

parcelRegister("aXmxE", function(module, exports) {
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $b15ln = parcelRequire("b15ln");

const $9ab0949045688fbc$export$31a7d81156fc4fa1 = (cloudId, scope, aggregatorUrl, analyticsIdentifier, useConfluenceTypeInAri)=>{
    return new (0, $b15ln.default)(cloudId, scope, aggregatorUrl, analyticsIdentifier, useConfluenceTypeInAri);
};
module.exports["createSearchProvider"] = $9ab0949045688fbc$export$31a7d81156fc4fa1;

});

parcelRegister("b15ln", function(module, exports) {

var $fCd3b = parcelRequire("fCd3b");


var $b4vCW = parcelRequire("b4vCW");


var $9cGsb = parcelRequire("9cGsb");

const $1dc83b808cb1c829$var$ANALYTICS_IDENTIFIER = 'editor-quick-search';
class $1dc83b808cb1c829$export$2e2bcd8739ae039 {
    getAriString(opt) {
        try {
            return new (0, $9cGsb.ResourceIdentifier)(opt).toString();
        } catch (e) {
            return '';
        }
    }
    confluencePageBlogResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>({
                title: item.title,
                // The `item.url` is only the relative path so we need to prefix the `item.baseUrl`
                url: item.baseUrl + item.url,
                container: item.container.title,
                contentType: this.mapToContentType(item.content && item.content.type),
                updatedTimestamp: item.lastModified,
                objectId: this.getAriString({
                    resourceOwner: 'confluence',
                    cloudId: this.cloudId,
                    resourceType: this.useConfluenceTypeInAri && item.content?.type || 'content',
                    resourceId: item.content && item.content.id
                })
            }));
    }
    jiraIssueResponseTransformer(response) {
        if (!response) return [];
        return response.results.map((item)=>({
                title: item.name,
                // The `item.url` here for Jira Issue is the absolute url
                url: item.url,
                container: item.attributes.container && item.attributes.container.title || '',
                contentType: this.mapToContentType(item.attributes['@type'], item.attributes.issueTypeName),
                updatedTimestamp: item.attributes.updated,
                objectId: this.getAriString({
                    resourceOwner: 'jira',
                    cloudId: this.cloudId,
                    resourceType: 'issue',
                    resourceId: item.id
                })
            }));
    }
    mapToContentType(type, subType) {
        switch(type){
            case 'issue':
                switch(subType){
                    case 'Bug':
                        return 'jira.issue.bug';
                    case 'Story':
                        return 'jira.issue.story';
                    case 'Task':
                        return 'jira.issue.task';
                    default:
                        return 'jira.issue';
                }
            case 'page':
                return 'confluence.page';
            case 'blogpost':
                return 'confluence.blogpost';
            default:
                return 'default';
        }
    }
    async quickSearch(query, limit) {
        const result = await this.client.search({
            query: query,
            scopes: [
                this.scope
            ],
            analytics: {
                identifier: this.analyticsIdentifier
            },
            resultLimit: limit
        });
        switch(this.scope){
            case (0, $b4vCW.Scope).ConfluencePageBlog:
                {
                    const scopeResult = result.response.retrieveScope(this.scope);
                    return this.confluencePageBlogResponseTransformer(scopeResult);
                }
            case (0, $b4vCW.Scope).JiraIssue:
                {
                    const scopeResult = result.response.retrieveScope(this.scope);
                    return this.jiraIssueResponseTransformer(scopeResult);
                }
            default:
                throw new Error(`Unsupported scope - ${this.scope}`);
        }
    }
    constructor(cloudId, scope, aggregatorUrl, analyticsIdentifier = $1dc83b808cb1c829$var$ANALYTICS_IDENTIFIER, useConfluenceTypeInAri = false){
        this.client = void 0;
        this.scope = void 0;
        this.cloudId = void 0;
        this.analyticsIdentifier = void 0;
        this.useConfluenceTypeInAri = void 0;
        switch(scope){
            case (0, $b4vCW.Scope).ConfluencePageBlog:
            case (0, $b4vCW.Scope).JiraIssue:
                break;
            default:
                throw new Error(`Unsupported scope - ${scope}`);
        }
        this.scope = scope;
        this.cloudId = cloudId;
        this.analyticsIdentifier = analyticsIdentifier;
        this.useConfluenceTypeInAri = useConfluenceTypeInAri;
        const config = {
            cloudId: cloudId,
            aggregatorUrl: aggregatorUrl
        };
        this.client = (0, $fCd3b.createClient)(config);
    }
}
module.exports["default"] = $1dc83b808cb1c829$export$2e2bcd8739ae039;

});

parcelRegister("fCd3b", function(module, exports) {

var $gABt9 = parcelRequire("gABt9");


var $iVNH5 = parcelRequire("iVNH5");

const $a663f43e8e7364a7$var$MAX_SITES_INITIAL_QUERY = 3;
const $a663f43e8e7364a7$var$limitToMaxSiteUsage = (sites = [])=>{
    return sites.slice(0, $a663f43e8e7364a7$var$MAX_SITES_INITIAL_QUERY);
};
class $a663f43e8e7364a7$var$AggregatorClient {
    async getAutoCorrection({ query: query }) {
        const cloudId = this.cloudId;
        // The language is hardcoded to 'en' as the backend does not support other languages
        // Also the frontend only auto corrects in English locale
        const body = {
            query: query,
            language: 'en',
            cloudId: cloudId
        };
        const response = await this.makePostRequest($a663f43e8e7364a7$var$AggregatorClient.AUTO_CORRECT_API_URL, body);
        return response.fullCorrection;
    }
    async search({ query: query, context: context, scopes: scopes, modelParams: modelParams, resultLimit: resultLimit, filters: filters = [], experience: experience, sites: sites = [] }) {
        const cloudId = this.cloudId;
        const cloudIdsToFilterOn = sites.length > 0 ? sites : $a663f43e8e7364a7$var$limitToMaxSiteUsage(this.siteMasterList).map((site)=>site.cloudId);
        const body = {
            query: query,
            cloudId: cloudId,
            limit: resultLimit,
            scopes: scopes,
            filters: filters,
            searchSession: context,
            ...modelParams.length > 0 ? {
                modelParams: modelParams
            } : {},
            experience: experience,
            cloudIds: cloudIdsToFilterOn
        };
        const { result: response, durationMs: requestDurationMs } = await (0, $iVNH5.timed)(this.makePostRequest($a663f43e8e7364a7$var$AggregatorClient.QUICKSEARCH_API_URL, body));
        return {
            response: {
                rawData: response,
                retrieveScope: (scope)=>// @ts-expect-error TS2367: This comparison appears to be unintentional because the types 'Scope' and 'SingleScope' have no overlap
                    response.scopes.find((s)=>s.id === scope) || null
            },
            requestDurationMs: requestDurationMs
        };
    }
    constructor({ url: url, cloudId: cloudId, siteMasterList: siteMasterList }){
        this.serviceConfig = void 0;
        this.cloudId = void 0;
        this.siteMasterList = void 0;
        this.makePostRequest = (path, body)=>{
            const options = {
                path: path,
                requestInit: {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body)
                }
            };
            return (0, $gABt9.utils).requestService(this.serviceConfig, options);
        };
        this.serviceConfig = {
            url: url
        };
        this.cloudId = cloudId;
        this.siteMasterList = siteMasterList;
    }
}
$a663f43e8e7364a7$var$AggregatorClient.QUICKSEARCH_API_URL = 'quicksearch/v1';
$a663f43e8e7364a7$var$AggregatorClient.AUTO_CORRECT_API_URL = 'autocorrect';
const $a663f43e8e7364a7$export$5d730b7aed1a3eb0 = ({ cloudId: cloudId, aggregatorUrl: aggregatorUrl, aggregatorHostName: aggregatorHostName })=>{
    const aggregatorClient = new $a663f43e8e7364a7$var$AggregatorClient({
        cloudId: cloudId,
        url: aggregatorUrl || `${aggregatorHostName || ''}/gateway/api/xpsearch-aggregator`,
        siteMasterList: []
    });
    async function getAutoCorrection({ query: query }) {
        return aggregatorClient.getAutoCorrection({
            query: query
        });
    }
    async function search({ query: query, scopes: scopes, resultLimit: resultLimit, analytics: analytics, sites: sites = [] }) {
        return aggregatorClient.search({
            query: query,
            context: {
                sessionId: analytics.sessionId ? analytics.sessionId : 'not-applicable',
                referrerId: null
            },
            scopes: scopes,
            modelParams: [],
            resultLimit: resultLimit,
            filters: [],
            experience: `external-${analytics.identifier}`,
            sites: sites
        });
    }
    return {
        search: search,
        getAutoCorrection: getAutoCorrection
    };
};
module.exports["createClient"] = $a663f43e8e7364a7$export$5d730b7aed1a3eb0;

});

parcelRegister("iVNH5", function(module, exports) {
const $7a547b1e741af2d7$export$d35186a762cd39c8 = async (promise)=>{
    const startTime = Date.now();
    const result = await promise;
    const duration = Date.now() - startTime;
    return {
        result: result,
        durationMs: duration
    };
};
module.exports["timed"] = $7a547b1e741af2d7$export$d35186a762cd39c8;

});

parcelRegister("9cGsb", function(module, exports) {
"use strict";
var $6b362a72760d8152$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
function $6b362a72760d8152$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bAWmc = parcelRequire("bAWmc");


$6b362a72760d8152$var$__export((parcelRequire("5ixmT")));
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ var $6b362a72760d8152$var$InvalidAriError = /** @class */ function(_super) {
    $6b362a72760d8152$var$__extends(InvalidAriError, _super);
    /**
   * Construct an InvalidAriError given an error message
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {string|undefined} description - The error message
   */ function InvalidAriError(ariString, description) {
        var _this = _super.call(this, "Invalid ari string: " + ariString + (description ? '. ' + description : '')) || this;
        _this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(_this, InvalidAriError.prototype);
        return _this;
    }
    /**
   * Construct an InvalidAriError given some constraint violations
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
   */ InvalidAriError.withConstraintViolations = function(ariString, violations) {
        return new InvalidAriError(ariString, violations.map(function(v) {
            return v.toString();
        }).join('\n'));
    };
    return InvalidAriError;
}(Error);
module.exports.InvalidAriError = $6b362a72760d8152$var$InvalidAriError;
function $6b362a72760d8152$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
var $6b362a72760d8152$var$basicCharConstraint = $bAWmc.pattern(/^[a-z][a-z.-]*$/);
var $6b362a72760d8152$var$resourceOwnerConstraints = [
    $bAWmc.lengthBetween(3, 255),
    $6b362a72760d8152$var$basicCharConstraint
];
var $6b362a72760d8152$var$resourceTypeConstraints = [
    $bAWmc.lengthBetween(3, 255),
    $6b362a72760d8152$var$basicCharConstraint
];
var $6b362a72760d8152$var$cloudIdConstraints = [
    $bAWmc.lengthBetween(36, 255)
];
var $6b362a72760d8152$var$siteResourceType = 'site';
var $6b362a72760d8152$var$resourceIdChars = /[\w-._~:@#]/.source;
var $6b362a72760d8152$var$resourceIdConstraints = [
    $bAWmc.pattern(new RegExp("^" + $6b362a72760d8152$var$resourceIdChars + "+(/" + $6b362a72760d8152$var$resourceIdChars + "*)*(;v=" + $6b362a72760d8152$var$resourceIdChars + "*)*$"))
]; /**
                                                                                                                                                          * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
                                                                                                                                                          * (like those for site wide ARIs) are upgraded to their latest form.
                                                                                                                                                          */ 
function $6b362a72760d8152$var$upgrade(values) {
    var resourceId = values.resourceId, resourceOwner = values.resourceOwner, cloudId = values.cloudId; // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $6b362a72760d8152$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
var $6b362a72760d8152$var$ResourceIdentifier = /** @class */ function() {
    /**
   * Create a new Ari
   *
   * Only the resourceOwner is a required field, any other field can be omitted.
   * Older format types are converted on creation
   *
   * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
   * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
   * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
   * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
   *
   * @throws {InvalidAriError} if the provided segments fail to pass validation
   */ function ResourceIdentifier(values) {
        var _a = $6b362a72760d8152$var$upgrade(values), resourceId = _a.resourceId, resourceOwner = _a.resourceOwner, resourceType = _a.resourceType, cloudId = _a.cloudId;
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    Object.defineProperty(ResourceIdentifier.prototype, "cloudId", {
        get: function() {
            if (this.resourceType === $6b362a72760d8152$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
            return this.internalCloudId;
        },
        enumerable: true,
        configurable: true
    });
    /**
  * Parse a string as an Ari
  *
  * @param {string} ariString - the string to parse
  * @returns {Ari} the parsed ari
  * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
  */ ResourceIdentifier.parse = function(ariString) {
        if (!ariString) throw new $6b362a72760d8152$var$InvalidAriError(ariString);
        var match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $6b362a72760d8152$var$InvalidAriError(ariString);
        var terms = match.map(function(a) {
            return a && a.length > 0 ? a : undefined;
        });
        var resourceOwner = terms[1];
        if (!resourceOwner) throw new $6b362a72760d8152$var$InvalidAriError(ariString);
        return new ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    };
    ResourceIdentifier.parseEncoded = function(encodedAriString) {
        return $6b362a72760d8152$var$parse(decodeURIComponent(encodedAriString));
    }; /**
      * Converts this Ari to a string.
      */ 
    ResourceIdentifier.prototype.toString = function() {
        if (!this.ariString) {
            var resourceId = this.resourceType === $6b362a72760d8152$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            var resourceType = this.resourceType || '';
            var sanitizedCloudId = this.resourceType === $6b362a72760d8152$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = "ari:cloud:" + this.resourceOwner + ":" + sanitizedCloudId + ":" + resourceType + "/" + resourceId;
        }
        return this.ariString;
    }; /**
      * Converts this object to its json representation
      */ 
    ResourceIdentifier.prototype.toJSON = function() {
        return this.toString();
    }; /**
      * Checks if this context is the same as another context
      *
      * @param {Ari} other - the other parameter to match with
      * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
      */ 
    ResourceIdentifier.prototype.equals = function(other) {
        return other instanceof ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    }; /**
      * This method checks if the current context contains the other context.
      *
      * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
      * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
      *
      * @param {Ari} other
      * @returns {boolean}
      */ 
    ResourceIdentifier.prototype.contains = function(other) {
        return this.matches(new ResourceIdentifier(other));
    }; /**
      * Checks if this context is the same as or contains the provided context.
      *
      * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
      *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
      *
      * e.g.
      * ```
      * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
      * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
      *
      * @param {Ari} other - the other parameter to match with
      * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
      */ 
    ResourceIdentifier.prototype.matches = function(other) {
        return $6b362a72760d8152$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $6b362a72760d8152$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $6b362a72760d8152$var$siteResourceType && !!other.resourceType || $6b362a72760d8152$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $6b362a72760d8152$var$siteResourceType && !!other.resourceType || $6b362a72760d8152$var$matchesSegment(this.resourceId, other.resourceId));
    };
    ResourceIdentifier.prototype.validateSiteWide = function() {
        var _a = this, resourceType = _a.resourceType, cloudId = _a.cloudId;
        if (resourceType === $6b362a72760d8152$var$siteResourceType && !cloudId) return new $bAWmc.GeneralValidationError('site wide ARIs must have a cloudId');
    };
    ResourceIdentifier.prototype.validate = function() {
        var constraintViolations = [
            $bAWmc.validateField(this, 'resourceOwner', $6b362a72760d8152$var$resourceOwnerConstraints),
            $bAWmc.validateField(this, 'resourceType', $6b362a72760d8152$var$resourceTypeConstraints),
            $bAWmc.validateField(this, 'resourceId', $6b362a72760d8152$var$resourceIdConstraints),
            $bAWmc.validateField(this, 'cloudId', $6b362a72760d8152$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter(function(v) {
            return v;
        });
        if (constraintViolations.length > 0) throw $6b362a72760d8152$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $6b362a72760d8152$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    };
    ResourceIdentifier.prototype.urlEncode = function() {
        return encodeURIComponent(this.toString());
    };
    ResourceIdentifier.prototype.urlDecode = function() {
        return decodeURIComponent(this.toString());
    };
    return ResourceIdentifier;
}();
module.exports.ResourceIdentifier = $6b362a72760d8152$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $6b362a72760d8152$var$parse(ariString) {
    return $6b362a72760d8152$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $6b362a72760d8152$var$parse; /**
                        * Parse a URL encoded string as an Ari
                        *
                        * @param {string} encodedAriString - the string to parse
                        * @returns {Ari} the parsed ari
                        * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
                        */ 
function $6b362a72760d8152$var$parseEncoded(encodedAriString) {
    return $6b362a72760d8152$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $6b362a72760d8152$var$parseEncoded;

});

parcelRegister("bAWmc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $871053056dfd3da9$var$LengthConstraint = /** @class */ function() {
    function LengthConstraint(min, max) {
        this.min = min;
        this.max = max;
    }
    Object.defineProperty(LengthConstraint.prototype, "description", {
        get: function() {
            return "length must be between " + this.min + " and " + this.max;
        },
        enumerable: true,
        configurable: true
    });
    LengthConstraint.prototype.isValid = function(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    };
    return LengthConstraint;
}();
module.exports.LengthConstraint = $871053056dfd3da9$var$LengthConstraint;
var $871053056dfd3da9$var$RegexConstraint = /** @class */ function() {
    function RegexConstraint(regex) {
        this.regex = regex;
    }
    Object.defineProperty(RegexConstraint.prototype, "description", {
        get: function() {
            return "value must match regex " + this.regex.source;
        },
        enumerable: true,
        configurable: true
    });
    RegexConstraint.prototype.isValid = function(value) {
        return !value || this.regex.test(value);
    };
    return RegexConstraint;
}();
module.exports.RegexConstraint = $871053056dfd3da9$var$RegexConstraint;
var $871053056dfd3da9$var$GeneralValidationError = /** @class */ function() {
    function GeneralValidationError(error) {
        this.error = error;
    }
    GeneralValidationError.prototype.toString = function() {
        return this.error;
    };
    return GeneralValidationError;
}();
module.exports.GeneralValidationError = $871053056dfd3da9$var$GeneralValidationError;
var $871053056dfd3da9$var$ConstraintViolation = /** @class */ function() {
    function ConstraintViolation(fieldName, value, constraints) {
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    ConstraintViolation.prototype.toString = function() {
        var constraintSummary = this.constraints.map(function(c) {
            return "  - " + c.description;
        }).join('\n');
        return "'" + this.value + "' is not a valid value for " + this.fieldName + " as it violates the following constraints:\n" + constraintSummary;
    };
    return ConstraintViolation;
}();
module.exports.ConstraintViolation = $871053056dfd3da9$var$ConstraintViolation;
function $871053056dfd3da9$var$lengthBetween(min, max) {
    return new $871053056dfd3da9$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $871053056dfd3da9$var$lengthBetween;
function $871053056dfd3da9$var$pattern(regex) {
    return new $871053056dfd3da9$var$RegexConstraint(regex);
}
module.exports.pattern = $871053056dfd3da9$var$pattern;
function $871053056dfd3da9$var$validateField(object, fieldName, constraints) {
    var value = object[fieldName];
    var violatedConstraints = constraints.map(function(c) {
        return c.isValid(value) ? undefined : c;
    }).filter(function(c) {
        return c;
    });
    return violatedConstraints.length > 0 ? new $871053056dfd3da9$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $871053056dfd3da9$var$validateField;

});

parcelRegister("5ixmT", function(module, exports) {
"use strict";
var $3db8846e4ba8de9f$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $199iK = parcelRequire("199iK");

var $3db8846e4ba8de9f$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($3db8846e4ba8de9f$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
var $3db8846e4ba8de9f$var$AppFamilyAriError = /** @class */ function(_super) {
    $3db8846e4ba8de9f$var$__extends(AppFamilyAriError, _super);
    function AppFamilyAriError(message, cause) {
        var _this = _super.call(this, message) || this;
        _this.cause = cause;
        return _this;
    }
    return AppFamilyAriError;
}(Error);
module.exports.AppFamilyAriError = $3db8846e4ba8de9f$var$AppFamilyAriError;
var $3db8846e4ba8de9f$var$NotAppFamilyAriError = /** @class */ function(_super) {
    $3db8846e4ba8de9f$var$__extends(NotAppFamilyAriError, _super);
    function NotAppFamilyAriError(ari, reason) {
        var _this = _super.call(this, "ari is not a valid App family ari: " + ari.toString() + " as " + reason) || this;
        _this.reason = reason;
        return _this;
    }
    return NotAppFamilyAriError;
}($3db8846e4ba8de9f$var$AppFamilyAriError);
module.exports.NotAppFamilyAriError = $3db8846e4ba8de9f$var$NotAppFamilyAriError;
var $3db8846e4ba8de9f$var$NotExpectedAppFamilyAriTypeError = /** @class */ function(_super) {
    $3db8846e4ba8de9f$var$__extends(NotExpectedAppFamilyAriTypeError, _super);
    function NotExpectedAppFamilyAriTypeError(type, ari, cause) {
        var _this = _super.call(this, "App family ari (" + ari.toString() + ") is not of expected type: " + type, cause) || this;
        _this.cause = cause;
        return _this;
    }
    return NotExpectedAppFamilyAriTypeError;
}($3db8846e4ba8de9f$var$AppFamilyAriError);
module.exports.NotExpectedAppFamilyAriTypeError = $3db8846e4ba8de9f$var$NotExpectedAppFamilyAriTypeError; /**
                                                                              * throws NotAppFamilyAriError if not a valid app family ari
                                                                              */ 
function $3db8846e4ba8de9f$var$parseAppAri(ari) {
    return $199iK.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $3db8846e4ba8de9f$var$parseAppAri;
function $3db8846e4ba8de9f$var$createAppAri(json) {
    return new $199iK.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $3db8846e4ba8de9f$var$createAppAri;

});

parcelRegister("199iK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5ixmT = parcelRequire("5ixmT");


var $9cGsb = parcelRequire("9cGsb");

var $0d5dd8c916c95343$var$versionPrefix = ';v=';
var $0d5dd8c916c95343$var$AppFamilyAriImpl = /** @class */ function() {
    function AppFamilyAriImpl(json) {
        this.json = json;
    }
    Object.defineProperty(AppFamilyAriImpl.prototype, "appId", {
        get: function() {
            return this.json.appId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "environmentId", {
        get: function() {
            return this.json.environmentId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "version", {
        get: function() {
            return this.json.version;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "extensionGroupId", {
        get: function() {
            return this.json.extensionGroupId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "extensionKey", {
        get: function() {
            return this.json.extensionKey;
        },
        enumerable: true,
        configurable: true
    });
    AppFamilyAriImpl.prototype.toJSON = function() {
        return this.json;
    };
    AppFamilyAriImpl.parse = function(ari) {
        var resourceOwner = ari.resourceOwner, resourceType = ari.resourceType, resourceId = ari.resourceId;
        if (resourceOwner !== $5ixmT.AppFamilyAri.resourceOwner) throw new $5ixmT.NotAppFamilyAriError(ari, "resourceOwner (" + resourceOwner + ") must be " + $5ixmT.AppFamilyAri.resourceOwner);
        if (!resourceType || $5ixmT.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $5ixmT.NotAppFamilyAriError(ari, "resourceType must be one of " + $5ixmT.AppFamilyAri.appFamilyResourceTypes);
        if (!resourceId) throw new $5ixmT.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        var versionIndex = resourceId.indexOf($0d5dd8c916c95343$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($0d5dd8c916c95343$var$versionPrefix) > versionIndex) throw new $5ixmT.NotAppFamilyAriError(ari, 'can only include one version suffix');
        var _a = resourceId.split($0d5dd8c916c95343$var$versionPrefix), mainResourceId = _a[0], version = _a[1];
        var segments = mainResourceId.split('/').map($0d5dd8c916c95343$var$stripToUndefined);
        if (segments.length > 4) throw new $5ixmT.NotAppFamilyAriError(ari, "no path segments can be added after extensionKey " + segments.slice(4));
        var _b = segments[0], appId = _b === void 0 ? undefined : _b, _c = segments[1], environmentId = _c === void 0 ? undefined : _c, _d = segments[2], providedExtensionGroupId = _d === void 0 ? undefined : _d, _e = segments[3], extensionKey = _e === void 0 ? undefined : _e;
        if (!appId) throw new $5ixmT.NotAppFamilyAriError(ari, 'appId must be included');
        var extensionGroupId = providedExtensionGroupId || (resourceType === $5ixmT.AppFamilyAri.extensionGroupResourceType || resourceType === $5ixmT.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $5ixmT.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId, extensionGroupId, extensionKey must all be provided for resourceType " + $5ixmT.AppFamilyAri.extensionResourceType);
        else if (resourceType === $5ixmT.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId, extensionGroupId must all be provided for resourceType " + $5ixmT.AppFamilyAri.extensionGroupResourceType);
        else if (resourceType === $5ixmT.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId must be provided for resourceType " + $5ixmT.AppFamilyAri.environmentResourceType);
        else if (resourceType === $5ixmT.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, "environmentId must be provided for resourceType " + $5ixmT.AppFamilyAri.environmentResourceType);
        return new AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    };
    AppFamilyAriImpl.prototype.asAppAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isAppAri();
        }, 'app');
    };
    AppFamilyAriImpl.prototype.asAppEnvironmentAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isAppEnvironmentAri();
        }, 'environment');
    };
    AppFamilyAriImpl.prototype.asExtensionGroupAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isExtensionGroupAri();
        }, 'extension-group');
    };
    AppFamilyAriImpl.prototype.asExtensionAri = function() {
        var _this = this;
        return this.returnIf(function() {
            return _this.isExtensionAri();
        }, 'extension');
    };
    AppFamilyAriImpl.prototype.isAppAri = function() {
        return !this.isAtLeastAppEnvironmentAri;
    };
    AppFamilyAriImpl.prototype.isAppEnvironmentAri = function() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    };
    AppFamilyAriImpl.prototype.isExtensionGroupAri = function() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    };
    AppFamilyAriImpl.prototype.isExtensionAri = function() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    };
    AppFamilyAriImpl.prototype.returnIf = function(check, type) {
        if (!check()) throw new $5ixmT.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    };
    Object.defineProperty(AppFamilyAriImpl.prototype, "isAtLeastAppEnvironmentAri", {
        get: function() {
            return this.environmentId !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AppFamilyAriImpl.prototype, "isAtLeastExtensionGroupAri", {
        get: function() {
            return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    AppFamilyAriImpl.prototype.toAri = function() {
        var resourceOwner = $5ixmT.AppFamilyAri.resourceOwner;
        var _a = this.toJSON(), appId = _a.appId, environmentId = _a.environmentId, extensionGroupId = _a.extensionGroupId, extensionKey = _a.extensionKey, version = _a.version;
        function withVersion(segments) {
            var path = segments.join('/');
            if (!version) return path;
            else return "" + path + $0d5dd8c916c95343$var$versionPrefix + version;
        }
        if (this.isExtensionAri()) return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    };
    AppFamilyAriImpl.prototype.toString = function() {
        return this.toAri().toString();
    };
    return AppFamilyAriImpl;
}();
module.exports.AppFamilyAriImpl = $0d5dd8c916c95343$var$AppFamilyAriImpl;
function $0d5dd8c916c95343$var$stripToUndefined(str) {
    if (!str) return undefined;
    var trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});

parcelRegister("dkDqz", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");

const $2c3fc5ab77b32b66$export$3238f1bda20b469c = (0, $dOBRD.default)(()=>({
        allowBreakout: true,
        UNSAFE_addSidebarLayouts: true
    }));
module.exports["getLayoutOptions"] = $2c3fc5ab77b32b66$export$3238f1bda20b469c;

});

parcelRegister("bY24B", function(module, exports) {
const $0e0fdc78f7a1bae2$var$DEFAULT_EXPAND_OPTIONS = {
    allowInsertion: true,
    allowInteractiveExpand: true
};
const $0e0fdc78f7a1bae2$export$98ec01862577ac69 = ()=>{
    return $0e0fdc78f7a1bae2$var$DEFAULT_EXPAND_OPTIONS;
};
module.exports["useExpandOptions"] = $0e0fdc78f7a1bae2$export$98ec01862577ac69;

});

parcelRegister("jvzGU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hUz7g = parcelRequire("hUz7g");

const $83b906b815f15665$export$fddc468cd8cb4db9 = ()=>{
    return (0, $cozmU.useMemo)(()=>(0, $hUz7g.getTableOptions)(), []);
};
module.exports["useTableOptions"] = $83b906b815f15665$export$fddc468cd8cb4db9;

});

parcelRegister("hUz7g", function(module, exports) {
const $68268dc60793ca56$export$4fc4c895dbb98f6b = ()=>{
    return {
        allowTableResizing: true,
        allowTableAlignment: true,
        allowBackgroundColor: true,
        allowColumnResizing: true,
        allowColumnSorting: true,
        allowDistributeColumns: true,
        allowHeaderColumn: true,
        allowHeaderRow: true,
        allowMergeCells: true,
        allowNumberColumn: true,
        allowNestedTables: true,
        allowControls: true,
        stickyHeaders: true,
        allowAddColumnWithCustomStep: false
    };
};
module.exports["getTableOptions"] = $68268dc60793ca56$export$4fc4c895dbb98f6b;

});

parcelRegister("lmEhP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cMyWi = parcelRequire("cMyWi");


var $d5Ozc = parcelRequire("d5Ozc");


var $cDpdq = parcelRequire("cDpdq");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");


var $bQm3c = parcelRequire("bQm3c");


var $vLw8x = parcelRequire("vLw8x");


var $7zgzO = parcelRequire("7zgzO");


var $etKOR = parcelRequire("etKOR");


var $5mn6Y = parcelRequire("5mn6Y");


var $3gyyc = parcelRequire("3gyyc");


/**
 * Lazily loaded adapter that maps the editor's LinkPickerProps interface to RovoLinkPicker.
 * Loaded only when the `confluence_rovo_link_picker_experiment` experiment is enabled (TREX-1074),
 * keeping @atlassian/rovo-link-picker and its heavy transitive deps out of the baseline editor bundle.
 */ const $87c86ebe3b41800e$var$RovoLinkPickerAdapter = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "AgDGk",
    name: "RovoLinkPickerAdapter",
    loader: async ()=>(await (parcelRequire("gbbGu"))).RovoLinkPickerAdapter
});
const $87c86ebe3b41800e$var$useUndefined = ()=>undefined;
const $87c86ebe3b41800e$export$78db118acf87bd21 = (options, viewMode, isChromelessEditor, isLivePage)=>{
    const config = (0, $etKOR.useLinkingOptions)(options, isChromelessEditor);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    // TODO MODES-4363 Once getSpaTransitionDetails & its consumers are refactored to not use RoutesContext, use RouteState instead of RoutesContext
    const routesContext = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const useSmartLinkContextSafe = (0, $d5Ozc.conditionalHooksFactory)(()=>(0, $3gyyc.isSSRStreaming)(), (0, $cMyWi.useSmartLinkContext), $87c86ebe3b41800e$var$useUndefined);
    const smartCardContext = useSmartLinkContextSafe();
    const productConfig = (0, $cozmU.useMemo)(()=>({
            product: 'confluence',
            cloudId: cloudId
        }), [
        cloudId
    ]);
    /**
   * Store live page state props in refs so the onClickCallback has a stable reference
   * The onClickCallback passed to editor (and consumed within the useUniversalPreset hook)
   * is not updated when the live page state changes.
   */ const isLivePageRef = (0, $cozmU.useRef)(isLivePage);
    const viewModeRef = (0, $cozmU.useRef)(viewMode);
    (0, $cozmU.useEffect)(()=>{
        isLivePageRef.current = isLivePage;
        viewModeRef.current = viewMode;
    }, [
        isLivePage,
        viewMode
    ]);
    /**
   * By passing a callback we circumvent the default link click handling within platform
   *
   * We only want to allow smart links in live edit mode to navigte when this platform FF
   * is enabled. The guarded behaviour can be instilled as the default on clean up (alongside
   * removing the viewMode prop).
   */ const onClickCallback = (0, $cozmU.useCallback)(({ event: event, url: url })=>{
        if (viewModeRef.current && url) (0, $vLw8x.smartCardEventHandler)(routesContext, event, url);
    }, [
        routesContext
    ]);
    // Always called (rules of hooks); result discarded in treatment — useLinkPickerEditorProps
    // replaces `component` with its own wrapper, which RovoLinkPicker doesn't need.
    const defaultLinkPickerProps = (0, $cDpdq.useLinkPickerEditorProps)(undefined, (0, $6mKj3.expVal)('confluence_rovo_link_picker_experiment', 'isEnabled', false) ? undefined : productConfig);
    return (0, $cozmU.useMemo)(()=>({
            smartCardContext: smartCardContext,
            linking: {
                ...config.linking,
                linkPicker: (0, $6mKj3.expVal)('confluence_rovo_link_picker_experiment', 'isEnabled', false) ? {
                    ...config.linking?.linkPicker,
                    component: $87c86ebe3b41800e$var$RovoLinkPickerAdapter
                } : {
                    ...config.linking?.linkPicker,
                    ...defaultLinkPickerProps
                },
                smartLinks: {
                    ...config.linking?.smartLinks,
                    onClickCallback: onClickCallback
                }
            }
        }), // expVal is stable per session (experiment assignment doesn't change during a render lifecycle),
    // so it's intentionally omitted from dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        config,
        defaultLinkPickerProps,
        onClickCallback,
        smartCardContext
    ]);
};
const $87c86ebe3b41800e$export$9b0cf83b2bedfd63 = ({ children: children, options: options, viewMode: viewMode = false, isChromelessEditor: isChromelessEditor = false, isLivePage: isLivePage = false })=>{
    const mergedProps = $87c86ebe3b41800e$export$78db118acf87bd21(options, viewMode, isChromelessEditor, isLivePage);
    if ((0, $6mKj3.expVal)('confluence_quick_insert_embeds', 'cohort', 'control') !== 'control') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5mn6Y.RovoLinkPickerTabPreferenceProvider), null, children(mergedProps));
    return children(mergedProps);
};
module.exports["useLinkingFeatures"] = $87c86ebe3b41800e$export$78db118acf87bd21;
module.exports["EditorLinkingFeatures"] = $87c86ebe3b41800e$export$9b0cf83b2bedfd63;

});

parcelRegister("etKOR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kWKYj = parcelRequire("kWKYj");

const $5353808f826c81c2$export$535281304894bcdc = (cardOptions, isChromelessEditor = false)=>{
    const baseSmartLinks = (0, $kWKYj.useSmartCards)(isChromelessEditor);
    return (0, $cozmU.useMemo)(()=>({
            linking: {
                smartLinks: {
                    ...baseSmartLinks,
                    ...cardOptions
                }
            }
        }), [
        baseSmartLinks,
        cardOptions
    ]);
};
module.exports["useLinkingOptions"] = $5353808f826c81c2$export$535281304894bcdc;

});

parcelRegister("kWKYj", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ctpOV = parcelRequire("ctpOV");

const $11b3acfee7e9c227$export$5681a80d8b7b2bfb = (isChromelessEditor = false)=>{
    return (0, $cozmU.useMemo)(()=>{
        return (0, $ctpOV.getSmartCardOptions)(isChromelessEditor);
    }, [
        isChromelessEditor
    ]);
};
module.exports["useSmartCards"] = $11b3acfee7e9c227$export$5681a80d8b7b2bfb;

});

parcelRegister("ctpOV", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $iGhtC = parcelRequire("iGhtC");


var $6GQtz = parcelRequire("6GQtz");

const $97182487d32399bc$export$2a89c15ccab17d33 = (0, $dOBRD.default)((enableChromelessEditorCardProvider)=>{
    /**
   * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
   * (only supports Cloud single-issue URLs right now)
   */ const smartLinksBeforeMacros = 'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');
    const cardProvider = enableChromelessEditorCardProvider ? new (0, $iGhtC.InlineCommentEditorCardProvider)() : new (0, $6GQtz.ConfluenceEditorCardProvider)();
    if (!enableChromelessEditorCardProvider) {
        const ssrProvidersData = window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] || {};
        const ssrData = ssrProvidersData[cardProvider.name];
        cardProvider.setSSRData(ssrData);
    }
    // IMPORTANT: If you change the code below, please also update the
    // platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/pastePluginOptions.ts
    // platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/cardPluginOptions.ts
    return {
        provider: Promise.resolve(cardProvider),
        resolveBeforeMacros: smartLinksBeforeMacros,
        allowBlockCards: true,
        allowEmbeds: true
    };
});
module.exports["getSmartCardOptions"] = $97182487d32399bc$export$2a89c15ccab17d33;

});

parcelRegister("iGhtC", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $6GQtz = parcelRequire("6GQtz");

const $6f3acea258be288a$var$isLoomUrl = (url)=>{
    return url.match(// @ts-expect-error - TS1503 Typescript 5.9.2 upgrade
    RegExp("^https:\\/\\/(.*?\\.)?(loom\\..*?\\/(share|embed))\\/([a-zA-Z0-9-]*-)?(?<videoId>[a-f0-9]{32})"));
};
// MAUI app URLs: whiteboards and diagram apps embedded via native embeds
const $6f3acea258be288a$var$isWhiteboardUrl = (url)=>// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    !!url.match(RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>\\d+)(\\?\\/)?")) || !!url.match(// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>[0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12})(\\?\\/)?"));
const $6f3acea258be288a$var$isMauiUrl = (url)=>/\/remix\/ui\/[A-Za-z0-9_-]+/.test(url);
class $6f3acea258be288a$export$d4825e69ed899a33 extends (0, $6GQtz.ConfluenceEditorCardProvider) {
    getHardCodedAppearance(url) {
        if ($6f3acea258be288a$var$isLoomUrl(url)) return 'embed';
        if ((0, $9wGTI.fg)('cc_maui_embed_in_comment_editor')) {
            if ($6f3acea258be288a$var$isWhiteboardUrl(url) || $6f3acea258be288a$var$isMauiUrl(url)) return 'block';
        }
    }
}
module.exports["InlineCommentEditorCardProvider"] = $6f3acea258be288a$export$d4825e69ed899a33;

});

parcelRegister("6GQtz", function(module, exports) {

var $6RwwD = parcelRequire("6RwwD");


var $6mKj3 = parcelRequire("6mKj3");

const $1f40ba7d8e61cd02$var$isTrelloBoardUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?trello\.com\/b/);
const $1f40ba7d8e61cd02$var$isFigmaFileUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?figma\.com\/(design|board|file|proto|slides)/);
const $1f40ba7d8e61cd02$var$isFigmaMakeSiteUrl = (url)=>!!url.match(/^https:\/\/.+\.figma\.site/);
const $1f40ba7d8e61cd02$var$isMiroUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?miro\.com\/app\/board/);
const $1f40ba7d8e61cd02$var$isCanvaUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?canva\.com\/design/);
const $1f40ba7d8e61cd02$var$isLucidUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?lucid\.app\/lucidchart/);
const $1f40ba7d8e61cd02$var$isGoogleSlidesUrl = (url)=>!!url.match(/^https:\/\/docs\.google\.com\/presentation/);
const $1f40ba7d8e61cd02$var$isOneDrivePowerPointUrl = (url)=>!!url.match(/^https:\/\/onedrive\.live\.com\/:p/) || !!url.match(/^https:\/\/1drv\.ms\/p/);
const $1f40ba7d8e61cd02$var$isTrelloCardUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?trello\.com\/c/);
const $1f40ba7d8e61cd02$var$isPowerBIUrl = (url)=>!!url.match(/^https:\/\/app\.powerbi\.com\/(groups|reportEmbed)/);
const $1f40ba7d8e61cd02$var$isGoogleDocsUrl = (url)=>!!url.match(/^https:\/\/docs\.google\.com\/document/);
// https://learn.microsoft.com/en-us/onedrive/developer/controls/file-pickers/?view=odsp-graph-online
const $1f40ba7d8e61cd02$var$isLearnMicrosoftUrl = (url)=>!!url.match(/^https:\/\/learn\.microsoft\.com/);
// https://support.google.com/mail/answer/112508?hl=en&co=GENIE.Platform%3DDesktop
const $1f40ba7d8e61cd02$var$isSupportGoogleUrl = (url)=>!!url.match(/^https:\/\/support\.google\.com/);
// https://docs.github.com/en/codespaces
const $1f40ba7d8e61cd02$var$isDocsGithubUrl = (url)=>!!url.match(/^https:\/\/docs\.github\.com/);
const $1f40ba7d8e61cd02$var$isDropboxUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?dropbox\.com\/(home|preview|s|sh|sc|t|scl)/);
const $1f40ba7d8e61cd02$var$isBoxUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?box\.com\/(folder|file|notes|integrations|services|s|v)/);
const $1f40ba7d8e61cd02$var$isSlackUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?slack\.com\/(archives|client)/);
const $1f40ba7d8e61cd02$var$isTeamsUrl = (url)=>!!url.match(/^https:\/\/teams\.microsoft\.com\/l\/channel/) || !!url.match(/^https:\/\/teams\.cloud\.microsoft\/l\/channel/);
const $1f40ba7d8e61cd02$var$isLovableAppUrl = (url)=>!!url.match(/^https:\/\/.+\.lovable\.app/);
const $1f40ba7d8e61cd02$var$isReplitAppUrl = (url)=>!!url.match(/^https:\/\/.+\.replit\.app/);
class $1f40ba7d8e61cd02$export$9d24f5da29b1273e extends (0, $6RwwD.EditorCardProvider) {
    getHardCodedAppearance(url) {
        if ((0, $6mKj3.isExperimentEnabled)('confluence_smartlink_default_display_types')) {
            if (this.shouldDisplayAsEmbed(url)) return 'embed';
            if (this.shouldDisplayAsCard(url)) return 'block';
        }
        return super.getHardCodedAppearance(url);
    }
    /**
   * Opt in to honouring an explicitly-requested embed appearance as the default
   * (validated, with a card fallback) for the quick-insert embed flow. Both active
   * cohorts of the quick-insert embeds experiment (`prioritizeLinkInQIM` and
   * `prioritizeEmbedInQIM`) enable this — they differ only in quick-insert menu
   * ordering, not in embedding behaviour. Only `control` and unenrolled users keep
   * the existing behaviour.
   *
   * The platform only calls this when a link is inserted with a requested embed
   * appearance and the user has no saved preference, so the exposure here is
   * scoped to the quick-insert embed insertion path.
   */ shouldHonorRequestedEmbedAsDefault() {
        return (0, $6mKj3.expVal)('confluence_quick_insert_embeds', 'cohort', 'control') !== 'control';
    }
    shouldDisplayAsEmbed(url) {
        return $1f40ba7d8e61cd02$var$isTrelloBoardUrl(url) || $1f40ba7d8e61cd02$var$isFigmaFileUrl(url) || $1f40ba7d8e61cd02$var$isFigmaMakeSiteUrl(url) || $1f40ba7d8e61cd02$var$isMiroUrl(url) || $1f40ba7d8e61cd02$var$isCanvaUrl(url) || $1f40ba7d8e61cd02$var$isLucidUrl(url) || $1f40ba7d8e61cd02$var$isGoogleSlidesUrl(url) || $1f40ba7d8e61cd02$var$isOneDrivePowerPointUrl(url);
    }
    shouldDisplayAsCard(url) {
        return $1f40ba7d8e61cd02$var$isTrelloCardUrl(url) || $1f40ba7d8e61cd02$var$isPowerBIUrl(url) || $1f40ba7d8e61cd02$var$isGoogleDocsUrl(url) || $1f40ba7d8e61cd02$var$isLearnMicrosoftUrl(url) || $1f40ba7d8e61cd02$var$isSupportGoogleUrl(url) || $1f40ba7d8e61cd02$var$isDocsGithubUrl(url) || $1f40ba7d8e61cd02$var$isDropboxUrl(url) || $1f40ba7d8e61cd02$var$isBoxUrl(url) || $1f40ba7d8e61cd02$var$isSlackUrl(url) || $1f40ba7d8e61cd02$var$isTeamsUrl(url) || $1f40ba7d8e61cd02$var$isLovableAppUrl(url) || $1f40ba7d8e61cd02$var$isReplitAppUrl(url);
    }
    constructor(envKey, baseUrlOverride, onResolve, customCardClient, supportedUrlFilter, name){
        super(envKey, baseUrlOverride, 'CONFLUENCE', onResolve, customCardClient, supportedUrlFilter);
        this.name = void 0;
        this.name = name ?? 'editorCardProvider';
    }
}
module.exports["ConfluenceEditorCardProvider"] = $1f40ba7d8e61cd02$export$9d24f5da29b1273e;

});

parcelRegister("6RwwD", function(module, exports) {
/* eslint-disable require-unicode-regexp,prefer-regex-literals */ 
var $jawC3 = parcelRequire("jawC3");


var $drRzc = parcelRequire("drRzc");


var $ieeJu = parcelRequire("ieeJu");


var $4B79C = parcelRequire("4B79C");

var $ggGdk = parcelRequire("ggGdk");


var $6Q8Dd = parcelRequire("6Q8Dd");


var $koAyx = parcelRequire("koAyx");


var $8kONW = parcelRequire("8kONW");


var $4yccB = parcelRequire("4yccB");


var $ixfCV = parcelRequire("ixfCV");


var $biKbJ = parcelRequire("biKbJ");


var $iyuxZ = parcelRequire("iyuxZ");

const $d4521f0694a3bb0e$var$BATCH_WAIT_TIME = 50;
// Check if it is matching a Jira Roadmaps or Jira Timeline url
// NOT to be confused with JSM timeline
const $d4521f0694a3bb0e$var$JIRA_ROADMAP_OR_TIMELINE_REGEX = /^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/.*?\/(timeline|roadmap)\/?/;
const $d4521f0694a3bb0e$var$POLARIS_VIEW_REGEX = /^https:\/\/.*?\/jira\/polaris\/projects\/[^\/]+?\/ideas\/view\/\d+$|^https:\/\/.*?\/secure\/JiraProductDiscoveryAnonymous\.jspa\?hash=\w+|^https:\/\/.*?\/jira\/polaris\/share\/\w+|^https:\/\/.*?\/jira\/discovery\/share\/views\/[\w-]+(\?selectedIssue=[\w-]+&issueViewLayout=sidebar&issueViewSection=[\w-]+)?$/;
const $d4521f0694a3bb0e$var$JWM_VIEW_REGEX = /^https:\/\/.*?\/jira\/core\/projects\/[^\/]+?\/(timeline|calendar|list|board|summary|(form\/[^\/]+?))\/?/;
const $d4521f0694a3bb0e$var$JIRA_LIST_REGEX = /^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/list\/?/;
const $d4521f0694a3bb0e$var$GIPHY_MEDIA_REGEX = /^https:\/\/(.*?\.)?giphy\.com\/(gifs|media|clips)\//;
const $d4521f0694a3bb0e$var$PROFORMA_VIEW_REGEX = /^https:\/\/[^/]+\/jira\/(core|software(\/c)?|servicedesk)\/projects\/\w+\/forms\/form\/direct\/\d+\/\d+.*$/;
// prettier-ignore
// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
const $d4521f0694a3bb0e$var$CONFLUENCE_WHITEBOARD_DECIMAL_REGEX = RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>\\d+)(\\?\\/)?");
// prettier-ignore
// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
const $d4521f0694a3bb0e$var$CONFLUENCE_WHITEBOARD_UUID_REGEX = RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>[0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12})(\\?\\/)?");
const $d4521f0694a3bb0e$var$CONFLUENCE_DATABASE_REGEX = /\/wiki\/spaces\/~?[\d\w]+\/database\/\d+(\?.*)?$/;
const $d4521f0694a3bb0e$var$YOUTUBE_VIDEO_REGEX = /^https:\/\/(.*?\.)?(youtube\..*?\/(watch\?|v\/|shorts\/)|youtu\.be)/;
// prettier-ignore
// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
const $d4521f0694a3bb0e$var$LOOM_VIDEO_URL_REGEX = RegExp("^https:\\/\\/(.*?\\.)?(loom\\..*?\\/(share|embed))\\/([a-zA-Z0-9-]*-)?(?<videoId>[a-f0-9]{32})");
// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
const $d4521f0694a3bb0e$var$LOOM_SCREENSHOT_URL_REGEX = RegExp("^https:\\/\\/(.*?\\.)?loom\\..*?\\/i\\/(?<id>[a-f0-9]{32})");
const $d4521f0694a3bb0e$var$JIRA_DASHBOARD_REGEX = /^https:\/\/.*?\/jira\/dashboards\/[0-9]+.*/;
const $d4521f0694a3bb0e$var$JIRA_BACKLOG_REGEX = /https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\/backlog\??.*/;
const $d4521f0694a3bb0e$var$JIRA_BOARD_REGEX = /https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\??.*/;
// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
const $d4521f0694a3bb0e$var$JIRA_PLAN_REGEX = RegExp("https:\\/\\/.*?\\/jira\\/plans\\/(?<resourceId>\\d+)");
// prettier-ignore
// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
const $d4521f0694a3bb0e$var$JIRA_PLAN_WITH_SCENARIO_REGEX = RegExp("https:\\/\\/.*?\\/jira\\/plans\\/(?<resourceId>\\d+)\\/scenarios\\/(?<resourceContext>\\d+)\\/(timeline|summary|calendar|program\\/\\d+|dependencies)\\/?");
const $d4521f0694a3bb0e$var$JIRA_VERSION_REGEX = /https:\/\/.*?\/projects\/[^\/]+?\/versions\/\d+\/tab\/release-report-all-issues/;
const $d4521f0694a3bb0e$var$JIRA_FORM_REGEX = /https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/form\/\d\??.*/;
const $d4521f0694a3bb0e$var$JIRA_SUMMARY_REGEX = /^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/summary/;
const $d4521f0694a3bb0e$var$ROVO_AGENT_PROFILE_PAGE_REGEX = /^https:\/\/.*?\/people\/agent\/.+$/;
const $d4521f0694a3bb0e$var$CUSTOMER_360_LANDING_PAGE_REGEX = /^https:\/\/customer\.atlassian\.com\/.*$/;
// prettier-ignore
// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
const $d4521f0694a3bb0e$var$CONFLUENCE_TEAM_CALENDARS_REGEX = RegExp("\\/wiki\\/spaces\\/(?<resourceContext>[^\\/]+)\\/calendars\\/(?<resourceId>[a-zA-Z0-9-]+)");
const $d4521f0694a3bb0e$var$JIRA_ISSUE_NAVIGATOR_REGEX = /^https:\/\/.*?\/jira\/software|core\/(c\/)?projects\/[^\/]+?\/issues\/?/;
const $d4521f0694a3bb0e$var$AVP_VISUALIZATION_VIEW_REGEX = /^https:\/\/.*?\/avpviz\/c\/[^\/]+.*/;
const $d4521f0694a3bb0e$var$JIRA_WORK_ITEM_REGEX = /\/browse\/((?:\w+)-(?:\d+))/i;
const $d4521f0694a3bb0e$var$DOES_URL_MATCH_PATH_START_REGEX = /^[a-zA-Z0-9]/;
const $d4521f0694a3bb0e$var$DOES_URL_MATCH_PATH_END_REGEX = /[a-zA-Z0-9]$/;
const $d4521f0694a3bb0e$var$isJiraRoadmapOrTimeline = (url)=>url.match($d4521f0694a3bb0e$var$JIRA_ROADMAP_OR_TIMELINE_REGEX);
const $d4521f0694a3bb0e$var$isPolarisView = (url)=>url.match($d4521f0694a3bb0e$var$POLARIS_VIEW_REGEX);
const $d4521f0694a3bb0e$var$isJwmView = (url)=>url.match($d4521f0694a3bb0e$var$JWM_VIEW_REGEX);
const $d4521f0694a3bb0e$var$isJiraList = (url)=>url.match($d4521f0694a3bb0e$var$JIRA_LIST_REGEX);
const $d4521f0694a3bb0e$var$isGiphyMedia = (url)=>url.match($d4521f0694a3bb0e$var$GIPHY_MEDIA_REGEX);
const $d4521f0694a3bb0e$var$isProformaView = (url)=>url.match($d4521f0694a3bb0e$var$PROFORMA_VIEW_REGEX);
const $d4521f0694a3bb0e$var$isConfluenceWhiteboard = (url)=>url.match($d4521f0694a3bb0e$var$CONFLUENCE_WHITEBOARD_DECIMAL_REGEX) || url.match($d4521f0694a3bb0e$var$CONFLUENCE_WHITEBOARD_UUID_REGEX);
const $d4521f0694a3bb0e$var$isConfluenceDatabase = (url)=>url.match($d4521f0694a3bb0e$var$CONFLUENCE_DATABASE_REGEX);
const $d4521f0694a3bb0e$var$isYoutubeVideo = (url)=>url.match($d4521f0694a3bb0e$var$YOUTUBE_VIDEO_REGEX);
const $d4521f0694a3bb0e$var$isLoomVideoUrl = (url)=>{
    return url.match($d4521f0694a3bb0e$var$LOOM_VIDEO_URL_REGEX);
};
const $d4521f0694a3bb0e$var$isLoomScreenshotUrl = (url)=>{
    return url.match($d4521f0694a3bb0e$var$LOOM_SCREENSHOT_URL_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraDashboard = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_DASHBOARD_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraBacklog = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_BACKLOG_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraBoard = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_BOARD_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraPlan = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_PLAN_REGEX) || url.match($d4521f0694a3bb0e$var$JIRA_PLAN_WITH_SCENARIO_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraVersion = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_VERSION_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraForm = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_FORM_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraSummary = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_SUMMARY_REGEX);
};
const $d4521f0694a3bb0e$var$isRovoAgentProfilePage = (url)=>{
    return url.match($d4521f0694a3bb0e$var$ROVO_AGENT_PROFILE_PAGE_REGEX);
};
const $d4521f0694a3bb0e$var$isCustomer360LandingPage = (url)=>url.match($d4521f0694a3bb0e$var$CUSTOMER_360_LANDING_PAGE_REGEX);
const $d4521f0694a3bb0e$var$isConfluenceTeamCalendars = (url)=>url.match($d4521f0694a3bb0e$var$CONFLUENCE_TEAM_CALENDARS_REGEX);
const $d4521f0694a3bb0e$var$isJiraIssueNavigator = (url)=>url.match($d4521f0694a3bb0e$var$JIRA_ISSUE_NAVIGATOR_REGEX);
const $d4521f0694a3bb0e$var$isAvpVisualizationView = (url)=>url.match($d4521f0694a3bb0e$var$AVP_VISUALIZATION_VIEW_REGEX);
const $d4521f0694a3bb0e$export$6a9668b99d8a1708 = (url)=>$d4521f0694a3bb0e$var$JIRA_WORK_ITEM_REGEX.test(url);
// Local UrlChecker-compatible wrapper around the boolean-returning
// `isConfluenceSlideUrl` from `./url-checkers` (the single source of truth for
// slide URL matching). Wrapping (rather than aliasing the imported identifier
// directly inside the exported `internalUrlCheckers` object) avoids the
// @atlaskit/editor/no-re-export lint rule and gives the registry a uniform
// `(url) => RegExpMatchArray | null` signature. Consumers of
// `internalUrlCheckers` only check the truthiness of the result, so returning
// a synthetic single-element match array (or `null`) preserves behaviour.
const $d4521f0694a3bb0e$var$isConfluenceSlide = (url)=>(0, $8kONW.isConfluenceSlideUrl)(url) ? [
        url
    ] : null;
const $d4521f0694a3bb0e$export$da256e60841d38fd = {
    isJiraRoadmapOrTimeline: $d4521f0694a3bb0e$var$isJiraRoadmapOrTimeline,
    isPolarisView: $d4521f0694a3bb0e$var$isPolarisView,
    isJwmView: $d4521f0694a3bb0e$var$isJwmView,
    isJiraList: $d4521f0694a3bb0e$var$isJiraList,
    isConfluenceWhiteboard: $d4521f0694a3bb0e$var$isConfluenceWhiteboard,
    isConfluenceDatabase: $d4521f0694a3bb0e$var$isConfluenceDatabase,
    isConfluenceSlide: $d4521f0694a3bb0e$var$isConfluenceSlide,
    isJiraDashboard: $d4521f0694a3bb0e$var$isJiraDashboard,
    isJiraBacklog: $d4521f0694a3bb0e$var$isJiraBacklog,
    isJiraBoard: $d4521f0694a3bb0e$var$isJiraBoard,
    isJiraPlan: $d4521f0694a3bb0e$var$isJiraPlan,
    isJiraVersion: $d4521f0694a3bb0e$var$isJiraVersion,
    isJiraForm: $d4521f0694a3bb0e$var$isJiraForm,
    isJiraSummary: $d4521f0694a3bb0e$var$isJiraSummary,
    isRovoAgentProfilePage: $d4521f0694a3bb0e$var$isRovoAgentProfilePage,
    isConfluenceTeamCalendars: $d4521f0694a3bb0e$var$isConfluenceTeamCalendars,
    isJiraIssueNavigator: $d4521f0694a3bb0e$var$isJiraIssueNavigator
};
function $d4521f0694a3bb0e$export$4006295459a20a0(url) {
    return Object.values($d4521f0694a3bb0e$export$da256e60841d38fd).some((checker)=>checker(url));
}
function $d4521f0694a3bb0e$export$78234eee43b97e81(url) {
    return !$d4521f0694a3bb0e$export$4006295459a20a0(url);
}
function $d4521f0694a3bb0e$var$getAppearanceForNode(node) {
    return node.type === 'blockCard' ? 'block' : node.type === 'embedCard' ? 'embed' : 'inline';
}
function $d4521f0694a3bb0e$var$isCardNode(node) {
    return [
        'inlineCard',
        'blockCard',
        'embedCard'
    ].includes(node.type) && !!node.attrs && 'url' in node.attrs && typeof node.attrs.url === 'string';
}
class $d4521f0694a3bb0e$export$e4635c0135e1a519 extends (0, $drRzc.NodeDataProvider) {
    refreshCache(node) {
        if (this.getCacheStatusForNode(node) !== 'network') this.getData(node, ()=>{});
    }
    getData(node, callback) {
        if ((0, $ieeJu.expValEquals)('platform_editor_smartlink_local_cache', 'isEnabled', true) === false) // if local cache feature flag is disabled, fall back to the base implementation
        return super.getData(node, callback);
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) return;
        // if we can load a response from cache, use it first
        const key = this.nodeDataKey(jsonNode);
        const details = this.smartCardLocalCacheClient.getItem(key);
        // NAVX-4712: Handle responses with non-resolved statuses that were previously cached
        const isResolvedCachedResponse = details && details.meta && (0, $ggGdk.getStatus)(details) === 'resolved';
        if (isResolvedCachedResponse) callback({
            data: details
        });
        // if parent class NodeDataProvider has cached the network request for the node
        // we can skip fetching the data async and updating the session storage cache
        if (isResolvedCachedResponse && this.getCacheStatusForNode(jsonNode) === 'network') return;
        // fetch the latest data async and update the session storage cache
        this.getDataAsync(node, (payload)=>{
            const response = payload.data;
            if (!payload.error && response?.meta) {
                const status = (0, $ggGdk.getStatus)(response);
                if (status === 'resolved') this.smartCardLocalCacheClient.setItem(key, response);
            }
            callback(payload);
        });
    }
    nodeDataKey(node) {
        if (!(0, $ixfCV.fg)('platform_smartlink_inline_resolve_optimization')) return node.attrs.url;
        return `${node.attrs.url}|${$d4521f0694a3bb0e$var$getAppearanceForNode(node)}`;
    }
    fetchNodesData(nodes) {
        const promises = nodes.map((node)=>{
            const url = node.attrs.url;
            const appearance = (0, $ixfCV.fg)('platform_smartlink_inline_resolve_optimization') ? $d4521f0694a3bb0e$var$getAppearanceForNode(node) : undefined;
            return this.cardClient.fetchData(url, false, appearance);
        });
        return Promise.all(promises);
    }
    isNodeSupported(node) {
        if (!$d4521f0694a3bb0e$var$isCardNode(node)) return false;
        if (!this.supportedUrlFilter) return true;
        return this.supportedUrlFilter(node.attrs.url);
    }
    async batchProviders(keys) {
        // EDM-2205: Batch requests in the case that user paste multiple links at
        // once. This is so that only one /providersData is being called.
        const providersData = await this.fetchProvidersData();
        return keys.map(()=>providersData);
    }
    async checkLinkResolved(resourceUrl) {
        try {
            const response = await this.fetchData(resourceUrl);
            if ((0, $ggGdk.getStatus)(response) !== 'not_found') return true;
        } catch  {
            return false;
        }
    }
    async fetchDataForResource(resourceUrl) {
        try {
            const response = await this.fetchData(resourceUrl);
            if ((0, $ggGdk.getStatus)(response) !== 'not_found') return response;
        } catch  {
            return undefined;
        }
    }
    extractAriFromData(responseData) {
        if (responseData.data && 'atlassian:ari' in responseData.data) return responseData.data['atlassian:ari'];
        return undefined;
    }
    async fetchProvidersData() {
        const endpoint = `${this.resolverUrl}/providers`;
        const response = await (0, $biKbJ.request)('post', endpoint, undefined, this.requestHeaders);
        return {
            patterns: response.providers.reduce((allSources, provider)=>{
                return allSources.concat(provider.patterns);
            }, []),
            userPreferences: response.userPreferences
        };
    }
    async loadProviderData() {
        try {
            this.providersData = await this.providersLoader.load('providersData');
        } catch (err) {
            // eslint-disable-next-line
            console.error('failed to fetch /providers', err);
            this.providersLoader.clear('providerData');
            return undefined;
        }
    }
    async findPattern(url) {
        return !!await this.findPatternData(url) || !!await this.checkLinkResolved(url);
    }
    doesUrlMatchPath(path, url) {
        // Using [a-zA-Z0-9] here instead of \w since that includes underscores
        const startingRegex = $d4521f0694a3bb0e$var$DOES_URL_MATCH_PATH_START_REGEX.test(path) ? '(^|[^a-zA-Z0-9])' : '';
        const endingRegex = $d4521f0694a3bb0e$var$DOES_URL_MATCH_PATH_END_REGEX.test(path) ? '($|[^a-zA-Z0-9])' : '';
        const escapedPath = path.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        const regexPattern = new RegExp(`${startingRegex}${escapedPath}${endingRegex}`);
        return regexPattern.test(url);
    }
    async findUserPreference(url) {
        if (!this.providersData) await this.loadProviderData();
        const userPreferences = this.providersData?.userPreferences;
        if (userPreferences) {
            const { defaultAppearance: defaultAppearance, appearances: appearances } = userPreferences;
            const allMatchedLabeledAppearances = appearances.filter(({ urlSegment: urlSegment })=>this.doesUrlMatchPath(urlSegment, url));
            if (allMatchedLabeledAppearances.length > 0) {
                const longestMatchedLabeledAppearance = allMatchedLabeledAppearances.reduce((previousLabeledAppearance, currentLabeledAppearance)=>previousLabeledAppearance.urlSegment.length > currentLabeledAppearance.urlSegment.length ? previousLabeledAppearance : currentLabeledAppearance);
                return longestMatchedLabeledAppearance.appearance;
            }
            if (defaultAppearance !== 'inline') return defaultAppearance;
        }
    }
    async findPatternData(url) {
        if (!this.providersData) await this.loadProviderData();
        return this.providersData?.patterns.find((pattern)=>url.match(pattern.source));
    }
    /**
   *
   * Decides whether the url passed in should be embedded by default
   *
   * protected so that subclasses can override this in order to custom handle links embedded by default
   *
   * @param url
   * @returns 'embed' for the card appearance to embed by default
   */ getHardCodedAppearance(url) {
        // Replace directly with isJiraPlan(url) on cleanup
        const isJiraPlanEvaluated = $d4521f0694a3bb0e$var$isJiraPlan(url);
        const isJiraFormEvaluated = $d4521f0694a3bb0e$var$isJiraForm(url);
        const isJiraSummaryEvaluated = $d4521f0694a3bb0e$var$isJiraSummary(url);
        let isConfluenceTeamCalendarsEvaluated;
        if ((0, $ixfCV.fg)('tc_smart_link_embed_view')) isConfluenceTeamCalendarsEvaluated = $d4521f0694a3bb0e$var$isConfluenceTeamCalendars(url);
        if ($d4521f0694a3bb0e$var$isJiraRoadmapOrTimeline(url) || $d4521f0694a3bb0e$var$isPolarisView(url) || $d4521f0694a3bb0e$var$isJwmView(url) || $d4521f0694a3bb0e$var$isJiraList(url) || $d4521f0694a3bb0e$var$isGiphyMedia(url) || $d4521f0694a3bb0e$var$isProformaView(url) || $d4521f0694a3bb0e$var$isConfluenceWhiteboard(url) || $d4521f0694a3bb0e$var$isConfluenceDatabase(url) || (0, $8kONW.isConfluenceSlideUrl)(url) || $d4521f0694a3bb0e$var$isYoutubeVideo(url) || $d4521f0694a3bb0e$var$isLoomVideoUrl(url) || $d4521f0694a3bb0e$var$isLoomScreenshotUrl(url) && (0, $ixfCV.fg)('loom-support-screenshot-sl-resolution') || $d4521f0694a3bb0e$var$isJiraDashboard(url) || $d4521f0694a3bb0e$var$isJiraBacklog(url) || $d4521f0694a3bb0e$var$isJiraBoard(url) || $d4521f0694a3bb0e$var$isRovoAgentProfilePage(url) || $d4521f0694a3bb0e$var$isJiraVersion(url) || isJiraPlanEvaluated || isJiraFormEvaluated || isJiraSummaryEvaluated || $d4521f0694a3bb0e$var$isCustomer360LandingPage(url) || isConfluenceTeamCalendarsEvaluated || $d4521f0694a3bb0e$var$isJiraIssueNavigator(url) || $d4521f0694a3bb0e$var$isAvpVisualizationView(url) && (0, $ixfCV.fg)('avp_unfurl_shared_charts_embed_by_default_2')) return 'embed';
    }
    async fetchData(url) {
        // it uses fetchNodesData internally and caches the result
        return await this.getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS({
            // It's ok to cast any resourceUrl to inlineCard here, because only URL is important for the request.
            type: 'inlineCard',
            attrs: {
                url: url
            }
        });
    }
    /**
   * Make a /resolve call and find out if result has embed capability
   */ async canBeResolvedAsEmbed(url) {
        try {
            const details = await this.fetchData(url);
            if (!details) return false;
            // Imagine response is "unauthorized". We won't be able to tell if even after auth
            // page going to have preview. Yes, we can show auth view for embed. But what if even after
            // success auth flow there won't be preview? We will already have ugly embed ADF.
            // Being on a safe side - if we get anything but resolved - we decide it can't be an embed.
            if ((0, $ggGdk.getStatus)(details) !== 'resolved') return false;
            const embed = (0, $jawC3.extractSmartLinkEmbed)(details);
            return !!embed;
        } catch  {
            return false;
        }
    }
    /**
   * Opt-in hook: when a caller explicitly requests an `'embed'` appearance and the
   * user has no saved preference for the URL, honour that request as the default
   * (above any provider default), validating embeddability first and falling back
   * to a card (`'block'`) when the link cannot be embedded.
   *
   * Defaults to `false` so behaviour is unchanged for every existing consumer.
   * Subclasses (e.g. Confluence) can override this to opt in, typically behind an
   * experiment.
   */ shouldHonorRequestedEmbedAsDefault() {
        return false;
    }
    async getAuthStatusFromResolveResponse(url) {
        try {
            const { meta: { access: access, visibility: visibility } } = await this.fetchData(url);
            return {
                access: access,
                visibility: visibility
            };
        } catch  {
            return undefined;
        }
    }
    /**
   * Make a /resolve call and find out if result has datasource capability
   */ async getDatasourceFromResolveResponse(url) {
        try {
            const response = await this.fetchData(url);
            const datasources = response && response.datasources || [];
            if (datasources.length > 0) // For now we only have one datasource expected even though it is in an array.
            // When we have resources returning more than one we will have revisit this part.
            return datasources[0];
        } catch  {
            return undefined;
        }
    }
    /**
   * This is used to determine if the url is a local Jira url or a remote one.
   */ isLocalUrl(url) {
        return new URL(url).origin === this.baseUrl;
    }
    async resolve(url, appearance, shouldForceAppearance, isEmbedFriendlyLocation) {
        try {
            if (shouldForceAppearance === true) // At this point we don't need to check pattern nor call `check` because manual change means
            // this url is already supported and can be resolved. We want to ignore all other options and
            // respect user's choice.
            return this.transformer.toSmartlinkAdf(url, appearance);
            const hardCodedAppearance = this.getHardCodedAppearance(url);
            const [matchedProviderPattern, userPreference] = await Promise.all([
                this.findPatternData(url),
                this.findUserPreference(url)
            ]);
            if ((0, $ixfCV.fg)('issue-link-suggestions-in-comments')) {
                if ($d4521f0694a3bb0e$export$6a9668b99d8a1708(url) && this.isLocalUrl(url)) {
                    const data = await this.fetchDataForResource(url);
                    if (data) {
                        const issueAri = this.extractAriFromData(data);
                        if (issueAri) this.onResolve?.(url, issueAri);
                    }
                }
            }
            if (shouldForceAppearance === false && userPreference === 'url') return Promise.reject(undefined);
            const isSupported = !!matchedProviderPattern || await this.checkLinkResolved(url);
            if (isSupported) {
                const providerDefaultAppearance = matchedProviderPattern?.defaultView;
                const isEmbedFriendlyLocationEvaluated = isEmbedFriendlyLocation || isEmbedFriendlyLocation === undefined;
                let preferredAppearance = shouldForceAppearance === undefined ? // Ignore both User and provider's appearances if older editor that doesn't send shouldForceAppearance
                hardCodedAppearance || appearance : // User preferred appearance. It would be either one that has matching domain/path pattern OR
                // if user's default choice is NOT "inline" (so, block or embed at this point, url was dealt with above)
                userPreference || // If user's default choice is "inline" or user hasn't specified preferences at all,
                // we check whatever one of the hardcoded providers match url (jira /timeline, polaris, etc)
                isEmbedFriendlyLocationEvaluated && hardCodedAppearance || // If non match, we see if this provider has default appearance for this particular regexp
                providerDefaultAppearance || // If not, we pick what editor (or any other client) requested
                appearance;
                if (preferredAppearance === userPreference && userPreference === 'embed') {
                    const canItBeEmbed = await this.canBeResolvedAsEmbed(url);
                    if (!canItBeEmbed) preferredAppearance = 'inline';
                }
                // When a caller explicitly requested an embed (e.g. Confluence's quick-insert
                // embed flow tags the inserted link) and the user has no saved preference for
                // this URL, honour embed-by-default above the provider default — but only in an
                // embed-friendly location (matching how hard-coded embeds are gated above) and
                // only when the link can actually be embedded, otherwise fall back to a card.
                // Gated behind a default-off opt-in hook so other consumers are unaffected.
                if (!userPreference && appearance === 'embed' && isEmbedFriendlyLocationEvaluated && this.shouldHonorRequestedEmbedAsDefault()) {
                    const canItBeEmbed = await this.canBeResolvedAsEmbed(url);
                    preferredAppearance = canItBeEmbed ? 'embed' : 'block';
                }
                const datasource = await this.getDatasourceFromResolveResponse(url);
                if (datasource) {
                    const { id: id, parameters: parameters } = datasource;
                    return this.transformer.toDatasourceAdf({
                        id: id,
                        parameters: parameters,
                        // in the future when we support multiple views, we will need to pass this in as a parameter
                        // transform toDatasourceAdf to accept multiple views (like how how appearance for other other transforms are handled)
                        views: [
                            {
                                type: 'table'
                            }
                        ]
                    }, url);
                }
                if (isEmbedFriendlyLocationEvaluated && !userPreference) {
                    const authStatus = await this.getAuthStatusFromResolveResponse(url);
                    if (authStatus) {
                        const { access: access } = authStatus;
                        if (access === 'unauthorized') return this.transformer.toSmartlinkAdf(url, 'block');
                    }
                }
                return this.transformer.toSmartlinkAdf(url, preferredAppearance);
            }
        } catch (e) {
            // eslint-disable-next-line
            console.warn(`Error when trying to check Smart Card url "${url}"${e instanceof Error ? ` - ${e.name} ${e.message}` : ''}`, e);
        }
        return Promise.reject(undefined);
    }
    constructor(envKey, baseUrlOverride, product, onResolve, customCardClient, supportedUrlFilter){
        super();
        this.name = void 0;
        this.baseUrl = void 0;
        this.resolverUrl = void 0;
        this.providersData = void 0;
        this.requestHeaders = void 0;
        this.transformer = void 0;
        this.providersLoader = void 0;
        this.cardClient = void 0;
        this.smartCardLocalCacheClient = (0, $iyuxZ.SmartCardLocalCacheClient).getInstance();
        this.onResolve = void 0;
        this.supportedUrlFilter = void 0;
        this.name = 'editorCardProvider';
        this.baseUrl = baseUrlOverride || (0, $4B79C.getBaseUrl)(envKey);
        this.resolverUrl = (0, $4B79C.getResolverUrl)(envKey, baseUrlOverride);
        this.transformer = new (0, $koAyx.Transformer)();
        this.onResolve = onResolve;
        this.supportedUrlFilter = supportedUrlFilter;
        this.requestHeaders = {
            Origin: this.baseUrl
        };
        this.providersLoader = new (0, (/*@__PURE__*/$parcel$interopDefault($6Q8Dd)))((keys)=>this.batchProviders(keys), {
            batchScheduleFn: (callback)=>setTimeout(callback, $d4521f0694a3bb0e$var$BATCH_WAIT_TIME)
        });
        this.cardClient = customCardClient ?? new (0, $4yccB.default)(envKey, baseUrlOverride);
        if (!customCardClient && product) this.cardClient.setProduct(product);
    }
}
const $d4521f0694a3bb0e$export$b7c3c9a99f7959f5 = new $d4521f0694a3bb0e$export$e4635c0135e1a519();
module.exports["isInternalUrl"] = $d4521f0694a3bb0e$export$4006295459a20a0;
module.exports["isExternalUrl"] = $d4521f0694a3bb0e$export$78234eee43b97e81;
module.exports["EditorCardProvider"] = $d4521f0694a3bb0e$export$e4635c0135e1a519;
module.exports["editorCardProvider"] = $d4521f0694a3bb0e$export$b7c3c9a99f7959f5;

});

parcelRegister("jawC3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1XrQ3 = parcelRequire("1XrQ3");


var $9Q3yl = parcelRequire("9Q3yl");


var $bltJZ = parcelRequire("bltJZ");


var $ixfCV = parcelRequire("ixfCV");


var $2B4lz = parcelRequire("2B4lz");


var $hhrxw = parcelRequire("hhrxw");

function $6adaebd1c889f1f2$export$ab527c45f467d3f7(options) {
    const { defaultExtractorFunction: defaultExtractorFunction, extractorPrioritiesByType: extractorPrioritiesByType, extractorFunctionsByType: extractorFunctionsByType, json: json } = options;
    if (json) {
        const type = json['@type'];
        if (type && Array.isArray(type)) {
            let highestPriority = 0;
            let highestPriorityExtractorFunction = defaultExtractorFunction;
            for (let t of type)if (extractorPrioritiesByType[t] > highestPriority) {
                highestPriority = extractorPrioritiesByType[t];
                highestPriorityExtractorFunction = extractorFunctionsByType[t];
            }
            return highestPriorityExtractorFunction(json);
        }
        if (type && extractorFunctionsByType[type]) return extractorFunctionsByType[type](json);
    }
    return defaultExtractorFunction(json);
}
const $6adaebd1c889f1f2$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $6adaebd1c889f1f2$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
    return undefined;
};
const $6adaebd1c889f1f2$export$67f3d92c824fd850 = (icon)=>{
    if (typeof icon === 'string') return icon;
    else if (icon['@type'] === 'Link') return $6adaebd1c889f1f2$export$396ba4ef2e37dc65(icon);
    else {
        if (icon.url) return $6adaebd1c889f1f2$export$396ba4ef2e37dc65(icon.url);
    }
    return undefined;
};
const $6adaebd1c889f1f2$export$2e9ae379995d99e3 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (type) {
        if (Array.isArray(jsonLd['@type'])) return type;
        else return [
            type
        ];
    }
    return undefined;
};
const $6adaebd1c889f1f2$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
    return undefined;
};
const $6adaebd1c889f1f2$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd?.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return $6adaebd1c889f1f2$export$396ba4ef2e37dc65(url);
    }
    return undefined;
};
const $6adaebd1c889f1f2$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof jsonLd?.summary === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
    return undefined;
};
const $6adaebd1c889f1f2$export$b05803156e5015b6 = (jsonLd, removeTextHighlightingFromTitle)=>{
    if (!jsonLd) return undefined;
    const name = jsonLd.name?.replace(/[\r\n]+/g, '');
    const id = jsonLd['@id'] || '';
    // Check if this is a reference to something _inside_ a Repository.
    // We format these titles to represent more metadata.
    const context = $6adaebd1c889f1f2$export$efdbd45f3e77a161(jsonLd);
    const type = $6adaebd1c889f1f2$export$2e9ae379995d99e3(jsonLd);
    const hasContextType = context && context.type;
    const hasContextRepo = hasContextType && context.type.includes('atlassian:SourceCodeRepository');
    if (hasContextRepo && type) {
        const contextName = context.name && `${context.name}: ` || '';
        // COMMIT: `repo-name: abf137c title of commit message`
        if (type.includes('atlassian:SourceCodeCommit')) {
            const [, hashContent] = id.split(':');
            const hash = hashContent && `${hashContent.substring(0, 8)} `;
            return contextName + (hash || '') + name;
        }
        // PR: `repo-name: #42 title of pull request`
        if (type.includes('atlassian:SourceCodePullRequest')) {
            const pullRequest = jsonLd;
            const internalId = pullRequest['atlassian:internalId'];
            const internalIdRef = internalId && `#${internalId} `;
            return contextName + (internalIdRef || '') + name;
        }
        // BRANCH: `repo-name/branch-name`
        if (type.includes('atlassian:SourceCodeReference')) return contextName + name;
        // FILE: `repo-name: filepath`
        if (type.includes('schema:DigitalDocument')) return contextName + name;
    }
    if (removeTextHighlightingFromTitle) {
        const textFragmentRegex = new RegExp(' \\| :~:text=.*', 'g');
        const truncated = name?.replace(textFragmentRegex, '');
        return truncated;
    }
    return name;
};
const $6adaebd1c889f1f2$export$3185b99040f72cfd = (details)=>details?.data && 'name' in details.data && details.data.name || undefined;
const $6adaebd1c889f1f2$export$efdbd45f3e77a161 = (jsonLd)=>{
    const context = jsonLd.context;
    if (context) {
        if (typeof context === 'string') return {
            name: context
        };
        else if (context['@type'] === 'Link') {
            if (context.name) return {
                name: context.name
            };
        } else {
            if (context.name) return {
                name: context.name,
                icon: context.icon && $6adaebd1c889f1f2$export$67f3d92c824fd850(context.icon),
                type: $6adaebd1c889f1f2$export$2e9ae379995d99e3(context)
            };
        }
    }
    return undefined;
};
const $6adaebd1c889f1f2$export$a832871718466647 = (jsonLd)=>{
    const generator = jsonLd.generator;
    if (generator) {
        if (typeof generator === 'string') throw Error('Link.generator requires a name and icon.');
        else if (generator['@type'] === 'Link') {
            if (generator.name) return (0, $ixfCV.fg)('platform_sl_google_rebrand') ? (0, $2B4lz.rebrandProvider)({
                text: generator.name
            }) : {
                text: generator.name
            };
        } else if (generator.name) {
            const id = generator['@id'];
            return (0, $ixfCV.fg)('platform_sl_google_rebrand') ? (0, $2B4lz.rebrandProvider)({
                text: generator.name,
                icon: $6adaebd1c889f1f2$export$6fb636a2ac885215(generator.icon, id),
                ...(0, $ixfCV.fg)('platform_lp_use_entity_icon_url_for_icon') ? {
                    iconLabel: generator.name
                } : undefined,
                id: id,
                image: $6adaebd1c889f1f2$var$extractProviderImage(generator.image)
            }) : {
                text: generator.name,
                icon: $6adaebd1c889f1f2$export$6fb636a2ac885215(generator.icon, id),
                ...(0, $ixfCV.fg)('platform_lp_use_entity_icon_url_for_icon') ? {
                    iconLabel: generator.name
                } : undefined,
                id: id,
                image: $6adaebd1c889f1f2$var$extractProviderImage(generator.image)
            };
        }
    }
    return undefined;
};
const $6adaebd1c889f1f2$export$6fb636a2ac885215 = (icon, id)=>{
    if (id) {
        if (id === (0, $hhrxw.CONFLUENCE_GENERATOR_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Q3yl.ConfluenceIcon), {
            appearance: "brand",
            size: "xxsmall",
            ...(0, $ixfCV.fg)('navx-1895-new-logo-design') ? {
                shouldUseNewLogoDesign: true
            } : undefined
        });
        else if (id === (0, $hhrxw.JIRA_GENERATOR_ID)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.JiraIcon), {
            appearance: "brand",
            size: "xxsmall",
            ...(0, $ixfCV.fg)('navx-1895-new-logo-design') ? {
                shouldUseNewLogoDesign: true
            } : undefined
        });
    }
    if (icon) return $6adaebd1c889f1f2$export$67f3d92c824fd850(icon);
    return undefined;
};
const $6adaebd1c889f1f2$var$extractProviderImage = (image)=>{
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return $6adaebd1c889f1f2$export$396ba4ef2e37dc65(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return $6adaebd1c889f1f2$export$396ba4ef2e37dc65(image.url);
        }
    }
    return undefined;
};
const $6adaebd1c889f1f2$export$38df542ff03a4183 = (id)=>{
    return id === (0, $hhrxw.CONFLUENCE_GENERATOR_ID);
};
const $6adaebd1c889f1f2$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
    return undefined;
};
const $6adaebd1c889f1f2$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
    return undefined;
};
const $6adaebd1c889f1f2$export$601b23e9cf369aed = (jsonLd)=>{
    if (jsonLd['atlassian:dateViewed']) return jsonLd['atlassian:dateViewed'];
    return undefined;
};
const $6adaebd1c889f1f2$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && $6adaebd1c889f1f2$export$67f3d92c824fd850(person.icon)
        };
    }
    return undefined;
};
const $6adaebd1c889f1f2$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>$6adaebd1c889f1f2$export$c471ae5fddcf1392(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = $6adaebd1c889f1f2$export$c471ae5fddcf1392(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
    return undefined;
};
const $6adaebd1c889f1f2$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd['atlassian:assignedTo'];
    if (assignedTo) return $6adaebd1c889f1f2$export$c471ae5fddcf1392(assignedTo);
    return undefined;
};
const $6adaebd1c889f1f2$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map($6adaebd1c889f1f2$export$c471ae5fddcf1392).filter((item)=>!!item);
        else {
            const item = $6adaebd1c889f1f2$export$c471ae5fddcf1392(attributedTo);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
const $6adaebd1c889f1f2$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map($6adaebd1c889f1f2$export$c471ae5fddcf1392).filter((item)=>!!item);
        else {
            const item = $6adaebd1c889f1f2$export$c471ae5fddcf1392(ownedBy);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
const $6adaebd1c889f1f2$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return $6adaebd1c889f1f2$export$c471ae5fddcf1392(updatedBy);
    return undefined;
};
const $6adaebd1c889f1f2$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return $6adaebd1c889f1f2$export$396ba4ef2e37dc65(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return $6adaebd1c889f1f2$export$396ba4ef2e37dc65(image.url);
        }
    }
    return undefined;
};
const $6adaebd1c889f1f2$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};
const $6adaebd1c889f1f2$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = $6adaebd1c889f1f2$export$3e8ad908070b68b2(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: $6adaebd1c889f1f2$export$396ba4ef2e37dc65(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: $6adaebd1c889f1f2$export$396ba4ef2e37dc65(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
    return undefined;
};
const $6adaebd1c889f1f2$export$8beff7405d020ddf = (response)=>response?.entityData;
const $6adaebd1c889f1f2$export$c7168210b81d9383 = (response)=>Boolean($6adaebd1c889f1f2$export$8beff7405d020ddf(response));
const $6adaebd1c889f1f2$var$extractEntityEmbedUrl = (response)=>{
    const entity = $6adaebd1c889f1f2$export$8beff7405d020ddf(response);
    return entity && 'liveEmbedUrl' in entity && typeof entity?.liveEmbedUrl === 'string' ? entity?.liveEmbedUrl : undefined;
};
const $6adaebd1c889f1f2$export$ad879f2c9d5100a0 = (response)=>{
    if (!response?.meta?.generator) return undefined;
    if ((0, $ixfCV.fg)('platform_lp_use_entity_icon_url_for_icon')) {
        const entityIcon = $6adaebd1c889f1f2$export$19346520e937a99f(response);
        if (entityIcon) return (0, $ixfCV.fg)('platform_sl_google_rebrand') ? (0, $2B4lz.rebrandProvider)({
            text: response.meta.generator.name,
            icon: entityIcon.url,
            id: response.meta.generator.id,
            image: entityIcon.url,
            iconLabel: entityIcon.label
        }) : {
            text: response.meta.generator.name,
            icon: entityIcon.url,
            id: response.meta.generator.id,
            image: entityIcon.url,
            iconLabel: entityIcon.label
        };
    }
    const { icon: icon, id: id, image: image, name: name } = response.meta.generator;
    if (!name || !icon) throw Error('Link.generator requires a name and icon.');
    let providerIcon;
    switch(id){
        case 0, $hhrxw.CONFLUENCE_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Q3yl.ConfluenceIcon), {
                appearance: "brand",
                ...(0, $ixfCV.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined,
                size: "xxsmall"
            });
            break;
        case 0, $hhrxw.JIRA_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.JiraIcon), {
                appearance: "brand",
                ...(0, $ixfCV.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined,
                size: "xxsmall"
            });
            break;
        default:
            providerIcon = icon.url;
    }
    return (0, $ixfCV.fg)('platform_sl_google_rebrand') ? (0, $2B4lz.rebrandProvider)({
        text: name,
        icon: providerIcon,
        id: id,
        image: image ? image : icon.url,
        ...(0, $ixfCV.fg)('platform_lp_use_entity_icon_url_for_icon') ? {
            iconLabel: name
        } : undefined
    }) : {
        text: name,
        icon: providerIcon,
        id: id,
        image: image ? image : icon.url,
        ...(0, $ixfCV.fg)('platform_lp_use_entity_icon_url_for_icon') ? {
            iconLabel: name
        } : undefined
    };
};
const $6adaebd1c889f1f2$export$19346520e937a99f = (response)=>{
    if ((0, $ixfCV.fg)('platform_lp_use_entity_icon_url_for_icon')) {
        const entity = $6adaebd1c889f1f2$export$8beff7405d020ddf(response);
        if (!entity) return undefined;
        if (!(0, $1XrQ3.isBaseEntity)(entity)) return undefined;
        if ((0, $1XrQ3.isDesignEntity)(entity) && entity.iconUrl) return {
            url: entity.iconUrl,
            label: entity.type
        };
        if ((0, $1XrQ3.isDocumentEntity)(entity) && entity.type.iconUrl) return {
            url: entity.type.iconUrl,
            label: entity.type.category
        };
        // When JSON-LD is deprecated, we can change this to returning entity provider icon.
        // For now code upstream will return better result when this method returns undefined.
        return undefined;
    } else {
        const entity = $6adaebd1c889f1f2$export$8beff7405d020ddf(response);
        let url;
        if (entity) url = 'iconUrl' in entity && typeof entity?.iconUrl === 'string' ? entity.iconUrl : response?.meta.generator?.icon?.url;
        return {
            url: url,
            label: entity?.displayName
        };
    }
};
const $6adaebd1c889f1f2$export$3eda18658b66108 = (response, removeTextHighlightingFromTitle)=>{
    if ($6adaebd1c889f1f2$export$c7168210b81d9383(response)) return $6adaebd1c889f1f2$export$8beff7405d020ddf(response)?.displayName;
    return $6adaebd1c889f1f2$export$b05803156e5015b6(response?.data, removeTextHighlightingFromTitle);
};
const $6adaebd1c889f1f2$export$7ba9b12c6a1b73de = (response)=>{
    if ($6adaebd1c889f1f2$export$c7168210b81d9383(response)) return $6adaebd1c889f1f2$export$8beff7405d020ddf(response)?.url;
    return $6adaebd1c889f1f2$export$63f54cf4c5883620(response?.data);
};
const $6adaebd1c889f1f2$export$16b02be3e2bb31ad = (response)=>{
    if ($6adaebd1c889f1f2$export$c7168210b81d9383(response)) return $6adaebd1c889f1f2$export$8beff7405d020ddf(response)?.ari || $6adaebd1c889f1f2$export$8beff7405d020ddf(response)?.thirdPartyAri;
    const data = response?.data;
    return $6adaebd1c889f1f2$export$be18a6294fd426ec(data);
};
const $6adaebd1c889f1f2$export$864b719baf5d744d = (response, iframeUrlType)=>{
    if ($6adaebd1c889f1f2$export$c7168210b81d9383(response)) {
        // TODO: Missing iframeUrlType
        const embedUrl = $6adaebd1c889f1f2$var$extractEntityEmbedUrl(response);
        return embedUrl ? {
            src: embedUrl
        } : undefined;
    }
    return $6adaebd1c889f1f2$export$4b0d98b1b7f6d115(response?.data, 'web', iframeUrlType);
};
const $6adaebd1c889f1f2$export$ff753ed519e96e9e = (response)=>{
    if ($6adaebd1c889f1f2$export$c7168210b81d9383(response)) return $6adaebd1c889f1f2$export$ad879f2c9d5100a0(response);
    return response?.data && $6adaebd1c889f1f2$export$a832871718466647(response?.data);
};
const $6adaebd1c889f1f2$export$7a685df468cbf38f = (response)=>{
    if ($6adaebd1c889f1f2$export$c7168210b81d9383(response)) return $6adaebd1c889f1f2$export$8beff7405d020ddf(response)?.createdAt;
    return response?.data && $6adaebd1c889f1f2$export$e1226a5e0bbbf862(response.data);
};
const $6adaebd1c889f1f2$export$75047940e157fd1f = (response)=>{
    if ($6adaebd1c889f1f2$export$c7168210b81d9383(response)) return $6adaebd1c889f1f2$export$8beff7405d020ddf(response)?.lastUpdatedAt;
    return response?.data && $6adaebd1c889f1f2$export$7fc2f5e6f9d22ae7(response.data);
};
const $6adaebd1c889f1f2$export$242875b46118beb2 = (response)=>{
    if (!response || !response.data) return undefined;
    if ($6adaebd1c889f1f2$export$c7168210b81d9383(response)) return $6adaebd1c889f1f2$export$8beff7405d020ddf(response)?.createdBy?.displayName;
    const persons = $6adaebd1c889f1f2$export$a66235cba0c9d11a(response.data);
    return !!persons?.length ? persons[0].name : undefined;
};
const $6adaebd1c889f1f2$export$41fc716e1bc2dc90 = (response)=>{
    if (!response || !response.data) return undefined;
    if ($6adaebd1c889f1f2$export$c7168210b81d9383(response)) {
        const entity = $6adaebd1c889f1f2$export$8beff7405d020ddf(response);
        const owners = entity?.owners;
        if (owners) return owners.map((owner)=>({
                name: owner.displayName,
                src: owner.picture
            })).filter((item)=>!!item);
    }
    return $6adaebd1c889f1f2$export$a66235cba0c9d11a(response.data);
};
const $6adaebd1c889f1f2$export$7f099a839071a190 = (response)=>{
    if (!response || !response.data) return undefined;
    if ($6adaebd1c889f1f2$export$c7168210b81d9383(response)) return $6adaebd1c889f1f2$export$8beff7405d020ddf(response)?.lastUpdatedBy?.displayName;
    const person = $6adaebd1c889f1f2$export$8a2d1ed7e6f336f0(response.data);
    return person ? person.name : undefined;
};
const $6adaebd1c889f1f2$export$96ed4c1b14ac210a = (response)=>{
    if ($6adaebd1c889f1f2$export$c7168210b81d9383(response)) {
        const entity = $6adaebd1c889f1f2$export$8beff7405d020ddf(response);
        return entity && 'exportLinks' in entity && Array.isArray(entity.exportLinks) && entity.exportLinks.length > 0 ? entity?.exportLinks?.[0].url : undefined;
    }
    return response?.data?.['atlassian:downloadUrl'];
};
module.exports["genericExtractPropsFromJSONLD"] = $6adaebd1c889f1f2$export$ab527c45f467d3f7;
module.exports["extractUrlFromLinkJsonLd"] = $6adaebd1c889f1f2$export$396ba4ef2e37dc65;
module.exports["extractUrlFromIconJsonLd"] = $6adaebd1c889f1f2$export$67f3d92c824fd850;
module.exports["extractType"] = $6adaebd1c889f1f2$export$2e9ae379995d99e3;
module.exports["extractAri"] = $6adaebd1c889f1f2$export$be18a6294fd426ec;
module.exports["extractLink"] = $6adaebd1c889f1f2$export$63f54cf4c5883620;
module.exports["extractSummary"] = $6adaebd1c889f1f2$export$db5a8500f6b6286e;
module.exports["extractTitle"] = $6adaebd1c889f1f2$export$b05803156e5015b6;
module.exports["extractContext"] = $6adaebd1c889f1f2$export$efdbd45f3e77a161;
module.exports["extractNameFromJsonLd"] = $6adaebd1c889f1f2$export$3185b99040f72cfd;
module.exports["extractProvider"] = $6adaebd1c889f1f2$export$a832871718466647;
module.exports["extractProviderIcon"] = $6adaebd1c889f1f2$export$6fb636a2ac885215;
module.exports["isConfluenceGenerator"] = $6adaebd1c889f1f2$export$38df542ff03a4183;
module.exports["extractDateCreated"] = $6adaebd1c889f1f2$export$e1226a5e0bbbf862;
module.exports["extractDateUpdated"] = $6adaebd1c889f1f2$export$7fc2f5e6f9d22ae7;
module.exports["extractDateViewed"] = $6adaebd1c889f1f2$export$601b23e9cf369aed;
module.exports["extractPersonFromJsonLd"] = $6adaebd1c889f1f2$export$c471ae5fddcf1392;
module.exports["extractMembers"] = $6adaebd1c889f1f2$export$6281d080d62a0719;
module.exports["extractPersonAssignedTo"] = $6adaebd1c889f1f2$export$38a0979ebf273662;
module.exports["extractPersonCreatedBy"] = $6adaebd1c889f1f2$export$a66235cba0c9d11a;
module.exports["extractPersonOwnedBy"] = $6adaebd1c889f1f2$export$19ee667f3f7a6ec3;
module.exports["extractPersonUpdatedBy"] = $6adaebd1c889f1f2$export$8a2d1ed7e6f336f0;
module.exports["extractImage"] = $6adaebd1c889f1f2$export$4c753a1297cb9805;
module.exports["extractPlatformIsSupported"] = $6adaebd1c889f1f2$export$3e8ad908070b68b2;
module.exports["extractPreview"] = $6adaebd1c889f1f2$export$4b0d98b1b7f6d115;
module.exports["extractEntity"] = $6adaebd1c889f1f2$export$8beff7405d020ddf;
module.exports["isEntityPresent"] = $6adaebd1c889f1f2$export$c7168210b81d9383;
module.exports["extractEntityProvider"] = $6adaebd1c889f1f2$export$ad879f2c9d5100a0;
module.exports["extractEntityIcon"] = $6adaebd1c889f1f2$export$19346520e937a99f;
module.exports["extractSmartLinkTitle"] = $6adaebd1c889f1f2$export$3eda18658b66108;
module.exports["extractSmartLinkUrl"] = $6adaebd1c889f1f2$export$7ba9b12c6a1b73de;
module.exports["extractSmartLinkAri"] = $6adaebd1c889f1f2$export$16b02be3e2bb31ad;
module.exports["extractSmartLinkEmbed"] = $6adaebd1c889f1f2$export$864b719baf5d744d;
module.exports["extractSmartLinkProvider"] = $6adaebd1c889f1f2$export$ff753ed519e96e9e;
module.exports["extractSmartLinkCreatedOn"] = $6adaebd1c889f1f2$export$7a685df468cbf38f;
module.exports["extractSmartLinkModifiedOn"] = $6adaebd1c889f1f2$export$75047940e157fd1f;
module.exports["extractSmartLinkCreatedBy"] = $6adaebd1c889f1f2$export$242875b46118beb2;
module.exports["extractSmartLinkAuthorGroup"] = $6adaebd1c889f1f2$export$41fc716e1bc2dc90;
module.exports["extractSmartLinkModifiedBy"] = $6adaebd1c889f1f2$export$7f099a839071a190;
module.exports["extractSmartLinkDownloadUrl"] = $6adaebd1c889f1f2$export$96ed4c1b14ac210a;

});

parcelRegister("1XrQ3", function(module, exports) {
const $54e326c4fdcf6d71$var$DESIGN_TYPES = [
    'FILE',
    'CANVAS',
    'GROUP',
    'NODE',
    'PROTOTYPE',
    'OTHER'
];
const $54e326c4fdcf6d71$var$DESIGN_STATUSES = [
    'READY_FOR_DEVELOPMENT',
    'UNKNOWN',
    'NONE'
];
const $54e326c4fdcf6d71$var$REMOTE_LINK_TYPES = [
    'document',
    'alert',
    'test',
    'security',
    'logFile',
    'prototype',
    'coverage',
    'bugReport',
    'releaseNotes',
    'other'
];
const $54e326c4fdcf6d71$var$APPEARANCES = [
    'default',
    'inprogress',
    'moved',
    'new',
    'removed',
    'success'
];
const $54e326c4fdcf6d71$var$WORK_ITEM_SUB_TYPES = [
    'task',
    'bug',
    'story',
    'epic',
    'feature',
    'question',
    'other',
    'incident',
    'problem',
    'approval',
    'section',
    'milestone',
    'work_item',
    'default_task'
];
const $54e326c4fdcf6d71$var$DOCUMENT_CATEGORIES = [
    'folder',
    'document',
    'presentation',
    'spreadsheet',
    'image',
    'audio',
    'video',
    'pdf',
    'shortcut',
    'code',
    'archive',
    'form',
    'web-page',
    'other'
];
/**
 * Runtime membership check for string literal tuples.
 * Keeps guard logic aligned with tuple-derived union types.
 */ const $54e326c4fdcf6d71$var$isOneOf = (values, value)=>typeof value === 'string' && values.includes(value);
const $54e326c4fdcf6d71$var$isObject = (value)=>typeof value === 'object' && value !== null;
const $54e326c4fdcf6d71$var$asRecord = (value)=>value;
const $54e326c4fdcf6d71$export$12af7c5462954d1e = (value)=>$54e326c4fdcf6d71$var$isObject(value) && typeof value.displayName === 'string' && typeof value.id === 'string' && typeof value.url === 'string';
const $54e326c4fdcf6d71$export$8dc9be81b5b6266b = (value)=>$54e326c4fdcf6d71$export$12af7c5462954d1e(value) && $54e326c4fdcf6d71$var$isOneOf($54e326c4fdcf6d71$var$DESIGN_STATUSES, $54e326c4fdcf6d71$var$asRecord(value).status) && $54e326c4fdcf6d71$var$isOneOf($54e326c4fdcf6d71$var$DESIGN_TYPES, $54e326c4fdcf6d71$var$asRecord(value).type);
const $54e326c4fdcf6d71$export$f16c4076686c1f5b = (value)=>{
    if (!$54e326c4fdcf6d71$export$12af7c5462954d1e(value)) return false;
    const entity = $54e326c4fdcf6d71$var$asRecord(value);
    const remoteLink = entity['atlassian:remote-link'];
    return $54e326c4fdcf6d71$var$isObject(remoteLink) && $54e326c4fdcf6d71$var$isOneOf($54e326c4fdcf6d71$var$REMOTE_LINK_TYPES, remoteLink.type);
};
const $54e326c4fdcf6d71$export$791f1b4852e2a184 = (value)=>$54e326c4fdcf6d71$export$12af7c5462954d1e(value) && $54e326c4fdcf6d71$var$isObject($54e326c4fdcf6d71$var$asRecord(value)['atlassian:project']);
const $54e326c4fdcf6d71$export$162dad7a1238d377 = (value)=>{
    if (!$54e326c4fdcf6d71$export$12af7c5462954d1e(value)) return false;
    const entity = $54e326c4fdcf6d71$var$asRecord(value);
    const workItem = entity['atlassian:work-item'];
    return $54e326c4fdcf6d71$var$isObject(workItem) && typeof workItem.status === 'string' && $54e326c4fdcf6d71$var$isOneOf($54e326c4fdcf6d71$var$WORK_ITEM_SUB_TYPES, workItem.subtype) && typeof workItem.team === 'string';
};
const $54e326c4fdcf6d71$export$32c06ee7e0e9b79e = (value)=>{
    if (!$54e326c4fdcf6d71$export$12af7c5462954d1e(value)) return false;
    const entityType = $54e326c4fdcf6d71$var$asRecord(value).type;
    return $54e326c4fdcf6d71$var$isObject(entityType) && (entityType.category === undefined || $54e326c4fdcf6d71$var$isOneOf($54e326c4fdcf6d71$var$DOCUMENT_CATEGORIES, entityType.category)) && (entityType.iconUrl === undefined || typeof entityType.iconUrl === 'string') && ($54e326c4fdcf6d71$var$isOneOf($54e326c4fdcf6d71$var$DOCUMENT_CATEGORIES, entityType.category) || typeof entityType.iconUrl === 'string');
};
const $54e326c4fdcf6d71$export$33e8c1bbf9148b0e = (value)=>$54e326c4fdcf6d71$export$12af7c5462954d1e(value) && ('attachments' in value || 'commentCount' in value || 'hidden' in value || 'isPinned' in value || 'lastActive' in value || 'reactions' in value);
const $54e326c4fdcf6d71$export$6c20afe8743cb761 = (value)=>$54e326c4fdcf6d71$export$12af7c5462954d1e(value) && ('isArchived' in value || 'lastActive' in value || 'memberCount' in value || 'members' in value || 'membershipType' in value || 'topic' in value || 'workspace' in value);
const $54e326c4fdcf6d71$export$fe785532d894f833 = (value)=>$54e326c4fdcf6d71$export$12af7c5462954d1e(value) && !$54e326c4fdcf6d71$export$8dc9be81b5b6266b(value) && !$54e326c4fdcf6d71$export$f16c4076686c1f5b(value) && !$54e326c4fdcf6d71$export$791f1b4852e2a184(value) && !$54e326c4fdcf6d71$export$162dad7a1238d377(value) && !$54e326c4fdcf6d71$export$32c06ee7e0e9b79e(value) && !$54e326c4fdcf6d71$export$33e8c1bbf9148b0e(value) && !$54e326c4fdcf6d71$export$6c20afe8743cb761(value);
const $54e326c4fdcf6d71$export$47565ffe58e56845 = (value)=>$54e326c4fdcf6d71$export$12af7c5462954d1e(value) && ($54e326c4fdcf6d71$export$8dc9be81b5b6266b(value) || $54e326c4fdcf6d71$export$f16c4076686c1f5b(value) || $54e326c4fdcf6d71$export$791f1b4852e2a184(value) || $54e326c4fdcf6d71$export$162dad7a1238d377(value) || $54e326c4fdcf6d71$export$32c06ee7e0e9b79e(value) || $54e326c4fdcf6d71$export$33e8c1bbf9148b0e(value) || $54e326c4fdcf6d71$export$6c20afe8743cb761(value) || $54e326c4fdcf6d71$export$fe785532d894f833(value));
module.exports["isBaseEntity"] = $54e326c4fdcf6d71$export$12af7c5462954d1e;
module.exports["isDesignEntity"] = $54e326c4fdcf6d71$export$8dc9be81b5b6266b;
module.exports["isDocumentEntity"] = $54e326c4fdcf6d71$export$32c06ee7e0e9b79e;

});

parcelRegister("9Q3yl", function(module, exports) {

var $5lkNm = parcelRequire("5lkNm");


var $6YXrY = parcelRequire("6YXrY");


var $8UJqr = parcelRequire("8UJqr");

const $c22c9af788df97f8$export$68f3db7f6af48bcb = (0, $6YXrY.createFeatureFlaggedComponent)((0, $8UJqr.ConfluenceIcon), (0, $5lkNm.ConfluenceIcon));
module.exports["ConfluenceIcon"] = $c22c9af788df97f8$export$68f3db7f6af48bcb;

});

parcelRegister("2B4lz", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");

const $602fe273a6b2bdab$var$GOOGLE_DRIVE = 'Google Drive';
const $602fe273a6b2bdab$export$df1b15aebbcf717e = (provider)=>{
    switch(provider?.text){
        case 'Google':
            return {
                ...provider,
                ...(0, $ixfCV.fg)('platform_lp_use_entity_icon_url_for_icon') ? {
                    iconLabel: $602fe273a6b2bdab$var$GOOGLE_DRIVE
                } : undefined,
                text: $602fe273a6b2bdab$var$GOOGLE_DRIVE
            };
        default:
            return provider;
    }
};
module.exports["rebrandProvider"] = $602fe273a6b2bdab$export$df1b15aebbcf717e;

});

parcelRegister("hhrxw", function(module, exports) {
const $e03d26a78ec0b544$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $e03d26a78ec0b544$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $e03d26a78ec0b544$export$84a73a0383f58180 = 'JiraTask';
const $e03d26a78ec0b544$export$c6c83963a9378a67 = 'JiraSubTask';
const $e03d26a78ec0b544$export$58af3c426c111a6d = 'JiraStory';
const $e03d26a78ec0b544$export$ac9898a63417219e = 'JiraBug';
const $e03d26a78ec0b544$export$54db5e3fb12e39cd = 'JiraEpic';
const $e03d26a78ec0b544$export$2f54a5a217202c85 = 'JiraIncident';
const $e03d26a78ec0b544$export$d097371052bfc411 = 'JiraServiceRequest';
const $e03d26a78ec0b544$export$efd9452ad16c6676 = 'JiraChange';
const $e03d26a78ec0b544$export$2e7e70abb5d81f67 = 'JiraProblem';
const $e03d26a78ec0b544$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
var $e03d26a78ec0b544$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $e03d26a78ec0b544$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Video"] = "FileType:Video";
    return IconType;
}({});
module.exports["CONFLUENCE_GENERATOR_ID"] = $e03d26a78ec0b544$export$cee224b5de4d6d66;
module.exports["JIRA_GENERATOR_ID"] = $e03d26a78ec0b544$export$f654d825189934a7;
module.exports["JIRA_TASK"] = $e03d26a78ec0b544$export$84a73a0383f58180;
module.exports["JIRA_SUB_TASK"] = $e03d26a78ec0b544$export$c6c83963a9378a67;
module.exports["JIRA_STORY"] = $e03d26a78ec0b544$export$58af3c426c111a6d;
module.exports["JIRA_BUG"] = $e03d26a78ec0b544$export$ac9898a63417219e;
module.exports["JIRA_EPIC"] = $e03d26a78ec0b544$export$54db5e3fb12e39cd;
module.exports["JIRA_INCIDENT"] = $e03d26a78ec0b544$export$2f54a5a217202c85;
module.exports["JIRA_SERVICE_REQUEST"] = $e03d26a78ec0b544$export$d097371052bfc411;
module.exports["JIRA_CHANGE"] = $e03d26a78ec0b544$export$efd9452ad16c6676;
module.exports["JIRA_PROBLEM"] = $e03d26a78ec0b544$export$2e7e70abb5d81f67;
module.exports["JIRA_CUSTOM_TASK_TYPE"] = $e03d26a78ec0b544$export$ce25cfc40b280dbc;
module.exports["SmartLinkSize"] = $e03d26a78ec0b544$export$51f13ced115cbdae;
module.exports["IconType"] = $e03d26a78ec0b544$export$13ff1290a9e22e77;

});

parcelRegister("drRzc", function(module, exports) {

var $4iudd = parcelRequire("4iudd");


var $fqVYq = parcelRequire("fqVYq");

class $27efd3461a9c6d27$export$1185db7a00c13eed {
    /**
   * Sets the SSR data for the provider.
   * This pre-populates the cache with data rendered on the server, preventing redundant network requests on the client.
   * Calling this method will invalidate the existing cache.
   *
   * @example
   * ```
   * const ssrData = window.__SSR_NODE_DATA__ || {};
   * nodeDataProvider.setSSRData(ssrData);
   * ```
   *
   * @param ssrData A map of node data keys to their corresponding data.
   */ setSSRData(ssrData = {}) {
        if ((0, $fqVYq.editorExperiment)('platform_synced_block', true)) {
            this.updateCache(ssrData, {
                strategy: 'replace',
                source: 'ssr'
            });
            return;
        }
        this.cacheVersion++;
        this.cache = Object.fromEntries(Object.entries(ssrData).map(([key, data])=>[
                key,
                {
                    data: data,
                    source: 'ssr'
                }
            ]));
    }
    /**
   * Clears all cached data.
   * This increments the internal cache version, invalidating any pending network requests.
   *
   * @example
   * ```
   * function useMyNodeDataProvider(contentId: string) {
   *  const nodeDataProvider = new MyNodeDataProvider();
   *
   *  // Reset the cache when the contentId changes (e.g., when the user navigates to a different page).
   *  useEffect(() => {
   *    nodeDataProvider.resetCache();
   *  }, [contentId]);
   *
   *  return nodeDataProvider;
   * }
   * ```
   */ resetCache() {
        this.cacheVersion++;
        this.cache = {};
    }
    /**
   * Fetches data for a given node using a cache-first-then-network strategy.
   *
   * The provided callback may be called multiple times:
   * 1. Immediately with data from the SSR cache, if available.
   * 2. Asynchronously with data fetched from the network.
   *
   * @example
   * ```
   * const nodeDataProvider = new MyNodeDataProvider();
   *
   * nodeDataProvider.getData(node, (data) => {
   * 	console.log('Node data:', data);
   * });
   * ```
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @param callback The callback function to call with the fetched data or an error.
   */ getData(node, callback) {
        // Move implementation to a separate async method
        // to keep this method synchronous and avoid async/await in the public API.
        this.getDataAsync(node, callback);
    }
    async getDataAsync(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        const dataFromCache = this.cache[dataKey];
        if (dataFromCache !== undefined) // If we have the data in the SSR data, we can use it directly
        callback({
            data: dataFromCache.data
        });
        if ((0, $4iudd.isSSR)()) // During SSR, we only use the cache and never fetch from the network.
        // Use loading state instead.
        return;
        // If no data is available in the cache, or the data is from the network,
        // we need to fetch it from the network.
        if (dataFromCache?.source !== 'network') {
            // Store the current cache version before making the request,
            // so we can check if the cache has changed while we are waiting for the network response.
            const cacheVersionBeforeRequest = this.cacheVersion;
            // Create a unique key for the in-flight network request
            // based on the cache version and the data key.
            const networkRequestInFlightKey = `${cacheVersionBeforeRequest}-${dataKey}`;
            // Check if there is already a network request in flight for this data
            // to avoid duplicate requests.
            const networkRequestInFlight = this.networkRequestsInFlight[networkRequestInFlightKey];
            if (networkRequestInFlight) {
                try {
                    const data = await networkRequestInFlight;
                    callback({
                        data: data
                    });
                } catch (error) {
                    callback({
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                }
                return;
            }
            try {
                const dataPromise = this.fetchNodesData([
                    jsonNode
                ]).then(([value])=>value);
                // Store the promise in the in-flight requests map
                this.networkRequestsInFlight[networkRequestInFlightKey] = dataPromise;
                const data = await dataPromise;
                // We need to call the callback with the data with result even if the cache version has changed,
                // so all promises that are waiting for the data can resolve.
                callback({
                    data: data
                });
                // If the cache version has changed, we don't want to use the data from the network
                // because it could be stale data.
                if (cacheVersionBeforeRequest === this.cacheVersion) {
                    // Replace promise with the resolved data in the cache
                    if ((0, $fqVYq.editorExperiment)('platform_synced_block', true)) this.updateCache({
                        [dataKey]: data
                    }, {
                        strategy: 'merge',
                        source: 'network'
                    });
                    else this.cache[dataKey] = {
                        data: data,
                        source: 'network'
                    };
                }
            } catch (error) {
                // If an error occurs, we call the callback with the error
                callback({
                    error: error instanceof Error ? error : new Error(String(error))
                });
            } finally{
                // Ensure we clean up the in-flight request entry
                delete this.networkRequestsInFlight[networkRequestInFlightKey];
            }
        }
    }
    /**
   * Fetches data for a given node and returns it as a Promise.
   * This is a convenience wrapper around the `data` method for use with async/await.
   *
   * Note: This promise resolves with the *first* available data, which could be from the SSR cache or the network.
   * It may not provide the most up-to-date data if a network fetch is in progress.
   *
   * Note: This method is only for migration purposes. Use {@link getData} in new code instead.
   *
   * @private
   * @deprecated Don't use this method, use {@link getData} method instead.
   *             This method is only for migration purposes.
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @returns A promise that resolves with the node's data.
   */ getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS(node) {
        return new Promise((resolve, reject)=>{
            try {
                this.getData(node, (payload)=>{
                    if (payload.error) reject(payload.error);
                    else resolve(payload.data);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Checks the cache for the given node and returns its status.
   *
   * Possible return values:
   * - `false`: No cached data found for the node.
   * - `'ssr'`: Data is cached from server-side rendering (SSR).
   * - `'network'`: Data is cached from a network request.
   *
   * @param node The node (or its ProseMirror representation) to check in the cache.
   * @returns The cache status: `false`, `'ssr'`, or `'network'`.
   */ getCacheStatusForNode(node) {
        const dataFromCache = this.getNodeDataFromCache(node);
        return dataFromCache ? dataFromCache.source : false;
    }
    /**
   * Retrieves the cached data for a given node, if available.
   *
   * @param node The node (or its ProseMirror representation) for which to retrieve cached data.
   * @returns The cached data object containing `data` and `source`, or `undefined` if no cache entry exists.
   */ getNodeDataFromCache(node) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return undefined;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        return this.cache[dataKey];
    }
    /**
   * Returns the keys of the cache.
   *
   * @returns An array of the keys of the cache.
   */ getNodeDataCacheKeys() {
        return Object.keys(this.cache);
    }
    /**
   * Updates the cache with new records using merge or replace strategies.
   * This method should be the only way to modify the cache directly.
   * This allow subclasses to use it when needed. e.g. abstract fetchNodesData implementation.
   *
   * @example
   * ```
   * const newRecords = {
   *   'node-id-1': { value: 'updated data' },
   *   'node-id-3': { value: 'new data' }
   * };
   * nodeDataProvider.updateCache(newRecords, { strategy: 'merge', source: 'network' });
   * ```
   *
   * Supports two strategies:
   * - 'merge' (default): Merges new records into the existing cache.
   * - 'replace': Replaces the entire cache with the new records, invalidating any in-flight requests.
   *
   * @param records A map of node data keys to their corresponding data.
   * @param options Optional settings for the update operation.
   * @param options.strategy The strategy to use for updating the cache ('merge' or 'replace'). Defaults to 'merge'.
   * @param options.source The source of the data being added ('ssr' or 'network'). Defaults to 'network'.
   */ updateCache(records = {}, options) {
        const strategy = options?.strategy ?? 'merge';
        const source = options?.source ?? 'network';
        if (strategy === 'merge') {
            for (const [key, data] of Object.entries(records))this.cache[key] = {
                data: data,
                source: source
            };
            return;
        } else if (strategy === 'replace') {
            // Replace the entire cache with the new records
            // This will increase the cache version to invalidate any in-flight requests
            this.resetCache();
            this.cache = Object.fromEntries(Object.entries(records).map(([key, data])=>[
                    key,
                    {
                        data: data,
                        source: source
                    }
                ]));
        }
    }
    /**
   * Removes one or more entries from the cache.
   *
   * @param keys A single data key or array of data keys to remove from the cache.
   */ removeFromCache(keys) {
        keys.forEach((key)=>{
            delete this.cache[key];
        });
    }
    constructor(){
        this.cacheVersion = void 0;
        this.cache = void 0;
        this.networkRequestsInFlight = void 0;
        /**
     * A unique name for the provider. Used for identification in SSR.
     */ this.name = void 0;
        this.cacheVersion = 0;
        this.cache = {};
        this.networkRequestsInFlight = {};
    }
}
module.exports["NodeDataProvider"] = $27efd3461a9c6d27$export$1185db7a00c13eed;

});

parcelRegister("koAyx", function(module, exports) {
class $b7cac00c977cfcad$export$f993aef960936087 {
    buildInlineAdf(url) {
        return {
            type: 'inlineCard',
            attrs: {
                url: url
            }
        };
    }
    buildBlockAdf(url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url
            }
        };
    }
    buildEmbedAdf(url) {
        return {
            type: 'embedCard',
            attrs: {
                url: url,
                layout: 'wide'
            }
        };
    }
    buildDatasourceAdf(datasource, url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url,
                datasource: datasource
            }
        };
    }
    toSmartlinkAdf(url, appearance) {
        switch(appearance){
            case 'inline':
                return this.buildInlineAdf(url);
            case 'block':
                return this.buildBlockAdf(url);
            case 'embed':
                return this.buildEmbedAdf(url);
        }
    }
    toDatasourceAdf(datasource, url) {
        return this.buildDatasourceAdf(datasource, url);
    }
}
module.exports["Transformer"] = $b7cac00c977cfcad$export$f993aef960936087;

});

parcelRegister("8kONW", function(module, exports) {
/**
 * URL checker utilities for Confluence content types.
 *
 * Exported via the `@atlaskit/editor-card-provider/url-checkers` subpath
 * so consumers don't have to depend on the barrel file.
 */ /**
 * Matches Confluence Slides URLs.
 *
 * Examples:
 *   - /wiki/spaces/TEAM/slide/12345
 *   - /wiki/spaces/~uid/slide/8fb8c642-803d-59fe-8d1c-066610e860c6
 */ // eslint-disable-next-line require-unicode-regexp -- consistent with isConfluenceDatabase in provider.ts
const $025d94307c54f6b4$var$CONFLUENCE_SLIDE_URL_PATTERN = /\/wiki\/spaces\/~?[\d\w]+\/slide\/[\d\w-]+(\?.*)?$/;
const $025d94307c54f6b4$export$4091d55e0211d2e1 = (url)=>$025d94307c54f6b4$var$CONFLUENCE_SLIDE_URL_PATTERN.test(url);
module.exports["isConfluenceSlideUrl"] = $025d94307c54f6b4$export$4091d55e0211d2e1;

});

parcelRegister("biKbJ", function(module, exports) {
const $57ceb58159fd0951$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $57ceb58159fd0951$export$bae979e68e4dc802 extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(error){
        super(error);
    }
}
async function $57ceb58159fd0951$export$b5fe3f66a567bec0(method, url, // eslint-disable-next-line @typescript-eslint/no-explicit-any
data, headers) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || $57ceb58159fd0951$var$ALLOWED_RESPONSE_STATUS_CODES.includes(response.status)) return await response.json();
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $57ceb58159fd0951$export$bae979e68e4dc802(error);
        throw error;
    }
}
module.exports["request"] = $57ceb58159fd0951$export$b5fe3f66a567bec0;

});

parcelRegister("iyuxZ", function(module, exports) {

var $6YrB3 = parcelRequire("6YrB3");

var $842937149a04b8ba$var$_SmartCardLocalCacheClient;
const $842937149a04b8ba$var$SMART_CARD_CACHE_CLIENT_KEY = 'smart-card-url-data';
const $842937149a04b8ba$var$SMART_CARD_CACHE_KEY = 'response-cache';
const $842937149a04b8ba$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS = 100;
class $842937149a04b8ba$export$1987ad1ab31f2528 {
    /**
   * Gets the singleton instance of SmartCardLocalCacheClient.
   * This ensures all callers share the same in-memory cache and prevents
   * race conditions when multiple instances write to the same storage key.
   * @param maxItems Maximum number of items to store in the cache (only used on first instantiation)
   * @returns The singleton instance
   */ static getInstance(maxItems = $842937149a04b8ba$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS) {
        if (!$842937149a04b8ba$export$1987ad1ab31f2528.instance) $842937149a04b8ba$export$1987ad1ab31f2528.instance = new $842937149a04b8ba$export$1987ad1ab31f2528(maxItems);
        return $842937149a04b8ba$export$1987ad1ab31f2528.instance;
    }
    /**
   * Resets the singleton instance. Only intended for testing purposes.
   * @internal
   */ static resetInstance() {
        $842937149a04b8ba$export$1987ad1ab31f2528.instance = null;
    }
    constructor(maxItems = $842937149a04b8ba$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS){
        this.storageClient = new (0, $6YrB3.default)($842937149a04b8ba$var$SMART_CARD_CACHE_CLIENT_KEY, {
            storageEngine: 'sessionStorage'
        });
        this.maxItems = void 0;
        this.memoryCache = void 0;
        this.pendingWrite = false;
        /**
     * Retrieves the entire cache object from memory
     * @returns The entire cache object
     */ this.getCache = ()=>{
            return this.memoryCache;
        };
        /**
     * Caches the SmartLinkResponse against the provided url in storage
     * @param url The url (key) to store the response against
     * @param response The SmartLinkResponse to be cached in storage
     */ this.setItem = (url, response)=>{
            // Add or update the item in the cache with current timestamp
            this.memoryCache[url] = {
                data: response,
                timestamp: Date.now()
            };
            // Apply FIFO behavior if cache exceeds maxItems
            const cacheKeys = Object.keys(this.memoryCache);
            if (cacheKeys.length > this.maxItems) {
                // Sort keys by timestamp (oldest first) and remove the oldest items
                const sortedKeys = cacheKeys.sort((a, b)=>this.memoryCache[a].timestamp - this.memoryCache[b].timestamp);
                const itemsToRemove = cacheKeys.length - this.maxItems;
                const keysToRemove = sortedKeys.slice(0, itemsToRemove);
                keysToRemove.forEach((key)=>{
                    delete this.memoryCache[key];
                });
            }
            // Write through to storage asynchronously (non-blocking)
            // Debounced to batch multiple rapid calls into a single write
            if (!this.pendingWrite) {
                this.pendingWrite = true;
                queueMicrotask(()=>{
                    try {
                        this.storageClient.setItemWithExpiry($842937149a04b8ba$var$SMART_CARD_CACHE_KEY, JSON.stringify(this.memoryCache));
                    } catch (_) {
                    // Ignore storage write errors (e.g. quota exceeded) to prevent blocking future writes
                    // Cache will still function in-memory for the session, but won't persist
                    } finally{
                        this.pendingWrite = false;
                    }
                });
            }
        };
        /**
     * Retrieves the cached SmartLinkResponse for the provided url from storage (if it exists)
     * @param url The url (key) to retrieve the cached response for
     * @returns The cached SmartLinkResponse if it exists, else undefined
     */ this.getItem = (url)=>{
            if (!url) return;
            const response = this.memoryCache?.[url]?.data;
            return response;
        };
        /**
     * Checks if a cached entry exists for the provided url in storage
     * @param url The url (key) to check for existence in the cache
     * @returns True if a cached entry exists, else false
     */ this.isUrlInCache = (url)=>{
            return url in this.memoryCache;
        };
        this.maxItems = maxItems;
        // Load cache from storage into memory on instantiation
        const stored = this.storageClient.getItem($842937149a04b8ba$var$SMART_CARD_CACHE_KEY, {
            useExpiredItem: true
        });
        this.memoryCache = stored ? JSON.parse(stored) : {};
    }
}
$842937149a04b8ba$var$_SmartCardLocalCacheClient = $842937149a04b8ba$export$1987ad1ab31f2528;
$842937149a04b8ba$export$1987ad1ab31f2528.instance = null;
module.exports["SmartCardLocalCacheClient"] = $842937149a04b8ba$export$1987ad1ab31f2528;

});

parcelRegister("5mn6Y", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $7a677adb37846106$var$NOOP_SET_PREFERRED_TAB_KEY = ()=>{
// Intentional no-op: safe default/reset used as the context fallback and the
// module-level setter when no provider is mounted. Setting a tab preference
// without a mounted provider should silently do nothing rather than throw.
};
const $7a677adb37846106$var$NOOP_SET_EMBED_INTENT = ()=>{
// Intentional no-op: safe default/reset used as the context fallback and the
// module-level setter when no provider is mounted.
};
const $7a677adb37846106$var$RovoLinkPickerTabPreferenceContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    preferredTabKey: undefined,
    setPreferredTabKey: $7a677adb37846106$var$NOOP_SET_PREFERRED_TAB_KEY,
    embedIntent: false,
    setEmbedIntent: $7a677adb37846106$var$NOOP_SET_EMBED_INTENT
});
/**
 * Module-level holder for the latest setter from the most recently mounted
 * provider. This exists so non-React callers (specifically quick-insert action
 * closures inside `ExtensionManifest`s, which run outside the render tree)
 * can read the up-to-date setter without re-creating the manifest on every
 * render.
 *
 * The provider keeps this in sync via `useEffect`; consumers must read the
 * setter at action-execution time via `getSetPreferredTabKey()`.
 */ let $7a677adb37846106$var$latestSetPreferredTabKey = $7a677adb37846106$var$NOOP_SET_PREFERRED_TAB_KEY;
/**
 * Module-level holder for the latest `setEmbedIntent` from the most recently
 * mounted provider. Mirrors `latestSetPreferredTabKey` so the non-React
 * quick-insert action closures can record embed intent without re-creating the
 * manifest on every render.
 */ let $7a677adb37846106$var$latestSetEmbedIntent = $7a677adb37846106$var$NOOP_SET_EMBED_INTENT;
const $7a677adb37846106$export$c46323df35736cd5 = ()=>$7a677adb37846106$var$latestSetPreferredTabKey;
const $7a677adb37846106$export$98cdae88d44f387c = ()=>$7a677adb37846106$var$latestSetEmbedIntent;
const $7a677adb37846106$export$726d95d3ef56bfbf = ({ children: children })=>{
    const [preferredTabKey, setPreferredTabKeyState] = (0, $cozmU.useState)(undefined);
    const [embedIntent, setEmbedIntentState] = (0, $cozmU.useState)(false);
    const setPreferredTabKey = (0, $cozmU.useCallback)((key)=>{
        setPreferredTabKeyState(key);
    }, []);
    const setEmbedIntent = (0, $cozmU.useCallback)((value)=>{
        setEmbedIntentState(value);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        $7a677adb37846106$var$latestSetPreferredTabKey = setPreferredTabKey;
        return ()=>{
            if ($7a677adb37846106$var$latestSetPreferredTabKey === setPreferredTabKey) $7a677adb37846106$var$latestSetPreferredTabKey = $7a677adb37846106$var$NOOP_SET_PREFERRED_TAB_KEY;
        };
    }, [
        setPreferredTabKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        $7a677adb37846106$var$latestSetEmbedIntent = setEmbedIntent;
        return ()=>{
            if ($7a677adb37846106$var$latestSetEmbedIntent === setEmbedIntent) $7a677adb37846106$var$latestSetEmbedIntent = $7a677adb37846106$var$NOOP_SET_EMBED_INTENT;
        };
    }, [
        setEmbedIntent
    ]);
    const value = (0, $cozmU.useMemo)(()=>({
            preferredTabKey: preferredTabKey,
            setPreferredTabKey: setPreferredTabKey,
            embedIntent: embedIntent,
            setEmbedIntent: setEmbedIntent
        }), [
        preferredTabKey,
        setPreferredTabKey,
        embedIntent,
        setEmbedIntent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7a677adb37846106$var$RovoLinkPickerTabPreferenceContext.Provider, {
        value: value
    }, children);
};
const $7a677adb37846106$export$94d4724b240e82bf = ()=>(0, $cozmU.useContext)($7a677adb37846106$var$RovoLinkPickerTabPreferenceContext);
module.exports["getSetPreferredTabKey"] = $7a677adb37846106$export$c46323df35736cd5;
module.exports["getSetEmbedIntent"] = $7a677adb37846106$export$98cdae88d44f387c;
module.exports["RovoLinkPickerTabPreferenceProvider"] = $7a677adb37846106$export$726d95d3ef56bfbf;
module.exports["useRovoLinkPickerTabPreference"] = $7a677adb37846106$export$94d4724b240e82bf;

});

parcelRegister("3gyyc", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $1P2f3 = parcelRequire("1P2f3");

const $59e4a4ba3e3599a7$export$7e063004a2621936 = ()=>{
    try {
        const isSSRRendered = // In most places there is no document when running on server-side
        typeof document === 'undefined' || // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        typeof $1P2f3 !== 'undefined' && $1P2f3.env?.REACT_SSR || typeof window !== 'undefined' && window.__SSR_RENDERED__ || globalThis.__SSR_RENDERED__;
        const isSSRReactStreaming = typeof window !== 'undefined' && window.__SSR_REACT_STREAMING__ || globalThis.__SSR_REACT_STREAMING__;
        return Boolean(isSSRRendered) && (0, $6mKj3.expValEquals)('platform_editor_editor_ssr_streaming', 'isEnabled', true) && Boolean(isSSRReactStreaming);
    } catch  {
        // Catch possible error that might occur and just return false
        return false;
    }
};
module.exports["isSSRStreaming"] = $59e4a4ba3e3599a7$export$7e063004a2621936;

});

parcelRegister("gbbGu", function(module, exports) {

let $bc76bcafef379207$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bc76bcafef379207$var$load("hZVEi"),
    $bc76bcafef379207$var$load("hS8gF"),
    $bc76bcafef379207$var$load("g8A75"),
    $bc76bcafef379207$var$load("6wr18"),
    $bc76bcafef379207$var$load("do0Fh"),
    $bc76bcafef379207$var$load("1ce1Q"),
    $bc76bcafef379207$var$load("l25pP"),
    $bc76bcafef379207$var$load("ffEVr"),
    $bc76bcafef379207$var$load("gA528"),
    $bc76bcafef379207$var$load("gzrfp"),
    $bc76bcafef379207$var$load("ewN9L"),
    $bc76bcafef379207$var$load("1YMDo")
]).then(()=>parcelRequire('2pRIg'));

});

parcelRegister("i8Ylv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3ricL = parcelRequire("3ricL");


var $9DHhW = parcelRequire("9DHhW");


var $i1t43 = parcelRequire("i1t43");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $5oPgz = parcelRequire("5oPgz");


var $6mKj3 = parcelRequire("6mKj3");


var $42MJM = parcelRequire("42MJM");


var $48ubT = parcelRequire("48ubT");


var $euL71 = parcelRequire("euL71");


var $lsxnT = parcelRequire("lsxnT");


var $cwY4x = parcelRequire("cwY4x");

const $618e6728be00f8eb$var$WAC_LINK = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $618e6728be00f8eb$var$messages = (0, $kSwu1.defineMessages)({
    title: {
        id: "editor-features.ai-optin-modal.title",
        defaultMessage: "Elevate your team\u2019s writing"
    },
    description: {
        id: "editor-features.ai-optin-modal.description",
        defaultMessage: "Help enhance your team\u2019s writing with Rovo. Let AI improve clarity, maintain a professional tone, or craft concise content."
    },
    readMoreText: {
        id: "editor-features.ai-optin-modal.learn-more.link.text",
        defaultMessage: "<a>Read about Rovo</a>"
    },
    adminTurnOnText: {
        id: "editor-features.ai-optin-modal.admin-turn-on-text",
        defaultMessage: "Turn on Rovo features for your users from Atlassian Administration."
    },
    closeCTAText: {
        id: "editor-features.ai-optin-modal.close-cta-text",
        defaultMessage: "Maybe later"
    },
    getStartCTAText: {
        id: "editor-features.ai-optin-modal.get-started-cta-text",
        defaultMessage: "Get started"
    },
    learnMoreText: {
        id: "editor-features.ai-optin-modal.learn-more-cta-text",
        defaultMessage: "Learn more"
    },
    upgradePlanText: {
        id: "editor-features.ai-optin-modal.upgrade-plan-text",
        defaultMessage: "To start using Rovo in your products, upgrade your plan."
    },
    upsellText: {
        id: "editor-features.ai-optin-modal.upsell-text",
        defaultMessage: "With Rovo (AI), your team can craft concise, clear, and professional content faster than ever."
    },
    freePlanText: {
        id: "editor-features.ai-optin-modal.free-plan-text",
        defaultMessage: "You\u2019re on the free plan."
    },
    standardPlanText: {
        id: "editor-features.ai-optin-modal.standard-plan-text",
        defaultMessage: "You\u2019re on the standard plan."
    }
});
const $618e6728be00f8eb$var$OptInModal = ({ onClose: onClose, edition: edition, isSiteAdmin: isSiteAdmin, orgId: orgId, environment: environment })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const adminLink = $618e6728be00f8eb$var$getOptInDeepLink(orgId, environment);
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const onOptInReadMoreClick = (0, $cozmU.useCallback)((e)=>{
        e.stopPropagation();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'editorAI',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'editorAIOptInReadMoreLink',
                attributes: {
                    product: 'confluence',
                    isOrgAdmin: isSiteAdmin
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isSiteAdmin
    ]);
    const showUpsell = edition !== (0, $euL71.ConfluenceEdition).PREMIUM;
    /**
   * HOT-116592 - https://atlassian.enterprise.slack.com/archives/C08MHDT1KLJ
   * This is used to track if the AIUpsell and / or AIOptIn components are rendered
   */ const onRender = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'editorAI',
                action: 'triggerOptInFlowModalRendered',
                actionSubject: 'editorAIOptInDialog',
                actionSubjectId: 'editorAIModalRendered',
                attributes: {
                    product: 'confluence',
                    isOrgAdmin: isSiteAdmin,
                    edition: edition,
                    env: environment,
                    upsell: showUpsell
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isSiteAdmin,
        showUpsell,
        edition,
        environment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
        width: "fit-content",
        onClose: onClose,
        testId: showUpsell ? 'editor-ai-upsell-modal' : 'editor-ai-opt-in-modal',
        /**
   * HOT-116592 - https://atlassian.enterprise.slack.com/archives/C08MHDT1KLJ
   * Mark this modal as transactional as its a critical part of the ai upsell / opt in
   */ messageType: "transactional",
        messageId: "editor-ai-opt-in-modal"
    }, showUpsell ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $42MJM.AIUpsell), {
        feature: "editorAI",
        title: formatMessage($618e6728be00f8eb$var$messages.title),
        body: `${formatMessage($618e6728be00f8eb$var$messages.upsellText)}
				<p></p>
				<p>${edition === (0, $euL71.ConfluenceEdition).FREE ? formatMessage($618e6728be00f8eb$var$messages.freePlanText) : formatMessage($618e6728be00f8eb$var$messages.standardPlanText)} ${formatMessage($618e6728be00f8eb$var$messages.upgradePlanText)}</p>`,
        image: {
            src: {
                default: (0, (/*@__PURE__*/$parcel$interopDefault($cwY4x))),
                dark: (0, (/*@__PURE__*/$parcel$interopDefault($cwY4x)))
            },
            alt: 'editor-ai-opt-in-banner'
        },
        learnMoreLink: {
            message: formatMessage($618e6728be00f8eb$var$messages.learnMoreText),
            href: $618e6728be00f8eb$var$WAC_LINK
        },
        onRender: onRender
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5oPgz.default), {
        source: "editorAI",
        product: "confluence",
        isOrgAdmin: true,
        onAdminClose: onClose,
        // TODO: Update the attribute below so it is translated.
        // eslint-disable-next-line no-restricted-syntax
        image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($cwY4x))),
            height: "96px",
            alt: "editor-ai-opt-in-banner"
        }),
        adminLink: adminLink,
        adminHeaderText: formatMessage($618e6728be00f8eb$var$messages.title),
        adminCloseCTAText: formatMessage($618e6728be00f8eb$var$messages.closeCTAText),
        adminCTAText: formatMessage($618e6728be00f8eb$var$messages.getStartCTAText),
        adminBodyText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            space: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, formatMessage($618e6728be00f8eb$var$messages.description), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$618e6728be00f8eb$var$messages.readMoreText,
            values: {
                a: (s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                        href: $618e6728be00f8eb$var$WAC_LINK,
                        target: "_blank",
                        onClick: onOptInReadMoreClick,
                        rel: "noopener noreferrer"
                    }, s)
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, formatMessage($618e6728be00f8eb$var$messages.adminTurnOnText))),
        onRender: onRender
    }));
};
const $618e6728be00f8eb$var$getOptInDeepLink = (orgId, environment)=>{
    if (!orgId || !environment) return undefined;
    if (orgId) {
        if (environment === 'PRODUCTION') return `https://admin.atlassian.com/o/${orgId}/atlassian-intelligence`;
        else if (environment === 'STAGING') return `https://admin.stg.atlassian.com/o/${orgId}/atlassian-intelligence`;
    }
};
const $618e6728be00f8eb$var$getOptInStatus = (isAdminHubAIEnabled, isAIEnabledForContent, isSiteAdmin, edition, isRovoLLMEnabled)=>{
    // environment-aware enablement via feature encoding
    const isAIFeatureEnabled = (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-ai');
    if (!isAIFeatureEnabled) return 'disabled';
    if (!isAIEnabledForContent && isAdminHubAIEnabled) return 'disabled';
    // When the Rovo Access experiment is enabled, also require isRovoLLMEnabled so that
    // blocking Confluence in Rovo Access (which sets isRovoLLMEnabled=false while leaving
    // isAdminHubAIEnabled=true) correctly disables all Rovo-powered editor features.
    if (isAdminHubAIEnabled && (isRovoLLMEnabled || !(0, $6mKj3.expVal)('platform_editor_rovo_access_ai_opt_in', 'isEnabled', false))) return 'enabled';
    if (edition === null) return 'disabled';
    if (isSiteAdmin) return 'disabled-opt-in';
    return 'disabled';
};
const $618e6728be00f8eb$var$defaultEmptyTrigger = ()=>{};
const $618e6728be00f8eb$var$defaultEmptyComponent = ()=>null;
const $618e6728be00f8eb$export$90c93708fff010b3 = ({ isAdminHubAIEnabled: isAdminHubAIEnabled, isAIEnabledForContent: isAIEnabledForContent = true, edition: edition, orgId: orgId, environment: environment, isRovoLLMEnabled: isRovoLLMEnabled = true })=>{
    const isSiteAdmin = (0, $48ubT.useIsSiteAdmin)().isSiteAdmin;
    const optInStatus = $618e6728be00f8eb$var$getOptInStatus(isAdminHubAIEnabled, isAIEnabledForContent, isSiteAdmin, edition, isRovoLLMEnabled);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (optInStatus === 'disabled-opt-in') {
            const preloadImages = (paths)=>{
                paths.forEach((path)=>{
                    const img = new Image();
                    img.src = path;
                });
            };
            preloadImages([
                (0, (/*@__PURE__*/$parcel$interopDefault($cwY4x)))
            ]);
        }
    }, [
        optInStatus
    ]);
    const [showOptInModal, setShowOptInModal] = (0, $cozmU.useState)(false);
    const triggerOptInFlow = (0, $cozmU.useCallback)(()=>{
        if (edition !== null) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'editorAI',
                action: 'triggerOptInFlow',
                actionSubject: 'editorAIOptInDialog',
                actionSubjectId: 'editorAIOptInTrigger',
                attributes: {
                    isOrgAdmin: isSiteAdmin,
                    optInType: edition === (0, $euL71.ConfluenceEdition).PREMIUM ? 'AIOptIn' : 'AIUpsell'
                }
            }
        }).fire();
        setShowOptInModal(true);
    }, [
        setShowOptInModal,
        createAnalyticsEvent,
        edition,
        isSiteAdmin
    ]);
    const AIOptInModal = (0, $cozmU.useCallback)(()=>{
        const onCloseModal = ()=>setShowOptInModal(false);
        return showOptInModal && edition !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($618e6728be00f8eb$var$OptInModal, {
            onClose: onCloseModal,
            edition: edition,
            isSiteAdmin: isSiteAdmin,
            orgId: orgId,
            environment: environment
        }) : null;
    }, [
        showOptInModal,
        edition,
        isSiteAdmin,
        orgId,
        environment
    ]);
    if (optInStatus === 'disabled-opt-in') return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerOptInFlow,
        AIOptInModal: AIOptInModal
    };
    return {
        optInStatus: optInStatus,
        triggerOptInFlow: $618e6728be00f8eb$var$defaultEmptyTrigger,
        AIOptInModal: $618e6728be00f8eb$var$defaultEmptyComponent
    };
};
const $618e6728be00f8eb$export$aa96168180a4e542 = (isAdminHubAIEnabled)=>{
    return isAdminHubAIEnabled ? 'enabled' : 'disabled';
};
module.exports["useEditorAIOptIn"] = $618e6728be00f8eb$export$90c93708fff010b3;

});

parcelRegister("i1t43", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $w6R6I = parcelRequire("w6R6I");


var $ixfCV = parcelRequire("ixfCV");


var $7vK9E = parcelRequire("7vK9E");

var $iMnC5 = parcelRequire("iMnC5");

const $7e44050607850249$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    defaultAppearanceMotion: "_4bfu1r31 _1hms8stv _ajmmnqa1 _v564hxmd _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1j28 _1bnx8stv _jf4cnqa1 _30l313af _1nrm1j28 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    subtleAppearanceMotion: "_4bfu1j28 _1hms8stv _ajmmnqa1 _v564hxmd _syazazsu _1a3b1j28 _4fpr8stv _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    inverseAppearanceMotion: "_4bfu1r31 _1hms8stv _ajmmnqa1 _v564hxmd _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1j28 _1bnx8stv _jf4cnqa1 _30l315cr _1nrm1j28 _c2wa8stv _1iohnqa1 _1ggl87vo _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $7e44050607850249$var$iconStyles = null;
const $7e44050607850249$var$LinkWithoutRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(21);
    let children;
    let htmlAttributes;
    let newWindowLabel;
    let t1;
    let target;
    let testId;
    if ($[0] !== t0) {
        const { children: t2, testId: t3, appearance: t4, newWindowLabel: t5, target: t6, className: _preventedClassName, style: _preventedStyle, ...t7 } = t0;
        children = t2;
        testId = t3;
        t1 = t4;
        newWindowLabel = t5;
        target = t6;
        htmlAttributes = t7;
        $[0] = t0;
        $[1] = children;
        $[2] = htmlAttributes;
        $[3] = newWindowLabel;
        $[4] = t1;
        $[5] = target;
        $[6] = testId;
    } else {
        children = $[1];
        htmlAttributes = $[2];
        newWindowLabel = $[3];
        t1 = $[4];
        target = $[5];
        testId = $[6];
    }
    const appearance = t1 === undefined ? "default" : t1;
    let t2;
    if ($[7] !== appearance) {
        t2 = (0, $w6R6I.cx)($7e44050607850249$var$styles.base, (0, $ixfCV.fg)("platform-dst-shape-theme-default") && $7e44050607850249$var$styles.baseT26Shape, appearance === "default" && ((0, $ixfCV.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.defaultAppearanceMotion : $7e44050607850249$var$styles.defaultAppearance), appearance === "subtle" && ((0, $ixfCV.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.subtleAppearanceMotion : $7e44050607850249$var$styles.subtleAppearance), appearance === "inverse" && ((0, $ixfCV.fg)("platform-dst-motion-uplift-list-item") ? $7e44050607850249$var$styles.inverseAppearanceMotion : $7e44050607850249$var$styles.inverseAppearance), appearance !== "inverse" && $7e44050607850249$var$styles.visitedLink);
        $[7] = appearance;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== target || $[10] !== testId) {
        t3 = target === "_blank" && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            as: "span",
            xcss: $7e44050607850249$var$styles.iconWrapper,
            testId: testId && `${testId}__icon`
        }, "\uFEFF", /*#__PURE__*/ $cozmU.createElement("svg", {
            width: "12",
            height: "12",
            viewBox: "0 0 12 12",
            fill: "none",
            className: (0, $hekY6.default)([
                "_1bsbgm0b _4t3igm0b _ahbqzjw7"
            ])
        }, /*#__PURE__*/ $cozmU.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
            fill: "currentColor"
        })));
        $[9] = target;
        $[10] = testId;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== children || $[13] !== htmlAttributes || $[14] !== newWindowLabel || $[15] !== ref || $[16] !== t2 || $[17] !== t3 || $[18] !== target || $[19] !== testId) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.default), {
            ...htmlAttributes,
            target: target,
            ref: ref,
            xcss: t2,
            testId: testId,
            componentName: "Link",
            newWindowLabel: newWindowLabel
        }, children, t3);
        $[12] = children;
        $[13] = htmlAttributes;
        $[14] = newWindowLabel;
        $[15] = ref;
        $[16] = t2;
        $[17] = t3;
        $[18] = target;
        $[19] = testId;
        $[20] = t4;
    } else t4 = $[20];
    return t4;
} : ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.default // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $w6R6I.cx)($7e44050607850249$var$styles.base, (0, $ixfCV.fg)('platform-dst-shape-theme-default') && $7e44050607850249$var$styles.baseT26Shape, appearance === 'default' && ((0, $ixfCV.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.defaultAppearanceMotion : $7e44050607850249$var$styles.defaultAppearance), appearance === 'subtle' && ((0, $ixfCV.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.subtleAppearanceMotion : $7e44050607850249$var$styles.subtleAppearance), appearance === 'inverse' && ((0, $ixfCV.fg)('platform-dst-motion-uplift-list-item') ? $7e44050607850249$var$styles.inverseAppearanceMotion : $7e44050607850249$var$styles.inverseAppearance), // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $7e44050607850249$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel
    }, children, target === '_blank' && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        as: "span",
        xcss: $7e44050607850249$var$styles.iconWrapper,
        testId: testId && `${testId}__icon`
    }, "\uFEFF", /*#__PURE__*/ $cozmU.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        className: (0, $hekY6.default)([
            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
        fill: "currentColor"
    }))));
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $7e44050607850249$var$Link = /*#__PURE__*/ (0, $cozmU.forwardRef)($7e44050607850249$var$LinkWithoutRef);
var $7e44050607850249$export$2e2bcd8739ae039 = $7e44050607850249$var$Link;
module.exports["default"] = $7e44050607850249$export$2e2bcd8739ae039;

});

parcelRegister("5oPgz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $ad7Ou = parcelRequire("ad7Ou");

var $eKMV3 = parcelRequire("eKMV3");


var $i1t43 = parcelRequire("i1t43");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");


var $bIyG9 = parcelRequire("bIyG9");


var $gLuQR = parcelRequire("gLuQR");


var $dOrqE = parcelRequire("dOrqE");


var $3JALx = parcelRequire("3JALx");

const $18d021949c5b420c$var$VisibleTextOrgAdminStyles = (0, $buxP3.xcss)({
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $18d021949c5b420c$var$AiOptIn = ({ source: source, product: product, isOrgAdmin: isOrgAdmin, image: image, headerText: headerText, bodyText: bodyText, width: width, testId: testId, onAdminCTA: onAdminCTA, onAdminClose: onAdminClose, adminBodyText: adminBodyText, adminHeaderText: adminHeaderText, adminCTAText: adminCTAText, adminCloseCTAText: adminCloseCTAText, adminLink: adminLink, onRender: onRender })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (onRender) onRender();
    }, [
        onRender
    ]);
    const onLearnMoreClicked = (e)=>{
        e.stopPropagation();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogLearnMoreLink',
                attributes: {
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    const formatMessageValues = {
        a: (s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                href: (0, $gLuQR.AI_LINK),
                target: "_blank",
                onClick: onLearnMoreClicked
            }, s),
        br: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("br", null)
    };
    const defaultHeader = formatMessage((0, $dOrqE.messages).aiOptInDialogHeaderText);
    const header = headerText ?? defaultHeader;
    const body = bodyText ?? formatMessage((0, $dOrqE.messages).aiOptInDialogBodyText, formatMessageValues);
    const orgAdminBody = adminBodyText ?? formatMessage((0, $dOrqE.messages).aiOptInDialogAdminBodyText, formatMessageValues);
    const orgAdminHeader = adminHeaderText ?? defaultHeader;
    (0, $cozmU.useEffect)(()=>{
        const preloadImages = (paths)=>{
            paths.forEach((path)=>{
                const img = new Image();
                img.src = path;
            });
        };
        preloadImages([
            (0, (/*@__PURE__*/$parcel$interopDefault($bIyG9)))
        ]);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'aiGlobalOptInDialog',
                attributes: {
                    source: source,
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source,
        product,
        isOrgAdmin
    ]);
    const onCloseClicked = (e)=>{
        e.stopPropagation();
        onAdminClose?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCloseButton',
                attributes: {
                    product: product
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    const onCTAClicked = (e)=>{
        e.stopPropagation();
        onAdminCTA?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCTAButton',
                attributes: {
                    product: product
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3JALx.OptInBackgroundBorder), {
        width: width,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3JALx.OptInContainer), null, image ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3JALx.ImageWrapper), null, image) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3JALx.ImageWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bIyG9))),
        height: "96px",
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3JALx.ContentContainer), null, isOrgAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $18d021949c5b420c$var$VisibleTextOrgAdminStyles
    }, formatMessage((0, $dOrqE.messages).aiOptInAdminOnlyVisible)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3JALx.HeaderWrapper), null, isOrgAdmin ? orgAdminHeader : header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3JALx.BodyWrapper), {
        "data-testid": "dialog-body-text"
    }, isOrgAdmin ? orgAdminBody : body), isOrgAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3JALx.ButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onCloseClicked,
        testId: "admin-close-button"
    }, adminCloseCTAText ?? formatMessage((0, $dOrqE.messages).aiOptInDialogAdminMaybeLaterButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
        appearance: "primary",
        onClick: onCTAClicked,
        href: adminLink ?? (0, $gLuQR.ADMIN_LINK),
        target: "_blank",
        testId: "admin-cta-button"
    }, adminCTAText ?? formatMessage((0, $dOrqE.messages).aiOptInDialogAdminGetStartedButtonText))))));
};
var $18d021949c5b420c$export$2e2bcd8739ae039 = $18d021949c5b420c$var$AiOptIn;
module.exports["default"] = $18d021949c5b420c$export$2e2bcd8739ae039;

});

parcelRegister("bIyG9", function(module, exports) {
module.exports = new URL("global-opt-in-default-image-banner.cf053e66.svg", import.meta.url).toString();

});

parcelRegister("gLuQR", function(module, exports) {
const $8c06b23912f46f08$export$550fac1a4ec3d365 = 'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products';
const $8c06b23912f46f08$export$bae9a077d7ed5dfe = 'http://admin.atlassian.com/';
module.exports["AI_LINK"] = $8c06b23912f46f08$export$550fac1a4ec3d365;
module.exports["ADMIN_LINK"] = $8c06b23912f46f08$export$bae9a077d7ed5dfe;

});

parcelRegister("dOrqE", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $0adcba90580c9181$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    /**
   * Messages for the AI Global Opt-in component
   */ aiOptInDialogHeaderText: {
        id: "ai-opt-in.dialog.header.text",
        defaultMessage: "Work smarter, not harder"
    },
    aiOptInDialogBodyText: {
        id: "ai-opt-in.dialog.body.text",
        defaultMessage: "Get up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration."
    },
    aiOptInDialogLearnMoreLinkText: {
        id: "ai-opt-in.dialog.learn-more.link.text",
        defaultMessage: "Learn more about Atlassian Intelligence"
    },
    aiOptInDialogAdminBodyText: {
        id: "ai-opt-in.dialog.admin.body.text",
        defaultMessage: "Get your team up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration."
    },
    aiOptInDialogAdminMaybeLaterButtonText: {
        id: "ai-opt-in.dialog.admin.maybe-later.button.text",
        defaultMessage: "Maybe later"
    },
    aiOptInDialogAdminGetStartedButtonText: {
        id: "ai-opt-in.dialog.admin.get-started.button.text",
        defaultMessage: "Get started"
    },
    aiOptInBannerBodyText: {
        id: "ai-opt-in.banner.body.text",
        defaultMessage: "Work smarter, not harder. Express your interest in Atlassian Intelligence so your admin knows you\u2019d like them to activate it."
    },
    aiOptInBannerLearnMoreText: {
        id: "ai-opt-in.banner.learn.more.text",
        defaultMessage: "Learn more"
    },
    aiOptInAdminBannerBodyText: {
        id: "ai-opt-in.banner.admin.body.text",
        defaultMessage: "Get everyone up to speed quickly and consume information with ease. Turn on <a>Atlassian Intelligence</a> features for your users from Atlassian Administration."
    },
    aiOptInAdminOnlyVisible: {
        id: "ai-opt-in.admin.only.visible.text",
        defaultMessage: "This message is only visible to org admins."
    }
});
module.exports["messages"] = $0adcba90580c9181$export$defe85febe8b728c;

});

parcelRegister("3JALx", function(module, exports) {
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");

const $af8ff95fabcf5ee5$export$24c280970213bb11 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $9aYkv.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _2rko1qi0 _11q71lxv _16qs130s _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _kqswh2mm",
            __cmplp.width ? "_1bsb1efm" : "_1bsbkbql",
            __cmplp.className
        ])
    });
});
const $af8ff95fabcf5ee5$export$a0fab83bea8ccf2e = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2rkofajl _1e0c1txw _2lx21bp4 _bfhk1bhr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $af8ff95fabcf5ee5$export$75f07c36086c2c81 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2rko1cku _1e0c1txw _1biu1cku _1jpx1dfr _mezj1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $af8ff95fabcf5ee5$export$9d2b4227a95687cc = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_zulpu2gc _1e0c1txw _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _2lx21bp4 _1wpz1fhb _4cvr1y6m",
            __cmplp.className
        ])
    });
});
const $af8ff95fabcf5ee5$export$960a49cc3d27a090 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11c81e3o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $af8ff95fabcf5ee5$export$14966827497f4695 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c8fhey",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $af8ff95fabcf5ee5$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_zulp1b66 _1e0c1txw _1bsb1osq _19pku2gc _1bahesu3",
            __cmplp.className
        ])
    });
});
module.exports["OptInBackgroundBorder"] = $af8ff95fabcf5ee5$export$24c280970213bb11;
module.exports["OptInContainer"] = $af8ff95fabcf5ee5$export$a0fab83bea8ccf2e;
module.exports["ImageWrapper"] = $af8ff95fabcf5ee5$export$75f07c36086c2c81;
module.exports["ContentContainer"] = $af8ff95fabcf5ee5$export$9d2b4227a95687cc;
module.exports["HeaderWrapper"] = $af8ff95fabcf5ee5$export$960a49cc3d27a090;
module.exports["BodyWrapper"] = $af8ff95fabcf5ee5$export$14966827497f4695;
module.exports["ButtonContainer"] = $af8ff95fabcf5ee5$export$eddf54ea3db8d0f0;

});

parcelRegister("42MJM", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $9DHhW = parcelRequire("9DHhW");


var $lHQAj = parcelRequire("lHQAj");


var $euL71 = parcelRequire("euL71");


var $cHKtk = parcelRequire("cHKtk");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $20dc6939391e7f10$var$UpsellBackgroundBorder = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1reo15vq _18m915vq _2rko1qi0 _1yt4v77o _11q7kwyp _16qs130s _1bsb1kdj _kqswh2mm",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _2rko1qi0 _1yt4v77o _11q7kwyp _16qs130s _1bsb1kdj _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $20dc6939391e7f10$var$UpsellContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2rkofajl _1e0c1txw _2lx21bp4 _bfhk1bhr",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2rkofajl _1e0c1txw _2lx21bp4 _bfhk1bhr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $20dc6939391e7f10$var$ImageWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "img" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2rko1cku _4t3iys9h",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2rko1cku _4t3iys9h",
            __cmplp.className
        ])
    });
});
const $20dc6939391e7f10$var$ContentContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_zbay22hw _155npxbi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_zbay22hw _155npxbi",
            __cmplp.className
        ])
    });
});
const $20dc6939391e7f10$export$38f23d3987aa9723 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { title: title, body: body, feature: feature, image: image, learnMoreLink: learnMoreLink, onRender: onRender } = t0;
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { showRequestUpgradeButton: showRequestUpgradeButton, loading: loading } = (0, $cHKtk.useEnableEndUserRequestUpgrade)(`${feature}UpsellScreen`);
    let t1;
    if ($[0] !== learnMoreLink.message || $[1] !== showRequestUpgradeButton) {
        t1 = showRequestUpgradeButton ? {
            id: "change-edition.ai-upsell.learn-more.with-end-user-request-button",
            defaultMessage: "Learn more",
            description: "Learn more link label when end user request upgrade button is present"
        } : {
            id: "change-edition.ai-upsell.learn-more",
            defaultMessage: learnMoreLink.message
        };
        $[0] = learnMoreLink.message;
        $[1] = showRequestUpgradeButton;
        $[2] = t1;
    } else t1 = $[2];
    const learnMoreLinkMessageDescriptor = t1;
    const bannerImage = colorMode === "dark" ? image?.src.dark : image?.src.default;
    let t2;
    let t3;
    if ($[3] !== onRender) {
        t2 = ()=>{
            if (onRender) onRender();
        };
        t3 = [
            onRender
        ];
        $[3] = onRender;
        $[4] = t2;
        $[5] = t3;
    } else {
        t2 = $[4];
        t3 = $[5];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[6] !== bannerImage) {
        t4 = ()=>{
            if (bannerImage) {
                const preloadImages = $20dc6939391e7f10$var$_temp2;
                preloadImages([
                    bannerImage
                ]);
            }
        };
        t5 = [
            bannerImage
        ];
        $[6] = bannerImage;
        $[7] = t4;
        $[8] = t5;
    } else {
        t4 = $[7];
        t5 = $[8];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    let t7;
    if ($[9] !== createAnalyticsEvent || $[10] !== feature) {
        t6 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "aiUpsellDialog",
                    attributes: {
                        feature: feature
                    }
                }
            }).fire();
        };
        t7 = [
            createAnalyticsEvent,
            feature
        ];
        $[9] = createAnalyticsEvent;
        $[10] = feature;
        $[11] = t6;
        $[12] = t7;
    } else {
        t6 = $[11];
        t7 = $[12];
    }
    (0, $cozmU.useEffect)(t6, t7);
    const t8 = `${feature}LearnMore`;
    let t9;
    if ($[13] !== learnMoreLink || $[14] !== learnMoreLinkMessageDescriptor || $[15] !== t8) {
        t9 = {
            ...learnMoreLink,
            messageDescriptor: learnMoreLinkMessageDescriptor,
            actionSubjectId: t8
        };
        $[13] = learnMoreLink;
        $[14] = learnMoreLinkMessageDescriptor;
        $[15] = t8;
        $[16] = t9;
    } else t9 = $[16];
    const t10 = `${feature}UpsellScreen`;
    const t11 = `${feature}TryPremium`;
    let t12;
    if ($[17] !== bannerImage) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($20dc6939391e7f10$var$ImageWrapper, {
            src: bannerImage
        });
        $[17] = bannerImage;
        $[18] = t12;
    } else t12 = $[18];
    let t13;
    if ($[19] !== body || $[20] !== loading || $[21] !== showRequestUpgradeButton || $[22] !== t10 || $[23] !== t11 || $[24] !== t12 || $[25] !== t9 || $[26] !== title) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($20dc6939391e7f10$var$UpsellBackgroundBorder, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($20dc6939391e7f10$var$UpsellContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($20dc6939391e7f10$var$ContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lHQAj.Card), {
            title: title,
            body: body,
            learnMoreLink: t9,
            source: t10,
            targetEdition: (0, $euL71.ConfluenceEdition).PREMIUM,
            upgradeEditionActionSubjectId: t11,
            isLoadingRequestUpgradeButton: loading,
            showRequestUpgradeButton: showRequestUpgradeButton
        }, t12))));
        $[19] = body;
        $[20] = loading;
        $[21] = showRequestUpgradeButton;
        $[22] = t10;
        $[23] = t11;
        $[24] = t12;
        $[25] = t9;
        $[26] = title;
        $[27] = t13;
    } else t13 = $[27];
    return t13;
} : ({ title: title, body: body, feature: feature, image: image, learnMoreLink: learnMoreLink, onRender: onRender })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { showRequestUpgradeButton: showRequestUpgradeButton, loading: loading } = (0, $cHKtk.useEnableEndUserRequestUpgrade)(`${feature}UpsellScreen`);
    const learnMoreLinkMessageDescriptor = (0, $cozmU.useMemo)(()=>{
        return showRequestUpgradeButton ? {
            id: 'change-edition.ai-upsell.learn-more.with-end-user-request-button',
            defaultMessage: 'Learn more',
            description: 'Learn more link label when end user request upgrade button is present'
        } : {
            id: 'change-edition.ai-upsell.learn-more',
            defaultMessage: learnMoreLink.message
        };
    }, [
        showRequestUpgradeButton,
        learnMoreLink.message
    ]);
    const bannerImage = colorMode === 'dark' ? image?.src.dark : image?.src.default;
    (0, $cozmU.useEffect)(()=>{
        if (onRender) onRender();
    }, [
        onRender
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (bannerImage) {
            const preloadImages = (paths)=>{
                paths.forEach((path)=>{
                    const img = new Image();
                    img.src = path;
                });
            };
            preloadImages([
                bannerImage
            ]);
        }
    }, [
        bannerImage
    ]);
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'aiUpsellDialog',
                attributes: {
                    feature: feature
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        feature
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($20dc6939391e7f10$var$UpsellBackgroundBorder, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($20dc6939391e7f10$var$UpsellContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($20dc6939391e7f10$var$ContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lHQAj.Card), {
        title: title,
        body: body,
        learnMoreLink: {
            ...learnMoreLink,
            messageDescriptor: learnMoreLinkMessageDescriptor,
            actionSubjectId: `${feature}LearnMore`
        },
        source: `${feature}UpsellScreen`,
        targetEdition: (0, $euL71.ConfluenceEdition).PREMIUM,
        upgradeEditionActionSubjectId: `${feature}TryPremium`,
        isLoadingRequestUpgradeButton: loading,
        showRequestUpgradeButton: showRequestUpgradeButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($20dc6939391e7f10$var$ImageWrapper, {
        src: bannerImage
    })))));
};
function $20dc6939391e7f10$var$_temp(path) {
    const img = new Image();
    img.src = path;
}
function $20dc6939391e7f10$var$_temp2(paths) {
    paths.forEach($20dc6939391e7f10$var$_temp);
}
module.exports["AIUpsell"] = $20dc6939391e7f10$export$38f23d3987aa9723;

});

parcelRegister("lHQAj", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $4WmbV = parcelRequire("4WmbV");

const $5558feba06e8dbf9$export$60332b2344f7fe41 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== children) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, children);
        $[3] = children;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
            ...props,
            withTasteAndToneStyling: true,
            buttonGroupAlignment: "right"
        }));
        $[5] = props;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== t1 || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardLayout, null, t1, t2);
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardLayout, null, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        ...props,
        withTasteAndToneStyling: true,
        buttonGroupAlignment: "right"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardLayout = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _4cvr1h6o _bfhk1bhr _kqswh2mm",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _4cvr1h6o _bfhk1bhr _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardSectionMessageContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1yt41ejb _1wpz1fhb",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt41ejb _1wpz1fhb",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardContentsContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_18rx4jg8",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_18rx4jg8",
            __cmplp.className
        ])
    });
});
$5558feba06e8dbf9$var$CardContentsContainer.displayName = 'CardContentsContainer';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardWithBorderAndBox = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2rko12b0 _19itoecm _11q71bhr _1reo15vq _18m915vq _16qs130s",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2rko12b0 _19itoecm _11q71bhr _1reo15vq _18m915vq _16qs130s",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$export$8a23e74e5cf3ca41 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
module.exports["Card"] = $5558feba06e8dbf9$export$60332b2344f7fe41;
module.exports["CardContainer"] = $5558feba06e8dbf9$export$8a23e74e5cf3ca41;

});

parcelRegister("4WmbV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $7joZr = parcelRequire("7joZr");


var $a9aSv = parcelRequire("a9aSv");


var $1ytiN = parcelRequire("1ytiN");


var $5u7Ox = parcelRequire("5u7Ox");


var $iJ9aA = parcelRequire("iJ9aA");


var $ki6F7 = parcelRequire("ki6F7");


var $k4Vdy = parcelRequire("k4Vdy");


var $iC1wS = parcelRequire("iC1wS");


var $lNKOh = parcelRequire("lNKOh");


var $bhvFb = parcelRequire("bhvFb");

var $3a454656eb0e87cd$export$d33a80488b9cab17 = /*#__PURE__*/ function(SectionMessageButtonConfig) {
    SectionMessageButtonConfig["DEFAULT"] = "default";
    SectionMessageButtonConfig["UPGRADE_ONLY"] = "upgradeOnly";
    SectionMessageButtonConfig["NONE"] = "none";
    return SectionMessageButtonConfig;
}({});
const $3a454656eb0e87cd$export$2e68cfab3dc25476 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(65);
    let footer;
    let grandfathered;
    let headerButton;
    let learnMoreLink;
    let onRequestUpgradeButtonClick;
    let onUpFlowOpen;
    let props;
    let secondaryLink;
    let source;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let targetEdition;
    if ($[0] !== t0) {
        ({ canShowUpgradeButton: t1, buttonConfig: t2, upgradeEditionActionSubjectId: t3, grandfathered: grandfathered, source: source, onUpFlowOpen: onUpFlowOpen, secondaryLink: secondaryLink, targetEdition: targetEdition, learnMoreLink: learnMoreLink, footer: footer, headerButton: headerButton, showRequestUpgradeButton: t4, isLoadingRequestUpgradeButton: t5, onRequestUpgradeButtonClick: onRequestUpgradeButtonClick, requestUpgradeButtonIsLoading: t6, ...props } = t0);
        $[0] = t0;
        $[1] = footer;
        $[2] = grandfathered;
        $[3] = headerButton;
        $[4] = learnMoreLink;
        $[5] = onRequestUpgradeButtonClick;
        $[6] = onUpFlowOpen;
        $[7] = props;
        $[8] = secondaryLink;
        $[9] = source;
        $[10] = t1;
        $[11] = t2;
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
        $[15] = t6;
        $[16] = targetEdition;
    } else {
        footer = $[1];
        grandfathered = $[2];
        headerButton = $[3];
        learnMoreLink = $[4];
        onRequestUpgradeButtonClick = $[5];
        onUpFlowOpen = $[6];
        props = $[7];
        secondaryLink = $[8];
        source = $[9];
        t1 = $[10];
        t2 = $[11];
        t3 = $[12];
        t4 = $[13];
        t5 = $[14];
        t6 = $[15];
        targetEdition = $[16];
    }
    const canShowUpgradeButton = t1 === undefined ? true : t1;
    const buttonConfig = t2 === undefined ? "default" : t2;
    const upgradeEditionActionSubjectId = t3 === undefined ? "freeTryNow" : t3;
    const showRequestUpgradeButton = t4 === undefined ? false : t4;
    const isLoadingRequestUpgradeButton = t5 === undefined ? false : t5;
    const requestUpgradeButtonIsLoading = t6 === undefined ? false : t6;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const t7 = Boolean(grandfathered);
    let t8;
    if ($[17] !== isSiteAdmin || $[18] !== t7) {
        t8 = {
            isSiteAdmin: isSiteAdmin,
            isGrandfathered: t7
        };
        $[17] = isSiteAdmin;
        $[18] = t7;
        $[19] = t8;
    } else t8 = $[19];
    const CTAAnalyticsAttributes = t8;
    let t9;
    if ($[20] !== CTAAnalyticsAttributes || $[21] !== source) {
        t9 = (actionSubjectId)=>({
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: CTAAnalyticsAttributes
            });
        $[20] = CTAAnalyticsAttributes;
        $[21] = source;
        $[22] = t9;
    } else t9 = $[22];
    const generateCTAAnalyticsProps = t9;
    let t10;
    if ($[23] !== CTAAnalyticsAttributes || $[24] !== createAnalyticsEvent || $[25] !== source) {
        t10 = (clickEventActionSubjectId, linkMessage)=>{
            if (createAnalyticsEvent) createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "link",
                    actionSubjectId: clickEventActionSubjectId,
                    source: source,
                    attributes: {
                        ...CTAAnalyticsAttributes,
                        linkMessage: linkMessage
                    }
                }
            }).fire();
        };
        $[23] = CTAAnalyticsAttributes;
        $[24] = createAnalyticsEvent;
        $[25] = source;
        $[26] = t10;
    } else t10 = $[26];
    const triggerLinkClickAnalytics = t10;
    let t11;
    if ($[27] !== secondaryLink || $[28] !== triggerLinkClickAnalytics) {
        t11 = ()=>{
            const link = secondaryLink;
            if (link) {
                triggerLinkClickAnalytics(link.actionSubjectId, link.messageDescriptor.defaultMessage);
                if (typeof link.onClick === "function") link.onClick();
            }
        };
        $[27] = secondaryLink;
        $[28] = triggerLinkClickAnalytics;
        $[29] = t11;
    } else t11 = $[29];
    const handleSecondaryLinkClick = t11;
    let t12;
    let t13;
    if ($[30] !== CTAAnalyticsAttributes || $[31] !== createAnalyticsEvent || $[32] !== source) {
        t12 = ()=>{
            if (createAnalyticsEvent) createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "changeEditionGatewayScreen",
                    attributes: {
                        ...CTAAnalyticsAttributes,
                        source: source
                    }
                }
            }).fire();
        };
        t13 = [
            createAnalyticsEvent,
            CTAAnalyticsAttributes,
            source
        ];
        $[30] = CTAAnalyticsAttributes;
        $[31] = createAnalyticsEvent;
        $[32] = source;
        $[33] = t12;
        $[34] = t13;
    } else {
        t12 = $[33];
        t13 = $[34];
    }
    (0, $cozmU.useEffect)(t12, t13);
    let T0;
    let t14;
    if ($[35] !== buttonConfig || $[36] !== canShowUpgradeButton || $[37] !== generateCTAAnalyticsProps || $[38] !== handleSecondaryLinkClick || $[39] !== isLoadingRequestUpgradeButton || $[40] !== isSiteAdmin || $[41] !== learnMoreLink || $[42] !== onRequestUpgradeButtonClick || $[43] !== onUpFlowOpen || $[44] !== props || $[45] !== requestUpgradeButtonIsLoading || $[46] !== secondaryLink || $[47] !== showRequestUpgradeButton || $[48] !== source || $[49] !== targetEdition || $[50] !== upgradeEditionActionSubjectId) {
        const renderButtons = ()=>{
            if (isLoadingRequestUpgradeButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                testId: "loading-end-user-request-upgrade-button-skeleton",
                width: "200px",
                height: "32px"
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lNKOh.ChangeEditionSectionMessageButtonsWrapper), {
                isSiteAdmin: isSiteAdmin,
                canShowUpgradeButton: canShowUpgradeButton,
                shouldShowLearnMore: !secondaryLink,
                showRequestUpgradeButton: showRequestUpgradeButton
            }, (t15)=>{
                const { showUpgradeTryNowButton: showUpgradeTryNowButton, showLearnMore: showLearnMore, learnMoreIsPrimaryCTA: learnMoreIsPrimaryCTA } = t15;
                let primary;
                const upgradeEditionButton = showUpgradeTryNowButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ki6F7.UpgradeEditionButton), {
                    analyticsProps: generateCTAAnalyticsProps(upgradeEditionActionSubjectId),
                    onUpFlowOpen: onUpFlowOpen,
                    targetEdition: targetEdition,
                    ...props
                }) : null;
                if (upgradeEditionButton) primary = upgradeEditionButton;
                else if (showRequestUpgradeButton) primary = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5u7Ox.EndUserRequestUpgradeButton), {
                    source: source,
                    onRequestUpgradeButtonClick: onRequestUpgradeButtonClick,
                    requestUpgradeButtonIsLoading: requestUpgradeButtonIsLoading
                });
                let secondaries;
                if (buttonConfig !== "upgradeOnly" || !isSiteAdmin) {
                    if (upgradeEditionButton && primary !== upgradeEditionButton) secondaries = [
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(upgradeEditionButton, {
                            appearance: "link"
                        })
                    ];
                    else secondaries = getSecondaries(showLearnMore, learnMoreIsPrimaryCTA);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, primary, secondaries);
            });
        };
        const getSecondaries = (showLearnMore_0, learnMoreIsPrimaryCTA_0)=>{
            const withIcon = Boolean(learnMoreLink?.icon);
            const learnMoreAppearance = withIcon || learnMoreIsPrimaryCTA_0 ? learnMoreLink?.appearance || "default" : "link";
            const learnMoreButton = showLearnMore_0 ? renderLearnMoreLink({
                appearance: learnMoreAppearance
            }) : null;
            const secondaryLinkComponent = secondaryLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                key: "secondLink",
                appearance: secondaryLink.appearance || "default",
                href: secondaryLink.href ? secondaryLink.href : undefined,
                id: "secondaryLink",
                spacing: "default",
                target: secondaryLink.target || "_blank",
                onClick: handleSecondaryLinkClick,
                testId: (0, $k4Vdy.calculateTestId)({
                    source: source,
                    actionSubjectId: secondaryLink.actionSubjectId
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), secondaryLink.messageDescriptor)) : null;
            return secondaryLink?.appearance === "primary" && learnMoreAppearance !== "primary" ? [
                secondaryLinkComponent,
                learnMoreButton
            ] : [
                learnMoreButton,
                secondaryLinkComponent
            ];
        };
        const renderLearnMoreLink = (t16)=>{
            const { children: children, ...learnMoreProps } = t16;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJ9aA.LearnMoreButton), {
                key: "learnMore",
                analyticsProps: generateCTAAnalyticsProps(learnMoreLink?.actionSubjectId || "freeLearnMore"),
                appearance: learnMoreLink?.appearance || "default",
                onUpFlowOpen: onUpFlowOpen,
                targetEdition: targetEdition,
                inProductHelpId: learnMoreLink?.inProductHelpId,
                inProductHelpTopic: learnMoreLink?.inProductHelpTopic,
                href: learnMoreLink?.href,
                icon: learnMoreLink?.icon,
                ariaLabel: learnMoreLink?.ariaLabel,
                ...learnMoreProps,
                onClick: learnMoreLink?.onClick
            }, children !== undefined ? children : learnMoreLink?.messageDescriptor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), learnMoreLink.messageDescriptor) : undefined);
        };
        T0 = (0, $bhvFb.EditionSectionMessage);
        t14 = buttonConfig !== "none" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7joZr.default), null, renderButtons()) : undefined;
        $[35] = buttonConfig;
        $[36] = canShowUpgradeButton;
        $[37] = generateCTAAnalyticsProps;
        $[38] = handleSecondaryLinkClick;
        $[39] = isLoadingRequestUpgradeButton;
        $[40] = isSiteAdmin;
        $[41] = learnMoreLink;
        $[42] = onRequestUpgradeButtonClick;
        $[43] = onUpFlowOpen;
        $[44] = props;
        $[45] = requestUpgradeButtonIsLoading;
        $[46] = secondaryLink;
        $[47] = showRequestUpgradeButton;
        $[48] = source;
        $[49] = targetEdition;
        $[50] = upgradeEditionActionSubjectId;
        $[51] = T0;
        $[52] = t14;
    } else {
        T0 = $[51];
        t14 = $[52];
    }
    let t15;
    if ($[53] !== footer || $[54] !== isSiteAdmin) {
        t15 = isSiteAdmin && footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, footer) : null;
        $[53] = footer;
        $[54] = isSiteAdmin;
        $[55] = t15;
    } else t15 = $[55];
    let t16;
    if ($[56] !== headerButton) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7joZr.default), null, headerButton);
        $[56] = headerButton;
        $[57] = t16;
    } else t16 = $[57];
    let t17;
    if ($[58] !== T0 || $[59] !== props || $[60] !== t14 || $[61] !== t15 || $[62] !== t16 || $[63] !== targetEdition) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            actions: t14,
            edition: targetEdition,
            footer: t15,
            headerButton: t16,
            ...props
        });
        $[58] = T0;
        $[59] = props;
        $[60] = t14;
        $[61] = t15;
        $[62] = t16;
        $[63] = targetEdition;
        $[64] = t17;
    } else t17 = $[64];
    return t17;
} : ({ canShowUpgradeButton: canShowUpgradeButton = true, buttonConfig: buttonConfig = "default", upgradeEditionActionSubjectId: upgradeEditionActionSubjectId = 'freeTryNow', grandfathered: grandfathered, source: source, onUpFlowOpen: onUpFlowOpen, secondaryLink: secondaryLink, targetEdition: targetEdition, learnMoreLink: learnMoreLink, footer: footer, headerButton: headerButton, showRequestUpgradeButton: showRequestUpgradeButton = false, isLoadingRequestUpgradeButton: isLoadingRequestUpgradeButton = false, onRequestUpgradeButtonClick: onRequestUpgradeButtonClick, requestUpgradeButtonIsLoading: requestUpgradeButtonIsLoading = false, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const CTAAnalyticsAttributes = (0, $cozmU.useMemo)(()=>{
        return {
            isSiteAdmin: isSiteAdmin,
            isGrandfathered: Boolean(grandfathered)
        };
    }, [
        grandfathered,
        isSiteAdmin
    ]);
    const generateCTAAnalyticsProps = (actionSubjectId)=>({
            actionSubjectId: actionSubjectId,
            source: source,
            attributes: CTAAnalyticsAttributes
        });
    const triggerLinkClickAnalytics = (clickEventActionSubjectId, linkMessage)=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: clickEventActionSubjectId,
                source: source,
                attributes: {
                    ...CTAAnalyticsAttributes,
                    linkMessage: linkMessage
                }
            }
        }).fire();
    };
    const handleSecondaryLinkClick = ()=>{
        const link = secondaryLink;
        if (link) {
            triggerLinkClickAnalytics(link.actionSubjectId, link.messageDescriptor.defaultMessage);
            if (typeof link.onClick === 'function') link.onClick();
        }
    };
    (0, $cozmU.useEffect)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'changeEditionGatewayScreen',
                attributes: {
                    ...CTAAnalyticsAttributes,
                    source: source
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        CTAAnalyticsAttributes,
        source
    ]);
    const renderButtons = ()=>{
        if (isLoadingRequestUpgradeButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            testId: "loading-end-user-request-upgrade-button-skeleton",
            width: "200px",
            height: "32px"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lNKOh.ChangeEditionSectionMessageButtonsWrapper), {
            isSiteAdmin: isSiteAdmin,
            canShowUpgradeButton: canShowUpgradeButton,
            shouldShowLearnMore: !secondaryLink,
            showRequestUpgradeButton: showRequestUpgradeButton
        }, ({ showUpgradeTryNowButton: showUpgradeTryNowButton, showLearnMore: showLearnMore, learnMoreIsPrimaryCTA: learnMoreIsPrimaryCTA })=>{
            //
            // primary
            //
            let primary;
            const upgradeEditionButton = showUpgradeTryNowButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ki6F7.UpgradeEditionButton), {
                analyticsProps: generateCTAAnalyticsProps(upgradeEditionActionSubjectId),
                onUpFlowOpen: onUpFlowOpen,
                targetEdition: targetEdition,
                ...props
            }) : null;
            if (upgradeEditionButton) primary = upgradeEditionButton;
            else if (showRequestUpgradeButton) primary = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5u7Ox.EndUserRequestUpgradeButton), {
                source: source,
                onRequestUpgradeButtonClick: onRequestUpgradeButtonClick,
                requestUpgradeButtonIsLoading: requestUpgradeButtonIsLoading
            });
            //
            // secondaries
            //
            let secondaries;
            if (buttonConfig !== "upgradeOnly" || !isSiteAdmin) {
                // If the 'Try it free/now' button is to be shown, but it is not the
                // primary CTA, then make sure its appearance is appropriate for a
                // secondary:
                if (upgradeEditionButton && primary !== upgradeEditionButton) secondaries = [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(upgradeEditionButton, {
                        appearance: 'link'
                    })
                ];
                else secondaries = getSecondaries(showLearnMore, learnMoreIsPrimaryCTA);
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, primary, secondaries);
        });
    };
    const getSecondaries = (showLearnMore_0, learnMoreIsPrimaryCTA_0)=>{
        const withIcon = Boolean(learnMoreLink?.icon);
        const learnMoreAppearance = withIcon || learnMoreIsPrimaryCTA_0 ? learnMoreLink?.appearance || 'default' : 'link';
        const learnMoreButton = showLearnMore_0 ? renderLearnMoreLink({
            appearance: learnMoreAppearance
        }) : null;
        const secondaryLinkComponent = secondaryLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            key: "secondLink",
            appearance: secondaryLink.appearance || 'default',
            href: secondaryLink.href ? secondaryLink.href : undefined,
            id: "secondaryLink",
            spacing: "default",
            target: secondaryLink.target || '_blank',
            onClick: handleSecondaryLinkClick,
            testId: (0, $k4Vdy.calculateTestId)({
                source: source,
                actionSubjectId: secondaryLink.actionSubjectId
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), secondaryLink.messageDescriptor)) : null;
        return secondaryLink?.appearance === 'primary' && learnMoreAppearance !== 'primary' ? [
            secondaryLinkComponent,
            learnMoreButton
        ] : [
            learnMoreButton,
            secondaryLinkComponent
        ];
    };
    const renderLearnMoreLink = ({ children: children, ...learnMoreProps })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJ9aA.LearnMoreButton), {
            key: "learnMore",
            analyticsProps: generateCTAAnalyticsProps(learnMoreLink?.actionSubjectId || 'freeLearnMore'),
            appearance: learnMoreLink?.appearance || 'default',
            onUpFlowOpen: onUpFlowOpen,
            targetEdition: targetEdition,
            inProductHelpId: learnMoreLink?.inProductHelpId,
            inProductHelpTopic: learnMoreLink?.inProductHelpTopic,
            href: learnMoreLink?.href,
            icon: learnMoreLink?.icon,
            ariaLabel: learnMoreLink?.ariaLabel,
            ...learnMoreProps,
            onClick: learnMoreLink?.onClick
        }, children !== undefined ? children : learnMoreLink?.messageDescriptor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), learnMoreLink.messageDescriptor) : undefined);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bhvFb.EditionSectionMessage), {
        actions: buttonConfig !== "none" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7joZr.default), null, renderButtons()) : undefined,
        edition: targetEdition,
        footer: isSiteAdmin && footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, footer) : null,
        headerButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7joZr.default), null, headerButton),
        ...props
    });
};
module.exports["SectionMessageButtonConfig"] = $3a454656eb0e87cd$export$d33a80488b9cab17;
module.exports["ChangeEditionSectionMessage"] = $3a454656eb0e87cd$export$2e68cfab3dc25476;

});

parcelRegister("5u7Ox", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $aRGok = parcelRequire("aRGok");


var $9DHhW = parcelRequire("9DHhW");


var $4PPzL = parcelRequire("4PPzL");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $TCbX7 = parcelRequire("TCbX7");


var $bZmiL = parcelRequire("bZmiL");

const $125b05aca1e71376$export$ccc7e3a47fa3a9b0 = ({ source: source, requestUpgradeButtonIsLoading: requestUpgradeButtonIsLoading = false, onRequestUpgradeButtonClick: onRequestUpgradeButtonClick })=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const hasSentViewedEvent = (0, $cozmU.useRef)(false);
    const [showModal, setShowModal] = (0, $cozmU.useState)(false);
    const [isLoadingModal, setIsLoadingModal] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleCloseModal = ()=>{
        setShowModal(false);
    };
    const handleOpenModal = ()=>{
        if (onRequestUpgradeButtonClick) // If onRequestUpgradeButtonClick is provided, call it let it handle the modal opening
        onRequestUpgradeButtonClick();
        else {
            setIsLoadingModal(true);
            setShowModal(true);
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'endUserRequestUpgradeButton',
                source: source,
                attributes: {
                    ...(0, $bZmiL.editionAnalytics)(edition)
                }
            }
        }).fire();
    };
    (0, $cozmU.useEffect)(()=>{
        if (hasSentViewedEvent.current) return;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'viewed',
                actionSubject: 'button',
                actionSubjectId: 'endUserRequestUpgradeButton',
                source: source,
                attributes: {
                    ...(0, $bZmiL.editionAnalytics)(edition)
                }
            }
        }).fire();
        hasSentViewedEvent.current = true;
    }, [
        createAnalyticsEvent,
        edition,
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: edition === (0, $d9tcB.ConfluenceEdition).STANDARD ? 'growth-luna' : 'growth-transmuters'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        testId: "experiment-confluence-enable-end-user-request.request-upgrade-button",
        onClick: handleOpenModal,
        appearance: "primary",
        isLoading: isLoadingModal || requestUpgradeButtonIsLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "experiment-confluence-enable-end-user-request.request-upgrade-button.label",
        defaultMessage: "Request to try"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, showModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $TCbX7.EndUserRequestUpgradeModalEntrypoint), {
        source: source,
        handleCloseModal: handleCloseModal,
        setIsLoadingModal: setIsLoadingModal
    })));
};
module.exports["EndUserRequestUpgradeButton"] = $125b05aca1e71376$export$ccc7e3a47fa3a9b0;

});

parcelRegister("TCbX7", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2d60c82434c5c2c8$export$8512e09daabbe9d7 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "i-AMj",
    name: "EndUserRequestUpgradeModalEntrypoint",
    loader: async ()=>(await (parcelRequire("iohb3"))).EndUserRequestUpgradeModal
});
module.exports["EndUserRequestUpgradeModalEntrypoint"] = $2d60c82434c5c2c8$export$8512e09daabbe9d7;

});

parcelRegister("iohb3", function(module, exports) {

let $d637caee764ab118$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d637caee764ab118$var$load("iUXaE"),
    $d637caee764ab118$var$load("lTkx9"),
    $d637caee764ab118$var$load("6wr18"),
    $d637caee764ab118$var$load("dxcsb"),
    $d637caee764ab118$var$load("99ObF"),
    $d637caee764ab118$var$load("Wowvf"),
    $d637caee764ab118$var$load("ffEVr"),
    $d637caee764ab118$var$load("jZMUd"),
    $d637caee764ab118$var$load("hhss7"),
    $d637caee764ab118$var$load("eRrWU")
]).then(()=>parcelRequire('4YFRT'));

});

parcelRegister("bZmiL", function(module, exports) {

var $7L1H0 = parcelRequire("7L1H0");

const $ac662e4699f149b2$export$a6ecd874f477affc = (edition)=>({
        currentProductEdition: (0, $7L1H0.mapConfluenceEditionToSupportedCurrentEdition)(edition)
    });
module.exports["editionAnalytics"] = $ac662e4699f149b2$export$a6ecd874f477affc;

});

parcelRegister("7L1H0", function(module, exports) {

var $d9tcB = parcelRequire("d9tcB");

const $4f5583827653668a$var$supportedCurrentEditionsMap = {
    [(0, $d9tcB.ConfluenceEdition).FREE]: 'free',
    [(0, $d9tcB.ConfluenceEdition).STANDARD]: 'standard'
};
const $4f5583827653668a$var$isSupportedEdition = (edition)=>{
    return edition in $4f5583827653668a$var$supportedCurrentEditionsMap;
};
const $4f5583827653668a$export$b48897de0c2497d9 = (edition)=>{
    if (!edition || !$4f5583827653668a$var$isSupportedEdition(edition)) return undefined;
    return $4f5583827653668a$var$supportedCurrentEditionsMap[edition];
};
module.exports["mapConfluenceEditionToSupportedCurrentEdition"] = $4f5583827653668a$export$b48897de0c2497d9;

});

parcelRegister("iJ9aA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $jd2pZ = parcelRequire("jd2pZ");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $2KmnS = parcelRequire("2KmnS");


var $bQm3c = parcelRequire("bQm3c");


var $f7tt0 = parcelRequire("f7tt0");


var $gsZdA = parcelRequire("gsZdA");


var $f7Bnv = parcelRequire("f7Bnv");


var $iC1wS = parcelRequire("iC1wS");


var $euL71 = parcelRequire("euL71");


var $e5k34 = parcelRequire("e5k34");


var $k4Vdy = parcelRequire("k4Vdy");

const $c00269aedb3a5e7e$var$inProductHelpButtonWithPadding = (0, $buxP3.xcss)({
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    margin: 'auto'
});
const $c00269aedb3a5e7e$var$inProductHelpButtonWithoutPadding = (0, $buxP3.xcss)({
    padding: 'space.0'
});
const $c00269aedb3a5e7e$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    tryItFree: {
        id: "change-edition.section.message.try.free",
        defaultMessage: "Try it free"
    },
    learnMoreButton: {
        id: "change-edition.section.message.general.button.link",
        defaultMessage: "Learn more"
    }
});
const $c00269aedb3a5e7e$export$628b38b203828231 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(40);
    let { analyticsProps: analyticsProps, appearance: appearance, isSiteAdmin: isSiteAdmin, onUpFlowOpen: onUpFlowOpen, targetEdition: t1, isGrandfathered: t2, inProductHelpId: inProductHelpId, inProductHelpTopic: inProductHelpTopic, href: href, children: children, icon: icon, onClick: onClick, ariaLabel: ariaLabel, ...learnMoreProps } = t0;
    const targetEdition = t1 === undefined ? (0, $euL71.ConfluenceEdition).STANDARD : t1;
    const isGrandfathered = t2 === undefined ? false : t2;
    const intl = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId, edition: edition, userId: userId, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const [isUpFlowOpen, setIsUpFlowOpen] = (0, $cozmU.useState)(false);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const showUpFlow = isLicensed && (!isSiteAdmin || edition === (0, $euL71.ConfluenceEdition).FREE);
    const { source: source, actionSubjectId: actionSubjectId } = analyticsProps;
    const testId = (0, $k4Vdy.calculateTestId)({
        source: source,
        actionSubjectId: actionSubjectId
    });
    let t3;
    if ($[0] !== children) {
        t3 = children !== undefined ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton);
        $[0] = children;
        $[1] = t3;
    } else t3 = $[1];
    const message = t3;
    const iconOnly = icon && !message;
    let t4;
    let t5;
    if ($[2] !== experienceTracker || $[3] !== showUpFlow) {
        t4 = ()=>()=>{
                if (!showUpFlow) experienceTracker.abort({
                    name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                    reason: "Canceled by user"
                });
            };
        t5 = [
            experienceTracker,
            showUpFlow
        ];
        $[2] = experienceTracker;
        $[3] = showUpFlow;
        $[4] = t4;
        $[5] = t5;
    } else {
        t4 = $[4];
        t5 = $[5];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[6] !== actionSubjectId || $[7] !== analyticsProps || $[8] !== createAnalyticsEvent || $[9] !== edition || $[10] !== experienceTracker || $[11] !== isSiteAdmin || $[12] !== showUpFlow || $[13] !== source || $[14] !== targetEdition) {
        t6 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "link",
                    actionSubjectId: "freeLearnMore",
                    ...analyticsProps,
                    attributes: {
                        currentEdition: edition,
                        isSiteAdmin: isSiteAdmin,
                        linkMessage: $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton.defaultMessage,
                        targetEdition: targetEdition,
                        ...analyticsProps.attributes
                    }
                }
            }).fire();
            experienceTracker.start({
                name: showUpFlow ? (0, $irVI7.UPSELL_EDITION_UPFLOW_EXPERIENCE) : (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                attributes: {
                    currentEdition: edition,
                    linkClicked: actionSubjectId || "freeLearnMore",
                    source: source,
                    targetEdition: targetEdition
                }
            });
        };
        $[6] = actionSubjectId;
        $[7] = analyticsProps;
        $[8] = createAnalyticsEvent;
        $[9] = edition;
        $[10] = experienceTracker;
        $[11] = isSiteAdmin;
        $[12] = showUpFlow;
        $[13] = source;
        $[14] = targetEdition;
        $[15] = t6;
    } else t6 = $[15];
    const fireClickAnalytics = t6;
    let t7;
    if ($[16] !== onUpFlowOpen) {
        t7 = ()=>{
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($jd2pZ)))(onUpFlowOpen)) setIsUpFlowOpen(false);
        };
        $[16] = onUpFlowOpen;
        $[17] = t7;
    } else t7 = $[17];
    const onUpFlowClose = t7;
    const renderLearnMoreButton = (t8)=>{
        const props = t8 === undefined ? {} : t8;
        if (appearance === "inline-link") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", props, message);
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            appearance: appearance,
            className: appearance === "subtle-link" ? undefined : "primaryButton",
            id: "learnMoreLink",
            spacing: iconOnly ? "none" : "default",
            iconBefore: icon,
            testId: testId,
            ...props
        }, message);
    };
    let t9;
    if ($[18] !== createAnalyticsEvent || $[19] !== inProductHelpId) {
        t9 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "helpLink",
                    source: "adminKeyUpSell",
                    attributes: {
                        targetArticleId: inProductHelpId,
                        isSPA: true
                    }
                }
            }).fire();
        };
        $[18] = createAnalyticsEvent;
        $[19] = inProductHelpId;
        $[20] = t9;
    } else t9 = $[20];
    const fireAnalyticsEvent = t9;
    if (isGrandfathered && !isSiteAdmin) return null;
    if (!href) href = showUpFlow ? "#" : (0, $gsZdA.LEARN_MORE_LINK);
    const target = href.startsWith("#") ? undefined : "_blank";
    let t10;
    if ($[21] !== fireClickAnalytics || $[22] !== onClick || $[23] !== showUpFlow || $[24] !== target) {
        t10 = (ev)=>{
            fireClickAnalytics();
            if (onClick) {
                onClick();
                return;
            }
            if (!target && showUpFlow) {
                setIsUpFlowOpen(true);
                ev.preventDefault();
            }
        };
        $[21] = fireClickAnalytics;
        $[22] = onClick;
        $[23] = showUpFlow;
        $[24] = target;
        $[25] = t10;
    } else t10 = $[25];
    const buttonProps = {
        target: target,
        href: href,
        onClick: t10,
        "aria-label": ariaLabel && intl.formatMessage(ariaLabel),
        testId: testId,
        ...learnMoreProps
    };
    const t11 = !showUpFlow && inProductHelpId && inProductHelpTopic ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: iconOnly ? $c00269aedb3a5e7e$var$inProductHelpButtonWithoutPadding : $c00269aedb3a5e7e$var$inProductHelpButtonWithPadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f7tt0.InProductHelpButton), {
        articleId: inProductHelpId,
        onClick: fireAnalyticsEvent,
        articleTopic: inProductHelpTopic,
        testId: testId,
        ...learnMoreProps
    }, iconOnly ? icon : message)) : renderLearnMoreButton(buttonProps);
    let t12;
    if ($[26] !== cloudId || $[27] !== edition || $[28] !== isSiteAdmin || $[29] !== isUpFlowOpen || $[30] !== onUpFlowClose || $[31] !== onUpFlowOpen || $[32] !== showUpFlow || $[33] !== source || $[34] !== targetEdition || $[35] !== userId) {
        t12 = showUpFlow && isUpFlowOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e5k34.UpFlowCommerceRouterLoadable), {
            cloudId: cloudId,
            atlassianAccountId: userId || undefined,
            canChangeEdition: isSiteAdmin,
            currentEdition: edition || undefined,
            targetEdition: targetEdition,
            flow: (0, $2KmnS.UpFlowComponentFlowType).LEARN_MORE,
            product: "confluence",
            touchpointId: source,
            onClose: onUpFlowClose,
            onOpen: onUpFlowOpen,
            isExperienceTrackerEnabled: true,
            epMessageId: (0, $gsZdA.UP_FLOW_EP_MESSAGE_ID)
        });
        $[26] = cloudId;
        $[27] = edition;
        $[28] = isSiteAdmin;
        $[29] = isUpFlowOpen;
        $[30] = onUpFlowClose;
        $[31] = onUpFlowOpen;
        $[32] = showUpFlow;
        $[33] = source;
        $[34] = targetEdition;
        $[35] = userId;
        $[36] = t12;
    } else t12 = $[36];
    let t13;
    if ($[37] !== t11 || $[38] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t11, t12);
        $[37] = t11;
        $[38] = t12;
        $[39] = t13;
    } else t13 = $[39];
    return t13;
} : ({ analyticsProps: analyticsProps, appearance: appearance, isSiteAdmin: isSiteAdmin, onUpFlowOpen: onUpFlowOpen, targetEdition: targetEdition = (0, $euL71.ConfluenceEdition).STANDARD, isGrandfathered: isGrandfathered = false, inProductHelpId: inProductHelpId, inProductHelpTopic: inProductHelpTopic, href: href, children: children, icon: icon, onClick: onClick, ariaLabel: ariaLabel, ...learnMoreProps })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId, edition: edition, userId: userId, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const [isUpFlowOpen, setIsUpFlowOpen] = (0, $cozmU.useState)(false);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const showUpFlow = isLicensed && (!isSiteAdmin || edition === (0, $euL71.ConfluenceEdition).FREE);
    const { source: source, actionSubjectId: actionSubjectId } = analyticsProps;
    const testId = (0, $k4Vdy.calculateTestId)({
        source: source,
        actionSubjectId: actionSubjectId
    });
    const message = children !== undefined ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton);
    const iconOnly = icon && !message;
    (0, $cozmU.useEffect)(()=>()=>{
            if (!showUpFlow) experienceTracker.abort({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                reason: 'Canceled by user'
            });
        }, [
        experienceTracker,
        showUpFlow
    ]);
    const fireClickAnalytics = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'freeLearnMore',
                ...analyticsProps,
                attributes: {
                    currentEdition: edition,
                    isSiteAdmin: isSiteAdmin,
                    linkMessage: $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton.defaultMessage,
                    targetEdition: targetEdition,
                    ...analyticsProps.attributes
                }
            }
        }).fire();
        experienceTracker.start({
            name: showUpFlow ? (0, $irVI7.UPSELL_EDITION_UPFLOW_EXPERIENCE) : (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
            attributes: {
                currentEdition: edition,
                linkClicked: actionSubjectId || 'freeLearnMore',
                source: source,
                targetEdition: targetEdition
            }
        });
    };
    const onUpFlowClose = ()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($jd2pZ)))(onUpFlowOpen)) // only attempt to close if there is no onUpFlowOpen handler (as
        // UpFlowComponent will invoke it to unmount our parent already)
        setIsUpFlowOpen(false);
    };
    const renderLearnMoreButton = (props = {})=>{
        if (appearance === 'inline-link') return(// eslint-disable-next-line @atlaskit/design-system/no-html-anchor
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", props, message));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            appearance: appearance,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
            className: appearance === 'subtle-link' ? undefined : 'primaryButton',
            id: "learnMoreLink",
            spacing: iconOnly ? 'none' : 'default',
            iconBefore: icon,
            testId: testId,
            ...props
        }, message);
    };
    const fireAnalyticsEvent = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'helpLink',
                source: 'adminKeyUpSell',
                attributes: {
                    targetArticleId: inProductHelpId,
                    isSPA: true
                }
            }
        }).fire();
    };
    if (isGrandfathered && !isSiteAdmin) return null;
    // prioritizing href if it passed by the consumer regardless of edition type
    if (!href) href = showUpFlow ? '#' : (0, $gsZdA.LEARN_MORE_LINK);
    const target = href.startsWith('#') ? undefined : '_blank';
    const buttonProps = {
        target: target,
        href: href,
        onClick: (ev)=>{
            fireClickAnalytics();
            if (onClick) {
                onClick();
                return;
            }
            if (!target && showUpFlow) {
                setIsUpFlowOpen(true);
                ev.preventDefault();
            }
        },
        'aria-label': ariaLabel && intl.formatMessage(ariaLabel),
        testId: testId,
        ...learnMoreProps
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, !showUpFlow && inProductHelpId && inProductHelpTopic ? /**
     * Special handling In Product Help Button
     * InProductHelpButton force the spacing to none, thus creating a BOX here to add back the padding and margin
     */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: iconOnly ? $c00269aedb3a5e7e$var$inProductHelpButtonWithoutPadding : $c00269aedb3a5e7e$var$inProductHelpButtonWithPadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f7tt0.InProductHelpButton), {
        articleId: inProductHelpId,
        onClick: fireAnalyticsEvent,
        articleTopic: inProductHelpTopic,
        testId: testId,
        ...learnMoreProps
    }, iconOnly ? icon : message)) : renderLearnMoreButton(buttonProps), showUpFlow && isUpFlowOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e5k34.UpFlowCommerceRouterLoadable), {
        cloudId: cloudId,
        atlassianAccountId: userId || undefined,
        canChangeEdition: isSiteAdmin,
        currentEdition: edition || undefined,
        targetEdition: targetEdition,
        flow: (0, $2KmnS.UpFlowComponentFlowType).LEARN_MORE,
        product: "confluence",
        touchpointId: source,
        onClose: onUpFlowClose,
        onOpen: onUpFlowOpen,
        isExperienceTrackerEnabled: true,
        epMessageId: (0, $gsZdA.UP_FLOW_EP_MESSAGE_ID)
    }));
};
const $c00269aedb3a5e7e$export$176492db868efc7f = (0, $f7Bnv.withIsSiteAdmin)($c00269aedb3a5e7e$export$628b38b203828231);
module.exports["i18n"] = $c00269aedb3a5e7e$export$a7357cdd1f0b0168;
module.exports["LearnMoreButtonComponent"] = $c00269aedb3a5e7e$export$628b38b203828231;
module.exports["LearnMoreButton"] = $c00269aedb3a5e7e$export$176492db868efc7f;

});

parcelRegister("2KmnS", function(module, exports) {
var $af6754ea8048b03c$export$a719c036dcaa8cea = /*#__PURE__*/ function(UpFlowComponentFlowType) {
    UpFlowComponentFlowType["LEARN_MORE"] = "learn-more";
    UpFlowComponentFlowType["UPGRADE"] = "upgrade";
    UpFlowComponentFlowType["REQUEST_UPGRADE"] = "request-upgrade";
    UpFlowComponentFlowType["REQUEST_LEARN_MORE"] = "request-learn-more";
    return UpFlowComponentFlowType;
}({});
module.exports["UpFlowComponentFlowType"] = $af6754ea8048b03c$export$a719c036dcaa8cea;

});

parcelRegister("f7tt0", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d0dfdd35e9850cea$export$b14685a9b52779e1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "xD_n9",
    name: "InProductHelpButton",
    loader: async ()=>(await (parcelRequire("a77yF"))).InProductHelpButton
});
module.exports["InProductHelpButton"] = $d0dfdd35e9850cea$export$b14685a9b52779e1;

});

parcelRegister("a77yF", function(module, exports) {

let $75d06bbbb7d49c89$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $75d06bbbb7d49c89$var$load("idSqX"),
    $75d06bbbb7d49c89$var$load("82QsP")
]).then(()=>parcelRequire('lcEzf'));

});

parcelRegister("gsZdA", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ const $f57489e4f8cda39e$export$997e23a0aec74966 = 'https://confluence.atlassian.com/display/ConfCloud/Confluence+Cloud+plans';
var $f57489e4f8cda39e$export$fd53124e1292f3e0 = /*#__PURE__*/ function(SECTION_MESSAGE_APPEARANCE_TYPES) {
    SECTION_MESSAGE_APPEARANCE_TYPES["DEFAULT"] = "default";
    SECTION_MESSAGE_APPEARANCE_TYPES["FLAT"] = "flat";
    SECTION_MESSAGE_APPEARANCE_TYPES["INLINE"] = "inline";
    SECTION_MESSAGE_APPEARANCE_TYPES["INLINE_MODAL"] = "inline-modal";
    return SECTION_MESSAGE_APPEARANCE_TYPES;
}({});
const $f57489e4f8cda39e$export$9d01cd0779f8a694 = 'confluence-up-flow-modal';
module.exports["LEARN_MORE_LINK"] = $f57489e4f8cda39e$export$997e23a0aec74966;
module.exports["SECTION_MESSAGE_APPEARANCE_TYPES"] = $f57489e4f8cda39e$export$fd53124e1292f3e0;
module.exports["UP_FLOW_EP_MESSAGE_ID"] = $f57489e4f8cda39e$export$9d01cd0779f8a694;

});

parcelRegister("f7Bnv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1ytiN = parcelRequire("1ytiN");

function $7faf87d57bd98ac2$export$a3bfa6bb89ccecd5(WrappedComponent) {
    return function WithIsSiteAdminComponent(props) {
        const { isSiteAdmin: isSiteAdmin, error: error, loading: loading } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
        if (error || loading) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
            ...props,
            isSiteAdmin: isSiteAdmin
        });
    };
}
module.exports["withIsSiteAdmin"] = $7faf87d57bd98ac2$export$a3bfa6bb89ccecd5;

});

parcelRegister("iC1wS", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");

const $8ea1c6a3abbe8170$var$EditionsAnalyticsContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $8ea1c6a3abbe8170$export$198c73506737f848 = (payload, data)=>({
        ...payload,
        data: {
            ...payload.data,
            attributes: {
                ...payload.data.attributes,
                ...data?.customAttributes
            }
        }
    });
const $8ea1c6a3abbe8170$export$ce3e4b18be9c194b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(8);
    const internalData = (0, $cozmU.useContext)($8ea1c6a3abbe8170$var$EditionsAnalyticsContext);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== internalData) {
        t0 = (data)=>$8ea1c6a3abbe8170$export$198c73506737f848(data, internalData);
        $[0] = internalData;
        $[1] = t0;
    } else t0 = $[1];
    const wrapAnalyticsEventPayload = t0;
    let t1;
    if ($[2] !== createAnalyticsEvent || $[3] !== wrapAnalyticsEventPayload) {
        t1 = (initialPayload)=>createAnalyticsEvent(wrapAnalyticsEventPayload(initialPayload));
        $[2] = createAnalyticsEvent;
        $[3] = wrapAnalyticsEventPayload;
        $[4] = t1;
    } else t1 = $[4];
    const wrappedCreateAnalyticsEvent = t1;
    let t2;
    if ($[5] !== wrapAnalyticsEventPayload || $[6] !== wrappedCreateAnalyticsEvent) {
        t2 = {
            createAnalyticsEvent: wrappedCreateAnalyticsEvent,
            wrapAnalyticsEventPayload: wrapAnalyticsEventPayload
        };
        $[5] = wrapAnalyticsEventPayload;
        $[6] = wrappedCreateAnalyticsEvent;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ()=>{
    const internalData = (0, $cozmU.useContext)($8ea1c6a3abbe8170$var$EditionsAnalyticsContext);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const wrapAnalyticsEventPayload = (0, $cozmU.useCallback)((data)=>$8ea1c6a3abbe8170$export$198c73506737f848(data, internalData), [
        internalData
    ]);
    const wrappedCreateAnalyticsEvent = (0, $cozmU.useCallback)((initialPayload)=>createAnalyticsEvent(wrapAnalyticsEventPayload(initialPayload)), [
        createAnalyticsEvent,
        wrapAnalyticsEventPayload
    ]);
    return {
        createAnalyticsEvent: wrappedCreateAnalyticsEvent,
        wrapAnalyticsEventPayload: wrapAnalyticsEventPayload
    };
};
const $8ea1c6a3abbe8170$var$emptyAttributes = {};
const $8ea1c6a3abbe8170$export$1b581a2ec13e37f1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, customAttributes: t1 } = t0;
    const customAttributes = t1 === undefined ? $8ea1c6a3abbe8170$var$emptyAttributes : t1;
    let t2;
    if ($[0] !== customAttributes) {
        t2 = {
            customAttributes: customAttributes
        };
        $[0] = customAttributes;
        $[1] = t2;
    } else t2 = $[1];
    const editionsAnalyticsContextValue = t2;
    let t3;
    if ($[2] !== children || $[3] !== editionsAnalyticsContextValue) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8ea1c6a3abbe8170$var$EditionsAnalyticsContext.Provider, {
            value: editionsAnalyticsContextValue
        }, children);
        $[2] = children;
        $[3] = editionsAnalyticsContextValue;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ children: children, customAttributes: customAttributes = $8ea1c6a3abbe8170$var$emptyAttributes })=>{
    const editionsAnalyticsContextValue = (0, $cozmU.useMemo)(()=>({
            customAttributes: customAttributes
        }), [
        customAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8ea1c6a3abbe8170$var$EditionsAnalyticsContext.Provider, {
        value: editionsAnalyticsContextValue
    }, children);
};
const $8ea1c6a3abbe8170$export$19bbfac2f7120ab5 = (Component)=>{
    const WrappedComponent = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
        const $ = (0, $bDgLe.c)(3);
        const context = $8ea1c6a3abbe8170$export$ce3e4b18be9c194b();
        let t0;
        if ($[0] !== context || $[1] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                ...props,
                ...context
            });
            $[0] = context;
            $[1] = props;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    } : (props)=>{
        const context = $8ea1c6a3abbe8170$export$ce3e4b18be9c194b();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            ...props,
            ...context
        });
    };
    return WrappedComponent;
};
module.exports["useEditionsAnalyticsContext"] = $8ea1c6a3abbe8170$export$ce3e4b18be9c194b;
module.exports["AnalyticsProvider"] = $8ea1c6a3abbe8170$export$1b581a2ec13e37f1;

});

parcelRegister("k4Vdy", function(module, exports) {

var $gfV78 = parcelRequire("gfV78");

const $b05bae0ef566e919$export$b1556774836001f5 = ({ actionSubjectId: actionSubjectId, source: source })=>actionSubjectId !== undefined ? `${source}${(0, (/*@__PURE__*/$parcel$interopDefault($gfV78)))(actionSubjectId)}` : undefined;
module.exports["calculateTestId"] = $b05bae0ef566e919$export$b1556774836001f5;

});

parcelRegister("ki6F7", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $ey6Pt = parcelRequire("ey6Pt");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $8QJDy = parcelRequire("8QJDy");


var $ad7Ou = parcelRequire("ad7Ou");


var $5SGpQ = parcelRequire("5SGpQ");


var $2NUGZ = parcelRequire("2NUGZ");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $fGzMp = parcelRequire("fGzMp");


var $b3j2Y = parcelRequire("b3j2Y");


var $bQm3c = parcelRequire("bQm3c");


var $ij4CE = parcelRequire("ij4CE");


var $9wGTI = parcelRequire("9wGTI");


var $dqdrq = parcelRequire("dqdrq");


var $ktelT = parcelRequire("ktelT");


var $2UjZJ = parcelRequire("2UjZJ");


var $gsZdA = parcelRequire("gsZdA");


var $5M47w = parcelRequire("5M47w");


var $l0DoV = parcelRequire("l0DoV");


var $euL71 = parcelRequire("euL71");


var $e5k34 = parcelRequire("e5k34");


var $fDbEj = parcelRequire("fDbEj");


var $k4Vdy = parcelRequire("k4Vdy");


var $iC1wS = parcelRequire("iC1wS");





var $iAMak = parcelRequire("iAMak");


var $7VDbW = parcelRequire("7VDbW");


var $jW145 = parcelRequire("jW145");

const $3615035320db7a8b$var$i18n = (0, $kSwu1.defineMessages)({
    tryItFree: {
        id: "change-edition.upgrade.try.free",
        defaultMessage: "Try it free"
    },
    tryItNow: {
        id: "change-edition.upgrade.try.now",
        defaultMessage: "Try it now"
    },
    tryPremium: {
        id: "change-edition.upgrade.try.premium",
        defaultMessage: "Try Premium"
    }
});
const $3615035320db7a8b$export$bfc8da995ea49800 = (appearance)=>{
    if (appearance === 'primary') return 0, $dqdrq.GradientCTAButton;
    if (appearance === 'subtle-link') return 0, $ktelT.GradientSubtleLinkButton;
    return 0, $5SGpQ.default;
};
const $3615035320db7a8b$var$editionMap = {
    [(0, $euL71.ConfluenceEdition).FREE]: (0, $5M47w.CommerceDeepLinksTargetEdition).FREE,
    [(0, $euL71.ConfluenceEdition).STANDARD]: (0, $5M47w.CommerceDeepLinksTargetEdition).STANDARD,
    [(0, $euL71.ConfluenceEdition).PREMIUM]: (0, $5M47w.CommerceDeepLinksTargetEdition).PREMIUM
};
const $3615035320db7a8b$var$extractUpsellDeepLink = (deepLink)=>{
    // If deepLink is not a string, return error type for debugging
    if (!deepLink) return undefined;
    if (typeof deepLink !== 'string') return `ERROR_TYPE:${typeof deepLink}`;
    // Extract the base URL without query parameters
    return deepLink.split('?')[0];
};
/**
 * @deprecated Please reach out to #cc-ai-growth for details before use. Please read https://hello.atlassian.net/wiki/spaces/CE2/pages/2797298237/Contribution+Consumption+Guidelines+For+Common+Feature+Gate+Upsell+Component
 */ const $3615035320db7a8b$var$UpgradeEditionButtonLegacy = ({ analyticsProps: { actionSubjectId: actionSubjectId, attributes: attributes, source: source }, appearance: appearance = 'primary', children: children, onUpFlowOpen: onUpFlowOpen, targetEdition: targetEdition = (0, $euL71.ConfluenceEdition).STANDARD, onUpgradeButtonClick: onUpgradeButtonClick })=>{
    const [openUpFlow, setOpenUpFlow] = (0, $cozmU.useState)(false);
    const [pollingError, setPollingError] = (0, $cozmU.useState)();
    const { cloudId: cloudId, edition: currentEdition, userId: userId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $ey6Pt.default),
        fragmentArtifact: (0, $ey6Pt.default),
        __callerPackage__: "change-edition"
    });
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    // free -> standard: upflow spa;
    // free/standard -> premium: adminhub
    const showUpFlow = targetEdition === (0, $euL71.ConfluenceEdition).STANDARD;
    const { cohort: upflowV2ExperimentCohort, isSiteAdmin: isSiteAdmin, isBillingAdmin: isBillingAdmin, loading: upflowV2EligibilityHookLoading } = (0, $2UjZJ.useUpflowV2ConfluenceStandardFGsExperiment)({
        skip: !showUpFlow || !openUpFlow,
        touchpointId: source,
        currentEdition: currentEdition,
        targetEdition: targetEdition
    });
    const { commerceBackendName: commerceBackendName, planConsentDeepLink: planConsentDeepLink, errorMessage: commerceDeepLinksError } = (0, $5M47w.useCommerceDeepLinks)({
        targetEdition: $3615035320db7a8b$var$editionMap[targetEdition],
        skipDeepLinks: showUpFlow
    });
    (0, $cozmU.useEffect)(()=>()=>{
            // 1. With upflow enabled, when the user clicks on the upgrade CTA, the
            //    upflow dialog opens and this component unmounts; the upsell experience
            //    continues and experience tracking is subsequently handled by the
            //    UpFlow component.
            // or
            // 2. With upflow DISabled, unmounting here simply means user navigated away
            //    from the upsell UI and we DO want to signal an aborted experience.
            if (!showUpFlow) experienceTracker.abort({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                reason: 'Canceled by user'
            });
        }, [
        experienceTracker,
        showUpFlow
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Using a TRACK event for tacking the traffic to the UpgradeEditionButton.
        // This will help us gauage Commerce API traffic to compute the deep links.
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'rendered',
                actionSubject: 'upgradeEditionButton',
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: {
                    ...attributes,
                    currentEdition: currentEdition,
                    targetEdition: targetEdition
                }
            }
        }).fire();
    // We only need this to fire once, when the component mounts
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const fireClickAnalytics = ()=>{
        if (attributes) {
            attributes.currentEdition = currentEdition;
            attributes.targetEdition = targetEdition;
            attributes.commerceBackend = commerceBackendName;
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: attributes
            }
        }).fire();
        if (commerceDeepLinksError) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'errored',
                actionSubject: 'useCommerceDeepLinks',
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: {
                    ...attributes,
                    currentEdition: currentEdition,
                    targetEdition: targetEdition,
                    upsellDeepLink: $3615035320db7a8b$var$extractUpsellDeepLink(planConsentDeepLink),
                    errorMessage: commerceDeepLinksError
                }
            }
        }).fire();
    };
    const onTryWithoutUpFlowClick = async ()=>{
        if (onUpgradeButtonClick) onUpgradeButtonClick();
        // start polling and reload the page when done
        try {
            const updatedEdition = await (0, $fDbEj.waitForEditionChange)(currentEdition, writeFragmentInterop);
            experienceTracker.succeed({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                attributes: {
                    currentEdition: currentEdition,
                    targetEdition: updatedEdition
                }
            });
            // Default behavior
            window.location.reload();
        } catch (error) {
            if (error === (0, $fDbEj.TimeoutError)) // We don't expect the user to always proceed to upgrade in Admin Hub after seeing the estimated billing info.
            experienceTracker.abort({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                reason: 'Possibly canceled by user'
            });
            else {
                (0, $fGzMp.stopExperienceOnError)((0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE), error);
                setPollingError(error);
            }
        }
    };
    const onUpFlowClose = ()=>{
        setOpenUpFlow(false);
    };
    const onTryButtonClick = ()=>{
        // we always want to fire both the exposure event as well as the click event
        fireClickAnalytics();
        // start the experience tracker
        experienceTracker.start({
            name: showUpFlow ? (0, $irVI7.UPSELL_EDITION_UPFLOW_EXPERIENCE) : (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
            attributes: {
                currentEdition: currentEdition,
                linkClicked: actionSubjectId,
                source: source,
                targetEdition: targetEdition
            }
        });
        // then handle the click behaviour based on FF
        if (showUpFlow) setOpenUpFlow(true);
        else onTryWithoutUpFlowClick();
    };
    const buttonProps = {
        appearance: appearance,
        className: 'primaryButton',
        href: showUpFlow ? undefined : planConsentDeepLink,
        onClick: onTryButtonClick,
        target: showUpFlow ? undefined : '_blank',
        iconBefore: appearance === 'primary' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NUGZ))), {
            label: "",
            color: "var(--ds-icon-inverse, #FFFFFF)"
        }) : undefined,
        testId: (0, $k4Vdy.calculateTestId)({
            source: source,
            actionSubjectId: actionSubjectId
        })
    };
    const upflowV2ExperimentButtonProps = {
        appearance: appearance,
        testId: 'upflowV2ExperimentLoadingButton',
        isDisabled: true,
        isLoading: true,
        iconBefore: appearance === 'primary' ? (0, (/*@__PURE__*/$parcel$interopDefault($2NUGZ))) : undefined
    };
    const buttonChildren = children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3615035320db7a8b$var$i18n.tryItFree);
    const ButtonComponent = $3615035320db7a8b$export$bfc8da995ea49800(appearance);
    const renderModalContent = ()=>{
        if (upflowV2EligibilityHookLoading) return null;
        if (upflowV2ExperimentCohort === 'variation') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l0DoV.TryStandardUpflowV2ExperimentTreatmentModalLoadable), {
            isOpen: openUpFlow,
            closeModal: onUpFlowClose,
            touchpointId: source,
            targetEdition: targetEdition,
            isBillingAdmin: isBillingAdmin,
            isSiteAdmin: isSiteAdmin,
            currentEdition: currentEdition
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e5k34.UpFlowCommerceRouterLoadable), {
            canChangeEdition: true // this component should only ever be used for site admins
            ,
            cloudId: cloudId,
            currentEdition: currentEdition || undefined,
            atlassianAccountId: userId || undefined,
            flow: "upgrade",
            product: "confluence",
            targetEdition: targetEdition,
            touchpointId: source,
            isExperienceTrackerEnabled: true,
            onClose: // Note: onUpFlowOpen function closes the parent component which
            // means we don't need to trigger the onClose.
            onUpFlowOpen ? undefined : onUpFlowClose,
            onOpen: onUpFlowOpen,
            epMessageId: (0, $gsZdA.UP_FLOW_EP_MESSAGE_ID)
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, pollingError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: pollingError
    }) : null, upflowV2EligibilityHookLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), upflowV2ExperimentButtonProps, buttonChildren) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ButtonComponent, buttonProps, buttonChildren), showUpFlow && openUpFlow ? renderModalContent() : null);
};
const $3615035320db7a8b$export$f7f19bf883ba50e2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(78);
    const { analyticsProps: t1, appearance: t2, children: children, targetEdition: t3, onUpgradeButtonClick: onUpgradeButtonClick } = t0;
    const { actionSubjectId: actionSubjectId, attributes: attributes, source: source } = t1;
    const appearance = t2 === undefined ? "primary" : t2;
    const targetEdition = t3 === undefined ? (0, $euL71.ConfluenceEdition).STANDARD : t3;
    const { cloudId: cloudId, edition: currentEdition } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const [isModalOpen, setModalOpen] = (0, $cozmU.useState)(false);
    let t4;
    if ($[0] !== cloudId || $[1] !== targetEdition) {
        t4 = {
            cloudId: cloudId,
            targetEdition: targetEdition
        };
        $[0] = cloudId;
        $[1] = targetEdition;
        $[2] = t4;
    } else t4 = $[2];
    const { isBillingAdmin: isBillingAdmin, isSiteAdmin: isSiteAdmin, isAvailableToUser: isAvailableToUser, experienceUrl: experienceUrl, loading: loading, error: error } = (0, $jW145.useUpgradeButtonDetails)(t4);
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = new (0, $8QJDy.default)({
            product: "confluence"
        });
        $[3] = t5;
    } else t5 = $[3];
    const origin = t5;
    let t6;
    if ($[4] !== experienceUrl) {
        t6 = experienceUrl ? origin.addToUrl(experienceUrl) : null;
        $[4] = experienceUrl;
        $[5] = t6;
    } else t6 = $[5];
    const upgradeUrl = t6;
    let t7;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = origin.toAnalyticsAttributes({
            hasGeneratedId: true
        });
        $[6] = t7;
    } else t7 = $[6];
    const originAttributes = t7;
    const shouldShowUpgradeCTA = !loading && (isBillingAdmin || isSiteAdmin) && isAvailableToUser && experienceUrl !== null;
    let t8;
    if ($[7] !== source || $[8] !== targetEdition) {
        t8 = targetEdition === (0, $euL71.ConfluenceEdition).STANDARD && (0, $iAMak.SUPPORTED_TOUCHPOINTS).includes(source);
        $[7] = source;
        $[8] = targetEdition;
        $[9] = t8;
    } else t8 = $[9];
    const shouldShowModal = t8;
    let roles;
    if ($[10] !== isBillingAdmin || $[11] !== isSiteAdmin) {
        roles = [];
        if (isSiteAdmin) roles.push("siteAdmin");
        if (isBillingAdmin) roles.push("billingAdmin");
        $[10] = isBillingAdmin;
        $[11] = isSiteAdmin;
        $[12] = roles;
    } else roles = $[12];
    const userRoles = roles;
    let t9;
    if ($[13] !== actionSubjectId || $[14] !== attributes || $[15] !== createAnalyticsEvent || $[16] !== currentEdition || $[17] !== source || $[18] !== targetEdition || $[19] !== userRoles) {
        t9 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "link",
                    actionSubjectId: actionSubjectId,
                    source: source,
                    attributes: {
                        ...attributes,
                        ...originAttributes,
                        currentEdition: currentEdition,
                        targetEdition: targetEdition,
                        userRoles: userRoles
                    }
                }
            }).fire();
        };
        $[13] = actionSubjectId;
        $[14] = attributes;
        $[15] = createAnalyticsEvent;
        $[16] = currentEdition;
        $[17] = source;
        $[18] = targetEdition;
        $[19] = userRoles;
        $[20] = t9;
    } else t9 = $[20];
    const fireClickAnalytics = t9;
    let t10;
    if ($[21] !== fireClickAnalytics || $[22] !== onUpgradeButtonClick || $[23] !== upgradeUrl) {
        t10 = ()=>{
            onUpgradeButtonClick?.();
            fireClickAnalytics();
            if (!upgradeUrl) return;
            const newTab = window.open(upgradeUrl, "_blank");
            if (newTab) newTab.opener = null;
            else window.location.href = upgradeUrl;
        };
        $[21] = fireClickAnalytics;
        $[22] = onUpgradeButtonClick;
        $[23] = upgradeUrl;
        $[24] = t10;
    } else t10 = $[24];
    const onDirectToCommerceClick = t10;
    let t11;
    let t12;
    if ($[25] !== actionSubjectId || $[26] !== attributes || $[27] !== createAnalyticsEvent || $[28] !== currentEdition || $[29] !== source || $[30] !== targetEdition) {
        t11 = ()=>{
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "rendered",
                    actionSubject: "upgradeEditionButton",
                    actionSubjectId: actionSubjectId,
                    source: source,
                    attributes: {
                        ...attributes,
                        currentEdition: currentEdition,
                        targetEdition: targetEdition
                    }
                }
            }).fire();
        };
        t12 = [
            createAnalyticsEvent,
            actionSubjectId,
            source,
            attributes,
            currentEdition,
            targetEdition
        ];
        $[25] = actionSubjectId;
        $[26] = attributes;
        $[27] = createAnalyticsEvent;
        $[28] = currentEdition;
        $[29] = source;
        $[30] = targetEdition;
        $[31] = t11;
        $[32] = t12;
    } else {
        t11 = $[31];
        t12 = $[32];
    }
    (0, $cozmU.useEffect)(t11, t12);
    let t13;
    if ($[33] !== fireClickAnalytics || $[34] !== onUpgradeButtonClick) {
        t13 = ()=>{
            onUpgradeButtonClick?.();
            fireClickAnalytics();
            setModalOpen(true);
        };
        $[33] = fireClickAnalytics;
        $[34] = onUpgradeButtonClick;
        $[35] = t13;
    } else t13 = $[35];
    const onModalRouteClick = t13;
    let t14;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = ()=>setModalOpen(false);
        $[36] = t14;
    } else t14 = $[36];
    const closeModal = t14;
    const onClick = shouldShowModal ? onModalRouteClick : onDirectToCommerceClick;
    let t15;
    if ($[37] !== children) {
        t15 = children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3615035320db7a8b$var$i18n.tryItFree);
        $[37] = children;
        $[38] = t15;
    } else t15 = $[38];
    const buttonChildren = t15;
    let t16;
    if ($[39] !== appearance) {
        t16 = $3615035320db7a8b$export$bfc8da995ea49800(appearance);
        $[39] = appearance;
        $[40] = t16;
    } else t16 = $[40];
    const ButtonComponent = t16;
    let t17;
    if ($[41] !== appearance) {
        t17 = appearance === "primary" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NUGZ))), {
            label: "",
            color: "var(--ds-icon-inverse, #FFFFFF)"
        }) : undefined;
        $[41] = appearance;
        $[42] = t17;
    } else t17 = $[42];
    let t18;
    if ($[43] !== actionSubjectId || $[44] !== source) {
        t18 = (0, $k4Vdy.calculateTestId)({
            source: source,
            actionSubjectId: actionSubjectId
        });
        $[43] = actionSubjectId;
        $[44] = source;
        $[45] = t18;
    } else t18 = $[45];
    let t19;
    if ($[46] !== appearance || $[47] !== t17 || $[48] !== t18) {
        t19 = {
            appearance: appearance,
            iconBefore: t17,
            testId: t18
        };
        $[46] = appearance;
        $[47] = t17;
        $[48] = t18;
        $[49] = t19;
    } else t19 = $[49];
    const sharedButtonProps = t19;
    let t20;
    let t21;
    if ($[50] !== attributes || $[51] !== createAnalyticsEvent || $[52] !== currentEdition || $[53] !== error || $[54] !== isAvailableToUser || $[55] !== loading || $[56] !== source || $[57] !== targetEdition || $[58] !== upgradeUrl) {
        t20 = ()=>{
            if (loading) return;
            let failure;
            if (error) failure = {
                actionSubjectId: "upgradeDetailsQuery",
                errorMessage: error.message
            };
            else if (isAvailableToUser && !upgradeUrl) failure = {
                actionSubjectId: "experienceUrl"
            };
            if (!failure) return;
            createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    action: "errored",
                    actionSubject: "upgradeEditionButton",
                    actionSubjectId: failure.actionSubjectId,
                    source: source,
                    attributes: {
                        ...attributes,
                        currentEdition: currentEdition,
                        targetEdition: targetEdition,
                        ...failure.errorMessage ? {
                            errorMessage: failure.errorMessage
                        } : {}
                    }
                }
            }).fire();
        };
        t21 = [
            loading,
            error,
            isAvailableToUser,
            upgradeUrl,
            createAnalyticsEvent,
            source,
            attributes,
            currentEdition,
            targetEdition
        ];
        $[50] = attributes;
        $[51] = createAnalyticsEvent;
        $[52] = currentEdition;
        $[53] = error;
        $[54] = isAvailableToUser;
        $[55] = loading;
        $[56] = source;
        $[57] = targetEdition;
        $[58] = upgradeUrl;
        $[59] = t20;
        $[60] = t21;
    } else {
        t20 = $[59];
        t21 = $[60];
    }
    (0, $cozmU.useEffect)(t20, t21);
    if (loading || !shouldShowUpgradeCTA || !upgradeUrl) return null;
    let t22;
    if ($[61] !== ButtonComponent || $[62] !== buttonChildren || $[63] !== onClick || $[64] !== sharedButtonProps) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ButtonComponent, {
            ...sharedButtonProps,
            onClick: onClick
        }, buttonChildren);
        $[61] = ButtonComponent;
        $[62] = buttonChildren;
        $[63] = onClick;
        $[64] = sharedButtonProps;
        $[65] = t22;
    } else t22 = $[65];
    let t23;
    if ($[66] !== currentEdition || $[67] !== isBillingAdmin || $[68] !== isModalOpen || $[69] !== isSiteAdmin || $[70] !== shouldShowModal || $[71] !== source || $[72] !== targetEdition || $[73] !== upgradeUrl) {
        t23 = shouldShowModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7VDbW.StandardUpgradeModalLoadable), {
            isOpen: isModalOpen,
            closeModal: closeModal,
            touchpointId: source,
            targetEdition: targetEdition,
            isBillingAdmin: isBillingAdmin,
            isSiteAdmin: isSiteAdmin,
            currentEdition: currentEdition,
            experienceUrl: upgradeUrl
        }) : null;
        $[66] = currentEdition;
        $[67] = isBillingAdmin;
        $[68] = isModalOpen;
        $[69] = isSiteAdmin;
        $[70] = shouldShowModal;
        $[71] = source;
        $[72] = targetEdition;
        $[73] = upgradeUrl;
        $[74] = t23;
    } else t23 = $[74];
    let t24;
    if ($[75] !== t22 || $[76] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t22, t23);
        $[75] = t22;
        $[76] = t23;
        $[77] = t24;
    } else t24 = $[77];
    return t24;
} : ({ analyticsProps: { actionSubjectId: actionSubjectId, attributes: attributes, source: source }, appearance: appearance = 'primary', children: children, targetEdition: targetEdition = (0, $euL71.ConfluenceEdition).STANDARD, onUpgradeButtonClick: onUpgradeButtonClick })=>{
    const { cloudId: cloudId, edition: currentEdition } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const [isModalOpen, setModalOpen] = (0, $cozmU.useState)(false);
    const { isBillingAdmin: isBillingAdmin, isSiteAdmin: isSiteAdmin, isAvailableToUser: isAvailableToUser, experienceUrl: experienceUrl, loading: loading, error: error } = (0, $jW145.useUpgradeButtonDetails)({
        cloudId: cloudId,
        targetEdition: targetEdition
    });
    const origin = (0, $cozmU.useMemo)(()=>new (0, $8QJDy.default)({
            product: 'confluence'
        }), []);
    const upgradeUrl = (0, $cozmU.useMemo)(()=>experienceUrl ? origin.addToUrl(experienceUrl) : null, [
        origin,
        experienceUrl
    ]);
    const originAttributes = (0, $cozmU.useMemo)(()=>origin.toAnalyticsAttributes({
            hasGeneratedId: true
        }), [
        origin
    ]);
    const shouldShowUpgradeCTA = !loading && (isBillingAdmin || isSiteAdmin) && isAvailableToUser && experienceUrl !== null;
    const shouldShowModal = targetEdition === (0, $euL71.ConfluenceEdition).STANDARD && (0, $iAMak.SUPPORTED_TOUCHPOINTS).includes(source);
    const userRoles = (0, $cozmU.useMemo)(()=>{
        const roles = [];
        if (isSiteAdmin) roles.push('siteAdmin');
        if (isBillingAdmin) roles.push('billingAdmin');
        return roles;
    }, [
        isSiteAdmin,
        isBillingAdmin
    ]);
    const fireClickAnalytics = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: {
                    ...attributes,
                    ...originAttributes,
                    currentEdition: currentEdition,
                    targetEdition: targetEdition,
                    userRoles: userRoles
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        actionSubjectId,
        source,
        attributes,
        originAttributes,
        currentEdition,
        targetEdition,
        userRoles
    ]);
    const onDirectToCommerceClick = (0, $cozmU.useCallback)(()=>{
        onUpgradeButtonClick?.();
        fireClickAnalytics();
        // The button is only rendered once `upgradeUrl` is available (see the guard
        // before the return), so this is defensive rather than expected to be hit.
        if (!upgradeUrl) return;
        const newTab = window.open(upgradeUrl, '_blank');
        if (newTab) // Sever the opener reference to prevent reverse tabnabbing (the opened
        // Commerce page must not be able to navigate this tab via window.opener).
        newTab.opener = null;
        else window.location.href = upgradeUrl;
    }, [
        onUpgradeButtonClick,
        fireClickAnalytics,
        upgradeUrl
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Mirror the legacy button's render tracking exactly (sendTrackEvent /
        // 'rendered' with the same attribute shape) so the productionized path
        // stays joinable with the existing Commerce-traffic dashboards. Fired once
        // on mount, like legacy.
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'rendered',
                actionSubject: 'upgradeEditionButton',
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: {
                    ...attributes,
                    currentEdition: currentEdition,
                    targetEdition: targetEdition
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        actionSubjectId,
        source,
        attributes,
        currentEdition,
        targetEdition
    ]);
    const onModalRouteClick = (0, $cozmU.useCallback)(()=>{
        onUpgradeButtonClick?.();
        fireClickAnalytics();
        setModalOpen(true);
    }, [
        onUpgradeButtonClick,
        fireClickAnalytics
    ]);
    const closeModal = (0, $cozmU.useCallback)(()=>setModalOpen(false), []);
    const onClick = shouldShowModal ? onModalRouteClick : onDirectToCommerceClick;
    const buttonChildren = children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3615035320db7a8b$var$i18n.tryItFree);
    const ButtonComponent = $3615035320db7a8b$export$bfc8da995ea49800(appearance);
    const sharedButtonProps = {
        appearance: appearance,
        iconBefore: appearance === 'primary' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NUGZ))), {
            label: "",
            color: "var(--ds-icon-inverse, #FFFFFF)"
        }) : undefined,
        testId: (0, $k4Vdy.calculateTestId)({
            source: source,
            actionSubjectId: actionSubjectId
        })
    };
    (0, $cozmU.useEffect)(()=>{
        if (loading) return;
        // Two distinct failure modes are reported separately:
        // 1. The eligibility/experience-URL query itself failed.
        // 2. The query succeeded for an eligible user but returned no experience URL.
        let failure;
        if (error) failure = {
            actionSubjectId: 'upgradeDetailsQuery',
            errorMessage: error.message
        };
        else if (isAvailableToUser && !upgradeUrl) failure = {
            actionSubjectId: 'experienceUrl'
        };
        if (!failure) return;
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'errored',
                actionSubject: 'upgradeEditionButton',
                actionSubjectId: failure.actionSubjectId,
                source: source,
                attributes: {
                    ...attributes,
                    currentEdition: currentEdition,
                    targetEdition: targetEdition,
                    ...failure.errorMessage ? {
                        errorMessage: failure.errorMessage
                    } : {}
                }
            }
        }).fire();
    }, [
        loading,
        error,
        isAvailableToUser,
        upgradeUrl,
        createAnalyticsEvent,
        source,
        attributes,
        currentEdition,
        targetEdition
    ]);
    // Render nothing while the eligibility/experience-URL query is in flight. The
    // data fetch is new behaviour for this path, so a transient disabled button
    // could appear and then disappear for ineligible users; rendering null avoids
    // that flicker.
    if (loading || !shouldShowUpgradeCTA || !upgradeUrl) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ButtonComponent, {
        ...sharedButtonProps,
        onClick: onClick
    }, buttonChildren), shouldShowModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7VDbW.StandardUpgradeModalLoadable), {
        isOpen: isModalOpen,
        closeModal: closeModal,
        touchpointId: source,
        targetEdition: targetEdition,
        isBillingAdmin: isBillingAdmin,
        isSiteAdmin: isSiteAdmin,
        currentEdition: currentEdition,
        experienceUrl: upgradeUrl
    }) : null);
};
const $3615035320db7a8b$export$2f4bd8d23e81b246 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    if ((0, $9wGTI.fg)("confluence_direct_to_commerce_upgrade")) {
        let t0;
        if ($[0] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3615035320db7a8b$export$f7f19bf883ba50e2, props);
            $[0] = props;
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    let t0;
    if ($[2] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3615035320db7a8b$var$UpgradeEditionButtonLegacy, props);
        $[2] = props;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props)=>{
    if ((0, $9wGTI.fg)('confluence_direct_to_commerce_upgrade')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3615035320db7a8b$export$f7f19bf883ba50e2, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3615035320db7a8b$var$UpgradeEditionButtonLegacy, props);
};
module.exports["determineButtonComponent"] = $3615035320db7a8b$export$bfc8da995ea49800;
module.exports["UpgradeEditionButtonDirectToCommerce"] = $3615035320db7a8b$export$f7f19bf883ba50e2;
module.exports["UpgradeEditionButton"] = $3615035320db7a8b$export$2f4bd8d23e81b246;

});

parcelRegister("ey6Pt", function(module, exports) {
/**
 * @generated SignedSource<<fc69fbf29eae12ee72060bd72bafc119>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $377a05a3faea70b3$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "UpgradeEditionButtonFragment",
        "selections": [
            {
                "concreteType": "Editions",
                "kind": "LinkedField",
                "name": "editions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "confluence"
                    },
                    v0 /*: any*/ 
                ]
            },
            v0 /*: any*/ 
        ],
        "type": "ConfluenceTenantContext"
    };
}();
$377a05a3faea70b3$var$node.hash = "bee007bb99f1be1656322a1f41effd37";
var $377a05a3faea70b3$export$2e2bcd8739ae039 = $377a05a3faea70b3$var$node;
module.exports["default"] = $377a05a3faea70b3$export$2e2bcd8739ae039;

});

parcelRegister("2NUGZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a9109095f0a9b69c0b01202dc3ed5e4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $20ac225077229fe3$var$_react = $20ac225077229fe3$var$_interopRequireDefault((parcelRequire("cozmU")));

var $20ac225077229fe3$var$_baseNew = $20ac225077229fe3$var$_interopRequireDefault((parcelRequire("gElAV")));
function $20ac225077229fe3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Editions".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing premium features in upsell experiences. The Editions gem icon has officially replaced the sparkle icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $20ac225077229fe3$var$EditionsIcon = (props)=>/*#__PURE__*/ $20ac225077229fe3$var$_react.default.createElement($20ac225077229fe3$var$_baseNew.default, Object.assign({
        name: "EditionsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m12.75 1 .096.006a.75.75 0 0 1 .54.347l2.5 4a.75.75 0 0 1-.066.883l-7.25 8.5a.75.75 0 0 1-1.14 0l-7.25-8.5a.75.75 0 0 1-.066-.883l2.5-4 .056-.079A.75.75 0 0 1 3.25 1zM8 11.813 9.719 6.5H6.28zm-1.873-.914L4.704 6.5H2.375zm3.745 0L13.625 6.5h-2.33zM11.302 5h2.596l-1.563-2.5H10.52zM6.27 5h3.46l-.782-2.5H7.052zM2.103 5h2.595l.781-2.5H3.665z"/>`
    }, props));
$20ac225077229fe3$var$EditionsIcon.displayName = 'EditionsIcon';
var $20ac225077229fe3$var$_default = module.exports.default = $20ac225077229fe3$var$EditionsIcon;

});

parcelRegister("dqdrq", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $2NUGZ = parcelRequire("2NUGZ");


var $j4WDj = parcelRequire("j4WDj");


var $6J7Bn = parcelRequire("6J7Bn");

const $ce55fe36479bc4cf$var$StyledButton = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(11);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? (0, $6J7Bn.ButtonBase) : t2;
        let t3;
        let t4;
        let t5;
        let t6;
        let t7;
        let t8;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = (0, $9aYkv.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_DEFAULT_START));
            t4 = (0, $9aYkv.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_DEFAULT_END));
            t5 = (0, $9aYkv.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_HOVER_START));
            t6 = (0, $9aYkv.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_HOVER_END));
            t7 = (0, $9aYkv.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_START));
            t8 = (0, $9aYkv.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_END));
            $[3] = t3;
            $[4] = t4;
            $[5] = t5;
            $[6] = t6;
            $[7] = t7;
            $[8] = t8;
        } else {
            t3 = $[3];
            t4 = $[4];
            t5 = $[5];
            t6 = $[6];
            t7 = $[7];
            t8 = $[8];
        }
        let t9;
        if ($[9] !== __cmpls) {
            t9 = {
                ...__cmpls,
                "--_iozncj": t3,
                "--_id2ec3": t4,
                "--_1wa1xp5": t5,
                "--_1ck0ygl": t6,
                "--_1jf6nc6": t7,
                "--_1kksnqn": t8
            };
            $[9] = __cmpls;
            $[10] = t9;
        } else t9 = $[10];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmplp,
            style: t9,
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_1wgmglyw _1tnq12b0 _nup9qsa8 _ge1r1cay _h99ltlke _r7sm1uxc _1xlotlke _1jypidpf _1fm3idpf _12z9idpf _1dwpidpf _kl6h116y _1w901gfe _1l5a1gfe _zelm1gfe _1fh11gfe _1f1j1gfe",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = (0, $6J7Bn.ButtonBase), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_iozncj": (0, $9aYkv.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_DEFAULT_START)),
            "--_id2ec3": (0, $9aYkv.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_DEFAULT_END)),
            "--_1wa1xp5": (0, $9aYkv.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_HOVER_START)),
            "--_1ck0ygl": (0, $9aYkv.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_HOVER_END)),
            "--_1jf6nc6": (0, $9aYkv.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_START)),
            "--_1kksnqn": (0, $9aYkv.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_END))
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1wgmglyw _1tnq12b0 _nup9qsa8 _ge1r1cay _h99ltlke _r7sm1uxc _1xlotlke _1jypidpf _1fm3idpf _12z9idpf _1dwpidpf _kl6h116y _1w901gfe _1l5a1gfe _zelm1gfe _1fh11gfe _1f1j1gfe",
            __cmplp.className
        ])
    });
});
const $ce55fe36479bc4cf$var$ButtonText = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_11c8fhey _1e0c1txw _4cvr1h6o _1bah1h6o _k48p1wq8",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11c8fhey _1e0c1txw _4cvr1h6o _1bah1h6o _k48p1wq8",
            __cmplp.className
        ])
    });
}); /**
     * A styled button with a gradient background, intended to be used as a product edition upgrade CTA button.
     */ 
const $ce55fe36479bc4cf$export$d1aef6466b5ecaa5 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    let buttonProps;
    let children;
    if ($[0] !== t0) {
        ({ children: children, ...buttonProps } = t0);
        $[0] = t0;
        $[1] = buttonProps;
        $[2] = children;
    } else {
        buttonProps = $[1];
        children = $[2];
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NUGZ))), {
            label: ""
        });
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ce55fe36479bc4cf$var$ButtonText, null, children);
        $[4] = children;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== buttonProps || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ce55fe36479bc4cf$var$StyledButton, {
            iconBefore: t1,
            ...buttonProps
        }, t2);
        $[6] = buttonProps;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ children: children, ...buttonProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ce55fe36479bc4cf$var$StyledButton, {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NUGZ))), {
            label: ""
        }),
        ...buttonProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ce55fe36479bc4cf$var$ButtonText, null, children));
};
module.exports["GradientCTAButton"] = $ce55fe36479bc4cf$export$d1aef6466b5ecaa5;

});

parcelRegister("j4WDj", function(module, exports) {
const $67193f3c2d75b820$export$3ff4048780acdec9 = "var(--ds-chart-purple-bolder, #AF59E1)";
const $67193f3c2d75b820$export$ac8ee41608bff6f4 = "var(--ds-chart-blue-bolder, #357DE8)";
const $67193f3c2d75b820$export$12fbdde791205cea = "var(--ds-chart-purple-bolder-hovered, #964AC0)";
const $67193f3c2d75b820$export$7653c62635354aaf = "var(--ds-chart-blue-bolder-hovered, #1868DB)";
const $67193f3c2d75b820$export$d4accc94291dcf84 = "var(--ds-chart-purple-boldest, #803FA5)";
const $67193f3c2d75b820$export$16a15d5a9b73591b = "var(--ds-chart-blue-boldest, #1558BC)";
const $67193f3c2d75b820$export$fca70c3c81bb0f58 = "var(--ds-background-accent-blue-subtlest, #E9F2FE)";
const $67193f3c2d75b820$export$f737ffc625de304f = "var(--ds-background-accent-purple-subtlest, #F8EEFE)";
const $67193f3c2d75b820$export$b1ab5fb618714abb = "var(--ds-border-accent-purple, #AF59E1)";
const $67193f3c2d75b820$export$7a262e0e9c5a1e2a = "var(--ds-border-accent-blue, #357DE8)";
const $67193f3c2d75b820$export$71b6aed4f8256b2 = "var(--ds-background-discovery-bold-pressed, #673286)";
const $67193f3c2d75b820$export$c9d89eb8e0b59a5a = "var(--ds-background-selected-bold-pressed, #123263)";
module.exports["GRADIENT_CTA_BUTTON_DEFAULT_START"] = $67193f3c2d75b820$export$3ff4048780acdec9;
module.exports["GRADIENT_CTA_BUTTON_DEFAULT_END"] = $67193f3c2d75b820$export$ac8ee41608bff6f4;
module.exports["GRADIENT_CTA_BUTTON_HOVER_START"] = $67193f3c2d75b820$export$12fbdde791205cea;
module.exports["GRADIENT_CTA_BUTTON_HOVER_END"] = $67193f3c2d75b820$export$7653c62635354aaf;
module.exports["GRADIENT_CTA_BUTTON_ACTIVE_START"] = $67193f3c2d75b820$export$d4accc94291dcf84;
module.exports["GRADIENT_CTA_BUTTON_ACTIVE_END"] = $67193f3c2d75b820$export$16a15d5a9b73591b;
module.exports["GRADIENT_BACKGROUND_SUBTLEST_START"] = $67193f3c2d75b820$export$fca70c3c81bb0f58;
module.exports["GRADIENT_BACKGROUND_SUBTLEST_END"] = $67193f3c2d75b820$export$f737ffc625de304f;
module.exports["GRADIENT_CTA_BUTTON_INVERTED_BORDER_START"] = $67193f3c2d75b820$export$b1ab5fb618714abb;
module.exports["GRADIENT_CTA_BUTTON_INVERTED_BORDER_END"] = $67193f3c2d75b820$export$7a262e0e9c5a1e2a;
module.exports["GRADIENT_CTA_BUTTON_SELECTED_START"] = $67193f3c2d75b820$export$71b6aed4f8256b2;
module.exports["GRADIENT_CTA_BUTTON_SELECTED_END"] = $67193f3c2d75b820$export$c9d89eb8e0b59a5a;

});

parcelRegister("6J7Bn", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $7ZB0A = parcelRequire("7ZB0A");

const $e9beab952dc913a3$export$b0bb876e969289cd = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $7ZB0A.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_d16p1ano _1dqt12x7 _1toh1r31 _5jyqglyw _mrqmnqa1 _if29116y _1kba1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = (0, $7ZB0A.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_d16p1ano _1dqt12x7 _1toh1r31 _5jyqglyw _mrqmnqa1 _if29116y _1kba1h6o",
            __cmplp.className
        ])
    });
});
module.exports["ButtonBase"] = $e9beab952dc913a3$export$b0bb876e969289cd;

});

parcelRegister("ktelT", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $2NUGZ = parcelRequire("2NUGZ");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-html-anchor -- To migrate as part of go/ui-styling-standard
const $903332396267b541$var$LinkWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "a" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_11q71879 _11c8fhey _zulpv77o _1e0c116y _4cvr1h6o _80omtlke _k48pwu06 _1bsb1ns9 _pjrq1758 _oo9g1j28 _18u01b66 _1xjxgktf _1nj1uyj3 _13r27vkz _1nm57vkz _19lc19y2 _1fyq1yf3 _1h7d1kdv _v6kc1j28",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11q71879 _11c8fhey _zulpv77o _1e0c116y _4cvr1h6o _80omtlke _k48pwu06 _1bsb1ns9 _pjrq1758 _oo9g1j28 _18u01b66 _1xjxgktf _1nj1uyj3 _13r27vkz _1nm57vkz _19lc19y2 _1fyq1yf3 _1h7d1kdv _v6kc1j28",
            __cmplp.className
        ])
    });
});
const $903332396267b541$export$7e6e2bf13161f2a = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { href: href, onClick: onClick, target: target, children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NUGZ))), {
            label: ""
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== href || $[3] !== onClick || $[4] !== target) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($903332396267b541$var$LinkWrapper, {
            href: href,
            onClick: onClick,
            target: target,
            role: "link"
        }, t1, children);
        $[1] = children;
        $[2] = href;
        $[3] = onClick;
        $[4] = target;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ href: href, onClick: onClick, target: target, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($903332396267b541$var$LinkWrapper, {
        href: href,
        onClick: onClick,
        target: target,
        role: "link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2NUGZ))), {
        label: ""
    }), children);
};
module.exports["GradientSubtleLinkButton"] = $903332396267b541$export$7e6e2bf13161f2a;

});

parcelRegister("2UjZJ", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $gXR0B = parcelRequire("gXR0B");


var $f1B2z = parcelRequire("f1B2z");

const $dd8da84ad086336b$export$2bbc11bf12d076a0 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { skip: skip, touchpointId: touchpointId, currentEdition: currentEdition, targetEdition: targetEdition } = t0;
    const fireExperimentExposureEvent = (0, $gXR0B.useFeatureExposedAnalytics)();
    const [abCohort, setAbCohort] = (0, $cozmU.useState)(null);
    let t1;
    if ($[0] !== currentEdition || $[1] !== skip || $[2] !== targetEdition) {
        t1 = {
            skip: skip,
            currentEdition: currentEdition,
            targetEdition: targetEdition
        };
        $[0] = currentEdition;
        $[1] = skip;
        $[2] = targetEdition;
        $[3] = t1;
    } else t1 = $[3];
    const { isEligible: isEligible, isSiteAdmin: isSiteAdmin, isBillingAdmin: isBillingAdmin, error: eligibilityHookError, loading: eligibilityHookLoading } = (0, $f1B2z.useIsEligibleForUpflowV2ConfluenceStandardFGsExperiment)(t1);
    let t2;
    let t3;
    if ($[4] !== currentEdition || $[5] !== eligibilityHookError || $[6] !== fireExperimentExposureEvent || $[7] !== isBillingAdmin || $[8] !== isEligible || $[9] !== isSiteAdmin || $[10] !== targetEdition || $[11] !== touchpointId) {
        t2 = ()=>{
            if (isEligible) {
                fireExperimentExposureEvent({
                    flagKey: "grw-1930_confluence_upv2_standard_ab",
                    cohort: (0, $6mKj3.expVal)("grw-1930_confluence_upv2_standard_ab", "cohort", "not-enrolled"),
                    growthInitiative: "luna",
                    touchpointId: touchpointId,
                    additionalAttributes: {
                        currentEdition: currentEdition,
                        targetEdition: targetEdition,
                        isSiteAdmin: isSiteAdmin,
                        isBillingAdmin: isBillingAdmin
                    }
                });
                setAbCohort((0, $6mKj3.expVal)("grw-1930_confluence_upv2_standard_ab", "cohort", "not-enrolled"));
            } else if (eligibilityHookError) setAbCohort(null);
            else setAbCohort("not-enrolled");
        };
        t3 = [
            fireExperimentExposureEvent,
            isEligible,
            eligibilityHookError,
            currentEdition,
            targetEdition,
            isSiteAdmin,
            isBillingAdmin,
            touchpointId
        ];
        $[4] = currentEdition;
        $[5] = eligibilityHookError;
        $[6] = fireExperimentExposureEvent;
        $[7] = isBillingAdmin;
        $[8] = isEligible;
        $[9] = isSiteAdmin;
        $[10] = targetEdition;
        $[11] = touchpointId;
        $[12] = t2;
        $[13] = t3;
    } else {
        t2 = $[12];
        t3 = $[13];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[14] !== abCohort || $[15] !== eligibilityHookError || $[16] !== eligibilityHookLoading || $[17] !== isBillingAdmin || $[18] !== isSiteAdmin) {
        t4 = {
            cohort: abCohort,
            isSiteAdmin: isSiteAdmin,
            isBillingAdmin: isBillingAdmin,
            loading: eligibilityHookLoading,
            error: eligibilityHookError
        };
        $[14] = abCohort;
        $[15] = eligibilityHookError;
        $[16] = eligibilityHookLoading;
        $[17] = isBillingAdmin;
        $[18] = isSiteAdmin;
        $[19] = t4;
    } else t4 = $[19];
    return t4;
} : ({ skip: skip, touchpointId: touchpointId, currentEdition: currentEdition, targetEdition: targetEdition })=>{
    const fireExperimentExposureEvent = (0, $gXR0B.useFeatureExposedAnalytics)();
    const [abCohort, setAbCohort] = (0, $cozmU.useState)(null);
    const { isEligible: isEligible, isSiteAdmin: isSiteAdmin, isBillingAdmin: isBillingAdmin, error: eligibilityHookError, loading: eligibilityHookLoading } = (0, $f1B2z.useIsEligibleForUpflowV2ConfluenceStandardFGsExperiment)({
        skip: skip,
        currentEdition: currentEdition,
        targetEdition: targetEdition
    });
    (0, $cozmU.useEffect)(()=>{
        if (isEligible) {
            fireExperimentExposureEvent({
                flagKey: 'grw-1930_confluence_upv2_standard_ab',
                cohort: (0, $6mKj3.expVal)('grw-1930_confluence_upv2_standard_ab', 'cohort', 'not-enrolled'),
                growthInitiative: 'luna',
                touchpointId: touchpointId,
                additionalAttributes: {
                    currentEdition: currentEdition,
                    targetEdition: targetEdition,
                    isSiteAdmin: isSiteAdmin,
                    isBillingAdmin: isBillingAdmin
                }
            });
            setAbCohort((0, $6mKj3.expVal)('grw-1930_confluence_upv2_standard_ab', 'cohort', 'not-enrolled'));
        } else if (eligibilityHookError) // Error occurred, reset to null
        setAbCohort(null);
        else setAbCohort('not-enrolled');
    }, [
        fireExperimentExposureEvent,
        isEligible,
        eligibilityHookError,
        currentEdition,
        targetEdition,
        isSiteAdmin,
        isBillingAdmin,
        touchpointId
    ]);
    return {
        cohort: abCohort,
        isSiteAdmin: isSiteAdmin,
        isBillingAdmin: isBillingAdmin,
        loading: eligibilityHookLoading,
        error: eligibilityHookError
    };
};
module.exports["useUpflowV2ConfluenceStandardFGsExperiment"] = $dd8da84ad086336b$export$2bbc11bf12d076a0;

});

parcelRegister("gXR0B", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");

const $c07cc869290551b6$export$5218ddb3d9c658c0 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const sentFlagKeys = (0, $cozmU.useRef)(t0);
    let t1;
    if ($[1] !== createAnalyticsEvent) {
        t1 = (t2)=>{
            const { flagKey: flagKey, cohort: cohort, touchpointId: touchpointId, growthInitiative: growthInitiative, additionalAttributes: t3 } = t2;
            const additionalAttributes = t3 === undefined ? {} : t3;
            const flagTouchpointKey = `${flagKey}:${touchpointId}`;
            if (sentFlagKeys.current.includes(flagTouchpointKey)) return;
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "exposed",
                    actionSubject: "experiment",
                    actionSubjectId: `${flagKey}-exposed`,
                    source: flagKey,
                    attributes: {
                        cohort: cohort,
                        touchpointId: touchpointId,
                        growthInitiative: growthInitiative,
                        ...additionalAttributes
                    }
                }
            }).fire();
            sentFlagKeys.current.push(flagTouchpointKey);
        };
        $[1] = createAnalyticsEvent;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const sentFlagKeys = (0, $cozmU.useRef)([]);
    // This ensures the experiment exposure event is only fired once per flagKey / touchpoint combination.
    return (0, $cozmU.useCallback)(({ flagKey: flagKey, cohort: cohort, touchpointId: touchpointId, growthInitiative: growthInitiative, additionalAttributes: additionalAttributes = {} })=>{
        const flagTouchpointKey = `${flagKey}:${touchpointId}`;
        if (sentFlagKeys.current.includes(flagTouchpointKey)) return;
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'exposed',
                actionSubject: 'experiment',
                actionSubjectId: `${flagKey}-exposed`,
                source: flagKey,
                attributes: {
                    cohort: cohort,
                    touchpointId: touchpointId,
                    growthInitiative: growthInitiative,
                    ...additionalAttributes
                }
            }
        }).fire();
        sentFlagKeys.current.push(flagTouchpointKey);
    }, [
        createAnalyticsEvent
    ]);
};
module.exports["useFeatureExposedAnalytics"] = $c07cc869290551b6$export$5218ddb3d9c658c0;

});

parcelRegister("f1B2z", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $iFJDd = parcelRequire("iFJDd");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $dSPRj = parcelRequire("dSPRj");


var $kDXZR = parcelRequire("kDXZR");


var $hSerX = parcelRequire("hSerX");


var $1ytiN = parcelRequire("1ytiN");


var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $jMyy4 = parcelRequire("jMyy4");

const $26baada861c32413$var$extractBillingAdminStatus = (billingData)=>{
    return billingData?.tenantContexts?.[0]?.entitlementInfo?.entitlement?.transactionAccount?.isCurrentUserBillingAdmin;
};
const $26baada861c32413$export$6da6d4db5c51c32 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { skip: t1, currentEdition: currentEdition, targetEdition: targetEdition } = t0;
    const skip = t1 === undefined ? false : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const isBasicEligible = Boolean(cloudId && currentEdition === (0, $euL71.ConfluenceEdition).FREE && targetEdition === (0, $euL71.ConfluenceEdition).STANDARD && isSiteAdmin);
    let t2;
    if ($[0] !== cloudId) {
        t2 = {
            cloudId: cloudId
        };
        $[0] = cloudId;
        $[1] = t2;
    } else t2 = $[1];
    const t3 = skip || !isBasicEligible;
    let t4;
    if ($[2] !== t2 || $[3] !== t3) {
        t4 = {
            interopApolloAggClient: true,
            variables: t2,
            skip: t3
        };
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    const { data: billingAdminData, loading: isBillingAdminQueryLoading, error: billingAdminQueryError } = (0, $jMyy4.useQueryInterop)((0, $iFJDd.default), {
        ...t4,
        __callerPackage__: "change-edition"
    });
    let t5;
    let t6;
    if ($[5] !== billingAdminQueryError || $[6] !== createAnalyticsEvent) {
        t5 = ()=>{
            if (billingAdminQueryError) {
                const eventPayload = (0, $dSPRj.createProductSpecificAnalyticsIntegrationPayload)({
                    product: (0, $kDXZR.Product).CONFLUENCE,
                    team: (0, $hSerX.Team).GROWTH_LUNA,
                    experimentMeta: {
                        experimentKey: "grw-1930_confluence_upv2_standard_ab"
                    },
                    errorType: (0, $kDXZR.ErrorType).GRAPHQL,
                    errorMessage: billingAdminQueryError.message,
                    source: "useIsEligibleForUpflowV2ConfluenceStandardFGsExperiment hook",
                    severity: (0, $kDXZR.Severity).HIGH
                });
                createAnalyticsEvent(eventPayload).fire();
            }
        };
        t6 = [
            billingAdminQueryError,
            createAnalyticsEvent
        ];
        $[5] = billingAdminQueryError;
        $[6] = createAnalyticsEvent;
        $[7] = t5;
        $[8] = t6;
    } else {
        t5 = $[7];
        t6 = $[8];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[9] !== billingAdminData) {
        t7 = $26baada861c32413$var$extractBillingAdminStatus(billingAdminData);
        $[9] = billingAdminData;
        $[10] = t7;
    } else t7 = $[10];
    const isBillingAdmin = t7;
    const t8 = Boolean(isBasicEligible && isBillingAdmin);
    let t9;
    if ($[11] !== billingAdminQueryError || $[12] !== isBillingAdmin || $[13] !== isBillingAdminQueryLoading || $[14] !== isSiteAdmin || $[15] !== t8) {
        t9 = {
            isEligible: t8,
            isSiteAdmin: isSiteAdmin,
            isBillingAdmin: isBillingAdmin,
            loading: isBillingAdminQueryLoading,
            error: billingAdminQueryError
        };
        $[11] = billingAdminQueryError;
        $[12] = isBillingAdmin;
        $[13] = isBillingAdminQueryLoading;
        $[14] = isSiteAdmin;
        $[15] = t8;
        $[16] = t9;
    } else t9 = $[16];
    return t9;
} : ({ skip: skip = false, currentEdition: currentEdition, targetEdition: targetEdition })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const isBasicEligible = Boolean(cloudId && currentEdition === (0, $euL71.ConfluenceEdition).FREE && targetEdition === (0, $euL71.ConfluenceEdition).STANDARD && isSiteAdmin);
    const { data: billingAdminData, loading: isBillingAdminQueryLoading, error: billingAdminQueryError } = (0, $jMyy4.useQueryInterop)((0, $iFJDd.default), {
        interopApolloAggClient: true,
        variables: {
            cloudId: cloudId
        },
        skip: skip || !isBasicEligible,
        __callerPackage__: "change-edition"
    });
    (0, $cozmU.useEffect)(()=>{
        if (billingAdminQueryError) {
            const eventPayload = (0, $dSPRj.createProductSpecificAnalyticsIntegrationPayload)({
                product: (0, $kDXZR.Product).CONFLUENCE,
                team: (0, $hSerX.Team).GROWTH_LUNA,
                experimentMeta: {
                    experimentKey: 'grw-1930_confluence_upv2_standard_ab'
                },
                errorType: (0, $kDXZR.ErrorType).GRAPHQL,
                errorMessage: billingAdminQueryError.message,
                source: 'useIsEligibleForUpflowV2ConfluenceStandardFGsExperiment hook',
                severity: (0, $kDXZR.Severity).HIGH
            });
            createAnalyticsEvent(eventPayload).fire();
        }
    }, [
        billingAdminQueryError,
        createAnalyticsEvent
    ]);
    const isBillingAdmin = (0, $cozmU.useMemo)(()=>{
        return $26baada861c32413$var$extractBillingAdminStatus(billingAdminData);
    }, [
        billingAdminData
    ]);
    return {
        isEligible: Boolean(isBasicEligible && isBillingAdmin),
        isSiteAdmin: isSiteAdmin,
        isBillingAdmin: isBillingAdmin,
        loading: isBillingAdminQueryLoading,
        error: billingAdminQueryError
    };
};
module.exports["useIsEligibleForUpflowV2ConfluenceStandardFGsExperiment"] = $26baada861c32413$export$6da6d4db5c51c32;

});

parcelRegister("iFJDd", function(module, exports) {
/**
 * @generated SignedSource<<866081fcf7d7262f140ca6d94be95dba>>
 * @relayHash f9ca0c6d46f517f6d908bd327972e2da
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d3e73d4b2171a44acf3020206988b6e04ee509d46422cdee27046a9cfd3e6cd6
const $a78c8196dfce8e13$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "hamsProductKey",
            "value": "confluence.ondemand"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isCurrentUserBillingAdmin"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsEligibleForUpflowV2ConfluenceStandardFGsExperimentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                },
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsEligibleForUpflowV2ConfluenceStandardFGsExperimentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ 
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "f9ca0c6d46f517f6d908bd327972e2da",
            "id": "d3e73d4b2171a44acf3020206988b6e04ee509d46422cdee27046a9cfd3e6cd6",
            "metadata": {},
            "name": "useIsEligibleForUpflowV2ConfluenceStandardFGsExperimentQuery",
            "operationKind": "query",
            "text": "query useIsEligibleForUpflowV2ConfluenceStandardFGsExperimentQuery($cloudId:ID!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:\"confluence.ondemand\"){__typename,entitlement{__typename,id,transactionAccount{__typename,...on Node{__isNode:__typename,id,__typename},isCurrentUserBillingAdmin}}}}}"
        }
    };
}();
$a78c8196dfce8e13$var$node.hash = "5ffb5864cc8b6acf0f584617c954e009";
var $a78c8196dfce8e13$export$2e2bcd8739ae039 = $a78c8196dfce8e13$var$node;
module.exports["default"] = $a78c8196dfce8e13$export$2e2bcd8739ae039;

});

parcelRegister("dSPRj", function(module, exports) {

var $kDXZR = parcelRequire("kDXZR");


var $8rbeW = parcelRequire("8rbeW");


var $1yPaR = parcelRequire("1yPaR");


var $kfAzm = parcelRequire("kfAzm");

const $a212d78e5c5d5090$export$8c06ae8e7f403dea = ({ product: product, team: team, experimentMeta: experimentMeta, errorType: errorType, errorMessage: errorMessage, source: source, severity: severity, additionalAttributes: additionalAttributes = {} }, isActiveExperiment = true)=>{
    (0, $kfAzm.validateExperimentName)(experimentMeta.experimentKey);
    const eventPayload = (0, $8rbeW.createEventPayload)({
        team: team,
        experimentMeta: experimentMeta,
        errorType: errorType,
        errorMessage: errorMessage,
        source: source,
        severity: severity,
        isActiveExperiment: isActiveExperiment,
        additionalAttributes: additionalAttributes,
        product: product
    });
    switch(product){
        case (0, $kDXZR.Product).ADMIN_HUB:
            return {
                data: eventPayload
            };
        case (0, $kDXZR.Product).JIRA:
            return {
                data: eventPayload,
                productSpecificRules: {
                    jira: {
                        createAnalyticsEventPayload: (0, $1yPaR.convertEventPayloadForJiraCreateAnalyticsEvent)({
                            data: eventPayload
                        }),
                        fireEventPayload: (0, $1yPaR.convertEventAttributesForJiraFireEvent)({
                            data: eventPayload
                        })
                    }
                }
            };
        case (0, $kDXZR.Product).CONFLUENCE:
            return {
                type: (0, $kDXZR.CONFLUENCE_OPERATIONAL_EVENT_TYPE),
                data: eventPayload
            };
        default:
            throw new Error(`Unsupported product: ${product}`);
    }
};
module.exports["createProductSpecificAnalyticsIntegrationPayload"] = $a212d78e5c5d5090$export$8c06ae8e7f403dea;

});

parcelRegister("kDXZR", function(module, exports) {
const $aa1060f9b12c78e3$export$ec4825154d679381 = 'error';
const $aa1060f9b12c78e3$export$a924d1f92c0e2e78 = 'growth-experiment';
const $aa1060f9b12c78e3$export$e5025d93161b0712 = 'sendOperationalEvent';
const $aa1060f9b12c78e3$export$5c3e8a6b8e7ba45b = 'growth-error-analytics';
var $aa1060f9b12c78e3$export$264ad599d7cef668 = /*#__PURE__*/ function(Product) {
    Product["JIRA"] = "jira";
    Product["CONFLUENCE"] = "confluence";
    Product["ADMIN_HUB"] = "admin-hub";
    return Product;
}({});
var $aa1060f9b12c78e3$export$dba1278861bf0dc1 = /*#__PURE__*/ function(ErrorType) {
    ErrorType["GRAPHQL"] = "graphql";
    ErrorType["REST"] = "rest";
    ErrorType["ERROR_BOUNDARY"] = "error-boundary";
    ErrorType["GENERIC"] = "generic";
    return ErrorType;
}({});
var $aa1060f9b12c78e3$export$918a9776c0a3cf27 = /*#__PURE__*/ function(Severity) {
    Severity["LOW"] = "low";
    Severity["MEDIUM"] = "medium";
    Severity["HIGH"] = "high";
    return Severity;
}({});
const $aa1060f9b12c78e3$export$a61493d7ab73936 = 'growth';
module.exports["ERROR_ACTION"] = $aa1060f9b12c78e3$export$ec4825154d679381;
module.exports["ERROR_ACTION_SUBJECT"] = $aa1060f9b12c78e3$export$a924d1f92c0e2e78;
module.exports["CONFLUENCE_OPERATIONAL_EVENT_TYPE"] = $aa1060f9b12c78e3$export$e5025d93161b0712;
module.exports["Product"] = $aa1060f9b12c78e3$export$264ad599d7cef668;
module.exports["ErrorType"] = $aa1060f9b12c78e3$export$dba1278861bf0dc1;
module.exports["Severity"] = $aa1060f9b12c78e3$export$918a9776c0a3cf27;
module.exports["EVENT_TAG_GROWTH"] = $aa1060f9b12c78e3$export$a61493d7ab73936;

});

parcelRegister("8rbeW", function(module, exports) {

var $kDXZR = parcelRequire("kDXZR");

const $a0f2ba6b4e00e653$export$f2a94361d01a626c = ({ team: team, experimentMeta: experimentMeta, errorType: errorType, errorMessage: errorMessage, source: source, severity: severity, isActiveExperiment: isActiveExperiment, product: product, additionalAttributes: additionalAttributes = {} })=>{
    const actionSubjectId = `${(0, $kDXZR.ERROR_ACTION_SUBJECT)}-${experimentMeta.experimentKey}-${errorType}`;
    return {
        action: (0, $kDXZR.ERROR_ACTION),
        actionSubject: (0, $kDXZR.ERROR_ACTION_SUBJECT),
        actionSubjectId: actionSubjectId,
        source: experimentMeta.experimentKey,
        attributes: {
            errorType: errorType,
            team: team,
            experimentKey: experimentMeta.experimentKey,
            cohort: experimentMeta?.cohort,
            severity: severity,
            errorMessage: errorMessage,
            isActiveExperiment: isActiveExperiment,
            product: product,
            detailedSource: source,
            ...additionalAttributes
        },
        tags: [
            (0, $kDXZR.EVENT_TAG_GROWTH)
        ]
    };
};
module.exports["createEventPayload"] = $a0f2ba6b4e00e653$export$f2a94361d01a626c;

});

parcelRegister("1yPaR", function(module, exports) {

var $kDXZR = parcelRequire("kDXZR");


var $dSPRj = parcelRequire("dSPRj");

const $252f6e885d08536c$export$d5090ca98c07c12d = (payload)=>{
    const { data: data } = payload;
    return {
        action: data.action,
        actionSubject: data.actionSubject,
        source: data.source,
        actionSubjectId: data.actionSubjectId,
        tags: data.tags
    };
};
const $252f6e885d08536c$export$2144cc21b87dd554 = (payload)=>{
    const { data: data } = payload;
    const eventName = `${data.actionSubject} ${data.action}`;
    return {
        eventName: eventName,
        attributes: data.attributes
    };
};
const $252f6e885d08536c$export$f106561f47f05126 = (event)=>{
    const { payload: payload } = event;
    // Extract attributes from the event payload and create a formatted payload
    // specifically for Jira product integration
    const analyticsEventPayload = (0, $dSPRj.createProductSpecificAnalyticsIntegrationPayload)({
        product: (0, $kDXZR.Product).JIRA,
        team: payload.attributes.team,
        experimentMeta: {
            experimentKey: payload.attributes.experimentKey,
            cohort: payload.attributes.cohort
        },
        errorType: payload.attributes.errorType,
        errorMessage: payload.attributes.errorMessage,
        source: payload.attributes.source,
        severity: payload.attributes.severity
    });
    // Return both payload formats needed for complete Jira analytics integration:
    // 1. createEventPayload: Used with Jira's createAnalyticsEvent
    // 2. fireEventPayload: Used with Jira's fireEvent
    return {
        createEventPayload: $252f6e885d08536c$export$d5090ca98c07c12d(analyticsEventPayload),
        fireEventPayload: $252f6e885d08536c$export$2144cc21b87dd554(analyticsEventPayload)
    };
};
module.exports["convertEventPayloadForJiraCreateAnalyticsEvent"] = $252f6e885d08536c$export$d5090ca98c07c12d;
module.exports["convertEventAttributesForJiraFireEvent"] = $252f6e885d08536c$export$2144cc21b87dd554;

});

parcelRegister("kfAzm", function(module, exports) {
/**
 * Validates that an experiment name doesn't contain spaces.
 * Experiment names with spaces can cause issues in dashboards and analytics tracking.
 *
 * @param experimentName The experiment name to validate
 * @throws Error if experiment name contains spaces
 */ const $be23e90f5d58cba5$export$7fa6b5da621cbeb2 = (experimentName)=>{
    if (experimentName.includes(' ')) throw new Error(`Experiment name "${experimentName}" contains spaces. ` + 'Experiment names must not contain spaces to ensure proper tracking in dashboards. ' + 'Use camelCase or hyphens instead (e.g., "myExperiment" or "my-experiment").');
};
module.exports["validateExperimentName"] = $be23e90f5d58cba5$export$7fa6b5da621cbeb2;

});

parcelRegister("hSerX", function(module, exports) {
/**
 * Enumeration of authorized teams for growth error analytics
 *
 * IMPORTANT: If your team wants to use growth-commons-error-analytics:
 * 1. Add your team name following the convention 'TEAM_NAME = team-name'
 * 2. Create a PR and request review from the #growth-luna channel
 * 3. Provide context about your team and use case in the PR description
 *
 * The growth-luna team reviews all additions to maintain analytics quality
 * and ensure proper integration with dashboards.
 *
 * @example
 * // Adding a new team:
 * // GROWTH_NEW_TEAM = 'growth-new-team', // requires approval
 */ var $15f1b055081784db$export$3e5d0af8e738b082 = /*#__PURE__*/ function(Team) {
    Team["GROWTH_LUNA"] = "growth-luna";
    return Team;
}({});
module.exports["Team"] = $15f1b055081784db$export$3e5d0af8e738b082;

});

parcelRegister("5M47w", function(module, exports) {

var $63Hn9 = parcelRequire("63Hn9");


var $jJ96k = parcelRequire("jJ96k");


var $cozmU = parcelRequire("cozmU");


var $8QJDy = parcelRequire("8QJDy");


var $7mzZ9 = parcelRequire("7mzZ9");


var $jH9cM = parcelRequire("jH9cM");


var $bQm3c = parcelRequire("bQm3c");


var $1ytiN = parcelRequire("1ytiN");


var $8H5XZ = parcelRequire("8H5XZ");


var $7Sm4c = parcelRequire("7Sm4c");





var $lh1MN = parcelRequire("lh1MN");


var $hfUvC = parcelRequire("hfUvC");


var $jMyy4 = parcelRequire("jMyy4");

var $ae96eb60e6557b8b$export$92b15cc7e26a62fb = /*#__PURE__*/ function(CommerceDeepLinksTargetEdition) {
    CommerceDeepLinksTargetEdition["FREE"] = "free";
    CommerceDeepLinksTargetEdition["STANDARD"] = "standard";
    CommerceDeepLinksTargetEdition["PREMIUM"] = "premium";
    return CommerceDeepLinksTargetEdition;
}({});
const $ae96eb60e6557b8b$var$CLOUD_ADMIN_ENV_URLS = {
    PRODUCTION: 'https://admin.atlassian.com',
    STAGING: 'https://admin.stg.atlassian.com'
};
const $ae96eb60e6557b8b$export$16287b6da0e34b4e = '/admin/billing/applications/change-edition/confluence.ondemand';
const $ae96eb60e6557b8b$export$4591cf268e289775 = '/admin/billing/applications';
const $ae96eb60e6557b8b$var$addAtlOriginToUrl = (url)=>{
    const origin = new (0, $8QJDy.default)({
        product: 'confluence'
    });
    return origin.addToUrl(url);
};
const $ae96eb60e6557b8b$export$39685ba9de2c4192 = ({ cloudId: cloudId, environment: environment, orgId: orgId })=>{
    const CLOUD_ADMIN_URL = $ae96eb60e6557b8b$var$CLOUD_ADMIN_ENV_URLS[environment ?? 'PRODUCTION'];
    if (orgId || cloudId) return orgId ? `${CLOUD_ADMIN_URL}/o/${orgId}/billing-preview` : `${CLOUD_ADMIN_URL}/s/${cloudId}/billing-preview`;
    // In an extreme case where we cannot detect cloudId or orgId, we route user to main AdminHub page.
    return CLOUD_ADMIN_URL;
};
const $ae96eb60e6557b8b$var$buildPlanSelectionLink = (params)=>{
    const { cloudId: cloudId, commerceBackendName: commerceBackendName, environment: environment, entitlementId: entitlementId, transactionAccountId: transactionAccountId, orgId: orgId } = params;
    if (commerceBackendName === (0, $7mzZ9.COMMERCE_BACKEND_HAMS)) return $ae96eb60e6557b8b$export$16287b6da0e34b4e;
    if (commerceBackendName === (0, $7mzZ9.COMMERCE_BACKEND_CCP) && entitlementId && transactionAccountId) {
        const CLOUD_ADMIN_URL = $ae96eb60e6557b8b$var$CLOUD_ADMIN_ENV_URLS[environment ?? 'PRODUCTION'];
        // https://admin.atlassian.com/billing/:txaId/entitlement/:entitlementId/change-plan?referrer=[referrer]
        // See https://hello.atlassian.net/wiki/spaces/BILLIONS/pages/2652063891/How+to+Deeplink+to+BAC+s+change+plan
        return `${CLOUD_ADMIN_URL}/billing/${transactionAccountId}/entitlement/${entitlementId}/change-plan?referrer=confluence`;
    }
    return $ae96eb60e6557b8b$export$39685ba9de2c4192({
        cloudId: cloudId,
        environment: environment,
        orgId: orgId
    });
};
const $ae96eb60e6557b8b$var$buildPlanConsentLink = (params)=>{
    const { cloudId: cloudId, commerceBackendName: commerceBackendName, entitlementId: entitlementId, environment: environment, orgId: orgId, transactionAccountId: transactionAccountId, targetEdition: targetEdition } = params;
    if (commerceBackendName === (0, $7mzZ9.COMMERCE_BACKEND_HAMS)) return targetEdition ? `${$ae96eb60e6557b8b$var$buildPlanSelectionLink(params)}/${targetEdition}` : $ae96eb60e6557b8b$var$buildPlanSelectionLink(params);
    if (commerceBackendName === (0, $7mzZ9.COMMERCE_BACKEND_CCP) && entitlementId && transactionAccountId) // https://admin.atlassian.com/billing/:txaId/entitlement/:entitlementId/change-plan?offeringName=[offering name]&referrer=[referrer]
    // See https://hello.atlassian.net/wiki/spaces/BILLIONS/pages/2820329173/How+to+Deeplink+change+plan+consent
    return targetEdition ? `${$ae96eb60e6557b8b$var$buildPlanSelectionLink(params)}&offeringName=${targetEdition}` : $ae96eb60e6557b8b$var$buildPlanSelectionLink(params);
    return $ae96eb60e6557b8b$export$39685ba9de2c4192({
        cloudId: cloudId,
        environment: environment,
        orgId: orgId
    });
};
const $ae96eb60e6557b8b$var$buildSubscriptionDetailsLink = (params)=>{
    const { cloudId: cloudId, commerceBackendName: commerceBackendName, environment: environment, entitlementId: entitlementId, orgId: orgId, transactionAccountId: transactionAccountId } = params;
    if (commerceBackendName === (0, $7mzZ9.COMMERCE_BACKEND_HAMS)) return $ae96eb60e6557b8b$export$4591cf268e289775;
    if (commerceBackendName === (0, $7mzZ9.COMMERCE_BACKEND_CCP) && entitlementId && transactionAccountId) {
        const CLOUD_ADMIN_URL = $ae96eb60e6557b8b$var$CLOUD_ADMIN_ENV_URLS[environment ?? 'PRODUCTION'];
        // https://admin.atlassian.com/billing/:txaId/entitlement/:entitlementId
        return `${CLOUD_ADMIN_URL}/billing/${transactionAccountId}/entitlement/${entitlementId}`;
    }
    return $ae96eb60e6557b8b$export$39685ba9de2c4192({
        cloudId: cloudId,
        environment: environment,
        orgId: orgId
    });
};
// (Concept is adopted from Kent C. Dodds here:
//  https://kentcdodds.com/blog/get-a-catch-block-error-message-with-typescript)
const $ae96eb60e6557b8b$var$getErrorMessage = (label, error)=>{
    const message = error instanceof Error ? error.message : String(error);
    return `${label}: ${message}`;
};
const $ae96eb60e6557b8b$export$91505ae0b86ded0b = ({ targetEdition: targetEdition, skipDeepLinks: skipDeepLinks = false })=>{
    const { environment: environment, cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    if (!isSiteAdmin || !cloudId) skipDeepLinks = true;
    /**
   * The best practice advocates for one graphql per component and ideally no graphql quries in a hook
   * but to construct the deeplink, we need to:
   * 1. first call Commerce API to retrieve the Confluence instance backend service (CCP or HAMS),
   * 2. for CCP, call ccgraphql to retrieve the ccpEntitlementId
   * 3. for CCP, call AGG to retrieve the CCP transaction account Id using the ccpEntitlementId retrieved in step #2.
   *
   * This is a stop gap solution while we work with Commerce to eventually have one AGG query
   * to provide everything we need with just a CloudId and the product key (e.g. confluence
   */ const { commerceBackendName: commerceBackendName, loading: commerceBackendNameLoading, error: commerceBackendNameError } = (0, $hfUvC.useCommerceRolloutInformation)(skipDeepLinks || (0, $jH9cM.isFedRamp)());
    // If it is in FedRamp, we can assume it is CCP backend.
    // More details -> https://atlassian.slack.com/archives/C04LF8UKAE4/p1734981625650579
    const isCcpBackend = commerceBackendName === (0, $7mzZ9.COMMERCE_BACKEND_CCP) || (0, $jH9cM.isFedRamp)();
    const { data: ccpEntitlementIdData, loading: ccpEntitlementIdLoading, error: ccpEntitlementIdError } = (0, $jMyy4.useQueryInterop)(/** @schema cc */ (0, $jJ96k.default), {
        skip: skipDeepLinks || !isCcpBackend,
        __callerPackage__: "change-edition"
    });
    const ccpEntitlementId = !ccpEntitlementIdLoading ? (0, $lh1MN.getCcpEntitlementFromQuery)(ccpEntitlementIdData) : undefined;
    const { data: ccpEntitlementTxaIdData, loading: ccpEntitlementTxaIdLoading, error: ccpEntitlementTxaIdError } = (0, $jMyy4.useQueryInterop)(/** @schema agg */ (0, $63Hn9.default), {
        variables: {
            entitlementId: ccpEntitlementId || '',
            targetEditionName: targetEdition || ''
        },
        skip: skipDeepLinks || !isCcpBackend || !ccpEntitlementId,
        interopApolloAggClient: true,
        __callerPackage__: "change-edition"
    });
    if (skipDeepLinks) return {
        commerceBackendName: null,
        planSelectionDeepLink: undefined,
        planConsentDeepLink: undefined,
        subscriptionDetailsDeepLink: undefined,
        loading: false,
        errorMessage: undefined
    };
    let errorMessage;
    let planSelectionDeepLink;
    let planConsentDeepLink;
    let subscriptionDetailsDeepLink;
    let changeOfferingDeepLink;
    try {
        const entitlementId = ccpEntitlementId;
        const transactionAccountId = ccpEntitlementTxaIdData?.ccp?.entitlement?.transactionAccountId;
        // format -> https://admin.stg.atlassian.com/billing/UUID/entitlement/TWC-UUID-OR-CONF/change-plan?requireAtlOrigin=true&referrer=confluence
        // Note: if product is TWC Confluence, then there is no referrer param added from ccp-graphql
        const changeOfferingExperienceUrl = ccpEntitlementTxaIdData?.ccp?.entitlement?.experienceCapabilities?.changeOfferingV2?.experienceUrl ?? undefined;
        const commerceParams = {
            cloudId: cloudId,
            commerceBackendName: commerceBackendName,
            environment: environment,
            entitlementId: entitlementId,
            orgId: orgId,
            transactionAccountId: transactionAccountId || undefined
        };
        planSelectionDeepLink = $ae96eb60e6557b8b$var$addAtlOriginToUrl($ae96eb60e6557b8b$var$buildPlanSelectionLink(commerceParams));
        planConsentDeepLink = $ae96eb60e6557b8b$var$addAtlOriginToUrl($ae96eb60e6557b8b$var$buildPlanConsentLink({
            targetEdition: targetEdition,
            ...commerceParams
        }));
        if (changeOfferingExperienceUrl) {
            const url = new URL(changeOfferingExperienceUrl);
            url.searchParams.set('referrer', 'confluence');
            changeOfferingDeepLink = $ae96eb60e6557b8b$var$addAtlOriginToUrl(url.toString());
        }
        subscriptionDetailsDeepLink = $ae96eb60e6557b8b$var$addAtlOriginToUrl($ae96eb60e6557b8b$var$buildSubscriptionDetailsLink(commerceParams));
        // Mark all graphql errors as handled since we will return the fallback plan selection url
        if ((0, $8H5XZ.isGraphQLError)(ccpEntitlementIdError) && !(0, $7Sm4c.isErrorMarkedAsHandled)(ccpEntitlementIdError)) (0, $7Sm4c.markErrorAsHandled)(ccpEntitlementIdError);
        if ((0, $8H5XZ.isGraphQLError)(ccpEntitlementTxaIdError) && !(0, $7Sm4c.isErrorMarkedAsHandled)(ccpEntitlementTxaIdError)) (0, $7Sm4c.markErrorAsHandled)(ccpEntitlementTxaIdError);
        if (commerceBackendNameError) errorMessage = $ae96eb60e6557b8b$var$getErrorMessage('Error retrieving Commerce Backend Service', commerceBackendNameError);
        else if (ccpEntitlementIdError) errorMessage = $ae96eb60e6557b8b$var$getErrorMessage('Error retrieving CCP Entitlement Id', ccpEntitlementIdError);
        else if (ccpEntitlementTxaIdError) errorMessage = $ae96eb60e6557b8b$var$getErrorMessage('Error retrieving CCP Transaction Account Id', ccpEntitlementTxaIdError);
    } catch (e) {
        errorMessage = $ae96eb60e6557b8b$var$getErrorMessage('Error in useCommerceDeepLinks', e);
    }
    const loading = commerceBackendNameLoading || ccpEntitlementIdLoading || ccpEntitlementTxaIdLoading;
    return {
        commerceBackendName: commerceBackendName,
        planSelectionDeepLink: planSelectionDeepLink,
        planConsentDeepLink: changeOfferingDeepLink || planConsentDeepLink,
        subscriptionDetailsDeepLink: subscriptionDetailsDeepLink,
        loading: loading,
        errorMessage: errorMessage
    };
};
module.exports["CommerceDeepLinksTargetEdition"] = $ae96eb60e6557b8b$export$92b15cc7e26a62fb;
module.exports["useCommerceDeepLinks"] = $ae96eb60e6557b8b$export$91505ae0b86ded0b;

});

parcelRegister("63Hn9", function(module, exports) {
/**
 * @generated SignedSource<<bc80cc11ea20a8c6e36dd6a82fcb8445>>
 * @relayHash 1550b53499cc9c4c43997e297fa050c5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 10738af8cd0e26e61c93e96a9aa88d2a81fd8fade160ae57f575778fdf62b7c5
const $9dd5459212e2b154$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "entitlementId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "targetEditionName"
        }
    ], v1 = [
        {
            "concreteType": "CcpQueryApi",
            "kind": "LinkedField",
            "name": "ccp",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "entitlementId"
                        }
                    ],
                    "concreteType": "CcpEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "transactionAccountId"
                        },
                        {
                            "concreteType": "CcpEntitlementExperienceCapabilities",
                            "kind": "LinkedField",
                            "name": "experienceCapabilities",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "offeringName",
                                            "variableName": "targetEditionName"
                                        }
                                    ],
                                    "concreteType": "CcpChangeOfferingExperienceCapability",
                                    "kind": "LinkedField",
                                    "name": "changeOfferingV2",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "experienceUrl"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCommerceDeepLinksCcpTransactionAccountIdQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCommerceDeepLinksCcpTransactionAccountIdQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1550b53499cc9c4c43997e297fa050c5",
            "id": "10738af8cd0e26e61c93e96a9aa88d2a81fd8fade160ae57f575778fdf62b7c5",
            "metadata": {},
            "name": "useCommerceDeepLinksCcpTransactionAccountIdQuery",
            "operationKind": "query",
            "text": "query useCommerceDeepLinksCcpTransactionAccountIdQuery($entitlementId:ID!,$targetEditionName:String){ccp{entitlement(id:$entitlementId){transactionAccountId,experienceCapabilities{changeOfferingV2(offeringName:$targetEditionName){experienceUrl}},id}}}"
        }
    };
}();
$9dd5459212e2b154$var$node.hash = "0078d9648e47947324143eae530f4046";
var $9dd5459212e2b154$export$2e2bcd8739ae039 = $9dd5459212e2b154$var$node;
module.exports["default"] = $9dd5459212e2b154$export$2e2bcd8739ae039;

});

parcelRegister("jJ96k", function(module, exports) {
/**
 * @generated SignedSource<<1ddb95bbcdb9a7b40f1063fa499f8cc1>>
 * @relayHash 7b6d56299e8bad23570ed5580bdc5641
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6a5e4f4a4d3d13a42fadcbccaa10e14ae28ca67b7e22b87a8246aa660c4e7797
const $edae1a4299d7e8da$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicenseStates",
                    "kind": "LinkedField",
                    "name": "licenseStates",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "LicenseState",
                            "kind": "LinkedField",
                            "name": "confluence",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "ccpEntitlementId"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "Tenant",
            "kind": "LinkedField",
            "name": "tenant",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "cloudId"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useCommerceDeepLinksCcpEntitlementQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useCommerceDeepLinksCcpEntitlementQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "7b6d56299e8bad23570ed5580bdc5641",
            "id": "6a5e4f4a4d3d13a42fadcbccaa10e14ae28ca67b7e22b87a8246aa660c4e7797",
            "metadata": {},
            "name": "useCommerceDeepLinksCcpEntitlementQuery",
            "operationKind": "query",
            "text": "query useCommerceDeepLinksCcpEntitlementQuery{confluence_tenantContext{licenseStates{confluence{ccpEntitlementId}}},tenant{cloudId}}"
        }
    };
}();
$edae1a4299d7e8da$var$node.hash = "f1b8b946a65b7c16eb6735dad6d5b323";
var $edae1a4299d7e8da$export$2e2bcd8739ae039 = $edae1a4299d7e8da$var$node;
module.exports["default"] = $edae1a4299d7e8da$export$2e2bcd8739ae039;

});

parcelRegister("7mzZ9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3Jm5C = parcelRequire("3Jm5C");


var $5Ntrt = parcelRequire("5Ntrt");


var $glP0S = parcelRequire("glP0S");

var $9Ipdf = parcelRequire("9Ipdf");

var $6T8f4 = parcelRequire("6T8f4");


var $lDGcP = parcelRequire("lDGcP");

const $3f033e7d4421dbbb$export$56507f8f3f7349a5 = 'HAMS';
const $3f033e7d4421dbbb$export$9a39331b1bb2f849 = 'CCP';
const $3f033e7d4421dbbb$export$49ab1426acf387e4 = async (_params, _options)=>{
    return {
        payload: {
            commerceBackend: 'CCP',
            ccp: {}
        },
        error: undefined,
        exception: undefined
    };
};
const $3f033e7d4421dbbb$export$532017a098b73852 = (params, options)=>{
    const fetch = (0, $3Jm5C.useCommerceFetch)();
    const effectiveOptions = (0, $cozmU.useMemo)(()=>({
            fetch: fetch,
            ...options
        }), [
        fetch,
        options
    ]);
    const startTask = (0, $6T8f4.useTaskTracker)({
        action: 'fetched',
        actionSubject: 'commerceRolloutInformation',
        source: 'unknown'
    });
    return (0, $5Ntrt.useFetchService)((0, $cozmU.useCallback)(async ()=>{
        const taskResult = await startTask(async ()=>{
            const result = await $3f033e7d4421dbbb$export$49ab1426acf387e4(params, effectiveOptions);
            if ((0, $lDGcP.isSuccessful)(result)) return {
                succeed: {
                    payload: result.payload
                }
            };
            else if ((0, $lDGcP.isException)(result)) // fetch can sometimes throw, but most likely this is a bug
            return {
                fail: {
                    payload: result.exception,
                    loggablePayload: result.exception,
                    responsibleService: (0, $9Ipdf).COMMERCE_LIBRARIES,
                    probabilityOfBug: (0, $glP0S).GUARANTEED
                }
            };
            return {
                // Failed response from server.
                fail: {
                    payload: result.error,
                    responsibleService: (0, $9Ipdf).BILLING_API_GATEWAY,
                    // TODO: Review HTTP codes to differentiate between bug and normal errors
                    probabilityOfBug: (0, $glP0S).MAYBE
                }
            };
        });
        if (taskResult.succeed !== undefined) return taskResult.succeed.payload;
        throw taskResult.fail.payload;
    }, [
        startTask,
        params,
        effectiveOptions
    ]));
};
module.exports["COMMERCE_BACKEND_HAMS"] = $3f033e7d4421dbbb$export$56507f8f3f7349a5;
module.exports["COMMERCE_BACKEND_CCP"] = $3f033e7d4421dbbb$export$9a39331b1bb2f849;
module.exports["fetchCommerceRolloutInformation"] = $3f033e7d4421dbbb$export$49ab1426acf387e4;

});

parcelRegister("3Jm5C", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $a33Aa = parcelRequire("a33Aa");


var $4WRsC = parcelRequire("4WRsC");


var $50xL3 = parcelRequire("50xL3");


var $7w3I8 = parcelRequire("7w3I8");


var $bh60g = parcelRequire("bh60g");


var $6hHTZ = parcelRequire("6hHTZ");

const $da757615b319bd0e$export$5f844fc0012b62a = ()=>{
    const commerceContextFetch = (0, $bh60g.useCommerceOverride)(fetch);
    const dispatchSentryException = (0, $50xL3.useSentryExceptionDispatch)();
    return (0, $cozmU.useCallback)(async (...args)=>{
        const startTime = performance.now();
        const [fetchInput] = args;
        const sanitizedUrl = (0, $7w3I8.sanitizeUrlString)((0, $6hHTZ.getRequestUrl)(fetchInput));
        try {
            const response = await commerceContextFetch(...args);
            if (response.status >= 400) dispatchSentryException({
                exception: new Error(`Status: ${response.status}\nURL: ${sanitizedUrl}`)
            });
            (0, $a33Aa.addSpanToAll)('fetch', sanitizedUrl, [
                {
                    name: 'network'
                }
            ], startTime, performance.now(), JSON.stringify(response).length);
            return response;
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn(error);
            const oldErrorMessage = (()=>{
                if (error instanceof Error) return error.stack ?? error.toString();
                else return JSON.stringify(error);
            })();
            const newErrorMessage = `An error occurred when fetching from ${sanitizedUrl}\n\n ${oldErrorMessage}`;
            const wrappedError = new Error(newErrorMessage);
            dispatchSentryException({
                exception: wrappedError
            });
            throw error;
        }
    }, [
        commerceContextFetch,
        dispatchSentryException
    ]);
};
const $da757615b319bd0e$export$2eeff918208c7909 = (request, dispatchSentryException)=>request.catch((error)=>{
        // reportHttpError doesn't dispatch url as HttpResponseError has a resource name in the message
        if (error instanceof (0, $4WRsC.HttpResponseError)) dispatchSentryException({
            exception: error
        });
        const oldErrorMessage = (()=>{
            if (error instanceof Error) return error.stack ?? error.toString();
            else return JSON.stringify(error);
        })();
        const newErrorMessage = `An error occurred when fetching data\n\n ${oldErrorMessage}`;
        dispatchSentryException({
            exception: new Error(newErrorMessage)
        });
        return error;
    });
module.exports["useCommerceFetch"] = $da757615b319bd0e$export$5f844fc0012b62a;

});

parcelRegister("4WRsC", function(module, exports) {
class $e4732a7ef2c5ad5a$export$d2f2761cbe9cebf2 extends Error {
    constructor(resourceName, statusCode, body){
        super(`Unable to fetch ${resourceName}, status: ${statusCode}`);
        this.statusCode = void 0;
        this.body = void 0;
        this.name = 'HttpResponseError';
        this.statusCode = statusCode;
        this.body = body;
        // necessary as Subclassing Error needs special treatment in typescript for some compilation targets
        //https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $e4732a7ef2c5ad5a$export$d2f2761cbe9cebf2.prototype);
    }
}
const $e4732a7ef2c5ad5a$export$a4c208475de70990 = async (resourceName, response)=>{
    const res = await response;
    if (res.ok) return response;
    throw new $e4732a7ef2c5ad5a$export$d2f2761cbe9cebf2(resourceName, res.status, // ignore error if there is no body,
    // there is no way to check if body is set as https://developer.mozilla.org/en-US/docs/Web/API/Body/bodyUsed is not supported by many browsers
    await res.json().catch(()=>undefined));
};
module.exports["HttpResponseError"] = $e4732a7ef2c5ad5a$export$d2f2761cbe9cebf2;
module.exports["rejectOnHttpError"] = $e4732a7ef2c5ad5a$export$a4c208475de70990;

});

parcelRegister("50xL3", function(module, exports) {

var $5xYJM = parcelRequire("5xYJM");


var $8SiA5 = parcelRequire("8SiA5");


var $44Iij = parcelRequire("44Iij");

const $e8f2a3b45cf30eda$export$3c3f21d4489e178a = (0, $5xYJM.internalGasV3UIEventChannel).useBreadcrumbedEventDispatch;
const $e8f2a3b45cf30eda$export$5e75c4fb0a07e6f4 = (0, $5xYJM.internalGasV3ScreenEventChannel).useEventDispatch;
const $e8f2a3b45cf30eda$export$eb1dac57abae25e8 = (0, $5xYJM.internalGasV3TrackEventChannel).useBreadcrumbedEventDispatch;
const $e8f2a3b45cf30eda$export$ab6d20b2228c09c6 = (0, $5xYJM.internalGasV3OperationalEventChannel).useBreadcrumbedEventDispatch;
const $e8f2a3b45cf30eda$export$cf4d833c52e18bed = (0, $5xYJM.internalSentryExceptionChannel).useBreadcrumbedEventDispatch;
const $e8f2a3b45cf30eda$export$8eb9a37a282b8ea6 = (0, $8SiA5.createAtlaskitToEventChannelRepackager)($e8f2a3b45cf30eda$export$3c3f21d4489e178a);
const $e8f2a3b45cf30eda$export$d6cab26720f11779 = (0, $5xYJM.breadcrumbMountedEventChannel).Listener;
const $e8f2a3b45cf30eda$export$794ea2871d096951 = (Component, name, attributes)=>(0, $44Iij.withBreadcrumb)(Component, (0, $5xYJM.Breadcrumb), name, attributes);
module.exports["useSentryExceptionDispatch"] = $e8f2a3b45cf30eda$export$cf4d833c52e18bed;

});

parcelRegister("5xYJM", function(module, exports) {

var $44Iij = parcelRequire("44Iij");


var $9Wigt = parcelRequire("9Wigt");

const $e0c123191fd87b1c$var$breadcrumbAPI = (0, $44Iij.createBreadcrumbAPI)();
const $e0c123191fd87b1c$export$1622e7b9340efb0 = $e0c123191fd87b1c$var$breadcrumbAPI.breadcrumbMountedEventChannel;
const $e0c123191fd87b1c$export$dabcc1ec9dd9d1cc = $e0c123191fd87b1c$var$breadcrumbAPI.Breadcrumb;
const $e0c123191fd87b1c$export$a841c408695b0137 = $e0c123191fd87b1c$var$breadcrumbAPI.useGetBreadcrumbs;
const $e0c123191fd87b1c$export$58a908b728d2cddc = (0, $9Wigt.createCatchingEventChannel)();
const $e0c123191fd87b1c$export$34eb9485fd3a664a = (0, $9Wigt.createCatchingEventChannel)();
const $e0c123191fd87b1c$export$fb5e587076f78057 = (0, $9Wigt.createCatchingEventChannel)();
const $e0c123191fd87b1c$export$f92d259194a988f8 = (0, $9Wigt.createCatchingEventChannel)();
const $e0c123191fd87b1c$export$d9c23c680d73705d = (0, $9Wigt.createCatchingEventChannel)();
const $e0c123191fd87b1c$export$b7973f9532f3f87f = (0, $44Iij.createBreadcrumbedEventChannel)($e0c123191fd87b1c$var$breadcrumbAPI, (0, $9Wigt.createCatchingEventChannel));
const $e0c123191fd87b1c$export$5a78c7e669ed705e = (0, $9Wigt.createCatchingEventChannel)();
const $e0c123191fd87b1c$export$90a2fbbf51eb525f = (0, $44Iij.createBreadcrumbedEventChannel)($e0c123191fd87b1c$var$breadcrumbAPI, (0, $9Wigt.createCatchingEventChannel));
const $e0c123191fd87b1c$export$c70a8fa9e6b52c91 = (0, $44Iij.createBreadcrumbedEventChannel)($e0c123191fd87b1c$var$breadcrumbAPI, (0, $9Wigt.createCatchingEventChannel));
const $e0c123191fd87b1c$export$d9101fe70b7457a1 = (0, $44Iij.createBreadcrumbedEventChannel)($e0c123191fd87b1c$var$breadcrumbAPI, (0, $9Wigt.createCatchingEventChannel));
module.exports["breadcrumbMountedEventChannel"] = $e0c123191fd87b1c$export$1622e7b9340efb0;
module.exports["Breadcrumb"] = $e0c123191fd87b1c$export$dabcc1ec9dd9d1cc;
module.exports["internalGasV3UIEventChannel"] = $e0c123191fd87b1c$export$b7973f9532f3f87f;
module.exports["internalGasV3ScreenEventChannel"] = $e0c123191fd87b1c$export$5a78c7e669ed705e;
module.exports["internalGasV3TrackEventChannel"] = $e0c123191fd87b1c$export$90a2fbbf51eb525f;
module.exports["internalGasV3OperationalEventChannel"] = $e0c123191fd87b1c$export$c70a8fa9e6b52c91;
module.exports["internalSentryExceptionChannel"] = $e0c123191fd87b1c$export$d9101fe70b7457a1;

});

parcelRegister("44Iij", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9Wigt = parcelRequire("9Wigt");

const $737ecd1f578fc7b5$var$emptyObject = {};
const $737ecd1f578fc7b5$export$783e5d823c500873 = ()=>{
    const context = /*#__PURE__*/ (0, $cozmU.createContext)(()=>undefined);
    const useGetBreadcrumbs = ()=>(0, $cozmU.useContext)(context);
    const breadcrumbMountedEventChannel = (0, $9Wigt.createEventChannel)();
    const { useEventDispatch: useEventDispatch } = breadcrumbMountedEventChannel;
    const EmitEventOnMount = ({ name: name, getMountedBreadcrumbPayload: getMountedBreadcrumbPayload })=>{
        const eventDispatch = useEventDispatch();
        (0, $cozmU.useEffect)(()=>{
            // Should always be defined at this point.
            eventDispatch(getMountedBreadcrumbPayload());
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            name
        ]);
        return null;
    };
    const Breadcrumb = ({ children: children, ...breadcrumbPayload })=>{
        const getParentBreadcrumbs = useGetBreadcrumbs();
        // TODO: Type inference doesn't seem to understand that children and name are never a part of breadcrumbPayload. Investigate and fix.
        const castBreadcrumbPayload = breadcrumbPayload;
        // Prevents breadcrumb callback from being recreated everytime props change/every-render
        const breadcrumbRef = (0, $cozmU.useRef)(castBreadcrumbPayload);
        (0, $cozmU.useLayoutEffect)(()=>{
            // Ensures that the breadcrumb only updates when it component is mounted
            breadcrumbRef.current = castBreadcrumbPayload;
        });
        // TODO: Memoize this in the future?
        const getMountedBreadcrumbPayload = (0, $cozmU.useCallback)(()=>({
                breadcrumbs: [
                    ...getParentBreadcrumbs()?.breadcrumbs ?? [],
                    breadcrumbRef.current
                ],
                payload: breadcrumbRef.current
            }), [
            getParentBreadcrumbs
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(EmitEventOnMount, {
            name: breadcrumbPayload.name,
            getMountedBreadcrumbPayload: getMountedBreadcrumbPayload
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(context.Provider, {
            value: getMountedBreadcrumbPayload
        }, children));
    };
    return {
        breadcrumbMountedEventChannel: /**
     * An event channel whos event represents that a breadcrumb was mounted
     */ breadcrumbMountedEventChannel,
        Breadcrumb: Breadcrumb,
        useGetBreadcrumbs: useGetBreadcrumbs
    };
};
const $737ecd1f578fc7b5$export$d3653322274df895 = ({ useGetBreadcrumbs: useGetBreadcrumbs }, createEventChannelFn = (0, $9Wigt.createEventChannel))=>{
    const { Listener: Listener, useEventDispatch: useEventDispatch } = createEventChannelFn();
    const useBreadcrumbedEventDispatch = ()=>{
        const eventDispatch = useEventDispatch();
        const getParentBreadcrumbs = useGetBreadcrumbs();
        const breadcrumbedEventDispatch = (0, $cozmU.useCallback)((payload)=>eventDispatch({
                breadcrumbs: getParentBreadcrumbs()?.breadcrumbs ?? [],
                payload: payload
            }), [
            getParentBreadcrumbs,
            eventDispatch
        ]);
        return breadcrumbedEventDispatch;
    };
    return {
        Listener: Listener,
        useEventDispatch: useEventDispatch,
        useBreadcrumbedEventDispatch: useBreadcrumbedEventDispatch
    };
};
const $737ecd1f578fc7b5$export$794ea2871d096951 = (Component, Breadcrumb, name, // TODO: Fix up this type
breadcrumbFields = $737ecd1f578fc7b5$var$emptyObject)=>{
    const ComponentWithBreadcrumb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Breadcrumb, {
            ...breadcrumbFields,
            name: name
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props));
    return ComponentWithBreadcrumb;
};
module.exports["createBreadcrumbAPI"] = $737ecd1f578fc7b5$export$783e5d823c500873;
module.exports["createBreadcrumbedEventChannel"] = $737ecd1f578fc7b5$export$d3653322274df895;
module.exports["withBreadcrumb"] = $737ecd1f578fc7b5$export$794ea2871d096951;

});

parcelRegister("9Wigt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $813d3e232857ecbd$export$5f3dbb5babc7e42e = (defaultOnEventCallback)=>{
    const context = /*#__PURE__*/ (0, $cozmU.createContext)(defaultOnEventCallback);
    const useEventDispatch = ()=>{
        const onEventCallback = (0, $cozmU.useContext)(context);
        const fireEventCallback = (0, $cozmU.useCallback)((event)=>{
            onEventCallback?.(event);
        }, [
            onEventCallback
        ]);
        return fireEventCallback;
    };
    const EventCatcher = ({ onEvent: onEvent, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(context.Provider, {
            value: onEvent
        }, children);
    return {
        Listener: EventCatcher,
        useEventDispatch: useEventDispatch
    };
};
const $813d3e232857ecbd$export$7b182ad6fa711a33 = ()=>{
    const catchingEventChannel = $813d3e232857ecbd$export$5f3dbb5babc7e42e();
    const ListenerThatDoesntConsumeEvent = $813d3e232857ecbd$export$a5fa32b3c7f79e99({
        from: catchingEventChannel.Listener,
        to: catchingEventChannel.useEventDispatch
    });
    return {
        Listener: ListenerThatDoesntConsumeEvent,
        useEventDispatch: catchingEventChannel.useEventDispatch
    };
};
const $813d3e232857ecbd$export$21d0f08655d40180 = (...listenersToCombine)=>{
    const CombinedListener = ({ children: children, onEvent: onEvent })=>{
        let wrappedChildren = children;
        for (const ListenerToCombine of listenersToCombine)wrappedChildren = ListenerToCombine({
            onEvent: onEvent,
            children: wrappedChildren
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, wrappedChildren);
    };
    return CombinedListener;
};
const $813d3e232857ecbd$export$9591aa59b8e3deeb = ({ from: inboundListenerValue, to: useOutboundEventDispatch, useTransformer: useTransformer })=>{
    const InboundListener = Array.isArray(inboundListenerValue) ? $813d3e232857ecbd$export$21d0f08655d40180(...inboundListenerValue) : inboundListenerValue;
    const Transformer = ({ children: children, ...transformerProps })=>{
        const dispatchTransformedEvent = useOutboundEventDispatch();
        const transform = useTransformer(transformerProps);
        const transformFn = (0, $cozmU.useCallback)((payload)=>{
            const transformed = transform(payload);
            dispatchTransformedEvent(transformed);
        }, [
            dispatchTransformedEvent,
            transform
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InboundListener, {
            onEvent: transformFn
        }, children);
    };
    return Transformer;
};
const $813d3e232857ecbd$export$a5fa32b3c7f79e99 = ({ from: from, to: to })=>{
    const ListenerThatDoesntConsumeEvent = $813d3e232857ecbd$export$9591aa59b8e3deeb({
        from: from,
        to: to,
        useTransformer: ({ onEvent: onEvent })=>(0, $cozmU.useCallback)((payload)=>{
                onEvent(payload);
                return payload;
            }, [
                onEvent
            ])
    });
    return ListenerThatDoesntConsumeEvent;
};
const $813d3e232857ecbd$export$6c91a1925c226122 = (Listener, filter)=>{
    const FilteredListener = ({ onEvent: onEvent, ...other })=>{
        const filteredOnEvent = (0, $cozmU.useCallback)((eventPayload)=>{
            if (filter(eventPayload)) onEvent(eventPayload);
        }, [
            onEvent
        ]);
        return Listener({
            onEvent: filteredOnEvent,
            ...other
        });
    };
    return FilteredListener;
};
const $813d3e232857ecbd$export$acca048df1683b81 = (children, components)=>{
    let wrappedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    for(let i = components.length - 1; i >= 0; i--){
        const { Listener: Listener, onEvent: onEvent } = components[i];
        wrappedChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Listener, {
            onEvent: onEvent
        }, wrappedChildren);
    }
    return wrappedChildren;
};
module.exports["createCatchingEventChannel"] = $813d3e232857ecbd$export$5f3dbb5babc7e42e;
module.exports["createEventChannel"] = $813d3e232857ecbd$export$7b182ad6fa711a33;

});

parcelRegister("8SiA5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3d3WW = parcelRequire("3d3WW");

var $9DHhW = parcelRequire("9DHhW");

const $76b8bf28f736269c$var$ATLASKIT_CHANNEL = 'atlaskit';
const $76b8bf28f736269c$export$b1e3a2222bb9a86d = (useEventDispatch, channel)=>{
    const RepackageAnalyticsNextEvent = ({ children: children, ...uiProperties })=>{
        const dispatchAnalytics = useEventDispatch();
        const repackageAtlaskitEvent = (0, $cozmU.useCallback)((event)=>{
            dispatchAnalytics({
                ...uiProperties,
                ...event.payload,
                attributes: {
                    ...uiProperties.attributes,
                    ...event.payload.attributes
                }
            });
        }, [
            dispatchAnalytics,
            uiProperties
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
            channel: channel,
            onEvent: repackageAtlaskitEvent
        }, children);
    };
    return RepackageAnalyticsNextEvent;
};
const $76b8bf28f736269c$export$1ec809871e34d2f0 = (useEventDispatch)=>{
    const RepackageAtlaskitEvent = $76b8bf28f736269c$export$b1e3a2222bb9a86d(useEventDispatch, 'atlaskit');
    return RepackageAtlaskitEvent;
};
const $76b8bf28f736269c$export$ad0c43fbe23d07ab = (Listener, channel = $76b8bf28f736269c$var$ATLASKIT_CHANNEL)=>{
    return ({ children: children })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
        const fireAsAtlaskitEvent = (0, $cozmU.useCallback)((payload)=>{
            createAnalyticsEvent(payload).fire(channel);
        }, [
            createAnalyticsEvent
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Listener, {
            onEvent: fireAsAtlaskitEvent
        }, children);
    };
};
module.exports["createAtlaskitToEventChannelRepackager"] = $76b8bf28f736269c$export$1ec809871e34d2f0;

});

parcelRegister("7w3I8", function(module, exports) {
/**
 * @param url The URL you want to sanitize
 * @returns A URL string without any user generated content (UGC) or PII (personally identifiable information). The URL will not necessarily be valid URL.
 */ const $7fcd339085c02b2e$export$ceb09b958e605eff = (url)=>{
    // TODO: Should redact anything not from atlassian.com/atlassian.net/bitbucket.org/etc
    return url.replace(/\?.*$/, '');
};
module.exports["sanitizeUrlString"] = $7fcd339085c02b2e$export$ceb09b958e605eff;

});

parcelRegister("bh60g", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dhwg6 = parcelRequire("dhwg6");

const $e81d37085298e4b7$export$8d3ccdf5c3b9600a = ({ children: children, overrides: overrides })=>{
    const [registry] = (0, $cozmU.useState)(()=>new Map(overrides));
    (0, $cozmU.useEffect)(()=>{
        const callbacks = overrides.map(([subject, target])=>$e81d37085298e4b7$export$87a46fc2314946e0(registry, subject, target));
        return ()=>callbacks.forEach((cb)=>cb());
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    overrides);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dhwg6.overrideContext).Provider, {
        value: registry
    }, children);
};
const $e81d37085298e4b7$export$edb6244a86733174 = ()=>(0, $cozmU.useContext)((0, $dhwg6.overrideContext));
const $e81d37085298e4b7$export$87a46fc2314946e0 = (registry, subject, override)=>{
    registry.set(subject, override);
    return ()=>{
        registry.delete(subject);
    };
};
const $e81d37085298e4b7$export$9218bfcced62f524 = (registry, subject)=>{
    return registry.get(subject) || subject;
};
const $e81d37085298e4b7$export$cf6f15ae0c6d3b84 = (subject)=>{
    const registry = $e81d37085298e4b7$export$edb6244a86733174();
    return (registry || new Map()).get(subject) || subject;
};
const $e81d37085298e4b7$export$ef191f4a42af511d = (subject, target)=>[
        subject,
        target
    ];
module.exports["useCommerceOverride"] = $e81d37085298e4b7$export$cf6f15ae0c6d3b84;

});

parcelRegister("dhwg6", function(module, exports) {
// eslint-disable-next-line import/no-extraneous-dependencies

var $cozmU = parcelRequire("cozmU");

const $b3617a79a841468e$export$81b0387840a1a60c = (0, $cozmU.createContext)(new Map());
module.exports["overrideContext"] = $b3617a79a841468e$export$81b0387840a1a60c;

});

parcelRegister("6hHTZ", function(module, exports) {
const $dcd64b429c3a6f30$export$14619c0eed01a470 = (fetchInput)=>typeof fetchInput === 'string' ? fetchInput : fetchInput instanceof URL ? fetchInput.href : fetchInput.url;
module.exports["getRequestUrl"] = $dcd64b429c3a6f30$export$14619c0eed01a470;

});

parcelRegister("5Ntrt", function(module, exports) {
// eslint-disable-next-line import/no-extraneous-dependencies

var $cozmU = parcelRequire("cozmU");

const $7b4f705ab4ffebd4$export$6de4685a6c88b4e9 = (request, initialState = {
    loading: false,
    data: undefined,
    error: undefined
})=>{
    const [state, setState] = (0, $cozmU.useState)(initialState);
    const fetchData = (0, $cozmU.useCallback)(async (...requestArgs)=>{
        setState({
            loading: true,
            data: undefined,
            error: undefined
        });
        try {
            const data = await request(...requestArgs);
            setState({
                loading: false,
                data: data,
                error: undefined
            });
            return data;
        } catch (error) {
            // Casting promise error to provided type. I assumes that the person that
            // provides types know that kind of type promise will return on reject.
            setState({
                loading: false,
                data: undefined,
                error: error
            });
            throw error;
        }
    }, [
        request
    ]);
    return (0, $cozmU.useMemo)(()=>({
            ...state,
            fetchData: fetchData
        }), [
        state,
        fetchData
    ]);
};
const $7b4f705ab4ffebd4$export$ff7e5879ade03276 = (request)=>{
    const service = $7b4f705ab4ffebd4$export$6de4685a6c88b4e9(request, {
        loading: true,
        data: undefined,
        error: undefined
    });
    const { fetchData: fetchData } = service;
    (0, $cozmU.useEffect)(()=>{
        // on error promise will be resolved to undefined, error instance available in state
        // eslint-disable-next-line no-console
        fetchData().catch((error)=>console.warn(error));
    }, [
        fetchData
    ]);
    return (0, $cozmU.useMemo)(()=>{
        const { fetchData: fetchData, ...state } = service;
        return {
            ...state,
            refresh: ()=>fetchData()
        };
    }, [
        service
    ]);
};
const $7b4f705ab4ffebd4$export$18e513c1248d8ad5 = (request)=>{
    const service = $7b4f705ab4ffebd4$export$6de4685a6c88b4e9(request, {
        loading: false,
        data: undefined,
        error: undefined
    });
    return (0, $cozmU.useMemo)(()=>{
        const { fetchData: fetchData, ...state } = service;
        return {
            ...state,
            update: fetchData
        };
    }, [
        service
    ]);
};
const $7b4f705ab4ffebd4$export$d9765c5cd98039 = (request)=>{
    const service = $7b4f705ab4ffebd4$export$18e513c1248d8ad5(request);
    return (0, $cozmU.useMemo)(()=>{
        const { update: update, ...state } = service;
        return {
            ...state,
            fetch: update
        };
    }, [
        service
    ]);
};
const $7b4f705ab4ffebd4$export$7077fee76310bc60 = (request)=>{
    const service = $7b4f705ab4ffebd4$export$6de4685a6c88b4e9(request);
    return (0, $cozmU.useMemo)(()=>{
        const { fetchData: fetchData, ...state } = service;
        return {
            ...state,
            create: fetchData
        };
    }, [
        service
    ]);
};
module.exports["useFetchService"] = $7b4f705ab4ffebd4$export$ff7e5879ade03276;
module.exports["useUpdateService"] = $7b4f705ab4ffebd4$export$18e513c1248d8ad5;

});

parcelRegister("glP0S", function(module, exports) {
/**
 * For when the code is meant to only ever executed when a bug has ocurred.
 *
 * Note: Choosing a probability-of-bug value should not be speculate/account for specific bugs in the code base
 *
 * Examples:
 * - A top-level try-catch whos only purpose is to prevent your entire application from crashing when random exceptions are thrown
 * - HTTP 500 status code handling logic (assuming 500s only happen when the server has experienced a bug/crash)
 * - Server responses that signal that the JSON payload frontend sent was completely wrong
 * - Part of your app unexpectedly crashes
 * - Any response bodys/HTTP statuses you were not expecting to receive
 */ const $ad755b85a2ffec4b$export$6af268b89fae390b = 'guaranteed';
const $ad755b85a2ffec4b$export$dab33e9f81ed2cbf = 'maybe';
const $ad755b85a2ffec4b$export$c53d0f541b41b88e = 'none';
module.exports["GUARANTEED"] = $ad755b85a2ffec4b$export$6af268b89fae390b;
module.exports["MAYBE"] = $ad755b85a2ffec4b$export$dab33e9f81ed2cbf;
module.exports["NONE"] = $ad755b85a2ffec4b$export$c53d0f541b41b88e;

});

parcelRegister("9Ipdf", function(module, exports) {
/**
 * Note: If you add a service here please name after what's mentioned in Microscope.
 * It'll make figuring out who to page (if we need to) easier. See: https://microscope.prod.atl-paas.net/services/commerce-libraries
 *
 * TODO: Probably worth adding some sort of build check to make sure this is enforced
 */ /**
 * It's not enforced, but if you add a service here
 */ /**
 * Generally, you'll want to use this value if you're not 100% sure who can cause the error.
 */ const $66065802af3a213d$export$78244dbb77cfa6b6 = 'unknown';
const $66065802af3a213d$export$aed27a6561cc0f5c = 'unknown-external';
const $66065802af3a213d$export$983d8427a452c1b = 'commerce-libraries';
const $66065802af3a213d$export$d5a5208541f78b0 = 'hams';
const $66065802af3a213d$export$856303030f6df405 = 'billing-api-gateway';
module.exports["UNKNOWN"] = $66065802af3a213d$export$78244dbb77cfa6b6;
module.exports["UNKNOWN_EXTERNAL"] = $66065802af3a213d$export$aed27a6561cc0f5c;
module.exports["COMMERCE_LIBRARIES"] = $66065802af3a213d$export$983d8427a452c1b;
module.exports["HAMS"] = $66065802af3a213d$export$d5a5208541f78b0;
module.exports["BILLING_API_GATEWAY"] = $66065802af3a213d$export$856303030f6df405;

});

parcelRegister("6T8f4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $glP0S = parcelRequire("glP0S");


var $5xYJM = parcelRequire("5xYJM");


var $awBkn = parcelRequire("awBkn");


var $9Ipdf = parcelRequire("9Ipdf");


var $9sThO = parcelRequire("9sThO");

const $dd10014adafb085b$export$9a00dee1beb8f576 = (actionSubject)=>{
    return actionSubject.charAt(0).toUpperCase() + actionSubject.substring(1);
};
const $dd10014adafb085b$export$4903c942fa101973 = {
    TASK_FAILURE: 'fe.user.task.failure',
    TASK_SUCCESS: 'fe.user.task.success'
};
const $dd10014adafb085b$export$b921bb722afe30af = ({ action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, histogramBuckets: _histogramBuckets = '4000' })=>{
    const dispatchGasV3Track = (0, $5xYJM.internalGasV3TrackEventChannel).useBreadcrumbedEventDispatch();
    const dispatchSentry = (0, $5xYJM.internalSentryExceptionChannel).useBreadcrumbedEventDispatch();
    const task = actionSubjectId ? `${actionSubjectId}` : `${action}${$dd10014adafb085b$export$9a00dee1beb8f576(actionSubject)}`;
    return (0, $cozmU.useCallback)((payload)=>{
        const sharedGasV3Payload = {
            ...payload
        };
        const sendSentryEvent = (loggablePayload, eventName, eventTaskId, exceptionTags)=>{
            if (loggablePayload === undefined && [
                (0, $glP0S.MAYBE),
                (0, $glP0S.NONE)
            ].includes(exceptionTags.probabilityOfBug)) // Don't bother sending a payload if it's undefined and the probability of bug isn't guaranteed
            // TODO: Should enforce that it's never undefined for ProbabilityOfBug.GUARANTEED
            return;
            dispatchSentry({
                exception: loggablePayload,
                scopeContext: (0, $awBkn.withTelemetryInfoScopeContext)({
                    tags: {
                        task: task,
                        eventName: eventName,
                        ...exceptionTags,
                        ...eventTaskId !== undefined ? {
                            eventTaskId: eventTaskId
                        } : undefined,
                        ...payload.actionSubjectId !== undefined ? {
                            actionSubjectId: payload.actionSubjectId
                        } : undefined
                    }
                })
            });
        };
        const fail = ({ loggablePayload: loggablePayload, probabilityOfBug: probabilityOfBug = (0, $glP0S.MAYBE), eventTaskId: baseEventTaskId, responsibleService: responsibleService = (0, $9Ipdf.UNKNOWN) } = {})=>{
            const eventTaskId = (()=>{
                if (baseEventTaskId !== undefined) return baseEventTaskId;
                if (probabilityOfBug === (0, $glP0S.GUARANTEED)) {
                    if ((0, $9sThO.responsibleServiceIncludesCommerceLibraries)(responsibleService)) return 'guaranteed-bug';
                    return 'external-bug';
                }
                // Not sending any other values in fear of cardinality problems
                return undefined;
            })();
            sendSentryEvent(loggablePayload, $dd10014adafb085b$export$4903c942fa101973.TASK_FAILURE, eventTaskId, {
                probabilityOfBug: probabilityOfBug,
                responsibleService: responsibleService
            });
        // TODO: Consider sending some sort of GasV3 failure information
        };
        const succeed = ({ loggablePayload: loggablePayload, eventTaskId: eventTaskId, responsibleService: responsibleService = (0, $9Ipdf.UNKNOWN) } = {})=>{
            sendSentryEvent(loggablePayload, $dd10014adafb085b$export$4903c942fa101973.TASK_SUCCESS, eventTaskId, {
                probabilityOfBug: (0, $glP0S.NONE),
                responsibleService: responsibleService
            });
            dispatchGasV3Track(sharedGasV3Payload);
        };
        return {
            fail: fail,
            succeed: succeed
        };
    }, [
        dispatchGasV3Track,
        dispatchSentry,
        task
    ]);
};
const $dd10014adafb085b$export$94273a7593441cd3 = (x)=>x.succeed !== undefined;
const $dd10014adafb085b$export$8ea5335bded027a0 = (taskInfo)=>{
    const startTask = $dd10014adafb085b$export$b921bb722afe30af(taskInfo);
    const taskInfoRef = (0, $cozmU.useRef)(taskInfo);
    // TODO: replace by useEvent once it is available. Ponyfilling with useRef for now
    const higherLevelStartTask = (0, $cozmU.useCallback)(/**
   * Please note that thrown errors will be interpreted as guaranteed buggy failures.
   * @param payload This data passed into this function will be shared between both failure and successful tasks
   */ async (callback, payload)=>{
        const { fail: fail, succeed: succeed } = startTask(payload || taskInfoRef.current);
        try {
            const result = await callback();
            if (result.succeed !== undefined) succeed(result.succeed);
            else if (result.fail !== undefined) fail(result.fail);
            else fail({
                probabilityOfBug: (0, $glP0S.GUARANTEED),
                loggablePayload: {
                    result: result,
                    error: new Error('Could not find succeed nor fail')
                }
            });
            return result;
        } catch (err) {
            if (err instanceof TypeError && err.message === 'Failed to fetch') fail({
                probabilityOfBug: (0, $glP0S.MAYBE),
                loggablePayload: err
            });
            else fail({
                probabilityOfBug: (0, $glP0S.GUARANTEED),
                loggablePayload: err
            });
            throw err;
        }
    }, [
        startTask
    ]);
    return higherLevelStartTask;
};
module.exports["useTaskTracker"] = $dd10014adafb085b$export$8ea5335bded027a0;

});

parcelRegister("awBkn", function(module, exports) {

var $glP0S = parcelRequire("glP0S");


var $9Ipdf = parcelRequire("9Ipdf");


var $9sThO = parcelRequire("9sThO");

const $8230cff51e5ef4fd$export$bf5f90a1a9d2de58 = ({ probabilityOfBug: probabilityOfBug, responsibleService: responsibleService })=>{
    switch(probabilityOfBug){
        case 0, $glP0S.GUARANTEED:
            if ((0, $9sThO.responsibleServiceIncludesCommerceLibraries)(responsibleService)) return 'fatal';
            return 'error';
        case 0, $glP0S.MAYBE:
            return 'warning';
        case 0, $glP0S.NONE:
            return 'log';
        default:
            // Should never happen so sending critical :3
            return 'fatal';
    }
};
const $8230cff51e5ef4fd$var$severityOrdering = new Map([
    [
        'fatal',
        0
    ],
    [
        'fatal',
        1
    ],
    [
        'error',
        2
    ],
    [
        'warning',
        3
    ],
    [
        'info',
        4
    ],
    [
        'log',
        5
    ],
    [
        undefined,
        6
    ]
]);
const $8230cff51e5ef4fd$export$cae73843c52c598b = (severity1, severity2)=>{
    if ($8230cff51e5ef4fd$var$severityOrdering.get(severity1) <= $8230cff51e5ef4fd$var$severityOrdering.get(severity2)) return severity1;
    return severity2;
};
const $8230cff51e5ef4fd$export$c7063fd1387b3458 = (scopeContext)=>{
    const tags = {
        ...scopeContext.tags,
        responsibleService: scopeContext.tags.responsibleService ?? (0, $9Ipdf.UNKNOWN)
    };
    return {
        ...scopeContext,
        tags: tags,
        level: $8230cff51e5ef4fd$export$bf5f90a1a9d2de58(tags)
    };
};
module.exports["withTelemetryInfoScopeContext"] = $8230cff51e5ef4fd$export$c7063fd1387b3458;

});

parcelRegister("9sThO", function(module, exports) {

var $9Ipdf = parcelRequire("9Ipdf");

const $7d3d4006cc024087$export$6d5fcf71bce583e2 = (responsibleService)=>responsibleService === (0, $9Ipdf.COMMERCE_LIBRARIES) || responsibleService === (0, $9Ipdf.UNKNOWN);
module.exports["responsibleServiceIncludesCommerceLibraries"] = $7d3d4006cc024087$export$6d5fcf71bce583e2;

});

parcelRegister("lDGcP", function(module, exports) {
const $7490265e82b65da5$export$40f07171f4b6ee01 = (result)=>result.exception !== undefined;
const $7490265e82b65da5$export$e6127cc7fe7395c3 = (result)=>result.error !== undefined;
const $7490265e82b65da5$export$a7324067d5b1efd6 = (result)=>result.payload !== undefined;
const $7490265e82b65da5$export$4ece3b219cb1e8e7 = (result)=>result.payload === undefined;
const $7490265e82b65da5$export$d0a8c5cfb02e95fe = (error)=>({
        error: error,
        payload: undefined,
        exception: undefined
    });
const $7490265e82b65da5$export$6338ef6f72008c7 = (payload)=>({
        payload: payload,
        error: undefined,
        exception: undefined
    });
const $7490265e82b65da5$export$89242b2b73a7bdd = (exception)=>{
    return {
        payload: undefined,
        error: undefined,
        exception: exception
    };
};
module.exports["isException"] = $7490265e82b65da5$export$40f07171f4b6ee01;
module.exports["isSuccessful"] = $7490265e82b65da5$export$a7324067d5b1efd6;

});

parcelRegister("lh1MN", function(module, exports) {
const $7f1ee6750f4adf66$export$db45730c9afae012 = (data)=>{
    if (!data) return undefined;
    return data.confluence_tenantContext?.licenseStates?.confluence?.ccpEntitlementId || undefined;
};
module.exports["getCcpEntitlementFromQuery"] = $7f1ee6750f4adf66$export$db45730c9afae012;

});

parcelRegister("hfUvC", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $cozmU = parcelRequire("cozmU");


var $7mzZ9 = parcelRequire("7mzZ9");


var $24CJQ = parcelRequire("24CJQ");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");

const $e7daf7179cc3ad9e$export$b65b36d21c9a62a9 = 'confluence.ondemand';
const $e7daf7179cc3ad9e$var$memoizedFetchCommerceRolloutInformation = (0, $dOBRD.default)(async (cloudId)=>{
    const rolloutInfoResult = await (0, $7mzZ9.fetchCommerceRolloutInformation)({
        cloudId: cloudId,
        productKey: $e7daf7179cc3ad9e$export$b65b36d21c9a62a9
    }, {
        fetch: (0, $f7B1p.cfetch)
    });
    return rolloutInfoResult;
});
const $e7daf7179cc3ad9e$export$44d1450d6b2633f0 = (skip = false)=>{
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)(null);
    const [commerceBackendName, setCommerceBackendName] = (0, $cozmU.useState)(null);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    if (!cloudId) skip = true;
    (0, $cozmU.useEffect)(()=>{
        if (skip) return;
        const fetchCommerceRolloutInformation = async ()=>{
            try {
                const rolloutInfoResult = await $e7daf7179cc3ad9e$var$memoizedFetchCommerceRolloutInformation(cloudId);
                if ((0, $24CJQ.isSuccessful)(rolloutInfoResult)) setCommerceBackendName(rolloutInfoResult.payload.commerceBackend);
                else {
                    const error_1 = (0, $24CJQ.isException)(rolloutInfoResult) ? rolloutInfoResult.exception : rolloutInfoResult.error;
                    setError(error_1);
                }
            } catch (error_0) {
                error_0.message = `useCommerceBackendName: ${error_0.message}`;
                setError(error_0);
            } finally{
                setLoading(false);
            }
        };
        fetchCommerceRolloutInformation();
    }, [
        cloudId,
        skip
    ]);
    return {
        commerceBackendName: skip ? null : commerceBackendName,
        loading: skip ? false : loading,
        error: skip ? null : error
    };
};
module.exports["useCommerceRolloutInformation"] = $e7daf7179cc3ad9e$export$44d1450d6b2633f0;

});

parcelRegister("24CJQ", function(module, exports) {
const $02b44be3ccfad2c3$export$40f07171f4b6ee01 = (result)=>result.exception !== undefined;
const $02b44be3ccfad2c3$export$e6127cc7fe7395c3 = (result)=>result.error !== undefined;
const $02b44be3ccfad2c3$export$a7324067d5b1efd6 = (result)=>result.payload !== undefined;
const $02b44be3ccfad2c3$export$4ece3b219cb1e8e7 = (result)=>result.payload === undefined;
const $02b44be3ccfad2c3$export$d0a8c5cfb02e95fe = (error)=>({
        error: error,
        payload: undefined,
        exception: undefined
    });
const $02b44be3ccfad2c3$export$6338ef6f72008c7 = (payload)=>({
        payload: payload,
        error: undefined,
        exception: undefined
    });
const $02b44be3ccfad2c3$export$89242b2b73a7bdd = (exception)=>{
    return {
        payload: undefined,
        error: undefined,
        exception: exception
    };
};
module.exports["isException"] = $02b44be3ccfad2c3$export$40f07171f4b6ee01;
module.exports["isSuccessful"] = $02b44be3ccfad2c3$export$a7324067d5b1efd6;

});

parcelRegister("l0DoV", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $537ed6b0b56c707f$export$5422bd88477f90e5 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "uHF1j",
    name: "TryStandardUpflowV2ExperimentTreatmentModalLoadable",
    loader: async ()=>(await (parcelRequire("aTLsO"))).TryStandardUpflowV2ExperimentTreatmentModalWithErrorBoundary
});
module.exports["TryStandardUpflowV2ExperimentTreatmentModalLoadable"] = $537ed6b0b56c707f$export$5422bd88477f90e5;

});

parcelRegister("aTLsO", function(module, exports) {

let $7ef3dbc0608079dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7ef3dbc0608079dd$var$load("6wr18"),
    $7ef3dbc0608079dd$var$load("j99ao"),
    $7ef3dbc0608079dd$var$load("ffEVr"),
    $7ef3dbc0608079dd$var$load("jZMUd"),
    $7ef3dbc0608079dd$var$load("hhss7"),
    $7ef3dbc0608079dd$var$load("fYFVU")
]).then(()=>parcelRequire('h60zh'));

});

parcelRegister("fDbEj", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");


var $gQY3Y = parcelRequire("gQY3Y");


var $jKFU9 = parcelRequire("jKFU9");

const $3737157ebbad3bf6$var$timeNow = ()=>new Date().getTime();
const $3737157ebbad3bf6$export$66d311bf29d5c89c = new Error('TIMEOUT');
const $3737157ebbad3bf6$export$d63cfb67ca7b2a0 = (currentEdition, writeFragmentInterop)=>{
    if (!currentEdition) return Promise.reject(new Error('No currentEdition supplied'));
    const pollEndTime = new Date($3737157ebbad3bf6$var$timeNow() + (0, $jKFU9.CHANGE_EDITION_POLL_DURATION_MINS) * 60000).getTime();
    const pollAndResolve = (resolve, reject)=>{
        if ($3737157ebbad3bf6$var$timeNow() > pollEndTime) reject($3737157ebbad3bf6$export$66d311bf29d5c89c);
        (0, $c0rhi.queryInterop)({
            query: (0, $gQY3Y.waitForEditionChangeQuery),
            errorPolicy: 'all',
            fetchPolicy: 'network-only',
            __callerPackage__: "change-edition"
        }).then((response)=>{
            const polledEdition = response.data?.tenant?.editions?.confluence;
            if (polledEdition && currentEdition !== polledEdition) {
                // Write the latest edition to cache.
                writeFragmentInterop({
                    fragmentId: '$ROOT_QUERY.confluence_tenantContext',
                    data: {
                        editions: {
                            confluence: polledEdition,
                            __typename: 'ConfluenceEditions'
                        },
                        __typename: 'Tenant'
                    }
                });
                resolve(polledEdition);
            } else setTimeout(()=>{
                pollAndResolve(resolve, reject);
            }, (0, $jKFU9.CHANGE_EDITION_POLL_INTERVAL_SECS) * 1000);
        }).catch(reject);
    };
    return new Promise((resolve, reject)=>pollAndResolve(resolve, reject));
};
module.exports["TimeoutError"] = $3737157ebbad3bf6$export$66d311bf29d5c89c;
module.exports["waitForEditionChange"] = $3737157ebbad3bf6$export$d63cfb67ca7b2a0;

});

parcelRegister("gQY3Y", function(module, exports) {

var $cLzsY = parcelRequire("cLzsY");

const $1047f6c600fde1f6$export$291c2fa2b3781c67 = (0, $cLzsY.default);
module.exports["waitForEditionChangeQuery"] = $1047f6c600fde1f6$export$291c2fa2b3781c67;

});

parcelRegister("cLzsY", function(module, exports) {
/**
 * @generated SignedSource<<905713eccc18ec27c48d092c32f0cb36>>
 * @relayHash 1f96316e590a2b194e51c68e90ba41fe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 241b0a4ae1b4aa71513dc33dc53ca7f3c35e7c5a3662ea814901abd521642ef3
const $5953893bb8ead2fa$var$node = function() {
    var v0 = [
        {
            "alias": "tenant",
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Editions",
                    "kind": "LinkedField",
                    "name": "editions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "confluence"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "waitForEditionChangeQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "waitForEditionChangeQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "1f96316e590a2b194e51c68e90ba41fe",
            "id": "241b0a4ae1b4aa71513dc33dc53ca7f3c35e7c5a3662ea814901abd521642ef3",
            "metadata": {},
            "name": "waitForEditionChangeQuery",
            "operationKind": "query",
            "text": "query waitForEditionChangeQuery{tenant:confluence_tenantContext{editions{confluence}}}"
        }
    };
}();
$5953893bb8ead2fa$var$node.hash = "6fd7b1d4e0dd25a6c39ba6c8851caa63";
var $5953893bb8ead2fa$export$2e2bcd8739ae039 = $5953893bb8ead2fa$var$node;
module.exports["default"] = $5953893bb8ead2fa$export$2e2bcd8739ae039;

});

parcelRegister("jKFU9", function(module, exports) {
const $97f7046950ca68f7$export$4f9b7eb5b7999045 = 3;
const $97f7046950ca68f7$export$6925031fb600919f = 1;
module.exports["CHANGE_EDITION_POLL_INTERVAL_SECS"] = $97f7046950ca68f7$export$4f9b7eb5b7999045;
module.exports["CHANGE_EDITION_POLL_DURATION_MINS"] = $97f7046950ca68f7$export$6925031fb600919f;

});

parcelRegister("iAMak", function(module, exports) {
/**
 * Touchpoints for which the Standard upgrade modal has tailored header + content
 * (see getTouchpointHeader / getTouchpointContent). These mirror the dedicated
 * cases the Upflow V2 experiment treatment modal supported. Any touchpoint NOT in
 * this list intentionally falls through to the direct-to-Commerce path rather than
 * opening the modal with generic default content.
 */ const $727e092d2d0f098c$export$8b3c299a11a1e324 = [
    'shareAndRestrictDialogUpsell',
    'individualSpacePermission',
    'adminGlobalPermissions',
    'adminSpacePermissions',
    'publicLinksExportUpsell'
];
module.exports["SUPPORTED_TOUCHPOINTS"] = $727e092d2d0f098c$export$8b3c299a11a1e324;

});

parcelRegister("7VDbW", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $552fcf9feb2e8b79$export$f64958a0a44d45d2 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "uWYJ1",
    name: "StandardUpgradeModalLoadable",
    loader: async ()=>(await (parcelRequire("4pTU3"))).StandardUpgradeModal
});
module.exports["StandardUpgradeModalLoadable"] = $552fcf9feb2e8b79$export$f64958a0a44d45d2;

});

parcelRegister("4pTU3", function(module, exports) {

let $3374dc6a29019c49$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3374dc6a29019c49$var$load("jZMUd"),
    $3374dc6a29019c49$var$load("6wr18"),
    $3374dc6a29019c49$var$load("j99ao"),
    $3374dc6a29019c49$var$load("ffEVr"),
    $3374dc6a29019c49$var$load("hhss7"),
    $3374dc6a29019c49$var$load("5RRH5")
]).then(()=>parcelRequire('2WGjl'));

});

parcelRegister("jW145", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $kFu01 = parcelRequire("kFu01");


var $cozmU = parcelRequire("cozmU");


var $1ytiN = parcelRequire("1ytiN");


var $jMyy4 = parcelRequire("jMyy4");

const $795b2e20606fa79f$export$88d9c26e0dec3691 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { cloudId: cloudId, targetEdition: targetEdition } = t0;
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    let t1;
    if ($[0] !== targetEdition) {
        t1 = targetEdition.toLowerCase();
        $[0] = targetEdition;
        $[1] = t1;
    } else t1 = $[1];
    const offeringName = t1;
    let t2;
    if ($[2] !== cloudId || $[3] !== offeringName) {
        t2 = {
            cloudId: cloudId,
            offeringName: offeringName
        };
        $[2] = cloudId;
        $[3] = offeringName;
        $[4] = t2;
    } else t2 = $[4];
    const t3 = !cloudId;
    let t4;
    if ($[5] !== t2 || $[6] !== t3) {
        t4 = {
            interopApolloAggClient: true,
            variables: t2,
            skip: t3
        };
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $kFu01.default), {
        ...t4,
        __callerPackage__: "change-edition"
    });
    const entitlement = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
    const isBillingAdmin = entitlement?.transactionAccount?.isCurrentUserBillingAdmin ?? null;
    const offering = entitlement?.experienceCapabilities?.changeOfferingV2;
    const isAvailableToUser = offering?.isAvailableToUser ?? false;
    const experienceUrl = offering?.experienceUrl ?? null;
    let t5;
    if ($[8] !== error || $[9] !== experienceUrl || $[10] !== isAvailableToUser || $[11] !== isBillingAdmin || $[12] !== isSiteAdmin || $[13] !== loading) {
        t5 = {
            isBillingAdmin: isBillingAdmin,
            isSiteAdmin: isSiteAdmin,
            isAvailableToUser: isAvailableToUser,
            experienceUrl: experienceUrl,
            loading: loading,
            error: error
        };
        $[8] = error;
        $[9] = experienceUrl;
        $[10] = isAvailableToUser;
        $[11] = isBillingAdmin;
        $[12] = isSiteAdmin;
        $[13] = loading;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
} : ({ cloudId: cloudId, targetEdition: targetEdition })=>{
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const offeringName = targetEdition.toLowerCase();
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $kFu01.default), {
        interopApolloAggClient: true,
        variables: {
            cloudId: cloudId,
            offeringName: offeringName
        },
        skip: !cloudId,
        __callerPackage__: "change-edition"
    });
    const entitlement = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
    const isBillingAdmin = entitlement?.transactionAccount?.isCurrentUserBillingAdmin ?? null;
    const offering = entitlement?.experienceCapabilities?.changeOfferingV2;
    const isAvailableToUser = offering?.isAvailableToUser ?? false;
    const experienceUrl = offering?.experienceUrl ?? null;
    return {
        isBillingAdmin: isBillingAdmin,
        isSiteAdmin: isSiteAdmin,
        isAvailableToUser: isAvailableToUser,
        experienceUrl: experienceUrl,
        loading: loading,
        error: error
    };
};
module.exports["useUpgradeButtonDetails"] = $795b2e20606fa79f$export$88d9c26e0dec3691;

});

parcelRegister("kFu01", function(module, exports) {
/**
 * @generated SignedSource<<03ebc451e51692ee3282051b42a27c6a>>
 * @relayHash addf88e3fdb39e235a3b0e146b7ff58e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9ff1c384bb29f7f5c355982e653af47872a54290a9831b4a84faf575fe3527ce
const $2c2790f1293814b4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "offeringName"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "hamsProductKey",
            "value": "confluence.ondemand"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isCurrentUserBillingAdmin"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "offeringName",
            "variableName": "offeringName"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v8 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useUpgradeButtonDetailsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                },
                                                v5 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useUpgradeButtonDetailsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ 
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "addf88e3fdb39e235a3b0e146b7ff58e",
            "id": "9ff1c384bb29f7f5c355982e653af47872a54290a9831b4a84faf575fe3527ce",
            "metadata": {},
            "name": "useUpgradeButtonDetailsQuery",
            "operationKind": "query",
            "text": "query useUpgradeButtonDetailsQuery($cloudId:ID!,$offeringName:String!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:\"confluence.ondemand\"){__typename,entitlement{__typename,id,transactionAccount{__typename,...on Node{__isNode:__typename,id,__typename},isCurrentUserBillingAdmin},experienceCapabilities{__typename,changeOfferingV2(offeringName:$offeringName){__typename,isAvailableToUser,experienceUrl}}}}}}"
        }
    };
}();
$2c2790f1293814b4$var$node.hash = "3c802537aa544beab0f3df07ee3acb77";
var $2c2790f1293814b4$export$2e2bcd8739ae039 = $2c2790f1293814b4$var$node;
module.exports["default"] = $2c2790f1293814b4$export$2e2bcd8739ae039;

});

parcelRegister("lNKOh", function(module, exports) {
const $5ea77288491beecf$export$2321d4fb07b49d13 = ({ canShowUpgradeButton: canShowUpgradeButton, children: children, isSiteAdmin: isSiteAdmin, shouldShowLearnMore: shouldShowLearnMore = true, showRequestUpgradeButton: showRequestUpgradeButton })=>{
    let showUpgradeTryNowButton = false;
    let showLearnMore = true;
    let learnMoreIsPrimaryCTA = true;
    if (canShowUpgradeButton) {
        if (isSiteAdmin) showUpgradeTryNowButton = true;
        if (showUpgradeTryNowButton) {
            // NOTE: Don't show 'Learn More' CTA if it will appear in between the
            // Upgrade Edition button and a secondary feature link (like
            // "Remove this page's restrictions" button). In those cases, "Learn
            // More" CTA will be displayed at the end of the general text content,
            // outside of this component.
            showLearnMore = shouldShowLearnMore;
            learnMoreIsPrimaryCTA = false;
        }
    }
    if (showRequestUpgradeButton) // If an end user request upgrade button is present,
    // we don't show the learn more link if it's not specifically provided.
    showLearnMore = shouldShowLearnMore;
    return children({
        showUpgradeTryNowButton: showUpgradeTryNowButton,
        showLearnMore: showLearnMore,
        learnMoreIsPrimaryCTA: learnMoreIsPrimaryCTA
    });
};
module.exports["ChangeEditionSectionMessageButtonsWrapper"] = $5ea77288491beecf$export$2321d4fb07b49d13;

});

parcelRegister("bhvFb", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $QPvOh = parcelRequire("QPvOh");


var $9wGTI = parcelRequire("9wGTI");


var $gsZdA = parcelRequire("gsZdA");

const $1848832735763b59$var$contentContainerStyles = {
    regular: "_1e0c1txw _2lx21bp4 _16jlkb7n _p12f1lk2",
    isCard: "_p12f1osq"
};
const $1848832735763b59$var$sectionMessageTitleStyles = {
    regular: "_11c81e3o _19pkidpf _syazi7uo",
    regularNew: "_11c81af2 _k48p1wq8 _19pkidpf _syazi7uo",
    inlineModal: "_11c81af2 _19pkze3t _n3tdpxbi"
};
const $1848832735763b59$var$sectionMessageBodyStyles = {
    withTitle: "_19pku2gc",
    noTitle: "_19pkidpf"
};
const $1848832735763b59$var$sectionMessageHeaderButtonStyles = {
    regular: "_1e0c1txw _1bahesu3 _kqswstnw _154ipxbi _1xi21ejb",
    default: "_154ixy5q _1xi2oahv",
    isCardDefault: "_1xi2xy5q",
    isCard: "_1xi2pxbi"
};
const $1848832735763b59$var$sectionMessageActionRowStyles = {
    default: "_1e0c1txw _19pkpxbi",
    right: "_1bahesu3 _166l1sbv _6ufw1q9c",
    inlineModal: "_19pk16xz _1e0c1txw"
};
const $1848832735763b59$var$sectionMessageFooterStyles = {
    default: "_x3do1uh4 _19pkpxbi _otyrpxbi _ca0qutpp"
};
const $1848832735763b59$var$sectionMessageContainerStyles = {
    regular: "_2rkofajl _19pkidpf _2hwx1wug _otyridpf _18u01wug _bfhk1bhr _1e0c1txw _16jlkb7n",
    withTasteAndToneStyling: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhk1j28",
    default: "_1yt44ar7 _16qs130s _p12fasau",
    flat: "_1yt44ar7 _p12fasau",
    inline: "_11c8fhey",
    inlineModal: "_p12f1kdj"
};
const $1848832735763b59$export$d8126cfce410377d = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(35);
    const { actions: actions, appearanceType: appearanceType, body: body, footer: footer, title: title, headerButton: headerButton, withTasteAndToneStyling: t1, buttonGroupAlignment: t2 } = t0;
    const withTasteAndToneStyling = t1 === undefined ? false : t1;
    const buttonGroupAlignment = t2 === undefined ? "left" : t2;
    const withTitle = Boolean(title);
    const isCard = Boolean(buttonGroupAlignment === "right");
    const updatedAppearanceType = appearanceType || (withTasteAndToneStyling ? (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE : (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT);
    const t3 = withTasteAndToneStyling && $1848832735763b59$var$sectionMessageContainerStyles.withTasteAndToneStyling;
    const t4 = updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageContainerStyles["default"];
    const t5 = updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).FLAT && $1848832735763b59$var$sectionMessageContainerStyles.flat;
    const t6 = updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE && $1848832735763b59$var$sectionMessageContainerStyles.inline;
    const t7 = updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageContainerStyles.inlineModal;
    let t8;
    if ($[0] !== t3 || $[1] !== t4 || $[2] !== t5 || $[3] !== t6 || $[4] !== t7) {
        t8 = (0, $hekY6.default)([
            $1848832735763b59$var$sectionMessageContainerStyles.regular,
            t3,
            t4,
            t5,
            t6,
            t7
        ]);
        $[0] = t3;
        $[1] = t4;
        $[2] = t5;
        $[3] = t6;
        $[4] = t7;
        $[5] = t8;
    } else t8 = $[5];
    const t9 = isCard && $1848832735763b59$var$contentContainerStyles.isCard;
    let t10;
    if ($[6] !== t9) {
        t10 = (0, $hekY6.default)([
            $1848832735763b59$var$contentContainerStyles.regular,
            t9
        ]);
        $[6] = t9;
        $[7] = t10;
    } else t10 = $[7];
    let t11;
    if ($[8] !== title || $[9] !== updatedAppearanceType || $[10] !== withTitle) {
        t11 = withTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $1848832735763b59$var$sectionMessageTitleStyles[(0, $9wGTI.fg)("ten_active_boards_in_standard") ? "regularNew" : "regular"],
                updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageTitleStyles.inlineModal
            ])
        }, title);
        $[8] = title;
        $[9] = updatedAppearanceType;
        $[10] = withTitle;
        $[11] = t11;
    } else t11 = $[11];
    let t12;
    if ($[12] !== body || $[13] !== withTitle) {
        t12 = typeof body === "string" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            dangerouslySetInnerHTML: {
                __html: (0, (/*@__PURE__*/$parcel$interopDefault($QPvOh))).sanitize(body)
            },
            className: (0, $hekY6.default)([
                $1848832735763b59$var$sectionMessageBodyStyles.noTitle,
                withTitle && $1848832735763b59$var$sectionMessageBodyStyles.withTitle
            ])
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $1848832735763b59$var$sectionMessageBodyStyles.noTitle,
                withTitle && $1848832735763b59$var$sectionMessageBodyStyles.withTitle
            ])
        }, body);
        $[12] = body;
        $[13] = withTitle;
        $[14] = t12;
    } else t12 = $[14];
    let t13;
    if ($[15] !== headerButton || $[16] !== isCard || $[17] !== updatedAppearanceType) {
        t13 = headerButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $1848832735763b59$var$sectionMessageHeaderButtonStyles.regular,
                updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageHeaderButtonStyles["default"],
                isCard && $1848832735763b59$var$sectionMessageHeaderButtonStyles.isCard,
                isCard && updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageHeaderButtonStyles.isCardDefault
            ])
        }, headerButton);
        $[15] = headerButton;
        $[16] = isCard;
        $[17] = updatedAppearanceType;
        $[18] = t13;
    } else t13 = $[18];
    let t14;
    if ($[19] !== actions || $[20] !== buttonGroupAlignment || $[21] !== updatedAppearanceType) {
        t14 = actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $1848832735763b59$var$sectionMessageActionRowStyles["default"],
                buttonGroupAlignment === "right" && $1848832735763b59$var$sectionMessageActionRowStyles.right,
                updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageActionRowStyles.inlineModal,
                "actionButtons"
            ])
        }, actions);
        $[19] = actions;
        $[20] = buttonGroupAlignment;
        $[21] = updatedAppearanceType;
        $[22] = t14;
    } else t14 = $[22];
    let t15;
    if ($[23] !== footer) {
        t15 = footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $1848832735763b59$var$sectionMessageFooterStyles["default"]
            ])
        }, footer);
        $[23] = footer;
        $[24] = t15;
    } else t15 = $[24];
    let t16;
    if ($[25] !== t10 || $[26] !== t11 || $[27] !== t12 || $[28] !== t13 || $[29] !== t14 || $[30] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t10
        }, t11, t12, t13, t14, t15);
        $[25] = t10;
        $[26] = t11;
        $[27] = t12;
        $[28] = t13;
        $[29] = t14;
        $[30] = t15;
        $[31] = t16;
    } else t16 = $[31];
    let t17;
    if ($[32] !== t16 || $[33] !== t8) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "edition-section-message",
            className: t8
        }, t16);
        $[32] = t16;
        $[33] = t8;
        $[34] = t17;
    } else t17 = $[34];
    return t17;
} : ({ actions: actions, appearanceType: appearanceType, body: body, footer: footer, title: title, headerButton: headerButton, withTasteAndToneStyling: withTasteAndToneStyling = false, buttonGroupAlignment: buttonGroupAlignment = 'left' })=>{
    const withTitle = Boolean(title);
    const isCard = Boolean(buttonGroupAlignment === 'right');
    const updatedAppearanceType = appearanceType || (withTasteAndToneStyling ? (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE : (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "edition-section-message",
        className: (0, $hekY6.default)([
            $1848832735763b59$var$sectionMessageContainerStyles['regular'],
            withTasteAndToneStyling && $1848832735763b59$var$sectionMessageContainerStyles['withTasteAndToneStyling'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageContainerStyles['default'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).FLAT && $1848832735763b59$var$sectionMessageContainerStyles['flat'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE && $1848832735763b59$var$sectionMessageContainerStyles['inline'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageContainerStyles['inlineModal']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $1848832735763b59$var$contentContainerStyles['regular'],
            isCard && $1848832735763b59$var$contentContainerStyles['isCard']
        ])
    }, withTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $1848832735763b59$var$sectionMessageTitleStyles[(0, $9wGTI.fg)('ten_active_boards_in_standard') ? 'regularNew' : 'regular'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageTitleStyles['inlineModal']
        ])
    }, title), typeof body === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // See https://hello.atlassian.net/browse/APOLLO-3511
    , {
        // and other code tagged with this ticket
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: (0, (/*@__PURE__*/$parcel$interopDefault($QPvOh))).sanitize(body)
        },
        className: (0, $hekY6.default)([
            $1848832735763b59$var$sectionMessageBodyStyles['noTitle'],
            withTitle && $1848832735763b59$var$sectionMessageBodyStyles['withTitle']
        ])
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $1848832735763b59$var$sectionMessageBodyStyles['noTitle'],
            withTitle && $1848832735763b59$var$sectionMessageBodyStyles['withTitle']
        ])
    }, body), headerButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $1848832735763b59$var$sectionMessageHeaderButtonStyles['regular'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageHeaderButtonStyles['default'],
            isCard && $1848832735763b59$var$sectionMessageHeaderButtonStyles['isCard'],
            isCard && updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageHeaderButtonStyles['isCardDefault']
        ])
    }, headerButton), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            $1848832735763b59$var$sectionMessageActionRowStyles['default'],
            buttonGroupAlignment === 'right' && $1848832735763b59$var$sectionMessageActionRowStyles['right'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageActionRowStyles['inlineModal'],
            "actionButtons"
        ])
    }, actions), footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $1848832735763b59$var$sectionMessageFooterStyles['default']
        ])
    }, footer)));
};
module.exports["EditionSectionMessage"] = $1848832735763b59$export$d8126cfce410377d;

});

parcelRegister("QPvOh", function(module, exports) {
/*! @license DOMPurify 2.5.8 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.8/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct()) _construct = Reflect.construct;
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!construct) construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /* Add properties to a lookup table */ function addToSet(set, array, transformCaseFunc) {
        var _transformCaseFunc;
        transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === 'string') {
                var lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /* Shallow clone an object */ function clone(object) {
        var newObject = create(null);
        var property;
        for(property in object)if (apply(hasOwnProperty, object, [
            property
        ]) === true) newObject[property] = object[property];
        return newObject;
    }
    /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn('fallback value for', element);
            return null;
        }
        return fallbackValue;
    }
    var html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    // SVG
    var svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    var svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'fedropshadow',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    var mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    var text = freeze([
        '#text'
    ]);
    var html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'xmlns',
        'slot'
    ]);
    var svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    var mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    var xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var DOCTYPE_NAME = seal(/^html$/i);
    var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
        if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = 'data-tt-policy-suffix';
        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
        var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function createHTML(html) {
                    return html;
                },
                createScriptURL: function createScriptURL(scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
        };
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = '2.5.8';
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var originalDocument = window1.document;
        var document = window1.document;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        var getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            var template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
        var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        var importNode = originalDocument.importNode;
        var documentMode = {};
        try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
        } catch (_) {}
        var hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
        var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ var ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ var SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ var SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ var SANITIZE_NAMED_PROPS = false;
        var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = null;
        var DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ var NAMESPACE = HTML_NAMESPACE;
        var IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ var ALLOWED_NAMESPACES = null;
        var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ var PARSER_MEDIA_TYPE;
        var SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        var transformCaseFunc;
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement('form');
        var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || _typeof(cfg) !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, svg$1);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                try {
                    node.outerHTML = emptyHTML;
                } catch (_) {
                    node.remove();
                }
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ var _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === 'is' && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc;
            var leadingWhitespace;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            var body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */ var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
        };
        /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ var _isNode = function _isNode(object) {
            return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content;
            /* Execute a hook if present */ _executeHook('beforeSanitizeElements', currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Check if tagname contains Unicode */ if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook('uponSanitizeElement', currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Mitigate a problem with templates inside select */ if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any ocurrence of processing instructions */ if (currentNode.nodeType === 7) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i){
                            var childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
                content = stringReplace(content, ERB_EXPR$1, ' ');
                content = stringReplace(content, TMPLIT_EXPR$1, ' ');
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeElements', currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */ var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr;
            var value;
            var lcName;
            var l;
            /* Execute a hook if present */ _executeHook('beforeSanitizeAttributes', currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            var hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                attr = attributes[l];
                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                value = name === 'value' ? attr.value : stringTrim(attr.value);
                lcName = transformCaseFunc(name);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                    value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
                    value = stringReplace(value, ERB_EXPR$1, ' ');
                    value = stringReplace(value, TMPLIT_EXPR$1, ' ');
                }
                /* Is `value` valid for this attribute? */ var lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeAttributes', currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode;
            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */ _executeHook('beforeSanitizeShadowDOM', fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook('uponSanitizeShadowNode', shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeShadowDOM', fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var body;
            var importedNode;
            var currentNode;
            var oldNode;
            var returnNode;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Check we can run. Otherwise fall back or ignore */ if (!DOMPurify.isSupported) {
                if (_typeof(window1.toStaticHTML) === 'object' || typeof window1.toStaticHTML === 'function') {
                    if (typeof dirty === 'string') return window1.toStaticHTML(dirty);
                    if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                }
                return dirty;
            }
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    var tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Fix IE's strange behavior with manipulated textNodes #89 */ if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                oldNode = currentNode;
            }
            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});

parcelRegister("cHKtk", function(module, exports) {

var $hG9ZM = parcelRequire("hG9ZM");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $1ytiN = parcelRequire("1ytiN");


var $7tXrp = parcelRequire("7tXrp");


var $bZmiL = parcelRequire("bZmiL");

const $0db05c5b00b76da2$export$4af81e07a25a3fcc = (source)=>{
    // TODO: During productionization replace with EligibleTouchpoints type for source
    const { cloudId: cloudId, edition: edition, userId: userId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const eligibleTouchpoint = (0, $7tXrp.getEligibleTouchpointForEdition)(source, edition);
    const offeringName = eligibleTouchpoint?.requestedEdition ?? 'standard';
    const isEnabledStandardEdition = edition === (0, $d9tcB.ConfluenceEdition).STANDARD;
    const { loading: loading, data: data } = (0, $jMyy4.useQueryInterop)((0, $hG9ZM.default), {
        variables: {
            cloudId: cloudId,
            offeringName: offeringName,
            shouldCheckForTrial: isEnabledStandardEdition
        },
        fetchPolicy: 'cache-first',
        skip: !isEnabledStandardEdition || isSiteAdmin || !eligibleTouchpoint,
        interopApolloAggClient: true,
        __callerPackage__: "experiment-confluence-enable-end-user-request"
    });
    const { isEligibleForEndUserRequestStandard: isEligibleForEndUserRequestStandard } = (0, $cozmU.useMemo)(()=>{
        const entitlement = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
        const isInCollection = entitlement?.relatesFromEntitlements?.find((item)=>item?.relationshipType === 'COLLECTION')?.entitlementId;
        const isChangeOfferingAvailable = entitlement?.experienceCapabilities?.changeOfferingV2?.isAvailableToUser;
        const changeOfferingExperienceUrl = entitlement?.experienceCapabilities?.changeOfferingV2?.experienceUrl;
        const canUpgrade = Boolean(isChangeOfferingAvailable && changeOfferingExperienceUrl);
        const hasPaymentDetailsEntered = Boolean(entitlement?.transactionAccount?.isBillToPresent);
        const entitlementInfo = data?.tenantContexts?.[0]?.entitlementInfo;
        const entitlementId = entitlementInfo?.entitlementId;
        const transactionAccountId = entitlement?.transactionAccount?.key;
        // Additional eligibility checks for Standard
        const trialTimeLeft = entitlement?.subscription?.trial?.timeLeft;
        const isInTrial = Boolean(trialTimeLeft && trialTimeLeft > 0);
        const invoiceableStatus = typeof entitlement?.subscription?.accountDetails?.invoiceGroup?.invoiceable === 'boolean' ? entitlement.subscription.accountDetails.invoiceGroup.invoiceable ? 'INVOICEABLE' : 'NOT_INVOICEABLE' : 'UNKNOWN';
        const isInPredunning = entitlement?.preDunning?.status === 'IN_PRE_DUNNING' && invoiceableStatus === 'NOT_INVOICEABLE';
        return {
            isEligibleForEndUserRequestStandard: Boolean(!loading && !isInCollection && isEnabledStandardEdition && hasPaymentDetailsEntered && !canUpgrade && Boolean(userId) && Boolean(changeOfferingExperienceUrl) && Boolean(transactionAccountId) && Boolean(entitlementId) && !isInTrial && !isInPredunning)
        };
    }, [
        data,
        loading,
        isEnabledStandardEdition,
        userId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isEligibleForEndUserRequestStandard) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'exposed',
                actionSubject: 'feature',
                source: 'useEnableEndUserRequestUpgrade',
                attributes: {
                    cohort: (0, $6mKj3.expVal)('twcg-1169_ceurs2p_end_user_requests', 'cohort', 'not-enrolled'),
                    flagKey: 'twcg-1169_ceurs2p_end_user_requests',
                    touchpoint: source,
                    ...(0, $bZmiL.editionAnalytics)(edition)
                }
            }
        }).fire();
    }, [
        edition,
        isEligibleForEndUserRequestStandard,
        createAnalyticsEvent,
        source
    ]);
    return {
        showRequestUpgradeButton: // Standard Edition
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        isEligibleForEndUserRequestStandard && (0, $6mKj3.expValEquals)('twcg-1169_ceurs2p_end_user_requests', 'cohort', 'variation'),
        loading: loading
    };
};
module.exports["useEnableEndUserRequestUpgrade"] = $0db05c5b00b76da2$export$4af81e07a25a3fcc;

});

parcelRegister("hG9ZM", function(module, exports) {
/**
 * @generated SignedSource<<7540d078609821cbd0d1d47464bf1494>>
 * @relayHash 95c17f8ab13d7575aa221eba1b6971a5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e810472e5bef79ddd590fcbef7d716cc8bfbcf5a0d5843c4293d62692950c1c2
const $a3d3dc9056ba2c7e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "offeringName"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldCheckForTrial"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "hamsProductKey",
            "value": "confluence.ondemand"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "entitlementId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "offeringName",
            "variableName": "offeringName"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v8 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v9 = {
        "kind": "ScalarField",
        "name": "key"
    }, v10 = {
        "kind": "ScalarField",
        "name": "isBillToPresent"
    }, v11 = {
        "kind": "ScalarField",
        "name": "relationshipType"
    }, v12 = {
        "kind": "ScalarField",
        "name": "status"
    }, v13 = {
        "kind": "ScalarField",
        "name": "timeLeft"
    }, v14 = {
        "kind": "ScalarField",
        "name": "invoiceable"
    }, v15 = [
        v4 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEnableEndUserRequestUpgradeQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "relatesFromEntitlements",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "shouldCheckForTrial",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "preDunning",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "subscription",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "trial",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "accountDetails",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "invoiceGroup",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v14 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEnableEndUserRequestUpgradeQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v15 /*: any*/ ,
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "relatesFromEntitlements",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "shouldCheckForTrial",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "preDunning",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "subscription",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "trial",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v13 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "accountDetails",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "invoiceGroup",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        v14 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v15 /*: any*/ ,
                                                                            "type": "CcpInvoiceGroup"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v15 /*: any*/ ,
                                                            "type": "CcpSubscription"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "95c17f8ab13d7575aa221eba1b6971a5",
            "id": "e810472e5bef79ddd590fcbef7d716cc8bfbcf5a0d5843c4293d62692950c1c2",
            "metadata": {},
            "name": "useEnableEndUserRequestUpgradeQuery",
            "operationKind": "query",
            "text": "query useEnableEndUserRequestUpgradeQuery($cloudId:ID!,$offeringName:String!,$shouldCheckForTrial:Boolean!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:\"confluence.ondemand\"){__typename,entitlementId,entitlement{id,__typename,experienceCapabilities{__typename,changeOfferingV2(offeringName:$offeringName){__typename,isAvailableToUser,experienceUrl}},transactionAccount{__typename,key,isBillToPresent,...on Node{__isNode:__typename,id}},relatesFromEntitlements{__typename,entitlementId,relationshipType},preDunning@include(if:$shouldCheckForTrial){__typename,status}\n        subscription@include(if:$shouldCheckForTrial){__typename,trial{__typename,timeLeft},accountDetails{__typename,invoiceGroup{__typename,invoiceable,...on CcpInvoiceGroup{id}}},...on CcpSubscription{id}}}}}}"
        }
    };
}();
$a3d3dc9056ba2c7e$var$node.hash = "ab7d869d4ea7e269d66f1403bf66098f";
var $a3d3dc9056ba2c7e$export$2e2bcd8739ae039 = $a3d3dc9056ba2c7e$var$node;
module.exports["default"] = $a3d3dc9056ba2c7e$export$2e2bcd8739ae039;

});

parcelRegister("7tXrp", function(module, exports) {

var $d9tcB = parcelRequire("d9tcB");

const $f4962613d517e76c$var$FREE_TOUCHPOINTS = {
    pageInsights: {
        requestedEdition: 'standard',
        requestedFeature: 'pageInsights'
    },
    archiveUpsellDialog: {
        requestedEdition: 'standard',
        requestedFeature: 'archive'
    },
    generalAccessLevelSelector: {
        requestedEdition: 'standard',
        requestedFeature: 'pagePermissions'
    },
    shareAndRestrictDialogUpsell: {
        requestedEdition: 'standard',
        requestedFeature: 'pagePermissions'
    },
    quickSummaryUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'rovo'
    },
    teamCalendarUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'calendars'
    },
    'whiteboardCreationPaywall-upfrontDialog': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    }
};
const $f4962613d517e76c$var$STANDARD_TOUCHPOINTS = {
    viewSpacePerms: {
        requestedEdition: 'premium',
        requestedFeature: 'copySpacePermissions'
    },
    contentManagerUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'contentManager'
    },
    adminCenter: {
        requestedEdition: 'premium',
        requestedFeature: 'adminCenter'
    },
    userAccessUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'inspectPermissions'
    },
    shareAndRestrictDialogInspectPermissionsUpsell: {
        requestedEdition: 'premium',
        requestedFeature: 'inspectPermissions'
    },
    restrictionsDialogInspectPermissionsUpsell: {
        requestedEdition: 'premium',
        requestedFeature: 'inspectPermissions'
    },
    companyHubUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'companyHub'
    },
    premiumCardsInsertUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumCarouselInsertUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumSpotlightInsertUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumCardsConfigUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumCarouselConfigUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumSpotlightConfigUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    whiteboardsUpsellCtaScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboardInsert'
    },
    'whiteboardCreationPaywall-upfrontDialog': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    },
    'whiteboardCreationPaywall-unsetDialog': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    },
    'whiteboardCreationPaywall-viewOnlyButton': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    },
    createSpaceDrawer: {
        requestedEdition: 'premium',
        requestedFeature: 'copySpacePermissions'
    }
};
const $f4962613d517e76c$export$354adb22437506d7 = (source, edition)=>{
    switch(edition){
        case (0, $d9tcB.ConfluenceEdition).FREE:
            return $f4962613d517e76c$var$FREE_TOUCHPOINTS[source];
        case (0, $d9tcB.ConfluenceEdition).STANDARD:
            return $f4962613d517e76c$var$STANDARD_TOUCHPOINTS[source];
        default:
            return undefined;
    }
};
module.exports["getEligibleTouchpointForEdition"] = $f4962613d517e76c$export$354adb22437506d7;

});

parcelRegister("48ubT", function(module, exports) {

var $05h0Q = parcelRequire("05h0Q");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $w033M = parcelRequire("w033M");


var $jMyy4 = parcelRequire("jMyy4");

const $cfdb58fabb92c022$export$f9f8a5cdb0c565ef = ()=>{
    const { data: data, error: error, loading: isAdminCheckLoading } = (0, $jMyy4.useQueryInterop)((0, $05h0Q.default), {
        __callerPackage__: "current-user"
    });
    if (error) {
        if (!(0, $1uFM6.isUnauthorizedError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    const isSiteAdmin = (0, $w033M.getIsSiteAdminFromQuery)(data);
    return {
        isSiteAdmin: isSiteAdmin,
        isAdminCheckLoading: isAdminCheckLoading
    };
};
module.exports["useIsSiteAdmin"] = $cfdb58fabb92c022$export$f9f8a5cdb0c565ef;

});

parcelRegister("05h0Q", function(module, exports) {
/**
 * @generated SignedSource<<53a82c4d5f6d4a903b628178ddbe9e81>>
 * @relayHash 4434db08f18656b277e4683bc4dcaf5d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 049c6ec4db12d273730e8108ab3e3697ea427432281cceb660f908b10068087b
const $ea94449346330325$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "isSiteAdmin"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useIsSiteAdminUseIsSiteAdminQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useIsSiteAdminUseIsSiteAdminQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "4434db08f18656b277e4683bc4dcaf5d",
            "id": "049c6ec4db12d273730e8108ab3e3697ea427432281cceb660f908b10068087b",
            "metadata": {},
            "name": "useIsSiteAdminUseIsSiteAdminQuery",
            "operationKind": "query",
            "text": "query useIsSiteAdminUseIsSiteAdminQuery{isSiteAdmin}"
        }
    };
}();
$ea94449346330325$var$node.hash = "ce32420547b7702bc996599bbe635142";
var $ea94449346330325$export$2e2bcd8739ae039 = $ea94449346330325$var$node;
module.exports["default"] = $ea94449346330325$export$2e2bcd8739ae039;

});

parcelRegister("w033M", function(module, exports) {
const $ea2c8f52a33264f1$export$4782acb2cb5b7c11 = (queryData)=>Boolean(queryData?.isSiteAdmin);
module.exports["getIsSiteAdminFromQuery"] = $ea2c8f52a33264f1$export$4782acb2cb5b7c11;

});

parcelRegister("cwY4x", function(module, exports) {
module.exports = new URL("editor-ai-opt-in-banner.523b2454.svg", import.meta.url).toString();

});

parcelRegister("7mpOv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");

const $7ae32555811cd45f$export$cc5edac91cdebf9b = (_props = {})=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    return {
        isAIEnabledForContent: isAdminHubAIEnabled,
        isRovoEnabledForContent: isRovoLLMEnabled
    };
};
function $7ae32555811cd45f$export$fb975e2d7306f54a(WrappedComponent) {
    return function EnhancedComponent(props) {
        const [contentId] = (0, $ep3mz.usePageContentId)();
        const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = $7ae32555811cd45f$export$cc5edac91cdebf9b({
            contentId: contentId ?? ''
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
            ...props,
            isAIEnabledForContent: isAIEnabledForContent,
            isRovoEnabledForContent: isRovoEnabledForContent
        });
    };
}
module.exports["useIsAIEnabledForContent"] = $7ae32555811cd45f$export$cc5edac91cdebf9b;
module.exports["withIsAIEnabledForContent"] = $7ae32555811cd45f$export$fb975e2d7306f54a;

});

parcelRegister("a37Yb", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");


var $9BMpC = parcelRequire("9BMpC");

const $10850ba042c4d830$export$8476ffec3fa9a1c6 = ({ editorAPIRef: editorAPIRef })=>{
    const pluginOptions = (0, $cozmU.useMemo)(()=>{
        if (!(0, $9wGTI.fg)('cc_aifc_ai_streaming_spotlight')) return {};
        return {
            ButtonWrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9BMpC.AIStreamingSpotlight), {
                    editorAPIRef: editorAPIRef
                }, children)
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        pluginOptions: pluginOptions
    };
};
module.exports["useTrackChangesPlugin"] = $10850ba042c4d830$export$8476ffec3fa9a1c6;

});

parcelRegister("9BMpC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $4aRua = parcelRequire("4aRua");


var $57p4j = parcelRequire("57p4j");


var $ixfCV = parcelRequire("ixfCV");


var $I7hWB = parcelRequire("I7hWB");


var $3k5Tv = parcelRequire("3k5Tv");


var $lsxnT = parcelRequire("lsxnT");


var $bPDOf = parcelRequire("bPDOf");


var $ivb8S = parcelRequire("ivb8S");


var $9wGTI = parcelRequire("9wGTI");


var $9chzr = parcelRequire("9chzr");


var $2K2hA = parcelRequire("2K2hA");


var $4enp7 = parcelRequire("4enp7");


var $6VFk2 = parcelRequire("6VFk2");


var $2Vz7H = parcelRequire("2Vz7H");


var $l3ydK = parcelRequire("l3ydK");


var $4AC39 = parcelRequire("4AC39");


var $gi4qj = parcelRequire("gi4qj");


var $uyMbP = parcelRequire("uyMbP");


var $3eYzF = parcelRequire("3eYzF");


var $8jXZv = parcelRequire("8jXZv");


var $9Zall = parcelRequire("9Zall");


var $dOlTT = parcelRequire("dOlTT");

const $3da6770d1388bea2$var$i18n = (0, $kSwu1.defineMessages)({
    AIStreamingSpotlightTitle: {
        id: "onboarding-ai-first-create.ai-streaming.spotlight.title",
        defaultMessage: "View changes or undo"
    },
    AIStreamingSpotlightDescription: {
        id: "onboarding-ai-first-create.ai-streamin.spotlight.description",
        defaultMessage: "Compare your edits and Rovo\u2019s to a prior version and undo if needed."
    },
    AIStreamingSpotlightCTA: {
        id: "onboarding-ai-first-create.ai-streamin.spotlight.cta",
        defaultMessage: "OK"
    }
});
const $3da6770d1388bea2$export$cdcb27ae41cfd474 = ({ children: children, editorAPIRef: editorAPIRef })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $cozmU.useState)(false);
    const [streamingState, setStreamingState] = (0, $cozmU.useState)('initial');
    const { isStreaming: isStreaming, isShowDiffAvailable: isShowDiffAvailable } = (0, $3k5Tv.useSharedPluginStateWithSelector)(editorAPIRef?.current, [
        'aiExperience',
        'trackChanges'
    ], (states)=>{
        return {
            isStreaming: states?.aiExperienceState?.isStreaming,
            isShowDiffAvailable: states?.trackChangesState?.isShowDiffAvailable
        };
    });
    (0, $cozmU.useEffect)(()=>{
        if (isStreaming) {
            if (streamingState === 'initial') setStreamingState('streaming');
        } else if (streamingState === 'streaming' && isShowDiffAvailable) setStreamingState('completed');
        else setStreamingState('initial');
    }, [
        isStreaming,
        isShowDiffAvailable,
        streamingState
    ]);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { data: data, loading: loading, error: error } = (0, $ivb8S.useGetOnboardingState)(Object.values((0, $bPDOf.AIFC_ONBOARDING_STATE_KEYS)), !(0, $9wGTI.fg)('cc_aifc_ai_streaming_spotlight') || !(0, $9wGTI.fg)('aifc_create_enabled'));
    const { hasSeenTrackChangesStreamingSpotlight: hasSeenTrackChangesStreamingSpotlight } = (0, $ivb8S.deserializeState)(data);
    const handleSpotlightStart = (0, $cozmU.useCallback)(()=>{
        setOnboardingState({
            key: (0, $bPDOf.AIFC_ONBOARDING_STATE_KEYS).hasSeenTrackChangesStreamingSpotlight,
            value: 'true'
        });
        setIsSpotlightActive(true);
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'AIStreamingSpotlight',
                attributes: {
                    source: 'onboarding-ai-first-create'
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        setOnboardingState
    ]);
    const handleSpotlightStop = (0, $cozmU.useCallback)(()=>{
        setIsSpotlightActive(false);
    }, []);
    const { useChoreographer: useChoreographer } = (0, $lsxnT.useChoreographerAssets)();
    const aiStreamingSpotlightChoreographer = useChoreographer('AIStreamingSpotlight', {
        start: handleSpotlightStart,
        stop: handleSpotlightStop
    });
    const handleSpotlightInteraction = (0, $cozmU.useCallback)((action, actionSubject, actionSubjectIdSuffix)=>{
        setIsSpotlightActive(false);
        aiStreamingSpotlightChoreographer.stopMessage();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: `AIStreamingSpotlight${actionSubjectIdSuffix ?? ''}`,
                source: 'onboarding-ai-first-create'
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        aiStreamingSpotlightChoreographer
    ]);
    const handleOnClick = (0, $cozmU.useCallback)(()=>{
        handleSpotlightInteraction('clicked', 'button', 'CTA');
    }, [
        handleSpotlightInteraction
    ]);
    const handleOnDismiss = (0, $cozmU.useCallback)(()=>{
        handleSpotlightInteraction('clicked', 'button', 'Dismiss');
    }, [
        handleSpotlightInteraction
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!loading && !error && !hasSeenTrackChangesStreamingSpotlight && !isStreaming && isShowDiffAvailable && streamingState === 'completed' && (0, $9wGTI.fg)('cc_aifc_ai_streaming_spotlight')) aiStreamingSpotlightChoreographer.startMessage();
    }, [
        loading,
        error,
        hasSeenTrackChangesStreamingSpotlight,
        aiStreamingSpotlightChoreographer,
        isStreaming,
        isShowDiffAvailable,
        streamingState
    ]);
    if (!isSpotlightActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9chzr.UNSAFE_UpdateOnChange), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dOlTT.PopoverContent), {
        dismiss: handleOnDismiss,
        isVisible: isSpotlightActive,
        placement: "bottom-start"
    }, (()=>{
        const spotlightCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gi4qj.SpotlightCard), {
            testId: "ai-streaming-spotlight"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6VFk2.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4enp7.SpotlightHeadline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "span",
            size: "small"
        }, formatMessage($3da6770d1388bea2$var$i18n.AIStreamingSpotlightTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AC39.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l3ydK.SpotlightDismissControl), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyMbP.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, formatMessage($3da6770d1388bea2$var$i18n.AIStreamingSpotlightDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Vz7H.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eYzF.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2K2hA.SpotlightPrimaryAction), {
            onClick: handleOnClick
        }, formatMessage($3da6770d1388bea2$var$i18n.AIStreamingSpotlightCTA)))));
        return (0, $ixfCV.fg)('platform-dst-motion-uplift-spotlight') ? spotlightCard : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            entranceDirection: "left"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", props, spotlightCard));
    })()));
};
module.exports["AIStreamingSpotlight"] = $3da6770d1388bea2$export$cdcb27ae41cfd474;

});

parcelRegister("bPDOf", function(module, exports) {
const $4fc1e4c0ecd68c6d$export$dcf613c5ca1d0575 = {
    hasSeenAIFCSpotlight: 'aifc-onboarding:hasSeenAIFCSpotlight',
    isAIFCSpotlightActive: 'aifc-onboarding:isAIFCSpotlightActive',
    hasSeenWhiteboardSmartCreateSpotlight: 'aifc-onboarding:hasSeenWhiteboardSmartCreateSpotlight',
    hasSeenTrackChangesStreamingSpotlight: 'aifc-onboarding:hasSeenTrackChangesStreamingSpotlight',
    isAIFCChatSpotlightActive: 'aifc-onboarding:isAIFCChatSpotlightActive',
    hasSeenAIFCChatSpotlight: 'aifc-onboarding:hasSeenAIFCChatSpotlight',
    hasDismissedGettingStartedTour: 'aifc-onboarding:hasDismissedGettingStartedTour',
    hasSeenDeeplinkReturnSpotlight: 'aifc-onboarding:hasSeenDeeplinkReturnSpotlight',
    hasSeenTwcAifcOnboarding: 'aifc-onboarding:hasSeenTwcAifcOnboarding'
};
const $4fc1e4c0ecd68c6d$export$6024bf9594f957fe = [
    ...Object.values($4fc1e4c0ecd68c6d$export$dcf613c5ca1d0575)
];
module.exports["AIFC_ONBOARDING_STATE_KEYS"] = $4fc1e4c0ecd68c6d$export$dcf613c5ca1d0575;
module.exports["AIFCOnboardingKeys"] = $4fc1e4c0ecd68c6d$export$6024bf9594f957fe;

});

parcelRegister("9chzr", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ixfCV = parcelRequire("ixfCV");


var $ikWHh = parcelRequire("ikWHh");


var $eVcJM = parcelRequire("eVcJM");

const $c64a9e97047f0043$export$6a6a5d23d75b0f62 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { selectors: selectors, options: options } = t0;
    let t1;
    if ($[0] !== options || $[1] !== selectors) {
        t1 = (0, $ixfCV.fg)("platform-dst-top-layer-spotlight") ? /*#__PURE__*/ $cozmU.createElement((0, $eVcJM.UNSAFE_UpdateOnChange), {
            selectors: selectors,
            options: options
        }) : /*#__PURE__*/ $cozmU.createElement((0, $ikWHh.UNSAFE_UpdateOnChange), {
            selectors: selectors,
            options: options
        });
        $[0] = options;
        $[1] = selectors;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ selectors: selectors, options: options })=>(0, $ixfCV.fg)('platform-dst-top-layer-spotlight') ? /*#__PURE__*/ $cozmU.createElement((0, $eVcJM.UNSAFE_UpdateOnChange), {
        selectors: selectors,
        options: options
    }) : /*#__PURE__*/ $cozmU.createElement((0, $ikWHh.UNSAFE_UpdateOnChange), {
        selectors: selectors,
        options: options
    });
module.exports["UNSAFE_UpdateOnChange"] = $c64a9e97047f0043$export$6a6a5d23d75b0f62;

});

parcelRegister("ikWHh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $haNN4 = parcelRequire("haNN4");


var $j8G8s = parcelRequire("j8G8s");

const $2507bbd5b7af8817$var$defaultOptions = {
    childList: true,
    subtree: true
};
const $2507bbd5b7af8817$export$6a6a5d23d75b0f62 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { selectors: t1, options: t2 } = t0;
    let t3;
    if ($[0] !== t1) {
        t3 = t1 === undefined ? [
            "body"
        ] : t1;
        $[0] = t1;
        $[1] = t3;
    } else t3 = $[1];
    const selectors = t3;
    const options = t2 === undefined ? $2507bbd5b7af8817$var$defaultOptions : t2;
    const { popoverContent: popoverContent } = (0, $cozmU.useContext)((0, $j8G8s.SpotlightContext));
    const { update: update } = popoverContent;
    let t4;
    let t5;
    if ($[2] !== options || $[3] !== selectors || $[4] !== update) {
        t4 = ()=>{
            if (!update || selectors.length === 0) return;
            const doc = (0, $haNN4.getDocument)();
            if (!doc) return;
            const elements = new Set();
            selectors.forEach((selector)=>{
                const element = doc.querySelector(selector);
                if (!element) return;
                elements.add(element);
            });
            if (elements.size === 0) return;
            const observers = [];
            elements.forEach((element_0)=>{
                const observer = new MutationObserver((mutations)=>{
                    if (mutations.length === 0) return;
                    update();
                });
                observer.observe(element_0, options);
                observers.push(observer);
            });
            return ()=>{
                observers.forEach($2507bbd5b7af8817$var$_temp);
            };
        };
        t5 = [
            selectors,
            options,
            update
        ];
        $[2] = options;
        $[3] = selectors;
        $[4] = update;
        $[5] = t4;
        $[6] = t5;
    } else {
        t4 = $[5];
        t5 = $[6];
    }
    (0, $cozmU.useEffect)(t4, t5);
    return null;
} : ({ selectors: selectors = [
    'body'
], options: options = $2507bbd5b7af8817$var$defaultOptions })=>{
    const { popoverContent: popoverContent } = (0, $cozmU.useContext)((0, $j8G8s.SpotlightContext));
    const { update: update } = popoverContent;
    (0, $cozmU.useEffect)(()=>{
        if (!update || selectors.length === 0) return;
        const doc = (0, $haNN4.getDocument)();
        if (!doc) return;
        const elements = new Set();
        selectors.forEach((selector)=>{
            const element = doc.querySelector(selector);
            if (!element) return;
            elements.add(element);
        });
        if (elements.size === 0) return;
        const observers = [];
        elements.forEach((element_0)=>{
            const observer = new MutationObserver((mutations)=>{
                if (mutations.length === 0) return;
                update();
            });
            observer.observe(element_0, options);
            observers.push(observer);
        });
        return ()=>{
            observers.forEach((observer_0)=>observer_0.disconnect());
        };
    }, [
        selectors,
        options,
        update
    ]);
    return null;
};
function $2507bbd5b7af8817$var$_temp(observer_0) {
    return observer_0.disconnect();
}
module.exports["UNSAFE_UpdateOnChange"] = $2507bbd5b7af8817$export$6a6a5d23d75b0f62;

});

parcelRegister("eVcJM", function(module, exports) {
const $40d232a496003659$export$6a6a5d23d75b0f62 = (_props)=>null;
module.exports["UNSAFE_UpdateOnChange"] = $40d232a496003659$export$6a6a5d23d75b0f62;

});

parcelRegister("32x2E", function(module, exports) {

var $1UWNP = parcelRequire("1UWNP");


var $bwAnG = parcelRequire("bwAnG");


var $7W8i8 = parcelRequire("7W8i8");

const $dc26b22176754e2e$var$logger = (0, $7W8i8.getLogger)('emoji-provider');
const $dc26b22176754e2e$export$ca6dda5263526f75 = '/gateway/api/emoji';
const $dc26b22176754e2e$export$240be4f98742fdda = (cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const config = {
        providers: [
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/standard`
            },
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/atlassian`
            }
        ],
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks || {}
    };
    if (cloudId && (userId || allowAnonymousAccess)) config.providers.push({
        url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/site`
    });
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $dc26b22176754e2e$export$1504d130127dbc5f = (_EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? false;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    return `${cloudId}_${userId}_${allowAnonymousAccess}_${emojiSSRConfig ? 'withSSR' : 'noSSR'}`;
};
const $dc26b22176754e2e$export$9e6d4bd03aadcea5 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? undefined;
    const emojiConfig = $dc26b22176754e2e$export$240be4f98742fdda(cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess);
    return new EmojiResource(emojiConfig);
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return emojiResource.getEmojiProvider();
    } catch (err) {
        return Promise.resolve(undefined);
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$b263a0680b18512c = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return new (0, $bwAnG.EmojiNodeDataProvider)(emojiResource);
    } catch (err) {
        return undefined;
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
module.exports["getEmojiConfig"] = $dc26b22176754e2e$export$240be4f98742fdda;
module.exports["getEmojiProvider"] = $dc26b22176754e2e$export$8210f5f78c0bcf27;
module.exports["getEmojiNodeDataProvider"] = $dc26b22176754e2e$export$b263a0680b18512c;

});

parcelRegister("bwAnG", function(module, exports) {

var $4iudd = parcelRequire("4iudd");


var $l4yrE = parcelRequire("l4yrE");


var $4xiow = parcelRequire("4xiow");


var $drRzc = parcelRequire("drRzc");


var $anBbz = parcelRequire("anBbz");

class $dfb1108de4ce4e19$export$67106c51beb59865 extends (0, $drRzc.NodeDataProvider) {
    isNodeSupported(node) {
        return node.type === 'emoji';
    }
    nodeDataKey(node) {
        return node.attrs.id || node.attrs.shortName;
    }
    /**
   * Implementing different re-fetching strategy for emoji.
   *
   * Default strategy for NodeDataProvider is to:
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   * 4. Re-render node with fresh data.
   *
   * This is similar, but doesn't update the node.
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   */ getData(node, callback) {
        const cached = this.getNodeDataFromCache(node);
        if (cached?.data) {
            callback(cached);
            if (!(0, $4iudd.isSSR)() && typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(()=>void this.getDataAsync(node, ()=>{}));
        } else this.getDataAsync(node, callback);
    }
    async fetchNodesData(nodes) {
        // If we have an `optimisticImageApi`, use it to generate a URL immediately.
        // This is how emojis are server-side rendered in Confluence.
        // Without this, the emoji server response will hit timeout on SSR and the emoji will not be rendered.
        //
        // We are using this optimization only in SSR because on client side we need to know a valid emoji size
        // which is not possible to get from optimisticImageApi.
        //
        // Check platform/packages/editor/renderer/src/react/nodes/emoji.tsx
        // and platform/packages/elements/emoji/src/components/common/ResourcedEmojiComponent.tsx
        const getOptimisticImageUrl = this.emojiResource.emojiProviderConfig.optimisticImageApi?.getUrl;
        if ((0, $4iudd.isSSR)() && getOptimisticImageUrl) return nodes.map((node)=>{
            if ((0, $anBbz.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true)) {
                // Skip SSR for nodes without an Id
                if (!node.attrs.id) return undefined;
                const unicodeEmoji = (0, $4xiow.emojiIdToEmoji)(node.attrs.id);
                if (unicodeEmoji) return {
                    id: node.attrs.id,
                    shortName: node.attrs.shortName,
                    fallback: node.attrs.text,
                    representation: {
                        unicodeEmoji: unicodeEmoji
                    },
                    searchable: true,
                    type: '',
                    category: ''
                };
            }
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            const optimisticImageURL = getOptimisticImageUrl(emojiId);
            return {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text,
                representation: {
                    height: (0, $l4yrE.defaultEmojiHeight),
                    width: (0, $l4yrE.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true,
                // Type and category are unknown at this point.
                // It's not a big deal, because EmojiNodeView doesn't use them.
                type: '',
                category: ''
            };
        });
        // This is slower path because during access to emojiProvider emojiResource
        // makes a request to fetch all emojis.
        const emojiProvider = await this.emojiProvider;
        const fetches = nodes.map(async (node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            // This usually fast because the emojiProvider already has all emojis fetched.
            const result = await emojiProvider.fetchByEmojiId(emojiId, true);
            // For STANDARD emojis, return a UnicodeRepresentation so they are rendered
            // as native text characters rather than images (twemoji removal).
            if (node.attrs.id && result && (0, $anBbz.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true)) {
                const unicodeEmoji = (0, $4xiow.emojiIdToEmoji)(node.attrs.id);
                if (unicodeEmoji) return {
                    ...result,
                    representation: {
                        unicodeEmoji: unicodeEmoji
                    }
                };
            }
            // If we have optimisticImageApi, we need to path response and set URL from it to match the URL used in SSR.
            if (getOptimisticImageUrl && result) {
                const optimisticImageURL = getOptimisticImageUrl(emojiId);
                if (result.representation && 'imagePath' in result.representation) return {
                    ...result,
                    representation: {
                        ...result.representation,
                        imagePath: optimisticImageURL
                    }
                };
            }
            return result;
        });
        return Promise.all(fetches);
    }
    constructor(resource){
        super();
        this.name = 'emojiNodeDataProvider';
        this.emojiResource = void 0;
        this.emojiProvider = void 0;
        this.emojiResource = resource;
        this.emojiProvider = resource.getEmojiProvider();
    }
}
module.exports["EmojiNodeDataProvider"] = $dfb1108de4ce4e19$export$67106c51beb59865;

});

parcelRegister("jO6sX", function(module, exports) {

var $ip8Mg = parcelRequire("ip8Mg");


var $bPFvq = parcelRequire("bPFvq");


var $cbHql = parcelRequire("cbHql");


var $cozmU = parcelRequire("cozmU");


var $fqVYq = parcelRequire("fqVYq");


var $fFmJj = parcelRequire("fFmJj");


var $9wGTI = parcelRequire("9wGTI");


var $hp2SH = parcelRequire("hp2SH");


var $bQm3c = parcelRequire("bQm3c");


var $c0rhi = parcelRequire("c0rhi");


var $6s78L = parcelRequire("6s78L");


var $fEmGS = parcelRequire("fEmGS");


var $44LO1 = parcelRequire("44LO1");


var $iGI5F = parcelRequire("iGI5F");

const $0d17c8f0adf5cf3d$var$EditorPreferencesQuery = (0, $cbHql.default);
const $0d17c8f0adf5cf3d$var$EditorPreferencesMutation = (0, $bPFvq.default);
const $0d17c8f0adf5cf3d$export$3ece90ca9e31f585 = (confluenceEditorSettings)=>{
    if (confluenceEditorSettings && confluenceEditorSettings) return confluenceEditorSettings;
    return {};
};
class $0d17c8f0adf5cf3d$export$accffe59bc474b30 {
    init() {
        if (!this.initialized) this.fetchPreferences().catch(()=>{
        // Do nothing
        });
    }
    // add this to implment the UserPreferensProvider interface.
    loadPreferences() {
        return Promise.reject();
    }
    async fetchPreferences() {
        if (!this.apolloClient) return Promise.reject('No apollo client');
        try {
            if (!this.initialized) {
                const { data: data } = await (0, $c0rhi.queryInterop)({
                    query: $0d17c8f0adf5cf3d$var$EditorPreferencesQuery,
                    __callerPackage__: "editor-presets"
                });
                this.userPreferences = $0d17c8f0adf5cf3d$export$3ece90ca9e31f585(data?.userPreferences?.confluenceEditorSettings);
                this.initialized = true;
            }
            return Promise.resolve();
        } catch (error) {
            return Promise.reject(error);
        }
    }
    async updatePreference(key, value) {
        if (!this.apolloClient) return Promise.reject('No apollo client');
        this.userPreferences[key] = value;
        const variables = {
            [key]: value
        };
        try {
            const response = await (0, $6s78L.mutateInterop)({
                mutation: $0d17c8f0adf5cf3d$var$EditorPreferencesMutation,
                variables: variables,
                update: ()=>{
                    // this is required to indicate toolbar changes to progressive object header
                    (0, $fEmGS.writeQueryInterop)({
                        query: $0d17c8f0adf5cf3d$var$EditorPreferencesQuery,
                        data: {
                            userPreferences: {
                                __typename: 'UserPreferences',
                                confluenceEditorSettings: {
                                    __typename: 'ConfluenceEditorSettings',
                                    toolbarDockingInitialPosition: value === 'top' ? value : null // Null is required since apollo cache uses shallow reference equality
                                }
                            }
                        },
                        __callerPackage__: "editor-presets"
                    });
                },
                __callerPackage__: "editor-presets"
            });
            const confluenceEditorSettings = $0d17c8f0adf5cf3d$export$3ece90ca9e31f585(response.data?.updateUserPreferences?.confluenceEditorSettings);
            this.userPreferences[key] = confluenceEditorSettings[key];
            return Promise.resolve();
        } catch (error) {
            return Promise.reject(error);
        }
    }
    getPreference(key) {
        return this.userPreferences[key];
    }
    constructor(){
        this.userPreferences = {};
        // We use getApolloClient to get the apollo client instance
        // This is to avoid adding required apollo context
        this.apolloClient = (0, $hp2SH.getApolloClient)();
        this.initialized = false;
        this.init();
    }
}
const $0d17c8f0adf5cf3d$var$createUserPreferencesProvider = (options)=>{
    if ((0, $9wGTI.fg)('platform_editor_user_preferences_provider_update')) {
        const getFallbackUserPreferences = ()=>({
                toolbarDockingInitialPosition: options?.getCurrentIsLivePage?.() ? 'none' : 'top'
            });
        return new (0, $44LO1.EditorUserPreferencesProvider)({
            getFallbackUserPreferences: getFallbackUserPreferences
        });
    }
    return new $0d17c8f0adf5cf3d$export$accffe59bc474b30();
};
const $0d17c8f0adf5cf3d$export$c88c6b9f15f77aea = (options)=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const confluenceEditorPreferencesProvider = (0, $cozmU.useRef)();
    const editorPreferencesProvider = (0, $cozmU.useRef)();
    const persistenceAPI = (0, $cozmU.useRef)();
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $ip8Mg.default),
        __callerPackage__: "editor-presets"
    });
    if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) {
        if ((0, $9wGTI.fg)('platform_editor_use_preferences_plugin')) {
            if (!editorPreferencesProvider.current) {
                const isLivePage = options?.getCurrentIsLivePage?.() ?? false;
                persistenceAPI.current = new (0, $iGI5F.UserPreferencesPersistenceAPI)(isLoggedIn, readFragmentInterop);
                editorPreferencesProvider.current = (0, $iGI5F.getUserPreferencesProvider)({
                    isLivePage: isLivePage,
                    persistenceAPI: persistenceAPI.current,
                    readFragmentInterop: readFragmentInterop
                });
            }
        } else if (!confluenceEditorPreferencesProvider.current) confluenceEditorPreferencesProvider.current = isLoggedIn ? $0d17c8f0adf5cf3d$var$createUserPreferencesProvider(options) : undefined;
    }
    (0, $cozmU.useEffect)(()=>{
        if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) {
            if (persistenceAPI.current && (0, $9wGTI.fg)('platform_editor_use_preferences_plugin')) persistenceAPI.current.setIsLoggedIn(isLoggedIn);
        }
    }, [
        isLoggedIn
    ]);
    return {
        confluenceEditorPreferencesProvider: confluenceEditorPreferencesProvider.current,
        editorPreferencesProvider: editorPreferencesProvider.current ?? undefined
    };
};
module.exports["parseConfluenceEditorSettings"] = $0d17c8f0adf5cf3d$export$3ece90ca9e31f585;
module.exports["useEditorPreferencesProvider"] = $0d17c8f0adf5cf3d$export$c88c6b9f15f77aea;

});

parcelRegister("ip8Mg", function(module, exports) {
/**
 * @generated SignedSource<<a9b62471ce29523412c79e09bd6d074d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $dcb986cc56874e48$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "EditorPreferencesQueryFragment",
    "selections": [
        {
            "concreteType": "ConfluenceEditorSettings",
            "kind": "LinkedField",
            "name": "confluenceEditorSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "toolbarDockingInitialPosition"
                }
            ]
        }
    ],
    "type": "UserPreferences"
};
$dcb986cc56874e48$var$node.hash = "c14a58c792cd6196c5f117a58ba70054";
var $dcb986cc56874e48$export$2e2bcd8739ae039 = $dcb986cc56874e48$var$node;
module.exports["default"] = $dcb986cc56874e48$export$2e2bcd8739ae039;

});

parcelRegister("bPFvq", function(module, exports) {
/**
 * @generated SignedSource<<5d5b83cfc50c2c31f5f5173ccf476851>>
 * @relayHash 1b2bc31ac42719bf8add4db3a6390b58
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 127d43e36b149ae142a2ec8732d260390b2cd6c7260cd15d254197587add32cb
const $185ebb8cafff52fb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "toolbarDockingInitialPosition"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "toolbarDockingInitialPosition",
                                    "variableName": "toolbarDockingInitialPosition"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "confluenceEditorSettingsInput"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "userPreferences"
                }
            ],
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "updateUserPreferences",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceEditorSettings",
                    "kind": "LinkedField",
                    "name": "confluenceEditorSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "toolbarDockingInitialPosition"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditorPreferencesMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditorPreferencesMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1b2bc31ac42719bf8add4db3a6390b58",
            "id": "127d43e36b149ae142a2ec8732d260390b2cd6c7260cd15d254197587add32cb",
            "metadata": {},
            "name": "EditorPreferencesMutation",
            "operationKind": "mutation",
            "text": "mutation EditorPreferencesMutation($toolbarDockingInitialPosition:String!){updateUserPreferences(userPreferences:{confluenceEditorSettingsInput:{toolbarDockingInitialPosition:$toolbarDockingInitialPosition}}){confluenceEditorSettings{toolbarDockingInitialPosition}}}"
        }
    };
}();
$185ebb8cafff52fb$var$node.hash = "37475c1d65dabe41f55ac97eba30ddfa";
var $185ebb8cafff52fb$export$2e2bcd8739ae039 = $185ebb8cafff52fb$var$node;
module.exports["default"] = $185ebb8cafff52fb$export$2e2bcd8739ae039;

});

parcelRegister("cbHql", function(module, exports) {
/**
 * @generated SignedSource<<ca53475eaec9df41a732c9e6f52f225d>>
 * @relayHash c67b40e0841cbe3641e147b8f635e291
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8cba7661cae04b18a2f396c25dedbd53d2bb4184aef34b7e93cfb70fbef58af5
const $40163854596f3729$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceEditorSettings",
                    "kind": "LinkedField",
                    "name": "confluenceEditorSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "toolbarDockingInitialPosition"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "EditorPreferencesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "EditorPreferencesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "c67b40e0841cbe3641e147b8f635e291",
            "id": "8cba7661cae04b18a2f396c25dedbd53d2bb4184aef34b7e93cfb70fbef58af5",
            "metadata": {},
            "name": "EditorPreferencesQuery",
            "operationKind": "query",
            "text": "query EditorPreferencesQuery{userPreferences{confluenceEditorSettings{toolbarDockingInitialPosition}}}"
        }
    };
}();
$40163854596f3729$var$node.hash = "49dd5f6cf6c26477ad455a4c7f501e60";
var $40163854596f3729$export$2e2bcd8739ae039 = $40163854596f3729$var$node;
module.exports["default"] = $40163854596f3729$export$2e2bcd8739ae039;

});

parcelRegister("44LO1", function(module, exports) {

var $6ryhQ = parcelRequire("6ryhQ");


var $18dXR = parcelRequire("18dXR");


var $hp2SH = parcelRequire("hp2SH");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $lmtWR = parcelRequire("lmtWR");


var $l1uFv = parcelRequire("l1uFv");


var $c0rhi = parcelRequire("c0rhi");


var $6s78L = parcelRequire("6s78L");


var $fEmGS = parcelRequire("fEmGS");


var $jO6sX = parcelRequire("jO6sX");

const $fa29ff75a45929c5$var$EditorUserPreferencesProviderQuery = (0, $18dXR.default);
const $fa29ff75a45929c5$var$EditorUserPreferencesProviderMutation = (0, $6ryhQ.default);
var $fa29ff75a45929c5$var$Status = /*#__PURE__*/ function(Status) {
    Status["Complete"] = "complete";
    Status["Error"] = "error";
    Status["Pending"] = "pending";
    return Status;
}($fa29ff75a45929c5$var$Status || {});
const $fa29ff75a45929c5$export$48d7c418edadb60c = ()=>Boolean(undefined);
class $fa29ff75a45929c5$export$7f7007b732b93d85 {
    // synchronously load preferences from cache
    loadPreferencesFromCache() {
        if (!$fa29ff75a45929c5$export$48d7c418edadb60c()) {
            const userPreferenceStorage = (0, $17wUi.confluenceLocalStorageInstance) && (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).EDITOR_CONTROLS_INITIAL_PREFERENCES);
            if (userPreferenceStorage) this.userPreferences = JSON.parse(userPreferenceStorage);
        }
        if (!this.apolloClient) return undefined;
        try {
            const result = (0, $l1uFv.readQueryInterop)({
                query: $fa29ff75a45929c5$var$EditorUserPreferencesProviderQuery,
                __callerPackage__: "editor-presets"
            });
            if (result?.userPreferences) {
                this.userPreferences = (0, $jO6sX.parseConfluenceEditorSettings)(result.userPreferences?.confluenceEditorSettings);
                // if we have a cached value, we can set the status to complete
                // since we are not going to make a network request
                // to fetch the preferences with loadPreferencesInternal and not skipCache
                if (this.providerStatus !== "complete") this.providerStatus = "complete";
            }
            return this.userPreferences;
        } catch  {
            return this.userPreferences;
        }
    }
    async loadPreferencesInternal(options) {
        if (!this.apolloClient) return Promise.reject('No apollo client');
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: $fa29ff75a45929c5$var$EditorUserPreferencesProviderQuery,
            fetchPolicy: options?.skipCache ? 'no-cache' : 'cache-first',
            __callerPackage__: "editor-presets"
        });
        this.userPreferences = (0, $jO6sX.parseConfluenceEditorSettings)(data?.userPreferences?.confluenceEditorSettings);
        this.updateLocalStorage();
        return this.userPreferences;
    }
    async loadPreferences() {
        try {
            const userPreferences = await this.loadPreferencesInternal({
                skipCache: true
            });
            // can recover from the status previous error
            if (this.providerStatus !== "complete") this.providerStatus = "complete";
            return userPreferences;
        } catch (error) {
            // We will ignore subssequent errors if thte status was complete
            // And will use the data from previous request
            if (this.providerStatus !== "complete") this.providerStatus = "error";
            return Promise.reject(error);
        }
    }
    updateLocalStorage() {
        if (!$fa29ff75a45929c5$export$48d7c418edadb60c()) (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).EDITOR_CONTROLS_INITIAL_PREFERENCES, JSON.stringify(this.userPreferences));
    }
    async updatePreference(key, value) {
        if (!this.apolloClient) return Promise.reject('No apollo client');
        const variables = {
            [key]: value
        };
        this.userPreferences[key] = value;
        const { data: data } = await (0, $6s78L.mutateInterop)({
            mutation: $fa29ff75a45929c5$var$EditorUserPreferencesProviderMutation,
            variables: variables,
            update: ()=>{
                // this is required to indicate toolbar changes to any useQuery for EditorPreferencesQuery, particularly progressive object header
                const getValue = ()=>value ?? null;
                (0, $fEmGS.writeQueryInterop)({
                    query: $fa29ff75a45929c5$var$EditorUserPreferencesProviderQuery,
                    data: {
                        userPreferences: {
                            __typename: 'UserPreferences',
                            confluenceEditorSettings: {
                                __typename: 'ConfluenceEditorSettings',
                                toolbarDockingInitialPosition: getValue()
                            }
                        }
                    },
                    __callerPackage__: "editor-presets"
                });
            },
            __callerPackage__: "editor-presets"
        });
        const updatedUserPreferences = (0, $jO6sX.parseConfluenceEditorSettings)(data?.updateUserPreferences?.confluenceEditorSettings);
        this.userPreferences = {
            ...this.userPreferences,
            ...updatedUserPreferences
        };
        if (value === 'top') (0, $lmtWR.persistBannerDismissalNewPinning)('toolbar-inline');
        else if (value === 'none') (0, $lmtWR.persistBannerDismissalNewPinning)('toolbar-top');
        this.updateLocalStorage();
    }
    getPreference(key) {
        const fallbackUserPreferences = this.getFallbackUserPreferences?.() || {};
        return this.userPreferences[key] || fallbackUserPreferences[key];
    }
    constructor(options = {}){
        this.userPreferences = {};
        this.getFallbackUserPreferences = void 0;
        // We use getApolloClient to get the apollo client instance
        // This is to avoid adding required apollo context
        this.apolloClient = (0, $hp2SH.getApolloClient)();
        this.providerStatus = "pending";
        this.getFallbackUserPreferences = options.getFallbackUserPreferences;
        this.loadPreferencesFromCache();
        this.loadPreferencesInternal().then(()=>{
            this.providerStatus = "complete";
        }).catch(()=>{
            this.providerStatus = "error";
        });
    }
}
module.exports["isSSR"] = $fa29ff75a45929c5$export$48d7c418edadb60c;
module.exports["EditorUserPreferencesProvider"] = $fa29ff75a45929c5$export$7f7007b732b93d85;

});

parcelRegister("6ryhQ", function(module, exports) {
/**
 * @generated SignedSource<<c8150b45e41048bfba095ba618c09c83>>
 * @relayHash abbe28b997f121d37d2a6bcf9de50587
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f5be2854f68d3367f4e7c42520108fad469d661f65c300a3a4d181891edb92ec
const $90a65d92fac4dfbd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "toolbarDockingInitialPosition"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "fields": [
                                {
                                    "kind": "Variable",
                                    "name": "toolbarDockingInitialPosition",
                                    "variableName": "toolbarDockingInitialPosition"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "confluenceEditorSettingsInput"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "userPreferences"
                }
            ],
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "updateUserPreferences",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceEditorSettings",
                    "kind": "LinkedField",
                    "name": "confluenceEditorSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "toolbarDockingInitialPosition"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditorUserPreferencesProviderMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditorUserPreferencesProviderMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "abbe28b997f121d37d2a6bcf9de50587",
            "id": "f5be2854f68d3367f4e7c42520108fad469d661f65c300a3a4d181891edb92ec",
            "metadata": {},
            "name": "EditorUserPreferencesProviderMutation",
            "operationKind": "mutation",
            "text": "mutation EditorUserPreferencesProviderMutation($toolbarDockingInitialPosition:String!){updateUserPreferences(userPreferences:{confluenceEditorSettingsInput:{toolbarDockingInitialPosition:$toolbarDockingInitialPosition}}){confluenceEditorSettings{toolbarDockingInitialPosition}}}"
        }
    };
}();
$90a65d92fac4dfbd$var$node.hash = "58cff6da35ff84f165c997ef5ed48166";
var $90a65d92fac4dfbd$export$2e2bcd8739ae039 = $90a65d92fac4dfbd$var$node;
module.exports["default"] = $90a65d92fac4dfbd$export$2e2bcd8739ae039;

});

parcelRegister("18dXR", function(module, exports) {
/**
 * @generated SignedSource<<68f3663927156d076fc22d8e424efb71>>
 * @relayHash 63854a4c84372d699a45f9c1a07dc352
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3e409706ac010c745c55960052598708ff7eaf469154eb4c8db7ff920f81b76e
const $e4a48aa60613f0b2$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceEditorSettings",
                    "kind": "LinkedField",
                    "name": "confluenceEditorSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "toolbarDockingInitialPosition"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "EditorUserPreferencesProviderQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "EditorUserPreferencesProviderQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "63854a4c84372d699a45f9c1a07dc352",
            "id": "3e409706ac010c745c55960052598708ff7eaf469154eb4c8db7ff920f81b76e",
            "metadata": {},
            "name": "EditorUserPreferencesProviderQuery",
            "operationKind": "query",
            "text": "query EditorUserPreferencesProviderQuery{userPreferences{confluenceEditorSettings{toolbarDockingInitialPosition}}}"
        }
    };
}();
$e4a48aa60613f0b2$var$node.hash = "22c44eb8a7e5e6240c1d402a68a09da0";
var $e4a48aa60613f0b2$export$2e2bcd8739ae039 = $e4a48aa60613f0b2$var$node;
module.exports["default"] = $e4a48aa60613f0b2$export$2e2bcd8739ae039;

});

parcelRegister("lmtWR", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $7W8i8 = parcelRequire("7W8i8");

const $087f019a02b7077e$var$logger = (0, $7W8i8.getLogger)('EditorControlsBannerDismissal');
const $087f019a02b7077e$var$NEW_PINNING_STORAGE_KEY = (0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_EDITOR_CONTROLS_ONBOARDING_BANNER_NEW_PINNING_DISMISSED;
const $087f019a02b7077e$var$AUTO_DISMISSAL_THRESHOLD = 604800000; // 7 days in milliseconds
const $087f019a02b7077e$export$b16c0225931fdfcf = (isTopBanner)=>{
    return isTopBanner ? 'toolbar-top' : 'toolbar-inline';
};
const $087f019a02b7077e$var$getLocalStorageItem = (storageKey)=>{
    try {
        const itemString = (0, $17wUi.confluenceLocalStorageInstance).getItem(storageKey);
        if (!itemString) return undefined;
        const item = JSON.parse(itemString);
        if (typeof item === 'object' && item !== null && !Array.isArray(item) && Object.keys(item).every((key)=>[
                'toolbar-top',
                'toolbar-inline'
            ].includes(key))) return item;
    } catch (error) {
        $087f019a02b7077e$var$logger.error`Error parsing local storage key(${storageKey}): ${error}`;
    }
    return undefined;
};
const $087f019a02b7077e$var$recordFirstViewTime = (bannerType, item)=>{
    const firstViewed = {
        firstViewed: Date.now()
    };
    try {
        if (!item) (0, $17wUi.confluenceLocalStorageInstance).setItem($087f019a02b7077e$var$NEW_PINNING_STORAGE_KEY, JSON.stringify({
            [bannerType]: firstViewed
        }));
        else {
            item[bannerType] = {
                ...item[bannerType],
                ...firstViewed
            };
            (0, $17wUi.confluenceLocalStorageInstance).setItem($087f019a02b7077e$var$NEW_PINNING_STORAGE_KEY, JSON.stringify(item));
        }
    } catch (error) {
        $087f019a02b7077e$var$logger.error`Error setting local storage key(${$087f019a02b7077e$var$NEW_PINNING_STORAGE_KEY}): ${error}`;
    }
};
const $087f019a02b7077e$export$7b46a18b5966c9f8 = (bannerType)=>{
    const localStorageItem = $087f019a02b7077e$var$getLocalStorageItem($087f019a02b7077e$var$NEW_PINNING_STORAGE_KEY);
    const { firstViewed: firstViewed, count: dismissalCount } = localStorageItem?.[bannerType] || {};
    // Record first view time if it does not exist. Do this before returning to
    // ensure we record a time even if there are no prior records
    if (firstViewed === undefined) $087f019a02b7077e$var$recordFirstViewTime(bannerType, localStorageItem);
    // No local storage = no banner dismissal
    if (!localStorageItem) return false;
    // If banner was first viewed more than a week ago, hide it even if it had not been dismissed
    const shouldAutoDismiss = firstViewed && Date.now() - firstViewed > $087f019a02b7077e$var$AUTO_DISMISSAL_THRESHOLD;
    if (shouldAutoDismiss) return true;
    // If count is anything other than undefined, it means the banner has been dismissed (including if count is 0!)
    return dismissalCount !== undefined;
};
const $087f019a02b7077e$export$1f63bcf565c85af4 = (bannerType)=>{
    let item = $087f019a02b7077e$var$getLocalStorageItem($087f019a02b7077e$var$NEW_PINNING_STORAGE_KEY);
    if (!item) item = {
        [bannerType]: {
            count: 0
        }
    };
    else {
        const existingDismissal = item[bannerType];
        item[bannerType] = {
            ...existingDismissal,
            count: 0
        };
    }
    try {
        (0, $17wUi.confluenceLocalStorageInstance).setItem($087f019a02b7077e$var$NEW_PINNING_STORAGE_KEY, JSON.stringify(item));
    } catch (error) {
        $087f019a02b7077e$var$logger.error`Error setting local storage key(${$087f019a02b7077e$var$NEW_PINNING_STORAGE_KEY}): ${error}`;
    }
};
module.exports["getBannerType"] = $087f019a02b7077e$export$b16c0225931fdfcf;
module.exports["isBannerDismissedInLocalStorage"] = $087f019a02b7077e$export$7b46a18b5966c9f8;
module.exports["persistBannerDismissalNewPinning"] = $087f019a02b7077e$export$1f63bcf565c85af4;

});

parcelRegister("iGI5F", function(module, exports) {

var $9nf1H = parcelRequire("9nf1H");


var $eBRrD = parcelRequire("eBRrD");


var $6mKj3 = parcelRequire("6mKj3");


var $17wUi = parcelRequire("17wUi");


var $c0rhi = parcelRequire("c0rhi");


var $6s78L = parcelRequire("6s78L");


var $fEmGS = parcelRequire("fEmGS");


var $1UApO = parcelRequire("1UApO");


var $cbHql = parcelRequire("cbHql");


var $bPFvq = parcelRequire("bPFvq");


var $44LO1 = parcelRequire("44LO1");

const $5fb34be1fffb3f33$var$parseConfluenceEditorSettings = (confluenceEditorSettings)=>{
    if (confluenceEditorSettings) {
        const result = {};
        const entries = Object.entries(confluenceEditorSettings);
        for (const [key, value] of entries){
            if (key === 'toolbarDockingInitialPosition' && value && (0, $eBRrD.TOOLBAR_DOCKING_POSITIONS).includes(value)) result.toolbarDockingPosition = value;
            else if (value !== null && value !== undefined) // Pass through other settings as-is
            result[key] = value;
        }
        return result;
    }
    return {};
};
const $5fb34be1fffb3f33$var$updateLocalStorage = (userPreferences)=>{
    // confluenceLocalStorageInstance is only available in the browser environment
    if (!(0, $44LO1.isSSR)() && (0, $17wUi.confluenceLocalStorageInstance)) (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).EDITOR_CONTROLS_INITIAL_PREFERENCES, JSON.stringify(userPreferences));
};
class $5fb34be1fffb3f33$export$acb1a00758cac9cd {
    setIsLoggedIn(isLoggedin) {
        this.isLoggedin = isLoggedin;
    }
    getInitialUserPreferences() {
        let initialUserPreferences;
        try {
            if (this.readFragmentInterop) {
                const result = this.readFragmentInterop({
                    id: `$ROOT_QUERY.userPreferences`
                });
                if (result) initialUserPreferences = $5fb34be1fffb3f33$var$parseConfluenceEditorSettings(result.confluenceEditorSettings);
            }
        } catch  {
            initialUserPreferences = undefined;
        }
        // If we don't have values from the Apollo cache, we try to fetch from local storage
        if (!initialUserPreferences && !(0, $44LO1.isSSR)()) try {
            const userPreferenceStorage = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).EDITOR_CONTROLS_INITIAL_PREFERENCES);
            if (userPreferenceStorage) initialUserPreferences = JSON.parse(userPreferenceStorage);
        } catch  {
            // If the local storage is corrupted or not available, we ignore the error and return undefined
            initialUserPreferences = undefined;
        }
        return initialUserPreferences;
    }
    async updateUserPreference(key, value) {
        if (!this.isLoggedin) // If the user is not logged in, we return the key with updated value
        // This is to ensure that the editor can still function without flaws
        // but the value will not be persisted to the server
        return Promise.resolve({
            [key]: value
        });
        // we only support updating the toolbarDockingInitialPosition preference ATM,
        // need to update this if we add more preferences
        const variables = {
            toolbarDockingInitialPosition: value
        };
        try {
            const { data: data } = await (0, $6s78L.mutateInterop)({
                mutation: (0, $bPFvq.default),
                variables: variables,
                __callerPackage__: "editor-presets"
            });
            // this is required to indicate toolbar changes to any useQuery for EditorPreferencesQuery, particularly progressive object header
            (0, $fEmGS.writeQueryInterop)({
                query: (0, $cbHql.default),
                data: {
                    userPreferences: {
                        __typename: 'UserPreferences',
                        confluenceEditorSettings: {
                            toolbarDockingInitialPosition: value ?? null
                        }
                    }
                },
                __callerPackage__: "editor-presets"
            });
            const userPreferences = $5fb34be1fffb3f33$var$parseConfluenceEditorSettings(data?.updateUserPreferences?.confluenceEditorSettings);
            $5fb34be1fffb3f33$var$updateLocalStorage(userPreferences);
            return {
                [key]: userPreferences[key]
            };
        } catch  {
            // In case of an error, we return the key with updated value
            // This is to ensure that the editor can still function without flaws
            // but the value might not be persisted to the server
            return {
                [key]: value
            };
        }
    }
    async loadUserPreferences() {
        let userPreferences = {};
        if (!this.isLoggedin) // If the user is not logged in, we return an empty object
        return Promise.resolve(userPreferences);
        try {
            // first time we load we use cache-first policy to avoid unnecessary network requests
            // after the first load we always use no-cache to ensure we have the latest preferences
            // this is particularly important when user has multiple tabs open and changes preferences in one tab
            // we want to ensure other tabs have the latest preferences
            const fetchPolicy = !this.isInitialLoad && (0, $6mKj3.expVal)('cc_editor_preferences_query_optimisation', 'isEnabled', false) ? 'cache-first' : 'no-cache';
            this.isInitialLoad = true;
            const { data: data } = await (0, $c0rhi.queryInterop)({
                query: (0, $cbHql.default),
                fetchPolicy: fetchPolicy,
                __callerPackage__: "editor-presets"
            });
            userPreferences = $5fb34be1fffb3f33$var$parseConfluenceEditorSettings(data?.userPreferences?.confluenceEditorSettings);
            $5fb34be1fffb3f33$var$updateLocalStorage(userPreferences);
            return userPreferences;
        } catch  {
            // if upload local storage fails, we will still return the user preferences
            return userPreferences;
        }
    }
    constructor(isLoggedin = true, readFragmentInterop){
        this.readFragmentInterop = void 0;
        this.isLoggedin = true;
        this.isInitialLoad = false;
        this.setIsLoggedIn(isLoggedin);
        this.readFragmentInterop = readFragmentInterop;
    }
}
const $5fb34be1fffb3f33$export$c53529b5ad54089d = (options)=>{
    const persistenceAPI = options.persistenceAPI || new $5fb34be1fffb3f33$export$acb1a00758cac9cd(undefined, options.readFragmentInterop);
    return new (0, $9nf1H.UserPreferencesProvider)(persistenceAPI, {
        toolbarDockingPosition: options.isLivePage ? 'none' : 'top'
    });
};
module.exports["UserPreferencesPersistenceAPI"] = $5fb34be1fffb3f33$export$acb1a00758cac9cd;
module.exports["getUserPreferencesProvider"] = $5fb34be1fffb3f33$export$c53529b5ad54089d;

});

parcelRegister("9nf1H", function(module, exports) {

var $bNXZY = parcelRequire("bNXZY");


var $19mEO = parcelRequire("19mEO");

class $b6ee7f3696e07456$export$42096c77943a6f6f {
    /**
   * This method returns the initialized state of the user preferences provider
   * @returns true if the user preferences provider is initialized, false otherwise
   * @example userPreferencesProvider.isInitialized
   */ get isInitialized() {
        return this.initialized;
    }
    /**
   * This method fetches the latest user preferences
   * @returns a promise that resolves with the user preferences, or rejects if error occurs
   * @throws Error if there is an error loading user preferences
   * @example userPreferencesProvider.loadPreferences()
   */ async loadPreferences() {
        const userPreferences = await this.persistenceAPI.loadUserPreferences();
        this.setUserPreferences(userPreferences);
    }
    /**
   * This method updates a user preference
   * @param key
   * @param value
   * @returns a promise that resolves when the user preference is updated
   * @throws Error if there is an error updating user preferences
   * @example userPreferencesProvider.updatePreference('toolbarDockingPosition', 'top')
   */ async updatePreference(key, value) {
        const userPreferences = await this.persistenceAPI.updateUserPreference(key, value);
        this.setUserPreferences(userPreferences);
    }
    /**
   * get a user preference, Note that this function is a not async function,
   * meaning that consumers should prefetch the user preference and make it available initially
   * @param key
   * @returns the user preference
   * @example userPreferencesProvider.getPreference('toolbarDockingPosition')
   */ getPreference(key) {
        return this.resolvedUserPreferences[key];
    }
    /**
   * get all user preferences
   * @returns the user preferences
   * @example userPreferencesProvider.getPreferences()
   */ getPreferences() {
        return this.resolvedUserPreferences;
    }
    /**
   * This method fetches the latest user preferences
   * @param onUpdate
   * @returns a function to unsubscribe from the updates
   * @example
   */ onUpdate(onUpdate) {
        this.updateCallbacks.push(onUpdate);
        // Return the cleanup function to unsubscribe from the updates
        return ()=>{
            this.updateCallbacks = this.updateCallbacks.filter((callback)=>callback !== onUpdate);
        };
    }
    /**
   * This method is used to set the default user preferences,
   * setting the default user preferences will also trigger an update
   * This is useful when the default user preferences dynamically based on the context
   * @param preferences
   * @example
   */ setDefaultPreferences(preferences) {
        this.defaultPreferences = preferences;
        const hasUpdated = this.resolveUserPreferences();
        if (hasUpdated) this.notifyUserPreferencesUpdated();
    }
    setUserPreferences(userPreferences) {
        this.userPreferences = userPreferences;
        const hasUpdated = this.resolveUserPreferences();
        if (hasUpdated || !this.initialized) {
            if (!this.initialized) this.initialized = true;
            this.notifyUserPreferencesUpdated();
        }
    }
    /**
   * This method is used to notify the user preferences updated
   * @example userPreferencesProvider.notifyUserPreferencesUpdated()
   */ notifyUserPreferencesUpdated() {
        this.updateCallbacks.forEach((callback)=>{
            callback(this.resolvedUserPreferences);
        });
    }
    /**
   * This method resolves the user preferences by merging the default preferences
   * with the user preferences and filtering out any undefined or null values
   * to avoid overwriting default preferences with null values
   * @returns true if the user preferences were updated, false otherwise
   * @example userPreferencesProvider.resolveUserPreferences()
   */ resolveUserPreferences() {
        // Merge default preferences with user preferences
        // and filter out any undefined or null values
        // to avoid overwriting default preferences with null values
        const newResolvedUserPreferences = (0, $19mEO.mergeUserPreferences)(this.userPreferences, this.defaultPreferences);
        // if the user preferences is NOT initialized, we need to update and notify
        // the user preferences
        // if the user preferences is initialized, we need to check if the new user preferences
        // is different from the old user preferences
        const isSame = (0, $bNXZY.areUserPreferencesEqual)(newResolvedUserPreferences, this.resolvedUserPreferences);
        const needUpdate = !isSame;
        if (needUpdate) this.resolvedUserPreferences = newResolvedUserPreferences;
        return needUpdate;
    }
    /**
   * This is the constructor for the UserPreferencesProvider class.
   * @param persistenceAPI - The persistence API to use for loading and updating user preferences
   * @param defaultPreferences - The default user preferences to use
   * @param initialUserPreferences - The initial user preferences to use (optional)
   * @example const userPreferencesProvider = new UserPreferencesProvider(persistenceAPI, defaultPreferences);
   */ constructor(persistenceAPI, defaultPreferences){
        this.updateCallbacks = [];
        this.userPreferences = {};
        this.defaultPreferences = void 0;
        this.resolvedUserPreferences = void 0;
        this.initialized = false;
        this.persistenceAPI = void 0;
        this.persistenceAPI = persistenceAPI;
        this.defaultPreferences = defaultPreferences;
        this.resolvedUserPreferences = defaultPreferences;
        const initialUserPreferences = this.persistenceAPI.getInitialUserPreferences?.();
        if (initialUserPreferences) this.setUserPreferences(initialUserPreferences);
        // the initial user preferences might come from the local cache,
        // so we need to always load the preferences
        this.loadPreferences();
    }
}
module.exports["UserPreferencesProvider"] = $b6ee7f3696e07456$export$42096c77943a6f6f;

});

parcelRegister("bNXZY", function(module, exports) {
const $57c1a5f1d2d22984$export$6d64c804b8f53798 = (left, right)=>{
    return Object.entries(left).every(([key, value])=>{
        return value === right[key];
    });
};
module.exports["areUserPreferencesEqual"] = $57c1a5f1d2d22984$export$6d64c804b8f53798;

});

parcelRegister("19mEO", function(module, exports) {

var $eBRrD = parcelRequire("eBRrD");

const $b029ab76b1eb310d$export$c583bb83c793248b = (userPreferences, defaultPreferences)=>{
    const newResolvedUserPreferences = {
        ...defaultPreferences,
        ...Object.fromEntries(Object.entries(userPreferences).filter(([key, value])=>{
            if (key === 'toolbarDockingPosition') return (0, $eBRrD.TOOLBAR_DOCKING_POSITIONS).includes(value);
            return value !== undefined && value !== null;
        }))
    };
    return newResolvedUserPreferences;
};
module.exports["mergeUserPreferences"] = $b029ab76b1eb310d$export$c583bb83c793248b;

});

parcelRegister("eBRrD", function(module, exports) {
const $64987b53c225184f$export$e2238e88752bfc4a = [
    'top',
    'none'
];
module.exports["TOOLBAR_DOCKING_POSITIONS"] = $64987b53c225184f$export$e2238e88752bfc4a;

});

parcelRegister("5xrDe", function(module, exports) {

var $llOMF = parcelRequire("llOMF");


var $fxjEF = parcelRequire("fxjEF");


var $7eCZG = parcelRequire("7eCZG");


var $8PVlW = parcelRequire("8PVlW");


var $cX2jD = parcelRequire("cX2jD");


var $9ki8I = parcelRequire("9ki8I");


var $h0KOi = parcelRequire("h0KOi");


var $40ukF = parcelRequire("40ukF");


var $kaUwk = parcelRequire("kaUwk");


var $f2WDp = parcelRequire("f2WDp");


var $7gk7g = parcelRequire("7gk7g");


var $4y9hw = parcelRequire("4y9hw");


var $k7vUa = parcelRequire("k7vUa");


var $k8SUN = parcelRequire("k8SUN");


var $3VDvd = parcelRequire("3VDvd");


var $iVGec = parcelRequire("iVGec");


var $laiso = parcelRequire("laiso");


var $5HQgD = parcelRequire("5HQgD");


var $hFvHs = parcelRequire("hFvHs");


var $5bzSg = parcelRequire("5bzSg");


var $7gEjc = parcelRequire("7gEjc");


var $2ZvWx = parcelRequire("2ZvWx");


var $jeuMk = parcelRequire("jeuMk");


var $4Bdub = parcelRequire("4Bdub");


var $2hEu6 = parcelRequire("2hEu6");


var $drevR = parcelRequire("drevR");


var $gUZEQ = parcelRequire("gUZEQ");


var $hYOOW = parcelRequire("hYOOW");


var $lK9Pz = parcelRequire("lK9Pz");


var $ifkCZ = parcelRequire("ifkCZ");


var $gkbos = parcelRequire("gkbos");


var $1171P = parcelRequire("1171P");


var $3HCXM = parcelRequire("3HCXM");


var $fLS6B = parcelRequire("fLS6B");


var $dYbu7 = parcelRequire("dYbu7");


var $eHllO = parcelRequire("eHllO");


var $4exuQ = parcelRequire("4exuQ");


var $3gmKQ = parcelRequire("3gmKQ");


var $jIG3b = parcelRequire("jIG3b");


var $dGnqc = parcelRequire("dGnqc");


var $1CaNG = parcelRequire("1CaNG");


var $4Kyof = parcelRequire("4Kyof");


var $7iL2d = parcelRequire("7iL2d");


var $a31lS = parcelRequire("a31lS");


var $e6Dq9 = parcelRequire("e6Dq9");


var $lDJPY = parcelRequire("lDJPY");


var $7Upsh = parcelRequire("7Upsh");


var $2QN3e = parcelRequire("2QN3e");


var $d1HsG = parcelRequire("d1HsG");


var $cud1R = parcelRequire("cud1R");


var $HGu9Y = parcelRequire("HGu9Y");


var $eEseG = parcelRequire("eEseG");


var $5VZEy = parcelRequire("5VZEy");


var $dxDD9 = parcelRequire("dxDD9");


var $grjTL = parcelRequire("grjTL");


var $hHtwA = parcelRequire("hHtwA");


var $f3DNZ = parcelRequire("f3DNZ");


var $1ZhW4 = parcelRequire("1ZhW4");


var $cjuKO = parcelRequire("cjuKO");


var $e273U = parcelRequire("e273U");


var $5tMpU = parcelRequire("5tMpU");


var $4gNvG = parcelRequire("4gNvG");


var $4lpx1 = parcelRequire("4lpx1");


var $ftAOO = parcelRequire("ftAOO");


var $fb3SZ = parcelRequire("fb3SZ");


var $bkj40 = parcelRequire("bkj40");


var $51qBv = parcelRequire("51qBv");


var $hBGxo = parcelRequire("hBGxo");


var $fKdaf = parcelRequire("fKdaf");


var $lfQQe = parcelRequire("lfQQe");


var $ctVsO = parcelRequire("ctVsO");


var $l5MIu = parcelRequire("l5MIu");


var $1K7sQ = parcelRequire("1K7sQ");


var $1U7Jq = parcelRequire("1U7Jq");


var $dHFAY = parcelRequire("dHFAY");


var $5C5Mq = parcelRequire("5C5Mq");


var $abOD2 = parcelRequire("abOD2");


var $6WRJZ = parcelRequire("6WRJZ");


var $5JZoZ = parcelRequire("5JZoZ");


var $3Q36X = parcelRequire("3Q36X");


var $irqyl = parcelRequire("irqyl");


var $7pyfy = parcelRequire("7pyfy");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $1Rod9 = parcelRequire("1Rod9");


var $6xiPL = parcelRequire("6xiPL");

function $acd5ba3d0ffc1618$export$19f11869d6f7a120(options) {
    const appearance = options.appearance;
    const featureFlags = (0, $1Rod9.createFeatureFlagsFromProps)(options.featureFlags);
    const getEditorFeatureFlags = ()=>featureFlags;
    const cardOptions = options.linking?.smartLinks;
    return new (0, $a31lS.EditorPresetBuilder)().add([
        (0, $h0KOi.featureFlagsPlugin),
        featureFlags || {}
    ]).maybeAdd((0, $ftAOO.uiControlRegistryPlugin), (0, $6mKj3.UNSAFE_expValNoExposure)('platform_editor_table_menu_updates', 'isEnabled', false) || (0, $6mKj3.UNSAFE_expValNoExposure)('platform_editor_layout_column_menu', 'isEnabled', false)).maybeAdd((0, $4lpx1.userIntentPlugin), (0, $6mKj3.UNSAFE_expValNoExposure)('platform_editor_table_menu_updates', 'isEnabled', false) || (0, $6mKj3.UNSAFE_expValNoExposure)('platform_editor_layout_column_menu', 'isEnabled', false)).add([
        (0, $4gNvG.toolbarPlugin),
        {
            contextualFormattingEnabled: 'always-pinned'
        }
    ]).add([
        (0, $1CaNG.analyticsPlugin),
        {}
    ]).add((0, $lK9Pz.betterTypeHistoryPlugin)).add([
        (0, $hYOOW.pastePlugin),
        {
            cardOptions: cardOptions,
            sanitizePrivateContent: true,
            isFullPage: true
        }
    ]).add((0, $ifkCZ.default)).add((0, $4Kyof.focusPlugin)).add((0, $e6Dq9.compositionPlugin)).add([
        (0, $lDJPY.contextIdentifierPlugin),
        {
            contextIdentifierProvider: options.contextIdentifierProvider
        }
    ]).add([
        (0, $7Upsh.default),
        {
            allowInlineCursorTarget: true,
            allowScrollGutter: {
                // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                getScrollElement: ()=>document.querySelector('.fabric-editor-popup-scroll-parent')
            }
        }
    ]).maybeAdd((0, $eEseG.localIdPlugin), (0, $9wGTI.fg)('platform_editor_adf_with_localid')).maybeAdd([
        (0, $5C5Mq.userPreferencesPlugin),
        {
            initialUserPreferences: {
                toolbarDockingPosition: 'top'
            },
            userPreferencesProvider: undefined
        }
    ], (0, $9wGTI.fg)('platform_editor_use_preferences_plugin')).add((0, $2QN3e.decorationsPlugin)).add([
        (0, $d1HsG.typeAheadPlugin),
        {
            isMobile: false
        }
    ]).add([
        (0, $hBGxo.primaryToolbarPlugin),
        {
            contextualFormattingEnabled: true
        }
    ]).add([
        (0, $fKdaf.blockTypePlugin),
        {
            includeBlockQuoteAsTextstyleOption: true,
            lastNodeMustBeParagraph: false,
            isUndoRedoButtonsEnabled: undefined,
            allowBlockType: undefined
        }
    ]).add((0, $5VZEy.clearMarksOnEmptyDocPlugin)).add([
        (0, $dxDD9.selectionToolbarPlugin),
        {
            preferenceToolbarAboveSelection: true,
            contextualFormattingEnabled: true
        }
    ]).add([
        (0, $3HCXM.hyperlinkPlugin),
        {
            editorAppearance: appearance,
            linkPicker: options.linking?.linkPicker,
            lpLinkPicker: featureFlags.lpLinkPicker ?? false,
            onClickCallback: cardOptions?.onClickCallback,
            platform: 'web'
        }
    ]).add([
        (0, $grjTL.textFormattingPlugin),
        {
            responsiveToolbarMenu: undefined
        }
    ]).add((0, $lfQQe.widthPlugin)).add([
        (0, $hHtwA.quickInsertPlugin),
        {
            enableElementBrowser: true,
            disableDefaultItems: false,
            headless: false
        }
    ]).add([
        (0, $f3DNZ.placeholderPlugin),
        {
            placeholder: options.placeholder
        }
    ]).add((0, $cjuKO.unsupportedContentPlugin)).add((0, $e273U.editorDisabledPlugin)).add((0, $1ZhW4.copyButtonPlugin)).add((0, $5tMpU.floatingToolbarPlugin)).add([
        (0, $fb3SZ.selectionPlugin),
        {
            useLongPressSelection: false
        }
    ]).add([
        (0, $bkj40.default),
        {
            allowCopyToClipboard: true,
            useLongPressSelection: false,
            allowCompositionInputOverride: false,
            formatCodeProvider: (0, $6xiPL.getCodeBlockFormatProvider)()
        }
    ]).add((0, $ctVsO.ufoPlugin)).add((0, $7gk7g.dataConsumerPlugin)).add((0, $7eCZG.accessibilityUtilsPlugin)).add((0, $8PVlW.contentInsertionPlugin)).add((0, $cX2jD.batchAttributeUpdatesPlugin)).add([
        (0, $fLS6B.breakoutPlugin),
        {
            allowBreakoutButton: appearance === 'full-page'
        }
    ]).add((0, $dYbu7.alignmentPlugin)).add([
        (0, $gkbos.textColorPlugin),
        true
    ]).add((0, $hFvHs.listPlugin)).add((0, $2hEu6.rulePlugin)).add([
        (0, $k8SUN.expandPlugin),
        {
            ...typeof options.expandOptions === 'object' ? options.expandOptions : {},
            useLongPressSelection: false,
            appearance: appearance,
            allowInteractiveExpand: true
        }
    ]).add((0, $eHllO.guidelinePlugin)).add([
        (0, $iVGec.gridPlugin),
        {
            shouldCalcBreakoutGridLines: true
        }
    ]).add([
        (0, $5bzSg.mediaPlugin),
        {
            ...options.media,
            allowLazyLoading: true,
            allowBreakoutSnapPoints: true,
            allowAdvancedToolBarOptions: typeof options.media?.allowAdvancedToolBarOptions !== 'undefined' ? options.media?.allowAdvancedToolBarOptions : true,
            allowCommentsOnMedia: false,
            allowDropzoneDropLine: true,
            allowMediaSingleEditable: true,
            allowRemoteDimensionsFetch: true,
            allowMarkingUploadsAsIncomplete: false,
            allowImagePreview: true,
            fullWidthEnabled: appearance === 'full-width',
            editorAppearance: appearance,
            uploadErrorHandler: undefined,
            waitForMediaUpload: true,
            isCopyPasteEnabled: true,
            alignLeftOnInsert: typeof options.media?.alignLeftOnInsert !== 'undefined' ? options.media?.alignLeftOnInsert : false,
            getEditorFeatureFlags: getEditorFeatureFlags
        }
    ]).add((0, $7gEjc.mediaInsertPlugin)).add((0, $cud1R.default)).add([
        (0, $2ZvWx.mentionsPlugin),
        {
            mentionProvider: options.mentionProvider,
            sanitizePrivateContent: true,
            allowZeroWidthSpaceAfter: true,
            profilecardProvider: undefined
        }
    ]).add([
        (0, $k7vUa.emojiPlugin),
        {
            emojiProvider: options.emojiProvider
        }
    ]).add([
        (0, $gUZEQ.default),
        {
            tableOptions: !options.tableOptions || typeof options.tableOptions === 'boolean' ? {} : options.tableOptions,
            isTableScalingEnabled: true,
            allowContextualMenu: true,
            fullWidthEnabled: appearance === 'full-width',
            wasFullWidthEnabled: undefined,
            getEditorFeatureFlags: getEditorFeatureFlags,
            isCommentEditor: false,
            isChromelessEditor: false
        }
    ]).add((0, $7iL2d.fragmentPlugin)).add([
        (0, $jIG3b.tasksAndDecisionsPlugin),
        {
            allowNestedTasks: true,
            consumeTabs: true,
            useLongPressSelection: false,
            taskDecisionProvider: options.taskDecisionProvider
        }
    ]).add([
        (0, $jeuMk.default),
        {
            useLongPressSelection: false,
            allowCustomPanel: true,
            allowCustomPanelEdit: true
        }
    ]).add([
        (0, $laiso.helpDialogPlugin),
        false
    ]).add((0, $l5MIu.contextPanelPlugin)).add([
        (0, $3gmKQ.extensionPlugin),
        {
            breakoutEnabled: appearance === 'full-page',
            useLongPressSelection: false,
            appearance: appearance
        }
    ]).add([
        (0, $4y9hw.default),
        {
            weekStartDay: undefined
        }
    ]).add([
        (0, $1K7sQ.default),
        {}
    ]).add([
        (0, $4exuQ.layoutPlugin),
        {
            ...typeof options.layoutOptions === 'object' ? options.layoutOptions : {},
            useLongPressSelection: false,
            UNSAFE_allowSingleColumnLayout: undefined,
            editorAppearance: appearance
        }
    ]).add([
        (0, $40ukF.cardPlugin),
        {
            ...options.linking?.smartLinks,
            fullWidthMode: appearance === 'full-width',
            linkPicker: options.linking?.linkPicker,
            lpLinkPicker: featureFlags.lpLinkPicker ?? false,
            editorAppearance: appearance
        }
    ]).add([
        (0, $f2WDp.customAutoformatPlugin),
        {
            autoformattingProvider: options.autoformattingProvider
        }
    ]).add([
        (0, $drevR.statusPlugin),
        {
            menuDisabled: false,
            allowZeroWidthSpaceAfter: true
        }
    ]).add((0, $HGu9Y.indentationPlugin)).add((0, $3VDvd.scrollIntoViewPlugin)).add([
        (0, $1171P.toolbarListsIndentationPlugin),
        {
            showIndentationButtons: true,
            allowHeadingAndParagraphIndentation: true
        }
    ]).add([
        (0, $5HQgD.insertBlockPlugin),
        {
            allowTables: true,
            allowExpand: true,
            horizontalRuleEnabled: true,
            tableSelectorSupported: featureFlags?.tableSelector,
            nativeStatusSupported: true,
            showElementBrowserLink: true,
            appearance: appearance
        }
    ]).add([
        (0, $dGnqc.findReplacePlugin),
        {
            takeFullWidth: false,
            twoLineEditorToolbar: !!featureFlags.twoLineEditorToolbar
        }
    ]).add((0, $9ki8I.borderPlugin)).add((0, $4Bdub.pasteOptionsToolbarPlugin)).add([
        (0, $kaUwk.codeBidiWarningPlugin),
        {
            appearance: appearance
        }
    ]).add([
        (0, $irqyl.aiPlugin),
        options.editorPluginAIOptions
    ]).add((0, $7pyfy.aiStreamingOrchestratorPlugin)).add((0, $1U7Jq.highlightPlugin)).add((0, $51qBv.codeBlockAdvancedPlugin)).add((0, $dHFAY.blockControlsPlugin)).add((0, $6WRJZ.default)).add((0, $abOD2.undoRedoPlugin)).add((0, $5JZoZ.showDiffPlugin)).add([
        (0, $3Q36X.trackChangesPlugin),
        {
            showOnToolbar: true,
            ButtonWrapper: options.trackChangesPluginOptions?.ButtonWrapper
        }
    ]).add([
        (0, $fxjEF.syncedBlockPlugin),
        {
            enableSourceCreation: false,
            syncedBlockRenderer: (0, $llOMF.getSyncedBlockRenderer)({
                syncBlockRendererOptions: {
                    eventHandlers: options.syncedBlockEventHandlers,
                    stickyHeaders: {
                        show: true,
                        offsetTop: 0
                    }
                }
            }),
            syncBlockDataProvider: options.syncedBlockProvider
        }
    ]);
}
module.exports["createSnippetEditorPreset"] = $acd5ba3d0ffc1618$export$19f11869d6f7a120;

});

parcelRegister("llOMF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $51dOO = parcelRequire("51dOO");

const $b3a8a9aa2ea1cab4$export$8add922a5c506966 = ({ syncBlockRendererOptions: syncBlockRendererOptions, getAccountId: getAccountId })=>({ syncBlockFetchResult: syncBlockFetchResult, api: api })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $51dOO.SyncedBlockRenderer), {
            syncBlockRendererOptions: syncBlockRendererOptions,
            syncBlockFetchResult: syncBlockFetchResult,
            api: api,
            getAccountId: getAccountId
        });
    };
module.exports["getSyncedBlockRenderer"] = $b3a8a9aa2ea1cab4$export$8add922a5c506966;

});

parcelRegister("51dOO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4iudd = parcelRequire("4iudd");


var $3k5Tv = parcelRequire("3k5Tv");


var $amQv1 = parcelRequire("amQv1");


var $3txmH = parcelRequire("3txmH");

const $2fd9f12fe41d1c40$var$SyncedBlockRendererComponent = ({ syncBlockRendererOptions: syncBlockRendererOptions, syncBlockFetchResult: syncBlockFetchResult, api: api, getAccountId: getAccountId })=>{
    (0, $cozmU.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            (0, $amQv1.handleSSRErrorsAnalytics)(api?.analytics?.actions.fireAnalyticsEvent);
        }, 0);
        return ()=>{
            clearTimeout(timeoutId);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { isLoading: isLoading, providerFactory: providerFactory, reloadData: reloadData, ssrProviders: ssrProviders, syncBlockInstance: syncBlockInstance } = syncBlockFetchResult;
    const isSSRMode = (0, $4iudd.isSSR)();
    const rendererOptions = (0, $cozmU.useMemo)(()=>{
        if (!isSSRMode || syncBlockRendererOptions?.media?.ssr || // already has ssr config
        !ssrProviders?.media?.viewMediaClientConfig) return syncBlockRendererOptions;
        const mediaSSR = {
            mode: 'server',
            config: ssrProviders?.media.viewMediaClientConfig
        };
        return {
            ...syncBlockRendererOptions,
            media: {
                ...syncBlockRendererOptions?.media || {},
                ssr: mediaSSR
            }
        };
    }, [
        syncBlockRendererOptions,
        ssrProviders,
        isSSRMode
    ]);
    const { isCollabOffline: isCollabOffline, contentMode: contentMode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'connectivity',
        'contentFormat'
    ], ({ connectivityState: connectivityState, contentFormatState: contentFormatState })=>({
            isCollabOffline: connectivityState?.mode === 'collab-offline',
            contentMode: contentFormatState?.contentMode
        }));
    const result = (0, $3txmH.renderSyncedBlockContent)({
        syncBlockInstance: syncBlockInstance,
        isLoading: isLoading,
        rendererOptions: contentMode ? {
            ...rendererOptions,
            contentMode: contentMode
        } : rendererOptions,
        providerFactory: providerFactory,
        reloadData: reloadData,
        fireAnalyticsEvent: api?.analytics?.actions.fireAnalyticsEvent,
        resourceId: syncBlockInstance?.resourceId,
        isOffline: isCollabOffline,
        getAccountId: getAccountId
    });
    return result.element;
};
const $2fd9f12fe41d1c40$export$a53459da4a5011e9 = /*#__PURE__*/ (0, $cozmU.memo)($2fd9f12fe41d1c40$var$SyncedBlockRendererComponent);
module.exports["SyncedBlockRenderer"] = $2fd9f12fe41d1c40$export$a53459da4a5011e9;

});

parcelRegister("k7vUa", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $ldqjS = parcelRequire("ldqjS");


var $83k8i = parcelRequire("83k8i");

var $gx3UZ = parcelRequire("gx3UZ");


var $jGK9e = parcelRequire("jGK9e");


var $kpCD8 = parcelRequire("kpCD8");


var $efqK4 = parcelRequire("efqK4");


var $gZpSA = parcelRequire("gZpSA");


var $kCECX = parcelRequire("kCECX");


var $dtUVl = parcelRequire("dtUVl");

var $af2XZ = parcelRequire("af2XZ");

var $6ALId = parcelRequire("6ALId");

var $9tfSW = parcelRequire("9tfSW");


var $eDtFr = parcelRequire("eDtFr");


var $fqVYq = parcelRequire("fqVYq");


var $2PMvb = parcelRequire("2PMvb");


var $f5VOy = parcelRequire("f5VOy");


var $g5ewD = parcelRequire("g5ewD");


var $38lAe = parcelRequire("38lAe");


var $6wqCa = parcelRequire("6wqCa");


var $8civN = parcelRequire("8civN");

const $080d08f451e47419$export$144d1b98bacb98cc = (emoji, emojiProvider)=>({
        title: emoji.shortName || '',
        key: emoji.id || emoji.shortName,
        render ({ isSelected: isSelected, onClick: onClick, onHover: onHover }) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dtUVl.default), {
                emoji: emoji,
                selected: isSelected,
                onMouseMove: onHover,
                onSelection: onClick,
                emojiProvider: emojiProvider
            });
        },
        emoji: emoji
    });
function $080d08f451e47419$export$fc10aeed3a532e2a(fn) {
    // Cache results here
    const seen = new Map();
    function memoized(emoji, emojiProvider) {
        // Check cache for hits
        const hit = seen.get(emoji.id || emoji.shortName);
        if (hit) return hit;
        // Generate new result and cache it
        const result = fn(emoji, emojiProvider);
        seen.set(emoji.id || emoji.shortName, result);
        return result;
    }
    return {
        call: memoized,
        clear: seen.clear.bind(seen)
    };
}
const $080d08f451e47419$var$memoizedToItem = $080d08f451e47419$export$fc10aeed3a532e2a($080d08f451e47419$export$144d1b98bacb98cc);
const $080d08f451e47419$var$defaultListLimit = 50;
const $080d08f451e47419$var$isFullShortName = (query)=>query && query.length > 1 && query.charAt(0) === ':' && query.charAt(query.length - 1) === ':';
const $080d08f451e47419$var$TRIGGER = ':';
function $080d08f451e47419$var$delayUntilIdle(cb) {
    if (typeof window === 'undefined') return;
    // eslint-disable-next-line compat/compat
    if (window.requestIdleCallback !== undefined) // eslint-disable-next-line compat/compat
    return window.requestIdleCallback(()=>cb(), {
        timeout: 500
    });
    return window.requestAnimationFrame(()=>cb());
}
const $080d08f451e47419$export$d1221bd3f80501e0 = ({ config: options, api: api })=>{
    let previousEmojiProvider;
    const typeAhead = {
        id: (0, $efqK4.TypeAheadAvailableNodes).EMOJI,
        trigger: $080d08f451e47419$var$TRIGGER,
        // Custom regex must have a capture group around trigger
        // so it's possible to use it without needing to scan through all triggers again
        customRegex: '\\(?(:)',
        headless: options ? options.headless : undefined,
        getItems ({ query: query, editorState: editorState }) {
            const pluginState = $080d08f451e47419$var$getEmojiPluginState(editorState);
            const emojiProvider = pluginState.emojiProvider;
            if (!emojiProvider) return Promise.resolve([]);
            return new Promise((resolve)=>{
                const emojiProviderChangeHandler = {
                    result (emojiResult) {
                        if (!emojiResult || !emojiResult.emojis) resolve([]);
                        else {
                            const emojiItems = emojiResult.emojis.map((emoji)=>$080d08f451e47419$var$memoizedToItem.call(emoji, emojiProvider));
                            resolve(emojiItems);
                        }
                        emojiProvider.unsubscribe(emojiProviderChangeHandler);
                    }
                };
                emojiProvider.subscribe(emojiProviderChangeHandler);
                emojiProvider.filter($080d08f451e47419$var$TRIGGER.concat(query), {
                    limit: $080d08f451e47419$var$defaultListLimit,
                    skinTone: emojiProvider.getSelectedTone(),
                    sort: !query.length ? (0, $9tfSW.SearchSort).UsageFrequency : (0, $9tfSW.SearchSort).Default
                });
            });
        },
        forceSelect ({ query: query, items: items, editorState: editorState }) {
            const { asciiMap: asciiMap } = $080d08f451e47419$export$e3ef5170578bd8ba.getState(editorState) || {};
            const normalizedQuery = $080d08f451e47419$var$TRIGGER.concat(query);
            // if the query has space at the end
            // check the ascii map for emojis
            if (!options?.disableAutoformat && asciiMap && normalizedQuery.length >= 3 && normalizedQuery.endsWith(' ') && asciiMap.has(normalizedQuery.trim())) {
                const emoji = asciiMap.get(normalizedQuery.trim());
                return {
                    title: emoji?.name || '',
                    emoji: emoji
                };
            }
            const matchedItem = $080d08f451e47419$var$isFullShortName(normalizedQuery) ? items.find((item)=>item.title.toLowerCase() === normalizedQuery) : undefined;
            return matchedItem;
        },
        selectItem (state, item, insert, { mode: mode }) {
            const emojiPluginState = $080d08f451e47419$export$e3ef5170578bd8ba.getState(state);
            if (emojiPluginState.emojiProvider && emojiPluginState.emojiProvider.recordSelection && item.emoji) emojiPluginState.emojiProvider.recordSelection(item.emoji).then((0, $6ALId.recordSelectionSucceededSli)(item.emoji, {
                createAnalyticsEvent: api?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined
            })).catch((0, $6ALId.recordSelectionFailedSli)(item.emoji, {
                createAnalyticsEvent: api?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined
            }));
            const fragment = (0, $2PMvb.createEmojiFragment)(state.doc, state.selection.$head, item.emoji);
            const tr = insert(fragment);
            api?.analytics?.actions.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).INSERTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EMOJI,
                attributes: {
                    inputMethod: (0, $krYZG.INPUT_METHOD).TYPEAHEAD
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            })(tr);
            return tr;
        }
    };
    api?.base?.actions.registerMarks(({ tr: tr, node: node, pos: pos })=>{
        const { doc: doc } = tr;
        const { schema: schema } = doc.type;
        const { emoji: emojiNodeType } = schema.nodes;
        if (node.type === emojiNodeType) {
            const newText = node.attrs.text;
            const currentPos = tr.mapping.map(pos);
            tr.replaceWith(currentPos, currentPos + node.nodeSize, schema.text(newText, node.marks));
        }
    });
    return {
        name: 'emoji',
        nodes () {
            return [
                {
                    name: 'emoji',
                    node: (0, $f5VOy.emojiNodeSpec)()
                }
            ];
        },
        usePluginHook () {
            (0, $cozmU.useEffect)(()=>{
                $080d08f451e47419$var$delayUntilIdle(()=>{
                    (0, $af2XZ.preloadEmojiPicker)();
                });
            }, []);
        },
        pmPlugins () {
            return [
                {
                    name: 'emoji',
                    plugin: (pmPluginFactoryParams)=>{
                        return $080d08f451e47419$var$createEmojiPlugin(pmPluginFactoryParams, options, api);
                    }
                },
                {
                    name: 'emojiAsciiInputRule',
                    plugin: ({ schema: schema })=>(0, $6wqCa.inputRulePlugin)(schema, api?.analytics?.actions, api, options?.disableAutoformat)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const { emojiResourceConfig: emojiResourceConfig, asciiMap: asciiMap, emojiProvider: emojiProvider, inlineEmojiPopupOpen: inlineEmojiPopupOpen, emojiProviderPromise: emojiProviderPromise } = $080d08f451e47419$export$e3ef5170578bd8ba.getState(editorState) ?? {};
            return {
                emojiResourceConfig: emojiResourceConfig,
                asciiMap: asciiMap,
                typeAheadHandler: typeAhead,
                emojiProvider: emojiProvider,
                emojiProviderPromise: emojiProviderPromise,
                inlineEmojiPopupOpen: inlineEmojiPopupOpen
            };
        },
        actions: {
            openTypeAhead: (0, $38lAe.openTypeAhead)(typeAhead, api),
            setProvider: async (providerPromise)=>{
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons
                if (previousEmojiProvider === provider || options?.emojiProvider === providerPromise) return false;
                previousEmojiProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>$080d08f451e47419$var$setProviderTr(provider)(tr)) ?? false;
            }
        },
        commands: {
            insertEmoji: (0, $2PMvb.insertEmoji)(api?.analytics?.actions)
        },
        contentComponent ({ editorView: editorView, popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement }) {
            if (!api || (0, $fqVYq.editorExperiment)('platform_editor_controls', 'control') || !editorView) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8civN.InlineEmojiPopup), {
                api: api,
                editorView: editorView,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsMountPoint: popupsMountPoint,
                popupsScrollableElement: popupsScrollableElement
            });
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'emoji',
                        title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).emoji),
                        description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).emojiDescription),
                        priority: 500,
                        keyshortcut: ':',
                        isDisabledOffline: false,
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jGK9e.IconEmoji), null),
                        action (insert) {
                            if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1', {
                                exposure: true
                            })) {
                                // Clear slash
                                let tr = insert('');
                                tr = (0, $38lAe.setInlineEmojiPopupOpen)(true)(tr);
                                return tr;
                            }
                            const tr = insert(undefined);
                            api?.typeAhead?.actions.openAtTransaction({
                                triggerHandler: typeAhead,
                                inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT
                            })(tr);
                            return tr;
                        }
                    }
                ],
            typeAhead: typeAhead,
            floatingToolbar: (state, intl)=>{
                const isViewMode = ()=>api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
                if (!isViewMode()) return undefined;
                const onClick = (stateFromClickEvent, dispatch)=>{
                    if (!api?.annotation) return true;
                    if (api?.analytics?.actions) api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $krYZG.ACTION).CLICKED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).BUTTON,
                        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                        eventType: (0, $krYZG.EVENT_TYPE).UI,
                        attributes: {
                            source: 'highlightActionsMenu',
                            pageMode: 'edit',
                            sourceNode: 'emoji'
                        }
                    });
                    const command = api.annotation?.actions?.setInlineCommentDraftState(true, (0, $krYZG.INPUT_METHOD).TOOLBAR);
                    return command(stateFromClickEvent, dispatch);
                };
                return {
                    title: 'Emoji floating toolbar',
                    nodeType: [
                        state.schema.nodes.emoji
                    ],
                    onPositionCalculated: (0, $gZpSA.calculateToolbarPositionAboveSelection)('Emoji floating toolbar'),
                    items: (node)=>{
                        const annotationState = api?.annotation?.sharedState.currentState();
                        const activeCommentMark = node.marks.find((mark)=>mark.type.name === 'annotation' && annotationState?.annotations[mark.attrs.id] === false);
                        const showAnnotation = annotationState && annotationState.isVisible && !annotationState.bookmark && !annotationState.mouseData.isSelecting && !activeCommentMark && isViewMode();
                        if (showAnnotation) return [
                            {
                                type: 'button',
                                showTitle: true,
                                testId: 'add-comment-emoji-button',
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))),
                                title: intl.formatMessage((0, $83k8i.annotationMessages).createComment),
                                onClick: onClick,
                                tooltipContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldqjS.ToolTipContent), {
                                    description: intl.formatMessage((0, $83k8i.annotationMessages).createComment)
                                }),
                                supportsViewMode: true
                            }
                        ];
                        return [];
                    }
                };
            }
        }
    };
};
/**
 * Actions
 */ const $080d08f451e47419$var$setAsciiMap = (asciiMap)=>(state, dispatch)=>{
        if (dispatch) {
            const tr = (0, $38lAe.setAsciiMap)(asciiMap)(state.tr);
            dispatch(tr);
        }
        return true;
    };
function $080d08f451e47419$export$ae9fa76f15c1e295(fn, limitTime, limitCount, onLimitReached) {
    let lastCallTime = 0;
    let callCount = 0;
    return function wrappedFn(...args) {
        const now = Date.now();
        if (now - lastCallTime < limitTime) {
            if (++callCount > limitCount) onLimitReached?.();
        } else {
            lastCallTime = now;
            callCount = 1;
        }
        return fn(...args);
    };
}
// At this stage console.error only
const $080d08f451e47419$var$logRateWarning = ()=>{};
const $080d08f451e47419$var$setProviderTr = $080d08f451e47419$export$ae9fa76f15c1e295((provider)=>(tr)=>(0, $38lAe.setProvider)(provider)(tr), // If we change the emoji provider more than three times every 5 seconds we should warn.
// This seems like a really long time but the performance can be that laggy that we don't
// even get 3 events in 3 seconds and miss this indicator.
5000, 3, $080d08f451e47419$var$logRateWarning);
const $080d08f451e47419$var$setProvider = (provider)=>(state, dispatch)=>{
        if (dispatch) {
            const tr = $080d08f451e47419$var$setProviderTr(provider)(state.tr);
            dispatch(tr);
        }
        return true;
    };
const $080d08f451e47419$export$e3ef5170578bd8ba = new (0, $kCECX.PluginKey)('emojiPlugin');
function $080d08f451e47419$var$getEmojiPluginState(state) {
    return $080d08f451e47419$export$e3ef5170578bd8ba.getState(state) || {};
}
function $080d08f451e47419$var$createEmojiPlugin(pmPluginFactoryParams, options, api) {
    return new (0, $kpCD8.SafePlugin)({
        key: $080d08f451e47419$export$e3ef5170578bd8ba,
        state: {
            init () {
                if (options?.emojiProvider && (0, $fqVYq.editorExperiment)('platform_editor_prevent_toolbar_layout_shifts', true)) return {
                    emojiProviderPromise: options.emojiProvider
                };
                return {};
            },
            apply (tr, pluginState) {
                const { action: action, params: params } = tr.getMeta($080d08f451e47419$export$e3ef5170578bd8ba) || {
                    action: null,
                    params: null
                };
                let newPluginState = pluginState;
                switch(action){
                    case (0, $38lAe.ACTIONS).SET_PROVIDER:
                        newPluginState = {
                            ...pluginState,
                            emojiProvider: params.provider,
                            emojiProviderPromise: (0, $fqVYq.editorExperiment)('platform_editor_prevent_toolbar_layout_shifts', true) ? Promise.resolve(params.provider) : undefined
                        };
                        pmPluginFactoryParams.dispatch($080d08f451e47419$export$e3ef5170578bd8ba, newPluginState);
                        return newPluginState;
                    case (0, $38lAe.ACTIONS).SET_ASCII_MAP:
                        newPluginState = {
                            ...pluginState,
                            asciiMap: params.asciiMap
                        };
                        pmPluginFactoryParams.dispatch($080d08f451e47419$export$e3ef5170578bd8ba, newPluginState);
                        return newPluginState;
                    case (0, $38lAe.ACTIONS).SET_INLINE_POPUP:
                        newPluginState = {
                            ...pluginState,
                            inlineEmojiPopupOpen: params.open
                        };
                        pmPluginFactoryParams.dispatch($080d08f451e47419$export$e3ef5170578bd8ba, newPluginState);
                        return newPluginState;
                }
                return newPluginState;
            }
        },
        props: {
            nodeViews: {
                emoji: (node)=>{
                    return new (0, $g5ewD.EmojiNodeView)(node, {
                        intl: pmPluginFactoryParams.getIntl(),
                        api: api,
                        emojiNodeDataProvider: options?.emojiNodeDataProvider
                    });
                }
            }
        },
        view (editorView) {
            const providerHandler = (name, providerPromise)=>{
                switch(name){
                    case 'emojiProvider':
                        if (!providerPromise) return $080d08f451e47419$var$setProvider?.(undefined)?.(editorView.state, editorView.dispatch);
                        providerPromise.then((provider)=>{
                            $080d08f451e47419$var$setProvider?.(provider)?.(editorView.state, editorView.dispatch);
                            provider.getAsciiMap().then((asciiMap)=>{
                                $080d08f451e47419$var$setAsciiMap(asciiMap)(editorView.state, editorView.dispatch);
                            });
                        }).catch(()=>$080d08f451e47419$var$setProvider?.(undefined)?.(editorView.state, editorView.dispatch));
                        break;
                }
                return;
            };
            if (options?.emojiProvider) providerHandler('emojiProvider', options.emojiProvider);
            return {
                destroy () {
                    if (pmPluginFactoryParams.providerFactory) pmPluginFactoryParams.providerFactory.unsubscribe('emojiProvider', providerHandler);
                }
            };
        }
    });
}
module.exports["emojiPlugin"] = $080d08f451e47419$export$d1221bd3f80501e0;
module.exports["emojiPluginKey"] = $080d08f451e47419$export$e3ef5170578bd8ba;

});

parcelRegister("2PMvb", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $fRYCB = parcelRequire("fRYCB");


var $aPdNQ = parcelRequire("aPdNQ");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");

const $e819716a0e878e7b$export$c62c7770bca4be17 = (doc, pos, emoji)=>{
    const { id: id = '', fallback: fallback, shortName: shortName } = emoji;
    const annotationMarksForPos = (0, $fRYCB.getAnnotationMarksForPos)(pos);
    const emojiNode = doc.type.schema.nodes.emoji.createChecked({
        shortName: shortName,
        id: id,
        text: fallback || shortName
    }, null, annotationMarksForPos);
    const space = doc.type.schema.text(' ', annotationMarksForPos);
    return (0, $aPdNQ.Fragment).fromArray([
        emojiNode,
        space
    ]);
};
const $e819716a0e878e7b$export$8d5c072327044b6f = (editorAnalyticsAPI)=>(emojiId, inputMethod)=>{
        return ({ tr: tr })=>{
            const { doc: doc, selection: selection } = tr;
            const { emoji: emoji } = tr.doc.type.schema.nodes;
            if (emoji && emojiId) {
                const fragment = $e819716a0e878e7b$export$c62c7770bca4be17(doc, selection.$head, emojiId);
                const newTr = (0, $bjg0G.safeInsert)(fragment)(tr);
                if (inputMethod) editorAnalyticsAPI?.attachAnalyticsEvent({
                    action: (0, $krYZG.ACTION).INSERTED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EMOJI,
                    attributes: {
                        inputMethod: inputMethod
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                })(newTr);
                newTr.setSelection((0, $kCECX.Selection).near(newTr.doc.resolve(selection.$from.pos + fragment.size)));
                return newTr;
            }
            return null;
        };
    };
module.exports["createEmojiFragment"] = $e819716a0e878e7b$export$c62c7770bca4be17;
module.exports["insertEmoji"] = $e819716a0e878e7b$export$8d5c072327044b6f;

});

parcelRegister("f5VOy", function(module, exports) {

var $kOOm4 = parcelRequire("kOOm4");


var $8Dx7s = parcelRequire("8Dx7s");


var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");

const $536e450147041236$var$isSSR = Boolean(undefined);
const $536e450147041236$export$d122e24cc43292f6 = ()=>{
    const emojiNode = (0, $ixfCV.fg)('platform_editor_adf_with_localid') ? (0, $kOOm4.emojiWithLocalId) : (0, $kOOm4.emoji);
    if ($536e450147041236$var$isSSR) return emojiNode;
    return {
        ...emojiNode,
        toDOM: (node)=>$536e450147041236$export$9edeb07c311f4561(node)
    };
};
function $536e450147041236$export$9edeb07c311f4561(node) {
    // From packages/elements/emoji/src/components/common/EmojiPlaceholder.tsx
    const { shortName: shortName, id: id, text: text } = node.attrs;
    const isEmojiScalingEnabled = (0, $ieeJu.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true);
    const attrs = {
        'data-emoji-short-name': shortName,
        'data-emoji-id': id,
        'data-emoji-text': text,
        contenteditable: 'false',
        style: (0, $8Dx7s.convertToInlineCss)({
            content: "''",
            fill: "var(--ds-background-neutral, #0515240F)",
            ...isEmojiScalingEnabled ? {
                minWidth: '16.25px',
                minHeight: '16.25px'
            } : {
                minWidth: `20px`,
                width: `20px`,
                height: `20px`
            },
            position: 'relative',
            margin: '-1px 0',
            display: 'inline-block',
            background: "var(--ds-background-neutral, #0515240F)",
            borderRadius: "var(--ds-radius-small, 3px)",
            overflow: 'hidden',
            verticalAlign: 'middle',
            whiteSpace: 'nowrap',
            textAlign: 'center'
        }),
        'aria-busy': 'true',
        'aria-label': shortName,
        class: 'emoji-common-placeholder'
    };
    if ((0, $ixfCV.fg)('platform_editor_adf_with_localid')) attrs['data-local-id'] = node.attrs.localId;
    return [
        'span',
        attrs
    ];
}
module.exports["emojiNodeSpec"] = $536e450147041236$export$d122e24cc43292f6;
module.exports["emojiToDom"] = $536e450147041236$export$9edeb07c311f4561;

});

parcelRegister("g5ewD", function(module, exports) {

var $3u5lg = parcelRequire("3u5lg");


var $haNN4 = parcelRequire("haNN4");


var $4iudd = parcelRequire("4iudd");


var $l4yrE = parcelRequire("l4yrE");

var $k8ZZN = parcelRequire("k8ZZN");

var $2O2Zk = parcelRequire("2O2Zk");


var $jv11C = parcelRequire("jv11C");


var $6Ixg8 = parcelRequire("6Ixg8");


var $aPdNQ = parcelRequire("aPdNQ");


var $4xiow = parcelRequire("4xiow");


var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $fqVYq = parcelRequire("fqVYq");


var $f5VOy = parcelRequire("f5VOy");

const $144c0f90b58057f8$var$SINGLE_EMOJI_REGEX = // Regular expression to match a single emoji character
// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
RegExp("^(\\p{Emoji_Presentation}(?:[\\u{1F3FB}-\\u{1F3FF}])?|\\p{Extended_Pictographic}\\u{FE0F}(?:[\\u{1F3FB}-\\u{1F3FF}])?(?:\\u{200D}\\p{Extended_Pictographic}\\u{FE0F}?(?:[\\u{1F3FB}-\\u{1F3FF}])?)*|\\p{Extended_Pictographic}\\u{FE0F}?(?:[\\u{1F3FB}-\\u{1F3FF}])?(?:\\u{200D}\\p{Extended_Pictographic}\\u{FE0F}?(?:[\\u{1F3FB}-\\u{1F3FF}])?)+|\\p{Regional_Indicator}\\p{Regional_Indicator})$", "u");
function $144c0f90b58057f8$export$1d677781db73ff20(fallbackText) {
    return $144c0f90b58057f8$var$SINGLE_EMOJI_REGEX.test(fallbackText);
}
class $144c0f90b58057f8$export$cadc6675ce598ba8 {
    static logError(error) {
        (0, $jv11C.logException)(error, {
            location: 'editor-plugin-emoji/EmojiNodeView'
        });
    }
    /** Type guard to check if a Node is an HTMLElement in a safe way. */ isHTMLElement(element) {
        if (element === null) return false;
        // In SSR `HTMLElement` is not defined, so we need to use duck typing here
        return 'innerHTML' in element && 'style' in element && 'classList' in element;
    }
    async updateDom(emojiProvider) {
        try {
            const { shortName: shortName, id: id, text: fallback } = this.node.attrs;
            const emojiDescription = await emojiProvider?.fetchByEmojiId({
                id: id,
                shortName: shortName,
                fallback: fallback
            }, true);
            if (!emojiDescription) {
                $144c0f90b58057f8$export$cadc6675ce598ba8.logError(new Error('Emoji description is not loaded'));
                this.renderFallback();
                return;
            }
            const unicodeEmoji = id && (0, $anBbz.expValEqualsNoExposure)('platform_use_unicode_emojis', 'isEnabled', true) ? (0, $4xiow.emojiIdToEmoji)(id) : undefined;
            const emojiRepresentation = unicodeEmoji ? {
                unicodeEmoji: unicodeEmoji
            } : emojiDescription?.representation;
            if (!$144c0f90b58057f8$export$cadc6675ce598ba8.isEmojiRepresentationSupported(emojiRepresentation)) {
                $144c0f90b58057f8$export$cadc6675ce598ba8.logError(new Error('Emoji representation is not supported'));
                this.renderFallback();
                return;
            }
            this.renderEmoji(emojiDescription, emojiRepresentation);
        } catch (error) {
            $144c0f90b58057f8$export$cadc6675ce598ba8.logError(error instanceof Error ? error : new Error('Unknown error on EmojiNodeView updateDom'));
            this.renderFallback();
        }
    }
    static isEmojiRepresentationSupported(representation) {
        return !!representation && ('sprite' in representation || 'imagePath' in representation || 'mediaPath' in representation || 'unicodeEmoji' in representation);
    }
    static shouldRecordUnicodeEmojiExposure(description, representation) {
        return description.type === 'STANDARD' || 'unicodeEmoji' in representation;
    }
    // Pay attention, this method should be called only when the emoji provider returns
    // emoji data to prevent rendering empty emoji during loading.
    cleanUpAndRenderCommonAttributes() {
        // Clean up the DOM before rendering the new emoji
        if (this.domElement) {
            this.domElement.innerHTML = '';
            this.domElement.style.cssText = '';
            this.domElement.classList.remove((0, $k8ZZN.EmojiSharedCssClassName).EMOJI_PLACEHOLDER);
            this.domElement.removeAttribute('aria-label'); // The label is set in the renderEmoji method
            this.domElement.removeAttribute('aria-busy');
        }
    }
    renderFallback() {
        this.renderingFallback = true;
        this.cleanUpAndRenderCommonAttributes();
        let doc = (0, $haNN4.getDocument)();
        if (!doc) // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        doc = document;
        const fallbackElement = doc.createElement('span');
        const { text: text, shortName: shortName } = this.node.attrs;
        // When the gate is enabled and the emoji is "custom" (i.e. its fallback
        // text is not a single standard Unicode emoji), render the Unicode
        // Replacement Character (U+FFFD) instead of the shortName text. Standard
        // emojis continue to fall back to their Unicode text representation.
        const fallbackText = text || shortName;
        const useReplacementChar = (0, $ixfCV.fg)('platform_editor_custom_emoji_unicode_fallback') && !$144c0f90b58057f8$export$1d677781db73ff20(fallbackText);
        const renderedFallbackText = useReplacementChar ? '\uFFFD' : fallbackText;
        fallbackElement.innerText = renderedFallbackText;
        fallbackElement.setAttribute('role', 'img');
        fallbackElement.setAttribute('title', shortName);
        fallbackElement.setAttribute('aria-label', shortName);
        fallbackElement.setAttribute('data-testid', `fallback-emoji-${shortName}`);
        fallbackElement.setAttribute('data-emoji-type', 'fallback');
        this.dom.appendChild(fallbackElement);
    }
    renderEmoji(description, representation) {
        this.renderingFallback = false;
        this.cleanUpAndRenderCommonAttributes();
        const emojiType = 'unicodeEmoji' in representation ? 'unicode' : 'sprite' in representation ? 'sprite' : 'image';
        let doc = (0, $haNN4.getDocument)();
        if (!doc) // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        doc = document;
        // Add wrapper for the emoji
        const containerElement = doc.createElement('span');
        containerElement.setAttribute('role', 'img');
        containerElement.setAttribute('title', description.shortName);
        containerElement.classList.add((0, $k8ZZN.EmojiSharedCssClassName).EMOJI_CONTAINER);
        containerElement.setAttribute('data-testid', `${emojiType}-emoji-${description.shortName}`);
        containerElement.setAttribute('data-emoji-type', emojiType);
        containerElement.setAttribute('aria-label', `${this.intl.formatMessage((0, $2O2Zk.messages).emojiNodeLabel)} ${description.shortName}`);
        const emojiElement = 'unicodeEmoji' in representation ? this.createUnicodeEmojiElement(representation.unicodeEmoji) : 'sprite' in representation ? this.createSpriteEmojiElement(representation) : this.createImageEmojiElement(description, representation);
        containerElement.appendChild(emojiElement);
        this.dom.appendChild(containerElement);
        if ($144c0f90b58057f8$export$cadc6675ce598ba8.shouldRecordUnicodeEmojiExposure(description, representation)) (0, $ieeJu.expValEquals)('platform_use_unicode_emojis', 'isEnabled', true);
    }
    createUnicodeEmojiElement(emoji) {
        let doc = (0, $haNN4.getDocument)();
        if (!doc) // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        doc = document;
        const spanElement = doc.createElement('span');
        spanElement.classList.add((0, $k8ZZN.EmojiSharedCssClassName).EMOJI_UNICODE);
        spanElement.textContent = emoji;
        spanElement.style.display = 'inline-flex';
        spanElement.style.fontSize = `var(--emoji-common-unicode-size, ${0, $l4yrE.defaultEmojiHeight}px)`;
        spanElement.style.alignItems = 'center';
        spanElement.style.aspectRatio = '1/1';
        spanElement.style.lineHeight = '1em';
        spanElement.style.margin = '-1px 0';
        spanElement.style.verticalAlign = 'middle'; // to keep vertical alignment consistent with images
        return spanElement;
    }
    createSpriteEmojiElement(representation) {
        let doc = (0, $haNN4.getDocument)();
        if (!doc) // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        doc = document;
        const spriteElement = doc.createElement('span');
        spriteElement.classList.add((0, $k8ZZN.EmojiSharedCssClassName).EMOJI_SPRITE);
        const sprite = representation.sprite;
        const xPositionInPercent = 100 / (sprite.column - 1) * representation.xIndex;
        const yPositionInPercent = 100 / (sprite.row - 1) * representation.yIndex;
        spriteElement.style.backgroundImage = `url(${sprite.url})`;
        spriteElement.style.backgroundPosition = `${xPositionInPercent}% ${yPositionInPercent}%`;
        spriteElement.style.backgroundSize = `${sprite.column * 100}% ${sprite.row * 100}%`;
        spriteElement.style.minWidth = `${0, $l4yrE.defaultEmojiHeight}px`;
        spriteElement.style.minHeight = `${0, $l4yrE.defaultEmojiHeight}px`;
        if (!(0, $ieeJu.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true)) {
            spriteElement.style.width = `${0, $l4yrE.defaultEmojiHeight}px`;
            spriteElement.style.height = `${0, $l4yrE.defaultEmojiHeight}px`;
        }
        return spriteElement;
    }
    createImageEmojiElement(emojiDescription, representation) {
        let doc = (0, $haNN4.getDocument)();
        if (!doc) // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        doc = document;
        const imageElement = doc.createElement('img');
        imageElement.classList.add((0, $k8ZZN.EmojiSharedCssClassName).EMOJI_IMAGE);
        imageElement.src = 'imagePath' in representation ? representation.imagePath : representation.mediaPath;
        imageElement.loading = 'lazy';
        imageElement.alt = emojiDescription.name || emojiDescription.shortName;
        imageElement.style.minWidth = `${0, $l4yrE.defaultEmojiHeight}px`;
        imageElement.style.objectFit = 'contain';
        imageElement.height = (0, $l4yrE.defaultEmojiHeight);
        imageElement.onerror = ()=>{
            if ((0, $fqVYq.editorExperiment)('platform_editor_offline_editing_web', true)) {
                // If there's an error (ie. offline) render the ascii fallback if possible, otherwise
                // mark the node to refresh when returning online.
                // Create a check that confirms if this.node.attrs.text if an ascii emoji
                if ($144c0f90b58057f8$export$1d677781db73ff20(this.node.attrs.text)) this.renderFallback();
                else this.renderingFallback = true;
            } else this.renderFallback();
        };
        return imageElement;
    }
    /**
   * Prosemirror node view for rendering emoji nodes. This class is responsible for
   * rendering emoji nodes in the editor, handling updates, and managing fallback rendering.
   *
   * @param node - The ProseMirror node representing the emoji.
   * @param extraProps - An object containing additional parameters.
   * @param extraProps.intl - The internationalization object for formatting messages.
   * @param extraProps.api - The editor API for accessing shared state and connectivity features.
   * @param extraProps.emojiNodeDataProvider - (Optional) A provider for fetching emoji data.
   *
   * @example
   * const emojiNodeView = new EmojiNodeView(node, { intl, api, emojiNodeDataProvider });
   */ constructor(node, { intl: intl, api: api, emojiNodeDataProvider: emojiNodeDataProvider }){
        this.dom = void 0;
        this.domElement = void 0;
        this.node = void 0;
        this.intl = void 0;
        this.renderingFallback = false;
        this.destroy = ()=>{};
        this.node = node;
        this.intl = intl;
        const { dom: dom } = (0, $aPdNQ.DOMSerializer).renderSpec(document, (0, $f5VOy.emojiToDom)(this.node));
        this.dom = dom;
        this.domElement = this.isHTMLElement(dom) ? dom : undefined;
        if (emojiNodeDataProvider) {
            let previousEmojiDescription;
            emojiNodeDataProvider.getData(node, (payload)=>{
                if (payload.error) {
                    $144c0f90b58057f8$export$cadc6675ce598ba8.logError(payload.error);
                    this.renderFallback();
                    return;
                }
                const optionalEmojiDescription = payload.data;
                if (!optionalEmojiDescription) {
                    this.renderFallback();
                    return;
                }
                const emojiRepresentation = optionalEmojiDescription?.representation;
                if (!$144c0f90b58057f8$export$cadc6675ce598ba8.isEmojiRepresentationSupported(emojiRepresentation)) {
                    this.renderFallback();
                    return;
                }
                if ((0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(previousEmojiDescription, optionalEmojiDescription)) // Do not re-render if the emoji description is the same as before
                return;
                previousEmojiDescription = optionalEmojiDescription;
                this.renderEmoji(optionalEmojiDescription, emojiRepresentation);
            });
        } else {
            if ((0, $4iudd.isSSR)()) // The provider doesn't work in SSR, and we don't want to render fallback in SSR,
            // that's why we don't need to continue node rendering.
            // In SSR we want to show a placeholder, that `emojiToDom()` returns.
            return;
            // We use the `emojiProvider` from the shared state
            // because it supports the `emojiProvider` prop in the `ComposableEditor` options
            // as well as the `emojiProvider` in the `EmojiPlugin` options.
            const sharedState = api?.emoji?.sharedState;
            if (!sharedState) return;
            let emojiProvider = sharedState.currentState()?.emojiProvider;
            if (emojiProvider) this.updateDom(emojiProvider);
            const unsubscribe = sharedState.onChange(({ nextSharedState: nextSharedState })=>{
                if (emojiProvider === nextSharedState?.emojiProvider) // Do not update if the provider is the same
                return;
                emojiProvider = nextSharedState?.emojiProvider;
                this.updateDom(emojiProvider);
            });
            // Refresh emojis if we go back online
            const subscribeToConnection = api?.connectivity?.sharedState.onChange(({ prevSharedState: prevSharedState, nextSharedState: nextSharedState })=>{
                if ((0, $6Ixg8.isOfflineMode)(prevSharedState?.mode) && nextSharedState?.mode === 'online' && this.renderingFallback && (0, $fqVYq.editorExperiment)('platform_editor_offline_editing_web', true)) this.updateDom(sharedState.currentState()?.emojiProvider);
            });
            this.destroy = ()=>{
                unsubscribe();
                subscribeToConnection?.();
            };
        }
    }
}
module.exports["EmojiNodeView"] = $144c0f90b58057f8$export$cadc6675ce598ba8;

});

parcelRegister("2O2Zk", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $373e836c88a63247$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    emojiNodeLabel: {
        id: "fabric.emoji.label",
        defaultMessage: "Emoji"
    }
});
module.exports["messages"] = $373e836c88a63247$export$defe85febe8b728c;

});

parcelRegister("38lAe", function(module, exports) {

var $k7vUa = parcelRequire("k7vUa");

const $0ac6ed1cc3df6249$export$92a1a3b7554e9387 = {
    SET_PROVIDER: 'SET_PROVIDER',
    SET_RESULTS: 'SET_RESULTS',
    SET_ASCII_MAP: 'SET_ASCII_MAP',
    SET_INLINE_POPUP: 'SET_INLINE_POPUP'
};
const $0ac6ed1cc3df6249$export$5e8f481ab8296997 = (asciiMap)=>(tr)=>{
        return tr.setMeta((0, $k7vUa.emojiPluginKey), {
            action: $0ac6ed1cc3df6249$export$92a1a3b7554e9387.SET_ASCII_MAP,
            params: {
                asciiMap: asciiMap
            }
        });
    };
const $0ac6ed1cc3df6249$export$adbec20dbbf15a6b = (typeaheadHandler, api)=>(inputMethod)=>{
        return Boolean(api?.typeAhead?.actions.open({
            triggerHandler: typeaheadHandler,
            inputMethod: inputMethod
        }));
    };
const $0ac6ed1cc3df6249$export$1572b3eade6662f9 = (provider)=>(tr)=>{
        return tr.setMeta((0, $k7vUa.emojiPluginKey), {
            action: $0ac6ed1cc3df6249$export$92a1a3b7554e9387.SET_PROVIDER,
            params: {
                provider: provider
            }
        });
    };
const $0ac6ed1cc3df6249$export$f53f9c9a74ec859b = (open)=>(tr)=>tr.setMeta((0, $k7vUa.emojiPluginKey), {
            action: $0ac6ed1cc3df6249$export$92a1a3b7554e9387.SET_INLINE_POPUP,
            params: {
                open: open
            }
        });
module.exports["ACTIONS"] = $0ac6ed1cc3df6249$export$92a1a3b7554e9387;
module.exports["setAsciiMap"] = $0ac6ed1cc3df6249$export$5e8f481ab8296997;
module.exports["openTypeAhead"] = $0ac6ed1cc3df6249$export$adbec20dbbf15a6b;
module.exports["setProvider"] = $0ac6ed1cc3df6249$export$1572b3eade6662f9;
module.exports["setInlineEmojiPopupOpen"] = $0ac6ed1cc3df6249$export$f53f9c9a74ec859b;

});

parcelRegister("6wqCa", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $kpCD8 = parcelRequire("kpCD8");


var $d8RhQ = parcelRequire("d8RhQ");


var $91Kwo = parcelRequire("91Kwo");

var $3brWT = parcelRequire("3brWT");

let $4ed2d201aff988fe$var$matcher;
function $4ed2d201aff988fe$export$568a7ed6897c4817(schema, editorAnalyticsAPI, pluginInjectionApi, disableAutoformat) {
    if (disableAutoformat) return;
    if (schema.nodes.emoji) {
        $4ed2d201aff988fe$var$initMatcher(pluginInjectionApi);
        const asciiEmojiRule = (0, $d8RhQ.createRule)($4ed2d201aff988fe$var$AsciiEmojiMatcher.REGEX, $4ed2d201aff988fe$var$inputRuleHandler(editorAnalyticsAPI));
        return new (0, $kpCD8.SafePlugin)((0, $91Kwo.createPlugin)('emoji', [
            asciiEmojiRule
        ]));
    }
    return;
}
function $4ed2d201aff988fe$var$initMatcher(pluginInjectionApi) {
    pluginInjectionApi?.emoji.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
        const emojiProvider = nextSharedState?.emojiProvider;
        if (emojiProvider) emojiProvider.getAsciiMap().then((map)=>{
            $4ed2d201aff988fe$var$matcher = new $4ed2d201aff988fe$var$RecordingAsciiEmojiMatcher(emojiProvider, map);
        });
    });
}
const $4ed2d201aff988fe$var$inputRuleHandler = (editorAnalyticsAPI)=>(state, matchParts, start, end)=>{
        if (!$4ed2d201aff988fe$var$matcher) return null;
        const match = $4ed2d201aff988fe$var$matcher.match(matchParts);
        if (match) {
            const transactionCreator = new $4ed2d201aff988fe$var$AsciiEmojiTransactionCreator(state, match, start, end, editorAnalyticsAPI);
            return transactionCreator.create();
        }
        return null;
    };
const $4ed2d201aff988fe$var$REGEX_LEADING_CAPTURE_INDEX = 1;
const $4ed2d201aff988fe$var$REGEX_EMOJI_LEADING_PARENTHESES = 2;
const $4ed2d201aff988fe$var$REGEX_EMOJI_ASCII_CAPTURE_INDEX = 3;
const $4ed2d201aff988fe$var$REGEX_TRAILING_CAPTURE_INDEX = 4;
const $4ed2d201aff988fe$var$getLeadingString = (match, withParenthesis = true)=>match[$4ed2d201aff988fe$var$REGEX_LEADING_CAPTURE_INDEX] + (withParenthesis ? match[$4ed2d201aff988fe$var$REGEX_EMOJI_LEADING_PARENTHESES] : '');
const $4ed2d201aff988fe$var$getLeadingStringWithoutParentheses = (match)=>$4ed2d201aff988fe$var$getLeadingString(match, false);
const $4ed2d201aff988fe$var$getAscii = (match, withParentheses = false)=>(withParentheses ? match[$4ed2d201aff988fe$var$REGEX_EMOJI_LEADING_PARENTHESES] : '') + match[$4ed2d201aff988fe$var$REGEX_EMOJI_ASCII_CAPTURE_INDEX].trim();
const $4ed2d201aff988fe$var$getAsciiWithParentheses = (matchParts)=>$4ed2d201aff988fe$var$getAscii(matchParts, true);
const $4ed2d201aff988fe$var$getTrailingString = (match)=>match[$4ed2d201aff988fe$var$REGEX_TRAILING_CAPTURE_INDEX] || '';
class $4ed2d201aff988fe$var$AsciiEmojiMatcher {
    match(matchParts) {
        return this.getAsciiEmojiMatch($4ed2d201aff988fe$var$getLeadingStringWithoutParentheses(matchParts), $4ed2d201aff988fe$var$getAsciiWithParentheses(matchParts), $4ed2d201aff988fe$var$getTrailingString(matchParts)) || this.getAsciiEmojiMatch($4ed2d201aff988fe$var$getLeadingString(matchParts), $4ed2d201aff988fe$var$getAscii(matchParts), $4ed2d201aff988fe$var$getTrailingString(matchParts));
    }
    getAsciiEmojiMatch(leading, ascii, trailing) {
        const emoji = this.asciiToEmojiMap.get(ascii);
        return emoji ? {
            emoji: emoji,
            leadingString: leading,
            trailingString: trailing
        } : undefined;
    }
    constructor(asciiToEmojiMap){
        this.asciiToEmojiMap = void 0;
        this.asciiToEmojiMap = asciiToEmojiMap;
    }
}
/**
 * A matcher that will record ascii matches as usages of the matched emoji.
 */ /**
 * This regex matches 2 scenarios:
 * 1. an emoticon starting with a colon character (e.g. :D => 😃)
 * 2. an emoticon not starting with a colon character (e.g. 8-D => 😎)
 *
 * Explanation (${leafNodeReplacementCharacter} is replaced with character \ufffc)
 *
 *  1st Capturing Group ((?:^|[\s\ufffc])(?:\(*?))
 *    Non-capturing group (?:^|[\s\ufffc])
 *      1st Alternative ^
 *        ^ asserts position at start of the string
 *      2nd Alternative [\s\ufffc]
 *        matches a single character present in [\s\ufffc]
 *    Non-capturing group (?:\(*?)
 *      matches the character ( literally between zero and unlimited times, as few times as possible, expanding as needed (lazy)
 *  2nd Capturing Group (\(?)
 *    matches a single ( if present
 *  3rd Capturing Group ([^:\s\ufffc\(]\S{1,3}|:\S{1,3}( ))
 *    1st Alternative [^:\s\ufffc\(]\S{1,3}
 *      matches a single character not present in [^:\s\ufffc\(] between 1 and 3 times, as many times as possible, giving back as needed (greedy)
 *    2nd Alternative :\S{1,3}( )
 *      : matches the character : literally
 *      \S{1,3} matches any non-whitespace character between 1 and 3 times, as many times as possible, giving back as needed (greedy)
 *  4th Capturing Group ( )
 *
 * See https://regex101.com/r/HRS9O2/4
 */ // New behavior: All emoticons require whitespace after them
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
$4ed2d201aff988fe$var$AsciiEmojiMatcher.REGEX = new RegExp(`((?:^|[\\s${(0, $3brWT.leafNodeReplacementCharacter)}])(?:\\(*?))(\\(?)([^:\\s${(0, $3brWT.leafNodeReplacementCharacter)}\\(]\\S{1,3}|:\\S{1,3})([\\s\\t\\n])$`);
class $4ed2d201aff988fe$var$RecordingAsciiEmojiMatcher extends $4ed2d201aff988fe$var$AsciiEmojiMatcher {
    match(matchParts) {
        const match = super.match(matchParts);
        if (match && this.emojiProvider.recordSelection) this.emojiProvider.recordSelection(match.emoji);
        return match;
    }
    constructor(emojiProvider, asciiToEmojiMap){
        super(asciiToEmojiMap);
        this.emojiProvider = void 0;
        this.emojiProvider = emojiProvider;
    }
}
class $4ed2d201aff988fe$var$AsciiEmojiTransactionCreator {
    create() {
        const tr = this.state.tr.replaceWith(this.from, this.to, this.createNodes());
        this.editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).INSERTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).EMOJI,
            attributes: {
                inputMethod: (0, $krYZG.INPUT_METHOD).ASCII
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    }
    get from() {
        return this.start + this.match.leadingString.length;
    }
    get to() {
        return this.end;
    }
    createNodes() {
        const nodes = [
            this.createEmojiNode()
        ];
        if (this.trailingTextNodeRequired()) nodes.push(this.createTrailingTextNode());
        return nodes;
    }
    createEmojiNode() {
        const { emoji: emojiTypeNode } = this.state.schema.nodes;
        return emojiTypeNode.create(this.getEmojiNodeAttrs());
    }
    getEmojiNodeAttrs() {
        const emoji = this.match.emoji;
        return {
            id: emoji.id,
            shortName: emoji.shortName,
            text: emoji.fallback || emoji.shortName
        };
    }
    trailingTextNodeRequired() {
        return this.match.trailingString.length > 0;
    }
    createTrailingTextNode() {
        return this.state.schema.text(this.match.trailingString);
    }
    constructor(state, match, start, end, editorAnalyticsAPI){
        this.state = void 0;
        this.match = void 0;
        this.start = void 0;
        this.end = void 0;
        this.editorAnalyticsAPI = void 0;
        this.state = state;
        this.match = match;
        this.start = start;
        this.end = end;
        this.editorAnalyticsAPI = editorAnalyticsAPI;
    }
}
const $4ed2d201aff988fe$var$plugins = (schema, providerFactory, featureFlags, editorAnalyticsAPI, pluginInjectionApi)=>{
    return [
        $4ed2d201aff988fe$export$568a7ed6897c4817(schema, editorAnalyticsAPI, pluginInjectionApi)
    ].filter((plugin)=>!!plugin);
};
var $4ed2d201aff988fe$export$2e2bcd8739ae039 = $4ed2d201aff988fe$var$plugins;
module.exports["inputRulePlugin"] = $4ed2d201aff988fe$export$568a7ed6897c4817;

});

parcelRegister("8civN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $krYZG = parcelRequire("krYZG");


var $ajK0g = parcelRequire("ajK0g");


var $4y8CY = parcelRequire("4y8CY");


var $7XIuB = parcelRequire("7XIuB");


var $uyXFl = parcelRequire("uyXFl");

var $9Muxb = parcelRequire("9Muxb");


var $4Qu9h = parcelRequire("4Qu9h");


var $7Y8M5 = parcelRequire("7Y8M5");


var $lAkJe = parcelRequire("lAkJe");


var $ixfCV = parcelRequire("ixfCV");


var $38lAe = parcelRequire("38lAe");

const $fea728d07a1765e1$var$PopupWithListeners = (0, $9Muxb.default)((0, $7XIuB.default));
const $fea728d07a1765e1$var$emojiPopupMessages = {
    emojiPickerAriaLabel: {
        id: 'fabric.emoji.picker.aria.label',
        defaultMessage: 'Emoji picker',
        description: 'Accessible label for the emoji picker popup'
    }
};
const $fea728d07a1765e1$export$b7ec9ebb3bbf8534 = ({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, onClose: onClose })=>{
    const { emojiProvider: emojiProvider, inlineEmojiPopupOpen: isOpen } = (0, $4y8CY.useSharedPluginState)(api, [
        'emoji'
    ])?.emojiState ?? {};
    const intl = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        if (isOpen && (0, $ixfCV.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.handleIntentToStartEdit({
            shouldStartTimer: false,
            shouldPersistActiveSession: true
        }));
    }, [
        isOpen,
        api
    ]);
    const handleOnClose = (0, $cozmU.useCallback)(()=>{
        if ((0, $ixfCV.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
        onClose?.();
    }, [
        onClose,
        api
    ]);
    const focusEditor = (0, $cozmU.useCallback)(()=>{
        // use requestAnimationFrame to run this async after the call
        requestAnimationFrame(()=>editorView.focus());
    }, [
        editorView
    ]);
    const handleSelection = (0, $cozmU.useCallback)((emojiId)=>{
        api.core.actions.execute(api.emoji.commands.insertEmoji(emojiId, (0, $krYZG.INPUT_METHOD).PICKER));
        handleOnClose();
    }, [
        api.core.actions,
        api.emoji.commands,
        handleOnClose
    ]);
    if (!isOpen || !emojiProvider) return null;
    const domRef = (0, $ajK0g.getDomRefFromSelection)(editorView, (0, $krYZG.ACTION_SUBJECT_ID).PICKER_EMOJI, api?.analytics?.actions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fea728d07a1765e1$var$PopupWithListeners, {
        ariaLabel: intl.formatMessage($fea728d07a1765e1$var$emojiPopupMessages.emojiPickerAriaLabel),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            0,
            12
        ],
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        zIndex: (0, $7Y8M5.akEditorFloatingDialogZIndex),
        fitHeight: 350,
        fitWidth: 350,
        target: domRef,
        onUnmount: focusEditor,
        focusTrap: true,
        preventOverflow: true,
        handleClickOutside: handleOnClose,
        handleEscapeKeydown: handleOnClose,
        captureClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyXFl.OutsideClickTargetRefContext).Consumer, null, (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lAkJe.EmojiPicker), {
            emojiProvider: Promise.resolve(emojiProvider),
            onPickerRef: setOutsideClickTargetRef,
            onSelection: handleSelection
        })));
};
const $fea728d07a1765e1$var$InlineEmojiPopupContent = ({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView })=>{
    const emojiProvider = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'emoji.emojiProvider');
    const intl = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        if ((0, $ixfCV.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.handleIntentToStartEdit({
            shouldStartTimer: false,
            shouldPersistActiveSession: true
        }));
    }, [
        api?.core.actions,
        api?.metrics?.commands
    ]);
    const handleOnClose = (0, $cozmU.useCallback)(()=>{
        editorView.dispatch((0, $38lAe.setInlineEmojiPopupOpen)(false)(editorView.state.tr));
        if ((0, $ixfCV.fg)('platform_editor_ease_of_use_metrics')) api?.core.actions.execute(api?.metrics?.commands.startActiveSessionTimer());
    }, [
        editorView,
        api.core.actions,
        api.metrics?.commands
    ]);
    const focusEditor = (0, $cozmU.useCallback)(()=>{
        // use requestAnimationFrame to run this async after the call
        requestAnimationFrame(()=>editorView.focus());
    }, [
        editorView
    ]);
    const handleSelection = (0, $cozmU.useCallback)((emojiId)=>{
        api.core.actions.execute(api.emoji.commands.insertEmoji(emojiId, (0, $krYZG.INPUT_METHOD).PICKER));
        handleOnClose();
    }, [
        api.core.actions,
        api.emoji.commands,
        handleOnClose
    ]);
    const domRef = (0, $cozmU.useMemo)(()=>(0, $ajK0g.getDomRefFromSelection)(editorView, (0, $krYZG.ACTION_SUBJECT_ID).PICKER_EMOJI, api?.analytics?.actions), [
        editorView,
        api?.analytics?.actions
    ]);
    if (!emojiProvider) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fea728d07a1765e1$var$PopupWithListeners, {
        ariaLabel: intl.formatMessage($fea728d07a1765e1$var$emojiPopupMessages.emojiPickerAriaLabel),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            0,
            12
        ],
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        zIndex: (0, $7Y8M5.akEditorFloatingDialogZIndex),
        fitHeight: 350,
        fitWidth: 350,
        target: domRef,
        onUnmount: focusEditor,
        focusTrap: true,
        preventOverflow: true,
        handleClickOutside: handleOnClose,
        handleEscapeKeydown: handleOnClose,
        captureClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyXFl.OutsideClickTargetRefContext).Consumer, null, (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lAkJe.EmojiPicker), {
            emojiProvider: Promise.resolve(emojiProvider),
            onPickerRef: setOutsideClickTargetRef,
            onSelection: handleSelection
        })));
};
const $fea728d07a1765e1$export$295b54f3ba0abfa5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView })=>{
    const isOpen = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'emoji.inlineEmojiPopupOpen');
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fea728d07a1765e1$var$InlineEmojiPopupContent, {
        api: api,
        editorView: editorView,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement
    });
});
module.exports["InlineEmojiPopup"] = $fea728d07a1765e1$export$295b54f3ba0abfa5;

});

parcelRegister("ajK0g", function(module, exports) {

var $bjg0G = parcelRequire("bjg0G");


var $krYZG = parcelRequire("krYZG");

const $c1a12c1d77a0edce$export$49d74ed2464a12b9 = (view, actionSubjectId, editorAnalyticsAPI)=>{
    try {
        const domRef = (0, $bjg0G.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
        if (domRef instanceof HTMLElement) {
            // If element is not a paragraph, we need to find the closest paragraph parent
            if (domRef.nodeName !== 'P') {
                const paragraphRef = domRef.closest('p');
                if (paragraphRef) return paragraphRef;
            }
            return domRef;
        } else throw new Error('Invalid DOM reference');
    } catch (error) {
        if (editorAnalyticsAPI) {
            const payload = {
                action: (0, $krYZG.ACTION).ERRORED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).PICKER,
                actionSubjectId: actionSubjectId,
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    error: 'Error getting DOM reference from selection'
                }
            };
            editorAnalyticsAPI.fireAnalyticsEvent(payload);
        }
    }
};
module.exports["getDomRefFromSelection"] = $c1a12c1d77a0edce$export$49d74ed2464a12b9;

});

parcelRegister("2ZvWx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kHija = parcelRequire("kHija");


var $krYZG = parcelRequire("krYZG");


var $725R2 = parcelRequire("725R2");

var $gx3UZ = parcelRequire("gx3UZ");


var $794I6 = parcelRequire("794I6");


var $jGK9e = parcelRequire("jGK9e");


var $bijHC = parcelRequire("bijHC");


var $caelp = parcelRequire("caelp");


var $ixfCV = parcelRequire("ixfCV");


var $lkoJ5 = parcelRequire("lkoJ5");


var $kaZKS = parcelRequire("kaZKS");


var $3mDyZ = parcelRequire("3mDyZ");


var $03fL3 = parcelRequire("03fL3");


var $4WUlX = parcelRequire("4WUlX");


var $95fLA = parcelRequire("95fLA");


var $3njTd = parcelRequire("3njTd");


var $6tSFE = parcelRequire("6tSFE");

const $46aa276b63f2a096$var$processName = (name, intl)=>{
    const unknownLabel = intl.formatMessage((0, $725R2.mentionMessages).unknownLabel);
    if (name.status === (0, $caelp.MentionNameStatus).OK) return `@${name.name || unknownLabel}`;
    else return `@${unknownLabel}`;
};
/**
 * We will need to clean this up once mentionProvider is
 * put inside mention plugin.
 * See: https://product-fabric.atlassian.net/browse/ED-26011
 */ function $46aa276b63f2a096$var$Component({ mentionProvider: mentionProvider, api: api }) {
    const mentionProviderMemo = (0, $cozmU.useMemo)(()=>{
        return mentionProvider;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const intl = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        mentionProviderMemo?.then((mentionProviderSync)=>{
            api?.base?.actions?.registerMarks(({ tr: tr, node: node, pos: pos })=>{
                const { doc: doc } = tr;
                const { schema: schema } = doc.type;
                const { mention: mentionNodeType } = schema.nodes;
                const { id: id } = node.attrs;
                if (node.type === mentionNodeType) {
                    if ((0, $bijHC.isResolvingMentionProvider)(mentionProviderSync)) {
                        const nameDetail = mentionProviderSync?.resolveMentionName(id);
                        let newText;
                        if ((0, $caelp.isPromise)(nameDetail)) newText = `@${intl.formatMessage((0, $725R2.mentionMessages).unknownLabel)}`;
                        else newText = $46aa276b63f2a096$var$processName(nameDetail, intl);
                        const currentPos = tr.mapping.map(pos);
                        tr.replaceWith(currentPos, currentPos + node.nodeSize, schema.text(newText, node.marks));
                    }
                }
            });
        });
    }, [
        mentionProviderMemo,
        api,
        intl
    ]);
    return null;
}
const $46aa276b63f2a096$export$280dfabe1535ae84 = ({ config: options, api: api })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($kHija)))();
    let previousMediaProvider;
    const fireEvent = (payload, channel)=>{
        const fireAnalyticsEvent = api?.analytics?.actions?.fireAnalyticsEvent;
        if (!fireAnalyticsEvent) return;
        if (payload.attributes && !payload.attributes.sessionId) payload.attributes.sessionId = sessionId;
        fireAnalyticsEvent(payload, channel);
    };
    const typeAhead = (0, $6tSFE.createTypeAheadConfig)({
        sanitizePrivateContent: options?.sanitizePrivateContent,
        mentionInsertDisplayName: options?.insertDisplayName,
        HighlightComponent: options?.HighlightComponent,
        handleMentionsChanged: options?.handleMentionsChanged,
        enableAgentSectioning: options?.enableAgentSectioning,
        fireEvent: fireEvent,
        api: api
    });
    return {
        name: 'mention',
        nodes () {
            return [
                {
                    name: 'mention',
                    node: (0, $kaZKS.mentionNodeSpec)()
                }
            ];
        },
        pmPlugins () {
            const plugins = [
                {
                    name: 'mention',
                    plugin: (pmPluginFactoryParams)=>(0, $03fL3.createMentionPlugin)({
                            pmPluginFactoryParams: pmPluginFactoryParams,
                            fireEvent: fireEvent,
                            options: options,
                            api: api
                        })
                }
            ];
            if ((0, $ixfCV.fg)('jira_invites_auto_tag_new_user_in_mentions_fg')) plugins.push({
                name: 'mentionPlaceholder',
                plugin: ()=>(0, $4WUlX.createMentionPlaceholderPlugin)()
            });
            return plugins;
        },
        contentComponent ({ editorView: editorView, providerFactory: providerFactory }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $794I6.WithProviders), {
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                providers: [
                    'mentionProvider'
                ],
                providerFactory: providerFactory,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                renderNode: ({ mentionProvider: mentionProvider })=>{
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($46aa276b63f2a096$var$Component, {
                        mentionProvider: mentionProvider,
                        api: api
                    }), (0, $ixfCV.fg)('jira_invites_auto_tag_new_user_in_mentions_fg') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95fLA.InlineInviteRecaptchaContainer), {
                        mentionProvider: mentionProvider,
                        api: api
                    }));
                }
            });
        },
        secondaryToolbarComponent ({ editorView: editorView, disabled: disabled }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3njTd.SecondaryToolbarComponent), {
                editorView: editorView,
                api: api,
                disabled: disabled,
                typeAhead: typeAhead
            });
        },
        commands: {
            insertMention: (0, $lkoJ5.insertMention)({
                sanitizePrivateContent: options?.sanitizePrivateContent ?? false,
                mentionInsertDisplayName: options?.insertDisplayName ?? false,
                api: api
            })
        },
        actions: {
            openTypeAhead (inputMethod) {
                return Boolean(api?.typeAhead?.actions?.open({
                    triggerHandler: typeAhead,
                    inputMethod: inputMethod
                }));
            },
            announceMentionsInsertion: (mentionChanges)=>{
                if (options?.handleMentionsChanged) options.handleMentionsChanged(mentionChanges);
            },
            updateSectionTitle: (props)=>{
                if (!options?.enableAgentSectioning) return false;
                return api?.typeAhead?.actions?.updateSectionTitle?.(props) ?? false;
            },
            setProvider: async (providerPromise)=>{
                if (!(0, $ixfCV.fg)('platform_editor_mention_provider_via_plugin_config')) return false;
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons
                if (previousMediaProvider === provider) return false;
                previousMediaProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $3mDyZ.mentionPluginKey), {
                        action: (0, $03fL3.ACTIONS).SET_PROVIDER,
                        params: {
                            provider: provider
                        }
                    })) ?? false;
            }
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const mentionPluginState = (0, $3mDyZ.mentionPluginKey).getState(editorState);
            return {
                ...mentionPluginState,
                typeAheadHandler: typeAhead
            };
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'mention',
                        title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).mention),
                        description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).mentionDescription),
                        keywords: [
                            'team',
                            'user'
                        ],
                        priority: 400,
                        keyshortcut: '@',
                        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jGK9e.IconMention), null),
                        action (insert, state) {
                            const tr = insert(undefined);
                            const pluginState = (0, $3mDyZ.mentionPluginKey).getState(state);
                            if (pluginState && pluginState.canInsertMention === false) return false;
                            api?.typeAhead?.actions.openAtTransaction({
                                triggerHandler: typeAhead,
                                inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT
                            })(tr);
                            return tr;
                        }
                    }
                ],
            typeAhead: typeAhead
        }
    };
};
module.exports["mentionsPlugin"] = $46aa276b63f2a096$export$280dfabe1535ae84;

});

parcelRegister("bijHC", function(module, exports) {

var $gABt9 = parcelRequire("gABt9");


var $caelp = parcelRequire("caelp");


var $2SUNK = parcelRequire("2SUNK");


var $b3nqj = parcelRequire("b3nqj");


var $55fM8 = parcelRequire("55fM8");

const $ec39392517ed4807$var$MAX_QUERY_ITEMS = 100;
const $ec39392517ed4807$var$MAX_NOTIFIED_ITEMS = 20;
const $ec39392517ed4807$var$emptySecurityProvider = ()=>{
    return {
        params: {},
        headers: {}
    };
};
class $ec39392517ed4807$export$4529f10aed0950d4 {
    subscribe(key, callback, errCallback, infoCallback, allResultsCallback, analyticsListeners) {
        if (callback) this.changeListeners.set(key, callback);
        if (errCallback) this.errListeners.set(key, errCallback);
        if (infoCallback) this.infoListeners.set(key, infoCallback);
        if (allResultsCallback) this.allResultsListeners.set(key, allResultsCallback);
        if (analyticsListeners) this.analyticsListeners.set(key, analyticsListeners);
    }
    unsubscribe(key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
        this.analyticsListeners.delete(key);
    }
    constructor(){
        this.changeListeners = void 0;
        this.errListeners = void 0;
        this.infoListeners = void 0;
        this.allResultsListeners = void 0;
        this.analyticsListeners = void 0;
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
        this.analyticsListeners = new Map();
    }
}
class $ec39392517ed4807$export$8576ba1ed2760927 extends $ec39392517ed4807$export$4529f10aed0950d4 {
    shouldHighlightMention(_mention) {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    filter(query) {
        throw new Error(`not yet implemented.\nParams: query=${query}`);
    }
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    recordMentionSelection(_mention) {
    // Do nothing
    }
    isFiltering(_query) {
        return false;
    }
    _notifyListeners(mentionsResult, stats) {
        (0, $2SUNK.default)('ak-mention-resource._notifyListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $ec39392517ed4807$var$MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            } catch (e) {
                // ignore error from listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAllResultsListeners(mentionsResult) {
        (0, $2SUNK.default)('ak-mention-resource._notifyAllResultsListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $ec39392517ed4807$var$MAX_NOTIFIED_ITEMS), mentionsResult.query);
            } catch (e) {
                // ignore error from listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyErrorListeners(error, query) {
        this.errListeners.forEach((listener, key)=>{
            try {
                listener(error, query);
            } catch (e) {
                // ignore error from listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyInfoListeners(info) {
        this.infoListeners.forEach((listener, key)=>{
            try {
                listener(info);
            } catch (e) {
                // ignore error fromr listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAnalyticsListeners(event, actionSubject, action, attributes) {
        this.analyticsListeners.forEach((listener, key)=>{
            try {
                listener(event, actionSubject, action, attributes);
            } catch (e) {
                // ignore error from listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $ec39392517ed4807$export$5a4331e3e1c43553 extends $ec39392517ed4807$export$8576ba1ed2760927 {
    shouldHighlightMention(mention) {
        if (this.config.shouldHighlightMention) return this.config.shouldHighlightMention(mention);
        return false;
    }
    getMentionDisabledState(mention) {
        return this.config.getMentionDisabledState?.(mention);
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        } else {
            const date = new Date(searchTime).toISOString().substr(17, 6);
            (0, $2SUNK.default)('Stale search result, skipping', date, query); // eslint-disable-line no-console, max-len
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
        if (query) this.activeSearches.delete(query);
    }
    async filter(query, contextIdentifier) {
        try {
            const searchTime = Date.now();
            let results;
            if (!query) results = await this.initialState(contextIdentifier);
            else {
                this.activeSearches.add(query);
                const searchResponse = this.search(query, contextIdentifier);
                results = await searchResponse.mentions;
            }
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    resolveMentionName(id) {
        if (!this.config.mentionNameResolver) return {
            id: id,
            name: '',
            status: (0, $caelp.MentionNameStatus).UNKNOWN
        };
        return this.config.mentionNameResolver.lookupName(id);
    }
    cacheMentionName(id, mentionName) {
        if (!this.config.mentionNameResolver) return;
        this.config.mentionNameResolver.cacheName(id, mentionName);
    }
    supportsMentionNameResolving() {
        return !!this.config.mentionNameResolver;
    }
    updateActiveSearches(query) {
        this.activeSearches.add(query);
    }
    verifyMentionConfig(config) {
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.securityProvider) config.securityProvider = $ec39392517ed4807$var$emptySecurityProvider;
    }
    initialState(contextIdentifier) {
        return this.remoteInitialState(contextIdentifier);
    }
    /**
   * Clear a context object to generate query params by removing empty
   * strings, `undefined` and empty values.
   *
   * @param contextIdentifier the current context identifier
   * @returns a safe context for query encoding
   */ clearContext(contextIdentifier = {}) {
        return Object.keys(contextIdentifier).filter((key)=>contextIdentifier[key]).reduce((context, key)=>({
                [key]: contextIdentifier[key],
                ...context
            }), {});
    }
    getQueryParams(contextIdentifier) {
        const configParams = {};
        if (this.config.containerId) configParams['containerId'] = this.config.containerId;
        if (this.config.productId) configParams['productIdentifier'] = this.config.productId;
        // if contextParams exist then it will override configParams for containerId
        return {
            ...configParams,
            ...this.clearContext(contextIdentifier)
        };
    }
    /**
   * Returns the initial mention display list before a search is performed for the specified
   * container.
   *
   * @param contextIdentifier
   * @returns Promise
   */ async remoteInitialState(contextIdentifier) {
        const queryParams = this.getQueryParams(contextIdentifier);
        const configHeaders = this.config.headers;
        const options = {
            path: 'bootstrap',
            queryParams: queryParams,
            ...configHeaders && {
                requestInit: {
                    headers: configHeaders
                }
            }
        };
        try {
            const result = await (0, $gABt9.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), (0, $caelp.SliNames).INITIAL_STATE, (0, $caelp.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, '');
        } catch (error) {
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), (0, $caelp.SliNames).INITIAL_STATE, (0, $caelp.Actions).FAILED);
            throw error;
        }
    }
    search(query, contextIdentifier) {
        return {
            mentions: this.remoteSearch(query, contextIdentifier)
        };
    }
    async remoteSearch(query, contextIdentifier) {
        const configHeaders = this.config.headers;
        const options = {
            path: 'search',
            queryParams: {
                query: query,
                limit: $ec39392517ed4807$var$MAX_QUERY_ITEMS,
                ...this.getQueryParams(contextIdentifier)
            },
            ...configHeaders && {
                requestInit: {
                    headers: configHeaders
                }
            }
        };
        try {
            const result = await (0, $gABt9.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), (0, $caelp.SliNames).SEARCH, (0, $caelp.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, query);
        } catch (error) {
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), (0, $caelp.SliNames).SEARCH, (0, $caelp.Actions).FAILED);
            throw error;
        }
    }
    transformServiceResponse(result, query) {
        const mentions = result.mentions.map((mention)=>{
            let lozenge;
            if ((0, $caelp.isAppMention)(mention)) lozenge = mention.userType;
            else if ((0, $caelp.isTeamMention)(mention)) lozenge = mention.userType;
            return {
                ...mention,
                lozenge: lozenge,
                query: query
            };
        });
        return {
            ...result,
            mentions: mentions,
            query: result.query || query
        };
    }
    constructor(config){
        super();
        this.config = void 0;
        this.lastReturnedSearch = void 0;
        this.activeSearches = void 0;
        this.productName = void 0;
        this.shouldEnableInvite = void 0;
        this.userRole = void 0;
        this.onInviteItemClick = void 0;
        this.inviteXProductUser = void 0;
        this.verifyMentionConfig(config);
        this.config = config;
        this.lastReturnedSearch = 0;
        this.activeSearches = new Set();
        this.productName = config.productName;
        this.shouldEnableInvite = !!config.shouldEnableInvite;
        this.onInviteItemClick = config.onInviteItemClick;
        this.inviteXProductUser = config.inviteXProductUser;
        this.userRole = config.userRole || 'basic';
        if (this.config.debounceTime) this.filter = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(this.filter, this.config.debounceTime);
    }
}
class $ec39392517ed4807$export$65bd6083489bd8bb {
    constructor(statusCode, statusMessage){
        this.name = void 0;
        this.message = void 0;
        this.statusCode = void 0;
        this.stack = void 0;
        this.statusCode = statusCode;
        this.message = statusMessage;
        this.name = 'HttpError';
        this.stack = new Error().stack;
    }
}
const $ec39392517ed4807$export$ae1fce5f69858ef3 = (p)=>!!(p && p.supportsMentionNameResolving && p.supportsMentionNameResolving());
var $ec39392517ed4807$export$2e2bcd8739ae039 = $ec39392517ed4807$export$5a4331e3e1c43553;
module.exports["AbstractResource"] = $ec39392517ed4807$export$4529f10aed0950d4;
module.exports["AbstractMentionResource"] = $ec39392517ed4807$export$8576ba1ed2760927;
module.exports["isResolvingMentionProvider"] = $ec39392517ed4807$export$ae1fce5f69858ef3;
module.exports["default"] = $ec39392517ed4807$export$2e2bcd8739ae039;

});

parcelRegister("caelp", function(module, exports) {
var $c573a2458006a7eb$export$2102863a3c660c6b = /*#__PURE__*/ function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    MentionType[MentionType["DISABLED"] = 3] = "DISABLED";
    return MentionType;
}({});
var $c573a2458006a7eb$export$81124e6148ca5db0 = /*#__PURE__*/ function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    return UserAccessLevel;
}({});
var $c573a2458006a7eb$export$8436e53e45ffe15b = /*#__PURE__*/ function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    return UserType;
}({});
var $c573a2458006a7eb$export$7afb0727c7d7e8af = /*#__PURE__*/ function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
    return SliNames;
}({});
var $c573a2458006a7eb$export$5c42d9dea6d035c1 = /*#__PURE__*/ function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
    return ComponentNames;
}({});
var $c573a2458006a7eb$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
    return Actions;
}({});
var $c573a2458006a7eb$export$b8fa67dc54502853 = /*#__PURE__*/ function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    return MentionNameStatus;
}({});
function $c573a2458006a7eb$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === $c573a2458006a7eb$export$81124e6148ca5db0[0];
}
function $c573a2458006a7eb$export$37b8dcac6198c514(mention) {
    return !!mention.userType && mention.userType === $c573a2458006a7eb$export$8436e53e45ffe15b[1];
}
function $c573a2458006a7eb$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === $c573a2458006a7eb$export$8436e53e45ffe15b[2];
}
function $c573a2458006a7eb$export$803b1379348dbfd5(mention) {
    return mention.userType && mention.userType === $c573a2458006a7eb$export$8436e53e45ffe15b[3];
}
function $c573a2458006a7eb$export$d13d4f976b36a397(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
const $c573a2458006a7eb$export$4369c812aac99591 = (p)=>!!(p && p.then);
module.exports["MentionType"] = $c573a2458006a7eb$export$2102863a3c660c6b;
module.exports["UserAccessLevel"] = $c573a2458006a7eb$export$81124e6148ca5db0;
module.exports["UserType"] = $c573a2458006a7eb$export$8436e53e45ffe15b;
module.exports["SliNames"] = $c573a2458006a7eb$export$7afb0727c7d7e8af;
module.exports["ComponentNames"] = $c573a2458006a7eb$export$5c42d9dea6d035c1;
module.exports["Actions"] = $c573a2458006a7eb$export$b52183d5cfb26dc9;
module.exports["MentionNameStatus"] = $c573a2458006a7eb$export$b8fa67dc54502853;
module.exports["isRestricted"] = $c573a2458006a7eb$export$dbaa15dc1820b89a;
module.exports["isSpecialMention"] = $c573a2458006a7eb$export$37b8dcac6198c514;
module.exports["isAppMention"] = $c573a2458006a7eb$export$eb590c844d13454c;
module.exports["isTeamMention"] = $c573a2458006a7eb$export$803b1379348dbfd5;
module.exports["isSpecialMentionText"] = $c573a2458006a7eb$export$d13d4f976b36a397;
module.exports["isPromise"] = $c573a2458006a7eb$export$4369c812aac99591;

});

parcelRegister("2SUNK", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b516e3b9bd2f12c$export$2e2bcd8739ae039);
let $1b516e3b9bd2f12c$var$debugEnabled = false;
let $1b516e3b9bd2f12c$var$stacktracesEnabled = false;
function $1b516e3b9bd2f12c$export$748ada60eaf985cc(enable) {
    $1b516e3b9bd2f12c$var$debugEnabled = enable;
}
function $1b516e3b9bd2f12c$export$4f7017086af31c25(enable) {
    $1b516e3b9bd2f12c$var$stacktracesEnabled = enable;
}
function $1b516e3b9bd2f12c$export$2a858f450a2f66d() {
    if ($1b516e3b9bd2f12c$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $1b516e3b9bd2f12c$export$2e2bcd8739ae039(msg, ...args) {
    if ($1b516e3b9bd2f12c$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("b3nqj", function(module, exports) {

var $852mP = parcelRequire("852mP");


var $4cczm = parcelRequire("4cczm");


var $caelp = parcelRequire("caelp");

const $39262f9932c4c2bd$var$packageName = "platform-pkg";
const $39262f9932c4c2bd$var$packageVersion = "0.0.0-use.local";
const $39262f9932c4c2bd$export$245097525aef1262 = 'sli';
const $39262f9932c4c2bd$export$c724588856bbfbcf = 'smart';
const $39262f9932c4c2bd$export$a823474ae5cb9e9c = (props)=>(action, duration, userIds = [], query)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $caelp.ComponentNames).TYPEAHEAD,
                attributes: {
                    packageName: $39262f9932c4c2bd$var$packageName,
                    packageVersion: $39262f9932c4c2bd$var$packageVersion,
                    componentName: (0, $caelp.ComponentNames).MENTION,
                    duration: Math.round(duration),
                    userIds: userIds,
                    queryLength: query ? query.length : 0
                },
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $4cczm.ELEMENTS_CHANNEL));
        }
    };
const $39262f9932c4c2bd$export$44902bc7b3f0b09f = (createEvent)=>(actionSubject, action, text, id, accessLevel)=>{
        const payload = {
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $852mP.UI_EVENT_TYPE),
            attributes: {
                packageName: $39262f9932c4c2bd$var$packageName,
                packageVersion: $39262f9932c4c2bd$var$packageVersion,
                componentName: (0, $caelp.ComponentNames).MENTION,
                accessLevel: accessLevel,
                isSpecial: (0, $caelp.isSpecialMentionText)(text),
                userId: id
            }
        };
        const event = createEvent(payload);
        event.fire((0, $4cczm.ELEMENTS_CHANNEL));
        return event;
    };
const $39262f9932c4c2bd$export$c8b245b690e10169 = (props)=>(actionSubject, action)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = $39262f9932c4c2bd$export$c357a2872628de7c(actionSubject, action);
            props.createAnalyticsEvent(eventPayload).fire((0, $4cczm.ELEMENTS_CHANNEL));
        }
    };
const $39262f9932c4c2bd$export$c357a2872628de7c = (actionSubject, action, attributes)=>{
    const eventPayload = {
        action: action,
        actionSubject: actionSubject,
        eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
        attributes: {
            packageName: $39262f9932c4c2bd$var$packageName,
            packageVersion: $39262f9932c4c2bd$var$packageVersion,
            componentName: (0, $caelp.ComponentNames).MENTION,
            ...attributes
        }
    };
    return eventPayload;
};
const $39262f9932c4c2bd$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: (0, $caelp.ComponentNames).MENTION,
                actionSubjectId: 'hydration',
                attributes: {
                    packageName: $39262f9932c4c2bd$var$packageName,
                    packageVersion: $39262f9932c4c2bd$var$packageVersion,
                    componentName: (0, $caelp.ComponentNames).MENTION,
                    userId: userId,
                    fromCache: fromCache,
                    duration: Math.round(duration)
                },
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $4cczm.ELEMENTS_CHANNEL));
        }
    };
// OLD Analytics
const $39262f9932c4c2bd$var$MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
const $39262f9932c4c2bd$export$34ac71ce24cddec2 = (firePrivateAnalyticsEvent)=>(eventName, text, accessLevel)=>{
        if (firePrivateAnalyticsEvent) firePrivateAnalyticsEvent(`${$39262f9932c4c2bd$var$MENTION_ANALYTICS_PREFIX}.${eventName}`, {
            accessLevel: accessLevel,
            isSpecial: (0, $caelp.isSpecialMentionText)(text)
        });
    };
module.exports["SLI_EVENT_TYPE"] = $39262f9932c4c2bd$export$245097525aef1262;
module.exports["SMART_EVENT_TYPE"] = $39262f9932c4c2bd$export$c724588856bbfbcf;
module.exports["fireAnalyticsMentionTypeaheadEvent"] = $39262f9932c4c2bd$export$a823474ae5cb9e9c;
module.exports["fireAnalyticsMentionEvent"] = $39262f9932c4c2bd$export$44902bc7b3f0b09f;
module.exports["fireSliAnalyticsEvent"] = $39262f9932c4c2bd$export$c8b245b690e10169;
module.exports["fireAnalyticsMentionHydrationEvent"] = $39262f9932c4c2bd$export$91b2fa6a0fe06408;

});

parcelRegister("4cczm", function(module, exports) {
const $577b7b0c5e75a3c1$export$d821aa4c8afb384e = 'fabric-elements';
module.exports["ELEMENTS_CHANNEL"] = $577b7b0c5e75a3c1$export$d821aa4c8afb384e;

});

parcelRegister("lkoJ5", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $kHija = parcelRequire("kHija");


var $fRYCB = parcelRequire("fRYCB");


var $aPdNQ = parcelRequire("aPdNQ");


var $bijHC = parcelRequire("bijHC");


var $mW7G5 = parcelRequire("mW7G5");

const $8b7abe07a19e812f$var$isAgentUserType = (userType)=>userType === 'APP' || userType === 'AGENT';
const $8b7abe07a19e812f$export$c39c34a625f03dcd = ({ mentionInsertDisplayName: mentionInsertDisplayName, mentionProvider: mentionProvider, tr: tr, sanitizePrivateContent: sanitizePrivateContent, suppressInviteXProductUser: suppressInviteXProductUser })=>({ name: name, id: id, userType: userType, nickname: nickname, localId: localId, accessLevel: accessLevel, isXProductUser: isXProductUser })=>{
        const schema = tr.doc.type.schema;
        const trimmedNickname = nickname && nickname.startsWith('@') ? nickname.slice(1) : nickname;
        const renderName = mentionInsertDisplayName || !trimmedNickname ? name : trimmedNickname;
        if (!suppressInviteXProductUser && isXProductUser && mentionProvider?.inviteXProductUser) mentionProvider.inviteXProductUser(id, name);
        // Don't insert into document if document data is sanitized.
        const text = sanitizePrivateContent ? '' : `@${renderName}`;
        if (sanitizePrivateContent && (0, $bijHC.isResolvingMentionProvider)(mentionProvider)) // Cache (locally) for later rendering
        mentionProvider.cacheMentionName(id, renderName);
        const annotationMarksForPos = (0, $fRYCB.getAnnotationMarksForPos)(tr.selection.$head);
        const mentionNode = schema.nodes.mention.createChecked({
            text: text,
            id: id,
            accessLevel: accessLevel,
            userType: userType === 'DEFAULT' ? null : userType,
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            localId: localId ?? (0, (/*@__PURE__*/$parcel$interopDefault($kHija)))()
        }, null, annotationMarksForPos);
        const space = schema.text(' ', annotationMarksForPos);
        return (0, $aPdNQ.Fragment).from([
            mentionNode,
            space
        ]);
    };
const $8b7abe07a19e812f$export$8c4314a90d4c5fc1 = ({ sanitizePrivateContent: sanitizePrivateContent, api: api, mentionInsertDisplayName: mentionInsertDisplayName })=>({ name: name, id: id, userType: userType, localId: localId, nickname: nickname, accessLevel: accessLevel, isXProductUser: isXProductUser })=>{
        return ({ tr: tr })=>{
            const mentionProvider = api?.mention.sharedState.currentState()?.mentionProvider;
            const mentionFragment = $8b7abe07a19e812f$export$c39c34a625f03dcd({
                sanitizePrivateContent: sanitizePrivateContent,
                mentionProvider: mentionProvider,
                mentionInsertDisplayName: mentionInsertDisplayName,
                tr: tr,
                suppressInviteXProductUser: (0, $mW7G5.expVal)('platform_editor_agent_mentions', 'isEnabled', false) && $8b7abe07a19e812f$var$isAgentUserType(userType)
            })({
                name: name,
                id: id,
                userType: userType,
                nickname: nickname,
                localId: localId,
                accessLevel: accessLevel,
                isXProductUser: isXProductUser
            });
            return tr.insert(tr.selection.from, mentionFragment);
        };
    };
module.exports["createSingleMentionFragment"] = $8b7abe07a19e812f$export$c39c34a625f03dcd;
module.exports["insertMention"] = $8b7abe07a19e812f$export$8c4314a90d4c5fc1;

});

parcelRegister("kaZKS", function(module, exports) {

var $jKue6 = parcelRequire("jKue6");


var $8Dx7s = parcelRequire("8Dx7s");


var $mW7G5 = parcelRequire("mW7G5");

const $4b286f207e48092c$var$isSSR = Boolean(undefined);
const $4b286f207e48092c$export$a9cde69b487c37ac = ()=>{
    if ($4b286f207e48092c$var$isSSR) return 0, $jKue6.mention;
    return {
        ...(0, $jKue6.mention),
        toDOM: (node)=>{
            // packages/elements/mention/src/components/Mention/index.tsx
            const mentionAttrs = {
                'aria-busy': 'true',
                contenteditable: 'false',
                'data-access-level': '',
                'data-mention-id': node.attrs.id,
                'data-prosemirror-content-type': 'node',
                'data-prosemirror-node-inline': 'true',
                'data-prosemirror-node-name': 'mention',
                'data-user-type': (0, $mW7G5.expVal)('platform_editor_agent_mentions', 'isEnabled', false) && node.attrs.userType ? node.attrs.userType : undefined,
                style: (0, $8Dx7s.convertToInlineCss)({
                    display: 'inline',
                    border: `1px solid transparent`,
                    background: "var(--ds-background-neutral, #0515240F)",
                    color: "var(--ds-text-subtle, #505258)",
                    borderRadius: '20px',
                    cursor: 'pointer',
                    padding: '0 0.3em 2px 0.23em',
                    wordBreak: 'break-word'
                })
            };
            return [
                'span',
                mentionAttrs,
                node.attrs.text
            ];
        }
    };
};
module.exports["mentionNodeSpec"] = $4b286f207e48092c$export$a9cde69b487c37ac;

});

parcelRegister("3mDyZ", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $1f05b80a177c2fc1$export$617302757e30e37c = new (0, $kCECX.PluginKey)('mentionPlugin');
module.exports["mentionPluginKey"] = $1f05b80a177c2fc1$export$617302757e30e37c;

});

parcelRegister("03fL3", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $kpCD8 = parcelRequire("kpCD8");


var $eFgM7 = parcelRequire("eFgM7");


var $b3nqj = parcelRequire("b3nqj");


var $caelp = parcelRequire("caelp");


var $ixfCV = parcelRequire("ixfCV");


var $fqVYq = parcelRequire("fqVYq");


var $dmd1U = parcelRequire("dmd1U");


var $h7vjz = parcelRequire("h7vjz");


var $bEDoi = parcelRequire("bEDoi");


var $3mDyZ = parcelRequire("3mDyZ");


var $8g3Uw = parcelRequire("8g3Uw");

const $3adf1cb9ffcfeebe$export$92a1a3b7554e9387 = {
    COMMIT_PENDING_TYPED_AGENT_MENTION: 'COMMIT_PENDING_TYPED_AGENT_MENTION',
    DISCARD_PENDING_TYPED_AGENT_MENTION: 'DISCARD_PENDING_TYPED_AGENT_MENTION',
    SET_PENDING_TYPED_AGENT_MENTION: 'SET_PENDING_TYPED_AGENT_MENTION',
    SET_PROVIDER: 'SET_PROVIDER'
};
const $3adf1cb9ffcfeebe$var$AGENT_USER_TYPES = new Set([
    'APP',
    'AGENT'
]);
const $3adf1cb9ffcfeebe$var$isAgentUserType = (userType)=>{
    return typeof userType === 'string' && $3adf1cb9ffcfeebe$var$AGENT_USER_TYPES.has(userType);
};
const $3adf1cb9ffcfeebe$var$getAgentMentionName = (text, fallbackName)=>{
    const trimmedFallbackName = typeof fallbackName === 'string' ? fallbackName.trim() : '';
    const normalizedFallbackName = (trimmedFallbackName.startsWith('@') ? trimmedFallbackName.slice(1).trim() : trimmedFallbackName) || null;
    if (typeof text !== 'string') return normalizedFallbackName;
    const trimmedText = text.trim();
    const displayName = trimmedText.startsWith('@') ? trimmedText.slice(1).trim() : trimmedText;
    const normalizedName = displayName || normalizedFallbackName;
    return normalizedName;
};
const $3adf1cb9ffcfeebe$var$AI_STREAMING_TRANSFORMATION_META_KEY = 'isAIStreamingTransformation';
const $3adf1cb9ffcfeebe$var$AGENT_MENTION_INACTIVITY_MS = 3000;
const $3adf1cb9ffcfeebe$var$MAX_PENDING_TYPED_AGENT_MENTION_FOCUS_DEFERS = 20;
const $3adf1cb9ffcfeebe$var$PACKAGE_NAME = "platform-pkg";
const $3adf1cb9ffcfeebe$var$PACKAGE_VERSION = "0.0.0-use.local";
const $3adf1cb9ffcfeebe$var$setProvider = (provider)=>(state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setMeta((0, $3mDyZ.mentionPluginKey), {
            action: $3adf1cb9ffcfeebe$export$92a1a3b7554e9387.SET_PROVIDER,
            params: {
                provider: provider
            }
        }));
        return true;
    };
/**
 * Returns true when a transaction represents a local user document edit that
 * should restart pending agent-mention inactivity tracking.
 *
 * Remote/collab updates, replace-document transactions, AI streaming transforms,
 * selection-only movements, and metadata-only transactions are intentionally ignored.
 */ const $3adf1cb9ffcfeebe$var$isQualifyingLocalUserDocChange = (tr)=>{
    const isAIStreaming = Boolean(tr.getMeta($3adf1cb9ffcfeebe$var$AI_STREAMING_TRANSFORMATION_META_KEY));
    return tr.docChanged && !tr.getMeta('isRemote') && !tr.getMeta('replaceDocument') && !isAIStreaming;
};
const $3adf1cb9ffcfeebe$var$isLocalSelectionChange = (tr, hasPositionChanged)=>{
    const isAIStreaming = Boolean(tr.getMeta($3adf1cb9ffcfeebe$var$AI_STREAMING_TRANSFORMATION_META_KEY));
    // Pressing Enter can move selection through a doc split without setting tr.selectionSet
    // or changing from/to numerically, so local doc changes are checked against the
    // pending mention's current parent before publishing.
    return (hasPositionChanged || tr.docChanged) && !tr.getMeta('isRemote') && !tr.getMeta('replaceDocument') && !isAIStreaming;
};
/**
 * Reads agent-mention details from a known document position without traversing
 * the document. Callers pass a matcher so mapped positions are only accepted
 * when they still point at the same pending/tracked mention.
 */ const $3adf1cb9ffcfeebe$var$getAgentMentionDetailsAtPos = (state, pos, matchesMention, fallbackName)=>{
    if (pos < 0 || pos > state.doc.content.size) return null;
    const node = state.doc.nodeAt(pos);
    const mentionSchema = state.schema.nodes.mention;
    if (node?.type !== mentionSchema || !$3adf1cb9ffcfeebe$var$isAgentUserType(node.attrs.userType) || !matchesMention(node.attrs) || !node.attrs.id || !node.attrs.localId) return null;
    const $mentionPos = state.doc.resolve(Math.min(pos + node.nodeSize, state.doc.content.size));
    const parentNode = $mentionPos.node($mentionPos.depth);
    const id = node.attrs.id;
    const name = $3adf1cb9ffcfeebe$var$getAgentMentionName(node.attrs.text, fallbackName);
    return {
        id: id,
        localId: node.attrs.localId,
        context: (0, $bEDoi.getAgentMentionParentContext)(parentNode, node.attrs.localId),
        name: name,
        prompt: parentNode.textContent.trim() || null,
        nodeSize: node.nodeSize,
        parentEnd: $mentionPos.end($mentionPos.depth),
        parentNodeType: parentNode.type.name ?? null,
        parentStart: $mentionPos.start($mentionPos.depth),
        pos: pos
    };
};
/**
 * Finds an agent mention that survived a document change when the changed-range
 * scan did not find one. Uses the tracked localId as the mention instance identity
 * so same-agent mentions elsewhere in the document cannot be selected as fallback.
 */ const $3adf1cb9ffcfeebe$var$getSurvivingAgentMentionDetails = (state, preferredLocalId, preferredName)=>{
    const mentionSchema = state.schema.nodes.mention;
    let result = null;
    state.doc.descendants((node, pos)=>{
        if (result) return false;
        if (node.type !== mentionSchema || !$3adf1cb9ffcfeebe$var$isAgentUserType(node.attrs.userType) || node.attrs.localId !== preferredLocalId) return true;
        result = $3adf1cb9ffcfeebe$var$getAgentMentionDetailsAtPos(state, pos, (attrs)=>attrs.localId === preferredLocalId, preferredName);
        return !result;
    });
    return result;
};
/**
 * Maps a pending typed agent mention through a document-changing transaction and
 * returns the updated pending state. If the mapped position was deleted or no
 * longer points at the same local mention, the pending mention is cleared.
 */ const $3adf1cb9ffcfeebe$var$getPendingTypedAgentMentionAfterDocChange = (state, tr, pendingTypedAgentMention, { resetTimer: resetTimer })=>{
    const mappedPos = tr.mapping.mapResult(pendingTypedAgentMention.pos, 1);
    const resetCount = resetTimer ? pendingTypedAgentMention.resetCount + 1 : pendingTypedAgentMention.resetCount;
    if (mappedPos.deleted) return null;
    const pendingMentionDetails = $3adf1cb9ffcfeebe$var$getAgentMentionDetailsAtPos(state, mappedPos.pos, (attrs)=>attrs.localId === pendingTypedAgentMention.localId, pendingTypedAgentMention.name);
    return pendingMentionDetails ? {
        id: pendingMentionDetails.id,
        localId: pendingTypedAgentMention.localId,
        name: pendingMentionDetails.name,
        nodeSize: pendingMentionDetails.nodeSize,
        parentNodeType: pendingMentionDetails.parentNodeType,
        pos: pendingMentionDetails.pos,
        resetCount: resetCount
    } : null;
};
const $3adf1cb9ffcfeebe$var$hasPendingMentionMovedToNewParent = (oldState, tr, previousPendingTypedAgentMention, pendingMentionDetails)=>{
    if (!previousPendingTypedAgentMention) return false;
    const previousMentionDetails = $3adf1cb9ffcfeebe$var$getAgentMentionDetailsAtPos(oldState, previousPendingTypedAgentMention.pos, (attrs)=>attrs.localId === previousPendingTypedAgentMention.localId);
    // Keep the previous parent boundary associated with the left side of an
    // insertion at that boundary, so typing at the start of the parent does not
    // look like the pending mention moved into a new parent.
    const mappedPreviousParentStart = previousMentionDetails && tr.mapping.map(previousMentionDetails.parentStart, -1);
    return Boolean(previousMentionDetails && mappedPreviousParentStart !== pendingMentionDetails.parentStart);
};
const $3adf1cb9ffcfeebe$var$isSelectionOutsideDirectParent = (state, pendingMentionDetails)=>{
    return state.selection.from < pendingMentionDetails.parentStart || state.selection.to > pendingMentionDetails.parentEnd;
};
/**
 * Finalises a pending typed agent mention by copying its details into the
 * public lastInserted* plugin state after the caller has already resolved the
 * pending mention from the current document.
 */ const $3adf1cb9ffcfeebe$var$commitResolvedPendingTypedAgentMention = (pluginState, pendingMentionDetails)=>{
    return {
        hasPublicPluginStateChanged: true,
        pluginState: {
            ...pluginState,
            pendingTypedAgentMention: null,
            lastInsertedAgentMentionId: pendingMentionDetails.id,
            lastInsertedAgentMentionLocalId: pendingMentionDetails.localId,
            lastInsertedAgentMentionContext: pendingMentionDetails.context,
            lastInsertedAgentMentionName: pendingMentionDetails.name,
            lastInsertedAgentMentionPrompt: pendingMentionDetails.prompt,
            lastInsertedAgentMentionParentNodeType: pendingMentionDetails.parentNodeType,
            lastAgentMentionInsertionCount: (pluginState.lastAgentMentionInsertionCount ?? 0) + 1
        }
    };
};
/**
 * Resolves and finalises a pending typed agent mention. If the tracked mention
 * no longer resolves, the stale pending state is cleared without dispatching a
 * public update.
 */ const $3adf1cb9ffcfeebe$var$commitPendingTypedAgentMention = (state, pluginState, pendingTypedAgentMention)=>{
    const pendingMentionDetails = $3adf1cb9ffcfeebe$var$getAgentMentionDetailsAtPos(state, pendingTypedAgentMention.pos, (attrs)=>attrs.localId === pendingTypedAgentMention.localId, pendingTypedAgentMention.name);
    if (!pendingMentionDetails) return {
        hasPublicPluginStateChanged: false,
        pluginState: {
            ...pluginState,
            pendingTypedAgentMention: null
        }
    };
    return $3adf1cb9ffcfeebe$var$commitResolvedPendingTypedAgentMention(pluginState, pendingMentionDetails);
};
const $3adf1cb9ffcfeebe$var$hasTrackedAgentMentionState = (pluginState)=>Boolean(pluginState.pendingTypedAgentMention) || pluginState.lastInsertedAgentMentionId != null || pluginState.lastInsertedAgentMentionLocalId != null || pluginState.lastInsertedAgentMentionContext != null || pluginState.lastInsertedAgentMentionName != null || pluginState.lastInsertedAgentMentionPrompt != null || pluginState.lastInsertedAgentMentionParentNodeType != null;
/**
 * Clears agent mention state that points at a specific document snapshot.
 * replaceDocument swaps content wholesale, so pending typed mentions and
 * lastInserted* details from the previous document must be cleared together.
 */ const $3adf1cb9ffcfeebe$var$clearTrackedAgentMentionState = (pluginState)=>{
    return {
        ...pluginState,
        pendingTypedAgentMention: null,
        lastInsertedAgentMentionId: null,
        lastInsertedAgentMentionLocalId: null,
        lastInsertedAgentMentionContext: null,
        lastInsertedAgentMentionName: null,
        lastInsertedAgentMentionPrompt: null,
        lastInsertedAgentMentionParentNodeType: null
    };
};
function $3adf1cb9ffcfeebe$export$36c073f17660f60f({ pmPluginFactoryParams: pmPluginFactoryParams, fireEvent: fireEvent, options: options, api: api }) {
    let mentionProvider;
    // Injected by Rovo-aware consumers only. Non-Rovo consumers omit this field
    // entirely so this plugin incurs zero bundle cost from rovo-experience-api.
    const getIsRovoPanelOpen = options?.getIsRovoPanelOpen;
    const sendAnalytics = (event, actionSubject, action, attributes)=>{
        if (event === (0, $b3nqj.SLI_EVENT_TYPE) || event === (0, $b3nqj.SMART_EVENT_TYPE)) fireEvent({
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                packageName: $3adf1cb9ffcfeebe$var$PACKAGE_NAME,
                packageVersion: $3adf1cb9ffcfeebe$var$PACKAGE_VERSION,
                componentName: (0, $caelp.ComponentNames).MENTION,
                ...attributes
            }
        }, 'fabricElements');
    };
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $3mDyZ.mentionPluginKey),
        state: {
            init (_, state) {
                const canInsertMention = (0, $8g3Uw.canMentionBeCreatedInRange)(state.selection.from, state.selection.to)(state);
                return {
                    canInsertMention: canInsertMention
                };
            },
            apply (tr, pluginState, oldState, newState) {
                const { action: action, params: params } = tr.getMeta((0, $3mDyZ.mentionPluginKey)) || {
                    action: null,
                    params: null
                };
                let hasPublicPluginStateChanged = false;
                let newPluginState = pluginState;
                const isAgentMentionsExperimentEnabled = (0, $fqVYq.editorExperiment)('platform_editor_agent_mentions', true);
                const hasPositionChanged = oldState.selection.from !== newState.selection.from || oldState.selection.to !== newState.selection.to;
                if (tr.docChanged || tr.selectionSet && hasPositionChanged) {
                    newPluginState = {
                        ...pluginState,
                        canInsertMention: (0, $8g3Uw.canMentionBeCreatedInRange)(newState.selection.from, newState.selection.to)(newState)
                    };
                    hasPublicPluginStateChanged = true;
                }
                switch(action){
                    case $3adf1cb9ffcfeebe$export$92a1a3b7554e9387.COMMIT_PENDING_TYPED_AGENT_MENTION:
                        {
                            const pendingTypedAgentMention = newPluginState.pendingTypedAgentMention;
                            // Ignore stale timer callbacks. The localId and resetCount must still match the
                            // current pending mention so older timers cannot publish after later user edits.
                            if (!isAgentMentionsExperimentEnabled || !pendingTypedAgentMention || pendingTypedAgentMention.localId !== params?.localId || pendingTypedAgentMention.resetCount !== params?.resetCount) break;
                            const commitResult = $3adf1cb9ffcfeebe$var$commitPendingTypedAgentMention(newState, newPluginState, pendingTypedAgentMention);
                            newPluginState = commitResult.pluginState;
                            hasPublicPluginStateChanged = hasPublicPluginStateChanged || commitResult.hasPublicPluginStateChanged;
                            break;
                        }
                    case $3adf1cb9ffcfeebe$export$92a1a3b7554e9387.DISCARD_PENDING_TYPED_AGENT_MENTION:
                        {
                            // Silently discard the pending typed agent mention without committing it.
                            const pendingTypedAgentMentionToDiscard = newPluginState.pendingTypedAgentMention;
                            if (!isAgentMentionsExperimentEnabled || !pendingTypedAgentMentionToDiscard || pendingTypedAgentMentionToDiscard.localId !== params?.localId || pendingTypedAgentMentionToDiscard.resetCount !== params?.resetCount) break;
                            newPluginState = {
                                ...newPluginState,
                                pendingTypedAgentMention: null
                            };
                            hasPublicPluginStateChanged = true;
                            break;
                        }
                    case $3adf1cb9ffcfeebe$export$92a1a3b7554e9387.SET_PROVIDER:
                        newPluginState = {
                            ...newPluginState,
                            mentionProvider: params.provider
                        };
                        hasPublicPluginStateChanged = true;
                        break;
                }
                // When the agent mentions experiment is off, dispatch immediately (original behaviour).
                // When it's on, defer dispatch to after the agent tracking block below so that
                // agent-mention state changes are included in the notification.
                if (hasPublicPluginStateChanged && !isAgentMentionsExperimentEnabled) pmPluginFactoryParams.dispatch((0, $3mDyZ.mentionPluginKey), newPluginState);
                if (options?.handleMentionsChanged && tr.docChanged) {
                    (0, $eFgM7.insm).session?.startFeature('mentionDeletionDetection');
                    const mentionSchema = newState.schema.nodes.mention;
                    const mentionsRemoved = new Map();
                    tr.steps.forEach((step, index)=>{
                        step.getMap().forEach((from, to)=>{
                            const newStart = tr.mapping.slice(index).map(from, -1);
                            const newEnd = tr.mapping.slice(index).map(to);
                            const oldStart = tr.mapping.invert().map(newStart, -1);
                            const oldEnd = tr.mapping.invert().map(newEnd);
                            const oldSlice = oldState.doc.slice(oldStart, oldEnd);
                            const newSlice = newState.doc.slice(newStart, newEnd);
                            const mentionsBefore = new Map();
                            const mentionsAfter = new Map();
                            oldSlice.content.descendants((node)=>{
                                if (node.type.name === mentionSchema.name && node.attrs.localId) mentionsBefore.set(node.attrs.localId, {
                                    id: node.attrs.id,
                                    localId: node.attrs.localId
                                });
                            });
                            newSlice.content.descendants((node)=>{
                                if (node.type.name === mentionSchema.name && node.attrs.localId) mentionsAfter.set(node.attrs.localId, {
                                    id: node.attrs.id,
                                    localId: node.attrs.localId
                                });
                            });
                            // Determine which mentions were removed in this step
                            mentionsBefore.forEach((mention, localId)=>{
                                if (!mentionsAfter.has(localId)) mentionsRemoved.set(localId, mention);
                            });
                            // Adjust mentionsRemoved by removing any that reappear
                            mentionsAfter.forEach((_, localId)=>{
                                if (mentionsRemoved.has(localId)) mentionsRemoved.delete(localId);
                            });
                        });
                    });
                    if (mentionsRemoved.size > 0) {
                        const changes = Array.from(mentionsRemoved.values()).map((mention)=>({
                                id: mention.id,
                                localId: mention.localId,
                                type: 'deleted'
                            }));
                        options.handleMentionsChanged(changes);
                    }
                    (0, $eFgM7.insm).session?.endFeature('mentionDeletionDetection');
                }
                if (isAgentMentionsExperimentEnabled && $3adf1cb9ffcfeebe$var$isQualifyingLocalUserDocChange(tr)) {
                    const mentionSchema = newState.schema.nodes.mention;
                    const newDocRanges = [];
                    const oldDocRanges = [];
                    let stepsTouchMentions = false;
                    tr.steps.forEach((step)=>{
                        let found = false;
                        // Only merge a step's ranges if it actually touched an agent mention,
                        // so unrelated steps (e.g. mark-only changes) don't inflate the scan area.
                        const stepNewRanges = [];
                        const stepOldRanges = [];
                        step.getMap().forEach((oldFrom, oldTo, newFrom, newTo)=>{
                            stepOldRanges.push([
                                oldFrom,
                                oldTo
                            ]);
                            stepNewRanges.push([
                                newFrom,
                                newTo
                            ]);
                            if (!found) {
                                // Clamp positions: delete-only steps can produce newTo > doc.content.size.
                                const clampedNewFrom = Math.min(newFrom, newState.doc.content.size);
                                const clampedNewTo = Math.min(newTo, newState.doc.content.size);
                                if (clampedNewFrom < clampedNewTo) newState.doc.nodesBetween(clampedNewFrom, clampedNewTo, (node)=>{
                                    if (node.type === mentionSchema && $3adf1cb9ffcfeebe$var$isAgentUserType(node.attrs.userType)) found = true;
                                    return !found;
                                });
                                if (!found) {
                                    const clampedOldFrom = Math.min(oldFrom, oldState.doc.content.size);
                                    const clampedOldTo = Math.min(oldTo, oldState.doc.content.size);
                                    if (clampedOldFrom < clampedOldTo) oldState.doc.nodesBetween(clampedOldFrom, clampedOldTo, (node)=>{
                                        if (node.type === mentionSchema && $3adf1cb9ffcfeebe$var$AGENT_USER_TYPES.has(node.attrs.userType)) found = true;
                                        return !found;
                                    });
                                }
                            }
                        });
                        if (found) {
                            stepsTouchMentions = true;
                            newDocRanges.push(...stepNewRanges);
                            oldDocRanges.push(...stepOldRanges);
                        }
                    });
                    const shouldResolveAgentMentionState = stepsTouchMentions || Boolean(newPluginState.lastInsertedAgentMentionLocalId);
                    if (shouldResolveAgentMentionState) {
                        let agentMentionId = null;
                        let agentMentionLocalId = null;
                        let agentMentionContext = null;
                        let agentMentionName = null;
                        let agentMentionPrompt = null;
                        let agentMentionParentNodeType = null;
                        const existingAgentMentionLocalIdsInChangedRanges = new Set();
                        let pendingTypedAgentMentionDetails = null;
                        if (stepsTouchMentions) {
                            for (const [from, to] of newDocRanges){
                                const clampedTo = Math.min(to, newState.doc.content.size);
                                if (from >= clampedTo) continue;
                                newState.doc.nodesBetween(from, clampedTo, (node, pos)=>{
                                    if (node.type !== mentionSchema || !$3adf1cb9ffcfeebe$var$isAgentUserType(node.attrs.userType)) return true;
                                    if (pendingTypedAgentMentionDetails === null && action === $3adf1cb9ffcfeebe$export$92a1a3b7554e9387.SET_PENDING_TYPED_AGENT_MENTION && node.attrs.localId === params?.localId) pendingTypedAgentMentionDetails = $3adf1cb9ffcfeebe$var$getAgentMentionDetailsAtPos(newState, pos, (attrs)=>attrs.localId === params.localId, params.name);
                                    if (agentMentionLocalId === null && node.attrs.localId) {
                                        const agentMentionDetails = $3adf1cb9ffcfeebe$var$getAgentMentionDetailsAtPos(newState, pos, (attrs)=>attrs.localId === node.attrs.localId, params?.name);
                                        if (agentMentionDetails) {
                                            agentMentionId = agentMentionDetails.id;
                                            agentMentionLocalId = agentMentionDetails.localId;
                                            agentMentionContext = agentMentionDetails.context;
                                            agentMentionName = agentMentionDetails.name;
                                            agentMentionPrompt = agentMentionDetails.prompt;
                                            agentMentionParentNodeType = agentMentionDetails.parentNodeType;
                                        }
                                    }
                                    return true;
                                });
                            }
                            for (const [from, to] of oldDocRanges){
                                const clampedOldTo = Math.min(to, oldState.doc.content.size);
                                if (from >= clampedOldTo) continue;
                                oldState.doc.nodesBetween(from, clampedOldTo, (node)=>{
                                    if (node.type !== mentionSchema || !$3adf1cb9ffcfeebe$var$isAgentUserType(node.attrs.userType)) return true;
                                    if (node.attrs.localId) existingAgentMentionLocalIdsInChangedRanges.add(node.attrs.localId);
                                    return true;
                                });
                            }
                        }
                        // When a deletion collapses the new-doc range to a zero-width point, or when
                        // the doc changed but no step covered the tracked mention, the new-doc scan
                        // above finds nothing. Check whether any agent mention survived in the document.
                        let resolvedFromFullDocFallback = false;
                        if (agentMentionId === null && newPluginState.lastInsertedAgentMentionLocalId) {
                            const survivorDetails = $3adf1cb9ffcfeebe$var$getSurvivingAgentMentionDetails(newState, newPluginState.lastInsertedAgentMentionLocalId, newPluginState.lastInsertedAgentMentionName);
                            if (survivorDetails) {
                                agentMentionId = survivorDetails.id;
                                agentMentionLocalId = survivorDetails.localId;
                                agentMentionContext = survivorDetails.context;
                                agentMentionName = survivorDetails.name;
                                agentMentionPrompt = survivorDetails.prompt;
                                agentMentionParentNodeType = survivorDetails.parentNodeType;
                                resolvedFromFullDocFallback = true;
                            }
                        }
                        const trackedAgentMentionLocalId = newPluginState.lastInsertedAgentMentionLocalId ?? null;
                        const changedRangeMentionIsNew = agentMentionLocalId !== null && !existingAgentMentionLocalIdsInChangedRanges.has(agentMentionLocalId);
                        if (agentMentionLocalId !== null && !changedRangeMentionIsNew && agentMentionLocalId !== trackedAgentMentionLocalId) {
                            const survivorDetails = trackedAgentMentionLocalId ? $3adf1cb9ffcfeebe$var$getSurvivingAgentMentionDetails(newState, trackedAgentMentionLocalId, newPluginState.lastInsertedAgentMentionName) : null;
                            if (survivorDetails) {
                                agentMentionId = survivorDetails.id;
                                agentMentionLocalId = survivorDetails.localId;
                                agentMentionContext = survivorDetails.context;
                                agentMentionName = survivorDetails.name;
                                agentMentionParentNodeType = survivorDetails.parentNodeType;
                                resolvedFromFullDocFallback = true;
                            } else {
                                agentMentionId = null;
                                agentMentionLocalId = null;
                                agentMentionContext = null;
                                agentMentionName = null;
                                agentMentionParentNodeType = null;
                            }
                        }
                        const isNewInsertion = agentMentionId !== null && !resolvedFromFullDocFallback && changedRangeMentionIsNew;
                        const isPendingTypedAgentMentionInsertion = isNewInsertion && action === $3adf1cb9ffcfeebe$export$92a1a3b7554e9387.SET_PENDING_TYPED_AGENT_MENTION && typeof params?.localId === 'string';
                        const newInsertionCount = isNewInsertion ? (newPluginState.lastAgentMentionInsertionCount ?? 0) + 1 : undefined;
                        const pendingTypedAgentMentionDetailsForState = pendingTypedAgentMentionDetails;
                        if (isPendingTypedAgentMentionInsertion && pendingTypedAgentMentionDetailsForState) {
                            const pendingTypedAgentMentionLocalId = params?.localId;
                            newPluginState = {
                                ...newPluginState,
                                pendingTypedAgentMention: {
                                    id: pendingTypedAgentMentionDetailsForState.id,
                                    localId: pendingTypedAgentMentionLocalId,
                                    name: pendingTypedAgentMentionDetailsForState.name,
                                    nodeSize: pendingTypedAgentMentionDetailsForState.nodeSize,
                                    parentNodeType: pendingTypedAgentMentionDetailsForState.parentNodeType,
                                    pos: pendingTypedAgentMentionDetailsForState.pos,
                                    resetCount: 1
                                }
                            };
                        } else if (isPendingTypedAgentMentionInsertion) {
                            // Fallback: if the localId-specific scan missed the typed mention,
                            // publish immediately so the insertion is not dropped.
                            newPluginState = {
                                ...newPluginState,
                                pendingTypedAgentMention: null,
                                lastInsertedAgentMentionId: agentMentionId,
                                lastInsertedAgentMentionLocalId: agentMentionLocalId,
                                lastInsertedAgentMentionContext: agentMentionContext,
                                lastInsertedAgentMentionName: agentMentionName,
                                lastInsertedAgentMentionPrompt: agentMentionPrompt,
                                lastInsertedAgentMentionParentNodeType: agentMentionParentNodeType,
                                ...newInsertionCount !== undefined ? {
                                    lastAgentMentionInsertionCount: newInsertionCount
                                } : {}
                            };
                            hasPublicPluginStateChanged = true;
                        } else if (agentMentionId !== (newPluginState.lastInsertedAgentMentionId ?? null) || agentMentionLocalId !== (newPluginState.lastInsertedAgentMentionLocalId ?? null) || agentMentionName !== (newPluginState.lastInsertedAgentMentionName ?? null) || agentMentionPrompt !== (newPluginState.lastInsertedAgentMentionPrompt ?? null) || agentMentionParentNodeType !== (newPluginState.lastInsertedAgentMentionParentNodeType ?? null) || newInsertionCount !== undefined) {
                            // Suppress the nudge for pasted/non-typed agent mentions when Rovo is already
                            // open.
                            const isTaskItemMentionForPaste = agentMentionParentNodeType === 'taskItem';
                            if (!isTaskItemMentionForPaste && isNewInsertion && getIsRovoPanelOpen?.()) ;
                            else {
                                // Not suppressed — update state so the nudge fires normally.
                                newPluginState = {
                                    ...newPluginState,
                                    lastInsertedAgentMentionId: agentMentionId,
                                    lastInsertedAgentMentionLocalId: agentMentionLocalId,
                                    lastInsertedAgentMentionContext: agentMentionContext,
                                    lastInsertedAgentMentionName: agentMentionName,
                                    lastInsertedAgentMentionPrompt: agentMentionPrompt,
                                    lastInsertedAgentMentionParentNodeType: agentMentionParentNodeType,
                                    ...newInsertionCount !== undefined ? {
                                        lastAgentMentionInsertionCount: newInsertionCount
                                    } : {}
                                };
                                hasPublicPluginStateChanged = true;
                            }
                        }
                    }
                }
                if (isAgentMentionsExperimentEnabled && tr.docChanged && tr.getMeta('replaceDocument') && $3adf1cb9ffcfeebe$var$hasTrackedAgentMentionState(newPluginState)) {
                    newPluginState = $3adf1cb9ffcfeebe$var$clearTrackedAgentMentionState(newPluginState);
                    hasPublicPluginStateChanged = true;
                }
                if (isAgentMentionsExperimentEnabled && newPluginState.pendingTypedAgentMention && action !== $3adf1cb9ffcfeebe$export$92a1a3b7554e9387.SET_PENDING_TYPED_AGENT_MENTION && action !== $3adf1cb9ffcfeebe$export$92a1a3b7554e9387.COMMIT_PENDING_TYPED_AGENT_MENTION && tr.docChanged) newPluginState = {
                    ...newPluginState,
                    pendingTypedAgentMention: $3adf1cb9ffcfeebe$var$getPendingTypedAgentMentionAfterDocChange(newState, tr, newPluginState.pendingTypedAgentMention, {
                        resetTimer: $3adf1cb9ffcfeebe$var$isQualifyingLocalUserDocChange(tr)
                    })
                };
                // Typed agent mentions stay pending while the user is still editing around them,
                // but leaving the mention's direct parent means they have moved on from that
                // paragraph/block. Publish immediately in that case instead of waiting for the
                // inactivity timer.
                const shouldCheckPendingTypedAgentMentionParent = $3adf1cb9ffcfeebe$var$isLocalSelectionChange(tr, hasPositionChanged);
                if (isAgentMentionsExperimentEnabled && newPluginState.pendingTypedAgentMention && action !== $3adf1cb9ffcfeebe$export$92a1a3b7554e9387.SET_PENDING_TYPED_AGENT_MENTION && action !== $3adf1cb9ffcfeebe$export$92a1a3b7554e9387.COMMIT_PENDING_TYPED_AGENT_MENTION && shouldCheckPendingTypedAgentMentionParent) {
                    const pendingTypedAgentMention = newPluginState.pendingTypedAgentMention;
                    const pendingMentionDetails = $3adf1cb9ffcfeebe$var$getAgentMentionDetailsAtPos(newState, pendingTypedAgentMention.pos, (attrs)=>attrs.localId === pendingTypedAgentMention.localId, pendingTypedAgentMention.name);
                    if (!pendingMentionDetails) newPluginState = {
                        ...newPluginState,
                        pendingTypedAgentMention: null
                    };
                    else if ($3adf1cb9ffcfeebe$var$hasPendingMentionMovedToNewParent(oldState, tr, pluginState.pendingTypedAgentMention, pendingMentionDetails) || $3adf1cb9ffcfeebe$var$isSelectionOutsideDirectParent(newState, pendingMentionDetails)) {
                        // Suppress the nudge when Rovo chat is already open, mirroring the same
                        // guard used in the inactivity-timer path. Task-item mentions are
                        // exempt because they auto-fire the mini modal and never show a nudge.
                        if (pendingMentionDetails.parentNodeType !== 'taskItem' && getIsRovoPanelOpen?.()) {
                            // Discard without committing so lastInsertedAgentMention* fields are
                            // never set and the downstream nudge listener never fires.
                            newPluginState = {
                                ...newPluginState,
                                pendingTypedAgentMention: null
                            };
                            hasPublicPluginStateChanged = true;
                        } else {
                            const commitResult = $3adf1cb9ffcfeebe$var$commitResolvedPendingTypedAgentMention(newPluginState, pendingMentionDetails);
                            newPluginState = commitResult.pluginState;
                            hasPublicPluginStateChanged = hasPublicPluginStateChanged || commitResult.hasPublicPluginStateChanged;
                        }
                    }
                }
                if (hasPublicPluginStateChanged && isAgentMentionsExperimentEnabled) pmPluginFactoryParams.dispatch((0, $3mDyZ.mentionPluginKey), newPluginState);
                return newPluginState;
            }
        },
        props: {
            nodeViews: {
                mention: (node)=>{
                    return new (0, $dmd1U.MentionNodeView)(node, {
                        options: options,
                        api: api,
                        portalProviderAPI: pmPluginFactoryParams.portalProviderAPI
                    });
                }
            }
        },
        view (editorView) {
            const isAgentMentionsEnabled = (0, $fqVYq.editorExperiment)('platform_editor_agent_mentions', true);
            let pendingTypedAgentMentionTimer;
            let pendingTypedAgentMentionTimerKey = null;
            let pendingTypedAgentMentionFocusDeferCount = 0;
            /**
       * Clears the currently scheduled pending typed-agent-mention timer.
       *
       * By default this also resets the focus defer count because a new pending mention,
       * local edit reset, or cleanup should start a fresh escape-hatch window. Focus-based
       * retries pass `preserveFocusDeferCount` so repeated defers for the same pending
       * mention are counted toward the bounded retry cap.
       */ const clearPendingTypedAgentMentionTimer = ({ preserveFocusDeferCount: preserveFocusDeferCount = false } = {})=>{
                if (pendingTypedAgentMentionTimer) {
                    clearTimeout(pendingTypedAgentMentionTimer);
                    pendingTypedAgentMentionTimer = undefined;
                }
                pendingTypedAgentMentionTimerKey = null;
                if (!preserveFocusDeferCount) pendingTypedAgentMentionFocusDeferCount = 0;
            };
            /**
       * Typed agent mentions intentionally wait before invoking the agent so content the
       * user adds next can become context. That context can be authored through
       * editor-adjacent UI, such as mention typeahead, date picker, or status picker,
       * where focus leaves the ProseMirror editor but remains in the active document.
       * Treat that as continued authoring activity by restarting the inactivity window.
       * This only defers the inactivity timer path: existing selection-change handling can
       * still publish or clear the pending mention sooner. After 20 focus defers (~1 minute),
       * publish anyway so pathological focus states cannot keep the mention pending indefinitely.
       */ const shouldDeferPendingTypedAgentMention = ()=>typeof document !== 'undefined' && document.hasFocus() && !editorView.hasFocus();
            const schedulePendingTypedAgentMentionTimer = (mentionPluginState, { preserveFocusDeferCount: preserveFocusDeferCount = false } = {})=>{
                if (!isAgentMentionsEnabled) {
                    clearPendingTypedAgentMentionTimer();
                    return;
                }
                const pendingTypedAgentMention = mentionPluginState?.pendingTypedAgentMention;
                if (!pendingTypedAgentMention) {
                    clearPendingTypedAgentMentionTimer();
                    return;
                }
                const timerKey = `${pendingTypedAgentMention.localId}:${pendingTypedAgentMention.resetCount}`;
                if (timerKey === pendingTypedAgentMentionTimerKey) return;
                clearPendingTypedAgentMentionTimer({
                    preserveFocusDeferCount: preserveFocusDeferCount
                });
                pendingTypedAgentMentionTimerKey = timerKey;
                pendingTypedAgentMentionTimer = setTimeout(()=>{
                    {
                        // Suppress the agent-mention nudge when the Rovo panel is already open,
                        // but only for non-task-item mentions.
                        const isTaskItemMention = pendingTypedAgentMention.parentNodeType === 'taskItem';
                        if (!isTaskItemMention && getIsRovoPanelOpen?.()) {
                            // Dispatch a discard so pendingTypedAgentMention is nulled out of plugin
                            // state.
                            editorView.dispatch(editorView.state.tr.setMeta((0, $3mDyZ.mentionPluginKey), {
                                action: $3adf1cb9ffcfeebe$export$92a1a3b7554e9387.DISCARD_PENDING_TYPED_AGENT_MENTION,
                                params: {
                                    localId: pendingTypedAgentMention.localId,
                                    resetCount: pendingTypedAgentMention.resetCount
                                }
                            }));
                            return;
                        }
                    }
                    const latestPendingTypedAgentMention = (0, $3mDyZ.mentionPluginKey).getState(editorView.state)?.pendingTypedAgentMention;
                    if (!latestPendingTypedAgentMention || latestPendingTypedAgentMention.localId !== pendingTypedAgentMention.localId || latestPendingTypedAgentMention.resetCount !== pendingTypedAgentMention.resetCount) return;
                    if (shouldDeferPendingTypedAgentMention() && pendingTypedAgentMentionFocusDeferCount < $3adf1cb9ffcfeebe$var$MAX_PENDING_TYPED_AGENT_MENTION_FOCUS_DEFERS) {
                        pendingTypedAgentMentionFocusDeferCount++;
                        pendingTypedAgentMentionTimerKey = null;
                        schedulePendingTypedAgentMentionTimer((0, $3mDyZ.mentionPluginKey).getState(editorView.state), {
                            preserveFocusDeferCount: true
                        });
                        return;
                    }
                    pendingTypedAgentMentionFocusDeferCount = 0;
                    editorView.dispatch(editorView.state.tr.setMeta((0, $3mDyZ.mentionPluginKey), {
                        action: $3adf1cb9ffcfeebe$export$92a1a3b7554e9387.COMMIT_PENDING_TYPED_AGENT_MENTION,
                        params: {
                            localId: pendingTypedAgentMention.localId,
                            resetCount: pendingTypedAgentMention.resetCount
                        }
                    }));
                }, $3adf1cb9ffcfeebe$var$AGENT_MENTION_INACTIVITY_MS);
            };
            const providerHandler = (name, providerPromise)=>{
                switch(name){
                    case 'mentionProvider':
                        if (!providerPromise) {
                            fireEvent({
                                action: (0, $krYZG.ACTION).ERRORED,
                                actionSubject: (0, $krYZG.ACTION_SUBJECT).MENTION,
                                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).MENTION_PROVIDER,
                                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                                attributes: {
                                    reason: (0, $h7vjz.MENTION_PROVIDER_UNDEFINED)
                                }
                            });
                            return $3adf1cb9ffcfeebe$var$setProvider(undefined)(editorView.state, editorView.dispatch);
                        }
                        providerPromise.then((provider)=>{
                            if (mentionProvider) mentionProvider.unsubscribe('mentionPlugin');
                            mentionProvider = provider;
                            $3adf1cb9ffcfeebe$var$setProvider(provider)(editorView.state, editorView.dispatch);
                            provider.subscribe('mentionPlugin', undefined, undefined, undefined, undefined, sendAnalytics);
                        }).catch(()=>{
                            fireEvent({
                                action: (0, $krYZG.ACTION).ERRORED,
                                actionSubject: (0, $krYZG.ACTION_SUBJECT).MENTION,
                                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).MENTION_PROVIDER,
                                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                                attributes: {
                                    reason: (0, $h7vjz.MENTION_PROVIDER_REJECTED)
                                }
                            });
                            return $3adf1cb9ffcfeebe$var$setProvider(undefined)(editorView.state, editorView.dispatch);
                        });
                        break;
                }
                return;
            };
            const providerViaConfig = (0, $ixfCV.fg)('platform_editor_mention_provider_via_plugin_config');
            if (providerViaConfig && options?.mentionProvider) providerHandler('mentionProvider', options?.mentionProvider);
            else pmPluginFactoryParams.providerFactory.subscribe('mentionProvider', providerHandler);
            return {
                update (view, prevState) {
                    const mentionPluginState = (0, $3mDyZ.mentionPluginKey).getState(view.state);
                    if (mentionPluginState === (0, $3mDyZ.mentionPluginKey).getState(prevState)) return;
                    schedulePendingTypedAgentMentionTimer(mentionPluginState);
                },
                destroy () {
                    clearPendingTypedAgentMentionTimer();
                    if (pmPluginFactoryParams.providerFactory) pmPluginFactoryParams.providerFactory.unsubscribe('mentionProvider', providerHandler);
                    if (mentionProvider) mentionProvider.unsubscribe('mentionPlugin');
                }
            };
        }
    });
}
module.exports["ACTIONS"] = $3adf1cb9ffcfeebe$export$92a1a3b7554e9387;
module.exports["createMentionPlugin"] = $3adf1cb9ffcfeebe$export$36c073f17660f60f;

});

parcelRegister("dmd1U", function(module, exports) {

var $8dxef = parcelRequire("8dxef");


var $fngNp = parcelRequire("fngNp");


var $aPdNQ = parcelRequire("aPdNQ");


var $bijHC = parcelRequire("bijHC");

var $caelp = parcelRequire("caelp");





var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");


var $mW7G5 = parcelRequire("mW7G5");


var $4ewm2 = parcelRequire("4ewm2");


var $32HVc = parcelRequire("32HVc");

const $b4da57a29721502b$var$primitiveClassName = 'editor-mention-primitive';
// eslint-disable-next-line require-unicode-regexp
const $b4da57a29721502b$var$AT_PREFIX_REGEX = /^@/;
const $b4da57a29721502b$var$getAccessibilityLabelFromName = (name)=>name.replace($b4da57a29721502b$var$AT_PREFIX_REGEX, '');
// Workaround: AI-rewritten pages may store the raw AAID (e.g. '@712020:uuid') in attrs.text for
// APP/AGENT mentions instead of the display name. Detect this so we can fall through to provider
// resolution. Pattern: '@digits:uuid' — distinct from plain-UUID human AAIDs (no numeric prefix).
const $b4da57a29721502b$var$AAID_MENTION_TEXT_PATTERN = // eslint-disable-next-line require-unicode-regexp
/^@\d+:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/** Returns true if `text` looks like a raw AAID rather than a display name. */ const $b4da57a29721502b$var$isMentionTextAnAaid = (text)=>$b4da57a29721502b$var$AAID_MENTION_TEXT_PATTERN.test(text);
const $b4da57a29721502b$var$isAgentMentionsExperimentEnabled = ()=>(0, $mW7G5.expVal)('platform_editor_agent_mentions', 'isEnabled', false);
/**
 * Returns true if the node is an APP/AGENT mention whose stored text is a raw
 * AAID (e.g. '@712020:uuid') rather than a resolved display name.
 * All AAID-workaround guards should go through this helper so the checks stay
 * consistent and can't drift apart.
 */ const $b4da57a29721502b$var$isAgentAaidText = (node, isAgentMentionsEnabled)=>isAgentMentionsEnabled && (node.attrs.userType === 'APP' || node.attrs.userType === 'AGENT') && !!node.attrs.text && $b4da57a29721502b$var$isMentionTextAnAaid(node.attrs.text);
const $b4da57a29721502b$var$toDOM = (node)=>{
    // packages/elements/mention/src/components/Mention/index.tsx
    let mentionAttrs = {
        contenteditable: 'false',
        'data-access-level': node.attrs.accessLevel,
        'data-mention-id': node.attrs.id,
        'data-prosemirror-content-type': 'node',
        'data-prosemirror-node-inline': 'true',
        'data-prosemirror-node-name': 'mention',
        'data-prosemirror-node-view-type': 'vanilla',
        class: 'mentionView-content-wrap inlineNodeView'
    };
    if ((0, $ixfCV.fg)('platform_editor_adf_with_localid')) mentionAttrs = {
        ...mentionAttrs,
        'data-local-id': node.attrs.localId
    };
    const isAgentMentionsEnabled = $b4da57a29721502b$var$isAgentMentionsExperimentEnabled();
    if (isAgentMentionsEnabled && node.attrs.userType) mentionAttrs = {
        ...mentionAttrs,
        'data-user-type': node.attrs.userType
    };
    const browser = (0, $8dxef.getBrowserInfo)();
    const hasAgentAaidText = $b4da57a29721502b$var$isAgentAaidText(node, isAgentMentionsEnabled);
    return [
        'span',
        mentionAttrs,
        [
            'span',
            {
                class: 'zeroWidthSpaceContainer'
            },
            [
                'span',
                {
                    class: 'inlineNodeViewAddZeroWidthSpace'
                },
                (0, $fngNp.ZERO_WIDTH_SPACE)
            ]
        ],
        [
            'span',
            {
                spellcheck: 'false',
                class: $b4da57a29721502b$var$primitiveClassName
            },
            node.attrs.text && !hasAgentAaidText ? node.attrs.text : "@\u2026"
        ],
        browser.android ? [
            'span',
            {
                class: 'zeroWidthSpaceContainer',
                contenteditable: 'false'
            },
            [
                'span',
                {
                    class: 'inlineNodeViewAddZeroWidthSpace'
                },
                (0, $fngNp.ZERO_WIDTH_SPACE)
            ]
        ] : [
            'span',
            {
                class: 'inlineNodeViewAddZeroWidthSpace'
            },
            (0, $fngNp.ZERO_WIDTH_SPACE)
        ]
    ];
};
const $b4da57a29721502b$var$processName = (name)=>{
    return name.status === (0, $caelp.MentionNameStatus).OK ? `@${name.name || ''}` : `@_|unknown|_`;
};
const $b4da57a29721502b$var$handleProviderName = async (mentionProvider, node, isAgentMentionsEnabled)=>{
    // Also resolve when text is a raw AAID — provider will return the real display name.
    const textIsAaid = $b4da57a29721502b$var$isAgentAaidText(node, isAgentMentionsEnabled);
    if ((0, $bijHC.isResolvingMentionProvider)(mentionProvider) && node.attrs.id && (!node.attrs.text || textIsAaid)) {
        const nameDetail = mentionProvider?.resolveMentionName(node.attrs.id);
        const resolvedNameDetail = await nameDetail;
        return $b4da57a29721502b$var$processName(resolvedNameDetail);
    }
};
const $b4da57a29721502b$var$getNewState = (isHighlighted, isRestricted, isDisabled)=>{
    if (isDisabled) return 'disabled';
    if (isHighlighted) return 'self';
    if (isRestricted) return 'restricted';
    return 'default';
};
class $b4da57a29721502b$export$ed501823ec7e75de {
    setClassList(state, disabledTooltip) {
        this.mentionPrimitiveElement?.classList.toggle('mention-self', state === 'self');
        this.mentionPrimitiveElement?.classList.toggle('mention-restricted', state === 'restricted');
        this.mentionPrimitiveElement?.classList.toggle('mention-disabled', state === 'disabled');
        // Mirror the React `<Mention>` a11y behaviour: when the chip is
        // disabled, expose `aria-disabled` so assistive tech announces it as
        // such. Also surface the tooltip text via `aria-label` so screen-reader
        // users hear *why* the chip is disabled, matching the React `<Mention>`
        // behaviour at `Mention/index.tsx` line 152.
        if (this.domElement) {
            if (state === 'disabled') {
                this.domElement.setAttribute('aria-disabled', 'true');
                if (disabledTooltip) {
                    const text = this.node.attrs.text || '@...';
                    this.domElement.setAttribute('aria-label', `${text} \u{2014} ${disabledTooltip}`);
                }
            } else {
                this.domElement.removeAttribute('aria-disabled');
                this.domElement.removeAttribute('aria-label');
            }
        }
    }
    getDisabledState(mentionProvider) {
        const input = {
            id: this.node.attrs.id,
            userType: this.node.attrs.userType
        };
        return mentionProvider?.getMentionDisabledState?.(input);
    }
    /**
   * Subscribes this NodeView to disabled-state-change notifications on the
   * supplied provider so already-rendered chips can re-evaluate themselves
   * when the consumer's predicate inputs change (e.g. the active agent
   * selection toggling in Rovo Chat). No-op for providers that don't
   * implement `subscribeToDisabledStateChanges`.
   *
   * Idempotent: re-calling with the same provider keeps the existing
   * subscription; passing a different provider tears the old subscription
   * down before attaching the new one. Safe to call from the sharedState
   * `onChange` handler when the editor swaps providers.
   */ subscribeToProviderDisabledStateChanges(mentionProvider) {
        if (this.subscribedProvider === mentionProvider) return;
        this.unsubscribeFromDisabledStateChanges?.();
        this.unsubscribeFromDisabledStateChanges = undefined;
        this.subscribedProvider = mentionProvider;
        if (!mentionProvider?.subscribeToDisabledStateChanges) return;
        this.unsubscribeFromDisabledStateChanges = mentionProvider.subscribeToDisabledStateChanges(()=>{
            this.updateState(this.subscribedProvider);
        });
    }
    syncDisabledTooltip(disabledState) {
        // Capture the tooltip text into a local so the rest of the method can
        // branch on a truthy string instead of re-asserting non-null fields
        // off of `disabledState`.
        const tooltipText = disabledState?.disabled ? disabledState.tooltip : undefined;
        const chip = this.mentionPrimitiveElement;
        const { portalProviderAPI: portalProviderAPI } = this.config;
        if (!chip || !portalProviderAPI) return;
        if (tooltipText) {
            if (!this.disabledTooltip) this.disabledTooltip = (0, $4ewm2.disabledTooltipRenderer)({
                chipElement: chip,
                portalProviderAPI: portalProviderAPI
            });
            this.disabledTooltip.setTooltip(tooltipText);
        } else if (this.disabledTooltip) {
            this.disabledTooltip.destroy();
            this.disabledTooltip = undefined;
        }
    }
    setTextContent(name, isAgentMentionsEnabled) {
        // Also overwrite when text is a raw AAID so the resolved name takes precedence.
        const textIsAaid = $b4da57a29721502b$var$isAgentAaidText(this.node, isAgentMentionsEnabled);
        if (name && (!this.node.attrs.text || textIsAaid) && this.mentionPrimitiveElement) this.mentionPrimitiveElement.textContent = name;
    }
    shouldHighlightMention(mentionProvider) {
        const { currentUserId: currentUserId } = this.config.options ?? {};
        // Check options first (immediate), then provider (async), then default to false
        if (currentUserId && this.node.attrs.id === currentUserId) return true;
        else return mentionProvider?.shouldHighlightMention({
            id: this.node.attrs.id
        }) ?? false;
    }
    async updateState(mentionProvider) {
        const isAgentMentionsEnabled = $b4da57a29721502b$var$isAgentMentionsExperimentEnabled();
        const isHighlighted = (0, $ieeJu.expValEquals)('platform_editor_vc90_transition_mentions', 'isEnabled', true) ? this.shouldHighlightMention(mentionProvider) : mentionProvider?.shouldHighlightMention({
            id: this.node.attrs.id
        }) ?? false;
        const disabledState = this.getDisabledState(mentionProvider);
        const isDisabled = !!disabledState?.disabled;
        const newState = $b4da57a29721502b$var$getNewState(isHighlighted, (0, $caelp.isRestricted)(this.node.attrs.accessLevel), isDisabled);
        const disabledTooltip = disabledState?.disabled ? disabledState.tooltip : undefined;
        // `setClassList` always runs so the aria-label (which depends on the
        // tooltip text) stays in sync when the tooltip reason changes while
        // the chip remains disabled. State-change-only writes would leave a
        // stale aria-label after a tooltip-text-only update.
        this.setClassList(newState, disabledTooltip);
        // Tooltip wiring runs every update (not just on state change) so that
        // the tooltip text stays in sync if the disabled reason changes while
        // the chip is already disabled.
        this.syncDisabledTooltip(disabledState);
        const name = await $b4da57a29721502b$var$handleProviderName(mentionProvider, this.node, isAgentMentionsEnabled);
        this.setTextContent(name, isAgentMentionsEnabled);
        // Only overwrite the disabled-state aria-label with the name-based one
        // when the chip is NOT disabled; otherwise the disabled reason set in
        // `setClassList` would be silently clobbered, regressing a11y.
        if (this.domElement && this.config.options?.profilecardProvider && newState !== 'disabled') {
            const text = name ?? this.node.attrs.text;
            if (text && !$b4da57a29721502b$var$isAgentAaidText(this.node, isAgentMentionsEnabled)) this.domElement.setAttribute('aria-label', $b4da57a29721502b$var$getAccessibilityLabelFromName(text));
        }
    }
    nodeIsEqual(nextNode) {
        if (this.config.options?.sanitizePrivateContent) {
            // Compare nodes but ignore the text parameter as it may be sanitized
            const nextNodeAttrs = {
                ...nextNode.attrs,
                text: this.node.attrs.text
            };
            return this.node.hasMarkup(nextNode.type, nextNodeAttrs, nextNode.marks);
        }
        return this.node.sameMarkup(nextNode);
    }
    update(node) {
        if (!this.nodeIsEqual(node)) return false;
        this.node = node;
        // Keep the profile card renderer's node reference in sync so that the
        // click handler always reads up-to-date attrs.
        this.updateProfileCardNode?.(node);
        return true;
    }
    destroy() {
        // Surface the destruction to the provider before tearing down so the
        // chat layer can react (e.g. drop the agent id from `selectedAgentIds`).
        // This is the lowest-level deletion signal — fires for backspace,
        // select-and-delete, programmatic doc replaces, and editor unmount.
        try {
            this.subscribedProvider?.notifyMentionDestroyed?.({
                id: this.node.attrs.id
            });
        } catch (_error) {
        // Defensive: never let consumer-side notification errors prevent
        // the NodeView from cleaning up its own resources below.
        }
        this.cleanup?.();
        this.destroyProfileCard?.();
        this.disabledTooltip?.destroy();
        this.disabledTooltip = undefined;
        this.unsubscribeFromDisabledStateChanges?.();
        this.unsubscribeFromDisabledStateChanges = undefined;
        this.subscribedProvider = undefined;
    }
    deselectNode() {
        this.removeProfileCard?.();
    }
    constructor(node, config){
        this.dom = void 0;
        this.domElement = void 0;
        this.contentDOM = void 0;
        this.config = void 0;
        this.node = void 0;
        this.cleanup = void 0;
        this.destroyProfileCard = void 0;
        this.removeProfileCard = void 0;
        this.updateProfileCardNode = void 0;
        this.mentionPrimitiveElement = void 0;
        this.disabledTooltip = void 0;
        this.unsubscribeFromDisabledStateChanges = void 0;
        this.subscribedProvider = void 0;
        const { options: options, api: api, portalProviderAPI: portalProviderAPI } = config;
        const { dom: dom, contentDOM: contentDOM } = (0, $aPdNQ.DOMSerializer).renderSpec(document, $b4da57a29721502b$var$toDOM(node));
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.config = config;
        this.node = node;
        this.domElement = dom instanceof HTMLElement ? dom : undefined;
        this.mentionPrimitiveElement = this.domElement ? this.domElement.querySelector(`.${$b4da57a29721502b$var$primitiveClassName}`) ?? undefined : undefined;
        const { mentionProvider: mentionProvider } = api?.mention.sharedState.currentState() ?? {};
        this.updateState(mentionProvider);
        this.subscribeToProviderDisabledStateChanges(mentionProvider);
        this.cleanup = api?.mention.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            this.updateState(nextSharedState?.mentionProvider);
            this.subscribeToProviderDisabledStateChanges(nextSharedState?.mentionProvider);
        });
        const { destroyProfileCard: destroyProfileCard, removeProfileCard: removeProfileCard, updateNode: updateNode } = (0, $32HVc.profileCardRenderer)({
            dom: dom,
            options: options,
            portalProviderAPI: portalProviderAPI,
            node: node,
            api: api
        });
        // Accessibility attributes - based on `packages/people-and-teams/profilecard/src/components/User/ProfileCardTrigger.tsx`
        if (this.domElement && options?.profilecardProvider) {
            const isAgentMentionsEnabled = $b4da57a29721502b$var$isAgentMentionsExperimentEnabled();
            if (node.attrs.text && !$b4da57a29721502b$var$isAgentAaidText(node, isAgentMentionsEnabled)) this.domElement.setAttribute('aria-label', $b4da57a29721502b$var$getAccessibilityLabelFromName(node.attrs.text));
            this.domElement.setAttribute('aria-expanded', 'false');
            this.domElement.setAttribute('role', 'button');
            this.domElement.setAttribute('tabindex', '0');
            this.domElement.setAttribute('aria-haspopup', 'dialog');
        }
        this.destroyProfileCard = destroyProfileCard;
        this.removeProfileCard = removeProfileCard;
        this.updateProfileCardNode = updateNode;
    }
}
module.exports["MentionNodeView"] = $b4da57a29721502b$export$ed501823ec7e75de;

});

parcelRegister("4ewm2", function(module, exports) {
/* disabledTooltipRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $iwjSV = parcelRequire("iwjSV");


var $lpNn5 = parcelRequire("lpNn5");

const $34bc83e8a693fb40$var$styles = {
    hiddenTrigger: "_1e0cglyw"
}; /**
    * ADS `<Tooltip>` hands us a ref via its render-prop child. That ref may be
    * either a callback ref or a mutable ref object — React supports both shapes
    * and ADS's typing keeps both possible. This helper assigns the supplied
    * element to whichever ref shape was provided so the tooltip ends up using
    * the chip's bounding box for positioning and its DOM for trigger events.
    */ 
const $34bc83e8a693fb40$var$assignRef = (ref, element)=>{
    if (typeof ref === 'function') ref(element);
    else if (ref) ref.current = element;
}; /**
    * Names of the React-style trigger-prop handlers we forward from ADS
    * `<Tooltip>` onto the chip element.
    */ 
const $34bc83e8a693fb40$var$TRIGGER_EVENT_MAP = [
    [
        'onMouseOver',
        'mouseover'
    ],
    [
        'onMouseOut',
        'mouseout'
    ],
    [
        'onMouseMove',
        'mousemove'
    ],
    [
        'onMouseDown',
        'mousedown'
    ],
    [
        'onFocus',
        'focusin'
    ],
    [
        'onBlur',
        'focusout'
    ]
]; /**
                                                                                                                                                                                                                                                         * Anchors an ADS `<Tooltip>` to a ProseMirror chip element that is **not** a
                                                                                                                                                                                                                                                         * React child of the tooltip. The chip itself stays in the PM document; this
                                                                                                                                                                                                                                                         * renderer mounts an always-present React subtree via `portalProviderAPI` whose
                                                                                                                                                                                                                                                         * sole job is to host the tooltip and forward the ADS-provided trigger ref +
                                                                                                                                                                                                                                                         * event handlers onto the chip.
                                                                                                                                                                                                                                                         *
                                                                                                                                                                                                                                                         * The forwarding is deliberate: ADS `<Tooltip>` expects to attach its hover /
                                                                                                                                                                                                                                                         * focus / blur listeners to its render-prop child, but our render-prop child
                                                                                                                                                                                                                                                         * is a `display: none` placeholder span that no real event can reach. We bridge
                                                                                                                                                                                                                                                         * those listeners to the chip via `addEventListener` so the tooltip opens and
                                                                                                                                                                                                                                                         * closes in response to the user actually interacting with the chip — keyboard
                                                                                                                                                                                                                                                         * focus, mouse hover, screen-reader focus, the lot.
                                                                                                                                                                                                                                                         */ 
const $34bc83e8a693fb40$var$useBridgedTriggerListeners = (chip, triggerProps)=>{
    (0, $cozmU.useEffect)(()=>{
        // Build the bindAll bindings array out of only the handlers ADS actually
        // supplied. Each React handler is wrapped in a thin adapter so the
        // listener signature matches the native `EventListener` shape; ADS
        // handlers ignore the synthetic-event-only fields they don't use
        // (target, currentTarget), so passing the raw DOM event through
        // `unknown` is safe in practice.
        const bindings = $34bc83e8a693fb40$var$TRIGGER_EVENT_MAP.flatMap(([propName, eventName])=>{
            const handler = triggerProps[propName];
            if (!handler) return [];
            return [
                {
                    type: eventName,
                    listener: (event)=>{
                        handler(event);
                    }
                }
            ];
        });
        if (bindings.length === 0) return;
        const unbind = (0, $cbY7C.bindAll)(chip, bindings);
        return unbind;
    }, [
        chip,
        triggerProps
    ]);
};
const $34bc83e8a693fb40$var$AnchoredTooltip = ({ subscribe: subscribe, getInitialTooltip: getInitialTooltip, referenceElement: referenceElement })=>{
    const [tooltip, setTooltipState] = (0, $cozmU.useState)(getInitialTooltip);
    (0, $cozmU.useEffect)(()=>subscribe(setTooltipState), [
        subscribe
    ]);
    if (!tooltip) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: tooltip,
        position: "top"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34bc83e8a693fb40$var$TriggerBridge, {
            referenceElement: referenceElement,
            tooltipProps: tooltipProps
        }));
}; /**
    * Render-prop child for ADS `<Tooltip>`. The element it returns is a
    * `display: none` placeholder that satisfies the render-prop API; the
    * real trigger surface is the chip in the PM document, which receives
    * both the ADS ref and the bridged event listeners via the side-effects
    * declared on this component.
    */ 
const $34bc83e8a693fb40$var$TriggerBridge = ({ referenceElement: referenceElement, tooltipProps: tooltipProps })=>{
    $34bc83e8a693fb40$var$useBridgedTriggerListeners(referenceElement, tooltipProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        ref: ()=>$34bc83e8a693fb40$var$assignRef(tooltipProps.ref, referenceElement),
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            $34bc83e8a693fb40$var$styles.hiddenTrigger
        ])
    });
};
const $34bc83e8a693fb40$export$7aebbaf65ecffc01 = ({ chipElement: chipElement, portalProviderAPI: portalProviderAPI })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- mirror existing renderer pattern
    const key = (0, (/*@__PURE__*/$parcel$interopDefault($iwjSV)))();
    let currentTooltip;
    const listeners = new Set();
    const broadcast = ()=>{
        listeners.forEach((listener)=>listener(currentTooltip));
    };
    const getInitialTooltip = ()=>currentTooltip;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>{
            listeners.delete(listener);
        };
    };
    const renderElement = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34bc83e8a693fb40$var$AnchoredTooltip, {
            referenceElement: chipElement,
            getInitialTooltip: getInitialTooltip,
            subscribe: subscribe
        });
    portalProviderAPI.render(renderElement, chipElement, key);
    return {
        setTooltip (text) {
            currentTooltip = text;
            broadcast();
        },
        destroy () {
            portalProviderAPI.remove(key);
            listeners.clear();
        }
    };
};
module.exports["disabledTooltipRenderer"] = $34bc83e8a693fb40$export$7aebbaf65ecffc01;

});

parcelRegister("32HVc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $iwjSV = parcelRequire("iwjSV");


var $kCECX = parcelRequire("kCECX");


var $ixfCV = parcelRequire("ixfCV");


var $eW61a = parcelRequire("eW61a");


var $mW7G5 = parcelRequire("mW7G5");


var $kAsd7 = parcelRequire("kAsd7");

const $3c67ecf901edaf58$export$6adf928fbc333163 = ({ dom: dom, options: options, portalProviderAPI: portalProviderAPI, node: node, api: api })=>{
    // Keep a mutable reference to the latest node so the click handler always
    // reads up-to-date attrs
    let currentNode = node;
    let renderingProfileCard = false;
    let navigatingToProfile = false;
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const key = (0, (/*@__PURE__*/$parcel$interopDefault($iwjSV)))();
    let cleanupSelection;
    const removeProfileCard = ()=>{
        if (dom instanceof HTMLElement) dom.setAttribute('aria-expanded', 'false');
        portalProviderAPI.remove(key);
        renderingProfileCard = false;
        cleanupSelection?.();
    };
    const renderProfileCardPopup = (renderProfileCard)=>{
        if (!(dom instanceof HTMLElement) || renderingProfileCard) return;
        const referenceElement = dom;
        referenceElement.setAttribute('aria-expanded', 'true');
        renderingProfileCard = true;
        portalProviderAPI.render(()=>renderProfileCard(referenceElement), referenceElement, key);
        cleanupSelection = api?.selection?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            const selection = nextSharedState?.selection;
            if (selection instanceof (0, $kCECX.NodeSelection) ? (0, $mW7G5.expVal)('platform_editor_reduced_profile_cards', 'isEnabled', false) ? selection.node.sameMarkup(currentNode) : selection.node === node : false) return;
            removeProfileCard?.();
        });
    };
    const renderEditorProfileCard = ()=>{
        const activeMention = (0, $mW7G5.expVal)('platform_editor_reduced_profile_cards', 'isEnabled', false) ? (()=>{
            // Read the display name from the DOM element at click time — this is
            // always up-to-date even when node.attrs.text is absent
            const primitiveText = dom instanceof HTMLElement ? dom.querySelector('.editor-mention-primitive')?.textContent?.trim() : undefined;
            return {
                attrs: {
                    ...currentNode?.attrs,
                    text: currentNode?.attrs?.text || primitiveText || undefined
                }
            };
        })() : {
            attrs: node.attrs
        };
        renderProfileCardPopup((referenceElement)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kAsd7.ProfileCardComponent), {
                activeMention: activeMention,
                profilecardProvider: options?.profilecardProvider,
                dom: referenceElement,
                closeComponent: removeProfileCard
            }));
    };
    const renderUserProfileCard = ({ userId: userId, cloudId: cloudId, renderUserMentionCard: renderUserMentionCard })=>{
        if (!renderUserMentionCard) return false;
        renderProfileCardPopup((referenceElement)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderUserMentionCard({
                userId: userId,
                cloudId: cloudId,
                children: null,
                referenceElement: referenceElement
            })));
        return true;
    };
    const navigateToProfile = (userId, cloudId)=>{
        if (navigatingToProfile) return;
        navigatingToProfile = true;
        const { href: href, target: target } = (0, $eW61a.navigateToTeamsApp)({
            type: 'USER',
            payload: {
                userId: userId
            },
            cloudId: cloudId
        });
        window.open(href, target, 'noopener,noreferrer');
    };
    const renderDefaultProfileCard = (userId, provider)=>{
        if (renderUserProfileCard({
            userId: userId,
            cloudId: provider.cloudId,
            renderUserMentionCard: provider.renderUserMentionCard
        })) return;
        navigateToProfile(userId, provider.cloudId);
    };
    const listenerCleanup = (0, $cbY7C.bind)(dom, {
        type: 'click',
        listener: ()=>{
            if ((0, $ixfCV.fg)('people-teams_migrate-user-profile-card')) {
                const userId = (0, $mW7G5.expVal)('platform_editor_reduced_profile_cards', 'isEnabled', false) ? currentNode.attrs?.id : node.attrs?.id;
                if (!userId) return;
                navigatingToProfile = false;
                options?.profilecardProvider?.then((provider)=>{
                    if (!(0, $mW7G5.expVal)('platform_editor_agent_mentions', 'isEnabled', false)) {
                        renderDefaultProfileCard(userId, provider);
                        return;
                    }
                    if ((0, $kAsd7.isAgentMentionType)((0, $mW7G5.expVal)('platform_editor_reduced_profile_cards', 'isEnabled', false) ? currentNode.attrs?.userType : node.attrs?.userType)) renderEditorProfileCard();
                    else renderDefaultProfileCard(userId, provider);
                });
                return;
            }
            if (options?.profilecardProvider) renderEditorProfileCard();
        }
    });
    return {
        destroyProfileCard: ()=>{
            listenerCleanup();
            removeProfileCard?.();
        },
        removeProfileCard: removeProfileCard,
        updateNode: (nextNode)=>{
            currentNode = nextNode;
        }
    };
};
module.exports["profileCardRenderer"] = $3c67ecf901edaf58$export$6adf928fbc333163;

});

parcelRegister("kAsd7", function(module, exports) {
/* ProfileCardComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $cbY7C = parcelRequire("cbY7C");


var $4wH3g = parcelRequire("4wH3g");


var $cHMfQ = parcelRequire("cHMfQ");


var $ieeJu = parcelRequire("ieeJu");


var $mW7G5 = parcelRequire("mW7G5");


var $gsOTn = parcelRequire("gsOTn");

const $a1a3b105e9a646e0$var$LEADING_AT_SIGN_RE = /^@/;

const $a1a3b105e9a646e0$var$AgentProfileCardResourcedLazy = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "8tR1f",
    name: "AgentProfileCardResourcedLazy",
    loader: ()=>Promise.resolve((parcelRequire("4PAHv"))).then(({ AgentProfileCardResourced: AgentProfileCardResourced })=>AgentProfileCardResourced),
    loading: ()=>null
});
const $a1a3b105e9a646e0$var$styles = {
    loadingStyles: "_2rko12b0 _16qs130s"
};
const $a1a3b105e9a646e0$var$LoadingWrapper = ({ children: children, isLoading: isLoading })=>isLoading ? /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $a1a3b105e9a646e0$var$styles.loadingStyles
        ])
    }, children) : children;
const $a1a3b105e9a646e0$export$eab6bc3eb8597f0 = (userType)=>userType === 'APP' || userType === 'AGENT';
const $a1a3b105e9a646e0$export$2776629671584a76 = ({ id: id, provider: provider })=>{
    const [data, setData] = (0, $cozmU.useState)();
    const [reportingLinesData, setReportingLinesData] = (0, $cozmU.useState)(undefined);
    const [shouldShowGiveKudos, setShouldShowGiveKudos] = (0, $cozmU.useState)(false);
    const [teamCentralBaseUrl, setTeamCentralBaseUrl] = (0, $cozmU.useState)(undefined);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const [hasError, setHasError] = (0, $cozmU.useState)(false); // From: packages/people-and-teams/profilecard/src/components/User/ProfileCardTrigger.tsx
    (0, $cozmU.useEffect)(()=>{
        const fetchData = async ()=>{
            if (!id || !provider) return;
            setIsLoading(true);
            try {
                const [data, reportingLines, shouldGiveKudos, teamCentralBaseUrl] = await Promise.all([
                    provider?.resourceClient.getProfile(provider?.cloudId || '', id, ()=>{}),
                    provider?.resourceClient.getReportingLines(id),
                    provider?.resourceClient.shouldShowGiveKudos(),
                    provider?.resourceClient.getTeamCentralBaseUrl({
                        withOrgContext: true,
                        withSiteContext: true
                    })
                ]);
                setData(data);
                setReportingLinesData(reportingLines);
                setShouldShowGiveKudos(shouldGiveKudos ?? false);
                setTeamCentralBaseUrl(teamCentralBaseUrl);
                setHasError(false);
            } catch  {
                setHasError(true);
            } finally{
                setIsLoading(false);
            }
        };
        fetchData();
    }, [
        id,
        provider
    ]);
    return {
        data: data,
        reportingLinesData: reportingLinesData,
        shouldShowGiveKudos: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        isLoading: isLoading,
        hasError: hasError
    };
};
function $a1a3b105e9a646e0$export$cbc1b955d6cce80d({ profilecardProvider: profilecardProvider, activeMention: activeMention, dom: dom, closeComponent: closeComponent }) {
    const [provider, setProvider] = (0, $cozmU.useState)(undefined);
    (0, $cozmU.useEffect)(()=>{
        profilecardProvider?.then((p)=>{
            setProvider(p);
        });
    }, [
        profilecardProvider
    ]);
    const { id: id, text: text, accessLevel: accessLevel, userType: userType } = activeMention.attrs ?? {};
    (0, $cozmU.useEffect)(()=>{
        return (0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener: (e)=>{
                if (e.key === 'Escape') closeComponent();
            }
        });
    });
    if (!(0, $mW7G5.expVal)('platform_editor_agent_mentions', 'isEnabled', false)) return /*#__PURE__*/ $cozmU.createElement((0, $gsOTn.Popup), {
        referenceElement: dom
    }, /*#__PURE__*/ $cozmU.createElement($a1a3b105e9a646e0$var$UserProfileCardContent, {
        accessLevel: accessLevel,
        id: id,
        provider: provider,
        text: text
    }));
    const isAgentMention = $a1a3b105e9a646e0$export$eab6bc3eb8597f0(userType);
    return /*#__PURE__*/ $cozmU.createElement((0, $gsOTn.Popup), {
        referenceElement: dom
    }, isAgentMention && provider && id ? /*#__PURE__*/ $cozmU.createElement($a1a3b105e9a646e0$var$AgentProfileCardContent, {
        accountId: id,
        provider: provider,
        text: (0, $mW7G5.expVal)('platform_editor_reduced_profile_cards', 'isEnabled', false) ? text : undefined
    }) : /*#__PURE__*/ $cozmU.createElement($a1a3b105e9a646e0$var$UserProfileCardContent, {
        accessLevel: accessLevel,
        id: id,
        provider: provider,
        text: text
    }));
}
const $a1a3b105e9a646e0$var$UserProfileCardContent = ({ accessLevel: accessLevel, id: id, provider: provider, text: text })=>{
    const actions = (0, $cozmU.useMemo)(()=>provider?.getActions(id, text ?? '', accessLevel), [
        accessLevel,
        id,
        provider,
        text
    ]);
    const { data: data, reportingLinesData: reportingLinesData, shouldShowGiveKudos: shouldShowGiveKudos, teamCentralBaseUrl: teamCentralBaseUrl, isLoading: isLoading, hasError: hasError } = $a1a3b105e9a646e0$export$2776629671584a76({
        id: id,
        provider: provider
    });
    return /*#__PURE__*/ $cozmU.createElement($a1a3b105e9a646e0$var$LoadingWrapper, {
        isLoading: isLoading
    }, /*#__PURE__*/ $cozmU.createElement((0, $cHMfQ.ProfileCardLazy), {
        avatarUrl: data?.avatarUrl,
        accountType: data?.accountType,
        status: data?.status,
        statusModifiedDate: data?.statusModifiedDate,
        timestring: data?.timestring,
        isCurrentUser: data?.isCurrentUser,
        isBot: data?.isBot,
        fullName: data?.fullName,
        userId: id,
        cloudId: provider?.cloudId,
        actions: actions,
        isLoading: isLoading,
        location: data?.location,
        companyName: data?.companyName,
        customLozenges: data?.customLozenges,
        nickname: data?.nickname,
        email: data?.email,
        hasError: hasError,
        reportingLines: reportingLinesData,
        isKudosEnabled: shouldShowGiveKudos,
        teamCentralBaseUrl: teamCentralBaseUrl,
        isRenderedInPortal: (0, $ieeJu.expValEquals)('editor_a11y_7152_profile_card_tab_order', 'isEnabled', true)
    }));
};
const $a1a3b105e9a646e0$var$AgentProfileCardContent = ({ accountId: accountId, provider: provider, text: text })=>{
    const agentName = (text ?? '').replace($a1a3b105e9a646e0$var$LEADING_AT_SIGN_RE, '');
    return (0, $mW7G5.expVal)('platform_editor_reduced_profile_cards', 'isEnabled', false) ? /*#__PURE__*/ $cozmU.createElement($a1a3b105e9a646e0$var$AgentProfileCardResourcedLazy, {
        accountId: accountId,
        cloudId: provider.cloudId,
        resourceClient: provider.resourceClient,
        agentName: agentName
    }) : /*#__PURE__*/ $cozmU.createElement($a1a3b105e9a646e0$var$AgentProfileCardResourcedLazy, {
        accountId: accountId,
        cloudId: provider.cloudId,
        resourceClient: provider.resourceClient
    });
};
module.exports["isAgentMentionType"] = $a1a3b105e9a646e0$export$eab6bc3eb8597f0;
module.exports["ProfileCardComponent"] = $a1a3b105e9a646e0$export$cbc1b955d6cce80d;

});

parcelRegister("gsOTn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lQV5m = parcelRequire("lQV5m");


var $cK21K = parcelRequire("cK21K");


var $jp2Q3 = parcelRequire("jp2Q3");


var $mW7G5 = parcelRequire("mW7G5");


var $4TQmh = parcelRequire("4TQmh");

const $7d010c443e804a8e$export$51eddd7655ca235a = ({ children: children, update: update })=>{
    // Ref used here to skip update on first render (when refs haven't been set)
    const isFirstRenderRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update,
        children
    ]);
    return children;
};
/**
 * Hook that attaches a ResizeObserver to the popup container div and calls
 * forceUpdate whenever the popup's size changes. This handles the case where
 * the popup content changes size due to internal state changes (e.g. the agent
 * profile card transitioning from loading → loaded), which cannot be detected
 * via the `children` prop dependency alone.
 */ function $7d010c443e804a8e$var$useResizeAwarePopper({ popupRef: popupRef, forceUpdate: forceUpdate }) {
    const forceUpdateRef = (0, $cozmU.useRef)(forceUpdate);
    (0, $cozmU.useLayoutEffect)(()=>{
        forceUpdateRef.current = forceUpdate;
    }, [
        forceUpdate
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!popupRef || typeof ResizeObserver === 'undefined') return;
        const observer = new ResizeObserver(()=>{
            // forceUpdate is synchronous unlike update() which is debounced.
            // This ensures Popper recalculates position (and flips if needed)
            // immediately when the popup content grows, before the browser repaints.
            if (typeof forceUpdateRef.current === 'function') forceUpdateRef.current();
        });
        observer.observe(popupRef);
        return ()=>observer.disconnect();
    }, [
        popupRef
    ]);
}
function $7d010c443e804a8e$export$129a32eedafa97c5({ referenceElement: referenceElement, children: children }) {
    const [targetRef, setPopupRef] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(null);
    (0, $4TQmh.useFocusTrap)({
        targetRef: targetRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
        zIndex: (0, $jp2Q3.layers).modal()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lQV5m.Popper), {
        referenceElement: referenceElement,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            0,
            8
        ],
        placement: "bottom-end",
        strategy: "fixed",
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        modifiers: (0, $mW7G5.expVal)('platform_editor_agent_mentions', 'isEnabled', false) ? [
            {
                name: 'flip',
                options: {
                    rootBoundary: 'viewport',
                    padding: 5
                }
            },
            {
                name: 'preventOverflow',
                options: {
                    rootBoundary: 'viewport',
                    padding: 5
                }
            }
        ] : []
    }, ({ ref: ref, style: style, update: update, forceUpdate: forceUpdate })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7d010c443e804a8e$var$PopupInner, {
            ref: ref,
            style: style,
            update: update,
            forceUpdate: (0, $mW7G5.expVal)('platform_editor_agent_mentions', 'isEnabled', false) ? forceUpdate : undefined,
            setPopupRef: setPopupRef
        }, children))));
}
const $7d010c443e804a8e$var$PopupInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(({ style: style, update: update, forceUpdate: forceUpdate, setPopupRef: setPopupRef, children: children }, ref)=>{
    const [popupDiv, setPopupDiv] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(null);
    $7d010c443e804a8e$var$useResizeAwarePopper({
        popupRef: popupDiv,
        forceUpdate: forceUpdate
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: (node)=>{
            if (node) {
                if (typeof ref === 'function') ref(node);
                else if (ref) ref.current = node;
                setPopupRef(node);
                setPopupDiv(node);
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7d010c443e804a8e$export$51eddd7655ca235a, {
        update: update
    }, children));
});
module.exports["Popup"] = $7d010c443e804a8e$export$129a32eedafa97c5;

});

parcelRegister("4TQmh", function(module, exports) {
/**
 * Custom hook to add focus trap
 * used for focus trap in ReactionPicker
 * copied from useFocusManager in @atlaskit/popup
 */ 
var $cozmU = parcelRequire("cozmU");


var $dlU1V = parcelRequire("dlU1V");

const $7717b28d9181c793$export$5562a1f223a0d314 = ({ targetRef: targetRef })=>{
    (0, $cozmU.useEffect)(()=>{
        if (!targetRef) return;
        const trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: targetRef,
            fallbackFocus: targetRef,
            returnFocusOnDeactivate: true
        };
        const focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($dlU1V)))(targetRef, trapConfig);
        // wait for the popup to reposition itself before we focus
        let frameId = requestAnimationFrame(()=>{
            frameId = null;
            focusTrap.activate();
        });
        return ()=>{
            if (frameId !== null) {
                cancelAnimationFrame(frameId);
                frameId = null;
            }
            focusTrap.deactivate();
        };
    }, [
        targetRef
    ]);
};
module.exports["useFocusTrap"] = $7717b28d9181c793$export$5562a1f223a0d314;

});

parcelRegister("h7vjz", function(module, exports) {
const $73747af4ce45049c$export$7d0bcf8324b20190 = 'REJECTED';
const $73747af4ce45049c$export$eceeecffdf63fc89 = 'UNDEFINED';
module.exports["MENTION_PROVIDER_REJECTED"] = $73747af4ce45049c$export$7d0bcf8324b20190;
module.exports["MENTION_PROVIDER_UNDEFINED"] = $73747af4ce45049c$export$eceeecffdf63fc89;

});

parcelRegister("bEDoi", function(module, exports) {
const $ff045bcca47777e2$var$PASS_THROUGH_PROMPT_INLINE_NODE_TYPES = new Set([
    'hardBreak',
    'inlineCard',
    'mention',
    'text'
]);
const $ff045bcca47777e2$var$isAgentMention = (node)=>node.type === 'mention' && node.attrs?.userType === 'APP';
const $ff045bcca47777e2$var$isAllowedAgentMention = (node, agentMentionLocalId)=>!$ff045bcca47777e2$var$isAgentMention(node) || node.attrs?.localId === agentMentionLocalId;
const $ff045bcca47777e2$var$getStatusText = (node)=>{
    const text = node.attrs?.text;
    return typeof text === 'string' && text ? text : null;
};
const $ff045bcca47777e2$var$getDateText = (node)=>{
    const timestamp = node.attrs?.timestamp;
    if (typeof timestamp !== 'string' || !timestamp) return null;
    const date = new Date(Number(timestamp));
    if (Number.isNaN(date.getTime())) return null;
    return date.toISOString().slice(0, 10);
};
const $ff045bcca47777e2$var$toPromptInlineNode = (node, agentMentionLocalId)=>{
    if (!$ff045bcca47777e2$var$isAllowedAgentMention(node, agentMentionLocalId)) return null;
    if ($ff045bcca47777e2$var$PASS_THROUGH_PROMPT_INLINE_NODE_TYPES.has(node.type)) return node;
    if (node.type === 'status') {
        const text = $ff045bcca47777e2$var$getStatusText(node);
        return text ? {
            type: 'text',
            text: text
        } : null;
    }
    if (node.type === 'date') {
        const text = $ff045bcca47777e2$var$getDateText(node);
        return text ? {
            type: 'text',
            text: text
        } : null;
    }
    return null;
};
const $ff045bcca47777e2$export$edbd9e89d6e6e22c = (parentNode, agentMentionLocalId)=>{
    const parentAdf = parentNode.toJSON();
    const supportedInlineContent = (parentAdf.content ?? []).flatMap((node)=>{
        const promptNode = $ff045bcca47777e2$var$toPromptInlineNode(node, agentMentionLocalId);
        return promptNode ? [
            promptNode
        ] : [];
    });
    return {
        type: 'doc',
        version: 1,
        content: [
            {
                type: 'paragraph',
                content: supportedInlineContent
            }
        ]
    };
};
module.exports["getAgentMentionParentContext"] = $ff045bcca47777e2$export$edbd9e89d6e6e22c;

});

parcelRegister("8g3Uw", function(module, exports) {

var $bjg0G = parcelRequire("bjg0G");


var $3mDyZ = parcelRequire("3mDyZ");

function $53c3edcc8f17caae$export$1e2b0e72eff65e51(state) {
    return (0, $3mDyZ.mentionPluginKey).getState(state);
}
const $53c3edcc8f17caae$export$bdc4118452fb5868 = (from, to)=>(state)=>{
        const $from = state.doc.resolve(from);
        const $to = state.doc.resolve(to);
        const mention = state.schema.nodes.mention.createChecked();
        if ($from.parent === $to.parent && (0, $bjg0G.canInsert)($from, mention)) return true;
        return false;
    };
module.exports["getMentionPluginState"] = $53c3edcc8f17caae$export$1e2b0e72eff65e51;
module.exports["canMentionBeCreatedInRange"] = $53c3edcc8f17caae$export$bdc4118452fb5868;

});

parcelRegister("4WUlX", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $8nvEM = parcelRequire("8nvEM");

const $5d7c690d3bb032eb$export$42622392b518cf42 = new (0, $kCECX.PluginKey)('mentionPlaceholderPlugin');
const $5d7c690d3bb032eb$export$9db21fd659b6b6c3 = {
    SHOW_PLACEHOLDER: 'SHOW_PLACEHOLDER',
    HIDE_PLACEHOLDER: 'HIDE_PLACEHOLDER'
};
function $5d7c690d3bb032eb$export$a6f49f496e9473d7() {
    return new (0, $kpCD8.SafePlugin)({
        key: $5d7c690d3bb032eb$export$42622392b518cf42,
        state: {
            init: ()=>({}),
            apply (tr, pluginState) {
                const meta = tr.getMeta($5d7c690d3bb032eb$export$42622392b518cf42);
                if (meta?.action === $5d7c690d3bb032eb$export$9db21fd659b6b6c3.SHOW_PLACEHOLDER) return {
                    placeholder: meta.placeholder
                };
                if (meta?.action === $5d7c690d3bb032eb$export$9db21fd659b6b6c3.HIDE_PLACEHOLDER) return {};
                return pluginState;
            }
        },
        props: {
            decorations: (state)=>{
                const pluginState = $5d7c690d3bb032eb$export$42622392b518cf42.getState(state);
                if (pluginState?.placeholder) {
                    const { selection: selection } = state;
                    const span = document.createElement('span');
                    span.textContent = pluginState.placeholder;
                    span.style.setProperty('color', "var(--ds-text-accent-blue, #1558BC)");
                    return (0, $8nvEM.DecorationSet).create(state.doc, [
                        (0, $8nvEM.Decoration).widget(selection.from, span)
                    ]);
                }
                return null;
            }
        }
    });
}
module.exports["mentionPlaceholderPluginKey"] = $5d7c690d3bb032eb$export$42622392b518cf42;
module.exports["MENTION_PLACEHOLDER_ACTIONS"] = $5d7c690d3bb032eb$export$9db21fd659b6b6c3;
module.exports["createMentionPlaceholderPlugin"] = $5d7c690d3bb032eb$export$a6f49f496e9473d7;

});

parcelRegister("95fLA", function(module, exports) {
/* InlineInviteRecaptchaContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $4WUlX = parcelRequire("4WUlX");


var $6vx77 = parcelRequire("6vx77");

const $9fd25c117a8979d3$export$468624c2fd30bc43 = ({ mentionProvider: mentionProvider, api: api })=>{
    const [provider, setProvider] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!mentionProvider) return;
        let isMounted = true;
        mentionProvider.then((resolvedProvider)=>{
            if (!isMounted) return;
            setProvider(resolvedProvider);
        }).catch(()=>{});
        return ()=>{
            isMounted = false;
            setProvider(null);
        };
    }, [
        mentionProvider
    ]);
    const handleSuccess = (0, $cozmU.useCallback)((userId, email)=>{
        if (!api?.mention?.commands?.insertMention || !api?.core?.actions?.execute) return;
        const name = email.split('@')[0] || email;
        api.core.actions.execute(api.mention.commands.insertMention({
            id: userId,
            name: name,
            userType: 'DEFAULT',
            accessLevel: 'CONTAINER'
        }));
        api.core.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $4WUlX.mentionPlaceholderPluginKey), {
                action: (0, $4WUlX.MENTION_PLACEHOLDER_ACTIONS).HIDE_PLACEHOLDER
            });
            return tr;
        });
    }, [
        api
    ]);
    const handleClose = (0, $cozmU.useCallback)(()=>{
        if (!api?.core?.actions?.execute) return;
        api.core.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $4WUlX.mentionPlaceholderPluginKey), {
                action: (0, $4WUlX.MENTION_PLACEHOLDER_ACTIONS).HIDE_PLACEHOLDER
            });
            return tr;
        });
    }, [
        api
    ]);
    const handleReady = (0, $cozmU.useCallback)((showRecaptcha)=>{
        if (provider) {
            if (showRecaptcha) provider.showInlineInviteRecaptcha = showRecaptcha;
            else delete provider.showInlineInviteRecaptcha;
        }
    }, [
        provider
    ]);
    if (!provider?.InlineInviteRecaptcha || !api?.mention?.commands?.insertMention || !api?.core?.actions?.execute) return null;
    const RecaptchaComponent = provider.InlineInviteRecaptcha;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RecaptchaComponent, {
        analyticsSource: (0, $6vx77.MENTION_SOURCE),
        onSuccess: handleSuccess,
        onClose: handleClose,
        onReady: handleReady
    });
};
module.exports["InlineInviteRecaptchaContainer"] = $9fd25c117a8979d3$export$468624c2fd30bc43;

});

parcelRegister("6vx77", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $caelp = parcelRequire("caelp");


var $iqYqm = parcelRequire("iqYqm");

const $3c763a8883b2eeda$var$componentName = 'mention';
const $3c763a8883b2eeda$export$867a43da6e470584 = 'mentionInEditor';
const $3c763a8883b2eeda$var$emptyQueryResponse = {
    queryLength: 0,
    spaceInQuery: false
};
const $3c763a8883b2eeda$var$extractAttributesFromQuery = (query)=>{
    if (query) return {
        queryLength: query.length,
        spaceInQuery: query.indexOf(' ') !== -1
    };
    return $3c763a8883b2eeda$var$emptyQueryResponse;
};
const $3c763a8883b2eeda$export$e1d5d51810b7e165 = (duration, upKeyCount, downKeyCount, sessionId, query)=>{
    const { queryLength: queryLength, spaceInQuery: spaceInQuery } = $3c763a8883b2eeda$var$extractAttributesFromQuery(query);
    return {
        action: (0, $krYZG.ACTION).CANCELLED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).MENTION_TYPEAHEAD,
        eventType: (0, $krYZG.EVENT_TYPE).UI,
        attributes: {
            componentName: $3c763a8883b2eeda$var$componentName,
            duration: duration,
            queryLength: queryLength,
            spaceInQuery: spaceInQuery,
            upKeyCount: upKeyCount,
            downKeyCount: downKeyCount,
            sessionId: sessionId
        }
    };
};
const $3c763a8883b2eeda$var$getPosition = (mentionList, selectedMention)=>{
    if (mentionList) {
        const index = mentionList.findIndex((mention)=>mention.id === selectedMention.id);
        return index === -1 ? undefined : index;
    }
    return;
};
const $3c763a8883b2eeda$var$isClicked = (insertType)=>insertType === 'selected';
const $3c763a8883b2eeda$export$c102b710f5c857c4 = (sessionId, contextIdentifierProvider, userRole, additionalAttributes)=>{
    const { containerId: containerId, objectId: objectId, childObjectId: childObjectId } = contextIdentifierProvider || {};
    return {
        action: (0, $krYZG.ACTION).RENDERED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).INVITE_ITEM,
        eventType: (0, $krYZG.EVENT_TYPE).UI,
        attributes: {
            componentName: $3c763a8883b2eeda$var$componentName,
            containerId: containerId,
            objectId: objectId,
            childObjectId: childObjectId,
            userRole: userRole,
            sessionId: sessionId,
            source: $3c763a8883b2eeda$export$867a43da6e470584,
            ...additionalAttributes
        }
    };
};
const $3c763a8883b2eeda$export$e4c4d872dcfe2b15 = (duration, upKeyCount, downKeyCount, sessionId, insertType, query, contextIdentifierProvider, userRole, additionalAttributes)=>{
    const { queryLength: queryLength, spaceInQuery: spaceInQuery } = $3c763a8883b2eeda$var$extractAttributesFromQuery(query);
    const { containerId: containerId, objectId: objectId, childObjectId: childObjectId } = contextIdentifierProvider || {};
    return {
        action: $3c763a8883b2eeda$var$isClicked(insertType) ? (0, $krYZG.ACTION).CLICKED : (0, $krYZG.ACTION).PRESSED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).INVITE_ITEM,
        eventType: (0, $krYZG.EVENT_TYPE).UI,
        attributes: {
            componentName: $3c763a8883b2eeda$var$componentName,
            duration: duration,
            queryLength: queryLength,
            spaceInQuery: spaceInQuery,
            upKeyCount: upKeyCount,
            downKeyCount: downKeyCount,
            containerId: containerId,
            objectId: objectId,
            childObjectId: childObjectId,
            userRole: userRole,
            sessionId: sessionId,
            keyboardKey: $3c763a8883b2eeda$var$isClicked(insertType) ? undefined : insertType,
            ...additionalAttributes
        }
    };
};
const $3c763a8883b2eeda$export$84030a552533cdf8 = (duration, upKeyCount, downKeyCount, sessionId, insertType, mention, mentionLocalId, mentionList, query, contextIdentifierProvider, taskListId, taskItemId, isAgent)=>{
    const { queryLength: queryLength, spaceInQuery: spaceInQuery } = $3c763a8883b2eeda$var$extractAttributesFromQuery(query);
    let containerId;
    let objectId;
    let childObjectId;
    if (contextIdentifierProvider) {
        containerId = contextIdentifierProvider.containerId || undefined;
        objectId = contextIdentifierProvider.objectId || undefined;
        childObjectId = contextIdentifierProvider.childObjectId || undefined;
    }
    return {
        action: $3c763a8883b2eeda$var$isClicked(insertType) ? (0, $krYZG.ACTION).CLICKED : (0, $krYZG.ACTION).PRESSED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).MENTION_TYPEAHEAD,
        eventType: (0, $krYZG.EVENT_TYPE).UI,
        containerId: containerId,
        objectId: objectId,
        childObjectId: childObjectId,
        attributes: {
            sessionId: sessionId,
            duration: duration,
            position: $3c763a8883b2eeda$var$getPosition(mentionList, mention),
            keyboardKey: $3c763a8883b2eeda$var$isClicked(insertType) ? undefined : insertType,
            source: mention.source,
            queryLength: queryLength,
            spaceInQuery: spaceInQuery,
            isSpecial: (0, $caelp.isSpecialMention)(mention),
            accessLevel: mention.accessLevel || '',
            userType: mention.userType,
            userId: mention.id,
            upKeyCount: upKeyCount,
            downKeyCount: downKeyCount,
            memberCount: (0, $iqYqm.isTeamType)(mention.userType) && mention.context ? mention.context.memberCount : null,
            includesYou: (0, $iqYqm.isTeamType)(mention.userType) && mention.context ? mention.context.includesYou : null,
            ...isAgent ? {
                isAgent: isAgent
            } : {},
            taskListId: taskListId,
            taskItemId: taskItemId,
            localId: mentionLocalId,
            containerId: containerId,
            objectId: objectId,
            childObjectId: childObjectId
        }
    };
};
const $3c763a8883b2eeda$export$901fb6651fc13b0e = (duration, userIds, query, teams, xProductMentionsLength)=>{
    const { queryLength: queryLength, spaceInQuery: spaceInQuery } = $3c763a8883b2eeda$var$extractAttributesFromQuery(query);
    const actionSubject = userIds ? (0, $krYZG.ACTION_SUBJECT).MENTION_TYPEAHEAD : (0, $krYZG.ACTION_SUBJECT).TEAM_MENTION_TYPEAHEAD;
    return {
        action: (0, $krYZG.ACTION).RENDERED,
        actionSubject: actionSubject,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            componentName: $3c763a8883b2eeda$var$componentName,
            duration: duration,
            userIds: userIds,
            teams: teams,
            queryLength: queryLength,
            spaceInQuery: spaceInQuery,
            xProductMentionsLength: xProductMentionsLength
        }
    };
};
module.exports["MENTION_SOURCE"] = $3c763a8883b2eeda$export$867a43da6e470584;
module.exports["buildTypeAheadCancelPayload"] = $3c763a8883b2eeda$export$e1d5d51810b7e165;
module.exports["buildTypeAheadInviteItemViewedPayload"] = $3c763a8883b2eeda$export$c102b710f5c857c4;
module.exports["buildTypeAheadInviteItemClickedPayload"] = $3c763a8883b2eeda$export$e4c4d872dcfe2b15;
module.exports["buildTypeAheadInsertedPayload"] = $3c763a8883b2eeda$export$84030a552533cdf8;
module.exports["buildTypeAheadRenderedPayload"] = $3c763a8883b2eeda$export$901fb6651fc13b0e;

});

parcelRegister("iqYqm", function(module, exports) {

var $3huzY = parcelRequire("3huzY");

// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $4f67756a83abfeaf$var$SUFFIX_WITH_EXTRA_WORDS_REGEX = /\s[^\s]+\s/;
const $4f67756a83abfeaf$export$6ddb6ef001273170 = (userType)=>userType === 'TEAM';
const $4f67756a83abfeaf$export$c427182c53a1ba5 = (stat)=>stat && !isNaN(stat.teamMentionDuration);
const $4f67756a83abfeaf$export$f5a334b5a28d1e01 = (mention)=>mention && mention.id === (0, $3huzY.INVITE_ITEM_DESCRIPTION).id;
const $4f67756a83abfeaf$export$16a134d4e1b461dc = (query, firstQueryWithoutResults)=>{
    if (!firstQueryWithoutResults) return true;
    const lastIndexWithResults = firstQueryWithoutResults.length - 1;
    let suffix = query.slice(lastIndexWithResults);
    if (query[lastIndexWithResults - 1] === ' ') suffix = ' ' + suffix;
    const depletedExtraWords = $4f67756a83abfeaf$var$SUFFIX_WITH_EXTRA_WORDS_REGEX.test(suffix);
    return !depletedExtraWords;
};
module.exports["isTeamType"] = $4f67756a83abfeaf$export$6ddb6ef001273170;
module.exports["isTeamStats"] = $4f67756a83abfeaf$export$c427182c53a1ba5;
module.exports["isInviteItem"] = $4f67756a83abfeaf$export$f5a334b5a28d1e01;
module.exports["shouldKeepInviteItem"] = $4f67756a83abfeaf$export$16a134d4e1b461dc;

});

parcelRegister("3huzY", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $725R2 = parcelRequire("725R2");


var $gFEZF = parcelRequire("gFEZF");

const $9e72da09049bbe6e$var$mentionItemStyle = null;
const $9e72da09049bbe6e$var$mentionItemSelectedStyle = null;
const $9e72da09049bbe6e$var$rowStyle = null;
const $9e72da09049bbe6e$var$avatarStyle = null;
const $9e72da09049bbe6e$var$nameSectionStyle = null;
const $9e72da09049bbe6e$var$capitalizedStyle = null;
const $9e72da09049bbe6e$export$75621ed4176efc9e = {
    id: 'invite-teammate'
}; // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9e72da09049bbe6e$var$leftClick = (event)=>{
    return event.button === 0 && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey;
};
const $9e72da09049bbe6e$var$InviteItem = ({ productName: productName, onMount: onMount, onMouseEnter: onMouseEnter, onSelection: onSelection, selected: selected, userRole: userRole, intl: intl })=>{
    const onSelected = (0, $cozmU.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        if (onSelection) {
            // For mouse events, only handle left click
            if ('button' in event && !$9e72da09049bbe6e$var$leftClick(event)) return;
             // For keyboard events, only handle Enter and Space
            if ('key' in event && event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            onSelection($9e72da09049bbe6e$export$75621ed4176efc9e, event);
        }
    }, [
        onSelection
    ]);
    const onItemMouseEnter = (0, $cozmU.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        if (onMouseEnter) onMouseEnter($9e72da09049bbe6e$export$75621ed4176efc9e, event);
    }, [
        onMouseEnter
    ]);
    const onItemFocus = (0, $cozmU.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        if (onMouseEnter) onMouseEnter($9e72da09049bbe6e$export$75621ed4176efc9e, event);
    }, [
        onMouseEnter
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (onMount) onMount();
    }, [
        onMount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "button",
        tabIndex: 0,
        onMouseDown: onSelected,
        onKeyDown: onSelected,
        onMouseEnter: onItemMouseEnter,
        onFocus: onItemFocus,
        "data-id": $9e72da09049bbe6e$export$75621ed4176efc9e.id,
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _bfhk1j28 _1e0c1ule _2mzuglyw _80omtlke",
            selected && "_bfhk1dpa"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _2lx2vrvc _1n261g80 _ca0q12x7 _n3td12x7 _19bvdlk8 _u5f3dlk8 _1bto1l2s _s7n4nkob"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _4cvr1h6o _1bah1h6o _kqswh2mm _1bsb14no _4t3i14no"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
        label: intl.formatMessage((0, $725R2.mentionMessages).mentionsAddLabel),
        color: "var(--ds-icon-subtle, #505258)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "name-section",
        className: (0, $hekY6.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _18u0dlk8 _syazazsu"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage // Ignored via go/ees005
    ), {
        ...(0, $725R2.mentionMessages).inviteItemTitle,
        values: {
            userRole: userRole || 'basic',
            productName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                "data-testid": "capitalized-message",
                className: (0, $hekY6.default)([
                    "_1p1d1dk0"
                ])
            }, productName)
        }
    }))));
};
// eslint-disable-next-line @typescript-eslint/ban-types
const $9e72da09049bbe6e$var$_default_1 = (0, $kSwu1.injectIntl)($9e72da09049bbe6e$var$InviteItem);
var $9e72da09049bbe6e$export$2e2bcd8739ae039 = $9e72da09049bbe6e$var$_default_1;
module.exports["INVITE_ITEM_DESCRIPTION"] = $9e72da09049bbe6e$export$75621ed4176efc9e;
module.exports["default"] = $9e72da09049bbe6e$export$2e2bcd8739ae039;

});

parcelRegister("3njTd", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $3k5Tv = parcelRequire("3k5Tv");


var $9VsR6 = parcelRequire("9VsR6");

const $d9ba2a3fc2614da9$var$selector = (states)=>{
    return {
        mentionProvider: states.mentionState?.mentionProvider
    };
};
function $d9ba2a3fc2614da9$export$124ea4367cf7d1fc({ editorView: editorView, api: api, typeAhead: typeAhead, disabled: disabled }) {
    const { mentionProvider: mentionProvider } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'mention'
    ], $d9ba2a3fc2614da9$var$selector);
    const openMentionTypeAhead = (0, $cozmU.useCallback)(()=>{
        api?.typeAhead?.actions?.open({
            triggerHandler: typeAhead,
            inputMethod: (0, $krYZG.INPUT_METHOD).INSERT_MENU
        });
    }, [
        api,
        typeAhead
    ]);
    return !mentionProvider ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9VsR6.default), {
        editorView: editorView,
        onInsertMention: openMentionTypeAhead,
        isDisabled: disabled || api?.typeAhead?.actions.isAllowed(editorView.state)
    });
}
module.exports["SecondaryToolbarComponent"] = $d9ba2a3fc2614da9$export$124ea4367cf7d1fc;

});

parcelRegister("9VsR6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $725R2 = parcelRequire("725R2");


var $aiL0G = parcelRequire("aiL0G");

var $ldbHR = parcelRequire("ldbHR");


var $hMv2K = parcelRequire("hMv2K");

// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $b8b4c00b66e41763$var$ToolbarMention extends (0, $cozmU.PureComponent) {
    render() {
        const mentionStringTranslated = this.props.intl.formatMessage((0, $725R2.mentionMessages).mentionsIconLabel);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldbHR.default), {
            testId: this.props.testId,
            buttonId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).MENTION,
            spacing: "none",
            onClick: this.handleInsertMention,
            disabled: this.props.isDisabled,
            title: mentionStringTranslated + '@',
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMv2K))), {
                label: mentionStringTranslated
            })
        });
    }
    constructor(...args){
        super(...args);
        this.handleInsertMention = ()=>{
            if (!this.props.editorView) return false;
            this.props.onInsertMention();
            return true;
        };
    }
}
// eslint-disable-next-line @typescript-eslint/ban-types
const $b8b4c00b66e41763$var$_default_1 = (0, $kSwu1.injectIntl)($b8b4c00b66e41763$var$ToolbarMention);
var $b8b4c00b66e41763$export$2e2bcd8739ae039 = $b8b4c00b66e41763$var$_default_1;
module.exports["default"] = $b8b4c00b66e41763$export$2e2bcd8739ae039;

});

parcelRegister("6tSFE", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kHija = parcelRequire("kHija");


var $725R2 = parcelRequire("725R2");


var $efqK4 = parcelRequire("efqK4");


var $aPdNQ = parcelRequire("aPdNQ");


var $bjg0G = parcelRequire("bjg0G");


var $9KSWX = parcelRequire("9KSWX");


var $6svtM = parcelRequire("6svtM");

var $doJuV = parcelRequire("doJuV");


var $bijHC = parcelRequire("bijHC");


var $ixfCV = parcelRequire("ixfCV");


var $fqVYq = parcelRequire("fqVYq");


var $mW7G5 = parcelRequire("mW7G5");


var $lkoJ5 = parcelRequire("lkoJ5");


var $3mDyZ = parcelRequire("3mDyZ");


var $03fL3 = parcelRequire("03fL3");


var $4WUlX = parcelRequire("4WUlX");


var $8g3Uw = parcelRequire("8g3Uw");


var $3huzY = parcelRequire("3huzY");


var $9PCgk = parcelRequire("9PCgk");


var $6vx77 = parcelRequire("6vx77");


var $iqYqm = parcelRequire("iqYqm");

const $7944f58fade65870$var$isAgentUserType = (userType)=>userType === 'APP' || userType === 'AGENT';
const $7944f58fade65870$var$isAgentMention = (mention)=>$7944f58fade65870$var$isAgentUserType(mention.userType) || mention.appType === 'agent';
const $7944f58fade65870$var$isAgentTypeAheadItem = (item)=>item.mention ? $7944f58fade65870$var$isAgentMention(item.mention) : false;
const $7944f58fade65870$var$createInviteItem = ({ mentionProvider: mentionProvider, onInviteItemMount: onInviteItemMount, query: query, emailDomain: emailDomain })=>({
        title: (0, $3huzY.INVITE_ITEM_DESCRIPTION).id,
        render: ({ isSelected: isSelected, onClick: onClick, onHover: onHover })=>emailDomain && mentionProvider.getShouldEnableInlineInvite?.() && (0, $ixfCV.fg)('jira_invites_auto_tag_new_user_in_mentions_fg') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9PCgk.default), {
                productName: mentionProvider ? mentionProvider.productName : undefined,
                selected: isSelected,
                onMount: onInviteItemMount,
                onMouseEnter: onHover,
                onSelection: onClick,
                userRole: mentionProvider.userRole,
                query: query,
                emailDomain: emailDomain
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3huzY.default), {
                productName: mentionProvider ? mentionProvider.productName : undefined,
                selected: isSelected,
                onMount: onInviteItemMount,
                onMouseEnter: onHover,
                onSelection: onClick,
                userRole: mentionProvider.userRole
            }),
        mention: (0, $3huzY.INVITE_ITEM_DESCRIPTION)
    });
const $7944f58fade65870$var$withInviteItem = ({ mentionProvider: mentionProvider, firstQueryWithoutResults: firstQueryWithoutResults, currentQuery: currentQuery, onInviteItemMount: onInviteItemMount, emailDomain: emailDomain })=>(mentionItems)=>{
        const inviteItem = $7944f58fade65870$var$createInviteItem({
            mentionProvider: mentionProvider,
            onInviteItemMount: onInviteItemMount,
            query: currentQuery,
            emailDomain: emailDomain
        });
        const keepInviteItem = (0, $iqYqm.shouldKeepInviteItem)(currentQuery, firstQueryWithoutResults);
        if (mentionItems.length === 0) return keepInviteItem ? [
            inviteItem
        ] : [];
        return [
            ...mentionItems,
            // invite item should be shown at the bottom
            inviteItem
        ];
    };
const $7944f58fade65870$var$makeMentionToTypeaheadItem = (useRefreshedItemHeight)=>(mention)=>{
        const itemHeight = useRefreshedItemHeight ? (0, $6svtM.MENTION_ITEM_HEIGHT_REFRESHED) : (0, $6svtM.MENTION_ITEM_HEIGHT);
        return {
            title: mention.id,
            render: ({ isSelected: isSelected, onClick: onClick, onHover: onHover })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $doJuV.default), {
                    mention: mention,
                    selected: isSelected,
                    onMouseEnter: onHover,
                    onSelection: onClick,
                    height: itemHeight
                }),
            getCustomComponentHeight: ()=>{
                return itemHeight;
            },
            mention: mention
        };
    };
const $7944f58fade65870$export$f476360102d72b2 = (mention)=>$7944f58fade65870$var$makeMentionToTypeaheadItem((0, $mW7G5.expVal)('platform_editor_agent_mentions', 'isEnabled', false))(mention);
function $7944f58fade65870$export$fc10aeed3a532e2a(fn) {
    // Cache results here
    const seen = new Map();
    function memoized(mention) {
        // Check cache for hits
        const hit = seen.get(mention.id);
        if (hit) return hit;
        // Generate new result and cache it
        const result = fn(mention);
        seen.set(mention.id, result);
        return result;
    }
    return {
        call: memoized,
        clear: seen.clear.bind(seen)
    };
}
const $7944f58fade65870$var$buildAndSendElementsTypeAheadAnalytics = (fireEvent)=>({ query: query, mentions: mentions, stats: stats })=>{
        let duration = 0;
        let userOrTeamIds = null;
        let teams = null;
        let xProductMentionsLength = 0;
        if (!(0, $iqYqm.isTeamStats)(stats)) {
            // is from primary mention endpoint which could be just user mentions or user/team mentions
            duration = stats && stats.duration;
            teams = null;
            userOrTeamIds = mentions.map((mention)=>mention.id);
            xProductMentionsLength = mentions.filter((mention)=>mention.isXProductUser).length;
        } else {
            // is from dedicated team-only mention endpoint
            duration = stats && stats.teamMentionDuration;
            userOrTeamIds = null;
            teams = mentions.map((mention)=>(0, $iqYqm.isTeamType)(mention.userType) ? {
                    teamId: mention.id,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    includesYou: mention.context.includesYou,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    memberCount: mention.context.memberCount
                } : null).filter((m)=>!!m);
        }
        const payload = (0, $6vx77.buildTypeAheadRenderedPayload)(duration, userOrTeamIds, query, teams, xProductMentionsLength);
        fireEvent(payload, 'fabric-elements');
    };
/**
 * When a team mention is selected, we render a team link and list of member/user mentions
 * in editor content
 */ const $7944f58fade65870$var$buildNodesForTeamMention = (schema, selectedMention, mentionProvider, sanitizePrivateContent)=>{
    const { nodes: nodes, marks: marks } = schema;
    const { name: name, id: teamId, accessLevel: accessLevel, context: context } = selectedMention;
    // build team link
    const defaultTeamLink = `${window.location.origin}/people/team/${teamId}`;
    const teamLink = context && context.teamLink ? context.teamLink : defaultTeamLink;
    const teamLinkNode = (0, $ixfCV.fg)('team-mention-inline-smartlink') ? schema.nodes.inlineCard.create({
        url: teamLink
    }) : // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    schema.text(name, [
        marks.link.create({
            href: teamLink
        })
    ]);
    const openBracketText = schema.text('(');
    const closeBracketText = schema.text(')');
    const emptySpaceText = schema.text(' ');
    const inlineNodes = [
        teamLinkNode,
        emptySpaceText,
        openBracketText
    ];
    const members = context && context.members ? context.members : [];
    members.forEach((member, index)=>{
        const { name: name, id: id } = member;
        const mentionName = `@${name}`;
        const text = sanitizePrivateContent ? '' : mentionName;
        if (sanitizePrivateContent && (0, $bijHC.isResolvingMentionProvider)(mentionProvider)) mentionProvider.cacheMentionName(id, name);
        const userMentionNode = nodes.mention.createChecked({
            text: text,
            id: member.id,
            accessLevel: accessLevel,
            userType: 'DEFAULT',
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            localId: (0, (/*@__PURE__*/$parcel$interopDefault($kHija)))()
        });
        inlineNodes.push(userMentionNode);
        // should not add empty space after the last user mention.
        if (index !== members.length - 1) inlineNodes.push(emptySpaceText);
    });
    inlineNodes.push(closeBracketText);
    return (0, $aPdNQ.Fragment).fromArray(inlineNodes);
};
/**
 * Shared mentions → typeahead-items transformer used by both the
 * single-shot `getItems` Promise path and the multi-emit
 * `subscribeToItemsUpdates` path. Factoring this out avoids any
 * chance the two paths drift in subtle item-shape behaviour (invite
 * item injection, analytics emission, no-results bookkeeping).
 *
 * NOTE: `firstQueryWithoutResults` is captured by closure in
 * `createTypeAheadConfig` and intentionally mutated here as a
 * side-effect — preserves the existing single-shot semantics.
 */ const $7944f58fade65870$var$makeTransformMentionsToTypeAheadItems = ({ fireEvent: fireEvent, getFirstQueryWithoutResults: getFirstQueryWithoutResults, setFirstQueryWithoutResults: setFirstQueryWithoutResults, toItem: toItem })=>{
    return ({ mentions: mentions, query: query, stats: stats, mentionProvider: mentionProvider, contextIdentifierProvider: contextIdentifierProvider, sessionId: sessionId })=>{
        const mentionItems = mentions.map((mention)=>toItem(mention));
        $7944f58fade65870$var$buildAndSendElementsTypeAheadAnalytics(fireEvent)({
            query: query,
            mentions: mentions,
            stats: stats
        });
        if (mentions.length === 0 && getFirstQueryWithoutResults() === null) setFirstQueryWithoutResults(query);
        if (!mentionProvider.shouldEnableInvite || mentionItems.length > 2) return mentionItems;
        const emailDomain = mentionProvider.userEmailDomain;
        return $7944f58fade65870$var$withInviteItem({
            mentionProvider: mentionProvider,
            firstQueryWithoutResults: getFirstQueryWithoutResults() || '',
            currentQuery: query,
            onInviteItemMount: ()=>{
                fireEvent((0, $6vx77.buildTypeAheadInviteItemViewedPayload)(sessionId, contextIdentifierProvider, mentionProvider.userRole, (0, $ixfCV.fg)('jira_invites_auto_tag_new_user_in_mentions_fg') ? {
                    isInlineInviteMentionsEnabled: mentionProvider.getShouldEnableInlineInvite?.()
                } : {}));
            },
            emailDomain: emailDomain
        })(mentionItems);
    };
};
const $7944f58fade65870$export$90e81ee10e57772b = ({ sanitizePrivateContent: sanitizePrivateContent, mentionInsertDisplayName: mentionInsertDisplayName, fireEvent: fireEvent, HighlightComponent: HighlightComponent, api: api, handleMentionsChanged: handleMentionsChanged, enableAgentSectioning: enableAgentSectioning = false })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    let sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($kHija)))();
    let firstQueryWithoutResults = null;
    const subscriptionKeys = new Set();
    const transformMentionsToTypeAheadItems = $7944f58fade65870$var$makeTransformMentionsToTypeAheadItems({
        fireEvent: fireEvent,
        getFirstQueryWithoutResults: ()=>firstQueryWithoutResults,
        setFirstQueryWithoutResults: (query)=>{
            firstQueryWithoutResults = query;
        },
        toItem: $7944f58fade65870$export$fc10aeed3a532e2a($7944f58fade65870$var$makeMentionToTypeaheadItem(enableAgentSectioning)).call
    });
    const typeAhead = {
        id: (0, $efqK4.TypeAheadAvailableNodes).MENTION,
        trigger: '@',
        // Custom regex must have a capture group around trigger
        // so it's possible to use it without needing to scan through all triggers again
        customRegex: '\\(?(@)',
        getHighlight: (_state)=>{
            const CustomHighlightComponent = HighlightComponent;
            if (CustomHighlightComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CustomHighlightComponent, null);
            return null;
        },
        getItems ({ query: query, editorState: editorState }) {
            const pluginState = (0, $8g3Uw.getMentionPluginState)(editorState);
            if (!pluginState?.mentionProvider) return Promise.resolve([]);
            const { mentionProvider: mentionProvider } = pluginState;
            const { contextIdentifierProvider: contextIdentifierProvider } = api?.contextIdentifier?.sharedState.currentState() ?? {};
            return new Promise((resolve, reject)=>{
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                const key = `loadingMentionsForTypeAhead_${(0, (/*@__PURE__*/$parcel$interopDefault($kHija)))()}`;
                const mentionsSubscribeCallback = (mentions, resultQuery = '', stats)=>{
                    if (query !== resultQuery) return;
                    mentionProvider.unsubscribe(key);
                    subscriptionKeys.delete(key);
                    const items = transformMentionsToTypeAheadItems({
                        mentions: mentions,
                        query: query,
                        stats: stats,
                        mentionProvider: mentionProvider,
                        contextIdentifierProvider: contextIdentifierProvider,
                        sessionId: sessionId
                    });
                    resolve(items);
                };
                subscriptionKeys.add(key);
                mentionProvider.subscribe(key, mentionsSubscribeCallback, ()=>{
                    if ((0, $fqVYq.editorExperiment)('platform_editor_offline_editing_web', true)) {
                        mentionProvider.unsubscribe(key);
                        subscriptionKeys.delete(key);
                        reject('FETCH_ERROR');
                    }
                });
                mentionProvider.filter(query || '', {
                    ...contextIdentifierProvider,
                    sessionId: sessionId
                });
            });
        },
        getSections ({ intl: intl }) {
            if (!enableAgentSectioning) return [];
            return [
                {
                    id: 'people',
                    title: intl.formatMessage((0, $725R2.mentionMessages).typeAheadSectionPeople),
                    filter: (item)=>!$7944f58fade65870$var$isAgentTypeAheadItem(item),
                    limit: 5,
                    sectionTitleDisplay: {
                        showWhenQueryPresent: false,
                        showWhenOnlySection: true
                    }
                },
                {
                    id: 'agents',
                    title: intl.formatMessage((0, $725R2.mentionMessages).typeAheadSectionAgents),
                    filter: (item)=>$7944f58fade65870$var$isAgentTypeAheadItem(item),
                    limit: 5,
                    sectionTitleDisplay: {
                        showWhenQueryPresent: false,
                        showWhenOnlySection: true
                    },
                    lozenge: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
                        appearance: "new"
                    }, intl.formatMessage((0, $725R2.mentionMessages).typeAheadSectionAgentsLabsLozengeLabel))
                }
            ];
        },
        onOpen: ()=>{
            firstQueryWithoutResults = null;
        },
        selectItem (state, item, insert, { mode: mode, stats: stats, query: query, sourceListItem: sourceListItem }) {
            const { schema: schema } = state;
            const pluginState = (0, $8g3Uw.getMentionPluginState)(state);
            const { mentionProvider: mentionProvider } = pluginState;
            const { id: id, name: name, nickname: nickname, accessLevel: accessLevel, userType: userType, isXProductUser: isXProductUser } = item.mention;
            const { contextIdentifierProvider: contextIdentifierProvider } = api?.contextIdentifier?.sharedState.currentState() ?? {};
            const mentionContext = {
                ...contextIdentifierProvider,
                sessionId: sessionId
            };
            const isAgentMentionsExperimentEnabled = (0, $mW7G5.expVal)('platform_editor_agent_mentions', 'isEnabled', false);
            const isAgentMentionInsertion = isAgentMentionsExperimentEnabled && $7944f58fade65870$var$isAgentMention(item.mention);
            // userType can be missing for provider-only agent mentions. Copy/paste cannot
            // see appType, so persist APP only when there is no explicit userType.
            const persistedUserType = isAgentMentionInsertion && userType == null ? 'APP' : userType;
            if (mentionProvider && !(0, $iqYqm.isInviteItem)(item.mention)) mentionProvider.recordMentionSelection(item.mention, mentionContext);
            // use same timer as StatsModifier
            const pickerElapsedTime = stats.startedAt ? performance.now() - stats.startedAt : 0;
            if (mentionProvider && mentionProvider.shouldEnableInvite && (0, $iqYqm.isInviteItem)(item.mention)) {
                // Don't fire event and the callback with selection by space press
                if (mode !== 'space') {
                    fireEvent((0, $6vx77.buildTypeAheadInviteItemClickedPayload)(pickerElapsedTime, stats.keyCount.arrowUp, stats.keyCount.arrowDown, sessionId, mode, query, contextIdentifierProvider, mentionProvider.userRole, (0, $ixfCV.fg)('jira_invites_auto_tag_new_user_in_mentions_fg') ? {
                        isInlineInviteMentionsEnabled: mentionProvider.getShouldEnableInlineInvite?.()
                    } : {}));
                    if (mentionProvider.getShouldEnableInlineInvite?.() && (0, $ixfCV.fg)('jira_invites_auto_tag_new_user_in_mentions_fg')) {
                        // Get the email from query, using the same logic as InviteItemWithEmailDomain
                        const emailDomain = mentionProvider.userEmailDomain;
                        let email = query || '';
                        // If query doesn't include @ and we have an email domain, append it
                        if (email && !email.includes('@') && emailDomain) email = `${email.toLowerCase()}@${emailDomain}`;
                        // If query already includes @, use it as is
                        if (email && mentionProvider.showInlineInviteRecaptcha) {
                            mentionProvider.showInlineInviteRecaptcha(email);
                            const { tr: tr } = state;
                            tr.setMeta((0, $4WUlX.mentionPlaceholderPluginKey), {
                                action: (0, $4WUlX.MENTION_PLACEHOLDER_ACTIONS).SHOW_PLACEHOLDER,
                                placeholder: `@${query}`
                            });
                            return tr;
                        }
                    } else if (mentionProvider.onInviteItemClick) // Fallback to old behavior for backward compatibility
                    mentionProvider.onInviteItemClick('mention');
                }
                return state.tr;
            }
            let taskListId, taskItemId;
            const taskList = (0, $bjg0G.findParentNodeOfType)(state.schema.nodes.taskList)(state.selection);
            if (taskList) {
                taskListId = taskList.node.attrs.localId;
                const taskItem = (0, $bjg0G.findParentNodeOfType)(state.schema.nodes.taskItem)(state.selection);
                if (taskItem) taskItemId = taskItem.node.attrs.localId;
            }
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            const mentionLocalId = (0, (/*@__PURE__*/$parcel$interopDefault($kHija)))();
            if (handleMentionsChanged) {
                const mentionChange = {
                    id: id,
                    localId: mentionLocalId,
                    method: 'typed',
                    type: 'added',
                    ...isAgentMentionInsertion ? {
                        shouldSuppressMentionNotification: true
                    } : {}
                };
                if (taskItemId) handleMentionsChanged([
                    {
                        ...mentionChange,
                        taskLocalId: taskItemId
                    }
                ]);
                else handleMentionsChanged([
                    mentionChange
                ]);
            }
            fireEvent((0, $6vx77.buildTypeAheadInsertedPayload)(pickerElapsedTime, stats.keyCount.arrowUp, stats.keyCount.arrowDown, sessionId, mode, item.mention, mentionLocalId, sourceListItem.map((x)=>x.mention), query, contextIdentifierProvider, taskListId, taskItemId, isAgentMentionInsertion));
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($kHija)))();
            if (mentionProvider && (0, $iqYqm.isTeamType)(userType)) return insert($7944f58fade65870$var$buildNodesForTeamMention(schema, item.mention, mentionProvider, sanitizePrivateContent));
            if (!isAgentMentionInsertion && isXProductUser && mentionProvider && mentionProvider.inviteXProductUser) mentionProvider.inviteXProductUser(id, name);
            const tr = insert((0, $lkoJ5.createSingleMentionFragment)({
                mentionProvider: mentionProvider,
                mentionInsertDisplayName: mentionInsertDisplayName,
                tr: state.tr,
                sanitizePrivateContent: sanitizePrivateContent,
                suppressInviteXProductUser: isAgentMentionInsertion
            })({
                name: name,
                id: id,
                userType: persistedUserType,
                nickname: nickname,
                localId: mentionLocalId,
                accessLevel: accessLevel,
                isXProductUser: isXProductUser
            }));
            if (isAgentMentionInsertion) tr.setMeta((0, $3mDyZ.mentionPluginKey), {
                action: (0, $03fL3.ACTIONS).SET_PENDING_TYPED_AGENT_MENTION,
                params: {
                    localId: mentionLocalId,
                    name: name
                }
            });
            return tr;
        },
        dismiss ({ editorState: editorState, query: query, stats: stats, wasItemInserted: wasItemInserted }) {
            firstQueryWithoutResults = null;
            const pickerElapsedTime = stats.startedAt ? performance.now() - stats.startedAt : 0;
            if (!wasItemInserted) fireEvent((0, $6vx77.buildTypeAheadCancelPayload)(pickerElapsedTime, stats.keyCount.arrowUp, stats.keyCount.arrowDown, sessionId, query || ''), 'fabric-elements');
            const pluginState = (0, $8g3Uw.getMentionPluginState)(editorState);
            if (pluginState?.mentionProvider) {
                const mentionProvider = pluginState.mentionProvider;
                for (const key of subscriptionKeys)mentionProvider.unsubscribe(key);
            }
            subscriptionKeys.clear();
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            sessionId = (0, (/*@__PURE__*/$parcel$interopDefault($kHija)))();
        }
    };
    /**
   * Opt-in multi-emit path. Subscribes to the provider's stream of
   * results for the lifetime of the type-ahead session — does NOT
   * unsubscribe after the first emission. Lets providers like
   * `RovoChatMentionResource` deliver people-first then merged
   * people + agents to the dropdown without the typeahead dropping
   * the second emission on the floor.
   *
   * Gated behind `rovo_chat_agent_selection` (the same gate that drives
   * agent mentions in the Rovo chat input). The generic type-ahead hook
   * opts a handler into streaming purely by the presence of this method,
   * so we only attach it when the gate is on — otherwise the proven
   * single-shot `getItems` path continues to drive every consumer.
   */ const subscribeToItemsUpdates = ({ query: query, editorState: editorState })=>{
        const pluginState = (0, $8g3Uw.getMentionPluginState)(editorState);
        if (!pluginState?.mentionProvider) return {
            initial: Promise.resolve([]),
            subscribe: ()=>()=>{}
        };
        const { mentionProvider: mentionProvider } = pluginState;
        const { contextIdentifierProvider: contextIdentifierProvider } = api?.contextIdentifier?.sharedState.currentState() ?? {};
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const key = `loadingMentionsForTypeAhead_${(0, (/*@__PURE__*/$parcel$interopDefault($kHija)))()}`;
        let initialResolve = null;
        let initialReject = null;
        let initialResolved = false;
        let updateCallback = null;
        let unsubscribed = false;
        const initial = new Promise((resolve, reject)=>{
            initialResolve = resolve;
            initialReject = reject;
        });
        const mentionsSubscribeCallback = (mentions, resultQuery = '', stats)=>{
            // Drop emissions tagged with a query that has moved on.
            // Mirrors the same guard in the single-shot `getItems`.
            if (query !== resultQuery) return;
            if (unsubscribed) return;
            const items = transformMentionsToTypeAheadItems({
                mentions: mentions,
                query: query,
                stats: stats,
                mentionProvider: mentionProvider,
                contextIdentifierProvider: contextIdentifierProvider,
                sessionId: sessionId
            });
            if (!initialResolved) {
                initialResolved = true;
                initialResolve?.(items);
            } else updateCallback?.(items);
        };
        subscriptionKeys.add(key);
        mentionProvider.subscribe(key, mentionsSubscribeCallback, ()=>{
            if ((0, $fqVYq.editorExperiment)('platform_editor_offline_editing_web', true)) {
                mentionProvider.unsubscribe(key);
                subscriptionKeys.delete(key);
                if (!initialResolved) {
                    initialResolved = true;
                    initialReject?.('FETCH_ERROR');
                }
            }
        });
        mentionProvider.filter(query || '', {
            ...contextIdentifierProvider,
            sessionId: sessionId
        });
        return {
            initial: initial,
            subscribe: (update)=>{
                if (updateCallback) throw new Error('TypeAhead mention updates support only one subscriber');
                updateCallback = update;
                return ()=>{
                    unsubscribed = true;
                    updateCallback = null;
                    mentionProvider.unsubscribe(key);
                    subscriptionKeys.delete(key);
                    // If cleanup runs before the first emission, settle the initial
                    // promise so its `.then` chain (and the closures it holds) is
                    // released instead of pending forever.
                    if (!initialResolved) {
                        initialResolved = true;
                        initialResolve?.([]);
                    }
                };
            }
        };
    };
    // Presence of `subscribeToItemsUpdates` is how the type-ahead hook
    // opts a handler into the multi-emit path, so only expose it when the
    // agent-selection gate is on.
    if ((0, $ixfCV.fg)('rovo_chat_agent_selection')) typeAhead.subscribeToItemsUpdates = subscribeToItemsUpdates;
    return typeAhead;
};
module.exports["createTypeAheadConfig"] = $7944f58fade65870$export$90e81ee10e57772b;

});

parcelRegister("6svtM", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $ixfCV = parcelRequire("ixfCV");


var $c8XQL = parcelRequire("c8XQL");

function $1652590ce3e9c88a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1652590ce3e9c88a$export$be24b091af3609e7 = /*#__PURE__*/ (0, $c8XQL.default)("div", {
    target: "e1b3haxs7"
})({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    overflow: 'hidden',
    padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
    textOverflow: 'ellipsis',
    verticalAlign: 'middle'
});
const $1652590ce3e9c88a$export$141d6bfd196b561 = /*#__PURE__*/ (0, $c8XQL.default)("span", {
    target: "e1b3haxs6"
})((props)=>({
        position: 'relative',
        flex: 'initial',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.restricted ? '0.5' : 'inherit'
    }));
const $1652590ce3e9c88a$export$159b59de9966d2d3 = /*#__PURE__*/ (0, $c8XQL.default)("div", {
    target: "e1b3haxs5"
})((props)=>({
        flex: 1,
        minWidth: 0,
        marginLeft: "var(--ds-space-150, 12px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.restricted ? '0.5' : 'inherit'
    }));
const $1652590ce3e9c88a$export$d1c198a7fd873fad = /*#__PURE__*/ (0, $c8XQL.default)("span", {
    target: "e1b3haxs4"
})({
    name: "a6q67k",
    styles: "display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:var(--ds-text, #292A2E)"
});
const $1652590ce3e9c88a$export$50ad5d386685fccb = /*#__PURE__*/ (0, $c8XQL.default)("div", {
    target: "e1b3haxs3"
})((props)=>({
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'right',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: props.restricted ? '0.5' : 'inherit',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '& > span': (0, $ixfCV.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? {
                marginRight: "var(--ds-space-negative-025, -2px)",
                marginBottom: "var(--ds-space-025, 2px)",
                marginTop: "var(--ds-space-025, 2px)"
            } : {
                marginBottom: "var(--ds-space-025, 2px)"
            }
        }
    }));
const $1652590ce3e9c88a$export$cf4c6e54e715dfd9 = /*#__PURE__*/ (0, $c8XQL.default)("div", {
    target: "e1b3haxs2"
})({
    name: "1w8issl",
    styles: "margin-left:var(--ds-space-250, 20px);flex:none;color:var(--ds-text-subtlest, #6B6E76);font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $1652590ce3e9c88a$export$934cc98367d9ca68 = 48;
const $1652590ce3e9c88a$export$e924bd8329057f42 = 44;
const $1652590ce3e9c88a$export$cf80dda9d7a88a01 = /*#__PURE__*/ (0, $c8XQL.default)("div", {
    target: "e1b3haxs1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: props.selected ? "var(--ds-background-selected, #E9F2FE)" : 'transparent',
        display: 'block',
        overflow: 'hidden',
        listStyleType: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${props.height ?? $1652590ce3e9c88a$export$934cc98367d9ca68}px`,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1.2,
        cursor: 'pointer'
    }));
const $1652590ce3e9c88a$export$7bf9a8fa7c04527a = /*#__PURE__*/ (0, $c8XQL.default)("div", {
    target: "e1b3haxs0"
})({
    name: "8l7ck6",
    styles: "padding-left:var(--ds-space-050, 4px);color:var(--ds-text-subtle, #505258)"
});
module.exports["RowStyle"] = $1652590ce3e9c88a$export$be24b091af3609e7;
module.exports["AvatarStyle"] = $1652590ce3e9c88a$export$141d6bfd196b561;
module.exports["NameSectionStyle"] = $1652590ce3e9c88a$export$159b59de9966d2d3;
module.exports["FullNameStyle"] = $1652590ce3e9c88a$export$d1c198a7fd873fad;
module.exports["InfoSectionStyle"] = $1652590ce3e9c88a$export$50ad5d386685fccb;
module.exports["TimeStyle"] = $1652590ce3e9c88a$export$cf4c6e54e715dfd9;
module.exports["MENTION_ITEM_HEIGHT"] = $1652590ce3e9c88a$export$934cc98367d9ca68;
module.exports["MENTION_ITEM_HEIGHT_REFRESHED"] = $1652590ce3e9c88a$export$e924bd8329057f42;
module.exports["MentionItemStyle"] = $1652590ce3e9c88a$export$cf80dda9d7a88a01;
module.exports["AccessSectionStyle"] = $1652590ce3e9c88a$export$7bf9a8fa7c04527a;

});

parcelRegister("c8XQL", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $lOiVq = parcelRequire("lOiVq");


var $fp2Bc = parcelRequire("fp2Bc");


var $gE1ec = parcelRequire("gE1ec");


var $lxV8r = parcelRequire("lxV8r");


var $cozmU = parcelRequire("cozmU");


var $ifF9E = parcelRequire("ifF9E");

var $8d74a858e0464007$var$isDevelopment = false;
var $8d74a858e0464007$var$testOmitPropsOnStringTag = (0, $ifF9E.default);
var $8d74a858e0464007$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $8d74a858e0464007$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $8d74a858e0464007$var$testOmitPropsOnStringTag : $8d74a858e0464007$var$testOmitPropsOnComponent;
};
var $8d74a858e0464007$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $8d74a858e0464007$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $lxV8r.registerStyles)(cache, serialized, isStringTag);
    (0, $gE1ec.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $lxV8r.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $8d74a858e0464007$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $8d74a858e0464007$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $8d74a858e0464007$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $lOiVq.withEmotionCache)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $cozmU.useContext((0, $lOiVq.ThemeContext));
            }
            if (typeof props.className === 'string') className = (0, $lxV8r.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $fp2Bc.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $8d74a858e0464007$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement($8d74a858e0464007$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $cozmU.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $8d74a858e0464007$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $eb3ax.default)({}, options, nextOptions, {
                shouldForwardProp: $8d74a858e0464007$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};
module.exports["default"] = $8d74a858e0464007$export$2e2bcd8739ae039;

});

parcelRegister("gE1ec", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

var $c1e155a1b94f67fa$var$syncFallback = function syncFallback(create) {
    return create();
};
var $c1e155a1b94f67fa$var$useInsertionEffect = $cozmU.useInsertionEffect ? $cozmU.useInsertionEffect : false;
var $c1e155a1b94f67fa$export$db21c7ffa21794e7 = $c1e155a1b94f67fa$var$useInsertionEffect || $c1e155a1b94f67fa$var$syncFallback;
var $c1e155a1b94f67fa$export$811a713a7276cb9d = $c1e155a1b94f67fa$var$useInsertionEffect || $cozmU.useLayoutEffect;
module.exports["useInsertionEffectAlwaysWithSyncFallback"] = $c1e155a1b94f67fa$export$db21c7ffa21794e7;
module.exports["useInsertionEffectWithLayoutFallback"] = $c1e155a1b94f67fa$export$811a713a7276cb9d;

});

parcelRegister("ifF9E", function(module, exports) {

var $e8eWN = parcelRequire("e8eWN");

// eslint-disable-next-line no-undef
var $d4998d3150d9a680$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $d4998d3150d9a680$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $e8eWN.default)(function(prop) {
    return $d4998d3150d9a680$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
module.exports["default"] = $d4998d3150d9a680$export$2e2bcd8739ae039;

});

parcelRegister("doJuV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $9KSWX = parcelRequire("9KSWX");


var $ixfCV = parcelRequire("ixfCV");


var $IOtUu = parcelRequire("IOtUu");


var $cozmU = parcelRequire("cozmU");


var $fodiz = parcelRequire("fodiz");


var $caelp = parcelRequire("caelp");


var $j1Rvl = parcelRequire("j1Rvl");


var $j3F9y = parcelRequire("j3F9y");


var $iD1Wv = parcelRequire("iD1Wv");


var $fdYSR = parcelRequire("fdYSR");


var $6svtM = parcelRequire("6svtM");


var $9G1o9 = parcelRequire("9G1o9");


var $hDw5O = parcelRequire("hDw5O");


var $21cx5 = parcelRequire("21cx5");


var $8Ep7E = parcelRequire("8Ep7E");

const $dae2fb0401c0f17b$var$lozengeAppearanceToTagColor = {
    default: 'standard',
    success: 'lime',
    removed: 'red',
    inprogress: 'blue',
    new: 'purple',
    moved: 'orange'
};
function $dae2fb0401c0f17b$var$renderTag(lozenge) {
    if (typeof lozenge === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
        text: lozenge,
        color: "standard",
        isRemovable: false,
        migration_fallback: "lozenge"
    });
    if (typeof lozenge === 'object') {
        const { appearance: appearance, text: text } = lozenge;
        const color = appearance ? $dae2fb0401c0f17b$var$lozengeAppearanceToTagColor[appearance] : 'standard';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
            text: text,
            color: color,
            isRemovable: false,
            migration_fallback: "lozenge"
        });
    }
    return null;
}
function $dae2fb0401c0f17b$var$renderLozenge(lozenge) {
    if (typeof lozenge === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), null, lozenge);
    if (typeof lozenge === 'object') {
        const { appearance: appearance, text: text } = lozenge;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: appearance
        }, text);
    }
    return null;
}
function $dae2fb0401c0f17b$var$renderTime(time) {
    if (time) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6svtM.TimeStyle), null, time);
    return null;
}
class $dae2fb0401c0f17b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        const { mention: mention, selected: selected, forwardedRef: forwardedRef, height: height } = this.props;
        const { id: id, highlight: highlight, presence: presence, name: name, mentionName: mentionName, lozenge: lozenge, accessLevel: accessLevel, isXProductUser: isXProductUser } = mention;
        const { time: time } = presence || {};
        const restricted = (0, $caelp.isRestricted)(accessLevel);
        const nameHighlights = highlight && highlight.name;
        const xProductUserInfoIconColor = selected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $21cx5.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6svtM.MentionItemStyle), {
            selected: selected,
            height: height,
            onMouseDown: this.onMentionSelected,
            onMouseMove: this.onMentionMenuItemMouseMove,
            onMouseEnter: this.onMentionMenuItemMouseEnter,
            "data-mention-item": true,
            "data-testid": `mention-item-${id}`,
            "data-mention-id": id,
            "data-mention-name": mentionName,
            "data-selected": selected,
            ref: forwardedRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6svtM.RowStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6svtM.AvatarStyle), {
            restricted: restricted
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Ep7E.MentionAvatar), {
            selected: selected,
            mention: mention
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6svtM.NameSectionStyle), {
            restricted: restricted
        }, (0, $9G1o9.renderHighlight)((0, $6svtM.FullNameStyle), name, nameHighlights), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hDw5O.default), {
            mention: mention
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6svtM.InfoSectionStyle), {
            restricted: restricted
        }, (0, $ixfCV.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? $dae2fb0401c0f17b$var$renderTag(lozenge) : $dae2fb0401c0f17b$var$renderLozenge(lozenge), $dae2fb0401c0f17b$var$renderTime(time)), restricted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iD1Wv.default), {
            name: name
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6svtM.AccessSectionStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j1Rvl.NoAccessLabel), null, (text)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fdYSR.default), {
                label: text
            }))))) : null, isXProductUser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
            color: xProductUserInfoIconColor,
            label: ''
        }))));
    }
    constructor(...args){
        super(...args);
        // internal, used for callbacks
        this.onMentionSelected = (event)=>{
            if ((0, $j3F9y.leftClick)(event) && this.props.onSelection) {
                event.preventDefault();
                this.props.onSelection(this.props.mention, event);
            }
        };
        this.onMentionMenuItemMouseMove = (event)=>{
            if (this.props.onMouseMove) this.props.onMouseMove(this.props.mention, event);
        };
        this.onMentionMenuItemMouseEnter = (event)=>{
            if (this.props.onMouseEnter) this.props.onMouseEnter(this.props.mention, event);
        };
    }
}
const $dae2fb0401c0f17b$export$604dabd552e94336 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dae2fb0401c0f17b$export$2e2bcd8739ae039, {
            ...props,
            forwardedRef: ref
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dae2fb0401c0f17b$export$2e2bcd8739ae039, {
        ...props,
        forwardedRef: ref
    });
});
module.exports["default"] = $dae2fb0401c0f17b$export$2e2bcd8739ae039;
module.exports["MentionItemWithRef"] = $dae2fb0401c0f17b$export$604dabd552e94336;

});

parcelRegister("j1Rvl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $92AHJ = parcelRequire("92AHJ");

const $878ccfcc8552aaa6$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
        const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
        const message = formatMessage(messageDescriptor, values);
        if (typeof children === 'function') return children(message);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            values: values,
            ...messageDescriptor
        });
    };
const $878ccfcc8552aaa6$export$98e06fe7a6174253 = $878ccfcc8552aaa6$export$392a0c6a82ab0e50((0, $92AHJ.messages).unknownUserError);
const $878ccfcc8552aaa6$export$58bd5a2057b6b855 = $878ccfcc8552aaa6$export$392a0c6a82ab0e50((0, $92AHJ.messages).noAccessWarning);
const $878ccfcc8552aaa6$export$da9f8ce14593162f = $878ccfcc8552aaa6$export$392a0c6a82ab0e50((0, $92AHJ.messages).noAccessLabel);
const $878ccfcc8552aaa6$export$4a258ffee7316766 = $878ccfcc8552aaa6$export$392a0c6a82ab0e50((0, $92AHJ.messages).defaultHeadline);
const $878ccfcc8552aaa6$export$702321a50d74536e = $878ccfcc8552aaa6$export$392a0c6a82ab0e50((0, $92AHJ.messages).defaultAdvisedAction);
const $878ccfcc8552aaa6$export$ed7f16088a93ae9d = $878ccfcc8552aaa6$export$392a0c6a82ab0e50((0, $92AHJ.messages).loginAgain);
const $878ccfcc8552aaa6$export$3ab158df56460d1c = $878ccfcc8552aaa6$export$392a0c6a82ab0e50((0, $92AHJ.messages).differentText);































const $878ccfcc8552aaa6$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("d4YSb")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("2cdNr")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("7l9dA")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("gpL0n")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("bjfkf")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("kLZmK")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("5a0Qd")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("1KQVk")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("bqpxF")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("l7Ke1")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("dGQYY")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("1lX2v")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("freW0")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("3OPCa")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("bwEbt")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("5at1X")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("eWJ7x")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("2FTTE")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("bq5Mn")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("6paIk")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("I5fxG")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("1FesQ")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("cx1wp")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("jK1Cf")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("bMkyl")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("fIOvF")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("486Xk")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("6bLNM")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("8jfJ9")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("isVNG")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $878ccfcc8552aaa6$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("gpL0n")).then((mod)=>mod.default);
            }
    }
};
module.exports["UnknownUserError"] = $878ccfcc8552aaa6$export$98e06fe7a6174253;
module.exports["NoAccessWarning"] = $878ccfcc8552aaa6$export$58bd5a2057b6b855;
module.exports["NoAccessLabel"] = $878ccfcc8552aaa6$export$da9f8ce14593162f;
module.exports["DefaultHeadline"] = $878ccfcc8552aaa6$export$4a258ffee7316766;
module.exports["DefaultAdvisedAction"] = $878ccfcc8552aaa6$export$702321a50d74536e;
module.exports["LoginAgain"] = $878ccfcc8552aaa6$export$ed7f16088a93ae9d;
module.exports["DifferentText"] = $878ccfcc8552aaa6$export$3ab158df56460d1c;
module.exports["getMessagesForLocale"] = $878ccfcc8552aaa6$export$d0a3169680473b6c;

});

parcelRegister("92AHJ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $fb7b952708721b37$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    unknownUserError: {
        id: "fabric.mention.unknow.user.error",
        defaultMessage: "Unknown user {userId}"
    },
    noAccessWarning: {
        id: "fabric.mention.noAccess.warning",
        defaultMessage: "{name} won't be notified as they have no access"
    },
    noAccessLabel: {
        id: "fabric.mention.noAccess.label",
        defaultMessage: "No access"
    },
    defaultHeadline: {
        id: "fabric.mention.error.defaultHeadline",
        defaultMessage: "Something went wrong"
    },
    defaultAdvisedAction: {
        id: "fabric.mention.error.defaultAction",
        defaultMessage: "Try again in a few seconds"
    },
    loginAgain: {
        id: "fabric.mention.error.loginAgain",
        defaultMessage: "Try logging out then in again"
    },
    differentText: {
        id: "fabric.mention.error.differentText",
        defaultMessage: "Try entering different text"
    },
    memberCountWithoutYou: {
        id: "fabric.elements.mentions.team.member.count",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}"
    },
    memberCountWithYou: {
        id: "fabric.elements.mentions.team.member.count.including.you",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you"
    },
    plus50MembersWithoutYou: {
        id: "fabric.elements.mentions.team.member.50plus",
        defaultMessage: "Team \u2022 50+ members"
    },
    plus50MembersWithYou: {
        id: "fabric.elements.mentions.team.member.50plus.including.you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    xProductMentionDescription: {
        id: "fabric.elements.mentions.xproduct.mention.description",
        defaultMessage: "Needs access to Confluence"
    }
});
module.exports["messages"] = $fb7b952708721b37$export$defe85febe8b728c;

});

parcelRegister("d4YSb", function(module, exports) {

let $985ade335fa31a0e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $985ade335fa31a0e$var$load("1JYrd"),
    $985ade335fa31a0e$var$load("cip6w"),
    $985ade335fa31a0e$var$load("3feYV"),
    $985ade335fa31a0e$var$load("gAG2n"),
    $985ade335fa31a0e$var$load("hFpP9"),
    $985ade335fa31a0e$var$load("cwjU2"),
    $985ade335fa31a0e$var$load("3Ff1R"),
    $985ade335fa31a0e$var$load("423Ga")
]).then(()=>parcelRequire('aIUTc'));

});

parcelRegister("2cdNr", function(module, exports) {

let $19976772e476e5d9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $19976772e476e5d9$var$load("30242"),
    $19976772e476e5d9$var$load("3qBwQ"),
    $19976772e476e5d9$var$load("7Q1SM"),
    $19976772e476e5d9$var$load("cYGDU"),
    $19976772e476e5d9$var$load("ddSTH"),
    $19976772e476e5d9$var$load("33Iaa"),
    $19976772e476e5d9$var$load("blA7x"),
    $19976772e476e5d9$var$load("gJroP")
]).then(()=>parcelRequire('aK3gp'));

});

parcelRegister("7l9dA", function(module, exports) {

let $5581a51deee4024c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5581a51deee4024c$var$load("15aAJ"),
    $5581a51deee4024c$var$load("8rREG"),
    $5581a51deee4024c$var$load("7JdzX"),
    $5581a51deee4024c$var$load("dgXJL"),
    $5581a51deee4024c$var$load("9d8JZ"),
    $5581a51deee4024c$var$load("6681T"),
    $5581a51deee4024c$var$load("3dn3H"),
    $5581a51deee4024c$var$load("cYXvt")
]).then(()=>parcelRequire('d43Vk'));

});

parcelRegister("gpL0n", function(module, exports) {

let $bf33715bc1c03891$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bf33715bc1c03891$var$load("hUbK8").then(()=>parcelRequire('6BJ6x'));

});

parcelRegister("bjfkf", function(module, exports) {

let $83bd5b66aa53de45$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $83bd5b66aa53de45$var$load("l5BBd"),
    $83bd5b66aa53de45$var$load("93ASN"),
    $83bd5b66aa53de45$var$load("24LNf"),
    $83bd5b66aa53de45$var$load("htu5t"),
    $83bd5b66aa53de45$var$load("1A450"),
    $83bd5b66aa53de45$var$load("iYQCc"),
    $83bd5b66aa53de45$var$load("nBJth")
]).then(()=>parcelRequire('9BUhf'));

});

parcelRegister("kLZmK", function(module, exports) {

let $f1f7cc6d5a6f7a03$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f1f7cc6d5a6f7a03$var$load("bbv9t"),
    $f1f7cc6d5a6f7a03$var$load("9fQoJ"),
    $f1f7cc6d5a6f7a03$var$load("cnlNg"),
    $f1f7cc6d5a6f7a03$var$load("lTboH"),
    $f1f7cc6d5a6f7a03$var$load("gBDXQ"),
    $f1f7cc6d5a6f7a03$var$load("d3Phe"),
    $f1f7cc6d5a6f7a03$var$load("lASLx"),
    $f1f7cc6d5a6f7a03$var$load("bIXgz")
]).then(()=>parcelRequire('3u3mj'));

});

parcelRegister("5a0Qd", function(module, exports) {

let $3c1e89fd267619bd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3c1e89fd267619bd$var$load("7p4je"),
    $3c1e89fd267619bd$var$load("8SZbD"),
    $3c1e89fd267619bd$var$load("9Uf61"),
    $3c1e89fd267619bd$var$load("iE05k"),
    $3c1e89fd267619bd$var$load("lv5aU"),
    $3c1e89fd267619bd$var$load("3Yk1e"),
    $3c1e89fd267619bd$var$load("5lJyy"),
    $3c1e89fd267619bd$var$load("9w9df")
]).then(()=>parcelRequire('dWF5g'));

});

parcelRegister("1KQVk", function(module, exports) {

let $147323d6e8bf4a31$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $147323d6e8bf4a31$var$load("5ZQnr"),
    $147323d6e8bf4a31$var$load("2hqQb"),
    $147323d6e8bf4a31$var$load("lJyww"),
    $147323d6e8bf4a31$var$load("gVfjY"),
    $147323d6e8bf4a31$var$load("8RVFi")
]).then(()=>parcelRequire('33aAd'));

});

parcelRegister("bqpxF", function(module, exports) {

let $8515ef876a31f490$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8515ef876a31f490$var$load("1jQRQ"),
    $8515ef876a31f490$var$load("5pOQA"),
    $8515ef876a31f490$var$load("fJSEb"),
    $8515ef876a31f490$var$load("5GSny"),
    $8515ef876a31f490$var$load("cQump"),
    $8515ef876a31f490$var$load("ajzkj"),
    $8515ef876a31f490$var$load("eyysG"),
    $8515ef876a31f490$var$load("27gvR")
]).then(()=>parcelRequire('hDeI8'));

});

parcelRegister("l7Ke1", function(module, exports) {

let $f60e1bc71727e466$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f60e1bc71727e466$var$load("km37l"),
    $f60e1bc71727e466$var$load("gbksI"),
    $f60e1bc71727e466$var$load("9TeWr"),
    $f60e1bc71727e466$var$load("j2X7f"),
    $f60e1bc71727e466$var$load("fE8pi"),
    $f60e1bc71727e466$var$load("kUZ7k"),
    $f60e1bc71727e466$var$load("dJQL7"),
    $f60e1bc71727e466$var$load("czj6d")
]).then(()=>parcelRequire('dvQoK'));

});

parcelRegister("dGQYY", function(module, exports) {

let $9f784bcef31f77a7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9f784bcef31f77a7$var$load("lTbXI"),
    $9f784bcef31f77a7$var$load("a98cw"),
    $9f784bcef31f77a7$var$load("fOGnR"),
    $9f784bcef31f77a7$var$load("e40mE"),
    $9f784bcef31f77a7$var$load("btBGI"),
    $9f784bcef31f77a7$var$load("cDQOq"),
    $9f784bcef31f77a7$var$load("8upye"),
    $9f784bcef31f77a7$var$load("GlmUM")
]).then(()=>parcelRequire('cvpu0'));

});

parcelRegister("1lX2v", function(module, exports) {

let $0fc58c977e435e13$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0fc58c977e435e13$var$load("8wMQe").then(()=>parcelRequire('LjIsh'));

});

parcelRegister("freW0", function(module, exports) {

let $b3d4f6565dde8137$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b3d4f6565dde8137$var$load("iUyZj"),
    $b3d4f6565dde8137$var$load("4PDaO"),
    $b3d4f6565dde8137$var$load("8nEeY"),
    $b3d4f6565dde8137$var$load("lMhbw"),
    $b3d4f6565dde8137$var$load("amTTV"),
    $b3d4f6565dde8137$var$load("kLZKK"),
    $b3d4f6565dde8137$var$load("c7GMc"),
    $b3d4f6565dde8137$var$load("bnhJ1")
]).then(()=>parcelRequire('e4VAB'));

});

parcelRegister("3OPCa", function(module, exports) {

let $2c7e1436d04eac89$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2c7e1436d04eac89$var$load("kPlMQ"),
    $2c7e1436d04eac89$var$load("ervs7"),
    $2c7e1436d04eac89$var$load("fzzMQ"),
    $2c7e1436d04eac89$var$load("8CX31"),
    $2c7e1436d04eac89$var$load("kYd4i"),
    $2c7e1436d04eac89$var$load("33S6H"),
    $2c7e1436d04eac89$var$load("kFae4"),
    $2c7e1436d04eac89$var$load("iZWpE")
]).then(()=>parcelRequire('96CT4'));

});

parcelRegister("bwEbt", function(module, exports) {

let $8641da90021f141d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8641da90021f141d$var$load("iT2sv"),
    $8641da90021f141d$var$load("iMMtn"),
    $8641da90021f141d$var$load("3gNEO"),
    $8641da90021f141d$var$load("23VWs"),
    $8641da90021f141d$var$load("e1KaU"),
    $8641da90021f141d$var$load("93obY"),
    $8641da90021f141d$var$load("6Y9jE"),
    $8641da90021f141d$var$load("cUTaY")
]).then(()=>parcelRequire('2YvEH'));

});

parcelRegister("5at1X", function(module, exports) {

let $3c3467c741031007$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3c3467c741031007$var$load("lyPpF"),
    $3c3467c741031007$var$load("eX5n7"),
    $3c3467c741031007$var$load("gvylW"),
    $3c3467c741031007$var$load("aiYuN"),
    $3c3467c741031007$var$load("gqMCT"),
    $3c3467c741031007$var$load("bxfRe"),
    $3c3467c741031007$var$load("ed6s8"),
    $3c3467c741031007$var$load("lAuJd")
]).then(()=>parcelRequire('6VUXz'));

});

parcelRegister("eWJ7x", function(module, exports) {

let $ae197b7e6281f8e9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ae197b7e6281f8e9$var$load("iN3cj"),
    $ae197b7e6281f8e9$var$load("3nHdy"),
    $ae197b7e6281f8e9$var$load("80OLx"),
    $ae197b7e6281f8e9$var$load("gDEvm"),
    $ae197b7e6281f8e9$var$load("5MwHB"),
    $ae197b7e6281f8e9$var$load("1EVcg"),
    $ae197b7e6281f8e9$var$load("96q1k"),
    $ae197b7e6281f8e9$var$load("XQtfV")
]).then(()=>parcelRequire('4D1c2'));

});

parcelRegister("2FTTE", function(module, exports) {

let $1f2ac4fcd19f7080$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1f2ac4fcd19f7080$var$load("eC1OL"),
    $1f2ac4fcd19f7080$var$load("ilL9c"),
    $1f2ac4fcd19f7080$var$load("e4s0V"),
    $1f2ac4fcd19f7080$var$load("64nco"),
    $1f2ac4fcd19f7080$var$load("9cx6P"),
    $1f2ac4fcd19f7080$var$load("28EXy"),
    $1f2ac4fcd19f7080$var$load("7RZp5"),
    $1f2ac4fcd19f7080$var$load("leyTH")
]).then(()=>parcelRequire('htiZ2'));

});

parcelRegister("bq5Mn", function(module, exports) {

let $85069b121ab4bc4a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $85069b121ab4bc4a$var$load("4NJ49"),
    $85069b121ab4bc4a$var$load("bfOZL"),
    $85069b121ab4bc4a$var$load("4dPO1"),
    $85069b121ab4bc4a$var$load("jLbRX"),
    $85069b121ab4bc4a$var$load("5g0HW"),
    $85069b121ab4bc4a$var$load("gg8tK"),
    $85069b121ab4bc4a$var$load("eF54W"),
    $85069b121ab4bc4a$var$load("3hnPt")
]).then(()=>parcelRequire('6FDlX'));

});

parcelRegister("6paIk", function(module, exports) {

let $4a9d6374e12b3eab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a9d6374e12b3eab$var$load("3zH5p").then(()=>parcelRequire('9VK7h'));

});

parcelRegister("I5fxG", function(module, exports) {

let $08482ea73d01879b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $08482ea73d01879b$var$load("fsCDU"),
    $08482ea73d01879b$var$load("apVmx"),
    $08482ea73d01879b$var$load("kuolm"),
    $08482ea73d01879b$var$load("fvE7S"),
    $08482ea73d01879b$var$load("5xPg2")
]).then(()=>parcelRequire('0aYYd'));

});

parcelRegister("1FesQ", function(module, exports) {

let $1364d713114d6fc2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1364d713114d6fc2$var$load("g9gkE"),
    $1364d713114d6fc2$var$load("jYdbS"),
    $1364d713114d6fc2$var$load("ltrgi"),
    $1364d713114d6fc2$var$load("6ncWv"),
    $1364d713114d6fc2$var$load("gFneG"),
    $1364d713114d6fc2$var$load("fu25G"),
    $1364d713114d6fc2$var$load("iQGcz"),
    $1364d713114d6fc2$var$load("ar4uw")
]).then(()=>parcelRequire('fHwYp'));

});

parcelRegister("cx1wp", function(module, exports) {

let $91f9bf4454da4b7f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $91f9bf4454da4b7f$var$load("dKdA9").then(()=>parcelRequire('6IGZA'));

});

parcelRegister("jK1Cf", function(module, exports) {

let $e5f391125e366c30$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e5f391125e366c30$var$load("jhikU"),
    $e5f391125e366c30$var$load("f0i3H"),
    $e5f391125e366c30$var$load("69YlM"),
    $e5f391125e366c30$var$load("bvBAp"),
    $e5f391125e366c30$var$load("9kqmW"),
    $e5f391125e366c30$var$load("cyTsc"),
    $e5f391125e366c30$var$load("kXCsp"),
    $e5f391125e366c30$var$load("disCG")
]).then(()=>parcelRequire('cycD1'));

});

parcelRegister("bMkyl", function(module, exports) {

let $89341eca9b757efd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $89341eca9b757efd$var$load("52XP1").then(()=>parcelRequire('klwXC'));

});

parcelRegister("fIOvF", function(module, exports) {

let $b72225467f057513$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b72225467f057513$var$load("fSsz4"),
    $b72225467f057513$var$load("kWOpS"),
    $b72225467f057513$var$load("kgHzZ"),
    $b72225467f057513$var$load("9tUAi"),
    $b72225467f057513$var$load("bS9pO"),
    $b72225467f057513$var$load("j4ur8"),
    $b72225467f057513$var$load("fF7Id")
]).then(()=>parcelRequire('9kSto'));

});

parcelRegister("486Xk", function(module, exports) {

let $301d4e1521a68fed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $301d4e1521a68fed$var$load("k3bMq").then(()=>parcelRequire('5pQz0'));

});

parcelRegister("6bLNM", function(module, exports) {

let $4818d99fabfc5b23$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4818d99fabfc5b23$var$load("lF2HI").then(()=>parcelRequire('dPXRL'));

});

parcelRegister("8jfJ9", function(module, exports) {

let $60cc4c332ad17f63$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $60cc4c332ad17f63$var$load("d91RK"),
    $60cc4c332ad17f63$var$load("f7hfJ"),
    $60cc4c332ad17f63$var$load("brdRT"),
    $60cc4c332ad17f63$var$load("QI1kr"),
    $60cc4c332ad17f63$var$load("5LvhC"),
    $60cc4c332ad17f63$var$load("lWBlc"),
    $60cc4c332ad17f63$var$load("s2EmI"),
    $60cc4c332ad17f63$var$load("jc0YL")
]).then(()=>parcelRequire('AOOMd'));

});

parcelRegister("isVNG", function(module, exports) {

let $d717ad7a14072abe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d717ad7a14072abe$var$load("708J7"),
    $d717ad7a14072abe$var$load("kVqUf"),
    $d717ad7a14072abe$var$load("j03Pa"),
    $d717ad7a14072abe$var$load("2IMxh"),
    $d717ad7a14072abe$var$load("98tcg"),
    $d717ad7a14072abe$var$load("kke1I"),
    $d717ad7a14072abe$var$load("gOwMq"),
    $d717ad7a14072abe$var$load("6GfaN")
]).then(()=>parcelRequire('gMQJr'));

});

parcelRegister("j3F9y", function(module, exports) {
function $d4691eb235268492$export$fd3cd03f8ac42187(event) {
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $d4691eb235268492$export$de744e30016241b0(oldPosition, newPosition) {
    if (!oldPosition || oldPosition.x !== newPosition.x || oldPosition.y !== newPosition.y) return true;
    return false;
}
function $d4691eb235268492$export$34ebdaf2c517ae75(event) {
    return event.button === 0 && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey;
}
module.exports["mouseLocation"] = $d4691eb235268492$export$fd3cd03f8ac42187;
module.exports["actualMouseMove"] = $d4691eb235268492$export$de744e30016241b0;
module.exports["leftClick"] = $d4691eb235268492$export$34ebdaf2c517ae75;

});

parcelRegister("iD1Wv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $70ab48cd50028ae1$var$AsyncNoAccessTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("bfi3l")).then((module)=>{
        return {
            default: module.NoAccessTooltip
        };
    }));
var $70ab48cd50028ae1$export$2e2bcd8739ae039 = $70ab48cd50028ae1$var$AsyncNoAccessTooltip;
module.exports["default"] = $70ab48cd50028ae1$export$2e2bcd8739ae039;

});

parcelRegister("bfi3l", function(module, exports) {

let $021ce3818119c131$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $021ce3818119c131$var$load("akbkC").then(()=>parcelRequire('d7Uen'));

});

parcelRegister("fdYSR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $e8e9337ea066cb42$var$AsyncLockCircleIcon = /*#__PURE__*/ (0, $cozmU.lazy)(()=>Promise.resolve((parcelRequire("4efpo"))).then((module)=>({
            default: module.default
        })));
var $e8e9337ea066cb42$export$2e2bcd8739ae039 = $e8e9337ea066cb42$var$AsyncLockCircleIcon;
module.exports["default"] = $e8e9337ea066cb42$export$2e2bcd8739ae039;

});

parcelRegister("9G1o9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $022db5897bf17146$export$2bcf43b01d5314f5(ReactComponent, value, highlights, prefix) {
    if (!value) return null;
    const parts = [];
    const prefixText = prefix || '';
    let lastIndex = 0;
    if (highlights) {
        for(let i = 0; i < highlights.length; i++){
            const h = highlights[i];
            const start = h.start;
            const end = h.end;
            if (start > lastIndex) parts.push({
                value: value.substring(lastIndex, start),
                matches: false
            });
            parts.push({
                value: value.substring(start, end + 1),
                matches: true
            });
            lastIndex = end + 1;
        }
        if (lastIndex < value.length) parts.push({
            value: value.substring(lastIndex, value.length),
            matches: false
        });
    } else parts.push({
        value: value,
        matches: false
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ReactComponent, null, prefixText, parts.map((part, index)=>{
        if (part.matches) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", {
            key: index
        }, part.value);
        return part.value;
    }));
}
module.exports["renderHighlight"] = $022db5897bf17146$export$2bcf43b01d5314f5;

});

parcelRegister("hDw5O", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $caelp = parcelRequire("caelp");


var $k6XCk = parcelRequire("k6XCk");


var $adD94 = parcelRequire("adD94");


var $016fw = parcelRequire("016fw");


var $92AHJ = parcelRequire("92AHJ");

class $ecd8f9ff3570eba7$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        const { userType: userType, isXProductUser: isXProductUser } = this.props.mention;
        if (isXProductUser) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $016fw.DescriptionBylineStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $92AHJ.messages).xProductMentionDescription));
        switch(userType){
            case (0, $caelp.UserType)[(0, $caelp.UserType).TEAM]:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $adD94.default), {
                    mention: this.props.mention
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k6XCk.default), {
                    mention: this.props.mention
                });
        }
    }
}
module.exports["default"] = $ecd8f9ff3570eba7$export$2e2bcd8739ae039;

});

parcelRegister("k6XCk", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9G1o9 = parcelRequire("9G1o9");


var $016fw = parcelRequire("016fw");

class $b7b06fc6f9fb609a$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        const { highlight: highlight, name: name, nickname: nickname } = this.props.mention;
        const nicknameHighlights = highlight && highlight.nickname;
        if (name === nickname) return null;
        return (0, $9G1o9.renderHighlight)((0, $016fw.DescriptionBylineStyle), nickname, nicknameHighlights, '@');
    }
}
module.exports["default"] = $b7b06fc6f9fb609a$export$2e2bcd8739ae039;

});

parcelRegister("016fw", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $c8XQL = parcelRequire("c8XQL");

function $b0724d5a86bed298$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b0724d5a86bed298$export$607100a5f9cc9977 = /*#__PURE__*/ (0, $c8XQL.default)("span", {
    target: "e1bkpfff0"
})({
    name: "mffxab",
    styles: "color:var(--ds-text-subtlest, #6B6E76);font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);margin-top:var(--ds-space-025, 2px);display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
});
module.exports["DescriptionBylineStyle"] = $b0724d5a86bed298$export$607100a5f9cc9977;

});

parcelRegister("adD94", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $016fw = parcelRequire("016fw");


var $92AHJ = parcelRequire("92AHJ");

class $073279505be3a44b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        const { context: context } = this.props.mention;
        if (!context) return null;
        const includesYou = context.includesYou;
        const memberCount = context.memberCount;
        return this.renderByline(memberCount, includesYou);
    }
    constructor(...args){
        super(...args);
        this.renderByline = (memberCount, includesYou)=>{
            if (includesYou) {
                if (memberCount > 50) return this.getBylineComponent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $92AHJ.messages).plus50MembersWithYou));
                return this.getBylineComponent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $92AHJ.messages).memberCountWithYou,
                    values: {
                        0: memberCount
                    }
                }));
            } else {
                if (memberCount > 50) return this.getBylineComponent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $92AHJ.messages).plus50MembersWithoutYou));
                return this.getBylineComponent(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $92AHJ.messages).memberCountWithoutYou,
                    values: {
                        0: memberCount
                    }
                }));
            }
        };
        this.getBylineComponent = (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $016fw.DescriptionBylineStyle), null, message);
    }
}
module.exports["default"] = $073279505be3a44b$export$2e2bcd8739ae039;

});

parcelRegister("21cx5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $j1Rvl = parcelRequire("j1Rvl");

const $f497c875f65a609f$var$EMPTY = {};
const $f497c875f65a609f$var$useI18n = (0, $gtMdU.isReactCompilerActivePlatform)() ? (locale)=>{
    const $ = (0, $bDgLe.c)(3);
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState($f497c875f65a609f$var$EMPTY);
    let t0;
    let t1;
    if ($[0] !== locale) {
        t0 = ()=>{
            let aborted = false;
            setMessages($f497c875f65a609f$var$EMPTY);
            (0, $j1Rvl.getMessagesForLocale)(locale).then((messages_0)=>{
                if (!aborted) setMessages(messages_0);
            }).catch($f497c875f65a609f$var$_temp);
            return ()=>{
                aborted = true;
            };
        };
        t1 = [
            locale
        ];
        $[0] = locale;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t0, t1);
    return messages;
} : (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState($f497c875f65a609f$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        let aborted = false;
        setMessages($f497c875f65a609f$var$EMPTY);
        (0, $j1Rvl.getMessagesForLocale)(locale).then((messages_0)=>{
            if (!aborted) setMessages(messages_0);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $f497c875f65a609f$var$MessagesIntlProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = props;
    const intl = (0, $kSwu1.useIntl)();
    const messages = $f497c875f65a609f$var$useI18n(intl.locale);
    let t0;
    if ($[0] !== children || $[1] !== intl || $[2] !== messages) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            ...intl,
            messages: messages
        }, children);
        $[0] = children;
        $[1] = intl;
        $[2] = messages;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props)=>{
    const { children: children } = props;
    const intl = (0, $kSwu1.useIntl)();
    const messages = $f497c875f65a609f$var$useI18n(intl.locale);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        ...intl,
        messages: messages
    }, children);
};
var $f497c875f65a609f$export$2e2bcd8739ae039 = $f497c875f65a609f$var$MessagesIntlProvider;
function $f497c875f65a609f$var$_temp(error) {
    console.error(error);
}
module.exports["default"] = $f497c875f65a609f$export$2e2bcd8739ae039;

});

parcelRegister("8Ep7E", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $arQY7 = parcelRequire("arQY7");

var $dWZMi = parcelRequire("dWZMi");


var $2c3Eq = parcelRequire("2c3Eq");


var $ixfCV = parcelRequire("ixfCV");


var $caelp = parcelRequire("caelp");

const $fdc9240587cfc5be$export$35f495c0dc0a1015 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { mention: mention, selected: selected } = t0;
    const { appType: appType, avatarUrl: avatarUrl, presence: presence } = mention;
    const borderColor = selected ? "var(--ds-border, #0B120E24)" : undefined;
    let t1;
    if ($[0] !== presence) {
        t1 = presence || {};
        $[0] = presence;
        $[1] = t1;
    } else t1 = $[1];
    const { status: status } = t1;
    if ((0, $caelp.isTeamMention)(mention)) {
        let t2;
        if ($[2] !== avatarUrl || $[3] !== borderColor) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2c3Eq.default), {
                src: avatarUrl,
                size: "medium",
                borderColor: borderColor
            });
            $[2] = avatarUrl;
            $[3] = borderColor;
            $[4] = t2;
        } else t2 = $[4];
        return t2;
    }
    let t2;
    if ($[5] !== mention) {
        t2 = (0, $caelp.isAppMention)(mention) && mention.appType === "agent" && (0, $ixfCV.fg)("rovo_chat_agent_selection");
        $[5] = mention;
        $[6] = t2;
    } else t2 = $[6];
    const shouldRenderAgentMentionAvatar = t2;
    let t3;
    if ($[7] !== appType || $[8] !== shouldRenderAgentMentionAvatar) {
        t3 = shouldRenderAgentMentionAvatar ? "hexagon" : (0, $ixfCV.fg)("jira_ai_agent_avatar_issue_view_comment_mentions") ? (0, $dWZMi.default)(appType) : undefined;
        $[7] = appType;
        $[8] = shouldRenderAgentMentionAvatar;
        $[9] = t3;
    } else t3 = $[9];
    const avatarAppearance = t3;
    let t4;
    if ($[10] !== avatarAppearance || $[11] !== avatarUrl || $[12] !== borderColor || $[13] !== status) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            src: avatarUrl,
            size: "medium",
            presence: status,
            borderColor: borderColor,
            appearance: avatarAppearance
        });
        $[10] = avatarAppearance;
        $[11] = avatarUrl;
        $[12] = borderColor;
        $[13] = status;
        $[14] = t4;
    } else t4 = $[14];
    return t4;
} : ({ mention: mention, selected: selected })=>{
    const { appType: appType, avatarUrl: avatarUrl, presence: presence } = mention;
    const borderColor = selected ? "var(--ds-border, #0B120E24)" : undefined;
    const { status: status } = presence || {};
    if ((0, $caelp.isTeamMention)(mention)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2c3Eq.default), {
        src: avatarUrl,
        size: "medium",
        borderColor: borderColor
    });
    // Agent providers can request GraphQL `identityAccount { picture }` and pass it as
    // `avatarUrl`; this component only applies the hexagon agent shape.
    const shouldRenderAgentMentionAvatar = (0, $caelp.isAppMention)(mention) && mention.appType === 'agent' && (0, $ixfCV.fg)('rovo_chat_agent_selection');
    const avatarAppearance = shouldRenderAgentMentionAvatar ? 'hexagon' : (0, $ixfCV.fg)('jira_ai_agent_avatar_issue_view_comment_mentions') ? (0, $dWZMi.default)(appType) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        src: avatarUrl,
        size: "medium",
        presence: status,
        borderColor: borderColor,
        appearance: avatarAppearance
    });
};
module.exports["MentionAvatar"] = $fdc9240587cfc5be$export$35f495c0dc0a1015;

});

parcelRegister("2c3Eq", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7zsi1 = parcelRequire("7zsi1");

var $arQY7 = parcelRequire("arQY7");


var $ixfCV = parcelRequire("ixfCV");


var $3VIRc = parcelRequire("3VIRc");

const $402d6e8638203e24$export$ebe0b8fe8b6acbfd = "var(--ds-icon-inverse, #FFFFFF)";
const $402d6e8638203e24$export$72502e51aebdd94e = "var(--ds-icon-subtle, #505258)";
const $402d6e8638203e24$var$TeamAvatar = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TeamAvatar(t0) {
    const $ = (0, $bDgLe.c)(31);
    let props;
    let src;
    let t1;
    let t2;
    let t3;
    let testId;
    if ($[0] !== t0) {
        ({ testId: testId, src: src, size: t1, teamId: t2, compact: t3, ...props } = t0);
        $[0] = t0;
        $[1] = props;
        $[2] = src;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = testId;
    } else {
        props = $[1];
        src = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        testId = $[6];
    }
    const size = t1 === undefined ? "medium" : t1;
    let teamId = t2 === undefined ? "" : t2;
    const compact = t3 === undefined ? false : t3;
    let t4;
    if ($[7] !== teamId) {
        t4 = teamId.replace("ari:cloud:identity::team/", "");
        $[7] = teamId;
        $[8] = t4;
    } else t4 = $[8];
    teamId = t4;
    if ((0, $ixfCV.fg)("enable_teams_t26_design_drop_core_experiences")) {
        const t5 = `${testId}-team-avatar`;
        let t6;
        if ($[9] !== size || $[10] !== src || $[11] !== teamId || $[12] !== testId) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7zsi1.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3VIRc.TeamAvatarImage), {
                key: teamId,
                src: src,
                size: size,
                testId: testId,
                teamId: teamId
            }));
            $[9] = size;
            $[10] = src;
            $[11] = teamId;
            $[12] = testId;
            $[13] = t6;
        } else t6 = $[13];
        let t7;
        if ($[14] !== props || $[15] !== size || $[16] !== t5 || $[17] !== t6) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
                ...props,
                appearance: "square",
                size: size,
                testId: t5
            }, t6);
            $[14] = props;
            $[15] = size;
            $[16] = t5;
            $[17] = t6;
            $[18] = t7;
        } else t7 = $[18];
        return t7;
    }
    const t5 = `${testId}-team-avatar`;
    let t6;
    if ($[19] !== compact || $[20] !== size || $[21] !== src || $[22] !== teamId || $[23] !== testId) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3VIRc.TeamAvatarImage), {
            src: src,
            size: size,
            testId: testId,
            teamId: teamId,
            compact: compact
        });
        $[19] = compact;
        $[20] = size;
        $[21] = src;
        $[22] = teamId;
        $[23] = testId;
        $[24] = t6;
    } else t6 = $[24];
    let t7;
    if ($[25] !== props || $[26] !== size || $[27] !== src || $[28] !== t5 || $[29] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            appearance: "square",
            ...props,
            size: size,
            src: src,
            testId: t5
        }, t6);
        $[25] = props;
        $[26] = size;
        $[27] = src;
        $[28] = t5;
        $[29] = t6;
        $[30] = t7;
    } else t7 = $[30];
    return t7;
} : function TeamAvatar({ testId: testId, src: src, size: size = 'medium', teamId: teamId = '', compact: compact = false, ...props }) {
    // Strip ARI in case the teamId was given in that format
    teamId = teamId.replace('ari:cloud:identity::team/', '');
    if ((0, $ixfCV.fg)('enable_teams_t26_design_drop_core_experiences')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        ...props,
        appearance: "square",
        size: size,
        testId: `${testId}-team-avatar`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7zsi1.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3VIRc.TeamAvatarImage), {
        key: teamId,
        src: src,
        size: size,
        testId: testId,
        teamId: teamId
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        appearance: "square",
        ...props,
        size: size,
        src: src,
        testId: `${testId}-team-avatar`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3VIRc.TeamAvatarImage), {
        src: src,
        size: size,
        testId: testId,
        teamId: teamId,
        compact: compact
    }));
};
var $402d6e8638203e24$export$2e2bcd8739ae039 = $402d6e8638203e24$var$TeamAvatar;
module.exports["default"] = $402d6e8638203e24$export$2e2bcd8739ae039;

});

parcelRegister("3VIRc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $ixfCV = parcelRequire("ixfCV");


var $iMnC5 = parcelRequire("iMnC5");


var $giWSb = parcelRequire("giWSb");


var $l5WTV = parcelRequire("l5WTV");


var $5jzbe = parcelRequire("5jzbe");

const $e9b0094c91a8ccec$var$boxShadowCssVar = '--avatar-box-shadow';
const $e9b0094c91a8ccec$var$bgColorCssVar = '--avatar-bg-color'; /**
                                            * We need to maintan the container styles manually until Avatar provides the correct border radius.
                                            * After that we can return to wrapping in <AvatarContent> rather than span
                                            */ 
const $e9b0094c91a8ccec$var$containerStyles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _kqswpfqs _4cvr1fhb _1bah1h6o _2lx21bp4 _80om1kw7 _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _t9ec1aqe _9v7aze3t _qc5o1p41 _z0ai1osq _18postnw _1hfk1j28 _aetrf705 _1peqidpf _11fnglyw",
    nonCompactSpacing: "_6rthv77o _1pfhv77o _12l2v77o _ahbqv77o",
    compactSpacing: "_6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t",
    circle: "_2rko1qll _14mj1qll",
    positionRelative: "_kqswh2mm",
    disabled: "_80om13gf _1hfkvuon _1peq2wxo"
};
const $e9b0094c91a8ccec$var$unboundStyles = {
    root: "_vchh1ntv _bfhkcxp3 _16qs1nhn",
    interactive: "_80omtlke _4tpu1f0r _ez1ykb7n _gcm1jer9 _eeh8kb7n _jlxit94y"
};
const $e9b0094c91a8ccec$var$avatarImageStyles = {
    image: "_16jlkb7n _1o9zkb7n _i0dl1osq _1e0c1txw _1bsb1osq _4t3i1osq"
};
const $e9b0094c91a8ccec$var$SIZES = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 96,
    xxlarge: 128
};
const $e9b0094c91a8ccec$var$borderRadiusMap = {
    xsmall: "_2rkol0p1",
    small: "_2rkol0p1",
    medium: "_2rkol0p1",
    large: "_2rkol0p1",
    xlarge: "_2rkol0p1",
    xxlarge: "_2rkol0p1"
};
const $e9b0094c91a8ccec$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
}; /**
    * __Avatar image__
    *
    * An avatar image is an internal component used to control the rendering phases of an image.
    */ 
const $e9b0094c91a8ccec$export$ac3673635a5387be = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { alt: t1, src: src, size: size, testId: testId, teamId: teamId, compact: t2 } = t0;
    const alt = t1 === undefined ? "" : t1;
    const compact = t2 === undefined ? false : t2;
    const [hasImageErrored, setHasImageErrored] = (0, $cozmU.useState)(false);
    let t3;
    if ($[0] !== src || $[1] !== teamId) {
        t3 = (0, $5jzbe.getTeamAvatarSrc)(src, teamId);
        $[0] = src;
        $[1] = teamId;
        $[2] = t3;
    } else t3 = $[2];
    const avatarSrc = t3;
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            if ((0, $ixfCV.fg)("enable_teams_t26_design_drop_core_experiences")) return;
            setHasImageErrored(false);
        };
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== avatarSrc) {
        t5 = [
            avatarSrc
        ];
        $[4] = avatarSrc;
        $[5] = t5;
    } else t5 = $[5];
    (0, $cozmU.useEffect)(t4, t5);
    if ((!avatarSrc || hasImageErrored) && !(0, $ixfCV.fg)("enable_teams_t26_design_drop_core_experiences")) {
        const t6 = $e9b0094c91a8ccec$var$SIZES[size];
        const t7 = $e9b0094c91a8ccec$var$SIZES[size];
        let t8;
        if ($[6] !== alt || $[7] !== compact || $[8] !== t6 || $[9] !== t7 || $[10] !== testId) {
            t8 = /*#__PURE__*/ $cozmU.createElement((0, $giWSb.FallbackAvatar), {
                "aria-label": alt,
                width: t6,
                height: t7,
                "data-testid": testId,
                compact: compact
            });
            $[6] = alt;
            $[7] = compact;
            $[8] = t6;
            $[9] = t7;
            $[10] = testId;
            $[11] = t8;
        } else t8 = $[11];
        return t8;
    }
    if ((0, $ixfCV.fg)("enable_teams_t26_design_drop_core_experiences")) {
        const resolvedSrc = hasImageErrored ? (0, $l5WTV.TEAM_FALLBACK_AVATAR_DATA_URI) : avatarSrc;
        const t6 = testId && `${testId}--image`;
        let t7;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = ()=>setHasImageErrored(true);
            $[12] = t7;
        } else t7 = $[12];
        let t8;
        if ($[13] !== alt || $[14] !== resolvedSrc || $[15] !== t6) {
            t8 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
                as: "img",
                src: resolvedSrc,
                alt: alt,
                testId: t6,
                xcss: $e9b0094c91a8ccec$var$avatarImageStyles.image,
                onError: t7
            });
            $[13] = alt;
            $[14] = resolvedSrc;
            $[15] = t6;
            $[16] = t8;
        } else t8 = $[16];
        return t8;
    }
    const t6 = $e9b0094c91a8ccec$var$borderRadiusMap[size];
    const t7 = $e9b0094c91a8ccec$var$widthHeightMap[size];
    const t8 = compact ? $e9b0094c91a8ccec$var$containerStyles.compactSpacing : $e9b0094c91a8ccec$var$containerStyles.nonCompactSpacing;
    let t9;
    if ($[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
        t9 = (0, $hekY6.default)([
            $e9b0094c91a8ccec$var$unboundStyles.root,
            $e9b0094c91a8ccec$var$containerStyles.root,
            t6,
            t7,
            t8
        ]);
        $[17] = t6;
        $[18] = t7;
        $[19] = t8;
        $[20] = t9;
    } else t9 = $[20];
    const t10 = testId && `${testId}--image`;
    let t11;
    let t12;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = ()=>setHasImageErrored(true);
        t12 = (0, $hekY6.default)([
            $e9b0094c91a8ccec$var$avatarImageStyles.image
        ]);
        $[21] = t11;
        $[22] = t12;
    } else {
        t11 = $[21];
        t12 = $[22];
    }
    let t13;
    if ($[23] !== alt || $[24] !== avatarSrc || $[25] !== t10) {
        t13 = /*#__PURE__*/ $cozmU.createElement("img", {
            src: avatarSrc,
            alt: alt,
            "data-testid": t10,
            onError: t11,
            className: t12
        });
        $[23] = alt;
        $[24] = avatarSrc;
        $[25] = t10;
        $[26] = t13;
    } else t13 = $[26];
    let t14;
    if ($[27] !== alt || $[28] !== t13 || $[29] !== t9 || $[30] !== testId) {
        t14 = /*#__PURE__*/ $cozmU.createElement("span", {
            "data-testid": testId,
            "aria-label": alt,
            className: t9
        }, t13);
        $[27] = alt;
        $[28] = t13;
        $[29] = t9;
        $[30] = testId;
        $[31] = t14;
    } else t14 = $[31];
    return t14;
} : ({ alt: alt = '', src: src, size: size, testId: testId, teamId: teamId, compact: compact = false })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $cozmU.useState)(false);
    const avatarSrc = (0, $5jzbe.getTeamAvatarSrc)(src, teamId);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $ixfCV.fg)('enable_teams_t26_design_drop_core_experiences')) return;
        setHasImageErrored(false);
    }, [
        avatarSrc
    ]);
    if ((!avatarSrc || hasImageErrored) && !(0, $ixfCV.fg)('enable_teams_t26_design_drop_core_experiences')) return /*#__PURE__*/ $cozmU.createElement((0, $giWSb.FallbackAvatar), {
        "aria-label": alt,
        width: $e9b0094c91a8ccec$var$SIZES[size],
        height: $e9b0094c91a8ccec$var$SIZES[size],
        "data-testid": testId,
        compact: compact
    });
    if ((0, $ixfCV.fg)('enable_teams_t26_design_drop_core_experiences')) {
        const resolvedSrc = hasImageErrored ? (0, $l5WTV.TEAM_FALLBACK_AVATAR_DATA_URI) : avatarSrc;
        return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            as: "img",
            src: resolvedSrc,
            alt: alt,
            testId: testId && `${testId}--image`,
            xcss: $e9b0094c91a8ccec$var$avatarImageStyles.image,
            onError: ()=>setHasImageErrored(true)
        });
    }
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": testId,
        "aria-label": alt,
        className: (0, $hekY6.default)([
            $e9b0094c91a8ccec$var$unboundStyles.root,
            $e9b0094c91a8ccec$var$containerStyles.root,
            $e9b0094c91a8ccec$var$borderRadiusMap[size],
            $e9b0094c91a8ccec$var$widthHeightMap[size],
            compact ? $e9b0094c91a8ccec$var$containerStyles.compactSpacing : $e9b0094c91a8ccec$var$containerStyles.nonCompactSpacing
        ])
    }, /*#__PURE__*/ $cozmU.createElement("img", {
        src: avatarSrc,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        onError: ()=>setHasImageErrored(true),
        className: (0, $hekY6.default)([
            $e9b0094c91a8ccec$var$avatarImageStyles.image
        ])
    }));
};
module.exports["TeamAvatarImage"] = $e9b0094c91a8ccec$export$ac3673635a5387be;

});

parcelRegister("giWSb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

const $fd19101f9abb11e9$var$styles = {
    wrapper: "_1reo15vq _18m915vq _2rkol0p1 _1e0c1txw",
    wrapperSpacing: "_19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
    compactWrapperSpacing: "_19pkze3t _2hwxze3t _otyrze3t _18u0ze3t"
};
const $fd19101f9abb11e9$export$eb63dcc490f6bbcd = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FallbackAvatar(t0) {
    const $ = (0, $bDgLe.c)(12);
    let compact;
    let props;
    if ($[0] !== t0) {
        ({ compact: compact, ...props } = t0);
        $[0] = t0;
        $[1] = compact;
        $[2] = props;
    } else {
        compact = $[1];
        props = $[2];
    }
    const t1 = compact ? $fd19101f9abb11e9$var$styles.compactWrapperSpacing : $fd19101f9abb11e9$var$styles.wrapperSpacing;
    let t2;
    if ($[3] !== t1) {
        t2 = (0, $w6R6I.cx)($fd19101f9abb11e9$var$styles.wrapper, t1);
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_2032_552)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "32",
            height: "32",
            rx: "4",
            fill: "#DCDFE4"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
            fill: "#44546F"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
            fill: "#44546F"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
            fill: "#44546F"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
            fill: "#44546F"
        }));
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_2032_552"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "32",
            height: "32",
            rx: "4",
            fill: "white"
        })));
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== props) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props
        }, t3, t4);
        $[7] = props;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== t2 || $[10] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: t2
        }, t5);
        $[9] = t2;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : function FallbackAvatar({ compact: compact, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($fd19101f9abb11e9$var$styles.wrapper, compact ? $fd19101f9abb11e9$var$styles.compactWrapperSpacing : $fd19101f9abb11e9$var$styles.wrapperSpacing)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2032_552)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "4",
        fill: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z",
        fill: "#44546F"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z",
        fill: "#44546F"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z",
        fill: "#44546F"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z",
        fill: "#44546F"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2032_552"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "32",
        height: "32",
        rx: "4",
        fill: "white"
    })))));
};
module.exports["FallbackAvatar"] = $fd19101f9abb11e9$export$eb63dcc490f6bbcd;

});

parcelRegister("l5WTV", function(module, exports) {
const $ef1de21fbce43fe8$export$215bd25cfab1a96 = `data:image/svg+xml;utf8,${encodeURIComponent(`<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2032_552)">
<rect width="32" height="32" rx="4" fill="#DCDFE4"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M10.6666 12.6666C11.7712 12.6666 12.6666 11.7712 12.6666 10.6666C12.6666 9.56206 11.7712 8.66663 10.6666 8.66663C9.56202 8.66663 8.66658 9.56206 8.66658 10.6666C8.66658 11.7712 9.56202 12.6666 10.6666 12.6666ZM10.6666 14.6666C12.8757 14.6666 14.6666 12.8758 14.6666 10.6666C14.6666 8.45749 12.8757 6.66663 10.6666 6.66663C8.45745 6.66663 6.66658 8.45749 6.66658 10.6666C6.66658 12.8758 8.45745 14.6666 10.6666 14.6666Z" fill="#44546F"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M21.3333 12.6666C22.4378 12.6666 23.3333 11.7712 23.3333 10.6666C23.3333 9.56206 22.4378 8.66663 21.3333 8.66663C20.2287 8.66663 19.3333 9.56206 19.3333 10.6666C19.3333 11.7712 20.2287 12.6666 21.3333 12.6666ZM21.3333 14.6666C23.5424 14.6666 25.3333 12.8758 25.3333 10.6666C25.3333 8.45749 23.5424 6.66663 21.3333 6.66663C19.1241 6.66663 17.3333 8.45749 17.3333 10.6666C17.3333 12.8758 19.1241 14.6666 21.3333 14.6666Z" fill="#44546F"/>
<path d="M21.6666 16C24.4273 16.0004 26.6666 18.2385 26.6666 21V22.6666C26.6666 24.1394 25.4727 25.3333 23.9999 25.3333H20.135C18.0324 25.3333 16.1545 24.018 15.436 22.042L14.6843 19.9747C14.2531 18.7892 13.1264 18 11.8649 18H10.3333C8.6764 18 7.33325 19.3431 7.33325 21V22.6666C7.33325 23.0348 7.63173 23.3333 7.99992 23.3333H13.3333V25.3333H7.99992C6.52716 25.3333 5.33325 24.1394 5.33325 22.6666V21C5.33325 18.2385 7.57183 16 10.3333 16H11.8649C13.9674 16 15.8453 17.3153 16.5638 19.2913L17.3156 21.3585C17.7467 22.5441 18.8734 23.3333 20.135 23.3333H23.9999C24.3681 23.3333 24.6666 23.0348 24.6666 22.6666V21C24.6666 19.3437 23.3233 18.0004 21.6666 18H20.135V16H21.6666Z" fill="#44546F"/>
<path d="M20.135 16C19.5972 16 18.7183 16.1407 18.0518 16.4564L18.908 18.2639C19.064 18.19 19.288 18.1205 19.537 18.0703C19.785 18.0203 20.0045 18 20.135 18V16Z" fill="#44546F"/>
</g>
<defs>
<clipPath id="clip0_2032_552">
<rect width="32" height="32" rx="4" fill="white"/>
</clipPath>
</defs>
</svg>`)}`;
module.exports["TEAM_FALLBACK_AVATAR_DATA_URI"] = $ef1de21fbce43fe8$export$215bd25cfab1a96;

});

parcelRegister("5jzbe", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $l5WTV = parcelRequire("l5WTV");

function $b576d3f3fb082ae0$export$59ff7d19feb890b6(src, teamId) {
    if (src) return src;
    else if (teamId) return `/gateway/api/v4/teams/${teamId}/avatar`;
    return (0, $ixfCV.fg)('enable_teams_t26_design_drop_core_experiences') ? (0, $l5WTV.TEAM_FALLBACK_AVATAR_DATA_URI) : undefined;
}
module.exports["getTeamAvatarSrc"] = $b576d3f3fb082ae0$export$59ff7d19feb890b6;

});

parcelRegister("9PCgk", function(module, exports) {
/* InviteItemWithEmailDomain.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $725R2 = parcelRequire("725R2");


var $ldb9Z = parcelRequire("ldb9Z");


var $24dy7 = parcelRequire("24dy7");


var $kh0hi = parcelRequire("kh0hi");


var $bsEy7 = parcelRequire("bsEy7");

const $048a4cb654a308c1$var$mentionItemStyle = null;
const $048a4cb654a308c1$var$mentionItemSelectedStyle = null;
const $048a4cb654a308c1$var$displayNameStyles = {
    localPart: "_1i4q1hna",
    domainPart: "_1e0c1o8l _p12f1osq _1i4q1hna"
};
const $048a4cb654a308c1$var$DisplayName = ({ name: name })=>{
    const atIndex = name.indexOf('@');
    if (atIndex === -1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $048a4cb654a308c1$var$displayNameStyles.localPart
        ])
    }, name);
    const localPart = name.slice(0, atIndex);
    const domainPart = name.slice(atIndex); // includes the @
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $048a4cb654a308c1$var$displayNameStyles.localPart
        ])
    }, localPart), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $048a4cb654a308c1$var$displayNameStyles.domainPart
        ])
    }, domainPart));
};
const $048a4cb654a308c1$var$style = {
    byline: "_19pkv77o",
    rowStyle: "_1reo15vq _18m915vq _4cvr1h6o _1e0c1txw _2lx2vrvc _1n261g80 _ca0q12x7 _n3td12x7 _19bvutpp _u5f3utpp _1bto1l2s _s7n4nkob",
    avatar: "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _4cvr1h6o _1bah1h6o _kqswh2mm _1bsb14no _4t3i14no",
    nameSection: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _18u0utpp _2hwxu2gc _syazazsu",
    capitalize: "_1p1d1dk0",
    inviteButton: "_2rko12b0 _11c8fhey _1h6d1l7x _1dqonqa1 _189ee4h9 _1e0c116y _4cvr1h6o _1bah1h6o _ca0q12x7 _u5f3utpp _n3td12x7 _19bvutpp _syazazsu _k48p1wq8 _4t3iviql _bfhksm61 _cun9187o _irr31dpa"
};
const $048a4cb654a308c1$var$VALID_OPTION = 'VALID';
const $048a4cb654a308c1$var$POTENTIAL_OPTION = 'POTENTIAL'; // eslint-disable-next-line require-unicode-regexp
const $048a4cb654a308c1$var$COMPLETE_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const $048a4cb654a308c1$var$ERROR_DELAY_MS = 750; /**
                             * Truncates an email-like string to fit within a max length by inserting an
                             * ellipsis into the middle of the local part (before the @).
                             *
                             * Preserves the full `@domain` suffix so users can always see
                             * which domain the invite targets.
                             */ 
const $048a4cb654a308c1$export$e6502b0a7f7ab4ba = (value, maxLength = 34)=>{
    if (value.length <= maxLength) return value;
    const atIndex = value.lastIndexOf('@');
    if (atIndex === -1) {
        // No @ — truncate to maxLength and append ellipsis
        const ellipsis = '\u2026';
        return `${value.slice(0, maxLength - 1)}${ellipsis}`;
    }
    const domain = value.slice(atIndex); // includes @
    const local = value.slice(0, atIndex);
    const ellipsis = '\u2026';
    const available = maxLength - domain.length - ellipsis.length;
    if (available <= 0) // Domain alone exceeds budget — show as much as we can
    return `${ellipsis}${domain.slice(-(maxLength - ellipsis.length))}`;
    const leading = Math.ceil(available / 2);
    const trailing = Math.floor(available / 2);
    const truncatedLocal = trailing > 0 ? `${local.slice(0, leading)}${ellipsis}${local.slice(local.length - trailing)}` : `${local.slice(0, leading)}${ellipsis}`;
    return `${truncatedLocal}${domain}`;
};
const $048a4cb654a308c1$var$getInviteOption = (inputValue, suggestedEmailDomain)=>{
    if (inputValue.includes(' ') && inputValue.includes('@')) return $048a4cb654a308c1$export$e6502b0a7f7ab4ba(inputValue);
    const isEmail = inputValue && [
        $048a4cb654a308c1$var$VALID_OPTION,
        $048a4cb654a308c1$var$POTENTIAL_OPTION
    ].includes((0, $bsEy7.isValidEmail)(inputValue));
    if (isEmail || !suggestedEmailDomain) return $048a4cb654a308c1$export$e6502b0a7f7ab4ba(inputValue);
    return $048a4cb654a308c1$export$e6502b0a7f7ab4ba(`${inputValue.toLocaleLowerCase()}@${suggestedEmailDomain}`);
};
const $048a4cb654a308c1$var$getIsEmailValid = (inputValue)=>{
    if (!inputValue || inputValue.length === 0) return false;
    if (inputValue.includes(' ')) return false;
    if (inputValue.includes('@') && !$048a4cb654a308c1$var$COMPLETE_EMAIL_REGEX.test(inputValue)) return false;
    return true;
};
const $048a4cb654a308c1$export$75621ed4176efc9e = {
    id: 'invite-teammate'
};
const $048a4cb654a308c1$var$InviteItemWithEmailDomain = ({ productName: productName, onMount: onMount, onMouseEnter: onMouseEnter, onSelection: onSelection, selected: selected, userRole: userRole, query: query = '', emailDomain: emailDomain, intl: intl })=>{
    const [showErrorIcon, setShowErrorIcon] = (0, $cozmU.useState)(query.length !== 0 && !$048a4cb654a308c1$var$getIsEmailValid(query));
    const timeoutRef = (0, $cozmU.useRef)();
    const possibleEmail = $048a4cb654a308c1$var$getInviteOption(query, emailDomain);
    const isEmailValid = $048a4cb654a308c1$var$getIsEmailValid(query);
    const getByline = ()=>{
        if (showErrorIcon) return intl.formatMessage((0, $725R2.mentionMessages).inviteTeammateInvalidEmail);
        if (userRole === 'admin') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage // Ignored via go/ees005
        ), {
            ...(0, $725R2.mentionMessages).inviteItemTitle,
            values: {
                userRole: userRole || 'basic',
                productName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                    "data-testid": "capitalized-message",
                    className: (0, $hekY6.default)([
                        $048a4cb654a308c1$var$style.capitalize
                    ])
                }, productName)
            }
        });
        return intl.formatMessage((0, $725R2.mentionMessages).sendInvite);
    };
    const onInviteButtonClick = (0, $cozmU.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        if (onSelection) {
            event.preventDefault();
            onSelection($048a4cb654a308c1$export$75621ed4176efc9e, event);
        }
    }, [
        onSelection
    ]);
    const onItemMouseEnter = (0, $cozmU.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        if (onMouseEnter) onMouseEnter($048a4cb654a308c1$export$75621ed4176efc9e, event);
    }, [
        onMouseEnter
    ]);
    const onItemFocus = (0, $cozmU.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        if (onMouseEnter) onMouseEnter($048a4cb654a308c1$export$75621ed4176efc9e, event);
    }, [
        onMouseEnter
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (onMount) onMount();
    }, [
        onMount
    ]); // Debounce error icon display: only show error after user stops typing invalid input
    (0, $cozmU.useEffect)(()=>{
        // Clear existing timeout
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = undefined;
        } // Reset error icon immediately if input becomes valid or empty
        if (isEmailValid || query.length === 0) setShowErrorIcon(false);
        else // Debounce: only show error icon after delay if input remains invalid
        timeoutRef.current = setTimeout(()=>{
            setShowErrorIcon(true);
        }, $048a4cb654a308c1$var$ERROR_DELAY_MS);
         // Cleanup timeout on unmount or when query changes
        return ()=>{
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, [
        query,
        isEmailValid
    ]);
    const displayName = query && emailDomain ? possibleEmail : undefined;
    return displayName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        onMouseEnter: onItemMouseEnter,
        onFocus: onItemFocus,
        "data-id": $048a4cb654a308c1$export$75621ed4176efc9e.id,
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _bfhk1j28 _1e0c1ule _2mzuglyw",
            selected && "_bfhk1dpa"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $048a4cb654a308c1$var$style.rowStyle
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $048a4cb654a308c1$var$style.avatar
        ])
    }, showErrorIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        label: "Error",
        color: "var(--ds-icon-danger, #C9372C)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ldb9Z))), {
        label: "Email",
        color: "var(--ds-icon-subtle, #505258)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "name-section",
        className: (0, $hekY6.default)([
            $048a4cb654a308c1$var$style.nameSection
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($048a4cb654a308c1$var$DisplayName, {
        name: displayName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $048a4cb654a308c1$var$style.byline
        ])
    }, getByline())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
        onClick: onInviteButtonClick,
        xcss: $048a4cb654a308c1$var$style.inviteButton,
        isDisabled: showErrorIcon
    }, intl.formatMessage((0, $725R2.mentionMessages).inviteButton))));
};
// eslint-disable-next-line @typescript-eslint/ban-types
const $048a4cb654a308c1$var$_default_1 = (0, $kSwu1.injectIntl)($048a4cb654a308c1$var$InviteItemWithEmailDomain);
var $048a4cb654a308c1$export$2e2bcd8739ae039 = $048a4cb654a308c1$var$_default_1;
module.exports["default"] = $048a4cb654a308c1$export$2e2bcd8739ae039;

});

parcelRegister("bsEy7", function(module, exports) {
const $c776d91474b4faaf$var$validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const $c776d91474b4faaf$var$potentialRegex = /^[^\s@]+@[^\s@]*$/i;
const $c776d91474b4faaf$export$371e338370561054 = (inputText)=>{
    if (inputText.match($c776d91474b4faaf$var$validRegex)) return 'VALID';
    if (inputText.match($c776d91474b4faaf$var$potentialRegex)) return 'POTENTIAL';
    return 'INVALID';
};
module.exports["isValidEmail"] = $c776d91474b4faaf$export$371e338370561054;

});

parcelRegister("HGu9Y", function(module, exports) {

var $7toP7 = parcelRequire("7toP7");


var $fClPf = parcelRequire("fClPf");


var $aOTwp = parcelRequire("aOTwp");


var $gYiLB = parcelRequire("gYiLB");

const $7545ccce0e49e308$export$171e576bb7c729fa = ({ api: api })=>({
        name: 'indentation',
        marks () {
            return [
                {
                    name: 'indentation',
                    mark: (0, $7toP7.indentation)
                }
            ];
        },
        actions: {
            indentParagraphOrHeading: (0, $aOTwp.getIndentCommand)(api?.analytics?.actions),
            outdentParagraphOrHeading: (0, $aOTwp.getOutdentCommand)(api?.analytics?.actions)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const { tr: { selection: selection }, schema: { marks: { indentation: indentation } } } = editorState;
            const node = selection.$from.node();
            const indentationMark = node.marks.find((mark)=>mark.type === indentation);
            return {
                isIndentationAllowed: (0, $aOTwp.isIndentationAllowed)(editorState.schema, node),
                // @ts-ignore - TS2869 TypeScript 5.9.2 upgrade
                indentDisabled: (indentationMark?.attrs.level >= (0, $fClPf.MAX_INDENTATION_LEVEL)) ?? false,
                outdentDisabled: !indentationMark
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'indentationKeymap',
                    plugin: ()=>(0, $gYiLB.keymapPlugin)(api?.analytics?.actions)
                }
            ];
        }
    });
module.exports["indentationPlugin"] = $7545ccce0e49e308$export$171e576bb7c729fa;

});

parcelRegister("aOTwp", function(module, exports) {

var $iX5Ka = parcelRequire("iX5Ka");

var $krYZG = parcelRequire("krYZG");


var $9WBFV = parcelRequire("9WBFV");


var $fClPf = parcelRequire("fClPf");


var $fanJz = parcelRequire("fanJz");


var $eFZrs = parcelRequire("eFZrs");

const $8ccb9806c3a6424a$export$54db194d337db321 = (schema, node)=>{
    const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = schema;
    if ([
        paragraph,
        heading
    ].indexOf(node.type) > -1) {
        if (alignment) {
            const hasAlignment = node.marks.filter((mark)=>mark.type === alignment)[0];
            return !hasAlignment;
        }
        return true;
    }
    return false;
};
/**
 * Create new indentation command (Either indent or outdent depend of getArgsFn)
 * @param getNewIndentationAttrs Function to handle new indentation level
 */ function $8ccb9806c3a6424a$var$createIndentationCommand(getNewIndentationAttrs) {
    return (state, dispatch)=>{
        const { indentation: indentation } = state.schema.marks;
        return (0, $9WBFV.toggleBlockMark)(indentation, getNewIndentationAttrs, $8ccb9806c3a6424a$export$54db194d337db321)(state, dispatch);
    };
}
function $8ccb9806c3a6424a$var$createIndentationCommandWithAnalytics({ getNewIndentationAttrs: getNewIndentationAttrs, direction: direction, inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI }) {
    // Create a new getAttrs function to record the changes
    const { getAttrs: getAttrs, getAndResetAttrsChanges: getAndResetAttrsChanges } = (0, $fanJz.default)(getNewIndentationAttrs, {
        direction: direction
    });
    // Use new getAttrs wrapper
    const indentationCommand = $8ccb9806c3a6424a$var$createIndentationCommand(getAttrs);
    // Return a new command where we change dispatch for our analytics dispatch
    return (state, dispatch)=>{
        return indentationCommand(state, (0, $eFZrs.createAnalyticsDispatch)({
            getAttrsChanges: getAndResetAttrsChanges,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI,
            state: state,
            dispatch: dispatch
        }));
    };
}
/**
 * Get new level for outdent
 * @param oldAttr Old attributes for the mark, undefined if the mark doesn't exit
 * @returns  - undefined; No change required
 *           - false; Remove the mark
 *           - object; Update attributes
 */ const $8ccb9806c3a6424a$var$getIndentAttrs = (oldAttr)=>{
    if (!oldAttr) return {
        level: 1
    }; // No mark exist, create a new one with level 1
    const { level: level } = oldAttr;
    if (level >= (0, $fClPf.MAX_INDENTATION_LEVEL)) return undefined; // Max indentation level reached, do nothing.
    return {
        level: level + 1
    }; // Otherwise, increase the level by one
};
const $8ccb9806c3a6424a$export$b294289254b8cdac = (editorAnalyticsAPI)=>(inputMethod = (0, $krYZG.INPUT_METHOD).KEYBOARD)=>$8ccb9806c3a6424a$var$createIndentationCommandWithAnalytics({
            getNewIndentationAttrs: $8ccb9806c3a6424a$var$getIndentAttrs,
            direction: (0, $iX5Ka.INDENT_DIRECTION).INDENT,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
/**
 * Get new level for outdent
 * @param oldAttr Old attributes for the mark, undefined if the mark doesn't exit
 * @returns  - undefined; No change required
 *           - false; Remove the mark
 *           - object; Update attributes
 */ const $8ccb9806c3a6424a$var$getOutdentAttrs = (oldAttr)=>{
    if (!oldAttr) return undefined; // Do nothing;
    const { level: level } = oldAttr;
    if (level <= 1) return false; // Remove the mark
    return {
        level: level - 1
    }; // Decrease the level on other cases
};
const $8ccb9806c3a6424a$export$620b2a1f10eb3a5f = (editorAnalyticsAPI)=>(inputMethod = (0, $krYZG.INPUT_METHOD).KEYBOARD)=>$8ccb9806c3a6424a$var$createIndentationCommandWithAnalytics({
            getNewIndentationAttrs: $8ccb9806c3a6424a$var$getOutdentAttrs,
            direction: (0, $iX5Ka.INDENT_DIRECTION).OUTDENT,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
const $8ccb9806c3a6424a$export$33ad14ed4b6e7a8e = (state, dispatch)=>(0, $9WBFV.toggleBlockMark)(state.schema.marks.indentation, ()=>false)(state, dispatch);
module.exports["isIndentationAllowed"] = $8ccb9806c3a6424a$export$54db194d337db321;
module.exports["getIndentCommand"] = $8ccb9806c3a6424a$export$b294289254b8cdac;
module.exports["getOutdentCommand"] = $8ccb9806c3a6424a$export$620b2a1f10eb3a5f;

});

parcelRegister("fanJz", function(module, exports) {
$parcel$export(module.exports, "default", () => $7dd1315d32deb815$export$2e2bcd8739ae039);
function $7dd1315d32deb815$export$2e2bcd8739ae039(getAttrs, options) {
    let changes = [];
    function getAttrsWithChangesRecorder(prevAttrs, node) {
        const newAttrs = getAttrs(prevAttrs, node);
        changes.push({
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            node: node,
            prevAttrs: prevAttrs,
            newAttrs: newAttrs,
            options: options
        });
        return newAttrs;
    }
    return {
        getAttrs: getAttrsWithChangesRecorder,
        getAndResetAttrsChanges () {
            const oldChanges = changes;
            changes = [];
            return oldChanges;
        }
    };
}

});

parcelRegister("eFZrs", function(module, exports) {

var $krYZG = parcelRequire("krYZG");

var $iX5Ka = parcelRequire("iX5Ka");

const $1736d54b67a5c25e$var$indentTypes = {
    paragraph: (0, $iX5Ka.INDENT_TYPE).PARAGRAPH,
    heading: (0, $iX5Ka.INDENT_TYPE).HEADING
};
function $1736d54b67a5c25e$export$c67aac760a384f96(prevAttrs, newAttrs) {
    if (newAttrs === undefined) return $1736d54b67a5c25e$export$697340b93338bcbd(prevAttrs);
    else if (newAttrs === false) return 0;
    return newAttrs.level;
}
function $1736d54b67a5c25e$export$697340b93338bcbd(prevAttrs) {
    if (prevAttrs === undefined) return 0;
    return prevAttrs.level;
}
function $1736d54b67a5c25e$export$4f15b45384b61427({ getAttrsChanges: getAttrsChanges, inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI, state: state, dispatch: dispatch }) {
    return (tr)=>{
        const currentTr = tr;
        const changes = getAttrsChanges(); // Get all attributes changes
        // Add analytics event for each change stored.
        changes.forEach(({ node: node, prevAttrs: prevAttrs, newAttrs: newAttrs, options: { direction: direction } })=>{
            const indentType = $1736d54b67a5c25e$var$indentTypes[node.type.name];
            if (!indentType) return; // If no valid indent type continue
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).FORMATTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_INDENT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: inputMethod,
                    previousIndentationLevel: $1736d54b67a5c25e$export$697340b93338bcbd(prevAttrs),
                    newIndentLevel: $1736d54b67a5c25e$export$c67aac760a384f96(prevAttrs, newAttrs),
                    direction: direction,
                    indentType: indentType
                }
            })(currentTr);
        });
        // Dispatch analytics if exist
        if (dispatch) dispatch(tr);
    };
}
module.exports["createAnalyticsDispatch"] = $1736d54b67a5c25e$export$4f15b45384b61427;

});

parcelRegister("gYiLB", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $ldqjS = parcelRequire("ldqjS");


var $b9BvQ = parcelRequire("b9BvQ");


var $44cyU = parcelRequire("44cyU");


var $bjg0G = parcelRequire("bjg0G");


var $aOTwp = parcelRequire("aOTwp");

function $1df8e650ca8df6e6$export$e832373cff8dec22(editorAnalyticsAPI) {
    const list = {};
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.indent)), (state, dispatch)=>{
        const { blockTaskItem: blockTaskItem, paragraph: paragraph, doc: doc } = state.schema.nodes;
        if (blockTaskItem) {
            let hasBlockTaskItem = false;
            let hasParagraphAtDocLevel = false;
            // Check if the selection contains a blockTaskItem
            state.doc.nodesBetween(state.selection.from, state.selection.to, (node, _pos, parent)=>{
                if (node.type === blockTaskItem) {
                    hasBlockTaskItem = true;
                    return false; // stop iterating
                }
                if (node.type === paragraph && parent?.type === doc) hasParagraphAtDocLevel = true;
            });
            if (hasBlockTaskItem && !hasParagraphAtDocLevel) return false; // let `editor-plugin-tasks-and-decisions` handle indentation
        }
        return (0, $aOTwp.getIndentCommand)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).KEYBOARD)(state, dispatch);
    }, list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.outdent)), (0, $aOTwp.getOutdentCommand)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).KEYBOARD), list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.backspace)), (state, dispatch)=>{
        const { selection: selection } = state;
        const { blockTaskItem: blockTaskItem } = state.schema.nodes;
        // Let `editor-plugin-tasks-and-decisions` handle indentation inside blockTaskItems
        if ((0, $b9BvQ.isTextSelection)(selection) && selection.$cursor && selection.$cursor.parentOffset === 0 && !(0, $bjg0G.hasParentNodeOfType)([
            blockTaskItem
        ])(selection)) return dispatch ? (0, $aOTwp.getOutdentCommand)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).KEYBOARD)(state, dispatch) : false;
        return false;
    }, list);
    return (0, $44cyU.keymap)(list);
}
var $1df8e650ca8df6e6$export$2e2bcd8739ae039 = $1df8e650ca8df6e6$export$e832373cff8dec22;
module.exports["keymapPlugin"] = $1df8e650ca8df6e6$export$e832373cff8dec22;

});

parcelRegister("eEseG", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $8e6sC = parcelRequire("8e6sC");


var $31JyQ = parcelRequire("31JyQ");


var $fkaeB = parcelRequire("fkaeB");

const $6608a0556249eb50$export$a305f4d2cc38e07 = ({ api: api })=>({
        name: 'localId',
        actions: {
            replaceNode: (0, $8e6sC.replaceNode)(api),
            getNode: (0, $8e6sC.getNode)(api)
        },
        pmPlugins () {
            return [
                {
                    name: 'localIdPlugin',
                    plugin: ()=>(0, $31JyQ.createPlugin)(api)
                },
                {
                    name: 'localId-watchmen',
                    plugin: ()=>(0, $ixfCV.fg)('platform_editor_ai_aifc_localid_error_reporting') ? (0, $fkaeB.createWatchmenPlugin)(api) : undefined
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const watchmentPluginState = (0, $fkaeB.localIdWatchmenPluginKey).getState(editorState);
            return {
                localIdWatchmenEnabled: !!watchmentPluginState?.enabled,
                localIdStatus: new Map(watchmentPluginState?.localIdStatus)
            };
        }
    });
module.exports["localIdPlugin"] = $6608a0556249eb50$export$a305f4d2cc38e07;

});

parcelRegister("8e6sC", function(module, exports) {
function $40bf6b0f05eaa921$export$aadcc3ba2430b(tr, localId) {
    let result;
    tr.doc.descendants((node, pos)=>{
        if (result) return false;
        if (node.attrs.localId === localId) result = {
            node: node,
            pos: pos
        };
        return result === undefined;
    });
    return result;
}
const $40bf6b0f05eaa921$export$5542201de9311ab2 = (api)=>({ localId: localId, value: value })=>{
        const nodeWithPos = $40bf6b0f05eaa921$export$3f778c4e796a1f9c(api)({
            localId: localId
        });
        if (!nodeWithPos) return false;
        const { pos: pos, node: node } = nodeWithPos;
        return api?.core.actions.execute(({ tr: tr })=>tr.replaceWith(pos, pos + node.nodeSize, value).scrollIntoView()) ?? false;
    };
const $40bf6b0f05eaa921$export$3f778c4e796a1f9c = (api)=>({ localId: localId })=>{
        let result;
        api?.core.actions.execute(({ tr: tr })=>{
            result = $40bf6b0f05eaa921$export$aadcc3ba2430b(tr, localId);
            return null;
        });
        return result;
    };
module.exports["replaceNode"] = $40bf6b0f05eaa921$export$5542201de9311ab2;
module.exports["getNode"] = $40bf6b0f05eaa921$export$3f778c4e796a1f9c;

});

parcelRegister("31JyQ", function(module, exports) {

var $hdvEd = parcelRequire("hdvEd");

var $gIRc3 = parcelRequire("gIRc3");


var $jbOus = parcelRequire("jbOus");


var $kpCD8 = parcelRequire("kpCD8");


var $gLqwM = parcelRequire("gLqwM");


var $kCECX = parcelRequire("kCECX");


var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");


var $lAynq = parcelRequire("lAynq");

const $5b0a3c9a072181ad$export$588b8cd7ca34b82 = new (0, $kCECX.PluginKey)('localIdPlugin');
const $5b0a3c9a072181ad$var$generateUUID = ()=>{
    return (0, $lAynq.generateShortUUID)();
};
// Fallback for Safari which doesn't support requestIdleCallback
const $5b0a3c9a072181ad$var$requestIdleCallbackWithFallback = (callback)=>{
    if (typeof requestIdleCallback !== 'undefined') requestIdleCallback(callback);
    else // Fallback to requestAnimationFrame for Safari
    requestAnimationFrame(callback);
};
const $5b0a3c9a072181ad$export$ae829ec7b2625219 = (api)=>{
    // Track if we've initialized existing UUIDs for this plugin instance
    let hasInitializedExistingUUIDs = false;
    return new (0, $kpCD8.SafePlugin)({
        key: $5b0a3c9a072181ad$export$588b8cd7ca34b82,
        view: (editorView)=>{
            /**
			 * This performs a one-time scan of the document to add local IDs
			 * to nodes that don't have them. It's designed to run only once per
			 * editor instance to avoid performance issues.
			 */ if (api?.collabEdit) return {
                update: ()=>{}
            };
            $5b0a3c9a072181ad$var$requestIdleCallbackWithFallback(()=>{
                const tr = editorView.state.tr;
                const nodesToUpdate = new Map(); // position -> localId
                const { text: text, hardBreak: hardBreak, mediaGroup: mediaGroup } = editorView.state.schema.nodes;
                // Media group is ignored for now
                // https://bitbucket.org/atlassian/adf-schema/src/fb2236147a0c2bc9c8efbdb75fd8f8c411df44ba/packages/adf-schema/src/next-schema/nodes/mediaGroup.ts#lines-12
                const ignoredNodeTypes = mediaGroup ? [
                    text.name,
                    hardBreak.name,
                    mediaGroup.name
                ] : [
                    text.name,
                    hardBreak.name
                ];
                editorView.state.doc.descendants((node, pos)=>{
                    if (!ignoredNodeTypes.includes(node.type.name) && !node.attrs.localId && !!node.type.spec.attrs?.localId) nodesToUpdate.set(pos, $5b0a3c9a072181ad$var$generateUUID());
                    return true; // Continue traversing
                });
                if (nodesToUpdate.size > 0) {
                    $5b0a3c9a072181ad$export$6722232dcd7a6b1b(nodesToUpdate, tr);
                    (0, $jbOus.tintDirtyTransaction)(tr);
                    editorView.dispatch(tr);
                }
            });
            return {
                update: ()=>{}
            };
        },
        /**
		 * Handles adding local IDs to new nodes that are created and have the localId attribute
		 * This ensures uniqueness of localIds on nodes being created or edited
		 */ appendTransaction: (transactions, _oldState, newState)=>{
            if (api?.composition.sharedState.currentState()?.isComposing) return undefined;
            let modified = false;
            const tr = newState.tr;
            const { text: text, hardBreak: hardBreak, mediaGroup: mediaGroup } = newState.schema.nodes;
            // Media group is ignored for now
            // https://bitbucket.org/atlassian/adf-schema/src/fb2236147a0c2bc9c8efbdb75fd8f8c411df44ba/packages/adf-schema/src/next-schema/nodes/mediaGroup.ts#lines-12
            const ignoredNodeTypes = [
                text?.name,
                hardBreak?.name,
                mediaGroup?.name
            ];
            const addedNodes = new Set();
            // A single PMNode reference can appear at multiple positions in the doc (e.g.
            // `createTable` from `prosemirror-utils` reuses cell node objects across
            // non-header rows), so the new code path tracks every position per node identity.
            // The legacy path retains the single-position-per-node map for compatibility.
            const positionsByNode = new Map();
            const addedNodePos = new Map();
            const localIds = new Set();
            const nodesToUpdate = new Map(); // position -> localId
            // Process only the nodes added in the transactions
            transactions.forEach((transaction)=>{
                if (!transaction.docChanged) return;
                if ((0, $ieeJu.expValEquals)('platform_editor_ai_template_localids', 'isEnabled', true)) {
                    if (transaction.getMeta('uiEvent') === 'cut' || // We skip remote transactions as we don't want to affect transactions
                    // created by other collaborators.
                    //
                    // Exception (platform_editor_ai_template_localids): applying a template to a
                    // blank page arrives as a remote OverrideDocumentStep (a full-document
                    // replacement with no localIds). We still want those template nodes to get
                    // localIds, so we let such transactions through. Ordinary remote edits are
                    // still skipped, and existing localIds are never overwritten.
                    Boolean(transaction.getMeta('isRemote')) && !transaction.steps.some((step)=>step instanceof (0, $gIRc3.OverrideDocumentStep))) return;
                } else {
                    if (transaction.getMeta('uiEvent') === 'cut' || // We skip remote transactions as we don't want to affect transactions created
                    // by other users
                    Boolean(transaction.getMeta('isRemote'))) return;
                }
                // Ignore local ID updates for certain transactions
                // this is purposely not a public API as we should not use
                // this except in some circumstances (ie. streaming)
                if (transaction.getMeta('ignoreLocalIdUpdate')) return;
                transaction.steps.forEach((step)=>{
                    // Steps with a slice are scanned for nodes that need localIds.
                    // OverrideDocumentStep (template replacement) has no `slice`, so when the
                    // experiment is on we also scan it so the inserted template nodes get
                    // localIds.
                    const isTemplateOverrideStep = step instanceof (0, $gIRc3.OverrideDocumentStep) && (0, $ieeJu.expValEquals)('platform_editor_ai_template_localids', 'isEnabled', true);
                    if (!(0, $gLqwM.stepHasSlice)(step) && !isTemplateOverrideStep) return;
                    step.getMap().forEach((oldStart, oldEnd, newStart, newEnd)=>{
                        // Scan the changed range to find all nodes
                        tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node, pos)=>{
                            if (ignoredNodeTypes.includes(node.type.name) || !node.type.spec.attrs?.localId) return true;
                            modified = true;
                            if ((0, $ixfCV.fg)('platform_editor_use_localid_dedupe')) {
                                // Always add to addedNodes for duplicate prevention
                                addedNodes.add(node);
                                if ((0, $ieeJu.expValEquals)('platform_editor_ai_tablecell_localids', 'isEnabled', true)) {
                                    const positions = positionsByNode.get(node) ?? new Set();
                                    positions.add(pos);
                                    positionsByNode.set(node, positions);
                                } else addedNodePos.set(node, pos);
                            } else if (!node?.attrs.localId) nodesToUpdate.set(pos, $5b0a3c9a072181ad$var$generateUUID());
                            return true;
                        });
                    });
                });
            });
            if (addedNodes.size > 0 && (0, $ixfCV.fg)('platform_editor_use_localid_dedupe')) {
                newState.doc.descendants((node)=>{
                    // Also track existing UUIDs in the global Set for short UUID collision detection
                    if (node.attrs?.localId && !hasInitializedExistingUUIDs) (0, $lAynq.generatedShortUUIDs).add(node.attrs.localId);
                    if (addedNodes.has(node)) return true;
                    localIds.add(node.attrs.localId);
                    return true;
                });
                hasInitializedExistingUUIDs = true;
                // Also ensure the added have no duplicates
                const seenIds = new Set();
                if ((0, $ieeJu.expValEquals)('platform_editor_ai_tablecell_localids', 'isEnabled', true)) for (const node of addedNodes){
                    const positions = positionsByNode.get(node);
                    if (!positions || positions.size === 0) continue;
                    const existingId = node.attrs.localId;
                    const needsNewIds = !existingId || localIds.has(existingId) || seenIds.has(existingId);
                    if (needsNewIds) // No usable localId: assign a fresh unique one to every position.
                    for (const pos of positions){
                        const newId = $5b0a3c9a072181ad$var$generateUUID();
                        nodesToUpdate.set(pos, newId);
                        seenIds.add(newId);
                        modified = true;
                    }
                    else if (positions.size > 1) {
                        // Shared node reference: keep the existing id at the first position,
                        // assign fresh ones to the rest so they don't share the same localId.
                        seenIds.add(existingId);
                        const [_first, ...rest] = Array.from(positions);
                        for (const pos of rest){
                            const newId = $5b0a3c9a072181ad$var$generateUUID();
                            nodesToUpdate.set(pos, newId);
                            seenIds.add(newId);
                            modified = true;
                        }
                    } else if (existingId) seenIds.add(existingId);
                }
                else for (const node of addedNodes){
                    if (!node.attrs.localId || localIds.has(node.attrs.localId) || seenIds.has(node.attrs.localId)) {
                        const pos = addedNodePos.get(node);
                        if (pos !== undefined) {
                            const newId = $5b0a3c9a072181ad$var$generateUUID();
                            nodesToUpdate.set(pos, newId);
                            seenIds.add(newId);
                            modified = true;
                        }
                    }
                    if (node.attrs.localId) seenIds.add(node.attrs.localId);
                }
            }
            // Apply local ID updates based on the improvements feature flag:
            // - When enabled: Batch all updates into a single BatchAttrsStep
            // - When disabled: Individual steps were already applied above during node processing
            if (modified && nodesToUpdate.size > 0) $5b0a3c9a072181ad$export$6722232dcd7a6b1b(nodesToUpdate, tr);
            return modified ? tr : undefined;
        }
    });
};
const $5b0a3c9a072181ad$export$6722232dcd7a6b1b = (nodesToUpdate, tr)=>{
    const batchData = Array.from(nodesToUpdate.entries()).map(([pos, localId])=>{
        const node = tr.doc.nodeAt(pos);
        if (!node) throw new Error(`Node does not exist at position ${pos}`);
        return {
            position: pos,
            attrs: {
                localId: localId
            },
            nodeType: node.type.name
        };
    });
    tr.step(new (0, $hdvEd.BatchAttrsStep)(batchData));
    tr.setMeta('addToHistory', false);
};
module.exports["createPlugin"] = $5b0a3c9a072181ad$export$ae829ec7b2625219;

});

parcelRegister("lAynq", function(module, exports) {

var $2nOF5 = parcelRequire("2nOF5");

const $e2423c7c0afd9a06$export$f710f46299736b99 = new Set();
const $e2423c7c0afd9a06$export$cafea8c01b062dd4 = ()=>{
    const maxRetries = 10;
    for(let attempt = 0; attempt < maxRetries; attempt++)try {
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        const shortUUID = crypto.randomUUID().split('-')[4];
        if (!$e2423c7c0afd9a06$export$f710f46299736b99.has(shortUUID)) {
            $e2423c7c0afd9a06$export$f710f46299736b99.add(shortUUID);
            return shortUUID;
        }
    } catch  {
        break;
    }
    // Fallback to full UUID if short UUID generation fails or max retries exceeded
    return (0, $2nOF5.uuid).generate();
};
module.exports["generatedShortUUIDs"] = $e2423c7c0afd9a06$export$f710f46299736b99;
module.exports["generateShortUUID"] = $e2423c7c0afd9a06$export$cafea8c01b062dd4;

});

parcelRegister("fkaeB", function(module, exports) {

var $hdvEd = parcelRequire("hdvEd");

var $1A89X = parcelRequire("1A89X");


var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $eOaGc = parcelRequire("eOaGc");

/**
 * This is a safeguard limit to avoid tracking localIds in extremely large documents with too many localIds.
 * If the number of unique localIds exceeds this limit, the watchmen plugin will disable itself to avoid performance issues.
 * Reminder: The Map has a hard limit of 2^24 (16 million) entries in V8, please keep this value well below that
 * to avoid any potential memory issues.
 */ const $a343dc14c5fe8177$var$MAX_LOCAL_ID_MAP_SIZE = 2097152; // 2^21
const $a343dc14c5fe8177$export$a45751f625b5b80e = new (0, $kCECX.PluginKey)('localIdWatchmenPlugin');
/**
 * Scans the entire document to find all active localIds
 */ const $a343dc14c5fe8177$var$scanDocumentForLocalIds = (doc)=>{
    const localIds = new Set();
    doc.descendants((node)=>{
        if (node.attrs?.localId) localIds.add(node.attrs.localId);
        // Check marks for localIds
        if (node.marks) node.marks.forEach((mark)=>{
            if (mark.attrs?.localId) localIds.add(mark.attrs.localId);
        });
        return localIds.size < $a343dc14c5fe8177$var$MAX_LOCAL_ID_MAP_SIZE; // Continue traversing
    });
    return localIds;
};
const $a343dc14c5fe8177$var$getReplacementStatusCode = (tr, step)=>{
    let method;
    if (step instanceof (0, $eOaGc.AttrStep) || step instanceof (0, $eOaGc.DocAttrStep)) method = 'ByAttr';
    else if (step instanceof (0, $1A89X.SetAttrsStep)) method = 'BySetAttrs';
    else if (step instanceof (0, $hdvEd.BatchAttrsStep)) method = 'ByBatchAttrs';
    else if (step instanceof (0, $eOaGc.ReplaceStep)) {
        const isDeleting = step.from < step.to; // range has content to remove
        const isInserting = step.slice.content.size > 0; // slice has content to insert
        if (isDeleting && !isInserting) method = 'ByDelete'; // removing content, inserting nothing
        else // isDeleting && isInserting
        method = 'ByReplace';
    } else if (step instanceof (0, $eOaGc.ReplaceAroundStep)) method = 'ByReplaceAround';
    else method = 'ByUnknown';
    if (tr.getMeta('isAIStreamingTransformation')) return `AIChange${method}`;
    if (tr.getMeta('replaceDocument')) return `docChange${method}`;
    if (tr.getMeta('isRemote')) return `remoteChange${method}`;
    return `localChange${method}`;
};
/**
 * Handles AttrStep and DocAttrStep which modify a single attribute
 */ const $a343dc14c5fe8177$var$handleAttrStep = (tr, step, localIdStatus, preDoc)=>{
    if (step.attr !== 'localId') return {
        localIdStatus: localIdStatus,
        modified: false
    };
    let modified = false;
    const newlocalIdStatus = new Map(localIdStatus);
    // Get the old value if it exists
    let oldLocalId;
    if (step instanceof (0, $eOaGc.AttrStep)) try {
        const node = preDoc.nodeAt(step.pos);
        oldLocalId = node?.attrs?.localId;
    } catch  {
    // Position might be invalid
    }
    // Handle the new value
    const newLocalId = step.value;
    if (oldLocalId && oldLocalId !== newLocalId) {
        // Old localId is being replaced or removed
        newlocalIdStatus.set(oldLocalId, $a343dc14c5fe8177$var$getReplacementStatusCode(tr, step));
        modified = true;
    }
    if (newLocalId) {
        newlocalIdStatus.set(newLocalId, 'current');
        modified = true;
    }
    return {
        localIdStatus: newlocalIdStatus,
        modified: modified
    };
};
/**
 * Handles SetAttrsStep which sets multiple attributes at once
 */ const $a343dc14c5fe8177$var$handleSetAttrsStep = (tr, step, localIdStatus, preDoc)=>{
    const attrs = step.attrs;
    if (!attrs || !attrs.hasOwnProperty('localId')) return {
        localIdStatus: localIdStatus,
        modified: false
    };
    let modified = false;
    const newlocalIdStatus = new Map(localIdStatus);
    // Get old localId from the node being modified
    try {
        const node = preDoc.nodeAt(step.pos);
        const oldLocalId = node?.attrs?.localId;
        if (oldLocalId && oldLocalId !== attrs.localId) {
            newlocalIdStatus.set(oldLocalId, $a343dc14c5fe8177$var$getReplacementStatusCode(tr, step));
            modified = true;
        }
    } catch  {
    // Position might be invalid
    }
    const newLocalId = attrs.localId;
    if (newLocalId) {
        newlocalIdStatus.set(newLocalId, 'current');
        modified = true;
    }
    return {
        localIdStatus: newlocalIdStatus,
        modified: modified
    };
};
/**
 * Handles BatchAttrsStep which applies multiple attribute changes
 */ const $a343dc14c5fe8177$var$handleBatchAttrsStep = (tr, step, localIdStatus, preDoc)=>{
    let modified = false;
    const newlocalIdStatus = new Map(localIdStatus);
    step.data.forEach((change)=>{
        if (!change.attrs?.hasOwnProperty('localId')) return;
        // Get old localId from the node being modified
        try {
            const node = preDoc.nodeAt(change.position);
            const oldLocalId = node?.attrs?.localId;
            const newLocalId = change.attrs.localId;
            if (oldLocalId && oldLocalId !== newLocalId) {
                newlocalIdStatus.set(oldLocalId, $a343dc14c5fe8177$var$getReplacementStatusCode(tr, step));
                modified = true;
            }
            if (newLocalId) {
                newlocalIdStatus.set(newLocalId, 'current');
                modified = true;
            }
        } catch  {
        // Position might be invalid
        }
    });
    return {
        localIdStatus: newlocalIdStatus,
        modified: modified
    };
};
/**
 * Handles ReplaceStep which inserts or deletes content
 */ const $a343dc14c5fe8177$var$handleReplaceStep = (tr, step, localIdStatus, preDoc, postDoc)=>{
    let modified = false;
    try {
        // Create a temporary set to collect new localIds
        const changedLocaleIds = new Map();
        const replaceCode = $a343dc14c5fe8177$var$getReplacementStatusCode(tr, step);
        step.getMap().forEach((oldStart, oldEnd, newStart, newEnd)=>{
            // For each step map item we can just look at the nodes in the old doc and mark them as "inactive" and then
            // look at the nodes in the doc after the step has been applied and mark them as "active"
            // then lastly we can compare these to the current states and only update what's different.
            preDoc.nodesBetween(oldStart, oldEnd, (node)=>{
                if (node.attrs?.localId) changedLocaleIds.set(node.attrs.localId, replaceCode);
                if (node.marks) node.marks.forEach((mark)=>{
                    if (mark.attrs?.localId) changedLocaleIds.set(node.attrs.localId, replaceCode);
                });
            });
            postDoc.nodesBetween(newStart, newEnd, (node)=>{
                if (node.attrs?.localId) changedLocaleIds.set(node.attrs.localId, 'current');
                if (node.marks) node.marks.forEach((mark)=>{
                    if (mark.attrs?.localId) changedLocaleIds.set(node.attrs.localId, 'current');
                });
            });
        });
        if (!!changedLocaleIds.size) {
            const newlocalIdStatus = new Map(localIdStatus);
            for (const [key, value] of changedLocaleIds)if (!localIdStatus.has(key) || localIdStatus.get(key) !== value) {
                modified = true;
                newlocalIdStatus.set(key, value);
            }
            return {
                localIdStatus: newlocalIdStatus,
                modified: modified
            };
        }
    } catch  {
    // If position calculation fails, do a full document rescan as fallback
    // This shouldn't happen often but provides safety
    }
    return {
        localIdStatus: localIdStatus,
        modified: modified
    };
};
/**
 * Handles ReplaceAroundStep which wraps or unwraps content
 */ const $a343dc14c5fe8177$var$handleReplaceAroundStep = (tr, step, localIdStatus, preDoc, postDoc)=>{
    let modified = false;
    const newlocalIdStatus = new Map(localIdStatus);
    // Scan the affected region before and after the step
    const from = step.from;
    const to = step.to;
    try {
        // Collect localIds from the old region
        const oldLocalIds = new Set();
        if (from < to && from >= 0 && to <= preDoc.content.size) preDoc.nodesBetween(from, to, (node)=>{
            if (node.attrs?.localId) oldLocalIds.add(node.attrs.localId);
            if (node.marks) node.marks.forEach((mark)=>{
                if (mark.attrs?.localId) oldLocalIds.add(mark.attrs.localId);
            });
        });
        // Collect localIds from the new region
        const map = step.getMap();
        const newFrom = map.map(from, -1);
        const newTo = map.map(to, 1);
        const newLocalIds = new Set();
        if (newFrom < newTo && newFrom >= 0 && newTo <= postDoc.content.size) postDoc.nodesBetween(newFrom, newTo, (node)=>{
            if (node.attrs?.localId) newLocalIds.add(node.attrs.localId);
            if (node.marks) node.marks.forEach((mark)=>{
                if (mark.attrs?.localId) newLocalIds.add(mark.attrs.localId);
            });
        });
        // Find localIds that were removed
        oldLocalIds.forEach((localId)=>{
            if (!newLocalIds.has(localId) && newlocalIdStatus.get(localId) === 'current') {
                newlocalIdStatus.set(localId, $a343dc14c5fe8177$var$getReplacementStatusCode(tr, step));
                modified = true;
            }
        });
        // Find localIds that were added
        newLocalIds.forEach((localId)=>{
            if (!oldLocalIds.has(localId)) {
                newlocalIdStatus.set(localId, 'current');
                modified = true;
            }
        });
    } catch  {
    // Position might be invalid, skip this step
    }
    return {
        localIdStatus: newlocalIdStatus,
        modified: modified
    };
};
/**
 * Processes a transaction to update localId tracking state
 */ const $a343dc14c5fe8177$var$processTransaction = (tr, currentState)=>{
    let localIdStatus = currentState.localIdStatus;
    let modified = false;
    // Process each step in the transaction
    try {
        tr.steps.forEach((step, index)=>{
            let result;
            // steps are relative to their docs, so we ensure we reference the doc before/after the step was applied.
            const preDoc = tr.docs?.[index] ?? tr.doc;
            const postDoc = tr.docs?.[index + 1] ?? tr.doc;
            if (step instanceof (0, $eOaGc.AttrStep) || step instanceof (0, $eOaGc.DocAttrStep)) result = $a343dc14c5fe8177$var$handleAttrStep(tr, step, localIdStatus, preDoc);
            else if (step instanceof (0, $1A89X.SetAttrsStep)) result = $a343dc14c5fe8177$var$handleSetAttrsStep(tr, step, localIdStatus, preDoc);
            else if (step instanceof (0, $hdvEd.BatchAttrsStep)) result = $a343dc14c5fe8177$var$handleBatchAttrsStep(tr, step, localIdStatus, preDoc);
            else if (step instanceof (0, $eOaGc.ReplaceStep)) result = $a343dc14c5fe8177$var$handleReplaceStep(tr, step, localIdStatus, preDoc, postDoc);
            else if (step instanceof (0, $eOaGc.ReplaceAroundStep)) result = $a343dc14c5fe8177$var$handleReplaceAroundStep(tr, step, localIdStatus, preDoc, postDoc);
            else // Unknown step type, no changes
            result = {
                localIdStatus: localIdStatus,
                modified: false
            };
            localIdStatus = result.localIdStatus;
            modified = modified || result.modified;
        });
    } catch  {
        // If any error occurs during step processing, we fallback to disabling the plugin
        return {
            enabled: false,
            initLocalIdSize: currentState.initLocalIdSize,
            localIdStatus: new Map(),
            lastUpdated: Date.now()
        };
    }
    // If nothing changed, return the same state object
    if (!modified) return currentState;
    // If we exceeded the max size while processing the steps, we need to disable the watchmen from further processing.
    // If a Map size limit of 2^24 is exceeded then it's more than likely an error would have been thrown during processing
    // which would also disable this plugin.
    if (localIdStatus.size >= $a343dc14c5fe8177$var$MAX_LOCAL_ID_MAP_SIZE) return {
        enabled: false,
        initLocalIdSize: currentState.initLocalIdSize,
        localIdStatus: new Map(),
        lastUpdated: Date.now()
    };
    // Return new state with updated sets
    return {
        enabled: true,
        initLocalIdSize: currentState.initLocalIdSize,
        localIdStatus: localIdStatus,
        lastUpdated: Date.now()
    };
};
const $a343dc14c5fe8177$export$69a1d29561fe4403 = (api)=>{
    // Ensure limited mode is initialized
    return new (0, $kpCD8.SafePlugin)({
        key: $a343dc14c5fe8177$export$a45751f625b5b80e,
        state: {
            init (_config, state) {
                const isLimitedModeEnabled = api?.limitedMode?.sharedState.currentState()?.enabled ?? false;
                if (isLimitedModeEnabled) return {
                    enabled: false,
                    initLocalIdSize: -1,
                    localIdStatus: new Map(),
                    lastUpdated: Date.now()
                };
                // Initialize by scanning the entire document
                const activeLocalIds = $a343dc14c5fe8177$var$scanDocumentForLocalIds(state.doc);
                if (activeLocalIds.size >= $a343dc14c5fe8177$var$MAX_LOCAL_ID_MAP_SIZE) return {
                    enabled: false,
                    initLocalIdSize: activeLocalIds.size,
                    localIdStatus: new Map(),
                    lastUpdated: Date.now()
                };
                return {
                    enabled: true,
                    initLocalIdSize: activeLocalIds.size,
                    localIdStatus: new Map(Array.from(activeLocalIds).map((key)=>[
                            key,
                            'current'
                        ])),
                    lastUpdated: Date.now()
                };
            },
            apply (tr, currentPluginState) {
                const { enabled: enabled } = tr.getMeta($a343dc14c5fe8177$export$a45751f625b5b80e) || {
                    enabled: currentPluginState.enabled
                };
                const newPluginState = currentPluginState;
                if (enabled !== currentPluginState.enabled) {
                    // If this plugin enabled state is changing and it's being disabled at runtime then we will kill this plugin
                    // to avoid tracking localIds when in limited mode or there after.
                    // Once disabled it cannot be re-enabled without a full editor reload.
                    if (!enabled) return {
                        enabled: false,
                        initLocalIdSize: currentPluginState.initLocalIdSize,
                        localIdStatus: currentPluginState.localIdStatus,
                        lastUpdated: Date.now()
                    };
                }
                if (!newPluginState.enabled) // If this plugin has been disabled, do not track localIds.
                return newPluginState;
                // If no steps, nothing changed
                if (tr.steps.length === 0 || !tr.docChanged) return newPluginState;
                // Process the transaction to update state
                return $a343dc14c5fe8177$var$processTransaction(tr, newPluginState);
            }
        },
        view (editorView) {
            // If limited mode changes, for example if we start not limited but then all of a sudden become limited, we kill
            // the watchment plugin to avoid tracking localIds when in limited mode. We also don't want/need to re-enable it once it's disabled.
            const unsub = api?.limitedMode?.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
                const watchmentPluginState = $a343dc14c5fe8177$export$a45751f625b5b80e.getState(editorView.state);
                if (nextSharedState.enabled && watchmentPluginState?.enabled === true) // if nextSharedState.enabled === true, then we need to disable the watchmen plugin, if not already disabled
                editorView.dispatch(editorView.state.tr.setMeta($a343dc14c5fe8177$export$a45751f625b5b80e, {
                    enabled: false
                }));
            });
            return {
                destroy: unsub
            };
        }
    });
};
module.exports["localIdWatchmenPluginKey"] = $a343dc14c5fe8177$export$a45751f625b5b80e;
module.exports["createWatchmenPlugin"] = $a343dc14c5fe8177$export$69a1d29561fe4403;

});

parcelRegister("ftAOO", function(module, exports) {

var $2M55c = parcelRequire("2M55c");

/**
 * Collect all components that belong to the tree rooted at `surfaceKey`.
 *
 * A surface is a root component (one with no `parents`). Starting from that
 * root, every component whose parent chain leads back to it is included.
 */ function $f252d7be92f1d2a3$var$getComponentsForSurface(allComponents, surfaceKey) {
    const root = allComponents.find((c)=>c.key === surfaceKey && (!c.parents || c.parents.length === 0));
    if (!root) return [];
    const includedKeys = new Set([
        surfaceKey
    ]);
    let changed = true;
    while(changed){
        changed = false;
        for (const component of allComponents){
            if (includedKeys.has(component.key)) continue;
            if (component.parents?.some((p)=>includedKeys.has(p.key))) {
                includedKeys.add(component.key);
                changed = true;
            }
        }
    }
    return allComponents.filter((c)=>includedKeys.has(c.key));
}
const $f252d7be92f1d2a3$export$eb211d52411e6f09 = ()=>{
    const registry = (0, $2M55c.createRegistry)();
    return {
        name: 'uiControlRegistry',
        actions: {
            register: (components)=>{
                registry.register(components);
            },
            getComponents: (surface)=>{
                return $f252d7be92f1d2a3$var$getComponentsForSurface(registry.components, surface);
            }
        }
    };
};
module.exports["uiControlRegistryPlugin"] = $f252d7be92f1d2a3$export$eb211d52411e6f09;

});

parcelRegister("2M55c", function(module, exports) {
const $60b8781de832a885$export$b877d3ed23ba6b7a = ()=>{
    const components = [];
    const register = (newComponents)=>{
        components.push(...newComponents);
    };
    return {
        register: register,
        components: components
    };
};
module.exports["createRegistry"] = $60b8781de832a885$export$b877d3ed23ba6b7a;

});

parcelRegister("51qBv", function(module, exports) {

var $561lj = parcelRequire("561lj");


var $dK6bS = parcelRequire("dK6bS");

const $4f3f5baef79264ec$export$a69eee655819c5bd = ({ api: api, config: config })=>{
    return {
        name: 'codeBlockAdvanced',
        nodes () {
            return [
                {
                    name: 'codeBlock',
                    node: (0, $561lj.codeBlockNodeWithFixedToDOM)({
                        allowCodeFolding: config?.allowCodeFolding ?? false
                    })
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'codeBlockAdvancedPlugin',
                    plugin: ({ getIntl: getIntl })=>(0, $dK6bS.createPlugin)({
                            api: api,
                            extensions: config?.extensions ?? [],
                            allowCodeFolding: config?.allowCodeFolding ?? false,
                            getIntl: getIntl
                        })
                }
            ];
        }
    };
};
module.exports["codeBlockAdvancedPlugin"] = $4f3f5baef79264ec$export$a69eee655819c5bd;

});

parcelRegister("561lj", function(module, exports) {

var $jDAs4 = parcelRequire("jDAs4");


var $6gBg9 = parcelRequire("6gBg9");


var $8Dx7s = parcelRequire("8Dx7s");


var $cRhiT = parcelRequire("cRhiT");


var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");

const $c0e4e9972d346b0c$var$codeBlockClassNames = {
    container: (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER,
    start: (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_START,
    end: (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_END,
    contentWrapper: (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER,
    contentWrapped: (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPED,
    content: (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
};
const $c0e4e9972d346b0c$var$MATCH_NEWLINES = new RegExp('\n', 'gu');
const $c0e4e9972d346b0c$var$getGutterBaseStyle = ()=>({
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        position: 'relative',
        flexShrink: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        boxSizing: 'content-box'
    });
const $c0e4e9972d346b0c$var$getGutterPadding = (allowCodeFolding)=>allowCodeFolding ? `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-100, 8px)";
const $c0e4e9972d346b0c$var$getGuttersWithLineNumbers = (content, config)=>[
        'div',
        {
            // Based on packages/editor/editor-common/src/styles/shared/code-block.ts
            // But we can't reuse that class as it adds a ::before that intefers with this approach
            style: (0, $8Dx7s.convertToInlineCss)({
                ...$c0e4e9972d346b0c$var$getGutterBaseStyle(),
                width: 'var(--lineNumberGutterWidth, 2rem)',
                /* top and bottom | left and right */ padding: $c0e4e9972d346b0c$var$getGutterPadding(config.allowCodeFolding)
            }),
            contenteditable: 'false'
        },
        [
            'div',
            {
                class: 'code-block-gutter-pseudo-element',
                style: (0, $8Dx7s.convertToInlineCss)({
                    textAlign: 'right',
                    color: "var(--ds-text-subtlest, #6B6E76)",
                    fontFamily: "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
                    whiteSpace: 'pre-wrap'
                }),
                'data-label': content
            }
        ]
    ];
const $c0e4e9972d346b0c$var$getFoldOnlyGutter = ()=>[
        'div',
        {
            style: (0, $8Dx7s.convertToInlineCss)({
                ...$c0e4e9972d346b0c$var$getGutterBaseStyle(),
                padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
            }),
            contenteditable: 'false'
        }
    ];
const $c0e4e9972d346b0c$var$getGutters = (content, config, hideLineNumbers)=>{
    if (!hideLineNumbers) return [
        $c0e4e9972d346b0c$var$getGuttersWithLineNumbers(content, config)
    ];
    if (config.allowCodeFolding) return [
        $c0e4e9972d346b0c$var$getFoldOnlyGutter()
    ];
    return [];
};
// Based on: `packages/editor/editor-plugin-code-block/src/nodeviews/code-block.ts`
const $c0e4e9972d346b0c$var$toDOM = (node, formattedAriaLabel, config)=>{
    let totalLineCount = 1;
    node.forEach((node)=>{
        const text = node.text;
        if (text) totalLineCount += (node.text.match($c0e4e9972d346b0c$var$MATCH_NEWLINES) || []).length;
    });
    const hideLineNumbers = (0, $6gBg9.areCodeBlockLineNumbersHidden)(node);
    const maxDigits = totalLineCount.toString().length;
    const content = node.textContent.split('\n').map((_, i)=>i + 1).join('\n');
    const gutters = $c0e4e9972d346b0c$var$getGutters(content, config, hideLineNumbers);
    const isCodeBlockWrapped = (0, $anBbz.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && node.attrs.wrap === true;
    const className = [
        $c0e4e9972d346b0c$var$codeBlockClassNames.container,
        isCodeBlockWrapped ? $c0e4e9972d346b0c$var$codeBlockClassNames.contentWrapped : undefined
    ].filter(Boolean).join(' ');
    return [
        'pre',
        {
            class: className,
            style: `--lineNumberGutterWidth:${maxDigits}ch;`,
            'data-language': node.attrs.language || '',
            ...(0, $anBbz.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && {
                'data-wrap': node.attrs.wrap ? 'true' : 'false',
                ...hideLineNumbers && {
                    'data-hide-line-numbers': 'true'
                }
            }
        },
        [
            'div',
            {
                class: $c0e4e9972d346b0c$var$codeBlockClassNames.start,
                contenteditable: 'false'
            }
        ],
        [
            'div',
            {
                class: $c0e4e9972d346b0c$var$codeBlockClassNames.contentWrapper
            },
            ...gutters,
            [
                'div',
                {
                    class: $c0e4e9972d346b0c$var$codeBlockClassNames.content
                },
                [
                    'code',
                    {
                        'data-language': node.attrs.language || '',
                        spellcheck: 'false',
                        'data-testid': 'code-block--code',
                        'aria-label': formattedAriaLabel,
                        ...(0, $ixfCV.fg)('platform_editor_adf_with_localid') && {
                            'data-local-id': node.attrs.localId
                        }
                    },
                    0
                ]
            ]
        ],
        [
            'div',
            {
                class: $c0e4e9972d346b0c$var$codeBlockClassNames.end,
                contenteditable: 'false'
            }
        ]
    ];
};
const $c0e4e9972d346b0c$export$3cf83e71c577e77b = (config)=>{
    return {
        ...(0, $ieeJu.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true) ? (0, $jDAs4.codeBlock) : (0, $ixfCV.fg)('platform_editor_adf_with_localid') ? (0, $jDAs4.codeBlockWithLocalId) : (0, $jDAs4.codeBlock),
        toDOM: (node)=>$c0e4e9972d346b0c$var$toDOM(node, '', config)
    };
};
module.exports["codeBlockNodeWithFixedToDOM"] = $c0e4e9972d346b0c$export$3cf83e71c577e77b;

});

parcelRegister("dK6bS", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $ixu0Q = parcelRequire("ixu0Q");


var $kz1SL = parcelRequire("kz1SL");

const $7df39c642c535c5a$export$ae829ec7b2625219 = (props)=>{
    return new (0, $kpCD8.SafePlugin)({
        props: {
            nodeViews: {
                codeBlock: (0, $ixu0Q.lazyCodeBlockView)(props)
            },
            // Custom selection behaviour to fix issues with codeblocks with Shift + Arrow{Up || Down}
            // These issues are also present in the prosemirror codemirror example and @marijnh suggests to
            // use custom event handlers: https://github.com/ProseMirror/website/issues/83
            handleKeyDown (view, event) {
                if (!(event instanceof KeyboardEvent)) return false;
                if (event.key === 'ArrowUp' && event.shiftKey) return (0, $kz1SL.shiftArrowUpWorkaround)(view, event);
                else if (event.key === 'ArrowDown' && event.shiftKey) return (0, $kz1SL.shiftArrowDownWorkaround)(view, event);
            }
        }
    });
};
module.exports["createPlugin"] = $7df39c642c535c5a$export$ae829ec7b2625219;

});

parcelRegister("ixu0Q", function(module, exports) {

var $hMfrQ = parcelRequire("hMfrQ");


const $766d24dab7d8c4dd$export$28da8fbeb01202c6 = (props)=>{
    return (0, $hMfrQ.withLazyLoading)({
        nodeName: 'codeBlock',
        getNodeViewOptions: ()=>{},
        loader: async ()=>{
            const { getCodeBlockAdvancedNodeView: getCodeBlockAdvancedNodeView } = await (parcelRequire("iQMGH"));
            return (node, view, getPos, _decs, _nodeViewOptions, innerDecorations)=>getCodeBlockAdvancedNodeView(props)(node, view, getPos, innerDecorations);
        }
    });
};
module.exports["lazyCodeBlockView"] = $766d24dab7d8c4dd$export$28da8fbeb01202c6;

});

parcelRegister("iQMGH", function(module, exports) {

let $db92d9b51f947d91$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $db92d9b51f947d91$var$load("fBohe"),
    $db92d9b51f947d91$var$load("gx3t5"),
    $db92d9b51f947d91$var$load("hmrCV")
]).then(()=>parcelRequire('kDxNm'));

});

parcelRegister("kz1SL", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $12e69e2dcfc4bd75$export$d4559115ffe0b372 = (view, event)=>{
    const { doc: doc, selection: { $head: $head, $anchor: $anchor }, tr: tr, schema: { nodes: { codeBlock: codeBlock } } } = view.state;
    // Position we want to check (directly after our current position)
    const pos = Math.max($head.pos - 1, 1);
    const isNodeBefore = doc.resolve(pos).nodeBefore?.type === codeBlock;
    const maybeProblematicNode = isNodeBefore ? doc.resolve(pos).nodeBefore : doc.resolve(pos).node();
    if (maybeProblematicNode?.type === codeBlock) {
        const nodeSize = maybeProblematicNode.nodeSize;
        const startPos = isNodeBefore ? pos : $head.pos;
        tr.setSelection((0, $kCECX.TextSelection).create(doc, $anchor.pos, Math.max(startPos - nodeSize, 0)));
        view.dispatch(tr);
        event.preventDefault();
        return true;
    }
    return false;
};
const $12e69e2dcfc4bd75$export$ba335e235e59f4ed = (view, event)=>{
    const { doc: doc, selection: { $head: $head, $anchor: $anchor }, tr: tr, schema: { nodes: { codeBlock: codeBlock } } } = view.state;
    // Position we want to check (directly after our current position)
    const pos = $head.pos + 1;
    const isNodeAfter = doc.resolve(pos).nodeAfter?.type === codeBlock;
    const maybeProblematicNode = isNodeAfter ? doc.resolve(pos).nodeAfter : doc.resolve(pos).node();
    if (maybeProblematicNode?.type === codeBlock) {
        const nodeSize = maybeProblematicNode.nodeSize;
        const startPos = isNodeAfter ? pos : $head.pos;
        tr.setSelection((0, $kCECX.TextSelection).create(doc, $anchor.pos, Math.min(startPos + nodeSize, doc.content.size)));
        view.dispatch(tr);
        event.preventDefault();
        return true;
    }
    return false;
};
module.exports["shiftArrowUpWorkaround"] = $12e69e2dcfc4bd75$export$d4559115ffe0b372;
module.exports["shiftArrowDownWorkaround"] = $12e69e2dcfc4bd75$export$ba335e235e59f4ed;

});

parcelRegister("1U7Jq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1ptyh = parcelRequire("1ptyh");


var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $klpad = parcelRequire("klpad");


var $8dubf = parcelRequire("8dubf");


var $lpCJp = parcelRequire("lpCJp");


var $3qA9L = parcelRequire("3qA9L");


var $4KwOr = parcelRequire("4KwOr");


var $cjq97 = parcelRequire("cjq97");


var $9trAT = parcelRequire("9trAT");

const $dc90d7d40da4ba04$export$8751de4ba1d9a8f9 = ({ api: api })=>{
    const editorAnalyticsAPI = api?.analytics?.actions;
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const primaryToolbarComponent = ({ popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, editorView: editorView })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cjq97.PrimaryToolbarHighlightColorWithIntl), {
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            disabled: disabled,
            isToolbarReducedSpacing: isToolbarReducedSpacing,
            pluginInjectionApi: api,
            editorView: editorView
        });
    };
    if (!isToolbarAIFCEnabled) api?.primaryToolbar?.actions.registerComponent({
        name: 'highlight',
        component: primaryToolbarComponent
    });
    else api?.toolbar?.actions.registerComponents((0, $9trAT.getToolbarComponent)(api));
    return {
        name: 'highlight',
        marks () {
            if ((0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true) || (0, $ieeJu.expValEquals)('platform_editor_lovability_color_schema_change', 'isEnabled', true)) return [
                {
                    name: 'backgroundColor',
                    mark: (0, $1ptyh.backgroundColor)
                }
            ];
            // color is defined in platform/packages/editor/adf-schema/src/next-schema/marks/color.ts
            return [
                {
                    name: 'backgroundColor',
                    mark: {
                        ...(0, $1ptyh.backgroundColor),
                        excludes: 'color'
                    }
                }
            ];
        },
        commands: {
            changeColor: (0, $klpad.changeColor)(editorAnalyticsAPI)
        },
        pmPlugins: ()=>{
            const plugins = [
                {
                    name: 'highlight',
                    plugin: ()=>(0, $3qA9L.createPlugin)({
                            api: api
                        })
                },
                {
                    name: 'highlightKeymap',
                    plugin: ()=>(0, $lpCJp.keymapPlugin)({
                            api: api
                        })
                },
                {
                    name: 'highlightPadding',
                    plugin: ()=>(0, $8dubf.createHighlightPaddingPlugin)()
                }
            ];
            return plugins;
        },
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $3qA9L.highlightPluginKey).getState(editorState);
        },
        pluginsOptions: !isToolbarAIFCEnabled ? {
            selectionToolbar () {
                const toolbarDocking = (0, $ixfCV.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition : api?.selectionToolbar?.sharedState?.currentState()?.toolbarDocking;
                if (toolbarDocking === 'none' && (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1', {
                    exposure: true
                })) {
                    const toolbarCustom = {
                        type: 'custom',
                        render: (view, _idx, dispatchAnalyticsEvent)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4KwOr.FloatingToolbarHighlightColorWithIntl), {
                                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                                pluginInjectionApi: api,
                                editorView: view
                            }),
                        fallback: []
                    };
                    const rank = (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? 5 : -9;
                    return {
                        rank: rank,
                        isToolbarAbove: true,
                        items: [
                            toolbarCustom
                        ],
                        pluginName: 'highlight'
                    };
                } else return undefined;
            }
        } : {},
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined
    };
};
module.exports["highlightPlugin"] = $dc90d7d40da4ba04$export$8751de4ba1d9a8f9;

});

parcelRegister("klpad", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $5tsXu = parcelRequire("5tsXu");

var $bhf6v = parcelRequire("bhf6v");


var $2RAus = parcelRequire("2RAus");


var $evFm2 = parcelRequire("evFm2");

var $1jFAi = parcelRequire("1jFAi");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $3qA9L = parcelRequire("3qA9L");


var $fMLvg = parcelRequire("fMLvg");

const $aab02ab2394ccf36$var$maybeSyncSelectionAfterFormat = (tr)=>{
    if (tr.docChanged && (0, $ieeJu.expValEquals)('platform_editor_fix_selection_text_color_change', 'isEnabled', true)) tr.setMeta((0, $2RAus.FORMAT_SELECTION_SYNC_META), true);
};
const $aab02ab2394ccf36$export$917538e4f4eb20f9 = (editorAnalyticsAPI)=>({ color: color, inputMethod: inputMethod })=>({ tr: tr })=>{
            const { marks: marks } = tr.doc.type.schema;
            const { backgroundColor: backgroundColor } = tr.doc.type.schema.marks;
            if (!backgroundColor) return null;
            editorAnalyticsAPI?.attachAnalyticsEvent($aab02ab2394ccf36$var$createAnalyticsEvent(color, inputMethod, tr))(tr);
            tr.scrollIntoView();
            if (color === (0, $evFm2.REMOVE_HIGHLIGHT_COLOR)) (0, $5tsXu.removeMark)(backgroundColor)({
                tr: tr
            });
            else {
                if ((0, $ieeJu.expValEquals)('platform_editor_lovability_color_schema_change', 'isEnabled', true) && !(0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true)) {
                    const overrideMarks = [
                        'textColor'
                    ];
                    overrideMarks.forEach((mark)=>{
                        if (marks[mark]) (0, $5tsXu.removeMark)(marks[mark])({
                            tr: tr
                        });
                    });
                }
                tr.setMeta((0, $3qA9L.highlightPluginKey), {
                    type: (0, $3qA9L.HighlightPluginAction).CHANGE_COLOR,
                    color: color
                });
                (0, $bhf6v.toggleMark)(backgroundColor, {
                    color: color
                })({
                    tr: tr
                });
            }
            $aab02ab2394ccf36$var$maybeSyncSelectionAfterFormat(tr);
            return tr;
        };
const $aab02ab2394ccf36$var$createAnalyticsEvent = (color, inputMethod, tr)=>{
    const previousColor = (0, $fMLvg.getActiveColor)(tr) ?? (0, $evFm2.REMOVE_HIGHLIGHT_COLOR);
    const highlightPalette = (0, $anBbz.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) ? (0, $1jFAi.highlightColorPaletteNew) : (0, $evFm2.highlightColorPalette);
    // get color names from palette
    const newColorFromPalette = highlightPalette.find(({ value: value })=>value === color);
    const previousColorFromPalette = highlightPalette.find(({ value: value })=>value === previousColor);
    const newColorLabel = newColorFromPalette ? newColorFromPalette.label : color;
    const previousColorLabel = previousColorFromPalette ? previousColorFromPalette.label : previousColor;
    return {
        action: (0, $krYZG.ACTION).FORMATTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            newColor: newColorLabel.toLowerCase(),
            previousColor: previousColorLabel ? previousColorLabel.toLowerCase() : '',
            inputMethod: inputMethod
        }
    };
};
module.exports["changeColor"] = $aab02ab2394ccf36$export$917538e4f4eb20f9;

});

parcelRegister("1jFAi", function(module, exports) {

var $1ptyh = parcelRequire("1ptyh");


var $xx2Zf = parcelRequire("xx2Zf");


var $evFm2 = parcelRequire("evFm2");


var $9Av6M = parcelRequire("9Av6M");


var $j1hRT = parcelRequire("j1hRT");

const $db5946739e91a2e0$export$7dee00034afd0ce = [
    {
        value: (0, $evFm2.REMOVE_HIGHLIGHT_COLOR),
        label: 'No color',
        // Mostly informative, only used for analytics
        border: "var(--ds-border, #0B120E24)",
        message: (0, $xx2Zf.default)((0, $j1hRT.default), 'no-color')
    }
];
(0, $1ptyh.backgroundColorPaletteNew).forEach((label, color)=>{
    $db5946739e91a2e0$export$7dee00034afd0ce.push((0, $9Av6M.mapPaletteColor)(label, color));
});
module.exports["highlightColorPaletteNew"] = $db5946739e91a2e0$export$7dee00034afd0ce;

});

parcelRegister("3qA9L", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $k07LC = parcelRequire("k07LC");


var $kCECX = parcelRequire("kCECX");


var $ixfCV = parcelRequire("ixfCV");


var $anBbz = parcelRequire("anBbz");


var $fMLvg = parcelRequire("fMLvg");


var $b71zX = parcelRequire("b71zX");

const $f58243ba1921692c$export$b8f1e1e1a4636cb0 = new (0, $kCECX.PluginKey)('highlight');
var $f58243ba1921692c$export$2dfab9d4f3f51423 = /*#__PURE__*/ function(HighlightPluginAction) {
    HighlightPluginAction[HighlightPluginAction["CHANGE_COLOR"] = 0] = "CHANGE_COLOR";
    HighlightPluginAction[HighlightPluginAction["SET_PALETTE"] = 1] = "SET_PALETTE";
    return HighlightPluginAction;
}({});
const $f58243ba1921692c$var$DEFAULT_BACKGROUND_COLOR = '#FFFFFF';
const $f58243ba1921692c$var$getActiveColorInNonActiveTheme = (color)=>(0, $k07LC.getHighlightColorInNonActiveTheme)(color, {
        defaultBackgroundColor: $f58243ba1921692c$var$DEFAULT_BACKGROUND_COLOR
    });
const $f58243ba1921692c$export$ae829ec7b2625219 = ({ api: api })=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $f58243ba1921692c$export$b8f1e1e1a4636cb0,
        state: {
            init: (_, editorState)=>({
                    activeColor: null,
                    disabled: (0, $b71zX.getDisabledState)(editorState),
                    isPaletteOpen: false,
                    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
                    ...(0, $ixfCV.fg)('platform_editor_lovability_text_bg_color_patch_1') && (0, $anBbz.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && {
                        activeColorInNonActiveTheme: $f58243ba1921692c$var$getActiveColorInNonActiveTheme(null),
                        isMultiHighlightColor: false
                    }
                }),
            apply: (tr, pluginState, _oldState, newState)=>{
                const action = tr.getMeta($f58243ba1921692c$export$b8f1e1e1a4636cb0)?.type;
                switch(action){
                    case 0:
                        const { color: color } = tr.getMeta($f58243ba1921692c$export$b8f1e1e1a4636cb0);
                        return {
                            ...pluginState,
                            activeColor: color,
                            // eslint-disable-next-line @atlaskit/platform/no-preconditioning
                            ...(0, $ixfCV.fg)('platform_editor_lovability_text_bg_color_patch_1') && (0, $anBbz.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && {
                                activeColorInNonActiveTheme: $f58243ba1921692c$var$getActiveColorInNonActiveTheme(color),
                                isMultiHighlightColor: false
                            }
                        };
                    case 1:
                        const { isPaletteOpen: isPaletteOpen } = tr.getMeta($f58243ba1921692c$export$b8f1e1e1a4636cb0);
                        return {
                            ...pluginState,
                            isPaletteOpen: isPaletteOpen
                        };
                    default:
                        const activeColor = (0, $fMLvg.getActiveColor)(tr);
                        const isMultiHighlightColor = activeColor === (0, $fMLvg.MULTIPLE_HIGHLIGHT_COLORS_SELECTED);
                        return {
                            ...pluginState,
                            activeColor: activeColor,
                            disabled: (0, $b71zX.getDisabledState)(newState),
                            // eslint-disable-next-line @atlaskit/platform/no-preconditioning
                            ...activeColor !== pluginState.activeColor && (0, $ixfCV.fg)('platform_editor_lovability_text_bg_color_patch_1') && (0, $anBbz.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && {
                                // When the selection spans multiple highlight colors, `activeColor` is the
                                // `MULTIPLE_HIGHLIGHT_COLORS_SELECTED` sentinel rather than a real hex value.
                                // Passing it through would resolve the literal sentinel as a color, so fall
                                // back to the neutral default instead.
                                activeColorInNonActiveTheme: $f58243ba1921692c$var$getActiveColorInNonActiveTheme(isMultiHighlightColor ? null : activeColor),
                                isMultiHighlightColor: isMultiHighlightColor
                            }
                        };
                }
            }
        }
    });
};
module.exports["highlightPluginKey"] = $f58243ba1921692c$export$b8f1e1e1a4636cb0;
module.exports["HighlightPluginAction"] = $f58243ba1921692c$export$2dfab9d4f3f51423;
module.exports["createPlugin"] = $f58243ba1921692c$export$ae829ec7b2625219;

});

parcelRegister("fMLvg", function(module, exports) {

var $hXuXM = parcelRequire("hXuXM");


var $kCECX = parcelRequire("kCECX");


var $8HW7o = parcelRequire("8HW7o");

const $cc72b0b788eceff6$export$544437a37c3070a9 = 'multiple';
const $cc72b0b788eceff6$var$getAllUniqueBackgroundColorMarksInRange = (from, to, tr)=>{
    const { doc: doc } = tr;
    const { backgroundColor: backgroundColor } = doc.type.schema.marks;
    const colorMarks = [];
    const colorSet = new Set();
    doc.nodesBetween(from, to, (node)=>{
        if (node.isLeaf) {
            const mark = backgroundColor.isInSet(node.marks);
            if (mark && !colorSet.has(mark.attrs.color)) {
                colorMarks.push(mark);
                colorSet.add(mark.attrs.color);
            }
        }
    });
    return colorMarks;
};
const $cc72b0b788eceff6$var$getAllUniqueBackgroundColorMarksInCellSelection = (selection, tr)=>{
    const colorMarks = [];
    const colorSet = new Set();
    selection.forEachCell((cell, cellPos)=>{
        const from = cellPos;
        const to = cellPos + cell.nodeSize;
        const marks = $cc72b0b788eceff6$var$getAllUniqueBackgroundColorMarksInRange(from, to, tr);
        marks.forEach((mark)=>{
            if (!colorSet.has(mark.attrs.color)) {
                colorMarks.push(mark);
                colorSet.add(mark.attrs.color);
            }
        });
    });
    return colorMarks;
};
// For Cell Selections - find first instance of a backgroundColor mark
// if all cells entirely contain this mark, set the color.
// If the selection contains multiple colors, return null
const $cc72b0b788eceff6$var$getColorFromCellSelection = (selection, tr)=>{
    const marks = $cc72b0b788eceff6$var$getAllUniqueBackgroundColorMarksInCellSelection(selection, tr);
    if (marks.length > 1) return $cc72b0b788eceff6$export$544437a37c3070a9;
    const firstColorMark = marks.at(0);
    if (!firstColorMark) return null;
    let foundUncolouredNode = false;
    selection.forEachCell((cell, cellPos)=>{
        if (foundUncolouredNode) return;
        const from = cellPos;
        const to = cellPos + cell.nodeSize;
        if (!(0, $hXuXM.entireSelectionContainsMark)(firstColorMark, tr.doc, from, to)) foundUncolouredNode = true;
    });
    return foundUncolouredNode ? null : firstColorMark.attrs.color;
};
// All other selections - find the first instance of a backgroundColor mark
// if selection entirely contains this mark, set the color.
// If the selection contains multiple colors, return null
const $cc72b0b788eceff6$var$getColorFromRange = (from, to, tr)=>{
    const marks = $cc72b0b788eceff6$var$getAllUniqueBackgroundColorMarksInRange(from, to, tr);
    if (marks.length > 1) return $cc72b0b788eceff6$export$544437a37c3070a9;
    const firstColorMark = marks.at(0);
    if (firstColorMark && (0, $hXuXM.entireSelectionContainsMark)(firstColorMark, tr.doc, from, to)) return firstColorMark.attrs.color;
    return null;
};
// For Cursor selections - set color if it is found in the storedMarks or $cursor.marks
const $cc72b0b788eceff6$var$getColorFromCursor = (selection, tr)=>{
    if (!selection.$cursor) return null;
    const mark = tr.doc.type.schema.marks.backgroundColor.isInSet([
        ...tr.storedMarks ? tr.storedMarks : [],
        ...selection.$cursor.marks()
    ]);
    return mark?.attrs.color ?? null;
};
const $cc72b0b788eceff6$export$1c6fa8f53a5fb47f = (tr)=>{
    const { selection: selection } = tr;
    let color = null;
    if (selection instanceof (0, $8HW7o.CellSelection)) color = $cc72b0b788eceff6$var$getColorFromCellSelection(selection, tr);
    else if (selection instanceof (0, $kCECX.TextSelection) && selection.$cursor) color = $cc72b0b788eceff6$var$getColorFromCursor(selection, tr);
    else color = $cc72b0b788eceff6$var$getColorFromRange(selection.from, selection.to, tr);
    return color;
};
module.exports["MULTIPLE_HIGHLIGHT_COLORS_SELECTED"] = $cc72b0b788eceff6$export$544437a37c3070a9;
module.exports["getActiveColor"] = $cc72b0b788eceff6$export$1c6fa8f53a5fb47f;

});

parcelRegister("b71zX", function(module, exports) {

var $kzHT3 = parcelRequire("kzHT3");

var $adJV7 = parcelRequire("adJV7");


var $4EksL = parcelRequire("4EksL");


var $kCECX = parcelRequire("kCECX");

const $e2943e24876b6d57$export$4af1020a67b5ec91 = (state)=>{
    const { backgroundColor: backgroundColor } = state.schema.marks;
    const { empty: empty, ranges: ranges, $cursor: $cursor } = state.selection;
    if (!backgroundColor) return true;
    if (state.selection instanceof (0, $kCECX.NodeSelection) || state.selection instanceof (0, $4EksL.GapCursorSelection)) return true;
    if (empty && !$cursor || (0, $kzHT3.isMarkAllowedInRange)(state.doc, ranges, backgroundColor) === false) return true;
    if ((0, $adJV7.isMarkExcluded)(backgroundColor, state.storedMarks || $cursor && $cursor.marks())) return true;
    return false;
};
module.exports["getDisabledState"] = $e2943e24876b6d57$export$4af1020a67b5ec91;

});

parcelRegister("8dubf", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $8nvEM = parcelRequire("8nvEM");


var $3YhlK = parcelRequire("3YhlK");


var $2Y3yg = parcelRequire("2Y3yg");

const $c486e0fd30b92a7e$export$64079c8b271eeba4 = new (0, $kCECX.PluginKey)('highlightPaddingPluginKey');
const $c486e0fd30b92a7e$export$8d5a971433249768 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $c486e0fd30b92a7e$export$64079c8b271eeba4,
        state: {
            init: (_, state)=>{
                // Initially scan the entire doc to create all highlight padding decorations
                // after which updates will only apply to changed ranges
                const initialDecorationSet = (0, $8nvEM.DecorationSet).empty;
                const decorationSet = (0, $3YhlK.addPaddingDecorations)({
                    decorationSet: initialDecorationSet,
                    state: state,
                    from: 0,
                    to: state.doc.content.size
                });
                return {
                    decorationSet: decorationSet
                };
            },
            apply: (tr, pluginState, _oldState, state)=>{
                if (!tr.docChanged) return pluginState;
                let decorationSet = pluginState.decorationSet.map(tr.mapping, tr.doc);
                tr.mapping.maps.forEach((stepMap)=>{
                    stepMap.forEach((_oldStart, _oldEnd, start, end)=>{
                        decorationSet = (0, $2Y3yg.updatePaddingDecorations)({
                            decorationSet: decorationSet,
                            state: state,
                            start: start,
                            end: end
                        });
                    });
                });
                return {
                    decorationSet: decorationSet
                };
            }
        },
        props: {
            decorations: (state)=>{
                return $c486e0fd30b92a7e$export$64079c8b271eeba4.getState(state).decorationSet;
            }
        }
    });
};
module.exports["createHighlightPaddingPlugin"] = $c486e0fd30b92a7e$export$8d5a971433249768;

});

parcelRegister("3YhlK", function(module, exports) {

var $8nvEM = parcelRequire("8nvEM");


var $kX7j6 = parcelRequire("kX7j6");

const $0dd8ab74fbe19def$var$createPaddingDecoration = ({ pos: pos, node: node, padLeft: padLeft, padRight: padRight })=>{
    const classes = [];
    const baseClass = 'background-color';
    const padLeftClass = `${baseClass}-padding-left`;
    const padRightClass = `${baseClass}-padding-right`;
    if (padLeft) classes.push(padLeftClass);
    if (padRight) classes.push(padRightClass);
    return (0, $8nvEM.Decoration).inline(pos, pos + node.nodeSize, {
        class: classes.join(' ')
    });
};
const $0dd8ab74fbe19def$export$e955b6e659e59713 = ({ decorationSet: decorationSet, state: state, from: from, to: to })=>{
    let newDecorationSet = decorationSet;
    state.doc.nodesBetween(from, to, (node, pos)=>{
        if (!(0, $kX7j6.isHighlightedTextNode)(node)) return;
        const nodeStart = pos;
        const nodeEnd = pos + node.nodeSize;
        const padLeft = (0, $kX7j6.shouldPadLeft)({
            state: state,
            nodeStart: nodeStart
        });
        const padRight = (0, $kX7j6.shouldPadRight)({
            state: state,
            nodeEnd: nodeEnd
        });
        if (padLeft && padRight) {
            const newDecoration = $0dd8ab74fbe19def$var$createPaddingDecoration({
                pos: nodeStart,
                node: node,
                padLeft: padLeft,
                padRight: padRight
            });
            newDecorationSet = newDecorationSet.add(state.doc, [
                newDecoration
            ]);
        }
    });
    return newDecorationSet;
};
module.exports["addPaddingDecorations"] = $0dd8ab74fbe19def$export$e955b6e659e59713;

});

parcelRegister("kX7j6", function(module, exports) {
const $04ef2b2b71a6e383$export$d6f914f85b7b868b = (node)=>{
    return node.isText && node.marks.some((mark)=>mark.type.name === 'backgroundColor');
};
const $04ef2b2b71a6e383$export$48e6e6ce50a6fb39 = ({ state: state, nodeStart: nodeStart })=>{
    const $pos = state.doc.resolve(nodeStart);
    const isAtBlockStart = $pos.parentOffset === 0;
    if (isAtBlockStart) return true;
    const isAtDocStart = nodeStart === 0;
    if (isAtDocStart) return true;
    const isPrevCharSpace = state.doc.textBetween(nodeStart - 1, nodeStart) === ' ';
    if (isPrevCharSpace) return true;
    return false;
};
const $04ef2b2b71a6e383$export$b44b3045e621df46 = ({ state: state, nodeEnd: nodeEnd })=>{
    const $pos = state.doc.resolve(nodeEnd);
    const isAtBlockEnd = $pos.parentOffset === $pos.parent.content.size;
    if (isAtBlockEnd) return true;
    const isAtDocEnd = nodeEnd === state.doc.content.size;
    if (isAtDocEnd) return true;
    const isNextCharSpace = state.doc.textBetween(nodeEnd, nodeEnd + 1) === ' ';
    if (isNextCharSpace) return true;
    return false;
};
module.exports["isHighlightedTextNode"] = $04ef2b2b71a6e383$export$d6f914f85b7b868b;
module.exports["shouldPadLeft"] = $04ef2b2b71a6e383$export$48e6e6ce50a6fb39;
module.exports["shouldPadRight"] = $04ef2b2b71a6e383$export$b44b3045e621df46;

});

parcelRegister("2Y3yg", function(module, exports) {

var $3YhlK = parcelRequire("3YhlK");

const $c292e18cced6f552$export$d9003f1f8089aa99 = ({ decorationSet: prevDecorationSet, state: state, start: start, end: end })=>{
    // First remove any decorations within the range
    // Note that it finds all decorations in the set which touch the given range (including decorations that start or end directly at the boundaries)
    const toRemove = prevDecorationSet.find(start, end);
    const decorationSet = prevDecorationSet.remove(toRemove);
    // Expand the range by 1 on each side to catch adjacent text nodes
    // that may need padding decorations added/removed
    const from = Math.max(0, start - 1);
    const to = Math.min(state.doc.content.size, end + 1);
    return (0, $3YhlK.addPaddingDecorations)({
        decorationSet: decorationSet,
        state: state,
        from: from,
        to: to
    });
};
module.exports["updatePaddingDecorations"] = $c292e18cced6f552$export$d9003f1f8089aa99;

});

parcelRegister("lpCJp", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $ldqjS = parcelRequire("ldqjS");

var $eBSR7 = parcelRequire("eBSR7");


var $aC6bW = parcelRequire("aC6bW");


var $evFm2 = parcelRequire("evFm2");

var $1jFAi = parcelRequire("1jFAi");


var $anBbz = parcelRequire("anBbz");


var $klpad = parcelRequire("klpad");


var $hho3D = parcelRequire("hho3D");

function $96e0040b7d537f88$export$e832373cff8dec22({ api: api }) {
    const list = {};
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    if (!isToolbarAIFCEnabled) (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.toggleHighlightPalette).common, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hho3D.togglePalette)(api)({
        inputMethod: (0, $krYZG.INPUT_METHOD).SHORTCUT
    }), list);
    const analyticsApi = api?.analytics?.actions;
    const highlightPalette = (0, $anBbz.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) ? (0, $1jFAi.highlightColorPaletteNew) : (0, $evFm2.highlightColorPalette);
    const color = highlightPalette.find(({ label: label })=>label === 'Yellow');
    if (color) (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.applyYellowHighlight).common, (0, $aC6bW.editorCommandToPMCommand)((0, $klpad.changeColor)(analyticsApi)({
        color: color.value,
        inputMethod: (0, $krYZG.INPUT_METHOD).SHORTCUT
    })), list);
    return (0, $eBSR7.keymap)(list);
}
module.exports["keymapPlugin"] = $96e0040b7d537f88$export$e832373cff8dec22;

});

parcelRegister("hho3D", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $3qA9L = parcelRequire("3qA9L");

const $2aa1bfdef742e4d8$export$7c9cf3bdfeac3246 = (api)=>({ inputMethod: inputMethod })=>(state, dispatch)=>{
            const isPaletteOpen = (0, $3qA9L.highlightPluginKey).getState(state)?.isPaletteOpen;
            return $2aa1bfdef742e4d8$export$9567774ece486a9(api)({
                isPaletteOpen: !isPaletteOpen,
                inputMethod: inputMethod
            })(state, dispatch);
        };
const $2aa1bfdef742e4d8$export$9567774ece486a9 = (api)=>({ isPaletteOpen: isPaletteOpen, inputMethod: inputMethod })=>(state, dispatch)=>{
            const isDisabled = (0, $3qA9L.highlightPluginKey).getState(state)?.disabled;
            if (!isDisabled) {
                const tr = state.tr;
                tr.setMeta((0, $3qA9L.highlightPluginKey), {
                    type: (0, $3qA9L.HighlightPluginAction).SET_PALETTE,
                    isPaletteOpen: isPaletteOpen
                });
                api.analytics?.actions.attachAnalyticsEvent($2aa1bfdef742e4d8$var$createAnalyticsEvent(isPaletteOpen, inputMethod))(tr);
                tr.setMeta('addToHistory', false);
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };
const $2aa1bfdef742e4d8$var$createAnalyticsEvent = (isPaletteOpen, inputMethod)=>{
    return {
        action: isPaletteOpen ? (0, $krYZG.ACTION).OPENED : (0, $krYZG.ACTION).CLOSED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).TOOLBAR,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: inputMethod
        }
    };
};
module.exports["togglePalette"] = $2aa1bfdef742e4d8$export$7c9cf3bdfeac3246;
module.exports["setPalette"] = $2aa1bfdef742e4d8$export$9567774ece486a9;

});

parcelRegister("4KwOr", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $krYZG = parcelRequire("krYZG");


var $3k5Tv = parcelRequire("3k5Tv");


var $f1UXy = parcelRequire("f1UXy");


var $ldqjS = parcelRequire("ldqjS");


var $hzZPp = parcelRequire("hzZPp");


var $9iFhC = parcelRequire("9iFhC");

var $6DhDg = parcelRequire("6DhDg");


var $aiL0G = parcelRequire("aiL0G");

var $ldbHR = parcelRequire("ldbHR");


var $9Rqjc = parcelRequire("9Rqjc");


var $7sJoX = parcelRequire("7sJoX");


var $58BEn = parcelRequire("58BEn");


var $fqVYq = parcelRequire("fqVYq");


var $hho3D = parcelRequire("hho3D");


var $17Axi = parcelRequire("17Axi");


var $bvwoM = parcelRequire("bvwoM");

const $0f74fcdc8766f2ac$var$selector = (states)=>{
    return {
        isPaletteOpen: states.highlightState?.isPaletteOpen,
        activeColor: states.highlightState?.activeColor,
        disabled: states.highlightState?.disabled
    };
};
const $0f74fcdc8766f2ac$var$FloatingToolbarHighlightColor = ({ pluginInjectionApi: pluginInjectionApi, intl: { formatMessage: formatMessage }, editorView: editorView })=>{
    const toolbarItemRef = (0, $cozmU.useRef)(null);
    const { activeColor: activeColor, disabled: disabled, isPaletteOpen: isPaletteOpen } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'highlight'
    ], $0f74fcdc8766f2ac$var$selector);
    const setDropdownOpen = (isOpen)=>{
        if (!disabled && editorView && pluginInjectionApi) {
            const { state: state, dispatch: dispatch } = editorView;
            (0, $hho3D.setPalette)(pluginInjectionApi)({
                isPaletteOpen: isOpen,
                inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
            })(state, dispatch);
        }
        pluginInjectionApi?.analytics?.actions.fireAnalyticsEvent({
            action: isOpen ? (0, $krYZG.ACTION).OPENED : (0, $krYZG.ACTION).CLOSED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TOOLBAR,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
            }
        });
    };
    const isDropdownOpen = !!isPaletteOpen;
    const { handleClick: handleClick, handleKeyDown: handleKeyDown, handleClickOutside: handleClickOutside, handleEscapeKeydown: handleEscapeKeydown, handleColorChange: handleColorChange, isOpenedByKeyboard: isOpenedByKeyboard } = (0, $bvwoM.useDropdownEvents)({
        toolbarItemRef: toolbarItemRef,
        setIsDropdownOpen: setDropdownOpen,
        isDropdownOpen: isDropdownOpen,
        pluginInjectionApi: pluginInjectionApi
    });
    // Don't render the toolbar option while the plugin is initialising
    if (activeColor === undefined || disabled === undefined) return null;
    const toolbarButtonLabel = formatMessage((0, $hzZPp.highlightMessages).highlight);
    // Get the design token for the  active color (if it exists) to modify the toolbar
    // icon, but show the nice rainbow if none is selected
    const activeColorToken = activeColor === null ? null : (0, $9Rqjc.hexToEditorTextBackgroundPaletteColor)(activeColor);
    const title = (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $ldqjS.tooltip)((0, $ldqjS.toggleHighlightPalette), toolbarButtonLabel) : toolbarButtonLabel;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $17Axi.PaletteDropdown), {
        isOpen: isDropdownOpen && !disabled,
        activeColor: activeColor,
        trigger: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-imported-style-values
            css: (0, $9iFhC.disableBlueBorderStyles),
            buttonId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).BACKGROUND_COLOR,
            spacing: (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? 'default' : 'compact',
            disabled: disabled,
            selected: isDropdownOpen,
            "aria-label": title,
            "aria-keyshortcuts": (0, $ldqjS.getAriaKeyshortcuts)((0, $ldqjS.toggleHighlightPalette)),
            "aria-expanded": isDropdownOpen,
            "aria-haspopup": true,
            title: title,
            onClick: handleClick,
            onKeyDown: handleKeyDown,
            ref: toolbarItemRef,
            iconBefore: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                css: (0, $9iFhC.triggerWrapperStylesWithPadding)
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $f1UXy.DynamicStrokeIconDecoration), {
                selectedColor: activeColorToken,
                disabled: disabled,
                icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($58BEn))), {
                    label: "",
                    color: "currentColor",
                    spacing: "spacious"
                })
            }), // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                css: (0, $6DhDg.expandIconContainerStyle)
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: "",
                color: "currentColor",
                size: "small"
            })))
        }, (0, $fqVYq.editorExperiment)('platform_editor_controls', 'control') && formatMessage((0, $hzZPp.highlightMessages).highlightFloatingToolbar)),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onColorChange: (color)=>handleColorChange({
                color: color,
                inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
            }),
        isOpenedByKeyboard: isOpenedByKeyboard,
        handleClickOutside: handleClickOutside,
        handleEscapeKeydown: handleEscapeKeydown
    });
};
const $0f74fcdc8766f2ac$export$5d201a8e1b725031 = (0, $kSwu1.injectIntl)($0f74fcdc8766f2ac$var$FloatingToolbarHighlightColor);
module.exports["FloatingToolbarHighlightColorWithIntl"] = $0f74fcdc8766f2ac$export$5d201a8e1b725031;

});

parcelRegister("17Axi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7xQNd = parcelRequire("7xQNd");

var $3gFnx = parcelRequire("3gFnx");

var $evFm2 = parcelRequire("evFm2");

var $1jFAi = parcelRequire("1jFAi");


var $9RT19 = parcelRequire("9RT19");

var $9GNtS = parcelRequire("9GNtS");


var $9Rqjc = parcelRequire("9Rqjc");


var $7Y8M5 = parcelRequire("7Y8M5");


var $ieeJu = parcelRequire("ieeJu");

const $beb5a9a099edbe6a$var$HIGHLIGHT_COLOR_PICKER_COLUMNS = 8;
const $beb5a9a099edbe6a$var$HIGHLIGHT_COLOR_PICKER_COLUMNS_NEW = 10;
const $beb5a9a099edbe6a$export$780f86860853be18 = (props)=>{
    const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isOpen: isOpen, activeColor: activeColor, trigger: trigger, onColorChange: onColorChange, isOpenedByKeyboard: isOpenedByKeyboard, handleClickOutside: handleClickOutside, handleEscapeKeydown: handleEscapeKeydown } = props;
    const isNewColorPaletteEnabled = (0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true);
    const highlightPalette = isNewColorPaletteEnabled ? (0, $1jFAi.highlightColorPaletteNew) : (0, $evFm2.highlightColorPalette);
    const colorPickerColumns = isNewColorPaletteEnabled ? $beb5a9a099edbe6a$var$HIGHLIGHT_COLOR_PICKER_COLUMNS_NEW : $beb5a9a099edbe6a$var$HIGHLIGHT_COLOR_PICKER_COLUMNS;
    // pixels, used to determine where to horizontally position the dropdown when space is limited
    // this should reflect the width of the dropdown when fully populated with colors, including translations due to layering
    const fitWidth = isNewColorPaletteEnabled ? 338 : 274;
    // 8 cols: 272 = (32 * 8) + (8 + 8)
    // 10 cols: 336 = (32 * 10) + (8 + 8)
    // Not sure where the extra 2px comes from
    const selectedColor = activeColor || (isNewColorPaletteEnabled ? (0, $evFm2.REMOVE_HIGHLIGHT_COLOR) : null);
    const { selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex } = (0, $3gFnx.getSelectedRowAndColumnFromPalette)(highlightPalette, selectedColor, colorPickerColumns);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GNtS.DropdownContainer), {
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        isOpen: isOpen,
        handleClickOutside: handleClickOutside,
        handleEscapeKeydown: handleEscapeKeydown,
        zIndex: (0, $7Y8M5.akEditorMenuZIndex),
        fitWidth: fitWidth,
        closeOnTab: true,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        arrowKeyNavigationProviderOptions: {
            type: (0, $9RT19.ArrowKeyNavigationType).COLOR,
            selectedRowIndex: selectedRowIndex,
            selectedColumnIndex: selectedColumnIndex,
            isOpenedByKeyboard: isOpenedByKeyboard,
            isPopupPositioned: true
        },
        trigger: trigger
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "highlight-color-palette"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7xQNd.default), {
        cols: colorPickerColumns,
        onClick: onColorChange,
        selectedColor: selectedColor,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        paletteOptions: {
            palette: highlightPalette,
            hexToPaletteColor: (0, $9Rqjc.hexToEditorTextBackgroundPaletteColor)
        }
    })));
};
module.exports["PaletteDropdown"] = $beb5a9a099edbe6a$export$780f86860853be18;

});

parcelRegister("bvwoM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $klpad = parcelRequire("klpad");

const $c5c096bb56d4fa88$export$98f4eb06acf89919 = (args)=>{
    const { toolbarItemRef: toolbarItemRef, setIsDropdownOpen: setIsDropdownOpen, isDropdownOpen: isDropdownOpen, pluginInjectionApi: pluginInjectionApi } = args;
    const [isOpenedByKeyboard, setIsOpenedByKeyboard] = (0, $cozmU.useState)(false);
    return {
        handleClick: ()=>{
            setIsOpenedByKeyboard(false);
            setIsDropdownOpen(!isDropdownOpen);
        },
        handleKeyDown: (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                setIsOpenedByKeyboard(true);
                setIsDropdownOpen(!isDropdownOpen);
            }
        },
        handleClickOutside: ()=>{
            if (isDropdownOpen) {
                setIsDropdownOpen(false);
                setIsOpenedByKeyboard(false);
            }
        },
        handleEscapeKeydown: ()=>{
            if (isDropdownOpen) {
                setIsDropdownOpen(false);
                setIsOpenedByKeyboard(false);
                toolbarItemRef?.current?.focus();
            }
        },
        handleColorChange: ({ color: color, inputMethod: inputMethod })=>{
            pluginInjectionApi?.core?.actions.execute((0, $klpad.changeColor)(pluginInjectionApi?.analytics?.actions)({
                color: color,
                inputMethod: inputMethod
            }));
            setIsDropdownOpen(false);
        },
        isOpenedByKeyboard: isOpenedByKeyboard
    };
};
module.exports["useDropdownEvents"] = $c5c096bb56d4fa88$export$98f4eb06acf89919;

});

parcelRegister("cjq97", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $krYZG = parcelRequire("krYZG");


var $3k5Tv = parcelRequire("3k5Tv");


var $f1UXy = parcelRequire("f1UXy");


var $ldqjS = parcelRequire("ldqjS");


var $hzZPp = parcelRequire("hzZPp");


var $9iFhC = parcelRequire("9iFhC");

var $6DhDg = parcelRequire("6DhDg");


var $aiL0G = parcelRequire("aiL0G");

var $ldbHR = parcelRequire("ldbHR");


var $9Rqjc = parcelRequire("9Rqjc");


var $7sJoX = parcelRequire("7sJoX");


var $58BEn = parcelRequire("58BEn");


var $4ez2K = parcelRequire("4ez2K");


var $hho3D = parcelRequire("hho3D");


var $17Axi = parcelRequire("17Axi");


var $bvwoM = parcelRequire("bvwoM");

const $0956ebe46a405aea$var$selector = (states)=>{
    return {
        isPaletteOpen: states.highlightState?.isPaletteOpen,
        highlightDisabled: states.highlightState?.disabled,
        activeColor: states.highlightState?.activeColor
    };
};
const $0956ebe46a405aea$var$PrimaryToolbarHighlightColor = ({ popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, disabled: disabled, pluginInjectionApi: pluginInjectionApi, intl: { formatMessage: formatMessage }, editorView: editorView })=>{
    const toolbarItemRef = (0, $cozmU.useRef)(null);
    const { isPaletteOpen: isPaletteOpen, highlightDisabled: highlightDisabled, activeColor: activeColor } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'highlight'
    ], $0956ebe46a405aea$var$selector);
    const setIsDropdownOpen = (isOpen)=>{
        if (!highlightDisabled) {
            const { state: state, dispatch: dispatch } = editorView;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (0, $hho3D.setPalette)(pluginInjectionApi)({
                isPaletteOpen: isOpen,
                inputMethod: (0, $krYZG.INPUT_METHOD).TOOLBAR
            })(state, dispatch);
        }
    };
    const isDropdownOpen = !!isPaletteOpen;
    const { handleClick: handleClick, handleKeyDown: handleKeyDown, handleClickOutside: handleClickOutside, handleEscapeKeydown: handleEscapeKeydown, handleColorChange: handleColorChange, isOpenedByKeyboard: isOpenedByKeyboard } = (0, $bvwoM.useDropdownEvents)({
        toolbarItemRef: toolbarItemRef,
        setIsDropdownOpen: setIsDropdownOpen,
        isDropdownOpen: isDropdownOpen,
        pluginInjectionApi: pluginInjectionApi
    });
    // Don't render the toolbar option while the plugin is initialising
    if (activeColor === undefined || highlightDisabled === undefined) return null;
    const toolbarButtonLabel = formatMessage((0, $hzZPp.highlightMessages).highlight);
    // Get the design token for the  active color (if it exists) to modify the toolbar
    // icon, but show the nice rainbow if none is selected
    const activeColorToken = activeColor === null ? null : (0, $9Rqjc.hexToEditorTextBackgroundPaletteColor)(activeColor);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4ez2K.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $17Axi.PaletteDropdown), {
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        isOpen: isDropdownOpen && !highlightDisabled,
        activeColor: activeColor,
        trigger: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-imported-style-values
            css: (0, $9iFhC.disableBlueBorderStyles),
            buttonId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).BACKGROUND_COLOR,
            spacing: isToolbarReducedSpacing ? 'none' : 'default',
            disabled: disabled || highlightDisabled,
            selected: isDropdownOpen,
            "aria-label": (0, $ldqjS.tooltip)((0, $ldqjS.toggleHighlightPalette), toolbarButtonLabel),
            "aria-keyshortcuts": (0, $ldqjS.getAriaKeyshortcuts)((0, $ldqjS.toggleHighlightPalette)),
            "aria-expanded": isDropdownOpen,
            "aria-haspopup": true,
            title: (0, $ldqjS.tooltip)((0, $ldqjS.toggleHighlightPalette), toolbarButtonLabel),
            onClick: handleClick,
            onKeyDown: handleKeyDown,
            ref: toolbarItemRef,
            iconBefore: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                css: (0, $9iFhC.triggerWrapperStylesWithPadding)
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $f1UXy.DynamicStrokeIconDecoration), {
                selectedColor: activeColorToken,
                disabled: highlightDisabled,
                icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($58BEn))), {
                    label: "",
                    color: "currentColor",
                    spacing: "spacious"
                })
            }), //eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                css: (0, $6DhDg.expandIconContainerStyle)
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: "",
                color: "currentColor",
                size: "small"
            })))
        }),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onColorChange: (color)=>handleColorChange({
                color: color,
                inputMethod: (0, $krYZG.INPUT_METHOD).TOOLBAR
            }),
        isOpenedByKeyboard: isOpenedByKeyboard,
        handleClickOutside: handleClickOutside,
        handleEscapeKeydown: handleEscapeKeydown
    }));
};
const $0956ebe46a405aea$export$124ac7b23aa1ea6a = (0, $kSwu1.injectIntl)($0956ebe46a405aea$var$PrimaryToolbarHighlightColor);
module.exports["PrimaryToolbarHighlightColorWithIntl"] = $0956ebe46a405aea$export$124ac7b23aa1ea6a;

});

parcelRegister("9trAT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3nacY = parcelRequire("3nacY");

var $hVLmg = parcelRequire("hVLmg");


var $3drJJ = parcelRequire("3drJJ");

const $fa195af61c51f8bd$export$6cd8b101843de8d2 = (api)=>{
    return [
        {
            ...(0, $3nacY.HIGHLIGHT_MENU_ITEM),
            parents: [
                {
                    ...(0, $3nacY.TEXT_COLOR_HIGHLIGHT_MENU_SECTION),
                    rank: (0, $hVLmg.TEXT_COLOR_HIGHLIGHT_MENU_SECTION_RANK)[(0, $3nacY.HIGHLIGHT_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3drJJ.HighlightColorMenuItem), {
                    api: api,
                    parents: parents
                })
        }
    ];
};
module.exports["getToolbarComponent"] = $fa195af61c51f8bd$export$6cd8b101843de8d2;

});

parcelRegister("3drJJ", function(module, exports) {
/* HighlightColorMenuItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $hzZPp = parcelRequire("hzZPp");


var $is7KY = parcelRequire("is7KY");


var $evFm2 = parcelRequire("evFm2");

var $1jFAi = parcelRequire("1jFAi");

var $hEYnV = parcelRequire("hEYnV");


var $4Qu9h = parcelRequire("4Qu9h");


var $9Rqjc = parcelRequire("9Rqjc");

var $g8ETs = parcelRequire("g8ETs");


var $74bCf = parcelRequire("74bCf");

var $kwf4Z = parcelRequire("kwf4Z");


var $I7hWB = parcelRequire("I7hWB");


var $eh6Ml = parcelRequire("eh6Ml");


var $9FyRG = parcelRequire("9FyRG");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");


var $ieeJu = parcelRequire("ieeJu");

const $41e58cb6d3564e2b$var$HIGHLIGHT_COLOR_PICKER_COLUMNS = 10;
const $41e58cb6d3564e2b$var$styles = {
    container: "_zulp12x7 _19pkpxbi",
    icon: "_1e0c1o8l _18u01n1a"
};
const $41e58cb6d3564e2b$var$getTextColorIconColor = (defaultColor, textColor, isNewColorPaletteEnabled)=>{
    if (!isNewColorPaletteEnabled) return "var(--ds-icon, #292A2E)";
    if (!textColor || defaultColor && textColor === defaultColor) return "var(--ds-icon, #292A2E)";
    return (0, $g8ETs.hexToEditorTextPaletteColor)(textColor) || "var(--ds-icon, #292A2E)";
};
const $41e58cb6d3564e2b$var$TextColorIconDecorator = ({ label: label, isSelected: isSelected, iconColor: iconColor })=>{
    return isSelected ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        color: "var(--ds-icon, #292A2E)",
        label: label
    }) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        as: "span",
        xcss: $41e58cb6d3564e2b$var$styles.icon
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9FyRG))), {
        label: label,
        color: iconColor,
        shouldRecommendSmallIcon: true,
        spacing: "spacious",
        size: "small"
    }));
};
const $41e58cb6d3564e2b$var$NoColorIconDecorator = ({ isSelected: isSelected, iconColor: iconColor })=>/*#__PURE__*/ $cozmU.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, /*#__PURE__*/ $cozmU.createElement("g", {
        transform: "translate(-1 -1)"
    }, /*#__PURE__*/ $cozmU.createElement("rect", {
        x: "1.70703",
        y: "1.35383",
        width: "29.8003",
        height: "0.5",
        transform: "rotate(45 1.70703 1.35383)",
        stroke: "var(--ds-border, #0B120E24)",
        strokeWidth: "0.5"
    }), isSelected ? /*#__PURE__*/ $cozmU.createElement("path", {
        d: "M17.959 7.9707L10.709 16.9707C10.5675 17.1462 10.3544 17.2488 10.1289 17.25C9.90343 17.2512 9.68924 17.1506 9.5459 16.9766L6.0459 12.7266L7.2041 11.7734L10.1182 15.3115L16.791 7.0293L17.959 7.9707Z",
        fill: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ $cozmU.createElement("path", {
        d: "M7.80469 16L10.9746 7.26953H12.2637L15.4746 16H14.3027L12.4512 10.8203C12.3379 10.5 12.2051 10.1016 12.0527 9.625C11.9043 9.14453 11.7227 8.5332 11.5078 7.79102H11.7188C11.5078 8.54102 11.3242 9.16016 11.168 9.64844C11.0156 10.1328 10.8887 10.5234 10.7871 10.8203L8.98828 16H7.80469ZM9.39844 13.5625V12.5898H13.8809V13.5625H9.39844Z",
        fill: iconColor
    })));
function $41e58cb6d3564e2b$export$5b2f3a4c271f0961({ api: api, parents: parents }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const activeColor = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'highlight.activeColor');
    const context = (0, $kwf4Z.useToolbarDropdownMenu)();
    const { textColor: textColor, defaultColor: defaultColor } = (0, $hEYnV.useSelectedTextColor)();
    const closeMenu = context?.closeMenu;
    const isNewColorPaletteEnabled = (0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true);
    const selectedColor = activeColor || (isNewColorPaletteEnabled ? (0, $evFm2.REMOVE_HIGHLIGHT_COLOR) : null);
    const handleHighlightColorChange = (0, $cozmU.useCallback)((color, event)=>{
        if (api?.highlight?.commands?.changeColor) {
            api.core.actions.execute(api.highlight.commands.changeColor({
                color: color,
                inputMethod: (0, $is7KY.getInputMethodFromParentKeys)(parents)
            }));
            if (!isNewColorPaletteEnabled) closeMenu?.(event);
        }
    }, [
        api,
        closeMenu,
        isNewColorPaletteEnabled,
        parents
    ]);
    const colorPalette = (0, $cozmU.useMemo)(()=>{
        const isSelected = (color)=>color.value === selectedColor;
        const iconColor = $41e58cb6d3564e2b$var$getTextColorIconColor(defaultColor, textColor, isNewColorPaletteEnabled);
        const highlightPalette = isNewColorPaletteEnabled ? (0, $1jFAi.highlightColorPaletteNew) : (0, $evFm2.highlightColorPalette);
        return highlightPalette.filter((color)=>isNewColorPaletteEnabled || color.value !== (0, $evFm2.REMOVE_HIGHLIGHT_COLOR)).map((color)=>({
                ...color,
                decorator: isNewColorPaletteEnabled && color.value === (0, $evFm2.REMOVE_HIGHLIGHT_COLOR) ? /*#__PURE__*/ $cozmU.createElement($41e58cb6d3564e2b$var$NoColorIconDecorator, {
                    isSelected: isSelected(color),
                    iconColor: iconColor
                }) : /*#__PURE__*/ $cozmU.createElement($41e58cb6d3564e2b$var$TextColorIconDecorator, {
                    label: color.label,
                    isSelected: isSelected(color),
                    iconColor: iconColor
                })
            }));
    }, [
        defaultColor,
        textColor,
        isNewColorPaletteEnabled,
        selectedColor
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.default), {
        xcss: $41e58cb6d3564e2b$var$styles.container,
        testId: "highlight-color-menu-item"
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "xxsmall"
    }, formatMessage((0, $hzZPp.highlightMessages).highlight)), /*#__PURE__*/ $cozmU.createElement((0, $74bCf.default), {
        cols: isNewColorPaletteEnabled ? $41e58cb6d3564e2b$var$HIGHLIGHT_COLOR_PICKER_COLUMNS : undefined,
        onClick: (color, _, event)=>{
            handleHighlightColorChange(color, event);
        },
        selectedColor: selectedColor,
        paletteOptions: {
            palette: colorPalette || [],
            hexToPaletteColor: (0, $9Rqjc.hexToEditorTextBackgroundPaletteColor)
        }
    }));
}
module.exports["HighlightColorMenuItem"] = $41e58cb6d3564e2b$export$5b2f3a4c271f0961;

});

parcelRegister("hEYnV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $8xvQD = parcelRequire("8xvQD");

const $903f1392564b5212$export$dbd605ef953212b2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $8xvQD.SelectedTextColorContext));
} : ()=>(0, $cozmU.useContext)((0, $8xvQD.SelectedTextColorContext));
module.exports["useSelectedTextColor"] = $903f1392564b5212$export$dbd605ef953212b2;

});

parcelRegister("3Q36X", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kIyFa = parcelRequire("kIyFa");


var $d9F9A = parcelRequire("d9F9A");


var $aiLzV = parcelRequire("aiLzV");


var $hpOE9 = parcelRequire("hpOE9");


var $k8QT2 = parcelRequire("k8QT2");

const $a2c87a834d4794ab$export$1ce21d3d70c60c32 = ({ api: api, config: options })=>{
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const primaryToolbarComponent = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k8QT2.TrackChangesToolbarButton), {
            api: api
        });
    };
    if (options?.showOnToolbar === true) {
        if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $hpOE9.getToolbarComponents)(api, options));
        else api?.primaryToolbar?.actions?.registerComponent({
            name: 'trackChanges',
            component: primaryToolbarComponent
        });
    }
    return {
        name: 'trackChanges',
        pmPlugins () {
            return [
                {
                    name: 'trackChangesKeyMap',
                    plugin: ()=>(0, $kIyFa.keymapPlugin)(api)
                },
                {
                    name: 'trackChangesPlugin',
                    plugin: ()=>(0, $d9F9A.createTrackChangesPlugin)(api)
                }
            ];
        },
        commands: {
            toggleChanges: ({ tr: tr })=>{
                return tr.setMeta((0, $d9F9A.trackChangesPluginKey), {
                    action: (0, $aiLzV.TOGGLE_TRACK_CHANGES_ACTION).TOGGLE_TRACK_CHANGES
                });
            },
            resetBaseline: ({ tr: tr })=>{
                if (!api?.trackChanges?.sharedState.currentState()?.isShowDiffAvailable) return null;
                return tr.setMeta((0, $d9F9A.trackChangesPluginKey), {
                    action: (0, $aiLzV.TOGGLE_TRACK_CHANGES_ACTION).RESET_BASELINE
                });
            }
        },
        getSharedState: (editorState)=>{
            if (!editorState) return {
                isDisplayingChanges: false,
                isShowDiffAvailable: false
            };
            return {
                isDisplayingChanges: Boolean((0, $d9F9A.trackChangesPluginKey).getState(editorState)?.shouldChangesBeDisplayed),
                isShowDiffAvailable: Boolean((0, $d9F9A.trackChangesPluginKey).getState(editorState)?.isShowDiffAvailable)
            };
        }
    };
};
module.exports["trackChangesPlugin"] = $a2c87a834d4794ab$export$1ce21d3d70c60c32;

});

parcelRegister("kIyFa", function(module, exports) {

var $8dxef = parcelRequire("8dxef");


var $ldqjS = parcelRequire("ldqjS");


var $kpCD8 = parcelRequire("kpCD8");


var $44cyU = parcelRequire("44cyU");

function $7275f18329282451$export$e832373cff8dec22(api) {
    const list = {};
    const browser = (0, $8dxef.getBrowserInfo)();
    // Exclude Firefox browser from keyboard shortcut
    if (!browser.gecko) (0, $ldqjS.bindKeymapWithCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.toggleViewChanges).common, ()=>{
        const isShowDiffAvailable = api?.trackChanges?.sharedState.currentState()?.isShowDiffAvailable;
        if (!isShowDiffAvailable) return false;
        const result = api?.core.actions.execute(api?.trackChanges?.commands.toggleChanges);
        return result ?? false;
    }, list);
    return new (0, $kpCD8.SafePlugin)({
        props: {
            handleKeyDown (view, event) {
                const keyboardEvent = (0, $ldqjS.isCapsLockOnAndModifyKeyboardEvent)(event);
                return (0, $44cyU.keydownHandler)(list)(view, keyboardEvent);
            }
        }
    });
}
module.exports["keymapPlugin"] = $7275f18329282451$export$e832373cff8dec22;

});

parcelRegister("d9F9A", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $eOaGc = parcelRequire("eOaGc");


var $ixfCV = parcelRequire("ixfCV");


var $aHU1u = parcelRequire("aHU1u");


var $5keal = parcelRequire("5keal");


var $aiLzV = parcelRequire("aiLzV");

const $84ce75f014b05932$export$7304ae0cfc08f061 = new (0, $kCECX.PluginKey)('trackChangesPlugin');
const $84ce75f014b05932$export$26b3581d344cfc94 = (doc, steps)=>{
    try {
        // Filter out AttrStep's since attribute changes shouldn't affect baseline content comparison
        const contentSteps = steps.filter((step)=>!(step.step instanceof (0, $eOaGc.AttrStep)));
        for (const step of contentSteps.slice().reverse()){
            const result = step.inverted.apply(doc);
            if (result.failed === null && result.doc) doc = result.doc;
        }
        return doc;
    } catch  {
        // Temporary - we need to understand how this happens - but we want to unblock issues where this crashes the editor
        return undefined;
    }
};
const $84ce75f014b05932$export$67af324863e9eeaf = (api)=>{
    // Mark the state to be reset on next time the document has a meaningful change
    let resetBaseline = false;
    return new (0, $kpCD8.SafePlugin)({
        key: $84ce75f014b05932$export$7304ae0cfc08f061,
        state: {
            init () {
                return {
                    steps: [],
                    shouldChangesBeDisplayed: false,
                    isShowDiffAvailable: false,
                    allocations: new Set()
                };
            },
            apply (tr, state) {
                const metadata = tr.getMeta($84ce75f014b05932$export$7304ae0cfc08f061);
                if (metadata && metadata.action === (0, $aiLzV.TOGGLE_TRACK_CHANGES_ACTION).RESET_BASELINE) return {
                    ...state,
                    steps: [],
                    isShowDiffAvailable: false
                };
                if (metadata && metadata.action === (0, $aiLzV.TOGGLE_TRACK_CHANGES_ACTION).TOGGLE_TRACK_CHANGES) {
                    resetBaseline = true;
                    return {
                        ...state,
                        shouldChangesBeDisplayed: !state.shouldChangesBeDisplayed
                    };
                }
                const isDocChanged = tr.docChanged && tr.steps.some((step)=>step instanceof (0, $eOaGc.ReplaceStep) || step instanceof (0, $eOaGc.ReplaceAroundStep) || step instanceof (0, $eOaGc.AddMarkStep) || step instanceof (0, $eOaGc.RemoveMarkStep) || step instanceof (0, $eOaGc.AttrStep));
                const isAnnotationStep = (step)=>step instanceof (0, $eOaGc.AddMarkStep) && step.mark.type.name === 'annotation';
                if (!isDocChanged || tr.getMeta('isRemote') || tr.getMeta('replaceDocument') || tr.steps.some(isAnnotationStep)) // If the transaction is remote, we need to map the steps to the current document
                return {
                    ...state,
                    steps: state.steps.map((s)=>{
                        const newStep = s.step.map(tr.mapping);
                        const newInvertedStep = s.inverted.map(tr.mapping);
                        if (newStep && newInvertedStep) return new (0, $5keal.InvertableStep)(newStep, newInvertedStep, s.allocation);
                        return undefined;
                    }).filter((s)=>!!s)
                };
                // If we don't have the history plugin don't limit the change tracking
                const historyState = api?.history?.sharedState.currentState();
                const currentAllocation = historyState ? historyState.done.eventCount + historyState.undone.eventCount : (state.steps.at(-1)?.allocation ?? 0) + 1;
                const newSteps = tr.steps.map((step, idx)=>new (0, $5keal.InvertableStep)(step, step.invert(tr.docs[idx]), currentAllocation));
                const concatSteps = resetBaseline ? newSteps : [
                    ...state.steps,
                    ...newSteps
                ];
                resetBaseline = false;
                const { allocations: allocations, steps: steps } = (0, $aHU1u.filterSteps)(concatSteps, state.allocations.add(currentAllocation));
                // Calculate if there are actual changes by comparing current doc with baseline
                const baselineDoc = $84ce75f014b05932$export$26b3581d344cfc94(tr.doc, steps);
                const hasChangesFromBaseline = baselineDoc ? !tr.doc.eq(baselineDoc) : false;
                // Create a new ChangeSet based on document changes
                return {
                    ...state,
                    allocations: allocations,
                    steps: steps,
                    shouldChangesBeDisplayed: false,
                    isShowDiffAvailable: hasChangesFromBaseline
                };
            }
        },
        view () {
            return {
                update (view, prevState) {
                    const prevShouldChangesBeDisplayed = $84ce75f014b05932$export$7304ae0cfc08f061.getState(prevState)?.shouldChangesBeDisplayed;
                    const currentPluginState = $84ce75f014b05932$export$7304ae0cfc08f061.getState(view.state);
                    const currentShouldChangesBeDisplayed = currentPluginState?.shouldChangesBeDisplayed;
                    if (prevShouldChangesBeDisplayed === false && currentShouldChangesBeDisplayed === true) {
                        const steps = currentPluginState?.steps ?? [];
                        const originalDoc = $84ce75f014b05932$export$26b3581d344cfc94(view.state.doc, steps);
                        if (originalDoc) api?.core?.actions.execute(api?.showDiff?.commands?.showDiff({
                            originalDoc: originalDoc,
                            steps: steps.map((s)=>s.step),
                            diffType: (0, $ixfCV.fg)('platform_editor_ai_smart_diff') ? 'smart' : 'inline'
                        }));
                    } else if (currentShouldChangesBeDisplayed === false && prevShouldChangesBeDisplayed === true) api?.core?.actions.execute(api?.showDiff?.commands?.hideDiff);
                }
            };
        }
    });
};
module.exports["trackChangesPluginKey"] = $84ce75f014b05932$export$7304ae0cfc08f061;
module.exports["createTrackChangesPlugin"] = $84ce75f014b05932$export$67af324863e9eeaf;

});

parcelRegister("aHU1u", function(module, exports) {

var $krzOZ = parcelRequire("krzOZ");

function $e3699701ab91b140$export$1f6a8febb8dbe92b(steps, allocations) {
    if (allocations.size <= (0, $krzOZ.MAX_STEPS_FROM_BASELINE)) return {
        steps: steps,
        allocations: allocations
    };
    // Create a new allocation, retaining only the most recent values
    const elements = Array.from(allocations);
    const newAllocation = new Set(elements.slice(-(0, $krzOZ.MAX_STEPS_FROM_BASELINE)));
    const finalSteps = [];
    let cutoffFound = false;
    for (const step of steps){
        if (newAllocation.has(step.allocation)) cutoffFound = true;
        // Accept everything after this point otherwise we could have mis-ordered steps
        if (cutoffFound) finalSteps.push(step);
    }
    return {
        steps: finalSteps,
        allocations: newAllocation
    };
}
module.exports["filterSteps"] = $e3699701ab91b140$export$1f6a8febb8dbe92b;

});

parcelRegister("krzOZ", function(module, exports) {
// To be determined a suitable threshold
// Exported for testing
const $59a6e778f9015334$export$e7e75006689980e4 = 10;
module.exports["MAX_STEPS_FROM_BASELINE"] = $59a6e778f9015334$export$e7e75006689980e4;

});

parcelRegister("5keal", function(module, exports) {
class $e246d3698737be30$export$ebdc1f934f4dd665 {
    constructor(step, inverted, allocation){
        this.step = step;
        this.inverted = inverted;
        this.allocation = allocation;
    }
}
module.exports["InvertableStep"] = $e246d3698737be30$export$ebdc1f934f4dd665;

});

parcelRegister("aiLzV", function(module, exports) {
var $637decd8b6d1c5c4$export$afb82ed05a2451a3 = /*#__PURE__*/ function(TOGGLE_TRACK_CHANGES_ACTION) {
    TOGGLE_TRACK_CHANGES_ACTION["TOGGLE_TRACK_CHANGES"] = "TOGGLE_TRACK_CHANGES";
    TOGGLE_TRACK_CHANGES_ACTION["RESET_BASELINE"] = "RESET_BASELINE";
    return TOGGLE_TRACK_CHANGES_ACTION;
}({});
module.exports["TOGGLE_TRACK_CHANGES_ACTION"] = $637decd8b6d1c5c4$export$afb82ed05a2451a3;

});

parcelRegister("hpOE9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3nacY = parcelRequire("3nacY");

var $hVLmg = parcelRequire("hVLmg");


var $k8QT2 = parcelRequire("k8QT2");

const $4ddb435087268510$export$a758406ca53b86a5 = (api, options)=>{
    return [
        {
            type: (0, $3nacY.TRACK_CHANGES_GROUP).type,
            key: (0, $3nacY.TRACK_CHANGES_GROUP).key,
            parents: [
                {
                    type: (0, $3nacY.TRACK_CHANGES_SECTION).type,
                    key: (0, $3nacY.TRACK_CHANGES_SECTION).key,
                    rank: (0, $hVLmg.TRACK_CHANGES_SECTION_RANK)[(0, $3nacY.TRACK_CHANGES_GROUP).key]
                }
            ]
        },
        {
            type: (0, $3nacY.TRACK_CHANGES_BUTTON).type,
            key: (0, $3nacY.TRACK_CHANGES_BUTTON).key,
            parents: [
                {
                    type: (0, $3nacY.TRACK_CHANGES_GROUP).type,
                    key: (0, $3nacY.TRACK_CHANGES_GROUP).key,
                    rank: (0, $hVLmg.TRACK_CHANGES_GROUP_RANK)[(0, $3nacY.TRACK_CHANGES_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k8QT2.TrackChangesToolbarButton), {
                    api: api,
                    wrapper: options?.ButtonWrapper
                })
        }
    ];
};
module.exports["getToolbarComponents"] = $4ddb435087268510$export$a758406ca53b86a5;

});

parcelRegister("k8QT2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $8dxef = parcelRequire("8dxef");


var $3k5Tv = parcelRequire("3k5Tv");


var $ldqjS = parcelRequire("ldqjS");


var $iInrd = parcelRequire("iInrd");


var $fxbF1 = parcelRequire("fxbF1");

var $6t3CY = parcelRequire("6t3CY");

var $lslMH = parcelRequire("lslMH");

const $40e70f543816f372$export$da54b7c34578dd9e = ({ api: api, wrapper: Wrapper })=>{
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const { isDisplayingChanges: isDisplayingChanges, isShowDiffAvailable: isShowDiffAvailable } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'trackChanges'
    ], (states)=>({
            isDisplayingChanges: states.trackChangesState?.isDisplayingChanges,
            isShowDiffAvailable: states.trackChangesState?.isShowDiffAvailable
        }));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        const wasShowingDiffSelected = isDisplayingChanges;
        const result = api?.core.actions.execute(api?.trackChanges?.commands.toggleChanges);
        // On de-selection - focus back on the editor
        if (result && wasShowingDiffSelected) api?.core.actions.focus();
    }, [
        api,
        isDisplayingChanges
    ]);
    const browser = (0, $8dxef.getBrowserInfo)();
    // Exclude Firefox browser from showing keyboard shortcut in tooltip
    const showShortcut = !browser.gecko;
    const tooltipContent = showShortcut ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldqjS.ToolTipContent), {
        description: formatMessage((0, $iInrd.trackChangesMessages).toolbarIconLabel),
        keymap: (0, $ldqjS.toggleViewChanges)
    }) : formatMessage((0, $iInrd.trackChangesMessages).toolbarIconLabel);
    if (!isToolbarAIFCEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fxbF1))),
        label: formatMessage((0, $iInrd.trackChangesMessages).toolbarIconLabel),
        appearance: "subtle",
        isDisabled: !isShowDiffAvailable,
        isSelected: isDisplayingChanges,
        onClick: handleClick
    }));
    const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6t3CY.ToolbarButton), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fxbF1))), {
            label: formatMessage((0, $iInrd.trackChangesMessages).toolbarIconLabel),
            size: "small"
        }),
        onClick: handleClick,
        isDisabled: !isShowDiffAvailable,
        isSelected: isDisplayingChanges
    }));
    return Wrapper ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Wrapper, null, button) : button;
};
module.exports["TrackChangesToolbarButton"] = $40e70f543816f372$export$da54b7c34578dd9e;

});

parcelRegister("fxbF1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::619fb4ad6cec2107e8d1f4fc5bb05b5a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4f2fba9f65c2ddf$var$_react = $b4f2fba9f65c2ddf$var$_interopRequireDefault((parcelRequire("cozmU")));

var $b4f2fba9f65c2ddf$var$_baseNew = $b4f2fba9f65c2ddf$var$_interopRequireDefault((parcelRequire("gElAV")));
function $b4f2fba9f65c2ddf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "History".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for history and recent
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b4f2fba9f65c2ddf$var$HistoryIcon = (props)=>/*#__PURE__*/ $b4f2fba9f65c2ddf$var$_react.default.createElement($b4f2fba9f65c2ddf$var$_baseNew.default, Object.assign({
        name: "HistoryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1.5 8A6.5 6.5 0 1 0 8 1.5a6.36 6.36 0 0 0-4.651 2.005l1.298.26a.75.75 0 0 1-.09 1.483l-3.25.25A.75.75 0 0 1 .5 4.75V1.5l.013-.137a.75.75 0 0 1 1.456-.079l.34 1.138A7.86 7.86 0 0 1 8 0a8 8 0 1 1-8 8zm7.25-4.25v4.389l2.219 1.775-.938 1.172-2.5-2A.75.75 0 0 1 7.25 8.5V3.75z"/>`
    }, props));
$b4f2fba9f65c2ddf$var$HistoryIcon.displayName = 'HistoryIcon';
var $b4f2fba9f65c2ddf$var$_default = module.exports.default = $b4f2fba9f65c2ddf$var$HistoryIcon;

});

parcelRegister("1Rod9", function(module, exports) {

var $3ppaK = parcelRequire("3ppaK");

function $33d6ff45ac878a78$export$63102b0cbe181144(featureFlags) {
    const normalizedFeatureFlags = (0, $3ppaK.normalizeFeatureFlags)(featureFlags);
    // IMPORTANT: If you add a new feature flag here, please make sure to add it to the
    // `featureFlagsPluginOptions` function in 'packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/featureFlagsPluginOptions.ts`.
    return {
        ...normalizedFeatureFlags,
        catchAllTracking: false,
        showAvatarGroupAsPlugin: false,
        errorBoundaryDocStructure: false,
        synchronyErrorDocStructure: false,
        enableViewUpdateSubscription: false,
        collabAvatarScroll: false,
        twoLineEditorToolbar: false,
        disableSpellcheckByBrowser: undefined
    };
}
module.exports["createFeatureFlagsFromProps"] = $33d6ff45ac878a78$export$63102b0cbe181144;

});

parcelRegister("6xiPL", function(module, exports) {

var $kwQ9l = parcelRequire("kwQ9l");


var $6mKj3 = parcelRequire("6mKj3");

let $d01568efbca88c19$var$codeBlockFormatProvider;
const $d01568efbca88c19$export$8ef3c9ac982ee475 = ()=>{
    if (!(0, $6mKj3.expVal)('platform_editor_code_block_q4_lovability', 'isEnabled', false)) return undefined;
    $d01568efbca88c19$var$codeBlockFormatProvider ?? ($d01568efbca88c19$var$codeBlockFormatProvider = (0, $kwQ9l.createCodeBlockFormatProvider)());
    return $d01568efbca88c19$var$codeBlockFormatProvider;
};
module.exports["getCodeBlockFormatProvider"] = $d01568efbca88c19$export$8ef3c9ac982ee475;

});

parcelRegister("kwQ9l", function(module, exports) {

var $9UdKP = parcelRequire("9UdKP");

const $9a6bef97c36a75b2$var$preload = async (language)=>{
    if (!(0, $9UdKP.isSupportedLanguage)(language)) return;
    await (0, $9UdKP.loadFormatter)(language).catch(()=>undefined);
};
const $9a6bef97c36a75b2$var$formatCode = async ({ content: content, language: language })=>{
    if (!(0, $9UdKP.isSupportedLanguage)(language)) return {
        errorType: 'formatter-execution-failed',
        language: language,
        status: 'failed'
    };
    const format = await (0, $9UdKP.loadFormatter)(language).catch(()=>undefined);
    if (!format) return {
        errorType: 'formatter-load-failed',
        language: language,
        status: 'failed'
    };
    let formattedContent;
    try {
        formattedContent = await format(content);
    } catch  {
        return {
            errorType: 'formatter-execution-failed',
            language: language,
            status: 'failed'
        };
    }
    return {
        content: formattedContent,
        language: language,
        status: formattedContent === content ? 'unchanged' : 'formatted'
    };
};
const $9a6bef97c36a75b2$export$213065f4d8d59ac = ()=>({
        formatCode: $9a6bef97c36a75b2$var$formatCode,
        isSupportedLanguage: $9UdKP.isSupportedLanguage,
        preload: $9a6bef97c36a75b2$var$preload
    });
module.exports["createCodeBlockFormatProvider"] = $9a6bef97c36a75b2$export$213065f4d8d59ac;

});

parcelRegister("9UdKP", function(module, exports) {
let $5cc88dbd91b5e50b$var$prettierFormatterPromise;
let $5cc88dbd91b5e50b$var$sqlFormatterPromise;
const $5cc88dbd91b5e50b$var$stripFinalLineEnding = (content)=>{
    if (content.endsWith('\r\n')) return content.slice(0, -2);
    if (content.endsWith('\n')) return content.slice(0, -1);
    return content;
};



const $5cc88dbd91b5e50b$var$loadPrettierFormatter = ()=>{
    if (!$5cc88dbd91b5e50b$var$prettierFormatterPromise) $5cc88dbd91b5e50b$var$prettierFormatterPromise = Promise.all([
        (parcelRequire("kOKyc")),
        (parcelRequire("8jBZd")),
        (parcelRequire("c8jfa"))
    ]).then(([prettier, babelPlugin, estreePlugin])=>{
        return (content, parser)=>prettier.format(content, {
                parser: parser,
                plugins: [
                    babelPlugin.default,
                    estreePlugin.default
                ]
            }).then($5cc88dbd91b5e50b$var$stripFinalLineEnding);
    }).catch((error)=>{
        $5cc88dbd91b5e50b$var$prettierFormatterPromise = undefined;
        throw error;
    });
    return $5cc88dbd91b5e50b$var$prettierFormatterPromise;
};

const $5cc88dbd91b5e50b$var$loadSqlFormatter = ()=>{
    if (!$5cc88dbd91b5e50b$var$sqlFormatterPromise) $5cc88dbd91b5e50b$var$sqlFormatterPromise = (parcelRequire("ISVhk")).then((formatter)=>formatter.format).catch((error)=>{
        $5cc88dbd91b5e50b$var$sqlFormatterPromise = undefined;
        throw error;
    });
    return $5cc88dbd91b5e50b$var$sqlFormatterPromise;
};
const $5cc88dbd91b5e50b$var$loadPrettierLanguageFormatter = (parser)=>async ()=>{
        const format = await $5cc88dbd91b5e50b$var$loadPrettierFormatter();
        return (content)=>format(content, parser);
    };
const $5cc88dbd91b5e50b$var$loadSqlLanguageFormatter = async ()=>{
    const format = await $5cc88dbd91b5e50b$var$loadSqlFormatter();
    return (content)=>format(content, {
            language: 'sql'
        });
};
const $5cc88dbd91b5e50b$var$languageFormatters = {
    javascript: $5cc88dbd91b5e50b$var$loadPrettierLanguageFormatter('babel'),
    json: $5cc88dbd91b5e50b$var$loadPrettierLanguageFormatter('json'),
    jsx: $5cc88dbd91b5e50b$var$loadPrettierLanguageFormatter('babel'),
    sql: $5cc88dbd91b5e50b$var$loadSqlLanguageFormatter
};
const $5cc88dbd91b5e50b$export$47c66070d6d6cd6d = (language)=>typeof language === 'string' && language in $5cc88dbd91b5e50b$var$languageFormatters;
const $5cc88dbd91b5e50b$export$819465c5ba26e010 = (language)=>$5cc88dbd91b5e50b$var$languageFormatters[language]();
module.exports["isSupportedLanguage"] = $5cc88dbd91b5e50b$export$47c66070d6d6cd6d;
module.exports["loadFormatter"] = $5cc88dbd91b5e50b$export$819465c5ba26e010;

});

parcelRegister("kOKyc", function(module, exports) {

let $f27c96210168c8a0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f27c96210168c8a0$var$load("8yhpo").then(()=>parcelRequire('HUkVt'));

});

parcelRegister("8jBZd", function(module, exports) {

let $60dd905dab1c4fb8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $60dd905dab1c4fb8$var$load("iba7Y").then(()=>parcelRequire('eyRZU'));

});

parcelRegister("c8jfa", function(module, exports) {

let $8d5528c02931abd8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8d5528c02931abd8$var$load("1O2Ve").then(()=>parcelRequire('b0DMM'));

});

parcelRegister("ISVhk", function(module, exports) {

let $086eb6b56d1d9253$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $086eb6b56d1d9253$var$load("b48dU").then(()=>parcelRequire('gfpM4'));

});

parcelRegister("anvR9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $2f76e69d1d3f5e57$export$6b580bde8e7240a3(baseProvider, snippetId, scope) {
    return (0, $cozmU.useMemo)(()=>{
        if (!baseProvider || !snippetId) return baseProvider;
        return baseProvider.then((base)=>({
                ...base,
                objectId: JSON.stringify({
                    snippetId: snippetId,
                    scope: scope
                })
            }));
    }, [
        baseProvider,
        snippetId,
        scope
    ]);
}
module.exports["useSnippetEditorContextIdentifierProvider"] = $2f76e69d1d3f5e57$export$6b580bde8e7240a3;

});

parcelRegister("3plmx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ggGdk = parcelRequire("ggGdk");


var $kLzei = parcelRequire("kLzei");


var $bQm3c = parcelRequire("bQm3c");


var $btIEy = parcelRequire("btIEy");


var $i6Ps3 = parcelRequire("i6Ps3");


var $eaaOs = parcelRequire("eaaOs");


var $6M71K = parcelRequire("6M71K");

const $78db0f388b3bc59b$var$useInitialState = ()=>{
    return (0, $cozmU.useMemo)(()=>{
        const ssrProvidersData = window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] || {};
        const ssrData = ssrProvidersData.editorCardProvider;
        if (!ssrData) return undefined;
        return Object.entries(ssrData).reduce((acc, [cacheKey, details])=>{
            const { metadataStatus: cacheMetadataStatus, url: url } = (0, $eaaOs.getUrlAndMetadataStatus)(cacheKey);
            const status = (0, $ggGdk.getStatus)(details);
            const metadataStatus = status === 'resolved' ? cacheMetadataStatus : 'resolved';
            if (acc[url]?.metadataStatus === 'resolved' && metadataStatus !== 'resolved') return acc;
            acc[url] = {
                status: status,
                details: details,
                metadataStatus: metadataStatus
            };
            return acc;
        }, {});
    }, []);
};
const $78db0f388b3bc59b$var$useStoreOptions = ()=>{
    const isPageSSR = (0, $i6Ps3.isPageSSRd)();
    const initialState = $78db0f388b3bc59b$var$useInitialState();
    const oldInitialState = window['__SSR_SMARTLINKS__'];
    const oldStoreOptions = (0, $btIEy.useStoreOptions)(oldInitialState, isPageSSR);
    return (0, $cozmU.useMemo)(()=>{
        if (initialState) return {
            initialState: initialState
        };
        return oldStoreOptions.storeOptions;
    }, [
        oldStoreOptions,
        initialState
    ]);
};
function $78db0f388b3bc59b$export$eaed11d22c122636(WrappedComponent) {
    return (props)=>{
        const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
        const storeOptions = $78db0f388b3bc59b$var$useStoreOptions();
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6M71K.ConfluenceSmartCardProvider), {
            ...(0, $kLzei.getSmartCardRenderers)(),
            storeOptions: storeOptions,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            doNotUsePreviewPanels: true
        }, content));
    };
}
module.exports["withSmartCardProviderContext"] = $78db0f388b3bc59b$export$eaed11d22c122636;

});

parcelRegister("awIbt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $faAj4 = parcelRequire("faAj4");


var $d7j1D = parcelRequire("d7j1D");

function $44be53440eeaa295$export$7deec7951f922f64(WrappedComponent) {
    function withEditorActions(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7j1D.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $faAj4.default), {
            render: (editorActions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                    editorActions: editorActions,
                    ...props
                })
        }));
    }
    return withEditorActions;
}
module.exports["withEditorActions"] = $44be53440eeaa295$export$7deec7951f922f64;

});

parcelRegister("faAj4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $54Cdh = parcelRequire("54Cdh");

class $c089dd5bc3bc2565$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c089dd5bc3bc2565$var$WithEditorActionsNew, this.props);
    }
    constructor(props){
        super(props);
    }
}
const $c089dd5bc3bc2565$var$WithEditorActionsNew = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WithEditorActionsNew(props) {
    const $ = (0, $bDgLe.c)(3);
    const { render: render } = props;
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $54Cdh.EditorContext));
    const t0 = context?.editorActions;
    let t1;
    if ($[0] !== render || $[1] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c089dd5bc3bc2565$var$WithEditorActionsInner, {
            render: render,
            editorActions: t0
        });
        $[0] = render;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function WithEditorActionsNew(props) {
    const { render: render } = props;
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $54Cdh.EditorContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c089dd5bc3bc2565$var$WithEditorActionsInner, {
        render: render,
        editorActions: context?.editorActions
    });
}; // Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $c089dd5bc3bc2565$var$WithEditorActionsInner extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidMount() {
        this.props.editorActions._privateSubscribe(()=>this.forceUpdate());
    }
    componentWillUnmount() {
        this.props.editorActions._privateUnsubscribe(()=>this.forceUpdate());
    }
    render() {
        return this.props.render(this.props.editorActions);
    }
}
module.exports["default"] = $c089dd5bc3bc2565$export$2e2bcd8739ae039;

});

parcelRegister("aNHzZ", function(module, exports) {
const $1a12bc74546e803b$export$93264818345214c8 = 60;
const $1a12bc74546e803b$export$765b1eac9c70d01 = 40;
const $1a12bc74546e803b$export$4e4fc3c1312865b2 = 120;
const $1a12bc74546e803b$export$4648d4b2e5c9cb99 = 60;
function $1a12bc74546e803b$export$a9547c92fffb73eb(includeSharingField) {
    const values = {
        snippetName: '',
        snippetDescription: ''
    };
    if (includeSharingField) values.isShared = false;
    return values;
}
module.exports["MAX_SNIPPET_NAME_LENGTH"] = $1a12bc74546e803b$export$93264818345214c8;
module.exports["SNIPPET_NAME_CUTOFF_LENGTH"] = $1a12bc74546e803b$export$765b1eac9c70d01;
module.exports["MAX_SNIPPET_DESCRIPTION_LENGTH"] = $1a12bc74546e803b$export$4e4fc3c1312865b2;
module.exports["SNIPPET_DESCRIPTION_CUTOFF_LENGTH"] = $1a12bc74546e803b$export$4648d4b2e5c9cb99;
module.exports["getDefaultFormValues"] = $1a12bc74546e803b$export$a9547c92fffb73eb;

});

parcelRegister("7rMlZ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lpJCW = parcelRequire("lpJCW");

const $654f394c978fbfe1$export$9497073af4ab734f = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, isLoading: isLoading } = t0;
    if (isLoading) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpJCW.AIBorder), {
                loading: true,
                hideGlow: true,
                useModalStyles: true
            }, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[2] = children;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["AIInputField"] = $654f394c978fbfe1$export$9497073af4ab734f;

});

parcelRegister("lpJCW", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $8jQuQ = parcelRequire("8jQuQ");

var $9ivsj = parcelRequire("9ivsj");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5e4f95acdf8fc4d$var$GradientPropertyContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1bsb1osq _kqswh2mm _c71l1kw7",
            __cmplp.className
        ])
    });
});
const $f5e4f95acdf8fc4d$var$outerContainerStyles = (0, $buxP3.xcss)({
    overflow: 'hidden',
    position: 'relative',
    background: `conic-gradient(
    from var(--gradient-angle, 45deg),
    #0065FF 10%,
    #0469FF 30%,
    #BF63F3 50%,
    #FFA900 70%,
    #0065FF 90%
  )`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ...(0, $8jQuQ.reduceMotionAsPerUserPreference),
    maxHeight: 'inherit'
});
const $f5e4f95acdf8fc4d$var$animationStyles = (0, $buxP3.xcss)({
    animation: 'rotationAnimation linear 2s infinite'
});
const $f5e4f95acdf8fc4d$var$baseGlowStyles = (0, $buxP3.xcss)({
    position: 'absolute',
    filter: 'blur(25px)',
    opacity: '0.5',
    height: '100%',
    width: '100%'
});
const $f5e4f95acdf8fc4d$var$defaultBorderRadiusStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.large'
});
const $f5e4f95acdf8fc4d$var$modalBorderRadiusStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.small'
});
const $f5e4f95acdf8fc4d$var$innerContainerStyles = (0, $buxP3.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    maxHeight: 'inherit',
    display: 'flex',
    flexDirection: 'column',
    backgroundClip: 'content-box'
});
const $f5e4f95acdf8fc4d$export$6ed1e39f4dbe0bbf = ({ loading: loading = false, children: children, useModalStyles: useModalStyles, hideGlow: hideGlow, customInnerContainerStyles: customInnerContainerStyles, customGlowStyles: customGlowStyles, ...props })=>{
    const isReducedMotion = (0, $9ivsj.useIsReducedMotion)();
    const shouldRotate = loading && !isReducedMotion;
    const containerStyles = shouldRotate ? [
        $f5e4f95acdf8fc4d$var$outerContainerStyles,
        $f5e4f95acdf8fc4d$var$animationStyles
    ] : [
        $f5e4f95acdf8fc4d$var$outerContainerStyles
    ];
    const glowStyles = customGlowStyles ? [
        $f5e4f95acdf8fc4d$var$baseGlowStyles,
        customGlowStyles
    ] : [
        $f5e4f95acdf8fc4d$var$baseGlowStyles
    ];
    const borderRadiusStyles = useModalStyles ? $f5e4f95acdf8fc4d$var$modalBorderRadiusStyles : $f5e4f95acdf8fc4d$var$defaultBorderRadiusStyles;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5e4f95acdf8fc4d$var$GradientPropertyContainer, {
        "data-testid": "ai-border-container",
        ...props
    }, shouldRotate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: [
            ...containerStyles,
            borderRadiusStyles,
            ...hideGlow ? [] : glowStyles
        ],
        testId: "loading-glow"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: [
            ...containerStyles,
            borderRadiusStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        padding: "space.025",
        xcss: [
            $f5e4f95acdf8fc4d$var$innerContainerStyles,
            borderRadiusStyles,
            customInnerContainerStyles
        ]
    }, children)));
};
module.exports["AIBorder"] = $f5e4f95acdf8fc4d$export$6ed1e39f4dbe0bbf;

});

parcelRegister("8jQuQ", function(module, exports) {
/**
 * Use for any CSS based motion (animation or transition).
 * Always put at the end of your declaration for correct use of the cascade.
 * Reduced motion preference is generally set through OS preferences/settings.
 *
 * @deprecated This is not fully compatible with Compiled CSS and will be removed in the future.
 * You should hardcode the `prefers-reduced-motion` media query in your file instead.
 */ const $cfd6e6a22c7a51c3$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
module.exports["reduceMotionAsPerUserPreference"] = $cfd6e6a22c7a51c3$export$f0f789643ba5a83c;

});

parcelRegister("9ivsj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $dX6FL = parcelRequire("dX6FL");


var $jlWUB = parcelRequire("jlWUB");

const $68c74ae30c005fed$export$c537e63161742ce3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $cozmU.useState)((0, $jlWUB.isReducedMotion));
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            if (!(0, $dX6FL.isMatchMediaAvailable)()) return;
            const mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
            const onChange = (event)=>setPrefersReducedMotion(event.matches);
            return (0, $cbY7C.bind)(mediaQueryList, {
                type: "change",
                listener: onChange
            });
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return prefersReducedMotion;
} : ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $cozmU.useState)((0, $jlWUB.isReducedMotion));
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $dX6FL.isMatchMediaAvailable)()) return;
        const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (event)=>setPrefersReducedMotion(event.matches);
        return (0, $cbY7C.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
module.exports["useIsReducedMotion"] = $68c74ae30c005fed$export$c537e63161742ce3;

});

parcelRegister("ag32C", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $6qCW4 = parcelRequire("6qCW4");


var $j1kxT = parcelRequire("j1kxT");

const $25d6d3c74e99db00$var$styles = {
    fieldWrapper: "_1wcd1b66 _1i10ze3t"
}; /**
    * Wraps CharacterCounterField to only show the "X characters remaining"
    * message once the field value reaches the cutoff length.
    */ 
function $25d6d3c74e99db00$export$a3e93264a5dc60ff(t0) {
    const $ = (0, $bDgLe.c)(10);
    let cutoff;
    let name;
    let rest;
    if ($[0] !== t0) {
        ({ cutoff: cutoff, name: name, ...rest } = t0);
        $[0] = t0;
        $[1] = cutoff;
        $[2] = name;
        $[3] = rest;
    } else {
        cutoff = $[1];
        name = $[2];
        rest = $[3];
    }
    let t1;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            values: true
        };
        $[4] = t1;
    } else t1 = $[4];
    const formState = (0, $j1kxT.useFormState)(t1);
    const fieldValue = String(formState?.values?.[name] ?? "");
    const underMaximumMessage = fieldValue.length >= cutoff ? undefined : "\xA0";
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $25d6d3c74e99db00$var$styles.fieldWrapper
        ]);
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== name || $[7] !== rest || $[8] !== underMaximumMessage) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t2
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6qCW4.default), {
            name: name,
            underMaximumMessage: underMaximumMessage,
            ...rest
        }));
        $[6] = name;
        $[7] = rest;
        $[8] = underMaximumMessage;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
}
module.exports["SnippetCharacterCounterField"] = $25d6d3c74e99db00$export$a3e93264a5dc60ff;

});

parcelRegister("cqjzX", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $dUI0h = parcelRequire("dUI0h");


var $lMGh1 = parcelRequire("lMGh1");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $lpNn5 = parcelRequire("lpNn5");

const $cdd6066178b1b7b7$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    sharingChangeToPersonalWarning: {
        id: "snippets.snippetEditorModal.sharingChangeToPersonalWarning",
        defaultMessage: "If you change this to a personal template it will only be available to you"
    },
    saveToPersonal: {
        id: "snippets.snippetEditorModal.saveToPersonal",
        defaultMessage: "Personal"
    },
    saveToSiteWide: {
        id: "snippets.snippetEditorModal.saveToSiteWide",
        defaultMessage: "Site wide"
    },
    saveToPersonalTooltip: {
        id: "snippets.snippetEditorModal.saveToPersonalTooltip",
        defaultMessage: "Save to this space to keep this template private."
    },
    saveToSiteWideTooltip: {
        id: "snippets.snippetEditorModal.saveToSiteWideTooltip",
        defaultMessage: "Site wide lets your company access this template but not edit."
    }
});
const $cdd6066178b1b7b7$var$styles = {
    saveToButtonGroup: "_zulp1b66 _2rko1qi0 _1reo15vq _18m915vq _1yt4v77o _189ee4h9 _1dqonqa1 _1h6d1l7x _1e0c1txw _1bsb1osq",
    saveToButtonSlot: "_16jlkb7n _1o9zkb7n _i0dlf1ug",
    warningIconWrapper: "_1e0c1txw _19pkv77o"
};
const $cdd6066178b1b7b7$export$f665397237719938 = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { name: name, label: label, defaultValue: defaultValue } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== defaultValue || $[1] !== intl) {
        t1 = (t2)=>{
            const { fieldProps: fieldProps } = t2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
                space: "space.075"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
                role: "group",
                "aria-labelledby": fieldProps["aria-labelledby"],
                space: "space.050",
                xcss: $cdd6066178b1b7b7$var$styles.saveToButtonGroup
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                xcss: $cdd6066178b1b7b7$var$styles.saveToButtonSlot
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                content: intl.formatMessage($cdd6066178b1b7b7$export$defe85febe8b728c.saveToPersonalTooltip),
                position: "bottom"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                appearance: "subtle",
                isSelected: fieldProps.value === false,
                onClick: ()=>fieldProps.onChange(false),
                "aria-pressed": fieldProps.value === false,
                shouldFitContainer: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $cdd6066178b1b7b7$export$defe85febe8b728c.saveToPersonal)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                xcss: $cdd6066178b1b7b7$var$styles.saveToButtonSlot
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                content: intl.formatMessage($cdd6066178b1b7b7$export$defe85febe8b728c.saveToSiteWideTooltip),
                position: "bottom"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                appearance: "subtle",
                isSelected: fieldProps.value === true,
                onClick: ()=>fieldProps.onChange(true),
                "aria-pressed": fieldProps.value === true,
                shouldFitContainer: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $cdd6066178b1b7b7$export$defe85febe8b728c.saveToSiteWide))))), defaultValue === true && fieldProps.value === false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
                space: "space.075"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                xcss: $cdd6066178b1b7b7$var$styles.warningIconWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
                label: "warning",
                color: "var(--ds-icon-warning, #E06C00)",
                size: "small"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
                size: "small",
                color: "color.text.warning"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $cdd6066178b1b7b7$export$defe85febe8b728c.sharingChangeToPersonalWarning))));
        };
        $[0] = defaultValue;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== defaultValue || $[4] !== label || $[5] !== name || $[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: name,
            label: label,
            defaultValue: defaultValue
        }, t1);
        $[3] = defaultValue;
        $[4] = label;
        $[5] = name;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
module.exports["SnippetSharingField"] = $cdd6066178b1b7b7$export$f665397237719938;

});

parcelRegister("d3Wxa", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7joZr = parcelRequire("7joZr");


var $ad7Ou = parcelRequire("ad7Ou");


var $I7hWB = parcelRequire("I7hWB");


var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $iMnC5 = parcelRequire("iMnC5");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $lsxnT = parcelRequire("lsxnT");


var $ivb8S = parcelRequire("ivb8S");


var $bEwOV = parcelRequire("bEwOV");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $hPTbh = parcelRequire("hPTbh");


var $8yRiX = parcelRequire("8yRiX");


var $jxXkP = parcelRequire("jxXkP");


var $1PcZL = parcelRequire("1PcZL");


var $bUxVg = parcelRequire("bUxVg");

const $ba74060991560bb5$var$styles = {
    headerContainer: "_ca0qxy5q _u5f3xy5q _19bvxy5q",
    illustrationWrapper: "_1e0c1txw _1bah1h6o _ca0q1ejb _n3tdu2gc"
};
const $ba74060991560bb5$var$FIRST_SNIPPET_CREATED_ANALYTICS = {
    ACTION_VIEWED: 'viewed',
    ACTION_DISMISSED: 'dismissed',
    DISMISSAL_CLOSE: 'close',
    DISMISSAL_VIEW_TEMPLATES: 'viewTemplates'
};
const $ba74060991560bb5$export$27aea554c0492dfd = (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { onClose: onClose, onCloseComplete: onCloseComplete } = t0;
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const openSnippetPanel = (0, $8yRiX.useOpenSnippetPanel)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isViewMode = pageMode === (0, $cD1qu.PageMode).VIEW;
    const { fireModalClosedAnalytic: fireModalClosedAnalytic } = (0, $jxXkP.useSnippetAnalytics)((0, $hPTbh.ANALYTICS_ORIGIN).FIRST_SNIPPET_CREATED_MODAL);
    let t1;
    let t2;
    if ($[0] !== fireModalClosedAnalytic) {
        t1 = ()=>{
            fireModalClosedAnalytic((0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).FIRST_SNIPPET_CREATED_MODAL, {
                action: $ba74060991560bb5$var$FIRST_SNIPPET_CREATED_ANALYTICS.ACTION_VIEWED
            });
        };
        t2 = [
            fireModalClosedAnalytic
        ];
        $[0] = fireModalClosedAnalytic;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] !== fireModalClosedAnalytic || $[4] !== onClose || $[5] !== setOnboardingState) {
        t3 = ()=>{
            fireModalClosedAnalytic((0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).FIRST_SNIPPET_CREATED_MODAL, {
                action: $ba74060991560bb5$var$FIRST_SNIPPET_CREATED_ANALYTICS.ACTION_DISMISSED,
                dismissalAction: $ba74060991560bb5$var$FIRST_SNIPPET_CREATED_ANALYTICS.DISMISSAL_CLOSE
            });
            setOnboardingState({
                key: (0, $bEwOV.SNIPPETS_ONBOARDING).HAS_SEEN_FIRST_SNIPPET_CREATED_MODAL,
                value: "true"
            });
            onClose();
        };
        $[3] = fireModalClosedAnalytic;
        $[4] = onClose;
        $[5] = setOnboardingState;
        $[6] = t3;
    } else t3 = $[6];
    const handleDismiss = t3;
    let t4;
    if ($[7] !== fireModalClosedAnalytic || $[8] !== onClose || $[9] !== openSnippetPanel || $[10] !== setOnboardingState) {
        t4 = ()=>{
            fireModalClosedAnalytic((0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).FIRST_SNIPPET_CREATED_MODAL, {
                action: $ba74060991560bb5$var$FIRST_SNIPPET_CREATED_ANALYTICS.ACTION_DISMISSED,
                dismissalAction: $ba74060991560bb5$var$FIRST_SNIPPET_CREATED_ANALYTICS.DISMISSAL_VIEW_TEMPLATES
            });
            setOnboardingState({
                key: (0, $bEwOV.SNIPPETS_ONBOARDING).HAS_SEEN_FIRST_SNIPPET_CREATED_MODAL,
                value: "true"
            });
            openSnippetPanel();
            onClose();
        };
        $[7] = fireModalClosedAnalytic;
        $[8] = onClose;
        $[9] = openSnippetPanel;
        $[10] = setOnboardingState;
        $[11] = t4;
    } else t4 = $[11];
    const handleViewTemplate = t4;
    let t5;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "medium"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $bUxVg.messages).firstSnippetCreatedModalTitle));
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $ba74060991560bb5$var$styles.headerContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            space: "space.100"
        }, t5, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            color: "color.text.subtle"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $bUxVg.messages).firstSnippetCreatedModalSubtitle))));
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $ba74060991560bb5$var$styles.illustrationWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($1PcZL))),
            alt: "",
            width: 554,
            height: 253,
            "data-testid": "first-snippet-created-illustration"
        })));
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== handleDismiss || $[16] !== handleViewTemplate || $[17] !== isViewMode) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7joZr.default), null, isViewMode ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: handleDismiss
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $bUxVg.messages).firstSnippetCreatedModalOkButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            onClick: handleDismiss
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $bUxVg.messages).firstSnippetCreatedModalCloseButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: handleViewTemplate
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $bUxVg.messages).firstSnippetCreatedModalViewButton)))));
        $[15] = handleDismiss;
        $[16] = handleViewTemplate;
        $[17] = isViewMode;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== Modal || $[20] !== handleDismiss || $[21] !== onCloseComplete || $[22] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
            onClose: handleDismiss,
            onCloseComplete: onCloseComplete,
            width: "medium"
        }, t6, t7, t8);
        $[19] = Modal;
        $[20] = handleDismiss;
        $[21] = onCloseComplete;
        $[22] = t8;
        $[23] = t9;
    } else t9 = $[23];
    return t9;
};
module.exports["FirstSnippetCreatedModal"] = $ba74060991560bb5$export$27aea554c0492dfd;

});

parcelRegister("1PcZL", function(module, exports) {
module.exports = new URL("FirstSnippetCreatedIllustration.e21b8838.svg", import.meta.url).toString();

});

parcelRegister("bUxVg", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $83855988ed16504b$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    firstSnippetCreatedModalTitle: {
        id: "snippets.firstSnippetCreatedModalTitle",
        defaultMessage: "Nice! You created your first template."
    },
    firstSnippetCreatedModalSubtitle: {
        id: "snippets.firstSnippetCreatedModalSubtitle",
        defaultMessage: "Type \"/template\" or favorite templates for quick access."
    },
    firstSnippetCreatedModalCloseButton: {
        id: "snippets.firstSnippetCreatedModalCloseButton",
        defaultMessage: "Close"
    },
    firstSnippetCreatedModalViewButton: {
        id: "snippets.firstSnippetCreatedModalViewButton",
        defaultMessage: "View my template"
    },
    firstSnippetCreatedModalOkButton: {
        id: "snippets.firstSnippetCreatedModalOkButton",
        defaultMessage: "Ok"
    }
});
module.exports["messages"] = $83855988ed16504b$export$defe85febe8b728c;

});

parcelRegister("cYuYM", function(module, exports) {

var $5vi32 = parcelRequire("5vi32");


var $9bL1w = parcelRequire("9bL1w");

const $955ee3c4efc889bc$export$349f17fbd3b37cd1 = ()=>{
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const { isTemplateBrowserEnabled: isTemplateBrowserEnabled, isTemplateBrowserPanelEnabled: isTemplateBrowserPanelEnabled } = (0, $9bL1w.useEmbeddedEditPageFeatures)();
    if (!isEmbeddedConfluence) return true;
    return !!(isTemplateBrowserEnabled || isTemplateBrowserPanelEnabled);
};
module.exports["useIsSnippetCreateEnabled"] = $955ee3c4efc889bc$export$349f17fbd3b37cd1;

});

parcelRegister("inDu6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $kRW4Y = parcelRequire("kRW4Y");

function $34458177b4f70747$export$69f1ef99d32d73a0(InnerComponent) {
    var _WithDialogs;
    return _WithDialogs = class WithDialogs extends (0, $cozmU.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                to: [
                    (0, $kRW4Y.DialogsStateContainer)
                ]
            }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InnerComponent, {
                    ...this.props,
                    dialogs: dialogs
                }));
        }
    }, _WithDialogs.displayName = `withDialogs(${InnerComponent.displayName || InnerComponent.name})`, _WithDialogs;
}
module.exports["withDialogs"] = $34458177b4f70747$export$69f1ef99d32d73a0;

});

parcelRegister("kRW4Y", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $2BAFx = parcelRequire("2BAFx");

class $c329db8a0d5b9472$export$11ff2eb6414212c6 extends (0, $kNIYN.Container) {
    onChildClose(key, ...args) {
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        this.setState((state)=>({
                stack: state.stack.map((frame)=>frame === childFrame ? {
                        ...frame,
                        alive: false
                    } : frame)
            }));
    }
    onChildCloseComplete(key, ...args) {
        // A child dialog called its onCloseComplete prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        this.setState((state)=>({
                stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
            }));
    }
    constructor(stack = []){
        super();
        /*
        Arguably, nextKey belongs in state (as per 'flags' package). But then there's
        an unenviable choice of, in showDialog, putting the React.createElement in the
        setState callback, or giving setState an object instead of a callback and
        risk having two dialogs opened with the same key in the (unlikely) scenario
        that they're both opened in the same tick.
      */ this.showModal = (componentClass, originalProps, children)=>{
            this.showDialog(componentClass, originalProps, children);
        };
        /**
     * @deprecated use `.showModal()` instead (see "next/packages/dialogs/README.md" for migration instructions)
     */ this.showDialog = (componentClass, originalProps, children)=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(componentClass, {
                ...props,
                onClose: (...args)=>this.onChildClose(key, ...args),
                onCloseComplete: (...args)=>this.onChildCloseComplete(key, ...args)
            }, children);
            this.setState((state)=>({
                    stack: [
                        ...state.stack,
                        {
                            key: key,
                            component: component,
                            alive: true,
                            originalProps: {
                                onClose: 'onClose' in props ? props.onClose : undefined,
                                onCloseComplete: 'onCloseComplete' in props ? props.onCloseComplete : undefined
                            }
                        }
                    ]
                }));
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return ()=>{
                this.onChildClose(key);
            };
        };
        this.state = {
            stack: stack
        };
        // If you're pre-supplying a stack, make nextKey bigger than any of its keys
        if (stack.length) {
            const maxKey = Math.max(...stack.map((frame)=>frame.key));
            (0, $2BAFx.dialogKeyState).nextKey = maxKey + 1;
        }
    }
}
module.exports["DialogsStateContainer"] = $c329db8a0d5b9472$export$11ff2eb6414212c6;

});

parcelRegister("aJv6Q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("9FoVw", function(module, exports) {
/**
 * @fileoverview Unified comment navigation utilities for scrolling to different comment types
 * and handling various navigation scenarios across editor and renderer contexts.
 */ 
var $fJCU9 = parcelRequire("fJCU9");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $6mKj3 = parcelRequire("6mKj3");


var $4L9ve = parcelRequire("4L9ve");


var $kgNLQ = parcelRequire("kgNLQ");


var $i49vP = parcelRequire("i49vP");


var $aHcFH = parcelRequire("aHcFH");

var $0343eaf78527fd4c$export$99058db374262376 = /*#__PURE__*/ function(ShortcutType) {
    ShortcutType["NEXT"] = "next";
    ShortcutType["PREVIOUS"] = "previous";
    ShortcutType["UNREAD"] = "unread";
    return ShortcutType;
}({});
var $0343eaf78527fd4c$var$CommentType = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    return CommentType;
}($0343eaf78527fd4c$var$CommentType || {});
var $0343eaf78527fd4c$export$ca559f4ef107f965 = /*#__PURE__*/ function(ViewValues) {
    ViewValues["OPEN"] = "OPEN";
    ViewValues["UNREAD"] = "UNREAD";
    ViewValues["DELETED_CONTENT"] = "DELETED_CONTENT";
    ViewValues["RESOLVED"] = "RESOLVED";
    ViewValues["MENTIONS_ME"] = "MENTIONS_ME";
    return ViewValues;
}({});
// Navigation types based on comment scrolling architecture
var $0343eaf78527fd4c$var$NavigationType = /*#__PURE__*/ function(NavigationType) {
    NavigationType["INLINE_ANNOTATION"] = "inline_annotation";
    NavigationType["COMMENTS_PANEL"] = "comments_panel";
    NavigationType["FOOTER_COMMENTS"] = "footer_comments";
    NavigationType["DEEP_LINK"] = "deep_link";
    NavigationType["KEYBOARD_SHORTCUT"] = "keyboard_shortcut";
    NavigationType["INLINE_HEADER_ARROWS"] = "inline_header_arrows";
    return NavigationType;
}($0343eaf78527fd4c$var$NavigationType || {});
var $0343eaf78527fd4c$export$e6e360ac7d345e5 = /*#__PURE__*/ function(ScrollBehavior) {
    ScrollBehavior["INSTANT"] = "instant";
    ScrollBehavior["SMOOTH"] = "smooth";
    return ScrollBehavior;
}({});
var $0343eaf78527fd4c$export$3044ab7fdabeaee6 = /*#__PURE__*/ function(NavigationContext) {
    NavigationContext["EDITOR"] = "editor";
    NavigationContext["RENDERER"] = "renderer";
    NavigationContext["PANEL"] = "panel";
    NavigationContext["REPLY"] = "reply";
    return NavigationContext;
}({});
var $0343eaf78527fd4c$export$368ed1d84e0ae668 = /*#__PURE__*/ function(CommentNavigationStatus) {
    CommentNavigationStatus["FOUND_IN_DOM"] = "FOUND_IN_DOM";
    CommentNavigationStatus["DELETED_CONTENT"] = "DELETED_CONTENT";
    CommentNavigationStatus["RESOLVED"] = "RESOLVED";
    CommentNavigationStatus["UNKNOWN"] = "UNKNOWN";
    CommentNavigationStatus["REMOVED_BY_ANOTHER_USER"] = "REMOVED_BY_ANOTHER_USER";
    return CommentNavigationStatus;
}({});
const $0343eaf78527fd4c$export$9f32f1ed184088e0 = (options)=>{
    const { scrollBehavior: scrollBehavior, context: context, block: block, inline: inline, markElement: markElement, annotationId: annotationId } = options;
    if (!markElement) return false;
    // Handle different contexts
    switch(context){
        case "editor":
            // Check if element needs to be expanded in editor
            (0, $i49vP.checkElementExpandInEditor)(markElement);
            // Emit the setselectedannotation event
            const editorEmitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
            editorEmitter.emit('setselectedannotation', markElement.id);
            // Scroll to the element in editor
            (0, $i49vP.scrollToElementInEditor)({
                targetElement: markElement,
                viewingRoomOffset: -100
            });
            return true;
        case "renderer":
            // Renderer-specific logic with improved focus management
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const focusedMarkerRef = document.querySelector("[data-has-focus='true']");
            if (focusedMarkerRef?.id !== markElement.id) {
                const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                emitter.emit((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                    annotationId: markElement.id
                });
                // Check if element needs to be expanded
                (0, $aHcFH.checkElementExpand)(markElement, true);
            }
            // Scroll to the annotation mark
            markElement.scrollIntoView({
                behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
                block: block,
                inline: inline
            });
            return true;
        case "panel":
            // For panel context, ensure annotation is visible and highlighted
            if (annotationId) {
                // Emit events to ensure the annotation is properly focused
                const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                emitter.emit((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                    annotationId: annotationId
                });
            }
            // Scroll the annotation into view
            markElement.scrollIntoView({
                behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
                block: block,
                inline: inline
            });
            return true;
        default:
            return false;
    }
};
/**
 * Wait for the comments panel to be rendered in the DOM
 * Returns a Promise that resolves when the panel is available or times out after 5 seconds
 */ const $0343eaf78527fd4c$var$waitForCommentsPanel = ()=>{
    const commentsPanelListContainerId = 'comments-panel-list-container';
    return new Promise((resolve)=>{
        const observer = new MutationObserver(()=>{
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const panel = document.querySelector(`[data-testid='${commentsPanelListContainerId}']`);
            if (panel) {
                observer.disconnect();
                resolve(true);
            }
        });
        // Start observing the document body for changes
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        // Set a timeout to avoid infinite waiting
        setTimeout(()=>{
            observer.disconnect();
            resolve(false);
        }, 5000); // 5 second timeout
    });
};
/**
 * Wait for the comments panel view/filter to change to the specified view
 * Returns a Promise that resolves when the view change is complete or times out after 3 seconds
 */ const $0343eaf78527fd4c$var$waitForViewChange = (expectedView)=>{
    return new Promise((resolve)=>{
        // Check if the view has already changed by checking the data-current-view attribute on the container
        const checkView = ()=>{
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const container = document.querySelector('[data-testid="comments-panel-list-container"]');
            if (container && container.getAttribute('data-current-view') === expectedView) return true;
        };
        if (checkView()) {
            resolve(true);
            return;
        }
        // Observe document body for both container creation and attribute changes
        // This handles cases where the container gets unmounted/remounted
        const observer = new MutationObserver(()=>{
            if (checkView()) {
                observer.disconnect();
                resolve(true);
            }
        });
        // Observe the entire document body to catch:
        // 1. Container being created/removed
        // 2. Attribute changes on the container when it exists
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: [
                'data-current-view'
            ]
        });
        // Set a timeout to avoid infinite waiting
        setTimeout(()=>{
            observer.disconnect();
            resolve(false);
        }, 3000); // 3 second timeout
    });
};
/**
 * Check if the top edge of an element is visible in the viewport
 * Used to determine if scrolling is needed based on element visibility
 */ const $0343eaf78527fd4c$var$isElementTopVisible = (element)=>{
    const rect = element.getBoundingClientRect();
    return rect.top >= 0;
};
/**
 * Wait for an element to finish scrolling into view
 * Returns a Promise that resolves when the element is reasonably visible or times out
 */ const $0343eaf78527fd4c$var$waitForScrollCompletion = (element, timeout = 3000)=>{
    return new Promise((resolve)=>{
        const startTime = Date.now();
        const check = ()=>{
            if ($0343eaf78527fd4c$var$isElementTopVisible(element)) // Add a small delay after element becomes visible to let scrolling settle
            setTimeout(()=>resolve(true), 150);
            else if (Date.now() - startTime > timeout) resolve(false);
            else requestAnimationFrame(check);
        };
        // Small delay to let scroll animation start
        setTimeout(check, 16);
    });
};
/**
 * Helper function for viewport checking - returns true if should skip scrolling due to viewport visibility
 */ const $0343eaf78527fd4c$var$checkAndHandleViewportVisibility = (element, shouldScrollIfCommentIsInViewport)=>{
    if (!shouldScrollIfCommentIsInViewport) {
        const commentIsInViewport = $0343eaf78527fd4c$var$isElementTopVisible(element);
        if (commentIsInViewport) return true;
    }
    return false;
};
/**
 * Handle scroll completion based on awaitScrollCompletion flag and scroll behavior
 */ const $0343eaf78527fd4c$var$handleScrollCompletion = (awaitScrollCompletion, scrollBehavior, element)=>{
    if (awaitScrollCompletion) return scrollBehavior === "smooth" ? $0343eaf78527fd4c$var$waitForScrollCompletion(element) : Promise.resolve(true);
    return true;
};
/**
 * Check if an element is already fully visible within the panel
 * Avoids unnecessary scrolling if the element is already in view
 */ const $0343eaf78527fd4c$var$isElementFullyVisible = (element)=>{
    const elementRect = element.getBoundingClientRect();
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const panelContainer = document.querySelector('[data-testid="comments-panel-list-container"]');
    const panelRect = panelContainer?.getBoundingClientRect();
    if (!panelRect) return false;
    return elementRect.top >= panelRect.top && elementRect.bottom <= panelRect.bottom;
};
/**
 * Determine the optimal scroll position based on context and comment type
 * Considers whether to scroll to start, center, or end based on various factors
 */ const $0343eaf78527fd4c$var$determineScrollPosition = (element, block, scrollToEnd, commentType)=>{
    let scrollBlock = block;
    if (scrollToEnd) {
        // Check if the comment thread reply is out of view
        // Map CommentsType to CommentType enum for domUtils functions
        const commentTypeEnum = commentType === 'INLINE' ? "inline" : "general";
        const isOutOfView = (0, $aHcFH.isCommentThreadReplyOutOfView)(element, commentTypeEnum);
        if (isOutOfView) scrollBlock = 'end';
    } else {
        // Check if we should scroll to top
        // Map CommentsType to CommentType enum for domUtils functions
        const commentTypeEnum = commentType === 'INLINE' ? "inline" : "general";
        const shouldScrollToTop = (0, $aHcFH.shouldScrollCommentThreadToTop)(element, commentTypeEnum);
        if (shouldScrollToTop) scrollBlock = 'start';
    }
    return scrollBlock;
};
/**
 * Perform the actual scrolling operation with optimized behavior
 * Handles different scroll scenarios based on user interaction context
 */ const $0343eaf78527fd4c$var$performScrollToElement = (element, scrollBehavior, block, scrollToEnd, hasKeyPressed, annotationClicked, scrollOnLoad, commentType)=>{
    // Skip scrolling if element is already fully visible
    if ($0343eaf78527fd4c$var$isElementFullyVisible(element)) return;
    // Determine scroll behavior based on trigger type
    if (hasKeyPressed || annotationClicked || scrollOnLoad) {
        const scrollBlock = $0343eaf78527fd4c$var$determineScrollPosition(element, block, scrollToEnd, commentType);
        element.scrollIntoView({
            behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
            block: scrollBlock
        });
    } else // Default scroll behavior
    element.scrollIntoView({
        behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
        block: block
    });
};
const $0343eaf78527fd4c$export$390f6df30bfcd812 = (options)=>{
    const { scrollBehavior: scrollBehavior, context: context, block: block, commentId: commentId, annotationId: annotationId, commentType: commentType, scrollToEnd: scrollToEnd = false, hasKeyPressed: hasKeyPressed = false, annotationClicked: annotationClicked = false, scrollOnLoad: scrollOnLoad = false, shouldScrollIfCommentIsInViewport: shouldScrollIfCommentIsInViewport = true, awaitScrollCompletion: awaitScrollCompletion = false } = options;
    // Only handle panel context navigation
    if (context !== "panel") return false;
    // Define panel container and thread selectors
    const commentsPanelListContainerId = 'comments-panel-list-container';
    // annotationId is used for DOM selectors, commentId is the actual comment identifier
    const commentThreadContainerId = `comment-thread-${annotationId}-container`;
    // Check if panel is available, wait if not
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const panelContainer = document.querySelector(`[data-testid='${commentsPanelListContainerId}']`);
    if (!panelContainer) // Panel is not rendered yet, wait for it to appear
    return $0343eaf78527fd4c$var$waitForCommentsPanel().then((panelAvailable)=>{
        if (panelAvailable) // Recursively call the function now that panel is available
        return $0343eaf78527fd4c$export$390f6df30bfcd812(options);
        return false;
    });
    // Look for the specific comment thread container
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const commentThreadElement = document.querySelector(`[data-testid='${commentThreadContainerId}']`);
    // If comment thread exists, scroll immediately
    if (commentThreadElement) {
        const skipScrollDueToViewport = $0343eaf78527fd4c$var$checkAndHandleViewportVisibility(commentThreadElement, shouldScrollIfCommentIsInViewport);
        if (skipScrollDueToViewport) return true;
        $0343eaf78527fd4c$var$performScrollToElement(commentThreadElement, scrollBehavior, block, scrollToEnd, hasKeyPressed, annotationClicked, scrollOnLoad, commentType);
        // For panel navigation, always return Promise when awaitScrollCompletion is true
        return $0343eaf78527fd4c$var$handleScrollCompletion(awaitScrollCompletion, scrollBehavior, commentThreadElement);
    }
    // Use optimized observer to watch for comment thread container creation
    if (commentId) (0, $aHcFH.watchForCommentContainerAndScroll)(commentId);
    else if (annotationId) (0, $aHcFH.watchForCommentContainerAndScroll)('', annotationId);
    return true;
};
const $0343eaf78527fd4c$export$dcd3c0d6a66d0412 = async (options)=>{
    const { expectedView: expectedView, commentId: commentId, annotationId: annotationId, ...navigationOptions } = options;
    // Only wait for view change for panel context
    if (navigationOptions.context === "panel" && expectedView) await $0343eaf78527fd4c$var$waitForViewChange(expectedView);
    // Then perform the navigation - pass both commentId and annotationId
    return $0343eaf78527fd4c$export$390f6df30bfcd812({
        ...navigationOptions,
        commentId: commentId,
        annotationId: annotationId
    });
};
const $0343eaf78527fd4c$export$34fd7e98d0739b5c = (options)=>{
    const { block: block, inline: inline, commentId: commentId, scrollBehavior: scrollBehavior, navigationContext: navigationContext, shouldScrollIfCommentIsInViewport: shouldScrollIfCommentIsInViewport = true, awaitScrollCompletion: awaitScrollCompletion = false } = options;
    let containerId;
    if (!commentId) return false;
    // Check if comment already exists in DOM
    // Determine container ID based on navigation context:
    // - PANEL: uses comment-thread container
    // - REPLY: uses data-comment-id attribute selector
    // - Default (footer): uses footer-comment-thread container
    if (navigationContext === "panel") containerId = `comment-thread-${commentId}-container`;
    else if (navigationContext === "reply") containerId = `[data-comment-id="${commentId}"]`;
    else containerId = `footer-comment-thread-${commentId}-container`;
    // Use querySelector for REPLY context (attribute selector), getElementById for others (ID)
    const existingComment = navigationContext === "reply" ? // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector(containerId) : // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.getElementById(containerId);
    if (existingComment) {
        const skipScrollDueToViewport = $0343eaf78527fd4c$var$checkAndHandleViewportVisibility(existingComment, shouldScrollIfCommentIsInViewport);
        if (skipScrollDueToViewport) return true;
        // Comment is already rendered, scroll to it immediately
        existingComment.scrollIntoView({
            behavior: scrollBehavior,
            block: block,
            inline: inline
        });
        // Wait for scroll completion when awaitScrollCompletion is true, otherwise return true
        return $0343eaf78527fd4c$var$handleScrollCompletion(awaitScrollCompletion, scrollBehavior, existingComment);
    } else {
        // Comment not yet rendered, use DOM resolver to watch for it
        (0, $aHcFH.watchForCommentRepliesAndScroll)({
            targetCommentId: commentId,
            onScrollReady: (commentElement)=>{
                // Find the container element by ID or selector based on navigation context
                const containerElement = navigationContext === "reply" ? // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.querySelector(containerId) : // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.getElementById(containerId);
                const elementToScroll = containerElement || commentElement;
                elementToScroll.scrollIntoView({
                    behavior: scrollBehavior,
                    block: block,
                    inline: inline
                });
            },
            containerId: containerId
        });
        return true;
    }
};
const $0343eaf78527fd4c$export$ea1c337d9000e2 = (options)=>{
    const { scrollBehavior: scrollBehavior, block: block, inline: inline, commentId: commentId, markElement: markElement, context: context } = options;
    if (!commentId || !markElement) return false;
    // Check if comment already exists in DOM
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const existingComment = document.querySelector(`[data-comment-id="${commentId}"]`);
    if (existingComment) {
        // Comment is already rendered, scroll to it immediately
        existingComment.scrollIntoView({
            behavior: scrollBehavior,
            block: block,
            inline: inline
        });
        return true;
    }
    // we need to click on the annotation in the editor if the comment is not yet rendered
    if (context === "editor" && markElement) (0, $i49vP.openInlineCommentInEditor)({
        targetElement: markElement,
        targetElementID: markElement.id,
        shouldScroll: false
    });
    // Comment not yet rendered, use DOM resolver to watch for it
    (0, $aHcFH.watchForCommentRepliesAndScroll)({
        targetCommentId: commentId,
        onScrollReady: (commentElement)=>{
            commentElement.scrollIntoView({
                behavior: scrollBehavior,
                block: block,
                inline: inline
            });
        },
        markElement: markElement
    });
    return true;
};
const $0343eaf78527fd4c$export$807107038899c351 = (options)=>{
    const { scrollBehavior: scrollBehavior, block: block, inline: inline, annotationId: annotationId, commentId: commentId, commentType: commentType, isCommentsPanelOpen: isCommentsPanelOpen, hasKeyPressed: hasKeyPressed = true, scrollToEnd: scrollToEnd = false, context: context, shortcutType: shortcutType, isResolved: isResolved, previousAnnotationId: previousAnnotationId } = options;
    // Get the mark element for both inline navigation and annotation events
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    let markElement = document.getElementById(annotationId);
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const commentElement = document.querySelector(`[data-comment-id="${commentId}"]`);
    // Get the previous comment element for difference-based scrolling
    const previousCommentElement = previousAnnotationId ? // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.getElementById(previousAnnotationId) : null;
    // Check if the mark element is in a sticky table header and adjust if needed
    const isInStickyTableHeader = markElement?.closest && markElement.closest('.pm-table-sticky-wrapper');
    if (isInStickyTableHeader && markElement && (0, $6mKj3.expValEquals)('confluence_comment_enable_table_header_navigation', 'isEnabled', true)) // Get the real element from the non-sticky table using getNodeForTableORMacro
    markElement = (0, $aHcFH.getNodeForTableORMacro)(markElement) || markElement;
    if (commentType === 'FOOTER') $0343eaf78527fd4c$export$34fd7e98d0739b5c({
        scrollBehavior: scrollBehavior,
        block: block,
        inline: inline || 'center',
        commentId: annotationId
    });
    // If comments panel is open, use panel navigation
    if (isCommentsPanelOpen) {
        // For inline comments, also call handleInlineAnnotationNavigation to ensure proper inline comment behavior
        if (commentType === 'INLINE' && !isResolved) $0343eaf78527fd4c$export$9f32f1ed184088e0({
            scrollBehavior: scrollBehavior,
            context: context || "panel",
            block: block,
            inline: inline || 'center',
            markElement: markElement,
            annotationId: annotationId
        });
        // This ensure the ViewComponent useEffect is not triggered
        if (markElement && !isResolved) {
            // Emit annotation events for panel navigation
            if (context === "editor") {
                const editorEmitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
                editorEmitter.emit('setselectedannotation', annotationId);
            } else if (context === "renderer") {
                const rendererEmitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                rendererEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                    annotationIds: [
                        annotationId
                    ],
                    eventTarget: null
                });
            }
        }
        // Use the existing panel navigation logic
        const result = $0343eaf78527fd4c$export$390f6df30bfcd812({
            scrollBehavior: scrollBehavior,
            context: "panel",
            block: block,
            inline: inline,
            annotationId: annotationId,
            commentType: commentType,
            hasKeyPressed: hasKeyPressed,
            scrollToEnd: scrollToEnd
        });
        if (result instanceof Promise) // For async panel navigation, return true immediately
        // The actual navigation will happen asynchronously
        return true;
        return result;
    }
    if (!markElement) return false;
    // For standalone navigation (comments panel closed), expand the element if needed
    if (commentType === 'INLINE' && context === "renderer") (0, $aHcFH.checkElementExpand)(markElement, true);
    // Use difference-based scrolling if we have both previous and next elements
    if (previousCommentElement && markElement && previousCommentElement !== markElement && (0, $6mKj3.expValEquals)('confluence_comment_use_kbs_exp', 'isEnabled', true)) {
        if (context === "editor") {
            // For editor: use scrollableContainer.scrollBy with difference offset
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const scrollableContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
            if (scrollableContainer) {
                // Calculate difference between next and previous comment positions
                const nextRect = markElement.getBoundingClientRect();
                const previousRect = previousCommentElement.getBoundingClientRect();
                const differenceOffset = nextRect.top - previousRect.top;
                scrollableContainer.scrollBy(0, differenceOffset);
            }
        } else // For renderer: use scrollToComment with difference-based scrolling
        (0, $aHcFH.scrollToComment)(markElement, previousCommentElement, true, false);
        return true;
    }
    // For unread navigation, scroll to the comment element with data-comment-id instead of markElement
    if (shortcutType === "unread" && commentElement) commentElement.scrollIntoView({
        behavior: scrollBehavior,
        block: block,
        inline: inline || 'nearest'
    });
    else // For standalone navigation, we don't emit events - just scroll to the element
    markElement.scrollIntoView({
        behavior: scrollBehavior,
        block: block,
        inline: inline || 'nearest'
    });
    return true;
};
/**
 * Calculate the height of media comment placeholder to adjust scroll offset.
 * When the media comment placeholder is visible, it pushes the contents of the page down,
 * so we need to scroll a bit less to keep the cursor over the navigation arrow icon.
 */ const $0343eaf78527fd4c$var$getMediaCommentPlaceholderHeight = (options)=>{
    const { previousCommentElement: previousCommentElement, action: action, nextCommentIndex: nextCommentIndex, totalComments: totalComments } = options;
    const isCurrentCommentContentMediaComment = previousCommentElement?.closest('.media-single-node');
    const isNavigatingToLastCommentFromPreviousAction = action === 'previous' && nextCommentIndex === totalComments - 1;
    const isNavigatingToFirstCommentFromNextAction = action === 'next' && nextCommentIndex === 0;
    if (isCurrentCommentContentMediaComment && (action === 'next' || isNavigatingToLastCommentFromPreviousAction || isNavigatingToFirstCommentFromNextAction)) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const mediaCommentSelectedPlaceholder = document.querySelector('[data-id="caption-placeholder"]');
        return mediaCommentSelectedPlaceholder ? mediaCommentSelectedPlaceholder.offsetHeight : 0;
    }
    return 0;
};
const $0343eaf78527fd4c$export$36dad1a923539611 = (options)=>{
    const { previousMarkerRef: previousMarkerRef, nextMarkerRef: nextMarkerRef, context: context, action: action, nextCommentIndex: nextCommentIndex, totalComments: totalComments } = options;
    // Get the next comment element
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const nextMarkElement = document.getElementById(nextMarkerRef);
    if (!nextMarkElement) return false;
    // Get the previous and next comment elements
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const previousCommentElement = document.getElementById(previousMarkerRef);
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const nextCommentElement = document.getElementById(nextMarkerRef);
    if (previousCommentElement && nextCommentElement) {
        const heightOfMediaCommentSelectedPlaceholder = $0343eaf78527fd4c$var$getMediaCommentPlaceholderHeight({
            previousCommentElement: previousCommentElement,
            action: action,
            nextCommentIndex: nextCommentIndex,
            totalComments: totalComments
        });
        if (context === "editor") {
            // For editor: use scrollableContainer.scrollBy with difference offset
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const scrollableContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
            if (scrollableContainer) {
                // Calculate difference between current and previous comment positions using calculateElementOffset
                // This handles special cases like sticky table headers
                const previousOffset = (0, $aHcFH.calculateElementOffset)(previousCommentElement);
                const nextOffset = (0, $aHcFH.calculateElementOffset)(nextCommentElement);
                const differenceOffset = nextOffset - previousOffset - heightOfMediaCommentSelectedPlaceholder;
                scrollableContainer.scrollBy(0, differenceOffset);
            }
        } else // For renderer: use scrollToComment
        (0, $aHcFH.scrollToComment)(nextCommentElement, previousCommentElement, true, false);
    }
    return true;
};
/**
 * Wait for a comment marker element to appear in the DOM.
 * Resolves immediately if the element already exists, otherwise waits via MutationObserver until timeout.
 */ const $0343eaf78527fd4c$var$waitForCommentElement = ({ markerRef: markerRef, timeoutMs: timeoutMs })=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const existingElement = document.getElementById(markerRef);
    if (existingElement) return Promise.resolve(existingElement);
    return new Promise((resolve)=>{
        const observer = new MutationObserver(()=>{
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const element = document.getElementById(markerRef);
            if (!element) return;
            observer.disconnect();
            resolve(element);
        });
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        setTimeout(()=>{
            observer.disconnect();
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const fallbackElement = document.getElementById(markerRef);
            resolve(fallbackElement);
        }, timeoutMs);
    });
};
const $0343eaf78527fd4c$export$6591627df1eb1f44 = async ({ markerRef: markerRef, commentId: commentId, timeoutMs: timeoutMs = 3000, getCommentThreadsRemovedByOtherUsers: getCommentThreadsRemovedByOtherUsers })=>{
    let element = null;
    if (markerRef) element = await $0343eaf78527fd4c$var$waitForCommentElement({
        markerRef: markerRef,
        timeoutMs: timeoutMs
    });
    // Check if comment was removed by another user BEFORE checking processed state
    // This check happens early because it's a specific known state
    // NOTE - we can't import the official type here due to circular dep concerns
    if (commentId) {
        const commentThreadsRemovedByOtherUsers = getCommentThreadsRemovedByOtherUsers?.();
        if (commentThreadsRemovedByOtherUsers?.[commentId] === 'deleted') return {
            status: "REMOVED_BY_ANOTHER_USER",
            element: undefined
        };
    }
    // Read processed state after DOM wait to avoid stale classification.
    const state = (0, $4L9ve.getProcessedCommentsDataState)();
    const rootComment = state.isDataProcessed && markerRef ? state.flatMarkerRefMap[markerRef] : undefined;
    if (element) {
        if (rootComment && (0, $kgNLQ.isCommentResolved)(rootComment)) return {
            status: "RESOLVED",
            element: undefined
        };
        return {
            status: "FOUND_IN_DOM",
            element: element
        };
    }
    // Comment marker is missing from the DOM — classify as DELETED_CONTENT or UNKNOWN.
    // Note: classification depends on cc_comments_new_comments_data_manager being enabled.
    // When disabled, state isn't populated so are forced into FOUND_IN_DOM or UNKNOWN
    if (!state.isDataProcessed) return {
        status: "UNKNOWN",
        element: undefined
    };
    const existsInData = rootComment || commentId && state.flatCommentsMap[commentId];
    return existsInData ? {
        status: "DELETED_CONTENT",
        element: undefined
    } : {
        status: "UNKNOWN",
        element: undefined
    };
};
module.exports["ShortcutType"] = $0343eaf78527fd4c$export$99058db374262376;
module.exports["ScrollBehavior"] = $0343eaf78527fd4c$export$e6e360ac7d345e5;
module.exports["NavigationContext"] = $0343eaf78527fd4c$export$3044ab7fdabeaee6;
module.exports["CommentNavigationStatus"] = $0343eaf78527fd4c$export$368ed1d84e0ae668;
module.exports["handleInlineAnnotationNavigation"] = $0343eaf78527fd4c$export$9f32f1ed184088e0;
module.exports["handleCommentsPanelNavigation"] = $0343eaf78527fd4c$export$390f6df30bfcd812;
module.exports["handleCommentsPanelNavigationWithViewChange"] = $0343eaf78527fd4c$export$dcd3c0d6a66d0412;
module.exports["handleFooterCommentsNavigation"] = $0343eaf78527fd4c$export$34fd7e98d0739b5c;
module.exports["handleDeepLinkNavigation"] = $0343eaf78527fd4c$export$ea1c337d9000e2;
module.exports["handleKeyboardShortcutNavigation"] = $0343eaf78527fd4c$export$807107038899c351;
module.exports["handleInlineHeaderArrowsNavigation"] = $0343eaf78527fd4c$export$36dad1a923539611;
module.exports["waitForCommentStatus"] = $0343eaf78527fd4c$export$6591627df1eb1f44;

});

parcelRegister("4L9ve", function(module, exports) {
/**
 * Sweet state store for processed comments data.
 * This store should ONLY be updated by CommentsDataBackgroundLoader.
 * All other consumers should use the state/actions hooks to read data.
 */ 
var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");


var $kgNLQ = parcelRequire("kgNLQ");

const $20eb19f7ec5706e8$export$53ac33307b5acee9 = ()=>({
        lastProcessedData: null,
        allComments: [],
        allFilteredComments: [],
        openInlineComments: [],
        openFooterComments: [],
        resolvedComments: [],
        openComments: [],
        commentsDataMap: {
            inline: {},
            general: {}
        },
        flatCommentsMap: {},
        flatMarkerRefMap: {},
        hasNestedComments: false,
        isDataProcessed: false,
        commentCount: 0,
        hasAnyComments: false,
        error: undefined,
        refetch: undefined
    });
const $20eb19f7ec5706e8$export$e324594224ef24da = {
    /**
	 * Updates all processed comments data.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 * Note: refetch is set separately via setRefetch, so it's not included here.
	 */ setProcessedData: (data)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...data,
                error: undefined,
                // Keep existing refetch if it exists, don't overwrite it
                refetch: currentState.refetch
            });
        },
    /**
	 * Sets an error state for processed comments data.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ setError: (error)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                error: error,
                isDataProcessed: true
            });
        },
    /**
	 * Clears error and resets isDataProcessed to initial values.
	 * Skips setState when already at initial values to avoid unnecessary re-renders.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ clearErrorAndResetIsDataProcessed: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const initialState = $20eb19f7ec5706e8$export$53ac33307b5acee9();
            if (currentState.error === initialState.error && currentState.isDataProcessed === initialState.isDataProcessed) return;
            setState({
                ...currentState,
                error: initialState.error,
                isDataProcessed: initialState.isDataProcessed
            });
        },
    /**
	 * Sets isDataProcessed to true without changing other state.
	 * Only updates if isDataProcessed is currently false to prevent unnecessary re-renders.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ setDataToProcessed: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isDataProcessed) return;
            setState({
                ...currentState,
                isDataProcessed: true
            });
        },
    /**
	 * Sets the refetch function from useAllCommentsData.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ setRefetch: (refetch)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                refetch: refetch
            });
        },
    /**
	 * Clears all processed comments data and resets to initial state.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ clearProcessedData: ()=>({ setState: setState })=>{
            setState($20eb19f7ec5706e8$export$53ac33307b5acee9());
        },
    /**
	 * Processes the raw comments data if it hasn't already been processed and updates the store with
	 * categorized comments. Can be used with output from useAllCommentsData() hook (that is, the full
	 * comments data query result) or the full comments data cache (for when we need to synchronously
	 * process updated cache data).
	 *
	 * Note that for Apollo GQL, if the data hasn't changed then readQuery() will return the same
	 * data reference as the full comment query does. So it is safe to compare data references from
	 * real queries and cache reads to avoid unnecessary reprocessing.
	 *
	 */ // TODO: Verify the data reference behavior for Relay GQL when we start enabling Relay support.
    processCommentsData: ({ data: data, pageMode: pageMode })=>({ setState: setState, getState: getState })=>{
            // Nothing to process if data is null
            if (!data) return;
            // Don't process the same data twice - if the data reference is the same as the last processed
            const currentState = getState();
            if (currentState.isDataProcessed && currentState.lastProcessedData === data) return;
            // Filter out null nodes and create array (empty array if no data)
            const allComments = (data?.comments?.nodes || []).filter((node)=>node !== null);
            // Categorize comments using default contentStatus filters
            const contentStatusFilters = (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode);
            const categorizedData = (0, $kgNLQ.categorizeComments)(allComments, contentStatusFilters);
            // Update the store with categorized comments
            setState({
                ...currentState,
                ...categorizedData,
                allComments: allComments,
                lastProcessedData: data,
                error: undefined,
                isDataProcessed: true
            });
        }
};
const $20eb19f7ec5706e8$export$4be6ac988c62a591 = (0, $8s9DV.createStore)({
    initialState: $20eb19f7ec5706e8$export$53ac33307b5acee9(),
    actions: $20eb19f7ec5706e8$export$e324594224ef24da,
    name: 'ProcessedCommentsDataStore'
});
const $20eb19f7ec5706e8$export$421cff7071854c91 = (0, $kBr4q.createHook)($20eb19f7ec5706e8$export$4be6ac988c62a591);
const $20eb19f7ec5706e8$export$2919c8d01260d4fe = (0, $kBr4q.createActionsHook)($20eb19f7ec5706e8$export$4be6ac988c62a591);
const $20eb19f7ec5706e8$export$93d43ef0fc9d136b = (0, $kBr4q.createStateHook)($20eb19f7ec5706e8$export$4be6ac988c62a591);
// Non-React utility for accessing store outside of React components
const $20eb19f7ec5706e8$var$processedCommentsDataStoreInstance = (0, $c6StJ.defaultRegistry).getStore($20eb19f7ec5706e8$export$4be6ac988c62a591);
const $20eb19f7ec5706e8$export$db6951977b558d4d = ()=>{
    return $20eb19f7ec5706e8$var$processedCommentsDataStoreInstance.storeState.getState();
};
const $20eb19f7ec5706e8$export$ae4b56ccf0bbe776 = ()=>{
    return $20eb19f7ec5706e8$var$processedCommentsDataStoreInstance.actions;
};
module.exports["useProcessedCommentsData"] = $20eb19f7ec5706e8$export$421cff7071854c91;
module.exports["useProcessedCommentsDataActions"] = $20eb19f7ec5706e8$export$2919c8d01260d4fe;
module.exports["useProcessedCommentsDataState"] = $20eb19f7ec5706e8$export$93d43ef0fc9d136b;
module.exports["getProcessedCommentsDataState"] = $20eb19f7ec5706e8$export$db6951977b558d4d;
module.exports["getProcessedCommentsDataActions"] = $20eb19f7ec5706e8$export$ae4b56ccf0bbe776;

});

parcelRegister("i49vP", function(module, exports) {

var $gfqXk = parcelRequire("gfqXk");


var $4EKKB = parcelRequire("4EKKB");


var $aHcFH = parcelRequire("aHcFH");

const $36cd0189b09a46b6$var$getElementOffsetFromTopOfPage = (element)=>{
    let elementOffsetTop = 0;
    let nodeToMeasure = element;
    while(nodeToMeasure && !nodeToMeasure.classList.contains('fabric-editor-popup-scroll-parent')){
        elementOffsetTop += nodeToMeasure.offsetTop;
        nodeToMeasure = nodeToMeasure.offsetParent;
    }
    return elementOffsetTop;
};
const $36cd0189b09a46b6$export$cc3d34287540b287 = (element)=>{
    const expandSelectors = [
        '.ak-editor-expand'
    ];
    const getExpandButton = (node)=>{
        if (node.classList.contains('ak-editor-expand')) {
            const button = node.querySelector('.ak-editor-expand__icon-container');
            return button;
        }
        return null;
    };
    const isExpanded = (button)=>{
        const expandContainer = button.closest('.ak-editor-expand');
        return expandContainer?.classList.contains('ak-editor-expand__expanded') || false;
    };
    const onExpand = ()=>{
        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
            isInExpand: true
        });
    };
    (0, $aHcFH.checkElementExpandMultiLevelCommon)(element, {
        isEditor: true,
        expandSelectors: expandSelectors,
        getExpandButton: getExpandButton,
        isExpanded: isExpanded,
        onExpand: onExpand
    });
};
const $36cd0189b09a46b6$export$a1bb3d68e0c3dbb8 = (element)=>{
    $36cd0189b09a46b6$export$cc3d34287540b287(element);
};
const $36cd0189b09a46b6$export$2163ce5a75e4a465 = ({ targetElement: targetElement, targetElementID: targetElementID, shouldScroll: shouldScroll = true })=>{
    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    $36cd0189b09a46b6$export$a1bb3d68e0c3dbb8(targetElement);
    emitter.emit('setselectedannotation', targetElementID);
    window.getSelection()?.setPosition(targetElement);
    shouldScroll && $36cd0189b09a46b6$export$4ee22c4fac4681d8({
        targetElement: targetElement,
        viewingRoomOffset: -100
    });
};
const $36cd0189b09a46b6$export$4ee22c4fac4681d8 = ({ targetElement: targetElement, viewingRoomOffset: viewingRoomOffset = 0 })=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const editorScrollableContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
    if (editorScrollableContainer) editorScrollableContainer.scrollTo(0, $36cd0189b09a46b6$var$getElementOffsetFromTopOfPage(targetElement) + viewingRoomOffset // add viewing room
    );
};
const $36cd0189b09a46b6$export$443ba0c8d1b21569 = ({ data: data, previousAnnotations: previousAnnotations })=>{
    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const topLevelCommentMarkerRefs = data?.comments?.nodes?.map((node)=>(node?.location).inlineMarkerRef);
    if (topLevelCommentMarkerRefs && topLevelCommentMarkerRefs.length > 0) {
        const newAnnotationsSet = new Set(topLevelCommentMarkerRefs);
        const removedMarkerRefs = [];
        previousAnnotations.forEach((item)=>{
            if (!newAnnotationsSet.has(item)) removedMarkerRefs.push(item);
        });
        let updatedAnnotations = [
            ...previousAnnotations
        ];
        const addedMarkerRefs = [];
        newAnnotationsSet.forEach((item)=>{
            if (!previousAnnotations.includes(item)) addedMarkerRefs.push(item);
        });
        for (const markerRef of addedMarkerRefs){
            emitter.emit('create', markerRef);
            updatedAnnotations.push(markerRef);
        }
        for (const markerRef of removedMarkerRefs){
            emitter.emit('resolve', markerRef);
            updatedAnnotations = updatedAnnotations.filter((annotation)=>annotation !== markerRef);
        }
        return updatedAnnotations;
    }
    return [];
};
module.exports["checkElementExpandInEditor"] = $36cd0189b09a46b6$export$a1bb3d68e0c3dbb8;
module.exports["openInlineCommentInEditor"] = $36cd0189b09a46b6$export$2163ce5a75e4a465;
module.exports["scrollToElementInEditor"] = $36cd0189b09a46b6$export$4ee22c4fac4681d8;

});

parcelRegister("aHcFH", function(module, exports) {

var $1d2ww = parcelRequire("1d2ww");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $cD1qu = parcelRequire("cD1qu");


var $i49vP = parcelRequire("i49vP");

const $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7 = 'inline-create-comment-selection';
const $a78c261c3211f7d6$export$b803c692fbaaa5a4 = 'inline-highlight';
const $a78c261c3211f7d6$export$fb3d0eebfe85522a = 'active-highlight';
const $a78c261c3211f7d6$export$b899b07e3f725968 = ()=>{
    const commentData = {
        commentIndex: undefined,
        totalComments: undefined
    };
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) {
        commentData['commentIndex'] = Number(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['position']);
        commentData['totalComments'] = Number(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['totalComments']);
    }
    return commentData;
};
const $a78c261c3211f7d6$export$1f7acceb752add79 = (pageMode)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const marks = Array.from(document.querySelectorAll($a78c261c3211f7d6$export$8c7b048437c01388(pageMode))).map((node)=>{
        if (pageMode === 'edit') return node.id;
        else return $a78c261c3211f7d6$export$8f4213b45c05ab5d(node);
    });
    /* In case of overlapping comments there will be multiple tags with the same markerRefs. We need to remove
  duplicates in that case so we can navigate between comments correctly */ return new Set(marks);
};
const $a78c261c3211f7d6$export$9b48c18cc387f791 = (markerRefList, pageMode = 'view')=>{
    const distinctMarks = [
        ...$a78c261c3211f7d6$export$1f7acceb752add79(pageMode)
    ];
    return distinctMarks.filter((mark)=>mark && markerRefList.includes(mark));
};
const $a78c261c3211f7d6$export$8c7b048437c01388 = (pageMode = 'view')=>{
    if (pageMode === 'edit') return "[annotationtype='inlineComment']";
    else return '[data-mark-annotation-type="inlineComment"], .inline-comment-marker';
};
const $a78c261c3211f7d6$export$f7ceeb7ba8156450 = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const activeHighlights = document.querySelectorAll(`.${$a78c261c3211f7d6$export$fb3d0eebfe85522a}`);
    activeHighlights.forEach((activeHighlight)=>{
        activeHighlight.classList.remove($a78c261c3211f7d6$export$fb3d0eebfe85522a);
    });
};
const $a78c261c3211f7d6$var$getNextTextNodeOld = (node, boundingParentNode)=>{
    let currentNode = node;
    let nextTextNode = currentNode?.nextSibling;
    // If the node has no next sibling, grab it's parent's next sibling until we find a node
    while(!nextTextNode){
        nextTextNode = currentNode?.parentElement?.nextSibling;
        if (nextTextNode) {
            // WS-2551 - If the bounding parent exists and we're out of bounds of it, we're done looking
            if (boundingParentNode && !boundingParentNode.contains(nextTextNode)) {
                nextTextNode = null;
                break;
            }
            // If we've landed on a text node, then break out
            if (nextTextNode.nodeType === Node.TEXT_NODE) break;
            // If the node exists and it's a hard break (<br />), we do one of two things:
            //   1. If it has a bounding parent, break out because the <br /> signifies the end of the selection
            //   2. If not, then move to the next sibling because we don't count hard breaks in selections
            if (nextTextNode?.tagName === 'BR') {
                if (boundingParentNode) break;
                else nextTextNode = nextTextNode.nextSibling;
            }
        } else // If the text node we tried to access is null, we need to jump up a generation
        currentNode = currentNode?.parentNode;
    }
    // Search for the first text node in the next node
    while(nextTextNode && nextTextNode.nodeType !== Node.TEXT_NODE)nextTextNode = nextTextNode.firstChild;
    return nextTextNode;
};
const $a78c261c3211f7d6$export$3e98291f1f032a77 = (currentNode, boundingNode, isInlineMark)=>{
    let nextTextNode = isInlineMark ? currentNode : currentNode?.nextSibling;
    while(nextTextNode && nextTextNode.nodeType !== Node.TEXT_NODE){
        // If the text node is the bounding node, return that node
        if (boundingNode && nextTextNode?.isSameNode(boundingNode)) return nextTextNode;
        // Check if the node is a hard break (<br />) or an element with role="presentation" we do one of two things:
        if (nextTextNode?.tagName === 'BR') {
            // If it has a bounding parent, break out because the <br /> signifies the end of the selection
            if (boundingNode) return nextTextNode;
            // If not, then move to the next sibling because we don't count hard breaks in selections
            nextTextNode = nextTextNode.nextSibling;
        } else if (nextTextNode?.attributes?.getNamedItem('role')?.value === 'presentation') // If the element has role="presentation", move to the parent element's sibling because this current node does not contain a text node
        nextTextNode = nextTextNode.parentNode?.nextSibling;
        else if ($a78c261c3211f7d6$var$isEmojiNode(nextTextNode)) {
            // If we encounter an emoji and it's also the bounding node, return nothing
            if (boundingNode && nextTextNode?.isSameNode(boundingNode)) return null;
            // Otherwise, just return the node after it and keep going
            nextTextNode = nextTextNode.nextSibling;
        } else // Otherwise, search for the first text node in the next node
        nextTextNode = nextTextNode.firstChild;
    }
    // If we've found the text node, return that node
    if (nextTextNode?.nodeType === Node.TEXT_NODE) return nextTextNode;
    // If the text node we tried to access is null, we need to jump up a generation
    if (!nextTextNode) return $a78c261c3211f7d6$export$3e98291f1f032a77(currentNode?.parentNode, boundingNode);
};
const $a78c261c3211f7d6$var$extractTextNodesIntoRangesOld = (selectedRange)=>{
    const rangesToHighlight = [];
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = selectedRange;
    // NOTE: It's not possible for us to get here with anything other than "#text" nodes
    //       for the start container due to our highlighting restrictions, so we only
    //       need to check the type for endContainer when we get a selected range
    // WS-2551 - Triple clicks are the only thing that can cause the endContainer to be a non-text node
    const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
    // If the start and end containers don't match, we need to loop through and extract
    // the text nodes out all common elements and create ranges to represent each of them
    if (!startContainer.isSameNode(endContainer)) {
        let boundingParentNode;
        // Push the starting node into a range
        const startingRange = new Range();
        startingRange.setStart(startContainer, startOffset);
        startingRange.setEnd(startContainer, startContainer.length);
        rangesToHighlight.push(startingRange);
        // WS-2551 - In the case of a triple click, we only want to contain our selection to the
        // first non-comment parent wrapping the starting container to ensure we don't over select
        if (isTripleClick) {
            boundingParentNode = startContainer.parentNode;
            while(!boundingParentNode || boundingParentNode.nodeType === Node.TEXT_NODE || $a78c261c3211f7d6$export$8f4213b45c05ab5d(boundingParentNode) !== null)boundingParentNode = boundingParentNode?.parentNode;
        } else {
            // Push the ending node into a range only if it's not a triple click
            const endingRange = new Range();
            endingRange.setStart(endContainer, 0);
            endingRange.setEnd(endContainer, endOffset);
            rangesToHighlight.push(endingRange);
        }
        // Iterate through all the inner nodes and extract the text ranges
        let node = $a78c261c3211f7d6$var$getNextTextNodeOld(startContainer, boundingParentNode);
        while(node && !node.isSameNode(endContainer) && node.nodeType === Node.TEXT_NODE){
            if (node.length) {
                const range = new Range();
                range.selectNodeContents(node);
                rangesToHighlight.push(range);
            }
            node = $a78c261c3211f7d6$var$getNextTextNodeOld(node, boundingParentNode);
        }
    } else // If they are the same container it's much simpler and we can just use the range
    rangesToHighlight.push(selectedRange);
    return rangesToHighlight;
};
const $a78c261c3211f7d6$var$isEmojiNode = (node)=>{
    if (!node) return false;
    const attributes = node?.attributes;
    const classList = node?.classList;
    return attributes && attributes.getNamedItem('data-emoji-id') || classList && classList.contains('emoji-common-node');
};
const $a78c261c3211f7d6$var$extractTextNodesIntoRanges = (selectedRange)=>{
    const rangesToHighlight = [];
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = selectedRange;
    // NOTE: It's not possible for us to get here with anything other than "#text" nodes
    //       for the start container due to our highlighting restrictions, so we only
    //       need to check the type for endContainer when we get a selected range
    // The endContainer is a non-text node when the user either:
    // 1. Triple clicks a node
    // 2. Highlights a header
    // 3. The highlight goes to the next node but does not actually highlight anything (offset === 0)
    const isNonTextNodeEndContainer = endContainer.nodeType !== Node.TEXT_NODE;
    // If highlight is just one node (i.e. same containers), it's much simpler and we can just use the range
    if (startContainer.isSameNode(endContainer)) {
        rangesToHighlight.push(selectedRange);
        return rangesToHighlight;
    }
    // If the start and end containers don't match, we need to loop through and extract
    // the text nodes out all common elements and create ranges to represent each of them
    let boundingNode;
    // Push the starting node into a range
    const startingRange = new Range();
    startingRange.setStart(startContainer, startOffset);
    startingRange.setEnd(startContainer, startContainer.length);
    rangesToHighlight.push(startingRange);
    // In the case of a non-text node endContainer, we want to set a bounding node to the endContainer so we know
    // to stop traversing the DOM when hidding that bounding node
    if (isNonTextNodeEndContainer) {
        // If the end container is non-text and an emoji, we need to jump up a level or else it is
        // going to be bound to a node that we will never be able to check and thus never exit
        if ($a78c261c3211f7d6$var$isEmojiNode(endContainer)) boundingNode = endContainer.parentNode;
        else boundingNode = endContainer;
    } else {
        // Push the ending node into a range
        const endingRange = new Range();
        endingRange.setStart(endContainer, 0);
        endingRange.setEnd(endContainer, endOffset);
        rangesToHighlight.push(endingRange);
    }
    // Get the first "inner" node between the start and end containers
    let node = $a78c261c3211f7d6$export$3e98291f1f032a77(startContainer, boundingNode);
    // Iterate through all the inner nodes and extract the text ranges
    while(node && !node.isSameNode(endContainer) && node.nodeType === Node.TEXT_NODE){
        if (node.length) {
            const range = new Range();
            range.selectNodeContents(node);
            rangesToHighlight.push(range);
        }
        node = $a78c261c3211f7d6$export$3e98291f1f032a77(node, boundingNode);
    }
    return rangesToHighlight;
};
const $a78c261c3211f7d6$export$739c145b6a07c076 = (isFabricPage, isCreateDialogOpen = false, markerRef = '')=>{
    const highlightClass = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
    let markOffsetTop = 0;
    // Measure the offset of the highlight from the renderer wrapper
    // WS-2618 We have old macros that render tiny inline comments so we need to look for both fabric and tiny marker refs
    if (markerRef) {
        const highlight = $a78c261c3211f7d6$export$21445ab787d3b446(markerRef);
        markOffsetTop = $a78c261c3211f7d6$export$331805bfbe18b1c0(highlight);
    } else {
        const selection = window.getSelection();
        // If there is a user selection, we need to create a new temp "highlight" for this
        // new selection as it is removed when the temp "highlight" is created
        const isNewSelection = selection && selection.type == 'Range' && !isCreateDialogOpen;
        if (isNewSelection) {
            // Reset any existing DOM selections
            $a78c261c3211f7d6$export$743373b19993e2b0();
            // Mark the selection in the DOM temporarily
            $a78c261c3211f7d6$export$4147ba71ff179432(false);
        }
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const createCommentHighlight = document.querySelector(`.${highlightClass}`);
        markOffsetTop = $a78c261c3211f7d6$export$331805bfbe18b1c0(createCommentHighlight);
    }
    // On a fabric page, the highlight is positioned relative to the renderer
    // wrapper. To correctly position the sidebar we need to measure the offset
    // of the renderer wrapper and the offset of the highlight from the wrapper
    if (isFabricPage) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const rendererWrapper = document.querySelector('#content .ak-renderer-wrapper');
        if (rendererWrapper) markOffsetTop += rendererWrapper.offsetTop;
    } else {
        // In tiny, we need to remove the title and author info offset to position it correctly
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const pageMetadata = document.querySelector('#content-body .page-metadata-modification-info');
        if (pageMetadata) markOffsetTop -= pageMetadata.offsetTop - pageMetadata.offsetHeight;
    }
    return markOffsetTop;
};
const $a78c261c3211f7d6$export$4147ba71ff179432 = (useNewHighlightLogic)=>{
    const highlightClass = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
    const selection = window.getSelection();
    if (!selection || selection.type !== 'Range') // Throw error?
    return;
    // Extract the range
    const selectedRange = selection.getRangeAt(0);
    // Get an array of the ranges to make highlights
    const rangesToHighlight = useNewHighlightLogic ? $a78c261c3211f7d6$var$extractTextNodesIntoRanges(selectedRange) : $a78c261c3211f7d6$var$extractTextNodesIntoRangesOld(selectedRange);
    rangesToHighlight.forEach((range)=>{
        // Create a new wrapper element with the correct class
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const highlightWrapper = document.createElement('span');
        highlightWrapper.classList.add(highlightClass);
        // Extract the contents of the range and add it to the new wrapper
        highlightWrapper.appendChild(range.extractContents());
        // Re-insert the wrapper back into the range
        range.insertNode(highlightWrapper);
    });
    // Clear the selection
    selection.removeAllRanges();
};
const $a78c261c3211f7d6$var$unwrapTextNodes = (wrappedNodes)=>{
    while(wrappedNodes.length){
        const node = wrappedNodes.shift();
        if (!node) return;
        const { parentNode: parentNode } = node;
        // Extract the text contents of the selection node out of the temp wrapper
        while(node.firstChild)parentNode?.insertBefore(node.firstChild, node);
        // After the text has been extracted, delete the wrapper
        parentNode?.removeChild(node);
        // Normalize the parent to fix any text node fragmentation
        parentNode?.normalize();
    }
};
const $a78c261c3211f7d6$export$743373b19993e2b0 = ()=>{
    const highlightClass = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
    // Grab all the newly created selection nodes
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const tempSelectionNodes = Array.from(document.querySelectorAll(`.${highlightClass}`));
    $a78c261c3211f7d6$var$unwrapTextNodes(tempSelectionNodes);
};
const $a78c261c3211f7d6$export$a160a5110cbadcb8 = (isFabricPage, markerRef, isActive = true)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const createCommentSelectionNodes = document.querySelectorAll(`.${$a78c261c3211f7d6$export$d2bdbdaa2c26e7f7}`);
    const ref = markerRef || '';
    // If we find selection nodes in the DOM, we need to add some attributes to them,
    // based on the page type, so they behave correctly when the user clicks a highlight
    if (createCommentSelectionNodes.length) createCommentSelectionNodes.forEach((selectionNode)=>{
        if (isFabricPage) {
            selectionNode.setAttribute($a78c261c3211f7d6$export$98471574bfa5228e, ref);
            selectionNode.setAttribute('data-mark-annotation-type', 'inlineComment');
        } else {
            selectionNode.setAttribute($a78c261c3211f7d6$export$90ee95b6cd79c832, ref);
            selectionNode.classList.add('inline-comment-marker');
        }
        const classesToAdd = [
            $a78c261c3211f7d6$export$b803c692fbaaa5a4
        ];
        if (isActive) classesToAdd.push($a78c261c3211f7d6$export$fb3d0eebfe85522a);
        // Add the classes needed
        selectionNode.classList.add(...classesToAdd);
        // Finally, remove the selection class to make it a full mark
        selectionNode.classList.remove($a78c261c3211f7d6$export$d2bdbdaa2c26e7f7);
    });
};
const $a78c261c3211f7d6$var$setHighlightsAsActive = (highlightElement, skipClassCheck = false)=>{
    if (skipClassCheck || highlightElement.classList.contains($a78c261c3211f7d6$export$b803c692fbaaa5a4)) highlightElement.classList.add($a78c261c3211f7d6$export$fb3d0eebfe85522a);
    // We need to set all the children of this highlight to active as well
    const { children: children } = highlightElement;
    for(let i = 0; i < children.length; ++i)$a78c261c3211f7d6$var$setHighlightsAsActive(children[i], skipClassCheck);
};
const $a78c261c3211f7d6$export$fd55463aeed84830 = (markerRef, skipClassCheck = false)=>{
    const highlightMarks = $a78c261c3211f7d6$export$6dfccc77fe608546(markerRef) || [];
    highlightMarks.forEach((highlight)=>$a78c261c3211f7d6$var$setHighlightsAsActive(highlight, skipClassCheck));
};
const $a78c261c3211f7d6$export$280edc47a64130be = (markerRef)=>{
    const highlight = $a78c261c3211f7d6$export$21445ab787d3b446(markerRef || '');
    return Boolean(highlight && highlight.classList.contains($a78c261c3211f7d6$export$fb3d0eebfe85522a));
};
const $a78c261c3211f7d6$export$a26c4eafef12029f = (markerRef)=>{
    const highlightMarksToRemove = Array.from($a78c261c3211f7d6$export$6dfccc77fe608546(markerRef));
    $a78c261c3211f7d6$var$unwrapTextNodes(highlightMarksToRemove);
    $a78c261c3211f7d6$export$f7ceeb7ba8156450();
};
const $a78c261c3211f7d6$export$a0939f064b367798 = ()=>{
    const highlightedAnnotations = Array.from(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelectorAll('.ak-editor-annotation-blur, .ak-editor-annotation-focus'));
    const highlightedAnnotationIds = highlightedAnnotations.map((annotation)=>annotation?.closest('.annotationView-content-wrap')?.id).filter((id)=>Boolean(id));
    return new Set(highlightedAnnotationIds);
};
const $a78c261c3211f7d6$export$98471574bfa5228e = 'data-id';
const $a78c261c3211f7d6$export$90ee95b6cd79c832 = 'data-ref';
const $a78c261c3211f7d6$var$hasAdfContent = (input)=>{
    const content = input && input.content;
    return content && content.some($a78c261c3211f7d6$var$validateContent);
};
// Check to make sure if we have item.type as paragraph content is not empty (user did not type anything)
// or user has put in blank spaces(empty string) and clicked save
// Any type other than paragraph is valid (e.g:- when user inserts divider, status etc without content)
const $a78c261c3211f7d6$var$validateContent = (item)=>item.type !== 'paragraph' || $a78c261c3211f7d6$var$validateParagraph(item);
const $a78c261c3211f7d6$var$validateParagraph = (item)=>{
    if (item.content) return item.content.some($a78c261c3211f7d6$var$isParagraphNotEmpty);
    return false;
};
const $a78c261c3211f7d6$var$isParagraphNotEmpty = (item)=>item.type !== 'text' || item.text.trim() !== '';
const $a78c261c3211f7d6$export$915f03d46d87bfd4 = (adf)=>!adf || !$a78c261c3211f7d6$var$hasAdfContent(adf);
const $a78c261c3211f7d6$export$d204c0ea9b3f0d7d = (isFabricPage)=>isFabricPage ? $a78c261c3211f7d6$export$98471574bfa5228e : $a78c261c3211f7d6$export$90ee95b6cd79c832;
const $a78c261c3211f7d6$export$8f4213b45c05ab5d = (element)=>{
    let markerRef = null;
    if (element) {
        markerRef = element.getAttribute($a78c261c3211f7d6$export$98471574bfa5228e);
        if (!markerRef) markerRef = element.getAttribute($a78c261c3211f7d6$export$90ee95b6cd79c832);
    }
    return markerRef;
};
const $a78c261c3211f7d6$export$21445ab787d3b446 = (markerRef, additionalQueryScope = '')=>{
    if (!markerRef) return null;
    // We need to allow for additional query scope to be added to specify particular markerRef comments
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    return document.querySelector(`${additionalQueryScope} [${$a78c261c3211f7d6$export$98471574bfa5228e}="${markerRef}"], ${additionalQueryScope} [${$a78c261c3211f7d6$export$90ee95b6cd79c832}="${markerRef}"]`);
};
const $a78c261c3211f7d6$export$6dfccc77fe608546 = (markerRef)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    return document.querySelectorAll(`[${$a78c261c3211f7d6$export$98471574bfa5228e}="${markerRef}"], [${$a78c261c3211f7d6$export$90ee95b6cd79c832}="${markerRef}"]`);
};
const $a78c261c3211f7d6$var$isHighlightCandidateVisible = (element)=>{
    const rect = element.getBoundingClientRect();
    const computedStyle = window.getComputedStyle(element);
    return element.isConnected && computedStyle.display !== 'none' && computedStyle.visibility !== 'hidden' && element.getAttribute('aria-hidden') !== 'true' && (rect.width > 0 || rect.height > 0);
};
const $a78c261c3211f7d6$export$c36aa9f15eddb765 = (markerRef)=>{
    if (!markerRef) return null;
    const allHighlights = Array.from($a78c261c3211f7d6$export$6dfccc77fe608546(markerRef));
    const visibleHighlight = allHighlights.find((element)=>$a78c261c3211f7d6$var$isHighlightCandidateVisible(element));
    return visibleHighlight || $a78c261c3211f7d6$export$21445ab787d3b446(markerRef);
};
const $a78c261c3211f7d6$export$6d23af9d8c2844b1 = [
    'enter',
    'escape'
];
const $a78c261c3211f7d6$var$getDimensions = ()=>{
    try {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const nav4ScrollParent = document.getElementById('AkMainContent');
        const currentPageOffset = !!nav4ScrollParent ? nav4ScrollParent.scrollTop : window.scrollY || (window.top?.scrollY ?? 0);
        return {
            currentWindowHeight: window.innerHeight || (window.top?.innerHeight ?? 0),
            currentPageOffset: currentPageOffset
        };
    } catch  {
        // Catch cross origin iframe error https://hello.atlassian.net/browse/CBT-907
        return {
            currentWindowHeight: 0,
            currentPageOffset: 0
        };
    }
};
const $a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET = 350;
const $a78c261c3211f7d6$export$858fd2398afb28e4 = (commentElement, useInstantScroll = false, isAbove = false)=>{
    if (!commentElement) return;
    const { currentWindowHeight: currentWindowHeight, currentPageOffset: currentPageOffset } = $a78c261c3211f7d6$var$getDimensions();
    const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement) + commentElement.offsetHeight + (isAbove ? -$a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET : 0);
    // If the position of the comment box is more than halfway down the screen, reposition it to the center
    if (offset <= currentPageOffset || offset > currentPageOffset + currentWindowHeight * (2 / 3)) {
        const windowOffset = currentWindowHeight / 5;
        window.scrollTo({
            top: offset - windowOffset,
            behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
        });
    }
};
const $a78c261c3211f7d6$export$b451b837f5309ae9 = ({ commentId: commentId, targetCommentId: targetCommentId, isEditor: isEditor, viewingRoomOffset: viewingRoomOffset = -150, useInstantScroll: useInstantScroll = false })=>{
    if (commentId !== targetCommentId) return;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const commentElement = document.querySelector(`[data-comment-id="${commentId}"]`);
    if (isEditor && commentElement) (0, $i49vP.scrollToElementInEditor)({
        targetElement: commentElement,
        viewingRoomOffset: viewingRoomOffset
    });
    else $a78c261c3211f7d6$export$fc9b5eebad60b835({
        element: commentElement,
        viewingRoomOffset: viewingRoomOffset,
        useInstantScroll: useInstantScroll
    });
};
const $a78c261c3211f7d6$export$e5d4e097ce63febc = ({ commentElement: commentElement, scrollRootElement: scrollRootElement, currentPageOffset: currentPageOffset, currentWindowHeight: currentWindowHeight, isAbove: isAbove, isFabricPage: isFabricPage, useInstantScroll: useInstantScroll })=>{
    if (!commentElement) return;
    // We may be in an iframe so use window.top
    const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement) + commentElement.offsetHeight + (isAbove ? -$a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET : 0);
    const rendererOffset = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector('#content .ak-renderer-wrapper')?.offsetTop || 0;
    // If the position of the highlight is more than halfway down the screen, reposition it to the center
    if (offset + rendererOffset <= currentPageOffset || offset + rendererOffset > currentPageOffset + currentWindowHeight * (2 / 3)) {
        const windowOffset = isFabricPage ? currentWindowHeight / 5 : currentWindowHeight / 3;
        scrollRootElement.scrollTo({
            top: offset - windowOffset,
            behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
        });
    }
};
const $a78c261c3211f7d6$export$c7436bd0a15f3e7e = ({ commentElement: commentElement, isFabricPage: isFabricPage, useInstantScroll: useInstantScroll = false, isAbove: isAbove = false, isCommentsPanel: isCommentsPanel })=>{
    if (!commentElement) return;
    const nodeToConsider = $a78c261c3211f7d6$export$ee0755cb593feed6(commentElement) || commentElement;
    const targetCommentHighlight = nodeToConsider.getBoundingClientRect();
    const { scrollRootElement: scrollRootElement, getDimensions: getDimensionsFromScrollRootContext } = $a78c261c3211f7d6$var$getScrollRootContext();
    const { currentWindowHeight: currentWindowHeight, currentPageOffset: currentPageOffset } = getDimensionsFromScrollRootContext();
    if (isCommentsPanel) {
        const commentHighlightAboveViewPort = Math.floor(targetCommentHighlight.bottom) < currentPageOffset;
        const commentHighlightBelowViewPort = targetCommentHighlight.top + 200 > window.innerHeight;
        // Scroll the highlight into view in the main content body
        if (commentHighlightAboveViewPort || commentHighlightBelowViewPort) $a78c261c3211f7d6$export$e5d4e097ce63febc({
            commentElement: commentElement,
            scrollRootElement: scrollRootElement,
            currentPageOffset: currentPageOffset,
            currentWindowHeight: currentWindowHeight,
            isAbove: isAbove,
            isFabricPage: !!isFabricPage,
            useInstantScroll: useInstantScroll
        });
    } else $a78c261c3211f7d6$export$e5d4e097ce63febc({
        commentElement: commentElement,
        scrollRootElement: scrollRootElement,
        currentPageOffset: currentPageOffset,
        currentWindowHeight: currentWindowHeight,
        isAbove: isAbove,
        isFabricPage: !!isFabricPage,
        useInstantScroll: useInstantScroll
    });
    //If comment is in expand, open respective expand
    $a78c261c3211f7d6$export$876171b9c9b54aab(commentElement, isFabricPage);
};
const $a78c261c3211f7d6$export$66b4d1e3b6633573 = (target, scrollContainer)=>{
    const rect = target.getBoundingClientRect();
    const parentRect = scrollContainer.getBoundingClientRect();
    let moveY = 0;
    // The distance (in pixels) between the target and the end of the visible viewport at which point,
    // when scrolling the target into view, scrolling takes place.
    const SCROLL_THRESHOLD = 60;
    // The extra space (in pixels) that is left above or below the target when it is scrolled into view.
    const SCROLL_MARGIN = 120;
    // Note: visible area of the container refers to parentRect.top/bottom +/- SCROLL_THRESHOLD
    if (rect.top < parentRect.top + SCROLL_THRESHOLD) // If the target is above the top of the visible area of the container, moveY should be negative to bring target down into view
    moveY = -(parentRect.top - rect.top + SCROLL_MARGIN);
    else if (rect.bottom > parentRect.bottom - SCROLL_THRESHOLD) // If the target's bottom is below the bottom of the visible area of the container, move Y should be positive to bring target up into view
    moveY = rect.bottom - parentRect.bottom + SCROLL_MARGIN;
    if (moveY) scrollContainer.scrollTop += moveY;
};
const $a78c261c3211f7d6$export$fb40c5e75b82df8 = (isEditor, isViewCommentMode)=>{
    if (isEditor && isViewCommentMode) return 'editor-comments-sidebar';
    else if (isEditor && !isViewCommentMode) return 'editor-create-sidebar';
    else if (!isEditor && isViewCommentMode) return 'renderer-comments-sidebar';
    else return 'renderer-create-sidebar';
};
const $a78c261c3211f7d6$export$59a770a0e59b0dd2 = (container)=>{
    const selector = [
        'button:not([disabled])',
        'a[href]',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        '[contenteditable="true"]',
        '[tabindex]:not([tabindex="-1"])'
    ].join(',');
    return Array.from(container.querySelectorAll(selector)).filter((element)=>!element.hasAttribute('disabled') && element.getAttribute('aria-hidden') !== 'true');
};
const $a78c261c3211f7d6$export$642e21ba866d02df = (container, element)=>{
    if (!element) return false;
    return $a78c261c3211f7d6$export$59a770a0e59b0dd2(container)[0] === element;
};
const $a78c261c3211f7d6$export$876aeb5dffd449af = (container, element)=>{
    if (!element) return false;
    const tabbableElements = $a78c261c3211f7d6$export$59a770a0e59b0dd2(container);
    return tabbableElements[tabbableElements.length - 1] === element;
};
const $a78c261c3211f7d6$export$cfa8eefe354167cd = (element, focusOptions)=>{
    element.setAttribute('tabIndex', '-1');
    element.focus(focusOptions);
};
const $a78c261c3211f7d6$export$db9eae89818590a4 = (commentElement, previousCommentElement, isFabricPage, isEditor)=>{
    if (!commentElement) return;
    const { scrollRootElement: scrollRootElement, scrollRootOffset: scrollRootOffset } = $a78c261c3211f7d6$var$getScrollRootContext();
    // if current open comment is out of viewport, we need to scroll so that the next comment is in viewport
    const sidebarId = $a78c261c3211f7d6$export$fb40c5e75b82df8(isEditor, true); // Hard-coding isViewCommentMode to true because navigation only exists in the view scenario
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const inlineCommentSidebar = document.getElementById(sidebarId);
    const inlineCommentPosition = inlineCommentSidebar?.getBoundingClientRect();
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const documentContent = document.getElementById('content');
    const documentContentTopPosition = documentContent?.getBoundingClientRect().top;
    const commentAboveViewport = inlineCommentPosition && documentContentTopPosition && inlineCommentPosition.top < documentContentTopPosition + scrollRootOffset;
    const commentBelowViewport = inlineCommentPosition && inlineCommentPosition.top + 200 > window.innerHeight;
    if (commentAboveViewport || commentBelowViewport) {
        $a78c261c3211f7d6$export$c7436bd0a15f3e7e({
            commentElement: commentElement,
            isFabricPage: isFabricPage
        });
        return;
    }
    const previousOffset = previousCommentElement ? $a78c261c3211f7d6$export$331805bfbe18b1c0(previousCommentElement) : 0;
    const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement);
    const differenceOffset = offset - previousOffset;
    scrollRootElement.scrollBy({
        top: differenceOffset,
        behavior: 'smooth' // navigation uses a smooth scroll
    });
    // If comment is in expand, open respective expand
    $a78c261c3211f7d6$export$876171b9c9b54aab(commentElement, isFabricPage);
};
const $a78c261c3211f7d6$var$adjustNodeForStickyHeader = (stickyHeaderElement)=>{
    let adjustedElement = stickyHeaderElement;
    const markerRef = $a78c261c3211f7d6$export$8f4213b45c05ab5d(adjustedElement);
    // If this is exists it's a commited comment, look for its counterpart in the real table
    // TODO: Support new highlights when we allow it
    if (markerRef) // WS-2618 We have old macros that render tiny inline comments so we need to look for both fabric and tiny marker refs
    adjustedElement = $a78c261c3211f7d6$export$21445ab787d3b446(markerRef, '.pm-table-wrapper');
    return adjustedElement;
};
const $a78c261c3211f7d6$export$ee0755cb593feed6 = (element)=>{
    let nodeToReturn = element;
    // Sticky table headers duplicate the elements in the DOM so we need to check if this is the real one or not
    // If the highlight has a parent with the class .pm-table-sticky-wrapper it is the fake one
    if (nodeToReturn && nodeToReturn.closest && nodeToReturn.closest('.pm-table-sticky-wrapper')) nodeToReturn = $a78c261c3211f7d6$var$adjustNodeForStickyHeader(nodeToReturn);
    if (nodeToReturn) {
        // WS-2718 - If a comment is in an extension macro
        const extensionParent = nodeToReturn.closest('.ak-renderer-extension');
        if (extensionParent) nodeToReturn = extensionParent;
    }
    return nodeToReturn;
};
const $a78c261c3211f7d6$export$331805bfbe18b1c0 = (element, relativeToElement, isRendererAnnotationProviderEnabled)=>{
    let elementOffsetTop = 0;
    let nodeToMeasure = element;
    // new sticky header implementation
    if ((0, $6mKj3.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow')) {
        if (relativeToElement && nodeToMeasure && nodeToMeasure.closest && nodeToMeasure.closest('tr.pm-table-row-native-sticky-active')) {
            const elementRect = nodeToMeasure.getBoundingClientRect();
            const containerRect = relativeToElement.getBoundingClientRect();
            return elementRect.top - containerRect.top;
        }
    }
    // Sticky table headers duplicate the elements in the DOM so we need to check if this is the real one or not
    // If the highlight has a parent with the class .pm-table-sticky-wrapper it is the fake one
    if (nodeToMeasure && nodeToMeasure.closest && nodeToMeasure.closest('.pm-table-sticky-wrapper')) // The RAP annotation draft mark is applied to the both pm-table-sticky-wrapper as well as the pm-table-wrapper.
    // Need to check only pm-table-wrapper annotation draft mark for the RAP enabled
    nodeToMeasure = isRendererAnnotationProviderEnabled ? // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector(`.pm-table-wrapper [data-annotation-draft-mark="true"]`) : $a78c261c3211f7d6$var$adjustNodeForStickyHeader(nodeToMeasure);
    // Iterate through the offset parents until we are back to the ak-renderer-wrapper to get the
    // proper offset Fabric Pages wrap the content in a .ak-renderer-wrapper element, but Tiny
    // pages do not have anything like that, but will return null when we get to <body>
    while(nodeToMeasure && !nodeToMeasure.classList.contains('ak-renderer-wrapper') && nodeToMeasure !== relativeToElement){
        elementOffsetTop += nodeToMeasure.offsetTop;
        nodeToMeasure = nodeToMeasure.offsetParent;
    }
    // WS-2718 - If a comment is in an extension macro, we need to add its container offset as well
    if (nodeToMeasure) {
        const extensionParent = nodeToMeasure.closest('.ak-renderer-extension');
        if (extensionParent) elementOffsetTop += extensionParent.offsetTop;
    }
    return elementOffsetTop;
};
const $a78c261c3211f7d6$export$d0d02dc9adb82d62 = (element, isFabricPage)=>{
    //get the child of element passed in
    const expandElement = element?.hasChildNodes() ? element?.firstChild : element;
    //check if element is expand button and return element if so
    if (isFabricPage) {
        if (expandElement?.tagName?.toLowerCase() === 'button') return expandElement;
    } else if (expandElement?.classList?.contains('expand-control')) return expandElement?.firstChild; //it's one child down for tiny pages
    return null;
};
const $a78c261c3211f7d6$export$1a2319f5c2109ee1 = (element, options)=>{
    const { expandSelectors: expandSelectors, getExpandButton: getExpandButton, isExpanded: isExpanded, onExpand: onExpand } = options;
    const nodeToCheck = element;
    // Check if comment is in any expand
    const isInExpand = expandSelectors.some((selector)=>nodeToCheck?.closest?.(selector));
    if (!isInExpand) return;
    // Find all expand buttons that need to be opened, starting from the innermost
    const expandButtonsToOpen = [];
    let currentNode = nodeToCheck;
    while(currentNode){
        // Check if current node has an expand button
        const expandButton = getExpandButton(currentNode);
        if (expandButton) // Check if this expand is already opened
        {
            if (!isExpanded(expandButton)) expandButtonsToOpen.push(expandButton);
        }
        currentNode = currentNode?.parentElement;
    }
    // Open all expand buttons from innermost to outermost
    const buttonsToClick = [
        ...expandButtonsToOpen
    ].reverse();
    buttonsToClick.forEach((expandButton)=>{
        if (onExpand) onExpand(expandButton);
        expandButton.click();
    });
};
const $a78c261c3211f7d6$export$d2685a53bf6957f4 = (element, isFabricPage)=>{
    const expandElementClassname = isFabricPage ? '.expand-content-wrapper' : '.expand-content';
    const nestedExpandElementClassname = '.nestedExpand-content-wrapper';
    const expandSelectors = [
        expandElementClassname,
        nestedExpandElementClassname
    ];
    const getExpandButton = (node)=>$a78c261c3211f7d6$export$d0d02dc9adb82d62(node, isFabricPage);
    const isExpanded = (button)=>{
        return isFabricPage ? button.getAttribute('aria-expanded') === 'true' : button.className.includes('expanded');
    };
    $a78c261c3211f7d6$export$1a2319f5c2109ee1(element, {
        isFabricPage: isFabricPage,
        expandSelectors: expandSelectors,
        getExpandButton: getExpandButton,
        isExpanded: isExpanded
    });
};
const $a78c261c3211f7d6$export$876171b9c9b54aab = (element, isFabricPage)=>{
    $a78c261c3211f7d6$export$d2685a53bf6957f4(element, isFabricPage);
};
const $a78c261c3211f7d6$export$187f977414e8342c = (action, index, markerRefList)=>{
    if (markerRefList.length === 0 || index === undefined || index === -1) return;
    let commentIndex = -1;
    //Navigate to first inline comment if we're on the last comment and the user clicks next,
    // or to the last comment if we're on the first comment and the user clicks previous
    if (action === 'next') commentIndex = index === markerRefList.length - 1 ? 0 : index + 1;
    else if (action === 'previous') commentIndex = index === 0 ? markerRefList.length - 1 : index - 1;
    return markerRefList[commentIndex];
};
const $a78c261c3211f7d6$export$883ebc059dd86e88 = (index, markerRefList, unreadMarkerRefList)=>{
    if (index === undefined || markerRefList.length === 0 || index === -1 || !unreadMarkerRefList || unreadMarkerRefList.length === 0) return;
    let commentIndex = index % markerRefList.length; // Handle case where index is beyond array length
    const refListLength = markerRefList.length;
    let iterations = 0;
    while(markerRefList[commentIndex] !== undefined && !unreadMarkerRefList.includes(markerRefList[commentIndex]) && iterations < refListLength){
        commentIndex = (commentIndex + 1) % markerRefList.length;
        iterations++;
    }
    return markerRefList[commentIndex];
};
const $a78c261c3211f7d6$export$b401b3c3a0774fd7 = ()=>// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
const $a78c261c3211f7d6$export$2cdf1b96a9f86d16 = async (text)=>{
    if ($a78c261c3211f7d6$export$b401b3c3a0774fd7()) // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    await navigator.clipboard.writeText(text);
};
const $a78c261c3211f7d6$export$ab567600730c0b3b = (annotationElement, scrollParentSelector)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const scrollParent = document.querySelector(scrollParentSelector);
    return $a78c261c3211f7d6$export$331805bfbe18b1c0(annotationElement, scrollParent);
};
const $a78c261c3211f7d6$export$3cdeee3ea1732782 = (annotationElement, scrollParentSelector, isView)=>{
    let offset = 0;
    if (annotationElement) {
        // If the annotation is the wrapperDOM, we actually need #content to be the scrollParent
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const scrollParent = document.querySelector('div#content[data-inline-comments-target="true"]');
        if (scrollParent) {
            let annotationOffset;
            if (isView) annotationOffset = $a78c261c3211f7d6$export$331805bfbe18b1c0(annotationElement);
            else {
                // If the annotation is the wrapperDOM, we need to find the actual highlight instead
                const actualHiglightElement = scrollParent.querySelector(scrollParentSelector);
                annotationOffset = $a78c261c3211f7d6$export$331805bfbe18b1c0(actualHiglightElement, undefined, true);
            }
            offset = annotationOffset + scrollParent.offsetTop;
        }
    }
    return offset;
};
const $a78c261c3211f7d6$export$9f8164812b21bc7a = (entries)=>{
    const windowHeight = window.innerHeight;
    if ((0, $6mKj3.expValEquals)('confluence_unify_footer_comments_space_width', 'isEnabled', true) || (0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_space_ld')) {
        if (!(0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_space_ld')) {
            // When fg is ON, we would have verified that there's no
            // endOfPageRecommendations before adding this ResizeObserver.
            // So no need to check it here.
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const endOfPageRecommendations = document.querySelector('.end-of-page-rec-wrapper');
            if (endOfPageRecommendations) return 0;
        }
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const editorTextArea = document.getElementById('ak-editor-textarea');
        const editorBottom = editorTextArea?.getBoundingClientRect().bottom;
        if (editorBottom && windowHeight) {
            // The minimum spacing between bottom of editor content and top of footer is 120px
            const minimumSpacing = 120;
            // - There's an existing fixed 24px margin below editor content.
            // - ObjectAddCommentContainer.tsx has a 64px height.
            // - We lift footer comment top by 14px to make it visually distinct
            //   when a short LiveDoc has some vs zero existing footer comment.
            const editorBottomMargin = 24;
            const addFooterCommentHeight = 64;
            const extraFooterCommentHeightToShow = 14;
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const editorScrollParent = document.querySelector('.fabric-editor-popup-scroll-parent');
            const currentScroll = editorScrollParent?.scrollTop ?? 0;
            const editorBottomUnscrolled = editorBottom + currentScroll;
            const verticalDistanceFromWindowBottomUnscrolled = windowHeight - editorBottomUnscrolled;
            return Math.max(verticalDistanceFromWindowBottomUnscrolled - editorBottomMargin - addFooterCommentHeight - extraFooterCommentHeightToShow, minimumSpacing);
        }
    } else {
        // The calculation is
        // 15px of marginTop on the comment container
        // 2px full-page-editor-style bottom which above the viewport
        // 1px border which is cumulates to 120px
        const thresholdTop = 102;
        const editorEntry = entries.find((entry)=>entry.target.id === 'ak-editor-textarea');
        const editorBottom = editorEntry?.target.getBoundingClientRect().bottom;
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const editorContentHeight = document.querySelector(`.ak-editor-content-area .ProseMirror`)?.getBoundingClientRect().height;
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const documentContentBottom = document.querySelector(`[data-testid='full-page-editor-style']`)?.getBoundingClientRect().bottom;
        if (editorContentHeight) {
            // If the document content is larger than the window height, just set it to a static 120 to keep the proper spacing
            if (editorContentHeight > windowHeight) return 120;
            if (documentContentBottom && editorBottom) {
                const verticalDistance = documentContentBottom - editorBottom;
                if (verticalDistance >= thresholdTop && editorContentHeight <= windowHeight) return verticalDistance - thresholdTop;
                else if (verticalDistance <= thresholdTop) return thresholdTop;
            }
        }
    }
};
const $a78c261c3211f7d6$export$e3a17b46d43aa5f6 = ()=>{
    // This is deprecated, and will be replaced by a new approach that works in SSR.
    let newTop = 0;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const endOfPageRecommendations = document.querySelector('.end-of-page-rec-wrapper');
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const legacyLabels = document.querySelector('[data-vc="view-page-labels-container"]');
    // no extra spacing if the page shows end-of-page recommendations or legacy labels
    if (!endOfPageRecommendations && !legacyLabels) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const rendererContent = document.getElementById('main-content');
        const rendererContentBottom = rendererContent?.getBoundingClientRect()?.bottom ?? 0;
        if (rendererContentBottom) {
            // - There's an existing fixed 80px margin below Page content (See
            //   next/packages/view-page-common/src/ViewPageContent.tsx).
            // - ObjectAddCommentContainer.tsx has a 64px height.
            // - We lift footer comment top by 14px (matching Editor version ^)
            //   to make it visually distinct when a short Page has some vs zero
            //   existing footer comment.
            const contentBottomMargin = 80;
            const addFooterCommentHeight = 64;
            const extraFooterCommentHeightToShow = 14;
            // Find the current scroll offset on the Page.
            // This is similar to implementation in getDimensionsForNav4(),
            // but when the window is very narrow, nav4ScrollParent.scrollTop
            // can be 0 (nav4ScrollParent element itself exists on page) while
            // window.scrollY is positive.
            // So this is a more robust implementation. Will explore whether
            // getDimensionsForNav4() can be updated to use this implementation
            // in a separate PR.
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const nav4ScrollParent = document.getElementById('AkMainContent');
            const currentPageOffset = (nav4ScrollParent?.scrollTop ?? 0) + (window.scrollY ?? window.top?.scrollY ?? 0);
            const rendererContentBottomUnscrolled = rendererContentBottom + currentPageOffset;
            const windowHeight = window.innerHeight;
            const verticalDistanceFromWindowBottomUnscrolled = windowHeight - rendererContentBottomUnscrolled - contentBottomMargin;
            newTop = Math.max(verticalDistanceFromWindowBottomUnscrolled - addFooterCommentHeight - extraFooterCommentHeightToShow, 0);
        }
    }
    return newTop;
};
const $a78c261c3211f7d6$export$fc9b5eebad60b835 = ({ element: element, viewingRoomOffset: viewingRoomOffset = -150, useInstantScroll: useInstantScroll = false })=>{
    if (!element) return;
    const { scrollRootElement: scrollRootElement, scrollRootOffset: scrollRootOffset } = $a78c261c3211f7d6$var$getScrollRootContext();
    const elementRect = element.getBoundingClientRect();
    const elementTopViewport = elementRect.top;
    const scrollRootTopViewport = scrollRootElement instanceof Window ? 0 // Window doesn't have a bounding rect; its top is always 0
     : scrollRootElement.getBoundingClientRect().top;
    const elementTopFromScrollRoot = elementTopViewport - scrollRootTopViewport;
    const targetScrollPosition = elementTopFromScrollRoot + scrollRootOffset + viewingRoomOffset;
    scrollRootElement.scrollTo({
        top: targetScrollPosition,
        behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
    });
    // open expand if the element is inside an expand
    $a78c261c3211f7d6$export$876171b9c9b54aab(element, true);
};
const $a78c261c3211f7d6$export$b3ba907d5759e257 = (commentId, annotationId)=>{
    let isDisconnected = false;
    let commentFound = false;
    // Find the most specific container to observe
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const commentsPanelListContainer = document.querySelector('[data-testid="comments-panel-list-container"]');
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const targetContainer = commentsPanelListContainer || document.body;
    const observer = new MutationObserver(()=>{
        if (isDisconnected || commentFound) return;
        const commentElement = targetContainer.querySelector(`[data-comment-id="${commentId}"]`) || (annotationId ? targetContainer.querySelector(`[data-testid="comment-thread-${annotationId}-container"]`) : null);
        if (commentElement) {
            commentFound = true;
            commentElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center'
            });
            isDisconnected = true;
            observer.disconnect();
        }
    });
    // Start observing only the specific container
    observer.observe(targetContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: annotationId ? [
            'data-comment-id',
            'data-testid'
        ] : [
            'data-comment-id'
        ]
    });
    // Return cleanup function
    return ()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
        }
    };
};
const $a78c261c3211f7d6$export$b1b7c9bcc75c855d = ({ targetCommentId: targetCommentId, onScrollReady: onScrollReady, onFallback: onFallback, timeoutMs: timeoutMs = 10000, markElement: markElement, containerId: containerId })=>{
    if ((0, $6mKj3.expValEquals)('confluence_comments_use_new_observer', 'isEnabled', true)) return $a78c261c3211f7d6$export$4d09fb2a10e54800({
        targetCommentId: targetCommentId,
        onScrollReady: onScrollReady,
        onFallback: onFallback,
        timeoutMs: timeoutMs,
        markElement: markElement,
        containerId: containerId
    });
    let commentFound = false;
    let isDisconnected = false;
    const observer = new MutationObserver((mutations)=>{
        if (isDisconnected) return;
        // First, look for the comment element if we haven't found it yet
        if (!commentFound) {
            for (const mutation of mutations)if (mutation.type === 'childList') {
                for (const addedNode of Array.from(mutation.addedNodes))if (addedNode.nodeType === Node.ELEMENT_NODE) {
                    const element = addedNode;
                    // Check if this element or any of its descendants has the specific data-comment-id
                    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                    const containerElement = containerId ? document.getElementById(containerId) : null;
                    const commentElement = containerElement || element.querySelector?.(`[data-comment-id="${targetCommentId}"]`) || (element.matches?.(`[data-comment-id="${targetCommentId}"]`) ? element : null);
                    if (commentElement) {
                        commentFound = true;
                        // Early return if the comment is in the container element
                        if (containerElement) {
                            onScrollReady(containerElement);
                            isDisconnected = true;
                            observer.disconnect();
                            return;
                        }
                        markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                        // Check the initial state of the show more button
                        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                        const showMoreButton = document.querySelector('[data-testid="show-hidden-replies"]');
                        if (!showMoreButton) {
                            onScrollReady(commentElement);
                            isDisconnected = true;
                            observer.disconnect();
                            return;
                        } else // Trigger click on the show more button to expand all replies
                        showMoreButton.click();
                        break;
                    }
                }
            }
        }
        // If comment is found, watch for the show more button to disappear
        if (commentFound) {
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const commentElement = document.querySelector(`[data-comment-id="${targetCommentId}"]`);
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const showMoreButton = document.querySelector('[data-testid="show-hidden-replies"]');
            if (commentElement && !showMoreButton) {
                markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                onScrollReady(commentElement);
                isDisconnected = true;
                observer.disconnect();
                return;
            }
        }
    });
    // Start observing
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    // Clean up observer after specified timeout to prevent memory leaks
    const timeoutId = setTimeout(()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            // Fallback behavior if comment was found but button never disappeared
            if (commentFound) {
                // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                const commentElement = document.querySelector(`[data-comment-id="${targetCommentId}"]`);
                if (commentElement) {
                    // Check and open expand sections if needed before scrolling
                    markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                    onScrollReady(commentElement);
                }
            } else if (onFallback) onFallback();
        }
    }, timeoutMs);
    // Return cleanup function
    return ()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            clearTimeout(timeoutId);
        }
    };
};
/**
 * Find the comment element by ID or data-comment-id attribute
 */ const $a78c261c3211f7d6$var$findCommentElement = (targetCommentId, containerId, isFooterCommentInPanel)=>{
    // If isFooterCommentInPanel is true, use comment-thread-${targetCommentId}-container
    if (isFooterCommentInPanel) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const panelContainer = document.getElementById(`comment-thread-${targetCommentId}-container`);
        if (panelContainer) return panelContainer;
    }
    // Try container element first if containerId is provided
    if (containerId) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const container = document.getElementById(containerId);
        if (container) return container;
    }
    // Fall back to finding by data-comment-id
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    return document.querySelector(`[data-comment-id="${targetCommentId}"]`);
};
const $a78c261c3211f7d6$export$5eaef9e6a0975768 = (commentElement, targetCommentId)=>{
    if (!commentElement) return null;
    // 1. Check within commentElement (descendants)
    const buttonInComment = commentElement.querySelector('[data-testid="show-hidden-replies"]');
    if (buttonInComment) return buttonInComment;
    // 2. Check in parent element (siblings)
    const parentElement = commentElement.parentElement;
    const buttonInParent = parentElement?.querySelector('[data-testid="show-hidden-replies"]');
    if (buttonInParent) return buttonInParent;
    // 3. Check in replies container (specific to this comment thread)
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const repliesContainer = document.querySelector(`[data-testid="comment-thread-${targetCommentId}-replies"]`);
    const buttonInReplies = repliesContainer?.querySelector('[data-testid="show-hidden-replies"]');
    if (buttonInReplies) return buttonInReplies;
    return null;
};
/**
 * Handle the comment element being found
 * Checks for show more button and either scrolls immediately or clicks to expand
 */ const $a78c261c3211f7d6$var$handleCommentFound = (commentElement, targetCommentId, containerId, markElement, onScrollReady)=>{
    // If container element exists and we're using it, scroll immediately
    if (containerId && commentElement.id === containerId) {
        markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
        onScrollReady(commentElement);
        return true; // Indicates we should disconnect
    }
    // Expand mark element if needed
    markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
    // Check for show more button
    const showMoreButton = $a78c261c3211f7d6$export$5eaef9e6a0975768(commentElement, targetCommentId);
    if (!showMoreButton) {
        // No show more button, scroll immediately
        onScrollReady(commentElement);
        return true; // Indicates we should disconnect
    } else {
        // Show more button exists, click it to expand replies
        showMoreButton.click();
        return false; // Keep watching for button to disappear
    }
};
/**
 * Check if comment element exists in newly added nodes
 */ const $a78c261c3211f7d6$var$checkAddedNodes = (addedNodes, targetCommentId, containerId, isFooterCommentInPanel, onCommentFound)=>{
    for (const addedNode of Array.from(addedNodes)){
        if (addedNode.nodeType !== Node.ELEMENT_NODE) continue;
        const element = addedNode;
        // Check if this element or its descendants contains the comment
        let commentElement = null;
        // First check for container element
        if (containerId) {
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const container = document.getElementById(containerId);
            if (container) commentElement = container;
        }
        // If not found, check for comment by data-comment-id
        if (!commentElement) commentElement = element.querySelector?.(`[data-comment-id="${targetCommentId}"]`) || (element.matches?.(`[data-comment-id="${targetCommentId}"]`) ? element : null);
        // If isFooterCommentInPanel, also check for panel container
        if (!commentElement && isFooterCommentInPanel) {
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const panelContainer = document.getElementById(`comment-thread-${targetCommentId}-container`);
            if (panelContainer) commentElement = panelContainer;
        }
        if (commentElement) {
            const shouldDisconnect = onCommentFound(commentElement);
            if (shouldDisconnect) return true; // Indicates we should stop processing
        }
    }
    return false;
};
const $a78c261c3211f7d6$export$4d09fb2a10e54800 = ({ targetCommentId: targetCommentId, onScrollReady: onScrollReady, onFallback: onFallback, timeoutMs: timeoutMs = 10000, markElement: markElement, containerId: containerId, isFooterCommentInPanel: isFooterCommentInPanel = false })=>{
    let commentFound = false;
    let isDisconnected = false;
    const handleCommentFoundWrapper = (commentElement)=>{
        commentFound = true;
        return $a78c261c3211f7d6$var$handleCommentFound(commentElement, targetCommentId, containerId, markElement, onScrollReady);
    };
    const observer = new MutationObserver((mutations)=>{
        if (isDisconnected) return;
        // First, look for the comment element if we haven't found it yet
        if (!commentFound) {
            for (const mutation of mutations)if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                const shouldStop = $a78c261c3211f7d6$var$checkAddedNodes(mutation.addedNodes, targetCommentId, containerId, isFooterCommentInPanel, handleCommentFoundWrapper);
                if (shouldStop) {
                    isDisconnected = true;
                    observer.disconnect();
                    return;
                }
            }
        }
        // If comment is found, watch for the show more button to disappear
        if (commentFound) {
            const commentElement = $a78c261c3211f7d6$var$findCommentElement(targetCommentId, containerId, isFooterCommentInPanel);
            const showMoreButton = $a78c261c3211f7d6$export$5eaef9e6a0975768(commentElement, targetCommentId);
            // If comment exists and show more button is gone, we're ready to scroll
            if (commentElement && !showMoreButton) {
                markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                onScrollReady(commentElement);
                isDisconnected = true;
                observer.disconnect();
                return;
            }
        }
    });
    // Start observing
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    // Clean up observer after specified timeout to prevent memory leaks
    const timeoutId = setTimeout(()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            // Fallback behavior if comment was found but button never disappeared
            if (commentFound) {
                const commentElement = $a78c261c3211f7d6$var$findCommentElement(targetCommentId, containerId, isFooterCommentInPanel);
                if (commentElement) {
                    // Check and open expand sections if needed before scrolling
                    markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                    onScrollReady(commentElement);
                }
            } else if (onFallback) onFallback();
        }
    }, timeoutMs);
    // Return cleanup function
    return ()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            clearTimeout(timeoutId);
        }
    };
};
/**
 * Returns the HTMLElement or window that should be used as the scroll root. By default,
 *  this is the div with id=AkMainContent, if the id exists in the DOM
 */ function $a78c261c3211f7d6$var$getScrollRootContext() {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const nav4ScrollRootElement = document.getElementById('AkMainContent');
    const scrollRootElement = nav4ScrollRootElement || window;
    const scrollRootOffset = nav4ScrollRootElement ? nav4ScrollRootElement.scrollTop : window.scrollY;
    return {
        scrollRootElement: scrollRootElement,
        scrollRootOffset: scrollRootOffset,
        getDimensions: $a78c261c3211f7d6$var$getDimensions
    };
}
// Constants for comment thread visibility
const $a78c261c3211f7d6$var$SCROLLED_COMMENTS_HEADER_GAP_SIZE_IN_PIXELS = 8;
const $a78c261c3211f7d6$var$NUM_HIDDEN_PIXELS_TO_BE_CONSIDERED_OUT_OF_VIEW = 60;
const $a78c261c3211f7d6$var$getTotalOffsetAboveCommentsPanelThreads = (generalCommentsHeaderHeight)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    let objectSidebarPanelHeader = document.querySelector("[data-testid='object-sidebar-panel-header']");
    let additionalOffset = 0;
    if (!objectSidebarPanelHeader) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        objectSidebarPanelHeader = document.querySelector("[data-testid='scrolled-object-sidebar-panel-header']");
        additionalOffset = $a78c261c3211f7d6$var$SCROLLED_COMMENTS_HEADER_GAP_SIZE_IN_PIXELS;
    }
    const objectSidebarPanelHeaderHeight = objectSidebarPanelHeader?.getBoundingClientRect().height ?? 0;
    const objectHeaderHeight = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[data-testid='object-header-container']")?.getBoundingClientRect().height ?? 0;
    const topNavContainerHeight = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[data-testid='grid-topNav']")?.getBoundingClientRect().height ?? 0;
    const bannerContainerHeight = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[data-testid='banner-container']")?.getBoundingClientRect().height ?? 0;
    const editorControlsOnboardingBannerHeight = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[data-testid='editor-controls-onboarding-banner']")?.getBoundingClientRect().height ?? 0;
    const announcementBannerHeight = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[id='AkBanner']")?.getBoundingClientRect().height ?? 0;
    return objectSidebarPanelHeaderHeight + objectHeaderHeight + topNavContainerHeight + bannerContainerHeight + additionalOffset + generalCommentsHeaderHeight + editorControlsOnboardingBannerHeight + announcementBannerHeight;
};
const $a78c261c3211f7d6$export$4d211f4974dcf196 = (commentThreadElement, commentType)=>{
    const commentThreadRect = commentThreadElement.getBoundingClientRect();
    const generalCommentsHeaderHeight = commentType === 'general' ? // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[data-testid='comment-section-separator']")?.getBoundingClientRect().height ?? 0 : 0;
    const totalPaddingAboveCommentThreadView = $a78c261c3211f7d6$var$getTotalOffsetAboveCommentsPanelThreads(generalCommentsHeaderHeight);
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const objectSidebarPanelFooter = document.querySelector("[data-testid='object-sidebar-panel-footer']");
    const objectSidebarPanelFooterHeight = objectSidebarPanelFooter?.getBoundingClientRect().height ?? 0;
    const viewportTop = totalPaddingAboveCommentThreadView;
    const viewportBottom = window.innerHeight - objectSidebarPanelFooterHeight;
    const commentTopInView = commentThreadRect.top >= viewportTop;
    const commentBottomInView = commentThreadRect.bottom <= viewportBottom;
    if (commentTopInView && commentBottomInView) // Comment is 100% in view
    return false;
    else if (!commentTopInView && commentBottomInView) // Comment is <100% in view and the hidden part is the top part of the comment
    return true;
    else if (commentTopInView && !commentBottomInView) {
        // Comment is <100% in view and the hidden part is the bottom of the comment
        const hiddenBottomHeight = commentThreadRect.bottom - viewportBottom;
        if (hiddenBottomHeight <= $a78c261c3211f7d6$var$NUM_HIDDEN_PIXELS_TO_BE_CONSIDERED_OUT_OF_VIEW) // The hidden part is <= 60 pixels
        return false;
        else // The hidden part is > 60 pixels
        return true;
    } else // Comment is <100% in view and the hidden part is the top part of the comment
    return true;
};
const $a78c261c3211f7d6$export$9c5b7a3c864ae31b = (commentThreadElement, commentType)=>{
    const commentThreadRect = commentThreadElement.getBoundingClientRect();
    const generalCommentsHeaderHeight = commentType === 'general' ? // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[data-testid='comment-section-separator']")?.getBoundingClientRect().height ?? 0 : 0;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const objectSidebarPanelFooter = document.querySelector("[data-testid='object-sidebar-panel-footer']");
    const objectSidebarPanelFooterHeight = objectSidebarPanelFooter?.getBoundingClientRect().height ?? 0;
    return(// Element is partially out of view below the comments panel viewport
    commentThreadRect.bottom + generalCommentsHeaderHeight > window.innerHeight - objectSidebarPanelFooterHeight);
};
const $a78c261c3211f7d6$export$e3c287b6d80b16ce = ({ pageMode: pageMode, pageWidthType: pageWidthType, hasEndOfPageRecommendations: hasEndOfPageRecommendations })=>{
    const endOfPageRecommendationsMaxWidth = '1000px';
    if (pageMode === (0, $cD1qu.PageMode).VIEW && ((0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_width') || (0, $6mKj3.expValEquals)('confluence_unify_footer_comments_space_width', 'isEnabled', true))) {
        // pageWidthType is a string like '"default"' / '"full-width"' in renderer mode, and is undefined in live doc mode
        const isDefaultWidth = pageWidthType && JSON.parse(pageWidthType) === (0, $1d2ww.ContentAppearanceType).DEFAULT;
        if (hasEndOfPageRecommendations) // when end-of-page recommendations is present, always match its width (see EndOfPageRecContainer.tsx)
        return {
            width: isDefaultWidth ? '87.5%' : '100%',
            maxWidth: endOfPageRecommendationsMaxWidth
        };
        else return {
            width: '100%',
            maxWidth: isDefaultWidth ? '760px' : '1800px' // if not defaultWidth, use full page width
        };
    }
    if (pageMode !== (0, $cD1qu.PageMode).VIEW && ((0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_width_ld') || (0, $6mKj3.expValEquals)('confluence_unify_footer_comments_space_width', 'isEnabled', true))) return {
        width: '100%',
        maxWidth: hasEndOfPageRecommendations && (0, $6mKj3.expValEquals)('confluence_ai_related_content_for_live_pages', 'isEnabled', true) ? endOfPageRecommendationsMaxWidth : '100%'
    };
    // Base case: when the fg for the current pageMode isn't ON, i.e. either of:
    // - pageMode === PageMode.VIEW && !fg('confluence_frontend_unify_footer_comment_width') && !expValEquals('confluence_unify_footer_comments_space_width', 'isEnabled', true)
    // - pageMode !== PageMode.VIEW && !fg('confluence_frontend_unify_footer_comment_width_ld') && !expValEquals('confluence_unify_footer_comments_space_width', 'isEnabled', true)
    // This block can be removed entirely once both fgs are rolled out.
    let maxWidth = '100%';
    if (pageWidthType) maxWidth = JSON.parse(pageWidthType) === (0, $1d2ww.ContentAppearanceType).DEFAULT ? '1000px' : 'unset';
    return {
        width: '100%',
        maxWidth: maxWidth
    };
};
module.exports["CREATE_COMMENT_SELECTION_CLASS"] = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
module.exports["HIGHLIGHT_CLASS"] = $a78c261c3211f7d6$export$b803c692fbaaa5a4;
module.exports["ACTIVE_CLASS"] = $a78c261c3211f7d6$export$fb3d0eebfe85522a;
module.exports["getCommentIndexAndCount"] = $a78c261c3211f7d6$export$b899b07e3f725968;
module.exports["getInlineMarkSelector"] = $a78c261c3211f7d6$export$8c7b048437c01388;
module.exports["getMarkerRef"] = $a78c261c3211f7d6$export$8f4213b45c05ab5d;
module.exports["getSortedMarkerRefs"] = $a78c261c3211f7d6$export$9b48c18cc387f791;
module.exports["clearActiveHighlight"] = $a78c261c3211f7d6$export$f7ceeb7ba8156450;
module.exports["getNextTextNode"] = $a78c261c3211f7d6$export$3e98291f1f032a77;
module.exports["getHighlightOffset"] = $a78c261c3211f7d6$export$739c145b6a07c076;
module.exports["getHighlightFromMarkerRef"] = $a78c261c3211f7d6$export$21445ab787d3b446;
module.exports["calculateElementOffset"] = $a78c261c3211f7d6$export$331805bfbe18b1c0;
module.exports["resetTemporaryDOMHighlight"] = $a78c261c3211f7d6$export$743373b19993e2b0;
module.exports["convertDOMHighlightToMark"] = $a78c261c3211f7d6$export$a160a5110cbadcb8;
module.exports["setCommentAsActive"] = $a78c261c3211f7d6$export$fd55463aeed84830;
module.exports["removeMarkInDOM"] = $a78c261c3211f7d6$export$a26c4eafef12029f;
module.exports["isEmptyAdf"] = $a78c261c3211f7d6$export$915f03d46d87bfd4;
module.exports["getFocusableElementFromMarkerRef"] = $a78c261c3211f7d6$export$c36aa9f15eddb765;
module.exports["keyPropagationList"] = $a78c261c3211f7d6$export$6d23af9d8c2844b1;
module.exports["scrollToElementWithViewingRoom"] = $a78c261c3211f7d6$export$fc9b5eebad60b835;
module.exports["scrollCommentIntoView"] = $a78c261c3211f7d6$export$c7436bd0a15f3e7e;
module.exports["getNodeForTableORMacro"] = $a78c261c3211f7d6$export$ee0755cb593feed6;
module.exports["checkElementExpand"] = $a78c261c3211f7d6$export$876171b9c9b54aab;
module.exports["getSidebarId"] = $a78c261c3211f7d6$export$fb40c5e75b82df8;
module.exports["isFirstTabbableElement"] = $a78c261c3211f7d6$export$642e21ba866d02df;
module.exports["isLastTabbableElement"] = $a78c261c3211f7d6$export$876aeb5dffd449af;
module.exports["focusElementAndUpdateTabIndex"] = $a78c261c3211f7d6$export$cfa8eefe354167cd;
module.exports["scrollToComment"] = $a78c261c3211f7d6$export$db9eae89818590a4;
module.exports["checkElementExpandMultiLevelCommon"] = $a78c261c3211f7d6$export$1a2319f5c2109ee1;
module.exports["getNextMarkerRef"] = $a78c261c3211f7d6$export$187f977414e8342c;
module.exports["getNextUnreadThreadKey"] = $a78c261c3211f7d6$export$883ebc059dd86e88;
module.exports["copyToClipboard"] = $a78c261c3211f7d6$export$2cdf1b96a9f86d16;
module.exports["calculateEditorOffsetFromParent"] = $a78c261c3211f7d6$export$ab567600730c0b3b;
module.exports["calculateRendererOffsetFromParent"] = $a78c261c3211f7d6$export$3cdeee3ea1732782;
module.exports["getCommentPositionTopOfSectionEditor"] = $a78c261c3211f7d6$export$9f8164812b21bc7a;
module.exports["getCommentPositionTopOfSectionRenderer"] = $a78c261c3211f7d6$export$e3a17b46d43aa5f6;
module.exports["watchForCommentContainerAndScroll"] = $a78c261c3211f7d6$export$b3ba907d5759e257;
module.exports["watchForCommentRepliesAndScroll"] = $a78c261c3211f7d6$export$b1b7c9bcc75c855d;
module.exports["shouldScrollCommentThreadToTop"] = $a78c261c3211f7d6$export$4d211f4974dcf196;
module.exports["isCommentThreadReplyOutOfView"] = $a78c261c3211f7d6$export$9c5b7a3c864ae31b;
module.exports["getWidthAndMaxWidth"] = $a78c261c3211f7d6$export$e3c287b6d80b16ce;

});

parcelRegister("fNzRA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $en1dX = parcelRequire("en1dX");


var $irVI7 = parcelRequire("irVI7");


var $8Ss4E = parcelRequire("8Ss4E");


var $bQm3c = parcelRequire("bQm3c");

var $7b4a2f6cc35c72e1$export$94f8d08c2312472b = /*#__PURE__*/ function(AddFooterCommentMode) {
    AddFooterCommentMode["FOOTER"] = "footer";
    // The footer comments section
    AddFooterCommentMode["STICKY_DRAFT"] = "sticky_draft";
    // The sticky draft that persists outside of the footer
    AddFooterCommentMode["STICKY_FOOTER"] = "sticky_footer";
    return AddFooterCommentMode;
}({});
const $7b4a2f6cc35c72e1$export$8a175172a11240d4 = /*#__PURE__*/ (0, $cozmU.createContext)({
    expandCommentContainer: ()=>{},
    closeCommentContainer: ()=>{},
    setWrapperWidth: ()=>{},
    setIsObjectCommentWrapperVisible: ()=>{},
    setFooterEditorEntry: ()=>{}
});
$7b4a2f6cc35c72e1$export$8a175172a11240d4.displayName = 'ObjectCommentDispatchContext';
const $7b4a2f6cc35c72e1$export$358734f355c08965 = /*#__PURE__*/ (0, $cozmU.createContext)({
    expanded: false,
    footerEditorEntry: undefined,
    width: undefined,
    isObjectCommentWrapperVisible: false
});
$7b4a2f6cc35c72e1$export$358734f355c08965.displayName = 'ObjectCommentContext';
const $7b4a2f6cc35c72e1$export$d248a0e4aca56201 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { children: children } = t0;
    const [expanded, setExpanded] = (0, $cozmU.useState)(false);
    const [footerEditorEntry, setFooterEditorEntry] = (0, $cozmU.useState)(undefined);
    const [width, setWidth] = (0, $cozmU.useState)(undefined);
    const [isObjectCommentWrapperVisible, setIsObjectCommentWrapperVisible] = (0, $cozmU.useState)(false);
    const { edition: edition, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isGuest = accessStatus === "EXTERNAL_COLLABORATOR_ACCESS";
    let t1;
    if ($[0] !== expanded || $[1] !== footerEditorEntry || $[2] !== isObjectCommentWrapperVisible || $[3] !== width) {
        t1 = {
            expanded: expanded,
            footerEditorEntry: footerEditorEntry,
            width: width,
            isObjectCommentWrapperVisible: isObjectCommentWrapperVisible
        };
        $[0] = expanded;
        $[1] = footerEditorEntry;
        $[2] = isObjectCommentWrapperVisible;
        $[3] = width;
        $[4] = t1;
    } else t1 = $[4];
    const providerValue = t1;
    let t2;
    if ($[5] !== edition || $[6] !== isGuest) {
        t2 = (props)=>{
            const { entryPoint: entryPoint } = props ?? {};
            if (entryPoint) (0, $8Ss4E.startEditorExperiences)({
                name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                attributes: {
                    editor: "FABRIC",
                    isSingleExperience: true,
                    edition: edition,
                    source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                    entryPoint: entryPoint,
                    isGuest: isGuest
                }
            }, {
                name: (0, $irVI7.ADD_PAGE_COMMENT_LOAD_EXPERIENCE)
            }, {
                name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE)
            });
            setExpanded(true);
        };
        $[5] = edition;
        $[6] = isGuest;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    let t4;
    let t5;
    let t6;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setFooterEditorEntry(undefined);
            setExpanded(false);
        };
        t4 = (width_0)=>{
            setWidth(width_0 ? `${width_0}px` : "100%");
        };
        t5 = (visible)=>{
            setIsObjectCommentWrapperVisible(visible);
        };
        t6 = (footerEditorEntry_0)=>{
            setFooterEditorEntry(footerEditorEntry_0);
        };
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
        $[11] = t6;
    } else {
        t3 = $[8];
        t4 = $[9];
        t5 = $[10];
        t6 = $[11];
    }
    let t7;
    if ($[12] !== t2) {
        t7 = {
            expandCommentContainer: t2,
            closeCommentContainer: t3,
            setWrapperWidth: t4,
            setIsObjectCommentWrapperVisible: t5,
            setFooterEditorEntry: t6
        };
        $[12] = t2;
        $[13] = t7;
    } else t7 = $[13];
    const dispatchProviderValue = t7;
    let t8;
    if ($[14] !== children || $[15] !== dispatchProviderValue) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7b4a2f6cc35c72e1$export$8a175172a11240d4.Provider, {
            value: dispatchProviderValue
        }, children);
        $[14] = children;
        $[15] = dispatchProviderValue;
        $[16] = t8;
    } else t8 = $[16];
    let t9;
    if ($[17] !== providerValue || $[18] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7b4a2f6cc35c72e1$export$358734f355c08965.Provider, {
            value: providerValue
        }, t8);
        $[17] = providerValue;
        $[18] = t8;
        $[19] = t9;
    } else t9 = $[19];
    return t9;
} : ({ children: children })=>{
    const [expanded, setExpanded] = (0, $cozmU.useState)(false);
    const [footerEditorEntry, setFooterEditorEntry] = (0, $cozmU.useState)(undefined);
    const [width, setWidth] = (0, $cozmU.useState)(undefined);
    const [isObjectCommentWrapperVisible, setIsObjectCommentWrapperVisible] = (0, $cozmU.useState)(false);
    const { edition: edition, accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isGuest = accessStatus === 'EXTERNAL_COLLABORATOR_ACCESS';
    const providerValue = (0, $cozmU.useMemo)(()=>({
            expanded: expanded,
            footerEditorEntry: footerEditorEntry,
            width: width,
            isObjectCommentWrapperVisible: isObjectCommentWrapperVisible
        }), [
        expanded,
        footerEditorEntry,
        width,
        isObjectCommentWrapperVisible
    ]);
    const dispatchProviderValue = (0, $cozmU.useMemo)(()=>({
            expandCommentContainer: (props)=>{
                const { entryPoint: entryPoint } = props ?? {};
                if (entryPoint) (0, $8Ss4E.startEditorExperiences)({
                    name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                    attributes: {
                        editor: 'FABRIC',
                        isSingleExperience: true,
                        edition: edition,
                        source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                        entryPoint: entryPoint,
                        isGuest: isGuest
                    }
                }, {
                    name: (0, $irVI7.ADD_PAGE_COMMENT_LOAD_EXPERIENCE)
                }, {
                    name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE)
                });
                setExpanded(true);
            },
            closeCommentContainer: ()=>{
                setFooterEditorEntry(undefined);
                setExpanded(false);
            },
            setWrapperWidth: (width_0)=>{
                setWidth(width_0 ? `${width_0}px` : '100%');
            },
            setIsObjectCommentWrapperVisible: (visible)=>{
                setIsObjectCommentWrapperVisible(visible);
            },
            setFooterEditorEntry: (footerEditorEntry_0)=>{
                setFooterEditorEntry(footerEditorEntry_0);
            }
        }), [
        setExpanded,
        setFooterEditorEntry,
        setWidth,
        setIsObjectCommentWrapperVisible,
        edition,
        isGuest
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7b4a2f6cc35c72e1$export$358734f355c08965.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7b4a2f6cc35c72e1$export$8a175172a11240d4.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $7b4a2f6cc35c72e1$export$da430766ddf17a6b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($7b4a2f6cc35c72e1$export$358734f355c08965);
} : ()=>{
    return (0, $cozmU.useContext)($7b4a2f6cc35c72e1$export$358734f355c08965);
};
const $7b4a2f6cc35c72e1$export$8ba3235fe153fa01 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($7b4a2f6cc35c72e1$export$8a175172a11240d4);
} : ()=>{
    return (0, $cozmU.useContext)($7b4a2f6cc35c72e1$export$8a175172a11240d4);
};
module.exports["AddFooterCommentMode"] = $7b4a2f6cc35c72e1$export$94f8d08c2312472b;
module.exports["ObjectCommentProvider"] = $7b4a2f6cc35c72e1$export$d248a0e4aca56201;
module.exports["useObjectCommentContext"] = $7b4a2f6cc35c72e1$export$da430766ddf17a6b;
module.exports["useObjectCommentDispatchContext"] = $7b4a2f6cc35c72e1$export$8ba3235fe153fa01;

});

parcelRegister("en1dX", function(module, exports) {
var $88e03e673e36ecc4$export$6890652a1aff7d1c = /*#__PURE__*/ function(AnalyticsSource) {
    AnalyticsSource["COMMENTS_PANEL"] = "commentsPanel";
    AnalyticsSource["STANDALONE"] = "standalone";
    AnalyticsSource["PAGE_FOOTER"] = "pageFooter";
    return AnalyticsSource;
}({});
var $88e03e673e36ecc4$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["REOPEN_COMMENT"] = "reopenComment";
    return ActionName;
}({});
var $88e03e673e36ecc4$export$ffa1150e6a48f9cd = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    CommentType["PAGE"] = "page";
    return CommentType;
}({});
module.exports["AnalyticsSource"] = $88e03e673e36ecc4$export$6890652a1aff7d1c;
module.exports["ActionName"] = $88e03e673e36ecc4$export$9c95d6e1614bad84;
module.exports["CommentType"] = $88e03e673e36ecc4$export$ffa1150e6a48f9cd;

});

parcelRegister("9jl6v", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $cozmU = parcelRequire("cozmU");


var $l0zDh = parcelRequire("l0zDh");


var $aHcFH = parcelRequire("aHcFH");


var $9FoVw = parcelRequire("9FoVw");


var $i49vP = parcelRequire("i49vP");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");

const $427c50c01d3953e2$export$87eb11c3f8007b3b = /*#__PURE__*/ (0, $cozmU.createContext)({
    createComment: ()=>{},
    clearCreateHighlight: ()=>{},
    onHighlightClick: ()=>{},
    toggleSidebar: ()=>{},
    setResolvedComment: ()=>{},
    setActiveHighlight: ()=>{},
    navigateToInlineComment: ()=>{}
});
$427c50c01d3953e2$export$87eb11c3f8007b3b.displayName = 'InlineCommentsDispatchContext';
const $427c50c01d3953e2$export$e6352a1cdc05c52c = /*#__PURE__*/ (0, $cozmU.createContext)({
    newCommentHighlight: undefined,
    highlightOrigin: 'userHighlight',
    activeHighlight: null,
    firstHighlightClicked: false,
    shouldDisplaySidebar: false,
    resolvedComment: null
});
$427c50c01d3953e2$export$e6352a1cdc05c52c.displayName = 'InlineCommentsContext';
const $427c50c01d3953e2$export$f54686667fb05777 = ({ children: children })=>{
    const [newCommentHighlight, setNewCommentHighlight] = (0, $cozmU.useState)();
    const [highlightOrigin, setHighlightOrigin] = (0, $cozmU.useState)('userHighlight');
    /**
   * We eventually want this value to be the official state for loading/displaying
   * the UI for inline comments. InlineCommentSidebar and some child components have created
   * stateful logic (active highlight, isSidebarShown, etc) that assumes
   * the code is always loaded which we will eventually adjust.
   */ const [shouldDisplaySidebar, setShouldDisplaySidebar] = (0, $cozmU.useState)(false);
    const firstHighlightClicked = (0, $cozmU.useRef)(false);
    const [activeHighlight, setActiveHighlight] = (0, $cozmU.useState)(null);
    const [resolvedComment, setResolvedComment] = (0, $cozmU.useState)(null);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const providerValue = (0, $cozmU.useMemo)(()=>({
            newCommentHighlight: newCommentHighlight,
            highlightOrigin: highlightOrigin,
            activeHighlight: activeHighlight,
            resolvedComment: resolvedComment,
            firstHighlightClicked: firstHighlightClicked.current,
            shouldDisplaySidebar: shouldDisplaySidebar
        }), [
        activeHighlight,
        highlightOrigin,
        newCommentHighlight,
        resolvedComment,
        shouldDisplaySidebar,
        firstHighlightClicked
    ]);
    const dispatchProviderValue = (0, $cozmU.useMemo)(()=>({
            createComment: (newHighlight, origin = 'userHighlight')=>{
                /**
       * Creating a comment is one of the three user explicit scenarios
       * where we want to load inline comments code.
       */ setShouldDisplaySidebar(true);
                setNewCommentHighlight(newHighlight);
                setHighlightOrigin(origin);
                if (resolvedComment) setResolvedComment(null);
            },
            clearCreateHighlight: ()=>setNewCommentHighlight(undefined),
            onHighlightClick: (markerRef)=>{
                if (!firstHighlightClicked.current) firstHighlightClicked.current = true;
                /**
       * Clicking on a highlight is one of the three user explicit scenarios
       * where we want to load inline comments code.
       */ if (markerRef) setShouldDisplaySidebar(true);
                else setShouldDisplaySidebar(false);
                setActiveHighlight(markerRef);
            },
            setResolvedComment: setResolvedComment,
            toggleSidebar: (shouldDisplay)=>setShouldDisplaySidebar(shouldDisplay),
            setActiveHighlight: setActiveHighlight,
            navigateToInlineComment: ({ action: action, triggeredByKeyboardShortcut: triggeredByKeyboardShortcut, currentCommentIndex: currentCommentIndex, onNavigationClick: onNavigationClick, getCommentIndex: getCommentIndex, isEditor: isEditor, removeCommentQueryParams: removeCommentQueryParams, unresolvedInlineComments: unresolvedInlineComments, createAnalyticsEvent: createAnalyticsEvent, contentId: contentId, isNavigateToNextUnread: isNavigateToNextUnread, unreadInlineComments: unreadInlineComments = [], unreadGeneralComments: unreadGeneralComments = [], footerComments: footerComments = [], scrollToFooterComment: scrollToFooterComment, commentsDataMap: commentsDataMap })=>{
                (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                    navigationAction: action
                });
                const couldBeNavigatingToFooterComment = triggeredByKeyboardShortcut && footerComments?.length > 0;
                if (unresolvedInlineComments?.length < 2 && !couldBeNavigatingToFooterComment) {
                    (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.abort({
                        abortReason: 'Comment navigation when only one comment'
                    });
                    experienceTracker.abort({
                        name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                        reason: 'Comment navigation when only one comment',
                        checkForTimeout: true,
                        publishDebugPoints: true,
                        attributes: {
                            stopPoint: 'comment-context/InlineCommentsContext'
                        }
                    });
                    return;
                }
                // Clear the focusedCommentId queryParams so that reply does not opens up if any...
                removeCommentQueryParams();
                const combinedInlineFooterComments = [
                    ...unresolvedInlineComments,
                    ...footerComments
                ];
                let nextThreadKey = '';
                let currentThreadKey = '';
                if (triggeredByKeyboardShortcut) {
                    if (isNavigateToNextUnread) {
                        // Add 1 to currentCommentIndex to move to the next comment, otherwise it gets stuck on the current comment
                        const nextIndex = currentCommentIndex + 1;
                        nextThreadKey = (0, $aHcFH.getNextUnreadThreadKey)(nextIndex, combinedInlineFooterComments, [
                            ...unreadInlineComments,
                            ...unreadGeneralComments
                        ]) ?? '';
                    } else nextThreadKey = (0, $aHcFH.getNextMarkerRef)(action, currentCommentIndex, combinedInlineFooterComments) ?? '';
                    currentThreadKey = combinedInlineFooterComments[currentCommentIndex];
                } else {
                    nextThreadKey = (0, $aHcFH.getNextMarkerRef)(action, currentCommentIndex, unresolvedInlineComments) ?? '';
                    currentThreadKey = unresolvedInlineComments[currentCommentIndex];
                }
                if (!nextThreadKey) {
                    (0, $4EKKB.selectInlineComment).debug(`Couldn't find next annotation to select in document`);
                    return;
                }
                (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                    annotationId: nextThreadKey
                });
                if (triggeredByKeyboardShortcut) {
                    if (footerComments.includes(nextThreadKey) && scrollToFooterComment && commentsDataMap?.general?.[nextThreadKey]) {
                        setActiveHighlight(null);
                        scrollToFooterComment(nextThreadKey);
                        (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.abort({
                            abortReason: 'Navigating to general comment'
                        });
                        return;
                    }
                }
                const nextCommentElement = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.getElementById(nextThreadKey) || // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.getElementById(`footer-comment-thread-${nextThreadKey}-container`);
                if (nextCommentElement) (0, $i49vP.checkElementExpandInEditor)(nextCommentElement);
                else (0, $4EKKB.selectInlineComment).debug('No annotation found in doc to check if in expand');
                onNavigationClick(nextThreadKey);
                const nextCommentIndex = getCommentIndex(nextThreadKey);
                const enableOnArrowNavigation = !triggeredByKeyboardShortcut;
                // Handle scrolling navigation
                if (enableOnArrowNavigation) (0, $9FoVw.handleInlineHeaderArrowsNavigation)({
                    previousMarkerRef: currentThreadKey,
                    nextMarkerRef: nextThreadKey,
                    context: isEditor ? (0, $9FoVw.NavigationContext).EDITOR : (0, $9FoVw.NavigationContext).RENDERER,
                    action: action,
                    nextCommentIndex: nextCommentIndex,
                    totalComments: unresolvedInlineComments.length
                });
                if (nextCommentElement) {
                    // As we navigate inline comments with arrow icons, we want to update the cursor location to where the open inline comment is
                    // unless it is a media node in which case, we want our selection to be the media node element.
                    const media = nextCommentElement.querySelector(`.${(0, $l0zDh.ClassNames).MEDIA_CONTAINER}`);
                    if (media) {
                        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                            commentType: 'block',
                            blockType: 'media'
                        });
                        enableOnArrowNavigation && window.getSelection()?.setPosition(media);
                    } else {
                        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                            commentType: 'inline'
                        });
                        enableOnArrowNavigation && window.getSelection()?.setPosition(nextCommentElement);
                    }
                }
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'navigate',
                        actionSubjectId: 'inlineCommentArrowsNavigate',
                        attributes: {
                            triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
                            action: action
                        },
                        objectType: 'inlineComment',
                        objectId: contentId,
                        source: isEditor ? 'editPageScreen' : 'renderPageScreen'
                    }
                }).fire();
            }
        }), [
        resolvedComment,
        firstHighlightClicked,
        setShouldDisplaySidebar,
        setHighlightOrigin,
        setResolvedComment,
        setActiveHighlight,
        experienceTracker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($427c50c01d3953e2$export$e6352a1cdc05c52c.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($427c50c01d3953e2$export$87eb11c3f8007b3b.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $427c50c01d3953e2$export$89bc450b4e1563a9 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($427c50c01d3953e2$export$e6352a1cdc05c52c);
} : ()=>{
    return (0, $cozmU.useContext)($427c50c01d3953e2$export$e6352a1cdc05c52c);
};
const $427c50c01d3953e2$export$43e36990fc9d516b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($427c50c01d3953e2$export$87eb11c3f8007b3b);
} : ()=>{
    return (0, $cozmU.useContext)($427c50c01d3953e2$export$87eb11c3f8007b3b);
};
module.exports["InlineCommentsProvider"] = $427c50c01d3953e2$export$f54686667fb05777;
module.exports["useInlineCommentsContext"] = $427c50c01d3953e2$export$89bc450b4e1563a9;
module.exports["useInlineCommentsDispatchContext"] = $427c50c01d3953e2$export$43e36990fc9d516b;

});

parcelRegister("dkkKv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $7Sm4c = parcelRequire("7Sm4c");


var $bQm3c = parcelRequire("bQm3c");


var $aSsfA = parcelRequire("aSsfA");


var $htsj6 = parcelRequire("htsj6");


var $aqBZ0 = parcelRequire("aqBZ0");


var $9rE3H = parcelRequire("9rE3H");


var $b1hSc = parcelRequire("b1hSc");


var $8i27m = parcelRequire("8i27m");


var $3ZsvI = parcelRequire("3ZsvI");

const $7c240d799ee287c0$export$1369688a638bab5e = ({ pageId: pageId, skip: skip = false, type: type, onCompletedFn: onCompletedFn, returnNativeLoading: returnNativeLoading = false, useStableCommentsDataUpdates: // Doing this in the useEffect has slightly different behavior than the native graphQL query, this lets us choose which behavior we want
useStableCommentsDataUpdates = false, fetchPolicy: fetchPolicy, isPreload: isPreload = false })=>{
    // The query loading was not sticking around long enough or triggering at the right times
    // so I created a loading state that will set after the query is successful/fails
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [{ commentsDataMap: commentsDataMap, cacheUpdateFailed: cacheUpdateFailed }, { addNewCommentThreads: addNewCommentThreads, setCommentsDataMap: setCommentsDataMap, setFooterCommentsLoadingState: setFooterCommentsLoadingState }] = (0, $8i27m.useCommentsData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { userId: currentUserId } = (0, $bQm3c.useSessionData)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    // Determine if the query should be skipped
    const skipQuery = !pageId || skip;
    const hasAlreadyFetchedInitialData = Object.keys(commentsDataMap.inline).length > 0 || Object.keys(commentsDataMap.general).length > 0;
    // Check if the page is archived
    const isArchived = contentStatus === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED);
    // Using preload variables isn't 100% necessary since we write to the full cache,
    // but should be more stable in the event the full cache update fails
    const queryVariables = isPreload ? (0, $9rE3H.buildConsistentActiveCommentsQueryPreloadVariables)(pageId, isArchived) : (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
        pageId: pageId,
        type: type,
        isArchived: isArchived
    });
    const cacheUpdateFailedFetchPolicy = cacheUpdateFailed ? 'network-only' : undefined;
    const defaultFetchPolicy = skipQuery || isPreload ? 'cache-only' : 'cache-and-network'; // TODO: Cache and network probably not perfect, used to ensure consistency on the panel
    // Execute the query
    const { data: data, loading: queryLoading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $b1hSc.default), {
        variables: queryVariables,
        // Skip is not respected after the initial call: https://github.com/apollographql/apollo-client/issues/6190#issuecomment-649933628
        fetchPolicy: fetchPolicy || cacheUpdateFailedFetchPolicy || defaultFetchPolicy,
        skip: skipQuery,
        onCompleted: (result)=>{
            // onCompleted doesn't fire as expected after multiple cache reads
            if (!useStableCommentsDataUpdates && result) {
                (0, $3ZsvI.updateCommentsDataState)({
                    data: result,
                    updateData: hasAlreadyFetchedInitialData ? addNewCommentThreads : setCommentsDataMap,
                    pageMode: pageMode,
                    currentUserId: currentUserId ?? '',
                    isOpen: true
                });
                if (!skipQuery) // Don't update loading state if the query is skipped
                // onCompleted will still get called in some circumstances with skip = true
                (0, $3ZsvI.updateFooterCommentsLoadingState)(data, setFooterCommentsLoadingState);
            }
            setLoading(false);
            if (result) onCompletedFn && onCompletedFn();
        },
        onError: undefined,
        errorPolicy: 'all',
        __callerPackage__: "comments-data"
    });
    (0, $cozmU.useEffect)(()=>{
        if (error) {
            // If the error is related to reactionsSummary returning null, just mark it handled
            // or if the error is related to cc-pages not being reachable, just mark it handled
            if (error.message.search(/reactions/i) !== -1 || error.message.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
            setLoading(false);
        }
    }, [
        error
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (queryLoading) setLoading(true);
    }, [
        queryLoading
    ]);
    let returnLoading = queryLoading;
    // If we're not returning the native loading out of apollo, update returnLoading to our tracked version
    if (!returnNativeLoading) returnLoading = !skipQuery ? loading : false;
    // We set totalCount to ACTIVE_COMMENTS_QUERY_PRELOAD_LOADING_FLAG when preload is loading
    // We should respect this regardless of context, since the query really is loading behind the scenes
    const isPreloadLoading = data?.comments?.totalCount === (0, $9rE3H.ACTIVE_COMMENTS_QUERY_PRELOAD_LOADING_FLAG);
    returnLoading = isPreloadLoading || returnLoading;
    (0, $cozmU.useEffect)(()=>{
        // onCompleted gets fired on the first cache-read only, which as you can imagine causes a lot of race conditions during transition
        // This is the recommended way to deal with complex scenarios involving cache + network reads
        // onCompleted will also fire incorrectly for concurrent calls on the same page, since it has an outdated copy of hasAlreadyFetchedInitialData telescoped in before some calls complete
        if (!skipQuery && isPreloadLoading) // Mark this as preloading to prevent race conditions where loading is not yet set in caller
        setFooterCommentsLoadingState((0, $8i27m.FooterCommentsLoadingStateType).PRELOADING);
        if (useStableCommentsDataUpdates && !isPreloadLoading && !skipQuery && data) {
            // Preload updates data, which we don't want
            (0, $3ZsvI.updateCommentsDataState)({
                data: data,
                updateData: hasAlreadyFetchedInitialData ? addNewCommentThreads : setCommentsDataMap,
                pageMode: pageMode,
                currentUserId: currentUserId ?? '',
                isOpen: true
            });
            // Don't update loading state if the query is skipped
            (0, $3ZsvI.updateFooterCommentsLoadingState)(data, setFooterCommentsLoadingState);
        }
    }, [
        data,
        useStableCommentsDataUpdates,
        hasAlreadyFetchedInitialData,
        addNewCommentThreads,
        setCommentsDataMap,
        pageMode,
        currentUserId,
        skipQuery,
        type,
        setFooterCommentsLoadingState,
        isPreloadLoading
    ]);
    return {
        loading: returnLoading,
        data: // If we skip the query make sure loading is false
        data,
        error: error,
        refetch: refetch
    };
};
module.exports["useActiveCommentsQuery"] = $7c240d799ee287c0$export$1369688a638bab5e;

});

parcelRegister("aqBZ0", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $1f65bcd6ebccf55c$export$41b2e06f27dfe96e = 'archived';
const $1f65bcd6ebccf55c$export$e2153f1ee0381860 = 'ARCHIVE_';
const $1f65bcd6ebccf55c$export$c8e98879124fb1f0 = 'UNARCHIVE_';
const $1f65bcd6ebccf55c$export$781b73bccf46ba2c = 255;
const $1f65bcd6ebccf55c$export$ab874a69c0b17d25 = 500;
var $1f65bcd6ebccf55c$export$ca079fdb822b790f = /*#__PURE__*/ function(ArchiveStatus) {
    ArchiveStatus["LOADING"] = "loading";
    ArchiveStatus["ERROR"] = "error";
    ArchiveStatus["SUCCESS"] = "success";
    return ArchiveStatus;
}({});
const $1f65bcd6ebccf55c$export$90622b83e51be397 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
const $1f65bcd6ebccf55c$export$a2742df05b19b873 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/#When-content-is-inheriting-restrictions-from-parent-content';
const $1f65bcd6ebccf55c$export$9de02bef22980fc = 'https://support.atlassian.com/confluence-cloud/docs/archive-pages/#Who-can-archive-an-item';
const $1f65bcd6ebccf55c$export$45c8fb669461b6d5 = 'https://support.atlassian.com/confluence-cloud/docs/restore-archived-pages-to-the-page-tree/#Who-can-restore-an-item';
const $1f65bcd6ebccf55c$export$f71e45bebd610efa = 'archivedPageBanner';
const $1f65bcd6ebccf55c$export$7d669dd29a0917b2 = 'archive-page-banner-restore-link';
const $1f65bcd6ebccf55c$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    restoreLinkMessage: {
        id: "archive-pages.page-banner.link.unarchive",
        defaultMessage: "Restore"
    },
    learnMoreLinkMessage: {
        id: "archive-pages.page-banner.link.learn-more",
        defaultMessage: "Learn more"
    },
    hasRestoreContentPermissionBannerMessage: {
        id: "archive-pages.content-banner.message-restorable",
        defaultMessage: "This content is archived. Restore to make changes."
    },
    noRestoreContentPermissionBannerMessage: {
        id: "archive-pages.content-banner.message-unrestorable",
        defaultMessage: "This content is archived."
    }
});
module.exports["CONTENT_STATUS_ARCHIVED"] = $1f65bcd6ebccf55c$export$41b2e06f27dfe96e;
module.exports["ARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$e2153f1ee0381860;
module.exports["UNARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$c8e98879124fb1f0;
module.exports["ARCHIVE_PAGES_WITH_NOTE_CHARACTER_LIMIT"] = $1f65bcd6ebccf55c$export$781b73bccf46ba2c;
module.exports["BULK_ARCHIVE_PAGE_SELECTION_LIMIT"] = $1f65bcd6ebccf55c$export$ab874a69c0b17d25;
module.exports["ArchiveStatus"] = $1f65bcd6ebccf55c$export$ca079fdb822b790f;
module.exports["PAGE_INHERITED_RESTRICTIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$a2742df05b19b873;
module.exports["ARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$9de02bef22980fc;
module.exports["UNARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$45c8fb669461b6d5;
module.exports["ARCHIVED_PAGE_BANNER_ANALYTICS_SOURCE"] = $1f65bcd6ebccf55c$export$f71e45bebd610efa;
module.exports["ARCHIVED_PAGE_BANNER_RESTORE_LINK_TESTID"] = $1f65bcd6ebccf55c$export$7d669dd29a0917b2;
module.exports["i18n"] = $1f65bcd6ebccf55c$export$a7357cdd1f0b0168;

});

parcelRegister("9rE3H", function(module, exports) {
const $5b808dc3cc2fdcb5$export$3816ffab97d6707 = 3;
const $5b808dc3cc2fdcb5$export$c2458e66b06ab105 = -1; // We can't do cache.evict based on apollo version, so use -1 as a flag
const $5b808dc3cc2fdcb5$export$ed108990552755bd = 2000;
const $5b808dc3cc2fdcb5$export$37f798be419840d9 = (contentId, isArchived)=>{
    return {
        pageId: contentId,
        contentStatus: [
            isArchived ? 'ARCHIVED' : 'CURRENT',
            'DRAFT'
        ],
        type: [
            'FOOTER'
        ],
        first: $5b808dc3cc2fdcb5$export$3816ffab97d6707
    };
};
const $5b808dc3cc2fdcb5$export$aebda4267d7ff0ef = ({ pageId: pageId, type: type, isArchived: isArchived = false })=>{
    return {
        pageId: pageId,
        contentStatus: [
            isArchived ? 'ARCHIVED' : 'CURRENT',
            'DRAFT'
        ],
        first: $5b808dc3cc2fdcb5$export$ed108990552755bd,
        ...type && {
            type: [
                type
            ]
        }
    };
};
module.exports["ACTIVE_COMMENTS_QUERY_PRELOAD_LOADING_FLAG"] = $5b808dc3cc2fdcb5$export$c2458e66b06ab105;
module.exports["buildConsistentActiveCommentsQueryPreloadVariables"] = $5b808dc3cc2fdcb5$export$37f798be419840d9;
module.exports["buildConsistentActiveCommentsQueryVariables"] = $5b808dc3cc2fdcb5$export$aebda4267d7ff0ef;

});

parcelRegister("b1hSc", function(module, exports) {
/**
 * @generated SignedSource<<df78531541631ab4c7caa75da707783f>>
 * @relayHash 51e15b77790c5d8cdaef4df99503fbf3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ec4e8503cac8503ab97b9d5696225ef01a65c63685ff47bcda76917fd8a9386
const $4bf9442691f65266$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "type"
    }, v4 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v5 = [
        {
            "fields": [
                {
                    "kind": "Literal",
                    "name": "commentState",
                    "value": "UNRESOLVED"
                },
                {
                    "kind": "Variable",
                    "name": "commentType",
                    "variableName": "type"
                }
            ],
            "kind": "ObjectValue",
            "name": "confluenceCommentFilter"
        },
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ROOT"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v4 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "singleThreaded",
            "value": true
        },
        {
            "kind": "Variable",
            "name": "type",
            "variableName": "type"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v11 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v12 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    v6 /*: any*/ ,
                    v11 /*: any*/ 
                ],
                "type": "KnownUser"
            }
        ]
    }, v13 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v14 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v13 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v15 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v16 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v13 /*: any*/ 
    }, v17 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v18 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v19 = {
        "kind": "ScalarField",
        "name": "type"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v21 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v22 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v23 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v24 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v20 /*: any*/ ,
                    v21 /*: any*/ ,
                    v22 /*: any*/ ,
                    v23 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v23 /*: any*/ ,
                    v21 /*: any*/ ,
                    v20 /*: any*/ ,
                    v22 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v26 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v19 /*: any*/ ,
            v24 /*: any*/ ,
            v25 /*: any*/ 
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v28 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v29 = {
        "kind": "ScalarField",
        "name": "when"
    }, v30 = {
        "kind": "ScalarField",
        "name": "number"
    }, v31 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v8 /*: any*/ 
                ]
            },
            v29 /*: any*/ ,
            v30 /*: any*/ 
        ]
    }, v32 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v4 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v7 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v33 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v34 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    v11 /*: any*/ 
                ],
                "type": "KnownUser"
            }
        ]
    }, v35 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            v19 /*: any*/ ,
            v24 /*: any*/ ,
            v25 /*: any*/ 
        ]
    }, v36 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v6 /*: any*/ ,
                    v8 /*: any*/ 
                ]
            },
            v29 /*: any*/ ,
            v30 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ActiveCommentsQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v7 /*: any*/ ,
                                v12 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v26 /*: any*/ ,
                                v27 /*: any*/ ,
                                v28 /*: any*/ ,
                                v31 /*: any*/ ,
                                v32 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v31 /*: any*/ ,
                                        v32 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v33 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ActiveCommentsQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v7 /*: any*/ ,
                                v34 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v35 /*: any*/ ,
                                v27 /*: any*/ ,
                                v28 /*: any*/ ,
                                v36 /*: any*/ ,
                                v32 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v34 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v35 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v36 /*: any*/ ,
                                        v32 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v33 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "51e15b77790c5d8cdaef4df99503fbf3",
            "id": "3ec4e8503cac8503ab97b9d5696225ef01a65c63685ff47bcda76917fd8a9386",
            "metadata": {},
            "name": "ActiveCommentsQuery",
            "operationKind": "query",
            "text": "query ActiveCommentsQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$type:[CommentType],$first:Long)@allowHigherTimeout{comments(pageId:$pageId,contentStatus:$contentStatus,depth:ROOT,confluenceCommentFilter:{commentState:UNRESOLVED,commentType:$type},singleThreaded:true,type:$type,first:$first){__typename,nodes{id,author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{__typename,accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}},replies{id,author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{__typename,accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}},totalCount}}"
        }
    };
}();
$4bf9442691f65266$var$node.hash = "37d97577cf19b12ed92bf7d36576353c";
var $4bf9442691f65266$export$2e2bcd8739ae039 = $4bf9442691f65266$var$node;
module.exports["default"] = $4bf9442691f65266$export$2e2bcd8739ae039;

});

parcelRegister("cgy29", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aWwYt = parcelRequire("aWwYt");


var $cMvMc = parcelRequire("cMvMc");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $brNvA = parcelRequire("brNvA");


var $cZa7r = parcelRequire("cZa7r");


var $4DJgG = parcelRequire("4DJgG");

const $dacb5f0322f4a333$export$5ae138a5a05281f1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { contentId: contentId, isFabric: isFabric, sendKeyboardShortcutAnalytics: sendKeyboardShortcutAnalytics } = t0;
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setSelectionOptionsForCreateEditor: setSelectionOptionsForCreateEditor } = (0, $cZa7r.useAnnotationsDispatch)();
    const { createComment: createComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { commentToReattach: commentToReattach } = (0, $brNvA.useReattachComment)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const content = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            content.current = document.querySelector("div#content");
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[2] !== commentToReattach || $[3] !== contentId || $[4] !== createComment || $[5] !== hideObjectSidebar || $[6] !== isFabric || $[7] !== isObjectSidebarShown || $[8] !== setSelectionOptionsForCreateEditor) {
        t3 = (t4)=>{
            const { experienceAttributes: experienceAttributes } = t4 === undefined ? {} : t4;
            if (isObjectSidebarShown) hideObjectSidebar();
            if (isFabric) setSelectionOptionsForCreateEditor({
                experienceAttributes: experienceAttributes
            });
            else if (content.current) createComment((0, $4DJgG.getLegacyConvertedSelectionObj)({
                content: content,
                contentId: contentId,
                commentToReattach: commentToReattach
            }));
        };
        $[2] = commentToReattach;
        $[3] = contentId;
        $[4] = createComment;
        $[5] = hideObjectSidebar;
        $[6] = isFabric;
        $[7] = isObjectSidebarShown;
        $[8] = setSelectionOptionsForCreateEditor;
        $[9] = t3;
    } else t3 = $[9];
    const createReactInlineCommentHighlight = t3;
    let t4;
    if ($[10] !== createReactInlineCommentHighlight || $[11] !== hasContentChanged || $[12] !== sendKeyboardShortcutAnalytics) {
        const handleCommentButtonClick = (t5)=>{
            const { dialogs: dialogs, shortcut: shortcut, experienceAttributes: experienceAttributes_0 } = t5;
            if (hasContentChanged) dialogs.showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>createReactInlineCommentHighlight({
                        experienceAttributes: experienceAttributes_0
                    })
            });
            else createReactInlineCommentHighlight({
                experienceAttributes: experienceAttributes_0
            });
            if (shortcut) sendKeyboardShortcutAnalytics(shortcut);
        };
        t4 = {
            handleCommentButtonClick: handleCommentButtonClick
        };
        $[10] = createReactInlineCommentHighlight;
        $[11] = hasContentChanged;
        $[12] = sendKeyboardShortcutAnalytics;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : ({ contentId: contentId, isFabric: isFabric, sendKeyboardShortcutAnalytics: sendKeyboardShortcutAnalytics })=>{
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setSelectionOptionsForCreateEditor: setSelectionOptionsForCreateEditor } = (0, $cZa7r.useAnnotationsDispatch)();
    const { createComment: createComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { commentToReattach: commentToReattach } = (0, $brNvA.useReattachComment)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const content = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        content.current = document.querySelector('div#content');
    }, []);
    const createReactInlineCommentHighlight = ({ experienceAttributes: experienceAttributes } = {})=>{
        if (isObjectSidebarShown) hideObjectSidebar();
        if (isFabric) setSelectionOptionsForCreateEditor({
            experienceAttributes: experienceAttributes
        });
        else if (content.current) createComment((0, $4DJgG.getLegacyConvertedSelectionObj)({
            content: content,
            contentId: contentId,
            commentToReattach: commentToReattach
        }));
    };
    const handleCommentButtonClick = ({ dialogs: dialogs, shortcut: shortcut, experienceAttributes: experienceAttributes_0 })=>{
        if (hasContentChanged) dialogs.showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>createReactInlineCommentHighlight({
                    experienceAttributes: experienceAttributes_0
                })
        });
        else createReactInlineCommentHighlight({
            experienceAttributes: experienceAttributes_0
        });
        if (shortcut) sendKeyboardShortcutAnalytics(shortcut);
    };
    return {
        handleCommentButtonClick: handleCommentButtonClick
    };
};
module.exports["useCreateCommentAction"] = $dacb5f0322f4a333$export$5ae138a5a05281f1;

});

parcelRegister("brNvA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $2c05d1bead0fe3b6$export$fb4e7a383f5cb089 = /*#__PURE__*/ (0, $cozmU.createContext)({
    commentToReattach: null,
    reattachHighlight: null,
    isInReattachMode: ()=>false
});
$2c05d1bead0fe3b6$export$fb4e7a383f5cb089.displayName = 'ReattachCommentContext';
const $2c05d1bead0fe3b6$export$29a077948aa018ea = /*#__PURE__*/ (0, $cozmU.createContext)({
    setCommentToReattach: ()=>{},
    setReattachHighlight: ()=>{},
    clearReattachMode: ()=>{}
});
$2c05d1bead0fe3b6$export$fb4e7a383f5cb089.displayName = 'ReattachCommentDispatchContext';
const $2c05d1bead0fe3b6$export$eeb6c3345224df9d = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { children: children } = t0;
    const [commentToReattach, setCommentToReattach] = (0, $cozmU.useState)(null);
    const [reattachHighlight, setReattachHighlight] = (0, $cozmU.useState)(null);
    let t1;
    if ($[0] !== commentToReattach) {
        t1 = ()=>Boolean(commentToReattach);
        $[0] = commentToReattach;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== commentToReattach || $[3] !== reattachHighlight || $[4] !== t1) {
        t2 = {
            commentToReattach: commentToReattach,
            reattachHighlight: reattachHighlight,
            isInReattachMode: t1
        };
        $[2] = commentToReattach;
        $[3] = reattachHighlight;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    const providerValue = t2;
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            setCommentToReattach: setCommentToReattach,
            setReattachHighlight: (highlight)=>{
                setReattachHighlight(highlight?.numMatches !== 0 ? highlight : null);
            },
            clearReattachMode: ()=>{
                setCommentToReattach(null);
                setReattachHighlight(null);
            }
        };
        $[6] = t3;
    } else t3 = $[6];
    const dispatchProviderValue = t3;
    let t4;
    if ($[7] !== children) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2c05d1bead0fe3b6$export$29a077948aa018ea.Provider, {
            value: dispatchProviderValue
        }, children);
        $[7] = children;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== providerValue || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2c05d1bead0fe3b6$export$fb4e7a383f5cb089.Provider, {
            value: providerValue
        }, t4);
        $[9] = providerValue;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ children: children })=>{
    const [commentToReattach, setCommentToReattach] = (0, $cozmU.useState)(null);
    const [reattachHighlight, setReattachHighlight] = (0, $cozmU.useState)(null);
    const providerValue = (0, $cozmU.useMemo)(()=>({
            commentToReattach: commentToReattach,
            reattachHighlight: reattachHighlight,
            isInReattachMode: ()=>Boolean(commentToReattach)
        }), [
        commentToReattach,
        reattachHighlight
    ]);
    const dispatchProviderValue = (0, $cozmU.useMemo)(()=>({
            setCommentToReattach: setCommentToReattach,
            setReattachHighlight: (highlight)=>{
                setReattachHighlight(highlight?.numMatches !== 0 ? highlight : null);
            },
            clearReattachMode: ()=>{
                setCommentToReattach(null);
                setReattachHighlight(null);
            }
        }), [
        setCommentToReattach,
        setReattachHighlight
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2c05d1bead0fe3b6$export$fb4e7a383f5cb089.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2c05d1bead0fe3b6$export$29a077948aa018ea.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $2c05d1bead0fe3b6$export$d801c7a3a205f98e = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($2c05d1bead0fe3b6$export$fb4e7a383f5cb089);
} : ()=>{
    return (0, $cozmU.useContext)($2c05d1bead0fe3b6$export$fb4e7a383f5cb089);
};
const $2c05d1bead0fe3b6$export$344893016ba0bdd4 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($2c05d1bead0fe3b6$export$29a077948aa018ea);
} : ()=>{
    return (0, $cozmU.useContext)($2c05d1bead0fe3b6$export$29a077948aa018ea);
};
module.exports["ReattachCommentContext"] = $2c05d1bead0fe3b6$export$fb4e7a383f5cb089;
module.exports["ReattachCommentProvider"] = $2c05d1bead0fe3b6$export$eeb6c3345224df9d;
module.exports["useReattachComment"] = $2c05d1bead0fe3b6$export$d801c7a3a205f98e;
module.exports["useReattachCommentDispatch"] = $2c05d1bead0fe3b6$export$344893016ba0bdd4;

});

parcelRegister("4DJgG", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $7W8i8 = parcelRequire("7W8i8");


var $aUTn5 = parcelRequire("aUTn5");

const $917b9bb03b3149d5$var$logger = (0, $7W8i8.getLogger)('inline-comment');
const $917b9bb03b3149d5$export$dbde27c406dff8e8 = ({ content: content, contentId: contentId, commentToReattach: commentToReattach, actions: actions })=>{
    let selectionObj = {
        numMatches: 0,
        matchIndex: -1,
        selectedText: '',
        timestamp: 0
    };
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) {
        $917b9bb03b3149d5$var$logger.debug`No text selected. Creating inline comment at cursor position.`;
        return selectionObj;
    }
    if (selection) {
        // TODO clean up after above FG is removed
        const range = selection.getRangeAt(0);
        const legacySelection = (0, $aUTn5.convertSelectionToLegacyFormat)(content.current, range, contentId);
        const { searchText: { numMatches: numMatches, index: matchIndex, selectedText: selectedText } } = legacySelection;
        selectionObj = {
            numMatches: numMatches,
            matchIndex: matchIndex,
            selectedText: selectedText,
            timestamp: Date.now()
        };
        /**
     * We generate the annotation step for the upcoming new collab service
     * to consume. This means we will eventually started sending markerRef
     * ids from the FE.
     */ try {
            const markerRef = commentToReattach ? commentToReattach.inlineMarkerRef : (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
            if (actions) {
                const proseMirrorStep = actions.annotate(range, markerRef, 'inlineComment');
                const { step: { from: from, to: to, mark: mark } } = proseMirrorStep;
                selectionObj['step'] = {
                    from: from,
                    to: to,
                    mark: {
                        type: 'annotation',
                        attrs: {
                            key: mark.attrs?.annotationType,
                            value: mark.attrs?.id
                        }
                    }
                };
            }
        } catch (e) {
            $917b9bb03b3149d5$var$logger.error`An error occurred when generating a step - ${e}`;
        }
    }
    return selectionObj;
};
module.exports["getLegacyConvertedSelectionObj"] = $917b9bb03b3149d5$export$dbde27c406dff8e8;

});

parcelRegister("aUTn5", function(module, exports) {
/* eslint-disable no-restricted-globals */ 
var $9wGTI = parcelRequire("9wGTI");


var $2zMIV = parcelRequire("2zMIV");


var $kbVzJ = parcelRequire("kbVzJ");

const $92069b7b1bcb2285$export$c5bc138cfa79c2b2 = [
    // Legacy mention
    '.user-mention',
    // Fabric mention
    '[data-mention-id]',
    // Connect macro
    '.ap-container',
    // Links
    'a[href^="/"]',
    // Macros that doesn't have body
    '.conf-macro[data-hasbody="false"]',
    // Normal status
    '.status-lozenge-span',
    // Date will get rendered as "Today" in fabric
    '.date-lozenger-container',
    // Inline Smart Card/Jira issue link
    '[data-inline-card="true"]',
    '.inlineCardView-content-wrap',
    '.smart-link-title-wrapper',
    // Actual jira issue macro
    '.jira-issue',
    // Title for expand
    '.ak-renderer-extension-overflow-container button',
    '[data-node-type="expand"] > button',
    '[data-node-type="nestedExpand"] > button',
    // JIRA Macro
    '.jira-issues',
    // datasource table for new JIM macro
    '.datasource-table',
    // Inline file attachments
    "[data-type='file']",
    // Fabric code snippets
    '.code-block',
    // Legacy code snippets
    '.conf-macro[data-macro-name="code"]',
    // Sticky table headers (WS-2345 - Sticky header comment flow is strange for now, restrict until we can find a better solution)
    '.pm-table-sticky-wrapper',
    // Block cards
    '.blockCardView-content-wrap',
    // Excerpt Includes (WS-2563)
    '.ak-excerpt-include',
    // View All Container
    '#view-all-inline-comments-container',
    // Strikethrough
    's',
    // Emoji
    '[data-emoji-id]',
    // Charts
    "[data-mark-type='dataConsumer']",
    // Reattach Dialog
    '#reattach-container',
    // BEGIN EDITOR EXCLUSIONS
    //
    // Gadget?
    "[extensionkey='gadget']",
    // placeholder content
    'span[data-placeholder]',
    // covers most macros, would this be too encompassing?
    "[contenteditable='false']",
    // page include macro
    "[data-node-type='include']",
    // page properties report adf macro
    '.page-properties-report'
].join(',');
function $92069b7b1bcb2285$var$getSelectionHTML(selectionRange) {
    if ((0, $9wGTI.fg)('confluence-remove-jquery-from-selection-conversion')) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const div = document.createElement('div');
        div.appendChild(selectionRange.cloneContents());
        return div.innerHTML;
    } else return $('<div>').append(selectionRange.cloneContents()).html();
}
function $92069b7b1bcb2285$var$getContainingElement(selectionRange) {
    if (selectionRange.commonAncestorContainer) {
        const selectRangeElement = selectionRange.commonAncestorContainer;
        if (selectRangeElement.nodeType === 3) //Is TextNode
        return selectRangeElement.parentNode;
        return selectRangeElement;
    }
}
function $92069b7b1bcb2285$var$getFirstAndLastSelectionRect(selectionRange, clientRects) {
    // In Chrome triple clicking text will cause all the text in an element to be selected. When calling
    // getClientRects after a triple click, the array will contain rects for each line of highlighted text
    // in the highlighted element and also a clientRects for the adjacent sibling element even though no text
    // is highlighted inside it. If the endOffset is zero, we ignore this final clientRect because no text
    // is highlighted inside of it.
    //
    // Also, in Chrome, Safari and Firefox, get client rects return a clientRects representing each inline element
    // including rectangles for all nested elements. IE8 return many less rects, maybe just one for the ancestor
    // element containing the highlight or a clientRects for each line of highlight without individual rects for each
    // inline element
    const rects = {
        first: clientRects[0],
        last: clientRects[clientRects.length - 1]
    };
    if (selectionRange.endOffset !== 'undefined') //In IE, if we highlight on resolved inline comment, we will length of clientRects is 1
    {
        if (selectionRange.endOffset === 0 && clientRects.length > 1) rects.last = clientRects[clientRects.length - 2];
    }
    return rects;
}
function $92069b7b1bcb2285$var$getSelectionRects(selectionRange) {
    // if using documentation theme, get scrolltop of documentation theme content which is fixed size
    // certain browsers give the scrollTop on html element, some give it on the body element. this works in both.
    const scrollTop = window.scrollY;
    const scrollLeft = window.scrollX;
    let clientRects = selectionRange.getClientRects();
    // IE fails to provide client rects when highlighting a paragraph containing only an image or triple clicking to
    // highlight any paragraph containing content other than plain text. In this case, it is safe to assume parent
    // element dimensions will represent the highlighted area
    if (!clientRects.length && selectionRange.parentElement && selectionRange.parentElement()) {
        if ((0, $9wGTI.fg)('confluence-remove-jquery-from-selection-conversion')) {
            const parentElement = selectionRange.parentElement();
            const rect = parentElement.getBoundingClientRect();
            clientRects = [
                {
                    top: rect.top,
                    left: rect.left,
                    bottom: rect.top + scrollTop + rect.height,
                    right: rect.left + scrollLeft + rect.width
                }
            ];
        } else {
            const $parentElement = $(selectionRange.parentElement());
            const parentOffset = $parentElement.offset();
            if (parentOffset) clientRects = [
                {
                    top: parentOffset.top - scrollTop,
                    left: parentOffset.left - scrollLeft,
                    bottom: parentOffset.top + ($parentElement.height() || 0),
                    right: parentOffset.left + ($parentElement.width() || 0)
                }
            ];
        }
    }
    const rects = $92069b7b1bcb2285$var$getFirstAndLastSelectionRect(selectionRange, clientRects);
    /*
   * Calculates Create Issue dialog target area
   */ const getOverlap = function(firstRect, lastRect) {
        const overlap = {};
        overlap.top = firstRect.top;
        overlap.left = (firstRect.left || 0) + scrollLeft;
        overlap.bottom = lastRect.bottom;
        if (firstRect.left !== undefined && firstRect.right !== undefined && lastRect.left !== undefined && lastRect.right !== undefined) {
            if (firstRect.left >= lastRect.right) overlap.right = firstRect.right;
            else overlap.right = lastRect.right;
        }
        overlap.right = (overlap.right || 0) + scrollLeft;
        // adjust top for doc theme
        overlap.top = (overlap.top || 0) + scrollTop;
        overlap.bottom = (overlap.bottom || 0) + scrollTop;
        // set width and height
        overlap.width = overlap.right - overlap.left;
        overlap.height = overlap.bottom - overlap.top;
        return overlap;
    };
    /*
   * Calculates the action panel target area
   */ const getHighlightStart = function(rect) {
        const highlight = {};
        if (!rect) return highlight;
        highlight.width = rect.right - rect.left;
        highlight.height = rect.bottom - rect.top;
        highlight.left = rect.left + scrollLeft;
        highlight.right = rect.right + scrollLeft;
        highlight.top = rect.top + scrollTop;
        highlight.bottom = rect.bottom + scrollTop;
        return highlight;
    };
    return {
        first: getHighlightStart(rects.first),
        average: getOverlap(rects.first, rects.last)
    };
}
function $92069b7b1bcb2285$var$getSelectionText(selectionRange) {
    return (0, $2zMIV.textNormalize)(String(selectionRange));
}
/**
 * Generates javascript object containing the context of the selected text to help locate in storage format
 *
 * @param root container of content which can be selected
 * @param selectedText text that currently highlighted
 * @param selected range object representing the current selection
 * @param pageId the page id we're currently on
 * @param includeTraceForMatches a boolean stating whether or not to include a tree trace for each match
 * @return object containing metadata about the location of the selected text
 */ function $92069b7b1bcb2285$var$computeSearchTextObject(root, selectedText, selected, pageId, includeTraceForMatches) {
    // WS-2345 - Sticky header create comment flow is strange for now, disabling it until a better solution is found
    // https://product-fabric.atlassian.net/browse/CEMS-1100
    //
    // sticky headers create duplicate tables to work, which causes duplicate
    // text content to end up in the inline comment text string. ignore sticky
    // table content when not visible, and vice versa.
    // const inSticky = findStickyHeader(selected.startContainer);
    // const ignoreTable: HTMLElement[] = Array.from(
    //   inSticky
    //     ? root.querySelectorAll(
    //         ".pm-table-container .pm-table-wrapper tr:first-of-type"
    //       )
    //     : root.querySelectorAll(".pm-table-sticky-wrapper")
    // );
    const ignoreTable = Array.from(root.querySelectorAll('.pm-table-sticky-wrapper'));
    const ignoredNodes = Array.from(root.querySelectorAll($92069b7b1bcb2285$export$c5bc138cfa79c2b2));
    const { text: text, nodesStartPos: nodesStartPos, nodes: nodes } = (0, $kbVzJ.indexTextNodes)(root, [
        ...ignoredNodes,
        ...ignoreTable
    ]);
    const { index: index, numMatches: numMatches, matchTraceList: matchTraceList } = (0, $kbVzJ.findMatches)(text, selectedText, selected.startContainer, selected.startOffset, nodesStartPos, nodes, includeTraceForMatches);
    const searchTextObj = {
        pageId: pageId,
        selectedText: selectedText,
        index: index,
        numMatches: numMatches
    };
    if (matchTraceList) searchTextObj.matchTraceList = matchTraceList;
    return searchTextObj;
}
function $92069b7b1bcb2285$export$4ba66d628a1e5980(contentContainer, selectionRange, pageId, lastModified, getTraceForMatches) {
    const rawText = $92069b7b1bcb2285$var$getSelectionText(selectionRange);
    const text = rawText.trim();
    let searchText;
    // It finds all the occurrences of selected text.
    // Since if I select word "is" there maybe a lot occurrences on the page.
    // searchText.index tells the backend which one is really the one I selected.
    // That is among, for example 20 matches, the 5th match is my selection.
    if (text) searchText = $92069b7b1bcb2285$var$computeSearchTextObject(contentContainer, // It is important to pass raw text here
    rawText, selectionRange, pageId, getTraceForMatches);
    return getTraceForMatches ? searchText.matchTraceList : {
        text: text,
        searchText: searchText,
        area: $92069b7b1bcb2285$var$getSelectionRects(selectionRange),
        html: $92069b7b1bcb2285$var$getSelectionHTML(selectionRange),
        containingElement: $92069b7b1bcb2285$var$getContainingElement(selectionRange),
        range: selectionRange,
        lastModified: lastModified
    };
}
function $92069b7b1bcb2285$export$b297c7070f7a854(contentContainer, selectionRange, pageId) {
    const matchTraceList = $92069b7b1bcb2285$export$4ba66d628a1e5980(contentContainer, selectionRange, pageId, null, true);
    return matchTraceList || [];
}
module.exports["IGNORE_SELECTORS"] = $92069b7b1bcb2285$export$c5bc138cfa79c2b2;
module.exports["convertSelectionToLegacyFormat"] = $92069b7b1bcb2285$export$4ba66d628a1e5980;
module.exports["getMatchTraces"] = $92069b7b1bcb2285$export$b297c7070f7a854;

});

parcelRegister("2zMIV", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $aUTn5 = parcelRequire("aUTn5");

const $15cdccae323ae129$var$logger = (0, $7W8i8.getLogger)('highlight-action');
const $15cdccae323ae129$export$4042f14350dc38e1 = (container, contentId)=>{
    const selection = window.getSelection();
    // getSelection() only returns null for iframes in firefox; in all other cases the type field is set to "None"
    if (!selection || selection?.type === 'None') return false;
    let legacyHighlight;
    try {
        legacyHighlight = (0, $aUTn5.convertSelectionToLegacyFormat)(container, selection.getRangeAt(0), contentId);
    } catch (err) {
        $15cdccae323ae129$var$logger.error`An error occurred while highlighting content - ${err}`;
    }
    if (!legacyHighlight || !legacyHighlight.searchText) return false;
    const { searchText: { selectedText: selectedText, index: index, numMatches: numMatches } } = legacyHighlight;
    /*
   * A valid highlight contains:
   *
   *   A selection that has a length (non-empty)
   *   A matched index (-1 means not found)
   *   A positive non-zero number of matches
   *   A match index that is less than the number of matches
   *
   */ return selectedText.replace(/\n/g, '').length > 0 && index !== -1 && numMatches > 0 && index < numMatches;
};
const $15cdccae323ae129$export$6c73cedfcc8a18f2 = ()=>{
    const selection = window.getSelection();
    if (!selection || selection?.type === 'None') return false;
    const range = $15cdccae323ae129$export$fef151b94550e9f5();
    if (!range) return false;
    const parentElement = $15cdccae323ae129$export$ab738b211369230e(range);
    return parentElement instanceof HTMLElement && Boolean(parentElement.closest('table'));
};
const $15cdccae323ae129$export$42b4db950c80743f = (s)=>{
    /*
    CONF-36789: on IE, selectionRange.toString() always convert all &nbsp; to normal space
    on other browsers, it does not. So we must convert manually to made consistency across all browsers
    */ return s.replace(/\u00a0/g, '\u0020');
};
const $15cdccae323ae129$export$fef151b94550e9f5 = ()=>{
    const selection = window.getSelection();
    // no selection made webkit
    if (!selection || selection.isCollapsed) return null;
    const selectionRange = selection.getRangeAt(0);
    // Don't show popup if selection is white space
    if (!String(selectionRange).trim()) return null;
    return selectionRange;
};
const $15cdccae323ae129$export$cfa2225e87938781 = (node)=>{
    const TEXT_NODE_TYPE = 3;
    if (!node) return null;
    if (node.nodeType !== TEXT_NODE_TYPE && node.scrollWidth > node.clientWidth) return node;
    else return $15cdccae323ae129$export$cfa2225e87938781(node.parentNode);
};
const $15cdccae323ae129$export$6fc0706fcfa876ec = (node)=>{
    const ELEMENT_NODE_TYPE = 1;
    if (!node) return null;
    if (node.nodeType === ELEMENT_NODE_TYPE) {
        if (node.classList.contains('pm-table-sticky-wrapper')) return node;
    }
    if (node.parentElement) return $15cdccae323ae129$export$6fc0706fcfa876ec(node.parentElement);
    return null;
};
const $15cdccae323ae129$export$ab738b211369230e = (selectionRange)=>{
    if (selectionRange.commonAncestorContainer) {
        const selectRangeElement = selectionRange.commonAncestorContainer;
        if (selectRangeElement.nodeType === 3) //Is TextNode
        return selectRangeElement.parentNode;
        return selectRangeElement;
    }
    return null;
};
module.exports["isHighlightValidForInlineComment"] = $15cdccae323ae129$export$4042f14350dc38e1;
module.exports["isHighlightValidForBulkCreateJiraIssues"] = $15cdccae323ae129$export$6c73cedfcc8a18f2;
module.exports["getRange"] = $15cdccae323ae129$export$fef151b94550e9f5;
module.exports["getContainingElement"] = $15cdccae323ae129$export$ab738b211369230e;
module.exports["textNormalize"] = $15cdccae323ae129$export$42b4db950c80743f;
module.exports["findStickyHeader"] = $15cdccae323ae129$export$6fc0706fcfa876ec;

});

parcelRegister("kbVzJ", function(module, exports) {
// eslint-disable-next-line import/no-cycle

var $2zMIV = parcelRequire("2zMIV");

const $567297790b62d2d4$var$TEXT_NODE_TYPE = 3;
function $567297790b62d2d4$export$2a4369abc54086f5(list, search, from) {
    const startPosInRange = Math.min(from, list.length - 1);
    let l = startPosInRange;
    let r = list.length;
    while(l < r){
        // This is a LEGACY disable statement after rule addition. Use `Math.floor((l+r)/2)` next time
        // eslint-disable-next-line no-bitwise
        const mid = l + r >> 1;
        if (list[mid] <= search) l = mid + 1;
        else r = mid;
    }
    return Math.max(l - 1, startPosInRange);
}
function $567297790b62d2d4$export$2605a3f2b4d7f885(root, ignoredNodes) {
    let textNode;
    let text = '';
    const nodesStartPos = [];
    const nodes = [];
    const nodeFilter = (textNode)=>{
        /**
     * If the text node is a descendent of one of the ignored node.
     * It means the text was rendered by maybe a macro.
     * Ignore these text nodes.
     */ return ignoredNodes.some((node)=>node === textNode || node.contains(textNode)) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
    };
    // createNodeIterator accepts an object with acceptNode field as node filter.
    // However IE 11 is expecting a function directly.
    nodeFilter.acceptNode = nodeFilter;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const iter = document.createNodeIterator(root, NodeFilter.SHOW_TEXT, nodeFilter, false);
    while(textNode = iter.nextNode()){
        const normalizedText = (0, $2zMIV.textNormalize)(textNode.nodeValue);
        // WS-2885 - \u0020 represents the spacebar character so this regex handles any number of space only characters
        //           that may exist as their own nodes. We don't need to worry about only commenting on a space here
        //           because the popup has logic to only show itself if more than just a space is selected.
        if (/^\u0020+$/.test(normalizedText) || normalizedText.trim()) {
            // If it is not completely empty
            nodesStartPos.push(text.length);
            nodes.push(textNode);
            text += normalizedText;
        }
    }
    return {
        text: text,
        nodesStartPos: nodesStartPos,
        nodes: nodes
    };
}
function $567297790b62d2d4$var$getNodeTextLength(node) {
    return node && node.nodeValue ? node.nodeValue.length : 0;
}
function $567297790b62d2d4$export$f4585c00f32d9257(text, rawSelectedText, startContainer, startOffset, nodesStartPos, nodes, includeTraceForMatches) {
    const matchTraceList = [];
    if (!startContainer) return {
        numMatches: 0,
        index: -1,
        matchTraceList: null
    };
    let start = 0;
    let nodeStart = 0;
    let found = 0;
    let index = -1;
    let numMatches = 0;
    // loop through the provided text body string, starting from the beginning,
    // and update the index to search from until the rawSelectedtext can
    // no longer be found
    while((found = text.indexOf(rawSelectedText, start)) !== -1){
        // nodesStartPos is built by slowly concatenanting each non-empty text node value
        // together into a single string, and storing the index number at which the next string starts
        // with the matched index, find the nearest index value but return that index-1.
        // For example, if our match index is 10 and nodesStartPos = [0, 5, 11, 13],
        // we return index 1 (11 is the nearest but we want the index-1, 5).
        const pos = $567297790b62d2d4$export$2a4369abc54086f5(nodesStartPos, found, nodeStart);
        const textNode = nodes[pos];
        // In Firefox there is a case that startOffset is the end of a text node.
        // In this case it means the selection is actually starting from the next sibling node.
        let startNode = startContainer;
        if (startNode.nodeType === $567297790b62d2d4$var$TEXT_NODE_TYPE && startOffset >= $567297790b62d2d4$var$getNodeTextLength(startNode)) {
            startOffset -= $567297790b62d2d4$var$getNodeTextLength(startNode);
            startNode = startContainer.nextSibling;
        }
        if (startNode && (startNode.nodeType === $567297790b62d2d4$var$TEXT_NODE_TYPE && textNode === startNode || // Text node in IE 11 doesn't have contains method
        startNode.nodeType !== $567297790b62d2d4$var$TEXT_NODE_TYPE && startNode.contains(textNode))) {
            // The current text node might be the one we are selecting.
            // However a single text may have more than one match of the selected text.
            // We need to double check if the offset is correct.
            const offsetForCurrentFoundText = found - nodesStartPos[pos];
            if (offsetForCurrentFoundText <= startOffset) index = numMatches;
        }
        // Trace the text node back to the root if the flag is true
        if (includeTraceForMatches) {
            let element = textNode.parentElement;
            const parentElements = [];
            // We want to loop and record all the elements up to the div#content node
            while(element && element.getAttribute('id') !== 'content'){
                let classes = '';
                let attributes = '';
                const { tagName: tagName } = element;
                const classList = element.classList ? element.classList.value : '';
                const dataAttributes = element.getAttributeNames().filter((attribute)=>attribute.indexOf('data-') !== -1);
                // Handle classes
                if (classList.length) classes = `.${classList.split(' ').join('.')}`;
                // Handle data attributes
                if (dataAttributes.length) dataAttributes.forEach((attribute)=>{
                    // We don't want to get the value of the data-macro-body and data-title attributes
                    // because they can contain user information and we don't want to record it
                    if (attribute !== 'data-macro-body' && attribute !== 'data-title') {
                        // While it's "possible", we'll never actually get here if element is null
                        const value = element?.getAttribute(attribute);
                        attributes += `[${attribute}="${value}"]`;
                    } else attributes += `[${attribute}]`;
                });
                parentElements.unshift(`${tagName}${classes}${attributes}`);
                element = element.parentElement;
            }
            matchTraceList.push(parentElements.join(' > '));
        }
        numMatches++;
        start = found + 1;
        nodeStart = pos;
    }
    return {
        numMatches: numMatches,
        index: index,
        matchTraceList: matchTraceList.length ? matchTraceList : null
    };
}
module.exports["indexTextNodes"] = $567297790b62d2d4$export$2605a3f2b4d7f885;
module.exports["findMatches"] = $567297790b62d2d4$export$f4585c00f32d9257;

});

parcelRegister("liGyh", function(module, exports) {

var $dIPzP = parcelRequire("dIPzP");


var $cozmU = parcelRequire("cozmU");


var $6tkbf = parcelRequire("6tkbf");


var $7zgzO = parcelRequire("7zgzO");


var $ep3mz = parcelRequire("ep3mz");


var $7W8i8 = parcelRequire("7W8i8");


var $6mKj3 = parcelRequire("6mKj3");


var $lb2Lp = parcelRequire("lb2Lp");


var $kgNLQ = parcelRequire("kgNLQ");


var $aSsfA = parcelRequire("aSsfA");


var $jMyy4 = parcelRequire("jMyy4");


var $1rdvc = parcelRequire("1rdvc");

const $ba57c93125c5375a$var$useCommentQueryParamsCommentLocationQuery = (0, $dIPzP.default);
const $ba57c93125c5375a$var$logger = (0, $7W8i8.getLogger)('comment-query-params');
const $ba57c93125c5375a$export$63c5e37b7c8d14d1 = ({ location: location, queryArchivedContent: queryArchivedContent = false } = {})=>{
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const [pageId] = (0, $ep3mz.usePageContentId)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { focusedCommentId: focusedCommentId, editComment: editComment, commentId: commentId, replyToComment: replyToComment, showCommentArea: showCommentArea, shouldMention: shouldMention, unreadCommentMark: unreadCommentMark } = getQueryParams();
    const targetCommentId = focusedCommentId || replyToComment || editComment && commentId;
    const shouldSkipQuery = !targetCommentId || !location;
    // NEW FLOW: Use useCommentById when experiment is enabled
    const { comment: comment, error: commentError } = (0, $lb2Lp.useCommentById)({
        commentId: targetCommentId || '',
        contentId: pageId || '',
        contentStatus: (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode),
        options: {
            skip: shouldSkipQuery || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
        }
    });
    // OLD FLOW: Direct GraphQL query (fallback when experiment is disabled)
    const { data: legacyData, error: legacyError } = (0, $jMyy4.useQueryInterop)($ba57c93125c5375a$var$useCommentQueryParamsCommentLocationQuery, {
        variables: {
            commentId: targetCommentId,
            contentStatus: [
                queryArchivedContent ? (0, $1rdvc.GraphQLContentStatus).ARCHIVED : (0, $1rdvc.GraphQLContentStatus).DRAFT,
                (0, $1rdvc.GraphQLContentStatus).CURRENT
            ]
        },
        skip: shouldSkipQuery || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false),
        __callerPackage__: "comment"
    });
    if (legacyError) $ba57c93125c5375a$var$logger.error`Error: Unable to query comment location for ${commentId}`;
    // Determine error state - use new flow error or old flow error
    const error = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? commentError : legacyError;
    // Note that this will detect missing inline and footer comments because the query will find
    // either type of comment - so if the comment doesn't exist, we will get the "not found" error
    // In the new flow, useCommentById returns an error when the comment isn't found after loading completes
    const isCommentNotFound = error ? (0, $6tkbf.isCommentNotFoundError)(error.message || String(error)) : false;
    let focusedId;
    let editCommentId;
    let replyToCommentId;
    // Extract location and container ID from either new or old flow
    const commentLocation = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? comment?.location?.type : legacyData?.comments?.nodes?.[0]?.location?.type;
    // Extract container ID from either new or old flow
    let commentContainerId;
    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
        if (comment && 'container' in comment) // Comment replies coming from the new manager don't have a container
        commentContainerId = comment.container?.id;
        else commentContainerId = undefined;
    } else commentContainerId = legacyData?.comments?.nodes?.[0]?.container?.id;
    // Only return comment IDs for relevant location; If no location is given, return them all
    const shouldReturnIds = (!location || location === commentLocation) && (pageId === commentContainerId || commentContainerId === undefined && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false));
    if (shouldReturnIds) {
        /* A focused comment query param just uses "focusedCommentId={COMMENT_ID}" */ focusedId = focusedCommentId ? focusedCommentId : undefined;
        /* An edit comment query param uses a combination of "editComment=true&commentId={COMMENT_ID}" */ editCommentId = editComment && editComment === 'true' && commentId ? commentId : undefined;
        /* A reply to comment query param just uses "replyToComment={COMMENT_ID}" */ replyToCommentId = replyToComment ? replyToComment : undefined;
    }
    /* PAGE COMMENTS ONLY: A new comment uses the "showCommentArea=true" query param */ const shouldOpenNewCommentEditor = showCommentArea === 'true';
    /* A mention comment uses the "shouldMention=true" query param */ const shouldMentionInNewCommentEditor = shouldMention === 'true' && replyToCommentId !== undefined;
    const removeCommentQueryParamsFunction = ()=>{
        let commentTypeKey = '', commentIdKey = '', commentMentionKey = '';
        if (focusedId) commentTypeKey = 'focusedCommentId';
        else if (shouldMentionInNewCommentEditor) {
            commentTypeKey = 'replyToComment';
            commentMentionKey = 'shouldMention';
        } else if (replyToCommentId) commentTypeKey = 'replyToComment';
        else if (editCommentId) {
            commentTypeKey = 'editComment';
            commentIdKey = 'commentId';
        } else if (shouldOpenNewCommentEditor) commentTypeKey = 'showCommentArea';
        if (commentTypeKey || commentIdKey || commentMentionKey || unreadCommentMark) {
            const params = getQueryParams();
            setQueryParams({
                ...params,
                [commentTypeKey]: undefined,
                [commentIdKey]: undefined,
                [commentMentionKey]: undefined,
                unreadCommentMark: undefined
            });
        }
    };
    const removeCommentQueryParams = (0, $cozmU.useCallback)(removeCommentQueryParamsFunction, [
        getQueryParams,
        setQueryParams,
        unreadCommentMark,
        editCommentId,
        replyToCommentId,
        shouldOpenNewCommentEditor,
        shouldMentionInNewCommentEditor,
        focusedId
    ]);
    const setFocusedCommentQueryParam = (commentId)=>{
        const params = getQueryParams();
        setQueryParams({
            ...params,
            focusedCommentId: commentId
        });
    };
    return {
        focusedCommentId: focusedId,
        editCommentId: editCommentId,
        replyToCommentId: replyToCommentId,
        shouldOpenNewCommentEditor: shouldOpenNewCommentEditor,
        shouldMentionInNewCommentEditor: shouldMentionInNewCommentEditor,
        unreadCommentMark: unreadCommentMark,
        removeCommentQueryParams: removeCommentQueryParams,
        setFocusedCommentQueryParam: setFocusedCommentQueryParam,
        isCommentNotFound: isCommentNotFound
    };
};
const $ba57c93125c5375a$export$b073d30d47d4035b = ({ queryArchivedContent: queryArchivedContent = false } = {})=>$ba57c93125c5375a$export$63c5e37b7c8d14d1({
        location: 'INLINE',
        queryArchivedContent: queryArchivedContent
    });
const $ba57c93125c5375a$export$97d0ff531551284c = ()=>$ba57c93125c5375a$export$63c5e37b7c8d14d1({
        location: 'FOOTER'
    });
module.exports["useInlineCommentQueryParams"] = $ba57c93125c5375a$export$b073d30d47d4035b;

});

parcelRegister("dIPzP", function(module, exports) {
/**
 * @generated SignedSource<<221cd0274b1b44eaf8c01d1dd00eeb04>>
 * @relayHash ab6c713571991d15a172cc151a881572
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f949e31d273ba334fe47e353750570e04e6318fda46c0dcfe74b06fb9a6a4dae
const $c1e2aac1eea196bd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentStatus"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentId",
                    "variableName": "commentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                }
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "location",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                }
                            ]
                        },
                        v1 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCommentQueryParamsCommentLocationQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCommentQueryParamsCommentLocationQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ab6c713571991d15a172cc151a881572",
            "id": "f949e31d273ba334fe47e353750570e04e6318fda46c0dcfe74b06fb9a6a4dae",
            "metadata": {},
            "name": "useCommentQueryParamsCommentLocationQuery",
            "operationKind": "query",
            "text": "query useCommentQueryParamsCommentLocationQuery($commentId:ID,$contentStatus:[GraphQLContentStatus]){comments(commentId:$commentId,contentStatus:$contentStatus){nodes{container{id},location{__typename,type},id}}}"
        }
    };
}();
$c1e2aac1eea196bd$var$node.hash = "60bed37eee2f8a7739db095067b4457b";
var $c1e2aac1eea196bd$export$2e2bcd8739ae039 = $c1e2aac1eea196bd$var$node;
module.exports["default"] = $c1e2aac1eea196bd$export$2e2bcd8739ae039;

});

parcelRegister("6tkbf", function(module, exports) {

var $lb2Lp = parcelRequire("lb2Lp");


var $6mKj3 = parcelRequire("6mKj3");

const $6b00aa328c211ce7$export$5c24224d7e29c719 = ()=>{
    return {
        context: {
            fetchOptions: {
                ignoreNoNetworkError: (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_offline_fix', 'isEnabled', true)
            }
        }
    };
};
const $6b00aa328c211ce7$export$9f99b736afd21d01 = (errorMessage)=>{
    if (errorMessage) {
        // Check if the full error message matches the string thrown from useCommentById
        if (errorMessage === (0, $lb2Lp.USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE)) return true;
        // Also check the reason message (extracted from backend error format)
        const reasonStartIdx = errorMessage.lastIndexOf(':') + 1;
        const reasonMessage = errorMessage.substring(reasonStartIdx, errorMessage.length).trim();
        // If this string is ever updated on the BE and you need to change it - make sure to also update USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE for consistency
        const backendReasonMessage = 'No comment found for the given id';
        return reasonMessage === backendReasonMessage;
    }
    return false;
};
module.exports["buildMutationContextForNoNetworkError"] = $6b00aa328c211ce7$export$5c24224d7e29c719;
module.exports["isCommentNotFoundError"] = $6b00aa328c211ce7$export$9f99b736afd21d01;

});

parcelRegister("lb2Lp", function(module, exports) {

var $dc3kb = parcelRequire("dc3kb");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $6mKj3 = parcelRequire("6mKj3");


var $NYiei = parcelRequire("NYiei");


var $kgNLQ = parcelRequire("kgNLQ");


var $4L9ve = parcelRequire("4L9ve");

// The `useCommentById` hook efficiently fetches a single comment by ID with a simple strategy:
// First, it checks the cache for the allCommentsDataQuery using useAllCommentsData with cache-only
// policy. If the comment is found in the cache and data is processed, it uses that data. Otherwise,
// it makes a separate query for just the specific comment. This ensures quick access to individual
// comments without unnecessary network requests when data is already cached. The hook also provides
// loading states, error handling, and comprehensive type safety.
// Unfortunately our Relay-friendly type generation tools don't support GQL fragments yet - but in
// order to keep the definition of the comment fields in sync (so the cache update fragment is
// always in sync with the full query) we will need to manually make any changes to one definition
// in any others as well, until our tooling supports fragments and then we move to a more
// fragmented-based approach.  Note there are also comment queries or fragments in the following
// files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data-manager/src/updateCommentInCache.ts
// - next/packages/comments-data-manager/src/useCreateObjectCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineReplyMutation.ts
// - next/packages/object-comments/src/components/ObjectCommentContainer.tsx
// TODO: Replace with the exported fragment from useAllCommentsData.ts when our tooling supports
// it, if we are allowed to share fragments between packages/files.  If we are not allowed to share
// fragments, we should move this hook - or at least the part that executes the query into the
// useAllCommentsData.ts file.
const $f4841d4502be35b2$var$commentByIdQuery = (0, $dc3kb.default);
const $f4841d4502be35b2$export$4bf99575c214d4b = 'Comment not found: No comment found for the given id';
const $f4841d4502be35b2$export$1f091977fe1929e2 = 'useCommentById requires either commentId or markerRef and contentId to be provided';
const $f4841d4502be35b2$export$778dda4ccca7793f = ({ commentId: commentId, markerRef: markerRef, contentId: contentId, contentStatus: contentStatus = [
    'CURRENT'
], options: options = {} })=>{
    const { fetchPolicy: fetchPolicy = 'cache-first', onError: parentOnError, skip: explicitlySkipped = false } = options;
    // Skip queries if experiment is disabled or explicitly skipped through options
    const skip = explicitlySkipped || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false);
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    // Validate that at least one identifier is provided (only if not skipping)
    const validationError = (0, $cozmU.useMemo)(()=>!skip && (!contentId || !commentId && !markerRef) ? new Error($f4841d4502be35b2$export$1f091977fe1929e2) : undefined, [
        skip,
        commentId,
        markerRef,
        contentId
    ]);
    const skipQueries = skip || !!validationError;
    // Skip the individual comment query if we have cached data from the full query, it's been processed, and we're not asking for fresh BE data
    const shouldSkipOneCommentQuery = skipQueries || fetchPolicy !== 'network-only' && processedCommentsData.isDataProcessed;
    // Always query with all 4 content statuses to guarantee cache hits on preloaded data
    // We'll filter the result client-side based on the passed-in contentStatus
    const oneCommentData = (0, $jMyy4.useQueryInterop)($f4841d4502be35b2$var$commentByIdQuery, {
        variables: {
            pageId: contentId ?? '',
            commentId: commentId || undefined,
            inlineMarkerRef: markerRef || undefined,
            contentStatus: (0, $NYiei.allContentStatuses)
        },
        fetchPolicy: fetchPolicy,
        skip: shouldSkipOneCommentQuery,
        onError: (error)=>{
            // Handle specific GraphQL errors gracefully
            // WS-3494 - If the error isn't related to reactionsSummary returning null, just mark it handled
            // COMMENTS-188 - Or if the error isn't related to cc-pages not being reachable just mark it handled
            if (error?.message?.search(/reactions/i) !== -1 || error?.message?.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "comments-data-manager"
    });
    // Look for the comment using the flat map for O(1) lookup, or fall back to searching arrays
    const finalComment = (0, $cozmU.useMemo)(()=>{
        if (validationError) return undefined;
        // If data is processed, try to find in the flat maps (fastest - O(1))
        if (processedCommentsData.isDataProcessed) {
            if (commentId) {
                const cachedComment = processedCommentsData.flatCommentsMap?.[commentId];
                if (cachedComment) return cachedComment;
            } else if (markerRef) {
                const cachedCommentByMarkerRef = processedCommentsData.flatMarkerRefMap?.[markerRef];
                if (cachedCommentByMarkerRef) return cachedCommentByMarkerRef;
            }
        }
        // Fall back to searching in oneCommentData if available
        if (oneCommentData.data?.comments?.nodes) {
            // Filter out any null nodes - can't just use .filter because TS complains about type
            // mismatch.  Fortunately, this query should only have one comment node anyway.
            const commentData = oneCommentData.data.comments.nodes.map((node)=>node).filter((node)=>node);
            if (!commentData) return undefined;
            // Search in retrieved comments and their replies
            return (0, $kgNLQ.findAndFilterComment)(commentData, commentId, markerRef, contentStatus);
        }
        return undefined;
    }, [
        validationError,
        commentId,
        processedCommentsData.flatCommentsMap,
        processedCommentsData.flatMarkerRefMap,
        processedCommentsData.isDataProcessed,
        oneCommentData.data?.comments?.nodes,
        markerRef,
        contentStatus
    ]);
    // Create an error if we have the full response but can't find the comment
    // 99% of the time this error will be thrown when cachedUseAllCommentsData is populated, but the comment isn't available
    // useCommentByIdQuery **should** throw a similar error if the comment isn't found from the BE,
    // but keep the check here in case the BE changes, or our comment is in another status & is filtered out
    const commentNotFoundError = (0, $cozmU.useMemo)(()=>{
        // Only create error if:
        // 1. We're not loading anymore (have full response)
        // 2. We have data (either from processedCommentsData or oneCommentData)
        // 3. We searched for the comment but didn't find it
        // 4. There's no existing error
        if (!skipQueries && processedCommentsData.isDataProcessed && !oneCommentData.loading && !processedCommentsData.error && !oneCommentData.error && finalComment === undefined) return new Error($f4841d4502be35b2$export$4bf99575c214d4b);
        return undefined;
    }, [
        skipQueries,
        processedCommentsData.isDataProcessed,
        processedCommentsData.error,
        oneCommentData.loading,
        oneCommentData.error,
        finalComment
    ]);
    // Memoize the final error to ensure stable reference for use in external useEffects
    const error = (0, $cozmU.useMemo)(()=>{
        return validationError || processedCommentsData.error || oneCommentData.error || commentNotFoundError;
    }, [
        validationError,
        processedCommentsData.error,
        oneCommentData.error,
        commentNotFoundError
    ]);
    // Call onError when the error changes
    (0, $cozmU.useEffect)(()=>{
        if (error && parentOnError) parentOnError(error);
    }, [
        error,
        parentOnError
    ]);
    return {
        loading: !processedCommentsData.isDataProcessed && oneCommentData.loading,
        error: // (Only loading state if both are loading)
        error,
        comment: finalComment
    };
};
const $f4841d4502be35b2$export$77a85b13740d9b96 = async ({ commentId: commentId, markerRef: markerRef, contentId: contentId, fetchPolicy: fetchPolicy = 'network-only' })=>{
    if (!contentId || !commentId && !markerRef) return Promise.resolve(null);
    const response = await (0, $c0rhi.queryInterop)({
        query: $f4841d4502be35b2$var$commentByIdQuery,
        variables: {
            pageId: contentId,
            commentId: commentId || undefined,
            inlineMarkerRef: markerRef || undefined,
            // Query for all content statuses - don't filter by contentStatus
            contentStatus: (0, $NYiei.allContentStatuses)
        },
        fetchPolicy: fetchPolicy,
        __callerPackage__: "comments-data-manager"
    });
    const nodes = response?.data?.comments?.nodes;
    if (!nodes || nodes.length === 0) return null;
    // Filter out nulls and convert readonly array to mutable array
    const comments = nodes.filter((node)=>node !== null);
    return (0, $kgNLQ.findAndFilterComment)(comments, commentId, markerRef, (0, $NYiei.allContentStatuses));
};
module.exports["USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE"] = $f4841d4502be35b2$export$4bf99575c214d4b;
module.exports["useCommentById"] = $f4841d4502be35b2$export$778dda4ccca7793f;
module.exports["fetchCommentById"] = $f4841d4502be35b2$export$77a85b13740d9b96;

});

parcelRegister("dc3kb", function(module, exports) {
/**
 * @generated SignedSource<<1ab88c86ecf711245680266df88d829b>>
 * @relayHash 30943931b9ef970914fcabde1ec18427
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e72641598fb62206869fe26a1fc4981fbd345a6b2241970ee8cf4532c3ad8454
const $09771c757ee62765$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "inlineMarkerRef"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v4 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "type"
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v12 = {
        "kind": "LinkedField",
        "name": "contributors",
        "plural": true,
        "selections": [
            v6 /*: any*/ ,
            v7 /*: any*/ ,
            v9 /*: any*/ ,
            v11 /*: any*/ 
        ]
    }, v13 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v14 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v13 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v15 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v16 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v13 /*: any*/ 
    }, v17 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v18 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v19 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v21 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v22 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v23 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            v10 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ ,
                            v22 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ ,
                            v22 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v25 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v26 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v4 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "number"
    }, v28 = {
        "kind": "ScalarField",
        "name": "when"
    }, v29 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentId",
                    "variableName": "commentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Variable",
                    "name": "inlineMarkerRef",
                    "variableName": "inlineMarkerRef"
                },
                v4 /*: any*/ 
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        },
                        v12 /*: any*/ ,
                        v14 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ 
                            ]
                        },
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v17 /*: any*/ ,
                        v18 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        v25 /*: any*/ ,
                        v26 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v9 /*: any*/ 
                                    ]
                                },
                                v12 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                v26 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                v27 /*: any*/ ,
                                v28 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCommentByIdQuery",
            "selections": v29 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCommentByIdQuery",
            "selections": v29 /*: any*/ 
        },
        "params": {
            "cacheID": "30943931b9ef970914fcabde1ec18427",
            "id": "e72641598fb62206869fe26a1fc4981fbd345a6b2241970ee8cf4532c3ad8454",
            "metadata": {},
            "name": "useCommentByIdQuery",
            "operationKind": "query",
            "text": "query useCommentByIdQuery($pageId:ID!,$commentId:ID,$inlineMarkerRef:String,$contentStatus:[GraphQLContentStatus]){comments(pageId:$pageId,contentStatus:$contentStatus,commentId:$commentId,inlineMarkerRef:$inlineMarkerRef){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}}}}"
        }
    };
}();
$09771c757ee62765$var$node.hash = "e144cc71550d14f94a82d8439ed2ba0e";
var $09771c757ee62765$export$2e2bcd8739ae039 = $09771c757ee62765$var$node;
module.exports["default"] = $09771c757ee62765$export$2e2bcd8739ae039;

});

parcelRegister("NYiei", function(module, exports) {

var $1Pttz = parcelRequire("1Pttz");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $7Sm4c = parcelRequire("7Sm4c");


var $6mKj3 = parcelRequire("6mKj3");


var $kgNLQ = parcelRequire("kgNLQ");

const $bd3b81debc212a33$export$ef1591875b2a95ef = 1500;
const $bd3b81debc212a33$export$a1c5d5765ca44631 = [
    'DRAFT',
    'CURRENT',
    'ARCHIVED',
    'DELETED'
];
const $bd3b81debc212a33$export$a5752cd8da7feaeb = (0, $1Pttz.default);
const $bd3b81debc212a33$export$66fa4e722aa8c832 = (contentId)=>({
        pageId: contentId,
        contentStatus: $bd3b81debc212a33$export$a1c5d5765ca44631,
        first: $bd3b81debc212a33$export$ef1591875b2a95ef
    });
const $bd3b81debc212a33$var$addCommentRootToCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, newComment: newComment, repliesCount: repliesCount })=>{
    const updatedRootComments = [
        ...cachedRootComments
    ];
    let updatedTotalCount = totalCount;
    // If there is already a comment with the same ID in the root array, replace it
    // Normally this shouldn't happen because new comments should always have unique IDs, but there
    // is a case were this can happen with replies (see below) - so let's be safe and handle it just
    // in case it ever happens with root comments as well.
    const existingRootIndex = updatedRootComments.findIndex((comment)=>newComment?.id && comment?.id === newComment?.id);
    if (existingRootIndex !== -1) updatedRootComments[existingRootIndex] = newComment;
    else {
        // Else add the newly added comment to the end of the root comments list
        updatedRootComments.push(newComment);
        // Increment total count. Note that we can only add individual comments without any replies, but
        // let's be safe and adjust for any replies in case this ever changes
        updatedTotalCount += repliesCount + 1;
    }
    return {
        updatedRootComments: updatedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: undefined
    };
};
const $bd3b81debc212a33$var$addCommentReplyInCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, newComment: newComment, repliesCount: repliesCount, parentId: parentId })=>{
    // For replies, we need to add the reply from the top-level parent's replies list in the main
    // query's cache. This is because the reply arrays are actually flat arrays of Comment objects -
    // nested comments are not actually nested in the GQL data schema but stored flat in the root
    // parent's replies array with the parentId field that indicates which comment they really reply
    // to (we build the actual nested structure elsewhere in the FE). So to add a reply, we need to
    // find the top-level parent comment first.
    let updatedTotalCount = totalCount;
    let error = undefined;
    // First, find the top-level parent comment
    const parentComment = (0, $kgNLQ.findRootCommentForReply)(cachedRootComments, parentId);
    if (parentComment) {
        // Create a copy of the parent's replies array, as the original is readonly
        const updatedReplies = [
            ...parentComment.replies
        ];
        // If there is already a reply with the same ID in the parent's replies, replace it
        // Normally this shouldn't happen because new comments should always have unique IDs, but there
        // is a case were this can happen - when we're in edit mode and another user who is also in
        // edit mode also adds a reply to comment on the new text and then Updates the page -> we get
        // the new reply via the pubsub events and again when the new text is added by the Update.
        const existingReplyIndex = updatedReplies.findIndex((reply)=>newComment?.id && reply?.id === newComment?.id);
        if (existingReplyIndex !== -1) updatedReplies[existingReplyIndex] = newComment;
        else {
            // Else add the new  reply to the array
            updatedReplies.push(newComment);
            // Increment total count. We can only add individual comments without any replies, but let's be
            // safe and adjust for any replies in case this ever changes
            updatedTotalCount += 1 + repliesCount;
        }
        // Coerce the readonly replies array to be modifiable so we don't have to create new
        // modifiable comment objects all the way up the parent chain
        parentComment.replies = updatedReplies;
    } else // Parent comment not found
    error = Error(`Cannot add reply comment in cache: can not find parent comment with ID ${parentId}`);
    return {
        updatedRootComments: cachedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: error
    };
};
const $bd3b81debc212a33$var$addCommentToCache = ({ cachedRootComments: cachedRootComments, newComment: newComment, totalCount: totalCount })=>{
    // Update the appropriate part of the cache depending on whether it's a root comment or a reply
    const parentId = newComment?.parentId;
    const repliesCount = newComment?.replies?.length || 0;
    return !parentId ? $bd3b81debc212a33$var$addCommentRootToCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        newComment: newComment,
        repliesCount: repliesCount
    }) : $bd3b81debc212a33$var$addCommentReplyInCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        newComment: newComment,
        repliesCount: repliesCount,
        parentId: parentId
    });
};
const $bd3b81debc212a33$var$deleteRootCommentInCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, commentId: commentId, repliesCount: repliesCount })=>{
    let updatedTotalCount = totalCount;
    // Remove the newly resolved comment from the list if we can find it
    // Create a copy of the root comment array without the deleted reply, as the original is readonly
    const updatedRootComments = cachedRootComments.filter((comment)=>comment?.id !== commentId);
    // Decrement total count - currently we can't delete a reply that has any comments, but
    // let's be safe and adjust for any replies in case this ever changes
    updatedTotalCount -= 1 + repliesCount;
    return {
        updatedRootComments: updatedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: undefined
    };
};
const $bd3b81debc212a33$var$deleteCommentReplyInCache = ({ cachedRootComments: cachedRootComments, totalCount: totalCount, commentId: commentId, repliesCount: repliesCount, parentId: parentId })=>{
    // For replies, we need to remove the reply from the top-level comment's replies list in the main
    // query's cache. This is because the reply arrays are actually flat arrays of Comment objects -
    // nested comments are not actually nested in the GQL data schema but stored flat in the root
    // parent's replies array with the parentId field that indicates which comment they really reply
    // to (we build the actual nested structure elsewhere in the FE).  So to remove a reply, we need to
    // find the top-level parent comment first.
    let updatedTotalCount = totalCount;
    let error = undefined;
    // First, find the top-level parent comment
    const parentComment = (0, $kgNLQ.findRootCommentForReply)(cachedRootComments, parentId);
    if (parentComment) {
        // Create a copy of the parent's replies array without the deleted reply, as the original
        // is readonly
        const updatedReplies = (parentComment.replies || []).filter((reply)=>reply?.id !== commentId);
        // Coerce the readonly replies array to be modifiable so we don't have to create new
        // modifiable comment objects all the way up the parent chain
        parentComment.replies = updatedReplies;
        // Decrement total count. Currently we can't delete a reply that has any comments. Also
        // since we can’t have spread fragments in Relay-friendly queries yet, the current
        // CommentReply type doesn't have a `replies` field. And the backend, sends the nested
        // replies to us in a flat list with the correct parentIDs so the FE must manually nest
        // them. But let's adjust the count for replies just in case this ever changes.
        updatedTotalCount -= 1 + repliesCount;
    } else // Parent comment not found
    error = Error(`Cannot delete reply comment in cache: can not find parent comment with ID ${parentId}`);
    return {
        updatedRootComments: cachedRootComments,
        updatedTotalCount: updatedTotalCount,
        error: error
    };
};
const $bd3b81debc212a33$var$removeCommentFromCache = ({ cachedRootComments: cachedRootComments, commentId: commentId, totalCount: totalCount })=>{
    // Find the comment to delete to determine if it's a root comment or a reply
    const commentToDelete = (0, $kgNLQ.findCommentInData)(cachedRootComments, commentId);
    if (!commentToDelete) return {
        updatedRootComments: [],
        updatedTotalCount: 0,
        error: new Error(`Cannot delete comment in cache: comment with ID ${commentId} not found`)
    };
    // Update the appropriate part of the cache depending on whether it's a root comment or a reply
    const parentId = commentToDelete.parentId;
    const repliesCount = commentToDelete.replies?.length || 0;
    return !parentId ? $bd3b81debc212a33$var$deleteRootCommentInCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        commentId: commentId,
        repliesCount: repliesCount
    }) : $bd3b81debc212a33$var$deleteCommentReplyInCache({
        cachedRootComments: cachedRootComments,
        totalCount: totalCount,
        commentId: commentId,
        repliesCount: repliesCount,
        parentId: parentId
    });
};
const $bd3b81debc212a33$export$19f817fe57f17368 = ({ contentId: contentId, options: options = {} })=>{
    const { fetchPolicy: fetchPolicy = 'cache-first', onCompleted: parentOnCompleted, onError: onError } = options;
    // Shared handling for query errors (initial load and refetch): mark certain errors as handled, then invoke callback.
    // WS-3494 / COMMENTS-188
    const applyQueryErrorHandling = (0, $cozmU.useCallback)((error, callback)=>{
        if (error?.message?.search(/reactions/i) !== -1 || error?.message?.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
        callback?.(error);
    }, []);
    const handleQueryError = (0, $cozmU.useCallback)((error)=>applyQueryErrorHandling(error, onError), [
        applyQueryErrorHandling,
        onError
    ]);
    // Skip query if experiment is disabled, no content ID, or explicitly skipped
    const shouldSkip = !contentId || !!options.skip || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false);
    const queryResponse = (0, $jMyy4.useQueryInterop)($bd3b81debc212a33$export$a5752cd8da7feaeb, {
        variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId ?? ''),
        skip: shouldSkip,
        context: {
            single: true
        },
        fetchPolicy: // We auto-batch queries that fire within 10ms of eachother. Since this query is slow, this unbatches it to avoid slowing down everything else
        fetchPolicy,
        onCompleted: (data)=>{
            parentOnCompleted?.(data);
        },
        onError: handleQueryError,
        __callerPackage__: "comments-data-manager"
    });
    const refetch = (0, $cozmU.useCallback)(async ({ onError: refetchOnError } = {})=>{
        try {
            return await queryResponse.refetch();
        } catch (error) {
            applyQueryErrorHandling(error, refetchOnError ?? onError);
        }
    }, [
        queryResponse,
        applyQueryErrorHandling,
        onError
    ]);
    const addCommentInCache = (0, $cozmU.useCallback)(({ newComment: newComment, onError: onError })=>{
        // If the new comment is a root comment, we need to add it to the root comments list and
        // update the main query's cache and totalCount. If it's a reply, we need to add it to its
        // parent comments's replies list in the cache - but we still  update the whole main query
        // (vs. just update the parent comment itself via a fragment update) because we need to
        // update the main query's totalCount in the cache to keep everything in sync.
        try {
            // Read the (root level) query from the cache
            const dataProxy = (0, $l1uFv.readQueryInterop)({
                query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
                __callerPackage__: "comments-data-manager"
            });
            // Make a shallow copy that's not readonly if there are nodes (which are readonly),
            // otherwise use an empty array
            const nodes = dataProxy?.comments?.nodes ? [
                ...dataProxy?.comments?.nodes
            ] : [];
            const cachedRootComments = nodes.filter((comment)=>!!comment);
            const totalCount = dataProxy?.comments?.totalCount || 0;
            const { updatedRootComments: updatedRootComments, updatedTotalCount: updatedTotalCount, error: error } = $bd3b81debc212a33$var$addCommentToCache({
                cachedRootComments: cachedRootComments,
                newComment: newComment,
                totalCount: totalCount
            });
            if (error) {
                onError?.(error);
                return;
            }
            (0, $fEmGS.writeQueryInterop)({
                query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
                data: {
                    comments: {
                        nodes: updatedRootComments,
                        totalCount: updatedTotalCount,
                        __typename: 'PaginatedCommentList'
                    }
                },
                __callerPackage__: "comments-data-manager"
            });
        } catch (err) {
            onError?.(new Error(`An error occurred when adding new comment to cache with ID ${newComment?.id}: ${err}`));
        }
    }, [
        contentId
    ]);
    const deleteCommentInCache = (0, $cozmU.useCallback)(({ commentId: commentId, onError: onError })=>{
        // First, we try to find the comment to determine if it's a root comment or a reply.  If it's a
        // root comment, we need to remove it from the root comments list and update the main query's
        // cache and totalCount. If it's a reply, we need to update its parent comments's replies list
        // in the cache - but we still  update the whole main query (vs. just update the parent comment
        // itself via a fragment update) because we need to update the main query's totalCount in the
        // cache to keep everything in sync.
        try {
            // Read the (root level) query from the cache
            const dataProxy = (0, $l1uFv.readQueryInterop)({
                query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
                __callerPackage__: "comments-data-manager"
            });
            // Make a shallow copy that's not readonly if there are nodes (which are readonly),
            // otherwise use an empty array
            const nodes = dataProxy?.comments?.nodes ? [
                ...dataProxy?.comments?.nodes
            ] : [];
            const cachedRootComments = nodes.filter((comment)=>!!comment);
            const totalCount = dataProxy?.comments?.totalCount || 0;
            const { updatedRootComments: updatedRootComments, updatedTotalCount: updatedTotalCount, error: error } = $bd3b81debc212a33$var$removeCommentFromCache({
                cachedRootComments: cachedRootComments,
                commentId: commentId,
                totalCount: totalCount
            });
            if (error) {
                onError?.(error);
                return false;
            }
            (0, $fEmGS.writeQueryInterop)({
                query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
                variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
                data: {
                    comments: {
                        nodes: updatedRootComments,
                        totalCount: updatedTotalCount,
                        __typename: 'PaginatedCommentList'
                    }
                },
                __callerPackage__: "comments-data-manager"
            });
            return true;
        } catch (err) {
            onError?.(new Error(`An error occurred when deleting cached comment with ID ${commentId}: ${err}`));
            return false;
        }
    }, [
        contentId
    ]);
    return {
        loading: queryResponse.loading,
        error: queryResponse.error,
        refetch: refetch,
        data: queryResponse.data,
        addCommentInCache: addCommentInCache,
        deleteCommentInCache: deleteCommentInCache
    };
};
const $bd3b81debc212a33$export$713a041e7ad7d7c4 = (contentId)=>{
    const dataProxy = (0, $l1uFv.readQueryInterop)({
        query: $bd3b81debc212a33$export$a5752cd8da7feaeb,
        variables: $bd3b81debc212a33$export$66fa4e722aa8c832(contentId),
        __callerPackage__: "comments-data-manager"
    });
    return dataProxy;
};
module.exports["MAX_COMMENTS_TO_RETURN"] = $bd3b81debc212a33$export$ef1591875b2a95ef;
module.exports["allContentStatuses"] = $bd3b81debc212a33$export$a1c5d5765ca44631;
module.exports["useAllCommentsData"] = $bd3b81debc212a33$export$19f817fe57f17368;
module.exports["getCommentsDataFromCache"] = $bd3b81debc212a33$export$713a041e7ad7d7c4;

});

parcelRegister("1Pttz", function(module, exports) {
/**
 * @generated SignedSource<<88a71c42d0cb01ab5e7d98601a8ad2dc>>
 * @relayHash e661073d22fa388ab2cfa6921674c35d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a72eb2929d0b453a77d38c0daac00993d0e7ed83ff549852056b0cf9f11bcde6
const $e5d3dc3314ebdbc2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v8 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v11 = {
        "kind": "LinkedField",
        "name": "contributors",
        "plural": true,
        "selections": [
            v5 /*: any*/ ,
            v6 /*: any*/ ,
            v8 /*: any*/ ,
            v10 /*: any*/ 
        ]
    }, v12 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v13 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v12 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v14 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v15 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v12 /*: any*/ 
    }, v16 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v17 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v19 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v21 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v22 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v9 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v24 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v25 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "number"
    }, v27 = {
        "kind": "ScalarField",
        "name": "when"
    }, v28 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Literal",
                    "name": "depth",
                    "value": "ROOT"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                v3 /*: any*/ 
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ 
                            ]
                        },
                        v11 /*: any*/ ,
                        v13 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ 
                            ]
                        },
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v17 /*: any*/ ,
                        v22 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        v25 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v11 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                v26 /*: any*/ ,
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                },
                v5 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useAllCommentsDataQuery",
            "selections": v28 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useAllCommentsDataQuery",
            "selections": v28 /*: any*/ 
        },
        "params": {
            "cacheID": "e661073d22fa388ab2cfa6921674c35d",
            "id": "a72eb2929d0b453a77d38c0daac00993d0e7ed83ff549852056b0cf9f11bcde6",
            "metadata": {},
            "name": "useAllCommentsDataQuery",
            "operationKind": "query",
            "text": "query useAllCommentsDataQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$first:Long!){comments(pageId:$pageId,contentStatus:$contentStatus,depth:ROOT,first:$first){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}},totalCount,__typename}}"
        }
    };
}();
$e5d3dc3314ebdbc2$var$node.hash = "776a014f361baa317c627109df7aaaa3";
var $e5d3dc3314ebdbc2$export$2e2bcd8739ae039 = $e5d3dc3314ebdbc2$var$node;
module.exports["default"] = $e5d3dc3314ebdbc2$export$2e2bcd8739ae039;

});

parcelRegister("1rdvc", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 *
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $39a1d37ae379d69e$export$b634e5de755b7d35 = /*#__PURE__*/ function(GraphQLContentStatus) {
    GraphQLContentStatus["ARCHIVED"] = "ARCHIVED";
    GraphQLContentStatus["CURRENT"] = "CURRENT";
    GraphQLContentStatus["DELETED"] = "DELETED";
    GraphQLContentStatus["DRAFT"] = "DRAFT";
    return GraphQLContentStatus;
}({});
module.exports["GraphQLContentStatus"] = $39a1d37ae379d69e$export$b634e5de755b7d35;

});

parcelRegister("6GD8y", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2944f0e1873f71ce$export$90839ff33b4905a0 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "pU1rv",
    name: "GeneralShortcutListener",
    loader: async ()=>(await (parcelRequire("cPt0K"))).GeneralShortcutListener
});
module.exports["GeneralShortcutListener"] = $2944f0e1873f71ce$export$90839ff33b4905a0;

});

parcelRegister("cPt0K", function(module, exports) {

let $9570c06e3b725460$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9570c06e3b725460$var$load("3kVph"),
    $9570c06e3b725460$var$load("hhss7"),
    $9570c06e3b725460$var$load("kpHRm")
]).then(()=>parcelRequire('3w3bV'));

});

parcelRegister("gnkil", function(module, exports) {
// Note: When modifying shortcut settings, make sure to test across all input fields on the page.
// Some input fields may not have shortcuts fully disabled, which could cause conflicts with shortcuts.
// Ensure that the new shortcuts do not interfere with normal input field operations.
// When making change in this file, make sure the corresponding tab in @confluence/keyboard-shortcuts-dialog is also updated
// Shortcuts for editor2
const $e13bb5c64c0a0eec$export$170fefa3f8a9258a = {
    PUBLISH: 'mod+enter',
    PUBLISH_WITH_COMMENT: 'mod+shift+enter',
    EDIT: 'e',
    PREVIEW: 'mod+shift+e',
    UNDO: 'mod+z',
    REDO: 'mod+shift+z',
    FIND_REPLACE: 'mod+f'
};
const $e13bb5c64c0a0eec$export$1cbe44c5850db728 = 'mod+s';
const $e13bb5c64c0a0eec$export$73148f05a63f43f = 'command+enter';
const $e13bb5c64c0a0eec$export$67c56ed34ece0f2a = 'mod+enter';
const $e13bb5c64c0a0eec$export$c19d729632cce38f = 'b';
const $e13bb5c64c0a0eec$export$e896f39257754358 = 'c';
const $e13bb5c64c0a0eec$export$c9d367283380f242 = 'f';
const $e13bb5c64c0a0eec$export$44da7c32f8b979f6 = 'm';
const $e13bb5c64c0a0eec$export$f10fe393178b1b45 = 'k';
const $e13bb5c64c0a0eec$export$3837d28de95f38e = 'e';
const $e13bb5c64c0a0eec$export$99088c948bf0270f = 'r';
const $e13bb5c64c0a0eec$export$ddb528ae2130e6f3 = 'w';
const $e13bb5c64c0a0eec$export$95a205588c16f013 = 's';
const $e13bb5c64c0a0eec$export$f7fab4391dadca28 = 'l';
const $e13bb5c64c0a0eec$export$2f62883c954429eb = 't';
const $e13bb5c64c0a0eec$export$96f161bee6b4340d = 'n';
const $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172 = 'p';
const $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031 = 'g f';
const $e13bb5c64c0a0eec$export$b947af6524920798 = 'g g';
const $e13bb5c64c0a0eec$export$53e346b715d2b7c7 = 'g d';
const $e13bb5c64c0a0eec$export$8cb32cdc75719ad2 = 'g n';
const $e13bb5c64c0a0eec$export$b4842d8ad92c38a3 = 'g r';
const $e13bb5c64c0a0eec$export$298e62593d4ef85 = 'g s';
const $e13bb5c64c0a0eec$export$5d4720de35488ecb = 'g s';
const $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7 = 'g o';
const $e13bb5c64c0a0eec$export$f5473855a7a167a7 = 'g c';
const $e13bb5c64c0a0eec$export$cee4257b1a828f0d = '/';
const $e13bb5c64c0a0eec$export$159e447a25b21930 = '[';
const $e13bb5c64c0a0eec$export$922297bddc2a63e6 = 'mod+z';
const $e13bb5c64c0a0eec$export$420825475f86fe8d = 'left';
const $e13bb5c64c0a0eec$export$db9252a2db2b8e9e = 'right';
const $e13bb5c64c0a0eec$export$faa4136cec2aa7a0 = '?';
const $e13bb5c64c0a0eec$export$362c0171844ea600 = 'a';
const $e13bb5c64c0a0eec$export$5d80e625aa457659 = ']';
const $e13bb5c64c0a0eec$export$cc9bab4159e8aec9 = 'e';
const $e13bb5c64c0a0eec$export$285e80cf6c078ba6 = 'mod+shift+e';
const $e13bb5c64c0a0eec$export$8d0081a3f70f258c = 'ctrl+.';
const $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14 = 'ctrl+,';
const $e13bb5c64c0a0eec$export$de4065c6a68e4031 = 'mod+option+c';
const $e13bb5c64c0a0eec$export$b5f3b4e8358360b3 = 'ctrl+shift+d';
const $e13bb5c64c0a0eec$export$9cee57908df99565 = 'ctrl+option+n';
const $e13bb5c64c0a0eec$export$b0a212f4fb6d9350 = 'mod+shift+u';
const $e13bb5c64c0a0eec$export$986cc862e5f6eec1 = 'mod+option+r';
const $e13bb5c64c0a0eec$export$d3b6b270c6770b4f = 'ctrl+option+r';
const $e13bb5c64c0a0eec$export$adb85b0fd79d17f8 = 'ctrl+]';
const $e13bb5c64c0a0eec$export$1822b04007c39b0c = 'mod+option+shift+b';
const $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99 = 'ctrl+option+c';
const $e13bb5c64c0a0eec$export$f5ba0af3c65d3125 = 'meta+alt+c';
const $e13bb5c64c0a0eec$export$c372eed375f60e68 = 'ctrl+shift+/';
const $e13bb5c64c0a0eec$export$406fcfa6807667 = 'ctrl+[';
const $e13bb5c64c0a0eec$export$4ec29504bd71f204 = 'ctrl+option+f';
const $e13bb5c64c0a0eec$export$4148526d63a5bc01 = 'mod+option+o';
const $e13bb5c64c0a0eec$export$b7088d9be4883093 = 'ctrl+option+z';
const $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c = 'alt+shift+z';
const $e13bb5c64c0a0eec$export$2bdd2e57d23976c4 = 'mod+option+h';
const $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899 = 'mod+option+g';
const $e13bb5c64c0a0eec$export$18a9bb0de7844bb6 = 'mod+option+8';
const $e13bb5c64c0a0eec$export$3fe2d0f3fe115364 = 'mod+option+v';
const $e13bb5c64c0a0eec$export$a3e38cca130cbc49 = 'mod+option+w';
const $e13bb5c64c0a0eec$export$a769ea2ac46f94da = 'ctrl+option+w';
const $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd = 'mod+option+s';
const $e13bb5c64c0a0eec$export$4bc8c55d04859f5a = 'ctrl+shift+i';
const $e13bb5c64c0a0eec$export$1f53991bf9b208a0 = 'ctrl+option+a';
const $e13bb5c64c0a0eec$export$650d7b87402f841f = 'ctrl+option+t';
const $e13bb5c64c0a0eec$export$dc2c2f2eed832016 = 'meta+alt+t';
const $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d = 'mod+.';
const $e13bb5c64c0a0eec$export$c252fe6b173dfad3 = 'ctrl+meta+.';
const $e13bb5c64c0a0eec$export$a1552937ff7cca64 = 'mod+option+k';
const $e13bb5c64c0a0eec$export$f7727b957c03a88b = 'mod+option+e';
const $e13bb5c64c0a0eec$export$f0043475aa91a151 = 'alt+meta+x';
const $e13bb5c64c0a0eec$export$bc654500edb91b60 = 'mod+shift+x';
module.exports["EDITOR2_SHORTCUTS"] = $e13bb5c64c0a0eec$export$170fefa3f8a9258a;
module.exports["BROWSER_SAVE_SHORTCUT"] = $e13bb5c64c0a0eec$export$1cbe44c5850db728;
module.exports["COMMENT_EDITOR_SHORTCUT"] = $e13bb5c64c0a0eec$export$73148f05a63f43f;
module.exports["INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$67c56ed34ece0f2a;
module.exports["BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$c19d729632cce38f;
module.exports["GLOBAL_CREATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$e896f39257754358;
module.exports["STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$c9d367283380f242;
module.exports["CREATE_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$44da7c32f8b979f6;
module.exports["LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f10fe393178b1b45;
module.exports["EDIT_SHORTCUT"] = $e13bb5c64c0a0eec$export$3837d28de95f38e;
module.exports["PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$99088c948bf0270f;
module.exports["WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddb528ae2130e6f3;
module.exports["SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$95a205588c16f013;
module.exports["LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7fab4391dadca28;
module.exports["VIEW_ATTACHMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$2f62883c954429eb;
module.exports["NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$96f161bee6b4340d;
module.exports["PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172;
module.exports["SUBMIT_FEEDBACK_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031;
module.exports["NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$b947af6524920798;
module.exports["GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$53e346b715d2b7c7;
module.exports["NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$8cb32cdc75719ad2;
module.exports["GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b4842d8ad92c38a3;
module.exports["GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$298e62593d4ef85;
module.exports["SPACE_OVERVIEW_SHORTCUT_NAV_3"] = $e13bb5c64c0a0eec$export$5d4720de35488ecb;
module.exports["SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7;
module.exports["AI_MATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f5473855a7a167a7;
module.exports["NAVIGATION_SLASH_SHORTCUT"] = $e13bb5c64c0a0eec$export$cee4257b1a828f0d;
module.exports["SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$159e447a25b21930;
module.exports["UNDO_SHORTCUT"] = $e13bb5c64c0a0eec$export$922297bddc2a63e6;
module.exports["PREV_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$420825475f86fe8d;
module.exports["NEXT_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$db9252a2db2b8e9e;
module.exports["HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$faa4136cec2aa7a0;
module.exports["AUTOMATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$362c0171844ea600;
module.exports["TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER"] = $e13bb5c64c0a0eec$export$5d80e625aa457659;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_EDIT"] = $e13bb5c64c0a0eec$export$cc9bab4159e8aec9;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_VIEW"] = $e13bb5c64c0a0eec$export$285e80cf6c078ba6;
module.exports["UNIVERSAL_NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$8d0081a3f70f258c;
module.exports["UNIVERSAL_PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14;
module.exports["UNIVERSAL_OPEN_COMMENT_EDITOR"] = $e13bb5c64c0a0eec$export$de4065c6a68e4031;
module.exports["UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT"] = $e13bb5c64c0a0eec$export$b5f3b4e8358360b3;
module.exports["UNIVERSAL_CREATE_NOTE_SHORTCUT"] = $e13bb5c64c0a0eec$export$9cee57908df99565;
module.exports["UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b0a212f4fb6d9350;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$986cc862e5f6eec1;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$d3b6b270c6770b4f;
module.exports["UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$adb85b0fd79d17f8;
module.exports["UNIVERSAL_BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$1822b04007c39b0c;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$f5ba0af3c65d3125;
module.exports["UNIVERSAL_HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$c372eed375f60e68;
module.exports["UNIVERSAL_SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$406fcfa6807667;
module.exports["UNIVERSAL_STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$4ec29504bd71f204;
module.exports["UNIVERSAL_NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$4148526d63a5bc01;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$b7088d9be4883093;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c;
module.exports["UNIVERSAL_GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$2bdd2e57d23976c4;
module.exports["UNIVERSAL_GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899;
module.exports["UNIVERSAL_GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$18a9bb0de7844bb6;
module.exports["UNIVERSAL_SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$3fe2d0f3fe115364;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$a3e38cca130cbc49;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$a769ea2ac46f94da;
module.exports["UNIVERSAL_SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd;
module.exports["UNIVERSAL_OPEN_DETAILS_PANEL_SHORTCUT"] = $e13bb5c64c0a0eec$export$4bc8c55d04859f5a;
module.exports["UNIVERSAL_LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$1f53991bf9b208a0;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$650d7b87402f841f;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$dc2c2f2eed832016;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$c252fe6b173dfad3;
module.exports["UNIVERSAL_LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$a1552937ff7cca64;
module.exports["UNIVERSAL_SELECT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7727b957c03a88b;
module.exports["UNIVERSAL_OPEN_DEVTOOLS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0043475aa91a151;
module.exports["UNIVERSAL_TOGGLE_MARKDOWN_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$bc654500edb91b60;

});

parcelRegister("fHAwL", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $7fff4328005dca96$var$initialState = {
    // isUpdatingUnreadComments tracks when we're updating the unread comments set
    // (e.g., during initial render or when manually updating the set).
    isUpdatingUnreadComments: true,
    // isUnreadQueryLoading tracks when we're actively fetching comments from the server.
    isUnreadQueryLoading: false,
    unreadCommentIDSet: new Set(),
    shouldClearVisibleThreads: false
};
const $7fff4328005dca96$var$actions = {
    setIsUpdatingUnreadComments: (isUpdatingUnreadComments)=>({ setState: setState })=>{
            setState({
                isUpdatingUnreadComments: isUpdatingUnreadComments
            });
        },
    setIsUnreadQueryLoading: (loading)=>({ setState: setState })=>{
            setState({
                isUnreadQueryLoading: loading
            });
        },
    updateUnreadCommentIDSet: (unreadCommentIDSet, operation = 'initialize')=>({ setState: setState, getState: getState })=>{
            const { unreadCommentIDSet: existingSet } = getState();
            switch(operation){
                case 'initialize':
                    setState({
                        unreadCommentIDSet: unreadCommentIDSet
                    });
                    break;
                case 'add':
                    setState({
                        unreadCommentIDSet: new Set([
                            ...existingSet,
                            ...unreadCommentIDSet
                        ])
                    });
                    break;
                case 'remove':
                    const newSet = new Set(existingSet);
                    unreadCommentIDSet.forEach((id)=>newSet.delete(id));
                    setState({
                        unreadCommentIDSet: newSet
                    });
                    break;
                case 'removeAll':
                    setState({
                        unreadCommentIDSet: new Set()
                    });
                    break;
            }
        },
    setShouldClearVisibleThreads: (shouldClearVisibleThreads)=>({ setState: setState })=>{
            setState({
                shouldClearVisibleThreads: shouldClearVisibleThreads
            });
        }
};
const $7fff4328005dca96$var$UnreadCommentsStore = (0, $8s9DV.createStore)({
    initialState: $7fff4328005dca96$var$initialState,
    actions: $7fff4328005dca96$var$actions,
    name: 'UnreadCommentsStore'
});
const $7fff4328005dca96$export$df6365a5248dcd96 = (0, $kBr4q.createHook)($7fff4328005dca96$var$UnreadCommentsStore);
const $7fff4328005dca96$export$b7fe87478f70c759 = (0, $kBr4q.createActionsHook)($7fff4328005dca96$var$UnreadCommentsStore);
const $7fff4328005dca96$export$fdd0a0c032c12265 = (0, $kBr4q.createStateHook)($7fff4328005dca96$var$UnreadCommentsStore);
module.exports["useUnreadComments"] = $7fff4328005dca96$export$df6365a5248dcd96;
module.exports["useUnreadCommentsActions"] = $7fff4328005dca96$export$b7fe87478f70c759;
module.exports["useUnreadCommentsState"] = $7fff4328005dca96$export$fdd0a0c032c12265;

});

parcelRegister("izhdc", function(module, exports) {

var $8i27m = parcelRequire("8i27m");

const $fd72c77cd5bf52d0$export$8a92cb9a88bcfd3b = (currentlyRenderedThreads, unresolvedInlineComments)=>{
    // Grab everything on the screen as a set for quick access
    const allRenderedInlineCommentIds = new Set(unresolvedInlineComments);
    // Grab all of the refs for inline comments that are available on the panel
    const panelCommentRefs = currentlyRenderedThreads.map((comment)=>{
        if (comment.type === 'INLINE') {
            if ('inlineMarkerRef' in comment && comment.inlineMarkerRef) return {
                ref: comment.inlineMarkerRef,
                type: (0, $8i27m.CommentType).INLINE
            };
            else return {
                ref: '',
                type: (0, $8i27m.CommentType).INLINE
            };
        } else return {
            ref: comment.id,
            type: (0, $8i27m.CommentType).GENERAL
        };
    }).filter((comment)=>{
        return comment.ref !== '';
    });
    // Grab the refs that we can navigate too (aka the ones rendered on the page, so open (i.e. not resolved) comments)
    const navigableInlineCommentRefs = new Set(panelCommentRefs.map((comment)=>{
        if (comment.type === (0, $8i27m.CommentType).INLINE) return allRenderedInlineCommentIds.has(comment.ref) ? comment.ref : '';
        else return comment.ref;
    }));
    return {
        panelCommentRefs: panelCommentRefs,
        navigableInlineCommentRefs: navigableInlineCommentRefs
    };
};
const $fd72c77cd5bf52d0$export$6fbaa3cb5c58ff29 = (action, panelCommentRefs, currentlySelectedThreadKey)=>{
    let nextIndex = panelCommentRefs.findIndex((comment)=>{
        return comment.ref === currentlySelectedThreadKey;
    });
    if (nextIndex === -1) nextIndex = 0;
    else if (action === 'next') nextIndex = (nextIndex + 1) % panelCommentRefs.length;
    else nextIndex = (nextIndex - 1 + panelCommentRefs.length) % panelCommentRefs.length;
    return panelCommentRefs[nextIndex];
};
module.exports["parsePanelAndInlineRefs"] = $fd72c77cd5bf52d0$export$8a92cb9a88bcfd3b;
module.exports["getNextRef"] = $fd72c77cd5bf52d0$export$6fbaa3cb5c58ff29;

});

parcelRegister("gSkOQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aSsfA = parcelRequire("aSsfA");


var $6lAIr = parcelRequire("6lAIr");


var $i6UMJ = parcelRequire("i6UMJ");


var $8i27m = parcelRequire("8i27m");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");

const $89de80864b4e19fe$export$618f651f678380bf = ()=>{
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, commentsDataMap: legacyCommentsDataMap } = (0, $8i27m.useCommentsDataState)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    const commentsDataMap = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? processedCommentsData.commentsDataMap : legacyCommentsDataMap;
    return (0, $cozmU.useMemo)(()=>{
        const footerCommentThreads = (0, $6lAIr.getVisibleCommentThreads)({
            includeGeneralComments: true,
            commentsDataMap: commentsDataMap,
            includeInlineComments: false,
            orderedAnnotationIds: (0, $i6UMJ.getAnnotationThreadKeys)(orderedActiveAnnotationIdList),
            pageMode: pageMode
        });
        const footerCommentIds = footerCommentThreads.map((thread)=>thread.id);
        return {
            footerCommentIds: footerCommentIds,
            footerCommentThreads: footerCommentThreads
        };
    }, [
        commentsDataMap,
        orderedActiveAnnotationIdList,
        pageMode
    ]);
};
module.exports["useFooterComments"] = $89de80864b4e19fe$export$618f651f678380bf;

});

parcelRegister("6lAIr", function(module, exports) {

var $cD1qu = parcelRequire("cD1qu");


var $8i27m = parcelRequire("8i27m");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $i6UMJ = parcelRequire("i6UMJ");


var $3mVfX = parcelRequire("3mVfX");

const $475d5d8641a18b80$var$isParentCommentOpen = (commentData)=>commentData.isOpen;
const $475d5d8641a18b80$var$wasCommentRemovedByAnotherUser = (comment)=>Boolean(comment.wasRemovedByAnotherUser);
const $475d5d8641a18b80$var$wasCommentDeletedByAnotherUser = (comment)=>comment.wasRemovedByAnotherUser === (0, $8i27m.CommentActionType).DELETE_COMMENT;
const $475d5d8641a18b80$var$isInlineLocation = (location)=>{
    return location && 'inlineMarkerRef' in location;
};
const $475d5d8641a18b80$var$isParentComment = (comment)=>'isOpen' in comment;
const $475d5d8641a18b80$var$getVisibleGeneralComments = ({ isCommentValid: isCommentValid, comments: comments })=>Object.values(comments).reduce((acc, comment)=>{
        if (isCommentValid(comment)) acc.push({
            ...comment,
            replies: comment.replies.filter((reply)=>reply && isCommentValid(reply))
        });
        return acc;
    }, []);
const $475d5d8641a18b80$var$getNextInlineResolveProperties = (inlineResolveProperties, isDangling)=>{
    if (!inlineResolveProperties) return {};
    return {
        inlineResolveProperties: {
            ...inlineResolveProperties,
            isDangling: isDangling
        }
    };
};
const $475d5d8641a18b80$var$updateCommentLocation = (comment, isDangling)=>{
    const commentLocation = comment.location;
    if (!$475d5d8641a18b80$var$isInlineLocation(commentLocation)) return commentLocation;
    // When the experiment is enabled and the resolved-properties spread would
    // produce a structurally identical object (i.e. isDangling is unchanged
    // and there are no inlineResolveProperties to merge), short-circuit by
    // returning the existing location reference. This stops every render of
    // CommentsPanelList from minting a new `location` object — which today
    // cascades into a new `comment` object via getNextComment, breaking
    // React.memo on the row components.
    if ((0, $6mKj3.expValEquals)('confluence_comments_panel_memo_rows', 'isEnabled', true)) {
        const existingResolveProperties = commentLocation.inlineResolveProperties;
        if (!existingResolveProperties) // Nothing to merge in; the spread would produce an equivalent object.
        return commentLocation;
        if (existingResolveProperties.isDangling === isDangling) // All fields would be identical; preserve reference.
        return commentLocation;
    }
    return {
        ...commentLocation,
        ...$475d5d8641a18b80$var$getNextInlineResolveProperties(commentLocation.inlineResolveProperties, isDangling)
    };
};
const $475d5d8641a18b80$var$getNextComment = (comment, isDangling)=>{
    // When the experiment is enabled, only allocate a new wrapper if the
    // derived `location` actually changed. updateCommentLocation now returns
    // the original location reference when it would be structurally identical,
    // so we can safely short-circuit here on referential equality.
    if ((0, $6mKj3.expValEquals)('confluence_comments_panel_memo_rows', 'isEnabled', true)) {
        const nextLocation = $475d5d8641a18b80$var$updateCommentLocation(comment, isDangling);
        if (nextLocation === comment.location) return comment;
        return {
            ...comment,
            location: nextLocation
        };
    }
    const { replies: replies, ...rest } = comment;
    return {
        ...rest,
        replies: replies,
        location: $475d5d8641a18b80$var$updateCommentLocation(comment, isDangling)
    };
};
const $475d5d8641a18b80$var$getVisibleInlineComments = (isCommentValid, comments, orderedAnnotationIds, _isNewDanglingCommentExperienceEnabled)=>{
    const activeMarkerRefs = new Set(orderedAnnotationIds);
    const nonDangling = [];
    const dangling = [];
    const validComments = Object.values(comments).reduce((acc, comment)=>{
        if (isCommentValid(comment)) {
            if ((0, $6mKj3.expValEquals)('confluence_comments_panel_memo_rows', 'isEnabled', true)) {
                // Only build a new replies array if filtering would actually drop
                // any entries; otherwise reuse the original array reference. Then
                // only build a new comment wrapper if the replies reference
                // changed. This keeps the input reference whenever the validity
                // status of the comment and its replies is unchanged across
                // renders, allowing React.memo on row components to bail out.
                const filteredReplies = comment.replies.filter(isCommentValid);
                const replies = filteredReplies.length === comment.replies.length ? comment.replies : filteredReplies;
                if (replies === comment.replies) acc.push(comment);
                else acc.push({
                    ...comment,
                    replies: replies
                });
            } else acc.push({
                ...comment,
                replies: (comment.replies ?? []).filter(isCommentValid)
            });
        }
        return acc;
    }, []);
    for (const comment of validComments){
        const commentLocation = comment.location;
        const inlineMarkerRef = $475d5d8641a18b80$var$isInlineLocation(commentLocation) ? commentLocation.inlineMarkerRef : null;
        const isDangling = !inlineMarkerRef || !activeMarkerRefs.has(inlineMarkerRef);
        const updatedComment = $475d5d8641a18b80$var$getNextComment(comment, isDangling);
        if (isDangling) dangling.push(updatedComment);
        else nonDangling.push(updatedComment);
    }
    return [
        nonDangling,
        dangling
    ];
};
const $475d5d8641a18b80$export$70df9f207ee9869d = (comment)=>{
    if ($475d5d8641a18b80$var$wasCommentDeletedByAnotherUser(comment)) return false;
    return $475d5d8641a18b80$var$isParentComment(comment) ? !$475d5d8641a18b80$var$isParentCommentOpen(comment) : true;
};
const $475d5d8641a18b80$export$28d3eb19856355d7 = (comment)=>{
    if ($475d5d8641a18b80$var$wasCommentRemovedByAnotherUser(comment)) return false;
    return $475d5d8641a18b80$var$isParentComment(comment) ? $475d5d8641a18b80$var$isParentCommentOpen(comment) : true;
};
const $475d5d8641a18b80$var$sortInlineCommentsByOrderedActiveAnnotationIdList = (comments, orderedAnnotationIds)=>{
    const commentsByMarkerRef = new Map(comments.map((comment)=>{
        const commentLocation = comment.location;
        const inlineMarkerRef = $475d5d8641a18b80$var$isInlineLocation(commentLocation) ? commentLocation.inlineMarkerRef : null;
        return [
            inlineMarkerRef,
            comment
        ];
    }));
    return orderedAnnotationIds.map((id)=>commentsByMarkerRef.get(id)).filter((comment)=>comment !== undefined);
};
const $475d5d8641a18b80$var$getVisibleInlineThreadsForView = (currentView, sortedNonDanglingComments, danglingComments)=>{
    switch(currentView){
        case (0, $3mVfX.ViewValues).OPEN:
            return sortedNonDanglingComments;
        case (0, $3mVfX.ViewValues).DELETED_CONTENT:
            return danglingComments;
        default:
            return [
                ...sortedNonDanglingComments,
                ...danglingComments
            ];
    }
};
const $475d5d8641a18b80$var$getVisibleInlineThreads = ({ isCommentValid: isCommentValid, commentsDataMap: commentsDataMap, orderedAnnotationIds: orderedAnnotationIds, currentView: currentView, isNewDanglingCommentExperienceEnabled: isNewDanglingCommentExperienceEnabled })=>{
    const [nonDanglingComments, danglingComments] = $475d5d8641a18b80$var$getVisibleInlineComments(isCommentValid, commentsDataMap.inline, orderedAnnotationIds, isNewDanglingCommentExperienceEnabled);
    const sortedNonDanglingComments = $475d5d8641a18b80$var$sortInlineCommentsByOrderedActiveAnnotationIdList(nonDanglingComments, orderedAnnotationIds);
    const visibleInlineThreadsForView = isNewDanglingCommentExperienceEnabled ? $475d5d8641a18b80$var$getVisibleInlineThreadsForView(currentView, sortedNonDanglingComments, danglingComments) : [
        ...sortedNonDanglingComments,
        ...danglingComments
    ];
    return visibleInlineThreadsForView;
};
const $475d5d8641a18b80$var$getIsCommentValid = ({ currentView: currentView })=>{
    switch(currentView){
        case (0, $3mVfX.ViewValues).RESOLVED:
            return $475d5d8641a18b80$export$70df9f207ee9869d;
        default:
            return $475d5d8641a18b80$export$28d3eb19856355d7;
    }
};
// Determine if general comments are enabled based on the user's selection and - if using the new
// Comments Data Manager -  the user is not in Edit mode. In the legacy commments data management,
// general comments were not loaded into the commentsDataMap when the page is in Edit mode and thus
// not added to the visible threads list. But in the Comments Data Manager, all comments are loaded
// regardless of the page mode, and since we still don't want to have general comments in the list
// in Edit mode we need to explicitly hide them.
const $475d5d8641a18b80$var$isGeneralCommentsEnabled = ({ includeGeneralComments: includeGeneralComments, pageMode: pageMode })=>(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? includeGeneralComments && pageMode !== (0, $cD1qu.PageMode).EDIT : includeGeneralComments;
const $475d5d8641a18b80$export$cbe812921774e978 = ({ commentsDataMap: commentsDataMap, orderedAnnotationIds: orderedAnnotationIds, includeInlineComments: includeInlineComments, includeGeneralComments: includeGeneralComments, currentView: currentView = (0, $3mVfX.ViewValues).OPEN, isNewDanglingCommentExperienceEnabled: isNewDanglingCommentExperienceEnabled = (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux'), isCommentValid: providedIsCommentValid, pageMode: pageMode })=>{
    const threads = [];
    const isCommentValid = providedIsCommentValid ?? $475d5d8641a18b80$var$getIsCommentValid({
        currentView: currentView
    });
    if (includeInlineComments) {
        const inlineThreads = $475d5d8641a18b80$var$getVisibleInlineThreads({
            isCommentValid: isCommentValid,
            commentsDataMap: commentsDataMap,
            orderedAnnotationIds: orderedAnnotationIds,
            currentView: currentView,
            isNewDanglingCommentExperienceEnabled: isNewDanglingCommentExperienceEnabled
        });
        threads.push(...inlineThreads);
    }
    if ($475d5d8641a18b80$var$isGeneralCommentsEnabled({
        includeGeneralComments: includeGeneralComments,
        pageMode: pageMode
    })) {
        const generalThreads = $475d5d8641a18b80$var$getVisibleGeneralComments({
            isCommentValid: isCommentValid,
            comments: commentsDataMap.general
        }).sort((0, $i6UMJ.getCommentsSortedOldestToNewest));
        threads.push(...generalThreads);
    }
    return threads;
};
module.exports["isCommentOpen"] = $475d5d8641a18b80$export$28d3eb19856355d7;
module.exports["getVisibleCommentThreads"] = $475d5d8641a18b80$export$cbe812921774e978;

});

parcelRegister("i6UMJ", function(module, exports) {

var $9B4fQ = parcelRequire("9B4fQ");


var $422HI = parcelRequire("422HI");


var $7Oxky = parcelRequire("7Oxky");


var $8i27m = parcelRequire("8i27m");


var $6faGq = parcelRequire("6faGq");


var $3mVfX = parcelRequire("3mVfX");

const $6ed006a18ff2d87d$var$SCROLLED_COMMENTS_HEADER_GAP_SIZE_IN_PIXELS = 8;
const $6ed006a18ff2d87d$var$NUM_HIDDEN_PIXELS_TO_BE_CONSIDERED_OUT_OF_VIEW = 60;
const $6ed006a18ff2d87d$var$getTotalOffsetAboveCommentsPanelThreads = (generalCommentsHeaderHeight)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    let objectSidebarPanelHeader = document.querySelector("[data-testid='object-sidebar-panel-header']");
    let additionalOffset = 0;
    if (!objectSidebarPanelHeader) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        objectSidebarPanelHeader = document.querySelector("[data-testid='scrolled-object-sidebar-panel-header']");
        additionalOffset = $6ed006a18ff2d87d$var$SCROLLED_COMMENTS_HEADER_GAP_SIZE_IN_PIXELS;
    }
    const objectSidebarPanelHeaderHeight = objectSidebarPanelHeader?.getBoundingClientRect().height ?? 0;
    const objectHeaderHeight = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[data-testid='object-header-container']")?.getBoundingClientRect().height ?? 0;
    const topNavContainerHeight = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[data-testid='grid-topNav']")?.getBoundingClientRect().height ?? 0;
    const bannerContainerHeight = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[data-testid='banner-container']")?.getBoundingClientRect().height ?? 0;
    const editorControlsOnboardingBannerHeight = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[data-testid='editor-controls-onboarding-banner']")?.getBoundingClientRect().height ?? 0;
    const announcementBannerHeight = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[id='AkBanner']")?.getBoundingClientRect().height ?? 0;
    return objectSidebarPanelHeaderHeight + objectHeaderHeight + topNavContainerHeight + bannerContainerHeight + additionalOffset + generalCommentsHeaderHeight + editorControlsOnboardingBannerHeight + announcementBannerHeight;
};
const $6ed006a18ff2d87d$export$4d211f4974dcf196 = (commentThreadElement, commentType)=>{
    const commentThreadRect = commentThreadElement.getBoundingClientRect();
    const generalCommentsHeaderHeight = commentType === (0, $8i27m.CommentType).GENERAL ? // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[data-testid='comment-section-separator']")?.getBoundingClientRect().height ?? 0 : 0;
    const totalPaddingAboveCommentThreadView = $6ed006a18ff2d87d$var$getTotalOffsetAboveCommentsPanelThreads(generalCommentsHeaderHeight);
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const objectSidebarPanelFooter = document.querySelector("[data-testid='object-sidebar-panel-footer']");
    const objectSidebarPanelFooterHeight = objectSidebarPanelFooter?.getBoundingClientRect().height ?? 0;
    const viewportTop = totalPaddingAboveCommentThreadView;
    const viewportBottom = window.innerHeight - objectSidebarPanelFooterHeight;
    const commentTopInView = commentThreadRect.top >= viewportTop;
    const commentBottomInView = commentThreadRect.bottom <= viewportBottom;
    if (commentTopInView && commentBottomInView) // Comment is 100% in view
    return false;
    else if (!commentTopInView && commentBottomInView) // Comment is <100% in view and the hidden part is the top part of the comment
    return true;
    else if (commentTopInView && !commentBottomInView) {
        // Comment is <100% in view and the hidden part is the bottom of the comment
        const hiddenBottomHeight = commentThreadRect.bottom - viewportBottom;
        if (hiddenBottomHeight <= $6ed006a18ff2d87d$var$NUM_HIDDEN_PIXELS_TO_BE_CONSIDERED_OUT_OF_VIEW) // The hidden part is <= 60 pixels
        return false;
        else // The hidden part is > 60 pixels
        return true;
    } else // Comment is <100% in view and the hidden part is the top part of the comment
    return true;
};
const $6ed006a18ff2d87d$export$9c5b7a3c864ae31b = (commentThreadElement, commentType)=>{
    const commentThreadRect = commentThreadElement.getBoundingClientRect();
    const generalCommentsHeaderHeight = commentType === (0, $8i27m.CommentType).GENERAL ? // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[data-testid='comment-section-separator']")?.getBoundingClientRect().height ?? 0 : 0;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const objectSidebarPanelFooter = document.querySelector("[data-testid='object-sidebar-panel-footer']");
    const objectSidebarPanelFooterHeight = objectSidebarPanelFooter?.getBoundingClientRect().height ?? 0;
    return(// Element is partially out of view below the comments panel viewport
    commentThreadRect.bottom + generalCommentsHeaderHeight > window.innerHeight - objectSidebarPanelFooterHeight);
};
var $6ed006a18ff2d87d$export$50c823aead020a09 = /*#__PURE__*/ function(LocationValue) {
    LocationValue["PANEL"] = "panel";
    LocationValue["FOOTER"] = "footer";
    LocationValue["STANDALONE"] = "standalone";
    return LocationValue;
}({});
const $6ed006a18ff2d87d$export$68e3ad656cdca3ec = (orderedActiveAnnotationIdList)=>{
    return orderedActiveAnnotationIdList.slice(0, Math.min(orderedActiveAnnotationIdList.length, (0, $7Oxky.COMMENT_BATCH_SIZE))).filter((item)=>!item.isLoaded) // only get the ones that are not loaded yet
    .map((item)=>item.threadKey);
};
const $6ed006a18ff2d87d$var$getDanglingComments = ({ commentsDataMap: commentsDataMap, annotationsSet: annotationsSet, openCommentThreads: openCommentThreads })=>{
    // Add dangling comments and handle real-time changes
    for(const threadKey in commentsDataMap.inline){
        const commentThread = commentsDataMap.inline[threadKey];
        const isDanglingComment = commentThread?.location?.inlineResolveProperties?.isDangling;
        if (commentThread?.isOpen) {
            // if the comment is already dangling, we want to add it to the list
            if (isDanglingComment) {
                const markerRef = commentThread?.location?.inlineMarkerRef;
                // comment is no longer dangling if it has a marker ref and is in the annotations set
                if (markerRef && annotationsSet && annotationsSet.has(markerRef)) {
                    const inlineLocation = commentThread.location;
                    const updatedCommentThread = {
                        ...commentThread,
                        location: {
                            ...commentThread.location,
                            inlineResolveProperties: {
                                ...inlineLocation.inlineResolveProperties,
                                isDangling: false
                            }
                        }
                    };
                    openCommentThreads.push(updatedCommentThread);
                } else openCommentThreads.push(commentThread);
                continue;
            }
            // check for real time dangling comments
            const markerRef = commentThread?.location?.inlineMarkerRef;
            // comment is dangling if it has a marker ref and is not in the annotations set
            // deleted and resolved comments are not in commentsDataMap so we know it's only dangling scenario
            // we do this here so the view will update immediately, but the actual mutation is handled in useDanglingOperations
            if (markerRef && annotationsSet && !annotationsSet.has(markerRef)) {
                const inlineLocation = commentThread.location;
                const updatedCommentThread = {
                    ...commentThread,
                    location: {
                        ...commentThread.location,
                        inlineResolveProperties: {
                            ...inlineLocation.inlineResolveProperties,
                            isDangling: true
                        }
                    }
                };
                openCommentThreads.push(updatedCommentThread);
            }
        }
    }
};
const $6ed006a18ff2d87d$export$aa9a5ed6405f18d6 = ({ commentsDataMap: commentsDataMap, orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, removedThreadsMap: removedThreadsMap, showInlineComments: showInlineComments, showGeneralComments: showGeneralComments, location: location = "panel" })=>{
    const openCommentThreads = [];
    const annotationsSet = new Set(orderedActiveAnnotationIdList.map((item)=>item.threadKey));
    // inline comments
    if (showInlineComments && location === "panel") {
        const removedAnnotationIds = new Set(Object.values(removedThreadsMap.inline));
        const filteredActiveAnnotationIds = orderedActiveAnnotationIdList.filter((item)=>!removedAnnotationIds.has(item.threadKey));
        const totalAnnotationsCount = filteredActiveAnnotationIds.length + Object.keys(removedThreadsMap).length;
        let activeIndex = 0; // Track position in filteredActiveAnnotationIds
        for(let i = 0; i < totalAnnotationsCount; i++){
            let threadKey = '';
            if (removedThreadsMap.inline.hasOwnProperty(i)) {
                threadKey = removedThreadsMap.inline[i];
                const commentThread = commentsDataMap.inline[threadKey];
                if (commentThread) openCommentThreads.push(commentThread);
            } else if (activeIndex < filteredActiveAnnotationIds.length) {
                threadKey = filteredActiveAnnotationIds[activeIndex].threadKey;
                const commentThread = commentsDataMap.inline[threadKey];
                // dangling comments had a marker ref and will be inside commentsDataMap, so we want to ignore these first
                const isDanglingComment = commentThread?.location?.inlineResolveProperties?.isDangling;
                // Don't add if it's dangling or might become dangling (has marker ref but not in annotations set)
                const markerRef = commentThread?.location?.inlineMarkerRef;
                const mightBecomeDangling = markerRef && annotationsSet && !annotationsSet.has(markerRef);
                if (commentThread?.isOpen && !isDanglingComment && !mightBecomeDangling) openCommentThreads.push(commentThread);
                activeIndex++;
            }
        }
        $6ed006a18ff2d87d$var$getDanglingComments({
            commentsDataMap: commentsDataMap,
            openCommentThreads: openCommentThreads,
            annotationsSet: annotationsSet
        });
    }
    // general comments
    if (showGeneralComments || location === "footer") {
        // We can just push these in the order we have them because we have no concept of "active"
        const generalComments = Object.values(commentsDataMap.general).filter((generalComment)=>{
            return generalComment.isOpen || generalComment.wasRemovedByAnotherUser === (0, $8i27m.CommentActionType).DELETE_COMMENT;
        });
        openCommentThreads.push(...generalComments);
    }
    return openCommentThreads;
};
const $6ed006a18ff2d87d$export$4fc364cd63a9b204 = ({ commentsDataMap: commentsDataMap, showInlineComments: showInlineComments, showGeneralComments: showGeneralComments, location: location = "panel" })=>{
    const resolvedCommentThreads = [];
    // inline comments
    if (showInlineComments && location === "panel") for(const key in commentsDataMap.inline){
        const comment = commentsDataMap.inline[key];
        if (comment.isOpen === false) resolvedCommentThreads.push(comment);
    }
    // general comments
    if (showGeneralComments) for(const key in commentsDataMap.general){
        const comment = commentsDataMap.general[key];
        if (comment.isOpen === false) resolvedCommentThreads.push(comment);
    }
    return resolvedCommentThreads;
};
const $6ed006a18ff2d87d$var$getCommentResolvedOrCreatedTime = (comment)=>{
    const commentLocation = comment.location;
    const resolvedTime = commentLocation?.inlineResolveProperties?.resolvedTime || commentLocation?.commentResolveProperties?.resolvedTime; // from the BE, this is for both reopened and resolved time, in milliseconds
    return resolvedTime || (0, $6faGq.getValidDate)(comment.createdAtNonLocalized).getTime(); // getTime() returns milliseconds
};
const $6ed006a18ff2d87d$export$d2935240a910e26e = (currentSort, commentThreads)=>{
    if (currentSort === (0, $3mVfX.SortValues).MOST_RECENT) return [
        ...commentThreads
    ].sort((a, b)=>$6ed006a18ff2d87d$var$getCommentResolvedOrCreatedTime(b) - $6ed006a18ff2d87d$var$getCommentResolvedOrCreatedTime(a));
    return commentThreads;
};
const $6ed006a18ff2d87d$export$47f9a121266175f = (annotations)=>annotations.map((annotation)=>annotation.threadKey);
const $6ed006a18ff2d87d$export$7119b2a60583b6dc = (marks = [])=>marks.map((mark)=>mark.attrs.id);
const $6ed006a18ff2d87d$export$b02d74cde949c060 = (commentA, commentB)=>(0, $6faGq.getValidDate)(commentA?.createdAtNonLocalized).getTime() - (0, $6faGq.getValidDate)(commentB?.createdAtNonLocalized).getTime();
const $6ed006a18ff2d87d$export$5425fcea1abfd6f7 = (error)=>{
    if (!error) // if falsy, consider it as NOT containing non-reactionsSummary errors
    return true;
    else if (error instanceof (0, $422HI.ApolloErrorInterop) || error instanceof (0, $9B4fQ.ApolloError)) {
        // TODO we will need to migrate to ApolloRelayInterops to get proper error type of ApolloErrorInterop instead of ApolloError
        // after migration, we can remove the instanceof ApolloError check here
        const hasOtherGqlErrors = error.graphQLErrors?.filter((e)=>!e.path?.includes('reactionsSummary'))?.length > 0;
        return !hasOtherGqlErrors && !error.networkError;
    } else // if truthy but not an ApolloErrorInterop, consider it as containing non-reactionsSummary errors
    return false;
};
module.exports["LocationValue"] = $6ed006a18ff2d87d$export$50c823aead020a09;
module.exports["getSortedCommentThreads"] = $6ed006a18ff2d87d$export$d2935240a910e26e;
module.exports["getAnnotationThreadKeys"] = $6ed006a18ff2d87d$export$47f9a121266175f;
module.exports["getMarkIds"] = $6ed006a18ff2d87d$export$7119b2a60583b6dc;
module.exports["getCommentsSortedOldestToNewest"] = $6ed006a18ff2d87d$export$b02d74cde949c060;
module.exports["onlyHasReactionsSummaryErrors"] = $6ed006a18ff2d87d$export$5425fcea1abfd6f7;

});

parcelRegister("7Oxky", function(module, exports) {

var $9j86J = parcelRequire("9j86J");


var $cozmU = parcelRequire("cozmU");


var $7Sm4c = parcelRequire("7Sm4c");


var $bQm3c = parcelRequire("bQm3c");


var $aSsfA = parcelRequire("aSsfA");


var $jMyy4 = parcelRequire("jMyy4");


var $8i27m = parcelRequire("8i27m");


var $3ZsvI = parcelRequire("3ZsvI");

const $9d95853344936385$var$useActiveInlineCommentsQueryActiveInlineCommentsQuery = (0, $9j86J.default);
const $9d95853344936385$export$e8d93aa39e79e9aa = 1000; // setting to 1000 for now until we implement infinite scroll for the comments panel
const $9d95853344936385$export$6ddede7674b6d70f = ({ pageId: pageId, markerRefList: markerRefList, skip: skip = false })=>{
    // The query loading was not sticking around long enough or triggering at the right times
    // so I created a loading state that will set after the query is successful/fails
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [{ commentsDataMap: commentsDataMap }, { addNewCommentThreads: addNewCommentThreads, setCommentsDataMap: setCommentsDataMap }] = (0, $8i27m.useCommentsData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { userId: currentUserId } = (0, $bQm3c.useSessionData)();
    // Determine if the query should be skipped
    const skipQuery = !pageId || markerRefList.length === 0 || skip;
    const hasAlreadyFetchedInitialData = Object.keys(commentsDataMap.inline).length > 0;
    // Execute the query
    const { data: data, loading: queryLoading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)($9d95853344936385$var$useActiveInlineCommentsQueryActiveInlineCommentsQuery, {
        variables: {
            pageId: pageId,
            inlineMarkerRefList: markerRefList,
            contentStatus: [
                'CURRENT',
                'DRAFT'
            ]
        },
        // Skip is not respected after the initial call: https://github.com/apollographql/apollo-client/issues/6190#issuecomment-649933628
        fetchPolicy: skipQuery ? 'cache-only' : 'cache-and-network',
        // We want to utilize the cache as much as possible, but keep the list up to date if it changes
        skip: skipQuery,
        onCompleted: (result)=>{
            (0, $3ZsvI.updateCommentsDataState)({
                data: result,
                updateData: hasAlreadyFetchedInitialData ? addNewCommentThreads : setCommentsDataMap,
                pageMode: pageMode,
                currentUserId: currentUserId ?? '',
                isOpen: true
            });
            setLoading(false);
        },
        onError: (err)=>{
            // If the error is related to reactionsSummary returning null, just mark it handled
            // or if the error is related to cc-pages not being reachable, just mark it handled
            if (err.message.search(/reactions/i) !== -1 || err.message.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(err);
            setLoading(false);
        },
        __callerPackage__: "comments-data"
    });
    (0, $cozmU.useEffect)(()=>{
        if (queryLoading) setLoading(true);
    }, [
        queryLoading
    ]);
    return {
        loading: !skipQuery ? loading : false,
        data: // If we skip the query make sure loading is false
        data,
        error: error,
        refetch: refetch
    };
};
module.exports["COMMENT_BATCH_SIZE"] = $9d95853344936385$export$e8d93aa39e79e9aa;

});

parcelRegister("9j86J", function(module, exports) {
/**
 * @generated SignedSource<<c36f8ff279465cc8e51c147ad27df0fc>>
 * @relayHash 7f2f5b1f8eabf86158412fc6d30f35d6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 13f41a7981b1d0d7a2ba4907ee0baedf14ff9510a934a126d5407f86dc09ff15
const $1a28e5c1a6e6a8b1$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "inlineMarkerRefList"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        {
            "kind": "Variable",
            "name": "inlineMarkerRefList",
            "variableName": "inlineMarkerRefList"
        },
        v3 /*: any*/ 
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v7 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v6 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v8 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v9 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v6 /*: any*/ 
    }, v10 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v11 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "type"
    }, v13 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v14 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    v13 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v14 /*: any*/ ,
                    v15 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v18 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v19 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v20 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v21 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v23 = {
        "kind": "ScalarField",
        "name": "when"
    }, v24 = {
        "kind": "ScalarField",
        "name": "number"
    }, v25 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v22 /*: any*/ 
                ]
            },
            v23 /*: any*/ ,
            v24 /*: any*/ 
        ]
    }, v26 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v28 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v29 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v22 /*: any*/ ,
            v26 /*: any*/ ,
            v27 /*: any*/ ,
            v28 /*: any*/ 
        ]
    }, v30 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v31 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v32 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v33 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v31 /*: any*/ ,
                    v22 /*: any*/ 
                ]
            },
            v23 /*: any*/ ,
            v24 /*: any*/ 
        ]
    }, v34 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            v22 /*: any*/ ,
            v26 /*: any*/ ,
            v27 /*: any*/ ,
            v28 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useActiveInlineCommentsQueryActiveInlineCommentsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v25 /*: any*/ ,
                                v29 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ 
                                    ]
                                },
                                v30 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useActiveInlineCommentsQueryActiveInlineCommentsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v32 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v33 /*: any*/ ,
                                v34 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v32 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v33 /*: any*/ ,
                                        v34 /*: any*/ ,
                                        v30 /*: any*/ 
                                    ]
                                },
                                v30 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "7f2f5b1f8eabf86158412fc6d30f35d6",
            "id": "13f41a7981b1d0d7a2ba4907ee0baedf14ff9510a934a126d5407f86dc09ff15",
            "metadata": {},
            "name": "useActiveInlineCommentsQueryActiveInlineCommentsQuery",
            "operationKind": "query",
            "text": "query useActiveInlineCommentsQueryActiveInlineCommentsQuery($inlineMarkerRefList:[String!]!,$pageId:ID!,$contentStatus:[GraphQLContentStatus]){comments(inlineMarkerRefList:$inlineMarkerRefList,pageId:$pageId,contentStatus:$contentStatus){nodes{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}}}"
        }
    };
}();
$1a28e5c1a6e6a8b1$var$node.hash = "55c0fbf12929f614cd8832ad8c70d69e";
var $1a28e5c1a6e6a8b1$export$2e2bcd8739ae039 = $1a28e5c1a6e6a8b1$var$node;
module.exports["default"] = $1a28e5c1a6e6a8b1$export$2e2bcd8739ae039;

});

parcelRegister("6faGq", function(module, exports) {

var $3ejfs = parcelRequire("3ejfs");


var $3iaSn = parcelRequire("3iaSn");

const $fd14f0f09d6b2a27$export$48c62524de3612b3 = (dateString)=>{
    if (!dateString) return new Date(0); // Return earliest possible date if missing
    // Ensure UTC timezone. Some createdAt values are missing the UTC timezone identifier, and some have it
    const normalizedDate = dateString.endsWith('Z') ? dateString : `${dateString}Z`;
    // Try to parse the date, return earliest date if invalid
    const parsed = new Date(normalizedDate);
    return isNaN(parsed.getTime()) ? new Date(0) : parsed;
};

const $fd14f0f09d6b2a27$export$63880caa66d80fb9 = ({ intl: intl, dateString: dateString, commentStatus: commentStatus = (0, $3iaSn.CommentStatus).OPEN, resolveProperties: resolveProperties, isReply: isReply = false })=>{
    if (!dateString) return '';
    // Get formatted timestamp
    let timestamp;
    try {
        const { formatTimeAgo: formatTimeAgo } = (parcelRequire("1JmNR"));
        timestamp = formatTimeAgo(intl, $fd14f0f09d6b2a27$export$48c62524de3612b3(dateString));
    } catch (error) {
        // Fallback to a simple date format if formatTimeAgo is not available
        const date = $fd14f0f09d6b2a27$export$48c62524de3612b3(dateString);
        timestamp = date.toLocaleDateString(intl.locale);
    }
    // For replies, just return the timestamp without comment status
    if (isReply) return timestamp;
    // Format based on comment status
    switch(commentStatus){
        case (0, $3iaSn.CommentStatus).RESOLVED:
            return intl.formatMessage((0, $3ejfs.commentsi18n).resolvedByInfoText, {
                friendlyDate: timestamp,
                username: resolveProperties?.resolvedUser
            });
        case (0, $3iaSn.CommentStatus).REOPENED:
            return intl.formatMessage((0, $3ejfs.commentsi18n).reopenedByTooltipTextCommentsPanel, {
                createdAtNonLocalized: timestamp,
                username: resolveProperties?.resolvedUser
            });
        case (0, $3iaSn.CommentStatus).OPEN:
        default:
            return intl.formatMessage((0, $3ejfs.commentsi18n).createdTimestamp, {
                timestamp: timestamp
            });
    }
};
module.exports["getValidDate"] = $fd14f0f09d6b2a27$export$48c62524de3612b3;
module.exports["formatTimestampForAriaLabel"] = $fd14f0f09d6b2a27$export$63880caa66d80fb9;

});

parcelRegister("3ejfs", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $d1e9edb9f1563526$export$454b2229580969d0 = (0, $kSwu1.defineMessages)({
    resolvedByInfoText: {
        id: "comments-util.resolved.by.info.text",
        defaultMessage: "Resolved by {username} {friendlyDate}"
    },
    reopenedByTooltipTextCommentsPanel: {
        id: "comments-util.reopened.by.tooltip.text.comments.panel",
        defaultMessage: "Added {createdAtNonLocalized}, reopened by {username}"
    },
    createdTimestamp: {
        id: "comments-util.timestamp.created",
        defaultMessage: "created {timestamp}"
    },
    resolvedDateInfoText: {
        id: "comments-util.resolved.date.info.text",
        defaultMessage: "Resolved {friendlyDate}"
    },
    reopenedDateInfoText: {
        id: "comments-util.reopened.date.info.text",
        defaultMessage: "Reopened {friendlyDate}"
    },
    generalCommentTooltip: {
        id: "comments-util.view.tooltip.general.comment",
        defaultMessage: "General comment"
    },
    anonymous: {
        id: "comments-util.display.name.anonymous",
        defaultMessage: "Anonymous"
    },
    editedBy: {
        id: "comments-util.edited.by",
        defaultMessage: "Edited by {username} {at}"
    },
    edited: {
        id: "comments-util.edited",
        defaultMessage: "Edited"
    },
    resolvedByTooltipTextCommentsPanel: {
        id: "comments-util.resolved.by.tooltip.text.comments.panel",
        defaultMessage: "By {username}"
    }
});
module.exports["commentsi18n"] = $d1e9edb9f1563526$export$454b2229580969d0;

});

parcelRegister("3iaSn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

var $c6395b80aeb36ecd$export$4f1057b172870e9c = /*#__PURE__*/ function(CommentStatus) {
    CommentStatus["OPEN"] = "OPEN";
    CommentStatus["RESOLVED"] = "RESOLVED";
    CommentStatus["REOPENED"] = "REOPENED";
    return CommentStatus;
}({});
const $c6395b80aeb36ecd$export$eac30d30628b994a = ({ resolveProperties: resolveProperties })=>{
    return (0, $cozmU.useMemo)(()=>{
        // If no resolve properties, the comment is open
        if (!resolveProperties) return "OPEN";
        // If resolved is false, the comment is reopened
        if (!resolveProperties.resolved) return "REOPENED";
        return "RESOLVED";
    }, [
        resolveProperties
    ]);
};
module.exports["CommentStatus"] = $c6395b80aeb36ecd$export$4f1057b172870e9c;
module.exports["useGetCommentStatus"] = $c6395b80aeb36ecd$export$eac30d30628b994a;

});

parcelRegister("1JmNR", function(module, exports) {
$parcel$export(module.exports, "formatTimeAgo", () => (parcelRequire("1YXTQ")).formatTimeAgo);
$parcel$export(module.exports, "TimeAgo", () => (parcelRequire("1YXTQ")).TimeAgo);
$parcel$export(module.exports, "StaticTimeAgo", () => (parcelRequire("1YXTQ")).StaticTimeAgo);
$parcel$export(module.exports, "formatRelativeTimeAgo", () => (parcelRequire("6gnMn")).formatRelativeTimeAgo);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $1YXTQ = parcelRequire("1YXTQ");


var $6gnMn = parcelRequire("6gnMn");


});

parcelRegister("1YXTQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $clUfR = parcelRequire("clUfR");


var $7GLtr = parcelRequire("7GLtr");


var $awd1Q = parcelRequire("awd1Q");


var $bQm3c = parcelRequire("bQm3c");

'use no memo';
const $6f4eb0725770e50a$var$i18n = (0, $kSwu1.defineMessages)({
    now: {
        id: "time-ago.time.now",
        defaultMessage: "now"
    },
    lessThanAMinute: {
        id: "time-ago.time.lessThanAMinute",
        defaultMessage: "less than a minute ago"
    },
    onPreposition: {
        id: "time-ago.prepositions.on",
        defaultMessage: "on {datetime}"
    }
});
const $6f4eb0725770e50a$var$gradation = [
    // Less than 5 seconds -> "now"
    {
        format: ({ intl: intl })=>intl.formatMessage($6f4eb0725770e50a$var$i18n.now)
    },
    // Between 5-45 seconds -> "less than a minute ago"
    {
        threshold: 5,
        format: ({ intl: intl })=>intl.formatMessage($6f4eb0725770e50a$var$i18n.lessThanAMinute)
    },
    // Between 45 seconds-2.5 minutes -> "X minutes ago"
    {
        threshold: 45,
        factor: 60,
        unit: 'minute'
    },
    // Between 2.5-45 minutes -> "X minutes ago" (rounded to 5)
    {
        threshold: 150,
        factor: 60,
        granularity: 5,
        unit: 'minute'
    },
    // Between 45 minutes-24 hours -> "X hours ago"
    {
        threshold: 2700,
        factor: 3600,
        unit: 'hour'
    },
    // After 24 hours -> "full date"
    {
        threshold: 86400,
        format: ({ intl: intl, date: date, locale: locale, usePrepositions: usePrepositions, dateFormatOptions: dateFormatOptions, timeZone: timeZone, tenantTimeZone: tenantTimeZone })=>{
            const datetime = date.toLocaleDateString(locale, {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                timeZone: (()=>{
                    // Prefer timeZone if provided, otherwise use tenantTimeZone, otherwise use browser timezone
                    const tz = timeZone || tenantTimeZone || (0, $clUfR.guessTimeZone)();
                    // Validate the timezone, use UTC as fallback for invalid values
                    return (0, $7GLtr.isValidTimeZone)(tz) ? tz : 'Etc/UTC';
                })(),
                ...dateFormatOptions
            });
            if (usePrepositions) return intl.formatMessage($6f4eb0725770e50a$var$i18n.onPreposition, {
                datetime: datetime
            });
            return datetime;
        }
    }
];
const $6f4eb0725770e50a$var$getGradationIndex = (seconds)=>{
    let i = $6f4eb0725770e50a$var$gradation.length - 1;
    while(i > 0 && seconds < ($6f4eb0725770e50a$var$gradation[i].threshold || seconds))i--;
    return i;
};
const $6f4eb0725770e50a$var$getSecondsSince = (date)=>(Date.now() - date.getTime()) / 1000;
const $6f4eb0725770e50a$export$78ae3e68d8c394bc = (intl, date, usePrepositions, dateFormatOptions, timeZone, tenantTimeZone)=>{
    const locale = (0, $awd1Q.getTranslation)().locale;
    const dateObject = new Date(date);
    const seconds = $6f4eb0725770e50a$var$getSecondsSince(dateObject);
    const i = $6f4eb0725770e50a$var$getGradationIndex(seconds);
    const customFormat = $6f4eb0725770e50a$var$gradation[i].format;
    if (customFormat) return customFormat({
        intl: intl,
        date: dateObject,
        locale: locale,
        usePrepositions: usePrepositions,
        dateFormatOptions: dateFormatOptions,
        timeZone: timeZone,
        tenantTimeZone: tenantTimeZone
    });
    const localeLanguage = new Intl.Locale(locale).language;
    const formatter = new Intl.RelativeTimeFormat(localeLanguage, {
        style: 'long',
        numeric: 'auto'
    });
    const granularity = $6f4eb0725770e50a$var$gradation[i].granularity || 1;
    const factor = $6f4eb0725770e50a$var$gradation[i].factor || 1;
    const value = -Math.round(seconds / factor / granularity) * granularity;
    const unit = $6f4eb0725770e50a$var$gradation[i].unit || 'second';
    return formatter.format(value, unit);
};
const $6f4eb0725770e50a$export$fc791eb9f9c39e49 = ({ date: date, usePrepositions: usePrepositions, dateFormatOptions: dateFormatOptions })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { timeZone: timeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        suppressHydrationWarning: true
    }, $6f4eb0725770e50a$export$78ae3e68d8c394bc(intl, date, usePrepositions, dateFormatOptions, timeZone, tenantTimeZone));
};
const $6f4eb0725770e50a$export$9e4a631e7281406a = ({ date: date, ...otherProps })=>{
    const [, setRenders] = (0, $cozmU.useState)(0);
    const dateObject = new Date(date);
    const seconds = $6f4eb0725770e50a$var$getSecondsSince(dateObject);
    const i = $6f4eb0725770e50a$var$getGradationIndex(seconds);
    (0, $cozmU.useEffect)(()=>{
        if (i != $6f4eb0725770e50a$var$gradation.length - 1) {
            const timeToNextGradation = ($6f4eb0725770e50a$var$gradation[i + 1].threshold || seconds) - seconds;
            const timeout = setTimeout(()=>{
                setRenders((x)=>x + 1);
            }, timeToNextGradation * 1000);
            return ()=>clearTimeout(timeout);
        }
    }, [
        i,
        seconds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f4eb0725770e50a$export$fc791eb9f9c39e49, {
        date: date,
        ...otherProps
    });
};
module.exports["formatTimeAgo"] = $6f4eb0725770e50a$export$78ae3e68d8c394bc;
module.exports["StaticTimeAgo"] = $6f4eb0725770e50a$export$fc791eb9f9c39e49;
module.exports["TimeAgo"] = $6f4eb0725770e50a$export$9e4a631e7281406a;

});

parcelRegister("clUfR", function(module, exports) {
const $dad8374cf8f904e8$export$c333b33f2586074c = ()=>{
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch  {
        return 'Etc/UTC';
    }
};
module.exports["guessTimeZone"] = $dad8374cf8f904e8$export$c333b33f2586074c;

});

parcelRegister("7GLtr", function(module, exports) {
const $0e3ee782c26ab488$export$c793e14020d7c7b = (timeZone)=>{
    try {
        Intl.DateTimeFormat(undefined, {
            timeZone: timeZone
        });
        return true;
    } catch  {
        return false;
    }
};
module.exports["isValidTimeZone"] = $0e3ee782c26ab488$export$c793e14020d7c7b;

});

parcelRegister("6gnMn", function(module, exports) {

var $jb2R2 = parcelRequire("jb2R2");

var $bg9GW = parcelRequire("bg9GW");

var $fNtG8 = parcelRequire("fNtG8");

var $jgqX6 = parcelRequire("jgqX6");

var $hnDzv = parcelRequire("hnDzv");


var $kSwu1 = parcelRequire("kSwu1");

const $926347e03f273aaa$var$i18n = (0, $kSwu1.defineMessages)({
    justNow: {
        id: "time-ago.relative.just-now",
        defaultMessage: "Just now"
    },
    minutesAgo: {
        id: "time-ago.relative.minutes-ago",
        defaultMessage: "{minuteCount} {minuteCount, plural, one {minute} other {minutes}} ago"
    },
    hoursAgo: {
        id: "time-ago.relative.hours-ago",
        defaultMessage: "{hourCount} {hourCount, plural, one {hour} other {hours}} ago"
    },
    daysAgo: {
        id: "time-ago.relative.days-ago",
        defaultMessage: "{dayCount} {dayCount, plural, one {day} other {days}} ago"
    },
    monthsAgo: {
        id: "time-ago.relative.months-ago",
        defaultMessage: "{monthCount} {monthCount, plural, one {month} other {months}} ago"
    },
    yearsAgo: {
        id: "time-ago.relative.years-ago",
        defaultMessage: "{yearCount} {yearCount, plural, one {year} other {years}} ago"
    }
});
const $926347e03f273aaa$export$b77ccb75f39eecf = (date, intl, now = new Date())=>{
    const dateObject = new Date(date);
    const minutesDiff = (0, $fNtG8.default)(now, dateObject);
    const hoursDiff = (0, $bg9GW.default)(now, dateObject);
    const daysDiff = (0, $jb2R2.default)(now, dateObject);
    const monthsDiff = (0, $jgqX6.default)(now, dateObject);
    const yearsDiff = (0, $hnDzv.default)(now, dateObject);
    if (minutesDiff < 1) return intl.formatMessage($926347e03f273aaa$var$i18n.justNow);
    if (minutesDiff < 60) return intl.formatMessage($926347e03f273aaa$var$i18n.minutesAgo, {
        minuteCount: minutesDiff
    });
    if (hoursDiff < 24) return intl.formatMessage($926347e03f273aaa$var$i18n.hoursAgo, {
        hourCount: hoursDiff
    });
    if (daysDiff < 31) return intl.formatMessage($926347e03f273aaa$var$i18n.daysAgo, {
        dayCount: daysDiff
    });
    if (monthsDiff < 12) return intl.formatMessage($926347e03f273aaa$var$i18n.monthsAgo, {
        monthCount: monthsDiff
    });
    return intl.formatMessage($926347e03f273aaa$var$i18n.yearsAgo, {
        yearCount: yearsDiff
    });
};
module.exports["formatRelativeTimeAgo"] = $926347e03f273aaa$export$b77ccb75f39eecf;

});

parcelRegister("bg9GW", function(module, exports) {
$parcel$export(module.exports, "default", () => $8328b4ddc95230a8$export$2e2bcd8739ae039);

var $jO73f = parcelRequire("jO73f");


var $g93kp = parcelRequire("g93kp");


var $3yGK6 = parcelRequire("3yGK6");


var $byLBW = parcelRequire("byLBW");

function $8328b4ddc95230a8$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $3yGK6.default)(2, arguments);
    var diff = (0, $g93kp.default)(dateLeft, dateRight) / (0, $jO73f.millisecondsInHour);
    return (0, $byLBW.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("jO73f", function(module, exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $e6b828148d99ab2b$export$dfd9b671c89acc8e = 7;
var $e6b828148d99ab2b$export$3913210603d8e9ae = 365.2425;
var $e6b828148d99ab2b$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e6b828148d99ab2b$export$91246f0b9bd9beff = 60000;
var $e6b828148d99ab2b$export$7f72910d6dfd237a = 3600000;
var $e6b828148d99ab2b$export$397c2d5776aa9055 = 1000;
var $e6b828148d99ab2b$export$4dec998e48f9c246 = -$e6b828148d99ab2b$export$81caae6e1cc7a622;
var $e6b828148d99ab2b$export$f2f5ae5a8e2d8f9f = 60;
var $e6b828148d99ab2b$export$3c58128db900d44e = 3;
var $e6b828148d99ab2b$export$80d7e435f744f319 = 12;
var $e6b828148d99ab2b$export$4db7641526e3241f = 4;
var $e6b828148d99ab2b$export$698aec755e92c695 = 3600;
var $e6b828148d99ab2b$export$a77c1a7ebebe2a5a = 60;
var $e6b828148d99ab2b$export$815a9362476d2fe3 = $e6b828148d99ab2b$export$698aec755e92c695 * 24;
var $e6b828148d99ab2b$export$34804a017b31e2fe = $e6b828148d99ab2b$export$815a9362476d2fe3 * 7;
var $e6b828148d99ab2b$export$7271e9e3478110d1 = $e6b828148d99ab2b$export$815a9362476d2fe3 * $e6b828148d99ab2b$export$3913210603d8e9ae;
var $e6b828148d99ab2b$export$8e6600bbdee7dabb = $e6b828148d99ab2b$export$7271e9e3478110d1 / 12;
var $e6b828148d99ab2b$export$be1dccf2de902d31 = $e6b828148d99ab2b$export$8e6600bbdee7dabb * 3;
module.exports["millisecondsInMinute"] = $e6b828148d99ab2b$export$91246f0b9bd9beff;
module.exports["millisecondsInHour"] = $e6b828148d99ab2b$export$7f72910d6dfd237a;
module.exports["millisecondsInSecond"] = $e6b828148d99ab2b$export$397c2d5776aa9055;

});

parcelRegister("fNtG8", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8027429ed7dcbe2$export$2e2bcd8739ae039);

var $jO73f = parcelRequire("jO73f");


var $g93kp = parcelRequire("g93kp");


var $3yGK6 = parcelRequire("3yGK6");


var $byLBW = parcelRequire("byLBW");

function $b8027429ed7dcbe2$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $3yGK6.default)(2, arguments);
    var diff = (0, $g93kp.default)(dateLeft, dateRight) / (0, $jO73f.millisecondsInMinute);
    return (0, $byLBW.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("hnDzv", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca7347c324945db7$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $9wdry = parcelRequire("9wdry");


var $eYSi7 = parcelRequire("eYSi7");


var $3yGK6 = parcelRequire("3yGK6");

function $ca7347c324945db7$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    var sign = (0, $eYSi7.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $9wdry.default)(dateLeft, dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    dateLeft.setFullYear(1584);
    dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastYearNotFull = (0, $eYSi7.default)(dateLeft, dateRight) === -sign;
    var result = sign * (difference - Number(isLastYearNotFull));
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("9wdry", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ee187ccd32d3646$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $6ee187ccd32d3646$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}

});

parcelRegister("8SCD6", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $l5y3Y = parcelRequire("l5y3Y");

const $6881c6359fe8b822$export$4da9db299e81cd38 = /*#__PURE__*/ (0, $cozmU.createContext)({
    isReactionsEnabled: false
});
$6881c6359fe8b822$export$4da9db299e81cd38.displayName = 'ReactionsContext';
const $6881c6359fe8b822$export$2157a4212fd7f5b1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { contentId: contentId, children: children } = t0;
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    let t1;
    if ($[0] !== isReactionsEnabled) {
        t1 = {
            isReactionsEnabled: isReactionsEnabled
        };
        $[0] = isReactionsEnabled;
        $[1] = t1;
    } else t1 = $[1];
    const reactionsContextValue = t1;
    let t2;
    if ($[2] !== children || $[3] !== reactionsContextValue) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6881c6359fe8b822$export$4da9db299e81cd38.Provider, {
            value: reactionsContextValue
        }, children);
        $[2] = children;
        $[3] = reactionsContextValue;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ contentId: contentId, children: children })=>{
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    const reactionsContextValue = (0, $cozmU.useMemo)(()=>({
            isReactionsEnabled: isReactionsEnabled
        }), [
        isReactionsEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6881c6359fe8b822$export$4da9db299e81cd38.Provider, {
        value: reactionsContextValue
    }, children);
};
module.exports["ReactionsContext"] = $6881c6359fe8b822$export$4da9db299e81cd38;
module.exports["ReactionsProvider"] = $6881c6359fe8b822$export$2157a4212fd7f5b1;

});

parcelRegister("l5y3Y", function(module, exports) {

var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $eSLr0 = parcelRequire("eSLr0");


var $9Z1sw = parcelRequire("9Z1sw");


var $dPJCf = parcelRequire("dPJCf");

const $13602a0094cde4d6$export$da23010c6e2ddd94 = (contentId)=>{
    const isPDFExport = (0, $dPJCf.usePathnameMatcher)({
        selector: (pathname)=>pathname?.indexOf('/wiki/pdf/') !== -1
    });
    const baseOptions = {
        variables: {
            contentId: contentId,
            location: (0, $eSLr0.ATL_PAGE_CONTENT_FOOTER_ACTIONS)
        },
        skip: isPDFExport
    };
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const queryResult = (0, $6mKj3.expValEquals)('confluence_stop_watching_webpanellocationquery', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        __callerPackage__: "comments-hooks"
    }) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: 'cache-first',
        __callerPackage__: "comments-hooks"
    });
    const data = queryResult.data;
    return !isPDFExport && Boolean(data?.webPanels?.length);
};
module.exports["useIsReactionsEnabled"] = $13602a0094cde4d6$export$da23010c6e2ddd94;

});

parcelRegister("eSLr0", function(module, exports) {
// web items
const $0673dc41d4591954$export$b1fc939aa7feb92f = 'system.content.action';
const $0673dc41d4591954$export$cc265e0ec08cd67d = 'system.content.button';
const $0673dc41d4591954$export$d2beebd05fcd6f70 = 'system.dashboard';
const $0673dc41d4591954$export$9aacf4bfaa57e6fc = 'system.content.byline';
const $0673dc41d4591954$export$1b2697f8e6fa897f = 'system.content.metadata';
const $0673dc41d4591954$export$76fccc09e967256f = 'page.metadata.banner';
const $0673dc41d4591954$export$630f26f93c0b82dc = 'system.header/left';
const $0673dc41d4591954$export$67f0ff836865be9e = 'system.header/left.button.group';
const $0673dc41d4591954$export$ac6c373b69972f05 = 'system.help/pages';
const $0673dc41d4591954$export$1835f2a2eaa3b55b = 'system.user';
const $0673dc41d4591954$export$8fc5196f34e2202a = 'system.admin';
const $0673dc41d4591954$export$e83e042e2b565918 = 'system.editor.precursor.buttons';
const $0673dc41d4591954$export$2a98a7a0b026585a = 'system.create.dialog/content';
const $0673dc41d4591954$export$9022327d826319c7 = 'system.create.space.dialog/content';
const $0673dc41d4591954$export$b7555e81ec195340 = 'page.view.selection/action-panel';
const $0673dc41d4591954$export$dbd4ce8bddb36f82 = 'atl.dashboard.secondary';
const $0673dc41d4591954$export$78738b07c213d412 = 'atl.general';
const $0673dc41d4591954$export$45c1e55ebc7a8070 = 'atl.footer';
const $0673dc41d4591954$export$e1325689a3e8f66b = 'atl.page.metadata.banner';
const $0673dc41d4591954$export$e8a1b6a55853b054 = 'atl.page.content.footer.actions';
const $0673dc41d4591954$export$488204faf384ca14 = 'atl.editor.savebar';
const $0673dc41d4591954$export$c7ef8755b728af2b = 'system.admin/siteadministration';
const $0673dc41d4591954$export$a7876e82ed48f038 = 'system.admin/security';
module.exports["TOOLS_MENU_CONTAINER"] = $0673dc41d4591954$export$b1fc939aa7feb92f;
module.exports["PAGE_BUTTONS"] = $0673dc41d4591954$export$cc265e0ec08cd67d;
module.exports["SYSTEM_CONTENT_BYLINE"] = $0673dc41d4591954$export$9aacf4bfaa57e6fc;
module.exports["SYSTEM_CONTENT_METADATA"] = $0673dc41d4591954$export$1b2697f8e6fa897f;
module.exports["PAGE_METADATA_BANNER"] = $0673dc41d4591954$export$76fccc09e967256f;
module.exports["SYSTEM_HEADER_LEFT"] = $0673dc41d4591954$export$630f26f93c0b82dc;
module.exports["SYSTEM_HELP"] = $0673dc41d4591954$export$ac6c373b69972f05;
module.exports["SYSTEM_USER"] = $0673dc41d4591954$export$1835f2a2eaa3b55b;
module.exports["SYSTEM_ADMIN"] = $0673dc41d4591954$export$8fc5196f34e2202a;
module.exports["SYSTEM_EDITOR_PRECURSOR_BUTTONS"] = $0673dc41d4591954$export$e83e042e2b565918;
module.exports["CREATE_DIALOG"] = $0673dc41d4591954$export$2a98a7a0b026585a;
module.exports["CREATE_SPACE_DIALOG"] = $0673dc41d4591954$export$9022327d826319c7;
module.exports["ACTION_PANEL"] = $0673dc41d4591954$export$b7555e81ec195340;
module.exports["DASHBOARD_SECONDARY"] = $0673dc41d4591954$export$dbd4ce8bddb36f82;
module.exports["ATL_GENERAL"] = $0673dc41d4591954$export$78738b07c213d412;
module.exports["ATL_FOOTER"] = $0673dc41d4591954$export$45c1e55ebc7a8070;
module.exports["ATL_PAGE_METADATA"] = $0673dc41d4591954$export$e1325689a3e8f66b;
module.exports["ATL_PAGE_CONTENT_FOOTER_ACTIONS"] = $0673dc41d4591954$export$e8a1b6a55853b054;
module.exports["ATL_EDITOR_SAVEBAR"] = $0673dc41d4591954$export$488204faf384ca14;
module.exports["SYSTEM_ADMIN_SITE_ADMINISTRATION_SECURITY"] = $0673dc41d4591954$export$a7876e82ed48f038;

});

parcelRegister("9Z1sw", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $eq95w = parcelRequire("eq95w");


var $cozmU = parcelRequire("cozmU");


var $ah4BL = parcelRequire("ah4BL");


var $bavCP = parcelRequire("bavCP");


var $8wW9d = parcelRequire("8wW9d");


var $9wGTI = parcelRequire("9wGTI");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $ep3mz = parcelRequire("ep3mz");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $eSLr0 = parcelRequire("eSLr0");


var $3QyBm = parcelRequire("3QyBm");


var $iqPSe = parcelRequire("iqPSe");

const $0aea74171df1eb15$export$d97dfe528d83a912 = (0, $eq95w.default);
const $0aea74171df1eb15$var$WebPanelLocationBatchContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $0aea74171df1eb15$export$784950ebf49d8a5f = (location)=>{
    const $ = (0, $bDgLe.c)(3);
    const batchContext = (0, $cozmU.useContext)($0aea74171df1eb15$var$WebPanelLocationBatchContext);
    let t0;
    if ($[0] !== batchContext || $[1] !== location) {
        t0 = batchContext?.locations.includes(location) ? batchContext.getResultForLocation(location) : null;
        $[0] = batchContext;
        $[1] = location;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
const $0aea74171df1eb15$var$getUniqueLocations = (locations)=>Array.from(new Set(locations.filter(Boolean)));
const $0aea74171df1eb15$var$groupPanelsByLocation = (webPanels)=>{
    const panelsByLocation = new Map();
    webPanels?.forEach((panel)=>{
        if (panel?.location) {
            const panels = panelsByLocation.get(panel.location) ?? [];
            panels.push(panel);
            panelsByLocation.set(panel.location, panels);
        }
    });
    return panelsByLocation;
};
const $0aea74171df1eb15$var$getWebPanelLocationVariables = ({ location: location, locations: locations, contentIdentifier: contentIdentifier, spaceIdentifier: spaceIdentifier })=>{
    const selectedLocations = locations ?? (location ? [
        location
    ] : []);
    const locationVariables = selectedLocations.length > 1 ? {
        location: null,
        locations: selectedLocations
    } : {
        location: selectedLocations[0]
    };
    return {
        ...locationVariables,
        ...contentIdentifier != null ? {
            contentId: contentIdentifier
        } : {},
        ...contentIdentifier == null && spaceIdentifier != null ? {
            spaceKey: spaceIdentifier
        } : {}
    };
};
const $0aea74171df1eb15$var$useWebPanelLocationIdentifiers = ()=>{
    const $ = (0, $bDgLe.c)(8);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    let t0;
    let t1;
    if ($[0] !== contentId || $[1] !== getQueryParams || $[2] !== spaceKey) {
        const queryParams = getQueryParams();
        t0 = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, "spaceKey") || (0, $c3Qwv.getSingleParam)(queryParams, "key");
        t1 = contentId || (0, $c3Qwv.getSingleParam)(queryParams, "pageId");
        $[0] = contentId;
        $[1] = getQueryParams;
        $[2] = spaceKey;
        $[3] = t0;
        $[4] = t1;
    } else {
        t0 = $[3];
        t1 = $[4];
    }
    let t2;
    if ($[5] !== t0 || $[6] !== t1) {
        t2 = {
            spaceIdentifier: t0,
            contentIdentifier: t1
        };
        $[5] = t0;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
const $0aea74171df1eb15$var$UFOWebPanelLocationWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, locationName: locationName, panels: panels } = t0;
    const panelHasContent = panels?.length && panels.some($0aea74171df1eb15$var$_temp);
    let t1;
    let t2;
    if ($[0] !== panels) {
        t1 = ()=>{
            if ((0, $9wGTI.fg)("cc_record_non_content_macros")) (0, $8wW9d.recordNonContentAppKeys)((panels ?? []).map($0aea74171df1eb15$var$_temp2));
        };
        t2 = [
            panels
        ];
        $[0] = panels;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    if (!panelHasContent) return children;
    const t3 = `web-panel-${locationName}`;
    let t4;
    if ($[3] !== children || $[4] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ah4BL.UFOThirdPartySegment), {
            name: t3
        }, children);
        $[3] = children;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
};
const $0aea74171df1eb15$var$WebPanelLocationBatchContextProvider = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { data: data, loading: loading, error: error, locations: locations, children: children } = t0;
    data?.webPanels;
    const t1 = data?.webPanels;
    let t2;
    if ($[0] !== t1) {
        t2 = $0aea74171df1eb15$var$groupPanelsByLocation(t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const panelsByLocation = t2;
    let t3;
    if ($[2] !== data || $[3] !== error || $[4] !== loading || $[5] !== panelsByLocation) {
        t3 = (location)=>({
                data: data ? {
                    webPanels: panelsByLocation.get(location) ?? []
                } : data,
                loading: loading,
                error: error
            });
        $[2] = data;
        $[3] = error;
        $[4] = loading;
        $[5] = panelsByLocation;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== locations || $[8] !== t3) {
        t4 = {
            locations: locations,
            getResultForLocation: t3
        };
        $[7] = locations;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    const contextValue = t4;
    let t5;
    if ($[10] !== children || $[11] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$WebPanelLocationBatchContext.Provider, {
            value: contextValue
        }, children);
        $[10] = children;
        $[11] = contextValue;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
};
const $0aea74171df1eb15$export$2c530b46a1768809 = (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { locations: locations, children: children } = t0;
    const { spaceIdentifier: spaceIdentifier, contentIdentifier: contentIdentifier } = $0aea74171df1eb15$var$useWebPanelLocationIdentifiers();
    let t1;
    if ($[0] !== locations) {
        t1 = locations.join("\0");
        $[0] = locations;
        $[1] = t1;
    } else t1 = $[1];
    const locationsKey = t1;
    let t2;
    if ($[2] !== locationsKey) {
        t2 = $0aea74171df1eb15$var$getUniqueLocations(locationsKey.split("\0"));
        $[2] = locationsKey;
        $[3] = t2;
    } else t2 = $[3];
    const uniqueLocations = t2;
    let t3;
    if ($[4] !== contentIdentifier || $[5] !== spaceIdentifier || $[6] !== uniqueLocations) {
        t3 = $0aea74171df1eb15$var$getWebPanelLocationVariables({
            locations: uniqueLocations,
            contentIdentifier: contentIdentifier,
            spaceIdentifier: spaceIdentifier
        });
        $[4] = contentIdentifier;
        $[5] = spaceIdentifier;
        $[6] = uniqueLocations;
        $[7] = t3;
    } else t3 = $[7];
    const variables = t3;
    if (spaceIdentifier === "byDraft" || uniqueLocations.length === 0) {
        let t4;
        if ($[8] !== children) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[8] = children;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    let t4;
    if ($[10] !== children || $[11] !== uniqueLocations) {
        t4 = (t5)=>{
            const { data: data, loading: loading, error: error } = t5;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$WebPanelLocationBatchContextProvider, {
                data: data,
                loading: loading,
                error: error,
                locations: uniqueLocations
            }, children);
        };
        $[10] = children;
        $[11] = uniqueLocations;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== t4 || $[14] !== variables) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
            query: $0aea74171df1eb15$export$d97dfe528d83a912,
            variables: variables,
            fetchPolicy: "cache-first",
            __callerPackage__: "web-panel-location"
        }, t4);
        $[13] = t4;
        $[14] = variables;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
};
const $0aea74171df1eb15$export$2482f01f112556a = ({ location: location, style: style = {}, renderWhenLoading: renderWhenLoading, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', children: children, onCompleted: onCompleted })=>{
    const { spaceIdentifier: spaceIdentifier, contentIdentifier: contentIdentifier } = $0aea74171df1eb15$var$useWebPanelLocationIdentifiers();
    const batchResult = $0aea74171df1eb15$export$784950ebf49d8a5f(location);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const completedBatchResultKeyRef = (0, $cozmU.useRef)(null);
    const EXPERIENCE_NAME_BY_LOCATION = {
        [(0, $eSLr0.ATL_FOOTER)]: (0, $irVI7.EXTENSION_POINT_HOME_FOOTER_EXPERIENCE),
        [(0, $eSLr0.ATL_GENERAL)]: (0, $irVI7.EXTENSION_POINT_HOME_HEADER_EXPERIENCE),
        [(0, $eSLr0.ATL_EDITOR_SAVEBAR)]: (0, $irVI7.EXTENSION_POINT_EDITOR_SAVEBAR_EXPERIENCE)
    };
    const experienceName = EXPERIENCE_NAME_BY_LOCATION[location] || null;
    (0, $cozmU.useEffect)(()=>{
        if (experienceName) experienceTracker.start({
            name: experienceName
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const variables = $0aea74171df1eb15$var$getWebPanelLocationVariables({
        location: location,
        contentIdentifier: contentIdentifier,
        spaceIdentifier: spaceIdentifier
    });
    (0, $cozmU.useEffect)(()=>{
        if (batchResult?.loading || batchResult?.error || !batchResult?.data || !onCompleted) return;
        const batchResultKey = `${contentIdentifier || ''}:${spaceIdentifier || ''}:${location}`;
        if (completedBatchResultKeyRef.current !== batchResultKey) {
            completedBatchResultKeyRef.current = batchResultKey;
            onCompleted();
        }
    }, [
        batchResult,
        contentIdentifier,
        location,
        onCompleted,
        spaceIdentifier
    ]);
    // TODO: The task to remove this hack is captured in CFE-1873.
    // There's some weird scenario where the UI ends up with a space key of "byDraft" relating to the way tinymce
    // creates content. Given that it's tinymce specific, I'm applying this hack for now and we can remove it once we're
    // at 100% rollout for the Fabric editor.
    if (spaceIdentifier === 'byDraft') return null;
    const renderWebPanels = ({ data: data, loading: loading, error: error })=>{
        // For transitions, loading and data is true
        if (loading && data) return null;
        if (!renderWhenLoading) {
            if (loading || error || !data) return null;
        }
        let panels = (data?.webPanels || []).filter((panel)=>panel);
        panels = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, panels);
        // For panels that don't have a placeholder
        if (!renderWhenLoading && !panels.length) {
            if (experienceName) experienceTracker.succeed({
                name: experienceName
            });
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$UFOWebPanelLocationWrapper, {
            locationName: location,
            panels: panels
        }, children ? children({
            panels: panels
        }) : panels.map((panel)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqPSe.WebPanel), {
                key: panel.completeKey,
                panelId: panel.completeKey,
                html: panel.html
            });
        })), experienceName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: experienceName
        }) : null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        /* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: style,
        "data-vc-ignore-if-no-layout-shift": true
    }, batchResult ? renderWebPanels(batchResult) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
        query: $0aea74171df1eb15$export$d97dfe528d83a912,
        variables: variables,
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted,
        __callerPackage__: "web-panel-location"
    }, renderWebPanels));
};
function $0aea74171df1eb15$var$_temp(panel) {
    return panel.html !== "";
}
function $0aea74171df1eb15$var$_temp2(panel_0) {
    return panel_0.completeKey;
}
module.exports["WebPanelLocationQuery"] = $0aea74171df1eb15$export$d97dfe528d83a912;
module.exports["useWebPanelLocationBatchResult"] = $0aea74171df1eb15$export$784950ebf49d8a5f;
module.exports["WebPanelLocationBatchProvider"] = $0aea74171df1eb15$export$2c530b46a1768809;
module.exports["WebPanelLocation"] = $0aea74171df1eb15$export$2482f01f112556a;

});

parcelRegister("eq95w", function(module, exports) {
/**
 * @generated SignedSource<<663f21e6dfcd4d4c24754e54b45772e8>>
 * @relayHash 8b133e3996bec5b3feff733a500f3451
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1205b4c053e3bf1a11112543759ae8178f8f0e4161f42e7f549b3c8cdcd56847
const $9206d19da4400201$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "location"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locations"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "location",
                    "variableName": "location"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "locations"
                }
            ],
            "concreteType": "WebPanel",
            "kind": "LinkedField",
            "name": "webPanels",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "moduleKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "completeKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "html"
                },
                {
                    "kind": "ScalarField",
                    "name": "location"
                },
                {
                    "kind": "ScalarField",
                    "name": "label"
                },
                {
                    "kind": "ScalarField",
                    "name": "weight"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WebPanelLocationQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WebPanelLocationQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "8b133e3996bec5b3feff733a500f3451",
            "id": "1205b4c053e3bf1a11112543759ae8178f8f0e4161f42e7f549b3c8cdcd56847",
            "metadata": {},
            "name": "WebPanelLocationQuery",
            "operationKind": "query",
            "text": "query WebPanelLocationQuery($location:String,$locations:[String],$contentId:ID,$spaceKey:String){webPanels(location:$location,locations:$locations,contentId:$contentId,key:$spaceKey){moduleKey,completeKey,html,location,label,weight,name}}"
        }
    };
}();
$9206d19da4400201$var$node.hash = "c9e0e68be80f814df706b6c0d828dae1";
var $9206d19da4400201$export$2e2bcd8739ae039 = $9206d19da4400201$var$node;
module.exports["default"] = $9206d19da4400201$export$2e2bcd8739ae039;

});

parcelRegister("bavCP", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $jMyy4 = parcelRequire("jMyy4");

const $86f32d96feea2a1f$export$67f105fad14d18d = (0, $3u0dr.isReactCompilerActiveV2)() ? function QueryInterop(t0) {
    const $ = (0, $bDgLe.c)(7);
    let children;
    let props;
    let query;
    if ($[0] !== t0) {
        ({ children: children, query: query, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
        $[3] = query;
    } else {
        children = $[1];
        props = $[2];
        query = $[3];
    }
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    let t1;
    if ($[4] !== children || $[5] !== result) {
        t1 = children(result);
        $[4] = children;
        $[5] = result;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : function QueryInterop({ children: children, query: query, ...props }) {
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    return children(result);
};
module.exports["QueryInterop"] = $86f32d96feea2a1f$export$67f105fad14d18d;

});

parcelRegister("8wW9d", function(module, exports) {
/* eslint-disable check-react-ssr-usage/guard-browser-globals -- Client-only instrumentation; non-content 3P apps are fetched and rendered on the client, never SSRed. */ /**
 * Instrumentation for third-party (3P) apps rendered OUTSIDE of page content
 * (e.g. byline, page banner, context menu, content tools, web panels).
 *
 * Unlike content macros/extensions (which are indexed from the ADF document by
 * `ExtrensionIndexProvider`), these apps are fetched client-side via GraphQL
 * hooks (`useWebItemLocation` / `useExtensionList`) and are therefore invisible
 * to the content-based telemetry.
 *
 * Each non-content surface calls `recordNonContentAppKeys` when its apps resolve.
 * The collected keys are stashed on a dedicated window global and later folded
 * into the page-load metric's `connectAppKeys` attribute (React UFO
 * `extra_properties`) by `pageLoadEventPlugin`, so they land in the same RUM
 * dataset as content app keys.
 */ const $eb9f67592b61ef7c$export$75dfc4b4563b78a5 = (appKeys)=>{
    if (typeof window === 'undefined') return;
    const keys = window.__NON_CONTENT_APP_KEYS__ ?? new Set();
    for (const key of appKeys)if (key) keys.add(key);
    window.__NON_CONTENT_APP_KEYS__ = keys;
};
const $eb9f67592b61ef7c$export$40caeb9e96de3450 = ()=>typeof window === 'undefined' ? new Set() : window.__NON_CONTENT_APP_KEYS__ ?? new Set();
const $eb9f67592b61ef7c$export$d36eed915298b207 = ()=>{
    if (typeof window === 'undefined') return;
    window.__NON_CONTENT_APP_KEYS__ = new Set();
};
module.exports["recordNonContentAppKeys"] = $eb9f67592b61ef7c$export$75dfc4b4563b78a5;
module.exports["getNonContentAppKeys"] = $eb9f67592b61ef7c$export$40caeb9e96de3450;

});

parcelRegister("1eaCJ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $03574d8c2683228e$export$4962f3898bd5c829(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { name: name, attributes: attributes } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== experienceTracker || $[2] !== name) {
        t1 = ()=>experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        t2 = [
            name,
            attributes,
            experienceTracker
        ];
        $[0] = attributes;
        $[1] = experienceTracker;
        $[2] = name;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceSuccess"] = $03574d8c2683228e$export$4962f3898bd5c829;

});

parcelRegister("3QyBm", function(module, exports) {

var $1xpoY = parcelRequire("1xpoY");

const $e9dc2b5b8bc8054b$export$888fec185e58bf9c = (location, items)=>{
    const locationsToHideConnectApps = (0, $1xpoY.default).getStringList('confluence_frontend_hidden_extension_points', []);
    const loc = Array.isArray(location) ? location[0] : location;
    if (locationsToHideConnectApps.includes(loc)) items = items.filter((item)=>!item?.completeKey?.startsWith('com.atlassian.plugins.atlassian-connect-plugin:'));
    return items;
};
module.exports["filterConnectAppsFromExtensionPoints"] = $e9dc2b5b8bc8054b$export$888fec185e58bf9c;

});

parcelRegister("iqPSe", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $brpfO = parcelRequire("brpfO");


var $6mKj3 = parcelRequire("6mKj3");


var $6UM2Q = parcelRequire("6UM2Q");


var $gIaMn = parcelRequire("gIaMn");


var $gEtAQ = parcelRequire("gEtAQ");

function $c50a10795e04dcb9$export$bbe14c99ac0820b3(t0) {
    const $ = (0, $bDgLe.c)(18);
    const { html: html, panelId: panelId } = t0;
    const containerRef = (0, $cozmU.useRef)(null);
    const [ssrSuccess, setSsrSuccess] = (0, $cozmU.useState)(true);
    let t1;
    if ($[0] !== html) {
        let t2;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /"moduleLocation"\s*:\s*"atl\.general"/;
            $[2] = t2;
        } else t2 = $[2];
        t1 = html.match(t2);
        $[0] = html;
        $[1] = t1;
    } else t1 = $[1];
    const moduleLocationMatch = t1;
    let t2;
    if ($[3] !== moduleLocationMatch) {
        t2 = Boolean(moduleLocationMatch) && (0, $gEtAQ.isSpaceOverview)();
        $[3] = moduleLocationMatch;
        $[4] = t2;
    } else t2 = $[4];
    const isMatchForActivatable = t2;
    let t3;
    if ($[5] !== isMatchForActivatable || $[6] !== ssrSuccess) {
        t3 = ()=>{
            const container = containerRef.current;
            if (!container) return;
            if (isMatchForActivatable && (0, $6mKj3.expVal)("confluence_frontend_early_webpanel_initialization", "isEnabled", false)) {
                if (window?.__HYDRATABLE__) {
                    const scriptElement = container.querySelector("script.ap-iframe-body-script");
                    if (scriptElement) {
                        const scriptContent = scriptElement.textContent || "";
                        const match = scriptContent.match(/"uniqueKey":"([^"]+)"/);
                        if (match) {
                            const uniqueKey = match[1];
                            const iframe = container.querySelector(`iframe[id*="${uniqueKey}"]`);
                            if (iframe) return;
                        }
                    }
                }
                if (ssrSuccess) setSsrSuccess(false);
            }
            (0, $brpfO.evalLegacyConnectInlineScripts)(container, (0, $6mKj3.expVal)("confluence_frontend_early_webpanel_initialization", "isEnabled", false));
        };
        $[5] = isMatchForActivatable;
        $[6] = ssrSuccess;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== html || $[9] !== isMatchForActivatable || $[10] !== panelId || $[11] !== ssrSuccess) {
        t4 = [
            html,
            panelId,
            ssrSuccess,
            isMatchForActivatable
        ];
        $[8] = html;
        $[9] = isMatchForActivatable;
        $[10] = panelId;
        $[11] = ssrSuccess;
        $[12] = t4;
    } else t4 = $[12];
    (0, $cozmU.useLayoutEffect)(t3, t4);
    let t5;
    if ($[13] !== html || $[14] !== isMatchForActivatable || $[15] !== panelId || $[16] !== ssrSuccess) {
        t5 = isMatchForActivatable && (0, $6mKj3.expVal)("confluence_frontend_early_webpanel_initialization", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: containerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6UM2Q.ActivatableComponent), {
            id: panelId ?? "WebPanel",
            triggers: [
                {
                    type: (0, $gIaMn.ActivationTriggerType).SSR_ONLY
                }
            ],
            ssrSuccess: ssrSuccess,
            analyticsName: "WebPanel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-vc-ignore-if-no-layout-shift": true,
            dangerouslySetInnerHTML: {
                __html: html
            }
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: containerRef,
            "data-vc-ignore-if-no-layout-shift": true,
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
        $[13] = html;
        $[14] = isMatchForActivatable;
        $[15] = panelId;
        $[16] = ssrSuccess;
        $[17] = t5;
    } else t5 = $[17];
    return t5;
}
module.exports["WebPanel"] = $c50a10795e04dcb9$export$bbe14c99ac0820b3;

});

parcelRegister("brpfO", function(module, exports) {

var $cpjd2 = parcelRequire("cpjd2");

const $5886a35f608ee97f$var$evalScripts = (allScripts)=>{
    allScripts.forEach((elementScript)=>{
        /**
		 * When evaluating the connect scripts, the eval function inherits the context in which is it called.
		 *
		 * This means that the eval function will have access to the variables and functions
		 * in the current scope. One of these variables is the `require` passed in from Atlaspack's module system.
		 *
		 * Since the eval scripts rely on AMD's require being globally available, and Atlaspack
		 * is now shadowing that variable, we need to evaluate the scripts in the global scope.
		 *
		 * We can do this using "indirect" eval, see the MDN docs for more info:
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/eval#direct_and_indirect_eval
		 *
		 * Assigning the eval function to a variable is enough to trigger the indirect eval behavior,
		 * and the scripts will be able to access the global require.
		 */ const evalInGlobalScope = eval;
        evalInGlobalScope(elementScript.innerHTML);
    });
};
function $5886a35f608ee97f$export$5beb7086100d432e(container, isEarlyInitFGEnabled = false) {
    // Connect macros have an inline script that doesn't work automatically when
    // rendered in react using dangerouslySetInnerHTML. This script evaluates any
    // connect macro.
    if (!container) return Promise.reject(new Error('evalLegacyConnectInlineScripts missing container argument'));
    const connectScripts = Array.from(container.querySelectorAll('script.ap-iframe-body-script'));
    const macroScripts = Array.from(container.querySelectorAll('script.cc-macro-body-script'));
    const allScripts = connectScripts.concat(macroScripts);
    // If the connect resources are preloaded, we don't need to download them again, just evaluate the scripts.
    if (window.__CONNECT_RESOURCES_PRELOADED__ && isEarlyInitFGEnabled) {
        $5886a35f608ee97f$var$evalScripts(allScripts);
        return Promise.resolve(null);
    }
    return new Promise((resolve)=>{
        if (allScripts.length > 0) // Download the connect web resources required to render an add-on before evaluating the inline scripts.
        (0, $cpjd2.requireLegacyWRM)([
            // ensure navigator-context misc dep is loaded before navigator-context
            'wr!confluence.web.resources:querystring',
            // resource to provide the context value of AP.navigator.getLocation
            'wr!confluence.web.resources:navigator-context',
            'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
        ], ()=>{
            $5886a35f608ee97f$var$evalScripts(allScripts);
            resolve(null);
        }, ()=>{});
        else resolve(null);
    });
}
module.exports["evalLegacyConnectInlineScripts"] = $5886a35f608ee97f$export$5beb7086100d432e;

});

parcelRegister("6UM2Q", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $9s45p = parcelRequire("9s45p");


var $75bK2 = parcelRequire("75bK2");


var $hRdzX = parcelRequire("hRdzX");

const $68e0b10beef6f399$export$1db2f2faaee8467f = (0, $3u0dr.isReactCompilerActiveV2)() ? function ActivatableComponent(t0) {
    const $ = (0, $bDgLe.c)(26);
    const { children: children, triggers: triggers, onActivate: onActivate, id: id, analyticsName: analyticsName, ssrSuccess: ssrSuccess } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $9s45p.makeGate)();
        $[0] = t1;
    } else t1 = $[0];
    const gate = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t2;
    if ($[1] !== children) {
        t2 = ()=>children;
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    const renderChildren = t2;
    let t3;
    if ($[3] !== analyticsName || $[4] !== createAnalyticsEvent || $[5] !== id || $[6] !== onActivate || $[7] !== triggers) {
        t3 = (reason)=>{
            if (gate?.getStatus() === "suspended") {
                onActivate?.(reason);
                if (analyticsName) createAnalyticsEvent({
                    type: "sendOperationalEvent",
                    data: {
                        source: "activatableComponent",
                        action: "activated",
                        actionSubject: "activatableComponent",
                        attributes: {
                            analyticsName: analyticsName,
                            triggers: triggers,
                            boundaryId: id,
                            activationReason: reason
                        }
                    }
                }).fire();
                gate.resolve();
            }
        };
        $[3] = analyticsName;
        $[4] = createAnalyticsEvent;
        $[5] = id;
        $[6] = onActivate;
        $[7] = triggers;
        $[8] = t3;
    } else t3 = $[8];
    const activateComponent = t3;
    let t4;
    if ($[9] !== activateComponent || $[10] !== analyticsName || $[11] !== id || $[12] !== triggers) {
        t4 = {
            triggers: triggers,
            gate: gate,
            activateComponent: activateComponent,
            boundaryId: id,
            analyticsName: analyticsName
        };
        $[9] = activateComponent;
        $[10] = analyticsName;
        $[11] = id;
        $[12] = triggers;
        $[13] = t4;
    } else t4 = $[13];
    const hostRefWithActivation = (0, $hRdzX.useActivationTriggers)(t4);
    let t5;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = gate?.getStatus?.();
        $[14] = t5;
    } else t5 = $[14];
    const t6 = analyticsName || id;
    let t7;
    if ($[15] !== activateComponent || $[16] !== id || $[17] !== renderChildren || $[18] !== ssrSuccess || $[19] !== t6 || $[20] !== triggers) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $75bK2.Boundary), {
            gate: gate,
            id: id,
            render: renderChildren,
            ssrSuccess: ssrSuccess,
            activateComponent: activateComponent,
            resolved: t5 === "resolved",
            boundaryName: t6,
            triggers: triggers
        });
        $[15] = activateComponent;
        $[16] = id;
        $[17] = renderChildren;
        $[18] = ssrSuccess;
        $[19] = t6;
        $[20] = triggers;
        $[21] = t7;
    } else t7 = $[21];
    let t8;
    if ($[22] !== hostRefWithActivation || $[23] !== id || $[24] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: hostRefWithActivation,
            "data-hydration-shield": id
        }, t7);
        $[22] = hostRefWithActivation;
        $[23] = id;
        $[24] = t7;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
} : function ActivatableComponent({ children: children, triggers: triggers, onActivate: onActivate, id: id, analyticsName: analyticsName, ssrSuccess: ssrSuccess }) {
    const gate = (0, $cozmU.useMemo)(()=>(0, $9s45p.makeGate)(), []);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const renderChildren = (0, $cozmU.useCallback)(()=>{
        return children;
    }, [
        children
    ]);
    const activateComponent = (0, $cozmU.useCallback)((reason)=>{
        if (gate?.getStatus() === 'suspended') {
            onActivate?.(reason);
            if (analyticsName) createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'activatableComponent',
                    action: 'activated',
                    actionSubject: 'activatableComponent',
                    attributes: {
                        analyticsName: analyticsName,
                        triggers: triggers,
                        boundaryId: id,
                        activationReason: reason
                    }
                }
            }).fire();
            gate.resolve();
        }
    }, [
        gate,
        id,
        onActivate,
        createAnalyticsEvent,
        analyticsName,
        triggers
    ]);
    const hostRefWithActivation = (0, $hRdzX.useActivationTriggers)({
        triggers: triggers,
        gate: gate,
        activateComponent: activateComponent,
        boundaryId: id,
        analyticsName: analyticsName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: hostRefWithActivation,
        "data-hydration-shield": id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $75bK2.Boundary), {
        gate: gate,
        id: id,
        render: renderChildren,
        ssrSuccess: ssrSuccess,
        activateComponent: activateComponent,
        resolved: gate?.getStatus?.() === 'resolved',
        boundaryName: analyticsName || id,
        triggers: triggers
    }));
};
module.exports["ActivatableComponent"] = $68e0b10beef6f399$export$1db2f2faaee8467f;

});

parcelRegister("fIKxq", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gIaMn = parcelRequire("gIaMn");

var $jmjWc = parcelRequire("jmjWc");


var $6mKj3 = parcelRequire("6mKj3");


var $8zMP3 = parcelRequire("8zMP3");


var $5Abqh = parcelRequire("5Abqh");


var $ihn35 = parcelRequire("ihn35");


const $d90c1a5bdc683f34$export$ea341515a2d0d231 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cFlY8",
    name: "EndOfPageRecommendationLoader",
    loader: async ()=>(await (parcelRequire("22xxv"))).EndOfPageRecommendation
});

const $d90c1a5bdc683f34$export$1589de5a2b0484dc = (0, $jmjWc.LoadableActivatable)({
    __loadable_id__: "nhVSK",
    name: "EndOfPageRecommendationLoaderWithScrollIntoView",
    loader: async ()=>(await (parcelRequire("22xxv"))).EndOfPageRecommendation,
    triggers: [
        {
            type: (0, $gIaMn.ActivationTriggerType).SCROLL_INTO_VIEW
        }
    ],
    ssrSuccessCheckName: (0, $5Abqh.SSR_PARTIAL_COMPONENT).EndOfPageRecommendation
});
const $d90c1a5bdc683f34$export$ab3a258d2d028df5 = (props)=>{
    const $ = (0, $bDgLe.c)(5);
    if ((0, $6mKj3.expVal)("confluence_end_of_page_recs_suspense", "isEnabled", false)) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ihn35.EndOfPageRecPlaceholderContainer), null);
            $[0] = t0;
        } else t0 = $[0];
        let t1;
        if ($[1] !== props) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
                dataFetcherName: "end-of-page-recommendations",
                fallback: t0
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d90c1a5bdc683f34$export$ea341515a2d0d231, props));
            $[1] = props;
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    let t0;
    if ($[3] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d90c1a5bdc683f34$export$1589de5a2b0484dc, props);
        $[3] = props;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
};
module.exports["EndOfPageRecommendationLoader"] = $d90c1a5bdc683f34$export$ea341515a2d0d231;
module.exports["EndOfPageRecommendationFinalLoader"] = $d90c1a5bdc683f34$export$ab3a258d2d028df5;

});

parcelRegister("8zMP3", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $a1L5E = parcelRequire("a1L5E");


var $hZpML = parcelRequire("hZpML");


var $8zKDl = parcelRequire("8zKDl");


var $cemw8 = parcelRequire("cemw8");

// Enhanced context to track the full boundary chain from root to current
const $5cfe2edd168ef31e$var$SuspenseBoundaryNameContext = /*#__PURE__*/ (0, $cozmU.createContext)([]);
const $5cfe2edd168ef31e$export$b17d024ed060ce0b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($5cfe2edd168ef31e$var$SuspenseBoundaryNameContext);
} : ()=>{
    return (0, $cozmU.useContext)($5cfe2edd168ef31e$var$SuspenseBoundaryNameContext);
};
const $5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader = (0, $3u0dr.isReactCompilerActiveV2)() ? function SuspenseWithDataFetcherReader(t0) {
    const $ = (0, $bDgLe.c)(2);
    const { dataFetcher: dataFetcher, children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function SuspenseWithDataFetcherReader({ dataFetcher: dataFetcher, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
function $5cfe2edd168ef31e$export$553ede96e278ba94({ dataFetcherName: dataFetcherName, fallback: fallback = null, children: children }) {
    // Capture the SSR streaming value on initial render using useRef
    // This ensures the component tree doesn't change when the global variable
    // is deleted during route navigation
    const isSSRStreaming = (0, $cozmU.useRef)(window.__SSR_REACT_STREAMING__);
    // Get the current boundary chain from parent context
    const parentBoundaryChain = (0, $cozmU.useContext)($5cfe2edd168ef31e$var$SuspenseBoundaryNameContext);
    // Create new chain by appending current boundary to parent chain
    const currentBoundaryChain = [
        ...parentBoundaryChain,
        dataFetcherName
    ];
    if (isSSRStreaming.current) {
        const dataFetcher = (0, $8zKDl.getDataFetcherForSuspense)(dataFetcherName, isSSRStreaming.current);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5cfe2edd168ef31e$var$SuspenseBoundaryNameContext.Provider, {
            value: currentBoundaryChain
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cemw8.HydrationSafeSuspense), {
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader, {
            dataFetcher: dataFetcher
        }, (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SUSPENSE}/${dataFetcherName}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: `stream-suspense-${dataFetcherName}`
        }, children), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SUSPENSE}/${dataFetcherName}.end`))));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
}
module.exports["SuspenseWithDataFetcher"] = $5cfe2edd168ef31e$export$553ede96e278ba94;

});

parcelRegister("8zKDl", function(module, exports) {
function $2b2227915da27313$export$63116239d47be9ca(dataFetcherName, isSSRStreaming = true) {
    if (!isSSRStreaming || !dataFetcherName) return null;
    return window.__dataFetcherForSuspense__?.[dataFetcherName] ?? null;
}
module.exports["getDataFetcherForSuspense"] = $2b2227915da27313$export$63116239d47be9ca;

});

parcelRegister("cemw8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $e4o8D = parcelRequire("e4o8D");

const $28f120e398482486$var$HydrationSafeSuspenseContent = /*#__PURE__*/ (0, $cozmU.memo)(function HydrationSafeSuspenseContent({ children: children, fallback: fallback }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: fallback
    }, children);
}, (_prevProps, nextProps)=>{
    // Block updates while locked (during hydration)
    return nextProps.isLocked;
});
function $28f120e398482486$export$a0bfcafd6d556141({ fallback: fallback = null, children: children }) {
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28f120e398482486$var$HydrationSafeSuspenseContent, {
        isLocked: renderServerPlaceholder,
        fallback: fallback
    }, children);
}
module.exports["HydrationSafeSuspense"] = $28f120e398482486$export$a0bfcafd6d556141;

});

parcelRegister("ihn35", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $e8a7d12ee4dfec6a$export$f0a7c5a0719c820d = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1txw _2lx21bp4 _1bah1h6o _ca0qoahv _n3tdv47k _p12fukw8 _1bsb1osq _4t3i68cl",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$efb20161e583b9b8 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_11c81qyo _1e0c1txw _1bah1yb4 _4cvr1h6o _n3tdu2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$80837d77c7223a53 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o _u5f3u2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$7b34b3c5c4f8605a = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _bfhki8nm _4t3it94y _1bsbidpf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$48423cf6a25b5248 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_zulputpp _11c8fhey _1yt44ar7 _1e0c1txw _2lx21bp4 _p12fsb0t",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$77a9080c0e27b9d1 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1e0c1txw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$49166591ec160d97 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1e0c1txw _19bvu2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$ee3e739bedcb3f4c = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2lx2vrvc _1n261g80 _zulppxbi _1e0c1txw _4t3i1obz _1bah1yb4",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$227f3f793075b973 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isNav4Enabled: isNav4Enabled, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_zulp1ejb _11c8fhey _1e0c1txw _2lx21bp4 _u5f3xncg _p12f10k3",
            !__cmplp.isNav4Enabled && "_19bvv47k",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$545440ab15c19255 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_zulppxbi _1e0c1txw _2lx21bp4",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$bb7ed78cda4c11ab = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_zulputpp _11c8i4vh _syazazsu _1e0c1txw _4cvr1h6o _19bv1ejb",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$a436177ded449686 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_zulppxbi _1e0c1txw _4cvr1h6o _19bvutpp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$faaa5da096482ae9 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_11c8i4vh _syazazsu",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$a1abff0c22b50819 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_18u01b66",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $e8a7d12ee4dfec6a$export$23b4998b204f6604 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "p" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_11c8i4vh _syazazsu _n3tdu2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
module.exports["EndOfPageRecPlaceholderContainer"] = $e8a7d12ee4dfec6a$export$f0a7c5a0719c820d;
module.exports["InfoContainer"] = $e8a7d12ee4dfec6a$export$48423cf6a25b5248;
module.exports["FeedbackContainer"] = $e8a7d12ee4dfec6a$export$77a9080c0e27b9d1;
module.exports["EndOfPageRecAdminConfigContainer"] = $e8a7d12ee4dfec6a$export$227f3f793075b973;
module.exports["EndOfPageRecHideControlContainer"] = $e8a7d12ee4dfec6a$export$545440ab15c19255;
module.exports["EndOfPageRecHideToggleContainer"] = $e8a7d12ee4dfec6a$export$bb7ed78cda4c11ab;
module.exports["SpaceFeedbackButtonWrapper"] = $e8a7d12ee4dfec6a$export$a1abff0c22b50819;

});

parcelRegister("22xxv", function(module, exports) {

let $17c5c8e3bfe2510f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $17c5c8e3bfe2510f$var$load("dKv6J"),
    $17c5c8e3bfe2510f$var$load("8JUxP"),
    $17c5c8e3bfe2510f$var$load("bb3WM"),
    $17c5c8e3bfe2510f$var$load("iwH7W"),
    $17c5c8e3bfe2510f$var$load("i3R6S"),
    $17c5c8e3bfe2510f$var$load("cIET7"),
    $17c5c8e3bfe2510f$var$load("32NHR"),
    $17c5c8e3bfe2510f$var$load("glmO2"),
    $17c5c8e3bfe2510f$var$load("gW7tk"),
    $17c5c8e3bfe2510f$var$load("1GCFv"),
    $17c5c8e3bfe2510f$var$load("h4Nf7"),
    $17c5c8e3bfe2510f$var$load("4XkGy"),
    $17c5c8e3bfe2510f$var$load("kHXvF"),
    $17c5c8e3bfe2510f$var$load("7gL7H"),
    $17c5c8e3bfe2510f$var$load("fuOfV"),
    $17c5c8e3bfe2510f$var$load("jL1Ke"),
    $17c5c8e3bfe2510f$var$load("5MQ0D"),
    $17c5c8e3bfe2510f$var$load("cmmpX"),
    $17c5c8e3bfe2510f$var$load("Kj0I8"),
    $17c5c8e3bfe2510f$var$load("5xnun"),
    $17c5c8e3bfe2510f$var$load("6wr18"),
    $17c5c8e3bfe2510f$var$load("59hV4"),
    $17c5c8e3bfe2510f$var$load("8zMmc"),
    $17c5c8e3bfe2510f$var$load("4x9Jx"),
    $17c5c8e3bfe2510f$var$load("ffEVr"),
    $17c5c8e3bfe2510f$var$load("kFiBp"),
    $17c5c8e3bfe2510f$var$load("iUXaE"),
    $17c5c8e3bfe2510f$var$load("lTkx9"),
    $17c5c8e3bfe2510f$var$load("Wowvf"),
    $17c5c8e3bfe2510f$var$load("eRhBr"),
    $17c5c8e3bfe2510f$var$load("7EorR"),
    $17c5c8e3bfe2510f$var$load("hhss7"),
    $17c5c8e3bfe2510f$var$load("iV6RN")
]).then(()=>parcelRequire('kPKkS'));

});

parcelRegister("3UatB", function(module, exports) {

let $2d7eba7bda078c34$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2d7eba7bda078c34$var$load("hvk9p").then(()=>parcelRequire('5Gh4V'));

});

parcelRegister("iNYtG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4r9Ir = parcelRequire("4r9Ir");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $bQm3c = parcelRequire("bQm3c");


var $6UYek = parcelRequire("6UYek");


var $8i27m = parcelRequire("8i27m");


var $3mVfX = parcelRequire("3mVfX");


var $dkkKv = parcelRequire("dkkKv");


var $l5y3Y = parcelRequire("l5y3Y");


var $fHAwL = parcelRequire("fHAwL");


var $d3bcC = parcelRequire("d3bcC");


var $6mKj3 = parcelRequire("6mKj3");


var $NYiei = parcelRequire("NYiei");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $804Ue = parcelRequire("804Ue");


var $83eLG = parcelRequire("83eLG");


var $aM1he = parcelRequire("aM1he");

const $d9d12cfcf38f06b2$export$ae25147d30bdeffa = ({ contentId: contentId, contentType: contentType })=>{
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    const { addNewComment: addNewComment, removeComment: removeComment, clearNewComments: clearNewComments } = (0, $cozmU.useContext)((0, $4r9Ir.NewCommentsContext));
    const { addSubscriber: addSubscriber, removeSubscriber: removeSubscriber, setContentType: setContentType, setContentId: setContentId } = (0, $6UYek.useSubscriptionsDispatchContext)() || {};
    const subscriptions = (0, $cozmU.useRef)([]);
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { updateUnreadCommentIDSet: updateUnreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsActions)();
    const { getViewedCommentsCacheOnly: getViewedCommentsCacheOnly } = (0, $d3bcC.useViewedComments)({
        pageId: contentId
    });
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { addReplyToCommentThread: addReplyToCommentThread, addNewCommentThreads: addNewCommentThreads, getCurrentCommentsPanelState: getCurrentCommentsPanelState, updateCommentBody: updateCommentBody, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, reopenParentComment: reopenParentComment } = (0, $8i27m.useCommentsDataActions)();
    const { setReplyToCommentId: setReplyToCommentId, getCommentsPanelState: getCommentsPanelState } = (0, $3mVfX.useCommentsPanelActions)();
    const clearReplyIfRemoved = (0, $cozmU.useCallback)(({ commentId: commentId })=>{
        const { replyToCommentId: replyToCommentId } = getCommentsPanelState();
        if (replyToCommentId === commentId) setReplyToCommentId();
    }, [
        getCommentsPanelState,
        setReplyToCommentId
    ]);
    // Control skip state - start with true to prevent query on mount, set to false when events are detected
    const [shouldSkipQuery, setShouldSkipQuery] = (0, $cozmU.useState)(true);
    // Reset skip state when contentId changes (new page)
    (0, $cozmU.useEffect)(()=>{
        setShouldSkipQuery(true);
    }, [
        contentId
    ]);
    const { deleteCommentInCache: deleteCommentInCache, addCommentInCache: addCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    });
    // Implementation using ActiveCommentsQuery
    // Skip is controlled by state - starts as true, set to false when handleEventFetchSuccess is called
    const { refetch: activeCommentsRefetch } = (0, $dkkKv.useActiveCommentsQuery)({
        pageId: contentId,
        type: 'FOOTER',
        skip: shouldSkipQuery || !contentId,
        fetchPolicy: 'cache-and-network'
    });
    const subscribeToPageCommentsPubSub = (0, $cozmU.useCallback)(()=>{
        // Early return if pageMode is Edit - do not setup pubsub for edit pages
        if (pageMode === (0, $cD1qu.PageMode).EDIT) return;
        if (subscriptions.current.length > 0 && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return;
        const queryArgs = {
            isReactionsEnabled: isReactionsEnabled
        };
        subscriptions.current = (0, $83eLG.setUpPageCommentsPubSub)({
            contentId: contentId,
            contentType: contentType,
            userId: userId,
            reloader: activeCommentsRefetch,
            addNewComment: addNewComment,
            removeComment: removeComment,
            queryArgs: queryArgs,
            addNewCommentThreads: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? ()=>{} : addNewCommentThreads,
            addReplyToCommentThread: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? ()=>{} : addReplyToCommentThread,
            updateCommentBody: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? ()=>{} : updateCommentBody,
            updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
            reopenParentComment: reopenParentComment,
            getCurrentCommentsPanelState: getCurrentCommentsPanelState,
            addSubscriber: addSubscriber,
            setContentType: setContentType,
            setContentId: setContentId,
            updateUnreadCommentIDSet: updateUnreadCommentIDSet,
            getViewedCommentsCacheOnly: getViewedCommentsCacheOnly,
            addCommentInCache: addCommentInCache,
            deleteCommentInCache: deleteCommentInCache,
            clearReplyIfRemoved: clearReplyIfRemoved
        }) ?? [];
    }, [
        contentId,
        contentType,
        userId,
        activeCommentsRefetch,
        addNewComment,
        removeComment,
        isReactionsEnabled,
        addNewCommentThreads,
        addReplyToCommentThread,
        updateCommentBody,
        updateRemovedCommentIdsMap,
        reopenParentComment,
        getCurrentCommentsPanelState,
        addSubscriber,
        setContentType,
        setContentId,
        updateUnreadCommentIDSet,
        getViewedCommentsCacheOnly,
        addCommentInCache,
        deleteCommentInCache,
        pageMode,
        clearReplyIfRemoved
    ]);
    const unsubscribeFromPageCommentsPubSub = (0, $cozmU.useCallback)(()=>{
        // Early return if pageMode is Edit - no pubsub was set up for edit pages
        if (pageMode === (0, $cD1qu.PageMode).EDIT) return;
        if (subscriptions.current.length === 0 && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return;
        const queryArgs_0 = {
            isReactionsEnabled: isReactionsEnabled
        };
        (0, $83eLG.removePageCommentsPubSub)({
            contentId: contentId,
            contentType: contentType,
            userId: userId,
            reloader: activeCommentsRefetch,
            addNewComment: addNewComment,
            removeComment: removeComment,
            queryArgs: queryArgs_0,
            updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
            removeSubscriber: removeSubscriber,
            subscriptions: subscriptions.current,
            getViewedCommentsCacheOnly: getViewedCommentsCacheOnly
        });
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) subscriptions.current = [];
    }, [
        contentId,
        contentType,
        userId,
        activeCommentsRefetch,
        addNewComment,
        removeComment,
        isReactionsEnabled,
        updateRemovedCommentIdsMap,
        removeSubscriber,
        getViewedCommentsCacheOnly,
        pageMode
    ]);
    const handleEventFetchSuccess = (0, $cozmU.useCallback)((data)=>{
        if (data && data.contentId === contentId) {
            // Enable the query so refetch can work
            setShouldSkipQuery(false);
            if (data.commentEvents.length) {
                const commentData = data.commentEvents.map((event)=>{
                    return {
                        commentId: event.id,
                        accountId: event.accountId
                    };
                });
                (0, $aM1he.reloadAndAddPageComments)(activeCommentsRefetch, addNewComment, commentData, userId);
            }
        }
    }, [
        contentId,
        addNewComment,
        activeCommentsRefetch,
        userId
    ]);
    if (!userId || pageMode === (0, $cD1qu.PageMode).EDIT && (0, $6mKj3.expValEquals)('confluence_comments_get_document_version_number', 'isEnabled', true)) return null;
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COLLABORATION
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $804Ue.MissedPubSubCommentEventsHandler), {
        contentId: contentId,
        eventType: (0, $804Ue.CommentEventType).FOOTER,
        subscribeToPubSubEvents: subscribeToPageCommentsPubSub,
        unsubscribeFromPubSubEvents: unsubscribeFromPageCommentsPubSub,
        onEventFetchSuccess: handleEventFetchSuccess,
        onDocumentReturn: clearNewComments,
        isAutoReloadPageComments: true
    }));
};
module.exports["PageCommentsPubSubHandler"] = $d9d12cfcf38f06b2$export$ae25147d30bdeffa;

});

parcelRegister("4r9Ir", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7IghX = parcelRequire("7IghX");

const $4ae3b5b25efc2fdf$export$c465d99c658013a3 = /*#__PURE__*/ (0, $cozmU.createContext)({
    newCommentPositions: [],
    addNewComment: ()=>{},
    removeComment: ()=>{},
    acknowledgeComment: ()=>{},
    acknowledgeComments: ()=>{},
    clearNewComments: ()=>{}
});
const $4ae3b5b25efc2fdf$var$getCommentScreenPosition = (commentId)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const commentElem = document.querySelector(`#comment-${commentId}`);
    if (commentElem) return {
        top: commentElem.offsetTop,
        bottom: commentElem.offsetTop + commentElem.offsetHeight
    };
    return {
        top: Number.NEGATIVE_INFINITY,
        bottom: Number.POSITIVE_INFINITY
    };
};
const $4ae3b5b25efc2fdf$export$18a14437c7fa7b9f = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [newCommentPositions, setNewCommentPositions] = (0, $cozmU.useState)(t1);
    const { count: count, setCount: setCount } = (0, $cozmU.useContext)((0, $7IghX.PageCommentsCountContext));
    let t2;
    if ($[1] !== count || $[2] !== setCount) {
        t2 = (t3)=>{
            const { currentUserMadeComment: currentUserMadeComment, newCommentId: newCommentId } = t3;
            if (newCommentId) {
                const pos = $4ae3b5b25efc2fdf$var$getCommentScreenPosition(newCommentId);
                setNewCommentPositions((existingPositions)=>{
                    const commentExists = existingPositions.some((e)=>e.id === newCommentId);
                    return !commentExists ? [
                        ...existingPositions,
                        {
                            id: newCommentId,
                            pos: pos,
                            seen: false,
                            currentUserMadeComment: currentUserMadeComment
                        }
                    ] : existingPositions;
                });
                setCount(count + 1);
            }
        };
        $[1] = count;
        $[2] = setCount;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== count || $[5] !== newCommentPositions || $[6] !== setCount) {
        t3 = (commentId)=>{
            if (commentId) {
                const idx = newCommentPositions.findIndex((comment)=>commentId === comment.id);
                if (idx !== -1) {
                    const positionCopy = [
                        ...newCommentPositions
                    ];
                    positionCopy.splice(idx, 1);
                    setNewCommentPositions(positionCopy);
                }
                const newCount = count - 1;
                setCount(newCount < 0 ? 0 : newCount);
            }
        };
        $[4] = count;
        $[5] = newCommentPositions;
        $[6] = setCount;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    let t5;
    if ($[8] !== newCommentPositions) {
        t4 = (commentId_0)=>{
            if (commentId_0) {
                const comment_0 = newCommentPositions.find((commentPosition)=>commentPosition.id === commentId_0);
                if (comment_0) comment_0.seen = true;
            }
        };
        t5 = (commentIds)=>{
            if (commentIds && commentIds.length) commentIds.forEach((commentId_1)=>{
                const comment_1 = newCommentPositions.find((commentPosition_0)=>commentPosition_0.id === commentId_1);
                if (comment_1) comment_1.seen = true;
            });
        };
        $[8] = newCommentPositions;
        $[9] = t4;
        $[10] = t5;
    } else {
        t4 = $[9];
        t5 = $[10];
    }
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setNewCommentPositions([]);
        };
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== newCommentPositions || $[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
        t7 = {
            newCommentPositions: newCommentPositions,
            addNewComment: t2,
            removeComment: t3,
            acknowledgeComment: t4,
            acknowledgeComments: t5,
            clearNewComments: t6
        };
        $[12] = newCommentPositions;
        $[13] = t2;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
        $[17] = t7;
    } else t7 = $[17];
    const newCommentsContextValue = t7;
    let t8;
    if ($[18] !== children || $[19] !== newCommentsContextValue) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4ae3b5b25efc2fdf$export$c465d99c658013a3.Provider, {
            value: newCommentsContextValue
        }, children);
        $[18] = children;
        $[19] = newCommentsContextValue;
        $[20] = t8;
    } else t8 = $[20];
    return t8;
} : ({ children: children })=>{
    const [newCommentPositions, setNewCommentPositions] = (0, $cozmU.useState)([]);
    const { count: count, setCount: setCount } = (0, $cozmU.useContext)((0, $7IghX.PageCommentsCountContext));
    const newCommentsContextValue = (0, $cozmU.useMemo)(()=>({
            newCommentPositions: newCommentPositions,
            addNewComment: ({ currentUserMadeComment: currentUserMadeComment, newCommentId: newCommentId })=>{
                if (newCommentId) {
                    const pos = $4ae3b5b25efc2fdf$var$getCommentScreenPosition(newCommentId);
                    setNewCommentPositions((existingPositions)=>{
                        const commentExists = existingPositions.some((e)=>e.id === newCommentId);
                        return !commentExists ? [
                            ...existingPositions,
                            {
                                id: newCommentId,
                                pos: pos,
                                seen: false,
                                currentUserMadeComment: currentUserMadeComment
                            }
                        ] : existingPositions;
                    });
                    // Update the comment count
                    setCount(count + 1);
                }
            },
            removeComment: (commentId)=>{
                if (commentId) {
                    const idx = newCommentPositions.findIndex((comment)=>commentId === comment.id);
                    if (idx !== -1) {
                        const positionCopy = [
                            ...newCommentPositions
                        ];
                        positionCopy.splice(idx, 1);
                        setNewCommentPositions(positionCopy);
                    }
                    // Update the comment count
                    const newCount = count - 1;
                    setCount(newCount < 0 ? 0 : newCount);
                }
            },
            acknowledgeComment: (commentId_0)=>{
                if (commentId_0) {
                    const comment_0 = newCommentPositions.find((commentPosition)=>commentPosition.id === commentId_0);
                    if (comment_0) comment_0.seen = true;
                }
            },
            acknowledgeComments: (commentIds)=>{
                if (commentIds && commentIds.length) commentIds.forEach((commentId_1)=>{
                    const comment_1 = newCommentPositions.find((commentPosition_0)=>commentPosition_0.id === commentId_1);
                    if (comment_1) comment_1.seen = true;
                });
            },
            clearNewComments: ()=>{
                setNewCommentPositions([]);
            }
        }), [
        count,
        newCommentPositions,
        setCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4ae3b5b25efc2fdf$export$c465d99c658013a3.Provider, {
        value: newCommentsContextValue
    }, children);
};
module.exports["NewCommentsContext"] = $4ae3b5b25efc2fdf$export$c465d99c658013a3;
module.exports["NewCommentsProvider"] = $4ae3b5b25efc2fdf$export$18a14437c7fa7b9f;

});

parcelRegister("7IghX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $230ca5ca2ceedabc$export$560530991a10c1f8 = /*#__PURE__*/ (0, $cozmU.createContext)({
    count: 0,
    setCount: ()=>{}
});
const $230ca5ca2ceedabc$export$d3be1c3b23ba5810 = ({ children: children, contentId: contentId })=>{
    const [count, setCount] = (0, $cozmU.useState)(0);
    const pageCommentsCountContextValue = (0, $cozmU.useMemo)(()=>({
            count: count,
            setCount: setCount
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        count,
        contentId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($230ca5ca2ceedabc$export$560530991a10c1f8.Provider, {
        value: pageCommentsCountContextValue
    }, children);
};
module.exports["PageCommentsCountContext"] = $230ca5ca2ceedabc$export$560530991a10c1f8;
module.exports["PageCommentsCountProvider"] = $230ca5ca2ceedabc$export$d3be1c3b23ba5810;

});

parcelRegister("6UYek", function(module, exports) {

var $fbcPJ = parcelRequire("fbcPJ");


var $cozmU = parcelRequire("cozmU");


var $kyKWe = parcelRequire("kyKWe");


var $fD0Uz = parcelRequire("fD0Uz");


var $9wGTI = parcelRequire("9wGTI");


var $7Sm4c = parcelRequire("7Sm4c");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $1xpoY = parcelRequire("1xpoY");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $3vc4U = parcelRequire("3vc4U");

const $da160e8fa3112de6$var$SubscriptionsContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $da160e8fa3112de6$var$SubscriptionsDispatchContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $da160e8fa3112de6$export$2612561ece05d878 = [
    '401',
    'Failed to fetch',
    'Load Failed',
    'Network error',
    'GraphQL error: undefined',
    'Auth category: UNAUTHENTICATED is not allowed in service confluence_monolith_subscriptions'
];
const $da160e8fa3112de6$var$getLegacyApolloError = (error)=>{
    if (!('errors' in error) || !Array.isArray(error.errors)) return undefined;
    const firstError = error.errors[0];
    return firstError && typeof firstError === 'object' ? firstError : undefined;
};
const $da160e8fa3112de6$var$getLegacyApolloErrorMessage = (error)=>{
    const firstError = $da160e8fa3112de6$var$getLegacyApolloError(error);
    if (!firstError || !('message' in firstError)) return undefined;
    return typeof firstError.message === 'string' ? firstError.message : undefined;
};
const $da160e8fa3112de6$var$getLegacyApolloErrorStatusCode = (error)=>{
    const firstError = $da160e8fa3112de6$var$getLegacyApolloError(error);
    if (!firstError || !('extensions' in firstError)) return undefined;
    const { extensions: extensions } = firstError;
    if (!extensions || typeof extensions !== 'object' || !('statusCode' in extensions)) return undefined;
    return typeof extensions.statusCode === 'number' ? extensions.statusCode : undefined;
};
const $da160e8fa3112de6$export$5f043fff8b6d3ca6 = ({ children: children })=>{
    const [contentModified, setContentModified] = (0, $cozmU.useState)(null);
    const [contentId, setContentId] = (0, $cozmU.useState)(null);
    const [contentType, setContentType] = (0, $cozmU.useState)(null);
    const subscribersRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef({});
    // if there are no subscribers left we set the contentId and contentType to null
    // remove subscriber on unmount of subscription component
    /***
   * Adds a subscriber to the context.
   * @delta - the delta to subscribe to
   * @subscriberId - an id for the subscriber, used to remove the subscriber later
   * @onSubscriptionData - callback to be called when data is received for the delta
   * @returns uniqueSubscriberId - a unique id for the subscriber, used to remove the subscriber later
   */ const addSubscriber = (0, $cozmU.useCallback)(({ subscriberId: subscriberId, onSubscriptionData: onSubscriptionData, delta: delta })=>{
        const subscribers = subscribersRef.current;
        const uniqueSubscriberId = `${subscriberId}-${(0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()}`; // ensure unique subscriberId
        const currentSubscribersForDelta = subscribers?.[delta] || [];
        subscribers[delta] = [
            ...currentSubscribersForDelta,
            {
                id: uniqueSubscriberId,
                onSubscriptionData: onSubscriptionData
            }
        ];
        return uniqueSubscriberId;
    }, []);
    const removeSubscriber = (0, $cozmU.useCallback)(({ delta: delta, subscriberId: subscriberId })=>{
        const subscribers = subscribersRef.current;
        if (subscribers.hasOwnProperty(delta)) {
            subscribers[delta] = (subscribers[delta] ?? []).filter((sub)=>sub.id !== subscriberId);
            // if there are no subscribers left for this delta, we can remove the delta
            if (subscribers[delta].length === 0) {
                delete subscribers[delta];
                // if that was the last subscriber we can stop the subscription entirely
                if (Object.keys(subscribers).length === 0) {
                    setContentId(null);
                    setContentType(null);
                }
            }
        }
    }, [
        setContentId,
        setContentType
    ]);
    const callSubscribers = (0, $cozmU.useCallback)((deltas, data)=>{
        const subscribers = subscribersRef.current;
        deltas.forEach((delta)=>{
            const subscribersForDelta = subscribers[delta];
            if (subscribersForDelta) subscribersForDelta.forEach((subscriber)=>{
                const callback = subscriber?.onSubscriptionData?.(delta, data);
                if (callback instanceof Promise) Promise.resolve(callback).catch((err)=>{
                    (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                        // hard coded as the package will cause circular dependency
                        attribution: 'page-experiences'
                    });
                });
            });
        });
    }, []);
    const { id: id, onSubscriptionComplete: onSubscriptionComplete, extensions: extensions, onSubscriptionData: onDataReceived } = (0, $3vc4U.useSubscriptionValues)({
        contentType: contentType,
        contentId: contentId
    });
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const skipSubscriptionForAnonUsers = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS;
    const { error: error } = (0, $fD0Uz.useSubscriptionInterop)((0, $fbcPJ.default), {
        variables: {
            id: id,
            __extensions: extensions
        },
        extensions: extensions,
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData (response) {
            onDataReceived(response);
            const { subscriptionData: subscriptionData } = response;
            if (!subscriptionData || !subscriptionData.data) return;
            const deltas = subscriptionData?.data?.confluence_onContentModified?._deltas;
            const data = subscriptionData?.data?.confluence_onContentModified;
            if (deltas && Array.isArray(deltas) && deltas.length > 0 && data) callSubscribers(deltas, data);
            setContentModified(data ?? null);
        },
        skip: !id || skipSubscriptionForAnonUsers || !(0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider'),
        interopApolloAggClient: true,
        __callerPackage__: "graphql"
    });
    (0, $cozmU.useEffect)(()=>{
        if (error) {
            const errorMessage = error?.message || $da160e8fa3112de6$var$getLegacyApolloErrorMessage(error) || error?.graphQLErrors?.[0]?.message || error?.graphQLErrors?.[0]?.originalError?.message || error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.extensions?.message;
            const statusCode = $da160e8fa3112de6$var$getLegacyApolloErrorStatusCode(error);
            // if there is no error message it is likely to be a client side network issue
            // eg spotty vpn
            //
            // When graphql-subscriptions rate-limits us it returns an HTML page (eg a 429),
            // which graphql-ws feeds into JSON.parse and throws a SyntaxError. In V8 the
            // thrown message embeds the offending token, eg:
            //   Unexpected token '<', "<!DOCTYPE "... is not valid JSON
            // We match on the HTML markers rather than the generic "Unexpected token" so we
            // only suppress HTML payloads and not unrelated malformed-JSON bugs.
            const isHtmlRateLimitError = (0, $1xpoY.default).getBoolean('confluence_html_error_catching', false) && Boolean(errorMessage && /Unexpected token '<'|<!DOCTYPE|<html/.test(errorMessage));
            const isIgnoredError = $da160e8fa3112de6$export$2612561ece05d878.some((errorString)=>error?.message.includes(errorString)) || !errorMessage || isHtmlRateLimitError;
            if (statusCode !== 403 && !isIgnoredError) {
                const e = new Error(`Subscription Error - :${errorMessage}`);
                (0, $fJlJm.setContentErrorAttributes)(e, {
                    objectId: contentId,
                    objectType: contentType
                });
                (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                    // hard coded as the package will cause circular dependency
                    attribution: 'page-experiences'
                });
            }
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error,
        contentId,
        contentType
    ]);
    const contextValue = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            contentModified: contentModified,
            error: error
        }), [
        contentModified,
        error
    ]);
    const dispatchContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            setContentType: setContentType,
            setContentId: setContentId,
            addSubscriber: addSubscriber,
            removeSubscriber: removeSubscriber
        }), [
        setContentType,
        setContentId,
        addSubscriber,
        removeSubscriber
    ]);
    if ((0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($da160e8fa3112de6$var$SubscriptionsContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($da160e8fa3112de6$var$SubscriptionsDispatchContext.Provider, {
        value: dispatchContextValue
    }, children));
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
const $da160e8fa3112de6$export$98d6302051bd25df = ()=>{
    return (0, $cozmU.useContext)($da160e8fa3112de6$var$SubscriptionsContext);
};
const $da160e8fa3112de6$export$e2675019a3c1d99f = ()=>{
    return (0, $cozmU.useContext)($da160e8fa3112de6$var$SubscriptionsDispatchContext);
};
module.exports["SubscriptionsContextProvider"] = $da160e8fa3112de6$export$5f043fff8b6d3ca6;
module.exports["useSubscriptionsContext"] = $da160e8fa3112de6$export$98d6302051bd25df;
module.exports["useSubscriptionsDispatchContext"] = $da160e8fa3112de6$export$e2675019a3c1d99f;

});

parcelRegister("fbcPJ", function(module, exports) {
/**
 * @generated SignedSource<<c3d204b8cdf61b7b48be93a59878a242>>
 * @relayHash ea2b205ca41661c4d9e75a2c80bfd1c5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1544e91e1f726342c809416076aa298d38dd5af242cabac4b6c9a623bc409d20
const $31174e902ea6e4b2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "type"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "kind": "ScalarField",
        "name": "version"
    }, v6 = [
        v4 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "value"
        },
        v5 /*: any*/ ,
        v3 /*: any*/ 
    ], v7 = [
        v4 /*: any*/ ,
        v3 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "spaceKey"
    }, v9 = {
        "kind": "ScalarField",
        "name": "contentId"
    }, v10 = [
        v9 /*: any*/ ,
        v3 /*: any*/ 
    ], v11 = {
        "kind": "ScalarField",
        "name": "confVersion"
    }, v12 = {
        "kind": "ScalarField",
        "name": "commentId"
    }, v13 = {
        "kind": "ScalarField",
        "name": "inlineCommentType"
    }, v14 = {
        "kind": "ScalarField",
        "name": "adfBodyContent"
    }, v15 = {
        "kind": "ScalarField",
        "name": "markerRef"
    }, v16 = {
        "kind": "ScalarField",
        "name": "publishVersionNumber"
    }, v17 = {
        "kind": "ScalarField",
        "name": "from"
    }, v18 = {
        "kind": "ScalarField",
        "name": "to"
    }, v19 = {
        "kind": "ScalarField",
        "name": "pos"
    }, v20 = {
        "kind": "ScalarField",
        "name": "annotationType"
    }, v21 = [
        v12 /*: any*/ ,
        v15 /*: any*/ ,
        v3 /*: any*/ 
    ], v22 = {
        "kind": "ScalarField",
        "name": "replies"
    }, v23 = {
        "kind": "ScalarField",
        "name": "pageCommentType"
    }, v24 = [
        v3 /*: any*/ ,
        v12 /*: any*/ 
    ], v25 = {
        "kind": "ScalarField",
        "name": "emojiId"
    }, v26 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "ConfluenceContentModified",
            "kind": "LinkedField",
            "name": "confluence_onContentModified",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "accountId"
                },
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "_deltas"
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "contentStateUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "emojiTitleUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "coverPictureUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "pageTitlePropertyUpdated",
                    "plural": false,
                    "selections": v6 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyDeleted",
                    "kind": "LinkedField",
                    "name": "coverPictureDeleted",
                    "plural": false,
                    "selections": v7 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyDeleted",
                    "kind": "LinkedField",
                    "name": "emojiTitleDeleted",
                    "plural": false,
                    "selections": v7 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyDeleted",
                    "kind": "LinkedField",
                    "name": "contentStateDeleted",
                    "plural": false,
                    "selections": v7 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceCoverPictureWidthUpdated",
                    "kind": "LinkedField",
                    "name": "coverPictureWidthUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "coverPictureWidth"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluencePageBlogified",
                    "kind": "LinkedField",
                    "name": "pageBlogified",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "spaceName"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "blogTitle"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "converterDisplayName"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceEmbedUpdated",
                    "kind": "LinkedField",
                    "name": "embedUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "product"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isBlankStateUpdate"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluencePageMigrated",
                    "kind": "LinkedField",
                    "name": "pageMigrated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fabricEligibility"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceContentRestrictionUpdated",
                    "kind": "LinkedField",
                    "name": "contentRestrictionUpdated",
                    "plural": false,
                    "selections": v10 /*: any*/ 
                },
                {
                    "concreteType": "ConfluencePageMoved",
                    "kind": "LinkedField",
                    "name": "pageMoved",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "oldSpaceKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "newSpaceKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "oldParentId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "oldPosition"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "newSpaceAlias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "oldSpaceAlias"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluencePageUpdated",
                    "kind": "LinkedField",
                    "name": "pageUpdated",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "trigger"
                        },
                        v11 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceWorkflowApplicationChanged",
                    "kind": "LinkedField",
                    "name": "workflowApplicationChanged",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "changeType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "newWorkflowStatusId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "contentStatus"
                        },
                        v5 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceMarkdownModeUpdated",
                    "kind": "LinkedField",
                    "name": "markdownModeUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isMarkdownMode"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceContentUpdatedWithTemplate",
                    "kind": "LinkedField",
                    "name": "contentUpdatedWithTemplate",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "subtype"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentCreated",
                    "kind": "LinkedField",
                    "name": "inlineCommentCreated",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v14 /*: any*/ ,
                        v3 /*: any*/ ,
                        v15 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceRendererInlineCommentCreated",
                    "kind": "LinkedField",
                    "name": "rendererInlineCommentCreated",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v12 /*: any*/ ,
                        v14 /*: any*/ ,
                        v13 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceInlineCommentStep",
                            "kind": "LinkedField",
                            "name": "step",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                {
                                    "concreteType": "ConfluenceInlineCommentStepMark",
                                    "kind": "LinkedField",
                                    "name": "mark",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                                            "kind": "LinkedField",
                                            "name": "attrs",
                                            "plural": false,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ]
                                        },
                                        v3 /*: any*/ 
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentCreated",
                    "kind": "LinkedField",
                    "name": "editorInlineCommentCreated",
                    "plural": false,
                    "selections": [
                        v14 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v15 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentUpdated",
                    "kind": "LinkedField",
                    "name": "inlineCommentUpdated",
                    "plural": false,
                    "selections": v21 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceInlineCommentDeleted",
                    "kind": "LinkedField",
                    "name": "inlineCommentDeleted",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v15 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentResolved",
                    "kind": "LinkedField",
                    "name": "inlineCommentResolved",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceInlineCommentResolveProperties",
                            "kind": "LinkedField",
                            "name": "inlineResolveProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isDangling"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolved"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedByDangling"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedFriendlyDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedTime"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedUser"
                                },
                                v3 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "inlineText"
                        },
                        v15 /*: any*/ ,
                        v22 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentUpdated",
                    "kind": "LinkedField",
                    "name": "inlineCommentUnresolved",
                    "plural": false,
                    "selections": v21 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceInlineCommentReattached",
                    "kind": "LinkedField",
                    "name": "inlineCommentReattached",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v3 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceInlineCommentStep",
                            "kind": "LinkedField",
                            "name": "step",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                {
                                    "concreteType": "ConfluenceInlineCommentStepMark",
                                    "kind": "LinkedField",
                                    "name": "mark",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                                            "kind": "LinkedField",
                                            "name": "attrs",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v20 /*: any*/ 
                                            ]
                                        },
                                        v3 /*: any*/ 
                                    ]
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceCommentCreated",
                    "kind": "LinkedField",
                    "name": "commentCreated",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v14 /*: any*/ ,
                        v12 /*: any*/ ,
                        v23 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceCommentUpdated",
                    "kind": "LinkedField",
                    "name": "commentUpdated",
                    "plural": false,
                    "selections": v24 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceCommentUpdated",
                    "kind": "LinkedField",
                    "name": "commentDeleted",
                    "plural": false,
                    "selections": v24 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceCommentCreated",
                    "kind": "LinkedField",
                    "name": "commentResolved",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v14 /*: any*/ ,
                        v12 /*: any*/ ,
                        v23 /*: any*/ ,
                        v22 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceCommentUpdated",
                    "kind": "LinkedField",
                    "name": "commentReopened",
                    "plural": false,
                    "selections": v24 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceSchedulePublished",
                    "kind": "LinkedField",
                    "name": "schedulePublished",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "publishTime"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "eventType"
                        },
                        v11 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceContentAccessRequested",
                    "kind": "LinkedField",
                    "name": "contentAccessRequested",
                    "plural": false,
                    "selections": v10 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentAccessDecisionMade",
                    "kind": "LinkedField",
                    "name": "contentAccessDecisionMade",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "decision"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineReactionAdded",
                    "kind": "LinkedField",
                    "name": "inlineReactionAdded",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v15 /*: any*/ ,
                        v25 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "newHighlight"
                        },
                        {
                            "concreteType": "ConfluenceInlineCommentStep",
                            "kind": "LinkedField",
                            "name": "step",
                            "plural": false,
                            "selections": [
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                {
                                    "concreteType": "ConfluenceInlineCommentStepMark",
                                    "kind": "LinkedField",
                                    "name": "mark",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                                            "kind": "LinkedField",
                                            "name": "attrs",
                                            "plural": false,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v2 /*: any*/ 
                                            ]
                                        },
                                        v1 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "stepType"
                                }
                            ]
                        },
                        v16 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineReactionRemoved",
                    "kind": "LinkedField",
                    "name": "inlineReactionRemoved",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v15 /*: any*/ ,
                        v25 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineReactionHighlightDeleted",
                    "kind": "LinkedField",
                    "name": "inlineReactionHighlightDeleted",
                    "plural": false,
                    "selections": v21 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SubscriptionsContextProviderSubscription",
            "selections": v26 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SubscriptionsContextProviderSubscription",
            "selections": v26 /*: any*/ 
        },
        "params": {
            "cacheID": "ea2b205ca41661c4d9e75a2c80bfd1c5",
            "id": "1544e91e1f726342c809416076aa298d38dd5af242cabac4b6c9a623bc409d20",
            "metadata": {},
            "name": "SubscriptionsContextProviderSubscription",
            "operationKind": "subscription",
            "text": "subscription SubscriptionsContextProviderSubscription($id:ID!){confluence_onContentModified(id:$id){type,id,accountId,__typename,_deltas,contentStateUpdated{key,value,version,__typename},emojiTitleUpdated{key,value,version,__typename},coverPictureUpdated{key,value,version,__typename},pageTitlePropertyUpdated{key,value,version,__typename},coverPictureDeleted{key,__typename},emojiTitleDeleted{key,__typename},contentStateDeleted{key,__typename},coverPictureWidthUpdated{coverPictureWidth,__typename},pageBlogified{spaceKey,spaceName,blogTitle,converterDisplayName,__typename},embedUpdated{product,isBlankStateUpdate,__typename},pageMigrated{fabricEligibility,__typename},contentRestrictionUpdated{contentId,__typename},pageMoved{oldSpaceKey,newSpaceKey,oldParentId,oldPosition,newSpaceAlias,oldSpaceAlias,__typename},pageUpdated{__typename,trigger,confVersion},workflowApplicationChanged{contentId,changeType,newWorkflowStatusId,contentStatus,version,__typename},markdownModeUpdated{isMarkdownMode,__typename},contentUpdatedWithTemplate{spaceKey,subtype,__typename},inlineCommentCreated{commentId,inlineCommentType,adfBodyContent,__typename,markerRef},rendererInlineCommentCreated{__typename,commentId,adfBodyContent,inlineCommentType,markerRef,publishVersionNumber,step{from,to,pos,mark{attrs{annotationType,__typename},__typename},__typename}},editorInlineCommentCreated{adfBodyContent,commentId,inlineCommentType,markerRef,__typename},inlineCommentUpdated{commentId,markerRef,__typename},inlineCommentDeleted{commentId,inlineCommentType,markerRef,__typename},inlineCommentResolved{commentId,inlineResolveProperties{isDangling,resolved,resolvedByDangling,resolvedFriendlyDate,resolvedTime,resolvedUser,__typename},inlineText,markerRef,replies,__typename},inlineCommentUnresolved{commentId,markerRef,__typename},inlineCommentReattached{commentId,__typename,markerRef,publishVersionNumber,step{from,mark{attrs{__typename,annotationType},__typename},__typename}},commentCreated{__typename,adfBodyContent,commentId,pageCommentType},commentUpdated{__typename,commentId},commentDeleted{__typename,commentId},commentResolved{__typename,adfBodyContent,commentId,pageCommentType,replies},commentReopened{__typename,commentId},schedulePublished{publishTime,eventType,confVersion,__typename},contentAccessRequested{contentId,__typename},contentAccessDecisionMade{contentId,decision,__typename},inlineReactionAdded{commentId,markerRef,emojiId,newHighlight,step{from,to,pos,mark{attrs{annotationType,id},type},stepType},publishVersionNumber,__typename},inlineReactionRemoved{commentId,markerRef,emojiId,__typename},inlineReactionHighlightDeleted{commentId,markerRef,__typename}}}"
        }
    };
}();
$31174e902ea6e4b2$var$node.hash = "efc034f232cec513c997752add52e641";
var $31174e902ea6e4b2$export$2e2bcd8739ae039 = $31174e902ea6e4b2$var$node;
module.exports["default"] = $31174e902ea6e4b2$export$2e2bcd8739ae039;

});

parcelRegister("fD0Uz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7EPz1 = parcelRequire("7EPz1");


var $6SsN4 = parcelRequire("6SsN4");


var $eqEJl = parcelRequire("eqEJl");


var $422HI = parcelRequire("422HI");


var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");


var $iF5wn = parcelRequire("iF5wn");

const $c7f06d7e4ea271ae$var$isRelayGraphQLTaggedNode = (subscription)=>typeof subscription === 'function' || subscription.kind !== 'Document';
const $c7f06d7e4ea271ae$var$isFormattedExecutionResult = (response)=>Boolean(response && typeof response === 'object' && ('data' in response || 'errors' in response));
const $c7f06d7e4ea271ae$var$isSubscriptionData = (response)=>!$c7f06d7e4ea271ae$var$isFormattedExecutionResult(response);
const $c7f06d7e4ea271ae$var$getSubscriptionDataAndExtensions = (response)=>{
    if (response == null) return {
        data: undefined,
        extensions: undefined
    };
    if ($c7f06d7e4ea271ae$var$isSubscriptionData(response)) return {
        data: response,
        extensions: undefined
    };
    return {
        data: response.data ?? undefined,
        extensions: response.extensions
    };
};
const $c7f06d7e4ea271ae$export$4966ff7f324f6363 = (response)=>{
    const { data: data, extensions: extensions } = $c7f06d7e4ea271ae$var$getSubscriptionDataAndExtensions(response);
    return {
        ...extensions ? {
            extensions: extensions
        } : {},
        subscriptionData: {
            data: data,
            loading: false,
            ...extensions ? {
                extensions: extensions
            } : {}
        }
    };
};
const $c7f06d7e4ea271ae$var$__TEST_ONLY_isTestOnlySafeEnvironment = ()=>{
    const isProduction = true;
    const isCloudProduction = true;
    const isCloudStaging = false;
    if (isProduction || isCloudProduction || isCloudStaging) return false;
    const isTest = false;
    const isDevelopment = false;
    const isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost';
    return isTest || isDevelopment || isLocalhost;
};
const $c7f06d7e4ea271ae$export$1bed67b955596e29 = (forceRelay)=>{
    if (!$c7f06d7e4ea271ae$var$__TEST_ONLY_isTestOnlySafeEnvironment()) return false;
    window.__TEST_ONLY_FORCE_RELAY_MODE__ = forceRelay;
    return true;
};
function $c7f06d7e4ea271ae$export$275462b87cef6610(subscription, options) {
    const forceRelayMode = window.__TEST_ONLY_FORCE_RELAY_MODE__;
    const shouldUseRelay = forceRelayMode || (0, $iffSy.isRelayEnabled)(options?.__callerPackage__, {
        phase: 'subscription'
    });
    if (shouldUseRelay) {
        if (!$c7f06d7e4ea271ae$var$isRelayGraphQLTaggedNode(subscription)) throw new Error('[Relay migration] useSubscriptionInterop Relay mode requires graphql tag');
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return $c7f06d7e4ea271ae$var$useSubscriptionInteropRelay(subscription, options);
    } else {
        const { interopApolloAggClient: interopApolloAggClient, extensions: extensions, ...apolloOptions } = options ?? {};
        // Apollo v2's `useSubscription` does not forward a per-call `context` option down
        // to the WebSocket link, so we smuggle `extensions` through `variables.__extensions`.
        // `AttachExtensionsLink` strips it back out and re-attaches it to the operation
        // context, which `GraphQLWSLink.request` then sets on the wire payload.
        const variables = extensions !== undefined ? {
            ...apolloOptions.variables,
            __extensions: extensions
        } : apolloOptions.variables;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return (0, $7EPz1.useSubscription)((0, $86okN.toDocumentNode)(subscription), {
            ...apolloOptions,
            variables: variables,
            ...interopApolloAggClient ? {
                client: window.GLOBAL_APOLLO_AGG_CLIENT ?? window.MOCK_GATEWAY_APOLLO_CLIENT
            } : {}
        });
    }
}
const $c7f06d7e4ea271ae$var$toApolloErrorInterop = (error)=>new (0, $422HI.ApolloErrorInterop)({
        networkError: error instanceof Error ? error : new Error(String(error))
    });
function $c7f06d7e4ea271ae$var$useSubscriptionInteropRelay(subscription, options) {
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const [data, setData] = (0, $cozmU.useState)(undefined);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const [loading, setLoading] = (0, $cozmU.useState)(!options?.skip);
    const disposableRef = (0, $cozmU.useRef)(null);
    const callbacksRef = (0, $cozmU.useRef)(options);
    callbacksRef.current = options;
    const skip = options?.skip;
    const variables = (0, $iF5wn.useMemoObj)(options?.variables, options?.__callerPackage__, {
        phase: 'subscription'
    });
    const extensions = (0, $iF5wn.useMemoObj)(options?.extensions, options?.__callerPackage__, {
        phase: 'subscription'
    });
    (0, $cozmU.useEffect)(()=>{
        if (skip) {
            setLoading(false);
            return;
        }
        setLoading(true);
        setError(undefined);
        setData(undefined);
        try {
            disposableRef.current = (0, $eqEJl.requestSubscription)(environment, {
                subscription: subscription,
                variables: variables,
                // `RelayWebSocketSubscriptionHandler` reads `cacheConfig.metadata.extensions`
                // and attaches them to the WS payload's `extensions` field.
                // cacheConfig is always set because useMemoObj coerces undefined → {}, so any
                // guard on `extensions` would always evaluate the same way. The consumer
                // (RelayWebSocketSubscriptionHandler) ignores an empty extensions object.
                cacheConfig: {
                    metadata: {
                        extensions: extensions
                    }
                },
                onNext: (response)=>{
                    const { data: responseData } = $c7f06d7e4ea271ae$var$getSubscriptionDataAndExtensions(response);
                    setData(responseData);
                    setError(undefined);
                    setLoading(false);
                    callbacksRef.current?.onSubscriptionData?.($c7f06d7e4ea271ae$export$4966ff7f324f6363(response));
                },
                onError: (err_0)=>{
                    setError($c7f06d7e4ea271ae$var$toApolloErrorInterop(err_0));
                    setLoading(false);
                },
                onCompleted: ()=>{
                    setLoading(false);
                    callbacksRef.current?.onSubscriptionComplete?.();
                }
            });
        } catch (err) {
            setError($c7f06d7e4ea271ae$var$toApolloErrorInterop(err));
            setLoading(false);
        }
        return ()=>{
            if (!disposableRef.current) return;
            disposableRef.current.dispose();
            disposableRef.current = null;
        };
    }, [
        environment,
        subscription,
        variables,
        extensions,
        skip
    ]);
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSubscriptionInterop"] = $c7f06d7e4ea271ae$export$275462b87cef6610;

});

parcelRegister("3vc4U", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $bQm3c = parcelRequire("bQm3c");


var $fSDun = parcelRequire("fSDun");

const $e5d99b79ae0d2558$var$REPLAY_WINDOW_HOURS = 48;
const $e5d99b79ae0d2558$export$d9c46c14618307b6 = ({ contentId: contentId, contentType: contentType, replayCap: replayCap })=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const lastSequenceId = (0, $cozmU.useRef)(Math.floor(new Date().getTime() / 1000));
    const [updateExtensionsTrigger, setUpdateExtensionsTrigger] = (0, $cozmU.useState)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const onSubscriptionComplete = (0, $cozmU.useCallback)(()=>{
        setUpdateExtensionsTrigger(updateExtensionsTrigger + 1);
    }, [
        updateExtensionsTrigger,
        setUpdateExtensionsTrigger
    ]);
    const onSubscriptionData = (0, $cozmU.useCallback)((result)=>{
        // update the last received message timestamp with either the messages time or use a best guess from the current time
        lastSequenceId.current = result?.extensions?.sequenceNumber ?? Math.floor(new Date().getTime() / 1000);
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'received',
                actionSubject: 'subscription.event',
                source: 'AGGSubscriptions',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    request_id: result?.extensions?.agg?.request_id || '',
                    traceId: result?.extensions?.traceId || ''
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        contentType
    ]);
    const ari = !contentId || !contentType || !cloudId || !activationId ? '' : (0, $fSDun.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: contentType,
        activationId: activationId,
        resourceId: contentId
    });
    const extensions = (0, $cozmU.useMemo)(()=>{
        const fallbackReplayCapInSeconds = Math.floor((Date.now() - $e5d99b79ae0d2558$var$REPLAY_WINDOW_HOURS * 3600000) / 1000);
        let sequenceNumber;
        if (replayCap !== undefined) sequenceNumber = replayCap;
        else if (lastSequenceId.current < fallbackReplayCapInSeconds) sequenceNumber = fallbackReplayCapInSeconds;
        else sequenceNumber = lastSequenceId.current;
        return updateExtensionsTrigger > 0 ? {
            command: {
                type: 'replay',
                data: {
                    sequenceNumber: sequenceNumber
                }
            }
        } : {};
    }, [
        updateExtensionsTrigger,
        replayCap
    ]);
    return {
        id: ari,
        extensions: extensions,
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData: onSubscriptionData
    };
};
module.exports["useSubscriptionValues"] = $e5d99b79ae0d2558$export$d9c46c14618307b6;

});

parcelRegister("fSDun", function(module, exports) {
// Copied from @confluence/content-types-utils/src/getConfluenceContentAri.ts
/**
 * Resource types where the ARIs include activationIds. This is a pattern
 * that started with Confluence Databases.
 */ const $ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID = [
    'database',
    'embed',
    'folder',
    'slide'
];
const $ad4104a6b6731a94$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ($ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID.includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $ad4104a6b6731a94$export$6a2f2c83863e9bfe;

});

parcelRegister("d3bcC", function(module, exports) {

var $5VFXo = parcelRequire("5VFXo");


var $aXiya = parcelRequire("aXiya");


var $eLFD2 = parcelRequire("eLFD2");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $ij4CE = parcelRequire("ij4CE");


var $fFmJj = parcelRequire("fFmJj");





var $ep3mz = parcelRequire("ep3mz");


var $1ggpj = parcelRequire("1ggpj");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $6fil2 = parcelRequire("6fil2");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $18a2fd912dfb58ac$var$ContentAnalyticsViewedComments = (0, $eLFD2.default);
// Helper function to safely convert content type for the viewed comments query
const $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments = (contentType)=>{
    // Only page, database, whiteboard, and slide support the viewed comments query
    if (contentType === 'page' || contentType === 'database' || (0, $1ggpj.isCanvasContentType)(contentType)) return contentType;
    // Fallback to page for other content types (blogpost, embed, etc.)
    return 'page';
};
// Helper to generate stable ROOT_QUERY cache key
// Ensures consistent key format regardless of object property order
const $18a2fd912dfb58ac$var$getRootQueryCacheId = (pageId, contentType)=>{
    const validContentType = $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments(contentType);
    // Sort keys to ensure stable JSON.stringify output
    const variables = {
        contentId: pageId,
        contentType: validContentType
    };
    return `$ROOT_QUERY.contentAnalyticsViewedComments(${JSON.stringify(variables)})`;
};
const $18a2fd912dfb58ac$export$cd81a9ad0848990 = ({ pageId: pageId })=>{
    const [contentType] = (0, $ep3mz.useContentType)();
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $aXiya.default),
        fragmentSpec: (0, $aXiya.default),
        __callerPackage__: "unread-comments"
    });
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $5VFXo.default),
        __callerPackage__: "unread-comments"
    });
    // Network-only query for fresh data
    const { refetch: refetch } = (0, $jMyy4.useQueryInterop)($18a2fd912dfb58ac$var$ContentAnalyticsViewedComments, {
        skip: true,
        // Never query on render
        fetchPolicy: 'network-only',
        variables: {
            contentId: pageId,
            contentType: $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments(contentType)
        },
        __callerPackage__: "unread-comments"
    });
    // Helper function to process the query result
    const processQueryResult = (0, $cozmU.useCallback)((data)=>{
        const commentIds = data?.contentAnalyticsViewedComments?.commentIds ?? [];
        const viewedCommentsSet = new Set(commentIds.filter((id)=>id !== null && id !== undefined));
        return {
            success: true,
            data: viewedCommentsSet
        };
    }, []);
    // Helper function for cache-only queries
    const executeCacheOnlyQuery = (0, $cozmU.useCallback)(()=>{
        if (!pageId || !contentType) throw new Error('Page ID and content type are required');
        try {
            // Read from ROOT_QUERY (where Apollo stores query results)
            const rootQueryCacheId = $18a2fd912dfb58ac$var$getRootQueryCacheId(pageId, contentType);
            const rootQueryData = readFragmentInterop({
                id: rootQueryCacheId
            });
            if (rootQueryData) {
                // Convert fragment data to query result format
                const queryResult = {
                    contentAnalyticsViewedComments: {
                        commentIds: rootQueryData.commentIds
                    }
                };
                return processQueryResult(queryResult);
            }
            return {
                success: false,
                error: new Error('No viewed comments data found in cache')
            };
        } catch (error) {
            // Handle cache read errors - these are local operations so we just log unexpected errors
            (0, $fJlJm.setContentErrorAttributes)(error, {
                objectId: pageId,
                objectType: 'page'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
            return {
                success: false,
                error: error
            };
        }
    }, [
        pageId,
        contentType,
        processQueryResult,
        readFragmentInterop
    ]);
    // Helper function for network-only queries
    const executeNetworkOnlyQuery = (0, $cozmU.useCallback)(async ()=>{
        if (!pageId) throw new Error('Page ID and content type are required');
        try {
            const result = await refetch({
                contentId: pageId,
                contentType: $18a2fd912dfb58ac$var$getValidContentTypeForViewedComments(contentType)
            });
            // Apollo automatically writes query results to ROOT_QUERY cache, so we don't need to explicitly write
            // The executeCacheOnlyQuery function will read from ROOT_QUERY directly
            return processQueryResult(result.data);
        } catch (error) {
            // Handle expected errors (403/unauthorized, network errors) - just mark as handled
            if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $6fil2.containsNetworkError)(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                return {
                    success: false,
                    error: error
                };
            }
            // Handle unexpected errors
            (0, $fJlJm.setContentErrorAttributes)(error, {
                objectId: pageId,
                objectType: 'page'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
            return {
                success: false,
                error: error
            };
        }
    }, [
        pageId,
        contentType,
        processQueryResult,
        refetch
    ]);
    // Cached data query - uses cache-only for performance
    const getViewedCommentsCacheOnly = (0, $cozmU.useCallback)(()=>{
        try {
            return executeCacheOnlyQuery();
        } catch (error) {
            return {
                success: false,
                error: error
            };
        }
    }, [
        executeCacheOnlyQuery
    ]);
    // Fresh data query - always uses network-only for latest data
    const getViewedCommentsFresh = (0, $cozmU.useCallback)(()=>executeNetworkOnlyQuery(), [
        executeNetworkOnlyQuery
    ]);
    // Function to update the viewed comments cache
    // This is used for optimistic updates when comments are viewed locally
    const updateViewedCommentsCache = (0, $cozmU.useCallback)((commentIds)=>{
        if (!pageId || !contentType || commentIds.length === 0) return;
        try {
            // Read from ROOT_QUERY (where Apollo stores query results)
            const rootQueryCacheId = $18a2fd912dfb58ac$var$getRootQueryCacheId(pageId, contentType);
            const rootQueryData = readFragmentInterop({
                id: rootQueryCacheId
            });
            const existingCommentIds = rootQueryData?.commentIds ?? [];
            // Merge new comment IDs with existing ones
            const existingSet = new Set(existingCommentIds.filter((id)=>id !== null));
            commentIds.forEach((id)=>existingSet.add(id));
            const mergedCommentIds = Array.from(existingSet);
            // Update ROOT_QUERY cache
            writeFragmentInterop({
                fragmentId: rootQueryCacheId,
                data: {
                    commentIds: mergedCommentIds,
                    __typename: 'ViewedComments'
                }
            });
        } catch (error) {
            // Handle cache writing errors - these are local operations so we just log unexpected errors
            (0, $fJlJm.setContentErrorAttributes)(error, {
                objectId: pageId,
                objectType: 'page'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        pageId,
        contentType,
        readFragmentInterop,
        writeFragmentInterop
    ]);
    return {
        getViewedCommentsCacheOnly: getViewedCommentsCacheOnly,
        getViewedCommentsFresh: getViewedCommentsFresh,
        updateViewedCommentsCache: updateViewedCommentsCache
    };
};
module.exports["useViewedComments"] = $18a2fd912dfb58ac$export$cd81a9ad0848990;

});

parcelRegister("5VFXo", function(module, exports) {
/**
 * @generated SignedSource<<81d1b8de15cc7be4dc05b1f67ad843c8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a1027eddc6949c38$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useViewedComments_read",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "commentIds"
        }
    ],
    "type": "ViewedComments"
};
$a1027eddc6949c38$var$node.hash = "8133cc01831582777d2e0911570e19eb";
var $a1027eddc6949c38$export$2e2bcd8739ae039 = $a1027eddc6949c38$var$node;
module.exports["default"] = $a1027eddc6949c38$export$2e2bcd8739ae039;

});

parcelRegister("aXiya", function(module, exports) {
/**
 * @generated SignedSource<<958fb5adbccc1c73817035c31c0d22af>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7e3d4a4e06abb15d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useViewedComments_write",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "commentIds"
        }
    ],
    "type": "ViewedComments"
};
$7e3d4a4e06abb15d$var$node.hash = "d155cf7774eeec1efd57aa640539aef9";
var $7e3d4a4e06abb15d$export$2e2bcd8739ae039 = $7e3d4a4e06abb15d$var$node;
module.exports["default"] = $7e3d4a4e06abb15d$export$2e2bcd8739ae039;

});

parcelRegister("eLFD2", function(module, exports) {
/**
 * @generated SignedSource<<5a09a8bafd0f0986741b44b0b326104b>>
 * @relayHash 62839dc9a36eb801c9e817f5ebefa91f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 525c1fabca433deba33679d7a93d12d89e84cc662a445506517775392adadc65
const $61b7521c17137f8d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentType"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                }
            ],
            "concreteType": "ViewedComments",
            "kind": "LinkedField",
            "name": "contentAnalyticsViewedComments",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "commentIds"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useViewedCommentsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useViewedCommentsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "62839dc9a36eb801c9e817f5ebefa91f",
            "id": "525c1fabca433deba33679d7a93d12d89e84cc662a445506517775392adadc65",
            "metadata": {},
            "name": "useViewedCommentsQuery",
            "operationKind": "query",
            "text": "query useViewedCommentsQuery($contentId:ID!,$contentType:ConfluenceAnalyticsCommentContentType!){contentAnalyticsViewedComments(contentId:$contentId,contentType:$contentType){commentIds}}"
        }
    };
}();
$61b7521c17137f8d$var$node.hash = "3584bbc92d39d1aa58e2ff1c3396ad40";
var $61b7521c17137f8d$export$2e2bcd8739ae039 = $61b7521c17137f8d$var$node;
module.exports["default"] = $61b7521c17137f8d$export$2e2bcd8739ae039;

});

parcelRegister("1ggpj", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $lx6jn = parcelRequire("lx6jn");

var $2aa2bdb281c6889a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["PAGE"] = "page";
    ContentType["BLOGPOST"] = "blogpost";
    ContentType["DATABASE"] = "database";
    ContentType["SLIDE"] = "slide";
    ContentType["EMBED"] = "embed";
    ContentType["FOLDER"] = "folder";
    return ContentType;
}({});
const $2aa2bdb281c6889a$export$31930b8b7828306b = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$e8b4d9d0d681efa4 = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name,
    (0, $1NBp8.EDIT_PAGE).name,
    (0, $1NBp8.EDIT_PAGE_V2).name
];
const $2aa2bdb281c6889a$export$142530096b49b828 = [
    "whiteboard",
    "database",
    "slide",
    "embed",
    "page",
    "folder",
    "blogpost"
];
const $2aa2bdb281c6889a$export$de22146d402d9bdd = {
    ["whiteboard"]: (0, $lx6jn.FeedbackSource).WHITEBOARD,
    ["embed"]: (0, $lx6jn.FeedbackSource).EMBED,
    ["database"]: (0, $lx6jn.FeedbackSource).DATABASE,
    ["slide"]: (0, $lx6jn.FeedbackSource).SLIDE
};
const $2aa2bdb281c6889a$export$4aba9c2e2995f563 = [
    "whiteboard",
    "slide"
];
const $2aa2bdb281c6889a$export$ea7ca1acbbc07168 = (contentType)=>!!contentType && $2aa2bdb281c6889a$export$4aba9c2e2995f563.includes(contentType);
const $2aa2bdb281c6889a$export$10c6f1bef31d587c = [
    'database',
    'slide',
    'embed',
    'folder'
];
const $2aa2bdb281c6889a$export$544bad8872c0b7ed = 400;
module.exports["ContentType"] = $2aa2bdb281c6889a$export$e2e108cbe2e4f865;
module.exports["ARCHIVE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$31930b8b7828306b;
module.exports["DELETE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$e8b4d9d0d681efa4;
module.exports["VALID_OPERATION_TARGETS"] = $2aa2bdb281c6889a$export$142530096b49b828;
module.exports["CONTENT_TYPE_FEEDBACK_SOURCE"] = $2aa2bdb281c6889a$export$de22146d402d9bdd;
module.exports["isCanvasContentType"] = $2aa2bdb281c6889a$export$ea7ca1acbbc07168;
module.exports["TYPES_WITH_ACTIVATIONID"] = $2aa2bdb281c6889a$export$10c6f1bef31d587c;
module.exports["onChangeTitleDebounceTime"] = $2aa2bdb281c6889a$export$544bad8872c0b7ed;

});

parcelRegister("lx6jn", function(module, exports) {
var $4d57d476a3596595$export$1953473fc535c5c1 = /*#__PURE__*/ function(FeedbackSource) {
    FeedbackSource["EDITOR"] = "Editor";
    FeedbackSource["HELP_PANEL"] = "Help Panel";
    FeedbackSource["THEME_SELECTOR"] = "Theme Selector";
    FeedbackSource["WHITEBOARD"] = "Whiteboard";
    FeedbackSource["EMBED"] = "Embed";
    FeedbackSource["DATABASE"] = "Database";
    FeedbackSource["NAV_4"] = "Nav4";
    FeedbackSource["SHARE_DIALOG"] = "Share Dialog";
    FeedbackSource["CONTENT_WRAPPER"] = "Content Wrapper";
    FeedbackSource["LIVE_DOCS"] = "Live Docs";
    FeedbackSource["EDITOR_CONTROLS"] = "Editor Controls";
    FeedbackSource["NOTES"] = "Notes";
    FeedbackSource["CREATE_WITH_ROVO"] = "Create with Rovo";
    FeedbackSource["SLIDE"] = "Slide";
    return FeedbackSource;
}({});
module.exports["FeedbackSource"] = $4d57d476a3596595$export$1953473fc535c5c1;

});

parcelRegister("804Ue", function(module, exports) {

var $lFugL = parcelRequire("lFugL");


var $cozmU = parcelRequire("cozmU");


var $c0rhi = parcelRequire("c0rhi");


var $9wGTI = parcelRequire("9wGTI");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $flE5X = parcelRequire("flE5X");


var $cAdj8 = parcelRequire("cAdj8");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $6mKj3 = parcelRequire("6mKj3");

var $11771bad87ca0882$export$c51d39001809fe3e = /*#__PURE__*/ function(PubSubState) {
    PubSubState[PubSubState["ACTIVE"] = 0] = "ACTIVE";
    PubSubState[PubSubState["TERMINATED"] = 1] = "TERMINATED";
    return PubSubState;
}({});
var $11771bad87ca0882$export$77deeade63afd3a6 = /*#__PURE__*/ function(CommentEventType) {
    CommentEventType[CommentEventType["ALL"] = 0] = "ALL";
    CommentEventType[CommentEventType["FOOTER"] = 1] = "FOOTER";
    CommentEventType[CommentEventType["INLINE"] = 2] = "INLINE";
    return CommentEventType;
}({});
const $11771bad87ca0882$export$5a33be95ac52bdad = 2000;
const $11771bad87ca0882$export$f09c511f29ef2d = 3000;
const $11771bad87ca0882$export$45c0a7c4ba2fbb03 = ({ contentId: contentId, eventType: eventType, subscribeToPubSubEvents: subscribeToPubSubEvents, unsubscribeFromPubSubEvents: unsubscribeFromPubSubEvents, onEventFetchSuccess: onEventFetchSuccess, onFetchContentVersionEvent: onFetchContentVersionEvent, onDocumentReturn: onDocumentReturn, lastPollTime: lastPollTime, inactiveInterval: inactiveInterval = $11771bad87ca0882$export$5a33be95ac52bdad, returnInterval: returnInterval = $11771bad87ca0882$export$f09c511f29ef2d, isAutoReloadPageComments: isAutoReloadPageComments = false })=>{
    const { documentNeedsUpdate: documentNeedsUpdate, publishedDocumentVersion: publishedDocumentVersion, currentDocumentVersion: currentDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatus)();
    const { setDocumentNeedsUpdate: setDocumentNeedsUpdate, setPublishedDocumentVersion: setPublishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatusDispatch)();
    const lastEventCheckTimeRef = (0, $cozmU.useRef)(lastPollTime || Date.now());
    const subscriptionShutdownTimer = (0, $cozmU.useRef)(null);
    const missedEventQueryTimeout = (0, $cozmU.useRef)(null);
    // Check if document is undefined to handle SSR playwright tests
    const [documentVisible, setDocumentVisible] = (0, $cozmU.useState)(typeof document !== 'undefined' ? !document.hidden : true);
    const [pubSubState, setPubSubState] = (0, $cozmU.useState)(0);
    const { pageInfo: pageInfo, refetch: refetch } = (0, $cAdj8.usePageInfo)({
        fetchPolicy: 'cache-first',
        // this is required for page navigation using the page tree
        onCompleted: (data)=>{
            if (!(0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) {
                const number = data?.content?.nodes?.[0]?.version?.number;
                if (number) setPublishedDocumentVersion(number);
            }
        }
    });
    const pageMode = (0, $aSsfA.useGetPageMode)();
    (0, $cozmU.useEffect)(()=>{
        const latestVersion = pageInfo?.version?.number;
        if (latestVersion && (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) {
            setPublishedDocumentVersion(latestVersion);
            if ((0, $6mKj3.expValEquals)('confluence_fe_correct_document_needs_update', 'isEnabled', true)) // Set documentNeedsUpdate to true only if all of the following are true:
            // 1. pageMode is VIEW
            // 2. currentDocumentVersion is set to a valid version number
            // 3. latestVersion is different from currentDocumentVersion
            // Otherwise, set documentNeedsUpdate to false.
            setDocumentNeedsUpdate(pageMode === (0, $cD1qu.PageMode).VIEW && currentDocumentVersion > 0 && latestVersion !== currentDocumentVersion);
            else setDocumentNeedsUpdate(latestVersion !== currentDocumentVersion);
        }
    }, [
        pageInfo?.version?.number,
        currentDocumentVersion,
        setPublishedDocumentVersion,
        setDocumentNeedsUpdate,
        pageMode
    ]);
    const fetchContentVersionNumber = async ()=>{
        try {
            if (refetch) {
                const { data: data } = await refetch();
                return data?.content?.nodes?.[0]?.version?.number;
            }
        } catch (e) {
            if ((0, $1uFM6.isUnauthorizedError)(e) || e instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(e);
            return;
        }
    };
    const fetchMissingCommentEventsSinceTime = async (contentId, since)=>{
        try {
            const response = await (0, $c0rhi.queryInterop)({
                query: (0, $lFugL.default),
                variables: {
                    contentId: contentId,
                    since: since
                },
                fetchPolicy: 'no-cache',
                errorPolicy: 'all',
                __callerPackage__: "comments-pubsub"
            });
            const comments = response.data?.quickReload?.comments || [];
            let filteredCommentEvents = comments;
            // Filter out comment events tha we're not subscribed to
            if (eventType !== 0) filteredCommentEvents = comments.filter((comment)=>eventType === 1 ? comment.comment?.location.type === 'FOOTER' : comment.comment?.location.type === 'INLINE');
            const commentEvents = filteredCommentEvents.map((comment)=>{
                const commentId = comment.comment?.id;
                const type = comment.comment?.location.type;
                const accountId = comment.comment?.author?.accountId || '';
                return {
                    id: commentId,
                    type: type,
                    accountId: accountId
                };
            });
            const time = response.data?.quickReload?.time;
            return {
                commentEvents: commentEvents,
                time: time,
                contentId: contentId
            };
        } catch (e) {
            if ((0, $1uFM6.isUnauthorizedError)(e) || e instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(e);
            // Just do nothing
            return;
        }
    };
    const clearMissedEventTimeout = ()=>{
        if (missedEventQueryTimeout.current) {
            clearTimeout(missedEventQueryTimeout.current);
            missedEventQueryTimeout.current = null;
        }
    };
    const checkAndHandleMissedEvents = ()=>{
        // If we already have a timeout queued clear it
        clearMissedEventTimeout();
        // Check for the missed events on a timeout after the user has been back for 3 seconds
        missedEventQueryTimeout.current = setTimeout(async ()=>{
            if (documentNeedsUpdate) return;
            const contentLatestVersion = await fetchContentVersionNumber();
            if (!isAutoReloadPageComments && contentLatestVersion !== publishedDocumentVersion) {
                if (!(0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) // when experiment is ON, this is done in the useEffect block above
                setPublishedDocumentVersion(contentLatestVersion);
                onFetchContentVersionEvent && onFetchContentVersionEvent();
                return;
            }
            // Call passed in fetch function
            fetchMissingCommentEventsSinceTime(contentId, lastEventCheckTimeRef.current || Date.now()).then((res)=>{
                // This check of content types is needed in case the promise resolves after a user has already changed pages
                if (res && contentId === res.contentId) {
                    lastEventCheckTimeRef.current = res.time ?? Date.now();
                    // Return the result to the caller
                    onEventFetchSuccess(res);
                }
            // If the call fails, do nothing, just assume the events were missed
            });
        }, returnInterval);
    };
    // Wire up pub sub events when the component mounts
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            window.removeEventListener('beforeunload', unsubscribeFromPubSubEvents);
            unsubscribeFromPubSubEvents();
            if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
            (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return;
            clearMissedEventTimeout();
        };
    // We only want to resub when the content changes or the passed in functions change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
    // Need to subscribe to the pubsub when component mounts or contentId, publishedDocumentVersion changes
    (0, $cozmU.useEffect)(()=>{
        // No need to subscribe to the pubsub when doc version is 0
        // We need the events only when we have a valid version number i.e published
        if (publishedDocumentVersion === 0) return;
        subscribeToPubSubEvents();
        // Make sure to unsubscribe from pubsub events if the browser closes
        window.addEventListener('beforeunload', unsubscribeFromPubSubEvents);
    // We only want to resub when the content changes or the passed in functions change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        publishedDocumentVersion,
        documentNeedsUpdate
    ]);
    // Listen to document visibility changes
    (0, $cozmU.useEffect)(()=>{
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return;
        const changeVisibility = ()=>setDocumentVisible(!document.hidden);
        document.addEventListener('visibilitychange', changeVisibility);
        return ()=>{
            document.removeEventListener('visibilitychange', changeVisibility);
        };
    }, [
        setDocumentVisible
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return;
        if (documentVisible && subscriptionShutdownTimer.current) {
            clearTimeout(subscriptionShutdownTimer.current);
            subscriptionShutdownTimer.current = null;
        }
        // When the document becomes hidden, record the current time as the last check time
        if (!documentVisible) lastEventCheckTimeRef.current = Date.now();
        // If the document is no longer visible, set a timeout to unsubscribe from pubsub events
        if (!documentVisible && !subscriptionShutdownTimer.current && pubSubState === 0) subscriptionShutdownTimer.current = setTimeout(()=>{
            unsubscribeFromPubSubEvents();
            setPubSubState(1);
        }, inactiveInterval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        documentVisible
    ]);
    // Resubscribe to the pubsub events when we come back and handle any missed events
    (0, $cozmU.useEffect)(()=>{
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) return;
        setPubSubState((prevState)=>{
            if (documentVisible && prevState === 1) {
                onDocumentReturn && onDocumentReturn();
                checkAndHandleMissedEvents();
                subscribeToPubSubEvents();
                return 0;
            }
            return prevState;
        });
    // We only want this to fire when the document visibility has changed, not the pubsub state
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        documentVisible
    ]);
    return null;
};
module.exports["CommentEventType"] = $11771bad87ca0882$export$77deeade63afd3a6;
module.exports["MissedPubSubCommentEventsHandler"] = $11771bad87ca0882$export$45c0a7c4ba2fbb03;

});

parcelRegister("lFugL", function(module, exports) {
/**
 * @generated SignedSource<<ec37448e00124aacfed3c0e6870df73b>>
 * @relayHash 7477557bbdcb7cd2b6d07a81a3bcb66a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b47931f2ea144024bb11778c3ea928f58c21a4afcb19e487b4f53bc0a3d0c559
const $f560d9e78fe64cde$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "since"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "contentId"
        },
        {
            "kind": "Variable",
            "name": "since",
            "variableName": "since"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "time"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v6 = {
        "kind": "InlineFragment",
        "selections": v5 /*: any*/ ,
        "type": "KnownUser"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": v5 /*: any*/ ,
        "type": "UnknownUser"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MissedPubSubCommentEventsHandlerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "QuickReload",
                    "kind": "LinkedField",
                    "name": "quickReload",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "QuickReloadComment",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "comment",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MissedPubSubCommentEventsHandlerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "QuickReload",
                    "kind": "LinkedField",
                    "name": "quickReload",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "QuickReloadComment",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "comment",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "7477557bbdcb7cd2b6d07a81a3bcb66a",
            "id": "b47931f2ea144024bb11778c3ea928f58c21a4afcb19e487b4f53bc0a3d0c559",
            "metadata": {},
            "name": "MissedPubSubCommentEventsHandlerQuery",
            "operationKind": "query",
            "text": "query MissedPubSubCommentEventsHandlerQuery($contentId:Long!,$since:Long!){quickReload(pageId:$contentId,since:$since){time,comments{comment{id,location{__typename,type},author{__typename,...on KnownUser{accountId},...on UnknownUser{accountId}}}}}}"
        }
    };
}();
$f560d9e78fe64cde$var$node.hash = "7c3b6fa82a316ebe81a0bcd5cab2114e";
var $f560d9e78fe64cde$export$2e2bcd8739ae039 = $f560d9e78fe64cde$var$node;
module.exports["default"] = $f560d9e78fe64cde$export$2e2bcd8739ae039;

});

parcelRegister("cAdj8", function(module, exports) {

var $69Jl3 = parcelRequire("69Jl3");


var $cozmU = parcelRequire("cozmU");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $1uFM6 = parcelRequire("1uFM6");


var $flE5X = parcelRequire("flE5X");


var $jMyy4 = parcelRequire("jMyy4");

const $a1394411ec7881e4$var$usePageInfoPageInfoQuery = (0, $69Jl3.default);
const $a1394411ec7881e4$export$e1b9843c9a40eb2 = {
    id: '',
    type: '',
    status: '',
    space: {
        id: '',
        operations: []
    },
    operations: [],
    version: {
        number: -1
    }
};
const $a1394411ec7881e4$export$7b2dac1793a2824 = ({ fetchPolicy: fetchPolicy = 'cache-and-network', onCompleted: onCompleted, onError: onError } = {})=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)($a1394411ec7881e4$var$usePageInfoPageInfoQuery, {
        variables: {
            pageId: contentId
        },
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted,
        __callerPackage__: "page-info"
    });
    return (0, $cozmU.useMemo)(()=>{
        // Handle error case first
        if (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error) || error instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(error);
            onError?.(error);
            return {
                pageInfo: null,
                loading: false,
                error: error,
                refetch: null
            };
        }
        // If we have data, use it even during loading
        if (data) {
            const pageInfoNode = data.content?.nodes?.[0] ?? null;
            if (pageInfoNode) return {
                pageInfo: pageInfoNode,
                loading: loading,
                error: undefined,
                refetch: refetch
            };
            return {
                pageInfo: {
                    ...$a1394411ec7881e4$export$e1b9843c9a40eb2
                },
                loading: loading,
                error: undefined,
                refetch: refetch
            };
        }
        // Only return null pageInfo if we have no data at all
        return {
            pageInfo: null,
            loading: loading,
            error: undefined,
            refetch: null
        };
    }, [
        data,
        loading,
        error,
        onError,
        refetch
    ]);
};
module.exports["usePageInfo"] = $a1394411ec7881e4$export$7b2dac1793a2824;

});

parcelRegister("69Jl3", function(module, exports) {
/**
 * @generated SignedSource<<a52aa17c9371e87ad68639adf48d413b>>
 * @relayHash ece963db192ceabc724d67f753bee503
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2811ac8ea0cd2136d716a0779dac023c092684c56d72b0b668fe85db77dee6d4
const $c7d0a8215908754e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "pageId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "current",
                        "archived",
                        "draft"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        },
                        v2 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "number"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePageInfoPageInfoQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePageInfoPageInfoQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "ece963db192ceabc724d67f753bee503",
            "id": "2811ac8ea0cd2136d716a0779dac023c092684c56d72b0b668fe85db77dee6d4",
            "metadata": {},
            "name": "usePageInfoPageInfoQuery",
            "operationKind": "query",
            "text": "query usePageInfoPageInfoQuery($pageId:ID){content(id:$pageId,status:[\"current\",\"archived\",\"draft\"]){nodes{id,type,status,space{id,operations{operation,targetType}},operations{operation,targetType},version{number}}}}"
        }
    };
}();
$c7d0a8215908754e$var$node.hash = "a5580c0bc26236652ac23ad7c3f4bf51";
var $c7d0a8215908754e$export$2e2bcd8739ae039 = $c7d0a8215908754e$var$node;
module.exports["default"] = $c7d0a8215908754e$export$2e2bcd8739ae039;

});

parcelRegister("a8ZQ3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $0e1f4810033038ec$export$82f0a2c62bb8fbf = /*#__PURE__*/ (0, $cozmU.createContext)({
    documentUpdated: false,
    documentNeedsUpdate: false,
    publishedDocumentVersion: 0,
    currentDocumentVersion: 0
});
$0e1f4810033038ec$export$82f0a2c62bb8fbf.displayName = 'DocumentUpdateStatusContext';
const $0e1f4810033038ec$export$d35f8c93092bdd5a = /*#__PURE__*/ (0, $cozmU.createContext)({
    setDocumentUpdated: ()=>{},
    setDocumentNeedsUpdate: ()=>{},
    setPublishedDocumentVersion: ()=>{},
    setCurrentDocumentVersion: ()=>{}
});
$0e1f4810033038ec$export$d35f8c93092bdd5a.displayName = 'DocumentUpdateStatusDispatchContext';
const $0e1f4810033038ec$export$e1e6df7f9af5d046 = ({ children: children })=>{
    const [documentUpdated, setDocumentUpdated] = (0, $cozmU.useState)(false);
    const [documentNeedsUpdate, setDocumentNeedsUpdate] = (0, $cozmU.useState)(false);
    const [publishedDocumentVersion, setPublishedDocumentVersion] = (0, $cozmU.useState)(0);
    const [currentDocumentVersion, setCurrentDocumentVersion] = (0, $cozmU.useState)(0);
    const providerValue = (0, $cozmU.useMemo)(()=>({
            documentUpdated: documentUpdated,
            documentNeedsUpdate: documentNeedsUpdate,
            publishedDocumentVersion: publishedDocumentVersion,
            currentDocumentVersion: currentDocumentVersion
        }), [
        documentUpdated,
        documentNeedsUpdate,
        publishedDocumentVersion,
        currentDocumentVersion
    ]);
    const dispatchProviderValue = (0, $cozmU.useMemo)(()=>({
            setDocumentUpdated: setDocumentUpdated,
            setDocumentNeedsUpdate: setDocumentNeedsUpdate,
            setPublishedDocumentVersion: setPublishedDocumentVersion,
            setCurrentDocumentVersion: setCurrentDocumentVersion
        }), [
        setDocumentUpdated,
        setDocumentNeedsUpdate,
        setPublishedDocumentVersion,
        setCurrentDocumentVersion
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e1f4810033038ec$export$82f0a2c62bb8fbf.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e1f4810033038ec$export$d35f8c93092bdd5a.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $0e1f4810033038ec$export$ff9e1d20f8dc4075 = ()=>{
    return (0, $cozmU.useContext)($0e1f4810033038ec$export$82f0a2c62bb8fbf);
};
const $0e1f4810033038ec$export$317fac591d89e2e3 = ()=>{
    return (0, $cozmU.useContext)($0e1f4810033038ec$export$d35f8c93092bdd5a);
};
module.exports["DocumentUpdateStatusProvider"] = $0e1f4810033038ec$export$e1e6df7f9af5d046;
module.exports["useDocumentUpdateStatus"] = $0e1f4810033038ec$export$ff9e1d20f8dc4075;
module.exports["useDocumentUpdateStatusDispatch"] = $0e1f4810033038ec$export$317fac591d89e2e3;

});

parcelRegister("83eLG", function(module, exports) {

var $7S9uM = parcelRequire("7S9uM");


var $gRrX4 = parcelRequire("gRrX4");


var $8i27m = parcelRequire("8i27m");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $kQekh = parcelRequire("kQekh");


var $jLcXM = parcelRequire("jLcXM");


var $e4kZB = parcelRequire("e4kZB");


var $lb2Lp = parcelRequire("lb2Lp");


var $c0rhi = parcelRequire("c0rhi");


var $b11gn = parcelRequire("b11gn");


var $2QXMk = parcelRequire("2QXMk");


var $aM1he = parcelRequire("aM1he");

const $ced40be9017d58cb$var$FETCH_COMMENT_RETRY_DELAYS_MS = [
    500,
    1000,
    2000
];
/**
 * Fetches a comment by ID with automatic retry on null result.
 * The pubsub event can arrive before the server has committed the comment,
 * causing fetchCommentById to return null. We retry with backoff to handle this.
 */ const $ced40be9017d58cb$var$fetchCommentByIdWithRetry = async ({ commentId: commentId, contentId: contentId })=>{
    let result = await (0, $lb2Lp.fetchCommentById)({
        commentId: commentId,
        contentId: contentId,
        fetchPolicy: 'network-only'
    });
    if (result !== null) return result;
    for (const delayMs of $ced40be9017d58cb$var$FETCH_COMMENT_RETRY_DELAYS_MS){
        // eslint-disable-next-line no-await-in-loop
        await new Promise((resolve)=>setTimeout(resolve, delayMs));
        // eslint-disable-next-line no-await-in-loop
        result = await (0, $lb2Lp.fetchCommentById)({
            commentId: commentId,
            contentId: contentId,
            fetchPolicy: 'network-only'
        });
        if (result !== null) return result;
    }
    return result;
};
const $ced40be9017d58cb$export$66752be9311cfe87 = async (contentId, commentId)=>{
    const queryVariables = {
        commentId: commentId,
        contentId: contentId
    };
    const commentDataResult = await (0, $c0rhi.queryInterop)({
        query: (0, $kQekh.CommentsSectionGetSingleCommentQuery),
        fetchPolicy: 'network-only',
        variables: queryVariables,
        __callerPackage__: "comments-pubsub"
    });
    return commentDataResult.data;
};
const $ced40be9017d58cb$export$e02e3f365960f15 = async (contentId, commentId)=>{
    const queryVariables = {
        commentId: commentId,
        contentId: contentId
    };
    const commentDataResult = await (0, $c0rhi.queryInterop)({
        query: (0, $jLcXM.ActivePageCommentQuery),
        fetchPolicy: 'network-only',
        variables: queryVariables,
        __callerPackage__: "comments-pubsub"
    });
    return commentDataResult.data;
};
const $ced40be9017d58cb$export$37a9d770052438a6 = async ({ commentId: commentId, contentId: contentId, addNewCommentThreads: addNewCommentThreads, addReplyToCommentThread: addReplyToCommentThread })=>{
    const commentThreadDataResult = await $ced40be9017d58cb$export$66752be9311cfe87(contentId, commentId ?? '');
    const comment = commentThreadDataResult?.comments?.nodes?.[0];
    if (comment) {
        const createdAt = comment.version.when;
        const commentLocation = comment.location;
        // Parent comment case
        if (!comment.parentId) addNewCommentThreads && addNewCommentThreads({
            general: {
                [comment.id]: {
                    ...comment,
                    isOpen: true,
                    wasRemovedByAnotherUser: false,
                    type: (0, $8i27m.CommentType).GENERAL,
                    replies: [],
                    // Newly created comments will never have replies
                    contributors: comment.contributors ?? [],
                    createdAt: {
                        value: createdAt
                    },
                    location: {
                        type: 'FOOTER',
                        commentResolveProperties: commentLocation.commentResolveProperties
                    },
                    links: {
                        webui: comment.links.webui,
                        editui: null
                    },
                    permissions: {
                        isEditable: comment.permissions.isEditable,
                        isRemovable: comment.permissions.isRemovable,
                        isResolvable: true
                    }
                }
            },
            inline: {}
        });
        else {
            const threadKey = comment.ancestors[comment.ancestors.length - 1]?.id ?? comment.id;
            addReplyToCommentThread && addReplyToCommentThread(threadKey, {
                ...comment,
                isOpen: true,
                wasRemovedByAnotherUser: false,
                type: (0, $8i27m.CommentType).GENERAL,
                createdAt: {
                    value: createdAt
                },
                location: {
                    type: 'FOOTER',
                    commentResolveProperties: commentLocation.commentResolveProperties
                },
                links: {
                    webui: comment.links.webui,
                    editui: null
                },
                permissions: {
                    isEditable: comment.permissions.isEditable,
                    isRemovable: comment.permissions.isRemovable,
                    isResolvable: true
                }
            }, (0, $8i27m.CommentType).GENERAL);
        }
    }
};
const $ced40be9017d58cb$export$9cc4fc7c59ab4b10 = async ({ commentId: commentId, contentId: contentId, updateCommentBody: updateCommentBody })=>{
    const commentThreadDataResult = await $ced40be9017d58cb$export$66752be9311cfe87(contentId, commentId ?? '');
    const comment = commentThreadDataResult?.comments?.nodes?.[0];
    if (comment) {
        const threadKey = comment.ancestors[comment.ancestors.length - 1]?.id ?? comment.id;
        updateCommentBody && updateCommentBody(comment.id, threadKey, comment.body.value, (0, $8i27m.CommentType).GENERAL, comment.version?.by?.displayName);
    }
};
const $ced40be9017d58cb$export$4d3ff641e060619d = async ({ commentId: commentId, contentId: contentId, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap })=>{
    const commentThreadDataResult = await $ced40be9017d58cb$export$66752be9311cfe87(contentId, commentId ?? '');
    const comment = commentThreadDataResult?.comments?.nodes?.[0];
    if (comment && // @ts-expect-error
    comment.location.__typename === 'FooterComment' && comment.location.commentResolveProperties) updateRemovedCommentIdsMap && updateRemovedCommentIdsMap({
        threadKey: comment.id,
        commentId: comment.id,
        commentActionType: (0, $8i27m.CommentActionType).RESOLVE_COMMENT_THREAD,
        isReply: !!comment.parentId,
        commentType: (0, $8i27m.CommentType).GENERAL,
        resolvedProperties: comment.location.commentResolveProperties
    });
    else if (comment) updateRemovedCommentIdsMap && updateRemovedCommentIdsMap({
        threadKey: comment.id,
        commentId: comment.id,
        commentActionType: (0, $8i27m.CommentActionType).RESOLVE_COMMENT_THREAD,
        isReply: !!comment.parentId,
        commentType: (0, $8i27m.CommentType).GENERAL
    });
};
const $ced40be9017d58cb$export$bbee85055c5ba3c6 = async ({ commentId: commentId, contentId: contentId, addNewCommentThreads: addNewCommentThreads, getCurrentCommentsPanelState: getCurrentCommentsPanelState })=>{
    if (!getCurrentCommentsPanelState) return;
    const { commentsDataMap: commentsDataMap } = getCurrentCommentsPanelState();
    // Use the new ActivePageCommentQuery
    const commentThreadDataResult = await $ced40be9017d58cb$export$e02e3f365960f15(contentId, commentId ?? '');
    const comment = commentThreadDataResult?.comments?.nodes?.[0];
    if (comment && commentsDataMap) {
        const commentsDataMapClone = {
            ...commentsDataMap
        };
        const commentInMap = commentsDataMapClone[(0, $8i27m.CommentType).GENERAL][comment.id];
        if (commentInMap) {
            commentInMap.isOpen = true;
            commentInMap.wasRemovedByAnotherUser = false;
            addNewCommentThreads && addNewCommentThreads(commentsDataMapClone);
        }
    }
    return comment;
};
const $ced40be9017d58cb$var$handleUnreadCommentsForReopenedComment = ({ comment: comment, userId: userId, viewedComments: viewedComments, updateUnreadCommentIDSet: updateUnreadCommentIDSet })=>{
    const validUnreadCommentIds = new Set();
    // Validate the main comment
    const commentForValidation = (0, $e4kZB.buildValidationObjectFromProps)({
        commentId: comment.id,
        userId: comment.author?.__typename === 'KnownUser' ? comment.author.accountId : undefined,
        createdAt: comment.createdAt?.value || undefined,
        commentType: 'FOOTER',
        // Page comments are always FOOTER type
        resolveProperties: {
            resolved: false
        } // reopened comment = resolved false
    });
    if ((0, $e4kZB.isValidUnreadComment)({
        comment: commentForValidation,
        currentUserId: userId,
        viewedComments: viewedComments
    })) validUnreadCommentIds.add(comment.id);
    // Validate replies if they exist
    if (comment.replies) comment.replies.forEach((reply)=>{
        const replyForValidation = (0, $e4kZB.buildValidationObjectFromProps)({
            commentId: reply.id,
            userId: reply.author?.__typename === 'KnownUser' ? reply.author.accountId : undefined,
            createdAt: reply.createdAt?.value || undefined,
            commentType: 'FOOTER',
            // Page comments are always FOOTER type
            resolveProperties: {
                resolved: false
            } // reopened comment = resolved false
        });
        if ((0, $e4kZB.isValidUnreadComment)({
            comment: replyForValidation,
            currentUserId: userId,
            viewedComments: viewedComments
        })) validUnreadCommentIds.add(reply.id);
    });
    updateUnreadCommentIDSet(validUnreadCommentIds, 'add');
};
const $ced40be9017d58cb$export$d4b860510819f61b = async ({ commentId: commentId, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, getCurrentCommentsPanelState: getCurrentCommentsPanelState })=>{
    if (commentId) {
        // Default to code to delete the top-level comment
        let threadKey = commentId;
        let isReply = false;
        // This should always be true, but if it isn't don't break
        // This case handles removing replies in the panel
        if (getCurrentCommentsPanelState) {
            const { commentsDataMap: commentsDataMap } = getCurrentCommentsPanelState();
            // If the comment is not in the general map, it's a reply
            // That means we need to loop through the flat arrays of replies for each parent comment to find our id
            // It's not fast since it potentially checks every comment on the page, but it's better than a network call
            if (!commentsDataMap[(0, $8i27m.CommentType).GENERAL][commentId]) {
                const allGeneralComments = commentsDataMap[(0, $8i27m.CommentType).GENERAL];
                for (const parentComment of Object.values(allGeneralComments))if (parentComment.replies) {
                    for (const reply of parentComment.replies)if (reply.id === commentId) {
                        threadKey = parentComment.id;
                        isReply = true;
                        break;
                    }
                }
            }
        }
        updateRemovedCommentIdsMap && updateRemovedCommentIdsMap({
            threadKey: threadKey,
            commentId: commentId,
            commentActionType: (0, $8i27m.CommentActionType).DELETE_COMMENT,
            isReply: isReply,
            commentType: (0, $8i27m.CommentType).GENERAL
        });
    }
};
const $ced40be9017d58cb$export$4d067148c1e8c84d = ({ userId: userId, contentId: contentId, reloader: reloader, addNewComment: addNewComment, removeComment: removeComment, updateQueryVariables: updateQueryVariables, addNewCommentThreads: addNewCommentThreads, addReplyToCommentThread: addReplyToCommentThread, updateCommentBody: updateCommentBody, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, reopenParentComment: reopenParentComment, getCurrentCommentsPanelState: getCurrentCommentsPanelState, getViewedCommentsCacheOnly: getViewedCommentsCacheOnly, updateUnreadCommentIDSet: updateUnreadCommentIDSet, addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache, clearReplyIfRemoved: clearReplyIfRemoved })=>(event, payload)=>{
        if (!event) return;
        let commentRequestBody;
        const { accountId: accountId } = payload;
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) commentRequestBody = payload?.[event];
        else commentRequestBody = payload.commentRequestBody;
        const { commentId: commentId } = commentRequestBody;
        const isReply = commentRequestBody?.pageCommentType === 'REPLY';
        // We don't need to respond to events that the current user initiated, unless we need to process their reply.
        if ((0, $2QXMk.shouldSkipOwnPubSubEvent)({
            accountId: accountId,
            currentUserId: userId,
            isReply: isReply,
            isOwnReplyPubSubProcessingEnabled: (0, $6mKj3.expVal)('cc_comments_pubsub_process_own_replies', 'isEnabled', false) && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
        })) return;
        const { start: startCommentsPubSubExperience, succeed: succeedCommentsPubSubExperience, fail: failCommentsPubSubExperience } = (0, $b11gn.createCommentsPubSubExperienceTracker)((0, $b11gn.CommentsPubSubSource).PageCommentsPubSub);
        startCommentsPubSubExperience(event);
        try {
            switch(event){
                case 'commentCreated':
                case 'avi:confluence:created:comment':
                    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                        if (addCommentInCache && commentId) {
                            const fetchFn = (0, $6mKj3.expVal)('cc_comments_page_comment_retry', 'isEnabled', false) ? $ced40be9017d58cb$var$fetchCommentByIdWithRetry : ({ commentId: cId, contentId: cntId })=>(0, $lb2Lp.fetchCommentById)({
                                    commentId: cId,
                                    contentId: cntId,
                                    fetchPolicy: 'network-only'
                                });
                            fetchFn({
                                commentId: commentId,
                                contentId: contentId
                            }).then((comment)=>{
                                if (comment) {
                                    addCommentInCache({
                                        newComment: comment,
                                        onError: failCommentsPubSubExperience
                                    });
                                    succeedCommentsPubSubExperience();
                                } else failCommentsPubSubExperience(new Error(`commentCreated: comment ${commentId} not found after retries`));
                            }).catch((err)=>{
                                failCommentsPubSubExperience(err);
                            });
                        } else failCommentsPubSubExperience(new Error('commentCreated: addCommentInCache or commentId is not defined'));
                    } else if (!reloader || !addNewComment) failCommentsPubSubExperience(new Error('commentCreated: reloader or addNewComment is not defined'));
                    else Promise.all([
                        $ced40be9017d58cb$export$37a9d770052438a6({
                            commentId: commentId,
                            contentId: contentId,
                            addNewCommentThreads: addNewCommentThreads,
                            addReplyToCommentThread: addReplyToCommentThread
                        }),
                        (0, $aM1he.reloadAndAddPageComments)(reloader, addNewComment, [
                            {
                                commentId: commentId,
                                accountId: accountId
                            }
                        ], userId)
                    ]).then(()=>{
                        succeedCommentsPubSubExperience();
                    }).catch((err)=>{
                        failCommentsPubSubExperience(err);
                    });
                    if (updateUnreadCommentIDSet && accountId !== userId) updateUnreadCommentIDSet(new Set([
                        commentId
                    ]), 'add');
                    break;
                case 'commentResolved':
                case 'avi:confluence:resolved:comment':
                    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                        if (commentId) // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                        (0, $lb2Lp.fetchCommentById)({
                            commentId: commentId,
                            contentId: contentId,
                            fetchPolicy: 'network-only'
                        }).then(()=>{
                            clearReplyIfRemoved?.({
                                commentId: commentId
                            });
                            // Handle unread comments after fetchCommentById completes
                            const { replies: replies = [] } = commentRequestBody;
                            if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                                commentId,
                                ...replies
                            ]), 'remove');
                        }).then(()=>{
                            succeedCommentsPubSubExperience();
                        }).catch((err)=>{
                            failCommentsPubSubExperience(err);
                        });
                        else failCommentsPubSubExperience(new Error('commentResolved: commentId is not defined'));
                        // When cc_comments_new_comments_data_manager is enabled, only commentActionType and commentId are used
                        // The rest of the variables here are defaults
                        if (updateRemovedCommentIdsMap && commentId) updateRemovedCommentIdsMap({
                            threadKey: commentId,
                            commentId: commentId,
                            commentActionType: (0, $8i27m.CommentActionType).RESOLVE_COMMENT_THREAD,
                            isReply: false,
                            commentType: (0, $8i27m.CommentType).GENERAL
                        });
                    } else if (reloader) reloader().then(()=>$ced40be9017d58cb$export$4d3ff641e060619d({
                            commentId: commentId,
                            contentId: contentId,
                            updateRemovedCommentIdsMap: updateRemovedCommentIdsMap
                        }).then(()=>{
                            // Handle unread comments after reloader completes
                            const { replies: replies = [] } = commentRequestBody;
                            if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                                commentId,
                                ...replies
                            ]), 'remove');
                        })).then(()=>{
                        succeedCommentsPubSubExperience();
                    }).catch((err)=>{
                        failCommentsPubSubExperience(err);
                    });
                    else failCommentsPubSubExperience(new Error('commentResolved: reloader is not defined'));
                    break;
                case 'commentDeleted':
                case 'avi:confluence:deleted:comment':
                    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                        if (deleteCommentInCache && commentId) {
                            const deletionSuccessful = deleteCommentInCache({
                                commentId: commentId,
                                onError: failCommentsPubSubExperience
                            });
                            if (deletionSuccessful) clearReplyIfRemoved?.({
                                commentId: commentId
                            });
                        }
                        if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                            commentId
                        ]), 'remove');
                        // When cc_comments_new_comments_data_manager is enabled, only commentActionType and commentId are used
                        // The rest of the variables here are defaults
                        if (updateRemovedCommentIdsMap && commentId) updateRemovedCommentIdsMap({
                            threadKey: commentId,
                            commentId: commentId,
                            commentActionType: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                            isReply: false,
                            commentType: (0, $8i27m.CommentType).GENERAL
                        });
                        succeedCommentsPubSubExperience();
                    } else if (!reloader) failCommentsPubSubExperience(new Error('commentDeleted: reloader is not defined'));
                    else Promise.all([
                        $ced40be9017d58cb$export$d4b860510819f61b({
                            commentId: commentId,
                            updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
                            getCurrentCommentsPanelState: getCurrentCommentsPanelState
                        }),
                        reloader().then(()=>{
                            removeComment && removeComment(commentId);
                            if (updateUnreadCommentIDSet) updateUnreadCommentIDSet(new Set([
                                commentId
                            ]), 'remove');
                        })
                    ]).then(()=>{
                        succeedCommentsPubSubExperience();
                    }).catch((err)=>{
                        failCommentsPubSubExperience(err);
                    });
                    break;
                case 'commentReopened':
                case 'avi:confluence:reopen:comment':
                    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                        if (commentId) // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                        (0, $lb2Lp.fetchCommentById)({
                            commentId: commentId,
                            contentId: contentId,
                            fetchPolicy: 'network-only'
                        }).then((commentData)=>{
                            // Handle unread comments with the fetched comment data
                            if (updateUnreadCommentIDSet && commentData && userId && getViewedCommentsCacheOnly) {
                                const viewedCommentsResult = getViewedCommentsCacheOnly();
                                if (viewedCommentsResult.success && viewedCommentsResult.data) $ced40be9017d58cb$var$handleUnreadCommentsForReopenedComment({
                                    comment: commentData,
                                    userId: userId,
                                    viewedComments: viewedCommentsResult.data,
                                    updateUnreadCommentIDSet: updateUnreadCommentIDSet
                                });
                            }
                        }).then(()=>{
                            succeedCommentsPubSubExperience();
                        }).catch((err)=>{
                            failCommentsPubSubExperience(err);
                        });
                        else failCommentsPubSubExperience(new Error('commentReopened: commentId is not defined'));
                    } else if (reloader) reloader().then(async ()=>{
                        const comment = await $ced40be9017d58cb$export$bbee85055c5ba3c6({
                            commentId: commentId,
                            contentId: contentId,
                            addNewCommentThreads: addNewCommentThreads,
                            getCurrentCommentsPanelState: getCurrentCommentsPanelState
                        });
                        // Handle unread comments with the existing comment data
                        if (updateUnreadCommentIDSet && comment && userId && getViewedCommentsCacheOnly) {
                            const viewedCommentsResult = getViewedCommentsCacheOnly();
                            if (viewedCommentsResult.success && viewedCommentsResult.data) $ced40be9017d58cb$var$handleUnreadCommentsForReopenedComment({
                                comment: comment,
                                userId: userId,
                                viewedComments: viewedCommentsResult.data,
                                updateUnreadCommentIDSet: updateUnreadCommentIDSet
                            });
                        }
                    }).then(()=>{
                        succeedCommentsPubSubExperience();
                    }).catch((err)=>{
                        failCommentsPubSubExperience(err);
                    });
                    else failCommentsPubSubExperience(new Error('commentReopened: reloader is not defined'));
                    // Remove from commentThreadsRemovedByOtherUsers when reopened
                    if (commentId && reopenParentComment) reopenParentComment({
                        threadKey: commentId,
                        commentType: (0, $8i27m.CommentType).GENERAL,
                        parentCommentId: commentId
                    });
                    break;
                case 'commentUpdated':
                case 'avi:confluence:updated:comment':
                    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
                        if (commentId) // fetchCommentById implicitly updates useAllCommentsDataQuery cache
                        (0, $lb2Lp.fetchCommentById)({
                            commentId: commentId,
                            contentId: contentId,
                            fetchPolicy: 'network-only'
                        }).then(()=>{
                            succeedCommentsPubSubExperience();
                        }).catch((err)=>{
                            failCommentsPubSubExperience(err);
                        });
                        else failCommentsPubSubExperience(new Error('commentUpdated: commentId is not defined'));
                    } else if (updateQueryVariables) Promise.all([
                        $ced40be9017d58cb$export$9cc4fc7c59ab4b10({
                            commentId: commentId,
                            contentId: contentId,
                            updateCommentBody: updateCommentBody
                        }),
                        (0, $aM1he.updateComment)(commentId, updateQueryVariables)
                    ]).then(()=>{
                        succeedCommentsPubSubExperience();
                    }).catch((err)=>{
                        failCommentsPubSubExperience(err);
                    });
                    else failCommentsPubSubExperience(new Error('commentUpdated: updateQueryVariables is not defined'));
                    break;
                default:
                    failCommentsPubSubExperience(new Error(`Unhandled comments pubsub event: ${event}`));
                    break;
            }
        } catch (error) {
            failCommentsPubSubExperience(error);
            throw error;
        }
    };
const $ced40be9017d58cb$export$c542af303309df99 = ({ contentId: contentId, contentType: contentType, userId: userId, reloader: reloader, addNewComment: addNewComment, removeComment: removeComment, queryArgs: { isReactionsEnabled: isReactionsEnabled }, addNewCommentThreads: addNewCommentThreads, addReplyToCommentThread: addReplyToCommentThread, updateCommentBody: updateCommentBody, updateRemovedCommentIdsMap: updateRemovedCommentIdsMap, reopenParentComment: reopenParentComment, getCurrentCommentsPanelState: getCurrentCommentsPanelState, addSubscriber: addSubscriber, setContentType: setContentType, setContentId: setContentId, updateUnreadCommentIDSet: updateUnreadCommentIDSet, getViewedCommentsCacheOnly: getViewedCommentsCacheOnly, addCommentInCache: addCommentInCache, deleteCommentInCache: deleteCommentInCache, clearReplyIfRemoved: clearReplyIfRemoved })=>{
    const pubSubResourceType = contentType || 'page';
    const subscriberIds = [];
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) {
        if (!addSubscriber || !setContentType || !setContentId) return;
        setContentType(pubSubResourceType);
        setContentId(contentId);
        const subscribers = [
            {
                subscriberId: 'pageCommentsPubSubCommentCreated',
                onSubscriptionData: $ced40be9017d58cb$export$4d067148c1e8c84d({
                    userId: userId,
                    contentId: contentId,
                    reloader: reloader,
                    addNewComment: addNewComment,
                    addNewCommentThreads: addNewCommentThreads,
                    addReplyToCommentThread: addReplyToCommentThread,
                    updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                    addCommentInCache: addCommentInCache
                }),
                delta: 'commentCreated'
            },
            {
                subscriberId: 'pageCommentsPubSubCommentResolved',
                onSubscriptionData: $ced40be9017d58cb$export$4d067148c1e8c84d({
                    userId: userId,
                    contentId: contentId,
                    reloader: reloader,
                    addNewComment: addNewComment,
                    updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
                    updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                    clearReplyIfRemoved: clearReplyIfRemoved
                }),
                delta: 'commentResolved'
            },
            {
                subscriberId: 'pageCommentsPubSubCommentDeleted',
                onSubscriptionData: $ced40be9017d58cb$export$4d067148c1e8c84d({
                    userId: userId,
                    contentId: contentId,
                    reloader: reloader,
                    removeComment: removeComment,
                    updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
                    getCurrentCommentsPanelState: getCurrentCommentsPanelState,
                    updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                    deleteCommentInCache: deleteCommentInCache,
                    clearReplyIfRemoved: clearReplyIfRemoved
                }),
                delta: 'commentDeleted'
            },
            {
                subscriberId: 'pageCommentsPubSubCommentReopened',
                onSubscriptionData: $ced40be9017d58cb$export$4d067148c1e8c84d({
                    userId: userId,
                    contentId: contentId,
                    reloader: reloader,
                    addNewComment: addNewComment,
                    addNewCommentThreads: addNewCommentThreads,
                    reopenParentComment: reopenParentComment,
                    getCurrentCommentsPanelState: getCurrentCommentsPanelState,
                    getViewedCommentsCacheOnly: getViewedCommentsCacheOnly,
                    updateUnreadCommentIDSet: updateUnreadCommentIDSet
                }),
                delta: 'commentReopened'
            },
            {
                subscriberId: 'pageCommentsPubSubCommentUpdated',
                onSubscriptionData: $ced40be9017d58cb$export$4d067148c1e8c84d({
                    userId: userId,
                    contentId: contentId,
                    updateQueryVariables: {
                        contentId: contentId,
                        isReactionsEnabled: isReactionsEnabled
                    },
                    updateCommentBody: updateCommentBody
                }),
                delta: 'commentUpdated'
            }
        ];
        for (const subscriber of subscribers)subscriberIds.push({
            subscriberId: addSubscriber(subscriber),
            delta: subscriber.delta
        });
        return subscriberIds;
    } else (0, $gRrX4.getPubSubClient)().then((client)=>{
        client.joinChannel(pubSubResourceType, contentId).finally(()=>{
            client.subscribe((0, $7S9uM.eventToAvi)('created:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
                userId: userId,
                contentId: contentId,
                reloader: reloader,
                addNewComment: addNewComment,
                addNewCommentThreads: addNewCommentThreads,
                addReplyToCommentThread: addReplyToCommentThread,
                updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                addCommentInCache: addCommentInCache
            }));
            client.subscribe((0, $7S9uM.eventToAvi)('resolved:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
                userId: userId,
                contentId: contentId,
                reloader: reloader,
                addNewComment: addNewComment,
                updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
                updateUnreadCommentIDSet: updateUnreadCommentIDSet
            }));
            client.subscribe((0, $7S9uM.eventToAvi)('deleted:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
                userId: userId,
                contentId: contentId,
                reloader: reloader,
                removeComment: removeComment,
                updateRemovedCommentIdsMap: updateRemovedCommentIdsMap,
                getCurrentCommentsPanelState: getCurrentCommentsPanelState,
                updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                deleteCommentInCache: deleteCommentInCache
            }));
            client.subscribe((0, $7S9uM.eventToAvi)('reopen:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
                userId: userId,
                contentId: contentId,
                reloader: reloader,
                addNewComment: addNewComment,
                addNewCommentThreads: addNewCommentThreads,
                reopenParentComment: reopenParentComment,
                getCurrentCommentsPanelState: getCurrentCommentsPanelState,
                getViewedCommentsCacheOnly: getViewedCommentsCacheOnly,
                updateUnreadCommentIDSet: updateUnreadCommentIDSet
            }));
            client.subscribe((0, $7S9uM.eventToAvi)('updated:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
                userId: userId,
                contentId: contentId,
                updateQueryVariables: {
                    contentId: contentId,
                    isReactionsEnabled: isReactionsEnabled
                },
                updateCommentBody: updateCommentBody
            }));
        }).catch((error)=>{
            throw new Error(`Unable to joinChannel ${JSON.stringify(error)}`);
        });
    });
};
const $ced40be9017d58cb$export$f6e2e9a186163b28 = ({ contentId: contentId, contentType: contentType, userId: userId, reloader: reloader, addNewComment: addNewComment, removeComment: removeComment, queryArgs: { isReactionsEnabled: isReactionsEnabled }, removeSubscriber: removeSubscriber, subscriptions: subscriptions, getViewedCommentsCacheOnly: getViewedCommentsCacheOnly })=>{
    const pubSubResourceType = contentType || 'page';
    const eventsToUnsubscribe = [
        'commentCreated',
        'commentDeleted',
        'commentUpdated'
    ];
    // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    if ((0, $9wGTI.fg)('cc_fps_migration_comments') && (0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider')) {
        if (!removeSubscriber || !subscriptions?.length) return;
        for (const subscriber of subscriptions)if (eventsToUnsubscribe.includes(subscriber.delta)) removeSubscriber(subscriber);
    } else (0, $gRrX4.getPubSubClient)().then((client)=>{
        client.leaveChannel(pubSubResourceType, contentId);
        client.unsubscribe((0, $7S9uM.eventToAvi)('created:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
            userId: userId,
            contentId: contentId,
            reloader: reloader,
            addNewComment: addNewComment,
            getViewedCommentsCacheOnly: getViewedCommentsCacheOnly
        }));
        client.unsubscribe((0, $7S9uM.eventToAvi)('deleted:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
            userId: userId,
            contentId: contentId,
            reloader: reloader,
            removeComment: removeComment,
            getViewedCommentsCacheOnly: getViewedCommentsCacheOnly
        }));
        client.unsubscribe((0, $7S9uM.eventToAvi)('updated:comment'), $ced40be9017d58cb$export$4d067148c1e8c84d({
            userId: userId,
            contentId: contentId,
            updateQueryVariables: {
                contentId: contentId,
                isReactionsEnabled: isReactionsEnabled
            },
            getViewedCommentsCacheOnly: getViewedCommentsCacheOnly
        }));
    });
};
module.exports["setUpPageCommentsPubSub"] = $ced40be9017d58cb$export$c542af303309df99;
module.exports["removePageCommentsPubSub"] = $ced40be9017d58cb$export$f6e2e9a186163b28;

});

parcelRegister("kQekh", function(module, exports) {

var $k5aG8 = parcelRequire("k5aG8");


var $f9FCO = parcelRequire("f9FCO");

const $90ffe60e2eae60ca$export$bf87400a8da436f8 = (0, $f9FCO.default);
const $90ffe60e2eae60ca$export$caecd77287327384 = (0, $k5aG8.default);
module.exports["CommentsSectionGetSingleCommentQuery"] = $90ffe60e2eae60ca$export$bf87400a8da436f8;
module.exports["CommentsSectionGetSingleCommentWithoutReactionsQuery"] = $90ffe60e2eae60ca$export$caecd77287327384;

});

parcelRegister("k5aG8", function(module, exports) {
/**
 * @generated SignedSource<<8ed7915c440f335b6a58fb7784fdbb97>>
 * @relayHash d3bcc60b520b9e62b29ac8be494a67be
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7283bb4b16c1cdbaba6a6dd79d25ca7b709cb15a18141ac1fd787bca033d468c
const $2711060718729916$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "ancestors",
        "plural": true,
        "selections": [
            v2 /*: any*/ 
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionType"
            }
        ],
        "type": "KnownUser"
    }, v9 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v10 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v9 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v11 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v12 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v9 /*: any*/ 
    }, v13 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v14 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v17 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v15 /*: any*/ ,
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v20 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v15 /*: any*/ ,
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v21 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v22 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v24 = {
        "kind": "ScalarField",
        "name": "number"
    }, v25 = {
        "kind": "ScalarField",
        "name": "when"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ 
        ],
        "type": "KnownUser"
    }, v27 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CommentsSectionGetSingleCommentQueryWithoutReactionsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CommentsSectionGetSingleCommentQueryWithoutReactionsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v27 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v27 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v27 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "d3bcc60b520b9e62b29ac8be494a67be",
            "id": "7283bb4b16c1cdbaba6a6dd79d25ca7b709cb15a18141ac1fd787bca033d468c",
            "metadata": {},
            "name": "CommentsSectionGetSingleCommentQueryWithoutReactionsQuery",
            "operationKind": "query",
            "text": "query CommentsSectionGetSingleCommentQueryWithoutReactionsQuery($commentId:ID!){comments(commentId:$commentId){nodes{id,ancestors{id},author{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId,permissionType}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{friendlyWhen,number,when,by{__typename,type,displayName,...on KnownUser{accountId}}}}}}"
        }
    };
}();
$2711060718729916$var$node.hash = "2d393682eae4feef3986d5e4ea1bd5a6";
var $2711060718729916$export$2e2bcd8739ae039 = $2711060718729916$var$node;
module.exports["default"] = $2711060718729916$export$2e2bcd8739ae039;

});

parcelRegister("f9FCO", function(module, exports) {
/**
 * @generated SignedSource<<ba3d28415cb064032a9b12514118849b>>
 * @relayHash 1a3bffe088c5850ddf1b9c1ca4f044de
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 99bae9281cfcad757a48d4ce24663228d32566fabd997953e6327a8ca274f81a
const $c1f0ddf438970e3e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "ancestors",
        "plural": true,
        "selections": [
            v2 /*: any*/ 
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionType"
            }
        ],
        "type": "KnownUser"
    }, v9 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v10 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v9 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v11 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v12 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v9 /*: any*/ 
    }, v13 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v14 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v17 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v15 /*: any*/ ,
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v20 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v15 /*: any*/ ,
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v21 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v22 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v24 = {
        "kind": "ScalarField",
        "name": "number"
    }, v25 = {
        "kind": "ScalarField",
        "name": "when"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ 
        ],
        "type": "KnownUser"
    }, v27 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            {
                "kind": "Variable",
                "name": "pageId",
                "variableName": "contentId"
            }
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v28 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CommentsSectionGetSingleCommentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CommentsSectionGetSingleCommentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v28 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v28 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v28 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "1a3bffe088c5850ddf1b9c1ca4f044de",
            "id": "99bae9281cfcad757a48d4ce24663228d32566fabd997953e6327a8ca274f81a",
            "metadata": {},
            "name": "CommentsSectionGetSingleCommentQuery",
            "operationKind": "query",
            "text": "query CommentsSectionGetSingleCommentQuery($commentId:ID!,$contentId:ID!){comments(commentId:$commentId){nodes{id,ancestors{id},author{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId,permissionType}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{friendlyWhen,number,when,by{__typename,type,displayName,...on KnownUser{accountId}}},reactionsSummary(pageId:$contentId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}}}"
        }
    };
}();
$c1f0ddf438970e3e$var$node.hash = "326ee68c128aba1a564502e019c38ae6";
var $c1f0ddf438970e3e$export$2e2bcd8739ae039 = $c1f0ddf438970e3e$var$node;
module.exports["default"] = $c1f0ddf438970e3e$export$2e2bcd8739ae039;

});

parcelRegister("jLcXM", function(module, exports) {

var $233nj = parcelRequire("233nj");

const $f35c50316f68c508$export$34ea693bdbe9d3f6 = (0, $233nj.default);
module.exports["ActivePageCommentQuery"] = $f35c50316f68c508$export$34ea693bdbe9d3f6;

});

parcelRegister("233nj", function(module, exports) {
/**
 * @generated SignedSource<<8d67f7ad40d94c56816dcc35e2d1abb9>>
 * @relayHash 4b2b231d2dc45d90f0e6c67f64d74442
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 59117d0e39c953fac3a300093542641681064ffbd898fae1d4fd06ea427e52d0
const $6a66bb9e87369108$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "ancestors",
        "plural": true,
        "selections": [
            v2 /*: any*/ 
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionType"
            }
        ],
        "type": "KnownUser"
    }, v9 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v10 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v9 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v11 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v12 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v9 /*: any*/ 
    }, v13 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v14 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v17 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v15 /*: any*/ ,
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v20 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v15 /*: any*/ ,
                    v16 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v21 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v22 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v24 = {
        "kind": "ScalarField",
        "name": "number"
    }, v25 = {
        "kind": "ScalarField",
        "name": "when"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ 
        ],
        "type": "KnownUser"
    }, v27 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            {
                "kind": "Variable",
                "name": "pageId",
                "variableName": "contentId"
            }
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v2 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v28 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ActivePageCommentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v27 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ActivePageCommentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v28 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v28 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v28 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v27 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v28 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "4b2b231d2dc45d90f0e6c67f64d74442",
            "id": "59117d0e39c953fac3a300093542641681064ffbd898fae1d4fd06ea427e52d0",
            "metadata": {},
            "name": "ActivePageCommentQuery",
            "operationKind": "query",
            "text": "query ActivePageCommentQuery($commentId:ID!,$contentId:ID!){comments(commentId:$commentId){nodes{id,ancestors{id},author{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId,permissionType}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{friendlyWhen,number,when,by{__typename,type,displayName,...on KnownUser{accountId}}},reactionsSummary(pageId:$contentId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}},replies{id,author{__typename,type,...on KnownUser{accountId,permissionType}},createdAt{value},createdAtNonLocalized,parentId}}}}"
        }
    };
}();
$6a66bb9e87369108$var$node.hash = "74318b0c1a4a8927e074ad4bb12d4099";
var $6a66bb9e87369108$export$2e2bcd8739ae039 = $6a66bb9e87369108$var$node;
module.exports["default"] = $6a66bb9e87369108$export$2e2bcd8739ae039;

});

parcelRegister("e4kZB", function(module, exports) {
const $5243889752facbc2$export$446c7c25f5f55821 = (comment)=>{
    return {
        id: comment.id,
        author: {
            accountId: comment.author?.__typename === 'KnownUser' ? comment.author.accountId : undefined
        },
        createdAt: {
            value: comment.createdAt?.value || ''
        },
        location: {
            type: comment.location.type,
            inlineMarkerRef: comment.location?.inlineMarkerRef,
            inlineResolveProperties: comment.location?.inlineResolveProperties,
            commentResolveProperties: comment.location?.commentResolveProperties
        }
    };
};
const $5243889752facbc2$export$77349abd6de54bd8 = ({ commentId: commentId, userId: userId, createdAt: createdAt, commentType: commentType, resolveProperties: resolveProperties })=>{
    return {
        id: commentId,
        author: {
            accountId: userId || undefined
        },
        createdAt: {
            value: createdAt || ''
        },
        location: {
            type: commentType,
            ...commentType === 'INLINE' ? {
                inlineResolveProperties: resolveProperties || {
                    resolved: false
                }
            } : {
                commentResolveProperties: resolveProperties || {
                    resolved: false
                }
            }
        }
    };
};
const $5243889752facbc2$export$8df0b6c8bcdda615 = ({ pageMode: pageMode = 'view', annotationsInEditorDoc: annotationsInEditorDoc, rendererAnnotations: rendererAnnotations })=>(markerRef)=>{
        if (!markerRef) return false; // default to false if no marker ref
        // Treat 'live' mode as 'edit' mode
        const effectivePageMode = pageMode === 'live' ? 'edit' : pageMode;
        return effectivePageMode === 'view' ? !rendererAnnotations.has(markerRef) : !annotationsInEditorDoc.has(markerRef);
    };
const $5243889752facbc2$export$22ce26f7ba09f326 = ({ comment: comment, currentUserId: currentUserId, viewedComments: viewedComments, isDanglingCallback: isDanglingCallback })=>{
    // Early return if comment is already viewed
    if (viewedComments.has(comment.id)) return false;
    const isNotOwnComment = comment.author?.accountId && comment.author.accountId !== currentUserId;
    const createdLast30Days = new Date(comment.createdAt?.value) > new Date(Date.now() - 2592000000);
    const commentLocation = comment?.location;
    const markerRef = commentLocation?.inlineMarkerRef;
    const isDanglingInlineComment = isDanglingCallback ? isDanglingCallback(markerRef) : false;
    const isPageComment = comment?.location.type === 'FOOTER';
    const isResolved = comment?.location?.inlineResolveProperties?.resolved || comment?.location?.commentResolveProperties?.resolved;
    return !isResolved && isNotOwnComment && createdLast30Days && (!isDanglingInlineComment || isPageComment);
};
const $5243889752facbc2$export$92c1e243fe45a57f = async ({ allComments: allComments, currentUserId: currentUserId, pageId: pageId, updateUnreadCommentIDSet: updateUnreadCommentIDSet, resetStates: resetStates, viewedComments: viewedComments, isDanglingCallback: isDanglingCallback, addNewCommentThreads: addNewCommentThreads })=>{
    if (!allComments || !pageId) return;
    const unreadCommentIds = new Set();
    // keep track inline comment threads so we can prepopulate comments data map in order to keep track of dangling and resolved comments for unread
    const inlineCommentThreadsToAdd = {};
    allComments.forEach((comment)=>{
        if (!comment) return;
        if (comment.location.type === 'INLINE') {
            const commentLocation = comment.location;
            const threadKey = commentLocation?.inlineMarkerRef;
            if (threadKey) // Our query only returns open comments, so we need to set the isOpen status to true
            inlineCommentThreadsToAdd[threadKey] = {
                ...comment,
                isOpen: true,
                wasRemovedByAnotherUser: false
            };
        }
        if (currentUserId) {
            const parentCommentForValidation = $5243889752facbc2$export$446c7c25f5f55821(comment);
            if ($5243889752facbc2$export$22ce26f7ba09f326({
                comment: parentCommentForValidation,
                currentUserId: currentUserId,
                viewedComments: viewedComments,
                isDanglingCallback: isDanglingCallback
            })) unreadCommentIds.add(comment.id);
            if (comment.replies) comment.replies.forEach((reply)=>{
                if (reply) {
                    const replyForValidation = $5243889752facbc2$export$446c7c25f5f55821(reply);
                    if ($5243889752facbc2$export$22ce26f7ba09f326({
                        comment: replyForValidation,
                        currentUserId: currentUserId,
                        viewedComments: viewedComments,
                        isDanglingCallback: isDanglingCallback
                    })) unreadCommentIds.add(reply.id);
                }
            });
        }
    });
    updateUnreadCommentIDSet(unreadCommentIds, 'initialize');
    // Add the comment threads for inline comments at the end
    addNewCommentThreads && addNewCommentThreads({
        inline: inlineCommentThreadsToAdd,
        general: {}
    });
    // Once we are done updating the unread list, need to reset the states.
    resetStates();
};
module.exports["buildValidationObjectFromProps"] = $5243889752facbc2$export$77349abd6de54bd8;
module.exports["commentIsDangling"] = $5243889752facbc2$export$8df0b6c8bcdda615;
module.exports["isValidUnreadComment"] = $5243889752facbc2$export$22ce26f7ba09f326;
module.exports["createUnreadCommentsSet"] = $5243889752facbc2$export$92c1e243fe45a57f;

});

parcelRegister("b11gn", function(module, exports) {

var $gtj7V = parcelRequire("gtj7V");


var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");

var $c84c3a6392bd7f68$export$4dc7cc9100b67c07 = /*#__PURE__*/ function(CommentsPubSubSource) {
    CommentsPubSubSource["EditorInlineCommentsPubSub"] = "editorInlineCommentsPubSub";
    CommentsPubSubSource["RendererInlineCommentsPubSub"] = "rendererInlineCommentsPubSub";
    CommentsPubSubSource["PageCommentsPubSub"] = "pageCommentsPubSub";
    return CommentsPubSubSource;
}({});
const $c84c3a6392bd7f68$export$c83a826d1956bd57 = (source)=>{
    // Unique per event invocation; lets us detect concurrent-event collisions
    // by matching initialTrackingId === terminalTrackingId in logs.
    let trackingId;
    return {
        start: (event)=>{
            // IMPORTANT - because this is in a factory method, it is deliberate that mixing
            // & matching starts / failures / successes across invocations will lead to different trackingIDs.
            // If you need to refactor this to be cross-file, or cross-function for a valid case,
            // you'll probably need to lift this out of the factory
            trackingId = crypto.randomUUID();
            (0, $fGzMp.getExperienceTracker)().start({
                name: (0, $irVI7.COMMENTS_PUBSUB_EVENT_EXPERIENCE),
                // 15s — above the AGG client's ~10s network timeout.
                timeout: 15000,
                attributes: {
                    event: event,
                    source: source,
                    initialTrackingId: trackingId,
                    ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)()
                }
            });
        },
        succeed: ()=>{
            (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.COMMENTS_PUBSUB_EVENT_EXPERIENCE),
                attributes: {
                    terminalTrackingId: trackingId
                }
            });
        },
        fail: (err)=>{
            (0, $fGzMp.getExperienceTracker)().fail({
                name: (0, $irVI7.COMMENTS_PUBSUB_EVENT_EXPERIENCE),
                error: err instanceof Error ? err : new Error(String(err)),
                attributes: {
                    terminalTrackingId: trackingId
                }
            });
        }
    };
};
module.exports["CommentsPubSubSource"] = $c84c3a6392bd7f68$export$4dc7cc9100b67c07;
module.exports["createCommentsPubSubExperienceTracker"] = $c84c3a6392bd7f68$export$c83a826d1956bd57;

});

parcelRegister("2QXMk", function(module, exports) {
const $67c4ff113c7d4c29$export$e314db58fea1ec32 = ({ accountId: accountId = null, currentUserId: currentUserId = null, isReply: isReply, isOwnReplyPubSubProcessingEnabled: isOwnReplyPubSubProcessingEnabled })=>{
    if (accountId !== currentUserId) return false;
    if (!isReply) return true;
    return !isOwnReplyPubSubProcessingEnabled;
};
module.exports["shouldSkipOwnPubSubEvent"] = $67c4ff113c7d4c29$export$e314db58fea1ec32;

});

parcelRegister("aM1he", function(module, exports) {

var $kQekh = parcelRequire("kQekh");


var $c0rhi = parcelRequire("c0rhi");

const $406672c94379d4ab$export$5a1cd239009d83a6 = async (commentId, { contentId: contentId, isReactionsEnabled: isReactionsEnabled })=>{
    const query = isReactionsEnabled ? (0, $kQekh.CommentsSectionGetSingleCommentQuery) : (0, $kQekh.CommentsSectionGetSingleCommentWithoutReactionsQuery);
    const variables = isReactionsEnabled ? {
        commentId: commentId,
        contentId: contentId
    } : {
        commentId: commentId
    };
    // Query the single comment to update the cache
    (0, $c0rhi.queryInterop)({
        query: query,
        variables: variables,
        __callerPackage__: "comments-pubsub"
    });
};
const $406672c94379d4ab$export$af4b8274c1b86043 = (reloader, addNewComment, commentData, currentUserId)=>reloader().then(()=>{
        setTimeout(()=>{
            // HACK: Give the comments section time to render the new comment
            commentData.forEach((data)=>{
                addNewComment({
                    newCommentId: data.commentId,
                    currentUserMadeComment: data.accountId === currentUserId
                });
            });
        }, 3000);
    }).catch((err)=>{
        throw err;
    });
module.exports["updateComment"] = $406672c94379d4ab$export$5a1cd239009d83a6;
module.exports["reloadAndAddPageComments"] = $406672c94379d4ab$export$af4b8274c1b86043;

});

parcelRegister("5Xv1X", function(module, exports) {

let $456a8877238c582b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $456a8877238c582b$var$load("dzUzj"),
    $456a8877238c582b$var$load("giAlZ")
]).then(()=>parcelRequire('4eqe7'));

});

parcelRegister("gGHFp", function(module, exports) {

var $joyRP = parcelRequire("joyRP");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $flWvL = parcelRequire("flWvL");

const $fc42d4eabc71418e$var$UseEditorContentModeValueQuery = (0, $joyRP.default);
function $fc42d4eabc71418e$export$6bb080aad8c6a96a({ contentId: contentId, isArchived: isArchived }) {
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const isDraft = !isLivePage && Boolean(isEditorPage);
    const status = (0, $flWvL.queryStatusFor)(isDraft, isArchived);
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($fc42d4eabc71418e$var$UseEditorContentModeValueQuery, {
        variables: {
            contentId: contentId,
            isDraft: isDraft,
            status: [
                status
            ]
        },
        fetchPolicy: 'cache-and-network',
        skip: !contentId // avoid starting network flow
        ,
        __callerPackage__: "editor-content-mode-button"
    });
    let serverModeRaw;
    const contentProps = data?.content?.nodes?.[0]?.contentProperties;
    if (isDraft) serverModeRaw = contentProps?.draft?.contentMode;
    else serverModeRaw = contentProps?.latest?.contentMode;
    const mode = (0, $flWvL.serverToUiContentMode)(serverModeRaw);
    return (0, $cozmU.useMemo)(()=>({
            mode: mode,
            isLoading: Boolean(loading),
            error: error ?? null
        }), [
        mode,
        loading,
        error
    ]);
}
module.exports["useEditorContentModeValue"] = $fc42d4eabc71418e$export$6bb080aad8c6a96a;

});

parcelRegister("joyRP", function(module, exports) {
/**
 * @generated SignedSource<<11e8316517ac59e0b0326a7aa3a855c6>>
 * @relayHash ff452defe6c30c6aef6cb69359d0b5a9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 34a936a3c8d22258a1afe16bee6383e33250109cc96bccd4cb0241a006a579ad
const $fd020ad5a5ea36ff$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDraft"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "contentMode"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "isDraft",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "concreteType": "PublishedContentProperties",
                                            "kind": "LinkedField",
                                            "name": "latest",
                                            "plural": false,
                                            "selections": v1 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "condition": "isDraft",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "DraftContentProperties",
                                            "kind": "LinkedField",
                                            "name": "draft",
                                            "plural": false,
                                            "selections": v1 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEditorContentModeValueQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEditorContentModeValueQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ff452defe6c30c6aef6cb69359d0b5a9",
            "id": "34a936a3c8d22258a1afe16bee6383e33250109cc96bccd4cb0241a006a579ad",
            "metadata": {},
            "name": "useEditorContentModeValueQuery",
            "operationKind": "query",
            "text": "query useEditorContentModeValueQuery($contentId:ID!,$isDraft:Boolean!,$status:[String]){content(id:$contentId,status:$status){nodes{id,contentProperties{latest@skip(if:$isDraft){contentMode},draft@include(if:$isDraft){contentMode}}}}}"
        }
    };
}();
$fd020ad5a5ea36ff$var$node.hash = "51a479801516afe1b59a1bbcd1c3f7d5";
var $fd020ad5a5ea36ff$export$2e2bcd8739ae039 = $fd020ad5a5ea36ff$var$node;
module.exports["default"] = $fd020ad5a5ea36ff$export$2e2bcd8739ae039;

});

parcelRegister("flWvL", function(module, exports) {
const $601c87545eb15d39$export$7744ef788ce8060b = (server)=>{
    if (typeof server === 'string') {
        const v = server.toLowerCase();
        if (v === 'compact') return 'compact';
    }
    return 'standard';
};
const $601c87545eb15d39$export$c21c52065fb17015 = (ui)=>ui === 'compact' ? 'COMPACT' : 'STANDARD';
const $601c87545eb15d39$export$9b5b746082006bde = (m)=>m === 'compact' ? 'standard' : 'compact';
const $601c87545eb15d39$export$bc47da214dd10736 = (opts)=>{
    if (opts.isLivePage) return 'CURRENT';
    if (opts.isEditorPage) return 'DRAFT';
    return 'CURRENT';
};
const $601c87545eb15d39$export$7052ab1304ba8160 = (isDraft, isArchived)=>{
    return isArchived ? 'archived' : isDraft ? 'draft' : 'current';
};
module.exports["serverToUiContentMode"] = $601c87545eb15d39$export$7744ef788ce8060b;
module.exports["uiToServerContentMode"] = $601c87545eb15d39$export$c21c52065fb17015;
module.exports["flipContentMode"] = $601c87545eb15d39$export$9b5b746082006bde;
module.exports["resolveContentStatus"] = $601c87545eb15d39$export$bc47da214dd10736;
module.exports["queryStatusFor"] = $601c87545eb15d39$export$7052ab1304ba8160;

});

parcelRegister("lfmjq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7aRa9 = parcelRequire("7aRa9");

const $0d3a7c976c53fe50$export$687b1508b29e79eb = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const intl = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        const urlParams = new URLSearchParams(window.location.search);
        const moved = urlParams.get('moved');
        if (moved === 'success') {
            // Show the success flag
            flags.showSuccessFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0d3a7c976c53fe50$var$i18n.movePageItemMovedTitle),
                isAutoDismiss: true
            });
            // Clean up URL parameters without causing a page reload
            urlParams.delete('moved');
            const newParams = urlParams.size > 0 ? `?${urlParams.toString()}` : '';
            const newUrl = `${window.location.pathname}${newParams}${window.location.hash}`;
            window.history.replaceState({}, '', newUrl);
        }
    }, [
        flags,
        intl
    ]);
    return null;
});
const $0d3a7c976c53fe50$var$i18n = (0, $kSwu1.defineMessages)({
    movePageItemMovedTitle: {
        id: "page-tree.move-page.flag.success",
        defaultMessage: "Item moved"
    }
});
module.exports["MovePageSuccessFlag"] = $0d3a7c976c53fe50$export$687b1508b29e79eb;

});

parcelRegister("ecUYt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $7xVCs = parcelRequire("7xVCs");

function $1b739b5871223ff5$export$347bd2772961ad32(WrappedComponent) {
    function withPageTreeStateUpdater(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: [
                (0, $7xVCs.PageTreeStateUpdater)
            ]
        }, (pageTreeStateUpdater)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                pageTreeStateUpdater: pageTreeStateUpdater,
                ...props
            }));
    }
    return withPageTreeStateUpdater;
}
module.exports["withPageTreeStateUpdater"] = $1b739b5871223ff5$export$347bd2772961ad32;

});

parcelRegister("hd53J", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ln0hx = parcelRequire("ln0hx");

var $1kHsc = parcelRequire("1kHsc");


var $aSsfA = parcelRequire("aSsfA");


var $gtj7V = parcelRequire("gtj7V");


var $NYiei = parcelRequire("NYiei");


var $4L9ve = parcelRequire("4L9ve");

// Initiates the loading of all comment data for the specified page in the background
// This component is also responsible for processing the raw comments data and updating
// the ProcessedCommentsDataStore with categorized results using default contentStatus filters.
// Experience tracking constants
const $52b7f7492d78c524$var$COMMENTS_DATA_BACKGROUND_LOAD_EXPERIENCE = 'comments-data-background-load';
const $52b7f7492d78c524$export$bdd232a9ca677e73 = ({ contentId: contentId })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const [{ lastProcessedData: lastProcessedData }, { setProcessedData: setProcessedData, setError: setError, setRefetch: setRefetch, clearErrorAndResetIsDataProcessed: clearErrorAndResetIsDataProcessed, setDataToProcessed: setDataToProcessed, processCommentsData: processCommentsData }] = (0, $4L9ve.useProcessedCommentsData)();
    // Track refetch count to force effect to run after every refetch
    const [refetchCount, setRefetchCount] = (0, $cozmU.useState)(0);
    // Call the hook to load all comments - should only when content has settled and is ready so we
    // don't impact loading times
    // Always fetch with network-only to ensure we get fresh data
    const { loading: loading, error: error, data: data, refetch: refetch } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: !contentId,
            fetchPolicy: 'network-only'
        }
    });
    // Set refetch function in store whenever it changes.
    // Wrap refetch so that when the view calls it (e.g. Retry), we clear error/processed state first.
    // Increment refetchCount in .then() to force the processing effect to run.
    // On refetch failure we always setError, then call the caller's onError if they passed one.
    (0, $cozmU.useEffect)(()=>{
        if (refetch) {
            const wrappedRefetch = ({ onError: callerOnError } = {})=>{
                clearErrorAndResetIsDataProcessed();
                return refetch({
                    onError: (err)=>{
                        setError(err instanceof Error ? err : new Error(String(err)));
                        callerOnError?.(err);
                    }
                }).then((result)=>{
                    setRefetchCount((c)=>c + 1);
                    return result;
                });
            };
            setRefetch(wrappedRefetch);
        }
    }, [
        refetch,
        setRefetch,
        clearErrorAndResetIsDataProcessed,
        setError
    ]);
    // Process and update the ProcessedCommentsDataStore when data changes or refetch completes
    // This is the ONLY place where the processed data store should be updated
    // Depends on refetchCount to ensure effect runs after every refetch
    (0, $cozmU.useEffect)(()=>{
        // Don't process data while loading
        if (loading) return;
        if (error) {
            setError(error);
            return;
        }
        // When data is undefined (e.g. refetch failed and error was set in the wrapper catch),
        // don't call setProcessedData or we'd overwrite that error with error: undefined.
        if (data === undefined) return;
        // Fast path: if data reference is same as last processed (cached data from refetch),
        // just flip isDataProcessed to true without reprocessing
        if (data === lastProcessedData) {
            setDataToProcessed();
            return;
        }
        processCommentsData({
            data: data,
            pageMode: pageMode
        });
    }, [
        data,
        loading,
        error,
        pageMode,
        setProcessedData,
        setError,
        contentId,
        refetchCount,
        lastProcessedData,
        setDataToProcessed,
        processCommentsData
    ]);
    // Experience tracking: Handle success/failure when loading completes
    (0, $cozmU.useEffect)(()=>{
        if (!contentId) return;
        // Only track completion if we're not still loading
        if (!loading) {
            if (error) // Experience failed due to error
            experienceTracker.fail({
                name: $52b7f7492d78c524$var$COMMENTS_DATA_BACKGROUND_LOAD_EXPERIENCE,
                error: error
            });
            else // Experience succeeded - comments data loaded successfully
            experienceTracker.succeed({
                name: $52b7f7492d78c524$var$COMMENTS_DATA_BACKGROUND_LOAD_EXPERIENCE
            });
        }
    }, [
        loading,
        error,
        contentId,
        experienceTracker
    ]);
    // This component only triggers the hook, doesn't render anything other than the ExperienceStart,
    // which handles being rendered multiple times with the same props gracefully
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
        name: $52b7f7492d78c524$var$COMMENTS_DATA_BACKGROUND_LOAD_EXPERIENCE,
        attributes: {
            ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
            contentId: contentId
        }
    });
};
module.exports["CommentsDataBackgroundLoader"] = $52b7f7492d78c524$export$bdd232a9ca677e73;

});

parcelRegister("ln0hx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $0c8ceb2bfbb43f95$export$f20b867e738a222c({ id: id, name: name, attributes: attributes, collect: collect, onSuccess: onSuccess }) {
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const wasCalledRef = (0, $cozmU.useRef)(false);
    if (!wasCalledRef.current) {
        experienceTracker.start({
            attributes: attributes,
            name: name,
            id: id,
            collect: collect,
            onSuccess: onSuccess
        });
        wasCalledRef.current = true;
    }
    return null;
}
module.exports["ExperienceStart"] = $0c8ceb2bfbb43f95$export$f20b867e738a222c;

});

parcelRegister("8S5Nq", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $218fb6be7858ca8d$export$c96c4e8509a478b = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "OOALz",
    name: "SmartButtonConfigPanel",
    loader: async ()=>(await (parcelRequire("2oLpJ"))).SmartButtonConfigPanel
});
module.exports["SmartButtonConfigPanel"] = $218fb6be7858ca8d$export$c96c4e8509a478b;

});

parcelRegister("2oLpJ", function(module, exports) {

let $1bf29a1a89e0ed15$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1bf29a1a89e0ed15$var$load("LWh5V"),
    $1bf29a1a89e0ed15$var$load("7EorR"),
    $1bf29a1a89e0ed15$var$load("jqoep"),
    $1bf29a1a89e0ed15$var$load("lbsQO"),
    $1bf29a1a89e0ed15$var$load("7TnhR"),
    $1bf29a1a89e0ed15$var$load("6wr18"),
    $1bf29a1a89e0ed15$var$load("2xKrc"),
    $1bf29a1a89e0ed15$var$load("ffEVr"),
    $1bf29a1a89e0ed15$var$load("hhss7"),
    $1bf29a1a89e0ed15$var$load("lhkXg"),
    $1bf29a1a89e0ed15$var$load("hjl2g")
]).then(()=>parcelRequire('cN6V7'));

});

parcelRegister("iz4WO", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $9wGTI = parcelRequire("9wGTI");

const $a33c6d5d862efa17$export$cb03d08131b95fd = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    return {
        isSmartButtonAllowed: isPremium || (0, $9wGTI.fg)('a4c_free_and_standard_editions')
    };
};
module.exports["useSmartButtonPremiumGate"] = $a33c6d5d862efa17$export$cb03d08131b95fd;

});

parcelRegister("jOYfu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $5aeb329f1887f8c3$export$f82678483d6187c3 = ()=>{
    const [smartButtonActiveNodeLocalId, setSmartButtonActiveNodeLocalId] = (0, $cozmU.useState)(null);
    const openSmartButtonConfigPanel = (0, $cozmU.useCallback)((localId)=>{
        setSmartButtonActiveNodeLocalId(localId);
    }, [
        setSmartButtonActiveNodeLocalId
    ]);
    const closeSmartButtonConfigPanel = (0, $cozmU.useCallback)(()=>{
        setSmartButtonActiveNodeLocalId(null);
    }, [
        setSmartButtonActiveNodeLocalId
    ]);
    return (0, $cozmU.useMemo)(()=>({
            smartButtonActiveNodeLocalId: smartButtonActiveNodeLocalId,
            openSmartButtonConfigPanel: openSmartButtonConfigPanel,
            closeSmartButtonConfigPanel: closeSmartButtonConfigPanel
        }), [
        smartButtonActiveNodeLocalId,
        openSmartButtonConfigPanel,
        closeSmartButtonConfigPanel
    ]);
};
module.exports["useSmartButtonConfigPanel"] = $5aeb329f1887f8c3$export$f82678483d6187c3;

});

parcelRegister("jXhAV", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d2180b659da4cd23$export$cace184d1f5b9f1 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "QfGBR",
    name: "QuickReload",
    loader: async ()=>{
        const { QuickReload: QuickReload } = await (parcelRequire("bKNB2"));
        return QuickReload;
    }
});
module.exports["QuickReload"] = $d2180b659da4cd23$export$cace184d1f5b9f1;

});

parcelRegister("bKNB2", function(module, exports) {

let $88ea766454d1b70b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $88ea766454d1b70b$var$load("6wr18"),
    $88ea766454d1b70b$var$load("ddJza"),
    $88ea766454d1b70b$var$load("ifgY7"),
    $88ea766454d1b70b$var$load("diyjB"),
    $88ea766454d1b70b$var$load("ffEVr"),
    $88ea766454d1b70b$var$load("ddvkk"),
    $88ea766454d1b70b$var$load("3upHR"),
    $88ea766454d1b70b$var$load("7XFs3")
]).then(()=>parcelRequire('1EPbu'));

});

parcelRegister("fSC8h", function(module, exports) {
var $aa49ff5a5783772f$export$c51d39001809fe3e = /*#__PURE__*/ function(PubSubState) {
    PubSubState[PubSubState["POLLING_ONLY"] = 0] = "POLLING_ONLY";
    PubSubState[PubSubState["PUBSUB_ONLY"] = 1] = "PUBSUB_ONLY";
    PubSubState[PubSubState["ACTIVE"] = 2] = "ACTIVE";
    PubSubState[PubSubState["TERMINATED"] = 3] = "TERMINATED";
    return PubSubState;
}({});
const $aa49ff5a5783772f$export$5a33be95ac52bdad = 2000;
var $aa49ff5a5783772f$export$8f29965b50c50222 = /*#__PURE__*/ function(PubSubFlagType) {
    PubSubFlagType[PubSubFlagType["COMMENT"] = 0] = "COMMENT";
    PubSubFlagType[PubSubFlagType["EDIT"] = 1] = "EDIT";
    return PubSubFlagType;
}({});
var $aa49ff5a5783772f$export$6ea4b0c62affbe44 = /*#__PURE__*/ function(PageMode) {
    PageMode[PageMode["EDITOR"] = 0] = "EDITOR";
    PageMode[PageMode["LIVE"] = 1] = "LIVE";
    PageMode[PageMode["RENDERER"] = 2] = "RENDERER";
    return PageMode;
}({});
module.exports["PubSubState"] = $aa49ff5a5783772f$export$c51d39001809fe3e;
module.exports["INACTIVE_TAB_WAIT_INTERVAL"] = $aa49ff5a5783772f$export$5a33be95ac52bdad;
module.exports["PubSubFlagType"] = $aa49ff5a5783772f$export$8f29965b50c50222;
module.exports["PageMode"] = $aa49ff5a5783772f$export$6ea4b0c62affbe44;

});

parcelRegister("3d5UI", function(module, exports) {
function $28507a73a7688e48$var$isDefined(path) {
    return path.split('.').reduce((object, pathPart)=>{
        return object && object[pathPart] ? object[pathPart] : null;
    }, window);
}
const $28507a73a7688e48$var$lines = {};
function $28507a73a7688e48$var$logOnce(message) {}
function $28507a73a7688e48$export$d2adf65b87e47523() {
    for(const key in $28507a73a7688e48$var$lines)delete $28507a73a7688e48$var$lines[key];
}
function $28507a73a7688e48$export$88d492d47be57a7e({ listener: listener, globalProperty: globalProperty, interval: interval = 250 }, callback) {
    if ($28507a73a7688e48$var$isDefined(globalProperty)) {
        $28507a73a7688e48$var$logOnce(`window.${globalProperty} is already available for use by ${listener}.`);
        callback();
        return null;
    }
    const waitForGlobalInterval = setInterval(()=>{
        $28507a73a7688e48$var$logOnce(`${listener} is waiting for window.${globalProperty} to be available`);
        if ($28507a73a7688e48$var$isDefined(globalProperty)) {
            $28507a73a7688e48$var$logOnce(`window.${globalProperty} now available!`);
            clearInterval(waitForGlobalInterval);
            callback();
        }
    }, interval);
}
module.exports["waitForGlobal"] = $28507a73a7688e48$export$88d492d47be57a7e;

});

parcelRegister("6OEkb", function(module, exports) {

var $7br77 = parcelRequire("7br77");


var $lWOeJ = parcelRequire("lWOeJ");


var $2GT4I = parcelRequire("2GT4I");


var $dOBRD = parcelRequire("dOBRD");


var $86okN = parcelRequire("86okN");


var $hp2SH = parcelRequire("hp2SH");


var $gKr8t = parcelRequire("gKr8t");


var $ge2sX = parcelRequire("ge2sX");

// Fragments for reading cached page title from different GraphQL types
const $5e2eb46b901e6cea$var$PTPageTitleFragment = (0, $2GT4I.default);
const $5e2eb46b901e6cea$var$ContentTitleFragment = (0, $lWOeJ.default);
const $5e2eb46b901e6cea$var$SearchConfluencePageBlogAttachmentTitleFragment = (0, $7br77.default);
var $5e2eb46b901e6cea$var$Client = /*#__PURE__*/ function(Client) {
    Client["CC_GRAPHQL"] = "Cc graphql client";
    Client["AGG_GRAPHQL"] = "Agg graphql client";
    return Client;
}($5e2eb46b901e6cea$var$Client || {});
const $5e2eb46b901e6cea$var$FRAGMENTS_BY_TYPE = [
    {
        // Page tree stores pages as PTPage
        client: "Cc graphql client",
        gqlType: 'PTPage',
        fragment: $5e2eb46b901e6cea$var$PTPageTitleFragment
    },
    {
        // Current page, pages from Recents, Home's Discover feed, etc.
        client: "Cc graphql client",
        gqlType: 'Content',
        fragment: $5e2eb46b901e6cea$var$ContentTitleFragment
    },
    {
        // Search query uses AGG graphql client
        client: "Agg graphql client",
        gqlType: 'SearchConfluencePageBlogAttachment',
        fragment: $5e2eb46b901e6cea$var$SearchConfluencePageBlogAttachmentTitleFragment
    }
];
const $5e2eb46b901e6cea$export$3726046076a35f2c = (0, $dOBRD.default)((contentId)=>{
    if (!contentId) return {
        title: undefined,
        source: undefined
    };
    const cloudId = (0, $ge2sX.getCloudId)();
    const ccGqlClient = (0, $hp2SH.getApolloClient)();
    const aggGqlClient = (0, $gKr8t.getAGGClient)();
    const clientMap = {
        ["Cc graphql client"]: ccGqlClient,
        ["Agg graphql client"]: aggGqlClient
    };
    let title;
    let source;
    $5e2eb46b901e6cea$var$FRAGMENTS_BY_TYPE.some(({ client: client, gqlType: gqlType, fragment: fragment })=>{
        // readFragment throws an error if it finds the item in the cache without both id and subtype, so we wrap in try/catch
        try {
            let id = `${gqlType}:${contentId}`;
            if (gqlType === 'SearchConfluencePageBlogAttachment') // Search graphql query includes the ARI in the id
            id = `${gqlType}:ari:cloud:confluence:${cloudId}:page/${contentId}`;
            // This approach is duplicated in /confluence/next/packages/live-pages-utils/src/getCachedPageData.ts
            // and should be migrated to readFragmentInterop.
            const fragmentData = clientMap[client].readFragment({
                id: id,
                fragment: (0, $86okN.toDocumentNode)(fragment)
            });
            if (fragmentData?.title) {
                title = fragmentData.title;
                source = gqlType;
                return true;
            }
        } catch  {
        // Fragment not found in cache, continue to next type
        }
        return false;
    });
    return {
        title: title,
        source: source
    };
});
module.exports["getCachedPageTitle"] = $5e2eb46b901e6cea$export$3726046076a35f2c;

});

parcelRegister("7br77", function(module, exports) {
/**
 * @generated SignedSource<<f48f782f9c911bcc733df803c321c344>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4e54bf7229bfc419$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageTitle_SearchTitleFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        }
    ],
    "type": "SearchConfluencePageBlogAttachment"
};
$4e54bf7229bfc419$var$node.hash = "d90150d434d564e9cfbe7d4d09a5bba7";
var $4e54bf7229bfc419$export$2e2bcd8739ae039 = $4e54bf7229bfc419$var$node;
module.exports["default"] = $4e54bf7229bfc419$export$2e2bcd8739ae039;

});

parcelRegister("lWOeJ", function(module, exports) {
/**
 * @generated SignedSource<<fada755ffc7229141a13c0afef22ac62>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c1d105b77e8b3188$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageTitle_ContentTitleFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        }
    ],
    "type": "Content"
};
$c1d105b77e8b3188$var$node.hash = "1115adb3266e3c279996feed3d6fdcd5";
var $c1d105b77e8b3188$export$2e2bcd8739ae039 = $c1d105b77e8b3188$var$node;
module.exports["default"] = $c1d105b77e8b3188$export$2e2bcd8739ae039;

});

parcelRegister("2GT4I", function(module, exports) {
/**
 * @generated SignedSource<<39992b74f5a2b25523dc77cb4acc3409>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d72376c6388be165$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageTitle_PageTreeTitleFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "title"
        }
    ],
    "type": "PTPage"
};
$d72376c6388be165$var$node.hash = "5ea3936d33c7a82bf109180867502c4b";
var $d72376c6388be165$export$2e2bcd8739ae039 = $d72376c6388be165$var$node;
module.exports["default"] = $d72376c6388be165$export$2e2bcd8739ae039;

});

parcelRegister("gKr8t", function(module, exports) {

var $9B4fQ = parcelRequire("9B4fQ");


var $10d5H = parcelRequire("10d5H");


var $7G1r9 = parcelRequire("7G1r9");


var $2bfWW = parcelRequire("2bfWW");


var $cC0P5 = parcelRequire("cC0P5");


var $adWn1 = parcelRequire("adWn1");


var $9jPdT = parcelRequire("9jPdT");




var $iMHGI = parcelRequire("iMHGI");


var $8xqRi = parcelRequire("8xqRi");


var $3cnNA = parcelRequire("3cnNA");



var $11MAl = parcelRequire("11MAl");


var $5c4nm = parcelRequire("5c4nm");

let $6d0c6b833ab477dd$var$apolloClient = null;
const $6d0c6b833ab477dd$var$wrappedFetch = (0, $iMHGI.createWrappedFetch)({
    isForAggOnly: true
});
const $6d0c6b833ab477dd$export$ed315e0c0d70f648 = 'agg';
const $6d0c6b833ab477dd$var$fragmentMatcher = new (0, $cC0P5.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: {
        __schema: {
            types: (0, (/*@__PURE__*/$parcel$interopDefault($adWn1)))
        }
    }
});
const $6d0c6b833ab477dd$export$8ddb56c88a6a3feb = new (0, $5c4nm.BroadcastConfigurableInMemoryCache)({
    fragmentMatcher: $6d0c6b833ab477dd$var$fragmentMatcher
});
const $6d0c6b833ab477dd$export$73fc90876f9d2053 = ()=>{
    $6d0c6b833ab477dd$var$apolloClient = null;
};
const $6d0c6b833ab477dd$export$13fdb03e350a572c = ()=>{
    // Use mock gateway Apollo client in tests
    if (window.MOCK_GATEWAY_APOLLO_CLIENT) return window.MOCK_GATEWAY_APOLLO_CLIENT;
    if (!$6d0c6b833ab477dd$var$apolloClient) {
        $6d0c6b833ab477dd$var$apolloClient = $6d0c6b833ab477dd$var$createApolloClient();
        window.GLOBAL_APOLLO_AGG_CLIENT = $6d0c6b833ab477dd$var$apolloClient;
    }
    return $6d0c6b833ab477dd$var$apolloClient;
};
const $6d0c6b833ab477dd$var$createLinks = ()=>{
    const links = [
        (0, $9jPdT.createOnErrorLink)()
    ];
    const subscriptionLinks = [];
    links.push((0, $11MAl.SSRClientLink)($6d0c6b833ab477dd$export$ed315e0c0d70f648, $6d0c6b833ab477dd$export$8ddb56c88a6a3feb));
    subscriptionLinks.push((0, $3cnNA.AttachExtensionsLink));
    subscriptionLinks.push((0, $8xqRi.getAGGWebSocketLinkInstance)());
    links.push(new (0, $2bfWW.HttpLink)({
        credentials: 'include',
        uri: '/gateway/api/graphql',
        fetch: $6d0c6b833ab477dd$var$wrappedFetch
    }));
    return (0, $10d5H.split)(// Condition for handling subscriptions
    // we don't want to use subscriptions in SSR mode
    ({ query: query })=>{
        const definition = (0, $7G1r9.getMainDefinition)(query);
        return definition?.kind === 'OperationDefinition' && definition?.operation === 'subscription' && // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        true;
    }, // WebSocket link for subscriptions
    (0, $10d5H.from)(subscriptionLinks), // HTTP link for non-subscription operations
    (0, $10d5H.from)(links));
};
const $6d0c6b833ab477dd$var$createApolloClient = ()=>{
    if (typeof window['__APOLLO_AGG_STATE__'] === 'object') $6d0c6b833ab477dd$export$8ddb56c88a6a3feb.restore(window['__APOLLO_AGG_STATE__']);
    const client = new (0, $9B4fQ.ApolloClient)({
        // Prevent cache and network query to refresh when they are already preloaded on server-side.
        // Refreshing data will cause component to fallback to loading state.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        ssrMode: Boolean(undefined),
        connectToDevTools: false,
        link: (0, $10d5H.from)([
            $6d0c6b833ab477dd$var$createLinks()
        ]),
        cache: $6d0c6b833ab477dd$export$8ddb56c88a6a3feb
    });
    // This is not actual API from Apollo. This field is read in next/packages/ssr-app/src/module-replacements/apollo-client.js
    client.__isAGGClient = true;
    return client;
};
module.exports["apolloAGGCache"] = $6d0c6b833ab477dd$export$8ddb56c88a6a3feb;
module.exports["getAGGClient"] = $6d0c6b833ab477dd$export$13fdb03e350a572c;

});

parcelRegister("8xqRi", function(module, exports) {

var $4cvLo = parcelRequire("4cvLo");

function $aa9065bb91596100$export$91893b414ff080f2() {
    let WEBSOCKET_URL;
    WEBSOCKET_URL = `wss://${window?.location?.host}/gateway/api/graphql/subscriptions`;
    return WEBSOCKET_URL;
}
let $aa9065bb91596100$var$wsLink;
function $aa9065bb91596100$export$4b71fe053d09625a() {
    const WEBSOCKET_URL = $aa9065bb91596100$export$91893b414ff080f2();
    if (!$aa9065bb91596100$var$wsLink) $aa9065bb91596100$var$wsLink = new (0, $4cvLo.GraphQLWSLink)({
        url: ()=>{
            return WEBSOCKET_URL;
        },
        shouldRetry: ()=>{
            return true;
        },
        keepAlive: (0, $4cvLo.KEEP_ALIVE),
        retryAttempts: 5
    });
    return $aa9065bb91596100$var$wsLink;
}
module.exports["getAGGWebSocketLinkInstance"] = $aa9065bb91596100$export$4b71fe053d09625a;

});

parcelRegister("4cvLo", function(module, exports) {

var $bKqeQ = parcelRequire("bKqeQ");


var $10d5H = parcelRequire("10d5H");


var $bPh6H = parcelRequire("bPh6H");


var $422HI = parcelRequire("422HI");


var $04e9M = parcelRequire("04e9M");


var $dbZMH = parcelRequire("dbZMH");


var $ac4MN = parcelRequire("ac4MN");


var $bBofs = parcelRequire("bBofs");

const $fca9c472df15863c$export$e9ff5bb5c39478ed = 600000;
class $fca9c472df15863c$export$b26b2f8eae2af9a extends (0, $10d5H.ApolloLink) {
    request(operation) {
        // Add null check for operation.getContext to prevent "Cannot read properties of undefined" errors
        const context = operation.getContext?.() || {};
        // context is coming from a previous link since we are using apollo v2
        // subscriptions does not have context or extensions in some cases
        return new (0, $10d5H.Observable)((observer)=>{
            const subscription = this.client.subscribe({
                ...operation,
                query: (0, $bPh6H.print)(operation.query),
                extensions: context?.extensions
            }, {
                next: (result)=>{
                    // Transform null data to empty object
                    const transformedResult = {
                        ...result,
                        data: result.data === null ? {} : result.data
                    };
                    observer.next(transformedResult);
                },
                complete: observer.complete.bind(observer),
                error: (err)=>{
                    if (this.closedInfo && !this.closedInfo?.wasClean && !err?.message) (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                        client.sendOperationalEvent({
                            source: 'confluence-AGGWebSocketLink',
                            actionSubject: 'webSocket',
                            action: 'closed-socket-error',
                            attributes: {
                                reason: this.closedInfo?.reason,
                                code: this.closedInfo?.code,
                                wasClean: this.closedInfo?.wasClean
                            }
                        });
                    });
                    if (err instanceof Error) return observer.error(err);
                    return observer.error(new (0, $422HI.ApolloErrorInterop)({
                        graphQLErrors: Array.isArray(err) ? err : [
                            err
                        ]
                    }));
                }
            });
            // keep track of the subscription so we can unsubscribe later
            this.replayQueries[operation.operationName] = {
                unsubscribe: subscription,
                query: (0, $bPh6H.print)(operation.query)
            };
            return subscription;
        });
    }
    constructor(options){
        super();
        this.client = void 0;
        this.internetConnectionState = 'healthy';
        this.timedOut = null;
        this.closedInfo = null;
        this.replayQueries = {};
        this.currentGetInternetConnectionStatePromise = null;
        this.onConnected = (_socket, _payload, wasRetry)=>{
            (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                client.sendOperationalEvent({
                    source: 'confluence-AGGWebSocketLink',
                    actionSubject: 'webSocket',
                    action: wasRetry ? 'reconnected' : 'connected'
                });
            });
        };
        this.verifyAndUpdateInternetHealth = async ()=>{
            this.currentGetInternetConnectionStatePromise = this.currentGetInternetConnectionStatePromise || (0, $dbZMH.getInternetConnectionState)();
            const internetHealthState = await this.currentGetInternetConnectionStatePromise;
            this.internetConnectionState = internetHealthState;
            this.currentGetInternetConnectionStatePromise = null;
        };
        this.verifyAndUpdateInternetHealthUntilHealthy = async ()=>{
            await this.verifyAndUpdateInternetHealth();
            if (this.internetConnectionState === 'healthy') return;
            else this.client?.terminate();
            await new Promise((resolve)=>{
                setTimeout(resolve, 500);
            });
            return this.verifyAndUpdateInternetHealthUntilHealthy();
        };
        this.retryWait = async (retries)=>{
            const retryDelayRange = await (0, $ac4MN.getDelayRangeFromGraphqlWebsocketState)(retries);
            // This is the logic reused from legacy WebSocket with a check verifyAndUpdateInternetHealthUntilHealthy
            // If the internet connection is healthy then we can retry, otherwise we do not need to retry
            // We subtract the time spent waiting to reconnect from the exponential backoff
            const startedAt = Date.now();
            await this.verifyAndUpdateInternetHealthUntilHealthy();
            // since we took some time to verify internet health, reduce the exponential backoff
            const msCheckingInternetHealth = Date.now() - startedAt;
            const retryDelay = (0, $ac4MN.getBackOffDelay)({
                range: retryDelayRange,
                timeSpent: msCheckingInternetHealth
            });
            // monitor status looks at if a user is idle or hidden to determine the retry delay
            await new Promise((resolve)=>{
                let timeoutId = setTimeout(resolve, retryDelay);
                const newRetryDelayRange = (0, $bBofs.calculateBackOffRange)({
                    status: 'active',
                    attemptsCount: retries
                });
                const msAlreadyWaited = Date.now() - startedAt;
                const newRetryDelay = (0, $ac4MN.getBackOffDelay)({
                    range: newRetryDelayRange,
                    timeSpent: msAlreadyWaited
                });
                const actualReconnectionDelay = Math.max(newRetryDelay - msAlreadyWaited, 0);
                // Clear old timeout and set a new one with the updated delay
                clearTimeout(timeoutId);
                timeoutId = setTimeout(resolve, actualReconnectionDelay);
            });
        };
        this.client = (0, $bKqeQ.createClient)({
            ...options,
            retryWait: this.retryWait,
            on: {
                connected: this.onConnected,
                closed: (info)=>{
                    this.closedInfo = info;
                },
                ping: (received)=>{
                    if (!received /* sent */ ) this.timedOut = setTimeout(()=>{
                        // unsubscribe so that we can reconnect with new arguments
                        for(const key in this.replayQueries)// unsubscribes queries so that we can reconnect with new arguments
                        if (this.replayQueries[key]) {
                            this.replayQueries[key].unsubscribe();
                            delete this.replayQueries[key];
                        }
                        this.client.terminate();
                    }, $fca9c472df15863c$export$e9ff5bb5c39478ed / 2);
                },
                pong: (received)=>{
                    if (received && this.timedOut !== null) clearTimeout(this.timedOut);
                }
            }
        });
    }
}
module.exports["KEEP_ALIVE"] = $fca9c472df15863c$export$e9ff5bb5c39478ed;
module.exports["GraphQLWSLink"] = $fca9c472df15863c$export$b26b2f8eae2af9a;

});

parcelRegister("dbZMH", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/getInternetConnectionState.ts when we move to Relay.
 */ // partially copied from Trello modified to use confluences network check
const $3d23f6bbdf409903$export$ddfffe3f5c167fa6 = async ()=>{
    // we can early return unhealthy if offline for navigator, but we cant if onLine.
    // That's because you can be online, but be waiting for VPN connection or something
    // else that blocks actually allowing internet.
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (!navigator.onLine) return 'unhealthy';
    for(let i = 0; i < 3; i++){
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        if (!navigator.onLine) return 'unhealthy';
        // stagger it a little because of flakey VPN's and firewalls
        await new Promise((res)=>setTimeout(res, 1000));
    }
    // we got 3 good attempts, safe to say healthy
    return 'healthy';
};
module.exports["getInternetConnectionState"] = $3d23f6bbdf409903$export$ddfffe3f5c167fa6;

});

parcelRegister("ac4MN", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/getBackOffDelay.ts when we move to Relay.
 */ // copied from Trello

var $bBofs = parcelRequire("bBofs");

function $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(start, end) {
    const spread = end - start;
    return Math.floor(start + Math.random() * spread);
}
const $5a87cb4548ea235b$export$73e02b3a26ecb0d7 = ({ range: range, timeSpent: timeSpent = 0 })=>{
    const [lowerBound, upperBound] = range;
    const delay = $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(lowerBound, upperBound);
    return Math.max(delay - timeSpent, 0);
};
const $5a87cb4548ea235b$export$ac8ba6656a385f56 = async (retries)=>{
    /**
	 * We're overriding the status multipliers here to make the reconnection
	 * back-off less aggressive. To reduce client
	 * reconnect load on graphql-subscriptions.
	 * The default status multipliers are: { active: 1, idle: 10 }.
	 */ const activeMultiplier = 1;
    let status = 'idle';
    if (typeof window !== 'undefined') // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    status = document.visibilityState === 'visible' ? 'active' : 'idle';
    else status = 'idle';
    return (0, $bBofs.calculateBackOffRange)({
        status: status,
        attemptsCount: retries,
        statusMultipliersOverride: {
            active: activeMultiplier,
            idle: 10
        }
    });
};
module.exports["getBackOffDelay"] = $5a87cb4548ea235b$export$73e02b3a26ecb0d7;
module.exports["getDelayRangeFromGraphqlWebsocketState"] = $5a87cb4548ea235b$export$ac8ba6656a385f56;

});

parcelRegister("bBofs", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/calculateBackOffRange.ts when we move to Relay.
 */ // copied from Trello

var $11y02 = parcelRequire("11y02");

function $35212ac5bc2e900f$export$de85ae9dfb4a57bc({ status: status, attemptsCount: attemptsCount, statusMultipliersOverride: statusMultipliersOverride, jitterStatusMultipliersOverride: jitterStatusMultipliersOverride, connectionHealth: connectionHealth = 'base', baseLowerBoundOverride: baseLowerBoundOverride, baseUpperBoundOverride: baseUpperBoundOverride, maxDelayOverride: maxDelayOverride }) {
    const [baseLowerBound, baseUpperBound] = (0, $11y02.getReconnectDelayBounds)(connectionHealth);
    const maxDelay = maxDelayOverride ?? (0, $11y02.getMaxDelay)({
        status: status,
        connectionHealth: connectionHealth
    });
    const statusMultipliers = statusMultipliersOverride ?? (0, $11y02.getDefaultStatusMultipliers)();
    const jitterStatusMultipliers = jitterStatusMultipliersOverride ?? (0, $11y02.jitterStatusMultipliers);
    const attemptsMultiplier = Math.pow(2, attemptsCount);
    const totalMultiplier = statusMultipliers[status] * attemptsMultiplier;
    const jitterMultiplier = jitterStatusMultipliers[status];
    const maxFirstActiveDelay = 2000;
    const maxFirstIdleDelay = 60000;
    let tempUpperOverride;
    if (attemptsCount > 0) tempUpperOverride = undefined;
    else if (status === 'active') tempUpperOverride = maxFirstActiveDelay;
    else tempUpperOverride = maxFirstIdleDelay;
    const lowerBound = (baseLowerBoundOverride ?? baseLowerBound) * totalMultiplier;
    const upperBound = tempUpperOverride ?? (baseUpperBoundOverride ?? baseUpperBound) * totalMultiplier * jitterMultiplier;
    return [
        Math.min(lowerBound, maxDelay),
        Math.min(upperBound, maxDelay)
    ];
}
module.exports["calculateBackOffRange"] = $35212ac5bc2e900f$export$de85ae9dfb4a57bc;

});

parcelRegister("11y02", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/backOffConfig.ts when we move to Relay.
 */ // copied from Trello
const $0b8d464841156fc9$var$TEN_MINUTES_IN_MS = 600000;
const $0b8d464841156fc9$export$d89658363be37383 = ({ status: status, connectionHealth: connectionHealth })=>{
    const maxDelays = {
        active: {
            base: 64000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        },
        idle: {
            base: 450000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        }
    };
    return maxDelays[status][connectionHealth];
};
const $0b8d464841156fc9$export$1b131e77a0e75a0a = ()=>({
        active: 1,
        idle: 15
    });
const $0b8d464841156fc9$export$a1d6d3ff41cd93e9 = {
    active: 1,
    idle: 2
};
const $0b8d464841156fc9$export$e5680a2329370bd3 = (connectionHealth)=>{
    const bounds = {
        base: [
            800,
            2000
        ],
        serverIncident: [
            800,
            4000
        ]
    };
    return bounds[connectionHealth];
};
module.exports["getMaxDelay"] = $0b8d464841156fc9$export$d89658363be37383;
module.exports["getDefaultStatusMultipliers"] = $0b8d464841156fc9$export$1b131e77a0e75a0a;
module.exports["jitterStatusMultipliers"] = $0b8d464841156fc9$export$a1d6d3ff41cd93e9;
module.exports["getReconnectDelayBounds"] = $0b8d464841156fc9$export$e5680a2329370bd3;

});

parcelRegister("3cnNA", function(module, exports) {

var $10d5H = parcelRequire("10d5H");

const $eb414ef0fc36a486$export$51a2bb897a605125 = new (0, $10d5H.ApolloLink)((operation, forward)=>{
    if (operation.variables && operation.variables.__extensions) {
        operation.setContext({
            extensions: operation.variables.__extensions
        });
        // remove the property since it's not an actual valid variable
        delete operation.variables.__extensions;
    }
    return forward(operation);
});
module.exports["AttachExtensionsLink"] = $eb414ef0fc36a486$export$51a2bb897a605125;

});

parcelRegister("bRTjQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iTJtk = parcelRequire("iTJtk");


var $3d3WW = parcelRequire("3d3WW");


var $9wGTI = parcelRequire("9wGTI");


var $3jwuS = parcelRequire("3jwuS");


var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");


var $2SowE = parcelRequire("2SowE");

const $4c66dfa08a03eed2$var$handleOnProseMirrorRendered = (onProseMirrorRendered, eventAttributes)=>{
    if (onProseMirrorRendered && typeof onProseMirrorRendered === 'function') {
        const clientRouteStart = performance.getEntriesByName('browser-metric.start').pop()?.startTime;
        const proseMirrorRenderedTimestamp = (0, $2SowE.getProseMirrorFMPTimestamp)(eventAttributes?.startTime, eventAttributes?.duration);
        const proseMirrorRenderedFMP = typeof clientRouteStart !== 'undefined' && typeof proseMirrorRenderedTimestamp !== 'undefined' ? Math.round(proseMirrorRenderedTimestamp - clientRouteStart) : proseMirrorRenderedTimestamp;
        onProseMirrorRendered({
            ...eventAttributes,
            proseMirrorRenderedFMP: proseMirrorRenderedFMP,
            proseMirrorRenderedTimestamp: proseMirrorRenderedTimestamp
        });
    }
};
const $4c66dfa08a03eed2$export$2d1d97ac8c5e1e6f = (props)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { edition: edition, environment: environment } = (0, $bQm3c.useSessionData)() || {};
    // setting default to development so in tests it doesn't fail due to being undefined
    const safeEnvironment = environment || 'DEVELOPMENT';
    const { contentId: contentId, contentType: contentType, children: children, source: source, collabService: collabService, onProseMirrorRendered: onProseMirrorRendered, isGuest: isGuest, touchpointId: touchpointId } = props;
    const handleEvent = (0, $cozmU.useCallback)((event)=>{
        const instanceName = safeEnvironment;
        if (event?.payload?.action === 'proseMirrorRendered') $4c66dfa08a03eed2$var$handleOnProseMirrorRendered(onProseMirrorRendered, event?.payload?.attributes);
        event.update((payload)=>{
            const isCommentEvent = payload.attributes && payload.attributes.appearance === 'comment';
            // WS-3190 If this is a comment event use the existing objectId as it correlates to the commentId
            let newPayload = (0, $2SowE.extendPayloadAttributes)(payload, {
                objectId: isCommentEvent ? payload.attributes.objectId : contentId,
                editorSource: source
            });
            if (instanceName) newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, {
                instance: instanceName
            });
            newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, {
                collabService: collabService ?? 'none',
                ...(0, $9wGTI.fg)('confluence_editor_content_type_analytics') && {
                    contentType: contentType
                },
                isLivePage: isLivePage,
                edition: edition,
                spaceId: spaceId
            });
            if (isGuest !== undefined) newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, {
                isGuest: isGuest
            });
            if (touchpointId) newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, {
                touchpointId: touchpointId
            });
            newPayload.source = source || 'unknown';
            if (event.context) {
                const attributesFromContext = (0, $2SowE.extractAttributesFromContext)(event.context);
                newPayload.attributes = {
                    ...newPayload.attributes,
                    ...attributesFromContext
                };
            }
            return newPayload;
        });
    }, [
        contentId,
        contentType,
        source,
        collabService,
        onProseMirrorRendered,
        edition,
        safeEnvironment,
        isLivePage,
        spaceId,
        isGuest,
        touchpointId
    ]);
    const handleFabricElementsEvents = (0, $cozmU.useCallback)((event)=>{
        event.update((payload)=>{
            return (0, $2SowE.extendPayloadAttributes)(payload, {
                pageType: contentType,
                editorSource: source,
                objectId: contentId,
                objectType: contentType,
                spaceId: spaceId,
                isLivePage: isLivePage
            });
        });
    }, [
        contentId,
        contentType,
        source,
        isLivePage,
        spaceId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: handleEvent,
        channel: (0, $iTJtk.FabricChannel).editor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: handleFabricElementsEvents,
        channel: (0, $iTJtk.FabricChannel).elements
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: handleFabricElementsEvents,
        channel: (0, $iTJtk.FabricChannel).media
    }, children)));
};
module.exports["EditorAnalyticsListener"] = $4c66dfa08a03eed2$export$2d1d97ac8c5e1e6f;

});

parcelRegister("2SowE", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ function $3c96f0e6009ebcf8$export$dc64ca688fb64c26(payload, newAttributes) {
    return {
        ...payload,
        attributes: {
            ...payload.attributes,
            ...newAttributes
        }
    };
}
const $3c96f0e6009ebcf8$export$a9a68a8b41555f13 = (startTime, duration)=>{
    return Number.isFinite(startTime) && Number.isFinite(duration) ? Math.round(startTime + duration) : undefined;
};
const $3c96f0e6009ebcf8$export$7ed9e23d68ab9aa6 = (context)=>{
    return context.filter((obj)=>obj.attributes && typeof obj.attributes === 'object' && !Array.isArray(obj.attributes)).reduce((acc, obj)=>({
            ...acc,
            ...obj.attributes
        }), {});
};
module.exports["extendPayloadAttributes"] = $3c96f0e6009ebcf8$export$dc64ca688fb64c26;
module.exports["getProseMirrorFMPTimestamp"] = $3c96f0e6009ebcf8$export$a9a68a8b41555f13;
module.exports["extractAttributesFromContext"] = $3c96f0e6009ebcf8$export$7ed9e23d68ab9aa6;

});

parcelRegister("foQ4a", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $19052bf55936e796$export$e581bd1f88227e0a = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isExternalCollaborator: accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
    };
};
module.exports["useIsExternalCollaborator"] = $19052bf55936e796$export$e581bd1f88227e0a;

});

parcelRegister("2xS8W", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $w6R6I = parcelRequire("w6R6I");


var $1d2ww = parcelRequire("1d2ww");


var $3mVfX = parcelRequire("3mVfX");


var $aHcFH = parcelRequire("aHcFH");


var $6mKj3 = parcelRequire("6mKj3");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $fNzRA = parcelRequire("fNzRA");


var $ep3mz = parcelRequire("ep3mz");


var $jAfH5 = parcelRequire("jAfH5");


var $aOKRX = parcelRequire("aOKRX");


var $niTts = parcelRequire("niTts");


var $l1B53 = parcelRequire("l1B53");


var $dL5YQ = parcelRequire("dL5YQ");

const $e3138de675756a06$var$styles = {
    stickyDraftViewPageWrapper: "_kqsw1if8 _1pbykb7n",
    stickyDraftLivePageWrapper: "_kqsw1n9t _1pbybfng",
    hiddenStyles: "_1e0cglyw",
    visibleStyles: "_1e0c1txw",
    commonStyle: "_4cvr1h6o _1bah1h6o _94n5ze3t _bfhkvuon",
    childWrapperStyle: "_1yt4pxbi _19pkidpf _2hwx1wug _otyridpf _18u01wug _1h6d1l7x _uwhke4h9 _15a5nqa1",
    zIndexStyle: "_1pby1kze _1ltvze3t _1bsb1osq"
};
const $e3138de675756a06$export$d2696a038fec0750 = (t0)=>{
    const $ = (0, $bDgLe.c)(54);
    const { pageWidthType: pageWidthType } = t0;
    const { expanded: expanded, isObjectCommentWrapperVisible: isObjectCommentWrapperVisible, footerEditorEntry: footerEditorEntry } = (0, $fNzRA.useObjectCommentContext)();
    const { expandCommentContainer: expandCommentContainer, setWrapperWidth: setWrapperWidth, setIsObjectCommentWrapperVisible: setIsObjectCommentWrapperVisible, setFooterEditorEntry: setFooterEditorEntry } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [objectCommentWrapperDimensions, setObjectCommentWrapperDimensions] = (0, $cozmU.useState)(null);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isViewPage = pageMode === (0, $cD1qu.PageMode).VIEW;
    const { width: pageContentWidth, left: pageContentLeft, right: pageContentRight } = (0, $aOKRX.usePageContentDimensions)();
    const { hasRecs: hasRecs } = (0, $jAfH5.usePageRecommendationData)();
    const { addFooterCommentAdf: addFooterCommentAdf } = (0, $3mVfX.useCommentsPanelState)();
    let t1;
    let t2;
    if ($[0] !== expandCommentContainer || $[1] !== expanded || $[2] !== isObjectCommentWrapperVisible || $[3] !== setFooterEditorEntry) {
        t1 = ()=>{
            if (isObjectCommentWrapperVisible && expanded) {
                expandCommentContainer();
                setFooterEditorEntry((0, $3mVfX.AddFooterCommentMode).FOOTER);
            }
        };
        t2 = [
            isObjectCommentWrapperVisible,
            expandCommentContainer,
            expanded,
            setFooterEditorEntry
        ];
        $[0] = expandCommentContainer;
        $[1] = expanded;
        $[2] = isObjectCommentWrapperVisible;
        $[3] = setFooterEditorEntry;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[6] !== isViewPage || $[7] !== setIsObjectCommentWrapperVisible || $[8] !== setWrapperWidth) {
        t3 = ()=>{
            let intersectionObserver = null;
            let resizeObserver = null;
            const calculateObjectCommentWrapperWidth = ()=>{
                const objectCommentWrapper = document.querySelector("[data-testid=\"object-comment-wrapper\"]");
                if (objectCommentWrapper) {
                    const rect = objectCommentWrapper.getBoundingClientRect();
                    setObjectCommentWrapperDimensions({
                        width: rect.width
                    });
                    setWrapperWidth(rect.width);
                }
            };
            const setupObservers = ()=>{
                const commentWrapper = document.querySelector("[data-testid=\"object-comment-wrapper\"]");
                if (!commentWrapper) {
                    setIsObjectCommentWrapperVisible(false);
                    return;
                }
                if (!intersectionObserver) {
                    intersectionObserver = new IntersectionObserver((t4)=>{
                        const [entry] = t4;
                        setIsObjectCommentWrapperVisible(entry.isIntersecting);
                    }, {
                        rootMargin: "0px"
                    });
                    intersectionObserver.observe(commentWrapper);
                }
                if (!resizeObserver) {
                    resizeObserver = new ResizeObserver(()=>{
                        calculateObjectCommentWrapperWidth();
                    });
                    resizeObserver.observe(commentWrapper);
                }
                calculateObjectCommentWrapperWidth();
            };
            setupObservers();
            const mutationObserver = new MutationObserver(()=>{
                const commentWrapper_0 = document.querySelector("[data-testid=\"object-comment-wrapper\"]");
                if (commentWrapper_0 && (!intersectionObserver || !isViewPage && !resizeObserver)) setupObservers();
            });
            mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
            return ()=>{
                if (intersectionObserver) intersectionObserver.disconnect();
                if (resizeObserver) resizeObserver.disconnect();
                mutationObserver.disconnect();
            };
        };
        $[6] = isViewPage;
        $[7] = setIsObjectCommentWrapperVisible;
        $[8] = setWrapperWidth;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== contentId || $[11] !== isViewPage || $[12] !== setIsObjectCommentWrapperVisible || $[13] !== setWrapperWidth) {
        t4 = [
            isViewPage,
            setWrapperWidth,
            setIsObjectCommentWrapperVisible,
            contentId
        ];
        $[10] = contentId;
        $[11] = isViewPage;
        $[12] = setIsObjectCommentWrapperVisible;
        $[13] = setWrapperWidth;
        $[14] = t4;
    } else t4 = $[14];
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[15] !== pageContentLeft || $[16] !== pageContentRight || $[17] !== pageContentWidth) {
        t5 = {
            width: pageContentWidth,
            left: pageContentLeft,
            right: pageContentRight
        };
        $[15] = pageContentLeft;
        $[16] = pageContentRight;
        $[17] = pageContentWidth;
        $[18] = t5;
    } else t5 = $[18];
    const pageContentDimensions = t5;
    let t6;
    if ($[19] !== pageWidthType) {
        t6 = ()=>{
            if (pageWidthType === undefined) return "100%";
            return JSON.parse(pageWidthType) === (0, $1d2ww.ContentAppearanceType).DEFAULT ? "1000px" : "unset";
        };
        $[19] = pageWidthType;
        $[20] = t6;
    } else t6 = $[20];
    const getMaxWidth = t6;
    let t7;
    if ($[21] !== getMaxWidth || $[22] !== hasRecs || $[23] !== isViewPage || $[24] !== objectCommentWrapperDimensions || $[25] !== pageMode || $[26] !== pageWidthType) {
        t7 = ()=>{
            if (isViewPage && (0, $6mKj3.expValEquals)("confluence_unify_footer_comments_space_width", "isEnabled", true)) {
                const computedWidths = (0, $aHcFH.getWidthAndMaxWidth)({
                    pageMode: pageMode,
                    pageWidthType: pageWidthType,
                    hasEndOfPageRecommendations: hasRecs ?? false
                });
                return {
                    width: computedWidths.width,
                    maxWidth: computedWidths.maxWidth
                };
            }
            return {
                maxWidth: isViewPage ? getMaxWidth() : "100%",
                width: !isViewPage && objectCommentWrapperDimensions ? `${objectCommentWrapperDimensions.width}px` : "100%"
            };
        };
        $[21] = getMaxWidth;
        $[22] = hasRecs;
        $[23] = isViewPage;
        $[24] = objectCommentWrapperDimensions;
        $[25] = pageMode;
        $[26] = pageWidthType;
        $[27] = t7;
    } else t7 = $[27];
    const getStyle = t7;
    const showStickyDraft = !isObjectCommentWrapperVisible && (addFooterCommentAdf || expanded) && footerEditorEntry !== (0, $3mVfX.AddFooterCommentMode).STICKY_DRAFT;
    let t8;
    if ($[28] !== expandCommentContainer || $[29] !== setFooterEditorEntry) {
        t8 = ()=>{
            expandCommentContainer();
            setFooterEditorEntry((0, $3mVfX.AddFooterCommentMode).STICKY_DRAFT);
        };
        $[28] = expandCommentContainer;
        $[29] = setFooterEditorEntry;
        $[30] = t8;
    } else t8 = $[30];
    const expandEditorHandler = t8;
    if (!showStickyDraft) return;
    const t9 = isViewPage ? $e3138de675756a06$var$styles.stickyDraftViewPageWrapper : $e3138de675756a06$var$styles.stickyDraftLivePageWrapper;
    const t10 = showStickyDraft ? $e3138de675756a06$var$styles.visibleStyles : $e3138de675756a06$var$styles.hiddenStyles;
    const t11 = !isViewPage && $e3138de675756a06$var$styles.zIndexStyle;
    let t12;
    if ($[31] !== t10 || $[32] !== t11 || $[33] !== t9) {
        t12 = (0, $w6R6I.cx)(t9, t10, $e3138de675756a06$var$styles.commonStyle, t11);
        $[31] = t10;
        $[32] = t11;
        $[33] = t9;
        $[34] = t12;
    } else t12 = $[34];
    let t13;
    if ($[35] !== pageContentDimensions || $[36] !== pageMode) {
        t13 = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $niTts.hideWhiteSpace)({
            shouldRenderFixedStyle: true,
            pageContentDimensions: pageContentDimensions
        }) : undefined;
        $[35] = pageContentDimensions;
        $[36] = pageMode;
        $[37] = t13;
    } else t13 = $[37];
    let t14;
    if ($[38] !== getStyle) {
        t14 = getStyle();
        $[38] = getStyle;
        $[39] = t14;
    } else t14 = $[39];
    const t15 = !showStickyDraft ? $e3138de675756a06$var$styles.hiddenStyles : $e3138de675756a06$var$styles.visibleStyles;
    let t16;
    if ($[40] !== t15) {
        t16 = (0, $w6R6I.cx)(t15);
        $[40] = t15;
        $[41] = t16;
    } else t16 = $[41];
    let t17;
    if ($[42] !== expandEditorHandler) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l1B53.DraftCommentBox), {
            expandPageCommentEditorHandler: expandEditorHandler
        });
        $[42] = expandEditorHandler;
        $[43] = t17;
    } else t17 = $[43];
    let t18;
    if ($[44] !== t16 || $[45] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dL5YQ.ObjectAddCommentProfileWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: t16
        }, t17)));
        $[44] = t16;
        $[45] = t17;
        $[46] = t18;
    } else t18 = $[46];
    let t19;
    if ($[47] !== t14 || $[48] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $e3138de675756a06$var$styles.childWrapperStyle,
            style: t14
        }, t18);
        $[47] = t14;
        $[48] = t18;
        $[49] = t19;
    } else t19 = $[49];
    let t20;
    if ($[50] !== t12 || $[51] !== t13 || $[52] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: t12,
            testId: "sticky-draft-comment-box",
            id: "addCommentButton-draft",
            style: t13
        }, t19);
        $[50] = t12;
        $[51] = t13;
        $[52] = t19;
        $[53] = t20;
    } else t20 = $[53];
    return t20;
};
module.exports["StickyDraftCommentContainer"] = $e3138de675756a06$export$d2696a038fec0750;

});

parcelRegister("jAfH5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $jtuBN = parcelRequire("jtuBN");


var $ep3mz = parcelRequire("ep3mz");


var $2HQyh = parcelRequire("2HQyh");


var $8dbvt = parcelRequire("8dbvt");

const $7e53ce3ad8fd4fef$export$1d93f080b8c40251 = (skip = false)=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const baseOptions = {
        variables: {
            type: 'page',
            id: contentId ?? '',
            exp: 'end_of_page_v5',
            key: spaceKey ?? '',
            keyString: spaceKey ?? ''
        },
        context: {
            single: true
        },
        errorPolicy: 'all',
        skip: skip
    };
    const { error: error, loading: loading, data: data } = (0, $6mKj3.expValEquals)('confluence_frontend_stop_watching_queries', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $2HQyh.default), {
        ...baseOptions,
        __callerPackage__: "page-recommendations"
    }) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)((0, $2HQyh.default), {
        ...baseOptions,
        __callerPackage__: "page-recommendations"
    });
    const pageCardData = (0, $cozmU.useMemo)(()=>(0, $8dbvt.transformAndOrderRecs)(data?.getRecommendedPages?.recommendedPages), [
        data
    ]);
    if (error || skip) return {
        loading: false,
        error: error,
        data: undefined,
        hasRecs: false
    };
    return {
        loading: loading,
        error: error,
        data: pageCardData,
        hasRecs: pageCardData && pageCardData.length > 2
    };
};
module.exports["usePageRecommendationData"] = $7e53ce3ad8fd4fef$export$1d93f080b8c40251;

});

parcelRegister("2HQyh", function(module, exports) {
/**
 * @generated SignedSource<<e56ee58f550eae496b45df46a24c2dad>>
 * @relayHash feae64578b0a3fba44f22230201969bb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d0f43d5f65a3508b994607eb8d4e91bf66495920ccf8c57a40fc1366d299272
const $5b8dbd4fd00aa380$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "exp"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "key"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "keyString"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "keyString"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v5 /*: any*/ 
        ]
    }, v7 = [
        {
            "kind": "Variable",
            "name": "entityId",
            "variableName": "id"
        },
        {
            "kind": "Variable",
            "name": "entityType",
            "variableName": "type"
        },
        {
            "kind": "Variable",
            "name": "experience",
            "variableName": "exp"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "title"
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v11 = {
        "kind": "ScalarField",
        "name": "creatorId"
    }, v12 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v14 = {
        "kind": "ScalarField",
        "name": "key"
    }, v15 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v14 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v16 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    v14 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v17 = {
        "kind": "ScalarField",
        "name": "strategy"
    }, v18 = {
        "concreteType": "RecommendedPagesStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "userCanToggle"
            },
            {
                "kind": "ScalarField",
                "name": "isEnabled"
            }
        ]
    }, v19 = {
        "args": [
            {
                "kind": "Variable",
                "name": "entityId",
                "variableName": "key"
            }
        ],
        "concreteType": "RecommendedPagesSpaceStatus",
        "kind": "LinkedField",
        "name": "getRecommendedPagesSpaceStatus",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "recommendedPagesEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "defaultBehavior"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EndOfPageRecommendationQuery",
            "selections": [
                v6 /*: any*/ ,
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "RecommendedPages",
                    "kind": "LinkedField",
                    "name": "getRecommendedPages",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "RecommendedPagesItem",
                            "kind": "LinkedField",
                            "name": "recommendedPages",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ 
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        v18 /*: any*/ 
                    ]
                },
                v19 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EndOfPageRecommendationQuery",
            "selections": [
                v6 /*: any*/ ,
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "RecommendedPages",
                    "kind": "LinkedField",
                    "name": "getRecommendedPages",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "RecommendedPagesItem",
                            "kind": "LinkedField",
                            "name": "recommendedPages",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ 
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        },
                        v18 /*: any*/ 
                    ]
                },
                v19 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "feae64578b0a3fba44f22230201969bb",
            "id": "5d0f43d5f65a3508b994607eb8d4e91bf66495920ccf8c57a40fc1366d299272",
            "metadata": {},
            "name": "EndOfPageRecommendationQuery",
            "operationKind": "query",
            "text": "query EndOfPageRecommendationQuery($type:String!,$id:ID!,$exp:String!,$key:ID!,$keyString:String!){space(key:$keyString){id},getRecommendedPages(entityType:$type,entityId:$id,experience:$exp){recommendedPages{content{id,title,type,subType,creatorId,links{webui},history{ownedBy{__typename,displayName}},space{id,key,name},emoji:properties(key:\"emoji-title-published\"){nodes{id,key,value}}},strategy},status{userCanToggle,isEnabled}},getRecommendedPagesSpaceStatus(entityId:$key){recommendedPagesEnabled,defaultBehavior}}"
        }
    };
}();
$5b8dbd4fd00aa380$var$node.hash = "89dc64ac31ebaadc798791741477c5f3";
var $5b8dbd4fd00aa380$export$2e2bcd8739ae039 = $5b8dbd4fd00aa380$var$node;
module.exports["default"] = $5b8dbd4fd00aa380$export$2e2bcd8739ae039;

});

parcelRegister("8dbvt", function(module, exports) {

var $cxMI6 = parcelRequire("cxMI6");

const $d8f8e39152f0bc27$export$19f6fc45ac74736 = (data, strategiesCounter)=>{
    const pageCardData = (0, $cxMI6.transformGlobalContent)(data.content);
    pageCardData.likesCount = 0;
    pageCardData.commentsCount = 0;
    pageCardData.recommendationStrategy = $d8f8e39152f0bc27$export$7c50bf2d337b5c51(data, strategiesCounter);
    return pageCardData;
};
const $d8f8e39152f0bc27$export$7c50bf2d337b5c51 = (data, strategiesCounter)=>{
    const strategies = data.strategy;
    if (strategies.includes('CONTENT_TO_CONTENT')) return 'CONTENT_TO_CONTENT';
    const currentCounter = new Map();
    strategies.forEach((entry)=>{
        const entryCount = strategiesCounter.get(entry) || 0;
        currentCounter.set(entry, entryCount);
    });
    const sortedCounter = new Map([
        ...currentCounter.entries()
    ].sort((a, b)=>a[1] - b[1]));
    const strategy = [
        ...sortedCounter.keys()
    ][0];
    const count = strategiesCounter.get(strategy) || 0;
    strategiesCounter.set(strategy, count + 1);
    return strategy;
};
const $d8f8e39152f0bc27$export$9c80c5ff7d0b31d7 = (recs)=>{
    if (!recs) return;
    const strategiesCounter = new Map();
    const recsSortedByStrategyCount = [
        ...recs
    ].sort((a, b)=>a.strategy.length > b.strategy.length ? 1 : -1);
    const transformedRecs = recsSortedByStrategyCount.map((rec)=>$d8f8e39152f0bc27$export$19f6fc45ac74736(rec, strategiesCounter));
    // return to initial order
    const pageCards = new Array();
    recs.forEach((rec)=>{
        const contentId = rec?.content?.id;
        if (!contentId) return;
        const el = transformedRecs.find((card)=>card?.id === contentId);
        if (el) pageCards.push(el);
    });
    return pageCards;
};
module.exports["transformEndOfPageRecContent"] = $d8f8e39152f0bc27$export$19f6fc45ac74736;
module.exports["transformAndOrderRecs"] = $d8f8e39152f0bc27$export$9c80c5ff7d0b31d7;

});

parcelRegister("cxMI6", function(module, exports) {

var $brn6e = parcelRequire("brn6e");


var $8rneB = parcelRequire("8rneB");


var $huWyw = parcelRequire("huWyw");


var $c7GB4 = parcelRequire("c7GB4");

const $c6273926c8df4325$var$ALL_CONTENT_TYPE = [
    'page',
    'blogpost',
    'whiteboard',
    'database',
    'embed',
    'folder',
    'slide'
];
const $c6273926c8df4325$var$resumeDraftWebUiBypass = (urlPath, content)=>{
    const bypassUrl = (0, $huWyw.getURLBypassingResumeDraftAction)({
        url: urlPath || '',
        spaceKey: content?.space?.alias || content?.space?.key || '',
        contentType: content?.type,
        editorVersion: content?.editorVersion?.nodes?.[0]?.value?.replace(/['"]+/g, ''),
        contentId: content?.id || '',
        noContextPath: true
    });
    return bypassUrl;
};
const $c6273926c8df4325$export$a0bd4958aceee288 = (content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent)=>{
    const EMOJI_CONTENT_TYPE = isWhiteboardEmojiFGEnabled ? [
        'page',
        'blogpost',
        'embed',
        'whiteboard',
        'slide'
    ] : [
        'page',
        'blogpost',
        'embed'
    ];
    const contentType = $c6273926c8df4325$var$ALL_CONTENT_TYPE.includes(content?.type) ? content.type : 'page';
    if (isActivityV3HomeRecent) return {
        id: (0, $c7GB4.getIdFromConfluenceContentAri)({
            ari: content?.id,
            resourceType: contentType
        }) || '',
        status: content?.status === 'draft' || content?.status === 'unpublished' ? content?.status : undefined,
        // @ts-expect-error TODO FIXME there is some deep null mismatch, which might be worth fixing
        title: (0, $brn6e.getTitleAndEmoji)(content?.title, content?.metadata?.titleEmojiPublished?.value || '', content?.metadata?.titleEmojiDraft?.value || '', content?.status, untitledDraftText, EMOJI_CONTENT_TYPE.includes(contentType)),
        type: contentType,
        subType: content?.subtype,
        editorVersion: content?.editorVersion,
        links: {
            editui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.editUi, content),
            webui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.webUi, content)
        },
        isStarred: content?.viewer?.favoritedSummary?.isFavorite || false,
        likesCount: content?.likesSummary?.count || 0,
        commentsCount: content?.commentCountSummary?.total || 0,
        excerpt: content?.body?.excerpt?.trim()
    };
    return {
        id: content?.id || '',
        status: content?.status === 'draft' || content?.status === 'unpublished' ? content?.status : undefined,
        // @ts-expect-error TODO FIXME there is some deep null mismatch, which might be worth fixing
        title: (0, $brn6e.getTitleAndEmoji)(content?.title, (0, $8rneB.getEmojiPublishedFromProperties)(content), (0, $8rneB.getEmojiDraftFromProperties)(content), content?.status, untitledDraftText, EMOJI_CONTENT_TYPE.includes(contentType)),
        type: contentType,
        subType: content?.subType,
        editorVersion: content?.editorVersion,
        links: {
            editui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.editui, content),
            webui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.webui, content)
        },
        isStarred: content?.metadata?.currentuser?.favourited?.isFavourite || false,
        likesCount: content?.likes?.count || 0,
        commentsCount: content?.metadata?.comments?.commentsCount || 0,
        excerpt: content?.excerpt?.trim(),
        lastAction: {
            when: content?.metadata?.lastModifiedDate || '',
            action: 'updated'
        }
    };
};
const $c6273926c8df4325$export$898674fde3fd0597 = (content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent = false)=>{
    const spaceAlias = content?.space?.alias || content?.space?.key;
    return {
        ...$c6273926c8df4325$export$a0bd4958aceee288(content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent),
        space: {
            spaceKey: spaceAlias || '',
            name: content?.space?.name || ''
        },
        creatorId: content?.creatorId || '',
        history: {
            ownedBy: {
                displayName: content?.history?.ownedBy?.displayName || ''
            }
        }
    };
};
const $c6273926c8df4325$export$1e1d4cb60561af2b = (content, untitledDraftText = '', isWhiteboardEmojiFGEnabled = false)=>{
    const createdBy = content?.status === 'draft' ? content?.version?.by : content?.history?.createdBy;
    const ownedBy = content?.status === 'draft' ? content?.version?.by : content?.history?.ownedBy;
    return {
        ...$c6273926c8df4325$export$a0bd4958aceee288(content, untitledDraftText, isWhiteboardEmojiFGEnabled),
        createdBy: {
            displayName: createdBy?.displayName || '',
            profilePicture: createdBy?.profilePicture?.path || '',
            accountId: createdBy?.accountId || ''
        },
        ownedBy: {
            displayName: ownedBy?.displayName || '',
            profilePicture: ownedBy?.profilePicture?.path || '',
            accountId: ownedBy?.accountId || ''
        }
    };
};
const $c6273926c8df4325$export$ee67d5d6f48183b0 = (card)=>Boolean(card.createdBy);
module.exports["transformGlobalContent"] = $c6273926c8df4325$export$898674fde3fd0597;
module.exports["transformSpaceContent"] = $c6273926c8df4325$export$1e1d4cb60561af2b;
module.exports["isSpacePageCard"] = $c6273926c8df4325$export$ee67d5d6f48183b0;

});

parcelRegister("brn6e", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $7PLO8 = parcelRequire("7PLO8");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $6mKj3 = parcelRequire("6mKj3");


var $3shHM = parcelRequire("3shHM");


var $8rneB = parcelRequire("8rneB");


var $5DJsZ = parcelRequire("5DJsZ");


var $5amrO = parcelRequire("5amrO");

const $a7a7184e7345058e$export$8807f1cb55bf77de = async ({ userId: userId, cloudId: cloudId, emojiId: emojiId })=>{
    const provider = await (0, $8rneB.getEmojiProvider)(cloudId, userId);
    if (provider) {
        const emoji = await provider.findById(emojiId);
        if (emoji) return provider.loadMediaEmoji(emoji);
    }
    return Promise.resolve(null);
};
const $a7a7184e7345058e$export$66e71aac8865f81a = /([a-z\d_-]+):/;
let $a7a7184e7345058e$var$hasSetFavicon = false;
let $a7a7184e7345058e$var$previousFavicon = null;
const $a7a7184e7345058e$var$updateFaviconHref = (href)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const favIcons = document.querySelectorAll("link[rel~='icon']");
    favIcons.forEach((linkEl)=>{
        // remember default favicon on first change in case we need to revert
        if (!$a7a7184e7345058e$var$hasSetFavicon) {
            $a7a7184e7345058e$var$previousFavicon = linkEl.href;
            $a7a7184e7345058e$var$hasSetFavicon = true;
        }
        linkEl.href = href;
    });
};
const $a7a7184e7345058e$export$4bb2c221b7e4cc0 = (emoji)=>{
    if (!(0, $ixfCV.fg)('confluence_emoji_title_favicon')) return;
    if (!emoji) {
        if ($a7a7184e7345058e$var$hasSetFavicon && $a7a7184e7345058e$var$previousFavicon) $a7a7184e7345058e$var$updateFaviconHref($a7a7184e7345058e$var$previousFavicon);
        return;
    }
    $a7a7184e7345058e$var$updateFaviconHref(emoji);
};
const $a7a7184e7345058e$export$ea48fb6f63107646 = async ({ selectedEmoji: selectedEmoji, emojiProvider: emojiProvider, onUpdateStartEmoji: onUpdateStartEmoji, createAnalyticsEvent: createAnalyticsEvent, emojiTitleState: emojiTitleState, onEmojiUpdated: onEmojiUpdated, onUpdateEndEmoji: onUpdateEndEmoji, updateContentProperty: updateContentProperty, contentId: contentId, componentName: componentName, isLivePage: isLivePage, emojiStatusFieldName: emojiStatusFieldName, aiSuggestedEmojiId: aiSuggestedEmojiId, isSmartCreate: isSmartCreate, hasReplacedAIFCEmoji: hasReplacedAIFCEmoji, setHasReplacedAIFCEmoji: setHasReplacedAIFCEmoji, aiEmojiSuggestionSource: aiEmojiSuggestionSource }, _event)=>{
    onUpdateStartEmoji && onUpdateStartEmoji();
    // Snapshot before overwrite to detect if the AIFC-suggested emoji was replaced.
    const previouslySelectedEmoji = emojiTitleState.state.selectedEmoji;
    const previouslySelectedEmojiId = typeof previouslySelectedEmoji === 'string' ? previouslySelectedEmoji : previouslySelectedEmoji?.id;
    const replacedAIFCSuggestedEmoji = !hasReplacedAIFCEmoji && !!isSmartCreate && !!aiSuggestedEmojiId && previouslySelectedEmojiId === aiSuggestedEmojiId;
    if (replacedAIFCSuggestedEmoji) setHasReplacedAIFCEmoji?.(true);
    const replacedBlankPageAutoSuggestedEmoji = !hasReplacedAIFCEmoji && aiEmojiSuggestionSource === 'pasteAutoTitle' && !!aiSuggestedEmojiId && previouslySelectedEmojiId === aiSuggestedEmojiId;
    if (replacedBlankPageAutoSuggestedEmoji) setHasReplacedAIFCEmoji?.(true);
    const replacedSuggestTitleSuggestedEmoji = !hasReplacedAIFCEmoji && aiEmojiSuggestionSource === 'suggestTitle' && !!aiSuggestedEmojiId && previouslySelectedEmojiId === aiSuggestedEmojiId;
    if (replacedSuggestTitleSuggestedEmoji) setHasReplacedAIFCEmoji?.(true);
    // Snapshot the shared flag at fire time so the value reflects the latest
    // state regardless of when/where the picker JSX was created.
    const justRestoredEmoji = !!emojiTitleState.justRestoredEmoji;
    (0, $3shHM.sendAnalyticsEvent)(createAnalyticsEvent, {
        eventType: 'sendUIEvent',
        element: 'button',
        action: 'clicked',
        actionSubject: 'emojiPicker',
        actionSubjectId: 'emoji',
        attributes: {
            emojiId: selectedEmoji?.id,
            inputMethod: 'title',
            isLivePage: isLivePage,
            replacedAIFCSuggestedEmoji: replacedAIFCSuggestedEmoji,
            replacedBlankPageAutoSuggestedEmoji: replacedBlankPageAutoSuggestedEmoji,
            replacedSuggestTitleSuggestedEmoji: replacedSuggestTitleSuggestedEmoji,
            aiEmojiSuggestionSource: aiEmojiSuggestionSource,
            isRestoreLatestEmojiEnabled: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_livedocs_restore_latest_emoji'),
            replacedRestoredEmoji: justRestoredEmoji
        }
    });
    // Reset after firing so the next selection correctly reports
    // replacedRestoredEmoji=false.
    emojiTitleState.justRestoredEmoji = false;
    const propertyKey = (0, $5amrO.convertEmojiFieldNameToPropertyKey)(emojiStatusFieldName);
    const loadedEmoji = await emojiProvider.loadMediaEmoji(selectedEmoji, true);
    emojiTitleState.setOpenSecondEmojiPicker(false);
    emojiTitleState.setSelectedEmoji(loadedEmoji);
    return onEmojiUpdated().then(({ data: data })=>{
        const versionNumber = (0, $8rneB.getVersionNumber)(data, emojiStatusFieldName);
        const newVersionNumber = versionNumber ? versionNumber + 1 : 1;
        const emojiValue = selectedEmoji?.id?.replace(/['"]+/g, '') ?? '';
        return updateContentProperty({
            propertyKey: propertyKey,
            propertyValue: emojiValue,
            hasExistingProperty: versionNumber > 0,
            options: {
                update: ()=>{
                    try {
                        const cacheData = (0, $l1uFv.readQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            __callerPackage__: "emoji-title"
                        });
                        if (cacheData.content.nodes[0][emojiStatusFieldName]) cacheData.content.nodes[0][emojiStatusFieldName].nodes[0] = {
                            ...cacheData.content.nodes[0][emojiStatusFieldName].nodes[0],
                            id: contentId,
                            key: propertyKey,
                            value: emojiValue,
                            version: {
                                number: newVersionNumber,
                                __typename: 'Version'
                            }
                        };
                        (0, $fEmGS.writeQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            data: data,
                            __callerPackage__: "emoji-title"
                        });
                    } catch (error) {
                        throw new Error(`${componentName} failed to write to cache while updating ${propertyKey} content property after user selecting emoji ${error.message}`);
                    }
                }
            },
            shouldOptimisticResponse: true
        }).then(()=>{
            onUpdateEndEmoji && onUpdateEndEmoji();
            emojiTitleState.setSelectedEmoji(loadedEmoji);
        }).catch((error)=>{
            throw new Error(`${componentName} failed to update ${propertyKey} content property after user selecting emoji ${error.message}`);
        });
    });
};
const $a7a7184e7345058e$export$fbfb144f0da80edc = (_event, { onUpdateStartEmoji: onUpdateStartEmoji, onUpdateEndEmoji: onUpdateEndEmoji, onEmojiUpdated: onEmojiUpdated, contentId: contentId, updateContentProperty: updateContentProperty, componentName: componentName = '', emojiStatusFieldName: emojiStatusFieldName })=>{
    onUpdateStartEmoji && onUpdateStartEmoji();
    const propertyKey = (0, $5amrO.convertEmojiFieldNameToPropertyKey)(emojiStatusFieldName);
    return onEmojiUpdated().then(()=>{
        return updateContentProperty({
            propertyKey: propertyKey,
            isDelete: true,
            options: {
                update: ()=>{
                    try {
                        const data = (0, $l1uFv.readQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            __callerPackage__: "emoji-title"
                        });
                        data.content.nodes[0][emojiStatusFieldName] = {
                            nodes: [],
                            __typename: 'PaginatedJsonContentPropertyList'
                        };
                        (0, $fEmGS.writeQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                skipPublishedFragment: true,
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                            },
                            data: data,
                            __callerPackage__: "emoji-title"
                        });
                    } catch (error) {
                        throw new Error(`${componentName} failed to write to cache while updating content property after user removing emoji ${error.message}`);
                    }
                }
            },
            shouldOptimisticResponse: true
        }).finally(()=>{
            onUpdateEndEmoji && onUpdateEndEmoji();
        }).catch((error)=>{
            throw new Error(`${componentName} failed to update ${propertyKey} content property after user removing emoji ${error.message}`);
        });
    });
};
const $a7a7184e7345058e$export$8c0236acf4c550c0 = RegExp("^(\\p{RI}\\p{RI}|\\p{Extended_Pictographic}(\\p{Emoji_Modifier}|\\u{FE0F}\\u{20E3}?|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?(\\u{200D}\\p{Extended_Pictographic}(\\p{Emoji_Modifier}|\\u{FE0F}\\u{20E3}?|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?)*)", "u");
const $a7a7184e7345058e$export$cb9bb843138d9261 = (title)=>title && title.replace($a7a7184e7345058e$export$8c0236acf4c550c0, '').trimLeft() || '';
const $a7a7184e7345058e$export$9d1875ac2476f6b6 = (title)=>title && $a7a7184e7345058e$export$8c0236acf4c550c0.exec(title)?.[0] || '';
const $a7a7184e7345058e$export$388f90f8e727e4d5 = (rawTitle = '', rawPublishedEmoji = '', rawDraftEmoji = '', status = '', untitledDraftText = '', getEmoji = true)=>{
    const nativeEmoji = getEmoji ? $a7a7184e7345058e$export$9d1875ac2476f6b6(rawTitle) : '';
    let selectedEmoji = '';
    if (getEmoji) selectedEmoji = status?.toLowerCase() === 'draft' ? rawDraftEmoji : rawPublishedEmoji;
    const hasNativeEmoji = nativeEmoji.length > 0;
    const hasSelectedEmoji = selectedEmoji.length > 0;
    const emoji = hasSelectedEmoji ? selectedEmoji : nativeEmoji;
    let text = hasNativeEmoji && !hasSelectedEmoji ? $a7a7184e7345058e$export$cb9bb843138d9261(rawTitle) : rawTitle;
    if (status === 'draft' && !text) text = untitledDraftText;
    return {
        text: text,
        emoji: emoji,
        selectedEmoji: selectedEmoji
    };
};
module.exports["getEmojiFromEmojiId"] = $a7a7184e7345058e$export$8807f1cb55bf77de;
module.exports["maybeOverrideFaviconWithEmoji"] = $a7a7184e7345058e$export$4bb2c221b7e4cc0;
module.exports["onSelectEmoji"] = $a7a7184e7345058e$export$ea48fb6f63107646;
module.exports["onRemoveEmoji"] = $a7a7184e7345058e$export$fbfb144f0da80edc;
module.exports["emojiExp"] = $a7a7184e7345058e$export$8c0236acf4c550c0;
module.exports["removeEmojiFromTitle"] = $a7a7184e7345058e$export$cb9bb843138d9261;
module.exports["getEmojiFromTitle"] = $a7a7184e7345058e$export$9d1875ac2476f6b6;
module.exports["getTitleAndEmoji"] = $a7a7184e7345058e$export$388f90f8e727e4d5;

});

parcelRegister("7PLO8", function(module, exports) {
const $3009aa09d1bfedbe$export$93a0fdadbf6c055a = ()=>{
    return new URLSearchParams(window.location.search.substring(1)).get('draftShareId') || '';
};
module.exports["getDraftShareIdFromQueryParam"] = $3009aa09d1bfedbe$export$93a0fdadbf6c055a;

});

parcelRegister("3shHM", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");


var $8rneB = parcelRequire("8rneB");


var $5amrO = parcelRequire("5amrO");


var $5DJsZ = parcelRequire("5DJsZ");

const $d6c558249b167bda$export$5e53520e517ec9ab = (createAnalyticsEvent, { eventType: eventType, element: element, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes = {} })=>{
    createAnalyticsEvent({
        type: eventType,
        data: {
            action: action,
            source: 'EmojiTitleSection',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                element: element,
                ...attributes
            }
        }
    }).fire();
};
const $d6c558249b167bda$export$1fa99c5c7c4cc530 = async ({ createAnalyticsEvent: createAnalyticsEvent, contentId: contentId, isLivePage: isLivePage })=>{
    const { data: data } = await (0, $c0rhi.queryInterop)({
        query: (0, $5DJsZ.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            skipPublishedFragment: false
        },
        __callerPackage__: "emoji-title"
    });
    const emojiId = (0, $8rneB.getEmojiId)(data, (0, $5amrO.EMOJI_TITLE_DRAFT_FIELD));
    const hasDraftEmoji = emojiId.length >= 0 && emojiId !== '';
    // only track draft with emoji
    if (hasDraftEmoji) $d6c558249b167bda$export$5e53520e517ec9ab(createAnalyticsEvent, {
        eventType: 'sendTrackEvent',
        element: '',
        action: 'created',
        actionSubject: 'draftWithEmoji',
        actionSubjectId: '',
        attributes: {
            emojiId: emojiId,
            isLivePage: isLivePage
        }
    });
};
const $d6c558249b167bda$export$5a8401d422e6e576 = ({ createAnalyticsEvent: createAnalyticsEvent, emoji: emoji, context: context, error: error = {
    message: ''
}, isLivePage: isLivePage })=>{
    $d6c558249b167bda$export$5e53520e517ec9ab(createAnalyticsEvent, {
        eventType: 'sendTrackEvent',
        element: 'emoji',
        action: 'error',
        actionSubject: 'renderEmoji',
        actionSubjectId: 'renderEmojiError',
        attributes: {
            emojiShortName: emoji && emoji.shortName,
            emojiId: emoji && emoji.id,
            context: context,
            errorMessage: error.message,
            isLivePage: isLivePage
        }
    });
};
module.exports["sendAnalyticsEvent"] = $d6c558249b167bda$export$5e53520e517ec9ab;
module.exports["trackDraftCreatedWithEmoji"] = $d6c558249b167bda$export$1fa99c5c7c4cc530;
module.exports["onFailedToLoadEmoji"] = $d6c558249b167bda$export$5a8401d422e6e576;

});

parcelRegister("8rneB", function(module, exports) {

var $kwzZh = parcelRequire("kwzZh");


var $32x2E = parcelRequire("32x2E");


var $5amrO = parcelRequire("5amrO");

const $61659933fe71a4ee$export$d2d37cdca5b73056 = (data, emojiFieldName)=>data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.version?.number || 0;
const $61659933fe71a4ee$export$4f65bc4b6ab2638 = (data, emojiFieldName)=>(data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$7f77dde40cb9b60a = (emojiValue)=>(emojiValue || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$var$transformProperty = (property)=>{
    if (property) return {
        propertyId: property?.id ?? '',
        value: (property?.value || '').replace(/['"]+/g, '').replace(/null/, ''),
        versionNumber: 'version' in property && property.version?.number || 0
    };
};
const $61659933fe71a4ee$var$findPropertyByKey = (object, key)=>$61659933fe71a4ee$var$transformProperty(object?.properties?.nodes?.find((node)=>node?.key === key));
const $61659933fe71a4ee$export$1b37039eb4b94aa5 = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-published');
const $61659933fe71a4ee$export$4d2921b7085d93bb = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-draft');
const $61659933fe71a4ee$export$f6641c501f8a1aee = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$e1cb12562674727b = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$db0acf1152e62ad6 = (data)=>((data?.content?.nodes?.[0] || data?.singleContent)?.emojiTitlePublished?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$a5b3ff94c918547 = (content)=>(content?.emoji?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$c4fe69c947489b89 = (content)=>(content?.emojiDraft?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$bb520a2176fa2873 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$fbf43d9e87015d93 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$b8852397200defa1 = (data, emojiFieldName)=>{
    let nodes;
    if (data && 'content' in data) nodes = data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0];
    else nodes = data?.emojiTitlePublished?.nodes?.[0];
    return !!nodes?.value && nodes?.value !== '""' && nodes?.value !== '"null"';
};
const $61659933fe71a4ee$export$496af73e8e85fd08 = (data)=>{
    return $61659933fe71a4ee$export$b8852397200defa1(data, 'emojiTitlePublished');
};
const $61659933fe71a4ee$export$53519180ca077ff2 = (data)=>$61659933fe71a4ee$export$b8852397200defa1(data, (0, $5amrO.EMOJI_TITLE_PUBLISHED_FIELD));
const $61659933fe71a4ee$export$8210f5f78c0bcf27 = async (cloudId, userId)=>{
    return await (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
        cloudId: cloudId,
        userId: userId
    });
};
var $61659933fe71a4ee$export$66d7571a7d7aad65 = /*#__PURE__*/ function(DefaultTitleEmojiValues) {
    DefaultTitleEmojiValues["LIVE_PAGE_DEFAULT"] = "live-page-default";
    DefaultTitleEmojiValues["NONE"] = "none";
    return DefaultTitleEmojiValues;
}({});
const $61659933fe71a4ee$export$efb819bf9c3235c7 = (data)=>{
    if (!data) return false;
    const defaultTitleEmoji = data?.content?.nodes?.[0]?.contentProperties?.latest?.defaultTitleEmoji;
    // This property denotes whether or not we show a default emoji icon, and is initially set to null to avoid backfilling on the BE;
    // therefore, a null value OR a specifically set value implies that we need to show a default icon, while a "none" value implies
    // that we should not show an icon. The default icon should also be overriden by a user-set emoji.
    return defaultTitleEmoji === null || defaultTitleEmoji === "live-page-default";
};
module.exports["getVersionNumber"] = $61659933fe71a4ee$export$d2d37cdca5b73056;
module.exports["getEmojiId"] = $61659933fe71a4ee$export$4f65bc4b6ab2638;
module.exports["sanitizeEmojiValue"] = $61659933fe71a4ee$export$7f77dde40cb9b60a;
module.exports["getEmojiPublishedProperty"] = $61659933fe71a4ee$export$1b37039eb4b94aa5;
module.exports["getEmojiDraftProperty"] = $61659933fe71a4ee$export$4d2921b7085d93bb;
module.exports["getEmojiFromPublishedPageProperties"] = $61659933fe71a4ee$export$f6641c501f8a1aee;
module.exports["getEmojiFromDraftPageProperties"] = $61659933fe71a4ee$export$e1cb12562674727b;
module.exports["getPublishedEmojiId"] = $61659933fe71a4ee$export$db0acf1152e62ad6;
module.exports["getEmojiValueFromContent"] = $61659933fe71a4ee$export$a5b3ff94c918547;
module.exports["getEmojiDraftFromProperties"] = $61659933fe71a4ee$export$bb520a2176fa2873;
module.exports["getEmojiPublishedFromProperties"] = $61659933fe71a4ee$export$fbf43d9e87015d93;
module.exports["getHasEmoji"] = $61659933fe71a4ee$export$b8852397200defa1;
module.exports["doesContentHaveEmojiPublished"] = $61659933fe71a4ee$export$496af73e8e85fd08;
module.exports["getEmojiProvider"] = $61659933fe71a4ee$export$8210f5f78c0bcf27;
module.exports["DefaultTitleEmojiValues"] = $61659933fe71a4ee$export$66d7571a7d7aad65;
module.exports["getHasLiveDocsDefaultEmoji"] = $61659933fe71a4ee$export$efb819bf9c3235c7;

});

parcelRegister("5amrO", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $99t4P = parcelRequire("99t4P");

const $bb7cbab4663812b3$export$342dc808a4f4a7ab = 'emoji-title-draft';
const $bb7cbab4663812b3$export$97ffb0b9059d248e = 'emoji-title-published';
const $bb7cbab4663812b3$export$5a027b13986198b7 = 'emojiTitleDraft';
const $bb7cbab4663812b3$export$b78a8db8f4546258 = 'emojiTitlePublished';
const $bb7cbab4663812b3$export$61509c1d76ea5fb2 = (contentType)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isWhiteboardEmoji = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    if (isWhiteboardEmoji || isLivePage) return $bb7cbab4663812b3$export$b78a8db8f4546258;
    else return $bb7cbab4663812b3$export$5a027b13986198b7;
};
const $bb7cbab4663812b3$export$28c62f1b367f9166 = (fieldName)=>{
    return fieldName === $bb7cbab4663812b3$export$b78a8db8f4546258 ? $bb7cbab4663812b3$export$97ffb0b9059d248e : $bb7cbab4663812b3$export$342dc808a4f4a7ab;
};
module.exports["EMOJI_TITLE_DRAFT_FIELD"] = $bb7cbab4663812b3$export$5a027b13986198b7;
module.exports["EMOJI_TITLE_PUBLISHED_FIELD"] = $bb7cbab4663812b3$export$b78a8db8f4546258;
module.exports["useEmojiStatusFieldName"] = $bb7cbab4663812b3$export$61509c1d76ea5fb2;
module.exports["convertEmojiFieldNameToPropertyKey"] = $bb7cbab4663812b3$export$28c62f1b367f9166;

});

parcelRegister("99t4P", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $6b4026d31beb25d0$export$f0410e068eb2ef9e = (contentType)=>{
    return contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles');
};
module.exports["isEmojiTitleEnabled"] = $6b4026d31beb25d0$export$f0410e068eb2ef9e;

});

parcelRegister("5DJsZ", function(module, exports) {
/**
 * @generated SignedSource<<8b96b7ca504d956e62c9a3c7888eb72c>>
 * @relayHash 736318216100158fedfd1efdb0277723
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ee7b55ba4a12d84512c880cfd1a46392ff785081052c438befeefd868cef06a6
const $4dc353069380bea7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipPublishedFragment"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v4 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "condition": "skipPublishedFragment",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "emojiTitlePublished",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "emoji-title-published"
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v5 /*: any*/ ,
                                    "storageKey": "properties(key:\"emoji-title-published\")"
                                }
                            ]
                        },
                        {
                            "alias": "emojiTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "emoji-title-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v5 /*: any*/ ,
                            "storageKey": "properties(key:\"emoji-title-draft\")"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PublishedContentProperties",
                                    "kind": "LinkedField",
                                    "name": "latest",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "defaultTitleEmoji"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EmojiTitleQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EmojiTitleQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "736318216100158fedfd1efdb0277723",
            "id": "ee7b55ba4a12d84512c880cfd1a46392ff785081052c438befeefd868cef06a6",
            "metadata": {},
            "name": "EmojiTitleQuery",
            "operationKind": "query",
            "text": "query EmojiTitleQuery($contentId:ID,$status:[String],$draftShareId:String,$skipPublishedFragment:Boolean!){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,emojiTitlePublished:properties(key:\"emoji-title-published\")@skip(if:$skipPublishedFragment){nodes{id,key,value,version{number}}},emojiTitleDraft:properties(key:\"emoji-title-draft\"){nodes{id,key,value,version{number}}},contentProperties{latest{defaultTitleEmoji}}}}}"
        }
    };
}();
$4dc353069380bea7$var$node.hash = "c3af19fccb4a5096e4bb34c9aa198098";
var $4dc353069380bea7$export$2e2bcd8739ae039 = $4dc353069380bea7$var$node;
module.exports["default"] = $4dc353069380bea7$export$2e2bcd8739ae039;

});

parcelRegister("huWyw", function(module, exports) {

var $jlIaF = parcelRequire("jlIaF");

const $61f50eb1c9d5c417$export$35f6369946b1d8c9 = ({ url: url, spaceKey: spaceKey, contentType: contentType, editorVersion: editorVersion, contentId: contentId, fabricEditorSupported: fabricEditorSupported, noContextPath: noContextPath })=>{
    const isPage = contentType === 'page';
    const isBlog = contentType === 'blogpost';
    const isPageOrBlog = isPage || isBlog;
    const isUsingFabricEditor = fabricEditorSupported || editorVersion === 'v2'; // as opposed to the v1 TinyMCE editor
    const providedURLHitsResumeDraftAction = url.includes('resumedraft.action');
    if (isPageOrBlog && isUsingFabricEditor && providedURLHitsResumeDraftAction) {
        const contentTypeForURL = isPage ? 'pages' : 'blog';
        const contentIdForURL = contentId;
        // Extract the query string from the relative URL.
        const queryString = url.includes('?') ? url.slice(url.indexOf('?') + 1) : '';
        // Extract the `draftShareId` from the query string.
        const urlSearchParams = new URLSearchParams(queryString);
        const draftShareId = urlSearchParams.get('draftShareId');
        const draftShareIdParamString = draftShareId ? `draftShareId=${draftShareId}` : '';
        const optionalContextPath = noContextPath ? '' : (0, $jlIaF.CONTEXT_PATH);
        const bypassURL = `${optionalContextPath}/spaces/${spaceKey}/${contentTypeForURL}/edit-v2/${contentIdForURL}?${draftShareIdParamString}`;
        return bypassURL;
    } else return url;
};
module.exports["getURLBypassingResumeDraftAction"] = $61f50eb1c9d5c417$export$35f6369946b1d8c9;

});

parcelRegister("c7GB4", function(module, exports) {

var $gsyiL = parcelRequire("gsyiL");

var $iOCEj = parcelRequire("iOCEj");

var $av9vJ = parcelRequire("av9vJ");

var $lEAnc = parcelRequire("lEAnc");

var $6B1vK = parcelRequire("6B1vK");

var $1lJ86 = parcelRequire("1lJ86");

var $cCPLV = parcelRequire("cCPLV");


var $1ggpj = parcelRequire("1ggpj");

const $c96e0d62cf176fc6$export$84dfa7fadd8a006b = ({ ari: ari, resourceType: resourceType })=>{
    if (!ari) return null;
    switch(resourceType){
        case (0, $1ggpj.ContentType).PAGE:
            return (0, $6B1vK.ConfluencePageAri).parse(ari).pageId;
        case (0, $1ggpj.ContentType).BLOGPOST:
            return (0, $gsyiL.ConfluenceBlogpostAri).parse(ari).blogpostId;
        case (0, $1ggpj.ContentType).WHITEBOARD:
            return (0, $cCPLV.ConfluenceWhiteboardAri).parse(ari).whiteboardId;
        case (0, $1ggpj.ContentType).DATABASE:
            return (0, $iOCEj.ConfluenceDatabaseAri).parse(ari).databaseId;
        case (0, $1ggpj.ContentType).EMBED:
            return (0, $av9vJ.ConfluenceEmbedAri).parse(ari).embedId;
        case (0, $1ggpj.ContentType).FOLDER:
            return (0, $lEAnc.ConfluenceFolderAri).parse(ari).folderId;
        case (0, $1ggpj.ContentType).SLIDE:
            return (0, $1lJ86.ConfluenceSlideAri).parse(ari).slideId;
    }
};
module.exports["getIdFromConfluenceContentAri"] = $c96e0d62cf176fc6$export$84dfa7fadd8a006b;

});

parcelRegister("gsyiL", function(module, exports) {

var $eQkRH = parcelRequire("eQkRH");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/blogpost/manifest.ts
var $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $eQkRH.ConfluenceBlogpostAriResourceOwner),
    resourceType: (0, $eQkRH.ConfluenceBlogpostAriResourceType),
    resourceIdSlug: "{blogpostId}",
    resourceIdSegmentFormats: {
        blogpostId: /[0-9]+/
    }
};
// src/confluence/blogpost/index.ts
var $bfb9de7804f5bb44$export$8602a2c2f6ac09bc = class _ConfluenceBlogpostAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get blogpostId() {
        return this._blogpostId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts.qualifier,
            platformQualifier: $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts.resourceOwner,
            resourceType: $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts.resourceType,
            resourceId: `${opts.blogpostId}`,
            resourceIdSegmentValues: {
                blogpostId: opts.blogpostId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $bfb9de7804f5bb44$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            blogpostId: this.blogpostId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._blogpostId = opts.resourceIdSegmentValues.blogpostId;
    }
};
module.exports["ConfluenceBlogpostAri"] = $bfb9de7804f5bb44$export$8602a2c2f6ac09bc;

});

parcelRegister("eQkRH", function(module, exports) {
// src/confluence/blogpost/types.ts
var $ace61b64202bfb2d$export$9389f06bd1d0765c = "confluence", $ace61b64202bfb2d$export$fb777a2d645a4129 = "blogpost";
module.exports["ConfluenceBlogpostAriResourceOwner"] = $ace61b64202bfb2d$export$9389f06bd1d0765c;
module.exports["ConfluenceBlogpostAriResourceType"] = $ace61b64202bfb2d$export$fb777a2d645a4129;

});

parcelRegister("iOCEj", function(module, exports) {

var $jp6rV = parcelRequire("jp6rV");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/database/manifest.ts
var $db2ae073c8566cc3$var$confluenceDatabaseAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jp6rV.ConfluenceDatabaseAriResourceOwner),
    resourceType: (0, $jp6rV.ConfluenceDatabaseAriResourceType),
    resourceIdSlug: "activation/{activationId}/{databaseId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        databaseId: /[0-9]+/
    }
};
// src/confluence/database/index.ts
var $db2ae073c8566cc3$export$317cd32472deea7e = class _ConfluenceDatabaseAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get databaseId() {
        return this._databaseId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $db2ae073c8566cc3$var$confluenceDatabaseAriStaticOpts.qualifier,
            platformQualifier: $db2ae073c8566cc3$var$confluenceDatabaseAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $db2ae073c8566cc3$var$confluenceDatabaseAriStaticOpts.resourceOwner,
            resourceType: $db2ae073c8566cc3$var$confluenceDatabaseAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.databaseId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                databaseId: opts.databaseId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $db2ae073c8566cc3$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $db2ae073c8566cc3$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            databaseId: this.databaseId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._databaseId = opts.resourceIdSegmentValues.databaseId;
    }
};
module.exports["ConfluenceDatabaseAri"] = $db2ae073c8566cc3$export$317cd32472deea7e;

});

parcelRegister("jp6rV", function(module, exports) {
// src/confluence/database/types.ts
var $e2055ad385da7e5a$export$e83bc7b627335f1d = "confluence", $e2055ad385da7e5a$export$d26db9a1a0b750aa = "database";
module.exports["ConfluenceDatabaseAriResourceOwner"] = $e2055ad385da7e5a$export$e83bc7b627335f1d;
module.exports["ConfluenceDatabaseAriResourceType"] = $e2055ad385da7e5a$export$d26db9a1a0b750aa;

});

parcelRegister("av9vJ", function(module, exports) {

var $1pgGd = parcelRequire("1pgGd");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/embed/manifest.ts
var $7a542d43713a04fa$var$confluenceEmbedAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1pgGd.ConfluenceEmbedAriResourceOwner),
    resourceType: (0, $1pgGd.ConfluenceEmbedAriResourceType),
    resourceIdSlug: "activation/{activationId}/{embedId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        embedId: /[0-9]+/
    }
};
// src/confluence/embed/index.ts
var $7a542d43713a04fa$export$47d4b4205d0ac61a = class _ConfluenceEmbedAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get embedId() {
        return this._embedId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7a542d43713a04fa$var$confluenceEmbedAriStaticOpts.qualifier,
            platformQualifier: $7a542d43713a04fa$var$confluenceEmbedAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $7a542d43713a04fa$var$confluenceEmbedAriStaticOpts.resourceOwner,
            resourceType: $7a542d43713a04fa$var$confluenceEmbedAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.embedId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                embedId: opts.embedId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $7a542d43713a04fa$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $7a542d43713a04fa$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            embedId: this.embedId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._embedId = opts.resourceIdSegmentValues.embedId;
    }
};
module.exports["ConfluenceEmbedAri"] = $7a542d43713a04fa$export$47d4b4205d0ac61a;

});

parcelRegister("1pgGd", function(module, exports) {
// src/confluence/embed/types.ts
var $10651083a44828c2$export$7a02af293cacddd2 = "confluence", $10651083a44828c2$export$f817d48842ea0d4a = "embed";
module.exports["ConfluenceEmbedAriResourceOwner"] = $10651083a44828c2$export$7a02af293cacddd2;
module.exports["ConfluenceEmbedAriResourceType"] = $10651083a44828c2$export$f817d48842ea0d4a;

});

parcelRegister("lEAnc", function(module, exports) {

var $7SOnZ = parcelRequire("7SOnZ");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/folder/manifest.ts
var $fc398c589f411de7$var$confluenceFolderAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $7SOnZ.ConfluenceFolderAriResourceOwner),
    resourceType: (0, $7SOnZ.ConfluenceFolderAriResourceType),
    resourceIdSlug: "activation/{activationId}/{folderId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        folderId: /[0-9]+/
    }
};
// src/confluence/folder/index.ts
var $fc398c589f411de7$export$501a782385a3f485 = class _ConfluenceFolderAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get folderId() {
        return this._folderId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $fc398c589f411de7$var$confluenceFolderAriStaticOpts.qualifier,
            platformQualifier: $fc398c589f411de7$var$confluenceFolderAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $fc398c589f411de7$var$confluenceFolderAriStaticOpts.resourceOwner,
            resourceType: $fc398c589f411de7$var$confluenceFolderAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.folderId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                folderId: opts.folderId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $fc398c589f411de7$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $fc398c589f411de7$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            folderId: this.folderId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._folderId = opts.resourceIdSegmentValues.folderId;
    }
};
module.exports["ConfluenceFolderAri"] = $fc398c589f411de7$export$501a782385a3f485;

});

parcelRegister("7SOnZ", function(module, exports) {
// src/confluence/folder/types.ts
var $5bd4a92be6836a9b$export$77cf4e1b17902bfa = "confluence", $5bd4a92be6836a9b$export$6256ff329bc25a9c = "folder";
module.exports["ConfluenceFolderAriResourceOwner"] = $5bd4a92be6836a9b$export$77cf4e1b17902bfa;
module.exports["ConfluenceFolderAriResourceType"] = $5bd4a92be6836a9b$export$6256ff329bc25a9c;

});

parcelRegister("6B1vK", function(module, exports) {

var $jyUkr = parcelRequire("jyUkr");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/page/manifest.ts
var $4cd75eda3ba03299$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jyUkr.ConfluencePageAriResourceOwner),
    resourceType: (0, $jyUkr.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $4cd75eda3ba03299$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $4cd75eda3ba03299$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $4cd75eda3ba03299$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $4cd75eda3ba03299$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $4cd75eda3ba03299$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $4cd75eda3ba03299$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $4cd75eda3ba03299$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["ConfluencePageAri"] = $4cd75eda3ba03299$export$3f931dd15d96caff;

});

parcelRegister("jyUkr", function(module, exports) {
// src/confluence/page/types.ts
var $e3dce2fc5add42f7$export$da53e4f7db4c6a71 = "confluence", $e3dce2fc5add42f7$export$636fc622562a2c5b = "page";
module.exports["ConfluencePageAriResourceOwner"] = $e3dce2fc5add42f7$export$da53e4f7db4c6a71;
module.exports["ConfluencePageAriResourceType"] = $e3dce2fc5add42f7$export$636fc622562a2c5b;

});

parcelRegister("1lJ86", function(module, exports) {

var $1AG0i = parcelRequire("1AG0i");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/slide/manifest.ts
var $0fbac26e81c45336$var$confluenceSlideAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1AG0i.ConfluenceSlideAriResourceOwner),
    resourceType: (0, $1AG0i.ConfluenceSlideAriResourceType),
    resourceIdSlug: "activation/{activationId}/{slideId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        slideId: /[0-9]+/
    }
};
// src/confluence/slide/index.ts
var $0fbac26e81c45336$export$86048ac46024146a = class _ConfluenceSlideAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get slideId() {
        return this._slideId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $0fbac26e81c45336$var$confluenceSlideAriStaticOpts.qualifier,
            platformQualifier: $0fbac26e81c45336$var$confluenceSlideAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $0fbac26e81c45336$var$confluenceSlideAriStaticOpts.resourceOwner,
            resourceType: $0fbac26e81c45336$var$confluenceSlideAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.slideId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                slideId: opts.slideId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $0fbac26e81c45336$var$confluenceSlideAriStaticOpts);
        return new _ConfluenceSlideAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $0fbac26e81c45336$var$confluenceSlideAriStaticOpts);
        return new _ConfluenceSlideAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            slideId: this.slideId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._slideId = opts.resourceIdSegmentValues.slideId;
    }
};
module.exports["ConfluenceSlideAri"] = $0fbac26e81c45336$export$86048ac46024146a;

});

parcelRegister("1AG0i", function(module, exports) {
// src/confluence/slide/types.ts
var $1289bc4ba87a8942$export$204fa7edd529d4b3 = "confluence", $1289bc4ba87a8942$export$3de52c55a164daa4 = "slide";
module.exports["ConfluenceSlideAriResourceOwner"] = $1289bc4ba87a8942$export$204fa7edd529d4b3;
module.exports["ConfluenceSlideAriResourceType"] = $1289bc4ba87a8942$export$3de52c55a164daa4;

});

parcelRegister("cCPLV", function(module, exports) {

var $9z7xR = parcelRequire("9z7xR");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/whiteboard/manifest.ts
var $9311318266bf230b$var$confluenceWhiteboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $9z7xR.ConfluenceWhiteboardAriResourceOwner),
    resourceType: (0, $9z7xR.ConfluenceWhiteboardAriResourceType),
    resourceIdSlug: "{whiteboardId}",
    resourceIdSegmentFormats: {
        whiteboardId: /[0-9]+/
    }
};
// src/confluence/whiteboard/index.ts
var $9311318266bf230b$export$ba3d25b6768ddb10 = class _ConfluenceWhiteboardAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get whiteboardId() {
        return this._whiteboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $9311318266bf230b$var$confluenceWhiteboardAriStaticOpts.qualifier,
            platformQualifier: $9311318266bf230b$var$confluenceWhiteboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $9311318266bf230b$var$confluenceWhiteboardAriStaticOpts.resourceOwner,
            resourceType: $9311318266bf230b$var$confluenceWhiteboardAriStaticOpts.resourceType,
            resourceId: `${opts.whiteboardId}`,
            resourceIdSegmentValues: {
                whiteboardId: opts.whiteboardId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $9311318266bf230b$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $9311318266bf230b$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            whiteboardId: this.whiteboardId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._whiteboardId = opts.resourceIdSegmentValues.whiteboardId;
    }
};
module.exports["ConfluenceWhiteboardAri"] = $9311318266bf230b$export$ba3d25b6768ddb10;

});

parcelRegister("9z7xR", function(module, exports) {
// src/confluence/whiteboard/types.ts
var $6f6d3c41ba97755c$export$6130ea1abbb885ef = "confluence", $6f6d3c41ba97755c$export$d3070d1568a10e2d = "whiteboard";
module.exports["ConfluenceWhiteboardAriResourceOwner"] = $6f6d3c41ba97755c$export$6130ea1abbb885ef;
module.exports["ConfluenceWhiteboardAriResourceType"] = $6f6d3c41ba97755c$export$d3070d1568a10e2d;

});

parcelRegister("aOKRX", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b6b1455842ddb08b$export$d0606705f36ae70a = ()=>{
    const $ = (0, $bDgLe.c)(6);
    const [pageContentWidth, setPageContentWidth] = (0, $cozmU.useState)(0);
    const [pageContentLeft, setPageContentLeft] = (0, $cozmU.useState)(0);
    const [pageContentRight, setPageContentRight] = (0, $cozmU.useState)(0);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            let resizeObserver = null;
            let mutationObserver = null;
            let pageContentOnly = null;
            const updateDimensions = ()=>{
                if (!pageContentOnly) return;
                const rect = pageContentOnly.getBoundingClientRect();
                setPageContentWidth(rect.width);
                setPageContentLeft(rect.left);
                setPageContentRight(rect.right);
            };
            const handleWindowResize = ()=>{
                updateDimensions();
            };
            window.addEventListener("resize", handleWindowResize);
            const setupObservers = (element)=>{
                pageContentOnly = element;
                if (resizeObserver) resizeObserver.disconnect();
                resizeObserver = new ResizeObserver(()=>{
                    updateDimensions();
                });
                resizeObserver.observe(element);
                updateDimensions();
            };
            const existingElement = document.querySelector("[data-testid='page-content-only']");
            if (existingElement) setupObservers(existingElement);
            mutationObserver = new MutationObserver(()=>{
                const newPageContentOnly = document.querySelector("[data-testid='page-content-only']");
                if (newPageContentOnly && newPageContentOnly !== pageContentOnly) setupObservers(newPageContentOnly);
            });
            mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
            return ()=>{
                if (resizeObserver) resizeObserver.disconnect();
                window.removeEventListener("resize", handleWindowResize);
                if (mutationObserver) mutationObserver.disconnect();
            };
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[2] !== pageContentLeft || $[3] !== pageContentRight || $[4] !== pageContentWidth) {
        t2 = {
            width: pageContentWidth,
            left: pageContentLeft,
            right: pageContentRight
        };
        $[2] = pageContentLeft;
        $[3] = pageContentRight;
        $[4] = pageContentWidth;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};
module.exports["usePageContentDimensions"] = $b6b1455842ddb08b$export$d0606705f36ae70a;

});

parcelRegister("niTts", function(module, exports) {
const $829c98791d74b4c3$export$a9fce9e535ae2163 = ({ shouldRenderFixedStyle: shouldRenderFixedStyle, pageContentDimensions: pageContentDimensions, fallbackWidth: fallbackWidth = '100%' })=>{
    if (!shouldRenderFixedStyle) return {
        width: fallbackWidth
    };
    const { width: pageContentWidth, left: pageContentLeft, right: pageContentRight } = pageContentDimensions;
    // Handle case where dimensions might be undefined or width might be a string
    const width = typeof pageContentWidth === 'number' ? pageContentWidth : 0;
    const left = pageContentLeft ?? 0;
    const right = pageContentRight ?? 0;
    return {
        left: left > 0 ? `${left}px` : '0px',
        right: right > 0 ? `${window.innerWidth - right}px` : '0px',
        width: width > 0 ? `${width}px` : '100%'
    };
};
module.exports["hideWhiteSpace"] = $829c98791d74b4c3$export$a9fce9e535ae2163;

});

parcelRegister("l1B53", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $hBYtq = parcelRequire("hBYtq");

const $656c656df397599d$var$styles = {
    draftComment: "_2rko12b0 _1yt4u2gc _189ee4h9 _1dqonqa1 _1h6d1l7x _1bsb1osq _4t3i14no _1e0c1txw _4cvr1h6o _1bah1yb4 _syaz1rpy _bfhk1j9a"
};
const $656c656df397599d$var$i18n = (0, $kSwu1.defineMessages)({
    unsavedDraftComment: {
        id: "object-comments.draft-comment-box.text",
        defaultMessage: "Comment in progress - select to continue"
    }
});
const $656c656df397599d$export$82fe65228be9eec = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { testId: t1, expandPageCommentEditorHandler: expandPageCommentEditorHandler } = t0;
    const testId = t1 === undefined ? "draft-comment-box" : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== formatMessage) {
        t2 = formatMessage($656c656df397599d$var$i18n.unsavedDraftComment);
        $[0] = formatMessage;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== expandPageCommentEditorHandler || $[3] !== t2 || $[4] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
            xcss: $656c656df397599d$var$styles.draftComment,
            testId: testId,
            onClick: expandPageCommentEditorHandler
        }, t2);
        $[2] = expandPageCommentEditorHandler;
        $[3] = t2;
        $[4] = testId;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
};
module.exports["DraftCommentBox"] = $656c656df397599d$export$82fe65228be9eec;

});

parcelRegister("dL5YQ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $8lS8J = parcelRequire("8lS8J");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $jMyy4 = parcelRequire("jMyy4");


var $9wGTI = parcelRequire("9wGTI");


var $fs6LW = parcelRequire("fs6LW");


var $bQm3c = parcelRequire("bQm3c");


var $e4o8D = parcelRequire("e4o8D");

const $f361dd7d6e4d9bdd$var$ObjectAddCommentProfileWrapperUserQuery = (0, $8lS8J.default);
const $f361dd7d6e4d9bdd$var$styles = {
    addCommentWrapperStyles: "_1bsb1osq",
    addCommentWrapperWithBannerStyles: "_1e0c11p5 _yv0e1ul4 _gy1ppxbi _1bsb1osq",
    addCommentOpenContainerStyles: "_zulppxbi _1e0c1txw _2lx2vrvc _1bsb1osq _4cvr1y6m",
    addCommentOpenContainerWithBannerStyles: "_1e0c1bgi",
    addCommentEditorStyles: "_yyhycs5v _1ii7cs5v _1bsb1osq _1ul9idpf",
    bannerStyles: "_yyhycs5v _1ii7kb7n _1ul9idpf",
    avatarStyles: "_yyhykb7n _1ii7cs5v _1bsbzwfg _4t3izwfg _1o9zidpf"
};
const $f361dd7d6e4d9bdd$var$avatarFloatStyle = {
    float: 'left'
};
const $f361dd7d6e4d9bdd$export$5a360c1cb6170ba8 = (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { children: children, banner: banner } = t0;
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const t1 = userId || "";
    let t2;
    if ($[0] !== t1) {
        t2 = {
            id: t1
        };
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const t3 = !userId;
    let t4;
    if ($[2] !== t2 || $[3] !== t3) {
        t4 = {
            variables: t2,
            fetchPolicy: (0, $9wGTI.fg)("confluence-comments-fix-avatar-flash") ? "cache-first" : "cache-and-network",
            skip: t3
        };
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    const { data: userData, loading: loading } = (0, $jMyy4.useQueryInterop)($f361dd7d6e4d9bdd$var$ObjectAddCommentProfileWrapperUserQuery, {
        ...t4,
        __callerPackage__: "object-comments"
    });
    const t5 = userData?.user?.photos?.[0]?.value || "";
    const t6 = userData?.user?.displayName || "";
    let t7;
    if ($[5] !== t5 || $[6] !== t6 || $[7] !== userId) {
        t7 = {
            avatarUrl: t5,
            accountId: userId,
            displayName: t6
        };
        $[5] = t5;
        $[6] = t6;
        $[7] = userId;
        $[8] = t7;
    } else t7 = $[8];
    const userInfo = t7;
    const t8 = banner ? $f361dd7d6e4d9bdd$var$styles.addCommentWrapperWithBannerStyles : $f361dd7d6e4d9bdd$var$styles.addCommentWrapperStyles;
    let t9;
    if ($[9] !== banner) {
        t9 = banner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $f361dd7d6e4d9bdd$var$styles.bannerStyles
        }, banner) : null;
        $[9] = banner;
        $[10] = t9;
    } else t9 = $[10];
    const t10 = banner ? $f361dd7d6e4d9bdd$var$styles.addCommentOpenContainerWithBannerStyles : $f361dd7d6e4d9bdd$var$styles.addCommentOpenContainerStyles;
    let t11;
    if ($[11] !== loading || $[12] !== renderServerPlaceholder || $[13] !== userInfo) {
        t11 = loading || renderServerPlaceholder ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fs6LW.ProfileAvatar), {
            canViewProfile: true,
            src: userInfo.avatarUrl,
            userId: userInfo.accountId,
            isAnonymous: !userInfo.accountId,
            name: userInfo.displayName,
            testId: "profile-avatar-comment"
        });
        $[11] = loading;
        $[12] = renderServerPlaceholder;
        $[13] = userInfo;
        $[14] = t11;
    } else t11 = $[14];
    let t12;
    if ($[15] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $f361dd7d6e4d9bdd$var$styles.avatarStyles,
            style: $f361dd7d6e4d9bdd$var$avatarFloatStyle
        }, t11);
        $[15] = t11;
        $[16] = t12;
    } else t12 = $[16];
    let t13;
    if ($[17] !== children) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $f361dd7d6e4d9bdd$var$styles.addCommentEditorStyles
        }, children);
        $[17] = children;
        $[18] = t13;
    } else t13 = $[18];
    let t14;
    if ($[19] !== t10 || $[20] !== t12 || $[21] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: t10
        }, t12, t13);
        $[19] = t10;
        $[20] = t12;
        $[21] = t13;
        $[22] = t14;
    } else t14 = $[22];
    let t15;
    if ($[23] !== t14 || $[24] !== t8 || $[25] !== t9) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: t8
        }, t9, t14);
        $[23] = t14;
        $[24] = t8;
        $[25] = t9;
        $[26] = t15;
    } else t15 = $[26];
    return t15;
};
module.exports["ObjectAddCommentProfileWrapper"] = $f361dd7d6e4d9bdd$export$5a360c1cb6170ba8;

});

parcelRegister("8lS8J", function(module, exports) {
/**
 * @generated SignedSource<<41cbeaa06d5991b406f8cd5c92a2f482>>
 * @relayHash 0725da37403499b17b096784b15edae6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a6bddc3903f6a6922c0ab03a3ba2a65c67ef085bec5807493eace122485b54d1
const $a4f88c0b86e6c5fb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ObjectAddCommentProfileWrapperUserQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ObjectAddCommentProfileWrapperUserQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0725da37403499b17b096784b15edae6",
            "id": "a6bddc3903f6a6922c0ab03a3ba2a65c67ef085bec5807493eace122485b54d1",
            "metadata": {},
            "name": "ObjectAddCommentProfileWrapperUserQuery",
            "operationKind": "query",
            "text": "query ObjectAddCommentProfileWrapperUserQuery($id:ID!){user:confluence_atlassianUser(id:$id){id,displayName,photos{value}}}"
        }
    };
}();
$a4f88c0b86e6c5fb$var$node.hash = "d4c2e7d15525539be1b21ee5306d9088";
var $a4f88c0b86e6c5fb$export$2e2bcd8739ae039 = $a4f88c0b86e6c5fb$var$node;
module.exports["default"] = $a4f88c0b86e6c5fb$export$2e2bcd8739ae039;

});

parcelRegister("fs6LW", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $arQY7 = parcelRequire("arQY7");


var $jyPfN = parcelRequire("jyPfN");


var $9wGTI = parcelRequire("9wGTI");


var $a6t12 = parcelRequire("a6t12");

const $98dff64af54e38f8$var$avatarWrapperStyles = {
    base: (0, $buxP3.xcss)({
        display: 'inline-flex',
        backgroundColor: 'color.background.neutral.subtle',
        borderWidth: '0',
        padding: 'space.0',
        borderRadius: 'radius.full',
        outlineOffset: 'space.0',
        ':focus-within': {
            outlineStyle: 'solid',
            outlineWidth: 'border.width.focused',
            outlineColor: 'color.border.focused'
        }
    }),
    blockBase: (0, $buxP3.xcss)({
        display: 'flex'
    }),
    cursor: (0, $buxP3.xcss)({
        cursor: 'pointer'
    })
};
const $98dff64af54e38f8$var$i18n = (0, $kSwu1.defineMessages)({
    label: {
        id: "profile.avatar.image",
        defaultMessage: "profile image of a user"
    },
    ariaLabel: {
        id: "profile.avatar.ariaLabel",
        defaultMessage: "More information about {name}"
    }
});
const $98dff64af54e38f8$export$3778be82376b06d7 = (t0)=>{
    const $ = (0, $bDgLe.c)(44);
    const { userId: userId, canViewProfile: t1, isAnonymous: t2, size: t3, src: src, onClick: onClick, trigger: trigger, name: name, stackIndex: stackIndex, testId: testId, position: position, borderColor: borderColor, offset: offset, isBlockLevel: t4 } = t0;
    const canViewProfile = t1 === undefined ? true : t1;
    const isAnonymous = t2 === undefined ? false : t2;
    const size = t3 === undefined ? "medium" : t3;
    const isBlockLevel = t4 === undefined ? false : t4;
    const intl = (0, $kSwu1.useIntl)();
    const avatarSrc = isAnonymous || !canViewProfile || !src ? undefined : src;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const willRenderProfileCardTrigger = !isAnonymous && canViewProfile && !!userId && hasViewUserProfilePermission;
    const avatarRef = (0, $cozmU.useRef)(null);
    const [isVisible, setIsVisible] = (0, $cozmU.useState)(false);
    const [shouldReturnFocus, setShouldReturnFocus] = (0, $cozmU.useState)(false);
    const [wasKeyboardAction, setWasKeyboardAction] = (0, $cozmU.useState)(false);
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (isVisible_0)=>{
            setIsVisible(isVisible_0);
        };
        $[0] = t5;
    } else t5 = $[0];
    const handleVisibilityChange = t5;
    let t6;
    let t7;
    if ($[1] !== isVisible || $[2] !== shouldReturnFocus) {
        t6 = ()=>{
            if (shouldReturnFocus && !isVisible && avatarRef.current) {
                avatarRef.current.focus();
                setShouldReturnFocus(false);
            }
        };
        t7 = [
            isVisible,
            shouldReturnFocus
        ];
        $[1] = isVisible;
        $[2] = shouldReturnFocus;
        $[3] = t6;
        $[4] = t7;
    } else {
        t6 = $[3];
        t7 = $[4];
    }
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[5] !== isVisible || $[6] !== wasKeyboardAction) {
        t8 = (e)=>{
            e.stopPropagation();
            if (e.key === "Enter") {
                setWasKeyboardAction(true);
                setIsVisible($98dff64af54e38f8$var$_temp);
                setShouldReturnFocus(true);
            } else if (e.key === "Escape" && isVisible && wasKeyboardAction) {
                setIsVisible(false);
                setWasKeyboardAction(false);
                setShouldReturnFocus(true);
            }
        };
        $[5] = isVisible;
        $[6] = wasKeyboardAction;
        $[7] = t8;
    } else t8 = $[7];
    const handleKeyDown = t8;
    const t9 = (0, $9wGTI.fg)("a11y_whiteboards_changes") ? "" : name || "";
    let t10;
    if ($[8] !== intl) {
        t10 = (0, $9wGTI.fg)("a11y_whiteboards_changes") ? {} : {
            label: intl.formatMessage($98dff64af54e38f8$var$i18n.label)
        };
        $[8] = intl;
        $[9] = t10;
    } else t10 = $[9];
    let t11;
    if ($[10] !== avatarSrc || $[11] !== borderColor || $[12] !== onClick || $[13] !== size || $[14] !== stackIndex || $[15] !== t10 || $[16] !== t9 || $[17] !== testId) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            src: avatarSrc,
            size: size,
            target: "_blank",
            name: t9,
            ...t10,
            stackIndex: stackIndex,
            testId: testId,
            borderColor: borderColor,
            onClick: onClick
        });
        $[10] = avatarSrc;
        $[11] = borderColor;
        $[12] = onClick;
        $[13] = size;
        $[14] = stackIndex;
        $[15] = t10;
        $[16] = t9;
        $[17] = testId;
        $[18] = t11;
    } else t11 = $[18];
    const Icon = t11;
    let t12;
    if ($[19] !== intl || $[20] !== isVisible || $[21] !== name || $[22] !== willRenderProfileCardTrigger) {
        t12 = ()=>{
            if ((0, $9wGTI.fg)("a11y_whiteboards_changes")) return {};
            if (willRenderProfileCardTrigger) return {
                tabIndex: -1
            };
            return {
                "aria-haspopup": "true",
                "aria-expanded": isVisible,
                "aria-label": intl.formatMessage($98dff64af54e38f8$var$i18n.ariaLabel, {
                    name: name || ""
                }),
                role: "button",
                tabIndex: 0
            };
        };
        $[19] = intl;
        $[20] = isVisible;
        $[21] = name;
        $[22] = willRenderProfileCardTrigger;
        $[23] = t12;
    } else t12 = $[23];
    const getAriaProps = t12;
    const t13 = name || "";
    let t14;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = (0, $9wGTI.fg)("a11y_whiteboards_changes");
        $[24] = t14;
    } else t14 = $[24];
    const t15 = isBlockLevel && $98dff64af54e38f8$var$avatarWrapperStyles.blockBase;
    const t16 = canViewProfile && hasViewUserProfilePermission && $98dff64af54e38f8$var$avatarWrapperStyles.cursor;
    let t17;
    if ($[25] !== t15 || $[26] !== t16) {
        t17 = [
            $98dff64af54e38f8$var$avatarWrapperStyles.base,
            t15,
            t16
        ];
        $[25] = t15;
        $[26] = t16;
        $[27] = t17;
    } else t17 = $[27];
    let t18;
    if ($[28] !== getAriaProps) {
        t18 = getAriaProps();
        $[28] = getAriaProps;
        $[29] = t18;
    } else t18 = $[29];
    let t19;
    if ($[30] !== Icon || $[31] !== handleKeyDown || $[32] !== t17 || $[33] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: t17,
            testId: "avatarWrapperTestId",
            ref: avatarRef,
            onKeyDown: handleKeyDown,
            ...t18
        }, Icon);
        $[30] = Icon;
        $[31] = handleKeyDown;
        $[32] = t17;
        $[33] = t18;
        $[34] = t19;
    } else t19 = $[34];
    let t20;
    if ($[35] !== canViewProfile || $[36] !== isAnonymous || $[37] !== offset || $[38] !== position || $[39] !== t13 || $[40] !== t19 || $[41] !== trigger || $[42] !== userId) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: userId,
            canViewProfile: canViewProfile,
            isAnonymous: isAnonymous,
            trigger: trigger,
            fullName: t13,
            disabledAriaAttributes: t14,
            onVisibilityChange: handleVisibilityChange,
            position: position,
            offset: offset
        }, t19);
        $[35] = canViewProfile;
        $[36] = isAnonymous;
        $[37] = offset;
        $[38] = position;
        $[39] = t13;
        $[40] = t19;
        $[41] = trigger;
        $[42] = userId;
        $[43] = t20;
    } else t20 = $[43];
    return t20;
};
function $98dff64af54e38f8$var$_temp(prev) {
    return !prev;
}
module.exports["ProfileAvatar"] = $98dff64af54e38f8$export$3778be82376b06d7;

});

parcelRegister("jyPfN", function(module, exports) {

var $foQ4a = parcelRequire("foQ4a");

const $10d1e40b190a4139$export$5a38a817745a0c6f = ()=>{
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    return {
        canViewUserProfile: !isExternalCollaborator
    };
};
module.exports["useViewUserProfile"] = $10d1e40b190a4139$export$5a38a817745a0c6f;

});

parcelRegister("a6t12", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kNIYN = parcelRequire("kNIYN");


var $9DHhW = parcelRequire("9DHhW");


var $22Zs7 = parcelRequire("22Zs7");


var $9zU5G = parcelRequire("9zU5G");


var $9wGTI = parcelRequire("9wGTI");


var $jyPfN = parcelRequire("jyPfN");


var $jlIaF = parcelRequire("jlIaF");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $gqqjz = parcelRequire("gqqjz");

parcelRequire("5XsiK");
var $lfSOe = parcelRequire("lfSOe");


var $6OL2O = parcelRequire("6OL2O");

parcelRequire("dD7ks");
var $4N3op = parcelRequire("4N3op");


var $bedVD = parcelRequire("bedVD");


var $l7wqU = parcelRequire("l7wqU");


var $4GlQ9 = parcelRequire("4GlQ9");


var $bumSD = parcelRequire("bumSD");


var $4qzKl = parcelRequire("4qzKl");


var $gj42z = parcelRequire("gj42z");

const $3d0f3ea3171aff68$var$i18n = (0, $kSwu1.defineMessages)({
    viewProfile: {
        id: "profile.card.viewProfile",
        defaultMessage: "View profile"
    }
});
const $3d0f3ea3171aff68$export$98f80b73da7beaf4 = ({ push: push, userId: userId })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: ()=>(0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(userId).then(push),
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, '', (0, $jlIaF.CONTEXT_PATH))
    });
const $3d0f3ea3171aff68$export$4f94384af0327320 = ({ navigate: navigate, url: url })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: navigate,
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: url
    });
const $3d0f3ea3171aff68$export$d114163e55e8b2c5 = ({ loggedInUserId: loggedInUserId, getToggleFollowUser: getToggleFollowUser, renderFeedFollow: renderFeedFollow, userId: userId, followedUsers: followedUsers })=>{
    const followed = !!(userId && followedUsers?.includes(userId));
    return {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bedVD.FeedFollow), {
            followed: followed
        }),
        id: 'feed-follow-user',
        callback: getToggleFollowUser(userId, followed, 'profileCard'),
        shouldRender: (userData)=>renderFeedFollow && Boolean(userId) && userId !== loggedInUserId && userData?.status === 'active'
    };
};
const $3d0f3ea3171aff68$export$ba990269c861f33b = ({ loggedInUserId: loggedInUserId, getToggleFollowUser: getToggleFollowUser, renderFeedFollow: renderFeedFollow, followedRef: followedRef, userId: userId })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l7wqU.FeedFollowAction), {
            userId: userId
        }),
        id: 'feed-follow-user',
        callback: ()=>getToggleFollowUser(userId, followedRef.current, 'profileCard')(),
        shouldRender: ()=>renderFeedFollow && Boolean(userId) && userId !== loggedInUserId
    });
const $3d0f3ea3171aff68$export$59abd6feb7dc8540 = ({ position: position = 'bottom-start', userId: userId, isAnonymous: isAnonymous = false, canViewProfile: canViewProfile = true, children: children, trigger: trigger = 'hover', fullName: fullName, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, ariaLabel: ariaLabel, agent: agent })=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const { userId: loggedInUserId, cloudId: cloudId, featureFlags: featureFlags, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const reportingLines = (0, $4N3op.useNavigateToTeamsApp)({
        type: 'LANDING'
    });
    const getReportingLinesUserProfile = (clickedUserId)=>(0, $6OL2O.getNavigateToTeamsApp)(orgId || '', {
            type: 'USER',
            payload: {
                userId: clickedUserId
            }
        });
    const userProfile = (0, $4N3op.useNavigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId || ''
        }
    });
    const reportingLinesProfileUrl = (0, $lfSOe.isTeamsAppEnabled)() ? reportingLines.href : `${0, $jlIaF.CONTEXT_PATH}/people`;
    const { feedConfigError: feedConfigError, followedUsers: followedUsers, getToggleFollowUser: getToggleFollowUser, mutationError: mutationError, renderFeedFollow: renderFeedFollow } = (0, $4GlQ9.useFeedFollow)();
    const viewProfileAction = (0, $cozmU.useMemo)(()=>(0, $lfSOe.isTeamsAppEnabled)() ? $3d0f3ea3171aff68$export$4f94384af0327320({
            navigate: userProfile.onNavigate,
            url: userProfile.href
        }) : $3d0f3ea3171aff68$export$98f80b73da7beaf4({
            push: push,
            userId: userId
        }), [
        push,
        userId,
        userProfile
    ]);
    const followUserAction = (0, $cozmU.useMemo)(()=>$3d0f3ea3171aff68$export$d114163e55e8b2c5({
            loggedInUserId: loggedInUserId,
            getToggleFollowUser: getToggleFollowUser,
            renderFeedFollow: renderFeedFollow,
            userId: userId,
            followedUsers: followedUsers
        }), [
        loggedInUserId,
        getToggleFollowUser,
        renderFeedFollow,
        userId,
        followedUsers
    ]);
    // The card snapshots the actions, so the follow callback reads the latest follow state
    // from this ref (updated on every render) instead of a value captured when the action
    // was built. This keeps repeated follow/unfollow toggles in the correct direction.
    const followedRef = (0, $cozmU.useRef)(false);
    followedRef.current = !!(userId && followedUsers?.includes(userId));
    const followUserActionNext = (0, $cozmU.useMemo)(()=>$3d0f3ea3171aff68$export$ba990269c861f33b({
            loggedInUserId: loggedInUserId,
            getToggleFollowUser: getToggleFollowUser,
            renderFeedFollow: renderFeedFollow,
            followedRef: followedRef,
            userId: userId
        }), [
        loggedInUserId,
        getToggleFollowUser,
        renderFeedFollow,
        userId
    ]);
    // Should display profile?
    if (isAnonymous || !canViewProfile || !userId || !loggedInUserId || !hasViewUserProfilePermission) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    const reportingLinesClickCallback = (clickedUserId_0)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'profileCardWrapper',
                action: 'clicked',
                actionSubject: 'viewProfile',
                actionSubjectId: 'userProfileCard',
                attributes: {
                    clickTarget: 'userReportingLine'
                }
            }
        }).fire();
        if ((0, $lfSOe.isTeamsAppEnabled)()) {
            getReportingLinesUserProfile(clickedUserId_0).onNavigate();
            return false;
        }
        if (window.self !== window.top) window.open((0, $4qzKl.getAtlassianPeopleProfileUrl)(clickedUserId_0, '', (0, $jlIaF.CONTEXT_PATH)), '_blank', 'noreferrer');
        else (0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(clickedUserId_0).then(push, ()=>{});
    };
    if ((0, $9wGTI.fg)('people-teams_migrate-user-profile-card')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
        feedConfigError: feedConfigError,
        mutationError: mutationError,
        showErrorFlag: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9zU5G.UserProfileCardWithTrigger), {
        cloudId: cloudId,
        orgId: orgId || '',
        userId: userId,
        viewerId: loggedInUserId,
        placement: position,
        trigger: trigger,
        actions: [
            followUserActionNext
        ],
        agent: agent ? {
            ...agent,
            resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags)
        } : undefined,
        testId: "profileCardTrigger"
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
            feedConfigError: feedConfigError,
            mutationError: mutationError,
            showErrorFlag: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $22Zs7.default), {
            cloudId: cloudId,
            userId: userId,
            resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags),
            position: position,
            trigger: trigger,
            actions: [
                viewProfileAction,
                followUserAction
            ],
            reportingLinesProfileUrl: reportingLinesProfileUrl,
            onReportingLinesClick: (user)=>reportingLinesClickCallback(user.accountIdentifier),
            addFlag: (flag)=>flags.showFlag(flag),
            prepopulatedData: {
                fullName: fullName
            },
            disabledAriaAttributes: disabledAriaAttributes,
            onVisibilityChange: onVisibilityChange,
            offset: offset,
            testId: "profileCardTrigger",
            viewingUserId: loggedInUserId,
            ...disabledAriaAttributes ? {} : {
                ariaLabel: ariaLabel
            }
        }, children)));
};
module.exports["ProfileCardWrapper"] = $3d0f3ea3171aff68$export$59abd6feb7dc8540;

});

parcelRegister("5XsiK", function(module, exports) {
$parcel$export(module.exports, "isTeamsAppEnabled", () => (parcelRequire("lfSOe")).isTeamsAppEnabled);

var $lfSOe = parcelRequire("lfSOe");


});

parcelRegister("lfSOe", function(module, exports) {

var $eAXDY = parcelRequire("eAXDY");

const $6739d59719e0930b$export$5921b2a93a401547 = ()=>{
    return (0, $eAXDY.isTeamsAppEnabled)({
        userHasNav4Enabled: true,
        hostProduct: 'confluence'
    });
};
module.exports["isTeamsAppEnabled"] = $6739d59719e0930b$export$5921b2a93a401547;

});

parcelRegister("dD7ks", function(module, exports) {
$parcel$export(module.exports, "useNavigateToTeamsApp", () => (parcelRequire("4N3op")).useNavigateToTeamsApp);

var $4N3op = parcelRequire("4N3op");


});

parcelRegister("4N3op", function(module, exports) {

var $eW61a = parcelRequire("eW61a");


var $bQm3c = parcelRequire("bQm3c");


var $dPJCf = parcelRequire("dPJCf");

const $bf6b29a56d69bf9f$export$520a42ab062954ec = (navActionPayload, shouldOpenInSameTab)=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    return (0, $eW61a.navigateToTeamsApp)({
        push: push,
        hostProduct: 'confluence',
        orgId: orgId,
        cloudId: cloudId,
        userHasNav4Enabled: true,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["useNavigateToTeamsApp"] = $bf6b29a56d69bf9f$export$520a42ab062954ec;

});

parcelRegister("bedVD", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $lpNn5 = parcelRequire("lpNn5");

const $e4e11ee9fe4a88c9$var$i18n = (0, $kSwu1.defineMessages)({
    follow: {
        id: "profile.card.follow",
        defaultMessage: "Follow"
    },
    unfollow: {
        id: "profile.card.unfollow",
        defaultMessage: "Unfollow"
    },
    followTooltip: {
        id: "profile.card.follow.tooltip",
        defaultMessage: "See activity in feed"
    },
    unfollowTooltip: {
        id: "profile.card.unfollow.tooltip",
        defaultMessage: "Stop seeing activity in feed"
    }
});
const $e4e11ee9fe4a88c9$export$d258f317c876c5dc = (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { followed: followed } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== followed || $[1] !== intl) {
        t1 = intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollowTooltip : $e4e11ee9fe4a88c9$var$i18n.followTooltip);
        $[0] = followed;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== followed || $[4] !== intl) {
        t2 = intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollow : $e4e11ee9fe4a88c9$var$i18n.follow);
        $[3] = followed;
        $[4] = intl;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, t2);
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t1 || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t1,
            position: "bottom",
            testId: "feed-follow-tooltip"
        }, t3);
        $[8] = t1;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
};
module.exports["FeedFollow"] = $e4e11ee9fe4a88c9$export$d258f317c876c5dc;

});

parcelRegister("l7wqU", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bedVD = parcelRequire("bedVD");


var $4GlQ9 = parcelRequire("4GlQ9");

const $460a3972eab8fd69$export$38809e1c08e05a16 = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { userId: userId } = t0;
    const { followedUsers: followedUsers } = (0, $4GlQ9.useFeedFollow)();
    let t1;
    if ($[0] !== followedUsers || $[1] !== userId) {
        t1 = userId && followedUsers?.includes(userId);
        $[0] = followedUsers;
        $[1] = userId;
        $[2] = t1;
    } else t1 = $[2];
    const followed = !!t1;
    let t2;
    if ($[3] !== followed) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bedVD.FeedFollow), {
            followed: followed
        });
        $[3] = followed;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
module.exports["FeedFollowAction"] = $460a3972eab8fd69$export$38809e1c08e05a16;

});

parcelRegister("4GlQ9", function(module, exports) {

var $k7Nop = parcelRequire("k7Nop");


var $hOSkW = parcelRequire("hOSkW");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $bQm3c = parcelRequire("bQm3c");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");

const $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery = (0, $hOSkW.default);
const $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowMutation = (0, $k7Nop.default);
const $e2d6f47b8e3454eb$var$isUserHasNoAccessError = (error)=>error?.graphQLErrors?.some((gqlError)=>gqlError?.path?.includes('getFeedUserConfig') && gqlError?.message?.includes('User not permitted to access Confluence'));
let $e2d6f47b8e3454eb$export$8631e45fce8db7c6 = false;
function $e2d6f47b8e3454eb$export$438df56e0ed352e6() {
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { data: data, loading: queryLoading, error: feedConfigError } = (0, $jMyy4.useQueryInterop)($e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery, {
        skip: !isLicensed || $e2d6f47b8e3454eb$export$8631e45fce8db7c6,
        onError: (error)=>$e2d6f47b8e3454eb$export$8631e45fce8db7c6 = $e2d6f47b8e3454eb$var$isUserHasNoAccessError(error),
        __callerPackage__: "profile"
    });
    const [mutateFeedFollow, { error: mutationError }] = (0, $308Wd.useMutationInterop)($e2d6f47b8e3454eb$var$useFeedFollowFeedFollowMutation, {
        refetchQueries: [
            {
                query: $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery
            }
        ],
        __callerPackage__: "profile"
    });
    const followedUsersRaw = data?.getFeedUserConfig?.accountIds;
    const followedUsers = followedUsersRaw ? followedUsersRaw.map((id)=>id ?? null) : undefined;
    const getToggleFollowUser = (0, $cozmU.useCallback)((accountId, following, source)=>async ()=>{
            if (!accountId) return;
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'feedFollow',
                    source: source,
                    attributes: {
                        id: accountId,
                        settingType: 'user',
                        actionType: following ? 'unfollow' : 'follow'
                    }
                }
            }).fire();
            try {
                if (following) await mutateFeedFollow({
                    variables: {
                        unfollow: [
                            accountId
                        ]
                    }
                });
                else await mutateFeedFollow({
                    variables: {
                        follow: [
                            accountId
                        ]
                    }
                });
            } catch  {
            // noop since the hook consumer logs the error through <ErrorDisplay>
            // mutateFeedFollow() has the potential to throw an error;
            // since we do not provide an onError callback to the useMutation hook
            // we need to catch the error here as a safety net.
            }
        }, [
        mutateFeedFollow,
        createAnalyticsEvent
    ]);
    return (0, $cozmU.useMemo)(()=>({
            renderFeedFollow: !(queryLoading || feedConfigError || $e2d6f47b8e3454eb$export$8631e45fce8db7c6) && isLicensed,
            loading: queryLoading,
            getToggleFollowUser: getToggleFollowUser,
            feedConfigError: feedConfigError,
            mutationError: mutationError,
            followedUsers: followedUsers ?? []
        }), [
        queryLoading,
        feedConfigError,
        isLicensed,
        getToggleFollowUser,
        mutationError,
        followedUsers
    ]);
}
module.exports["useFeedFollow"] = $e2d6f47b8e3454eb$export$438df56e0ed352e6;

});

parcelRegister("k7Nop", function(module, exports) {
/**
 * @generated SignedSource<<faabaa80182918f5d00c229b25800acb>>
 * @relayHash 564d8ad9d36377c3d791529bbbb8a24b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d32fc5b6758b0cdbd537bc59e7432e83998cce61163ae34755c64a402dc367c
const $2274f77c1a29b092$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "follow"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "unfollow"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "followUsers",
                            "variableName": "follow"
                        },
                        {
                            "kind": "Variable",
                            "name": "unfollowUsers",
                            "variableName": "unfollow"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "SetFeedUserConfigPayload",
            "kind": "LinkedField",
            "name": "setFeedUserConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFeedFollowFeedFollowMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFeedFollowFeedFollowMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "564d8ad9d36377c3d791529bbbb8a24b",
            "id": "5d32fc5b6758b0cdbd537bc59e7432e83998cce61163ae34755c64a402dc367c",
            "metadata": {},
            "name": "useFeedFollowFeedFollowMutation",
            "operationKind": "mutation",
            "text": "mutation useFeedFollowFeedFollowMutation($follow:[ID],$unfollow:[ID]){setFeedUserConfig(input:{followUsers:$follow,unfollowUsers:$unfollow}){success}}"
        }
    };
}();
$2274f77c1a29b092$var$node.hash = "7ecf9b28db7400fffab67e3a3c52027c";
var $2274f77c1a29b092$export$2e2bcd8739ae039 = $2274f77c1a29b092$var$node;
module.exports["default"] = $2274f77c1a29b092$export$2e2bcd8739ae039;

});

parcelRegister("hOSkW", function(module, exports) {
/**
 * @generated SignedSource<<597a7b2d7b3333c8532a887f4cdcbd48>>
 * @relayHash bc87c04b481deeaeaae914ab875dc44e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 11f28c2ff5a1dd7dd27036b76ee213cfc4cc4dc180b6462f1906390361cc096b
const $eeb53afb4cc8b670$var$node = function() {
    var v0 = [
        {
            "concreteType": "FollowingFeedGetUserConfig",
            "kind": "LinkedField",
            "name": "getFeedUserConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "accountIds"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useFeedFollowFeedFollowQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useFeedFollowFeedFollowQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "bc87c04b481deeaeaae914ab875dc44e",
            "id": "11f28c2ff5a1dd7dd27036b76ee213cfc4cc4dc180b6462f1906390361cc096b",
            "metadata": {},
            "name": "useFeedFollowFeedFollowQuery",
            "operationKind": "query",
            "text": "query useFeedFollowFeedFollowQuery{getFeedUserConfig{accountIds}}"
        }
    };
}();
$eeb53afb4cc8b670$var$node.hash = "73bdcd7f6c8309a4d0a16e77fd4c5fed";
var $eeb53afb4cc8b670$export$2e2bcd8739ae039 = $eeb53afb4cc8b670$var$node;
module.exports["default"] = $eeb53afb4cc8b670$export$2e2bcd8739ae039;

});

parcelRegister("bumSD", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $lRkXe = parcelRequire("lRkXe");


var $bp86Z = parcelRequire("bp86Z");

const $226eb0cd9c5c41b1$var$DIRECTORY_GRAPHQL_PATH = '/gateway/api/directory/graphql';
const $226eb0cd9c5c41b1$var$USER_PROFILE_CONFIG = {
    url: $226eb0cd9c5c41b1$var$DIRECTORY_GRAPHQL_PATH,
    cacheSize: 100,
    cacheMaxAge: 300000 // - 5 minutes
};
const $226eb0cd9c5c41b1$export$441fd008df03d370 = (0, $dOBRD.default)((cloudId, _)=>{
    const profileClientConfig = {
        ...$226eb0cd9c5c41b1$var$USER_PROFILE_CONFIG,
        productIdentifier: 'confluence',
        cloudId: cloudId
    };
    return new (0, $lRkXe.default)(profileClientConfig, {
        userClient: new (0, $bp86Z.UserProfileClientForConfluence)(profileClientConfig)
    });
});
module.exports["getProfileClient"] = $226eb0cd9c5c41b1$export$441fd008df03d370;

});

parcelRegister("bp86Z", function(module, exports) {

var $34knR = parcelRequire("34knR");


var $9fywD = parcelRequire("9fywD");


var $7lu50 = parcelRequire("7lu50");


var $ldOrZ = parcelRequire("ldOrZ");


var $2A84u = parcelRequire("2A84u");


var $9jSPN = parcelRequire("9jSPN");


var $c0rhi = parcelRequire("c0rhi");

class $e0ed8187aad1d5de$export$8e0680112f77975e extends (0, $34knR.default) {
    async makeRequest(cloudId, userId) {
        // Note because we are only subclassing "makeRequest()", we are still using UserProfileClient's
        // default "getProfile()" function - which means we automatically get the standard
        // UserProfileClient caching of the full user profile data, including our added properties
        (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).start();
        const UserProfileClientForConfluencePromise = (0, $c0rhi.queryInterop)({
            query: (0, $2A84u.UserProfileClientForConfluenceQuery),
            variables: {
                userId: userId
            },
            __callerPackage__: "profile"
        });
        // If the standard user data query fails, we want to reject the returned promise because there
        // won't be any data for the caller to make a useful ProfileCard.  But if the standard user
        // data query succeeds but External Collaboration data query fails, we want to still display
        // the ProfileCard with the standard user data (that is, we don't want to reject).  In order to
        // do this, we can't use "Promise.all()" because it will return immediately when any of its
        // requests fail.  Instead we need to wait until all of the requests complete or fail, and that
        // means using "Promise.allSettled()", which has a much more complicated return object.
        const [userProfileClientForConfluenceQueryResult, standardUserDataResult] = await Promise.allSettled([
            UserProfileClientForConfluencePromise,
            super.makeRequest(cloudId, userId)
        ]);
        if (standardUserDataResult.status === 'rejected') {
            (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).stop({
                customData: {
                    success: false
                }
            });
            return Promise.reject(standardUserDataResult.reason);
        }
        // If the External Collaboration query was successful and External Collaboration is entitled
        // and this user is an External user, then add our custom Lozenge to the standard user profile
        // data
        const customLozenges = [];
        if (userProfileClientForConfluenceQueryResult.status === 'fulfilled') {
            const confluenceUserResponse = userProfileClientForConfluenceQueryResult.value.data;
            if ((0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(confluenceUserResponse) && confluenceUserResponse?.user?.confluence?.permissionType === (0, $ldOrZ.SitePermissionType).EXTERNAL) customLozenges.push({
                ...(0, $9fywD.ExternalUserLozengeProps),
                key: 'ExternalUserLozenge'
            });
        }
        (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).stop({
            customData: {
                success: true
            }
        });
        return {
            ...standardUserDataResult.value,
            customLozenges: customLozenges
        };
    }
}
module.exports["UserProfileClientForConfluence"] = $e0ed8187aad1d5de$export$8e0680112f77975e;

});

parcelRegister("9fywD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9KSWX = parcelRequire("9KSWX");


var $lpNn5 = parcelRequire("lpNn5");

const $43aed8c383cce8da$var$i18n = (0, $kSwu1.defineMessages)({
    externalUserLozengeText: {
        id: "external-collab-ui.user-guest-lozenge",
        defaultMessage: "Guest"
    },
    guestUserTooltip: {
        id: "external-collab-ui.user-guest-lozenge.tooltip",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    }
});
const $43aed8c383cce8da$export$4de00d985a23014d = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $43aed8c383cce8da$var$i18n.guestUserTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $43aed8c383cce8da$var$i18n.externalUserLozengeText)),
    appearance: 'default',
    isBold: false
};
const $43aed8c383cce8da$export$aa87bb37f13b8b5 = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $43aed8c383cce8da$export$4de00d985a23014d;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalUserLozengeProps"] = $43aed8c383cce8da$export$4de00d985a23014d;
module.exports["ExternalUserLozenge"] = $43aed8c383cce8da$export$aa87bb37f13b8b5;

});

parcelRegister("7lu50", function(module, exports) {
// old definition from tysy - not a real query being used
const $a928a12ca5fd59f3$export$adaf854818ff0d42 = (queryData)=>{
    return queryData?.entitlements?.externalCollaborator.isEntitled;
};
module.exports["getExternalCollaboratorEntitlementFromQuery"] = $a928a12ca5fd59f3$export$adaf854818ff0d42;

});

parcelRegister("ldOrZ", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $0709253cacc9fe3a$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["SitePermissionType"] = $0709253cacc9fe3a$export$8995abb8169b2cb8;

});

parcelRegister("2A84u", function(module, exports) {

var $ay9Uu = parcelRequire("ay9Uu");

const $ab1c6257ac115bcc$export$8322eea6a290b246 = (0, $ay9Uu.default);
module.exports["UserProfileClientForConfluenceQuery"] = $ab1c6257ac115bcc$export$8322eea6a290b246;

});

parcelRegister("ay9Uu", function(module, exports) {
/**
 * @generated SignedSource<<c8072e566be2615c9f169051b183f1d7>>
 * @relayHash e3b7fcde55b949bf8d80bddd9a0ac180
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ee7894fc24fdc7e2f211db85d0b9ca04c99930331a3373b4aec2e287d771850d
const $bb661b120eec94ae$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userId"
        }
    ], v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": false
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "userId"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ExternalCollaboratorFeature",
                    "kind": "LinkedField",
                    "name": "externalCollaborator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "UserProfileClientForConfluenceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "UserProfileClientForConfluenceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "e3b7fcde55b949bf8d80bddd9a0ac180",
            "id": "ee7894fc24fdc7e2f211db85d0b9ca04c99930331a3373b4aec2e287d771850d",
            "metadata": {},
            "name": "UserProfileClientForConfluenceQuery",
            "operationKind": "query",
            "text": "query UserProfileClientForConfluenceQuery($userId:ID){user:confluence_atlassianUser(current:false,id:$userId){id,confluence{permissionType}},entitlements{externalCollaborator{isEntitled}}}"
        }
    };
}();
$bb661b120eec94ae$var$node.hash = "f636f7ede64e4c0d1757767b061d53b5";
var $bb661b120eec94ae$export$2e2bcd8739ae039 = $bb661b120eec94ae$var$node;
module.exports["default"] = $bb661b120eec94ae$export$2e2bcd8739ae039;

});

parcelRegister("9jSPN", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $5487d57e41530957$export$c2710940b43dcf08 = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.PROFILE_CARD_QUERY_CUSTOM_KEY)
});
module.exports["PROFILE_CARD_QUERY_METRIC"] = $5487d57e41530957$export$c2710940b43dcf08;

});

parcelRegister("lSOAM", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");


var $8RwKN = parcelRequire("8RwKN");


var $64KID = parcelRequire("64KID");


var $fQ3iN = parcelRequire("fQ3iN");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    (0, $64KID.namedRoutes).HOME.name,
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $8RwKN.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const $2a47a9fc48674e91$export$c5aa7fcaede4a84d = (0, $iDdTC.metrics).pageLoad;
const $2a47a9fc48674e91$export$19ba7be4fcf34f3d = (0, $iDdTC.metrics).custom;
const $2a47a9fc48674e91$export$36d7a61d0660e29c = (0, $iDdTC.metrics).interaction;
const $2a47a9fc48674e91$var$concurrent = (0, $iDdTC.metrics).concurrent;
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["createPageLoadMetric"] = $2a47a9fc48674e91$export$c5aa7fcaede4a84d;
module.exports["createCustomMetric"] = $2a47a9fc48674e91$export$19ba7be4fcf34f3d;
module.exports["createInteractionMetric"] = $2a47a9fc48674e91$export$36d7a61d0660e29c;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("iDdTC", function(module, exports) {

var $9aI7t = parcelRequire("9aI7t");


var $b94r6 = parcelRequire("b94r6");

const $ffb05ca8baf9d9e1$export$b0c5c2fac8144e54 = {
    pageLoad: $b94r6.pageLoad,
    pageSegmentLoad: $b94r6.pageSegmentLoad,
    interaction: $b94r6.interaction,
    custom: $b94r6.custom,
    concurrent: $9aI7t.concurrent
};
module.exports["metrics"] = $ffb05ca8baf9d9e1$export$b0c5c2fac8144e54;

});

parcelRegister("9aI7t", function(module, exports) {

var $lCTbz = parcelRequire("lCTbz");


var $b94r6 = parcelRequire("b94r6");

const $95763ae236d73d99$var$concurrentMetrics = {};
const $95763ae236d73d99$var$getKey = (config, type)=>`${type}--${config.key}`;
const $95763ae236d73d99$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $95763ae236d73d99$var$ensurePath = (config, type)=>{
    const key = $95763ae236d73d99$var$getKey(config, type);
    if (!(key in $95763ae236d73d99$var$concurrentMetrics)) $95763ae236d73d99$var$concurrentMetrics[key] = {};
};
const $95763ae236d73d99$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $95763ae236d73d99$var$getKey(config, type);
    if (concurrentKey in $95763ae236d73d99$var$concurrentMetrics && $95763ae236d73d99$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $95763ae236d73d99$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $95763ae236d73d99$var$concurrentMetrics)) $95763ae236d73d99$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $95763ae236d73d99$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $95763ae236d73d99$var$validateConfig(config);
    $95763ae236d73d99$var$ensurePath(config, type);
    const metricFromCache = $95763ae236d73d99$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $lCTbz.BMEventsType).INLINE_RESULT ? (0, $b94r6.interaction) : (0, $b94r6.custom);
    const metric = metricFactory(config);
    $95763ae236d73d99$var$concurrentMetrics[$95763ae236d73d99$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $95763ae236d73d99$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).CUSTOM)
};
module.exports["concurrent"] = $95763ae236d73d99$export$370df09ecc3de059;

});

parcelRegister("b94r6", function(module, exports) {

var $ipFlS = parcelRequire("ipFlS");


var $3L5Pu = parcelRequire("3L5Pu");


var $h51B5 = parcelRequire("h51B5");


var $lCTbz = parcelRequire("lCTbz");

const $01df368966019ba1$export$791d520f7e8058a5 = (config)=>{
    return new (0, $3L5Pu.PageLoadMetric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).PAGE_LOAD
    });
};
const $01df368966019ba1$export$94114666844d5f66 = (config)=>{
    return new (0, $h51B5.PageSegmentLoadMetric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
const $01df368966019ba1$export$92473e6020ad89b4 = (config)=>{
    return new (0, $ipFlS.Metric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).INLINE_RESULT
    });
};
const $01df368966019ba1$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $ipFlS.Metric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).CUSTOM
    });
};
module.exports["pageLoad"] = $01df368966019ba1$export$791d520f7e8058a5;
module.exports["pageSegmentLoad"] = $01df368966019ba1$export$94114666844d5f66;
module.exports["interaction"] = $01df368966019ba1$export$92473e6020ad89b4;
module.exports["custom"] = $01df368966019ba1$export$4c00f665f0d4b443;

});

parcelRegister("ipFlS", function(module, exports) {

var $hvVQt = parcelRequire("hvVQt");


var $581yf = parcelRequire("581yf");


var $7IphZ = parcelRequire("7IphZ");

class $4db3d4178d03c3ea$export$efdd3e096bc27746 extends (0, $7IphZ.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $hvVQt.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $581yf.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}
module.exports["Metric"] = $4db3d4178d03c3ea$export$efdd3e096bc27746;

});

parcelRegister("3L5Pu", function(module, exports) {

var $97AWA = parcelRequire("97AWA");


var $jk8rA = parcelRequire("jk8rA");


var $hvVQt = parcelRequire("hvVQt");


var $581yf = parcelRequire("581yf");


var $lCTbz = parcelRequire("lCTbz");


var $2QFOI = parcelRequire("2QFOI");


var $wgCbG = parcelRequire("wgCbG");


var $eNslE = parcelRequire("eNslE");

class $bbca0ae0eaeecc15$export$3c51073271a9eac3 extends (0, $2QFOI.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $wgCbG.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $wgCbG.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $wgCbG.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $2QFOI.BasePageLoadMetric).FMP]) {
                const mark = (0, $97AWA.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $wgCbG.pageLoadMetaMetric).markFMP(mark);
            } else (0, $wgCbG.pageLoadMetaMetric).markFMP(this.marks[(0, $2QFOI.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $hvVQt.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $581yf.submitter).queue(data);
        (0, $jk8rA.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $wgCbG.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $wgCbG.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $wgCbG.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $581yf.submitter).config.configChunk;
        if (!configChunk?.[(0, $lCTbz.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $eNslE.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $581yf.submitter).queue(webVitalMetric.getData());
        (0, $jk8rA.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}
module.exports["PageLoadMetric"] = $bbca0ae0eaeecc15$export$3c51073271a9eac3;

});

parcelRegister("eNslE", function(module, exports) {

var $lCTbz = parcelRequire("lCTbz");


var $7IphZ = parcelRequire("7IphZ");

class $23d0f6650a8bd5e3$export$dc0d85d4d6503cd7 extends (0, $7IphZ.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $lCTbz.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $7IphZ.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}
module.exports["WebVitalsMetric"] = $23d0f6650a8bd5e3$export$dc0d85d4d6503cd7;

});

parcelRegister("h51B5", function(module, exports) {

var $97AWA = parcelRequire("97AWA");


var $lCTbz = parcelRequire("lCTbz");


var $7IphZ = parcelRequire("7IphZ");


var $ipFlS = parcelRequire("ipFlS");


var $wgCbG = parcelRequire("wgCbG");

class $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1 extends (0, $ipFlS.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $wgCbG.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $wgCbG.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $97AWA.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $lCTbz.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $7IphZ.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $7IphZ.MetricState).STARTED) (0, $wgCbG.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP = 'fmp';
module.exports["PageSegmentLoadMetric"] = $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1;

});

parcelRegister("fQ3iN", function(module, exports) {
/**
 * BM3 Deprecation Phase 2 — gated wrapper around the raw BM3 page-segment-load factory.
 *
 * This file is the canonical implementation behind the public name
 * `createPageSegmentLoadMetric` (re-exported from
 * `@confluence/browser-metrics/entry-points/metricConfigs.ts`). All Confluence consumers
 * call the gated variant by virtue of importing the public name; there is no separate
 * "raw" public entry point.
 *
 * When the `cc_bm3_deprecation_phase_2` gate is OFF (default), every method call delegates
 * verbatim to the underlying BM3 PageSegmentLoadMetric so existing behaviour and the BM3
 * `PAGE_SEGMENT_LOAD` analytics events are preserved.
 *
 * When the gate is ON, the BM3 calls are skipped and equivalent UFO custom marks / custom
 * data are emitted instead. This lets us roll out the removal of the BM3 page-segment-load
 * events incrementally — controlled by Statsig — without touching any of the ~25
 * perf.config files or ~20 imperative call sites. Consumers continue to use
 * `METRIC.start()`, `.stop()`, `.cancel()`, `.mark()`, `.markFMP()`,
 * `.startFromPageLoad()` exactly as before; the gate decision is centralised here.
 *
 * The gate `fg(...)` is evaluated **inline at the callsite of each method**, never aliased
 * or wrapped, in line with the feature-gate-and-experiment-usage AGENTS guidance. Per-method
 * (rather than per-construction) evaluation is required because perf.config modules are
 * imported very early in app boot — earlier than Statsig data is loaded — so a one-shot
 * `fg()` call at construction time would always read the default (false) value.
 *
 * Implementation note: rather than returning a *new* wrapper object, this helper mutates
 * the real BM3 metric instance by overriding selected methods with bound functions that
 * consult the gate. This preserves the metric's class identity, prototype chain, and
 * private internal state so it remains a fully drop-in substitute everywhere a BM3
 * PageSegmentLoadMetric is used (including in `pageLoadMetric.include[]` / `until[]`
 * arrays where BM3 walks the internal experience graph).
 *
 * Once the gate has fully ramped, this file's body will be replaced with a UFO-only
 * implementation and the BM3 dependency removed entirely.
 */ 
var $3PNw6 = parcelRequire("3PNw6");


var $l6Cdg = parcelRequire("l6Cdg");


var $9wGTI = parcelRequire("9wGTI");


var $3YpC9 = parcelRequire("3YpC9");


var $kw6I9 = parcelRequire("kw6I9");

function $a96d58ddd476e3f0$export$34f706592a2f7442(config) {
    const metric = (0, $kw6I9.createBM3PageSegmentLoadMetricRaw)(config);
    const key = config.key;
    // Capture the original methods before overriding them.
    const realStart = metric.start.bind(metric);
    const realStartFromPageLoad = metric.startFromPageLoad.bind(metric);
    const realStop = metric.stop.bind(metric);
    const realCancel = metric.cancel.bind(metric);
    const realMark = metric.mark.bind(metric);
    const realMarkFMP = metric.markFMP.bind(metric);
    metric.start = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $l6Cdg.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStart(...args);
    };
    metric.startFromPageLoad = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $l6Cdg.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`);
            return;
        }
        return realStartFromPageLoad(...args);
    };
    metric.stop = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            (0, $l6Cdg.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            const opts = args[0];
            if (opts?.customData) (0, $3PNw6.addUFOCustomData)(opts.customData);
            return true;
        }
        return realStop(...args);
    };
    metric.cancel = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            // Note - there's no equivalent for cancel in UFO, so we use the end mark instead.
            (0, $l6Cdg.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`);
            return;
        }
        return realCancel(...args);
    };
    metric.mark = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [name, timestamp] = args;
            (0, $l6Cdg.addUFOCustomMark)(name, timestamp);
            return;
        }
        return realMark(...args);
    };
    metric.markFMP = (...args)=>{
        if ((0, $9wGTI.fg)('cc_bm3_deprecation_phase_2')) {
            const [timestamp] = args;
            (0, $l6Cdg.addUFOCustomMark)(`fmp:${key}`, timestamp);
            return;
        }
        return realMarkFMP(...args);
    };
    return metric;
}
module.exports["createPageSegmentLoadMetric"] = $a96d58ddd476e3f0$export$34f706592a2f7442;

});

parcelRegister("3YpC9", function(module, exports) {
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';
module.exports["PAGE_SEGMENT_MARK_PREFIX_START"] = $4dbe182ee19642b3$export$f59b3ea823fcdb3d;
module.exports["PAGE_SEGMENT_MARK_PREFIX_END"] = $4dbe182ee19642b3$export$a217b163593f51a;

});

parcelRegister("kw6I9", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");

const $864083edfead32eb$export$2a2fe1e11b4e0413 = (0, $iDdTC.metrics).pageSegmentLoad;
module.exports["createBM3PageSegmentLoadMetricRaw"] = $864083edfead32eb$export$2a2fe1e11b4e0413;

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("fd6g2", function(module, exports) {
// "confluence.fe.custom.XXX"
const $88f9a74d7687653d$export$3fe4a04f712fdf3b = 'mentions-query';
const $88f9a74d7687653d$export$18a3d3c084ff47d0 = 'profile-card-query';
const $88f9a74d7687653d$export$95463e4d15a0dca9 = 'legacy-extension-loading';
const $88f9a74d7687653d$export$5a66bfdc2ac06329 = 'fabric-publish-page';
const $88f9a74d7687653d$export$96dfe3e664538004 = 'time-to-app-idle';
const $88f9a74d7687653d$export$18a3e97ff841447b = 'share-notif-from-restrictions';
const $88f9a74d7687653d$export$d0eb1faf5fa0dbc7 = 'tc-events-fetch';
const $88f9a74d7687653d$export$ec119fee4dbc7f75 = 'tc-subcals-fetch';
const $88f9a74d7687653d$export$5e0f3443b5224f1d = 'ai-snippet-hover-card';
const $88f9a74d7687653d$export$693c7d831f137ed3 = 'tc-jira-projects-fetch';
module.exports["MENTIONS_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$3fe4a04f712fdf3b;
module.exports["PROFILE_CARD_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$18a3d3c084ff47d0;
module.exports["LEGACY_EXTENSION_LOADING_CUSTOM_KEY"] = $88f9a74d7687653d$export$95463e4d15a0dca9;
module.exports["FABRIC_PUBLISH_PAGE_KEY"] = $88f9a74d7687653d$export$5a66bfdc2ac06329;
module.exports["TIME_TO_APP_IDLE_KEY"] = $88f9a74d7687653d$export$96dfe3e664538004;
module.exports["TEAM_CALENDARS_EVENT_FETCH_KEY"] = $88f9a74d7687653d$export$d0eb1faf5fa0dbc7;
module.exports["TEAM_CALENDARS_SUBCALS_FETCH_KEY"] = $88f9a74d7687653d$export$ec119fee4dbc7f75;
module.exports["TEAM_CALENDARS_JIRA_PROJECTS_FETCH_KEY"] = $88f9a74d7687653d$export$693c7d831f137ed3;

});

parcelRegister("4qzKl", function(module, exports) {
// TODO: remove once @confluence-classic/confluence-urls is added to next

var $jlIaF = parcelRequire("jlIaF");

const $7b986e69785602e5$export$3b6a64cfeda8b00 = (accountId, src, context = '')=>{
    if (!accountId) return '';
    return `${context}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$5f1a0e9946984804 = async (accountId, src)=>{
    if (!accountId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$cb80ef5511478588 = (teamId, src, context = '')=>{
    if (!teamId) return '';
    return `${context}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$470c1413f7223a06 = async (teamId, src)=>{
    if (!teamId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
// Replacement for the getAttributeNames DOM API since it's not supported by IE
const $7b986e69785602e5$var$getAttributeNames = (element)=>Array.from(element.attributes).map((attribute)=>attribute.name);
// Return only DOM elements that have the data-account-id attribute
const $7b986e69785602e5$var$withAccountId = (element)=>element.getAttribute('data-account-id');
// Returns React props that can be used to recreate a DOM element
const $7b986e69785602e5$var$getReactPropsFromDOMElement = (element)=>{
    const attributeToProp = {
        class: 'className'
    };
    const props = {};
    $7b986e69785602e5$var$getAttributeNames(element).forEach((attribute)=>{
        props[attributeToProp[attribute] || attribute] = element.getAttribute(attribute);
    });
    props.dangerouslySetInnerHTML = {
        __html: element.innerHTML
    };
    return props;
};
function $7b986e69785602e5$export$a98860edfb97e545(userElements) {
    return userElements.filter($7b986e69785602e5$var$withAccountId).map((element)=>{
        const props = $7b986e69785602e5$var$getReactPropsFromDOMElement(element);
        // Set this attribute to stop the old user profile hovers from binding
        props['data-user-hover-bound'] = 'true';
        // Ensure that links go to the same location as the profile card
        props.href = $7b986e69785602e5$export$3b6a64cfeda8b00(props['data-account-id'], null);
        const placeholder = window.document.createElement('span');
        if (!element.parentNode) return {};
        element.parentNode.replaceChild(placeholder, element);
        return {
            props: props,
            placeholder: placeholder
        };
    });
}
module.exports["getAtlassianPeopleProfileUrl"] = $7b986e69785602e5$export$3b6a64cfeda8b00;
module.exports["getAtlassianPeopleProfileUrlAsync"] = $7b986e69785602e5$export$5f1a0e9946984804;
module.exports["getTeamUrl"] = $7b986e69785602e5$export$cb80ef5511478588;
module.exports["replaceUserElementsWithPlaceholders"] = $7b986e69785602e5$export$a98860edfb97e545;

});

parcelRegister("gj42z", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $kSwu1 = parcelRequire("kSwu1");


var $b3j2Y = parcelRequire("b3j2Y");


var $gqqjz = parcelRequire("gqqjz");

const $3ade761a05c1a959$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    followMutationErrorTitle: {
        id: "profile.card.feed.follow.mutation.error.title",
        defaultMessage: "We\u2019re having trouble doing that"
    },
    followMutationErrorDescription: {
        id: "profile.card.feed.follow.mutation.error.description",
        defaultMessage: "Try following or unfollowing this user again "
    }
});
const $3ade761a05c1a959$export$cb92340e76dc7cda = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { feedConfigError: feedConfigError, mutationError: mutationError, showErrorFlag: showErrorFlag } = t0;
    let t1;
    if ($[0] !== feedConfigError) {
        t1 = feedConfigError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: feedConfigError
        }) : null;
        $[0] = feedConfigError;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== mutationError || $[3] !== showErrorFlag) {
        t2 = mutationError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: mutationError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: [
                (0, $gqqjz.FlagsStateContainer)
            ]
        }, (flags)=>{
            if (showErrorFlag) flags.showErrorFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorDescription)
            });
            return null;
        })) : null;
        $[2] = mutationError;
        $[3] = showErrorFlag;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1, t2);
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
module.exports["FeedFollowErrorDisplay"] = $3ade761a05c1a959$export$cb92340e76dc7cda;

});

parcelRegister("70pcM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3mVfX = parcelRequire("3mVfX");


var $jmjWc = parcelRequire("jmjWc");


var $8zMP3 = parcelRequire("8zMP3");


const $21986f05fdcd4f3c$var$ObjectCommentContainerLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "zDMTR",
    name: "ObjectCommentContainerLoader",
    loader: async ()=>(await (parcelRequire("ekvOS"))).ObjectCommentContainer
});
const $21986f05fdcd4f3c$export$5a58d81bd405c4ec = ({ showGeneralComment: showGeneralComment, pageWidthType: pageWidthType, showLabels: showLabels, hasReactions: hasReactions, editorIsUserOffline: editorIsUserOffline, hasCommentSessions: hasCommentSessions })=>{
    const { setShowGeneralComments: setShowGeneralComments } = (0, $3mVfX.useCommentsPanelActions)();
    (0, $cozmU.useEffect)(()=>{
        setShowGeneralComments(showGeneralComment);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- we only want to set the comment type once on the comment mount
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
        dataFetcherName: "object-comments"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($21986f05fdcd4f3c$var$ObjectCommentContainerLoader, {
        pageWidthType: pageWidthType,
        showLabels: showLabels,
        hasReactions: hasReactions,
        editorIsUserOffline: editorIsUserOffline,
        hasCommentSessions: hasCommentSessions
    }));
};
module.exports["ObjectCommentWrapper"] = $21986f05fdcd4f3c$export$5a58d81bd405c4ec;

});

parcelRegister("ekvOS", function(module, exports) {

let $a6eb9da50bee8fc6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a6eb9da50bee8fc6$var$load("ig9dh"),
    $a6eb9da50bee8fc6$var$load("hA8hA"),
    $a6eb9da50bee8fc6$var$load("ddvkk"),
    $a6eb9da50bee8fc6$var$load("3upHR"),
    $a6eb9da50bee8fc6$var$load("6wr18"),
    $a6eb9da50bee8fc6$var$load("lsOq1"),
    $a6eb9da50bee8fc6$var$load("agdLZ"),
    $a6eb9da50bee8fc6$var$load("kxG0W"),
    $a6eb9da50bee8fc6$var$load("byAMe"),
    $a6eb9da50bee8fc6$var$load("l1HBI"),
    $a6eb9da50bee8fc6$var$load("gYeBT"),
    $a6eb9da50bee8fc6$var$load("4W6oq"),
    $a6eb9da50bee8fc6$var$load("dlm6q"),
    $a6eb9da50bee8fc6$var$load("jzUgs"),
    $a6eb9da50bee8fc6$var$load("7EorR"),
    $a6eb9da50bee8fc6$var$load("jqoep"),
    $a6eb9da50bee8fc6$var$load("ffEVr"),
    $a6eb9da50bee8fc6$var$load("gzrfp"),
    $a6eb9da50bee8fc6$var$load("79Tk4"),
    $a6eb9da50bee8fc6$var$load("gVVrO"),
    $a6eb9da50bee8fc6$var$load("6KRyd"),
    $a6eb9da50bee8fc6$var$load("01KnF")
]).then(()=>parcelRequire('5CNGn'));

});

parcelRegister("85rxh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $bf7e99398a94595e$export$2cbe7bfb10d82597 = (cloudId, userId, orgId)=>{
    return (0, $cozmU.useCallback)((purpose)=>{
        if (purpose === 'rovo-agent') return {
            contentURL: window.location.origin + window.location.pathname,
            cloudId: cloudId,
            userId: userId,
            orgId: orgId
        };
        return null;
    }, [
        cloudId,
        userId,
        orgId
    ]);
};
module.exports["useGetChannelVariables"] = $bf7e99398a94595e$export$2cbe7bfb10d82597;

});

parcelRegister("59NtD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ieeJu = parcelRequire("ieeJu");


var $7mpOv = parcelRequire("7mpOv");

function $3a67abb687c46b2c$export$8f887a582517d0da({ cloudId: cloudId, isRovoEnabled: isRovoEnabled, editorAPI: editorAPI, contentId: contentId, showAllSkills: showAllSkills = true, allowedSkills: allowedSkills, onSkillSelected: onSkillSelected, onAnalyticsEvent: onAnalyticsEvent }) {
    const { isAIEnabledForContent: isAIEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    // Keep a ref to the latest editorAPI so callbacks always read the
    // current value at invocation time, regardless of when the config
    // was memoised or cached by upstream consumers.
    const editorAPIRef = (0, $cozmU.useRef)(editorAPI);
    editorAPIRef.current = editorAPI;
    const defaultOnAnalyticsEvent = (0, $cozmU.useCallback)((payload)=>{
        const api = editorAPIRef.current;
        api?.analytics?.actions?.fireAnalyticsEvent(payload);
    }, []);
    return (0, $cozmU.useMemo)(()=>{
        // Read isInDocumentStreamingEnabled from the AI plugin shared state.
        // This value is set once during plugin initialisation and does not change,
        // so a synchronous read inside useMemo is safe.
        const aiState = editorAPI?.aiExperience?.sharedState?.currentState();
        const isInDocumentStreamingEnabled = aiState?.aiDecorationExperiencePluginState?.isInDocumentStreamingEnabled ?? false;
        if (!isRovoEnabled || !isAIEnabledForContent || !cloudId || !isInDocumentStreamingEnabled || !(0, $ieeJu.expValEquals)('platform_editor_insert_menu_ai', 'isEnabled', true)) return undefined;
        const handleSkillSelected = onSkillSelected ?? ((slashCommand, skill)=>{
            setTimeout(()=>{
                const api = editorAPIRef.current;
                const command = api?.aiExperience?.actions?.handleSkillSelected(slashCommand, skill);
                if (command !== undefined) api?.core?.actions.execute(command);
            }, 0);
        });
        return {
            enabled: true,
            cloudId: cloudId,
            showAllSkills: showAllSkills,
            allowedSkills: allowedSkills,
            onSkillSelected: handleSkillSelected,
            onAnalyticsEvent: onAnalyticsEvent ?? defaultOnAnalyticsEvent
        };
    }, [
        isRovoEnabled,
        isAIEnabledForContent,
        cloudId,
        editorAPI,
        showAllSkills,
        allowedSkills,
        onSkillSelected,
        onAnalyticsEvent,
        defaultOnAnalyticsEvent
    ]);
}
module.exports["useRovoSkillsConfig"] = $3a67abb687c46b2c$export$8f887a582517d0da;

});

parcelRegister("1NbQn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $53f32890288a0cee$export$72a52078406bf49d({ isUnpublishedDraft: isUnpublishedDraft, contentType: contentType, editorActions: editorActions, editorType: editorType, initialShouldFocusEditor: initialShouldFocusEditor = true }) {
    // TODO: replace some of these arbitrary state values from graphQL query
    /**
	 * @todo CTE-268 typing in title is slow with in-editor templates (long term solution)
	 * For now, we are solving this by debouncing calls to the onTitleChange function inside EditorTitle
	 * Debouncing has some drawbacks for collaborators, so we only want this optimization when
	 * the template panel could be open
	 */ const debounceTitleChangeUpdates = isUnpublishedDraft && contentType === 'page';
    const isTemplateEditor = editorType === 'template';
    const [isTitleFocused, setIsTitleFocused] = (0, $cozmU.useState)(null);
    const [shouldFocusEditor, setShouldFocusEditor] = (0, $cozmU.useState)(initialShouldFocusEditor);
    // This function is only called when "tab" or "enter" is pressed when focused in the title
    const focusEditor = (0, $cozmU.useCallback)(()=>{
        setIsTitleFocused(false);
        setShouldFocusEditor(true);
    }, []);
    const onFocusChanged = (0, $cozmU.useCallback)((_isTitleFocused)=>{
        setIsTitleFocused(_isTitleFocused);
        // we disable editor when title is focused
        // re-enabling editor leads to force focus set on it
        // this leads to focus bugs when clicking on other inputs
        // so we explicitly disable editor focus here
        setShouldFocusEditor(false);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        // focus editor ONLY when forced to.
        // Losing title focus should NOT require forcing an editor focus
        // (in the case of backtabbing or clicking on a different button)
        // TODO: CTE-2423 remove editorType check once Confluence adopts editor version Rambo (with media focus bug fix)
        if (!isTitleFocused && shouldFocusEditor && !isTemplateEditor) editorActions.focus({
            scrollIntoView: false
        });
    }, [
        editorActions,
        isTitleFocused,
        shouldFocusEditor,
        isTemplateEditor
    ]);
    return (0, $cozmU.useMemo)(()=>({
            isTitleFocused: isTitleFocused,
            shouldFocusEditor: shouldFocusEditor,
            debounceTitleChangeUpdates: debounceTitleChangeUpdates,
            focusEditor: focusEditor,
            onFocusChanged: onFocusChanged
        }), [
        isTitleFocused,
        shouldFocusEditor,
        debounceTitleChangeUpdates,
        focusEditor,
        onFocusChanged
    ]);
}
module.exports["useEditorTitleFocus"] = $53f32890288a0cee$export$72a52078406bf49d;

});

parcelRegister("nIvaQ", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $fXb84 = parcelRequire("fXb84");


var $7ZQNA = parcelRequire("7ZQNA");

const $c4f625141049567c$export$1248f2ac56981fbd = ()=>(0, $6mKj3.expValEquals)('platform_editor_early_exit_return_draft', 'isEnabled', true) ? (0, $fXb84.CollabDraftWithRelevanceQuery) : (0, $7ZQNA.CollabDraftQuery);
module.exports["getCollabDraftQuery"] = $c4f625141049567c$export$1248f2ac56981fbd;

});

parcelRegister("fXb84", function(module, exports) {

var $kiLxw = parcelRequire("kiLxw");

const $abbff5e8c5475947$export$fb92c84fb9714700 = (0, $kiLxw.default);
module.exports["CollabDraftWithRelevanceQuery"] = $abbff5e8c5475947$export$fb92c84fb9714700;

});

parcelRegister("kiLxw", function(module, exports) {
/**
 * @generated SignedSource<<c2d68d945c3fe4452d03d6bdc8ddfd5c>>
 * @relayHash 5eb9ba691ed48d80122a8d87074eee9c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 19ff778aa0cc634375733dc31cf334d93ce6c8c4e3dd7bf786f4393165965ee1
const $ff1e82bf0b897703$var$node = function() {
    var v0 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hydrateAdf"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "hydrateAdf",
                    "variableName": "hydrateAdf"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "CollabDraft",
            "kind": "LinkedField",
            "name": "collabDraft",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "document"
                },
                {
                    "kind": "ScalarField",
                    "name": "version"
                },
                {
                    "concreteType": "CollabDraftMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "relevance"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CollabDraftWithRelevanceQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CollabDraftWithRelevanceQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "5eb9ba691ed48d80122a8d87074eee9c",
            "id": "19ff778aa0cc634375733dc31cf334d93ce6c8c4e3dd7bf786f4393165965ee1",
            "metadata": {},
            "name": "CollabDraftWithRelevanceQuery",
            "operationKind": "query",
            "text": "query CollabDraftWithRelevanceQuery($id:ID!,$draftShareId:String=\"\",$hydrateAdf:Boolean){collabDraft(id:$id,draftShareId:$draftShareId,hydrateAdf:$hydrateAdf){document,version,metadata{title,relevance}}}"
        }
    };
}();
$ff1e82bf0b897703$var$node.hash = "c0bfcca7b64103265224238d7c18d9b1";
var $ff1e82bf0b897703$export$2e2bcd8739ae039 = $ff1e82bf0b897703$var$node;
module.exports["default"] = $ff1e82bf0b897703$export$2e2bcd8739ae039;

});

parcelRegister("7ZQNA", function(module, exports) {

var $lU81J = parcelRequire("lU81J");

const $270318977b9095e1$export$89183b1b5e58f33c = (0, $lU81J.default);
module.exports["CollabDraftQuery"] = $270318977b9095e1$export$89183b1b5e58f33c;

});

parcelRegister("lU81J", function(module, exports) {
/**
 * @generated SignedSource<<81d932c04171cccd3ee1c517fa2180ce>>
 * @relayHash cd92794db2ea2a3b9bfa36b4fb9ae833
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 44e85cfd7f416b92fd30c810982ddfc4aeaa8b9ab964fe47829b79185c29b63a
const $e1affc2f9f206abd$var$node = function() {
    var v0 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hydrateAdf"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "hydrateAdf",
                    "variableName": "hydrateAdf"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "CollabDraft",
            "kind": "LinkedField",
            "name": "collabDraft",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "document"
                },
                {
                    "kind": "ScalarField",
                    "name": "version"
                },
                {
                    "concreteType": "CollabDraftMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CollabDraftQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CollabDraftQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "cd92794db2ea2a3b9bfa36b4fb9ae833",
            "id": "44e85cfd7f416b92fd30c810982ddfc4aeaa8b9ab964fe47829b79185c29b63a",
            "metadata": {},
            "name": "CollabDraftQuery",
            "operationKind": "query",
            "text": "query CollabDraftQuery($id:ID!,$draftShareId:String=\"\",$hydrateAdf:Boolean){collabDraft(id:$id,draftShareId:$draftShareId,hydrateAdf:$hydrateAdf){document,version,metadata{title}}}"
        }
    };
}();
$e1affc2f9f206abd$var$node.hash = "3cf6959ca06a0e7e4a4e60e0c720b14e";
var $e1affc2f9f206abd$export$2e2bcd8739ae039 = $e1affc2f9f206abd$var$node;
module.exports["default"] = $e1affc2f9f206abd$export$2e2bcd8739ae039;

});

parcelRegister("fqIt3", function(module, exports) {
const $3014a7cdda499b2d$var$collabDraftFetchTimestamps = new Map();
// TTL for CollabDraftQuery cached data
// This prevents stale data during SPA transitions while still allowing
// cache-first for SSR-rendered pages within the TTL window
const $3014a7cdda499b2d$var$COLLAB_DRAFT_TTL_MS = 15000;
/**
 * Creates a composite cache key that includes both contentId and draftShareId.
 * This aligns with how Apollo caches queries by their variables.
 */ const $3014a7cdda499b2d$var$getCacheKey = (contentId, draftShareId)=>{
    return `${contentId}:${draftShareId || ''}`;
};
function $3014a7cdda499b2d$export$76901333d647261(contentId, draftShareId) {
    const key = $3014a7cdda499b2d$var$getCacheKey(contentId, draftShareId);
    const lastFetchTime = $3014a7cdda499b2d$var$collabDraftFetchTimestamps.get(key);
    if (!lastFetchTime) return true;
    return Date.now() - lastFetchTime > $3014a7cdda499b2d$var$COLLAB_DRAFT_TTL_MS;
}
function $3014a7cdda499b2d$export$85437e97168f99bc(contentId, draftShareId) {
    const key = $3014a7cdda499b2d$var$getCacheKey(contentId, draftShareId);
    $3014a7cdda499b2d$var$collabDraftFetchTimestamps.set(key, Date.now());
}
function $3014a7cdda499b2d$export$5f725cb33e7218ab(contentId, draftShareId) {
    const key = $3014a7cdda499b2d$var$getCacheKey(contentId, draftShareId);
    $3014a7cdda499b2d$var$collabDraftFetchTimestamps.delete(key);
}
function $3014a7cdda499b2d$export$a379bfa68f31645e() {
    $3014a7cdda499b2d$var$collabDraftFetchTimestamps.clear();
}
module.exports["isCollabDraftCacheStale"] = $3014a7cdda499b2d$export$76901333d647261;
module.exports["markCollabDraftFetched"] = $3014a7cdda499b2d$export$85437e97168f99bc;
module.exports["clearCollabDraftTimestamp"] = $3014a7cdda499b2d$export$5f725cb33e7218ab;

});

parcelRegister("lvOsp", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $7EPz1 = parcelRequire("7EPz1");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $eqEJl = parcelRequire("eqEJl");


var $8BQV6 = parcelRequire("8BQV6");


var $422HI = parcelRequire("422HI");


var $26Yfd = parcelRequire("26Yfd");


var $kczYx = parcelRequire("kczYx");


var $iffSy = parcelRequire("iffSy");


var $3NBsC = parcelRequire("3NBsC");


var $5T18X = parcelRequire("5T18X");


var $86okN = parcelRequire("86okN");


var $iF5wn = parcelRequire("iF5wn");


var $bFdYQ = parcelRequire("bFdYQ");


var $3VgTg = parcelRequire("3VgTg");


var $7M67g = parcelRequire("7M67g");

/** Synced-each-render ref; no microtask lag. */ function $278c8d04dad7bc1d$var$useSyncedRef(value) {
    const ref = (0, $cozmU.useRef)(value);
    ref.current = value;
    return ref;
}
/**
 * Coerce an unknown thrown value into an ApolloErrorInterop so callers can
 * read Apollo's `graphQLErrors` / `networkError` fields uniformly across the
 * Apollo and Relay branches.
 */ function $278c8d04dad7bc1d$var$toApolloError(err) {
    if ((0, $422HI.isApolloError)(err)) return err;
    const networkError = err instanceof Error ? err : new Error(String(err));
    return new (0, $422HI.ApolloErrorInterop)({
        networkError: networkError
    });
}
function $278c8d04dad7bc1d$var$getOperationName(node) {
    if ('definitions' in node) {
        const def = node.definitions?.find((d)=>d.kind === 'OperationDefinition' && 'name' in d);
        return def?.name?.value ?? 'unknown';
    }
    return 'unknown';
}
function $278c8d04dad7bc1d$export$363a8d7f501f3769(query, options) {
    const operationName = (0, $7M67g.getRelayOperationName)(query);
    if ((0, $iffSy.isRelayEnabled)(options?.__callerPackage__, {
        operationName: operationName,
        phase: 'lazy'
    })) // eslint-disable-next-line react-hooks/rules-of-hooks -- Apollo/Relay route is branch-stable for a given caller package.
    return $278c8d04dad7bc1d$var$useLazyQueryInteropRelay(query, options);
    // eslint-disable-next-line react-hooks/rules-of-hooks -- Apollo/Relay route is branch-stable for a given caller package.
    return $278c8d04dad7bc1d$var$useLazyQueryInteropApollo(query, options);
}
const $278c8d04dad7bc1d$var$useLazyQueryInteropApollo = (0, $3u0dr.isReactCompilerActiveV2)() ? function useLazyQueryInteropApollo(query, options) {
    const $ = (0, $bDgLe.c)(49);
    let t0;
    if ($[0] !== options) {
        t0 = options ?? {};
        $[0] = options;
        $[1] = t0;
    } else t0 = $[1];
    let apolloOptions;
    let interopApolloAggClient;
    if ($[2] !== t0) {
        ({ interopApolloAggClient: interopApolloAggClient, ...apolloOptions } = t0);
        $[2] = t0;
        $[3] = apolloOptions;
        $[4] = interopApolloAggClient;
    } else {
        apolloOptions = $[3];
        interopApolloAggClient = $[4];
    }
    const t1 = options?.__callerPackage__;
    let t2;
    if ($[5] !== apolloOptions.fetchPolicy || $[6] !== apolloOptions.onCompleted || $[7] !== apolloOptions.variables || $[8] !== interopApolloAggClient || $[9] !== query || $[10] !== t1) {
        t2 = {
            query: query,
            variables: apolloOptions.variables,
            fetchPolicy: apolloOptions.fetchPolicy,
            useAggClient: interopApolloAggClient,
            onCompleted: apolloOptions.onCompleted,
            callerPackage: t1
        };
        $[5] = apolloOptions.fetchPolicy;
        $[6] = apolloOptions.onCompleted;
        $[7] = apolloOptions.variables;
        $[8] = interopApolloAggClient;
        $[9] = query;
        $[10] = t1;
        $[11] = t2;
    } else t2 = $[11];
    const { getLatestVariables: getLatestVariables, getVariables: getCacheBridgeVariables, isEnabled: isCacheBridgeEnabled, onCompleted: onApolloCompletedWithCacheBridge, syncObservedResult: syncObservedResult, updateLatestVariables: updateLatestVariables } = (0, $3VgTg.useApolloQueryCacheBridgeSync)(t2);
    const onApolloCompleted = isCacheBridgeEnabled ? onApolloCompletedWithCacheBridge : apolloOptions.onCompleted;
    let t3;
    if ($[12] !== query) {
        t3 = (0, $86okN.toDocumentNode)(query);
        $[12] = query;
        $[13] = t3;
    } else t3 = $[13];
    let t4;
    if ($[14] !== onApolloCompleted) {
        t4 = onApolloCompleted ? {
            onCompleted: onApolloCompleted
        } : {};
        $[14] = onApolloCompleted;
        $[15] = t4;
    } else t4 = $[15];
    let t5;
    if ($[16] !== interopApolloAggClient) {
        t5 = interopApolloAggClient ? {
            client: window.GLOBAL_APOLLO_AGG_CLIENT ?? window.MOCK_GATEWAY_APOLLO_CLIENT
        } : {};
        $[16] = interopApolloAggClient;
        $[17] = t5;
    } else t5 = $[17];
    const t6 = apolloOptions?.context;
    const t7 = query.params?.id;
    let t8;
    if ($[18] !== t6 || $[19] !== t7) {
        t8 = {
            ...t6,
            requestId: t7
        };
        $[18] = t6;
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== apolloOptions || $[22] !== t4 || $[23] !== t5 || $[24] !== t8) {
        t9 = {
            ...apolloOptions,
            ...t4,
            ...t5,
            context: t8
        };
        $[21] = apolloOptions;
        $[22] = t4;
        $[23] = t5;
        $[24] = t8;
        $[25] = t9;
    } else t9 = $[25];
    const lazyQueryResult = (0, $7EPz1.useLazyQuery)(t3, t9);
    const [executeLazyQuery, apolloResult] = lazyQueryResult;
    const apolloData = apolloResult.data;
    const apolloError = apolloResult.error;
    const apolloCalled = apolloResult.called;
    let t10;
    if ($[26] !== apolloResult.variables || $[27] !== getCacheBridgeVariables) {
        t10 = getCacheBridgeVariables(apolloResult.variables);
        $[26] = apolloResult.variables;
        $[27] = getCacheBridgeVariables;
        $[28] = t10;
    } else t10 = $[28];
    const apolloVariables = t10;
    let t11;
    let t12;
    if ($[29] !== apolloVariables || $[30] !== isCacheBridgeEnabled || $[31] !== updateLatestVariables) {
        t11 = ()=>{
            if (!isCacheBridgeEnabled) return;
            updateLatestVariables(apolloVariables);
        };
        t12 = [
            apolloVariables,
            isCacheBridgeEnabled,
            updateLatestVariables
        ];
        $[29] = apolloVariables;
        $[30] = isCacheBridgeEnabled;
        $[31] = updateLatestVariables;
        $[32] = t11;
        $[33] = t12;
    } else {
        t11 = $[32];
        t12 = $[33];
    }
    (0, $cozmU.useEffect)(t11, t12);
    let t13;
    let t14;
    if ($[34] !== apolloCalled || $[35] !== apolloData || $[36] !== apolloError || $[37] !== apolloVariables || $[38] !== isCacheBridgeEnabled || $[39] !== syncObservedResult) {
        t13 = ()=>{
            if (!isCacheBridgeEnabled) return;
            syncObservedResult({
                skip: !apolloCalled,
                variables: apolloVariables,
                data: apolloData,
                error: apolloError
            });
        };
        t14 = [
            apolloCalled,
            apolloData,
            apolloError,
            apolloVariables,
            isCacheBridgeEnabled,
            syncObservedResult
        ];
        $[34] = apolloCalled;
        $[35] = apolloData;
        $[36] = apolloError;
        $[37] = apolloVariables;
        $[38] = isCacheBridgeEnabled;
        $[39] = syncObservedResult;
        $[40] = t13;
        $[41] = t14;
    } else {
        t13 = $[40];
        t14 = $[41];
    }
    (0, $cozmU.useEffect)(t13, t14);
    let t15;
    if ($[42] !== executeLazyQuery || $[43] !== getLatestVariables || $[44] !== updateLatestVariables) {
        t15 = (executeOptions)=>{
            updateLatestVariables(executeOptions?.variables ?? getLatestVariables());
            return executeLazyQuery(executeOptions);
        };
        $[42] = executeLazyQuery;
        $[43] = getLatestVariables;
        $[44] = updateLatestVariables;
        $[45] = t15;
    } else t15 = $[45];
    const executeLazyQueryWithCacheBridgeVariables = t15;
    if (!isCacheBridgeEnabled) return lazyQueryResult;
    let t16;
    if ($[46] !== apolloResult || $[47] !== executeLazyQueryWithCacheBridgeVariables) {
        t16 = [
            executeLazyQueryWithCacheBridgeVariables,
            apolloResult
        ];
        $[46] = apolloResult;
        $[47] = executeLazyQueryWithCacheBridgeVariables;
        $[48] = t16;
    } else t16 = $[48];
    return t16;
} : function useLazyQueryInteropApollo(query, options) {
    const { interopApolloAggClient: interopApolloAggClient, ...apolloOptions } = options ?? {};
    const { getLatestVariables: getLatestVariables, getVariables: getCacheBridgeVariables, isEnabled: isCacheBridgeEnabled, onCompleted: onApolloCompletedWithCacheBridge, syncObservedResult: syncObservedResult, updateLatestVariables: updateLatestVariables } = (0, $3VgTg.useApolloQueryCacheBridgeSync)({
        query: query,
        variables: apolloOptions.variables,
        fetchPolicy: apolloOptions.fetchPolicy,
        useAggClient: interopApolloAggClient,
        onCompleted: apolloOptions.onCompleted,
        callerPackage: options?.__callerPackage__
    });
    const onApolloCompleted = isCacheBridgeEnabled ? onApolloCompletedWithCacheBridge : apolloOptions.onCompleted;
    const lazyQueryResult = (0, $7EPz1.useLazyQuery)((0, $86okN.toDocumentNode)(query), {
        ...apolloOptions,
        ...onApolloCompleted ? {
            onCompleted: onApolloCompleted
        } : {},
        ...interopApolloAggClient ? {
            client: window['GLOBAL_APOLLO_AGG_CLIENT'] ?? window['MOCK_GATEWAY_APOLLO_CLIENT']
        } : {},
        context: {
            ...apolloOptions?.context,
            requestId: query.params?.id
        }
    });
    const [executeLazyQuery, apolloResult] = lazyQueryResult;
    const apolloData = apolloResult.data;
    const apolloError = apolloResult.error;
    const apolloCalled = apolloResult.called;
    const apolloVariables = getCacheBridgeVariables(apolloResult.variables);
    (0, $cozmU.useEffect)(()=>{
        if (!isCacheBridgeEnabled) return;
        updateLatestVariables(apolloVariables);
    }, [
        apolloVariables,
        isCacheBridgeEnabled,
        updateLatestVariables
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isCacheBridgeEnabled) return;
        syncObservedResult({
            skip: !apolloCalled,
            variables: apolloVariables,
            data: apolloData,
            error: apolloError
        });
    }, [
        apolloCalled,
        apolloData,
        apolloError,
        apolloVariables,
        isCacheBridgeEnabled,
        syncObservedResult
    ]);
    const executeLazyQueryWithCacheBridgeVariables = (0, $cozmU.useCallback)((executeOptions)=>{
        updateLatestVariables(executeOptions?.variables ?? getLatestVariables());
        return executeLazyQuery(executeOptions);
    }, [
        executeLazyQuery,
        getLatestVariables,
        updateLatestVariables
    ]);
    if (!isCacheBridgeEnabled) return lazyQueryResult;
    return [
        executeLazyQueryWithCacheBridgeVariables,
        apolloResult
    ];
};
function $278c8d04dad7bc1d$var$useLazyQueryInteropRelay(query, options) {
    // Validate before any hook call so the throw isn't masked by useRelayEnvironment().
    if (!('params' in query)) throw new Error(`[Relay migration] unsupported tagged node provided for operation "${$278c8d04dad7bc1d$var$getOperationName(query)}". Please make sure you generated Relay artifacts for your operation`);
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const operationName = (0, $7M67g.getRelayOperationName)(query) ?? undefined;
    const hookVariables = (0, $iF5wn.useMemoObj)(options?.variables, options?.__callerPackage__, {
        operationName: operationName,
        phase: 'memo'
    });
    const hookContext = options?.context;
    const initialFetchPolicy = options?.fetchPolicy ? (0, $3NBsC.mapFetchPolicyForQuery)(options.fetchPolicy) : undefined;
    const subsequentFetchPolicy = options?.nextFetchPolicy ? (0, $3NBsC.mapFetchPolicyForQuery)(options.nextFetchPolicy) : initialFetchPolicy;
    const cacheBridgeFetchPolicy = options?.fetchPolicy;
    const cacheBridgeSubsequentFetchPolicy = options?.nextFetchPolicy ?? cacheBridgeFetchPolicy;
    const interopApolloAggClient = options?.interopApolloAggClient;
    const onError = (0, $26Yfd.useStableCallback)(options?.onError ?? function noop() {});
    const onCompleted = (0, $26Yfd.useStableCallback)(options?.onCompleted ?? function noop() {});
    const [data, setData] = (0, $cozmU.useState)(undefined);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const [loading, setLoading] = (0, $cozmU.useState)(false);
    const [called, setCalled] = (0, $cozmU.useState)(false);
    // Mirrors Apollo's `variables` from the most recent invocation.
    const [activeVariables, setActiveVariables] = (0, $cozmU.useState)(hookVariables);
    const isMountedRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    // Subscribe to cache updates after query is called to keep data reactive.
    // This ensures that when mutations update the cache, components using this
    // lazy query will automatically re-render with the fresh data, matching
    // Apollo's behavior where useLazyQuery subscribes to cache changes.
    // See: https://hello.atlassian.net/browse/COPPER-XXXXX (Star menu bug)
    (0, $cozmU.useEffect)(()=>{
        if (!called) return;
        // Subscribe to the Relay store to watch for cache updates (e.g., from mutations).
        // This matches the pattern used in useQueryInterop for reactive cache updates.
        const operation = (0, $eqEJl.createOperationDescriptor)((0, $eqEJl.getRequest)(query), activeVariables);
        const retainDisposable = environment.retain(operation);
        const storeSubscription = environment.subscribe(environment.lookup(operation.fragment), (snapshot)=>{
            // Only update if mounted and data is not missing from cache
            if (isMountedRef.current && !snapshot.isMissingData) setData(snapshot.data);
        });
        return ()=>{
            storeSubscription.dispose();
            retainDisposable.dispose();
        };
    }, [
        called,
        environment,
        query,
        activeVariables
    ]);
    // Sequencing counters discard out-of-order responses.
    const executeIdRef = (0, $cozmU.useRef)(0);
    const fetchMoreIdRef = (0, $cozmU.useRef)(0);
    // hookContext is unmemoised; data/activeVariables can change mid-fetchMore via a concurrent execute.
    const hookContextRef = $278c8d04dad7bc1d$var$useSyncedRef(hookContext);
    const dataRef = $278c8d04dad7bc1d$var$useSyncedRef(data);
    const activeVarsRef = $278c8d04dad7bc1d$var$useSyncedRef(activeVariables);
    const mirrorRelayResultToApollo = (0, $cozmU.useCallback)((relayResult, resultVariables, fetchPolicy)=>{
        // Lazy Relay execution remains the original source of truth; mirror
        // successful payloads into Apollo with the variables from that run.
        (0, $bFdYQ.syncQueryCacheBridge)({
            source: 'relay',
            query: query,
            variables: resultVariables,
            data: relayResult,
            fetchPolicy: fetchPolicy,
            useAggClient: interopApolloAggClient
        });
    }, [
        interopApolloAggClient,
        query
    ]);
    const ufoContext = (0, $cozmU.useContext)((0, $8BQV6.default));
    const ufoOperationName = `relay_${query.params?.name ?? 'unnamed'}`;
    (0, $cozmU.useEffect)(()=>{
        if (called && loading) return ufoContext?.hold(ufoOperationName);
    }, [
        called,
        loading,
        ufoOperationName,
        ufoContext
    ]);
    const execute = (0, $cozmU.useCallback)((executeOptions)=>{
        const variables = executeOptions?.variables ?? hookVariables;
        const context = {
            ...hookContextRef.current,
            ...executeOptions?.context
        };
        // First execute uses fetchPolicy, re-invocations use nextFetchPolicy.
        const isFirstCall = executeIdRef.current === 0;
        const cacheBridgeResultFetchPolicy = isFirstCall ? cacheBridgeFetchPolicy : cacheBridgeSubsequentFetchPolicy;
        executeIdRef.current += 1;
        // Invalidate any in-flight fetchMore so it can't merge into fresh execute data.
        fetchMoreIdRef.current += 1;
        const id = executeIdRef.current;
        const isStillCurrent = ()=>isMountedRef.current && id === executeIdRef.current;
        setCalled(true);
        setActiveVariables(variables);
        setLoading(true);
        setError(undefined);
        (0, $kczYx.fetchQuery)(environment, query, variables, {
            fetchPolicy: isFirstCall ? initialFetchPolicy : subsequentFetchPolicy,
            networkCacheConfig: {
                metadata: context
            }
        }).toPromise().then((result)=>{
            if (!isStillCurrent()) return;
            setLoading(false);
            if (result !== undefined) {
                mirrorRelayResultToApollo(result, variables, cacheBridgeResultFetchPolicy);
                setData(result);
                setError(undefined);
                onCompleted(result);
                return;
            }
            // Store-only cache miss: surface so callers aren't left indeterminate.
            const err = $278c8d04dad7bc1d$var$toApolloError(new Error('[Relay migration] fetchQuery resolved with no data (likely a store-only cache miss)'));
            setError(err);
            onError(err);
        }).catch((rawErr)=>{
            if (!isStillCurrent()) return;
            const err = $278c8d04dad7bc1d$var$toApolloError(rawErr);
            setError(err);
            setLoading(false);
            onError(err);
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- refs (hookContextRef) have stable identity, omitted intentionally
    [
        environment,
        query,
        hookVariables,
        initialFetchPolicy,
        subsequentFetchPolicy,
        cacheBridgeFetchPolicy,
        cacheBridgeSubsequentFetchPolicy,
        mirrorRelayResultToApollo,
        onCompleted,
        onError
    ]);
    const fetchMore = (0, $cozmU.useCallback)((fetchMoreOpts)=>{
        const baseVariables = activeVarsRef.current;
        const variables = {
            ...baseVariables,
            ...fetchMoreOpts.variables
        };
        fetchMoreIdRef.current += 1;
        const id = fetchMoreIdRef.current;
        const isStillCurrent = ()=>isMountedRef.current && id === fetchMoreIdRef.current;
        setLoading(true);
        return (0, $kczYx.fetchQuery)(environment, query, variables, {
            // fetchMore must always hit the network (matches Apollo); cached pages would be stale.
            fetchPolicy: 'network-only',
            networkCacheConfig: {
                metadata: hookContextRef.current
            }
        }).toPromise().then((fetchMoreResult)=>{
            // Throw so .catch handles it (avoids double onError).
            if (fetchMoreResult === undefined) throw new Error('[Relay migration] fetchMore resolved with no data (likely a store-only cache miss)');
            const merged = fetchMoreOpts.updateQuery(dataRef.current ?? {}, {
                fetchMoreResult: fetchMoreResult,
                variables: variables
            });
            if (isStillCurrent()) {
                mirrorRelayResultToApollo(merged, baseVariables, cacheBridgeSubsequentFetchPolicy);
                setData(merged);
                setLoading(false);
                setError(undefined);
            }
            return {
                data: merged,
                loading: false,
                networkStatus: (0, $5T18X.NetworkStatus).ready,
                stale: false
            };
        }).catch((rawErr)=>{
            // onError gated by isStillCurrent (matches execute); re-throw for Apollo's contract.
            const err = $278c8d04dad7bc1d$var$toApolloError(rawErr);
            if (isStillCurrent()) {
                setError(err);
                setLoading(false);
                onError(err);
            }
            throw err;
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- refs (activeVarsRef, dataRef, hookContextRef) have stable identity, omitted intentionally
    [
        environment,
        query,
        cacheBridgeSubsequentFetchPolicy,
        mirrorRelayResultToApollo,
        onError
    ]);
    // Lazy hooks don't auto-poll; no-op for Apollo signature parity.
    const stopPolling = (0, $cozmU.useCallback)(()=>{}, []);
    // Cast: Apollo's overloaded fetchMore is structurally a superset of FetchMoreType.
    return [
        execute,
        {
            data: data,
            loading: loading,
            error: error,
            called: called,
            variables: activeVariables,
            fetchMore: fetchMore,
            stopPolling: stopPolling
        }
    ];
}
module.exports["useLazyQueryInterop"] = $278c8d04dad7bc1d$export$363a8d7f501f3769;

});

parcelRegister("bjxK7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $ixfCV = parcelRequire("ixfCV");


var $bQm3c = parcelRequire("bQm3c");


var $2vVvv = parcelRequire("2vVvv");


var $iP9x4 = parcelRequire("iP9x4");


var $4IoVL = parcelRequire("4IoVL");


var $gXrHX = parcelRequire("gXrHX");


var $cLo2u = parcelRequire("cLo2u");


var $e2Vf0 = parcelRequire("e2Vf0");


var $6mKj3 = parcelRequire("6mKj3");

const $8ad336116c673b49$export$74fedad14355d824 = ({ contentId: contentId, contentType: contentType, editorAPI: editorAPI, flags: flags, viewMode: viewMode, mediaViewerExtensions: mediaViewerExtensions, fallbackMediaNameFetcher: fallbackMediaNameFetcher })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { featureFlags: featureFlags } = (0, $bQm3c.useSessionData)();
    const { isExternalShareRequest: isExternalShare } = (0, $cozmU.useContext)((0, $gXrHX.ExternalShareContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const ssrMediaConfig = (0, $iP9x4.useMediaSSRModeAndAuthConfig)({
        contentId: contentId,
        spaceKey: spaceKey ?? undefined,
        isExternalShare: isExternalShare
    });
    const resolver = (0, $cozmU.useRef)();
    // Store a stable Promise that will be resolved once when mediaProvider is created
    // This avoids race conditions when ssrMediaProvider changes after the effect has run
    const mediaProviderPromiseRef = (0, $cozmU.useRef)();
    if (!mediaProviderPromiseRef.current && (0, $6mKj3.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true)) mediaProviderPromiseRef.current = new Promise((resolve)=>{
        resolver.current = resolve;
    });
    // Keep most recent option values so dynamic provider getters don't close over stale ones
    const latestParamsRef = (0, $cozmU.useRef)({
        contentId: contentId,
        spaceKey: spaceKey,
        isExternalShare: isExternalShare,
        contentType: contentType,
        viewMode: viewMode
    });
    latestParamsRef.current = {
        contentId: contentId,
        spaceKey: spaceKey,
        isExternalShare: isExternalShare,
        contentType: contentType,
        viewMode: viewMode
    };
    // Holds the most recently resolved MediaProvider so we can call refreshUploadDataIfNeeded
    // on it when contentId changes (see useEffect below). This closes the window where the
    // old provider's uploadParams.collection is stale after a SPA navigation but before the
    // new provider Promise resolves.
    const resolvedProviderRef = (0, $cozmU.useRef)(undefined);
    const showAttachmentLimitReachedFlag = (0, $cozmU.useCallback)((data)=>{
        if (flags && data) flags.showErrorFlag((0, $2vVvv.getAttachmentSizeLimitErrorFlag)(data, intl)).then(()=>{
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'nextEditorAttachmentTooLargeFlag'
                }
            }).fire();
        });
        return !!data;
    }, [
        flags,
        intl,
        createAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!contentId) return;
        const createMediaProvider = ()=>{
            if (viewMode) return (0, $ixfCV.fg)('confluence_frontend_transition_preloading_system') ? (0, $4IoVL.createRendererMediaProviderDynamic)(()=>({
                    contentId: latestParamsRef.current.contentId,
                    spaceKey: latestParamsRef.current.spaceKey,
                    isExternalShare: latestParamsRef.current.isExternalShare
                })) : (0, $4IoVL.createRendererMediaProvider)({
                contentId: contentId,
                spaceKey: spaceKey,
                isExternalShare: isExternalShare
            });
            if (contentType) return (0, $ixfCV.fg)('confluence_frontend_transition_preloading_system') ? (0, $4IoVL.createEditorMediaProviderDynamic)(()=>({
                    contentId: latestParamsRef.current.contentId,
                    spaceKey: latestParamsRef.current.spaceKey,
                    contentType: latestParamsRef.current.contentType,
                    isExternalShare: latestParamsRef.current.isExternalShare,
                    // Passing undefined will allow us to use the default atlaskit size limit error behavior
                    onUploadRejection: flags ? showAttachmentLimitReachedFlag : undefined
                })) : (0, $4IoVL.createEditorMediaProvider)({
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: contentType,
                isExternalShare: isExternalShare,
                // Passing undefined will allow us to use the default atlaskit size limit error behavior
                onUploadRejection: flags ? showAttachmentLimitReachedFlag : undefined
            });
        };
        // When the fix is enabled and we already have a resolved provider (i.e. this is a
        // subsequent contentId change / SPA navigation), reuse the existing provider instance
        // rather than creating a new one concurrently. The provider's getOptions() getter
        // already returns the new contentId via latestParamsRef, so auth tokens and view config
        // are dynamic. We just need to refresh upload data and re-notify the media plugin.
        if ((0, $ixfCV.fg)('confluence_frontend_fix_stale_media_collection') && (0, $ixfCV.fg)('confluence_frontend_transition_preloading_system') && resolvedProviderRef.current) {
            const currentProvider = resolvedProviderRef.current;
            // Await the refresh before setProvider so the media plugin reads the correct
            // collection when it initialises — not the stale value from the previous page.
            const refreshed = currentProvider.refreshUploadDataIfNeeded?.().then(()=>{
                editorAPI?.media?.actions.setProvider(Promise.resolve(currentProvider));
            });
            return;
        }
        const mediaProvider = createMediaProvider();
        if (mediaProvider) {
            editorAPI?.media?.actions.setProvider(mediaProvider);
            if (resolver.current) {
                resolver.current(mediaProvider);
                if ((0, $ixfCV.fg)('confluence_frontend_fix_stale_media_collection')) {
                    // Clear resolver so Strict Mode's second invocation doesn't call it again,
                    // and track the provider instance the bridge holds so refreshUploadDataIfNeeded
                    // is called on the same instance on SPA navigation — not a duplicate.
                    resolver.current = undefined;
                    Promise.resolve(mediaProvider).then((resolved)=>{
                        resolvedProviderRef.current = resolved;
                    });
                }
            }
        }
    }, [
        contentId,
        contentType,
        spaceKey,
        isExternalShare,
        viewMode,
        flags,
        showAttachmentLimitReachedFlag,
        featureFlags,
        editorAPI
    ]);
    const ssrMediaProvider = (0, $cozmU.useMemo)(()=>{
        if ((0, $6mKj3.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true)) {
            if (!ssrMediaConfig) return undefined;
            return {
                viewMediaClientConfig: ssrMediaConfig.config
            };
        }
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        ssrMediaConfig;
        return undefined;
        return {
            viewMediaClientConfig: ssrMediaConfig.config
        };
    }, [
        ssrMediaConfig
    ]);
    // IMPORTANT: If you change the code below, please also update the
    // platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/mediaPluginOptions/mediaPluginOptions.ts
    return (0, $cozmU.useMemo)(()=>(0, $e2Vf0.getMediaOptions)({
            mediaProvider: (0, $6mKj3.expValEquals)('platform_editor_media_vc_fixes', 'isEnabled', true) ? mediaProviderPromiseRef.current : new Promise((resolve)=>resolver.current = resolve),
            ssrMediaProvider: ssrMediaProvider,
            intl: intl,
            featureFlags: featureFlags,
            mediaViewerExtensions: mediaViewerExtensions,
            fallbackMediaNameFetcher: fallbackMediaNameFetcher
        }), [
        intl,
        featureFlags,
        ssrMediaProvider,
        mediaViewerExtensions,
        fallbackMediaNameFetcher
    ]);
};
module.exports["useMediaOptions"] = $8ad336116c673b49$export$74fedad14355d824;

});

parcelRegister("2vVvv", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $57725dc45b51a081$var$attachmentSizeErrorFlagI18n = (0, $kSwu1.defineMessages)({
    errorTitle: {
        id: "fabric-media-support.attachment-size-limit-error.title",
        defaultMessage: "{fileName} is too large to upload"
    },
    errorDescription: {
        id: "fabric-media-support.attachment-size-limit-error.description",
        defaultMessage: "Attachments must be {size} or less."
    },
    learnMore: {
        id: "fabric-media-support.attachment-size-limit-error.learn-more",
        defaultMessage: "Learn more"
    }
});
const $57725dc45b51a081$var$sizeLimitLearnMoreLink = 'https://support.atlassian.com/confluence-cloud/docs/upload-a-file/';
const $57725dc45b51a081$var$attachmentZeroByteErrorFlagI18n = (0, $kSwu1.defineMessages)({
    errorTitle: {
        id: "fabric-media-support.attachment-zero-byte-error.title",
        defaultMessage: "{fileName} is empty (zero bytes)"
    },
    errorDescription: {
        id: "fabric-media-support.attachment-zero-byte.description",
        defaultMessage: "Attachments must be at least 1 byte of size"
    }
});
const $57725dc45b51a081$export$f2d538a5633fea72 = (bytes, maxMagnitude)=>{
    if (bytes <= 0) return '0 bytes';
    const k = 1024;
    const decimals = 2;
    const units = [
        'bytes',
        'KB',
        'MB',
        'GB',
        'TB',
        'PB',
        'EB',
        'ZB',
        'YB'
    ];
    let maxIndex = units.length - 1;
    let exponent = Math.floor(Math.log(bytes) / Math.log(k));
    if (maxMagnitude && maxMagnitude < maxIndex) maxIndex = maxMagnitude;
    exponent = exponent > maxIndex ? maxIndex : exponent;
    return `${parseFloat((bytes / Math.pow(k, exponent)).toFixed(decimals))} ${units[exponent]}`;
};
const $57725dc45b51a081$export$1c61cf0ed486df46 = (data, intl)=>{
    if (data.reason === 'fileSizeLimitExceeded') return {
        title: intl.formatMessage($57725dc45b51a081$var$attachmentSizeErrorFlagI18n.errorTitle, {
            fileName: data.fileName
        }),
        description: intl.formatMessage($57725dc45b51a081$var$attachmentSizeErrorFlagI18n.errorDescription, {
            size: $57725dc45b51a081$export$f2d538a5633fea72(data.limit)
        }),
        actions: [
            {
                content: intl.formatMessage($57725dc45b51a081$var$attachmentSizeErrorFlagI18n.learnMore),
                onClick: ()=>{
                    window.open($57725dc45b51a081$var$sizeLimitLearnMoreLink, '_blank');
                }
            }
        ]
    };
    else return {
        title: intl.formatMessage($57725dc45b51a081$var$attachmentZeroByteErrorFlagI18n.errorTitle, {
            fileName: data.fileName
        }),
        description: intl.formatMessage($57725dc45b51a081$var$attachmentZeroByteErrorFlagI18n.errorDescription)
    };
};
module.exports["getAttachmentSizeLimitErrorFlag"] = $57725dc45b51a081$export$1c61cf0ed486df46;

});

parcelRegister("iP9x4", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $2j0AL = parcelRequire("2j0AL");


var $4h1jl = parcelRequire("4h1jl");


var $9wGTI = parcelRequire("9wGTI");


var $4IoVL = parcelRequire("4IoVL");

const $2c59df77bd212c3d$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR = 'mediaProvider unavailable, must use initialAuth';
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $2c59df77bd212c3d$var$isServerEnvironment = ()=>undefined;
const $2c59df77bd212c3d$var$isClientEnvironment = ()=>window.__SSR_RENDERED__;
const $2c59df77bd212c3d$var$getInitialAuth = (config)=>{
    const recordedAuth = config.contentProduct === 'jira-work-item' ? (0, $4h1jl.jiraMediaConfigRecorder)?.get() : (0, $4h1jl.mediaConfigRecorder)?.get();
    if (!recordedAuth) return undefined;
    return {
        ...recordedAuth,
        // If the mediaToken is provided in the config, use it.
        // This ensures the correct token is used in cases where the token differs from
        // the initial page, such as media included through an `include` macro.
        token: config?.mediaToken || recordedAuth.token
    };
};
const $2c59df77bd212c3d$var$getInitialEnforceDataSecurityPolicy = ()=>{
    if (!(0, $9wGTI.fg)('dlp_attachment_download_respects_data_export_dsp')) return false;
    const shouldEnforceDataSecurityPolicy = (0, $4h1jl.mediaConfigEnforceDSPRecorder)?.get();
    return !!shouldEnforceDataSecurityPolicy;
};
const $2c59df77bd212c3d$var$getServerModeConfig = (config)=>({
        mode: 'server',
        config: {
            authProvider: ()=>Promise.reject(new Error($2c59df77bd212c3d$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR)),
            initialAuth: $2c59df77bd212c3d$var$getInitialAuth(config),
            enforceDataSecurityPolicy: $2c59df77bd212c3d$var$getInitialEnforceDataSecurityPolicy()
        }
    });
const $2c59df77bd212c3d$var$createClientAuthProvider = ({ contentAri: contentAri, contentId: contentId, contentProduct: contentProduct, spaceKey: spaceKey, isExternalShare: isExternalShare, mediaToken: mediaToken })=>async (authContext)=>{
        if (!!contentId && (!!spaceKey || contentProduct === 'jira-work-item')) {
            const { viewMediaClientConfig: viewMediaClientConfig } = await (0, $4IoVL.createRendererMediaProvider)({
                contentAri: contentAri,
                contentId: contentId,
                contentProduct: contentProduct,
                spaceKey: spaceKey,
                isExternalShare: isExternalShare,
                mediaToken: mediaToken
            });
            return viewMediaClientConfig.authProvider(authContext);
        } else throw new Error($2c59df77bd212c3d$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR);
    };
const $2c59df77bd212c3d$var$getClientModeConfig = (config)=>({
        mode: 'client',
        config: {
            authProvider: $2c59df77bd212c3d$var$createClientAuthProvider(config),
            initialAuth: config.contentProduct === 'jira-work-item' ? window.__JIRA_MEDIA_CONFIG__ : window.__MEDIA_CONFIG__,
            enforceDataSecurityPolicy: window.__MEDIA_CONFIG_ENFORCE_DSP__
        }
    });
const $2c59df77bd212c3d$var$getMediaSSRModeAndAuthConfig = (config)=>{
    if ($2c59df77bd212c3d$var$isServerEnvironment()) return $2c59df77bd212c3d$var$getServerModeConfig(config);
    else if ($2c59df77bd212c3d$var$isClientEnvironment()) return $2c59df77bd212c3d$var$getClientModeConfig(config);
};
const $2c59df77bd212c3d$export$85decadf1b9d641b = (0, $dOBRD.default)($2c59df77bd212c3d$var$getMediaSSRModeAndAuthConfig, (0, (/*@__PURE__*/$parcel$interopDefault($2j0AL))));
const $2c59df77bd212c3d$export$45c8e19bd67cadee = (config)=>{
    return $2c59df77bd212c3d$export$85decadf1b9d641b(config);
};
module.exports["getMediaSSRModeAndAuthConfigMemoized"] = $2c59df77bd212c3d$export$85decadf1b9d641b;
module.exports["useMediaSSRModeAndAuthConfig"] = $2c59df77bd212c3d$export$45c8e19bd67cadee;

});

parcelRegister("2j0AL", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("4h1jl", function(module, exports) {

var $2BiLx = parcelRequire("2BiLx");

const $c75b7ce9b9db2aec$export$279f2f878f49d0df = new (0, $2BiLx.ObjectRecorder)();
const $c75b7ce9b9db2aec$export$269fe681eda28e68 = new (0, $2BiLx.ObjectRecorder)();
const $c75b7ce9b9db2aec$export$e125b144e38aa5db = new (0, $2BiLx.ObjectRecorder)();
module.exports["mediaConfigRecorder"] = $c75b7ce9b9db2aec$export$279f2f878f49d0df;
module.exports["jiraMediaConfigRecorder"] = $c75b7ce9b9db2aec$export$269fe681eda28e68;
module.exports["mediaConfigEnforceDSPRecorder"] = $c75b7ce9b9db2aec$export$e125b144e38aa5db;

});

parcelRegister("2BiLx", function(module, exports) {
class $53dcea44a491523c$export$e411414ea02dd271 {
    set(object) {
        this.object = object;
    }
    get() {
        return this.object;
    }
    reset() {
        this.object = null;
    }
    constructor(){
        this.object = null;
    }
}
module.exports["ObjectRecorder"] = $53dcea44a491523c$export$e411414ea02dd271;

});

parcelRegister("gXrHX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $k3pHv = parcelRequire("k3pHv");

const $a357cfbdfa4d3d24$export$74d34469a946b330 = /*#__PURE__*/ (0, $cozmU.createContext)({
    isExternalShareRequest: false,
    userType: (0, $k3pHv.UserTypes).ANONYMOUS,
    shareToken: undefined,
    isAccessLinkRequest: false
});
module.exports["ExternalShareContext"] = $a357cfbdfa4d3d24$export$74d34469a946b330;

});

parcelRegister("k3pHv", function(module, exports) {
var $dcb154d9b517823f$export$df06b7fc047181f5 = /*#__PURE__*/ function(UserTypes) {
    // Anonymous users, not logged in
    UserTypes["ANONYMOUS"] = "anonymous";
    // Logged in, not Confluence user - member in the org
    UserTypes["ORG_MEMBER"] = "org-member";
    // Logged in, Licensed Confluence user
    UserTypes["CONFLUENCE_USER"] = "confluence-user";
    // Logged in, Atlassian user not in the org
    UserTypes["ATLASSIAN_USER"] = "atlassian-user";
    return UserTypes;
}({});
module.exports["UserTypes"] = $dcb154d9b517823f$export$df06b7fc047181f5;

});

parcelRegister("cLo2u", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    const $ = (0, $bDgLe.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
}
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("f6GmT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $44ba2156dd739cb9$export$54727fabeade699b = ()=>{
    const editorPluginAIFeedbackHandlers = (0, $cozmU.useRef)({
        handleFeedbackClicked: ()=>{},
        handleReviewStateEntered: ()=>{},
        handleExperienceEnded: ()=>{}
    });
    return {
        editorPluginAIFeedbackHandlers: editorPluginAIFeedbackHandlers
    };
};
module.exports["useEditorPluginAIFeedbackHandlers"] = $44ba2156dd739cb9$export$54727fabeade699b;

});

parcelRegister("bMmYR", function(module, exports) {
/**
 * Sleep an async context for timeoutMs milliseconds
 *
 * Note this does not block but instead sets a timeout
 *
 * @param timeoutMs The timeout in milliseconds
 * @returns {Promise} A promise that resolves after timeoutMs milliseconds
 */ const $e3747894d76f1f8c$var$sleep = (timeoutMs)=>new Promise((resolve)=>setTimeout(resolve, timeoutMs));
const $e3747894d76f1f8c$export$9369b12211e1fce4 = (action, { backOff: backOff = true, jitter: jitter = true, timeout: timeout = 2000, maxAttempts: maxAttempts = 3 } = {}, shouldRetry)=>{
    const recursiveRetry = async (attempt)=>{
        let nextTryIn = null;
        if (attempt < maxAttempts) {
            const jitterFactor = jitter ? 1 + Math.random() : 1;
            const backOffFactor = backOff ? Math.pow(2, attempt) : 1;
            nextTryIn = timeout * backOffFactor * jitterFactor;
        }
        try {
            return await action(attempt, nextTryIn);
        } catch (ex) {
            if (nextTryIn === null) throw ex;
            if (shouldRetry && !await shouldRetry(ex)) throw ex;
            await $e3747894d76f1f8c$var$sleep(nextTryIn);
            return await recursiveRetry(attempt + 1);
        }
    };
    return recursiveRetry(0);
};
module.exports["retry"] = $e3747894d76f1f8c$export$9369b12211e1fce4;

});

parcelRegister("gxtki", function(module, exports) {
function $249d0e770ebf7c87$export$4163f075d4b10c85(mutationErrors) {
    return mutationErrors.map((e)=>({
            ...e,
            // The Array check normalizes the fact that the GraphQL schema
            // can differ at __runtime__ between AGG and cc-graphql.
            extensions: Array.isArray(e.extensions) ? e.extensions : e.extensions != null ? [
                e.extensions
            ] : undefined
        }));
}
module.exports["mutationErrorExtensionsAggCompat"] = $249d0e770ebf7c87$export$4163f075d4b10c85;

});

parcelRegister("8uySb", function(module, exports) {
/* EditorDisplayWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $a680464f54a8caa4$var$baseStyles = null; /* hide the editor when the page is being previewed */ 
const $a680464f54a8caa4$var$hiddenStyles = null;
const $a680464f54a8caa4$var$visibleStyles = null;
const $a680464f54a8caa4$var$overflowHiddenStyles = null;
const $a680464f54a8caa4$var$toolbarMarginStyles = null;
const $a680464f54a8caa4$var$toolbarNoMarginStyles = null; /**
                                     * Component wrapping the editor to apply styling overrides
                                     */ 
const $a680464f54a8caa4$export$1a692c35a5e9cddf = ({ isHidden: isHidden, isEditorActionBarRendered: isEditorActionBarRendered, isToolbarAifcEnabled: isToolbarAifcEnabled, ...props })=>{
    const shouldApplyToolbarMargin = isEditorActionBarRendered && !isToolbarAifcEnabled;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ...props,
        className: (0, $hekY6.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1tkeidpf _kqswh2mm _19jk1jfw _kibh1jfw _bq9y1f4h _yovj1ejb _1dmjpxbi _1k07v47k _1iwipxbi _1jpz1b66",
            isHidden ? "_1e0cglyw" : "_1e0cn7od",
            isEditorActionBarRendered && "_18m915vq",
            shouldApplyToolbarMargin ? "_1i191ejb" : "_1i19ze3t"
        ])
    });
};
module.exports["EditorDisplayWrapper"] = $a680464f54a8caa4$export$1a692c35a5e9cddf;

});

parcelRegister("2dIEg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bQm3c = parcelRequire("bQm3c");


var $csex9 = parcelRequire("csex9");

const $f68cade398718716$export$67e1ff255b9f648f = ({ editorPluginAIFeedbackHandlers: editorPluginAIFeedbackHandlers })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { FeedbackCollector: FeedbackCollector, openFeedbackCollector: openFeedbackCollector } = (0, $csex9.useEditorAIFeedbackCollector)();
    (0, $cozmU.useEffect)(()=>{
        if (editorPluginAIFeedbackHandlers.current) editorPluginAIFeedbackHandlers.current.handleFeedbackClicked = openFeedbackCollector;
    }, [
        editorPluginAIFeedbackHandlers,
        cloudId,
        openFeedbackCollector
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(FeedbackCollector, null);
};
module.exports["EditorPluginAIWithFeedback"] = $f68cade398718716$export$67e1ff255b9f648f;

});

parcelRegister("csex9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $2uDbg = parcelRequire("2uDbg");


var $91uAX = parcelRequire("91uAX");


var $7aRa9 = parcelRequire("7aRa9");


var $jLw6A = parcelRequire("jLw6A");


var $bQm3c = parcelRequire("bQm3c");

const $9006c850d364bf02$var$GAIE_ENTRYPOINT_ID = '73cf1eae-42a3-418a-a7ac-976ba0b5735d';
const $9006c850d364bf02$var$FEEDBACK_CONTEXT_ID = 'customfield_10047';
const $9006c850d364bf02$var$LINK_TO_PRIVACY_POLICY = 'https://www.atlassian.com/legal/privacy-policy';
const $9006c850d364bf02$var$LINK_TO_RESEARCH_GROUP = 'https://www.atlassian.com/research-group';
const $9006c850d364bf02$var$i18n = (0, $kSwu1.defineMessages)({
    feedbackTitle: {
        id: "editor-features.rovo-feedback-collector.title",
        defaultMessage: "Help us make Rovo even better"
    },
    flagTitle: {
        id: "editor-features.ai-feedback-collector.flag-title",
        defaultMessage: "Thanks!"
    },
    flagDescription: {
        id: "editor-features.ai-feedback-collector.flag-description",
        defaultMessage: "Your valuable feedback helps us continually improve our products."
    },
    summaryPlaceholder: {
        id: "editor-features.ai-feedback-collector.summary-placeholder",
        defaultMessage: "Let us know what you were trying to do and how it could be better"
    },
    userConsentCheckboxLabel: {
        id: "editor-features.ai-feedback-collector.user-consent-checkbox-label",
        defaultMessage: "Include my last prompt and response in the feedback."
    },
    canContactText: {
        id: "editor-features.ai-feedback-collector.can-contact.label",
        defaultMessage: "Atlassian can contact me about this feedback. See our {privacyPolicyLink}."
    },
    privacyPolicyLink: {
        id: "editor-features.ai-feedback-collector.privacy-policy.link",
        defaultMessage: "privacy policy"
    },
    improveAtlassianText: {
        id: "editor-features.ai-feedback-collector.improve-atlassian",
        defaultMessage: "I\u2019d like to help improve Atlassian products by joining the {researchGroupLink}."
    },
    researchGroupLink: {
        id: "editor-features.ai-feedback-collector.research-group.link",
        defaultMessage: "Atlassian Research Group"
    }
});
const $9006c850d364bf02$var$PrivacyPolicyLink = ({ link: link })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $9006c850d364bf02$var$i18n.privacyPolicyLink));
const $9006c850d364bf02$var$ResearchGroupLink = ({ link: link })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $9006c850d364bf02$var$i18n.researchGroupLink));
const $9006c850d364bf02$var$CanContactLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$9006c850d364bf02$var$i18n.canContactText,
        values: {
            privacyPolicyLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9006c850d364bf02$var$PrivacyPolicyLink, {
                link: $9006c850d364bf02$var$LINK_TO_PRIVACY_POLICY
            })
        }
    });
};
const $9006c850d364bf02$var$EnrolLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$9006c850d364bf02$var$i18n.improveAtlassianText,
        values: {
            researchGroupLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9006c850d364bf02$var$ResearchGroupLink, {
                link: $9006c850d364bf02$var$LINK_TO_RESEARCH_GROUP
            })
        }
    });
};
const $9006c850d364bf02$var$buildAdditionalFields = ({ feedbackContext: feedbackContext, hasUserConsent: hasUserConsent })=>{
    if (!feedbackContext) return undefined;
    const aiExperience = feedbackContext.getAIExperience?.(hasUserConsent) || {};
    let feedbackMetadataStringified = `sentiment: ${feedbackContext.sentiment}\n`;
    Object.entries({
        ...aiExperience,
        ...feedbackContext.editorAttributes
    }).forEach((item)=>{
        feedbackMetadataStringified += `${item[0]}: ${item[1]}\n`;
    });
    return [
        {
            id: $9006c850d364bf02$var$FEEDBACK_CONTEXT_ID,
            value: feedbackMetadataStringified
        }
    ];
};
const $9006c850d364bf02$var$EditorAIFeedbackCollectorComponent = ({ flags: flags, feedbackTitle: feedbackTitle, feedbackContext: feedbackContext, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { userIdForAnalytics: userIdForAnalytics, displayName: displayName } = (0, $bQm3c.useSessionData)();
    const { loading: loading, error: error, restrictions: restrictions } = (0, $jLw6A.usePageRestrictionsContext)();
    const [hasUserConsent, setHasUserConsent] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        /**
     * Once the check for page restrictions is no longer loading and has no errors,
     * set the user content value based on the levels of restrictions for the page.
     */ if (loading || error || !restrictions) return;
        const isRestricted = restrictions.hasRestrictions || restrictions.hasViewRestrictions || restrictions.hasInheritedRestrictions;
        return setHasUserConsent(!isRestricted);
    }, [
        loading,
        error,
        restrictions
    ]);
    const handleHasUserConsent = (0, $cozmU.useCallback)(()=>{
        setHasUserConsent((current)=>!current);
    }, []);
    const { showFlag: showFlag } = flags;
    const displayFlag = ()=>{
        showFlag({
            type: 'success-circle',
            title: formatMessage($9006c850d364bf02$var$i18n.flagTitle),
            description: formatMessage($9006c850d364bf02$var$i18n.flagDescription)
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91uAX.default), {
        name: displayName ?? undefined,
        atlassianAccountId: userIdForAnalytics ?? undefined,
        onClose: onClose,
        onSubmit: displayFlag,
        customContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.default), {
            label: formatMessage($9006c850d364bf02$var$i18n.userConsentCheckboxLabel),
            onChange: handleHasUserConsent,
            isChecked: hasUserConsent
        }),
        entrypointId: $9006c850d364bf02$var$GAIE_ENTRYPOINT_ID,
        showTypeField: false,
        feedbackTitle: feedbackTitle || formatMessage($9006c850d364bf02$var$i18n.feedbackTitle),
        anonymousFeedback: false,
        summaryPlaceholder: formatMessage($9006c850d364bf02$var$i18n.summaryPlaceholder),
        canBeContactedLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9006c850d364bf02$var$CanContactLabel, null),
        enrolInResearchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9006c850d364bf02$var$EnrolLabel, null),
        additionalFields: $9006c850d364bf02$var$buildAdditionalFields({
            feedbackContext: feedbackContext,
            hasUserConsent: hasUserConsent
        })
    });
};
const $9006c850d364bf02$var$EditorAIFeedbackCollectorWithFlags = (0, $7aRa9.withFlags)($9006c850d364bf02$var$EditorAIFeedbackCollectorComponent);
const $9006c850d364bf02$export$6ffb247c35565a98 = ()=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [feedbackContext, setFeedbackContext] = (0, $cozmU.useState)();
    const onClose = (0, $cozmU.useCallback)(()=>{
        setFeedbackContext(undefined);
        setIsOpen(false);
    }, []);
    const openFeedbackCollector = (0, $cozmU.useCallback)((feedbackSubmissionArgs)=>{
        setFeedbackContext(feedbackSubmissionArgs);
        setIsOpen(true);
    }, []);
    const EditorAIFeedbackCollector = (0, $cozmU.useCallback)(()=>isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9006c850d364bf02$var$EditorAIFeedbackCollectorWithFlags, {
            feedbackContext: feedbackContext,
            onClose: onClose
        }) : null, [
        isOpen,
        onClose,
        feedbackContext
    ]);
    return {
        FeedbackCollector: EditorAIFeedbackCollector,
        openFeedbackCollector: openFeedbackCollector
    };
};
module.exports["useEditorAIFeedbackCollector"] = $9006c850d364bf02$export$6ffb247c35565a98;

});

parcelRegister("2uDbg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $7r5Hr = parcelRequire("7r5Hr");


var $lmzCg = parcelRequire("lmzCg");


var $8c6io = parcelRequire("8c6io");


var $2hGAN = parcelRequire("2hGAN");


var $cAK2R = parcelRequire("cAK2R");


var $kbRVk = parcelRequire("kbRVk");

const $5e9458ef4430c05f$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $5e9458ef4430c05f$var$Checkbox = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Checkbox(t0, ref) {
    const $ = (0, $bDgLe.c)(59);
    let analyticsContext;
    let className;
    let isCheckedProp;
    let isRequired;
    let label;
    let name;
    let onChangeProps;
    let rest;
    let t1;
    let t2;
    let t3;
    let t4;
    let testId;
    let value;
    let xcss;
    if ($[0] !== t0) {
        ({ isChecked: isCheckedProp, isDisabled: t1, isInvalid: t2, defaultChecked: t3, isIndeterminate: t4, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest } = t0);
        $[0] = t0;
        $[1] = analyticsContext;
        $[2] = className;
        $[3] = isCheckedProp;
        $[4] = isRequired;
        $[5] = label;
        $[6] = name;
        $[7] = onChangeProps;
        $[8] = rest;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
        $[13] = testId;
        $[14] = value;
        $[15] = xcss;
    } else {
        analyticsContext = $[1];
        className = $[2];
        isCheckedProp = $[3];
        isRequired = $[4];
        label = $[5];
        name = $[6];
        onChangeProps = $[7];
        rest = $[8];
        t1 = $[9];
        t2 = $[10];
        t3 = $[11];
        t4 = $[12];
        testId = $[13];
        value = $[14];
        xcss = $[15];
    }
    const isDisabled = t1 === undefined ? false : t1;
    const isInvalid = t2 === undefined ? false : t2;
    const defaultChecked = t3 === undefined ? false : t3;
    const isIndeterminate = t4 === undefined ? false : t4;
    const [isCheckedState, setIsCheckedState] = (0, $cozmU.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    let t5;
    if ($[16] !== onChangeProps) {
        t5 = (e, analyticsEvent)=>{
            setIsCheckedState(e.target.checked);
            if (onChangeProps) onChangeProps(e, analyticsEvent);
        };
        $[16] = onChangeProps;
        $[17] = t5;
    } else t5 = $[17];
    const onChange = t5;
    let t6;
    if ($[18] !== analyticsContext || $[19] !== onChange) {
        t6 = {
            fn: onChange,
            action: "changed",
            analyticsData: analyticsContext,
            componentName: "checkbox",
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        };
        $[18] = analyticsContext;
        $[19] = onChange;
        $[20] = t6;
    } else t6 = $[20];
    const onChangeAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t6);
    const internalRef = (0, $cozmU.useRef)(null);
    const mergedRefs = (0, $lmzCg.default)([
        internalRef,
        ref
    ]);
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    let t7;
    if ($[21] !== internalRef || $[22] !== isIndeterminate) {
        t7 = ()=>{
            if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
        };
        $[21] = internalRef;
        $[22] = isIndeterminate;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== isIndeterminate) {
        t8 = [
            isIndeterminate
        ];
        $[24] = isIndeterminate;
        $[25] = t8;
    } else t8 = $[25];
    (0, $cozmU.useEffect)(t7, t8);
    const t9 = label;
    const t10 = rest.id ? `${rest.id}-label` : undefined;
    const t11 = testId && `${testId}--checkbox-label`;
    let t12;
    if ($[26] !== className) {
        t12 = (0, $hekY6.default)([
            $5e9458ef4430c05f$var$checkboxStyles.root,
            className
        ]);
        $[26] = className;
        $[27] = t12;
    } else t12 = $[27];
    const t13 = isInvalid ? "true" : undefined;
    const t14 = testId && `${testId}--hidden-checkbox`;
    const t15 = isInvalid ? "true" : undefined;
    let t16;
    if ($[28] !== isChecked || $[29] !== isDisabled || $[30] !== isRequired || $[31] !== mergedRefs || $[32] !== name || $[33] !== onChangeAnalytics || $[34] !== rest || $[35] !== t12 || $[36] !== t13 || $[37] !== t14 || $[38] !== t15 || $[39] !== value) {
        t16 = /*#__PURE__*/ $cozmU.createElement("input", {
            tabIndex: 0,
            ...rest,
            type: "checkbox",
            ref: mergedRefs,
            disabled: isDisabled,
            checked: isChecked,
            value: value,
            name: name,
            required: isRequired,
            className: t12,
            onChange: onChangeAnalytics,
            "aria-invalid": t13,
            "data-testid": t14,
            "data-invalid": t15
        });
        $[28] = isChecked;
        $[29] = isDisabled;
        $[30] = isRequired;
        $[31] = mergedRefs;
        $[32] = name;
        $[33] = onChangeAnalytics;
        $[34] = rest;
        $[35] = t12;
        $[36] = t13;
        $[37] = t14;
        $[38] = t15;
        $[39] = value;
        $[40] = t16;
    } else t16 = $[40];
    let t17;
    if ($[41] !== isChecked || $[42] !== isIndeterminate) {
        t17 = /*#__PURE__*/ $cozmU.createElement((0, $8c6io.default), {
            isIndeterminate: isIndeterminate,
            isChecked: isChecked
        });
        $[41] = isChecked;
        $[42] = isIndeterminate;
        $[43] = t17;
    } else t17 = $[43];
    let t18;
    if ($[44] !== isRequired || $[45] !== label) {
        t18 = label && /*#__PURE__*/ $cozmU.createElement((0, $cAK2R.default), null, label, isRequired && /*#__PURE__*/ $cozmU.createElement((0, $kbRVk.default), null));
        $[44] = isRequired;
        $[45] = label;
        $[46] = t18;
    } else t18 = $[46];
    let t19;
    if ($[47] !== isChecked || $[48] !== isDisabled || $[49] !== isIndeterminate || $[50] !== isInvalid || $[51] !== t10 || $[52] !== t11 || $[53] !== t16 || $[54] !== t17 || $[55] !== t18 || $[56] !== t9 || $[57] !== xcss) {
        t19 = /*#__PURE__*/ $cozmU.createElement((0, $2hGAN.default), {
            isDisabled: isDisabled,
            isChecked: isChecked,
            isIndeterminate: isIndeterminate,
            isInvalid: isInvalid,
            label: t9,
            id: t10,
            testId: t11,
            xcss: xcss
        }, t16, t17, t18);
        $[47] = isChecked;
        $[48] = isDisabled;
        $[49] = isIndeterminate;
        $[50] = isInvalid;
        $[51] = t10;
        $[52] = t11;
        $[53] = t16;
        $[54] = t17;
        $[55] = t18;
        $[56] = t9;
        $[57] = xcss;
        $[58] = t19;
    } else t19 = $[58];
    return t19;
} : function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $cozmU.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $cozmU.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $cozmU.useRef)(null);
    const mergedRefs = (0, $lmzCg.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $cozmU.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $2hGAN.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss
    }, /*#__PURE__*/ $cozmU.createElement("input" // It is necessary only for Safari. It allows to render focus styles.
    , {
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        className: (0, $hekY6.default)([
            $5e9458ef4430c05f$var$checkboxStyles.root,
            className
        ]),
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ $cozmU.createElement((0, $8c6io.default), {
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ $cozmU.createElement((0, $cAK2R.default), null, label, isRequired && /*#__PURE__*/ $cozmU.createElement((0, $kbRVk.default), null)));
}));
$5e9458ef4430c05f$var$Checkbox.displayName = 'Checkbox';
var $5e9458ef4430c05f$export$2e2bcd8739ae039 = $5e9458ef4430c05f$var$Checkbox;
module.exports["default"] = $5e9458ef4430c05f$export$2e2bcd8739ae039;

});

parcelRegister("8c6io", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $ef6550583d45a5c6$var$svgStyles = {
    root: "_nd5lfibj _1reo15vq _18m915vq _v5641mn3 _2rko12b0 _1a3742bt _lcxvglyw _syazmov0 _lswu1kgh _1cwg1i6y",
    rect: "_v56411so _1snbe4h9 _1s17hteq"
};
function $ef6550583d45a5c6$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ $cozmU.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit"
    });
    if (isChecked) return /*#__PURE__*/ $cozmU.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    });
     // No icon
    return null;
}
const $ef6550583d45a5c6$var$CheckboxIcon = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { isIndeterminate: isIndeterminate, isChecked: isChecked } = t0;
    let t1;
    if ($[0] !== isChecked || $[1] !== isIndeterminate) {
        t1 = $ef6550583d45a5c6$var$getIcon(isIndeterminate, isChecked);
        $[0] = isChecked;
        $[1] = isIndeterminate;
        $[2] = t1;
    } else t1 = $[2];
    const icon = t1;
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $ef6550583d45a5c6$var$svgStyles.root
        ]);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ $cozmU.createElement("rect", {
            fill: "currentColor",
            x: "5.5",
            y: "5.5",
            width: "13",
            height: "13",
            rx: "1.5",
            className: (0, $hekY6.default)([
                $ef6550583d45a5c6$var$svgStyles.rect
            ])
        });
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== icon) {
        t4 = /*#__PURE__*/ $cozmU.createElement("svg", {
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            role: "presentation",
            className: t2
        }, /*#__PURE__*/ $cozmU.createElement("g", {
            fillRule: "evenodd"
        }, t3, icon));
        $[5] = icon;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $cozmU.useMemo)(()=>$ef6550583d45a5c6$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $hekY6.default)([
            $ef6550583d45a5c6$var$svgStyles.root
        ])
    }, /*#__PURE__*/ $cozmU.createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ $cozmU.createElement("rect", {
        fill: "currentColor",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        className: (0, $hekY6.default)([
            $ef6550583d45a5c6$var$svgStyles.rect
        ])
    }), icon));
});
var $ef6550583d45a5c6$export$2e2bcd8739ae039 = $ef6550583d45a5c6$var$CheckboxIcon;
module.exports["default"] = $ef6550583d45a5c6$export$2e2bcd8739ae039;

});

parcelRegister("2hGAN", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $1634ca3e0554fde5$var$baseStyles = null;
const $1634ca3e0554fde5$var$textLabelLayoutStyles = null; // Checked/Indeterminate state
const $1634ca3e0554fde5$var$checkedStyles = null; // Invalid state - must override hover/active to maintain red border
const $1634ca3e0554fde5$var$invalidStyles = null; // Disabled state - must override hover/active to maintain disabled appearance
const $1634ca3e0554fde5$var$disabledStyles = null; // Disabled + Checked/Indeterminate
const $1634ca3e0554fde5$var$disabledCheckedStyles = null;
const $1634ca3e0554fde5$var$Label = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Label(t0) {
    const $ = (0, $bDgLe.c)(13);
    const { children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss } = t0;
    const t1 = label && "_zulp1nu5 _yv0ey09t";
    const t2 = (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz";
    const t3 = isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2";
    const t4 = isDisabled && "_1qwn187o _f0gr187o _syaz1gmx _80om13gf _1vj5187o _q29q187o _dh4g187o _cz1u187o _jom5wc43 _1s0718qt _106f18qt";
    const t5 = isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac";
    let t6;
    if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5 || $[5] !== xcss) {
        t6 = (0, $hekY6.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            t1,
            t2,
            t3,
            t4,
            t5,
            xcss
        ]);
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = xcss;
        $[6] = t6;
    } else t6 = $[6];
    const t7 = isDisabled || undefined;
    let t8;
    if ($[7] !== children || $[8] !== id || $[9] !== t6 || $[10] !== t7 || $[11] !== testId) {
        t8 = /*#__PURE__*/ $cozmU.createElement("label", {
            className: t6,
            "data-testid": testId,
            "data-disabled": t7,
            id: id
        }, children);
        $[7] = children;
        $[8] = id;
        $[9] = t6;
        $[10] = t7;
        $[11] = testId;
        $[12] = t8;
    } else t8 = $[12];
    return t8;
} : function Label({ children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ $cozmU.createElement("label", {
        className: (0, $hekY6.default)([
            "_11c8fhey _1e0c11p5 _1ejihkll _umai184x _1qwn1j9a _f0grrsbi _1c53glyw _1e9d1j28 _syazi7uo _80om73ad _ljcgdfik _1vj5l4ek _dh4gr01l _cz1u1l7x _jom5wc43 _1s071onz _106f1onz",
            label && "_zulp1nu5 _yv0ey09t",
            (isChecked || isIndeterminate) && "_1qwnjmqp _f0grjmqp _1e9d5w2r _1vj51q28 _q29q1q28 _dh4gr01l _cz1u1l7x _zoo95w2r _jom5wc43 _1s071onz _106f1onz",
            isInvalid && "_f0gr1bqt _q29q1bqt _cz1u1bqt _1s07gir2",
            isDisabled && "_1qwn187o _f0gr187o _syaz1gmx _80om13gf _1vj5187o _q29q187o _dh4g187o _cz1u187o _jom5wc43 _1s0718qt _106f18qt",
            isDisabled && (isChecked || isIndeterminate) && "_1e9d2sac _9js12sac _zoo92sac",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
};
var $1634ca3e0554fde5$export$2e2bcd8739ae039 = $1634ca3e0554fde5$var$Label;
module.exports["default"] = $1634ca3e0554fde5$export$2e2bcd8739ae039;

});

parcelRegister("cAK2R", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $4870a5341200be20$var$labelTextStyles = null;
const $4870a5341200be20$var$LabelText = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LabelText(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_nd5l11ig _1wpz1h6o"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ $cozmU.createElement("span", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : function LabelText({ children: children }) {
    return /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_nd5l11ig _1wpz1h6o"
        ])
    }, children);
};
var $4870a5341200be20$export$2e2bcd8739ae039 = $4870a5341200be20$var$LabelText;
module.exports["default"] = $4870a5341200be20$export$2e2bcd8739ae039;

});

parcelRegister("kbRVk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $126a273b3177dba3$var$requiredIndicatorStyles = null;
const $126a273b3177dba3$var$RequiredIndicator = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RequiredIndicator() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement("span", {
            "aria-hidden": true,
            className: (0, $hekY6.default)([
                "_syaz1tmw _bozgv77o"
            ])
        }, "*");
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function RequiredIndicator() {
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "aria-hidden": true,
        className: (0, $hekY6.default)([
            "_syaz1tmw _bozgv77o"
        ])
    }, "*");
};
var $126a273b3177dba3$export$2e2bcd8739ae039 = $126a273b3177dba3$var$RequiredIndicator;
module.exports["default"] = $126a273b3177dba3$export$2e2bcd8739ae039;

});

parcelRegister("91uAX", function(module, exports) {
$parcel$export(module.exports, "default", () => $eb4dd8e62f46596b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "FeedbackFlag", () => (parcelRequire("7MfQo")).default);


var $2eX69 = parcelRequire("2eX69");


var $7MfQo = parcelRequire("7MfQo");


var $eb4dd8e62f46596b$export$2e2bcd8739ae039 = (0, $2eX69.default);

});

parcelRegister("2eX69", function(module, exports) {

var $e9nC3 = parcelRequire("e9nC3");


var $cozmU = parcelRequire("cozmU");


var $ixfCV = parcelRequire("ixfCV");


var $5BnIc = parcelRequire("5BnIc");


var $9C5oc = parcelRequire("9C5oc");


var $h45y6 = parcelRequire("h45y6");

const $a45798977a968ec1$var$MAX_SUMMARY_LENGTH_CHARS = 100;
const $a45798977a968ec1$var$singleLineTruncatedText = (text, length = $a45798977a968ec1$var$MAX_SUMMARY_LENGTH_CHARS)=>{
    const singleLineText = text.replace(/\n/g, ' ');
    return (0, $9C5oc.default)(singleLineText, length);
};
class $a45798977a968ec1$export$2e2bcd8739ae039 extends (0, $cozmU.Component) {
    async componentDidMount() {
        const anonymousFeedback = !await this.shouldShowOptInCheckboxesNew();
        this.setState({
            anonymousFeedback: anonymousFeedback
        });
    }
    getGatewayUrl() {
        const { customGatewayUrl: customGatewayUrl, url: url } = this.props;
        if (customGatewayUrl) return customGatewayUrl;
        if (url) return url;
        return $a45798977a968ec1$export$2e2bcd8739ae039.defaultProps.url;
    }
    getFeedbackUrl() {
        const { customFeedbackUrl: customFeedbackUrl, url: url } = this.props;
        if (customFeedbackUrl) return customFeedbackUrl;
        if (url) return url;
        return $a45798977a968ec1$export$2e2bcd8739ae039.defaultProps.url;
    }
    getPackageVersion() {
        return "0.0.0-use.local";
    }
    async getEntitlementInformation() {
        const url = this.getGatewayUrl();
        // jira / confluence / bitbucket / trello
        let productName;
        let productEntitlement;
        let entitlementDetails;
        let productKey;
        if (window.location.host.includes('bitbucket.org')) {
            productName = 'Bitbucket';
            productKey = 'bitbucket';
            entitlementDetails = JSON.parse(JSON.stringify(document.querySelector('meta[id="bb-bootstrap"]')?.getAttribute('data-current-user')));
            const hasPremium = entitlementDetails['hasPremium'];
            productEntitlement = hasPremium ? 'PREMIUM' : 'STANDARD';
        } else if ([
            'trellis.coffee',
            'trello.com'
        ].includes(window.location.host)) {
            productName = 'Trello';
            productKey = 'trello';
        } else {
            if (document.querySelector('meta[id="confluence-context-path"]')) {
                productName = 'Confluence';
                productKey = 'pricingplan.confluence.ondemand';
            } else {
                productName = 'Jira';
                productKey = 'jira-software.ondemand';
            }
            try {
                entitlementDetails = await fetch(`${url}/customer-context/entitlements/${window.location.host}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    ...(0, $5BnIc.isApiGatewayUrl)(url) ? {
                        credentials: 'include'
                    } : {}
                });
            } catch (e) {
                entitlementDetails = undefined;
            }
        }
        let entitlement;
        const entitlementInformation = [];
        const cloudSiteId = entitlementDetails?.cloudSiteId || '';
        if (entitlementDetails?.children) entitlement = entitlementDetails?.children.find((entitlement)=>{
            return entitlement.key === productKey;
        });
        entitlementInformation.push({
            id: 'product',
            value: productName ? productName?.toLowerCase() : ''
        }, {
            id: 'hostingType',
            value: entitlement?.product ? entitlement.product.hostingType : 'CLOUD'
        }, {
            id: 'entitlementEdition',
            value: productEntitlement ?? ''
        }, {
            id: 'cloudId',
            value: cloudSiteId
        });
        return entitlementInformation;
    }
    getTypeFieldValue(dtype) {
        switch(dtype){
            case 'bug':
                return this.props.typeBugDefaultValue;
            case 'comment':
                return this.props.typeCommentDefaultValue;
            case 'suggestion':
                return this.props.typeSuggestionDefaultValue;
            case 'question':
                return this.props.typeQuestionDefaultValue;
            case 'empty':
            default:
                return this.props.typeEmptyDefaultValue;
        }
    }
    async getAtlassianID() {
        const { atlassianAccountId: atlassianAccountId, shouldGetEntitlementDetails: shouldGetEntitlementDetails } = this.props;
        try {
            if (atlassianAccountId || !shouldGetEntitlementDetails) return atlassianAccountId;
            const url = this.getGatewayUrl();
            const result = await fetch(`${url}/me`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                ...(0, $5BnIc.isApiGatewayUrl)(url) ? {
                    credentials: 'include'
                } : {}
            });
            const json = await result.json();
            return json.account_id;
        } catch (e) {
            return undefined;
        }
    }
    shouldShowOptInCheckboxes() {
        if (this.props.anonymousFeedback) return !this.props.anonymousFeedback;
        if (this.props.atlassianAccountId) return true;
        let response;
        this.getAtlassianID().then((result)=>{
            response = result !== undefined;
        }).catch(()=>{
            response = false;
        });
        // @ts-ignore
        return response;
    }
    shouldShowOptInCheckboxesNew() {
        return new Promise((resolve)=>{
            if (this.props.anonymousFeedback) resolve(!this.props.anonymousFeedback);
            if (this.props.atlassianAccountId) resolve(true);
            this.getAtlassianID().then((result)=>{
                resolve(result !== undefined);
            }).catch(()=>{
                resolve(false);
            });
        });
    }
    getDescription(formValues) {
        return formValues.description || this.props.descriptionDefaultValue;
    }
    getSummary(formValues) {
        return $a45798977a968ec1$var$singleLineTruncatedText(formValues.description, this.props.summaryTruncateLength) || this.props.summaryDefaultValue;
    }
    getCustomerName() {
        return this.props.name ?? this.props.customerNameDefaultValue;
    }
    addEmailToContext() {
        const contextField = this.props.additionalFields.find((field)=>{
            return field.id === 'customfield_10047';
        });
        if (contextField) contextField.value = `${contextField.value}
        email: ${this.props.email}`;
        else this.props.additionalFields.push({
            id: 'customfield_10047',
            value: `email: ${this.props.email}`
        });
    }
    addAccountIdToContext(atlassianID) {
        if (atlassianID) {
            const contextField = this.props.additionalFields.find((field)=>{
                return field.id === 'customfield_10047';
            });
            if (contextField) contextField.value = `${contextField.value}
			atlassian-account-id: ${atlassianID}`;
        }
    }
    async mapFormToJSD(formValues) {
        let entitlementInformation = null;
        if (this.props?.shouldGetEntitlementDetails) entitlementInformation = await this.getEntitlementInformation();
        if (this.props?.email) this.addEmailToContext();
        const atlassianID = await this.getAtlassianID();
        this.addAccountIdToContext(atlassianID);
        return {
            fields: [
                ...entitlementInformation !== null && entitlementInformation || [],
                this.props.showTypeField ? {
                    id: this.props.typeFieldId,
                    value: this.getTypeFieldValue(formValues.type)
                } : undefined,
                {
                    id: this.props.summaryFieldId,
                    value: this.getSummary(formValues)
                },
                {
                    id: this.props.descriptionFieldId,
                    value: this.getDescription(formValues)
                },
                {
                    id: 'aaidOrHash',
                    value: formValues.canBeContacted ? atlassianID : undefined
                },
                {
                    id: this.props.customerNameFieldId,
                    value: this.getCustomerName()
                },
                formValues.canBeContacted ? {
                    id: this.props.canBeContactedFieldId,
                    value: this.props.canBeContactedAgreeValue
                } : {
                    id: this.props.canBeContactedFieldId,
                    value: this.props.canBeContactedDeclineValue
                },
                formValues.enrollInResearchGroup ? {
                    id: this.props.enrollInResearchFieldId,
                    value: this.props.enrollInResearchAgreeValue
                } : {
                    id: this.props.enrollInResearchFieldId,
                    value: this.props.enrollInResearchDeclineValue
                },
                ...this.props.additionalFields
            ].filter(Boolean)
        };
    }
    render() {
        const anonymousFeedback = !this.shouldShowOptInCheckboxes();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h45y6.default), {
            customContent: this.props.customContent,
            feedbackTitle: this.props.feedbackTitle,
            feedbackTitleDetails: this.props.feedbackTitleDetails,
            showTypeField: this.props.showTypeField,
            showDefaultTextFields: this.props.showDefaultTextFields,
            hasDescriptionDefaultValue: !!this.props.descriptionDefaultValue,
            canBeContactedLabel: this.props.canBeContactedLabel,
            enrolInResearchLabel: this.props.enrolInResearchLabel,
            summaryPlaceholder: this.props.summaryPlaceholder,
            submitButtonLabel: this.props.submitButtonLabel,
            cancelButtonLabel: this.props.cancelButtonLabel,
            feedbackGroupLabels: this.props.feedbackGroupLabels,
            onSubmit: this.postFeedback,
            onClose: this.props.onClose,
            onCancel: this.props.onCancel,
            locale: this.props.locale,
            anonymousFeedback: (0, $ixfCV.fg)('platform.proforma-form-builder-feedback_hupaz') ? this.state.anonymousFeedback : anonymousFeedback,
            selectLabel: this.props.selectLabel,
            customTextAreaLabel: this.props.customTextAreaLabel,
            customFeedbackOptions: this.props.customFeedbackOptions,
            shouldReturnFocusRef: this.props.shouldReturnFocusRef,
            dialogRef: this.props.dialogRef,
            disableSubmitButton: this.props.disableSubmitButton,
            ...(0, $ixfCV.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                enrolInResearchLink: this.props.enrolInResearchLink,
                canBeContactedLink: this.props.canBeContactedLink
            },
            showRequiredFieldsSummary: this.props.showRequiredFieldsSummary
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            anonymousFeedback: true
        };
        this.postFeedback = async (formValues)=>{
            const entrypointId = this.props.entrypointId;
            let fetchUrl = this.getFeedbackUrl();
            // Don't dispatch unless we have suitable props (allows tests to pass through empty strings and avoid redundant network calls)
            if (entrypointId) {
                const formData = await this.mapFormToJSD(formValues);
                const body = {
                    feedback: {
                        entrypointId: this.props.entrypointId,
                        entrypointUiVersion: this.getPackageVersion(),
                        ...formData
                    }
                };
                if ((0, $5BnIc.isApiGatewayUrl)(fetchUrl)) fetchUrl += '/feedback-collector-api';
                else if (!this.props.customFeedbackUrl) fetchUrl = 'https://feedback-collector-api.services.atlassian.com';
                const postData = (0, $e9nC3.Buffer).from(JSON.stringify(body)).toString('base64');
                fetch(`${fetchUrl}/v2/feedback`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        data: postData
                    }),
                    credentials: 'include'
                });
            }
            this.props.onClose();
            // slightly delay confirming submit since we don't wait for the REST call to succeed
            //
            // Because `onClose` is invoked prior to this timeout triggering, the `componentWillUnmount`
            // may occur before the `onSubmit` is called. To prevent prematurely cancelling the
            // network request, we deliberately don't clear this timeout inside `componentWillUnmount`.
            //
            setTimeout(()=>this.props.onSubmit(formValues), this.props.timeoutOnSubmit);
        };
    }
}
$a45798977a968ec1$export$2e2bcd8739ae039.defaultProps = {
    locale: 'en',
    url: '/gateway/api',
    shouldGetEntitlementDetails: true,
    canBeContactedFieldId: 'customfield_10043',
    canBeContactedAgreeValue: [
        {
            id: '10109'
        }
    ],
    canBeContactedDeclineValue: [
        {
            id: '10111'
        }
    ],
    additionalFields: [],
    customerNameFieldId: 'customfield_10045',
    customerNameDefaultValue: 'unknown',
    descriptionFieldId: 'description',
    descriptionDefaultValue: '',
    enrollInResearchFieldId: 'customfield_10044',
    enrollInResearchAgreeValue: [
        {
            id: '10110'
        }
    ],
    enrollInResearchDeclineValue: [
        {
            id: '10112'
        }
    ],
    summaryFieldId: 'summary',
    summaryDefaultValue: '',
    summaryTruncateLength: 100,
    timeoutOnSubmit: 700,
    typeFieldId: 'customfield_10042',
    typeBugDefaultValue: {
        id: '10105'
    },
    typeCommentDefaultValue: {
        id: '10106'
    },
    typeSuggestionDefaultValue: {
        id: '10107'
    },
    typeQuestionDefaultValue: {
        id: '10108'
    },
    typeEmptyDefaultValue: {
        id: 'empty'
    },
    showTypeField: true,
    showDefaultTextFields: true,
    anonymousFeedback: false,
    onClose: ()=>{},
    onSubmit: ()=>{}
};
module.exports["default"] = $a45798977a968ec1$export$2e2bcd8739ae039;

});

parcelRegister("5BnIc", function(module, exports) {
const $db292a71bf6452ef$export$f0f6fc934288a17c = (url)=>[
        '/gateway/api'
    ].includes(url);
module.exports["isApiGatewayUrl"] = $db292a71bf6452ef$export$f0f6fc934288a17c;

});

parcelRegister("9C5oc", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c5409c9e56ee67a$export$2e2bcd8739ae039);
function $0c5409c9e56ee67a$export$2e2bcd8739ae039(text, maxLength) {
    if (!text || !maxLength) return text;
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
}

});

parcelRegister("h45y6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $2uDbg = parcelRequire("2uDbg");


var $dTHYM = parcelRequire("dTHYM");

var $7BfeF = parcelRequire("7BfeF");

var $dUI0h = parcelRequire("dUI0h");

var $2Nu0e = parcelRequire("2Nu0e");

var $dQLwo = parcelRequire("dQLwo");

var $hpa99 = parcelRequire("hpa99");


var $i1t43 = parcelRequire("i1t43");


var $7aRdF = parcelRequire("7aRdF");

var $fEPJS = parcelRequire("fEPJS");

var $eQiT1 = parcelRequire("eQiT1");

var $9Umtx = parcelRequire("9Umtx");

var $jq995 = parcelRequire("jq995");


var $ixfCV = parcelRequire("ixfCV");


var $1VhsF = parcelRequire("1VhsF");


var $6wGOF = parcelRequire("6wGOF");


var $e3Wrf = parcelRequire("e3Wrf");


var $5r21M = parcelRequire("5r21M");


var $hTUp6 = parcelRequire("hTUp6");

const $dcf72f8838f67ff8$var$LinkWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            paddingInlineStart: "var(--ds-space-300, 24px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginInlineStart: "var(--ds-space-050, 4px)"
        }
    }, children);
};
const $dcf72f8838f67ff8$var$FeedbackForm = ({ showTypeField: showTypeField = true, showDefaultTextFields: showDefaultTextFields = true, customContent: customContent, onClose: onClose, onCancel: onCancel, onSubmit: onSubmit, feedbackTitle: feedbackTitle, feedbackTitleDetails: feedbackTitleDetails, feedbackGroupLabels: feedbackGroupLabels, summaryPlaceholder: summaryPlaceholder, canBeContactedLabel: canBeContactedLabel, canBeContactedLink: canBeContactedLink, enrolInResearchLabel: enrolInResearchLabel, enrolInResearchLink: enrolInResearchLink, submitButtonLabel: submitButtonLabel, cancelButtonLabel: cancelButtonLabel, anonymousFeedback: anonymousFeedback, hasDescriptionDefaultValue: hasDescriptionDefaultValue, selectLabel: selectLabel, customTextAreaLabel: customTextAreaLabel, customFeedbackOptions: customFeedbackOptions = [], shouldReturnFocusRef: shouldReturnFocusRef, dialogRef: dialogRef, disableSubmitButton: disableSubmitButton, showRequiredFieldsSummary: showRequiredFieldsSummary = true })=>{
    const [canBeContacted, setCanBeContacted] = (0, $cozmU.useState)(false);
    const [description, setDescription] = (0, $cozmU.useState)('');
    const [enrollInResearchGroup, setEnrollInResearchGroup] = (0, $cozmU.useState)(false);
    const [type, setType] = (0, $cozmU.useState)('empty');
    const [isSubmitting, setIsSubmitting] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isTypeSelected = ()=>type !== 'empty';
    const validateType = (value)=>showTypeField && (!value || value === 'empty') ? formatMessage((0, $5r21M.messages).validationErrorTypeRequired) : undefined;
    const validateDescription = (value)=>{
        if (!showDefaultTextFields || hasDescriptionDefaultValue) return undefined;
        return !value || !value.trim() ? formatMessage((0, $5r21M.messages).validationErrorDescriptionRequired) : undefined;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleCancel = (...args)=>{
        onCancel?.(...args);
        // Forward every arg the click handler received so consumers retain the full
        // pre-change runtime contract (originating event + Atlaskit UI analytics event).
        onClose(...args);
    };
    const canShowTextField = isTypeSelected() || !showTypeField;
    const isDisabled = isSubmitting || disableSubmitButton;
    const getFieldLabels = (record)=>({
            bug: record?.bug?.fieldLabel || formatMessage((0, $5r21M.messages).formBugLabel),
            comment: record?.comment?.fieldLabel || formatMessage((0, $5r21M.messages).formCommentLabel),
            suggestion: record?.suggestion?.fieldLabel || formatMessage((0, $5r21M.messages).formSuggestionLabel),
            question: record?.question?.fieldLabel || formatMessage((0, $5r21M.messages).formQuestionLabel),
            empty: record?.empty?.fieldLabel || formatMessage((0, $5r21M.messages).formEmptyLabel),
            not_relevant: record?.not_relevant?.fieldLabel || formatMessage((0, $5r21M.messages).formNotRelevantLabel),
            not_accurate: record?.not_accurate?.fieldLabel || formatMessage((0, $5r21M.messages).formNotAccurateLabel),
            too_slow: record?.too_slow?.fieldLabel || formatMessage((0, $5r21M.messages).formTooSlowLabel),
            unhelpful_links: record?.unhelpful_links?.fieldLabel || formatMessage((0, $5r21M.messages).formUnhelpfulLinksLabel),
            other: record?.other?.fieldLabel || formatMessage((0, $5r21M.messages).formOtherLabel)
        });
    const getSelectOptions = (record)=>[
            {
                label: record?.question?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionQuestionLabel),
                value: 'question'
            },
            {
                label: record?.comment?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionCommentLabel),
                value: 'comment'
            },
            {
                label: record?.bug?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionBugLabel),
                value: 'bug'
            },
            {
                label: record?.suggestion?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionSuggestionLabel),
                value: 'suggestion'
            }
        ];
    const getDefaultPlaceholder = (record)=>record?.empty?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionDefaultPlaceholder);
    const focusRef = (0, $cozmU.useRef)();
    const selectOptions = customFeedbackOptions.length > 0 ? customFeedbackOptions : getSelectOptions(feedbackGroupLabels);
    const renderContactLabelAppify = ()=>{
        if ((0, $ixfCV.fg)('jfp_a11y_team_feedback_collector_nested_elements')) return (0, $5r21M.messages).canBeContactedLabelAppifyWithoutLink;
        return (0, $5r21M.messages).canBeContactedLabelAppify;
    };
    const renderContactLabel = ()=>{
        if ((0, $ixfCV.fg)('jfp_a11y_team_feedback_collector_nested_elements')) return (0, $5r21M.messages).canBeContactedLabelWithoutLink;
        return (0, $5r21M.messages).canBeContactedLabel;
    };
    const requiredFieldsSummary = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("p", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            color: "var(--ds-text-subtle, #505258)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: "var(--ds-space-300, 24px)"
        }
    }, formatMessage((0, $5r21M.messages).requiredFieldsSummary), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpa99.default), null));
    const feedbackIsAnonymous = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("p", null, formatMessage((0, $5r21M.messages).feedbackIsAnonymous));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        ref: dialogRef,
        shouldCloseOnOverlayClick: false,
        onClose: onClose,
        testId: "feedbackCollectorModalDialog",
        shouldReturnFocus: shouldReturnFocusRef,
        shouldScrollInViewport: true
    }, (0, $ixfCV.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: async ()=>{
            setIsSubmitting(true);
            try {
                await onSubmit({
                    canBeContacted: canBeContacted,
                    description: description,
                    enrollInResearchGroup: enrollInResearchGroup,
                    type: type
                });
            } finally{
                setIsSubmitting(false);
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, feedbackTitle || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).feedbackTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, (0, $ixfCV.fg)('ak_feedback_collector_hide_required_summary') ? showRequiredFieldsSummary && requiredFieldsSummary : requiredFieldsSummary, feedbackTitleDetails, customContent, showTypeField ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "topic",
        id: "topic",
        label: selectLabel || formatMessage((0, $5r21M.messages).selectionOptionDefaultLabel),
        isRequired: true,
        validate: validateType
    }, ({ fieldProps: { id: id, ...restProps }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
            ...restProps,
            value: selectOptions.find((opt)=>opt.value === type) ?? null,
            onChange: (option)=>{
                if (!option || option instanceof Array) return;
                setType(option.value);
                restProps.onChange?.(option.value);
            },
            menuPosition: "fixed",
            options: selectOptions,
            // @ts-ignore
            ref: focusRef,
            placeholder: getDefaultPlaceholder(feedbackGroupLabels),
            inputId: id,
            isInvalid: !!error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, error)))) : null, showDefaultTextFields && canShowTextField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        label: showTypeField ? getFieldLabels(feedbackGroupLabels)[type] : customTextAreaLabel || formatMessage((0, $5r21M.messages).defaultCustomTextAreaLabel),
        isRequired: true,
        name: "description",
        id: "description",
        validate: validateDescription
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
            ...fieldProps,
            name: "foo",
            minimumRows: 6,
            placeholder: summaryPlaceholder || undefined,
            onChange: (e)=>{
                setDescription(e.target.value);
                fieldProps.onChange(e.target.value);
            },
            value: description
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, error)))), !anonymousFeedback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Nu0e.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("legend", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).optInOptionsLegend)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "can-be-contacted"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.default), {
            ...fieldProps,
            "aria-describedby": undefined,
            label: canBeContactedLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...(0, $ixfCV.fg)('product-terminology-refresh') ? renderContactLabelAppify() : renderContactLabel(),
                ...!(0, $ixfCV.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                    values: {
                        a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                                href: "https://www.atlassian.com/legal/privacy-policy",
                                target: "_blank"
                            }, chunks)
                    }
                }
            }),
            onChange: (event)=>setCanBeContacted(event.target.checked)
        }), canBeContactedLabel && canBeContactedLink && (0, $ixfCV.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, canBeContactedLink), !canBeContactedLabel && (0, $ixfCV.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: "https://www.atlassian.com/legal/privacy-policy",
            target: "_blank"
        }, formatMessage((0, $5r21M.messages).privacyPolicy))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "enroll-in-research-group"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.default), {
            ...fieldProps,
            "aria-describedby": undefined,
            label: enrolInResearchLabel || formatMessage((0, $5r21M.messages).enrolInResearchLabel),
            onChange: (event)=>setEnrollInResearchGroup(event.target.checked)
        }), enrolInResearchLabel && enrolInResearchLink && (0, $ixfCV.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, enrolInResearchLink)))) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: 'anonymousFeedback'
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
            title: formatMessage((0, $5r21M.messages).feedbackIsAnonymousTitle),
            appearance: 'information'
        }, feedbackIsAnonymous))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        onClick: handleCancel
    }, cancelButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).cancelButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "primary",
        type: "submit",
        isDisabled: isSubmitting || isDisabled,
        testId: "feedbackCollectorSubmitBtn"
    }, submitButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).submitButtonLabel)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: async ()=>{
            setIsSubmitting(true);
            try {
                await onSubmit({
                    canBeContacted: canBeContacted,
                    description: description,
                    enrollInResearchGroup: enrollInResearchGroup,
                    type: type
                });
            } finally{
                setIsSubmitting(false);
            }
        }
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, feedbackTitle || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).feedbackTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, (0, $ixfCV.fg)('ak_feedback_collector_hide_required_summary') ? showRequiredFieldsSummary && requiredFieldsSummary : requiredFieldsSummary, feedbackTitleDetails, customContent, showTypeField ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "topic",
            id: "topic",
            label: selectLabel || formatMessage((0, $5r21M.messages).selectionOptionDefaultLabel),
            isRequired: true,
            validate: validateType
        }, ({ fieldProps: { id: id, ...restProps }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
                ...restProps,
                value: selectOptions.find((opt)=>opt.value === type) ?? null,
                onChange: (option)=>{
                    if (!option || option instanceof Array) return;
                    setType(option.value);
                    restProps.onChange?.(option.value);
                },
                menuPosition: "fixed",
                options: selectOptions,
                // @ts-ignore
                ref: focusRef,
                placeholder: getDefaultPlaceholder(feedbackGroupLabels),
                inputId: id,
                isInvalid: !!error
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, error)))) : null, showDefaultTextFields && canShowTextField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            label: showTypeField ? getFieldLabels(feedbackGroupLabels)[type] : customTextAreaLabel || formatMessage((0, $5r21M.messages).defaultCustomTextAreaLabel),
            isRequired: true,
            name: "description",
            id: "description",
            validate: validateDescription
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
                ...fieldProps,
                name: "foo",
                minimumRows: 6,
                placeholder: summaryPlaceholder || undefined,
                onChange: (e)=>{
                    setDescription(e.target.value);
                    fieldProps.onChange(e.target.value);
                },
                value: description
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, error)))), !anonymousFeedback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Nu0e.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("legend", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).optInOptionsLegend)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "can-be-contacted"
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.default), {
                ...fieldProps,
                "aria-describedby": undefined,
                label: canBeContactedLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $ixfCV.fg)('product-terminology-refresh') ? renderContactLabelAppify() : renderContactLabel(),
                    ...!(0, $ixfCV.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                        values: {
                            a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                                    href: "https://www.atlassian.com/legal/privacy-policy",
                                    target: "_blank"
                                }, chunks)
                        }
                    }
                }),
                onChange: (event)=>setCanBeContacted(event.target.checked)
            }), canBeContactedLabel && canBeContactedLink && (0, $ixfCV.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, canBeContactedLink), !canBeContactedLabel && (0, $ixfCV.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                href: "https://www.atlassian.com/legal/privacy-policy",
                target: "_blank"
            }, formatMessage((0, $5r21M.messages).privacyPolicy))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "enroll-in-research-group"
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.default), {
                ...fieldProps,
                "aria-describedby": undefined,
                label: enrolInResearchLabel || formatMessage((0, $5r21M.messages).enrolInResearchLabel),
                onChange: (event)=>setEnrollInResearchGroup(event.target.checked)
            }), enrolInResearchLabel && enrolInResearchLink && (0, $ixfCV.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, enrolInResearchLink)))) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: 'anonymousFeedback'
        }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
                title: formatMessage((0, $5r21M.messages).feedbackIsAnonymousTitle),
                appearance: 'information'
            }, feedbackIsAnonymous))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            appearance: "subtle",
            onClick: handleCancel
        }, cancelButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).cancelButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            appearance: "primary",
            type: "submit",
            isDisabled: isSubmitting || isDisabled,
            testId: "feedbackCollectorSubmitBtn"
        }, submitButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).submitButtonLabel))))));
};
const $dcf72f8838f67ff8$var$FeedbackFormWithIntl = ({ locale: locale, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hTUp6.IntlProviderWithResolvedMessages), {
        locale: locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$FeedbackForm, props));
};
var $dcf72f8838f67ff8$export$2e2bcd8739ae039 = $dcf72f8838f67ff8$var$FeedbackFormWithIntl;
module.exports["default"] = $dcf72f8838f67ff8$export$2e2bcd8739ae039;

});

parcelRegister("5r21M", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $0eef762dd50d9f91$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    feedbackTitle: {
        id: "feedback-collector.feedback-title",
        defaultMessage: "Share your thoughts"
    },
    enrolInResearchLabel: {
        id: "feedback-collector.enrol-in-research.label",
        defaultMessage: "I'd like to participate in product research"
    },
    canBeContactedLabel: {
        id: "feedback-collector.can-be-contacted.label",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the <a>Atlassian Privacy Policy</a>."
    },
    canBeContactedLabelWithoutLink: {
        id: "feedback-collector.can-be-contacted.label-without-link",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the Atlassian Privacy Policy."
    },
    privacyPolicy: {
        id: "feedback-collector.privacy-policy",
        defaultMessage: "Atlassian Privacy Policy"
    },
    summaryPlaceholder: {
        id: "feedback-collector.summary-placeholder",
        defaultMessage: "Let us know what's on your mind"
    },
    formCommentLabel: {
        id: "feedback-collector.form.comment.label",
        defaultMessage: "Let us know what's on your mind"
    },
    submitButtonLabel: {
        id: "feedback-collector.submit-button.label",
        defaultMessage: "Send feedback"
    },
    cancelButtonLabel: {
        id: "feedback-collector.cancel-button.label",
        defaultMessage: "Cancel"
    },
    giveFeedback: {
        id: "proforma-form-builder.give-feedback",
        defaultMessage: "Give feedback"
    },
    formBugLabel: {
        id: "feedback-collector.form.bug.label",
        defaultMessage: "Describe the bug or issue"
    },
    formSuggestionLabel: {
        id: "feedback-collector.form.suggestion.label",
        defaultMessage: "Let us know what you'd like to improve"
    },
    formQuestionLabel: {
        id: "feedback-collector.form.question.label",
        defaultMessage: "What would you like to know?"
    },
    formEmptyLabel: {
        id: "feedback-collector.form.empty.label",
        defaultMessage: "Select an option"
    },
    formNotRelevantLabel: {
        id: "feedback-collector.form.not-relevant.label",
        defaultMessage: "Wasn't relevant"
    },
    formNotAccurateLabel: {
        id: "feedback-collector.form.not-accurate.label",
        defaultMessage: "Wasn't accurate"
    },
    formTooSlowLabel: {
        id: "feedback-collector.form.too-slow.label",
        defaultMessage: "Too slow"
    },
    formUnhelpfulLinksLabel: {
        id: "feedback-collector.form.unhelpful-links.label",
        defaultMessage: "Unhelpful links"
    },
    formOtherLabel: {
        id: "feedback-collector.form.other.label",
        defaultMessage: "Other"
    },
    selectionOptionQuestionLabel: {
        id: "feedback-collector.option.question.label",
        defaultMessage: "Ask a question"
    },
    selectionOptionCommentLabel: {
        id: "feedback-collector.option.comment.label",
        defaultMessage: "Leave a comment"
    },
    selectionOptionBugLabel: {
        id: "feedback-collector.option.bug.label",
        defaultMessage: "Report a bug"
    },
    selectionOptionSuggestionLabel: {
        id: "feedback-collector.option.suggestion.label",
        defaultMessage: "Suggest an improvement"
    },
    selectionOptionDefaultLabel: {
        id: "feedback-collector.option.default.label",
        defaultMessage: "Select feedback"
    },
    selectionOptionDefaultPlaceholder: {
        id: "feedback-collector.option.default.placeholder",
        defaultMessage: "Choose one"
    },
    feedbackIconLabel: {
        id: "proforma-form-builder.feedback-icon-label",
        defaultMessage: "Feedback"
    },
    feedbackSuccessFlagDescription: {
        id: "feedback-collector.success-flag.description",
        defaultMessage: "Your valuable feedback helps us continually improve our products."
    },
    feedbackSuccessFlagTitle: {
        id: "feedback-collector.success-flag.title",
        defaultMessage: "Thanks!"
    },
    feedbackIsAnonymousTitle: {
        id: "feedback-collector.anonymous.title",
        defaultMessage: "Anonymous feedback"
    },
    feedbackIsAnonymous: {
        id: "feedback-collector.anonymous",
        defaultMessage: "This feedback is being submitted anonymously. Atlassian will not be able to contact you directly regarding this feedback"
    },
    requiredFieldsSummary: {
        id: "feedback-collector.required.fields.summary",
        defaultMessage: "Required fields are marked with an asterisk"
    },
    defaultCustomTextAreaLabel: {
        id: "feedback-collector.default.custom.textarea.label",
        defaultMessage: "What's on your mind?"
    },
    canBeContactedLabelAppify: {
        id: "feedback-collector.can-be-contacted.label-appify",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian apps and services. I acknowledge the <a>Atlassian Privacy Policy</a>."
    },
    canBeContactedLabelAppifyWithoutLink: {
        id: "feedback-collector.can-be-contacted.label-appify-without-link",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian apps and services. I acknowledge the Atlassian Privacy Policy."
    },
    feedbackSuccessFlagDescriptionAppify: {
        id: "feedback-collector.success-flag.description-appify",
        defaultMessage: "Your valuable feedback helps us continually improve our apps."
    },
    validationErrorTypeRequired: {
        id: "feedback-collector.validation.type.required",
        defaultMessage: "Please select a feedback type"
    },
    validationErrorDescriptionRequired: {
        id: "feedback-collector.validation.description.required",
        defaultMessage: "Please provide a description"
    },
    optInOptionsLegend: {
        id: "feedback-collector.opt-in.options.legend",
        defaultMessage: "Atlassian opt-in options"
    }
});
module.exports["messages"] = $0eef762dd50d9f91$export$defe85febe8b728c;

});

parcelRegister("hTUp6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $b2A1s = parcelRequire("b2A1s");

const $fb8b4f9502ba72fc$export$f793de1293176fe6 = ({ children: children, locale: locale })=>{
    const [resolvedMessagesForLocale, setResolvedMessagesForLocale] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        const fetchMessageLocale = async ()=>{
            if (locale) {
                const messages = await (0, $b2A1s.getMessagesForLocale)(locale);
                setResolvedMessagesForLocale(messages);
            }
        };
        fetchMessageLocale();
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        locale: locale || 'en',
        defaultLocale: "en",
        messages: resolvedMessagesForLocale
    }, children);
};
module.exports["IntlProviderWithResolvedMessages"] = $fb8b4f9502ba72fc$export$f793de1293176fe6;

});

parcelRegister("b2A1s", function(module, exports) {
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ const $e1a3f1d7e16f1235$export$d0a3169680473b6c = async (locale)=>{
    locale = locale.replace('-', '_');
    try {
        const messages = await import(/* webpackChunkName: "@atlaskit-internal_feedback-collector/i18n-tranlations" */ `../i18n/${locale}`);
        return messages.default;
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        const messages = await import(/* webpackChunkName: "@atlaskit-internal_feedback-collector/i18n-tranlations" */ `../i18n/${parentLocale}`);
        return messages.default;
    } catch (e) {
    // ignore
    }
};
module.exports["getMessagesForLocale"] = $e1a3f1d7e16f1235$export$d0a3169680473b6c;

});

parcelRegister("7MfQo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $a2foB = parcelRequire("a2foB");


var $chu6R = parcelRequire("chu6R");


var $ixfCV = parcelRequire("ixfCV");


var $5r21M = parcelRequire("5r21M");


var $hTUp6 = parcelRequire("hTUp6");

const $cf0d91eb970c8b8a$var$FeedbackFlag = ({ description: description, title: title })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a2foB.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
            spacing: "spacious",
            color: "var(--ds-icon-success, #6A9A23)",
            label: "Success"
        }),
        id: "feedbackSent",
        description: description || formatMessage((0, $ixfCV.fg)('product-terminology-refresh') ? (0, $5r21M.messages).feedbackSuccessFlagDescriptionAppify : (0, $5r21M.messages).feedbackSuccessFlagDescription),
        title: title || formatMessage((0, $5r21M.messages).feedbackSuccessFlagTitle)
    });
};
const $cf0d91eb970c8b8a$var$FeedbackFlagWithIntl = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hTUp6.IntlProviderWithResolvedMessages), {
        locale: props.locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cf0d91eb970c8b8a$var$FeedbackFlag, props));
var $cf0d91eb970c8b8a$export$2e2bcd8739ae039 = $cf0d91eb970c8b8a$var$FeedbackFlagWithIntl;
module.exports["default"] = $cf0d91eb970c8b8a$export$2e2bcd8739ae039;

});

parcelRegister("3IZob", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $10e4e925e54c9160$var$DocChangeContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    subscribeDocChange: ()=>{},
    unsubscribeDocChange: ()=>{}
});
const $10e4e925e54c9160$var$DocChangeContextProvider = ({ children: children })=>{
    const subscriptions = (0, $cozmU.useRef)(new Set());
    const handleDocChange = (0, $cozmU.useCallback)((editorView)=>{
        subscriptions.current.forEach((callback)=>{
            callback(editorView);
        });
    }, []);
    const subscribeDocChange = (0, $cozmU.useCallback)((callback)=>{
        subscriptions.current.add(callback);
    }, []);
    const unsubscribeDocChange = (0, $cozmU.useCallback)((callback)=>{
        subscriptions.current.delete(callback);
    }, []);
    const value = (0, $cozmU.useMemo)(()=>({
            subscribeDocChange: subscribeDocChange,
            unsubscribeDocChange: unsubscribeDocChange
        }), [
        subscribeDocChange,
        unsubscribeDocChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($10e4e925e54c9160$var$DocChangeContext.Provider, {
        value: value
    }, children({
        handleDocChange: handleDocChange
    }));
};
const $10e4e925e54c9160$export$82deeccbd0ef6b25 = ()=>(0, $cozmU.useContext)($10e4e925e54c9160$var$DocChangeContext);
function $10e4e925e54c9160$export$9747c97496f7b432(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($10e4e925e54c9160$var$DocChangeContextProvider, null, ({ handleDocChange: handleDocChange })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                ...props,
                handleDocChange: handleDocChange
            }));
}
module.exports["useDocChangeContext"] = $10e4e925e54c9160$export$82deeccbd0ef6b25;
module.exports["withDocChangeContext"] = $10e4e925e54c9160$export$9747c97496f7b432;

});

parcelRegister("dE9mB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4oS56 = parcelRequire("4oS56");

const $e37f3b5c00f62365$export$1eb912906fa8f246 = ({ children: children, editorAPI: editorAPI })=>{
    const [item, setItem] = (0, $cozmU.useState)(null);
    const setNewItem = (0, $cozmU.useCallback)((newItem)=>{
        setItem((prevItem)=>{
            if (prevItem && prevItem.itemName !== newItem.itemName) prevItem.close();
            return newItem;
        });
    }, []);
    const removeItem = (0, $cozmU.useCallback)((itemName)=>{
        setItem((prevItem)=>prevItem?.itemName === itemName ? null : prevItem);
    }, []);
    const providerValue = (0, $cozmU.useMemo)(()=>({
            item: item,
            setItem: setNewItem,
            removeItem: removeItem,
            editorAPI: editorAPI
        }), [
        item,
        removeItem,
        setNewItem,
        editorAPI
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4oS56.EditorContextPanelContext).Provider, {
        value: providerValue
    }, children);
};
module.exports["EditorContextPanelContextProvider"] = $e37f3b5c00f62365$export$1eb912906fa8f246;

});

parcelRegister("4oS56", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $a02892cdeb8a3601$export$be6a93f320014444 = (0, $cozmU.createContext)({
    item: null,
    setItem: ()=>{},
    removeItem: ()=>{},
    editorAPI: undefined
});
module.exports["EditorContextPanelContext"] = $a02892cdeb8a3601$export$be6a93f320014444;

});

parcelRegister("2KWDO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $c1cJ9 = parcelRequire("c1cJ9");


var $aWwYt = parcelRequire("aWwYt");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $jvYFk = parcelRequire("jvYFk");


var $6KaG6 = parcelRequire("6KaG6");


var $4oS56 = parcelRequire("4oS56");


var $1vpkQ = parcelRequire("1vpkQ");


var $f28S3 = parcelRequire("f28S3");


var $dKo2t = parcelRequire("dKo2t");


var $laFNM = parcelRequire("laFNM");


var $jln20 = parcelRequire("jln20");

const $954086d867f34b7e$export$863fb2cf408343cd = /*#__PURE__*/ (0, $cozmU.memo)(()=>{
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panelWidth = (0, $aWwYt.usePanelWidth)();
    const panel = (0, $aWwYt.usePanel)();
    const { item: contextPanelItem, editorAPI: editorAPI } = (0, $cozmU.useContext)((0, $4oS56.EditorContextPanelContext));
    const { contentId: contentId, contentStatus: contentStatus } = (0, $laFNM.useApprovals)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const currentRightSidebarPanelId = rightSidebarContext.getCurrent()?.panelId;
    const isSidebarApprovalsPaneOpen = currentRightSidebarPanelId === (0, $1vpkQ.APPROVALS_PANE_ID);
    const isSidebarApprovalActivityPaneOpen = currentRightSidebarPanelId === (0, $f28S3.APPROVAL_ACTIVITY_PANE_ID);
    const approvalsPaneContextKey = (0, $1vpkQ.getApprovalsPaneContextKey)({
        contentId: contentId,
        contentStatus: contentStatus
    });
    const isApprovalActivityEnabledForContext = (0, $cozmU.useMemo)(()=>(0, $dKo2t.isApprovalActivityEnabled)(), []);
    const rightSidebarContextRef = (0, $cozmU.useRef)(rightSidebarContext);
    rightSidebarContextRef.current = rightSidebarContext;
    (0, $cozmU.useEffect)(()=>{
        (0, $1vpkQ.syncApprovalsPaneContextOwnership)({
            isApprovalsExperimentEnabled: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true),
            isSidebarApprovalsPaneOpen: isSidebarApprovalsPaneOpen,
            contextKey: approvalsPaneContextKey,
            closeApprovalsPane: ()=>rightSidebarContextRef.current.close((0, $1vpkQ.APPROVALS_PANE_ID))
        });
    }, [
        approvalsPaneContextKey,
        isSidebarApprovalsPaneOpen
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isApprovalActivityEnabledForContext) return;
        (0, $f28S3.syncApprovalActivityPaneContextOwnership)({
            isApprovalActivityEnabled: true,
            isSidebarApprovalActivityPaneOpen: isSidebarApprovalActivityPaneOpen,
            // Always-close sentinel: openApprovalActivityPaneForContext only ever
            // stores a non-empty "contentId:contentStatus" key, so an empty key can
            // never own the pane -> it is always closed on entering edit mode. Do
            // not "fix" this to pass the real content key.
            contextKey: '',
            closeApprovalActivityPane: ()=>rightSidebarContextRef.current.close((0, $f28S3.APPROVAL_ACTIVITY_PANE_ID))
        });
    }, [
        isApprovalActivityEnabledForContext,
        isSidebarApprovalActivityPaneOpen
    ]);
    // Previously, the pattern was to set state in EditorContextPanelContext in order to render components here.
    // Now, we render components directly in EditorContextPanelView to avoid bugs like https://hello.jira.atlassian.cloud/browse/DISCO-4183
    //
    // When the panel system flag is on, comments/details/jira panels render via navigation-system Panel in
    // PageLayout.tsx. Extension panels (ToC, etc.) always render here in ContextPanel.
    if (isObjectSidebarShown && !((0, $9wGTI.fg)('ads-panel-system-confluence-object-sidebar') && (0, $jvYFk.isMigratedToPanelSystem)(panel?.id))) {
        const isResizablePanel = !!panel?.isResizable;
        const isInjectedAIOrExtensionPanel = (panel?.id === 'proactive-ai-panel' || panel?.id.startsWith && panel?.id.startsWith('extensions-panel') || panel?.id === 'editor-element-insert-sidebar-panel') && (0, $9wGTI.fg)('platform_editor_ai_object_sidebar_injection');
        // Width the editor's `<ContextPanel>` should reserve. `panelWidth` is
        // encoded as `visibleWidth + CONTENT_RIGHT_PADDING` for resizable
        // panels (see `setVisiblePanelWidth`); subtract to get the visible
        // width. Clamp to `MIN_PANEL_WIDTH` so we never under-reserve.
        let editorContextPanelCustomWidth;
        if (isResizablePanel) editorContextPanelCustomWidth = Math.max(panelWidth - (0, $aWwYt.CONTENT_RIGHT_PADDING), (0, $aWwYt.MIN_PANEL_WIDTH));
        else if (isInjectedAIOrExtensionPanel) editorContextPanelCustomWidth = panelWidth || (0, $aWwYt.MIN_PANEL_WIDTH);
        else editorContextPanelCustomWidth = (0, $aWwYt.MIN_PANEL_WIDTH);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c1cJ9.ContextPanel), {
            visible: true,
            editorAPI: editorAPI ?? undefined,
            hasPadding: false,
            customWidth: editorContextPanelCustomWidth
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6KaG6.ObjectSidebarPanel), null));
    }
    let component;
    let hasPadding;
    let customWidth;
    if (contextPanelItem) {
        component = contextPanelItem.component;
        hasPadding = contextPanelItem.hasPadding;
        customWidth = contextPanelItem.customWidth;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c1cJ9.ContextPanel), {
        visible: !!contextPanelItem,
        editorAPI: editorAPI ?? undefined,
        hasPadding: hasPadding,
        customWidth: customWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, component));
});
module.exports["EditorContextPanelView"] = $954086d867f34b7e$export$863fb2cf408343cd;

});

parcelRegister("6KaG6", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ce38ba3becf24406$export$877a45ed8043e865 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "K9Gzp",
    name: "ObjectSidebarPanel",
    loader: async ()=>(await (parcelRequire("60aoN"))).ObjectSidebarPanelWrapper
});
module.exports["ObjectSidebarPanel"] = $ce38ba3becf24406$export$877a45ed8043e865;

});

parcelRegister("60aoN", function(module, exports) {

let $45eacf2cdcc0bdc0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $45eacf2cdcc0bdc0$var$load("he34V"),
    $45eacf2cdcc0bdc0$var$load("houtd"),
    $45eacf2cdcc0bdc0$var$load("hZ2FX"),
    $45eacf2cdcc0bdc0$var$load("g9l6t"),
    $45eacf2cdcc0bdc0$var$load("idSqX"),
    $45eacf2cdcc0bdc0$var$load("ghNAx"),
    $45eacf2cdcc0bdc0$var$load("hhss7"),
    $45eacf2cdcc0bdc0$var$load("gr9Xf")
]).then(()=>parcelRequire('iFpSu'));

});

parcelRegister("1vpkQ", function(module, exports) {

var $17wUi = parcelRequire("17wUi");

const $f378941f4cbfa1d0$export$64c46cf06596fc50 = 'approvals-pane';
const $f378941f4cbfa1d0$export$48f59b832d015459 = 400;
const $f378941f4cbfa1d0$export$e439c3cb9ea2e5e3 = 'confluence.approvals.pane.contextKey';
const $f378941f4cbfa1d0$export$3a9fc041f15ae7db = 'confluence.approvals.pane.initialApprovers';
const $f378941f4cbfa1d0$export$bbf9a6919720fa3a = 'CURRENT';
const $f378941f4cbfa1d0$export$74a7304e4ecb72ad = 'DRAFT';
const $f378941f4cbfa1d0$export$effd283748674146 = ({ contentId: contentId, contentStatus: contentStatus })=>`${contentId}:${contentStatus}`;
/**
 * In-memory cache of the approvals pane context key.
 *
 * When the `confluence_browser_storage_controls` feature gate is enabled,
 * `sessionStorageManager.setItem` delegates to `AtlBrowserStorageSession.setItem`
 * which is **async** (it awaits IndexedDB consent checks before writing to
 * `sessionStorage`). This means a synchronous read immediately after a write
 * will return `null` — the value hasn't been persisted yet.
 *
 * The ownership helpers (`shouldRenderApprovalsPaneForContext`,
 * `syncApprovalsPaneContextOwnership`) run synchronously during React renders
 * and effects, so they need a synchronous source of truth. This in-memory
 * variable serves that purpose. Session storage is still written for
 * durability across page reloads, but in-session reads use this cache.
 */ let $f378941f4cbfa1d0$var$inMemoryContextKey = null;
let $f378941f4cbfa1d0$var$inMemoryInitialApprovers = null;
const $f378941f4cbfa1d0$var$setSessionStorageItem = (key, value)=>{
    (0, $17wUi.confluenceSessionStorageInstance)?.setItem?.(key, value);
};
const $f378941f4cbfa1d0$var$removeSessionStorageItem = (key)=>{
    (0, $17wUi.confluenceSessionStorageInstance)?.removeItem?.(key);
};
const $f378941f4cbfa1d0$export$7df64ccaccec4e24 = ()=>$f378941f4cbfa1d0$var$inMemoryContextKey;
const $f378941f4cbfa1d0$export$d4f550c493c9338 = (contextKey)=>{
    $f378941f4cbfa1d0$var$inMemoryContextKey = contextKey;
    $f378941f4cbfa1d0$var$setSessionStorageItem($f378941f4cbfa1d0$export$e439c3cb9ea2e5e3, contextKey);
};
const $f378941f4cbfa1d0$export$fbd6783260490074 = ()=>{
    $f378941f4cbfa1d0$var$inMemoryContextKey = null;
    $f378941f4cbfa1d0$var$removeSessionStorageItem($f378941f4cbfa1d0$export$e439c3cb9ea2e5e3);
};
const $f378941f4cbfa1d0$export$6c66b77d99c1694e = (initialApprovers)=>{
    $f378941f4cbfa1d0$var$inMemoryInitialApprovers = initialApprovers;
    $f378941f4cbfa1d0$var$setSessionStorageItem($f378941f4cbfa1d0$export$3a9fc041f15ae7db, JSON.stringify(initialApprovers));
};
const $f378941f4cbfa1d0$export$b726f35a92bad435 = ()=>{
    $f378941f4cbfa1d0$var$inMemoryInitialApprovers = null;
    $f378941f4cbfa1d0$var$removeSessionStorageItem($f378941f4cbfa1d0$export$3a9fc041f15ae7db);
};
const $f378941f4cbfa1d0$export$e9025dd3a93a7d3c = ()=>{
    const initialApprovers = $f378941f4cbfa1d0$var$inMemoryInitialApprovers ?? undefined;
    $f378941f4cbfa1d0$export$b726f35a92bad435();
    return initialApprovers;
};
const $f378941f4cbfa1d0$export$823b1a6d7b43bfe4 = ({ contextKey: contextKey, storedContextKey: storedContextKey })=>storedContextKey === contextKey;
const $f378941f4cbfa1d0$export$41945f41a6acb22 = ({ isApprovalsExperimentEnabled: isApprovalsExperimentEnabled, isSidebarApprovalsPaneOpen: isSidebarApprovalsPaneOpen, contextKey: contextKey })=>{
    if (!isApprovalsExperimentEnabled || !isSidebarApprovalsPaneOpen) return false;
    return $f378941f4cbfa1d0$export$823b1a6d7b43bfe4({
        contextKey: contextKey,
        storedContextKey: $f378941f4cbfa1d0$export$7df64ccaccec4e24()
    });
};
const $f378941f4cbfa1d0$export$f29b4d98dbe0b579 = ({ isApprovalsExperimentEnabled: isApprovalsExperimentEnabled, isSidebarApprovalsPaneOpen: isSidebarApprovalsPaneOpen, contextKey: contextKey, closeApprovalsPane: closeApprovalsPane })=>{
    if (!isApprovalsExperimentEnabled) return;
    if (!isSidebarApprovalsPaneOpen) {
        $f378941f4cbfa1d0$export$fbd6783260490074();
        return;
    }
    const storedContextKey = $f378941f4cbfa1d0$export$7df64ccaccec4e24();
    if ($f378941f4cbfa1d0$export$823b1a6d7b43bfe4({
        contextKey: contextKey,
        storedContextKey: storedContextKey
    })) return;
    closeApprovalsPane();
    $f378941f4cbfa1d0$export$fbd6783260490074();
};
const $f378941f4cbfa1d0$export$c922f15693c980c9 = ({ contentId: contentId, contentStatus: contentStatus, initialApprovers: initialApprovers, rightSidebarContext: rightSidebarContext })=>{
    $f378941f4cbfa1d0$export$d4f550c493c9338($f378941f4cbfa1d0$export$effd283748674146({
        contentId: contentId,
        contentStatus: contentStatus
    }));
    if (initialApprovers) $f378941f4cbfa1d0$export$6c66b77d99c1694e(initialApprovers);
    else $f378941f4cbfa1d0$export$b726f35a92bad435();
    rightSidebarContext.open($f378941f4cbfa1d0$export$64c46cf06596fc50, $f378941f4cbfa1d0$export$48f59b832d015459);
};
module.exports["APPROVALS_PANE_ID"] = $f378941f4cbfa1d0$export$64c46cf06596fc50;
module.exports["APPROVALS_PANE_CURRENT_CONTENT_STATUS"] = $f378941f4cbfa1d0$export$bbf9a6919720fa3a;
module.exports["APPROVALS_PANE_DRAFT_CONTENT_STATUS"] = $f378941f4cbfa1d0$export$74a7304e4ecb72ad;
module.exports["getApprovalsPaneContextKey"] = $f378941f4cbfa1d0$export$effd283748674146;
module.exports["getStoredApprovalsPaneContextKey"] = $f378941f4cbfa1d0$export$7df64ccaccec4e24;
module.exports["clearStoredApprovalsPaneContextKey"] = $f378941f4cbfa1d0$export$fbd6783260490074;
module.exports["consumeApprovalsPaneInitialApprovers"] = $f378941f4cbfa1d0$export$e9025dd3a93a7d3c;
module.exports["syncApprovalsPaneContextOwnership"] = $f378941f4cbfa1d0$export$f29b4d98dbe0b579;
module.exports["openApprovalsPaneForContext"] = $f378941f4cbfa1d0$export$c922f15693c980c9;

});

parcelRegister("f28S3", function(module, exports) {

var $17wUi = parcelRequire("17wUi");

const $5d35b4c8a88cf3c5$export$1cf966ab51733f40 = 'approval-activity-pane';
const $5d35b4c8a88cf3c5$export$312e57b102de2eda = 400;
const $5d35b4c8a88cf3c5$export$d9243646277c1b68 = 'confluence.approvals.activityPane.contextKey';
const $5d35b4c8a88cf3c5$export$ebd91df43704fb21 = ({ contentId: contentId, contentStatus: contentStatus })=>`${contentId}:${contentStatus}`;
// Synchronous source of truth for the ownership helpers: session storage writes
// can be async (under `confluence_browser_storage_controls`), so an immediate
// read can miss. Storage is still written for durability across reloads.
let $5d35b4c8a88cf3c5$var$inMemoryContextKey = null;
const $5d35b4c8a88cf3c5$export$139dba4020acd3ec = ()=>$5d35b4c8a88cf3c5$var$inMemoryContextKey;
const $5d35b4c8a88cf3c5$export$515df3935cc07f4d = (contextKey)=>{
    $5d35b4c8a88cf3c5$var$inMemoryContextKey = contextKey;
    (0, $17wUi.confluenceSessionStorageInstance).setItem($5d35b4c8a88cf3c5$export$d9243646277c1b68, contextKey);
};
const $5d35b4c8a88cf3c5$export$32575512fde29f65 = ()=>{
    $5d35b4c8a88cf3c5$var$inMemoryContextKey = null;
    (0, $17wUi.confluenceSessionStorageInstance).removeItem($5d35b4c8a88cf3c5$export$d9243646277c1b68);
};
const $5d35b4c8a88cf3c5$export$e0b014cdef5c4ad0 = ({ contextKey: contextKey, storedContextKey: storedContextKey })=>storedContextKey === contextKey;
const $5d35b4c8a88cf3c5$export$8160aab3b9f65497 = ({ isApprovalActivityEnabled: isApprovalActivityEnabled, isSidebarApprovalActivityPaneOpen: isSidebarApprovalActivityPaneOpen, contextKey: contextKey })=>{
    if (!isApprovalActivityEnabled || !isSidebarApprovalActivityPaneOpen) return false;
    return $5d35b4c8a88cf3c5$export$e0b014cdef5c4ad0({
        contextKey: contextKey,
        storedContextKey: $5d35b4c8a88cf3c5$export$139dba4020acd3ec()
    });
};
const $5d35b4c8a88cf3c5$export$cbee9c4602f01758 = ({ isApprovalActivityEnabled: isApprovalActivityEnabled, isSidebarApprovalActivityPaneOpen: isSidebarApprovalActivityPaneOpen, contextKey: contextKey, closeApprovalActivityPane: closeApprovalActivityPane })=>{
    // When disabled while the pane is still open, close it so it can't linger
    // with stale content; always clear ownership so a re-enable can't match it.
    if (!isApprovalActivityEnabled) {
        if (isSidebarApprovalActivityPaneOpen) closeApprovalActivityPane();
        $5d35b4c8a88cf3c5$export$32575512fde29f65();
        return;
    }
    if (!isSidebarApprovalActivityPaneOpen) {
        $5d35b4c8a88cf3c5$export$32575512fde29f65();
        return;
    }
    const storedContextKey = $5d35b4c8a88cf3c5$export$139dba4020acd3ec();
    if ($5d35b4c8a88cf3c5$export$e0b014cdef5c4ad0({
        contextKey: contextKey,
        storedContextKey: storedContextKey
    })) return;
    closeApprovalActivityPane();
    $5d35b4c8a88cf3c5$export$32575512fde29f65();
};
const $5d35b4c8a88cf3c5$export$88863c5159ce1de9 = ({ contentId: contentId, contentStatus: contentStatus, rightSidebarContext: rightSidebarContext })=>{
    // Open first so a failure can't leave an orphaned key that makes the
    // ownership helpers think a pane is open when it never actually opened.
    rightSidebarContext.open($5d35b4c8a88cf3c5$export$1cf966ab51733f40, $5d35b4c8a88cf3c5$export$312e57b102de2eda);
    $5d35b4c8a88cf3c5$export$515df3935cc07f4d($5d35b4c8a88cf3c5$export$ebd91df43704fb21({
        contentId: contentId,
        contentStatus: contentStatus
    }));
};
module.exports["APPROVAL_ACTIVITY_PANE_ID"] = $5d35b4c8a88cf3c5$export$1cf966ab51733f40;
module.exports["getApprovalActivityPaneContextKey"] = $5d35b4c8a88cf3c5$export$ebd91df43704fb21;
module.exports["getStoredApprovalActivityPaneContextKey"] = $5d35b4c8a88cf3c5$export$139dba4020acd3ec;
module.exports["clearStoredApprovalActivityPaneContextKey"] = $5d35b4c8a88cf3c5$export$32575512fde29f65;
module.exports["shouldRenderApprovalActivityPaneForContext"] = $5d35b4c8a88cf3c5$export$8160aab3b9f65497;
module.exports["syncApprovalActivityPaneContextOwnership"] = $5d35b4c8a88cf3c5$export$cbee9c4602f01758;
module.exports["openApprovalActivityPaneForContext"] = $5d35b4c8a88cf3c5$export$88863c5159ce1de9;

});

parcelRegister("dKo2t", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");

const $2ddf5200ab3dbe55$export$cfe0477428ce7edd = ()=>{
    if (!(0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) return false;
    // The dynamic config exposes its boolean under `value` (not `isEnabled`).
    const [activityLogConfig] = (0, $6mKj3.UNSAFE_noExposureExp)('confluence_approvals_activity_log');
    return activityLogConfig.get('value', false) === true;
};
module.exports["isApprovalActivityEnabled"] = $2ddf5200ab3dbe55$export$cfe0477428ce7edd;

});

parcelRegister("laFNM", function(module, exports) {

var $lKLmX = parcelRequire("lKLmX");


var $fenUZ = parcelRequire("fenUZ");


var $zALBk = parcelRequire("zALBk");


var $2WqwD = parcelRequire("2WqwD");


var $chVEh = parcelRequire("chVEh");


var $lygOH = parcelRequire("lygOH");


var $8V29N = parcelRequire("8V29N");


var $l5Ac1 = parcelRequire("l5Ac1");


var $dzmR0 = parcelRequire("dzmR0");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $2wo33 = parcelRequire("2wo33");


var $lfBMY = parcelRequire("lfBMY");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $jln20 = parcelRequire("jln20");


var $i9VoI = parcelRequire("i9VoI");


var $3Xs1I = parcelRequire("3Xs1I");

var $c0urc = parcelRequire("c0urc");


var $1vpkQ = parcelRequire("1vpkQ");


var $lKfPX = parcelRequire("lKfPX");


var $kWNKJ = parcelRequire("kWNKJ");


var $kLSdN = parcelRequire("kLSdN");

const $e450e61f37c9899d$var$DRAFT_CONTENT_STATUS = 'DRAFT';
const $e450e61f37c9899d$var$CURRENT_CONTENT_STATUS = 'CURRENT';
const $e450e61f37c9899d$export$eac3cbee8fb231fd = ({ principalType: principalType, principalId: principalId })=>`${principalType}:${principalId}`;
// errorType values returned by confluence_createContentApproval that represent
// known, expected failure conditions. These are marked as handled so they do not
// surface as unexpected errors in monitoring.
const $e450e61f37c9899d$var$EXPECTED_CREATE_APPROVAL_ERROR_TYPES = new Set([
    'BAD_REQUEST',
    'ACCESS_DENIED',
    'NOT_FOUND'
]);
/**
 * Shared error classification for approval mutation responses.
 * Classifies the error as handled (expected) or reports to monitoring (unexpected),
 * then throws so the caller can surface it to the UI.
 */ function $e450e61f37c9899d$var$handleApprovalMutationError(errors, fallbackMessage) {
    const firstError = errors[0];
    const errorMessage = firstError?.message || fallbackMessage;
    const errorType = firstError?.extensions?.errorType;
    const error = Object.assign(new Error(errorMessage), {
        extensions: firstError?.extensions
    });
    if (errorType && $e450e61f37c9899d$var$EXPECTED_CREATE_APPROVAL_ERROR_TYPES.has(errorType)) (0, $7Sm4c.markErrorAsHandled)(error);
    else (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    });
    throw error;
}
// GraphQL Mutations - AGG Ready
// Mutation: Create Workflow Application
const $e450e61f37c9899d$var$createWorkflowApplicationMutation = (0, $dzmR0.default);
// Mutation: Create Workflow Review
const $e450e61f37c9899d$var$createWorkflowReviewMutation = (0, $l5Ac1.default);
// Mutation: Update Workflow Application
const $e450e61f37c9899d$var$updateWorkflowApplicationMutation = (0, $8V29N.default);
// Mutation: Update Reviewer Decision (Approve/Deny)
const $e450e61f37c9899d$var$updateReviewerDecisionMutation = (0, $lygOH.default);
// Mutation: Update Workflow Review (add/remove reviewers, update status)
const $e450e61f37c9899d$var$updateWorkflowReviewMutation = (0, $chVEh.default);
// Mutation: Resolve Approval Agent
const $e450e61f37c9899d$var$resolveApprovalAgentMutation = (0, $2WqwD.default);
// Mutation: Create Workflow Application With Review (combined)
const $e450e61f37c9899d$var$createWorkflowApplicationWithReviewMutation = (0, $zALBk.default);
// Mutation: Remove Content Approval Reviewer
const $e450e61f37c9899d$var$removeContentApprovalReviewerMutation = (0, $fenUZ.default);
// GraphQL Query - Combined: active workflow application + available workflow statuses
// Single query for preloading and runtime; fetches both confluence_getActiveWorkflowApplication
// and confluence_contentApprovalStatuses (transitionType: null returns all statuses)
const $e450e61f37c9899d$var$approvalsDataQuery = (0, $lKLmX.default);
// Default context values
const $e450e61f37c9899d$var$defaultContextValue = {
    approvalRequest: null,
    approvalRequestLoading: false,
    availableWorkflowStatuses: [],
    contentId: '',
    contentStatus: $e450e61f37c9899d$var$CURRENT_CONTENT_STATUS,
    isCurrentUserRequestor: false,
    isCurrentUserApprover: false,
    currentUserApprover: null,
    approvalProgress: {
        current: 0,
        total: 0
    },
    hasEditPermission: false,
    isDraftLockedForEditing: false,
    otherModeReviewStatus: null,
    isContentApprovalsEnabled: false,
    disallowFirstPublish: false,
    requiredApprovers: [],
    isRequiredApproversActive: false,
    isPendingReviewBlockedByRequiredApproversChange: false,
    pendingLiveDocApprovalContentId: null
};
const $e450e61f37c9899d$var$defaultDispatchValue = {
    createWorkflowApplication: async ()=>{
        throw new Error('createWorkflowApplication not implemented');
    },
    cancelWorkflowApplication: async ()=>{
        throw new Error('cancelWorkflowApplication not implemented');
    },
    clearApprovalRequestOptimistically: ()=>{},
    startApproval: async ()=>{
        throw new Error('startApproval not implemented');
    },
    updateApprovalStatus: async ()=>{
        throw new Error('updateApprovalStatus not implemented');
    },
    addApprover: async ()=>{
        throw new Error('addApprover not implemented');
    },
    removeApprover: async ()=>{
        throw new Error('removeApprover not implemented');
    },
    cancelApproval: async ()=>{
        throw new Error('cancelApproval not implemented');
    },
    resolveApprovalAgent: async ()=>'',
    startApprovalCombined: async ()=>undefined,
    requestLiveDocApprovalConversion: ()=>{},
    clearLiveDocApprovalConversion: ()=>{}
};
const $e450e61f37c9899d$export$eb47cecb126081cc = /*#__PURE__*/ (0, $cozmU.createContext)($e450e61f37c9899d$var$defaultContextValue);
$e450e61f37c9899d$export$eb47cecb126081cc.displayName = 'ApprovalsContext';
const $e450e61f37c9899d$export$a8239efa8a51a660 = /*#__PURE__*/ (0, $cozmU.createContext)($e450e61f37c9899d$var$defaultDispatchValue);
$e450e61f37c9899d$export$a8239efa8a51a660.displayName = 'ApprovalsDispatchContext';
/**
 * DefaultApprovalsProvider - Returns default/empty approval context
 */ const $e450e61f37c9899d$var$DefaultApprovalsProvider = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e450e61f37c9899d$export$eb47cecb126081cc.Provider, {
        value: $e450e61f37c9899d$var$defaultContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e450e61f37c9899d$export$a8239efa8a51a660.Provider, {
        value: $e450e61f37c9899d$var$defaultDispatchValue
    }, children));
const $e450e61f37c9899d$export$c720d3c28af710a = ({ children: children, contentId: contentIdProp })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const [{ spaceKey: spaceKey }] = (0, $ep3mz.usePageState)();
    const contentId = contentIdProp || pageContentId;
    if (!cloudId || !contentId || !spaceKey || !(0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e450e61f37c9899d$var$DefaultApprovalsProvider, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e450e61f37c9899d$var$ApprovalsProviderComponent, {
        contentId: contentId,
        spaceKey: spaceKey
    }, children);
};
/**
 * This provider:
 * 1. Fetches approval data using GraphQL query
 * 2. Exposes data through read context (ApprovalsContext)
 * 3. Exposes mutations through write context (ApprovalsDispatchContext)
 * 4. Handles cache updates and refetching after mutations
 */ const $e450e61f37c9899d$var$ApprovalsProviderComponent = ({ children: children, contentId: contentId, spaceKey: spaceKey })=>{
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const [{ contentType: contentType }] = (0, $ep3mz.usePageState)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const contentStatus = pageMode === (0, $cD1qu.PageMode).EDIT ? $e450e61f37c9899d$var$DRAFT_CONTENT_STATUS : $e450e61f37c9899d$var$CURRENT_CONTENT_STATUS;
    // The content status that is opposite of the current status
    const otherContentStatus = contentStatus === $e450e61f37c9899d$var$DRAFT_CONTENT_STATUS ? $e450e61f37c9899d$var$CURRENT_CONTENT_STATUS : $e450e61f37c9899d$var$DRAFT_CONTENT_STATUS;
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { close: closeRightSidebar, open: openRightSidebar } = rightSidebarContext;
    const [isOptimisticallyCancelled, setIsOptimisticallyCancelled] = (0, $cozmU.useState)(false);
    /**
   * Live-doc → page approval conversion intent.
   * We use this to track the contentId of the live-doc that the user wants to convert to a page.
   */ const [pendingLiveDocApprovalContentId, setPendingLiveDocApprovalContentId] = (0, $cozmU.useState)(null);
    const [optimisticWorkflowStatus, setOptimisticWorkflowStatus] = (0, $cozmU.useState)(null);
    // Tracks whether a cancelWorkflowApplication mutation is currently in flight.
    // Used to prevent the workflowApplicationChanged subscription from resetting
    // isOptimisticallyCancelled before the cancel mutation has completed on the backend,
    // which would cause a flash of stale workflow status data.
    const isCancellationInFlightRef = (0, $cozmU.useRef)(false);
    // Track whether we've received data for the current content/mode pair. This ensures
    // approvalRequestLoading stays true from the moment contentId or contentStatus changes until
    // fresh data has actually arrived — even if useQueryInteropRelay's loading flag flips true→false
    // within a single React batch (e.g. when the Relay store has cached normalized data).
    const currentContentCacheKey = `${contentId}:${contentStatus}`;
    const lastSettledContentCacheKeyRef = (0, $cozmU.useRef)(null);
    const shouldForceNetworkFetch = lastSettledContentCacheKeyRef.current !== currentContentCacheKey;
    // Reset optimistic state when navigating to a different page or switching content status (View ↔ Edit).
    (0, $cozmU.useEffect)(()=>{
        setIsOptimisticallyCancelled(false);
        setOptimisticWorkflowStatus(null);
    }, [
        contentId,
        contentStatus
    ]);
    const canEdit = (0, $2wo33.useCanPerformContentOperation)({
        contentId: contentId,
        operation: (0, $lfBMY.OperationTypes).UPDATE,
        status: contentStatus === $e450e61f37c9899d$var$CURRENT_CONTENT_STATUS ? (0, $cD1qu.CURRENT_STATUS) : (0, $cD1qu.DRAFT_STATUS)
    });
    const hasEditPermission = canEdit ?? false;
    // Query for available workflow statuses and active workflow application
    const { data: approvalsData, loading: approvalsLoading, refetch: refetchApprovalsData } = (0, $jMyy4.useQueryInterop)($e450e61f37c9899d$var$approvalsDataQuery, {
        variables: {
            cloudId: cloudId,
            contentId: contentId,
            contentStatus: contentStatus,
            transitionType: null,
            otherContentStatus: // null returns all statuses
            otherContentStatus,
            spaceKey: spaceKey,
            includeApprovalsBetaFeatures: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)
        },
        ...shouldForceNetworkFetch ? {
            fetchPolicy: 'network-only'
        } : {},
        skip: !cloudId || !contentId || !(0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true),
        __callerPackage__: "approvals"
    });
    const refetchVariables = (0, $cozmU.useMemo)(()=>({
            cloudId: cloudId,
            contentId: contentId,
            contentStatus: contentStatus,
            transitionType: null,
            otherContentStatus: otherContentStatus,
            spaceKey: spaceKey,
            includeApprovalsBetaFeatures: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true),
            cacheBuster: ''
        }), [
        cloudId,
        contentId,
        contentStatus,
        otherContentStatus,
        spaceKey
    ]);
    // Detect when approvalsData belongs to a previously-viewed page. useQueryInteropRelay keeps old
    // data in state while a refetch with new variables is in flight, so without this guard the UI
    // would render Page A's fully-interactive workflow/review data while viewing Page B.
    const isDataStale = (0, $cozmU.useMemo)(()=>{
        const responseContentId = approvalsData?.confluence_getActiveWorkflowApplication?.workflowApplication?.contentId;
        // If the response contains a workflow application for a different page, data is stale.
        // When responseContentId is null/undefined/empty (no active workflow or falsy defaults),
        // there is nothing stale to hide.
        return !!responseContentId && responseContentId !== contentId;
    }, [
        approvalsData,
        contentId
    ]);
    if (!approvalsLoading && !isDataStale) lastSettledContentCacheKeyRef.current = currentContentCacheKey;
    const isAwaitingFreshData = lastSettledContentCacheKeyRef.current !== currentContentCacheKey;
    const availableWorkflowStatuses = (0, $cozmU.useMemo)(()=>{
        if (isDataStale || !approvalsData?.confluence_contentApprovalStatuses) return [];
        return approvalsData.confluence_contentApprovalStatuses.reduce((acc, status)=>{
            if (status === null || status === undefined) return acc;
            acc.push({
                id: status.id || '',
                name: status.displayProperties?.name || '',
                allowsReviews: status.allowsReviews || false,
                color: status.displayProperties?.color || undefined
            });
            return acc;
        }, []);
    }, [
        isDataStale,
        approvalsData
    ]);
    const contentVersion = (0, $cozmU.useMemo)(()=>{
        const fromWorkflow = approvalsData?.confluence_getActiveWorkflowApplication?.workflowApplication?.contentVersion;
        if (fromWorkflow !== undefined && fromWorkflow !== null) return fromWorkflow;
        return approvalsData?.content?.nodes?.[0]?.version?.number ?? 0;
    }, [
        approvalsData
    ]);
    const isContentApprovalsEnabled = (0, $cozmU.useMemo)(()=>{
        const isSpaceApprovalsEnabled = Boolean(approvalsData?.space?.spaceTypeSettings?.enabledFeatures?.isContentApprovalsEnabled);
        const isApprovalsSiteEnabled = (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) ? Boolean(approvalsData?.confluence_contentApprovalsSiteSettings?.enabled) : true;
        return isSpaceApprovalsEnabled && isApprovalsSiteEnabled;
    }, [
        approvalsData
    ]);
    const disallowFirstPublish = (0, $cozmU.useMemo)(()=>approvalsData?.confluence_contentApprovalsSpaceSettingConfig?.config?.disallowFirstPublish ?? false, [
        approvalsData
    ]);
    const requiredApprovers = (0, $cozmU.useMemo)(()=>{
        if (!(0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) return [];
        const settingsConfig = approvalsData?.confluence_contentApprovalsSpaceSettingConfig;
        const enforcedConfig = settingsConfig?.config?.enforcedApprovalReviewerConfig;
        if (settingsConfig?.success !== true || !enforcedConfig) return [];
        const seenPrincipalKeys = new Set();
        return (enforcedConfig.reviewers ?? []).reduce((acc, reviewer)=>{
            if (reviewer?.principalType !== 'USER' || !reviewer.principalId) return acc;
            const principalKey = $e450e61f37c9899d$export$eac3cbee8fb231fd({
                principalType: reviewer.principalType,
                principalId: reviewer.principalId
            });
            if (seenPrincipalKeys.has(principalKey)) return acc;
            seenPrincipalKeys.add(principalKey);
            acc.push({
                principalId: reviewer.principalId,
                principalType: reviewer.principalType,
                name: reviewer.user?.displayName ?? '',
                avatarUrl: reviewer.user?.photos?.find((p)=>p?.isPrimary)?.value || undefined,
                isActive: reviewer.user?.isActive ?? undefined
            });
            return acc;
        }, []);
    }, [
        approvalsData?.confluence_contentApprovalsSpaceSettingConfig
    ]);
    const isRequiredApproversActive = (0, $cozmU.useMemo)(()=>{
        if (!(0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) return false;
        const settingsConfig = approvalsData?.confluence_contentApprovalsSpaceSettingConfig;
        const enforcedConfig = settingsConfig?.config?.enforcedApprovalReviewerConfig;
        return settingsConfig?.success === true && enforcedConfig?.isEnabled === true && requiredApprovers.length > 0;
    }, [
        approvalsData?.confluence_contentApprovalsSpaceSettingConfig,
        requiredApprovers
    ]);
    /**
   * Live-doc → page approval auto-open effect.
   *
   * After a successful convert-to-page redirect, the new page mounts this provider with the
   * intent still set in sessionStorage. When we land on the CURRENT (published) content in
   * VIEW mode and the intent matches this contentId, atomically consume the persisted intent,
   * clear the React state, and open the approvals pane.
   */ (0, $cozmU.useEffect)(()=>{
        if (!(0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) return;
        if (contentStatus !== $e450e61f37c9899d$var$CURRENT_CONTENT_STATUS) return;
        if (pageMode !== (0, $cD1qu.PageMode).VIEW) return;
        if (approvalsLoading) return; // wait for data before consuming
        const intent = (0, $kLSdN.consumeLiveDocApprovalRedirectIntent)();
        if (!intent || intent.contentId !== contentId) return;
        setPendingLiveDocApprovalContentId(null);
        if (isContentApprovalsEnabled) // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        (0, $1vpkQ.openApprovalsPaneForContext)({
            contentId: contentId,
            contentStatus: $e450e61f37c9899d$var$CURRENT_CONTENT_STATUS,
            rightSidebarContext: {
                open: openRightSidebar
            }
        });
    }, [
        contentId,
        openRightSidebar,
        contentStatus,
        pageMode,
        approvalsLoading,
        isContentApprovalsEnabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (optimisticWorkflowStatus && approvalsData?.confluence_getActiveWorkflowApplication?.workflowApplication?.workflowStatusId === optimisticWorkflowStatus.id) // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        setOptimisticWorkflowStatus(null);
    }, [
        approvalsData,
        optimisticWorkflowStatus
    ]);
    const approvalRequest = (0, $cozmU.useMemo)(()=>{
        if (isDataStale) return null;
        if (isOptimisticallyCancelled) return null;
        const application = approvalsData?.confluence_getActiveWorkflowApplication?.workflowApplication;
        if (optimisticWorkflowStatus && application?.workflowStatusId !== optimisticWorkflowStatus.id) return {
            application: {
                contentId: contentId,
                contentVersion: contentVersion,
                contentStatus: contentStatus,
                applicationId: '',
                isActive: true,
                workflowStatusId: optimisticWorkflowStatus.id
            },
            review: null
        };
        const review = approvalsData?.confluence_getActiveWorkflowApplication?.workflowReviewWithDecisions;
        if (!application) return null;
        return {
            application: {
                contentId: application.contentId || contentId,
                contentVersion: application.contentVersion || 1,
                contentStatus: application.contentStatus || '',
                // NOTE: This indicates draft (DRAFT) or published (CURRENT)
                applicationId: application.id || '',
                isActive: application.isActive || false,
                workflowStatusId: application.workflowStatusId || '',
                ...application.modifier && {
                    applicationLastModifiedBy: {
                        displayName: application.modifier.displayName || '',
                        avatarUrl: application.modifier.photos?.find((p)=>p?.isPrimary)?.value || undefined,
                        userId: application.modifier.id || ''
                    }
                },
                applicationLastModifiedDate: application.lastModificationDate?.value || ''
            },
            // There can be an application without a review; return review: null in that case
            review: review !== null && review !== undefined ? {
                reviewId: review.id || '',
                reviewCreationDate: review.creationDate?.value || '',
                dueDate: review.dueDate?.value ? (0, $kWNKJ.extractDateOnlyFromUtcEpochMillis)(review.dueDate.value) ?? undefined : undefined,
                requestorId: review.creatorAaid || '',
                requestorName: review.creator?.displayName || '',
                requestorAvatarUrl: review.creator?.photos?.find((p)=>p?.isPrimary)?.value || '',
                reviewLastModifiedDate: review.reviewLastModified?.value || '',
                // milliseconds since epoch
                reviewComment: review.reviewComment || undefined,
                reviewStatus: review.reviewStatus || 'PENDING',
                approvers: review.reviewerDecisions?.reduce((acc, reviewerDecision)=>{
                    if (reviewerDecision == null) return acc;
                    acc.push({
                        decisionId: reviewerDecision.decisionId || '',
                        reviewerId: reviewerDecision.reviewerId || '',
                        isRequired: reviewerDecision.required ?? true,
                        principalId: reviewerDecision.principalId || '',
                        principalType: reviewerDecision.principalType || 'USER',
                        name: reviewerDecision.user?.displayName || '',
                        avatarUrl: reviewerDecision.user?.photos?.find((p)=>p?.isPrimary)?.value || '',
                        status: reviewerDecision.reviewerDecisionStatus || 'PENDING_REVIEW',
                        decisionComment: reviewerDecision.comment || '',
                        responseLastModifiedDate: reviewerDecision?.lastModifiedDate?.value || ''
                    });
                    return acc;
                }, [])
            } : null
        };
    }, [
        isDataStale,
        isOptimisticallyCancelled,
        optimisticWorkflowStatus,
        contentVersion,
        contentStatus,
        approvalsData?.confluence_getActiveWorkflowApplication?.workflowApplication,
        approvalsData?.confluence_getActiveWorkflowApplication?.workflowReviewWithDecisions,
        contentId
    ]);
    const isCurrentUserRequestor = (0, $cozmU.useMemo)(()=>{
        return approvalRequest?.review?.requestorId === userId;
    }, [
        approvalRequest,
        userId
    ]);
    const currentUserApprover = (0, $cozmU.useMemo)(()=>{
        return approvalRequest?.review?.approvers?.find((approver)=>approver.principalId === userId) || null;
    }, [
        approvalRequest,
        userId
    ]);
    const onWorkflowApplicationChanged = (0, $cozmU.useCallback)((_eventName, response)=>{
        const eventData = response?.workflowApplicationChanged;
        const eventContentStatus = eventData?.contentStatus;
        if (eventContentStatus !== contentStatus) return;
        // Always refetch to pick up the latest data from the server.
        refetchApprovalsData(refetchVariables);
        // Reset the optimistic cancellation state when a live update arrives from another user.
        // Without this, if User 1 clears the review status (setting isOptimisticallyCancelled=true)
        // and User 2 then adds the review status back, User 1 would never see the new review
        // because isOptimisticallyCancelled would still be true, causing approvalRequest to
        // remain null even after the refetch returns fresh data with the new review.
        //
        // However, skip resetting when a cancellation mutation is in flight — the subscription
        // event may arrive before the mutation completes, meaning the refetch would return stale
        // data that still shows the old workflow status. This causes a flash where the old status
        // briefly reappears before the cancel mutation settles and the correct state is shown.
        // The cancel mutation's own completion path handles clearing isCancellationInFlightRef
        // and triggering a final refetch with up-to-date data.
        if (!isCancellationInFlightRef.current) setIsOptimisticallyCancelled(false);
    }, [
        refetchApprovalsData,
        refetchVariables,
        contentStatus
    ]);
    // Subscribe to real-time approval status changes (from backend workflowApplicationChanged events)
    (0, $i9VoI.useSubscriptionEvent)({
        subscriberId: 'ApprovalsProviderWorkflowApplicationChanged',
        delta: 'workflowApplicationChanged',
        contentId: contentId,
        contentType: contentType || 'page',
        skip: !(0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true),
        onDataReceived: onWorkflowApplicationChanged
    });
    // When the other mode's workflow changes (e.g. a DRAFT review is started while viewing the
    // published page), refetch so that otherModeReviewStatus reflects the latest state and any
    // banners or warnings dependent on it update accordingly.
    const onOtherModeWorkflowApplicationChanged = (0, $cozmU.useCallback)((_eventName, response)=>{
        const eventData = response?.workflowApplicationChanged;
        const eventContentStatus = eventData?.contentStatus;
        if (eventContentStatus !== otherContentStatus) return;
        refetchApprovalsData(refetchVariables);
    }, [
        refetchApprovalsData,
        refetchVariables,
        otherContentStatus
    ]);
    (0, $i9VoI.useSubscriptionEvent)({
        subscriberId: 'ApprovalsProviderOtherModeWorkflowApplicationChanged',
        delta: 'workflowApplicationChanged',
        contentId: contentId,
        contentType: contentType || 'page',
        skip: !(0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true),
        onDataReceived: onOtherModeWorkflowApplicationChanged
    });
    const approvalProgress = (0, $cozmU.useMemo)(()=>{
        if (!approvalRequest) return {
            current: 0,
            total: 0
        };
        const responded = approvalRequest.review?.approvers?.filter((a)=>a.status !== null && a.status !== 'PENDING_REVIEW').length;
        return {
            current: responded ?? 0,
            total: approvalRequest.review?.approvers?.length ?? 0
        };
    }, [
        approvalRequest
    ]);
    const isPendingReviewBlockedByRequiredApproversChange = (0, $cozmU.useMemo)(()=>{
        if (!(0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) || !isRequiredApproversActive) return false;
        const approvers = approvalRequest?.review?.approvers;
        if (approvalRequest?.review?.reviewStatus !== 'PENDING' || !approvers) return false;
        const currentApproverKeys = new Set(approvers.map((approver)=>$e450e61f37c9899d$export$eac3cbee8fb231fd({
                principalType: approver.principalType,
                principalId: approver.principalId
            })));
        const requiredApproverKeys = new Set(requiredApprovers.map($e450e61f37c9899d$export$eac3cbee8fb231fd));
        if (currentApproverKeys.size !== requiredApproverKeys.size) return true;
        for (const requiredApproverKey of requiredApproverKeys){
            if (!currentApproverKeys.has(requiredApproverKey)) return true;
        }
        return false;
    }, [
        approvalRequest?.review?.approvers,
        approvalRequest?.review?.reviewStatus,
        isRequiredApproversActive,
        requiredApprovers
    ]);
    // GraphQL Mutations
    const [createWorkflowApplicationMutationFn] = (0, $308Wd.useMutationInterop)($e450e61f37c9899d$var$createWorkflowApplicationMutation, {
        refetchQueries: [
            {
                query: $e450e61f37c9899d$var$approvalsDataQuery,
                variables: refetchVariables
            }
        ],
        __callerPackage__: "approvals"
    });
    const [createWorkflowReviewMutationFn] = (0, $308Wd.useMutationInterop)($e450e61f37c9899d$var$createWorkflowReviewMutation, {
        refetchQueries: [
            {
                query: $e450e61f37c9899d$var$approvalsDataQuery,
                variables: refetchVariables
            }
        ],
        __callerPackage__: "approvals"
    });
    const [updateWorkflowApplicationMutationFn] = (0, $308Wd.useMutationInterop)($e450e61f37c9899d$var$updateWorkflowApplicationMutation, {
        refetchQueries: [
            {
                query: $e450e61f37c9899d$var$approvalsDataQuery,
                variables: refetchVariables
            }
        ],
        __callerPackage__: "approvals"
    });
    const [updateReviewerDecisionMutationFn] = (0, $308Wd.useMutationInterop)($e450e61f37c9899d$var$updateReviewerDecisionMutation, {
        refetchQueries: [
            {
                query: $e450e61f37c9899d$var$approvalsDataQuery,
                variables: refetchVariables
            }
        ],
        __callerPackage__: "approvals"
    });
    const [updateWorkflowReviewMutationFn] = (0, $308Wd.useMutationInterop)($e450e61f37c9899d$var$updateWorkflowReviewMutation, {
        refetchQueries: [
            {
                query: $e450e61f37c9899d$var$approvalsDataQuery,
                variables: refetchVariables
            }
        ],
        __callerPackage__: "approvals"
    });
    const [removeContentApprovalReviewerMutationFn] = (0, $308Wd.useMutationInterop)($e450e61f37c9899d$var$removeContentApprovalReviewerMutation, {
        refetchQueries: [
            {
                query: $e450e61f37c9899d$var$approvalsDataQuery,
                variables: refetchVariables
            }
        ],
        __callerPackage__: "approvals"
    });
    const [resolveApprovalAgentMutationFn] = (0, $308Wd.useMutationInterop)($e450e61f37c9899d$var$resolveApprovalAgentMutation, {
        __callerPackage__: "approvals"
    });
    const [createWorkflowApplicationWithReviewMutationFn] = (0, $308Wd.useMutationInterop)($e450e61f37c9899d$var$createWorkflowApplicationWithReviewMutation, {
        refetchQueries: [
            {
                query: $e450e61f37c9899d$var$approvalsDataQuery,
                variables: refetchVariables
            }
        ],
        __callerPackage__: "approvals"
    });
    // Wrapped mutation functions
    // Resolves the approval agent ID. If the mutation fails, returns an empty string
    // so the caller can fall back to invoking regular Rovo instead of the agent.
    const resolveApprovalAgent = (0, $cozmU.useCallback)(async ()=>{
        try {
            const result = await resolveApprovalAgentMutationFn({
                variables: {
                    cloudId: cloudId
                }
            });
            const response = result?.data?.confluence_resolveApprovalAgent;
            if (!response?.success || response.errors?.length > 0) return '';
            return response.agent?.id ?? '';
        } catch  {
            return '';
        }
    }, [
        cloudId,
        resolveApprovalAgentMutationFn
    ]);
    const createWorkflowApplication = (0, $cozmU.useCallback)(async (status)=>{
        setIsOptimisticallyCancelled(false);
        setOptimisticWorkflowStatus(status);
        try {
            const result = await createWorkflowApplicationMutationFn({
                variables: {
                    cloudId: cloudId,
                    createWorkflowApplicationRequestInput: {
                        contentId: contentId,
                        contentStatus: contentStatus,
                        workflowId: 1,
                        workflowStatusId: 1,
                        // hardcoded -- backend assigns status on creation
                        isActive: true
                    }
                }
            });
            const workflowStatus = result.data?.confluence_createWorkflowApplication?.workflowStatus;
            return {
                applicationId: result.data?.confluence_createWorkflowApplication?.workflowApplication?.id,
                workflowStatusId: workflowStatus?.id ?? '1',
                name: workflowStatus?.displayProperties?.name || '',
                allowsReviews: workflowStatus?.allowsReviews || false
            };
        } catch (error) {
            setOptimisticWorkflowStatus(null);
            throw error;
        }
    }, [
        cloudId,
        contentId,
        contentStatus,
        createWorkflowApplicationMutationFn
    ]);
    /** Variables are optional: if not provided, this will cancel the workflow application for
  the latest content version for the current content status */ const cancelWorkflowApplication = (0, $cozmU.useCallback)(async (variables, options)=>{
        if (options?.closePane !== false) closeRightSidebar((0, $1vpkQ.APPROVALS_PANE_ID));
        isCancellationInFlightRef.current = true;
        try {
            await updateWorkflowApplicationMutationFn({
                variables: {
                    cloudId: cloudId,
                    updateWorkflowApplicationRequestInput: {
                        contentId: variables?.contentId ? parseInt(variables.contentId, 10) : parseInt(contentId, 10),
                        contentStatus: variables?.contentStatus ?? contentStatus,
                        version: variables?.version ?? (contentStatus === $e450e61f37c9899d$var$CURRENT_CONTENT_STATUS ? contentVersion : 1),
                        workflowStatusId: parseInt(variables?.workflowStatusId ?? approvalRequest?.application?.workflowStatusId ?? '1', 10),
                        isActive: false,
                        workflowId: 1
                    }
                }
            });
        } catch (error) {
            setIsOptimisticallyCancelled(false);
            (0, $7Sm4c.markErrorAsHandled)(error);
        // TODO: Add error handling
        } finally{
            isCancellationInFlightRef.current = false;
        }
    }, [
        cloudId,
        contentId,
        contentStatus,
        contentVersion,
        approvalRequest?.application?.workflowStatusId,
        updateWorkflowApplicationMutationFn,
        closeRightSidebar
    ]);
    const clearApprovalRequestOptimistically = (0, $cozmU.useCallback)(()=>{
        setIsOptimisticallyCancelled(true);
        setOptimisticWorkflowStatus(null);
    }, []);
    const requestLiveDocApprovalConversion = (0, $cozmU.useCallback)((requestContentId)=>{
        if (!(0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) return;
        setPendingLiveDocApprovalContentId(requestContentId);
    }, []);
    const clearLiveDocApprovalConversion = (0, $cozmU.useCallback)(()=>{
        if (!(0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) return;
        setPendingLiveDocApprovalContentId(null);
    }, []);
    const startApproval = (0, $cozmU.useCallback)(async (variables)=>{
        const result = await createWorkflowReviewMutationFn({
            variables: {
                cloudId: cloudId,
                createContentApprovalRequestInput: {
                    contentId: contentId,
                    contentStatus: contentStatus,
                    version: contentStatus === $e450e61f37c9899d$var$CURRENT_CONTENT_STATUS ? contentVersion : 1,
                    // DRAFT version is always 1,
                    comment: variables.message,
                    reviewers: variables.approvers
                }
            }
        });
        const response = result.data?.confluence_createContentApproval;
        if (response && !response.success) $e450e61f37c9899d$var$handleApprovalMutationError(response.errors, 'Failed to start approval');
        return response?.contentApproval ?? undefined;
    }, [
        cloudId,
        contentId,
        contentStatus,
        contentVersion,
        createWorkflowReviewMutationFn
    ]);
    const updateApprovalStatus = (0, $cozmU.useCallback)(async (variables)=>{
        const decisionStatus = variables.status;
        const result = await updateReviewerDecisionMutationFn({
            variables: {
                cloudId: cloudId,
                confluenceUpdateReviewerDecisionInput: {
                    reviewerId: parseInt(variables.reviewerId, 10),
                    decisionStatus: decisionStatus,
                    comment: variables.comment || null
                }
            }
        });
        const response = result.data?.confluence_updateReviewerDecision;
        if (response && !response.success) {
            const errorMessage = response.errors?.[0]?.message || 'Failed to update reviewer decision';
            throw new Error(errorMessage);
        }
    }, [
        cloudId,
        updateReviewerDecisionMutationFn
    ]);
    const addApprover = (0, $cozmU.useCallback)(async (variables)=>{
        if (!approvalRequest?.application || !approvalRequest?.review) throw new Error('approval request with review is required');
        const existingReviewers = approvalRequest.review.approvers.map((a)=>({
                principalId: a.principalId,
                principalType: a.principalType === 'GROUP' ? 'GROUP' : 'USER',
                isRequired: a.isRequired
            }));
        const existingIds = new Set(existingReviewers.map((r)=>r.principalId));
        const mergedReviewers = [
            ...existingReviewers
        ];
        for (const r of variables.approvers)if (!existingIds.has(r.principalId)) {
            mergedReviewers.push({
                principalId: r.principalId,
                principalType: r.principalType,
                isRequired: r.isRequired
            });
            existingIds.add(r.principalId);
        }
        await updateWorkflowReviewMutationFn({
            variables: {
                cloudId: cloudId,
                updateContentApprovalGraphQLInput: {
                    workflowApplicationId: parseInt(approvalRequest.application.applicationId, 10),
                    contentApprovalReviewId: parseInt(approvalRequest.review.reviewId, 10),
                    reviewers: mergedReviewers.map((a)=>({
                            principalId: a.principalId,
                            principalType: a.principalType === 'GROUP' ? 'GROUP' : 'USER',
                            isRequired: a.isRequired
                        }))
                }
            }
        });
    }, [
        approvalRequest,
        cloudId,
        updateWorkflowReviewMutationFn
    ]);
    const removeApprover = (0, $cozmU.useCallback)(async (variables)=>{
        if (!approvalRequest?.application || !approvalRequest?.review) throw new Error('approval request with review is required');
        const approver = approvalRequest.review.approvers.find((a)=>a.principalId === variables.principalId);
        if (!approver) throw new Error('Approver not found in current review');
        await removeContentApprovalReviewerMutationFn({
            variables: {
                cloudId: cloudId,
                removeContentApprovalReviewerInput: {
                    workflowApplicationId: approvalRequest.application.applicationId,
                    contentApprovalReviewId: approvalRequest.review.reviewId,
                    principalId: variables.principalId,
                    principalType: approver.principalType
                }
            }
        });
    }, [
        approvalRequest,
        cloudId,
        removeContentApprovalReviewerMutationFn
    ]);
    const cancelApproval = (0, $cozmU.useCallback)(async (variables)=>{
        closeRightSidebar((0, $1vpkQ.APPROVALS_PANE_ID));
        await updateWorkflowReviewMutationFn({
            variables: {
                cloudId: cloudId,
                updateContentApprovalGraphQLInput: {
                    workflowApplicationId: parseInt(variables.workflowApplicationId, 10),
                    contentApprovalReviewId: parseInt(variables.contentApprovalReviewId, 10),
                    approvalStatus: 'CANCELED'
                }
            }
        });
    }, [
        cloudId,
        updateWorkflowReviewMutationFn,
        closeRightSidebar
    ]);
    const startApprovalCombined = (0, $cozmU.useCallback)(async (variables)=>{
        const result = await createWorkflowApplicationWithReviewMutationFn({
            variables: {
                cloudId: cloudId,
                createWorkflowApplicationWithReviewRequestInput: {
                    contentId: contentId,
                    contentStatus: contentStatus,
                    version: contentStatus === $e450e61f37c9899d$var$CURRENT_CONTENT_STATUS ? contentVersion : 1,
                    comment: variables.message,
                    reviewers: variables.approvers,
                    ...variables.dueDate && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) ? {
                        dueDate: (0, $kWNKJ.encodeDueDateForMutation)(variables.dueDate)
                    } : {}
                }
            }
        });
        const response = result.data?.confluence_createWorkflowApplicationWithReview;
        if (response && !response.success) $e450e61f37c9899d$var$handleApprovalMutationError(response.errors, 'Failed to start approval');
        return {
            id: response?.workflowReviewWithDecisions?.id ?? '',
            reviewStatus: 'PENDING',
            workflowApplicationId: response?.workflowApplication?.id ?? null,
            comment: variables.message ?? null
        };
    }, [
        cloudId,
        contentId,
        contentStatus,
        contentVersion,
        createWorkflowApplicationWithReviewMutationFn
    ]);
    const otherModeReviewStatus = (0, $cozmU.useMemo)(()=>{
        if (isDataStale) return null;
        return approvalsData?.confluence_getActiveWorkflowApplicationForOtherStatus?.workflowReviewWithDecisions?.reviewStatus ?? null;
    }, [
        isDataStale,
        approvalsData?.confluence_getActiveWorkflowApplicationForOtherStatus
    ]);
    const isDraftLockedForEditing = (0, $cozmU.useMemo)(()=>{
        if (contentStatus !== $e450e61f37c9899d$var$DRAFT_CONTENT_STATUS) return false;
        const review = approvalRequest?.review;
        if (review == null) return false;
        return review.reviewStatus === 'PENDING' || review.reviewStatus === 'APPROVED';
    }, [
        contentStatus,
        approvalRequest?.review
    ]);
    // Context values - memoized to prevent unnecessary re-renders
    const contextValue = (0, $cozmU.useMemo)(()=>({
            approvalRequest: approvalRequest,
            // If we already have data for the current page, keep rendering it during in-flight
            // refetches (e.g. after a reviewer decision) so the byline and page banners don't
            // flicker. `isDataStale` / `isAwaitingFreshData` still hide UI on real navigations.
            approvalRequestLoading: approvalsLoading && !approvalsData || isDataStale || isAwaitingFreshData,
            contentVersion: contentVersion,
            availableWorkflowStatuses: availableWorkflowStatuses,
            contentId: contentId,
            contentStatus: contentStatus,
            isCurrentUserRequestor: isCurrentUserRequestor,
            isCurrentUserApprover: !!currentUserApprover,
            currentUserApprover: currentUserApprover,
            approvalProgress: approvalProgress,
            hasEditPermission: hasEditPermission,
            isDraftLockedForEditing: isDraftLockedForEditing,
            otherModeReviewStatus: otherModeReviewStatus,
            isContentApprovalsEnabled: isContentApprovalsEnabled,
            disallowFirstPublish: disallowFirstPublish,
            requiredApprovers: requiredApprovers,
            isRequiredApproversActive: isRequiredApproversActive,
            isPendingReviewBlockedByRequiredApproversChange: isPendingReviewBlockedByRequiredApproversChange,
            pendingLiveDocApprovalContentId: pendingLiveDocApprovalContentId
        }), [
        approvalRequest,
        approvalsLoading,
        approvalsData,
        isDataStale,
        isAwaitingFreshData,
        contentVersion,
        availableWorkflowStatuses,
        contentId,
        contentStatus,
        isCurrentUserRequestor,
        currentUserApprover,
        approvalProgress,
        hasEditPermission,
        isDraftLockedForEditing,
        otherModeReviewStatus,
        isContentApprovalsEnabled,
        disallowFirstPublish,
        requiredApprovers,
        isRequiredApproversActive,
        isPendingReviewBlockedByRequiredApproversChange,
        pendingLiveDocApprovalContentId
    ]);
    const dispatchValue = (0, $cozmU.useMemo)(()=>({
            createWorkflowApplication: createWorkflowApplication,
            cancelWorkflowApplication: cancelWorkflowApplication,
            clearApprovalRequestOptimistically: clearApprovalRequestOptimistically,
            startApproval: startApproval,
            updateApprovalStatus: updateApprovalStatus,
            addApprover: addApprover,
            removeApprover: removeApprover,
            cancelApproval: cancelApproval,
            resolveApprovalAgent: resolveApprovalAgent,
            startApprovalCombined: startApprovalCombined,
            requestLiveDocApprovalConversion: requestLiveDocApprovalConversion,
            clearLiveDocApprovalConversion: clearLiveDocApprovalConversion
        }), [
        createWorkflowApplication,
        cancelWorkflowApplication,
        clearApprovalRequestOptimistically,
        startApproval,
        updateApprovalStatus,
        addApprover,
        removeApprover,
        cancelApproval,
        resolveApprovalAgent,
        startApprovalCombined,
        requestLiveDocApprovalConversion,
        clearLiveDocApprovalConversion
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e450e61f37c9899d$export$eb47cecb126081cc.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e450e61f37c9899d$export$a8239efa8a51a660.Provider, {
        value: dispatchValue
    }, children, (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lKfPX.ApprovalCtaFlag), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Xs1I.QuickReloadSubscriber), {
        name: "approvals",
        types: [
            (0, $c0urc.ReloadType).content
        ],
        reload: refetchApprovalsData
    }))));
};
const $e450e61f37c9899d$export$38d1715f438e155f = ()=>{
    return (0, $cozmU.useContext)($e450e61f37c9899d$export$eb47cecb126081cc);
};
const $e450e61f37c9899d$export$ff5d1fbbfb1fe9d8 = ()=>{
    return (0, $cozmU.useContext)($e450e61f37c9899d$export$a8239efa8a51a660);
};
module.exports["ApprovalsProvider"] = $e450e61f37c9899d$export$c720d3c28af710a;
module.exports["useApprovals"] = $e450e61f37c9899d$export$38d1715f438e155f;
module.exports["useApprovalsDispatch"] = $e450e61f37c9899d$export$ff5d1fbbfb1fe9d8;

});

parcelRegister("lKLmX", function(module, exports) {
/**
 * @generated SignedSource<<b9ad5a08ae51c98f54e2bf136fb000a5>>
 * @relayHash 3a81188260e43110e57bf35a979f5053
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9c767da7861d97903ba1d85d6b0a41ab5ff13ba32a0ebf4537e812118caef418
const $c7a72aad1b5e4549$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeApprovalsBetaFeatures"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "otherContentStatus"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "transitionType"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "spaceKey"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "concreteType": "SpaceTypeSettings",
                "kind": "LinkedField",
                "name": "spaceTypeSettings",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "EnabledFeatures",
                        "kind": "LinkedField",
                        "name": "enabledFeatures",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isContentApprovalsEnabled"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v9 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v10 = {
        "kind": "ScalarField",
        "name": "success"
    }, v11 = {
        "kind": "ScalarField",
        "name": "message"
    }, v12 = {
        "kind": "ScalarField",
        "name": "principalType"
    }, v13 = {
        "kind": "ScalarField",
        "name": "principalId"
    }, v14 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v15 = {
        "kind": "ScalarField",
        "name": "isActive"
    }, v16 = {
        "kind": "ScalarField",
        "name": "value"
    }, v17 = {
        "kind": "ScalarField",
        "name": "isPrimary"
    }, v18 = [
        v7 /*: any*/ ,
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        {
            "concreteType": "AtlassianUserPhoto",
            "kind": "LinkedField",
            "name": "photos",
            "plural": true,
            "selections": [
                v16 /*: any*/ ,
                v17 /*: any*/ 
            ]
        }
    ], v19 = {
        "condition": "includeApprovalsBetaFeatures",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    v9 /*: any*/ 
                ],
                "concreteType": "ConfluenceContentApprovalsSiteSettings",
                "kind": "LinkedField",
                "name": "confluence_contentApprovalsSiteSettings",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "enabled"
                    }
                ]
            },
            {
                "args": [
                    v9 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "filterSelf",
                        "value": false
                    },
                    {
                        "kind": "Variable",
                        "name": "spaceKey",
                        "variableName": "spaceKey"
                    }
                ],
                "concreteType": "ConfluenceContentApprovalsSpaceSettingConfigPayload",
                "kind": "LinkedField",
                "name": "confluence_contentApprovalsSpaceSettingConfig",
                "plural": false,
                "selections": [
                    v10 /*: any*/ ,
                    {
                        "concreteType": "MutationError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            v11 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "ConfluenceContentApprovalsSpaceSettingConfig",
                        "kind": "LinkedField",
                        "name": "config",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "disallowFirstPublish"
                            },
                            {
                                "concreteType": "ConfluenceApprovalReviewerConfig",
                                "kind": "LinkedField",
                                "name": "enforcedApprovalReviewerConfig",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "isEnabled"
                                    },
                                    {
                                        "concreteType": "ConfluenceSpaceApprovalReviewerEntry",
                                        "kind": "LinkedField",
                                        "name": "reviewers",
                                        "plural": true,
                                        "selections": [
                                            v12 /*: any*/ ,
                                            v13 /*: any*/ ,
                                            {
                                                "concreteType": "AtlassianUser",
                                                "kind": "LinkedField",
                                                "name": "user",
                                                "plural": false,
                                                "selections": v18 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v20 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v21 = {
        "kind": "ScalarField",
        "name": "status"
    }, v22 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "number"
            }
        ]
    }, v23 = {
        "args": [
            v9 /*: any*/ ,
            {
                "kind": "Variable",
                "name": "transitionType",
                "variableName": "transitionType"
            }
        ],
        "concreteType": "ConfluenceApprovalsWorkflowStatus",
        "kind": "LinkedField",
        "name": "confluence_contentApprovalStatuses",
        "plural": true,
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "allowsReviews"
            },
            {
                "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
                "kind": "LinkedField",
                "name": "displayProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    }
                ]
            }
        ]
    }, v24 = {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
    }, v25 = {
        "kind": "Literal",
        "name": "fetchWorkflowReview",
        "value": true
    }, v26 = {
        "kind": "Literal",
        "name": "workflowId",
        "value": "1"
    }, v27 = [
        v9 /*: any*/ ,
        v24 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "otherContentStatus"
        },
        v25 /*: any*/ ,
        v26 /*: any*/ 
    ], v28 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v29 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v30 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v11 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    v28 /*: any*/ ,
                    v29 /*: any*/ 
                ]
            }
        ]
    }, v31 = {
        "kind": "ScalarField",
        "name": "reviewStatus"
    }, v32 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            v31 /*: any*/ 
        ]
    }, v33 = [
        v9 /*: any*/ ,
        v24 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        v25 /*: any*/ ,
        v26 /*: any*/ 
    ], v34 = {
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": v18 /*: any*/ 
    }, v35 = [
        v16 /*: any*/ 
    ], v36 = {
        "concreteType": "ConfluenceWorkflowApplicationDetails",
        "kind": "LinkedField",
        "name": "workflowApplication",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "workflowId"
            },
            {
                "kind": "ScalarField",
                "name": "contentId"
            },
            {
                "kind": "ScalarField",
                "name": "contentVersion"
            },
            {
                "kind": "ScalarField",
                "name": "contentStatus"
            },
            {
                "kind": "ScalarField",
                "name": "workflowStatusId"
            },
            v15 /*: any*/ ,
            v34 /*: any*/ ,
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "lastModificationDate",
                "plural": false,
                "selections": v35 /*: any*/ 
            },
            {
                "concreteType": "AtlassianUser",
                "kind": "LinkedField",
                "name": "modifier",
                "plural": false,
                "selections": v18 /*: any*/ 
            }
        ]
    }, v37 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "creatorAaid"
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "creationDate",
                "plural": false,
                "selections": v35 /*: any*/ 
            },
            v31 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "reviewComment"
            },
            {
                "condition": "includeApprovalsBetaFeatures",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "ConfluenceApprovalsDate",
                        "kind": "LinkedField",
                        "name": "dueDate",
                        "plural": false,
                        "selections": v35 /*: any*/ 
                    }
                ]
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "reviewLastModified",
                "plural": false,
                "selections": v35 /*: any*/ 
            },
            v34 /*: any*/ ,
            {
                "concreteType": "ConfluenceReviewerDecisionInfo",
                "kind": "LinkedField",
                "name": "reviewerDecisions",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "decisionId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reviewerId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "required"
                    },
                    v12 /*: any*/ ,
                    v13 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "reviewerDecisionStatus"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "comment"
                    },
                    {
                        "concreteType": "ConfluenceApprovalsDate",
                        "kind": "LinkedField",
                        "name": "lastModifiedDate",
                        "plural": false,
                        "selections": v35 /*: any*/ 
                    },
                    {
                        "concreteType": "AtlassianUser",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v7 /*: any*/ ,
                            v14 /*: any*/ ,
                            v15 /*: any*/ ,
                            {
                                "concreteType": "AtlassianUserPhoto",
                                "kind": "LinkedField",
                                "name": "photos",
                                "plural": true,
                                "selections": [
                                    v17 /*: any*/ ,
                                    v16 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v38 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v11 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    v28 /*: any*/ ,
                    v29 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v7 /*: any*/ 
                        ],
                        "type": "BulkMutationErrorExtension"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                v8 /*: any*/ ,
                v19 /*: any*/ ,
                {
                    "args": v20 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v21 /*: any*/ ,
                                v22 /*: any*/ 
                            ]
                        }
                    ]
                },
                v23 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v27 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ ,
                        v30 /*: any*/ ,
                        v32 /*: any*/ 
                    ]
                },
                {
                    "args": v33 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ ,
                        v30 /*: any*/ ,
                        v36 /*: any*/ ,
                        v37 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                v8 /*: any*/ ,
                v19 /*: any*/ ,
                {
                    "args": v20 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v21 /*: any*/ ,
                                v22 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                },
                v23 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v27 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ ,
                        v38 /*: any*/ ,
                        v32 /*: any*/ 
                    ]
                },
                {
                    "args": v33 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ ,
                        v38 /*: any*/ ,
                        v36 /*: any*/ ,
                        v37 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "3a81188260e43110e57bf35a979f5053",
            "id": "9c767da7861d97903ba1d85d6b0a41ab5ff13ba32a0ebf4537e812118caef418",
            "metadata": {},
            "name": "ApprovalsContextApprovalsDataQuery",
            "operationKind": "query",
            "text": "query ApprovalsContextApprovalsDataQuery($cloudId:ID!,$contentId:ID!,$contentStatus:String!,$otherContentStatus:String!,$transitionType:ConfluenceApprovalTransitionType,$spaceKey:String!,$includeApprovalsBetaFeatures:Boolean!){space(key:$spaceKey){id,spaceTypeSettings{enabledFeatures{isContentApprovalsEnabled}}},confluence_contentApprovalsSiteSettings(cloudId:$cloudId)@include(if:$includeApprovalsBetaFeatures){enabled}\n  confluence_contentApprovalsSpaceSettingConfig(cloudId:$cloudId,spaceKey:$spaceKey,filterSelf:false)@include(if:$includeApprovalsBetaFeatures){success,errors{message},config{disallowFirstPublish,enforcedApprovalReviewerConfig{isEnabled,reviewers{principalType,principalId,user{id,displayName,isActive,photos{value,isPrimary}}}}}},content(id:$contentId){nodes{status,version{number},id}},confluence_contentApprovalStatuses(cloudId:$cloudId,transitionType:$transitionType){id,allowsReviews,displayProperties{name,color}},confluence_getActiveWorkflowApplicationForOtherStatus:confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$otherContentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowReviewWithDecisions{id,reviewStatus}},confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$contentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowApplication{id,workflowId,contentId,contentVersion,contentStatus,workflowStatusId,isActive,creator{id,displayName,isActive,photos{value,isPrimary}},lastModificationDate{value},modifier{id,displayName,isActive,photos{value,isPrimary}}},workflowReviewWithDecisions{id,creatorAaid,creationDate{value},reviewStatus,reviewComment,dueDate@include(if:$includeApprovalsBetaFeatures){value},reviewLastModified{value},creator{id,displayName,isActive,photos{value,isPrimary}},reviewerDecisions{decisionId,reviewerId,required,principalType,principalId,reviewerDecisionStatus,comment,lastModifiedDate{value},user{id,displayName,isActive,photos{isPrimary,value}}}}}}"
        }
    };
}();
$c7a72aad1b5e4549$var$node.hash = "20f79def106defb4cc34e9f770d1c8cc";
var $c7a72aad1b5e4549$export$2e2bcd8739ae039 = $c7a72aad1b5e4549$var$node;
module.exports["default"] = $c7a72aad1b5e4549$export$2e2bcd8739ae039;

});

parcelRegister("fenUZ", function(module, exports) {
/**
 * @generated SignedSource<<b459a5fabf2f5fbcebc6e34670b6d831>>
 * @relayHash 1c45745cc12810ecdbcde25f697fac8e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ffe21b74af26001371a0042d20b490c10d31e8bdd61af3f5ec29791965fdf02
const $51700bb24bdc6b5f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "removeContentApprovalReviewerInput"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "removeContentApprovalReviewerInput",
            "variableName": "removeContentApprovalReviewerInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ApprovalsContextRemoveContentApprovalReviewerMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceContentApprovalPayload",
                    "kind": "LinkedField",
                    "name": "confluence_removeContentApprovalReviewer",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ApprovalsContextRemoveContentApprovalReviewerMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceContentApprovalPayload",
                    "kind": "LinkedField",
                    "name": "confluence_removeContentApprovalReviewer",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "1c45745cc12810ecdbcde25f697fac8e",
            "id": "1ffe21b74af26001371a0042d20b490c10d31e8bdd61af3f5ec29791965fdf02",
            "metadata": {},
            "name": "ApprovalsContextRemoveContentApprovalReviewerMutation",
            "operationKind": "mutation",
            "text": "mutation ApprovalsContextRemoveContentApprovalReviewerMutation($cloudId:ID!,$removeContentApprovalReviewerInput:ConfluenceRemoveContentApprovalReviewerInput!){confluence_removeContentApprovalReviewer(cloudId:$cloudId,removeContentApprovalReviewerInput:$removeContentApprovalReviewerInput){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$51700bb24bdc6b5f$var$node.hash = "697e5f36bdc5f862fd4fb3d7c42a7b48";
var $51700bb24bdc6b5f$export$2e2bcd8739ae039 = $51700bb24bdc6b5f$var$node;
module.exports["default"] = $51700bb24bdc6b5f$export$2e2bcd8739ae039;

});

parcelRegister("zALBk", function(module, exports) {
/**
 * @generated SignedSource<<084cf03641b36488ca6feed196445337>>
 * @relayHash 39de47f938cab217b90fa8be44254bf0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ce39d0bfebafbc64cc7bd0412051708f3b89b6a9db998561ce493d8e60dd10d6
const $983a375dea48c645$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "createWorkflowApplicationWithReviewRequestInput"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "createWorkflowApplicationWithReviewRequestInput",
            "variableName": "createWorkflowApplicationWithReviewRequestInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = [
        v6 /*: any*/ 
    ], v8 = {
        "concreteType": "ConfluenceWorkflowApplicationDetails",
        "kind": "LinkedField",
        "name": "workflowApplication",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v9 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v10 = {
        "concreteType": "ConfluenceApprovalsWorkflowStatus",
        "kind": "LinkedField",
        "name": "workflowStatus",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "allowsReviews"
            },
            {
                "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
                "kind": "LinkedField",
                "name": "displayProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "icon"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ApprovalsContextCreateWorkflowApplicationWithReviewMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_createWorkflowApplicationWithReview",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ 
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ApprovalsContextCreateWorkflowApplicationWithReviewMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_createWorkflowApplicationWithReview",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v7 /*: any*/ ,
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        },
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "39de47f938cab217b90fa8be44254bf0",
            "id": "ce39d0bfebafbc64cc7bd0412051708f3b89b6a9db998561ce493d8e60dd10d6",
            "metadata": {},
            "name": "ApprovalsContextCreateWorkflowApplicationWithReviewMutation",
            "operationKind": "mutation",
            "text": "mutation ApprovalsContextCreateWorkflowApplicationWithReviewMutation($cloudId:ID!,$createWorkflowApplicationWithReviewRequestInput:ConfluenceCreateContentApprovalRequestInput!){confluence_createWorkflowApplicationWithReview(cloudId:$cloudId,createWorkflowApplicationWithReviewRequestInput:$createWorkflowApplicationWithReviewRequestInput){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowApplication{id},workflowReviewWithDecisions{id},workflowStatus{id,allowsReviews,displayProperties{name,description,color,icon}}}}"
        }
    };
}();
$983a375dea48c645$var$node.hash = "1f600841294ca5c66fe6bd680de7b5df";
var $983a375dea48c645$export$2e2bcd8739ae039 = $983a375dea48c645$var$node;
module.exports["default"] = $983a375dea48c645$export$2e2bcd8739ae039;

});

parcelRegister("2WqwD", function(module, exports) {
/**
 * @generated SignedSource<<557cd1dd876b1e0b39b296de919920eb>>
 * @relayHash 7e7e86c50393bd91ccd31140eb439adb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b9bcae1436f9202c13d56dc45389fd2497c967083f8c60073ee6be35e8a9b328
const $e3200d7e3785782c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceApprovalAgentPayload",
            "kind": "LinkedField",
            "name": "confluence_resolveApprovalAgent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "ConfluenceApprovalAgent",
                    "kind": "LinkedField",
                    "name": "agent",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ApprovalsContextResolveApprovalAgentMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ApprovalsContextResolveApprovalAgentMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7e7e86c50393bd91ccd31140eb439adb",
            "id": "b9bcae1436f9202c13d56dc45389fd2497c967083f8c60073ee6be35e8a9b328",
            "metadata": {},
            "name": "ApprovalsContextResolveApprovalAgentMutation",
            "operationKind": "mutation",
            "text": "mutation ApprovalsContextResolveApprovalAgentMutation($cloudId:ID!){confluence_resolveApprovalAgent(cloudId:$cloudId){success,agent{id},errors{message}}}"
        }
    };
}();
$e3200d7e3785782c$var$node.hash = "e4cb35491d152f5cba04815adf8e599d";
var $e3200d7e3785782c$export$2e2bcd8739ae039 = $e3200d7e3785782c$var$node;
module.exports["default"] = $e3200d7e3785782c$export$2e2bcd8739ae039;

});

parcelRegister("chVEh", function(module, exports) {
/**
 * @generated SignedSource<<a70f42d7d1ac9065535a52f1567efca0>>
 * @relayHash 27144a0bed02bf89bd05934de4bc8547
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b58a57226e51cf212c8f99536a985edea6c86fe3250346eb71ececf9680043a1
const $340575ae55838f10$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "updateContentApprovalGraphQLInput"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "updateContentApprovalGraphQLInput",
            "variableName": "updateContentApprovalGraphQLInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "isPrimary"
        },
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v8 = {
        "concreteType": "ConfluenceWorkflowReview",
        "kind": "LinkedField",
        "name": "contentApproval",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "reviewStatus"
            },
            {
                "kind": "ScalarField",
                "name": "comment"
            },
            {
                "concreteType": "ConfluenceWorkflowReviewer",
                "kind": "LinkedField",
                "name": "reviewers",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "principalType"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "principalId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isRequired"
                    },
                    {
                        "concreteType": "AtlassianUser",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v6 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "displayName"
                            },
                            {
                                "concreteType": "AtlassianUserPhoto",
                                "kind": "LinkedField",
                                "name": "photos",
                                "plural": true,
                                "selections": v7 /*: any*/ 
                            },
                            {
                                "concreteType": "AtlassianUserEmail",
                                "kind": "LinkedField",
                                "name": "emails",
                                "plural": true,
                                "selections": v7 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ApprovalsContextUpdateWorkflowReviewMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceContentApprovalPayload",
                    "kind": "LinkedField",
                    "name": "confluence_updateContentApproval",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v8 /*: any*/ 
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ApprovalsContextUpdateWorkflowReviewMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceContentApprovalPayload",
                    "kind": "LinkedField",
                    "name": "confluence_updateContentApproval",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v6 /*: any*/ 
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        },
                        v8 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "27144a0bed02bf89bd05934de4bc8547",
            "id": "b58a57226e51cf212c8f99536a985edea6c86fe3250346eb71ececf9680043a1",
            "metadata": {},
            "name": "ApprovalsContextUpdateWorkflowReviewMutation",
            "operationKind": "mutation",
            "text": "mutation ApprovalsContextUpdateWorkflowReviewMutation($cloudId:ID!,$updateContentApprovalGraphQLInput:ConfluenceUpdateContentApprovalRequestInput!){confluence_updateContentApproval(cloudId:$cloudId,updateContentApprovalGraphQLInput:$updateContentApprovalGraphQLInput){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},contentApproval{id,reviewStatus,comment,reviewers{principalType,principalId,isRequired,user{id,displayName,photos{isPrimary,value},emails{isPrimary,value}}}}}}"
        }
    };
}();
$340575ae55838f10$var$node.hash = "6e686f80296d6e3ef707726180b7464e";
var $340575ae55838f10$export$2e2bcd8739ae039 = $340575ae55838f10$var$node;
module.exports["default"] = $340575ae55838f10$export$2e2bcd8739ae039;

});

parcelRegister("lygOH", function(module, exports) {
/**
 * @generated SignedSource<<dcabcf53f82fa06f62cc3a35f89a447a>>
 * @relayHash afa8664360527d902e240ba8f2439caa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3f9b07106aa2dedfbc69fa47c92f7f5096395d3f5d08fc7e76614f3b76ac0fde
const $0aa9e770fdcc2607$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "confluenceUpdateReviewerDecisionInput"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "confluenceUpdateReviewerDecisionInput",
            "variableName": "confluenceUpdateReviewerDecisionInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ApprovalsContextUpdateReviewerDecisionMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowReviewerDecisionPayload",
                    "kind": "LinkedField",
                    "name": "confluence_updateReviewerDecision",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ApprovalsContextUpdateReviewerDecisionMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowReviewerDecisionPayload",
                    "kind": "LinkedField",
                    "name": "confluence_updateReviewerDecision",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "afa8664360527d902e240ba8f2439caa",
            "id": "3f9b07106aa2dedfbc69fa47c92f7f5096395d3f5d08fc7e76614f3b76ac0fde",
            "metadata": {},
            "name": "ApprovalsContextUpdateReviewerDecisionMutation",
            "operationKind": "mutation",
            "text": "mutation ApprovalsContextUpdateReviewerDecisionMutation($cloudId:ID!,$confluenceUpdateReviewerDecisionInput:ConfluenceUpdateReviewerDecisionInput!){confluence_updateReviewerDecision(cloudId:$cloudId,confluenceUpdateReviewerDecisionInput:$confluenceUpdateReviewerDecisionInput){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$0aa9e770fdcc2607$var$node.hash = "60408e64e95523cddd0fb83ab25da2c7";
var $0aa9e770fdcc2607$export$2e2bcd8739ae039 = $0aa9e770fdcc2607$var$node;
module.exports["default"] = $0aa9e770fdcc2607$export$2e2bcd8739ae039;

});

parcelRegister("8V29N", function(module, exports) {
/**
 * @generated SignedSource<<48c3cb0e36aee912af28e271da738a53>>
 * @relayHash dc259a2e51a1b01648a5dcdfa8b8904f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9164e05993bece776e7f69fa933f1d4c717c8c04a05c0017bd93c6332bf95fd6
const $f7bc745188f2b8be$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "updateWorkflowApplicationRequestInput"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "updateWorkflowApplicationRequestInput",
            "variableName": "updateWorkflowApplicationRequestInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ApprovalsContextUpdateWorkflowApplicationMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_updateWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ApprovalsContextUpdateWorkflowApplicationMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_updateWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "dc259a2e51a1b01648a5dcdfa8b8904f",
            "id": "9164e05993bece776e7f69fa933f1d4c717c8c04a05c0017bd93c6332bf95fd6",
            "metadata": {},
            "name": "ApprovalsContextUpdateWorkflowApplicationMutation",
            "operationKind": "mutation",
            "text": "mutation ApprovalsContextUpdateWorkflowApplicationMutation($cloudId:ID!,$updateWorkflowApplicationRequestInput:ConfluenceUpdateWorkflowApplicationRequestInput!){confluence_updateWorkflowApplication(cloudId:$cloudId,updateWorkflowApplicationRequestInput:$updateWorkflowApplicationRequestInput){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$f7bc745188f2b8be$var$node.hash = "cc3c6f7f13981af43e98d2ff646b92b8";
var $f7bc745188f2b8be$export$2e2bcd8739ae039 = $f7bc745188f2b8be$var$node;
module.exports["default"] = $f7bc745188f2b8be$export$2e2bcd8739ae039;

});

parcelRegister("l5Ac1", function(module, exports) {
/**
 * @generated SignedSource<<09fe912fa9a6d38ad229a1d9b0a841a0>>
 * @relayHash dcc67a3c302bf1451aa072fa5b312aec
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 43f604e8c261aebb7a014bc621255865be5532c76b95bb916a3188eab46880eb
const $8c79d69cd01688c2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "createContentApprovalRequestInput"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "createContentApprovalRequestInput",
            "variableName": "createContentApprovalRequestInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "isPrimary"
        },
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v8 = {
        "concreteType": "ConfluenceWorkflowReview",
        "kind": "LinkedField",
        "name": "contentApproval",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "workflowApplicationId"
            },
            {
                "kind": "ScalarField",
                "name": "reviewStatus"
            },
            {
                "kind": "ScalarField",
                "name": "comment"
            },
            {
                "concreteType": "ConfluenceWorkflowReviewer",
                "kind": "LinkedField",
                "name": "reviewers",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "principalType"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "principalId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isRequired"
                    },
                    {
                        "concreteType": "AtlassianUser",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v6 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "displayName"
                            },
                            {
                                "concreteType": "AtlassianUserPhoto",
                                "kind": "LinkedField",
                                "name": "photos",
                                "plural": true,
                                "selections": v7 /*: any*/ 
                            },
                            {
                                "concreteType": "AtlassianUserEmail",
                                "kind": "LinkedField",
                                "name": "emails",
                                "plural": true,
                                "selections": v7 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ApprovalsContextCreateWorkflowReviewMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceContentApprovalPayload",
                    "kind": "LinkedField",
                    "name": "confluence_createContentApproval",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v8 /*: any*/ 
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ApprovalsContextCreateWorkflowReviewMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceContentApprovalPayload",
                    "kind": "LinkedField",
                    "name": "confluence_createContentApproval",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v6 /*: any*/ 
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        },
                        v8 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "dcc67a3c302bf1451aa072fa5b312aec",
            "id": "43f604e8c261aebb7a014bc621255865be5532c76b95bb916a3188eab46880eb",
            "metadata": {},
            "name": "ApprovalsContextCreateWorkflowReviewMutation",
            "operationKind": "mutation",
            "text": "mutation ApprovalsContextCreateWorkflowReviewMutation($cloudId:ID!,$createContentApprovalRequestInput:ConfluenceCreateContentApprovalRequestInput!){confluence_createContentApproval(cloudId:$cloudId,createContentApprovalRequestInput:$createContentApprovalRequestInput){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},contentApproval{id,workflowApplicationId,reviewStatus,comment,reviewers{principalType,principalId,isRequired,user{id,displayName,photos{isPrimary,value},emails{isPrimary,value}}}}}}"
        }
    };
}();
$8c79d69cd01688c2$var$node.hash = "7aac889eeb2c9a4140e4c54a84dd5a22";
var $8c79d69cd01688c2$export$2e2bcd8739ae039 = $8c79d69cd01688c2$var$node;
module.exports["default"] = $8c79d69cd01688c2$export$2e2bcd8739ae039;

});

parcelRegister("dzmR0", function(module, exports) {
/**
 * @generated SignedSource<<4f765a92a66efbde7d5dde6237fa23f0>>
 * @relayHash 1e9445150784f0b413d2dfb9d66ed41b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ed205a119d56079a8af470bc8da947b40a588f347acb2d591ba9e50a0228a7ab
const $2c0c245b53785143$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "createWorkflowApplicationRequestInput"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "createWorkflowApplicationRequestInput",
            "variableName": "createWorkflowApplicationRequestInput"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = [
        v6 /*: any*/ 
    ], v8 = {
        "concreteType": "ConfluenceWorkflowApplicationDetails",
        "kind": "LinkedField",
        "name": "workflowApplication",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v9 = {
        "concreteType": "ConfluenceApprovalsWorkflowStatus",
        "kind": "LinkedField",
        "name": "workflowStatus",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "allowsReviews"
            },
            {
                "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
                "kind": "LinkedField",
                "name": "displayProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "description"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "icon"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ApprovalsContextCreateWorkflowApplicationMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_createWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v8 /*: any*/ ,
                        v9 /*: any*/ 
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ApprovalsContextCreateWorkflowApplicationMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_createWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v7 /*: any*/ ,
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        },
                        v8 /*: any*/ ,
                        v9 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "1e9445150784f0b413d2dfb9d66ed41b",
            "id": "ed205a119d56079a8af470bc8da947b40a588f347acb2d591ba9e50a0228a7ab",
            "metadata": {},
            "name": "ApprovalsContextCreateWorkflowApplicationMutation",
            "operationKind": "mutation",
            "text": "mutation ApprovalsContextCreateWorkflowApplicationMutation($cloudId:ID!,$createWorkflowApplicationRequestInput:ConfluenceCreateWorkflowApplicationRequestInput!){confluence_createWorkflowApplication(cloudId:$cloudId,createWorkflowApplicationRequestInput:$createWorkflowApplicationRequestInput){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowApplication{id},workflowStatus{id,allowsReviews,displayProperties{name,description,color,icon}}}}"
        }
    };
}();
$2c0c245b53785143$var$node.hash = "3ee5dcab7b3bf9faa65315741af6e60b";
var $2c0c245b53785143$export$2e2bcd8739ae039 = $2c0c245b53785143$var$node;
module.exports["default"] = $2c0c245b53785143$export$2e2bcd8739ae039;

});

parcelRegister("2wo33", function(module, exports) {

var $cFXjQ = parcelRequire("cFXjQ");


var $9Z22p = parcelRequire("9Z22p");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");


var $63cta = parcelRequire("63cta");


var $5rZJf = parcelRequire("5rZJf");

const $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    const permittedOperations = operationCheckResult?.content?.nodes?.[0]?.operations ?? [];
    const targetContentType = !!contentType ? contentType : operationCheckResult?.content?.nodes?.[0]?.type;
    if (!targetContentType) return false;
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === targetContentType);
};
const $fec7e6ab8c349d98$export$9df6fd1dd45ee771 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    // prettier-ignore
    const permittedOperations = operationCheckResult?.space?.operations ?? [];
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === contentType);
};
const $fec7e6ab8c349d98$export$e1260b60fe3f2784 = async ({ contentId: contentId, operation: operation, contentType: contentType })=>{
    const contentOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $63cta.ContentOperationsQuery),
        variables: {
            contentId: contentId
        },
        __callerPackage__: "entity-operations"
    });
    return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: contentOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$bcbdef0ac5f1ac47 = async ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const spaceOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $5rZJf.SpaceOperationsQuery),
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "entity-operations"
    });
    return $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: spaceOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$301dbe403ac05dd5 = ({ contentId: contentId, operation: operation, contentType: contentType, status: status })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $9Z22p.default), {
        variables: {
            contentId: contentId,
            status: status
        },
        skip: !contentId,
        __callerPackage__: "entity-operations"
    });
    if (!contentId) return false;
    if (graphQLResult?.data) return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return undefined;
};
const $fec7e6ab8c349d98$export$1fefcc1c89f32022 = ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $cFXjQ.default), {
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "entity-operations"
    });
    // Only show the publish button if the user has permission to update (edit) this content.
    let canPerformOperation = undefined;
    if (graphQLResult?.data) canPerformOperation = $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return [
        canPerformOperation,
        graphQLResult
    ];
};
module.exports["canPerformSpaceOperation"] = $fec7e6ab8c349d98$export$9df6fd1dd45ee771;
module.exports["useCanPerformContentOperation"] = $fec7e6ab8c349d98$export$301dbe403ac05dd5;
module.exports["useCanPerformSpaceOperation"] = $fec7e6ab8c349d98$export$1fefcc1c89f32022;

});

parcelRegister("cFXjQ", function(module, exports) {
/**
 * @generated SignedSource<<247131d79908e150d144b65bd18338c4>>
 * @relayHash 66373ccec9c74286b704fa866e6f85ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b
const $718578d961a6d231$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "66373ccec9c74286b704fa866e6f85ed",
            "id": "1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b",
            "metadata": {},
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersSpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$718578d961a6d231$var$node.hash = "cc953c6fb5811bde7a3b5ed25712839f";
var $718578d961a6d231$export$2e2bcd8739ae039 = $718578d961a6d231$var$node;
module.exports["default"] = $718578d961a6d231$export$2e2bcd8739ae039;

});

parcelRegister("9Z22p", function(module, exports) {
/**
 * @generated SignedSource<<a98ec14c52d173566241d54d72eed0e4>>
 * @relayHash 74ad4c4ef681c6629c8477bfc21dc6ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58
const $16467728a654d6f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "74ad4c4ef681c6629c8477bfc21dc6ca",
            "id": "e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58",
            "metadata": {},
            "name": "entityOperationsHelpersContentOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$16467728a654d6f6$var$node.hash = "a2091cf4018c51963a252c5d39ee0cbc";
var $16467728a654d6f6$export$2e2bcd8739ae039 = $16467728a654d6f6$var$node;
module.exports["default"] = $16467728a654d6f6$export$2e2bcd8739ae039;

});

parcelRegister("63cta", function(module, exports) {

var $8r0lJ = parcelRequire("8r0lJ");

const $bc89d0f4a052c761$export$a42cd9ccc4f06e9e = (0, $8r0lJ.default);
module.exports["ContentOperationsQuery"] = $bc89d0f4a052c761$export$a42cd9ccc4f06e9e;

});

parcelRegister("8r0lJ", function(module, exports) {
/**
 * @generated SignedSource<<8e9cb6fd76c3c39141d1214b5e844944>>
 * @relayHash afd2c148a694798349dbf7c95e9faf5e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a
const $9494deed8cae7257$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "afd2c148a694798349dbf7c95e9faf5e",
            "id": "e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a",
            "metadata": {},
            "name": "ContentOperationsQuery",
            "operationKind": "query",
            "text": "query ContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$9494deed8cae7257$var$node.hash = "ab356c29a3f1071c83869406e4056f82";
var $9494deed8cae7257$export$2e2bcd8739ae039 = $9494deed8cae7257$var$node;
module.exports["default"] = $9494deed8cae7257$export$2e2bcd8739ae039;

});

parcelRegister("5rZJf", function(module, exports) {

var $3QLqz = parcelRequire("3QLqz");

const $8e7057c5d2ae7999$export$636a01496687d185 = (0, $3QLqz.default);
module.exports["SpaceOperationsQuery"] = $8e7057c5d2ae7999$export$636a01496687d185;

});

parcelRegister("3QLqz", function(module, exports) {
/**
 * @generated SignedSource<<c3ea92623b4eef102f52ae11931592ca>>
 * @relayHash 5ff0445d5306228126745d8454e82696
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6
const $5b7055a8a77b29df$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5ff0445d5306228126745d8454e82696",
            "id": "b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6",
            "metadata": {},
            "name": "SpaceOperationsQuery",
            "operationKind": "query",
            "text": "query SpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$5b7055a8a77b29df$var$node.hash = "c0226693d03f6d30e3056758ad9ba59d";
var $5b7055a8a77b29df$export$2e2bcd8739ae039 = $5b7055a8a77b29df$var$node;
module.exports["default"] = $5b7055a8a77b29df$export$2e2bcd8739ae039;

});

parcelRegister("lfBMY", function(module, exports) {
var $93e6e1e47a4562a8$export$64e79c67b77e1326 = /*#__PURE__*/ function(OperationTypes) {
    OperationTypes["USE"] = "use";
    OperationTypes["LIMITED_USE"] = "limited_use";
    OperationTypes["EXTERNAL_COLLABORATOR_USE"] = "external_collaborator_use";
    OperationTypes["CREATE"] = "create";
    OperationTypes["READ"] = "read";
    OperationTypes["UPDATE"] = "update";
    OperationTypes["DELETE"] = "delete";
    OperationTypes["COPY"] = "copy";
    OperationTypes["MOVE"] = "move";
    OperationTypes["EXPORT"] = "export";
    OperationTypes["ARCHIVE"] = "archive";
    OperationTypes["PURGE"] = "purge";
    OperationTypes["PURGE_VERSION"] = "purge_version";
    OperationTypes["ADMINISTER"] = "administer";
    OperationTypes["RESTORE"] = "restore";
    OperationTypes["CREATE_SPACE"] = "create_space";
    OperationTypes["RESTRICT_CONTENT"] = "restrict_content";
    OperationTypes["CLEAR_PERMISSIONS"] = "clear_permissions";
    return OperationTypes;
}({});
module.exports["OperationTypes"] = $93e6e1e47a4562a8$export$64e79c67b77e1326;

});

parcelRegister("jln20", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");


var $lRhY3 = parcelRequire("lRhY3");


var $87whh = parcelRequire("87whh");


var $aWwYt = parcelRequire("aWwYt");

function $8facebd0ecb5e0ee$export$909966f260e2b2b({ sidebars: sidebars, setSidebars: setSidebars, triggerButtonRef: triggerButtonRef, setTriggerButtonRef: setTriggerButtonRef, hideObjectSidebar: hideObjectSidebar, hidePreviewPanel: hidePreviewPanel, isPreviewPanelOpen: isPreviewPanelOpen }) {
    const entries = sidebars.map((s, i)=>[
            s.panelId,
            i
        ]);
    const index = entries.reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
    return {
        sidebars: sidebars,
        open: (panelId, width, isMinimized = false, toTop = true)=>{
            hideObjectSidebar();
            if (isPreviewPanelOpen) hidePreviewPanel();
            const newSidebars = Array.from(sidebars);
            if (panelId in index) newSidebars.splice(index[panelId], 1);
            (toTop ? Array.prototype.unshift : Array.prototype.push).call(newSidebars, {
                panelId: panelId,
                width: width,
                isCollapsed: false,
                isMinimized: isMinimized
            });
            setSidebars(newSidebars);
        },
        close: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars.splice(idx, 1);
                setSidebars(newSidebars);
            }
        },
        closeAll: ()=>{
            setSidebars([]);
        },
        minimize: (panelId)=>{
            const idx = index[panelId];
            if (idx >= 0) {
                const newSidebars = Array.from(sidebars);
                newSidebars[idx].isMinimized = true;
                setSidebars(newSidebars);
            }
        },
        getCurrent: ()=>{
            const idx = $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars);
            return idx >= 0 ? sidebars[idx] : null;
        },
        triggerButtonRef: triggerButtonRef,
        setTriggerButtonRef: setTriggerButtonRef
    };
}
function $8facebd0ecb5e0ee$var$currentSidebarIndex(sidebars) {
    if (sidebars.length === 1) return 0;
    return sidebars.findIndex((s)=>!s.isCollapsed && !s.isMinimized);
}
const $8facebd0ecb5e0ee$export$409021d56647e6f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    sidebars: [],
    open: ()=>{},
    close: ()=>{},
    closeCurrent: ()=>{},
    closeAll: ()=>{},
    minimize: ()=>{},
    getCurrent: ()=>null,
    triggerButtonRef: null,
    setTriggerButtonRef: ()=>{}
});
const $8facebd0ecb5e0ee$export$8c38c254c6602904 = ()=>{
    return (0, $cozmU.useContext)($8facebd0ecb5e0ee$export$409021d56647e6f);
};
const $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [sidebars, setSidebars] = (0, $cozmU.useState)(t1);
    const [triggerButtonRef, setTriggerButtonRef] = (0, $cozmU.useState)(null);
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { close: hidePreviewPanel } = (0, $lRhY3.usePreviewPanelsActions)();
    const isPreviewPanelOpen = (0, $87whh.useIsPreviewPanelOpen)();
    let t2;
    if ($[1] !== hideObjectSidebar || $[2] !== hidePreviewPanel || $[3] !== isPreviewPanelOpen || $[4] !== sidebars || $[5] !== triggerButtonRef) {
        t2 = $8facebd0ecb5e0ee$export$909966f260e2b2b({
            sidebars: sidebars,
            setSidebars: setSidebars,
            triggerButtonRef: triggerButtonRef,
            setTriggerButtonRef: setTriggerButtonRef,
            hideObjectSidebar: hideObjectSidebar,
            hidePreviewPanel: hidePreviewPanel,
            isPreviewPanelOpen: isPreviewPanelOpen
        });
        $[1] = hideObjectSidebar;
        $[2] = hidePreviewPanel;
        $[3] = isPreviewPanelOpen;
        $[4] = sidebars;
        $[5] = triggerButtonRef;
        $[6] = t2;
    } else t2 = $[6];
    const contextValue = t2;
    let t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const handleCloseGlobalSidebar = ()=>{
                if ((0, $9wGTI.fg)("forge-ui-fix-forge-confluence-mainlayout-rerender")) setSidebars($8facebd0ecb5e0ee$var$_temp);
                else setSidebars([]);
            };
            window.addEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            return ()=>{
                window.removeEventListener("closeGlobalSidebar", handleCloseGlobalSidebar);
            };
        };
        t4 = [];
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[9] !== children || $[10] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8facebd0ecb5e0ee$export$409021d56647e6f.Provider, {
            value: contextValue
        }, children);
        $[9] = children;
        $[10] = contextValue;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
function $8facebd0ecb5e0ee$var$_temp(prev) {
    return prev.length === 0 ? prev : [];
}
module.exports["useRightSidebarContext"] = $8facebd0ecb5e0ee$export$8c38c254c6602904;
module.exports["RightSidebarContextProvider"] = $8facebd0ecb5e0ee$export$7fac9ec6ea44ff1f;

});

parcelRegister("87whh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $3Ap09 = parcelRequire("3Ap09");

const $5fad2268a70a3d3b$export$c68e55e6e77f3d5d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (panelId)=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
} : (panelId)=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
module.exports["useIsPreviewPanelOpen"] = $5fad2268a70a3d3b$export$c68e55e6e77f3d5d;

});

parcelRegister("i9VoI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6UYek = parcelRequire("6UYek");

const $357775eda04c1a81$export$63ba9f3f1b368ae8 = ({ onDataReceived: onDataReceived, skip: skip = false, contentId: contentId, contentType: contentType, delta: delta, subscriberId: subscriberId })=>{
    const dispatch = (0, $6UYek.useSubscriptionsDispatchContext)();
    const { setContentId: setContentId, setContentType: setContentType, removeSubscriber: removeSubscriber, addSubscriber: addSubscriber } = dispatch || {};
    (0, $cozmU.useEffect)(()=>{
        if (skip || !addSubscriber || !contentId || !contentType || !removeSubscriber) return;
        setContentId?.(contentId);
        setContentType?.(contentType);
        const uniqueSubscriberId = addSubscriber({
            delta: delta,
            subscriberId: subscriberId,
            onSubscriptionData: onDataReceived
        });
        return ()=>{
            removeSubscriber({
                delta: delta,
                subscriberId: uniqueSubscriberId
            });
        };
    }, [
        skip,
        dispatch,
        contentId,
        contentType,
        setContentId,
        setContentType,
        addSubscriber,
        removeSubscriber,
        subscriberId,
        delta,
        onDataReceived
    ]);
    return null;
};
module.exports["useSubscriptionEvent"] = $357775eda04c1a81$export$63ba9f3f1b368ae8;

});

parcelRegister("3Xs1I", function(module, exports) {

var $1SNEF = parcelRequire("1SNEF");

const $cf20926a3ed5ce71$export$b107cc869756fe73 = (reloaderProps)=>{
    (0, $1SNEF.useQuickReloadSubscriber)(reloaderProps);
    return null;
};
module.exports["QuickReloadSubscriber"] = $cf20926a3ed5ce71$export$b107cc869756fe73;

});

parcelRegister("1SNEF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $c0urc = parcelRequire("c0urc");

const $511608ca1b2c45b1$export$2f94e407b6c7d69d = (reloader)=>{
    const { contentId: contentId, registerReloader: registerReloader, unregisterReloader: unregisterReloader } = (0, $cozmU.useContext)((0, $c0urc.QuickReloadContext));
    (0, $cozmU.useEffect)(()=>{
        registerReloader(reloader);
        return ()=>{
            unregisterReloader(reloader);
        };
    // NOTE: these are only dependencies of this effect
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        reloader.name
    ]);
};
module.exports["useQuickReloadSubscriber"] = $511608ca1b2c45b1$export$2f94e407b6c7d69d;

});

parcelRegister("lKfPX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7aRa9 = parcelRequire("7aRa9");


var $jln20 = parcelRequire("jln20");


var $laFNM = parcelRequire("laFNM");


var $1vpkQ = parcelRequire("1vpkQ");

const $bc82d16866a75c79$var$SOURCE_CONFLUENCE_APPROVALS_PARAM = 'source_confluence_approvals';
const $bc82d16866a75c79$var$i18n = (0, $kSwu1.defineMessages)({
    alreadyApprovedTitle: {
        id: "approvals.flag.already-approved.title",
        defaultMessage: "You've already approved this page"
    },
    alreadyRequestedChangesTitle: {
        id: "approvals.flag.already-requested-changes.title",
        defaultMessage: "You've already requested changes on this page"
    },
    changeDecisionAction: {
        id: "approvals.flag.already-responded.change-decision",
        defaultMessage: "Change your decision"
    },
    approvalUnavailableTitle: {
        id: "approvals.flag.approval-unavailable.title",
        defaultMessage: "This approval request is no longer available"
    },
    approvalUnavailableDescription: {
        id: "approvals.flag.approval-unavailable.description",
        defaultMessage: "It may have been deleted."
    }
});
const $bc82d16866a75c79$var$removeSourceConfluenceApprovalsParam = ()=>{
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.delete($bc82d16866a75c79$var$SOURCE_CONFLUENCE_APPROVALS_PARAM);
    const newSearch = urlParams.size > 0 ? `?${urlParams.toString()}` : '';
    const newUrl = `${window.location.pathname}${newSearch}${window.location.hash}`;
    window.history.replaceState({}, '', newUrl);
};
const $bc82d16866a75c79$var$ApprovalCtaFlagComponent = ({ flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { approvalRequestLoading: approvalRequestLoading, isCurrentUserApprover: isCurrentUserApprover, currentUserApprover: currentUserApprover, approvalRequest: approvalRequest, contentId: contentId, contentStatus: contentStatus } = (0, $laFNM.useApprovals)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const openApprovalsPane = (0, $cozmU.useCallback)(()=>{
        (0, $1vpkQ.openApprovalsPaneForContext)({
            contentId: contentId,
            contentStatus: contentStatus,
            rightSidebarContext: rightSidebarContext
        });
    }, [
        contentId,
        contentStatus,
        rightSidebarContext
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (approvalRequestLoading) return;
        const urlParams = new URLSearchParams(window.location.search);
        const isFromApprovalsCta = urlParams.has($bc82d16866a75c79$var$SOURCE_CONFLUENCE_APPROVALS_PARAM);
        if (!isFromApprovalsCta) return;
        $bc82d16866a75c79$var$removeSourceConfluenceApprovalsParam();
        let state = 'none';
        if (!isCurrentUserApprover) state = 'unavailable';
        else if (currentUserApprover && currentUserApprover.status !== 'PENDING_REVIEW') state = 'already-responded';
        if (state === 'unavailable') {
            flags.showWarningFlag({
                title: formatMessage($bc82d16866a75c79$var$i18n.approvalUnavailableTitle),
                description: formatMessage($bc82d16866a75c79$var$i18n.approvalUnavailableDescription),
                isAutoDismiss: true
            });
            return;
        }
        if (state === 'already-responded' && currentUserApprover) {
            const isApprovalInProgress = approvalRequest?.review?.reviewStatus === 'PENDING';
            const title = currentUserApprover.status === 'REVIEWER_APPROVED' ? formatMessage($bc82d16866a75c79$var$i18n.alreadyApprovedTitle) : formatMessage($bc82d16866a75c79$var$i18n.alreadyRequestedChangesTitle);
            flags.showInfoFlag({
                title: title,
                isAutoDismiss: true,
                ...isApprovalInProgress && {
                    actions: [
                        {
                            content: formatMessage($bc82d16866a75c79$var$i18n.changeDecisionAction),
                            onClick: openApprovalsPane
                        }
                    ]
                }
            });
        }
    }, [
        approvalRequestLoading,
        isCurrentUserApprover,
        currentUserApprover,
        approvalRequest,
        flags,
        formatMessage,
        openApprovalsPane
    ]);
    return null;
};
const $bc82d16866a75c79$export$34defb28b3191b49 = (0, $7aRa9.withFlags)($bc82d16866a75c79$var$ApprovalCtaFlagComponent);
module.exports["ApprovalCtaFlag"] = $bc82d16866a75c79$export$34defb28b3191b49;

});

parcelRegister("kWNKJ", function(module, exports) {
const $ee796f8cd4c67c5a$var$DUE_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
const $ee796f8cd4c67c5a$var$parseDateOnlyParts = (dateOnly)=>{
    if (!$ee796f8cd4c67c5a$var$DUE_DATE_PATTERN.test(dateOnly)) return null;
    const [yearText, monthText, dayText] = dateOnly.split('-');
    const year = Number(yearText);
    const month = Number(monthText);
    const day = Number(dayText);
    const date = new Date(Date.UTC(year, month - 1, day));
    if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return null;
    return {
        year: year,
        month: month,
        day: day
    };
};
const $ee796f8cd4c67c5a$export$fc6c2280cb790cc8 = (date = new Date())=>{
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};
const $ee796f8cd4c67c5a$export$b07a58925d8eab51 = (dateOnly, todayDateOnly = $ee796f8cd4c67c5a$export$fc6c2280cb790cc8())=>{
    if (dateOnly === '') return 'valid';
    if (!$ee796f8cd4c67c5a$var$parseDateOnlyParts(dateOnly)) return 'invalid';
    return dateOnly < todayDateOnly ? 'past' : 'valid';
};
const $ee796f8cd4c67c5a$export$1dede1071256c7ab = (dateOnly)=>`${dateOnly}T00:00:00Z`;
const $ee796f8cd4c67c5a$export$bf7132afcf8b3081 = (epochMillis)=>{
    const millis = Number(epochMillis);
    if (!Number.isFinite(millis)) return null;
    const date = new Date(millis);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};
const $ee796f8cd4c67c5a$export$42719bbbada85ca6 = (dateOnly)=>{
    const parts = $ee796f8cd4c67c5a$var$parseDateOnlyParts(dateOnly);
    if (!parts) return null;
    return new Date(Date.UTC(parts.year, parts.month - 1, parts.day, 12));
};
const $ee796f8cd4c67c5a$export$15ef3e5b99fff21b = (dateOnly, todayDateOnly = $ee796f8cd4c67c5a$export$fc6c2280cb790cc8())=>$ee796f8cd4c67c5a$export$b07a58925d8eab51(dateOnly, todayDateOnly) === 'past';
module.exports["getLocalDateOnly"] = $ee796f8cd4c67c5a$export$fc6c2280cb790cc8;
module.exports["validateDueDate"] = $ee796f8cd4c67c5a$export$b07a58925d8eab51;
module.exports["encodeDueDateForMutation"] = $ee796f8cd4c67c5a$export$1dede1071256c7ab;
module.exports["extractDateOnlyFromUtcEpochMillis"] = $ee796f8cd4c67c5a$export$bf7132afcf8b3081;
module.exports["getNoonUtcDateFromDateOnly"] = $ee796f8cd4c67c5a$export$42719bbbada85ca6;
module.exports["isDueDateOverdue"] = $ee796f8cd4c67c5a$export$15ef3e5b99fff21b;

});

parcelRegister("kLSdN", function(module, exports) {
/**
 * Tiny persistence helper for the "live doc → page" approval conversion intent.
 *
 * Why this lives in @confluence/approvals
 * ---------------------------------------
 * The intent expresses a fact about an approval lifecycle: "the user wanted to start an
 * approval but the source was a live doc, so we asked them to convert first". Approvals consumes
 * the intent after redirect, and @confluence/publish-modal sets it only after the user confirms
 * the convert-to-page publish path. Both @confluence/content-state and @confluence/publish-modal
 * already depend on @confluence/approvals, so colocating the helper here adds zero new package
 * edges and avoids the circular dependency that PR #377980 ran into when content-state tried to
 * imperatively call into publish-modal.
 *
 * Why sessionStorage
 * ------------------
 * The convert-to-page publish flow causes a full navigation to the newly-published page, so
 * any in-memory React state is lost. We need the intent to survive that single redirect so
 * the destination page's ApprovalsProvider can auto-open the approvals pane. sessionStorage
 * is scoped to the tab, so stale intents naturally expire when the tab closes.
 *
 * Why an in-memory mirror
 * -----------------------
 * When the `confluence_browser_storage_controls` gate is on, the underlying storage instance
 * delegates writes to `AtlBrowserStorageSession.setItem`, which is async — it awaits an
 * IndexedDB consent check before persisting. A synchronous read immediately after a write
 * can therefore return null. The in-memory cache provides a synchronous read for the same
 * tab; sessionStorage is consulted only on first read after a fresh page load (i.e. after
 * the redirect, when the in-memory variable has been reset).
 *
 * Feature-gate kill switch
 * ------------------------
 * The setter is the only entry point that writes anything. Callers MUST gate the setter behind
 * `expValEquals('confluence_approvals_eap', 'isEnabled', true)` before calling. With the gate off, nothing is ever set, so
 * the auto-open effects in `ApprovalsProvider` and `PublishModalMountPoint` (which also
 * gate-first) are no-ops and the feature is fully dormant.
 */ 
var $17wUi = parcelRequire("17wUi");

const $b3e3645d3c163dd5$export$b2a7df7f03827f26 = 'confluence.approvals.liveDoc.redirect';
/** Intents older than this are discarded on read if the publish flow never completed cleanly. */ const $b3e3645d3c163dd5$var$INTENT_TTL_MS = 1800000;
let $b3e3645d3c163dd5$var$inMemoryRedirectIntent = null;
const $b3e3645d3c163dd5$export$ef89414a70fb495 = ({ contentId: contentId })=>{
    const intent = {
        contentId: contentId,
        createdAt: Date.now()
    };
    $b3e3645d3c163dd5$var$inMemoryRedirectIntent = intent;
    (0, $17wUi.confluenceSessionStorageInstance).setItem($b3e3645d3c163dd5$export$b2a7df7f03827f26, JSON.stringify(intent));
};
const $b3e3645d3c163dd5$var$isIntentExpired = (intent)=>Date.now() - intent.createdAt > $b3e3645d3c163dd5$var$INTENT_TTL_MS;
const $b3e3645d3c163dd5$export$187a97295c2c958f = ()=>{
    if ($b3e3645d3c163dd5$var$inMemoryRedirectIntent) {
        if ($b3e3645d3c163dd5$var$isIntentExpired($b3e3645d3c163dd5$var$inMemoryRedirectIntent)) {
            $b3e3645d3c163dd5$export$cbaad3c266777d3a();
            return null;
        }
        return $b3e3645d3c163dd5$var$inMemoryRedirectIntent;
    }
    const storedValue = (0, $17wUi.confluenceSessionStorageInstance).getItem($b3e3645d3c163dd5$export$b2a7df7f03827f26);
    if (!storedValue) return null;
    try {
        const parsed = JSON.parse(storedValue);
        if (typeof parsed.contentId !== 'string' || typeof parsed.createdAt !== 'number') return null;
        const intent = {
            contentId: parsed.contentId,
            createdAt: parsed.createdAt
        };
        if ($b3e3645d3c163dd5$var$isIntentExpired(intent)) {
            $b3e3645d3c163dd5$export$cbaad3c266777d3a();
            return null;
        }
        $b3e3645d3c163dd5$var$inMemoryRedirectIntent = intent;
        return intent;
    } catch  {
        return null;
    }
};
const $b3e3645d3c163dd5$export$cbaad3c266777d3a = ()=>{
    $b3e3645d3c163dd5$var$inMemoryRedirectIntent = null;
    (0, $17wUi.confluenceSessionStorageInstance).removeItem($b3e3645d3c163dd5$export$b2a7df7f03827f26);
};
const $b3e3645d3c163dd5$export$ed79ee0498d59617 = ()=>{
    const intent = $b3e3645d3c163dd5$export$187a97295c2c958f();
    if (intent) $b3e3645d3c163dd5$export$cbaad3c266777d3a();
    return intent;
};
module.exports["setLiveDocApprovalRedirectIntent"] = $b3e3645d3c163dd5$export$ef89414a70fb495;
module.exports["consumeLiveDocApprovalRedirectIntent"] = $b3e3645d3c163dd5$export$ed79ee0498d59617;

});

parcelRegister("bAGpj", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dcoGt = parcelRequire("dcoGt");


var $cZa7r = parcelRequire("cZa7r");


var $9wGTI = parcelRequire("9wGTI");


var $dANtQ = parcelRequire("dANtQ");


var $ep3mz = parcelRequire("ep3mz");


var $9zMAu = parcelRequire("9zMAu");


var $ikqOG = parcelRequire("ikqOG");

const $16e040c4263f7228$export$665978abdb00663c = ({ pageId: pageId, editorActions: editorActions, triggerAnalyticsEvent: triggerAnalyticsEvent, updateUnresolvedInlineComment: updateUnresolvedInlineComment })=>{
    const { setEditorCreateProps: setEditorCreateProps, setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const annotationManager = (0, $cZa7r.useAnnotationManager)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(pageId);
    const canAddCommentsRef = (0, $cozmU.useRef)(canAddComments);
    canAddCommentsRef.current = canAddComments;
    const getCanAddComments = (0, $cozmU.useCallback)(()=>canAddCommentsRef.current, []);
    const { reactionMarkerRefs: reactionMarkerRefs, reactionMarkerMap: reactionMarkerMap } = (0, $9zMAu.useActiveInlineData)(pageId);
    const { mergedReactionMarkerMap: mergedReactionMarkerMap, optimisticResolvedMarkerRefs: optimisticResolvedMarkerRefs } = (0, $ikqOG.useInlineReactionMarkers)({
        reactionMarkerRefs: reactionMarkerRefs,
        reactionMarkerMap: reactionMarkerMap
    });
    const mergedReactionMarkerMapRef = (0, $cozmU.useRef)(mergedReactionMarkerMap);
    mergedReactionMarkerMapRef.current = mergedReactionMarkerMap;
    const getReactionMarkerMap = (0, $cozmU.useCallback)(()=>mergedReactionMarkerMapRef.current, []);
    const optimisticResolvedMarkerRefsRef = (0, $cozmU.useRef)(optimisticResolvedMarkerRefs);
    optimisticResolvedMarkerRefsRef.current = optimisticResolvedMarkerRefs;
    const getOptimisticResolvedMarkerRefs = (0, $cozmU.useCallback)(()=>optimisticResolvedMarkerRefsRef.current, []);
    return (0, $cozmU.useMemo)(()=>({
            inlineComment: (0, $dcoGt.getEditorInlineCommentOptions)({
                pageId: pageId,
                editorActions: editorActions,
                triggerAnalyticsEvent: triggerAnalyticsEvent,
                updateUnresolvedInlineComment: updateUnresolvedInlineComment,
                setEditorCreateProps: setEditorCreateProps,
                setEditorViewProps: setEditorViewProps,
                editorAnnotationProviderManagersEnabled: (0, $9wGTI.fg)('confluence_frontend_editor_annotation_manager'),
                getCanAddComments: getCanAddComments,
                contentType: contentType,
                getReactionMarkerMap: getReactionMarkerMap,
                getOptimisticResolvedMarkerRefs: getOptimisticResolvedMarkerRefs
            }),
            annotationManager: annotationManager
        }), [
        pageId,
        triggerAnalyticsEvent,
        editorActions,
        updateUnresolvedInlineComment,
        setEditorCreateProps,
        setEditorViewProps,
        annotationManager,
        contentType,
        getCanAddComments,
        getReactionMarkerMap,
        getOptimisticResolvedMarkerRefs
    ]);
};
module.exports["useEditorAnnotationProviderOptions"] = $16e040c4263f7228$export$665978abdb00663c;

});

parcelRegister("dcoGt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gfqXk = parcelRequire("gfqXk");


var $hXzKU = parcelRequire("hXzKU");


var $kDIns = parcelRequire("kDIns");


var $jmjWc = parcelRequire("jmjWc");


var $fS1ba = parcelRequire("fS1ba");


var $gYgF0 = parcelRequire("gYgF0");


const $74da12b96ee2cb30$var$CreateComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "lDg6H",
    name: "CreateComponent",
    loader: async ()=>(await Promise.resolve((parcelRequire("4tTm9")))).CreateComponent
});

const $74da12b96ee2cb30$var$ViewComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "bZUjL",
    name: "ViewComponent",
    loader: async ()=>(await Promise.resolve((parcelRequire("3omFm")))).ViewComponent
});
const $74da12b96ee2cb30$var$ViewComponentMemoized = ({ pageId: pageId, editorActions: editorActions, getReactionMarkerMap: getReactionMarkerMap })=>/*#__PURE__*/ (0, $cozmU.memo)((props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($74da12b96ee2cb30$var$ViewComponent, {
            pageId: pageId,
            editorActions: editorActions,
            ...props,
            reactionMarkerMap: getReactionMarkerMap?.()
        });
    });
const $74da12b96ee2cb30$var$CreateComponentMemoized = ({ pageId: pageId })=>/*#__PURE__*/ (0, $cozmU.memo)((props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($74da12b96ee2cb30$var$CreateComponent, {
            pageId: pageId,
            ...props
        });
    });
const $74da12b96ee2cb30$export$e453b02e89d48d2b = ({ pageId: pageId, editorActions: editorActions, triggerAnalyticsEvent: triggerAnalyticsEvent, updateUnresolvedInlineComment: updateUnresolvedInlineComment, editorAnnotationProviderManagersEnabled: editorAnnotationProviderManagersEnabled, getCanAddComments: getCanAddComments, contentType: contentType, getReactionMarkerMap: getReactionMarkerMap, getOptimisticResolvedMarkerRefs: getOptimisticResolvedMarkerRefs })=>{
    let updateSubscriber = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    if (!updateSubscriber?.off) updateSubscriber = null;
    return {
        viewComponent: editorAnnotationProviderManagersEnabled ? (0, $fS1ba.ViewManager)({
            pageId: pageId,
            editorActions: editorActions,
            getReactionMarkerMap: getReactionMarkerMap
        }) : $74da12b96ee2cb30$var$ViewComponentMemoized({
            pageId: pageId,
            editorActions: editorActions,
            getReactionMarkerMap: getReactionMarkerMap
        }),
        createComponent: editorAnnotationProviderManagersEnabled ? (0, $gYgF0.CreateManager)({
            pageId: pageId
        }) : $74da12b96ee2cb30$var$CreateComponentMemoized({
            pageId: pageId
        }),
        getState: (annotations)=>{
            const optimisticResolvedMarkerRefs = getOptimisticResolvedMarkerRefs?.();
            return (0, $kDIns.getEditorResolvedState)({
                annotations: annotations,
                pageId: pageId,
                triggerAnalyticsEvent: triggerAnalyticsEvent,
                updateUnresolvedInlineComment: updateUnresolvedInlineComment,
                optimisticResolvedMarkerRefs: optimisticResolvedMarkerRefs
            });
        },
        updateSubscriber: updateSubscriber,
        disallowOnWhitespace: true,
        isToolbarAbove: true,
        supportedBlockNodes: [
            'media'
        ],
        onCommentButtonMount: ()=>(0, $hXzKU.LazyCommentEditor).preload(),
        getCanAddComments: getCanAddComments,
        contentType: contentType
    };
};
module.exports["getEditorInlineCommentOptions"] = $74da12b96ee2cb30$export$e453b02e89d48d2b;

});

parcelRegister("hXzKU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lfoFx = parcelRequire("lfoFx");


var $jmjWc = parcelRequire("jmjWc");


var $6mKj3 = parcelRequire("6mKj3");


var $jnVM5 = parcelRequire("jnVM5");


const $7b7af88805418522$export$b355deaeb7ea7f7c = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "2kww5",
    name: "LazyCommentEditor",
    loader: async ()=>(await (parcelRequire("48za6"))).CommentEditor,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "medium",
            interactionName: "comment-editor-loadable"
        })),
    waitForNetworkOnline: ()=>(0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
});

const $7b7af88805418522$export$301ffca6e2410600 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Pf9d2",
    name: "LazyInlineCommentEditor",
    loader: async ()=>(await (parcelRequire("48za6"))).CommentEditor,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jnVM5.LazyCommentEditorPlaceholder), null),
    waitForNetworkOnline: ()=>(0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
});

const $7b7af88805418522$export$b728c0889ff2145f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "DmrQC",
    name: "LazyCommentEditorWithoutSpinner",
    loader: async ()=>(await (parcelRequire("48za6"))).CommentEditor,
    waitForNetworkOnline: ()=>(0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
});
module.exports["LazyCommentEditor"] = $7b7af88805418522$export$b355deaeb7ea7f7c;
module.exports["LazyInlineCommentEditor"] = $7b7af88805418522$export$301ffca6e2410600;
module.exports["LazyCommentEditorWithoutSpinner"] = $7b7af88805418522$export$b728c0889ff2145f;

});

parcelRegister("jnVM5", function(module, exports) {
/* LazyCommentEditorPlaceholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8e8d5100a3bfca53$var$InputContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt41b66 _19itia51 _2rkofajl _11c8fhey _4t3i1ul9 _vchhusvi _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $8e8d5100a3bfca53$export$b85a78dfaafd1a99 = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8e8d5100a3bfca53$var$InputContainer, {
        disabled: true,
        placeholder: intl.formatMessage({
            id: "comment.reply.placeholder",
            defaultMessage: "Reply"
        })
    }));
};
module.exports["LazyCommentEditorPlaceholder"] = $8e8d5100a3bfca53$export$b85a78dfaafd1a99;

});

parcelRegister("48za6", function(module, exports) {

let $30332f329a2261b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $30332f329a2261b7$var$load("kT6dz"),
    $30332f329a2261b7$var$load("RylUf"),
    $30332f329a2261b7$var$load("gbejv"),
    $30332f329a2261b7$var$load("GD9EA"),
    $30332f329a2261b7$var$load("Kj0I8"),
    $30332f329a2261b7$var$load("5xnun"),
    $30332f329a2261b7$var$load("hUbK8"),
    $30332f329a2261b7$var$load("6wr18"),
    $30332f329a2261b7$var$load("9dRBj"),
    $30332f329a2261b7$var$load("lE3Rc"),
    $30332f329a2261b7$var$load("29yyZ"),
    $30332f329a2261b7$var$load("d0Ppk"),
    $30332f329a2261b7$var$load("HaNwW"),
    $30332f329a2261b7$var$load("9mHAG"),
    $30332f329a2261b7$var$load("7eTC9"),
    $30332f329a2261b7$var$load("iErjZ"),
    $30332f329a2261b7$var$load("agv3Q"),
    $30332f329a2261b7$var$load("garBx"),
    $30332f329a2261b7$var$load("2CrXe"),
    $30332f329a2261b7$var$load("beMmd"),
    $30332f329a2261b7$var$load("l4MHo"),
    $30332f329a2261b7$var$load("k97np"),
    $30332f329a2261b7$var$load("3cN9G"),
    $30332f329a2261b7$var$load("2J2X1"),
    $30332f329a2261b7$var$load("gvvmX"),
    $30332f329a2261b7$var$load("jgxNN"),
    $30332f329a2261b7$var$load("4RsKm"),
    $30332f329a2261b7$var$load("dZYhM"),
    $30332f329a2261b7$var$load("ig9dh"),
    $30332f329a2261b7$var$load("hA8hA"),
    $30332f329a2261b7$var$load("bpmjT"),
    $30332f329a2261b7$var$load("6cD8V"),
    $30332f329a2261b7$var$load("jzUgs"),
    $30332f329a2261b7$var$load("35X59"),
    $30332f329a2261b7$var$load("dxcsb"),
    $30332f329a2261b7$var$load("2hLAI"),
    $30332f329a2261b7$var$load("dCilB"),
    $30332f329a2261b7$var$load("1T8H1"),
    $30332f329a2261b7$var$load("fyKFO"),
    $30332f329a2261b7$var$load("d9sg7"),
    $30332f329a2261b7$var$load("l0N35"),
    $30332f329a2261b7$var$load("7gL7H"),
    $30332f329a2261b7$var$load("ekVH8"),
    $30332f329a2261b7$var$load("c1gk3"),
    $30332f329a2261b7$var$load("ffEVr"),
    $30332f329a2261b7$var$load("eCXJR"),
    $30332f329a2261b7$var$load("1VTX2"),
    $30332f329a2261b7$var$load("cHcD4"),
    $30332f329a2261b7$var$load("2m65P"),
    $30332f329a2261b7$var$load("7TnhR"),
    $30332f329a2261b7$var$load("houtd"),
    $30332f329a2261b7$var$load("ddvkk"),
    $30332f329a2261b7$var$load("3upHR"),
    $30332f329a2261b7$var$load("iUXaE"),
    $30332f329a2261b7$var$load("lTkx9"),
    $30332f329a2261b7$var$load("Wowvf"),
    $30332f329a2261b7$var$load("eRhBr"),
    $30332f329a2261b7$var$load("hZ2FX"),
    $30332f329a2261b7$var$load("7EorR"),
    $30332f329a2261b7$var$load("9ZY0g"),
    $30332f329a2261b7$var$load("hhss7"),
    $30332f329a2261b7$var$load("8Ovry")
]).then(()=>parcelRequire('3qEAL'));

});

parcelRegister("kDIns", function(module, exports) {

var $kmYOg = parcelRequire("kmYOg");


var $dOBRD = parcelRequire("dOBRD");


var $3u5lg = parcelRequire("3u5lg");


var $epbW8 = parcelRequire("epbW8");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $7W8i8 = parcelRequire("7W8i8");


var $6mKj3 = parcelRequire("6mKj3");


var $vNBpg = parcelRequire("vNBpg");


var $NYiei = parcelRequire("NYiei");


var $kgNLQ = parcelRequire("kgNLQ");


var $4L9ve = parcelRequire("4L9ve");


var $gtj7V = parcelRequire("gtj7V");


var $cD1qu = parcelRequire("cD1qu");


var $c0rhi = parcelRequire("c0rhi");

const $655a1f23a26f4e27$export$c53aa0aa4a7c5e4 = (0, $kmYOg.default);
const $655a1f23a26f4e27$export$7037a4d88a618a89 = (contentId, pageMode)=>({
        pageId: contentId,
        contentStatus: (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode),
        first: (0, $NYiei.MAX_COMMENTS_TO_RETURN)
    });
const $655a1f23a26f4e27$var$logger = (0, $7W8i8.getLogger)('inline-comments-common:state-resolver');
const $655a1f23a26f4e27$var$getPreloadAwareAnnotationsData = async ({ contentId: contentId, pageMode: pageMode })=>{
    if (!contentId) return [];
    // Check if processed comments data is available
    const processedData = (0, $4L9ve.getProcessedCommentsDataState)();
    // If data is processed, use it directly
    if (processedData.isDataProcessed) return processedData.openInlineComments;
    // Data not processed yet - fetch fresh data directly with network-only
    // This is simpler (albeit slightly slower) than preloading and guarantees fresh data
    // If we do preload in the future - keep in mind that we have to satisfy the following use cases
    // 1. We load in SSR and preload fails --> no cache data
    // 2. We load in SPA and preload hasn't completed before we check the cache value
    // 3. We load in SPA and have a stale value in the cache
    // If preloading you can also show stale data initially and refresh by manually updating annotations states
    // However if you do this, be careful for integrations w/ focused comments
    try {
        const result = await (0, $c0rhi.queryInterop)({
            query: $655a1f23a26f4e27$export$c53aa0aa4a7c5e4,
            variables: $655a1f23a26f4e27$export$7037a4d88a618a89(contentId, pageMode),
            fetchPolicy: 'network-only',
            __callerPackage__: "comments-util"
        });
        return result?.data?.comments?.nodes?.filter((node)=>node?.location) || [];
    } catch  {
        return [];
    }
};
const $655a1f23a26f4e27$export$8f0e4480674935ab = (0, $dOBRD.default)((annotations, validAnnotationsCallback, states, reactionMarkerRefs, optimisticResolvedMarkerRefs)=>{
    const rendererAnnotationMap = {};
    const annotationState = [];
    const optimisticResolvedMarkerRefSet = new Set(optimisticResolvedMarkerRefs);
    annotations.forEach((id, idx)=>{
        // this will override any repeat ids given by the Renderer
        rendererAnnotationMap[id] = idx;
        annotationState.push({
            annotationType: (0, $epbW8.AnnotationTypes).INLINE_COMMENT,
            id: id,
            state: (0, $epbW8.AnnotationMarkStates).RESOLVED
        });
    });
    states?.forEach((state)=>{
        const annotationId = state.location.inlineMarkerRef;
        const isResolved = Boolean(state.location?.inlineResolveProperties?.resolved) || (annotationId ? optimisticResolvedMarkerRefSet.has(annotationId) : false);
        // mark all unresolved annotations to be displayed by the renderer
        if (!isResolved) {
            if (annotationId) {
                const index = rendererAnnotationMap[annotationId];
                /**
         * If the BE returns an annotation that the Renderer did not
         * provide, we could error here. Also account for 0 index.
         */ if (index || index === 0) annotationState[index].state = (0, $epbW8.AnnotationMarkStates).ACTIVE;
            }
        }
    });
    // Mark inline reaction annotations as ACTIVE so they render as highlights
    reactionMarkerRefs?.forEach((markerRef)=>{
        const index = rendererAnnotationMap[markerRef];
        if ((index || index === 0) && !optimisticResolvedMarkerRefSet.has(markerRef)) annotationState[index].state = (0, $epbW8.AnnotationMarkStates).ACTIVE;
    });
    const validAnnotations = annotations.filter((annotation)=>{
        const index = rendererAnnotationMap[annotation];
        return annotationState[index].state === (0, $epbW8.AnnotationMarkStates).ACTIVE;
    });
    // Record the valid annotations to use for navigation and query params
    validAnnotationsCallback(validAnnotations);
    return annotationState;
}, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
const $655a1f23a26f4e27$export$228a0d958905d789 = (0, $dOBRD.default)((annotations, states, updateUnresolvedInlineComment, optimisticResolvedMarkerRefs)=>{
    /**
   * Build a map of annotation states with a default of true for resolved.
   * This is to accommodate deleted annotations that still exist in the ADF.
   */ const editorAnnotationMap = {};
    const annotationState = [];
    const optimisticResolvedMarkerRefSet = new Set(optimisticResolvedMarkerRefs);
    annotations.forEach((id, idx)=>{
        // this will override any repeat ids given by the Editor
        editorAnnotationMap[id] = idx;
        annotationState.push({
            annotationType: (0, $epbW8.AnnotationTypes).INLINE_COMMENT,
            id: id,
            state: {
                resolved: true
            }
        });
    });
    states.forEach((state)=>{
        const annotationId = state?.location?.inlineMarkerRef || '';
        const isResolved = Boolean(state?.location?.inlineResolveProperties?.resolved) || (annotationId ? optimisticResolvedMarkerRefSet.has(annotationId) : false);
        // mark all unresolved annotations to be displayed by the editor
        if (!isResolved) {
            const index = editorAnnotationMap[annotationId];
            /**
       * If the BE returns an annotation that the Editor did not
       * provide, we could error here. Also account for 0 index.
       */ if (index || index === 0) annotationState[index].state.resolved = false;
        }
    });
    //Ordered list of unresolved inline comments
    const unresolvedInlineComments = annotations.filter((annotationId)=>{
        const index = editorAnnotationMap[annotationId];
        if (!annotationState[index].state.resolved) return annotationId;
    });
    updateUnresolvedInlineComment(unresolvedInlineComments);
    return annotationState;
}, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
const $655a1f23a26f4e27$export$38c1ce6adefc79a5 = async ({ annotations: annotations, pageId: pageId, triggerAnalyticsEvent: triggerAnalyticsEvent, updateUnresolvedInlineComment: updateUnresolvedInlineComment, optimisticResolvedMarkerRefs: optimisticResolvedMarkerRefs })=>{
    if (!annotations.length) {
        updateUnresolvedInlineComment([]);
        return Promise.resolve([]);
    }
    try {
        let annotationStateNodes;
        // Check if we should use the new comments data manager flow
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) // NEW FLOW: Use preload-aware annotations data utility
        annotationStateNodes = await $655a1f23a26f4e27$var$getPreloadAwareAnnotationsData({
            contentId: pageId,
            pageMode: (0, $cD1qu.PageMode).LIVE // same as PageMode.EDIT for our case
        });
        else {
            // OLD FLOW: Direct GraphQL query (fallback when experiment is disabled)
            const data = await (0, $c0rhi.queryInterop)({
                query: (0, $vNBpg.AnnotationStateQuery),
                fetchPolicy: 'network-only',
                variables: {
                    pageId: pageId,
                    // @ts-ignore - Legacy contentStatus values passed before typecheck changes
                    contentStatus: [
                        'DRAFT',
                        'CURRENT'
                    ]
                },
                __callerPackage__: "comments-util"
            });
            // Filter null elements
            annotationStateNodes = data.data.comments?.nodes?.filter((node)=>node !== null);
        }
        // Common logic: map annotation state nodes to editor states
        return $655a1f23a26f4e27$export$228a0d958905d789(annotations, annotationStateNodes, updateUnresolvedInlineComment, optimisticResolvedMarkerRefs);
    } catch (error) {
        // COMMENTS-211 - When this code executes sometimes the `triggerAnalyticsEvent` is passed in as a promise
        //                this causes this call to throw an error where `.fire()` is not defined and thus the
        //                code below it which handles the various expected errors thrown to not run and thus
        //                the errors are thrown up the stack as unhandled ui errors causing a lot of noise
        try {
            if (triggerAnalyticsEvent) triggerAnalyticsEvent({
                data: {
                    source: 'editorComponent',
                    action: 'failed',
                    actionSubject: 'annotationState',
                    actionSubjectId: 'inlineComments',
                    attributes: {
                        errorName: error.name,
                        errorMessage: error.message
                    }
                },
                type: 'sendOperationalEvent'
            }).fire();
        } catch (e) {
            $655a1f23a26f4e27$var$logger.error`Error when logging analytics event, ${e}`;
        }
        if ((0, $1uFM6.isUnauthorizedError)(error) || // CEMS-1343 - Some specific pages have annotations that have a "null" id because we
        //             still informed the editor on failed creation attempts
        error?.message.includes('java.lang.NullPointerException') || // COMMENTS-211 - If we don't find any inline comments for the given markerRefList
        //               we should mark it handled and return an empty list to be consumed
        error?.message.includes('.NotFoundException')) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return [];
        } else {
            $655a1f23a26f4e27$var$logger.error`Error when retrieving resolved status for marks, ${error}`;
            throw error;
        }
    }
};
let $655a1f23a26f4e27$var$rendererAnnotationsIds;
const $655a1f23a26f4e27$export$a0fcca613dd8b2c7 = async ({ annotations: annotations, pageId: pageId, triggerAnalyticsEvent: triggerAnalyticsEvent, validAnnotationsCallback: validAnnotationsCallback, isNestedRender: isNestedRender, reactionMarkerRefs: reactionMarkerRefs, optimisticResolvedMarkerRefs: optimisticResolvedMarkerRefs })=>{
    // We need to have the page level renderer annotations
    // When the page renders the value of isNestedRender is false as per PageContentRendererFabrics
    // Later, when the macro renders isNestedRender is true
    // so, we will hold the value of annotations for the page renderer when isNestedRender is false
    if (!annotations.length) {
        validAnnotationsCallback([]);
        return Promise.resolve([]);
    }
    if (!isNestedRender) $655a1f23a26f4e27$var$rendererAnnotationsIds = annotations;
    try {
        let annotationStateNodes;
        // Check if we should use the new comments data manager flow
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) // NEW FLOW: Use preload-aware annotations data utility
        annotationStateNodes = await $655a1f23a26f4e27$var$getPreloadAwareAnnotationsData({
            contentId: pageId,
            pageMode: (0, $cD1qu.PageMode).VIEW
        });
        else {
            // OLD FLOW: Direct GraphQL query (fallback when experiment is disabled)
            const data = await (0, $c0rhi.queryInterop)({
                query: (0, $vNBpg.AnnotationStateQuery),
                fetchPolicy: isNestedRender ? 'cache-first' : 'network-only',
                variables: {
                    pageId: pageId
                },
                __callerPackage__: "comments-util"
            });
            // Filter null elements
            annotationStateNodes = data.data.comments?.nodes?.filter((node)=>node !== null);
        }
        // Common logic: map annotation state nodes to renderer states
        return $655a1f23a26f4e27$export$8f0e4480674935ab($655a1f23a26f4e27$var$rendererAnnotationsIds, validAnnotationsCallback, annotationStateNodes, reactionMarkerRefs, optimisticResolvedMarkerRefs);
    } catch (error) {
        // COMMENTS-1131 - When this code executes sometimes the `triggerAnalyticsEvent` is passed in as a promise
        //                this causes this call to throw an error where `.fire()` is not defined and thus the
        //                code below it which handles the various expected errors thrown to not run and thus
        //                the errors are thrown up the stack as unhandled ui errors causing a lot of noise
        try {
            if (triggerAnalyticsEvent) triggerAnalyticsEvent({
                source: 'rendererComponent',
                action: 'failed',
                actionSubject: 'annotationState',
                actionSubjectId: 'inlineComments',
                attributes: {
                    ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                    errorName: error.name,
                    errorMessage: error.message
                }
            }).fire();
        } catch (e) {
            $655a1f23a26f4e27$var$logger.error`Error when logging analytics event, ${e}`;
        }
        if ((0, $1uFM6.isUnauthorizedError)(error) || // CEMS-1343 - Some specific pages have annotations that have a "null" id because we
        //             still informed the editor on failed creation attempts
        error?.message.includes('java.lang.NullPointerException') || // COMMENTS-211 - If we don't find any inline comments for the given markerRefList
        //               we should mark it handled and return an empty list to be consumed
        error?.message.includes('.NotFoundException')) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return [];
        } else {
            $655a1f23a26f4e27$var$logger.error`Error when retrieving resolved status for marks, ${error}`;
            throw error;
        }
    }
};
module.exports["getEditorResolvedState"] = $655a1f23a26f4e27$export$38c1ce6adefc79a5;
module.exports["getRendererAnnotationStates"] = $655a1f23a26f4e27$export$a0fcca613dd8b2c7;

});

parcelRegister("kmYOg", function(module, exports) {
/**
 * @generated SignedSource<<8fc743fa44c5cd210e605b4e8ce0cf28>>
 * @relayHash d689c46cc95f36419f19f207f3ceb687
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da0d02555fb2e7138559c38df00467b0a1669fe42733ebf6cfa8115dbdbb4a2f
const $f5022931ec1c887f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "confluenceCommentFilter",
                    "value": {
                        "commentState": "UNRESOLVED",
                        "commentType": "INLINE"
                    }
                },
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Literal",
                    "name": "depth",
                    "value": "ROOT"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "pageId",
                    "variableName": "pageId"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": [
                        "INLINE"
                    ]
                }
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "contentStatus"
                        },
                        {
                            "kind": "LinkedField",
                            "name": "location",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "inlineMarkerRef"
                                        },
                                        {
                                            "concreteType": "InlineCommentResolveProperties",
                                            "kind": "LinkedField",
                                            "name": "inlineResolveProperties",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "resolved"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "InlineComment"
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                },
                v3 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "stateResolverPreloadAnnotationsDataQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "stateResolverPreloadAnnotationsDataQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "d689c46cc95f36419f19f207f3ceb687",
            "id": "da0d02555fb2e7138559c38df00467b0a1669fe42733ebf6cfa8115dbdbb4a2f",
            "metadata": {},
            "name": "stateResolverPreloadAnnotationsDataQuery",
            "operationKind": "query",
            "text": "query stateResolverPreloadAnnotationsDataQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$first:Long!){comments(pageId:$pageId,contentStatus:$contentStatus,confluenceCommentFilter:{commentState:UNRESOLVED,commentType:INLINE},type:[INLINE],depth:ROOT,first:$first){nodes{id,contentStatus,location{__typename,type,...on InlineComment{inlineMarkerRef,inlineResolveProperties{resolved}}}},totalCount,__typename}}"
        }
    };
}();
$f5022931ec1c887f$var$node.hash = "af92d028ec6cef46bb981d53522dfe18";
var $f5022931ec1c887f$export$2e2bcd8739ae039 = $f5022931ec1c887f$var$node;
module.exports["default"] = $f5022931ec1c887f$export$2e2bcd8739ae039;

});

parcelRegister("vNBpg", function(module, exports) {

var $hRVfm = parcelRequire("hRVfm");

const $951c06b69b244c75$export$dedc8dce0be2f721 = (0, $hRVfm.default);
module.exports["AnnotationStateQuery"] = $951c06b69b244c75$export$dedc8dce0be2f721;

});

parcelRegister("hRVfm", function(module, exports) {
/**
 * @generated SignedSource<<46b3ab55d6477d87980ae5cdc67e4862>>
 * @relayHash 0a59fed9dfa6599d230495f1a47dbc7c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 26bdeb44b2916ab641fa116a225079027626cb4cc6f97c58a4313672060fb97b
const $791a5813533710f7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ROOT"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 1500
        },
        {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "pageId"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": [
                "INLINE",
                "UNRESOLVED"
            ]
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "resolved"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "resolvedUser"
                    }
                ]
            }
        ],
        "type": "InlineComment"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "AnnotationStateQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "AnnotationStateQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "0a59fed9dfa6599d230495f1a47dbc7c",
            "id": "26bdeb44b2916ab641fa116a225079027626cb4cc6f97c58a4313672060fb97b",
            "metadata": {},
            "name": "AnnotationStateQuery",
            "operationKind": "query",
            "text": "query AnnotationStateQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus]){comments(pageId:$pageId,contentStatus:$contentStatus,type:[INLINE,UNRESOLVED],depth:ROOT,first:1500){nodes{id,location{__typename,type,...on InlineComment{inlineMarkerRef,inlineResolveProperties{resolved,resolvedUser}}}}}}"
        }
    };
}();
$791a5813533710f7$var$node.hash = "40ea3762a17ce85bcac23a6ef83d3cbe";
var $791a5813533710f7$export$2e2bcd8739ae039 = $791a5813533710f7$var$node;
module.exports["default"] = $791a5813533710f7$export$2e2bcd8739ae039;

});

parcelRegister("fS1ba", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bSvtO = parcelRequire("bSvtO");


var $cZa7r = parcelRequire("cZa7r");


var $8aF6s = parcelRequire("8aF6s");


var $cMvMc = parcelRequire("cMvMc");


var $gfqXk = parcelRequire("gfqXk");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $aJPUt = parcelRequire("aJPUt");


var $gtj7V = parcelRequire("gtj7V");


var $6mKj3 = parcelRequire("6mKj3");


var $5fMeR = parcelRequire("5fMeR");

const $9dbfd76fc543be2b$var$relativeFilePath = 'annotation-provider-inline-comments/editor/ViewManager';
const $9dbfd76fc543be2b$export$76599b5777b5fa44 = ({ pageId: pageId, editorActions: editorActions, newlySelectedAnnotationId: newlySelectedAnnotationId, annotations: annotations, annotationsList: annotationsList, getInlineNodeTypes: getInlineNodeTypes, onClose: onClose, onDelete: onDelete, onResolve: onResolve, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar, isOffline: isOfflineFromProps, reactionMarkerMap: reactionMarkerMap })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { editorViewProps: editorViewProps, editorCreateProps: editorCreateProps, storedCommentData: storedCommentData } = (0, $cZa7r.useAnnotations)();
    const { setEditorViewProps: setEditorViewProps, setIsOffline: setIsOffline, clearStoredCommentData: clearStoredCommentData } = (0, $cZa7r.useAnnotationsDispatch)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const { isCommentsPanelShown: isCommentsPanelShown } = (0, $5fMeR.useShowCommentsPanel)();
    // Clear stored comment data when annotation changes (before new component renders)
    (0, $cozmU.useEffect)(()=>{
        if (storedCommentData) {
            const currentAnnotationId = annotations?.[0]?.id;
            const storedAnnotationId = storedCommentData?.location?.inlineMarkerRef;
            // Clear stored data if we're viewing a different annotation
            if (currentAnnotationId && storedAnnotationId && currentAnnotationId !== storedAnnotationId) clearStoredCommentData();
        }
    }, [
        annotations,
        storedCommentData,
        clearStoredCommentData
    ]);
    const handleClose = (0, $cozmU.useCallback)(()=>{
        // NOTE: Any logic added to the handleClose function will need to be duplicated to EditorCommentShortcutListener.tsx. To revisit - create a shared function so the close inline comment logic can be reused
        // When closing the sidebar, return focus to the previously selected annotation element
        setTimeout(()=>{
            // Use scrollIntoView: false to prevent unwanted page scroll when focus is restored
            editorActions?.focus({
                scrollIntoView: !(0, $6mKj3.expValEquals)('confluence_comment_disable_scroll_onfocus', 'isEnabled', true)
            });
        }, 100);
        onClose && onClose();
        setEditorViewProps(null);
        if (storedCommentData) clearStoredCommentData();
        experienceTracker.abort({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            reason: 'Inline comment was closed',
            checkForTimeout: true,
            publishDebugPoints: true,
            attributes: {
                stopPoint: $9dbfd76fc543be2b$var$relativeFilePath
            }
        });
    }, [
        editorActions,
        onClose,
        setEditorViewProps,
        experienceTracker,
        storedCommentData,
        clearStoredCommentData
    ]);
    (0, $cozmU.useEffect)(()=>{
        const handleSetEditorViewProps = ()=>{
            setEditorViewProps({
                pageId: pageId,
                editorActions: editorActions,
                annotations: annotations,
                annotationsList: annotationsList,
                getInlineNodeTypes: getInlineNodeTypes,
                onClose: handleClose,
                onDelete: onDelete,
                onResolve: onResolve,
                isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
                reactionMarkerMap: reactionMarkerMap
            });
            // Only start the experience if the comments panel is closed to track the core view-inline-comment experience
            if (!isCommentsPanelShown && annotations[0]?.id) {
                const experienceState = experienceTracker.getExperienceState((0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE));
                /*
         * Note: This logic runs after certain entrypoints start the view-inline-comment experience.
         * We don't start a new experience if the annotation ID of the running experience is the same
         * as the current annotation to avoid duplicating and aborting experiences.
         */ if (experienceState === null || experienceState?.hasStopped || experienceState?.hasStopped === false && experienceState?.attributes?.annotationId !== annotations[0]?.id) experienceTracker.start({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                    attributes: {
                        ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                        annotationId: annotations[0]?.id,
                        entryPoint: $9dbfd76fc543be2b$var$relativeFilePath,
                        pageClass: 'editor'
                    }
                });
            }
            if (editorCreateProps) experienceTracker.succeed({
                name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE)
            });
        };
        // The annotation currently being shown
        const currentlyShownAnnotationId = editorViewProps && editorViewProps.annotations.length > 0 ? editorViewProps.annotations[0].id : undefined;
        // We only want to do anything if a new annotation has been clicked/selected
        if (newlySelectedAnnotationId !== currentlyShownAnnotationId) {
            // We only want to show the dialog if a new annotation has been selected AND content has changed
            // if a new annotation has not been selected, the onClose() function will handle the changed dialog
            // COMMENTS-3216 - With Concurrent Mode the rendering cycle is optimized to show things sooner
            //				   causing this component to mount before the state change for the comment content
            //				   is registered and thus causes the user to be prompted. We will never have a case
            //				   that currentlyShownAnnotationId is undefined AND there are changes, so this is safe
            if (hasContentChanged && currentlyShownAnnotationId !== undefined) {
                let abortedExperience = false;
                let abortedExperienceEntrypoint = '';
                const experienceState = experienceTracker.getExperienceState((0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE));
                /*
         * If a keyboard shortcut or comment navigation is used to navigate when the content has changed,
         * we abort and restart the experience on confirm because we can't predict if the user will
         * confirm the navigation, or how long the user will take to confirm.
         */ if (experienceState !== null && experienceState?.hasStopped === false && (experienceState?.attributes?.entryPoint === 'comments-shortcuts/EditorCommentShortcutListener' || experienceState?.attributes?.entryPoint === 'inline-comments-common/CommentNavigation')) {
                    abortedExperienceEntrypoint = experienceState?.attributes?.entryPoint;
                    experienceTracker.abort({
                        name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                        reason: 'Comment warning dialog displayed',
                        checkForTimeout: true,
                        publishDebugPoints: true,
                        attributes: {
                            stopPoint: $9dbfd76fc543be2b$var$relativeFilePath
                        }
                    });
                    abortedExperience = true;
                }
                showModal((0, $cMvMc.CommentWarningDialog), {
                    onConfirm: ()=>{
                        if (abortedExperience) {
                            experienceTracker.start({
                                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                                timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                                attributes: {
                                    ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                                    annotationId: annotations.length && annotations[0].id,
                                    entryPoint: $9dbfd76fc543be2b$var$relativeFilePath,
                                    pageClass: 'editor'
                                }
                            });
                            (0, $4EKKB.selectInlineComment).debug(`Restarting experience after comment was discarded from comment warning dialog. Initial entrypoint: ${abortedExperienceEntrypoint}`);
                        }
                        // On confirm, activate the newly clicked one
                        if (annotations.length > 0) emitter.emit('setselectedannotation', annotations[0].id);
                        resetContentChanged();
                        handleSetEditorViewProps();
                    },
                    onCancel: ()=>{
                        // If we have a previously shown annotationId we want to keep it highlighted until the user makes their choice
                        if (currentlyShownAnnotationId) emitter.emit('setselectedannotation', currentlyShownAnnotationId);
                    }
                });
            } else handleSetEditorViewProps();
        }
    // We only want to listen to changes that signifies a new comment click
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        newlySelectedAnnotationId
    ]);
    (0, $cozmU.useEffect)(()=>{
        // This is effectively gated by the platform_editor_offline_editing_web experiment, via platform/packages/editor/editor-plugin-annotation/src/ui/InlineCommentView.tsx
        setIsOffline(isOfflineFromProps === true);
    }, [
        isOfflineFromProps,
        setIsOffline
    ]);
    return null;
};
const $9dbfd76fc543be2b$export$e2fb22396d3bf4b8 = ({ pageId: pageId, editorActions: editorActions, getReactionMarkerMap: getReactionMarkerMap })=>/*#__PURE__*/ (0, $cozmU.memo)((viewComponentProps)=>{
        // TODO: Handle multiple annotations
        const newlySelectedAnnotationId = viewComponentProps.annotations.length > 0 ? viewComponentProps.annotations[0].id : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9dbfd76fc543be2b$export$76599b5777b5fa44, {
            pageId: pageId,
            editorActions: editorActions,
            newlySelectedAnnotationId: newlySelectedAnnotationId,
            ...viewComponentProps,
            reactionMarkerMap: getReactionMarkerMap?.()
        });
    });
module.exports["ViewManager"] = $9dbfd76fc543be2b$export$e2fb22396d3bf4b8;

});

parcelRegister("gYgF0", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cZa7r = parcelRequire("cZa7r");


var $aWwYt = parcelRequire("aWwYt");


var $bSvtO = parcelRequire("bSvtO");


var $cMvMc = parcelRequire("cMvMc");


var $8aF6s = parcelRequire("8aF6s");


var $9wGTI = parcelRequire("9wGTI");

const $a70e629208b21e04$export$3fa94ae7388781e0 = ({ pageId: pageId, onCreate: onCreate, onCreateError: onCreateError, onClose: onClose, dom: dom, textSelection: textSelection, inlineNodeTypes: inlineNodeTypes, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar, isOffline: isOfflineFromProps })=>{
    const { editorViewProps: editorViewProps } = (0, $cZa7r.useAnnotations)();
    const { setEditorCreateProps: setEditorCreateProps, setEditorViewProps: setEditorViewProps, setIsOffline: setIsOffline, setStoredCommentData: setStoredCommentData } = (0, $cZa7r.useAnnotationsDispatch)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const annotationManager = (0, $cZa7r.useAnnotationManager)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const isShowingComment = editorViewProps && editorViewProps.annotations.length > 0;
    const handleClose = (0, $cozmU.useCallback)(()=>{
        if ((0, $9wGTI.fg)('platform_editor_comments_api_manager')) annotationManager?.clearDraft();
        else onClose && onClose();
        setEditorCreateProps(null);
    }, [
        onClose,
        setEditorCreateProps,
        annotationManager
    ]);
    const handleCreate = (0, $cozmU.useCallback)((id, commentData)=>{
        if (commentData) setStoredCommentData(commentData);
        if ((0, $9wGTI.fg)('platform_editor_comments_api_manager')) return annotationManager?.applyDraft(id);
        else return onCreate && onCreate(id);
    }, [
        onCreate,
        annotationManager,
        setStoredCommentData
    ]);
    const closeObjectSidebar = (0, $cozmU.useCallback)(()=>{
        if (isObjectSidebarShown) hideObjectSidebar();
    }, [
        isObjectSidebarShown,
        hideObjectSidebar
    ]);
    (0, $cozmU.useEffect)(()=>{
        const handleSetEditorCreateProps = ()=>{
            setEditorViewProps(null);
            setEditorCreateProps({
                pageId: pageId,
                textSelection: textSelection,
                dom: dom,
                onCreate: handleCreate,
                onCreateError: onCreateError,
                onClose: handleClose,
                inlineNodeTypes: inlineNodeTypes,
                isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
                closeObjectSidebar: closeObjectSidebar
            });
        };
        if (isShowingComment && hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                setEditorViewProps(null);
                handleSetEditorCreateProps();
                closeObjectSidebar();
            },
            onCancel: ()=>{
                // If the user cancels, then cancel out the highlight
                handleClose();
            }
        });
        else handleSetEditorCreateProps();
    // We only want to listen to changes that signifies a new comment
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dom,
        textSelection
    ]);
    (0, $cozmU.useEffect)(()=>{
        // This is effectively gated by the platform_editor_offline_editing_web experiment, via platform/packages/editor/editor-plugin-annotation/src/ui/InlineCommentView.tsx
        setIsOffline(isOfflineFromProps === true);
    }, [
        isOfflineFromProps,
        setIsOffline
    ]);
    return null;
};
const $a70e629208b21e04$export$a455823a9487ea0 = ({ pageId: pageId })=>/*#__PURE__*/ (0, $cozmU.memo)((createComponentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a70e629208b21e04$export$3fa94ae7388781e0, {
            pageId: pageId,
            ...createComponentProps
        }));
module.exports["CreateManager"] = $a70e629208b21e04$export$a455823a9487ea0;

});

parcelRegister("9zMAu", function(module, exports) {

var $bA6ND = parcelRequire("bA6ND");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");

const $74bbf8cfd9a1c35f$var$useActiveInlineDataActiveInlineDataQuery = (0, $bA6ND.default);
const $74bbf8cfd9a1c35f$export$b1ae1d74e0f8721d = (contentId)=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($74bbf8cfd9a1c35f$var$useActiveInlineDataActiveInlineDataQuery, {
        variables: {
            cloudId: cloudId,
            contentId: `ari:cloud:confluence:${cloudId}:${contentType === 'blogpost' ? 'blogpost' : 'page'}/${contentId}`
        },
        skip: !(0, $6mKj3.expVal)('confluence_inline_reactions', 'isEnabled', false),
        __callerPackage__: "experiment-inline-reactions"
    });
    return (0, $cozmU.useMemo)(()=>{
        const reactions = data?.confluence_activeInlineData?.reactions ?? [];
        const reactionMarkerRefs = [];
        const reactionMarkerMap = reactions.reduce((acc, marker)=>{
            if (marker) {
                reactionMarkerRefs.push(marker.markerRef);
                acc[marker.markerRef] = marker.commentId;
            }
            return acc;
        }, {});
        return {
            reactionMarkerRefs: reactionMarkerRefs,
            reactionMarkerMap: reactionMarkerMap,
            loading: loading,
            error: error
        };
    }, [
        data,
        loading,
        error
    ]);
};
module.exports["useActiveInlineData"] = $74bbf8cfd9a1c35f$export$b1ae1d74e0f8721d;

});

parcelRegister("bA6ND", function(module, exports) {
/**
 * @generated SignedSource<<428d5d05389190f3430e2e55e0611abb>>
 * @relayHash 489e47f009d264a94dcf13fd8bbf4da5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bdb31f2f6d397ed61363226785e1134c6f4c380caf11e97e782427d2c1885515
const $2d165df3d65dbb71$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ConfluenceActiveInlineData",
            "kind": "LinkedField",
            "name": "confluence_activeInlineData",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceInlineMarker",
                    "kind": "LinkedField",
                    "name": "reactions",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "commentId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "markerRef"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useActiveInlineDataActiveInlineDataQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useActiveInlineDataActiveInlineDataQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "489e47f009d264a94dcf13fd8bbf4da5",
            "id": "bdb31f2f6d397ed61363226785e1134c6f4c380caf11e97e782427d2c1885515",
            "metadata": {},
            "name": "useActiveInlineDataActiveInlineDataQuery",
            "operationKind": "query",
            "text": "query useActiveInlineDataActiveInlineDataQuery($cloudId:ID!,$contentId:ID!){confluence_activeInlineData(cloudId:$cloudId,contentId:$contentId){reactions{commentId,markerRef,type}}}"
        }
    };
}();
$2d165df3d65dbb71$var$node.hash = "1068a88ea8d0dcc33a5206b8fda71604";
var $2d165df3d65dbb71$export$2e2bcd8739ae039 = $2d165df3d65dbb71$var$node;
module.exports["default"] = $2d165df3d65dbb71$export$2e2bcd8739ae039;

});

parcelRegister("ikqOG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dklIa = parcelRequire("dklIa");

const $ca333d186b666e4b$export$fc080b9f1ca96cbc = ({ reactionMarkerRefs: reactionMarkerRefs, reactionMarkerMap: reactionMarkerMap })=>{
    const optimisticReactionMarkerMap = (0, $dklIa.useOptimisticReactionMarkerMap)();
    const optimisticResolvedMarkerRefs = (0, $dklIa.useOptimisticResolvedMarkerRefs)();
    const optimisticDeletedMarkerRefs = (0, $dklIa.useOptimisticDeletedMarkerRefs)();
    const { pruneOptimisticReactions: pruneOptimisticReactions, pruneOptimisticResolvedMarkerRefs: pruneOptimisticResolvedMarkerRefs, pruneOptimisticDeletedMarkerRefs: pruneOptimisticDeletedMarkerRefs } = (0, $dklIa.useInlineReactionActions)();
    const optimisticResolvedMarkerRefList = (0, $cozmU.useMemo)(()=>Array.from(optimisticResolvedMarkerRefs), [
        optimisticResolvedMarkerRefs
    ]);
    // Drain optimistic entries once the server-confirmed map contains them so
    // the optimistic store does not grow unbounded. `pruneOptimisticReactions`
    // is itself a no-op when nothing needs pruning.
    // Also drain resolved refs once the server no longer returns them.
    (0, $cozmU.useEffect)(()=>{
        const serverKeys = Object.keys(reactionMarkerMap);
        if (serverKeys.length > 0) pruneOptimisticReactions(serverKeys);
        // Only drain resolved refs when the server has returned data — an empty
        // reactionMarkerRefs during initial load would otherwise immediately clear
        // all optimistic-resolved refs, causing the highlight to reappear when
        // server data lands.
        if (reactionMarkerRefs.length > 0) {
            pruneOptimisticResolvedMarkerRefs(reactionMarkerRefs);
            pruneOptimisticDeletedMarkerRefs(reactionMarkerRefs);
        }
    }, [
        reactionMarkerMap,
        reactionMarkerRefs,
        pruneOptimisticReactions,
        pruneOptimisticResolvedMarkerRefs,
        pruneOptimisticDeletedMarkerRefs
    ]);
    const mergedReactionMarkerMap = (0, $cozmU.useMemo)(()=>{
        const hasOptimistic = Object.keys(optimisticReactionMarkerMap).length > 0;
        const hasResolved = optimisticResolvedMarkerRefs.size > 0;
        const hasDeleted = optimisticDeletedMarkerRefs.size > 0;
        if (!hasOptimistic && !hasResolved && !hasDeleted) return reactionMarkerMap;
        // Server map wins on key conflicts.
        const mergedMap = hasOptimistic ? {
            ...optimisticReactionMarkerMap,
            ...reactionMarkerMap
        } : {
            ...reactionMarkerMap
        };
        for (const ref of optimisticResolvedMarkerRefs)delete mergedMap[ref];
        for (const ref of optimisticDeletedMarkerRefs)delete mergedMap[ref];
        return mergedMap;
    }, [
        reactionMarkerMap,
        optimisticReactionMarkerMap,
        optimisticResolvedMarkerRefs,
        optimisticDeletedMarkerRefs
    ]);
    const mergedReactionMarkerRefs = (0, $cozmU.useMemo)(()=>{
        const optimisticRefs = Object.keys(optimisticReactionMarkerMap);
        const hasOptimistic = optimisticRefs.length > 0;
        const hasResolved = optimisticResolvedMarkerRefs.size > 0;
        const hasDeleted = optimisticDeletedMarkerRefs.size > 0;
        if (!hasOptimistic && !hasResolved && !hasDeleted) return reactionMarkerRefs;
        const set = new Set(reactionMarkerRefs);
        for (const ref of optimisticRefs)set.add(ref);
        // Filter out any refs that have been optimistically resolved but not yet
        // removed by the server refetch — prevents stale highlights reappearing.
        for (const ref of optimisticResolvedMarkerRefs)set.delete(ref);
        for (const ref of optimisticDeletedMarkerRefs)set.delete(ref);
        return Array.from(set);
    }, [
        reactionMarkerRefs,
        optimisticReactionMarkerMap,
        optimisticResolvedMarkerRefs,
        optimisticDeletedMarkerRefs
    ]);
    return {
        mergedReactionMarkerRefs: mergedReactionMarkerRefs,
        mergedReactionMarkerMap: mergedReactionMarkerMap,
        optimisticResolvedMarkerRefs: optimisticResolvedMarkerRefList
    };
};
module.exports["useInlineReactionMarkers"] = $ca333d186b666e4b$export$fc080b9f1ca96cbc;

});

parcelRegister("dklIa", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");

const $c3a6d60a3494ed40$var$defaultCommentState = Object.freeze({
    optimisticReactions: Object.freeze([]),
    inFlightEmojiIds: Object.freeze(new Set()),
    rollbackMap: Object.freeze(new Map()),
    error: undefined
});
const $c3a6d60a3494ed40$var$getCommentState = (state, commentId)=>state.commentReactionState[commentId] ?? $c3a6d60a3494ed40$var$defaultCommentState;
const $c3a6d60a3494ed40$var$setCommentState = (state, commentId, patch)=>({
        ...state.commentReactionState,
        [commentId]: {
            ...$c3a6d60a3494ed40$var$getCommentState(state, commentId),
            ...patch
        }
    });
const $c3a6d60a3494ed40$var$DEFAULT_STALENESS = Object.freeze({
    changed: 0,
    fetched: 0
});
const $c3a6d60a3494ed40$export$64e3401c254cca65 = (commentId, emojiId)=>`${commentId}::${emojiId}`;
/**
 * Merges server reaction data into the existing display order.
 * Existing emojis keep their position; their values are updated from `server`
 * (or from `inFlightOverrides` when a mutation is in-flight).
 * Emojis absent from both `server` and `inFlightOverrides` are dropped.
 * New emojis (from server or still-in-flight) are appended at the end.
 */ const $c3a6d60a3494ed40$var$stabilizeReactions = (current, server, inFlightOverrides = new Map(), deletedInFlight = new Set())=>{
    const serverMap = new Map();
    for (const r of server)if (!deletedInFlight.has(r.emojiId)) serverMap.set(r.emojiId, r);
    const result = [];
    const seenIds = new Set();
    for (const r of current){
        if (deletedInFlight.has(r.emojiId)) continue;
        const inFlight = inFlightOverrides.get(r.emojiId);
        if (inFlight) {
            result.push(inFlight);
            seenIds.add(r.emojiId);
        } else if (serverMap.has(r.emojiId)) {
            result.push(serverMap.get(r.emojiId));
            seenIds.add(r.emojiId);
        }
    // not in server and not in-flight → removed, omit
    }
    for (const r of server)if (!seenIds.has(r.emojiId) && !deletedInFlight.has(r.emojiId)) {
        result.push(r);
        seenIds.add(r.emojiId);
    }
    for (const [emojiId, optimistic] of inFlightOverrides)if (!seenIds.has(emojiId)) {
        result.push(optimistic);
        seenIds.add(emojiId);
    }
    return result;
};
const $c3a6d60a3494ed40$var$initialState = {
    opener: null,
    picker: null,
    optimisticReactionMarkerMap: {},
    optimisticResolvedMarkerRefs: new Set(),
    optimisticDeletedMarkerRefs: new Set(),
    commentReactionState: {},
    reactedUsersStaleness: {}
};
const $c3a6d60a3494ed40$var$registerOpener = (opener)=>({ setState: setState })=>{
        setState({
            opener: opener
        });
    };
const $c3a6d60a3494ed40$var$triggerOpen = ()=>({ getState: getState })=>{
        getState().opener?.();
    };
const $c3a6d60a3494ed40$var$openPicker = ({ anchorTop: anchorTop, anchorLeft: anchorLeft, contentType: contentType, pageId: pageId, onCreate: onCreate, step: step, originalSelection: originalSelection, onClose: onClose })=>({ setState: setState, getState: getState })=>{
        if (getState().picker) return;
        setState({
            picker: {
                anchorTop: anchorTop,
                anchorLeft: anchorLeft,
                contentType: contentType,
                pageId: pageId,
                onCreate: onCreate,
                step: step,
                originalSelection: originalSelection,
                onClose: onClose
            }
        });
    };
const $c3a6d60a3494ed40$var$closePicker = ()=>({ setState: setState, getState: getState })=>{
        const { picker: picker } = getState();
        if (!picker) return;
        picker.onClose?.();
        setState({
            picker: null
        });
    };
const $c3a6d60a3494ed40$var$addOptimisticReaction = (markerRef, commentId)=>({ setState: setState, getState: getState })=>{
        setState({
            optimisticReactionMarkerMap: {
                ...getState().optimisticReactionMarkerMap,
                [markerRef]: commentId
            }
        });
    };
const $c3a6d60a3494ed40$var$addOptimisticResolvedMarkerRef = (markerRef)=>({ setState: setState, getState: getState })=>{
        const current = getState().optimisticResolvedMarkerRefs;
        if (current.has(markerRef)) return;
        setState({
            optimisticResolvedMarkerRefs: new Set([
                ...current,
                markerRef
            ])
        });
    };
/**
 * Roll back an optimistic resolve — removes the ref from the set so the
 * highlight reappears. Called when the resolve mutation fails.
 */ const $c3a6d60a3494ed40$var$removeOptimisticResolvedMarkerRef = (markerRef)=>({ setState: setState, getState: getState })=>{
        const current = getState().optimisticResolvedMarkerRefs;
        if (!current.has(markerRef)) return;
        const next = new Set(current);
        next.delete(markerRef);
        setState({
            optimisticResolvedMarkerRefs: next
        });
    };
/**
 * Drain any optimistic-resolved refs that are no longer present in the
 * server-confirmed marker refs (meaning the server has confirmed removal).
 * No-ops when the set is empty to avoid an extra re-render.
 */ const $c3a6d60a3494ed40$var$pruneOptimisticResolvedMarkerRefs = (serverMarkerRefs)=>({ setState: setState, getState: getState })=>{
        const current = getState().optimisticResolvedMarkerRefs;
        if (current.size === 0) return;
        const serverSet = new Set(serverMarkerRefs);
        const next = new Set();
        for (const ref of current)// Keep only refs that the server still returns (not yet confirmed removed).
        if (serverSet.has(ref)) next.add(ref);
        if (next.size !== current.size) setState({
            optimisticResolvedMarkerRefs: next
        });
    };
const $c3a6d60a3494ed40$var$addOptimisticDeletedMarkerRef = (markerRef)=>({ setState: setState, getState: getState })=>{
        const current = getState().optimisticDeletedMarkerRefs;
        if (current.has(markerRef)) return;
        setState({
            optimisticDeletedMarkerRefs: new Set([
                ...current,
                markerRef
            ])
        });
    };
const $c3a6d60a3494ed40$var$pruneOptimisticDeletedMarkerRefs = (serverMarkerRefs)=>({ setState: setState, getState: getState })=>{
        const current = getState().optimisticDeletedMarkerRefs;
        if (current.size === 0) return;
        const serverSet = new Set(serverMarkerRefs);
        const next = new Set();
        for (const ref of current)if (serverSet.has(ref)) next.add(ref);
        if (next.size !== current.size) setState({
            optimisticDeletedMarkerRefs: next
        });
    };
/**
 * Drop any optimistic entries whose markerRef is now in the server-confirmed map.
 * Called from `useRendererAnnotationProviderOptions` whenever `useActiveInlineData`
 * returns a new `reactionMarkerMap`, so the optimistic store does not grow forever.
 * No-ops (and skips the setState) when nothing needs to be pruned to avoid an
 * extra re-render cycle.
 */ const $c3a6d60a3494ed40$var$pruneOptimisticReactions = (confirmedMarkerRefs)=>({ setState: setState, getState: getState })=>{
        const current = getState().optimisticReactionMarkerMap;
        if (Object.keys(current).length === 0 || confirmedMarkerRefs.length === 0) return;
        const confirmedSet = new Set(confirmedMarkerRefs);
        let changed = false;
        const next = {};
        for (const [markerRef, commentId] of Object.entries(current)){
            if (confirmedSet.has(markerRef)) {
                changed = true;
                continue;
            }
            next[markerRef] = commentId;
        }
        if (changed) setState({
            optimisticReactionMarkerMap: next
        });
    };
/**
 * Sync server reactions into the store for a given comment.
 *
 * When nothing is in-flight, the server data replaces the optimistic array.
 * When mutations are in-flight, server data is merged: in-flight emojis keep
 * their optimistic values while everything else updates to the server truth.
 */ const $c3a6d60a3494ed40$var$syncServerReactions = (commentId, serverReactions)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const comment = $c3a6d60a3494ed40$var$getCommentState(state, commentId);
        if (comment.inFlightEmojiIds.size === 0) {
            setState({
                commentReactionState: $c3a6d60a3494ed40$var$setCommentState(state, commentId, {
                    optimisticReactions: $c3a6d60a3494ed40$var$stabilizeReactions(comment.optimisticReactions, serverReactions)
                })
            });
            return;
        }
        // Merge: keep optimistic values for in-flight emojis, use server for the rest.
        // Build the snapshot as a Map for O(1) lookup (avoids quadratic nested iteration).
        const inFlightSnapshot = new Map();
        for (const r of comment.optimisticReactions)if (comment.inFlightEmojiIds.has(r.emojiId)) inFlightSnapshot.set(r.emojiId, r);
        // Track emojis that were optimistically deleted (in-flight but absent from
        // optimisticReactions because their count hit 0). We must suppress these from
        // the server payload so they don't get resurrected before the mutation settles.
        const deletedInFlight = new Set();
        for (const id of comment.inFlightEmojiIds)if (!inFlightSnapshot.has(id)) deletedInFlight.add(id);
        setState({
            commentReactionState: $c3a6d60a3494ed40$var$setCommentState(state, commentId, {
                optimisticReactions: $c3a6d60a3494ed40$var$stabilizeReactions(comment.optimisticReactions, serverReactions, inFlightSnapshot, deletedInFlight)
            })
        });
    };
/**
 * Apply an optimistic toggle (add or remove) for an existing emoji.
 * Returns `null` if the emoji is already in-flight or not found (no-op).
 * Otherwise applies the optimistic update, marks in-flight, and returns
 * `true` if removing or `false` if adding, so the caller knows which
 * mutation to fire.
 *
 * This combines the guard, optimistic update, and in-flight marking into a
 * single synchronous store transaction so that rapid-fire calls (e.g. double
 * clicks) are properly de-duped even before React re-renders.
 */ const $c3a6d60a3494ed40$var$applyOptimisticToggle = (commentId, emojiId)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const comment = $c3a6d60a3494ed40$var$getCommentState(state, commentId);
        if (comment.inFlightEmojiIds.has(emojiId)) return null;
        const currentReaction = comment.optimisticReactions.find((r)=>r.emojiId === emojiId);
        if (!currentReaction) return null;
        const isRemoving = currentReaction.reacted;
        // Save rollback snapshot
        const nextRollback = new Map(comment.rollbackMap);
        nextRollback.set(emojiId, comment.optimisticReactions);
        // Mark in-flight
        const nextInFlight = new Set(comment.inFlightEmojiIds);
        nextInFlight.add(emojiId);
        let nextReactions;
        if (isRemoving) {
            const newCount = currentReaction.count - 1;
            if (newCount <= 0) nextReactions = comment.optimisticReactions.filter((r)=>r.emojiId !== emojiId);
            else nextReactions = comment.optimisticReactions.map((r)=>r.emojiId === emojiId ? {
                    ...r,
                    count: newCount,
                    reacted: false
                } : r);
        } else nextReactions = comment.optimisticReactions.map((r)=>r.emojiId === emojiId ? {
                ...r,
                count: r.count + 1,
                reacted: true
            } : r);
        setState({
            commentReactionState: $c3a6d60a3494ed40$var$setCommentState(state, commentId, {
                optimisticReactions: nextReactions,
                rollbackMap: nextRollback,
                inFlightEmojiIds: nextInFlight,
                error: undefined
            })
        });
        return isRemoving;
    };
/**
 * Apply an optimistic add for a new or existing-but-not-reacted emoji.
 * Returns `false` if already in-flight or already reacted (no-op).
 * Otherwise applies the optimistic update, marks in-flight, and returns `true`.
 *
 * Like `applyOptimisticToggle`, this combines guard + update + in-flight
 * into a single synchronous transaction.
 */ const $c3a6d60a3494ed40$var$applyOptimisticAdd = (commentId, emojiId, templateAri, templateContainerAri)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const comment = $c3a6d60a3494ed40$var$getCommentState(state, commentId);
        if (comment.inFlightEmojiIds.has(emojiId)) return false;
        const existingReaction = comment.optimisticReactions.find((r)=>r.emojiId === emojiId);
        if (existingReaction?.reacted) return false;
        // Save rollback snapshot
        const nextRollback = new Map(comment.rollbackMap);
        nextRollback.set(emojiId, comment.optimisticReactions);
        // Mark in-flight
        const nextInFlight = new Set(comment.inFlightEmojiIds);
        nextInFlight.add(emojiId);
        let nextReactions;
        if (existingReaction) nextReactions = comment.optimisticReactions.map((r)=>r.emojiId === emojiId ? {
                ...r,
                count: r.count + 1,
                reacted: true
            } : r);
        else nextReactions = [
            ...comment.optimisticReactions,
            {
                ari: templateAri,
                containerAri: templateContainerAri,
                emojiId: emojiId,
                count: 1,
                reacted: true
            }
        ];
        setState({
            commentReactionState: $c3a6d60a3494ed40$var$setCommentState(state, commentId, {
                optimisticReactions: nextReactions,
                rollbackMap: nextRollback,
                inFlightEmojiIds: nextInFlight,
                error: undefined
            })
        });
        return true;
    };
/** Clear in-flight and rollback state for a settled mutation. */ const $c3a6d60a3494ed40$var$onEmojiSettled = (commentId, emojiId)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const comment = $c3a6d60a3494ed40$var$getCommentState(state, commentId);
        const nextInFlight = new Set(comment.inFlightEmojiIds);
        nextInFlight.delete(emojiId);
        const nextRollback = new Map(comment.rollbackMap);
        nextRollback.delete(emojiId);
        setState({
            commentReactionState: $c3a6d60a3494ed40$var$setCommentState(state, commentId, {
                inFlightEmojiIds: nextInFlight,
                rollbackMap: nextRollback
            })
        });
    };
/** Roll back optimistic state on mutation error. */ const $c3a6d60a3494ed40$var$onEmojiMutationError = (commentId, emojiId, error)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const comment = $c3a6d60a3494ed40$var$getCommentState(state, commentId);
        const rollback = comment.rollbackMap.get(emojiId);
        // Clear in-flight and rollback for this emoji
        const nextInFlight = new Set(comment.inFlightEmojiIds);
        nextInFlight.delete(emojiId);
        const nextRollback = new Map(comment.rollbackMap);
        nextRollback.delete(emojiId);
        setState({
            commentReactionState: $c3a6d60a3494ed40$var$setCommentState(state, commentId, {
                optimisticReactions: rollback ?? comment.optimisticReactions,
                inFlightEmojiIds: nextInFlight,
                rollbackMap: nextRollback,
                error: error
            })
        });
    };
/** Remove all state for a comment (call on unmount). */ const $c3a6d60a3494ed40$var$cleanupComment = (commentId)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const { [commentId]: _, ...rest } = state.commentReactionState;
        // Drop any reacted-users freshness entries for this comment's pairs so the
        // registry does not grow unbounded across a long session.
        const keyPrefix = `${commentId}::`;
        let removedStaleness = false;
        const nextStaleness = {};
        for (const [key, value] of Object.entries(state.reactedUsersStaleness)){
            if (key.startsWith(keyPrefix)) {
                removedStaleness = true;
                continue;
            }
            nextStaleness[key] = value;
        }
        setState({
            commentReactionState: rest,
            ...removedStaleness ? {
                reactedUsersStaleness: nextStaleness
            } : {}
        });
    };
/**
 * Record that the reactor list for a comment+emoji pair changed (local mutation
 * or remote pubsub event), bumping its `changed` counter so the next mounted
 * facepile fetcher refetches from the network.
 */ const $c3a6d60a3494ed40$var$markReactedUsersChanged = (commentId, emojiId)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const key = $c3a6d60a3494ed40$export$64e3401c254cca65(commentId, emojiId);
        const current = state.reactedUsersStaleness[key] ?? $c3a6d60a3494ed40$var$DEFAULT_STALENESS;
        setState({
            reactedUsersStaleness: {
                ...state.reactedUsersStaleness,
                [key]: {
                    changed: current.changed + 1,
                    fetched: current.fetched
                }
            }
        });
    };
/**
 * Record that a facepile fetcher has refetched the reactor list for a
 * comment+emoji pair, catching `fetched` up to `changed`. No-ops when already
 * caught up to avoid a redundant re-render.
 */ const $c3a6d60a3494ed40$var$markReactedUsersFetched = (commentId, emojiId)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const key = $c3a6d60a3494ed40$export$64e3401c254cca65(commentId, emojiId);
        const current = state.reactedUsersStaleness[key];
        if (!current || current.fetched === current.changed) return;
        setState({
            reactedUsersStaleness: {
                ...state.reactedUsersStaleness,
                [key]: {
                    changed: current.changed,
                    fetched: current.changed
                }
            }
        });
    };
/**
 * Apply a remote pubsub delta (add or remove) from another user.
 *
 * On +1: increment the existing emoji count, or create a new entry with
 *        count=1 and reacted=false if it doesn't exist yet.
 * On -1: decrement the count, removing the entry if it reaches zero.
 *        No-ops if the comment has no state yet (nothing to decrement).
 */ const $c3a6d60a3494ed40$var$applyRemoteDelta = (commentId, emojiId, delta, templateAri = '', templateContainerAri = '')=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const comment = $c3a6d60a3494ed40$var$getCommentState(state, commentId);
        const existing = comment.optimisticReactions.find((r)=>r.emojiId === emojiId);
        let nextReactions;
        if (delta === 1) {
            if (existing) // Increment existing entry, preserve `reacted` (current user's state)
            nextReactions = comment.optimisticReactions.map((r)=>r.emojiId === emojiId ? {
                    ...r,
                    count: r.count + 1
                } : r);
            else {
                // If this comment has no store entry yet, skip writing: persisting a new
                // CommentReactionState here would create a leaked record (ari: '', containerAri: '')
                // for a comment that is not currently mounted. syncServerReactions will provide
                // authoritative state when the component does mount and refetches.
                if (state.commentReactionState[commentId] === undefined) return;
                // Create a new entry - 'reacted' is false since this is a remote user's reaction
                nextReactions = [
                    ...comment.optimisticReactions,
                    {
                        ari: templateAri,
                        containerAri: templateContainerAri,
                        emojiId: emojiId,
                        count: 1,
                        reacted: false
                    }
                ];
            }
        } else {
            // delta === -1
            if (!existing) // No emoji found in store - nothing to decrement
            return;
            const newCount = existing.count - 1;
            if (newCount <= 0) nextReactions = comment.optimisticReactions.filter((r)=>r.emojiId !== emojiId);
            else nextReactions = comment.optimisticReactions.map((r)=>r.emojiId === emojiId ? {
                    ...r,
                    count: newCount
                } : r);
        }
        setState({
            commentReactionState: $c3a6d60a3494ed40$var$setCommentState(state, commentId, {
                optimisticReactions: nextReactions
            })
        });
    };
const $c3a6d60a3494ed40$var$actions = {
    registerOpener: $c3a6d60a3494ed40$var$registerOpener,
    triggerOpen: $c3a6d60a3494ed40$var$triggerOpen,
    openPicker: $c3a6d60a3494ed40$var$openPicker,
    closePicker: $c3a6d60a3494ed40$var$closePicker,
    addOptimisticReaction: $c3a6d60a3494ed40$var$addOptimisticReaction,
    pruneOptimisticReactions: $c3a6d60a3494ed40$var$pruneOptimisticReactions,
    addOptimisticResolvedMarkerRef: $c3a6d60a3494ed40$var$addOptimisticResolvedMarkerRef,
    removeOptimisticResolvedMarkerRef: $c3a6d60a3494ed40$var$removeOptimisticResolvedMarkerRef,
    pruneOptimisticResolvedMarkerRefs: $c3a6d60a3494ed40$var$pruneOptimisticResolvedMarkerRefs,
    addOptimisticDeletedMarkerRef: $c3a6d60a3494ed40$var$addOptimisticDeletedMarkerRef,
    pruneOptimisticDeletedMarkerRefs: $c3a6d60a3494ed40$var$pruneOptimisticDeletedMarkerRefs,
    syncServerReactions: $c3a6d60a3494ed40$var$syncServerReactions,
    applyOptimisticToggle: $c3a6d60a3494ed40$var$applyOptimisticToggle,
    applyOptimisticAdd: $c3a6d60a3494ed40$var$applyOptimisticAdd,
    onEmojiSettled: $c3a6d60a3494ed40$var$onEmojiSettled,
    onEmojiMutationError: $c3a6d60a3494ed40$var$onEmojiMutationError,
    cleanupComment: $c3a6d60a3494ed40$var$cleanupComment,
    applyRemoteDelta: $c3a6d60a3494ed40$var$applyRemoteDelta,
    markReactedUsersChanged: $c3a6d60a3494ed40$var$markReactedUsersChanged,
    markReactedUsersFetched: $c3a6d60a3494ed40$var$markReactedUsersFetched
};
const $c3a6d60a3494ed40$export$6f57813fe9f31bf9 = (0, $8s9DV.createStore)({
    initialState: $c3a6d60a3494ed40$var$initialState,
    actions: $c3a6d60a3494ed40$var$actions,
    name: 'inlineReactionStore'
});
const $c3a6d60a3494ed40$export$4bea784acc47afc0 = (0, $kBr4q.createActionsHook)($c3a6d60a3494ed40$export$6f57813fe9f31bf9);
const $c3a6d60a3494ed40$export$95648a16d8bcb2ae = (0, $kBr4q.createStateHook)($c3a6d60a3494ed40$export$6f57813fe9f31bf9, {
    selector: (state)=>state.picker
});
const $c3a6d60a3494ed40$export$a2df1890187165d2 = (0, $kBr4q.createStateHook)($c3a6d60a3494ed40$export$6f57813fe9f31bf9, {
    selector: (state)=>state.optimisticReactionMarkerMap
});
function $c3a6d60a3494ed40$export$8adad8a188e9f237() {
    return (0, $c6StJ.defaultRegistry).getStore($c3a6d60a3494ed40$export$6f57813fe9f31bf9).storeState.getState().optimisticReactionMarkerMap;
}
function $c3a6d60a3494ed40$export$ff40a497e226daf7(markerRef) {
    return (0, $c6StJ.defaultRegistry).getStore($c3a6d60a3494ed40$export$6f57813fe9f31bf9).storeState.getState().optimisticResolvedMarkerRefs.has(markerRef);
}
function $c3a6d60a3494ed40$export$e0bbeb963dd9ccf1(markerRef) {
    (0, $c6StJ.defaultRegistry).getStore($c3a6d60a3494ed40$export$6f57813fe9f31bf9).actions.addOptimisticDeletedMarkerRef(markerRef);
}
const $c3a6d60a3494ed40$export$acabd5c13c46827c = (0, $kBr4q.createStateHook)($c3a6d60a3494ed40$export$6f57813fe9f31bf9, {
    selector: (state)=>state.optimisticResolvedMarkerRefs
});
const $c3a6d60a3494ed40$export$15ea3ad646d59eec = (0, $kBr4q.createStateHook)($c3a6d60a3494ed40$export$6f57813fe9f31bf9, {
    selector: (state)=>state.optimisticDeletedMarkerRefs
});
const $c3a6d60a3494ed40$export$c2b73a32145e6e04 = (0, $kBr4q.createStateHook)($c3a6d60a3494ed40$export$6f57813fe9f31bf9, {
    selector: (state, commentId)=>state.commentReactionState[commentId] ?? $c3a6d60a3494ed40$var$defaultCommentState
});
const $c3a6d60a3494ed40$export$2b46bd66d45480ef = (0, $kBr4q.createStateHook)($c3a6d60a3494ed40$export$6f57813fe9f31bf9, {
    selector: (state, pairKey)=>state.reactedUsersStaleness[pairKey] ?? $c3a6d60a3494ed40$var$DEFAULT_STALENESS
});
function $c3a6d60a3494ed40$export$20c2e9914ef136a5(pairKey) {
    return (0, $c6StJ.defaultRegistry).getStore($c3a6d60a3494ed40$export$6f57813fe9f31bf9).storeState.getState().reactedUsersStaleness[pairKey] ?? $c3a6d60a3494ed40$var$DEFAULT_STALENESS;
}
module.exports["reactedUsersPairKey"] = $c3a6d60a3494ed40$export$64e3401c254cca65;
module.exports["useInlineReactionActions"] = $c3a6d60a3494ed40$export$4bea784acc47afc0;
module.exports["useInlineReactionPicker"] = $c3a6d60a3494ed40$export$95648a16d8bcb2ae;
module.exports["useOptimisticReactionMarkerMap"] = $c3a6d60a3494ed40$export$a2df1890187165d2;
module.exports["getOptimisticReactionMarkerMap"] = $c3a6d60a3494ed40$export$8adad8a188e9f237;
module.exports["isOptimisticallyResolvedMarkerRef"] = $c3a6d60a3494ed40$export$ff40a497e226daf7;
module.exports["markOptimisticDeletedMarkerRef"] = $c3a6d60a3494ed40$export$e0bbeb963dd9ccf1;
module.exports["useOptimisticResolvedMarkerRefs"] = $c3a6d60a3494ed40$export$acabd5c13c46827c;
module.exports["useOptimisticDeletedMarkerRefs"] = $c3a6d60a3494ed40$export$15ea3ad646d59eec;
module.exports["useCommentReactionState"] = $c3a6d60a3494ed40$export$c2b73a32145e6e04;
module.exports["useReactedUsersStaleness"] = $c3a6d60a3494ed40$export$2b46bd66d45480ef;
module.exports["getReactedUsersStaleness"] = $c3a6d60a3494ed40$export$20c2e9914ef136a5;

});

parcelRegister("aUU0C", function(module, exports) {

var $3u5lg = parcelRequire("3u5lg");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $6b57ff110c624a89$var$initialState = {
    annotations: []
};
const $6b57ff110c624a89$var$actions = {
    setEditorAnnotations: (newAnnotations, pageId)=>({ getState: getState, setState: setState })=>{
            const { annotations: annotations } = getState();
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(newAnnotations, annotations)) setState({
                annotations: newAnnotations,
                pageId: pageId
            });
        }
};
const $6b57ff110c624a89$var$EditorAnnotationsStore = (0, $8s9DV.createStore)({
    initialState: $6b57ff110c624a89$var$initialState,
    actions: $6b57ff110c624a89$var$actions,
    name: 'EditorAnnotationsStore'
});
const $6b57ff110c624a89$export$af3b3e68acbfeb43 = (0, $kBr4q.createHook)($6b57ff110c624a89$var$EditorAnnotationsStore);
const $6b57ff110c624a89$export$72e98d7f4c892f01 = (0, $kBr4q.createActionsHook)($6b57ff110c624a89$var$EditorAnnotationsStore);
module.exports["useEditorAnnotations"] = $6b57ff110c624a89$export$af3b3e68acbfeb43;
module.exports["useEditorAnnotationsActions"] = $6b57ff110c624a89$export$72e98d7f4c892f01;

});

parcelRegister("k8e76", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

var $5GOpG = parcelRequire("5GOpG");


var $hE1Uz = parcelRequire("hE1Uz");

const $221ff47547c5dafc$var$initialState = {
    unresolvedInlineComments: []
};
const $221ff47547c5dafc$var$actions = {
    updateUnresolvedInlineComment: (unresolvedInlineComments)=>({ setState: setState })=>{
            setState({
                unresolvedInlineComments: unresolvedInlineComments
            });
        },
    addUnresolvedInlineComment: (unresolvedAnnotationId, pageModes)=>({ setState: setState, getState: getState })=>{
            if (!unresolvedAnnotationId) return;
            const { unresolvedInlineComments: unresolvedInlineComments } = getState();
            setState({
                unresolvedInlineComments: (0, $hE1Uz.findUnresolvedCommentIndex)(unresolvedAnnotationId, unresolvedInlineComments, pageModes)
            });
        },
    removeUnresolvedInlineComment: (unresolvedAnnotationId)=>({ setState: setState, getState: getState })=>{
            if (!unresolvedAnnotationId) return;
            const { unresolvedInlineComments: unresolvedInlineComments } = getState();
            const updatedUnresolvedInlineComments = [
                ...unresolvedInlineComments
            ];
            const unresolvedAnnotationIdx = updatedUnresolvedInlineComments.indexOf(unresolvedAnnotationId);
            // Remove the passed in comment if it exists and reset the state
            if (unresolvedAnnotationIdx > -1) {
                updatedUnresolvedInlineComments.splice(unresolvedAnnotationIdx, 1);
                setState({
                    unresolvedInlineComments: updatedUnresolvedInlineComments
                });
            }
        }
};
const $221ff47547c5dafc$var$InlineCommentsStore = (0, $8s9DV.createStore)({
    initialState: $221ff47547c5dafc$var$initialState,
    actions: $221ff47547c5dafc$var$actions,
    name: 'InlineCommentsStore'
});
const $221ff47547c5dafc$export$2d5fb1576e30b55e = (0, $kBr4q.createHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$84bffd53ee003f3d = (0, $kBr4q.createActionsHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$f4e420e107a562b0 = (0, $kBr4q.createStateHook)($221ff47547c5dafc$var$InlineCommentsStore);
const $221ff47547c5dafc$export$d9930cd528b1e4f5 = (0, $5GOpG.createSubscriber)($221ff47547c5dafc$var$InlineCommentsStore);
module.exports["useInlineComments"] = $221ff47547c5dafc$export$2d5fb1576e30b55e;
module.exports["useInlineCommentsActions"] = $221ff47547c5dafc$export$84bffd53ee003f3d;
module.exports["useInlineCommentsState"] = $221ff47547c5dafc$export$f4e420e107a562b0;

});

parcelRegister("hE1Uz", function(module, exports) {
var $8288f6cefaa5e2cf$var$PageMode = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}($8288f6cefaa5e2cf$var$PageMode || {});
const $8288f6cefaa5e2cf$export$556f3f3c22ea5327 = (unresolvedAnnotationId, unresolvedInlineComments, pageMode)=>{
    const isFullPageEditor = pageMode === "live" || pageMode === "edit";
    let activeAnnotationMarks;
    if (isFullPageEditor) {
        // In the full-page editor mode, collect parent spans with unique IDs for annotation boundaries
        const parentSpansSet = new Set();
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const annotations = document.querySelectorAll('.ak-editor-annotation-focus, .ak-editor-annotation-blur');
        annotations.forEach((element)=>{
            const parentSpan = element.closest('span[id]');
            if (parentSpan) parentSpansSet.add(parentSpan);
        });
        activeAnnotationMarks = Array.from(parentSpansSet);
    } else // For renderer or view mode, collect marks with active annotation state
    activeAnnotationMarks = Array.from(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelectorAll("mark[data-mark-annotation-state='active']"));
    // Attempt to find the index of the new unresolved annotation by matching its element
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const newlyUnresolvedAnnotation = document.getElementById(unresolvedAnnotationId);
    const allUnresolvedAnnotations = Array.from(activeAnnotationMarks);
    const matchedIndex = newlyUnresolvedAnnotation ? allUnresolvedAnnotations.indexOf(newlyUnresolvedAnnotation) : -1;
    // Construct the new array with unresolved comments
    const newUnresolvedInlineComments = [
        ...unresolvedInlineComments
    ];
    if (matchedIndex !== -1) newUnresolvedInlineComments.splice(matchedIndex, 0, unresolvedAnnotationId);
    else newUnresolvedInlineComments.push(unresolvedAnnotationId);
    return newUnresolvedInlineComments;
};
module.exports["findUnresolvedCommentIndex"] = $8288f6cefaa5e2cf$export$556f3f3c22ea5327;

});

parcelRegister("WheoQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $b0ecc354fcdb9645$export$23b7aa19be1bc1ad = (callbacks)=>(0, $cozmU.useCallback)((annotationsList)=>{
        callbacks.forEach((callback)=>callback(annotationsList));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, callbacks);
module.exports["useUpdateAnnotations"] = $b0ecc354fcdb9645$export$23b7aa19be1bc1ad;

});

parcelRegister("aPQsP", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3ge84 = parcelRequire("3ge84");


var $9DHhW = parcelRequire("9DHhW");


var $bdpeX = parcelRequire("bdpeX");


var $fgEJD = parcelRequire("fgEJD");


var $nFs2M = parcelRequire("nFs2M");


var $lTECB = parcelRequire("lTECB");


var $7rOWN = parcelRequire("7rOWN");


var $eeCnx = parcelRequire("eeCnx");


var $etDDt = parcelRequire("etDDt");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $7PHx9 = parcelRequire("7PHx9");

var $1M1t5 = parcelRequire("1M1t5");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $iz4WO = parcelRequire("iz4WO");


var $jRxDI = parcelRequire("jRxDI");


var $iONqR = parcelRequire("iONqR");


var $dZUkS = parcelRequire("dZUkS");


var $fxClS = parcelRequire("fxClS");


var $euL71 = parcelRequire("euL71");


var $6b7RE = parcelRequire("6b7RE");


var $gH8jv = parcelRequire("gH8jv");


var $2YtTU = parcelRequire("2YtTU");


var $4U6ec = parcelRequire("4U6ec");


var $3IZob = parcelRequire("3IZob");


var $giS6h = parcelRequire("giS6h");


var $fgd2r = parcelRequire("fgd2r");


var $jgzkh = parcelRequire("jgzkh");


var $glRTB = parcelRequire("glRTB");


var $1kHsc = parcelRequire("1kHsc");


var $aQw7y = parcelRequire("aQw7y");


var $bfil7 = parcelRequire("bfil7");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $1JyKZ = parcelRequire("1JyKZ");


var $cEgMD = parcelRequire("cEgMD");


var $dPJCf = parcelRequire("dPJCf");


var $lJDEI = parcelRequire("lJDEI");


var $9bL1w = parcelRequire("9bL1w");


var $lvKPs = parcelRequire("lvKPs");


var $aIqlA = parcelRequire("aIqlA");

const $f03f53a782506f81$var$noop = ()=>{};
const $f03f53a782506f81$var$_getClassicEditorProviders = (0, $dOBRD.default)(({ cloudId: cloudId, contentId: contentId, contentTitle: contentTitle, contentType: contentType, contentVersion: contentVersion, spaceKey: spaceKey, spaceId: spaceId, contentMode: contentMode, editorActions: editorActions, createAnalyticsEvent: createAnalyticsEvent, mentionProvider: mentionProvider, intlNext: intlNext, openMacroBrowserToEditExistingMacro: openMacroBrowserToEditExistingMacro, openMacroBrowserForInitialConfiguration: openMacroBrowserForInitialConfiguration, setActiveModal: setActiveModal, openConnectionsPanel: openConnectionsPanel, openConfigPanel: openConfigPanel, openSmartButtonConfigPanel: openSmartButtonConfigPanel, closeActiveModal: closeActiveModal, getMigrationExtensionManifest: getMigrationExtensionManifest, extensionContextProvider: extensionContextProvider, subscribeDocChange: subscribeDocChange, unsubscribeDocChange: unsubscribeDocChange, onCompleteCallback: onCompleteCallback, analyticsContext: analyticsContext, isLivePage: isLivePage, allowCreateDatabaseExtension: allowCreateDatabaseExtension, allowDatabaseQuickInsert: allowDatabaseQuickInsert, allowCreateWhiteboardExtension: allowCreateWhiteboardExtension, allowCreateWithRovoExtension: allowCreateWithRovoExtension, openSmartCreationModal: openSmartCreationModal, rovoSkillsConfig: rovoSkillsConfig, flags: flags, editorAPI: editorAPI, setUpsellModalSource: setUpsellModalSource, hideGlassPaneForForge: hideGlassPaneForForge, isFullPageEditor: isFullPageEditor, allowLegacyMacros: allowLegacyMacros, allowCompanyHubExclusiveExtensions: allowCompanyHubExclusiveExtensions, isCollabEditForLiveUpdatesEnabled: isCollabEditForLiveUpdatesEnabled, setQueryParams: setQueryParams, isBlockTemplateQuickInsertEnabled: isBlockTemplateQuickInsertEnabled, snippets: snippets, experienceTracker: experienceTracker, edition: edition, isSmartButtonAllowed: isSmartButtonAllowed, isAdmin: isAdmin, userId: userId, isPublishedPage: isPublishedPage, connectedProductKeysPromise: connectedProductKeysPromise, allowAgentManagedExtensionProvider: allowAgentManagedExtensionProvider })=>{
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const pageContext = {
        contentId: contentId,
        contentTitle: contentTitle,
        spaceKey: spaceKey,
        spaceId: spaceId,
        features: {
            configPanel: {
                enabled: true,
                optedOut: (0, $fgd2r.getOptedOutMacros)()
            },
            elementBrowser: true
        }
    };
    const extensionHandlers = (0, $lvKPs.getFullPageExtensionHandlers)({
        contentId: contentId,
        spaceKey: spaceKey,
        extensionContextProvider: extensionContextProvider,
        editorActions: editorActions,
        subscribeDocChange: subscribeDocChange,
        unsubscribeDocChange: unsubscribeDocChange,
        isLivePage: isLivePage,
        isCollabEditForLiveUpdatesEnabled: isCollabEditForLiveUpdatesEnabled
    });
    const macroConfig = {
        contentId: contentId,
        setActiveModal: setActiveModal,
        closeActiveModal: closeActiveModal
    };
    const hideCreateContentMacros = isCompanyHub && (0, $9wGTI.fg)('company-hub-hide-create-content-macros');
    const confluenceMacroExtensionProviderForEditor = (0, $bfil7.getConfluenceMacrosExtensionProviderForEditor)(pageContext, extensionHandlers, editorAPI ?? undefined, editorActions, macroConfig, getMigrationExtensionManifest || $f03f53a782506f81$var$noop, openMacroBrowserToEditExistingMacro || $f03f53a782506f81$var$noop, openMacroBrowserForInitialConfiguration || $f03f53a782506f81$var$noop, intlNext, createAnalyticsEvent, onCompleteCallback, isLivePage, flags, experienceTracker, contentType, allowCreateDatabaseExtension && !hideCreateContentMacros, allowDatabaseQuickInsert, allowCreateWhiteboardExtension && !hideCreateContentMacros, allowCreateWithRovoExtension, openSmartCreationModal, rovoSkillsConfig, allowLegacyMacros, isCompanyHub, undefined, allowAgentManagedExtensionProvider);
    const extensionProvidersList = [];
    extensionProvidersList.push(confluenceMacroExtensionProviderForEditor);
    const extensions = [];
    extensions.push((0, $fgEJD.default)({
        appKey: (0, $4U6ec.DROPBOX_APP_KEY),
        canMountinIframe: false
    }));
    if (!hideCreateContentMacros) extensions.push((0, $nFs2M.manifest)({
        intl: intlNext,
        defaultCloudId: cloudId,
        defaultFormValues: {
            'confluence-page': {
                parentId: contentId,
                spaceId: spaceId
            }
        },
        analyticsContext: analyticsContext,
        pageContext: {
            isLivePage: isLivePage,
            isBlogpost: contentType === 'blogpost',
            isFullPageEditor: isFullPageEditor
        },
        location: 'confluence-page',
        allowConfluenceEditViewEmbed: true,
        flags: {
            showSuccess: ({ title: title, description: description, actions: actions })=>{
                flags?.showSuccessFlag({
                    title: title,
                    description: description,
                    actions: actions,
                    isAutoDismiss: true
                });
            },
            showFailure: ({ title: title, description: description, actions: actions })=>{
                flags?.showErrorFlag({
                    title: title,
                    description: description,
                    actions: actions,
                    isAutoDismiss: true
                });
            }
        }
    }));
    extensionProvidersList.push(new (0, $bdpeX.default)(extensions));
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const showPremiumExtensions = isAdmin || isPremium;
    const premiumExtensions = showPremiumExtensions ? (0, $gH8jv.createPremiumExtensionManifests)({
        contentId: contentId,
        editorActions: editorActions,
        openConfigPanel: openConfigPanel,
        intl: intlNext,
        setUpsellModalSource: setUpsellModalSource,
        allowCompanyHubExclusiveExtensions: allowCompanyHubExclusiveExtensions
    }) : [];
    extensionProvidersList.push(new (0, $bdpeX.default)(premiumExtensions));
    // Don't add the Smart Button extension if we're in the Company Hub,
    // the company-hub-migration-prevent-1p-macro experiment is enabled,
    // and the company-hub-prevent-1p-macro-via-tap-trait gate returns false.
    // company-hub-prevent-1p-macro-via-tap-trait is controlled by a tap trait that checks if a tenant's company hub
    // has been published with unsupported 1p macros in the last 4 months,
    // in which case we will allow them to insert Smart Button, an unsupported 1p macro.
    if (!isCompanyHub || !(0, $6mKj3.expVal)('company-hub-migration-prevent-1p-macro', 'isEnabled', false) || (0, $9wGTI.fg)('company-hub-prevent-1p-macro-via-tap-trait')) extensionProvidersList.push((0, $jRxDI.smartButtonExtensionProvider)({
        contentId: contentId,
        editorActions: editorActions,
        openSmartButtonConfigPanel: openSmartButtonConfigPanel,
        intl: intlNext,
        isSmartButtonAllowed: isSmartButtonAllowed,
        contentType: contentType
    }));
    extensionProvidersList.push((0, $6b7RE.projectLinkerExtensionProvider)({
        cloudId: cloudId,
        intl: intlNext,
        editorActions: editorActions,
        createAnalyticsEvent: createAnalyticsEvent
    }));
    extensionProvidersList.push((0, $7PHx9.connectChartExtensionProvider)(intlNext, editorActions, openConnectionsPanel, createAnalyticsEvent));
    extensionProvidersList.push((0, $1M1t5.referentialityExtensionProvider)({
        intl: intlNext,
        openConnectionsPanel: openConnectionsPanel,
        createAnalyticsEvent: createAnalyticsEvent
    }));
    if ((0, $6mKj3.UNSAFE_expValNoExposure)('cc-maui-experiment', 'isEnabled', false) || (0, $9wGTI.fg)('platform_native_embeds_rollout_non_maui_experience')) {
        const pageMode = isLivePage ? 'live' : 'edit';
        const analyticsPageMode = isPublishedPage ? 'view' : pageMode;
        const nativeEmbedAnalyticsPageContext = {
            spaceId: spaceId,
            isLivePage: !!isLivePage,
            pageMode: analyticsPageMode
        };
        const nativeEmbedExtension = (0, $7rOWN.createManifest)(isPublishedPage, editorAPI ?? undefined, undefined, (0, $eeCnx.createMauiNativeEmbedBannerRenderer)(editorAPI ?? undefined), nativeEmbedAnalyticsPageContext);
        extensionProvidersList.push(new (0, $bdpeX.default)([
            nativeEmbedExtension
        ], nativeEmbedExtension.modules?.autoConvert?.url ?? []));
    } else if ((0, $9wGTI.fg)('platform_editor_native_embeds_fallback_transform')) extensionProvidersList.push(new (0, $bdpeX.default)([
        (0, $etDDt.createNativeEmbedsFallbackManifest)(editorAPI ?? undefined)
    ]));
    if ((0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false)) {
        const shouldAddBlockTemplateQuickInsert = isBlockTemplateQuickInsertEnabled && (0, $6mKj3.expVal)('platform_editor_blocks_conf', 'isEnabled', false);
        const onOpenTemplatePanel = ()=>{
            if (setQueryParams) (0, $lJDEI.setInEditorTemplatesPanelQueryParam)(setQueryParams, (0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_KEEP_OPEN), (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_BLOCK));
        };
        extensionProvidersList.push((0, $iONqR.snippetExtensionProvider)(intlNext, snippets, shouldAddBlockTemplateQuickInsert ? onOpenTemplatePanel : undefined, userId, createAnalyticsEvent));
    }
    if ((0, $6mKj3.expVal)('confluence_quick_insert_embeds', 'cohort', 'control') !== 'control') extensionProvidersList.push((0, $jgzkh.createThirdPartyQuickInsertExtensionProvider)({
        editorActions: editorActions,
        intlNext: intlNext,
        createAnalyticsEvent: createAnalyticsEvent,
        cohort: (0, $6mKj3.expVal)('confluence_quick_insert_embeds', 'cohort', 'control'),
        connectedProductKeysPromise: connectedProductKeysPromise
    }));
    extensionProvidersList.push((0, $aIqlA.getForgeExtensionHandler)({
        spaceKey: spaceKey,
        spaceId: spaceId,
        contentId: contentId,
        contentType: contentType,
        contentVersion: contentVersion,
        contentMode: contentMode,
        mentionProvider: mentionProvider,
        isEditing: true,
        connectExtensionProvider: confluenceMacroExtensionProviderForEditor,
        editorActions: editorActions,
        hideGlassPaneForForge: hideGlassPaneForForge,
        intl: intlNext,
        locale: intlNext.locale,
        isLivePage: !!isLivePage,
        editorAPI: editorAPI,
        useGetContextToken: $1JyKZ.useGetContextToken
    }));
    return extensionProvidersList;
});
const $f03f53a782506f81$var$_getExtensionRelatedProps = (0, $dOBRD.default)(({ cloudId: cloudId, contentId: contentId, contentTitle: contentTitle, contentType: contentType, contentVersion: contentVersion, contentMode: contentMode, editorActions: editorActions, createAnalyticsEvent: createAnalyticsEvent, mentionProvider: mentionProvider, spaceKey: spaceKey, spaceId: spaceId, openMacroBrowserToEditExistingMacro: // Props from ClassicEditorContext
openMacroBrowserToEditExistingMacro, openMacroBrowserForInitialConfiguration: openMacroBrowserForInitialConfiguration, setActiveModal: setActiveModal, openConnectionsPanel: openConnectionsPanel, openConfigPanel: openConfigPanel, openSmartButtonConfigPanel: openSmartButtonConfigPanel, closeActiveModal: closeActiveModal, getMigrationExtensionManifest: getMigrationExtensionManifest, extensionContextProvider: extensionContextProvider, intlNext: intlNext, featureFlagClient: featureFlagClient, subscribeDocChange: subscribeDocChange, unsubscribeDocChange: unsubscribeDocChange, onCompleteCallback: onCompleteCallback, analyticsContext: analyticsContext, isLivePage: isLivePage, allowCreateDatabaseExtension: allowCreateDatabaseExtension, allowDatabaseQuickInsert: allowDatabaseQuickInsert, allowCreateWhiteboardExtension: allowCreateWhiteboardExtension, allowCreateWithRovoExtension: allowCreateWithRovoExtension, openSmartCreationModal: openSmartCreationModal, rovoSkillsConfig: rovoSkillsConfig, flags: flags, aiOptInStatus: aiOptInStatus, editorAPI: editorAPI, setUpsellModalSource: setUpsellModalSource, hideGlassPaneForForge: hideGlassPaneForForge, isFullPageEditor: isFullPageEditor, allowLegacyMacros: allowLegacyMacros, allowCompanyHubExclusiveExtensions: allowCompanyHubExclusiveExtensions, isCollabEditForLiveUpdatesEnabled: isCollabEditForLiveUpdatesEnabled, setQueryParams: setQueryParams, isBlockTemplateQuickInsertEnabled: isBlockTemplateQuickInsertEnabled, snippets: snippets, experienceTracker: experienceTracker, edition: edition, isSmartButtonAllowed: isSmartButtonAllowed, isAdmin: isAdmin, userId: userId, isPublishedPage: isPublishedPage, connectedProductKeysPromise: connectedProductKeysPromise, allowAgentManagedExtensionProvider: allowAgentManagedExtensionProvider })=>{
    const extensionProviders = $f03f53a782506f81$var$_getClassicEditorProviders({
        cloudId: cloudId,
        contentId: contentId,
        contentTitle: contentTitle,
        contentType: contentType,
        contentVersion: contentVersion,
        contentMode: contentMode,
        spaceKey: spaceKey,
        spaceId: spaceId,
        editorActions: editorActions,
        createAnalyticsEvent: createAnalyticsEvent,
        mentionProvider: mentionProvider,
        intlNext: intlNext,
        featureFlagClient: featureFlagClient,
        openMacroBrowserToEditExistingMacro: openMacroBrowserToEditExistingMacro,
        openMacroBrowserForInitialConfiguration: openMacroBrowserForInitialConfiguration,
        setActiveModal: setActiveModal,
        openConnectionsPanel: openConnectionsPanel,
        openConfigPanel: openConfigPanel,
        openSmartButtonConfigPanel: openSmartButtonConfigPanel,
        closeActiveModal: closeActiveModal,
        getMigrationExtensionManifest: getMigrationExtensionManifest,
        extensionContextProvider: extensionContextProvider,
        subscribeDocChange: subscribeDocChange,
        unsubscribeDocChange: unsubscribeDocChange,
        onCompleteCallback: onCompleteCallback,
        analyticsContext: analyticsContext,
        isLivePage: isLivePage,
        allowCreateDatabaseExtension: allowCreateDatabaseExtension,
        allowDatabaseQuickInsert: allowDatabaseQuickInsert,
        allowCreateWhiteboardExtension: allowCreateWhiteboardExtension,
        allowCreateWithRovoExtension: allowCreateWithRovoExtension,
        openSmartCreationModal: openSmartCreationModal,
        rovoSkillsConfig: rovoSkillsConfig,
        flags: flags,
        snippets: snippets,
        aiOptInStatus: aiOptInStatus,
        editorAPI: editorAPI,
        setUpsellModalSource: setUpsellModalSource,
        hideGlassPaneForForge: hideGlassPaneForForge,
        isFullPageEditor: isFullPageEditor,
        allowLegacyMacros: allowLegacyMacros,
        allowCompanyHubExclusiveExtensions: allowCompanyHubExclusiveExtensions,
        isCollabEditForLiveUpdatesEnabled: isCollabEditForLiveUpdatesEnabled,
        setQueryParams: setQueryParams,
        isBlockTemplateQuickInsertEnabled: isBlockTemplateQuickInsertEnabled,
        experienceTracker: experienceTracker,
        edition: edition,
        isSmartButtonAllowed: isSmartButtonAllowed,
        isAdmin: isAdmin,
        userId: userId,
        isPublishedPage: isPublishedPage,
        connectedProductKeysPromise: connectedProductKeysPromise,
        allowAgentManagedExtensionProvider: allowAgentManagedExtensionProvider
    });
    const allowExtension = {
        allowBreakout: true,
        allowExtendFloatingToolbars: true
    };
    return {
        allowExtension: allowExtension,
        extensionProviders: extensionProviders
    };
});
const $f03f53a782506f81$export$d22e3badff9938a7 = ({ contentId: contentId, contentTitle: contentTitle, contentType: contentType, contentVersion: contentVersion, editorActions: editorActions, mentionProvider: mentionProvider, spaceKey: spaceKey, spaceId: spaceId, contentMode: contentMode, extensionContextProvider: extensionContextProvider, openConnectionsPanel: openConnectionsPanel, openConfigPanel: openConfigPanel, openSmartButtonConfigPanel: openSmartButtonConfigPanel, onCompleteCallback: onCompleteCallback, isLivePage: isLivePage, allowCreateDatabaseExtension: allowCreateDatabaseExtension, allowDatabaseQuickInsert: allowDatabaseQuickInsert, allowCreateWhiteboardExtension: allowCreateWhiteboardExtension, allowCreateWithRovoExtension: allowCreateWithRovoExtension, openSmartCreationModal: openSmartCreationModal, rovoSkillsConfig: rovoSkillsConfig, flags: flags, aiOptInStatus: aiOptInStatus, editorAPI: editorAPI, setUpsellModalSource: setUpsellModalSource, isFullPageEditor: isFullPageEditor = false, allowLegacyMacros: allowLegacyMacros = false, allowCompanyHubExclusiveExtensions: allowCompanyHubExclusiveExtensions = false, isCollabEditForLiveUpdatesEnabled: isCollabEditForLiveUpdatesEnabled })=>{
    const { openMacroBrowserForInitialConfiguration: openMacroBrowserForInitialConfiguration, openMacroBrowserToEditExistingMacro: openMacroBrowserToEditExistingMacro, loadMacroBrowserResources: loadMacroBrowserResources, setActiveModal: setActiveModal, closeActiveModal: closeActiveModal, getMigrationExtensionManifest: getMigrationExtensionManifest, getExtensionHandlers: getExtensionHandlers, populateExtensionProviders: populateExtensionProviders } = (0, $cozmU.useContext)((0, $giS6h.ClassicEditorContext));
    const { cloudId: cloudId, featureFlagClient: featureFlagClient, edition: edition, userId: userId, activationId: activationId, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const { isSmartButtonAllowed: isSmartButtonAllowed } = (0, $iz4WO.useSmartButtonPremiumGate)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const isAdmin = (0, $8Lx5S.useIsAdmin)();
    const shouldShowPremiumUpsell = (0, $2YtTU.usePremiumGate)();
    const intlNext = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    // Trigger loading of macro browser resources
    (0, $cozmU.useEffect)(()=>{
        if (loadMacroBrowserResources) loadMacroBrowserResources();
    }, [
        loadMacroBrowserResources
    ]);
    const { subscribeDocChange: subscribeDocChange, unsubscribeDocChange: unsubscribeDocChange } = (0, $3IZob.useDocChangeContext)();
    const analyticsContext = (0, $cozmU.useContext)((0, $3ge84.default));
    const { isTemplateBrowserEnabled: isTemplateBrowserEnabled } = (0, $9bL1w.useEmbeddedEditPageFeatures)();
    const isEmbeddedConfluence = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    // Enable block template quick insert when we are not in embedded Confluence or when in embedded Confluence andthe template browser is enabled
    const isBlockTemplateQuickInsertEnabled = !isEmbeddedConfluence || !!isTemplateBrowserEnabled;
    // Get snippets snapshot without subscribing to avoid re-renders
    const { snippets: snippets, isLoading: snippetsLoading, isLoaded: snippetsLoaded } = (0, $dZUkS.getSnippetsStateSnapshot)();
    // If snippets are still loading, register a callback to add them to quick insert when done.
    // Only register when quick insert is enabled (not gated off in Embedded Confluence).
    (0, $cozmU.useEffect)(()=>{
        if (isBlockTemplateQuickInsertEnabled && snippetsLoading && !snippetsLoaded && editorAPI) (0, $fxClS.registerSnippetsQuickInsertOnLoad)(editorAPI, userId);
    // Only watch editorAPI - we check the loading state from the snapshot at render time
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        editorAPI
    ]);
    // TODO: Currently, Forge macros can only be non-bodied, but there's work
    // underway to allow for bodied macros. When that's complete, we'll need
    // to update this to be contingent on the macro type.
    const hideGlassPaneForForge = (0, $aQw7y.useShouldHideOverlay)('forge', false);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isPublishedPage = pageMode === (0, $cD1qu.PageMode).VIEW;
    // Third-party quick-insert items are filtered to products the user has actually
    // connected. We only fetch that connector config for the experiment cohort, so
    // the request stays scoped. Reading the cohort without exposure here — the
    // authoritative exposure is fired inside the provider builder.
    const isQuickInsertEmbedsEnabled = (0, $6mKj3.UNSAFE_expValNoExposure)('confluence_quick_insert_embeds', 'cohort', 'control') !== 'control';
    const connectedProductKeys = (0, $glRTB.useConnectedThirdPartyProductKeys)(isQuickInsertEmbedsEnabled);
    // Bridge the async connected-product keys into a single stable promise.
    // `connectedProductKeys` transitions from `undefined` to a `Set` once the
    // connector-config request resolves; feeding that value straight into the
    // extension-provider memo would rebuild every provider and force the editor to
    // re-initialise mid-load. Instead we hand the third-party provider a promise
    // with a stable identity so the editor keeps the same `extensionProviders`
    // array and just picks up the quick-insert items when the request settles.
    const connectedProductKeysDeferredRef = (0, $cozmU.useRef)(null);
    if (connectedProductKeysDeferredRef.current === null) {
        let resolveConnectedProductKeys = ()=>{};
        const promise = new Promise((resolve)=>{
            resolveConnectedProductKeys = resolve;
        });
        connectedProductKeysDeferredRef.current = {
            promise: promise,
            resolve: resolveConnectedProductKeys
        };
    }
    (0, $cozmU.useEffect)(()=>{
        if (connectedProductKeys !== undefined) connectedProductKeysDeferredRef.current?.resolve(connectedProductKeys);
    }, [
        connectedProductKeys
    ]);
    const connectedProductKeysPromise = connectedProductKeysDeferredRef.current.promise;
    const extensionOptions = (0, $cozmU.useMemo)(()=>$f03f53a782506f81$var$_getExtensionRelatedProps({
            cloudId: cloudId,
            activationId: activationId,
            contentId: contentId,
            contentTitle: contentTitle,
            contentType: contentType,
            contentVersion: contentVersion,
            contentMode: contentMode,
            editorActions: editorActions,
            createAnalyticsEvent: createAnalyticsEvent,
            mentionProvider: mentionProvider,
            spaceKey: spaceKey,
            spaceId: spaceId,
            openMacroBrowserForInitialConfiguration: openMacroBrowserForInitialConfiguration,
            openMacroBrowserToEditExistingMacro: openMacroBrowserToEditExistingMacro,
            setActiveModal: setActiveModal,
            openConnectionsPanel: openConnectionsPanel,
            openConfigPanel: openConfigPanel,
            openSmartButtonConfigPanel: openSmartButtonConfigPanel,
            closeActiveModal: closeActiveModal,
            getMigrationExtensionManifest: getMigrationExtensionManifest,
            extensionContextProvider: extensionContextProvider,
            intlNext: intlNext,
            featureFlagClient: featureFlagClient,
            subscribeDocChange: subscribeDocChange,
            unsubscribeDocChange: unsubscribeDocChange,
            onCompleteCallback: onCompleteCallback,
            analyticsContext: analyticsContext,
            isLivePage: isLivePage,
            allowCreateDatabaseExtension: allowCreateDatabaseExtension,
            allowDatabaseQuickInsert: allowDatabaseQuickInsert,
            allowCreateWhiteboardExtension: allowCreateWhiteboardExtension,
            allowCreateWithRovoExtension: allowCreateWithRovoExtension,
            openSmartCreationModal: openSmartCreationModal,
            rovoSkillsConfig: rovoSkillsConfig,
            flags: flags,
            aiOptInStatus: aiOptInStatus,
            editorAPI: editorAPI,
            setUpsellModalSource: shouldShowPremiumUpsell ? setUpsellModalSource : undefined,
            hideGlassPaneForForge: hideGlassPaneForForge,
            isFullPageEditor: isFullPageEditor,
            allowLegacyMacros: allowLegacyMacros,
            allowCompanyHubExclusiveExtensions: allowCompanyHubExclusiveExtensions,
            isCollabEditForLiveUpdatesEnabled: isCollabEditForLiveUpdatesEnabled,
            setQueryParams: setQueryParams,
            isBlockTemplateQuickInsertEnabled: isBlockTemplateQuickInsertEnabled,
            snippets: snippets,
            experienceTracker: experienceTracker,
            edition: edition,
            isSmartButtonAllowed: isSmartButtonAllowed,
            isAdmin: isAdmin,
            userId: userId,
            isPublishedPage: isPublishedPage,
            connectedProductKeysPromise: connectedProductKeysPromise,
            allowAgentManagedExtensionProvider: isRovoLLMEnabled
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        contentId,
        contentVersion,
        spaceKey,
        editorAPI,
        spaceId,
        // `connectedProductKeysPromise` has a stable identity (see the deferred ref
        // above), so it is intentionally omitted here — the third-party provider is
        // built once and resolves its manifest when the connector config settles,
        // which avoids rebuilding the editor's extension providers mid-load.
        isRovoLLMEnabled
    ]);
    return {
        extensionOptions: extensionOptions,
        rendererExtensionOptions: {
            getExtensionHandlers: getExtensionHandlers,
            populateExtensionProviders: populateExtensionProviders
        }
    };
};
module.exports["useExtensionOptions"] = $f03f53a782506f81$export$d22e3badff9938a7;

});

parcelRegister("fgEJD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $fRQ3t = parcelRequire("fRQ3t");


var $fGQsh = parcelRequire("fGQsh");


var $ieeJu = parcelRequire("ieeJu");


var $ffHos = parcelRequire("ffHos");


var $1rTuu = parcelRequire("1rTuu");


async function $a483c26c85115b09$var$pickFromDropbox(appKey, canMountinIframe) {
    await (0, $ffHos.default)(appKey);
    let popupMountPoint;
    let root = null;
    // BC - as of 2020-01-21 this does not work, as no dropbox app we have is authorised
    // to iframe in the picker - we are currently waiting for permissions.
    // To test the picker, comment out the render call, and the `iframe` and `winowName` options
    if (canMountinIframe) {
        const Modal = await (parcelRequire("lsNYE"));
        // The decision has been made to simply append our modal to the body
        // Using the passed in popupMountPoint has the potential to cause
        // problems, and several users pass down document.body anyway
        //
        // We want to append it and attach it to a new div so we have complete control.
        popupMountPoint = document.getElementById((0, $1rTuu.POPUP_MOUNTPOINT));
        if (!popupMountPoint) {
            popupMountPoint = document.createElement('div');
            popupMountPoint.id = (0, $1rTuu.POPUP_MOUNTPOINT);
            document.body.appendChild(popupMountPoint);
        }
        if ((0, $ieeJu.expValEquals)('platform_editor_react19_migration', 'isEnabled', true)) {
            root = (0, $fRQ3t.createRoot)(popupMountPoint);
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal.default, {
                onClose: ()=>{}
            }));
        } else // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal.default, {
            onClose: ()=>{}
        }), popupMountPoint);
    }
    let files;
    try {
        files = await new Promise((resolve, reject)=>{
            window.Dropbox.choose({
                iframe: canMountinIframe,
                windowName: canMountinIframe ? (0, $1rTuu.DROPBOX_IFRAME_NAME) : undefined,
                success: resolve,
                cancel: reject
            });
        });
    // eslint-disable-next-line no-unused-vars
    } catch (e) {
        if ((0, $ieeJu.expValEquals)('platform_editor_react19_migration', 'isEnabled', true)) {
            if (root) root.unmount();
        } else if (popupMountPoint) (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).unmountComponentAtNode(popupMountPoint);
        return;
    }
    let node;
    if (!files.length) {
        if ((0, $ieeJu.expValEquals)('platform_editor_react19_migration', 'isEnabled', true)) {
            if (root) root.unmount();
        } else if (popupMountPoint) (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).unmountComponentAtNode(popupMountPoint);
        return;
    }
    const newNodes = files.map((file)=>(0, $fGQsh.inlineCard)({
            url: file.link
        }));
    if (newNodes.length === 1) node = newNodes[0];
    else // NOTE: we are not currently passing in `multiselect`, so this is not a possible state,
    // but we likely want to allow multiselect in the future so doing some future-proofing
    node = {
        type: 'paragraph',
        content: newNodes
    };
    if ((0, $ieeJu.expValEquals)('platform_editor_react19_migration', 'isEnabled', true)) {
        if (root) root.unmount();
    } else if (popupMountPoint) (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).unmountComponentAtNode(popupMountPoint);
    return node;
}



const $a483c26c85115b09$var$manifestFunction = ({ appKey: appKey, canMountinIframe: canMountinIframe })=>({
        title: 'Dropbox',
        type: 'com.dropbox.fabric',
        key: 'dropbox',
        description: 'Embed Dropbox file to collaborate with your team',
        icons: {
            '16': ()=>(parcelRequire("fzDlG")).then((mod)=>mod.default),
            '24': ()=>(parcelRequire("fzDlG")).then((mod)=>mod.default),
            '48': ()=>(parcelRequire("fzDlG")).then((mod)=>mod.default)
        },
        modules: {
            quickInsert: [
                {
                    key: 'item',
                    action: ()=>// eslint-disable-next-line no-async-promise-executor
                        new Promise(async (resolve, reject)=>{
                            try {
                                const newNode = await $a483c26c85115b09$var$pickFromDropbox(appKey, canMountinIframe);
                                if (!newNode) reject();
                                else resolve(newNode);
                            } catch (e) {
                                reject(e);
                            }
                        })
                }
            ]
        }
    });
var $a483c26c85115b09$export$2e2bcd8739ae039 = $a483c26c85115b09$var$manifestFunction;
module.exports["default"] = $a483c26c85115b09$export$2e2bcd8739ae039;

});

parcelRegister("ffHos", function(module, exports) {
$parcel$export(module.exports, "default", () => $be3a3f6f185e575f$export$2e2bcd8739ae039);
// Ignored via go/ees005
// eslint-disable-next-line require-await

var $be3a3f6f185e575f$export$2e2bcd8739ae039 = async (appKey)=>{
    if (!window.Dropbox) // The dropbox script is in no way typescript, and is not our code
    // It attached the `Dropbox` property to window.
    // @ts-ignore
    return (parcelRequire("lhBxx")).then(()=>{
        window.Dropbox.appKey = appKey;
    });
    else {
        window.Dropbox.appKey = appKey;
        return Promise.resolve();
    }
};

});

parcelRegister("lhBxx", function(module, exports) {

let $f7e84e250600bd73$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f7e84e250600bd73$var$load("cDDxK").then(()=>parcelRequire('fBDwQ'));

});

parcelRegister("1rTuu", function(module, exports) {
const $1af081a1ec8141ce$export$6a428e19cddf769b = 'twp-dropbox-popup-mount-point';
const $1af081a1ec8141ce$export$5719e9fb73d0a1be = 'twp-dropboxjs-iframe';
module.exports["POPUP_MOUNTPOINT"] = $1af081a1ec8141ce$export$6a428e19cddf769b;
module.exports["DROPBOX_IFRAME_NAME"] = $1af081a1ec8141ce$export$5719e9fb73d0a1be;

});

parcelRegister("lsNYE", function(module, exports) {

let $fa02faf0a24d1223$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fa02faf0a24d1223$var$load("1chJD").then(()=>parcelRequire('7Elgg'));

});

parcelRegister("fzDlG", function(module, exports) {

let $b568a5badc3859e2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b568a5badc3859e2$var$load("OggOY").then(()=>parcelRequire('jBe45'));

});

parcelRegister("nFs2M", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

parcelRequire("eRn3r");
var $9aUDG = parcelRequire("9aUDG");
var $3QYdZ = parcelRequire("3QYdZ");


var $kSwu1 = parcelRequire("kSwu1");


var $9kbTQ = parcelRequire("9kbTQ");


var $gBjHb = parcelRequire("gBjHb");


var $ixfCV = parcelRequire("ixfCV");


var $8dxef = parcelRequire("8dxef");


var $7QClO = parcelRequire("7QClO");


var $8ZNTx = parcelRequire("8ZNTx");


var $6y2do = parcelRequire("6y2do");


var $hA0gf = parcelRequire("hA0gf");


var $fk1wh = parcelRequire("fk1wh");

// as const so that values can be looked up for i18n in ./ui/messages/keywords
const $8bf6b0a23ed1ec82$var$JIRA_KEYWORDS = [
    'create',
    'issue',
    'ticket',
    'raise',
    'new'
];
const $8bf6b0a23ed1ec82$var$CONFLUENCE_KEYWORDS = [
    'create',
    'page',
    'new',
    'space',
    'publish'
];
// categories will put us into tabs in the quick insert browser (the plus menu)
const $8bf6b0a23ed1ec82$var$JIRA_CATEGORIES = [
    'development',
    'external-content'
];
const $8bf6b0a23ed1ec82$var$CONFLUENCE_CATEGORIES = [
    'confluence-content'
];



const $8bf6b0a23ed1ec82$export$e538f94cc8cf4db8 = ({ intl: intl, intlLocale: intlLocale, defaultCloudId: defaultCloudId, analyticsContext: analyticsContext, location: location, gatewayBaseUrl: gatewayBaseUrl, flags: flags, defaultFormValues: defaultFormValues, pageContext: pageContext, allowConfluenceEditViewEmbed: allowConfluenceEditViewEmbed })=>{
    const formatMessage = (descriptor)=>{
        return intl?.formatMessage(descriptor) ?? descriptor.defaultMessage;
    };
    return {
        title: 'Link create editor extension',
        type: 'extension',
        key: 'com.atlassian.linking-platform.create',
        description: 'Configures quick insert commands for creating objects, like Jira issues and Confluence pages as links',
        icons: {
            '48': ()=>(parcelRequire("3LnW2")).then((mod)=>mod.default)
        },
        modules: {
            quickInsert: [
                {
                    key: 'linking-platform-create-jira-issue',
                    title: formatMessage((0, $ixfCV.fg)('jira-issue-terminology-update-m4') ? (0, $8ZNTx.jiraExtensionMessages).extensionTitleIssueTerminologyRefreshM4 : (0, $8ZNTx.jiraExtensionMessages).extensionTitle),
                    description: formatMessage((0, $ixfCV.fg)('jira-issue-terminology-update-m4') ? (0, $8ZNTx.jiraExtensionMessages).extensionDescriptionIssueTerminologyRefreshM4 : (0, $8ZNTx.jiraExtensionMessages).extensionDescription),
                    featured: true,
                    categories: $8bf6b0a23ed1ec82$var$JIRA_CATEGORIES,
                    keywords: [
                        'jira',
                        ...$8bf6b0a23ed1ec82$var$JIRA_KEYWORDS.map((keyword)=>formatMessage((0, $hA0gf.keywords)[keyword]))
                    ],
                    icon: ()=>(parcelRequire("3LnW2")).then((mod)=>mod.default),
                    action: async ()=>$8bf6b0a23ed1ec82$var$showCreateModal({
                            intl: intl,
                            intlLocale: intlLocale,
                            defaultCloudId: defaultCloudId,
                            analyticsContext: analyticsContext,
                            entityKey: 'jira-issue',
                            gatewayBaseUrl: gatewayBaseUrl,
                            location: location,
                            flags: flags,
                            defaultFormValues: defaultFormValues
                        })
                },
                {
                    key: 'linking-platform-create-confluence-page',
                    title: formatMessage((0, $6y2do.confluenceExtensionMessages).extensionTitle),
                    description: formatMessage((0, $6y2do.confluenceExtensionMessages).extensionDescription),
                    featured: true,
                    categories: $8bf6b0a23ed1ec82$var$CONFLUENCE_CATEGORIES,
                    keywords: [
                        'confluence',
                        ...$8bf6b0a23ed1ec82$var$CONFLUENCE_KEYWORDS.map((keyword)=>formatMessage((0, $hA0gf.keywords)[keyword]))
                    ],
                    icon: ()=>Promise.resolve((parcelRequire("hMaHH"))).then((mod)=>mod.default),
                    action: async ()=>{
                        // Only do one step page creation if we are
                        // 1. in the full page editor
                        // 2. not in a blogpost
                        // 3. not using Safari
                        const shouldUseOneStepCreate = location === 'confluence-page' && pageContext?.isFullPageEditor && !pageContext?.isBlogpost && !(0, $8dxef.getBrowserInfo)().safari;
                        if (shouldUseOneStepCreate) return $8bf6b0a23ed1ec82$var$oneStepCreate({
                            intl: intl,
                            intlLocale: intlLocale,
                            defaultCloudId: defaultCloudId,
                            analyticsContext: analyticsContext,
                            gatewayBaseUrl: gatewayBaseUrl,
                            flags: flags,
                            defaultFormValues: defaultFormValues
                        });
                        return $8bf6b0a23ed1ec82$var$showCreateModal({
                            intl: intl,
                            intlLocale: intlLocale,
                            defaultCloudId: defaultCloudId,
                            analyticsContext: analyticsContext,
                            entityKey: 'confluence-page',
                            gatewayBaseUrl: gatewayBaseUrl,
                            location: location,
                            flags: flags,
                            defaultFormValues: defaultFormValues,
                            allowConfluenceEditViewEmbed: allowConfluenceEditViewEmbed
                        });
                    }
                }
            ]
        }
    };
};
const $8bf6b0a23ed1ec82$var$DEFAULT_LOCALE = 'en';
const $8bf6b0a23ed1ec82$var$LINK_CREATE_REFERENCE_MOUNT_POINT_ID = 'link-create-mount-point';
const $8bf6b0a23ed1ec82$var$getMountPoint = ()=>{
    let modalEl = document.getElementById(`${$8bf6b0a23ed1ec82$var$LINK_CREATE_REFERENCE_MOUNT_POINT_ID}`);
    if (modalEl === null) {
        modalEl = document.createElement('div');
        modalEl.id = $8bf6b0a23ed1ec82$var$LINK_CREATE_REFERENCE_MOUNT_POINT_ID;
        document.body.appendChild(modalEl);
    }
    return modalEl;
};
const $8bf6b0a23ed1ec82$var$AnalyticsProviderWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, value: value } = t0;
    if (value === undefined) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== children || $[3] !== value) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7QClO.LinkCreateModalProvider), {
            value: value
        }, children);
        $[2] = children;
        $[3] = value;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ children: children, value: value })=>{
    if (value === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7QClO.LinkCreateModalProvider), {
        value: value
    }, children);
};

const $8bf6b0a23ed1ec82$var$LazyEditorExtensionLinkCreate = (0, $9aUDG.lazy)(()=>(parcelRequire("lRbnR")).then(({ EditorExtensionLinkCreate: EditorExtensionLinkCreate })=>({
            default: EditorExtensionLinkCreate
        })));

const $8bf6b0a23ed1ec82$var$LazyOneStepLinkCreate = (0, $9aUDG.lazy)(()=>(parcelRequire("egPcE")).then(({ OneStepLinkCreate: OneStepLinkCreate })=>({
            default: OneStepLinkCreate
        })));
/*
 * Rather than rendering a modal and requesting user input, this function
 * creates a new page and immediately inserts it without any user input.
 * The title is generated on the backend so the new page is just created
 * and inserted as a smartlink. This is part of the Confluence Inline Create
 * One Step experiment.
 */ const $8bf6b0a23ed1ec82$var$oneStepCreate = ({ intl: intl, intlLocale: intlLocale, defaultCloudId: defaultCloudId, gatewayBaseUrl: gatewayBaseUrl, analyticsContext: analyticsContext, flags: flags, defaultFormValues: defaultFormValues })=>{
    return new Promise(async (res)=>{
        const mountPoint = $8bf6b0a23ed1ec82$var$getMountPoint();
        const handleCreate = (payload)=>{
            res({
                type: 'inlineCard',
                attrs: {
                    url: payload.url
                }
            });
            // Open the draft in a new tab and show the success flag
            const parentId = defaultFormValues?.['confluence-page']?.parentId ?? '';
            window.name = parentId;
            // createdFrom param indicates to the new draft window to show a success flag on load
            const url = new URL(payload.linkToOpen ?? payload.url);
            url.searchParams.set('createdFrom', parentId);
            window.open(url, '_blank');
        };
        const handleComplete = ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).unmountComponentAtNode(mountPoint);
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bf6b0a23ed1ec82$var$AnalyticsProviderWrapper, {
            value: analyticsContext
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            messages: intl?.messages ?? {},
            locale: intl?.locale ?? intlLocale ?? 'en',
            defaultLocale: $8bf6b0a23ed1ec82$var$DEFAULT_LOCALE,
            onError: intl?.onError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
            data: {
                source: 'inlineCreateOneStep',
                attributes: {
                    component: 'editorExtensionLinkCreate',
                    location: 'confluence-page',
                    triggeredFrom: 'quick-insert'
                }
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fk1wh.ErrorBoundary), {
            flags: flags,
            onError: ()=>{
                /**
             * If something goes wrong, resolve the promise to editor,
             * and unmount the component mountpoint
             */ res();
                handleComplete();
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3QYdZ.LazySuspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bf6b0a23ed1ec82$var$LazyOneStepLinkCreate, {
            onCreate: handleCreate,
            gatewayBaseUrl: gatewayBaseUrl,
            defaultCloudId: defaultCloudId,
            defaultFormValues: defaultFormValues
        })))))), mountPoint);
    });
};
const $8bf6b0a23ed1ec82$var$showCreateModal = ({ intl: intl, intlLocale: intlLocale, defaultCloudId: defaultCloudId, entityKey: entityKey, gatewayBaseUrl: gatewayBaseUrl, location: location, analyticsContext: analyticsContext, flags: flags, defaultFormValues: defaultFormValues, allowConfluenceEditViewEmbed: allowConfluenceEditViewEmbed })=>new Promise(async (res)=>{
        const mountPoint = $8bf6b0a23ed1ec82$var$getMountPoint();
        const handleCreate = (payload)=>{
            res({
                type: 'inlineCard',
                attrs: {
                    url: payload.url
                }
            });
        };
        const handleCancel = ()=>{
            res();
        };
        const handleCloseComplete = ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).unmountComponentAtNode(mountPoint);
        };
        (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bf6b0a23ed1ec82$var$AnalyticsProviderWrapper, {
            value: analyticsContext
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            messages: intl?.messages ?? {},
            locale: intl?.locale ?? intlLocale ?? 'en',
            defaultLocale: $8bf6b0a23ed1ec82$var$DEFAULT_LOCALE,
            onError: intl?.onError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
            data: {
                attributes: {
                    component: 'editorExtensionLinkCreate',
                    location: location,
                    triggeredFrom: 'quick-insert'
                }
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fk1wh.ErrorBoundary), {
            flags: flags,
            onError: ()=>{
                /**
           * If something goes wrong, resolve the promise to editor,
           * and unmount the component mountpoint
           */ res();
                handleCloseComplete();
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3QYdZ.LazySuspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bf6b0a23ed1ec82$var$LazyEditorExtensionLinkCreate, {
            defaultCloudId: defaultCloudId,
            gatewayBaseUrl: gatewayBaseUrl,
            defaultFormValues: defaultFormValues,
            entityKey: entityKey,
            onCreate: handleCreate,
            onCancel: handleCancel,
            onCloseComplete: handleCloseComplete,
            flags: flags,
            allowConfluenceEditViewEmbed: allowConfluenceEditViewEmbed
        })))))), mountPoint);
    });
module.exports["manifest"] = $8bf6b0a23ed1ec82$export$e538f94cc8cf4db8;

});

parcelRegister("eRn3r", function(module, exports) {
$parcel$export(module.exports, "lazyForPaint", () => (parcelRequire("9aUDG")).lazyForPaint);
$parcel$export(module.exports, "lazyAfterPaint", () => (parcelRequire("9aUDG")).lazyAfterPaint);
$parcel$export(module.exports, "lazy", () => (parcelRequire("9aUDG")).lazy);
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("3QYdZ")).LazySuspense);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("8r5Wf")).useLazyPhase);
parcelRequire("jxKH9");
var $3Pobi = parcelRequire("3Pobi");


var $5a3Es = parcelRequire("5a3Es");


var $9aUDG = parcelRequire("9aUDG");

parcelRequire("6VSrF");
var $86UVJ = parcelRequire("86UVJ");
var $dHqFW = parcelRequire("dHqFW");

parcelRequire("hZz7i");
var $3QYdZ = parcelRequire("3QYdZ");

parcelRequire("itHHy");
var $8r5Wf = parcelRequire("8r5Wf");


var $bvYi1 = parcelRequire("bvYi1");


});

parcelRegister("jxKH9", function(module, exports) {
$parcel$export(module.exports, "MODE", () => (parcelRequire("3Pobi")).MODE);

var $3Pobi = parcelRequire("3Pobi");

const $e3a55206c71bac9e$var$DEFAULT_CROSS_ORIGIN = undefined;
const $e3a55206c71bac9e$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $e3a55206c71bac9e$var$DEFAULT_MODE = (0, $3Pobi.MODE).HYDRATE;
const $e3a55206c71bac9e$var$DEFAULT_RETRY = 2;
const $e3a55206c71bac9e$var$config = {
    crossOrigin: $e3a55206c71bac9e$var$DEFAULT_CROSS_ORIGIN,
    manifest: $e3a55206c71bac9e$var$DEFAULT_MANIFEST,
    mode: $e3a55206c71bac9e$var$DEFAULT_MODE,
    retry: $e3a55206c71bac9e$var$DEFAULT_RETRY
};
const $e3a55206c71bac9e$export$44487a86467333c3 = ()=>$e3a55206c71bac9e$var$config;
const $e3a55206c71bac9e$export$940a7873bb071df8 = (nextConfig)=>{
    var _nextConfig$crossOrig, _nextConfig$manifest, _nextConfig$mode, _nextConfig$retry;
    $e3a55206c71bac9e$var$config.crossOrigin = (_nextConfig$crossOrig = nextConfig.crossOrigin) != null ? _nextConfig$crossOrig : $e3a55206c71bac9e$var$DEFAULT_CROSS_ORIGIN;
    $e3a55206c71bac9e$var$config.manifest = (_nextConfig$manifest = nextConfig.manifest) != null ? _nextConfig$manifest : $e3a55206c71bac9e$var$DEFAULT_MANIFEST;
    $e3a55206c71bac9e$var$config.mode = (_nextConfig$mode = nextConfig.mode) != null ? _nextConfig$mode : $e3a55206c71bac9e$var$DEFAULT_MODE;
    $e3a55206c71bac9e$var$config.retry = (_nextConfig$retry = nextConfig.retry) != null ? _nextConfig$retry : $e3a55206c71bac9e$var$DEFAULT_RETRY;
};
module.exports["getConfig"] = $e3a55206c71bac9e$export$44487a86467333c3;
module.exports["setConfig"] = $e3a55206c71bac9e$export$940a7873bb071df8;

});

parcelRegister("3Pobi", function(module, exports) {
const $2c98e46ce94c4b5d$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};
module.exports["MODE"] = $2c98e46ce94c4b5d$export$e48589d9e4824227;

});

parcelRegister("5a3Es", function(module, exports) {

var $eegtN = parcelRequire("eegtN");


var $jxKH9 = parcelRequire("jxKH9");

parcelRequire("itHHy");
var $ehkpF = parcelRequire("ehkpF");
var $8r5Wf = parcelRequire("8r5Wf");


var $hBrZE = parcelRequire("hBrZE");

const $3c20b80e9e8d3df3$export$33c5f161e1d4706 = {
    init: (config)=>{
        (0, $jxKH9.setConfig)(config);
        (0, $ehkpF.LISTENERS).length = 0;
        (0, $8r5Wf.setCurrent)(0);
        if (!(0, $hBrZE.isNodeEnvironment)()) (0, $eegtN.collect)();
    }
};

});

parcelRegister("eegtN", function(module, exports) {

var $jxKH9 = parcelRequire("jxKH9");
var $3Pobi = parcelRequire("3Pobi");


var $gy5kI = parcelRequire("gy5kI");


var $4qzp5 = parcelRequire("4qzp5");


var $8WAU6 = parcelRequire("8WAU6");

const $a5bf27f95a5c4338$export$bb44f104e3c54dae = ()=>{
    const markers = document.querySelectorAll('input[data-lazy-begin]');
    const { mode: mode } = (0, $jxKH9.getConfig)();
    for(let i = 0, j = markers.length; i < j; i += 1){
        const el = markers[i];
        const { lazyBegin: lazyBegin } = el.dataset || {};
        const value = mode === (0, $3Pobi.MODE).RENDER ? (0, $4qzp5.cloneElements)(markers[i], lazyBegin) : (0, $8WAU6.refElements)(markers[i], lazyBegin);
        if ((0, $gy5kI.COLLECTED).has(lazyBegin)) (0, $gy5kI.COLLECTED).get(lazyBegin).push(value);
        else (0, $gy5kI.COLLECTED).set(lazyBegin, [
            value
        ]);
    }
};
module.exports["collect"] = $a5bf27f95a5c4338$export$bb44f104e3c54dae;

});

parcelRegister("gy5kI", function(module, exports) {
const $c0c3f558a37c633a$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $c0c3f558a37c633a$export$4831ef3968ea94ef = new Map();
module.exports["PHASE"] = $c0c3f558a37c633a$export$2cc7a2eaaea7809f;
module.exports["COLLECTED"] = $c0c3f558a37c633a$export$4831ef3968ea94ef;

});

parcelRegister("4qzp5", function(module, exports) {
const $33950d892bd67505$export$c42217d53a7ebafb = (fromEl, id)=>{
    const fragment = document.createElement('div');
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        // cloneNode is 50% faster than outerHTML/textContent
        fragment.appendChild(el.cloneNode(true));
    }
    return Array.from(fragment.childNodes);
};
module.exports["cloneElements"] = $33950d892bd67505$export$c42217d53a7ebafb;

});

parcelRegister("8WAU6", function(module, exports) {
const $68305ddfb331b362$export$c69443129766a7fc = (fromEl, id)=>{
    const result = [];
    let el = fromEl;
    while(el = el.nextSibling){
        if (el.dataset && el.dataset.lazyEnd === id) break;
        result.push(el);
    }
    return result;
};
module.exports["refElements"] = $68305ddfb331b362$export$c69443129766a7fc;

});

parcelRegister("itHHy", function(module, exports) {
$parcel$export(module.exports, "LazyPhaseContext", () => (parcelRequire("8r5Wf")).LazyPhaseContext);
$parcel$export(module.exports, "setCurrent", () => (parcelRequire("8r5Wf")).setCurrent);
$parcel$export(module.exports, "useLazyPhase", () => (parcelRequire("8r5Wf")).useLazyPhase);
$parcel$export(module.exports, "LISTENERS", () => (parcelRequire("ehkpF")).LISTENERS);

var $8r5Wf = parcelRequire("8r5Wf");


var $ehkpF = parcelRequire("ehkpF");


var $6h5l4 = parcelRequire("6h5l4");


});

parcelRegister("8r5Wf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gy5kI = parcelRequire("gy5kI");


var $ehkpF = parcelRequire("ehkpF");


var $6h5l4 = parcelRequire("6h5l4");

let $6245739e6eaab8ef$var$CURRENT_PHASE = (0, $gy5kI.PHASE).PAINT;
const $6245739e6eaab8ef$export$5f80f094fd31fffd = (phase)=>{
    $6245739e6eaab8ef$var$CURRENT_PHASE = phase;
    (0, $ehkpF.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $6245739e6eaab8ef$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $cozmU.createContext)({
    subscribe: (0, $6h5l4.createSubscribe)((0, $ehkpF.LISTENERS)),
    currentValue: ()=>$6245739e6eaab8ef$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $6245739e6eaab8ef$export$5f80f094fd31fffd((0, $gy5kI.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$6245739e6eaab8ef$export$5f80f094fd31fffd((0, $gy5kI.PHASE).PAINT)
    }
});
const $6245739e6eaab8ef$export$1dc361b277327f88 = ()=>{
    const v = (0, $cozmU.useContext)($6245739e6eaab8ef$export$5a25eca35e5debcb);
    return v.api;
};
module.exports["setCurrent"] = $6245739e6eaab8ef$export$5f80f094fd31fffd;
module.exports["LazyPhaseContext"] = $6245739e6eaab8ef$export$5a25eca35e5debcb;
module.exports["useLazyPhase"] = $6245739e6eaab8ef$export$1dc361b277327f88;

});

parcelRegister("ehkpF", function(module, exports) {
const $a6527ccf54714552$export$81b9c458a026d68f = [];
module.exports["LISTENERS"] = $a6527ccf54714552$export$81b9c458a026d68f;

});

parcelRegister("6h5l4", function(module, exports) {
const $491878cc97587aa1$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };
module.exports["createSubscribe"] = $491878cc97587aa1$export$364097d812234b3f;

});

parcelRegister("hBrZE", function(module, exports) {
$parcel$export(module.exports, "hash", () => (parcelRequire("9fFjP")).default);

var $9fFjP = parcelRequire("9fFjP");

const $cd0b9b420a47cee1$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $cd0b9b420a47cee1$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $cd0b9b420a47cee1$export$283635c04a02cc36 = ()=>{
    if (typeof window === "undefined" || window.name === 'nodejs') return true;
    return globalThis !== globalThis.window;
};
function $cd0b9b420a47cee1$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}
module.exports["getExport"] = $cd0b9b420a47cee1$export$d4c07b1daf44a7f;
module.exports["displayNameFromId"] = $cd0b9b420a47cee1$export$4429f98ef60d2d87;
module.exports["isNodeEnvironment"] = $cd0b9b420a47cee1$export$283635c04a02cc36;
module.exports["attrToProp"] = $cd0b9b420a47cee1$export$62bf630d0de3d781;

});

parcelRegister("9fFjP", function(module, exports) {
$parcel$export(module.exports, "default", () => $6bc590d7746b5907$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $6bc590d7746b5907$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});

parcelRegister("9aUDG", function(module, exports) {

var $hXfAR = parcelRequire("hXfAR");


var $jxKH9 = parcelRequire("jxKH9");


var $gy5kI = parcelRequire("gy5kI");


var $hBrZE = parcelRequire("hBrZE");
var $9fFjP = parcelRequire("9fFjP");


var $aH9lN = parcelRequire("aH9lN");


var $ilEj6 = parcelRequire("ilEj6");


var $lJ3sU = parcelRequire("lJ3sU");


var $ajpr4 = parcelRequire("ajpr4");


var $67Nku = parcelRequire("67Nku");


var $edTIv = parcelRequire("edTIv");


var $17PxK = parcelRequire("17PxK");

function $6ae0fb8adbd87448$var$_extends() {
    $6ae0fb8adbd87448$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6ae0fb8adbd87448$var$_extends.apply(this, arguments);
}
function $6ae0fb8adbd87448$var$lazyProxy(_loader, { defer: defer = (0, $gy5kI.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $hBrZE.isNodeEnvironment)();
    const dataLazyId = (0, $9fFjP.default)(moduleId);
    const LazyInternal = isServer ? (0, $lJ3sU.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: _loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $ilEj6.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $ajpr4.createDeferred)({
            loader: ()=>{
                const { retry: maxAttempts } = (0, $jxKH9.getConfig)();
                return (0, $edTIv.retry)(_loader, {
                    delay: (0, $aH9lN.RETRY_DELAY),
                    factor: (0, $aH9lN.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: _loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $hBrZE.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $jxKH9.getConfig)();
        return (0, $hXfAR.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority != null ? priority : defer === (0, $gy5kI.PHASE).PAINT ? (0, $aH9lN.PRIORITY).HIGH : (0, $aH9lN.PRIORITY).LOW;
        return (0, $67Nku.preloadAsset)({
            loader: _loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        preload: preload
    });
}
const $6ae0fb8adbd87448$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $gy5kI.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $gy5kI.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $gy5kI.PHASE).LAZY
    }
};
function $6ae0fb8adbd87448$export$c952e5f94576010e(loader, opts) {
    return $6ae0fb8adbd87448$var$lazyProxy(loader, $6ae0fb8adbd87448$var$_extends({}, $6ae0fb8adbd87448$export$93ca5d3f8675ae4c.lazyForPaint, opts || {}));
}
function $6ae0fb8adbd87448$export$291dd592399bdafa(loader, opts) {
    return $6ae0fb8adbd87448$var$lazyProxy(loader, $6ae0fb8adbd87448$var$_extends({}, $6ae0fb8adbd87448$export$93ca5d3f8675ae4c.lazyAfterPaint, opts || {}));
}
function $6ae0fb8adbd87448$export$488013bae63b21da(loader, opts) {
    return $6ae0fb8adbd87448$var$lazyProxy(loader, $6ae0fb8adbd87448$var$_extends({}, $6ae0fb8adbd87448$export$93ca5d3f8675ae4c.lazy, opts || {}));
}
module.exports["lazyForPaint"] = $6ae0fb8adbd87448$export$c952e5f94576010e;
module.exports["lazyAfterPaint"] = $6ae0fb8adbd87448$export$291dd592399bdafa;
module.exports["lazy"] = $6ae0fb8adbd87448$export$488013bae63b21da;

});

parcelRegister("hXfAR", function(module, exports) {
const $d1240ae4295f4288$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};
module.exports["getAssetUrlsFromId"] = $d1240ae4295f4288$export$303f43e55cf1ef2f;

});

parcelRegister("aH9lN", function(module, exports) {
const $7c952c608ad2380e$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $7c952c608ad2380e$export$a339266ad71b2447 = 300;
const $7c952c608ad2380e$export$ba64c908e55507fe = 1;
module.exports["PRIORITY"] = $7c952c608ad2380e$export$bb34f3538ba26c7e;
module.exports["RETRY_DELAY"] = $7c952c608ad2380e$export$a339266ad71b2447;
module.exports["RETRY_FACTOR"] = $7c952c608ad2380e$export$ba64c908e55507fe;

});

parcelRegister("ilEj6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jxKH9 = parcelRequire("jxKH9");
var $3Pobi = parcelRequire("3Pobi");


var $gy5kI = parcelRequire("gy5kI");

parcelRequire("6VSrF");
var $dHqFW = parcelRequire("dHqFW");

parcelRequire("itHHy");
var $8r5Wf = parcelRequire("8r5Wf");

parcelRequire("hZz7i");
var $aZNtm = parcelRequire("aZNtm");


var $aH9lN = parcelRequire("aH9lN");


var $17PxK = parcelRequire("17PxK");


var $6adGO = parcelRequire("6adGO");


var $jl5l1 = parcelRequire("jl5l1");


var $67Nku = parcelRequire("67Nku");


var $bvYi1 = parcelRequire("bvYi1");


var $aiyJe = parcelRequire("aiyJe");

function $d5b97455f4530d40$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const { requestIdleCallback: requestIdleCallback = setTimeout } = window;
    const ResolvedLazy = /*#__PURE__*/ (0, $cozmU.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $cozmU.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $gy5kI.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $gy5kI.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const profiler = (0, $cozmU.useContext)((0, $bvYi1.ProfilerContext)).current;
        const load = ()=>{
            if (status.started || !status.phase || !status.noWait) return;
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $17PxK.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        // Subscribe to LazyWait context, triggering load when until is true
        (0, $aiyJe.useSubscription)({
            context: (0, $dHqFW.WaitContext),
            load: load,
            onValue: (v)=>status.noWait = v === 1
        });
        if (defer === (0, $gy5kI.PHASE).AFTER_PAINT) {
            // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $aiyJe.useSubscription)({
                context: (0, $8r5Wf.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
            // Schedule preloading as will be needed soon
            (0, $cozmU.useMemo)(()=>{
                if (!status.preloaded) {
                    status.preloaded = true;
                    requestIdleCallback(()=>{
                        if (status.started) return;
                        (0, $67Nku.preloadAsset)({
                            loader: deferred.preload,
                            moduleId: moduleId,
                            priority: (0, $aH9lN.PRIORITY).LOW
                        });
                    });
                }
            }, [
                status
            ]);
        }
        const { setFallback: setFallback } = (0, $cozmU.useContext)((0, $aZNtm.LazySuspenseContext));
        (0, $cozmU.useMemo)(()=>{
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $gy5kI.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $jxKH9.getConfig)().mode === (0, $3Pobi.MODE).RENDER ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6adGO.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jl5l1.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ResolvedLazy, props);
    };
}
module.exports["createComponentClient"] = $d5b97455f4530d40$export$6898b5504b58699a;

});

parcelRegister("6VSrF", function(module, exports) {
$parcel$export(module.exports, "WaitContext", () => (parcelRequire("dHqFW")).WaitContext);

var $dHqFW = parcelRequire("dHqFW");


var $86UVJ = parcelRequire("86UVJ");


});

parcelRegister("dHqFW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $eYtLL = parcelRequire("eYtLL");

const $9f93fbb489094a52$export$9ba3fe09d15de47b = /*#__PURE__*/ (0, $cozmU.createContext)({
    subscribe: ()=>(0, $eYtLL.noopCleanup),
    currentValue: ()=>1
});
module.exports["WaitContext"] = $9f93fbb489094a52$export$9ba3fe09d15de47b;

});

parcelRegister("eYtLL", function(module, exports) {
const $ae6dc2e0431b9395$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};
module.exports["noopCleanup"] = $ae6dc2e0431b9395$export$276c7dbda7675aec;

});

parcelRegister("86UVJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dHqFW = parcelRequire("dHqFW");

const $5e7b0b64cd38d641$export$7bf6cf03fd32cddb = ({ until: until, children: children })=>{
    const closestWait = (0, $cozmU.useContext)((0, $dHqFW.WaitContext));
    const value = (0, $cozmU.useRef)(until && closestWait.currentValue() ? 1 : 0);
    const subscribers = (0, $cozmU.useRef)(new Set());
    const api = (0, $cozmU.useRef)({
        subscribe: (subscriber)=>{
            subscribers.current.add(subscriber);
            return ()=>{
                subscribers.current.delete(subscriber);
            };
        },
        currentValue: ()=>value.current
    });
    (0, $cozmU.useEffect)(()=>{
        // Notify subscribers when until prop or closest until value changes
        const notify = ()=>{
            value.current = closestWait.currentValue() && until ? 1 : 0;
            subscribers.current.forEach((subscriber)=>subscriber());
        };
        notify();
        return closestWait.subscribe(notify);
    }, [
        closestWait,
        until
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dHqFW.WaitContext).Provider, {
        value: api.current
    }, children);
};

});

parcelRegister("hZz7i", function(module, exports) {
$parcel$export(module.exports, "LazySuspense", () => (parcelRequire("3QYdZ")).LazySuspense);
$parcel$export(module.exports, "LazySuspenseContext", () => (parcelRequire("aZNtm")).LazySuspenseContext);

var $3QYdZ = parcelRequire("3QYdZ");


var $aZNtm = parcelRequire("aZNtm");


});

parcelRegister("3QYdZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hBrZE = parcelRequire("hBrZE");


var $aZNtm = parcelRequire("aZNtm");

class $2ce4f1cfa8b44b57$export$256c542058532d6f extends (0, $cozmU.Component) {
    componentDidMount() {
        this.mounted = true;
    }
    renderFallback(outsideSuspense) {
        const { DynamicFallback: DynamicFallback } = this;
        // Use render prop component to allow switch to hydration fallback
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DynamicFallback, {
            outsideSuspense: outsideSuspense
        }, (fallback)=>fallback);
    }
    renderServer() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZNtm.LazySuspenseContext).Provider, {
            value: this.state
        }, this.props.children);
    }
    renderClient() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZNtm.LazySuspenseContext).Provider, {
            value: this.state
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: this.renderFallback(false)
        }, this.props.children), (!this.mounted || this.hydrationFallback) && this.renderFallback(true));
    }
    render() {
        return (0, $hBrZE.isNodeEnvironment)() ? this.renderServer() : this.renderClient();
    }
    constructor(props){
        super(props);
        this.state = {
            // Used on server to render fallback down the tree
            fallback: this.props.fallback,
            // Used on client to replace fallback with magic input
            setFallback: (fallback)=>{
                if (this.hydrationFallback === fallback) return;
                this.hydrationFallback = fallback;
                // Schedule an update so we force switch from the sibling tree
                // back to the suspense boundary
                if (this.mounted) this.forceUpdate();
            }
        };
        this.hydrationFallback = null;
        this.mounted = false;
        this.DynamicFallback = ({ children: children, outsideSuspense: outsideSuspense })=>{
            // eslint-disable-next-line react-hooks/rules-of-hooks
            (0, $cozmU.useLayoutEffect)(()=>{
                return ()=>{
                    // the effect cleanup is called by the Suspense boundary itself
                    // when both Lazy AND the eventual promises thrown are done
                    // so Suspense will re-render with actual content and we remove
                    // the hydration fallback at the same time
                    if (!outsideSuspense) this.state.setFallback(null);
                };
            }, [
                outsideSuspense
            ]);
            return outsideSuspense ? children(this.hydrationFallback ? this.hydrationFallback : null) : children(this.hydrationFallback ? null : this.props.fallback);
        };
        this.DynamicFallback.displayName = 'DynamicFallback';
    }
}
module.exports["LazySuspense"] = $2ce4f1cfa8b44b57$export$256c542058532d6f;

});

parcelRegister("aZNtm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $8015fa1bd12f3c41$export$c33990e84065970c = /*#__PURE__*/ (0, $cozmU.createContext)({
    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null),
    setFallback: ()=>{
        console.warn('Missing <LooselySuspense /> boundary');
    }
});
module.exports["LazySuspenseContext"] = $8015fa1bd12f3c41$export$c33990e84065970c;

});

parcelRegister("17PxK", function(module, exports) {
const $0d1e6d5848f254be$export$6aa69c1258005366 = Symbol.for('react-loosely-lazy/loader-error');
const $0d1e6d5848f254be$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$0d1e6d5848f254be$export$6aa69c1258005366]: true
    });
    return error;
};
const $0d1e6d5848f254be$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($0d1e6d5848f254be$export$6aa69c1258005366);
module.exports["createLoaderError"] = $0d1e6d5848f254be$export$c73a6a6f0bf7d425;

});

parcelRegister("6adGO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $47ce4bb11269d032$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $47ce4bb11269d032$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $cozmU.useRef)(null);
    const { current: ssrDomNodes } = (0, $cozmU.useRef)(content || []);
    (0, $cozmU.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($47ce4bb11269d032$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            ssrDomNodes.forEach((node)=>{
                var _node$parentNode;
                return (_node$parentNode = node.parentNode) == null ? void 0 : _node$parentNode.removeChild(node);
            });
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $47ce4bb11269d032$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $47ce4bb11269d032$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};
module.exports["PlaceholderFallbackRender"] = $47ce4bb11269d032$export$d55db778a3e1446b;

});

parcelRegister("jl5l1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hBrZE = parcelRequire("hBrZE");

function $e1441e868bb78192$var$_extends() {
    $e1441e868bb78192$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e1441e868bb78192$var$_extends.apply(this, arguments);
}
const $e1441e868bb78192$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        type: "hidden",
        "data-lazy-begin": id
    }), content.map((el, i)=>{
        const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
        const props = Array.from(attributes).reduce((0, $hBrZE.attrToProp), {
            key: String(i)
        });
        // text node
        if (!tagName) return /*#__PURE__*/ (0, $cozmU.createElement)((0, $cozmU.Fragment), props, el.textContent);
        // childless tag
        if (!childNodes.length) return /*#__PURE__*/ (0, $cozmU.createElement)(tagName.toLowerCase(), props);
        // tag with content
        return /*#__PURE__*/ (0, $cozmU.createElement)(tagName.toLowerCase(), $e1441e868bb78192$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: ''
            },
            suppressHydrationWarning: true
        }));
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        type: "hidden",
        "data-lazy-end": id
    }));
};
module.exports["PlaceholderFallbackHydrate"] = $e1441e868bb78192$export$ca5b8fbc835d95e4;

});

parcelRegister("67Nku", function(module, exports) {

var $hXfAR = parcelRequire("hXfAR");


var $eYtLL = parcelRequire("eYtLL");


var $jxKH9 = parcelRequire("jxKH9");


var $hBrZE = parcelRequire("hBrZE");


var $aH9lN = parcelRequire("aH9lN");


var $2mjKV = parcelRequire("2mjKV");


var $bvYi1 = parcelRequire("bvYi1");

function $4759a958e17e309b$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $jxKH9.getConfig)();
    const assets = (0, $hXfAR.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $2mjKV.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $4759a958e17e309b$var$fakePromise = {
    then: ()=>$4759a958e17e309b$var$fakePromise,
    catch: ()=>$4759a958e17e309b$var$fakePromise,
    finally: ()=>$4759a958e17e309b$var$fakePromise
};
function $4759a958e17e309b$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $2mjKV.insertLinkTag)(href, rel));
        return $4759a958e17e309b$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $4759a958e17e309b$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $eYtLL.noopCleanup;
}
function $4759a958e17e309b$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    var _GlobalReactLooselyLa;
    if ((0, $hBrZE.isNodeEnvironment)()) return 0, $eYtLL.noopCleanup;
    (_GlobalReactLooselyLa = (0, $bvYi1.GlobalReactLooselyLazyProfiler).current) == null || _GlobalReactLooselyLa.onPreload(moduleId, priority);
    const rel = priority === (0, $aH9lN.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $4759a958e17e309b$export$3af04dbcb01bad4d,
        $4759a958e17e309b$export$1046fd6a49d5e7a,
        $4759a958e17e309b$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $eYtLL.noopCleanup;
}
module.exports["preloadAsset"] = $4759a958e17e309b$export$25bad4aa00c45355;

});

parcelRegister("2mjKV", function(module, exports) {

var $bvYi1 = parcelRequire("bvYi1");


var $eYtLL = parcelRequire("eYtLL");


var $jxKH9 = parcelRequire("jxKH9");

function $1b7cf5f1f73f5f76$export$6610512821c8a4ce(href, rel) {
    var _document$head;
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $eYtLL.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $jxKH9.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $bvYi1.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    (_document$head = document.head) == null || _document$head.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) {
            var _document$head2;
            (_document$head2 = document.head) == null || _document$head2.removeChild(link);
        }
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}
module.exports["insertLinkTag"] = $1b7cf5f1f73f5f76$export$6610512821c8a4ce;

});

parcelRegister("bvYi1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $86215b3df1759e88$export$e2d53c0cbedd2710 = {
    current: null
};
const $86215b3df1759e88$export$8146ab57a3f7a7cb = /*#__PURE__*/ (0, $cozmU.createContext)($86215b3df1759e88$export$e2d53c0cbedd2710);
module.exports["GlobalReactLooselyLazyProfiler"] = $86215b3df1759e88$export$e2d53c0cbedd2710;
module.exports["ProfilerContext"] = $86215b3df1759e88$export$8146ab57a3f7a7cb;

});

parcelRegister("aiyJe", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $77f6862aa953f5ea$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $cozmU.useContext)(context);
    (0, $cozmU.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useSubscription"] = $77f6862aa953f5ea$export$368b4214baeb914c;

});

parcelRegister("lJ3sU", function(module, exports) {

var $hXfAR = parcelRequire("hXfAR");


var $cozmU = parcelRequire("cozmU");


var $jxKH9 = parcelRequire("jxKH9");


var $gy5kI = parcelRequire("gy5kI");

parcelRequire("hZz7i");
var $aZNtm = parcelRequire("aZNtm");


var $hBrZE = parcelRequire("hBrZE");


var $17PxK = parcelRequire("17PxK");

function $fd107d191750b962$var$load(moduleId, loader) {
    try {
        return (0, $hBrZE.getExport)(loader());
    } catch (err) {
        throw (0, $17PxK.createLoaderError)(err);
    }
}
function $fd107d191750b962$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        var _getAssetUrlsFromId;
        const Resolved = ssr ? $fd107d191750b962$var$load(moduleId, loader) : null;
        const { fallback: fallback } = (0, $cozmU.useContext)((0, $aZNtm.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest } = (0, $jxKH9.getConfig)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
            type: "hidden",
            "data-lazy-begin": dataLazyId
        }), defer !== (0, $gy5kI.PHASE).LAZY && ((_getAssetUrlsFromId = (0, $hXfAR.getAssetUrlsFromId)(manifest, moduleId)) == null ? void 0 : _getAssetUrlsFromId.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("link", {
                key: url,
                rel: defer === (0, $gy5kI.PHASE).PAINT ? 'preload' : 'prefetch',
                href: url,
                crossOrigin: crossOrigin,
                as: "script"
            }))), Resolved ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Resolved, props) : fallback, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
            type: "hidden",
            "data-lazy-end": dataLazyId
        }));
    };
}
module.exports["createComponentServer"] = $fd107d191750b962$export$eb2e4b04351cdd9e;

});

parcelRegister("ajpr4", function(module, exports) {
const $781f68b739b0ef47$export$e673efccd97e4223 = ({ loader: loader, preload: preload })=>{
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: function(_preload) {
            function preload() {
                return _preload.apply(this, arguments);
            }
            preload.toString = function() {
                return _preload.toString();
            };
            return preload;
        }(()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        }),
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    return deferred;
};
module.exports["createDeferred"] = $781f68b739b0ef47$export$e673efccd97e4223;

});

parcelRegister("edTIv", function(module, exports) {
const $a5ad7fc44a458961$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $a5ad7fc44a458961$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $a5ad7fc44a458961$var$getPolicy = (configuration)=>{
    var _configuration$delay, _configuration$factor, _configuration$maxAtt;
    return {
        delay: Math.max(0, (_configuration$delay = configuration.delay) != null ? _configuration$delay : 0),
        factor: Math.max(0, (_configuration$factor = configuration.factor) != null ? _configuration$factor : 0),
        maxAttempts: Math.max(0, (_configuration$maxAtt = configuration.maxAttempts) != null ? _configuration$maxAtt : 0)
    };
};
function $a5ad7fc44a458961$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $a5ad7fc44a458961$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $a5ad7fc44a458961$var$calculateDelay(context, policy);
        if (delay) await $a5ad7fc44a458961$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}
module.exports["retry"] = $a5ad7fc44a458961$export$9369b12211e1fce4;

});

parcelRegister("7QClO", function(module, exports) {

var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");


var $3ge84 = parcelRequire("3ge84");

const $ca6c6da9b1e678f4$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func
};
class $ca6c6da9b1e678f4$export$9e8ad10df3086be2 extends (0, $cozmU.Component) {
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3ge84.default).Provider, {
            value: this.contextValue
        }, children);
    }
    constructor(props){
        super(props);
        this.contextValue = void 0;
        this.getChildContext = ()=>{
            return this.contextValue;
        };
        const { getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext, getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers } = this.props.value;
        this.contextValue = {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        };
    }
}
$ca6c6da9b1e678f4$export$9e8ad10df3086be2.contextTypes = $ca6c6da9b1e678f4$var$ContextTypes;
$ca6c6da9b1e678f4$export$9e8ad10df3086be2.childContextTypes = $ca6c6da9b1e678f4$var$ContextTypes;
module.exports["LinkCreateModalProvider"] = $ca6c6da9b1e678f4$export$9e8ad10df3086be2;

});

parcelRegister("8ZNTx", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $2ea05298ab1f96ef$export$1578873c8519570a = (0, $kSwu1.defineMessages)({
    extensionTitle: {
        id: "editorExtensionLinkCreate.jiraIssue.quickInsert.title",
        defaultMessage: "Create Jira issue"
    },
    extensionTitleIssueTerminologyRefreshM4: {
        id: "editorExtensionLinkCreate.jiraIssue.quickInsert.title-issue-terminology-refresh-m4",
        defaultMessage: "Create Jira work item"
    },
    extensionDescription: {
        id: "editorExtensionLinkCreate.jiraIssue.quickInsert.description",
        defaultMessage: "Create an issue inline and insert the issue as a link"
    },
    extensionDescriptionIssueTerminologyRefreshM4: {
        id: "editorExtensionLinkCreate.jiraIssue.quickInsert.description-issue-terminology-refresh-m4",
        defaultMessage: "Create a work item inline and insert the work item as a link"
    }
});
module.exports["jiraExtensionMessages"] = $2ea05298ab1f96ef$export$1578873c8519570a;

});

parcelRegister("6y2do", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $1bb62051f798a7b5$export$5d64ddc7566152fc = (0, $kSwu1.defineMessages)({
    extensionTitle: {
        id: "editorExtensionLinkCreate.confluencePage.quickInsert.title",
        defaultMessage: "Create Confluence page"
    },
    extensionDescription: {
        id: "editorExtensionLinkCreate.confluencePage.quickInsert.description",
        defaultMessage: "Create a new page and insert it as a link"
    }
});
module.exports["confluenceExtensionMessages"] = $1bb62051f798a7b5$export$5d64ddc7566152fc;

});

parcelRegister("hA0gf", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $5648f70efca02d11$export$eebaaf2b24d91f63 = (0, $kSwu1.defineMessages)({
    create: {
        id: "editorExtensionLinkCreate.keyword.create",
        defaultMessage: "create"
    },
    issue: {
        id: "editorExtensionLinkCreate.keyword.issue",
        defaultMessage: "work item"
    },
    ticket: {
        id: "editorExtensionLinkCreate.keyword.ticket",
        defaultMessage: "ticket"
    },
    raise: {
        id: "editorExtensionLinkCreate.keyword.raise",
        defaultMessage: "raise"
    },
    new: {
        id: "editorExtensionLinkCreate.keyword.new",
        defaultMessage: "new"
    },
    space: {
        id: "editorExtensionLinkCreate.keyword.space",
        defaultMessage: "space"
    },
    publish: {
        id: "editorExtensionLinkCreate.keyword.publish",
        defaultMessage: "publish"
    },
    page: {
        id: "editorExtensionLinkCreate.keyword.page",
        defaultMessage: "page"
    }
});
module.exports["keywords"] = $5648f70efca02d11$export$eebaaf2b24d91f63;

});

parcelRegister("fk1wh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kl6az = parcelRequire("kl6az");


var $gfago = parcelRequire("gfago");


var $e4mkW = parcelRequire("e4mkW");


var $1hEQf = parcelRequire("1hEQf");

const $9d04ee51ef30f642$var$NullFallback = ()=>null;
const $9d04ee51ef30f642$var$getErrorType = (error)=>{
    if (error instanceof Response) return 'NetworkError';
    if (error instanceof Error) return error.name;
    return typeof error;
};
const $9d04ee51ef30f642$export$e926676385687eaf = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { flags: flags, children: children, onError: onError } = t0;
    const { fireEvent: fireEvent } = (0, $gfago.useAnalyticsEvents)();
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9d04ee51ef30f642$var$NullFallback, null);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== fireEvent || $[2] !== flags || $[3] !== intl || $[4] !== onError) {
        t2 = (error)=>{
            if (error instanceof Error) (0, $kl6az.captureException)(error, "editor-extension-link-create");
            flags?.showFailure?.({
                title: intl.formatMessage((0, $1hEQf.messages).title),
                description: intl.formatMessage((0, $1hEQf.messages).description)
            });
            fireEvent("operational.editorExtensionLinkCreateExperience.failed", {
                errorType: $9d04ee51ef30f642$var$getErrorType(error)
            });
            onError?.();
        };
        $[1] = fireEvent;
        $[2] = flags;
        $[3] = intl;
        $[4] = onError;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== children || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e4mkW.BaseErrorBoundary), {
            errorComponent: t1,
            onError: t2
        }, children);
        $[6] = children;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ flags: flags, children: children, onError: onError })=>{
    const { fireEvent: fireEvent } = (0, $gfago.useAnalyticsEvents)();
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e4mkW.BaseErrorBoundary), {
        errorComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9d04ee51ef30f642$var$NullFallback, null),
        onError: (error)=>{
            // Capture exception to Sentry
            if (error instanceof Error) (0, $kl6az.captureException)(error, 'editor-extension-link-create');
            flags?.showFailure?.({
                title: intl.formatMessage((0, $1hEQf.messages).title),
                description: intl.formatMessage((0, $1hEQf.messages).description)
            });
            fireEvent('operational.editorExtensionLinkCreateExperience.failed', {
                errorType: $9d04ee51ef30f642$var$getErrorType(error)
            });
            onError?.();
        }
    }, children);
};
module.exports["ErrorBoundary"] = $9d04ee51ef30f642$export$e926676385687eaf;

});

parcelRegister("kl6az", function(module, exports) {
const $77b3a826bcc35a21$export$f5282963edea4a68 = async (_error, _packageName, _tags)=>{
    // Re-introduce in EDM-9682
    return;
};
module.exports["captureException"] = $77b3a826bcc35a21$export$f5282963edea4a68;

});

parcelRegister("gfago", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $2gJmi = parcelRequire("2gJmi");


var $8UWZQ = parcelRequire("8UWZQ");

const $7ecd0980ab89600d$export$5bf35293e545f20c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (...t1)=>{
            const params = t1;
            const event = createAnalyticsEvent((0, $8UWZQ.default)(...params));
            event.fire((0, $2gJmi.EVENT_CHANNEL));
        };
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const fireEvent = t0;
    let t1;
    if ($[2] !== fireEvent) {
        t1 = {
            fireEvent: fireEvent
        };
        $[2] = fireEvent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireEvent = (0, $cozmU.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $8UWZQ.default)(...params));
        event.fire((0, $2gJmi.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};
module.exports["useAnalyticsEvents"] = $7ecd0980ab89600d$export$5bf35293e545f20c;

});

parcelRegister("2gJmi", function(module, exports) {
const $1a45a4a70693b79b$export$3f072f06b90c3985 = 'media';
module.exports["EVENT_CHANNEL"] = $1a45a4a70693b79b$export$3f072f06b90c3985;

});

parcelRegister("8UWZQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::8052a100e37348fedbca09afdc0228fa>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen editor-extension-link-create
 */ const $4c11cb5f5c187a78$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $4c11cb5f5c187a78$export$2e2bcd8739ae039 = $4c11cb5f5c187a78$var$createEventPayload;
module.exports["default"] = $4c11cb5f5c187a78$export$2e2bcd8739ae039;

});

parcelRegister("e4mkW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

class $752075dd965af3cb$export$688779ac61ee945f extends (0, $cozmU.Component) {
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { children: children, errorComponent: errorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && errorComponent) return errorComponent;
        return children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
module.exports["BaseErrorBoundary"] = $752075dd965af3cb$export$688779ac61ee945f;

});

parcelRegister("1hEQf", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $eef0dcc9cf509edf$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    title: {
        id: "editorExtensionLinkCreate.genericError.title",
        defaultMessage: "Something went wrong"
    },
    description: {
        id: "editorExtensionLinkCreate.genericError.description",
        defaultMessage: "Refresh the page and try again."
    }
});
module.exports["messages"] = $eef0dcc9cf509edf$export$defe85febe8b728c;

});

parcelRegister("3LnW2", function(module, exports) {

let $2bd853e6eca0883c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2bd853e6eca0883c$var$load("6wr18"),
    $2bd853e6eca0883c$var$load("ffEVr"),
    $2bd853e6eca0883c$var$load("drSvo")
]).then(()=>parcelRequire('85kZK'));

});

parcelRegister("lRbnR", function(module, exports) {

let $fe9760c98e605dec$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fe9760c98e605dec$var$load("2hLAI"),
    $fe9760c98e605dec$var$load("dCilB"),
    $fe9760c98e605dec$var$load("6wr18"),
    $fe9760c98e605dec$var$load("ffEVr"),
    $fe9760c98e605dec$var$load("4Ldt2"),
    $fe9760c98e605dec$var$load("kGnQH")
]).then(()=>parcelRequire('3ydxn'));

});

parcelRegister("egPcE", function(module, exports) {

let $a63a472cb0785674$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a63a472cb0785674$var$load("eDRYm").then(()=>parcelRequire('eSJdb'));

});

parcelRegister("7rOWN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2sp5n = parcelRequire("2sp5n");


var $cXtTj = parcelRequire("cXtTj");


var $k9wGn = parcelRequire("k9wGn");

var $ljOiP = parcelRequire("ljOiP");


var $ixfCV = parcelRequire("ixfCV");


var $iwIwp = parcelRequire("iwIwp");


var $99TtX = parcelRequire("99TtX");


var $1NFwk = parcelRequire("1NFwk");


var $9F0bu = parcelRequire("9F0bu");


var $85cI7 = parcelRequire("85cI7");


var $7tMWI = parcelRequire("7tMWI");


var $8iBLq = parcelRequire("8iBLq");


var $aaqIB = parcelRequire("aaqIB");

/**
 * IDs of experiences that are always enabled regardless of the
 * `platform_native_embeds_rollout_non_maui_experience` feature gate.
 * MauiWhiteboardExperienceManifest is included because it only matches
 * whiteboard URLs with `isRemixDiagram=true` (i.e. diagrams created via the MAUI flow).
 */ const $ab76b84281e6545b$var$alwaysEnabledExperienceIds = new Set([
    (0, $9F0bu.MAUI_EXPERIENCE_MANIFEST_ID),
    (0, $85cI7.MAUI_WHITEBOARD_EXPERIENCE_MANIFEST_ID)
]);
const $ab76b84281e6545b$var$allExperiences = [
    (0, $1NFwk.DBEntryExperienceManifest),
    (0, $99TtX.DBExperienceManifest),
    (0, $9F0bu.MauiExperienceManifest),
    (0, $7tMWI.PageExperienceManifest),
    (0, $8iBLq.SlideExperienceManifest),
    // MauiWhiteboardExperienceManifest must come before WhiteboardExperienceManifest
    // so its more specific isUrlMatch (requiring isRemixDiagram=true) is checked first.
    (0, $85cI7.MauiWhiteboardExperienceManifest),
    (0, $aaqIB.WhiteboardExperienceManifest)
];
const $ab76b84281e6545b$var$gatedExperiences = $ab76b84281e6545b$var$allExperiences.map((experience)=>({
        ...experience,
        isUrlMatch: (url)=>{
            if (!(0, $ixfCV.fg)('platform_native_embeds_rollout_non_maui_experience')) {
                if ($ab76b84281e6545b$var$alwaysEnabledExperienceIds.has(experience.id)) return experience.isUrlMatch(url);
                return false;
            }
            return experience.isUrlMatch(url);
        }
    }));
// Register all experience manifests at module-load time.
// This is intentionally module-level (not inside a React lifecycle) because the
// facade must be available before any child embed loads.
(0, $iwIwp.getNativeEmbedFacade)().setup({
    experiences: $ab76b84281e6545b$var$gatedExperiences
});
const $ab76b84281e6545b$var$buildNativeEmbedParameters = (url, parameterDefaults)=>(0, $ljOiP.setParameters)({}, {
        url: url,
        alwaysShowTitle: false,
        alignment: (0, $k9wGn.DEFAULT_ALIGNMENT),
        height: 600,
        width: undefined,
        ...parameterDefaults
    });
const $ab76b84281e6545b$var$STANDALONE_URL_AUTOCONVERT_EXPERIMENT = 'platform_native_embeds_standalone_url_autoconvert';
const $ab76b84281e6545b$var$shouldRequireStandaloneUrlForAutoConvert = ()=>// eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- Use dynamic config directly so the paste guard defaults off and can be intentionally rolled out.
    (0, $cXtTj.default).getExperimentValue($ab76b84281e6545b$var$STANDALONE_URL_AUTOCONVERT_EXPERIMENT, 'value', false);
const $ab76b84281e6545b$var$getStandaloneUrl = (text)=>{
    const url = text.trim();
    // Native embed autoconvert only receives a URL here when the pasted content is exactly one link.
    if (!url || /\s/.test(url)) return undefined;
    try {
        new URL(url);
        return url;
    } catch  {
        return undefined;
    }
};

const $ab76b84281e6545b$var$createRenderFn = (isPublishedPage, api, renderOverlay, analyticsPageContext)=>async ()=>{
        const { default: Ui } = await (parcelRequire("lnFlR"));
        return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Ui, {
                ...props,
                api: api,
                isPublishedPage: isPublishedPage,
                renderOverlay: renderOverlay,
                analyticsPageContext: analyticsPageContext
            });
    };
const $ab76b84281e6545b$export$622e7486b3a76ca4 = (isPublishedPage, api, cardClient, renderOverlay, analyticsPageContext)=>{
    // Wire up the CardClient for short-link URL resolution when provided.
    // This is a separate call from setup() because the CardClient may not be
    // available at module-load time when setup() is called.
    if (cardClient) (0, $iwIwp.getNativeEmbedFacade)().setCardClient(cardClient);
    return {
        title: 'Native Embed',
        type: (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE),
        key: (0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY),
        description: 'Embed native Atlassian content',
        modules: {
            nodes: {
                default: {
                    type: 'extension',
                    render: $ab76b84281e6545b$var$createRenderFn(isPublishedPage, api, renderOverlay, analyticsPageContext),
                    // @ts-expect-error This option is experimental and not reflected in the manifest type definition
                    __hideFrame: true
                },
                ...Object.fromEntries((0, $iwIwp.getNativeEmbedFacade)().getAllExperienceIds().map((experienceId)=>[
                        experienceId,
                        {
                            type: 'extension',
                            render: $ab76b84281e6545b$var$createRenderFn(isPublishedPage, api, renderOverlay, analyticsPageContext),
                            __hideFrame: true
                        }
                    ]))
            },
            autoConvert: {
                url: [
                    (text)=>{
                        if (!(0, $ixfCV.fg)('native_embed_paste_preference_bypass')) return undefined;
                        const url = $ab76b84281e6545b$var$shouldRequireStandaloneUrlForAutoConvert() ? $ab76b84281e6545b$var$getStandaloneUrl(text) : text;
                        if (!url) return undefined;
                        // Check if URL matches any registered experience patterns
                        const experienceId = (0, $iwIwp.getNativeEmbedFacade)().getExperienceIdFromUrl(url);
                        if (experienceId) {
                            // Check if this experience should auto-convert to native embed
                            const manifest = (0, $iwIwp.getNativeEmbedFacade)().getManifestByUrl(url);
                            if (!manifest || manifest.shouldAutoConvertToNativeEmbed !== true) // Return undefined to allow smart link handling instead
                            return undefined;
                            return {
                                type: 'extension',
                                attrs: {
                                    extensionKey: `${0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY}:${experienceId}`,
                                    extensionType: (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE),
                                    parameters: $ab76b84281e6545b$var$buildNativeEmbedParameters(url, manifest?.parameterDefaults)
                                }
                            };
                        }
                        // Return undefined if URL doesn't match - handled by smart links instead.
                        return undefined;
                    }
                ]
            }
        }
    };
};
module.exports["createManifest"] = $ab76b84281e6545b$export$622e7486b3a76ca4;

});

parcelRegister("k9wGn", function(module, exports) {
const $838c444502c02117$export$cc438a848c487501 = 'nativeEmbedDepth';
const $838c444502c02117$export$8de1a2f5887e1625 = 2;
const $838c444502c02117$export$5deb91d6dd3decbb = ()=>{
    if (typeof window === 'undefined') return 0;
    const raw = new URLSearchParams(window.location.search).get($838c444502c02117$export$cc438a848c487501);
    if (raw === null) return 0;
    const parsed = Number(raw);
    return Number.isFinite(parsed) && parsed >= 0 ? Math.floor(parsed) : 0;
};
const $838c444502c02117$export$de0f33c023e33ebd = [
    'left',
    'center',
    'right',
    'wrap-left',
    'wrap-right'
];
const $838c444502c02117$export$11a9886c2819741 = 'center';
const $838c444502c02117$export$1770a45a9210903c = {
    url: undefined,
    alwaysShowTitle: false,
    alignment: $838c444502c02117$export$11a9886c2819741,
    borderColor: undefined,
    borderSize: undefined,
    displayText: undefined,
    height: 600,
    aspectRatio: 1,
    width: undefined
};
const $838c444502c02117$export$98d307a8fd081b69 = {
    ASK_ROVO: 'askRovo',
    REMIX: 'remix',
    REMIX_VARIANT: 'remixVariant',
    SUMMARISE: 'summarise',
    REFRESH: 'refresh',
    EDIT: 'edit',
    EMBED: 'embed',
    BORDER: 'border',
    ALIGNMENT: 'alignment',
    OPEN_IN_NEW_WINDOW: 'openInNewWindow',
    /** Opens the embed's fullscreen preview dialog. */ EXPAND: 'expand',
    EDIT_URL: 'editUrl',
    ALWAYS_SHOW_TITLE: 'alwaysShowTitle',
    SET_EMBED_TYPE: 'setEmbedType',
    /**
	 * Copies the native-embed node to the clipboard.
	 */ COPY: 'copy',
    /**
	 * @private
	 * @deprecated Use `COPY` instead. `COPY_LINK` is a deprecated alias for `COPY` and will be removed in a future release.
	 */ COPY_LINK: 'copyLink',
    DELETE: 'delete',
    SEPARATOR: 'separator'
};
const $838c444502c02117$export$8637b4cdcb7cc177 = [
    'onAlignmentClick',
    'onAppearanceClick',
    'onAskRovoClick',
    'onSummariseClick',
    'onChangeBorderClick',
    'onCopyClick',
    'onCopyLinkClick',
    'onDeleteClick',
    'onEditClick',
    'onEditUrlClick',
    'onExpandClick',
    'onOpenInNewWindowClick',
    'onRefreshClick',
    'onSetEmbedTypeClick',
    'onShowTitleClick'
];
module.exports["EMBED_DEPTH_QUERY_PARAM"] = $838c444502c02117$export$cc438a848c487501;
module.exports["MAX_EMBED_DEPTH"] = $838c444502c02117$export$8de1a2f5887e1625;
module.exports["getCurrentEmbedDepth"] = $838c444502c02117$export$5deb91d6dd3decbb;
module.exports["ALIGNMENT_VALUES"] = $838c444502c02117$export$de0f33c023e33ebd;
module.exports["DEFAULT_ALIGNMENT"] = $838c444502c02117$export$11a9886c2819741;
module.exports["NATIVE_EMBED_PARAMETER_DEFAULTS"] = $838c444502c02117$export$1770a45a9210903c;
module.exports["BUILTIN_TOOLBAR_KEYS"] = $838c444502c02117$export$98d307a8fd081b69;
module.exports["EDITOR_TOOLBAR_HANDLER_KEYS"] = $838c444502c02117$export$8637b4cdcb7cc177;

});

parcelRegister("ljOiP", function(module, exports) {

var $k9wGn = parcelRequire("k9wGn");

const $a2a11cb02df7dc54$var$getMacroParamsRecord = (parameters)=>{
    if (!parameters?.macroParams || typeof parameters.macroParams !== 'object') return {};
    return parameters.macroParams;
};
const $a2a11cb02df7dc54$var$unwrapMacroParamValue = (macroParamValue)=>{
    if (macroParamValue && typeof macroParamValue === 'object' && 'value' in macroParamValue) return macroParamValue.value;
    return macroParamValue;
};
const $a2a11cb02df7dc54$var$PARAMETER_VALIDATORS = {
    alignment: (value)=>(0, $k9wGn.ALIGNMENT_VALUES).includes(value)
};
/**
 * Explicitly declares the intended primitive type for each parameter key.
 * This is necessary for keys whose default value is `undefined` (e.g. `url`, `width`),
 * because `typeof undefined === 'undefined'` gives no type information for deserialization.
 */ const $a2a11cb02df7dc54$var$PARAMETER_TYPES = {
    alignment: 'string',
    alwaysShowTitle: 'boolean',
    aspectRatio: 'number',
    borderColor: 'string',
    borderSize: 'number',
    displayText: 'string',
    height: 'number',
    url: 'string',
    width: 'number'
};
const $a2a11cb02df7dc54$var$parseFromDefault = (defaultValue, value, explicitType)=>{
    const resolvedType = explicitType ?? typeof defaultValue;
    if (resolvedType === 'boolean') {
        if (typeof value === 'boolean') return value;
        if (value === 'true') return true;
        if (value === 'false') return false;
        return undefined;
    }
    if (resolvedType === 'number') {
        const parsed = typeof value === 'number' ? value : typeof value === 'string' ? Number(value) : NaN;
        return Number.isFinite(parsed) ? parsed : undefined;
    }
    // String-like values
    return typeof value === 'string' ? value : undefined;
};
const $a2a11cb02df7dc54$var$serializeParameterValue = (key, value)=>{
    const validator = $a2a11cb02df7dc54$var$PARAMETER_VALIDATORS[key];
    if (validator && !validator(value)) return undefined;
    return value === undefined ? undefined : String(value);
};
const $a2a11cb02df7dc54$var$deserializeParameterValue = (key, value)=>{
    const parsedValue = $a2a11cb02df7dc54$var$parseFromDefault((0, $k9wGn.NATIVE_EMBED_PARAMETER_DEFAULTS)[key], value, $a2a11cb02df7dc54$var$PARAMETER_TYPES[key]);
    const validator = $a2a11cb02df7dc54$var$PARAMETER_VALIDATORS[key];
    if (parsedValue === undefined) return undefined;
    if (validator && !validator(parsedValue)) return undefined;
    return parsedValue;
};
const $a2a11cb02df7dc54$export$c77521bc1ca83dcc = (parameters, key)=>{
    const macroParams = $a2a11cb02df7dc54$var$getMacroParamsRecord(parameters);
    if (!(key in macroParams)) return (0, $k9wGn.NATIVE_EMBED_PARAMETER_DEFAULTS)[key];
    const value = $a2a11cb02df7dc54$var$unwrapMacroParamValue(macroParams[key]);
    const parsedValue = $a2a11cb02df7dc54$var$deserializeParameterValue(key, value);
    return parsedValue === undefined ? (0, $k9wGn.NATIVE_EMBED_PARAMETER_DEFAULTS)[key] : parsedValue;
};
function $a2a11cb02df7dc54$export$1d5e65f36fbcdb49(parameters, key) {
    if (key) return $a2a11cb02df7dc54$export$c77521bc1ca83dcc(parameters, key);
    return Object.fromEntries(Object.keys((0, $k9wGn.NATIVE_EMBED_PARAMETER_DEFAULTS)).map((defaultKey)=>[
            defaultKey,
            $a2a11cb02df7dc54$export$c77521bc1ca83dcc(parameters, defaultKey)
        ]));
}
const $a2a11cb02df7dc54$export$98091b65241a3a6 = (parameters, update)=>{
    return $a2a11cb02df7dc54$export$60752c4a8a24d484(parameters, update);
};
const $a2a11cb02df7dc54$export$60752c4a8a24d484 = (parameters, updates)=>{
    const currentParameters = parameters ?? {};
    const currentMacroParams = $a2a11cb02df7dc54$var$getMacroParamsRecord(parameters);
    const wrappedUpdates = Object.fromEntries(Object.entries(updates).map(([key, value])=>[
            key,
            $a2a11cb02df7dc54$var$serializeParameterValue(key, value)
        ]).filter(([, value])=>value !== undefined).map(([key, value])=>[
            key,
            {
                value: value
            }
        ]));
    return {
        ...currentParameters,
        macroParams: {
            ...currentMacroParams,
            ...wrappedUpdates
        }
    };
};
const $a2a11cb02df7dc54$export$46a0fc3fddbe8c3b = (config)=>config;
module.exports["getParameter"] = $a2a11cb02df7dc54$export$c77521bc1ca83dcc;
module.exports["getParameters"] = $a2a11cb02df7dc54$export$1d5e65f36fbcdb49;
module.exports["setParameter"] = $a2a11cb02df7dc54$export$98091b65241a3a6;
module.exports["setParameters"] = $a2a11cb02df7dc54$export$60752c4a8a24d484;
module.exports["createEditorToolbarActions"] = $a2a11cb02df7dc54$export$46a0fc3fddbe8c3b;

});

parcelRegister("iwIwp", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $6Iq0g = parcelRequire("6Iq0g");


var $h2POc = parcelRequire("h2POc");

/**
 * Matches Confluence short-link URLs of the form /wiki/x/<token>.
 * These URLs do not map to a specific experience until resolved via ORS.
 */ const $3b2da6bf08d8f744$var$CONFLUENCE_SHORT_LINK_PATTERN = /\/wiki\/x\/[^/]+/;
let $3b2da6bf08d8f744$var$nativeEmbedFacade;
function $3b2da6bf08d8f744$export$31739795deb20347() {
    if (!$3b2da6bf08d8f744$var$nativeEmbedFacade) $3b2da6bf08d8f744$var$nativeEmbedFacade = new $3b2da6bf08d8f744$export$3aace7af5e09b157((0, $6Iq0g.getExperienceManifestRegistry)(), (0, $h2POc.getSurfaceService)());
    return $3b2da6bf08d8f744$var$nativeEmbedFacade;
}





class $3b2da6bf08d8f744$export$3aace7af5e09b157 {
    /**
   * Registers an experience manifest so it can be matched by URL via {@link resolveManifestForUrl}.
   */ registerExperienceManifest(manifest) {
        this.experienceManifestRegistry.registerExperienceManifest(manifest);
    }
    /**
   * One-shot convenience method that registers experience manifests and
   * optionally configures the host surface in a single call.
   *
   * Prefer `setup()` over calling `registerExperienceManifest` /
   * `setSurface` individually — it makes the configuration declarative,
   * validates inputs eagerly, and guards against accidental double-setup.
   *
   * The low-level methods remain available for advanced use cases
   * (conditional registration, dynamic surface changes, etc.).
   *
   * @param config - The setup configuration.
   * @param config.experiences - Non-empty array of experience manifests to register.
   * @param config.surface - Optional surface configuration.
   *
   * Logs a warning and returns early if `setup()` has already been called.
   *
   * @example
   * ```ts
   * import { getNativeEmbedFacade } from '@atlassian/native-embeds-core';
   *
   * getNativeEmbedFacade().setup({
   *   experiences: [WhiteboardExperienceManifest, DBExperienceManifest],
   * });
   * ```
   */ setup(config) {
        if (this.isSetUp) {
            // eslint-disable-next-line no-console
            console.warn("NativeEmbedFacade.setup() has already been called. This call will be ignored. Use the low-level registerExperienceManifest() and setSurface() methods if you need to modify configuration after initial setup.");
            return;
        }
        for (const manifest of config.experiences)this.registerExperienceManifest(manifest);
        if (config.surface) this.setSurface(config.surface);
        if (config.cardClient) this.cardClient = config.cardClient;
        this.isSetUp = true;
    }
    /**
   * Sets the {@link CardClient} instance used for short-link URL resolution.
   *
   * This is useful when the `CardClient` is not available at the time `setup()`
   * is called (e.g. when the facade is initialised at module-load time before
   * the card provider is ready). Calling this after `setup()` replaces any
   * previously configured client.
   *
   * @param cardClient - The CardClient instance to use for ORS requests.
   */ setCardClient(cardClient) {
        this.cardClient = cardClient;
    }
    /**
   * Synchronous function that verifies if the URL matches any registered experience, and returns the experience ID if it does.
   * @param url - The URL to get the experience from.
   * @returns
   */ getExperienceIdFromUrl(url) {
        return this.experienceManifestRegistry.getExperienceIdFromUrl(url);
    }
    /**
   * Async variant of {@link getExperienceIdFromUrl} that handles Confluence
   * short-link URLs (e.g. `/wiki/x/<token>`).
   *
   * When the URL is a Confluence short link and a `cardClient` has been
   * configured (via `setup({ cardClient })` or `setCardClient()`), this method
   * resolves the short link to its canonical URL via the Object Resolver
   * Service and then matches the expanded URL against registered experience
   * manifests.
   *
   * Falls back to the synchronous {@link getExperienceIdFromUrl} for all
   * non-short-link URLs, or when no `cardClient` is available.
   *
   * @param url - The URL to resolve and match.
   * @returns The matched experience manifest ID, or `undefined` if no match.
   */ async getExperienceIdFromUrlAsync(url) {
        // Fast path: direct synchronous match (works for all non-short-link URLs)
        const syncResult = this.experienceManifestRegistry.getExperienceIdFromUrl(url);
        if (syncResult) return syncResult;
        // Expand Confluence short links via ORS when a cardClient is available
        const expandedUrl = await this.expandShortLink(url);
        if (!expandedUrl) return undefined;
        return this.experienceManifestRegistry.getExperienceIdFromUrl(expandedUrl);
    }
    /**
   * If `url` is a Confluence short link and a `cardClient` is configured,
   * resolves it to its canonical expanded URL via the Object Resolver Service.
   *
   * Returns `undefined` when:
   * - the feature gate `platform_native_embeds_rollout_non_maui_experience` is off,
   * - the URL is not a short link,
   * - no `cardClient` is available, or
   * - resolution fails or returns the same URL.
   */ async expandShortLink(url) {
        if (!(0, $ixfCV.fg)('platform_native_embeds_rollout_non_maui_experience')) return undefined;
        const isShortLink = $3b2da6bf08d8f744$var$CONFLUENCE_SHORT_LINK_PATTERN.test(url);
        if (!isShortLink || !this.cardClient) return undefined;
        try {
            const response = await this.cardClient.fetchData(url);
            const data = response?.data;
            if (!data || typeof data !== 'object') return undefined;
            const resolvedUrl = data['url'];
            if (typeof resolvedUrl === 'string' && resolvedUrl !== url) return resolvedUrl;
            // url can also be an object with an @id (JsonLd Link type)
            if (resolvedUrl && typeof resolvedUrl === 'object') {
                const id = resolvedUrl['@id'];
                if (typeof id === 'string' && id !== url) return id;
            }
        } catch  {
        // Short-link expansion is best-effort; fall through to return undefined.
        }
        return undefined;
    }
    /**
   * Synchronous function that returns the manifest for a URL if it matches any registered experience.
   * Uses `isUrlMatch` to find the matching manifest.
   * @param url - The URL to get the manifest for.
   * @returns The matching manifest, or undefined if no match is found.
   */ getManifestByUrl(url) {
        return this.experienceManifestRegistry.getManifestByUrl(url);
    }
    /**
   * Synchronous function that returns the manifest for a given experience ID.
   * @param id - The experience manifest ID to look up.
   * @returns The matching manifest, or undefined if no match is found.
   */ getManifestById(id) {
        return this.experienceManifestRegistry.getManifestById(id);
    }
    /**
   * Returns a list of all registered experience IDs.
   */ getAllExperienceIds() {
        return this.experienceManifestRegistry.getAllExperienceIds();
    }
    /**
   * Register or replace the active host surface.
   *
   * The surface provides capabilities that differ per host (editor, renderer,
   * etc.). The {@link Surface} interface will grow as new surface concerns
   * are identified.
   *
   * - Replaces any previously registered surface (last-write-wins).
   * - Pass `null` to clear the surface (e.g. on unmount).
   *
   * @param surface - The surface configuration, or `null` to clear.
   */ setSurface(surface) {
        this.surfaceService.setSurface(surface);
    }
    /**
   * Finds the matching manifest for a URL and creates an experience.
   * Title metadata will be resolved later by Smart Card.
   *
   * When the URL is a Confluence short link (e.g. `/wiki/x/<token>`) and a
   * `cardClient` has been configured, the short link is expanded to its
   * canonical URL via the Object Resolver Service before manifest matching.
   * The experience is created with the expanded URL.
   */ async createExperienceForUrl(url) {
        // Reject non-URL strings early. macroParams.url may contain prose text
        // with an embedded link rather than a bare URL (e.g. after a bad paste).
        try {
            new URL(url);
        } catch  {
            return undefined;
        }
        const resolvedUrl = await this.expandShortLink(url) ?? url;
        const manifest = this.experienceManifestRegistry.getManifestByUrl(resolvedUrl);
        if (!manifest) return undefined;
        const urlMeta = {
            url: resolvedUrl,
            title: ''
        };
        // Lazy import — ExperienceService transitively pulls in
        // rovo-content-bridge-api which uses uuid/randomBytes. Keeping it out of
        // the static import graph prevents the SSR pre-compile crash.
        const { getExperienceService: getExperienceService } = await (parcelRequire("eoNlM"));
        const experience = getExperienceService().registerExperience({
            manifest: manifest,
            urlMeta: urlMeta
        });
        return {
            experience: experience,
            manifest: manifest
        };
    }
    /**
   * Unregister an experience and dispose its event listeners.
   *
   * Call when the embed is removed from the host surface (e.g. editor node
   * deleted, component unmount). This prevents memory leaks from stale
   * listener references.
   *
   * Safe to call with an ID that was never registered — it's a no-op.
   */ async destroyExperience(experienceId) {
        const { getExperienceService: getExperienceService } = await (parcelRequire("eoNlM"));
        getExperienceService().unregisterExperience(experienceId);
    }
    /** Notify the child embed that its selection state changed. */ async sendSelectedChange(experienceId, selected) {
        const { getExperienceService: getExperienceService } = await (parcelRequire("eoNlM"));
        getExperienceService().sendSelectedChange(experienceId, selected);
    }
    /** Notify the child embed that the embedded content should be read. */ async sendReadContent(experienceId) {
        if (!(0, $ixfCV.fg)('maui_remixable_page_native_embeds')) return undefined;
        const { getExperienceService: getExperienceService } = await (parcelRequire("eoNlM"));
        return getExperienceService().sendReadContent(experienceId);
    }
    /** Register `aliasId` as a secondary ID for `experienceId`. Overwrites any previous mapping for `aliasId`. */ async addAlias(aliasId, experienceId) {
        const { getExperienceService: getExperienceService } = await (parcelRequire("eoNlM"));
        getExperienceService().addAlias(aliasId, experienceId);
    }
    constructor(experienceManifestRegistry, surfaceService){
        this.experienceManifestRegistry = void 0;
        this.surfaceService = void 0;
        this.cardClient = void 0;
        this.isSetUp = false;
        this.experienceManifestRegistry = experienceManifestRegistry;
        this.surfaceService = surfaceService;
    }
}
module.exports["getNativeEmbedFacade"] = $3b2da6bf08d8f744$export$31739795deb20347;

});

parcelRegister("6Iq0g", function(module, exports) {
let $7626500f872d820e$var$experienceService;
function $7626500f872d820e$export$1b2983209f90e067() {
    if ($7626500f872d820e$var$experienceService) return $7626500f872d820e$var$experienceService;
    $7626500f872d820e$var$experienceService = new $7626500f872d820e$export$21c7ca9c95b7ce6b();
    return $7626500f872d820e$var$experienceService;
}
class $7626500f872d820e$export$21c7ca9c95b7ce6b {
    registerExperienceManifest(experienceManifest) {
        this.experienceManifests.push(experienceManifest);
    }
    safeIsUrlMatch(experience, url) {
        try {
            return experience.isUrlMatch(url);
        } catch  {
            return false;
        }
    }
    getExperienceIdFromUrl(url) {
        return this.experienceManifests.find((experience)=>this.safeIsUrlMatch(experience, url))?.id;
    }
    getManifestByUrl(url) {
        return this.experienceManifests.find((experience)=>this.safeIsUrlMatch(experience, url));
    }
    getManifestById(id) {
        return this.experienceManifests.find((experience)=>experience.id === id);
    }
    getAllExperienceIds() {
        return this.experienceManifests.map((experience)=>experience.id);
    }
    async getExperienceById(id) {
        return this.experienceManifests.find((experience)=>experience.id === id);
    }
    constructor(){
        this.experienceManifests = [];
    }
}
module.exports["getExperienceManifestRegistry"] = $7626500f872d820e$export$1b2983209f90e067;

});

parcelRegister("h2POc", function(module, exports) {
let $761c278f71652274$var$surfaceServiceInstance;
function $761c278f71652274$export$a019fb3db45daa2b() {
    if (!$761c278f71652274$var$surfaceServiceInstance) $761c278f71652274$var$surfaceServiceInstance = new $761c278f71652274$export$f9308bd8ae7f0c97();
    return $761c278f71652274$var$surfaceServiceInstance;
}
class $761c278f71652274$export$f9308bd8ae7f0c97 {
    /**
   * Register or replace the active host surface.
   *
   * @param surface - The surface configuration, or `null` to clear.
   */ setSurface(surface) {
        this._surface = surface;
    }
    /**
   * Returns the currently active surface, or `null` if none is set.
   */ getSurface() {
        return this._surface;
    }
    constructor(){
        this._surface = null;
    }
}
module.exports["getSurfaceService"] = $761c278f71652274$export$a019fb3db45daa2b;

});

parcelRegister("eoNlM", function(module, exports) {

let $a7b996873e1209d3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a7b996873e1209d3$var$load("9njOW").then(()=>parcelRequire('ddI8y'));

});

parcelRegister("99TtX", function(module, exports) {

var $ljOiP = parcelRequire("ljOiP");


var $8fPlA = parcelRequire("8fPlA");


var $dx0Kw = parcelRequire("dx0Kw");

const $0232ad9c82d62a25$export$6dc7663b60a7f493 = (0, $8fPlA.experienceManifestId)('database');
const $0232ad9c82d62a25$var$isDatabaseUrl = (url)=>{
    return url.match(/\/wiki\/spaces\/~?[\d\w]+\/database\/\d+(\?.*)?$/) !== null;
};
const $0232ad9c82d62a25$var$isDatabaseEntryUrl = (url)=>{
    try {
        return $0232ad9c82d62a25$var$isDatabaseUrl(url) && new URL(url).searchParams.has('entryId');
    } catch  {
        return false;
    }
};
const $0232ad9c82d62a25$var$isDatabaseNonEntryUrl = (url)=>{
    return $0232ad9c82d62a25$var$isDatabaseUrl(url) && !$0232ad9c82d62a25$var$isDatabaseEntryUrl(url);
};
const $0232ad9c82d62a25$export$3db4c20f17f55c0a = {
    ...(0, $dx0Kw.dbSharedManifestFields),
    id: $0232ad9c82d62a25$export$6dc7663b60a7f493,
    isUrlMatch: $0232ad9c82d62a25$var$isDatabaseNonEntryUrl,
    parameterDefaults: {
        alwaysShowTitle: true
    },
    uiConfig: {
        ...(0, $dx0Kw.dbSharedUiConfig),
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                items: [
                    ...(0, $dx0Kw.getDbToolbarItems)()
                ],
                moreItems: (0, $dx0Kw.dbMoreItems)
            })
    }
};
module.exports["DBExperienceManifest"] = $0232ad9c82d62a25$export$3db4c20f17f55c0a;

});

parcelRegister("8fPlA", function(module, exports) {
const $63ee794f4378af50$export$32c943c51c185af3 = (s)=>s;
module.exports["experienceManifestId"] = $63ee794f4378af50$export$32c943c51c185af3;

});

parcelRegister("dx0Kw", function(module, exports) {
/* shared.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $4MdqE = parcelRequire("4MdqE");


var $lBKFk = parcelRequire("lBKFk");


var $k0CUL = parcelRequire("k0CUL");


var $1bzO2 = parcelRequire("1bzO2");


var $k9wGn = parcelRequire("k9wGn");


var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $iPlb2 = parcelRequire("iPlb2");


var $hjJUc = parcelRequire("hjJUc");

const $95d7871f626fca16$var$dbIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
    (0, (/*@__PURE__*/$parcel$interopDefault($1bzO2))),
    (0, (/*@__PURE__*/$parcel$interopDefault($k0CUL))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4MdqE)))
];
const $95d7871f626fca16$var$dbHandleChildCommands = (_experience, _command)=>{};
const $95d7871f626fca16$var$dbTransformUrl = (url, _isFullScreen)=>{
    const urlObj = new URL(url);
    urlObj.searchParams.set('presentationMode', 'nativeEmbedEditorPlugin');
    return urlObj.toString();
};
const $95d7871f626fca16$var$dbRenderLoadingComponent = (props)=>/*#__PURE__*/ $cozmU.createElement((0, $hjJUc.default), {
        animationDisabled: props.animationDisabled,
        icons: $95d7871f626fca16$var$dbIcons,
        testId: props.testId
    });
const $95d7871f626fca16$export$8f59efcb9ee755ea = ()=>{
    const itemsBeforeUpdate = [
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
    ];
    const itemsAfterUpdate = [
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT
    ];
    return (0, $ixfCV.fg)('cc-maui-toolbar-separators-update') ? itemsAfterUpdate : itemsBeforeUpdate;
};
const $95d7871f626fca16$export$828ffb167e211671 = [
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
]; /**
                                                                                                                                                                         * Returns the "More options" dropdown items for the DB Entry embed.
                                                                                                                                                                         *
                                                                                                                                                                         * The "Always show title" toggle is gated on the `databases-native-embeds-v2`
                                                                                                                                                                         * experiment: it is only included when the experiment is enabled. Evaluated
                                                                                                                                                                         * lazily (rather than at module-load time) because the manifest is registered
                                                                                                                                                                         * before Statsig is bootstrapped.
                                                                                                                                                                         */ 
const $95d7871f626fca16$export$c84eb7789dc18 = ()=>{
    const items = [];
    if ((0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) && (0, $ieeJu.expValEquals)('databases-native-embeds-v2', 'isEnabled', true)) items.push((0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE);
    items.push((0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY, (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE);
    return items;
};
const $95d7871f626fca16$export$2ef16a6e7258368a = {
    editorToolbarHandlers: {},
    renderLoadingComponent: $95d7871f626fca16$var$dbRenderLoadingComponent,
    titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
    appearance: 'minimal',
    showHeader: false,
    showBorder: false,
    waitForContentReady: true
};
const $95d7871f626fca16$export$28b94c65c51f8734 = {
    allowVerticalResize: true,
    isActive: ()=>true,
    handleChildCommands: $95d7871f626fca16$var$dbHandleChildCommands,
    shouldAutoConvertToNativeEmbed: true,
    lockResizeAspectRatio: ()=>false,
    supportedFeatures: new Set((0, $iPlb2.allNativeEmbedCoreFeatures)),
    transformUrl: $95d7871f626fca16$var$dbTransformUrl
};
module.exports["getDbToolbarItems"] = $95d7871f626fca16$export$8f59efcb9ee755ea;
module.exports["dbMoreItems"] = $95d7871f626fca16$export$828ffb167e211671;
module.exports["getDbEntryMoreItems"] = $95d7871f626fca16$export$c84eb7789dc18;
module.exports["dbSharedUiConfig"] = $95d7871f626fca16$export$2ef16a6e7258368a;
module.exports["dbSharedManifestFields"] = $95d7871f626fca16$export$28b94c65c51f8734;

});

parcelRegister("iPlb2", function(module, exports) {
/**
 * Core features that are supported by all native embeds.
 *
 * All native embed must either support the feature or respond in
 * the feature handshake that its not supported.
 */ const $9ebc30870bad8c95$export$189dc4df3d8f1369 = {
    /** When agreed, the parent sends selected-change events to the child when the embed's selection state changes. */ SelectedChange: 'selected-change',
    /** When agreed, the parent sends view-mode-change events to the child when the embed switches between regular and maximize (e.g. full screen). */ ViewModeChange: 'view-mode-change',
    /** When agreed, the parent sends header-visibility-change events to the child when the host native embed controls/chrome visibility changes. */ HeaderVisibilityChange: 'header-visibility-change',
    /** When agreed, the child captures click events and notifies the host via the bridge. */ NotifyHostClick: 'notify-host-click',
    /** When agreed, the child can request the host to toggle the full-screen dialog. */ ToggleFullScreen: 'toggle-full-screen',
    /**
	 * When agreed, the child can request the host to resize the embed container. */ RequestResize: 'request-resize',
    /**
	 * When agreed, the host sends `on-full-screen-changed` events to the child whenever
	 * the inline full-screen preview opens or closes WITHOUT remounting the iframe.
	 *
	 * This handshake is only ever negotiated when the host runs the shared-iframe
	 * code path (i.e. `Element.prototype.moveBefore` is supported). On any other
	 * host path the embed is torn down and re-created across the full-screen
	 * toggle, so a child has no need for this event.
	 */ NoRefreshFullScreenPreview: 'no-refresh-full-screen-preview',
    /**
	 * When agreed, the child sends a `content-ready` event to the host once its
	 * content is fully rendered and visible to the user. The host holds its own
	 * loading overlay visible until this event fires (or a safety timeout elapses),
	 * preventing a flash of the child's internal loading state between the iframe
	 * `load` event and the child's first painted frame.
	 *
	 * Only negotiated for embed types that set `waitForContentReady: true` in their
	 * `uiConfig` (currently database native embeds).
	 */ ContentReady: 'content-ready'
};
const $9ebc30870bad8c95$export$75135a796fe6e3e2 = Object.values($9ebc30870bad8c95$export$189dc4df3d8f1369);
module.exports["NativeEmbedCoreFeature"] = $9ebc30870bad8c95$export$189dc4df3d8f1369;
module.exports["allNativeEmbedCoreFeatures"] = $9ebc30870bad8c95$export$75135a796fe6e3e2;

});

parcelRegister("hjJUc", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d31de4816ebba09$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $bJ0qH = parcelRequire("bJ0qH");


var $39SCI = parcelRequire("39SCI");

function $3d31de4816ebba09$export$2e2bcd8739ae039(props) {
    if (props.variant === 'simple-bar') {
        const { variant: _variant, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39SCI.default), rest);
    }
    const { variant: _variant, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bJ0qH.default), rest);
}

});

parcelRegister("bJ0qH", function(module, exports) {
$parcel$export(module.exports, "default", () => $5675a156d46f0f78$export$2e2bcd8739ae039);
/* icon-carousel-variant.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $b5sDq = parcelRequire("b5sDq");


var $h5uPL = parcelRequire("h5uPL");


var $jxqsh = parcelRequire("jxqsh");


var $bDjVc = parcelRequire("bDjVc");


var $g3Ghj = parcelRequire("g3Ghj");


var $bUupk = parcelRequire("bUupk");


var $7lIlR = parcelRequire("7lIlR");


var $cr8hb = parcelRequire("cr8hb");

const $5675a156d46f0f78$var$containerStyles = null;
const $5675a156d46f0f78$var$innerStyles = null;
const $5675a156d46f0f78$var$progressBarWrapperStyles = null;
const $5675a156d46f0f78$var$defaultIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b5sDq))),
    (0, (/*@__PURE__*/$parcel$interopDefault($jxqsh))),
    (0, (/*@__PURE__*/$parcel$interopDefault($h5uPL)))
];
function $5675a156d46f0f78$export$2e2bcd8739ae039({ animationDisabled: animationDisabled = false, icons: icons, testId: testId }) {
    const progress = (0, $cr8hb.useFakeProgress)(animationDisabled);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_1r04idpf _kqswstnw _1e0c1txw _4cvr1h6o _1bah1h6o _bfhkhfxm"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_zulpv47k _1e0c1txw _2lx21bp4 _4cvr1h6o"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $7lIlR.default), {
        animationDisabled: animationDisabled,
        icons: icons ?? $5675a156d46f0f78$var$defaultIcons,
        testId: testId ? `${testId}--${0, $g3Ghj.SLIDE_MORPH_TEST_ID_SUFFIX}` : undefined,
        cycleDirection: "right"
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_1bsb1tkr"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $bUupk.default), {
        ariaLabel: "Loading",
        testId: testId ? `${testId}--${0, $g3Ghj.PROGRESS_BAR_TEST_ID_SUFFIX}` : undefined,
        value: progress
    }))));
}

});

parcelRegister("b5sDq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a6242f603ec1727a8ab94c75bc410d8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81265fa4dab37321$var$_react = $81265fa4dab37321$var$_interopRequireDefault((parcelRequire("cozmU")));

var $81265fa4dab37321$var$_baseNew = $81265fa4dab37321$var$_interopRequireDefault((parcelRequire("gElAV")));
function $81265fa4dab37321$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DiagramSymbolMindMap".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for mind map diagram symbol.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $81265fa4dab37321$var$DiagramSymbolMindMapIcon = (props)=>/*#__PURE__*/ $81265fa4dab37321$var$_react.default.createElement($81265fa4dab37321$var$_baseNew.default, Object.assign({
        name: "DiagramSymbolMindMapIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12 13.5h2.5v-2H12zM1.5 9H4V7H1.5zM12 4.5h2.5v-2H12zm4 .125C16 5.385 15.384 6 14.625 6h-2.75c-.76 0-1.375-.616-1.375-1.375V4.25h-1a.5.5 0 0 0-.5.5v6.5a.5.5 0 0 0 .5.5h1v-.375c0-.76.616-1.375 1.375-1.375h2.75c.76 0 1.375.616 1.375 1.375v2.25c0 .76-.616 1.375-1.375 1.375h-2.75c-.76 0-1.375-.616-1.375-1.375v-.375h-1a2 2 0 0 1-2-2v-2.5h-2v.375c0 .76-.616 1.375-1.375 1.375h-2.75C.615 10.5 0 9.884 0 9.125v-2.25C0 6.115.616 5.5 1.375 5.5h2.75c.76 0 1.375.616 1.375 1.375v.375h2v-2.5a2 2 0 0 1 2-2h1v-.375c0-.76.616-1.375 1.375-1.375h2.75l.14.007c.694.07 1.235.656 1.235 1.368z"/>`
    }, props));
$81265fa4dab37321$var$DiagramSymbolMindMapIcon.displayName = 'DiagramSymbolMindMapIcon';
var $81265fa4dab37321$var$_default = module.exports.default = $81265fa4dab37321$var$DiagramSymbolMindMapIcon;

});

parcelRegister("h5uPL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a2c0dc6357dcf36b6b5fbc7fab2883cc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c70ad24a32d9055c$var$_react = $c70ad24a32d9055c$var$_interopRequireDefault((parcelRequire("cozmU")));

var $c70ad24a32d9055c$var$_baseNew = $c70ad24a32d9055c$var$_interopRequireDefault((parcelRequire("gElAV")));
function $c70ad24a32d9055c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sticker".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Used for sticker tool in Whiteboards
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c70ad24a32d9055c$var$StickerIcon = (props)=>/*#__PURE__*/ $c70ad24a32d9055c$var$_react.default.createElement($c70ad24a32d9055c$var$_baseNew.default, Object.assign({
        name: "StickerIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0-1.998 12.687L6 14c0-1.102.223-2.153.627-3.11a8 8 0 0 1 7.56-4.888A6.5 6.5 0 0 0 8 1.5m5.413 6.026a6.5 6.5 0 0 0-5.404 3.947 6.5 6.5 0 0 0-.483 1.94zM0 8a8 8 0 0 1 15.899-1.277.75.75 0 0 1-.21.65l-8.317 8.315a.75.75 0 0 1-.649.21A8 8 0 0 1 0 8" clip-rule="evenodd"/>`
    }, props));
$c70ad24a32d9055c$var$StickerIcon.displayName = 'StickerIcon';
var $c70ad24a32d9055c$var$_default = module.exports.default = $c70ad24a32d9055c$var$StickerIcon;

});

parcelRegister("g3Ghj", function(module, exports) {
const $f9469b1871c63b69$export$422c871edd75db5 = 'progress-bar';
const $f9469b1871c63b69$export$eb09afb535a4cb18 = 'slide-morph';
const $f9469b1871c63b69$export$7442c4c7574447bc = 50;
module.exports["PROGRESS_BAR_TEST_ID_SUFFIX"] = $f9469b1871c63b69$export$422c871edd75db5;
module.exports["SLIDE_MORPH_TEST_ID_SUFFIX"] = $f9469b1871c63b69$export$eb09afb535a4cb18;
module.exports["STATIC_PROGRESS_VALUE"] = $f9469b1871c63b69$export$7442c4c7574447bc;

});

parcelRegister("bUupk", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9ce3cf2ba109470$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $e9ce3cf2ba109470$var$MIN_VALUE = 0;
const $e9ce3cf2ba109470$var$MAX_VALUE = 100;
const $e9ce3cf2ba109470$var$containerStyles = null;
const $e9ce3cf2ba109470$var$barStyles = null; /**
                         * This is a progress bar component that was built to match the atlaskit component `@atlaskit/progress-bar`.
                         * We couldn't use the atlaskit component due to the colour requirements for this progress bar not being supported,
                         * hence, a custom component was required.
                         */ 
function $e9ce3cf2ba109470$export$2e2bcd8739ae039({ ariaLabel: ariaLabel, testId: testId, value: value = 0 }) {
    const valueParsed = Math.max($e9ce3cf2ba109470$var$MIN_VALUE, Math.min(value, $e9ce3cf2ba109470$var$MAX_VALUE));
    return /*#__PURE__*/ $cozmU.createElement("div", {
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": $e9ce3cf2ba109470$var$MIN_VALUE,
        "aria-valuenow": valueParsed,
        "aria-valuemax": $e9ce3cf2ba109470$var$MAX_VALUE,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_2rko1rr0 _1reo15vq _18m915vq _1bsb1osq _4t3ii2wt _kqswh2mm _bfhki8nm"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("span", {
        style: {
            width: `${valueParsed}%`
        },
        "data-testid": `${testId}--progress-value-bar`,
        className: (0, $hekY6.default)([
            "_2rko1rr0 _v564aq9m _1e0c1ule _4t3ii2wt _kqswstnw _bfhk10ef"
        ])
    }));
}

});

parcelRegister("7lIlR", function(module, exports) {
$parcel$export(module.exports, "default", () => $948620dedd13543d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $9NPFC = parcelRequire("9NPFC");


var $kVbnn = parcelRequire("kVbnn");


var $fEVaZ = parcelRequire("fEVaZ");

// so we override the background via a wrapper targeting the tile's root <span>.
const $948620dedd13543d$var$tileWrapperStyles = null;
function $948620dedd13543d$export$2e2bcd8739ae039({ animationDisabled: animationDisabled = false, icons: icons, testId: testId, cycleDirection: cycleDirection = 'right' }) {
    const iconsWithProps = icons.map((Icon)=>(props)=>/*#__PURE__*/ $cozmU.createElement(Icon, {
                color: "var(--ds-icon-subtle, #505258)",
                ...props
            }));
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_a47o1j9a"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $9NPFC.default), {
        label: "",
        backgroundColor: "color.background.neutral",
        hasBorder: true,
        size: "xlarge",
        testId: testId
    }, /*#__PURE__*/ $cozmU.createElement((0, $fEVaZ.default), {
        animationDisabled: animationDisabled,
        icons: iconsWithProps,
        cycleDirection: cycleDirection,
        testId: testId ? `${testId}--${0, $kVbnn.ICON_CYCLER_TEST_ID_SUFFIX}` : undefined
    })));
}

});

parcelRegister("kVbnn", function(module, exports) {
const $b041427678c4fb7b$export$a87bbf852b8799e2 = 'icon-cycler';
module.exports["ICON_CYCLER_TEST_ID_SUFFIX"] = $b041427678c4fb7b$export$a87bbf852b8799e2;

});

parcelRegister("fEVaZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $fded74c4bd3b5f47$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $fded74c4bd3b5f47$var$ICON_CYCLE_DELAY_MS = 900;
const $fded74c4bd3b5f47$var$ICON_CYCLE_TRANSITION_MS = 400;
const $fded74c4bd3b5f47$var$ICON_CYCLE_EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';
const $fded74c4bd3b5f47$var$enteringAnimations = {
    left: "_kqswh2mm _j7hqzuuk",
    right: "_kqswh2mm _j7hq1s47"
};
const $fded74c4bd3b5f47$var$exitingAnimations = {
    left: "_kqswstnw _j7hq1qyy",
    right: "_kqswstnw _j7hq1pdg"
};
const $fded74c4bd3b5f47$var$commonAnimationStyles = null;
const $fded74c4bd3b5f47$var$containerStyles = null;
const $fded74c4bd3b5f47$var$iconSlotStyles = null; /**
                              * Cycles through a list of icon components with a vertical slide transition.
                              *
                              * Each icon is shown for ICON_CYCLE_DELAY_MS, then the current icon slides
                              * out upward while the next icon slides in from below over ICON_CYCLE_TRANSITION_MS.
                              */ 
function $fded74c4bd3b5f47$export$2e2bcd8739ae039({ animationDisabled: animationDisabled = false, icons: icons, cycleDirection: cycleDirection = 'left', testId: testId }) {
    const [currentIndex, setCurrentIndex] = (0, $cozmU.useState)(0);
    const [isTransitioning, setIsTransitioning] = (0, $cozmU.useState)(false);
    const timerRef = (0, $cozmU.useRef)(null);
    const nextIndex = (currentIndex + 1) % icons.length;
    const scheduleNextTransition = (0, $cozmU.useCallback)(()=>{
        timerRef.current = setTimeout(()=>{
            setIsTransitioning(true);
        }, $fded74c4bd3b5f47$var$ICON_CYCLE_DELAY_MS);
    }, []);
    const handleAnimationEnd = (0, $cozmU.useCallback)(()=>{
        setIsTransitioning(false);
        setCurrentIndex((prev)=>(prev + 1) % icons.length);
    }, [
        icons.length
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (animationDisabled || icons.length <= 1) return;
        if (!isTransitioning) scheduleNextTransition();
        return ()=>{
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, [
        animationDisabled,
        icons.length,
        isTransitioning,
        scheduleNextTransition
    ]);
    if (icons.length === 0) return null;
    const CurrentIcon = icons[currentIndex];
    const NextIcon = icons[nextIndex];
    if (animationDisabled || icons.length === 1 || !isTransitioning) return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_kqswh2mm _1e0c1txw _4cvr1h6o _1bah1h6o"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o"
        ])
    }, /*#__PURE__*/ $cozmU.createElement(CurrentIcon, {
        label: ""
    })));
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_kqswh2mm _1e0c1txw _4cvr1h6o _1bah1h6o"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            "_5sag1cqc _1pgl18mf _1o51q7pw",
            $fded74c4bd3b5f47$var$exitingAnimations[cycleDirection]
        ])
    }, /*#__PURE__*/ $cozmU.createElement(CurrentIcon, {
        label: ""
    })), /*#__PURE__*/ $cozmU.createElement("div", {
        onAnimationEnd: handleAnimationEnd,
        className: (0, $hekY6.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            "_5sag1cqc _1pgl18mf _1o51q7pw",
            $fded74c4bd3b5f47$var$enteringAnimations[cycleDirection]
        ])
    }, /*#__PURE__*/ $cozmU.createElement(NextIcon, {
        label: ""
    })));
}

});

parcelRegister("cr8hb", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $g3Ghj = parcelRequire("g3Ghj");

function $e3f0b09e8c39256e$export$966e81c93dd9c110(animationDisabled) {
    const [progress, setProgress] = (0, $cozmU.useState)(animationDisabled ? (0, $g3Ghj.STATIC_PROGRESS_VALUE) : 0);
    (0, $cozmU.useEffect)(()=>{
        if (animationDisabled) return;
        const interval = setInterval(()=>{
            setProgress((prev)=>{
                if (prev < 10) return prev + 10;
                if (prev < 60) return prev + 35;
                if (prev < 90) return prev + 10;
                return prev;
            });
        }, 1000);
        return ()=>clearInterval(interval);
    }, [
        animationDisabled
    ]);
    return progress;
}
module.exports["useFakeProgress"] = $e3f0b09e8c39256e$export$966e81c93dd9c110;

});

parcelRegister("39SCI", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f0a885121af4f63$export$2e2bcd8739ae039);
/* simple-bar-variant.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $g3Ghj = parcelRequire("g3Ghj");


var $bUupk = parcelRequire("bUupk");


var $cr8hb = parcelRequire("cr8hb");

const $4f0a885121af4f63$var$messages = (0, $kSwu1.defineMessages)({
    loadingLabel: {
        id: "native-embeds-core.common.loading-overlay.simple-bar-variant.loadingLabel",
        defaultMessage: "Loading"
    }
});
const $4f0a885121af4f63$var$containerStyles = null;
const $4f0a885121af4f63$var$blanketStyles = null;
const $4f0a885121af4f63$var$progressBarWrapperStyles = null;
function $4f0a885121af4f63$export$2e2bcd8739ae039({ animationDisabled: animationDisabled = false, showBlanket: showBlanket = false, testId: testId }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const progress = (0, $cr8hb.useFakeProgress)(animationDisabled);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_1r04idpf _kqswstnw _1e0c1txw _4cvresu3 _1bah1h6o _85i5utpp _bfhkhfxm _1pbykb7n"
        ])
    }, showBlanket && /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_1r04idpf _kqswstnw _bfhk1i5c"
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_1bsb1lk2 _kqswh2mm _1pbykb7n"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $bUupk.default), {
        ariaLabel: formatMessage($4f0a885121af4f63$var$messages.loadingLabel),
        testId: testId ? `${testId}--${0, $g3Ghj.PROGRESS_BAR_TEST_ID_SUFFIX}` : undefined,
        value: progress
    })));
}

});

parcelRegister("1NFwk", function(module, exports) {

var $ljOiP = parcelRequire("ljOiP");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $8fPlA = parcelRequire("8fPlA");


var $dx0Kw = parcelRequire("dx0Kw");

const $2b4557ff3d43825b$var$isDbEntryV2Enabled = ()=>(0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) && (0, $ieeJu.expValEquals)('databases-native-embeds-v2', 'isEnabled', true);
/**
 * Returns the parameter defaults for the DB Entry embed.
 *
 * When v2 is enabled (see {@link isDbEntryV2Enabled}), new entry embeds
 * default to having the title visible (`alwaysShowTitle: true`),
 * matching the regular DB embed behaviour. Otherwise no override is
 * applied.
 */ const $2b4557ff3d43825b$var$getDbEntryParameterDefaults = ()=>$2b4557ff3d43825b$var$isDbEntryV2Enabled() ? {
        alwaysShowTitle: true
    } : {};
const $2b4557ff3d43825b$export$a8c9f0f28b60cece = (0, $8fPlA.experienceManifestId)('database-entry');
const $2b4557ff3d43825b$var$isDatabaseEntryUrl = (url)=>{
    try {
        return url.match(/\/wiki\/spaces\/~?[\d\w]+\/database\/\d+(\?.*)?$/) !== null && new URL(url).searchParams.has('entryId');
    } catch  {
        return false;
    }
};
const $2b4557ff3d43825b$export$b0c2faa0f9dece58 = {
    ...(0, $dx0Kw.dbSharedManifestFields),
    id: $2b4557ff3d43825b$export$a8c9f0f28b60cece,
    isUrlMatch: $2b4557ff3d43825b$var$isDatabaseEntryUrl,
    get parameterDefaults () {
        return $2b4557ff3d43825b$var$getDbEntryParameterDefaults();
    },
    uiConfig: {
        ...(0, $dx0Kw.dbSharedUiConfig),
        get appearance () {
            return $2b4557ff3d43825b$var$isDbEntryV2Enabled() ? 'overlay' : 'minimal';
        },
        get showBorder () {
            return $2b4557ff3d43825b$var$isDbEntryV2Enabled();
        },
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                items: [
                    ...(0, $dx0Kw.getDbToolbarItems)()
                ],
                moreItems: (0, $dx0Kw.getDbEntryMoreItems)()
            })
    }
};
module.exports["DBEntryExperienceManifest"] = $2b4557ff3d43825b$export$b0c2faa0f9dece58;

});

parcelRegister("9F0bu", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $1pCE4 = parcelRequire("1pCE4");


var $b5sDq = parcelRequire("b5sDq");


var $dazTo = parcelRequire("dazTo");


var $6Ec6w = parcelRequire("6Ec6w");


var $gJ798 = parcelRequire("gJ798");


var $k9wGn = parcelRequire("k9wGn");

var $ljOiP = parcelRequire("ljOiP");


var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $gqUuL = parcelRequire("gqUuL");


var $iPlb2 = parcelRequire("iPlb2");


var $hjJUc = parcelRequire("hjJUc");


var $8fPlA = parcelRequire("8fPlA");

const $d2e69b3762c8c591$var$mauiLoadingIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))),
    (0, (/*@__PURE__*/$parcel$interopDefault($gJ798))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b5sDq))),
    (0, (/*@__PURE__*/$parcel$interopDefault($dazTo)))
];
const $d2e69b3762c8c591$export$b0111d5aa9d78690 = (0, $8fPlA.experienceManifestId)('maui');
const $d2e69b3762c8c591$var$isMauiUrl = (url)=>/\/remix\/ui\/[A-Za-z0-9_-]+/.test(url); /**
                                                                                      * Experience manifest for a MAUI embed.
                                                                                      * Register with getNativeEmbedFacade().registerExperienceManifest(MauiExperienceManifest),
                                                                                      * then call getNativeEmbedFacade().createExperienceForUrl(url) to obtain an Experience for EmbedFrameUI.
                                                                                      */ 
const $d2e69b3762c8c591$export$f519d88de7ad4d5e = {
    id: $d2e69b3762c8c591$export$b0111d5aa9d78690,
    handleChildCommands: (_experience, _cmd)=>{},
    isUrlMatch: $d2e69b3762c8c591$var$isMauiUrl,
    supportedFeatures: new Set((0, $iPlb2.allNativeEmbedCoreFeatures)),
    isActive: ()=>true,
    lockResizeAspectRatio: ()=>!(0, $ixfCV.fg)('cc_maui_resize'),
    narrowEmbedThreshold: 50,
    parameterDefaults: {
        width: 760
    },
    shouldFocusOnClick: (_url, _meta)=>!(0, $ixfCV.fg)('cc_maui_editing'),
    shouldAutoConvertToNativeEmbed: true,
    transformUrl: (url, _isFullScreen, options)=>{
        const urlObj = new URL(url);
        const { colorMode: colorMode } = (0, $gqUuL.default)();
        if (colorMode) urlObj.searchParams.set('theme', colorMode);
         // When the host Confluence page is in edit mode, forward an
        // `enable-edits=` query param (empty value) so the embedded MAUI app
        // can render its edit-only affordances.
        if (options?.isEditMode) urlObj.searchParams.set('enable-edits', '');
        return urlObj.toString();
    },
    // remove this when MAUI is onboarded to the Linking Platform. This is here to allow testing before it is onboarded.
    resolveViaLinkingPlatform: false,
    uiConfig: {
        trackViewed: true,
        showBorder: false,
        showExpandButton: false,
        renderLoadingComponent: (props)=>{
            // The exposure is fired at the toolbar click in `duplicate-and-replace-maui-app.ts`.
            if ((0, $anBbz.expValEqualsNoExposure)('cc-maui-ai-edit-loading-experiment', 'isEnabled', true)) return /*#__PURE__*/ $cozmU.createElement((0, $hjJUc.default), {
                variant: "simple-bar",
                animationDisabled: props.animationDisabled,
                showBlanket: props.source === 'ai-edit',
                testId: props.testId
            });
            return /*#__PURE__*/ $cozmU.createElement((0, $hjJUc.default), {
                animationDisabled: props.animationDisabled,
                icons: $d2e69b3762c8c591$var$mauiLoadingIcons,
                testId: props.testId
            });
        },
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                customActions: {},
                items: [
                    ...(0, $ixfCV.fg)('cc-maui-phase-2') ? (0, $ixfCV.fg)('platform_editor_ai_remix_toolbar') ? [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).REMIX_VARIANT,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ] : [],
                    ...(0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true) ? (0, $ixfCV.fg)('cc-maui-toolbar-separators-update') ? [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).BORDER
                    ] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).BORDER,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ] : [],
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
                    ...(0, $ixfCV.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ],
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EXPAND,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
                ],
                moreItems: []
            }),
        editorToolbarHandlers: {
            onAskRovoClick: (_parameters, context)=>{
                const editorApi = context?.editorApi; // Stage the embed as the inline-Rovo streaming target. The overlay
                // is NOT triggered here — `RovoPromptScreenWithLogic.onSubmit`
                // promotes this on prompt submit. `expValEquals` (NOT NoExposure)
                // because this toolbar click is the designated `cc-maui-experiment`
                // exposure point.
                if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning -- gate + experiment layering for MAUI rollout (cc-maui-experiment + cc-maui-phase-2); will simplify post-rollout
                (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true) && (0, $ixfCV.fg)('cc-maui-phase-2')) {
                    const localId = context?.selectedNodeLocalId;
                    if (localId) editorApi?.aiExperience?.actions?.stageInlineRovoStreaming?.(localId);
                }
                editorApi?.aiExperience?.actions?.openAIModal?.({
                    invokedFrom: 'floatingToolbar'
                });
            }
        },
        fullScreenDialogControls: {
            hideOpenInNewTab: true,
            hideTitleIcon: true
        },
        headerControls: {
            hideMoreMenu: true,
            hideTitle: true
        },
        titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6Ec6w))),
        appearance: 'overlay'
    }
};
module.exports["MAUI_EXPERIENCE_MANIFEST_ID"] = $d2e69b3762c8c591$export$b0111d5aa9d78690;
module.exports["MauiExperienceManifest"] = $d2e69b3762c8c591$export$f519d88de7ad4d5e;

});

parcelRegister("1pCE4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b7739ad8bf36e5bd9a55f1766d10483c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $10761a64419352ea$var$_react = $10761a64419352ea$var$_interopRequireDefault((parcelRequire("cozmU")));

var $10761a64419352ea$var$_baseNew = $10761a64419352ea$var$_interopRequireDefault((parcelRequire("gElAV")));
function $10761a64419352ea$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeRemix".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Remix with Rovo
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $10761a64419352ea$var$AiGenerativeRemixIcon = (props)=>/*#__PURE__*/ $10761a64419352ea$var$_react.default.createElement($10761a64419352ea$var$_baseNew.default, Object.assign({
        name: "AiGenerativeRemixIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M15.78 11.22a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22h-2.845a2 2 0 0 1-1.552-.74l-1.124-1.382.967-1.189 1.321 1.626a.5.5 0 0 0 .388.185h2.845l-1.22-1.22 1.06-1.06z"/><path fill="currentcolor" d="M15.78 3.72a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06L13.44 5H10.6a.5.5 0 0 0-.39.19l-5.75 7.08a2 2 0 0 1-1.55.73H0v-1.5h2.91a.5.5 0 0 0 .39-.18l5.75-7.08a2 2 0 0 1 1.55-.74h2.85l-1.22-1.22 1.06-1.06zM6 4.25a.75.75 0 0 1-.49.71l-1.1.4a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.41 0l-.4-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.48-.59L0 4.25l.01-.12a.75.75 0 0 1 .48-.59l1.1-.4a.5.5 0 0 0 .3-.3l.4-1.1.05-.11A.75.75 0 0 1 3 1.24l.12.01a.75.75 0 0 1 .54.38l.05.11.4 1.1c.05.14.16.25.3.3l1.1.4a.75.75 0 0 1 .49.71"/>`
    }, props));
$10761a64419352ea$var$AiGenerativeRemixIcon.displayName = 'AiGenerativeRemixIcon';
var $10761a64419352ea$var$_default = module.exports.default = $10761a64419352ea$var$AiGenerativeRemixIcon;

});

parcelRegister("dazTo", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43688494f0a31d9179ab4b6542dc66c8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $99680d0c3dba17d6$var$_react = $99680d0c3dba17d6$var$_interopRequireDefault((parcelRequire("cozmU")));

var $99680d0c3dba17d6$var$_baseNew = $99680d0c3dba17d6$var$_interopRequireDefault((parcelRequire("gElAV")));
function $99680d0c3dba17d6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "World".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: Geographical data visualization.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $99680d0c3dba17d6$var$WorldIcon = (props)=>/*#__PURE__*/ $99680d0c3dba17d6$var$_react.default.createElement($99680d0c3dba17d6$var$_baseNew.default, Object.assign({
        name: "WorldIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/><path fill="currentcolor" d="M9.5 12.13a2.63 2.63 0 0 1 2.63-2.63H15V11h-2.87c-.62 0-1.12.5-1.12 1.13V15H9.5zm-1.5.62a2 2 0 0 0-2-2 .5.5 0 0 1-.5-.5v-.5A2.5 2.5 0 0 0 3 7.25H1v1.5h2a1 1 0 0 1 1 1v.5a2 2 0 0 0 2 2 .5.5 0 0 1 .5.5V15H8zm-1.25-6.5A.75.75 0 0 0 6 5.5h-.25A2.5 2.5 0 0 1 3.25 3V1.63h1.5V3a1 1 0 0 0 1 1H6a2.25 2.25 0 0 1 2.25 2.25c0 .41.34.75.75.75h1.5a.5.5 0 0 0 .5-.5 2 2 0 0 1 2-2h1.75V6H13a.5.5 0 0 0-.5.5 2 2 0 0 1-2 2H9a2.25 2.25 0 0 1-2.25-2.25"/>`
    }, props));
$99680d0c3dba17d6$var$WorldIcon.displayName = 'WorldIcon';
var $99680d0c3dba17d6$var$_default = module.exports.default = $99680d0c3dba17d6$var$WorldIcon;

});

parcelRegister("85cI7", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $cXtTj = parcelRequire("cXtTj");


var $b5sDq = parcelRequire("b5sDq");


var $h5uPL = parcelRequire("h5uPL");


var $jxqsh = parcelRequire("jxqsh");


var $bDjVc = parcelRequire("bDjVc");


var $k9wGn = parcelRequire("k9wGn");

var $ljOiP = parcelRequire("ljOiP");


var $ixfCV = parcelRequire("ixfCV");


var $iPlb2 = parcelRequire("iPlb2");


var $hjJUc = parcelRequire("hjJUc");


var $1xINT = parcelRequire("1xINT");


var $8fPlA = parcelRequire("8fPlA");

const $ec6282bd715404c7$export$7bda1cade81459d3 = (0, $8fPlA.experienceManifestId)('maui-whiteboard'); /**
                                                                                                                      * Dynamic-config killswitch for sending `disableCanvasScroll` conditionally in
                                                                                                                      * legacy full screen. Default `false` = change enabled (param omitted from the
                                                                                                                      * legacy full-screen URL so the blown-up board scrolls); set to `true` to roll
                                                                                                                      * back to the pre-EPS8-40 behavior (param sent everywhere).
                                                                                                                      */ 
const $ec6282bd715404c7$var$LEGACY_FS_CANVAS_SCROLL_KILLSWITCH = 'platform_native_embed_legacy_fs_canvas_scroll';
const $ec6282bd715404c7$var$ROVO_REMIX_TITLE_KILLSWITCH = 'platform_native_embed_rovo_remix_title';
const $ec6282bd715404c7$var$WAIT_FOR_CONTENT_READY_CONFIG = 'platform_native_embed_wait_for_content_ready';
const $ec6282bd715404c7$var$RELATIVE_URL_PARSE_BASE = 'https://native-embeds.invalid';
const $ec6282bd715404c7$var$whiteboardIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b5sDq))),
    (0, (/*@__PURE__*/$parcel$interopDefault($jxqsh))),
    (0, (/*@__PURE__*/$parcel$interopDefault($h5uPL)))
];
const $ec6282bd715404c7$var$shouldWaitForContentReady = ()=>// eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- Dynamic configuration controls this staged rollout.
    (0, $cXtTj.default).getExperimentValue($ec6282bd715404c7$var$WAIT_FOR_CONTENT_READY_CONFIG, 'value', false);
const $ec6282bd715404c7$var$isMauiWhiteboardUrl = (url)=>{
    const isWhiteboardPath = // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    url.match(RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>\\d+)(\\?\\/)?")) || url.match(// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>[0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12})(\\?\\/)?"));
    if (!isWhiteboardPath) return false;
    try {
        return new URL(url).searchParams.get('isRemixDiagram') === 'true';
    } catch  {
        return false;
    }
}; /**
    * Reads search params from either an absolute embed URL or a relative iframe
    * src such as `/canvas-embed/whiteboard/...`. The placeholder base is only
    * used by `URL` to parse relative URLs; absolute URLs keep their own origin
    * and nothing is requested from this host.
    */ 
const $ec6282bd715404c7$var$getSearchParamFromEmbedUrl = (url, param)=>{
    try {
        return new URL(url, $ec6282bd715404c7$var$RELATIVE_URL_PARSE_BASE).searchParams.get(param);
    } catch  {
        return null;
    }
};
const $ec6282bd715404c7$var$shouldHideRovoRemixTitle = (url)=>{
    // Killswitch: platform_native_embed_rovo_remix_title
    // false (default) = hide intermediary Rovo remix titles; true = rollback
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    if ((0, $cXtTj.default).getExperimentValue($ec6282bd715404c7$var$ROVO_REMIX_TITLE_KILLSWITCH, 'value', false)) return false;
    return $ec6282bd715404c7$var$getSearchParamFromEmbedUrl(url, 'parentProduct') === 'rovo';
}; /**
    * Experience manifest for a MAUI whiteboard embed — a whiteboard created through
    * the MAUI (remix diagram) flow.
    *
    * Register with getNativeEmbedFacade().registerExperience(MauiWhiteboardExperienceManifest)
    * to obtain an Experience for EmbedFrameUI.
    */ 
const $ec6282bd715404c7$export$72612bab14c2e7fe = {
    id: $ec6282bd715404c7$export$7bda1cade81459d3,
    isUrlMatch: $ec6282bd715404c7$var$isMauiWhiteboardUrl,
    shouldAutoConvertToNativeEmbed: true,
    supportedFeatures: new Set((0, $iPlb2.allNativeEmbedCoreFeatures)),
    // Thunk so the killswitch is read at URL-build time (after Statsig init), and
    // so the conditional behavior is gated at its source: when rolled back the
    // manifest emits the pre-EPS8-40 plain-string value, which `resolveQueryParams`
    // passes through unchanged at every build site.
    //
    // `disableCanvasScroll` is correct inline (and in shared-iframe full screen,
    // which reuses the inline URL) but makes the blown-up board feel broken in the
    // legacy full-screen iframe, so by default it is omitted from that build site
    // only. `hideCursors` applies everywhere (plain string === appliesTo: 'always').
    queryParams: ()=>{
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const rolledBack = (0, $cXtTj.default).getExperimentValue($ec6282bd715404c7$var$LEGACY_FS_CANVAS_SCROLL_KILLSWITCH, 'value', false);
        return rolledBack ? {
            disableCanvasScroll: 'true',
            hideCursors: 'true'
        } : {
            disableCanvasScroll: {
                value: 'true',
                appliesTo: 'exceptLegacyFullscreen'
            },
            hideCursors: 'true'
        };
    },
    transformUrl: (url, isFullScreen)=>{
        const urlObj = new URL(url);
        if (!isFullScreen) urlObj.searchParams.set('hideBorder', 'true');
         // this is used to identify the native embed view in the whiteboard app
        urlObj.searchParams.set('nativeEmbedView', 'true'); // Default the parent product for MAUI whiteboards when the native embed
        // URL doesn't already specify one. native-embeds-core re-applies this
        // onto the ORS-resolved iframe src (which otherwise defaults to
        // `smartlink`). An existing value (e.g. `rovo`) is preserved.
        // Killswitch: platform_native_embed_parent_product_url
        // false (default) = change enabled; true = rollback
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        if (!urlObj.searchParams.has('parentProduct') && !(0, $cXtTj.default).getExperimentValue('platform_native_embed_parent_product_url', 'value', false)) urlObj.searchParams.set('parentProduct', 'nativeEmbedDiagram');
        const initialTheme = (0, $1xINT.getInitialThemeParam)();
        if (initialTheme) urlObj.searchParams.set('themeState', initialTheme);
        return urlObj.toString();
    },
    isActive: ()=>{
        return true;
    },
    uiConfig: {
        trackViewed: true,
        isAskRovoEnabled: ()=>(0, $ixfCV.fg)('cc-maui-phase-2'),
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                items: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
                    ...(0, $ixfCV.fg)('platform_editor_ai_remix_toolbar') ? [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).REMIX_VARIANT
                    ] : [],
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT,
                    ...(0, $ixfCV.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ],
                    // BUILTIN_TOOLBAR_KEYS.BORDER, // Border option is yet to be implemented.
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
                    ...(0, $ixfCV.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ]
                ],
                moreItems: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
                ]
            }),
        editorToolbarHandlers: {},
        headerControls: {
            hideTitle: ({ url: url })=>$ec6282bd715404c7$var$shouldHideRovoRemixTitle(url)
        },
        renderLoadingComponent: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $hjJUc.default), {
                animationDisabled: props.animationDisabled,
                icons: $ec6282bd715404c7$var$whiteboardIcons,
                testId: props.testId
            }),
        titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
        appearance: 'overlay',
        waitForContentReady: $ec6282bd715404c7$var$shouldWaitForContentReady
    },
    handleChildCommands: (_experience, _cmd)=>{}
};
module.exports["MAUI_WHITEBOARD_EXPERIENCE_MANIFEST_ID"] = $ec6282bd715404c7$export$7bda1cade81459d3;
module.exports["MauiWhiteboardExperienceManifest"] = $ec6282bd715404c7$export$72612bab14c2e7fe;

});

parcelRegister("1xINT", function(module, exports) {

var $gqUuL = parcelRequire("gqUuL");


var $fcaWu = parcelRequire("fcaWu");

const $d5e4138f0844ba8b$export$6f4b285026a87b72 = ()=>{
    const theme = (0, $gqUuL.default)();
    if (Object.keys(theme).length === 0) return undefined;
    return (0, $fcaWu.themeObjectToString)(theme);
};
module.exports["getInitialThemeParam"] = $d5e4138f0844ba8b$export$6f4b285026a87b72;

});

parcelRegister("7tMWI", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kLlYX = parcelRequire("kLlYX");


var $gC2EJ = parcelRequire("gC2EJ");


var $hMaHH = parcelRequire("hMaHH");


var $4GyjL = parcelRequire("4GyjL");


var $d4GYd = parcelRequire("d4GYd");


var $UL6rM = parcelRequire("UL6rM");


var $k9wGn = parcelRequire("k9wGn");

var $ljOiP = parcelRequire("ljOiP");


var $ixfCV = parcelRequire("ixfCV");


var $iPlb2 = parcelRequire("iPlb2");


var $hjJUc = parcelRequire("hjJUc");


var $8fPlA = parcelRequire("8fPlA");

const $f5f0a9f7a4b49836$export$7870b2bb7b39809b = (0, $8fPlA.experienceManifestId)('page');
const $f5f0a9f7a4b49836$var$pageIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
    (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
    (0, (/*@__PURE__*/$parcel$interopDefault($UL6rM))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4GyjL)))
]; // Match page URLs: /wiki/spaces/<key>/pages/<id>
// Match blog URLs: /wiki/spaces/<key>/blog/<id> or /wiki/spaces/<key>/blog/<year>/<month>/<day>/<id>
const $f5f0a9f7a4b49836$var$pagePathPattern = /\/wiki\/spaces\/[^/]+\/(pages\/\d+|blog\/(\d+\/){0,3}\d+)/;
const $f5f0a9f7a4b49836$var$pageShortLinkPathPattern = /\/wiki\/x\/[A-Za-z0-9_-]+/;
const $f5f0a9f7a4b49836$var$isPageUrl = (url)=>{
    if ($f5f0a9f7a4b49836$var$pagePathPattern.test(url)) return true;
    return $f5f0a9f7a4b49836$var$pageShortLinkPathPattern.test(url);
};
const $f5f0a9f7a4b49836$var$isEditUrl = (url)=>/\/wiki\/spaces\/[^/]+\/(pages|blog)\/(edit-embed|edit-v2)\/\d+/.test(url); // PGXT-10098: keep blog icons correct before resolved metadata is available.
const $f5f0a9f7a4b49836$var$blogPathPattern = /\/wiki\/spaces\/[^/]+\/blog\//;
const $f5f0a9f7a4b49836$var$isBlogUrl = (url)=>{
    try {
        return $f5f0a9f7a4b49836$var$blogPathPattern.test(new URL(url).pathname);
    } catch  {
        return $f5f0a9f7a4b49836$var$blogPathPattern.test(url);
    }
};
const $f5f0a9f7a4b49836$var$resolveTitleIcon = (meta, url)=>{
    if (meta.documentType === 'schema:DigitalDocument') return 0, (/*@__PURE__*/$parcel$interopDefault($kLlYX));
    if (meta.documentType === 'schema:BlogPosting' || $f5f0a9f7a4b49836$var$isBlogUrl(url)) return 0, (/*@__PURE__*/$parcel$interopDefault($d4GYd));
    return 0, (/*@__PURE__*/$parcel$interopDefault($hMaHH));
}; /**
    * Experience manifest for a page embed.
    * Register with getNativeEmbedFacade().registerExperienceManifest(PageExperienceManifest),
    * then call getNativeEmbedFacade().createExperienceForUrl(url) to obtain an Experience for EmbedFrameUI.
    */ 
const $f5f0a9f7a4b49836$export$f85d1a9111fa6dfc = {
    enforceQueryParams: true,
    id: $f5f0a9f7a4b49836$export$7870b2bb7b39809b,
    handleChildCommands: (_experience, _cmd)=>{},
    isUrlMatch: $f5f0a9f7a4b49836$var$isPageUrl,
    supportedFeatures: new Set((0, $iPlb2.allNativeEmbedCoreFeatures)),
    isActive: ()=>true,
    shouldFocusOnClick: (url, meta)=>{
        // Don't steal focus for live docs (documentType === 'schema:DigitalDocument')
        if (meta.documentType === 'schema:DigitalDocument') return false;
         // Don't steal focus when the page is in edit mode
        if ($f5f0a9f7a4b49836$var$isEditUrl(url)) return false;
        return true;
    },
    transformUrl: (url, _isFullScreen)=>{
        const urlObj = new URL(url);
        urlObj.searchParams.set('sample-param', 'true');
        return urlObj.toString();
    },
    uiConfig: {
        showHeader: (_meta, url)=>!$f5f0a9f7a4b49836$var$isEditUrl(url),
        headerControls: {
            editButton: {
                show: (meta)=>meta.documentType !== 'schema:DigitalDocument',
                // Don't show edit button for live docs
                onSwitchToEditing: (currentUrl, originalUrl)=>{
                    const url = new URL(currentUrl); // Detect whether this is originally a blog URL. The iframe's internal
                    // SPA router may resolve blog URLs (e.g. /blog/2026/04/29/<id>) to
                    // their canonical /pages/<id> form, so iframeSrc (currentUrl) may
                    // show /pages/<id> even for blogs. We check the originalUrl (the URL
                    // before iframe navigation) to detect blogs reliably; fall back to
                    // the current URL when no originalUrl is provided.
                    const contentIsBlog = $f5f0a9f7a4b49836$var$isBlogUrl(originalUrl ?? currentUrl);
                    if (contentIsBlog) {
                        // Blogs use /blog/edit-v2/<id> because there is no /blog/edit-embed/ route,
                        // which would cause a redirect that strips native embed query params.
                        // Extract the content ID from either the blog URL or the resolved /pages/<id> URL.
                        const blogMatch = url.pathname.match(/\/blog\/(?:\d+\/\d+\/\d+\/)?(\d+)(?:\/[^/]*)?$/);
                        const pagesMatch = url.pathname.match(/\/pages\/(\d+)/);
                        const contentId = blogMatch?.[1] ?? pagesMatch?.[1];
                        if (contentId) // Replace the path portion after /spaces/<key>/ with /blog/edit-v2/<id>
                        url.pathname = url.pathname.replace(/\/spaces\/([^/]+)\/.*$/, `/spaces/$1/blog/edit-v2/${contentId}`);
                    } else // Pages use /pages/edit-embed/<id> (dedicated embedded editor route).
                    url.pathname = url.pathname.replace(/\/pages\/(\d+)/, '/pages/edit-embed/$1');
                    url.searchParams.set('initialAllowedFeatures', 'delete-draft');
                    return url.toString();
                },
                onSwitchToViewing: (currentUrl, _originalUrl)=>{
                    const url = new URL(currentUrl); // Reverse the edit URL transforms back to view URLs
                    url.pathname = url.pathname.replace(/\/pages\/edit-embed\/(\d+)/, '/pages/$1').replace(/\/blog\/edit-v2\/(\d+)/, '/blog/$1');
                    url.searchParams.delete('initialAllowedFeatures');
                    return url.toString();
                }
            }
        },
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                items: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
                    ...(0, $ixfCV.fg)('maui_remixable_page_native_embeds') ? [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).REMIX
                    ] : [],
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT,
                    ...(0, $ixfCV.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ],
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
                    ...(0, $ixfCV.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ]
                ],
                moreItems: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
                ]
            }),
        editorToolbarHandlers: {},
        renderLoadingComponent: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $hjJUc.default), {
                animationDisabled: props.animationDisabled,
                icons: $f5f0a9f7a4b49836$var$pageIcons,
                testId: props.testId
            }),
        resolveTitleIcon: $f5f0a9f7a4b49836$var$resolveTitleIcon,
        titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
        appearance: 'overlay'
    }
};
module.exports["PageExperienceManifest"] = $f5f0a9f7a4b49836$export$f85d1a9111fa6dfc;

});

parcelRegister("kLlYX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f2152e50a3b99db24df80b6d3e591d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1d93fa86ac2ebd2$var$_react = $f1d93fa86ac2ebd2$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f1d93fa86ac2ebd2$var$_baseNew = $f1d93fa86ac2ebd2$var$_interopRequireDefault((parcelRequire("gElAV")));
function $f1d93fa86ac2ebd2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f1d93fa86ac2ebd2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $f1d93fa86ac2ebd2$var$_react.default.createElement($f1d93fa86ac2ebd2$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$f1d93fa86ac2ebd2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $f1d93fa86ac2ebd2$var$_default = module.exports.default = $f1d93fa86ac2ebd2$var$PageLiveDocIcon;

});

parcelRegister("8iBLq", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $8kONW = parcelRequire("8kONW");


var $kWSTb = parcelRequire("kWSTb");


var $fZ5ji = parcelRequire("fZ5ji");


var $bYNUA = parcelRequire("bYNUA");


var $cFvoT = parcelRequire("cFvoT");


var $k9wGn = parcelRequire("k9wGn");

var $ljOiP = parcelRequire("ljOiP");


var $ixfCV = parcelRequire("ixfCV");


var $anBbz = parcelRequire("anBbz");


var $iPlb2 = parcelRequire("iPlb2");


var $hjJUc = parcelRequire("hjJUc");


var $8fPlA = parcelRequire("8fPlA");

const $dc247be55b77c9b0$var$slideIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($kWSTb))),
    (0, (/*@__PURE__*/$parcel$interopDefault($bYNUA))),
    (0, (/*@__PURE__*/$parcel$interopDefault($cFvoT))),
    (0, (/*@__PURE__*/$parcel$interopDefault($fZ5ji)))
];
const $dc247be55b77c9b0$export$7f3e59c853b03788 = (0, $8fPlA.experienceManifestId)('slide'); /**
                                                                                                  * Experience manifest for a slide embed.
                                                                                                  * Register with getNativeEmbedFacade().registerExperience(SlideExperienceManifest)
                                                                                                  * to obtain a Experience for EmbedFrameUI.
                                                                                                  */ 
const $dc247be55b77c9b0$export$513ec3204bdf9ec = {
    id: $dc247be55b77c9b0$export$7f3e59c853b03788,
    handleChildCommands: (_experience, _cmd)=>{},
    isUrlMatch: (url)=>(0, $anBbz.expValEqualsNoExposure)('cc-mui-slides-experiment', 'isEnabled', true) && (0, $8kONW.isConfluenceSlideUrl)(url),
    supportedFeatures: new Set((0, $iPlb2.allNativeEmbedCoreFeatures)),
    queryParams: {
        disableCanvasScroll: 'true'
    },
    isActive: ()=>(0, $anBbz.expValEqualsNoExposure)('cc-mui-slides-experiment', 'isEnabled', true),
    // Slides have a 16:9 canvas; set the default embed dimensions to 16:10 with a little extra height cause it looks nicer.
    parameterDefaults: {
        width: 960,
        height: 600
    },
    uiConfig: {
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                items: [
                    // BUILTIN_TOOLBAR_KEYS.ASK_ROVO, // Removed until correct context from embed is provided https://product-fabric.atlassian.net/browse/CNS-29056
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED,
                    ...(0, $ixfCV.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ],
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
                    ...(0, $ixfCV.fg)('cc-maui-toolbar-separators-update') ? [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT_URL
                    ] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT_URL,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ]
                ],
                moreItems: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
                ]
            }),
        editorToolbarHandlers: {},
        renderLoadingComponent: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $hjJUc.default), {
                animationDisabled: props.animationDisabled,
                icons: $dc247be55b77c9b0$var$slideIcons,
                testId: props.testId
            }),
        titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kWSTb))),
        appearance: 'overlay'
    }
};
module.exports["SlideExperienceManifest"] = $dc247be55b77c9b0$export$513ec3204bdf9ec;

});

parcelRegister("kWSTb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8306b821ef694f38a906a83337269c35>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f403cd42107c74dc$var$_react = $f403cd42107c74dc$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f403cd42107c74dc$var$_baseNew = $f403cd42107c74dc$var$_interopRequireDefault((parcelRequire("gElAV")));
function $f403cd42107c74dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeSlides".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Confluence Slides
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f403cd42107c74dc$var$AiGenerativeSlidesIcon = (props)=>/*#__PURE__*/ $f403cd42107c74dc$var$_react.default.createElement($f403cd42107c74dc$var$_baseNew.default, Object.assign({
        name: "AiGenerativeSlidesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 10V3.5H0V2h8v1.5H2.5V10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5H15V10a2 2 0 0 1-2 2h-1.376l1.822 2.139-1.142.972L9.654 12H8.75v3h-1.5v-3h-.903l-2.65 3.111-1.143-.972L4.376 12H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M13.115.009a.75.75 0 0 1 .541.378l.05.106.4 1.102c.051.138.16.248.3.299l1.1.4a.75.75 0 0 1 0 1.411l-1.1.401a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.411 0l-.401-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.485-.59L10 3l.009-.116a.75.75 0 0 1 .484-.59l1.102-.4a.5.5 0 0 0 .299-.3l.4-1.1.05-.107A.75.75 0 0 1 12.999 0z"/>`
    }, props));
$f403cd42107c74dc$var$AiGenerativeSlidesIcon.displayName = 'AiGenerativeSlidesIcon';
var $f403cd42107c74dc$var$_default = module.exports.default = $f403cd42107c74dc$var$AiGenerativeSlidesIcon;

});

parcelRegister("fZ5ji", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2f72cdc9dd744d65444b8998cb10ed6d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba30ac06fca117d5$var$_react = $ba30ac06fca117d5$var$_interopRequireDefault((parcelRequire("cozmU")));

var $ba30ac06fca117d5$var$_baseNew = $ba30ac06fca117d5$var$_interopRequireDefault((parcelRequire("gElAV")));
function $ba30ac06fca117d5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoMiniplayer".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for picture-in-picture functionality for videos.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ba30ac06fca117d5$var$VideoMiniplayerIcon = (props)=>/*#__PURE__*/ $ba30ac06fca117d5$var$_react.default.createElement($ba30ac06fca117d5$var$_baseNew.default, Object.assign({
        name: "VideoMiniplayerIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zm4.75 4a.75.75 0 0 1 .75-.75h4.75a.75.75 0 0 1 .75.75v2.75a.75.75 0 0 1-.75.75H7.5a.75.75 0 0 1-.75-.75z" clip-rule="evenodd"/>`
    }, props));
$ba30ac06fca117d5$var$VideoMiniplayerIcon.displayName = 'VideoMiniplayerIcon';
var $ba30ac06fca117d5$var$_default = module.exports.default = $ba30ac06fca117d5$var$VideoMiniplayerIcon;

});

parcelRegister("bYNUA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::197921048e92db6f31070962e79acfb7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8b8c03b563f282f7$var$_react = $8b8c03b563f282f7$var$_interopRequireDefault((parcelRequire("cozmU")));

var $8b8c03b563f282f7$var$_baseNew = $8b8c03b563f282f7$var$_interopRequireDefault((parcelRequire("gElAV")));
function $8b8c03b563f282f7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPlayCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: play video in Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8b8c03b563f282f7$var$VideoPlayCircleIcon = (props)=>/*#__PURE__*/ $8b8c03b563f282f7$var$_react.default.createElement($8b8c03b563f282f7$var$_baseNew.default, Object.assign({
        name: "VideoPlayCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m5-2.694c0-.808.866-1.32 1.574-.931l4.958 2.722a1.062 1.062 0 0 1 0 1.862l-4.958 2.722A1.063 1.063 0 0 1 5 10.75zm1.5.74v3.965l3.611-1.983z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.5 10.01V6.046l3.611 1.983z"/>`
    }, props));
$8b8c03b563f282f7$var$VideoPlayCircleIcon.displayName = 'VideoPlayCircleIcon';
var $8b8c03b563f282f7$var$_default = module.exports.default = $8b8c03b563f282f7$var$VideoPlayCircleIcon;

});

parcelRegister("aaqIB", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $cXtTj = parcelRequire("cXtTj");


var $b5sDq = parcelRequire("b5sDq");


var $h5uPL = parcelRequire("h5uPL");


var $jxqsh = parcelRequire("jxqsh");


var $bDjVc = parcelRequire("bDjVc");


var $k9wGn = parcelRequire("k9wGn");

var $ljOiP = parcelRequire("ljOiP");


var $ixfCV = parcelRequire("ixfCV");


var $iPlb2 = parcelRequire("iPlb2");


var $hjJUc = parcelRequire("hjJUc");


var $1xINT = parcelRequire("1xINT");


var $8fPlA = parcelRequire("8fPlA");


var $7wdoX = parcelRequire("7wdoX");

const $af71dcb44dbd21c6$export$571bdd0f87630d48 = (0, $8fPlA.experienceManifestId)('whiteboard'); /**
                                                                                                            * Dynamic-config killswitch for sending `disableCanvasScroll` conditionally in
                                                                                                            * legacy full screen. Default `false` = change enabled (param omitted from the
                                                                                                            * legacy full-screen URL so the blown-up board scrolls); set to `true` to roll
                                                                                                            * back to the pre-EPS8-40 behavior (param sent everywhere).
                                                                                                            */ 
const $af71dcb44dbd21c6$var$LEGACY_FS_CANVAS_SCROLL_KILLSWITCH = 'platform_native_embed_legacy_fs_canvas_scroll';
const $af71dcb44dbd21c6$var$WAIT_FOR_CONTENT_READY_CONFIG = 'platform_native_embed_wait_for_content_ready';
const $af71dcb44dbd21c6$var$whiteboardIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b5sDq))),
    (0, (/*@__PURE__*/$parcel$interopDefault($jxqsh))),
    (0, (/*@__PURE__*/$parcel$interopDefault($h5uPL)))
];
const $af71dcb44dbd21c6$var$shouldWaitForContentReady = ()=>// eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- Dynamic configuration controls this staged rollout.
    (0, $cXtTj.default).getExperimentValue($af71dcb44dbd21c6$var$WAIT_FOR_CONTENT_READY_CONFIG, 'value', false);
const $af71dcb44dbd21c6$var$isWhiteboardUrl = (url)=>// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    url.match(RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>\\d+)(\\?\\/)?")) || url.match(// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>[0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12})(\\?\\/)?")); /**
                                                                                                                                                * Experience manifest for a whiteboard embed.
                                                                                                                                                * Register with getNativeEmbedFacade().registerExperience(WhiteboardExperienceManifest)
                                                                                                                                                * to obtain a Experience for EmbedFrameUI.
                                                                                                                                                */ 
const $af71dcb44dbd21c6$export$257420b954ccf94c = {
    id: $af71dcb44dbd21c6$export$571bdd0f87630d48,
    handleChildCommands: (_experience, cmd)=>{
        switch(cmd.type){
            case (0, $7wdoX.NativeEmbedChildCommandType).FreezeFrameResponse:
                break;
            case (0, $7wdoX.NativeEmbedChildCommandType).UnfreezeFrameResponse:
                break;
        }
    },
    isUrlMatch: $af71dcb44dbd21c6$var$isWhiteboardUrl,
    shouldAutoConvertToNativeEmbed: true,
    supportedFeatures: new Set((0, $iPlb2.allNativeEmbedCoreFeatures)),
    // Thunk so the killswitch is read at URL-build time (after Statsig init), and
    // so the conditional behavior is gated at its source: when rolled back the
    // manifest emits the pre-EPS8-40 plain-string value, which `resolveQueryParams`
    // passes through unchanged at every build site.
    //
    // `disableCanvasScroll` is correct inline (and in shared-iframe full screen,
    // which reuses the inline URL) but makes the blown-up board feel broken in the
    // legacy full-screen iframe, so by default it is omitted from that build site
    // only. `hideCursors` applies everywhere (plain string === appliesTo: 'always').
    queryParams: ()=>{
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const rolledBack = (0, $cXtTj.default).getExperimentValue($af71dcb44dbd21c6$var$LEGACY_FS_CANVAS_SCROLL_KILLSWITCH, 'value', false);
        return rolledBack ? {
            disableCanvasScroll: 'true',
            hideCursors: 'true'
        } : {
            disableCanvasScroll: {
                value: 'true',
                appliesTo: 'exceptLegacyFullscreen'
            },
            hideCursors: 'true'
        };
    },
    transformUrl: (url, isFullScreen)=>{
        const urlObj = new URL(url);
        if (!isFullScreen) urlObj.searchParams.set('hideBorder', 'true');
         // this is used to identify the native embed view in the whiteboard app
        urlObj.searchParams.set('nativeEmbedView', 'true');
        const initialTheme = (0, $1xINT.getInitialThemeParam)();
        if (initialTheme) urlObj.searchParams.set('themeState', initialTheme);
        return urlObj.toString();
    },
    isActive: ()=>{
        return true;
    },
    uiConfig: {
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                items: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT,
                    ...(0, $ixfCV.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ],
                    // BUILTIN_TOOLBAR_KEYS.BORDER, // Border option is yet to be implemented.
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
                    ...(0, $ixfCV.fg)('cc-maui-toolbar-separators-update') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ]
                ],
                moreItems: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
                ]
            }),
        editorToolbarHandlers: {},
        renderLoadingComponent: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $hjJUc.default), {
                animationDisabled: props.animationDisabled,
                icons: $af71dcb44dbd21c6$var$whiteboardIcons,
                testId: props.testId
            }),
        titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
        appearance: 'overlay',
        waitForContentReady: $af71dcb44dbd21c6$var$shouldWaitForContentReady
    }
};
module.exports["WhiteboardExperienceManifest"] = $af71dcb44dbd21c6$export$257420b954ccf94c;

});

parcelRegister("7wdoX", function(module, exports) {
var $3d7fb527228d62f2$export$e02855afa78b2d37 = /*#__PURE__*/ function(NativeEmbedCommandType) {
    NativeEmbedCommandType["FreezeFrameRequest"] = "freezeFrameRequest";
    NativeEmbedCommandType["UnfreezeFrame"] = "unfreezeFrame";
    return NativeEmbedCommandType;
}({});
var $3d7fb527228d62f2$export$f17561b95ea7b258 = /*#__PURE__*/ function(NativeEmbedChildCommandType) {
    NativeEmbedChildCommandType["FreezeFrameResponse"] = "freezeFrameResponse";
    NativeEmbedChildCommandType["UnfreezeFrameResponse"] = "unfreezeFrameResponse";
    return NativeEmbedChildCommandType;
}({});
module.exports["NativeEmbedChildCommandType"] = $3d7fb527228d62f2$export$f17561b95ea7b258;

});

parcelRegister("lnFlR", function(module, exports) {

let $f90bd2872e672128$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f90bd2872e672128$var$load("2hLAI"),
    $f90bd2872e672128$var$load("dCilB"),
    $f90bd2872e672128$var$load("6wr18"),
    $f90bd2872e672128$var$load("jcyn8"),
    $f90bd2872e672128$var$load("9njOW"),
    $f90bd2872e672128$var$load("47s9y"),
    $f90bd2872e672128$var$load("ffEVr"),
    $f90bd2872e672128$var$load("bY4kf")
]).then(()=>parcelRequire('htIUR'));

});

parcelRegister("eeCnx", function(module, exports) {
/* MauiNativeEmbedBanner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

parcelRequire("fmu9K");
var $iTJtk = parcelRequire("iTJtk");


var $9DHhW = parcelRequire("9DHhW");


var $krYZG = parcelRequire("krYZG");


var $3k5Tv = parcelRequire("3k5Tv");


var $cXtTj = parcelRequire("cXtTj");


var $lMGh1 = parcelRequire("lMGh1");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");


var $90zNn = parcelRequire("90zNn");


var $5J9kV = parcelRequire("5J9kV");


var $3kyUj = parcelRequire("3kyUj");

const $ff88427019e7eb06$var$MAUI_WHITEBOARD_EXPERIENCE_MANIFEST_ID = 'maui-whiteboard';
const $ff88427019e7eb06$var$WHITEBOARD_EXPERIENCE_MANIFEST_ID = 'whiteboard';
const $ff88427019e7eb06$var$STALE_WHITEBOARD_BANNER_KILLSWITCH = 'confluence_native_embed_stale_whiteboard'; // Gives fast finalize/URL replacement a chance to settle before showing a false warning.
const $ff88427019e7eb06$var$NEEDS_FINALIZE_BANNER_DELAY_MS = 120000;
const $ff88427019e7eb06$var$messages = (0, $kSwu1.defineMessages)({
    bannerNeedsFinalizeMessage: {
        id: "editor-plugin-malleable-ui.MauiNativeEmbedBanner.bannerNeedsFinalizeMessage",
        defaultMessage: "Diagram not visible to others. Move your diagram\u2019s whiteboard to make it visible to others and avoid auto removal."
    },
    bannerFinalizingMessage: {
        id: "editor-plugin-malleable-ui.MauiNativeEmbedBanner.bannerFinalizingMessage",
        defaultMessage: "Moving whiteboard\u2026"
    },
    bannerFailedMessage: {
        id: "editor-plugin-malleable-ui.MauiNativeEmbedBanner.bannerFailedMessage",
        defaultMessage: "We couldn't move this diagram to this page. Please try again."
    },
    moveToPageButton: {
        id: "editor-plugin-malleable-ui.MauiNativeEmbedBanner.moveToPageButton",
        defaultMessage: "Move"
    },
    movingButton: {
        id: "editor-plugin-malleable-ui.MauiNativeEmbedBanner.movingButton",
        defaultMessage: "Moving\u2026"
    },
    tryAgainButton: {
        id: "editor-plugin-malleable-ui.MauiNativeEmbedBanner.tryAgainButton",
        defaultMessage: "Try again"
    }
});
const $ff88427019e7eb06$var$styles = {
    banner: "_1rjc1b66 _18zru2gc _n7zlm2kk _kqswstnw _154ize3t _1ltvze3t _1xi2ze3t _1pbyb4wl _bfhk1917 _syaz1xn9",
    bannerContent: "_1bsb1osq",
    bannerMessage: "_11c8wadc",
    actionLink: "_11c8wadc _4bfu1r31 _1hmsglyw _ajmmnqa1 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _bfhksm61 _syaz13af _k48pi7a9 _1s1h1r31 _11poglyw _8f1enqa1 _vbqb1gmx _j5dh15jw _9oik1r31 _1bnx8stv _jf4cnqa1 _9h8h12zz"
};
const $ff88427019e7eb06$export$dd4e69056658cc1 = (url)=>{
    if (!url) return undefined;
    return (0, $5J9kV.WHITEBOARD_PATH_REGEX).exec(url)?.[2];
};
const $ff88427019e7eb06$export$1bc65665b1ddeb6f = (experienceId)=>{
    if (experienceId === $ff88427019e7eb06$var$MAUI_WHITEBOARD_EXPERIENCE_MANIFEST_ID) return true;
    if (experienceId !== $ff88427019e7eb06$var$WHITEBOARD_EXPERIENCE_MANIFEST_ID) return false;
     // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- dynamic config killswitch, not a standard feature gate
    return !(0, $cXtTj.default).getExperimentValue($ff88427019e7eb06$var$STALE_WHITEBOARD_BANNER_KILLSWITCH, 'value', false);
};
const $ff88427019e7eb06$var$shouldShowBanner = (status)=>status === (0, $3kyUj.MauiEmbedFinalizeStatus).NEEDS_FINALIZE || status === (0, $3kyUj.MauiEmbedFinalizeStatus).FINALIZING || status === (0, $3kyUj.MauiEmbedFinalizeStatus).FAILED || status === (0, $3kyUj.MauiEmbedFinalizeStatus).NEEDS_SPACE_SELECTION && // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- dynamic config killswitch, not a standard feature gate
    !(0, $cXtTj.default).getExperimentValue('maui-native-embed-finalize-diagram-anywhere', 'value', false);
const $ff88427019e7eb06$var$TEST_ID = 'native-embed-extension--rovo-system-space-banner';
const $ff88427019e7eb06$export$e7b6e7d7200932ee = ({ api: api, experienceId: experienceId, url: url })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isSubmitting, setIsSubmitting] = (0, $cozmU.useState)(false);
    const [isNeedsFinalizeBannerDelayElapsed, setIsNeedsFinalizeBannerDelayElapsed] = (0, $cozmU.useState)(false);
    const probedKeyRef = (0, $cozmU.useRef)(null); // Tracks whether the banner is still mounted so we don't call
    // `setIsSubmitting(false)` after the component has been unmounted —
    // which happens when the in-flight finalize causes status to reach
    // FINALIZED and `shouldShowBanner` returns false.
    const mountedRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    const isBannerCandidate = $ff88427019e7eb06$export$1bc65665b1ddeb6f(experienceId);
    const contentId = (0, $cozmU.useMemo)(()=>isBannerCandidate ? $ff88427019e7eb06$export$dd4e69056658cc1(url) : undefined, [
        isBannerCandidate,
        url
    ]); // If the embed URL carries an `_rc` conversation-context payload (e.g.
    // the original Rovo Chat link), forward it so `finalizeAfterMove` can
    // take the convo-ai path. When absent (e.g. older links, or links
    // already moved/cleaned), the consumer falls back to the monolith
    // finalize endpoint.
    const conversationContext = (0, $cozmU.useMemo)(()=>isBannerCandidate && url ? (0, $5J9kV.parseMauiDiagramLink)(url)?.conversationContext : undefined, [
        isBannerCandidate,
        url
    ]);
    const status = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'malleableUi'
    ], (states)=>{
        const entry = contentId ? states.malleableUiState?.diagramPaste?.embedFinalizeStates?.[contentId] : undefined;
        return entry?.status ?? (0, $3kyUj.MauiEmbedFinalizeStatus).UNKNOWN;
    });
    const finalizeAction = api?.malleableUi?.actions?.finalizeMauiEmbedFromIndicator; // When on, rolls back to the 2-minute warning delay; when off, finalize status alone drives visibility.
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- dynamic config killswitch, not a standard feature gate
    const isStreamingWarningKillswitchOn = (0, $cXtTj.default).getExperimentValue('confluence_diagram_native_embed_warning_streaming', 'value', false);
    (0, $cozmU.useEffect)(()=>{
        if (!isStreamingWarningKillswitchOn) {
            setIsNeedsFinalizeBannerDelayElapsed(true);
            return;
        }
        if (!isBannerCandidate || !contentId || !url || status !== (0, $3kyUj.MauiEmbedFinalizeStatus).NEEDS_FINALIZE) {
            setIsNeedsFinalizeBannerDelayElapsed(false);
            return;
        }
        setIsNeedsFinalizeBannerDelayElapsed(false);
        const timerId = setTimeout(()=>{
            setIsNeedsFinalizeBannerDelayElapsed(true);
        }, $ff88427019e7eb06$var$NEEDS_FINALIZE_BANNER_DELAY_MS);
        return ()=>{
            clearTimeout(timerId);
        };
    }, [
        contentId,
        isBannerCandidate,
        isStreamingWarningKillswitchOn,
        status,
        url
    ]); // Fallback probe for pre-existing un-moved diagrams; self-skips once status is set (e.g. CHECKING during streaming).
    (0, $cozmU.useEffect)(()=>{
        if (!isBannerCandidate || !contentId || !url || !finalizeAction) return;
        const key = `${contentId}::${url}`;
        if (probedKeyRef.current === key) return;
        if (status !== (0, $3kyUj.MauiEmbedFinalizeStatus).UNKNOWN) {
            probedKeyRef.current = key;
            return;
        }
        probedKeyRef.current = key;
        createAnalyticsEvent?.({
            action: 'probed',
            actionSubject: 'mauiDiagram',
            actionSubjectId: 'embedFinalize',
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                contentId: contentId
            }
        })?.fire((0, $iTJtk.FabricChannel).editor);
        finalizeAction({
            contentId: contentId,
            originalUrl: url,
            conversationContext: conversationContext,
            mode: 'probe'
        });
    }, [
        contentId,
        conversationContext,
        createAnalyticsEvent,
        finalizeAction,
        isBannerCandidate,
        status,
        url
    ]);
    const onMoveToPage = (0, $cozmU.useCallback)(async ()=>{
        if (!contentId || !url || isSubmitting) return;
         // If the probe already denied permission, re-open the picker instead of
        // re-running the probe (which would just deny again).
        if (status === (0, $3kyUj.MauiEmbedFinalizeStatus).NEEDS_SPACE_SELECTION && // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- dynamic config killswitch, not a standard feature gate
        !(0, $cXtTj.default).getExperimentValue('maui-native-embed-finalize-diagram-anywhere', 'value', false)) {
            api?.core?.actions.execute((0, $90zNn.openMauiEmbedSpacePickerCommand)({
                contentId: contentId,
                originalUrl: url
            }));
            return;
        }
        if (!finalizeAction) return;
        setIsSubmitting(true);
        try {
            await finalizeAction({
                contentId: contentId,
                originalUrl: url,
                conversationContext: conversationContext,
                mode: 'finalize'
            });
        } finally{
            if (mountedRef.current) setIsSubmitting(false);
        }
    }, [
        contentId,
        conversationContext,
        api,
        finalizeAction,
        isSubmitting,
        status,
        url
    ]);
    if (!isBannerCandidate || !$ff88427019e7eb06$var$shouldShowBanner(status) || // Killswitch on: suppress the warning during the grace period (no-op when off).
    status === (0, $3kyUj.MauiEmbedFinalizeStatus).NEEDS_FINALIZE && !isNeedsFinalizeBannerDelayElapsed) return null;
    const inFlight = isSubmitting || status === (0, $3kyUj.MauiEmbedFinalizeStatus).FINALIZING;
    const isFailed = status === (0, $3kyUj.MauiEmbedFinalizeStatus).FAILED;
    const messageId = inFlight ? $ff88427019e7eb06$var$messages.bannerFinalizingMessage : isFailed ? $ff88427019e7eb06$var$messages.bannerFailedMessage : $ff88427019e7eb06$var$messages.bannerNeedsFinalizeMessage;
    const buttonLabelId = inFlight ? $ff88427019e7eb06$var$messages.movingButton : isFailed ? $ff88427019e7eb06$var$messages.tryAgainButton : $ff88427019e7eb06$var$messages.moveToPageButton;
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $ff88427019e7eb06$var$styles.banner,
        testId: `${$ff88427019e7eb06$var$TEST_ID}--wrapper`,
        role: "status",
        "aria-live": "polite"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        xcss: $ff88427019e7eb06$var$styles.bannerContent,
        space: "space.075",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
        label: "",
        color: "currentColor",
        spacing: "spacious",
        testId: `${$ff88427019e7eb06$var$TEST_ID}--icon`
    }), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        space: "space.075",
        alignBlock: "center",
        xcss: $ff88427019e7eb06$var$styles.bannerMessage
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        testId: `${$ff88427019e7eb06$var$TEST_ID}--message`
    }, intl.formatMessage(messageId)), /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.default), {
        xcss: $ff88427019e7eb06$var$styles.actionLink,
        isDisabled: inFlight,
        onClick: onMoveToPage,
        testId: `${$ff88427019e7eb06$var$TEST_ID}--action-button`
    }, intl.formatMessage(buttonLabelId)))));
};
const $ff88427019e7eb06$export$63c1684d0e85e4d8 = (api)=>(props)=>/*#__PURE__*/ $cozmU.createElement($ff88427019e7eb06$export$e7b6e7d7200932ee, {
            ...props,
            api: api
        });
module.exports["createMauiNativeEmbedBannerRenderer"] = $ff88427019e7eb06$export$63c1684d0e85e4d8;

});

parcelRegister("fmu9K", function(module, exports) {
$parcel$export(module.exports, "FabricChannel", () => (parcelRequire("iTJtk")).FabricChannel);

var $hpWmZ = parcelRequire("hpWmZ");


var $lMjmr = parcelRequire("lMjmr");


var $iTJtk = parcelRequire("iTJtk");


});

parcelRegister("90zNn", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $5J9kV = parcelRequire("5J9kV");


var $3kyUj = parcelRequire("3kyUj");

const $cce1ca9a43ab2ea5$var$getMauiEmbedContentId = ({ contentId: contentId, originalUrl: originalUrl })=>contentId ?? (originalUrl ? (0, $5J9kV.parseMauiDiagramLink)(originalUrl)?.contentId : undefined);
const $cce1ca9a43ab2ea5$export$10176484e72e39ca = (args)=>({ tr: tr })=>{
        if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- dynamic config killswitch, not a standard feature gate
        (0, $cXtTj.default).getExperimentValue('maui-native-embed-finalize-diagram-anywhere', 'value', false)) return null;
        const contentId = $cce1ca9a43ab2ea5$var$getMauiEmbedContentId(args);
        if (!contentId) return null;
        tr.setMeta((0, $3kyUj.mauiDiagramPastePluginKey), {
            type: (0, $3kyUj.ActionType).EMBED_FINALIZE_OPEN_PICKER,
            contentId: contentId
        });
        return tr;
    };
const $cce1ca9a43ab2ea5$export$5e7e7bd6033f1371 = (args)=>({ tr: tr })=>{
        if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- dynamic config killswitch, not a standard feature gate
        (0, $cXtTj.default).getExperimentValue('maui-native-embed-finalize-diagram-anywhere', 'value', false)) return null;
        const contentId = $cce1ca9a43ab2ea5$var$getMauiEmbedContentId(args);
        if (!contentId) return null;
        tr.setMeta((0, $3kyUj.mauiDiagramPastePluginKey), {
            type: (0, $3kyUj.ActionType).EMBED_FINALIZE_CLOSE_PICKER,
            contentId: contentId
        });
        return tr;
    };
module.exports["openMauiEmbedSpacePickerCommand"] = $cce1ca9a43ab2ea5$export$10176484e72e39ca;
module.exports["closeMauiEmbedSpacePickerCommand"] = $cce1ca9a43ab2ea5$export$5e7e7bd6033f1371;

});

parcelRegister("5J9kV", function(module, exports) {
/**
 * Single query-param name for the base64-encoded conversation context blob.
 * `isRemixDiagram` remains a separate param for fast detection in the paste
 * plugin without needing to decode.
 */ const $ab8587ce124d5a90$var$CONVO_CONTEXT_PARAM = '_rc';
const $ab8587ce124d5a90$export$cfeb9d315a2667e = /\/wiki\/spaces\/([^/]+)\/whiteboard\/(\d+)/;
const $ab8587ce124d5a90$var$REMIX_DIAGRAM_PARAM = 'isRemixDiagram';
/**
 * Matches a MAUI app URL of the form `/remix/ui/{appId}`.
 * The appId can contain alphanumeric characters, hyphens, and underscores.
 */ // eslint-disable-next-line require-unicode-regexp
const $ab8587ce124d5a90$var$MAUI_APP_PATH_REGEX = /\/remix\/ui\/([\w-]+)/;
/**
 * Extracts conversation context from the base64-encoded `_rc` query parameter.
 * Returns undefined if the param is missing or malformed.
 */ function $ab8587ce124d5a90$var$extractConversationContext(urlObj) {
    const encoded = urlObj.searchParams.get($ab8587ce124d5a90$var$CONVO_CONTEXT_PARAM);
    if (!encoded) return undefined;
    try {
        const json = atob(encoded);
        const parsed = JSON.parse(json);
        const { conversationId: conversationId, messageId: messageId, invocationId: invocationId } = parsed;
        if (!conversationId || !messageId || !invocationId) return undefined;
        return {
            conversationId: conversationId,
            messageId: messageId,
            invocationId: invocationId
        };
    } catch  {
        return undefined;
    }
}
/**
 * Strips the `_rc` conversation context query parameter from a URL string.
 */ function $ab8587ce124d5a90$var$stripConversationParams(url) {
    try {
        const urlObj = $ab8587ce124d5a90$var$toURL(url);
        if (!urlObj) return url;
        urlObj.searchParams.delete($ab8587ce124d5a90$var$CONVO_CONTEXT_PARAM);
        return urlObj.toString();
    } catch  {
        return url;
    }
}
function $ab8587ce124d5a90$export$6472c78b54a80875(url) {
    const trimmedUrl = url.trim();
    if (!trimmedUrl) return null;
    const pathMatch = $ab8587ce124d5a90$export$cfeb9d315a2667e.exec(trimmedUrl);
    if (!pathMatch) return null;
    const contentId = pathMatch[2];
    try {
        const urlObj = $ab8587ce124d5a90$var$toURL(trimmedUrl);
        if (!urlObj) return null;
        if (urlObj.searchParams.get($ab8587ce124d5a90$var$REMIX_DIAGRAM_PARAM) !== 'true') return null;
        return {
            contentId: contentId,
            originalUrl: trimmedUrl,
            conversationContext: $ab8587ce124d5a90$var$extractConversationContext(urlObj)
        };
    } catch  {
        return null;
    }
}
function $ab8587ce124d5a90$export$d58b6fdd356557bd(url, targetSpaceKey) {
    try {
        const replaced = url.replace($ab8587ce124d5a90$export$cfeb9d315a2667e, `/wiki/spaces/${encodeURIComponent(targetSpaceKey)}/whiteboard/$2`);
        return $ab8587ce124d5a90$var$stripConversationParams($ab8587ce124d5a90$var$stripRemixDiagramParam(replaced));
    } catch  {
        return url;
    }
}
/**
 * Strips the `isRemixDiagram` query parameter from a URL.
 */ function $ab8587ce124d5a90$var$stripRemixDiagramParam(url) {
    try {
        const urlObj = $ab8587ce124d5a90$var$toURL(url);
        if (!urlObj) return url;
        urlObj.searchParams.delete($ab8587ce124d5a90$var$REMIX_DIAGRAM_PARAM);
        return urlObj.toString();
    } catch  {
        return url;
    }
}
function $ab8587ce124d5a90$var$toURL(urlString) {
    try {
        return new URL(urlString);
    } catch  {
        try {
            return new URL(urlString, window.location.origin);
        } catch  {
            return null;
        }
    }
}
function $ab8587ce124d5a90$export$5f9527958cc0f7be(url) {
    const trimmedUrl = url.trim();
    if (!trimmedUrl) return null;
    const pathMatch = $ab8587ce124d5a90$var$MAUI_APP_PATH_REGEX.exec(trimmedUrl);
    if (!pathMatch) return null;
    return {
        appId: pathMatch[1],
        originalUrl: trimmedUrl
    };
}
function $ab8587ce124d5a90$export$5969f844d7846c47(url, newAppId) {
    try {
        return url.replace($ab8587ce124d5a90$var$MAUI_APP_PATH_REGEX, `/remix/ui/${encodeURIComponent(newAppId)}`);
    } catch  {
        return url;
    }
}
function $ab8587ce124d5a90$export$5497de8ab9c2c871(clipboardData) {
    const text = clipboardData.getData('text/plain');
    if (!text) return null;
    const trimmed = text.trim();
    if (trimmed.includes('\n') || trimmed.includes('\r')) return null;
    if (!trimmed.startsWith('http://') && !trimmed.startsWith('https://') && !trimmed.startsWith('/wiki/') && !trimmed.startsWith('/remix/')) return null;
    return trimmed;
}
module.exports["WHITEBOARD_PATH_REGEX"] = $ab8587ce124d5a90$export$cfeb9d315a2667e;
module.exports["parseMauiDiagramLink"] = $ab8587ce124d5a90$export$6472c78b54a80875;
module.exports["buildMovedUrl"] = $ab8587ce124d5a90$export$d58b6fdd356557bd;
module.exports["parseMauiAppLink"] = $ab8587ce124d5a90$export$5f9527958cc0f7be;
module.exports["buildDuplicatedMauiAppUrl"] = $ab8587ce124d5a90$export$5969f844d7846c47;
module.exports["extractPastedUrl"] = $ab8587ce124d5a90$export$5497de8ab9c2c871;

});

parcelRegister("3kyUj", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $cXtTj = parcelRequire("cXtTj");


var $ixfCV = parcelRequire("ixfCV");


var $irnO2 = parcelRequire("irnO2");


var $bjY3F = parcelRequire("bjY3F");


var $lhZdS = parcelRequire("lhZdS");


var $k6l1W = parcelRequire("k6l1W");


var $5J9kV = parcelRequire("5J9kV");

const $cb9542f9d166ab64$var$DUPLICATE_FALLBACK_ERROR_MESSAGE = 'Failed to duplicate MAUI app.';
const $cb9542f9d166ab64$var$getMauiExperienceTracker = ()=>(0, $bjY3F.ExperienceTrackerHandler).getInstance().experienceTracker;
const $cb9542f9d166ab64$var$failRemixDuplicateAppAndInsert = (error, attributes)=>{
    const experienceTracker = $cb9542f9d166ab64$var$getMauiExperienceTracker();
    experienceTracker.fail({
        name: (0, $irnO2.ExperienceName).REMIX_DUPLICATE_APP,
        error: error,
        attributes: attributes
    });
    experienceTracker.fail({
        name: (0, $irnO2.ExperienceName).REMIX_INSERT,
        error: error,
        attributes: {
            ...attributes,
            failedDueTo: (0, $irnO2.ExperienceName).REMIX_DUPLICATE_APP
        }
    });
};
var $cb9542f9d166ab64$export$61cfd1372c207927 = /*#__PURE__*/ function(MauiDiagramPasteFlagType) {
    MauiDiagramPasteFlagType["ERROR"] = "error";
    MauiDiagramPasteFlagType["INFO"] = "info";
    MauiDiagramPasteFlagType["SUCCESS"] = "success";
    return MauiDiagramPasteFlagType;
}({});
var $cb9542f9d166ab64$export$98d47fb2fca5e93 = /*#__PURE__*/ function(MauiEmbedFinalizeStatus) {
    /** No information yet — needs to call `resolveContentSpaceKey`. */ MauiEmbedFinalizeStatus["UNKNOWN"] = "UNKNOWN";
    /** Resolution is in flight. */ MauiEmbedFinalizeStatus["CHECKING"] = "CHECKING";
    /** Whiteboard is parented in a Rovo system space and needs finalize. */ MauiEmbedFinalizeStatus["NEEDS_FINALIZE"] = "NEEDS_FINALIZE";
    /** Already in a real (non-Rovo) space — nothing to do. */ MauiEmbedFinalizeStatus["NOT_NEEDED"] = "NOT_NEEDED";
    /** Finalize is in flight. */ MauiEmbedFinalizeStatus["FINALIZING"] = "FINALIZING";
    /** Finalize succeeded; URL has been rewritten. */ MauiEmbedFinalizeStatus["FINALIZED"] = "FINALIZED";
    /** Resolve or finalize failed — user can retry. */ MauiEmbedFinalizeStatus["FAILED"] = "FAILED";
    /** `canCreatePageInSpace` returned `false`; the picker mounts. */ MauiEmbedFinalizeStatus["NEEDS_SPACE_SELECTION"] = "NEEDS_SPACE_SELECTION";
    return MauiEmbedFinalizeStatus;
}({});
var $cb9542f9d166ab64$export$e4a712fff93fb00f = /*#__PURE__*/ function(ActionType) {
    ActionType["MOVE_STARTED"] = "MOVE_STARTED";
    ActionType["MOVE_SUCCEEDED"] = "MOVE_SUCCEEDED";
    ActionType["MOVE_FAILED"] = "MOVE_FAILED";
    ActionType["DUPLICATE_STARTED"] = "DUPLICATE_STARTED";
    ActionType["DUPLICATE_SUCCEEDED"] = "DUPLICATE_SUCCEEDED";
    ActionType["DUPLICATE_FAILED"] = "DUPLICATE_FAILED";
    ActionType["DISMISS_FLAG"] = "DISMISS_FLAG";
    ActionType["EMBED_FINALIZE_STATUS_CHANGED"] = "EMBED_FINALIZE_STATUS_CHANGED";
    /** Drops the per-content-id entry so the next mount re-runs the probe. */ ActionType["EMBED_FINALIZE_RESET"] = "EMBED_FINALIZE_RESET";
    /** Opens the space picker for a NEEDS_SPACE_SELECTION embed. */ ActionType["EMBED_FINALIZE_OPEN_PICKER"] = "EMBED_FINALIZE_OPEN_PICKER";
    /** Closes the space picker without resetting the embed's status. */ ActionType["EMBED_FINALIZE_CLOSE_PICKER"] = "EMBED_FINALIZE_CLOSE_PICKER";
    return ActionType;
}({});
const $cb9542f9d166ab64$export$acc845c5f0893b92 = new (0, $kCECX.PluginKey)('mauiDiagramPastePlugin');
/**
 * Set of currently-mounted EditorViews that have the diagram-paste PM
 * plugin installed. Populated by the plugin's `view()` lifecycle on mount
 * and removed on `destroy()`. Consulted by the `executeMauiEmbedFinalize`
 * action so it can dispatch transactions spanning the async finalize
 * workflow without callers needing to thread a view through.
 *
 * Why a Set (not a WeakMap keyed by PluginKey): `mauiDiagramPastePluginKey`
 * is a module-level singleton, so all live editor instances share the
 * exact same key. A WeakMap keyed by that singleton would only ever store
 * one slot — the last editor to mount would silently overwrite earlier
 * entries, and a stale entry from any earlier editor would shadow newer
 * ones once that editor unmounted. Using a Set lets us track every live
 * editor independently and disambiguate per-call via `originalUrl`.
 */ const $cb9542f9d166ab64$var$knownViews = new Set();
const $cb9542f9d166ab64$var$knownViewIntlGetters = new WeakMap();
function $cb9542f9d166ab64$export$6f4f362dd066ad09(originalUrl) {
    if (originalUrl) for (const view of $cb9542f9d166ab64$var$knownViews){
        if ($cb9542f9d166ab64$var$docContainsUrl(view.state.doc, originalUrl)) return view;
    }
    // Fallback: no URL provided, or no editor currently contains the URL.
    // Return the first known view — callers without a URL hint accept that
    // in multi-editor scenarios this is best-effort.
    return $cb9542f9d166ab64$var$knownViews.values().next().value;
}
const $cb9542f9d166ab64$var$fallbackGetIntl = ()=>({
        formatMessage: ({ defaultMessage: defaultMessage })=>defaultMessage
    });
const $cb9542f9d166ab64$var$formatFlagMessage = (getIntl, message)=>getIntl().formatMessage(message);
const $cb9542f9d166ab64$var$initialState = {
    isMoving: false,
    activeFlag: null,
    embedFinalizeStates: {}
};
const $cb9542f9d166ab64$var$CARD_NODE_NAMES = new Set([
    'inlineCard',
    'blockCard',
    'embedCard'
]);
const $cb9542f9d166ab64$var$ROVO_SPACE_PREFIX = '~ROVO';
/**
 * Checks whether the document already contains a reference to the given URL.
 * Only inspects card nodes and extension nodes (both flat and macroParams
 * formats) — link marks and plain text are intentionally skipped.
 *
 * Returns `true` on the first match, stopping traversal early.
 */ function $cb9542f9d166ab64$var$docContainsUrl(doc, url) {
    let found = false;
    doc.descendants((node)=>{
        if (found) return false;
        if ($cb9542f9d166ab64$var$CARD_NODE_NAMES.has(node.type.name) && node.attrs?.url?.includes(url)) {
            found = true;
            return false;
        }
        if (node.type.name === 'extension') {
            // Flat format: parameters.url
            if (node.attrs?.parameters?.url?.includes(url)) {
                found = true;
                return false;
            }
            // Native embed macro format: parameters.macroParams.url.value
            if (node.attrs?.parameters?.macroParams?.url?.value?.includes(url)) {
                found = true;
                return false;
            }
        }
        return true;
    });
    return found;
}
/**
 * Searches the editor document for any occurrence of the original URL and
 * replaces it with the new URL. Handles:
 * - inlineCard / blockCard / embedCard nodes with a url attribute
 * - extension nodes with a parameters.url attribute (native embeds)
 * - Hyperlink marks with the URL as href
 * - Plain text nodes containing the URL
 *
 * Mutations are collected during traversal and applied in reverse document
 * order so that earlier positions are not invalidated by later mutations.
 */ function $cb9542f9d166ab64$var$updateUrlInDoc(tr, originalUrl, newUrl) {
    const cardMutations = [];
    const extensionMutations = [];
    const linkMarkMutations = [];
    const textReplaceMutations = [];
    tr.doc.descendants((node, pos)=>{
        if ($cb9542f9d166ab64$var$CARD_NODE_NAMES.has(node.type.name) && node.attrs?.url?.includes(originalUrl)) {
            cardMutations.push({
                pos: pos,
                newAttrs: {
                    ...node.attrs,
                    url: node.attrs.url.replace(originalUrl, newUrl)
                }
            });
            return false;
        }
        // Native embed extension nodes store the URL in parameters.url
        if (node.type.name === 'extension' && node.attrs?.parameters?.url?.includes(originalUrl)) {
            extensionMutations.push({
                pos: pos,
                newAttrs: {
                    ...node.attrs,
                    parameters: {
                        ...node.attrs.parameters,
                        url: node.attrs.parameters.url.replace(originalUrl, newUrl)
                    }
                }
            });
            return false;
        }
        // Native embed macro extension nodes store the URL in parameters.macroParams.url.value
        if (node.type.name === 'extension' && node.attrs?.parameters?.macroParams?.url?.value?.includes(originalUrl)) {
            extensionMutations.push({
                pos: pos,
                newAttrs: {
                    ...node.attrs,
                    parameters: {
                        ...node.attrs.parameters,
                        macroParams: {
                            ...node.attrs.parameters.macroParams,
                            url: {
                                ...node.attrs.parameters.macroParams.url,
                                value: node.attrs.parameters.macroParams.url.value.replace(originalUrl, newUrl)
                            }
                        }
                    }
                }
            });
            return false;
        }
        if (node.isText) {
            node.marks?.forEach((mark)=>{
                if (mark.type.name === 'link' && mark.attrs?.href?.includes(originalUrl)) {
                    const newHref = mark.attrs.href.replace(originalUrl, newUrl);
                    const newMark = mark.type.create({
                        ...mark.attrs,
                        href: newHref
                    });
                    linkMarkMutations.push({
                        from: pos,
                        to: pos + node.nodeSize,
                        oldMark: mark,
                        newMark: newMark
                    });
                }
            });
            if (node.text?.includes(originalUrl)) {
                const startIdx = node.text.indexOf(originalUrl);
                textReplaceMutations.push({
                    from: pos + startIdx,
                    to: pos + startIdx + originalUrl.length,
                    newUrl: newUrl
                });
                return false;
            }
        }
        return true;
    });
    // Apply card node mutations in reverse order (setNodeMarkup doesn't change positions)
    for(let i = cardMutations.length - 1; i >= 0; i--){
        const { pos: pos, newAttrs: newAttrs } = cardMutations[i];
        tr.setNodeMarkup(pos, undefined, newAttrs);
    }
    // Apply extension node mutations in reverse order
    for(let i = extensionMutations.length - 1; i >= 0; i--){
        const { pos: pos, newAttrs: newAttrs } = extensionMutations[i];
        tr.setNodeMarkup(pos, undefined, newAttrs);
    }
    // Apply link mark mutations in reverse order (removeMark/addMark don't change positions)
    for(let i = linkMarkMutations.length - 1; i >= 0; i--){
        const { from: from, to: to, oldMark: oldMark, newMark: newMark } = linkMarkMutations[i];
        tr.removeMark(from, to, oldMark);
        tr.addMark(from, to, newMark);
    }
    // Apply text replacements in reverse order (replaceWith can change text length)
    for(let i = textReplaceMutations.length - 1; i >= 0; i--){
        const { from: from, to: to, newUrl: url } = textReplaceMutations[i];
        tr.replaceWith(from, to, tr.doc.type.schema.text(url));
    }
}
/**
 * Searches the editor document for any occurrence of the given URL and
 * removes it. Mirrors the coverage of `updateUrlInDoc`:
 *  - inlineCard / blockCard / embedCard nodes whose `url` includes the URL
 *  - `extension` nodes whose `parameters.url` or
 *    `parameters.macroParams.url.value` includes the URL
 *  - `link` marks whose `href` includes the URL (mark stripped from the range)
 *  - Plain text containing the URL (the matched substring is deleted)
 *
 * All occurrences in the doc are removed. This is intentional — when the
 * user does not have permission to re-parent a Rovo system-space whiteboard,
 * leaving any reference to the URL on the page would orphan it. Per the
 * DACI Option 2A decision we accept removing duplicate occurrences
 * elsewhere in the doc to guarantee the orphaned link is gone.
 *
 * Mutations are collected during traversal and applied in REVERSE document
 * order so earlier positions are not invalidated by later mutations. All
 * mutations land in a SINGLE transaction so undo restores the diagram in
 * one step and collab streams a single coherent change.
 *
 * Returns the number of occurrences removed (sum of all mutation buckets).
 * A return of 0 means the URL was no longer in the doc (e.g. a remote
 * collaborator already removed it, or the user undid the paste) — the
 * caller can treat this as a safe no-op.
 */ function $cb9542f9d166ab64$var$removeUrlFromDoc(tr, url) {
    const nodeDeletions = [];
    const linkMarkRemovals = [];
    const textDeletions = [];
    tr.doc.descendants((node, pos)=>{
        if ($cb9542f9d166ab64$var$CARD_NODE_NAMES.has(node.type.name) && node.attrs?.url?.includes(url)) {
            nodeDeletions.push({
                from: pos,
                to: pos + node.nodeSize
            });
            return false;
        }
        if (node.type.name === 'extension') {
            const flatUrl = node.attrs?.parameters?.url;
            const macroUrl = node.attrs?.parameters?.macroParams?.url?.value;
            if (typeof flatUrl === 'string' && flatUrl.includes(url) || typeof macroUrl === 'string' && macroUrl.includes(url)) {
                nodeDeletions.push({
                    from: pos,
                    to: pos + node.nodeSize
                });
                return false;
            }
        }
        if (node.isText) {
            node.marks?.forEach((mark)=>{
                if (mark.type.name === 'link' && mark.attrs?.href?.includes(url)) linkMarkRemovals.push({
                    from: pos,
                    to: pos + node.nodeSize,
                    mark: mark
                });
            });
            if (node.text?.includes(url)) {
                const startIdx = node.text.indexOf(url);
                textDeletions.push({
                    from: pos + startIdx,
                    to: pos + startIdx + url.length
                });
                // Keep traversing — a text node could contain multiple
                // occurrences but indexOf only finds the first; if needed
                // we'd loop here. For now matching updateUrlInDoc semantics.
                return false;
            }
        }
        return true;
    });
    // Apply mark removals FIRST. removeMark doesn't change any positions,
    // so doing this before any deletions means we don't need to map the
    // captured mark positions through `tr.mapping`.
    for(let i = linkMarkRemovals.length - 1; i >= 0; i--){
        const { from: from, to: to, mark: mark } = linkMarkRemovals[i];
        if (from < to) tr.removeMark(from, to, mark);
    }
    // Merge node and text deletions into a single bucket sorted by `from`,
    // then apply in REVERSE document order. Doing them in one pass —
    // rather than node-deletions-first then text-deletions — means each
    // deletion only affects positions strictly later in the doc, and our
    // reverse traversal already accounts for that. No `tr.mapping` calls
    // needed.
    const allDeletions = [
        ...nodeDeletions,
        ...textDeletions
    ].sort((a, b)=>a.from - b.from);
    for(let i = allDeletions.length - 1; i >= 0; i--){
        const { from: from, to: to } = allDeletions[i];
        if (from < to) tr.delete(from, to);
    }
    return nodeDeletions.length + linkMarkRemovals.length + textDeletions.length;
}
/**
 * Extracts a MAUI app URL from a pasted ProseMirror Slice by inspecting
 * extension nodes for a URL in the macroParams.url.value or parameters.url
 * structure. Returns the URL string if found, or null.
 */ function $cb9542f9d166ab64$var$extractMauiAppUrlFromSlice(slice) {
    if (!slice?.content?.descendants) return null;
    let foundUrl = null;
    slice.content.descendants((node)=>{
        if (foundUrl) return false;
        if (node.type.name === 'extension') {
            const macroUrl = node.attrs?.parameters?.macroParams?.url?.value;
            if (macroUrl && typeof macroUrl === 'string') {
                foundUrl = macroUrl;
                return false;
            }
            const flatUrl = node.attrs?.parameters?.url;
            if (flatUrl && typeof flatUrl === 'string') {
                foundUrl = flatUrl;
                return false;
            }
        }
        return true;
    });
    return foundUrl;
}
/**
 * Kicks off the async move workflow:
 * 1. Resolves the whiteboard's actual space key
 * 2. If the space starts with ~ROVO (Rovo system space), proceeds with the move
 * 3. Otherwise, skips the move (whiteboard is already in a real space)
 *
 * On success, updates the URL in the editor document to replace the space
 * key with the target space key.
 */ function $cb9542f9d166ab64$var$startMoveWorkflow({ view: view, config: config, linkInfo: linkInfo, currentPageId: currentPageId }) {
    const experienceTracker = (0, $bjY3F.ExperienceTrackerHandler).getInstance().experienceTracker;
    const experienceAttributes = {
        contentId: linkInfo.contentId,
        targetPageId: currentPageId,
        conversationChannelId: linkInfo.conversationContext?.conversationId
    };
    if (!config.resolveContentSpaceKey || !config.finalizeAfterMove || !config.targetSpaceKey) return;
    const { resolveContentSpaceKey: resolveContentSpaceKey, finalizeAfterMove: finalizeAfterMove, targetSpaceKey: targetSpaceKey } = config;
    resolveContentSpaceKey(linkInfo.contentId).then((spaceKey)=>{
        if (!spaceKey || !spaceKey.startsWith($cb9542f9d166ab64$var$ROVO_SPACE_PREFIX)) {
            // Not in a Rovo system space — already moved or not a MAUI diagram.
            // Update the URL in the doc if the space was resolved (so re-paste
            // from the same clipboard doesn't trigger another check).
            if (spaceKey) {
                const movedUrl = (0, $5J9kV.buildMovedUrl)(linkInfo.originalUrl, spaceKey);
                const updateTr = view.state.tr;
                $cb9542f9d166ab64$var$updateUrlInDoc(updateTr, linkInfo.originalUrl, movedUrl);
                view.dispatch(updateTr);
            }
            return;
        }
        experienceTracker.start({
            id: (0, $irnO2.ExperienceName).REMIX_DIAGRAM_PASTE_FINALIZE,
            name: (0, $irnO2.ExperienceName).REMIX_DIAGRAM_PASTE_FINALIZE,
            attributes: experienceAttributes
        });
        const startTr = view.state.tr;
        startTr.setMeta($cb9542f9d166ab64$export$acc845c5f0893b92, {
            type: "MOVE_STARTED"
        });
        view.dispatch(startTr);
        // The backend handles BOTH the move (cross-space reparent) and the
        // finalize. We never do a frontend GraphQL move — it would be
        // redundant work and double-trigger any side effects.
        return finalizeAfterMove(linkInfo.contentId, currentPageId, linkInfo.conversationContext).then(()=>{
            const movedUrl = (0, $5J9kV.buildMovedUrl)(linkInfo.originalUrl, targetSpaceKey);
            const successTr = view.state.tr;
            $cb9542f9d166ab64$var$updateUrlInDoc(successTr, linkInfo.originalUrl, movedUrl);
            successTr.setMeta($cb9542f9d166ab64$export$acc845c5f0893b92, {
                type: "MOVE_SUCCEEDED"
            });
            view.dispatch(successTr);
            config.fireAnalyticsEvent?.({
                action: 'moved',
                actionSubject: 'mauiDiagram',
                actionSubjectId: 'move',
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    contentId: linkInfo.contentId,
                    targetPageId: currentPageId
                }
            });
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).REMIX_DIAGRAM_PASTE_FINALIZE,
                attributes: experienceAttributes
            });
        }).catch((error)=>{
            if (config.isFinalizePermissionError?.(error)) // The user lacks space-create permission and was informed via an
            // error flag (dispatched by the outer .catch). The UX flow went as
            // expected, so succeed the experience with a denoting attribute.
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).REMIX_DIAGRAM_PASTE_FINALIZE,
                attributes: {
                    ...experienceAttributes,
                    isPermissionError: true
                }
            });
            else experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).REMIX_DIAGRAM_PASTE_FINALIZE,
                error: error,
                attributes: experienceAttributes
            });
            // Re-throw so the outer .catch still handles UI cleanup.
            throw error;
        });
    }).catch((error)=>{
        const failTr = view.state.tr;
        // When the removal feature is on, also strip the pasted reference
        // from the doc so the user isn't left with an orphaned link in a
        // temporary Rovo space. This is the original DACI Option 2A
        // intent — applied here for finalize failures (covers BOTH the
        // monolith path and the convo-ai path, since `finalizeAfterMove`
        // is the single funnel for both).
        //
        // Gated behind the same kill switch as the pre-flight permission
        // removal so the two paths share one rollback. When the kill
        // switch is ON the behaviour reverts to flag only, no removal.
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- Pre-existing kill switch shipped via Statsig experiment-as-flag (the team owning this gate uses experiments for fast rollback). Migration to a boolean feature gate is tracked separately and is not part of MAUI-556.
        const killSwitchOn = (0, $cXtTj.default).getExperimentValue('confluence_maui_remove_diagram_on_paste_fail', 'value', false);
        let occurrencesRemoved = 0;
        if (!killSwitchOn) occurrencesRemoved = $cb9542f9d166ab64$var$removeUrlFromDoc(failTr, linkInfo.originalUrl);
        config.fireAnalyticsEvent?.({
            action: (0, $krYZG.ACTION).ERROR,
            actionSubject: 'mauiDiagram',
            actionSubjectId: 'move',
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                contentId: linkInfo.contentId,
                targetPageId: currentPageId,
                errorMessage: error?.message,
                errorStack: error?.stack,
                occurrencesRemoved: occurrencesRemoved
            }
        });
        failTr.setMeta($cb9542f9d166ab64$export$acc845c5f0893b92, {
            type: "MOVE_FAILED",
            useLegacyCopy: killSwitchOn
        });
        // addToHistory defaults to true; setting explicitly so undo
        // restores the diagram in a single step alongside the flag.
        failTr.setMeta('addToHistory', true);
        view.dispatch(failTr);
    });
}
/**
 * Async duplicate workflow for MAUI app links: duplicates the app, then rewrites matching URLs in the doc.
 * Permission errors surface the BE's human-readable message verbatim; other failures use fallback copy.
 */ function $cb9542f9d166ab64$var$startDuplicateWorkflow({ view: view, config: config, linkInfo: linkInfo, currentPageId: currentPageId, getIntl: getIntl }) {
    const duplicateMauiApp = config.duplicateMauiApp;
    if (!duplicateMauiApp) return;
    const experienceTracker = $cb9542f9d166ab64$var$getMauiExperienceTracker();
    const experienceAttributes = {
        appId: linkInfo.appId,
        currentPageId: currentPageId,
        source: 'mauiDiagramPastePlugin'
    };
    experienceTracker.start({
        name: (0, $irnO2.ExperienceName).REMIX_DUPLICATE_APP,
        id: (0, $irnO2.ExperienceName).REMIX_DUPLICATE_APP,
        attributes: experienceAttributes
    });
    const startTr = view.state.tr;
    startTr.setMeta($cb9542f9d166ab64$export$acc845c5f0893b92, {
        type: "DUPLICATE_STARTED"
    });
    view.dispatch(startTr);
    const currentContentType = config.getCurrentContentType?.();
    Promise.resolve().then(()=>duplicateMauiApp(linkInfo.appId, currentPageId, currentContentType)).then(({ id: newAppId, attempts: attempts, statusCode: statusCode })=>{
        const wasNoOp = newAppId === linkInfo.appId;
        try {
            const successTr = view.state.tr;
            if (!wasNoOp) {
                const duplicatedUrl = (0, $5J9kV.buildDuplicatedMauiAppUrl)(linkInfo.originalUrl, newAppId);
                $cb9542f9d166ab64$var$updateUrlInDoc(successTr, linkInfo.originalUrl, duplicatedUrl);
            }
            successTr.setMeta($cb9542f9d166ab64$export$acc845c5f0893b92, {
                type: "DUPLICATE_SUCCEEDED"
            });
            view.dispatch(successTr);
        } catch (renderError) {
            const error = renderError instanceof Error ? renderError : new Error($cb9542f9d166ab64$var$DUPLICATE_FALLBACK_ERROR_MESSAGE);
            const failTr = view.state.tr;
            failTr.setMeta($cb9542f9d166ab64$export$acc845c5f0893b92, {
                type: "DUPLICATE_FAILED",
                errorMessage: renderError instanceof Error ? error.message : $cb9542f9d166ab64$var$formatFlagMessage(getIntl, (0, $lhZdS.messages).mauiAppDuplicateErrorDescription),
                // `/duplicate` already succeeded; this catch only handles editor render/update errors.
                isPermissionError: false
            });
            view.dispatch(failTr);
            config.fireAnalyticsEvent?.({
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                actionSubject: 'mauiAppDuplicate',
                actionSubjectId: 'mauiPaste',
                action: 'failed',
                attributes: {
                    originalId: linkInfo.appId,
                    newId: newAppId,
                    attempts: attempts,
                    statusCode: statusCode,
                    wasNoOp: wasNoOp,
                    errorMessage: error.message,
                    isPermissionError: false,
                    renderError: true
                }
            });
            $cb9542f9d166ab64$var$failRemixDuplicateAppAndInsert(error, {
                ...experienceAttributes,
                newAppId: newAppId,
                attempts: attempts,
                statusCode: statusCode,
                wasNoOp: wasNoOp
            });
            return;
        }
        config.fireAnalyticsEvent?.({
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            actionSubject: 'mauiAppDuplicate',
            actionSubjectId: 'mauiPaste',
            action: 'succeeded',
            attributes: {
                originalId: linkInfo.appId,
                newId: newAppId,
                attempts: attempts,
                statusCode: statusCode,
                wasNoOp: wasNoOp
            }
        });
        experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).REMIX_DUPLICATE_APP,
            attributes: {
                ...experienceAttributes,
                newAppId: newAppId,
                attempts: attempts,
                statusCode: statusCode,
                wasNoOp: wasNoOp
            }
        });
    }).catch((error)=>{
        const fallbackErrorMessage = $cb9542f9d166ab64$var$formatFlagMessage(getIntl, (0, $lhZdS.messages).mauiAppDuplicateErrorDescription);
        const statusCode = error?.statusCode;
        const errorCode = error?.code;
        const attempts = error?.attempts;
        const isPermissionError = statusCode === 403;
        const errorForExperience = error instanceof Error ? error : new Error($cb9542f9d166ab64$var$DUPLICATE_FALLBACK_ERROR_MESSAGE);
        const failTr = view.state.tr;
        failTr.setMeta($cb9542f9d166ab64$export$acc845c5f0893b92, {
            type: "DUPLICATE_FAILED",
            errorMessage: error?.message || fallbackErrorMessage,
            isPermissionError: isPermissionError
        });
        view.dispatch(failTr);
        config.fireAnalyticsEvent?.({
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            actionSubject: 'mauiAppDuplicate',
            actionSubjectId: 'mauiPaste',
            action: 'failed',
            attributes: {
                originalId: linkInfo.appId,
                errorMessage: error?.message,
                isPermissionError: isPermissionError,
                statusCode: statusCode,
                errorCode: errorCode,
                attempts: attempts
            }
        });
        $cb9542f9d166ab64$var$failRemixDuplicateAppAndInsert(errorForExperience, {
            ...experienceAttributes,
            statusCode: statusCode,
            errorCode: errorCode,
            isPermissionError: isPermissionError,
            attempts: attempts
        });
    });
}
function $cb9542f9d166ab64$var$runEmbedFinalizeWorkflow({ view: view, config: config, args: args, currentPageId: currentPageId, getIntl: getIntl }) {
    const { contentId: contentId, originalUrl: originalUrl, conversationContext: conversationContext, mode: mode = 'finalize', targetSpace: targetSpace } = args;
    const dispatchStatus = (status, extra)=>{
        const tr = view.state.tr;
        tr.setMeta($cb9542f9d166ab64$export$acc845c5f0893b92, {
            type: "EMBED_FINALIZE_STATUS_CHANGED",
            contentId: contentId,
            originalUrl: originalUrl,
            status: status,
            errorMessage: extra?.errorMessage,
            flag: extra?.flag
        });
        view.dispatch(tr);
    };
    if (!config.resolveContentSpaceKey || !config.finalizeAfterMove || !config.targetSpaceKey) {
        dispatchStatus("NOT_NEEDED");
        return Promise.resolve();
    }
    const { resolveContentSpaceKey: resolveContentSpaceKey, finalizeAfterMove: finalizeAfterMove, targetSpaceKey: targetSpaceKey } = config;
    dispatchStatus("CHECKING");
    return resolveContentSpaceKey(contentId).then(async (spaceKey)=>{
        if (!spaceKey || !spaceKey.startsWith($cb9542f9d166ab64$var$ROVO_SPACE_PREFIX)) {
            if (spaceKey && mode !== 'probe') {
                const movedUrl = (0, $5J9kV.buildMovedUrl)(originalUrl, spaceKey);
                if (movedUrl !== originalUrl) {
                    const updateTr = view.state.tr;
                    $cb9542f9d166ab64$var$updateUrlInDoc(updateTr, originalUrl, movedUrl);
                    view.dispatch(updateTr);
                }
            }
            dispatchStatus("NOT_NEEDED");
            return;
        }
        // Probe mode: surface that finalisation is needed but do NOT
        // kick off the actual save. The user-facing banner triggers
        // `mode: 'finalize'` separately when the action button is
        // clicked.
        if (mode === 'probe') {
            dispatchStatus("NEEDS_FINALIZE");
            return;
        }
        // Skip the probe when the user already picked a destination
        // from the picker (which only offers spaces they can write to).
        const siteId = config.finalizeLocation?.siteId;
        if (!targetSpace && siteId && // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- dynamic config killswitch, not a standard feature gate
        !(0, $cXtTj.default).getExperimentValue('maui-native-embed-finalize-diagram-anywhere', 'value', false)) {
            const allowed = await (0, $k6l1W.canCreatePageInSpace)(siteId, targetSpaceKey);
            if (!allowed) {
                dispatchStatus("NEEDS_SPACE_SELECTION", {
                    flag: {
                        id: `maui-embed-finalize-space-picker-${contentId}`,
                        type: "info",
                        title: $cb9542f9d166ab64$var$formatFlagMessage(getIntl, (0, $lhZdS.messages).flagFinalizeSpacePickerTitle),
                        description: $cb9542f9d166ab64$var$formatFlagMessage(getIntl, (0, $lhZdS.messages).flagFinalizeSpacePickerDescription)
                    }
                });
                $cb9542f9d166ab64$export$256d1471cb5e2656(view, {
                    contentId: contentId
                });
                return;
            }
        }
        dispatchStatus("FINALIZING");
        // When the user picked a different target space, the parent
        // MUST live in that space — falling back to `currentPageId`
        // would point at a page in the original (Rovo system) space.
        const parentPageId = targetSpace?.parentId ?? currentPageId;
        return finalizeAfterMove(contentId, parentPageId, conversationContext, targetSpace).then(()=>{
            const movedUrl = (0, $5J9kV.buildMovedUrl)(originalUrl, targetSpace?.key ?? targetSpaceKey);
            const successTr = view.state.tr;
            $cb9542f9d166ab64$var$updateUrlInDoc(successTr, originalUrl, movedUrl);
            successTr.setMeta($cb9542f9d166ab64$export$acc845c5f0893b92, {
                type: "EMBED_FINALIZE_STATUS_CHANGED",
                contentId: contentId,
                status: "FINALIZED",
                flag: {
                    id: `maui-embed-finalize-success-${contentId}`,
                    type: "success",
                    title: $cb9542f9d166ab64$var$formatFlagMessage(getIntl, (0, $lhZdS.messages).flagFinalizeSuccessTitle),
                    description: targetSpace ? $cb9542f9d166ab64$var$formatFlagMessage(getIntl, (0, $lhZdS.messages).flagFinalizeSuccessDescriptionPickedSpace) : $cb9542f9d166ab64$var$formatFlagMessage(getIntl, (0, $lhZdS.messages).flagFinalizeSuccessDescriptionCurrentPage)
                }
            });
            view.dispatch(successTr);
            config.fireAnalyticsEvent?.({
                action: 'finalized',
                actionSubject: 'mauiDiagram',
                actionSubjectId: 'embedFinalize',
                eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    contentId: contentId,
                    targetPageId: currentPageId
                }
            });
        });
    }).catch((error)=>{
        config.fireAnalyticsEvent?.({
            action: (0, $krYZG.ACTION).ERROR,
            actionSubject: 'mauiDiagram',
            actionSubjectId: 'embedFinalize',
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                contentId: contentId,
                targetPageId: currentPageId,
                errorMessage: error?.message,
                errorStack: error?.stack
            }
        });
        dispatchStatus("FAILED", {
            errorMessage: error?.message,
            flag: {
                id: `maui-embed-finalize-error-${contentId}`,
                type: "error",
                title: $cb9542f9d166ab64$var$formatFlagMessage(getIntl, (0, $lhZdS.messages).mauiDiagramFinalizeErrorTitle),
                description: $cb9542f9d166ab64$var$formatFlagMessage(getIntl, (0, $lhZdS.messages).mauiDiagramFinalizeErrorDescription)
            }
        });
    });
}
function $cb9542f9d166ab64$var$runTargetSpaceEmbedFinalizeWorkflow({ view: view, config: config, args: args, getIntl: getIntl }) {
    const { contentId: contentId, conversationContext: conversationContext, originalUrl: originalUrl, targetSpace: targetSpace } = args;
    const dispatchStatus = (status, extra)=>{
        const tr = view.state.tr;
        tr.setMeta($cb9542f9d166ab64$export$acc845c5f0893b92, {
            type: "EMBED_FINALIZE_STATUS_CHANGED",
            contentId: contentId,
            originalUrl: originalUrl,
            status: status,
            errorMessage: extra?.errorMessage,
            flag: extra?.flag
        });
        view.dispatch(tr);
    };
    // No permission probe is needed on the picked-location path (the user has
    // explicitly chosen a writable space), so go straight to FINALIZING below
    // rather than passing through CHECKING.
    if (!config.finalizeAfterMove) {
        const errorMessage = $cb9542f9d166ab64$var$formatFlagMessage(getIntl, (0, $lhZdS.messages).mauiDiagramFinalizeErrorDescription);
        dispatchStatus("FAILED", {
            errorMessage: errorMessage,
            flag: {
                id: `maui-embed-finalize-error-${contentId}`,
                type: "error",
                title: $cb9542f9d166ab64$var$formatFlagMessage(getIntl, (0, $lhZdS.messages).mauiDiagramFinalizeErrorTitle),
                description: errorMessage
            }
        });
        return Promise.resolve();
    }
    dispatchStatus("FINALIZING");
    return config.finalizeAfterMove(contentId, targetSpace.parentId, conversationContext, targetSpace).then(()=>{
        const movedUrl = (0, $5J9kV.buildMovedUrl)(originalUrl, targetSpace.key);
        const successTr = view.state.tr;
        $cb9542f9d166ab64$var$updateUrlInDoc(successTr, originalUrl, movedUrl);
        successTr.setMeta($cb9542f9d166ab64$export$acc845c5f0893b92, {
            type: "EMBED_FINALIZE_STATUS_CHANGED",
            contentId: contentId,
            status: "FINALIZED",
            flag: {
                id: `maui-embed-finalize-success-${contentId}`,
                type: "success",
                title: $cb9542f9d166ab64$var$formatFlagMessage(getIntl, (0, $lhZdS.messages).flagFinalizeSuccessTitle),
                description: $cb9542f9d166ab64$var$formatFlagMessage(getIntl, (0, $lhZdS.messages).flagFinalizeSuccessDescriptionPickedSpace)
            }
        });
        view.dispatch(successTr);
        config.fireAnalyticsEvent?.({
            action: 'finalized',
            actionSubject: 'mauiDiagram',
            actionSubjectId: 'embedFinalize',
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                contentId: contentId,
                targetPageId: targetSpace.parentId,
                targetSpaceId: targetSpace.id
            }
        });
    }).catch((error)=>{
        config.fireAnalyticsEvent?.({
            action: (0, $krYZG.ACTION).ERROR,
            actionSubject: 'mauiDiagram',
            actionSubjectId: 'embedFinalize',
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                contentId: contentId,
                targetPageId: targetSpace.parentId,
                targetSpaceId: targetSpace.id,
                errorMessage: error?.message,
                errorStack: error?.stack
            }
        });
        dispatchStatus("FAILED", {
            errorMessage: error?.message,
            flag: {
                id: `maui-embed-finalize-error-${contentId}`,
                type: "error",
                title: $cb9542f9d166ab64$var$formatFlagMessage(getIntl, (0, $lhZdS.messages).mauiDiagramFinalizeErrorTitle),
                description: $cb9542f9d166ab64$var$formatFlagMessage(getIntl, (0, $lhZdS.messages).mauiDiagramFinalizeErrorDescription)
            }
        });
    });
}
function $cb9542f9d166ab64$export$461315a798e4bb7e(view, config, args) {
    if (args.targetSpace && // eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- dynamic config killswitch, not a standard feature gate
    (0, $cXtTj.default).getExperimentValue('maui-native-embed-finalize-diagram-anywhere', 'value', false)) return Promise.resolve();
    const getIntl = $cb9542f9d166ab64$var$knownViewIntlGetters.get(view) ?? $cb9542f9d166ab64$var$fallbackGetIntl;
    if (args.targetSpace) return $cb9542f9d166ab64$var$runTargetSpaceEmbedFinalizeWorkflow({
        view: view,
        config: config,
        args: {
            ...args,
            targetSpace: args.targetSpace
        },
        getIntl: getIntl
    });
    const currentPageId = config.getCurrentPageId?.();
    if (!currentPageId) {
        const errorMessage = $cb9542f9d166ab64$var$formatFlagMessage(getIntl, (0, $lhZdS.messages).mauiDiagramFinalizeMissingPageDescription);
        const tr = view.state.tr;
        tr.setMeta($cb9542f9d166ab64$export$acc845c5f0893b92, {
            type: "EMBED_FINALIZE_STATUS_CHANGED",
            contentId: args.contentId,
            status: "FAILED",
            errorMessage: errorMessage,
            flag: {
                id: `maui-embed-finalize-error-${args.contentId}`,
                type: "error",
                title: $cb9542f9d166ab64$var$formatFlagMessage(getIntl, (0, $lhZdS.messages).mauiDiagramFinalizeErrorTitle),
                description: errorMessage
            }
        });
        view.dispatch(tr);
        return Promise.resolve();
    }
    return $cb9542f9d166ab64$var$runEmbedFinalizeWorkflow({
        view: view,
        config: config,
        args: args,
        currentPageId: currentPageId,
        getIntl: getIntl
    });
}
function $cb9542f9d166ab64$export$bc0fa4a2016df3f9(view, contentId, status) {
    if (!contentId) return;
    const tr = view.state.tr;
    tr.setMeta($cb9542f9d166ab64$export$acc845c5f0893b92, {
        type: "EMBED_FINALIZE_STATUS_CHANGED",
        contentId: contentId,
        status: status
    });
    view.dispatch(tr);
}
function $cb9542f9d166ab64$export$972cac6148b6343e(view, args) {
    if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- dynamic config killswitch, not a standard feature gate
    (0, $cXtTj.default).getExperimentValue('maui-native-embed-finalize-diagram-anywhere', 'value', false)) return;
    const tr = view.state.tr;
    tr.setMeta($cb9542f9d166ab64$export$acc845c5f0893b92, {
        type: "EMBED_FINALIZE_RESET",
        contentId: args.contentId
    });
    view.dispatch(tr);
}
function $cb9542f9d166ab64$export$256d1471cb5e2656(view, args) {
    if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- dynamic config killswitch, not a standard feature gate
    (0, $cXtTj.default).getExperimentValue('maui-native-embed-finalize-diagram-anywhere', 'value', false)) return;
    const tr = view.state.tr;
    tr.setMeta($cb9542f9d166ab64$export$acc845c5f0893b92, {
        type: "EMBED_FINALIZE_OPEN_PICKER",
        contentId: args.contentId
    });
    view.dispatch(tr);
}
function $cb9542f9d166ab64$export$e89cce805044cad8(view, args) {
    if (// eslint-disable-next-line @atlaskit/platform/use-recommended-utils -- dynamic config killswitch, not a standard feature gate
    (0, $cXtTj.default).getExperimentValue('maui-native-embed-finalize-diagram-anywhere', 'value', false)) return;
    const tr = view.state.tr;
    tr.setMeta($cb9542f9d166ab64$export$acc845c5f0893b92, {
        type: "EMBED_FINALIZE_CLOSE_PICKER",
        contentId: args.contentId
    });
    view.dispatch(tr);
}
function $cb9542f9d166ab64$export$e46b072e8cabda89(dispatch, config, getIntl = $cb9542f9d166ab64$var$fallbackGetIntl) {
    // Pending moves are tracked outside plugin state to avoid dispatching
    // transactions that would interfere with the card plugin's async
    // URL-to-embedCard resolution (which checks document structure via
    // isFreshlyPastedOnNewLine).
    let pendingMoveTimer = null;
    return new (0, $kpCD8.SafePlugin)({
        key: $cb9542f9d166ab64$export$acc845c5f0893b92,
        state: {
            init: ()=>$cb9542f9d166ab64$var$initialState,
            apply (tr, pluginState) {
                const meta = tr.getMeta($cb9542f9d166ab64$export$acc845c5f0893b92);
                if (!meta) return pluginState;
                let nextState;
                switch(meta.type){
                    case "MOVE_STARTED":
                    case "DUPLICATE_STARTED":
                        nextState = {
                            ...pluginState,
                            isMoving: true,
                            activeFlag: null
                        };
                        break;
                    case "MOVE_SUCCEEDED":
                    case "DUPLICATE_SUCCEEDED":
                        nextState = {
                            ...pluginState,
                            isMoving: false,
                            activeFlag: null
                        };
                        break;
                    case "MOVE_FAILED":
                        // NOTE: copy is intentionally a generic placeholder —
                        // the real BE error messages are not user-friendly and
                        // are still captured in the analytics event for ops.
                        // When the kill switch is ON we surface the pre-PR move-error
                        // copy so rollback is faithful (no removal AND no new copy).
                        nextState = {
                            ...pluginState,
                            isMoving: false,
                            activeFlag: meta.useLegacyCopy ? {
                                id: 'maui-diagram-move-error',
                                type: "error",
                                title: $cb9542f9d166ab64$var$formatFlagMessage(getIntl, (0, $lhZdS.messages).mauiDiagramMoveErrorTitle),
                                description: $cb9542f9d166ab64$var$formatFlagMessage(getIntl, (0, $lhZdS.messages).mauiDiagramMoveErrorDescription)
                            } : {
                                id: 'maui-diagram-paste-error',
                                type: "error",
                                title: $cb9542f9d166ab64$var$formatFlagMessage(getIntl, (0, $lhZdS.messages).mauiDiagramPasteErrorTitle),
                                description: $cb9542f9d166ab64$var$formatFlagMessage(getIntl, (0, $lhZdS.messages).mauiDiagramPasteErrorDescription)
                            }
                        };
                        break;
                    case "DUPLICATE_FAILED":
                        nextState = {
                            ...pluginState,
                            isMoving: false,
                            activeFlag: {
                                id: 'maui-app-duplicate-error',
                                type: "error",
                                title: meta.isPermissionError ? $cb9542f9d166ab64$var$formatFlagMessage(getIntl, (0, $lhZdS.messages).mauiAppDuplicatePermissionErrorTitle) : $cb9542f9d166ab64$var$formatFlagMessage(getIntl, (0, $lhZdS.messages).mauiAppDuplicateErrorTitle),
                                description: meta.errorMessage || $cb9542f9d166ab64$var$formatFlagMessage(getIntl, (0, $lhZdS.messages).mauiAppDuplicateErrorDescription)
                            }
                        };
                        break;
                    case "DISMISS_FLAG":
                        nextState = {
                            ...pluginState,
                            activeFlag: null
                        };
                        break;
                    case "EMBED_FINALIZE_RESET":
                        {
                            const contentId = typeof meta.contentId === 'string' ? meta.contentId : null;
                            if (!contentId || !(contentId in pluginState.embedFinalizeStates)) return pluginState;
                            const { [contentId]: _removed, ...rest } = pluginState.embedFinalizeStates;
                            const activeFlagId = pluginState.activeFlag?.id;
                            const isStaleFlagForEntry = activeFlagId === `maui-embed-finalize-error-${contentId}` || activeFlagId === `maui-embed-finalize-success-${contentId}`;
                            nextState = {
                                ...pluginState,
                                embedFinalizeStates: rest,
                                activeFlag: isStaleFlagForEntry ? null : pluginState.activeFlag
                            };
                            break;
                        }
                    case "EMBED_FINALIZE_OPEN_PICKER":
                        {
                            const contentId = typeof meta.contentId === 'string' ? meta.contentId : null;
                            const entry = contentId ? pluginState.embedFinalizeStates[contentId] : null;
                            if (!contentId || !entry || entry.status !== "NEEDS_SPACE_SELECTION") return pluginState;
                            nextState = {
                                ...pluginState,
                                embedFinalizeStates: {
                                    ...pluginState.embedFinalizeStates,
                                    [contentId]: {
                                        ...entry,
                                        pickerOpen: true
                                    }
                                }
                            };
                            break;
                        }
                    case "EMBED_FINALIZE_CLOSE_PICKER":
                        {
                            const contentId = typeof meta.contentId === 'string' ? meta.contentId : null;
                            const entry = contentId ? pluginState.embedFinalizeStates[contentId] : null;
                            if (!contentId || !entry || !entry.pickerOpen) return pluginState;
                            nextState = {
                                ...pluginState,
                                embedFinalizeStates: {
                                    ...pluginState.embedFinalizeStates,
                                    [contentId]: {
                                        ...entry,
                                        pickerOpen: false
                                    }
                                }
                            };
                            break;
                        }
                    case "EMBED_FINALIZE_STATUS_CHANGED":
                        {
                            const contentId = typeof meta.contentId === 'string' ? meta.contentId : null;
                            if (!contentId) return pluginState;
                            const nextEntry = {
                                status: meta.status,
                                errorMessage: meta.errorMessage,
                                originalUrl: meta.originalUrl
                            };
                            const existingEntry = pluginState.embedFinalizeStates[contentId];
                            // Reference-equality short-circuit so unrelated transactions don't
                            // trigger downstream re-renders for indicators not affected by
                            // this change.
                            if (existingEntry && existingEntry.status === nextEntry.status && existingEntry.errorMessage === nextEntry.errorMessage && existingEntry.originalUrl === nextEntry.originalUrl) return pluginState;
                            nextState = {
                                ...pluginState,
                                embedFinalizeStates: {
                                    ...pluginState.embedFinalizeStates,
                                    [contentId]: nextEntry
                                },
                                activeFlag: meta.flag === undefined ? pluginState.activeFlag : meta.flag ?? null
                            };
                            break;
                        }
                    default:
                        return pluginState;
                }
                dispatch($cb9542f9d166ab64$export$acc845c5f0893b92, nextState);
                return nextState;
            }
        },
        view (view) {
            // Track this view for the duration of its lifetime so async,
            // view-spanning workflows (e.g. the in-embed finalize action
            // triggered from the malleableUi plugin's `actions` surface)
            // can resolve the correct EditorView to dispatch against —
            // even when multiple editors are concurrently alive.
            $cb9542f9d166ab64$var$knownViews.add(view);
            $cb9542f9d166ab64$var$knownViewIntlGetters.set(view, getIntl);
            return {
                destroy () {
                    $cb9542f9d166ab64$var$knownViews.delete(view);
                    $cb9542f9d166ab64$var$knownViewIntlGetters.delete(view);
                }
            };
        },
        props: {
            handlePaste (view, event, slice) {
                const { clipboardData: clipboardData } = event;
                if (!clipboardData) return false;
                const url = (0, $5J9kV.extractPastedUrl)(clipboardData);
                const diagramLinkInfo = url ? (0, $5J9kV.parseMauiDiagramLink)(url) : null;
                let appLinkInfo = url && !diagramLinkInfo ? (0, $5J9kV.parseMauiAppLink)(url) : null;
                // If no MAUI link was found in the plain text, check the pasted
                // Slice for extension nodes containing a MAUI app URL (e.g. when
                // a native embed extension is copy-pasted from another page).
                if (!diagramLinkInfo && !appLinkInfo) {
                    const sliceUrl = $cb9542f9d166ab64$var$extractMauiAppUrlFromSlice(slice);
                    if (sliceUrl) appLinkInfo = (0, $5J9kV.parseMauiAppLink)(sliceUrl);
                }
                if (!diagramLinkInfo && !appLinkInfo) return false;
                const currentPageId = config.getCurrentPageId?.();
                // For the move workflow, currentPageId is required. For the
                // duplicate-only workflow (e.g. Jira), the container is resolved
                // inside duplicateMauiApp itself so we can skip this guard.
                // The fg gate ensures this relaxed behaviour only activates once the
                // Jira integration is fully launched.
                if (!currentPageId && (diagramLinkInfo || !appLinkInfo || !(0, $ixfCV.fg)('platform_editor_maui_jira_updates'))) {
                    // Dispatch the error on the next tick so it doesn't
                    // interfere with the paste transaction pipeline
                    const errorAction = diagramLinkInfo ? "MOVE_FAILED" : "DUPLICATE_FAILED";
                    const errorMessage = $cb9542f9d166ab64$var$formatFlagMessage(getIntl, (0, $lhZdS.messages).mauiDiagramFinalizeMissingPageDescription);
                    setTimeout(()=>{
                        const tr = view.state.tr;
                        tr.setMeta($cb9542f9d166ab64$export$acc845c5f0893b92, {
                            type: errorAction,
                            errorMessage: errorMessage
                        });
                        view.dispatch(tr);
                    }, 0);
                    // Start + immediately fail the experience so SLOs pick it up.
                    if (appLinkInfo && !diagramLinkInfo && config.duplicateMauiApp) {
                        const experienceTracker = $cb9542f9d166ab64$var$getMauiExperienceTracker();
                        const experienceAttributes = {
                            appId: appLinkInfo.appId,
                            currentPageId: undefined,
                            source: 'mauiDiagramPastePlugin',
                            reason: 'missingCurrentPageId'
                        };
                        experienceTracker.start({
                            name: (0, $irnO2.ExperienceName).REMIX_DUPLICATE_APP,
                            id: (0, $irnO2.ExperienceName).REMIX_DUPLICATE_APP,
                            attributes: experienceAttributes
                        });
                        $cb9542f9d166ab64$var$failRemixDuplicateAppAndInsert(new Error('Missing current page ID for MAUI paste workflow.'), experienceAttributes);
                    }
                    return false;
                }
                if ((0, $cXtTj.default).getExperimentValue('remix_maui_duplicate_stability_improvement', 'value', false) && appLinkInfo && currentPageId && $cb9542f9d166ab64$var$docContainsUrl(view.state.doc, appLinkInfo.originalUrl)) return false;
                // Clear any previously scheduled move — if the user pastes
                // back-to-back, only the latest paste triggers a move
                if (pendingMoveTimer !== null) clearTimeout(pendingMoveTimer);
                // Blogs can't parent whiteboard content, so skip move/finalize.
                // Paste inserts the native embed as-is. User can then finalize
                // it to their specified location from native embed UI.
                const isBlog = config.getCurrentContentType?.() === 'blogpost';
                // Schedule the workflow after a delay to avoid dispatching
                // transactions during the card plugin's async URL → embedCard
                // resolution window. The card plugin's isFreshlyPastedOnNewLine
                // check is sensitive to document/selection state changes.
                pendingMoveTimer = setTimeout(()=>{
                    pendingMoveTimer = null;
                    if (diagramLinkInfo) {
                        if (isBlog) return;
                        $cb9542f9d166ab64$var$startMoveWorkflow({
                            view: view,
                            config: config,
                            linkInfo: diagramLinkInfo,
                            currentPageId: currentPageId ?? ''
                        });
                    } else if (appLinkInfo) $cb9542f9d166ab64$var$startDuplicateWorkflow({
                        view: view,
                        config: config,
                        linkInfo: appLinkInfo,
                        currentPageId: currentPageId ?? '',
                        getIntl: getIntl
                    });
                }, 0);
                // Return false — let the default paste pipeline handle insertion
                // so the URL is auto-converted to a smart link as normal
                return false;
            }
        }
    });
}
module.exports["MauiDiagramPasteFlagType"] = $cb9542f9d166ab64$export$61cfd1372c207927;
module.exports["MauiEmbedFinalizeStatus"] = $cb9542f9d166ab64$export$98d47fb2fca5e93;
module.exports["ActionType"] = $cb9542f9d166ab64$export$e4a712fff93fb00f;
module.exports["mauiDiagramPastePluginKey"] = $cb9542f9d166ab64$export$acc845c5f0893b92;
module.exports["getMauiDiagramPasteView"] = $cb9542f9d166ab64$export$6f4f362dd066ad09;
module.exports["executeMauiEmbedFinalize"] = $cb9542f9d166ab64$export$461315a798e4bb7e;
module.exports["createMauiDiagramPastePmPlugin"] = $cb9542f9d166ab64$export$e46b072e8cabda89;

});

parcelRegister("irnO2", function(module, exports) {

var $4MiWC = parcelRequire("4MiWC");

var $cNAch = parcelRequire("cNAch");

const $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1 = {
    LOAD_PANEL: 'aiMateLoadPanel',
    LOAD_PANEL_COMPOSABLE_EDITOR: 'aiMateLoadPanelComposableEditor',
    LOAD_INLINE_EDITOR: 'aiMateLoadInlineComposableEditor',
    LOAD_BROWSE_AGENTS: 'aiMateLoadBrowseAgents',
    LOAD_CREATE_AGENT: 'aiMateLoadCreateAgent',
    LOAD_AUTO_SUGGEST_SKILLS_LEGACY: 'aiMateAutoSuggestSkillsLegacy',
    LOAD_AUTO_SUGGEST_SKILLS_UNIFIED: 'aiMateAutoSuggestSkillsUnified',
    LOAD_CHAT_PROMPT_INPUT_SKILLS: 'aiMateChatPromptInputSkillsLoad',
    LOAD_INLINE_CHAT_PROMPT_INPUT_SKILLS: 'aiMateInlineChatPromptInputSkillsLoad',
    FETCH_CHAT: 'aiMateFetchChat',
    PREFETCH_CHAT: 'aiMatePrefetchChat',
    FETCH_AGENTS: 'aiMateFetchAgents',
    FETCH_AGENTS_PAGINATED: 'aiMateFetchAgentsPaginated',
    FETCH_AGENTS_OVERRIDES: 'aiMateFetchAgentsOverrides',
    FETCH_AGENT_BY_AGENT_ID: 'aiMateFetchAgentByAgentId',
    FETCH_SCENARIO_LIST: 'aiMateFetchScenarioList',
    FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID: 'aiMateFetchAgentByIdentityAccountId',
    FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE: 'aiMateFetchAgentByExternalConfigReference',
    FETCH_AGENT_DEBUG_MODAL_DATA: 'aiMateFetchAgentDebugModalData',
    FETCH_AGENT_DEBUG_MODAL_CONVERSATION_REVIEW: 'aiMateFetchAgentDebugModalDataConversationReview',
    CREATE_AGENT: 'aiMateCreateAgent',
    UPDATE_AGENT: 'aiMateUpdateAgent',
    DELETE_AGENT: 'aiMateDeleteAgent',
    DUPLICATE_AGENT: 'aiMateDuplicateAgent',
    HYDRATE_AGENT_DATA: 'aiMateHydrateAgentData',
    HYDRATE_SKILL_METADATA: 'aiMateHydrateSkillMetadata',
    FAVOURITE_AGENT: 'aiMateFavouriteAgent',
    UNFAVOURITE_AGENT: 'aiMateUnfavouriteAgent',
    CLEAR_CHAT: 'aiMateClearChat',
    SEND_MESSAGE: 'aiMateSendMessage',
    SEND_MESSAGE_ROVO_CUSTOM_AGENT: 'aiMateSendMessageRovoCustomAgent',
    SEND_DR_MESSAGE: 'aiMateSendDRMessage',
    SEND_TD_MESSAGE: 'aiMateSendThinkDeeperMessage',
    SEND_TASK_MODE_MESSAGE: 'aiMateSendTaskModeMessage',
    SEND_CONFIRMED_TOOLS_MESSAGE: 'aiMateSendConfirmedToolsMessage',
    SEND_CONFIRMED_TOOLS_TASK_MODE_MESSAGE: 'aiMateSendConfirmedToolsTaskModeMessage',
    RECONNECT_TO_ACTIVE_STREAM: 'aiMateReconnectToActiveStream',
    ABORT_AGENT_STREAM: 'aiMateAbortAgentStream',
    ANSWER_NOW: 'aiMateAnswerNow',
    HYDRATE_CONVERSATION: 'aiMateHydrateConversation',
    GET_CONVERSATION_CHANNELS: 'aiMateGetConversationChannels',
    GET_CONVERSATION_CHANNELS_INITIAL_LOAD: 'aiMateGetConversationChannelsInitialLoad',
    UPDATE_CONVERSATION_CHANNEL: 'aiMateUpdateConversationChannel',
    CREATE_SEEDED_CONVERSATION_CHANNEL: 'aiMateCreateSeededConversationChannel',
    PUBSUB_LISTENER: 'aiMatePubSubListener',
    FETCH_AGENT_TENANT_DATA: 'aiMateFetchAgentTenantData',
    RESOLVE_CONVERSATION_ACTION: 'aiMateResolveConversationAction',
    BULK_RESOLVE_CONVERSATION_ACTIONS: 'aiMateBulkResolveConversationActions',
    MESSAGE_RENDERER: 'aiMateMessageRenderer',
    FETCH_CONTEXTUAL_STARTERS: 'aiMateFetchContextualStarters',
    FETCH_DYNAMIC_CONVERSATION_STARTERS: 'aiMateFetchDynamicConversationStarters',
    GENERATE_CONVERSATION_STARTERS: 'aiMateGenerateConversationStarters',
    FETCH_AGENT_TEAM_DATA: 'aiMateFetchAgentTeamData',
    FETCH_CONNECTED_KNOWLEDGE_SOURCES: 'aiMateFetchConnectedKnowledgeSources',
    FETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE: 'aiMateFetchKnowledgeSourcesStore',
    PREFETCH_CONNECTED_KNOWLEDGE_SOURCES_STORE: 'aiMatePrefetchKnowledgeSourcesStore',
    FETCH_AGENT_ACTIONS: 'aiMateFetchAgentActions',
    CHANGE_AGENT_OWNER: 'aiMateChangeAgentOwner',
    GET_AGENT_PERMISSIONS: 'aiMateGetAgentPermissions',
    AIFC_FINALIZE_CONTENT: 'aiMateAIFCFinalizeContent',
    PREVIEW_CONTENT: 'aiMatePreviewContent',
    PREVIEW_CARD_RENDER: 'aiMatePreviewCardRender',
    JIRA_PREVIEW_CARD_RENDER: 'aiMateJiraPreviewCardRender',
    JSM_PREVIEW_CARD_RENDER: 'aiMateJsmPreviewCardRender',
    FETCH_AGENT_SITE_PERMISSIONS: 'aiMateFetchAgentSitePermissions',
    PREFETCH_AGENT_SITE_PERMISSIONS: 'aiMatePrefetchAgentSitePermissions',
    SEND_MESSAGE_NL_AGENT: 'aiMateSendMessageNLAgent',
    FILTERED_CLIENT_ERROR: 'aiMateFilteredClientError',
    GET_RECOMMENDED_AGENTS: 'aiMateGetRecommendedAgents',
    PREFETCH_RECOMMENDED_AGENTS: 'aiMatePrefetchRecommendedAgents',
    PREFETCH_RECOMMENDED_SPACES: 'aiMatePrefetchRecommendedSpaces',
    OPEN_RECOMMENDED_SPACES: 'aiMateOpenRecommendedSpaces',
    UPLOAD_FILES_TO_CONVERSATION: 'aiMateUploadFilesToConversation',
    VALIDATE_FILES: 'aiMateValidateFiles',
    GET_CONVERSATION_FILES: 'aiMateGetConversationFiles',
    AIFC_MESSAGE: 'aiMateAifcMessage',
    AIFC_LOAD_STAGING_AREA_MODAL: 'aiMateLoadStagingAreaModal',
    AIFC_LOAD_CHAT_ONLY_CREATION_MODAL: 'aiMateLoadChatOnlyCreationModal',
    AIFC_LOAD_DRAFTS_SECTION: 'aiMateLoadDraftsSection',
    AIFC_GENERATE_CONTENT: 'aiMateAifcGenerateContent',
    AIFC_GENERATE_CONTENT_IN_CHAT: 'aiMateAifcGenerateContentInChat',
    AIFC_INITIAL_DATA_RECEIVED: 'aiMateAifcInitialDataReceived',
    AIFC_ALL_DATA_HANDLED: 'aiMateAifcAllDataHandled',
    AIFC_UPDATE_CONTENT: 'aiMateAifcUpdateContent',
    UPDATE_CONTENT_IN_CHAT: 'aiMateUpdateContentInChat',
    AIFC_MODAL_SESSION: 'aiMateAifcModalSession',
    CSM_WIDGET_RENDER: 'csmWidgetRender',
    CSM_AGENT_IDENTITY_NAME: 'csmAgentIdentityName',
    CSM_AGENT_IDENTITY_COMPANY: 'csmAgentIdentityCompany',
    CSM_AGENT_IDENTITY_TONE: 'csmAgentIdentityTone',
    CSM_AGENT_IDENTITY_GREETING_MESSAGE: 'csmAgentIdentityGreetingMessage',
    CSM_AGENT_IDENTITY_CONVERSATION_STARTERS: 'csmAgentIdentityConversationStarters',
    CSM_AGENT_IDENTITY_GENERATE_CONVERSATION_STARTERS: 'csmAgentIdentityGenerateConversationStarters',
    GET_AUTO_APPLY_STATE: 'aiMateGetAutoApplyState',
    SET_AUTO_APPLY_STATE: 'aiMateSetAutoApplyState',
    AGENTS_MODAL_AND_SIDEBAR_LIST: 'aiMateAgentsModalAndSidebarList',
    AGENTS_MODAL_FAVOURITE_AGENTS: 'aiMateAgentsModalFavouriteAgents',
    AGENTS_FULLSCREEN_AGENT_LIST: 'aiMateAgentsFullscreenAgentList',
    STUDIO_TRIGGER_SOLUTION_PLAN: 'aiMateStudioTriggerSolutionPlan',
    MY_PROJECTS_LIST_QUERY: 'aiMateMyProjectsListQuery',
    STUDIO_UPDATE_AGENT: 'aiMateStudioUpdateAgent',
    STUDIO_AUTOMATION_CREATE_RULE: 'aiMateStudioAutomationCreateRule',
    THREADS_LIST_QUERY: 'aiMateThreadsListQuery',
    WARM_CONVERSATION_CACHE: 'aiMateWarmConversationCache',
    WARM_CONTEXT_BANNER_LINK: 'aiMateWarmContextBannerLink',
    AIFC_LOAD_PROMPT_SUGGESTIONS: 'aiMateAifcLoadPromptSuggestions',
    REMIX_START: 'aiMateRemixStart',
    FETCH_PROMPTS: 'aiMateFetchPrompts',
    FETCH_INSIGHTS_STATUS: 'aiMateFetchInsightsStatus',
    FETCH_INSIGHTS_FEED: 'aiMateFetchInsightsFeed',
    REMIX_RENDERS_IN_MODAL: 'aiMateRemixRendersInModal',
    REMIX_REGENERATE: 'aiMateRemixRegenerate',
    REMIX_INSERT: 'aiMateRemixInsert',
    REMIX_DIAGRAM_PASTE_FINALIZE: 'aiMateRemixDiagramPasteFinalize',
    FETCH_TASKS: 'aiMateFetchTasks',
    LOAD_STICKY_SKILL_LISTENER: 'aiMateLoadStickySkillListener',
    /**
   * Tracks duplicating a Remix/MAUI app when its link is pasted into another
   * Confluence page. Started when the editor plugin detects a MAUI link in
   * the paste, succeeded once the duplicated app's URL has been swapped into
   * the editor doc, and failed if the duplicate API call (or any JS error in
   * the duplication flow) fails. When this experience fails, the
   * REMIX_INSERT experience is also failed so the overall paste-and-insert
   * flow is reflected in the SLO.
   */ REMIX_DUPLICATE_APP: 'aiMateRemixDuplicateApp',
    STUDIO_CREATE_AGENT: 'aiMateStudioCreateAgent',
    STUDIO_CREATE_AGENT_ASSIGN: 'aiMateStudioCreateAgentAssign',
    STUDIO_CREATE_AGENT_INVOKE: 'aiMateStudioCreateAgentInvoke',
    STUDIO_CREATE_AGENT_BUILD_AND_CHAT: 'aiMateStudioCreateAgentBuildAndChat',
    STUDIO_CREATE_AGENT_REFINE_IN_STUDIO: 'aiMateStudioCreateAgentRefineInStudio',
    STUDIO_CREATE_AGENT_RENDER: 'aiMateStudioCreateAgentRender',
    JIRA_SAVE_DRAFT_WORK_ITEM: 'aiMateJiraSaveDraftWorkItem',
    JIRA_RESOLVE_DRAFT_WORK_ITEM: 'aiMateJiraResolveDraftWorkItem',
    JIRA_CREATE_WORK_ITEMS_BULK: 'aiMateJiraCreateWorkItemsBulk'
};
var $b6334bd5b5c71b1c$export$3615d040a39afa1e = /*#__PURE__*/ function(ExperienceNamePostfix) {
    ExperienceNamePostfix["MINI_MODAL"] = "miniModal";
    return ExperienceNamePostfix;
}({});
const $b6334bd5b5c71b1c$export$97bfa295b10f6f9e = ({ deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, taskModeEnabled: taskModeEnabled, fastModeEnabled: fastModeEnabled, isCustomRovoAgent: isCustomRovoAgent })=>{
    if (isCustomRovoAgent) return $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.SEND_MESSAGE_ROVO_CUSTOM_AGENT;
    if (deepResearchEnabled) return $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.SEND_DR_MESSAGE;
    if (thinkDeeperEnabled) return $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.SEND_TD_MESSAGE;
    if (taskModeEnabled) return $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.SEND_TASK_MODE_MESSAGE;
    if (fastModeEnabled) // Sending the same experience name for fast mode as it is the same as the default (auto) mode
    return $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.SEND_MESSAGE;
    return $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.SEND_MESSAGE;
};
const $b6334bd5b5c71b1c$export$233a4307e330ea30 = [
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_GENERATE_CONTENT,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_GENERATE_CONTENT_IN_CHAT,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_UPDATE_CONTENT,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_FINALIZE_CONTENT,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_LOAD_STAGING_AREA_MODAL,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_MODAL_SESSION,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.REMIX_REGENERATE
];
const $b6334bd5b5c71b1c$export$1b8ade75bafe2a6d = {
    /** Browser-level network failure — request never reached Atlassian servers (e.g. VPN, firewall, no connectivity) */ CLIENT_FETCH_ERROR: 'clientFetchError',
    /** Rovo is not enabled for the user's organisation (product-not-active stream error) */ PRODUCT_NOT_ACTIVE: 'productNotActive',
    /** User is not authenticated or lacks permission (HTTP 401/403) */ AUTH_OR_PERMISSION_ERROR: 'authOrPermissionError'
};
const $b6334bd5b5c71b1c$export$449b821dadec8760 = [
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_INITIAL_DATA_RECEIVED,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.AIFC_ALL_DATA_HANDLED,
    $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1.PREVIEW_CONTENT,
    ...$b6334bd5b5c71b1c$export$233a4307e330ea30
];
const $b6334bd5b5c71b1c$export$ebde7a14f059b67f = {
    SUBMIT: 'submit',
    ACTION_COMPLETE_RECEIVED: 'action_complete_received',
    PREVIEW_VISIBLE: 'preview_visible'
};
const $b6334bd5b5c71b1c$export$35724980a513a99d = [
    {
        key: 'backend_latency',
        startMark: $b6334bd5b5c71b1c$export$ebde7a14f059b67f.SUBMIT,
        endMark: $b6334bd5b5c71b1c$export$ebde7a14f059b67f.ACTION_COMPLETE_RECEIVED
    },
    {
        key: 'render_latency',
        startMark: $b6334bd5b5c71b1c$export$ebde7a14f059b67f.ACTION_COMPLETE_RECEIVED,
        endMark: $b6334bd5b5c71b1c$export$ebde7a14f059b67f.PREVIEW_VISIBLE
    }
];
const $b6334bd5b5c71b1c$export$13437d7a030ee3e7 = new (0, $cNAch.UFOExperience)('remix-generate-preview', {
    type: (0, $4MiWC.ExperienceTypes).Experience,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult,
    timings: [
        ...$b6334bd5b5c71b1c$export$35724980a513a99d
    ]
});
const $b6334bd5b5c71b1c$export$bef09d36689d0f74 = {
    SUBMIT: 'submit',
    // mark the start of the experience when the user submits the edit request
    ACTION_COMPLETE_RECEIVED: 'action_complete_received',
    // mark when we receive the ACTION_COMPLETE event from the backend
    NODE_INSERTED: 'node_inserted' // mark when the new app node is inserted into the editor
};
const $b6334bd5b5c71b1c$export$222a56424ec38dc0 = [
    {
        key: 'backend_latency',
        startMark: $b6334bd5b5c71b1c$export$bef09d36689d0f74.SUBMIT,
        endMark: $b6334bd5b5c71b1c$export$bef09d36689d0f74.ACTION_COMPLETE_RECEIVED
    },
    {
        key: 'insertion_latency',
        startMark: $b6334bd5b5c71b1c$export$bef09d36689d0f74.ACTION_COMPLETE_RECEIVED,
        endMark: $b6334bd5b5c71b1c$export$bef09d36689d0f74.NODE_INSERTED
    }
];
const $b6334bd5b5c71b1c$export$a143927e9fe401a2 = new (0, $cNAch.UFOExperience)('remix-edit-existing', {
    type: (0, $4MiWC.ExperienceTypes).Experience,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult,
    timings: [
        ...$b6334bd5b5c71b1c$export$222a56424ec38dc0
    ]
});
module.exports["ExperienceName"] = $b6334bd5b5c71b1c$export$b881bd9f00ed8ed1;
module.exports["ExperienceNamePostfix"] = $b6334bd5b5c71b1c$export$3615d040a39afa1e;
module.exports["sendMessageExperienceName"] = $b6334bd5b5c71b1c$export$97bfa295b10f6f9e;
module.exports["AIFC_EXPERIENCES_TO_FAIL"] = $b6334bd5b5c71b1c$export$233a4307e330ea30;
module.exports["SLOExclusionReason"] = $b6334bd5b5c71b1c$export$1b8ade75bafe2a6d;
module.exports["AIFC_EXPERIENCES_TO_ABORT"] = $b6334bd5b5c71b1c$export$449b821dadec8760;
module.exports["REMIX_GENERATE_PREVIEW_MARKS"] = $b6334bd5b5c71b1c$export$ebde7a14f059b67f;
module.exports["remixGeneratePreviewExperience"] = $b6334bd5b5c71b1c$export$13437d7a030ee3e7;
module.exports["REMIX_EDIT_EXISTING_MARKS"] = $b6334bd5b5c71b1c$export$bef09d36689d0f74;
module.exports["remixEditExistingExperience"] = $b6334bd5b5c71b1c$export$a143927e9fe401a2;

});

parcelRegister("bjY3F", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $6cFsl = parcelRequire("6cFsl");


var $haNN4 = parcelRequire("haNN4");


var $cXtTj = parcelRequire("cXtTj");


var $ixfCV = parcelRequire("ixfCV");


var $a33Aa = parcelRequire("a33Aa");


var $boaiH = parcelRequire("boaiH");


var $10XTN = parcelRequire("10XTN");


var $hlvTd = parcelRequire("hlvTd");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $irnO2 = parcelRequire("irnO2");


var $1XM8n = parcelRequire("1XM8n");


var $8YL3U = parcelRequire("8YL3U");

var $78cafaa44d513db0$var$_ExperienceTrackerHandler;
const $78cafaa44d513db0$var$isRovoInstrumentedError = (error)=>error !== null && error !== undefined && typeof error === 'object' && 'errorAttributes' in error && typeof error.errorAttributes === 'object';
const $78cafaa44d513db0$var$isTerminalEvent = (event)=>event.action === 'taskSuccess' || event.action === 'taskFail' || event.action === 'taskAbort';
class $78cafaa44d513db0$export$5a92a056565f01cc {
    setSendAnalyticsEvent(sendAnalyticsEvent) {
        this.sendAnalyticsEvent = sendAnalyticsEvent;
    }
    static getInstance() {
        if (!$78cafaa44d513db0$export$5a92a056565f01cc.instance) {
            const dropEvents = (0, $cXtTj.default).getExperimentValue('platform_ai_drop_instrumentation_tracking', 'value', false);
            $78cafaa44d513db0$export$5a92a056565f01cc.instance = new $78cafaa44d513db0$export$5a92a056565f01cc(dropEvents);
        }
        // instance is guaranteed to be set after the guard above
        return $78cafaa44d513db0$export$5a92a056565f01cc.instance;
    }
    /**
   * @internal For tests only.
   */ static resetInstance() {
        $78cafaa44d513db0$export$5a92a056565f01cc.instance = undefined;
    }
    static setLabelStack(labelStack) {
        $78cafaa44d513db0$export$5a92a056565f01cc.labelStack = labelStack;
    }
    constructor(dropEvents){
        this.experienceTracker = new (0, $boaiH.ExperienceTracker)();
        this.sendAnalyticsEvent = null;
        this.tabVisibilityByExperience = new Map();
        const doc = (0, $haNN4.getDocument)();
        if (doc && (0, $ixfCV.fg)('rovo_chat_exp_tracking_tab_vis_metrics')) (0, $cbY7C.bind)(doc, {
            type: 'visibilitychange',
            listener: ()=>{
                const isHidden = doc.visibilityState === 'hidden';
                this.tabVisibilityByExperience.forEach((tracker)=>{
                    tracker.onVisibilityChange(isHidden);
                });
            }
        });
        if (!dropEvents) this.experienceTracker.subscribe((event)=>{
            if (event.action === 'taskStart' && (0, $ixfCV.fg)('rovo_chat_exp_tracking_tab_vis_metrics')) this.tabVisibilityByExperience.set(event.name, new (0, $8YL3U.TabVisibilityTracker)(doc));
            let filteredErrorAttributes = {};
            let preventSendingLogException = false;
            // When non-null, converts taskFail → taskAbort so the error is excluded from SLO
            // failure counts but still recorded for anomaly detection purposes.
            // Gated by a feature flag so this behaviour can be toggled off as a kill switch.
            let sloExclusion = null;
            const isErrorEvent = 'error' in event;
            // Skip SLO exclusion logic for the aiMateFilteredClientError experience itself
            // to avoid re-processing and potential infinite loops.
            const isFilteredClientErrorExperience = event.name === (0, $irnO2.ExperienceName).FILTERED_CLIENT_ERROR;
            if (isErrorEvent && !isFilteredClientErrorExperience) {
                // Classify common non-service errors so they can be tracked separately from
                // real backend failures:
                //   - client fetch errors (e.g. "Failed to fetch") — request never reached Atlassian
                //   - product-not-active — HTTP 200 but SSE payload contains an errorCode
                //   - auth/permission — HTTP 401/403 (session expired, HIPAA, IP allowlist, etc.)
                if ((0, $ixfCV.fg)('rovo_chat_exclude_client_errors_from_slo')) {
                    if ((0, $10XTN.isClientFetchError)(event.error)) {
                        preventSendingLogException = true;
                        sloExclusion = {
                            reason: (0, $irnO2.SLOExclusionReason).CLIENT_FETCH_ERROR
                        };
                    } else if ((0, $10XTN.isProductNotActiveError)(event.error)) {
                        preventSendingLogException = true;
                        sloExclusion = {
                            reason: (0, $irnO2.SLOExclusionReason).PRODUCT_NOT_ACTIVE
                        };
                    } else if ((0, $10XTN.isAuthOrPermissionError)(event.error)) {
                        preventSendingLogException = true;
                        sloExclusion = {
                            reason: (0, $irnO2.SLOExclusionReason).AUTH_OR_PERMISSION_ERROR
                        };
                    }
                }
                if (event.attributes) {
                    const { webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled } = event.attributes;
                    if (webSearchEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        webSearchEnabled: webSearchEnabled
                    };
                    if (deepResearchEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        deepResearchEnabled: deepResearchEnabled
                    };
                    if (fastModeEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        fastModeEnabled: fastModeEnabled
                    };
                    if (thinkDeeperEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        thinkDeeperEnabled: thinkDeeperEnabled
                    };
                }
                if ($78cafaa44d513db0$var$isRovoInstrumentedError(event.error)) {
                    const errorAttributes = event.error.errorAttributes;
                    // Remove undefined properties
                    filteredErrorAttributes = Object.fromEntries(Object.entries(errorAttributes).filter(([, value])=>value !== undefined));
                }
                const teamName = (0, $1XM8n.getOwningTeam)(event.error.message ?? '', event.name);
                filteredErrorAttributes = {
                    teamName: teamName,
                    // We intentionally put this first so a `teamName` attribute can override this.
                    ...filteredErrorAttributes
                };
                if (!preventSendingLogException) {
                    const error = event.error instanceof Error ? event.error : new Error(JSON.stringify(event.error));
                    const attributes = event.attributes;
                    // this is added by `useExperienceTracker` below
                    const touchpointSource = typeof attributes?.touchpointSource === 'string' ? attributes.touchpointSource : undefined;
                    const teamName = typeof attributes?.teamName === 'string' ? attributes.teamName : undefined;
                    const { traceId: traceIdFromErrorObject, ...filteredErrorAttributesRest } = filteredErrorAttributes;
                    const altTraceId = attributes?.traceId || traceIdFromErrorObject;
                    (0, $hlvTd.logException)({
                        exception: error,
                        name: event.name,
                        // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing experience-tracker baseline: legacy UFO attributes are assembled from mixed attribute sources before being passed to a string map API.
                        tags: {
                            source: 'aiMateExperienceTracker',
                            ...filteredErrorAttributesRest,
                            ...touchpointSource && {
                                touchpointSource: touchpointSource
                            },
                            ...teamName && {
                                teamName: teamName
                            },
                            // Rename traceId to atlTraceId if present in attributes to distinguish from Sentry's Trace ID
                            ...altTraceId && {
                                altTraceId: altTraceId
                            }
                        }
                    });
                }
            }
            if ($78cafaa44d513db0$var$isTerminalEvent(event)) // the experience tracker already uses performance.now() to calculate the duration, so we can just piggyback on that,
            // we will loose some precision due to rounding of duration, but it's good enough for our purposes
            (0, $a33Aa.addSpanToAll)('custom', `exp-${event.name}`, $78cafaa44d513db0$export$5a92a056565f01cc.labelStack, event.startTime, event.startTime + event.duration);
            const tabVisibilityAttributes = $78cafaa44d513db0$var$isTerminalEvent(event) && (0, $ixfCV.fg)('rovo_chat_exp_tracking_tab_vis_metrics') ? this.tabVisibilityByExperience.get(event.name)?.getAttributes(doc) ?? {} : {};
            // If the error should be excluded from SLO, report it as taskAbort instead of taskFail.
            // taskAbort events are not counted as failures in the SLO but are still recorded
            // so anomaly detectors can track spikes in these error types.
            const effectiveAction = sloExclusion && event.action === 'taskFail' ? 'taskAbort' : event.action;
            this.sendAnalyticsEvent?.({
                eventType: 'operational',
                action: effectiveAction,
                actionSubject: 'ui',
                attributes: {
                    task: event.name,
                    taskId: event.id,
                    startTime: event.startTime,
                    ...$78cafaa44d513db0$var$isTerminalEvent(event) && {
                        duration: event.duration
                    },
                    // Include error info on both taskFail and taskAbort (for excluded errors)
                    // so analytics/anomaly detectors can distinguish error types.
                    ...isErrorEvent && {
                        error: event.error.message,
                        ...filteredErrorAttributes
                    },
                    // Surface why the error was excluded from the SLO so the raw analytics
                    // event can be queried/grouped without joining to the synthetic experience.
                    ...sloExclusion && {
                        sloExclusionReason: sloExclusion.reason
                    },
                    ...event.attributes,
                    ...tabVisibilityAttributes
                }
            }, {
                removeDefaultTags: true
            });
            // When a client error is excluded from the main SLO (ie. converted to taskAbort),
            // track a separate experience so the volume of these errors can be monitored with its own SLO threshold.
            if (sloExclusion && isErrorEvent) {
                this.experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).FILTERED_CLIENT_ERROR,
                    id: (0, $irnO2.ExperienceName).FILTERED_CLIENT_ERROR,
                    startTime: event.startTime
                });
                this.experienceTracker.fail({
                    name: (0, $irnO2.ExperienceName).FILTERED_CLIENT_ERROR,
                    error: event.error,
                    attributes: {
                        // Preserve the original experience name, error, and exclusion reason for queryability
                        originalTask: event.name,
                        error: event.error.message,
                        sloExclusionReason: sloExclusion.reason,
                        ...filteredErrorAttributes
                    }
                });
            }
            if ($78cafaa44d513db0$var$isTerminalEvent(event) && (0, $ixfCV.fg)('rovo_chat_exp_tracking_tab_vis_metrics')) this.tabVisibilityByExperience.delete(event.name);
        });
    }
}
$78cafaa44d513db0$var$_ExperienceTrackerHandler = $78cafaa44d513db0$export$5a92a056565f01cc;
$78cafaa44d513db0$export$5a92a056565f01cc.instance = void 0;
$78cafaa44d513db0$export$5a92a056565f01cc.labelStack = [];
const $78cafaa44d513db0$export$63af6e7bbb4f375d = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $78cafaa44d513db0$var$_temp;
} : ()=>{
    return (0, $cozmU.useCallback)((componentLabelStack)=>{
        $78cafaa44d513db0$export$5a92a056565f01cc.setLabelStack(componentLabelStack);
    }, []);
};
const $78cafaa44d513db0$export$412c53791574f6f0 = (params)=>{
    (0, $6cFsl.di)((0, $Ou0Zz.useAnalytics));
    const { sendAnalyticsEvent: sendAnalyticsEvent, mode: conversationAssistantUIMode } = (0, $Ou0Zz.useAnalytics)();
    const getNameOverride = (0, $cozmU.useCallback)((name)=>{
        switch(conversationAssistantUIMode){
            case 'mini-modal':
                return `${name}.${(0, $irnO2.ExperienceNamePostfix).MINI_MODAL}`;
            default:
                return name;
        }
    }, [
        conversationAssistantUIMode
    ]);
    (0, $cozmU.useMemo)(()=>{
        const experienceTracker = $78cafaa44d513db0$export$5a92a056565f01cc.getInstance();
        // this is not ideal, okay just because `sendAnalyticsEvent` is never change
        // since every hook instance will override the singleton sendAnalyticsEvent
        experienceTracker.setSendAnalyticsEvent(sendAnalyticsEvent);
    }, [
        sendAnalyticsEvent
    ]);
    const experienceTrackerProxy = (0, $cozmU.useMemo)(()=>{
        const proxyHandler = {
            get: (target, prop)=>{
                // Overriding the experienceTracker target methods to add additional attributes
                if (prop === 'fail') return (failParams)=>{
                    target.fail({
                        ...failParams,
                        name: !!failParams.name ? getNameOverride(failParams.name) : failParams.name,
                        attributes: {
                            ...failParams.attributes,
                            touchpointSource: params?.touchpointSource,
                            teamName: failParams.teamName
                        }
                    });
                };
                if (prop === 'succeed') return (succeedParams)=>{
                    target.succeed({
                        ...succeedParams,
                        name: !!succeedParams.name ? getNameOverride(succeedParams.name) : succeedParams.name,
                        attributes: {
                            ...succeedParams.attributes,
                            touchpointSource: params?.touchpointSource
                        }
                    });
                };
                if (prop === 'start') return (startParams)=>{
                    target.start({
                        ...startParams,
                        name: !!startParams.name ? getNameOverride(startParams.name) : startParams.name
                    });
                };
                if (prop === 'abort') return (abortParams)=>{
                    target.abort({
                        ...abortParams,
                        name: !!abortParams.name ? getNameOverride(abortParams.name) : abortParams.name
                    });
                };
                if (prop === 'stopOnError') return (stopOnErrorParams)=>{
                    target.stopOnError({
                        ...stopOnErrorParams,
                        name: !!stopOnErrorParams.name ? getNameOverride(stopOnErrorParams.name) : stopOnErrorParams.name
                    });
                };
                return typeof target[prop] === 'function' ? target[prop].bind(target) : target[prop];
            }
        };
        return new Proxy($78cafaa44d513db0$export$5a92a056565f01cc.getInstance().experienceTracker, proxyHandler);
    }, [
        params?.touchpointSource,
        getNameOverride
    ]);
    return experienceTrackerProxy;
};
function $78cafaa44d513db0$var$_temp(componentLabelStack) {
    $78cafaa44d513db0$export$5a92a056565f01cc.setLabelStack(componentLabelStack);
}
module.exports["ExperienceTrackerHandler"] = $78cafaa44d513db0$export$5a92a056565f01cc;
module.exports["useUFOLabelStackSetter"] = $78cafaa44d513db0$export$63af6e7bbb4f375d;
module.exports["useAIMateExperienceTracker"] = $78cafaa44d513db0$export$412c53791574f6f0;

});

parcelRegister("boaiH", function(module, exports) {

var $2gr4B = parcelRequire("2gr4B");

class $ffade2ccf1ecf3ef$export$12b6b072930fd68f {
    start({ name: name, id: id, timeout: timeout, startTime: startTime, attributes: attributes, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort, collect: collect }) {
        const current = this.experiences[name];
        if (current && !current.hasStopped && current.id === id) return;
        // Before replacing a current experience, abort it to ensure
        // it is cleaned up.
        if (current) current.abort({
            reason: 'Aborted because the same experience was started with a new id'
        });
        const experience = new (0, $2gr4B.Experience)({
            name: name,
            id: id,
            timeout: timeout,
            startTime: startTime,
            attributes: attributes,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onAbort: onAbort,
            onStart: (startEvent)=>{
                this.emit(startEvent);
                let disposeCollectSubscription = ()=>{};
                if (collect) {
                    const events = [];
                    disposeCollectSubscription = this.subscribe((event)=>{
                        // Ignore already running experiences that started before this
                        // experience started
                        if (event.action === 'taskStart' || events.some((previousEvent)=>previousEvent.name === event.name && previousEvent.action === 'taskStart')) {
                            events.push(event);
                            collect(events, experience);
                        }
                    });
                }
                return (stopEvent)=>{
                    disposeCollectSubscription();
                    this.emit(stopEvent);
                };
            }
        });
        this.experiences[name] = experience;
    }
    succeed({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.succeed(attributes);
    }
    fail({ name: name, error: error, attributes: attributes }) {
        Object.values(this.experiences).forEach((current)=>{
            if (name != null && current.name !== name) return;
            current.fail({
                error: error,
                attributes: attributes
            });
        });
    }
    abort({ name: name, reason: reason, attributes: attributes, checkForTimeout: checkForTimeout }) {
        function abort(experience) {
            if (name != null && experience.name !== name) return;
            experience.abort({
                reason: reason,
                checkForTimeout: checkForTimeout,
                attributes: attributes
            });
        }
        const experiencesWithTimeouts = Object.values(this.experiences).filter((experience)=>experience.timeout);
        const experiencesWithoutTimeouts = Object.values(this.experiences).filter((experience)=>!experience.timeout);
        // We need to abort all experiences with timeouts first in order to properly
        // capture compound experiences composed of sub-experiences which have timeouts
        experiencesWithTimeouts.forEach(abort);
        experiencesWithoutTimeouts.forEach(abort);
    }
    subscribe(subscriber) {
        if (typeof subscriber !== 'function') throw new Error('Subscriber must be a function');
        this.subscribers.push(subscriber);
        return ()=>{
            this.subscribers = this.subscribers.filter((x)=>x !== subscriber);
        };
    }
    stopOnError({ name: name, error: error, attributes: attributes }) {
        if (this.isNetworkOfflineError(error)) {
            this.abort({
                name: name,
                reason: `Aborted ${name} because of network error: ${error.toString()}`,
                checkForTimeout: false,
                attributes: attributes
            });
            return;
        }
        return this.fail({
            name: name,
            error: error,
            attributes: attributes
        });
    }
    updateAttributes({ name: name, attributes: attributes }) {
        const current = this.experiences[name];
        if (!current) return;
        current.updateAttributes(attributes);
    }
    emit(event) {
        this.subscribers.forEach((subscriber)=>{
            try {
                subscriber(event);
            } catch (e) {}
        });
    }
    constructor(options){
        this.experiences = {};
        this.subscribers = [];
        this.isNetworkOfflineError = void 0;
        this.isNetworkOfflineError = options && options.isNetworkOfflineError || (()=>false);
    }
}
module.exports["ExperienceTracker"] = $ffade2ccf1ecf3ef$export$12b6b072930fd68f;

});

parcelRegister("2gr4B", function(module, exports) {

var $apqal = parcelRequire("apqal");

function $8617e1b2001e7e7c$var$mergeAttributes(first, last) {
    if (first === undefined) return last;
    if (last === undefined) return first;
    return {
        ...first,
        ...last
    };
}
class $8617e1b2001e7e7c$export$c90b54e658fc4d7c {
    get hasStopped() {
        return this._hasStopped;
    }
    succeed(attributes) {
        if (this._hasStopped) return;
        this.onSuccess && this.onSuccess();
        this.stop({
            action: 'taskSuccess',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    fail({ error: error, attributes: attributes }) {
        if (this._hasStopped) return;
        this.onFailure && this.onFailure();
        this.stop({
            action: 'taskFail',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            error: error,
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    abort({ reason: reason, attributes: attributes, checkForTimeout: checkForTimeout = true }) {
        if (this._hasStopped) return;
        // Check if the experience should have failed due to timeout
        if (checkForTimeout && this.timeout != null && this.getDuration() >= this.timeout) {
            this.fail({
                attributes: attributes,
                error: new (0, $apqal.ExperienceTimeoutError)(`${this.name} failed to complete in ${this.timeout}ms`)
            });
            return;
        }
        this.onAbort && this.onAbort();
        this.stop({
            action: 'taskAbort',
            name: this.name,
            id: this.id,
            startTime: this.startTime,
            duration: this.getDuration(),
            reason: reason,
            checkForTimeout: checkForTimeout,
            attributes: $8617e1b2001e7e7c$var$mergeAttributes(this.attributes, attributes)
        });
    }
    stopOn(event) {
        if (!event) return;
        if (event.action === 'taskSuccess') this.succeed();
        else if (event.action === 'taskAbort') this.abort({
            reason: event.reason,
            checkForTimeout: event.checkForTimeout
        });
        else if (event.action === 'taskFail') this.fail({
            error: event.error
        });
    }
    updateAttributes(attributes) {
        this.attributes = {
            ...this.attributes,
            ...attributes
        };
    }
    stop(event) {
        this._hasStopped = true;
        if (this.onStop) this.onStop(event);
    }
    getDuration() {
        return Math.round(window.performance.now() - this.startTime);
    }
    constructor({ name: name, id: id, timeout: timeout, startTime: startTime = window.performance.now(), attributes: attributes, onStart: onStart, onSuccess: onSuccess, onFailure: onFailure, onAbort: onAbort }){
        this.name = void 0;
        this.id = void 0;
        this.timeout = void 0;
        this._hasStopped = false;
        this.startTime = void 0;
        this.attributes = void 0;
        this.onStop = void 0;
        this.onSuccess = void 0;
        this.onFailure = void 0;
        this.onAbort = void 0;
        this.name = name;
        this.id = id;
        this.timeout = timeout;
        this.startTime = startTime;
        this.attributes = attributes;
        this.onSuccess = onSuccess;
        this.onFailure = onFailure;
        this.onAbort = onAbort;
        const startEvent = {
            action: 'taskStart',
            name: name,
            id: id,
            startTime: startTime,
            timeout: timeout,
            attributes: attributes
        };
        if (onStart) this.onStop = onStart(startEvent);
    }
}
module.exports["Experience"] = $8617e1b2001e7e7c$export$c90b54e658fc4d7c;

});

parcelRegister("apqal", function(module, exports) {
class $f9800b995ac71735$export$d27a2b6293f7631c extends Error {
    constructor(message){
        super(message);
        this.name = 'ExperienceTimeoutError';
    }
}
module.exports["ExperienceTimeoutError"] = $f9800b995ac71735$export$d27a2b6293f7631c;

});

parcelRegister("10XTN", function(module, exports) {

var $3PJhM = parcelRequire("3PJhM");

// Referenced from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Issues we are not gonna track in Sentry
const $ab109556016fa76e$var$KNOWN_NETWORK_ERRORS_LIMITED = [
    'server with the specified hostname could not be found',
    'connection failure',
    'Failed to fetch',
    'Load failed',
    // Safari equivalent of "Failed to fetch"
    'Network request failed',
    'NetworkError',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted'
];
const $ab109556016fa76e$var$isClientFetchErrorMessage = (message)=>{
    const errorTypes = $ab109556016fa76e$var$KNOWN_NETWORK_ERRORS_LIMITED;
    return Boolean(message) && !!errorTypes.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
};
const $ab109556016fa76e$var$KNOWN_NETWORK_ERRORS_TYPES = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $ab109556016fa76e$export$2e7adc44463c3f4f = (error)=>{
    if (!(0, $3PJhM.isRecord)(error)) return false;
    // Check top-level error name and message
    const hasKnownName = typeof error.name === 'string' && $ab109556016fa76e$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.name);
    const hasKnownMessage = typeof error.message === 'string' && $ab109556016fa76e$var$isClientFetchErrorMessage(error.message);
    if (hasKnownName || hasKnownMessage) return true;
    // Also check the nested cause (e.g. wrapped fetch errors)
    if (!(0, $3PJhM.isRecord)(error.cause)) return false;
    return typeof error.cause.name === 'string' && $ab109556016fa76e$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.cause.name) || typeof error.cause.message === 'string' && $ab109556016fa76e$var$isClientFetchErrorMessage(error.cause.message);
};
const $ab109556016fa76e$export$de229d5c9394f905 = (error)=>{
    if (!(0, $3PJhM.isRecord)(error)) return false;
    // RovoInstrumentedError shape
    const errorAttributes = (0, $3PJhM.isRecord)(error.errorAttributes) ? error.errorAttributes : undefined;
    const statusFromAttributes = errorAttributes?.statusCode;
    // Direct status on error
    const attributes = (0, $3PJhM.isRecord)(error.attributes) ? error.attributes : undefined;
    const statusDirect = error.status ?? attributes?.status;
    const status = statusFromAttributes ?? statusDirect;
    return status === 401 || status === 403;
};
const $ab109556016fa76e$export$9f0dca42eff14720 = (error)=>{
    if (!(0, $3PJhM.isRecord)(error)) return false;
    const errorAttributes = (0, $3PJhM.isRecord)(error.errorAttributes) ? error.errorAttributes : undefined;
    const errorCode = typeof errorAttributes?.errorCode === 'string' ? errorAttributes.errorCode.toLowerCase() : '';
    return errorCode.includes('product.not.active') || errorCode.includes('product_not_active');
};
module.exports["isClientFetchError"] = $ab109556016fa76e$export$2e7adc44463c3f4f;
module.exports["isAuthOrPermissionError"] = $ab109556016fa76e$export$de229d5c9394f905;
module.exports["isProductNotActiveError"] = $ab109556016fa76e$export$9f0dca42eff14720;

});

parcelRegister("3PJhM", function(module, exports) {
/**
 * Type guard that checks whether a value is a plain record object.
 */ const $99d6458d8ffffa8f$export$6ba840931da50680 = (value)=>typeof value === 'object' && value !== null && !Array.isArray(value);
module.exports["isRecord"] = $99d6458d8ffffa8f$export$6ba840931da50680;

});

parcelRegister("hlvTd", function(module, exports) {

var $jTKfH = parcelRequire("jTKfH");


var $10XTN = parcelRequire("10XTN");


var $cj7GQ = parcelRequire("cj7GQ");


var $fPSAz = parcelRequire("fPSAz");


// importing local file instead of from '@sentry/browser' otherwise there will be typescript errors
const $024249913f1d8b5b$var$importSentryAsync = async ()=>Promise.resolve((parcelRequire("eieXD")));
let $024249913f1d8b5b$var$sentryClient;
let $024249913f1d8b5b$var$accountIdPromise;
const $024249913f1d8b5b$var$defaultAccountIdProvider = ()=>new Promise((resolve, reject)=>{
        (0, $jTKfH.performHttpFetch)({
            path: '/gateway/api/me',
            options: {
                method: 'GET'
            }
        }).then((profileData)=>{
            if (profileData?.account_id) resolve(profileData.account_id);
            else reject(new Error('Profile data not loaded'));
        }).catch((error)=>{
            reject(error);
        });
    });
let $024249913f1d8b5b$var$accountIdProvider = $024249913f1d8b5b$var$defaultAccountIdProvider;
const $024249913f1d8b5b$export$59333a3d3d770a30 = (fn)=>{
    $024249913f1d8b5b$var$accountIdProvider = fn;
    $024249913f1d8b5b$var$accountIdPromise = undefined;
};
const $024249913f1d8b5b$export$e941c8ce80d1ac70 = ()=>{
    $024249913f1d8b5b$var$accountIdProvider = $024249913f1d8b5b$var$defaultAccountIdProvider;
    $024249913f1d8b5b$var$accountIdPromise = undefined;
};
// copied from platform/packages/people-and-teams/teams-client/src/services/sentry/utils/initialise-sentry.ts
const $024249913f1d8b5b$var$DISABLED_INTEGRATIONS = [
    'onerror',
    'onunhandledrejection',
    // In Jira this integration is being initialised twice, resulting in no events being sent to Sentry
    'Dedupe'
];
const $024249913f1d8b5b$var$getEnvironment = ()=>{
    return 'production';
};
const $024249913f1d8b5b$export$d8bd0edf6c978788 = async ({ customSentryDsn: customSentryDsn, packageName: packageName, product: productOverride, ignoreErrors: ignoreErrors, packageVersion: packageVersion } = {})=>{
    let accountId = 'UNKNOWN_AAID';
    let product = productOverride ?? (0, $cj7GQ.getRovoChatProduct)();
    try {
        if (!$024249913f1d8b5b$var$accountIdPromise) $024249913f1d8b5b$var$accountIdPromise = $024249913f1d8b5b$var$accountIdProvider();
        accountId = await $024249913f1d8b5b$var$accountIdPromise;
    } catch  {
    // do nothing
    }
    if ($024249913f1d8b5b$var$sentryClient) {
        // if sentry is trying to be initialized again with new product or account id
        // update the user and tags
        $024249913f1d8b5b$var$sentryClient.setTag('product', product);
        $024249913f1d8b5b$var$sentryClient.setUser({
            id: accountId
        });
        // do not initialise sentry again, only update the existing one
        return;
    }
    let importedSentry;
    try {
        importedSentry = await $024249913f1d8b5b$var$importSentryAsync();
    } catch (e) {
        console.warn('Failed to load conversation-assistant sentry', e); // eslint-disable-line no-console
        return;
    }
    // https://atlassian-2y.sentry.io/projects/ai-mate-conversation-assistant/getting-started/
    const defaultSentryDsn = 'https://0d679a1c0fe3816e2b2e34d4ca85d5da@o55978.ingest.sentry.io/4506794008903680';
    try {
        importedSentry.init({
            dsn: customSentryDsn || defaultSentryDsn,
            environment: $024249913f1d8b5b$var$getEnvironment(),
            integrations: (integrations)=>{
                return integrations.filter((integration)=>{
                    return $024249913f1d8b5b$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
                });
            },
            initialScope: {
                user: {
                    id: accountId
                },
                tags: {
                    packageName: packageName || '@atlassian/conversation-assistant',
                    product: product,
                    packageVersion: packageVersion
                }
            },
            // referencing jira/src/packages/platform/observability/errors-handling/src/utils/sentry/handling/normalise-sentry-event.tsx
            beforeSend: (event, hint)=>{
                const exception = hint?.originalException;
                // Ignore network-like errors
                if ((0, $10XTN.isClientFetchError)(exception)) return null;
                if (!event.tags?.name) // we only want to capture errors that has `name` tag from `logException` function below
                // since the `DISABLED_INTEGRATIONS` filter above is not enough to prevent unhandled errors
                return null;
                let updatedEvent = event;
                if (updatedEvent.request?.url) {
                    // Ignore events from localhost and staging
                    if (updatedEvent.request.url.includes('localhost') || updatedEvent.request.url.includes('jira-dev.com') || updatedEvent.request.url.includes('stg.atlassian.com') || updatedEvent.request.url.includes('stg.internal.atlassian.com') || updatedEvent.request.url.includes('stg-east.frontend.public.atl-paas.net')) return null;
                    updatedEvent.request.url = (0, $fPSAz.normaliseUrl)(updatedEvent.request.url);
                }
                if (updatedEvent.exception?.values) {
                    const allMatchedUUIDs = [];
                    updatedEvent.exception.values = updatedEvent.exception.values.map((exception)=>{
                        const { normalized: normalized, matchedUUIDs: matchedUUIDs } = (0, $fPSAz.normalizeUUID)(exception.value);
                        allMatchedUUIDs.push(...matchedUUIDs);
                        return {
                            ...exception,
                            value: normalized
                        };
                    });
                    if (allMatchedUUIDs.length > 0) {
                        if (!updatedEvent.tags) updatedEvent.tags = {};
                        updatedEvent.tags.matchedUUID = JSON.stringify(allMatchedUUIDs);
                    }
                }
                return updatedEvent;
            },
            attachStacktrace: true,
            ignoreErrors: ignoreErrors
        });
    } catch (error) {
        // this function throws e.update is not a function errors when we have a mismatch in sentry versions.
        // all targeted errors include 'update is not a function' even if minified differently
        if (error instanceof Error && error.message.includes('update is not a function')) ;
        else throw error;
    }
    $024249913f1d8b5b$var$sentryClient = importedSentry;
};
const $024249913f1d8b5b$var$getSentryClient = async ()=>{
    if (!$024249913f1d8b5b$var$sentryClient) // this only happens if something using sentry before the initialisation in root app
    await $024249913f1d8b5b$export$d8bd0edf6c978788();
    return $024249913f1d8b5b$var$sentryClient;
};
const $024249913f1d8b5b$export$f86b2a1a2ce291b3 = async ({ exception: exception, name: name, tags: tags })=>{
    const sentryClient = await $024249913f1d8b5b$var$getSentryClient();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.withScope((scope)=>{
        scope.setTag('name', name);
        if (tags) scope.setTags(tags);
        if (tags?.source === 'aiMateExperienceTracker') scope.setTag('experience', name);
        try {
            sentryClient.captureException(exception, scope);
        } catch (error) {
        // this function throws e.update is not a function errors when we have a mismatch in sentry versions. Instead of throwing and logging the error to sentry, swallow it.
        // TODO: upgrade sentry across confluence, jira, etc. to the same version to avoid this error
        }
    });
};
async function $024249913f1d8b5b$export$de29810e0b4aa46e(crumb) {
    const sentryClient = await $024249913f1d8b5b$var$getSentryClient();
    if (!sentryClient || typeof sentryClient.addBreadcrumb !== 'function') return;
    sentryClient.addBreadcrumb(typeof crumb === 'string' ? {
        message: crumb
    } : crumb);
}
module.exports["setupSentryClient"] = $024249913f1d8b5b$export$d8bd0edf6c978788;
module.exports["logException"] = $024249913f1d8b5b$export$f86b2a1a2ce291b3;
module.exports["addSentryBreadcrumb"] = $024249913f1d8b5b$export$de29810e0b4aa46e;

});

parcelRegister("jTKfH", function(module, exports) {
const $93101e1e1df3fd55$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-trace-id') ?? response?.headers?.get('atl-traceid') ?? response?.headers?.get('x-b3-traceid') ?? undefined;
class $93101e1e1df3fd55$export$26e841bcf1aeb894 extends Error {
    constructor(message, errorAttributes){
        super(message), this.errorAttributes = errorAttributes;
        this.name = 'FetchError';
    }
}
class $93101e1e1df3fd55$var$HttpApiError extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $93101e1e1df3fd55$export$a38d93aa782475f6 = async ({ path: path, options: options })=>{
    try {
        const response = await fetch(path, options);
        if (!response.ok || response.status >= 400) await $93101e1e1df3fd55$var$processHttpErrorResponse({
            response: response
        });
        return await response.json();
    } catch (err) {
        const originalErrorMessage = err instanceof Error ? 'Original error: ' + err.message : 'Unknown error';
        const statusCode = err instanceof $93101e1e1df3fd55$var$HttpApiError ? err?.errorAttributes?.statusCode : undefined;
        throw new $93101e1e1df3fd55$export$26e841bcf1aeb894(`performHttpFetch error while fetching ${path}. ${originalErrorMessage}`, {
            errorCode: 'performHttpFetchError',
            statusCode: statusCode
        });
    }
};
const $93101e1e1df3fd55$var$processHttpErrorResponse = async ({ response: response })=>{
    throw new $93101e1e1df3fd55$var$HttpApiError(`[Code ${response.status}] ${await response.text()}`, {
        statusCode: response.status,
        traceId: $93101e1e1df3fd55$export$9f229e40eb65abfc(response)
    });
};
module.exports["getTraceIdFromResponse"] = $93101e1e1df3fd55$export$9f229e40eb65abfc;
module.exports["FetchError"] = $93101e1e1df3fd55$export$26e841bcf1aeb894;
module.exports["performHttpFetch"] = $93101e1e1df3fd55$export$a38d93aa782475f6;

});

parcelRegister("cj7GQ", function(module, exports) {
const $cfb262a7d2b032b8$export$d4fdfa93c283ffc = ()=>{
    let product = 'UNKNOWN';
    const win = window;
    if (win.__ROVO_CHAT_CONFIG_PRODUCT__) product = win.__ROVO_CHAT_CONFIG_PRODUCT__;
    return product;
};
module.exports["getRovoChatProduct"] = $cfb262a7d2b032b8$export$d4fdfa93c283ffc;

});

parcelRegister("fPSAz", function(module, exports) {
const $155164db85c7fae0$var$pathnamePrefixes = [
    '/jira/',
    '/wiki/',
    '/browse/'
];
const $155164db85c7fae0$var$ATLAS_HOST = 'home.atlassian.com';
const $155164db85c7fae0$var$ATLAS_TEAM_HOST = 'team.atlassian.com';
const $155164db85c7fae0$var$UUID_REGEX = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const $155164db85c7fae0$export$d57ae76c6dc57a5 = (url)=>{
    try {
        let parsedUrl = new URL(url);
        let normalizedPath = '/any/';
        if (parsedUrl.host === $155164db85c7fae0$var$ATLAS_HOST || parsedUrl.host === $155164db85c7fae0$var$ATLAS_TEAM_HOST) // Replace org ID with "orgId" in the path
        normalizedPath = parsedUrl.pathname.replace(/\/o\/[^/]+/, '/o/orgId');
        const prefixRegex = new RegExp(`^(${$155164db85c7fae0$var$pathnamePrefixes.join('|')})`);
        if (prefixRegex.test(parsedUrl.pathname)) normalizedPath = parsedUrl.pathname.match(prefixRegex)[0];
        const normalizedUrl = `${parsedUrl.protocol}//${parsedUrl.host}${normalizedPath}`;
        return normalizedUrl;
    } catch (error) {
        return 'https://could-not-parse.example.com';
    }
};
const $155164db85c7fae0$export$5efaf8444170fe75 = (str)=>{
    if (!str) return {
        normalized: '',
        matchedUUIDs: []
    };
    const matchedUUIDs = str.match($155164db85c7fae0$var$UUID_REGEX) || [];
    const normalized = str.replace($155164db85c7fae0$var$UUID_REGEX, '{uuid}');
    return {
        normalized: normalized,
        matchedUUIDs: matchedUUIDs
    };
};
module.exports["normaliseUrl"] = $155164db85c7fae0$export$d57ae76c6dc57a5;
module.exports["normalizeUUID"] = $155164db85c7fae0$export$5efaf8444170fe75;

});

parcelRegister("Ou0Zz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7TCQz = parcelRequire("7TCQz");

var $9DHhW = parcelRequire("9DHhW");


var $ixfCV = parcelRequire("ixfCV");


var $cXLoX = parcelRequire("cXLoX");


var $hlvTd = parcelRequire("hlvTd");


var $89QZA = parcelRequire("89QZA");


var $eMlr8 = parcelRequire("eMlr8");


var $1jIs1 = parcelRequire("1jIs1");


var $nl5f2 = parcelRequire("nl5f2");

const $0fbd029e2a18e798$var$isTownSquareEvent = ()=>[
        'home.atlassian.com',
        'team.atlassian.com'
    ].some((host)=>window.location?.host?.includes(host));
const $0fbd029e2a18e798$var$DEFAULT_TAGS = [
    'atlaskit',
    'aiMate'
];
const $0fbd029e2a18e798$export$e955abb82869dc84 = (options)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { propertiesRef: propertiesRef, mode: mode } = (0, $89QZA.useAnalyticsPropertiesContext)();
    // TODO: Improve this functionality, potentially with a higher order provider for tags or similar
    // This is a temporary solution to add the 'townsquare' tag to operational events so Experience Tracker works in Atlas
    const maybeAtlasOperationalTags = (0, $cozmU.useCallback)((inputPayload)=>{
        const payload = (0, $7TCQz.isUIAnalyticsEvent)(inputPayload) ? inputPayload.payload : inputPayload;
        if (payload.actionSubject === 'ui' && payload.eventType === 'operational' && $0fbd029e2a18e798$var$isTownSquareEvent()) return [
            'townsquare'
        ];
        return [];
    }, []);
    const tagsForAIAnalytics = [
        ...$0fbd029e2a18e798$var$DEFAULT_TAGS
    ];
    if ($0fbd029e2a18e798$var$isTownSquareEvent()) tagsForAIAnalytics.push('townsquare');
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss, trackAIResultAction: trackAIResultAction, trackAIResultAdopted: trackAIResultAdopted, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $cXLoX.useAIEventsInstrumentation)({
        // Required configruation
        product: propertiesRef.current.product,
        subproduct: propertiesRef.current.product,
        aiFeatureName: 'aiChat',
        proactiveGeneratedAI: 0,
        userGeneratedAI: 1,
        enablePlatformEvents: true,
        tags: tagsForAIAnalytics,
        skipAISessionValidation: options?.skipAISessionValidation,
        customAnalyticsFire: (rawEvent, _createdEvent)=>{
            // Build event and apply context attributes
            const event = createAnalyticsEvent(rawEvent);
            if (!event) // In SSR / no-listener environments, `createAnalyticsEvent` can return `undefined`.
            // Nothing to fire.
            return;
            const aiMateContextAttributes = (0, $nl5f2.getAttributesFromContexts)(event.context);
            // Fire. `event.update(...)` returns `undefined` for stub events (no `<AnalyticsListener>`
            // mounted, e.g. during SSR), so fall back to the original event and guard `.fire` with
            // optional chaining.
            const updatedEvent = event.update({
                attributes: {
                    ...event.payload?.attributes ?? {},
                    ...aiMateContextAttributes
                }
            }) ?? event;
            updatedEvent?.fire?.((0, $1jIs1.ANALYTICS_CHANNEL));
        }
    });
    const getDefaultAttributes = (0, $cozmU.useCallback)(()=>{
        const { agentCreatorType: agentCreatorType, agentId: agentId, agentVisibility: agentVisibility, agentExternalConfigReference: agentExternalConfigReference, agentActions: agentActions, agentIsDefault: agentIsDefault, agentIsVerified: agentIsVerified, conversationChannelId: conversationChannelId, experienceId: experienceId, fullScreen: fullScreen, product: product, productHeader: productHeader, inProductExperience: inProductExperience, mode: mode_0, assistanceServiceConfigMinionAlias: assistanceServiceConfigMinionAlias, spaceId: spaceId } = propertiesRef.current;
        return {
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentCreatorType]: agentCreatorType,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentId]: agentId,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentVisibility]: agentVisibility,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).conversationChannelId]: conversationChannelId,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).experienceId]: experienceId,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).fullScreen]: fullScreen,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).product]: product,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).productHeader]: productHeader,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).inProductExperience]: inProductExperience,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).singleInstrumentationID]: conversationChannelId,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentExternalConfigReference]: agentExternalConfigReference,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentActions]: agentActions,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentIsDefault]: agentIsDefault,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).agentIsVerified]: agentIsVerified,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).mode]: mode_0,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).assistanceServiceConfigMinionAlias]: assistanceServiceConfigMinionAlias,
            [(0, $eMlr8.AI_MATE_ATTRIBUTES).spaceId]: spaceId
        };
    }, [
        propertiesRef
    ]);
    const trackAIMAUEvent = (0, $cozmU.useCallback)((payload_0)=>{
        // Handle tags
        const tags = [
            ...$0fbd029e2a18e798$var$DEFAULT_TAGS
        ];
        if ($0fbd029e2a18e798$var$isTownSquareEvent()) tags.push('townsquare');
        const { source: sourceUnknown, subjectId: subjectIdUnknown, proactive: proactive, userGenerated: userGenerated, doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, messageId: messageId, messageActions: messageActions, singleInstrumentationID: singleInstrumentationID, deepResearchEnabled: deepResearchEnabled, webSearchEnabled: webSearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, timestamp: timestamp, citedProductList: citedProductList, citedProduct: citedProduct, connectorInfo: connectorInfo, sourceProducts: sourceProducts, sourceProduct: sourceProduct, pluginsInvoked: pluginsInvoked, tools: tools, skillsInvoked: skillsInvoked, executedStratusSkill: executedStratusSkill, responseSources: responseSources, usesJsm: usesJsm, invokedFrom: invokedFrom, conversationChannelId: conversationChannelId_0, assistanceServiceConfigMinionAlias: assistanceServiceConfigMinionAlias_0, scenarioId: scenarioId, pageContext: pageContext, viewContext: viewContext, attributes: customAttributes } = payload_0;
        // source and subjectId are optional in the payload type but trackAI* functions require string.
        // The runtime value (including undefined) is intentionally passed through as-is.
        // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing analytics baseline: preserves the runtime value while satisfying a string-only downstream API type.
        const source = sourceUnknown;
        // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing analytics baseline: preserves the runtime value while satisfying a string-only downstream API type.
        const subjectId = subjectIdUnknown;
        let attributes = {
            ...getDefaultAttributes(),
            isAIFeature: 1,
            proactiveAIGenerated: proactive ? 1 : 0,
            userGeneratedAI: userGenerated ? 1 : 0,
            citedProductList: citedProductList,
            citedProduct: citedProduct,
            sourceProducts: sourceProducts,
            sourceProduct: sourceProduct,
            ...customAttributes,
            aiFeatureName: customAttributes?.aiFeatureName || 'aiChat'
        };
        if (messageId) attributes.messageId = messageId;
        if (messageActions) attributes.messageActions = messageActions;
        if (invokedFrom) attributes.invokedFrom = invokedFrom;
        if (timestamp) attributes.timestamp = timestamp;
        if (singleInstrumentationID) attributes.singleInstrumentationID = singleInstrumentationID;
        if (pluginsInvoked) attributes.pluginsInvoked = pluginsInvoked;
        if (tools) attributes.tools = tools;
        if (skillsInvoked) attributes.skillsInvoked = skillsInvoked;
        if (executedStratusSkill !== undefined) attributes.executedStratusSkill = executedStratusSkill;
        if (responseSources) attributes.responseSources = responseSources;
        if (connectorInfo && (0, $ixfCV.fg)('rovo_chat_connector_info_analytics')) attributes.connectorInfo = connectorInfo;
        if (usesJsm !== undefined) attributes.usesJsm = usesJsm;
        if (deepResearchEnabled) attributes.deepResearchEnabled = deepResearchEnabled;
        if (fastModeEnabled) attributes.fastModeEnabled = fastModeEnabled;
        if (thinkDeeperEnabled) attributes.thinkDeeperEnabled = thinkDeeperEnabled;
        if (webSearchEnabled) attributes.webSearchEnabled = webSearchEnabled;
        if (conversationChannelId_0) attributes.conversationChannelId = conversationChannelId_0;
        if (assistanceServiceConfigMinionAlias_0) attributes.assistanceServiceConfigMinionAlias = assistanceServiceConfigMinionAlias_0;
        if (pageContext) attributes.pageContext = pageContext;
        if (scenarioId) attributes.scenarioId = scenarioId;
        if (viewContext) attributes.viewContext = viewContext;
        let libAttributes = {
            ...attributes,
            aiFeatureName: customAttributes?.aiFeatureName || 'aiChat',
            proactiveGeneratedAI: proactive ? 1 : 0
        };
        switch(payload_0.type){
            case 'initiated':
                trackAIInteractionInit({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'viewed':
                trackAIResultView({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId,
                    doesNotMeetMAUCriteria: doesNotMeetMAUCriteria
                });
                break;
            case 'error':
                trackAIResultError({
                    aiErrorMessage: payload_0.errorMessage
                }, {
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'dismissed':
                trackAIInteractionDismiss({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'actioned':
                {
                    const actionedPayload = payload_0;
                    trackAIResultAction(actionedPayload.actionResult, {
                        attributes: libAttributes,
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                }
            case 'adopted':
                {
                    const adoptedPayload = payload_0;
                    trackAIResultAdopted(adoptedPayload.actionResult, {
                        attributes: {
                            ...libAttributes,
                            actionKey: adoptedPayload.actionKey,
                            rovoModifiedObjects: adoptedPayload.rovoModifiedObjects
                        },
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                }
            case 'feedback':
                {
                    const feedbackPayload = payload_0;
                    trackAIFeedbackSubmit(feedbackPayload.feedbackResult, {
                        attributes: libAttributes,
                        tags: tags,
                        source: source,
                        actionSubjectId: subjectId
                    });
                    break;
                }
        }
    // Handle specific AI MAU events
    }, [
        getDefaultAttributes,
        trackAIInteractionInit,
        trackAIResultView,
        trackAIResultError,
        trackAIInteractionDismiss,
        trackAIResultAction,
        trackAIResultAdopted,
        trackAIFeedbackSubmit
    ]);
    const sendAnalyticsEvent = (0, $cozmU.useCallback)((payload_1, options_0)=>{
        const extraTags = options_0?.removeDefaultTags ? [] : $0fbd029e2a18e798$var$DEFAULT_TAGS;
        const allTags = Array.from(new Set([
            ...extraTags,
            ...'tags' in payload_1 && Array.isArray(payload_1.tags) ? payload_1.tags : [],
            ...maybeAtlasOperationalTags(payload_1)
        ]));
        const defaultAttributes = getDefaultAttributes();
        // `UIAnalyticsEvent | undefined` because in SSR (no `<AnalyticsListener>`),
        // `createAnalyticsEvent` and `event.update(...)` may return `undefined` stubs.
        let eventToBeLoggedWithSentry;
        if ((0, $7TCQz.isUIAnalyticsEvent)(payload_1)) {
            const aiMateContextAttributes_0 = (0, $nl5f2.getAttributesFromContexts)(payload_1.context);
            // `payload.update(...)` can return `undefined` for stub events in SSR / no-listener
            // contexts. Fall back to the original event and guard `.fire` with optional chaining.
            const updatedEvent_0 = payload_1.update({
                ...payload_1.payload,
                tags: allTags,
                attributes: {
                    ...defaultAttributes,
                    // `payload.payload` is typed as defined on a UIAnalyticsEvent, but during SSR
                    // (and other no-listener contexts) the underlying event can be a stub whose
                    // `payload` is `undefined`. Guard the spread so the subscriber does not throw
                    // `Cannot read properties of undefined (reading 'attributes')`.
                    ...payload_1.payload?.attributes ?? {},
                    ...aiMateContextAttributes_0
                }
            }) ?? payload_1;
            updatedEvent_0?.fire?.((0, $1jIs1.ANALYTICS_CHANNEL));
            eventToBeLoggedWithSentry = updatedEvent_0;
        } else {
            const event_0 = createAnalyticsEvent({
                ...payload_1,
                tags: allTags,
                attributes: {
                    ...defaultAttributes,
                    ...payload_1.attributes
                }
            });
            if (!event_0) // In SSR / no-listener environments, `createAnalyticsEvent` can return `undefined`.
            // Nothing to fire or log.
            return;
            const aiMateContextAttributes_1 = (0, $nl5f2.getAttributesFromContexts)(event_0.context);
            // `event.update(...)` can return `undefined` for stub events in SSR / no-listener
            // contexts (previously crashed with `Cannot read properties of undefined (reading
            // 'fire')`). Fall back to the original event and guard `.fire` with optional chaining.
            const updatedEvent_1 = event_0.update({
                attributes: {
                    // `event.payload` is normally defined when `createAnalyticsEvent` is wired up
                    // via `<AnalyticsListener>`, but in SSR (where no listener is mounted) the
                    // returned event can be a stub whose `payload` is `undefined`. Spreading
                    // without a guard previously crashed the ExperienceTracker subscriber with
                    // `Cannot read properties of undefined (reading 'attributes')`.
                    ...event_0.payload?.attributes ?? {},
                    ...aiMateContextAttributes_1
                }
            }) ?? event_0;
            updatedEvent_1?.fire?.((0, $1jIs1.ANALYTICS_CHANNEL));
            eventToBeLoggedWithSentry = updatedEvent_1;
        }
        if (eventToBeLoggedWithSentry && eventToBeLoggedWithSentry.payload?.eventType !== 'operational') // choosing to log the event with Sentry if it is not an operational event to prevent noise in Sentry and not eat up the Sentry quota
        (0, $hlvTd.addSentryBreadcrumb)(`sendAnalyticsEvent event: ${JSON.stringify(eventToBeLoggedWithSentry)}`);
    }, [
        createAnalyticsEvent,
        maybeAtlasOperationalTags,
        getDefaultAttributes
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent,
        trackAIMAUEvent: trackAIMAUEvent,
        mode: mode
    };
};
module.exports["useAnalytics"] = $0fbd029e2a18e798$export$e955abb82869dc84;

});

parcelRegister("7TCQz", function(module, exports) {
/// <reference types="node" />

var $dgpXm = parcelRequire("dgpXm");

const $6cd011fc484d182c$export$35f8383928ba8d7 = (obj)=>obj instanceof (0, $dgpXm.default) || !!obj?._isUIAnalyticsEvent || // Backwards compatibility with older analytics-next packages
    obj?.constructor?.name === 'UIAnalyticsEvent';
module.exports["isUIAnalyticsEvent"] = $6cd011fc484d182c$export$35f8383928ba8d7;

});

parcelRegister("cXLoX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3U8XR = parcelRequire("3U8XR");

parcelRequire("fmu9K");
var $iTJtk = parcelRequire("iTJtk");


var $9DHhW = parcelRequire("9DHhW");


var $ixfCV = parcelRequire("ixfCV");


var $1np6T = parcelRequire("1np6T");


var $hBkQ2 = parcelRequire("hBkQ2");


var $lcvnm = parcelRequire("lcvnm");


var $dYyT0 = parcelRequire("dYyT0");


var $aZXY4 = parcelRequire("aZXY4");

const $64e125d19f27d2ae$export$ddf49ad062368ad2 = (customConfig)=>{
    let context = (0, $cozmU.useContext)((0, $1np6T.AIEventsInstrumentationContext));
    const aiEventAttributesOverride = (0, $cozmU.useRef)({});
    if (customConfig) context = {
        config: {
            ...(0, $hBkQ2.defaultAIEventsInstrumentationConfigValues),
            ...customConfig
        },
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ...(0, $aZXY4.useAIInstrumentationSetup)(customConfig.singleInstrumentationID, customConfig.cookieSingleInstrumentationConfig)
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    if (context === null) throw new Error('useAIEventsInstrumentation must be used within a AIEventsInstrumentationProvider');
    const { config: { source: source, aiExperienceName: aiExperienceName, aiFeatureName: aiFeatureName, proactiveGeneratedAI: proactiveGeneratedAI, userGeneratedAI: userGeneratedAI, isAIFeature: isAIFeature, channel: channel, subproduct: subproduct, actionSubjectId: actionSubjectId, tags: tags, product: product, eventDispatcherSource: eventDispatcherSource, skipAISessionValidation: skipAISessionValidation, customAnalyticsFire: customAnalyticsFire, additionalAttributes: additionalAttributes, useDefaultGASv3EventSchema: useDefaultGASv3EventSchema, enablePlatformEvents: enablePlatformEvents }, refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = context;
    const validateAndUpdateAISession = (0, $cozmU.useCallback)((nextState)=>{
        const currentAISessionState = getAISessionState();
        return (0, $3U8XR.match)({
            currentState: currentAISessionState,
            nextState: nextState,
            skipAISessionValidation: skipAISessionValidation
        }).with({
            skipAISessionValidation: true
        }, ()=>true).with({
            currentState: (0, $dYyT0.AISessionState).unset,
            nextState: (0, $3U8XR.P).union((0, $dYyT0.AISessionState).viewed, (0, $dYyT0.AISessionState).error, (0, $dYyT0.AISessionState).dismissed)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIInteractionInit()`);
            return false;
        }).with({
            currentState: (0, $dYyT0.AISessionState).initiated,
            nextState: (0, $3U8XR.P).union((0, $dYyT0.AISessionState).submitted, (0, $dYyT0.AISessionState).actioned, (0, $dYyT0.AISessionState).adopted, (0, $dYyT0.AISessionState).discarded)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIResultView()`);
            return false;
        }).otherwise(()=>{
            setAISessionState(nextState);
            return true;
        });
    }, [
        setAISessionState,
        getAISessionState,
        skipAISessionValidation
    ]);
    const fireEventWithOptionalChannel = (0, $cozmU.useCallback)((event)=>{
        if (typeof customAnalyticsFire === 'function') {
            customAnalyticsFire(event, createAnalyticsEvent({}));
            return;
        }
        if (enablePlatformEvents) {
            // it goes thru the aiMate analytics listener to avoid validation per prodcut listener
            // https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/f904f690cf57ef84acad6c7bf1b5bd90ad9cada2/analytics/analytics-listeners/src/atlaskit/process-event.ts#lines-58
            createAnalyticsEvent(event).fire((0, $iTJtk.FabricChannel).aiMate);
            return;
        }
        if (channel) {
            createAnalyticsEvent(event).fire(channel);
            return;
        }
        createAnalyticsEvent(event).fire();
    }, [
        channel,
        customAnalyticsFire,
        createAnalyticsEvent,
        enablePlatformEvents
    ]);
    const createAndMergeEventPayload = (0, $cozmU.useCallback)((payload, partialPayload)=>{
        const singleInstrumentationID = getSingleInstrumentationID();
        const eventPayload = {
            action: payload.action,
            actionSubject: payload.actionSubject,
            actionSubjectId: partialPayload?.actionSubjectId ?? actionSubjectId,
            attributes: {
                aiExperienceName: aiExperienceName,
                aiFeatureName: aiFeatureName,
                proactiveGeneratedAI: proactiveGeneratedAI,
                userGeneratedAI: userGeneratedAI,
                isAIFeature: isAIFeature,
                eventDispatcherSource: eventDispatcherSource,
                singleInstrumentationID: singleInstrumentationID,
                ...payload.attributes,
                ...partialPayload?.attributes,
                ...additionalAttributes,
                ...aiEventAttributesOverride.current
            }
        };
        return (0, $3U8XR.match)({
            product: product,
            channel: channel,
            useDefaultGASv3EventSchema: useDefaultGASv3EventSchema,
            enablePlatformEvents: enablePlatformEvents
        }).with({
            enablePlatformEvents: true
        }, ()=>{
            return {
                eventType: 'track',
                ...eventPayload,
                tags: (0, $lcvnm.getTagsWithPlatformTag)(tags),
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        }).with({
            product: 'confluence',
            channel: (0, $3U8XR.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // confluence event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/confluence/next/packages/analytics/src/analyticsListener.tsx#lines-53
            return {
                type: 'sendTrackEvent',
                data: {
                    ...eventPayload,
                    tags: partialPayload?.tags ?? tags,
                    source: partialPayload?.source ?? source,
                    subproduct: subproduct
                }
            };
        }).with({
            product: 'jira',
            channel: (0, $3U8XR.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // jira event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/jira/src/packages/platform/observability/product-analytics-bridge/src/utils/extract-data-from-event.tsx#lines-164
            // it requires to use no more than 4 properties on the top level of event shape for custom event fire.
            return eventPayload;
        }).otherwise(()=>{
            // for any other product type we should use the default event shape
            // also if there is a custom event channel, we also should use the default event shape
            return {
                eventType: 'track',
                ...eventPayload,
                tags: partialPayload?.tags ?? tags,
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        });
    }, [
        subproduct,
        channel,
        product,
        getSingleInstrumentationID,
        useDefaultGASv3EventSchema,
        source,
        tags,
        eventDispatcherSource,
        actionSubjectId,
        additionalAttributes,
        enablePlatformEvents,
        aiExperienceName,
        aiFeatureName,
        proactiveGeneratedAI,
        userGeneratedAI,
        isAIFeature
    ]);
    const trackAIInteractionInit = (0, $cozmU.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $dYyT0.AISessionState).initiated)) return;
        refreshSingleInstrumentationID(payload?.attributes?.singleInstrumentationID);
        const event = createAndMergeEventPayload({
            action: 'initiated',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        refreshSingleInstrumentationID,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel,
        validateAndUpdateAISession
    ]);
    const trackAIResultView = (0, $cozmU.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $dYyT0.AISessionState).viewed)) return;
        const { doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, attributes: attributes, ...payloadRest } = payload || {};
        const event = createAndMergeEventPayload({
            action: 'viewed',
            actionSubject: 'aiResult'
        }, {
            ...payloadRest,
            attributes: {
                ...attributes,
                doesNotMeetMAUCriteria: !!doesNotMeetMAUCriteria
            }
        });
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultError = (0, $cozmU.useCallback)((error, payload)=>{
        if (!validateAndUpdateAISession((0, $dYyT0.AISessionState).error)) return;
        const event = createAndMergeEventPayload({
            action: 'error',
            actionSubject: 'aiResult',
            attributes: {
                ...error
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIInteractionDismiss = (0, $cozmU.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $dYyT0.AISessionState).dismissed)) return;
        const event = createAndMergeEventPayload({
            action: 'dismissed',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAction = (0, $cozmU.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $dYyT0.AISessionState).actioned)) return;
        const event = createAndMergeEventPayload({
            action: 'actioned',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultDiscarded = (0, $cozmU.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $dYyT0.AISessionState).discarded)) return;
        const event = createAndMergeEventPayload({
            action: 'discarded',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAdopted = (0, $cozmU.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $dYyT0.AISessionState).adopted)) return;
        const event = createAndMergeEventPayload({
            action: 'adopted',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIFeedbackSubmit = (0, $cozmU.useCallback)((aiFeedbackResult, payload)=>{
        if (!validateAndUpdateAISession((0, $dYyT0.AISessionState).submitted)) return;
        const event = createAndMergeEventPayload({
            action: 'submitted',
            actionSubject: 'aiFeedback',
            attributes: {
                aiFeedbackResult: aiFeedbackResult
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const updateAIAttributes = (0, $cozmU.useCallback)((newAttributes)=>{
        aiEventAttributesOverride.current = {
            ...aiEventAttributesOverride.current,
            ...newAttributes
        };
    }, []);
    const baseReturn = {
        updateAIAttributes: updateAIAttributes,
        trackAIInteractionInit: trackAIInteractionInit,
        trackAIResultView: trackAIResultView,
        trackAIResultError: trackAIResultError,
        trackAIResultDiscarded: trackAIResultDiscarded,
        trackAIInteractionDismiss: trackAIInteractionDismiss,
        trackAIResultAction: trackAIResultAction,
        trackAIResultAdopted: trackAIResultAdopted,
        trackAIFeedbackSubmit: trackAIFeedbackSubmit,
        refreshSingleInstrumentationID: refreshSingleInstrumentationID
    };
    // Each `useCallback` above depends on `createAndMergeEventPayload`, which in
    // turn closes over per-render config values (e.g. `additionalAttributes`
    // passed via `customConfig`). When callers spread fresh literals on every
    // render, those callbacks get fresh identities every render too. Consumers
    // that feed them into their own `useCallback` / `useEffect` deps then suffer
    // spurious re-runs — and combined with functional state updaters, this can
    // drive infinite render loops (see Jira CRCS-4870 / OOM regression).
    //
    // Stabilise the entire return surface behind a feature gate.
    const stableReturn = $64e125d19f27d2ae$var$useStableMethods(baseReturn);
    return (0, $ixfCV.fg)('platform_ai_analytics_stable_handler_refs') ? stableReturn : baseReturn;
};
/**
 * Returns an object with the same shape as `methods`, but with every method
 * replaced by a stable wrapper that delegates to the latest version. The
 * wrappers are created once on mount; they always read the freshest closure
 * via a ref, so calls observe the same behaviour as calling the unstable
 * methods directly.
 */ function $64e125d19f27d2ae$var$useStableMethods(methods) {
    const ref = (0, $cozmU.useRef)(methods);
    ref.current = methods;
    return (0, $cozmU.useMemo)(()=>{
        const out = {};
        for (const key of Object.keys(ref.current))out[key] = (...args)=>ref.current[key](...args);
        return out;
    // Wrappers always read from `ref.current`; no deps needed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useAIEventsInstrumentation"] = $64e125d19f27d2ae$export$ddf49ad062368ad2;

});

parcelRegister("3U8XR", function(module, exports) {
const $2d7d8e3cc345803e$var$t = Symbol.for("@ts-pattern/matcher"), $2d7d8e3cc345803e$var$e = Symbol.for("@ts-pattern/isVariadic"), $2d7d8e3cc345803e$var$n = "@ts-pattern/anonymous-select-key", $2d7d8e3cc345803e$var$r = (t)=>Boolean(t && "object" == typeof t), $2d7d8e3cc345803e$var$i = (e)=>e && !!e[$2d7d8e3cc345803e$var$t], $2d7d8e3cc345803e$var$o = (n, s, c)=>{
    if ($2d7d8e3cc345803e$var$i(n)) {
        const e = n[$2d7d8e3cc345803e$var$t](), { matched: r, selections: i } = e.match(s);
        return r && i && Object.keys(i).forEach((t)=>c(t, i[t])), r;
    }
    if ($2d7d8e3cc345803e$var$r(n)) {
        if (!$2d7d8e3cc345803e$var$r(s)) return !1;
        if (Array.isArray(n)) {
            if (!Array.isArray(s)) return !1;
            let t = [], r = [], a = [];
            for (const o of n.keys()){
                const s = n[o];
                $2d7d8e3cc345803e$var$i(s) && s[$2d7d8e3cc345803e$var$e] ? a.push(s) : a.length ? r.push(s) : t.push(s);
            }
            if (a.length) {
                if (a.length > 1) throw new Error("Pattern error: Using `...P.array(...)` several times in a single pattern is not allowed.");
                if (s.length < t.length + r.length) return !1;
                const e = s.slice(0, t.length), n = 0 === r.length ? [] : s.slice(-r.length), i = s.slice(t.length, 0 === r.length ? Infinity : -r.length);
                return t.every((t, n)=>$2d7d8e3cc345803e$var$o(t, e[n], c)) && r.every((t, e)=>$2d7d8e3cc345803e$var$o(t, n[e], c)) && (0 === a.length || $2d7d8e3cc345803e$var$o(a[0], i, c));
            }
            return n.length === s.length && n.every((t, e)=>$2d7d8e3cc345803e$var$o(t, s[e], c));
        }
        return Reflect.ownKeys(n).every((e)=>{
            const r = n[e];
            var a;
            return (e in s || $2d7d8e3cc345803e$var$i(a = r) && "optional" === a[$2d7d8e3cc345803e$var$t]().matcherType) && $2d7d8e3cc345803e$var$o(r, s[e], c);
        });
    }
    return Object.is(s, n);
}, $2d7d8e3cc345803e$var$s = (e)=>{
    var n, o, a;
    return $2d7d8e3cc345803e$var$r(e) ? $2d7d8e3cc345803e$var$i(e) ? null != (n = null == (o = (a = e[$2d7d8e3cc345803e$var$t]()).getSelectionKeys) ? void 0 : o.call(a)) ? n : [] : Array.isArray(e) ? $2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s) : $2d7d8e3cc345803e$var$c(Object.values(e), $2d7d8e3cc345803e$var$s) : [];
}, $2d7d8e3cc345803e$var$c = (t, e)=>t.reduce((t, n)=>t.concat(e(n)), []);
function $2d7d8e3cc345803e$export$ce1e7a33533a73d9(...t) {
    if (1 === t.length) {
        const [e] = t;
        return (t)=>$2d7d8e3cc345803e$var$o(e, t, ()=>{});
    }
    if (2 === t.length) {
        const [e, n] = t;
        return $2d7d8e3cc345803e$var$o(e, n, ()=>{});
    }
    throw new Error(`isMatching wasn't given the right number of arguments: expected 1 or 2, received ${t.length}.`);
}
function $2d7d8e3cc345803e$var$u(t) {
    return Object.assign(t, {
        optional: ()=>$2d7d8e3cc345803e$var$l(t),
        and: (e)=>$2d7d8e3cc345803e$var$m(t, e),
        or: (e)=>$2d7d8e3cc345803e$var$d(t, e),
        select: (e)=>void 0 === e ? $2d7d8e3cc345803e$var$y(t) : $2d7d8e3cc345803e$var$y(e, t)
    });
}
function $2d7d8e3cc345803e$var$h(t) {
    return Object.assign(((t)=>Object.assign(t, {
            [Symbol.iterator] () {
                let n = 0;
                const r = [
                    {
                        value: Object.assign(t, {
                            [$2d7d8e3cc345803e$var$e]: !0
                        }),
                        done: !1
                    },
                    {
                        done: !0,
                        value: void 0
                    }
                ];
                return {
                    next: ()=>{
                        var t;
                        return null != (t = r[n++]) ? t : r.at(-1);
                    }
                };
            }
        }))(t), {
        optional: ()=>$2d7d8e3cc345803e$var$h($2d7d8e3cc345803e$var$l(t)),
        select: (e)=>$2d7d8e3cc345803e$var$h(void 0 === e ? $2d7d8e3cc345803e$var$y(t) : $2d7d8e3cc345803e$var$y(e, t))
    });
}
function $2d7d8e3cc345803e$var$l(e) {
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return void 0 === t ? ($2d7d8e3cc345803e$var$s(e).forEach((t)=>r(t, void 0)), {
                        matched: !0,
                        selections: n
                    }) : {
                        matched: $2d7d8e3cc345803e$var$o(e, t, r),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$2d7d8e3cc345803e$var$s(e),
                matcherType: "optional"
            })
    });
}
const $2d7d8e3cc345803e$var$f = (t, e)=>{
    for (const n of t)if (!e(n)) return !1;
    return !0;
}, $2d7d8e3cc345803e$var$g = (t, e)=>{
    for (const [n, r] of t.entries())if (!e(r, n)) return !1;
    return !0;
};
function $2d7d8e3cc345803e$var$m(...e) {
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return {
                        matched: e.every((e)=>$2d7d8e3cc345803e$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s),
                matcherType: "and"
            })
    });
}
function $2d7d8e3cc345803e$var$d(...e) {
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return $2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s).forEach((t)=>r(t, void 0)), {
                        matched: e.some((e)=>$2d7d8e3cc345803e$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s),
                matcherType: "or"
            })
    });
}
function $2d7d8e3cc345803e$var$p(e) {
    return {
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>({
                        matched: Boolean(e(t))
                    })
            })
    };
}
function $2d7d8e3cc345803e$var$y(...e) {
    const r = "string" == typeof e[0] ? e[0] : void 0, i = 2 === e.length ? e[1] : "string" == typeof e[0] ? void 0 : e[0];
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let e = {
                        [null != r ? r : $2d7d8e3cc345803e$var$n]: t
                    };
                    return {
                        matched: void 0 === i || $2d7d8e3cc345803e$var$o(i, t, (t, n)=>{
                            e[t] = n;
                        }),
                        selections: e
                    };
                },
                getSelectionKeys: ()=>[
                        null != r ? r : $2d7d8e3cc345803e$var$n
                    ].concat(void 0 === i ? [] : $2d7d8e3cc345803e$var$s(i))
            })
    });
}
function $2d7d8e3cc345803e$var$v(t) {
    return "number" == typeof t;
}
function $2d7d8e3cc345803e$var$b(t) {
    return "string" == typeof t;
}
function $2d7d8e3cc345803e$var$w(t) {
    return "bigint" == typeof t;
}
const $2d7d8e3cc345803e$var$S = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return !0;
})), $2d7d8e3cc345803e$var$O = $2d7d8e3cc345803e$var$S, $2d7d8e3cc345803e$var$j = (t)=>Object.assign($2d7d8e3cc345803e$var$u(t), {
        startsWith: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && t.startsWith(n)))));
        },
        endsWith: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && t.endsWith(n)))));
        },
        minLength: (e)=>$2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$b(e) && e.length >= t))(e))),
        length: (e)=>$2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$b(e) && e.length === t))(e))),
        maxLength: (e)=>$2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$b(e) && e.length <= t))(e))),
        includes: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && t.includes(n)))));
        },
        regex: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && Boolean(t.match(n))))));
        }
    }), $2d7d8e3cc345803e$var$K = $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$var$b)), $2d7d8e3cc345803e$var$x = (t)=>Object.assign($2d7d8e3cc345803e$var$u(t), {
        between: (e, n)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t, e)=>$2d7d8e3cc345803e$var$p((n)=>$2d7d8e3cc345803e$var$v(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e < t))(e))),
        gt: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e > t))(e))),
        lte: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e <= t))(e))),
        gte: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e >= t))(e))),
        int: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && Number.isInteger(t)))),
        finite: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && Number.isFinite(t)))),
        positive: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && t > 0))),
        negative: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && t < 0)))
    }), $2d7d8e3cc345803e$var$E = $2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$var$v)), $2d7d8e3cc345803e$var$A = (t)=>Object.assign($2d7d8e3cc345803e$var$u(t), {
        between: (e, n)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t, e)=>$2d7d8e3cc345803e$var$p((n)=>$2d7d8e3cc345803e$var$w(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e < t))(e))),
        gt: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e > t))(e))),
        lte: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e <= t))(e))),
        gte: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e >= t))(e))),
        positive: ()=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$w(t) && t > 0))),
        negative: ()=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$w(t) && t < 0)))
    }), $2d7d8e3cc345803e$var$P = $2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$var$w)), $2d7d8e3cc345803e$var$T = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return "boolean" == typeof t;
})), $2d7d8e3cc345803e$var$B = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return "symbol" == typeof t;
})), $2d7d8e3cc345803e$var$_ = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return null == t;
})), $2d7d8e3cc345803e$var$k = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return null != t;
}));
var $2d7d8e3cc345803e$export$56c0d5a1e737357d = {
    __proto__: null,
    matcher: $2d7d8e3cc345803e$var$t,
    optional: $2d7d8e3cc345803e$var$l,
    array: function(...e) {
        return $2d7d8e3cc345803e$var$h({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>{
                        if (!Array.isArray(t)) return {
                            matched: !1
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const n = e[0];
                        let r = {};
                        if (0 === t.length) return $2d7d8e3cc345803e$var$s(n).forEach((t)=>{
                            r[t] = [];
                        }), {
                            matched: !0,
                            selections: r
                        };
                        const i = (t, e)=>{
                            r[t] = (r[t] || []).concat([
                                e
                            ]);
                        };
                        return {
                            matched: t.every((t)=>$2d7d8e3cc345803e$var$o(n, t, i)),
                            selections: r
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $2d7d8e3cc345803e$var$s(e[0])
                })
        });
    },
    set: function(...e) {
        return $2d7d8e3cc345803e$var$u({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Set)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        }, i = e[0];
                        return {
                            matched: $2d7d8e3cc345803e$var$f(t, (t)=>$2d7d8e3cc345803e$var$o(i, t, r)),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $2d7d8e3cc345803e$var$s(e[0])
                })
        });
    },
    map: function(...e) {
        return $2d7d8e3cc345803e$var$u({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Map)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        var i;
                        if (1 === e.length) throw new Error(`\`P.map\` wasn't given enough arguments. Expected (key, value), received ${null == (i = e[0]) ? void 0 : i.toString()}`);
                        const [s, c] = e;
                        return {
                            matched: $2d7d8e3cc345803e$var$g(t, (t, e)=>{
                                const n = $2d7d8e3cc345803e$var$o(s, e, r), i = $2d7d8e3cc345803e$var$o(c, t, r);
                                return n && i;
                            }),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : [
                            ...$2d7d8e3cc345803e$var$s(e[0]),
                            ...$2d7d8e3cc345803e$var$s(e[1])
                        ]
                })
        });
    },
    intersection: $2d7d8e3cc345803e$var$m,
    union: $2d7d8e3cc345803e$var$d,
    not: function(e) {
        return $2d7d8e3cc345803e$var$u({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>({
                            matched: !$2d7d8e3cc345803e$var$o(e, t, ()=>{})
                        }),
                    getSelectionKeys: ()=>[],
                    matcherType: "not"
                })
        });
    },
    when: $2d7d8e3cc345803e$var$p,
    select: $2d7d8e3cc345803e$var$y,
    any: $2d7d8e3cc345803e$var$S,
    _: $2d7d8e3cc345803e$var$O,
    string: $2d7d8e3cc345803e$var$K,
    number: $2d7d8e3cc345803e$var$E,
    bigint: $2d7d8e3cc345803e$var$P,
    boolean: $2d7d8e3cc345803e$var$T,
    symbol: $2d7d8e3cc345803e$var$B,
    nullish: $2d7d8e3cc345803e$var$_,
    nonNullable: $2d7d8e3cc345803e$var$k,
    instanceOf: function(t) {
        return $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
            return (e)=>e instanceof t;
        }(t)));
    },
    shape: function(t) {
        return $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$export$ce1e7a33533a73d9(t)));
    }
};
class $2d7d8e3cc345803e$export$6c1467edb54d3773 extends Error {
    constructor(t){
        let e;
        try {
            e = JSON.stringify(t);
        } catch (n) {
            e = t;
        }
        super(`Pattern matching error: no pattern matches value ${e}`), this.input = void 0, this.input = t;
    }
}
const $2d7d8e3cc345803e$var$$ = {
    matched: !1,
    value: void 0
};
function $2d7d8e3cc345803e$export$4659b591c19bdf3d(t) {
    return new $2d7d8e3cc345803e$var$I(t, $2d7d8e3cc345803e$var$$);
}
class $2d7d8e3cc345803e$var$I {
    with(...t) {
        if (this.state.matched) return this;
        const e = t[t.length - 1], r = [
            t[0]
        ];
        let i;
        3 === t.length && "function" == typeof t[1] ? i = t[1] : t.length > 2 && r.push(...t.slice(1, t.length - 1));
        let s = !1, c = {};
        const a = (t, e)=>{
            s = !0, c[t] = e;
        }, u = !r.some((t)=>$2d7d8e3cc345803e$var$o(t, this.input, a)) || i && !Boolean(i(this.input)) ? $2d7d8e3cc345803e$var$$ : {
            matched: !0,
            value: e(s ? $2d7d8e3cc345803e$var$n in c ? c[$2d7d8e3cc345803e$var$n] : c : this.input, this.input)
        };
        return new $2d7d8e3cc345803e$var$I(this.input, u);
    }
    when(t, e) {
        if (this.state.matched) return this;
        const n = Boolean(t(this.input));
        return new $2d7d8e3cc345803e$var$I(this.input, n ? {
            matched: !0,
            value: e(this.input, this.input)
        } : $2d7d8e3cc345803e$var$$);
    }
    otherwise(t) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    exhaustive(t = $2d7d8e3cc345803e$var$L) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    run() {
        return this.exhaustive();
    }
    returnType() {
        return this;
    }
    narrow() {
        return this;
    }
    constructor(t, e){
        this.input = void 0, this.state = void 0, this.input = t, this.state = e;
    }
}
function $2d7d8e3cc345803e$var$L(t) {
    throw new $2d7d8e3cc345803e$export$6c1467edb54d3773(t);
}
module.exports["P"] = $2d7d8e3cc345803e$export$56c0d5a1e737357d;
module.exports["match"] = $2d7d8e3cc345803e$export$4659b591c19bdf3d;

});

parcelRegister("1np6T", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $ed34755b639c331c$export$4f059feb37b5835e = (0, $cozmU.createContext)(null);
module.exports["AIEventsInstrumentationContext"] = $ed34755b639c331c$export$4f059feb37b5835e;

});

parcelRegister("hBkQ2", function(module, exports) {

var $dYyT0 = parcelRequire("dYyT0");

const $853e98499c862a1a$export$5013b36eeed4ec19 = {
    isAIFeature: 1,
    actionSubjectId: 'client',
    eventDispatcherSource: (0, $dYyT0.EventDispatcherSources).JSLib,
    skipAISessionValidation: false,
    useDefaultGASv3EventSchema: false,
    enablePlatformEvents: false
};
module.exports["defaultAIEventsInstrumentationConfigValues"] = $853e98499c862a1a$export$5013b36eeed4ec19;

});

parcelRegister("dYyT0", function(module, exports) {
var $d8a67ee3bf0bc4aa$export$af92e0e920a45719 = /*#__PURE__*/ function(AISessionState) {
    AISessionState["unset"] = "[AIInteraction]:UNSET";
    AISessionState["initiated"] = "[AIInteraction]:INITIATED";
    AISessionState["viewed"] = "[AIInteraction]:VIEWED";
    AISessionState["error"] = "[AIInteraction]:ERROR";
    AISessionState["dismissed"] = "[AIInteraction]:DISMISSED";
    AISessionState["actioned"] = "[AIInteraction]:ACTIONED";
    AISessionState["adopted"] = "[AIInteraction]:ADOPTED";
    AISessionState["discarded"] = "[AIInteraction]:DISCARDED";
    AISessionState["submitted"] = "[AIInteraction]:SUBMITTED";
    return AISessionState;
}({});
var $d8a67ee3bf0bc4aa$export$7052d5b66e36f60f = /*#__PURE__*/ function(EventDispatcherSources) {
    EventDispatcherSources["JSLib"] = "name:@atlassian/ai-analytics|language:javascript";
    return EventDispatcherSources;
}({});
module.exports["AISessionState"] = $d8a67ee3bf0bc4aa$export$af92e0e920a45719;
module.exports["EventDispatcherSources"] = $d8a67ee3bf0bc4aa$export$7052d5b66e36f60f;

});

parcelRegister("lcvnm", function(module, exports) {
const $38ecbfbea3adeefa$export$e053e424fcbfebe9 = (tags)=>{
    const defaultTags = [
        'atlaskit'
    ];
    if (!tags) return defaultTags;
    return defaultTags.concat(tags);
};
module.exports["getTagsWithPlatformTag"] = $38ecbfbea3adeefa$export$e053e424fcbfebe9;

});

parcelRegister("aZXY4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gt79r = parcelRequire("gt79r");


var $7aMHy = parcelRequire("7aMHy");


var $dYyT0 = parcelRequire("dYyT0");

const $e169a5b684ca872a$export$259576f4e7ac6488 = (customSingleInstrumentationIDFromUserConfig, cookieSingleInstrumentationConfig)=>{
    const singleInstrumentationIDRef = (0, $cozmU.useRef)(undefined);
    const aiSessionStateRef = (0, $cozmU.useRef)((0, $dYyT0.AISessionState).unset);
    const setAISessionState = (0, $cozmU.useCallback)((nextState)=>{
        aiSessionStateRef.current = nextState;
    }, []);
    const getAISessionState = (0, $cozmU.useCallback)(()=>{
        return aiSessionStateRef.current;
    }, []);
    const refreshSingleInstrumentationID = (0, $cozmU.useCallback)((customSingleInstrumentationIDFromEvent)=>{
        const nextSingleInstrumentationID = (0, $gt79r.getNewSingleInstrumentationID)(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig);
        singleInstrumentationIDRef.current = nextSingleInstrumentationID;
        if (cookieSingleInstrumentationConfig) (0, $7aMHy.setSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName, nextSingleInstrumentationID);
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig
    ]);
    const getSingleInstrumentationID = (0, $cozmU.useCallback)(()=>{
        // this handles a race condition when we have a new singleInstrumentationID from the user config
        // but Provider knows only about the initial singleInstrumentationID. In this case we need to update
        // singleInstrumentationID at first step and then return a new one.
        if (customSingleInstrumentationIDFromUserConfig && customSingleInstrumentationIDFromUserConfig !== singleInstrumentationIDRef.current) {
            refreshSingleInstrumentationID();
            return singleInstrumentationIDRef.current;
        }
        if (cookieSingleInstrumentationConfig) return (0, $7aMHy.readSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName);
        return singleInstrumentationIDRef.current;
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig,
        refreshSingleInstrumentationID
    ]);
    return {
        refreshSingleInstrumentationID: refreshSingleInstrumentationID,
        getSingleInstrumentationID: getSingleInstrumentationID,
        setAISessionState: setAISessionState,
        getAISessionState: getAISessionState
    };
};
module.exports["useAIInstrumentationSetup"] = $e169a5b684ca872a$export$259576f4e7ac6488;

});

parcelRegister("gt79r", function(module, exports) {

var $3U8XR = parcelRequire("3U8XR");


var $iwjSV = parcelRequire("iwjSV");

function $51c6a65b1a5462f5$export$cee2a1482be61648(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig) {
    // priority for setting singleInstrumentationID override rule
    // 1. from consumer event attribute
    // 2. from consumer configuration
    // 3. from cookie lib
    // 4. default behaviour generates through the crypto API
    return (0, $3U8XR.match)({
        customSingleInstrumentationIDFromEvent: customSingleInstrumentationIDFromEvent,
        customSingleInstrumentationIDFromUserConfig: customSingleInstrumentationIDFromUserConfig
    }).with({
        customSingleInstrumentationIDFromEvent: (0, $3U8XR.P).string
    }, (result)=>result.customSingleInstrumentationIDFromEvent).with({
        customSingleInstrumentationIDFromUserConfig: (0, $3U8XR.P).string
    }, (result)=>result.customSingleInstrumentationIDFromUserConfig)// we can't use the crypto API in the browser due to SSR issues?
    // https://atlassian.slack.com/archives/C051ARA9QGH/p1749587419868869
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    .otherwise(()=>(0, (/*@__PURE__*/$parcel$interopDefault($iwjSV)))());
}
module.exports["getNewSingleInstrumentationID"] = $51c6a65b1a5462f5$export$cee2a1482be61648;

});

parcelRegister("7aMHy", function(module, exports) {

var $1Qi0Q = parcelRequire("1Qi0Q");

var $lnexi = parcelRequire("lnexi");

const $924bddecf3b99eb3$export$72d8c154d3f75075 = 'SINGLE_INSTRUMENTATION_ID_IS_NOT_SET';
const $924bddecf3b99eb3$export$35ae1861d13fb6c8 = (uniqueCookieFeatureName)=>`AI_INSTRUMENTATION_FEATURE_ID_${uniqueCookieFeatureName}`;
const $924bddecf3b99eb3$export$9a4eaf99327c19fe = (uniqueCookieFeatureName, nextSingleInstrumentationID)=>(0, $lnexi.setCookie)($924bddecf3b99eb3$export$35ae1861d13fb6c8(uniqueCookieFeatureName), nextSingleInstrumentationID, {
        expires: 7,
        domain: location.hostname,
        sameSite: 'strict'
    });
const $924bddecf3b99eb3$export$d6fb1caea334c7c7 = (uniqueCookieFeatureName)=>(0, $1Qi0Q.getCookie)($924bddecf3b99eb3$export$35ae1861d13fb6c8(uniqueCookieFeatureName)) || $924bddecf3b99eb3$export$72d8c154d3f75075;
module.exports["setSingleInstrumentationIDCookie"] = $924bddecf3b99eb3$export$9a4eaf99327c19fe;
module.exports["readSingleInstrumentationIDCookie"] = $924bddecf3b99eb3$export$d6fb1caea334c7c7;

});

parcelRegister("89QZA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");

const $87e579b14b793016$var$initialState = {
    conversationChannelId: '',
    experienceId: '',
    product: '',
    productHeader: '',
    inProductExperience: '',
    agentId: null,
    agentExternalConfigReference: null,
    agentActions: [],
    agentIsDefault: null,
    agentIsVerified: null,
    fullScreen: false,
    agentCreatorType: '',
    agentVisibility: '',
    singleInstrumentationID: '',
    mode: undefined
};
const $87e579b14b793016$var$AnalyticsPropertiesContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    propertiesRef: {
        current: {
            ...$87e579b14b793016$var$initialState
        }
    },
    mode: undefined,
    setAnalyticsPropertiesWithoutRerender: ()=>{}
});
const $87e579b14b793016$export$5ae3634fdb64882c = /*#__PURE__*/ (0, $cozmU.createContext)({
    sharedFeaturesInstrumentationId: undefined,
    isInSmartCreateFlow: undefined
});
const $87e579b14b793016$export$1aefd27d2ed3c1c9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, mode: mode } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            ...$87e579b14b793016$var$initialState
        };
        $[0] = t1;
    } else t1 = $[0];
    const propertiesRef = (0, $cozmU.useRef)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (properties)=>{
            propertiesRef.current = {
                ...propertiesRef.current,
                ...properties
            };
        };
        $[1] = t2;
    } else t2 = $[1];
    const setAnalyticsPropertiesWithoutRerender = t2;
    let t3;
    if ($[2] !== mode) {
        t3 = {
            propertiesRef: propertiesRef,
            mode: mode,
            setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender
        };
        $[2] = mode;
        $[3] = t3;
    } else t3 = $[3];
    const value = t3;
    let t4;
    if ($[4] !== children || $[5] !== value) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87e579b14b793016$var$AnalyticsPropertiesContext.Provider, {
            value: value
        }, children);
        $[4] = children;
        $[5] = value;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ children: children, mode: mode })=>{
    const propertiesRef = (0, $cozmU.useRef)({
        ...$87e579b14b793016$var$initialState
    });
    const setAnalyticsPropertiesWithoutRerender = (0, $cozmU.useCallback)((properties)=>{
        propertiesRef.current = {
            ...propertiesRef.current,
            ...properties
        };
    }, []);
    const value = (0, $cozmU.useMemo)(()=>({
            propertiesRef: propertiesRef,
            mode: mode,
            setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender
        }), [
        setAnalyticsPropertiesWithoutRerender,
        mode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87e579b14b793016$var$AnalyticsPropertiesContext.Provider, {
        value: value
    }, children);
};
const $87e579b14b793016$export$a00cd3c213413389 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { source: source, sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId, children: children, mode: mode, isAlwaysInSmartCreateFlow: isAlwaysInSmartCreateFlow } = t0;
    const { sharedFeaturesInstrumentationId: parentSharedFeaturesInstrumentationId, isInSmartCreateFlow: parentIsInSmartCreateFlow } = (0, $cozmU.useContext)($87e579b14b793016$export$5ae3634fdb64882c);
    const isInSmartCreateFlow = isAlwaysInSmartCreateFlow === undefined ? parentIsInSmartCreateFlow : isAlwaysInSmartCreateFlow;
    const t1 = sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId;
    let t2;
    if ($[0] !== isInSmartCreateFlow || $[1] !== t1) {
        t2 = {
            sharedFeaturesInstrumentationId: t1,
            isInSmartCreateFlow: isInSmartCreateFlow
        };
        $[0] = isInSmartCreateFlow;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== source || $[4] !== t2) {
        t3 = {
            source: source,
            attributes: t2
        };
        $[3] = source;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    const data = t3;
    const t4 = sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId;
    let t5;
    if ($[6] !== isInSmartCreateFlow || $[7] !== t4) {
        t5 = {
            sharedFeaturesInstrumentationId: t4,
            isInSmartCreateFlow: isInSmartCreateFlow
        };
        $[6] = isInSmartCreateFlow;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== children || $[10] !== mode) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87e579b14b793016$export$1aefd27d2ed3c1c9, {
            mode: mode
        }, children);
        $[9] = children;
        $[10] = mode;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== t5 || $[13] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87e579b14b793016$export$5ae3634fdb64882c.Provider, {
            value: t5
        }, t6);
        $[12] = t5;
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== data || $[16] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
            data: data
        }, t7);
        $[15] = data;
        $[16] = t7;
        $[17] = t8;
    } else t8 = $[17];
    return t8;
} : ({ source: source, sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId, children: children, mode: mode, isAlwaysInSmartCreateFlow: isAlwaysInSmartCreateFlow })=>{
    const { sharedFeaturesInstrumentationId: parentSharedFeaturesInstrumentationId, isInSmartCreateFlow: parentIsInSmartCreateFlow } = (0, $cozmU.useContext)($87e579b14b793016$export$5ae3634fdb64882c);
    const isInSmartCreateFlow = isAlwaysInSmartCreateFlow === undefined ? parentIsInSmartCreateFlow : isAlwaysInSmartCreateFlow;
    const data = (0, $cozmU.useMemo)(()=>({
            source: source,
            attributes: {
                sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId,
                isInSmartCreateFlow: isInSmartCreateFlow
            }
        }), [
        source,
        sharedFeaturesInstrumentationId,
        parentSharedFeaturesInstrumentationId,
        isInSmartCreateFlow
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87e579b14b793016$export$5ae3634fdb64882c.Provider, {
        value: {
            sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId,
            isInSmartCreateFlow: isInSmartCreateFlow
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87e579b14b793016$export$1aefd27d2ed3c1c9, {
        mode: mode
    }, children)));
};
const $87e579b14b793016$export$ab8aa3dfd687f012 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($87e579b14b793016$var$AnalyticsPropertiesContext);
} : ()=>{
    return (0, $cozmU.useContext)($87e579b14b793016$var$AnalyticsPropertiesContext);
};
module.exports["SharedFeaturesInstrumentationIdContext"] = $87e579b14b793016$export$5ae3634fdb64882c;
module.exports["AnalyticsContextWithSourceAndProperties"] = $87e579b14b793016$export$a00cd3c213413389;
module.exports["useAnalyticsPropertiesContext"] = $87e579b14b793016$export$ab8aa3dfd687f012;

});

parcelRegister("eMlr8", function(module, exports) {
/**
 * NOTE: Some of these fields are used to track AI MAU
 * See this page for more details: https://hello.atlassian.net/wiki/spaces/AAI/pages/3770721410/Unified+event+Instrumentation+for+AI
 */ const $49f89fe5a40ece12$export$8cffc8b2c93affd4 = {
    agentCreatorType: 'agentCreatorType',
    agentId: 'agentId',
    agentVisibility: 'agentVisibility',
    agentExternalConfigReference: 'agentExternalConfigReference',
    agentActions: 'agentActions',
    agentIsDefault: 'agentIsDefault',
    agentIsVerified: 'agentIsVerified',
    conversationChannelId: 'conversationChannelId',
    experienceId: 'experienceId',
    fullScreen: 'fullScreen',
    mode: 'mode',
    product: 'product',
    productHeader: 'productHeader',
    inProductExperience: 'inProductExperience',
    singleInstrumentationID: 'singleInstrumentationID',
    sharedFeaturesInstrumentationId: 'sharedFeaturesInstrumentationId',
    assistanceServiceConfigMinionAlias: 'assistanceServiceConfigMinionAlias',
    skillSelectionSource: 'skillSelectionSource',
    // The Rovo Space a chat is scoped to (when any). Set on every event fired
    // while a space-scoped chat is active so "Space MAU" (unique users who
    // initiate a chat in a space) can be measured downstream.
    spaceId: 'spaceId'
};
module.exports["AI_MATE_ATTRIBUTES"] = $49f89fe5a40ece12$export$8cffc8b2c93affd4;

});

parcelRegister("1jIs1", function(module, exports) {
parcelRequire("fmu9K");
var $iTJtk = parcelRequire("iTJtk");

const $70c81957c9ee94b4$export$85183a312807388d = (0, $iTJtk.FabricChannel).aiMate;
const $70c81957c9ee94b4$var$REMIX_SOURCES = [
    'remix',
    'inlineRovoFromRemix',
    'remixModalFromToolbar',
    'remixModalFromBlockControls',
    'remixModalFromBlockMenu',
    'remixModalFromFloatingToolbar',
    'remixModalFromViewPageFloatingToolbar',
    'remixModalFromViewPageNudge',
    'remixModalFromNudge',
    'remixModalFromObjectLevelSidebar',
    'remixModalFromPasteMenu',
    'remixStagingArea',
    'remixModalFromMediaInserts'
];
const $70c81957c9ee94b4$export$e86f3aae41de8a7 = 'smartLinkRovoButton';
const $70c81957c9ee94b4$export$5a1bc70923e441e9 = new Set($70c81957c9ee94b4$var$REMIX_SOURCES);
var $70c81957c9ee94b4$export$406073150b1a408 = /*#__PURE__*/ function(AUTOSUGGEST_SOURCE) {
    AUTOSUGGEST_SOURCE["ROVO_CHAT"] = "rovo-chat";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC"] = "confluence-aifc";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC_SLIDES"] = "confluence-aifc-slides";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC_WHITEBOARD"] = "confluence-aifc-whiteboard";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC_DATABASE"] = "confluence-aifc-database";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC_LIVE_DOC"] = "confluence-aifc-live-doc";
    return AUTOSUGGEST_SOURCE;
}({});
module.exports["ANALYTICS_CHANNEL"] = $70c81957c9ee94b4$export$85183a312807388d;
module.exports["SMART_LINK_ROVO_BUTTON_INTERACTION_SOURCE"] = $70c81957c9ee94b4$export$e86f3aae41de8a7;
module.exports["REMIX_INTERACTION_SOURCES"] = $70c81957c9ee94b4$export$5a1bc70923e441e9;
module.exports["AUTOSUGGEST_SOURCE"] = $70c81957c9ee94b4$export$406073150b1a408;

});

parcelRegister("nl5f2", function(module, exports) {

var $eq1BO = parcelRequire("eq1BO");


var $5oT0d = parcelRequire("5oT0d");

const $0e75beeba4a8395f$var$isSourceAndAttributes = (x)=>{
    if (typeof x !== 'object' || x === null) return false;
    if (!('source' in x) || !('attributes' in x) || typeof x.attributes !== 'object' || x.attributes === null) return false;
    return (0, $5oT0d.ALLOWED_AI_MATE_SOURCES).includes(x.source);
};
const $0e75beeba4a8395f$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    let contextsThatHaveAttributes = context.filter((x)=>$0e75beeba4a8395f$var$isSourceAndAttributes(x) || x[0, $eq1BO.AI_MATE_CONTEXT]);
    return contextsThatHaveAttributes.reduce((acc, x)=>{
        return {
            ...acc,
            ...x[0, $eq1BO.AI_MATE_CONTEXT]?.attributes ?? {},
            ...x.attributes ?? {}
        };
    }, {});
};
module.exports["getAttributesFromContexts"] = $0e75beeba4a8395f$export$d97c97ed77ff09e8;

});

parcelRegister("5oT0d", function(module, exports) {
const $19fd3c58da81b4e5$export$e31e24b63b7085fd = [
    'AIMate',
    'smart-create',
    'CSMAI',
    'CSMAIEmbed',
    'rovoServiceAgent',
    'solutionComposer'
];
module.exports["ALLOWED_AI_MATE_SOURCES"] = $19fd3c58da81b4e5$export$e31e24b63b7085fd;

});

parcelRegister("1XM8n", function(module, exports) {
/**
 * Determines the owning team for a failure event based on the experience task name,
 * error message, and optional attributes (e.g. actionKey).
 *
 * The rules are derived from the AIFC Top Baseline Errors report and use regex matching
 * to handle error messages that contain dynamic values (UUIDs, IDs, hashes, etc).
 *
 * @see https://hello.atlassian.net/wiki/spaces/ac8/pages/6822974693/Apr+13-14+2026+-+AIFC+Top+Baseline+Errors
 */ 
var $irnO2 = parcelRequire("irnO2");

var $8fc2212d0df9a0a6$export$e196c5257e9c94dd = /*#__PURE__*/ function(OwningTeam) {
    OwningTeam["AifcFoundations"] = "AIFC Foundations";
    OwningTeam["EditorAi"] = "Editor AI";
    OwningTeam["RovoChat"] = "Rovo Chat";
    OwningTeam["Whiteboards"] = "Whiteboards";
    OwningTeam["Databases"] = "Databases";
    OwningTeam["JiraAifc"] = "Jira AIFC";
    return OwningTeam;
}({});
/**
 * Step 1 — Experience-specific error rules.
 * These are checked first and only when the experience name matches.
 */ const $8fc2212d0df9a0a6$var$RULES_FOR_SPECIFIC_EXPERIENCES = [
    {
        pattern: /Something went wrong on Rovo's end. Please try sending your message again./i,
        team: "AIFC Foundations",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /The ConfluenceCreationTool was invoked, but valid content was not created for action key:.*whiteboard/i,
        team: "Whiteboards",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /The ConfluenceCreationTool was invoked, but valid content was not created for action key:.*database/i,
        team: "Databases",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /The ConfluenceCreationTool was invoked, but valid content was not created for action key:.*page/i,
        team: "AIFC Foundations",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /The orchestrator reached its depth limit and the ConfluenceCreationTool was not invoked./i,
        team: "AIFC Foundations",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT
        ]
    },
    {
        pattern: /Could not create content of type \w+ in the Confluence staging area./i,
        team: "AIFC Foundations",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT,
            (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT
        ]
    },
    {
        pattern: /Message action error: [Code 400] convoai.rest.bad.request - Failed to update page: missing pageId and ADF content for actionKey:.*/i,
        team: "AIFC Foundations",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_UPDATE_CONTENT
        ]
    },
    {
        pattern: /Message action error: [Code 400] convoai.rest.bad.request - Failed to update page: missing pageId and ADF content for actionKey:.*/i,
        team: "Editor AI",
        experiences: [
            (0, $irnO2.ExperienceName).UPDATE_CONTENT_IN_CHAT
        ]
    },
    {
        pattern: /AIFC stream received edit tags but no elements were affected/i,
        team: "Whiteboards",
        experiences: [
            (0, $irnO2.ExperienceName).AIFC_UPDATE_CONTENT
        ]
    }
];
/**
 * Step 2 — Global error rules that apply across all experiences.
 */ const $8fc2212d0df9a0a6$var$GLOBAL_ERROR_MESSAGE_RULES = [
    {
        pattern: /network error/i,
        team: "Rovo Chat"
    },
    {
        pattern: /An error occurred. Please try again later./i,
        team: "Rovo Chat"
    },
    {
        pattern: /Failed to fetch/i,
        team: "Rovo Chat"
    },
    {
        pattern: /An unknown error occurred/i,
        team: "Rovo Chat"
    },
    {
        pattern: /\[Code 403\] {"code":403,"message":"You're unable to access content because your IP address is not listed in the IP allowlist. Contact your admin for help."}/i,
        team: "Rovo Chat"
    },
    {
        pattern: /AIFC stream received only preamble but no <todo_list>, SVG or whiteboards XML.*/i,
        team: "Whiteboards"
    },
    {
        pattern: /No sizing converter defined for element type 'mindmap'/i,
        team: "Whiteboards"
    },
    {
        pattern: /AIFC stream received edit tags but no elements were affected/i,
        team: "Whiteboards"
    },
    {
        pattern: /Could not find database:/i,
        team: "Databases"
    }
];
/**
 * Step 3 — Default team ownership per experience.
 * Used as a fallback when no error-pattern rule matches.
 */ const $8fc2212d0df9a0a6$var$DEFAULT_TEAM_FOR_EXPERIENCE = new Map([
    [
        (0, $irnO2.ExperienceName).AIFC_FINALIZE_CONTENT,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).AIFC_ALL_DATA_HANDLED,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).AIFC_GENERATE_CONTENT_IN_CHAT,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).AIFC_INITIAL_DATA_RECEIVED,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).AIFC_MODAL_SESSION,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).AIFC_UPDATE_CONTENT,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).UPDATE_CONTENT_IN_CHAT,
        "Editor AI"
    ],
    [
        (0, $irnO2.ExperienceName).PREVIEW_CARD_RENDER,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).PREVIEW_CONTENT,
        "AIFC Foundations"
    ],
    [
        (0, $irnO2.ExperienceName).SEND_MESSAGE,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).SEND_TASK_MODE_MESSAGE,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).SEND_CONFIRMED_TOOLS_TASK_MODE_MESSAGE,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).LOAD_AUTO_SUGGEST_SKILLS_LEGACY,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).LOAD_AUTO_SUGGEST_SKILLS_UNIFIED,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).LOAD_CHAT_PROMPT_INPUT_SKILLS,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).LOAD_INLINE_CHAT_PROMPT_INPUT_SKILLS,
        "Rovo Chat"
    ],
    [
        (0, $irnO2.ExperienceName).JIRA_SAVE_DRAFT_WORK_ITEM,
        "Jira AIFC"
    ],
    [
        (0, $irnO2.ExperienceName).JIRA_CREATE_WORK_ITEMS_BULK,
        "Jira AIFC"
    ]
]);
const $8fc2212d0df9a0a6$export$d6e429d0895093 = (errorMessage, experienceName)=>{
    if (!errorMessage) return $8fc2212d0df9a0a6$var$DEFAULT_TEAM_FOR_EXPERIENCE.get(experienceName);
    // Step 1: Experience-specific error-pattern rules
    if (experienceName) for (const rule of $8fc2212d0df9a0a6$var$RULES_FOR_SPECIFIC_EXPERIENCES){
        if (rule.experiences.includes(experienceName) && rule.pattern.test(errorMessage)) return rule.team;
    }
    // Step 2: Global error-pattern rules
    for (const rule of $8fc2212d0df9a0a6$var$GLOBAL_ERROR_MESSAGE_RULES){
        if (rule.pattern.test(errorMessage)) return rule.team;
    }
    // Step 3: Default team for this experience
    if (experienceName) return $8fc2212d0df9a0a6$var$DEFAULT_TEAM_FOR_EXPERIENCE.get(experienceName);
    return undefined;
};
module.exports["getOwningTeam"] = $8fc2212d0df9a0a6$export$d6e429d0895093;

});

parcelRegister("8YL3U", function(module, exports) {
class $f2446ffb8af04183$export$79c3dc6f15d36f18 {
    onVisibilityChange(isHidden) {
        const now = performance.now();
        if (isHidden) {
            if (this.lastHiddenAt === null) this.lastHiddenAt = now;
            if (this.firstHiddenOffsetMs === null) this.firstHiddenOffsetMs = now - this.startTime;
        } else if (this.lastHiddenAt !== null) {
            this.totalHiddenMs += now - this.lastHiddenAt;
            this.lastHiddenAt = null;
        }
    }
    getAttributes(doc) {
        const now = performance.now();
        const elapsed = now - this.startTime;
        let totalHiddenMs = this.totalHiddenMs;
        if (this.lastHiddenAt !== null) totalHiddenMs += now - this.lastHiddenAt;
        const tabHiddenProportion = elapsed > 0 ? totalHiddenMs / elapsed : 0;
        return {
            isActiveTab: doc ? doc.visibilityState === 'visible' : true,
            tabHiddenProportion: tabHiddenProportion,
            tabFirstHiddenOffsetMs: this.firstHiddenOffsetMs
        };
    }
    constructor(doc){
        this.startTime = void 0;
        this.totalHiddenMs = 0;
        this.lastHiddenAt = void 0;
        this.firstHiddenOffsetMs = void 0;
        this.startTime = performance.now();
        const isHidden = doc?.visibilityState === 'hidden';
        this.lastHiddenAt = isHidden ? this.startTime : null;
        this.firstHiddenOffsetMs = isHidden ? 0 : null;
    }
}
module.exports["TabVisibilityTracker"] = $f2446ffb8af04183$export$79c3dc6f15d36f18;

});

parcelRegister("lhZdS", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $6403ac5c7062c845$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    remixToolbarTooltip: {
        id: "highlight-actions.remix.inline-toolbar-tooltip",
        defaultMessage: "Remix"
    },
    remixToolbarLabel: {
        id: "highlight-actions.remix.inline-toolbar-label",
        defaultMessage: "Remix"
    },
    remixBlockTooltip: {
        id: "block-hover.remix.remix-tooltip",
        defaultMessage: "Remix"
    },
    remixBlockLabel: {
        id: "block-hover.remix.remix-label",
        defaultMessage: "Remix"
    },
    remixDisabledTooltipArchived: {
        id: "highlight-actions.remix.disabled-tooltip-archived",
        defaultMessage: "Content on archived pages can't be remixed"
    },
    remixDisabledTooltipVersionHistory: {
        id: "highlight-actions.remix.disabled-tooltip-version-history",
        defaultMessage: "Remix is unavailable in version history"
    },
    remixInProgressTooltip: {
        id: "highlight-actions.remix.in-progress-tooltip",
        defaultMessage: "Remix in progress..."
    },
    remixToolbarTooltipUpdated: {
        id: "highlight-actions.remix.inline-toolbar-tooltip-updated",
        defaultMessage: "Create a diagram, infographic, and more based on this content"
    },
    remixBlockTooltipUpdated: {
        id: "block-hover.remix.remix-tooltip-updated",
        defaultMessage: "Remix this content into a diagram, infographic, and more"
    },
    flagFinalizeSuccessTitle: {
        id: "editor-plugin-malleable-ui.maui.finalize.flag.success.title",
        defaultMessage: "Whiteboard moved"
    },
    flagFinalizeSuccessDescriptionCurrentPage: {
        id: "editor-plugin-malleable-ui.maui.finalize.flag.success.description.currentPage",
        defaultMessage: "Your diagram\u2019s whiteboard now lives under the current content."
    },
    flagFinalizeSuccessDescriptionPickedSpace: {
        id: "editor-plugin-malleable-ui.maui.finalize.flag.success.description.pickedSpace",
        defaultMessage: "Your diagram\u2019s whiteboard now lives in the space you selected."
    },
    flagFinalizeSpacePickerTitle: {
        id: "editor-plugin-malleable-ui.maui.finalize.flag.spacePicker.title",
        defaultMessage: "Choose where to save whiteboard"
    },
    flagFinalizeSpacePickerDescription: {
        id: "editor-plugin-malleable-ui.maui.finalize.flag.spacePicker.description",
        defaultMessage: "Select a location for this diagram\u2019s whiteboard so others can view it."
    },
    mauiDiagramFinalizeErrorTitle: {
        id: "editor-plugin-malleable-ui.mauiDiagramFinalizeErrorTitle",
        defaultMessage: "Couldn't save diagram to this page"
    },
    mauiDiagramFinalizeErrorDescription: {
        id: "editor-plugin-malleable-ui.mauiDiagramFinalizeErrorDescription",
        defaultMessage: "Something went wrong while saving this diagram. Please check your permissions and try again."
    },
    mauiDiagramFinalizeMissingPageDescription: {
        id: "editor-plugin-malleable-ui.mauiDiagramFinalizeMissingPageDescription",
        defaultMessage: "Could not determine the current page. Please save the page first and try again."
    },
    mauiDiagramMoveErrorTitle: {
        id: "editor-plugin-malleable-ui.mauiDiagramMoveErrorTitle",
        defaultMessage: "Could not move diagram"
    },
    mauiDiagramMoveErrorDescription: {
        id: "editor-plugin-malleable-ui.mauiDiagramMoveErrorDescription",
        defaultMessage: "You don't have permission to add content to this space. Paste it in a different space to make your diagram visible to others and avoid auto removal."
    },
    mauiDiagramPasteErrorTitle: {
        id: "editor-plugin-malleable-ui.mauiDiagramPasteErrorTitle",
        defaultMessage: "Could not paste diagram"
    },
    mauiDiagramPasteErrorDescription: {
        id: "editor-plugin-malleable-ui.mauiDiagramPasteErrorDescription",
        defaultMessage: "You don't have permission to add content to this space. Paste it in a different space."
    },
    mauiAppDuplicatePermissionErrorTitle: {
        id: "editor-plugin-malleable-ui.mauiAppDuplicatePermissionErrorTitle",
        defaultMessage: "You don't have permission to duplicate this component"
    },
    mauiAppDuplicateErrorTitle: {
        id: "editor-plugin-malleable-ui.mauiAppDuplicateErrorTitle",
        defaultMessage: "Could not duplicate component"
    },
    mauiAppDuplicateErrorDescription: {
        id: "editor-plugin-malleable-ui.mauiAppDuplicateErrorDescription",
        defaultMessage: "We couldn't duplicate this component. Please try again."
    },
    subtypeAdjustedFlagTitle: {
        id: "editor-plugin-malleable-ui.subtypeAdjustedFlagTitle",
        defaultMessage: "Output adjusted"
    },
    subtypeAdjustedFlagDescription: {
        id: "editor-plugin-malleable-ui.subtypeAdjustedFlagDescription",
        defaultMessage: "Your selection wasn't compatible with that output, so Rovo picked a new one."
    }
});
module.exports["messages"] = $6403ac5c7062c845$export$defe85febe8b728c;

});

parcelRegister("k6l1W", function(module, exports) {
/**
 * Pre-flight permission probe for the in-embed MAUI space picker.
 *
 * Hits the same `SearchConfluenceSpace.spaceEntity.operations` field
 * the ephemeral preview's `useConfluenceEntities` consumes, so picker
 * behaviour matches Smart Create 1:1.
 *
 * Exposes:
 * - `canCreatePageInSpace(cloudId, spaceKey)` — async permission check.
 * - `getCurrentSpaceSnapshot(cloudId, spaceKey)` — sync getter the picker
 *   uses to fill its `currentSpace` chip from the cache populated as a
 *   side-effect of the async probe.
 *
 * The picker always mounts AFTER the probe has run (it only mounts when
 * the probe returns `false`), so a single shared module-scoped snapshot
 * cache is enough to keep the chip rendering fully populated.
 */ 
var $haiCi = parcelRequire("haiCi");

// Inlined `space` branch of `ListEntitiesQuery` from
// `@atlassian/conversation-assistant-service`.
const $461835022b242a2e$var$ListSpacesWithOperationsQuery = `
query MauiFinalizeListSpacesWithOperations(
	$query: String!
	$siteAri: String!
	$entityAtis: [String!]!
) {
	search {
		search(
			query: $query
			filters: { entities: $entityAtis, locations: [$siteAri] }
			experience: "rovo-chat-message-actions"
		) {
			edges {
				node {
					type
					... on SearchConfluenceSpace {
						id: entityId
						name: title
						key
						iconPath
						spaceEntity {
							type
							operations { operation target }
						}
					}
				}
			}
		}
	}
}
`;
const $461835022b242a2e$var$SPACE_ENTITY_ATIS = [
    'ati:cloud:confluence:space'
];
// Sync snapshot the picker reads from after the async probe resolves.
const $461835022b242a2e$var$snapshots = new Map();
const $461835022b242a2e$var$cacheKey = (cloudId, spaceKey)=>`${cloudId}|${spaceKey}`;
async function $461835022b242a2e$export$f57a733034bffce2(cloudId, spaceKey) {
    if (!cloudId || !spaceKey) return false;
    try {
        const response = await (0, $haiCi.performGqlFetch)({
            gqlQuery: $461835022b242a2e$var$ListSpacesWithOperationsQuery,
            headerOptions: {
                'X-ExperimentalApi': 'confluence-agg-beta'
            },
            variables: {
                query: spaceKey,
                siteAri: `ari:cloud:confluence::site/${cloudId}`,
                entityAtis: $461835022b242a2e$var$SPACE_ENTITY_ATIS
            }
        });
        const edges = response?.data?.search?.search?.edges ?? [];
        for (const edge of edges){
            const node = edge?.node;
            if (node?.type !== 'space' || node.key !== spaceKey || !node.id) continue;
            const canCreate = node.spaceEntity?.operations?.some((op)=>op?.operation === 'CREATE' && op?.target === 'PAGE') ?? false;
            $461835022b242a2e$var$snapshots.set($461835022b242a2e$var$cacheKey(cloudId, spaceKey), {
                canCreatePage: canCreate,
                iconPath: node.iconPath,
                id: node.id,
                key: node.key,
                name: node.name ?? node.key,
                type: node.spaceEntity?.type ?? 'GLOBAL'
            });
            return canCreate;
        }
        return false;
    } catch  {
        return false;
    }
}
function $461835022b242a2e$export$62096b9f2444b8ed(cloudId, spaceKey) {
    return $461835022b242a2e$var$snapshots.get($461835022b242a2e$var$cacheKey(cloudId, spaceKey));
}
module.exports["canCreatePageInSpace"] = $461835022b242a2e$export$f57a733034bffce2;
module.exports["getCurrentSpaceSnapshot"] = $461835022b242a2e$export$62096b9f2444b8ed;

});

parcelRegister("haiCi", function(module, exports) {

var $jTKfH = parcelRequire("jTKfH");

const $a406323faf455711$var$extractQueryName = (gqlQuery)=>{
    const operationMatch = gqlQuery.match(/(?:query|mutation)\s+(\w+)/);
    return operationMatch ? operationMatch[1] : undefined;
};
const $a406323faf455711$export$f602b5befecb0b84 = async ({ gqlQuery: gqlQuery, headerOptions: headerOptions, variables: variables, abortController: abortController })=>{
    try {
        const response = await fetch('/gateway/api/graphql', {
            headers: {
                'Content-Type': 'application/json',
                ...headerOptions
            },
            method: 'POST',
            body: JSON.stringify({
                query: gqlQuery,
                variables: variables
            }),
            signal: abortController?.signal
        });
        const json = await response.json();
        if (json?.errors?.length) await $a406323faf455711$var$processGqlErrorResponse({
            errors: json.errors,
            gqlQuery: gqlQuery
        });
        return json;
    } catch (err) {
        // GqlApiError is already processed
        if (err instanceof $a406323faf455711$export$ba203f24e0131ba7) throw err;
        // Handle abort signal gracefully, it shouldn't be considered an error despite being caught
        if (err instanceof Error && err.name === 'AbortError') return {
            // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing GraphQL abort baseline: abort returns an empty typed success shape for generic callers.
            data: null,
            errors: undefined
        };
        const originalErrorMessage = err instanceof Error ? err.message : 'Unknown error';
        throw new (0, $jTKfH.FetchError)(`GraphQL query failed (promise rejected): ${originalErrorMessage}`, {
            errorCode: 'performGqlFetchError'
        });
    }
};
class $a406323faf455711$export$ba203f24e0131ba7 extends Error {
    constructor({ errors: errors, queryName: queryName }){
        const errorsString = errors.map((error)=>error.message).join(', ');
        const errorMessage = `GraphQL API error: ${errorsString}`;
        super(errorMessage);
        this.message = void 0;
        this.errorAttributes = void 0;
        this.message = errorMessage;
        this.name = 'GraphQLError';
        this.errorAttributes = {
            errorCode: 'GqlApiError',
            queryName: queryName,
            rawErrorMessage: errorMessage,
            errors: errorsString
        };
    }
}
const $a406323faf455711$var$processGqlErrorResponse = async ({ errors: errors, gqlQuery: gqlQuery })=>{
    const errorsToThrow = [];
    errors.forEach((error)=>{
        errorsToThrow.push({
            message: error.message,
            status_code: error.extensions.statusCode,
            classification: error.extensions.classification
        });
    });
    throw new $a406323faf455711$export$ba203f24e0131ba7({
        errors: errorsToThrow,
        queryName: $a406323faf455711$var$extractQueryName(gqlQuery)
    });
};
module.exports["performGqlFetch"] = $a406323faf455711$export$f602b5befecb0b84;
module.exports["GqlApiError"] = $a406323faf455711$export$ba203f24e0131ba7;

});

parcelRegister("etDDt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2sp5n = parcelRequire("2sp5n");


var $ljOiP = parcelRequire("ljOiP");


var $bfDV1 = parcelRequire("bfDV1");

const $65999e09fd854c03$var$experienceIds = [
    'whiteboard',
    'database',
    'maui',
    'page'
];
const $65999e09fd854c03$var$convertNativeEmbedNodeToCard = ({ api: api, localId: localId, url: url })=>{
    if (!localId) return;
    // If there is no URL, delete the node
    if (!url) {
        api?.core?.actions?.execute?.(({ tr: tr })=>{
            const targetNode = api?.localId?.actions?.getNode({
                localId: localId
            });
            if (!targetNode) return tr;
            return tr.delete(targetNode.pos, targetNode.pos + targetNode.node.nodeSize);
        });
        return;
    }
    const schema = api?.core?.sharedState.currentState()?.schema;
    if (!schema) return;
    // Convert the native embed node to an inline card
    const inlineCard = schema.nodeFromJSON({
        type: 'paragraph',
        content: [
            {
                type: 'inlineCard',
                attrs: {
                    url: url
                }
            }
        ]
    });
    api?.localId?.actions?.replaceNode({
        localId: localId,
        value: inlineCard
    });
};
const $65999e09fd854c03$export$bde152d863179cd9 = (api)=>{
    return {
        title: 'Native Embed Fallback',
        type: (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE),
        key: (0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY),
        description: 'Converts native-embed extension into a smart card, when fallback is required.',
        modules: {
            nodes: {
                default: {
                    type: 'extension',
                    render: async ()=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bfDV1.NativeEmbedsFallbackExtension), {
                                ...props,
                                onConvert: ()=>{
                                    $65999e09fd854c03$var$convertNativeEmbedNodeToCard({
                                        api: api,
                                        localId: props.node.localId,
                                        url: (0, $ljOiP.getParameters)(props.node.parameters, 'url')
                                    });
                                }
                            }),
                    // @ts-expect-error This option is experimental and not reflected in the manifest type definition
                    __hideFrame: true
                },
                ...Object.fromEntries($65999e09fd854c03$var$experienceIds.map((experienceId)=>[
                        experienceId,
                        {
                            type: 'extension',
                            render: async ()=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bfDV1.NativeEmbedsFallbackExtension), {
                                        ...props,
                                        onConvert: ()=>{
                                            $65999e09fd854c03$var$convertNativeEmbedNodeToCard({
                                                api: api,
                                                localId: props.node.localId,
                                                url: (0, $ljOiP.getParameters)(props.node.parameters, 'url')
                                            });
                                        }
                                    }),
                            __hideFrame: true
                        }
                    ]))
            }
        }
    };
};
module.exports["createNativeEmbedsFallbackManifest"] = $65999e09fd854c03$export$bde152d863179cd9;

});

parcelRegister("bfDV1", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

parcelRequire("fmu9K");
var $iTJtk = parcelRequire("iTJtk");


var $9DHhW = parcelRequire("9DHhW");


var $ad7Ou = parcelRequire("ad7Ou");


var $krYZG = parcelRequire("krYZG");


var $I7hWB = parcelRequire("I7hWB");


var $1WMy0 = parcelRequire("1WMy0");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");

const $681f5968c5b58c1b$var$messages = (0, $kSwu1.defineMessages)({
    title: {
        id: "native-embeds-fallback-editor-extension.title",
        defaultMessage: "Embed failed to load."
    },
    description: {
        id: "native-embeds-fallback-editor-extension.description",
        defaultMessage: "Something went wrong while loading the content."
    },
    refresh: {
        id: "native-embeds-fallback-editor-extension.refresh",
        defaultMessage: "Refresh"
    }
});
const $681f5968c5b58c1b$var$styles = {
    container: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1osq _4t3i1osq _1tke68cl _bfhkvuon"
};
const $681f5968c5b58c1b$export$6273057fe14fbe87 = ({ onConvert: onConvert })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (!createAnalyticsEvent) return;
        const event = {
            action: (0, $krYZG.ACTION).VIEWED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).NATIVE_EMBED_FALLBACK,
            eventType: (0, $krYZG.EVENT_TYPE).UI
        };
        createAnalyticsEvent(event)?.fire((0, $iTJtk.FabricChannel).editor);
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        testId: "native-embeds-fallback-extension",
        xcss: $681f5968c5b58c1b$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.100",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "small"
    }, formatMessage($681f5968c5b58c1b$var$messages.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        color: "color.text.subtle"
    }, formatMessage($681f5968c5b58c1b$var$messages.description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($1WMy0))),
        onClick: onConvert
    }, formatMessage($681f5968c5b58c1b$var$messages.refresh))));
};
module.exports["NativeEmbedsFallbackExtension"] = $681f5968c5b58c1b$export$6273057fe14fbe87;

});

parcelRegister("7PHx9", function(module, exports) {

var $bdpeX = parcelRequire("bdpeX");


var $fPsyy = parcelRequire("fPsyy");


var $1M1t5 = parcelRequire("1M1t5");


var $872OF = parcelRequire("872OF");

const $d6233c6a28189b9d$export$7e6e8089e041148 = async (intl, editorActions, openConnectionsPanel, createAnalyticsEvent)=>{
    return new (0, $bdpeX.default)([
        await (0, $fPsyy.createChartsExtension)({
            intl: intl,
            editorActions: editorActions,
            createAnalyticsEvent: createAnalyticsEvent,
            externalToolbarItems: openConnectionsPanel ? [
                (0, $1M1t5.getConnectionsToolbarItem)({
                    intl: intl,
                    openConnectionsPanel: openConnectionsPanel,
                    fireAnalytics: (adf)=>(0, $872OF.fireAnalyticsEventForConnectionsButton)(createAnalyticsEvent, adf)
                })
            ] : []
        })
    ]);
};
module.exports["connectChartExtensionProvider"] = $d6233c6a28189b9d$export$7e6e8089e041148;

});

parcelRegister("1M1t5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $bdpeX = parcelRequire("bdpeX");


var $eleTd = parcelRequire("eleTd");


var $3IXUB = parcelRequire("3IXUB");


var $8pcS0 = parcelRequire("8pcS0");


var $872OF = parcelRequire("872OF");

const $8f8eb5112d081276$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    toolbarItemLabel: {
        id: "app-referentiality.provider.toolbar.item.label",
        defaultMessage: "Manage connected data"
    }
});
const $8f8eb5112d081276$export$1b65aa3790d4a1ee = ({ intl: intl, openConnectionsPanel: openConnectionsPanel, fireAnalytics: fireAnalytics })=>({
        key: 'connections',
        label: intl.formatMessage($8f8eb5112d081276$export$a7357cdd1f0b0168.toolbarItemLabel),
        display: 'icon',
        tooltip: intl.formatMessage($8f8eb5112d081276$export$a7357cdd1f0b0168.toolbarItemLabel),
        icon: ()=>{
            return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eleTd))), {
                    spacing: "spacious",
                    label: intl.formatMessage($8f8eb5112d081276$export$a7357cdd1f0b0168.toolbarItemLabel)
                });
        },
        action: async (adf)=>{
            const localId = adf.attrs?.localId;
            if (localId) {
                openConnectionsPanel(localId);
                fireAnalytics(adf);
            }
        }
    });
const $8f8eb5112d081276$var$getTableContextualToolbar = ({ intl: intl, openConnectionsPanel: openConnectionsPanel, createAnalyticsEvent: createAnalyticsEvent })=>({
        context: {
            type: 'node',
            nodeType: 'table'
        },
        toolbarItems: [
            $8f8eb5112d081276$export$1b65aa3790d4a1ee({
                intl: intl,
                openConnectionsPanel: openConnectionsPanel,
                fireAnalytics: (adf)=>(0, $872OF.fireAnalyticsEventForConnectionsButton)(createAnalyticsEvent, adf)
            })
        ]
    });
const $8f8eb5112d081276$var$getConnectContextualToolbars = async ({ intl: intl, openConnectionsPanel: openConnectionsPanel, createAnalyticsEvent: createAnalyticsEvent })=>{
    const allMacros = await (0, $3IXUB.getMacroMetaData)();
    // All macros support referentiality
    const allMacrosWithRefDataSchema = allMacros.filter((macro)=>macro.pluginKey === 'com.atlassian.plugins.atlassian-connect-plugin' && (macro.refDataSchema?.inputType || macro.refDataSchema?.outputType));
    return allMacrosWithRefDataSchema.reduce((acc, macro)=>{
        const context = {
            type: 'extension',
            nodeType: 'extension',
            extensionKey: macro.macroName,
            extensionType: (0, $8pcS0.EXTENSION_TYPE).MACRO_CORE
        };
        return [
            ...acc,
            {
                context: context,
                toolbarItems: [
                    $8f8eb5112d081276$export$1b65aa3790d4a1ee({
                        intl: intl,
                        openConnectionsPanel: openConnectionsPanel,
                        fireAnalytics: (adf)=>(0, $872OF.fireAnalyticsEventForConnectionsButton)(createAnalyticsEvent, adf)
                    })
                ]
            }
        ];
    }, []);
};

const $8f8eb5112d081276$export$43c4531a8498e016 = async ({ intl: intl, openConnectionsPanel: openConnectionsPanel = ()=>null, createAnalyticsEvent: createAnalyticsEvent })=>{
    return new (0, $bdpeX.default)([
        {
            title: 'Referentiality',
            type: 'com.atlassian.confluence.referentiality',
            key: 'referentiality',
            icons: {
                '48': ()=>Promise.resolve((parcelRequire("6Ec6w")))
            },
            modules: {
                contextualToolbars: [
                    $8f8eb5112d081276$var$getTableContextualToolbar({
                        intl: intl,
                        openConnectionsPanel: openConnectionsPanel,
                        createAnalyticsEvent: createAnalyticsEvent
                    }),
                    ...await $8f8eb5112d081276$var$getConnectContextualToolbars({
                        intl: intl,
                        openConnectionsPanel: openConnectionsPanel,
                        createAnalyticsEvent: createAnalyticsEvent
                    })
                ]
            }
        }
    ]);
};
module.exports["getConnectionsToolbarItem"] = $8f8eb5112d081276$export$1b65aa3790d4a1ee;
module.exports["referentialityExtensionProvider"] = $8f8eb5112d081276$export$43c4531a8498e016;

});

parcelRegister("3IXUB", function(module, exports) {

var $8eAX8 = parcelRequire("8eAX8");


var $6OgRG = parcelRequire("6OgRG");


var $l21Jh = parcelRequire("l21Jh");

const $a3d4cd842e4cfa1b$var$loadMacroMetadata = (0, $8eAX8.createMetadataLoader)();
function $a3d4cd842e4cfa1b$export$e08f75a9d86fcdf4(browserConfig) {
    return (0, $l21Jh.autoConvert)($a3d4cd842e4cfa1b$export$82582a527779c20, browserConfig);
}
const $a3d4cd842e4cfa1b$export$82582a527779c20 = async ()=>{
    const macros = await $a3d4cd842e4cfa1b$var$loadMacroMetadata();
    const isAllowed = (0, $6OgRG.isAllowedWithFeatureFlags)();
    return macros.filter((macroMetadata)=>{
        if (macroMetadata.hidden) return false;
        return isAllowed(macroMetadata);
    });
};
module.exports["getAutoConverter"] = $a3d4cd842e4cfa1b$export$e08f75a9d86fcdf4;
module.exports["getMacroMetaData"] = $a3d4cd842e4cfa1b$export$82582a527779c20;

});

parcelRegister("8eAX8", function(module, exports) {

var $k5ycH = parcelRequire("k5ycH");


var $cpjd2 = parcelRequire("cpjd2");


var $8n9tL = parcelRequire("8n9tL");


var $64KID = parcelRequire("64KID");


var $9fLxI = parcelRequire("9fLxI");

const $d0091e97ce884599$var$MACRO_STATIC_CONNECT_WRM_RESOURCES = [
    'wr!com.atlassian.confluence.plugins.confluence-view-file-macro:view-file-macro-resources'
];
const $d0091e97ce884599$var$MACRO_DEFAULT_WRM_RESOURCES = [
    'wr!confluence.web.resources:view-content',
    'wr!confluence.macros.advanced:get-more'
];
const $d0091e97ce884599$export$1d71148f13231a96 = ()=>[
        // transitional and implicit dependencies
        'wrc!com.atlassian.confluence.extra.team-calendars:amd',
        'wrc!com.atlassian.confluence.extra.team-calendars:user-timezone-setup',
        // editor context
        'wrc!com.atlassian.confluence.extra.team-calendars:calendar-init-editor',
        // macro-browser (not loaded by macro browser for some reason)
        'wrc!com.atlassian.confluence.extra.team-calendars:macro-browser-web-resources'
    ];
function $d0091e97ce884599$export$c3c980ae518bc695(webresources, macroRenderedOutputFromSSR, macroOutput, callback, scriptContainer, unavailableCallback) {
    const defaultWrmResources = $d0091e97ce884599$var$MACRO_DEFAULT_WRM_RESOURCES;
    const staticConnectWrmResources = $d0091e97ce884599$var$MACRO_STATIC_CONNECT_WRM_RESOURCES;
    let deps = [], jsTags;
    if (macroRenderedOutputFromSSR || macroOutput) deps = [
        ...defaultWrmResources
    ];
    else {
        if (!webresources) return Promise.resolve();
        jsTags = webresources?.tags?.js ?? null;
        const contexts = !jsTags || !scriptContainer ? webresources.contexts && webresources.contexts.map((context)=>`wrc!${context}`) || [] : [];
        const keys = !jsTags || !scriptContainer ? webresources.keys && webresources.keys.map((key)=>`wr!${key}`) || [] : [];
        deps = [
            ...defaultWrmResources,
            ...staticConnectWrmResources,
            ...contexts,
            ...keys
        ];
    }
    return new Promise((resolve)=>{
        (0, $cpjd2.requireLegacyWRM)(deps, ()=>{
            // Callback
            if (callback) callback();
            if (scriptContainer && jsTags) (0, $k5ycH.loadResources)(scriptContainer, jsTags).then(resolve);
            else resolve();
        }, ()=>{
            // Unavailable Callback
            // eslint-disable-next-line no-console
            console.error(`Cannot loadMacroWebResources: ${deps}`);
            if (unavailableCallback) unavailableCallback();
        });
    });
}
function $d0091e97ce884599$export$a144665563142e() {
    let macrosMetadataCache = null;
    const macrosMetadataSpaceAwareCache = {};
    return async function metadataLoader() {
        const spaceKey = $d0091e97ce884599$var$getSpaceKey();
        if (spaceKey) {
            if (!macrosMetadataSpaceAwareCache[spaceKey]) macrosMetadataSpaceAwareCache[spaceKey] = $d0091e97ce884599$var$fetchMacroMetadata(spaceKey);
            return macrosMetadataSpaceAwareCache[spaceKey];
        }
        if (!macrosMetadataCache) macrosMetadataCache = $d0091e97ce884599$var$fetchMacroMetadata();
        return macrosMetadataCache;
    };
}
function $d0091e97ce884599$var$getSpaceKey() {
    const pageUrl = window.location.toString();
    const match = (0, $8n9tL.findAndMatchRoute)((0, $64KID.namedRoutes), pageUrl);
    // There's a race condition when the space key is not yet available in AJS upon
    // calling metadataLoader, therefore we fallback to the space key in the URL.
    return window.AJS?.Meta?.get('space-key') || match?.params?.spaceKey;
}
function $d0091e97ce884599$var$fetchMacroMetadata(spaceKey) {
    return (0, $9fLxI.getExtensionManifest)({
        spaceKey: spaceKey
    }).then((manifest)=>{
        const macros = manifest?.macros || [];
        return macros;
    });
}
module.exports["teamCalendarWRM"] = $d0091e97ce884599$export$1d71148f13231a96;
module.exports["loadMacroWebResources"] = $d0091e97ce884599$export$c3c980ae518bc695;
module.exports["createMetadataLoader"] = $d0091e97ce884599$export$a144665563142e;

});

parcelRegister("k5ycH", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $l6Xaz = parcelRequire("l6Xaz");

const $980b898db1533800$var$logger = (0, $7W8i8.getLogger)('wrm');
function $980b898db1533800$export$d3d08d944062d7e(container, tags, // Process tags as an array of links when linksMode = true
// We don't have tags info in CustomHeaderFooter.
linksMode = false) {
    if (!tags.length) return Promise.resolve();
    const fragment = window.document.createDocumentFragment();
    const promises = (0, $l6Xaz.parseScriptTags)(tags, linksMode).map(({ src: src, ...attributes })=>new Promise((resolve, reject)=>{
            if (window.document.querySelector(`script[data-wrm-key='${attributes['data-wrm-key']}']`)) // next/packages/content-renderer/src/TinyMCEServerFullRenderer.tsx will put script as defer to <head>
            // We don't want to re-initialize those scripts when rehydrate
            resolve(null);
            else {
                const scriptElement = window.document.createElement('script');
                scriptElement.async = false;
                scriptElement.src = src;
                scriptElement.onload = resolve;
                scriptElement.onerror = reject;
                Object.keys(attributes).forEach((attributeKey)=>scriptElement.setAttribute(attributeKey, attributes[attributeKey]));
                fragment.appendChild(scriptElement);
            }
        }));
    container.appendChild(fragment);
    return Promise.all(promises).catch((...args)=>{});
}
module.exports["loadResources"] = $980b898db1533800$export$d3d08d944062d7e;

});

parcelRegister("l6Xaz", function(module, exports) {
const $372ebd682f0fb003$var$SCRIPT_REGEX = /<script([^>]*)\/*>/gi;
// @ts-expect-error - TS1503 Typescript 5.9.2 upgrade
const $372ebd682f0fb003$var$QUOTES_REGEX = RegExp("^([\"']*)(?<value>.*?)\\1$");
const $372ebd682f0fb003$var$SPACE_REGEX = /\s+/;
function $372ebd682f0fb003$export$79fe7bf3ba344d67(tags, linksMode = false, matcher = $372ebd682f0fb003$var$SCRIPT_REGEX) {
    // Parse <script key="value">/script> into { key: "value" }
    if (linksMode) return Array.isArray(tags) ? tags.map((t)=>({
            src: t
        })) : [];
    if (typeof tags !== 'string') return [];
    const result = [];
    for (const [, attributes] of tags.matchAll(matcher))result.push(Object.fromEntries(attributes.split($372ebd682f0fb003$var$SPACE_REGEX).filter((pair)=>pair).map((pair)=>{
        const pos = pair.indexOf('=');
        if (pos !== -1) {
            const key = pair.substring(0, pos);
            const rawValue = pair.substring(pos + 1);
            const match = rawValue.match($372ebd682f0fb003$var$QUOTES_REGEX);
            const value = match?.groups?.value ?? rawValue;
            return [
                key,
                value
            ];
        } else return [
            pair,
            pair
        ];
    })));
    return result;
}
function $372ebd682f0fb003$export$a0d21c5c067fafcf(attributes) {
    // Convert { key: value } to key="value"
    const result = Object.entries(attributes).map(([key, value])=>value && key !== value ? `${key}="${value}"` : key).join(' ');
    return result ? ` ${result}` : '';
}
function $372ebd682f0fb003$export$eccc4243452442c6(tags) {
    // Jquery is always loaded in packages/confluence-frontend-server/templates/html/dashboard-spa-container.js
    // So we need to remove it from the superbatch tags
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).filter((attrs)=>attrs['data-wrm-key'] !== 'com.atlassian.plugins.jquery:jquery').map((attrs)=>`<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attrs)}></script>`).join('\n');
}
function $372ebd682f0fb003$export$a26b30913d2c455f(tags) {
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).map((attributes)=>{
        attributes['defer'] = 'defer';
        return `<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}></script>`;
    }).join('\n');
}
const $372ebd682f0fb003$var$srcExtractor = /src=["'](.*?)["']/gi;
function $372ebd682f0fb003$export$7ffad14b7106f714(jsTags) {
    if (!jsTags) return '';
    return [
        ...jsTags.matchAll($372ebd682f0fb003$var$srcExtractor)
    ].map((match)=>match[1]).filter((src)=>!!src).map((src)=>`<link rel="preload" href="${src}" as="script">`).join('\n');
}
function $372ebd682f0fb003$export$893dc3b18722ac51(resource, asyncScript = false) {
    const nonce = window.__SSR_NONCE_VALUE__;
    const attributes = Array.isArray(resource?.attributes) ? Object.fromEntries(resource.attributes.map((attr)=>[
            attr.key,
            attr.value
        ])) : resource.attributes || {};
    if (resource.type === 'css') return `<link rel="stylesheet" nonce="${nonce}" href="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)} />`;
    else if (resource.type === 'js') return `<script nonce="${nonce}" src="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}${asyncScript ? ' async fetchpriority="high"' : ''}></script>`;
    return '';
}
module.exports["parseScriptTags"] = $372ebd682f0fb003$export$79fe7bf3ba344d67;
module.exports["removeJquery"] = $372ebd682f0fb003$export$eccc4243452442c6;
module.exports["deferScript"] = $372ebd682f0fb003$export$a26b30913d2c455f;
module.exports["convertSuperBatchResourceToTags"] = $372ebd682f0fb003$export$893dc3b18722ac51;

});

parcelRegister("9fLxI", function(module, exports) {
async function $2552b7855153149c$export$573ee875a39e7e73({ spaceKey: spaceKey } = {
    spaceKey: undefined
}) {
    if (spaceKey) {
        var _window;
        const extensionManifestSpaceaware = (_window = window).__EXTENSION_MANIFEST_SPACEAWARE__ || (_window.__EXTENSION_MANIFEST_SPACEAWARE__ = {});
        if (!extensionManifestSpaceaware[spaceKey]) extensionManifestSpaceaware[spaceKey] = $2552b7855153149c$var$fetchExtensionManifests(spaceKey);
        return extensionManifestSpaceaware[spaceKey];
    }
    if (!window.__EXTENSION_MANIFEST__) window.__EXTENSION_MANIFEST__ = $2552b7855153149c$var$fetchExtensionManifests();
    return window.__EXTENSION_MANIFEST__;
}
function $2552b7855153149c$var$fetchExtensionManifests(spaceKey) {
    // eslint-disable-next-line check-credentials-option/has-credentials-option,no-restricted-syntax
    return fetch(`/wiki/plugins/macrobrowser/browse-macros.action?detailed=true&origin=extension-provider${spaceKey ? `&spaceKey=${spaceKey}` : ''}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((response)=>response.json());
}
module.exports["getExtensionManifest"] = $2552b7855153149c$export$573ee875a39e7e73;

});

parcelRegister("6OgRG", function(module, exports) {
// This blocklist should reflect what is in https://pug.jira-dev.com/wiki/spaces/AEC/pages/3239608672/Macro+blocklist so if you want to add or remove something, please remember to update the page.
const $38fb99c52e3447fe$var$blocklist = {
    align: true,
    bgcolor: true,
    center: true,
    cheese: true,
    clickable: true,
    code: true,
    colgroup: true,
    column: true,
    'content-by-user': true,
    copyright: true,
    'create-space-button': true,
    div: true,
    expand: true,
    'fancy-bullets': true,
    'google-drive-docs': true,
    'google-drive-sheets': true,
    'google-drive-slides': true,
    favpages: true,
    'gadget-b7a6531b1c147f2e175f1209bed5c0ad': true,
    'gadget-01c2ed272e88f7333da124a03a481477': true,
    'gadget-d2450e06a9a285cf57eedb2d502d9d65b964eb847382938b6c57809bac2261bb': true,
    'global-reports': true,
    highlight: true,
    htmlcomment: true,
    im: true,
    img: true,
    info: true,
    junitreport: true,
    li: true,
    loremipsum: true,
    lozenge: true,
    multimedia: true,
    navmap: true,
    network: true,
    noformat: true,
    note: true,
    ol: true,
    OneDrive: true,
    p: true,
    panel: true,
    pre: true,
    'privacy-policy': true,
    'privacy-mark': true,
    'recently-used-labels': true,
    'reg-tm': true,
    rollover: true,
    roundrect: true,
    search: true,
    section: true,
    sm: true,
    'space-attachments': true,
    'space-details': true,
    span: true,
    status: true,
    strike: true,
    style: true,
    table: true,
    tbody: true,
    td: true,
    th: true,
    thead: true,
    tr: true,
    'trello-board': true,
    'trello-card': true,
    tip: true,
    tm: true,
    ul: true,
    warning: true
};
function $38fb99c52e3447fe$export$1c6721fad2c8cfa0(macroMetadata, blocklistOverrides = {}) {
    const key = macroMetadata.alternateId || (macroMetadata.id ? macroMetadata.id.replace('macro-', '') : macroMetadata.macroName);
    return blocklistOverrides.hasOwnProperty(key) ? blocklistOverrides[key] : Boolean($38fb99c52e3447fe$var$blocklist[key]);
}
function $38fb99c52e3447fe$export$1dba5c5d55fad37f() {
    const overrides = {};
    return (macroMetadata)=>!$38fb99c52e3447fe$export$1c6721fad2c8cfa0(macroMetadata, overrides);
}
async function $38fb99c52e3447fe$export$f38acf7431de7e2b(macroBrowser) {
    const originalList = [
        ...macroBrowser.metadataList
    ];
    // Currently no FF info is needed to create the blocklist but if it was, need to pass featureFlagClient to isAllowedWithFeatureFlags()
    const isAllowed = $38fb99c52e3447fe$export$1dba5c5d55fad37f();
    macroBrowser.metadataList = macroBrowser.metadataList.filter(isAllowed);
    /**
	 * Bring blocklisted items back so they show up elsewhere
	 */ return function restore() {
        macroBrowser.metadataList = originalList;
    };
}
module.exports["isAllowedWithFeatureFlags"] = $38fb99c52e3447fe$export$1dba5c5d55fad37f;
module.exports["applyBlocklist"] = $38fb99c52e3447fe$export$f38acf7431de7e2b;

});

parcelRegister("l21Jh", function(module, exports) {

var $3CRZ9 = parcelRequire("3CRZ9");


var $8PZXE = parcelRequire("8PZXE");

const $159df558ca333321$var$noop = ()=>null;
const $159df558ca333321$export$65b04260b3a15835 = async (loadMacroMetadata, browserConfig)=>{
    const { contentId: contentId } = browserConfig;
    if (!contentId) return $159df558ca333321$var$noop;
    const [jiraAutoConvert, connectAddonAutoConvert] = await Promise.all([
        (0, $3CRZ9.createJiraConverter)(contentId),
        (0, $8PZXE.createConnectAddonConverter)(loadMacroMetadata, contentId)
    ]);
    return (link)=>jiraAutoConvert(link) || connectAddonAutoConvert(link);
};
module.exports["autoConvert"] = $159df558ca333321$export$65b04260b3a15835;

});

parcelRegister("3CRZ9", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $1i7uI = parcelRequire("1i7uI");


var $foRF9 = parcelRequire("foRF9");


var $6mEZ3 = parcelRequire("6mEZ3");

function $3fcae9e87e9104a7$var$convertLink(link, defaultJiraMacroAttributes) {
    const noop = ()=>{};
    const legacyHandler = (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).require('confluence/jim/editor-plugins/jira-paste-link');
    // jira paste handler needs object in this format
    const uri = {
        source: link
    };
    const jimPasteHandlerResult = legacyHandler.pasteHandler(uri, null, noop);
    if (!jimPasteHandlerResult || !jimPasteHandlerResult.params) return null;
    /**
	 * use JSON.parse , JSON.stringify to deeply clone object, avoid any reference
	 */ const macroAttributes = JSON.parse(JSON.stringify(defaultJiraMacroAttributes));
    if (!macroAttributes.attrs.parameters) macroAttributes.attrs.parameters = {};
    macroAttributes.attrs.parameters.macroParams = (0, $6mEZ3.wrapMacroParams)(jimPasteHandlerResult.params);
    return macroAttributes;
}
async function $3fcae9e87e9104a7$export$2264c7423a8e6d34(contentId) {
    const placeholderMacro = {
        macroDefinition: {
            name: 'jira'
        },
        contentId: contentId
    };
    // fetch ADF structure of JIM, and modify it to provide to editor later
    const jiraADFNode = await (0, $foRF9.fetchMacroAttributes)(placeholderMacro);
    return (link)=>$3fcae9e87e9104a7$var$convertLink(link, jiraADFNode);
}
module.exports["createJiraConverter"] = $3fcae9e87e9104a7$export$2264c7423a8e6d34;

});

parcelRegister("foRF9", function(module, exports) {

var $aoRTi = parcelRequire("aoRTi");


var $8pcS0 = parcelRequire("8pcS0");


var $fgbpl = parcelRequire("fgbpl");


var $aMlgD = parcelRequire("aMlgD");


var $6mEZ3 = parcelRequire("6mEZ3");

const $5faed47790e8728c$var$isBlueprint = (contentId)=>!/^[0-9]+$/.test(contentId);
const $5faed47790e8728c$export$74ec65bf601b5f8c = async (options)=>{
    const { macroDefinition: macroDefinition, contentId: contentId, selectedMacro: selectedMacro, intl: intl } = options;
    const results = await (0, $aoRTi.experimentalMacroPlaceholderADFQuery)({
        variables: {
            contentId: $5faed47790e8728c$var$isBlueprint(contentId) ? '0' : contentId ?? '0',
            macroDefinition: JSON.stringify(macroDefinition)
        }
    });
    let placeholderAdf;
    try {
        if (results?.data) placeholderAdf = JSON.parse(results?.data?.experimentalMacroPlaceholderADF?.json);
    } catch  {
        // eslint-disable-next-line no-console
        console.error('Error getting placeholder ADF');
    }
    const adf = {
        ...placeholderAdf
    };
    if ((0, $fgbpl.isBodiedExtension)(adf.type)) {
        if (selectedMacro) // Copy the macro contents into the adf node
        adf.content = selectedMacro.content;
        else if (!adf.content || adf.content.length === 0) {
            if (adf.type === (0, $8pcS0.BODIED_EXTENSION_TYPE)) adf.content = (0, $8pcS0.EMPTY_ADF_CONTENT);
            if (adf.type === (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE)) adf.content = (0, $8pcS0.MULTI_BODIED_INITIAL_CONTENT);
        }
    }
    const macroAttributes = (0, $6mEZ3.formatAsMacroAttributes)(adf);
    if (intl) {
        const macroTitleOverride = (0, $aMlgD.getMacroTitleOverride)(macroDefinition.name, intl);
        if (macroTitleOverride && macroAttributes.attrs.parameters?.macroMetadata) macroAttributes.attrs.parameters.macroMetadata.title = macroTitleOverride;
    }
    return macroAttributes;
};
module.exports["fetchMacroAttributes"] = $5faed47790e8728c$export$74ec65bf601b5f8c;

});

parcelRegister("aoRTi", function(module, exports) {

var $iS5Ay = parcelRequire("iS5Ay");


var $aBfpe = parcelRequire("aBfpe");


var $hBkCm = parcelRequire("hBkCm");

const $fef05c831d419c6c$export$145bdd0c11f23103 = async ({ variables: variables })=>{
    const result = await (0, $iS5Ay.experimentalQuery)({
        url: '/wiki/rest/internal/1.0/macro/placeholder',
        method: 'POST',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        body: JSON.stringify({
            macro: JSON.parse(variables.macroDefinition),
            contentId: variables.contentId
        }),
        parseResponseOnError: (error)=>{
            if ((0, $hBkCm.BadStatusError).isBadStatusError(error)) return {
                __badStatusError: true
            };
            throw error;
        },
        parseResult: (json)=>{
            if (json && typeof json === 'object' && '__badStatusError' in json) return {
                experimentalMacroPlaceholderADF: {
                    json: ''
                }
            };
            return {
                experimentalMacroPlaceholderADF: {
                    json: JSON.stringify(json)
                }
            };
        },
        variables: variables
    });
    return {
        data: result.data
    };
};
module.exports["experimentalMacroPlaceholderADFQuery"] = $fef05c831d419c6c$export$145bdd0c11f23103;

});

parcelRegister("iS5Ay", function(module, exports) {

var $c6StJ = parcelRequire("c6StJ");


var $6fil2 = parcelRequire("6fil2");


var $1RY07 = parcelRequire("1RY07");


var $GLgaM = parcelRequire("GLgaM");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");


var $bjeS8 = parcelRequire("bjeS8");

async function $7002390fd45cd24e$export$ca7e5505c9b1be25({ url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, fetchPolicy: fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'none', skip: skip = false, onError: onError, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, ignoreNoNetworkError: ignoreNoNetworkError, transformError: transformError }) {
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    const fetchData = async ()=>{
        try {
            const json = await (0, $GLgaM.fetchResponse)({
                url: url,
                method: method,
                body: body,
                headers: headers,
                credentials: credentials,
                parseResponseOnSuccess: parseResponseOnSuccess,
                parseResponseOnError: parseResponseOnError
            }, variables);
            return await parseResult(json, variables);
        } catch (error) {
            if (ignoreNoNetworkError && (0, $6fil2.containsNetworkError)(error)) return undefined;
            throw error;
        }
    };
    const storeInstance = (0, $c6StJ.defaultRegistry).getStore((0, $7ji4X.queryStateStore));
    const getCachedData = ()=>{
        const queryState = storeInstance.storeState.getState();
        return queryState[key]?.data;
    };
    const setCachedData = (data)=>{
        storeInstance.actions.setQueryState(key, {
            data: data,
            loading: false,
            error: undefined,
            called: true
        });
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $1RY07.apolloCompatibleQuery)({
        fetchData: fetchData,
        fetchPolicy: fetchPolicy,
        errorPolicy: errorPolicy,
        skip: skip,
        getCachedData: getCachedData,
        setCachedData: setCachedData,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalQuery"] = $7002390fd45cd24e$export$ca7e5505c9b1be25;

});

parcelRegister("1RY07", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");

async function $32cd044d306ca797$export$642c5b07a008cc22({ fetchData: fetchData, fetchPolicy: fetchPolicy, errorPolicy: errorPolicy = 'none', skip: skip = false, onCompleted: onCompleted, onError: onError, getCachedData: getCachedData, setCachedData: setCachedData, convertToApolloError: convertToApolloError }) {
    if (skip) return {
        data: undefined,
        error: undefined
    };
    // cache-first / store-or-network: return cached data if it exists or fetch from network
    if ((fetchPolicy === 'cache-first' || fetchPolicy === 'store-or-network') && getCachedData) {
        const cachedData = getCachedData();
        if (cachedData !== undefined) {
            onCompleted?.(cachedData);
            return {
                data: cachedData,
                error: undefined
            };
        }
    }
    // cache-and-network: return cached data immediately, fetch in background
    if (fetchPolicy === 'cache-and-network' && getCachedData) {
        const cachedData = getCachedData();
        if (cachedData !== undefined) {
            fetchData().catch(()=>{});
            onCompleted?.(cachedData);
            return {
                data: cachedData,
                error: undefined
            };
        }
    }
    // network-only or cache miss: fetch from network
    try {
        const data = await fetchData();
        if (fetchPolicy !== 'no-cache' && setCachedData) await setCachedData(data);
        onCompleted?.(data);
        return {
            data: data,
            error: undefined
        };
    } catch (error) {
        const apolloError = await Promise.resolve(convertToApolloError(error));
        if (apolloError.graphQLErrors?.length) apolloError.graphQLErrors.forEach((e)=>{
            (0, $7Sm4c.processError)(e);
        });
        onError?.(apolloError);
        if (errorPolicy === 'all') return {
            data: undefined,
            error: apolloError
        };
        // errorPolicy === 'none': throw the error
        throw apolloError;
    }
}
module.exports["apolloCompatibleQuery"] = $32cd044d306ca797$export$642c5b07a008cc22;

});

parcelRegister("7ji4X", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $67e5a1fc9f6e62d4$export$c6060eb21313da7c = {
    data: undefined,
    loading: false,
    error: undefined,
    called: false
};
const $67e5a1fc9f6e62d4$export$baa1629d06692c30 = {
    data: undefined,
    loading: true,
    error: undefined,
    called: true
};
const $67e5a1fc9f6e62d4$var$Store = (0, $8s9DV.createStore)({
    initialState: {},
    actions: {
        setQueryState: (key, state)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                const prevState = currentState[key] || $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
                const newState = typeof state === 'function' ? state(prevState) : state;
                setState({
                    ...currentState,
                    [key]: newState
                });
            }
    },
    name: 'useExperimentalQueryState'
});
const $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a = (0, $kBr4q.createActionsHook)($67e5a1fc9f6e62d4$var$Store);
const $67e5a1fc9f6e62d4$export$39156bd8f00c1e38 = (0, $kBr4q.createStateHook)($67e5a1fc9f6e62d4$var$Store, {
    selector: (state, params)=>state[params.key]
});
const $67e5a1fc9f6e62d4$export$14d57088f5885a49 = $67e5a1fc9f6e62d4$var$Store;
module.exports["INITIAL_IDLE_STATE"] = $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
module.exports["INITIAL_LOADING_STATE"] = $67e5a1fc9f6e62d4$export$baa1629d06692c30;
module.exports["useExperimentalQueryStateActions"] = $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a;
module.exports["useExperimentalQueryState"] = $67e5a1fc9f6e62d4$export$39156bd8f00c1e38;
module.exports["queryStateStore"] = $67e5a1fc9f6e62d4$export$14d57088f5885a49;

});

parcelRegister("6l6jb", function(module, exports) {
function $459f9fedb053e25e$export$a4f9b7f788f9e71f(params) {
    const { url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables } = params;
    return $459f9fedb053e25e$var$canonicalStringify({
        url: typeof url === 'function' ? url.toString() : url,
        method: typeof method === 'function' ? method.toString() : method,
        headers: headers,
        body: typeof body === 'function' ? body.toString() : body,
        credentials: credentials,
        variables: variables
    });
}
function $459f9fedb053e25e$export$ebaa599ca92b9c11(requestConfigs, variables) {
    const keys = requestConfigs.map((config)=>$459f9fedb053e25e$export$a4f9b7f788f9e71f({
            ...config,
            variables: variables
        })).sort();
    return $459f9fedb053e25e$var$canonicalStringify(keys);
}
// Serializes with sorted object keys for deterministic output
function $459f9fedb053e25e$var$canonicalStringify(value) {
    return JSON.stringify(value, $459f9fedb053e25e$var$canonicalStringifyReplacer);
}
function $459f9fedb053e25e$var$canonicalStringifyReplacer(_key, value) {
    // Ensures we only process plain objects (not arrays, dates, etc.)
    if (value && typeof value === 'object') {
        const proto = Object.getPrototypeOf(value);
        if (proto === Object.prototype || proto === null) {
            const keys = Object.keys(value);
            // If keys are already sorted, return the original value unchanged to avoid unnecessary object creation
            if (keys.every($459f9fedb053e25e$var$everyKeyInOrder)) return value;
            keys.sort();
            const sortedObject = Object.create(proto);
            keys.forEach((key)=>{
                sortedObject[key] = value[key];
            });
            return sortedObject;
        }
    }
    return value;
}
function $459f9fedb053e25e$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}
module.exports["generateCacheKey"] = $459f9fedb053e25e$export$a4f9b7f788f9e71f;
module.exports["generateCacheKeyForMultipleFetches"] = $459f9fedb053e25e$export$ebaa599ca92b9c11;

});

parcelRegister("8pcS0", function(module, exports) {
const $6863c3b6124eda1d$export$2400baf28368a887 = {
    TEMPLATE: 'com.atlassian.confluence.template',
    MACRO_CORE: 'com.atlassian.confluence.macro.core',
    MIGRATION: 'com.atlassian.confluence.migration',
    // used for all macros that use Extension API and require references to be rendered
    MACRO_WITH_REFERENCES: 'com.atlassian.confluence.macro.with.references',
    NATIVE: 'com.atlassian.confluence.native'
};
const $6863c3b6124eda1d$export$8e1715e14eb19dce = {
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__'
};
const $6863c3b6124eda1d$export$a4903313a3329d59 = {
    UNSUPPORTED_EXTENSION: 'unsupportedExtension',
    INVALID_ADF: 'invalidAdf'
};
const $6863c3b6124eda1d$export$84b772adeaf6b683 = 'extension';
const $6863c3b6124eda1d$export$5da07912b4c30471 = 'inlineExtension';
const $6863c3b6124eda1d$export$2af94dcd5e74e23b = 'bodiedExtension';
const $6863c3b6124eda1d$export$43b3eb119fc177ea = 'multiBodiedExtension';
const $6863c3b6124eda1d$export$6e997645168087e1 = [
    {
        content: [],
        type: 'paragraph'
    }
];
const $6863c3b6124eda1d$export$87be616c9ded92ee = [
    {
        type: 'extensionFrame',
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    }
];
const $6863c3b6124eda1d$export$f9804d409e73a2cd = {
    TEMPLATE: 'variable',
    INLINE_EXTERNAL_IMAGE: 'inline-external-image',
    INLINE_MEDIA_IMAGE: 'inline-media-image',
    PRIVACY_MARK: 'privacy-mark',
    ANCHOR: 'anchor',
    PANEL: 'panel',
    SECTION: 'section',
    CHEESE: 'cheese',
    COLUMN: 'column',
    CONTENT_BY_LABEL: 'contentbylabel',
    CONTENT_BY_USER: 'content-by-user',
    CREATE_SPACE_BUTTON: 'create-space-button',
    FAVORITE_PAGES: 'favpages',
    GLOBAL_REPORTS: 'global-reports',
    IM_PRESENCE: 'im',
    LOREMIPSUM: 'loremipsum',
    NAVIGATION_MAP: 'navmap',
    PAGE_TREE: 'pagetree',
    RECENTLY_UPDATED: 'recently-updated',
    RECENTLY_USED_LABELS: 'recently-used-labels',
    SEARCH: 'search',
    SPACE_DETAILS: 'space-details',
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__',
    REDACTED_MACRO_PLACEHOLDER: 'redactedMacroPlaceholder',
    TOC: 'toc',
    LIVE_SEARCH: 'livesearch',
    CREATE_FROM_TEMPLATE: 'create-from-template',
    CONFLUENCE_DATABASES: 'database-extension',
    DETAILS: 'details',
    DETAILS_SUMMARY: 'detailssummary',
    EXPAND: 'expand',
    EXCERPT: 'excerpt',
    EXCERPT_INCLUDE: 'excerpt-include',
    CHILDREN: 'children',
    PROFILE_PICTURE: 'profile-picture',
    PROFILE: 'profile',
    BLOG_POSTS: 'blog-posts',
    INCLUDE: 'include',
    JIRA: 'jira',
    JIRACHART: 'jirachart',
    LEGACY_CONTENT: 'legacy-content',
    TEAM_CALENDARS: 'calendar',
    CONTRIBUTORS: 'contributors',
    IFRAME: 'iframe',
    POPULAR_LABELS: 'popular-labels',
    TASKS_REPORT_MACRO: 'tasks-report-macro',
    NATIVE_EMBED: 'native-embed',
    HIDE: 'hide',
    PAGE_TREE_SEARCH: 'pagetreesearch',
    WIDGET: 'widget',
    CONTENT_REPORT_TABLE: 'content-report-table',
    CHANGE_HISTORY: 'change-history',
    VIEWPDF: 'viewpdf',
    ATTACHMENTS: 'attachments',
    AGENT_MANAGED_BLOCK: 'agent-managed-block'
};
const $6863c3b6124eda1d$export$52ab8a936196819e = [
    'toc',
    'expand',
    'trello-board',
    'status',
    'jiraroadmap'
];
const $6863c3b6124eda1d$export$ab3b6d629a99a505 = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TOC,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.ANCHOR,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.LIVE_SEARCH,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS_SUMMARY,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXPAND,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT_INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CREATE_FROM_TEMPLATE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.REDACTED_MACRO_PLACEHOLDER,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONFLUENCE_DATABASES,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PROFILE_PICTURE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PROFILE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.ATTACHMENTS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.BLOG_POSTS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.RECENTLY_UPDATED,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TEAM_CALENDARS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTRIBUTORS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.IFRAME,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.POPULAR_LABELS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_BY_LABEL,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE_SEARCH,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.WIDGET,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_REPORT_TABLE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHANGE_HISTORY,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.VIEWPDF,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TASKS_REPORT_MACRO
];
const $6863c3b6124eda1d$export$77fa9372f916e938 = new Set([
    $6863c3b6124eda1d$export$84b772adeaf6b683,
    $6863c3b6124eda1d$export$5da07912b4c30471,
    $6863c3b6124eda1d$export$2af94dcd5e74e23b
]);
const $6863c3b6124eda1d$export$12c3fa6b8a339bbd = 255;
const $6863c3b6124eda1d$export$3b4caad8695d985a = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHILDREN,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT_INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_BY_LABEL,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.RECENTLY_UPDATED
];
const $6863c3b6124eda1d$export$b700e56f703b191 = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHILDREN,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS_SUMMARY
];
module.exports["EXTENSION_TYPE"] = $6863c3b6124eda1d$export$2400baf28368a887;
module.exports["MIGRATION_EXTENSION_KEYS"] = $6863c3b6124eda1d$export$8e1715e14eb19dce;
module.exports["REGULAR_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$84b772adeaf6b683;
module.exports["INLINE_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$5da07912b4c30471;
module.exports["BODIED_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$2af94dcd5e74e23b;
module.exports["MULTI_BODIED_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$43b3eb119fc177ea;
module.exports["EMPTY_ADF_CONTENT"] = $6863c3b6124eda1d$export$6e997645168087e1;
module.exports["MULTI_BODIED_INITIAL_CONTENT"] = $6863c3b6124eda1d$export$87be616c9ded92ee;
module.exports["EXTENSION_KEY"] = $6863c3b6124eda1d$export$f9804d409e73a2cd;
module.exports["allowedMacrosForInsertMenu"] = $6863c3b6124eda1d$export$52ab8a936196819e;
module.exports["serverRenderedExtensions"] = $6863c3b6124eda1d$export$ab3b6d629a99a505;
module.exports["supportedExtensions"] = $6863c3b6124eda1d$export$77fa9372f916e938;
module.exports["MAX_ATLASSIAN_ALLOWED_FRAGMENT_LENGTH"] = $6863c3b6124eda1d$export$12c3fa6b8a339bbd;
module.exports["MODERENIZED_MACRO_KEYS"] = $6863c3b6124eda1d$export$3b4caad8695d985a;
module.exports["MACROS_WITH_LIVE_DOC_REFERENCE"] = $6863c3b6124eda1d$export$b700e56f703b191;

});

parcelRegister("fgbpl", function(module, exports) {

var $8pcS0 = parcelRequire("8pcS0");

const $aba988feb2cb54c3$export$b05e83f63451e97 = (extensionType)=>{
    return [
        (0, $8pcS0.BODIED_EXTENSION_TYPE),
        (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE)
    ].indexOf(extensionType) >= 0;
};
module.exports["isBodiedExtension"] = $aba988feb2cb54c3$export$b05e83f63451e97;

});

parcelRegister("aMlgD", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $9wGTI = parcelRequire("9wGTI");


var $8pcS0 = parcelRequire("8pcS0");

const $123431e233f03ed6$var$i18n = (0, $kSwu1.defineMessages)({
    anchorMacroTitle: {
        id: "fabric-extension-lib.anchor.title",
        defaultMessage: "Anchor link"
    },
    anchorMacroDescription: {
        id: "fabric-extension-lib.anchor.description",
        defaultMessage: "Create a link to anywhere"
    },
    childrenMacroTitle: {
        id: "fabric-extension-lib.children.live-docs.title",
        defaultMessage: "Child items (Child pages)"
    },
    childrenMacroDescription: {
        id: "fabric-extension-lib.children.live-docs.description",
        defaultMessage: "Display a custom list of content nested under a page or live doc."
    },
    detailsMacroTitle: {
        id: "fabric-extension-lib.details.live-docs.title",
        defaultMessage: "Content properties (Page properties)"
    },
    detailsMacroDescription: {
        id: "fabric-extension-lib.details.live-docs.description",
        defaultMessage: "Enter a table of summary information in this macro and display it on another page or live doc using a content properties report macro. You will need to add a label to this content and specify it in the report macro."
    },
    pageTreeMacroTitle: {
        id: "fabric-extension-lib.pagetree.live-docs.title",
        defaultMessage: "Content tree (Page tree)"
    },
    pageTreeMacroDescription: {
        id: "fabric-extension-lib.pagetree.live-docs.description",
        defaultMessage: "Display a full or partial content tree."
    },
    includeMacroTitle: {
        id: "fabric-extension-lib.include.live-docs.title",
        defaultMessage: "Include content (Include page)"
    },
    includeMacroDescription: {
        id: "fabric-extension-lib.include.live-docs.description",
        defaultMessage: "Display the full contents of a page or live doc."
    },
    detailsSummaryMacroTitle: {
        id: "fabric-extension-lib.details-summary.live-docs.title",
        defaultMessage: "Content properties report (Page properties report)"
    },
    detailsSummaryMacroDescription: {
        id: "fabric-extension-lib.details-summary.live-docs.description",
        defaultMessage: "Display a table of pages and live docs that contain a content properties macro and a specific label. The table includes a link to each item and the summary from the macro on that page or doc."
    },
    jiraMacroTitle: {
        id: "fabric-extension-lib.jira.title",
        defaultMessage: "Jira Data Center"
    },
    jiraMacroDescription: {
        id: "fabric-extension-lib.jira.description",
        defaultMessage: "Insert Jira work items from Data Center via JQL"
    }
});
const $123431e233f03ed6$export$f37635a5fac054ef = (extensionKey, intl)=>{
    // Override new macro title for anchor macro
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).ANCHOR) return intl.formatMessage($123431e233f03ed6$var$i18n.anchorMacroTitle);
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).JIRA && (0, $9wGTI.fg)('jim-renaming-to-jira-dc-macro')) return intl.formatMessage($123431e233f03ed6$var$i18n.jiraMacroTitle);
    if ((0, $8pcS0.MACROS_WITH_LIVE_DOC_REFERENCE).includes(extensionKey)) switch(extensionKey){
        case (0, $8pcS0.EXTENSION_KEY).CHILDREN:
            return intl.formatMessage($123431e233f03ed6$var$i18n.childrenMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).PAGE_TREE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.pageTreeMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).INCLUDE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.includeMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS_SUMMARY:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsSummaryMacroTitle);
    }
    return null;
};
const $123431e233f03ed6$export$d82ae1b0fd434097 = (extensionKey, intl)=>{
    // Override new macro title and description for anchor macro
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).ANCHOR) return intl.formatMessage($123431e233f03ed6$var$i18n.anchorMacroDescription);
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).JIRA && (0, $9wGTI.fg)('jim-renaming-to-jira-dc-macro')) return intl.formatMessage($123431e233f03ed6$var$i18n.jiraMacroDescription);
    // PGXT-7617 Update macro strings referencing page content types to also include live docs content types
    if ((0, $8pcS0.MACROS_WITH_LIVE_DOC_REFERENCE).includes(extensionKey)) switch(extensionKey){
        case (0, $8pcS0.EXTENSION_KEY).CHILDREN:
            return intl.formatMessage($123431e233f03ed6$var$i18n.childrenMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).PAGE_TREE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.pageTreeMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).INCLUDE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.includeMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS_SUMMARY:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsSummaryMacroDescription);
    }
    return null;
};
module.exports["getMacroTitleOverride"] = $123431e233f03ed6$export$f37635a5fac054ef;
module.exports["getMacroDescriptionOverride"] = $123431e233f03ed6$export$d82ae1b0fd434097;

});

parcelRegister("6mEZ3", function(module, exports) {

var $aMlgD = parcelRequire("aMlgD");


var $8pcS0 = parcelRequire("8pcS0");


var $juS6m = parcelRequire("juS6m");

function $b31b733ebe52245a$export$d80a64b0df71385c(params) {
    if (params.hasOwnProperty('')) return $b31b733ebe52245a$var$getParamValue(params['']) || '';
    return '';
}
function $b31b733ebe52245a$export$1d258479ae5735d7(macroParams = {}) {
    return Object.keys(macroParams).reduce((curr, key)=>{
        const value = $b31b733ebe52245a$var$getParamValue(macroParams[key]);
        if (value !== '') curr[key] = value;
        return curr;
    }, {});
}
function $b31b733ebe52245a$export$80a8efbe6e0eac1d(macroParams = {}) {
    return Object.keys(macroParams).reduce((curr, key)=>{
        const value = $b31b733ebe52245a$var$getParamValue(macroParams[key]);
        if (key !== '' || value !== '') curr[key] = {
            value: value
        };
        return curr;
    }, {});
}
// does every key have a value key inside?
function $b31b733ebe52245a$var$getParamValue(macroParam) {
    if (macroParam?.hasOwnProperty('value')) return macroParam.value;
    return macroParam;
}
function $b31b733ebe52245a$export$a113856a79fa82ca(node) {
    const { type: type, content: content, attrs: attrs, fragmentLocalId: fragmentLocalId, ...rest } = node;
    // There is a discrepancy in docs and implementation of different parts of the code
    // https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence-frontend/pull-requests/30727/overview?commentId=4917242
    const fieldWithMacroParameters = attrs?.parameters ? attrs : rest;
    const { macroParams: macroParams } = fieldWithMacroParameters?.parameters || {};
    const adf = {
        attrs: fieldWithMacroParameters,
        type: type
    };
    if (fragmentLocalId) adf.marks = [
        {
            attrs: {
                localId: fragmentLocalId,
                name: null
            },
            type: 'fragment'
        }
    ];
    // confluence needs to be updated to get rid of bodyType as per
    // https://product-fabric.atlassian.net/wiki/spaces/E/pages/252351342/Splitting+Extension+node+into+three+nodes
    // but for now, the beackend requires it to be sent
    adf.attrs.bodyType = 'none';
    if (type === 'bodiedExtension') {
        adf.content = content && content.length > 0 ? content : [];
        adf.attrs.bodyType = 'rich';
    }
    const keys = Object.keys(adf.attrs);
    keys.forEach((key)=>{
        if (adf.attrs[key] === undefined || adf.attrs[key] === null) delete adf.attrs[key];
    });
    if (adf.attrs?.parameters) adf.attrs.parameters.macroParams = $b31b733ebe52245a$export$80a8efbe6e0eac1d(macroParams);
    return adf;
}
function $b31b733ebe52245a$export$f700a29bb3cb52bb(node) {
    const { attrs: attrs, content: content, type: type } = node;
    const { macroParams: macroParams } = attrs.parameters;
    // MacroAttributes and ADNode are pretty much the same type, but
    // MacroAttributes requires either "extension", "bodiedExtension", "multiBodiedExtension" or
    // "inlineExtension". This check is so we can pass the ADNode as a
    // MacroAttributes, but will default to "extension" if given an unexpected
    // value.
    let extensionType = (0, $8pcS0.REGULAR_EXTENSION_TYPE);
    if ([
        (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE),
        (0, $8pcS0.BODIED_EXTENSION_TYPE),
        (0, $8pcS0.INLINE_EXTENSION_TYPE)
    ].indexOf(type) >= 0) extensionType = type;
    const macroAttributes = {
        type: extensionType,
        attrs: attrs
    };
    if (!macroAttributes.attrs.parameters) macroAttributes.attrs.parameters = {};
    if (content) macroAttributes.content = content;
    macroAttributes.attrs.parameters.macroParams = $b31b733ebe52245a$export$80a8efbe6e0eac1d(macroParams);
    return macroAttributes;
}
async function $b31b733ebe52245a$export$9ebfba63bbffe824(from, to, body, contentIdContext) {
    const queryData = await (0, $juS6m.experimentalContentBodyConvertQuery)(from, to, body, contentIdContext);
    return queryData.experimentalContentBodyConvert?.value;
}
async function $b31b733ebe52245a$export$4f223f6f161fb687(node, intl) {
    const legacyMacro = await $b31b733ebe52245a$export$dc6dc202968f1e29(node);
    legacyMacro.title = node.attrs?.parameters?.macroMetadata?.title;
    if (intl) {
        const description = (0, $aMlgD.getMacroDescriptionOverride)(node.attrs.extensionKey, intl);
        if (description) legacyMacro.description = description;
    }
    return legacyMacro;
}
async function $b31b733ebe52245a$export$dc6dc202968f1e29(node) {
    // just return the node if it's already in legacy format;
    if (node.hasOwnProperty('name') && !node.hasOwnProperty('attrs')) return Promise.resolve(node);
    const adNode = node;
    const { attrs: attrs } = adNode;
    const { extensionKey: extensionKey, parameters: parameters } = attrs || {
        extensionKey: null,
        parameters: {
            macroParams: {},
            macroMetadata: {
                schemaVersion: null
            }
        }
    };
    const { macroParams: macroParams, macroMetadata: macroMetadata } = parameters;
    const type = node.type;
    const name = extensionKey || '';
    const params = $b31b733ebe52245a$export$1d258479ae5735d7(macroParams || {});
    const defaultParameterValue = $b31b733ebe52245a$export$d80a64b0df71385c(macroParams || {});
    const schemaVersion = macroMetadata && macroMetadata.schemaVersion || '1';
    if (!adNode.content || adNode.content.length === 0) return {
        type: type,
        name: name,
        params: params,
        defaultParameterValue: defaultParameterValue,
        schemaVersion: schemaVersion,
        body: ''
    };
    const responseBody = await $b31b733ebe52245a$export$9ebfba63bbffe824('atlas_doc_format', 'storage', JSON.stringify({
        type: 'doc',
        content: adNode.content,
        version: 1
    }));
    return {
        type: type,
        name: name,
        params: params,
        defaultParameterValue: defaultParameterValue,
        schemaVersion: schemaVersion,
        body: responseBody || ''
    };
}
function $b31b733ebe52245a$export$9ca244251d53bbfc(node) {
    const parameters = {
        ...node?.parameters?.macroParams
    };
    if (parameters.__bodyContent) delete parameters.__bodyContent;
    // CEMS-300: To provide a consistent parameter to macro vendors for
    // both the Tiny and Fabric editors, we unwrap the parameter values
    return JSON.stringify($b31b733ebe52245a$export$1d258479ae5735d7(parameters));
}
module.exports["getDefaultParamValue"] = $b31b733ebe52245a$export$d80a64b0df71385c;
module.exports["unwrapMacroParams"] = $b31b733ebe52245a$export$1d258479ae5735d7;
module.exports["wrapMacroParams"] = $b31b733ebe52245a$export$80a8efbe6e0eac1d;
module.exports["extensionToADF"] = $b31b733ebe52245a$export$a113856a79fa82ca;
module.exports["formatAsMacroAttributes"] = $b31b733ebe52245a$export$f700a29bb3cb52bb;
module.exports["convertBody"] = $b31b733ebe52245a$export$9ebfba63bbffe824;
module.exports["formatAsLegacyMacroWithOverrides"] = $b31b733ebe52245a$export$4f223f6f161fb687;
module.exports["getParametersString"] = $b31b733ebe52245a$export$9ca244251d53bbfc;

});

parcelRegister("juS6m", function(module, exports) {

var $iS5Ay = parcelRequire("iS5Ay");


var $aBfpe = parcelRequire("aBfpe");

const $3a3d352db800a7ae$export$4cf4dd4c5ab7075b = async (from, to, body, contentIdContext)=>{
    const variables = {
        from: from,
        to: to,
        body: body,
        contentIdContext: contentIdContext
    };
    const requestBody = {
        representation: from,
        value: body
    };
    const params = new URLSearchParams();
    if (contentIdContext) params.append('contentIdContext', contentIdContext);
    const queryString = params.toString();
    const queryParams = queryString ? `?${queryString}` : '';
    const url = `/wiki/rest/api/contentbody/convert/${to}${queryParams}`;
    const result = await (0, $iS5Ay.experimentalQuery)({
        url: url,
        method: 'POST',
        body: JSON.stringify(requestBody),
        credentials: 'include',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResponseOnSuccess: async (response)=>{
            if (response.ok && response.status === 200) return response.json();
            throw response;
        },
        parseResponseOnError: (error)=>{
            throw new Error(`Conversion HTTP error, status = ${error.status}, message = "${error.statusText}"`);
        },
        parseResult: (response)=>({
                experimentalContentBodyConvert: {
                    value: response.value
                }
            }),
        variables: variables
    });
    return result.data;
};
module.exports["experimentalContentBodyConvertQuery"] = $3a3d352db800a7ae$export$4cf4dd4c5ab7075b;

});

parcelRegister("8PZXE", function(module, exports) {

var $foRF9 = parcelRequire("foRF9");


var $6mEZ3 = parcelRequire("6mEZ3");

/*
This script adds autoconvert handlers to the confluence editor.

It executes on editor initialisation, registering the handlers defined in the original add-on descriptors of whatever
add-ons are installed. Each one is associated with a particular macro (although a macro can be associated with many
handlers.

On pattern match, the each handler will be asked if they match and will be processed by the first matching handler.
The macro object is then created, using the matched uri and the information already existing in the JS context, and
the macro is inserted into the editor.
*/ const $44631a970962135a$var$TRELLO_MACRO_NAME = 'trello-card';
const $44631a970962135a$var$escapePattern = (str)=>{
    return str.replace(/[\-\[\]\/\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
};
const $44631a970962135a$var$replaceAll = (find, replace, str)=>{
    return str.replace(new RegExp(find, 'g'), replace);
};
const $44631a970962135a$var$convertPatternToRegex = (pattern)=>{
    // Consolidate any double up wildcards
    while(pattern.indexOf('{}{}') !== -1)pattern = pattern.replace('{}{}', '{}');
    // build a regex from the defined autoconvert pattern
    pattern = $44631a970962135a$var$escapePattern(pattern);
    pattern = $44631a970962135a$var$replaceAll('{}', '[^/]*?', pattern);
    // eslint-disable-next-line prefer-template
    pattern = '^' + pattern + '$';
    return pattern;
};
const $44631a970962135a$var$isPatternSafe = (pattern)=>{
    const patternBlockList = [
        'http://',
        'https://',
        'http://{}',
        'https://{}',
        'http://{}.{}',
        'https://{}.{}',
        'http://{}.{}.{}',
        'https://{}.{}.{}'
    ];
    // check the url pattern is not banned
    return patternBlockList.every((bannedPattern)=>bannedPattern !== pattern);
};
const $44631a970962135a$var$hasAutoconvertData = (macro)=>{
    return macro.autoconvertData && macro.autoconvertData.urlParameter && macro.autoconvertData.patterns;
};
const $44631a970962135a$var$getADFNodeForMacros = async (macros, contentId)=>{
    const macroAttributesArray = await Promise.all(Array.from(macros).map((macroName)=>(0, $foRF9.fetchMacroAttributes)({
            macroDefinition: {
                name: macroName
            },
            contentId: contentId
        })));
    return macroAttributesArray.reduce((accu, macroAttributes)=>{
        accu[macroAttributes.attrs.extensionKey] = macroAttributes;
        return accu;
    }, {});
};
const $44631a970962135a$var$convertLink = (link, autoconvertDefs, macroAttributesMap)=>{
    const matchedAcd = autoconvertDefs.find((acd)=>{
        return !!link.match(acd.matcher);
    });
    if (matchedAcd) {
        const { macroName: macroName, urlParameter: urlParameter } = matchedAcd;
        const params = {};
        params[urlParameter] = link;
        const macroAttributes = macroAttributesMap[macroName];
        const convertedMacroAttributes = JSON.parse(JSON.stringify(macroAttributes));
        convertedMacroAttributes.attrs.text = `${urlParameter} = ${link}`;
        convertedMacroAttributes.attrs.extensionKey = macroName;
        if (!convertedMacroAttributes.attrs.parameters) convertedMacroAttributes.attrs.parameters = {};
        convertedMacroAttributes.attrs.parameters.macroParams = (0, $6mEZ3.wrapMacroParams)(params);
        return convertedMacroAttributes;
    } else return null;
};
async function $44631a970962135a$export$13c25ccf87e8cca2(loadMacroMetadata, contentId) {
    const autoconvertDefs = [];
    const macros = await loadMacroMetadata();
    // this object contains name of macros which have correct autoconvertData
    const filteredMacros = new Set();
    macros.forEach((macro)=>{
        if (// Don't convert any new Trello links to Trello macro due to new Trello smart links
        !$44631a970962135a$var$hasAutoconvertData(macro) || macro.macroName === $44631a970962135a$var$TRELLO_MACRO_NAME) return;
        // only macro with autoconvertData can be converted
        macro.autoconvertData.patterns.forEach((pattern)=>{
            if ($44631a970962135a$var$isPatternSafe(pattern)) {
                const acd = {
                    macroName: macro.macroName,
                    urlParameter: macro.autoconvertData.urlParameter,
                    matcher: $44631a970962135a$var$convertPatternToRegex(pattern)
                };
                filteredMacros.add(acd.macroName);
                autoconvertDefs.push(acd);
            }
        });
    });
    const macroAttributes = await $44631a970962135a$var$getADFNodeForMacros(filteredMacros, contentId);
    return (link)=>$44631a970962135a$var$convertLink(link, autoconvertDefs, macroAttributes);
}
module.exports["createConnectAddonConverter"] = $44631a970962135a$export$13c25ccf87e8cca2;

});

parcelRegister("872OF", function(module, exports) {

var $9fBoq = parcelRequire("9fBoq");


var $8pcS0 = parcelRequire("8pcS0");

const $6089ca8d25fc98f0$var$fireAnalyticsEvent = (createAnalyticsEvent, sourceNode, targetAttributes)=>{
    if (!createAnalyticsEvent) return;
    const sourceAttributes = {
        sourceNodeType: sourceNode.type
    };
    // Source is Connect macro
    if (sourceNode.type === 'extension' && sourceNode.attrs?.extensionType === (0, $8pcS0.EXTENSION_TYPE).MACRO_CORE) Object.assign(sourceAttributes, {
        sourceExtensionType: sourceNode.attrs?.extensionType,
        sourceExtensionKey: sourceNode.attrs?.extensionKey,
        sourceExtensionTitle: sourceNode.attrs?.parameters?.macroMetadata?.title,
        sourceExtensionParameters: sourceNode.attrs?.parameters
    });
    // Source is a Table
    if (sourceNode.type === 'table') Object.assign(sourceAttributes, {
        sourceExtensionType: 'table'
    });
    // Source is a Chart
    if (sourceNode.type === 'extension' && sourceNode.attrs?.extensionType === 'com.atlassian.chart') Object.assign(sourceAttributes, {
        sourceExtensionType: sourceNode.attrs?.extensionType,
        sourceExtensionKey: sourceNode.attrs?.extensionKey,
        sourceExtensionTitle: sourceNode.attrs?.parameters?.extensionTitle,
        sourceExtensionParameters: sourceNode.attrs?.parameters
    });
    const analyticsData = {
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'createReference',
            source: 'editorFloatingToolbar',
            attributes: {
                ...sourceAttributes,
                ...targetAttributes
            }
        }
    };
    createAnalyticsEvent(analyticsData).fire();
};
const $6089ca8d25fc98f0$export$ab05b910337771f7 = (createAnalyticsEvent, sourceNode, targetMacro)=>{
    $6089ca8d25fc98f0$var$fireAnalyticsEvent(createAnalyticsEvent, sourceNode, {
        targetNodeType: 'extension',
        targetExtensionType: (0, $8pcS0.EXTENSION_TYPE).MACRO_CORE,
        targetExtensionKey: targetMacro.macroName,
        targetExtensionTitle: targetMacro.title,
        targetMacro: targetMacro
    });
};
const $6089ca8d25fc98f0$export$6fc4be8bb74a5f0 = (createAnalyticsEvent, sourceNode, targetMacro)=>{
    $6089ca8d25fc98f0$var$fireAnalyticsEvent(createAnalyticsEvent, sourceNode, {
        targetNodeType: 'extension',
        targetExtensionType: 'com.atlassian.ecosystem',
        targetExtensionKey: targetMacro.id.replace('ari:cloud:ecosystem::extension/', ''),
        targetExtensionTitle: (0, $9fBoq.extensionTitle)(targetMacro),
        targetMacro: targetMacro
    });
};
const $6089ca8d25fc98f0$export$6546d4aebb1728df = (createAnalyticsEvent, node)=>{
    $6089ca8d25fc98f0$var$fireAnalyticsEvent(createAnalyticsEvent, node, {});
};
module.exports["fireAnalyticsEventForConnectionsButton"] = $6089ca8d25fc98f0$export$6546d4aebb1728df;

});

parcelRegister("9fBoq", function(module, exports) {

var $hBxDy = parcelRequire("hBxDy");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $hBxDy.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $hBxDy.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("hBxDy", function(module, exports) {
var $77348f0599087222$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $77348f0599087222$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $77348f0599087222$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $77348f0599087222$export$beaef1891b3e7ca3;

});

parcelRegister("jRxDI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $bdpeX = parcelRequire("bdpeX");


var $jmjWc = parcelRequire("jmjWc");


var $au7xi = parcelRequire("au7xi");


const $8c4ed19546fbbebf$var$SmartButtonExtension = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8Gy08",
    name: "SmartButtonExtension",
    loader: async ()=>(await (parcelRequire("6B0iH"))).SmartButtonExtension
});
const $8c4ed19546fbbebf$var$i18n = (0, $kSwu1.defineMessages)({
    extensionName: {
        id: "automation-extensions.smart-button.name",
        defaultMessage: "Smart Button"
    },
    extensionDescription: {
        id: "automation-extensions.smart-button.description",
        defaultMessage: "Enables users to create smart buttons to run automation rules"
    }
});

// "Manifest" of the extension
// Describes extension properties and how it hooks into other parts of editor
const $8c4ed19546fbbebf$var$getSmartButtonExtensionManifest = ({ contentId: contentId, editorActions: editorActions, openSmartButtonConfigPanel: openSmartButtonConfigPanel, isSmartButtonAllowed: isSmartButtonAllowed, intl: intl, contentType: contentType, isTemplateEditor: isTemplateEditor = false })=>({
        title: intl.formatMessage($8c4ed19546fbbebf$var$i18n.extensionName),
        type: (0, $au7xi.smartButtonExtensionType),
        key: 'smart-button',
        description: intl.formatMessage($8c4ed19546fbbebf$var$i18n.extensionDescription),
        icons: {
            // 48 is the pixel size of the icon
            '48': ()=>(parcelRequire("atZGQ")).then((mod)=>mod.AutomationIcon)
        },
        // automation icon to run rule from button toolbar can be added here - see code remove for A4C-2519
        modules: {
            // This governs the / menu and + menu insertion
            // We disable extension insertion from both menus by setting this as undefined
            quickInsert: isSmartButtonAllowed && contentType === 'page' ? [
                {
                    key: 'quick-insert',
                    keywords: [
                        'automation'
                    ],
                    action: ()=>Promise.resolve({
                            type: 'inlineExtension',
                            key: 'smart-button',
                            attrs: {
                                extensionType: (0, $au7xi.smartButtonExtensionType),
                                extensionKey: 'smart-button',
                                parameters: {
                                    extensionTitle: intl.formatMessage($8c4ed19546fbbebf$var$i18n.extensionName)
                                }
                            }
                        })
                }
            ] : undefined,
            // This is the actual node inserted into the content
            nodes: {
                default: {
                    type: 'inlineExtension',
                    render: async ()=>({ node: node })=>{
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8c4ed19546fbbebf$var$SmartButtonExtension, {
                                extensionNode: node,
                                editorActions: editorActions,
                                openSmartButtonConfigPanel: openSmartButtonConfigPanel,
                                contentId: contentId,
                                contentType: contentType,
                                isTemplateEditor: isTemplateEditor
                            });
                        },
                    update: async ()=>{
                        const selectedNode = editorActions?.getSelectedNode()?.toJSON();
                        const selectedLocalId = selectedNode?.attrs?.localId;
                        if (!!selectedLocalId && openSmartButtonConfigPanel) openSmartButtonConfigPanel(selectedLocalId);
                    }
                }
            }
        }
    });
const $8c4ed19546fbbebf$export$5d6127d5858c50c9 = async ({ contentId: contentId, editorActions: editorActions, openSmartButtonConfigPanel: openSmartButtonConfigPanel, isSmartButtonAllowed: isSmartButtonAllowed, intl: intl, contentType: contentType, isTemplateEditor: isTemplateEditor = false })=>new (0, $bdpeX.default)([
        $8c4ed19546fbbebf$var$getSmartButtonExtensionManifest({
            contentId: contentId,
            editorActions: editorActions,
            openSmartButtonConfigPanel: openSmartButtonConfigPanel,
            isSmartButtonAllowed: isSmartButtonAllowed,
            intl: intl,
            contentType: contentType,
            isTemplateEditor: isTemplateEditor
        })
    ]);
module.exports["smartButtonExtensionProvider"] = $8c4ed19546fbbebf$export$5d6127d5858c50c9;

});

parcelRegister("au7xi", function(module, exports) {
const $ea41547e1b4f38b6$export$73185dbd06fc0dd8 = 'com.atlassian.automation.smart-button';
module.exports["smartButtonExtensionType"] = $ea41547e1b4f38b6$export$73185dbd06fc0dd8;

});

parcelRegister("6B0iH", function(module, exports) {

let $4cd66e764522468b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4cd66e764522468b$var$load("lbsQO"),
    $4cd66e764522468b$var$load("7TnhR"),
    $4cd66e764522468b$var$load("6wr18"),
    $4cd66e764522468b$var$load("2xKrc"),
    $4cd66e764522468b$var$load("ffEVr"),
    $4cd66e764522468b$var$load("lhkXg"),
    $4cd66e764522468b$var$load("hhss7"),
    $4cd66e764522468b$var$load("fgNp8")
]).then(()=>parcelRequire('6ncRx'));

});

parcelRegister("atZGQ", function(module, exports) {

let $7a1c773226e075e2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a1c773226e075e2$var$load("djlDY").then(()=>parcelRequire('iFAjt'));

});

parcelRegister("iONqR", function(module, exports) {

var $bdpeX = parcelRequire("bdpeX");


var $51WxS = parcelRequire("51WxS");

const $c614caf6b183de5b$export$e1aa62d66c6fe261 = (intl, snippets, onOpenTemplatePanel, userId, createAnalyticsEvent)=>{
    if (!onOpenTemplatePanel && (!snippets || snippets.length === 0)) return new (0, $bdpeX.default)([]);
    const manifest = (0, $51WxS.snippetExtensionManifest)({
        snippets: snippets || [],
        intl: intl,
        onOpenTemplatePanel: onOpenTemplatePanel,
        userId: userId,
        createAnalyticsEvent: createAnalyticsEvent
    });
    return new (0, $bdpeX.default)([
        manifest
    ]);
};
module.exports["snippetExtensionProvider"] = $c614caf6b183de5b$export$e1aa62d66c6fe261;

});

parcelRegister("51WxS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ivert = parcelRequire("ivert");


var $9KSWX = parcelRequire("9KSWX");


var $hPTbh = parcelRequire("hPTbh");


var $4uowN = parcelRequire("4uowN");


var $lCB0R = parcelRequire("lCB0R");

const $3f665bc0c658edea$var$messages = (0, $kSwu1.defineMessages)({
    snippetsQuickInsertTitle: {
        id: "snippets.snippetsQuickInsertTitle",
        defaultMessage: "Block Template Gallery"
    },
    newLozenge: {
        id: "snippets.quickInsert.newLozenge",
        defaultMessage: "New"
    },
    newLozengeUpdated: {
        id: "snippets.quickInsert.newLozenge.updated",
        defaultMessage: "New"
    },
    snippetIconLabel: {
        id: "snippets.snippetIconLabel",
        defaultMessage: "Block template icon"
    },
    snippetQuickInsertDescription: {
        id: "snippets.snippetQuickInsertDescription",
        defaultMessage: "Create, discover, & insert block templates"
    }
});
/**
 * Fires an `insertSnippet` UI event with `origin=quickInsert` when a snippet is
 * inserted from the quick-insert menu via the extension-provider path.
 *
 * The extension `action` API does not expose analytics, so the
 * `createAnalyticsEvent` factory is captured from the build site (where the
 * editor's analytics context is available) and used here. No-op when the
 * factory is unavailable or the gate is off — keeping the event shape identical
 * to the imperative `createSnippetQuickInsertItem` path.
 */ const $3f665bc0c658edea$var$fireQuickInsertSnippetInsertedAnalytic = (createAnalyticsEvent, snippet)=>{
    (0, $4uowN.fireSnippetUIEvent)(createAnalyticsEvent, (0, $4uowN.buildInsertSnippetEventData)(snippet), (0, $hPTbh.ANALYTICS_ORIGIN).QUICK_INSERT);
};

const $3f665bc0c658edea$export$bc0a2249d0f8fcd = ({ snippets: snippets, intl: intl, onOpenTemplatePanel: onOpenTemplatePanel, userId: userId, createAnalyticsEvent: createAnalyticsEvent })=>{
    const snippetsQuickInsertTitle = intl.formatMessage($3f665bc0c658edea$var$messages.snippetsQuickInsertTitle);
    const snippetIconLabel = intl.formatMessage($3f665bc0c658edea$var$messages.snippetIconLabel);
    const snippetQuickInsertDescription = intl.formatMessage($3f665bc0c658edea$var$messages.snippetQuickInsertDescription);
    const quickInsert = (0, $lCB0R.filterAndSort)(snippets, userId).map((snippet)=>({
            key: `snippet-${snippet.snippetId}`,
            title: snippet.name,
            description: (0, $lCB0R.createSnippetDescription)(snippet.createdBy, intl),
            keywords: (0, $lCB0R.extractSnippetKeywords)(snippet.name, intl),
            icon: async ()=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ivert))), {
                        label: snippetIconLabel
                    }),
            action: async ()=>{
                // Only record an insert event when there is a body to insert, matching
                // the imperative `createSnippetQuickInsertItem` path which guards on a
                // successful insert before firing.
                if (snippet.body) $3f665bc0c658edea$var$fireQuickInsertSnippetInsertedAnalytic(createAnalyticsEvent, snippet);
                return snippet.body;
            }
        }));
    // Add "Block Template" quick insert item if callback is provided
    if (onOpenTemplatePanel) quickInsert.unshift({
        key: 'block-template',
        title: snippetsQuickInsertTitle,
        description: snippetQuickInsertDescription,
        keywords: (0, $lCB0R.extractSnippetKeywords)($3f665bc0c658edea$var$messages.snippetsQuickInsertTitle.defaultMessage, intl),
        icon: async ()=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ivert))), {
                    label: snippetIconLabel
                }),
        lozenge: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: "new"
        }, intl.formatMessage($3f665bc0c658edea$var$messages.newLozengeUpdated)),
        action: async ()=>{
            onOpenTemplatePanel();
        }
    });
    return {
        title: snippetsQuickInsertTitle,
        description: snippetQuickInsertDescription,
        type: 'com.atlassian.confluence.macro.core',
        key: 'snippet-extension',
        icons: {
            // eslint-disable-next-line import/dynamic-import-chunkname
            '48': ()=>Promise.resolve((parcelRequire("ivert")))
        },
        modules: {
            quickInsert: quickInsert
        }
    };
};
module.exports["snippetExtensionManifest"] = $3f665bc0c658edea$export$bc0a2249d0f8fcd;

});

parcelRegister("fxClS", function(module, exports) {

var $dZUkS = parcelRequire("dZUkS");


var $5OfFS = parcelRequire("5OfFS");


var $lCB0R = parcelRequire("lCB0R");

const $14685d8ced03c929$export$81c899ea0c3802a0 = (editorAPI, userId)=>{
    if (!editorAPI) return;
    (0, $dZUkS.onCurrentFetchComplete)((loadedSnippets)=>{
        (0, $lCB0R.filterAndSort)(loadedSnippets, userId).forEach((snippet)=>{
            (0, $5OfFS.addSnippetQuickInsertItem)({
                snippet: snippet,
                editorAPI: editorAPI
            });
        });
    });
};
module.exports["registerSnippetsQuickInsertOnLoad"] = $14685d8ced03c929$export$81c899ea0c3802a0;

});

parcelRegister("6b7RE", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $bdpeX = parcelRequire("bdpeX");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");

const $9e56fbf670b6dc1e$export$858ce1ee8936577f = async (args)=>new (0, $bdpeX.default)([
        $9e56fbf670b6dc1e$var$getProjectLinkerExtensionManifest(args)
    ]);
const $9e56fbf670b6dc1e$var$getProjectLinkerExtensionManifest = ({ cloudId: cloudId, intl: intl, editorActions: editorActions, createAnalyticsEvent: createAnalyticsEvent })=>({
        title: intl.formatMessage((0, $6mKj3.expVal)('project-terminology-refresh', 'isEnabled', false) ? $9e56fbf670b6dc1e$var$i18n.titleGalaxia : $9e56fbf670b6dc1e$var$i18n.title),
        type: 'com.atlassian.confluence.project-linker',
        key: 'project-linker',
        description: intl.formatMessage($9e56fbf670b6dc1e$var$i18n.description),
        icons: {
            '48': async ()=>({
                    default: ()=>null
                })
        },
        modules: {
            nodes: {
                default: {
                    type: 'extension',
                    render: async ()=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9e56fbf670b6dc1e$var$ProjectLinkerLoader, {
                                cloudId: cloudId,
                                editorActions: editorActions,
                                createAnalyticsEvent: createAnalyticsEvent
                            }),
                    // @ts-expect-error This option is experimental and not reflected in the manifest type definition
                    __hideFrame: true
                }
            }
        }
    });

const $9e56fbf670b6dc1e$var$ProjectLinkerLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "mj056",
    name: "ProjectLinkerLoader",
    loader: async ()=>(await (parcelRequire("1axh2"))).ProjectLinkerWrapper
});
const $9e56fbf670b6dc1e$var$i18n = (0, $kSwu1.defineMessages)({
    title: {
        id: "create-space.project-linker.extension.title",
        defaultMessage: "Project linker"
    },
    titleGalaxia: {
        id: "create-space.project-linker.extension.title-galaxia",
        defaultMessage: "Space linker"
    },
    description: {
        id: "create-space.project-linker.extension.description",
        defaultMessage: "Provides a convenient way to link to projects on space overview"
    }
});
module.exports["projectLinkerExtensionProvider"] = $9e56fbf670b6dc1e$export$858ce1ee8936577f;

});

parcelRegister("1axh2", function(module, exports) {

let $0da089200cc021ee$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0da089200cc021ee$var$load("h5kct"),
    $0da089200cc021ee$var$load("hS8gF"),
    $0da089200cc021ee$var$load("g8A75"),
    $0da089200cc021ee$var$load("4RsKm"),
    $0da089200cc021ee$var$load("iUXaE"),
    $0da089200cc021ee$var$load("lTkx9"),
    $0da089200cc021ee$var$load("hZ2FX"),
    $0da089200cc021ee$var$load("Wowvf"),
    $0da089200cc021ee$var$load("gnocL"),
    $0da089200cc021ee$var$load("7EorR"),
    $0da089200cc021ee$var$load("6wr18"),
    $0da089200cc021ee$var$load("ffEVr"),
    $0da089200cc021ee$var$load("aIze1"),
    $0da089200cc021ee$var$load("hhss7"),
    $0da089200cc021ee$var$load("8AwXG")
]).then(()=>parcelRequire('cIFHL'));

});

parcelRegister("4U6ec", function(module, exports) {
/**
 * @deprecated This should be removed once we migrate away from using Synchrony
 */ var $5137e303faa24d7f$export$9c28bc693ca74328 = /*#__PURE__*/ function(SYNC_STATUS_KEY) {
    SYNC_STATUS_KEY["CONNECTED"] = "connected";
    SYNC_STATUS_KEY["DISCONNECTED"] = "disconnected";
    SYNC_STATUS_KEY["ERROR"] = "error";
    SYNC_STATUS_KEY["COLLAB_LIMIT"] = "collab-limit";
    SYNC_STATUS_KEY["PERMISSION_CHANGED"] = "permission-changed";
    return SYNC_STATUS_KEY;
}({});
const $5137e303faa24d7f$export$40bf0201c34f0600 = 'l5albia6lf64r4n';
const $5137e303faa24d7f$export$92a4a783381b2c9 = 'confluence.fabric.page.optin.page.has.been.migrated';
const $5137e303faa24d7f$export$6a9702599c19f55f = 8000;
const $5137e303faa24d7f$export$11e4ffbb7072caae = 'https://support.atlassian.com/confluence-cloud/docs/convert-pages-to-the-new-editor/#Convertpagestotheneweditor-WhatACTUALLYhappenswhenyourcontentisconverted';
module.exports["DROPBOX_APP_KEY"] = $5137e303faa24d7f$export$40bf0201c34f0600;
module.exports["learnMoreURL"] = $5137e303faa24d7f$export$11e4ffbb7072caae;

});

parcelRegister("fgd2r", function(module, exports) {
const $ee57e9dbd4a15340$export$41ec0510c4ed436a = (flagName, defaultValue, map)=>(featureFlags)=>{
        const maybeValue = featureFlags[flagName];
        if (typeof maybeValue === 'string') try {
            const value = JSON.parse(maybeValue);
            return map ? map(value) : value;
        } catch (err) {
            return defaultValue;
        }
        return defaultValue;
    };
const $ee57e9dbd4a15340$export$395b7f16d1fbd63c = ()=>{
    const optedOutMacros = [
        'create-from-template',
        'auibutton',
        'cfm-progress-bar-hyperlink-step',
        'decisionreport',
        'viewpdf',
        'viewdoc',
        'viewxls',
        'viewppt',
        'cqlmacro1',
        'detailssummary',
        'contentbylabel'
    ];
    return optedOutMacros;
};
module.exports["getOptedOutMacros"] = $ee57e9dbd4a15340$export$395b7f16d1fbd63c;

});

parcelRegister("jgzkh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $bdpeX = parcelRequire("bdpeX");


var $aC6bW = parcelRequire("aC6bW");


var $krYZG = parcelRequire("krYZG");


var $1Ns7R = parcelRequire("1Ns7R");


var $5mn6Y = parcelRequire("5mn6Y");


// Lazily load the shared app-icon module. It eagerly pulls in ~60 third-party
// SVG icon components plus @atlaskit/logo, so a static import drags that whole
// graph into the editor's initial-load bundle for every edit-page session.
// Quick-insert icons only ever render once the slash/insert menu is opened, so
// resolving the module inside the async `icon` loader keeps it off the
// initial-load (VC) critical path.
const $c9c6c8d8cd2d8eeb$var$loadAppIcon = async ()=>(await (parcelRequire("e5Eak"))).AppIcon;

const $c9c6c8d8cd2d8eeb$var$loadEmbedIcon = async ()=>(await Promise.resolve((parcelRequire("kTb7m")))).default;
const $c9c6c8d8cd2d8eeb$var$i18n = (0, $kSwu1.defineMessages)({
    appLinkDescription: {
        id: "editor-features.third-party-quick-insert.app-link.description",
        defaultMessage: "Insert a link from {appName}"
    },
    embedTitle: {
        id: "editor-features.third-party-quick-insert.embed.title",
        defaultMessage: "Embed"
    },
    embedDescription: {
        id: "editor-features.third-party-quick-insert.embed.description",
        defaultMessage: "Insert a link or embed external content"
    }
});
const $c9c6c8d8cd2d8eeb$var$THIRD_PARTY_APPS = [
    {
        tabKey: 'google-drive',
        title: 'Google Drive',
        keywords: [
            'google',
            'drive',
            'gdrive',
            'google drive',
            'link',
            'embed'
        ],
        appIconKey: 'Google Drive',
        categories: [
            'external-content'
        ]
    },
    {
        tabKey: 'figma',
        title: 'Figma',
        keywords: [
            'figma',
            'design',
            'link',
            'embed'
        ],
        appIconKey: 'Figma',
        categories: [
            'external-content'
        ]
    },
    {
        tabKey: 'amplitude',
        title: 'Amplitude',
        keywords: [
            'amplitude',
            'analytics',
            'link',
            'embed'
        ],
        appIconKey: 'amplitude',
        categories: [
            'external-content'
        ]
    },
    {
        tabKey: 'loom',
        title: 'Loom',
        keywords: [
            'loom',
            'video',
            'recording',
            'link',
            'embed'
        ],
        appIconKey: 'Loom',
        categories: [
            'external-content'
        ]
    },
    {
        tabKey: 'sharepoint',
        title: 'SharePoint',
        keywords: [
            'sharepoint',
            'microsoft',
            'link',
            'embed'
        ],
        appIconKey: 'sharepoint',
        categories: [
            'external-content'
        ]
    }
];
/**
 * Maps a quick-insert `tabKey` to the product key used in the search config's
 * accessible/connected product lists. Most tab keys already match the config
 * key; only the cases that differ need an entry here. The Google Drive tab id is
 * `google-drive` (matching the link picker tab), but the search config exposes
 * it under the product key `drive`.
 */ const $c9c6c8d8cd2d8eeb$var$TAB_KEY_TO_CONFIG_PRODUCT_KEY = {
    'google-drive': 'drive'
};
const $c9c6c8d8cd2d8eeb$var$ALWAYS_VISIBLE_TAB_KEYS = new Set([
    'loom'
]);
function $c9c6c8d8cd2d8eeb$var$isThirdPartyAppConnected(app, connectedProductKeys) {
    if ($c9c6c8d8cd2d8eeb$var$ALWAYS_VISIBLE_TAB_KEYS.has(app.tabKey)) return true;
    const configKey = ($c9c6c8d8cd2d8eeb$var$TAB_KEY_TO_CONFIG_PRODUCT_KEY[app.tabKey] ?? app.tabKey).toLowerCase();
    return connectedProductKeys.has(configKey);
}
const $c9c6c8d8cd2d8eeb$export$646cf094cc9ee61f = ({ editorActions: editorActions, intlNext: intlNext, cohort: cohort, createAnalyticsEvent: createAnalyticsEvent, connectedProductKeysPromise: connectedProductKeysPromise })=>{
    // Fires when a user selects one of the quick-insert embed items (the generic
    // `/embed` item or a per-app item). Feeds the `/embed` usage-rate metric and,
    // via `itemType`/`appKey`, the breakdown of which action the user took (embed
    // vs a specific app name). Uses the Confluence analytics listener schema
    // (`sendUIEvent`) so the event is captured by the Confluence pipeline.
    const fireQuickInsertEmbedSelected = (attributes)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'selected',
                actionSubject: 'quickInsertItem',
                actionSubjectId: 'embedQuickInsert',
                source: 'editPageScreen',
                attributes: attributes
            }
        }).fire();
    };
    const buildManifest = (connectedProductKeys)=>{
        const visibleApps = connectedProductKeys ? $c9c6c8d8cd2d8eeb$var$THIRD_PARTY_APPS.filter((app)=>$c9c6c8d8cd2d8eeb$var$isThirdPartyAppConnected(app, connectedProductKeys)) : $c9c6c8d8cd2d8eeb$var$THIRD_PARTY_APPS;
        const quickInsertModules = visibleApps.map((app)=>({
                key: `third-party-embed-${app.tabKey}`,
                title: app.title,
                description: intlNext.formatMessage($c9c6c8d8cd2d8eeb$var$i18n.appLinkDescription, {
                    appName: app.title
                }),
                keywords: app.keywords,
                categories: [
                    'external-content'
                ],
                icon: async ()=>{
                    const AppIcon = await $c9c6c8d8cd2d8eeb$var$loadAppIcon();
                    return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(AppIcon, {
                            app: app.appIconKey,
                            size: "small"
                        });
                },
                action: async ()=>{
                    fireQuickInsertEmbedSelected({
                        itemKey: `third-party-embed-${app.tabKey}`,
                        itemType: 'thirdPartyApp',
                        appKey: app.tabKey,
                        cohort: cohort
                    });
                    // Set the preferred tab key so the Rovo Link Picker opens on the correct tab
                    (0, $5mn6Y.getSetPreferredTabKey)()(app.tabKey);
                    // Record that this picker session was opened from a quick-insert embed entry
                    // point so the adapter can request an embed appearance for the inserted link.
                    (0, $5mn6Y.getSetEmbedIntent)()(true);
                    // Defer the link toolbar open to let the type-ahead settle
                    requestAnimationFrame(()=>{
                        const view = editorActions._privateGetEditorView();
                        if (!view) {
                            // The editor view went away before we could open the toolbar (e.g. the
                            // editor unmounted between selection and this frame). The preference was
                            // set synchronously above, but RovoLinkPickerAdapter will never mount to
                            // clear it — so clear it here to avoid leaking a stale tab into the next
                            // link picker open.
                            (0, $5mn6Y.getSetPreferredTabKey)()(undefined);
                            (0, $5mn6Y.getSetEmbedIntent)()(false);
                            return;
                        }
                        (0, $aC6bW.editorCommandToPMCommand)((0, $1Ns7R.showLinkToolbar)((0, $krYZG.INPUT_METHOD).QUICK_INSERT, undefined))(view.state, view.dispatch);
                    });
                    // Don't insert any ADF node
                    return undefined;
                }
            }));
        const embedModule = {
            key: 'embed',
            title: intlNext.formatMessage($c9c6c8d8cd2d8eeb$var$i18n.embedTitle),
            description: intlNext.formatMessage($c9c6c8d8cd2d8eeb$var$i18n.embedDescription),
            keywords: [
                'embed',
                'link',
                'url'
            ],
            categories: [
                'external-content'
            ],
            // Lower priority sorts earlier in the slash menu. Only boost the `/embed`
            // item for the `prioritizeEmbedInQIM` cohort; otherwise leave it unset so it
            // sorts by default relevance.
            priority: cohort === 'prioritizeEmbedInQIM' ? -300 : undefined,
            icon: $c9c6c8d8cd2d8eeb$var$loadEmbedIcon,
            action: async ()=>{
                fireQuickInsertEmbedSelected({
                    itemKey: 'embed',
                    itemType: 'embed',
                    cohort: cohort
                });
                // Record that this picker session was opened from the quick-insert embed entry
                // point so the adapter can request an embed appearance for the inserted link.
                (0, $5mn6Y.getSetEmbedIntent)()(true);
                // Defer the link toolbar open to let the type-ahead settle
                requestAnimationFrame(()=>{
                    const view = editorActions._privateGetEditorView();
                    if (!view) {
                        // The editor view went away before we could open the toolbar. Clear the
                        // embed intent so it can't leak into a later, unrelated link picker open.
                        (0, $5mn6Y.getSetEmbedIntent)()(false);
                        return;
                    }
                    (0, $aC6bW.editorCommandToPMCommand)((0, $1Ns7R.showLinkToolbar)((0, $krYZG.INPUT_METHOD).QUICK_INSERT, undefined))(view.state, view.dispatch);
                });
                // Don't insert any ADF node
                return undefined;
            }
        };
        return {
            title: 'Third-party embeds',
            description: 'Quick-insert items for third-party app links',
            type: 'com.atlassian.confluence.macro.core',
            key: 'third-party-quick-insert-embeds',
            icons: {
                '48': async ()=>{
                    const AppIcon = await $c9c6c8d8cd2d8eeb$var$loadAppIcon();
                    return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(AppIcon, {
                            app: null,
                            size: "small"
                        });
                }
            },
            modules: {
                quickInsert: [
                    embedModule,
                    ...quickInsertModules
                ]
            }
        };
    };
    // Build the provider once with a manifest promise so the editor's
    // `extensionProviders` array keeps a stable identity. When a connected-product
    // promise is supplied (experiment cohort) the manifest resolves after the
    // connector-config request settles; the editor picks up the quick-insert items
    // at that point without a prop change, so it is never re-initialised mid-load.
    // Without a promise we fail open and show every app synchronously.
    const manifestsPromise = connectedProductKeysPromise ? connectedProductKeysPromise.then((connectedProductKeys)=>[
            buildManifest(connectedProductKeys)
        ]) : Promise.resolve([
        buildManifest(undefined)
    ]);
    return new (0, $bdpeX.default)(manifestsPromise);
};
module.exports["createThirdPartyQuickInsertExtensionProvider"] = $c9c6c8d8cd2d8eeb$export$646cf094cc9ee61f;

});

parcelRegister("e5Eak", function(module, exports) {

let $a420b05cbe32bc0b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a420b05cbe32bc0b$var$load("do0Fh").then(()=>parcelRequire('1xWgP'));

});

parcelRegister("glRTB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $cS7ok = parcelRequire("cS7ok");


var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");


var $bQm3c = parcelRequire("bQm3c");

const $f01a6f39b3d867d1$var$QUICK_INSERT_EMBEDS_EXPERIENCE_ID = 'confluenceQuickInsertEmbeds';
function $f01a6f39b3d867d1$var$toError(value) {
    if (value instanceof Error) return value;
    if (typeof value === 'string') return new Error(value);
    try {
        return new Error(JSON.stringify(value) ?? String(value));
    } catch  {
        return new Error(String(value));
    }
}
function $f01a6f39b3d867d1$export$894984b8b3202e37(enabled) {
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((event)=>createAnalyticsEvent(event).fire(), [
        createAnalyticsEvent
    ]);
    const logException = (0, $cozmU.useCallback)((exception)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError($f01a6f39b3d867d1$var$toError(exception), {
            attribution: (0, $3IBnw.Attribution).INTEGRATIONS,
            partialFailure: true
        });
    }, []);
    const analytics = (0, $cozmU.useMemo)(()=>({
            searchSessionId: $f01a6f39b3d867d1$var$QUICK_INSERT_EMBEDS_EXPERIENCE_ID,
            source: $f01a6f39b3d867d1$var$QUICK_INSERT_EMBEDS_EXPERIENCE_ID,
            actionSubject: 'quickInsertEmbeds',
            taskNamePrefix: $f01a6f39b3d867d1$var$QUICK_INSERT_EMBEDS_EXPERIENCE_ID,
            fireAnalyticsEvent: fireAnalyticsEvent,
            logException: logException
        }), [
        fireAnalyticsEvent,
        logException
    ]);
    const disabled = !enabled || !cloudId || !userId;
    const { thirdPartyConfigs: thirdPartyConfigs } = (0, $cS7ok.useThirdPartyConfig)({
        cloudId: cloudId,
        userId: userId,
        disabled: disabled,
        analytics: analytics
    });
    // Derive a stable signature first so the returned Set keeps a stable identity
    // until the connected products actually change. The caller threads this value
    // into a memoised provider list, so a fresh Set on every render would rebuild
    // the editor's extension providers needlessly.
    const signature = (0, $cozmU.useMemo)(()=>{
        if (disabled || !thirdPartyConfigs) return undefined;
        return Object.entries(thirdPartyConfigs).filter(([, config])=>config?.userNeedsOAuth !== true).map(([key])=>key.toLowerCase()).sort().join(',');
    }, [
        disabled,
        thirdPartyConfigs
    ]);
    return (0, $cozmU.useMemo)(()=>{
        if (signature === undefined) return undefined;
        return new Set(signature ? signature.split(',') : []);
    }, [
        signature
    ]);
}
module.exports["useConnectedThirdPartyProductKeys"] = $f01a6f39b3d867d1$export$894984b8b3202e37;

});

parcelRegister("cS7ok", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ixfCV = parcelRequire("ixfCV");


var $i9pyX = parcelRequire("i9pyX");


var $dv1ov = parcelRequire("dv1ov");


var $33u17 = parcelRequire("33u17");


var $fIdaz = parcelRequire("fIdaz");


var $lG3cK = parcelRequire("lG3cK");


var $23xJD = parcelRequire("23xJD");


var $0SpY7 = parcelRequire("0SpY7");


var $lKvkH = parcelRequire("lKvkH");


var $d396o = parcelRequire("d396o");


var $aqAfG = parcelRequire("aqAfG");


var $5OPAY = parcelRequire("5OPAY");


var $aoy1P = parcelRequire("aoy1P");


var $fR63l = parcelRequire("fR63l");


var $dAuCI = parcelRequire("dAuCI");


var $3eS8z = parcelRequire("3eS8z");


var $92KTD = parcelRequire("92KTD");


var $7fkiQ = parcelRequire("7fkiQ");


var $eSwze = parcelRequire("eSwze");

const $b217d7e94854b92c$var$EXTRACT_PRODUCT = /ari:cloud:(.*)?::/;
const $b217d7e94854b92c$var$BITBUCKET_WORKSPACE_ARI = 'ari:cloud:bitbucket::workspace';
const $b217d7e94854b92c$var$FEDERATED_NO_OAUTH_PRODUCT_KEYS = new Set([
    'servicenow',
    'zendesk'
]);
/**
 * Normalizes product names from ARIs to match our product keys.
 * Backend uses 'jira-software' in ARIs but we use 'jira' as the product key.
 */ const $b217d7e94854b92c$var$normalizeProductFromAri = (ariProduct)=>{
    if (ariProduct === 'jira-software') return (0, $aqAfG.ProductKeys1P).Jira;
    return ariProduct;
};
/**
 * Nouns configuration (simplified - no icons for now)
 */ const $b217d7e94854b92c$var$supportedNouns = {
    [(0, $aqAfG.NounKeys).project]: {},
    [(0, $aqAfG.NounKeys).goal]: {},
    [(0, $aqAfG.NounKeys).AtlassianWebCrawler]: {}
};
/**
 * All product keys - 1P combined with 3P
 */ const $b217d7e94854b92c$var$allProductKeys = [
    ...Object.values((0, $aqAfG.ARI_EXTRACTED_1P_KEYS)),
    ...(0, $dAuCI.ThirdPartyConfigs).keys()
];
/**
 * Some products (eg. Loom) have separate auth checks that need to be enforced before
 * returning the final list of accessible products.
 *
 * Remove when cleaning up fg('rovo-search-combined-loom-auth')
 */ const $b217d7e94854b92c$var$lastMileProductChecks = (isUserLoomAuthed, products)=>{
    if (!products || products.length === 0) return products;
    return products.filter((product)=>isUserLoomAuthed || product !== (0, $fR63l.ProductKeys3P).Loom);
};
const $b217d7e94854b92c$export$2b0ac18f7cd43e19 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(90);
    const { cloudId: cloudIdProp, configFetchAbsoluteUrl: configFetchAbsoluteUrl, aggregatorHostName: aggregatorHostName, userId: userId, thirdPartyAbsoluteUrl: thirdPartyAbsoluteUrl, thirdPartyDisabled: thirdPartyDisabled, primaryProduct: primaryProduct, aggAbsoluteUrl: aggAbsoluteUrl, multiSiteSearchInRovo: multiSiteSearchInRovo, experience: experience, analytics: analytics } = t0;
    const { fireAnalyticsEvent: fireAnalyticsEvent, logException: logException, searchSessionId: searchSessionId, source: source, actionSubject: actionSubject, taskNamePrefix: taskNamePrefix, createNetworkCallbacks: createNetworkCallbacks } = analytics;
    const [firstPartyResponse, setFirstPartyResponse] = (0, $cozmU.useState)();
    const [isConfigLoaded, setIsConfigLoaded] = (0, $cozmU.useState)(false);
    const [isUserLoomAuthed, setIsUserLoomAuthed] = (0, $cozmU.useState)(false);
    const [linkedCloudARIs, setLinkedCloudARIs] = (0, $cozmU.useState)(undefined);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            nouns: []
        };
        $[0] = t1;
    } else t1 = $[0];
    const [accessibleProductsConfig, setAccessibleProductsConfig] = (0, $cozmU.useState)(t1);
    let t2;
    bb0: {
        if (!cloudIdProp && firstPartyResponse) {
            let t3;
            if ($[1] !== firstPartyResponse) {
                t3 = (0, $5OPAY.getFirstCloudId)(firstPartyResponse);
                $[1] = firstPartyResponse;
                $[2] = t3;
            } else t3 = $[2];
            t2 = t3;
            break bb0;
        }
        t2 = "";
    }
    const firstCloudId = t2;
    const t3 = cloudIdProp || firstCloudId || "";
    let t4;
    if ($[3] !== analytics || $[4] !== experience || $[5] !== t3 || $[6] !== thirdPartyAbsoluteUrl || $[7] !== thirdPartyDisabled || $[8] !== userId) {
        t4 = {
            cloudId: t3,
            userId: userId,
            absoluteUrl: thirdPartyAbsoluteUrl,
            disabled: thirdPartyDisabled,
            experience: experience,
            analytics: analytics
        };
        $[3] = analytics;
        $[4] = experience;
        $[5] = t3;
        $[6] = thirdPartyAbsoluteUrl;
        $[7] = thirdPartyDisabled;
        $[8] = userId;
        $[9] = t4;
    } else t4 = $[9];
    const thirdPartyResponse = $b217d7e94854b92c$export$4fc2f66fb6e9d067(t4);
    let t5;
    let t6;
    if ($[10] !== aggAbsoluteUrl || $[11] !== cloudIdProp || $[12] !== firstCloudId || $[13] !== logException || $[14] !== multiSiteSearchInRovo) {
        t5 = ()=>{
            const cloudId = cloudIdProp || firstCloudId;
            if (cloudId && multiSiteSearchInRovo) (0, $dv1ov.searchLinkedSitesQuery)({
                variables: {
                    id: `ari:cloud:confluence::site/${cloudId}`
                },
                aggAbsoluteUrl: aggAbsoluteUrl
            }).then((response)=>{
                const edges = response?.data?.collabContext_workspaceIsConnectedToWorkspace?.edges ?? [];
                const linkedARIs = edges.map($b217d7e94854b92c$var$_temp);
                const currentCloudIdARI = `ari:cloud:confluence::site/${cloudId}`;
                const currentIndex = linkedARIs.findIndex((ari)=>ari === currentCloudIdARI);
                if (currentIndex > 0) {
                    linkedARIs.splice(currentIndex, 1);
                    linkedARIs.unshift(currentCloudIdARI);
                }
                setLinkedCloudARIs(linkedARIs);
            }).catch((error)=>{
                logException(error);
            });
        };
        t6 = [
            cloudIdProp,
            firstCloudId,
            multiSiteSearchInRovo,
            logException,
            aggAbsoluteUrl
        ];
        $[10] = aggAbsoluteUrl;
        $[11] = cloudIdProp;
        $[12] = firstCloudId;
        $[13] = logException;
        $[14] = multiSiteSearchInRovo;
        $[15] = t5;
        $[16] = t6;
    } else {
        t5 = $[15];
        t6 = $[16];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    let t8;
    if ($[17] !== cloudIdProp || $[18] !== isUserLoomAuthed || $[19] !== logException || $[20] !== primaryProduct || $[21] !== userId) {
        t7 = ()=>{
            if (!(0, $ixfCV.fg)("rovo-search-combined-loom-auth") && !isUserLoomAuthed) {
                if (primaryProduct === (0, $d396o.PrimaryProductKeys).Confluence || primaryProduct === (0, $d396o.PrimaryProductKeys).Atlas || (primaryProduct === (0, $d396o.PrimaryProductKeys).Jira || primaryProduct === (0, $d396o.PrimaryProductKeys).Focus) && (0, $ixfCV.fg)("search_loom_auth_check_in_jira_mercury")) (0, $i9pyX.getUserLoomAuthStatus)({
                    userId: userId,
                    cloudId: cloudIdProp
                }).then((response_0)=>setIsUserLoomAuthed(response_0?.status === "mastered")).catch((error_0)=>{
                    logException(error_0);
                    setIsUserLoomAuthed(false);
                });
                else setIsUserLoomAuthed(true);
            }
        };
        t8 = [
            isUserLoomAuthed,
            setIsUserLoomAuthed,
            userId,
            logException,
            cloudIdProp,
            primaryProduct
        ];
        $[17] = cloudIdProp;
        $[18] = isUserLoomAuthed;
        $[19] = logException;
        $[20] = primaryProduct;
        $[21] = userId;
        $[22] = t7;
        $[23] = t8;
    } else {
        t7 = $[22];
        t8 = $[23];
    }
    (0, $cozmU.useEffect)(t7, t8);
    let t10;
    let t9;
    if ($[24] !== actionSubject || $[25] !== aggregatorHostName || $[26] !== cloudIdProp || $[27] !== configFetchAbsoluteUrl || $[28] !== createNetworkCallbacks || $[29] !== experience || $[30] !== fireAnalyticsEvent || $[31] !== firstPartyResponse || $[32] !== logException || $[33] !== searchSessionId || $[34] !== source || $[35] !== taskNamePrefix || $[36] !== userId) {
        t9 = ()=>{
            if (!firstPartyResponse) {
                const taskStartAt = performance.now();
                const taskId = crypto.randomUUID();
                const degradationCallback = (reason)=>{
                    fireAnalyticsEvent((0, $3eS8z.onDegradedDependency)({
                        dependency: "search-config",
                        searchSessionId: searchSessionId,
                        reason: reason,
                        source: source,
                        actionSubject: actionSubject
                    }));
                };
                const cacheAnalyticsCallback = async (state)=>{
                    fireAnalyticsEvent((0, $3eS8z.onRequestCacheAccess)({
                        requestName: "search-config",
                        searchSessionId: searchSessionId,
                        cacheHit: state.hit,
                        refreshTriggered: state.refreshTriggered,
                        source: source,
                        actionSubject: actionSubject
                    }));
                };
                const networkCallbacks = createNetworkCallbacks ? createNetworkCallbacks(taskId, (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_NETWORK), searchSessionId, fireAnalyticsEvent, taskStartAt, {}) : undefined;
                const searchConfigParams = {
                    cloudId: cloudIdProp,
                    absoluteUrl: configFetchAbsoluteUrl,
                    hostName: aggregatorHostName,
                    userId: userId,
                    degradationCallback: degradationCallback,
                    cacheAnalyticsCallback: cacheAnalyticsCallback,
                    expiration: 900000,
                    returnExpired: true,
                    onlyRefreshIfExpired: true,
                    networkCallbacks: networkCallbacks
                };
                fireAnalyticsEvent((0, $3eS8z.onTaskStart)({
                    searchSessionId: searchSessionId,
                    taskId: taskId,
                    task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_UX),
                    moreContext: {
                        experience: experience
                    }
                }));
                (0, $i9pyX.getSearchConfigV2)(searchConfigParams).then((response_1)=>{
                    setFirstPartyResponse(response_1);
                    fireAnalyticsEvent((0, $3eS8z.onTaskSuccess)({
                        searchSessionId: searchSessionId,
                        taskId: taskId,
                        task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_UX),
                        moreContext: {
                            timeTaken: performance.now() - taskStartAt,
                            experience: experience
                        }
                    }));
                }).catch((error_1)=>{
                    logException(error_1);
                    fireAnalyticsEvent((0, $3eS8z.onFailedDependency)({
                        dependency: "search-config",
                        searchSessionId: searchSessionId,
                        source: source,
                        actionSubject: actionSubject
                    }));
                    fireAnalyticsEvent((0, $3eS8z.onTaskFail)({
                        searchSessionId: searchSessionId,
                        taskId: taskId,
                        task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_UX),
                        moreContext: {
                            error: error_1.name,
                            timeTaken: performance.now() - taskStartAt,
                            experience: experience
                        }
                    }));
                    setFirstPartyResponse({
                        resources: [],
                        intercomHmac: "",
                        siteMetadata: []
                    });
                });
            }
        };
        t10 = [
            firstPartyResponse,
            setFirstPartyResponse,
            cloudIdProp,
            configFetchAbsoluteUrl,
            aggregatorHostName,
            userId,
            logException,
            fireAnalyticsEvent,
            searchSessionId,
            source,
            actionSubject,
            taskNamePrefix,
            createNetworkCallbacks,
            experience
        ];
        $[24] = actionSubject;
        $[25] = aggregatorHostName;
        $[26] = cloudIdProp;
        $[27] = configFetchAbsoluteUrl;
        $[28] = createNetworkCallbacks;
        $[29] = experience;
        $[30] = fireAnalyticsEvent;
        $[31] = firstPartyResponse;
        $[32] = logException;
        $[33] = searchSessionId;
        $[34] = source;
        $[35] = taskNamePrefix;
        $[36] = userId;
        $[37] = t10;
        $[38] = t9;
    } else {
        t10 = $[37];
        t9 = $[38];
    }
    (0, $cozmU.useEffect)(t9, t10);
    let t11;
    if ($[39] !== accessibleProductsConfig.products || $[40] !== cloudIdProp || $[41] !== firstPartyResponse || $[42] !== primaryProduct || $[43] !== thirdPartyResponse.productKeys || $[44] !== thirdPartyResponse.thirdPartyConfigs) {
        t11 = ()=>{
            if (thirdPartyResponse.productKeys && firstPartyResponse && !accessibleProductsConfig.products) {
                let allAccessibleProducts = [];
                const firstPartyProducts = [
                    ...new Set(firstPartyResponse.resources.flatMap($b217d7e94854b92c$var$_temp2))
                ];
                if (firstPartyProducts.length === 0 && primaryProduct) allAccessibleProducts.push(primaryProduct);
                else allAccessibleProducts.push(...firstPartyProducts);
                const areNounsEnabledThroughLegacyFlag = (0, $0SpY7.isNounsAvailable)(firstPartyResponse, cloudIdProp);
                const accessibleNouns = areNounsEnabledThroughLegacyFlag ? [] : firstPartyResponse.resources.flatMap($b217d7e94854b92c$var$_temp3);
                if (accessibleNouns.length > 0 && !areNounsEnabledThroughLegacyFlag) allAccessibleProducts.push((0, $aqAfG.ProductKeys1P).Atlas);
                if (allAccessibleProducts.includes("bitbucket") && !firstPartyResponse.resources.find($b217d7e94854b92c$var$_temp4)) allAccessibleProducts = allAccessibleProducts.filter($b217d7e94854b92c$var$_temp5);
                const doesUserHaveRovo = (0, $lKvkH.isRovoEnabled)(firstPartyResponse, cloudIdProp);
                if (doesUserHaveRovo) {
                    const thirdPartyProductKeys = thirdPartyResponse.productKeys || [];
                    allAccessibleProducts.push(...thirdPartyProductKeys);
                    setAccessibleProductsConfig({
                        products: allAccessibleProducts,
                        nouns: accessibleNouns,
                        thirdPartyConfigs: thirdPartyResponse.thirdPartyConfigs
                    });
                } else setAccessibleProductsConfig({
                    products: allAccessibleProducts,
                    nouns: accessibleNouns,
                    thirdPartyConfigs: {}
                });
                setIsConfigLoaded(true);
            }
        };
        $[39] = accessibleProductsConfig.products;
        $[40] = cloudIdProp;
        $[41] = firstPartyResponse;
        $[42] = primaryProduct;
        $[43] = thirdPartyResponse.productKeys;
        $[44] = thirdPartyResponse.thirdPartyConfigs;
        $[45] = t11;
    } else t11 = $[45];
    let t12;
    if ($[46] !== accessibleProductsConfig.products || $[47] !== cloudIdProp || $[48] !== fireAnalyticsEvent || $[49] !== firstPartyResponse || $[50] !== isUserLoomAuthed || $[51] !== logException || $[52] !== primaryProduct || $[53] !== thirdPartyResponse) {
        t12 = [
            isUserLoomAuthed,
            thirdPartyResponse,
            firstPartyResponse,
            setAccessibleProductsConfig,
            primaryProduct,
            fireAnalyticsEvent,
            logException,
            cloudIdProp,
            accessibleProductsConfig.products
        ];
        $[46] = accessibleProductsConfig.products;
        $[47] = cloudIdProp;
        $[48] = fireAnalyticsEvent;
        $[49] = firstPartyResponse;
        $[50] = isUserLoomAuthed;
        $[51] = logException;
        $[52] = primaryProduct;
        $[53] = thirdPartyResponse;
        $[54] = t12;
    } else t12 = $[54];
    (0, $cozmU.useEffect)(t11, t12);
    let t13;
    if ($[55] !== accessibleProductsConfig.products || $[56] !== isUserLoomAuthed) {
        t13 = (0, $ixfCV.fg)("rovo-search-combined-loom-auth") ? accessibleProductsConfig.products : $b217d7e94854b92c$var$lastMileProductChecks(isUserLoomAuthed, accessibleProductsConfig.products);
        $[55] = accessibleProductsConfig.products;
        $[56] = isUserLoomAuthed;
        $[57] = t13;
    } else t13 = $[57];
    const accessibleProducts = t13;
    const t14 = accessibleProductsConfig.nouns;
    const t15 = accessibleProductsConfig.thirdPartyConfigs;
    const t16 = firstPartyResponse?.intercomHmac;
    let t17;
    if ($[58] !== cloudIdProp || $[59] !== firstPartyResponse) {
        t17 = (0, $0SpY7.isNounsAvailable)(firstPartyResponse, cloudIdProp);
        $[58] = cloudIdProp;
        $[59] = firstPartyResponse;
        $[60] = t17;
    } else t17 = $[60];
    let t18;
    if ($[61] !== cloudIdProp || $[62] !== firstPartyResponse) {
        t18 = (0, $lKvkH.isRovoEnabled)(firstPartyResponse, cloudIdProp);
        $[61] = cloudIdProp;
        $[62] = firstPartyResponse;
        $[63] = t18;
    } else t18 = $[63];
    let t19;
    if ($[64] !== cloudIdProp || $[65] !== firstPartyResponse) {
        t19 = (0, $33u17.getJiraIssueIndexedForTenant)(firstPartyResponse, cloudIdProp);
        $[64] = cloudIdProp;
        $[65] = firstPartyResponse;
        $[66] = t19;
    } else t19 = $[66];
    let t20;
    if ($[67] !== cloudIdProp || $[68] !== firstPartyResponse) {
        t20 = (0, $lG3cK.getProductEdition)(firstPartyResponse, cloudIdProp);
        $[67] = cloudIdProp;
        $[68] = firstPartyResponse;
        $[69] = t20;
    } else t20 = $[69];
    let t21;
    if ($[70] !== cloudIdProp || $[71] !== firstPartyResponse) {
        t21 = (0, $fIdaz.getProductDataRegions)(firstPartyResponse, cloudIdProp);
        $[70] = cloudIdProp;
        $[71] = firstPartyResponse;
        $[72] = t21;
    } else t21 = $[72];
    let t22;
    if ($[73] !== cloudIdProp || $[74] !== firstPartyResponse) {
        t22 = (0, $23xJD.getRovoFeatures)(firstPartyResponse, cloudIdProp);
        $[73] = cloudIdProp;
        $[74] = firstPartyResponse;
        $[75] = t22;
    } else t22 = $[75];
    let t23;
    if ($[76] !== accessibleProducts || $[77] !== accessibleProductsConfig.nouns || $[78] !== accessibleProductsConfig.thirdPartyConfigs || $[79] !== firstCloudId || $[80] !== isConfigLoaded || $[81] !== linkedCloudARIs || $[82] !== t16 || $[83] !== t17 || $[84] !== t18 || $[85] !== t19 || $[86] !== t20 || $[87] !== t21 || $[88] !== t22) {
        t23 = {
            accessibleProducts: accessibleProducts,
            accessibleNouns: t14,
            thirdPartyConfigs: t15,
            firstCloudId: firstCloudId,
            intercomHmac: t16,
            isNounsAvailable: t17,
            isRovoEnabled: t18,
            isJiraIssueIndexed: t19,
            productEdition: t20,
            productDataRegions: t21,
            rovoFeatures: t22,
            isConfigLoaded: isConfigLoaded,
            linkedCloudARIs: linkedCloudARIs
        };
        $[76] = accessibleProducts;
        $[77] = accessibleProductsConfig.nouns;
        $[78] = accessibleProductsConfig.thirdPartyConfigs;
        $[79] = firstCloudId;
        $[80] = isConfigLoaded;
        $[81] = linkedCloudARIs;
        $[82] = t16;
        $[83] = t17;
        $[84] = t18;
        $[85] = t19;
        $[86] = t20;
        $[87] = t21;
        $[88] = t22;
        $[89] = t23;
    } else t23 = $[89];
    return t23;
} : ({ cloudId: cloudIdProp, configFetchAbsoluteUrl: configFetchAbsoluteUrl, aggregatorHostName: aggregatorHostName, userId: userId, thirdPartyAbsoluteUrl: thirdPartyAbsoluteUrl, thirdPartyDisabled: thirdPartyDisabled, primaryProduct: primaryProduct, aggAbsoluteUrl: aggAbsoluteUrl, multiSiteSearchInRovo: multiSiteSearchInRovo, experience: experience, analytics: analytics })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent, logException: logException, searchSessionId: searchSessionId, source: source, actionSubject: actionSubject, taskNamePrefix: taskNamePrefix, createNetworkCallbacks: createNetworkCallbacks } = analytics;
    const [firstPartyResponse, setFirstPartyResponse] = (0, $cozmU.useState)();
    const [isConfigLoaded, setIsConfigLoaded] = (0, $cozmU.useState)(false);
    // Loom requires a separate auth check
    const [isUserLoomAuthed, setIsUserLoomAuthed] = (0, $cozmU.useState)(false);
    // Rovo Multiple Site Search
    const [linkedCloudARIs, setLinkedCloudARIs] = (0, $cozmU.useState)(undefined);
    const [accessibleProductsConfig, setAccessibleProductsConfig] = (0, $cozmU.useState)({
        nouns: []
    });
    const firstCloudId = (0, $cozmU.useMemo)(()=>{
        if (!cloudIdProp && firstPartyResponse) return (0, $5OPAY.getFirstCloudId)(firstPartyResponse);
        return '';
    }, [
        firstPartyResponse,
        cloudIdProp
    ]);
    const thirdPartyResponse = $b217d7e94854b92c$export$4fc2f66fb6e9d067({
        cloudId: cloudIdProp || firstCloudId || '',
        userId: userId,
        absoluteUrl: thirdPartyAbsoluteUrl,
        disabled: thirdPartyDisabled,
        experience: experience,
        analytics: analytics
    });
    // Rovo Multiple Site Search - Store linked site ARIs in state
    (0, $cozmU.useEffect)(()=>{
        const cloudId = cloudIdProp || firstCloudId;
        if (cloudId && multiSiteSearchInRovo) (0, $dv1ov.searchLinkedSitesQuery)({
            variables: {
                id: `ari:cloud:confluence::site/${cloudId}`
            },
            aggAbsoluteUrl: aggAbsoluteUrl
        }).then((response)=>{
            const edges = response?.data?.collabContext_workspaceIsConnectedToWorkspace?.edges ?? [];
            const linkedARIs = edges.map((edge)=>edge.node.id);
            const currentCloudIdARI = `ari:cloud:confluence::site/${cloudId}`;
            const currentIndex = linkedARIs.findIndex((ari)=>ari === currentCloudIdARI);
            if (currentIndex > 0) {
                linkedARIs.splice(currentIndex, 1);
                linkedARIs.unshift(currentCloudIdARI);
            }
            setLinkedCloudARIs(linkedARIs);
        }).catch((error)=>{
            logException(error);
        });
    }, [
        cloudIdProp,
        firstCloudId,
        multiSiteSearchInRovo,
        logException,
        aggAbsoluteUrl
    ]);
    // Loom auth check
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $ixfCV.fg)('rovo-search-combined-loom-auth') && !isUserLoomAuthed) {
            if (primaryProduct === (0, $d396o.PrimaryProductKeys).Confluence || primaryProduct === (0, $d396o.PrimaryProductKeys).Atlas || (primaryProduct === (0, $d396o.PrimaryProductKeys).Jira || primaryProduct === (0, $d396o.PrimaryProductKeys).Focus) && (0, $ixfCV.fg)('search_loom_auth_check_in_jira_mercury')) (0, $i9pyX.getUserLoomAuthStatus)({
                userId: userId,
                cloudId: cloudIdProp
            }).then((response_0)=>setIsUserLoomAuthed(response_0?.status === 'mastered')).catch((error_0)=>{
                logException(error_0);
                setIsUserLoomAuthed(false);
            });
            else setIsUserLoomAuthed(true);
        }
    }, [
        isUserLoomAuthed,
        setIsUserLoomAuthed,
        userId,
        logException,
        cloudIdProp,
        primaryProduct
    ]);
    // Fetch 1P config
    (0, $cozmU.useEffect)(()=>{
        if (!firstPartyResponse) {
            const taskStartAt = performance.now();
            const taskId = crypto.randomUUID();
            const degradationCallback = (reason)=>{
                fireAnalyticsEvent((0, $3eS8z.onDegradedDependency)({
                    dependency: 'search-config',
                    searchSessionId: searchSessionId,
                    reason: reason,
                    source: source,
                    actionSubject: actionSubject
                }));
            };
            const cacheAnalyticsCallback = async (state)=>{
                fireAnalyticsEvent((0, $3eS8z.onRequestCacheAccess)({
                    requestName: 'search-config',
                    searchSessionId: searchSessionId,
                    cacheHit: state.hit,
                    refreshTriggered: state.refreshTriggered,
                    source: source,
                    actionSubject: actionSubject
                }));
            };
            const search1PConfigTTL = 900000; // 15 minutes
            const networkCallbacks = createNetworkCallbacks ? createNetworkCallbacks(taskId, (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_NETWORK), searchSessionId, fireAnalyticsEvent, taskStartAt, {}) : undefined;
            const searchConfigParams = {
                cloudId: cloudIdProp,
                absoluteUrl: configFetchAbsoluteUrl,
                hostName: aggregatorHostName,
                userId: userId,
                degradationCallback: degradationCallback,
                cacheAnalyticsCallback: cacheAnalyticsCallback,
                expiration: search1PConfigTTL,
                returnExpired: true,
                onlyRefreshIfExpired: true,
                networkCallbacks: networkCallbacks
            };
            fireAnalyticsEvent((0, $3eS8z.onTaskStart)({
                searchSessionId: searchSessionId,
                taskId: taskId,
                task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_UX),
                moreContext: {
                    experience: experience
                }
            }));
            (0, $i9pyX.getSearchConfigV2)(searchConfigParams).then((response_1)=>{
                setFirstPartyResponse(response_1);
                fireAnalyticsEvent((0, $3eS8z.onTaskSuccess)({
                    searchSessionId: searchSessionId,
                    taskId: taskId,
                    task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_UX),
                    moreContext: {
                        timeTaken: performance.now() - taskStartAt,
                        experience: experience
                    }
                }));
            }).catch((error_1)=>{
                logException(error_1);
                fireAnalyticsEvent((0, $3eS8z.onFailedDependency)({
                    dependency: 'search-config',
                    searchSessionId: searchSessionId,
                    source: source,
                    actionSubject: actionSubject
                }));
                fireAnalyticsEvent((0, $3eS8z.onTaskFail)({
                    searchSessionId: searchSessionId,
                    taskId: taskId,
                    task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_UX),
                    moreContext: {
                        error: error_1.name,
                        timeTaken: performance.now() - taskStartAt,
                        experience: experience
                    }
                }));
                setFirstPartyResponse({
                    resources: [],
                    intercomHmac: '',
                    siteMetadata: []
                });
            });
        }
    }, [
        firstPartyResponse,
        setFirstPartyResponse,
        cloudIdProp,
        configFetchAbsoluteUrl,
        aggregatorHostName,
        userId,
        logException,
        fireAnalyticsEvent,
        searchSessionId,
        source,
        actionSubject,
        taskNamePrefix,
        createNetworkCallbacks,
        experience
    ]);
    // Combine 1P and 3P config
    (0, $cozmU.useEffect)(()=>{
        if (thirdPartyResponse.productKeys && firstPartyResponse && !accessibleProductsConfig.products) {
            let allAccessibleProducts = [];
            const firstPartyProducts = [
                ...new Set(firstPartyResponse.resources.flatMap((resource)=>{
                    const { id: id } = resource;
                    const match = id.match($b217d7e94854b92c$var$EXTRACT_PRODUCT);
                    if (match && match.length >= 2) {
                        const normalizedProduct = $b217d7e94854b92c$var$normalizeProductFromAri(match[1]);
                        if ((0, $aqAfG.ARI_EXTRACTED_1P_KEYS).includes(normalizedProduct)) return [
                            normalizedProduct
                        ];
                        // Loom delivers a 1P-style ARI (ari:cloud:loom::site/...) but is classified
                        // as a 3P product (ProductKeys3P.Loom).
                        if (normalizedProduct === (0, $fR63l.ProductKeys3P).Loom) return [
                            normalizedProduct
                        ];
                    }
                    return [];
                }))
            ];
            if (firstPartyProducts.length === 0 && primaryProduct) allAccessibleProducts.push(primaryProduct);
            else allAccessibleProducts.push(...firstPartyProducts);
            const areNounsEnabledThroughLegacyFlag = (0, $0SpY7.isNounsAvailable)(firstPartyResponse, cloudIdProp);
            const accessibleNouns = areNounsEnabledThroughLegacyFlag ? [] : firstPartyResponse.resources.flatMap((resource_0)=>{
                const { id: id_0 } = resource_0;
                const match_0 = id_0.match($b217d7e94854b92c$var$EXTRACT_PRODUCT);
                if (match_0 && match_0.length >= 2 && match_0[1] in $b217d7e94854b92c$var$supportedNouns) return [
                    match_0[1]
                ];
                return [];
            });
            if (accessibleNouns.length > 0 && !areNounsEnabledThroughLegacyFlag) allAccessibleProducts.push((0, $aqAfG.ProductKeys1P).Atlas);
            if (allAccessibleProducts.includes('bitbucket') && !firstPartyResponse.resources.find((r)=>r.id.includes($b217d7e94854b92c$var$BITBUCKET_WORKSPACE_ARI))) allAccessibleProducts = allAccessibleProducts.filter((product)=>product !== (0, $aqAfG.ProductKeys1P).Bitbucket);
            const doesUserHaveRovo = (0, $lKvkH.isRovoEnabled)(firstPartyResponse, cloudIdProp);
            if (doesUserHaveRovo) {
                const thirdPartyProductKeys = thirdPartyResponse.productKeys || [];
                allAccessibleProducts.push(...thirdPartyProductKeys);
                setAccessibleProductsConfig({
                    products: allAccessibleProducts,
                    nouns: accessibleNouns,
                    thirdPartyConfigs: thirdPartyResponse.thirdPartyConfigs
                });
            } else setAccessibleProductsConfig({
                products: allAccessibleProducts,
                nouns: accessibleNouns,
                thirdPartyConfigs: {}
            });
            setIsConfigLoaded(true);
        }
    }, [
        isUserLoomAuthed,
        thirdPartyResponse,
        firstPartyResponse,
        setAccessibleProductsConfig,
        primaryProduct,
        fireAnalyticsEvent,
        logException,
        cloudIdProp,
        accessibleProductsConfig.products
    ]);
    const accessibleProducts = (0, $ixfCV.fg)('rovo-search-combined-loom-auth') ? accessibleProductsConfig.products : $b217d7e94854b92c$var$lastMileProductChecks(isUserLoomAuthed, accessibleProductsConfig.products);
    return {
        accessibleProducts: accessibleProducts,
        accessibleNouns: accessibleProductsConfig.nouns,
        thirdPartyConfigs: accessibleProductsConfig.thirdPartyConfigs,
        firstCloudId: firstCloudId,
        intercomHmac: firstPartyResponse?.intercomHmac,
        isNounsAvailable: (0, $0SpY7.isNounsAvailable)(firstPartyResponse, cloudIdProp),
        isRovoEnabled: (0, $lKvkH.isRovoEnabled)(firstPartyResponse, cloudIdProp),
        isJiraIssueIndexed: (0, $33u17.getJiraIssueIndexedForTenant)(firstPartyResponse, cloudIdProp),
        productEdition: (0, $lG3cK.getProductEdition)(firstPartyResponse, cloudIdProp),
        productDataRegions: (0, $fIdaz.getProductDataRegions)(firstPartyResponse, cloudIdProp),
        rovoFeatures: (0, $23xJD.getRovoFeatures)(firstPartyResponse, cloudIdProp),
        isConfigLoaded: isConfigLoaded,
        linkedCloudARIs: linkedCloudARIs
    };
};
const $b217d7e94854b92c$export$6750011b01164bda = async ()=>{
    const oldThirdPartyTypes = {
        'ai-3p-connector:sharepoint-domain': 'sharepoint',
        'ai-3p-connector:google-workspace': 'drive'
    };
    const thirdPartyTypes = {
        ...oldThirdPartyTypes,
        'lite-connector-gdrive': 'drive',
        'smartlinks-connector-gdrive': 'drive',
        'smartlinks-connector-gdrive-rsl': 'drive',
        'smartlinks-connector-salesforce': 'salesforce',
        'smartlinks-connector-airtable': 'airtable',
        'smartlinks-connector-figma': 'figma',
        'smartlinks-connector-gitlab': 'gitlab',
        'smartlinks-connector-miro': 'miro',
        'smartlinks-connector-asana': 'asana',
        'smartlinks-connector-smartsheet': 'smartsheet',
        'smartlinks-connector-dropbox': 'dropbox',
        'smartlinks-connector-box': 'box',
        'smartlinks-connector-lucid': 'lucid',
        'smartlinks-connector-hubspot': 'hubspot',
        'smartlinks-connector-docusign': 'docusign',
        'smartlinks-connector-slack': 'slack',
        'smartlinks-connector-teams': 'teams',
        'smartlinks-connector-azure-devops': 'azure-devops',
        'smartlinks-connector-notion': 'notion',
        'smartlinks-connector-onedrive': 'onedrive',
        'smartlinks-connector-sharepoint': 'sharepoint'
    };
    await (0, $dAuCI.ThirdPartyConfigs).forEach((config)=>{
        if (config.resourceType) thirdPartyTypes[config.resourceType] = config.id;
    });
    return thirdPartyTypes;
};
const $b217d7e94854b92c$export$b58c1135b7f9df6d = async ({ cloudId: cloudId, absoluteUrl: absoluteUrl, userId: userId, degradationCallback: degradationCallback, cacheAnalyticsCallback: cacheAnalyticsCallback, networkCallbacks: networkCallbacks })=>{
    const THIRD_PARTY_TYPES = await $b217d7e94854b92c$export$6750011b01164bda();
    const searchConfigParams = {
        cloudId: cloudId,
        absoluteUrl: absoluteUrl,
        userId: userId,
        degradationCallback: degradationCallback,
        cacheAnalyticsCallback: cacheAnalyticsCallback,
        expiration: 60000,
        // 1 minute
        returnExpired: true,
        onlyRefreshIfExpired: true,
        networkCallbacks: networkCallbacks
    };
    const resources = await (0, $i9pyX.get3pSearchConfig)(searchConfigParams);
    const connectorSourceMap = new Map();
    let productKeys = [];
    let thirdPartyConfigsWithAPIResponse = {};
    for (const resource of resources){
        if ((0, $aoy1P.isForgeConnectorProductKey)(resource.type) && (0, $ixfCV.fg)('rovo-search-dynamic-forge-config')) {
            const config = (0, $eSwze.mapForgeConnectorToThirdPartyConfig)(resource);
            if (config) {
                const productKey = resource.type;
                productKeys.push(productKey);
                thirdPartyConfigsWithAPIResponse[productKey] = config;
            }
            continue;
        }
        const productKey = THIRD_PARTY_TYPES[resource.type] || '';
        if (!productKey) continue;
        const { providerId: providerId, datasourceId: datasourceId } = resource;
        productKeys.push(productKey);
        let config = {};
        const staticConfig = await (0, $dAuCI.ThirdPartyConfigs).get(productKey);
        if (staticConfig) {
            const isFederatedNoOAuthConnector = $b217d7e94854b92c$var$FEDERATED_NO_OAUTH_PRODUCT_KEYS.has(productKey) && resource.connectorSyncType === (0, $aoy1P.FEDERATED_CONNECTOR_SOURCE);
            let sourceType;
            if (resource.type.startsWith((0, $aoy1P.SMARTLINKS_CONNECTOR_SOURCE))) sourceType = (0, $aoy1P.SMARTLINKS_CONNECTOR_SOURCE);
            else if (resource.type.startsWith((0, $aoy1P.LITE_CONNECTOR_SOURCE))) sourceType = (0, $aoy1P.LITE_CONNECTOR_SOURCE);
            else if (isFederatedNoOAuthConnector) sourceType = (0, $aoy1P.FEDERATED_CONNECTOR_SOURCE);
            else if (staticConfig.isFederated) sourceType = (0, $aoy1P.FEDERATED_CONNECTOR_SOURCE);
            else sourceType = (0, $aoy1P.FULL_CONNECTOR_SOURCE);
            connectorSourceMap.set(providerId, (connectorSourceMap.get(providerId) || new Set()).add(sourceType));
            const existingConfig = thirdPartyConfigsWithAPIResponse[productKey];
            const isExistingConfigFullConnectorSource = existingConfig?.connectorSources?.includes((0, $aoy1P.FULL_CONNECTOR_SOURCE)) || false;
            const outboundAuthUrl = isFederatedNoOAuthConnector ? '' : isExistingConfigFullConnectorSource && existingConfig?.outboundAuthUrl ? existingConfig.outboundAuthUrl : resource.outboundAuthUrl;
            const userNeedsOAuth = isFederatedNoOAuthConnector ? false : isExistingConfigFullConnectorSource && existingConfig ? existingConfig.userNeedsOAuth : !resource.isUserOAuthed;
            config = {
                ...staticConfig,
                outboundAuthUrl: outboundAuthUrl,
                userNeedsOAuth: userNeedsOAuth,
                providerId: providerId,
                datasourceId: datasourceId,
                connectionId: resource.connectionId,
                workspaceName: resource.workspaceName,
                workspaceUrl: resource.workspaceUrl,
                connectorSources: Array.from(connectorSourceMap.get(providerId) || []),
                impersonationEnabled: resource.isImpersonationAuthEnabled
            };
            const datasourceList = [];
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { datasources: datasources, ...configWithoutDatasources } = config;
            configWithoutDatasources.datasourceId = resource.datasourceId;
            configWithoutDatasources.connectionId = resource.connectionId;
            const datasource = {
                ...configWithoutDatasources,
                ...resource,
                outboundAuthUrl: isFederatedNoOAuthConnector ? '' : resource.outboundAuthUrl,
                userNeedsOAuth: isFederatedNoOAuthConnector ? false : !resource.isUserOAuthed,
                integrationAri: resource.integrationId || configWithoutDatasources.integrationAri
            };
            datasourceList.push(datasource);
            const extraDatasources = thirdPartyConfigsWithAPIResponse[productKey]?.datasources || [];
            const cleanedExtraDatasources = extraDatasources.map(// eslint-disable-next-line @typescript-eslint/no-unused-vars
            ({ datasources: datasources, ...configWithoutDatasources })=>configWithoutDatasources);
            datasourceList.push(...cleanedExtraDatasources);
            config.datasources = datasourceList;
            thirdPartyConfigsWithAPIResponse[productKey] = config;
        }
    }
    const filteredProductKeys = productKeys.filter((productKey)=>{
        if ((0, $aoy1P.isForgeConnectorProductKey)(productKey)) return true;
        return $b217d7e94854b92c$var$allProductKeys.includes(productKey);
    });
    return {
        productKeys: filteredProductKeys,
        thirdPartyConfigs: thirdPartyConfigsWithAPIResponse
    };
};
const $b217d7e94854b92c$var$EMPTY_RESPONSE = [];
const $b217d7e94854b92c$export$4fc2f66fb6e9d067 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { cloudId: cloudId, absoluteUrl: absoluteUrl, userId: userId, disabled: disabled, experience: experience, analytics: analytics } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {};
        $[0] = t1;
    } else t1 = $[0];
    const [config, setConfig] = (0, $cozmU.useState)(t1);
    const { fireAnalyticsEvent: fireAnalyticsEvent, logException: logException, searchSessionId: searchSessionId, source: source, actionSubject: actionSubject, taskNamePrefix: taskNamePrefix, createNetworkCallbacks: createNetworkCallbacks } = analytics;
    let t2;
    if ($[1] !== absoluteUrl || $[2] !== actionSubject || $[3] !== cloudId || $[4] !== config.productKeys || $[5] !== createNetworkCallbacks || $[6] !== disabled || $[7] !== experience || $[8] !== fireAnalyticsEvent || $[9] !== logException || $[10] !== searchSessionId || $[11] !== source || $[12] !== taskNamePrefix || $[13] !== userId) {
        t2 = ()=>{
            if (!config.productKeys) {
                if (!disabled && cloudId) {
                    const taskStartAt = performance.now();
                    const taskId = crypto.randomUUID();
                    fireAnalyticsEvent((0, $3eS8z.onTaskStart)({
                        searchSessionId: searchSessionId,
                        taskId: taskId,
                        task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_UX),
                        moreContext: {
                            experience: experience
                        }
                    }));
                    const networkCallbacks = createNetworkCallbacks ? createNetworkCallbacks(taskId, (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_NETWORK), searchSessionId, fireAnalyticsEvent, taskStartAt, {
                        experience: experience
                    }) : undefined;
                    const degradationCallback = (reason)=>{
                        fireAnalyticsEvent((0, $3eS8z.onDegradedDependency)({
                            dependency: "search-3p-config",
                            searchSessionId: searchSessionId,
                            reason: reason,
                            source: source,
                            actionSubject: actionSubject
                        }));
                    };
                    const cacheAnalyticsCallback = async (state)=>{
                        fireAnalyticsEvent((0, $3eS8z.onRequestCacheAccess)({
                            requestName: "search-3p-config",
                            searchSessionId: searchSessionId,
                            cacheHit: state.hit,
                            refreshTriggered: state.refreshTriggered,
                            source: source,
                            actionSubject: actionSubject
                        }));
                    };
                    $b217d7e94854b92c$export$b58c1135b7f9df6d({
                        cloudId: cloudId,
                        absoluteUrl: absoluteUrl,
                        userId: userId,
                        degradationCallback: degradationCallback,
                        cacheAnalyticsCallback: cacheAnalyticsCallback,
                        networkCallbacks: networkCallbacks
                    }).then((data)=>{
                        setConfig({
                            productKeys: data.productKeys,
                            thirdPartyConfigs: data.thirdPartyConfigs
                        });
                        fireAnalyticsEvent((0, $3eS8z.onTaskSuccess)({
                            searchSessionId: searchSessionId,
                            taskId: taskId,
                            task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_UX),
                            moreContext: {
                                timeTaken: performance.now() - taskStartAt,
                                experience: experience
                            }
                        }));
                    }).catch((error)=>{
                        fireAnalyticsEvent((0, $3eS8z.onFailedDependency)({
                            dependency: "search-3p-config",
                            searchSessionId: searchSessionId,
                            source: source,
                            actionSubject: actionSubject
                        }));
                        fireAnalyticsEvent((0, $3eS8z.onTaskFail)({
                            searchSessionId: searchSessionId,
                            taskId: taskId,
                            task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_UX),
                            moreContext: {
                                error: error.name,
                                timeTaken: performance.now() - taskStartAt,
                                experience: experience
                            }
                        }));
                        setConfig({
                            productKeys: $b217d7e94854b92c$var$EMPTY_RESPONSE,
                            thirdPartyConfigs: {}
                        });
                        logException(error);
                    });
                } else setConfig({
                    productKeys: $b217d7e94854b92c$var$EMPTY_RESPONSE,
                    thirdPartyConfigs: {}
                });
            }
        };
        $[1] = absoluteUrl;
        $[2] = actionSubject;
        $[3] = cloudId;
        $[4] = config.productKeys;
        $[5] = createNetworkCallbacks;
        $[6] = disabled;
        $[7] = experience;
        $[8] = fireAnalyticsEvent;
        $[9] = logException;
        $[10] = searchSessionId;
        $[11] = source;
        $[12] = taskNamePrefix;
        $[13] = userId;
        $[14] = t2;
    } else t2 = $[14];
    let t3;
    if ($[15] !== absoluteUrl || $[16] !== actionSubject || $[17] !== cloudId || $[18] !== config || $[19] !== createNetworkCallbacks || $[20] !== disabled || $[21] !== experience || $[22] !== fireAnalyticsEvent || $[23] !== logException || $[24] !== searchSessionId || $[25] !== source || $[26] !== taskNamePrefix || $[27] !== userId) {
        t3 = [
            cloudId,
            absoluteUrl,
            userId,
            disabled,
            config,
            logException,
            fireAnalyticsEvent,
            searchSessionId,
            source,
            actionSubject,
            taskNamePrefix,
            createNetworkCallbacks,
            experience
        ];
        $[15] = absoluteUrl;
        $[16] = actionSubject;
        $[17] = cloudId;
        $[18] = config;
        $[19] = createNetworkCallbacks;
        $[20] = disabled;
        $[21] = experience;
        $[22] = fireAnalyticsEvent;
        $[23] = logException;
        $[24] = searchSessionId;
        $[25] = source;
        $[26] = taskNamePrefix;
        $[27] = userId;
        $[28] = t3;
    } else t3 = $[28];
    (0, $cozmU.useEffect)(t2, t3);
    return config;
} : ({ cloudId: cloudId, absoluteUrl: absoluteUrl, userId: userId, disabled: disabled, experience: experience, analytics: analytics })=>{
    const [config, setConfig] = (0, $cozmU.useState)({});
    const { fireAnalyticsEvent: fireAnalyticsEvent, logException: logException, searchSessionId: searchSessionId, source: source, actionSubject: actionSubject, taskNamePrefix: taskNamePrefix, createNetworkCallbacks: createNetworkCallbacks } = analytics;
    (0, $cozmU.useEffect)(()=>{
        if (!config.productKeys) {
            if (!disabled && cloudId) {
                const taskStartAt = performance.now();
                const taskId = crypto.randomUUID();
                fireAnalyticsEvent((0, $3eS8z.onTaskStart)({
                    searchSessionId: searchSessionId,
                    taskId: taskId,
                    task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_UX),
                    moreContext: {
                        experience: experience
                    }
                }));
                const networkCallbacks = createNetworkCallbacks ? createNetworkCallbacks(taskId, (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_NETWORK), searchSessionId, fireAnalyticsEvent, taskStartAt, {
                    experience: experience
                }) : undefined;
                const degradationCallback = (reason)=>{
                    fireAnalyticsEvent((0, $3eS8z.onDegradedDependency)({
                        dependency: 'search-3p-config',
                        searchSessionId: searchSessionId,
                        reason: reason,
                        source: source,
                        actionSubject: actionSubject
                    }));
                };
                const cacheAnalyticsCallback = async (state)=>{
                    fireAnalyticsEvent((0, $3eS8z.onRequestCacheAccess)({
                        requestName: 'search-3p-config',
                        searchSessionId: searchSessionId,
                        cacheHit: state.hit,
                        refreshTriggered: state.refreshTriggered,
                        source: source,
                        actionSubject: actionSubject
                    }));
                };
                $b217d7e94854b92c$export$b58c1135b7f9df6d({
                    cloudId: cloudId,
                    absoluteUrl: absoluteUrl,
                    userId: userId,
                    degradationCallback: degradationCallback,
                    cacheAnalyticsCallback: cacheAnalyticsCallback,
                    networkCallbacks: networkCallbacks
                }).then((data)=>{
                    setConfig({
                        productKeys: data.productKeys,
                        thirdPartyConfigs: data.thirdPartyConfigs
                    });
                    fireAnalyticsEvent((0, $3eS8z.onTaskSuccess)({
                        searchSessionId: searchSessionId,
                        taskId: taskId,
                        task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_UX),
                        moreContext: {
                            timeTaken: performance.now() - taskStartAt,
                            experience: experience
                        }
                    }));
                }).catch((error)=>{
                    fireAnalyticsEvent((0, $3eS8z.onFailedDependency)({
                        dependency: 'search-3p-config',
                        searchSessionId: searchSessionId,
                        source: source,
                        actionSubject: actionSubject
                    }));
                    fireAnalyticsEvent((0, $3eS8z.onTaskFail)({
                        searchSessionId: searchSessionId,
                        taskId: taskId,
                        task: (0, $7fkiQ.buildTaskName)(taskNamePrefix, (0, $92KTD.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_UX),
                        moreContext: {
                            error: error.name,
                            timeTaken: performance.now() - taskStartAt,
                            experience: experience
                        }
                    }));
                    setConfig({
                        productKeys: $b217d7e94854b92c$var$EMPTY_RESPONSE,
                        thirdPartyConfigs: {}
                    });
                    logException(error);
                });
            } else setConfig({
                productKeys: $b217d7e94854b92c$var$EMPTY_RESPONSE,
                thirdPartyConfigs: {}
            });
        }
    }, [
        cloudId,
        absoluteUrl,
        userId,
        disabled,
        config,
        logException,
        fireAnalyticsEvent,
        searchSessionId,
        source,
        actionSubject,
        taskNamePrefix,
        createNetworkCallbacks,
        experience
    ]);
    return config;
};
function $b217d7e94854b92c$var$_temp(edge) {
    return edge.node.id;
}
function $b217d7e94854b92c$var$_temp2(resource) {
    const { id: id } = resource;
    const match = id.match($b217d7e94854b92c$var$EXTRACT_PRODUCT);
    if (match && match.length >= 2) {
        const normalizedProduct = $b217d7e94854b92c$var$normalizeProductFromAri(match[1]);
        if ((0, $aqAfG.ARI_EXTRACTED_1P_KEYS).includes(normalizedProduct)) return [
            normalizedProduct
        ];
        if (normalizedProduct === (0, $fR63l.ProductKeys3P).Loom) return [
            normalizedProduct
        ];
    }
    return [];
}
function $b217d7e94854b92c$var$_temp3(resource_0) {
    const { id: id_0 } = resource_0;
    const match_0 = id_0.match($b217d7e94854b92c$var$EXTRACT_PRODUCT);
    if (match_0 && match_0.length >= 2 && match_0[1] in $b217d7e94854b92c$var$supportedNouns) return [
        match_0[1]
    ];
    return [];
}
function $b217d7e94854b92c$var$_temp4(r) {
    return r.id.includes($b217d7e94854b92c$var$BITBUCKET_WORKSPACE_ARI);
}
function $b217d7e94854b92c$var$_temp5(product) {
    return product !== (0, $aqAfG.ProductKeys1P).Bitbucket;
}
module.exports["useFetchConfig"] = $b217d7e94854b92c$export$2b0ac18f7cd43e19;
module.exports["useThirdPartyConfig"] = $b217d7e94854b92c$export$4fc2f66fb6e9d067;
module.exports["getThirdPartyTypes"] = $b217d7e94854b92c$export$6750011b01164bda;
module.exports["get3pProductKeys"] = $b217d7e94854b92c$export$b58c1135b7f9df6d;

});

parcelRegister("i9pyX", function(module, exports) {

var $gABt9 = parcelRequire("gABt9");


var $bZF61 = parcelRequire("bZF61");


var $fyjce = parcelRequire("fyjce");


var $9C63M = parcelRequire("9C63M");


var $bfpjP = parcelRequire("bfpjP");


var $d9nAp = parcelRequire("d9nAp");

const $c1ab7bf16286d454$var$RELATIVE_URL = '/gateway/api/xpsearch-aggregator/configuration/v1';
const $c1ab7bf16286d454$var$RELATIVE_URL_V2 = '/gateway/api/xpsearch-aggregator/api/v2/configuration';
const $c1ab7bf16286d454$var$RELATIVE_3P_URL = '/gateway/api/third-party-configuration/connected-data-sources';
const $c1ab7bf16286d454$var$RELATIVE_LOOM_AUTH_URL = '/gateway/api/loom-auth/api/internal/identity/user-status';
const $c1ab7bf16286d454$export$19524a749d98a458 = 'search-config';
const $c1ab7bf16286d454$export$cf95148f36a28b96 = 'search-3p-config';
const $c1ab7bf16286d454$export$44d1e7c4ef26c467 = 'loom-user-auth';
const { refreshOnAccessDecorator: $c1ab7bf16286d454$var$refreshOnAccessDecoratorSearch } = (0, $fyjce.promiseCache)({
    name: $c1ab7bf16286d454$export$19524a749d98a458
});
const { refreshOnAccessDecorator: $c1ab7bf16286d454$var$refreshOnAccessDecorator3pSearch, update: $c1ab7bf16286d454$var$update3pCache } = (0, $fyjce.promiseCache)({
    name: $c1ab7bf16286d454$export$cf95148f36a28b96,
    expiration: 300000
});
const { refreshOnAccessDecorator: $c1ab7bf16286d454$var$refreshOnAccessDecoratorUserLoomAuth } = (0, $fyjce.promiseCache)({
    name: $c1ab7bf16286d454$export$44d1e7c4ef26c467
});
const $c1ab7bf16286d454$var$SITELESS_PRODUCTS = [
    'trello',
    'bitbucket'
];
/**
 * Creates a traceInfoExtractor that reads from a mutable headers reference.
 * Used by REST config endpoints to extract requestId/traceId from HTTP response headers
 * without storing them in the cache.
 */ const $c1ab7bf16286d454$var$createTraceInfoExtractor = (headersRef)=>{
    return ()=>{
        const headers = headersRef();
        const requestId = headers['atl-request-id'];
        const traceId = headers['x-trace-id'];
        if (requestId || traceId) return {
            requestId: requestId,
            traceId: traceId
        };
        return undefined;
    };
};
const $c1ab7bf16286d454$export$2e9655e8b4177582 = async ({ absoluteUrl: absoluteUrl = '', hostName: hostName, cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration })=>{
    const url = absoluteUrl || `${hostName || ''}${$c1ab7bf16286d454$var$RELATIVE_URL}`;
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = (0, $bZF61.generateHash)(`1p|${userId}|${cloudId}`);
    const supplier = ()=>(0, $gABt9.utils).requestService({
            url: url
        }, options).then((data)=>{
            const resources = data.resources.filter((resource)=>cloudId ? resource.id.includes(cloudId) || $c1ab7bf16286d454$var$SITELESS_PRODUCTS.find((product)=>resource.id.includes(product)) // Allow access to products that are not associated with a site
                 : true);
            return {
                resources: resources,
                intercomHmac: data.intercomHmac || '',
                siteMetadata: data.siteMetadata || []
            };
        });
    return $c1ab7bf16286d454$var$refreshOnAccessDecoratorSearch({
        key: key.toString(),
        supplier: supplier,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        serveResolvedDuringRefresh: true
    });
};
const $c1ab7bf16286d454$export$c6f4290269f11bd5 = async ({ absoluteUrl: absoluteUrl = '', hostName: hostName, cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, cacheAnalyticsCallback: cacheAnalyticsCallback, degradationCallback: degradationCallback = ()=>{}, returnExpired: returnExpired, networkCallbacks: networkCallbacks })=>{
    const url = absoluteUrl || `${hostName || ''}${$c1ab7bf16286d454$var$RELATIVE_URL_V2}/${cloudId}`;
    const queryParams = {
        operationName: 'searchPageFirstPartyConfig'
    };
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        },
        queryParams: queryParams
    };
    const key = (0, $bZF61.generateHash)(`1p|${userId}|${cloudId}|v2`);
    // Mutable reference for capturing tracing headers from the REST response.
    // Set by the supplier's reportTracingHeaders callback, read by traceInfoExtractor.
    // This avoids storing tracing headers in the cache — they're only used transiently for VitalStats events.
    let capturedTracingHeaders = {};
    const supplier = ()=>{
        capturedTracingHeaders = {};
        const searchConfigPromise = (0, $gABt9.utils).requestService({
            url: url
        }, {
            ...options,
            reportTracingHeaders: (headers)=>{
                capturedTracingHeaders = headers;
            }
        }).then((data)=>{
            return {
                resources: data.resources,
                intercomHmac: data.intercomHmac || '',
                siteMetadata: data.siteMetadata || []
            };
        });
        // Two cases here, due to the promiseCache from refreshOnAccessDecoratorSearch below
        // 1. Cache-miss: we of course want to handle degradation!
        // 2. Cache-hit: we actually still want to handle degradation, because if we can't refresh the cache due to a slow dependency, that is a signal we need in healthchecks
        // The alternate approach here would be to wrap the promiseCache in the DegradablePromise, but then we'd only get degradation pings on cache-miss.
        const degrader = new (0, $9C63M.DegradablePromise)(searchConfigPromise, degradationCallback);
        return degrader.promise();
    };
    const traceInfoExtractor = $c1ab7bf16286d454$var$createTraceInfoExtractor(()=>capturedTracingHeaders);
    return $c1ab7bf16286d454$var$refreshOnAccessDecoratorSearch({
        key: key.toString(),
        supplier: supplier,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        returnExpired: returnExpired,
        analyticsCallback: cacheAnalyticsCallback,
        networkCallbacks: networkCallbacks,
        serveResolvedDuringRefresh: true,
        traceInfoExtractor: traceInfoExtractor
    });
};
const $c1ab7bf16286d454$export$6916ea7f169882e0 = async ({ absoluteUrl: absoluteUrl = '', cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, cacheAnalyticsCallback: cacheAnalyticsCallback, degradationCallback: degradationCallback = ()=>{}, returnExpired: returnExpired, networkCallbacks: networkCallbacks })=>{
    const baseUrl = absoluteUrl || $c1ab7bf16286d454$var$RELATIVE_3P_URL;
    const url = `${baseUrl}/${cloudId}`;
    const queryParams = {
        operationName: 'searchPageThirdPartyConfig'
    };
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        },
        queryParams: queryParams
    };
    const key = (0, $d9nAp.generate3pHash)(userId || '', cloudId || '');
    // Mutable reference for capturing tracing headers from the REST response.
    // Set by the supplier's reportTracingHeaders callback, read by traceInfoExtractor.
    // This avoids storing tracing headers in the cache — they're only used transiently for VitalStats events.
    let capturedTracingHeaders = {};
    const supplier = ()=>{
        capturedTracingHeaders = {};
        const searchConfig3PPromise = (0, $gABt9.utils).requestService({
            url: url
        }, {
            ...options,
            reportTracingHeaders: (headers)=>{
                capturedTracingHeaders = headers;
            }
        });
        // Two cases here, due to the promiseCache from refreshOnAccessDecorator3pSearch below
        // 1. Cache-miss: we of course want to handle degradation!
        // 2. Cache-hit: we actually still want to handle degradation, because if we can't refresh the cache due to a slow dependency, that is a signal we need in healthchecks
        // The alternate approach here would be to wrap the promiseCache in the DegradablePromise, but then we'd only get degradation pings on cache-miss.
        const degrader = new (0, $9C63M.DegradablePromise)(searchConfig3PPromise, degradationCallback);
        return degrader.promise();
    };
    const traceInfoExtractor = $c1ab7bf16286d454$var$createTraceInfoExtractor(()=>capturedTracingHeaders);
    return $c1ab7bf16286d454$var$refreshOnAccessDecorator3pSearch({
        key: key.toString(),
        supplier: supplier,
        returnExpired: returnExpired,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        analyticsCallback: cacheAnalyticsCallback,
        networkCallbacks: networkCallbacks,
        serveResolvedDuringRefresh: true,
        traceInfoExtractor: traceInfoExtractor
    });
};
const $c1ab7bf16286d454$export$b75556aa5958ec1f = (userId, cloudId, updater)=>{
    const key = (0, $d9nAp.generate3pHash)(userId, cloudId);
    return $c1ab7bf16286d454$var$update3pCache(key.toString(), updater);
};
const $c1ab7bf16286d454$export$46e3d34ee7b8c58a = async ({ cloudId: cloudId, userId: userId })=>{
    const url = $c1ab7bf16286d454$var$RELATIVE_LOOM_AUTH_URL;
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = (0, $bfpjP.generateLoomAuthHash)(userId || '', cloudId || '');
    const supplier = ()=>(0, $gABt9.utils).requestService({
            url: url
        }, options);
    return $c1ab7bf16286d454$var$refreshOnAccessDecoratorUserLoomAuth({
        key: key.toString(),
        supplier: supplier,
        returnExpired: false
    });
};
module.exports["getSearchConfigV2"] = $c1ab7bf16286d454$export$c6f4290269f11bd5;
module.exports["get3pSearchConfig"] = $c1ab7bf16286d454$export$6916ea7f169882e0;
module.exports["update3pConfigCacheEntry"] = $c1ab7bf16286d454$export$b75556aa5958ec1f;
module.exports["getUserLoomAuthStatus"] = $c1ab7bf16286d454$export$46e3d34ee7b8c58a;

});

parcelRegister("bZF61", function(module, exports) {
/**
 * Simple implementation of djb2 hashing.
 * The reason we have it internally is because at the moment we can't add new
 * dependencies into search-client package as it triggers a deprecated VR test in Editor
 * and it is locked down. So it fails to resolve the new dependency
 */ const $a6b1de276595dc61$export$daf4c137c5f56404 = (query)=>{
    let hash = 5381;
    for(let i = 0; i < query.length; i++){
        const char = query.charCodeAt(i);
        hash = (hash << 5) + hash + char; /* hash * 33 + char */ 
    }
    return hash;
};
const $a6b1de276595dc61$export$5c07a4287a46fa1f = (variables)=>{
    try {
        return $a6b1de276595dc61$export$daf4c137c5f56404(JSON.stringify(variables)).toString();
    } catch (e) {
        return '';
    }
};
module.exports["generateHash"] = $a6b1de276595dc61$export$daf4c137c5f56404;
module.exports["generateHashFromVariables"] = $a6b1de276595dc61$export$5c07a4287a46fa1f;

});

parcelRegister("fyjce", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $6dPGs = parcelRequire("6dPGs");


var $6s56R = parcelRequire("6s56R");


var $8N8EQ = parcelRequire("8N8EQ");


var $7jITD = parcelRequire("7jITD");


var $5oT59 = parcelRequire("5oT59");


var $esAoV = parcelRequire("esAoV");

const $86ca83201018b107$export$e89e805418f4d2c = (args)=>{
    const { name: name, shouldUseStorageAdapter: shouldUseStorageAdapter } = args;
    let cacheInstance = null;
    let resolvedStorage = null;
    // During refresh, the main cache will hold pending promises so we need a way to access the last resolved value
    // This cache can return these values while the refresh is in progress
    const resolvedValueCache = new Map();
    /**
   * NOTE: Scope control (QS-9209)
   *
   * The storage adapter system is introduced specifically so the combined search config cache
   * can participate in host-provided persistence (e.g., Confluence SSR local storage).
   */ const COMBINED_CONFIG_PERSISTED_CACHE_KEY = (0, $5oT59.SEARCH_COMBINED_CONFIG_CACHE_KEY);
    const defaultLocalStorageAdapter = {
        getItem: (key)=>(0, $6dPGs.getLocalStorageItemAsString)(key),
        setItem: (key, value)=>(0, $6dPGs.setLocalStorageItem)(key, value)
    };
    function shouldUseAdapterSystemForThisCache() {
        // Explicit opt-in/out takes precedence (lets two caches share a `name` but
        // target different storage — bare key vs host-adapter/account-namespaced key).
        // When unspecified, preserve the historical behaviour: the combined-config
        // cache routes through the host adapter so the legacy path is untouched.
        if (shouldUseStorageAdapter !== undefined && ((0, $ixfCV.fg)('rovo_fps_use_rovo_config') || (0, $6s56R.isUsingRovoConfigStoreExperiment)())) return shouldUseStorageAdapter;
        return name === COMBINED_CONFIG_PERSISTED_CACHE_KEY;
    }
    const getCacheInstance = ()=>{
        /**
     * We lazily create the cache instance to avoid the issue in SSR
     * where the localStorage isn't available.
     */ if (!cacheInstance) {
            cacheInstance = (0, $7jITD.getInstance)(args);
            // Resolve persisted state lazily (SSR-safe)
            let persistedState = null;
            try {
                if (shouldUseAdapterSystemForThisCache()) {
                    const factory = (0, $esAoV.getSearchClientStorageAdapterFactory)();
                    if (factory) {
                        resolvedStorage = factory();
                        persistedState = resolvedStorage?.getItem(name) ?? null;
                    }
                    // If the adapter cache is cold or the factory isn't registered yet, fall back
                    // to the raw localStorage key. This ensures stale-but-present data is served
                    // immediately rather than blocking on the network and potentially timing out
                    // the DegradablePromise.
                    // SSR-safe: getLocalStorageItemAsString throws in SSR -> caught by outer try/catch.
                    if (!persistedState) persistedState = (0, $6dPGs.getLocalStorageItemAsString)(name);
                } else persistedState = (0, $6dPGs.getLocalStorageItemAsString)(name);
            } catch  {
            // Error retrieving persisted state - continue without it
            }
            if (persistedState) {
                // Populate the resolved value cache with the contents of local storage
                const object = cacheInstance.deserialize(persistedState);
                if (object) Object.entries(object).forEach(([key, entry])=>{
                    if (entry && 'result' in entry) resolvedValueCache.set(key, entry.result);
                });
            }
        }
        return cacheInstance;
    };
    const get = (key, returnExpired)=>{
        const storedValue = getCacheInstance().get(key, returnExpired ?? true); // fetch expired result by default
        const isExpired = getCacheInstance().isExpired(key);
        return {
            storedValue: storedValue,
            isExpired: isExpired
        };
    };
    const set = async (key, result, expiration)=>{
        getCacheInstance().set(key, result, expiration);
        try {
            const resolvedValue = await result;
            resolvedValueCache.set(key, resolvedValue);
            const serialized = await getCacheInstance().serialize();
            if (serialized) {
                if (shouldUseAdapterSystemForThisCache()) {
                    const adapter = resolvedStorage ?? (0, $esAoV.getSearchClientStorageAdapterFactory)()?.() ?? defaultLocalStorageAdapter;
                    adapter.setItem(name, serialized);
                } else (0, $6dPGs.setLocalStorageItem)(name, serialized);
            }
        } catch  {
        // noop - an exception in the result promise or serialisation should be ignored so we dont throw unhandled exceptions
        }
    };
    const update = async (key, updater, expiration)=>{
        // Read remaining TTL before get(), which removes expired entries from the map
        const remainingTtl = expiration ?? getCacheInstance().getRemainingTtl(key);
        const { storedValue: storedValue } = get(key, true);
        if (!storedValue) return false;
        try {
            const currentValue = await storedValue;
            const updatedValue = updater(currentValue);
            await set(key, Promise.resolve(updatedValue), remainingTtl || undefined);
            return true;
        } catch  {
            return false;
        }
    };
    const clear = (key)=>{
        if (key) resolvedValueCache.delete(key);
        else resolvedValueCache.clear();
        getCacheInstance().clear(key);
    };
    const refreshOnAccessDecorator = ({ key: key, supplier: supplier, returnExpired: returnExpired, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, analyticsCallback: analyticsCallback, networkCallbacks: networkCallbacks, serveResolvedDuringRefresh: serveResolvedDuringRefresh, traceInfoExtractor: traceInfoExtractor })=>{
        const { storedValue: storedValue, isExpired: isExpired } = get(key, returnExpired);
        const shouldRefresh = onlyRefreshIfExpired ? isExpired : true;
        // When enabled, returns already-resolved values from an in-memory cache during background
        // refresh instead of returning pending promises. Callers can opt out by passing false.
        const serveResolvedDuringRefreshEnabled = serveResolvedDuringRefresh ?? false;
        if (!storedValue || shouldRefresh) {
            // Wrap the supplier to track network calls
            const trackedSupplier = async ()=>{
                networkCallbacks?.onStart();
                try {
                    const result = await supplier();
                    const traceInfo = traceInfoExtractor ? traceInfoExtractor() : (0, $8N8EQ.extractTraceInfoFromResponse)(result);
                    networkCallbacks?.onSuccess(traceInfo);
                    return result;
                } catch (error) {
                    const errorName = error?.name || 'UnknownError';
                    const errorMessage = error?.message || 'An unknown error occurred';
                    networkCallbacks?.onError(errorName, errorMessage, undefined);
                    throw error;
                }
            };
            const apiPromise = trackedSupplier();
            set(key, apiPromise, expiration);
            // If there was already a stored value prior to refreshing, return it
            if (storedValue) {
                if (analyticsCallback) analyticsCallback({
                    refreshTriggered: true,
                    hit: true
                });
                // Return resolved value if serveResolvedDuringRefresh is enabled and we have it cached
                if (serveResolvedDuringRefreshEnabled) {
                    const resolvedValue = resolvedValueCache.get(key);
                    if (resolvedValue !== undefined) return resolvedValue;
                }
                return storedValue;
            } else {
                if (analyticsCallback) analyticsCallback({
                    refreshTriggered: true,
                    hit: false
                });
                return apiPromise;
            }
        } else {
            if (analyticsCallback) analyticsCallback({
                refreshTriggered: false,
                hit: true
            });
            // Return resolved value if serveResolvedDuringRefresh is enabled and we have it cached
            if (serveResolvedDuringRefreshEnabled) {
                const resolvedValue = resolvedValueCache.get(key);
                if (resolvedValue !== undefined) return resolvedValue;
            }
            return storedValue;
        }
    };
    const seed = (key, value, expiration)=>set(key, Promise.resolve(value), expiration);
    return {
        get: get,
        refreshOnAccessDecorator: refreshOnAccessDecorator,
        clear: clear,
        update: update,
        seed: seed
    };
};
module.exports["promiseCache"] = $86ca83201018b107$export$e89e805418f4d2c;

});

parcelRegister("6dPGs", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $7dBf8 = parcelRequire("7dBf8");

// `localStorage` is a browser-only Web API and does not exist during server-side
// rendering (SSR). Accessing the bare `localStorage` identifier on the server
// throws a `ReferenceError`, which crashes the render.
const $96c9493b1d7fc1a3$var$isLocalStorageAvailable = ()=>{
    if (!(0, $ixfCV.fg)('fix_ssr_browser_storage_undefined')) return true;
    return typeof window !== 'undefined' && typeof localStorage !== 'undefined';
};
const $96c9493b1d7fc1a3$export$5aa524d86254b4f = (key, value)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return;
    if ((0, $ixfCV.fg)('search_page_use_browser_storage_controls')) (0, $7dBf8.AtlBrowserStorageLocal).setItem(key, value);
    else // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.setItem(key, value);
};
const $96c9493b1d7fc1a3$export$93d719890ad66653 = (key)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return null;
    const item = (0, $ixfCV.fg)('search_page_use_browser_storage_controls') ? (0, $7dBf8.AtlBrowserStorageLocal).getItem(key) : // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
};
const $96c9493b1d7fc1a3$export$5df15f289f441790 = (key)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return null;
    const item = (0, $ixfCV.fg)('search_page_use_browser_storage_controls') ? (0, $7dBf8.AtlBrowserStorageLocal).getItem(key) : // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem(key);
    return item ? item : null;
};
const $96c9493b1d7fc1a3$export$baf306891f1b93bd = (key)=>{
    if (!$96c9493b1d7fc1a3$var$isLocalStorageAvailable()) return;
    if ((0, $ixfCV.fg)('search_page_use_browser_storage_controls')) (0, $7dBf8.AtlBrowserStorageLocal).removeItem(key);
    else // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.removeItem(key);
};
module.exports["setLocalStorageItem"] = $96c9493b1d7fc1a3$export$5aa524d86254b4f;
module.exports["getLocalStorageItem"] = $96c9493b1d7fc1a3$export$93d719890ad66653;
module.exports["getLocalStorageItemAsString"] = $96c9493b1d7fc1a3$export$5df15f289f441790;
module.exports["removeLocalStorageItem"] = $96c9493b1d7fc1a3$export$baf306891f1b93bd;

});

parcelRegister("6s56R", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $ixfCV = parcelRequire("ixfCV");

const $0f4933595e34bba8$export$aa9f97d4dfccb6ff = ()=>{
    if ((0, $ixfCV.fg)('rovo_cas_use_rovo_config')) return true;
    return (0, $cXtTj.default).getExperimentValue('rovo_cas_use_rovo_config_exp', 'cohort', 'control') === 'test';
};
module.exports["isUsingRovoConfigStoreExperiment"] = $0f4933595e34bba8$export$aa9f97d4dfccb6ff;

});

parcelRegister("8N8EQ", function(module, exports) {
const $20c1508e7bfb5af0$var$NOT_AVAILABLE = 'not_available';
const $20c1508e7bfb5af0$export$fca3401e33379daf = (result)=>{
    if (result && typeof result === 'object' && 'extensions' in result) {
        const extensions = result.extensions;
        const gateway = extensions?.gateway;
        if (gateway) return {
            requestId: gateway.request_id ?? undefined,
            traceId: gateway.trace_id ?? undefined
        };
    }
    return undefined;
};
const $20c1508e7bfb5af0$export$4acb28c262cd52bd = (traceInfo)=>({
        requestId: traceInfo?.requestId ?? $20c1508e7bfb5af0$var$NOT_AVAILABLE,
        traceId: traceInfo?.traceId ?? $20c1508e7bfb5af0$var$NOT_AVAILABLE
    });
module.exports["extractTraceInfoFromResponse"] = $20c1508e7bfb5af0$export$fca3401e33379daf;
module.exports["normaliseTraceInfo"] = $20c1508e7bfb5af0$export$4acb28c262cd52bd;

});

parcelRegister("7jITD", function(module, exports) {
const $df3ea53f68f38eaa$var$DEFAULT_EXPIRATION = 900000; // 15 mins in milliseconds
class $df3ea53f68f38eaa$var$Cache {
    get(key, returnExpired = false) {
        const entry = this.map[key];
        if (entry) {
            if (entry.isExpired()) {
                delete this.map[key];
                return returnExpired ? entry.getResult() : undefined;
            } else return entry.getResult();
        }
        return;
    }
    set(key, result, expiration) {
        const entry = new $df3ea53f68f38eaa$var$Entry({
            result: result,
            expirationTime: Date.now() + (expiration || this.expiration),
            accessCount: 0
        });
        this.map[key] = entry;
    }
    has(key) {
        return key in this.map;
    }
    clear(key) {
        if (key) delete this.map[key];
        else this.map = {};
    }
    async serialize() {
        const serialized = {};
        const resolvers = Object.entries(this.map).map(([key, entry])=>(async ()=>{
                serialized[key] = {
                    result: await entry.getResult(),
                    expirationTime: entry.getExpirationTime(),
                    accessCount: entry.getAccessCount()
                };
            })());
        await Promise.all(resolvers);
        return JSON.stringify(serialized);
    }
    deserialize(persisted) {
        try {
            const object = JSON.parse(persisted);
            for(const key in object){
                const { result: result, expirationTime: expirationTime, accessCount: accessCount } = object[key];
                this.map[key] = new $df3ea53f68f38eaa$var$Entry({
                    result: Promise.resolve(result),
                    expirationTime: expirationTime,
                    accessCount: accessCount
                });
            }
            return object;
        } catch  {
        // TODO: Log error via sentry
        }
        return undefined;
    }
    isExpired(key) {
        const entry = this.map[key];
        return entry ? entry.isExpired() : true;
    }
    getRemainingTtl(key) {
        const entry = this.map[key];
        if (!entry) return undefined;
        return Math.max(0, entry.getExpirationTime() - Date.now());
    }
    constructor(args = {}){
        this.map = void 0;
        this.expiration = void 0;
        const { expiration: expiration = $df3ea53f68f38eaa$var$DEFAULT_EXPIRATION } = args;
        this.map = {};
        this.expiration = expiration;
    }
}
class $df3ea53f68f38eaa$var$Entry {
    getResult() {
        this.accessCount++;
        return this.result;
    }
    isExpired() {
        return this.expirationTime < Date.now();
    }
    getExpirationTime() {
        return this.expirationTime;
    }
    getAccessCount() {
        return this.accessCount;
    }
    constructor({ result: result, expirationTime: expirationTime, accessCount: accessCount }){
        this.result = void 0;
        this.expirationTime = void 0;
        this.accessCount = void 0;
        this.result = result;
        this.expirationTime = expirationTime;
        this.accessCount = accessCount;
    }
}
const $df3ea53f68f38eaa$export$8bedcca5bbd73999 = (args)=>{
    return new $df3ea53f68f38eaa$var$Cache(args);
};
module.exports["getInstance"] = $df3ea53f68f38eaa$export$8bedcca5bbd73999;

});

parcelRegister("9C63M", function(module, exports) {

var $aHhuQ = parcelRequire("aHhuQ");

const $40115e6ed8d3612b$export$ff01cc10d3c607be = 6000; // default timeout
const $40115e6ed8d3612b$var$DEGRADE_ERROR = new (0, $aHhuQ.DegradeError)('Promise is degraded');
class $40115e6ed8d3612b$export$ea6d6e4c9647fa9 {
    static from(wrapped, degradationCallback = ()=>{}, timeoutMs) {
        return new $40115e6ed8d3612b$export$ea6d6e4c9647fa9(wrapped, degradationCallback, timeoutMs ?? $40115e6ed8d3612b$export$ff01cc10d3c607be);
    }
    constructor(wrapped, degradationCallback, timeoutMs = $40115e6ed8d3612b$export$ff01cc10d3c607be){
        this.degradablePromiseInternal = void 0;
        this.degradeTimeout = void 0;
        this.timeoutMs = void 0;
        this.degradeInternal = ()=>{
            // Default throws an error as this should never happen
            throw new Error('Programming error, cancelling promise is not properly rejected');
        };
        this.timeout = ()=>{
            this.degradeInternal();
        };
        this.promise = ()=>this.degradablePromiseInternal;
        const degrader = new Promise((_, reject)=>{
            this.degradeInternal = ()=>{
                reject($40115e6ed8d3612b$var$DEGRADE_ERROR);
                degradationCallback('timeout');
            };
        });
        // Call the degradation callback with 'failed' if the wrapped promise fails, easy way to track metrics at fetch level
        wrapped.catch(()=>{
            degradationCallback('failure');
        });
        // Build a finally chain into the wrapped promise so if it resolves early, we cancel the degradation
        const wrappedFinally = wrapped.finally(()=>{
            if (this.degradeTimeout) clearTimeout(this.degradeTimeout);
        });
        const wrapper = Promise.race([
            wrappedFinally,
            degrader
        ]);
        this.degradablePromiseInternal = wrapper;
        this.timeoutMs = timeoutMs ?? $40115e6ed8d3612b$export$ff01cc10d3c607be;
        this.degradeTimeout = setTimeout(this.timeout, this.timeoutMs);
    }
}
module.exports["DegradablePromise"] = $40115e6ed8d3612b$export$ea6d6e4c9647fa9;

});

parcelRegister("aHhuQ", function(module, exports) {
class $b0ed35fbaacb89be$export$85bf8e4fb143676a extends Error {
    constructor(...args){
        super(...args);
        this.isDegraded = true;
    }
}
module.exports["DegradeError"] = $b0ed35fbaacb89be$export$85bf8e4fb143676a;

});

parcelRegister("bfpjP", function(module, exports) {

var $bZF61 = parcelRequire("bZF61");

const $413fa6e1c2c21add$export$42b67d93e908c9dc = (userId, cloudId)=>(0, $bZF61.generateHash)(`loom|${userId}|${cloudId}`);
module.exports["generateLoomAuthHash"] = $413fa6e1c2c21add$export$42b67d93e908c9dc;

});

parcelRegister("d9nAp", function(module, exports) {

var $bZF61 = parcelRequire("bZF61");

const $de62146c16c69af1$export$f80795c7fd0ce9fc = (userId, cloudId)=>(0, $bZF61.generateHash)(`3p|${userId}|${cloudId}`);
module.exports["generate3pHash"] = $de62146c16c69af1$export$f80795c7fd0ce9fc;

});

parcelRegister("dv1ov", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $b0Mpu = parcelRequire("b0Mpu");


var $bZF61 = parcelRequire("bZF61");


var $bHHWv = parcelRequire("bHHWv");


var $hDUYn = parcelRequire("hDUYn");



var $fR7EZ = parcelRequire("fR7EZ");


var $bDWrn = parcelRequire("bDWrn");

const $fa20c6cebfd0e652$export$3aaf902e00a8e4ba = (0, $bHHWv.inMemoryCache)();
const $fa20c6cebfd0e652$export$69a3209f1a06c04d = $fa20c6cebfd0e652$export$3aaf902e00a8e4ba;
const $fa20c6cebfd0e652$export$a4f9b7f788f9e71f = (variables, originalQuery)=>{
    /**
   * Results once fetched will be used for upto 15 minutes from an in memory cache.
   * 1. Generate key based on query, entities, filters
   * 2. Serve from cache if present without resetting the expiration, evict if results are expired
   * 3. If not present or expired then invoke the api
   * 4. If API is invoked then store response in the cache with expiration and return back the response
   */ const keyObj = {
        query: variables.query,
        entities: variables.entities,
        commonFilters: variables.commonFilters,
        confluenceFilters: variables.confluenceFilters,
        jiraFilters: variables.jiraFilters,
        mercuryFilters: variables.mercuryFilters,
        compassFilters: variables.compassFilters,
        assetsFilters: variables.assetsFilters,
        thirdPartyFilters: variables.thirdPartyFilters,
        cloudIdARI: variables.cloudIdARI,
        sortField: variables.sort.at(0)?.field ?? '',
        sortOrder: variables.sort.at(0)?.order ?? '',
        after: variables.after,
        originalQuery: originalQuery
    };
    return (0, $bZF61.generateHashFromVariables)(keyObj);
};
// Expire the cache if there are errors or edges are empty
const $fa20c6cebfd0e652$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || !data.search || errors && errors.length > 0) return true;
    return data.search?.results.edges.length === 0;
};
const $fa20c6cebfd0e652$var$searchQuery = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, originalQuery: originalQuery, useCache: useCache, operationName: operationName, serveUserShardUI: serveUserShardUI = false, headers: headers, networkCallbacks: networkCallbacks })=>{
    // Default experience is search-page
    variables.experience = variables.experience || 'search-page';
    // Default skip3pEntityHydration is false
    variables.skip3pEntityHydration = variables.skip3pEntityHydration || variables.skipFieldsFor3pInQuickFind || false;
    // Disable GitHub hydration when skip3pEntityHydration is false to avoid duplication
    variables.includeGithubEntityHydration = !variables.skip3pEntityHydration ? false : variables.includeGithubEntityHydration || false;
    variables.includeSpaceSubtype = variables.includeSpaceSubtype || false;
    variables.skipFieldsFor3pInQuickFind = variables.skipFieldsFor3pInQuickFind || false;
    // Since the default experience is search-page, default experience is to include social signals
    variables.includeSocialSignals = variables.includeSocialSignals === undefined ? true : variables.includeSocialSignals;
    variables.includeJiraIssueType = variables.includeJiraIssueType || false;
    variables.includeJiraBoardContainer = variables.includeJiraBoardContainer || false; // Used to include the container field
    // Option to hydrate the confluenceEntity field
    variables.includeConfluenceEntity = typeof variables.includeConfluenceEntity === 'boolean' ? variables.includeConfluenceEntity : true;
    variables.includeAutocompleteSuggestions = variables.includeAutocompleteSuggestions || false;
    const graphQuery = (0, $bDWrn.queryGenerator)(operationName, serveUserShardUI);
    if (useCache) return $fa20c6cebfd0e652$export$3aaf902e00a8e4ba.inMemoryDecorator($fa20c6cebfd0e652$export$a4f9b7f788f9e71f(variables, originalQuery), (0, $hDUYn.withNetworkCallback)(()=>(0, $b0Mpu.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: graphQuery,
            operationName: operationName,
            headers: headers
        }), networkCallbacks), $fa20c6cebfd0e652$var$expireWhen);
    else return (0, $hDUYn.withNetworkCallback)(()=>(0, $b0Mpu.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: graphQuery,
            operationName: operationName,
            headers: headers
        }), networkCallbacks)();
};
const $fa20c6cebfd0e652$export$8d55189398f4cde7 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, originalQuery: originalQuery, serveUserShardUI: serveUserShardUI = false, headers: headers })=>{
    return $fa20c6cebfd0e652$var$searchQuery({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        originalQuery: originalQuery,
        useCache: true,
        operationName: (0, $bDWrn.SEARCH_PAGE_OPERATION_NAME),
        serveUserShardUI: serveUserShardUI,
        headers: headers
    });
};
const $fa20c6cebfd0e652$export$b62744f7ecc07873 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, originalQuery: originalQuery, serveUserShardUI: serveUserShardUI = false, headers: headers, networkCallbacks: networkCallbacks, operationName: operationName = (0, $bDWrn.SEARCH_DIALOG_OPERATION_NAME) })=>{
    return $fa20c6cebfd0e652$var$searchQuery({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        originalQuery: originalQuery,
        useCache: false,
        operationName: // Bypassing cache to match previous Quick Find behavior
        operationName,
        serveUserShardUI: serveUserShardUI,
        headers: headers,
        networkCallbacks: networkCallbacks
    });
};
const $fa20c6cebfd0e652$export$3dbd5bda6e5269b6 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, originalQuery: originalQuery, headers: headers })=>{
    const graphQuery = (0, $bDWrn.resultsCountQueryGenerator)();
    return $fa20c6cebfd0e652$export$3aaf902e00a8e4ba.inMemoryDecorator('count' + $fa20c6cebfd0e652$export$a4f9b7f788f9e71f(variables, originalQuery), ()=>(0, $b0Mpu.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: graphQuery,
            operationName: (0, $bDWrn.resultsCountOperationName),
            headers: headers
        }));
};
const $fa20c6cebfd0e652$export$c9f4828c7e4e077e = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $fR7EZ.dcSpaceFilterOptionsQueryGenerator)((0, $bDWrn.jiraDcProjectFilterOptionsOperationName));
    return (0, $b0Mpu.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $bDWrn.jiraDcProjectFilterOptionsOperationName),
        headers: headers
    });
};
const $fa20c6cebfd0e652$export$e261ee95abda868c = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $bDWrn.spaceARIEntitiesQueryGenerator)();
    return (0, $b0Mpu.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $bDWrn.spaceARIEntitiesOperationName),
        headers: headers
    });
};
const $fa20c6cebfd0e652$export$d18b1cb9e3a2ff17 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $bDWrn.confluenceDcContentFilterOptionsQueryGenerator)();
    return (0, $b0Mpu.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $bDWrn.confluenceDcContentFilterOptionsOperationName),
        headers: headers
    });
};
const $fa20c6cebfd0e652$export$900adb6f362c0bd3 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $bDWrn.documentARIEntitiesQueryGenerator)();
    return (0, $b0Mpu.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $bDWrn.documentARIEntitiesOperationName),
        headers: headers
    });
};
const $fa20c6cebfd0e652$export$b2301b91ba090677 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $bDWrn.confluenceDcPagesQueryGenerator)();
    return (0, $b0Mpu.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $bDWrn.confluenceDcPagesOperationName),
        headers: headers
    });
};
const $fa20c6cebfd0e652$export$a4620a3105d92aba = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $fR7EZ.dcSpaceFilterOptionsQueryGenerator)((0, $bDWrn.confluenceDcSpaceFilterOptionsOperationName));
    return (0, $b0Mpu.fetchAgg)({
        variables: {
            ...variables,
            integration: 'ari:cloud:platform::integration/confluence-dc'
        },
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $bDWrn.confluenceDcSpaceFilterOptionsOperationName),
        headers: headers
    });
};
const $fa20c6cebfd0e652$export$2e5009be45de0b79 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $bDWrn.thirdPartySpaceFilterOptionsQueryGenerator)();
    return (0, $b0Mpu.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $bDWrn.thirdPartySpaceFilterOptionsOperationName),
        headers: headers
    });
};
const $fa20c6cebfd0e652$export$54fa597426a1b0bc = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $bDWrn.thirdPartyRepositoryFilterOptionsQueryGenerator)();
    return (0, $b0Mpu.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $bDWrn.thirdPartyRepositoryFilterOptionsOperationName),
        headers: headers
    });
};
const $fa20c6cebfd0e652$export$3a1184d0405594d4 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const graphQuery = (0, $bDWrn.searchLinkedSiteQueryGenerator)();
    return (0, $b0Mpu.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: (0, $bDWrn.searchLinkedSitesOperationName),
        headers: headers
    });
};
module.exports["searchPageQueryCache"] = $fa20c6cebfd0e652$export$3aaf902e00a8e4ba;
module.exports["searchDialogQuery"] = $fa20c6cebfd0e652$export$b62744f7ecc07873;
module.exports["jiraDcProjectFilterOptionsQuery"] = $fa20c6cebfd0e652$export$c9f4828c7e4e077e;
module.exports["spaceARIEntitiesQuery"] = $fa20c6cebfd0e652$export$e261ee95abda868c;
module.exports["confluenceDcContentFilterOptionsQuery"] = $fa20c6cebfd0e652$export$d18b1cb9e3a2ff17;
module.exports["documentARIEntitiesQuery"] = $fa20c6cebfd0e652$export$900adb6f362c0bd3;
module.exports["confluenceDcPagesQuery"] = $fa20c6cebfd0e652$export$b2301b91ba090677;
module.exports["confluenceDcSpaceFilterOptionsQuery"] = $fa20c6cebfd0e652$export$a4620a3105d92aba;
module.exports["thirdPartySpaceFilterOptionsQuery"] = $fa20c6cebfd0e652$export$2e5009be45de0b79;
module.exports["thirdPartyRepositoryFilterOptionsQuery"] = $fa20c6cebfd0e652$export$54fa597426a1b0bc;
module.exports["searchLinkedSitesQuery"] = $fa20c6cebfd0e652$export$3a1184d0405594d4;

});

parcelRegister("b0Mpu", function(module, exports) {

var $gABt9 = parcelRequire("gABt9");

const $f4fcc0c6cc332c57$var$DEFAULT_GRAPHQL_ENDPOINT = '/gateway/api/graphql';
async function $f4fcc0c6cc332c57$export$f49dad89491f6bf2({ graphQuery: graphQuery, variables: variables, operationName: operationName, aggAbsoluteUrl: url = $f4fcc0c6cc332c57$var$DEFAULT_GRAPHQL_ENDPOINT, headers: headers }) {
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers
            },
            body: JSON.stringify({
                operationName: operationName,
                query: graphQuery,
                variables: variables
            })
        },
        queryParams: {
            ...operationName && {
                q: operationName
            }
        }
    };
    return (0, $gABt9.utils).requestService({
        url: url
    }, options);
}
module.exports["fetchAgg"] = $f4fcc0c6cc332c57$export$f49dad89491f6bf2;

});

parcelRegister("bHHWv", function(module, exports) {

var $7jITD = parcelRequire("7jITD");

const $9f86570151027da1$export$26b8d9fa10eeb703 = (args)=>{
    const cacheInstance = (0, $7jITD.getInstance)(args);
    const get = (key)=>key.length ? cacheInstance.get(key) : undefined;
    const set = (key, result)=>{
        if (key.length) cacheInstance.set(key, result);
    };
    const has = (key)=>cacheInstance.has(key);
    const clear = (key)=>cacheInstance.clear(key);
    const inMemoryDecorator = (key, supplier, expireWhen)=>{
        // Check if the key is already in the cache
        const cached = get(key);
        // If the key is in the cache, return the cached value
        if (cached) return cached;
        // If the key is not in the cache, call the supplier function
        const result = supplier();
        set(key, result);
        // If the promise is rejected, clear the cache
        result.catch(()=>{
            // If the promise is rejected, clear the cache
            cacheInstance.clear(key);
        });
        // Return the result
        // If the result should be expired, clear the cache
        return result.then((value)=>{
            if (expireWhen && expireWhen(value)) cacheInstance.clear(key);
            return value;
        });
    };
    return {
        get: get,
        set: set,
        has: has,
        clear: clear,
        inMemoryDecorator: inMemoryDecorator
    };
};
module.exports["inMemoryCache"] = $9f86570151027da1$export$26b8d9fa10eeb703;

});

parcelRegister("hDUYn", function(module, exports) {

var $8N8EQ = parcelRequire("8N8EQ");

const $8d0d0c6c05359dda$export$6f045830bd67248c = (fn, callbacks)=>{
    if (!callbacks) return fn;
    return async ()=>{
        callbacks.onStart();
        try {
            const result = await fn();
            const traceInfo = (0, $8N8EQ.extractTraceInfoFromResponse)(result);
            callbacks.onSuccess(traceInfo);
            return result;
        } catch (error) {
            const errorName = error?.name || 'UnknownError';
            const errorMessage = error?.message || 'An unknown error occurred';
            callbacks.onError(errorName, errorMessage);
            throw error;
        }
    };
};
module.exports["withNetworkCallback"] = $8d0d0c6c05359dda$export$6f045830bd67248c;

});

parcelRegister("fR7EZ", function(module, exports) {
const $86ce0b8e897249c4$export$5fcc1d1055e1b5a6 = (operationName)=>{
    const graphQuery = `
		query ${operationName} (
			$query: String!
			$cloudIdARI: String!
			$limit: Int!
			$entities: [String!]!
			$product: String!
			$integration: String!
			$containerTypes: [String!]
			) {
		search {
			search(
			query: $query
			first: $limit
			filters: {
				entities: $entities,
				thirdPartyFilters: {
					containerTypes : $containerTypes,
					thirdPartyProducts:[
						{
							product: $product,
							integrationId: $integration,
					subtypes:[]
					}
					]
				},
				locations: [$cloudIdARI]
			}
			experience: "search-page"
			) {
				edges {
					node {
					...on SearchResultGraphDocument {
						entity {
							...on ExternalSpace {
									id
									key
									displayName
									icon {
										height
										isDefault
										url
										width
									}
								}
							}
						}
					}
				}
			}
		}
	}
	`;
    return graphQuery;
};
module.exports["dcSpaceFilterOptionsQueryGenerator"] = $86ce0b8e897249c4$export$5fcc1d1055e1b5a6;

});

parcelRegister("bDWrn", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $3TZZX = parcelRequire("3TZZX");


const $6f6e40eb51d8920a$export$3f23d3d88b2b0734 = `
description
iconUrl
id
title
type
url
__typename
`;
const $6f6e40eb51d8920a$export$ba7243e49f8daaa4 = 'SearchPageQuery';
const $6f6e40eb51d8920a$export$87e857ecc7765700 = 'SearchDialogQuery';
const $6f6e40eb51d8920a$var$includeUserSignalsParam = (serveUserShardUI = false)=>{
    if (serveUserShardUI) return '\n		$includeUserSignals: Boolean!';
    else return '';
};
const $6f6e40eb51d8920a$export$bcad4d0714f0772f = (operationName, serveUserShardUI = false)=>{
    const partials = (0, $3TZZX.getSupportedPartials)(serveUserShardUI);
    const graphQuery = `
	query ${operationName}(
		$query: String!
		$cloudIdARI: [String!]!
		$tenantId: ID!
		$limit: Int!
		$entities: [String!]!
		$queryVersion: Int
		$searchSessionId: String
		$sessionId: String
		$commonFilters: SearchCommonFilter
		$confluenceFilters: SearchConfluenceFilter
		$jiraFilters: SearchJiraFilter
		$mercuryFilters: SearchMercuryFilter
		${(0, $ixfCV.fg)('talent_global_search') ? '$talentFilters: SearchTalentFilter' : ''}
		$compassFilters: SearchCompassFilter
		$thirdPartyFilters:  SearchThirdPartyFilter
		${(0, $ixfCV.fg)('assets_rovo_search_all') ? '$assetsFilters: SearchAssetsFilter' : ''}
		$sort: [SearchSortInput]
		$sourceProduct: String
		$experimentId: String
		$shadowExperimentId: String
		$experimentLayers: [SearchExperimentLayer]
		$after: String
		$disableQueryReplacement: Boolean
		$experience: String!
		$enableHighlighting: Boolean
		$skip3pEntityHydration: Boolean!
		$includeGithubEntityHydration: Boolean! = false
		$includeJiraIssueType: Boolean!
		$includeJiraBoardContainer: Boolean!
		$includeSocialSignals: Boolean!${$6f6e40eb51d8920a$var$includeUserSignalsParam(serveUserShardUI)}
		$fanoutExperimentCohort: String
		$includeSpaceSubtype: Boolean!
		$includeConfluenceEntity: Boolean!
		$skipFieldsFor3pInQuickFind: Boolean!
		$includeAutocompleteSuggestions: Boolean = false
	) {
		search {
			results: search(
				experience: $experience
				enableHighlighting: $enableHighlighting
				fanoutExperimentCohort: $fanoutExperimentCohort
				query: $query
				first: $limit
				after: $after
				sort: $sort
				disableQueryReplacement: $disableQueryReplacement
				filters: {
					entities: $entities
					locations: $cloudIdARI
					commonFilters: $commonFilters
					confluenceFilters: $confluenceFilters
					jiraFilters: $jiraFilters
					${(0, $ixfCV.fg)('assets_rovo_search_all') ? 'assetsFilters: $assetsFilters' : ''}
					mercuryFilters: $mercuryFilters
					compassFilters: $compassFilters
					thirdPartyFilters: $thirdPartyFilters
					${(0, $ixfCV.fg)('talent_global_search') ? 'talentFilters: $talentFilters' : ''}
				}
				analytics: {
					queryVersion: $queryVersion
					searchSessionId: $searchSessionId
					sessionId: $sessionId
					sourceProduct: $sourceProduct
				}
				experimentContext: {
					experimentId: $experimentId
					shadowExperimentId: $shadowExperimentId
					experimentLayers: $experimentLayers
				}
			) {
				edges {
					node {
						${$6f6e40eb51d8920a$export$3f23d3d88b2b0734}
						${partials}
					}
				}
				queryInfo {
					originalQuery
					replacementQuery
					suggestedQuery
					originalQueryType
					confidenceScore
					shouldTriggerAutocorrectionExperience
				}
				abTest {
					abTestId
					controlId
					experimentId
				}
				totalCount
				totalCounts {
					product
					count
				}
        pageInfo {
          endCursor
        }
				autocompleteSuggestions @include(if: $includeAutocompleteSuggestions)
			}
		}
	}
	`;
    return graphQuery;
};
const $6f6e40eb51d8920a$export$59ff8b98cf7da770 = 'ResultsCountQuery';
const $6f6e40eb51d8920a$export$35addfdbe1c7b563 = ()=>{
    const graphQuery = `
	query ${$6f6e40eb51d8920a$export$59ff8b98cf7da770}(
		$query: String!
		$cloudIdARI: String!
		$limit: Int!
		$entities: [String!]!
		$queryVersion: Int
		$searchSessionId: String
		$commonFilters: SearchCommonFilter
		$confluenceFilters: SearchConfluenceFilter
		$jiraFilters: SearchJiraFilter
		$mercuryFilters: SearchMercuryFilter
		${(0, $ixfCV.fg)('talent_global_search') ? '$talentFilters: SearchTalentFilter' : ''}
		$compassFilters: SearchCompassFilter
		$thirdPartyFilters:  SearchThirdPartyFilter
		${(0, $ixfCV.fg)('assets_rovo_search_all') ? '$assetsFilters: SearchAssetsFilter' : ''}
		$sort: [SearchSortInput]
		$sourceProduct: String
		$experimentId: String
		$shadowExperimentId: String
		$experimentLayers: [SearchExperimentLayer]
		$disableQueryReplacement: Boolean
	) {
		search {
			results: search(
				experience: "search-page"
				query: $query
				first: $limit
				sort: $sort
				disableQueryReplacement: $disableQueryReplacement
				filters: {
					entities: $entities
					locations: [$cloudIdARI]
					commonFilters: $commonFilters
					confluenceFilters: $confluenceFilters
					jiraFilters: $jiraFilters
					mercuryFilters: $mercuryFilters
					${(0, $ixfCV.fg)('talent_global_search') ? 'talentFilters: $talentFilters' : ''}
					compassFilters: $compassFilters
					thirdPartyFilters: $thirdPartyFilters
					${(0, $ixfCV.fg)('assets_rovo_search_all') ? 'assetsFilters: $assetsFilters' : ''}
				}
		analytics: {
					queryVersion: $queryVersion
					searchSessionId: $searchSessionId
					sourceProduct: $sourceProduct
				}
		experimentContext: {
			experimentId: $experimentId
			shadowExperimentId: $shadowExperimentId
			experimentLayers: $experimentLayers
		}
			) {

				queryInfo {
					originalQuery
					replacementQuery
					originalQueryType
					confidenceScore
					shouldTriggerAutocorrectionExperience
				}
				abTest {
					abTestId
					controlId
					experimentId
				}
				totalCount
				totalCounts {
					product
					count
				}
			}
		}
	}
	`;
    return graphQuery;
};
const $6f6e40eb51d8920a$export$fa19606e35da8d6d = 'jiraDcProjectFilterOptionsQuery';
const $6f6e40eb51d8920a$export$56917484085c839f = 'confluenceDcSpaceFilterOptionsQuery';
const $6f6e40eb51d8920a$export$7fed2443afa81b26 = 'thirdPartySpaceFilterOptionsQuery';
const $6f6e40eb51d8920a$export$5fce5a96ced87ae4 = ()=>{
    const graphQuery = `
		query ${$6f6e40eb51d8920a$export$7fed2443afa81b26} (
			$query: String!
			$cloudIdARI: String!
			$limit: Int!
			$entities: [String!]!
			$product: String!
			$integration: String!
			$subtypes: [String!]!
		) {
		search {
			search(
			query: $query
			first: $limit
			filters: {
				entities: $entities,
				thirdPartyFilters: {
					titleMatchOnly: true,
					thirdPartyProducts:[
						{
							product: $product,
							integrationId: $integration,
							subtypes: $subtypes
						}
					]
				},
				locations: [$cloudIdARI]
			}
			experience: "search-page"
			) {
				edges {
					node {
						...on SearchResultGraphDocument {
							entity {
								...on ExternalSpace {
									id
									displayName
									icon {
										url
									}
								}
							}
						}
					}
				}
			}
		}
	}
	`;
    return graphQuery;
};
const $6f6e40eb51d8920a$export$8535d2c38a35eb6f = 'teamsWorkspaceFilterOptionsQuery';
const $6f6e40eb51d8920a$export$baa4ec00dd3889d8 = ()=>{
    const graphQuery = `
		query ${$6f6e40eb51d8920a$export$8535d2c38a35eb6f} (
			$query: String!
			$cloudIdARI: String!
			$limit: Int!
			$entities: [String!]!
			$product: String!
			$integration: String!
			$subtypes: [String!]!
		) {
		search {
			search(
			query: $query
			first: $limit
			filters: {
				entities: $entities,
				thirdPartyFilters: {
					titleMatchOnly: true,
					thirdPartyProducts:[
						{
							product: $product,
							integrationId: $integration,
							subtypes: $subtypes
						}
					]
				},
				locations: [$cloudIdARI]
			}
			experience: "search-page"
			) {
				edges {
					node {
						...on SearchResultGraphDocument {
							entity {
								...on ExternalConversation {
									workspace
									id
								}
							}
						}
					}
				}
			}
		}
	}
	`;
    return graphQuery;
};
const $6f6e40eb51d8920a$export$c768638eb8676119 = 'thirdPartyRepositoryFilterOptionsQuery';
const $6f6e40eb51d8920a$export$3057eb5718aa2977 = ()=>{
    const graphQuery = `
		query ${$6f6e40eb51d8920a$export$c768638eb8676119} (
			$query: String!
			$cloudIdARI: String!
			$limit: Int!
			$entities: [String!]!
			$product: String!
			$integration: String!
			$subtypes: [String!]!
		) {
		search {
			search(
			query: $query
			first: $limit
			filters: {
				entities: $entities,
				thirdPartyFilters: {
					titleMatchOnly: true,
					thirdPartyProducts:[
						{
							product: $product,
							integrationId: $integration,
							subtypes: $subtypes
						}
					]
				},
				locations: [$cloudIdARI]
			}
			experience: "search-page"
			) {
				edges {
					node {
						...on SearchResultGraphDocument {
							entity {
								...on ExternalRepository {
									id
									name
								}
							}
						}
					}
				}
			}
		}
	}
	`;
    return graphQuery;
};
const $6f6e40eb51d8920a$export$4cc1a613b784cede = 'spaceIdFilterOptionsQuery';
const $6f6e40eb51d8920a$export$402074cb9d99809d = ()=>{
    const graphQuery = `
		query ${$6f6e40eb51d8920a$export$4cc1a613b784cede} ($ids: [ID!]!) {
			external_entities(ids: $ids) @optIn(to: "ExternalDataDepotQueryV2"){
				space {
					id
					displayName
					icon {
						url
					}
				}
			}
		}`;
    return graphQuery;
};
const $6f6e40eb51d8920a$export$fd96e79bbd846735 = 'documentIdFilterOptionsQuery';
const $6f6e40eb51d8920a$export$36d0a57a2adc8939 = ()=>{
    const graphQuery = `
		query ${$6f6e40eb51d8920a$export$fd96e79bbd846735} ($ids: [ID!]!) {
			external_entities(ids: $ids) @optIn(to: "ExternalDataDepotQueryV2"){
				document {
					id
					displayName
					container @optIn(to: "ExternalDataDepotQueryV2") {
                        ... on ExternalSpace {
                            id
                        }
                    }
				}
			}
		}`;
    return graphQuery;
};
const $6f6e40eb51d8920a$export$11124ad4475d739f = 'confluenceDcContentFilterOptionsQuery';
const $6f6e40eb51d8920a$export$80a2987504e5746a = ()=>{
    const graphQuery = `
		query ${$6f6e40eb51d8920a$export$11124ad4475d739f} (
			$query: String!
			$cloudIdARI: String!
			$limit: Int!
			$entities: [String!]!
			$product: String!
		) {
		search {
			search(
			query: $query
			first: $limit
			filters: {
				entities: $entities,
				locations: [$cloudIdARI],
				thirdPartyFilters: {
					thirdPartyProducts:[
						{
							product: $product,
							integrationId:"ari:cloud:platform::integration/confluence-dc",
							subtypes:[]
						}
					]
				}
			}
			analytics: {searchSessionId: "graphql"}
			experience: "search-page"
			) {
				edges {
					node {
					id
					title
					description
					... on SearchResultGraphDocument {
							entity {
								...on ExternalDocument {
									type {
										category
									}
									parentId
									container @optIn(to: "ExternalDataDepotQueryV2") {
										...on ExternalSpace {
											id
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
	`;
    return graphQuery;
};
const $6f6e40eb51d8920a$export$b12a4e91aeaa7036 = 'confluenceDcPagesQuery';
const $6f6e40eb51d8920a$export$feafc9cb648273dc = ()=>{
    const graphQuery = `
		query ${$6f6e40eb51d8920a$export$b12a4e91aeaa7036} (
			$ancestorIds: [ID!]!
		) {
			external_entities(ids: $ancestorIds) @optIn(to: "ExternalDataDepotQueryV2") {
				document {
					id
					displayName
				}
			}
		}
	`;
    return graphQuery;
};
const $6f6e40eb51d8920a$export$b6579c18b8ca60cd = 'CollabContextWorkspaceIsConnectedToWorkspaceQuery';
const $6f6e40eb51d8920a$export$4d33288c2a5c7de0 = ()=>{
    const graphQuery = `
		query ${$6f6e40eb51d8920a$export$b6579c18b8ca60cd}($id: ID!) {
			collabContext_workspaceIsConnectedToWorkspace(id: $id) {
				edges {
					node {
						id
					}
					cursor
				}
				pageInfo {
					endCursor
					hasNextPage
					hasPreviousPage
					startCursor
				}
			}
		}
	`;
    return graphQuery;
};
module.exports["SEARCH_PAGE_OPERATION_NAME"] = $6f6e40eb51d8920a$export$ba7243e49f8daaa4;
module.exports["SEARCH_DIALOG_OPERATION_NAME"] = $6f6e40eb51d8920a$export$87e857ecc7765700;
module.exports["queryGenerator"] = $6f6e40eb51d8920a$export$bcad4d0714f0772f;
module.exports["resultsCountOperationName"] = $6f6e40eb51d8920a$export$59ff8b98cf7da770;
module.exports["resultsCountQueryGenerator"] = $6f6e40eb51d8920a$export$35addfdbe1c7b563;
module.exports["jiraDcProjectFilterOptionsOperationName"] = $6f6e40eb51d8920a$export$fa19606e35da8d6d;
module.exports["confluenceDcSpaceFilterOptionsOperationName"] = $6f6e40eb51d8920a$export$56917484085c839f;
module.exports["thirdPartySpaceFilterOptionsOperationName"] = $6f6e40eb51d8920a$export$7fed2443afa81b26;
module.exports["thirdPartySpaceFilterOptionsQueryGenerator"] = $6f6e40eb51d8920a$export$5fce5a96ced87ae4;
module.exports["teamsWorkspaceFilterOptionsOperationName"] = $6f6e40eb51d8920a$export$8535d2c38a35eb6f;
module.exports["teamsWorkspaceFilterOptionsQueryGenerator"] = $6f6e40eb51d8920a$export$baa4ec00dd3889d8;
module.exports["thirdPartyRepositoryFilterOptionsOperationName"] = $6f6e40eb51d8920a$export$c768638eb8676119;
module.exports["thirdPartyRepositoryFilterOptionsQueryGenerator"] = $6f6e40eb51d8920a$export$3057eb5718aa2977;
module.exports["spaceARIEntitiesOperationName"] = $6f6e40eb51d8920a$export$4cc1a613b784cede;
module.exports["spaceARIEntitiesQueryGenerator"] = $6f6e40eb51d8920a$export$402074cb9d99809d;
module.exports["documentARIEntitiesOperationName"] = $6f6e40eb51d8920a$export$fd96e79bbd846735;
module.exports["documentARIEntitiesQueryGenerator"] = $6f6e40eb51d8920a$export$36d0a57a2adc8939;
module.exports["confluenceDcContentFilterOptionsOperationName"] = $6f6e40eb51d8920a$export$11124ad4475d739f;
module.exports["confluenceDcContentFilterOptionsQueryGenerator"] = $6f6e40eb51d8920a$export$80a2987504e5746a;
module.exports["confluenceDcPagesOperationName"] = $6f6e40eb51d8920a$export$b12a4e91aeaa7036;
module.exports["confluenceDcPagesQueryGenerator"] = $6f6e40eb51d8920a$export$feafc9cb648273dc;
module.exports["searchLinkedSitesOperationName"] = $6f6e40eb51d8920a$export$b6579c18b8ca60cd;
module.exports["searchLinkedSiteQueryGenerator"] = $6f6e40eb51d8920a$export$4d33288c2a5c7de0;

});

parcelRegister("3TZZX", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $bfn6U = parcelRequire("bfn6U");


var $lwDzf = parcelRequire("lwDzf");


var $51pfw = parcelRequire("51pfw");


var $cz1Yi = parcelRequire("cz1Yi");


var $imUxN = parcelRequire("imUxN");


var $axZZ7 = parcelRequire("axZZ7");


var $lqtzf = parcelRequire("lqtzf");


var $hABTJ = parcelRequire("hABTJ");


var $5Styu = parcelRequire("5Styu");


var $lwXsc = parcelRequire("lwXsc");

const $baa794815d2b0101$export$9f64d624a5905b0b = (serveUserShardUI = false)=>{
    return `
		${(0, $cz1Yi.getConfluencePartials)(serveUserShardUI)}
		${(0, $imUxN.getJiraPartials)()}
		${(0, $lwXsc.getTrelloPartials)()}
		${(0, $lwDzf.getAtlasPartials)()}
		${(0, $51pfw.getCompassPartials)()}
		${(0, $axZZ7.getMercuryPartials)()}
		${(0, $5Styu.getGraphPartials)()}
		${(0, $hABTJ.getFederatedPartials)()}
		${(0, $ixfCV.fg)('assets_rovo_search_all') ? (0, $bfn6U.getAssetsPartials)() : ''}
		${(0, $ixfCV.fg)('talent_global_search') ? (0, $lqtzf.getTalentPartials)() : ''}
	`;
};
module.exports["getSupportedPartials"] = $baa794815d2b0101$export$9f64d624a5905b0b;

});

parcelRegister("bfn6U", function(module, exports) {
const $ddc9a35e5ba235cd$export$6cb3c23f8cc6b5c8 = `
... on SearchResultAssetsObjectSchema {
	id
	title
	type
	description
	lastModifiedDate
	objectSchemaEntity {
		links {
			web
		}
	}
}
`;
const $ddc9a35e5ba235cd$export$6d6066e039c821f2 = (partial)=>{
    return partial.__typename === 'SearchResultAssetsObjectSchema';
};
const $ddc9a35e5ba235cd$export$f160c48c1d037f87 = ()=>{
    return `
		${$ddc9a35e5ba235cd$export$6cb3c23f8cc6b5c8}
	`;
};
const $ddc9a35e5ba235cd$export$6ff43818aa330e52 = `
... on SearchResultAssetsObjectType {
	id
	title
	type
	description
	lastModifiedDate
	objectSchemaEntity {
		id
		name
		links {
			web
		}
	}
	objectTypeEntity {
		icon {
			url48
		}
		links {
			web
		}
	}
}
`;
const $ddc9a35e5ba235cd$export$477919e939be033d = (partial)=>{
    return partial.__typename === 'SearchResultAssetsObjectType';
};
const $ddc9a35e5ba235cd$export$f11c57703f5bd591 = ()=>{
    return `
		${$ddc9a35e5ba235cd$export$6ff43818aa330e52}
	`;
};
const $ddc9a35e5ba235cd$export$e3c6dbbf952d90ed = `
... on SearchResultAssetsObject {
	id
	title
	description
	lastModifiedDate
	type
	schemaAri
	typeAri
	objectSchemaEntity {
		id
		name
		links {
			web
		}
	}
	objectTypeEntity {
		id
		name

	}
	objectEntity {
		links {
			web
		}
		avatar {
			url48
		}
	}
}
`;
const $ddc9a35e5ba235cd$export$6cfcb9e6160b8854 = (partial)=>{
    return partial.__typename === 'SearchResultAssetsObject';
};
const $ddc9a35e5ba235cd$export$48a3d1cc8f03ffb9 = ()=>{
    return `
		${$ddc9a35e5ba235cd$export$e3c6dbbf952d90ed}
	`;
};
const $ddc9a35e5ba235cd$export$b66206b66084d78d = (partial)=>{
    return $ddc9a35e5ba235cd$export$6d6066e039c821f2(partial) || $ddc9a35e5ba235cd$export$477919e939be033d(partial) || $ddc9a35e5ba235cd$export$6cfcb9e6160b8854(partial);
};
const $ddc9a35e5ba235cd$export$d49a85cc2b961760 = ()=>{
    return `
		${$ddc9a35e5ba235cd$export$f160c48c1d037f87()}
		${$ddc9a35e5ba235cd$export$f11c57703f5bd591()}
		${$ddc9a35e5ba235cd$export$48a3d1cc8f03ffb9()}
	`;
};
module.exports["isSearchResultAssetsObjectSchema"] = $ddc9a35e5ba235cd$export$6d6066e039c821f2;
module.exports["isSearchResultAssetsObjectType"] = $ddc9a35e5ba235cd$export$477919e939be033d;
module.exports["isSearchResultAssetsObject"] = $ddc9a35e5ba235cd$export$6cfcb9e6160b8854;
module.exports["isSearchAssetsPartial"] = $ddc9a35e5ba235cd$export$b66206b66084d78d;
module.exports["getAssetsPartials"] = $ddc9a35e5ba235cd$export$d49a85cc2b961760;

});

parcelRegister("lwDzf", function(module, exports) {
const $3a362426d95a08c8$var$SearchDefaultResultAtlas = ``;
const $3a362426d95a08c8$var$SearchResultAtlasProject = `
... on SearchResultAtlasProject {
  project {
    key
    state {
      label
      value
    }
    dueDate {
      label
    }
    isPrivate
  }
}
`;
const $3a362426d95a08c8$var$SearchResultAtlasGoal = `
... on SearchResultAtlasGoal {
  goal {
    description
    key
    status {
      localizedLabel {
        messageId
      }
      value
      score
    }
    targetDate {
      label
    }
  }
}
`;
const $3a362426d95a08c8$export$1724df33341798e0 = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchResultAtlasProject';
};
const $3a362426d95a08c8$export$1d556a3125797ca6 = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchResultAtlasGoal';
};
const $3a362426d95a08c8$export$bff995b1cea89df3 = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchResultAtlasTag';
};
const $3a362426d95a08c8$export$aa63de26c950cf0f = (partial)=>{
    return partial?.id?.includes('townsquare') && partial.__typename === 'SearchDefaultResult';
};
const $3a362426d95a08c8$export$750af6f011d7ee10 = (partial)=>{
    return $3a362426d95a08c8$export$1d556a3125797ca6(partial) || $3a362426d95a08c8$export$1724df33341798e0(partial) || $3a362426d95a08c8$export$bff995b1cea89df3(partial) || $3a362426d95a08c8$export$aa63de26c950cf0f(partial);
};
const $3a362426d95a08c8$export$272c689528faac47 = ()=>{
    return `
		${$3a362426d95a08c8$var$SearchResultAtlasGoal}
		${$3a362426d95a08c8$var$SearchResultAtlasProject}
		${$3a362426d95a08c8$var$SearchDefaultResultAtlas}
	`;
};
module.exports["isSearchResultAtlasProjectPartial"] = $3a362426d95a08c8$export$1724df33341798e0;
module.exports["isSearchResultAtlasGoalPartial"] = $3a362426d95a08c8$export$1d556a3125797ca6;
module.exports["isSearchAtlasPartial"] = $3a362426d95a08c8$export$750af6f011d7ee10;
module.exports["getAtlasPartials"] = $3a362426d95a08c8$export$272c689528faac47;

});

parcelRegister("51pfw", function(module, exports) {
const $e1374cb7dd251364$var$SearchResultCompassComponent = `
... on SearchResultCompassComponent {
	lastModifiedDate
	ownerId
	tier
	component {
		description
		state
	}
}
`;
const $e1374cb7dd251364$export$72cf2e1294c50ff4 = ()=>{
    return $e1374cb7dd251364$var$SearchResultCompassComponent;
};
const $e1374cb7dd251364$export$b8968ce5f9785283 = (partial)=>{
    return partial.__typename === 'SearchResultCompassComponent';
};
module.exports["getCompassPartials"] = $e1374cb7dd251364$export$72cf2e1294c50ff4;
module.exports["isSearchCompassPartial"] = $e1374cb7dd251364$export$b8968ce5f9785283;

});

parcelRegister("cz1Yi", function(module, exports) {
const $abaed1578237b609$var$SearchConfluencePageBlogAttachment = (serveUserShardUI)=>`
... on SearchConfluencePageBlogAttachment {
	lastModified
	${serveUserShardUI ? `
	latestUserAction @include(if: $includeUserSignals)
	latestUserActionTs @include(if: $includeUserSignals)
	` : ''}
	isVerified
	space {
		id
		name
		webUiLink
	}
	__typename
	confluenceEntity @include(if: $includeConfluenceEntity) {
		... on ConfluencePage {
			subtype
			commentCountSummary {
				total
			}
			likesSummary {
				count
			}
		}
	}
	socialSignal(tenantId: $tenantId) @include(if: $includeSocialSignals) {
		signal
		timestamp
		user {
			accountId
			name
			picture
			... on AtlassianAccountUser {
				email
				extendedProfile {
					jobTitle
				}
			}
		}
	}
	linkedResults {
		id
		title
		url
		type
		description
		lastModifiedDate
		category
		subtype
		integrationId
		providerId
	}
}
`;
const $abaed1578237b609$export$c89c057fd480d10c = (partial)=>{
    return partial.__typename === 'SearchConfluencePageBlogAttachment';
};
const $abaed1578237b609$var$SearchConfluenceSpace = `
... on SearchConfluenceSpace {
	key
	lastModified
	iconPath
	socialSignal(tenantId: $tenantId) @include(if: $includeSocialSignals) {
		signal
		timestamp
		user {
			accountId
			name
			picture
			... on AtlassianAccountUser {
				email
				extendedProfile {
					jobTitle
				}
			}
		}

	}
}
`;
const $abaed1578237b609$export$4619f000f23ee8d1 = (partial)=>{
    return partial.__typename === 'SearchConfluenceSpace';
};
const $abaed1578237b609$export$e4e5a86cb4c1e3e4 = (partial)=>{
    return $abaed1578237b609$export$c89c057fd480d10c(partial) || $abaed1578237b609$export$4619f000f23ee8d1(partial);
};
const $abaed1578237b609$export$d1ddb94b35ac2d77 = (serveUserShardUI = false)=>{
    return `
		${$abaed1578237b609$var$SearchConfluencePageBlogAttachment(serveUserShardUI)}
		${$abaed1578237b609$var$SearchConfluenceSpace}
	`;
};
module.exports["isSearchConfluencePageBlogAttachment"] = $abaed1578237b609$export$c89c057fd480d10c;
module.exports["isSearchConfluenceSpace"] = $abaed1578237b609$export$4619f000f23ee8d1;
module.exports["isSearchConfluencePartial"] = $abaed1578237b609$export$e4e5a86cb4c1e3e4;
module.exports["getConfluencePartials"] = $abaed1578237b609$export$d1ddb94b35ac2d77;

});

parcelRegister("imUxN", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 

/**
 * Hydrating the project avatar field causes additional latency so it is removed in this GraphQL Query
 * Investigation: https://hello.atlassian.net/wiki/x/iKKu8w
 */ const $fe7aae6ee50f421f$var$getSearchResultJiraProject = ()=>`
... on SearchResultJiraProject {
  projectId
  projectKey
  projectType
  lastModifiedDate
  project {
    webUrl
  }
	socialSignal(tenantId: $tenantId) @include(if: $includeSocialSignals) {
		signal
		timestamp
		user {
			accountId
			name
			picture
			... on AtlassianAccountUser {
				email
				extendedProfile {
					jobTitle
				}
			}
		}
	}
}`;
const $fe7aae6ee50f421f$export$aab3eed7c97209f8 = (partial)=>{
    return partial.__typename === 'SearchResultJiraProject';
};
const $fe7aae6ee50f421f$export$1f4b5d2e43f14510 = `
... on SearchResultJiraIssue {
  id
  title
  type
  description
  url
  iconUrl
  lastModifiedDate
  issueTypeId
  status {
    id
    name
  }
  issue {
    webUrl
		key
		assigneeField {
			user {
				name
				picture
			}
		}
    fieldsById(ids: ["project"]) {
      edges {
        node {
          __typename
          name
          ... on JiraProjectField {
            project {
              id
              name
			  projectType
            }
          }
        }
      }
    }
			issueTypeAvatarUrl
		issueTypeField @include(if: $includeJiraIssueType) {
			id
			issueType {
				id
				name
			}
		}
  }
  socialSignal(tenantId: $tenantId) @include(if: $includeSocialSignals) {
	    signal
		timestamp
		user {
			accountId
			name
			picture
			... on AtlassianAccountUser {
				email
				extendedProfile {
					jobTitle
				}
			}
	    }
  }
	linkedResults {
		id
		title
		url
		type
		description
		lastModifiedDate
		category
		subtype
		integrationId
		providerId
	}
  __typename
}
`;
const $fe7aae6ee50f421f$export$65f412f3857c35e0 = (partial)=>{
    return {
        ...partial,
        url: partial.issue?.webUrl || partial.url
    };
};
const $fe7aae6ee50f421f$export$85182d219d5a304f = (partial)=>({
        ...partial,
        url: partial.project?.webUrl || partial.url
    });
const $fe7aae6ee50f421f$export$e221e36ba6e9f139 = (partial)=>{
    return partial.__typename === 'SearchResultJiraIssue';
};
const $fe7aae6ee50f421f$export$9c283c2de8ddb8fb = (partial)=>{
    return partial.__typename === 'JiraProjectField' && partial.name === 'Project';
};
const $fe7aae6ee50f421f$export$832b8ae8473ed171 = ``;
const $fe7aae6ee50f421f$export$e0968d23c481cf04 = (partial)=>{
    return partial.__typename === 'SearchResultJiraFilter';
};
const $fe7aae6ee50f421f$export$7860041bfeffea77 = ``;
const $fe7aae6ee50f421f$export$3e9a71746a0d5ef1 = (partial)=>{
    return partial.__typename === 'SearchResultJiraDashboard';
};
const $fe7aae6ee50f421f$export$f2ae751487c16c56 = `
... on SearchResultJiraBoard {
  boardId
  container @include(if: $includeJiraBoardContainer) {
		__typename
		... on SearchResultJiraBoardProjectContainer {
			__typename
			projectName
		}
		... on SearchResultJiraBoardUserContainer {
			__typename
			userName
		}
	}
	board {
		boardFrontendUrl
		iconUrl
	}
  product
}
`;
const $fe7aae6ee50f421f$export$98e434e98950249c = (partial)=>{
    return partial.__typename === 'SearchResultJiraBoard';
};
const $fe7aae6ee50f421f$export$56752b3c89cc8a9e = (partial)=>{
    return partial.__typename === 'SearchResultJiraPlan';
};
const $fe7aae6ee50f421f$export$5a36738ca5faa27f = (partial)=>{
    return $fe7aae6ee50f421f$export$aab3eed7c97209f8(partial) || $fe7aae6ee50f421f$export$e221e36ba6e9f139(partial) || $fe7aae6ee50f421f$export$e0968d23c481cf04(partial) || $fe7aae6ee50f421f$export$3e9a71746a0d5ef1(partial) || $fe7aae6ee50f421f$export$98e434e98950249c(partial) || $fe7aae6ee50f421f$export$56752b3c89cc8a9e(partial);
};
const $fe7aae6ee50f421f$export$d1f9da0e5c74ebcb = ()=>{
    return `
		${$fe7aae6ee50f421f$var$getSearchResultJiraProject()}
		${$fe7aae6ee50f421f$export$1f4b5d2e43f14510}
		${$fe7aae6ee50f421f$export$832b8ae8473ed171}
		${$fe7aae6ee50f421f$export$7860041bfeffea77}
		${$fe7aae6ee50f421f$export$f2ae751487c16c56}
	`;
};
module.exports["isSearchResultJiraProject"] = $fe7aae6ee50f421f$export$aab3eed7c97209f8;
module.exports["isSearchResultJiraIssue"] = $fe7aae6ee50f421f$export$e221e36ba6e9f139;
module.exports["isJiraProjectField"] = $fe7aae6ee50f421f$export$9c283c2de8ddb8fb;
module.exports["isSearchResultJiraFilter"] = $fe7aae6ee50f421f$export$e0968d23c481cf04;
module.exports["isSearchResultJiraDashboard"] = $fe7aae6ee50f421f$export$3e9a71746a0d5ef1;
module.exports["isSearchResultJiraBoard"] = $fe7aae6ee50f421f$export$98e434e98950249c;
module.exports["isSearchJiraPartial"] = $fe7aae6ee50f421f$export$5a36738ca5faa27f;
module.exports["getJiraPartials"] = $fe7aae6ee50f421f$export$d1f9da0e5c74ebcb;

});

parcelRegister("axZZ7", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");

const $67028c881db0fef3$var$SearchResultMercuryFocusArea = `
... on SearchResultMercuryFocusArea {
	lastModifiedDate
	focusArea {
		id
		uuid
		name
		focusAreaType {
			id
			name
			hierarchyLevel
		}
		status {
			key
			displayName
		}
		health {
			key
			color
			displayName
		}
		targetDate {
			targetDate
			targetDateType
		}
		owner {
			accountId
			name
		}
	}
}
`;
const $67028c881db0fef3$var$SearchResultMercuryFocusAreaStatusUpdate = `
... on SearchResultMercuryFocusAreaStatusUpdate {
	lastModifiedDate
	focusArea {
		name
	}
}
`;
const $67028c881db0fef3$var$SearchResultMercuryOrganization = `
... on SearchResultMercuryOrganization {
	lastModifiedDate
	organization @optIn(to: "Mercury") {
		id
		name
		organizationType {
			id
			name
			hierarchyLevel
		}
		status {
			key
			displayName
		}
		targetDate {
			targetDate
			targetDateType
		}
		owner {
			accountId
			name
		}
	}
}
`;
const $67028c881db0fef3$var$SearchResultMercuryOrganizationStatusUpdate = `
... on SearchResultMercuryOrganizationStatusUpdate {
	lastModifiedDate
}
`;
const $67028c881db0fef3$var$SearchResultSpfAskPartial = `
... on SearchResultSpfAsk {
	lastModifiedDate
	ask @optIn(to: "Spf") {
		id
		name
		status
		targetDate {
			targetDate
			targetDateType
		}
	}
}
`;
const $67028c881db0fef3$var$SearchResultMercuryRiskPartial = `
... on SearchResultMercuryRisk {
	lastModifiedDate
	risk @optIn(to: "Mercury") {
		id
		name
		status {
			key
			displayName
		}
		targetDate {
			targetDate
			targetDateType
		}
	}
}
`;
const $67028c881db0fef3$export$8b0a4c9077b7d09b = (partial)=>{
    return partial?.id?.includes('mercury') && partial.__typename === 'SearchResultMercuryFocusArea';
};
const $67028c881db0fef3$export$c43349f9a39b01bd = (partial)=>{
    return partial?.id?.includes('mercury') && partial.__typename === 'SearchResultMercuryFocusAreaStatusUpdate';
};
const $67028c881db0fef3$export$d3264e7771e87974 = (partial)=>{
    return partial?.id?.includes('mercury') && partial.__typename === 'SearchResultMercuryOrganization';
};
const $67028c881db0fef3$export$aa29d4d3bbbb9e32 = (partial)=>{
    return partial?.id?.includes('mercury') && partial.__typename === 'SearchResultMercuryOrganizationStatusUpdate';
};
const $67028c881db0fef3$export$68b5e30200895184 = (partial)=>{
    return partial?.id?.includes('passionfruit') && partial.__typename === 'SearchResultSpfAsk';
};
const $67028c881db0fef3$export$180dc91590735353 = (partial)=>{
    return partial?.id?.includes('mercury') && partial.__typename === 'SearchResultMercuryRisk';
};
const $67028c881db0fef3$export$bbfb216d33463101 = (partial)=>{
    return $67028c881db0fef3$export$8b0a4c9077b7d09b(partial) || $67028c881db0fef3$export$c43349f9a39b01bd(partial) || $67028c881db0fef3$export$68b5e30200895184(partial) || $67028c881db0fef3$export$180dc91590735353(partial) || $67028c881db0fef3$export$d3264e7771e87974(partial) || $67028c881db0fef3$export$aa29d4d3bbbb9e32(partial);
};
const $67028c881db0fef3$export$fabaf03f9e1d6e25 = ()=>{
    return `
		${$67028c881db0fef3$var$SearchResultMercuryFocusArea}
		${$67028c881db0fef3$var$SearchResultMercuryFocusAreaStatusUpdate}
		${(0, $ixfCV.fg)('platform_passionfruit_search_onboarding_enabled') ? $67028c881db0fef3$var$SearchResultSpfAskPartial : ''}
		${(0, $ixfCV.fg)('platform_mercury_risk_search_ui_enabled') ? $67028c881db0fef3$var$SearchResultMercuryRiskPartial : ''}
		${(0, $ixfCV.fg)('platform_organization_search_onboarding_enabled') ? $67028c881db0fef3$var$SearchResultMercuryOrganization : ''}
		${(0, $ixfCV.fg)('platform_organization_search_onboarding_enabled') ? $67028c881db0fef3$var$SearchResultMercuryOrganizationStatusUpdate : ''}
	`;
};
module.exports["isSearchResultMercuryFocusAreaPartial"] = $67028c881db0fef3$export$8b0a4c9077b7d09b;
module.exports["isSearchResultMercuryFocusAreaStatusUpdatePartial"] = $67028c881db0fef3$export$c43349f9a39b01bd;
module.exports["isSearchResultMercuryOrganizationPartial"] = $67028c881db0fef3$export$d3264e7771e87974;
module.exports["isSearchResultMercuryOrganizationStatusUpdatePartial"] = $67028c881db0fef3$export$aa29d4d3bbbb9e32;
module.exports["isSearchResultSpfAskPartial"] = $67028c881db0fef3$export$68b5e30200895184;
module.exports["isSearchResultMercuryRiskPartial"] = $67028c881db0fef3$export$180dc91590735353;
module.exports["isSearchMercuryPartial"] = $67028c881db0fef3$export$bbfb216d33463101;
module.exports["getMercuryPartials"] = $67028c881db0fef3$export$fabaf03f9e1d6e25;

});

parcelRegister("lqtzf", function(module, exports) {
const $0e127d1d0d2dd836$var$SearchResultTalentPosition = `
... on SearchResultTalentPosition {
	__typename
	lastModifiedDate
	position {
		__typename
		worker {
			preferredName
			user {
				picture
			}
		}
		fieldValues(
			fieldIdIsIn: [
				"positionId",
				"positionStatus",
				"positionJobTitle",
				"positionPositionTitle",
				"positionKey",
				"positionExternalPositionKey",
				"positionWorker"
			]
		) {
			fieldId
			fieldValue {
				__typename
				... on RadarStringFieldValue {
					__typename
					stringValue: value
				}
			}
		}
	}
}
`;
const $0e127d1d0d2dd836$export$81d91ad826853e38 = (partial)=>{
    return partial?.id?.includes('radar') && partial.__typename === 'SearchResultTalentPosition';
};
const $0e127d1d0d2dd836$export$4f87e53676ad17f4 = (partial)=>{
    return $0e127d1d0d2dd836$export$81d91ad826853e38(partial);
};
const $0e127d1d0d2dd836$export$f39ac0d11d2a4da = ()=>{
    return `
		${$0e127d1d0d2dd836$var$SearchResultTalentPosition}
	`;
};
module.exports["isSearchTalentPartial"] = $0e127d1d0d2dd836$export$4f87e53676ad17f4;
module.exports["getTalentPartials"] = $0e127d1d0d2dd836$export$f39ac0d11d2a4da;

});

parcelRegister("hABTJ", function(module, exports) {

var $7avaU = parcelRequire("7avaU");


var $2HOu2 = parcelRequire("2HOu2");

const $8ff5965b7e47a02e$var$SearchResultFederatedPartial = `
... on SearchResultFederated @skip(if: $skipFieldsFor3pInQuickFind) {
	lastModifiedDate
	entity {
		${(0, $2HOu2.FederatedEmailPartial)}
	}
}
`;
var $8ff5965b7e47a02e$var$ResourceType = /*#__PURE__*/ function(ResourceType) {
    ResourceType["EMAIL"] = "email";
    return ResourceType;
}($8ff5965b7e47a02e$var$ResourceType || {});
const $8ff5965b7e47a02e$export$68ef445facedc0d5 = ()=>{
    return $8ff5965b7e47a02e$var$SearchResultFederatedPartial;
};
const $8ff5965b7e47a02e$export$4fafa9bf7ad5438a = (partial)=>partial.__typename === 'SearchResultFederated';
const $8ff5965b7e47a02e$export$c0c573cc3dff9ad6 = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "email";
};
module.exports["getFederatedPartials"] = $8ff5965b7e47a02e$export$68ef445facedc0d5;

});

parcelRegister("2HOu2", function(module, exports) {
const $28ebfbddd242fc9e$export$7c3d5c670817fb18 = `
... on SearchFederatedEmailEntity {
	sender {
		email
		name
	}
}
`;
module.exports["FederatedEmailPartial"] = $28ebfbddd242fc9e$export$7c3d5c670817fb18;

});

parcelRegister("5Styu", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $7avaU = parcelRequire("7avaU");


var $1qzQx = parcelRequire("1qzQx");


var $H9Wft = parcelRequire("H9Wft");


var $idD0I = parcelRequire("idD0I");


var $j325C = parcelRequire("j325C");


var $3UgcO = parcelRequire("3UgcO");


var $dR4Df = parcelRequire("dR4Df");


var $kg3OO = parcelRequire("kg3OO");


var $9GHVW = parcelRequire("9GHVW");


var $3e9cd = parcelRequire("3e9cd");


var $op8eC = parcelRequire("op8eC");


var $d7k9v = parcelRequire("d7k9v");


var $abc4G = parcelRequire("abc4G");


var $9kmby = parcelRequire("9kmby");


var $j8hui = parcelRequire("j8hui");


var $hV1Vq = parcelRequire("hV1Vq");


var $9GAIA = parcelRequire("9GAIA");


var $8UHlo = parcelRequire("8UHlo");


var $9dBo7 = parcelRequire("9dBo7");


var $lUvMj = parcelRequire("lUvMj");


var $8fx85 = parcelRequire("8fx85");


var $h0zJb = parcelRequire("h0zJb");


var $byWMV = parcelRequire("byWMV");

const $7cea49c1b7fc8fb2$var$TEAMS_INTEGRATION_ARI = 'ari:cloud:platform::integration/microsoft';
const $7cea49c1b7fc8fb2$var$SearchThirdPartyGraphDocumentPartial = `
... on SearchResultGraphDocument {
	excerpt @skip(if: $skipFieldsFor3pInQuickFind)
	permissionLevel @skip(if: $skipFieldsFor3pInQuickFind)
	initialContributors @skip(if: $skipFieldsFor3pInQuickFind) {
		name
		id
		externalId
	}
	subtype
	integrationId
	providerId
	connectorType
	lastModifiedDate
	linkedEntities @skip(if: $skipFieldsFor3pInQuickFind) {
		id
		title
		excerpt,
		permissionLevel,
		subtype
		integrationId
		lastModifiedDate
		entity @skip(if: $skip3pEntityHydration) {
			${(0, $9GAIA.ExternalMessagePartial)}
		}
		initialContributors {
			name
			id
			externalId
		}
		containerName @optIn(to: "SearchPerformanceImprovementChanges")
		allContributors @optIn(to: "SearchPerformanceImprovementChanges") {
			id
			accountId
			externalId
			name
			nickname
			email
			picture
			extendedProfile {
				jobTitle
				department
				organization
			}
		}
	}
	entity @skip(if: $skip3pEntityHydration) {
		${(0, $1qzQx.ExternalBranchPartial)}
		${(0, $H9Wft.ExternalCalendarEventPartial)}
		${(0, $idD0I.ExternalCampaignPartial)}
		${(0, $j325C.ExternalCasePartial)}
		${(0, $hV1Vq.ExternalLeadPartial)}
		${(0, $abc4G.ExternalDealPartial)}
		${(0, $3e9cd.ExternalCustomerOrgPartial)}
		${(0, $kg3OO.ExternalCommitPartial)}
		${(0, $9GHVW.ExternalConversationPartial)}
		${(0, $9kmby.ExternalDesignPartial)}
		${(0, $op8eC.ExternalDashboardPartial)}
		${(0, $d7k9v.ExternalDataTablePartial)}
		${(0, $j8hui.ExternalDocumentPartial)}
		${(0, $9GAIA.ExternalMessagePartial)}
		${(0, $8UHlo.ExternalProjectPartial)}
		${(0, $9dBo7.ExternalPullRequestPartial)}
		${(0, $8fx85.ExternalRepositoryPartial)}
		${(0, $h0zJb.ExternalVideoPartial)}
		${(0, $byWMV.ExternalWorkItemPartial)}
		${(0, $dR4Df.ExternalCommentPartial)}
		${(0, $lUvMj.ExternalRemoteLinkPartial)}
	}
	entity @include(if: $includeGithubEntityHydration) {
		${(0, $9dBo7.ExternalPullRequestPartial)}
		${(0, $8fx85.ExternalRepositoryPartial)}
		${(0, $byWMV.ExternalWorkItemPartial)}
	}
	containerName @optIn(to: "SearchPerformanceImprovementChanges") @skip(if: $skipFieldsFor3pInQuickFind)
	allContributors @optIn(to: "SearchPerformanceImprovementChanges") @skip(if: $skipFieldsFor3pInQuickFind) {
		id
		accountId
		externalId
		name
		nickname
		email
		picture
		extendedProfile {
			jobTitle
			department
			organization
		}
	}
	linkedResults @skip(if: $skipFieldsFor3pInQuickFind) {
		id
		title
		url
		type
		description
		lastModifiedDate
		category
		subtype
		integrationId
		providerId
	}
}
`;
var $7cea49c1b7fc8fb2$var$AccountStatus = /*#__PURE__*/ function(AccountStatus) {
    AccountStatus[AccountStatus["active"] = 0] = "active";
    AccountStatus[AccountStatus["inactive"] = 1] = "inactive";
    AccountStatus[AccountStatus["closed"] = 2] = "closed";
    return AccountStatus;
}($7cea49c1b7fc8fb2$var$AccountStatus || {});
var $7cea49c1b7fc8fb2$var$ExternalDocumentCategory = /*#__PURE__*/ function(ExternalDocumentCategory) {
    ExternalDocumentCategory[ExternalDocumentCategory["ARCHIVE"] = 0] = "ARCHIVE";
    ExternalDocumentCategory[ExternalDocumentCategory["AUDIO"] = 1] = "AUDIO";
    ExternalDocumentCategory[ExternalDocumentCategory["CODE"] = 2] = "CODE";
    ExternalDocumentCategory[ExternalDocumentCategory["DOCUMENT"] = 3] = "DOCUMENT";
    ExternalDocumentCategory[ExternalDocumentCategory["FOLDER"] = 4] = "FOLDER";
    ExternalDocumentCategory[ExternalDocumentCategory["FORM"] = 5] = "FORM";
    ExternalDocumentCategory[ExternalDocumentCategory["IMAGE"] = 6] = "IMAGE";
    ExternalDocumentCategory[ExternalDocumentCategory["OTHER"] = 7] = "OTHER";
    ExternalDocumentCategory[ExternalDocumentCategory["PDF"] = 8] = "PDF";
    ExternalDocumentCategory[ExternalDocumentCategory["PRESENTATION"] = 9] = "PRESENTATION";
    ExternalDocumentCategory[ExternalDocumentCategory["SHORTCUT"] = 10] = "SHORTCUT";
    ExternalDocumentCategory[ExternalDocumentCategory["SPREADSHEET"] = 11] = "SPREADSHEET";
    ExternalDocumentCategory[ExternalDocumentCategory["VIDEO"] = 12] = "VIDEO";
    ExternalDocumentCategory[ExternalDocumentCategory["WEB_PAGE"] = 13] = "WEB_PAGE";
    return ExternalDocumentCategory;
}($7cea49c1b7fc8fb2$var$ExternalDocumentCategory || {});
var $7cea49c1b7fc8fb2$var$ExternalEventType = /*#__PURE__*/ function(ExternalEventType) {
    ExternalEventType["APPOINTMENT"] = "appointment";
    ExternalEventType["BIRTHDAY"] = "birthday";
    ExternalEventType["DEFAULT"] = "default";
    ExternalEventType["EVENT"] = "event";
    ExternalEventType["FOCUS_TIME"] = "focus_time";
    ExternalEventType["OUT_OF_OFFICE"] = "out_of_office";
    ExternalEventType["REMINDER"] = "reminder";
    ExternalEventType["TASK"] = "task";
    ExternalEventType["WORKING_LOCATION"] = "working_location";
    return ExternalEventType;
}($7cea49c1b7fc8fb2$var$ExternalEventType || {});
var $7cea49c1b7fc8fb2$var$ExternalAttendeeRsvpStatus = /*#__PURE__*/ function(ExternalAttendeeRsvpStatus) {
    ExternalAttendeeRsvpStatus["ACCEPTED"] = "accepted";
    ExternalAttendeeRsvpStatus["DECLINED"] = "declined";
    ExternalAttendeeRsvpStatus["NOT_RESPONDED"] = "not_responded";
    ExternalAttendeeRsvpStatus["OTHER"] = "other";
    ExternalAttendeeRsvpStatus["TENATIVELY_ACCEPTED"] = "tenatively_accepted";
    return ExternalAttendeeRsvpStatus;
}($7cea49c1b7fc8fb2$var$ExternalAttendeeRsvpStatus || {});
var $7cea49c1b7fc8fb2$var$ExternalWorkItemType = /*#__PURE__*/ function(ExternalWorkItemType) {
    ExternalWorkItemType["TASK"] = "task";
    ExternalWorkItemType["DEFAULT_TASK"] = "default_task";
    ExternalWorkItemType["WORK_ITEM"] = "work_item";
    ExternalWorkItemType["EPIC"] = "epic";
    ExternalWorkItemType["BUG"] = "bug";
    ExternalWorkItemType["STORY"] = "story";
    ExternalWorkItemType["MILESTONE"] = "milestone";
    ExternalWorkItemType["SECTION"] = "section";
    ExternalWorkItemType["APPROVAL"] = "approval";
    ExternalWorkItemType["PROBLEM"] = "problem";
    ExternalWorkItemType["INCIDENT"] = "incident";
    ExternalWorkItemType["QUESTION"] = "question";
    ExternalWorkItemType["ISSUE"] = "issue";
    ExternalWorkItemType["TICKET"] = "ticket";
    ExternalWorkItemType["REQUESTED_ITEM"] = "requested_item";
    ExternalWorkItemType["CATALOG_ITEM"] = "catalog_item";
    ExternalWorkItemType["OTHER"] = "other";
    return ExternalWorkItemType;
}($7cea49c1b7fc8fb2$var$ExternalWorkItemType || {});
var $7cea49c1b7fc8fb2$var$ExternalMembershipType = /*#__PURE__*/ function(ExternalMembershipType) {
    ExternalMembershipType["PRIVATE"] = "PRIVATE";
    ExternalMembershipType["PUBLIC"] = "PUBLIC";
    ExternalMembershipType["SHARED"] = "SHARED";
    return ExternalMembershipType;
}($7cea49c1b7fc8fb2$var$ExternalMembershipType || {});
var $7cea49c1b7fc8fb2$var$ExternalConversationType = /*#__PURE__*/ function(ExternalConversationType) {
    ExternalConversationType["CHANNEL"] = "CHANNEL";
    ExternalConversationType["DIRECT_MESSAGE"] = "DIRECT_MESSAGE";
    ExternalConversationType["GROUP_DIRECT_MESSAGE"] = "GROUP_DIRECT_MESSAGE";
    return ExternalConversationType;
}($7cea49c1b7fc8fb2$var$ExternalConversationType || {});
var $7cea49c1b7fc8fb2$export$c6f9da6f70cfc2eb = /*#__PURE__*/ function(ResourceType) {
    ResourceType["BRANCH"] = "branch";
    ResourceType["CALENDAR_EVENT"] = "calendar-event";
    ResourceType["CAMPAIGN"] = "campaign";
    ResourceType["CASE"] = "case";
    ResourceType["LEAD"] = "lead";
    ResourceType["DEAL"] = "deal";
    ResourceType["CUSTOMER_ORG"] = "customer-org";
    ResourceType["CUSTOMER_CONTACT"] = "customer-contact";
    ResourceType["COMMENT"] = "comment";
    ResourceType["COMMIT"] = "commit";
    ResourceType["CONVERSATION"] = "conversation";
    ResourceType["DESIGN"] = "design";
    ResourceType["DOCUMENT"] = "document";
    ResourceType["MESSAGE"] = "message";
    ResourceType["PROJECT"] = "project";
    ResourceType["PULL_REQUEST"] = "pull-request";
    ResourceType["REPOSITORY"] = "repository";
    ResourceType["VIDEO"] = "video";
    ResourceType["WORK_ITEM"] = "work-item";
    ResourceType["SPACE"] = "space";
    ResourceType["REMOTE_LINK"] = "remote-link";
    ResourceType["DASHBOARD"] = "dashboard";
    ResourceType["DATA_TABLE"] = "data-table";
    return ResourceType;
}({});
const $7cea49c1b7fc8fb2$export$e169b729a14ad5f8 = ()=>{
    // One inline fragment per top-level 3P SearchResult subtype. Code results are a
    // distinct GraphQL type (SearchResultGraphCode); all other 3P documents share
    // SearchResultGraphDocument and discriminate via `entity { ... on ExternalX }`.
    // SearchResultGraphCode is gated to limit blast radius until the experiment ships.
    const partials = [
        $7cea49c1b7fc8fb2$var$SearchThirdPartyGraphDocumentPartial
    ];
    if ((0, $ixfCV.fg)('rovo_github_code_search')) partials.push((0, $3UgcO.ExternalCodePartial));
    return partials.join('\n');
};
const $7cea49c1b7fc8fb2$export$7dd4baba91338caa = (partial)=>partial.__typename === 'SearchResultGraphDocument';
const $7cea49c1b7fc8fb2$export$6c20afe8743cb761 = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "conversation";
};
const $7cea49c1b7fc8fb2$export$8dc9be81b5b6266b = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "design";
};
const $7cea49c1b7fc8fb2$export$33e8c1bbf9148b0e = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "message";
};
const $7cea49c1b7fc8fb2$export$9cfcc6ca7fb6e839 = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "video";
};
const $7cea49c1b7fc8fb2$export$9a3959a38fa67fd0 = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "branch";
};
const $7cea49c1b7fc8fb2$export$ece3e91c16809748 = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "commit";
};
const $7cea49c1b7fc8fb2$export$5bdc07901b0022c6 = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "comment";
};
const $7cea49c1b7fc8fb2$export$5ba84cc314040e0c = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "pull-request";
};
const $7cea49c1b7fc8fb2$export$9c4afe4ccb574692 = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "repository";
};
const $7cea49c1b7fc8fb2$export$32c06ee7e0e9b79e = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "document";
};
const $7cea49c1b7fc8fb2$export$791f1b4852e2a184 = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "project";
};
const $7cea49c1b7fc8fb2$export$92306a022e0703e0 = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "calendar-event";
};
const $7cea49c1b7fc8fb2$export$e23befac5f018c0b = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "deal";
};
const $7cea49c1b7fc8fb2$export$8d26baa8fb7886c4 = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "case";
};
const $7cea49c1b7fc8fb2$export$92e7f2bf63e191a = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "lead";
};
const $7cea49c1b7fc8fb2$export$4b4ac5f6534c6ce2 = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "campaign";
};
const $7cea49c1b7fc8fb2$export$1aff0f2a91c0ea03 = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "customer-org";
};
const $7cea49c1b7fc8fb2$export$40f90006d8fc8dee = (partial)=>$7cea49c1b7fc8fb2$export$33e8c1bbf9148b0e(partial) && partial.integrationId === $7cea49c1b7fc8fb2$var$TEAMS_INTEGRATION_ARI;
const $7cea49c1b7fc8fb2$export$162dad7a1238d377 = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "work-item";
};
const $7cea49c1b7fc8fb2$export$b10c98faa2e0b99a = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "dashboard";
};
const $7cea49c1b7fc8fb2$export$a24b6b49e5e27b50 = (partial)=>partial.__typename === 'SearchResultGraphCode';
const $7cea49c1b7fc8fb2$export$c9efee8db4eaf865 = (partial)=>{
    const { resourceType: resourceType } = (0, $7avaU.AnyAri).parse(partial.id);
    return resourceType === "data-table";
};
module.exports["ResourceType"] = $7cea49c1b7fc8fb2$export$c6f9da6f70cfc2eb;
module.exports["getGraphPartials"] = $7cea49c1b7fc8fb2$export$e169b729a14ad5f8;
module.exports["isSearchResultGraphEntity"] = $7cea49c1b7fc8fb2$export$7dd4baba91338caa;
module.exports["isPullRequestEntity"] = $7cea49c1b7fc8fb2$export$5ba84cc314040e0c;
module.exports["isDocumentEntity"] = $7cea49c1b7fc8fb2$export$32c06ee7e0e9b79e;
module.exports["isWorkItemEntity"] = $7cea49c1b7fc8fb2$export$162dad7a1238d377;
module.exports["isCodeResult"] = $7cea49c1b7fc8fb2$export$a24b6b49e5e27b50;

});

parcelRegister("1qzQx", function(module, exports) {
const $43438089e0bb18a5$export$5b6173385ccfaeaa = `
... on ExternalBranch {
    name
    container @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalRepository {
            name
        }
    }
}
`;
module.exports["ExternalBranchPartial"] = $43438089e0bb18a5$export$5b6173385ccfaeaa;

});

parcelRegister("H9Wft", function(module, exports) {
const $5426fa20c232f2c4$export$253480f0254db4f8 = `
... on ExternalCalendarEvent {
	attachments {
		byteSize
		mimeType
		thumbnailUrl
		title
		url
	}
	attendees {
		isOptional
		rsvpStatus
		user {
			thirdPartyUser {
				id
				email
				name
			}
			user {
				name
			}
		}
	}
	createdBy {
		thirdPartyUser {
			id
			email
			externalId
			name
			picture
		}
		user {
			name
		}
	}
	eventEndTime
	eventStartTime
	eventType
	location {
		address
		coordinates
		name
		url
	}
	recurringEventId
	videoMeetingUrl
}
`;
module.exports["ExternalCalendarEventPartial"] = $5426fa20c232f2c4$export$253480f0254db4f8;

});

parcelRegister("idD0I", function(module, exports) {
const $9fab2a79457ea924$export$e6966bd80a36700a = `
... on ExternalCampaign {
	status
	startDate
	endDate
	lastUpdated
	owners {
		thirdPartyUser {
			name
		}
	}
	createdBy {
		thirdPartyUser {
			name
		}
	}
}
`;
module.exports["ExternalCampaignPartial"] = $9fab2a79457ea924$export$e6966bd80a36700a;

});

parcelRegister("j325C", function(module, exports) {
const $148eecc81654df3e$export$86a2488e87c72bef = `
... on ExternalCase {
	displayNumber
	status
	isClosed
	lastUpdated
	owners {
		thirdPartyUser {
			accountId
			externalId
			name
			email
			id
		}
		user {
			name
		}
	}
	createdBy {
		thirdPartyUser {
			name
		}
	}
	container @optIn(to: "ExternalDataDepotQueryV2") {
		... on ExternalCustomerOrg {
			id
			displayName
		}
	}
}
`;
module.exports["ExternalCasePartial"] = $148eecc81654df3e$export$86a2488e87c72bef;

});

parcelRegister("3UgcO", function(module, exports) {
const $b757b8ad21357e78$export$f68956972379b38e = `
... on SearchResultGraphCode {
    path
    repository {
        name
    }
}
`;
module.exports["ExternalCodePartial"] = $b757b8ad21357e78$export$f68956972379b38e;

});

parcelRegister("dR4Df", function(module, exports) {
const $2694d7ba17518777$export$fd6f695cd68738d3 = `
... on ExternalComment {
	container @optIn(to: "ExternalDataDepotQueryV2") {
		... on ExternalSpace {
		displayName
		url
		subtype @include(if: $includeSpaceSubtype)
	   }
	}
}
`;
module.exports["ExternalCommentPartial"] = $2694d7ba17518777$export$fd6f695cd68738d3;

});

parcelRegister("kg3OO", function(module, exports) {
const $78cf6920f86363d6$export$3dcd3e619ad10a8c = `
... on ExternalCommit {
    author {
        user {
            name
        }
    }
    container @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalRepository{
            name
        }
    }
}
`;
module.exports["ExternalCommitPartial"] = $78cf6920f86363d6$export$3dcd3e619ad10a8c;

});

parcelRegister("9GHVW", function(module, exports) {
const $9d113d470662ea74$export$4597d51c3a28368e = `
... on ExternalConversation {
    id
    memberCount
    displayName
    membershipType
    workspace
    topic
    members {
        thirdPartyUser {
            id
            name
        }
        user {
            id
            name
        }
    }
}
`;
module.exports["ExternalConversationPartial"] = $9d113d470662ea74$export$4597d51c3a28368e;

});

parcelRegister("3e9cd", function(module, exports) {
const $294804153487137a$export$7a4547f8268cefd4 = `
... on ExternalCustomerOrg {
	country
	accountType
	thirdPartyId
	websiteUrl
	industry
	displayName
	contributors {
		thirdPartyUser {
			id
			name
		}
	}
	contacts {
		thirdPartyUser {
			id
			accountId
			externalId
			name
			nickname
			email
			picture
			extendedProfile {
				jobTitle
				department
				organization
			}
		}
		user {
			id
			name
		}
	}
	parent @optIn(to: "ExternalDataDepotQueryV2"){
		...on ExternalCustomerOrg {
			id
			displayName
		}
	}
	customerOrgLastActivity {
		lastActivityAt
		event
	}
	lifeTimeValue {
		value
		currencyCode
	}
}
`;
module.exports["ExternalCustomerOrgPartial"] = $294804153487137a$export$7a4547f8268cefd4;

});

parcelRegister("op8eC", function(module, exports) {
const $b70b8e66fb8813f5$export$7192c9d070d6e5d6 = `
... on ExternalDashboard {
	id
	url
	createdAt
	description
	displayName
	workspaceName
	lastUpdatedAt
	updateSequenceNumber
	lastUpdatedBy {
		thirdPartyUserId
		userId
	}
	owners {
		userId
		thirdPartyUser {
          	  name
        }
	}
	elements {
		name
		innerComponents
	}
	pages {
		name
	}
}
`;
module.exports["ExternalDashboardPartial"] = $b70b8e66fb8813f5$export$7192c9d070d6e5d6;

});

parcelRegister("d7k9v", function(module, exports) {
const $537c1e2032e51776$export$9f456561562ee774 = `
... on ExternalDataTable {
	id
	url
	dataTableType: type
	createdAt
	description
	displayName
	workspaceName
	lastUpdatedAt
	updateSequenceNumber
	lastUpdatedBy {
		thirdPartyUserId
		userId
	}
	owners {
		userId
		thirdPartyUser {
          	  name
        }
	}
	columns {
		name
		columnType
		description
		isRequired
	}
}
`;
module.exports["ExternalDataTablePartial"] = $537c1e2032e51776$export$9f456561562ee774;

});

parcelRegister("abc4G", function(module, exports) {
const $1c3d305843ceb449$export$d80c383820958dae = `
... on ExternalDeal {
	stage
	accountName
	dealClosedAt
	isClosed
	thirdPartyId
	parentId
	lastActivity {
		lastActivityAt
		event
	}
	opportunityAmount {
		value
		currencyCode
	}
	contributors {
		user {
			thirdPartyUser {
				id
				name
			}
		}
	}
	contact {
		thirdPartyUser {
			id
			accountId
			externalId
			name
			nickname
			email
			picture
			extendedProfile {
				jobTitle
				department
				organization
			}
		}
		user {
			id
			name
		}
	}
	parent @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalCustomerOrg {
          id
          displayName
        }
    }
}
`;
module.exports["ExternalDealPartial"] = $1c3d305843ceb449$export$d80c383820958dae;

});

parcelRegister("9kmby", function(module, exports) {
const $262146a3ee752664$export$5eda2cda79f28143 = `
... on ExternalDesign {
    thumbnail {
        externalUrl
    }
}
`;
module.exports["ExternalDesignPartial"] = $262146a3ee752664$export$5eda2cda79f28143;

});

parcelRegister("j8hui", function(module, exports) {
const $f5f5770abca4ed75$export$6193eef58692a804 = `
... on ExternalDocument {
    type {
        iconUrl
    }
    thirdPartyId
    parent @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalDocument {
            displayName
            url
        }
    }
	container @optIn(to: "ExternalDataDepotQueryV2") {
		... on ExternalSpace {
            displayName
            url
		}
	}
    reactions {
        reactionType
        total
    }
}
`;
module.exports["ExternalDocumentPartial"] = $f5f5770abca4ed75$export$6193eef58692a804;

});

parcelRegister("hV1Vq", function(module, exports) {
const $88d795ef5725e089$export$4396a1e234d5b991 = `
... on ExternalLead {
	status
	lastUpdated
	owners {
		thirdPartyUser {
			name
		}
	}
	createdBy {
		thirdPartyUser {
			name
		}
	}
}
`;
module.exports["ExternalLeadPartial"] = $88d795ef5725e089$export$4396a1e234d5b991;

});

parcelRegister("9GAIA", function(module, exports) {
const $748b839adcbb907e$export$3b9ed83b2b731ba0 = `
... on ExternalMessage {
    lastUpdated
    lastActive
    description
    reactionCount
    attachments {
	    title
        mimeType
        thumbnailUrl
        url
    }
    createdBy {
        thirdPartyUser {
            id
            accountId
            externalId
            name
            nickname
            email
			picture
            extendedProfile {
                jobTitle
                department
                organization
            }
        }
        user {
            id
            name
        }
    }
    container @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalConversation {
            id
            displayName
            memberCount
            membershipType
            type
            members {
                thirdPartyUser {
                    id
                    name
                    nickname
                    email
                    extendedProfile {
                        jobTitle
                        department
                        organization
                    }
                }
            }
        }
    }
    associatedWith {
        edges {
            node {
                id
                createdBy {
                    thirdPartyUser {
                        id
                        accountId
                        externalId
                        name
                        email
                    }
                }
                entity {
					__typename
					... on ExternalConversation {
						id
						displayName
						channelId:externalId
					}
					... on ThirdPartyUser {
                        id
                        email
						externalId
                        name
                        nickname
                        picture
                        extendedProfile {
                            jobTitle
                            department
                            organization
                        }
                    }
                }
            }
        }
    }
}
`;
module.exports["ExternalMessagePartial"] = $748b839adcbb907e$export$3b9ed83b2b731ba0;

});

parcelRegister("8UHlo", function(module, exports) {
const $ed95a68ae80492ce$export$f35cf9a497ba81f2 = `
... on ExternalProject {
	assignee {
		thirdPartyUser {
			id
			email
			name
		}
		user {
			name
		}
	}
	attachments {
		byteSize
		mimeType
		thumbnailUrl
		title
		url
	}
	createdBy {
		thirdPartyUser {
			id
			email
			name
		}
		user {
			name
		}
	}
	dueDate
	key
	status
	container @optIn(to: "ExternalDataDepotQueryV2") {
		... on ExternalSpace {
		displayName
		url
		subtype @include(if: $includeSpaceSubtype)
	   }
	}
}
`;
module.exports["ExternalProjectPartial"] = $ed95a68ae80492ce$export$f35cf9a497ba81f2;

});

parcelRegister("9dBo7", function(module, exports) {
const $732513b7ebdc37d6$export$fa7eefb2a03609fe = `
... on ExternalPullRequest {
    title
    lastUpdate
	pullRequestId
	pullRequestStatus: status
    container @optIn(to: "ExternalDataDepotQueryV2") {
        ... on ExternalRepository {
            name
        }
    }
}
`;
module.exports["ExternalPullRequestPartial"] = $732513b7ebdc37d6$export$fa7eefb2a03609fe;

});

parcelRegister("lUvMj", function(module, exports) {
const $a0269cbba7ec258c$export$2d22922c940459cd = `
... on ExternalRemoteLink {
  thumbnail {
    externalUrl
  }
}
`;
module.exports["ExternalRemoteLinkPartial"] = $a0269cbba7ec258c$export$2d22922c940459cd;

});

parcelRegister("8fx85", function(module, exports) {
const $b845bd70571620dd$export$82972f33e243e789 = `
... on ExternalRepository {
    name
}
`;
module.exports["ExternalRepositoryPartial"] = $b845bd70571620dd$export$82972f33e243e789;

});

parcelRegister("h0zJb", function(module, exports) {
const $dbd577a8d8c9a91d$export$d872aa2b0db5eb10 = `
... on ExternalVideo {
    durationInSeconds
    thumbnailUrl
    chapters {
        title
        startTimeInSeconds
    }
    createdBy {
        thirdPartyUser {
            id
            email
            name
        }
        user {
            name
        }
    }
}
`;
module.exports["ExternalVideoPartial"] = $dbd577a8d8c9a91d$export$d872aa2b0db5eb10;

});

parcelRegister("byWMV", function(module, exports) {
const $f9239d79f74c5c38$export$a50a1db4dd4e2aa3 = `
... on ExternalWorkItem {
	assignee {
		thirdPartyUser {
			id
			email
			name
		}
		user {
			name
		}
	}
	attachments {
		byteSize
		mimeType
		thumbnailUrl
		title
		url
	}
	collaborators {
		thirdPartyUser {
			id
			email
			name
		}
		user {
			name
		}
	}
	createdBy {
		thirdPartyUser {
			id
			email
			name
		}
		user {
			name
		}
	}
	dueDate
	exceedsMaxCollaborators
	workItemProject {
		id
		name
	}
	status
	subtype
	team
	container @optIn(to: "ExternalDataDepotQueryV2") {
		... on ExternalSpace {
		displayName
		url
		subtype @include(if: $includeSpaceSubtype)
	   }
	}
}
`;
module.exports["ExternalWorkItemPartial"] = $f9239d79f74c5c38$export$a50a1db4dd4e2aa3;

});

parcelRegister("lwXsc", function(module, exports) {
const $c0671df377997fec$var$SearchResultTrelloBoard = `
... on SearchResultTrelloBoard {
	type
	description
	lastModifiedDate
}
`;
const $c0671df377997fec$export$d40aaa445b6f7858 = (partial)=>{
    return partial.__typename === 'SearchResultTrelloBoard';
};
const $c0671df377997fec$var$SearchResultTrelloCard = `
... on SearchResultTrelloCard {
	type
	description
	lastModifiedDate
	boardName
	commentsCount
	linkedResults {
		id
		title
		url
		type
		description
		lastModifiedDate
		category
		subtype
		integrationId
		providerId
	}
}
`;
const $c0671df377997fec$export$980cabf11d827509 = (partial)=>{
    return partial.__typename === 'SearchResultTrelloCard';
};
const $c0671df377997fec$export$6ed59678949b7701 = (partial)=>{
    return $c0671df377997fec$export$d40aaa445b6f7858(partial) || $c0671df377997fec$export$980cabf11d827509(partial);
};
const $c0671df377997fec$export$73993ded7a48a460 = ()=>{
    return `
		${$c0671df377997fec$var$SearchResultTrelloBoard}
		${$c0671df377997fec$var$SearchResultTrelloCard}
	`;
};
module.exports["isSearchTrelloPartial"] = $c0671df377997fec$export$6ed59678949b7701;
module.exports["getTrelloPartials"] = $c0671df377997fec$export$73993ded7a48a460;

});

parcelRegister("33u17", function(module, exports) {
const $ae48cc92829f03f8$export$37c9c6a3ae5f363c = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isJiraIssueIndexed;
};
module.exports["getJiraIssueIndexedForTenant"] = $ae48cc92829f03f8$export$37c9c6a3ae5f363c;

});

parcelRegister("fIdaz", function(module, exports) {
const $4db360da15a65550$export$c635d3296555e2da = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.productDataRegions)?.productDataRegions;
};
module.exports["getProductDataRegions"] = $4db360da15a65550$export$c635d3296555e2da;

});

parcelRegister("lG3cK", function(module, exports) {
const $66c890b711298d6f$export$53e066a63a960439 = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.productEdition)?.productEdition;
};
module.exports["getProductEdition"] = $66c890b711298d6f$export$53e066a63a960439;

});

parcelRegister("23xJD", function(module, exports) {
const $1278134308bb68fc$export$2a1c0662041ee0a3 = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.rovoFeatures)?.rovoFeatures;
};
module.exports["getRovoFeatures"] = $1278134308bb68fc$export$2a1c0662041ee0a3;

});

parcelRegister("0SpY7", function(module, exports) {
const $ab9de293bd9af112$export$7693a3bd75b4a085 = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isNounsAvailable;
};
module.exports["isNounsAvailable"] = $ab9de293bd9af112$export$7693a3bd75b4a085;

});

parcelRegister("lKvkH", function(module, exports) {
const $b8f211e3fef74233$export$243c13f4da40a98e = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isRovoEnabled;
};
module.exports["isRovoEnabled"] = $b8f211e3fef74233$export$243c13f4da40a98e;

});

parcelRegister("d396o", function(module, exports) {
/**
 * Primary product keys represent products that can mount Search Page.
 */ const $006726c89d71ae03$export$15d12effc8830544 = {
    Atlas: 'townsquare',
    Confluence: 'confluence',
    Assets: 'cmdb',
    Focus: 'mercury',
    Jira: 'jira',
    Elevate: 'elevate',
    Talent: 'radar',
    RovoExtension: 'rovo-extension',
    Studio: 'studio'
};
module.exports["PrimaryProductKeys"] = $006726c89d71ae03$export$15d12effc8830544;

});

parcelRegister("aqAfG", function(module, exports) {


const $04ba0efeefc046b8$export$a0110d095394669e = {
    Atlas: 'townsquare',
    Bitbucket: 'bitbucket',
    Compass: 'compass',
    Confluence: 'confluence',
    Jira: 'jira',
    JiraProductDiscovery: 'jira-product-discovery',
    JiraServiceManagement: 'jira-servicedesk',
    Trello: 'trello',
    Focus: 'mercury',
    Assets: 'cmdb',
    Talent: 'radar'
};
const $04ba0efeefc046b8$export$deaa7a6e1403419a = Object.values($04ba0efeefc046b8$export$a0110d095394669e);
const $04ba0efeefc046b8$export$a93cddd79e3ea530 = {
    project: 'project',
    goal: 'goal',
    AtlassianWebCrawler: 'atlassian-web-crawler'
};
const $04ba0efeefc046b8$export$cc6a3ce6b37346b2 = (key)=>{
    return Object.values($04ba0efeefc046b8$export$a93cddd79e3ea530).includes(key);
};
module.exports["ProductKeys1P"] = $04ba0efeefc046b8$export$a0110d095394669e;
module.exports["ARI_EXTRACTED_1P_KEYS"] = $04ba0efeefc046b8$export$deaa7a6e1403419a;
module.exports["NounKeys"] = $04ba0efeefc046b8$export$a93cddd79e3ea530;

});

parcelRegister("5OPAY", function(module, exports) {






const $4d92eafc5833ccdb$var$EXTRACT_CLOUD_ID = /ari:cloud:.*?\/(.*)/;
const $4d92eafc5833ccdb$export$c1871fdf674a03c4 = (firstPartyResponse)=>{
    const match = firstPartyResponse.resources[0]?.id.match($4d92eafc5833ccdb$var$EXTRACT_CLOUD_ID);
    const extractedCloudId = match ? match[1] : '';
    return extractedCloudId;
};
module.exports["getFirstCloudId"] = $4d92eafc5833ccdb$export$c1871fdf674a03c4;

});

parcelRegister("aoy1P", function(module, exports) {

var $3L2aM = parcelRequire("3L2aM");

const $b2c70616c23e337b$export$e88fb694deeca21a = 'smartlinks-connector';
const $b2c70616c23e337b$export$83921c8e433ffcd9 = 'lite-connector-';
const $b2c70616c23e337b$export$7ad7a95070d8bb93 = (0, $3L2aM.ConnectorSources).Federated;
const $b2c70616c23e337b$export$e3a0662f044cd99b = (0, $3L2aM.ConnectorSources).Lite;
const $b2c70616c23e337b$export$c14e5e3fa6d8b46 = (0, $3L2aM.ConnectorSources).Smartlinks;
const $b2c70616c23e337b$export$aa06c0b5cc41ad9a = (0, $3L2aM.ConnectorSources).Full;
const $b2c70616c23e337b$export$37e0ed5b7fa94503 = (0, $3L2aM.ConnectorSources).Backfill;
const $b2c70616c23e337b$export$af092ad5a950adea = (value)=>{
    return Object.values((0, $3L2aM.ConnectorSources)).includes(value);
};
const $b2c70616c23e337b$export$9a0cf6dd1d986cc2 = 'forge-connector-';
const $b2c70616c23e337b$export$e5725489d3388d22 = (type)=>{
    return type.startsWith($b2c70616c23e337b$export$9a0cf6dd1d986cc2);
};
/**
 * Runtime registry for Forge connector icons.
 * Similar to ThirdPartyConfigs, but populated dynamically from API responses.
 */ const $b2c70616c23e337b$var$forgeConnectorIconsRegistry = new Map();
const $b2c70616c23e337b$export$4e96e986802512bd = (productKey, icon)=>{
    $b2c70616c23e337b$var$forgeConnectorIconsRegistry.set(productKey, icon);
};
const $b2c70616c23e337b$export$2f2bd8960b497856 = (productKey)=>{
    return $b2c70616c23e337b$var$forgeConnectorIconsRegistry.get(productKey);
};
const $b2c70616c23e337b$export$2768da79a2599ca3 = ()=>{
    $b2c70616c23e337b$var$forgeConnectorIconsRegistry.clear();
};
module.exports["FEDERATED_CONNECTOR_SOURCE"] = $b2c70616c23e337b$export$7ad7a95070d8bb93;
module.exports["LITE_CONNECTOR_SOURCE"] = $b2c70616c23e337b$export$e3a0662f044cd99b;
module.exports["SMARTLINKS_CONNECTOR_SOURCE"] = $b2c70616c23e337b$export$c14e5e3fa6d8b46;
module.exports["FULL_CONNECTOR_SOURCE"] = $b2c70616c23e337b$export$aa06c0b5cc41ad9a;
module.exports["isForgeConnectorProductKey"] = $b2c70616c23e337b$export$e5725489d3388d22;
module.exports["registerForgeConnectorIcon"] = $b2c70616c23e337b$export$4e96e986802512bd;

});

parcelRegister("3L2aM", function(module, exports) {
const $c439ce144d84d7bc$export$499e9a6668a55181 = {
    Federated: 'federated',
    Smartlinks: 'smartlinks',
    Lite: 'lite-connector',
    Full: 'full-connector',
    Backfill: 'backfill'
};
module.exports["ConnectorSources"] = $c439ce144d84d7bc$export$499e9a6668a55181;

});

parcelRegister("fR63l", function(module, exports) {
/**
 * Product keys for third-party connectors.
 * Each key maps to a unique identifier used throughout the search system.
 */ const $dce31c4071a2ecfb$export$93aa518ca2694c2d = {
    AtlassianWebCrawler: 'atlassian-web-crawler',
    Figma: 'figma',
    Github: 'github',
    GoogleDrive: 'drive',
    Loom: 'loom',
    OneDrive: 'onedrive',
    Dropbox: 'dropbox',
    Slack: 'slack',
    Sharepoint: 'sharepoint',
    Teams: 'teams',
    GoogleCalendar: 'google-calendar',
    OutlookCalendar: 'outlook-calendar',
    OutlookMail: 'outlook-mail',
    Gmail: 'gmail',
    AdobeSign: 'adobe-sign',
    Asana: 'asana',
    Zendesk: 'zendesk',
    Airtable: 'airtable',
    Smartsheet: 'smartsheet',
    Notion: 'notion',
    Miro: 'miro',
    Docusign: 'docusign',
    Lucid: 'lucid',
    Monday: 'monday',
    AzureDevops: 'azure-devops',
    Gitlab: 'gitlab',
    ConfluenceDC: 'confluence-dc',
    Canva: 'canva',
    Box: 'box',
    Zeplin: 'zeplin',
    ServiceNow: 'servicenow',
    Freshservice: 'freshservice',
    PowerBI: 'power-bi',
    ClickUp: 'clickup',
    Amplitude: 'amplitude',
    Stripe: 'stripe',
    AdobeXD: 'adobexd',
    Aha: 'aha',
    Mural: 'mural',
    Webex: 'webex',
    Todoist: 'todoist',
    PagerDuty: 'pagerduty',
    Pipedrive: 'pipedrive',
    Hubspot: 'hubspot',
    Dovetail: 'dovetail',
    LaunchDarkly: 'launchdarkly',
    Salesforce: 'salesforce',
    Sentry: 'sentry',
    JiraDC: 'jira-dc',
    Gitbook: 'gitbook',
    AWSS3: 'aws-s3',
    Databricks: 'databricks',
    JsmDC: 'jsm-dc',
    ForgeAdamVitareqDev: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
    ForgeAdamVitareqProd: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
    ForgeK15tScrollSitesDev: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
    ForgeK15tScrollSitesProd: 'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector',
    ForgePioAwsDev: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector',
    ForgePioAwsProd: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector',
    ForgePioClickupDev: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
    ForgePioClickupProd: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
    ForgePioGitbookDev: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
    ForgePioGitbookProd: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
    ForgePioGithubDev: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector',
    ForgePioGithubProd: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
    ForgePioGitlabDev: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector',
    ForgePioGitlabProd: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector',
    ForgePioGoogleDriveDev: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
    ForgePioGoogleDriveProd: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
    ForgePioGuruDev: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
    ForgePioGuruProd: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
    ForgePioHelpjuiceDev: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
    ForgePioHelpjuiceProd: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
    ForgePioHubspotDev: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
    ForgePioHubspotProd: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
    ForgePioSalesforceDev: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
    ForgePioSalesforceProd: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
    ForgePioSharepointDev: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
    ForgePioSharepointProd: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
    ForgePioStackOverflowDev: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
    ForgePioStackOverflowProd: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
    ForgeUtoolityGitbookDev: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
    ForgeUtoolityGitbookProd: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
    ForgeGdriveEugeneTestDev: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive',
    ForgeGdriveEugeneTestProd: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive',
    ForgeUnitoSalesforceDev: 'forge-connector-h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV-salesforce',
    ForgeUnitoSalesforceProd: 'forge-connector-qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8-salesforce',
    ForgeUnitoServicenowDev: 'forge-connector-52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q-servicenow',
    ForgeUnitoServicenowProd: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow',
    ForgeUnitoWrikeDev: 'forge-connector-gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO-wrike',
    ForgeUnitoWrikeProd: 'forge-connector-390XhSnH4YgwqVgmyqYOujxVoL3IOUcM-wrike',
    ForgeUnitoAsanaDev: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana',
    ForgeUnitoAsanaProd: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana',
    ForgeUnitoBasecampDev: 'forge-connector-nImlCTNLZUCtQzFsthpnlYJL0B981lMH-basecamp',
    ForgeUnitoBasecampProd: 'forge-connector-TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z-basecamp',
    Zoom: 'zoom'
};
const $dce31c4071a2ecfb$export$5378b945bea99ba3 = {
    AtlassianWebCrawler: 'webcrawler-connector',
    Figma: 'figma-connector',
    Github: 'github-connector',
    GoogleDrive: 'google-drive-connector',
    OneDrive: 'onedrive-connector',
    Dropbox: 'dropbox-connector',
    Slack: 'slack-connector',
    Sharepoint: 'sharepoint-connector',
    Teams: 'microsoft-teams-connector',
    GoogleCalendar: 'google-calendar-connector',
    OutlookCalendar: 'outlook-calendar-connector',
    OutlookMail: 'outlook-mail-connector',
    Gmail: 'gmail-connector',
    AdobeSign: 'adobe-sign-connector',
    Asana: 'asana-connector',
    Zendesk: 'zendesk-connector',
    Airtable: 'airtable-connector',
    Smartsheet: 'smartsheet-connector',
    Notion: 'notion-connector',
    Miro: 'miro-connector',
    Docusign: 'docusign-connector',
    Lucid: 'lucid-connector',
    Monday: 'monday-connector',
    AzureDevops: 'azure-devops-connector',
    Gitlab: 'gitlab-connector',
    ConfluenceDC: 'confluence-dc-connector',
    JiraDC: 'jira-dc-connector',
    JsmDC: 'jsm-dc-connector',
    Canva: 'canva-connector',
    Box: 'box-connector',
    Zeplin: 'smartlinks-connector-zeplin',
    ServiceNow: 'servicenow-connector',
    Freshservice: 'freshservice-connector',
    PowerBI: 'smartlinks-connector-power-bi',
    ClickUp: 'smartlinks-connector-clickup',
    Amplitude: 'smartlinks-connector-amplitude',
    Stripe: 'smartlinks-connector-stripe',
    AdobeXD: 'smartlinks-connector-adobexd',
    Aha: 'aha-connector',
    Mural: 'smartlinks-connector-mural',
    Webex: 'smartlinks-connector-webex',
    Todoist: 'smartlinks-connector-todoist',
    PagerDuty: 'smartlinks-connector-pagerduty',
    Pipedrive: 'smartlinks-connector-pipedrive',
    Hubspot: 'hubspot-connector',
    Dovetail: 'smartlinks-connector-dovetail',
    LaunchDarkly: 'smartlinks-connector-launchdarkly',
    Salesforce: 'salesforce-connector',
    Sentry: 'smartlinks-connector-sentry',
    Gitbook: 'gitbook-connector',
    AWSS3: 'aws-s3-connector',
    Databricks: 'databricks-connector',
    ForgeAdamVitareqDev: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
    ForgeAdamVitareqProd: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
    ForgeK15tScrollSitesDev: 'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
    ForgeK15tScrollSitesProd: 'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector',
    ForgePioAwsDev: 'forge-connector-HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL-s3-connector',
    ForgePioAwsProd: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector',
    ForgePioClickupDev: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
    ForgePioClickupProd: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
    ForgePioGitbookDev: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
    ForgePioGitbookProd: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
    ForgePioGithubDev: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector',
    ForgePioGithubProd: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
    ForgePioGitlabDev: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector',
    ForgePioGitlabProd: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector',
    ForgePioGoogleDriveDev: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
    ForgePioGoogleDriveProd: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
    ForgePioGuruDev: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
    ForgePioGuruProd: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
    ForgePioHelpjuiceDev: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
    ForgePioHelpjuiceProd: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
    ForgePioHubspotDev: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
    ForgePioHubspotProd: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
    ForgePioSalesforceDev: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
    ForgePioSalesforceProd: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
    ForgePioSharepointDev: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
    ForgePioSharepointProd: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
    ForgePioStackOverflowDev: 'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
    ForgePioStackOverflowProd: 'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
    ForgeUtoolityGitbookDev: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
    ForgeUtoolityGitbookProd: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
    ForgeGdriveEugeneTestDev: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive',
    ForgeGdriveEugeneTestProd: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive',
    ForgeUnitoSalesforceDev: 'forge-connector-h8rZu86YJHRfyVlmVeUR464Kuhz9OZvV-salesforce',
    ForgeUnitoSalesforceProd: 'forge-connector-qjk3Z8Kt2DWx29hdZHQapEYXAGCPIyd8-salesforce',
    ForgeUnitoServicenowDev: 'forge-connector-52qcnF9TIgxkDKY4OL7xNxAzcM0amb7q-servicenow',
    ForgeUnitoServicenowProd: 'forge-connector-RzFogW4EQLcXYmYpKkItRUhLAn3jETMq-servicenow',
    ForgeUnitoWrikeDev: 'forge-connector-gw0rFhQkj7PuTllmYdHbMaPw6jC18YvO-wrike',
    ForgeUnitoWrikeProd: 'forge-connector-390XhSnH4YgwqVgmyqYOujxVoL3IOUcM-wrike',
    ForgeUnitoAsanaDev: 'forge-connector-6wHDDwNbam77WvGwMKYMGDiTWP8pza54-asana',
    ForgeUnitoAsanaProd: 'forge-connector-sFXfxz3XEDS1wAWWCe345UVrSbUm9zyb-asana',
    ForgeUnitoBasecampDev: 'forge-connector-nImlCTNLZUCtQzFsthpnlYJL0B981lMH-basecamp',
    ForgeUnitoBasecampProd: 'forge-connector-TZqLHQtzvKxRikkh1KQlp4acwCzS5W1Z-basecamp',
    Zoom: 'zoom-connector'
};
module.exports["ProductKeys3P"] = $dce31c4071a2ecfb$export$93aa518ca2694c2d;
module.exports["ProductResourceTypes3P"] = $dce31c4071a2ecfb$export$5378b945bea99ba3;

});

parcelRegister("dAuCI", function(module, exports) {

var $fR63l = parcelRequire("fR63l");


class $a264614d865c7774$export$50e7f6c2eabc665 {
    /**
   * Returns the number of registered configs.
   */ get size() {
        return this.factories.size;
    }
    /**
   * Checks whether a config is registered for the given key.
   */ has(key) {
        return this.factories.has(key);
    }
    /**
   * Returns all registered product keys synchronously.
   */ keys() {
        return Array.from(this.factories.keys());
    }
    /**
   * Asynchronously retrieves a single config by key.
   * The config module is loaded on first access and cached thereafter.
   */ async get(key) {
        if (this.cache.has(key)) return this.cache.get(key);
        const factory = this.factories.get(key);
        if (!factory) return undefined;
        const config = await factory();
        this.cache.set(key, config);
        return config;
    }
    /**
   * Asynchronously iterates over all entries, invoking the callback for each.
   * Each config is lazily loaded as the iteration reaches it.
   */ async forEach(callbackfn) {
        for (const key of this.factories.keys()){
            const config = await this.get(key);
            if (config) await callbackfn(config, key);
        }
    }
    /**
   * Async generator that yields [key, config] entries lazily.
   */ async *entries() {
        for (const key of this.factories.keys()){
            const config = await this.get(key);
            if (config) yield [
                key,
                config
            ];
        }
    }
    /**
   * Async generator that yields config values lazily.
   */ async *values() {
        for (const key of this.factories.keys()){
            const config = await this.get(key);
            if (config) yield config;
        }
    }
    /**
   * Resolves all configs and returns them as a standard Map.
   * Useful when all configs are needed at once.
   */ async getAll() {
        const result = new Map();
        for (const key of this.factories.keys()){
            const config = await this.get(key);
            if (config) result.set(key, config);
        }
        return result;
    }
    constructor(entries){
        this.factories = void 0;
        this.cache = new Map();
        this.factories = new Map(entries);
    }
}
































































































































































































const $a264614d865c7774$export$f7937c5f282f2571 = new $a264614d865c7774$export$50e7f6c2eabc665([
    [
        (0, $fR63l.ProductKeys3P).AtlassianWebCrawler,
        ()=>(parcelRequire("iBxe8")).then((m)=>m.atlassianWebCrawlerConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Figma,
        ()=>(parcelRequire("gT6ig")).then((m)=>m.figmaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Github,
        ()=>(parcelRequire("ctb8J")).then((m)=>m.githubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).GoogleDrive,
        ()=>(parcelRequire("aBc9a")).then((m)=>m.googleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Sharepoint,
        ()=>(parcelRequire("gPij5")).then((m)=>m.sharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Loom,
        ()=>(parcelRequire("lEkZd")).then((m)=>m.loomConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OneDrive,
        ()=>(parcelRequire("6GYA1")).then((m)=>m.oneDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Dropbox,
        ()=>(parcelRequire("62RGF")).then((m)=>m.dropboxConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Slack,
        ()=>(parcelRequire("df2sa")).then((m)=>m.slackConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Teams,
        ()=>(parcelRequire("TPBVI")).then((m)=>m.teamsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).GoogleCalendar,
        ()=>(parcelRequire("1EmMA")).then((m)=>m.googleCalendarConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gmail,
        ()=>(parcelRequire("gsNVH")).then((m)=>m.gmailConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OutlookCalendar,
        ()=>(parcelRequire("lr0CG")).then((m)=>m.outlookCalendarConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OutlookMail,
        ()=>(parcelRequire("83jvW")).then((m)=>m.outlookMail)
    ],
    [
        (0, $fR63l.ProductKeys3P).Asana,
        ()=>(parcelRequire("aMNB6")).then((m)=>m.asanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zendesk,
        ()=>(parcelRequire("74xIl")).then((m)=>m.zendeskConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Airtable,
        ()=>(parcelRequire("8Vszy")).then((m)=>m.airtableConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Smartsheet,
        ()=>(parcelRequire("b22hO")).then((m)=>m.smartsheetConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Notion,
        ()=>(parcelRequire("cEdIY")).then((m)=>m.notionConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Miro,
        ()=>(parcelRequire("31RHj")).then((m)=>m.miroConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Docusign,
        ()=>(parcelRequire("02Ynr")).then((m)=>m.docusignConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Lucid,
        ()=>(parcelRequire("fwd4N")).then((m)=>m.lucidConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Monday,
        ()=>(parcelRequire("2RnL3")).then((m)=>m.mondayConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AzureDevops,
        ()=>(parcelRequire("58OWX")).then((m)=>m.azureDevopsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gitlab,
        ()=>(parcelRequire("kL104")).then((m)=>m.gitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ConfluenceDC,
        ()=>(parcelRequire("5Bro5")).then((m)=>m.confluenceDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).JiraDC,
        ()=>(parcelRequire("3Qz1U")).then((m)=>m.jiraDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).JsmDC,
        ()=>(parcelRequire("eC2Yf")).then((m)=>m.jsmDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Canva,
        ()=>(parcelRequire("3QlPK")).then((m)=>m.canvaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Box,
        ()=>(parcelRequire("hElI5")).then((m)=>m.boxConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zoom,
        ()=>(parcelRequire("a5g8K")).then((m)=>m.zoomConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zeplin,
        ()=>(parcelRequire("bgwDS")).then((m)=>m.zeplinConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ServiceNow,
        ()=>(parcelRequire("lAH85")).then((m)=>m.serviceNowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Freshservice,
        ()=>(parcelRequire("iKBOF")).then((m)=>m.freshserviceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).PowerBI,
        ()=>(parcelRequire("5pBM8")).then((m)=>m.powerBIConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ClickUp,
        ()=>(parcelRequire("92ME9")).then((m)=>m.clickUpConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Amplitude,
        ()=>(parcelRequire("6Jh1p")).then((m)=>m.amplitudeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Stripe,
        ()=>(parcelRequire("jzPn4")).then((m)=>m.stripeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AdobeXD,
        ()=>(parcelRequire("kZqu6")).then((m)=>m.adobeXDConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Aha,
        ()=>(parcelRequire("ajtDF")).then((m)=>m.ahaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AdobeSign,
        ()=>(parcelRequire("fKfb7")).then((m)=>m.adobeSignConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Mural,
        ()=>(parcelRequire("hXJgg")).then((m)=>m.muralConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Webex,
        ()=>(parcelRequire("hhNgf")).then((m)=>m.webexConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Todoist,
        ()=>(parcelRequire("crz44")).then((m)=>m.todoistConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).PagerDuty,
        ()=>(parcelRequire("3Igok")).then((m)=>m.pagerDutyConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Pipedrive,
        ()=>(parcelRequire("cz85h")).then((m)=>m.pipedriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Hubspot,
        ()=>(parcelRequire("dvJin")).then((m)=>m.hubSpotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Dovetail,
        ()=>(parcelRequire("7Mz2I")).then((m)=>m.dovetailConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).LaunchDarkly,
        ()=>(parcelRequire("aiSZX")).then((m)=>m.launchDarklyConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Salesforce,
        ()=>(parcelRequire("9EADZ")).then((m)=>m.salesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Sentry,
        ()=>(parcelRequire("8PK6n")).then((m)=>m.sentryConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gitbook,
        ()=>(parcelRequire("jctME")).then((m)=>m.gitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AWSS3,
        ()=>(parcelRequire("bR0Iu")).then((m)=>m.awss3Config)
    ],
    [
        (0, $fR63l.ProductKeys3P).Databricks,
        ()=>(parcelRequire("3jXBQ")).then((m)=>m.databricksConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqDev,
        ()=>(parcelRequire("bAiH4")).then((m)=>m.forgeAdamVitareqConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqProd,
        ()=>(parcelRequire("1xgz2")).then((m)=>m.forgeAdamVitareqConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesDev,
        ()=>(parcelRequire("4RPDt")).then((m)=>m.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesProd,
        ()=>(parcelRequire("fsXZE")).then((m)=>m.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioAwsDev,
        ()=>(parcelRequire("9aDYK")).then((m)=>m.forgePioAwsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioAwsProd,
        ()=>(parcelRequire("6JW0P")).then((m)=>m.forgePioAwsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioClickupDev,
        ()=>(parcelRequire("Uh4Xn")).then((m)=>m.forgePioClickupConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioClickupProd,
        ()=>(parcelRequire("jirMU")).then((m)=>m.forgePioClickupConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitbookDev,
        ()=>(parcelRequire("lemnx")).then((m)=>m.forgePioGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitbookProd,
        ()=>(parcelRequire("dzON5")).then((m)=>m.forgePioGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGithubDev,
        ()=>(parcelRequire("bhHm2")).then((m)=>m.forgePioGithubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGithubProd,
        ()=>(parcelRequire("cpHnm")).then((m)=>m.forgePioGithubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitlabDev,
        ()=>(parcelRequire("kdTUL")).then((m)=>m.forgePioGitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitlabProd,
        ()=>(parcelRequire("2ixRt")).then((m)=>m.forgePioGitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveDev,
        ()=>(parcelRequire("41BIu")).then((m)=>m.forgePioGoogleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveProd,
        ()=>(parcelRequire("6s4rU")).then((m)=>m.forgePioGoogleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGuruDev,
        ()=>(parcelRequire("6KzzT")).then((m)=>m.forgePioGuruConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGuruProd,
        ()=>(parcelRequire("9DwSf")).then((m)=>m.forgePioGuruConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceDev,
        ()=>(parcelRequire("gxp6w")).then((m)=>m.forgePioHelpjuiceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceProd,
        ()=>(parcelRequire("aYbsr")).then((m)=>m.forgePioHelpjuiceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHubspotDev,
        ()=>(parcelRequire("acx6k")).then((m)=>m.forgePioHubspotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHubspotProd,
        ()=>(parcelRequire("iWCTF")).then((m)=>m.forgePioHubspotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceDev,
        ()=>(parcelRequire("2tWj9")).then((m)=>m.forgePioSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceProd,
        ()=>(parcelRequire("arh0c")).then((m)=>m.forgePioSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSharepointDev,
        ()=>(parcelRequire("fb826")).then((m)=>m.forgePioSharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSharepointProd,
        ()=>(parcelRequire("iO6my")).then((m)=>m.forgePioSharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowDev,
        ()=>(parcelRequire("cXcSd")).then((m)=>m.forgePioStackOverflowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowProd,
        ()=>(parcelRequire("bIQJz")).then((m)=>m.forgePioStackOverflowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookDev,
        ()=>(parcelRequire("8ILPc")).then((m)=>m.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookProd,
        ()=>(parcelRequire("hUid6")).then((m)=>m.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestDev,
        ()=>(parcelRequire("4ZlVU")).then((m)=>m.forgeGdriveEugeneTestDevConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestProd,
        ()=>(parcelRequire("ft0CM")).then((m)=>m.forgeGdriveEugeneTestProdConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceDev,
        ()=>(parcelRequire("4EGFU")).then((m)=>m.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceProd,
        ()=>(parcelRequire("hJUgO")).then((m)=>m.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowDev,
        ()=>(parcelRequire("26Y6c")).then((m)=>m.forgeUnitoServicenowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowProd,
        ()=>(parcelRequire("k2jJ5")).then((m)=>m.forgeUnitoServicenowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeDev,
        ()=>(parcelRequire("8t1lq")).then((m)=>m.forgeUnitoWrikeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeProd,
        ()=>(parcelRequire("9uiEL")).then((m)=>m.forgeUnitoWrikeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaDev,
        ()=>(parcelRequire("lghtg")).then((m)=>m.forgeUnitoAsanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaProd,
        ()=>(parcelRequire("3qEIn")).then((m)=>m.forgeUnitoAsanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampDev,
        ()=>(parcelRequire("fbkFk")).then((m)=>m.forgeUnitoBasecampConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampProd,
        ()=>(parcelRequire("lcUNq")).then((m)=>m.forgeUnitoBasecampConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AtlassianWebCrawler,
        ()=>(parcelRequire("iBxe8")).then((m)=>m.atlassianWebCrawlerConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Figma,
        ()=>(parcelRequire("gT6ig")).then((m)=>m.figmaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Github,
        ()=>(parcelRequire("ctb8J")).then((m)=>m.githubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).GoogleDrive,
        ()=>(parcelRequire("aBc9a")).then((m)=>m.googleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Sharepoint,
        ()=>(parcelRequire("gPij5")).then((m)=>m.sharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Loom,
        ()=>(parcelRequire("lEkZd")).then((m)=>m.loomConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OneDrive,
        ()=>(parcelRequire("6GYA1")).then((m)=>m.oneDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Dropbox,
        ()=>(parcelRequire("62RGF")).then((m)=>m.dropboxConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Slack,
        ()=>(parcelRequire("df2sa")).then((m)=>m.slackConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Teams,
        ()=>(parcelRequire("TPBVI")).then((m)=>m.teamsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).GoogleCalendar,
        ()=>(parcelRequire("1EmMA")).then((m)=>m.googleCalendarConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gmail,
        ()=>(parcelRequire("gsNVH")).then((m)=>m.gmailConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OutlookCalendar,
        ()=>(parcelRequire("lr0CG")).then((m)=>m.outlookCalendarConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).OutlookMail,
        ()=>(parcelRequire("83jvW")).then((m)=>m.outlookMail)
    ],
    [
        (0, $fR63l.ProductKeys3P).Asana,
        ()=>(parcelRequire("aMNB6")).then((m)=>m.asanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zendesk,
        ()=>(parcelRequire("74xIl")).then((m)=>m.zendeskConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Airtable,
        ()=>(parcelRequire("8Vszy")).then((m)=>m.airtableConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Smartsheet,
        ()=>(parcelRequire("b22hO")).then((m)=>m.smartsheetConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Notion,
        ()=>(parcelRequire("cEdIY")).then((m)=>m.notionConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Miro,
        ()=>(parcelRequire("31RHj")).then((m)=>m.miroConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Docusign,
        ()=>(parcelRequire("02Ynr")).then((m)=>m.docusignConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Lucid,
        ()=>(parcelRequire("fwd4N")).then((m)=>m.lucidConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Monday,
        ()=>(parcelRequire("2RnL3")).then((m)=>m.mondayConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AzureDevops,
        ()=>(parcelRequire("58OWX")).then((m)=>m.azureDevopsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gitlab,
        ()=>(parcelRequire("kL104")).then((m)=>m.gitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ConfluenceDC,
        ()=>(parcelRequire("5Bro5")).then((m)=>m.confluenceDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).JiraDC,
        ()=>(parcelRequire("3Qz1U")).then((m)=>m.jiraDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).JsmDC,
        ()=>(parcelRequire("eC2Yf")).then((m)=>m.jsmDCConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Canva,
        ()=>(parcelRequire("3QlPK")).then((m)=>m.canvaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Box,
        ()=>(parcelRequire("hElI5")).then((m)=>m.boxConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zoom,
        ()=>(parcelRequire("a5g8K")).then((m)=>m.zoomConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Zeplin,
        ()=>(parcelRequire("bgwDS")).then((m)=>m.zeplinConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ServiceNow,
        ()=>(parcelRequire("lAH85")).then((m)=>m.serviceNowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Freshservice,
        ()=>(parcelRequire("iKBOF")).then((m)=>m.freshserviceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).PowerBI,
        ()=>(parcelRequire("5pBM8")).then((m)=>m.powerBIConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ClickUp,
        ()=>(parcelRequire("92ME9")).then((m)=>m.clickUpConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Amplitude,
        ()=>(parcelRequire("6Jh1p")).then((m)=>m.amplitudeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Stripe,
        ()=>(parcelRequire("jzPn4")).then((m)=>m.stripeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AdobeXD,
        ()=>(parcelRequire("kZqu6")).then((m)=>m.adobeXDConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Aha,
        ()=>(parcelRequire("ajtDF")).then((m)=>m.ahaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AdobeSign,
        ()=>(parcelRequire("fKfb7")).then((m)=>m.adobeSignConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Mural,
        ()=>(parcelRequire("hXJgg")).then((m)=>m.muralConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Webex,
        ()=>(parcelRequire("hhNgf")).then((m)=>m.webexConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Todoist,
        ()=>(parcelRequire("crz44")).then((m)=>m.todoistConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).PagerDuty,
        ()=>(parcelRequire("3Igok")).then((m)=>m.pagerDutyConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Pipedrive,
        ()=>(parcelRequire("cz85h")).then((m)=>m.pipedriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Hubspot,
        ()=>(parcelRequire("dvJin")).then((m)=>m.hubSpotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Dovetail,
        ()=>(parcelRequire("7Mz2I")).then((m)=>m.dovetailConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).LaunchDarkly,
        ()=>(parcelRequire("aiSZX")).then((m)=>m.launchDarklyConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Salesforce,
        ()=>(parcelRequire("9EADZ")).then((m)=>m.salesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Sentry,
        ()=>(parcelRequire("8PK6n")).then((m)=>m.sentryConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).Gitbook,
        ()=>(parcelRequire("jctME")).then((m)=>m.gitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).AWSS3,
        ()=>(parcelRequire("bR0Iu")).then((m)=>m.awss3Config)
    ],
    [
        (0, $fR63l.ProductKeys3P).Databricks,
        ()=>(parcelRequire("3jXBQ")).then((m)=>m.databricksConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqDev,
        ()=>(parcelRequire("bAiH4")).then((m)=>m.forgeAdamVitareqConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeAdamVitareqProd,
        ()=>(parcelRequire("1xgz2")).then((m)=>m.forgeAdamVitareqConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesDev,
        ()=>(parcelRequire("4RPDt")).then((m)=>m.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeK15tScrollSitesProd,
        ()=>(parcelRequire("fsXZE")).then((m)=>m.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioAwsDev,
        ()=>(parcelRequire("9aDYK")).then((m)=>m.forgePioAwsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioAwsProd,
        ()=>(parcelRequire("6JW0P")).then((m)=>m.forgePioAwsConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioClickupDev,
        ()=>(parcelRequire("Uh4Xn")).then((m)=>m.forgePioClickupConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioClickupProd,
        ()=>(parcelRequire("jirMU")).then((m)=>m.forgePioClickupConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitbookDev,
        ()=>(parcelRequire("lemnx")).then((m)=>m.forgePioGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitbookProd,
        ()=>(parcelRequire("dzON5")).then((m)=>m.forgePioGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGithubDev,
        ()=>(parcelRequire("bhHm2")).then((m)=>m.forgePioGithubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGithubProd,
        ()=>(parcelRequire("cpHnm")).then((m)=>m.forgePioGithubConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitlabDev,
        ()=>(parcelRequire("kdTUL")).then((m)=>m.forgePioGitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGitlabProd,
        ()=>(parcelRequire("2ixRt")).then((m)=>m.forgePioGitlabConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveDev,
        ()=>(parcelRequire("41BIu")).then((m)=>m.forgePioGoogleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGoogleDriveProd,
        ()=>(parcelRequire("6s4rU")).then((m)=>m.forgePioGoogleDriveConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGuruDev,
        ()=>(parcelRequire("6KzzT")).then((m)=>m.forgePioGuruConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioGuruProd,
        ()=>(parcelRequire("9DwSf")).then((m)=>m.forgePioGuruConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceDev,
        ()=>(parcelRequire("gxp6w")).then((m)=>m.forgePioHelpjuiceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHelpjuiceProd,
        ()=>(parcelRequire("aYbsr")).then((m)=>m.forgePioHelpjuiceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHubspotDev,
        ()=>(parcelRequire("acx6k")).then((m)=>m.forgePioHubspotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioHubspotProd,
        ()=>(parcelRequire("iWCTF")).then((m)=>m.forgePioHubspotConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceDev,
        ()=>(parcelRequire("2tWj9")).then((m)=>m.forgePioSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSalesforceProd,
        ()=>(parcelRequire("arh0c")).then((m)=>m.forgePioSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSharepointDev,
        ()=>(parcelRequire("fb826")).then((m)=>m.forgePioSharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioSharepointProd,
        ()=>(parcelRequire("iO6my")).then((m)=>m.forgePioSharepointConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowDev,
        ()=>(parcelRequire("cXcSd")).then((m)=>m.forgePioStackOverflowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgePioStackOverflowProd,
        ()=>(parcelRequire("bIQJz")).then((m)=>m.forgePioStackOverflowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookDev,
        ()=>(parcelRequire("8ILPc")).then((m)=>m.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUtoolityGitbookProd,
        ()=>(parcelRequire("hUid6")).then((m)=>m.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestDev,
        ()=>(parcelRequire("4ZlVU")).then((m)=>m.forgeGdriveEugeneTestDevConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeGdriveEugeneTestProd,
        ()=>(parcelRequire("ft0CM")).then((m)=>m.forgeGdriveEugeneTestProdConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceDev,
        ()=>(parcelRequire("4EGFU")).then((m)=>m.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoSalesforceProd,
        ()=>(parcelRequire("hJUgO")).then((m)=>m.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowDev,
        ()=>(parcelRequire("26Y6c")).then((m)=>m.forgeUnitoServicenowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoServicenowProd,
        ()=>(parcelRequire("k2jJ5")).then((m)=>m.forgeUnitoServicenowConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeDev,
        ()=>(parcelRequire("8t1lq")).then((m)=>m.forgeUnitoWrikeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoWrikeProd,
        ()=>(parcelRequire("9uiEL")).then((m)=>m.forgeUnitoWrikeConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaDev,
        ()=>(parcelRequire("lghtg")).then((m)=>m.forgeUnitoAsanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoAsanaProd,
        ()=>(parcelRequire("3qEIn")).then((m)=>m.forgeUnitoAsanaConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampDev,
        ()=>(parcelRequire("fbkFk")).then((m)=>m.forgeUnitoBasecampConfig)
    ],
    [
        (0, $fR63l.ProductKeys3P).ForgeUnitoBasecampProd,
        ()=>(parcelRequire("lcUNq")).then((m)=>m.forgeUnitoBasecampConfig)
    ]
]);
const $a264614d865c7774$var$productKeys3PValues = new Set(Object.values((0, $fR63l.ProductKeys3P)));
const $a264614d865c7774$export$985cb3900add20c8 = (value)=>$a264614d865c7774$var$productKeys3PValues.has(value);
module.exports["ThirdPartyConfigs"] = $a264614d865c7774$export$f7937c5f282f2571;

});

parcelRegister("iBxe8", function(module, exports) {

let $d8b574e2a5cc37c1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d8b574e2a5cc37c1$var$load("6wr18"),
    $d8b574e2a5cc37c1$var$load("ffEVr"),
    $d8b574e2a5cc37c1$var$load("bRtkB")
]).then(()=>parcelRequire('jAKKt'));

});

parcelRegister("gT6ig", function(module, exports) {

let $c4b6aa311ef513a4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c4b6aa311ef513a4$var$load("aF2C4").then(()=>parcelRequire('7dzhu'));

});

parcelRegister("ctb8J", function(module, exports) {

let $9140d59f8ad886b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9140d59f8ad886b7$var$load("3eAWG").then(()=>parcelRequire('aZX0c'));

});

parcelRegister("aBc9a", function(module, exports) {

let $7b76c832d4976913$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7b76c832d4976913$var$load("1HPRy").then(()=>parcelRequire('kFYBW'));

});

parcelRegister("gPij5", function(module, exports) {

let $c3ff9c1894b5ec04$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c3ff9c1894b5ec04$var$load("7zQG2").then(()=>parcelRequire('gOrBS'));

});

parcelRegister("lEkZd", function(module, exports) {

let $fc2d9cd8ca48ee61$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fc2d9cd8ca48ee61$var$load("jZMUd"),
    $fc2d9cd8ca48ee61$var$load("fdFOR")
]).then(()=>parcelRequire('lSeWC'));

});

parcelRegister("6GYA1", function(module, exports) {

let $4df5a84501aea93d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4df5a84501aea93d$var$load("hUZCM").then(()=>parcelRequire('4TRyZ'));

});

parcelRegister("62RGF", function(module, exports) {

let $466c932715083697$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $466c932715083697$var$load("2zKe1").then(()=>parcelRequire('2qza4'));

});

parcelRegister("df2sa", function(module, exports) {

let $9a3e943c15d3b5a9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9a3e943c15d3b5a9$var$load("dgWVQ").then(()=>parcelRequire('kDG5l'));

});

parcelRegister("TPBVI", function(module, exports) {

let $0a7d2bfe5b7d495f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0a7d2bfe5b7d495f$var$load("3cJjP").then(()=>parcelRequire('6sCQO'));

});

parcelRegister("1EmMA", function(module, exports) {

let $133b3308a7233083$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $133b3308a7233083$var$load("RMzu0").then(()=>parcelRequire('6eg6r'));

});

parcelRegister("gsNVH", function(module, exports) {

let $bfc5fdd4fc7f4d22$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bfc5fdd4fc7f4d22$var$load("4ZzjZ").then(()=>parcelRequire('52jas'));

});

parcelRegister("lr0CG", function(module, exports) {

let $f9ac9a496374d705$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f9ac9a496374d705$var$load("k90dx").then(()=>parcelRequire('ijAga'));

});

parcelRegister("83jvW", function(module, exports) {

let $5dcdbda30e12c09c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5dcdbda30e12c09c$var$load("amIJr").then(()=>parcelRequire('dPp45'));

});

parcelRegister("aMNB6", function(module, exports) {

let $7da4dc18e877575a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7da4dc18e877575a$var$load("gguK2").then(()=>parcelRequire('4Be7r'));

});

parcelRegister("74xIl", function(module, exports) {

let $52630f17b0854dee$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $52630f17b0854dee$var$load("hZzel").then(()=>parcelRequire('kmEEk'));

});

parcelRegister("8Vszy", function(module, exports) {

let $67f9cf78855bdd75$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $67f9cf78855bdd75$var$load("jTrn5").then(()=>parcelRequire('52Drw'));

});

parcelRegister("b22hO", function(module, exports) {

let $8081a799b789106b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8081a799b789106b$var$load("eOlJP").then(()=>parcelRequire('aaz0Y'));

});

parcelRegister("cEdIY", function(module, exports) {

let $9353ddd09a324ff5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9353ddd09a324ff5$var$load("3BeCY").then(()=>parcelRequire('kcCFv'));

});

parcelRegister("31RHj", function(module, exports) {

let $234b1e534467b651$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $234b1e534467b651$var$load("6b6gt").then(()=>parcelRequire('6lsSn'));

});

parcelRegister("02Ynr", function(module, exports) {

let $008f05a6f17f22ea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $008f05a6f17f22ea$var$load("407Jg").then(()=>parcelRequire('k521G'));

});

parcelRegister("fwd4N", function(module, exports) {

let $b4c3fcde50fe0553$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b4c3fcde50fe0553$var$load("63b2S").then(()=>parcelRequire('43W2t'));

});

parcelRegister("2RnL3", function(module, exports) {

let $2152f5d98da817b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2152f5d98da817b1$var$load("fJLp0").then(()=>parcelRequire('6ThsT'));

});

parcelRegister("58OWX", function(module, exports) {

let $3be538af45050ae5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3be538af45050ae5$var$load("bzCMM").then(()=>parcelRequire('4x6XK'));

});

parcelRegister("kL104", function(module, exports) {

let $f1c8f9056a588ec3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f1c8f9056a588ec3$var$load("alsd0").then(()=>parcelRequire('382mb'));

});

parcelRegister("5Bro5", function(module, exports) {

let $4145a70f960577ef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4145a70f960577ef$var$load("jZMUd"),
    $4145a70f960577ef$var$load("jZNbu")
]).then(()=>parcelRequire('8oQ7k'));

});

parcelRegister("3Qz1U", function(module, exports) {

let $2cd166a3a0327d1b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2cd166a3a0327d1b$var$load("jZMUd"),
    $2cd166a3a0327d1b$var$load("cYv6T")
]).then(()=>parcelRequire('79ijY'));

});

parcelRegister("eC2Yf", function(module, exports) {

let $aa36eb3d8ecf1009$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $aa36eb3d8ecf1009$var$load("jZMUd"),
    $aa36eb3d8ecf1009$var$load("9BBvG")
]).then(()=>parcelRequire('e7BOf'));

});

parcelRegister("3QlPK", function(module, exports) {

let $2cc72a2827e9e607$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2cc72a2827e9e607$var$load("jRzSB").then(()=>parcelRequire('fg2gb'));

});

parcelRegister("hElI5", function(module, exports) {

let $cd9703462afb8136$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cd9703462afb8136$var$load("2MOvO").then(()=>parcelRequire('fauGM'));

});

parcelRegister("a5g8K", function(module, exports) {

let $7576e419eec1cb14$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7576e419eec1cb14$var$load("1Sqxt").then(()=>parcelRequire('bj13p'));

});

parcelRegister("bgwDS", function(module, exports) {

let $833a8266b04eb5a8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $833a8266b04eb5a8$var$load("11sVB").then(()=>parcelRequire('3VdqU'));

});

parcelRegister("lAH85", function(module, exports) {

let $fb7e6a65b66ccf78$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fb7e6a65b66ccf78$var$load("frCen").then(()=>parcelRequire('iN1Vs'));

});

parcelRegister("iKBOF", function(module, exports) {

let $da69db677e750701$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $da69db677e750701$var$load("22bew").then(()=>parcelRequire('fA9zj'));

});

parcelRegister("5pBM8", function(module, exports) {

let $3f0c96f8bef833fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3f0c96f8bef833fc$var$load("4NtL2").then(()=>parcelRequire('iTxTm'));

});

parcelRegister("92ME9", function(module, exports) {

let $695a0929d74d2f0e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $695a0929d74d2f0e$var$load("3peYA").then(()=>parcelRequire('5pWqV'));

});

parcelRegister("6Jh1p", function(module, exports) {

let $4e642630456ad387$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4e642630456ad387$var$load("DPLw5").then(()=>parcelRequire('juuLe'));

});

parcelRegister("jzPn4", function(module, exports) {

let $e409226bb43ffbc8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e409226bb43ffbc8$var$load("emPuN").then(()=>parcelRequire('3juV6'));

});

parcelRegister("kZqu6", function(module, exports) {

let $f47e0c6fe7314294$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f47e0c6fe7314294$var$load("a8X2u").then(()=>parcelRequire('hIDj1'));

});

parcelRegister("ajtDF", function(module, exports) {

let $7822ab60aaa856ca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7822ab60aaa856ca$var$load("39rcm").then(()=>parcelRequire('7WW80'));

});

parcelRegister("fKfb7", function(module, exports) {

let $b766ecf99dcb12e7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b766ecf99dcb12e7$var$load("6xDnX").then(()=>parcelRequire('au9jr'));

});

parcelRegister("hXJgg", function(module, exports) {

let $d13b0e50e5899a08$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d13b0e50e5899a08$var$load("bWrbO").then(()=>parcelRequire('diJOH'));

});

parcelRegister("hhNgf", function(module, exports) {

let $c95a3c704c7acf2e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c95a3c704c7acf2e$var$load("e2pEU").then(()=>parcelRequire('5bQLl'));

});

parcelRegister("crz44", function(module, exports) {

let $90f334c6140cf4a0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $90f334c6140cf4a0$var$load("4s14m").then(()=>parcelRequire('dVIA3'));

});

parcelRegister("3Igok", function(module, exports) {

let $2b42321f56861e0b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2b42321f56861e0b$var$load("ake72").then(()=>parcelRequire('emznk'));

});

parcelRegister("cz85h", function(module, exports) {

let $925f063e9e60a948$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $925f063e9e60a948$var$load("icZ4h").then(()=>parcelRequire('fMCQp'));

});

parcelRegister("dvJin", function(module, exports) {

let $9d614e56edab5644$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9d614e56edab5644$var$load("ceQaW").then(()=>parcelRequire('cdiu6'));

});

parcelRegister("7Mz2I", function(module, exports) {

let $5aa832e47052f086$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5aa832e47052f086$var$load("lKvqu").then(()=>parcelRequire('8djpu'));

});

parcelRegister("aiSZX", function(module, exports) {

let $78063f56f0861dfa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $78063f56f0861dfa$var$load("6nEcR").then(()=>parcelRequire('3P9fk'));

});

parcelRegister("9EADZ", function(module, exports) {

let $707446315559077a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $707446315559077a$var$load("5d2zd").then(()=>parcelRequire('lPRuX'));

});

parcelRegister("8PK6n", function(module, exports) {

let $66e6d904c8677960$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $66e6d904c8677960$var$load("lmH6s").then(()=>parcelRequire('2zNcl'));

});

parcelRegister("jctME", function(module, exports) {

let $dfa63db87e8bb2b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dfa63db87e8bb2b1$var$load("h7ufj").then(()=>parcelRequire('h8Js2'));

});

parcelRegister("bR0Iu", function(module, exports) {

let $8a153339a5d5476b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8a153339a5d5476b$var$load("7ravW").then(()=>parcelRequire('9Om9G'));

});

parcelRegister("3jXBQ", function(module, exports) {

let $26b1629b18db5440$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $26b1629b18db5440$var$load("aZ5Xl").then(()=>parcelRequire('kiNtZ'));

});

parcelRegister("bAiH4", function(module, exports) {

let $86f18eac9cf3c96e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $86f18eac9cf3c96e$var$load("cTH3r").then(()=>parcelRequire('1RpaO'));

});

parcelRegister("1xgz2", function(module, exports) {

let $11e5b8d1886eee68$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $11e5b8d1886eee68$var$load("dne17").then(()=>parcelRequire('jENKA'));

});

parcelRegister("4RPDt", function(module, exports) {

let $38b42a6c124bdd71$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $38b42a6c124bdd71$var$load("cHAvQ").then(()=>parcelRequire('j34lg'));

});

parcelRegister("fsXZE", function(module, exports) {

let $b42801fc65ba38db$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b42801fc65ba38db$var$load("gpIIT").then(()=>parcelRequire('in2Pi'));

});

parcelRegister("9aDYK", function(module, exports) {

let $6ad40f2a8491628c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6ad40f2a8491628c$var$load("8qNIV").then(()=>parcelRequire('7vbr8'));

});

parcelRegister("6JW0P", function(module, exports) {

let $4e83f21bd16f4d79$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4e83f21bd16f4d79$var$load("701fE").then(()=>parcelRequire('k6vRK'));

});

parcelRegister("Uh4Xn", function(module, exports) {

let $0a927a99cc57cc79$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0a927a99cc57cc79$var$load("05bRk").then(()=>parcelRequire('aiL8h'));

});

parcelRegister("jirMU", function(module, exports) {

let $e0c540e00d23fa0c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e0c540e00d23fa0c$var$load("lnWlT").then(()=>parcelRequire('cY0ZT'));

});

parcelRegister("lemnx", function(module, exports) {

let $03fd19ddc4d2f4f5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $03fd19ddc4d2f4f5$var$load("jQK5h").then(()=>parcelRequire('9SYma'));

});

parcelRegister("dzON5", function(module, exports) {

let $9e25f13380966ec6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9e25f13380966ec6$var$load("kg1Ok").then(()=>parcelRequire('ie06K'));

});

parcelRegister("bhHm2", function(module, exports) {

let $8372e98813ff3fca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8372e98813ff3fca$var$load("kobFT").then(()=>parcelRequire('h5NUz'));

});

parcelRegister("cpHnm", function(module, exports) {

let $90997763425d308b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $90997763425d308b$var$load("bLIUJ").then(()=>parcelRequire('9Y160'));

});

parcelRegister("kdTUL", function(module, exports) {

let $eb906502f834c30e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eb906502f834c30e$var$load("cklhl").then(()=>parcelRequire('hdy05'));

});

parcelRegister("2ixRt", function(module, exports) {

let $1ac7876a9dbc87f3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1ac7876a9dbc87f3$var$load("2GC7K").then(()=>parcelRequire('djF8v'));

});

parcelRegister("41BIu", function(module, exports) {

let $2ee483264ab9d610$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2ee483264ab9d610$var$load("bD8in").then(()=>parcelRequire('dChew'));

});

parcelRegister("6s4rU", function(module, exports) {

let $4b28cf1866257ad5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4b28cf1866257ad5$var$load("gdVxH").then(()=>parcelRequire('TCovD'));

});

parcelRegister("6KzzT", function(module, exports) {

let $4ea2a2f6c2fe6e5a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ea2a2f6c2fe6e5a$var$load("7xK5Z").then(()=>parcelRequire('feDPe'));

});

parcelRegister("9DwSf", function(module, exports) {

let $704141aa2412a02b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $704141aa2412a02b$var$load("b4BtI").then(()=>parcelRequire('klS4t'));

});

parcelRegister("gxp6w", function(module, exports) {

let $c0a333981d8cd2fb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c0a333981d8cd2fb$var$load("iljFU").then(()=>parcelRequire('hFdyH'));

});

parcelRegister("aYbsr", function(module, exports) {

let $7fc865388b2cddea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7fc865388b2cddea$var$load("bXUvd").then(()=>parcelRequire('e6TPF'));

});

parcelRegister("acx6k", function(module, exports) {

let $76d4b38e8201bd79$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $76d4b38e8201bd79$var$load("26c2h").then(()=>parcelRequire('7piBv'));

});

parcelRegister("iWCTF", function(module, exports) {

let $dcabd0daf6868c6b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dcabd0daf6868c6b$var$load("3lk6X").then(()=>parcelRequire('3yXQ1'));

});

parcelRegister("2tWj9", function(module, exports) {

let $1ceb84f13c590a70$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1ceb84f13c590a70$var$load("huBNP").then(()=>parcelRequire('cmwLF'));

});

parcelRegister("arh0c", function(module, exports) {

let $79999d4c2faee95d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $79999d4c2faee95d$var$load("5tJYH").then(()=>parcelRequire('brRUk'));

});

parcelRegister("fb826", function(module, exports) {

let $b0ce1d3dbf7b805f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b0ce1d3dbf7b805f$var$load("ewhxr").then(()=>parcelRequire('dwyZc'));

});

parcelRegister("iO6my", function(module, exports) {

let $db11d5024549f94a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $db11d5024549f94a$var$load("boWJM").then(()=>parcelRequire('9sIt4'));

});

parcelRegister("cXcSd", function(module, exports) {

let $96e4fb255f7ce319$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $96e4fb255f7ce319$var$load("eNHPW").then(()=>parcelRequire('7UyZr'));

});

parcelRegister("bIQJz", function(module, exports) {

let $888cb5a34d15a279$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $888cb5a34d15a279$var$load("kUBpV").then(()=>parcelRequire('2KPYZ'));

});

parcelRegister("8ILPc", function(module, exports) {

let $659787c6ebdd7679$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $659787c6ebdd7679$var$load("baUsS").then(()=>parcelRequire('9lVxQ'));

});

parcelRegister("hUid6", function(module, exports) {

let $d095cad68f060ea0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d095cad68f060ea0$var$load("d0r9z").then(()=>parcelRequire('1HfnT'));

});

parcelRegister("4ZlVU", function(module, exports) {

let $3a1ddf5858170b02$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3a1ddf5858170b02$var$load("hG1ar").then(()=>parcelRequire('9JBuG'));

});

parcelRegister("ft0CM", function(module, exports) {

let $b42a0c6fad21d679$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b42a0c6fad21d679$var$load("kMyku").then(()=>parcelRequire('aHqTQ'));

});

parcelRegister("4EGFU", function(module, exports) {

let $363c002ee4aa7beb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $363c002ee4aa7beb$var$load("3xL2F").then(()=>parcelRequire('34wuK'));

});

parcelRegister("hJUgO", function(module, exports) {

let $cea249b3255b390d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cea249b3255b390d$var$load("7Ysw6").then(()=>parcelRequire('g36Mb'));

});

parcelRegister("26Y6c", function(module, exports) {

let $189ac2b9db3551f0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $189ac2b9db3551f0$var$load("7sOKp").then(()=>parcelRequire('eODbN'));

});

parcelRegister("k2jJ5", function(module, exports) {

let $e9634bc35b15b21e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e9634bc35b15b21e$var$load("jvUhP").then(()=>parcelRequire('2k3z5'));

});

parcelRegister("8t1lq", function(module, exports) {

let $62a2133071fe9094$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $62a2133071fe9094$var$load("fhT77").then(()=>parcelRequire('lHAGV'));

});

parcelRegister("9uiEL", function(module, exports) {

let $6e85632d71c22264$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6e85632d71c22264$var$load("cpTbC").then(()=>parcelRequire('iPw5B'));

});

parcelRegister("lghtg", function(module, exports) {

let $f7a8a4f4e0eff5ee$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f7a8a4f4e0eff5ee$var$load("2iL13").then(()=>parcelRequire('3LgSg'));

});

parcelRegister("3qEIn", function(module, exports) {

let $27f361e80ece6b26$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $27f361e80ece6b26$var$load("9RGBF").then(()=>parcelRequire('bRkOn'));

});

parcelRegister("fbkFk", function(module, exports) {

let $b0d7e9d4cfa90463$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b0d7e9d4cfa90463$var$load("gQYVn").then(()=>parcelRequire('eoGOF'));

});

parcelRegister("lcUNq", function(module, exports) {

let $f706c67fd5e57d65$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f706c67fd5e57d65$var$load("11yNG").then(()=>parcelRequire('jWqmd'));

});

parcelRegister("3eS8z", function(module, exports) {
const $355516be41f684c4$export$e98932ab9e22c265 = ({ dependency: dependency, searchSessionId: searchSessionId, reason: reason, source: source, actionSubject: actionSubject })=>{
    return {
        source: source,
        action: 'degradedDependency',
        actionSubject: actionSubject,
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                degradedDependency: dependency,
                reason: reason,
                searchSessionId: searchSessionId
            }
        }
    };
};
const $355516be41f684c4$export$7199f2d13e6ae9f7 = ({ dependency: dependency, searchSessionId: searchSessionId, source: source, actionSubject: actionSubject })=>{
    return {
        source: source,
        action: 'failedDependency',
        actionSubject: actionSubject,
        eventType: 'operational',
        attributes: {
            additionalAttributes: {
                failedDependency: dependency,
                searchSessionId: searchSessionId
            }
        }
    };
};
const $355516be41f684c4$export$786813d6840571a0 = ({ requestName: requestName, searchSessionId: searchSessionId, cacheHit: cacheHit, refreshTriggered: refreshTriggered, source: source, actionSubject: actionSubject })=>{
    return {
        source: source,
        action: 'requestCacheAccess',
        actionSubject: actionSubject,
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                requestName: requestName,
                cacheHit: cacheHit,
                refreshTriggered: refreshTriggered,
                searchSessionId: searchSessionId
            }
        }
    };
};
const $355516be41f684c4$var$baseVitalStatsEvent = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, action: action, moreContext: moreContext })=>{
    return {
        action: action,
        actionSubject: 'ui',
        eventType: 'operational',
        attributes: {
            additionalAttributes: {
                task: task,
                taskId: taskId,
                hostname: typeof window !== 'undefined' ? window.location.hostname : '',
                searchSessionId: searchSessionId,
                ...moreContext
            }
        }
    };
};
const $355516be41f684c4$export$656fa717a09eb821 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $355516be41f684c4$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskStart',
        moreContext: moreContext
    });
};
const $355516be41f684c4$export$3e9761d670712e50 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $355516be41f684c4$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskSuccess',
        moreContext: moreContext
    });
};
const $355516be41f684c4$export$2e311f5a2c70a936 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $355516be41f684c4$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskFail',
        moreContext: moreContext
    });
};
const $355516be41f684c4$export$807d68038784dd59 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $355516be41f684c4$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskAbort',
        moreContext: moreContext
    });
};
module.exports["onDegradedDependency"] = $355516be41f684c4$export$e98932ab9e22c265;
module.exports["onFailedDependency"] = $355516be41f684c4$export$7199f2d13e6ae9f7;
module.exports["onRequestCacheAccess"] = $355516be41f684c4$export$786813d6840571a0;
module.exports["onTaskStart"] = $355516be41f684c4$export$656fa717a09eb821;
module.exports["onTaskSuccess"] = $355516be41f684c4$export$3e9761d670712e50;
module.exports["onTaskFail"] = $355516be41f684c4$export$2e311f5a2c70a936;

});

parcelRegister("92KTD", function(module, exports) {
/**
 * Task name suffixes for vital stats tracking.
 * The full task name is: `${surfacePrefix}/${TASK_SUFFIX}`
 * e.g., 'search-page/first-party-config-ux' or 'quick-find/first-party-config-ux'
 */ const $80e9eb5613483f46$export$5f386c08e1416f1e = {
    FIRST_PARTY_CONFIG_UX: 'first-party-config-ux',
    FIRST_PARTY_CONFIG_NETWORK: 'first-party-config-network',
    THIRD_PARTY_CONFIG_UX: 'third-party-config-ux',
    THIRD_PARTY_CONFIG_NETWORK: 'third-party-config-network',
    COMBINED_CONFIG_UX: 'combined-config-ux',
    COMBINED_CONFIG_NETWORK: 'combined-config-network'
};
module.exports["CONFIG_TASK_SUFFIXES"] = $80e9eb5613483f46$export$5f386c08e1416f1e;

});

parcelRegister("7fkiQ", function(module, exports) {

const $58b4d704abb45fc1$export$577bc64d11eec8be = (surfacePrefix, suffix)=>`${surfacePrefix}/${suffix}`;
module.exports["buildTaskName"] = $58b4d704abb45fc1$export$577bc64d11eec8be;

});

parcelRegister("eSwze", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $aoy1P = parcelRequire("aoy1P");


var $i52Hf = parcelRequire("i52Hf");


var $5PPrc = parcelRequire("5PPrc");

const $2c98e8bd8cbf6213$export$70bfed163de04616 = (forgeConnector, onForgeConnectorTypeMapping)=>{
    if (!forgeConnector.lightIcon || !forgeConnector.workspaceName) return undefined;
    const icon = (0, $i52Hf.get3PLogoFromURL)(forgeConnector.lightIcon, forgeConnector.workspaceName, 'medium');
    const searchResultIcon = (0, $i52Hf.get3PLogoFromURL)(forgeConnector.lightIcon, forgeConnector.providerId, 'large');
    const productKey = forgeConnector.type;
    (0, $aoy1P.registerForgeConnectorIcon)(productKey, icon);
    const typeFilterConfig = forgeConnector.entityTypes ? (0, $5PPrc.mapAtisToTypeFilterConfig)(forgeConnector.entityTypes) : new Map();
    if (onForgeConnectorTypeMapping && (0, $ixfCV.fg)('rovo-search-dynamic-forge-config')) onForgeConnectorTypeMapping(productKey, typeFilterConfig);
    const config = {
        id: forgeConnector.type,
        displayName: forgeConnector.environmentType ? `${forgeConnector.workspaceName} (${forgeConnector.environmentType})` : forgeConnector.workspaceName,
        resourceType: forgeConnector.type,
        datasourceId: forgeConnector.datasourceId,
        connectionId: forgeConnector.connectionId,
        providerId: forgeConnector.providerId,
        outboundAuthUrl: forgeConnector.outboundAuthUrl,
        // `forgeConnector.integrationId` is a `string` (the wire shape).
        // `PlatformIntegrationAri` is a branded nominal type. The value at
        // this site is already an integration ARI (built server-side by the
        // platform integration registry), so the cast is structurally safe;
        // the `unknown` hop exists only because TS rejects direct
        // `string`-to-branded assignment. Same pattern is used in
        // `adapter.ts`. RAOC-22 follow-up: tighten in search-client by
        // exposing a constructor for branded ARIs.
        integrationAri: forgeConnector.integrationId ? forgeConnector.integrationId : `ari:cloud:platform::integration/${forgeConnector.providerId}`,
        filters: [
            'lastUpdated',
            'universalTypeFilter'
        ],
        displayWorkspaceNameAsProductName: true,
        isEnabled: ()=>true,
        userNeedsOAuth: !forgeConnector.isUserOAuthed,
        requiresOauth: !forgeConnector.isUserOAuthed && !forgeConnector.outboundAuthUrl ? false : true,
        icon: icon,
        searchResultIcon: searchResultIcon,
        typeFilterConfig: typeFilterConfig,
        workspaceName: forgeConnector.workspaceName,
        connectorSources: [
            (0, $aoy1P.FULL_CONNECTOR_SOURCE)
        ]
    };
    return config;
};
module.exports["mapForgeConnectorToThirdPartyConfig"] = $2c98e8bd8cbf6213$export$70bfed163de04616;

});

parcelRegister("i52Hf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");




var $6suVE = parcelRequire("6suVE");


var $ehKBQ = parcelRequire("ehKBQ");


var $iS3Tu = parcelRequire("iS3Tu");


var $dULnI = parcelRequire("dULnI");




var $9Jc29 = parcelRequire("9Jc29");






var $iPmoS = parcelRequire("iPmoS");

const $8a7a1ec4b7d3b7f4$var$svgIconContainerStyles = {
    small: "_1bsb7vkz _4t3i7vkz _1e0c1txw _4cvr1h6o _1bah1h6o",
    medium: "_1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o",
    large: "_1bsbzwfg _4t3izwfg _1e0c1txw _4cvr1h6o _1bah1h6o",
    xlarge: "_1bsbzwfg _4t3izwfg _1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $8a7a1ec4b7d3b7f4$var$SVGIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { glyph: SVG, label: label, size: size } = t0;
    const t1 = $8a7a1ec4b7d3b7f4$var$svgIconContainerStyles[size];
    const t2 = label || undefined;
    const t3 = label ? "img" : "presentation";
    let t4;
    if ($[0] !== SVG) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, null);
        $[0] = SVG;
        $[1] = t4;
    } else t4 = $[1];
    let t5;
    if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3 || $[5] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: t1,
            "aria-label": t2,
            role: t3
        }, t4);
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    return t5;
} : ({ glyph: SVG, label: label, size: size })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $8a7a1ec4b7d3b7f4$var$svgIconContainerStyles[size],
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, null));
};
const $8a7a1ec4b7d3b7f4$var$isCorrectableRovoSize = (size)=>{
    return [
        'xxsmall',
        'xsmall',
        'small',
        'medium',
        'large'
    ].includes(size);
};
const $8a7a1ec4b7d3b7f4$var$correctedSize = {
    xxsmall: 'small',
    xsmall: 'small',
    small: 'medium',
    medium: 'large',
    large: 'xlarge'
};
const $8a7a1ec4b7d3b7f4$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
}; /**
    * A wrapper for providing an internal \@atlaskit/icon - alike experience for working with custom Rovo Icons
    *
    * Internally uses <Icon glyph={glyph} ... />
    *
    * @param {} glyph function returning an SVG as JSX
    * @param defaultLabel an accessible label for the logo
    */ 
const $8a7a1ec4b7d3b7f4$export$7b66a86355afbb91 = (Glyph, defaultLabel = '', defaultSize = 'medium')=>{
    return ({ size: size = defaultSize, label: label = defaultLabel, testId: testId })=>{
        const mappedSize = size && $8a7a1ec4b7d3b7f4$var$isCorrectableRovoSize(size) ? $8a7a1ec4b7d3b7f4$var$correctedSize[size] : defaultSize;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-label": label || undefined,
            "data-testid": testId,
            role: label ? 'img' : 'presentation',
            className: (0, $hekY6.default)([
                $8a7a1ec4b7d3b7f4$var$sizeStyles[mappedSize]
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Glyph, null));
    };
}; /**
    * A wrapper for rendering 3P svg illustrations in a similar way for atlaskit icon components
    *
    * @param {} glyph function returning an SVG as JSX
    * @param defaultLabel an accessible label for the logo
    */ 
const $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d = (glyph, defaultLabel = '', defaultSize)=>{
    return ({ label: label = defaultLabel, size: size = defaultSize })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8a7a1ec4b7d3b7f4$var$SVGIcon, {
            label: label,
            glyph: glyph,
            size: size && $8a7a1ec4b7d3b7f4$var$isCorrectableRovoSize(size) ? $8a7a1ec4b7d3b7f4$var$correctedSize[size] : 'medium'
        });
}; /**
    * A wrapper for providing an internal \@atlaskit/icon - alike experience for working with \@atlaskit/logo
    *
    * Internally uses <LogoComponent ... />
    *
    * @param {} LogoComponent an import from \@atlaskit/logo
    * @param defaultLabel an accessible label for the logo
    */ 
const $8a7a1ec4b7d3b7f4$export$32db889b380fa03c = (LogoComponent, defaultLabel = '')=>{
    return ({ size: size, label: label, testId: testId })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LogoComponent, {
            label: label || defaultLabel,
            testId: testId,
            size: size || 'medium',
            appearance: "brand",
            shouldUseNewLogoDesign: true
        });
    };
}; /**
    * Takes a logo component and returns a new logo component that uses the new logo design.
    */ 
function $8a7a1ec4b7d3b7f4$export$a34cd1871c6541c9(Icon) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            ...props,
            shouldUseNewLogoDesign: true
        });
}
function $8a7a1ec4b7d3b7f4$export$fab9faef3411dc6c(iconGlyph, iconLabel, size) {
    return $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d(iconGlyph, iconLabel, size);
}
const $8a7a1ec4b7d3b7f4$var$imageStyles = null; /**
                           * Helper function to convert an image URL into a glyph function
                           *
                           * @param imageUrl URL string pointing to the image
                           * @returns A glyph function that returns an img element
                           */ 
const $8a7a1ec4b7d3b7f4$export$f9f7178f66750cba = (imageUrl)=>{
    return ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            src: imageUrl,
            alt: "",
            className: (0, $hekY6.default)([
                "_1bsb1osq _4t3i1osq _5ral1f51"
            ])
        });
    };
}; /**
    * Creates a RovoLogo from a URL. Useful for Forge connectors that provide icon URLs.
    * Uses the existing RovoLogoFromSVG infrastructure for consistent handling.
    */ 
function $8a7a1ec4b7d3b7f4$export$97ac28be52c9e29f(iconUrl, iconLabel, size) {
    return $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d($8a7a1ec4b7d3b7f4$export$f9f7178f66750cba(iconUrl), iconLabel, size);
} // Jira-specific icons
module.exports["RovoLogoFromGlyph"] = $8a7a1ec4b7d3b7f4$export$7b66a86355afbb91;
module.exports["RovoLogoFromSVG"] = $8a7a1ec4b7d3b7f4$export$dae027fade2c6d1d;
module.exports["RovoLogoFromLogo"] = $8a7a1ec4b7d3b7f4$export$32db889b380fa03c;
module.exports["get3PLogo"] = $8a7a1ec4b7d3b7f4$export$fab9faef3411dc6c;
module.exports["get3PLogoFromURL"] = $8a7a1ec4b7d3b7f4$export$97ac28be52c9e29f;

});

parcelRegister("6suVE", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $db93e344a28daeff$var$LazyGithubIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("3w7xz")).then((m)=>m.GithubIcon), {
    moduleId: '@atlassian/rovo-connectors-config/github/icon'
});

const $db93e344a28daeff$var$LazyGithubSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("3w7xz")).then((m)=>m.GithubSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/github/search-result-icon'
});
const $db93e344a28daeff$export$e8e65f186ccd8749 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($db93e344a28daeff$var$LazyGithubIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($db93e344a28daeff$var$LazyGithubIconComponent, null));
const $db93e344a28daeff$export$fa0f141eb732d2d7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($db93e344a28daeff$var$LazyGithubSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($db93e344a28daeff$var$LazyGithubSearchResultIconComponent, null));
module.exports["GithubIcon"] = $db93e344a28daeff$export$e8e65f186ccd8749;
module.exports["GithubSearchResultIcon"] = $db93e344a28daeff$export$fa0f141eb732d2d7;

});

parcelRegister("5mh7K", function(module, exports) {

var $3zIme = parcelRequire("3zIme");


var $6zMm4 = parcelRequire("6zMm4");


var $jrpaf = parcelRequire("jrpaf");


var $iqYgx = parcelRequire("iqYgx");


var $3Zhtx = parcelRequire("3Zhtx");

var $dZb8A = parcelRequire("dZb8A");


var $9W961 = parcelRequire("9W961");


var $f1SiZ = parcelRequire("f1SiZ");


var $6DjRB = parcelRequire("6DjRB");


var $ah4XH = parcelRequire("ah4XH");


var $cU4Ow = parcelRequire("cU4Ow");


var $31PDK = parcelRequire("31PDK");


function $bfc96ad9243c26fc$var$noop() {}
function $bfc96ad9243c26fc$var$deferToPhase(phase) {
    switch(phase){
        case (0, $iqYgx.PHASE).PAINT:
            return (0, $6zMm4.postTask)($bfc96ad9243c26fc$var$noop, {
                priority: 'user-blocking'
            });
        case (0, $iqYgx.PHASE).AFTER_PAINT:
            return (0, $6zMm4.postTask)($bfc96ad9243c26fc$var$noop, {
                priority: 'user-visible'
            });
        case (0, $iqYgx.PHASE).LAZY:
            return (0, $6zMm4.postTask)($bfc96ad9243c26fc$var$noop, {
                priority: 'background'
            });
        default:
            return Promise.resolve();
    }
}
function $bfc96ad9243c26fc$var$lazyProxy(loader, { defer: defer = (0, $iqYgx.PHASE).PAINT, moduleId: moduleId = '', ssr: ssr = true } = {}) {
    const isServer = (0, $3Zhtx.isNodeEnvironment)();
    const dataLazyId = (0, $dZb8A.default)(moduleId);
    // eslint-disable-next-line @typescript-eslint/ban-types
    const LazyInternal = isServer ? (0, $f1SiZ.createComponentServer)({
        dataLazyId: dataLazyId,
        defer: defer,
        loader: loader,
        moduleId: moduleId,
        ssr: ssr
    }) : (0, $9W961.createComponentClient)({
        dataLazyId: dataLazyId,
        defer: defer,
        // We separate the preload from the retryable request, as we do not want the preload to contribute to retry
        // attempts, when the the loader fallback is used
        deferred: (0, $ah4XH.createDeferred)(dataLazyId, {
            loader: ()=>{
                const { retry: maxAttempts, usePostTaskPhases: usePostTaskPhases } = (0, $jrpaf.getConfig)();
                const deferredLoader = usePostTaskPhases ? ()=>$bfc96ad9243c26fc$var$deferToPhase(defer).then(()=>loader()) : loader;
                return (0, $31PDK.retry)(deferredLoader, {
                    delay: (0, $6DjRB.RETRY_DELAY),
                    factor: (0, $6DjRB.RETRY_FACTOR),
                    maxAttempts: maxAttempts
                });
            },
            preload: loader
        }),
        moduleId: moduleId
    });
    LazyInternal.displayName = `Lazy(${(0, $3Zhtx.displayNameFromId)(moduleId)})`;
    /**
   * Allows getting module chunks urls
   */ const getAssetUrls = ()=>{
        const { manifest: manifest } = (0, $jrpaf.getConfig)();
        return (0, $3zIme.getAssetUrlsFromId)(manifest, moduleId);
    };
    /**
   * Allows imperatively preload/ prefetch the module chunk asset
   */ const preload = (priority)=>{
        const p = priority ?? (defer === (0, $iqYgx.PHASE).PAINT ? (0, $6DjRB.PRIORITY).HIGH : (0, $6DjRB.PRIORITY).LOW);
        return (0, $cU4Ow.preloadAsset)({
            loader: loader,
            moduleId: moduleId,
            priority: p
        });
    };
    return Object.assign(LazyInternal, {
        getAssetUrls: getAssetUrls,
        moduleId: moduleId,
        preload: preload
    });
}
const $bfc96ad9243c26fc$export$93ca5d3f8675ae4c = {
    lazyForPaint: {
        ssr: true,
        defer: (0, $iqYgx.PHASE).PAINT
    },
    lazyAfterPaint: {
        ssr: true,
        defer: (0, $iqYgx.PHASE).AFTER_PAINT
    },
    lazy: {
        ssr: false,
        defer: (0, $iqYgx.PHASE).LAZY
    }
};
function $bfc96ad9243c26fc$export$c952e5f94576010e(loader, opts) {
    return $bfc96ad9243c26fc$var$lazyProxy(loader, {
        ...$bfc96ad9243c26fc$export$93ca5d3f8675ae4c.lazyForPaint,
        ...opts || {}
    });
}
function $bfc96ad9243c26fc$export$291dd592399bdafa(loader, opts) {
    return $bfc96ad9243c26fc$var$lazyProxy(loader, {
        ...$bfc96ad9243c26fc$export$93ca5d3f8675ae4c.lazyAfterPaint,
        ...opts || {}
    });
}
function $bfc96ad9243c26fc$export$488013bae63b21da(loader, opts) {
    return $bfc96ad9243c26fc$var$lazyProxy(loader, {
        ...$bfc96ad9243c26fc$export$93ca5d3f8675ae4c.lazy,
        ...opts || {}
    });
}
module.exports["lazyForPaint"] = $bfc96ad9243c26fc$export$c952e5f94576010e;
module.exports["lazy"] = $bfc96ad9243c26fc$export$488013bae63b21da;

});

parcelRegister("3zIme", function(module, exports) {
const $26c544e248d4f3ef$export$303f43e55cf1ef2f = (manifest, id)=>{
    if (!manifest.assets || !manifest.assets[id]) return;
    return manifest.assets[id].map((asset)=>`${manifest.publicPath}${asset}`);
};
module.exports["getAssetUrlsFromId"] = $26c544e248d4f3ef$export$303f43e55cf1ef2f;

});

parcelRegister("jrpaf", function(module, exports) {
$parcel$export(module.exports, "MODE", () => (parcelRequire("hwBK6")).MODE);

var $hwBK6 = parcelRequire("hwBK6");

const $8f2b5a3b1d08430b$var$DEFAULT_CROSS_ORIGIN = undefined;
const $8f2b5a3b1d08430b$var$DEFAULT_MANIFEST = {
    publicPath: '/',
    assets: {}
};
const $8f2b5a3b1d08430b$var$DEFAULT_MODE = (0, $hwBK6.MODE).HYDRATE;
const $8f2b5a3b1d08430b$var$DEFAULT_RETRY = 2;
const $8f2b5a3b1d08430b$var$nullFunction = ()=>{};
const $8f2b5a3b1d08430b$var$config = {
    crossOrigin: $8f2b5a3b1d08430b$var$DEFAULT_CROSS_ORIGIN,
    manifest: $8f2b5a3b1d08430b$var$DEFAULT_MANIFEST,
    mode: $8f2b5a3b1d08430b$var$DEFAULT_MODE,
    retry: $8f2b5a3b1d08430b$var$DEFAULT_RETRY,
    react18: false,
    onChunkRender: $8f2b5a3b1d08430b$var$nullFunction,
    usePostTaskPhases: false,
    modernErrorFallback: false,
    markedForPreload: [],
    environment: undefined
};
const $8f2b5a3b1d08430b$export$44487a86467333c3 = ()=>$8f2b5a3b1d08430b$var$config;
const $8f2b5a3b1d08430b$export$940a7873bb071df8 = (nextConfig)=>{
    $8f2b5a3b1d08430b$var$config.crossOrigin = nextConfig.crossOrigin ?? $8f2b5a3b1d08430b$var$DEFAULT_CROSS_ORIGIN;
    $8f2b5a3b1d08430b$var$config.manifest = nextConfig.manifest ?? $8f2b5a3b1d08430b$var$DEFAULT_MANIFEST;
    $8f2b5a3b1d08430b$var$config.mode = nextConfig.mode ?? $8f2b5a3b1d08430b$var$DEFAULT_MODE;
    $8f2b5a3b1d08430b$var$config.retry = nextConfig.retry ?? $8f2b5a3b1d08430b$var$DEFAULT_RETRY;
    $8f2b5a3b1d08430b$var$config.react18 = nextConfig.react18 ?? false;
    $8f2b5a3b1d08430b$var$config.onChunkRender = nextConfig.onChunkRender ?? $8f2b5a3b1d08430b$var$nullFunction;
    $8f2b5a3b1d08430b$var$config.usePostTaskPhases = nextConfig.usePostTaskPhases ?? false;
    $8f2b5a3b1d08430b$var$config.modernErrorFallback = nextConfig.modernErrorFallback ?? false;
    $8f2b5a3b1d08430b$var$config.markedForPreload = nextConfig.markedForPreload ?? undefined;
    $8f2b5a3b1d08430b$var$config.environment = nextConfig.environment ?? undefined;
};
module.exports["getConfig"] = $8f2b5a3b1d08430b$export$44487a86467333c3;

});

parcelRegister("hwBK6", function(module, exports) {
const $b5e78af7707a7c4f$export$e48589d9e4824227 = {
    RENDER: 'RENDER',
    HYDRATE: 'HYDRATE'
};
module.exports["MODE"] = $b5e78af7707a7c4f$export$e48589d9e4824227;

});

parcelRegister("iqYgx", function(module, exports) {
const $affaceaac00ccc54$export$2cc7a2eaaea7809f = {
    PAINT: 0,
    AFTER_PAINT: 1,
    LAZY: 2
};
const $affaceaac00ccc54$export$4831ef3968ea94ef = new Map();
module.exports["PHASE"] = $affaceaac00ccc54$export$2cc7a2eaaea7809f;
module.exports["COLLECTED"] = $affaceaac00ccc54$export$4831ef3968ea94ef;

});

parcelRegister("3Zhtx", function(module, exports) {

var $dZb8A = parcelRequire("dZb8A");

const $a3803c67f4544810$export$d4c07b1daf44a7f = (m)=>'default' in m ? m.default : m;
const $a3803c67f4544810$export$4429f98ef60d2d87 = (id)=>{
    const fName = id.split('/').slice(-3).join('/');
    return fName || 'Component';
};
const $a3803c67f4544810$export$283635c04a02cc36 = ()=>{
    if (typeof window === 'undefined') return true;
    if (window.name === 'nodejs') return true;
    return false;
};
function $a3803c67f4544810$export$62bf630d0de3d781(props, attr) {
    switch(attr.name){
        case 'style':
            break;
        case 'class':
            props.className = attr.value;
            break;
        case 'crossorigin':
            props.crossOrigin = attr.value;
            break;
        default:
            props[attr.name] = attr.value;
    }
    return props;
}
module.exports["getExport"] = $a3803c67f4544810$export$d4c07b1daf44a7f;
module.exports["displayNameFromId"] = $a3803c67f4544810$export$4429f98ef60d2d87;
module.exports["isNodeEnvironment"] = $a3803c67f4544810$export$283635c04a02cc36;
module.exports["attrToProp"] = $a3803c67f4544810$export$62bf630d0de3d781;

});

parcelRegister("dZb8A", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a2d13c19047c2e6$export$2e2bcd8739ae039);
/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $2a2d13c19047c2e6$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        // @ts-ignore TS7029 fallthrough
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        // @ts-ignore TS7029 fallthrough
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}

});

parcelRegister("9W961", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $jrpaf = parcelRequire("jrpaf");
var $hwBK6 = parcelRequire("hwBK6");


var $iqYgx = parcelRequire("iqYgx");


var $6pwcu = parcelRequire("6pwcu");


var $hGTvt = parcelRequire("hGTvt");


var $bSocS = parcelRequire("bSocS");


var $3UFgg = parcelRequire("3UFgg");


var $27xqQ = parcelRequire("27xqQ");


var $bYDpj = parcelRequire("bYDpj");


var $iQUPl = parcelRequire("iQUPl");


var $6mYYR = parcelRequire("6mYYR");

function $9e10a968465c2ceb$export$6898b5504b58699a({ defer: defer, deferred: deferred, dataLazyId: dataLazyId, moduleId: moduleId }) {
    const ResolvedLazy = /*#__PURE__*/ (0, $cozmU.lazy)(()=>deferred.promise);
    return (props)=>{
        // use a single piece of state to hold info about progress or eventually
        // throw an error. We do change it via direct mutation as re-renders
        // break Suspense in React 18, making it lose hydration state
        const [status, bubbleError] = (0, $cozmU.useState)(()=>({
                noWait: undefined,
                phase: defer === (0, $iqYgx.PHASE).AFTER_PAINT ? false : true,
                preloaded: defer === (0, $iqYgx.PHASE).AFTER_PAINT ? false : true,
                started: false
            }));
        const { usePostTaskPhases: usePostTaskPhases } = (0, $jrpaf.getConfig)();
        const { setFallback: setFallback, getIsBoundaryInitialized: getIsBoundaryInitialized } = (0, $cozmU.useContext)((0, $3UFgg.LazySuspenseContext));
        const profiler = (0, $cozmU.useContext)((0, $bSocS.ProfilerContext)).current;
        const load = ()=>{
            if (usePostTaskPhases) {
                if (status.started) return;
            } else {
                if (status.started || !status.phase || !status.noWait) return;
            }
            status.started = true;
            let onResolve;
            if (profiler) {
                const eventInfo = {
                    identifier: moduleId
                };
                onResolve = ()=>{
                    profiler.onLoadComplete(eventInfo);
                };
                profiler.onLoadStart(eventInfo);
            }
            const result = deferred.start().catch((err)=>{
                // Throw the error within the component lifecycle
                // refer to https://github.com/facebook/react/issues/11409
                bubbleError(()=>{
                    throw (0, $27xqQ.createLoaderError)(err);
                });
            });
            if (onResolve) result.then(onResolve);
        };
        if (usePostTaskPhases) // Start loading immediately, as the loader itself will be delayed until the appropriate phase
        (0, $cozmU.useMemo)(()=>{
            load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        else {
            // Subscribe to LazyWait context, triggering load when until is true
            (0, $6mYYR.useSubscription)({
                context: (0, $6pwcu.WaitContext),
                load: load,
                onValue: (v)=>status.noWait = v === 1
            });
            if (defer === (0, $iqYgx.PHASE).AFTER_PAINT) // Subscribe to LazyPhase context, triggering load when own phase starts
            (0, $6mYYR.useSubscription)({
                context: (0, $hGTvt.LazyPhaseContext),
                load: load,
                onValue: (v)=>status.phase = v >= defer
            });
        }
        (0, $cozmU.useMemo)(()=>{
            // Skip collecting fallbacks if the boundary is already initialized
            if (usePostTaskPhases && getIsBoundaryInitialized()) return;
            // find SSR content (or fallbacks) wrapped in inputs based on lazyId
            const content = ((0, $iqYgx.COLLECTED).get(dataLazyId) || []).shift();
            if (!content) return;
            // override Suspense fallback with magic input wrappers
            const component = (0, $jrpaf.getConfig)().mode === (0, $hwBK6.MODE).RENDER ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iQUPl.PlaceholderFallbackRender), {
                id: dataLazyId,
                content: content
            }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bYDpj.PlaceholderFallbackHydrate), {
                id: dataLazyId,
                content: content
            });
            setFallback(component);
        }, [
            setFallback,
            getIsBoundaryInitialized,
            usePostTaskPhases
        ]);
        (0, $cozmU.useMemo)(()=>{
            const { mode: mode, react18: react18 } = (0, $jrpaf.getConfig)();
            // we dont remove fallback in RENDER mode as it happens too early
            // however it's not a problem for HYDRATION as Suspense will handle all nuances
            if (mode === (0, $hwBK6.MODE).HYDRATE && react18) // Allow hydration to support partials without server components
            // suspense will discard ssr during hydration if re-renders so we
            // set a dummy fallback to block updates from the provider until we resolve
            setFallback(/*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {}));
        }, [
            setFallback
        ]);
        return /*#__PURE__*/ (0, $8aG6j.jsx)(ResolvedLazy, {
            ...props
        });
    };
}
module.exports["createComponentClient"] = $9e10a968465c2ceb$export$6898b5504b58699a;

});

parcelRegister("6pwcu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aJQSl = parcelRequire("aJQSl");

const $548763ff32fd4fa9$export$9ba3fe09d15de47b = (0, $cozmU.createContext)({
    subscribe: ()=>(0, $aJQSl.noopCleanup),
    currentValue: ()=>1
});
module.exports["WaitContext"] = $548763ff32fd4fa9$export$9ba3fe09d15de47b;

});

parcelRegister("aJQSl", function(module, exports) {
const $05617924a76d0a6c$export$276c7dbda7675aec = ()=>{
// Nothing to cleanup...
};
module.exports["noopCleanup"] = $05617924a76d0a6c$export$276c7dbda7675aec;

});

parcelRegister("hGTvt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iqYgx = parcelRequire("iqYgx");


var $lJvTv = parcelRequire("lJvTv");


var $dcIK9 = parcelRequire("dcIK9");

let $672f0e6595584070$var$CURRENT_PHASE = (0, $iqYgx.PHASE).PAINT;
const $672f0e6595584070$export$5f80f094fd31fffd = (phase)=>{
    $672f0e6595584070$var$CURRENT_PHASE = phase;
    (0, $lJvTv.LISTENERS).slice(0).forEach((listener)=>listener(phase));
};
const $672f0e6595584070$export$5a25eca35e5debcb = /*#__PURE__*/ (0, $cozmU.createContext)({
    subscribe: (0, $dcIK9.createSubscribe)((0, $lJvTv.LISTENERS)),
    currentValue: ()=>$672f0e6595584070$var$CURRENT_PHASE,
    api: {
        startNextPhase: ()=>{
            $672f0e6595584070$export$5f80f094fd31fffd((0, $iqYgx.PHASE).AFTER_PAINT);
        },
        resetPhase: ()=>$672f0e6595584070$export$5f80f094fd31fffd((0, $iqYgx.PHASE).PAINT)
    }
});
const $672f0e6595584070$export$1dc361b277327f88 = ()=>{
    const v = (0, $cozmU.useContext)($672f0e6595584070$export$5a25eca35e5debcb);
    return v.api;
};
module.exports["LazyPhaseContext"] = $672f0e6595584070$export$5a25eca35e5debcb;

});

parcelRegister("lJvTv", function(module, exports) {
const $17f151a063744015$export$81b9c458a026d68f = [];
module.exports["LISTENERS"] = $17f151a063744015$export$81b9c458a026d68f;

});

parcelRegister("dcIK9", function(module, exports) {
const $66c4eef17986e77d$export$364097d812234b3f = (listeners)=>(listener)=>{
        listeners.push(listener);
        return ()=>{
            const index = listeners.indexOf(listener);
            if (index !== -1) listeners.splice(index, 1);
        };
    };
module.exports["createSubscribe"] = $66c4eef17986e77d$export$364097d812234b3f;

});

parcelRegister("bSocS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $0b79a9622223785f$export$e2d53c0cbedd2710 = {
    current: null
};
const $0b79a9622223785f$export$8146ab57a3f7a7cb = (0, $cozmU.createContext)($0b79a9622223785f$export$e2d53c0cbedd2710);
module.exports["GlobalReactLooselyLazyProfiler"] = $0b79a9622223785f$export$e2d53c0cbedd2710;
module.exports["ProfilerContext"] = $0b79a9622223785f$export$8146ab57a3f7a7cb;

});

parcelRegister("3UFgg", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $jrpaf = parcelRequire("jrpaf");
var $hwBK6 = parcelRequire("hwBK6");

const $307cdf761723c83f$export$c33990e84065970c = /*#__PURE__*/ (0, $cozmU.createContext)({
    getIsBoundaryInitialized: ()=>false,
    fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Fragment), {}),
    setFallback: ()=>{
        if ((0, $jrpaf.getConfig)().mode === (0, $hwBK6.MODE).RENDER) // render mode MUST have a properly configured boundary
        // eslint-disable-next-line no-console
        console.warn('Missing <LooselySuspense /> boundary');
    }
});
module.exports["LazySuspenseContext"] = $307cdf761723c83f$export$c33990e84065970c;

});

parcelRegister("27xqQ", function(module, exports) {
const $8d723af0e292a27d$export$6aa69c1258005366 = Symbol.for('@atlassian/react-loosely-lazy/loader-error');
const $8d723af0e292a27d$export$c73a6a6f0bf7d425 = (error)=>{
    if (typeof error === 'object') // @ts-expect-error Explicitly untyped
    return Object.assign(error, {
        [$8d723af0e292a27d$export$6aa69c1258005366]: true
    });
    return error;
};
const $8d723af0e292a27d$export$16a03aca4a3508b4 = (error)=>Object.getOwnPropertySymbols(error).includes($8d723af0e292a27d$export$6aa69c1258005366);
module.exports["createLoaderError"] = $8d723af0e292a27d$export$c73a6a6f0bf7d425;

});

parcelRegister("bYDpj", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $3Zhtx = parcelRequire("3Zhtx");

const $308221388927349f$export$ca5b8fbc835d95e4 = ({ id: id, content: content })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                type: "hidden",
                "data-lazy-begin": id
            }),
            content.map((el, i)=>{
                const { tagName: tagName = '', childNodes: childNodes = [], attributes: attributes = [] } = el;
                const props = Array.from(attributes).reduce((0, $3Zhtx.attrToProp), {
                    key: String(i)
                });
                // text node
                if (!tagName) return /*#__PURE__*/ (0, $cozmU.createElement)((0, $cozmU.Fragment), props, el.textContent);
                // childless tag
                if (!childNodes.length) return /*#__PURE__*/ (0, $cozmU.createElement)(tagName.toLowerCase(), props);
                // tag with content
                return /*#__PURE__*/ (0, $cozmU.createElement)(tagName.toLowerCase(), {
                    ...props,
                    dangerouslySetInnerHTML: {
                        __html: ''
                    },
                    suppressHydrationWarning: true
                });
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                type: "hidden",
                "data-lazy-end": id
            })
        ]
    });
};
module.exports["PlaceholderFallbackHydrate"] = $308221388927349f$export$ca5b8fbc835d95e4;

});

parcelRegister("iQUPl", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $bSocS = parcelRequire("bSocS");


var $6pwcu = parcelRequire("6pwcu");


var $3UFgg = parcelRequire("3UFgg");

function $fac82888d07c9621$var$isLinkPrefetch(el) {
    return el.tagName === 'LINK' && el.rel === 'prefetch';
}
const $fac82888d07c9621$var$usePlaceholderRender = (resolveId, content)=>{
    const hydrationRef = (0, $cozmU.useRef)(null);
    const { current: ssrDomNodes } = (0, $cozmU.useRef)(content || []);
    const profilerContext = (0, $cozmU.useContext)((0, $bSocS.ProfilerContext)).current;
    const waitContext = (0, $cozmU.useContext)((0, $6pwcu.WaitContext));
    const suspenseContext = (0, $cozmU.useContext)((0, $3UFgg.LazySuspenseContext));
    (0, $cozmU.useLayoutEffect)(()=>{
        const element = hydrationRef.current;
        const { parentNode: parentNode } = element || {};
        profilerContext?.placeholderFallBackMounted(resolveId, suspenseContext.name, !waitContext.currentValue());
        if (parentNode && !parentNode.contains(ssrDomNodes[0])) ssrDomNodes.reverse().forEach((node)=>{
            // this fixes an issue with Chrome that re-triggers and cancels prefetch
            // when node is appended again, making network panel quite noisy
            if ($fac82888d07c9621$var$isLinkPrefetch(node)) node.rel = '';
            parentNode.insertBefore(node, element.nextSibling);
        });
        return ()=>{
            profilerContext?.placeholderFallBackUnmounted(resolveId, suspenseContext.name, !waitContext.currentValue());
            ssrDomNodes.forEach((node)=>node.parentNode?.removeChild(node));
        };
    // [hydrationRef.current, ssrDomNodes] are expected to be stable
    // with the second one never changing by design and the first one changing after first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return hydrationRef;
};
const $fac82888d07c9621$export$d55db778a3e1446b = ({ id: id, content: content })=>{
    const placeholderRef = $fac82888d07c9621$var$usePlaceholderRender(id, content);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
        type: "hidden",
        "data-lazy-begin": id,
        ref: placeholderRef
    });
};
module.exports["PlaceholderFallbackRender"] = $fac82888d07c9621$export$d55db778a3e1446b;

});

parcelRegister("6mYYR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $fb43d3d8deaa2f13$export$368b4214baeb914c({ context: context, load: load, onValue: onValue }) {
    const { subscribe: subscribe, currentValue: currentValue } = (0, $cozmU.useContext)(context);
    (0, $cozmU.useMemo)(()=>{
        let unsubscribe = null;
        const check = ()=>{
            const done = onValue(currentValue());
            if (done) load();
            if (done && unsubscribe) unsubscribe();
            return done;
        };
        unsubscribe = !check() ? subscribe(check) : null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useSubscription"] = $fb43d3d8deaa2f13$export$368b4214baeb914c;

});

parcelRegister("f1SiZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $3zIme = parcelRequire("3zIme");


var $jrpaf = parcelRequire("jrpaf");
var $hwBK6 = parcelRequire("hwBK6");


var $iqYgx = parcelRequire("iqYgx");


var $3UFgg = parcelRequire("3UFgg");


var $3Zhtx = parcelRequire("3Zhtx");


var $27xqQ = parcelRequire("27xqQ");

function $e4910f9bc5a8efc5$var$load(moduleId, loader) {
    try {
        return (0, $3Zhtx.getExport)(loader());
    } catch (err) {
        throw (0, $27xqQ.createLoaderError)(err);
    }
}
function $e4910f9bc5a8efc5$export$eb2e4b04351cdd9e({ dataLazyId: dataLazyId, defer: defer, loader: loader, moduleId: moduleId, ssr: ssr }) {
    return (props)=>{
        const { fallback: fallback } = (0, $cozmU.useContext)((0, $3UFgg.LazySuspenseContext));
        const { crossOrigin: crossOrigin, manifest: manifest, onChunkRender: onChunkRender, mode: mode, react18: react18, modernErrorFallback: modernErrorFallback, environment: environment } = (0, $jrpaf.getConfig)();
        const shouldLoad = ssr || environment === 'client';
        const Resolved = shouldLoad ? $e4910f9bc5a8efc5$var$load(moduleId, loader) : null;
        onChunkRender(dataLazyId, moduleId, defer);
        if (mode === (0, $hwBK6.MODE).HYDRATE && react18) {
            if (!Resolved) throw new $e4910f9bc5a8efc5$var$ReactLooselyLazyNoSsrError(moduleId);
            return /*#__PURE__*/ (0, $8aG6j.jsx)(Resolved, {
                ...props
            });
        }
        if (modernErrorFallback) {
            if (!Resolved) // lets just return the fallback without extra fuzz
            // and "error" fallback is usually totally empty, so why bother?
            return fallback;
        }
        return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                    type: "hidden",
                    "data-lazy-begin": dataLazyId
                }),
                defer !== (0, $iqYgx.PHASE).LAZY && (0, $3zIme.getAssetUrlsFromId)(manifest, moduleId)?.map((url)=>/*#__PURE__*/ (0, $8aG6j.jsx)("link", {
                        rel: defer === (0, $iqYgx.PHASE).PAINT ? 'preload' : 'prefetch',
                        href: url,
                        crossOrigin: crossOrigin,
                        as: "script"
                    }, url)),
                Resolved ? /*#__PURE__*/ (0, $8aG6j.jsx)(Resolved, {
                    ...props
                }) : fallback,
                /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                    type: "hidden",
                    "data-lazy-end": dataLazyId
                })
            ]
        });
    };
}
class $e4910f9bc5a8efc5$var$ReactLooselyLazyNoSsrError extends Error {
    constructor(moduleId){
        super(`[no-error] React-Loosely-Lazy SSR opt out - ${moduleId}`);
        // This error is used to indicate to React that this component should not
        // render in SSR (it will instead trigger the nearest Suspense boundary)
        // so we mark it as ignored in SSR reporting.
        this.skipSsr = void 0;
        this.skipSsr = true;
    }
}
module.exports["createComponentServer"] = $e4910f9bc5a8efc5$export$eb2e4b04351cdd9e;

});

parcelRegister("6DjRB", function(module, exports) {
const $ee7f0d866347d691$export$bb34f3538ba26c7e = {
    HIGH: 0,
    LOW: 2
};
const $ee7f0d866347d691$export$a339266ad71b2447 = 300;
const $ee7f0d866347d691$export$ba64c908e55507fe = 1;
module.exports["PRIORITY"] = $ee7f0d866347d691$export$bb34f3538ba26c7e;
module.exports["RETRY_DELAY"] = $ee7f0d866347d691$export$a339266ad71b2447;
module.exports["RETRY_FACTOR"] = $ee7f0d866347d691$export$ba64c908e55507fe;

});

parcelRegister("ah4XH", function(module, exports) {
/**
 * a map of all created deferred to
 * - ensure there is single deferred created for every lazy (NOT YET ENFORCED/USED)
 * - track list of known LazyComponents so we can, for example, preload them by id
 */ const $841e841717fb4840$var$lazyIds = new Map();
/**
 * ids "marked" for preload on spot
 */ let $841e841717fb4840$var$preloadIds;
const $841e841717fb4840$export$ac21d099cbc8d569 = (preload)=>{
    $841e841717fb4840$var$preloadIds = preload;
    try {
        $841e841717fb4840$var$preloadIds.forEach((lazyId)=>{
            const deffered = $841e841717fb4840$var$lazyIds.get(lazyId);
            if (deffered) // preload dont have any "phases" and visa versa. Just load it ASAP
            deffered.preload();
        });
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('RLL preload', e);
    }
};
const $841e841717fb4840$export$e673efccd97e4223 = (lazyId, { loader: loader, preload: preload })=>{
    // we dont cache deferred FOR NOW as the goal is to handle networking first
    // the next step would in better pre-resolving deferred, so Suspense might be never triggered
    // if (lazyIds.has(lazyId)) {
    // 	return lazyIds.get(lazyId)!;
    // }
    let resolve;
    const deferred = {
        promise: new Promise((res)=>{
            resolve = (m)=>{
                let withDefault;
                deferred.result = m;
                if (!m.default) withDefault = {
                    default: m
                };
                res(withDefault ? withDefault : m);
            };
        }),
        result: undefined,
        preload: ()=>{
            if (deferred.result) return;
            preload().then((m)=>{
                deferred.result = m;
            }).catch(()=>{
            // Do nothing...
            });
        },
        start: ()=>{
            if (deferred.result) {
                resolve(deferred.result);
                return Promise.resolve();
            }
            // Make a new loader request when none have started or resolved yet
            return loader().then(resolve);
        }
    };
    $841e841717fb4840$var$lazyIds.set(lazyId, deferred);
    // in case of "just created" deferred is already marked for preload
    // do instant preload
    if ($841e841717fb4840$var$preloadIds?.includes(lazyId)) deferred.preload();
    return deferred;
};
module.exports["createDeferred"] = $841e841717fb4840$export$e673efccd97e4223;

});

parcelRegister("cU4Ow", function(module, exports) {

var $3zIme = parcelRequire("3zIme");


var $aJQSl = parcelRequire("aJQSl");


var $jrpaf = parcelRequire("jrpaf");


var $bSocS = parcelRequire("bSocS");


var $3Zhtx = parcelRequire("3Zhtx");


var $6DjRB = parcelRequire("6DjRB");


var $1Y0Bp = parcelRequire("1Y0Bp");

function $72b45db42b4960fa$export$3af04dbcb01bad4d({ moduleId: moduleId, rel: rel }) {
    const { manifest: manifest } = (0, $jrpaf.getConfig)();
    const assets = (0, $3zIme.getAssetUrlsFromId)(manifest, moduleId);
    if (!assets) throw new Error('Unsupported preload strategy');
    const cleanupLinkTags = assets.map((url)=>(0, $1Y0Bp.insertLinkTag)(url, rel));
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
const $72b45db42b4960fa$var$fakePromise = {
    then: ()=>$72b45db42b4960fa$var$fakePromise,
    catch: ()=>$72b45db42b4960fa$var$fakePromise,
    finally: ()=>$72b45db42b4960fa$var$fakePromise
};
function $72b45db42b4960fa$export$1046fd6a49d5e7a({ loader: loader, rel: rel }) {
    if (typeof __webpack_require__ === 'undefined' || typeof __webpack_get_script_filename__ === 'undefined') throw new Error('Unsupported preload strategy');
    // Replace requireEnsure to create link tags instead of scripts
    const requireEnsure = __webpack_require__.e;
    const cleanupLinkTags = [];
    __webpack_require__.e = function requirePreload(chunkId) {
        const href = __webpack_get_script_filename__(chunkId);
        cleanupLinkTags.push((0, $1Y0Bp.insertLinkTag)(href, rel));
        return $72b45db42b4960fa$var$fakePromise;
    };
    try {
        loader();
    } catch (err) {
    // Ignore any errors
    }
    // Restore real webpack require ensure
    __webpack_require__.e = requireEnsure;
    return ()=>{
        for (const cleanupLinkTag of cleanupLinkTags)cleanupLinkTag();
    };
}
function $72b45db42b4960fa$export$eb05139fa4dcf992({ loader: loader }) {
    loader();
    return 0, $aJQSl.noopCleanup;
}
function $72b45db42b4960fa$export$25bad4aa00c45355({ loader: loader, moduleId: moduleId, priority: priority }) {
    if ((0, $3Zhtx.isNodeEnvironment)()) return 0, $aJQSl.noopCleanup;
    (0, $bSocS.GlobalReactLooselyLazyProfiler).current?.onPreload(moduleId, priority);
    const rel = priority === (0, $6DjRB.PRIORITY).HIGH ? 'preload' : 'prefetch';
    const preloadStrategies = [
        $72b45db42b4960fa$export$3af04dbcb01bad4d,
        $72b45db42b4960fa$export$1046fd6a49d5e7a,
        $72b45db42b4960fa$export$eb05139fa4dcf992
    ];
    for (const strategy of preloadStrategies)try {
        return strategy({
            loader: loader,
            moduleId: moduleId,
            rel: rel
        });
    } catch (_) {
    // Try next strategy...
    }
    return 0, $aJQSl.noopCleanup;
}
module.exports["preloadAsset"] = $72b45db42b4960fa$export$25bad4aa00c45355;

});

parcelRegister("1Y0Bp", function(module, exports) {

var $aJQSl = parcelRequire("aJQSl");


var $jrpaf = parcelRequire("jrpaf");


var $bSocS = parcelRequire("bSocS");

function $e5a7bcb8f7812549$export$6610512821c8a4ce(href, rel) {
    // Skip if already preloaded, prefetched, or loaded
    if (document.querySelector(`link[href="${href}"]`) || document.querySelector(`script[src="${href}"]`)) return 0, $aJQSl.noopCleanup;
    const { crossOrigin: crossOrigin } = (0, $jrpaf.getConfig)();
    const link = document.createElement('link');
    link.rel = rel;
    link.as = 'script';
    if (crossOrigin) link.crossOrigin = crossOrigin;
    link.href = href;
    const profiler = (0, $bSocS.GlobalReactLooselyLazyProfiler).current;
    let removableListener = null;
    if (profiler) {
        const eventInfo = {
            identifier: href
        };
        const listener = ()=>{
            link.removeEventListener('onload', listener);
            removableListener = null;
            profiler.onLoadComplete(eventInfo);
        };
        link.addEventListener('onload', listener);
        removableListener = listener;
        profiler.onLoadStart(eventInfo);
    }
    document.head?.appendChild(link);
    return ()=>{
        // Remove the link if it is still in the document head
        if (link.parentNode === document.head) document.head?.removeChild(link);
        if (removableListener) link.removeEventListener('onload', removableListener);
    };
}
module.exports["insertLinkTag"] = $e5a7bcb8f7812549$export$6610512821c8a4ce;

});

parcelRegister("31PDK", function(module, exports) {
const $e0741a36efbb4dfa$var$calculateDelay = (context, policy)=>{
    const { attempt: attempt } = context;
    const { delay: delay, factor: factor } = policy;
    const retryAttempt = attempt - 1;
    // Do not use a delay on the first retry, or when the configured delay is 0
    if (retryAttempt === 1 || delay === 0) return 0;
    // Linear factor, like: https://github.com/Polly-Contrib/Polly.Contrib.WaitAndRetry#wait-and-retry-with-linear-back-off
    const add = factor * delay;
    return delay + add * (retryAttempt - 2);
};
const $e0741a36efbb4dfa$var$sleep = (delay)=>new Promise((resolve)=>setTimeout(resolve, delay));
const $e0741a36efbb4dfa$var$getPolicy = (configuration)=>({
        delay: Math.max(0, configuration.delay ?? 0),
        factor: Math.max(0, configuration.factor ?? 0),
        maxAttempts: Math.max(0, configuration.maxAttempts ?? 0)
    });
function $e0741a36efbb4dfa$export$9369b12211e1fce4(retryable, policyConfiguration = {}) {
    const policy = $e0741a36efbb4dfa$var$getPolicy(policyConfiguration);
    const { maxAttempts: maxAttempts } = policy;
    const context = {
        attempt: 1,
        attemptsRemaining: maxAttempts
    };
    const onError = async (err)=>{
        if (context.attemptsRemaining === 0) throw err;
        context.attempt += 1;
        context.attemptsRemaining -= 1;
        const delay = $e0741a36efbb4dfa$var$calculateDelay(context, policy);
        if (delay) await $e0741a36efbb4dfa$var$sleep(delay);
        return retryable().catch(onError);
    };
    return retryable().catch(onError);
}
module.exports["retry"] = $e0741a36efbb4dfa$export$9369b12211e1fce4;

});

parcelRegister("3w7xz", function(module, exports) {

let $28fa35a07f4c32d8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $28fa35a07f4c32d8$var$load("ECQ6q").then(()=>parcelRequire('kGNh6'));

});

parcelRegister("ehKBQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $6ce68911b0df4e15$var$LazyGitlabIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ilgI1")).then((m)=>m.GitlabIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitlab/icon'
});

const $6ce68911b0df4e15$var$LazyGitlabSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ilgI1")).then((m)=>m.GitlabSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitlab/search-result-icon'
});

const $6ce68911b0df4e15$var$LazyGitlabIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("ilgI1")).then((m)=>m.GitlabIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/gitlab/icon-borderless'
});
const $6ce68911b0df4e15$export$8b4e5326778cce0f = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6ce68911b0df4e15$var$LazyGitlabIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6ce68911b0df4e15$var$LazyGitlabIconComponent, null));
const $6ce68911b0df4e15$export$b828123bc19648f9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6ce68911b0df4e15$var$LazyGitlabSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6ce68911b0df4e15$var$LazyGitlabSearchResultIconComponent, null));
const $6ce68911b0df4e15$export$7e0d364467f49036 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6ce68911b0df4e15$var$LazyGitlabIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6ce68911b0df4e15$var$LazyGitlabIconBorderlessComponent, null));
module.exports["GitlabIcon"] = $6ce68911b0df4e15$export$8b4e5326778cce0f;
module.exports["GitlabSearchResultIcon"] = $6ce68911b0df4e15$export$b828123bc19648f9;
module.exports["GitlabIconBorderless"] = $6ce68911b0df4e15$export$7e0d364467f49036;

});

parcelRegister("ilgI1", function(module, exports) {

let $d5a726386ad88d53$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d5a726386ad88d53$var$load("1p9Ip").then(()=>parcelRequire('hYL6T'));

});

parcelRegister("iS3Tu", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $83bbbb3fda08bb6a$var$LazyGitbookIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lbDA4")).then((m)=>m.GitbookIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitbook/icon'
});

const $83bbbb3fda08bb6a$var$LazyGitbookSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("lbDA4")).then((m)=>m.GitbookSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/gitbook/search-result-icon'
});
const $83bbbb3fda08bb6a$export$6da1c7984975c183 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookIconComponent, null));
const $83bbbb3fda08bb6a$export$65b356f251826206 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($83bbbb3fda08bb6a$var$LazyGitbookSearchResultIconComponent, null));
module.exports["GitbookIcon"] = $83bbbb3fda08bb6a$export$6da1c7984975c183;
module.exports["GitbookSearchResultIcon"] = $83bbbb3fda08bb6a$export$65b356f251826206;

});

parcelRegister("lbDA4", function(module, exports) {

let $f6c953f826ed6884$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f6c953f826ed6884$var$load("k1ije").then(()=>parcelRequire('lG6hv'));

});

parcelRegister("dULnI", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $2cad9d35507cac43$var$LazyAzureDevopsIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8WMbv")).then((m)=>m.AzureDevopsIcon), {
    moduleId: '@atlassian/rovo-connectors-config/azure-devops/icon'
});

const $2cad9d35507cac43$var$LazyAzureDevopsSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("8WMbv")).then((m)=>m.AzureDevopsSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/azure-devops/search-result-icon'
});
const $2cad9d35507cac43$export$2dcf704e717ca168 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2cad9d35507cac43$var$LazyAzureDevopsIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2cad9d35507cac43$var$LazyAzureDevopsIconComponent, null));
const $2cad9d35507cac43$export$a64bb17da4dc2efb = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2cad9d35507cac43$var$LazyAzureDevopsSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2cad9d35507cac43$var$LazyAzureDevopsSearchResultIconComponent, null));
module.exports["AzureDevopsIcon"] = $2cad9d35507cac43$export$2dcf704e717ca168;
module.exports["AzureDevopsSearchResultIcon"] = $2cad9d35507cac43$export$a64bb17da4dc2efb;

});

parcelRegister("8WMbv", function(module, exports) {

let $68391df23b860e75$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $68391df23b860e75$var$load("axvMK").then(()=>parcelRequire('fTk3N'));

});

parcelRegister("9Jc29", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $f96caf77f5e0e90e$var$LazyGoogleDriveIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eauWV")).then((m)=>m.GoogleDriveIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google/icon'
});

const $f96caf77f5e0e90e$var$LazyGoogleDriveSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eauWV")).then((m)=>m.GoogleDriveSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google/search-result-icon'
});

const $f96caf77f5e0e90e$var$LazyGoogleDriveIconBorderlessComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eauWV")).then((m)=>m.GoogleDriveIconBorderless), {
    moduleId: '@atlassian/rovo-connectors-config/google/icon-borderless'
});

const $f96caf77f5e0e90e$var$LazyGoogleDriveAppSelectorIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("eauWV")).then((m)=>m.GoogleDriveAppSelectorIcon), {
    moduleId: '@atlassian/rovo-connectors-config/google/app-selector-icon'
});
const $f96caf77f5e0e90e$export$e16bd899bb4eebf9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveIconComponent, null));
const $f96caf77f5e0e90e$export$99050685a064f8e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveSearchResultIconComponent, null));
const $f96caf77f5e0e90e$export$1f3b452b60b13122 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveIconBorderlessComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveIconBorderlessComponent, null));
const $f96caf77f5e0e90e$export$e087ba40596ff085 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveAppSelectorIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f96caf77f5e0e90e$var$LazyGoogleDriveAppSelectorIconComponent, null));
module.exports["GoogleDriveIcon"] = $f96caf77f5e0e90e$export$e16bd899bb4eebf9;
module.exports["GoogleDriveSearchResultIcon"] = $f96caf77f5e0e90e$export$99050685a064f8e;
module.exports["GoogleDriveIconBorderless"] = $f96caf77f5e0e90e$export$1f3b452b60b13122;
module.exports["GoogleDriveAppSelectorIcon"] = $f96caf77f5e0e90e$export$e087ba40596ff085;

});

parcelRegister("eauWV", function(module, exports) {

let $a50a01c0fe4d8419$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a50a01c0fe4d8419$var$load("fz4Mg").then(()=>parcelRequire('aqriX'));

});

parcelRegister("iPmoS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5mh7K = parcelRequire("5mh7K");


const $b77f1e6828d0ac82$var$LazyForgePioGithubIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9RFVr")).then((m)=>m.ForgePioGithubIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-github-prod/icon'
});

const $b77f1e6828d0ac82$var$LazyForgePioGithubSearchResultIconComponent = (0, $5mh7K.lazyForPaint)(()=>(parcelRequire("9RFVr")).then((m)=>m.ForgePioGithubSearchResultIcon), {
    moduleId: '@atlassian/rovo-connectors-config/forge-pio-github-prod/search-result-icon'
});
const $b77f1e6828d0ac82$export$f1d7e8d930f0538e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b77f1e6828d0ac82$var$LazyForgePioGithubIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b77f1e6828d0ac82$var$LazyForgePioGithubIconComponent, null));
const $b77f1e6828d0ac82$export$f318f463f9328f3f = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b77f1e6828d0ac82$var$LazyForgePioGithubSearchResultIconComponent, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b77f1e6828d0ac82$var$LazyForgePioGithubSearchResultIconComponent, null));
module.exports["ForgePioGithubIcon"] = $b77f1e6828d0ac82$export$f1d7e8d930f0538e;
module.exports["ForgePioGithubSearchResultIcon"] = $b77f1e6828d0ac82$export$f318f463f9328f3f;

});

parcelRegister("9RFVr", function(module, exports) {

let $72e995d3df53c84c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $72e995d3df53c84c$var$load("cNleL").then(()=>parcelRequire('gcarM'));

});

parcelRegister("5PPrc", function(module, exports) {
const $b36df32f21d2d1ae$export$49f6cbb853d30562 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    Repository: 'repository',
    PullRequest: 'pull-request',
    Branch: 'branch',
    Commit: 'commit',
    DevopsWorkItem: 'devops-work-item',
    WebPage: 'web-page',
    Conversation: 'conversation',
    Message: 'message',
    Video: 'video',
    Design: 'design',
    Page: 'page',
    Blogpost: 'blogpost',
    Attachment: 'attachment',
    Space: 'space',
    Whiteboard: 'whiteboard',
    Slide: 'slide',
    Comment: 'comment',
    Database: 'database',
    Embed: 'embed',
    Folder: 'folder',
    Calendar: 'calendar',
    SpaceCalendar: 'space-calendar',
    Question: 'question',
    Answer: 'answer',
    Issue: 'issue',
    Epic: 'epic',
    Bug: 'bug',
    Story: 'story',
    Task: 'task',
    Subtask: 'subtask',
    Project: 'project',
    Incident: 'incident',
    Filter: 'filter',
    Plan: 'plan',
    Board: 'board',
    Component: 'component',
    Card: 'card',
    Goal: 'goal',
    Tag: 'tag',
    WorkItem: 'work-item',
    FocusArea: 'focus-area',
    Organization: 'organization',
    Ask: 'ask',
    Risk: 'risk',
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Deal: 'deal',
    Gliffy: 'gliffy',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    DataTable: 'data-table',
    AssetsObject: 'object',
    Type: 'type',
    Schema: 'schema',
    Position: 'position',
    Image: 'image',
    Audio: 'audio',
    Pdf: 'pdf',
    Shortcut: 'shortcut',
    Code: 'code',
    Archive: 'archive',
    Other: 'other',
    Notebook: 'notebook',
    Form: 'form',
    Article: 'article',
    Post: 'post',
    Ticket: 'ticket',
    Campaign: 'campaign',
    Case: 'case',
    CatalogItem: 'catalog-item',
    RequestedItem: 'requested-item',
    Demand: 'demand',
    KnowledgeArticle: 'knowledge-article',
    NewsArticle: 'news-article',
    Lead: 'lead'
};
const $b36df32f21d2d1ae$export$e01073b80ff953d5 = Object.values($b36df32f21d2d1ae$export$49f6cbb853d30562);
const $b36df32f21d2d1ae$export$1f2db89e0caa00c9 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    File: 'file',
    Database: 'database',
    WebPage: 'web-page',
    Page: 'page',
    Blogpost: 'blogpost',
    Article: 'article',
    Post: 'post',
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Design: 'design',
    Deal: 'deal',
    Video: 'video',
    Task: 'task',
    Issue: 'issue',
    Space: 'space',
    Project: 'project',
    Repository: 'repository',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    Image: 'image',
    Archive: 'archive',
    Audio: 'audio',
    Code: 'code',
    Pdf: 'pdf',
    Other: 'other',
    Software: 'software',
    ServiceDesk: 'service_desk',
    Business: 'business',
    DataTable: 'data-table',
    AssetsObject: 'object',
    Schema: 'schema',
    Type: 'type',
    Folder: 'folder',
    Notebook: 'notebook',
    Form: 'form',
    Shortcut: 'shortcut',
    Site: 'site',
    Subsite: 'subsite',
    Drive: 'drive',
    Comment: 'comment',
    Incident: 'incident',
    CatalogItem: 'catalog_item',
    RequestedItem: 'requested_item',
    KnowledgeArticle: 'knowledge_article',
    Demand: 'demand',
    NewsArticle: 'news_article',
    Epic: 'epic'
};
/**
 * Maps CloudGraph ATI to TypeFilterValueKey
 */ const $b36df32f21d2d1ae$var$ATI_TO_TYPE_FILTER_KEY_MAP = {
    'ati:cloud:graph:document': $b36df32f21d2d1ae$export$49f6cbb853d30562.Document,
    'ati:cloud:graph:message': $b36df32f21d2d1ae$export$49f6cbb853d30562.Message,
    'ati:cloud:graph:conversation': $b36df32f21d2d1ae$export$49f6cbb853d30562.Conversation,
    'ati:cloud:graph:design': $b36df32f21d2d1ae$export$49f6cbb853d30562.Design,
    'ati:cloud:graph:video': $b36df32f21d2d1ae$export$49f6cbb853d30562.Video,
    'ati:cloud:graph:space': $b36df32f21d2d1ae$export$49f6cbb853d30562.Space,
    'ati:cloud:graph:comment': $b36df32f21d2d1ae$export$49f6cbb853d30562.Comment,
    'ati:cloud:graph:repository': $b36df32f21d2d1ae$export$49f6cbb853d30562.Repository,
    'ati:cloud:graph:pull-request': $b36df32f21d2d1ae$export$49f6cbb853d30562.PullRequest,
    'ati:cloud:graph:commit': $b36df32f21d2d1ae$export$49f6cbb853d30562.Commit,
    'ati:cloud:graph:branch': $b36df32f21d2d1ae$export$49f6cbb853d30562.Branch,
    'ati:cloud:graph:calendar-event': $b36df32f21d2d1ae$export$49f6cbb853d30562.Calendar,
    'ati:cloud:graph:work-item': $b36df32f21d2d1ae$export$49f6cbb853d30562.WorkItem,
    'ati:cloud:graph:project': $b36df32f21d2d1ae$export$49f6cbb853d30562.Project,
    'ati:cloud:graph:deal': $b36df32f21d2d1ae$export$49f6cbb853d30562.Deal,
    'ati:cloud:graph:customer-org': $b36df32f21d2d1ae$export$49f6cbb853d30562.CustomerOrg,
    'ati:cloud:graph:customer-contact': $b36df32f21d2d1ae$export$49f6cbb853d30562.CustomerContact,
    'ati:cloud:graph:dashboard': $b36df32f21d2d1ae$export$49f6cbb853d30562.Dashboard,
    'ati:cloud:graph:data-table': $b36df32f21d2d1ae$export$49f6cbb853d30562.DataTable,
    'ati:cloud:graph:campaign': $b36df32f21d2d1ae$export$49f6cbb853d30562.Campaign,
    'ati:cloud:graph:case': $b36df32f21d2d1ae$export$49f6cbb853d30562.Case,
    'ati:cloud:graph:lead': $b36df32f21d2d1ae$export$49f6cbb853d30562.Lead
};
/**
 * Checks if an ATI string is a CloudGraph ATI
 */ const $b36df32f21d2d1ae$var$isCloudGraphAti = (ati)=>{
    return ati.startsWith('ati:cloud:graph:');
};
function $b36df32f21d2d1ae$export$770175465f396551(atis) {
    const typeFilterConfig = new Map();
    // Group ATIs by their corresponding TypeFilterValueKey
    const atisByTypeKey = new Map();
    for (const ati of atis)if ($b36df32f21d2d1ae$var$isCloudGraphAti(ati)) {
        const typeKey = $b36df32f21d2d1ae$var$ATI_TO_TYPE_FILTER_KEY_MAP[ati];
        if (typeKey) {
            if (!atisByTypeKey.has(typeKey)) atisByTypeKey.set(typeKey, []);
            atisByTypeKey.get(typeKey).push(ati);
        }
    }
    // Convert to TypeFilterConfig3P format
    for (const [typeKey, entityAtis] of atisByTypeKey)typeFilterConfig.set(typeKey, {
        entities3P: entityAtis,
        subTypes3P: [] // Most configs use empty subTypes3P, can be extended if needed
    });
    return typeFilterConfig;
}
module.exports["TypeFilterValueKey"] = $b36df32f21d2d1ae$export$49f6cbb853d30562;
module.exports["NounSubtypeKey"] = $b36df32f21d2d1ae$export$1f2db89e0caa00c9;
module.exports["mapAtisToTypeFilterConfig"] = $b36df32f21d2d1ae$export$770175465f396551;

});

parcelRegister("lvKPs", function(module, exports) {
/*
Not to be confused for comment-macro-extension-handler.tsx in the same package which is used specifically
for the comment editor. This MacroExtensionHandler file is used for creating extension handlers
for next/full-page-editor
*/ 
var $cozmU = parcelRequire("cozmU");


var $ceVeI = parcelRequire("ceVeI");


var $6mKj3 = parcelRequire("6mKj3");


var $aJPUt = parcelRequire("aJPUt");


var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");


var $8pcS0 = parcelRequire("8pcS0");


var $eS4Za = parcelRequire("eS4Za");


var $Qcu7n = parcelRequire("Qcu7n");


var $e8Lxy = parcelRequire("e8Lxy");


var $e1Stz = parcelRequire("e1Stz");


var $lE7FD = parcelRequire("lE7FD");


var $5a4cC = parcelRequire("5a4cC");


var $9m03g = parcelRequire("9m03g");


var $4EIU1 = parcelRequire("4EIU1");


var $bBRJy = parcelRequire("bBRJy");


var $56y8A = parcelRequire("56y8A");


var $aG1nm = parcelRequire("aG1nm");


var $9K8Oh = parcelRequire("9K8Oh");


var $hU8XU = parcelRequire("hU8XU");


var $fxgwG = parcelRequire("fxgwG");


var $dgMPt = parcelRequire("dgMPt");


var $fuLIO = parcelRequire("fuLIO");


var $n9ft3 = parcelRequire("n9ft3");


var $jaHkh = parcelRequire("jaHkh");


var $CbxlN = parcelRequire("CbxlN");


var $kuTjv = parcelRequire("kuTjv");


var $6aEhm = parcelRequire("6aEhm");


var $c8uPc = parcelRequire("c8uPc");


var $ahrsq = parcelRequire("ahrsq");


var $5h7sn = parcelRequire("5h7sn");


var $7NX4e = parcelRequire("7NX4e");


var $bJaqz = parcelRequire("bJaqz");


var $l8XTa = parcelRequire("l8XTa");


var $2n2cE = parcelRequire("2n2cE");


var $18Eyu = parcelRequire("18Eyu");


var $8jP8e = parcelRequire("8jP8e");


var $kvJ5e = parcelRequire("kvJ5e");

const $0e80447918933d7e$export$ea8f3f4f30a7109d = ({ contentId: contentId, spaceKey: spaceKey, extensionContextProvider: extensionContextProvider, editorActions: editorActions, subscribeDocChange: subscribeDocChange, unsubscribeDocChange: unsubscribeDocChange, isLivePage: isLivePage, isCollabEditForLiveUpdatesEnabled: isCollabEditForLiveUpdatesEnabled })=>{
    return {
        [(0, $8pcS0.EXTENSION_TYPE).MACRO_CORE]: $0e80447918933d7e$export$9270a983db609799({
            contentId: contentId,
            spaceKey: spaceKey,
            extensionContextProvider: extensionContextProvider,
            editorActions: editorActions,
            subscribeDocChange: subscribeDocChange,
            unsubscribeDocChange: unsubscribeDocChange,
            isLivePage: isLivePage,
            isCollabEditForLiveUpdatesEnabled: isCollabEditForLiveUpdatesEnabled
        }),
        [(0, $8pcS0.EXTENSION_TYPE).MIGRATION]: (0, $5h7sn.getMigrationExtHandlerForEditor)({
            contentId: contentId,
            contextProviders: {} // we do not yet need ClassicEditorContextProvider for InvalidExtension in next editor
        })
    };
};
const $0e80447918933d7e$export$9270a983db609799 = ({ contentId: contentId, spaceKey: spaceKey, extensionContextProvider: extensionContextProvider = {
    ClassicEditorContextProvider: ({ children: children, isWithinEditor: _isWithinEditor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children)
}, editorActions: editorActions, subscribeDocChange: subscribeDocChange, unsubscribeDocChange: unsubscribeDocChange, isLivePage: isLivePage, isCollabEditForLiveUpdatesEnabled: isCollabEditForLiveUpdatesEnabled })=>(0, $eS4Za.createMacroExtensionHandler)((extension, doc)=>{
        const resolvedExtensionKey = (0, $Qcu7n.resolveQuestionsMacroExtensionKey)(extension.extensionKey);
        const extensionKey = resolvedExtensionKey;
        // Update extension if key was resolved to a different value
        if (resolvedExtensionKey !== extension.extensionKey) extension = {
            ...extension,
            extensionKey: resolvedExtensionKey
        };
        const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(extension);
        const { ClassicEditorContextProvider: ClassicEditorContextProvider } = extensionContextProvider;
        const macroDefaultProps = {
            node: extension,
            references: doc?.[0]?.references || [],
            contentId: contentId,
            spaceKey: spaceKey,
            mode: (0, $5kjCz.EDITOR),
            extensionKey: extensionKey,
            attributes: attributes,
            multiBodiedExtensionActions: doc?.[0]?.actions,
            isConnectMacro: Boolean(doc?.[0]?.isConnectMacro)
        };
        let implementation;
        const legacyMacroRenderer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ClassicEditorContextProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fuLIO.LegacyMacroRendererQuery), macroDefaultProps));
        switch(extensionKey){
            // blocklist - block extensions - we want to show the editor's placeholder frame, so return empty div
            case 'toc':
                // toc needs to be rewritten as it accesses the DOM to create its tree
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jP8e.TableOfContentsLiveComponent), {
                    macroDefaultProps: macroDefaultProps,
                    editorActions: editorActions,
                    subscribeDocChange: subscribeDocChange,
                    unsubscribeDocChange: unsubscribeDocChange,
                    isCollabEditForLiveUpdatesEnabled: !!isCollabEditForLiveUpdatesEnabled
                });
                break;
            case 'create-from-template':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ahrsq.CreateFromTemplate), macroDefaultProps);
                break;
            case (0, $8pcS0.EXTENSION_KEY).TEAM_CALENDARS:
                implementation = (0, $6mKj3.expValEquals)('cc-engagement-team-calendar-macro-afm-migration', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kuTjv.TeamCalendarMacroLoader), {
                    extensionNode: extension,
                    macroDefaultProps: macroDefaultProps
                }) : legacyMacroRenderer;
                break;
            // blocklist - inline extensions - the editor doesn't render a placeholder frame, so we need to display something
            case 'pagetree':
                // pagetree is not spa friendly and will only work sometimes
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c8uPc.DeadMacroRenderer), macroDefaultProps);
                break;
            case 'anchor':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6aEhm.AnchorMacroRenderer), macroDefaultProps);
                break;
            case 'excerpt-include':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ClassicEditorContextProvider, {
                    isWithinEditor: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7NX4e.ExcerptIncludeExtensionHandler), {
                    ...macroDefaultProps,
                    isLivePage: isLivePage,
                    Renderer: (0, $e8Lxy.PageContentRenderer)
                }));
                break;
            case 'detailssummary':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ClassicEditorContextProvider, {
                    isWithinEditor: true
                }, (0, $ceVeI.isMigratedMacroImplEnabled)('detailssummary') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lE7FD.DetailsSummaryExtensionHandler), {
                    macroDefaultProps: macroDefaultProps,
                    macroParams: extension?.parameters?.macroParams,
                    openAnchorsInNewTab: true
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e1Stz.PagePropertiesReportRenderer), {
                    macroDefaultProps: macroDefaultProps,
                    macroParams: extension?.parameters?.macroParams,
                    openAnchorsInNewTab: true
                }));
                break;
            case (0, $8pcS0.EXTENSION_KEY).ATTACHMENTS:
                if ((0, $ceVeI.isMigratedMacroImplEnabled)((0, $8pcS0.EXTENSION_KEY).ATTACHMENTS)) implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bJaqz.AttachmentsMacroHandler), {
                    macroDefaultProps: macroDefaultProps,
                    macroParams: extension?.parameters?.macroParams
                });
                else implementation = legacyMacroRenderer;
                break;
            case 'blog-posts':
                if ((0, $ceVeI.isMigratedMacroImplEnabled)('blog-posts')) implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ClassicEditorContextProvider, {
                    isWithinEditor: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8XTa.BlogPostsExtensionHandler), {
                    ...macroDefaultProps,
                    macroParams: extension?.parameters?.macroParams,
                    Renderer: (0, $e8Lxy.PageContentRenderer),
                    appearance: "full-page"
                }));
                else implementation = legacyMacroRenderer;
                break;
            case 'recently-updated':
                if ((0, $ceVeI.isMigratedMacroImplEnabled)('recently-updated')) implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $n9ft3.RecentlyUpdatedMacroHandler), {
                    macroDefaultProps: macroDefaultProps,
                    macroParams: {
                        ...extension?.parameters?.macroParams,
                        currentSpaceKey: spaceKey
                    }
                });
                else implementation = legacyMacroRenderer;
                break;
            case 'profile-picture':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9m03g.ProfilePictureMacroHandler), {
                    macroDefaultProps: macroDefaultProps,
                    macroParams: extension?.parameters?.macroParams
                });
                break;
            case 'profile':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5a4cC.UserProfileMacroHandler), {
                    macroDefaultProps: macroDefaultProps,
                    macroParams: extension?.parameters?.macroParams
                });
                break;
            case 'include':
                if ((0, $ceVeI.isMigratedMacroImplEnabled)('include')) implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ClassicEditorContextProvider, {
                    isWithinEditor: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $18Eyu.PageIncludeExtensionHandler), {
                    ...macroDefaultProps,
                    macroParams: extension?.parameters?.macroParams,
                    Renderer: (0, $e8Lxy.PageContentRenderer),
                    appearance: "full-page"
                }));
                else implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ClassicEditorContextProvider, {
                    isWithinEditor: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fuLIO.LegacyMacroRendererQuery), macroDefaultProps));
                break;
            case 'livesearch':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJ5e.LiveSearchHandler), {
                    macroDefaultProps: macroDefaultProps
                });
                break;
            case 'questionslist-macro':
                implementation = legacyMacroRenderer;
                break;
            case 'questionslist-macro-native':
                implementation = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dgMPt.GlobalQuestionsListMacroHandler), {
                    macroDefaultProps: macroDefaultProps,
                    macroParams: extension?.parameters?.macroParams
                });
                break;
            case 'popular-labels':
                implementation = (0, $ceVeI.isMigratedMacroImplEnabled)('popular-labels') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bBRJy.PopularLabelsMacroHandler), {
                    macroDefaultProps: macroDefaultProps,
                    macroParams: {
                        ...extension?.parameters?.macroParams,
                        currentSpaceKey: spaceKey
                    }
                }) : legacyMacroRenderer;
                break;
            case 'contributors':
                implementation = (0, $ceVeI.isMigratedMacroImplEnabled)('contributors') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4EIU1.ContributorsMacroHandler), {
                    macroDefaultProps: macroDefaultProps,
                    macroParams: extension?.parameters?.macroParams
                }) : legacyMacroRenderer;
                break;
            case 'viewpdf':
                implementation = (0, $ceVeI.isMigratedMacroImplEnabled)('viewpdf') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $56y8A.ViewPdfMacroHandler), {
                    macroDefaultProps: macroDefaultProps,
                    macroParams: extension?.parameters?.macroParams
                }) : legacyMacroRenderer;
                break;
            case 'widget':
                implementation = (0, $ceVeI.isMigratedMacroImplEnabled)('widget') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aG1nm.WidgetMacroHandler), {
                    macroDefaultProps: macroDefaultProps,
                    macroParams: extension?.parameters?.macroParams
                }) : legacyMacroRenderer;
                break;
            case 'iframe':
                implementation = (0, $ceVeI.isMigratedMacroImplEnabled)('iframe') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9K8Oh.IFrameMacroRenderer), {
                    macroDefaultProps: macroDefaultProps,
                    macroParams: extension?.parameters?.macroParams
                }) : legacyMacroRenderer;
                break;
            case 'contentbylabel':
                implementation = (0, $ceVeI.isMigratedMacroImplEnabled)('contentbylabel') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ClassicEditorContextProvider, {
                    isWithinEditor: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2n2cE.ContentByLabelExtensionHandler), {
                    ...macroDefaultProps,
                    macroParams: extension?.parameters?.macroParams,
                    Renderer: (0, $e8Lxy.PageContentRenderer),
                    appearance: "full-page"
                })) : legacyMacroRenderer;
                break;
            case 'pagetreesearch':
                implementation = (0, $ceVeI.isMigratedMacroImplEnabled)('pagetreesearch') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hU8XU.PageTreeSearchMacroHandler), {
                    macroDefaultProps: macroDefaultProps,
                    macroParams: extension?.parameters?.macroParams
                }) : legacyMacroRenderer;
                break;
            case 'content-report-table':
                implementation = (0, $ceVeI.isMigratedMacroImplEnabled)('content-report-table') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jaHkh.ContentReportTableMacroHandler), {
                    macroDefaultProps: macroDefaultProps,
                    macroParams: {
                        ...extension?.parameters?.macroParams,
                        currentSpaceKey: spaceKey
                    }
                }) : legacyMacroRenderer;
                break;
            case 'tasks-report-macro':
                implementation = (0, $ceVeI.isMigratedMacroImplEnabled)('tasks-report-macro') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fxgwG.TasksReportMacroHandler), {
                    macroDefaultProps: macroDefaultProps,
                    macroParams: extension?.parameters?.macroParams
                }) : legacyMacroRenderer;
                break;
            case 'change-history':
                implementation = (0, $ceVeI.isMigratedMacroImplEnabled)('change-history') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $CbxlN.ChangeHistoryMacroHandler), {
                    macroDefaultProps: macroDefaultProps,
                    macroParams: extension?.parameters?.macroParams
                }) : legacyMacroRenderer;
                break;
            // generic macro renderer
            default:
                implementation = legacyMacroRenderer;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4KFTW.MacroExperienceStart), {
            name: (0, $5kjCz.getExperienceName)((0, $5kjCz.EDITOR), extension),
            contentId: contentId,
            mode: (0, $5kjCz.EDITOR),
            extensionKey: extensionKey,
            attributes: attributes,
            timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
        }), implementation);
    });
module.exports["getFullPageExtensionHandlers"] = $0e80447918933d7e$export$ea8f3f4f30a7109d;

});

parcelRegister("ceVeI", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");

const $c9f3102bc65ac225$export$2512ab5eef87236d = [
    'attachments',
    'blog-posts',
    'change-history',
    'content-report-table',
    'contributors',
    'detailssummary',
    'iframe',
    'include',
    'pagetree',
    'pagetreesearch',
    'profile',
    'profile-picture',
    'recently-updated',
    'viewpdf',
    'widget',
    'contentbylabel',
    'popular-labels',
    'tasks-report-macro'
];
const $c9f3102bc65ac225$var$getExperimentValue = (extensionKey)=>{
    switch(extensionKey){
        case 'blog-posts':
            return (0, $6mKj3.expValEquals)('cc_rewrite_blog_posts_legacy_macro', 'isEnabled', true);
        case 'content-report-table':
            return (0, $6mKj3.expValEquals)('cc_rewrite_content-report-table', 'isEnabled', true);
        case 'contentbylabel':
            return (0, $6mKj3.expValEquals)('cc_rewrite_contentbylabel_legacy_macro', 'isEnabled', true);
        case 'contributors':
            return (0, $6mKj3.expValEquals)('cc_rewrite_contributors_legacy_macro', 'isEnabled', true);
        case 'detailssummary':
        case 'profile':
        case 'profile-picture':
            return (0, $6mKj3.expValEquals)('cc_macro_full_ssr_support', 'isEnabled', true);
        case 'iframe':
            return (0, $6mKj3.expValEquals)('cc_rewrite_iframe_legacy_macro', 'isEnabled', true);
        case 'pagetree':
            return (0, $6mKj3.expValEquals)('cc_rewrite_pagetree_legacy_macro', 'isEnabled', true);
        case 'pagetreesearch':
            return (0, $6mKj3.expValEquals)('cc_rewrite_pagetree_search_legacy_macro', 'isEnabled', true);
        case 'popular-labels':
            return (0, $6mKj3.expValEquals)('cc_rewrite_popular_labels_legacy_macro', 'isEnabled', true);
        case 'recently-updated':
            return (0, $6mKj3.expValEquals)('cc_rewrite_recently_updated_legacy_macro', 'isEnabled', true);
        case 'viewpdf':
            return (0, $6mKj3.expValEquals)('cc_rewrite_viewpdf_macro', 'isEnabled', true);
        case 'widget':
            return (0, $6mKj3.expValEquals)('cc_rewrite_widget_legacy_macro', 'isEnabled', true);
        case 'attachments':
            return (0, $6mKj3.expValEquals)('cc_rewrite_attachments_legacy_macro', 'isEnabled', true);
        case 'include':
            return (0, $6mKj3.expValEquals)('cc_rewrite_page_include_legacy_macro', 'isEnabled', true);
        case 'tasks-report-macro':
            return (0, $6mKj3.expValEquals)('cc_rewrite_tasks_report_macro', 'isEnabled', true);
        case 'change-history':
            return (0, $6mKj3.expValEquals)('cc_rewrite_change_history_legacy_macro', 'isEnabled', true);
        default:
            return false;
    }
};
const $c9f3102bc65ac225$var$isMigratedMacroExtensionKey = (key)=>$c9f3102bc65ac225$export$2512ab5eef87236d.includes(key);
const $c9f3102bc65ac225$export$95a5e4cb1c9fae51 = (extensionKey)=>{
    const overrideList = (0, $1xpoY.default).getStringList('cc_macro_override_to_legacy_renderer', []);
    if (overrideList.includes(extensionKey)) return false;
    if (!$c9f3102bc65ac225$var$isMigratedMacroExtensionKey(extensionKey)) return false;
    return $c9f3102bc65ac225$var$getExperimentValue(extensionKey);
};
module.exports["MIGRATED_MACRO_EXTENSION_KEYS"] = $c9f3102bc65ac225$export$2512ab5eef87236d;
module.exports["isMigratedMacroImplEnabled"] = $c9f3102bc65ac225$export$95a5e4cb1c9fae51;

});

parcelRegister("5kjCz", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $irVI7 = parcelRequire("irVI7");


var $glCMv = parcelRequire("glCMv");


var $fGzMp = parcelRequire("fGzMp");


var $kmyYx = parcelRequire("kmyYx");


var $aJPUt = parcelRequire("aJPUt");


var $04e9M = parcelRequire("04e9M");


var $78QFu = parcelRequire("78QFu");


var $9Cbhx = parcelRequire("9Cbhx");

const $44f37a86f8c1409e$export$c3c3c3f81a03570c = 'renderer';
const $44f37a86f8c1409e$export$e70b8cd540123fd4 = 'editor';
const $44f37a86f8c1409e$export$f783453b83c906eb = 'pdf';
const $44f37a86f8c1409e$var$ACTION = {
    SUCCESS: 'taskSuccess',
    FAIL: 'taskFail',
    ABORT: 'taskAbort',
    START: 'taskStart'
};
const $44f37a86f8c1409e$export$84a4de0ef6621278 = (name)=>name.split('.').slice(1).join('.');
const $44f37a86f8c1409e$export$b94fa6ed199caed2 = (macroEventRegister = new Map())=>{
    const macros = [];
    // @ts-ignore
    for (const v of macroEventRegister.values()){
        const { name: name } = v;
        if (name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) {
            const macro = {
                uniqueHash: $44f37a86f8c1409e$export$84a4de0ef6621278(name),
                ...$44f37a86f8c1409e$export$ae13022b12e7d19a(v)
            };
            macros.push(macro);
        }
    }
    return macros;
};
const $44f37a86f8c1409e$export$c1196ba2be68e8d3 = (macro)=>{
    return {
        type: macro?.type || '',
        macroId: (0, $9Cbhx.getMacroId)(macro?.parameters),
        extensionKey: (0, $9Cbhx.getExtensionKey)(macro),
        extensionType: macro?.extensionType || ''
    };
};
const $44f37a86f8c1409e$export$ae13022b12e7d19a = (macroEvent)=>{
    return {
        extensionKey: (0, $9Cbhx.getExtensionKey)(macroEvent?.experienceAttributes),
        extensionType: macroEvent?.experienceAttributes?.extensionType || '',
        type: macroEvent?.experienceAttributes?.type || '',
        macroId: macroEvent?.experienceAttributes?.macroId || '',
        duration: macroEvent?.duration || '',
        status: macroEvent?.status || '',
        pageId: macroEvent?.pageId || ''
    };
};
const $44f37a86f8c1409e$export$b16b3cab64ff0bd4 = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) return;
    $44f37a86f8c1409e$export$f7c63e38d5d9fd0b(mode, contentId).start({
        attributes: {
            mode: mode
        },
        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
        id: contentId
    });
};
const $44f37a86f8c1409e$export$f9ebd83e8406755f = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) {
        if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister)) {
            const macroAttributes = {
                mode: mode,
                macros: null
            };
            if ($44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) macroAttributes.macros = $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister);
            (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    ...macroAttributes
                }
            });
        } else (0, $fGzMp.getExperienceTracker)().abort({
            name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
            reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
            attributes: {
                macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                mode: mode
            }
        });
        const jiraMacro = $44f37a86f8c1409e$export$32db3a6a0c8b81ea(macroEventRegister);
        jiraMacro.forEach((macro)=>{
            const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
            const status = macro.status;
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: status,
                    attributes: {
                        ...macro.experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`
                    }
                });
            });
        });
        // clean up after aborting all event
        macroEventRegister.clear();
        $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
    }
};
const $44f37a86f8c1409e$export$d693932e457c5586 = (eventRegister = new Map())=>{
    if (eventRegister.size === 0) return true;
    // only check whether all sub-experience has finished
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) return false;
    }
    return true;
};
const $44f37a86f8c1409e$export$375cf77d729480fb = (eventRegister = new Map())=>{
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) return true;
    }
    return false;
};
const $44f37a86f8c1409e$export$faf154bb66b40b64 = (name)=>name.includes((0, $9Cbhx.JIRA_EXTENSION_KEY));
const $44f37a86f8c1409e$export$f2ada44de4a33ea1 = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$32db3a6a0c8b81ea = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name)) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$98d7b4463a1de442 = (contentId, mode)=>{
    (function macroTimeout() {
        setTimeout(()=>{
            const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
            if (!macroEventRegister.has(contentId)) return;
            const pageEvent = macroEventRegister.get(contentId);
            const isTimedOut = Math.round(window.performance.now() - pageEvent.startTime) > (0, $aJPUt.ExperienceTimeout).MACRO_LOAD;
            // 1. all macro loaded or main-experience timeout and have sub-experience
            //    succeed the main experience and report to experience tracker and done
            if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister) && $44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            else if (isTimedOut) {
                // 2a. timeout does not has sub-experience, succeed the main experience
                if (!$44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                    name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                    attributes: {
                        mode: mode
                    }
                });
                else {
                    (0, $fGzMp.getExperienceTracker)().abort({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
                        attributes: {
                            macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                            mode: mode
                        }
                    });
                    const unsuceededJIRAMacro = $44f37a86f8c1409e$export$f2ada44de4a33ea1(macroEventRegister);
                    unsuceededJIRAMacro.forEach((macro)=>{
                        const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
                        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                            analyticsWebClient.sendOperationalEvent({
                                source: 'ui',
                                actionSubject: 'macroTracker',
                                action: 'taskAbort',
                                attributes: {
                                    ...macro.experienceAttributes,
                                    extensionKey: extensionKey,
                                    mode: mode,
                                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                                    reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                                }
                            });
                        });
                    });
                }
                // clean up after aborting all event
                macroEventRegister.clear();
                $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            } else macroTimeout();
        }, 2000);
    })();
};
const $44f37a86f8c1409e$var$macroEventRegisterHash = new Map();
const $44f37a86f8c1409e$export$adf8cb42c7fe1834 = (mode, contentId)=>{
    if ($44f37a86f8c1409e$var$macroEventRegisterHash.has(`${mode}.${contentId}`)) return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, new Map());
    return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
};
const $44f37a86f8c1409e$export$d7fca4196d2b6b6c = (mode, contentId, name, experienceAttributes)=>{
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
            analyticsWebClient.sendOperationalEvent({
                source: 'ui',
                actionSubject: 'macroTracker',
                action: 'taskStart',
                attributes: {
                    ...experienceAttributes,
                    extensionKey: extensionKey,
                    mode: mode,
                    pageId: contentId,
                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            });
        });
    }
};
const $44f37a86f8c1409e$export$d10b6dded8392899 = (mode, contentId, name, experienceAttributes)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    const macroId = experienceAttributes?.macroId;
    if (!macroEventRegister.has(macroId)) return;
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        const { status: status } = macroEventRegister.get(macroId);
        if (status === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskSuccess',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.ABORT) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskAbort',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.FAIL) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskFail',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        error: new (0, $glCMv.ExperienceTimeoutError)(`JIRA macro failed to complete in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`)
                    }
                });
            });
        }
    }
};
const $44f37a86f8c1409e$export$f7c63e38d5d9fd0b = (0, $dOBRD.default)((mode, contentId)=>{
    const macroTracker = new (0, $kmyYx.ExperienceTracker)();
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    macroTracker.subscribe((event)=>{
        const { action: action, name: name, attributes: experienceAttributes, ...rest } = event;
        const macroId = experienceAttributes?.macroId;
        if (action === $44f37a86f8c1409e$var$ACTION.START) {
            // prevent triggering of event
            const current = macroEventRegister.get(macroId);
            if (current && current.id === macroId) return;
            if (name === (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) // prevent firing the same view-all-macro more than once
            {
                if (!macroEventRegister.has(contentId)) {
                    // clear the event register, prevent event being re-tracked between SPA transition
                    macroEventRegister.clear();
                    (0, $fGzMp.getExperienceTracker)().start({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
                        id: contentId,
                        attributes: {
                            mode: mode
                        }
                    });
                    macroEventRegister.set(contentId, {
                        status: $44f37a86f8c1409e$var$ACTION.START,
                        name: name,
                        mode: mode,
                        ...rest
                    });
                    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
                }
            } else {
                // tracking each macro, report to MacroTracker
                macroEventRegister.set(macroId, {
                    status: $44f37a86f8c1409e$var$ACTION.START,
                    name: name,
                    experienceAttributes: {
                        ...experienceAttributes,
                        extensionKey: (0, $9Cbhx.getExtensionKey)(experienceAttributes)
                    },
                    pageId: contentId,
                    mode: mode,
                    ...rest
                });
                $44f37a86f8c1409e$export$d7fca4196d2b6b6c(mode, contentId, name, experienceAttributes);
            }
        } else if (action === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, name: name } = event;
            // tracking each macro when it successfully loads
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.SUCCESS,
                duration: duration,
                pageId: contentId
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action === $44f37a86f8c1409e$var$ACTION.ABORT) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, reason: reason, name: name } = event;
            // tracking each macro when it aborts loading
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.ABORT,
                duration: duration,
                pageId: contentId,
                reason: reason
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro aborts to load, aborts the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().abort({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                reason: 'Macro abort loading',
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action == $44f37a86f8c1409e$var$ACTION.FAIL) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, error: error, name: name } = event;
            // tracking each macro when it fails to load
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.FAIL,
                duration: duration,
                pageId: contentId,
                error: error
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro fails to load, fails the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().fail({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                error: error,
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode,
                    ...experienceAttributes
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        }
        $44f37a86f8c1409e$export$98d7b4463a1de442(contentId, mode);
    });
    return macroTracker;
});
const $44f37a86f8c1409e$export$4ce0bedef4e84bb7 = (mode, extension)=>{
    const attributes = $44f37a86f8c1409e$export$c1196ba2be68e8d3(extension);
    return `${mode}.${(0, $9Cbhx.getExtensionKey)(attributes)}.${attributes.macroId}`;
};
module.exports["RENDERER"] = $44f37a86f8c1409e$export$c3c3c3f81a03570c;
module.exports["EDITOR"] = $44f37a86f8c1409e$export$e70b8cd540123fd4;
module.exports["PDF"] = $44f37a86f8c1409e$export$f783453b83c906eb;
module.exports["getMacroAttributesFromADFNode"] = $44f37a86f8c1409e$export$c1196ba2be68e8d3;
module.exports["startMacroExperience"] = $44f37a86f8c1409e$export$b16b3cab64ff0bd4;
module.exports["getMacroExperienceTracker"] = $44f37a86f8c1409e$export$f7c63e38d5d9fd0b;
module.exports["stopMacroExperience"] = $44f37a86f8c1409e$export$f9ebd83e8406755f;
module.exports["stopJIRAMacro"] = $44f37a86f8c1409e$export$d10b6dded8392899;
module.exports["getExperienceName"] = $44f37a86f8c1409e$export$4ce0bedef4e84bb7;

});

parcelRegister("9Cbhx", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $hukUK = parcelRequire("hukUK");

const $9293ebd9645c82d6$export$7486394da5136452 = 'jira';
const $9293ebd9645c82d6$export$8d178e7efa3ed0e7 = 'issue-count';
const $9293ebd9645c82d6$export$c3f023baaa9b214b = 'table-view';
const $9293ebd9645c82d6$export$7d601f5ae4a82040 = 'single-issue';
const $9293ebd9645c82d6$export$47eae2202f029f6b = (parameters)=>{
    if (!parameters) return (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
    const idFromNode = parameters?.macroMetadata?.macroId?.value;
    if (idFromNode) return idFromNode;
    // for macro that does not have unique macro id, we want to generate some unique id
    return (0, $hukUK.objectHash)(parameters);
};
const $9293ebd9645c82d6$export$218d96312e385949 = (attributes)=>{
    if (!attributes) return '';
    const { extensionKey: extensionKey } = attributes;
    const macroParams = attributes?.parameters?.macroParams;
    if (extensionKey === $9293ebd9645c82d6$export$7486394da5136452) return `${extensionKey}${$9293ebd9645c82d6$export$cc2f094f034c7f8f(macroParams)}`;
    return extensionKey;
};
const $9293ebd9645c82d6$export$cc2f094f034c7f8f = (macroParams)=>{
    const prefix = '-';
    if (macroParams?.count?.value === 'true') return prefix + $9293ebd9645c82d6$export$8d178e7efa3ed0e7;
    else if (macroParams?.columns && macroParams?.maximumIssues) return prefix + $9293ebd9645c82d6$export$c3f023baaa9b214b;
    else if (macroParams?.key?.value) return prefix + $9293ebd9645c82d6$export$7d601f5ae4a82040;
    return '';
};
module.exports["JIRA_EXTENSION_KEY"] = $9293ebd9645c82d6$export$7486394da5136452;
module.exports["getMacroId"] = $9293ebd9645c82d6$export$47eae2202f029f6b;
module.exports["getExtensionKey"] = $9293ebd9645c82d6$export$218d96312e385949;

});

parcelRegister("4KFTW", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $38a1fdadc870189c$export$ed05b2901e9d7d22({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name, timeout: timeout }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).start({
            attributes: attributes,
            name: name,
            timeout: timeout,
            id: attributes?.macroId || contentId
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name,
        timeout
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceStart"] = $38a1fdadc870189c$export$ed05b2901e9d7d22;

});

parcelRegister("2bAZx", function(module, exports) {
// inspired by https://github.com/kentcdodds/use-deep-compare-effect/blob/master/src/index.js
/* eslint react-hooks/exhaustive-deps: 0 */ //Todo: this is flawed because callback is not included in the dependency array generated by useDeepCompareMemoize
// if the callback function (all use cases I found were inline functions and therfore not passed as a ref, were passes to the dep array they would trigger a re-evaluation every render defeating the purpose
// in order to properly work and handle the callback function being changed, the callback argument must be a useCallback or other function passed by ref and have it be included in the memoized depenedency array

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");

function $a4fa77695d2683a4$export$db77f469fe79526e(callback, dependencies) {
    (0, $cozmU.useEffect)(callback, $a4fa77695d2683a4$var$useDeepCompareMemoize(dependencies));
}
//eslint-ignore react-hooks/exhaustive-deps
function $a4fa77695d2683a4$var$useDeepCompareMemoize(value) {
    const ref = (0, $cozmU.useRef)();
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(value, ref.current)) ref.current = value;
    return ref.current;
}
module.exports["useDeepCompareEffect"] = $a4fa77695d2683a4$export$db77f469fe79526e;

});

parcelRegister("e1Stz", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $36f7db2a9cac59c0$export$7cf7439e5d7797c5 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ymRP0",
    name: "PagePropertiesReportRenderer",
    loader: async ()=>(await (parcelRequire("8QCt0"))).PagePropertiesReportRenderer
});
module.exports["PagePropertiesReportRenderer"] = $36f7db2a9cac59c0$export$7cf7439e5d7797c5;

});

parcelRegister("8QCt0", function(module, exports) {

let $671104c8ed68652b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $671104c8ed68652b$var$load("ilUG7"),
    $671104c8ed68652b$var$load("efUj2"),
    $671104c8ed68652b$var$load("ddvkk"),
    $671104c8ed68652b$var$load("3upHR"),
    $671104c8ed68652b$var$load("iUXaE"),
    $671104c8ed68652b$var$load("lTkx9"),
    $671104c8ed68652b$var$load("6wr18"),
    $671104c8ed68652b$var$load("hhss7"),
    $671104c8ed68652b$var$load("ffEVr"),
    $671104c8ed68652b$var$load("dnwTC")
]).then(()=>parcelRequire('3Jp28'));

});

parcelRegister("6aEhm", function(module, exports) {
/* AnchorMacroRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kTb7m = parcelRequire("kTb7m");


var $ixfCV = parcelRequire("ixfCV");


var $9tVje = parcelRequire("9tVje");

const $0c2b5b61ad0a1759$var$i18n = (0, $kSwu1.defineMessages)({
    anchorMacroLabel: {
        id: "fabric-extension-handlers.inline-extension.valid-anchor-macro.icon.label",
        defaultMessage: "Anchor link"
    }
});
const $0c2b5b61ad0a1759$var$highlightAnimation = null;
const $0c2b5b61ad0a1759$var$animationStyles = null;
const $0c2b5b61ad0a1759$var$macroWrapperStyles = null;
const $0c2b5b61ad0a1759$export$16f5c11d6d7adab1 = (props)=>{
    const intl = (0, $kSwu1.useIntl)();
    const [shouldPlayHighlightAnimation, setShouldPlayHighlightAnimation] = (0, $cozmU.useState)(false);
    const [isMacroVisible, setIsMacroVisible] = (0, $cozmU.useState)(false);
    const macroRef = (0, $cozmU.useRef)(null);
    const rawAnchorName = props?.node?.parameters?.macroParams[''].value; // Normalize TinyMCE-era anchor names: strip spaces to match legacy URL format.
    let anchorName = rawAnchorName;
    if (typeof rawAnchorName === 'string' && (0, $ixfCV.fg)('platform_editor_anchor_spaces_normalization')) anchorName = rawAnchorName.replaceAll(/\s+/g, '');
    let anchorValid = true;
    if (!anchorName || anchorName.includes(' ')) anchorValid = false;
    if (anchorValid) try {
        decodeURIComponent(anchorName);
    } catch  {
        anchorValid = false;
    }
    (0, $cozmU.useEffect)(()=>{
        setShouldPlayHighlightAnimation(anchorValid && window.location.hash === `#${anchorName}`);
        const handleOnHashChange = ()=>{
            setIsMacroVisible(false);
            setShouldPlayHighlightAnimation(anchorValid && window.location.hash === `#${anchorName}`);
        }; // There is a case where a url hash change occurs but does not reload the page.
        // To account for this, so we can still trigger the animation as expected when
        // the related anchor is scrolled to, we need to listen to the event.
        window.addEventListener('hashchange', handleOnHashChange);
        return ()=>{
            window.removeEventListener('hashchange', handleOnHashChange);
        };
    }, [
        anchorName,
        anchorValid,
        setShouldPlayHighlightAnimation
    ]);
    (0, $cozmU.useEffect)(()=>{
        {
            /**
       * IntersectionObserver doesn't work for SSR pages.
       * Escaped using process.env.REACT_SSR above, per rule,
       * and silenced eslint warning safely below.
       */ // eslint-disable-next-line
            const observer = new IntersectionObserver(([entry])=>{
                if (!isMacroVisible) setIsMacroVisible(entry.isIntersecting);
            }, {
                threshold: 1.0
            });
            if (macroRef?.current) observer.observe(macroRef.current);
             // Remove the observer as soon as the component is unmounted
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        isMacroVisible,
        setIsMacroVisible,
        macroRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: macroRef,
        id: anchorValid ? anchorName : undefined,
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _2rko12b0 _1e0c1txw _1bah1h6o _4cvr1h6o _bfhki8nm _1bsb1tcg _4t3igktf _vchhusvi",
            shouldPlayHighlightAnimation && isMacroVisible && "",
            shouldPlayHighlightAnimation && isMacroVisible && "_y44vwhg8"
        ])
    }, anchorValid ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
        label: intl.formatMessage($0c2b5b61ad0a1759$var$i18n.anchorMacroLabel),
        color: "var(--ds-icon-subtle, #505258)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9tVje.AnchorMacroPlaceholder), null));
};
module.exports["AnchorMacroRenderer"] = $0c2b5b61ad0a1759$export$16f5c11d6d7adab1;

});

parcelRegister("ahrsq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5kjCz = parcelRequire("5kjCz");


var $bX5uj = parcelRequire("bX5uj");


var $cYJC5 = parcelRequire("cYJC5");


var $bQm3c = parcelRequire("bQm3c");

const $78b48bb386aef67d$export$a6c71275c6598127 = ({ ...macroDefaultProps })=>{
    const { contentId: contentId, extensionKey: extensionKey, node: node, mode: mode } = macroDefaultProps;
    const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cYJC5.CreateFromTemplateLoader), {
        userId: userId || '',
        cloudId: cloudId,
        macroDefaultProps: macroDefaultProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: (0, $5kjCz.getExperienceName)(mode, node),
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes
    }));
};
module.exports["CreateFromTemplate"] = $78b48bb386aef67d$export$a6c71275c6598127;

});

parcelRegister("bX5uj", function(module, exports) {

var $5kjCz = parcelRequire("5kjCz");


var $2bAZx = parcelRequire("2bAZx");

function $b23c2b4e39153eb4$export$3462df5a881e125d({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: name,
            attributes: attributes
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceSuccess"] = $b23c2b4e39153eb4$export$3462df5a881e125d;

});

parcelRegister("8jP8e", function(module, exports) {
/* TableOfContentsLiveComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $55fM8 = parcelRequire("55fM8");


var $3xuv0 = parcelRequire("3xuv0");


var $1KOhB = parcelRequire("1KOhB");


var $lfoFx = parcelRequire("lfoFx");


var $kDhla = parcelRequire("kDhla");


var $fDdWw = parcelRequire("fDdWw");


var $dwS6P = parcelRequire("dwS6P");


var $bQm3c = parcelRequire("bQm3c");


var $djaPL = parcelRequire("djaPL");

const $57df12aecf845afb$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt41ajq _bfhksm61",
            __cmplp.className
        ])
    });
});
const $57df12aecf845afb$var$Centered = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $57df12aecf845afb$export$7345e257c3f26650 = ({ macroDefaultProps: macroDefaultProps, editorActions: editorActions, subscribeDocChange: subscribeDocChange, unsubscribeDocChange: unsubscribeDocChange, isCollabEditForLiveUpdatesEnabled: isCollabEditForLiveUpdatesEnabled })=>{
    const [isInitialLoadComplete, setIsInitialLoadComplete] = (0, $cozmU.useState)(false);
    const [adf, setAdf] = (0, $cozmU.useState)();
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const debounceMs = 400;
    const previousRemoteChangeTimeRef = (0, $cozmU.useRef)(undefined);
    const previousLocalChangeTimeRef = (0, $cozmU.useRef)(undefined);
    const previousADF = (0, $cozmU.useRef)();
    // Provided by the LCM extension-handler when this ToC is rendered inside a Legacy Content Macro.
    // When inside an LCM, editorActions is scoped to the LCM's nested editor and therefore only shows headings within the LCM.
    // Use the outerEditorView to show all page headings in this case.
    // outerEditorView be undefined when rendered outside an LCM so we'll use normal editorActions in this case.
    const outerEditorView = (0, $cozmU.useContext)((0, $djaPL.OuterEditorViewContext));
    const getEffectiveEditorView = (0, $cozmU.useCallback)(()=>{
        return outerEditorView ?? editorActions._privateGetEditorView();
    }, [
        outerEditorView,
        editorActions
    ]);
    const updateAdf = (0, $cozmU.useCallback)((editorView)=>{
        const effectiveView = outerEditorView ?? editorView;
        const doc = effectiveView?.state?.doc;
        if (doc) {
            const editorTransformer = new (0, $3xuv0.JSONTransformer)();
            const _adf = editorTransformer.encode(doc);
            if (isCollabEditForLiveUpdatesEnabled) {
                const shouldUpdateADF = previousADF.current ? !(0, $fDdWw.checkIsEqual)(previousADF.current, _adf) : true;
                previousADF.current = _adf;
                if (shouldUpdateADF) setAdf(_adf);
            } else setAdf(_adf);
        }
    }, [
        isCollabEditForLiveUpdatesEnabled,
        outerEditorView
    ]);
    const { fullPageEditorPresetAPI: fullPageEditorPresetAPI } = (0, $kDhla.useFullPageEditorApiState)();
    const debouncedUpdateADF = (0, $cozmU.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
            updateAdf(getEffectiveEditorView());
        }, debounceMs), [
        getEffectiveEditorView,
        updateAdf
    ]);
    (0, $1KOhB.usePluginStateEffect)(fullPageEditorPresetAPI, [
        'collabEdit'
    ], ({ collabEditState: collabEditState })=>{
        const lastRemoteChangeTime = collabEditState?.initialised?.lastRemoteOrganicBodyChangeAt;
        const lastLocalChangeTime = collabEditState?.initialised?.lastLocalOrganicBodyChangeAt;
        const hasRemoteChanged = lastRemoteChangeTime && lastRemoteChangeTime !== previousRemoteChangeTimeRef.current;
        const hasLocalChanged = lastLocalChangeTime && lastLocalChangeTime !== previousLocalChangeTimeRef.current;
        if (hasRemoteChanged || hasLocalChanged) {
            previousRemoteChangeTimeRef.current = lastRemoteChangeTime;
            previousLocalChangeTimeRef.current = lastLocalChangeTime;
            if (isCollabEditForLiveUpdatesEnabled) debouncedUpdateADF();
        }
    });
    (0, $cozmU.useEffect)(()=>{
        const debouncedHandleDocChange = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(updateAdf, debounceMs);
        if (!isCollabEditForLiveUpdatesEnabled) subscribeDocChange(debouncedHandleDocChange);
        return ()=>{
            if (!isCollabEditForLiveUpdatesEnabled) unsubscribeDocChange(debouncedHandleDocChange);
        };
    }, [
        subscribeDocChange,
        unsubscribeDocChange,
        debounceMs,
        updateAdf,
        isCollabEditForLiveUpdatesEnabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Ideally we would rely on the doc change handler to populate the ADF
        // but the doc change handler is sometimes not called on initial load.
        updateAdf(getEffectiveEditorView());
        setIsInitialLoadComplete(true);
    }, [
        getEffectiveEditorView,
        updateAdf
    ]);
    if (!isInitialLoadComplete) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($57df12aecf845afb$var$Centered, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        interactionName: "table-of-contents-live-component"
    }));
    else if (!adf) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($57df12aecf845afb$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dwS6P.TableOfContentsLoader), {
        isInEditMode: true,
        userId: userId ?? '',
        cloudId: cloudId ?? '',
        adf: adf,
        macroDefaultProps: macroDefaultProps
    }));
};
module.exports["TableOfContentsLiveComponent"] = $57df12aecf845afb$export$7345e257c3f26650;

});

parcelRegister("fDdWw", function(module, exports) {

var $3u5lg = parcelRequire("3u5lg");


var $jTt8P = parcelRequire("jTt8P");

const $b1a5d5594ebd3d9f$export$b502f7a77e1faf1e = (prevADF, nextADF)=>{
    const prevHeadings = [];
    const nextHeadings = [];
    // Go through the ADF and push any headings
    // to a new array
    (0, $jTt8P.traverse)(prevADF || {}, {
        heading: (node)=>{
            prevHeadings.push(node);
        }
    });
    (0, $jTt8P.traverse)(nextADF || {}, {
        heading: (node)=>{
            nextHeadings.push(node);
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(prevHeadings, nextHeadings);
};
module.exports["checkIsEqual"] = $b1a5d5594ebd3d9f$export$b502f7a77e1faf1e;

});

parcelRegister("dwS6P", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f07e1d0389c2db40$export$4b3001e460e8e078 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "CSP7X",
    name: "TableOfContentsLoader",
    loader: async ()=>(await (parcelRequire("jxfTL"))).TableOfContents
});

const $f07e1d0389c2db40$export$fa76cea84aad7618 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "JVXm_",
    name: "LazyTableOfContentsLoader",
    loader: async ()=>(await (parcelRequire("jxfTL"))).TableOfContents
});
module.exports["TableOfContentsLoader"] = $f07e1d0389c2db40$export$4b3001e460e8e078;
module.exports["LazyTableOfContentsLoader"] = $f07e1d0389c2db40$export$fa76cea84aad7618;

});

parcelRegister("jxfTL", function(module, exports) {

let $e38d6e76494f40a8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e38d6e76494f40a8$var$load("he34V"),
    $e38d6e76494f40a8$var$load("79Tk4"),
    $e38d6e76494f40a8$var$load("hZ2FX"),
    $e38d6e76494f40a8$var$load("lbsQO"),
    $e38d6e76494f40a8$var$load("ayJxT"),
    $e38d6e76494f40a8$var$load("hhss7"),
    $e38d6e76494f40a8$var$load("jjWia")
]).then(()=>parcelRequire('c8BWz'));

});

parcelRegister("djaPL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $606d3debb709f372$export$d7ea9fce87103426 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
module.exports["OuterEditorViewContext"] = $606d3debb709f372$export$d7ea9fce87103426;

});

parcelRegister("kvJ5e", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $l7BGZ = parcelRequire("l7BGZ");


var $5kjCz = parcelRequire("5kjCz");


var $bX5uj = parcelRequire("bX5uj");


var $6mEZ3 = parcelRequire("6mEZ3");

const $638330f188c4cca8$export$e8ac5007ab7a695a = ({ macroDefaultProps: macroDefaultProps })=>{
    const { contentId: contentId, extensionKey: extensionKey, node: node, mode: mode } = macroDefaultProps;
    const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l7BGZ.LiveSearchLoader), {
        macroNode: (0, $6mEZ3.extensionToADF)(node)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: (0, $5kjCz.getExperienceName)(mode, node),
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes
    }));
};
module.exports["LiveSearchHandler"] = $638330f188c4cca8$export$e8ac5007ab7a695a;

});

parcelRegister("l7BGZ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $076f2e82bb035170$export$b5586d12ffc2e1b = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Qw8xt",
    name: "LiveSearchLoader",
    loader: async ()=>(await (parcelRequire("8uvBl"))).LiveSearch
});

const $076f2e82bb035170$export$e7e4bc50f3fd132e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cgOQy",
    name: "LazyLiveSearchLoader",
    loader: async ()=>(await (parcelRequire("8uvBl"))).LiveSearch
});
module.exports["LiveSearchLoader"] = $076f2e82bb035170$export$b5586d12ffc2e1b;
module.exports["LazyLiveSearchLoader"] = $076f2e82bb035170$export$e7e4bc50f3fd132e;

});

parcelRegister("8uvBl", function(module, exports) {

let $62e9a37237cc07ce$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $62e9a37237cc07ce$var$load("iUXaE"),
    $62e9a37237cc07ce$var$load("lTkx9"),
    $62e9a37237cc07ce$var$load("6wr18"),
    $62e9a37237cc07ce$var$load("jYRaq"),
    $62e9a37237cc07ce$var$load("7G12e"),
    $62e9a37237cc07ce$var$load("io0qR"),
    $62e9a37237cc07ce$var$load("ffEVr"),
    $62e9a37237cc07ce$var$load("Wowvf"),
    $62e9a37237cc07ce$var$load("eRhBr"),
    $62e9a37237cc07ce$var$load("7EorR"),
    $62e9a37237cc07ce$var$load("hhss7"),
    $62e9a37237cc07ce$var$load("2IX0x")
]).then(()=>parcelRequire('jF1MT'));

});

parcelRegister("a7SsH", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $92a679059989a896$export$fb999f8a83c64817 = /*#__PURE__*/ function(NotificationAction) {
    NotificationAction["NOTIFY"] = "NOTIFY";
    NotificationAction["DONT_NOTIFY"] = "DONT_NOTIFY";
    return NotificationAction;
}({});
module.exports["NotificationAction"] = $92a679059989a896$export$fb999f8a83c64817;

});

parcelRegister("hdxAi", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $2d2e882c9a90b3be$var$getInitialState = ()=>({
        deletedMentions: [],
        addedMentions: [],
        deletedTasks: [],
        addedTasks: [],
        unrestrictedMentions: [],
        //Added mentions which have access to the current page
        parentSpaceRestrictedMentions: [],
        //Added mentions which dont have access to the current page due to parent or space restrictions
        pageRestrictedMentions: [],
        //Added mentions which dont have access to the current page due to page restrictions
        unrestrictedTasks: [],
        //Added task mentions which have access to the current page
        parentSpaceRestrictedTasks: [],
        //Added task mentions which dont have access to the current page due to parent or space restrictions
        pageRestrictedTasks: [],
        //Added task mentions which dont have access to the current page due to page restrictions
        editorApi: undefined,
        mentionsAdded: {
            currentUser: [],
            //Mentions of current user added by the current user
            otherUsers: [] //Mentions of other users added by the current user
        },
        tasksAdded: {
            currentUser: [],
            //Task mentions of current user added by the current user
            otherUsers: [] //Task mentions of other users added by the current user
        }
    });
const $2d2e882c9a90b3be$var$actions = {
    setDeletedMentions: (mentions)=>({ setState: setState })=>{
            setState({
                deletedMentions: mentions
            });
        },
    setAddedMentions: (mentions)=>({ setState: setState })=>{
            setState({
                addedMentions: mentions
            });
        },
    setUnrestrictedMentions: (mentions)=>({ setState: setState })=>{
            setState({
                unrestrictedMentions: mentions
            });
        },
    addUnrestrictedMentions: (addedUnrestrictedMentions)=>({ setState: setState, getState: getState })=>{
            const { unrestrictedMentions: unrestrictedMentions } = getState();
            const updatedUnrestrictedMentions = [
                ...unrestrictedMentions,
                ...addedUnrestrictedMentions
            ];
            setState({
                unrestrictedMentions: updatedUnrestrictedMentions
            });
        },
    removeUnrestrictedMentions: (removedUnrestrictedMention)=>({ setState: setState, getState: getState })=>{
            const removedLocalIds = new Set(removedUnrestrictedMention.map((mention)=>mention.localId));
            const { unrestrictedMentions: unrestrictedMentions } = getState();
            const updatedUnrestrictedMentions = unrestrictedMentions.filter((mention)=>!removedLocalIds.has(mention.localId));
            setState({
                unrestrictedMentions: updatedUnrestrictedMentions
            });
        },
    setParentSpaceRestrictedMentions: (mentions)=>({ setState: setState })=>{
            setState({
                parentSpaceRestrictedMentions: mentions
            });
        },
    addParentSpaceRestrictedMentions: (addedParentSpaceRestrictedMentions)=>({ setState: setState, getState: getState })=>{
            const { parentSpaceRestrictedMentions: parentSpaceRestrictedMentions } = getState();
            const updatedParentSpaceRestrictedMentions = [
                ...parentSpaceRestrictedMentions,
                ...addedParentSpaceRestrictedMentions
            ];
            setState({
                parentSpaceRestrictedMentions: updatedParentSpaceRestrictedMentions
            });
        },
    removeParentSpaceRestrictedMentions: (removedParentSpaceRestrictedMentions)=>({ setState: setState, getState: getState })=>{
            const removedLocalIds = new Set(removedParentSpaceRestrictedMentions.map((mention)=>mention.localId));
            const { parentSpaceRestrictedMentions: parentSpaceRestrictedMentions } = getState();
            const updatedParentSpaceRestrictedMentions = parentSpaceRestrictedMentions.filter((mention)=>!removedLocalIds.has(mention.localId));
            setState({
                parentSpaceRestrictedMentions: updatedParentSpaceRestrictedMentions
            });
        },
    setPageRestrictedMentions: (mentions)=>({ setState: setState })=>{
            setState({
                pageRestrictedMentions: mentions
            });
        },
    addPageRestrictedMentions: (addedPageRestrictedMentions)=>({ setState: setState, getState: getState })=>{
            const { pageRestrictedMentions: pageRestrictedMentions } = getState();
            const updatedPageRestrictedMention = [
                ...pageRestrictedMentions,
                ...addedPageRestrictedMentions
            ];
            setState({
                pageRestrictedMentions: updatedPageRestrictedMention
            });
        },
    removePageRestrictedMentions: (removedPageRestrictedMentions)=>({ setState: setState, getState: getState })=>{
            const removedLocalIds = new Set(removedPageRestrictedMentions.map((mention)=>mention.localId));
            const { pageRestrictedMentions: pageRestrictedMentions } = getState();
            const updatedPageRestrictedMention = pageRestrictedMentions.filter((mention)=>!removedLocalIds.has(mention.localId));
            setState({
                pageRestrictedMentions: updatedPageRestrictedMention
            });
        },
    setDeletedTasks: (tasks)=>({ setState: setState })=>{
            setState({
                deletedTasks: tasks
            });
        },
    setAddedTasks: (tasks)=>({ setState: setState })=>{
            setState({
                addedTasks: tasks
            });
        },
    setPageRestrictedTasks: (tasks)=>({ setState: setState })=>{
            setState({
                pageRestrictedTasks: tasks
            });
        },
    addPageRestrictedTasks: (addedPageRestrictedTasks)=>({ setState: setState, getState: getState })=>{
            const { pageRestrictedTasks: pageRestrictedTasks } = getState();
            const updatedPageRestrictedTasks = [
                ...pageRestrictedTasks,
                ...addedPageRestrictedTasks
            ];
            setState({
                pageRestrictedTasks: updatedPageRestrictedTasks
            });
        },
    removePageRestrictedTasks: (removedPageRestrictedTasks)=>({ setState: setState, getState: getState })=>{
            const removedLocalIds = new Set(removedPageRestrictedTasks.map((tasks)=>tasks.localId));
            const { pageRestrictedTasks: pageRestrictedTasks } = getState();
            const updatedPageRestrictedTasks = pageRestrictedTasks.filter((tasks)=>!removedLocalIds.has(tasks.localId));
            setState({
                pageRestrictedTasks: updatedPageRestrictedTasks
            });
        },
    setParentSpaceRestrictedTasks: (tasks)=>({ setState: setState })=>{
            setState({
                parentSpaceRestrictedTasks: tasks
            });
        },
    addParentSpaceRestrictedTasks: (addedParentSpaceRestrictedTasks)=>({ setState: setState, getState: getState })=>{
            const { parentSpaceRestrictedTasks: parentSpaceRestrictedTasks } = getState();
            const updatedParentSpaceRestrictedTasks = [
                ...parentSpaceRestrictedTasks,
                ...addedParentSpaceRestrictedTasks
            ];
            setState({
                parentSpaceRestrictedTasks: updatedParentSpaceRestrictedTasks
            });
        },
    removeParentSpaceRestrictedTasks: (removedParentSpaceRestrictedTasks)=>({ setState: setState, getState: getState })=>{
            const removedLocalIds = new Set(removedParentSpaceRestrictedTasks.map((tasks)=>tasks.localId));
            const { parentSpaceRestrictedTasks: parentSpaceRestrictedTasks } = getState();
            const updatedParentSpaceRestrictedTasks = parentSpaceRestrictedTasks.filter((tasks)=>!removedLocalIds.has(tasks.localId));
            setState({
                parentSpaceRestrictedTasks: updatedParentSpaceRestrictedTasks
            });
        },
    setUnrestrictedTasks: (tasks)=>({ setState: setState })=>{
            setState({
                unrestrictedTasks: tasks
            });
        },
    addUnrestrictedTasks: (addedUnrestrictedTasks)=>({ setState: setState, getState: getState })=>{
            const { unrestrictedTasks: unrestrictedTasks } = getState();
            const updatedUnrestrictedTasks = [
                ...unrestrictedTasks,
                ...addedUnrestrictedTasks
            ];
            setState({
                unrestrictedTasks: updatedUnrestrictedTasks
            });
        },
    removeUnrestrictedTasks: (removedUnrestrictedTasks)=>({ setState: setState, getState: getState })=>{
            const removedLocalIds = new Set(removedUnrestrictedTasks.map((tasks)=>tasks.localId));
            const { unrestrictedTasks: unrestrictedTasks } = getState();
            const updatedUnrestrictedTasks = unrestrictedTasks.filter((tasks)=>!removedLocalIds.has(tasks.localId));
            setState({
                unrestrictedTasks: updatedUnrestrictedTasks
            });
        },
    setMentionsAdded: (mentionsToAdd)=>({ setState: setState, getState: getState })=>{
            const { mentionsAdded: mentionsAdded } = getState();
            const updatedMentionsAdded = mentionsAdded;
            if (mentionsToAdd.currentUser) {
                if (mentionsToAdd.currentUser.length > 0) {
                    const currentUserMentions = mentionsToAdd.currentUser;
                    updatedMentionsAdded.currentUser = [
                        ...currentUserMentions,
                        ...mentionsAdded.currentUser
                    ];
                } else updatedMentionsAdded.currentUser = [];
            }
            setState({
                mentionsAdded: updatedMentionsAdded
            });
        },
    setTasksAdded: (tasksToAdd)=>({ setState: setState, getState: getState })=>{
            const { tasksAdded: tasksAdded } = getState();
            const updatedTasksAdded = tasksAdded;
            if (tasksToAdd.currentUser) {
                if (tasksToAdd.currentUser.length > 0) {
                    const currentUserTasks = tasksToAdd.currentUser;
                    updatedTasksAdded.currentUser = [
                        ...currentUserTasks,
                        ...tasksAdded.currentUser
                    ];
                } else updatedTasksAdded.currentUser = [];
            }
            setState({
                tasksAdded: updatedTasksAdded
            });
        },
    clearMentionsFlags: ()=>({ setState: setState })=>{
            setState($2d2e882c9a90b3be$var$getInitialState());
        }
};
const $2d2e882c9a90b3be$var$MentionsNotificationsStore = (0, $8s9DV.createStore)({
    initialState: $2d2e882c9a90b3be$var$getInitialState(),
    actions: $2d2e882c9a90b3be$var$actions,
    name: 'MentionsNotificationsStore'
});
const $2d2e882c9a90b3be$export$63a7b4a5d3248013 = (0, $kBr4q.createHook)($2d2e882c9a90b3be$var$MentionsNotificationsStore);
const $2d2e882c9a90b3be$export$e03e9325d0a65293 = (0, $kBr4q.createActionsHook)($2d2e882c9a90b3be$var$MentionsNotificationsStore);
module.exports["useMentionsNotifications"] = $2d2e882c9a90b3be$export$63a7b4a5d3248013;
module.exports["useMentionsNotificationsActions"] = $2d2e882c9a90b3be$export$e03e9325d0a65293;

});

parcelRegister("kGaEh", function(module, exports) {
$parcel$export(module.exports, "EditorTypes", () => (parcelRequire("lWVgZ")).EditorTypes);
$parcel$export(module.exports, "PreviewPageComponent", () => $93081da57503141f$export$376eaf8a4000eb1e);
$parcel$export(module.exports, "PreviewWithRenderer", () => $93081da57503141f$export$702c4e944f9180d3);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $jmjWc = parcelRequire("jmjWc");

parcelRequire("lWVgZ");


const $93081da57503141f$export$376eaf8a4000eb1e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "uDcJD",
    name: "PreviewPageComponent",
    loader: async ()=>(await (parcelRequire("e1qn9"))).PreviewPageComponent
});

const $93081da57503141f$export$702c4e944f9180d3 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "UqJvA",
    name: "PreviewWithRenderer",
    loader: async ()=>// NOTE: placed into the same chunk as this component is used by Tiny editor and also used internally by PreviewPageComponent
        (await (parcelRequire("gPVSD"))).PreviewWithRenderer
});

});

parcelRegister("e1qn9", function(module, exports) {

let $a3559dad0f0109fa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a3559dad0f0109fa$var$load("dtpmo"),
    $a3559dad0f0109fa$var$load("bYzij"),
    $a3559dad0f0109fa$var$load("5odbj"),
    $a3559dad0f0109fa$var$load("1bT50"),
    $a3559dad0f0109fa$var$load("1xRFJ"),
    $a3559dad0f0109fa$var$load("6lM2n")
]).then(()=>parcelRequire('esDVy'));

});

parcelRegister("gPVSD", function(module, exports) {

let $c41e4e8dc4afcd60$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c41e4e8dc4afcd60$var$load("dtpmo"),
    $c41e4e8dc4afcd60$var$load("bYzij"),
    $c41e4e8dc4afcd60$var$load("5odbj"),
    $c41e4e8dc4afcd60$var$load("1bT50"),
    $c41e4e8dc4afcd60$var$load("1xRFJ"),
    $c41e4e8dc4afcd60$var$load("6lM2n")
]).then(()=>parcelRequire('cPug3'));

});

parcelRegister("lWVgZ", function(module, exports) {
var $65441210bfcb6bd9$export$bb6127f23acfd41c = /*#__PURE__*/ function(EditorTypes) {
    EditorTypes["NCS"] = "ncs";
    EditorTypes["SYNCHRONY"] = "synchrony";
    EditorTypes["TEMPLATE"] = "template";
    return EditorTypes;
}({});
module.exports["EditorTypes"] = $65441210bfcb6bd9$export$bb6127f23acfd41c;

});

parcelRegister("2HGN8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $9wGTI = parcelRequire("9wGTI");


var $hYoU4 = parcelRequire("hYoU4");


var $8VcPj = parcelRequire("8VcPj");


var $1d2ww = parcelRequire("1d2ww");

const $652df36b21c46ede$var$ContentAppearanceContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    contentAppearance: {
        appearance: (0, $1d2ww.ContentAppearanceType).DEFAULT,
        version: 0
    },
    setContentAppearance: ()=>{},
    contentAppearanceLoading: false
});
const $652df36b21c46ede$export$53c04435be7a0acf = ({ contentId: contentId, children: children })=>{
    const [contentAppearanceOverride, setContentAppearanceOverride] = (0, $cozmU.useState)();
    // Clear the override state when navigating to a different page
    (0, $cozmU.useEffect)(()=>{
        if ((0, $9wGTI.fg)('platform_editor_appearance_override_reset')) setContentAppearanceOverride(undefined);
    }, [
        contentId
    ]);
    const [{ collabEditProvider: collabEditProvider }] = (0, $hYoU4.useNativeCollabState)();
    // Subscribe to metadata:changed events to update the content appearance for collaborators
    (0, $cozmU.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleMetadataChanged = (metadata)=>{
            const editorWidth = metadata?.editorWidth;
            const widthValue = editorWidth?.value;
            const version = editorWidth?.version;
            if (widthValue && version !== undefined) setContentAppearanceOverride((currentAppearance)=>{
                if (!currentAppearance || version > currentAppearance.version) return {
                    appearance: widthValue,
                    version: version
                };
                else return currentAppearance;
            });
        };
        collabEditProvider.on('metadata:changed', handleMetadataChanged);
        return ()=>{
            collabEditProvider.off('metadata:changed', handleMetadataChanged);
        };
    }, [
        collabEditProvider
    ]);
    /*
  	Previous check was:
  	const draftAppearanceQuery = getContentAppearanceQuery(ContentAppearancePropertyKey.DRAFT);
  	which always returns contentAppearanceQuery
  */ const { data: initialContentAppearanceData, loading: initialContentAppearanceLoading } = (0, $jMyy4.useQueryInterop)((0, $8VcPj.contentAppearanceQuery), {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ]
        },
        __callerPackage__: "content-appearance"
    });
    const context = (0, $cozmU.useMemo)(()=>{
        const initialContentAppearance = (0, $8VcPj.getContentAppearanceFromQueryData)(initialContentAppearanceData, (0, $1d2ww.ContentAppearancePropertyKey).DRAFT);
        // Under certain circumstances due to a previous bug with the content appearance during legacy editor autoconvert, an incorrect value may have been sent to collab service.
        // In this circumstance favour the initial content appearance value.
        const shouldUseInitial = contentAppearanceOverride && initialContentAppearance && contentAppearanceOverride.version === initialContentAppearance.version && contentAppearanceOverride.appearance !== initialContentAppearance.appearance;
        return {
            contentAppearance: shouldUseInitial ? initialContentAppearance : contentAppearanceOverride || initialContentAppearance,
            setContentAppearance: setContentAppearanceOverride,
            contentAppearanceLoading: initialContentAppearanceLoading
        };
    }, [
        initialContentAppearanceData,
        initialContentAppearanceLoading,
        contentAppearanceOverride
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($652df36b21c46ede$var$ContentAppearanceContext.Provider, {
        value: context
    }, children);
};
const $652df36b21c46ede$export$c3c73be39a08fc97 = ({ children: children })=>{
    const context = $652df36b21c46ede$export$4cedbdf2fdf3340d();
    return children(context);
};
const $652df36b21c46ede$export$4cedbdf2fdf3340d = ()=>{
    return (0, $cozmU.useContext)($652df36b21c46ede$var$ContentAppearanceContext);
};
module.exports["ContentAppearanceContextProvider"] = $652df36b21c46ede$export$53c04435be7a0acf;
module.exports["ContentAppearanceContextConsumer"] = $652df36b21c46ede$export$c3c73be39a08fc97;
module.exports["useContentAppearance"] = $652df36b21c46ede$export$4cedbdf2fdf3340d;

});

parcelRegister("a1uFh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $4yg9g = parcelRequire("4yg9g");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $8FvpY = parcelRequire("8FvpY");

var $6LguK = parcelRequire("6LguK");


var $5cryL = parcelRequire("5cryL");


var $ivb8S = parcelRequire("ivb8S");


var $lsxnT = parcelRequire("lsxnT");


var $8ul25 = parcelRequire("8ul25");


var $btgif = parcelRequire("btgif");

const $6e7c2a3fd79ba2ce$var$i18n = (0, $kSwu1.defineMessages)({
    editorModalTitle: {
        id: "onboarding-editor.modal.title",
        defaultMessage: "This page needs a title"
    },
    editorModalDescription: {
        id: "onboarding-editor.modal.description",
        defaultMessage: "Before you can publish this page, you\u2019ll need to give it a title."
    },
    editorModalPlaceholder: {
        id: "onboarding-editor.modal.placeholder",
        defaultMessage: "Enter title"
    },
    editorModalPublish: {
        id: "onboarding-editor.modal.button.publish",
        defaultMessage: "Publish"
    },
    editorModalClose: {
        id: "onboarding-editor.modal.button.close",
        defaultMessage: "Close"
    }
});
const $6e7c2a3fd79ba2ce$export$9265b150937a5ee1 = (props)=>{
    const { onTitleChange: onTitleChange, handlePublish: handlePublish } = props;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [title, setTitle] = (0, $cozmU.useState)('');
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { modal: modal, hideEditorModal: hideEditorModal } = (0, $6LguK.useEditorModalContext)();
    const showModal = modal?.[(0, $8FvpY.ALLOWED_EDITOR_MODAL).ONBOARDING_EDITOR_MODAL] || false;
    const { fireEditorModalPromptClosed: fireEditorModalPromptClosed, fireEditorModalPromptPublished: fireEditorModalPromptPublished } = (0, $8ul25.useEditorOnboardingEvents)();
    const intl = (0, $kSwu1.useIntl)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    (0, $cozmU.useEffect)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.ONBOARDING_EDITOR_PUBLISH_MODAL_PROMPT_EXPERIENCE),
            collect (events, experience) {
                // Fail or abort ONBOARDING_EDITOR_PUBLISH_MODAL_PROMPT_EXPERIENCE as soon as EDIT_PAGE_PUBLISH_EXPERIENCE fails or aborts:
                experience.stopOn(events.find(({ action: action, name: name })=>(action === 'taskFail' || action === 'taskAbort') && name === (0, $irVI7.EDIT_PAGE_PUBLISH_EXPERIENCE)));
            }
        });
    }, [
        experienceTracker
    ]);
    const endExperienceTracker = ()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.ONBOARDING_EDITOR_PUBLISH_MODAL_PROMPT_EXPERIENCE)
        });
    };
    const onClose = ()=>{
        hideEditorModal((0, $8FvpY.ALLOWED_EDITOR_MODAL).ONBOARDING_EDITOR_MODAL);
        fireEditorModalPromptClosed();
        endExperienceTracker();
    };
    const onClickPublish = ()=>{
        // There needs to be a title before publishing is possible
        onTitleChange(title);
        return Promise.resolve(hideEditorModal((0, $8FvpY.ALLOWED_EDITOR_MODAL).ONBOARDING_EDITOR_MODAL)).then(()=>{
            handlePublish();
        }).then(()=>{
            // set hasUserPublished to true
            setOnboardingState({
                key: (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).HAS_USER_PUBLISHED,
                value: 'true'
            });
            fireEditorModalPromptPublished();
            endExperienceTracker();
        });
    };
    return showModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
        key: "onboarding-editor-modal",
        onClose: onClose,
        shouldCloseOnEscapePress: true,
        shouldCloseOnOverlayClick: true,
        width: 480,
        messageType: "transactional",
        messageId: "onboarding-editor-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6e7c2a3fd79ba2ce$var$i18n.editorModalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $btgif.ModalDescription), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6e7c2a3fd79ba2ce$var$i18n.editorModalDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        testId: "editor-modal-prompt-textfield",
        autoFocus: true,
        onChange: (e)=>{
            setTitle(e.target.value);
        },
        placeholder: intl.formatMessage($6e7c2a3fd79ba2ce$var$i18n.editorModalPlaceholder)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: onClose,
        autoFocus: false,
        appearance: "subtle",
        testId: "editor-modal-prompt-close-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6e7c2a3fd79ba2ce$var$i18n.editorModalClose)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: onClickPublish,
        type: "submit",
        autoFocus: false,
        onSubmit: onClickPublish,
        isDisabled: title.length === 0,
        appearance: "primary",
        testId: "editor-modal-prompt-publish-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6e7c2a3fd79ba2ce$var$i18n.editorModalPublish)))) : null;
};
module.exports["OnboardingEditorModalPrompt"] = $6e7c2a3fd79ba2ce$export$9265b150937a5ee1;

});

parcelRegister("8FvpY", function(module, exports) {
const $1f6c26e8b75dac6d$export$66ebbe2730dd348f = {
    ONBOARDING_EDITOR_MODAL: 'onboarding-editor-modal'
};
module.exports["ALLOWED_EDITOR_MODAL"] = $1f6c26e8b75dac6d$export$66ebbe2730dd348f;

});

parcelRegister("6LguK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $a5f0fa1f60ef7a3d$export$f094ef697e0046b5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    showEditorModal: ()=>{},
    hideEditorModal: ()=>{},
    modal: {}
});
const $a5f0fa1f60ef7a3d$export$43769d91a63d8617 = ({ children: children })=>{
    const [modal, setModal] = (0, $cozmU.useState)({});
    const showEditorModal = (0, $cozmU.useCallback)((modalName)=>{
        setModal({
            ...modal,
            [modalName]: true
        });
    }, [
        modal
    ]);
    const hideEditorModal = (0, $cozmU.useCallback)((modalName)=>{
        setModal({
            ...modal,
            [modalName]: false
        });
    }, [
        modal
    ]);
    const editorModalContextValue = (0, $cozmU.useMemo)(()=>({
            showEditorModal: showEditorModal,
            hideEditorModal: hideEditorModal,
            modal: modal
        }), [
        showEditorModal,
        hideEditorModal,
        modal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a5f0fa1f60ef7a3d$export$f094ef697e0046b5.Provider, {
        value: editorModalContextValue
    }, children);
};
function $a5f0fa1f60ef7a3d$export$25df5f37bf8e13e4(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a5f0fa1f60ef7a3d$export$43769d91a63d8617, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, props));
}
const $a5f0fa1f60ef7a3d$export$452d9698d6861523 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($a5f0fa1f60ef7a3d$export$f094ef697e0046b5);
module.exports["withEditorModalContext"] = $a5f0fa1f60ef7a3d$export$25df5f37bf8e13e4;
module.exports["useEditorModalContext"] = $a5f0fa1f60ef7a3d$export$452d9698d6861523;

});

parcelRegister("5cryL", function(module, exports) {
const $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b = {
    EDITOR_ONBOARDING_ELIGIBLE_NEW: 'editor-state:editorOnboardingEligiblity',
    EDITOR_VISITED: 'editor-state:editorVisited',
    WAS_DRAFT_BANNER_SEEN: 'editor-state:wasDraftBannerSeen',
    IS_DRAFT_BANNER_VISIBLE: 'editor-state:isDraftBannerVisible',
    IS_LAND_IN_EDITOR_BANNER_VISIBLE: 'editor-state:isLandInEditorBannerVisible',
    HAS_USER_PUBLISHED: 'editor-state:hasUserPublished',
    SUCCESS_FLAG_SEEN: 'editor-state:successFlagCompleted',
    RECENT_SPOTLIGHT_OPEN: 'editor-state:recentSpotlightOpen',
    RECENT_SPOTLIGHT_SEEN: 'editor-state:recentSpotlightCompleted',
    EDITOR_TUTORIAL_SUCCESS_FLAG_SEEN: 'editor-state:editorTutorialSuccessFlagCompleted',
    WAS_EDITOR_CONVERSION_DIALOG_SEEN: 'editor-state:wasEditorConversionModalSeen',
    WAS_EDITOR_CONVERSION_DIALOG_V3_SEEN: 'editor-state:wasEditorConversionModalV3Seen'
};
const $d59a11eb5a1dc2b2$export$1a907d3885d0a16c = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-blueprint';
const $d59a11eb5a1dc2b2$export$3cae7707c5db4087 = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-v2-blueprint';
const $d59a11eb5a1dc2b2$export$fa405f661a23ebc5 = 'editor-onboarding';
const $d59a11eb5a1dc2b2$export$caf77613d415fe3 = [
    ...Object.values($d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b),
    $d59a11eb5a1dc2b2$export$1a907d3885d0a16c,
    $d59a11eb5a1dc2b2$export$3cae7707c5db4087
];
module.exports["EDITOR_ONBOARDING_STATE_KEYS"] = $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY"] = $d59a11eb5a1dc2b2$export$1a907d3885d0a16c;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED"] = $d59a11eb5a1dc2b2$export$3cae7707c5db4087;
module.exports["ONBOARDING_TUTORIAL_LABEL"] = $d59a11eb5a1dc2b2$export$fa405f661a23ebc5;
module.exports["EditorOnboardingKeys"] = $d59a11eb5a1dc2b2$export$caf77613d415fe3;

});

parcelRegister("8ul25", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");

const $37973aa3dd0a7e4f$export$4da26a7e02cd5140 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireGetEditorOnboardingStateFailed = (0, $cozmU.useCallback)((source)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'failed',
                actionSubject: 'getOnboardingState',
                actionSubjectId: 'editorOnboarding',
                source: source
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const fireEditorPublishSuccessFlagViewed = (0, $cozmU.useCallback)((type)=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'onboardingEditorPublishSuccessFlag',
                attributes: {
                    type: type
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const fireEditorModalPromptClosed = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'onboardingEditorModalPrompt',
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'closeButton'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const fireEditorModalPromptPublished = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'onboardingEditorModalPrompt',
                actionSubject: 'button',
                action: 'clicked',
                actionSubjectId: 'publishButton'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireGetEditorOnboardingStateFailed: fireGetEditorOnboardingStateFailed,
        fireEditorPublishSuccessFlagViewed: fireEditorPublishSuccessFlagViewed,
        fireEditorModalPromptClosed: fireEditorModalPromptClosed,
        fireEditorModalPromptPublished: fireEditorModalPromptPublished
    };
};
module.exports["useEditorOnboardingEvents"] = $37973aa3dd0a7e4f$export$4da26a7e02cd5140;

});

parcelRegister("btgif", function(module, exports) {
/* EditorModalPromptStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $8387ef6c90ca0a23$export$f50a68e3694789ee = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11c81af2 _syazi7uo _n3tdpxbi _1e0c1txw _1bah1yb4 _4cvr1h6o _z6mmtlke _10pb1tcg",
            __cmplp.className
        ])
    });
});
const $8387ef6c90ca0a23$export$70584796f9410aa4 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_syazi7uo _n3tdpxbi",
            __cmplp.className
        ])
    });
});
module.exports["ModalDescription"] = $8387ef6c90ca0a23$export$70584796f9410aa4;

});

parcelRegister("2QUbq", function(module, exports) {
/**
 * Approvals analytics utilities
 *
 * Shared constants and helpers for analytics events fired across the Approvals workflow.
 * All approval-related events should use the APPROVALS_ANALYTICS_SOURCE constant as their source.
 */ const $3b81570c8284038b$export$aafe3d1a02fab97e = 'ConfluenceApprovalsWorkflow';
const $3b81570c8284038b$export$a389a02f59f28efe = {
    type: 'sendUIEvent',
    data: {
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'invokeRovoAgent',
        source: $3b81570c8284038b$export$aafe3d1a02fab97e
    }
};
const $3b81570c8284038b$export$f1487629ac850cbf = (approvers, decisionChange)=>{
    const counts = approvers.reduce((acc, approver)=>{
        if (approver.status === 'REVIEWER_APPROVED') acc.approved++;
        else if (approver.status === 'REVIEWER_DENIED') acc.declined++;
        else if (approver.status === 'PENDING_REVIEW') acc.pending++;
        return acc;
    }, {
        approved: 0,
        declined: 0,
        pending: 0,
        total: approvers.length
    });
    if (decisionChange) {
        const { previousDecision: previousDecision = 'PENDING_REVIEW', newDecision: newDecision } = decisionChange;
        // Decrement the previous bucket (REVIEW_CANCELED is not a counted bucket; treat as no-op)
        if (previousDecision === 'REVIEWER_APPROVED') counts.approved--;
        else if (previousDecision === 'REVIEWER_DENIED') counts.declined--;
        else if (previousDecision === 'PENDING_REVIEW') counts.pending--;
        // Increment the new bucket
        if (newDecision === 'REVIEWER_APPROVED') counts.approved++;
        else counts.declined++;
    }
    return counts;
};
const $3b81570c8284038b$export$571dc04ca9eba9e2 = (error)=>{
    if (error == null || typeof error !== 'object') return null;
    const mutationError = error;
    const { extensions: extensions } = mutationError;
    if (extensions == null) return null;
    const ext = Array.isArray(extensions) ? extensions[0] : extensions;
    if (ext == null) return null;
    const { statusCode: statusCode } = ext;
    if (typeof statusCode === 'number') return statusCode;
    return null;
};
module.exports["APPROVALS_ANALYTICS_SOURCE"] = $3b81570c8284038b$export$aafe3d1a02fab97e;
module.exports["APPROVALS_INVOKE_ROVO_AGENT_CLICKED_EVENT"] = $3b81570c8284038b$export$a389a02f59f28efe;
module.exports["computeReviewStatusCounts"] = $3b81570c8284038b$export$f1487629ac850cbf;
module.exports["getFailureStatusCode"] = $3b81570c8284038b$export$571dc04ca9eba9e2;

});

parcelRegister("akN4j", function(module, exports) {
/* ApprovalActionConfirmationModal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $aRGok = parcelRequire("aRGok");


var $1l0kj = parcelRequire("1l0kj");


var $lsxnT = parcelRequire("lsxnT");

const $bf4b21e57b3706d5$var$i18n = (0, $kSwu1.defineMessages)({
    headingClearApproval: {
        id: "approvals.action-confirmation.modal.heading.clear-approval",
        defaultMessage: "Clear approval?"
    },
    headingCancelApproval: {
        id: "approvals.action-confirmation.modal.heading.cancel-approval",
        defaultMessage: "Cancel approval?"
    },
    headingChangeStatus: {
        id: "approvals.action-confirmation.modal.heading.change-status",
        defaultMessage: "Change status?"
    },
    bodyClearApproval: {
        id: "approvals.action-confirmation.modal.body.clear-approval",
        defaultMessage: "Are you sure you want to clear approval? Previous approval activity will remain available in audit logs."
    },
    bodyCancelApproval: {
        id: "approvals.action-confirmation.modal.body.cancel-approval",
        defaultMessage: "Are you sure you want to cancel approval? Previous approval activity will remain available in audit logs."
    },
    bodyChangeStatus: {
        id: "approvals.action-confirmation.modal.body.change-status",
        defaultMessage: "Are you sure you want to change status? Previous approval activity will remain available in audit logs."
    },
    confirmClearApproval: {
        id: "approvals.action-confirmation.modal.confirm.clear-approval",
        defaultMessage: "Clear approval"
    },
    confirmCancelApproval: {
        id: "approvals.action-confirmation.modal.confirm.cancel-approval",
        defaultMessage: "Cancel approval"
    },
    confirmChangeStatus: {
        id: "approvals.action-confirmation.modal.confirm.change-status",
        defaultMessage: "Change status"
    },
    cancelButton: {
        id: "approvals.action-confirmation.modal.cancel",
        defaultMessage: "Cancel"
    }
});
const $bf4b21e57b3706d5$var$styles = {
    footerRow: "_zulputpp _1bahesu3 _19pkpxbi"
};
const $bf4b21e57b3706d5$var$HEADING_BY_VARIANT = {
    clearApproval: $bf4b21e57b3706d5$var$i18n.headingClearApproval,
    cancelApproval: $bf4b21e57b3706d5$var$i18n.headingCancelApproval,
    changeStatus: $bf4b21e57b3706d5$var$i18n.headingChangeStatus
};
const $bf4b21e57b3706d5$var$BODY_BY_VARIANT = {
    clearApproval: $bf4b21e57b3706d5$var$i18n.bodyClearApproval,
    cancelApproval: $bf4b21e57b3706d5$var$i18n.bodyCancelApproval,
    changeStatus: $bf4b21e57b3706d5$var$i18n.bodyChangeStatus
};
const $bf4b21e57b3706d5$var$CONFIRM_BY_VARIANT = {
    clearApproval: $bf4b21e57b3706d5$var$i18n.confirmClearApproval,
    cancelApproval: $bf4b21e57b3706d5$var$i18n.confirmCancelApproval,
    changeStatus: $bf4b21e57b3706d5$var$i18n.confirmChangeStatus
};
const $bf4b21e57b3706d5$var$TEST_ID_BY_VARIANT = {
    clearApproval: 'approval-action-confirmation-modal-clear-approval',
    cancelApproval: 'approval-action-confirmation-modal-cancel-approval',
    changeStatus: 'approval-action-confirmation-modal-change-status'
};
const $bf4b21e57b3706d5$export$64f482d2cfabd4a = ({ variant: variant, onConfirm: onConfirm, onClose: onClose })=>{
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
        onClose: onClose,
        testId: $bf4b21e57b3706d5$var$TEST_ID_BY_VARIANT[variant]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $bf4b21e57b3706d5$var$HEADING_BY_VARIANT[variant]))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $bf4b21e57b3706d5$var$BODY_BY_VARIANT[variant])), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        xcss: $bf4b21e57b3706d5$var$styles.footerRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onClose,
        testId: "approval-action-confirmation-modal-cancel-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $bf4b21e57b3706d5$var$i18n.cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "warning",
        onClick: onConfirm,
        testId: "approval-action-confirmation-modal-confirm-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $bf4b21e57b3706d5$var$CONFIRM_BY_VARIANT[variant]))))));
};
module.exports["ApprovalActionConfirmationModal"] = $bf4b21e57b3706d5$export$64f482d2cfabd4a;

});

parcelRegister("6zK0v", function(module, exports) {
/* PressableLink.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hBYtq = parcelRequire("hBYtq");

const $89ea01e4247ccb78$var$styles = {
    root: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _4bfu1r31 _1hms8stv _ajmmnqa1 _bfhk1j28 _4bfu1rpy _syaz1rpy _30l3i7uo _9h8h12zz"
};
const $89ea01e4247ccb78$export$12e82d6c56cc7acc = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ onClick: onClick, children: children, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
        ref: ref,
        xcss: $89ea01e4247ccb78$var$styles.root,
        onClick: onClick,
        ...rest
    }, children));
$89ea01e4247ccb78$export$12e82d6c56cc7acc.displayName = 'PressableLink';
module.exports["PressableLink"] = $89ea01e4247ccb78$export$12e82d6c56cc7acc;

});

parcelRegister("lpuNH", function(module, exports) {

let $f963d327c10f82c0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f963d327c10f82c0$var$load("3vWnx").then(()=>parcelRequire('o1ACN'));

});

parcelRegister("bc1oR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aRGok = parcelRequire("aRGok");


var $jmjWc = parcelRequire("jmjWc");


const $59dfe7259baf5548$var$LiveDocConversionBlockedModalContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "y_qAG",
    name: "LiveDocConversionBlockedModalContent",
    loader: async ()=>(await (parcelRequire("2GSdi"))).LiveDocConversionBlockedModal
});
const $59dfe7259baf5548$export$b1e3cd6c92cb101b = ({ isOpen: isOpen, onClose: onClose })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($59dfe7259baf5548$var$LiveDocConversionBlockedModalContent, {
        onClose: onClose
    }) : null);
};
module.exports["LiveDocConversionBlockedModal"] = $59dfe7259baf5548$export$b1e3cd6c92cb101b;

});

parcelRegister("2GSdi", function(module, exports) {

let $1f598eadbc048b0c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1f598eadbc048b0c$var$load("7Cd3Z").then(()=>parcelRequire('1QNK6'));

});

parcelRegister("g01A4", function(module, exports) {

var $i9VoI = parcelRequire("i9VoI");


var $9wGTI = parcelRequire("9wGTI");


var $1xpoY = parcelRequire("1xpoY");


var $6mKj3 = parcelRequire("6mKj3");

const $e0f671e8616dafd9$export$c6d4df78386dbff6 = ({ callback: callback, subscriberId: subscriberId, contentId: contentId, contentType: contentType })=>{
    (0, $i9VoI.useSubscriptionEvent)({
        onDataReceived: callback,
        delta: 'contentRestrictionUpdated',
        subscriberId: subscriberId,
        contentType: contentType,
        contentId: contentId,
        skip: // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        !(0, $6mKj3.expVal)('cc_fps_migration_content-restriction-updated', 'isEnabled', false) || !(0, $9wGTI.fg)('confluence_enable_subscriptions-context-provider') || ![
            'DUAL',
            'GRAPHQL'
        ].includes((0, $1xpoY.default).getString('confluence-migrate-fps-to-graphql-subscription', ''))
    });
};
module.exports["useContentRestrictionSubscriptionEvent"] = $e0f671e8616dafd9$export$c6d4df78386dbff6;

});

parcelRegister("18HQ4", function(module, exports) {
/* BrowserIndicators.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");

const $4dfb2d8a6603cd21$export$adb584737d712b70 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { toolbarHidden: toolbarHidden, show: show, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_v56417u1 _1e0c1txw _kqswstnw _1bsb1osq _1pbykb7n _1bah1h6o _4cvr1h6o _1ltvze3t _4t3ixy5q _bfhkysee _8hrzjp4b",
            __cmplp.toolbarHidden ? "_154iidpf" : "_154i1ady",
            __cmplp.show ? "_t9ecp8ia" : "_t9ecdgp5",
            __cmplp.toolbarHidden ? "_1911idpf" : "_19111ady",
            __cmplp.className
        ])
    });
});
const $4dfb2d8a6603cd21$export$b4f88f0ca5784eef = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = $4dfb2d8a6603cd21$export$adb584737d712b70, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1pby1fw0",
            __cmplp.show && __cmplp.showOnlineBackground ? "_bfhk1y9u" : "_bfhkysee",
            __cmplp.className
        ])
    });
}); // TODO: Figure out why @compiled is having trouble with the @media lambda function below.
const $4dfb2d8a6603cd21$export$31ea92f3997410dd = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { mediaMaxWidth: mediaMaxWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1enk3bj": (0, $9aYkv.default)(__cmplp.mediaMaxWidth)
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _ect41kw7 _k48pwu06 _1wyb1crf _syaz1rpy _18u0u2gc _o5721q9c _1hma11y2",
            __cmplp.className
        ])
    });
});
$4dfb2d8a6603cd21$export$31ea92f3997410dd.defaultProps = {
    mediaMaxWidth: '650px'
};
const $4dfb2d8a6603cd21$export$bb5d4b172e6970cd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4dfb2d8a6603cd21$var$FadingSpanInternal, {
        "aria-hidden": !props?.show,
        ...props
    }); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $4dfb2d8a6603cd21$var$FadingSpanInternal = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { show: show, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_v564ayzn _1e0c1txw _4cvr1h6o _kqswstnw",
            __cmplp.show ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.className
        ])
    });
});
const $4dfb2d8a6603cd21$export$91672a4b819b5126 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _4cvresu3 _4t3iu2gc _18u0v77o",
            __cmplp.className
        ])
    });
});
const $4dfb2d8a6603cd21$export$c30cc6d619162254 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2rko1rr0 _11q71rpy _y44v1dpe _1e0c1o8l _1bsbv77o _4t3iv77o _2hwxv77o _1dvn10n5 _8rwrg43g",
            __cmplp.className
        ])
    });
});
const $4dfb2d8a6603cd21$export$b9ead157d7292e86 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11c8wadc _k48pwu06 _syaz1oa5",
            __cmplp.className
        ])
    });
});
module.exports["StatusIndicator"] = $4dfb2d8a6603cd21$export$b4f88f0ca5784eef;
module.exports["StyledText"] = $4dfb2d8a6603cd21$export$31ea92f3997410dd;
module.exports["FadingSpan"] = $4dfb2d8a6603cd21$export$bb5d4b172e6970cd;
module.exports["EllipsisContainer"] = $4dfb2d8a6603cd21$export$91672a4b819b5126;
module.exports["AnimatedDot"] = $4dfb2d8a6603cd21$export$c30cc6d619162254;
module.exports["StyledRefreshLink"] = $4dfb2d8a6603cd21$export$b9ead157d7292e86;

});

parcelRegister("1gh0Q", function(module, exports) {
/**
 * Regex to match the auto-generated live doc title format: "Untitled live doc YYYY-MM-DD"
 * or "Untitled live doc YYYY-MM-DD (n)" when multiple live docs are created on the same day.
 * This is the default title assigned by the backend when a new live doc is created.
 */ const $88fa25aefd5bae84$var$DEFAULT_LIVE_DOC_TITLE_PATTERN = /^Untitled live doc \d{4}-\d{2}-\d{2}( \(\d+\))?$/;
const $88fa25aefd5bae84$export$4926831772faf7e = (title)=>{
    if (!title) return false;
    return $88fa25aefd5bae84$var$DEFAULT_LIVE_DOC_TITLE_PATTERN.test(title);
};
module.exports["isDefaultLiveDocTitle"] = $88fa25aefd5bae84$export$4926831772faf7e;

});

parcelRegister("gkIgp", function(module, exports) {
var $44e99c386783fe05$export$ea1a2a449eaeaa2d = /*#__PURE__*/ function(CollabServiceProperty) {
    CollabServiceProperty["NCS"] = "ncs";
    CollabServiceProperty["SYNCHRONY"] = "synchrony";
    return CollabServiceProperty;
}({});
module.exports["CollabServiceProperty"] = $44e99c386783fe05$export$ea1a2a449eaeaa2d;

});

parcelRegister("S6mif", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jbOus = parcelRequire("jbOus");


var $9DHhW = parcelRequire("9DHhW");


var $422HI = parcelRequire("422HI");


var $bMmYR = parcelRequire("bMmYR");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $hBkCm = parcelRequire("hBkCm");


var $aMcHK = parcelRequire("aMcHK");


var $fJlJm = parcelRequire("fJlJm");


var $3jwuS = parcelRequire("3jwuS");

class $03a48f98bcaadc9f$export$26130dc3dd4c1286 extends Error {
    constructor(message, status, traceId){
        super(message), this.message = message, this.status = status, this.traceId = traceId;
        this.status = status;
        this.traceId = traceId;
    }
}
const $03a48f98bcaadc9f$var$isNotPermittedError = (error)=>{
    return error.code === (0, $jbOus.PROVIDER_ERROR_CODE).NO_PERMISSION_ERROR && 'EXPIRED_TOKEN' !== error.reason || error.code === (0, $jbOus.PROVIDER_ERROR_CODE).DOCUMENT_NOT_FOUND;
};
const $03a48f98bcaadc9f$export$fab3177d2bcbd98a = (error)=>{
    return !error.recoverable && (0, $jbOus.PROVIDER_ERROR_CODE).INTERNAL_SERVICE_ERROR !== error.code;
};
const $03a48f98bcaadc9f$var$getStatusCodeFromApolloError = (error)=>{
    return (0, $422HI.isApolloError)(error) && (0, $hBkCm.BadStatusError).isBadStatusError(error?.graphQLErrors?.[0]?.originalError) ? Number((0, $aMcHK.getStatusCodeError)(error.graphQLErrors[0].originalError)) : null;
};
const $03a48f98bcaadc9f$var$isTenantSuspendedError = (error)=>error.status === 423;
const $03a48f98bcaadc9f$export$5027865de34f9ec6 = (collabEditProvider, resetCollabService, contentId, contentType)=>{
    const [error, setError] = (0, $cozmU.useState)(null);
    const [recoveryError, setRecoveryError] = (0, $cozmU.useState)(null);
    const hasResetRef = (0, $cozmU.useRef)({
        resetInProgress: false,
        resetCount: 0
    });
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const currentEditorPageLoadExperienceName = isLivePage ? (0, $irVI7.VIEW_PAGE_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE);
    const stopExperienceOnRecoveryError = (0, $cozmU.useCallback)((recoveryErrorForAnalytics)=>{
        if (!!recoveryErrorForAnalytics?.status && recoveryErrorForAnalytics?.status < 500) {
            experienceTracker.abort({
                name: currentEditorPageLoadExperienceName,
                reason: `Recovery failed with error status ${recoveryErrorForAnalytics.status}`,
                attributes: {
                    errorStatus: recoveryErrorForAnalytics?.status,
                    traceId: recoveryErrorForAnalytics?.traceId,
                    objectId: contentId,
                    objectType: contentType,
                    isLivePage: isLivePage
                }
            });
            return;
        }
        experienceTracker.stopOnError({
            name: currentEditorPageLoadExperienceName,
            error: recoveryErrorForAnalytics,
            attributes: {
                ...recoveryErrorForAnalytics?.status ? {
                    errorStatus: recoveryErrorForAnalytics.status
                } : {},
                errorType: 'Recovery failed',
                traceId: recoveryErrorForAnalytics?.traceId,
                objectId: contentId,
                objectType: contentType,
                isLivePage: isLivePage
            }
        });
    }, [
        contentId,
        contentType,
        experienceTracker,
        currentEditorPageLoadExperienceName,
        isLivePage
    ]);
    const setErrorAndDisconnect = (0, $cozmU.useCallback)((newError)=>{
        if ($03a48f98bcaadc9f$var$isNotPermittedError(newError) || $03a48f98bcaadc9f$export$fab3177d2bcbd98a(newError) || $03a48f98bcaadc9f$var$isTenantSuspendedError(newError)) setError(newError);
        const experienceState = experienceTracker.getExperienceState(currentEditorPageLoadExperienceName);
        if (!experienceState || experienceState.hasStopped) {
            // initialisation completed but we received an error later
            if (!$03a48f98bcaadc9f$var$isNotPermittedError(newError)) {
                if ($03a48f98bcaadc9f$export$fab3177d2bcbd98a(newError)) experienceTracker.stopOnError({
                    name: (0, $irVI7.EDIT_PAGE_EXPERIENCE),
                    error: {
                        name: newError.code,
                        message: newError.message
                    },
                    attributes: {
                        errorStatus: newError.status,
                        objectId: contentId,
                        objectType: contentType,
                        isLivePage: isLivePage
                    }
                });
                else createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'error',
                        actionSubject: 'nativeEditor',
                        source: 'confluenceFrontend',
                        objectId: contentId,
                        objectType: contentType,
                        attributes: {
                            errorName: newError.code,
                            errorMessage: newError.message,
                            errorStatus: newError.status,
                            isRecoverable: true,
                            reason: 'reason' in newError ? newError.reason : 'unknown',
                            isLivePage: isLivePage
                        }
                    }
                }).fire();
            }
            return;
        }
        if ($03a48f98bcaadc9f$var$isNotPermittedError(newError)) {
            // expected 403 for restricted page or deleted page
            // for deleted page, 403 is returned with reason "RESOURCE_DELETED"
            let newErrorReason;
            if ('reason' in newError) newErrorReason = newError.reason;
            collabEditProvider.disconnect();
            experienceTracker.abort({
                name: currentEditorPageLoadExperienceName,
                reason: newErrorReason ?? 'page restricted or deleted',
                attributes: {
                    errorStatus: newError.status,
                    errorName: newError.code,
                    errorMessage: newError.message,
                    objectId: contentId,
                    objectType: contentType,
                    isLivePage: isLivePage
                }
            });
        } else if ($03a48f98bcaadc9f$export$fab3177d2bcbd98a(newError)) // unhandled/unexpected errors
        experienceTracker.stopOnError({
            name: currentEditorPageLoadExperienceName,
            error: {
                name: newError.code,
                message: newError.message
            },
            attributes: {
                errorStatus: newError.status,
                objectId: contentId,
                objectType: contentType,
                isLivePage: isLivePage
            }
        });
    }, [
        collabEditProvider,
        experienceTracker,
        createAnalyticsEvent,
        contentId,
        contentType,
        currentEditorPageLoadExperienceName,
        isLivePage
    ]);
    const collabRecovery = (0, $cozmU.useCallback)(async ()=>{
        if (hasResetRef.current.resetInProgress) return;
        else if (hasResetRef.current.resetCount > 0) {
            // recovery has already been attempted but we've received another 404d
            const error = new $03a48f98bcaadc9f$export$26130dc3dd4c1286(`Collab recovery unsuccessful`);
            setRecoveryError(error);
            stopExperienceOnRecoveryError(error);
            return;
        }
        hasResetRef.current = {
            resetInProgress: true,
            resetCount: hasResetRef.current.resetCount += 1
        };
        const shouldRetryPredicate = async (error)=>{
            const statusCode = $03a48f98bcaadc9f$var$getStatusCodeFromApolloError(error);
            return !!statusCode && statusCode >= 500;
        };
        try {
            await (0, $bMmYR.retry)(resetCollabService, {
                maxAttempts: 2,
                timeout: 2000
            }, shouldRetryPredicate); // kick off page recovery, with retry
            hasResetRef.current.resetInProgress = false;
        } catch (e) {
            // page recovery has failed, editor is empty... fatal error
            let recoveryError = e; // "public" error used by other components
            const statusCode = $03a48f98bcaadc9f$var$getStatusCodeFromApolloError(e);
            if (!!statusCode) recoveryError = new $03a48f98bcaadc9f$export$26130dc3dd4c1286(`Collab recovery responded with ${statusCode}`, statusCode, (0, $fJlJm.getTraceIdFromApolloError)(e) ?? undefined);
            setRecoveryError(recoveryError);
            stopExperienceOnRecoveryError(recoveryError);
            hasResetRef.current.resetInProgress = false;
        }
    }, [
        resetCollabService,
        stopExperienceOnRecoveryError
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleError = (emittedError)=>{
            if (emittedError.status == 404) // 404 means that collab service doesn't have the document but Confluence does
            // try reset the document before displaying error (will be created in collab service if it doesn't exist). Currently only attempt reset once (no retry)
            collabRecovery();
            else setErrorAndDisconnect(emittedError);
        };
        collabEditProvider.on('error', handleError);
        return ()=>{
            collabEditProvider.off('error', handleError);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collabEditProvider,
        resetCollabService
    ]);
    return {
        error: error,
        recoveryError: recoveryError
    };
};
module.exports["CollabRecoveryErrorType"] = $03a48f98bcaadc9f$export$26130dc3dd4c1286;
module.exports["isUnrecoverableError"] = $03a48f98bcaadc9f$export$fab3177d2bcbd98a;
module.exports["useError"] = $03a48f98bcaadc9f$export$5027865de34f9ec6;

});

parcelRegister("kXAjP", function(module, exports) {
$parcel$export(module.exports, "useConnectionsPanel", () => (parcelRequire("39X8O")).useConnectionsPanel);

var $jmjWc = parcelRequire("jmjWc");


var $39X8O = parcelRequire("39X8O");


const $a2d4e70bef17fdaf$export$2dabaf13426958f5 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "B5cUO",
    name: "EditorContextConnectionsPanel",
    loader: async ()=>(await (parcelRequire("bgLbw"))).EditorContextConnectionsPanel
});
module.exports["EditorContextConnectionsPanel"] = $a2d4e70bef17fdaf$export$2dabaf13426958f5;

});

parcelRegister("39X8O", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $d49dc00c3f0d1c58$export$7e80a76e7cd27a75 = ()=>{
    const [connectionsPanelActiveNodeLocalId, setConnectionsPanelActiveNodeLocalId] = (0, $cozmU.useState)(null);
    const openConnectionsPanel = (0, $cozmU.useCallback)((localId)=>{
        setConnectionsPanelActiveNodeLocalId(localId);
    }, [
        setConnectionsPanelActiveNodeLocalId
    ]);
    const closeConnectionsPanel = (0, $cozmU.useCallback)((localId)=>{
        if (!localId || localId && localId !== connectionsPanelActiveNodeLocalId) setConnectionsPanelActiveNodeLocalId(null);
    }, [
        connectionsPanelActiveNodeLocalId,
        setConnectionsPanelActiveNodeLocalId
    ]);
    return (0, $cozmU.useMemo)(()=>({
            connectionsPanelActiveNodeLocalId: connectionsPanelActiveNodeLocalId,
            setConnectionsPanelActiveNodeLocalId: setConnectionsPanelActiveNodeLocalId,
            openConnectionsPanel: openConnectionsPanel,
            closeConnectionsPanel: closeConnectionsPanel
        }), [
        connectionsPanelActiveNodeLocalId,
        setConnectionsPanelActiveNodeLocalId,
        openConnectionsPanel,
        closeConnectionsPanel
    ]);
};
module.exports["useConnectionsPanel"] = $d49dc00c3f0d1c58$export$7e80a76e7cd27a75;

});

parcelRegister("bgLbw", function(module, exports) {

let $8345ca40d59df914$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8345ca40d59df914$var$load("1xRFJ"),
    $8345ca40d59df914$var$load("i3hKX"),
    $8345ca40d59df914$var$load("8ZQ6W"),
    $8345ca40d59df914$var$load("WlGjZ")
]).then(()=>parcelRequire('gUdsz'));

});

parcelRegister("6dTPw", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");

parcelRequire("fDSmg");
var $7rgfa = parcelRequire("7rgfa");


var $hS1eb = parcelRequire("hS1eb");


var $fySJw = parcelRequire("fySJw");

const $dffc47041c3d315b$export$fdfa01513f7f82e4 = (0, $dOBRD.default)((createAnalyticsEvent, contentId, appearance = 'full-page', extensionHandlers, __rendererExtensionOptions, getExtensionHeight)=>{
    const editorAnalyticsAPI = (0, $hS1eb.getEditorAnalyticsAPI)(contentId, createAnalyticsEvent);
    const options = {
        editorAnalyticsAPI: editorAnalyticsAPI,
        appearance: appearance,
        featureFlags: {
            confluence_frontend_macro_interaction_design: true
        },
        externalObservers: [
            (0, $fySJw.getConnectDataListener)()
        ],
        extensionHandlers: extensionHandlers,
        __rendererExtensionOptions: __rendererExtensionOptions,
        getExtensionHeight: getExtensionHeight
    };
    return {
        ...(0, $7rgfa.createReferentiality)(options),
        options: options
    };
});
module.exports["getReferentialityContext"] = $dffc47041c3d315b$export$fdfa01513f7f82e4;

});

parcelRegister("fDSmg", function(module, exports) {
$parcel$export(module.exports, "referentialityPlugin", () => (parcelRequire("7rgfa")).referentialityPlugin);
$parcel$export(module.exports, "createReferentiality", () => (parcelRequire("7rgfa")).createReferentiality);
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $7rgfa = parcelRequire("7rgfa");


});

parcelRegister("7rgfa", function(module, exports) {

var $iAEsk = parcelRequire("iAEsk");


var $kpCD8 = parcelRequire("kpCD8");


var $51GYa = parcelRequire("51GYa");


var $czge2 = parcelRequire("czge2");


var $3JMJW = parcelRequire("3JMJW");


var $6SJ6d = parcelRequire("6SJ6d");


var $7EfEK = parcelRequire("7EfEK");


var $gkua4 = parcelRequire("gkua4");


var $2CPAu = parcelRequire("2CPAu");


var $bjg0G = parcelRequire("bjg0G");


var $3xuv0 = parcelRequire("3xuv0");


var $dOBRD = parcelRequire("dOBRD");


var $gyH45 = parcelRequire("gyH45");


var $d8HV0 = parcelRequire("d8HV0");

const $837fc35afdae8144$var$EmitterEvents = {
    TABLE_DELETED: 'TABLE_DELETED'
};
const $837fc35afdae8144$export$35dc45686fc2dbd7 = (node)=>{
    try {
        node.check();
        return true;
    } catch (err) {
        return false;
    }
};
const $837fc35afdae8144$var$allowedSource = (node, schema)=>{
    const nodeName = typeof node.type === 'string' ? node.type : node.type.name;
    return [
        schema.nodes.table?.name
    ].includes(nodeName) && node.attrs?.localId;
};
const $837fc35afdae8144$var$transformer = new (0, $3xuv0.JSONTransformer)();
const $837fc35afdae8144$var$memoizedEncodeNode = (0, $dOBRD.default)((node)=>$837fc35afdae8144$var$transformer.encodeNode(node));
function $837fc35afdae8144$var$createPlugin(providerFactory, extensionHandlers, extensionLoadingHandlers, portalProviderAPI, eventDispatcher, externalObservers, options = {}, pluginInjectionApi, api, featureFlags, __livePage, __rendererExtensionOptions) {
    const macroInteractionDesignFeatureFlags = {
        showMacroInteractionDesignUpdates: !!featureFlags?.[0, $d8HV0.MACRO_INTERACTION_DESIGN_UPDATES]
    };
    const showLivePagesBodiedMacrosRendererView = __rendererExtensionOptions?.isAllowedToUseRendererView;
    const extensionNodeViewOptions = {
        appearance: options.appearance,
        getExtensionHeight: options.getExtensionHeight
    };
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $51GYa.pluginKey),
        state: {
            init () {
                const dataSourceProvider = new (0, $czge2.DataSourceProvider)();
                const nodeMutationObserver = new (0, $3JMJW.NodeMutationObserver)(dataSourceProvider);
                externalObservers.forEach((externalObserver)=>externalObserver.init({
                        emit: (localId, data)=>dataSourceProvider.createOrUpdate(localId, data)
                    }));
                return {
                    dataSourceProvider: dataSourceProvider,
                    nodeMutationObserver: nodeMutationObserver,
                    changedSources: new Map(),
                    selectedNodeLocalId: undefined
                };
            },
            apply (tr, pluginState, state, ns) {
                let selectedNodeLocalId = pluginState.selectedNodeLocalId;
                if (!!api && !state.selection.eq(ns.selection)) {
                    const supportedNodeTypes = (0, $gyH45.getNodeTypesSupported)(state.schema);
                    const { fragment: fragment } = state.schema.marks;
                    const selectedNode = (0, $bjg0G.findSelectedNodeOfType)(supportedNodeTypes)(tr.selection) || (0, $bjg0G.findParentNodeOfType)(supportedNodeTypes)(tr.selection);
                    selectedNodeLocalId = selectedNode?.node && (fragment?.isInSet(selectedNode?.node.marks)?.attrs.localId || selectedNode?.node.attrs.localId);
                }
                const selectedLocalIdChanged = selectedNodeLocalId !== pluginState.selectedNodeLocalId;
                if (!tr.docChanged) return selectedLocalIdChanged ? {
                    ...pluginState,
                    selectedNodeLocalId: selectedNodeLocalId
                } : pluginState;
                const changedSources = new Map();
                for (const [pos, node] of pluginState.changedSources.entries()){
                    const newPos = tr.mapping.map(pos);
                    changedSources.set(newPos, node);
                }
                // Handle added/updated table node
                const changedNodes = (0, $6SJ6d.getChangedNodes)(tr).filter(({ node: node })=>{
                    // Since we are calling node validation with every interaction in useDispatchTransaction, we can safely drop the check node here to improve performance.
                    // More details: https://hello.atlassian.net/wiki/spaces/~70121ba36f99acdb4453d8f80fd8186963f3e/pages/5081212079/Optimising+typing+latency#Bonus
                    return tr.getMeta('uiEvent') !== 'cut' && $837fc35afdae8144$var$allowedSource(node, state.schema);
                });
                changedNodes.forEach(({ node: sourceNode, pos: pos })=>{
                    changedSources.set(pos, sourceNode);
                });
                if (changedNodes.length) return {
                    ...pluginState,
                    changedSources: changedSources,
                    selectedNodeLocalId: selectedNodeLocalId
                };
                if (selectedLocalIdChanged) return {
                    ...pluginState,
                    selectedNodeLocalId: selectedNodeLocalId
                };
                return pluginState;
            }
        },
        view: (editorView)=>{
            api?.attach(editorView);
            const tableNodeSchema = editorView.state.schema.nodes.table;
            const pluginState = (0, $51GYa.getPluginState)(editorView.state);
            if (!pluginState) return {};
            let handleDeleteDataSource;
            const dataSourceProvider = pluginState.dataSourceProvider;
            const nodeMutationObserver = pluginState.nodeMutationObserver;
            if (dataSourceProvider) {
                handleDeleteDataSource = (node)=>{
                    if (node && node.attrs) {
                        let tableExistsInDoc = false;
                        // ensure the destroyed node is actually not recreated
                        (0, $bjg0G.findChildrenByType)(editorView.state.doc, tableNodeSchema).forEach(({ node: existingNode })=>{
                            if (existingNode.attrs.localId === node.attrs.localId) tableExistsInDoc = true;
                        });
                        if (!tableExistsInDoc) dataSourceProvider.delete(node.attrs.localId);
                    }
                };
                eventDispatcher.on($837fc35afdae8144$var$EmitterEvents.TABLE_DELETED, handleDeleteDataSource);
            }
            if (nodeMutationObserver) (0, $bjg0G.findChildrenByType)(editorView.state.doc, tableNodeSchema).forEach(({ node: node })=>{
                const fragmentLocalId = node?.marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
                if (fragmentLocalId) nodeMutationObserver.emit(fragmentLocalId, {
                    get [(0, $gkua4.ADFReferenceTypes).TABLE] () {
                        return $837fc35afdae8144$var$memoizedEncodeNode(node);
                    }
                });
                nodeMutationObserver.emit(node.attrs.localId, {
                    get [(0, $gkua4.ADFReferenceTypes).TABLE] () {
                        return $837fc35afdae8144$var$memoizedEncodeNode(node);
                    }
                });
            });
            return {
                update (view, prevState) {
                    const pluginState = (0, $51GYa.getPluginState)(view.state);
                    if (!pluginState) return;
                    const prevPluginState = (0, $51GYa.getPluginState)(prevState);
                    const { changedSources: changedSources, nodeMutationObserver: nodeMutationObserver, selectedNodeLocalId: selectedNodeLocalId } = pluginState;
                    if (selectedNodeLocalId !== prevPluginState?.selectedNodeLocalId) api?.setSelectedLocalId(selectedNodeLocalId);
                    changedSources.forEach((node, pos)=>{
                        const fragmentLocalId = node?.marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
                        if (fragmentLocalId) nodeMutationObserver.emit(fragmentLocalId, {
                            get [(0, $gkua4.ADFReferenceTypes).TABLE] () {
                                return $837fc35afdae8144$var$memoizedEncodeNode(node);
                            }
                        });
                        if (node.attrs?.localId) nodeMutationObserver.emit(node.attrs.localId, {
                            get [(0, $gkua4.ADFReferenceTypes).TABLE] () {
                                return $837fc35afdae8144$var$memoizedEncodeNode(node);
                            }
                        });
                    });
                    changedSources.clear();
                },
                destroy () {
                    api?.detach();
                    if (dataSourceProvider) {
                        eventDispatcher.off($837fc35afdae8144$var$EmitterEvents.TABLE_DELETED, handleDeleteDataSource);
                        if (dataSourceProvider.clear) dataSourceProvider.clear();
                    }
                }
            };
        },
        props: {
            nodeViews: {
                // WARNING: these need to be kept in sync with the nodeViews
                // setup in the extension plugin.
                extension: (0, $7EfEK.default)(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionLoadingHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, undefined, undefined, undefined, (0, $iAEsk.isSSRStreaming)() ? options.intl : undefined),
                // WARNING: these need to be kept in sync with the nodeViews
                // setup in the extension plugin.
                bodiedExtension: (0, $7EfEK.default)(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionLoadingHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, showLivePagesBodiedMacrosRendererView, __rendererExtensionOptions?.showUpdated1PBodiedExtensionUI, __rendererExtensionOptions?.rendererExtensionHandlers, (0, $iAEsk.isSSRStreaming)() ? options.intl : undefined),
                // WARNING: these need to be kept in sync with the nodeViews
                // setup in the extension plugin.
                inlineExtension: (0, $7EfEK.default)(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionLoadingHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, undefined, undefined, undefined, (0, $iAEsk.isSSRStreaming)() ? options.intl : undefined)
            }
        }
    });
}
const $837fc35afdae8144$export$9d03c288c4007750 = ({ config: options, api: pluginInjectionApi })=>({
        name: 'referentiality',
        pmPlugins () {
            return [
                {
                    name: 'referentiality',
                    plugin: ({ providerFactory: providerFactory, portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, getIntl: getIntl })=>{
                        const extensionHandlers = options?.extensionHandlers ?? {};
                        const extensionLoadingHandlers = pluginInjectionApi?.extension?.actions.getExtensionLoadingHandlers();
                        const externalObservers = options?.externalObservers ?? [];
                        return $837fc35afdae8144$var$createPlugin(providerFactory, extensionHandlers, extensionLoadingHandlers, portalProviderAPI, eventDispatcher, externalObservers, {
                            appearance: options?.appearance,
                            getExtensionHeight: options?.getExtensionHeight,
                            intl: getIntl()
                        }, pluginInjectionApi, options?.api, options?.featureFlags, options?.__livePage, options?.__rendererExtensionOptions);
                    }
                }
            ];
        }
    });
const $837fc35afdae8144$export$7e7e0965a9844ba0 = (options)=>{
    const api = options?.api ?? new (0, $2CPAu.ReferentialityAPIImpl)(options);
    return {
        api: api,
        plugin: $837fc35afdae8144$export$9d03c288c4007750({
            config: {
                ...options,
                api: api
            }
        })
    };
};
module.exports["referentialityPlugin"] = $837fc35afdae8144$export$9d03c288c4007750;
module.exports["createReferentiality"] = $837fc35afdae8144$export$7e7e0965a9844ba0;

});

parcelRegister("51GYa", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $8d1e28cdb2c4f2cf$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('referentialityPlugin');
const $8d1e28cdb2c4f2cf$export$f05434c51e3762e = (state)=>state && $8d1e28cdb2c4f2cf$export$18d4026d1ea86bb1.getState(state);
module.exports["pluginKey"] = $8d1e28cdb2c4f2cf$export$18d4026d1ea86bb1;
module.exports["getPluginState"] = $8d1e28cdb2c4f2cf$export$f05434c51e3762e;

});

parcelRegister("3JMJW", function(module, exports) {
class $585a51fa0414d9ee$export$ab608a64509503ae {
    emit(id, adfReference) {
        this.dataSourceProvider.createOrUpdate(id, adfReference);
    }
    constructor(dataSourceProvider){
        this.dataSourceProvider = void 0;
        this.dataSourceProvider = dataSourceProvider;
    }
}
module.exports["NodeMutationObserver"] = $585a51fa0414d9ee$export$ab608a64509503ae;

});

parcelRegister("7EfEK", function(module, exports) {
$parcel$export(module.exports, "default", () => $0968ef814e0ae73c$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $1sE44 = parcelRequire("1sE44");

var $ak92H = parcelRequire("ak92H");


var $jnhwS = parcelRequire("jnhwS");


var $51GYa = parcelRequire("51GYa");

class $0968ef814e0ae73c$export$63dcdbe82ab2119 extends (0, $1sE44.ExtensionNode) {
    render(props, forwardRef) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ak92H.ExtensionNodeWrapper), {
            intl: props.intl,
            nodeType: this.node.type.name,
            macroInteractionDesignFeatureFlags: props.macroInteractionDesignFeatureFlags
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jnhwS.default), {
            editorAppearance: props.extensionNodeViewOptions.appearance,
            editorView: this.view,
            node: this.node,
            // The getPos arg is always a function when used with nodes
            // the version of the types we use has a union with the type
            // for marks.
            // This has been fixed in later versions of the definitly typed
            // types (and also in prosmirror-views inbuilt types).
            // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/57384
            getPos: this.getPos,
            providerFactory: props.providerFactory,
            handleContentDOMRef: forwardRef,
            extensionHandlers: props.extensionHandlers,
            extensionLoadingHandlers: props.extensionLoadingHandlers,
            dataSourceProvider: props.dataSourceProvider,
            pluginInjectionApi: props.pluginInjectionApi,
            macroInteractionDesignFeatureFlags: props.macroInteractionDesignFeatureFlags,
            showLivePagesBodiedMacrosRendererView: props.showLivePagesBodiedMacrosRendererView,
            showUpdatedLivePages1PBodiedExtensionUI: props.showUpdatedLivePages1PBodiedExtensionUI,
            rendererExtensionHandlers: props.rendererExtensionHandlers
        }));
    }
}
function $0968ef814e0ae73c$export$2e2bcd8739ae039(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionLoadingHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI, rendererExtensionHandlers, intl) {
    return (node, view, getPos)=>{
        const pluginState = (0, $51GYa.getPluginState)(view.state);
        return new $0968ef814e0ae73c$export$63dcdbe82ab2119(node, view, getPos, portalProviderAPI, eventDispatcher, {
            providerFactory: providerFactory,
            extensionHandlers: extensionHandlers,
            extensionLoadingHandlers: extensionLoadingHandlers,
            extensionNodeViewOptions: extensionNodeViewOptions,
            dataSourceProvider: pluginState?.dataSourceProvider,
            pluginInjectionApi: pluginInjectionApi,
            macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
            showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
            showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
            rendererExtensionHandlers: rendererExtensionHandlers,
            intl: intl
        }).init();
    };
}

});

parcelRegister("1sE44", function(module, exports) {
$parcel$export(module.exports, "default", () => $1edd959af8b178b3$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");


var $4iudd = parcelRequire("4iudd");


var $Igylv = parcelRequire("Igylv");


var $Mf8oW = parcelRequire("Mf8oW");


var $ak92H = parcelRequire("ak92H");

/**
 * Allowlists of extension keys + layout
 * Currently, only toc with default layout allows to skip React render.
 * Extensions NOT in this list always follow the normal React render path.
 */ const $1edd959af8b178b3$var$ssrHydrationExtensionAllowlist = [
    'toc'
];
const $1edd959af8b178b3$var$ssrHydrationLayoutAllowlist = [
    'default'
];
const $1edd959af8b178b3$var$isSSRHydrationEligible = (node)=>{
    if (node.type.name !== 'extension') return false;
    const { extensionKey: extensionKey, layout: layout } = node.attrs ?? {};
    if (!$1edd959af8b178b3$var$ssrHydrationExtensionAllowlist.includes(extensionKey)) return false;
    // Treat a missing layout attr as `default` (the schema default).
    const effectiveLayout = layout ?? 'default';
    return $1edd959af8b178b3$var$ssrHydrationLayoutAllowlist.includes(effectiveLayout);
};
/**
 * Per-(EditorView, extensionKey + localId) record of which extension identities
 * have already had their initial-hydration init pass. SSR DOM reuse is only valid
 * the very first time an ExtensionNode init runs for a given identity in a given
 * editor — that is the only moment a real SSR-rendered element for that identity
 * can exist in the editor DOM.
 *
 * After the first init, any element matching the SSR selector is the previous
 * node view's React-rendered domRef that ProseMirror has not yet detached (e.g.
 * during DnD / layout resize, where ProseMirror constructs the new node view
 * BEFORE destroying the old one). Reusing it as if it were SSR DOM causes the
 * new node view to skip React rendering and leaves the extension invisible
 * (EDITOR-6613).
 */ const $1edd959af8b178b3$var$consumedHydrationIdentitiesByEditor = new WeakMap();
const $1edd959af8b178b3$var$getHydrationIdentityKey = (extensionKey, localId)=>{
    if (typeof extensionKey !== 'string' || typeof localId !== 'string') return null;
    if (extensionKey === '' || localId === '') return null;
    return `${extensionKey}::${localId}`;
};
const $1edd959af8b178b3$var$hasHydrationIdentityBeenConsumed = (view, identityKey)=>{
    const consumed = $1edd959af8b178b3$var$consumedHydrationIdentitiesByEditor.get(view);
    return consumed ? consumed.has(identityKey) : false;
};
const $1edd959af8b178b3$var$markHydrationIdentityAsConsumed = (view, identityKey)=>{
    let consumed = $1edd959af8b178b3$var$consumedHydrationIdentitiesByEditor.get(view);
    if (!consumed) {
        consumed = new Set();
        $1edd959af8b178b3$var$consumedHydrationIdentitiesByEditor.set(view, consumed);
    }
    consumed.add(identityKey);
};
class $1edd959af8b178b3$export$456a23774b90f061 extends (0, $Igylv.default) {
    ignoreMutation(mutation) {
        // Extensions can perform async operations that will change the DOM.
        // To avoid having their tree rebuilt, we need to ignore the mutation
        // for atom based extensions if its not a layout, we need to give
        // children a chance to recalc
        return this.node.type.isAtom || mutation.type !== 'selection' && mutation.attributeName !== 'data-layout';
    }
    /** See {@link consumedHydrationIdentitiesByEditor}. Null when attrs are missing → SSR reuse skipped. */ getHydrationIdentityKey() {
        return $1edd959af8b178b3$var$getHydrationIdentityKey(this.node.attrs?.extensionKey, this.node.attrs?.localId);
    }
    /** True only for the first ExtensionNode of this identity in this editor. See {@link consumedHydrationIdentitiesByEditor}. */ isInInitialHydrationWindow() {
        const identityKey = this.getHydrationIdentityKey();
        if (identityKey === null) return false;
        return !$1edd959af8b178b3$var$hasHydrationIdentityBeenConsumed(this.view, identityKey);
    }
    // Reserve height by setting a minimum height for the extension node view element
    createDomRef() {
        if (!(0, $ixfCV.fg)('confluence_connect_macro_preset_height')) {
            // SSR DOM reuse — see {@link consumedHydrationIdentitiesByEditor}.
            if (!(0, $4iudd.isSSR)() && $1edd959af8b178b3$var$isSSRHydrationEligible(this.node) && this.isInInitialHydrationWindow() && (0, $ieeJu.expValEquals)('platform_editor_hydration_skip_react_portal', 'isEnabled', true)) {
                const ssrElement = this.findSSRElement();
                if (ssrElement) {
                    this.didReuseSsrDom = true;
                    return ssrElement;
                }
            }
            return super.createDomRef();
        }
        if (!this.node.isInline) {
            const htmlElement = document.createElement('div');
            const extensionHeight = this.reactComponentProps?.extensionNodeViewOptions?.getExtensionHeight?.(this.node);
            if (extensionHeight) htmlElement.style.setProperty('min-height', `${extensionHeight}px`);
            return htmlElement;
        }
        const htmlElement = document.createElement('span');
        return htmlElement;
    }
    /**
   * Attempts to find an existing SSR'd DOM element for this extension node by extensionKey and localId
   * which should uniquely identify the
   * extension node within the editor content.
   *
   * @returns The SSR'd element if found, otherwise null
   */ findSSRElement() {
        if (this.cachedSsrElement !== undefined) return this.cachedSsrElement || null;
        const extensionKey = this.node.attrs.extensionKey;
        const localId = this.node.attrs.localId;
        const editorDom = this.view.dom;
        if (extensionKey && localId) {
            const selector = `[extensionkey="${extensionKey}"][localid="${localId}"]`;
            const element = editorDom.querySelector(selector);
            if (element && element instanceof HTMLElement) {
                this.cachedSsrElement = element;
                return element;
            }
        }
        this.cachedSsrElement = null;
        return null;
    }
    /** Skip React Portal render on first init when reusing SSR DOM. See {@link consumedHydrationIdentitiesByEditor}. */ init() {
        if (!(0, $ieeJu.expValEquals)('platform_editor_hydration_skip_react_portal', 'isEnabled', true)) super.init();
        else {
            const isEligibleForSsrReuse = !(0, $4iudd.isSSR)() && $1edd959af8b178b3$var$isSSRHydrationEligible(this.node);
            if (isEligibleForSsrReuse && this.isInInitialHydrationWindow()) {
                const ssrElement = this.findSSRElement();
                const shouldSkipInitRender = ssrElement !== null;
                super.init(shouldSkipInitRender);
                const identityKey = this.getHydrationIdentityKey();
                if (identityKey !== null) // Close the hydration window — see {@link consumedHydrationIdentitiesByEditor}.
                $1edd959af8b178b3$var$markHydrationIdentityAsConsumed(this.view, identityKey);
            } else super.init();
        }
        return this;
    }
    update(node, decorations, _innerDecorations, validUpdate = ()=>true) {
        // Remove extensionNodeWrapper aka span.relative if we previously reused SSR DOM
        // control is back to React afterwards
        if (this.didReuseSsrDom && (0, $ieeJu.expValEquals)('platform_editor_hydration_skip_react_portal', 'isEnabled', true)) {
            const ssrElement = this.findSSRElement();
            if (ssrElement) {
                const extensionNodeWrapper = ssrElement.querySelector('[data-testid="extension-node-wrapper"]');
                if (extensionNodeWrapper) extensionNodeWrapper.remove();
                this.didReuseSsrDom = false;
            }
        }
        return super.update(node, decorations, _innerDecorations, validUpdate);
    }
    /**
   * Prevents ProseMirror from handling events that belong to the extension's React UI.
   *
   * For multibodied extensions: the node consists of a React app (e.g. tab bar) that controls
   * frames, and the editable frames themselves. Events inside frames must reach ProseMirror
   * for normal editing; events in the surrounding React app (buttons, navigation) are stopped
   * so ProseMirror doesn't create a NodeSelection on the entire node.
   *
   * For other extensions: input/textarea events are stopped so users can interact
   * with form elements inside the extension body without the editor intercepting them.
   */ stopEvent(event) {
        if (this.node.type.name === 'multiBodiedExtension') {
            const target = event.target;
            if (target instanceof Element) {
                if (target.closest('[data-multibodiedextension-frames]')) return false;
                return !!target.closest('[data-multiBodiedExtension-container]');
            }
            return false;
        }
        return event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement;
    }
    getContentDOM() {
        if (this.node.isInline) return;
        if (this.didReuseSsrDom) return;
        const contentDomWrapper = document.createElement('div');
        contentDomWrapper.className = `${this.node.type.name}-content-dom-wrapper`;
        const isBodiedExtension = this.node.type.name === 'bodiedExtension';
        const showMacroInteractionDesignUpdates = this.reactComponentProps?.macroInteractionDesignFeatureFlags?.showMacroInteractionDesignUpdates;
        if (isBodiedExtension && showMacroInteractionDesignUpdates && (0, $ieeJu.expValEquals)('platform_editor_bodiedextension_layoutshift_fix', 'isEnabled', true)) {
            // Create outer wrapper to hold space for the lozenge
            const outerWrapper = document.createElement('div');
            outerWrapper.className = `${this.node.type.name}-content-outer-wrapper`;
            // Create inner wrapper to position inner content
            const innerWrapper = document.createElement('div');
            innerWrapper.className = `${this.node.type.name}-content-inner-wrapper`;
            innerWrapper.appendChild(contentDomWrapper);
            outerWrapper.appendChild(innerWrapper);
            return {
                dom: outerWrapper,
                contentDOM: contentDomWrapper
            };
        }
        return {
            dom: contentDomWrapper
        };
    }
    render(props, forwardRef) {
        // While sitting on SSR DOM, skip the React portal — see {@link didReuseSsrDom}.
        if (this.didReuseSsrDom) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ak92H.ExtensionNodeWrapper), {
            intl: props.intl,
            nodeType: this.node.type.name,
            macroInteractionDesignFeatureFlags: props.macroInteractionDesignFeatureFlags
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Mf8oW.Extension), {
            editorView: this.view,
            node: this.node,
            eventDispatcher: this.eventDispatcher,
            // The getPos arg is always a function when used with nodes
            // the version of the types we use has a union with the type
            // for marks.
            // This has been fixed in later versions of the definitly typed
            // types (and also in prosmirror-views inbuilt types).
            // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/57384
            getPos: this.getPos,
            providerFactory: props.providerFactory,
            handleContentDOMRef: forwardRef,
            extensionHandlers: props.extensionHandlers,
            extensionLoadingHandlers: props.extensionLoadingHandlers,
            editorAppearance: props.extensionNodeViewOptions?.appearance,
            pluginInjectionApi: props.pluginInjectionApi,
            macroInteractionDesignFeatureFlags: props.macroInteractionDesignFeatureFlags,
            showLivePagesBodiedMacrosRendererView: props.showLivePagesBodiedMacrosRendererView,
            showUpdatedLivePages1PBodiedExtensionUI: props.showUpdatedLivePages1PBodiedExtensionUI,
            rendererExtensionHandlers: props.rendererExtensionHandlers
        }));
    }
    constructor(...args){
        super(...args);
        /** True between SSR DOM adoption in `createDomRef` and the SSR→React handoff in `update`. */ this.didReuseSsrDom = false;
        /**
     * Cache for SSR element lookup to avoid repeated DOM queries.
     * undefined = not yet searched, null = searched but not found, HTMLElement = found
     */ this.cachedSsrElement = void 0;
    }
}
function $1edd959af8b178b3$export$2e2bcd8739ae039(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionLoadingHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI, rendererExtensionHandlers, intl) {
    return (node, view, getPos)=>{
        return new $1edd959af8b178b3$export$456a23774b90f061(node, view, getPos, portalProviderAPI, eventDispatcher, {
            providerFactory: providerFactory,
            extensionHandlers: extensionHandlers,
            extensionLoadingHandlers: extensionLoadingHandlers,
            extensionNodeViewOptions: extensionNodeViewOptions,
            pluginInjectionApi: pluginInjectionApi,
            macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
            showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
            showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
            rendererExtensionHandlers: rendererExtensionHandlers,
            intl: intl
        }).init();
    };
}
module.exports["ExtensionNode"] = $1edd959af8b178b3$export$456a23774b90f061;

});

parcelRegister("Igylv", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $cozmU = parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $4iudd = parcelRequire("4iudd");

var $iAEsk = parcelRequire("iAEsk");


var $fGIRV = parcelRequire("fGIRV");


var $h75sz = parcelRequire("h75sz");


var $iAPNA = parcelRequire("iAPNA");

var $aTBle = parcelRequire("aTBle");


var $6pnwK = parcelRequire("6pnwK");


var $4HBuC = parcelRequire("4HBuC");


var $3k3tn = parcelRequire("3k3tn");


var $g9sVl = parcelRequire("g9sVl");

class $f03b41aa25e7d4ac$export$2e2bcd8739ae039 {
    /**
   * This method exists to move initialization logic out of the constructor,
   * so object can be initialized properly before calling render first time.
   *
   * Example:
   * Instance properties get added to an object only after super call in
   * constructor, which leads to some methods being undefined during the
   * first render.
   */ init(shouldSkipInitRender = false) {
        this.domRef = this.createDomRef();
        this.setDomAttrs(this.node, this.domRef);
        const { dom: contentDOMWrapper, contentDOM: contentDOM } = this.getContentDOM() || {
            dom: undefined,
            contentDOM: undefined
        };
        if (this.domRef && contentDOMWrapper) {
            this.domRef.appendChild(contentDOMWrapper);
            this.contentDOM = contentDOM ? contentDOM : contentDOMWrapper;
            this.contentDOMWrapper = contentDOMWrapper || contentDOM;
        }
        // @see ED-3790
        // something gets messed up during mutation processing inside of a
        // nodeView if DOM structure has nested plain "div"s, it doesn't see the
        // difference between them and it kills the nodeView
        this.domRef.classList.add(`${this.node.type.name}View-content-wrap`);
        const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $iAPNA.getPerformanceOptions)(this.view);
        trackingEnabled && (0, $aTBle.startMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name
        });
        if (!shouldSkipInitRender) {
            this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
            // During SSR, renderToStaticMarkup + container.innerHTML (in portal) clobbers the
            // contentDOMWrapper that was appended above. The React ref callback
            // (forwardRef) never fires in renderToStaticMarkup, so contentDOM is
            // left detached. Re-attach it by finding the marked SSR ref target.
            if ((0, $4iudd.isSSR)() && (0, $iAEsk.isSSRStreaming)() && this.domRef) {
                const refTarget = this.domRef.querySelector('[data-ssr-content-dom-ref]');
                if (refTarget) {
                    this.handleRef(refTarget);
                    // The marker is only needed to locate the re-attach target during
                    // this SSR pass. Remove it so it doesn't leak into the streamed
                    // HTML (it has no meaning on the client).
                    refTarget.removeAttribute('data-ssr-content-dom-ref');
                }
            }
        }
        trackingEnabled && (0, $iAPNA.stopMeasureReactNodeViewRendered)({
            nodeTypeName: this.node.type.name,
            dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
            samplingRate: samplingRate,
            slowThreshold: slowThreshold
        });
        return this;
    }
    // Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderReactComponent(component) {
        if (!this.domRef || !component) return;
        const componentWithErrorBoundary = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h75sz.ErrorBoundary), {
                component: (0, $krYZG.ACTION_SUBJECT).REACT_NODE_VIEW,
                componentId: this?.node?.type?.name ?? (0, $krYZG.ACTION_SUBJECT_ID).UNKNOWN_NODE,
                dispatchAnalyticsEvent: this.dispatchAnalyticsEvent
            }, component());
        this.portalProviderAPI.render(componentWithErrorBoundary, // Spreading props to pass through dynamic component props
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.domRef, this.key, undefined, this.shouldRenderImmediatelyInPortal);
    }
    createDomRef() {
        if (!this.node.isInline) return document.createElement('div');
        const htmlElement = document.createElement('span');
        return htmlElement;
    }
    getContentDOM() {
        return undefined;
    }
    _handleRef(node) {
        const contentDOM = this.contentDOMWrapper || this.contentDOM;
        // @ts-ignore
        // Spreading props to pass through dynamic component props
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let oldIgnoreMutation;
        let selectionBookmark;
        let mutationsIgnored = false;
        // move the contentDOM node inside the inner reference after rendering
        if (node && contentDOM && !node.contains(contentDOM)) {
            // @ts-ignore - ignoreMutation may not be declared
            oldIgnoreMutation = this.ignoreMutation; // store ref to previous ignoreMutation
            // ignore all mutations caused by ProseMirror's MutationObserver triggering
            // after DOM change, except selection changes
            // @ts-ignore ProseMirror adds selection type to MutationRecord
            this.ignoreMutation = (m)=>{
                const isSelectionMutation = m.type === 'selection';
                if (!isSelectionMutation) mutationsIgnored = true;
                return !isSelectionMutation;
            };
            // capture document selection state before React DOM changes triggers ProseMirror selection change transaction
            if (this.view.state.selection.visible) selectionBookmark = this.view.state.selection.getBookmark();
            node.appendChild(contentDOM);
            // After the next frame:
            requestAnimationFrame(()=>{
                // Restore the original mutation handler
                // @ts-ignore - this may not have been declared by implementing class
                this.ignoreMutation = oldIgnoreMutation;
                // Restore the selection only if:
                // - We have a selection bookmark
                // - Mutations were ignored during the table move
                // - The bookmarked selection is different from the current selection.
                if (selectionBookmark && mutationsIgnored) {
                    const resolvedSelection = selectionBookmark.resolve(this.view.state.tr.doc);
                    // Don't set the selection if it's the same as the current selection.
                    if (!resolvedSelection.eq(this.view.state.selection)) {
                        const tr = this.view.state.tr.setSelection(resolvedSelection);
                        tr.setMeta('source', 'ReactNodeView:_handleRef:selection-resync');
                        this.view.dispatch(tr);
                    }
                }
            });
        }
    }
    // Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    render(props, forwardRef) {
        return this.reactComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(this.reactComponent, {
            view: this.view,
            getPos: this.getPos,
            node: this.node,
            forwardRef: forwardRef,
            ...props
        }) : null;
    }
    update(node, decorations, _innerDecorations, validUpdate = ()=>true) {
        // @see https://github.com/ProseMirror/prosemirror/issues/648
        const isValidUpdate = this.node.type === node.type && validUpdate(this.node, node);
        this.decorations = decorations;
        if (!isValidUpdate) return false;
        if (this.domRef && !this.node.sameMarkup(node)) this.setDomAttrs(node, this.domRef);
        // View should not process a re-render if this is false.
        // We dont want to destroy the view, so we return true.
        // TODO: ED-13910 - Fix viewShouldUpdate readonly decoration array
        if (!this.viewShouldUpdate(node, decorations)) {
            this.node = node;
            return true;
        }
        this.node = node;
        this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
        return true;
    }
    viewShouldUpdate(nextNode, _decorations) {
        if (this._viewShouldUpdate) return this._viewShouldUpdate(nextNode);
        return true;
    }
    /**
   * Copies the attributes from a ProseMirror Node to a DOM node.
   * @param node The Prosemirror Node from which to source the attributes
   */ setDomAttrs(node, element) {
        Object.keys(node.attrs || {}).forEach((attr)=>{
            element.setAttribute(attr, node.attrs[attr]);
        });
    }
    get dom() {
        // Only return reference if domRef is defined
        if (this.domRef === undefined) //raise an error
        throw new Error('domRef is not defined or may have been destroyed');
        // Spreading props to pass through dynamic component props
        return this.domRef;
    }
    destroy() {
        if (!this.domRef) return;
        this.portalProviderAPI.remove(this.key);
        this.domRef = undefined;
        this.contentDOM = undefined;
    }
    static fromComponent(// Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component, portalProviderAPI, eventDispatcher, props, viewShouldUpdate) {
        return (node, view, getPos)=>new $f03b41aa25e7d4ac$export$2e2bcd8739ae039(node, view, getPos, portalProviderAPI, eventDispatcher, props, component, viewShouldUpdate).init();
    }
    constructor(_node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, // Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reactComponent, viewShouldUpdate, shouldRenderImmediatelyInPortal){
        this.domRef = void 0;
        this.contentDOMWrapper = void 0;
        // Spreading props to pass through dynamic component props
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.reactComponent = void 0;
        this.portalProviderAPI = void 0;
        this._viewShouldUpdate = void 0;
        this.eventDispatcher = void 0;
        this.decorations = [];
        this.reactComponentProps = void 0;
        this.view = void 0;
        this.getPos = void 0;
        this.contentDOM = void 0;
        this.node = void 0;
        this.key = void 0;
        this.shouldRenderImmediatelyInPortal = void 0;
        this.handleRef = (node)=>this._handleRef(node);
        this.dispatchAnalyticsEvent = (payload)=>{
            if (this.eventDispatcher) {
                const dispatch = (0, $fGIRV.createDispatch)(this.eventDispatcher);
                dispatch((0, $6pnwK.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        this.node = _node;
        this.view = view;
        this.getPos = getPos;
        this.portalProviderAPI = portalProviderAPI;
        this.reactComponentProps = reactComponentProps || {};
        this.reactComponent = reactComponent;
        this._viewShouldUpdate = viewShouldUpdate;
        this.eventDispatcher = eventDispatcher;
        this.key = (0, $4HBuC.generateUniqueNodeKey)();
        this.shouldRenderImmediatelyInPortal = shouldRenderImmediatelyInPortal || false;
    }
}
module.exports["default"] = $f03b41aa25e7d4ac$export$2e2bcd8739ae039;

});

parcelRegister("4HBuC", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $iwjSV = parcelRequire("iwjSV");

const $1746cd4e14fa5645$export$4a323a0542a1e4d1 = ()=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    return (0, (/*@__PURE__*/$parcel$interopDefault($iwjSV)))();
};
module.exports["generateUniqueNodeKey"] = $1746cd4e14fa5645$export$4a323a0542a1e4d1;

});

parcelRegister("3k3tn", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $aPdNQ = parcelRequire("aPdNQ");


var $ixfCV = parcelRequire("ixfCV");


var $krYZG = parcelRequire("krYZG");


var $4iudd = parcelRequire("4iudd");


var $h75sz = parcelRequire("h75sz");


var $6pnwK = parcelRequire("6pnwK");

var $iAPNA = parcelRequire("iAPNA");

var $aTBle = parcelRequire("aTBle");


var $8dxef = parcelRequire("8dxef");


var $fngNp = parcelRequire("fngNp");


var $4HBuC = parcelRequire("4HBuC");


var $6EnhY = parcelRequire("6EnhY");

const $d2b8a7e0987cd11a$export$dfb58b577a6f1cd9 = 'inlineNodeView';
const $d2b8a7e0987cd11a$var$canRenderFallback = (node)=>{
    return node.type.isInline && node.type.isAtom && node.type.isLeaf;
};
// list of inline nodes with toDOM fallback implementations that can be virtualized. As
// additional nodes are converted they should be added here
const $d2b8a7e0987cd11a$var$virtualizedNodeAllowlist = [
    'inlineCard'
];
function $d2b8a7e0987cd11a$var$createNodeView({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $4HBuC.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $d2b8a7e0987cd11a$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$d2b8a7e0987cd11a$export$dfb58b577a6f1cd9}`);
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $6pnwK.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($d2b8a7e0987cd11a$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key);
    }
    const { samplingRate: samplingRate, slowThreshold: slowThreshold, trackingEnabled: trackingEnabled } = (0, $iAPNA.getPerformanceOptions)(nodeViewParams.view);
    trackingEnabled && (0, $aTBle.startMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name
    });
    // We render the component while creating the node view
    renderComponent();
    trackingEnabled && (0, $iAPNA.stopMeasureReactNodeViewRendered)({
        nodeTypeName: currentNode.type.name,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        samplingRate: samplingRate,
        slowThreshold: slowThreshold
    });
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $d2b8a7e0987cd11a$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            renderComponent();
            return true;
        },
        destroy () {
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
function $d2b8a7e0987cd11a$var$createNodeViewVirtualized({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $4HBuC.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $d2b8a7e0987cd11a$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$d2b8a7e0987cd11a$export$dfb58b577a6f1cd9}`);
    function onBeforeReactDomRender() {
        if (!fallbackRef.current) return;
        domRef.removeChild(fallbackRef.current);
        fallbackRef.current = null;
    }
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $6pnwK.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($d2b8a7e0987cd11a$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key, onBeforeReactDomRender);
    }
    let didRenderComponentWithIntersectionObserver = false;
    let destroyed = false;
    let removeIntersectionObserver = ()=>{};
    function renderFallback() {
        if (!$d2b8a7e0987cd11a$var$canRenderFallback(currentNode) || typeof currentNode.type?.spec?.toDOM !== 'function') return;
        const fallback = (0, $aPdNQ.DOMSerializer).renderSpec(document, currentNode.type.spec.toDOM(currentNode));
        const dom = fallback.dom;
        fallbackRef.current = dom;
        domRef.replaceChildren(dom);
    }
    function attachNodeViewObserver() {
        const observer = (0, $6EnhY.getOrCreateOnVisibleObserver)(nodeViewParams.view);
        if (domRef) removeIntersectionObserver = observer.observe(domRef, ()=>{
            if (!didRenderComponentWithIntersectionObserver && !destroyed) {
                renderComponent();
                didRenderComponentWithIntersectionObserver = true;
            }
        });
    }
    renderFallback();
    // allow the fallback to render first before attaching the observer.
    // Will tweak this in a follow up PR to optimise rendering of visible
    // nodes without fallback rendering.
    setTimeout(()=>{
        attachNodeViewObserver();
    }, 0);
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps,
        stopEvent: (event)=>{
            const maybeStopEvent = extraNodeViewProps?.stopEvent;
            if (typeof maybeStopEvent === 'function') return maybeStopEvent(event);
            return false;
        }
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $d2b8a7e0987cd11a$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            if (didRenderComponentWithIntersectionObserver) renderComponent();
            return true;
        },
        destroy () {
            removeIntersectionObserver();
            destroyed = true;
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
/**
 * Copies the attributes from a ProseMirror Node to a DOM node.
 * @param node The Prosemirror Node from which to source the attributes
 */ function $d2b8a7e0987cd11a$var$setDomAttrs(node, element) {
    Object.keys(node.attrs || {}).forEach((attr)=>{
        element.setAttribute(attr, node.attrs[attr]);
    });
}
function $d2b8a7e0987cd11a$var$getPortalChildren({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, currentNode: currentNode, nodeViewParams: nodeViewParams, Component: Component, extraComponentProps: extraComponentProps }) {
    return function portalChildren() {
        //  All inline nodes use `display: inline` to allow for multi-line
        //  wrapping. This does produce an issue in Chrome where it is not
        //  possible to click select the position after the node,
        //  see: https://product-fabric.atlassian.net/browse/ED-12003
        //  however this is only a problem for node views that use
        //  `display: inline-block` somewhere within the Component.
        //  Looking at the below structure, spans with className
        //  `inlineNodeViewAddZeroWidthSpace` have pseudo elements that
        //  add a zero width space which fixes the problem.
        //  Without the additional zero width space before the Component,
        //  it is not possible to use the keyboard to range select in Safari.
        //
        //  Zero width spaces on either side of the Component also prevent
        //  the cursor from appearing inside the node view on all browsers.
        //
        //  Note:
        //  In future it is worth considering prohibiting the use of `display: inline-block`
        //  within inline node view Components however would require a sizable
        //  refactor. A test suite to catch any instances of this is ideal however
        //  the refactor required is currently out of scope for https://product-fabric.atlassian.net/browse/ED-14176
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $h75sz.ErrorBoundary), {
            component: (0, $krYZG.ACTION_SUBJECT).REACT_NODE_VIEW,
            componentId: currentNode?.type?.name ?? (0, $krYZG.ACTION_SUBJECT_ID).UNKNOWN_NODE,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            className: `zeroWidthSpaceContainer`
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            className: `${$d2b8a7e0987cd11a$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }), (0, $fngNp.ZERO_WIDTH_SPACE)), /*#__PURE__*/ (0, $lOiVq.jsx)(Component, {
            view: nodeViewParams.view,
            // TODO: ED-13910 - Remove the boolean to fix the prosemirror view type
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getPos: nodeViewParams.getPos,
            node: currentNode,
            ...extraComponentProps
        }), (0, $8dxef.getBrowserInfo)().android ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            className: `zeroWidthSpaceContainer`,
            contentEditable: "false"
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            className: `${$d2b8a7e0987cd11a$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }), (0, $fngNp.ZERO_WIDTH_SPACE)) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            className: `${$d2b8a7e0987cd11a$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
        }));
    };
}
const $d2b8a7e0987cd11a$var$counterPerEditorViewMap = new WeakMap();
function $d2b8a7e0987cd11a$export$17a8c3162956317d({ pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    function nodeViewProducer(...nodeViewProducerParameters) {
        const view = nodeViewProducerParameters[1];
        const node = nodeViewProducerParameters[0];
        const parameters = {
            nodeViewParams: {
                node: node,
                view: view,
                getPos: nodeViewProducerParameters[2],
                decorations: nodeViewProducerParameters[3]
            },
            pmPluginFactoryParams: pmPluginFactoryParams,
            Component: Component,
            extraComponentProps: extraComponentProps,
            extraNodeViewProps: extraNodeViewProps
        };
        const isNodeTypeAllowedToBeVirtualized = $d2b8a7e0987cd11a$var$virtualizedNodeAllowlist.includes(node?.type?.name || '');
        if (!isNodeTypeAllowedToBeVirtualized || (0, $4iudd.isSSR)()) return $d2b8a7e0987cd11a$var$createNodeView(parameters);
        if ((0, $ixfCV.fg)('platform_editor_inline_node_virt_threshold_override')) return $d2b8a7e0987cd11a$var$createNodeViewVirtualized(parameters);
        let inlineNodeViewsVirtualizationCounter = $d2b8a7e0987cd11a$var$counterPerEditorViewMap.get(view) || 0;
        inlineNodeViewsVirtualizationCounter += 1;
        $d2b8a7e0987cd11a$var$counterPerEditorViewMap.set(view, inlineNodeViewsVirtualizationCounter);
        // We never virtualize the 100th first elements
        if (inlineNodeViewsVirtualizationCounter <= 100) return $d2b8a7e0987cd11a$var$createNodeView(parameters);
        return $d2b8a7e0987cd11a$var$createNodeViewVirtualized(parameters);
    }
    return nodeViewProducer;
}
module.exports["getInlineNodeViewProducer"] = $d2b8a7e0987cd11a$export$17a8c3162956317d;

});

parcelRegister("6EnhY", function(module, exports) {
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $1UWNP = parcelRequire("1UWNP");

// Use this selector to set the intersection observer boundary for editor's inline node views
// If this does not exist, it will use the IntersectionObserver's default root
const $756975148395f764$var$INTERSECTION_OBSERVER_ROOT_SELECTOR = '[data-editor-scroll-container="true"]';
const $756975148395f764$var$INTERSECTION_OBSERVER_OPTIONS = {
    rootMargin: '0px 0px 100px 0px',
    threshold: 0
};
const $756975148395f764$export$d73c873f0a6a03c3 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((view)=>{
    const intersectionObserverOptions = {
        root: view.dom.closest($756975148395f764$var$INTERSECTION_OBSERVER_ROOT_SELECTOR),
        ...$756975148395f764$var$INTERSECTION_OBSERVER_OPTIONS
    };
    const callbackMap = new WeakMap();
    const observer = new IntersectionObserver((entries)=>{
        entries.filter((entry)=>entry.isIntersecting) // Only process visible entries
        .map((entry)=>callbackMap.get(entry.target))// Invoke callbacks together to group browser rendering
        // Avoiding requestAnimationFrame to reduce visual flickering
        .forEach((cb)=>cb?.());
    }, intersectionObserverOptions);
    return {
        observe: (el, callback)=>{
            callbackMap.set(el, callback);
            observer.observe(el);
            return ()=>observer.unobserve(el);
        }
    };
});
module.exports["getOrCreateOnVisibleObserver"] = $756975148395f764$export$d73c873f0a6a03c3;

});

parcelRegister("g9sVl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4iudd = parcelRequire("4iudd");


var $iAEsk = parcelRequire("iAEsk");

const $b7122d1a9520547e$export$27292f9d0a2a0aef = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ...props,
            ref: ref,
            "data-ssr-content-dom-ref": (0, $4iudd.isSSR)() && (0, $iAEsk.isSSRStreaming)() ? "" : undefined
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ...props,
        ref: ref,
        "data-ssr-content-dom-ref": (0, $4iudd.isSSR)() && (0, $iAEsk.isSSRStreaming)() ? '' : undefined
    }));
module.exports["NodeViewContentHole"] = $b7122d1a9520547e$export$27292f9d0a2a0aef;

});

parcelRegister("Mf8oW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $eNbr2 = parcelRequire("eNbr2");

var $794I6 = parcelRequire("794I6");


var $a3WdP = parcelRequire("a3WdP");

class $be16ee2984d6c6af$export$eeddbf09bb970356 extends (0, $cozmU.Component) {
    componentWillUnmount() {
        if (!this.props.providerFactory) // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $794I6.WithProviders), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- there seems to be an existing bug where the Extension component can't be resized if this is memoised because it doesn't rerender so this can't be memoised without a larger refactor
            providers: [
                'extensionProvider'
            ],
            providerFactory: this.providerFactory,
            renderNode: this.renderWithProvider
        });
    }
    constructor(props){
        super(props);
        this.providerFactory = void 0;
        this.renderWithProvider = ({ extensionProvider: extensionProvider })=>{
            const { node: node, getPos: getPos, editorView: editorView, handleContentDOMRef: handleContentDOMRef, extensionHandlers: extensionHandlers, extensionLoadingHandlers: extensionLoadingHandlers, references: references, editorAppearance: editorAppearance, pluginInjectionApi: pluginInjectionApi, eventDispatcher: eventDispatcher, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, rendererExtensionHandlers: rendererExtensionHandlers } = this.props;
            // Extensions are not yet using the new plugin architecture, and the use of the pluginInjectionApi
            // is not type safe in editor-common.
            // @ts-ignore
            const currentState = pluginInjectionApi?.editorViewMode?.sharedState?.currentState();
            const { contentMode: contentMode, mode: mode } = currentState || {};
            const isLivePageViewMode = contentMode === 'live-view' || mode === 'view';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a3WdP.ExtensionComponent), {
                editorView: editorView,
                node: node,
                getPos: getPos,
                references: references,
                extensionProvider: extensionProvider,
                handleContentDOMRef: handleContentDOMRef,
                extensionHandlers: extensionHandlers,
                extensionLoadingHandlers: extensionLoadingHandlers,
                editorAppearance: editorAppearance,
                pluginInjectionApi: pluginInjectionApi,
                eventDispatcher: eventDispatcher,
                macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
                showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
                showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
                rendererExtensionHandlers: rendererExtensionHandlers,
                isLivePageViewMode: isLivePageViewMode
            });
        };
        this.providerFactory = props.providerFactory || new (0, $eNbr2.default)();
    }
}
$be16ee2984d6c6af$export$eeddbf09bb970356.displayName = 'Extension';
module.exports["Extension"] = $be16ee2984d6c6af$export$eeddbf09bb970356;

});

parcelRegister("a3WdP", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dOBRD = parcelRequire("dOBRD");


var $kCECX = parcelRequire("kCECX");


var $ixfCV = parcelRequire("ixfCV");


var $cd8tA = parcelRequire("cd8tA");


var $apAmb = parcelRequire("apAmb");

var $gWBVp = parcelRequire("gWBVp");


var $8QIv2 = parcelRequire("8QIv2");


var $1BETI = parcelRequire("1BETI");


var $11KBS = parcelRequire("11KBS");


var $1aF4Q = parcelRequire("1aF4Q");

const $c68c5e4214724e52$var$getBodiedExtensionContent = (node)=>{
    const bodiedExtensionContent = [];
    node.content.forEach((childNode)=>{
        bodiedExtensionContent.push((0, $gWBVp.nodeToJSON)(childNode));
    });
    return !!bodiedExtensionContent.length ? bodiedExtensionContent : node.attrs.text;
};
const $c68c5e4214724e52$export$908ff786c04d5297 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(19);
    let extensionProviderResolver;
    let node;
    let restProps;
    let showLivePagesBodiedMacrosRendererView;
    if ($[0] !== props) {
        ({ extensionProvider: extensionProviderResolver, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, node: node, ...restProps } = props);
        $[0] = props;
        $[1] = extensionProviderResolver;
        $[2] = node;
        $[3] = restProps;
        $[4] = showLivePagesBodiedMacrosRendererView;
    } else {
        extensionProviderResolver = $[1];
        node = $[2];
        restProps = $[3];
        showLivePagesBodiedMacrosRendererView = $[4];
    }
    const [extensionProvider, setExtensionProvider] = (0, $cozmU.useState)(undefined);
    let t0;
    if ($[5] !== node || $[6] !== showLivePagesBodiedMacrosRendererView) {
        t0 = !!showLivePagesBodiedMacrosRendererView?.((0, $gWBVp.nodeToJSON)(node)) && !(0, $1BETI.isEmptyBodiedMacro)(node);
        $[5] = node;
        $[6] = showLivePagesBodiedMacrosRendererView;
        $[7] = t0;
    } else t0 = $[7];
    const [showBodiedExtensionRendererView, setShowBodiedExtensionRendererView] = (0, $cozmU.useState)(t0);
    const mountedRef = (0, $cozmU.useRef)(true);
    let t1;
    let t2;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            mountedRef.current = true;
            return ()=>{
                mountedRef.current = false;
            };
        };
        t2 = [];
        $[8] = t1;
        $[9] = t2;
    } else {
        t1 = $[8];
        t2 = $[9];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    let t4;
    if ($[10] !== extensionProviderResolver) {
        t3 = ()=>{
            extensionProviderResolver?.then((provider)=>{
                if (mountedRef.current) setExtensionProvider(provider);
            });
        };
        t4 = [
            extensionProviderResolver
        ];
        $[10] = extensionProviderResolver;
        $[11] = t3;
        $[12] = t4;
    } else {
        t3 = $[11];
        t4 = $[12];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[13] !== extensionProvider || $[14] !== node || $[15] !== restProps || $[16] !== showBodiedExtensionRendererView || $[17] !== showLivePagesBodiedMacrosRendererView) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c68c5e4214724e52$var$ExtensionComponentInner, {
            ...restProps,
            extensionProvider: extensionProvider,
            node: node,
            showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
            showBodiedExtensionRendererView: showBodiedExtensionRendererView,
            setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView
        });
        $[13] = extensionProvider;
        $[14] = node;
        $[15] = restProps;
        $[16] = showBodiedExtensionRendererView;
        $[17] = showLivePagesBodiedMacrosRendererView;
        $[18] = t5;
    } else t5 = $[18];
    return t5;
} : (props)=>{
    const { extensionProvider: extensionProviderResolver, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, node: node, ...restProps } = props;
    const [extensionProvider, setExtensionProvider] = (0, $cozmU.useState)(undefined);
    const [showBodiedExtensionRendererView, setShowBodiedExtensionRendererView] = (0, $cozmU.useState)(!!showLivePagesBodiedMacrosRendererView?.((0, $gWBVp.nodeToJSON)(node)) && !(0, $1BETI.isEmptyBodiedMacro)(node));
    const mountedRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    (0, $cozmU.useEffect)(()=>{
        extensionProviderResolver?.then((provider)=>{
            if (mountedRef.current) setExtensionProvider(provider);
        });
    }, [
        extensionProviderResolver
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c68c5e4214724e52$var$ExtensionComponentInner, {
        ...restProps,
        extensionProvider: extensionProvider,
        node: node,
        showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
        showBodiedExtensionRendererView: showBodiedExtensionRendererView,
        setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView
    });
};
class $c68c5e4214724e52$var$ExtensionComponentInner extends (0, $cozmU.Component) {
    componentDidUpdate() {
        this.parsePrivateNodePropsIfNeeded();
    }
    render() {
        const { node: node, handleContentDOMRef: handleContentDOMRef, editorView: editorView, references: references, editorAppearance: editorAppearance, pluginInjectionApi: pluginInjectionApi, getPos: getPos, eventDispatcher: eventDispatcher, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, extensionProvider: extensionProvider, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, showBodiedExtensionRendererView: showBodiedExtensionRendererView, setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView, isLivePageViewMode: isLivePageViewMode } = this.props;
        const { selection: selection } = editorView.state;
        const selectedNode = selection instanceof (0, $kCECX.NodeSelection) && selection.node;
        const position = typeof getPos === 'function' && getPos();
        const resolvedPosition = position && editorView.state.doc.resolve(position);
        const isNodeNested = !!(resolvedPosition && resolvedPosition.depth > 0);
        if (node.type.name === 'multiBodiedExtension') {
            const allowBodiedOverride = this.state._privateProps?.__allowBodiedOverride;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1aF4Q.default), {
                node: node,
                editorView: editorView,
                getPos: getPos,
                handleContentDOMRef: handleContentDOMRef,
                tryExtensionHandler: this.tryExtensionHandler.bind(this),
                eventDispatcher: eventDispatcher,
                pluginInjectionApi: pluginInjectionApi,
                editorAppearance: editorAppearance,
                macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
                isNodeSelected: selectedNode === node,
                isNodeNested: isNodeNested,
                isLivePageViewMode: isLivePageViewMode,
                allowBodiedOverride: allowBodiedOverride
            });
        }
        const extensionHandlerResult = this.tryExtensionHandler(undefined);
        switch(node.type.name){
            case 'extension':
            case 'bodiedExtension':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8QIv2.default), {
                    node: node,
                    getPos: this.props.getPos,
                    references: references,
                    extensionProvider: extensionProvider,
                    handleContentDOMRef: handleContentDOMRef,
                    view: editorView,
                    editorAppearance: editorAppearance,
                    hideFrame: this.state._privateProps?.__hideFrame,
                    pluginInjectionApi: pluginInjectionApi,
                    macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
                    isNodeSelected: selectedNode === node,
                    isNodeNested: isNodeNested,
                    showLivePagesBodiedMacrosRendererView: !!showLivePagesBodiedMacrosRendererView?.((0, $gWBVp.nodeToJSON)(node)),
                    showUpdatedLivePages1PBodiedExtensionUI: !!showUpdatedLivePages1PBodiedExtensionUI?.((0, $gWBVp.nodeToJSON)(node)),
                    showBodiedExtensionRendererView: showBodiedExtensionRendererView,
                    setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView,
                    isLivePageViewMode: isLivePageViewMode
                }, extensionHandlerResult);
            case 'inlineExtension':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $11KBS.default), {
                    node: node,
                    macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
                    isNodeSelected: selectedNode === node,
                    pluginInjectionApi: pluginInjectionApi,
                    isLivePageViewMode: isLivePageViewMode
                }, extensionHandlerResult);
            default:
                return null;
        }
    }
    tryExtensionHandler(actions) {
        const { node: node } = this.props;
        try {
            const extensionContent = this.handleExtension(node, actions);
            if (extensionContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(extensionContent)) return extensionContent;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Provided extension handler has thrown an error\n', e);
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        return null;
    }
    constructor(...args){
        super(...args);
        this.privatePropsParsed = false;
        this.state = {};
        // memoized to avoid rerender on extension state changes
        this.getNodeRenderer = (0, $dOBRD.default)((0, $cd8tA.getNodeRenderer));
        this.getExtensionModuleNodePrivateProps = (0, $dOBRD.default)((0, $cd8tA.getExtensionModuleNodePrivateProps));
        this.setIsNodeHovered = (isHovered)=>{
            // Don't want to show hover interactions for live page view mode
            if (!this.props.isLivePageViewMode) this.setState({
                isNodeHovered: isHovered
            });
        };
        /**
     * Parses any private nodes once an extension provider is available.
     *
     * We do this separately from resolving a node renderer component since the
     * private props come from extension provider, rather than an extension
     * handler which only handles `render`/component concerns.
     */ this.parsePrivateNodePropsIfNeeded = async ()=>{
            if (this.privatePropsParsed || !this.props.extensionProvider) return;
            this.privatePropsParsed = true;
            const { extensionType: extensionType, extensionKey: extensionKey } = this.props.node.attrs;
            /**
       * getExtensionModuleNodePrivateProps can throw if there are issues in the
       * manifest
       */ try {
                const privateProps = await this.getExtensionModuleNodePrivateProps(this.props.extensionProvider, extensionType, extensionKey);
                this.setState({
                    _privateProps: privateProps
                });
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error('Provided extension handler has thrown an error\n', e);
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        };
        this.handleExtension = (pmNode, actions)=>{
            const { extensionHandlers: extensionHandlers, extensionLoadingHandlers: extensionLoadingHandlers, editorView: editorView, showBodiedExtensionRendererView: showBodiedExtensionRendererView, rendererExtensionHandlers: rendererExtensionHandlers } = this.props;
            const { extensionType: extensionType, extensionKey: extensionKey, parameters: parameters, text: text } = pmNode.attrs;
            const isBodiedExtension = pmNode.type.name === 'bodiedExtension';
            const { selection: selection } = editorView.state;
            const isSelected = selection instanceof (0, $kCECX.NodeSelection) && selection.node === pmNode;
            if (isBodiedExtension && !showBodiedExtensionRendererView) return;
            const fragmentLocalId = pmNode?.marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
            const content = isBodiedExtension ? $c68c5e4214724e52$var$getBodiedExtensionContent(pmNode) : text;
            const node = {
                type: pmNode.type.name,
                extensionType: extensionType,
                extensionKey: extensionKey,
                parameters: parameters,
                content: content,
                localId: pmNode.attrs.localId,
                fragmentLocalId: fragmentLocalId
            };
            if (isBodiedExtension) {
                const rendererExtensionHandler = rendererExtensionHandlers?.[extensionType];
                // Forge bodied extensions don't get rendererExtensionHandlers passed in and use extensionHandlerFromProvider from the below logic instead
                if (rendererExtensionHandler) return (0, $apAmb.getExtensionRenderer)(rendererExtensionHandler)(node, (0, $gWBVp.toJSON)(editorView.state.doc));
            }
            let result;
            const loadingFallback = extensionLoadingHandlers?.[extensionType] ? (0, $apAmb.getExtensionRenderer)(extensionLoadingHandlers[extensionType])(node, editorView.state.doc, actions) : undefined;
            if (extensionHandlers && extensionHandlers[extensionType]) {
                const render = (0, $apAmb.getExtensionRenderer)(extensionHandlers[extensionType]);
                result = render(node, editorView.state.doc, actions);
            }
            if (!result) {
                const extensionHandlerFromProvider = this.props.extensionProvider && this.getNodeRenderer(this.props.extensionProvider, extensionType, extensionKey);
                if (extensionHandlerFromProvider) {
                    const NodeRenderer = extensionHandlerFromProvider;
                    if (node.type === 'multiBodiedExtension') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(NodeRenderer, {
                        node: node,
                        references: this.props.references,
                        actions: actions,
                        loadingFallback: loadingFallback
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(NodeRenderer, {
                        node: node,
                        references: this.props.references,
                        isSelected: isSelected,
                        loadingFallback: loadingFallback,
                        showUnknownMacroPlaceholder: (0, $ixfCV.fg)('tinymce_display_unknown_macro_body_content')
                    });
                }
            }
            return result ?? loadingFallback;
        };
    }
}
module.exports["ExtensionComponent"] = $c68c5e4214724e52$export$908ff786c04d5297;

});

parcelRegister("8QIv2", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $5X6fy = parcelRequire("5X6fy");


var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");


var $3k5Tv = parcelRequire("3k5Tv");


var $g9sVl = parcelRequire("g9sVl");


var $9ECRl = parcelRequire("9ECRl");


var $h9Lux = parcelRequire("h9Lux");


var $38lMZ = parcelRequire("38lMZ");


var $bYEj1 = parcelRequire("bYEj1");


var $imFKp = parcelRequire("imFKp");


var $1BETI = parcelRequire("1BETI");


var $dBzxx = parcelRequire("dBzxx");

function $d03f27f1eb216197$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d03f27f1eb216197$var$hoverStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    '&:hover': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    }
});
const $d03f27f1eb216197$var$containerStyle = {
    name: "nhejpy",
    styles: "container-type:inline-size"
};
function $d03f27f1eb216197$var$ExtensionWithPluginState(props) {
    const { node: node, handleContentDOMRef: handleContentDOMRef, children: children, widthState: widthState, handleRef: handleRef, shadowClassNames: shadowClassNames, hideFrame: hideFrame, editorAppearance: editorAppearance, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, isNodeSelected: isNodeSelected, isNodeHovered: isNodeHovered, isNodeNested: isNodeNested, setIsNodeHovered: setIsNodeHovered, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, showBodiedExtensionRendererView: showBodiedExtensionRendererView, setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView, pluginInjectionApi: pluginInjectionApi, isLivePageViewMode: isLivePageViewMode } = props;
    const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = macroInteractionDesignFeatureFlags || {};
    const isLegacyContentMacroExtension = (extensionNode)=>extensionNode.type.name === 'extension' && extensionNode.attrs?.extensionType === 'com.atlassian.confluence.migration' && extensionNode.attrs?.extensionKey === 'legacy-content';
    const showLegacyContentHeader = (0, $ixfCV.fg)('platform_editor_legacy_content_macro_visual_update') && isLegacyContentMacroExtension(node);
    const hasBody = [
        'bodiedExtension',
        'multiBodiedExtension'
    ].includes(node.type.name);
    const hasChildren = !!children;
    const removeBorder = showMacroInteractionDesignUpdates || !!(hideFrame && !hasBody);
    // Some native bodied macros (e.g Content properties) have this param to hide in view mode
    // which we want to also hide in live page view mode too
    const macroParamHiddenValue = node?.attrs?.parameters?.macroParams?.hidden?.value;
    const shouldHideInLivePageViewMode = isLivePageViewMode && macroParamHiddenValue === 'true'; // it is stored as a string
    const { getPos: getPos, view: view } = props;
    const isTopLevelNode = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        const pos = typeof getPos === 'function' ? getPos() : undefined;
        return typeof pos !== 'undefined' && !isNaN(pos) && view.state.doc.resolve(pos).depth === 0;
    }, [
        view,
        getPos
    ]);
    const layout = node.attrs.layout;
    const legacyShouldBreakout = [
        'full-width',
        'wide'
    ].includes(layout) && isTopLevelNode && editorAppearance !== 'full-width';
    const tinymceFullWidthModeEnabled = (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true);
    const breakoutExtensionFixEnabled = (0, $ieeJu.expValEquals)('confluence_max_width_breakout_extension_fix', 'isEnabled', true);
    const shouldUseBreakoutFix = tinymceFullWidthModeEnabled && breakoutExtensionFixEnabled;
    const shouldBreakout = shouldUseBreakoutFix ? (0, $38lMZ.shouldExtensionBreakout)({
        layout: layout,
        isTopLevelNode: isTopLevelNode,
        editorAppearance: editorAppearance
    }) : legacyShouldBreakout;
    // We don't want to show border for non-empty 1p bodied extensions in live pages
    const show1PBodiedExtensionBorder = showUpdatedLivePages1PBodiedExtensionUI ? (0, $1BETI.isEmptyBodiedMacro)(node) : true;
    const classNames = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('extension-container', 'block', shadowClassNames, {
        'with-overlay': !hasBody && !showMacroInteractionDesignUpdates,
        'with-bodied-border': showMacroInteractionDesignUpdates && (hasBody || isLegacyContentMacroExtension(node)) && !showBodiedExtensionRendererView && show1PBodiedExtensionBorder,
        'with-margin-styles': showMacroInteractionDesignUpdates && !isNodeNested && !showBodiedExtensionRendererView,
        'with-danger-overlay': showMacroInteractionDesignUpdates,
        'without-frame': removeBorder,
        [(0, $dBzxx.widerLayoutClassName)]: shouldBreakout
    });
    const overflowClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('extension-overflow-wrapper', {
        'with-body': hasBody,
        'with-margin-styles': showMacroInteractionDesignUpdates && !isNodeNested && !showBodiedExtensionRendererView,
        // Adding extra padding for renderer view so users can have a touch target to click on the extension
        'with-padding-styles': showMacroInteractionDesignUpdates && showBodiedExtensionRendererView
    });
    const headerClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))({
        'with-children': hasChildren,
        'without-frame': removeBorder
    });
    const newContentClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))({
        'with-padding-styles': showMacroInteractionDesignUpdates,
        'with-bodied-padding-styles': hasBody && showMacroInteractionDesignUpdates
    });
    const contentClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('extension-content', 'block', {
        'remove-border': showMacroInteractionDesignUpdates,
        'hide-content': showBodiedExtensionRendererView
    });
    let customContainerStyles = {
        width: '100%'
    };
    let newContentStyles = {};
    if (shouldBreakout) {
        // type is destructured so that breakout styles does not include it
        const { type: _type, ...breakoutStyles } = (0, $h9Lux.calculateBreakoutStyles)({
            mode: node.attrs.layout,
            widthStateWidth: widthState.width,
            widthStateLineLength: widthState.lineLength
        });
        newContentStyles = {
            ...breakoutStyles
        };
        customContainerStyles = breakoutStyles;
    }
    newContentStyles = {
        ...newContentStyles,
        ...(0, $dBzxx.contentWrapper)
    };
    const handleMouseEvent = (didHover)=>{
        if (setIsNodeHovered) setIsNodeHovered(didHover);
    };
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, !showLegacyContentHeader && showMacroInteractionDesignUpdates && !isLivePageViewMode && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $bYEj1.default), {
        isNodeSelected: isNodeSelected,
        isNodeHovered: isNodeHovered,
        isNodeNested: isNodeNested,
        node: node,
        showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
        customContainerStyles: customContainerStyles,
        setIsNodeHovered: setIsNodeHovered,
        isBodiedMacro: hasBody || isLegacyContentMacroExtension(node),
        showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
        showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
        showBodiedExtensionRendererView: showBodiedExtensionRendererView,
        setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView,
        pluginInjectionApi: pluginInjectionApi
    }), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-testid": "extension-container",
        ref: handleRef,
        "data-layout": node.attrs.layout,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $dBzxx.wrapperStyleInheritedCursor),
            showMacroInteractionDesignUpdates && !isLivePageViewMode && $d03f27f1eb216197$var$hoverStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: customContainerStyles,
        onMouseEnter: ()=>handleMouseEvent(true),
        // @atlassian/a11y/mouse-events-have-key-events: hover border is also applied via .ak-editor-selected-node
        // CSS on keyboard selection. No-ops here satisfy the rule without duplicating state updates.
        onFocus: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onMouseLeave: ()=>handleMouseEvent(false),
        onBlur: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-testid": "extension-overflow-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: overflowClassNames,
        css: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $dBzxx.overflowWrapperStyles),
            (0, $ixfCV.fg)('platform_fix_macro_renders_in_layouts') && $d03f27f1eb216197$var$containerStyle
        ]
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        className: 'extension-overlay',
        css: (0, $imFKp.overlay)
    }), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $dBzxx.header),
        contentEditable: false,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: headerClassNames
    }, !removeBorder && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $bYEj1.default), {
        isNodeSelected: isNodeSelected,
        node: node,
        showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
        pluginInjectionApi: pluginInjectionApi
    }), children), hasBody && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: newContentStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: newContentClassNames,
        "data-testid": "extension-new-content"
    }, !shouldHideInLivePageViewMode && /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-testid": "extension-content",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $dBzxx.extensionContent),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: contentClassNames
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $g9sVl.NodeViewContentHole), {
        ref: handleContentDOMRef
    }))))));
}
const $d03f27f1eb216197$var$Extension = (props)=>{
    const { pluginInjectionApi: pluginInjectionApi } = props;
    const { lineLength: lineLength, width: width } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'width'
    ], (states)=>({
            width: states.widthState?.width ?? 0,
            lineLength: states.widthState?.lineLength
        }));
    const memoizedWidthState = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            width: width ?? 0,
            lineLength: lineLength
        }), [
        width,
        lineLength
    ]);
    const widthState = (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedWidthState : {
        width: width ?? 0,
        lineLength: lineLength
    };
    // Ignored via go/ees005
    return /*#__PURE__*/ (0, $lOiVq.jsx)($d03f27f1eb216197$var$ExtensionWithPluginState, {
        widthState: widthState,
        ...props
    });
};
const $d03f27f1eb216197$var$_default_1 = (0, $9ECRl.default)($d03f27f1eb216197$var$Extension, {
    overflowSelector: '.extension-overflow-wrapper'
});
var $d03f27f1eb216197$export$2e2bcd8739ae039 = $d03f27f1eb216197$var$_default_1;
module.exports["default"] = $d03f27f1eb216197$export$2e2bcd8739ae039;

});

parcelRegister("38lMZ", function(module, exports) {
const $a42b9e424ed492bc$var$breakoutLayouts = new Set([
    'full-width',
    'wide'
]);
const $a42b9e424ed492bc$var$shouldRespectBreakoutForAppearance = (appearance)=>{
    if (!appearance) return true;
    if (appearance === 'full-width') return false;
    if (appearance === 'max') return false;
    return true;
};
const $a42b9e424ed492bc$export$85b54d274949f309 = ({ layout: layout, isTopLevelNode: isTopLevelNode = true, editorAppearance: editorAppearance })=>{
    if (!layout || !$a42b9e424ed492bc$var$breakoutLayouts.has(layout)) return false;
    if (!isTopLevelNode) return false;
    return $a42b9e424ed492bc$var$shouldRespectBreakoutForAppearance(editorAppearance);
};
module.exports["shouldExtensionBreakout"] = $a42b9e424ed492bc$export$85b54d274949f309;

});

parcelRegister("bYEj1", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $RiJVa = parcelRequire("RiJVa");


var $imFKp = parcelRequire("imFKp");


var $kYLTP = parcelRequire("kYLTP");

class $856e67b1d1258267$export$2e2bcd8739ae039 extends (0, $cozmU.Component) {
    render() {
        const { node: node, showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = this.props;
        const imageData = (0, $RiJVa.getExtensionLozengeData)({
            node: node,
            type: 'image'
        });
        if (!showMacroInteractionDesignUpdates && imageData && node.type.name !== 'extension') return this.renderImage(imageData);
        const iconData = (0, $RiJVa.getExtensionLozengeData)({
            node: node,
            type: 'icon'
        });
        return this.renderFallback(iconData);
    }
    constructor(...args){
        super(...args);
        this.renderImage = (lozengeData)=>{
            const { extensionKey: extensionKey } = this.props.node.attrs;
            const { url: url, ...rest } = lozengeData;
            // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            return /*#__PURE__*/ (0, $lOiVq.jsx)("img", {
                css: (0, $imFKp.styledImage),
                src: url,
                ...rest,
                alt: extensionKey
            });
        };
        this.renderFallback = (lozengeData)=>{
            const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates, isNodeSelected: isNodeSelected, isNodeHovered: isNodeHovered, isNodeNested: isNodeNested, customContainerStyles: customContainerStyles, setIsNodeHovered: setIsNodeHovered, isBodiedMacro: isBodiedMacro, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, showBodiedExtensionRendererView: showBodiedExtensionRendererView, setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView, pluginInjectionApi: pluginInjectionApi, isMultiBodiedMacro: isMultiBodiedMacro } = this.props;
            const { parameters: parameters, extensionKey: extensionKey } = this.props.node.attrs;
            const { name: name } = this.props.node.type;
            const params = parameters && parameters.macroParams;
            const title = parameters && parameters.extensionTitle || parameters && parameters.macroMetadata && parameters.macroMetadata.title || extensionKey;
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kYLTP.LozengeComponent), {
                isNodeHovered: isNodeHovered,
                isNodeSelected: isNodeSelected,
                isNodeNested: isNodeNested,
                showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
                extensionName: name,
                lozengeData: lozengeData,
                params: params,
                title: title,
                renderImage: this.renderImage,
                customContainerStyles: customContainerStyles,
                setIsNodeHovered: setIsNodeHovered,
                isBodiedMacro: isBodiedMacro,
                showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
                showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
                showBodiedExtensionRendererView: showBodiedExtensionRendererView,
                setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView,
                pluginInjectionApi: pluginInjectionApi,
                isMultiBodiedMacro: isMultiBodiedMacro
            });
        };
    }
}
module.exports["default"] = $856e67b1d1258267$export$2e2bcd8739ae039;

});

parcelRegister("imFKp", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");

function $f9471a55d63539ff$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f9471a55d63539ff$export$a7d01cf46bd1c5ed = '--ak-editor-extension-block-spacing';
const $f9471a55d63539ff$export$2c23939c304dcbb6 = {
    name: "1st3gh2",
    styles: "background:var(--ds-background-neutral, #0515240F);border-radius:var(--ds-radius-small, 3px);position:relative;vertical-align:middle;&.with-overlay{.extension-overlay{background:var(--ds-background-neutral-hovered, #0B120E24);color:transparent;}&:hover .extension-overlay{opacity:1;}}"
};
const $f9471a55d63539ff$export$29dd17c7f3c81c36 = {
    name: "7geot",
    styles: "border-radius:var(--ds-radius-small, 3px);position:absolute;width:100%;height:100%;opacity:0;pointer-events:none;transition:opacity 0.3s;top:0;left:0"
};
const $f9471a55d63539ff$export$f61e107d01719381 = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'inline-flex',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > img': {
        margin: `0 ${"var(--ds-space-050, 4px)"}`
    },
    /* TODO: fix in develop: https://atlassian.slack.com/archives/CFG3PSQ9E/p1647395052443259?thread_ts=1647394572.556029&cid=CFG3PSQ9E */ /* stylelint-disable-next-line */ label: 'placeholder-fallback'
});
const $f9471a55d63539ff$export$baa8de7b590bf812 = {
    name: "147iacu",
    styles: "display:inline-block;max-width:200px;margin-left:var(--ds-space-050, 4px);color:var(--ds-text-subtlest, #6B6E76);text-overflow:ellipsis;white-space:nowrap;overflow:hidden"
};
const $f9471a55d63539ff$export$83cb1da155637959 = {
    name: "1ib9bih-lozenge-image",
    styles: "max-height:16px;max-width:16px;label:lozenge-image"
};
module.exports["wrapperDefault"] = $f9471a55d63539ff$export$2c23939c304dcbb6;
module.exports["overlay"] = $f9471a55d63539ff$export$29dd17c7f3c81c36;
module.exports["placeholderFallback"] = $f9471a55d63539ff$export$f61e107d01719381;
module.exports["placeholderFallbackParams"] = $f9471a55d63539ff$export$baa8de7b590bf812;
module.exports["styledImage"] = $f9471a55d63539ff$export$83cb1da155637959;

});

parcelRegister("kYLTP", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kkFbH = parcelRequire("kkFbH");


var $imFKp = parcelRequire("imFKp");


var $aGmZp = parcelRequire("aGmZp");


var $ggmg0 = parcelRequire("ggmg0");

const $87435b85784be422$export$91a15f1424900d33 = 24;
const $87435b85784be422$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $87435b85784be422$export$14bad8182dc08b5a = ({ lozengeData: lozengeData, extensionName: extensionName, title: title, params: params, renderImage: renderImage, showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates, customContainerStyles: customContainerStyles, isNodeHovered: isNodeHovered, isNodeNested: isNodeNested, isNodeSelected: isNodeSelected, setIsNodeHovered: setIsNodeHovered, isBodiedMacro: isBodiedMacro, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, showBodiedExtensionRendererView: showBodiedExtensionRendererView, setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView, pluginInjectionApi: pluginInjectionApi, isMultiBodiedMacro: isMultiBodiedMacro })=>{
    const capitalizedTitle = $87435b85784be422$var$capitalizeFirstLetter(title);
    if (showMacroInteractionDesignUpdates) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ggmg0.ExtensionLabel), {
        text: capitalizedTitle,
        extensionName: extensionName,
        isNodeHovered: isNodeHovered,
        isNodeNested: isNodeNested,
        isNodeSelected: isNodeSelected,
        customContainerStyles: customContainerStyles,
        setIsNodeHovered: setIsNodeHovered,
        isBodiedMacro: isBodiedMacro,
        showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
        showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
        showBodiedExtensionRendererView: showBodiedExtensionRendererView,
        pluginInjectionApi: pluginInjectionApi,
        isMultiBodiedMacro: isMultiBodiedMacro
    }), showLivePagesBodiedMacrosRendererView && isBodiedMacro && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $aGmZp.EditToggle), {
        isNodeHovered: isNodeHovered,
        setIsNodeHovered: setIsNodeHovered,
        customContainerStyles: customContainerStyles,
        showBodiedExtensionRendererView: showBodiedExtensionRendererView,
        setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView
    }));
    const isBlockExtension = extensionName === 'extension';
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-testid": "lozenge-fallback",
        css: (0, $imFKp.placeholderFallback)
    }, lozengeData && !isBlockExtension ? renderImage({
        height: $87435b85784be422$export$91a15f1424900d33,
        width: $87435b85784be422$export$91a15f1424900d33,
        ...lozengeData
    }) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), {
        label: title
    }), /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        className: "extension-title"
    }, capitalizedTitle), params && !isBlockExtension && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: (0, $imFKp.placeholderFallbackParams)
    }, Object.keys(params).map((key)=>key && ` | ${key} = ${params[key].value}`))));
};
module.exports["LozengeComponent"] = $87435b85784be422$export$14bad8182dc08b5a;

});

parcelRegister("aGmZp", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $eh6Ml = parcelRequire("eh6Ml");


var $gC2EJ = parcelRequire("gC2EJ");


var $kA6Zo = parcelRequire("kA6Zo");

var $buxP3 = parcelRequire("buxP3");


var $ieeJu = parcelRequire("ieeJu");

function $9bf89b97db7e04ac$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9bf89b97db7e04ac$var$buttonContainerStyles = {
    name: "cy6p8l",
    styles: "opacity:0;line-height:1;position:absolute;width:max-content;top:-28px;display:inline-flex;justify-content:flex-end;color:var(--ds-text-subtle, #505258)"
};
const $9bf89b97db7e04ac$var$buttonStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`,
    minHeight: "var(--ds-space-300, 24px)",
    borderRadius: "var(--ds-radius-small, 4px)",
    paddingLeft: "var(--ds-space-150, 12px)",
    paddingRight: "var(--ds-space-150, 12px)",
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    '&:hover': {
        backgroundColor: "var(--ds-background-input-hovered, #F8F8F8)"
    },
    outlineColor: "var(--ds-border-focused, #4688EC)",
    border: 'none',
    backgroundColor: "var(--ds-background-input, #FFFFFF)",
    color: "var(--ds-text-subtle, #505258)"
});
const $9bf89b97db7e04ac$var$iconStyles = (0, $buxP3.xcss)({
    marginRight: 'space.075'
});
const $9bf89b97db7e04ac$var$i18n = (0, $kSwu1.defineMessages)({
    doneEditing: {
        id: "editor-common-extensibility-extension-lozenge-editToggle.done.editing",
        defaultMessage: "Done editing"
    },
    makeEdits: {
        id: "editor-common-extensibility-extension-lozenge-editToggle.make.edits",
        defaultMessage: "Make edits"
    }
});
const $9bf89b97db7e04ac$export$2ada5dce8cd41705 = ({ customContainerStyles: customContainerStyles, setIsNodeHovered: setIsNodeHovered, showBodiedExtensionRendererView: showBodiedExtensionRendererView, setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView })=>{
    const intl = (0, $kSwu1.useIntl)();
    const text = showBodiedExtensionRendererView ? intl.formatMessage($9bf89b97db7e04ac$var$i18n.makeEdits) : intl.formatMessage($9bf89b97db7e04ac$var$i18n.doneEditing);
    const icon = showBodiedExtensionRendererView ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
        testId: "edit-icon",
        label: ""
    }) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        testId: "check-mark-icon",
        label: ""
    });
    const handleClick = (0, $cozmU.useCallback)(()=>{
        setShowBodiedExtensionRendererView?.(!showBodiedExtensionRendererView);
    }, [
        showBodiedExtensionRendererView,
        setShowBodiedExtensionRendererView
    ]);
    const handleKeyDown = (0, $cozmU.useCallback)((event)=>{
        if (event.key === 'Enter') handleClick();
    }, [
        handleClick
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-testid": "extension-edit-toggle-container",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        css: [
            $9bf89b97db7e04ac$var$buttonContainerStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: customContainerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "extension-edit-toggle-container",
        onMouseOver: ()=>setIsNodeHovered?.(true),
        // @atlassian/a11y/mouse-events-have-key-events: keyboard focus is already handled by the
        // inner <button>'s onFocus/onBlur. No-ops here satisfy the rule without duplicating state updates.
        onFocus: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onMouseLeave: ()=>setIsNodeHovered?.(false),
        onBlur: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("button", {
        type: "button",
        "data-testid": "edit-toggle",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        css: $9bf89b97db7e04ac$var$buttonStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "extension-edit-toggle",
        onClick: handleClick,
        onKeyDown: handleKeyDown,
        onFocus: ()=>setIsNodeHovered?.(true),
        onBlur: ()=>setIsNodeHovered?.(false)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kA6Zo.default), {
        as: "span",
        xcss: $9bf89b97db7e04ac$var$iconStyles
    }, icon), text));
};
module.exports["EditToggle"] = $9bf89b97db7e04ac$export$2ada5dce8cd41705;

});

parcelRegister("ggmg0", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $5X6fy = parcelRequire("5X6fy");


var $kSwu1 = parcelRequire("kSwu1");


var $dPtk6 = parcelRequire("dPtk6");


var $ixfCV = parcelRequire("ixfCV");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");


var $ieeJu = parcelRequire("ieeJu");


var $lpNn5 = parcelRequire("lpNn5");

function $9cb941e776fb1132$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9cb941e776fb1132$var$containerStyles = {
    name: "1xnw70r",
    styles: "text-align:left;z-index:1;position:relative;&.bodied{margin-top:var(--ds-space-300, 24px);}"
};
const $9cb941e776fb1132$var$showLabelStyles = {
    name: "3ix1vd",
    styles: "opacity:1"
};
const $9cb941e776fb1132$var$hideLabelStyles = {
    name: "mws4fn",
    styles: "opacity:0"
};
const $9cb941e776fb1132$var$labelStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    opacity: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    display: 'inline-flex',
    justifyContent: 'left',
    position: 'absolute',
    width: 'max-content',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
    top: '-28px',
    // When updating this value, make sure to also update the value in EditToggle.tsx, buttonContainerStyles
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.show-label': {
        cursor: 'pointer',
        opacity: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.nested': {
        // Need to add indent if the node is nested since we removed previous indentation styles to make it fit properly
        // in the nested component
        marginLeft: "var(--ds-space-150, 12px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.inline': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        top: '-27px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.bodied-background': {
        background: "var(--ds-surface, #FFFFFF)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.bodied-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    },
    minHeight: "var(--ds-space-300, 24px)",
    alignItems: 'center',
    borderRadius: "var(--ds-radius-small, 3px)",
    paddingLeft: "var(--ds-space-100, 8px)",
    paddingRight: "var(--ds-space-100, 8px)",
    color: "var(--ds-text-subtle, #505258)",
    backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-left-margin': {
        marginLeft: "var(--ds-space-negative-150, -12px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-nested-left-margin': {
        marginLeft: 0
    },
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-bodied-macro-live-page-styles': {
        backgroundColor: "var(--ds-background-input, #FFFFFF)",
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    }
});
const $9cb941e776fb1132$var$spacerStyles = (0, $buxP3.xcss)({
    height: 'space.200',
    position: 'absolute',
    width: '100%'
});
const $9cb941e776fb1132$var$iconStyles = {
    name: "1s9vzwe",
    styles: "margin-left:var(--ds-space-075, 6px);&.hide-icon{display:none;}"
};
const $9cb941e776fb1132$var$bodiedMacroIconStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $9cb941e776fb1132$var$i18n = (0, $kSwu1.defineMessages)({
    configure: {
        id: "editor-common-extensibility.macro.button.configure",
        defaultMessage: "Configure {macroName}"
    }
});
const $9cb941e776fb1132$export$addedb5f7f03bdb1 = ({ text: text, extensionName: extensionName, customContainerStyles: customContainerStyles, isNodeNested: isNodeNested, isNodeSelected: isNodeSelected, setIsNodeHovered: setIsNodeHovered, isBodiedMacro: isBodiedMacro, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showBodiedExtensionRendererView: showBodiedExtensionRendererView, pluginInjectionApi: _pluginInjectionApi, isMultiBodiedMacro: isMultiBodiedMacro })=>{
    const isInlineExtension = extensionName === 'inlineExtension';
    const showDefaultBodiedStyles = isBodiedMacro;
    const shouldUseMultiBodiedMacroPresentation = isMultiBodiedMacro && (0, $ixfCV.fg)('confluence_frontend_native_tabs_extension');
    const containerClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))({
        bodied: isBodiedMacro && !shouldUseMultiBodiedMacroPresentation
    });
    const labelClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('extension-label', {
        nested: isNodeNested,
        inline: isInlineExtension,
        bodied: isBodiedMacro,
        'bodied-border': showDefaultBodiedStyles,
        'bodied-background': showDefaultBodiedStyles,
        'with-bodied-macro-live-page-styles': isBodiedMacro && showLivePagesBodiedMacrosRendererView,
        'always-hide-label': isBodiedMacro && showBodiedExtensionRendererView,
        // Need this separate class since we don't ever want to show the label during view mode
        'remove-left-margin': (!isBodiedMacro || shouldUseMultiBodiedMacroPresentation) && !isInlineExtension && !isNodeNested,
        'remove-nested-left-margin': isNodeNested && (!isBodiedMacro || shouldUseMultiBodiedMacroPresentation) && !isInlineExtension
    });
    const iconClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))({
        'extension-icon': true
    });
    const memoizedTooltipValues = (0, $cozmU.useMemo)(()=>({
            macroName: text
        }), [
        text
    ]);
    const tooltipValues = (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedTooltipValues : {
        macroName: text
    };
    return(// eslint-disable-next-line @atlassian/a11y/no-static-element-interactions, @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        css: $9cb941e776fb1132$var$containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: containerClassNames,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: customContainerStyles,
        onMouseOver: ()=>{
            setIsNodeHovered?.(true);
        },
        // @atlassian/a11y/mouse-events-have-key-events: label visibility on keyboard focus is already
        // handled via the .ak-editor-selected-node CSS class applied by ProseMirror on node selection.
        // No-ops here satisfy the rule.
        onFocus: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onMouseLeave: ()=>{
            setIsNodeHovered?.(false);
        },
        onBlur: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        "data-testid": "new-lozenge-container",
        contentEditable: false
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), {
            ...$9cb941e776fb1132$var$i18n.configure,
            values: tooltipValues
        }),
        position: "top"
    }, (tooltipProps)=>/*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            "data-testid": "new-lozenge-button",
            ...tooltipProps,
            css: [
                $9cb941e776fb1132$var$labelStyles,
                !showLivePagesBodiedMacrosRendererView && $9cb941e776fb1132$var$showLabelStyles,
                (!isBodiedMacro || showUpdatedLivePages1PBodiedExtensionUI || shouldUseMultiBodiedMacroPresentation && !isNodeSelected) && $9cb941e776fb1132$var$hideLabelStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: labelClassNames
        }, text, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            css: [
                $9cb941e776fb1132$var$iconStyles,
                isBodiedMacro && !shouldUseMultiBodiedMacroPresentation && $9cb941e776fb1132$var$bodiedMacroIconStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: iconClassNames,
            "data-testid": "config-icon"
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dPtk6))), {
            label: ""
        })))), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.default), {
        xcss: $9cb941e776fb1132$var$spacerStyles
    })));
};
module.exports["ExtensionLabel"] = $9cb941e776fb1132$export$addedb5f7f03bdb1;

});

parcelRegister("1BETI", function(module, exports) {
const $1ba924a21e00fd14$export$d01da3229dfc693b = (node)=>{
    if (node.type.name !== 'bodiedExtension') return false;
    const firstChildNode = node?.content?.firstChild;
    const firstGrandChildNode = firstChildNode?.firstChild;
    // If firstChildNode?.childCount > 1 means there is content along with the placeholder.
    const isEmptyWithPlacholder = firstGrandChildNode?.type?.name === 'placeholder' && firstChildNode?.childCount === 1;
    const isEmptyWithNoContent = !firstGrandChildNode && node.childCount === 1;
    return isEmptyWithPlacholder || isEmptyWithNoContent;
};
module.exports["isEmptyBodiedMacro"] = $1ba924a21e00fd14$export$d01da3229dfc693b;

});

parcelRegister("dBzxx", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");


var $imFKp = parcelRequire("imFKp");

const $cfb4a4c7963ce223$export$c51f29288b3ec9db = 'wider-layout';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $cfb4a4c7963ce223$var$wrapperStyleWithoutCursor = /*#__PURE__*/ (0, $lOiVq.css)((0, $imFKp.wrapperDefault), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.without-frame': {
        background: 'transparent'
    },
    width: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '.extension-overflow-wrapper:not(.with-body)': {
        overflowX: 'auto'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-bodied-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-hover-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-margin-styles': {
        margin: `0 ${"var(--ds-space-negative-250, -20px)"}`,
        padding: `0 ${"var(--ds-space-250, 20px)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.legacy-content': {
        borderRadius: `0 0 ${"var(--ds-radius-small, 3px)"} ${"var(--ds-radius-small, 3px)"}`
    }
});
const $cfb4a4c7963ce223$export$ebf956b2dea5bd2e = /*#__PURE__*/ (0, $lOiVq.css)($cfb4a4c7963ce223$var$wrapperStyleWithoutCursor, ".extension-overflow-wrapper:has(.extension-editable-area){cursor:inherit;}.extension-overflow-wrapper:not(:has(.extension-editable-area)){cursor:pointer;}");
const $cfb4a4c7963ce223$export$38e42c68cf43b5d4 = /*#__PURE__*/ (0, $lOiVq.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"} 0px`,
    verticalAlign: 'middle',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&.with-children:not(.without-frame)': {
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.without-frame': {
        padding: 0
    }
});
const $cfb4a4c7963ce223$export$a7db06668cad9adb = /*#__PURE__*/ (0, $lOiVq.css)({
    padding: "var(--ds-space-100, 8px)",
    background: "var(--ds-surface, #FFFFFF)",
    border: `1px solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: "var(--ds-radius-small, 3px)",
    cursor: 'initial',
    width: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-border': {
        border: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.hide-content': {
        display: 'none'
    }
});
const $cfb4a4c7963ce223$export$16dcf8c62f81d973 = /*#__PURE__*/ (0, $lOiVq.css)({
    boxSizing: 'border-box',
    paddingTop: "var(--ds-space-100, 8px)",
    paddingBottom: "var(--ds-space-100, 8px)",
    background: "var(--ds-surface, #FFFFFF)",
    border: `1px solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: "var(--ds-radius-small, 3px)",
    cursor: 'initial',
    width: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-border': {
        border: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.hide-content': {
        display: 'none'
    }
});
const $cfb4a4c7963ce223$export$2a82ddc22e8c7fbb = /*#__PURE__*/ (0, $lOiVq.css)({
    padding: `0 ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`,
    display: 'flex',
    justifyContent: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-padding-styles': {
        padding: "var(--ds-space-100, 8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-bodied-padding-styles': {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"}` // account for upcoming editor elements drag & drop feature
    }
});
const $cfb4a4c7963ce223$export$2ab74686abf0084 = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-margin-styles': {
        margin: `0 ${"var(--ds-space-negative-250, -20px)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-padding-styles': {
        padding: "var(--ds-space-100, 8px)"
    }
});
module.exports["widerLayoutClassName"] = $cfb4a4c7963ce223$export$c51f29288b3ec9db;
module.exports["wrapperStyleInheritedCursor"] = $cfb4a4c7963ce223$export$ebf956b2dea5bd2e;
module.exports["header"] = $cfb4a4c7963ce223$export$38e42c68cf43b5d4;
module.exports["extensionContent"] = $cfb4a4c7963ce223$export$16dcf8c62f81d973;
module.exports["contentWrapper"] = $cfb4a4c7963ce223$export$2a82ddc22e8c7fbb;
module.exports["overflowWrapperStyles"] = $cfb4a4c7963ce223$export$2ab74686abf0084;

});

parcelRegister("11KBS", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $5X6fy = parcelRequire("5X6fy");


var $7Y8M5 = parcelRequire("7Y8M5");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $3k5Tv = parcelRequire("3k5Tv");


var $dUm2W = parcelRequire("dUm2W");


var $bYEj1 = parcelRequire("bYEj1");


var $imFKp = parcelRequire("imFKp");


var $kMptO = parcelRequire("kMptO");

function $0b8b65b7765a8f32$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0b8b65b7765a8f32$var$inlineWrapperStyles = {
    name: "m3p6m2",
    styles: "max-width:100%;tr &{max-width:inherit;}.rich-media-item{max-width:100%;}"
};
const $0b8b65b7765a8f32$var$hoverStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    '&:hover': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    }
});
const $0b8b65b7765a8f32$var$MemoizedWidthContextProvider = ({ rendererContainerWidth: rendererContainerWidth, children: children })=>{
    const widthContextValue = (0, $cozmU.useMemo)(()=>(0, $dUm2W.createWidthContext)(rendererContainerWidth), [
        rendererContainerWidth
    ]);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $dUm2W.WidthContext).Provider, {
        value: widthContextValue
    }, children);
};
const $0b8b65b7765a8f32$var$LegacyWidthContextProvider = ({ rendererContainerWidth: rendererContainerWidth, children: children })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $dUm2W.WidthContext).Provider, {
        value: (0, $dUm2W.createWidthContext)(rendererContainerWidth)
    }, children);
};
const $0b8b65b7765a8f32$var$InlineExtension = (props)=>{
    const { node: node, pluginInjectionApi: pluginInjectionApi, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, isNodeSelected: isNodeSelected, children: children, isNodeHovered: isNodeHovered, setIsNodeHovered: setIsNodeHovered, isLivePageViewMode: isLivePageViewMode } = props;
    const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = macroInteractionDesignFeatureFlags || {};
    const { width: width } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'width'
    ], (states)=>{
        return {
            width: states.widthState?.width
        };
    });
    const hasChildren = !!children;
    const classNames = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('extension-container', 'inline', {
        'with-overlay': !showMacroInteractionDesignUpdates,
        'with-children': hasChildren,
        'with-danger-overlay': showMacroInteractionDesignUpdates
    });
    let rendererContainerWidth = 0;
    if ((0, $fqVYq.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    })) {
        if (width) {
            const padding = width > (0, $7Y8M5.akEditorFullPageNarrowBreakout) ? (0, $7Y8M5.akEditorGutterPaddingDynamic)() : (0, $7Y8M5.akEditorGutterPaddingReduced);
            rendererContainerWidth = width - padding * 2;
        }
    } else rendererContainerWidth = width ? width - (0, $7Y8M5.akEditorGutterPaddingDynamic)() * 2 : 0;
    const handleMouseEvent = (didHover)=>{
        if (setIsNodeHovered) setIsNodeHovered(didHover);
    };
    const inlineExtensionInternal = /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, showMacroInteractionDesignUpdates && !isLivePageViewMode && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $bYEj1.default), {
        node: node,
        isNodeSelected: isNodeSelected,
        isNodeHovered: isNodeHovered,
        showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
        setIsNodeHovered: setIsNodeHovered,
        pluginInjectionApi: pluginInjectionApi
    }), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        "data-testid": "inline-extension-wrapper",
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $kMptO.wrapperStyle),
            $0b8b65b7765a8f32$var$inlineWrapperStyles,
            showMacroInteractionDesignUpdates && !isLivePageViewMode && $0b8b65b7765a8f32$var$hoverStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        onMouseEnter: ()=>handleMouseEvent(true),
        // @atlassian/a11y/mouse-events-have-key-events: hover border is also accessible via keyboard selection.
        // No-ops here satisfy the rule without duplicating state updates.
        onFocus: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onMouseLeave: ()=>handleMouseEvent(false),
        onBlur: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: (0, $imFKp.overlay),
        className: "extension-overlay"
    }), children ? children : /*#__PURE__*/ (0, $lOiVq.jsx)((0, $bYEj1.default), {
        node: node,
        isNodeSelected: isNodeSelected,
        showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
        pluginInjectionApi: pluginInjectionApi
    })));
    return (0, $ieeJu.expValEquals)('enghealth-53346_fix_redaction_marker_editor', 'isEnabled', true) ? /*#__PURE__*/ (0, $lOiVq.jsx)($0b8b65b7765a8f32$var$MemoizedWidthContextProvider, {
        rendererContainerWidth: rendererContainerWidth
    }, inlineExtensionInternal) : /*#__PURE__*/ (0, $lOiVq.jsx)($0b8b65b7765a8f32$var$LegacyWidthContextProvider, {
        rendererContainerWidth: rendererContainerWidth
    }, inlineExtensionInternal);
};
var $0b8b65b7765a8f32$export$2e2bcd8739ae039 = $0b8b65b7765a8f32$var$InlineExtension;
module.exports["default"] = $0b8b65b7765a8f32$export$2e2bcd8739ae039;

});

parcelRegister("kMptO", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");


var $imFKp = parcelRequire("imFKp");

const $7fb94a0aa67ad2f6$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $lOiVq.css)((0, $imFKp.wrapperDefault), {
    cursor: 'pointer',
    display: 'inline-flex',
    margin: `1px 1px ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> img': {
        borderRadius: "var(--ds-radius-small, 3px)"
    },
    '&::after, &::before': {
        verticalAlign: 'text-top',
        display: 'inline-block',
        content: "''"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-children': {
        padding: 0,
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-hover-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    }
});
module.exports["wrapperStyle"] = $7fb94a0aa67ad2f6$export$c4d4f06a25de97f;

});

parcelRegister("1aF4Q", function(module, exports) {
/* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $cbY7C = parcelRequire("cbY7C");


var $5X6fy = parcelRequire("5X6fy");


var $kkFbH = parcelRequire("kkFbH");


var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");


var $3k5Tv = parcelRequire("3k5Tv");


var $4Hles = parcelRequire("4Hles");


var $h9Lux = parcelRequire("h9Lux");

var $RiJVa = parcelRequire("RiJVa");


var $bYEj1 = parcelRequire("bYEj1");


var $38lMZ = parcelRequire("38lMZ");


var $1aQhm = parcelRequire("1aQhm");


var $l2oBI = parcelRequire("l2oBI");

function $9dda0932ae9d1ced$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9dda0932ae9d1ced$var$getContainerCssExtendedStyles = (activeChildIndex, showMacroInteractionDesignUpdates)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $lOiVq.css)((0, $4Hles.sharedMultiBodiedExtensionStyles).mbeExtensionContainer, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [`.multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true']:nth-of-type(${activeChildIndex + 1})`]: /*#__PURE__*/ (0, $lOiVq.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        (0, $4Hles.sharedMultiBodiedExtensionStyles).extensionFrameContent, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        showMacroInteractionDesignUpdates && (0, $4Hles.removeMarginsAndBorder))
    });
const $9dda0932ae9d1ced$var$imageStyles = {
    name: "yadgg9",
    styles: "max-height:24px;max-width:24px"
};
const $9dda0932ae9d1ced$var$hoverStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    '&:hover': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    }
});
const $9dda0932ae9d1ced$var$MultiBodiedExtensionFrames = ({ articleRef: articleRef })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("article", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "multiBodiedExtension--frames",
        "data-testid": "multiBodiedExtension--frames",
        "data-multibodiedextension-frames": true,
        ref: articleRef
    });
};
const $9dda0932ae9d1ced$var$isSelectionInsideNode = (selection, node, getPos)=>{
    const nodeStartPosition = getPos();
    if (typeof nodeStartPosition !== 'number' || !selection) return false;
    const nodeEndPosition = nodeStartPosition + node.nodeSize;
    /*
  	selection starts within MBE ||
  	selection ends within MBE ||
  	selection includes MBE
  */ return nodeStartPosition < selection.from && selection.from < nodeEndPosition || nodeStartPosition < selection.to && selection.to < nodeEndPosition || nodeStartPosition >= selection.from && selection.to >= nodeEndPosition;
};
const $9dda0932ae9d1ced$var$useIsSelectionInsideNode = (editorView, node, getPos, enabled)=>{
    const nodeRef = (0, $cozmU.useRef)(node);
    const [isSelectionInside, setIsSelectionInside] = (0, $cozmU.useState)(()=>enabled && $9dda0932ae9d1ced$var$isSelectionInsideNode(editorView.state.selection, node, getPos));
    nodeRef.current = node;
    (0, $cozmU.useEffect)(()=>{
        if (!enabled) return;
        let animationFrameId;
        const updateSelectionInsideNode = ()=>{
            setIsSelectionInside($9dda0932ae9d1ced$var$isSelectionInsideNode(editorView.state.selection, nodeRef.current, getPos));
        };
        const scheduleUpdateSelectionInsideNode = ()=>{
            if (animationFrameId !== undefined) cancelAnimationFrame(animationFrameId);
            animationFrameId = requestAnimationFrame(updateSelectionInsideNode);
        };
        const ownerDocument = editorView.dom.ownerDocument;
        const unbindSelectionChange = (0, $cbY7C.bind)(ownerDocument, {
            listener: scheduleUpdateSelectionInsideNode,
            type: 'selectionchange'
        });
        const unbindKeyUp = (0, $cbY7C.bind)(editorView.dom, {
            listener: scheduleUpdateSelectionInsideNode,
            type: 'keyup'
        });
        const unbindMouseUp = (0, $cbY7C.bind)(editorView.dom, {
            listener: scheduleUpdateSelectionInsideNode,
            type: 'mouseup'
        });
        return ()=>{
            if (animationFrameId !== undefined) cancelAnimationFrame(animationFrameId);
            unbindSelectionChange();
            unbindKeyUp();
            unbindMouseUp();
        };
    }, [
        editorView,
        getPos,
        enabled
    ]);
    return enabled && isSelectionInside;
};
// Similar to the one in platform/packages/editor/editor-common/src/extensibility/Extension/Lozenge.tsx
const $9dda0932ae9d1ced$var$getWrapperTitleContent = (imageData, title, showMacroInteractionDesignUpdates)=>{
    if (showMacroInteractionDesignUpdates) return null;
    if (imageData) {
        const { url: url, ...rest } = imageData;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            className: "extension-title"
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("img", {
            css: $9dda0932ae9d1ced$var$imageStyles,
            src: url,
            ...rest,
            alt: title
        }), title));
    }
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "extension-title",
        "data-testid": 'multiBodiedExtension-default-lozenge'
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), {
        label: title
    }), title);
};
const $9dda0932ae9d1ced$var$MultiBodiedExtensionWithWidth = ({ node: node, handleContentDOMRef: handleContentDOMRef, getPos: getPos, tryExtensionHandler: tryExtensionHandler, editorView: editorView, eventDispatcher: eventDispatcher, widthState: widthState, editorAppearance: editorAppearance, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, isNodeSelected: isNodeSelected, isNodeHovered: isNodeHovered, isNodeNested: isNodeNested, setIsNodeHovered: setIsNodeHovered, pluginInjectionApi: pluginInjectionApi, isLivePageViewMode: isLivePageViewMode, allowBodiedOverride: allowBodiedOverride = false })=>{
    const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = macroInteractionDesignFeatureFlags || {};
    const { parameters: parameters, extensionKey: extensionKey } = node.attrs;
    const title = parameters && parameters.extensionTitle || parameters && parameters.macroMetadata && parameters.macroMetadata.title || extensionKey || node.type.name;
    const imageData = (0, $RiJVa.getExtensionLozengeData)({
        node: node,
        type: 'image'
    });
    const [activeChildIndex, setActiveChildIndex] = (0, $cozmU.useState)(0);
    // Adding to avoid aliasing `this` for the callbacks
    const updateActiveChild = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((index)=>{
        if (typeof index !== 'number') {
            setActiveChildIndex(0);
            throw new Error('Index is not valid');
        }
        setActiveChildIndex(index);
        return true;
    }, [
        setActiveChildIndex
    ]);
    const articleRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((node)=>{
        return handleContentDOMRef(node);
    }, [
        handleContentDOMRef
    ]);
    const childrenContainer = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        return /*#__PURE__*/ (0, $lOiVq.jsx)($9dda0932ae9d1ced$var$MultiBodiedExtensionFrames, {
            articleRef: articleRef
        });
    }, [
        articleRef
    ]);
    const actions = (0, $1aQhm.useMultiBodiedExtensionActions)({
        updateActiveChild: updateActiveChild,
        editorView: editorView,
        getPos: getPos,
        node: node,
        eventDispatcher: eventDispatcher,
        allowBodiedOverride: allowBodiedOverride,
        childrenContainer: childrenContainer
    });
    const extensionHandlerResult = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        return tryExtensionHandler(actions);
    }, [
        tryExtensionHandler,
        actions
    ]);
    const layout = node.attrs.layout;
    const legacyShouldBreakout = [
        'full-width',
        'wide'
    ].includes(layout) && editorAppearance !== 'full-width';
    const tinymceFullWidthModeEnabled = (0, $ieeJu.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true);
    const breakoutExtensionFixEnabled = (0, $ieeJu.expValEquals)('confluence_max_width_breakout_extension_fix', 'isEnabled', true);
    const shouldUseBreakoutFix = tinymceFullWidthModeEnabled && breakoutExtensionFixEnabled;
    const shouldBreakout = shouldUseBreakoutFix ? (0, $38lMZ.shouldExtensionBreakout)({
        layout: layout,
        editorAppearance: editorAppearance,
        isTopLevelNode: true
    }) : legacyShouldBreakout;
    let mbeWrapperStyles = {};
    if (shouldBreakout) {
        const { ...breakoutStyles } = (0, $h9Lux.calculateBreakoutStyles)({
            mode: node.attrs.layout,
            widthStateLineLength: widthState?.lineLength,
            widthStateWidth: widthState?.width
        });
        mbeWrapperStyles = breakoutStyles;
    }
    const shouldUseNativeTabsPresentation = (0, $ixfCV.fg)('confluence_frontend_native_tabs_extension');
    const isSelectionInsideMultiBodiedExtension = $9dda0932ae9d1ced$var$useIsSelectionInsideNode(editorView, node, getPos, shouldUseNativeTabsPresentation);
    const isMultiBodiedExtensionActive = isNodeSelected || isSelectionInsideMultiBodiedExtension;
    const wrapperClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('multiBodiedExtension--wrapper', 'extension-container', 'block', {
        'with-border': showMacroInteractionDesignUpdates && (shouldUseNativeTabsPresentation ? isMultiBodiedExtensionActive : true),
        'with-danger-overlay': showMacroInteractionDesignUpdates,
        'with-padding-background-styles': showMacroInteractionDesignUpdates,
        'with-margin-styles': showMacroInteractionDesignUpdates && !isNodeNested
    });
    const containerClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('multiBodiedExtension--container', {
        'remove-padding': showMacroInteractionDesignUpdates
    });
    const bodyContainerClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('multiBodiedExtension--body-container');
    const navigationClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('multiBodiedExtension--navigation', {
        'remove-margins': showMacroInteractionDesignUpdates,
        'remove-border': showMacroInteractionDesignUpdates
    });
    const overlayClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('multiBodiedExtension--overlay', {
        'with-margin': showMacroInteractionDesignUpdates
    });
    const handleMouseEvent = (didHover)=>{
        if (setIsNodeHovered) setIsNodeHovered(didHover);
    };
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, showMacroInteractionDesignUpdates && !isLivePageViewMode && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $bYEj1.default), {
        isNodeSelected: shouldUseNativeTabsPresentation ? isMultiBodiedExtensionActive : isNodeSelected,
        node: node,
        showMacroInteractionDesignUpdates: true,
        customContainerStyles: mbeWrapperStyles,
        isNodeHovered: isNodeHovered,
        isNodeNested: isNodeNested,
        setIsNodeHovered: setIsNodeHovered,
        isBodiedMacro: true,
        isMultiBodiedMacro: shouldUseNativeTabsPresentation,
        pluginInjectionApi: pluginInjectionApi
    }), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: wrapperClassNames,
        css: [
            /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766 */ shouldUseNativeTabsPresentation ? (0, $l2oBI.mbeExtensionWrapperCSSStyles) : (0, $l2oBI.mbeExtensionWrapperCSSStylesOld),
            /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage */ showMacroInteractionDesignUpdates && !isLivePageViewMode && $9dda0932ae9d1ced$var$hoverStyles
        ],
        "data-testid": "multiBodiedExtension--wrapper-editor",
        "data-layout": node.attrs.layout,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mbeWrapperStyles,
        onMouseEnter: ()=>handleMouseEvent(true),
        // @atlassian/a11y/mouse-events-have-key-events: hover border is also applied via .ak-editor-selected-node
        // CSS on keyboard selection. No-ops here satisfy the rule without duplicating state updates.
        onFocus: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onMouseLeave: ()=>handleMouseEvent(false),
        onBlur: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: shouldUseNativeTabsPresentation ? (0, $l2oBI.overlayStyles) : (0, $l2oBI.overlayStylesOld),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: overlayClassNames,
        "data-testid": "multiBodiedExtension--overlay"
    }), $9dda0932ae9d1ced$var$getWrapperTitleContent(imageData, title, showMacroInteractionDesignUpdates), /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: containerClassNames,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: $9dda0932ae9d1ced$var$getContainerCssExtendedStyles(activeChildIndex, showMacroInteractionDesignUpdates),
        "data-testid": "multiBodiedExtension--container",
        "data-multiBodiedExtension-container": true,
        "data-active-child-index": activeChildIndex
    }, allowBodiedOverride ? /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: bodyContainerClassNames,
        "data-testid": "multiBodiedExtension--body-container"
    }, extensionHandlerResult) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, $lOiVq.jsx)("nav", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: navigationClassNames,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $4Hles.sharedMultiBodiedExtensionStyles).mbeNavigation,
        "data-testid": "multiBodiedExtension-navigation"
    }, extensionHandlerResult), childrenContainer))));
};
const $9dda0932ae9d1ced$var$MultiBodiedExtension = (props)=>{
    const { pluginInjectionApi: pluginInjectionApi } = props;
    const { width: width, lineLength: lineLength } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'width'
    ], (states)=>({
            width: states.widthState?.width,
            lineLength: states.widthState?.lineLength
        }));
    // Ignored via go/ees005
    return /*#__PURE__*/ (0, $lOiVq.jsx)($9dda0932ae9d1ced$var$MultiBodiedExtensionWithWidth, {
        widthState: width === undefined ? undefined : {
            width: width,
            lineLength: lineLength
        },
        ...props
    });
};
var $9dda0932ae9d1ced$export$2e2bcd8739ae039 = $9dda0932ae9d1ced$var$MultiBodiedExtension;
module.exports["default"] = $9dda0932ae9d1ced$export$2e2bcd8739ae039;

});

parcelRegister("4Hles", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");


var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");

function $63365c1923ee5a66$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Wraps the navigation bar and extensionFrames
const $63365c1923ee5a66$var$mbeExtensionContainer = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    background: 'transparent !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'padding:': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        left: `${"var(--ds-space-100, 8px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        right: `${"var(--ds-space-100, 8px)"} !important`
    },
    paddingBottom: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-padding': {
        paddingBottom: 0
    },
    position: 'relative',
    verticalAlign: 'middle',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-handler-result': {
        marginLeft: "var(--ds-space-100, 8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true'], .multiBodiedExtension--frames > [data-extension-frame='true']": {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-content-dom-wrapper, .multiBodiedExtension--frames': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[data-extension-frame='true'] > :not(style):first-child, [data-extension-frame='true'] > style:first-child + *": {
            marginTop: 0
        }
    }
});
const $63365c1923ee5a66$var$mbeNavigation = {
    name: "1a47qx2",
    styles: "border-top-left-radius:var(--ds-radius-small, 3px);border-top-right-radius:var(--ds-radius-small, 3px);user-select:none;-webkit-user-modify:read-only;border-bottom:none !important;background:var(--ds-surface, #FFFFFF);margin-left:var(--ds-space-100, 8px);margin-right:var(--ds-space-100, 8px);&.remove-margins{margin:var(--ds-space-negative-100, -8px);}&.remove-border{border:none;}"
};
const $63365c1923ee5a66$var$extensionFrameContent = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    display: 'block !important',
    minHeight: '100px',
    background: 'transparent',
    borderBottomLeftRadius: "var(--ds-radius-small, 3px)",
    borderBottomRightRadius: "var(--ds-radius-small, 3px)",
    marginLeft: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-100, 8px)",
    cursor: 'initial',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.pm-table-with-controls': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-150, 12px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingRight: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.bodiedExtensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-100, 8px)"} !important`
    }
});
// Block spacing hook variant of extensionFrameContent. Identical to extensionFrameContent except
// the extension content margins read from the `--ak-editor-extension-block-spacing` CSS custom
// property (falling back to the original token values). Selected only when
// expValEquals('platform_editor_extension_block_spacing') is enabled.
const $63365c1923ee5a66$var$extensionFrameContentWithBlockSpacing = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    display: 'block !important',
    minHeight: '100px',
    background: 'transparent',
    borderBottomLeftRadius: "var(--ds-radius-small, 3px)",
    borderBottomRightRadius: "var(--ds-radius-small, 3px)",
    marginLeft: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-100, 8px)",
    cursor: 'initial',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.pm-table-with-controls': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-150, 12px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingRight: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.bodiedExtensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginTop: `var(--ak-editor-extension-block-spacing, ${"var(--ds-space-150, 12px)"}) !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginTop: `var(--ak-editor-extension-block-spacing, ${"var(--ds-space-100, 8px)"}) !important`
    }
});
const $63365c1923ee5a66$var$extensionFrameContentOld = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    padding: `${"var(--ds-space-100, 8px)"} !important`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    display: 'block !important',
    minHeight: '100px',
    background: 'transparent',
    borderBottomLeftRadius: "var(--ds-radius-small, 3px)",
    borderBottomRightRadius: "var(--ds-radius-small, 3px)",
    marginLeft: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-100, 8px)",
    cursor: 'initial',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.pm-table-with-controls': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-150, 12px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingRight: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.bodiedExtensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-100, 8px)"} !important`
    }
});
const $63365c1923ee5a66$export$8df0393dc2d5d656 = {
    name: "c620zi",
    styles: "margin-left:0;margin-right:0;border:none"
};
const $63365c1923ee5a66$export$9c7196ca47f67390 = {
    mbeExtensionContainer: $63365c1923ee5a66$var$mbeExtensionContainer,
    mbeNavigation: $63365c1923ee5a66$var$mbeNavigation,
    get extensionFrameContent () {
        if (!(0, $ixfCV.fg)('confluence_frontend_native_tabs_extension')) return $63365c1923ee5a66$var$extensionFrameContentOld;
        // Block spacing hook — when the experiment is on, use the variant whose extension content
        // margins read from --ak-editor-extension-block-spacing (falling back to the originals).
        // expValEquals always fires an exposure event.
        return (0, $ieeJu.expValEquals)('platform_editor_extension_block_spacing', 'isEnabled', true) ? $63365c1923ee5a66$var$extensionFrameContentWithBlockSpacing : $63365c1923ee5a66$var$extensionFrameContent;
    }
};
module.exports["removeMarginsAndBorder"] = $63365c1923ee5a66$export$8df0393dc2d5d656;
module.exports["sharedMultiBodiedExtensionStyles"] = $63365c1923ee5a66$export$9c7196ca47f67390;

});

parcelRegister("1aQhm", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kCECX = parcelRequire("kCECX");


var $ixfCV = parcelRequire("ixfCV");


var $krYZG = parcelRequire("krYZG");


var $l5pc4 = parcelRequire("l5pc4");

const $2e65762104d9a60b$export$3c7139d93ecb4f1f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { updateActiveChild: updateActiveChild, editorView: editorView, getPos: getPos, node: node, eventDispatcher: eventDispatcher, allowBodiedOverride: allowBodiedOverride, childrenContainer: childrenContainer } = t0;
    let t1;
    if ($[0] !== allowBodiedOverride || $[1] !== childrenContainer || $[2] !== editorView || $[3] !== eventDispatcher || $[4] !== getPos || $[5] !== node || $[6] !== updateActiveChild) {
        t1 = {
            changeActive (index, options) {
                const { state: state, dispatch: dispatch } = editorView;
                const updateActiveChildResult = updateActiveChild(index);
                if (eventDispatcher) (0, $l5pc4.sendMBEAnalyticsEvent)((0, $krYZG.ACTION).CHANGE_ACTIVE, node, eventDispatcher);
                const selection = options?.selection ?? "none";
                if (selection === "none") return updateActiveChildResult;
                const pos = getPos();
                if (typeof pos !== "number") return updateActiveChildResult;
                const possiblyMbeNode = state.doc.nodeAt(pos);
                if (possiblyMbeNode && possiblyMbeNode?.type?.name === "multiBodiedExtension" && possiblyMbeNode?.content) {
                    if (index < 0 || index >= possiblyMbeNode?.content?.childCount) throw new Error(`Index out of bounds: valid range is 0-${possiblyMbeNode?.content?.childCount - 1} inclusive`);
                    let desiredPos = pos;
                    for(let i = 0; i < index && i < possiblyMbeNode?.content?.childCount; i++)desiredPos = desiredPos + (possiblyMbeNode?.content?.child(i)?.nodeSize || 0);
                    const targetFrame = possiblyMbeNode.content.child(index);
                    if (selection === "start") dispatch(state.tr.setSelection((0, $kCECX.TextSelection).near(state.doc.resolve(desiredPos + 1))));
                    else dispatch(state.tr.setSelection((0, $kCECX.TextSelection).near(state.doc.resolve(desiredPos + targetFrame.nodeSize), -1)));
                    editorView.focus();
                }
                return updateActiveChildResult;
            },
            addChild () {
                const { state: state_0, dispatch: dispatch_0 } = editorView;
                const p = state_0.schema.nodes.paragraph.createAndFill({});
                if (!p) throw new Error("Could not create paragraph");
                const frame = state_0.schema.nodes.extensionFrame.createAndFill({}, [
                    p
                ]);
                const pos_0 = getPos();
                if (typeof pos_0 !== "number" || !frame) throw new Error("Could not create frame or position not valid");
                const insertAt = Math.min((pos_0 || 1) + node.content.size, state_0.doc.content.size);
                const tr = state_0.tr.insert(insertAt, frame);
                tr.setSelection(new (0, $kCECX.TextSelection)(tr.doc.resolve(insertAt + 1)));
                dispatch_0(tr);
                if (eventDispatcher) (0, $l5pc4.sendMBEAnalyticsEvent)((0, $krYZG.ACTION).ADD_CHILD, node, eventDispatcher);
                return true;
            },
            getChildrenCount () {
                return node.content.childCount;
            },
            removeChild (index_0) {
                const pos_1 = getPos();
                if (typeof pos_1 !== "number" || typeof index_0 !== "number") throw new Error("Position or index not valid");
                const { state: state_1, dispatch: dispatch_1 } = editorView;
                if (node.content.childCount === 1) {
                    const tr_0 = state_1.tr;
                    tr_0.deleteRange(pos_1, pos_1 + node.content.size);
                    dispatch_1(tr_0);
                    return true;
                }
                const $pos = state_1.doc.resolve(pos_1);
                const $startNodePos = state_1.doc.resolve($pos.start($pos.depth + 1));
                const startFramePosition = $startNodePos.posAtIndex(index_0);
                const maybeFrameNode = state_1.doc.nodeAt(startFramePosition);
                if (!maybeFrameNode) throw new Error("Could not find frame node");
                const endFramePosition = maybeFrameNode.content.size + startFramePosition;
                const tr_1 = state_1.tr;
                tr_1.deleteRange(startFramePosition, endFramePosition);
                dispatch_1(tr_1);
                if (eventDispatcher) (0, $l5pc4.sendMBEAnalyticsEvent)((0, $krYZG.ACTION).REMOVE_CHILD, node, eventDispatcher);
                return true;
            },
            reorderChildren (fromIndex, toIndex) {
                const pos_2 = getPos();
                if (typeof pos_2 !== "number" || typeof fromIndex !== "number" || typeof toIndex !== "number") throw new Error("Position or index not valid");
                if (fromIndex === toIndex) return true;
                const { state: state_2, dispatch: dispatch_2 } = editorView;
                const currentNode = state_2.doc.nodeAt(pos_2);
                if (!currentNode) throw new Error("Could not find extension node");
                const $pos_0 = state_2.doc.resolve(pos_2);
                const $startNodePos_0 = state_2.doc.resolve($pos_0.start($pos_0.depth + 1));
                const frames = [];
                currentNode.content.forEach((child)=>{
                    frames.push(child);
                });
                if (fromIndex >= frames.length || toIndex >= frames.length) throw new Error("Index out of bounds");
                const [removed] = frames.splice(fromIndex, 1);
                frames.splice(toIndex, 0, removed);
                const tr_2 = state_2.tr;
                const containerStart = $startNodePos_0.pos;
                const containerEnd = containerStart + currentNode.content.size;
                tr_2.replaceWith(containerStart, containerEnd, frames);
                dispatch_2(tr_2);
                return true;
            },
            updateParameters (parameters, analyticsChangedParam) {
                const { state: state_3, dispatch: dispatch_3 } = editorView;
                const pos_3 = getPos();
                if (typeof pos_3 !== "number") throw new Error("Position not valid");
                const updatedParameters = {
                    ...node.attrs,
                    parameters: {
                        ...node.attrs.parameters,
                        ...(0, $ixfCV.fg)("confluence_frontend_native_tabs_extension") ? {
                            ...parameters
                        } : {
                            macroParams: parameters
                        }
                    }
                };
                const tr_3 = state_3.tr.setNodeMarkup(pos_3, null, updatedParameters);
                dispatch_3(tr_3);
                if (eventDispatcher) (0, $l5pc4.sendMBEAnalyticsEvent)((0, $krYZG.ACTION).UPDATE_PARAMETERS, node, eventDispatcher, analyticsChangedParam && (0, $ixfCV.fg)("confluence_frontend_native_tabs_extension") ? {
                    changedParams: analyticsChangedParam
                } : undefined);
                return true;
            },
            getChildren () {
                const { state: state_4 } = editorView;
                const pos_4 = getPos();
                if (typeof pos_4 !== "number") return [];
                const children = state_4.doc.nodeAt(pos_4)?.content;
                if (eventDispatcher) (0, $l5pc4.sendMBEAnalyticsEvent)((0, $krYZG.ACTION).GET_CHILDREN, node, eventDispatcher);
                return children ? children.toJSON() : [];
            },
            getChildrenContainer () {
                if (!allowBodiedOverride) throw new Error("Could not provide children container");
                if (eventDispatcher) (0, $l5pc4.sendMBEAnalyticsEvent)((0, $krYZG.ACTION).GET_CHILDREN_CONTAINER, node, eventDispatcher);
                return childrenContainer;
            }
        };
        $[0] = allowBodiedOverride;
        $[1] = childrenContainer;
        $[2] = editorView;
        $[3] = eventDispatcher;
        $[4] = getPos;
        $[5] = node;
        $[6] = updateActiveChild;
        $[7] = t1;
    } else t1 = $[7];
    const actions = t1;
    return actions;
} : ({ updateActiveChild: updateActiveChild, editorView: editorView, getPos: getPos, node: node, eventDispatcher: eventDispatcher, allowBodiedOverride: allowBodiedOverride, childrenContainer: childrenContainer })=>{
    const actions = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        return {
            changeActive (index, options) {
                const { state: state, dispatch: dispatch } = editorView;
                const updateActiveChildResult = updateActiveChild(index);
                if (eventDispatcher) (0, $l5pc4.sendMBEAnalyticsEvent)((0, $krYZG.ACTION).CHANGE_ACTIVE, node, eventDispatcher);
                const selection = options?.selection ?? 'none';
                if (selection === 'none') return updateActiveChildResult;
                const pos = getPos();
                if (typeof pos !== 'number') return updateActiveChildResult;
                const possiblyMbeNode = state.doc.nodeAt(pos);
                if (possiblyMbeNode && possiblyMbeNode?.type?.name === 'multiBodiedExtension' && possiblyMbeNode?.content) {
                    if (index < 0 || index >= possiblyMbeNode?.content?.childCount) throw new Error(`Index out of bounds: valid range is 0-${possiblyMbeNode?.content?.childCount - 1} inclusive`);
                    let desiredPos = pos;
                    for(let i = 0; i < index && i < possiblyMbeNode?.content?.childCount; i++)desiredPos += possiblyMbeNode?.content?.child(i)?.nodeSize || 0;
                    const targetFrame = possiblyMbeNode.content.child(index);
                    if (selection === 'start') // +1 moves past the extensionFrame opening token; TextSelection.near() finds
                    // the nearest valid text cursor position from there.
                    dispatch(state.tr.setSelection((0, $kCECX.TextSelection).near(state.doc.resolve(desiredPos + 1))));
                    else // Place cursor at the end of the target frame's content.
                    // -1 bias searches backward from the frame's closing token.
                    dispatch(state.tr.setSelection((0, $kCECX.TextSelection).near(state.doc.resolve(desiredPos + targetFrame.nodeSize), -1)));
                    editorView.focus();
                }
                return updateActiveChildResult;
            },
            addChild () {
                const { state: state_0, dispatch: dispatch_0 } = editorView;
                const p = state_0.schema.nodes.paragraph.createAndFill({});
                if (!p) throw new Error('Could not create paragraph');
                const frame = state_0.schema.nodes.extensionFrame.createAndFill({}, [
                    p
                ]);
                const pos_0 = getPos();
                if (typeof pos_0 !== 'number' || !frame) throw new Error('Could not create frame or position not valid');
                const insertAt = Math.min((pos_0 || 1) + node.content.size, state_0.doc.content.size);
                const tr = state_0.tr.insert(insertAt, frame);
                tr.setSelection(new (0, $kCECX.TextSelection)(tr.doc.resolve(insertAt + 1)));
                dispatch_0(tr);
                if (eventDispatcher) (0, $l5pc4.sendMBEAnalyticsEvent)((0, $krYZG.ACTION).ADD_CHILD, node, eventDispatcher);
                return true;
            },
            getChildrenCount () {
                return node.content.childCount;
            },
            removeChild (index_0) {
                const pos_1 = getPos();
                // Ignored via go/ees007
                // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                // TODO: Add child index validation here, don't trust this data
                if (typeof pos_1 !== 'number' || typeof index_0 !== 'number') throw new Error('Position or index not valid');
                const { state: state_1, dispatch: dispatch_1 } = editorView;
                if (node.content.childCount === 1) {
                    const tr_0 = state_1.tr;
                    tr_0.deleteRange(pos_1, pos_1 + node.content.size);
                    dispatch_1(tr_0);
                    return true;
                }
                const $pos = state_1.doc.resolve(pos_1);
                const $startNodePos = state_1.doc.resolve($pos.start($pos.depth + 1));
                const startFramePosition = $startNodePos.posAtIndex(index_0);
                const maybeFrameNode = state_1.doc.nodeAt(startFramePosition);
                if (!maybeFrameNode) throw new Error('Could not find frame node');
                const endFramePosition = maybeFrameNode.content.size + startFramePosition;
                const tr_1 = state_1.tr;
                tr_1.deleteRange(startFramePosition, endFramePosition);
                dispatch_1(tr_1);
                if (eventDispatcher) (0, $l5pc4.sendMBEAnalyticsEvent)((0, $krYZG.ACTION).REMOVE_CHILD, node, eventDispatcher);
                return true;
            },
            reorderChildren (fromIndex, toIndex) {
                const pos_2 = getPos();
                if (typeof pos_2 !== 'number' || typeof fromIndex !== 'number' || typeof toIndex !== 'number') throw new Error('Position or index not valid');
                if (fromIndex === toIndex) return true;
                const { state: state_2, dispatch: dispatch_2 } = editorView;
                // Use current node from state (not stale closure)
                const currentNode = state_2.doc.nodeAt(pos_2);
                if (!currentNode) throw new Error('Could not find extension node');
                const $pos_0 = state_2.doc.resolve(pos_2);
                const $startNodePos_0 = state_2.doc.resolve($pos_0.start($pos_0.depth + 1));
                // Collect all current frame nodes
                const frames = [];
                currentNode.content.forEach((child)=>{
                    frames.push(child);
                });
                if (fromIndex >= frames.length || toIndex >= frames.length) throw new Error('Index out of bounds');
                // Reorder the frames array in memory
                const [removed] = frames.splice(fromIndex, 1);
                frames.splice(toIndex, 0, removed);
                // Atomically replace the entire MBE content with reordered frames
                const tr_2 = state_2.tr;
                const containerStart = $startNodePos_0.pos;
                const containerEnd = containerStart + currentNode.content.size;
                tr_2.replaceWith(containerStart, containerEnd, frames);
                dispatch_2(tr_2);
                return true;
            },
            updateParameters (parameters, analyticsChangedParam) {
                const { state: state_3, dispatch: dispatch_3 } = editorView;
                const pos_3 = getPos();
                if (typeof pos_3 !== 'number') throw new Error('Position not valid');
                // We are retaining node.attrs to keep the node type and extension key
                // and only updating the parameters coming in from the user
                // parameters will contain only macroParams information
                const updatedParameters = {
                    ...node.attrs,
                    parameters: {
                        ...node.attrs.parameters,
                        ...(0, $ixfCV.fg)('confluence_frontend_native_tabs_extension') ? {
                            ...parameters
                        } : {
                            macroParams: parameters
                        }
                    }
                };
                const tr_3 = state_3.tr.setNodeMarkup(pos_3, null, updatedParameters);
                dispatch_3(tr_3);
                if (eventDispatcher) (0, $l5pc4.sendMBEAnalyticsEvent)((0, $krYZG.ACTION).UPDATE_PARAMETERS, node, eventDispatcher, analyticsChangedParam && (0, $ixfCV.fg)('confluence_frontend_native_tabs_extension') ? {
                    changedParams: analyticsChangedParam
                } : undefined);
                return true;
            },
            getChildren () {
                const { state: state_4 } = editorView;
                const pos_4 = getPos();
                if (typeof pos_4 !== 'number') return [];
                const children = state_4.doc.nodeAt(pos_4)?.content;
                if (eventDispatcher) (0, $l5pc4.sendMBEAnalyticsEvent)((0, $krYZG.ACTION).GET_CHILDREN, node, eventDispatcher);
                return children ? children.toJSON() : [];
            },
            getChildrenContainer () {
                if (!allowBodiedOverride) throw new Error('Could not provide children container');
                if (eventDispatcher) (0, $l5pc4.sendMBEAnalyticsEvent)((0, $krYZG.ACTION).GET_CHILDREN_CONTAINER, node, eventDispatcher);
                return childrenContainer;
            }
        };
    }, [
        node,
        editorView,
        getPos,
        updateActiveChild,
        eventDispatcher,
        allowBodiedOverride,
        childrenContainer
    ]);
    return actions;
};
module.exports["useMultiBodiedExtensionActions"] = $2e65762104d9a60b$export$3c7139d93ecb4f1f;

});

parcelRegister("l5pc4", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $fGIRV = parcelRequire("fGIRV");


var $6pnwK = parcelRequire("6pnwK");

const $d90b6fce9b402e45$export$c39676f5ca8bcb0e = (action, node, eventDispatcher, attributes)=>{
    const analyticsDispatch = (0, $fGIRV.createDispatch)(eventDispatcher);
    analyticsDispatch((0, $6pnwK.analyticsEventKey), {
        payload: {
            action: action,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).MULTI_BODIED_EXTENSION,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                extensionType: node.attrs.extensionType,
                extensionKey: node.attrs.extensionKey,
                localId: node.attrs.localId,
                currentFramesCount: node.content.childCount,
                ...attributes
            }
        }
    });
};
module.exports["sendMBEAnalyticsEvent"] = $d90b6fce9b402e45$export$c39676f5ca8bcb0e;

});

parcelRegister("l2oBI", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /* eslint-disable @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");


var $imFKp = parcelRequire("imFKp");

function $084d3298f342321b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $084d3298f342321b$export$4226a1fc882c4ef9 = /*#__PURE__*/ (0, $lOiVq.css)((0, $imFKp.wrapperDefault), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-margin-styles': {
        marginTop: "var(--ds-space-300, 24px)",
        marginLeft: "var(--ds-space-negative-250, -20px)",
        marginRight: "var(--ds-space-negative-250, -20px)"
    },
    cursor: 'pointer',
    marginTop: "var(--ds-space-250, 20px)",
    marginBottom: "var(--ds-space-200, 16px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extension-title': {
        display: 'flex',
        alignItems: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        lineHeight: '16px !important',
        marginBottom: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-050, 4px)"} !important`,
        marginRight: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingTop: `${"var(--ds-space-100, 8px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-hover-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-padding-background-styles': {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"}`,
        background: 'transparent'
    }
});
const $084d3298f342321b$export$6bb53a1c4e28a730 = /*#__PURE__*/ (0, $lOiVq.css)((0, $imFKp.wrapperDefault), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-margin-styles': {
        marginTop: 0,
        marginLeft: "var(--ds-space-negative-150, -12px)",
        marginRight: "var(--ds-space-negative-150, -12px)"
    },
    cursor: 'pointer',
    marginTop: "var(--ds-space-250, 20px)",
    marginBottom: "var(--ds-space-200, 16px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extension-title': {
        display: 'flex',
        alignItems: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        lineHeight: '16px !important',
        marginBottom: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-050, 4px)"} !important`,
        marginRight: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingTop: `${"var(--ds-space-100, 8px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-hover-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-padding-background-styles': {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"}`,
        background: 'transparent'
    }
});
const $084d3298f342321b$export$9b0df2896b2eff02 = {
    name: "1ir4r0n",
    styles: "border-radius:var(--ds-radius-small, 3px);position:absolute;width:100%;height:100%;opacity:0;pointer-events:none;transition:opacity 0.3s;z-index:1;&.with-margin{margin-top:var(--ds-space-negative-100, -8px);margin-left:var(--ds-space-negative-250, -20px);}"
};
const $084d3298f342321b$export$85f4d1340338a338 = {
    name: "1jgeuox",
    styles: "border-radius:var(--ds-radius-small, 3px);position:absolute;width:100%;height:100%;opacity:0;pointer-events:none;transition:opacity 0.3s;z-index:1;&.with-margin{margin:var(--ds-space-negative-100, -8px);}"
};
module.exports["mbeExtensionWrapperCSSStyles"] = $084d3298f342321b$export$4226a1fc882c4ef9;
module.exports["mbeExtensionWrapperCSSStylesOld"] = $084d3298f342321b$export$6bb53a1c4e28a730;
module.exports["overlayStyles"] = $084d3298f342321b$export$9b0df2896b2eff02;
module.exports["overlayStylesOld"] = $084d3298f342321b$export$85f4d1340338a338;

});

parcelRegister("ak92H", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag React.Fragment
 */ parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $5X6fy = parcelRequire("5X6fy");


var $fngNp = parcelRequire("fngNp");


var $1caeZ = parcelRequire("1caeZ");

function $6906174335f6af7c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6906174335f6af7c$var$styles = {
    name: "4s3kp2",
    styles: "&.inline-extension{display:inline-block;}&.relative{position:relative;}"
};
const $6906174335f6af7c$var$hoverStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':has(.extension-label:hover) .extension-container, :has(.extension-edit-toggle-container:hover) .extension-container': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':has(.extension-container:hover) .extension-label, :has(.extension-edit-toggle-container:hover) .extension-label, .extension-label:hover': {
        opacity: 1,
        backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
        boxShadow: 'none',
        cursor: 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.always-hide-label': {
            opacity: 0,
            cursor: 'auto'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.with-bodied-macro-live-page-styles': {
            backgroundColor: "var(--ds-background-input, #FFFFFF)",
            boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':has(.extension-label:hover) .extension-icon, :has(.extension-container:hover) .extension-icon, :has(.extension-edit-toggle-container:hover) .extension-icon': {
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':has(.extension-label:hover) .extension-edit-toggle-container, :has(.extension-container:hover) .extension-edit-toggle-container, .extension-edit-toggle-container:hover': {
        opacity: 1
    }
});
const $6906174335f6af7c$export$f97fc055ac075140 = ({ children: children, nodeType: nodeType, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, intl: intl })=>{
    const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = macroInteractionDesignFeatureFlags || {};
    const wrapperClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))({
        'inline-extension': nodeType === 'inlineExtension' && showMacroInteractionDesignUpdates,
        relative: showMacroInteractionDesignUpdates
    });
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $1caeZ.ExtensionSSRReactContextsProvider), {
        intl: intl
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        "data-testid": "extension-node-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: wrapperClassNames,
        css: [
            $6906174335f6af7c$var$styles,
            $6906174335f6af7c$var$hoverStyles
        ]
    }, children, nodeType === 'inlineExtension' && (0, $fngNp.ZERO_WIDTH_SPACE)));
};
module.exports["ExtensionNodeWrapper"] = $6906174335f6af7c$export$f97fc055ac075140;

});

parcelRegister("1caeZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4iudd = parcelRequire("4iudd");


var $iAEsk = parcelRequire("iAEsk");

const $83b25d113ab31975$export$36cc1c5797436ac4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ExtensionSSRReactContextsProvider(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children, intl: intl } = t0;
    if (!(0, $4iudd.isSSR)() || !(0, $iAEsk.isSSRStreaming)()) return children;
    if (!intl) return children;
    let t1;
    if ($[0] !== children || $[1] !== intl) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.RawIntlProvider), {
            value: intl
        }, children);
        $[0] = children;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function ExtensionSSRReactContextsProvider({ children: children, intl: intl }) {
    if (!(0, $4iudd.isSSR)() || !(0, $iAEsk.isSSRStreaming)()) return children;
    if (!intl) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.RawIntlProvider), {
        value: intl
    }, children);
};
module.exports["ExtensionSSRReactContextsProvider"] = $83b25d113ab31975$export$36cc1c5797436ac4;

});

parcelRegister("jnhwS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $Mf8oW = parcelRequire("Mf8oW");

const $848fcbae82ed0c52$export$eba5603251c4feaf = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { editorView: editorView, node: node, dataSourceProvider: dataSourceProvider } = t0;
    let t1;
    if ($[0] !== editorView || $[1] !== node.marks) {
        t1 = node.marks?.find((mark)=>mark.type === editorView.state.schema.marks?.dataConsumer)?.attrs?.sources?.[0];
        $[0] = editorView;
        $[1] = node.marks;
        $[2] = t1;
    } else t1 = $[2];
    const dataSourceId = t1;
    let t2;
    if ($[3] !== dataSourceId || $[4] !== dataSourceProvider) {
        t2 = ()=>{
            const dataSourceReference = dataSourceProvider?.get(dataSourceId);
            if (dataSourceReference) return dataSourceReference;
        };
        $[3] = dataSourceId;
        $[4] = dataSourceProvider;
        $[5] = t2;
    } else t2 = $[5];
    const [reference, setReference] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(t2);
    let t3;
    let t4;
    if ($[6] !== dataSourceId || $[7] !== dataSourceProvider) {
        t3 = ()=>{
            dataSourceProvider?.unsubscribe(dataSourceId, setReference);
            dataSourceProvider?.subscribe(dataSourceId, setReference);
            return ()=>dataSourceProvider?.unsubscribe(dataSourceId, setReference);
        };
        t4 = [
            dataSourceProvider,
            dataSourceId
        ];
        $[6] = dataSourceId;
        $[7] = dataSourceProvider;
        $[8] = t3;
        $[9] = t4;
    } else {
        t3 = $[8];
        t4 = $[9];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t3, t4);
    let t5;
    if ($[10] !== reference) {
        t5 = reference ? [
            reference
        ] : [];
        $[10] = reference;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ editorView: editorView, node: node, dataSourceProvider: dataSourceProvider })=>{
    const dataSourceId = node.marks?.find((mark)=>mark.type === editorView.state.schema.marks?.dataConsumer)?.attrs?.sources?.[0];
    const [reference, setReference] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(()=>{
        const dataSourceReference = dataSourceProvider?.get(dataSourceId);
        if (dataSourceReference) return dataSourceReference;
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        dataSourceProvider?.unsubscribe(dataSourceId, setReference);
        dataSourceProvider?.subscribe(dataSourceId, setReference);
        return ()=>dataSourceProvider?.unsubscribe(dataSourceId, setReference);
    }, [
        dataSourceProvider,
        dataSourceId
    ]);
    return reference ? [
        reference
    ] : [];
};
const $848fcbae82ed0c52$var$ExtensionWithDataSource = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const reference = $848fcbae82ed0c52$export$eba5603251c4feaf(props);
    let t0;
    if ($[0] !== props || $[1] !== reference) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Mf8oW.Extension), {
            ...props,
            references: reference
        });
        $[0] = props;
        $[1] = reference;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const reference = $848fcbae82ed0c52$export$eba5603251c4feaf(props);
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Mf8oW.Extension), {
        ...props,
        references: reference
    });
};
var $848fcbae82ed0c52$export$2e2bcd8739ae039 = $848fcbae82ed0c52$var$ExtensionWithDataSource;
module.exports["default"] = $848fcbae82ed0c52$export$2e2bcd8739ae039;

});

parcelRegister("2CPAu", function(module, exports) {

var $kCECX = parcelRequire("kCECX");


var $2nOF5 = parcelRequire("2nOF5");


var $3xuv0 = parcelRequire("3xuv0");


var $hiQdW = parcelRequire("hiQdW");


var $gkua4 = parcelRequire("gkua4");


var $1qyJ5 = parcelRequire("1qyJ5");


var $e745x = parcelRequire("e745x");


var $gyH45 = parcelRequire("gyH45");


var $eiI2k = parcelRequire("eiI2k");

class $8965173715796a09$export$6a5e825be2d43d52 {
    get isAttached() {
        return !!this.editorView;
    }
    attach(editorView) {
        const { state: { schema: schema } } = editorView;
        if (!schema.marks.fragment) throw new (0, $e745x.CompatibilityError)('fragmentMark not supported');
        this.editorView = editorView;
    }
    detach() {
        this.editorView = undefined;
    }
    setNodeFocusCallback(callback) {
        this.nodeFocusCallback = callback;
    }
    setNodeNameCallback(callback) {
        this.nodeNameCallback = callback;
    }
    setSelectedLocalId(localId) {
        if (this.selectedLocalId === localId) return;
        this.selectedLocalId = localId;
        if (!!this.nodeFocusCallback) {
            if (!localId) {
                this.nodeFocusCallback(undefined);
                return;
            }
            if (this.editorView) {
                const { state: state } = this.editorView;
                const foundNode = (0, $gyH45.findNodeByLocalId)(localId, state);
                if (foundNode) this.nodeFocusCallback((0, $gyH45.createLinkNode)(this.normalizeLocalId(localId, foundNode.fragmentMark?.attrs.localId), foundNode.fragmentMark?.attrs.name || '', foundNode.node));
            }
        }
    }
    initialiseFragmentMarks() {
        if (!this.editorView) throw new (0, $e745x.ConfigurationError)('initialiseFragmentMarks');
        (0, $hiQdW.startMeasure)((0, $gkua4.MEASURE_NAME).INITIALISE_FRAGMENT_MARKS);
        const { state: state, dispatch: dispatch } = this.editorView;
        let { tr: tr } = state;
        const docSize = state.doc.nodeSize;
        const context = new (0, $1qyJ5.ReferentialityContext)(this.editorView, this.normalizeLocalId, false);
        let count = 0;
        const maxNumberUsedInFragmentMarkNames = context.getMaxNumberUsedInFragmentMarkNames();
        for (const target of context.namelessOnlyConnections()){
            const { markNameWithNumber: markNameWithNumber, markName: markName, markNameNumber: markNameNumber } = (0, $gyH45.generateMarkNameWithNumber)(target.node, state.schema, maxNumberUsedInFragmentMarkNames, this.nodeNameCallback);
            maxNumberUsedInFragmentMarkNames[markName] = markNameNumber;
            tr = (0, $gyH45.updateFragmentName)(state.schema, target, markNameWithNumber)(tr);
            count++;
        }
        tr.setMeta('addToHistory', false);
        (0, $hiQdW.stopMeasure)((0, $gkua4.MEASURE_NAME).INITIALISE_FRAGMENT_MARKS, (0, $eiI2k.captureInitialiseFragmentMarksEvent)({
            docSize: docSize,
            count: count,
            tr: tr,
            editorAnalyticsAPI: this.editorAnalyticsAPI
        }));
        dispatch(tr);
    }
    getConnections() {
        (0, $hiQdW.startMeasure)((0, $gkua4.MEASURE_NAME).GET_CONNECTIONS);
        const result = {};
        if (!this.editorView) {
            (0, $hiQdW.stopMeasure)((0, $gkua4.MEASURE_NAME).GET_CONNECTIONS);
            return result;
        }
        const { state: { tr: tr, doc: { nodeSize: nodeSize } } } = this.editorView;
        const context = new (0, $1qyJ5.ReferentialityContext)(this.editorView, this.normalizeLocalId);
        // First initialize all possible connection linkages
        for (const { node: node, normalizedId: normalizedId, name: name } of context.uniqueConnections())result[normalizedId] = (0, $gyH45.createConnectionLink)(node, normalizedId, name);
        // This 2nd-pass only looks at the consumer sources and updates all connections with the correct id refs.
        for (const { normalizedId: normalizedId, dataConsumer: dataConsumer } of context.consumerOnlyConnections()){
            // This is a ref to the node (connection link) which contains the consumer.
            const currentNodeLink = result[normalizedId];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            dataConsumer.attrs.sources.forEach((src)=>{
                const normalizedSrcId = context.getById(src)?.normalizedId ?? src;
                const srcLink = result[normalizedSrcId];
                if (srcLink && normalizedSrcId !== normalizedId) {
                    srcLink.targets.push(normalizedId);
                    currentNodeLink?.sources.push(normalizedSrcId);
                }
            });
        }
        (0, $hiQdW.stopMeasure)((0, $gkua4.MEASURE_NAME).GET_CONNECTIONS, (0, $eiI2k.captureGetConnectionsEvent)({
            tr: tr,
            editorAnalyticsAPI: this.editorAnalyticsAPI,
            docSize: nodeSize,
            count: Object.keys(result).length
        }));
        return result;
    }
    select(localId, scroll = false) {
        if (!this.editorView || !localId) throw new (0, $e745x.ConfigurationError)('select');
        const { state: state, dispatch: dispatch } = this.editorView;
        const foundNode = (0, $gyH45.findNodeByLocalId)(localId, state);
        if (foundNode) {
            const { tr: tr } = state;
            tr.setSelection((0, $kCECX.NodeSelection).create(state.doc, foundNode.pos));
            if (scroll) tr.scrollIntoView();
            tr.setMeta('addToHistory', false);
            dispatch(tr);
        }
    }
    updateName(localId, name) {
        try {
            (0, $hiQdW.startMeasure)((0, $gkua4.MEASURE_NAME).UPDATE_FRAGMENT_MARK_NAME);
            if (!this.isAttached || !this.editorView) throw new (0, $e745x.ConfigurationError)('updateName');
            const { state: state, state: { schema: schema }, dispatch: dispatch } = this.editorView;
            const foundNode = (0, $gyH45.findNodeByLocalId)(localId, state);
            if (!foundNode) throw new (0, $e745x.NodeNotFoundError)(localId);
            const { fragment: fragment } = schema.marks;
            const { fragmentMark: fragmentMark, node: node, pos: pos } = foundNode;
            const fragLocalId = fragmentMark?.attrs.localId ?? (0, $2nOF5.uuid).generate();
            const nextFragmentMark = fragment.create({
                localId: fragLocalId,
                name: name
            });
            const nextMarks = fragmentMark ? node.marks.filter((mark)=>mark.type !== nextFragmentMark.type) : node.marks.concat();
            nextMarks.push(nextFragmentMark);
            // ensure the fragment mark on the node has the correct id & name.
            const tr = state.tr.setNodeMarkup(pos, undefined, node.attrs, nextMarks);
            dispatch(tr);
            const linkNode = (0, $gyH45.createLinkNode)(this.normalizeLocalId(node.attrs.localId, fragLocalId), name, node);
            (0, $hiQdW.stopMeasure)((0, $gkua4.MEASURE_NAME).UPDATE_FRAGMENT_MARK_NAME, (0, $eiI2k.captureUpdateFragmentMarkNameEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                nodeType: node.type.name
            }));
            return linkNode;
        } catch (e) {
            (0, $hiQdW.stopMeasure)((0, $gkua4.MEASURE_NAME).UPDATE_FRAGMENT_MARK_NAME);
            throw e;
        }
    }
    getADFFromLocalId(localId) {
        if (!this.isAttached || !this.editorView) throw new (0, $e745x.ConfigurationError)('getADFFromLocalId');
        const { state: state } = this.editorView;
        const foundNode = (0, $gyH45.findNodeByLocalId)(localId, state);
        if (!foundNode) throw new (0, $e745x.NodeNotFoundError)(localId);
        return new (0, $3xuv0.JSONTransformer)().encodeNode(foundNode.node);
    }
    connectSource(targetLocalId, sourceLocalId) {
        try {
            (0, $hiQdW.startMeasure)((0, $gkua4.MEASURE_NAME).CONNECT_NODES);
            if (!this.editorView) throw new (0, $e745x.ConfigurationError)('connectSource');
            const { dispatch: dispatch, state: state } = this.editorView;
            const docSize = state.doc.nodeSize;
            const context = new (0, $1qyJ5.ReferentialityContext)(this.editorView, this.normalizeLocalId);
            const { source: source, target: target, tr: tr } = (0, $gyH45.connectNodes)(context, targetLocalId, sourceLocalId, state.tr);
            dispatch(tr);
            (0, $hiQdW.stopMeasure)((0, $gkua4.MEASURE_NAME).CONNECT_NODES, (0, $eiI2k.captureConnectNodesEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                actionType: 'connectSource',
                type: 'connect',
                sourceNodeType: source.node.type,
                targetNodeType: target.node.type
            }));
            return source;
        } catch (e) {
            (0, $hiQdW.stopMeasure)((0, $gkua4.MEASURE_NAME).CONNECT_NODES);
            throw e;
        }
    }
    connectTarget(sourceLocalId, targetLocalId) {
        try {
            (0, $hiQdW.startMeasure)((0, $gkua4.MEASURE_NAME).CONNECT_NODES);
            if (!this.editorView) throw new (0, $e745x.ConfigurationError)('connectTarget');
            const { dispatch: dispatch, state: state } = this.editorView;
            const docSize = state.doc.nodeSize;
            const context = new (0, $1qyJ5.ReferentialityContext)(this.editorView, this.normalizeLocalId);
            const { source: source, target: target, tr: tr } = (0, $gyH45.connectNodes)(context, targetLocalId, sourceLocalId, state.tr);
            dispatch(tr);
            (0, $hiQdW.stopMeasure)((0, $gkua4.MEASURE_NAME).CONNECT_NODES, (0, $eiI2k.captureConnectNodesEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                actionType: 'connectTarget',
                type: 'connect',
                sourceNodeType: source.node.type,
                targetNodeType: target.node.type
            }));
            return target;
        } catch (e) {
            (0, $hiQdW.stopMeasure)((0, $gkua4.MEASURE_NAME).CONNECT_NODES);
            throw e;
        }
    }
    updateTarget(sourceLocalId, oldTargetLocalId, newTargetLocalId) {
        try {
            (0, $hiQdW.startMeasure)((0, $gkua4.MEASURE_NAME).UPDATE_TARGET);
            if (!this.editorView) throw new (0, $e745x.ConfigurationError)('updateTarget');
            const { dispatch: dispatch, state: state } = this.editorView;
            const docSize = state.doc.nodeSize;
            const context = new (0, $1qyJ5.ReferentialityContext)(this.editorView, this.normalizeLocalId);
            const { target: target, source: source, tr: tr } = (0, $gyH45.connectNodes)(context, newTargetLocalId, sourceLocalId, (0, $gyH45.disconnectNodes)(context, oldTargetLocalId, sourceLocalId, state.tr));
            dispatch(tr);
            (0, $hiQdW.stopMeasure)((0, $gkua4.MEASURE_NAME).UPDATE_TARGET, (0, $eiI2k.captureUpdateTargetEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                newTargetNodeType: target.node.type,
                oldTargetNodeType: context.getById(oldTargetLocalId)?.node.type.name || '',
                sourceNodeType: source.node.type,
                type: 'update'
            }));
            return target;
        } catch (e) {
            (0, $hiQdW.stopMeasure)((0, $gkua4.MEASURE_NAME).UPDATE_TARGET);
            throw e;
        }
    }
    updateSource(targetLocalId, newSourceLocalId) {
        try {
            (0, $hiQdW.startMeasure)((0, $gkua4.MEASURE_NAME).UPDATE_SOURCE);
            if (!this.editorView) throw new (0, $e745x.ConfigurationError)('updateSource');
            const { dispatch: dispatch, state: state } = this.editorView;
            const docSize = state.doc.nodeSize;
            const context = new (0, $1qyJ5.ReferentialityContext)(this.editorView, this.normalizeLocalId);
            const { target: target, source: source, tr: tr } = (0, $gyH45.resetNodes)(context, targetLocalId, newSourceLocalId, state.tr);
            dispatch(tr);
            (0, $hiQdW.stopMeasure)((0, $gkua4.MEASURE_NAME).UPDATE_SOURCE, (0, $eiI2k.captureUpdateSourceEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                oldSourceNodeType: target.node.type,
                newSourceNodeType: source.node.type,
                type: 'update'
            }));
            return source;
        } catch (e) {
            (0, $hiQdW.stopMeasure)((0, $gkua4.MEASURE_NAME).UPDATE_SOURCE);
            throw e;
        }
    }
    disconnectTarget(sourceLocalId, targetLocalId) {
        try {
            (0, $hiQdW.startMeasure)((0, $gkua4.MEASURE_NAME).DISCONNECT_TARGET);
            if (!this.editorView) throw new (0, $e745x.ConfigurationError)('disconnectTarget');
            const { dispatch: dispatch, state: state } = this.editorView;
            const docSize = state.doc.nodeSize;
            const context = new (0, $1qyJ5.ReferentialityContext)(this.editorView, this.normalizeLocalId);
            const tr = (0, $gyH45.disconnectNodes)(context, targetLocalId, sourceLocalId, state.tr);
            dispatch(tr);
            (0, $hiQdW.stopMeasure)((0, $gkua4.MEASURE_NAME).DISCONNECT_TARGET, (0, $eiI2k.captureDisconnectTargetEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                sourceNodeType: context.getById(sourceLocalId)?.node.type.name || '',
                targetNodeType: context.getById(targetLocalId)?.node.type.name || ''
            }));
        } catch (e) {
            (0, $hiQdW.stopMeasure)((0, $gkua4.MEASURE_NAME).DISCONNECT_TARGET);
            throw e;
        }
    }
    disconnectSource(targetLocalId) {
        try {
            (0, $hiQdW.startMeasure)((0, $gkua4.MEASURE_NAME).DISCONNECT_SOURCE);
            if (!this.editorView) throw new (0, $e745x.ConfigurationError)('disconnectSource');
            const { dispatch: dispatch, state: state } = this.editorView;
            const docSize = state.doc.nodeSize;
            const target = (0, $gyH45.findNodeByLocalId)(targetLocalId, state);
            if (!target) throw new (0, $e745x.TargetReferenceError)(targetLocalId);
            const tr = (0, $gyH45.updateNodeSources)(state.schema, target.node, target.pos)(state.tr);
            dispatch(tr);
            (0, $hiQdW.stopMeasure)((0, $gkua4.MEASURE_NAME).DISCONNECT_SOURCE, (0, $eiI2k.captureDisconnectSourceEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                targetNodeType: target.node.type.name
            }));
        } catch (e) {
            (0, $hiQdW.stopMeasure)((0, $gkua4.MEASURE_NAME).DISCONNECT_SOURCE);
            throw e;
        }
    }
    insertAndConnectTarget(sourceLocalId, target) {
        try {
            (0, $hiQdW.startMeasure)((0, $gkua4.MEASURE_NAME).CONNECT_NODES);
            if (!this.editorView) throw new (0, $e745x.ConfigurationError)('insertAndConnectTarget');
            const { dispatch: dispatch, state: state } = this.editorView;
            const context = new (0, $1qyJ5.ReferentialityContext)(this.editorView, this.normalizeLocalId);
            const { linkNode: linkNode, tr: tr } = (0, $gyH45.insertTarget)(context, sourceLocalId, target, state.tr, this.nodeNameCallback);
            dispatch(tr);
            const docSize = tr.doc.nodeSize;
            (0, $hiQdW.stopMeasure)((0, $gkua4.MEASURE_NAME).CONNECT_NODES, (0, $eiI2k.captureConnectNodesEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                actionType: 'connectTarget',
                type: 'insertAndConnect',
                sourceNodeType: context.getById(sourceLocalId)?.node.type.name || '',
                targetNodeType: target.type
            }));
            return linkNode;
        } catch (e) {
            (0, $hiQdW.stopMeasure)((0, $gkua4.MEASURE_NAME).CONNECT_NODES);
            throw e;
        }
    }
    insertAndConnectSource(targetLocalId, source) {
        try {
            (0, $hiQdW.stopMeasure)((0, $gkua4.MEASURE_NAME).CONNECT_NODES);
            if (!this.editorView) throw new (0, $e745x.ConfigurationError)('insertAndConnectSource');
            const { state: state, state: { schema: schema }, dispatch: dispatch } = this.editorView;
            const nodeType = schema.nodes[source.type];
            if (!(0, $gyH45.getNodesSupportingFragmentMark)(schema).has(nodeType)) throw new (0, $e745x.UnsupportedTypeError)(source.type);
            const context = new (0, $1qyJ5.ReferentialityContext)(this.editorView, this.normalizeLocalId);
            const target = context.getById(targetLocalId);
            if (!target) throw new (0, $e745x.TargetReferenceError)(targetLocalId);
            const { linkNode: linkNode, node: node } = (0, $gyH45.createLinkElementNode)(context, source, this.nodeNameCallback);
            let tr = state.tr;
            const targetSources = (0, $gyH45.normalizeIds)(context, target.dataConsumer?.attrs.sources).add(linkNode.localId);
            tr = (0, $gyH45.updateSources)(schema, target, targetSources)(tr);
            tr = (0, $gyH45.insertNodeAfter)(targetLocalId, node, state, tr);
            tr = tr.setMeta('referentialityTableInserted', node.type.name === schema.nodes.table.name);
            dispatch(tr);
            const docSize = tr.doc.nodeSize;
            (0, $hiQdW.stopMeasure)((0, $gkua4.MEASURE_NAME).CONNECT_NODES, (0, $eiI2k.captureConnectNodesEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                actionType: 'connectSource',
                type: 'insertAndConnect',
                sourceNodeType: node.type.name,
                targetNodeType: context.getById(targetLocalId)?.node.type.name || ''
            }));
            return linkNode;
        } catch (e) {
            (0, $hiQdW.stopMeasure)((0, $gkua4.MEASURE_NAME).CONNECT_NODES);
            throw e;
        }
    }
    replaceAndUpdateTarget(sourceLocalId, oldTargetLocalId, newTarget) {
        try {
            (0, $hiQdW.stopMeasure)((0, $gkua4.MEASURE_NAME).UPDATE_TARGET);
            if (!this.editorView) throw new (0, $e745x.ConfigurationError)('replaceAndUpdateTarget');
            const { dispatch: dispatch, state: state } = this.editorView;
            const context = new (0, $1qyJ5.ReferentialityContext)(this.editorView, this.normalizeLocalId);
            const { linkNode: linkNode, tr: tr } = (0, $gyH45.insertTarget)(context, sourceLocalId, newTarget, state.tr, this.nodeNameCallback, oldTargetLocalId);
            dispatch(tr);
            const docSize = tr.doc.nodeSize;
            (0, $hiQdW.stopMeasure)((0, $gkua4.MEASURE_NAME).UPDATE_TARGET, (0, $eiI2k.captureUpdateTargetEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                type: 'replaceAndUpdate',
                newTargetNodeType: newTarget.type,
                oldTargetNodeType: context.getById(oldTargetLocalId)?.node.type.name || '',
                sourceNodeType: context.getById(sourceLocalId)?.node.type.name || ''
            }));
            return linkNode;
        } catch (e) {
            (0, $hiQdW.stopMeasure)((0, $gkua4.MEASURE_NAME).UPDATE_TARGET);
            throw e;
        }
    }
    replaceAndUpdateSource(targetLocalId, newSource) {
        try {
            (0, $hiQdW.startMeasure)((0, $gkua4.MEASURE_NAME).UPDATE_SOURCE);
            if (!this.editorView) throw new (0, $e745x.ConfigurationError)('replaceAndUpdateSource');
            const { state: { schema: schema }, state: state, dispatch: dispatch } = this.editorView;
            const nodeType = schema.nodes[newSource.type];
            if (!(0, $gyH45.getNodesSupportingFragmentMark)(schema).has(nodeType)) throw new (0, $e745x.UnsupportedTypeError)(newSource.type);
            const context = new (0, $1qyJ5.ReferentialityContext)(this.editorView, this.normalizeLocalId);
            const target = context.getById(targetLocalId);
            if (!target) throw new (0, $e745x.TargetReferenceError)(targetLocalId);
            const { linkNode: linkNode, node: node } = (0, $gyH45.createLinkElementNode)(context, newSource, this.nodeNameCallback);
            let tr = (0, $gyH45.updateSources)(context.schema, target, new Set([
                linkNode.localId
            ]))(state.tr);
            tr = (0, $gyH45.insertNodeAfter)(targetLocalId, node, state, tr);
            tr = tr.setMeta('referentialityTableInserted', node.type.name === schema.nodes.table.name);
            dispatch(tr);
            const docSize = tr.doc.nodeSize;
            (0, $hiQdW.stopMeasure)((0, $gkua4.MEASURE_NAME).UPDATE_SOURCE, (0, $eiI2k.captureUpdateSourceEvent)({
                tr: tr,
                editorAnalyticsAPI: this.editorAnalyticsAPI,
                docSize: docSize,
                oldSourceNodeType: target.node.type.name,
                newSourceNodeType: newSource.type,
                type: 'replaceAndUpdate'
            }));
            return linkNode;
        } catch (e) {
            (0, $hiQdW.stopMeasure)((0, $gkua4.MEASURE_NAME).UPDATE_SOURCE);
            throw e;
        }
    }
    /**
   * @constructor
   */ constructor({ nodeNameCallback: nodeNameCallback, nodeFocusCallback: // you can also set this callback using setNodeNameCallback method
    nodeFocusCallback, editorAnalyticsAPI: // you can also set this callback using setNodeFocusCallback method
    editorAnalyticsAPI, editorView: editorView, featureFlags: featureFlags } = {}){
        this.nodeNameCallback = void 0;
        this.nodeFocusCallback = void 0;
        this.normalizeLocalId = void 0;
        this.editorAnalyticsAPI = void 0;
        this.editorView = void 0;
        this.selectedLocalId = void 0;
        this.nodeNameCallback = nodeNameCallback;
        this.nodeFocusCallback = nodeFocusCallback;
        this.editorAnalyticsAPI = editorAnalyticsAPI;
        this.editorView = editorView;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.normalizeLocalId = (attrsLocalId, fragmentLocalId)=>fragmentLocalId ?? attrsLocalId;
    }
}
module.exports["ReferentialityAPIImpl"] = $8965173715796a09$export$6a5e825be2d43d52;

});

parcelRegister("1qyJ5", function(module, exports) {

var $gyH45 = parcelRequire("gyH45");

class $219a81cbb382f036$export$3e2fc71d3c4adf01 {
    /**
   * Convenience helper to get the EditorState
   */ get state() {
        return this.view.state;
    }
    /**
   * Convenience helper to get the Schema
   */ get schema() {
        return this.view.state.schema;
    }
    getById(localId) {
        return this.connections.get(localId);
    }
    hasId(localId) {
        return this.connections.has(localId);
    }
    getMaxNumberUsedInFragmentMarkNames() {
        return {
            ...this.maxNumberUsedInFragmentMarkName
        };
    }
    getMaxNumberUsedInFragmentMarkName(name) {
        return this.maxNumberUsedInFragmentMarkName[name] ?? 0;
    }
    updateMaxNumberUsedInFragmentMarkNames(name, value) {
        this.maxNumberUsedInFragmentMarkName[name] = value;
    }
    *uniqueConnections() {
        for (const id of this.uniqueNormalizedIds){
            const connection = this.connections.get(id);
            if (connection) yield connection;
        }
    }
    /**
   * This generator will only return connections which contain DataConsumer sources.
   */ *consumerOnlyConnections() {
        for (const id of this.uniqueNormalizedIds){
            const connection = this.connections.get(id);
            if (connection && !!connection.dataConsumer?.attrs.sources.length) yield connection;
        }
    }
    /**
   * This generator will only return connections which are sources
   */ *sourceOnlyConnections() {
        for (const id of this.uniqueSourceNormalizedIds){
            const connection = this.connections.get(id);
            if (connection) yield connection;
        }
    }
    /**
   * This generator will return connections which do not contain a name or fragment
   */ *namelessOnlyConnections() {
        for (const id of this.namelessNormalizedIds){
            const connection = this.connections.get(id);
            if (connection) yield connection;
        }
    }
    /**
   * @constructor
   * @param view
   * @param shallow A flag to help identify the depth of scan required. This default to true. A Shallow context assumes
   * that nodes with data consumers cannot contain descendants with fragmentMarks or dataConsumers
   */ constructor(view, normalizeLocalId, shallow = true){
        this.view = view;
        this.normalizeLocalId = normalizeLocalId;
        this.shallow = shallow;
        /**
     * This record is used to keep track of the max number in each fragment name.
     */ this.maxNumberUsedInFragmentMarkName = {};
        /**
     * This map enables quick lookup of all unnormalized connections
     */ this.connections = new Map();
        /**
     * This is a unique set containing only normalized localIds
     */ this.uniqueNormalizedIds = new Set();
        /**
     * This is a unique set containing only normalized localIds
     */ this.uniqueSourceNormalizedIds = new Set();
        /**
     * This is a unique set of normalized localIds which are nameless
     */ this.namelessNormalizedIds = new Set();
        const { doc: doc, schema: schema } = this.view.state;
        const { fragment: fragment, dataConsumer: dataConsumer } = schema.marks;
        const nodesSupportingFragmentMark = (0, $gyH45.getNodesSupportingFragmentMark)(schema);
        const sourceToTargetMappings = new Map();
        doc.descendants((node, pos, parent)=>{
            if (!nodesSupportingFragmentMark.has(node.type)) return true;
            const fragmentMark = fragment.isInSet(node.marks);
            // If node cannot be referenced by any means then abort.
            if (!fragmentMark && !node.attrs?.localId) return true;
            const normalizedId = this.normalizeLocalId(node.attrs?.localId, fragmentMark?.attrs?.localId);
            if (!normalizedId || this.connections.has(normalizedId)) return true;
            let decodedName;
            if (!!fragmentMark?.attrs.name) {
                decodedName = (0, $gyH45.decodeName)(fragmentMark.attrs.name);
                if (decodedName) {
                    const currentMax = this.maxNumberUsedInFragmentMarkName[decodedName.defaultName];
                    if (currentMax === undefined || currentMax < decodedName.defaultNameNumber) this.maxNumberUsedInFragmentMarkName[decodedName.defaultName] = decodedName.defaultNameNumber;
                }
            } else this.namelessNormalizedIds.add(normalizedId);
            const consumer = dataConsumer.isInSet(node.marks);
            const ref = {
                node: node,
                pos: pos,
                parent: parent,
                normalizedId: normalizedId,
                name: fragmentMark?.attrs?.name ?? normalizedId,
                ids: new Set(),
                targets: new Set(),
                fragmentMark: fragmentMark,
                dataConsumer: consumer,
                decodedName: decodedName
            };
            if (!!fragmentMark?.attrs?.localId) {
                ref.ids.add(fragmentMark.attrs.localId);
                this.connections.set(fragmentMark.attrs.localId, ref);
            }
            if (!!node.attrs?.localId) {
                ref.ids.add(node.attrs.localId);
                this.connections.set(node.attrs.localId, ref);
            }
            this.uniqueNormalizedIds.add(normalizedId);
            if (consumer) // A lookup map of srcId -> targetId[]. This enables quickly finding all nodes
            // which consume a specific source.
            consumer.attrs.sources.forEach((src)=>sourceToTargetMappings.set(src, sourceToTargetMappings.get(src)?.add(normalizedId) ?? new Set([
                    normalizedId
                ])));
            // Do not descend into children of a node which has a dataConsumer attached. This assumes all children of the node cannot
            // be referenced by another node. Unless of course this is not a shallow context.
            // if consumer: true & shallow: true -> return false // don't descend
            // if consumer: false & shallow: true -> return true // descend
            // if consumer: true & shallow: false -> return true // descend
            // if consumer: false & shallow: false -> return true // descend
            return !(shallow && consumer);
        });
        // This 2nd-pass is used to normalize all the source ids. We need to have full context before we're able to do this.
        for (const [source, targets] of sourceToTargetMappings){
            const connection = this.connections.get(source);
            if (connection) {
                this.uniqueSourceNormalizedIds.add(connection.normalizedId);
                connection.targets = new Set([
                    ...connection.targets,
                    ...targets
                ]);
            }
        }
    }
}
module.exports["ReferentialityContext"] = $219a81cbb382f036$export$3e2fc71d3c4adf01;

});

parcelRegister("gyH45", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");


var $2nOF5 = parcelRequire("2nOF5");


var $3xuv0 = parcelRequire("3xuv0");


var $bjg0G = parcelRequire("bjg0G");


var $e745x = parcelRequire("e745x");

const $f4c8b854671ecade$export$8174b2693cae81eb = (schema)=>{
    const { table: table, extension: extension, bodiedExtension: bodiedExtension, inlineExtension: inlineExtension } = schema.nodes;
    return [
        table,
        extension,
        bodiedExtension,
        inlineExtension
    ];
};
const $f4c8b854671ecade$export$3fdc75161fb8ee49 = (schema)=>{
    const { table: table, extension: extension, bodiedExtension: bodiedExtension, inlineExtension: inlineExtension } = schema.nodes;
    return new Map([
        [
            table,
            'Table'
        ],
        [
            extension,
            'Extension'
        ],
        [
            bodiedExtension,
            'Extension'
        ],
        [
            inlineExtension,
            'Extension'
        ]
    ]);
};
const $f4c8b854671ecade$export$549d0eefc6fd05c0 = (schema)=>{
    const { extension: extension, bodiedExtension: bodiedExtension, inlineExtension: inlineExtension } = schema.nodes;
    return new Set([
        extension,
        bodiedExtension,
        inlineExtension
    ].filter(Boolean));
};
const $f4c8b854671ecade$export$54a3e405bb0d0a4a = (node, id, name)=>({
        linkNode: {
            localId: id,
            name: name ?? id,
            node: {
                type: node.type.name,
                attrs: {
                    ...node.attrs
                }
            }
        },
        sources: [],
        targets: []
    });
const $f4c8b854671ecade$export$368b1080eb192086 = (name)=>{
    const splitName = name.split(' '); // ['Awesome', 'list', '2.0', '5']
    if (splitName.length < 2) return null;
    const lastNumberInName = Number(splitName[splitName.length - 1]);
    if (typeof lastNumberInName !== 'number') return null;
    const nameWithoutLastNumber = splitName.slice(0, splitName.length - 1) // ['Awesome', 'list', '2.0']
    .join(' '); // 'Awesome list 2.0'
    return {
        defaultName: nameWithoutLastNumber,
        defaultNameNumber: lastNumberInName
    };
};
const $f4c8b854671ecade$export$8a9a3ce4139f59c3 = ({ type: type, attrs: attrs }, schema, fragmentMarkNameLastNumbers, nodeNameCallback)=>{
    const nodesSupportingFragmentMark = $f4c8b854671ecade$export$3fdc75161fb8ee49(schema);
    const nodesSupportingNameCallback = $f4c8b854671ecade$export$549d0eefc6fd05c0(schema);
    let markName = '';
    if (nodesSupportingNameCallback.has(type)) {
        if (nodeNameCallback) markName = nodeNameCallback({
            node: {
                type: type.name,
                attrs: attrs
            }
        });
    }
    if (!markName) markName = nodesSupportingFragmentMark.get(type) ?? 'Element';
    const markNameNumber = (fragmentMarkNameLastNumbers?.[markName] ?? 0) + 1;
    return {
        markNameWithNumber: `${markName} ${markNameNumber}`,
        markName: markName,
        markNameNumber: markNameNumber
    };
};
const $f4c8b854671ecade$export$7503e197531554a8 = ({ normalizedId: normalizedId, name: name, node: node })=>$f4c8b854671ecade$export$dbdf2d08277c626e(normalizedId, name, node);
const $f4c8b854671ecade$export$dbdf2d08277c626e = (localId, name, node)=>{
    const jsonNode = new (0, $3xuv0.JSONTransformer)().encodeNode(node);
    return {
        localId: localId,
        name: name,
        node: {
            type: jsonNode.type,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            attrs: jsonNode.attrs
        }
    };
};
const $f4c8b854671ecade$export$c85fa7574bd3ee0b = (context, target, source)=>{
    if (target.normalizedId === source.normalizedId) return true;
    // Try and get a consumer from the source, this is because we don't care about the initial link between target -> source
    // we only care if somewhere down the chain after the source; is there a link back to this target.
    return !!source.dataConsumer?.attrs.sources.some((src)=>{
        const nextSrc = context.getById(src);
        return !!nextSrc && $f4c8b854671ecade$export$c85fa7574bd3ee0b(context, target, nextSrc);
    });
};
const $f4c8b854671ecade$export$b25165d24a0db921 = (state, localId)=>{
    let found = false;
    const { doc: doc, schema: schema } = state;
    const { fragment: fragment } = schema.marks;
    const nodesSupportingFragmentMark = $f4c8b854671ecade$export$3fdc75161fb8ee49(schema);
    // TODO: ED-26962 - Update scanning method to abort the scan immediately once a node has been found.
    doc.descendants((node)=>{
        if (found) return false;
        if (!nodesSupportingFragmentMark.has(node.type)) return true;
        if (node.attrs?.localId === localId) {
            found = true;
            return false;
        }
        const fragmentMark = fragment.isInSet(node.marks);
        // If node cannot be referenced by any means then abort.
        if (!fragmentMark) return true;
        if (fragmentMark?.attrs?.localId === localId) found = true;
        return !found;
    });
    return found;
};
const $f4c8b854671ecade$export$aadcc3ba2430b = (localId, state)=>{
    const { doc: doc, schema: schema } = state;
    const fragment = schema.marks.fragment;
    const nodesSupportingFragmentMark = $f4c8b854671ecade$export$3fdc75161fb8ee49(schema);
    let foundNode = null;
    doc.descendants((node, pos)=>{
        if (foundNode) return false;
        if (!nodesSupportingFragmentMark.has(node.type)) return true;
        const existingFragmentMark = fragment.isInSet(node.marks) ?? null;
        if (existingFragmentMark && existingFragmentMark.attrs.localId === localId) {
            foundNode = {
                node: node,
                pos: pos,
                fragmentMark: existingFragmentMark
            };
            return false;
        }
        if (node.attrs.localId === localId) {
            foundNode = {
                node: node,
                pos: pos,
                fragmentMark: existingFragmentMark
            };
            return false;
        }
        return true;
    });
    return foundNode;
};
const $f4c8b854671ecade$export$ebf688cb60f59a94 = (schema, localId, name, sources)=>{
    const { fragment: fragment, dataConsumer: dataConsumer } = schema.marks;
    return [
        fragment.create({
            localId: localId,
            name: name
        }),
        sources && dataConsumer.create({
            sources: Array.from(sources) ?? []
        })
    ].filter(Boolean);
};
const $f4c8b854671ecade$export$270e7ba5936d3c48 = (schema, type, attrs, marks)=>{
    const { table: table } = schema.nodes;
    const createNodeContent = type === table ? $f4c8b854671ecade$export$d142f815ac656d : $f4c8b854671ecade$export$85ceaeb5400c34da;
    return type.createChecked({
        ...attrs,
        localId: (0, $2nOF5.uuid).generate()
    }, createNodeContent(schema, type), marks);
};
const $f4c8b854671ecade$export$d142f815ac656d = (schema, type)=>{
    const { tableCell: tableCell, tableHeader: tableHeader, tableRow: tableRow } = schema.nodes;
    const cells = [];
    const headerCells = [];
    for(let i = 0; i < 3; i++){
        const cell = tableCell.createAndFill();
        if (cell) cells.push(cell);
        const headerCell = tableHeader.createAndFill();
        if (headerCell) headerCells.push(headerCell);
    }
    const rows = [];
    for(let i = 0; i < 3; i++)rows.push(tableRow.createChecked(null, i === 0 ? headerCells : cells));
    return rows;
};
const $f4c8b854671ecade$export$85ceaeb5400c34da = (schema, type)=>{
    const { bodiedExtension: bodiedExtension, paragraph: paragraph } = schema.nodes;
    if (type === bodiedExtension) return [
        paragraph.createChecked()
    ];
    return (0, $aPdNQ.Fragment).empty;
};
const $f4c8b854671ecade$export$9c63b8d16fa708c5 = (localId, node, state, tr, options)=>{
    tr = tr ?? state.tr;
    const nodePos = $f4c8b854671ecade$export$aadcc3ba2430b(localId, state);
    const insertPosition = nodePos ? nodePos.pos + nodePos.node.nodeSize : undefined;
    tr = (0, $bjg0G.safeInsert)(node, insertPosition)(tr);
    return tr;
};
const $f4c8b854671ecade$export$4c47e28146a39728 = (context, ids)=>{
    return ids?.reduce((idSet, id)=>{
        const ns = context.getById(id)?.normalizedId;
        // filters out undefined, null or empty items
        return !!ns ? idSet.add(ns) : idSet;
    }, new Set()) ?? new Set();
};
const $f4c8b854671ecade$export$6c4da287bd77d75c = (schema, target, sources)=>(tr)=>$f4c8b854671ecade$export$884cb393b34cee0d(schema, target.node, target.pos, sources, target.dataConsumer)(tr);
const $f4c8b854671ecade$export$884cb393b34cee0d = (schema, node, pos, sources, consumer)=>(tr)=>{
        const { dataConsumer: dataConsumer } = schema.marks;
        const currentSources = (consumer ?? dataConsumer.isInSet(node.marks))?.attrs.sources;
        // Quick Check: No point in updating node markup if nothing is changing.
        if (!sources?.size && !currentSources?.length) return tr;
        // This attempts to check deep equality. If the sizes are not the same or a source is different to what's being set; then
        // we want to perform the markup change, otherwise we should avoid unnecessary transactions.
        if (sources?.size === currentSources?.length && currentSources.every((src)=>sources.has(src))) return tr;
        const marks = (dataConsumer?.removeFromSet(node.marks) ?? node.marks).concat();
        if (!!sources?.size) marks.push(dataConsumer.create({
            sources: Array.from(sources)
        }));
        // If the old target sources is now 0 then the data consumer will be removed from the marks. Otherwise a new
        // consumer with updated sources will be injected.
        tr.setNodeMarkup(pos, undefined, node.attrs, marks);
        return tr;
    };
const $f4c8b854671ecade$export$c4bf0d625842a200 = (schema, target, name)=>(tr)=>{
        const { fragment: fragment } = schema.marks;
        // Quick Check: No point in updating node markup if nothing is changing.
        if (name === target.fragmentMark?.attrs.name) return tr;
        const marks = (target.fragmentMark?.removeFromSet(target.node.marks) ?? target.node.marks).concat();
        marks.push(fragment.create({
            localId: target.fragmentMark?.attrs.localId ?? (0, $2nOF5.uuid).generate(),
            name: name
        }));
        return tr.setNodeMarkup(target.pos, undefined, target.node.attrs, marks);
    };
const $f4c8b854671ecade$export$599e2146ce482fc4 = (context, element, nodeNameCallback, sources)=>{
    const nodeType = context.schema.nodes[element.type];
    if (!$f4c8b854671ecade$export$3fdc75161fb8ee49(context.schema).has(nodeType)) throw new (0, $e745x.UnsupportedTypeError)(element.type);
    const newNodeUUID = (0, $2nOF5.uuid).generate();
    if (context.hasId(newNodeUUID)) // XXX: Assuming UUID is true this condition should never occur.
    // This is just a safety catch; to protect against lightning strikes.
    throw new (0, $e745x.LocalIdCollisionError)(newNodeUUID);
    let attrs;
    if (element.type !== 'table') attrs = element.attrs;
    const { markNameWithNumber: markNameWithNumber } = $f4c8b854671ecade$export$8a9a3ce4139f59c3({
        type: nodeType,
        attrs: attrs
    }, context.schema, context.getMaxNumberUsedInFragmentMarkNames(), nodeNameCallback);
    if (element.type === 'table') attrs = {
        width: 760
    };
    const node = $f4c8b854671ecade$export$270e7ba5936d3c48(context.schema, nodeType, attrs, $f4c8b854671ecade$export$ebf688cb60f59a94(context.schema, newNodeUUID, markNameWithNumber, sources));
    const { inlineExtension: inlineExtension, paragraph: paragraph } = context.schema.nodes;
    // The finalNode is a post-processed node which is eventually added to the document. This may not be the actual
    // element node this was told to create as some nodes may need to be wrapped by others to be safely added  to the document.
    const finalNode = nodeType === inlineExtension ? paragraph.create(undefined, [
        node
    ]) : node;
    return {
        linkNode: $f4c8b854671ecade$export$dbdf2d08277c626e(newNodeUUID, markNameWithNumber, node),
        node: finalNode
    };
};
const $f4c8b854671ecade$export$2e109011d5320d15 = (context, targetLocalId, sourceLocalId, tr)=>{
    const target = context.getById(targetLocalId);
    if (!target) throw new (0, $e745x.TargetReferenceError)(targetLocalId);
    const source = context.getById(sourceLocalId);
    if (!source) throw new (0, $e745x.SourceReferenceError)(sourceLocalId);
    if (target.normalizedId === source.normalizedId) throw new (0, $e745x.CyclicReferenceError)(targetLocalId, sourceLocalId);
    // If the current target dataConsumer already has the source linked.
    const hasDataConsumerSource = !!target.dataConsumer?.attrs.sources.some((src)=>source.ids.has(src));
    if (hasDataConsumerSource) // If the connection has already been made, avoid an unnecessary transaction
    return {
        target: $f4c8b854671ecade$export$7503e197531554a8(target),
        source: $f4c8b854671ecade$export$7503e197531554a8(source),
        tr: tr
    };
    else {
        if ($f4c8b854671ecade$export$c85fa7574bd3ee0b(context, target, source)) throw new (0, $e745x.CyclicReferenceError)(targetLocalId, sourceLocalId);
        const newSources = $f4c8b854671ecade$export$4c47e28146a39728(context, target.dataConsumer?.attrs.sources);
        // Add the source to the target.
        newSources.add(source.normalizedId);
        tr = $f4c8b854671ecade$export$6c4da287bd77d75c(context.schema, target, newSources)(tr);
    }
    return {
        target: $f4c8b854671ecade$export$7503e197531554a8(target),
        source: $f4c8b854671ecade$export$7503e197531554a8(source),
        tr: tr
    };
};
const $f4c8b854671ecade$export$dba1c2bae2f381b9 = (context, targetLocalId, sourceLocalId, tr)=>{
    const source = context.getById(sourceLocalId);
    if (!source) throw new (0, $e745x.SourceReferenceError)(sourceLocalId);
    const target = context.getById(targetLocalId);
    if (!target) throw new (0, $e745x.TargetReferenceError)(targetLocalId);
    const targetSources = $f4c8b854671ecade$export$4c47e28146a39728(context, target.dataConsumer?.attrs.sources);
    // Remove the source from the target (if any) and update the sources if the source was deleted.
    if (targetSources.delete(source.normalizedId)) return $f4c8b854671ecade$export$6c4da287bd77d75c(context.schema, target, targetSources)(tr);
    return tr;
};
const $f4c8b854671ecade$export$b0852c37ee3e7ea9 = (context, targetLocalId, sourceLocalId, tr)=>{
    const target = context.getById(targetLocalId);
    if (!target) throw new (0, $e745x.TargetReferenceError)(targetLocalId);
    const source = context.getById(sourceLocalId);
    if (!source) throw new (0, $e745x.SourceReferenceError)(sourceLocalId);
    if (target.normalizedId === source.normalizedId) throw new (0, $e745x.CyclicReferenceError)(targetLocalId, sourceLocalId);
    // If the current target dataConsumer already has the source linked.
    const hasDataConsumerSource = !!target.dataConsumer?.attrs.sources.every((src)=>source.ids.has(src));
    if (hasDataConsumerSource) // If the connection has already been made, avoid an unnecessary transaction
    return {
        target: $f4c8b854671ecade$export$7503e197531554a8(target),
        source: $f4c8b854671ecade$export$7503e197531554a8(source),
        tr: tr
    };
    else {
        if ($f4c8b854671ecade$export$c85fa7574bd3ee0b(context, target, source)) throw new (0, $e745x.CyclicReferenceError)(targetLocalId, sourceLocalId);
        tr = $f4c8b854671ecade$export$6c4da287bd77d75c(context.schema, target, new Set([
            source.normalizedId
        ]))(tr);
    }
    return {
        target: $f4c8b854671ecade$export$7503e197531554a8(target),
        source: $f4c8b854671ecade$export$7503e197531554a8(source),
        tr: tr
    };
};
const $f4c8b854671ecade$export$73aa87199f4a96f5 = (context, localId, tr)=>{
    const source = context.getById(localId);
    if (!source) throw new (0, $e745x.SourceReferenceError)(localId);
    source.targets.forEach((target)=>{
        tr = $f4c8b854671ecade$export$dba1c2bae2f381b9(context, target, localId, tr);
    });
    return tr;
};
const $f4c8b854671ecade$export$328b0edc9fda3a36 = (context, oldSourceLocalId, newSourceLocalId, tr)=>{
    // This needs to disconnect the old source from all targets. Then update each target with the new source
    const oldSource = context.getById(oldSourceLocalId);
    if (!oldSource) throw new (0, $e745x.SourceReferenceError)(oldSourceLocalId);
    const newSource = context.getById(newSourceLocalId);
    if (!newSource) throw new (0, $e745x.SourceReferenceError)(newSourceLocalId);
    // If the old/new source are referring to the same connection then we should avoid unnecessary transactions.
    if (oldSource === newSource) return {
        source: $f4c8b854671ecade$export$7503e197531554a8(newSource),
        tr: tr
    };
    // Before we do any disconnecting or updating we must ensure a couple things first;
    // 1. The old source targets exist
    // 2. Moving the old source target to the new source doesn't cause a cyclic ref.
    for (const targetId of oldSource.targets){
        const target = context.getById(targetId);
        if (!target) throw new (0, $e745x.TargetReferenceError)(targetId);
        if ($f4c8b854671ecade$export$c85fa7574bd3ee0b(context, target, newSource)) throw new (0, $e745x.CyclicReferenceError)(targetId, newSourceLocalId);
        const targetSources = $f4c8b854671ecade$export$4c47e28146a39728(context, target.dataConsumer?.attrs.sources);
        const deleted = targetSources.delete(oldSource.normalizedId);
        // If the target source doesn't have the new source then it will be added.
        const added = !targetSources.has(newSource.normalizedId);
        targetSources.add(newSource.normalizedId);
        if (deleted || added) tr = $f4c8b854671ecade$export$6c4da287bd77d75c(context.schema, target, targetSources)(tr);
    }
    return {
        source: $f4c8b854671ecade$export$7503e197531554a8(newSource),
        tr: tr
    };
};
const $f4c8b854671ecade$export$fb891e3743d8c30f = (context, sourceLocalId, target, tr, nodeNameCallback, oldTargetLocalId)=>{
    const nodeType = context.schema.nodes[target.type];
    if (!$f4c8b854671ecade$export$3fdc75161fb8ee49(context.schema).has(nodeType)) throw new (0, $e745x.UnsupportedTypeError)(target.type);
    if (!context.hasId(sourceLocalId)) throw new (0, $e745x.SourceReferenceError)(sourceLocalId);
    const { linkNode: linkNode, node: node } = $f4c8b854671ecade$export$599e2146ce482fc4(context, target, nodeNameCallback, [
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        context.getById(sourceLocalId).normalizedId
    ]);
    if (!!oldTargetLocalId) // If an old target id has been supplied then this insert action is
    // replacing and old connection, so we need to disconnect the
    // old connection, then insert the new node.
    tr = $f4c8b854671ecade$export$dba1c2bae2f381b9(context, oldTargetLocalId, sourceLocalId, tr);
    tr = $f4c8b854671ecade$export$9c63b8d16fa708c5(sourceLocalId, node, context.state, tr);
    tr = tr.setMeta('referentialityTableInserted', node.type.name === context.schema.nodes.table.name);
    return {
        linkNode: linkNode,
        tr: tr
    };
};
module.exports["getNodeTypesSupported"] = $f4c8b854671ecade$export$8174b2693cae81eb;
module.exports["getNodesSupportingFragmentMark"] = $f4c8b854671ecade$export$3fdc75161fb8ee49;
module.exports["createConnectionLink"] = $f4c8b854671ecade$export$54a3e405bb0d0a4a;
module.exports["decodeName"] = $f4c8b854671ecade$export$368b1080eb192086;
module.exports["generateMarkNameWithNumber"] = $f4c8b854671ecade$export$8a9a3ce4139f59c3;
module.exports["createLinkNode"] = $f4c8b854671ecade$export$dbdf2d08277c626e;
module.exports["findNodeByLocalId"] = $f4c8b854671ecade$export$aadcc3ba2430b;
module.exports["insertNodeAfter"] = $f4c8b854671ecade$export$9c63b8d16fa708c5;
module.exports["normalizeIds"] = $f4c8b854671ecade$export$4c47e28146a39728;
module.exports["updateSources"] = $f4c8b854671ecade$export$6c4da287bd77d75c;
module.exports["updateNodeSources"] = $f4c8b854671ecade$export$884cb393b34cee0d;
module.exports["updateFragmentName"] = $f4c8b854671ecade$export$c4bf0d625842a200;
module.exports["createLinkElementNode"] = $f4c8b854671ecade$export$599e2146ce482fc4;
module.exports["connectNodes"] = $f4c8b854671ecade$export$2e109011d5320d15;
module.exports["disconnectNodes"] = $f4c8b854671ecade$export$dba1c2bae2f381b9;
module.exports["resetNodes"] = $f4c8b854671ecade$export$b0852c37ee3e7ea9;
module.exports["insertTarget"] = $f4c8b854671ecade$export$fb891e3743d8c30f;

});

parcelRegister("e745x", function(module, exports) {
class $6e1242ee45faf012$export$fa0bafaea078bc3e extends Error {
    constructor(reason){
        super(`Unable to attach, Incorrect configuration: ${reason}`), this.reason = reason;
    }
}
class $6e1242ee45faf012$export$c9ab3ad70477eb extends Error {
    constructor(handlerName){
        super(`Unable to execute ${handlerName}, API hasn't been initialized`), this.handlerName = handlerName;
    }
}
class $6e1242ee45faf012$export$6b13996afffc6894 extends Error {
    constructor(){
        super('An Error occured during Initialization');
    }
}
class $6e1242ee45faf012$export$e162153238934121 extends Error {
    constructor(){
        super('API not implemented');
    }
}
class $6e1242ee45faf012$export$fef5df6faf884a63 extends Error {
    constructor(type){
        super(`Unsupported type (${type})`);
    }
}
class $6e1242ee45faf012$export$8ef43b75008b17aa extends ReferenceError {
    constructor(localId){
        super(`Node (${localId}) could not be found`), this.localId = localId;
    }
}
class $6e1242ee45faf012$export$88aaf39bc2cab9a8 extends $6e1242ee45faf012$export$8ef43b75008b17aa {
    constructor(localId){
        super(localId), this.localId = localId;
    }
}
class $6e1242ee45faf012$export$311a85310d085910 extends $6e1242ee45faf012$export$8ef43b75008b17aa {
    constructor(localId){
        super(localId), this.localId = localId;
    }
}
class $6e1242ee45faf012$export$1a3d80e823d9a375 extends ReferenceError {
    constructor(targetLocalId, sourceLocalId){
        super(`Connecting Target (${targetLocalId}) to Source (${sourceLocalId}) will result in a Circular Reference`), this.targetLocalId = targetLocalId, this.sourceLocalId = sourceLocalId;
    }
}
class $6e1242ee45faf012$export$d754643475748116 extends ReferenceError {
    constructor(localId){
        super(`LocalId (${localId}) Collision has occured`), this.localId = localId;
    }
}
module.exports["CompatibilityError"] = $6e1242ee45faf012$export$fa0bafaea078bc3e;
module.exports["ConfigurationError"] = $6e1242ee45faf012$export$c9ab3ad70477eb;
module.exports["UnsupportedTypeError"] = $6e1242ee45faf012$export$fef5df6faf884a63;
module.exports["NodeNotFoundError"] = $6e1242ee45faf012$export$8ef43b75008b17aa;
module.exports["TargetReferenceError"] = $6e1242ee45faf012$export$88aaf39bc2cab9a8;
module.exports["SourceReferenceError"] = $6e1242ee45faf012$export$311a85310d085910;
module.exports["CyclicReferenceError"] = $6e1242ee45faf012$export$1a3d80e823d9a375;
module.exports["LocalIdCollisionError"] = $6e1242ee45faf012$export$d754643475748116;

});

parcelRegister("eiI2k", function(module, exports) {

var $krYZG = parcelRequire("krYZG");

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdd4dfaecbd3b2b8$var$getPayload = (payload)=>({
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        tags: [
            'editor'
        ],
        ...payload
    });
const $bdd4dfaecbd3b2b8$export$12008b1cff7b5512 = ({ docSize: docSize, count: count, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $bdd4dfaecbd3b2b8$var$getPayload({
            action: (0, $krYZG.ACTION).INITIALISED_FRAGMENT_MARK,
            attributes: {
                duration: duration,
                docSize: docSize,
                count: count
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};
const $bdd4dfaecbd3b2b8$export$bff45a9f8c570c00 = ({ docSize: docSize, sourceNodeType: sourceNodeType, targetNodeType: targetNodeType, type: type, actionType: actionType, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $bdd4dfaecbd3b2b8$var$getPayload({
            action: (0, $krYZG.ACTION).CONNECTED_NODES,
            attributes: {
                duration: duration,
                docSize: docSize,
                sourceNodeType: sourceNodeType,
                targetNodeType: targetNodeType,
                type: type,
                actionType: actionType
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};
const $bdd4dfaecbd3b2b8$export$d0d121977041a37d = ({ docSize: docSize, oldSourceNodeType: oldSourceNodeType, newSourceNodeType: newSourceNodeType, type: type, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $bdd4dfaecbd3b2b8$var$getPayload({
            action: (0, $krYZG.ACTION).UPDATED_SOURCE,
            attributes: {
                duration: duration,
                docSize: docSize,
                oldSourceNodeType: oldSourceNodeType,
                newSourceNodeType: newSourceNodeType,
                type: type
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};
const $bdd4dfaecbd3b2b8$export$9f5791db63c112cc = ({ docSize: docSize, targetNodeType: targetNodeType, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $bdd4dfaecbd3b2b8$var$getPayload({
            action: (0, $krYZG.ACTION).DISCONNECTED_SOURCE,
            attributes: {
                duration: duration,
                docSize: docSize,
                targetNodeType: targetNodeType
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};
const $bdd4dfaecbd3b2b8$export$1bb576f3f4bb0389 = ({ docSize: docSize, sourceNodeType: sourceNodeType, targetNodeType: targetNodeType, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $bdd4dfaecbd3b2b8$var$getPayload({
            action: (0, $krYZG.ACTION).DISCONNECTED_TARGET,
            attributes: {
                duration: duration,
                docSize: docSize,
                sourceNodeType: sourceNodeType,
                targetNodeType: targetNodeType
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};
const $bdd4dfaecbd3b2b8$export$41746208cd3b8ef5 = ({ docSize: docSize, newTargetNodeType: newTargetNodeType, oldTargetNodeType: oldTargetNodeType, sourceNodeType: sourceNodeType, type: type, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $bdd4dfaecbd3b2b8$var$getPayload({
            action: (0, $krYZG.ACTION).UPDATED_TARGET,
            attributes: {
                duration: duration,
                docSize: docSize,
                newTargetNodeType: newTargetNodeType,
                oldTargetNodeType: oldTargetNodeType,
                sourceNodeType: sourceNodeType,
                type: type
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};
const $bdd4dfaecbd3b2b8$export$6f3cdc6bed2f6e2e = ({ nodeType: nodeType, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $bdd4dfaecbd3b2b8$var$getPayload({
            action: (0, $krYZG.ACTION).UPDATED_FRAGMENT_MARK_NAME,
            attributes: {
                duration: duration,
                nodeType: nodeType
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};
const $bdd4dfaecbd3b2b8$export$c56def702d19a484 = ({ count: count, docSize: docSize, tr: tr, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return (duration)=>{
        const payload = $bdd4dfaecbd3b2b8$var$getPayload({
            action: (0, $krYZG.ACTION).GOT_CONNECTIONS,
            attributes: {
                docSize: docSize,
                duration: duration,
                count: count
            }
        });
        editorAnalyticsAPI?.attachAnalyticsEvent(payload)(tr);
    };
};
module.exports["captureInitialiseFragmentMarksEvent"] = $bdd4dfaecbd3b2b8$export$12008b1cff7b5512;
module.exports["captureConnectNodesEvent"] = $bdd4dfaecbd3b2b8$export$bff45a9f8c570c00;
module.exports["captureUpdateSourceEvent"] = $bdd4dfaecbd3b2b8$export$d0d121977041a37d;
module.exports["captureDisconnectSourceEvent"] = $bdd4dfaecbd3b2b8$export$9f5791db63c112cc;
module.exports["captureDisconnectTargetEvent"] = $bdd4dfaecbd3b2b8$export$1bb576f3f4bb0389;
module.exports["captureUpdateTargetEvent"] = $bdd4dfaecbd3b2b8$export$41746208cd3b8ef5;
module.exports["captureUpdateFragmentMarkNameEvent"] = $bdd4dfaecbd3b2b8$export$6f3cdc6bed2f6e2e;
module.exports["captureGetConnectionsEvent"] = $bdd4dfaecbd3b2b8$export$c56def702d19a484;

});

parcelRegister("d8HV0", function(module, exports) {
// This is a Statsig experiment
const $fff14be67fa63907$export$977ce18f16415288 = 'confluence_frontend_macro_interaction_design';
module.exports["MACRO_INTERACTION_DESIGN_UPDATES"] = $fff14be67fa63907$export$977ce18f16415288;

});

parcelRegister("hS1eb", function(module, exports) {

var $f0QSp = parcelRequire("f0QSp");

const $126cb09ff218d79b$export$a46cea14076acdff = (contentId, createAnalyticsEvent)=>(0, $f0QSp.editorAnalyticsAPI).analyticsCallback(contentId, createAnalyticsEvent);
module.exports["getEditorAnalyticsAPI"] = $126cb09ff218d79b$export$a46cea14076acdff;

});

parcelRegister("f0QSp", function(module, exports) {
const $b9a08ec7cb2f821d$var$normalizePayload = (payload)=>{
    const typeMap = {
        operational: 'sendOperationalEvent',
        screen: 'sendScreenEvent',
        track: 'sendTrackEvent',
        ui: 'sendUIEvent'
    };
    return {
        //adding "type" and "source", as they're originally omitted but expected by createAnalyticsEvent
        data: {
            ...payload,
            source: 'editorComponent'
        },
        type: typeMap[payload.eventType]
    };
};
const $b9a08ec7cb2f821d$export$5affe9476a7b3d5b = {
    analyticsCallback: (contentId, createAnalyticsEvent)=>{
        const fireAnalyticsEvent = (payload)=>{
            if (// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function' && createAnalyticsEvent) window.requestAnimationFrame(()=>{
                const analyticsPayload = $b9a08ec7cb2f821d$var$normalizePayload(payload);
                if (contentId) analyticsPayload.data.attributes = {
                    ...analyticsPayload.data.attributes,
                    objectId: contentId
                };
                createAnalyticsEvent(analyticsPayload).fire();
            });
        };
        const attachAnalyticsEvent = (payload)=>{
            fireAnalyticsEvent(payload);
            return (_tr)=>{
                return true;
            };
        };
        return {
            attachAnalyticsEvent: attachAnalyticsEvent,
            fireAnalyticsEvent: fireAnalyticsEvent
        };
    }
};
module.exports["editorAnalyticsAPI"] = $b9a08ec7cb2f821d$export$5affe9476a7b3d5b;

});

parcelRegister("fySJw", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $2XKS9 = parcelRequire("2XKS9");


var $dc2v6 = parcelRequire("dc2v6");


var $3LvmY = parcelRequire("3LvmY");


var $1AM4E = parcelRequire("1AM4E");

let $8e595456ec3aa5d5$var$connectDataListener;


class $8e595456ec3aa5d5$var$ConnectDataListener {
    init({ emit: emit }) {
        this.emit = emit;
    }
    static async validate(extensionKey, data) {
        const { validateSchema: validateSchema, DataTransferValidationError: DataTransferValidationError } = await (parcelRequire("31KN8"));
        if (!data.eventData) throw new DataTransferValidationError({
            message: "Passed data is missing 'eventData'."
        });
        const keys = Object.keys(data.eventData);
        if (keys.length !== 1) throw new DataTransferValidationError({
            message: "'eventData' should only include a single key. The key should be same with 'refDataSchema.outputType'."
        });
        const connectMacroKeyRefOutputTypeMap = await (0, $dc2v6.getConnectMacroKeyRefOutputTypeMap)();
        if (!connectMacroKeyRefOutputTypeMap.has(extensionKey)) // This is a case that shouldn't really happen. Throwing a regular error instead of DataTransferValidationError
        // because this error is not related to what the vendor emitted data.
        throw new Error('extensionKey is not found in the macro metadata.');
        if (connectMacroKeyRefOutputTypeMap.get(extensionKey) !== keys[0]) throw new DataTransferValidationError({
            message: `'eventData' should contain 'refDataSchema.outputType' defined in the app manifest (${connectMacroKeyRefOutputTypeMap.get(extensionKey)}).`
        });
        validateSchema(keys[0], data.eventData[keys[0]]);
    }
    async transfer(extensionKey, localId, data, createAnalyticsEvent, isViewPage) {
        if (this.emit && localId && data) {
            const transfer = {
                extensionKey: extensionKey,
                localId: localId,
                data: data,
                isViewPage: isViewPage
            };
            const isTrackable = (0, $1AM4E.ConnectReferentialityExperienceTrackerSupport).isTrackable(transfer);
            let didStartExperience = false;
            const shouldTrack = isTrackable;
            if (shouldTrack && !(0, $6mKj3.expVal)('confluence_fix_referentiality_metrics', 'isEnabled', false)) {
                (0, $1AM4E.ConnectReferentialityExperienceTrackerSupport).start(transfer);
                didStartExperience = true;
            }
            const { DataTransferValidationError: DataTransferValidationError } = await (parcelRequire("31KN8"));
            try {
                await $8e595456ec3aa5d5$var$ConnectDataListener.validate(extensionKey, data);
            } catch (e) {
                const event = (0, $3LvmY.getValidationFailedEvent)({
                    isViewPage: isViewPage,
                    extensionKey: extensionKey,
                    error: e
                });
                createAnalyticsEvent(event).fire();
                if (shouldTrack && !didStartExperience && !(e instanceof DataTransferValidationError)) {
                    (0, $1AM4E.ConnectReferentialityExperienceTrackerSupport).start(transfer);
                    didStartExperience = true;
                }
                if (didStartExperience) (0, $1AM4E.ConnectReferentialityExperienceTrackerSupport).fail(e instanceof Error ? e : String(e));
                if (e instanceof DataTransferValidationError) return {
                    status: (0, $2XKS9.ConnectDataTransferStatus).Error,
                    message: e.message,
                    module: 'data_provider',
                    errors: e.errors
                };
                throw e;
            }
            if (shouldTrack && !didStartExperience) {
                (0, $1AM4E.ConnectReferentialityExperienceTrackerSupport).start(transfer);
                didStartExperience = true;
            }
            this.emit(localId, data.eventData);
            if (didStartExperience) (0, $1AM4E.ConnectReferentialityExperienceTrackerSupport).succeed();
            return {
                status: (0, $2XKS9.ConnectDataTransferStatus).Success,
                message: 'Data accepted and emitted',
                module: 'data_provider'
            };
        }
        return {
            status: (0, $2XKS9.ConnectDataTransferStatus).Error,
            message: 'There was an issue accepting the data',
            module: 'data_provider'
        };
    }
    constructor(){
        this.emit = void 0;
    }
}
const $8e595456ec3aa5d5$export$605049a72d9f563 = ()=>{
    if (!$8e595456ec3aa5d5$var$connectDataListener) $8e595456ec3aa5d5$var$connectDataListener = new $8e595456ec3aa5d5$var$ConnectDataListener();
    return $8e595456ec3aa5d5$var$connectDataListener;
};
module.exports["getConnectDataListener"] = $8e595456ec3aa5d5$export$605049a72d9f563;

});

parcelRegister("2XKS9", function(module, exports) {
var $606590dfce3163d6$export$f9f405499e653992 = /*#__PURE__*/ function(ConnectDataTransferStatus) {
    ConnectDataTransferStatus["Success"] = "Success";
    ConnectDataTransferStatus["Error"] = "Error";
    return ConnectDataTransferStatus;
}({});
module.exports["ConnectDataTransferStatus"] = $606590dfce3163d6$export$f9f405499e653992;

});

parcelRegister("dc2v6", function(module, exports) {

var $3IXUB = parcelRequire("3IXUB");

let $a1018373af446f97$var$connectMacroKeyRefOutputTypeMap;
let $a1018373af446f97$var$initialized = false;
async function $a1018373af446f97$var$createMacroKeyRefOutputTypeMap() {
    const macros = await (0, $3IXUB.getMacroMetaData)();
    const result = macros.filter((macro)=>macro.refDataSchema != null).map((macro)=>[
            macro.macroName,
            macro.refDataSchema.outputType
        ]);
    return new Map(result);
}
async function $a1018373af446f97$export$9fde119d071a7062() {
    // used this initialized variable because I was seeing that connectMacroKeyRefOutputTypeMap may
    // be null errors otherwise
    if (!$a1018373af446f97$var$initialized) {
        $a1018373af446f97$var$connectMacroKeyRefOutputTypeMap = await $a1018373af446f97$var$createMacroKeyRefOutputTypeMap();
        $a1018373af446f97$var$initialized = true;
    }
    return $a1018373af446f97$var$connectMacroKeyRefOutputTypeMap;
}
module.exports["getConnectMacroKeyRefOutputTypeMap"] = $a1018373af446f97$export$9fde119d071a7062;

});

parcelRegister("3LvmY", function(module, exports) {
const $a60398d8d7606d16$export$16d909a88d49df97 = ({ isViewPage: isViewPage, extensionKey: extensionKey, error: error })=>{
    return {
        type: 'sendTrackEvent',
        data: {
            containerType: 'page',
            objectType: 'connectAddon',
            source: isViewPage ? 'viewPageScreen' : 'editPageScreen',
            action: 'failed',
            actionSubject: 'connectRefEventDataValidation',
            attributes: {
                extensionKey: extensionKey,
                message: error.message
            }
        }
    };
};
const $a60398d8d7606d16$export$f472af28e6312d6e = ({ isViewPage: isViewPage, extensionKey: extensionKey })=>{
    return {
        type: 'sendTrackEvent',
        data: {
            containerType: 'page',
            objectType: 'connectAddon',
            source: isViewPage ? 'viewPageScreen' : 'editPageScreen',
            action: 'received',
            actionSubject: 'connectRefEventData',
            attributes: {
                extensionKey: extensionKey
            }
        }
    };
};
module.exports["getValidationFailedEvent"] = $a60398d8d7606d16$export$16d909a88d49df97;
module.exports["getReceivedConnectRefDataEvent"] = $a60398d8d7606d16$export$f472af28e6312d6e;

});

parcelRegister("1AM4E", function(module, exports) {

var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");

const $b8656fd966301400$var$getError = (messageOrError)=>{
    if (messageOrError instanceof Error) return messageOrError;
    return new Error(messageOrError);
};
const $b8656fd966301400$export$9e19abdf0a0245fe = new class ConnectReferentialityExperienceTrackerSupport {
    isTrackable(transfer) {
        return Boolean(transfer?.extensionKey) && Boolean(transfer?.localId) && Boolean(transfer?.data);
    }
    start(transfer) {
        (0, $fGzMp.getExperienceTracker)().start({
            name: (0, $irVI7.CONNECT_REFERENTIALITY_EXPERIENCE),
            attributes: {
                extensionKey: transfer?.extensionKey,
                isViewPage: transfer?.isViewPage
            }
        });
    }
    succeed() {
        (0, $fGzMp.getExperienceTracker)().succeed({
            name: (0, $irVI7.CONNECT_REFERENTIALITY_EXPERIENCE)
        });
    }
    fail(messageOrError) {
        (0, $fGzMp.getExperienceTracker)().fail({
            name: (0, $irVI7.CONNECT_REFERENTIALITY_EXPERIENCE),
            error: $b8656fd966301400$var$getError(messageOrError)
        });
    }
}();
module.exports["ConnectReferentialityExperienceTrackerSupport"] = $b8656fd966301400$export$9e19abdf0a0245fe;

});

parcelRegister("31KN8", function(module, exports) {

let $2345c2ebf53cd779$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2345c2ebf53cd779$var$load("iEvs6").then(()=>parcelRequire('bppNh'));

});

parcelRegister("eHpfp", function(module, exports) {

let $ab38aa7364a77c7d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ab38aa7364a77c7d$var$load("gt1ja").then(()=>parcelRequire('98w9o'));

});

parcelRegister("4ri4I", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $4d309a7dc7a1cda3$export$64697004958d0ff1 = {
    editSource: ''
};
const $4d309a7dc7a1cda3$var$Store = (0, $8s9DV.createStore)({
    initialState: {
        ...$4d309a7dc7a1cda3$export$64697004958d0ff1
    },
    actions: {
        setEditSource: (editSource)=>({ setState: setState })=>{
                setState({
                    editSource: editSource
                });
            }
    },
    name: 'setEditSource'
});
const $4d309a7dc7a1cda3$export$ee479a8e5902b302 = (0, $kBr4q.createHook)($4d309a7dc7a1cda3$var$Store);
const $4d309a7dc7a1cda3$export$7e972f51583fdb8e = (0, $kBr4q.createActionsHook)($4d309a7dc7a1cda3$var$Store);
module.exports["useEditSource"] = $4d309a7dc7a1cda3$export$ee479a8e5902b302;
module.exports["useEditSourceActions"] = $4d309a7dc7a1cda3$export$7e972f51583fdb8e;

});

parcelRegister("lm6tr", function(module, exports) {

let $f8c0aca4726fba6e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f8c0aca4726fba6e$var$load("kD057").then(()=>parcelRequire('KcDfp'));

});

parcelRegister("9sGCn", function(module, exports) {

var $5RVp4 = parcelRequire("5RVp4");


var $5tydj = parcelRequire("5tydj");


var $kBBRP = parcelRequire("kBBRP");


var $b22Ya = parcelRequire("b22Ya");


var $dOBRD = parcelRequire("dOBRD");


var $fFmJj = parcelRequire("fFmJj");


var $ge2sX = parcelRequire("ge2sX");

var $416a341702253f60$var$Client = /*#__PURE__*/ function(Client) {
    Client["CC_GRAPHQL"] = "Cc graphql client";
    Client["AGG_GRAPHQL"] = "Agg graphql client";
    return Client;
}($416a341702253f60$var$Client || {});
const $416a341702253f60$var$FRAGMENTS_BY_TYPE = [
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        fragment: (0, $b22Ya.default)
    },
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        // If we don't have `status` cached but do have `subType` cached, this ensures we still fast load it. We prefer fast loading live docs even if we're uncertain whether they're archived.
        fragment: (0, $kBBRP.default)
    },
    {
        client: "Cc graphql client",
        gqlType: 'PTPage',
        fragment: (0, $5tydj.default)
    },
    {
        // Search query uses agg graphql client
        client: "Agg graphql client",
        gqlType: 'SearchConfluencePageBlogAttachment',
        fragment: (0, $5RVp4.default)
    }
];
const $416a341702253f60$export$b4dacd1dfdee469b = (0, $dOBRD.default)((contentId)=>{
    if (!contentId) // When content id does not exist, return undefined values
    return {
        subType: undefined,
        isArchived: undefined,
        gqlType: undefined
    };
    const cloudId = (0, $ge2sX.getCloudId)();
    let subType;
    let isArchived = undefined;
    let gqlTypeUsed;
    $416a341702253f60$var$FRAGMENTS_BY_TYPE.some(({ client: client, gqlType: gqlType, fragment: fragment })=>{
        // readFragment throws an error if it finds the item in the cache without both id and subtype, so we wrap in try/catch
        try {
            let id = `${gqlType}:${contentId}`;
            if (gqlType === 'SearchConfluencePageBlogAttachment') // Search graphql query includes the ARI in the id
            id = `${gqlType}:ari:cloud:confluence:${cloudId}:page/${contentId}`;
            const fragmentData = (0, $fFmJj.readFragmentInterop)({
                id: id,
                fragment: fragment,
                interopApolloAggClient: client === "Agg graphql client",
                __callerPackage__: "live-pages-utils"
            });
            if (fragmentData && 'subType' in fragmentData && fragmentData.subType) {
                subType = fragmentData.subType;
                isArchived = 'status' in fragmentData && fragmentData.status ? fragmentData.status?.toLowerCase?.() === 'archived' : undefined;
                gqlTypeUsed = gqlType;
                return true;
            } else if (fragmentData && 'subtype' in fragmentData && fragmentData.subtype) {
                // In search graphql query's response, subtype exists as an inline fragment on ConfluencePage
                subType = fragmentData.subtype?.toLowerCase?.();
                gqlTypeUsed = gqlType;
                return true;
            }
        } catch  {}
    });
    return {
        subType: subType,
        isArchived: isArchived,
        gqlType: gqlTypeUsed
    };
});
const $416a341702253f60$export$d56c32e9e73f8f9b = ()=>$416a341702253f60$export$b4dacd1dfdee469b.clear();
module.exports["getCachedPageData"] = $416a341702253f60$export$b4dacd1dfdee469b;
module.exports["clearMemoizedCachedPageData"] = $416a341702253f60$export$d56c32e9e73f8f9b;

});

parcelRegister("5RVp4", function(module, exports) {
/**
 * @generated SignedSource<<9964ae8171b6e20649f2fca9a76ff96a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d1b5c3b39238b90e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataSubTypeSearchFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "LinkedField",
            "name": "confluenceEntity",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "subtype"
                        }
                    ],
                    "type": "ConfluencePage"
                }
            ]
        }
    ],
    "type": "SearchConfluencePageBlogAttachment"
};
$d1b5c3b39238b90e$var$node.hash = "029b00b42bd8ba9e9b5ecf4947b241c2";
var $d1b5c3b39238b90e$export$2e2bcd8739ae039 = $d1b5c3b39238b90e$var$node;
module.exports["default"] = $d1b5c3b39238b90e$export$2e2bcd8739ae039;

});

parcelRegister("5tydj", function(module, exports) {
/**
 * @generated SignedSource<<06b30fff81deb6c9145868aacd1b6057>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $019558c9ca245006$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataSubTypePageTreeFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        }
    ],
    "type": "PTPage"
};
$019558c9ca245006$var$node.hash = "7ccb76f2a832d90b6f167fe96a11f5a9";
var $019558c9ca245006$export$2e2bcd8739ae039 = $019558c9ca245006$var$node;
module.exports["default"] = $019558c9ca245006$export$2e2bcd8739ae039;

});

parcelRegister("kBBRP", function(module, exports) {
/**
 * @generated SignedSource<<ba803410513b2e2b6e70f77d471effb5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6f66d8210bca9b3e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataSubTypeContentFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        }
    ],
    "type": "Content"
};
$6f66d8210bca9b3e$var$node.hash = "03b28a640aee18909db0a4f3575e7f08";
var $6f66d8210bca9b3e$export$2e2bcd8739ae039 = $6f66d8210bca9b3e$var$node;
module.exports["default"] = $6f66d8210bca9b3e$export$2e2bcd8739ae039;

});

parcelRegister("b22Ya", function(module, exports) {
/**
 * @generated SignedSource<<3f51ca78fc05b3943b12ce8587361a0d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f9170d170545992b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataContentFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        }
    ],
    "type": "Content"
};
$f9170d170545992b$var$node.hash = "b940ae3a5484e1099f106d12713d37f5";
var $f9170d170545992b$export$2e2bcd8739ae039 = $f9170d170545992b$var$node;
module.exports["default"] = $f9170d170545992b$export$2e2bcd8739ae039;

});

parcelRegister("cmBjr", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kyKWe = parcelRequire("kyKWe");


var $7aRa9 = parcelRequire("7aRa9");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $dPJCf = parcelRequire("dPJCf");


var $bqMNb = parcelRequire("bqMNb");


var $jv3O2 = parcelRequire("jv3O2");


var $i9VoI = parcelRequire("i9VoI");

const $1c71f3d63aae3f56$export$b0544c15da22323d = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const showConvertToLivePageFlag = (0, $jv3O2.useShowConvertToLivePageFlag)({
        flags: flags
    });
    const onSubscriptionEvent = (0, $cozmU.useCallback)((response)=>{
        const { accountId: accountId, pageUpdated: pageUpdated } = response || {};
        const trigger = pageUpdated?.trigger;
        if (trigger !== 'convertToLiveEdit') return;
        showConvertToLivePageFlag({
            converterWasCurrentUser: accountId === userId
        });
        // When another user converts the page to a live doc, we need to add a query param to avoid the double action bar bug.
        // Without this, the page may read stale SSR values indicating it's not a live page, causing UI weirdness.
        // The query param forces RouteState to increment transitionId, preventing it from using initial SSR values.
        setQueryParams({
            [(0, $bqMNb.FORCE_TRANSITION_QUERY_PARAM)]: (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()
        });
    }, [
        showConvertToLivePageFlag,
        userId,
        setQueryParams
    ]);
    (0, $i9VoI.useSubscriptionEvent)({
        subscriberId: 'convertToLivePageFlag',
        contentId: contentId,
        delta: 'pageUpdated',
        contentType: 'page',
        skip: !contentId,
        onDataReceived: (response)=>onSubscriptionEvent(response)
    });
    return null;
});
module.exports["ConvertToLivePageFlag"] = $1c71f3d63aae3f56$export$b0544c15da22323d;

});

parcelRegister("jv3O2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $jhwJP = parcelRequire("jhwJP");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $de2j9 = parcelRequire("de2j9");


var $ep3mz = parcelRequire("ep3mz");

const $a23dc1f066cda204$var$i18nBase = (0, $kSwu1.defineMessages)({
    flagTitle: {
        id: "editor-flags.convert-to-live-page-flag.flagTitle",
        defaultMessage: "This page was switched to a live page"
    },
    switcherFlagTitle: {
        id: "editor-flags.convert-to-live-page-flag.switcherFlagTitle",
        defaultMessage: "You\u2019ve switched to a live page"
    },
    flagBody: {
        id: "editor-flags.convert-to-live-page-flag.flagBody",
        defaultMessage: "Updates to this page will now be instant and visible in real time."
    },
    findOutMore: {
        id: "editor-flags.convert-to-live-page-flag.findOutMore",
        defaultMessage: "Find out more"
    },
    reloadButton: {
        id: "editor-flags.convert-to-live-page-flag.reloadButton",
        defaultMessage: "Reload"
    }
});
const $a23dc1f066cda204$var$i18nLiveDocs = (0, $kSwu1.defineMessages)({
    flagTitle: {
        id: "editor-flags.convert-to-live-page-flag.flagTitle.livedocs",
        defaultMessage: "This page was converted to a live doc"
    },
    switcherFlagTitle: {
        id: "editor-flags.convert-to-live-page-flag.switcherFlagTitle.livedocs",
        defaultMessage: "You\u2019ve converted to a live doc"
    },
    flagBody: {
        id: "editor-flags.convert-to-live-page-flag.flagBody.livedocs",
        defaultMessage: "Updates to this doc will now be instant and visible in real time."
    },
    findOutMore: {
        id: "editor-flags.convert-to-live-page-flag.findOutMore.livedocs",
        defaultMessage: "Find out more about live docs"
    }
});
const $a23dc1f066cda204$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($a23dc1f066cda204$var$i18nBase, $a23dc1f066cda204$var$i18nLiveDocs);
const $a23dc1f066cda204$var$LEARN_MORE_URL = 'https://support.atlassian.com/confluence-cloud/docs/create-and-collaborate-in-real-time-with-live-docs/';
const $a23dc1f066cda204$var$CONVERT_SUCCESS_FLAG_AUTO_CLOSE_TIME = 11000;
const $a23dc1f066cda204$export$cb5a789d90de377 = ({ flags: flags })=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const intl = (0, $kSwu1.useIntl)();
    const { replace: replace } = (0, $dPJCf.useRouteActions)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const handleOnClick = (0, $cozmU.useCallback)(()=>{
        const livePageLink = (0, $1NBp8.VIEW_PAGE).toUrl({
            spaceKey: spaceKey,
            contentId: contentId
        });
        return isOnEditRoute ? replace(livePageLink) : window.location.reload();
    }, [
        isOnEditRoute,
        replace,
        spaceKey,
        contentId
    ]);
    return (0, $cozmU.useCallback)(async ({ converterWasCurrentUser: converterWasCurrentUser })=>{
        const successFlag = await flags.showFlag({
            title: converterWasCurrentUser ? intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.switcherFlagTitle) : intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.flagTitle),
            description: intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.flagBody),
            type: 'success',
            id: 'convert-to-live-page-flag',
            close: 'never',
            // Needed to bypass the flags.hideAllFlags() call in EditorFlags.tsx on editor unmount.
            actions: [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                        "data-testid": "reload-button"
                    }, intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.reloadButton)),
                    onClick: handleOnClick
                },
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                        "data-testid": "find-out-more-button"
                    }, intl.formatMessage($a23dc1f066cda204$export$a7357cdd1f0b0168.findOutMore)),
                    onClick: ()=>window.open($a23dc1f066cda204$var$LEARN_MORE_URL, '_blank')
                }
            ]
        });
        // We don't want to auto-close the flag when a different user converts the page,
        // because there's no auto-redirect, so the user must click "Reload" in the flag to continue.
        if (converterWasCurrentUser) // Manually set a timeout so the flag auto-closes after the page transition completes.
        setTimeout(()=>flags.hideFlag(successFlag.id), $a23dc1f066cda204$var$CONVERT_SUCCESS_FLAG_AUTO_CLOSE_TIME);
    }, [
        intl,
        flags,
        handleOnClick
    ]);
};
module.exports["useShowConvertToLivePageFlag"] = $a23dc1f066cda204$export$cb5a789d90de377;

});

parcelRegister("jhwJP", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $8e78cdefc122a0a9$export$d1326a8d9df930b6 = (i18nBase, i18nLiveDocs)=>{
    const initializeData = (targetObj)=>{
        targetObj._data = (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? {
            ...i18nBase,
            ...i18nLiveDocs
        } : i18nBase;
        targetObj._initialized = true;
    };
    return new Proxy({}, {
        get: (targetObj, prop)=>{
            // Ensures retrieval of properties on i18n object use i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return targetObj._data[prop];
        },
        ownKeys: (targetObj)=>{
            // ensures `.keys` uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return Reflect.ownKeys(targetObj._data);
        },
        has: (targetObj, prop)=>{
            // Ensures for...in uses the i18n keys instead of targetObj keys
            if (!targetObj._initialized) initializeData(targetObj);
            return prop in targetObj._data;
        },
        getOwnPropertyDescriptor: (targetObj, prop)=>{
            // Ensures i18n props are enumerable, required for ownKeys/etc to work
            if (!targetObj._initialized) initializeData(targetObj);
            const descriptor = Object.getOwnPropertyDescriptor(targetObj._data, prop);
            return descriptor ? {
                ...descriptor,
                enumerable: true
            } : undefined;
        }
    });
};
module.exports["mergeLiveDocI18n"] = $8e78cdefc122a0a9$export$d1326a8d9df930b6;

});

parcelRegister("LSims", function(module, exports) {

var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $aJUpe = parcelRequire("aJUpe");


var $4Pmcr = parcelRequire("4Pmcr");

const $450638ee7a6e2e59$export$ec80b976b56288ba = (contentId)=>{
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $aJUpe.default), {
        variables: {
            contentId: contentId ?? '',
            isMarkdownModeEnabled: (0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true)
        },
        fetchPolicy: 'cache-only',
        skip: !contentId || !(0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true),
        __callerPackage__: "content-markdown-mode"
    });
    return (0, $4Pmcr.getIsMarkdownModeFromData)(data);
};
module.exports["useIsMarkdownMode"] = $450638ee7a6e2e59$export$ec80b976b56288ba;

});

parcelRegister("aJUpe", function(module, exports) {
/**
 * @generated SignedSource<<97f042394447b34381d2572432982113>>
 * @relayHash 8ee1f0cde2475ae17a8f029f978204ad
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1279c7f0b2788c28fc2ea16597139729f5d965c3d36268a5b7ab174d923c6971
const $1180c416e2ce3051$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "isMarkdownModeEnabled"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PublishedContentProperties",
                                    "kind": "LinkedField",
                                    "name": "latest",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "isMarkdownModeEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isMarkdownMode"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "IsMarkdownModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "IsMarkdownModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8ee1f0cde2475ae17a8f029f978204ad",
            "id": "1279c7f0b2788c28fc2ea16597139729f5d965c3d36268a5b7ab174d923c6971",
            "metadata": {},
            "name": "IsMarkdownModeQuery",
            "operationKind": "query",
            "text": "query IsMarkdownModeQuery($contentId:ID!,$isMarkdownModeEnabled:Boolean=false){content(id:$contentId){nodes{id,contentProperties{latest{isMarkdownMode@include(if:$isMarkdownModeEnabled)}}}}}"
        }
    };
}();
$1180c416e2ce3051$var$node.hash = "65f92bc360aa57691987c1aba7d545ca";
var $1180c416e2ce3051$export$2e2bcd8739ae039 = $1180c416e2ce3051$var$node;
module.exports["default"] = $1180c416e2ce3051$export$2e2bcd8739ae039;

});

parcelRegister("4Pmcr", function(module, exports) {
const $70bbf1741b7230f7$export$6bc4ac71fcf3f02a = (data)=>{
    return data?.content?.nodes?.[0]?.contentProperties?.latest?.isMarkdownMode ?? false;
};
module.exports["getIsMarkdownModeFromData"] = $70bbf1741b7230f7$export$6bc4ac71fcf3f02a;

});

parcelRegister("5zmqi", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $nIvaQ = parcelRequire("nIvaQ");


var $4qUu8 = parcelRequire("4qUu8");

const $59f6faa17a0b40be$var$COLLAB_DRAFT_VARIABLES = (contentId)=>({
        id: contentId,
        hydrateAdf: true
    });
const $59f6faa17a0b40be$export$81644b1180210cfe = async (contentId)=>{
    let convertedBody;
    try {
        const monolithResult = await (0, $c0rhi.queryInterop)({
            query: (0, $4qUu8.MarkdownConvertedBodyQuery),
            context: {
                single: true
            },
            fetchPolicy: 'network-only',
            variables: {
                contentId: contentId,
                status: [
                    'draft',
                    'current'
                ]
            },
            __callerPackage__: "content-markdown-mode"
        });
        const value = monolithResult?.data?.content?.nodes?.[0]?.body?.atlas_doc_format?.value;
        if (typeof value === 'string' && value.length > 0) convertedBody = value;
    } catch  {
        return undefined;
    }
    if (!convertedBody) return undefined;
    // Best-effort cache mirror. Isolated so a cache miss / write failure does
    // not drop the body the caller needs for `replaceDocument` — that path
    // is what keeps the editor populated across the mode flip.
    const collabDraftQuery = (0, $nIvaQ.getCollabDraftQuery)();
    try {
        const existing = (0, $l1uFv.readQueryInterop)({
            query: collabDraftQuery,
            variables: $59f6faa17a0b40be$var$COLLAB_DRAFT_VARIABLES(contentId),
            __callerPackage__: "content-markdown-mode"
        });
        // Preserve version + metadata (incl. `relevance` on the WithRelevance
        // variant); swap only `document`.
        (0, $fEmGS.writeQueryInterop)({
            query: collabDraftQuery,
            variables: $59f6faa17a0b40be$var$COLLAB_DRAFT_VARIABLES(contentId),
            data: {
                collabDraft: {
                    ...existing?.collabDraft,
                    document: convertedBody
                }
            },
            __callerPackage__: "content-markdown-mode"
        });
    } catch  {
    // see JSDoc
    }
    return convertedBody;
};
module.exports["refetchPageContent"] = $59f6faa17a0b40be$export$81644b1180210cfe;

});

parcelRegister("4qUu8", function(module, exports) {

var $1Qv9J = parcelRequire("1Qv9J");

const $0faef94ba621a68c$export$76c2bcd049e9b532 = (0, $1Qv9J.default);
module.exports["MarkdownConvertedBodyQuery"] = $0faef94ba621a68c$export$76c2bcd049e9b532;

});

parcelRegister("1Qv9J", function(module, exports) {
/**
 * @generated SignedSource<<9ba1093d2faffa7671c8a9ee5e67ea5a>>
 * @relayHash ec1aaca340bdd49293f1094fa3362f18
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c81830ee1f700a3e723bb561e8443b4ce4e0320dccd87bb214ea614cd125bf54
const $6562e0b89e6e4559$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentBodyPerRepresentation",
                            "kind": "LinkedField",
                            "name": "body",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentBody",
                                    "kind": "LinkedField",
                                    "name": "atlas_doc_format",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MarkdownConvertedBodyQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MarkdownConvertedBodyQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "ec1aaca340bdd49293f1094fa3362f18",
            "id": "c81830ee1f700a3e723bb561e8443b4ce4e0320dccd87bb214ea614cd125bf54",
            "metadata": {},
            "name": "MarkdownConvertedBodyQuery",
            "operationKind": "query",
            "text": "query MarkdownConvertedBodyQuery($contentId:ID!,$status:[String]!){content(id:$contentId,status:$status){nodes{id,body{atlas_doc_format{value}}}}}"
        }
    };
}();
$6562e0b89e6e4559$var$node.hash = "2652b00bc6d31f1e4785aeb0c45e5e03";
var $6562e0b89e6e4559$export$2e2bcd8739ae039 = $6562e0b89e6e4559$var$node;
module.exports["default"] = $6562e0b89e6e4559$export$2e2bcd8739ae039;

});

parcelRegister("hTLSK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $l1uFv = parcelRequire("l1uFv");


var $308Wd = parcelRequire("308Wd");


var $fEmGS = parcelRequire("fEmGS");


var $bQm3c = parcelRequire("bQm3c");


var $aJUpe = parcelRequire("aJUpe");


var $3PFO2 = parcelRequire("3PFO2");

const $f198f33a94a9cbf9$export$b6672b8bd1ee20b6 = (contentId, isMarkdownMode, isMarkdownModeEnabled)=>{
    const variables = {
        contentId: contentId,
        isMarkdownModeEnabled: isMarkdownModeEnabled
    };
    try {
        const cached = (0, $l1uFv.readQueryInterop)({
            query: (0, $aJUpe.default),
            variables: variables,
            __callerPackage__: "content-markdown-mode"
        });
        const updatedNodes = (cached?.content?.nodes ?? []).map((node)=>{
            if (!node || node.id !== contentId) return node;
            return {
                ...node,
                contentProperties: {
                    ...node.contentProperties,
                    latest: {
                        ...node.contentProperties?.latest,
                        isMarkdownMode: isMarkdownMode
                    }
                }
            };
        });
        (0, $fEmGS.writeQueryInterop)({
            query: (0, $aJUpe.default),
            variables: variables,
            data: {
                content: {
                    ...cached?.content,
                    nodes: updatedNodes
                }
            },
            __callerPackage__: "content-markdown-mode"
        });
    } catch  {
    // Cache miss — see JSDoc.
    }
};
const $f198f33a94a9cbf9$export$3572aa176fa6e0e3 = ()=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [updateMarkdownModeMutation, { loading: loading, error: error }] = (0, $308Wd.useMutationInterop)((0, $3PFO2.default), {
        __callerPackage__: "content-markdown-mode"
    });
    const updateMarkdownMode = (0, $cozmU.useCallback)(async (contentId, isMarkdownMode)=>{
        try {
            const result = await updateMarkdownModeMutation({
                variables: {
                    cloudId: cloudId,
                    input: {
                        contentId: contentId,
                        isMarkdownMode: isMarkdownMode
                    }
                }
            });
            const payload = result?.data?.confluence_updateMarkdownMode;
            if (payload?.success) return {
                success: true
            };
            const errorMessage = payload?.errors?.[0]?.message ?? undefined;
            return {
                success: false,
                errorMessage: errorMessage
            };
        } catch (e) {
            const errorMessage = e instanceof Error ? e.message : undefined;
            return {
                success: false,
                errorMessage: errorMessage
            };
        }
    }, [
        cloudId,
        updateMarkdownModeMutation
    ]);
    return {
        updateMarkdownMode: updateMarkdownMode,
        loading: loading,
        error: error
    };
};
module.exports["patchIsMarkdownModeCache"] = $f198f33a94a9cbf9$export$b6672b8bd1ee20b6;
module.exports["useUpdateMarkdownMode"] = $f198f33a94a9cbf9$export$3572aa176fa6e0e3;

});

parcelRegister("3PFO2", function(module, exports) {
/**
 * @generated SignedSource<<fe0f747cedae005b17051370ed3320b8>>
 * @relayHash d0b91783b4821bd978a5d2fd0c120efd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 601f697afe038b9fda9c5a6d14bb839534ca3e6825e77daf39701b3165183f73
const $a1d16a3b56c472ef$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ConfluenceUpdateMarkdownModePayload",
            "kind": "LinkedField",
            "name": "confluence_updateMarkdownMode",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "contentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "isMarkdownMode"
                },
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "UpdateMarkdownModeMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "UpdateMarkdownModeMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "d0b91783b4821bd978a5d2fd0c120efd",
            "id": "601f697afe038b9fda9c5a6d14bb839534ca3e6825e77daf39701b3165183f73",
            "metadata": {},
            "name": "UpdateMarkdownModeMutation",
            "operationKind": "mutation",
            "text": "mutation UpdateMarkdownModeMutation($cloudId:ID!,$input:ConfluenceUpdateMarkdownModeInput!){confluence_updateMarkdownMode(cloudId:$cloudId,input:$input){contentId,isMarkdownMode,success,errors{message}}}"
        }
    };
}();
$a1d16a3b56c472ef$var$node.hash = "47efe092e8db2f8efa6d6b357d26f1f8";
var $a1d16a3b56c472ef$export$2e2bcd8739ae039 = $a1d16a3b56c472ef$var$node;
module.exports["default"] = $a1d16a3b56c472ef$export$2e2bcd8739ae039;

});

parcelRegister("kXsBa", function(module, exports) {

var $cXQmG = parcelRequire("cXQmG");


var $7gy2b = parcelRequire("7gy2b");


var $cozmU = parcelRequire("cozmU");


var $cgpF0 = parcelRequire("cgpF0");


var $ij4CE = parcelRequire("ij4CE");


var $9wGTI = parcelRequire("9wGTI");


var $308Wd = parcelRequire("308Wd");




const $563fbe27571904a7$export$57b25de3525e313f = (contentId, currentTitle)=>{
    const [isEditing, setIsEditing] = (0, $cozmU.useState)(false);
    const [updatedTitleFromPubsub, setUpdatedTitleFromPubsub] = (0, $cozmU.useState)(undefined);
    const isProcessingTitleUpdate = (0, $cozmU.useRef)(false);
    const onMutationComplete = ()=>{
        setUpdateError(undefined);
        setIsEditing(false);
    };
    const [updateError, setUpdateError] = (0, $cozmU.useState)(undefined);
    const [updateContentTitle, { loading: updateLoading }] = (0, $308Wd.useMutationInterop)((0, $7gy2b.default), {
        onCompleted: onMutationComplete,
        onError: setUpdateError,
        __callerPackage__: "content-types-header"
    });
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $cXQmG.default),
        fragmentSpec: (0, $cXQmG.default),
        __callerPackage__: "content-types-header"
    });
    const updateCache = (0, $cozmU.useCallback)((value)=>{
        writeFragmentInterop({
            fragmentId: `Content:${contentId}`,
            data: {
                id: contentId,
                title: value,
                __typename: 'Content'
            }
        });
    }, [
        contentId,
        writeFragmentInterop
    ]);
    const updateTitle = (0, $cozmU.useCallback)(async (value_0)=>{
        if (value_0 === currentTitle) {
            setIsEditing(false);
            // We have to manually clear the error here because it is no longer relevant to this most recent call to `updateTitle`,
            // since we're now attempting to set the title back to the current title, which should be valid.
            setUpdateError(undefined);
            if (updatedTitleFromPubsub && updatedTitleFromPubsub !== currentTitle) {
                updateCache(updatedTitleFromPubsub);
                setUpdatedTitleFromPubsub(undefined);
            }
            if (!isProcessingTitleUpdate.current) return true;
        }
        try {
            const response = await updateContentTitle({
                variables: {
                    contentId: contentId,
                    title: value_0
                }
            });
            return Boolean(response.data?.updateTitle);
        } catch  {
            // error handled by useMutation result updateError
            return false;
        }
    }, [
        contentId,
        currentTitle,
        updateCache,
        updateContentTitle,
        updatedTitleFromPubsub
    ]);
    /**
   * The following section is a mutation queue to ensure that title updates are processed sequentially and that the
   * latest title is always the one that gets applied.
   * This is important because multiple title updates can be triggered in quick succession when AI inline streaming
   * occurs and we want to avoid stale state errors from the GQL store, but also ensure the latest title is the one that
   * gets applied.
   */ const latestQueuedTitleUpdate = (0, $cozmU.useRef)();
    const processQueue = (0, $cozmU.useCallback)(async ()=>{
        if (isProcessingTitleUpdate.current) return;
        isProcessingTitleUpdate.current = true;
        try {
            let nextUpdate = latestQueuedTitleUpdate.current;
            latestQueuedTitleUpdate.current = undefined;
            // We keep updating the title until there are no more titles in the cache
            while(nextUpdate !== undefined){
                const result = await updateTitle(nextUpdate.title);
                nextUpdate.resolve?.(result);
                nextUpdate = latestQueuedTitleUpdate.current;
                latestQueuedTitleUpdate.current = undefined;
            }
        } finally{
            isProcessingTitleUpdate.current = false;
        }
    }, [
        updateTitle
    ]);
    const enqueueTitle = (0, $cozmU.useCallback)(async (title)=>{
        latestQueuedTitleUpdate.current?.resolve?.(false);
        latestQueuedTitleUpdate.current = {
            title: title
        };
        if (!isProcessingTitleUpdate.current) await processQueue();
    }, [
        processQueue
    ]);
    // Fire-and-forget wrapper for the non-gated path. The underlying `updateTitle`
    // returns the mutation outcome but no public caller branches on it, so erase
    // the boolean here to keep the public type honest.
    const updateTitleVoid = (0, $cozmU.useCallback)(async (value_1)=>{
        await updateTitle(value_1);
    }, [
        updateTitle
    ]);
    const enqueueTitleAndWait = (0, $cozmU.useCallback)(async (title_0)=>{
        // Resolving the previous queued update as false means it was superseded, not that the BE mutation failed.
        latestQueuedTitleUpdate.current?.resolve?.(false);
        const result = new Promise((resolve)=>{
            latestQueuedTitleUpdate.current = {
                title: title_0,
                resolve: resolve
            };
        });
        if (!isProcessingTitleUpdate.current) processQueue();
        return result;
    }, [
        processQueue
    ]);
    // Set the title change handler when the component mounts
    // Content types use this method to update the title from within the iframe
    (0, $cozmU.useEffect)(()=>{
        (0, $cgpF0.contentTypesTitleServiceSingleton).setTitleChangeHandler(updateTitle);
        return ()=>{
            (0, $cgpF0.contentTypesTitleServiceSingleton).setTitleChangeHandler(()=>{});
        };
    }, [
        updateTitle
    ]);
    return {
        isEditing: isEditing,
        setIsEditing: setIsEditing,
        setUpdatedTitleFromPubsub: setUpdatedTitleFromPubsub,
        updateLoading: updateLoading,
        updateError: updateError,
        updateTitle: (0, $9wGTI.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? enqueueTitle : updateTitleVoid,
        updateTitleAndWait: (0, $9wGTI.fg)('platform_editor_ai_aifc_patch_ga_blockers') ? enqueueTitleAndWait : updateTitle,
        updateCache: updateCache
    };
};
module.exports["useContentTypesTitleUpdate"] = $563fbe27571904a7$export$57b25de3525e313f;

});

parcelRegister("cXQmG", function(module, exports) {
/**
 * @generated SignedSource<<aec625eb8d10dac10d8b75f45f93e968>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d6b675ba61ab7de1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useContentTypesTitleUpdateContentTitleWriteFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "title"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "__typename"
        }
    ],
    "type": "Content"
};
$d6b675ba61ab7de1$var$node.hash = "3d624df929b7f5b6bedfdab8b98fb427";
var $d6b675ba61ab7de1$export$2e2bcd8739ae039 = $d6b675ba61ab7de1$var$node;
module.exports["default"] = $d6b675ba61ab7de1$export$2e2bcd8739ae039;

});

parcelRegister("7gy2b", function(module, exports) {
/**
 * @generated SignedSource<<5d2bbc80e1c6738ea6a17dcaad56e8d9>>
 * @relayHash d1c5670c44e9f8fc9ac768758d436087
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8e8353d3ad0b3fc7ac6fe01393daf5d0934740f4bc4ac7fb665f4815b9daf79c
const $2064637d3d8753f2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "title"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "title",
                    "variableName": "title"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "updateTitle",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentTypesTitleUpdateContentTitleMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentTypesTitleUpdateContentTitleMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "d1c5670c44e9f8fc9ac768758d436087",
            "id": "8e8353d3ad0b3fc7ac6fe01393daf5d0934740f4bc4ac7fb665f4815b9daf79c",
            "metadata": {},
            "name": "useContentTypesTitleUpdateContentTitleMutation",
            "operationKind": "mutation",
            "text": "mutation useContentTypesTitleUpdateContentTitleMutation($contentId:ID!,$title:String){updateTitle(contentId:$contentId,title:$title){id,title,links{editui,webui}}}"
        }
    };
}();
$2064637d3d8753f2$var$node.hash = "8c498978fbdcfa01faf33b30473c33ec";
var $2064637d3d8753f2$export$2e2bcd8739ae039 = $2064637d3d8753f2$var$node;
module.exports["default"] = $2064637d3d8753f2$export$2e2bcd8739ae039;

});

parcelRegister("cgpF0", function(module, exports) {
class $ef2bdef46a40b8c0$export$b44304baa0bf4e7b {
    updateTitle(title) {
        this.titleChangeHandler(title);
    }
    setTitleChangeHandler(cb) {
        this.titleChangeHandler = cb;
    }
    constructor(){
        this.titleChangeHandler = void 0;
        this.titleChangeHandler = ()=>{};
    }
}
const $ef2bdef46a40b8c0$export$6450770420296206 = new $ef2bdef46a40b8c0$export$b44304baa0bf4e7b();
module.exports["contentTypesTitleServiceSingleton"] = $ef2bdef46a40b8c0$export$6450770420296206;

});

parcelRegister("1B6Lx", function(module, exports) {

var $hm7Pp = parcelRequire("hm7Pp");


var $fgrom = parcelRequire("fgrom");


var $1dRHU = parcelRequire("1dRHU");


var $ej7SU = parcelRequire("ej7SU");


var $cozmU = parcelRequire("cozmU");


var $fFmJj = parcelRequire("fFmJj");


var $ij4CE = parcelRequire("ij4CE");


var $bQm3c = parcelRequire("bQm3c");








var $ep3mz = parcelRequire("ep3mz");


var $de2j9 = parcelRequire("de2j9");

const $42cdb37fcd4a7f68$export$751dd0cb1bbd0638 = ()=>{
    const readLastEditedDraftVersionFragmentFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $ej7SU.default),
        __callerPackage__: "content-types-utils"
    });
    const readLastEditedVersionFragmentFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $1dRHU.default),
        __callerPackage__: "content-types-utils"
    });
    const writeLastEditedDraftVersionFragmentFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $fgrom.default),
        fragmentArtifact: (0, $fgrom.default),
        __callerPackage__: "content-types-utils"
    });
    const writeLastEditedVersionFragmentFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $hm7Pp.default),
        fragmentArtifact: (0, $hm7Pp.default),
        __callerPackage__: "content-types-utils"
    });
    const { displayName: displayName } = (0, $bQm3c.useSessionData)();
    const [currentPageContentId] = (0, $ep3mz.usePageContentId)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const updateTimestampCache = ({ contentId: contentId })=>{
        const newWhen = new Date().toISOString();
        const isEditingThisContent = isOnEditRoute && contentId === currentPageContentId;
        const id = `$Content:${contentId}.${isEditingThisContent ? 'draftVersion' : 'version'}`;
        let prevTypename = 'KnownUser';
        try {
            const readFragmentInterop = isEditingThisContent ? readLastEditedDraftVersionFragmentFragmentInterop : readLastEditedVersionFragmentFragmentInterop;
            const prevCache = readFragmentInterop({
                id: id
            });
            if (prevCache?.by?.__typename) prevTypename = prevCache.by.__typename;
        } catch  {
        // silently fallback to default typename "KnownUser"
        }
        try {
            const writeFragmentInterop = isEditingThisContent ? writeLastEditedDraftVersionFragmentFragmentInterop : writeLastEditedVersionFragmentFragmentInterop;
            writeFragmentInterop({
                fragmentId: id,
                data: {
                    by: {
                        displayName: displayName,
                        __typename: prevTypename
                    },
                    when: newWhen,
                    __typename: 'Version'
                }
            });
        } catch  {
        // silently fail write to cache
        }
    };
    const updateTimestampCacheWithCallback = (0, $cozmU.useCallback)(updateTimestampCache, [
        currentPageContentId,
        isOnEditRoute,
        displayName,
        readLastEditedDraftVersionFragmentFragmentInterop,
        readLastEditedVersionFragmentFragmentInterop,
        writeLastEditedDraftVersionFragmentFragmentInterop,
        writeLastEditedVersionFragmentFragmentInterop
    ]);
    return updateTimestampCacheWithCallback;
};
module.exports["useUpdateLastEditedTimestampVersionCache"] = $42cdb37fcd4a7f68$export$751dd0cb1bbd0638;

});

parcelRegister("hm7Pp", function(module, exports) {
/**
 * @generated SignedSource<<4c861bd06806240d51e12f7f085d0825>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $03557d594dff4afc$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useUpdateLastEditedTimestampVersionCacheLastEditedVersionWriteFragment",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ],
    "type": "Version"
};
$03557d594dff4afc$var$node.hash = "c18ed3f2e877d3ca1cd623e5a0859ba4";
var $03557d594dff4afc$export$2e2bcd8739ae039 = $03557d594dff4afc$var$node;
module.exports["default"] = $03557d594dff4afc$export$2e2bcd8739ae039;

});

parcelRegister("fgrom", function(module, exports) {
/**
 * @generated SignedSource<<80c5c7a474f99fd1ce0dcfa37ed63a6d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $61389ca52d0a73e1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useUpdateLastEditedTimestampVersionCacheLastEditedDraftVersionWriteFragment",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ],
    "type": "Version"
};
$61389ca52d0a73e1$var$node.hash = "f2546d473e081d7f407ad1cb2c10a7c2";
var $61389ca52d0a73e1$export$2e2bcd8739ae039 = $61389ca52d0a73e1$var$node;
module.exports["default"] = $61389ca52d0a73e1$export$2e2bcd8739ae039;

});

parcelRegister("1dRHU", function(module, exports) {
/**
 * @generated SignedSource<<9c87c26246d4536040dd79e5c847aea5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $342531e247c7cf4b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useUpdateLastEditedTimestampVersionCacheLastEditedVersionReadFragment",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ],
    "type": "Version"
};
$342531e247c7cf4b$var$node.hash = "e1d2099945c80fbb0be34791a561397b";
var $342531e247c7cf4b$export$2e2bcd8739ae039 = $342531e247c7cf4b$var$node;
module.exports["default"] = $342531e247c7cf4b$export$2e2bcd8739ae039;

});

parcelRegister("ej7SU", function(module, exports) {
/**
 * @generated SignedSource<<56e47737c7339d2b755b2c7c5677fdf4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4982d7036fccc1ba$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useUpdateLastEditedTimestampVersionCacheLastEditedDraftVersionReadFragment",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "when"
        }
    ],
    "type": "Version"
};
$4982d7036fccc1ba$var$node.hash = "52ad41feb7c48850dc9ff2da1dd55879";
var $4982d7036fccc1ba$export$2e2bcd8739ae039 = $4982d7036fccc1ba$var$node;
module.exports["default"] = $4982d7036fccc1ba$export$2e2bcd8739ae039;

});

parcelRegister("14ugT", function(module, exports) {

var $at96P = parcelRequire("at96P");


var $iEC7X = parcelRequire("iEC7X");


var $lwpIT = parcelRequire("lwpIT");


var $3om4W = parcelRequire("3om4W");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $7aRa9 = parcelRequire("7aRa9");


var $irVI7 = parcelRequire("irVI7");


var $3XjWl = parcelRequire("3XjWl");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");

parcelRequire("8nle6");
var $jLyos = parcelRequire("jLyos");

const $20ab76b3ff88654d$var$MOVE_TO_PERSONAL_SPACE_FLAG_ID = 'move-to-personal-space-flag';
// All global create dropdown flows share this prefix in their `source` URL param.
const $20ab76b3ff88654d$var$GLOBAL_CREATE_DROPDOWN_PREFIX = 'globalCreateDropdown';
/**
 * Returns the create experience name for the given content type.
 * Each content type has its own tracked experience during creation.
 */ function $20ab76b3ff88654d$var$getCreateExperienceName(contentType) {
    switch(contentType){
        case 'page':
        case 'blogpost':
            return 0, $irVI7.CREATE_PAGE_EXPERIENCE;
        case 'whiteboard':
            return 0, $irVI7.CREATE_WHITEBOARD_EXPERIENCE;
        case 'database':
            return 0, $irVI7.CREATE_DATABASE_EXPERIENCE;
        default:
            return '';
    }
}
function $20ab76b3ff88654d$var$getPostMoveUrl(contentType, spaceKey, contentId, isLivePage = false) {
    if (isLivePage) return (0, $1NBp8.VIEW_PAGE).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    });
    switch(contentType){
        case 'blogpost':
            return (0, $1NBp8.EDIT_BLOG_V2).toUrl({
                spaceKey: spaceKey,
                contentType: 'blog',
                contentId: contentId
            });
        case 'whiteboard':
            return (0, $1NBp8.WHITEBOARD_BOARD).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'database':
            return (0, $1NBp8.DATABASE_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        default:
            return (0, $1NBp8.EDIT_PAGE_V2).toUrl({
                spaceKey: spaceKey,
                contentType: 'pages',
                contentId: contentId
            });
    }
}
// Module-level set to track which contentIds have already shown the flag this session.
// Prevents re-showing after component remounts (e.g. navigation away and back).
// Resets on full page refresh — same lifecycle as the experience tracker state.
const $20ab76b3ff88654d$var$shownContentIds = new Set();
const $20ab76b3ff88654d$export$907f7ef55acee39a = $20ab76b3ff88654d$var$shownContentIds;
/**
 * Returns an ICU select key for the given content type.
 * Used as the {contentType} variable in i18n messages that use ICU select syntax
 * so translators can provide locale-specific labels for each content type.
 */ function $20ab76b3ff88654d$var$getContentTypeKey(contentType, isLivePage) {
    if (isLivePage) return 'liveDoc';
    switch(contentType){
        case 'page':
            return 'page';
        case 'blogpost':
            return 'blog';
        case 'whiteboard':
            return 'whiteboard';
        case 'database':
            return 'database';
        default:
            return 'other';
    }
}
const $20ab76b3ff88654d$var$i18nMessages = (0, $kSwu1.defineMessages)({
    flagTitle: {
        id: "content-types-utils.move-to-personal-space-flag.title",
        defaultMessage: "Do you want to move this to your own space?"
    },
    flagDescription: {
        id: "content-types-utils.move-to-personal-space-flag.description",
        defaultMessage: "This {contentType, select, page {page} blog {blog} whiteboard {whiteboard} database {database} liveDoc {live doc} other {content}} was created in a shared space. You can move it to your personal space instead."
    },
    moveAction: {
        id: "content-types-utils.move-to-personal-space-flag.move-action",
        defaultMessage: "Move to my space"
    },
    keepAction: {
        id: "content-types-utils.move-to-personal-space-flag.keep-action",
        defaultMessage: "Keep here"
    },
    moveSuccessTitle: {
        id: "content-types-utils.move-to-personal-space-flag.move-success-title",
        defaultMessage: "{contentType, select, page {Page} blog {Blog} whiteboard {Whiteboard} database {Database} liveDoc {Live doc} other {Content}} moved to your space"
    },
    moveErrorTitle: {
        id: "content-types-utils.move-to-personal-space-flag.move-error-title",
        defaultMessage: "Couldn't move {contentType, select, page {page} blog {blog} whiteboard {whiteboard} database {database} liveDoc {live doc} other {content}}"
    },
    moveErrorDescription: {
        id: "content-types-utils.move-to-personal-space-flag.move-error-description",
        defaultMessage: "Something went wrong. Please try moving it manually."
    }
});
const $20ab76b3ff88654d$var$MOVE_PAGE_APPEND_MUTATION = (0, $3om4W.default);
const $20ab76b3ff88654d$var$MOVE_PAGE_TOP_LEVEL_MUTATION = (0, $lwpIT.default);
const $20ab76b3ff88654d$var$MOVE_BLOG_MUTATION = (0, $iEC7X.default);
const $20ab76b3ff88654d$var$SPACE_HOMEPAGE_QUERY = (0, $at96P.default);
const $20ab76b3ff88654d$var$MoveToPersonalSpaceFlagTriggerComponent = ({ contentId: contentId, contentType: contentType, isLivePage: isLivePage, spaceKey: spaceKey, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const contentTypeKey = $20ab76b3ff88654d$var$getContentTypeKey(contentType, isLivePage);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const createExperienceName = $20ab76b3ff88654d$var$getCreateExperienceName(contentType);
    const createExperienceState = (0, $3XjWl.useExperienceState)(createExperienceName);
    // True if content was just created via the global create dropdown and the experience
    // has not failed or been aborted. Excludes page tree and space-level contextual creates.
    // Note: for pages/blogs the experience stops with taskSuccess before the editor mounts,
    // so we allow taskSuccess stops and only guard against taskFail and taskAbort.
    const isNewlyGloballyCreated = !!createExperienceState && createExperienceState.stopState !== 'taskFail' && createExperienceState.stopState !== 'taskAbort' && createExperienceState.attributes?.flow?.startsWith($20ab76b3ff88654d$var$GLOBAL_CREATE_DROPDOWN_PREFIX);
    // Re-use the preloaded personal space query — this data is preloaded during
    // preloadHomeRoute so it should be available in cache instantly.
    // Skip the query entirely when the page is not newly created to avoid
    // unnecessary network requests on regular page visits.
    const { data: personalSpaceDetailsData, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $jLyos.preloadPersonalSpaceDetailsQuery), {
        skip: !isNewlyGloballyCreated,
        __callerPackage__: "content-types-utils"
    });
    // If the user has a personal space, space will be non-null with a key and id.
    // If personal spaces are disabled or user hasn't created one, space will be null.
    const personalSpaceKey = personalSpaceDetailsData?.user?.confluence?.space?.key ?? null;
    const personalSpaceId = personalSpaceDetailsData?.user?.confluence?.space?.id ?? null;
    const hasPersonalSpace = personalSpaceKey !== null && personalSpaceId !== null;
    // Fetch the homepage (overview) page of the user's personal space so we can
    // move the content under it instead of at the space root level
    const { data: homepageData, loading: homepageLoading } = (0, $jMyy4.useQueryInterop)($20ab76b3ff88654d$var$SPACE_HOMEPAGE_QUERY, {
        variables: {
            spaceKey: personalSpaceKey || ''
        },
        skip: !isNewlyGloballyCreated || !hasPersonalSpace,
        __callerPackage__: "content-types-utils"
    });
    const personalSpaceHomepageId = homepageData?.space?.homepage?.id ?? null;
    const [movePageAppend] = (0, $308Wd.useMutationInterop)($20ab76b3ff88654d$var$MOVE_PAGE_APPEND_MUTATION, {
        __callerPackage__: "content-types-utils"
    });
    const [movePageTopLevel] = (0, $308Wd.useMutationInterop)($20ab76b3ff88654d$var$MOVE_PAGE_TOP_LEVEL_MUTATION, {
        __callerPackage__: "content-types-utils"
    });
    const [moveBlog] = (0, $308Wd.useMutationInterop)($20ab76b3ff88654d$var$MOVE_BLOG_MUTATION, {
        __callerPackage__: "content-types-utils"
    });
    // Use refs to avoid stale closures in flag action callbacks
    const personalSpaceKeyRef = (0, $cozmU.useRef)(personalSpaceKey);
    personalSpaceKeyRef.current = personalSpaceKey;
    const personalSpaceIdRef = (0, $cozmU.useRef)(personalSpaceId);
    personalSpaceIdRef.current = personalSpaceId;
    const personalSpaceHomepageIdRef = (0, $cozmU.useRef)(personalSpaceHomepageId);
    personalSpaceHomepageIdRef.current = personalSpaceHomepageId;
    const moveContent = (0, $cozmU.useCallback)(async ()=>{
        const homepageId = personalSpaceHomepageIdRef.current;
        const targetSpaceId = personalSpaceIdRef.current;
        const targetSpaceKey = personalSpaceKeyRef.current;
        switch(contentType){
            case 'blogpost':
                {
                    if (!targetSpaceId) return null;
                    // blogPostId and spaceId are typed as Long! but come as strings — cast as any
                    // to match the pattern used in MoveBlogModal
                    const moveBlogResult = await moveBlog({
                        variables: {
                            blogPostId: contentId,
                            spaceId: targetSpaceId
                        }
                    });
                    return moveBlogResult?.data?.moveBlog?.content?.id ?? null;
                }
            case 'database':
            case 'whiteboard':
            case 'page':
                {
                    if (homepageId) {
                        // Move under the overview/homepage page if it exists
                        const movePageAppendResult = await movePageAppend({
                            variables: {
                                pageId: contentId,
                                parentId: homepageId
                            }
                        });
                        return movePageAppendResult?.data?.movePageAppend?.page?.id ?? null;
                    }
                    if (!targetSpaceKey) return null;
                    // Fall back to top-level move if no homepage exists
                    const movePageTopLevelResult = await movePageTopLevel({
                        variables: {
                            pageId: contentId,
                            spaceKey: targetSpaceKey
                        }
                    });
                    return movePageTopLevelResult?.data?.movePageTopLevel?.page?.id ?? null;
                }
            default:
                return null;
        }
    }, [
        contentType,
        contentId,
        moveBlog,
        movePageAppend,
        movePageTopLevel
    ]);
    const handleMoveToPersonalSpace = (0, $cozmU.useCallback)(async ()=>{
        const targetSpaceKey = personalSpaceKeyRef.current;
        flags.hideFlag($20ab76b3ff88654d$var$MOVE_TO_PERSONAL_SPACE_FLAG_ID);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'moveToPersonalSpaceConfirm',
                source: 'moveToPersonalSpaceFlag',
                attributes: {
                    contentId: contentId,
                    createdInSpaceKey: spaceKey,
                    targetSpaceKey: targetSpaceKey
                }
            }
        }).fire();
        try {
            const movedPageId = await moveContent();
            if (!movedPageId || !targetSpaceKey) throw new Error('Missing move result or target space key');
            flags.showSuccessFlag({
                id: 'move-to-personal-space-success-flag',
                title: formatMessage($20ab76b3ff88654d$var$i18nMessages.moveSuccessTitle, {
                    contentType: contentTypeKey
                }),
                isAutoDismiss: true
            });
            push($20ab76b3ff88654d$var$getPostMoveUrl(contentType, targetSpaceKey, movedPageId, isLivePage));
        } catch  {
            flags.showErrorFlag({
                id: 'move-to-personal-space-error-flag',
                title: formatMessage($20ab76b3ff88654d$var$i18nMessages.moveErrorTitle, {
                    contentType: contentTypeKey
                }),
                description: formatMessage($20ab76b3ff88654d$var$i18nMessages.moveErrorDescription),
                isAutoDismiss: true
            });
        }
    }, [
        flags,
        formatMessage,
        createAnalyticsEvent,
        moveContent,
        push,
        contentId,
        spaceKey,
        contentType,
        isLivePage,
        contentTypeKey
    ]);
    const handleKeepHere = (0, $cozmU.useCallback)(()=>{
        flags.hideFlag($20ab76b3ff88654d$var$MOVE_TO_PERSONAL_SPACE_FLAG_ID);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'moveToPersonalSpaceDismiss',
                source: 'moveToPersonalSpaceFlag',
                attributes: {
                    contentId: contentId,
                    createdInSpaceKey: spaceKey
                }
            }
        }).fire();
    }, [
        flags,
        createAnalyticsEvent,
        contentId,
        spaceKey
    ]);
    const showFlag = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'moveToPersonalSpaceFlagScreen',
                attributes: {
                    contentId: contentId,
                    createdInSpaceKey: spaceKey
                }
            }
        }).fire();
        flags.showInfoFlag({
            id: $20ab76b3ff88654d$var$MOVE_TO_PERSONAL_SPACE_FLAG_ID,
            title: formatMessage($20ab76b3ff88654d$var$i18nMessages.flagTitle),
            description: formatMessage($20ab76b3ff88654d$var$i18nMessages.flagDescription, {
                contentType: contentTypeKey
            }),
            actions: [
                {
                    content: formatMessage($20ab76b3ff88654d$var$i18nMessages.moveAction),
                    onClick: handleMoveToPersonalSpace
                },
                {
                    content: formatMessage($20ab76b3ff88654d$var$i18nMessages.keepAction),
                    onClick: handleKeepHere
                }
            ]
        });
    }, [
        flags,
        formatMessage,
        createAnalyticsEvent,
        contentId,
        spaceKey,
        handleMoveToPersonalSpace,
        handleKeepHere,
        contentTypeKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Only trigger for newly created pages, and wait for all data to be ready
        if (!isNewlyGloballyCreated || loading || homepageLoading || !contentId || !spaceKey) return;
        // Don't show duplicate flags for the same contentId (survives remounts via module-level Set)
        if ($20ab76b3ff88654d$var$shownContentIds.has(contentId)) return;
        // Don't show if user doesn't have a personal space (personal spaces disabled)
        if (!hasPersonalSpace) return;
        // Don't show if content was created in a personal space (starts with ~)
        if (spaceKey.startsWith('~')) return;
        // Don't show if content was created in the user's personal space
        if (spaceKey === personalSpaceKey) return;
        $20ab76b3ff88654d$var$shownContentIds.add(contentId);
        showFlag();
    }, [
        isNewlyGloballyCreated,
        loading,
        homepageLoading,
        contentId,
        spaceKey,
        hasPersonalSpace,
        personalSpaceKey,
        showFlag
    ]);
    return null;
};
const $20ab76b3ff88654d$export$f3508a833a19ce8c = (0, $7aRa9.withFlags)($20ab76b3ff88654d$var$MoveToPersonalSpaceFlagTriggerComponent);
module.exports["MoveToPersonalSpaceFlagTrigger"] = $20ab76b3ff88654d$export$f3508a833a19ce8c;

});

parcelRegister("at96P", function(module, exports) {
/**
 * @generated SignedSource<<b42c4ce52850ad7f68110f1fa523d1dd>>
 * @relayHash 4b5e9dde5572ad2b72b3d90ce64b430b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 39a3fc8907cb86d55c6ae136031c14763a4ab02065d1f2219030a30119b932af
const $4fa5689684608def$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "spaceKey"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "homepage",
        "plural": false,
        "selections": [
            v2 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MoveToPersonalSpaceFlagTriggerSpaceHomepageQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MoveToPersonalSpaceFlagTriggerSpaceHomepageQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "4b5e9dde5572ad2b72b3d90ce64b430b",
            "id": "39a3fc8907cb86d55c6ae136031c14763a4ab02065d1f2219030a30119b932af",
            "metadata": {},
            "name": "MoveToPersonalSpaceFlagTriggerSpaceHomepageQuery",
            "operationKind": "query",
            "text": "query MoveToPersonalSpaceFlagTriggerSpaceHomepageQuery($spaceKey:String!){space(key:$spaceKey){homepage{id},id}}"
        }
    };
}();
$4fa5689684608def$var$node.hash = "b2693b9e2134a1e0b43171db1726ae37";
var $4fa5689684608def$export$2e2bcd8739ae039 = $4fa5689684608def$var$node;
module.exports["default"] = $4fa5689684608def$export$2e2bcd8739ae039;

});

parcelRegister("iEC7X", function(module, exports) {
/**
 * @generated SignedSource<<672861edb3a467c47872f4baad3d71aa>>
 * @relayHash a681ca4341eb62abd94f1e002744692a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8f19dca02a8c6c08d36848966e224cc2b9ece80fd54f2c467d2e7b7657bc7699
const $f919ec06c3c52f3b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "blogPostId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceId"
        }
    ], v1 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "blogPostId",
                    "variableName": "blogPostId"
                },
                {
                    "kind": "Variable",
                    "name": "targetSpaceId",
                    "variableName": "spaceId"
                }
            ],
            "kind": "ObjectValue",
            "name": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "key"
    }, v4 = {
        "kind": "ScalarField",
        "name": "alias"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MoveToPersonalSpaceFlagTriggerMoveBlogMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "MoveBlogPayload",
                    "kind": "LinkedField",
                    "name": "moveBlog",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MoveToPersonalSpaceFlagTriggerMoveBlogMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "MoveBlogPayload",
                    "kind": "LinkedField",
                    "name": "moveBlog",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v2 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "a681ca4341eb62abd94f1e002744692a",
            "id": "8f19dca02a8c6c08d36848966e224cc2b9ece80fd54f2c467d2e7b7657bc7699",
            "metadata": {},
            "name": "MoveToPersonalSpaceFlagTriggerMoveBlogMutation",
            "operationKind": "mutation",
            "text": "mutation MoveToPersonalSpaceFlagTriggerMoveBlogMutation($blogPostId:Long!,$spaceId:Long!){moveBlog(input:{blogPostId:$blogPostId,targetSpaceId:$spaceId}){content{id,space{key,alias,id}}}}"
        }
    };
}();
$f919ec06c3c52f3b$var$node.hash = "93b9a44f4c2595f8a579191b1566d4aa";
var $f919ec06c3c52f3b$export$2e2bcd8739ae039 = $f919ec06c3c52f3b$var$node;
module.exports["default"] = $f919ec06c3c52f3b$export$2e2bcd8739ae039;

});

parcelRegister("lwpIT", function(module, exports) {
/**
 * @generated SignedSource<<8b35d407107d9e66f8970cba2a730460>>
 * @relayHash f7117689bdd81ee360f2b94043895ce4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3b2d43333b298e4930cccff4151dc09b53b23a75941daf6c976d142b379957e2
const $92d8d4dd49e2504c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "pageId"
                        },
                        {
                            "kind": "Variable",
                            "name": "targetSpaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "MovePagePayload",
            "kind": "LinkedField",
            "name": "movePageTopLevel",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Page",
                    "kind": "LinkedField",
                    "name": "page",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MoveToPersonalSpaceFlagTriggerMovePageTopLevelMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MoveToPersonalSpaceFlagTriggerMovePageTopLevelMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f7117689bdd81ee360f2b94043895ce4",
            "id": "3b2d43333b298e4930cccff4151dc09b53b23a75941daf6c976d142b379957e2",
            "metadata": {},
            "name": "MoveToPersonalSpaceFlagTriggerMovePageTopLevelMutation",
            "operationKind": "mutation",
            "text": "mutation MoveToPersonalSpaceFlagTriggerMovePageTopLevelMutation($pageId:ID!,$spaceKey:String!){movePageTopLevel(input:{pageId:$pageId,targetSpaceKey:$spaceKey}){page{id}}}"
        }
    };
}();
$92d8d4dd49e2504c$var$node.hash = "55c2c510926003ccb21aa81ad404b906";
var $92d8d4dd49e2504c$export$2e2bcd8739ae039 = $92d8d4dd49e2504c$var$node;
module.exports["default"] = $92d8d4dd49e2504c$export$2e2bcd8739ae039;

});

parcelRegister("3om4W", function(module, exports) {
/**
 * @generated SignedSource<<b29115b5530334b993269e1e849520a1>>
 * @relayHash af579b7ccd18225f53e0ba7e5997759c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a304af1dcdc7cca397f23a09fa40f823a65f467687010593a4d8d90c922bb448
const $4e5e2421f46e2759$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "parentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "pageId"
                        },
                        {
                            "kind": "Variable",
                            "name": "parentId",
                            "variableName": "parentId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "MovePagePayload",
            "kind": "LinkedField",
            "name": "movePageAppend",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Page",
                    "kind": "LinkedField",
                    "name": "page",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MoveToPersonalSpaceFlagTriggerMovePageAppendMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MoveToPersonalSpaceFlagTriggerMovePageAppendMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "af579b7ccd18225f53e0ba7e5997759c",
            "id": "a304af1dcdc7cca397f23a09fa40f823a65f467687010593a4d8d90c922bb448",
            "metadata": {},
            "name": "MoveToPersonalSpaceFlagTriggerMovePageAppendMutation",
            "operationKind": "mutation",
            "text": "mutation MoveToPersonalSpaceFlagTriggerMovePageAppendMutation($pageId:ID!,$parentId:ID!){movePageAppend(input:{pageId:$pageId,parentId:$parentId}){page{id}}}"
        }
    };
}();
$4e5e2421f46e2759$var$node.hash = "79cbc17b214968c2ed046eeef92a15d0";
var $4e5e2421f46e2759$export$2e2bcd8739ae039 = $4e5e2421f46e2759$var$node;
module.exports["default"] = $4e5e2421f46e2759$export$2e2bcd8739ae039;

});

parcelRegister("3XjWl", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

const $a5d6810b007644fc$export$4a4fb33de7d01f75 = (experienceName)=>{
    const $ = (0, $bDgLe.c)(7);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t0;
    if ($[0] !== experienceName || $[1] !== experienceTracker) {
        t0 = experienceTracker.getExperienceState(experienceName);
        $[0] = experienceName;
        $[1] = experienceTracker;
        $[2] = t0;
    } else t0 = $[2];
    const [experienceState, setExperienceState] = (0, $cozmU.useState)(t0);
    let t1;
    let t2;
    if ($[3] !== experienceName || $[4] !== experienceTracker) {
        t1 = ()=>experienceTracker.subscribe((e)=>{
                if (e.name === experienceName) setExperienceState(experienceTracker.getExperienceState(experienceName));
            });
        t2 = [
            experienceName,
            experienceTracker
        ];
        $[3] = experienceName;
        $[4] = experienceTracker;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return experienceState;
};
module.exports["useExperienceState"] = $a5d6810b007644fc$export$4a4fb33de7d01f75;

});

parcelRegister("8nle6", function(module, exports) {
$parcel$export(module.exports, "preloadSpaceDetail", () => (parcelRequire("5SzHz")).preloadSpaceDetail);
$parcel$export(module.exports, "preloadPersonalSpaceDetail", () => (parcelRequire("jLyos")).preloadPersonalSpaceDetail);
$parcel$export(module.exports, "preloadPersonalSpaceDetailsQuery", () => (parcelRequire("jLyos")).preloadPersonalSpaceDetailsQuery);
$parcel$export(module.exports, "ConfluenceSpaceType", () => (parcelRequire("bgmQP")).ConfluenceSpaceType);

var $jmjWc = parcelRequire("jmjWc");


var $5SzHz = parcelRequire("5SzHz");


var $jLyos = parcelRequire("jLyos");


var $bgmQP = parcelRequire("bgmQP");


const $b92195a33e0fb686$export$f10aab7c26f92d55 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7NksR",
    name: "SpaceTargetSelect",
    loader: async ()=>(await Promise.resolve((parcelRequire("bgmQP")))).SpaceTargetSelect
});
module.exports["SpaceTargetSelect"] = $b92195a33e0fb686$export$f10aab7c26f92d55;

});

parcelRegister("5SzHz", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $4ZxLt = parcelRequire("4ZxLt");

const $01831239f93415a0$var$getEmptyResult = ()=>Promise.resolve({
        data: null,
        loading: false,
        error: null
    });
const $01831239f93415a0$export$ec3af86ec6a1dfc6 = async (spaceKey = '', { includeSpaceTypeSettings: includeSpaceTypeSettings = false } = {})=>{
    if (spaceKey) return (0, $dYU3e.query)({
        query: (0, $4ZxLt.default),
        variables: {
            spaceKey: spaceKey,
            includeSpaceTypeSettings: includeSpaceTypeSettings
        },
        __callerPackage__: "space-utils"
    });
    return $01831239f93415a0$var$getEmptyResult();
};
const $01831239f93415a0$export$2403e25f29f92c16 = async (spaceKey = '', options)=>{
    return $01831239f93415a0$export$ec3af86ec6a1dfc6(spaceKey, options);
};
module.exports["fetchSpaceDetail"] = $01831239f93415a0$export$ec3af86ec6a1dfc6;
module.exports["preloadSpaceDetail"] = $01831239f93415a0$export$2403e25f29f92c16;

});

parcelRegister("4ZxLt", function(module, exports) {
/**
 * @generated SignedSource<<76836bee9d3181bb32ece1357a68e03f>>
 * @relayHash 8503b5ca122c8b61cd10af1b1c2004c9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c7b8d2b5f3c58e629f5312f857084ff8cca4d4f415ebf6ae267632bf35e1a6b
const $cc63beb8a5381fdf$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeSpaceTypeSettings"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "dataClassificationTags"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "condition": "includeSpaceTypeSettings",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "SpaceTypeSettings",
                            "kind": "LinkedField",
                            "name": "spaceTypeSettings",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "EnabledContentTypes",
                                    "kind": "LinkedField",
                                    "name": "enabledContentTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isLivePagesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isWhiteboardsEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDatabasesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isSlidesEnabled"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSpaceDetailQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSpaceDetailQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "8503b5ca122c8b61cd10af1b1c2004c9",
            "id": "3c7b8d2b5f3c58e629f5312f857084ff8cca4d4f415ebf6ae267632bf35e1a6b",
            "metadata": {},
            "name": "useSpaceDetailQuery",
            "operationKind": "query",
            "text": "query useSpaceDetailQuery($spaceKey:String,$includeSpaceTypeSettings:Boolean!){space(key:$spaceKey){id,name,alias,key,type,dataClassificationTags,homepage{id,title,type},icon{path},spaceTypeSettings@include(if:$includeSpaceTypeSettings){enabledContentTypes{isLivePagesEnabled,isWhiteboardsEnabled,isDatabasesEnabled,isSlidesEnabled}}}}"
        }
    };
}();
$cc63beb8a5381fdf$var$node.hash = "591d4790bc30ed0352bb44ad552d45cb";
var $cc63beb8a5381fdf$export$2e2bcd8739ae039 = $cc63beb8a5381fdf$var$node;
module.exports["default"] = $cc63beb8a5381fdf$export$2e2bcd8739ae039;

});

parcelRegister("jLyos", function(module, exports) {

var $a2WOL = parcelRequire("a2WOL");


var $dYU3e = parcelRequire("dYU3e");

const $51133d1487ddd8f7$export$945871a9cdda3d0b = (0, $a2WOL.default);
const $51133d1487ddd8f7$export$88da34a67bdae7e0 = ()=>{
    return (0, $dYU3e.query)({
        query: $51133d1487ddd8f7$export$945871a9cdda3d0b,
        __callerPackage__: "space-utils"
    });
};
module.exports["preloadPersonalSpaceDetailsQuery"] = $51133d1487ddd8f7$export$945871a9cdda3d0b;
module.exports["preloadPersonalSpaceDetail"] = $51133d1487ddd8f7$export$88da34a67bdae7e0;

});

parcelRegister("a2WOL", function(module, exports) {
/**
 * @generated SignedSource<<99c90ef1034a28215bdf926b84b02699>>
 * @relayHash 0616a22c791eb8d27cd97c38dbbaaaed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fdab4f721e30e106cb6e937af7ef465a8e7ce5047eb501ede326a1f7618e0cbb
const $fb9284d373020379$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "dataClassificationTags"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "preloadPersonalSpaceDetailsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "preloadPersonalSpaceDetailsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0616a22c791eb8d27cd97c38dbbaaaed",
            "id": "fdab4f721e30e106cb6e937af7ef465a8e7ce5047eb501ede326a1f7618e0cbb",
            "metadata": {},
            "name": "preloadPersonalSpaceDetailsQuery",
            "operationKind": "query",
            "text": "query preloadPersonalSpaceDetailsQuery{user:confluence_atlassianUser(current:true){id,confluence{space{id,key,dataClassificationTags}}}}"
        }
    };
}();
$fb9284d373020379$var$node.hash = "a2cf47cae3a68d2f66118a725dfea818";
var $fb9284d373020379$export$2e2bcd8739ae039 = $fb9284d373020379$var$node;
module.exports["default"] = $fb9284d373020379$export$2e2bcd8739ae039;

});

parcelRegister("bgmQP", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6wGOF = parcelRequire("6wGOF");


var $l9ukq = parcelRequire("l9ukq");


var $iMnC5 = parcelRequire("iMnC5");


var $4aRua = parcelRequire("4aRua");


var $jp2Q3 = parcelRequire("jp2Q3");

var $c8b68f6ea32b0094$export$2fabe69f8125d5a7 = /*#__PURE__*/ function(ConfluenceSpaceType) {
    ConfluenceSpaceType["ALL"] = "ALL";
    ConfluenceSpaceType["ALL_EXCEPT_PERSONAL"] = "ALL_EXCEPT_PERSONAL";
    ConfluenceSpaceType["ALL_EXCEPT_SPECIFIC"] = "ALL_EXCEPT_SPECIFIC";
    ConfluenceSpaceType["PERSONAL"] = "PERSONAL";
    ConfluenceSpaceType["SPECIFIC"] = "SPECIFIC";
    return ConfluenceSpaceType;
}({});
const $c8b68f6ea32b0094$var$i18n = (0, $kSwu1.defineMessages)({
    ariaLabel: {
        id: "space-utils.permissions-export.form.space-target-select.aria-label",
        defaultMessage: "For which spaces"
    },
    all: {
        id: "space-utils.space-target-select.all",
        defaultMessage: "All"
    },
    allDescription: {
        id: "space-utils.space-target-select.allDescription",
        defaultMessage: "All spaces, regardless of type"
    },
    allExcludingPersonal: {
        id: "space-utils.space-target-select.allExcludingPersonal",
        defaultMessage: "All (excluding personal)"
    },
    allExcludingPersonalDescription: {
        id: "space-utils.space-target-select.allExcludingPersonalDescription",
        defaultMessage: "Don't include any personal spaces"
    },
    allExcludingSpecific: {
        id: "space-utils.space-target-select.allExcludingSpecific",
        defaultMessage: "All (excluding specific spaces)"
    },
    allExcludingSpecificDescription: {
        id: "space-utils.space-target-select.allExcludingSpecificDescription",
        defaultMessage: "Choose specific spaces to exclude"
    },
    personal: {
        id: "space-utils.space-target-select.personal",
        defaultMessage: "Only personal"
    },
    personalDescription: {
        id: "space-utils.space-target-select.personalDescription",
        defaultMessage: "All personal spaces"
    },
    specific: {
        id: "space-utils.space-target-select.specific",
        defaultMessage: "Only specific spaces"
    },
    specificDescription: {
        id: "space-utils.space-target-select.specificDescription",
        defaultMessage: "Choose specific spaces to include"
    }
});
const $c8b68f6ea32b0094$var$menuItemStyle = {
    style: "_zulp1b66 _1e0c1txw _2lx21bp4"
};
const $c8b68f6ea32b0094$var$CustomOption = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((props)=>{
    const $ = (0, $bDgLe.c)(10);
    let t0;
    if ($[0] !== props.data.label) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, props.data.label);
        $[0] = props.data.label;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props.data.description) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            color: "color.text.subtlest"
        }, props.data.description);
        $[2] = props.data.description;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $c8b68f6ea32b0094$var$menuItemStyle.style
        }, t0, t1);
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== props || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Option, props, t2);
        $[7] = props;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
});
const $c8b68f6ea32b0094$var$SELECT_STYLE_PROPS = {
    isSearchable: false,
    styles: {
        menu: (base)=>({
                ...base,
                width: '320px',
                padding: 0,
                margin: 0,
                zIndex: (0, $jp2Q3.layers).modal() + 1 // Higher than modal to appear above modal content
            }),
        menuPortal: (base)=>({
                ...base,
                zIndex: (0, $jp2Q3.layers).modal() + 1 // Higher than modal to appear above modal content
            }),
        control: (base)=>({
                ...base,
                width: '320px',
                padding: 0,
                margin: 0
            })
    }
};
const $c8b68f6ea32b0094$var$SPACE_TARGET_OPTIONS = [
    {
        label: 'all',
        value: "ALL",
        description: 'allDescription'
    },
    {
        label: 'allExcludingPersonal',
        value: "ALL_EXCEPT_PERSONAL",
        description: 'allExcludingPersonalDescription'
    },
    {
        label: 'allExcludingSpecific',
        value: "ALL_EXCEPT_SPECIFIC",
        description: 'allExcludingSpecificDescription'
    },
    {
        label: 'personal',
        value: "PERSONAL",
        description: 'personalDescription'
    },
    {
        label: 'specific',
        value: "SPECIFIC",
        description: 'specificDescription'
    }
];
const $c8b68f6ea32b0094$export$f10aab7c26f92d55 = (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { onChange: onChange, spaceTargetValue: spaceTargetValue, menuPortalTarget: menuPortalTarget } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let T0;
    let t1;
    let t2;
    let t3;
    if ($[0] !== formatMessage || $[1] !== onChange || $[2] !== spaceTargetValue) {
        let t4;
        if ($[7] !== formatMessage) {
            t4 = (option)=>({
                    label: formatMessage($c8b68f6ea32b0094$var$i18n[option.label]),
                    value: option.value,
                    description: formatMessage($c8b68f6ea32b0094$var$i18n[option.description])
                });
            $[7] = formatMessage;
            $[8] = t4;
        } else t4 = $[8];
        const options = $c8b68f6ea32b0094$var$SPACE_TARGET_OPTIONS.map(t4);
        T0 = (0, $6wGOF.default);
        t1 = options;
        if ($[9] !== onChange) {
            t2 = (newValue)=>onChange(newValue?.value);
            $[9] = onChange;
            $[10] = t2;
        } else t2 = $[10];
        let t5;
        if ($[11] !== spaceTargetValue) {
            t5 = (option_0)=>String(option_0.value) === String(spaceTargetValue);
            $[11] = spaceTargetValue;
            $[12] = t5;
        } else t5 = $[12];
        t3 = options.find(t5);
        $[0] = formatMessage;
        $[1] = onChange;
        $[2] = spaceTargetValue;
        $[3] = T0;
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else {
        T0 = $[3];
        t1 = $[4];
        t2 = $[5];
        t3 = $[6];
    }
    let t4;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            Option: $c8b68f6ea32b0094$var$CustomOption
        };
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] !== formatMessage) {
        t5 = formatMessage($c8b68f6ea32b0094$var$i18n.ariaLabel);
        $[14] = formatMessage;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== T0 || $[17] !== menuPortalTarget || $[18] !== t1 || $[19] !== t2 || $[20] !== t3 || $[21] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            options: t1,
            onChange: t2,
            value: t3,
            components: t4,
            menuPosition: "fixed",
            menuPortalTarget: menuPortalTarget,
            "aria-label": t5,
            ...$c8b68f6ea32b0094$var$SELECT_STYLE_PROPS
        });
        $[16] = T0;
        $[17] = menuPortalTarget;
        $[18] = t1;
        $[19] = t2;
        $[20] = t3;
        $[21] = t5;
        $[22] = t6;
    } else t6 = $[22];
    return t6;
};
module.exports["ConfluenceSpaceType"] = $c8b68f6ea32b0094$export$2fabe69f8125d5a7;
module.exports["SpaceTargetSelect"] = $c8b68f6ea32b0094$export$f10aab7c26f92d55;

});

parcelRegister("kSPGK", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

class $5d6af3820d303892$var$OptimisticTitleChangeEventBus {
    emit(contentId, title) {
        if (this.listeners[contentId]) this.listeners[contentId].forEach((fn)=>{
            fn(title);
        });
    }
    subscribe(contentId, fn) {
        if (!this.listeners[contentId]) this.listeners[contentId] = [];
        this.listeners[contentId].push(fn);
    }
    unsubcribe(contentId, fn) {
        if (this.listeners[contentId]) {
            const index = this.listeners[contentId].findIndex((item)=>item[0] === fn);
            if (index !== -1) this.listeners[contentId].splice(index, 1);
        }
    }
    constructor(){
        this.listeners = void 0;
        this.listeners = {};
    }
}
const $5d6af3820d303892$var$optimisticTitleChangeEventBus = new $5d6af3820d303892$var$OptimisticTitleChangeEventBus();
const $5d6af3820d303892$export$255638cdf0226b65 = (contentId, initialTitle, onOptimisticUpdate)=>{
    const $ = (0, $bDgLe.c)(16);
    const [optimisticTitle, setOptimisticTitle] = (0, $cozmU.useState)(initialTitle);
    let t0;
    if ($[0] !== contentId || $[1] !== optimisticTitle) {
        t0 = (value)=>{
            if (value !== optimisticTitle) $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.emit(contentId, value);
        };
        $[0] = contentId;
        $[1] = optimisticTitle;
        $[2] = t0;
    } else t0 = $[2];
    const publishOptimisticTitle = t0;
    let t1;
    if ($[3] !== contentId || $[4] !== onOptimisticUpdate) {
        t1 = (title)=>{
            setOptimisticTitle(title);
            onOptimisticUpdate && onOptimisticUpdate(contentId, title);
        };
        $[3] = contentId;
        $[4] = onOptimisticUpdate;
        $[5] = t1;
    } else t1 = $[5];
    const handleTitleChanged = t1;
    let t2;
    let t3;
    if ($[6] !== contentId || $[7] !== handleTitleChanged) {
        t2 = ()=>{
            $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.subscribe(contentId, handleTitleChanged);
            return ()=>{
                $5d6af3820d303892$var$optimisticTitleChangeEventBus && $5d6af3820d303892$var$optimisticTitleChangeEventBus.unsubcribe(contentId, handleTitleChanged);
            };
        };
        t3 = [
            contentId,
            handleTitleChanged
        ];
        $[6] = contentId;
        $[7] = handleTitleChanged;
        $[8] = t2;
        $[9] = t3;
    } else {
        t2 = $[8];
        t3 = $[9];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[10] !== initialTitle) {
        t4 = ()=>{
            setOptimisticTitle(initialTitle);
        };
        t5 = [
            initialTitle
        ];
        $[10] = initialTitle;
        $[11] = t4;
        $[12] = t5;
    } else {
        t4 = $[11];
        t5 = $[12];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[13] !== optimisticTitle || $[14] !== publishOptimisticTitle) {
        t6 = {
            optimisticTitle: optimisticTitle,
            setOptimisticTitle: publishOptimisticTitle
        };
        $[13] = optimisticTitle;
        $[14] = publishOptimisticTitle;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
};
module.exports["useOptimisticTitleChange"] = $5d6af3820d303892$export$255638cdf0226b65;

});

parcelRegister("iVSl1", function(module, exports) {

let $dc87b34787caf467$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $dc87b34787caf467$var$load("gkVge"),
    $dc87b34787caf467$var$load("3HUOM"),
    $dc87b34787caf467$var$load("dgPly"),
    $dc87b34787caf467$var$load("eOFeQ"),
    $dc87b34787caf467$var$load("dgmjH"),
    $dc87b34787caf467$var$load("hDJ0x"),
    $dc87b34787caf467$var$load("1dC87"),
    $dc87b34787caf467$var$load("6UOty"),
    $dc87b34787caf467$var$load("1xRFJ"),
    $dc87b34787caf467$var$load("5iv5O"),
    $dc87b34787caf467$var$load("ddvkk"),
    $dc87b34787caf467$var$load("3upHR"),
    $dc87b34787caf467$var$load("6lJkL"),
    $dc87b34787caf467$var$load("hUbK8"),
    $dc87b34787caf467$var$load("fqJr7"),
    $dc87b34787caf467$var$load("7H1j2"),
    $dc87b34787caf467$var$load("rF2nk"),
    $dc87b34787caf467$var$load("xS2oU"),
    $dc87b34787caf467$var$load("4jxHc"),
    $dc87b34787caf467$var$load("h5kct"),
    $dc87b34787caf467$var$load("1Gr4q"),
    $dc87b34787caf467$var$load("4RsKm"),
    $dc87b34787caf467$var$load("7EorR"),
    $dc87b34787caf467$var$load("9ZFGK"),
    $dc87b34787caf467$var$load("2hLAI"),
    $dc87b34787caf467$var$load("dCilB"),
    $dc87b34787caf467$var$load("1T8H1"),
    $dc87b34787caf467$var$load("fyKFO"),
    $dc87b34787caf467$var$load("d9sg7"),
    $dc87b34787caf467$var$load("l0N35"),
    $dc87b34787caf467$var$load("bU9L5"),
    $dc87b34787caf467$var$load("Wowvf"),
    $dc87b34787caf467$var$load("6wr18"),
    $dc87b34787caf467$var$load("39XCn"),
    $dc87b34787caf467$var$load("ffEVr"),
    $dc87b34787caf467$var$load("hhss7"),
    $dc87b34787caf467$var$load("6OMo6"),
    $dc87b34787caf467$var$load("aaRXj"),
    $dc87b34787caf467$var$load("fHlIz"),
    $dc87b34787caf467$var$load("4QwAJ"),
    $dc87b34787caf467$var$load("3i44s"),
    $dc87b34787caf467$var$load("5kI0b"),
    $dc87b34787caf467$var$load("kYkz1"),
    $dc87b34787caf467$var$load("jfYeU"),
    $dc87b34787caf467$var$load("b4nm1"),
    $dc87b34787caf467$var$load("geXPZ"),
    $dc87b34787caf467$var$load("aQ5uu"),
    $dc87b34787caf467$var$load("jfSwd"),
    $dc87b34787caf467$var$load("fV46K"),
    $dc87b34787caf467$var$load("jOE2W"),
    $dc87b34787caf467$var$load("jTOhL"),
    $dc87b34787caf467$var$load("96rwC"),
    $dc87b34787caf467$var$load("aJLFD"),
    $dc87b34787caf467$var$load("cFvW1"),
    $dc87b34787caf467$var$load("keUAv")
]).then(()=>parcelRequire('jeJjF'));

});

parcelRegister("hjUDQ", function(module, exports) {
var $3f94275ae089f93c$export$bdc3c19374266b98 = /*#__PURE__*/ function(ButtonStyle) {
    ButtonStyle["DEFAULT"] = "default";
    ButtonStyle["ALTERNATIVE_1"] = "alternative_1";
    return ButtonStyle;
}({});
var $3f94275ae089f93c$export$a6e645fda5339bf8 = /*#__PURE__*/ function(CornerStyle) {
    CornerStyle["ROUNDED"] = "rounded";
    CornerStyle["SQUARED"] = "squared";
    return CornerStyle;
}({});
var $3f94275ae089f93c$export$8954cfac7c08d16a = /*#__PURE__*/ function(Height) {
    Height["MEDIUM"] = "medium";
    Height["SMALL"] = "small";
    Height["LARGE"] = "large";
    return Height;
}({});
var $3f94275ae089f93c$export$9d7927214ed7d2cf = /*#__PURE__*/ function(Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["RIGHT"] = "right";
    Alignment["CENTER"] = "center";
    return Alignment;
}({});
var $3f94275ae089f93c$export$df54d73aa0ec5e82 = /*#__PURE__*/ function(Orientation) {
    Orientation["ROW"] = "row";
    Orientation["STACKED"] = "stacked";
    return Orientation;
}({});
var $3f94275ae089f93c$export$21e76ed09a093e97 = /*#__PURE__*/ function(CardLayout) {
    CardLayout["FOLDERS"] = "folders";
    CardLayout["ACCORDIONS"] = "accordions";
    return CardLayout;
}({});
var $3f94275ae089f93c$export$42809f9f1496f50d = /*#__PURE__*/ function(CommonLayout) {
    CommonLayout["FRAME_ABOVE_IMAGE"] = "frame-above-image";
    CommonLayout["SPLIT_IMAGE_RIGHT"] = "split-image-right";
    CommonLayout["SPLIT_IMAGE_LEFT"] = "split-image-left";
    CommonLayout["FULL_IMAGE_BACKGROUND"] = "full-image-background";
    CommonLayout["NO_IMAGE_BACKGROUND"] = "no-image-background";
    return CommonLayout;
}({});
var $3f94275ae089f93c$export$d4c0482bf980ef26 = /*#__PURE__*/ function(FeedbackType) {
    FeedbackType["CARDS"] = "Cards";
    FeedbackType["CAROUSEL"] = "Carousel";
    FeedbackType["COMPANY_HUB"] = "Company hub";
    FeedbackType["CUSTOMIZE_NAVIGATION"] = "Customize Navigation";
    FeedbackType["LINKS_MENU"] = "Links menu";
    FeedbackType["SPOTLIGHT"] = "Spotlight";
    FeedbackType["SECTION"] = "Section";
    FeedbackType["CUSTOM_SEARCH"] = "Custom search";
    return FeedbackType;
}({});
var $3f94275ae089f93c$export$533ae1c1b7b7ac6 = /*#__PURE__*/ function(ExtensionMode) {
    ExtensionMode["RENDERER"] = "renderer";
    ExtensionMode["EDITOR"] = "editor";
    return ExtensionMode;
}({});
const $3f94275ae089f93c$export$cb307dad255adf47 = 'epic.logout.LOG_OUT';
var $3f94275ae089f93c$export$1f60141b6ce5efed = /*#__PURE__*/ function(RenderVariant) {
    RenderVariant["MANUAL"] = "manual";
    RenderVariant["DYNAMIC"] = "dynamic";
    return RenderVariant;
}({});
var $3f94275ae089f93c$export$f6cd408cac7f930c = /*#__PURE__*/ function(SegmentationTargets) {
    SegmentationTargets["ALL"] = "all";
    SegmentationTargets["EACH"] = "each";
    return SegmentationTargets;
}({});
var $3f94275ae089f93c$export$bf7ebf7fed6e7189 = /*#__PURE__*/ function(ITEM_FIELDS) {
    ITEM_FIELDS["CARD_ID"] = "cardId";
    ITEM_FIELDS["TITLE"] = "title";
    ITEM_FIELDS["IS_TITLE_USER_EDITED"] = "isTitleUserEdited";
    ITEM_FIELDS["DESCRIPTION"] = "description";
    ITEM_FIELDS["IS_DESCRIPTION_USER_EDITED"] = "isDescriptionUserEdited";
    ITEM_FIELDS["IS_DESCRIPTION_SHOWN"] = "isDescriptionShown";
    ITEM_FIELDS["LABEL"] = "label";
    ITEM_FIELDS["IS_LABEL_HIDDEN"] = "isLabelHidden";
    ITEM_FIELDS["LINK"] = "link";
    ITEM_FIELDS["IS_LINK_USER_EDITED"] = "isLinkUserEdited";
    ITEM_FIELDS["IMAGE_SRC"] = "imageSrc";
    ITEM_FIELDS["CONFLUENCE_PAGE_ID"] = "confluencePageId";
    ITEM_FIELDS["IMAGE_ALT_TEXT"] = "imageAltText";
    ITEM_FIELDS["SEGMENTATION_TARGETS"] = "segmentationTarget";
    ITEM_FIELDS["AUDIENCE_SEGMENTATION_GROUP_IDS"] = "audienceSegmentationGroupIds";
    // group preferences stored via this field when segmentationTarget is EACH
    ITEM_FIELDS["LINK_RESOURCE_TYPE"] = "linkResourceType";
    ITEM_FIELDS["BACKGROUND_COLOR"] = "backgroundColor";
    ITEM_FIELDS["TEXT_COLOR"] = "textColor";
    ITEM_FIELDS["LABEL_COLOR"] = "labelColor";
    ITEM_FIELDS["LAYOUT"] = "layout";
    ITEM_FIELDS["IS_BUTTON_SHOWN"] = "isButtonShown";
    ITEM_FIELDS["BUTTON_TEXT"] = "buttonText";
    ITEM_FIELDS["BUTTON_STYLE"] = "buttonStyle";
    ITEM_FIELDS["HEIGHT"] = "height";
    return ITEM_FIELDS;
}({});
module.exports["ButtonStyle"] = $3f94275ae089f93c$export$bdc3c19374266b98;
module.exports["CornerStyle"] = $3f94275ae089f93c$export$a6e645fda5339bf8;
module.exports["Height"] = $3f94275ae089f93c$export$8954cfac7c08d16a;
module.exports["Alignment"] = $3f94275ae089f93c$export$9d7927214ed7d2cf;
module.exports["Orientation"] = $3f94275ae089f93c$export$df54d73aa0ec5e82;
module.exports["CardLayout"] = $3f94275ae089f93c$export$21e76ed09a093e97;
module.exports["CommonLayout"] = $3f94275ae089f93c$export$42809f9f1496f50d;
module.exports["FeedbackType"] = $3f94275ae089f93c$export$d4c0482bf980ef26;
module.exports["ExtensionMode"] = $3f94275ae089f93c$export$533ae1c1b7b7ac6;
module.exports["RenderVariant"] = $3f94275ae089f93c$export$1f60141b6ce5efed;
module.exports["SegmentationTargets"] = $3f94275ae089f93c$export$f6cd408cac7f930c;
module.exports["ITEM_FIELDS"] = $3f94275ae089f93c$export$bf7ebf7fed6e7189;

});

parcelRegister("cQhbe", function(module, exports) {
var $3ddd96eb421fb45c$export$c184dc244f9dacf4 = /*#__PURE__*/ function(AutoConvertEvent) {
    AutoConvertEvent["VIEWED"] = "pageViewed";
    AutoConvertEvent["EDITED"] = "pageEdited";
    AutoConvertEvent["PUBLISHED"] = "pagePublished";
    AutoConvertEvent["NOTIFICATION_SHOWN"] = "notificationShown";
    AutoConvertEvent["NOTIFICATION_ERROR"] = "notificationError";
    return AutoConvertEvent;
}({});
var $3ddd96eb421fb45c$export$a248ed70ead7ff08 = /*#__PURE__*/ function(AutoConvertActionSubject) {
    AutoConvertActionSubject["AUTO_CONVERSION"] = "autoConversion";
    AutoConvertActionSubject["AUTO_CONVERSION_BYLINE"] = "autoConversionByLine";
    return AutoConvertActionSubject;
}({});
var $3ddd96eb421fb45c$export$d8b435b7aa875953 = /*#__PURE__*/ function(RevertAutoConvertEvent) {
    RevertAutoConvertEvent["DIALOG_OPEN"] = "revertDialogOpen";
    RevertAutoConvertEvent["CLICKED"] = "revertClicked";
    RevertAutoConvertEvent["CANCELLED"] = "revertCancelled";
    RevertAutoConvertEvent["CONFIRMED"] = "revertConfirmed";
    RevertAutoConvertEvent["ERROR"] = "revertError";
    return RevertAutoConvertEvent;
}({});
var $3ddd96eb421fb45c$export$b22548c36d783030 = /*#__PURE__*/ function(AutoConvertPanelEvent) {
    AutoConvertPanelEvent["VIEWED"] = "panelViewed";
    AutoConvertPanelEvent["SUPPORTED"] = "panelSupported";
    AutoConvertPanelEvent["NONE"] = "panelNone";
    AutoConvertPanelEvent["GET_ERROR"] = "panelGetError";
    AutoConvertPanelEvent["SET_ERROR"] = "panelSetError";
    return AutoConvertPanelEvent;
}({});
var $3ddd96eb421fb45c$export$e8dbd545dc7c3af0 = /*#__PURE__*/ function(AutoConversionByLineEvent) {
    AutoConversionByLineEvent["CLICKED"] = "bylineClicked";
    AutoConversionByLineEvent["NEW_EDITOR_MODAL_OPENED"] = "newEditorModalOpened";
    AutoConversionByLineEvent["NEW_EDITOR_MODAL_CLOSED"] = "newEditorModalClosed";
    return AutoConversionByLineEvent;
}({});
const $3ddd96eb421fb45c$export$b4535793cfa6d80a = (createAnalyticsEvent, analytics, actionSubject)=>{
    const { pageAction: pageAction, source: source, setting: setting } = analytics;
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'triggered',
            actionSubject: actionSubject,
            source: source,
            actionSubjectId: 'page',
            attributes: {
                pageAction: pageAction,
                setting: setting
            }
        }
    }).fire();
};
const $3ddd96eb421fb45c$export$e045315387fc4262 = (createAnalyticsEvent, analytics)=>{
    const { level: level, panelAction: panelAction, source: source } = analytics;
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'autoConversion',
            source: source,
            actionSubjectId: 'panel',
            attributes: {
                level: level,
                panelAction: panelAction
            }
        }
    }).fire();
};
module.exports["AutoConvertEvent"] = $3ddd96eb421fb45c$export$c184dc244f9dacf4;
module.exports["AutoConvertActionSubject"] = $3ddd96eb421fb45c$export$a248ed70ead7ff08;
module.exports["RevertAutoConvertEvent"] = $3ddd96eb421fb45c$export$d8b435b7aa875953;
module.exports["AutoConvertPanelEvent"] = $3ddd96eb421fb45c$export$b22548c36d783030;
module.exports["AutoConversionByLineEvent"] = $3ddd96eb421fb45c$export$e8dbd545dc7c3af0;
module.exports["sendEditorConversionAnalyticsPageEvent"] = $3ddd96eb421fb45c$export$b4535793cfa6d80a;
module.exports["sendEditorConversionAnalyticsPanelEvent"] = $3ddd96eb421fb45c$export$e045315387fc4262;

});

parcelRegister("sLZsl", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $9e73f43295b80088$var$Store = (0, $8s9DV.createStore)({
    initialState: {
        isAutoConverted: false
    },
    actions: {
        setIsAutoConverted: (isAutoConverted)=>({ setState: setState })=>{
                setState({
                    isAutoConverted: isAutoConverted
                });
            }
    },
    name: 'isAutoConverted'
});
const $9e73f43295b80088$var$getAutoConvertState = (state)=>{
    return state.isAutoConverted;
};
const $9e73f43295b80088$export$dc84155a8aa7f285 = (0, $kBr4q.createHook)($9e73f43295b80088$var$Store, {
    selector: $9e73f43295b80088$var$getAutoConvertState
});
module.exports["useAutoConvertState"] = $9e73f43295b80088$export$dc84155a8aa7f285;

});

parcelRegister("gabmL", function(module, exports) {

var $9eNhQ = parcelRequire("9eNhQ");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $bQm3c = parcelRequire("bQm3c");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $euL71 = parcelRequire("euL71");


var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $hC6vw = parcelRequire("hC6vw");


var $1X7PR = parcelRequire("1X7PR");


var $bgRei = parcelRequire("bgRei");

const $b34fb09a67265b07$var$KNOWN_ERROR_MESSAGES = [
    'This is a Standard/Premium feature. You are currently subscribed to the Free plan.',
    'Anonymous access is not permitted'
];
const $b34fb09a67265b07$var$i18n = (0, $kSwu1.defineMessages)({
    publicLinkUrlPathError: {
        id: "public-links.usePublicLinkDataProvider.sharePathError.message",
        defaultMessage: "publicLinkStatus was ON, but no publicLinkUrlPath was provided"
    }
});
const $b34fb09a67265b07$var$computeData = (pageData, contentData, permissionsData, isPublicLinkStatusOnForContent, enrolledContentTypes, edition)=>{
    // Are Public Links allowed for this content type
    const isPublicLinkAllowedForContentType = !contentData.error && contentData.data !== undefined && enrolledContentTypes.includes(contentData.data.contentType);
    // Are Editable Public Links allowed for this content type
    const isPublicLinkEditAllowedForContentType = isPublicLinkAllowedForContentType && (edition === (0, $euL71.ConfluenceEdition).PREMIUM || (0, $6mKj3.expVal)('shareable_links_m0', 'isEnabled', false)) && contentData.data?.contentType === 'whiteboard';
    // Can current user edit Public Link status
    const baseCanEditPublicLink = !contentData.error && contentData.data?.canEditPublicLink === true;
    const canUpdateOrDeletePublicLink = !contentData.error && (contentData.data?.canUpdatePublicLink === true || contentData.data?.canDeletePublicLink === true);
    // Render-time call to ensure the experiment exposure is tracked even when baseCanEditPublicLink short-circuits the next clause.
    (0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false);
    const canEditPublicLink = baseCanEditPublicLink && (!isPublicLinkStatusOnForContent || canUpdateOrDeletePublicLink || !(0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false));
    // Value for if the Public Link has edit permissions i.e. Editable Public Whiteboards
    const isEditPublicLink = !!(!permissionsData.error && permissionsData.data?.hasEditPermission);
    // Are Public Links enabled by admins at Site and Space levels
    const isPublicLinkAdminEnabled = isPublicLinkStatusOnForContent || !pageData.error && pageData.data?.pageStatus === (0, $hC6vw.PublicLinkPageStatus).OFF;
    // Is Public Link allowed for content type, admin enabled, and status ON
    const isPublicLinkFullyEnabled = isPublicLinkStatusOnForContent && isPublicLinkAdminEnabled && isPublicLinkAllowedForContentType;
    const refetch = (dataToFetch = 'all')=>{
        // if dataToFetch !== permission, it means it's either all or public-link
        if (dataToFetch !== 'permission') pageData.refetch();
        // if dataToFetch !== public-link, it means it's either all or permission
        if (dataToFetch !== 'public-link') isPublicLinkEditAllowedForContentType && permissionsData.refetch();
    };
    return {
        isPublicLinkAdminEnabled: isPublicLinkAdminEnabled,
        isPublicLinkFullyEnabled: isPublicLinkFullyEnabled,
        isPublicLinkAllowedForContentType: isPublicLinkAllowedForContentType,
        isPublicLinkEditAllowedForContentType: isPublicLinkEditAllowedForContentType,
        isEditPublicLink: isEditPublicLink,
        canEditPublicLink: canEditPublicLink,
        publicLinkStatus: pageData.data?.pageStatus,
        publicLinkSharePath: pageData.data?.publicLinkUrlPath,
        refetch: refetch
    };
};
const $b34fb09a67265b07$export$4725159de576f61f = (props)=>{
    const publicLinkData = $b34fb09a67265b07$export$b7ccc28cc819be23({
        pageId: props.contentId,
        ...props
    });
    return publicLinkData.isLoading ? {
        isPublicLinkFullyEnabled: false,
        isPublicLinkAdminEnabled: false,
        isPublicLinkAllowedForContentType: false,
        isPublicLinkEditAllowedForContentType: false,
        canEditPublicLink: false,
        publicLinkStatus: undefined,
        publicLinkSharePath: undefined,
        isEditPublicLink: false,
        refetch: ()=>{},
        ...publicLinkData
    } : publicLinkData;
};
const $b34fb09a67265b07$export$b7ccc28cc819be23 = (props)=>{
    const enrolledContentTypes = [
        'page',
        'whiteboard'
    ];
    const intl = (0, $kSwu1.useIntl)();
    const { isLicensed: isLicensed, edition: edition } = (0, $bQm3c.useSessionData)();
    let contentData = (0, $1X7PR.usePublicLinkContentQuery)({
        contentId: props.pageId,
        skip: props.contentQueryProps?.skip
    });
    const contentType = props.contentQueryProps?.skip ? props.contentQueryProps?.contentType : contentData?.data?.contentType;
    contentData = {
        ...contentData,
        data: {
            ...contentData?.data,
            canEditPublicLink: contentData?.data?.canEditPublicLink ?? false,
            canUpdatePublicLink: contentData?.data?.canUpdatePublicLink ?? false,
            canDeletePublicLink: contentData?.data?.canDeletePublicLink ?? false,
            contentType: contentType ?? ''
        }
    };
    const shouldSkip = props.skip || !enrolledContentTypes.includes(contentData?.data?.contentType || '') || !isLicensed || edition === (0, $euL71.ConfluenceEdition).FREE;
    const rawPageData = (0, $jMyy4.useQueryInterop)((0, $9eNhQ.default), {
        variables: {
            pageId: props.pageId
        },
        fetchPolicy: props.fetchPolicy,
        skip: shouldSkip,
        __callerPackage__: "public-links"
    });
    const permissionsData = (0, $bgRei.usePublicLinkPermissionsForObject)({
        objectId: props.pageId,
        skip: shouldSkip || edition !== (0, $euL71.ConfluenceEdition).PREMIUM && !(0, $6mKj3.expVal)('shareable_links_m0', 'isEnabled', false) || contentData?.data?.contentType !== 'whiteboard'
    });
    const pageData = (0, $cozmU.useMemo)(()=>({
            isLoading: rawPageData.loading,
            data: rawPageData.data?.publicLinkPage,
            error: rawPageData.error,
            refetch: rawPageData.refetch
        }), [
        rawPageData.loading,
        rawPageData.data,
        rawPageData.error,
        rawPageData.refetch
    ]);
    if ((0, $1uFM6.isUnauthorizedError)(rawPageData.error) || // We currently aren't being given error types by the backend.
    // When we do, we can better parse these expected errors.
    // https://product-fabric.atlassian.net/browse/CPE-1991
    $b34fb09a67265b07$var$KNOWN_ERROR_MESSAGES.some((msg)=>rawPageData.error?.message?.includes(msg))) (0, $7Sm4c.markErrorAsHandled)(rawPageData.error);
    // Is Public Link Status for page ON
    const isPublicLinkStatusOnForContent = !pageData.error && pageData.data?.pageStatus === (0, $hC6vw.PublicLinkPageStatus).ON;
    const loading = pageData.isLoading || contentData.isLoading || permissionsData.isLoading;
    const errors = (0, $cozmU.useMemo)(()=>[
            pageData,
            contentData,
            permissionsData
        ].map((query)=>!query.isLoading && query.error).filter((err)=>Boolean(err)), [
        pageData,
        contentData,
        permissionsData
    ]);
    if (isPublicLinkStatusOnForContent && pageData.data?.publicLinkUrlPath === null) errors.push(new Error(intl.formatMessage($b34fb09a67265b07$var$i18n.publicLinkUrlPathError)));
    return loading ? {
        isLoading: true,
        errors: errors
    } : {
        isLoading: false,
        errors: errors,
        ...$b34fb09a67265b07$var$computeData(pageData, contentData, permissionsData, isPublicLinkStatusOnForContent, enrolledContentTypes, edition)
    };
};
const $b34fb09a67265b07$export$b86a4cadf4c50ae1 = ({ contentId: contentId, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children($b34fb09a67265b07$export$b7ccc28cc819be23({
        pageId: contentId
    })));
module.exports["usePublicLinkData"] = $b34fb09a67265b07$export$4725159de576f61f;
module.exports["usePublicLinkPageDataProvider"] = $b34fb09a67265b07$export$b7ccc28cc819be23;
module.exports["PublicLinkPageDataProvider"] = $b34fb09a67265b07$export$b86a4cadf4c50ae1;

});

parcelRegister("9eNhQ", function(module, exports) {
/**
 * @generated SignedSource<<f3ce31061615fe76b947269deb5d6c75>>
 * @relayHash 3f5a736f4dd660a89b02a4452e465d11
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d041a328d30295536c08edf8e81645ba3b1dcbd7e16c6e2d0e375aa0b48fc184
const $858700f9e1edfc48$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "pageId",
                    "variableName": "pageId"
                }
            ],
            "concreteType": "PublicLinkPage",
            "kind": "LinkedField",
            "name": "publicLinkPage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pageId"
                },
                {
                    "kind": "ScalarField",
                    "name": "pageStatus"
                },
                {
                    "kind": "ScalarField",
                    "name": "publicLinkUrlPath"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePublicLinkPageDataProviderPublicLinkPageQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePublicLinkPageDataProviderPublicLinkPageQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3f5a736f4dd660a89b02a4452e465d11",
            "id": "d041a328d30295536c08edf8e81645ba3b1dcbd7e16c6e2d0e375aa0b48fc184",
            "metadata": {},
            "name": "usePublicLinkPageDataProviderPublicLinkPageQuery",
            "operationKind": "query",
            "text": "query usePublicLinkPageDataProviderPublicLinkPageQuery($pageId:ID!){publicLinkPage(pageId:$pageId){pageId,pageStatus,publicLinkUrlPath}}"
        }
    };
}();
$858700f9e1edfc48$var$node.hash = "c030204610be720b223484d4a8d871cf";
var $858700f9e1edfc48$export$2e2bcd8739ae039 = $858700f9e1edfc48$var$node;
module.exports["default"] = $858700f9e1edfc48$export$2e2bcd8739ae039;

});

parcelRegister("hC6vw", function(module, exports) {
/**
 * @generated SignedSource<<05f748b5a6c8adbf92302798905bd021>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $d0a960900d3ff81b$export$cb24eb3958583602 = /*#__PURE__*/ function(PublicLinkPageStatus) {
    PublicLinkPageStatus["BLOCKED_BY_ORG"] = "BLOCKED_BY_ORG";
    PublicLinkPageStatus["BLOCKED_BY_PRODUCT"] = "BLOCKED_BY_PRODUCT";
    PublicLinkPageStatus["BLOCKED_BY_SPACE"] = "BLOCKED_BY_SPACE";
    PublicLinkPageStatus["BLOCKED_BY_CONTAINER_POLICY"] = "BLOCKED_BY_CONTAINER_POLICY";
    PublicLinkPageStatus["BLOCKED_BY_CLASSIFICATION_LEVEL"] = "BLOCKED_BY_CLASSIFICATION_LEVEL";
    PublicLinkPageStatus["OFF"] = "OFF";
    PublicLinkPageStatus["ON"] = "ON";
    PublicLinkPageStatus["SITE_BLOCKED"] = "SITE_BLOCKED";
    PublicLinkPageStatus["SITE_DISABLED"] = "SITE_DISABLED";
    PublicLinkPageStatus["SPACE_BLOCKED"] = "SPACE_BLOCKED";
    PublicLinkPageStatus["SPACE_DISABLED"] = "SPACE_DISABLED";
    return PublicLinkPageStatus;
}({});
module.exports["PublicLinkPageStatus"] = $d0a960900d3ff81b$export$cb24eb3958583602;

});

parcelRegister("1X7PR", function(module, exports) {

var $OoVEI = parcelRequire("OoVEI");


var $cozmU = parcelRequire("cozmU");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $cLo2u = parcelRequire("cLo2u");


var $foQ4a = parcelRequire("foQ4a");


var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $6Skv2 = parcelRequire("6Skv2");

const $3e0fb5c21944a86f$var$computeData = (data, isExternalCollaborator)=>{
    const contentType = data?.content?.nodes?.[0]?.type || '';
    const operations = data?.content?.nodes?.[0]?.operations || [];
    const hasManagePublicLinksPermission = Boolean(data?.space?.currentUser?.isAdmin);
    const canEditContent = (0, $6Skv2.hasPublicLinksOperation)(operations, 'update', contentType);
    const canCreatePublicLink = (0, $6Skv2.hasPublicLinksOperation)(operations, 'create_public_link', contentType);
    const canUpdatePublicLink = (0, $6Skv2.hasPublicLinksOperation)(operations, 'update', 'public_link');
    const canDeletePublicLink = (0, $6Skv2.hasPublicLinksOperation)(operations, 'delete', 'public_link');
    const canEditPublicLink = (0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false) ? canCreatePublicLink && !isExternalCollaborator : (hasManagePublicLinksPermission || canEditContent) && !isExternalCollaborator;
    return {
        contentType: contentType,
        canEditPublicLink: canEditPublicLink,
        canUpdatePublicLink: canUpdatePublicLink,
        canDeletePublicLink: canDeletePublicLink
    };
};
const $3e0fb5c21944a86f$export$13a7a098bd5c2599 = (props)=>{
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    const { loading: loading, data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $OoVEI.default), {
        skip: props.skip,
        variables: {
            contentId: props.contentId,
            hasSpaceKey: Boolean(spaceKey),
            spaceKey: spaceKey ?? ''
        },
        __callerPackage__: "public-links"
    });
    (0, $cozmU.useEffect)(()=>{
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    }, [
        error
    ]);
    return loading ? {
        isLoading: true
    } : {
        isLoading: false,
        error: error,
        data: error ? undefined : $3e0fb5c21944a86f$var$computeData(data, isExternalCollaborator)
    };
};
module.exports["usePublicLinkContentQuery"] = $3e0fb5c21944a86f$export$13a7a098bd5c2599;

});

parcelRegister("OoVEI", function(module, exports) {
/**
 * @generated SignedSource<<5d5c701005fd929073b85f42c85deac0>>
 * @relayHash 6ab077a19d911ef98a26d3adbdc3fb56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d97e35dd1097710a89c08e998e3514fe92b46c99fab60a5106b9d4e4545db9da
const $77c51ddc0082b191$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hasSpaceKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "condition": "hasSpaceKey",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "key",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "concreteType": "SpaceUserMetadata",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isAdmin"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "usePublicLinkContentQueryPublicLinkContentQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "usePublicLinkContentQueryPublicLinkContentQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "6ab077a19d911ef98a26d3adbdc3fb56",
            "id": "d97e35dd1097710a89c08e998e3514fe92b46c99fab60a5106b9d4e4545db9da",
            "metadata": {},
            "name": "usePublicLinkContentQueryPublicLinkContentQuery",
            "operationKind": "query",
            "text": "query usePublicLinkContentQueryPublicLinkContentQuery($contentId:ID!,$spaceKey:String!,$hasSpaceKey:Boolean!){content(id:$contentId){nodes{id,type,operations{operation,targetType}}},space(key:$spaceKey)@include(if:$hasSpaceKey){id,currentUser{isAdmin}}}"
        }
    };
}();
$77c51ddc0082b191$var$node.hash = "59655c56a4e7fa1ddec49b3697d04128";
var $77c51ddc0082b191$export$2e2bcd8739ae039 = $77c51ddc0082b191$var$node;
module.exports["default"] = $77c51ddc0082b191$export$2e2bcd8739ae039;

});

parcelRegister("6Skv2", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $i28ZW = parcelRequire("i28ZW");

const $56a1bd181349f72b$export$6f68fdaa2d77a244 = (operations, operation, targetType)=>(operations || []).some((op)=>op?.operation === operation && op?.targetType === targetType);
const $56a1bd181349f72b$export$1f45e3a137b2157c = (space)=>(0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false) ? (0, $i28ZW.hasSpaceOperation)(space?.operations, (0, $i28ZW.MANAGE_PUBLIC_LINKS)) : Boolean(space?.currentUser?.isAdmin);
const $56a1bd181349f72b$export$818b606ecaafcde3 = (space)=>space ? $56a1bd181349f72b$export$1f45e3a137b2157c(space) : undefined;
module.exports["hasPublicLinksOperation"] = $56a1bd181349f72b$export$6f68fdaa2d77a244;
module.exports["hasManagePublicLinksOperation"] = $56a1bd181349f72b$export$1f45e3a137b2157c;
module.exports["hasManagePublicLinksOperationOrUndefined"] = $56a1bd181349f72b$export$818b606ecaafcde3;

});

parcelRegister("i28ZW", function(module, exports) {

var $i0mmi = parcelRequire("i0mmi");


var $6mKj3 = parcelRequire("6mKj3");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $iquRY = parcelRequire("iquRY");


var $jMyy4 = parcelRequire("jMyy4");

const $981a614bc39b93a3$var$useSpaceManagementOperationsSpacePropertiesQuery = (0, $i0mmi.default);
const $981a614bc39b93a3$export$42add616309f8ea4 = 'manage_users';
const $981a614bc39b93a3$export$ceb95831d69da149 = 'manage_nonlicensed_users';
const $981a614bc39b93a3$export$3eb61eb33a05d6fe = 'manage_guest_users';
const $981a614bc39b93a3$export$fae9e1a00840692e = 'manage_public_links';
const $981a614bc39b93a3$export$d9a801072630763d = 'manage_templates';
const $981a614bc39b93a3$export$80ed1bd55ccf4772 = 'administer';
const $981a614bc39b93a3$export$a89133b28496ff30 = 'manage_look_and_feel';
const $981a614bc39b93a3$export$50faaafd42078ad9 = 'manage_content';
const $981a614bc39b93a3$export$a7c1ec142e70d69d = 'archive';
const $981a614bc39b93a3$export$92f9e1ed9114d3a6 = 'copy';
const $981a614bc39b93a3$export$3ea24d3a964169d2 = 'view_analytics';
const $981a614bc39b93a3$export$b838cef2a8827875 = (operations, spaceOperation)=>{
    return operations?.some((operation)=>operation?.operation === spaceOperation && operation?.targetType === 'space') ?? false;
};
const $981a614bc39b93a3$export$f8731d5631669ee8 = ({ spaceKey: spaceKey, skip: skip })=>{
    const { isRbacEnabled: isRbacEnabled, loading: isLoadingSpaceRoleMode } = (0, $iquRY.useSpaceRoleMode)();
    const defaultSkip = !spaceKey || !isRbacEnabled && !(0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false);
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($981a614bc39b93a3$var$useSpaceManagementOperationsSpacePropertiesQuery, {
        variables: {
            spaceKey: spaceKey
        },
        skip: skip !== undefined ? skip : defaultSkip,
        onError: (error)=>{
            if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
            else (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
            });
        },
        __callerPackage__: "space-utils"
    });
    const operations = data?.space?.operations;
    return {
        canManageSomeUsers: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$42add616309f8ea4) || $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$ceb95831d69da149) || $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$3eb61eb33a05d6fe),
        canManageUsers: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$42add616309f8ea4),
        canManageNonlicensedUsers: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$ceb95831d69da149),
        canManageGuestUsers: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$3eb61eb33a05d6fe),
        canManagePublicLinks: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$fae9e1a00840692e),
        canManageTemplates: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$d9a801072630763d),
        canManageLookAndFeel: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$a89133b28496ff30),
        canAdminister: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$80ed1bd55ccf4772),
        canManageContent: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$50faaafd42078ad9),
        canArchive: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$a7c1ec142e70d69d),
        canCopy: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$92f9e1ed9114d3a6),
        canViewAnalytics: $981a614bc39b93a3$export$b838cef2a8827875(operations, $981a614bc39b93a3$export$3ea24d3a964169d2),
        loading: loading || isLoadingSpaceRoleMode
    };
};
module.exports["MANAGE_PUBLIC_LINKS"] = $981a614bc39b93a3$export$fae9e1a00840692e;
module.exports["ADMINISTER"] = $981a614bc39b93a3$export$80ed1bd55ccf4772;
module.exports["MANAGE_CONTENT"] = $981a614bc39b93a3$export$50faaafd42078ad9;
module.exports["hasSpaceOperation"] = $981a614bc39b93a3$export$b838cef2a8827875;
module.exports["useSpaceManagementOperations"] = $981a614bc39b93a3$export$f8731d5631669ee8;

});

parcelRegister("i0mmi", function(module, exports) {
/**
 * @generated SignedSource<<10e9286ab7437b1579bfb197b3cdf663>>
 * @relayHash 0a3dc9cecca8233daf01e0443fdaa5e6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1509aa25f2392b1667fcb4313ac8da10a214bb194abea1065d129f0c6ea9e471
const $7dc84e66153faa36$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceManagementOperationsSpacePropertiesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceManagementOperationsSpacePropertiesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0a3dc9cecca8233daf01e0443fdaa5e6",
            "id": "1509aa25f2392b1667fcb4313ac8da10a214bb194abea1065d129f0c6ea9e471",
            "metadata": {},
            "name": "useSpaceManagementOperationsSpacePropertiesQuery",
            "operationKind": "query",
            "text": "query useSpaceManagementOperationsSpacePropertiesQuery($spaceKey:String!){space(key:$spaceKey){id,currentUser{isAdmin},operations{operation,targetType}}}"
        }
    };
}();
$7dc84e66153faa36$var$node.hash = "4d967e32f567d3367490b1d8fb6f1ecf";
var $7dc84e66153faa36$export$2e2bcd8739ae039 = $7dc84e66153faa36$var$node;
module.exports["default"] = $7dc84e66153faa36$export$2e2bcd8739ae039;

});

parcelRegister("iquRY", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $24WXz = parcelRequire("24WXz");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $cccaa992351fdb79$export$dcac763621aee435 = ()=>{
    const $ = (0, $bDgLe.c)(6);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== cloudId) {
        t0 = {
            variables: {
                cloudId: cloudId
            },
            onError: $cccaa992351fdb79$var$_temp
        };
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $24WXz.default), {
        ...t0,
        __callerPackage__: "space-utils"
    });
    const isNotPreRoles = data?.confluence_spaceRoleMode ? data.confluence_spaceRoleMode !== "PRE_ROLES" : false;
    const t1 = data?.confluence_spaceRoleMode;
    let t2;
    if ($[2] !== isNotPreRoles || $[3] !== loading || $[4] !== t1) {
        t2 = {
            spaceRoleMode: t1,
            isRbacEnabled: isNotPreRoles,
            loading: loading
        };
        $[2] = isNotPreRoles;
        $[3] = loading;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
};
function $cccaa992351fdb79$var$_temp(error) {
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
    });
    (0, $7Sm4c.markErrorAsHandled)(error);
}
module.exports["useSpaceRoleMode"] = $cccaa992351fdb79$export$dcac763621aee435;

});

parcelRegister("24WXz", function(module, exports) {
/**
 * @generated SignedSource<<2ff02ee1cce578f61d9a435abf2def2c>>
 * @relayHash 60ed41889a4cd98154a0419dcf1f59f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82
const $016cc5cc0310f39a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_spaceRoleMode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "60ed41889a4cd98154a0419dcf1f59f5",
            "id": "568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82",
            "metadata": {},
            "name": "useSpaceRoleModeQuery",
            "operationKind": "query",
            "text": "query useSpaceRoleModeQuery($cloudId:ID!){confluence_spaceRoleMode(cloudId:$cloudId)}"
        }
    };
}();
$016cc5cc0310f39a$var$node.hash = "88c4ae8983cc6692099b2b1e1d7a4379";
var $016cc5cc0310f39a$export$2e2bcd8739ae039 = $016cc5cc0310f39a$var$node;
module.exports["default"] = $016cc5cc0310f39a$export$2e2bcd8739ae039;

});

parcelRegister("bgRei", function(module, exports) {

var $8lkfF = parcelRequire("8lkfF");


var $cozmU = parcelRequire("cozmU");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $jMyy4 = parcelRequire("jMyy4");


var $j0YKV = parcelRequire("j0YKV");

const $6b8bec8977e1e896$export$c2d35981ca787f77 = ({ objectId: objectId, objectType: objectType = (0, $j0YKV.PublicLinkPermissionsObjectType).CONTENT, skip: skip })=>{
    const { loading: loading, error: error, data: data, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $8lkfF.default), {
        variables: {
            objectId: objectId,
            objectType: objectType
        },
        skip: skip,
        __callerPackage__: "public-links"
    });
    (0, $cozmU.useEffect)(()=>{
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    }, [
        error
    ]);
    const hasEditPermission = data?.publicLinkPermissionsForObject?.permissions?.includes((0, $j0YKV.PublicLinkPermissionsType).EDIT) ?? false;
    return loading ? {
        isLoading: true,
        refetch: refetch
    } : {
        isLoading: false,
        error: error,
        refetch: refetch,
        data: error ? undefined : {
            hasEditPermission: hasEditPermission,
            permissions: data?.publicLinkPermissionsForObject?.permissions ?? []
        }
    };
};
module.exports["usePublicLinkPermissionsForObject"] = $6b8bec8977e1e896$export$c2d35981ca787f77;

});

parcelRegister("8lkfF", function(module, exports) {
/**
 * @generated SignedSource<<9a6c634bec957f616ceda4f39993c91a>>
 * @relayHash f71176804f0f8510a7464cc538777917
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52a378cda6f621b63f57ad3ac3acae72028609509efa958d34656dfe1fe45eb1
const $5d187f97ac5d0d36$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "objectId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "objectType"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "objectId",
                    "variableName": "objectId"
                },
                {
                    "kind": "Variable",
                    "name": "objectType",
                    "variableName": "objectType"
                }
            ],
            "concreteType": "PublicLinkPermissions",
            "kind": "LinkedField",
            "name": "publicLinkPermissionsForObject",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "permissions"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f71176804f0f8510a7464cc538777917",
            "id": "52a378cda6f621b63f57ad3ac3acae72028609509efa958d34656dfe1fe45eb1",
            "metadata": {},
            "name": "usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery",
            "operationKind": "query",
            "text": "query usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery($objectId:ID!,$objectType:PublicLinkPermissionsObjectType!){publicLinkPermissionsForObject(objectId:$objectId,objectType:$objectType){permissions}}"
        }
    };
}();
$5d187f97ac5d0d36$var$node.hash = "374477f8db79649c77f638ae2ac0ca9b";
var $5d187f97ac5d0d36$export$2e2bcd8739ae039 = $5d187f97ac5d0d36$var$node;
module.exports["default"] = $5d187f97ac5d0d36$export$2e2bcd8739ae039;

});

parcelRegister("j0YKV", function(module, exports) {
/**
 * @generated SignedSource<<f0cd509e142f69bcae46da270cdbb1c1>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $d2563be1c2ded005$export$fcb2676e4c5b8efd = /*#__PURE__*/ function(PublicLinkPermissionsObjectType) {
    PublicLinkPermissionsObjectType["CONTENT"] = "CONTENT";
    return PublicLinkPermissionsObjectType;
}({});
var $d2563be1c2ded005$export$1d899d09218cc934 = /*#__PURE__*/ function(PublicLinkPermissionsType) {
    PublicLinkPermissionsType["EDIT"] = "EDIT";
    return PublicLinkPermissionsType;
}({});
module.exports["PublicLinkPermissionsObjectType"] = $d2563be1c2ded005$export$fcb2676e4c5b8efd;
module.exports["PublicLinkPermissionsType"] = $d2563be1c2ded005$export$1d899d09218cc934;

});

parcelRegister("6yCgm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");


const $41e0b21c174fc489$var$MainButtonsLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "4iG9v",
    name: "MainButtonsLoader",
    loader: async ()=>{
        return (await (parcelRequire("adcAL"))).MainButtons;
    }
});

const $41e0b21c174fc489$var$MainButtonsSSRLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "g2Qnu",
    name: "MainButtonsSSRLoader",
    loader: async ()=>{
        return (await (parcelRequire("adcAL"))).MainButtons;
    }
});
const $41e0b21c174fc489$export$f636d1325d93ee35 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, (0, $9wGTI.fg)('confluence_frontend_usd_ssr') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($41e0b21c174fc489$var$MainButtonsSSRLoader, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($41e0b21c174fc489$var$MainButtonsLoader, props));
const $41e0b21c174fc489$export$4fca0dd91afb40c6 = async ()=>$41e0b21c174fc489$var$MainButtonsLoader.preload();
module.exports["MainButtons"] = $41e0b21c174fc489$export$f636d1325d93ee35;
module.exports["loadMainButtons"] = $41e0b21c174fc489$export$4fca0dd91afb40c6;

});

parcelRegister("adcAL", function(module, exports) {

let $76f4e2c7beaaa9d4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $76f4e2c7beaaa9d4$var$load("bYzij"),
    $76f4e2c7beaaa9d4$var$load("8zMmc"),
    $76f4e2c7beaaa9d4$var$load("houtd"),
    $76f4e2c7beaaa9d4$var$load("ddvkk"),
    $76f4e2c7beaaa9d4$var$load("3upHR"),
    $76f4e2c7beaaa9d4$var$load("bjimZ"),
    $76f4e2c7beaaa9d4$var$load("kUfAt"),
    $76f4e2c7beaaa9d4$var$load("hZ2FX"),
    $76f4e2c7beaaa9d4$var$load("HaNwW"),
    $76f4e2c7beaaa9d4$var$load("4t77a"),
    $76f4e2c7beaaa9d4$var$load("8LtYa"),
    $76f4e2c7beaaa9d4$var$load("jXA76"),
    $76f4e2c7beaaa9d4$var$load("i1fe2"),
    $76f4e2c7beaaa9d4$var$load("diyjB"),
    $76f4e2c7beaaa9d4$var$load("6damH"),
    $76f4e2c7beaaa9d4$var$load("idSqX"),
    $76f4e2c7beaaa9d4$var$load("h4Nf7"),
    $76f4e2c7beaaa9d4$var$load("4XkGy"),
    $76f4e2c7beaaa9d4$var$load("fuOfV"),
    $76f4e2c7beaaa9d4$var$load("jL1Ke"),
    $76f4e2c7beaaa9d4$var$load("5MQ0D"),
    $76f4e2c7beaaa9d4$var$load("Kj0I8"),
    $76f4e2c7beaaa9d4$var$load("5xnun"),
    $76f4e2c7beaaa9d4$var$load("59hV4"),
    $76f4e2c7beaaa9d4$var$load("6wr18"),
    $76f4e2c7beaaa9d4$var$load("5dkX4"),
    $76f4e2c7beaaa9d4$var$load("el56J"),
    $76f4e2c7beaaa9d4$var$load("ibo4x"),
    $76f4e2c7beaaa9d4$var$load("e2WH6"),
    $76f4e2c7beaaa9d4$var$load("5vzT0"),
    $76f4e2c7beaaa9d4$var$load("lbsQO"),
    $76f4e2c7beaaa9d4$var$load("3kVph"),
    $76f4e2c7beaaa9d4$var$load("ffEVr"),
    $76f4e2c7beaaa9d4$var$load("aIddG"),
    $76f4e2c7beaaa9d4$var$load("jZMUd"),
    $76f4e2c7beaaa9d4$var$load("2EIkU"),
    $76f4e2c7beaaa9d4$var$load("iUXaE"),
    $76f4e2c7beaaa9d4$var$load("lTkx9"),
    $76f4e2c7beaaa9d4$var$load("Wowvf"),
    $76f4e2c7beaaa9d4$var$load("eRhBr"),
    $76f4e2c7beaaa9d4$var$load("daX4F"),
    $76f4e2c7beaaa9d4$var$load("6HpsR"),
    $76f4e2c7beaaa9d4$var$load("N3oqb"),
    $76f4e2c7beaaa9d4$var$load("ayJxT"),
    $76f4e2c7beaaa9d4$var$load("9ZY0g"),
    $76f4e2c7beaaa9d4$var$load("hhss7"),
    $76f4e2c7beaaa9d4$var$load("7EorR"),
    $76f4e2c7beaaa9d4$var$load("lP66B")
]).then(()=>parcelRequire('dcfqD'));

});

parcelRegister("aYZaZ", function(module, exports) {
$parcel$export(module.exports, "Buttons", () => (parcelRequire("iQb1R")).Buttons);

var $jmjWc = parcelRequire("jmjWc");


var $6tSjb = parcelRequire("6tSjb");


var $iQb1R = parcelRequire("iQb1R");


const $ecc7cc41466863e8$export$82d507aca0e648e3 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ZRz6B",
    name: "EllipsisDropdownComponent",
    loader: async ()=>(await (parcelRequire("30WyI"))).EllipsisDropdownComponent,
    loading: (0, $6tSjb.EllipsisPlaceholder)
});
module.exports["EllipsisDropdownComponent"] = $ecc7cc41466863e8$export$82d507aca0e648e3;

});

parcelRegister("6tSjb", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $5SGpQ = parcelRequire("5SGpQ");


var $6TaGl = parcelRequire("6TaGl");

const $565f8db62106cdff$var$i18n = (0, $kSwu1.defineMessages)({
    more: {
        id: "editor-ellipsis-dropdown.placeholder.ellipsis.more",
        defaultMessage: "More"
    }
});
const $565f8db62106cdff$export$2edf2f3658d4e349 = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    const label = intl.formatMessage($565f8db62106cdff$var$i18n.more);
    const moreIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
        color: "currentColor",
        spacing: "spacious",
        label: label
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5SGpQ.default), {
        testId: "ellipsis-placeholder",
        isDisabled: true,
        iconBefore: moreIcon,
        appearance: "subtle"
    });
};
module.exports["EllipsisPlaceholder"] = $565f8db62106cdff$export$2edf2f3658d4e349;

});

parcelRegister("30WyI", function(module, exports) {

let $231ecbc496b559b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $231ecbc496b559b3$var$load("1bT50"),
    $231ecbc496b559b3$var$load("bYzij"),
    $231ecbc496b559b3$var$load("6wr18"),
    $231ecbc496b559b3$var$load("diyjB"),
    $231ecbc496b559b3$var$load("ffEVr"),
    $231ecbc496b559b3$var$load("iY5MP")
]).then(()=>parcelRequire('3d2EW'));

});

parcelRegister("iQb1R", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $f15550a75cff81e6$export$665d5a662b7213f3 = /*#__PURE__*/ function(Buttons) {
    Buttons["DELETE_DRAFT"] = "delete-draft";
    Buttons["EDIT_LABELS"] = "edit-labels";
    Buttons["MOVE_PAGE"] = "move-page";
    Buttons["PREVIEW"] = "preview";
    Buttons["PUBLISH_WITHOUT_NOTIFY"] = "publish-without-notify";
    Buttons["RESOLVED_COMMENTS"] = "resolved-comments";
    Buttons["TEMPLATE_BROWSER"] = "template-browser";
    Buttons["VIEW_CHANGES"] = "view-changes";
    Buttons["EXPORT"] = "export";
    Buttons["ADVANCED"] = "advanced";
    Buttons["ARCHIVE"] = "archive";
    Buttons["ATTACHMENTS"] = "attachments";
    Buttons["SWITCH_TO_LIVE_EDIT"] = "switch-to-live-edit";
    Buttons["CLASSIFY_CONTENT"] = "classify-content";
    Buttons["MANAGE"] = "manage";
    Buttons["PRESENT"] = "presentation-mode";
    return Buttons;
}({});
module.exports["Buttons"] = $f15550a75cff81e6$export$665d5a662b7213f3;

});

parcelRegister("kATGJ", function(module, exports) {

let $efe25df63503f6fb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $efe25df63503f6fb$var$load("5vzT0"),
    $efe25df63503f6fb$var$load("4sZyu")
]).then(()=>parcelRequire('3iK0z'));

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("jacyh", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $d9bb792bb433dc50$var$initialState = {
    shouldForceRefetch: false // this is just a boolean that we toggle between false and true to force a refetch in blog tree
};
const $d9bb792bb433dc50$var$actions = {
    forceRefetchBlogTree: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                shouldForceRefetch: !currentState.shouldForceRefetch
            });
        }
};
const $d9bb792bb433dc50$var$BlogTreeStore = (0, $8s9DV.createStore)({
    initialState: $d9bb792bb433dc50$var$initialState,
    actions: $d9bb792bb433dc50$var$actions
});
const $d9bb792bb433dc50$export$9638016a54f09a07 = (0, $kBr4q.createHook)($d9bb792bb433dc50$var$BlogTreeStore);
const $d9bb792bb433dc50$export$861bc4451e1cbefa = (0, $kBr4q.createActionsHook)($d9bb792bb433dc50$var$BlogTreeStore);
module.exports["useBlogTreeStore"] = $d9bb792bb433dc50$export$9638016a54f09a07;
module.exports["useBlogTreeActions"] = $d9bb792bb433dc50$export$861bc4451e1cbefa;

});

parcelRegister("fwwrH", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0ba5a3a0ecf1d3dc$export$b44f4ceffd8a6e44 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "0XSep",
    name: "SmartCreateFeedbackBannerLoader",
    loader: async ()=>(await (parcelRequire("7TKX8"))).SmartCreateFeedbackBanner
});
module.exports["SmartCreateFeedbackBannerLoader"] = $0ba5a3a0ecf1d3dc$export$b44f4ceffd8a6e44;

});

parcelRegister("7TKX8", function(module, exports) {

let $5c0217513e888859$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5c0217513e888859$var$load("hhss7"),
    $5c0217513e888859$var$load("ddvkk"),
    $5c0217513e888859$var$load("3upHR"),
    $5c0217513e888859$var$load("hzVe9")
]).then(()=>parcelRequire('dSB3l'));

});

parcelRegister("eD8ha", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $98d4df931c17ad78$export$d11bc9a2de7fd8e3 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9jK-r",
    name: "BlankPageQuickActions",
    loader: async ()=>(await (parcelRequire("eIPsp"))).BlankPageQuickActions
});
module.exports["BlankPageQuickActions"] = $98d4df931c17ad78$export$d11bc9a2de7fd8e3;

});

parcelRegister("eIPsp", function(module, exports) {

let $ab7d171029e1d362$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ab7d171029e1d362$var$load("ddvkk"),
    $ab7d171029e1d362$var$load("3upHR"),
    $ab7d171029e1d362$var$load("hZ2FX"),
    $ab7d171029e1d362$var$load("9ZY0g"),
    $ab7d171029e1d362$var$load("6wr18"),
    $ab7d171029e1d362$var$load("4X1QD"),
    $ab7d171029e1d362$var$load("4WTdS"),
    $ab7d171029e1d362$var$load("9WR9l"),
    $ab7d171029e1d362$var$load("eoE6x"),
    $ab7d171029e1d362$var$load("ffEVr"),
    $ab7d171029e1d362$var$load("hhss7"),
    $ab7d171029e1d362$var$load("lbsQO"),
    $ab7d171029e1d362$var$load("daX4F"),
    $ab7d171029e1d362$var$load("ayJxT"),
    $ab7d171029e1d362$var$load("jzQ6f")
]).then(()=>parcelRequire('ylKHA'));

});

parcelRegister("7Jde4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e145ebbd6eaf2e0b8e4930467ce4a33d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a06fec133986b41$var$_react = $5a06fec133986b41$var$_interopRequireDefault((parcelRequire("cozmU")));

var $5a06fec133986b41$var$_baseNew = $5a06fec133986b41$var$_interopRequireDefault((parcelRequire("gElAV")));
function $5a06fec133986b41$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeCleanup".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for automated cleanup and tidy functionality
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5a06fec133986b41$var$AiGenerativeCleanupIcon = (props)=>/*#__PURE__*/ $5a06fec133986b41$var$_react.default.createElement($5a06fec133986b41$var$_baseNew.default, Object.assign({
        name: "AiGenerativeCleanupIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.23.44 12.22 8h1.58a2 2 0 0 1 1.91 2.59l-1.23 4a2 2 0 0 1-1.9 1.41H4.75a.75.75 0 0 1-.28-1.45h-.01l.02-.01q.03-.01.1-.06c.09-.06.23-.16.39-.32.31-.32.71-.88.93-1.84l.03-.09L7 9.3A2 2 0 0 1 8.87 8h1.8L12.78.06zM8.87 9.5a.5.5 0 0 0-.47.33l-1.06 2.89a5.7 5.7 0 0 1-.73 1.78h5.97a.5.5 0 0 0 .48-.35l1.23-4a.5.5 0 0 0-.48-.65zM4.62 1.01a.75.75 0 0 1 .54.38l.05.11.54 1.47.05.1a.5.5 0 0 0 .25.2l1.47.54.11.05a.75.75 0 0 1 0 1.31l-.11.05-1.47.54a.5.5 0 0 0-.3.3l-.54 1.47a.75.75 0 0 1-1.36.11l-.05-.1-.54-1.47a.5.5 0 0 0-.2-.25l-.1-.05-1.47-.53a.75.75 0 0 1-.48-.59L1 4.5l.01-.12a.75.75 0 0 1 .48-.59l1.47-.54.1-.05a.5.5 0 0 0 .2-.25l.54-1.47.05-.11A.75.75 0 0 1 4.5 1z"/>`
    }, props));
$5a06fec133986b41$var$AiGenerativeCleanupIcon.displayName = 'AiGenerativeCleanupIcon';
var $5a06fec133986b41$var$_default = module.exports.default = $5a06fec133986b41$var$AiGenerativeCleanupIcon;

});

parcelRegister("1FxtB", function(module, exports) {

var $jb2R2 = parcelRequire("jb2R2");


var $6mKj3 = parcelRequire("6mKj3");


var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");


var $JCGnt = parcelRequire("JCGnt");


var $kOUwv = parcelRequire("kOUwv");

const $5ae9e99501c25483$var$FIRST_TWO_WEEKS_THRESHOLD = 14;
const $5ae9e99501c25483$var$FIRST_ACTIVATION_DATE_TRAIT = 'firstActivationDate';
const $5ae9e99501c25483$var$AUTO_PROVISIONED_TRAIT = 'is_jira_confluence_d0_auto-provisioned';
const $5ae9e99501c25483$export$7f1639616eb37dbb = ({ skip: skip } = {})=>{
    // User-level: check if this user's first active date is within 14 days (for AP Xflow)
    const { isNewUser: isNewUser, loading: isNewUserLoading } = (0, $JCGnt.useIsNewUser)({
        activeDaysThreshold: $5ae9e99501c25483$var$FIRST_TWO_WEEKS_THRESHOLD
    }, Boolean(skip));
    // Tenant-level: check site traits for activation date and auto-provisioned status
    const { data: siteTraitsData, loading: isSiteTraitsLoading } = (0, $kOUwv.useSiteTraits)();
    const siteActivationDate = siteTraitsData?.attributes?.find(({ name: name })=>name === $5ae9e99501c25483$var$FIRST_ACTIVATION_DATE_TRAIT)?.value;
    const isSiteNewlyActivated = Boolean(siteActivationDate) && (0, $jb2R2.default)(new Date(), new Date(siteActivationDate)) < $5ae9e99501c25483$var$FIRST_TWO_WEEKS_THRESHOLD;
    const isAutoProvisioned = siteTraitsData?.attributes?.find(({ name: name })=>name === $5ae9e99501c25483$var$AUTO_PROVISIONED_TRAIT)?.value === 'true';
    // Check if the user is the founding admin (exclude nth users)
    const { data: onboardingStateData, loading: isOnboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN
    ], Boolean(skip));
    const { isFoundingAdmin: isFoundingAdmin } = (0, $ivb8S.deserializeState)(onboardingStateData);
    // When skip is true, return without calling expVal (which fires exposure).
    // This allows consumers to defer the exposure event until the UI is actually rendered.
    // Note: hooks above must still be called unconditionally to satisfy React's rules of hooks.
    if (skip) return {
        isEnabled: false,
        loading: false
    };
    // If still loading, don't enable yet
    if (isNewUserLoading || isSiteTraitsLoading || isOnboardingStateLoading) return {
        isEnabled: false,
        loading: true
    };
    // Only target founding admins (exclude nth users)
    if (!isFoundingAdmin) return {
        isEnabled: false,
        loading: false
    };
    // Determine if the tenant/user is within the first 14 days based on tenant type:
    // - AP Xflow: use user-level date (confluence_first_active via useIsNewUser)
    // - Non-AP Xflow / Land: use tenant-level date (firstActivationDate)
    const isWithinFirstTwoWeeks = isAutoProvisioned ? isNewUser : isSiteNewlyActivated;
    if (!isWithinFirstTwoWeeks) return {
        isEnabled: false,
        loading: false
    };
    return {
        isEnabled: (0, $6mKj3.expVal)('cfind-5926-upload-in-onboarding', 'isEnabled', false),
        loading: false
    };
};
module.exports["useCfind5926UploadInOnboarding"] = $5ae9e99501c25483$export$7f1639616eb37dbb;

});

parcelRegister("dBcar", function(module, exports) {
const $3c94963df51c0e13$export$4ddca8f5712d2331 = 'onboarding-state:';
const $3c94963df51c0e13$export$f35f2899eb1390e3 = 'peopleNudge';
const $3c94963df51c0e13$export$532485ca1547f1aa = 'legacy';
const $3c94963df51c0e13$export$31c8494ea74d2536 = 'introWorkflow';
const $3c94963df51c0e13$export$1f72e9a162b3795b = 'firstSpaceSelected';
const $3c94963df51c0e13$export$6315bee451a9fcc6 = 'teamSpaceCreated';
const $3c94963df51c0e13$export$c4e14780cf349e73 = 'xflowSpaceCreated';
const $3c94963df51c0e13$export$275d3dda87d2fa7a = 'nthUserOnboardingCompletedTimestamp';
const $3c94963df51c0e13$export$da223e550b96c9d6 = 'help';
const $3c94963df51c0e13$export$ffb6b379ff35f9e = 'onboardingIntents';
const $3c94963df51c0e13$export$d3276a0d758ffd2b = 'isFoundingAdmin';
const $3c94963df51c0e13$export$756b1a5a6b2488c3 = 'isSampleContentV2SpotlightVisible';
const $3c94963df51c0e13$export$8e5a8e09b19b20a8 = 'isMoreActionsTourVisible';
const $3c94963df51c0e13$export$2e10b71f921ae144 = 'isMoreActionsHintVisible';
const $3c94963df51c0e13$export$82fe49566957c443 = 'landOnPath';
const $3c94963df51c0e13$export$f6c79e39ab4496db = 'templateOnboardingViewedTime';
const $3c94963df51c0e13$export$49ac0bbeb4be0a06 = {
    ONBOARDING_INTENT_EXPERIENCES_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceClosed',
    ONBOARDING_EXPERIENCE_ELIGIBLE: 'onboarding-intent-experience:isOnboardingExperienceEligibleUser',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_VIEWED_AT: 'onboarding-intent-experiences:onboardingIntentExperienceLandViewedAt',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceLandClosed'
};
const $3c94963df51c0e13$export$6167e5b70dfd11d9 = {
    MODAL_SEEN: 'onboarding-reverse-trial:isModalSeen'
};
const $3c94963df51c0e13$export$49c044e5e3ccc2af = {
    EXPERIMENT_ELIGIBLE: 'templates-collection:isTaggedForTemplatesCollectionExperiment',
    EXPERIMENT_DISMISSED: 'templates-collection:isTemplatesSectionDismissed'
};
const $3c94963df51c0e13$export$dcbccfe8799c3c7b = {
    IS_DISMISSED: 'space-getting-started-tour:tourIsDismissed'
};
const $3c94963df51c0e13$export$305c55ea55928edf = {
    HAS_INVITE_CAPABILITIES: 'persistent-invite:hasInviteCapabilities'
};
const $3c94963df51c0e13$export$8b7e53c326da02ac = 'improvedGetStartedPath';
const $3c94963df51c0e13$export$cfc1794f56ac0d83 = 'improvedGetStartedWhiteboardPath';
const $3c94963df51c0e13$export$39a89660e80fa1a = 'isRedactionsTourVisible';
const $3c94963df51c0e13$export$b99b309b286adebc = 'nav4:isNav4GlobalSpotlightDismissed';
const $3c94963df51c0e13$export$20b0548cf5859d6 = 'nav4:isNav4SpaceTourDismissed';
const $3c94963df51c0e13$export$4d93dfc1d8538d55 = 'nav4:isNav4CollapseReminderSpotlightDismissed';
const $3c94963df51c0e13$export$94a4264abda026cc = 'creation-focused-nav:shouldShowSpotlight';
const $3c94963df51c0e13$export$f0597adb063e4c38 = 'creation-focused-nav:startTime';
const $3c94963df51c0e13$export$7ed75560092630f6 = {
    IS_SPOTLIGHT_DISMISS: 'whats-new-in-confluence:isWhatsNewInConfluneceSpotlightDismissed',
    PULSE_SEEN_AT: 'whats-new-in-confluence:whatsNewInConfluencePulseSeenAt'
};
const $3c94963df51c0e13$export$6c014427ebb0cbae = {
    HAS_SEEN_SPLASH_MODAL: 'create-with-rovo-announcement-splash:hasSeenSplashModal'
};
const $3c94963df51c0e13$export$ebacd4ef7f5400e2 = {
    CHAT_AUTO_OPENED: 'welcome-from-rovo:chatAutoOpened'
};
const $3c94963df51c0e13$export$d1ec748fb682ca97 = {
    NTH_USER_SELECTED_CONTENT_TYPE: 'nth-user-setup:nthUserSelectedContentType',
    NTH_USER_CONTENT_TYPE_SPOTLIGHT_SEEN: 'nth-user-setup:nthUserContentTypeSpotlightSeen',
    NTH_USER_CONTENT_TYPE_POPULAR_CONTENT_FOUND: 'nth-user-setup:nthUserContentTypePopularContentFound',
    NTH_USER_CONTENT_TYPE_LANDING_CONTENT_ID: 'nth-user-setup:nthUserContentTypeLandingContentId'
};
const $3c94963df51c0e13$export$1a3a43cef0acd011 = {
    PROMPT_DISMISSED: 'prompt-whiteboard-competitor-link:isPromptDismissed'
};
const $3c94963df51c0e13$export$5b471e2344a37be7 = {
    DISMISSED: 'prompt-database-competitor-link:isPromptDatabaseDismissed'
};
const $3c94963df51c0e13$export$c81223a0ce3b63df = {
    HAS_AUTO_FOLLOWED_SPACES: 'nth-user-auto-follow-spaces:hasAutoFollowedSpaces'
};
const $3c94963df51c0e13$export$f1328b04dc902e1f = {
    REVAMPED_BPQA_SHOWN_AT: 'land-users-in-editor-with-revamped-bpqa:revampedBpqaShownAt'
};
const $3c94963df51c0e13$export$e986b94fd54d134 = {
    SELECTED_TEMPLATES: 'use-cases-nth-user-onboarding:selectedTemplates',
    VIEWED_AT: 'use-cases-nth-user-onboarding:viewedAt',
    DISMISSED_HEADER: 'use-cases-nth-user-onboarding:headerDismissed',
    VIEWED_HEADER: 'use-cases-nth-user-onboarding:headerViewedAt'
};
const $3c94963df51c0e13$export$bbdc3607431bd9d3 = {
    EMOJI_TITLE_DISCOVERED: 'auto-page-emoji:emojiTitleDiscovered'
};
const $3c94963df51c0e13$export$31a43870c77aad50 = {
    NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE: 'simplify-nav-new-user:nthUserD0SimplifiedNavEligible',
    NTH_USER_D0_SIMPLIFIED_NAV_START_AT: 'simplify-nav-new-user:nthUserD0SimplifiedNavStartAt'
};
const $3c94963df51c0e13$export$400b215814bf3fc0 = {
    CHECKED_ELIGIBLE: 'creation-focused-nav-xflow:creationFocusedNavXflowCheckedEligible',
    START_AT: 'creation-focused-nav-xflow:creationFocusedNavXflowStartAt'
};
const $3c94963df51c0e13$export$94df39cf9e5d9804 = {
    TRENDING_PAGES: 'cross-join-nth-user-onboarding:trendingPages',
    DISMISSED: 'cross-join-nth-user-onboarding:dismissed'
};
const $3c94963df51c0e13$export$bfeb2da96277b623 = {
    INTRO_WORKFLOW: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$31c8494ea74d2536}`,
    LEGACY_ONBOARDING_STATE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$532485ca1547f1aa}`,
    IS_FOUNDING_ADMIN: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$d3276a0d758ffd2b}`,
    IS_SAMPLE_CONTENT_V2_SPOTLIGHT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$756b1a5a6b2488c3}`,
    LAND_ON_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$82fe49566957c443}`,
    TEAM_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$6315bee451a9fcc6}`,
    IS_MORE_ACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8e5a8e09b19b20a8}`,
    IS_MORE_ACTIONS_HINT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$2e10b71f921ae144}`,
    IMPROVED_GET_STARTED_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8b7e53c326da02ac}`,
    IMPROVED_GET_STARTED_WHITEBOARD_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$cfc1794f56ac0d83}`,
    IS_REDACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$39a89660e80fa1a}`,
    XFLOW_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$c4e14780cf349e73}`,
    TEMPLATE_ONBOARDING_VIEWED_TIME: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$f6c79e39ab4496db}`,
    NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$275d3dda87d2fa7a}`
};
const $3c94963df51c0e13$export$1660a2d7c2fff354 = '__complete__';
const $3c94963df51c0e13$export$66aa87593037fd4a = $3c94963df51c0e13$export$bfeb2da96277b623.LEGACY_ONBOARDING_STATE;
const $3c94963df51c0e13$export$d4f5dd2b883b8982 = [
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38,
    $3c94963df51c0e13$export$31a43870c77aad50.NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE,
    $3c94963df51c0e13$export$31a43870c77aad50.NTH_USER_D0_SIMPLIFIED_NAV_START_AT
];
const $3c94963df51c0e13$export$7a13c575f2c75084 = [
    ...Object.values($3c94963df51c0e13$export$49ac0bbeb4be0a06),
    ...Object.values($3c94963df51c0e13$export$6167e5b70dfd11d9),
    ...Object.values($3c94963df51c0e13$export$49c044e5e3ccc2af),
    ...Object.values($3c94963df51c0e13$export$dcbccfe8799c3c7b),
    ...Object.values($3c94963df51c0e13$export$305c55ea55928edf),
    $3c94963df51c0e13$export$b99b309b286adebc,
    $3c94963df51c0e13$export$20b0548cf5859d6,
    $3c94963df51c0e13$export$4d93dfc1d8538d55,
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38,
    ...Object.values($3c94963df51c0e13$export$7ed75560092630f6),
    ...Object.values($3c94963df51c0e13$export$6c014427ebb0cbae),
    ...Object.values($3c94963df51c0e13$export$ebacd4ef7f5400e2),
    ...Object.values($3c94963df51c0e13$export$d1ec748fb682ca97),
    ...Object.values($3c94963df51c0e13$export$1a3a43cef0acd011),
    ...Object.values($3c94963df51c0e13$export$5b471e2344a37be7),
    ...Object.values($3c94963df51c0e13$export$bfeb2da96277b623),
    ...Object.values($3c94963df51c0e13$export$c81223a0ce3b63df),
    ...Object.values($3c94963df51c0e13$export$f1328b04dc902e1f),
    ...Object.values($3c94963df51c0e13$export$e986b94fd54d134),
    ...Object.values($3c94963df51c0e13$export$bbdc3607431bd9d3),
    ...Object.values($3c94963df51c0e13$export$31a43870c77aad50),
    ...Object.values($3c94963df51c0e13$export$400b215814bf3fc0),
    ...Object.values($3c94963df51c0e13$export$94df39cf9e5d9804)
];
module.exports["ONBOARDING_INTENT_EXPERIENCES"] = $3c94963df51c0e13$export$49ac0bbeb4be0a06;
module.exports["TEMPLATES_COLLECTION"] = $3c94963df51c0e13$export$49c044e5e3ccc2af;
module.exports["PERSISTENT_INVITE"] = $3c94963df51c0e13$export$305c55ea55928edf;
module.exports["IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED"] = $3c94963df51c0e13$export$4d93dfc1d8538d55;
module.exports["CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT"] = $3c94963df51c0e13$export$94a4264abda026cc;
module.exports["CREATION_FOCUSED_NAV_START_TIME"] = $3c94963df51c0e13$export$f0597adb063e4c38;
module.exports["CREATE_WITH_ROVO_ANNOUNCEMENT_SPLASH"] = $3c94963df51c0e13$export$6c014427ebb0cbae;
module.exports["WELCOME_FROM_ROVO_CHAT"] = $3c94963df51c0e13$export$ebacd4ef7f5400e2;
module.exports["NTH_USER_SETUP_CONTENT_TYPE"] = $3c94963df51c0e13$export$d1ec748fb682ca97;
module.exports["PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED"] = $3c94963df51c0e13$export$1a3a43cef0acd011;
module.exports["NTH_USER_AUTO_FOLLOW_SPACES"] = $3c94963df51c0e13$export$c81223a0ce3b63df;
module.exports["LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA"] = $3c94963df51c0e13$export$f1328b04dc902e1f;
module.exports["USE_CASES_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$e986b94fd54d134;
module.exports["NTH_USER_EMOJI_TITLE_DISCOVERED"] = $3c94963df51c0e13$export$bbdc3607431bd9d3;
module.exports["SIMPLIFY_NAV_NEW_USER"] = $3c94963df51c0e13$export$31a43870c77aad50;
module.exports["CFIND_5565_CREATION_FOCUSED_NAV_XFLOW"] = $3c94963df51c0e13$export$400b215814bf3fc0;
module.exports["CROSS_JOIN_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$94df39cf9e5d9804;
module.exports["ONBOARDING_EXPERIENCES"] = $3c94963df51c0e13$export$bfeb2da96277b623;
module.exports["COMPLETE"] = $3c94963df51c0e13$export$1660a2d7c2fff354;
module.exports["NAV_EXPERIMENT_ONBOARDING_KEYS"] = $3c94963df51c0e13$export$d4f5dd2b883b8982;
module.exports["OnboardingKeys"] = $3c94963df51c0e13$export$7a13c575f2c75084;

});

parcelRegister("JCGnt", function(module, exports) {

var $6vgLy = parcelRequire("6vgLy");


var $f7MuR = parcelRequire("f7MuR");

const $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $affa2edf03b5b535$export$750d18e9348a361a = ({ activeDaysThreshold: activeDaysThreshold = 28, activeUserCutoffDate: activeUserCutoffDate }, skip = false)=>{
    const { data: data, loading: loading, error: error } = (0, $f7MuR.useSiteUserTraits)({
        skipBootstrap: skip
    });
    const confluenceFirstActive = data?.attributes?.find(({ name: name })=>name === $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const firstActiveDate = confluenceFirstActive ? new Date(confluenceFirstActive) : null;
    const { isNewlyCreatedUser: isNewlyCreatedUser } = (0, $6vgLy.useShouldExcludeUser)({
        checkDate: firstActiveDate,
        daysThreshold: activeDaysThreshold,
        cutoffDate: activeUserCutoffDate
    });
    if (loading) return {
        isNewUser: null,
        loading: true
    };
    if (error) return {
        isNewUser: null,
        error: error
    };
    return {
        isNewUser: isNewlyCreatedUser,
        loading: false,
        error: null
    };
};
module.exports["useIsNewUser"] = $affa2edf03b5b535$export$750d18e9348a361a;

});

parcelRegister("6vgLy", function(module, exports) {

var $gkHoc = parcelRequire("gkHoc");

var $6Mfv2 = parcelRequire("6Mfv2");

var $esV19 = parcelRequire("esV19");

const $859f2d1feb92d345$export$30b189c21f25ee23 = ({ checkDate: checkDate, daysThreshold: daysThreshold = 14, cutoffDate: cutoffDate })=>{
    // If there is no check date, we cannot determine if user is new
    if (!checkDate) return {
        shouldExclude: true,
        isNewlyCreatedUser: null,
        isNewUserAfterCutoffDate: false
    };
    const isNewlyCreatedUser = (0, $6Mfv2.default)((0, $gkHoc.default)(checkDate, daysThreshold), new Date());
    // Check if user is a new user (date is AFTER the cutoff date)
    // These users don't need changeboarding since it's all new to them
    const isNewUserAfterCutoffDate = cutoffDate && (0, $esV19.default)(cutoffDate) ? (0, $6Mfv2.default)(checkDate, cutoffDate) : false;
    const shouldExclude = isNewlyCreatedUser || isNewUserAfterCutoffDate;
    return {
        shouldExclude: shouldExclude,
        isNewlyCreatedUser: isNewlyCreatedUser,
        isNewUserAfterCutoffDate: isNewUserAfterCutoffDate
    };
};
module.exports["useShouldExcludeUser"] = $859f2d1feb92d345$export$30b189c21f25ee23;

});

parcelRegister("gkHoc", function(module, exports) {
$parcel$export(module.exports, "default", () => $be402bcc938fe0c2$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $be402bcc938fe0c2$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("6Mfv2", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ef33fad4d0e8632$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $4ef33fad4d0e8632$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var dateToCompare = (0, $dkBOe.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("f7MuR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $26d702ce000cc6e9$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $26d702ce000cc6e9$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        }
};
const $26d702ce000cc6e9$export$39f521003d60a645 = (0, $8s9DV.createStore)({
    initialState: $26d702ce000cc6e9$var$initialState,
    actions: $26d702ce000cc6e9$var$actions,
    name: 'siteUserTraitsStore'
});
const $26d702ce000cc6e9$export$55703aaacc066827 = (0, $kBr4q.createHook)($26d702ce000cc6e9$export$39f521003d60a645);
const $26d702ce000cc6e9$export$60cc1c45e628d86f = (0, $kBr4q.createActionsHook)($26d702ce000cc6e9$export$39f521003d60a645);
async function $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $26d702ce000cc6e9$var$hasFetched = false;
function $26d702ce000cc6e9$export$f1fbc6ad89f91b89() {
    $26d702ce000cc6e9$var$hasFetched = false;
}
function $26d702ce000cc6e9$var$getSiteUserTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.siteUser);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.siteUser);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $26d702ce000cc6e9$export$f02520a2cf0afa96({ skip: skip, skipBootstrap: skipBootstrap, fetchPolicy: fetchPolicy = 'cache-first' } = {}) {
    // skip=true -> full idle, no preload/store/fetch
    const preloadedData = (0, $cozmU.useMemo)(()=>skip ? null : $26d702ce000cc6e9$var$getSiteUserTraitsFromSources(), [
        skip
    ]);
    const [storeState, storeActions] = $26d702ce000cc6e9$export$55703aaacc066827();
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    // Track whether cache-and-network fetch dispatched this mount
    const fetchDispatchedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (skip) return;
        if (!cloudId || !userId) return;
        if (skipBootstrap) return;
        if (!hasLicensedAccess) return;
        if (fetchPolicy === 'cache-first') {
            // Old behavior: don't fetch if we have data from any source
            if (preloadedData || storeState.data || storeState.loading || storeState.error) return;
            if ($26d702ce000cc6e9$var$hasFetched) return;
            $26d702ce000cc6e9$var$hasFetched = true;
            storeActions.start();
            $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then((data)=>storeActions.success(data), (err)=>storeActions.error(err));
        } else {
            // cache-and-network: fetch once per mount
            if (storeState.loading) {
                fetchDispatchedRef.current = true;
                return;
            }
            if (fetchDispatchedRef.current) return;
            fetchDispatchedRef.current = true;
            storeActions.start();
            $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then((data)=>storeActions.success(data), (err)=>storeActions.error(err));
        }
    }, [
        skip,
        skipBootstrap,
        fetchPolicy,
        cloudId,
        userId,
        hasLicensedAccess,
        preloadedData,
        storeState,
        storeActions
    ]);
    if (skip) return {
        data: null,
        loading: false,
        error: null
    };
    // Fetched store result wins over preloaded data
    if (storeState.data) return {
        data: storeState.data,
        loading: storeState.loading,
        error: storeState.error
    };
    if (preloadedData) return {
        data: preloadedData,
        loading: storeState.loading,
        error: null
    };
    return {
        data: null,
        loading: storeState.loading,
        error: storeState.error
    };
}
module.exports["useSiteUserTraits"] = $26d702ce000cc6e9$export$f02520a2cf0afa96;

});

parcelRegister("dcJRl", function(module, exports) {
const $1eca0028b5407519$export$bab1229873daab56 = (tapTraits)=>{
    if (!tapTraits || Object.entries(tapTraits).length === 0) return null;
    return Object.entries(tapTraits).reduce((acc, [name, value])=>[
            ...acc,
            {
                name: name,
                value: String(value)
            }
        ], []);
};
module.exports["formatTapTraits"] = $1eca0028b5407519$export$bab1229873daab56;

});

parcelRegister("kOUwv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $d684465712516a35$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $d684465712516a35$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $d684465712516a35$export$2d97e7bb018b0cfb = (0, $8s9DV.createStore)({
    initialState: $d684465712516a35$var$initialState,
    actions: $d684465712516a35$var$actions,
    name: 'siteTraitsStore'
});
const $d684465712516a35$export$c84f691b170cbee3 = (0, $kBr4q.createHook)($d684465712516a35$export$2d97e7bb018b0cfb);
const $d684465712516a35$export$2aca02eeb1d46515 = (0, $kBr4q.createActionsHook)($d684465712516a35$export$2d97e7bb018b0cfb);
async function $d684465712516a35$var$fetchSiteTraitsData(cloudId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $d684465712516a35$var$hasFetched = false;
function $d684465712516a35$export$f1fbc6ad89f91b89() {
    $d684465712516a35$var$hasFetched = false;
}
function $d684465712516a35$var$getSiteTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.site);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.site);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $d684465712516a35$export$fcebe75065597a98({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $cozmU.useMemo)(()=>$d684465712516a35$var$getSiteTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $d684465712516a35$export$c84f691b170cbee3();
    const { accessStatus: accessStatus, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $cozmU.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($d684465712516a35$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !cloudId) return;
        $d684465712516a35$var$hasFetched = true;
        storeActions.start();
        $d684465712516a35$var$fetchSiteTraitsData(cloudId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        cloudId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSiteTraits"] = $d684465712516a35$export$fcebe75065597a98;

});

parcelRegister("hV9Q1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $42a2f15877153857$export$48a171bbad47b95a = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "kR_kE",
    name: "TemplatePreview",
    loader: async ()=>(await (parcelRequire("aeRz8"))).TemplatePreview
});
module.exports["TemplatePreview"] = $42a2f15877153857$export$48a171bbad47b95a;

});

parcelRegister("aeRz8", function(module, exports) {

let $7744c33afd84ac16$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7744c33afd84ac16$var$load("icfaw"),
    $7744c33afd84ac16$var$load("gbejv"),
    $7744c33afd84ac16$var$load("GD9EA"),
    $7744c33afd84ac16$var$load("he34V"),
    $7744c33afd84ac16$var$load("iUXaE"),
    $7744c33afd84ac16$var$load("lTkx9"),
    $7744c33afd84ac16$var$load("6wr18"),
    $7744c33afd84ac16$var$load("e1cuZ"),
    $7744c33afd84ac16$var$load("6kXh6"),
    $7744c33afd84ac16$var$load("cIET7"),
    $7744c33afd84ac16$var$load("7oAXW"),
    $7744c33afd84ac16$var$load("idSqX"),
    $7744c33afd84ac16$var$load("h1yOv"),
    $7744c33afd84ac16$var$load("kHXvF"),
    $7744c33afd84ac16$var$load("7gL7H"),
    $7744c33afd84ac16$var$load("cmmpX"),
    $7744c33afd84ac16$var$load("ffEVr"),
    $7744c33afd84ac16$var$load("4JSav"),
    $7744c33afd84ac16$var$load("lbsQO"),
    $7744c33afd84ac16$var$load("eCXJR"),
    $7744c33afd84ac16$var$load("1VTX2"),
    $7744c33afd84ac16$var$load("cHcD4"),
    $7744c33afd84ac16$var$load("2m65P"),
    $7744c33afd84ac16$var$load("80Yra"),
    $7744c33afd84ac16$var$load("houtd"),
    $7744c33afd84ac16$var$load("Wowvf"),
    $7744c33afd84ac16$var$load("eRhBr"),
    $7744c33afd84ac16$var$load("hZ2FX"),
    $7744c33afd84ac16$var$load("7EorR"),
    $7744c33afd84ac16$var$load("hhss7"),
    $7744c33afd84ac16$var$load("kT6dz"),
    $7744c33afd84ac16$var$load("aAWLw"),
    $7744c33afd84ac16$var$load("hvHZS")
]).then(()=>parcelRequire('5QLLH'));

});

parcelRegister("bUiJC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $22ad974994dfbc0b$var$applyDefaultWidth = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const editorScrollParent = document.querySelector('.fabric-editor-popup-scroll-parent');
    if (editorScrollParent) return editorScrollParent.clientWidth || 0;
    return 0;
};
const $22ad974994dfbc0b$export$5308d1e625847f03 = ({ isFixedWidth: isFixedWidth = false })=>{
    const defaultWidth = $22ad974994dfbc0b$var$applyDefaultWidth();
    const [width, setWidth] = (0, $cozmU.useState)(defaultWidth);
    const observerRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        const editorScrollParent = document.querySelector('.fabric-editor-popup-scroll-parent');
        if (editorScrollParent && !isFixedWidth) {
            observerRef.current = new ResizeObserver((entries)=>{
                setWidth(Math.floor(entries[0]?.target.clientWidth));
            });
            observerRef.current.observe(editorScrollParent);
            return ()=>observerRef?.current?.disconnect();
        }
    }, [
        observerRef,
        isFixedWidth
    ]);
    return {
        width: width,
        observerRef: observerRef.current
    };
};
module.exports["useEditorWidthObserver"] = $22ad974994dfbc0b$export$5308d1e625847f03;

});

parcelRegister("ixblh", function(module, exports) {
/* bpqaStyled.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $2932c138a6a4fe83$export$899fff719d224ef5 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_zs12fajl _kewefbnq _xlob1h6o",
            __cmplp.className
        ])
    });
});
const $2932c138a6a4fe83$export$5f734e3a73651e57 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11c8fhey _k48pi7a9",
            __cmplp.isDisabled ? "_syaz1gmx" : "_syazazsu",
            __cmplp.className
        ])
    });
});
const $2932c138a6a4fe83$export$25a86e6d831757c1 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1bsb1tcg _4t3i1tcg _wh9on7od _1an5n7od",
            __cmplp.isDisabled ? "_tzy41ou4" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
});
const $2932c138a6a4fe83$export$2285fc416017f7ef = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2lx21bp4 _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $2932c138a6a4fe83$export$61367bcbe6096b19 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTemplatesPanelOpen: isTemplatesPanelOpen, shouldAdjustForContextPanel: shouldAdjustForContextPanel, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt4pxbi _19itia51 _zulputpp _2rko1mok _2lx21bp4 _1e0c1txw _94n51ejb _bfhkvuon _1pbycs5v",
            __cmplp.isTemplatesPanelOpen && __cmplp.shouldAdjustForContextPanel ? "_2hwxa3o1" : "_2hwxidpf",
            __cmplp.className
        ])
    });
});
const $2932c138a6a4fe83$export$17a2f9655d167e3f = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt4pxbi _1e0c1txw _1bsb1wug _1bah1h6o _n3tdv47k _kqswstnw _94n5idpf",
            __cmplp.className
        ])
    });
});
const $2932c138a6a4fe83$export$f8e573bbc82f4efb = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _1bsb1osq _1bah1h6o _kqswh2mm _bfhkvuon",
            __cmplp.className
        ])
    });
});
const $2932c138a6a4fe83$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActive: isActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_zs12fajl _kewefbnq _xlob1h6o",
            __cmplp.isActive ? "_jmnr9yc7" : "_jmnrmzrp",
            __cmplp.className
        ])
    });
});
const $2932c138a6a4fe83$export$f4922e2dc59c62b7 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldShowTemplatePreview: shouldShowTemplatePreview, editorWidth: editorWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_kqswstnw _n3td68cl _bfhkvuon _1bsb1osq _1pbykb7n _1e0oidpf _jvszidpf _d7r2idpf _uhh2idpf _kvd7n7od _1oxg1osq _pnc7vuon _gdo5idpf _1jndidpf _1h8zidpf _1hblidpf _uzron7od _169tglyw _10pb1wug _1cpl1jfw _fkwnvuon",
            __cmplp.shouldShowTemplatePreview ? "_1e0c1wug" : "_1e0cglyw",
            __cmplp.editorWidth < 500 ? "_154i1bdq" : __cmplp.editorWidth < 820 ? "_154i1cg9" : "_154ikfja",
            __cmplp.className
        ])
    });
});
module.exports["QuickCardContainer"] = $2932c138a6a4fe83$export$899fff719d224ef5;
module.exports["ButtonText"] = $2932c138a6a4fe83$export$5f734e3a73651e57;
module.exports["QuickCardIcon"] = $2932c138a6a4fe83$export$25a86e6d831757c1;
module.exports["QuickCardColumn"] = $2932c138a6a4fe83$export$2285fc416017f7ef;
module.exports["BlankPageQuickActionsCardContainer"] = $2932c138a6a4fe83$export$61367bcbe6096b19;
module.exports["BlankPageQuickActionsWrapper"] = $2932c138a6a4fe83$export$17a2f9655d167e3f;
module.exports["BlankPageQuickActionsTemplatePreviewWrapper"] = $2932c138a6a4fe83$export$f8e573bbc82f4efb;
module.exports["Link"] = $2932c138a6a4fe83$export$a6c7ac8248d6e38a;
module.exports["BlankPageQuickActionsTemplatePreviewContainer"] = $2932c138a6a4fe83$export$f4922e2dc59c62b7;

});

parcelRegister("c06us", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4GdJK = parcelRequire("4GdJK");

const $5c0cf15fa14bb16f$export$e155e043455d63c1 = /*#__PURE__*/ (0, $cozmU.createContext)({
    templates: [],
    templateIndex: 0,
    buttonHovered: false,
    loading: false,
    error: undefined,
    setButtonHovered: ()=>{},
    setTemplateIndex: ()=>{},
    revampedBpqa: false
});
const $5c0cf15fa14bb16f$export$124ad6efb514134c = ({ children: children, spaceKey: spaceKey })=>{
    const [templateIndex, setTemplateIndex] = (0, $cozmU.useState)(0);
    const [buttonHovered, setButtonHovered] = (0, $cozmU.useState)(false);
    const { error: error, loading: loading, templates: templates, isNewUserTemplates: isNewUserTemplates } = (0, $4GdJK.useSuggestedTemplates)({
        spaceKey: spaceKey
    });
    const contextValue = (0, $cozmU.useMemo)(()=>{
        return {
            templates: templates,
            error: error,
            loading: loading,
            templateIndex: templateIndex,
            setTemplateIndex: setTemplateIndex,
            buttonHovered: buttonHovered,
            setButtonHovered: setButtonHovered,
            revampedBpqa: Boolean(isNewUserTemplates)
        };
    }, [
        templates,
        error,
        loading,
        templateIndex,
        setTemplateIndex,
        buttonHovered,
        setButtonHovered,
        isNewUserTemplates
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5c0cf15fa14bb16f$export$e155e043455d63c1.Provider, {
        value: contextValue
    }, children);
};
const $5c0cf15fa14bb16f$export$ba95a878db10004d = ()=>(0, $cozmU.useContext)($5c0cf15fa14bb16f$export$e155e043455d63c1);
module.exports["BlankPageQuickActionsProvider"] = $5c0cf15fa14bb16f$export$124ad6efb514134c;
module.exports["useBlankPageQuickActionsContext"] = $5c0cf15fa14bb16f$export$ba95a878db10004d;

});

parcelRegister("4GdJK", function(module, exports) {

var $9DHhW = parcelRequire("9DHhW");


var $jMyy4 = parcelRequire("jMyy4");


var $ae5hk = parcelRequire("ae5hk");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $iTCLy = parcelRequire("iTCLy");


var $5IOrg = parcelRequire("5IOrg");


var $fDlC6 = parcelRequire("fDlC6");

const $7fc37f1065645929$export$39dea997638a7196 = ({ spaceKey: spaceKey })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { templates: newUserTemplates, error: newUserTemplatesError, loading: newUserTemplatesLoading } = (0, $iTCLy.useNewUserTemplates)();
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $5IOrg.default), {
        variables: {
            spaceKey: spaceKey,
            sortingScheme: (0, $ae5hk.SortOrders).RELEVANCY_SORT,
            limit: (0, $fDlC6.TEMPLATE_LIMIT)
        },
        skip: !spaceKey,
        __callerPackage__: "blank-page-quick-actions"
    });
    if (error || newUserTemplatesError) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        if ((0, $1uFM6.isUnauthorizedError)(newUserTemplatesError)) (0, $7Sm4c.markErrorAsHandled)(newUserTemplatesError);
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: 'BlankPageQuickActions',
                action: 'error',
                actionSubject: 'useSuggestedTemplates',
                attributes: {
                    version: '2',
                    revampedBpqaError: Boolean(newUserTemplatesError)
                }
            }
        }).fire();
    }
    if (loading || newUserTemplatesLoading) return {
        templates: [],
        loading: true,
        error: error || newUserTemplatesError
    };
    if (newUserTemplates) return {
        templates: newUserTemplates,
        loading: false,
        error: error || newUserTemplatesError,
        isNewUserTemplates: true
    };
    const suggestedTemplates = data?.allTemplates?.nodes || [];
    // we want to filter out the blog post template and legacy
    // editor template, so we get 5 templates and return the
    // first 3 excluding them if they exist
    const templates = suggestedTemplates?.filter((template)=>template.itemModuleCompleteKey !== (0, $fDlC6.BPQA_EXCLUDED_TEMPLATE_KEYS).BLOG_POST && template.blueprintModuleCompleteKey !== (0, $fDlC6.BPQA_EXCLUDED_TEMPLATE_KEYS).LEGACY_EDITOR)?.slice(0, 3);
    return {
        error: error || newUserTemplatesError,
        templates: templates,
        loading: loading
    };
};
module.exports["useSuggestedTemplates"] = $7fc37f1065645929$export$39dea997638a7196;

});

parcelRegister("ae5hk", function(module, exports) {
var $5ff79979c9f78c44$export$edd0ae81c67ebc59 = /*#__PURE__*/ function(SortOrders) {
    SortOrders["RELEVANCY_SORT"] = "web.item.sorting.scheme.relevancy";
    SortOrders["ALPHABETICAL_SORT"] = "web.item.sorting.scheme.alphabetical";
    return SortOrders;
}({});
module.exports["SortOrders"] = $5ff79979c9f78c44$export$edd0ae81c67ebc59;

});

parcelRegister("iTCLy", function(module, exports) {

var $lK6As = parcelRequire("lK6As");


var $kSwu1 = parcelRequire("kSwu1");


var $jMyy4 = parcelRequire("jMyy4");


var $avNDU = parcelRequire("avNDU");


var $erbsn = parcelRequire("erbsn");


var $1UV7X = parcelRequire("1UV7X");

const $7042ac65234fccd4$var$templateInfo = (0, $lK6As.default);
const $7042ac65234fccd4$export$377e0a64bacf7634 = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { showNewUserTemplates: showNewUserTemplates, loading: shouldShowLoading, error: shouldShowError } = (0, $erbsn.useShouldShowNewUserTemplates)();
    const skip = !showNewUserTemplates;
    const { teamType: teamType, error: teamTypeError, loading: teamTypeLoading } = (0, $1UV7X.useTeamType)({
        skip: skip
    });
    const templates = (0, $avNDU.getTemplatesForTeamType)(teamType);
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($7042ac65234fccd4$var$templateInfo, {
        variables: {
            templateId0: templates[0].blueprintModuleCompleteKey,
            templateId1: templates[1].blueprintModuleCompleteKey,
            templateId2: templates[2].blueprintModuleCompleteKey
        },
        skip: skip || teamTypeLoading,
        __callerPackage__: "experiment-land-users-in-editor-with-revamped-bpqa"
    });
    if (shouldShowLoading || teamTypeLoading || loading) return {
        loading: true,
        templates: null
    };
    if (shouldShowError || teamTypeError || error) return {
        loading: false,
        templates: null,
        error: shouldShowError || teamTypeError || error
    };
    if (!showNewUserTemplates) return {
        loading: false,
        templates: null
    };
    if (!(data?.template0 && data?.template1 && data?.template2)) return {
        loading: false,
        templates: null
    };
    return {
        loading: false,
        templates: [
            {
                ...data.template0,
                name: formatMessage(templates[0].name)
            },
            {
                ...data.template1,
                name: formatMessage(templates[1].name)
            },
            {
                ...data.template2,
                name: formatMessage(templates[2].name)
            }
        ]
    };
};
module.exports["useNewUserTemplates"] = $7042ac65234fccd4$export$377e0a64bacf7634;

});

parcelRegister("lK6As", function(module, exports) {
/**
 * @generated SignedSource<<0f459c5c6fb994d8bde3d35a1982b0e9>>
 * @relayHash 628a56ca33e9462b0d28ee38c9055b21
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 83b376ae5628ba7b036093c628acc4c9bcbbfa4d904bbfabdb1d1199730710a7
const $78132ced4fa35efb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "templateId0"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "templateId1"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "templateId2"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "templateId"
        },
        {
            "kind": "ScalarField",
            "name": "contentBlueprintId"
        },
        {
            "kind": "ScalarField",
            "name": "blueprintModuleCompleteKey"
        },
        {
            "kind": "ScalarField",
            "name": "itemModuleCompleteKey"
        },
        {
            "kind": "ScalarField",
            "name": "templateType"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "ScalarField",
            "name": "iconURL"
        },
        {
            "kind": "ScalarField",
            "name": "darkModeIconURL"
        },
        {
            "kind": "ScalarField",
            "name": "styleClass"
        },
        {
            "kind": "ScalarField",
            "name": "hasWizard"
        },
        {
            "kind": "ScalarField",
            "name": "isNew"
        },
        {
            "kind": "ScalarField",
            "name": "isPromoted"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "hasGlobalBlueprintContent"
        },
        {
            "kind": "ScalarField",
            "name": "categoryIds"
        },
        {
            "kind": "ScalarField",
            "name": "keywords"
        },
        {
            "kind": "ScalarField",
            "name": "recommendationRank"
        },
        {
            "kind": "ScalarField",
            "name": "author"
        }
    ], v2 = [
        {
            "alias": "template0",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "templateId0"
                }
            ],
            "concreteType": "TemplateInfo",
            "kind": "LinkedField",
            "name": "templateInfo",
            "plural": false,
            "selections": v1 /*: any*/ 
        },
        {
            "alias": "template1",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "templateId1"
                }
            ],
            "concreteType": "TemplateInfo",
            "kind": "LinkedField",
            "name": "templateInfo",
            "plural": false,
            "selections": v1 /*: any*/ 
        },
        {
            "alias": "template2",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "templateId2"
                }
            ],
            "concreteType": "TemplateInfo",
            "kind": "LinkedField",
            "name": "templateInfo",
            "plural": false,
            "selections": v1 /*: any*/ 
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useNewUserTemplatesGetMultipleTemplateInfoQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useNewUserTemplatesGetMultipleTemplateInfoQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "628a56ca33e9462b0d28ee38c9055b21",
            "id": "83b376ae5628ba7b036093c628acc4c9bcbbfa4d904bbfabdb1d1199730710a7",
            "metadata": {},
            "name": "useNewUserTemplatesGetMultipleTemplateInfoQuery",
            "operationKind": "query",
            "text": "query useNewUserTemplatesGetMultipleTemplateInfoQuery($templateId0:ID!,$templateId1:ID!,$templateId2:ID!){template0:templateInfo(id:$templateId0){templateId,contentBlueprintId,blueprintModuleCompleteKey,itemModuleCompleteKey,templateType,name,description,iconURL,darkModeIconURL,styleClass,hasWizard,isNew,isPromoted,isFavourite,hasGlobalBlueprintContent,categoryIds,keywords,recommendationRank,author},template1:templateInfo(id:$templateId1){templateId,contentBlueprintId,blueprintModuleCompleteKey,itemModuleCompleteKey,templateType,name,description,iconURL,darkModeIconURL,styleClass,hasWizard,isNew,isPromoted,isFavourite,hasGlobalBlueprintContent,categoryIds,keywords,recommendationRank,author},template2:templateInfo(id:$templateId2){templateId,contentBlueprintId,blueprintModuleCompleteKey,itemModuleCompleteKey,templateType,name,description,iconURL,darkModeIconURL,styleClass,hasWizard,isNew,isPromoted,isFavourite,hasGlobalBlueprintContent,categoryIds,keywords,recommendationRank,author}}"
        }
    };
}();
$78132ced4fa35efb$var$node.hash = "f2f7112db65307812c35e5adf447d1ca";
var $78132ced4fa35efb$export$2e2bcd8739ae039 = $78132ced4fa35efb$var$node;
module.exports["default"] = $78132ced4fa35efb$export$2e2bcd8739ae039;

});

parcelRegister("avNDU", function(module, exports) {

var $aiWdm = parcelRequire("aiWdm");

const $48e6cac0e3cb7731$export$da219dd41e9a36c6 = (teamType)=>{
    const names = teamType ? (0, $aiWdm.TEMPLATES_FOR_TEAM_TYPE)[teamType] : (0, $aiWdm.DEFAULT_TEMPLATES);
    return [
        (0, $aiWdm.TEMPLATE_DETAILS)[names[0]],
        (0, $aiWdm.TEMPLATE_DETAILS)[names[1]],
        (0, $aiWdm.TEMPLATE_DETAILS)[names[2]]
    ];
};
module.exports["getTemplatesForTeamType"] = $48e6cac0e3cb7731$export$da219dd41e9a36c6;

});

parcelRegister("aiWdm", function(module, exports) {

var $9SB6a = parcelRequire("9SB6a");


var $bn6FP = parcelRequire("bn6FP");


var $gTWYs = parcelRequire("gTWYs");


var $6iYkp = parcelRequire("6iYkp");


var $foyvn = parcelRequire("foyvn");


var $e41Cf = parcelRequire("e41Cf");


var $1r4tc = parcelRequire("1r4tc");


var $bb2LR = parcelRequire("bb2LR");


var $pwYdt = parcelRequire("pwYdt");


var $6lUpS = parcelRequire("6lUpS");


var $dgwfH = parcelRequire("dgwfH");


var $jstmI = parcelRequire("jstmI");


var $6oRAi = parcelRequire("6oRAi");


var $gaFvi = parcelRequire("gaFvi");


var $8Wtdz = parcelRequire("8Wtdz");


var $eSfWU = parcelRequire("eSfWU");


var $7xZqB = parcelRequire("7xZqB");


var $213Un = parcelRequire("213Un");


var $l7frM = parcelRequire("l7frM");


var $aLm3s = parcelRequire("aLm3s");


var $5s7qv = parcelRequire("5s7qv");


var $1yDZQ = parcelRequire("1yDZQ");


var $afPQ2 = parcelRequire("afPQ2");


var $5JH7S = parcelRequire("5JH7S");


var $a8sHF = parcelRequire("a8sHF");


var $1yNgM = parcelRequire("1yNgM");


var $lTWO4 = parcelRequire("lTWO4");


var $9asgX = parcelRequire("9asgX");


var $4MIN5 = parcelRequire("4MIN5");


var $9DVwE = parcelRequire("9DVwE");


var $iw6AY = parcelRequire("iw6AY");


var $94Jhp = parcelRequire("94Jhp");


var $8M0ww = parcelRequire("8M0ww");


var $jLYIE = parcelRequire("jLYIE");


var $1OYbX = parcelRequire("1OYbX");


var $7lsiV = parcelRequire("7lsiV");


var $cp408 = parcelRequire("cp408");


var $7wFU4 = parcelRequire("7wFU4");


var $j2UKX = parcelRequire("j2UKX");


var $aN31k = parcelRequire("aN31k");


var $6S8Af = parcelRequire("6S8Af");


var $jvYP5 = parcelRequire("jvYP5");


var $gj4SK = parcelRequire("gj4SK");


var $13lju = parcelRequire("13lju");


var $hWJGo = parcelRequire("hWJGo");


var $1tltq = parcelRequire("1tltq");


var $92ViF = parcelRequire("92ViF");


var $jIOrS = parcelRequire("jIOrS");


var $8H9WZ = parcelRequire("8H9WZ");


var $7VKBt = parcelRequire("7VKBt");


var $6X8Zj = parcelRequire("6X8Zj");


var $VTY3P = parcelRequire("VTY3P");


var $ijIYo = parcelRequire("ijIYo");


var $b3cbC = parcelRequire("b3cbC");


var $6XrmQ = parcelRequire("6XrmQ");


var $l6TFT = parcelRequire("l6TFT");


var $iiotM = parcelRequire("iiotM");


var $1cGKl = parcelRequire("1cGKl");


var $izKBY = parcelRequire("izKBY");


var $7Ktvd = parcelRequire("7Ktvd");


var $hLWXI = parcelRequire("hLWXI");


var $bdZE7 = parcelRequire("bdZE7");


var $2TGLP = parcelRequire("2TGLP");


var $7UUU9 = parcelRequire("7UUU9");


var $bXaSP = parcelRequire("bXaSP");


var $5yJW9 = parcelRequire("5yJW9");


var $jhnvS = parcelRequire("jhnvS");


var $dTwzp = parcelRequire("dTwzp");


var $3BFOv = parcelRequire("3BFOv");


var $b9NEQ = parcelRequire("b9NEQ");


var $l4tWF = parcelRequire("l4tWF");


var $cIja8 = parcelRequire("cIja8");


var $CWEQZ = parcelRequire("CWEQZ");


var $1jHQ2 = parcelRequire("1jHQ2");


var $lVvAn = parcelRequire("lVvAn");


var $5hBhJ = parcelRequire("5hBhJ");


var $eqVHX = parcelRequire("eqVHX");


var $hRwQ5 = parcelRequire("hRwQ5");


var $ffSuc = parcelRequire("ffSuc");


var $49Nhu = parcelRequire("49Nhu");


var $aeq5M = parcelRequire("aeq5M");


var $3fMC8 = parcelRequire("3fMC8");


var $JiLos = parcelRequire("JiLos");


var $61Q1O = parcelRequire("61Q1O");


var $hbWkV = parcelRequire("hbWkV");

const $d8ff577dc849af37$export$d5b92d67f1b42228 = [
    'Project plan',
    'Meeting notes',
    'Brainstorming'
];
const $d8ff577dc849af37$export$52608caa2693c2d2 = {
    'Software development': [
        'Software Architecture Review',
        'Meeting notes',
        'Retrospective'
    ],
    'Product management': [
        'Product Requirements',
        'Meeting notes',
        'Brainstorming'
    ],
    Finance: [
        'Business status update',
        'Meeting notes',
        'Fundraising database'
    ],
    'Human resources': [
        'Employee handbook',
        'Meeting notes',
        'Hiring Process Template'
    ],
    Legal: [
        'Project plan',
        'Meeting notes',
        'DACI: Decision documentation'
    ],
    Marketing: [
        'Marketing campaign',
        'Meeting notes',
        'Marketing plan'
    ],
    Operations: [
        'Standard Operating Procedure (SOP) Template',
        'Meeting notes',
        'Project plan'
    ],
    Sales: [
        'Sales account planning',
        'Meeting notes',
        'Sales portal'
    ],
    Design: [
        'Design decision',
        'Meeting notes',
        'Design sprint'
    ],
    'Project management': [
        'Project plan',
        'Meeting notes',
        'Project status report'
    ],
    'IT support': [
        'Troubleshooting article',
        'Meeting notes',
        'ITSM runbook'
    ]
};
const $d8ff577dc849af37$export$18a5b6d9b6e10951 = {
    Brainstorming: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:brainstorming-with-remote-teams-blueprint',
        name: (0, $9SB6a.i18n).brainstormingTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($bn6FP))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($gTWYs)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($13lju))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($hWJGo)))
            }
        }
    },
    'Business status update': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-blueprint',
        name: (0, $9SB6a.i18n).businesStatusUpdateTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($6iYkp))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($foyvn)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($1tltq))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($92ViF)))
            }
        }
    },
    'DACI: Decision documentation': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint',
        name: (0, $9SB6a.i18n).DACIDecisionDocumentTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($e41Cf))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($1r4tc)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($jIOrS))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($8H9WZ)))
            }
        }
    },
    'Design decision': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-decision-blueprint',
        name: (0, $9SB6a.i18n).designDecisionTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($bb2LR))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($pwYdt)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($7VKBt))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($6X8Zj)))
            }
        }
    },
    'Design sprint': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-sprint-blueprint',
        name: (0, $9SB6a.i18n).designSprintTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($6lUpS))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($dgwfH)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($VTY3P))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($ijIYo)))
            }
        }
    },
    'Employee handbook': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:employee-handbook-blueprint',
        name: (0, $9SB6a.i18n).employeeHandbookTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($jstmI))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($6oRAi)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($b3cbC))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($6XrmQ)))
            }
        }
    },
    'Fundraising database': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:fundraising-database-blueprint',
        name: (0, $9SB6a.i18n).fundraisingDatabaseTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($gaFvi))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($8Wtdz)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($l6TFT))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($iiotM)))
            }
        }
    },
    'Hiring Process Template': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:hiring-process-blueprint',
        name: (0, $9SB6a.i18n).hiringProcessTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($eSfWU))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($7xZqB)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($1cGKl))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($izKBY)))
            }
        }
    },
    'ITSM runbook': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-runbook-blueprint',
        name: (0, $9SB6a.i18n).ITSMRunbookTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($213Un))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($l7frM)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($7Ktvd))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($hLWXI)))
            }
        }
    },
    'Marketing campaign': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-campaign-blueprint',
        name: (0, $9SB6a.i18n).marketingCampaignTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($aLm3s))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($5s7qv)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($bdZE7))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($2TGLP)))
            }
        }
    },
    'Marketing plan': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-blueprint',
        name: (0, $9SB6a.i18n).marketingPlanTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($1yNgM))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($lTWO4)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($dTwzp))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($3BFOv)))
            }
        }
    },
    'Meeting notes': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
        name: (0, $9SB6a.i18n).meetingNotesTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($5JH7S))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($a8sHF)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($5yJW9))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($jhnvS)))
            }
        }
    },
    'Product Requirements': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint',
        name: (0, $9SB6a.i18n).productRequirementsTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($9asgX))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($4MIN5)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($b9NEQ))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($l4tWF)))
            }
        }
    },
    'Project plan': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
        name: (0, $9SB6a.i18n).projectPlanTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($9DVwE))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($iw6AY)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($cIja8))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($CWEQZ)))
            }
        }
    },
    'Project status report': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-status-blueprint',
        name: (0, $9SB6a.i18n).projectStatusTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($94Jhp))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($8M0ww)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($1jHQ2))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($lVvAn)))
            }
        }
    },
    Retrospective: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-software-blueprints:retrospectives-blueprint',
        name: (0, $9SB6a.i18n).retrospectiveTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($jLYIE))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($1OYbX)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($5hBhJ))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($eqVHX)))
            }
        }
    },
    'Sales account planning': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:account-planning-for-sales-blueprint',
        name: (0, $9SB6a.i18n).salesAccountPlanningTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($7lsiV))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($cp408)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($hRwQ5))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($ffSuc)))
            }
        }
    },
    'Sales portal': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:sales-portal-template-blueprint',
        name: (0, $9SB6a.i18n).salesPortalTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($7wFU4))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($j2UKX)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($49Nhu))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($aeq5M)))
            }
        }
    },
    'Software Architecture Review': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:software-architecture-review-blueprint',
        name: (0, $9SB6a.i18n).softwareArchitectureReviewTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($aN31k))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($6S8Af)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($3fMC8))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($JiLos)))
            }
        }
    },
    'Standard Operating Procedure (SOP) Template': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:standard-operating-procedure-sop-blueprint',
        name: (0, $9SB6a.i18n).standardOperatingProcedureTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($1yDZQ))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($afPQ2)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($7UUU9))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($bXaSP)))
            }
        }
    },
    'Troubleshooting article': {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-troubleshooting-article-blueprint',
        name: (0, $9SB6a.i18n).troubleshootingArticleTemplateName,
        icons: {
            light: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($jvYP5))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($gj4SK)))
            },
            dark: {
                normal: (0, (/*@__PURE__*/$parcel$interopDefault($61Q1O))),
                hover: (0, (/*@__PURE__*/$parcel$interopDefault($hbWkV)))
            }
        }
    }
};
module.exports["DEFAULT_TEMPLATES"] = $d8ff577dc849af37$export$d5b92d67f1b42228;
module.exports["TEMPLATES_FOR_TEAM_TYPE"] = $d8ff577dc849af37$export$52608caa2693c2d2;
module.exports["TEMPLATE_DETAILS"] = $d8ff577dc849af37$export$18a5b6d9b6e10951;

});

parcelRegister("9SB6a", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $47eb490faf71feb2$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    brainstormingTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.brainstorming-name",
        defaultMessage: "Brainstorming"
    },
    brainstormingTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.brainstorming-description",
        defaultMessage: "Generate and group ideas"
    },
    businesStatusUpdateTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.business-status-update-name",
        defaultMessage: "Business Status Update"
    },
    businesStatusUpdateTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.business-status-update-description",
        defaultMessage: "Share team-wide updates"
    },
    DACIDecisionDocumentTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.daci-decision-document-name",
        defaultMessage: "DACI:Decision Document"
    },
    DACIDecisionDocumentTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.brainstorming-description",
        defaultMessage: "Drive clarity on decisions"
    },
    designDecisionTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.design-decision-name",
        defaultMessage: "Design Decision"
    },
    designDecisionTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.design-decision-description",
        defaultMessage: "Document design outcomes"
    },
    designSprintTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.design-sprint-name",
        defaultMessage: "Design Sprint"
    },
    designSprintTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.design-sprint-description",
        defaultMessage: "Run a structured sprint cycle"
    },
    employeeHandbookTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.employee-handbook-name",
        defaultMessage: "Employee Handbook"
    },
    employeeHandbookTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.employee-handbook-description",
        defaultMessage: "Centralize company policies"
    },
    fundraisingDatabaseTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.fundraising-database-name",
        defaultMessage: "Fundraising Database"
    },
    fundraisingDatabaseTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.fundraising-database-description",
        defaultMessage: "Track investor outreach"
    },
    hiringProcessTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.hiring-process-name",
        defaultMessage: "Hiring Process"
    },
    hiringProcessTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.hiring-process-description",
        defaultMessage: "Outline each hiring step"
    },
    ITSMRunbookTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.itsm-runbook-name",
        defaultMessage: "ITSM Runbook"
    },
    ITSMRunbookTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.itsm-runbook-description",
        defaultMessage: "Standardize incident response"
    },
    marketingCampaignTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.marketing-campaign-name",
        defaultMessage: "Marketing Campaign"
    },
    marketingCampaignTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.marketing-campaign-description",
        defaultMessage: "Plan campaign work"
    },
    marketingPlanTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.marketing-plan-name",
        defaultMessage: "Marketing Plan"
    },
    marketingPlanTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.marketing-plan-description",
        defaultMessage: "Outline marketing goals"
    },
    meetingNotesTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.meeting-notes-name",
        defaultMessage: "Meeting notes"
    },
    meetingNotesTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.meeting-notes-description",
        defaultMessage: "Capture meeting outcomes"
    },
    productRequirementsTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.product-requirements-name",
        defaultMessage: "Product Requirements"
    },
    productRequirementsTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.product-requirements-description",
        defaultMessage: "Align product goals and scope"
    },
    projectPlanTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.project-plan-name",
        defaultMessage: "Project Plan"
    },
    projectPlanTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.project-plan-description",
        defaultMessage: "Align teams on project scope"
    },
    projectStatusTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.project-status-report-name",
        defaultMessage: "Project Status Report"
    },
    projectStatusTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.project-status-report-description",
        defaultMessage: "Share team status updates"
    },
    retrospectiveTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.retrospective-name",
        defaultMessage: "Retrospective"
    },
    retrospectiveTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.retrospective-description",
        defaultMessage: "Reflect and improve as a team"
    },
    salesAccountPlanningTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.sales-account-planning-name",
        defaultMessage: "Sales Account Planning"
    },
    salesAccountPlanningTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.sales-account-planning-description",
        defaultMessage: "Set goals for key accounts"
    },
    salesPortalTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.sales-portal-name",
        defaultMessage: "Sales Portal"
    },
    salesPortalTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.sales-portal-description",
        defaultMessage: "Organize sales resources"
    },
    softwareArchitectureReviewTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.software-architecture-review-name",
        defaultMessage: "Software Architecture Review"
    },
    softwareArchitectureReviewTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.software-architecture-review-description",
        defaultMessage: "Evaluate technical designs"
    },
    standardOperatingProcedureTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.standard-operating-procedure-name",
        defaultMessage: "Standard Operating Procedure"
    },
    standardOperatingProcedureTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.standard-operating-procedure-description",
        defaultMessage: "Document recurring steps"
    },
    troubleshootingArticleTemplateName: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.troubleshooting-article-name",
        defaultMessage: "Troubleshooting article"
    },
    troubleshootingArticleTemplateDescription: {
        id: "experiment-land-users-in-editor-with-revamped-bpqa.templates.troubleshooting-article-description",
        defaultMessage: "Guide users to resolve issues"
    }
});
module.exports["i18n"] = $47eb490faf71feb2$export$a7357cdd1f0b0168;

});

parcelRegister("bn6FP", function(module, exports) {
module.exports = new URL("Brainstorming.94b58c6a.svg", import.meta.url).toString();

});

parcelRegister("gTWYs", function(module, exports) {
module.exports = new URL("Brainstorming Hover.84a73d80.svg", import.meta.url).toString();

});

parcelRegister("6iYkp", function(module, exports) {
module.exports = new URL("Business Status Update.1efc1ace.svg", import.meta.url).toString();

});

parcelRegister("foyvn", function(module, exports) {
module.exports = new URL("Business Status Update Hover.cc17fbf4.svg", import.meta.url).toString();

});

parcelRegister("e41Cf", function(module, exports) {
module.exports = new URL("DACI.8156ef8f.svg", import.meta.url).toString();

});

parcelRegister("1r4tc", function(module, exports) {
module.exports = new URL("DACI Hover.236fac19.svg", import.meta.url).toString();

});

parcelRegister("bb2LR", function(module, exports) {
module.exports = new URL("Design Decision.aea9ef88.svg", import.meta.url).toString();

});

parcelRegister("pwYdt", function(module, exports) {
module.exports = new URL("Design Decision Hover.2b270b62.svg", import.meta.url).toString();

});

parcelRegister("6lUpS", function(module, exports) {
module.exports = new URL("Design Sprint.b98d94bb.svg", import.meta.url).toString();

});

parcelRegister("dgwfH", function(module, exports) {
module.exports = new URL("Design Sprint Hover.aceafcc7.svg", import.meta.url).toString();

});

parcelRegister("jstmI", function(module, exports) {
module.exports = new URL("Employee Handbook.fb183623.svg", import.meta.url).toString();

});

parcelRegister("6oRAi", function(module, exports) {
module.exports = new URL("Employee Handbook Hover.40d99a75.svg", import.meta.url).toString();

});

parcelRegister("gaFvi", function(module, exports) {
module.exports = new URL("Fundraising.0a1781f3.svg", import.meta.url).toString();

});

parcelRegister("8Wtdz", function(module, exports) {
module.exports = new URL("Fundraising Database Hover.e1687271.svg", import.meta.url).toString();

});

parcelRegister("eSfWU", function(module, exports) {
module.exports = new URL("Hiring Process.1a46f9b1.svg", import.meta.url).toString();

});

parcelRegister("7xZqB", function(module, exports) {
module.exports = new URL("Hiring Process Hover.a7af5d46.svg", import.meta.url).toString();

});

parcelRegister("213Un", function(module, exports) {
module.exports = new URL("ITSM Runbook.272077bd.svg", import.meta.url).toString();

});

parcelRegister("l7frM", function(module, exports) {
module.exports = new URL("ITSM Runbook Hover.dfaa2fae.svg", import.meta.url).toString();

});

parcelRegister("aLm3s", function(module, exports) {
module.exports = new URL("Marketing Campaign.45dd758d.svg", import.meta.url).toString();

});

parcelRegister("5s7qv", function(module, exports) {
module.exports = new URL("Marketing Campaign Hover.5c2b5955.svg", import.meta.url).toString();

});

parcelRegister("1yDZQ", function(module, exports) {
module.exports = new URL("OKR Tracking.a04718bb.svg", import.meta.url).toString();

});

parcelRegister("afPQ2", function(module, exports) {
module.exports = new URL("OKR Tracking Hover.1ed55ab5.svg", import.meta.url).toString();

});

parcelRegister("5JH7S", function(module, exports) {
module.exports = new URL("Meeting notes.431ccf5e.svg", import.meta.url).toString();

});

parcelRegister("a8sHF", function(module, exports) {
module.exports = new URL("Meeting notes Hover.7ae587e9.svg", import.meta.url).toString();

});

parcelRegister("1yNgM", function(module, exports) {
module.exports = new URL("Mkt Plan.cf8b450c.svg", import.meta.url).toString();

});

parcelRegister("lTWO4", function(module, exports) {
module.exports = new URL("Mkt Plan Hover.8897bfdd.svg", import.meta.url).toString();

});

parcelRegister("9asgX", function(module, exports) {
module.exports = new URL("PRD.56426dd9.svg", import.meta.url).toString();

});

parcelRegister("4MIN5", function(module, exports) {
module.exports = new URL("PRD Hover.cb81c0eb.svg", import.meta.url).toString();

});

parcelRegister("9DVwE", function(module, exports) {
module.exports = new URL("Project Plan.f28f7914.svg", import.meta.url).toString();

});

parcelRegister("iw6AY", function(module, exports) {
module.exports = new URL("Project Plan Hover.48617613.svg", import.meta.url).toString();

});

parcelRegister("94Jhp", function(module, exports) {
module.exports = new URL("Proj Status Report.972dc052.svg", import.meta.url).toString();

});

parcelRegister("8M0ww", function(module, exports) {
module.exports = new URL("Project Status Hover.a6f2e4f1.svg", import.meta.url).toString();

});

parcelRegister("jLYIE", function(module, exports) {
module.exports = new URL("Retro.0a7a990a.svg", import.meta.url).toString();

});

parcelRegister("1OYbX", function(module, exports) {
module.exports = new URL("Retro Hover.17d739ed.svg", import.meta.url).toString();

});

parcelRegister("7lsiV", function(module, exports) {
module.exports = new URL("Sales Account Planning.7875e2a4.svg", import.meta.url).toString();

});

parcelRegister("cp408", function(module, exports) {
module.exports = new URL("Sales Account Planning Hover.f968f550.svg", import.meta.url).toString();

});

parcelRegister("7wFU4", function(module, exports) {
module.exports = new URL("Sales Portal.53643a97.svg", import.meta.url).toString();

});

parcelRegister("j2UKX", function(module, exports) {
module.exports = new URL("Sales Portal Hover.64b2d259.svg", import.meta.url).toString();

});

parcelRegister("aN31k", function(module, exports) {
module.exports = new URL("Software Arch Review.77a3a9da.svg", import.meta.url).toString();

});

parcelRegister("6S8Af", function(module, exports) {
module.exports = new URL("Software Arch Review Hover.e52e609b.svg", import.meta.url).toString();

});

parcelRegister("jvYP5", function(module, exports) {
module.exports = new URL("Troubleshooting Article.29206918.svg", import.meta.url).toString();

});

parcelRegister("gj4SK", function(module, exports) {
module.exports = new URL("Troubleshooting Article Hover.a6ecd9aa.svg", import.meta.url).toString();

});

parcelRegister("13lju", function(module, exports) {
module.exports = new URL("Brainstorming.f240c002.svg", import.meta.url).toString();

});

parcelRegister("hWJGo", function(module, exports) {
module.exports = new URL("Brainstorming Hover.e1c833f7.svg", import.meta.url).toString();

});

parcelRegister("1tltq", function(module, exports) {
module.exports = new URL("Business Status Update.60b38516.svg", import.meta.url).toString();

});

parcelRegister("92ViF", function(module, exports) {
module.exports = new URL("Business Status Update Hover.d2aa938c.svg", import.meta.url).toString();

});

parcelRegister("jIOrS", function(module, exports) {
module.exports = new URL("DACI.3cadbee0.svg", import.meta.url).toString();

});

parcelRegister("8H9WZ", function(module, exports) {
module.exports = new URL("DACI Hover.c4a9d2d6.svg", import.meta.url).toString();

});

parcelRegister("7VKBt", function(module, exports) {
module.exports = new URL("Design Decision.6306cc24.svg", import.meta.url).toString();

});

parcelRegister("6X8Zj", function(module, exports) {
module.exports = new URL("Design Decision Hover.c4751033.svg", import.meta.url).toString();

});

parcelRegister("VTY3P", function(module, exports) {
module.exports = new URL("Design Sprint.261d030b.svg", import.meta.url).toString();

});

parcelRegister("ijIYo", function(module, exports) {
module.exports = new URL("Design Sprint Hover.e398d42e.svg", import.meta.url).toString();

});

parcelRegister("b3cbC", function(module, exports) {
module.exports = new URL("Employee Handbook.b58ecb32.svg", import.meta.url).toString();

});

parcelRegister("6XrmQ", function(module, exports) {
module.exports = new URL("Employee Handbook Hover.94b5de04.svg", import.meta.url).toString();

});

parcelRegister("l6TFT", function(module, exports) {
module.exports = new URL("Fundraising.0b5ad295.svg", import.meta.url).toString();

});

parcelRegister("iiotM", function(module, exports) {
module.exports = new URL("Fundraising Database Hover.6c691554.svg", import.meta.url).toString();

});

parcelRegister("1cGKl", function(module, exports) {
module.exports = new URL("Hiring Process.7a363ddb.svg", import.meta.url).toString();

});

parcelRegister("izKBY", function(module, exports) {
module.exports = new URL("Hiring Process Hover.c4281ae3.svg", import.meta.url).toString();

});

parcelRegister("7Ktvd", function(module, exports) {
module.exports = new URL("ITSM Runbook.2a44e062.svg", import.meta.url).toString();

});

parcelRegister("hLWXI", function(module, exports) {
module.exports = new URL("ITSM Runbook Hover.69e2eef4.svg", import.meta.url).toString();

});

parcelRegister("bdZE7", function(module, exports) {
module.exports = new URL("Marketing Campaign.496d08ac.svg", import.meta.url).toString();

});

parcelRegister("2TGLP", function(module, exports) {
module.exports = new URL("Marketing Campaign Hover.5784e467.svg", import.meta.url).toString();

});

parcelRegister("7UUU9", function(module, exports) {
module.exports = new URL("OKR Tracking.3e82c60a.svg", import.meta.url).toString();

});

parcelRegister("bXaSP", function(module, exports) {
module.exports = new URL("OKR Tracking Hover.047609df.svg", import.meta.url).toString();

});

parcelRegister("5yJW9", function(module, exports) {
module.exports = new URL("Meeting notes.14684091.svg", import.meta.url).toString();

});

parcelRegister("jhnvS", function(module, exports) {
module.exports = new URL("Meeting notes Hover.418d408b.svg", import.meta.url).toString();

});

parcelRegister("dTwzp", function(module, exports) {
module.exports = new URL("Mkt Plan.51fd454e.svg", import.meta.url).toString();

});

parcelRegister("3BFOv", function(module, exports) {
module.exports = new URL("Mkt Plan Hover.eec8532b.svg", import.meta.url).toString();

});

parcelRegister("b9NEQ", function(module, exports) {
module.exports = new URL("PRD.b38857d1.svg", import.meta.url).toString();

});

parcelRegister("l4tWF", function(module, exports) {
module.exports = new URL("PRD Hover.599187af.svg", import.meta.url).toString();

});

parcelRegister("cIja8", function(module, exports) {
module.exports = new URL("Project Plan.dc0a681a.svg", import.meta.url).toString();

});

parcelRegister("CWEQZ", function(module, exports) {
module.exports = new URL("Project Plan Hover.579bdd0f.svg", import.meta.url).toString();

});

parcelRegister("1jHQ2", function(module, exports) {
module.exports = new URL("Proj Status Report.91e4cee0.svg", import.meta.url).toString();

});

parcelRegister("lVvAn", function(module, exports) {
module.exports = new URL("Project Status Hover.d317ca8f.svg", import.meta.url).toString();

});

parcelRegister("5hBhJ", function(module, exports) {
module.exports = new URL("Retro.f40bdbc6.svg", import.meta.url).toString();

});

parcelRegister("eqVHX", function(module, exports) {
module.exports = new URL("Retro Hover.fbb2e555.svg", import.meta.url).toString();

});

parcelRegister("hRwQ5", function(module, exports) {
module.exports = new URL("Sales Account Planning.1824dc16.svg", import.meta.url).toString();

});

parcelRegister("ffSuc", function(module, exports) {
module.exports = new URL("Sales Account Planning Hover.e1bd2a06.svg", import.meta.url).toString();

});

parcelRegister("49Nhu", function(module, exports) {
module.exports = new URL("Sales Portal.753ff2da.svg", import.meta.url).toString();

});

parcelRegister("aeq5M", function(module, exports) {
module.exports = new URL("Sales Portal Hover.f29ecdcb.svg", import.meta.url).toString();

});

parcelRegister("3fMC8", function(module, exports) {
module.exports = new URL("Software Arch Review.baf8365c.svg", import.meta.url).toString();

});

parcelRegister("JiLos", function(module, exports) {
module.exports = new URL("Software Arch Review Hover.0efbbff0.svg", import.meta.url).toString();

});

parcelRegister("61Q1O", function(module, exports) {
module.exports = new URL("Troubleshooting Article.300207db.svg", import.meta.url).toString();

});

parcelRegister("hbWkV", function(module, exports) {
module.exports = new URL("Troubleshooting Article Hover.e0b7be9f.svg", import.meta.url).toString();

});

parcelRegister("erbsn", function(module, exports) {

var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");


var $8Lx5S = parcelRequire("8Lx5S");


var $dE3yd = parcelRequire("dE3yd");

const $f0a3375858601913$export$e61a948785bd7b17 = ()=>{
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { data: data, loading: loading, error: error } = (0, $ivb8S.useGetOnboardingState)([
        ...Object.values((0, $dBcar.LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA))
    ], !isLicensed);
    const { revampedBpqaShownAt: revampedBpqaShownAt } = (0, $ivb8S.deserializeState)(data);
    const shownAtWithinLastWeek = (0, $dE3yd.isWithinLastWeek)(revampedBpqaShownAt);
    if (!isLicensed) return {
        showNewUserTemplates: false,
        loading: false
    };
    if (loading) return {
        showNewUserTemplates: false,
        loading: true
    };
    if (error) return {
        showNewUserTemplates: false,
        loading: false,
        error: error
    };
    return {
        showNewUserTemplates: shownAtWithinLastWeek,
        loading: false
    };
};
module.exports["useShouldShowNewUserTemplates"] = $f0a3375858601913$export$e61a948785bd7b17;

});

parcelRegister("dE3yd", function(module, exports) {

var $apWEJ = parcelRequire("apWEJ");

var $esV19 = parcelRequire("esV19");

const $49d42e0354c3a49f$export$29f82b09627f4ff0 = (timestamp)=>{
    if (typeof timestamp !== 'string' || timestamp.trim() === '') return false;
    const timestampDate = new Date(timestamp);
    if (!(0, $esV19.default)(timestampDate)) return false;
    return (0, $apWEJ.default)(new Date(), timestampDate) < 1;
};
module.exports["isWithinLastWeek"] = $49d42e0354c3a49f$export$29f82b09627f4ff0;

});

parcelRegister("apWEJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7959bd06e7aba5a6$export$2e2bcd8739ae039);

var $jb2R2 = parcelRequire("jb2R2");


var $3yGK6 = parcelRequire("3yGK6");


var $byLBW = parcelRequire("byLBW");

function $7959bd06e7aba5a6$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $3yGK6.default)(2, arguments);
    var diff = (0, $jb2R2.default)(dateLeft, dateRight) / 7;
    return (0, $byLBW.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("1UV7X", function(module, exports) {

var $6WfJ1 = parcelRequire("6WfJ1");


var $jMyy4 = parcelRequire("jMyy4");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $aiWdm = parcelRequire("aiWdm");

const $b12d442de7f1e3d8$var$teamTypeQuery = (0, $6WfJ1.default);
const $b12d442de7f1e3d8$var$TEAM_TYPES = Object.keys((0, $aiWdm.TEMPLATES_FOR_TEAM_TYPE));
const $b12d442de7f1e3d8$var$sanitizeTeamType = (teamType)=>{
    if (teamType && $b12d442de7f1e3d8$var$TEAM_TYPES.includes(teamType)) return teamType;
    return undefined;
};
const $b12d442de7f1e3d8$export$243eb30ff3b311dd = ({ skip: skip })=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($b12d442de7f1e3d8$var$teamTypeQuery, {
        variables: {
            userId: userId ?? ''
        },
        skip: skip || !isLicensed || !userId,
        interopApolloAggClient: true,
        __callerPackage__: "experiment-land-users-in-editor-with-revamped-bpqa"
    });
    if (loading) return {
        teamType: undefined,
        loading: true
    };
    if (error) return {
        teamType: undefined,
        loading: false,
        error: error
    };
    if (data?.user?.__typename === 'AtlassianAccountUser') return {
        teamType: $b12d442de7f1e3d8$var$sanitizeTeamType(data.user.extendedProfile?.teamType),
        loading: false
    };
    return {
        teamType: undefined,
        loading: false
    };
};
module.exports["useTeamType"] = $b12d442de7f1e3d8$export$243eb30ff3b311dd;

});

parcelRegister("6WfJ1", function(module, exports) {
/**
 * @generated SignedSource<<cea888b1c93718c993b46de0ddc13798>>
 * @relayHash 5a90bd734b6a803ea4d3f84efc341d99
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4c602c004189d4479e8c29bb10b203be22b88bcfcec34b7005c88320e4868a4a
const $a565dfe414b59a2e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accountId",
                    "variableName": "userId"
                }
            ],
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "concreteType": "AtlassianAccountUserExtendedProfile",
                            "kind": "LinkedField",
                            "name": "extendedProfile",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "teamType"
                                }
                            ]
                        }
                    ],
                    "type": "AtlassianAccountUser"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTeamTypeUserQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTeamTypeUserQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5a90bd734b6a803ea4d3f84efc341d99",
            "id": "4c602c004189d4479e8c29bb10b203be22b88bcfcec34b7005c88320e4868a4a",
            "metadata": {},
            "name": "useTeamTypeUserQuery",
            "operationKind": "query",
            "text": "query useTeamTypeUserQuery($userId:ID!){user(accountId:$userId){__typename,...on AtlassianAccountUser{extendedProfile{teamType}},id}}"
        }
    };
}();
$a565dfe414b59a2e$var$node.hash = "659b30ff95a73b6d22f7bc775f0941ef";
var $a565dfe414b59a2e$export$2e2bcd8739ae039 = $a565dfe414b59a2e$var$node;
module.exports["default"] = $a565dfe414b59a2e$export$2e2bcd8739ae039;

});

parcelRegister("5IOrg", function(module, exports) {
/**
 * @generated SignedSource<<fe571911745669516f11a74ed9e0569f>>
 * @relayHash 305bfba629f3fb1fcf0b98802abf2507
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 69cd3740366e8d29b1c6a6a4156b7f2fcdf259b3466473ee99895304547b640a
const $563193a81ba03362$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortingScheme"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "limit",
                    "variableName": "limit"
                },
                {
                    "kind": "Variable",
                    "name": "sortingScheme",
                    "variableName": "sortingScheme"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "PaginatedTemplateInfoList",
            "kind": "LinkedField",
            "name": "allTemplates",
            "plural": false,
            "selections": [
                {
                    "concreteType": "TemplateInfo",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "templateId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "contentBlueprintId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "blueprintModuleCompleteKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "itemModuleCompleteKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "templateType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "description"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "iconURL"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "darkModeIconURL"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "styleClass"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasWizard"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isNew"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isPromoted"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isFavourite"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasGlobalBlueprintContent"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "categoryIds"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "keywords"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "recommendationRank"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "author"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSuggestedTemplatesQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSuggestedTemplatesQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "305bfba629f3fb1fcf0b98802abf2507",
            "id": "69cd3740366e8d29b1c6a6a4156b7f2fcdf259b3466473ee99895304547b640a",
            "metadata": {},
            "name": "useSuggestedTemplatesQuery",
            "operationKind": "query",
            "text": "query useSuggestedTemplatesQuery($spaceKey:String!,$sortingScheme:String,$limit:Int!){allTemplates(spaceKey:$spaceKey,sortingScheme:$sortingScheme,limit:$limit){nodes{templateId,contentBlueprintId,blueprintModuleCompleteKey,itemModuleCompleteKey,templateType,name,description,iconURL,darkModeIconURL,styleClass,hasWizard,isNew,isPromoted,isFavourite,hasGlobalBlueprintContent,categoryIds,keywords,recommendationRank,author}}}"
        }
    };
}();
$563193a81ba03362$var$node.hash = "0e72a917d2ed7c5fe874a55ae939d049";
var $563193a81ba03362$export$2e2bcd8739ae039 = $563193a81ba03362$var$node;
module.exports["default"] = $563193a81ba03362$export$2e2bcd8739ae039;

});

parcelRegister("fDlC6", function(module, exports) {

var $fEPSi = parcelRequire("fEPSi");


var $bxEVw = parcelRequire("bxEVw");

const $7074b9818e0cdece$export$3d370c33621572df = 'cohort';
var $7074b9818e0cdece$export$9597a1504e32193b = /*#__PURE__*/ function(BLANK_PAGE_QUICK_ACTIONS_MULTI_VARIANT_COHORTS) {
    BLANK_PAGE_QUICK_ACTIONS_MULTI_VARIANT_COHORTS["NOT_ENROLLED"] = "not-enrolled";
    BLANK_PAGE_QUICK_ACTIONS_MULTI_VARIANT_COHORTS["CONTROL"] = "control";
    BLANK_PAGE_QUICK_ACTIONS_MULTI_VARIANT_COHORTS["VARIANT1"] = "variant1";
    BLANK_PAGE_QUICK_ACTIONS_MULTI_VARIANT_COHORTS["VARIANT2"] = "variant2";
    return BLANK_PAGE_QUICK_ACTIONS_MULTI_VARIANT_COHORTS;
}({});
var $7074b9818e0cdece$export$ffc89054ddebf9 = /*#__PURE__*/ function(BLANK_PAGE_QUICK_ACTIONS_SINGLE_VARIANT_COHORTS) {
    BLANK_PAGE_QUICK_ACTIONS_SINGLE_VARIANT_COHORTS["NOT_ENROLLED"] = "not-enrolled";
    BLANK_PAGE_QUICK_ACTIONS_SINGLE_VARIANT_COHORTS["CONTROL"] = "control";
    BLANK_PAGE_QUICK_ACTIONS_SINGLE_VARIANT_COHORTS["TEST"] = "test";
    return BLANK_PAGE_QUICK_ACTIONS_SINGLE_VARIANT_COHORTS;
}({});
const $7074b9818e0cdece$var$TABLE = (shouldTableBeFullWidth = false)=>({
        id: 'Table',
        testId: 'table-quick-action',
        name: {
            ...(0, $bxEVw.i18n).tableName
        },
        alt: {
            ...(0, $bxEVw.i18n).tableAltText
        },
        type: 'document',
        shortName: 'table',
        onClick: (editorView, editorApi, setLocalIdForOnboarding)=>{
            if (!editorView || !editorApi || !setLocalIdForOnboarding) return;
            // find inserted table node's local id
            const tableInfo = (0, $fEPSi.getSelectedTableInfo)(editorView.state.selection);
            if (!tableInfo) return;
            const { table: table } = tableInfo;
            const localId = table?.node.attrs.localId;
            setLocalIdForOnboarding(localId);
        },
        adf: [
            {
                type: 'table',
                attrs: {
                    layout: 'default',
                    width: shouldTableBeFullWidth ? 1800 : 760
                },
                content: [
                    {
                        type: 'tableRow',
                        content: [
                            {
                                type: 'tableHeader',
                                attrs: {
                                    colspan: 1,
                                    rowspan: 1
                                },
                                content: [
                                    {
                                        type: 'paragraph'
                                    }
                                ]
                            },
                            {
                                type: 'tableHeader',
                                attrs: {
                                    colspan: 1,
                                    rowspan: 1
                                },
                                content: [
                                    {
                                        type: 'paragraph'
                                    }
                                ]
                            },
                            {
                                type: 'tableHeader',
                                attrs: {
                                    colspan: 1,
                                    rowspan: 1
                                },
                                content: [
                                    {
                                        type: 'paragraph'
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        type: 'tableRow',
                        content: [
                            {
                                type: 'tableCell',
                                attrs: {
                                    colspan: 1,
                                    rowspan: 1
                                },
                                content: [
                                    {
                                        type: 'paragraph'
                                    }
                                ]
                            },
                            {
                                type: 'tableCell',
                                attrs: {
                                    colspan: 1,
                                    rowspan: 1
                                },
                                content: [
                                    {
                                        type: 'paragraph'
                                    }
                                ]
                            },
                            {
                                type: 'tableCell',
                                attrs: {
                                    colspan: 1,
                                    rowspan: 1
                                },
                                content: [
                                    {
                                        type: 'paragraph'
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        type: 'tableRow',
                        content: [
                            {
                                type: 'tableCell',
                                attrs: {
                                    colspan: 1,
                                    rowspan: 1
                                },
                                content: [
                                    {
                                        type: 'paragraph'
                                    }
                                ]
                            },
                            {
                                type: 'tableCell',
                                attrs: {
                                    colspan: 1,
                                    rowspan: 1
                                },
                                content: [
                                    {
                                        type: 'paragraph'
                                    }
                                ]
                            },
                            {
                                type: 'tableCell',
                                attrs: {
                                    colspan: 1,
                                    rowspan: 1
                                },
                                content: [
                                    {
                                        type: 'paragraph'
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    });
const $7074b9818e0cdece$var$INFO_PANEL = {
    id: 'InfoPanel',
    testId: 'info-panel-quick-action',
    name: {
        ...(0, $bxEVw.i18n).infoPanelName
    },
    alt: {
        ...(0, $bxEVw.i18n).infoPanelAltText
    },
    type: 'document',
    shortName: 'panel',
    adf: [
        {
            type: 'panel',
            attrs: {
                panelType: 'info'
            },
            content: [
                {
                    type: 'paragraph'
                }
            ]
        }
    ]
};
const $7074b9818e0cdece$var$TABLE_OF_CONTENTS = {
    id: 'TableOfContents',
    testId: 'table-of-contents-quick-action',
    name: {
        ...(0, $bxEVw.i18n).tableOfContentsName
    },
    alt: {
        ...(0, $bxEVw.i18n).tableOfContentsAltText
    },
    title: {
        ...(0, $bxEVw.i18n).tableOfContentsTitle
    },
    type: 'macro',
    shortName: 'toc',
    adf: [
        {
            type: 'extension',
            attrs: {
                layout: 'default',
                extensionType: 'com.atlassian.confluence.macro.core',
                extensionKey: 'toc',
                parameters: {
                    macroParams: {
                        style: {
                            value: 'none'
                        }
                    },
                    macroMetadata: {
                        schemaVersion: {
                            value: '1'
                        },
                        title: 'Table of Contents'
                    }
                }
            }
        }
    ]
};
const $7074b9818e0cdece$export$2525a2a8fd05dd3 = {
    id: 'ShowMore'
};
const $7074b9818e0cdece$export$c23518f40bf2594 = (shouldTableBeFullWidth = false)=>[
        $7074b9818e0cdece$var$TABLE(shouldTableBeFullWidth),
        $7074b9818e0cdece$var$INFO_PANEL,
        $7074b9818e0cdece$var$TABLE_OF_CONTENTS
    ];
var $7074b9818e0cdece$export$4a7d3275dddb1c6d = /*#__PURE__*/ function(BPQA_TOP_TEMPLATE_KEYS) {
    BPQA_TOP_TEMPLATE_KEYS["HOW_TO_ARTICLE"] = "com.atlassian.confluence.plugins.confluence-knowledge-base:kb-how-to-article-blueprint";
    BPQA_TOP_TEMPLATE_KEYS["PRODUCT_REQUIREMENTS"] = "com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint";
    BPQA_TOP_TEMPLATE_KEYS["PROJECT_PLAN"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint";
    BPQA_TOP_TEMPLATE_KEYS["RETROSPECTIVE"] = "com.atlassian.confluence.plugins.confluence-software-blueprints:retrospectives-blueprint";
    BPQA_TOP_TEMPLATE_KEYS["PRODUCT_ROADMAP"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:product-roadmap-blueprint";
    BPQA_TOP_TEMPLATE_KEYS["WEEKLY_MEETING_NOTES"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:recurring-meeting-minutes-blueprint";
    BPQA_TOP_TEMPLATE_KEYS["DECISIONS"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint";
    BPQA_TOP_TEMPLATE_KEYS["FILE_LIST"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:file-list-blueprint";
    return BPQA_TOP_TEMPLATE_KEYS;
}({});
var $7074b9818e0cdece$export$bead38a319d5af74 = /*#__PURE__*/ function(BPQA_EXCLUDED_TEMPLATE_KEYS) {
    // blog post is the one itemModuleCompleteKey because
    // it has no blueprintModuleCompleteKey
    BPQA_EXCLUDED_TEMPLATE_KEYS["BLOG_POST"] = "com.atlassian.confluence.plugins.confluence-create-content-plugin:create-blog-post";
    BPQA_EXCLUDED_TEMPLATE_KEYS["LEGACY_EDITOR"] = "com.atlassian.confluence.plugins.confluence-business-blueprints:tinyeditor-blueprint";
    return BPQA_EXCLUDED_TEMPLATE_KEYS;
}({});
const $7074b9818e0cdece$export$3d118b17c778eb8a = 3 + Object.keys($7074b9818e0cdece$export$bead38a319d5af74).length; // Number of templates to show + possible exclusions
const $7074b9818e0cdece$export$3e62b34d6fa050da = 3;
const $7074b9818e0cdece$export$52c9019030c737ed = 250;
module.exports["SHOW_MORE_ELEMENTS"] = $7074b9818e0cdece$export$2525a2a8fd05dd3;
module.exports["QUICK_ACTIONS"] = $7074b9818e0cdece$export$c23518f40bf2594;
module.exports["BPQA_TOP_TEMPLATE_KEYS"] = $7074b9818e0cdece$export$4a7d3275dddb1c6d;
module.exports["BPQA_EXCLUDED_TEMPLATE_KEYS"] = $7074b9818e0cdece$export$bead38a319d5af74;
module.exports["TEMPLATE_LIMIT"] = $7074b9818e0cdece$export$3d118b17c778eb8a;
module.exports["TEMPLATE_SKELETONS"] = $7074b9818e0cdece$export$3e62b34d6fa050da;
module.exports["TEMPLATE_PREVIEW_DELAY"] = $7074b9818e0cdece$export$52c9019030c737ed;

});

parcelRegister("bxEVw", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $bda044cad4f1d661$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    allTemplates: {
        id: "blank-page-quick-actions.allTemplates",
        defaultMessage: "All templates"
    },
    moreElements: {
        id: "blank-page-quick-actions.moreElements",
        defaultMessage: "More elements"
    },
    helperText: {
        id: "blank-page-quick-actions.helperText",
        defaultMessage: "Select an element to get started, or just type"
    },
    brainstormName: {
        id: "blank-page-quick-actions.brainstormName",
        defaultMessage: "Brainstorm"
    },
    brainstormDescription: {
        id: "blank-page-quick-actions.brainstormDescription",
        defaultMessage: "Use Brainstorm to insert content"
    },
    brainstormAltText: {
        id: "blank-page-quick-actions.brainstormAltText",
        defaultMessage: "Use Brainstorm to insert content"
    },
    tableName: {
        id: "blank-page-quick-actions.tableName",
        defaultMessage: "Table"
    },
    tableDescription: {
        id: "blank-page-quick-actions.tableDescription",
        defaultMessage: "Insert a table"
    },
    tableAltText: {
        id: "blank-page-quick-actions.tableAltText",
        defaultMessage: "Insert a table"
    },
    infoPanelName: {
        id: "blank-page-quick-actions.infoPanelName",
        defaultMessage: "Info panel"
    },
    infoPanelDescription: {
        id: "blank-page-quick-actions.infoPanelDescription",
        defaultMessage: "Highlight information in a colored panel"
    },
    infoPanelAltText: {
        id: "blank-page-quick-actions.infoPanelAltText",
        defaultMessage: "Insert an info panel to highlight information in a colored panel"
    },
    tableOfContentsName: {
        id: "blank-page-quick-actions.tableOfContentsName",
        defaultMessage: "Table of contents"
    },
    tableOfContentsDescription: {
        id: "blank-page-quick-actions.tableOfContentsDescription",
        defaultMessage: "Create a table of contents based on your content\u2019s headings"
    },
    tableOfContentsAltText: {
        id: "blank-page-quick-actions.tableOfContentsAltText",
        defaultMessage: "Insert a table of contents"
    },
    tableOfContentsTitle: {
        id: "blank-page-quick-actions.tableOfContentsTitle",
        defaultMessage: "Table of Contents"
    },
    templateLoadError: {
        id: "blank-page-quick-actions.templateLoadError",
        defaultMessage: "We\u2019re having trouble loading suggested templates - refresh, or go to <button>all templates.</button>"
    },
    templateSuccessFlagTitle: {
        id: "blank-page-quick-actions.templateSuccessFlagTitle",
        defaultMessage: "\u201C{templateName}\u201D template chosen"
    },
    templateSuccessFlagDescription: {
        id: "blank-page-quick-actions.templateSuccessFlagDescription",
        defaultMessage: "You can change templates any time."
    },
    templateSuccessFlagBrowserOtherTemplatesLink: {
        id: "blank-page-quick-actions.templateSuccessFlagBrowserOtherTemplatesLink",
        defaultMessage: "Browse other templates"
    },
    templateSuccessFlagClearEditorLink: {
        id: "blank-page-quick-actions.templateSuccessFlagClearEditorLink",
        defaultMessage: "Clear all"
    },
    revampedBpqaTemplatePrefix: {
        id: "blank-page-quick-actions.revampedBpqaTemplatePrefix",
        defaultMessage: "For you:"
    },
    createWithRovo: {
        id: "blank-page-quick-actions.createWithRovo",
        defaultMessage: "Create with Rovo"
    },
    chooseATemplate: {
        id: "blank-page-quick-actions.chooseATemplate",
        defaultMessage: "Choose a template"
    },
    addElements: {
        id: "blank-page-quick-actions.addElements",
        defaultMessage: "Add elements"
    },
    import: {
        id: "blank-page-quick-actions.import",
        defaultMessage: "Import"
    },
    clickAnywhereToDismiss: {
        id: "blank-page-quick-actions.clickAnywhereToDismiss",
        defaultMessage: "Click anywhere to dismiss"
    },
    templates: {
        id: "blank-page-quick-actions.templates",
        defaultMessage: "Templates"
    }
});
module.exports["i18n"] = $bda044cad4f1d661$export$a7357cdd1f0b0168;

});

parcelRegister("9V507", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c646a99d277cd4b5b22a16e5f42dbd2f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $738d50ffcc582510$var$_react = $738d50ffcc582510$var$_interopRequireDefault((parcelRequire("cozmU")));

var $738d50ffcc582510$var$_baseNew = $738d50ffcc582510$var$_interopRequireDefault((parcelRequire("gElAV")));
function $738d50ffcc582510$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeText".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for auto draft functionality in Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $738d50ffcc582510$var$AiGenerativeTextIcon = (props)=>/*#__PURE__*/ $738d50ffcc582510$var$_react.default.createElement($738d50ffcc582510$var$_baseNew.default, Object.assign({
        name: "AiGenerativeTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.617 9.011a.75.75 0 0 1 .588.483l.615 1.687 1.687.615a.75.75 0 0 1 0 1.41l-1.687.615-.615 1.686a.75.75 0 0 1-1.409 0l-.616-1.686-1.686-.616a.75.75 0 0 1 0-1.409l1.686-.615.616-1.687.048-.106A.75.75 0 0 1 12.5 9z"/><path fill="currentcolor" fill-rule="evenodd" d="M9.337.604a2 2 0 0 1 2.828 0l1.233 1.232a2 2 0 0 1 0 2.828l-8.1 8.099a2 2 0 0 1-1.022.547l-3.378.676a.75.75 0 0 1-.883-.883l.676-3.38a2 2 0 0 1 .546-1.02zm-7.04 9.159a.5.5 0 0 0-.136.256l-.456 2.275 2.278-.455a.5.5 0 0 0 .254-.137l6.078-6.078-1.94-1.94zm8.808-8.099a.5.5 0 0 0-.707 0l-.961.961 1.94 1.94.96-.961a.5.5 0 0 0 0-.707z" clip-rule="evenodd"/>`
    }, props));
$738d50ffcc582510$var$AiGenerativeTextIcon.displayName = 'AiGenerativeTextIcon';
var $738d50ffcc582510$var$_default = module.exports.default = $738d50ffcc582510$var$AiGenerativeTextIcon;

});

parcelRegister("lG7DR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $9wGTI = parcelRequire("9wGTI");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $30D0J = parcelRequire("30D0J");


var $gxTpP = parcelRequire("gxTpP");


var $5cryL = parcelRequire("5cryL");


var $ivb8S = parcelRequire("ivb8S");


var $2FNNv = parcelRequire("2FNNv");


var $4krqA = parcelRequire("4krqA");


var $9DBk6 = parcelRequire("9DBk6");

const $4eb4c2cd5aab6b56$var$CONFLUENCE_KEY = 'confluence';
const $4eb4c2cd5aab6b56$export$8334391e845b66cf = ()=>{
    const [isEligibleTag, setIsEligibleTag] = (0, $cozmU.useState)(false);
    // Contexts and hooks
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const isEstablishedUserTraitName = (0, $2FNNv.useIsEstablishedUserTraitName)();
    // Onboarding state
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        (0, $gxTpP.CONTEXTUAL_INVITE_NUDGE).EXPERIMENT_ELIGIBLE_TAG,
        (0, $gxTpP.CONTEXTUAL_INVITE_NUDGE).WAS_CONFETTI_SEEN,
        (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).HAS_USER_PUBLISHED,
        (0, $9DBk6.LIVE_PAGE_NUDGE).LIVE_PAGE_CONTEXTUAL_NUDGE_SEEN
    ], !(0, $9wGTI.fg)('cc_onboarding_experience'));
    const onboardingState = (0, $ivb8S.deserializeState)(onboardingStateData);
    const { contextualInviteNudgeEligibleTag: contextualInviteNudgeEligibleTag, hasUserPublished: hasUserPublished, wasLivePageNudgeSeen: wasLivePageNudgeSeen } = onboardingState;
    const skip = !isLicensed || onboardingStateLoading || Boolean(contextualInviteNudgeEligibleTag) || Boolean(hasUserPublished) || Boolean(wasLivePageNudgeSeen) || !(0, $9wGTI.fg)('cc_onboarding_experience');
    // User personalization query for isEstablishedUser
    const { data: userPersonalizationQueryData, loading: userPersonalizationQueryLoading, error: userPersonalizationQueryError } = (0, $30D0J.useExperimentalUserPersonalizationQuery)({
        variables: {
            userId: userId ?? ''
        },
        skip: skip
    });
    const attributes = userPersonalizationQueryData?.experimentalUserPersonalization?.attributes ?? [];
    const isEstablishedUser = attributes.find((attr)=>attr?.name === isEstablishedUserTraitName)?.value === 'true';
    // Combined loading and error states
    const loading = userPersonalizationQueryLoading || onboardingStateLoading;
    const error = userPersonalizationQueryError || onboardingStateError;
    (0, $cozmU.useEffect)(()=>{
        if (skip || loading || error || isEstablishedUser) return;
        const fetchInvitePermsAndSetEligibility = async ()=>{
            const response = await (0, $4krqA.memoizedGetInvitePermissions)(cloudId);
            if (response instanceof Error) createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: 'editorOrViewPage',
                    action: 'failed',
                    actionSubject: 'getInvitePermissions',
                    attributes: {
                        message: response?.message
                    }
                }
            }).fire();
            const canInviteToConfluence = [
                ...response?.directInvite ?? [],
                ...response?.invitePendingApproval ?? []
            ].some((item)=>item.includes($4eb4c2cd5aab6b56$var$CONFLUENCE_KEY));
            if (canInviteToConfluence) {
                setOnboardingState({
                    key: (0, $gxTpP.CONTEXTUAL_INVITE_NUDGE).EXPERIMENT_ELIGIBLE_TAG,
                    value: 'true'
                });
                setIsEligibleTag(true);
            }
        };
        fetchInvitePermsAndSetEligibility();
    }, [
        error,
        loading,
        skip,
        cloudId,
        contextualInviteNudgeEligibleTag,
        isEstablishedUser,
        setOnboardingState,
        createAnalyticsEvent
    ]);
    return {
        contextualInviteNudgeEligibleTag: Boolean(isEligibleTag || contextualInviteNudgeEligibleTag),
        onboardingState: onboardingState
    };
};
module.exports["useContextualInviteNudge"] = $4eb4c2cd5aab6b56$export$8334391e845b66cf;

});

parcelRegister("30D0J", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");


var $7c4rV = parcelRequire("7c4rV");

const $0f856dd8e4045e89$var$mapPersonalizationResponse = (response)=>({
        experimentalUserPersonalization: {
            attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(response.attributes)
        }
    });
const $0f856dd8e4045e89$export$241fc4ad38d78de1 = ({ skip: skip, onError: onError, variables: variables })=>{
    const lastHandledTraitErrorRef = (0, $cozmU.useRef)(null);
    const legacyResult = (0, $dK51B.useExperimentalQuery)({
        // eslint-disable-next-line confluence-targeting-usage/no-legacy-tap-personalization-api -- To be migrated to useAtlassianAccountTraits. See ACTIVATION-2527
        url: ({ userId: userId })=>`/gateway/api/tap-delivery/api/v3/personalization/user/${userId}`,
        method: 'GET',
        parseResult: $0f856dd8e4045e89$var$mapPersonalizationResponse,
        skip: skip || (0, $6mKj3.expVal)('cc_ce_mau_deprecated_tap_wrappers_migration', 'isEnabled', false),
        onError: onError,
        variables: variables
    });
    const atlassianAccountTraitsResult = (0, $7c4rV.useAtlassianAccountTraits)({
        skipBootstrap: skip || !variables.userId || !(0, $6mKj3.expVal)('cc_ce_mau_deprecated_tap_wrappers_migration', 'isEnabled', false)
    });
    (0, $cozmU.useEffect)(()=>{
        const traitError = atlassianAccountTraitsResult.error;
        if (skip || !variables.userId || !traitError || lastHandledTraitErrorRef.current === traitError || !(0, $6mKj3.expVal)('cc_ce_mau_deprecated_tap_wrappers_migration', 'isEnabled', false)) return;
        lastHandledTraitErrorRef.current = traitError;
        onError?.(traitError);
    }, [
        atlassianAccountTraitsResult.error,
        onError,
        skip,
        variables.userId
    ]);
    if (!(0, $6mKj3.expVal)('cc_ce_mau_deprecated_tap_wrappers_migration', 'isEnabled', false)) return legacyResult;
    if (skip || !variables.userId) return legacyResult;
    return {
        ...legacyResult,
        data: atlassianAccountTraitsResult.data ? $0f856dd8e4045e89$var$mapPersonalizationResponse(atlassianAccountTraitsResult.data) : undefined,
        loading: atlassianAccountTraitsResult.loading,
        error: atlassianAccountTraitsResult.error ?? undefined
    };
};
module.exports["useExperimentalUserPersonalizationQuery"] = $0f856dd8e4045e89$export$241fc4ad38d78de1;

});

parcelRegister("dK51B", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1GTIR = parcelRequire("1GTIR");


var $fqCbQ = parcelRequire("fqCbQ");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");

function $7ac155b86059b716$export$9a41df5b9f27a628({ url: url, method: method, headers: headers, body: body, variables: variables, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError
    });
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    return $7ac155b86059b716$export$defacdf98710c90a({
        key: key,
        fetchData: fetchData,
        variables: variables,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        skip: skip,
        fetchPolicy: fetchPolicy,
        pollInterval: pollInterval
    });
}
function $7ac155b86059b716$export$defacdf98710c90a({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    const { queryState: queryState, execute: execute, refetch: refetch, stopPolling: stopPolling } = (0, $fqCbQ.useExperimentalQueryExecution)({
        key: key,
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        fetchPolicy: fetchPolicy,
        isLazyQuery: false,
        pollInterval: pollInterval,
        isSSR: isSSR
    });
    (0, $cozmU.useEffect)(()=>{
        // Edit Page uses JSDOM, so effects run in SSR. Experimental queries should not execute during SSR
        if (!skip && !isSSR) execute();
    }, [
        execute,
        key,
        skip,
        fetchPolicy,
        isSSR
    ]);
    // If skip is true, return idle state with refetch
    if (skip) return {
        ...(0, $7ji4X.INITIAL_IDLE_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
    // Use store state if available, otherwise return initial loading state with refetch
    // (stable reference prevents extra renders before query executes)
    return queryState ? {
        ...queryState,
        refetch: refetch,
        stopPolling: stopPolling
    } : {
        ...(0, $7ji4X.INITIAL_LOADING_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQuery"] = $7ac155b86059b716$export$9a41df5b9f27a628;
module.exports["useExperimentalQueryBase"] = $7ac155b86059b716$export$defacdf98710c90a;

});

parcelRegister("1GTIR", function(module, exports) {

var $26Yfd = parcelRequire("26Yfd");


var $GLgaM = parcelRequire("GLgaM");

// Allows using variables from either the mutate call or initial hook call
// Follows Apollo Client behavior: only falls back when variables is undefined, not empty object
const $e94116a19c839dfc$var$resolveVariables = (localVariables, fallbackVariables)=>{
    return localVariables !== undefined ? localVariables : fallbackVariables ?? {};
};
const $e94116a19c839dfc$export$80ee20aa64f130f = ({ url: url, method: method, variables: variables = {}, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const response = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, resolvedVariables);
        return parseResult(response, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
const $e94116a19c839dfc$export$54f10667ecd8890d = ({ requestConfigs: requestConfigs, variables: variables = {}, parseResult: parseResult })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const responses = await Promise.all(requestConfigs.map((fetchOptions)=>(0, $GLgaM.fetchResponse)(fetchOptions, resolvedVariables)));
        return parseResult(responses, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
module.exports["useFetchData"] = $e94116a19c839dfc$export$80ee20aa64f130f;
module.exports["useFetchDataWithMultipleFetches"] = $e94116a19c839dfc$export$54f10667ecd8890d;

});

parcelRegister("fqCbQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $26Yfd = parcelRequire("26Yfd");


var $hR9WV = parcelRequire("hR9WV");


var $7ji4X = parcelRequire("7ji4X");


var $iXGsw = parcelRequire("iXGsw");

const $2b5be438041a56b3$export$96d43f36deadf5d1 = new Map();
function $2b5be438041a56b3$export$ca796a141438ab25({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, fetchPolicy: fetchPolicy, isLazyQuery: isLazyQuery = false, pollInterval: pollInterval, isSSR: isSSR = false }) {
    // For no-cache: use local state per hook instance instead of shared state
    const [localState, setLocalState] = (0, $cozmU.useState)();
    const sharedState = (0, $7ji4X.useExperimentalQueryState)({
        key: key
    });
    const { setQueryState: setQueryState } = (0, $7ji4X.useExperimentalQueryStateActions)();
    // Store the last used variables for polling
    // This ensures lazy queries remember their variables for subsequent poll requests
    const lastVariablesRef = (0, $cozmU.useRef)(undefined);
    // Choose which state to expose based on fetchPolicy
    const queryState = fetchPolicy === 'no-cache' ? localState : sharedState;
    const execute = (0, $26Yfd.useStableCallback)(async (variables, options)=>{
        // Store variables for future polling requests
        // This matches Apollo's behavior where lazy queries remember their variables
        if (variables !== undefined) lastVariablesRef.current = variables;
        // Use provided variables, or fall back to stored variables (e.g., during polling)
        const effectiveVariables = variables ?? lastVariablesRef.current;
        // If cache-first and we have data, return immediately (unless bypassCache is true, e.g., for polling)
        if (fetchPolicy === 'cache-first' && queryState?.data !== undefined && !options?.bypassCache) {
            onCompleted?.(queryState.data);
            return;
        }
        // Check if this exact query is already in flight (deduplication)
        const existingPromise = $2b5be438041a56b3$export$96d43f36deadf5d1.get(key);
        if (existingPromise) {
            // Wait for the shared promise
            const outcome = await existingPromise;
            // Set local state if no-cache policy. Other fetch policies use shared state
            if (fetchPolicy === 'no-cache') {
                if (outcome.error) setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: outcome.error,
                        called: true
                    }));
                else if (outcome.data !== undefined) setLocalState({
                    data: outcome.data,
                    loading: false,
                    error: undefined,
                    called: true
                });
            }
            // Call this component's callbacks
            if (outcome.error) onError?.(outcome.error);
            else if (outcome.data !== undefined) onCompleted?.(outcome.data);
            return;
        }
        // Create a Promise for the fetch operation that resolves to the outcome
        const fetchPromise = (async ()=>{
            try {
                // Set loading state if not initial fetch
                const shouldSetLoadingState = !options?.skipLoadingState && (isLazyQuery || queryState?.loading === false || queryState?.data !== undefined || queryState?.error);
                if (shouldSetLoadingState) {
                    // Update the appropriate state based on fetchPolicy
                    if (fetchPolicy === 'no-cache') setLocalState({
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                    else setQueryState(key, {
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                }
                const data = await fetchData(effectiveVariables);
                if (fetchPolicy === 'no-cache') setLocalState({
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                else setQueryState(key, {
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                onCompleted?.(data);
                return {
                    data: data
                };
            } catch (error) {
                const finalError = await (0, $hR9WV.handleError)({
                    error: error,
                    transformError: transformError,
                    onError: onError
                });
                if (fetchPolicy === 'no-cache') setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                else setQueryState(key, (prev)=>({
                        data: prev.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                return {
                    error: finalError
                };
            } finally{
                // Remove from in-flight map so future calls create a new request
                $2b5be438041a56b3$export$96d43f36deadf5d1.delete(key);
            }
        })();
        // Store the Promise in the Map before starting the fetch
        $2b5be438041a56b3$export$96d43f36deadf5d1.set(key, fetchPromise);
        await fetchPromise;
    });
    // Note: This only updates the shared state, so any fetch policies (e.g. "no-cache") will be ignored.
    // Please implement local state usage if it's needed in the future.
    const refetch = (0, $26Yfd.useStableCallback)(async (variables)=>{
        try {
            setQueryState(key, {
                data: queryState?.data,
                loading: true,
                error: undefined,
                called: true
            });
            const data = await fetchData(variables);
            setQueryState(key, {
                data: data,
                loading: false,
                error: undefined,
                called: true
            });
            onCompleted?.(data);
            return {
                data: data
            };
        } catch (error) {
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            setQueryState(key, (prev)=>({
                    data: prev.data,
                    loading: false,
                    error: finalError,
                    called: true
                }));
            throw finalError;
        }
    });
    const { stopPolling: stopPolling } = (0, $iXGsw.usePollInterval)(pollInterval, execute, fetchPolicy, isLazyQuery, queryState?.called, isSSR);
    return {
        queryState: queryState,
        execute: execute,
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQueryExecution"] = $2b5be438041a56b3$export$ca796a141438ab25;

});

parcelRegister("hR9WV", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $bjeS8 = parcelRequire("bjeS8");

const $b1a7f6ba28f294ca$export$d3da1ecaf1206c58 = async ({ error: error, transformError: transformError, onError: onError })=>{
    // The `transformError` callback can optionally return a new error to replace the original,
    // allowing for custom errors (e.g. based on the error's status code)
    const finalError = (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    // Process error for monitoring/analytics
    if (finalError.graphQLErrors?.length) finalError.graphQLErrors.forEach((e)=>{
        (0, $7Sm4c.processError)(e);
    });
    onError?.(finalError);
    return finalError;
};
module.exports["handleError"] = $b1a7f6ba28f294ca$export$d3da1ecaf1206c58;

});

parcelRegister("iXGsw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $d90d6eaddcfc40bd$export$55982a4d88e0db29(pollInterval, execute, fetchPolicy, isLazyQuery, called, isSSR) {
    if (pollInterval && fetchPolicy === 'cache-first') throw new Error('Queries that specify the cache-first fetchPolicy cannot also be polling queries.');
    const pollIntervalRef = (0, $cozmU.useRef)(null);
    const stopPolling = (0, $cozmU.useCallback)(()=>{
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
    }, []);
    const handlePoll = (0, $cozmU.useCallback)(()=>{
        execute(undefined, {
            bypassCache: true,
            skipLoadingState: true
        });
    }, [
        execute
    ]);
    // For non-lazy queries: poll immediately when pollInterval > 0
    // For lazy queries: only poll after query has been called at least once
    const shouldStartPolling = (0, $cozmU.useMemo)(()=>{
        if (isSSR || !pollInterval || pollInterval <= 0) return false;
        return !isLazyQuery || called;
    }, [
        isSSR,
        pollInterval,
        isLazyQuery,
        called
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Clear any existing poll interval when conditions change
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
        if (shouldStartPolling) pollIntervalRef.current = setInterval(()=>{
            handlePoll();
        }, pollInterval);
        // Cleanup on unmount or when dependencies change
        return ()=>{
            if (pollIntervalRef.current) {
                clearInterval(pollIntervalRef.current);
                pollIntervalRef.current = null;
            }
        };
    }, [
        pollInterval,
        handlePoll,
        shouldStartPolling
    ]);
    return {
        stopPolling: stopPolling
    };
}
module.exports["usePollInterval"] = $d90d6eaddcfc40bd$export$55982a4d88e0db29;

});

parcelRegister("CIjCq", function(module, exports) {
/**
 * The TAP delivery API returns mixed types (boolean, number, string), but the
 * previous experimental GraphQL schema defined all values as String!, causing
 * automatic coercion. When bypassing GraphQL via useExperimentalQuery, we need
 * to manually coerce to maintain the same behavior consumer code expects.
 */ function $3c8babd51a2343c1$export$1660902c4f08468b(attributes) {
    if (!attributes) return [];
    return attributes.map((attr)=>({
            ...attr,
            value: String(attr.value)
        }));
}
module.exports["stringifyPersonalizationAttributes"] = $3c8babd51a2343c1$export$1660902c4f08468b;

});

parcelRegister("7c4rV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $5a7a73b748300e1f$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $5a7a73b748300e1f$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $5a7a73b748300e1f$export$9bcfef244f363dbe = (0, $8s9DV.createStore)({
    initialState: $5a7a73b748300e1f$var$initialState,
    actions: $5a7a73b748300e1f$var$actions,
    name: 'atlassianAccountTraitsStore'
});
const $5a7a73b748300e1f$export$c35c4239c4894215 = (0, $kBr4q.createHook)($5a7a73b748300e1f$export$9bcfef244f363dbe);
const $5a7a73b748300e1f$export$aa4cdf7390fbf455 = (0, $kBr4q.createActionsHook)($5a7a73b748300e1f$export$9bcfef244f363dbe);
async function $5a7a73b748300e1f$var$fetchAtlassianAccountTraitsData(userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $5a7a73b748300e1f$var$hasFetched = false;
function $5a7a73b748300e1f$export$f1fbc6ad89f91b89() {
    $5a7a73b748300e1f$var$hasFetched = false;
}
function $5a7a73b748300e1f$var$getAtlassianAccountTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.user);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.user);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $5a7a73b748300e1f$export$88411c3a679154ab({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $cozmU.useMemo)(()=>$5a7a73b748300e1f$var$getAtlassianAccountTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $5a7a73b748300e1f$export$c35c4239c4894215();
    const { accessStatus: accessStatus, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $cozmU.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($5a7a73b748300e1f$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !userId) return;
        $5a7a73b748300e1f$var$hasFetched = true;
        storeActions.start();
        $5a7a73b748300e1f$var$fetchAtlassianAccountTraitsData(userId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        userId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useAtlassianAccountTraits"] = $5a7a73b748300e1f$export$88411c3a679154ab;

});

parcelRegister("gxTpP", function(module, exports) {
const $62a1556a5bf2ef38$export$ed1ceddf3ffdd8ab = {
    EXPERIMENT_ELIGIBLE_TAG: 'onboarding-contextual-invite-nudge:contextualInviteNudgeEligibleTag',
    WAS_CONFETTI_SEEN: 'onboarding-contextual-invite-nudge:wasFirstPublishConfettiSeen'
};
const $62a1556a5bf2ef38$export$fdbc8dd83db637ed = [
    ...Object.values($62a1556a5bf2ef38$export$ed1ceddf3ffdd8ab)
];
module.exports["CONTEXTUAL_INVITE_NUDGE"] = $62a1556a5bf2ef38$export$ed1ceddf3ffdd8ab;
module.exports["ContextualInviteNudgeOnboardingKeys"] = $62a1556a5bf2ef38$export$fdbc8dd83db637ed;

});

parcelRegister("2FNNv", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");

// Production trait: https://data-portal.internal.atlassian.com/targeting/traits/f0c5d949-91be-46e0-b440-7d7a953c9159
const $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME = 'confluence_is_established_user';
// Staging trait: https://data-portal-stg.internal.atlassian.com/targeting/traits/4015e85e-221b-4d95-a945-c68548e21a8b
// NOTE: DO NOT USE Staging trait named as `confluence_is_established_user` - this is a legacy trait created with wrong evaluation type and won't work for staging
const $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME_STAGING = 'confluence_is_established_user_stg';
const $f30477d177bb95bd$export$a284916a4d5ed017 = ()=>{
    const { environment: environment } = (0, $bQm3c.useSessionData)();
    if (environment !== 'PRODUCTION') return $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME_STAGING;
    return $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME;
};
module.exports["useIsEstablishedUserTraitName"] = $f30477d177bb95bd$export$a284916a4d5ed017;

});

parcelRegister("4krqA", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $f7B1p = parcelRequire("f7B1p");

const $205c154f2fef63b0$export$ab2f49a861856bab = '/gateway/api';
const $205c154f2fef63b0$export$df4d1d71f09676b7 = '/v3/invitations/capabilities';
function $205c154f2fef63b0$var$handleCapabilitiesResponse(response) {
    const directInvite = new Set();
    const invitePendingApproval = new Set();
    if (Array.isArray(response)) response.forEach((entry)=>{
        if (!directInvite.has(entry.resourceARI) && 'NONE' !== entry.directInvite.mode) directInvite.add(entry.resourceARI);
        if (!invitePendingApproval.has(entry.resourceARI) && 'NONE' !== entry.invitePendingApproval.mode) invitePendingApproval.add(entry.resourceARI);
    });
    return {
        directInvite: [
            ...directInvite
        ],
        invitePendingApproval: [
            ...invitePendingApproval
        ]
    };
}
// This closely follows the implementation of the client from the Invite People package
// platform/packages/people-and-teams/invite-people/src/clients/InviteApiClient.ts
// This logic is subject to change at any time and should only be used for experimental purposes
const $205c154f2fef63b0$var$getInvitePermissions = async (cloudId)=>{
    const resource = `ari:cloud:platform::site/${cloudId}`;
    try {
        const response = await (0, $f7B1p.cfetch)(`${$205c154f2fef63b0$export$ab2f49a861856bab}${$205c154f2fef63b0$export$df4d1d71f09676b7}?resource=${resource}`);
        const inviteResponse = await response.json();
        return $205c154f2fef63b0$var$handleCapabilitiesResponse(inviteResponse);
    } catch (error) {
        return error;
    }
};
const $205c154f2fef63b0$export$669226fe425132b5 = (0, $dOBRD.default)($205c154f2fef63b0$var$getInvitePermissions);
module.exports["memoizedGetInvitePermissions"] = $205c154f2fef63b0$export$669226fe425132b5;

});

parcelRegister("9DBk6", function(module, exports) {
const $d9e19a0d44ee3302$export$b02e3be205ee7739 = {
    LIVE_PAGE_CONTEXTUAL_NUDGE_SEEN: 'live-page-nudge:wasLivePageNudgeSeen',
    // used to limit calls to the invite permissions API
    LIVE_PAGE_INVITE_INELIGIBLE: 'live-page-nudge:livePageNudgeInviteIneligible'
};
const $d9e19a0d44ee3302$export$b3d9533dbdf35d0 = [
    ...Object.values($d9e19a0d44ee3302$export$b02e3be205ee7739)
];
module.exports["LIVE_PAGE_NUDGE"] = $d9e19a0d44ee3302$export$b02e3be205ee7739;
module.exports["LiveDocsOnboardingKeys"] = $d9e19a0d44ee3302$export$b3d9533dbdf35d0;

});

parcelRegister("bFMG7", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $5dyIT = parcelRequire("5dyIT");


var $cod3r = parcelRequire("cod3r");


var $79mss = parcelRequire("79mss");


var $cozmU = parcelRequire("cozmU");


var $7Sm4c = parcelRequire("7Sm4c");


var $e4o8D = parcelRequire("e4o8D");


var $308Wd = parcelRequire("308Wd");

var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $1cYlh = parcelRequire("1cYlh");


var $in5LX = parcelRequire("in5LX");


var $kknEZ = parcelRequire("kknEZ");


var $gSfo4 = parcelRequire("gSfo4");


var $fcQxC = parcelRequire("fcQxC");


var $lwZTW = parcelRequire("lwZTW");

const $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery = (0, $79mss.default);
const $8f8b1f599c43d665$export$160e6dbb5cf9582 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { flagStatus: flagStatus, submittedClassification: submittedClassification, setClassification: setClassification, setFlagStatus: setFlagStatus } = t0;
    let t1;
    let t2;
    if ($[0] !== flagStatus || $[1] !== setClassification || $[2] !== setFlagStatus || $[3] !== submittedClassification) {
        t1 = ()=>{
            if (flagStatus === (0, $in5LX.FlagStatus).SUCCESS) {
                setClassification(submittedClassification ?? null);
                setFlagStatus((0, $in5LX.FlagStatus).NONE);
            }
        };
        t2 = [
            flagStatus,
            submittedClassification,
            setClassification,
            setFlagStatus
        ];
        $[0] = flagStatus;
        $[1] = setClassification;
        $[2] = setFlagStatus;
        $[3] = submittedClassification;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
} : ({ flagStatus: flagStatus, submittedClassification: submittedClassification, setClassification: setClassification, setFlagStatus: setFlagStatus })=>{
    // Updates the classification state with the value of submittedClassification
    // on flag success, ensuring consistent behavior across edit tag & edit modal
    (0, $cozmU.useEffect)(()=>{
        if (flagStatus === (0, $in5LX.FlagStatus).SUCCESS) {
            setClassification(submittedClassification ?? null);
            setFlagStatus((0, $in5LX.FlagStatus).NONE);
        }
    }, [
        flagStatus,
        submittedClassification,
        setClassification,
        setFlagStatus
    ]);
};
const $8f8b1f599c43d665$export$e948ce957637ade5 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(39);
    const { contentId: contentId, contentStatusContext: t1, shouldSkipQueries: t2, shouldPreloadData: t3, shouldReadFromQueries: t4 } = t0;
    const contentStatusContext = t1 === undefined ? "current-only" : t1;
    const shouldSkipQueries = t2 === undefined ? false : t2;
    const shouldPreloadData = t3 === undefined ? false : t3;
    const shouldReadFromQueries = t4 === undefined ? false : t4;
    const shouldPreloadContentClassificationData = window.__SSR_RENDERED__ || shouldPreloadData;
    const [flagStatus, setFlagStatus] = (0, $cozmU.useState)((0, $in5LX.FlagStatus).NONE);
    const [classification, setClassification] = (0, $cozmU.useState)(null);
    const [currentContentId, setCurrentContentId] = (0, $cozmU.useState)(undefined);
    const [submittedClassification, setSubmittedClassification] = (0, $cozmU.useState)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { readContext: contentStatusReadContext } = (0, $fcQxC.getReadAndWriteContextFromQueryContext)(contentStatusContext);
    let t5;
    if ($[0] !== flagStatus || $[1] !== submittedClassification) {
        t5 = {
            flagStatus: flagStatus,
            submittedClassification: submittedClassification,
            setClassification: setClassification,
            setFlagStatus: setFlagStatus
        };
        $[0] = flagStatus;
        $[1] = submittedClassification;
        $[2] = t5;
    } else t5 = $[2];
    $8f8b1f599c43d665$export$160e6dbb5cf9582(t5);
    let t6;
    let t7;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (updateClassificationError)=>{
            setFlagStatus((0, $in5LX.FlagStatus).ERROR);
            (0, $7Sm4c.markErrorAsHandled)(updateClassificationError);
        };
        t7 = (data)=>{
            if (data?.bulkUpdateContentDataClassificationLevel?.success) setFlagStatus((0, $in5LX.FlagStatus).SUCCESS);
        };
        $[3] = t6;
        $[4] = t7;
    } else {
        t6 = $[3];
        t7 = $[4];
    }
    const [updateContentDataClassificationLevel] = (0, $308Wd.useMutationInterop)((0, $cod3r.default), {
        awaitRefetchQueries: true,
        onError: t6,
        onCompleted: t7,
        refetchQueries: ()=>[
                {
                    query: $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery,
                    variables: {
                        contentId: contentId,
                        lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
                    }
                }
            ],
        __callerPackage__: "data-classification"
    });
    let t8;
    let t9;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (deleteClassificationError)=>{
            setFlagStatus((0, $in5LX.FlagStatus).ERROR);
            (0, $7Sm4c.markErrorAsHandled)(deleteClassificationError);
        };
        t9 = (data_0)=>{
            if (data_0?.bulkDeleteContentDataClassificationLevel?.success) setFlagStatus((0, $in5LX.FlagStatus).SUCCESS);
        };
        $[5] = t8;
        $[6] = t9;
    } else {
        t8 = $[5];
        t9 = $[6];
    }
    const [deleteContentDataClassificationLevel, t10] = (0, $308Wd.useMutationInterop)((0, $5dyIT.default), {
        awaitRefetchQueries: true,
        onError: t8,
        onCompleted: t9,
        refetchQueries: ()=>[
                {
                    query: $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery,
                    variables: {
                        contentId: contentId,
                        lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
                    }
                }
            ],
        __callerPackage__: "data-classification"
    });
    const { loading: deleteLoading } = t10;
    const shouldSkipQueriesForClassification = shouldSkipQueries || !contentId;
    const t11 = contentId ?? "";
    const t12 = (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext);
    let t13;
    if ($[7] !== t11 || $[8] !== t12) {
        t13 = {
            contentId: t11,
            lowerCaseContentStatusArray: t12
        };
        $[7] = t11;
        $[8] = t12;
        $[9] = t13;
    } else t13 = $[9];
    const t14 = shouldPreloadContentClassificationData ? "cache-first" : "network-only";
    let t15;
    if ($[10] !== shouldSkipQueriesForClassification || $[11] !== t13 || $[12] !== t14) {
        t15 = {
            variables: t13,
            skip: shouldSkipQueriesForClassification,
            errorPolicy: "all",
            fetchPolicy: t14
        };
        $[10] = shouldSkipQueriesForClassification;
        $[11] = t13;
        $[12] = t14;
        $[13] = t15;
    } else t15 = $[13];
    const { data: objectLevelData, loading: objectLevelLoading, error: objectLevelError } = (0, $jMyy4.useQueryInterop)($8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery, {
        ...t15,
        __callerPackage__: "data-classification"
    });
    const classificationLevelDetails = objectLevelData?.singleContent?.classificationLevelDetails;
    const contentClassification = classificationLevelDetails?.classificationLevel;
    const contentLevelLoading = objectLevelLoading;
    const contentLevelError = objectLevelError;
    const spaceDefaultIsOverridden = classificationLevelDetails?.source === "CONTENT";
    const errorState = (0, $lwZTW.useClassificationErrorState)(classification, undefined, contentLevelError);
    const shouldNotDisplayContentClassification = contentClassification?.id === (0, $1cYlh.NO_CLASSIFICATION_OPTION_ID) || contentClassification?.status === (0, $kknEZ.Status).ARCHIVED || classification === null && deleteLoading || Boolean(contentLevelError);
    const contentClassificationFromQueryOrState = shouldReadFromQueries ? contentClassification : currentContentId === contentId && !!classification ? classification : contentClassification;
    const updatedClassification = shouldNotDisplayContentClassification ? null : contentClassificationFromQueryOrState;
    let t16;
    let t17;
    if ($[14] !== classification || $[15] !== contentId || $[16] !== updatedClassification) {
        t16 = ()=>{
            if (updatedClassification !== classification) {
                setClassification(updatedClassification ?? null);
                setCurrentContentId(contentId);
            }
        };
        t17 = [
            updatedClassification,
            classification,
            contentId
        ];
        $[14] = classification;
        $[15] = contentId;
        $[16] = updatedClassification;
        $[17] = t16;
        $[18] = t17;
    } else {
        t16 = $[17];
        t17 = $[18];
    }
    (0, $cozmU.useEffect)(t16, t17);
    const isClassificationPublished = classification?.status === (0, $kknEZ.Status).PUBLISHED || updatedClassification?.status === (0, $kknEZ.Status).PUBLISHED;
    const classificationFeatureEnabled = Boolean(objectLevelData?.singleContent?.classificationLevelDetails?.featureEnabled);
    const shouldDisplayClassification = classificationFeatureEnabled && (!!classification || !!updatedClassification) && !contentLevelLoading && isClassificationPublished;
    const hasNoClassification = !contentLevelLoading && !classification && !updatedClassification;
    let t18;
    if ($[19] !== objectLevelData?.singleContent?.classificationLevelDetails?.isReclassificationPermitted) {
        t18 = (objectLevelData?.singleContent?.classificationLevelDetails?.isReclassificationPermitted ?? false) || !(0, $6mKj3.expVal)("dlp_auto_classifications_enabled", "isEnabled", false);
        $[19] = objectLevelData?.singleContent?.classificationLevelDetails?.isReclassificationPermitted;
        $[20] = t18;
    } else t18 = $[20];
    const isReclassificationPermitted = t18;
    const isSSRedWithClassification = renderServerPlaceholder && updatedClassification;
    const classificationValue = isSSRedWithClassification ? updatedClassification ?? null : classification ?? updatedClassification ?? null;
    const t19 = classificationValue ?? null;
    const t20 = classificationLevelDetails?.source;
    const t21 = classificationLevelDetails?.canManageSpaceSettings;
    const t22 = classificationLevelDetails?.classificationControlSetting;
    const t23 = classificationLevelDetails?.userOverrideSetting;
    let t24;
    if ($[21] !== classificationFeatureEnabled || $[22] !== contentLevelError || $[23] !== contentLevelLoading || $[24] !== contentStatusContext || $[25] !== deleteContentDataClassificationLevel || $[26] !== errorState || $[27] !== flagStatus || $[28] !== hasNoClassification || $[29] !== isReclassificationPermitted || $[30] !== shouldDisplayClassification || $[31] !== spaceDefaultIsOverridden || $[32] !== t19 || $[33] !== t20 || $[34] !== t21 || $[35] !== t22 || $[36] !== t23 || $[37] !== updateContentDataClassificationLevel) {
        t24 = {
            classification: t19,
            spaceDefaultIsOverridden: spaceDefaultIsOverridden,
            contentLevelLoading: contentLevelLoading,
            contentLevelError: contentLevelError,
            updateContentDataClassificationLevel: updateContentDataClassificationLevel,
            deleteContentDataClassificationLevel: deleteContentDataClassificationLevel,
            setSubmittedClassification: setSubmittedClassification,
            flagStatus: flagStatus,
            setFlagStatus: setFlagStatus,
            errorState: errorState,
            shouldDisplayClassification: shouldDisplayClassification,
            hasNoClassification: hasNoClassification,
            contentStatusContext: contentStatusContext,
            featureEnabled: classificationFeatureEnabled,
            isReclassificationPermitted: isReclassificationPermitted,
            source: t20,
            canManageSpaceSettings: t21,
            classificationControlSetting: t22,
            userOverrideSetting: t23
        };
        $[21] = classificationFeatureEnabled;
        $[22] = contentLevelError;
        $[23] = contentLevelLoading;
        $[24] = contentStatusContext;
        $[25] = deleteContentDataClassificationLevel;
        $[26] = errorState;
        $[27] = flagStatus;
        $[28] = hasNoClassification;
        $[29] = isReclassificationPermitted;
        $[30] = shouldDisplayClassification;
        $[31] = spaceDefaultIsOverridden;
        $[32] = t19;
        $[33] = t20;
        $[34] = t21;
        $[35] = t22;
        $[36] = t23;
        $[37] = updateContentDataClassificationLevel;
        $[38] = t24;
    } else t24 = $[38];
    return t24;
} : ({ contentId: contentId, contentStatusContext: contentStatusContext = 'current-only', shouldSkipQueries: shouldSkipQueries = false, shouldPreloadData: shouldPreloadData = false, shouldReadFromQueries: shouldReadFromQueries = false })=>{
    const shouldPreloadContentClassificationData = window.__SSR_RENDERED__ || shouldPreloadData;
    const [flagStatus, setFlagStatus] = (0, $cozmU.useState)((0, $in5LX.FlagStatus).NONE);
    const [classification, setClassification] = (0, $cozmU.useState)(null);
    const [currentContentId, setCurrentContentId] = (0, $cozmU.useState)(undefined);
    const [submittedClassification, setSubmittedClassification] = (0, $cozmU.useState)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { readContext: contentStatusReadContext } = (0, $fcQxC.getReadAndWriteContextFromQueryContext)(contentStatusContext);
    $8f8b1f599c43d665$export$160e6dbb5cf9582({
        flagStatus: flagStatus,
        submittedClassification: submittedClassification,
        setClassification: setClassification,
        setFlagStatus: setFlagStatus
    });
    // The following two mutation functions are returned by this hook, behavior upon completion is handled within the hook
    const [updateContentDataClassificationLevel] = (0, $308Wd.useMutationInterop)((0, $cod3r.default), {
        awaitRefetchQueries: true,
        onError: (updateClassificationError)=>{
            setFlagStatus((0, $in5LX.FlagStatus).ERROR);
            (0, $7Sm4c.markErrorAsHandled)(updateClassificationError);
        },
        onCompleted: (data)=>{
            if (data?.bulkUpdateContentDataClassificationLevel?.success) setFlagStatus((0, $in5LX.FlagStatus).SUCCESS);
        },
        refetchQueries: ()=>[
                {
                    query: $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery,
                    variables: {
                        contentId: contentId,
                        lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
                    }
                }
            ],
        __callerPackage__: "data-classification"
    });
    const [deleteContentDataClassificationLevel, { loading: deleteLoading }] = (0, $308Wd.useMutationInterop)((0, $5dyIT.default), {
        awaitRefetchQueries: true,
        onError: (deleteClassificationError)=>{
            setFlagStatus((0, $in5LX.FlagStatus).ERROR);
            (0, $7Sm4c.markErrorAsHandled)(deleteClassificationError);
        },
        onCompleted: (data_0)=>{
            if (data_0?.bulkDeleteContentDataClassificationLevel?.success) setFlagStatus((0, $in5LX.FlagStatus).SUCCESS);
        },
        refetchQueries: ()=>[
                {
                    query: $8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery,
                    variables: {
                        contentId: contentId,
                        lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
                    }
                }
            ],
        __callerPackage__: "data-classification"
    });
    const shouldSkipQueriesForClassification = shouldSkipQueries || !contentId;
    const { data: objectLevelData, loading: objectLevelLoading, error: objectLevelError } = (0, $jMyy4.useQueryInterop)($8f8b1f599c43d665$var$UseContentClassificationContentDataClassificationQuery, {
        variables: {
            contentId: contentId ?? '',
            lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)(contentStatusReadContext)
        },
        skip: shouldSkipQueriesForClassification,
        errorPolicy: 'all',
        fetchPolicy: shouldPreloadContentClassificationData ? 'cache-first' : 'network-only',
        __callerPackage__: "data-classification"
    });
    const classificationLevelDetails = objectLevelData?.singleContent?.classificationLevelDetails;
    const contentClassification = classificationLevelDetails?.classificationLevel;
    const contentLevelLoading = objectLevelLoading;
    const contentLevelError = objectLevelError;
    const spaceDefaultIsOverridden = classificationLevelDetails?.source === 'CONTENT';
    const errorState = (0, $lwZTW.useClassificationErrorState)(classification, undefined, contentLevelError);
    // Determine whether to set classification either content level classification, or space default classification, or null through a series of booleans.
    // Cases where we should not display content classification:
    // 1. If "No classification" option is selected as content classification
    // 2. If content classification was archived
    // 3. If classification value from state hook is null (i.e. classification was deleted) and delete mutation is still loading
    // 4. If delete was successful and classification value from state hook is null
    // 5. If there was an error fetching content level classification
    const shouldNotDisplayContentClassification = contentClassification?.id === (0, $1cYlh.NO_CLASSIFICATION_OPTION_ID) || contentClassification?.status === (0, $kknEZ.Status).ARCHIVED || classification === null && deleteLoading || Boolean(contentLevelError);
    // This ternary determines whether to display content classification value from query or from state hook.
    // Checks whether content ID has changed since the last render, and if it has then we display the classification value from query.
    // (Resolves bug where classification wasn't properly updating when navigating between pages via page tree)
    const contentClassificationFromQueryOrState = shouldReadFromQueries ? contentClassification : currentContentId === contentId && !!classification ? classification : contentClassification;
    // Ultimately, we'll be displaying one of the two values as a content's current classification (in order of priority):
    // 1. Content level classification
    // 2. No classification (may render Add Classification button instead)
    const updatedClassification = shouldNotDisplayContentClassification ? null : contentClassificationFromQueryOrState;
    (0, $cozmU.useEffect)(()=>{
        if (updatedClassification !== classification) {
            setClassification(updatedClassification ?? null);
            setCurrentContentId(contentId);
        }
    }, [
        updatedClassification,
        classification,
        contentId
    ]);
    const isClassificationPublished = classification?.status === (0, $kknEZ.Status).PUBLISHED || updatedClassification?.status === (0, $kknEZ.Status).PUBLISHED;
    const classificationFeatureEnabled = Boolean(objectLevelData?.singleContent?.classificationLevelDetails?.featureEnabled);
    const shouldDisplayClassification = classificationFeatureEnabled && (!!classification || !!updatedClassification) && !contentLevelLoading && isClassificationPublished;
    const hasNoClassification = !contentLevelLoading && !classification && !updatedClassification;
    const isReclassificationPermitted = (objectLevelData?.singleContent?.classificationLevelDetails?.isReclassificationPermitted ?? false) || !(0, $6mKj3.expVal)('dlp_auto_classifications_enabled', 'isEnabled', false);
    //useEffect is not run during SSR, so we can't use classification from the state.
    //we cant use setClassification either as it causes side effects which causes unnecessary re-renders.
    //Instead, we can use updatedClassification for initial load for SSR.
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSRedWithClassification = renderServerPlaceholder && updatedClassification;
    const classificationValue = isSSRedWithClassification ? updatedClassification ?? null : classification ?? updatedClassification ?? null;
    return (0, $cozmU.useMemo)(()=>({
            classification: classificationValue ?? null,
            spaceDefaultIsOverridden: spaceDefaultIsOverridden,
            contentLevelLoading: contentLevelLoading,
            contentLevelError: contentLevelError,
            updateContentDataClassificationLevel: updateContentDataClassificationLevel,
            deleteContentDataClassificationLevel: deleteContentDataClassificationLevel,
            setSubmittedClassification: setSubmittedClassification,
            flagStatus: flagStatus,
            setFlagStatus: setFlagStatus,
            errorState: errorState,
            shouldDisplayClassification: shouldDisplayClassification,
            hasNoClassification: hasNoClassification,
            contentStatusContext: contentStatusContext,
            featureEnabled: classificationFeatureEnabled,
            isReclassificationPermitted: isReclassificationPermitted,
            source: classificationLevelDetails?.source,
            canManageSpaceSettings: classificationLevelDetails?.canManageSpaceSettings,
            classificationControlSetting: classificationLevelDetails?.classificationControlSetting,
            userOverrideSetting: classificationLevelDetails?.userOverrideSetting
        }), [
        classificationValue,
        spaceDefaultIsOverridden,
        contentLevelLoading,
        contentLevelError,
        updateContentDataClassificationLevel,
        deleteContentDataClassificationLevel,
        setSubmittedClassification,
        flagStatus,
        setFlagStatus,
        errorState,
        shouldDisplayClassification,
        hasNoClassification,
        contentStatusContext,
        classificationFeatureEnabled,
        isReclassificationPermitted,
        classificationLevelDetails
    ]);
};
module.exports["useContentClassification"] = $8f8b1f599c43d665$export$e948ce957637ade5;

});

parcelRegister("5dyIT", function(module, exports) {
/**
 * @generated SignedSource<<20621d8c8d7d7f709ac76a84782dff9d>>
 * @relayHash ee02cd6160cc1cfee6fa6d1fba84a159
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4fde877dd091b461b191c46c59a002d0bc95ac007ed500e5c0f27905f57ca0a2
const $916e4ca779bc282e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatuses"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentStatuses",
                            "variableName": "contentStatuses"
                        },
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "id"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "BulkDeleteContentDataClassificationLevelPayload",
            "kind": "LinkedField",
            "name": "bulkDeleteContentDataClassificationLevel",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useContentClassificationBulkDeleteContentDataClassificationLevelMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useContentClassificationBulkDeleteContentDataClassificationLevelMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ee02cd6160cc1cfee6fa6d1fba84a159",
            "id": "4fde877dd091b461b191c46c59a002d0bc95ac007ed500e5c0f27905f57ca0a2",
            "metadata": {},
            "name": "useContentClassificationBulkDeleteContentDataClassificationLevelMutation",
            "operationKind": "mutation",
            "text": "mutation useContentClassificationBulkDeleteContentDataClassificationLevelMutation($id:Long!,$contentStatuses:[ContentDataClassificationMutationContentStatus]!){bulkDeleteContentDataClassificationLevel(input:{id:$id,contentStatuses:$contentStatuses}){success,errors{message}}}"
        }
    };
}();
$916e4ca779bc282e$var$node.hash = "482a842e925e6082fc32c6749e95ba4b";
var $916e4ca779bc282e$export$2e2bcd8739ae039 = $916e4ca779bc282e$var$node;
module.exports["default"] = $916e4ca779bc282e$export$2e2bcd8739ae039;

});

parcelRegister("cod3r", function(module, exports) {
/**
 * @generated SignedSource<<45eb54206aa80f8b681379fd99d07765>>
 * @relayHash e435d6d2ef1fb5eebfc9d5c505f1e65c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c4bdbbd0abf52ccb487e52e67e59bd8bdce38ce12908470cb465fcad9d07bfba
const $cca7f8f2e7a5e122$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "classificationLevelId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatuses"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "classificationLevelId",
                            "variableName": "classificationLevelId"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentStatuses",
                            "variableName": "contentStatuses"
                        },
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "id"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "BulkUpdateContentDataClassificationLevelPayload",
            "kind": "LinkedField",
            "name": "bulkUpdateContentDataClassificationLevel",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useContentClassificationBulkUpdateContentDataClassificationLevelMutation",
            "selections": v3 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useContentClassificationBulkUpdateContentDataClassificationLevelMutation",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "e435d6d2ef1fb5eebfc9d5c505f1e65c",
            "id": "c4bdbbd0abf52ccb487e52e67e59bd8bdce38ce12908470cb465fcad9d07bfba",
            "metadata": {},
            "name": "useContentClassificationBulkUpdateContentDataClassificationLevelMutation",
            "operationKind": "mutation",
            "text": "mutation useContentClassificationBulkUpdateContentDataClassificationLevelMutation($id:Long!,$contentStatuses:[ContentDataClassificationMutationContentStatus]!,$classificationLevelId:ID!){bulkUpdateContentDataClassificationLevel(input:{id:$id,contentStatuses:$contentStatuses,classificationLevelId:$classificationLevelId}){success,errors{message}}}"
        }
    };
}();
$cca7f8f2e7a5e122$var$node.hash = "9839fe96ab36e63f6aab91bb7d0d00f7";
var $cca7f8f2e7a5e122$export$2e2bcd8739ae039 = $cca7f8f2e7a5e122$var$node;
module.exports["default"] = $cca7f8f2e7a5e122$export$2e2bcd8739ae039;

});

parcelRegister("79mss", function(module, exports) {
/**
 * @generated SignedSource<<217ed72306ad0003c83611da9b9dfec7>>
 * @relayHash 02343eb4ab11fc6471bc117cd9c349d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f9794fe079d8566f47a9f279f6b1eb86fd6f7441be80aea326be0f0bc4e003d
const $22165adc85ae14ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "lowerCaseContentStatusArray"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "lowerCaseContentStatusArray"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "ClassificationLevelDetails",
                    "kind": "LinkedField",
                    "name": "classificationLevelDetails",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentDataClassificationLevel",
                            "kind": "LinkedField",
                            "name": "classificationLevel",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "guideline"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "guidelineADF"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "color"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "featureEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "source"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReclassificationPermitted"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canManageSpaceSettings"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "classificationControlSetting"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "userOverrideSetting"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentClassificationContentDataClassificationQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentClassificationContentDataClassificationQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "02343eb4ab11fc6471bc117cd9c349d2",
            "id": "2f9794fe079d8566f47a9f279f6b1eb86fd6f7441be80aea326be0f0bc4e003d",
            "metadata": {},
            "name": "useContentClassificationContentDataClassificationQuery",
            "operationKind": "query",
            "text": "query useContentClassificationContentDataClassificationQuery($contentId:ID!,$lowerCaseContentStatusArray:[String]){singleContent(id:$contentId,status:$lowerCaseContentStatusArray){id,classificationLevelDetails{classificationLevel{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting}}}"
        }
    };
}();
$22165adc85ae14ea$var$node.hash = "e2a3c90b94181436fe0a32faafb92cf6";
var $22165adc85ae14ea$export$2e2bcd8739ae039 = $22165adc85ae14ea$var$node;
module.exports["default"] = $22165adc85ae14ea$export$2e2bcd8739ae039;

});

parcelRegister("1cYlh", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $kknEZ = parcelRequire("kknEZ");

const $e02e634ce8a36ce5$export$44086dc4ad5eb01b = 'NO_CLASSIFICATION';
const $e02e634ce8a36ce5$export$ea52aaec0b4536b2 = 'NO_CLASSIFICATION_OPTION';
const $e02e634ce8a36ce5$export$89b67151eed9295a = {
    id: $e02e634ce8a36ce5$export$ea52aaec0b4536b2,
    name: 'No default',
    order: 0,
    definition: "Pages in this space aren\u2019t classified by default.",
    color: 'NONE',
    status: (0, $kknEZ.Status).PUBLISHED
};
const $e02e634ce8a36ce5$export$de715bd2818cd084 = (0, $kSwu1.defineMessages)({
    name: {
        id: "data-classification.no-classification.content-name",
        defaultMessage: "No classification"
    },
    definition: {
        id: "data-classification.no-classification.content-definition",
        defaultMessage: "Content is not classified."
    }
});
const $e02e634ce8a36ce5$var$getDefaultMessage = (descriptor)=>typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : '';
const $e02e634ce8a36ce5$export$59df3feebe765454 = (formatMessage)=>({
        id: $e02e634ce8a36ce5$export$ea52aaec0b4536b2,
        name: formatMessage($e02e634ce8a36ce5$export$de715bd2818cd084.name),
        order: 0,
        definition: formatMessage($e02e634ce8a36ce5$export$de715bd2818cd084.definition),
        color: 'GREY',
        status: (0, $kknEZ.Status).PUBLISHED
    });
const $e02e634ce8a36ce5$export$2589b5a314728bad = $e02e634ce8a36ce5$export$59df3feebe765454($e02e634ce8a36ce5$var$getDefaultMessage);
module.exports["NO_CLASSIFICATION"] = $e02e634ce8a36ce5$export$44086dc4ad5eb01b;
module.exports["NO_CLASSIFICATION_OPTION_ID"] = $e02e634ce8a36ce5$export$ea52aaec0b4536b2;
module.exports["NO_CLASSIFICATION_OPTION"] = $e02e634ce8a36ce5$export$89b67151eed9295a;
module.exports["getNoClassificationForContent"] = $e02e634ce8a36ce5$export$59df3feebe765454;

});

parcelRegister("kknEZ", function(module, exports) {
var $ac489c3aaa697fba$export$96e9906d6d93a972 = /*#__PURE__*/ function(Status) {
    Status["PUBLISHED"] = "PUBLISHED";
    Status["ARCHIVED"] = "ARCHIVED";
    Status["DRAFT"] = "DRAFT";
    return Status;
}({});
module.exports["Status"] = $ac489c3aaa697fba$export$96e9906d6d93a972;

});

parcelRegister("in5LX", function(module, exports) {
var $4e391701f1805c48$export$4417bd7c8606be45 = /*#__PURE__*/ function(FlagStatus) {
    FlagStatus["NONE"] = "NONE";
    FlagStatus["SUCCESS"] = "SUCCESS";
    FlagStatus["ERROR"] = "ERROR";
    FlagStatus["LOADING"] = "LOADING";
    return FlagStatus;
}({});
module.exports["FlagStatus"] = $4e391701f1805c48$export$4417bd7c8606be45;

});

parcelRegister("gSfo4", function(module, exports) {

var $7tHGa = parcelRequire("7tHGa");

const $d569ee9ba15fe187$var$classificationContentStatusEnumToSingleContentSearchArrayMap = {
    [(0, $7tHGa.ContentStatus).CURRENT]: 'current',
    [(0, $7tHGa.ContentStatus).DRAFT]: 'draft',
    [(0, $7tHGa.ContentStatus).ARCHIVED]: 'archived'
};
const $d569ee9ba15fe187$var$getSingleContentStatusStringFromClassificationStatus = (status)=>{
    return $d569ee9ba15fe187$var$classificationContentStatusEnumToSingleContentSearchArrayMap[status];
};
const $d569ee9ba15fe187$export$930e5fd4dd47a5f1 = (statuses)=>{
    return statuses.map((status)=>$d569ee9ba15fe187$var$getSingleContentStatusStringFromClassificationStatus(status)).filter(Boolean);
};
module.exports["getQuerySingleContentStatusArrayVariable"] = $d569ee9ba15fe187$export$930e5fd4dd47a5f1;

});

parcelRegister("7tHGa", function(module, exports) {
var $c76572742e8d6c54$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "CURRENT";
    ContentStatus["DRAFT"] = "DRAFT";
    ContentStatus["ARCHIVED"] = "ARCHIVED";
    return ContentStatus;
}({});
module.exports["ContentStatus"] = $c76572742e8d6c54$export$b2be22e9d5dd3927;

});

parcelRegister("fcQxC", function(module, exports) {

var $7tHGa = parcelRequire("7tHGa");

const $304e5e6450715c84$export$20226314cf99189a = (context)=>{
    let readContext;
    let writeContext;
    switch(context){
        case 'draft-only':
            readContext = [
                (0, $7tHGa.ContentStatus).DRAFT
            ];
            writeContext = [
                (0, $7tHGa.ContentStatus).DRAFT
            ];
            break;
        case 'current-only':
            readContext = [
                (0, $7tHGa.ContentStatus).CURRENT,
                (0, $7tHGa.ContentStatus).ARCHIVED
            ];
            writeContext = [
                (0, $7tHGa.ContentStatus).CURRENT
            ];
            break;
        case 'current-and-draft':
            readContext = [
                (0, $7tHGa.ContentStatus).CURRENT,
                (0, $7tHGa.ContentStatus).ARCHIVED
            ];
            writeContext = [
                (0, $7tHGa.ContentStatus).CURRENT,
                (0, $7tHGa.ContentStatus).DRAFT
            ];
            break;
        default:
            readContext = [
                (0, $7tHGa.ContentStatus).CURRENT,
                (0, $7tHGa.ContentStatus).ARCHIVED
            ];
            writeContext = [
                (0, $7tHGa.ContentStatus).CURRENT
            ];
    }
    return {
        readContext: readContext,
        writeContext: writeContext
    };
};
module.exports["getReadAndWriteContextFromQueryContext"] = $304e5e6450715c84$export$20226314cf99189a;

});

parcelRegister("lwZTW", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aMcHK = parcelRequire("aMcHK");


var $7Sm4c = parcelRequire("7Sm4c");


var $79yie = parcelRequire("79yie");

const $68e08446abc76753$export$a992cfb755534ea3 = (0, $3u0dr.isReactCompilerActiveV2)() ? (currentClassification, spaceLevelError, contentLevelError)=>{
    const $ = (0, $bDgLe.c)(5);
    const [errorState, setErrorState] = (0, $cozmU.useState)((0, $79yie.ErrorState).NO_ERROR);
    let t0;
    let t1;
    if ($[0] !== contentLevelError || $[1] !== currentClassification || $[2] !== spaceLevelError) {
        t0 = ()=>{
            if (!currentClassification) {
                if (spaceLevelError || contentLevelError) {
                    if ((0, $aMcHK.isStatusCodeError)(contentLevelError, "404") || (0, $aMcHK.isStatusCodeError)(spaceLevelError, "404")) {
                        (0, $7Sm4c.markErrorAsHandled)(contentLevelError);
                        (0, $7Sm4c.markErrorAsHandled)(spaceLevelError);
                        setErrorState((0, $79yie.ErrorState).NULL);
                    } else setErrorState((0, $79yie.ErrorState).MESSAGE);
                }
            } else {
                if (spaceLevelError) (0, $7Sm4c.markErrorAsHandled)(spaceLevelError);
                setErrorState((0, $79yie.ErrorState).NO_ERROR);
            }
        };
        t1 = [
            currentClassification,
            spaceLevelError,
            contentLevelError
        ];
        $[0] = contentLevelError;
        $[1] = currentClassification;
        $[2] = spaceLevelError;
        $[3] = t0;
        $[4] = t1;
    } else {
        t0 = $[3];
        t1 = $[4];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return errorState;
} : (currentClassification, spaceLevelError, contentLevelError)=>{
    const [errorState, setErrorState] = (0, $cozmU.useState)((0, $79yie.ErrorState).NO_ERROR);
    (0, $cozmU.useEffect)(()=>{
        // If error exists, display corresponding components
        if (!currentClassification) {
            if (spaceLevelError || contentLevelError) {
                if ((0, $aMcHK.isStatusCodeError)(contentLevelError, '404') || (0, $aMcHK.isStatusCodeError)(spaceLevelError, '404')) {
                    (0, $7Sm4c.markErrorAsHandled)(contentLevelError);
                    (0, $7Sm4c.markErrorAsHandled)(spaceLevelError);
                    // If there is a handled error (404), return nothing
                    setErrorState((0, $79yie.ErrorState).NULL);
                } else // If there is an unhandled error (a non-404 error), return error message with error displays
                setErrorState((0, $79yie.ErrorState).MESSAGE);
            }
        } else {
            // If there's a content classification, we don't want to render null nor an error message for a space level error. We'll just mark the error as handled.
            if (spaceLevelError) (0, $7Sm4c.markErrorAsHandled)(spaceLevelError);
            setErrorState((0, $79yie.ErrorState).NO_ERROR);
        }
    }, [
        currentClassification,
        spaceLevelError,
        contentLevelError
    ]);
    return errorState;
};
module.exports["useClassificationErrorState"] = $68e08446abc76753$export$a992cfb755534ea3;

});

parcelRegister("79yie", function(module, exports) {
var $b3b9916290115f64$export$c1ed4f415b9e7023 = /*#__PURE__*/ function(ErrorState) {
    ErrorState["NULL"] = "NULL";
    ErrorState["MESSAGE"] = "MESSAGE";
    ErrorState["NO_ERROR"] = "NO_ERROR";
    return ErrorState;
}({});
module.exports["ErrorState"] = $b3b9916290115f64$export$c1ed4f415b9e7023;

});

parcelRegister("l2hqi", function(module, exports) {
var $d6376875f96c1896$export$2df6d049e5bad28e = /*#__PURE__*/ function(InlineCommentMode) {
    InlineCommentMode["EDIT"] = "edit";
    InlineCommentMode["VIEW"] = "view";
    InlineCommentMode["LIVE"] = "live";
    return InlineCommentMode;
}({});
module.exports["InlineCommentMode"] = $d6376875f96c1896$export$2df6d049e5bad28e;

});

parcelRegister("fMO7O", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iTJtk = parcelRequire("iTJtk");


var $9DHhW = parcelRequire("9DHhW");


var $3d3WW = parcelRequire("3d3WW");


var $7ZB0A = parcelRequire("7ZB0A");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $8Lx5S = parcelRequire("8Lx5S");


var $lyF5K = parcelRequire("lyF5K");


var $ftdAe = parcelRequire("ftdAe");


var $dUYlk = parcelRequire("dUYlk");


var $e8W3S = parcelRequire("e8W3S");


var $ebwTS = parcelRequire("ebwTS");

const $f160a6540be71b28$var$TRACK_EVENT = 'sendTrackEvent';
const $f160a6540be71b28$var$ANALYTICS_SOURCE = 'guestAttemptedMention';
const $f160a6540be71b28$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    mentionFlagTitle: {
        id: "external-collab-ui.guest-mention.restricted.flag.title",
        defaultMessage: "You can\u2019t mention people as a guest"
    },
    mentionFlagDescription: {
        id: "external-collab-ui.guest-mention.restricted.flag.description",
        defaultMessage: "To mention people, you need full access to Confluence."
    },
    learnMoreButton: {
        id: "external-collab-ui.guest-mention.learn-more-button",
        defaultMessage: "Learn more"
    },
    flagSuccessTitle: {
        id: "external-collab-ui.guest-request-to-upgrade.flag-success-title",
        defaultMessage: "Licensed user request sent!"
    },
    flagSuccessDescription: {
        id: "external-collab-ui.guest-request-to-upgrade.flag-success-description",
        defaultMessage: "If approved, you\u2019ll get a confirmation message from admin"
    },
    flagErrorTitle: {
        id: "external-collab-ui.guest-request-to-upgrade.flag-error-title",
        defaultMessage: "Request not sent"
    },
    flagErrorDescription: {
        id: "external-collab-ui.guest-request-to-upgrade.flag-error-description",
        defaultMessage: "Refresh the page to resubmit your request, or try again later."
    }
});
const $f160a6540be71b28$var$requestButtonContainerStyles = (0, $buxP3.xcss)({
    marginLeft: 'space.negative.150',
    marginTop: 'space.negative.025'
});
const $f160a6540be71b28$var$learnMoreButtonContainerStyles = (0, $buxP3.xcss)({
    marginTop: 'space.negative.025'
});
const $f160a6540be71b28$export$f9673a1f06bb6e52 = ({ children: children, dialogs: dialogs, flags: flags, suppressListener: suppressListener = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [attemptedMention, setAttemptedMention] = (0, $cozmU.useState)(false);
    const [flagNeedsUpdate, setFlagNeedsUpdate] = (0, $cozmU.useState)(false);
    const isGuest = (0, $8Lx5S.useIsGuest)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const shouldDisplayGuestUpgradeFlow = isGuest && attemptedMention;
    const handleFlagClose = (0, $cozmU.useCallback)(()=>{
        flags.hideAllFlags();
        setAttemptedMention(false);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'flag',
                actionSubjectId: 'guestMentionRequestAccess',
                source: $f160a6540be71b28$var$ANALYTICS_SOURCE,
                attributes: {
                    touchpointId: $f160a6540be71b28$var$ANALYTICS_SOURCE
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        flags
    ]);
    const showErrorFlag = (0, $cozmU.useCallback)((submissionError)=>{
        flags.showErrorFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f160a6540be71b28$export$a7357cdd1f0b0168.flagErrorTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f160a6540be71b28$export$a7357cdd1f0b0168.flagErrorDescription)
        });
        experienceTracker.fail({
            name: (0, $irVI7.SUBMIT_GUEST_MENTIONS_UPGRADE_FLOW_EXPERIENCE),
            error: submissionError
        });
    }, [
        experienceTracker,
        flags
    ]);
    const onGuestUpgradeRequestSubmitted = (0, $cozmU.useCallback)(()=>{
        handleFlagClose();
        flags.showSuccessFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f160a6540be71b28$export$a7357cdd1f0b0168.flagSuccessTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f160a6540be71b28$export$a7357cdd1f0b0168.flagSuccessDescription)
        });
        experienceTracker.succeed({
            name: (0, $irVI7.SUBMIT_GUEST_MENTIONS_UPGRADE_FLOW_EXPERIENCE)
        });
    }, [
        experienceTracker,
        flags,
        handleFlagClose
    ]);
    const handleOnSubmit = (error)=>{
        createAnalyticsEvent({
            type: $f160a6540be71b28$var$TRACK_EVENT,
            data: {
                action: !!error ? 'failed' : 'requested',
                actionSubject: 'productAccess',
                source: $f160a6540be71b28$var$ANALYTICS_SOURCE,
                attributes: {
                    touchpointId: $f160a6540be71b28$var$ANALYTICS_SOURCE
                }
            }
        }).fire();
        if (!error) onGuestUpgradeRequestSubmitted();
        else showErrorFlag(error);
    };
    const [submitGuestUpgradeRequest, { loading: guestUpgradeRequestIsLoading, isSubmitted: guestUpgradeSubmitted }] = (0, $e8W3S.useSubmitGuestUpgradeRequest)({
        onCompleted: handleOnSubmit
    });
    const { upgradeStatus: upgradeStatus, loading: permissionLoading } = (0, $lyF5K.useGuestRequestToUpgradeStatus)(!shouldDisplayGuestUpgradeFlow);
    const permissionDenied = upgradeStatus === (0, $ebwTS.UpgradeStatus).NOT_ELIGIBLE_TO_UPGRADE_AT_ALL;
    const requestPending = guestUpgradeSubmitted || upgradeStatus === (0, $ebwTS.UpgradeStatus).AN_UPGRADE_REQUEST_IS_PENDING;
    (0, $cozmU.useEffect)(()=>{
        if (permissionLoading || !shouldDisplayGuestUpgradeFlow) return;
        const submitGuestUpgradeRequestWithAnalytics = (_, analyticsEvent)=>{
            setFlagNeedsUpdate(true);
            const analyticsAttributes = {
                ...analyticsEvent.payload.attributes,
                touchpointId: $f160a6540be71b28$var$ANALYTICS_SOURCE
            };
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    ...analyticsEvent.payload,
                    actionSubjectId: 'submitGuestUpgradeRequest',
                    source: 'guestRequestAccess',
                    attributes: analyticsAttributes
                }
            }).fire();
            experienceTracker.start({
                name: (0, $irVI7.SUBMIT_GUEST_MENTIONS_UPGRADE_FLOW_EXPERIENCE)
            });
            submitGuestUpgradeRequest();
        };
        const handleOnSubmit = (error)=>{
            createAnalyticsEvent({
                type: $f160a6540be71b28$var$TRACK_EVENT,
                data: {
                    action: !!error ? 'failed' : 'requested',
                    actionSubject: 'productAccess',
                    source: $f160a6540be71b28$var$ANALYTICS_SOURCE,
                    attributes: {
                        touchpointId: $f160a6540be71b28$var$ANALYTICS_SOURCE
                    }
                }
            }).fire();
            if (!error) onGuestUpgradeRequestSubmitted();
            else showErrorFlag(error);
        };
        const openLearnMoreModal = (_, analyticsEvent)=>{
            handleFlagClose();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    ...analyticsEvent.payload,
                    actionSubjectId: 'guestUpgradeRequestLearnMore',
                    source: 'guestRequestAccess',
                    attributes: {
                        requested: requestPending
                    }
                }
            }).fire();
            dialogs.showModal((0, $dUYlk.GuestRequestToUpgradeLearnMoreDialogModal), {
                onSubmit: handleOnSubmit,
                requestPending: requestPending,
                analytics: {
                    touchpointId: $f160a6540be71b28$var$ANALYTICS_SOURCE
                }
            });
        };
        const requestUpgradeFlagId = 'guest-request-upgrade-flag';
        if (attemptedMention && flags.state.flags.length === 0) {
            flags.showCustomFlag({
                id: requestUpgradeFlagId,
                title: formatMessage($f160a6540be71b28$export$a7357cdd1f0b0168.mentionFlagTitle),
                description: formatMessage($f160a6540be71b28$export$a7357cdd1f0b0168.mentionFlagDescription),
                isAutoDismiss: false,
                onClose: handleFlagClose,
                actions: permissionDenied ? [] : [
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                            xcss: $f160a6540be71b28$var$requestButtonContainerStyles
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ftdAe.GuestRequestUpgradeButton), {
                            appearance: "link",
                            requestPending: requestPending,
                            loading: guestUpgradeRequestIsLoading,
                            onClick: submitGuestUpgradeRequestWithAnalytics
                        }))
                    },
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                            xcss: $f160a6540be71b28$var$learnMoreButtonContainerStyles
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                            appearance: "link",
                            onClick: openLearnMoreModal
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f160a6540be71b28$export$a7357cdd1f0b0168.learnMoreButton)))
                    }
                ]
            });
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'shown',
                    actionSubject: 'button',
                    actionSubjectId: 'submitGuestUpgradeRequest',
                    source: $f160a6540be71b28$var$ANALYTICS_SOURCE,
                    attributes: {
                        touchpointId: $f160a6540be71b28$var$ANALYTICS_SOURCE
                    }
                }
            }).fire();
        } else if (flagNeedsUpdate && guestUpgradeRequestIsLoading && flags.state.flags.length === 1) {
            flags.updateFlag(requestUpgradeFlagId, {
                actions: permissionDenied ? [] : [
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                            xcss: $f160a6540be71b28$var$requestButtonContainerStyles
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ftdAe.GuestRequestUpgradeButton), {
                            appearance: "link",
                            requestPending: requestPending,
                            loading: guestUpgradeRequestIsLoading,
                            onClick: submitGuestUpgradeRequestWithAnalytics
                        }))
                    },
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                            xcss: $f160a6540be71b28$var$learnMoreButtonContainerStyles
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                            appearance: "link",
                            onClick: openLearnMoreModal
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f160a6540be71b28$export$a7357cdd1f0b0168.learnMoreButton)))
                    }
                ]
            });
            setFlagNeedsUpdate(false);
        }
    }, [
        attemptedMention,
        createAnalyticsEvent,
        dialogs,
        experienceTracker,
        flags,
        flagNeedsUpdate,
        formatMessage,
        guestUpgradeRequestIsLoading,
        handleFlagClose,
        onGuestUpgradeRequestSubmitted,
        permissionDenied,
        permissionLoading,
        requestPending,
        setFlagNeedsUpdate,
        shouldDisplayGuestUpgradeFlow,
        showErrorFlag,
        submitGuestUpgradeRequest
    ]);
    const handleGuestMentionEvent = (event)=>{
        const { actionSubject: actionSubject, actionSubjectId: actionSubjectId } = event.payload;
        if (actionSubject === 'typeAhead' && actionSubjectId === 'mentionTypeAhead') setTimeout(()=>{
            setAttemptedMention(true);
        }, 5);
    };
    if (!isGuest || suppressListener) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: handleGuestMentionEvent,
        channel: (0, $iTJtk.FabricChannel).editor
    }, children);
};
module.exports["GuestMentionsNotificationsWrapper"] = $f160a6540be71b28$export$f9673a1f06bb6e52;

});

parcelRegister("lyF5K", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bQm3c = parcelRequire("bQm3c");


var $f7B1p = parcelRequire("f7B1p");


var $ebwTS = parcelRequire("ebwTS");

const $14503a2aea2a4136$export$1ee9ed72ffc111c1 = [
    // If a guest has "direct access", they will simply upgrade to a user immediately upon submitting a request without needing admin approval.
    (0, $ebwTS.CapabilityValues).DIRECT_ACCESS,
    // ... otherwise, they have the ability to request access, and wait for admin approval.
    (0, $ebwTS.CapabilityValues).REQUEST_ACCESS
];
const $14503a2aea2a4136$export$3ed095546414dc67 = [
    // The ones a Guest should never get, but technically exist on the endpoint:
    (0, $ebwTS.CapabilityValues).ACCESS_EXISTS,
    (0, $ebwTS.CapabilityValues).APPROVED_REQUEST_EXISTS,
    // The ones we expect to potentially get:
    (0, $ebwTS.CapabilityValues).DENIED_REQUEST_EXISTS,
    (0, $ebwTS.CapabilityValues).FORBIDDEN
];
const $14503a2aea2a4136$export$4e4260b083de0708 = 'product/member';
const $14503a2aea2a4136$export$d3e4104c62036f39 = (skip = false)=>{
    // if skip is true, we are not going to fetch the status, so we're not loading anything and it can be false
    // if skip is false, we are going to fetch the status and invoke API immediately, so loading can be true (same as previous implementation)
    const [loading, setLoading] = (0, $cozmU.useState)(!skip);
    const [error, setError] = (0, $cozmU.useState)();
    const [upgradeStatus, setUpgradeStatus] = (0, $cozmU.useState)(undefined);
    const [upgradeStatusReason, setUpgradeStatusReason] = (0, $cozmU.useState)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const fetchGuestUpgradeRequestStatus = (0, $cozmU.useCallback)(async ()=>{
        setLoading(true);
        const resource = `ari:cloud:confluence::site/${cloudId}`;
        const params = new URLSearchParams({
            resource: resource
        });
        return (0, $f7B1p.cfetch)(`/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        }).then((response)=>response.json()).then((data)=>{
            const statusArray = data.resultsV2[resource];
            const userCapabilityEntry = statusArray.find((entry)=>entry.role === $14503a2aea2a4136$export$4e4260b083de0708) || {};
            const status = userCapabilityEntry.accessMode;
            setUpgradeStatusReason(status);
            if ($14503a2aea2a4136$export$3ed095546414dc67.includes(status)) setUpgradeStatus((0, $ebwTS.UpgradeStatus).NOT_ELIGIBLE_TO_UPGRADE_AT_ALL);
            else if (status === (0, $ebwTS.CapabilityValues).PENDING_REQUEST_EXISTS) setUpgradeStatus((0, $ebwTS.UpgradeStatus).AN_UPGRADE_REQUEST_IS_PENDING);
            else if ($14503a2aea2a4136$export$1ee9ed72ffc111c1.includes(status)) setUpgradeStatus((0, $ebwTS.UpgradeStatus).CAN_REQUEST);
            else // We didn't get a valid value
            throw Error(`Did not receive a valid value for the accessMode status: ${status}.`);
        }).catch((caughtError)=>{
            // If anything fails, we just state you're not eligible, because we can't confirm it.
            setUpgradeStatus((0, $ebwTS.UpgradeStatus).NOT_ELIGIBLE_TO_UPGRADE_AT_ALL);
            setError(caughtError instanceof Error ? caughtError : new Error('Guest request to upgrade status load error', {
                cause: caughtError
            }));
        }).finally(()=>setLoading(false));
    }, [
        cloudId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (skip) return;
        fetchGuestUpgradeRequestStatus();
    }, [
        fetchGuestUpgradeRequestStatus,
        skip
    ]);
    return {
        upgradeStatus: upgradeStatus,
        upgradeStatusReason: upgradeStatusReason,
        loading: loading,
        error: error
    };
};
module.exports["useGuestRequestToUpgradeStatus"] = $14503a2aea2a4136$export$d3e4104c62036f39;

});

parcelRegister("ebwTS", function(module, exports) {
const $2f24b685c1e47a17$export$408edfc5a854220e = {
    ACCESS_EXISTS: 'ACCESS_EXISTS',
    DIRECT_ACCESS: 'DIRECT_ACCESS',
    APPROVED_REQUEST_EXISTS: 'APPROVED_REQUEST_EXISTS',
    DENIED_REQUEST_EXISTS: 'DENIED_REQUEST_EXISTS',
    FORBIDDEN: 'FORBIDDEN',
    PENDING_REQUEST_EXISTS: 'PENDING_REQUEST_EXISTS',
    REQUEST_ACCESS: 'REQUEST_ACCESS'
};
var $2f24b685c1e47a17$export$309264bca7eef03f = /*#__PURE__*/ function(UpgradeStatus) {
    UpgradeStatus["CAN_REQUEST"] = "CAN_REQUEST";
    UpgradeStatus["AN_UPGRADE_REQUEST_IS_PENDING"] = "AN_UPGRADE_REQUEST_IS_PENDING";
    UpgradeStatus["NOT_ELIGIBLE_TO_UPGRADE_AT_ALL"] = "NOT_ELIGIBLE_TO_UPGRADE_AT_ALL";
    return UpgradeStatus;
}({});
module.exports["CapabilityValues"] = $2f24b685c1e47a17$export$408edfc5a854220e;
module.exports["UpgradeStatus"] = $2f24b685c1e47a17$export$309264bca7eef03f;

});

parcelRegister("ftdAe", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $vIR70 = parcelRequire("vIR70");

const $141cc20ec350ae53$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    requestToUpgradeButton: {
        id: "external-collab-ui.guest-request-to-upgrade-page-tree.request-to-upgrade-button",
        defaultMessage: "Request full access"
    },
    requestToUpgradePendingButton: {
        id: "external-collab-ui.guest-request-to-upgrade-page-tree.request-to-upgrade-pending-button",
        defaultMessage: "Request pending approval"
    }
});
const $141cc20ec350ae53$export$2e85b5934aa19199 = ({ appearance: appearance, requestPending: requestPending, loading: loading, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $vIR70.default), {
        appearance: appearance,
        isDisabled: requestPending,
        isLoading: loading,
        onClick: onClick
    }, requestPending ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $141cc20ec350ae53$export$a7357cdd1f0b0168.requestToUpgradePendingButton) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $141cc20ec350ae53$export$a7357cdd1f0b0168.requestToUpgradeButton));
module.exports["GuestRequestUpgradeButton"] = $141cc20ec350ae53$export$2e85b5934aa19199;

});

parcelRegister("dUYlk", function(module, exports) {
/* GuestRequestToUpgradeLearnMoreModal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $I7hWB = parcelRequire("I7hWB");


var $eQiT1 = parcelRequire("eQiT1");


var $cDs9S = parcelRequire("cDs9S");


var $7ZB0A = parcelRequire("7ZB0A");


var $9KSWX = parcelRequire("9KSWX");


var $chu6R = parcelRequire("chu6R");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $lsxnT = parcelRequire("lsxnT");


var $fFaTu = parcelRequire("fFaTu");


var $f3BIf = parcelRequire("f3BIf");


var $ftdAe = parcelRequire("ftdAe");


var $e8W3S = parcelRequire("e8W3S");

const $6f1a718cab8b04f2$var$i18n = (0, $kSwu1.defineMessages)({
    guestRequestToUpgradeLearnMoreModalTitle: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-title",
        defaultMessage: "Request licensed user access to join your teammates"
    },
    guestRequestToUpgradeLearnMoreModalTitleSpacesMenu: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-title-spaces-menu",
        defaultMessage: "Request full access"
    },
    guestRequestToUpgradeLearnMoreModalCopy: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-copy",
        defaultMessage: "You are a guest on this Confluence site. Request licensed user access to unlock new features, and an admin will review your request."
    },
    guestRequestToUpgradeLearnMoreModalCopySpacesMenu: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-copy-spaces-menu",
        defaultMessage: "As a guest, you have limited access to this Confluence site but can request full access to unlock new ways to collaborate."
    },
    guestRequestToUpgradeLearnMoreModalGuestCardTitle: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-guest-card-title",
        defaultMessage: "Guest"
    },
    guestRequestToUpgradeLearnMoreModalGuestCardTitleLozenge: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-guest-card-title-lozenge",
        defaultMessage: "You"
    },
    guestRequestToUpgradeLearnMoreModalGuestCardCopy: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-guest-card-copy",
        defaultMessage: "Your admin may further restrict your functionality from these default settings."
    },
    guestRequestToUpgradeLearnMoreModalGuestCardCopySpacesMenu: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-guest-card-copy-spaces-menu",
        defaultMessage: "Your access is limited to:"
    },
    guestRequestToUpgradeLearnMoreModalGuestCardBenefitRowOne: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-guest-card-benefit-row-one",
        defaultMessage: "View, create, and edit in this space"
    },
    guestRequestToUpgradeLearnMoreModalGuestCardBenefitRowTwo: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-guest-card-benefit-row-two",
        defaultMessage: "Leave comments in this space"
    },
    guestRequestToUpgradeLearnMoreModalLicensedUserCardTitle: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-title",
        defaultMessage: "Licensed user"
    },
    guestRequestToUpgradeLearnMoreModalLicensedUserCardTitleSpacesMenu: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-title-spaces-menu",
        defaultMessage: "Full access"
    },
    guestRequestToUpgradeLearnMoreModalLicensedUserCardCopy: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-copy",
        defaultMessage: "Everything in guest plus,"
    },
    guestRequestToUpgradeLearnMoreModalLicensedUserCardCopySpacesMenu: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-copy-spaces-menu",
        defaultMessage: "Unlocks:"
    },
    guestRequestToUpgradeLearnMoreModalLicensedUserCardBenefitRowOne: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-benefit-row-one",
        defaultMessage: "Create your own space"
    },
    guestRequestToUpgradeLearnMoreModalLicensedUserCardBenefitRowTwo: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-benefit-row-two",
        defaultMessage: "View and collaborate in other spaces"
    },
    guestRequestToUpgradeLearnMoreModalLicensedUserCardBenefitRowThree: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-benefit-row-three",
        defaultMessage: "See other people\u2019s profiles"
    },
    guestRequestToUpgradeLearnMoreModalLicensedUserCardBenefitRowFour: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-benefit-row-four",
        defaultMessage: "Mention other people"
    },
    guestRequestToUpgradeLearnMoreModalLicensedUserCardBenefitRowFive: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-licensed-user-card-benefit-row-five",
        defaultMessage: "Create and join teams"
    },
    guestRequestToUpgradeLearnMoreModalFooterSecondaryButton: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-footer-secondary-button",
        defaultMessage: "Maybe later"
    },
    guestRequestToUpgradeLearnMoreModalFooterSecondaryButtonWhenPrimaryDisabled: {
        id: "external-collab-ui.guest-request-to-upgrade-learn-more-modal-footer-secondary-button-when-primary-disabled",
        defaultMessage: "Close"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f1a718cab8b04f2$var$ModalHeader = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt41ejb _1bsb1osq _vchhusvi _y3gn1h6o _ca0qxy5q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f1a718cab8b04f2$var$ModalBody = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_y3gn1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f1a718cab8b04f2$var$ModalCopy = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_18s8kzvm _1yt45gjp _p12f1lk4 _vchhusvi _y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $6f1a718cab8b04f2$var$ValuePropCardContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_zulp1ejb _1yt45gjp _1e0c1txw _1n261q9c _otyrv77o _dl4n1g80",
            __cmplp.className
        ])
    });
});
const $6f1a718cab8b04f2$var$ValuePropCard = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_19itno8c _2rkog72m _16jlkb7n _1o9zkb7n _i0dl5x59 _vchhusvi _1e0c1txw _2lx21bp4 _1n261g80 _4cvr1y6m _1tke7ivc _16qst7xp",
            __cmplp.className
        ])
    });
});
const $6f1a718cab8b04f2$var$CardTitleImage = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_18s8glhf _1bsb1osq _4t3ixncg",
            __cmplp.className
        ])
    });
});
const $6f1a718cab8b04f2$var$CardHeader = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "h1", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11c81af2 _zulpu2gc _1yt41big _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1osq _vchhusvi _y3gn1h6o _19pkidpf",
            __cmplp.className
        ])
    });
});
const $6f1a718cab8b04f2$var$CardContent = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt45gjp _y3gn1e5h",
            __cmplp.className
        ])
    });
});
const $6f1a718cab8b04f2$var$CardCopy = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_otyrv47k _vchhusvi _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $6f1a718cab8b04f2$var$BenefitRowContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o _1bah1y6m _otyru2gc",
            __cmplp.className
        ])
    });
});
const $6f1a718cab8b04f2$var$GUEST_BENEFITS = [
    {
        message: $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardBenefitRowOne
    },
    {
        message: $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardBenefitRowTwo
    }
];
const $6f1a718cab8b04f2$var$USER_BENEFITS = [
    {
        message: $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardBenefitRowOne,
        highlighted: true
    },
    {
        message: $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardBenefitRowTwo,
        highlighted: true
    },
    {
        message: $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardBenefitRowThree,
        highlighted: true
    },
    {
        message: $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardBenefitRowFour,
        highlighted: true
    },
    {
        message: $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardBenefitRowFive,
        highlighted: true
    }
];
const $6f1a718cab8b04f2$var$BenefitRow = ({ highlighted: highlighted = false, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$BenefitRowContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
        color: highlighted ? "var(--ds-icon-success, #6A9A23)" : "var(--ds-icon-accent-gray, #7D818A)",
        spacing: "none",
        label: ""
    }), children);
};
const $6f1a718cab8b04f2$var$determineCloseTrigger = (event, analyticsEvent)=>{
    return analyticsEvent.payload.actionSubject === 'button' ? 'closeButton' : analyticsEvent.payload.actionSubject === 'modalDialog' ? event instanceof KeyboardEvent && event.key === 'Escape' ? 'escapeKey' : 'outsideClick' : 'unknown';
};
const $6f1a718cab8b04f2$export$adda263aa585eebf = ({ onSubmit: onSubmit, requestPending: requestPending, closeModal: closeModal, analytics: analytics })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const headerRef = (0, $cozmU.useRef)(null);
    const [submitGuestUpgradeRequest, { loading: loading }] = (0, $e8W3S.useSubmitGuestUpgradeRequest)({
        onCompleted: onSubmit
    });
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'guestRequestAccessValuePropModal',
                attributes: {
                    touchpointId: analytics?.touchpointId
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        analytics
    ]);
    const scrollToTop = ()=>headerRef.current?.scrollIntoView({
            behavior: 'smooth'
        });
    const submitGuestUpgradeRequestWithAnalytics = async (_, analyticsEvent)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                ...analyticsEvent.payload,
                actionSubjectId: 'submitGuestUpgradeRequest',
                source: 'guestRequestAccessValuePropModal',
                attributes: {
                    touchpointId: analytics?.touchpointId
                }
            }
        }).fire();
        experienceTracker.start({
            name: (0, $irVI7.SUBMIT_GUEST_REQUEST_TO_UPGRADE_EXPERIENCE)
        });
        await submitGuestUpgradeRequest();
        closeModal();
    };
    const closeModalWithAnalytics = (event, analyticsEvent)=>{
        closeModal();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'closed',
                actionSubject: 'modalDialog',
                actionSubjectId: 'guestRequestAccessValuePropModal',
                source: 'guestRequestAccessValuePropModal',
                attributes: {
                    requested: requestPending,
                    closeTrigger: $6f1a718cab8b04f2$var$determineCloseTrigger(event, analyticsEvent),
                    touchpointId: analytics?.touchpointId
                }
            }
        }).fire();
    };
    const secondaryButtonCopy = requestPending ? $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalFooterSecondaryButtonWhenPrimaryDisabled : $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalFooterSecondaryButton;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
        width: 752,
        onClose: closeModalWithAnalytics,
        onOpenComplete: scrollToTop,
        shouldScrollInViewport: true,
        shouldCloseOnEscapePress: true,
        shouldCloseOnOverlayClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$ModalHeader, {
        ref: headerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "large",
        as: "h1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cDs9S.CloseButton), {
        onClick: closeModalWithAnalytics
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$ModalBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$ModalCopy, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalCopy)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$ValuePropCardContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$ValuePropCard, {
        className: "first"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$CardTitleImage, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fFaTu)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$CardHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardTitleLozenge))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$CardContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$CardCopy, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardCopy)), $6f1a718cab8b04f2$var$GUEST_BENEFITS.map((benefit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$BenefitRow, {
            key: benefit.message.id,
            highlighted: benefit.highlighted
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), benefit.message))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$ValuePropCard, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$CardTitleImage, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($f3BIf)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$CardHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$CardContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$CardCopy, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardCopy)), $6f1a718cab8b04f2$var$USER_BENEFITS.map((benefit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$BenefitRow, {
            key: benefit.message.id,
            highlighted: benefit.highlighted
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), benefit.message))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        onClick: closeModalWithAnalytics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), secondaryButtonCopy)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ftdAe.GuestRequestUpgradeButton), {
        appearance: "primary",
        requestPending: requestPending,
        loading: loading,
        onClick: submitGuestUpgradeRequestWithAnalytics
    })));
};
const $6f1a718cab8b04f2$export$c9be8187bfbfd769 = ({ onClose: onClose, onCloseComplete: onCloseComplete, onSubmit: onSubmit, requestPending: requestPending, analytics: analytics, isSpacesMenu: isSpacesMenu = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const headerRef = (0, $cozmU.useRef)(null);
    const [submitGuestUpgradeRequest, { loading: loading }] = (0, $e8W3S.useSubmitGuestUpgradeRequest)({
        onCompleted: onSubmit
    });
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'guestRequestAccessValuePropModal',
                attributes: {
                    touchpointId: analytics?.touchpointId
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        analytics
    ]);
    const scrollToTop = ()=>headerRef.current?.scrollIntoView({
            behavior: 'smooth'
        });
    const submitGuestUpgradeRequestWithAnalytics = async (_, analyticsEvent)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                ...analyticsEvent.payload,
                actionSubjectId: 'submitGuestUpgradeRequest',
                source: 'guestRequestAccessValuePropModal',
                attributes: {
                    touchpointId: analytics?.touchpointId
                }
            }
        }).fire();
        experienceTracker.start({
            name: (0, $irVI7.SUBMIT_GUEST_REQUEST_TO_UPGRADE_EXPERIENCE)
        });
        await submitGuestUpgradeRequest();
        onClose();
    };
    const closeModalWithAnalytics = (event, analyticsEvent)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'closed',
                actionSubject: 'modalDialog',
                actionSubjectId: 'guestRequestAccessValuePropModal',
                source: 'guestRequestAccessValuePropModal',
                attributes: {
                    requested: requestPending,
                    closeTrigger: $6f1a718cab8b04f2$var$determineCloseTrigger(event, analyticsEvent),
                    touchpointId: analytics?.touchpointId
                }
            }
        }).fire();
        onClose();
    };
    const secondaryButtonCopy = requestPending ? $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalFooterSecondaryButtonWhenPrimaryDisabled : $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalFooterSecondaryButton;
    return isSpacesMenu ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
        width: 752,
        onClose: closeModalWithAnalytics,
        onCloseComplete: onCloseComplete,
        onOpenComplete: scrollToTop,
        shouldScrollInViewport: true,
        shouldCloseOnEscapePress: true,
        shouldCloseOnOverlayClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$ModalHeader, {
        ref: headerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "large",
        as: "h1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalTitleSpacesMenu), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cDs9S.CloseButton), {
        onClick: closeModalWithAnalytics
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$ModalBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$ModalCopy, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalCopySpacesMenu)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$ValuePropCardContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$ValuePropCard, {
        className: "first"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$CardTitleImage, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fFaTu)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$CardHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardTitleLozenge))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$CardContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$CardCopy, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardCopySpacesMenu)), $6f1a718cab8b04f2$var$GUEST_BENEFITS.map((benefit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$BenefitRow, {
            key: benefit.message.id,
            highlighted: benefit.highlighted
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), benefit.message))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$ValuePropCard, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$CardTitleImage, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($f3BIf)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$CardHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardTitleSpacesMenu)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$CardContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$CardCopy, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardCopySpacesMenu)), $6f1a718cab8b04f2$var$USER_BENEFITS.map((benefit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$BenefitRow, {
            key: benefit.message.id,
            highlighted: benefit.highlighted
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), benefit.message))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        onClick: closeModalWithAnalytics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), secondaryButtonCopy)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ftdAe.GuestRequestUpgradeButton), {
        appearance: "primary",
        requestPending: requestPending,
        loading: loading,
        onClick: submitGuestUpgradeRequestWithAnalytics
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
        width: 752,
        onClose: closeModalWithAnalytics,
        onCloseComplete: onCloseComplete,
        onOpenComplete: scrollToTop,
        shouldScrollInViewport: true,
        shouldCloseOnEscapePress: true,
        shouldCloseOnOverlayClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$ModalHeader, {
        ref: headerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "large",
        as: "h1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cDs9S.CloseButton), {
        onClick: closeModalWithAnalytics
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$ModalBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$ModalCopy, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalCopy)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$ValuePropCardContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$ValuePropCard, {
        className: "first"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$CardTitleImage, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fFaTu)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$CardHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardTitle), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardTitleLozenge))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$CardContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$CardCopy, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalGuestCardCopy)), $6f1a718cab8b04f2$var$GUEST_BENEFITS.map((benefit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$BenefitRow, {
            key: benefit.message.id,
            highlighted: benefit.highlighted
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), benefit.message))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$ValuePropCard, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$CardTitleImage, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($f3BIf)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$CardHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$CardContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$CardCopy, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6f1a718cab8b04f2$var$i18n.guestRequestToUpgradeLearnMoreModalLicensedUserCardCopy)), $6f1a718cab8b04f2$var$USER_BENEFITS.map((benefit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$var$BenefitRow, {
            key: benefit.message.id,
            highlighted: benefit.highlighted
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), benefit.message))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        onClick: closeModalWithAnalytics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), secondaryButtonCopy)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ftdAe.GuestRequestUpgradeButton), {
        appearance: "primary",
        requestPending: requestPending,
        loading: loading,
        onClick: submitGuestUpgradeRequestWithAnalytics
    })));
};
const $6f1a718cab8b04f2$export$aa10072a5720d721 = (args)=>(closeModal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6f1a718cab8b04f2$export$adda263aa585eebf, {
            ...args,
            closeModal: closeModal
        });
module.exports["GuestRequestToUpgradeLearnMoreModal"] = $6f1a718cab8b04f2$export$adda263aa585eebf;
module.exports["GuestRequestToUpgradeLearnMoreDialogModal"] = $6f1a718cab8b04f2$export$c9be8187bfbfd769;
module.exports["GuestRequestToUpgradeLearnMoreModalFactory"] = $6f1a718cab8b04f2$export$aa10072a5720d721;

});

parcelRegister("fFaTu", function(module, exports) {
module.exports = new URL("Guest-Avatar.ebdf69f1.svg", import.meta.url).toString();

});

parcelRegister("f3BIf", function(module, exports) {
module.exports = new URL("Team-Avatars.4f1b07ad.svg", import.meta.url).toString();

});

parcelRegister("e8W3S", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $bQm3c = parcelRequire("bQm3c");


var $hBkCm = parcelRequire("hBkCm");

var $f7B1p = parcelRequire("f7B1p");


var $eh0mb = parcelRequire("eh0mb");

const $b1ebfcc93144065b$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    upgradeRequestNote: {
        id: "external-collab-ui.guest-request-to-upgrade.upgrade-request-note",
        defaultMessage: "This guest requested a Confluence license"
    }
});
const $b1ebfcc93144065b$export$4f101f8b41ecae81 = (cloudId, upgradeRequestNote)=>JSON.stringify({
        resource: `ari:cloud:confluence::site/${cloudId}`,
        note: upgradeRequestNote
    });
const $b1ebfcc93144065b$export$1fcc21aa81264365 = '/gateway/api/invitations/v1/access-requests/request';
const $b1ebfcc93144065b$export$dce8274ecfbb9f9e = ({ onCompleted: onCompleted })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [{ requestAccessState: requestAccessState }, { setRequestAccessState: setRequestAccessState }] = (0, $eh0mb.useGuestRequestUpgradeStore)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const submitGuestUpgradeRequest = (0, $cozmU.useCallback)(async ()=>{
        setRequestAccessState('loading');
        return (0, $f7B1p.cfetch)($b1ebfcc93144065b$export$1fcc21aa81264365, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: $b1ebfcc93144065b$export$4f101f8b41ecae81(cloudId, intl.formatMessage($b1ebfcc93144065b$export$a7357cdd1f0b0168.upgradeRequestNote))
        }).then((response)=>{
            if (response.ok && response.status === 200) {
                setRequestAccessState('submitted');
                onCompleted();
            } else {
                setRequestAccessState(undefined);
                throw new (0, $hBkCm.BadStatusError)(`${response.status}: ${response.statusText}`, response);
            }
        }).catch((caughtError)=>{
            setRequestAccessState(undefined);
            onCompleted(caughtError instanceof Error ? caughtError : new Error('Unknown error occurred during submission'));
        });
    }, [
        cloudId,
        intl,
        onCompleted,
        setRequestAccessState
    ]);
    return [
        submitGuestUpgradeRequest,
        {
            loading: requestAccessState === 'loading',
            isSubmitted: requestAccessState === 'submitted'
        }
    ];
};
module.exports["useSubmitGuestUpgradeRequest"] = $b1ebfcc93144065b$export$dce8274ecfbb9f9e;

});

parcelRegister("eh0mb", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $4708f874261747c2$var$Store = (0, $8s9DV.createStore)({
    initialState: {
        requestAccessState: undefined
    },
    actions: {
        setRequestAccessState: (value)=>({ setState: setState })=>{
                setState({
                    requestAccessState: value
                });
            }
    },
    name: 'guestRequestUpgradeStore'
});
const $4708f874261747c2$export$b72090e4288882db = (0, $kBr4q.createHook)($4708f874261747c2$var$Store);
module.exports["useGuestRequestUpgradeStore"] = $4708f874261747c2$export$b72090e4288882db;

});

parcelRegister("k31VO", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4f7d3262c48387ee$export$c0bc8bbccc993b75 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "tsrw0",
    name: "PublishModalKeyboardShortcuts",
    loader: async ()=>{
        return (await (parcelRequire("9SUYW"))).PublishModalKeyboardShortcuts;
    }
});
module.exports["PublishModalKeyboardShortcuts"] = $4f7d3262c48387ee$export$c0bc8bbccc993b75;

});

parcelRegister("9SUYW", function(module, exports) {

let $73255b9d9f7cfe4e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $73255b9d9f7cfe4e$var$load("gLFJS"),
    $73255b9d9f7cfe4e$var$load("92b7d"),
    $73255b9d9f7cfe4e$var$load("3kVph"),
    $73255b9d9f7cfe4e$var$load("ayJxT"),
    $73255b9d9f7cfe4e$var$load("hhss7"),
    $73255b9d9f7cfe4e$var$load("kXcA7")
]).then(()=>parcelRequire('bAPy4'));

});

parcelRegister("eu3xH", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $73d7c23c9a6a572e$export$b112826b6cf719c1 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "XmBDy",
    name: "PublishModalMountPoint",
    loader: async ()=>{
        return (await (parcelRequire("cosrw"))).PublishModalMountPoint;
    }
});
module.exports["PublishModalMountPoint"] = $73d7c23c9a6a572e$export$b112826b6cf719c1;

});

parcelRegister("cosrw", function(module, exports) {

let $905dca17689f249b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $905dca17689f249b$var$load("kFiBp"),
    $905dca17689f249b$var$load("gLFJS"),
    $905dca17689f249b$var$load("35X59"),
    $905dca17689f249b$var$load("92b7d"),
    $905dca17689f249b$var$load("2F69B"),
    $905dca17689f249b$var$load("j8Ant"),
    $905dca17689f249b$var$load("idSqX"),
    $905dca17689f249b$var$load("el56J"),
    $905dca17689f249b$var$load("guVy6"),
    $905dca17689f249b$var$load("ayJxT"),
    $905dca17689f249b$var$load("hhss7"),
    $905dca17689f249b$var$load("h2HOI")
]).then(()=>parcelRequire('2hWDW'));

});

parcelRegister("1N2OF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1ggpj = parcelRequire("1ggpj");


var $5ZqQS = parcelRequire("5ZqQS");


var $7Sm4c = parcelRequire("7Sm4c");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $6fil2 = parcelRequire("6fil2");


var $3jwuS = parcelRequire("3jwuS");


var $7mpOv = parcelRequire("7mpOv");


var $c0rhi = parcelRequire("c0rhi");


var $f5bZm = parcelRequire("f5bZm");


var $h7eE1 = parcelRequire("h7eE1");


var $jVFPV = parcelRequire("jVFPV");


var $6mKj3 = parcelRequire("6mKj3");

const $f6c5568d6d5a516f$export$3d87df4b3544fccb = ({ contentId: contentId, contentType: contentType, isUnpublishedDraft: isUnpublishedDraft, flags: flags, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, onBeforeValidation: onBeforeValidation, onValidationSuccess: onValidationSuccess, analyticsSource: analyticsSource, optimisticTitle: optimisticTitle, checkIfConditionPreventingPublish: checkIfConditionPreventingPublish })=>{
    const intl = (0, $kSwu1.useIntl)();
    // Changes to EditorTitle are debounced if the page is a draft, which we need to account for
    const titleDebounceTime = isUnpublishedDraft ? (0, $1ggpj.onChangeTitleDebounceTime) : 0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f5bZm.usePublishModalAnalyticsEvent)();
    const { isAIEnabledForContent: isAIEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // Since the validatePageAndOpenModal function may be running after this component has unmounted,
    // we have to query the apolloClient directly rather than using useQuery's refetch function.
    const validatePageAndOpenModal = (0, $cozmU.useCallback)((actionSubjectId)=>{
        const validatePage = async ()=>{
            if (checkIfConditionPreventingPublish && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) {
                if (await checkIfConditionPreventingPublish()) return;
            }
            // Live Pages only save changes to the `realTitle` when it is valid,
            // so we need to use the `optimisticTitle` here to get what the user
            // has actually typed into the title field, and then show the correct flag.
            const { title: realTitle } = await retrieveEditorTitleAndContent();
            // ?? must be used here to explicitly check null and undefined because we want to use optmisticTitle if it is an empty string, which is also falsey.
            const title = optimisticTitle ?? realTitle;
            try {
                const { data: data } = await (0, $c0rhi.queryInterop)({
                    query: (0, $h7eE1.ValidatePagePublishQuery),
                    errorPolicy: 'all',
                    fetchPolicy: 'network-only',
                    variables: {
                        contentId: contentId ?? '',
                        type: contentType,
                        title: title
                    },
                    __callerPackage__: "publish-modal"
                });
                // This is the same logic used to calculate `isTitleEmpty` in EditorPrimaryToolbarComponents.
                const isTitleEmpty = !title;
                if (!data.validatePagePublish?.isValid) await (0, $jVFPV.displayPublishErrorFlag)({
                    validationMessage: data.validatePagePublish?.message ?? '',
                    isTitleEmpty: isTitleEmpty,
                    flags: flags,
                    formatMessage: intl.formatMessage,
                    publish: validatePageAndOpenModal('PublishButtonInFlag'),
                    isAIEnabledForContent: isAIEnabledForContent,
                    isLivePage: isLivePage
                });
                else onValidationSuccess();
            } catch (error) {
                if (error) {
                    (0, $7Sm4c.markErrorAsHandled)(error);
                    if (!(0, $6fil2.containsNetworkError)(error) && !(0, $1uFM6.isUnauthorizedError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                        attribution: (0, $3IBnw.Attribution).PAGE_MODES
                    });
                }
            }
        };
        return async ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    actionSubject: 'button',
                    action: 'clicked',
                    actionSubjectId: actionSubjectId,
                    source: analyticsSource,
                    attributes: {
                        isUnpublishedDraft: isUnpublishedDraft
                    }
                }
            }).fire();
            setTimeout(async ()=>{
                onBeforeValidation();
                await validatePage();
            }, titleDebounceTime);
        };
    }, [
        contentId,
        contentType,
        retrieveEditorTitleAndContent,
        createAnalyticsEvent,
        flags,
        intl.formatMessage,
        titleDebounceTime,
        isUnpublishedDraft,
        analyticsSource,
        onBeforeValidation,
        onValidationSuccess,
        optimisticTitle,
        isAIEnabledForContent,
        isLivePage,
        checkIfConditionPreventingPublish
    ]);
    return validatePageAndOpenModal;
};
module.exports["usePrePublishTitleValidation"] = $f6c5568d6d5a516f$export$3d87df4b3544fccb;

});

parcelRegister("f5bZm", function(module, exports) {

var $hw7IX = parcelRequire("hw7IX");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $ep3mz = parcelRequire("ep3mz");


var $jMyy4 = parcelRequire("jMyy4");

const $d6a7ecdd01e28d6c$export$cd6c3e8c6818dcba = ()=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { createAnalyticsEvent: akCreateAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    /**
   * cache-only since it is utilizing the same query that the PublishButtonWithMoreOptions component
   * is using, so the data should already be available within the cache which is why there is no
   * error or loading checks as well.
   */ const { data: data } = (0, $jMyy4.useQueryInterop)((0, $hw7IX.default), {
        errorPolicy: 'all',
        fetchPolicy: 'cache-only',
        variables: {
            contentId: contentId
        },
        __callerPackage__: "publish-modal"
    });
    // Setup the rest of the necessary info for our analytics events that came from the query
    const analyticEventData = (0, $cozmU.useMemo)(()=>{
        return {
            objectId: contentId,
            objectType: data?.singleContent?.type ?? undefined,
            containerId: data?.singleContent?.space?.id ?? undefined
        };
    }, [
        data,
        contentId
    ]);
    const createAnalyticsEvent = (0, $cozmU.useCallback)((payload)=>{
        payload.data.objectType = analyticEventData.objectType;
        payload.data.objectId = analyticEventData.objectId;
        payload.data.containerType = 'space';
        payload.data.containerId = analyticEventData.containerId;
        return akCreateAnalyticsEvent(payload);
    }, [
        analyticEventData,
        akCreateAnalyticsEvent
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
};
module.exports["usePublishModalAnalyticsEvent"] = $d6a7ecdd01e28d6c$export$cd6c3e8c6818dcba;

});

parcelRegister("hw7IX", function(module, exports) {
/**
 * @generated SignedSource<<5caf907caa9dc9f636c2239a5d0706d5>>
 * @relayHash 5f6af3c9067662d2f2453cffe85e870d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5c7db24370db37ea3951c3b608b8a64c7b9652a4a0d6bdc9baf6eff8305f61db
const $40611a622a6050f5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "alias": "user",
            "concreteType": "ConfluencePersonConnection",
            "kind": "LinkedField",
            "name": "personConnection",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluencePersonEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "ConfluencePerson",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "email"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "permissionType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "displayName"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "accountId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "publicName"
                                },
                                {
                                    "concreteType": "Icon",
                                    "kind": "LinkedField",
                                    "name": "profilePicture",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "path"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "PaginatedGroupList",
            "kind": "LinkedField",
            "name": "group",
            "plural": false,
            "selections": [
                {
                    "concreteType": "GroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "Group",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "SchedulePublishInfo",
                    "kind": "LinkedField",
                    "name": "schedulePublishInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "date"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "versionComment"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "minorEdit"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        },
                        {
                            "concreteType": "TargetLocation",
                            "kind": "LinkedField",
                            "name": "targetLocation",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "parentId"
                                },
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "destinationSpace",
                                    "plural": false,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "alias"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "ScheduledRestrictions",
                            "kind": "LinkedField",
                            "name": "restrictions",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ScheduledRestriction",
                                    "kind": "LinkedField",
                                    "name": "update",
                                    "plural": false,
                                    "selections": v2 /*: any*/ 
                                },
                                {
                                    "concreteType": "ScheduledRestriction",
                                    "kind": "LinkedField",
                                    "name": "read",
                                    "plural": false,
                                    "selections": v2 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePublishModalAnalyticsEventPublishModalWithMoreOptionsQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePublishModalAnalyticsEventPublishModalWithMoreOptionsQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "5f6af3c9067662d2f2453cffe85e870d",
            "id": "5c7db24370db37ea3951c3b608b8a64c7b9652a4a0d6bdc9baf6eff8305f61db",
            "metadata": {},
            "name": "usePublishModalAnalyticsEventPublishModalWithMoreOptionsQuery",
            "operationKind": "query",
            "text": "query usePublishModalAnalyticsEventPublishModalWithMoreOptionsQuery($contentId:ID){singleContent(id:$contentId){id,type,space{id},schedulePublishInfo{date,versionComment,minorEdit,targetType,targetLocation{parentId,destinationSpace{id,key,alias}},restrictions{update{user:personConnection{edges{node{email,permissionType,displayName,accountId,publicName,profilePicture{path}}}},group{edges{node{name,id}}}},read{user:personConnection{edges{node{email,permissionType,displayName,accountId,publicName,profilePicture{path}}}},group{edges{node{name,id}}}}}}}}"
        }
    };
}();
$40611a622a6050f5$var$node.hash = "a8a0b6dda1e0a34e0ddf825a8ab4995a";
var $40611a622a6050f5$export$2e2bcd8739ae039 = $40611a622a6050f5$var$node;
module.exports["default"] = $40611a622a6050f5$export$2e2bcd8739ae039;

});

parcelRegister("h7eE1", function(module, exports) {

var $lWcGs = parcelRequire("lWcGs");

const $a57349b93ecbf15f$export$6d6976f1200f02ec = (0, $lWcGs.default);
module.exports["ValidatePagePublishQuery"] = $a57349b93ecbf15f$export$6d6976f1200f02ec;

});

parcelRegister("lWcGs", function(module, exports) {
/**
 * @generated SignedSource<<5be4d54fd79cfe5aaf77af974d9c0ce6>>
 * @relayHash 24fbb3cff8b05eaa1a5b7d5ae6a6a9c0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID be7633349102d5fe3dc7b73aba34d9c84ef0d7f5adad7bf0d7625ccddc1f8646
const $462ba838f57fbdac$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "title"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "type"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": "draft"
                },
                {
                    "kind": "Variable",
                    "name": "title",
                    "variableName": "title"
                },
                {
                    "kind": "Variable",
                    "name": "type",
                    "variableName": "type"
                }
            ],
            "concreteType": "PageValidationResult",
            "kind": "LinkedField",
            "name": "validatePagePublish",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isValid"
                },
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ValidatePagePublishQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ValidatePagePublishQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "24fbb3cff8b05eaa1a5b7d5ae6a6a9c0",
            "id": "be7633349102d5fe3dc7b73aba34d9c84ef0d7f5adad7bf0d7625ccddc1f8646",
            "metadata": {},
            "name": "ValidatePagePublishQuery",
            "operationKind": "query",
            "text": "query ValidatePagePublishQuery($contentId:ID!,$type:String,$title:String){validatePagePublish(id:$contentId,status:\"draft\",type:$type,title:$title){isValid,message}}"
        }
    };
}();
$462ba838f57fbdac$var$node.hash = "8954a1a5f4b5c46209e8bdbdcef7f2f7";
var $462ba838f57fbdac$export$2e2bcd8739ae039 = $462ba838f57fbdac$var$node;
module.exports["default"] = $462ba838f57fbdac$export$2e2bcd8739ae039;

});

parcelRegister("jVFPV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $esV19 = parcelRequire("esV19");


var $k5sGX = parcelRequire("k5sGX");


var $hP2NR = parcelRequire("hP2NR");


var $kSwu1 = parcelRequire("kSwu1");


var $bltJZ = parcelRequire("bltJZ");


var $iMnC5 = parcelRequire("iMnC5");


var $cHfGW = parcelRequire("cHfGW");


var $1mHQU = parcelRequire("1mHQU");


var $8mrqR = parcelRequire("8mrqR");


var $6mKj3 = parcelRequire("6mKj3");


var $c6abH = parcelRequire("c6abH");

function $431bc41fbb9babca$export$2d18ca8a66126a1d() {
    const hasWindow = typeof window !== 'undefined';
    const width = hasWindow ? window.innerWidth : null;
    const height = hasWindow ? window.innerHeight : null;
    return {
        width: width,
        height: height
    };
}
const $431bc41fbb9babca$var$ALL_TIMES_ARRAY = Array(48).fill(0).map((_, i)=>`${Math.floor(i / 2).toString().padStart(2, '0')}:${i % 2 ? '30' : '00'}`);
const $431bc41fbb9babca$var$i18n = (0, $kSwu1.defineMessages)({
    acceptTitle: {
        id: "publish-modal.flag.accept",
        defaultMessage: "Accept"
    }
});
const $431bc41fbb9babca$export$b182675d91dd4643 = (scheduledDate)=>{
    const currTime = new Date();
    const baseTime = (0, $hP2NR.default)(currTime, 5);
    // Return empty array when it is already 5 minutes until tomorrow
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    if (baseTime.toDateString() === tomorrow.toDateString()) return [];
    // Return array of valid time selections
    if (!!scheduledDate && (0, $k5sGX.default)(scheduledDate).toDateString() === baseTime.toDateString()) {
        // User selected same day, only return time in the future
        const baseHour = baseTime.getHours();
        const nextHour = baseHour + 1;
        // Time array
        const timesArray = Array(48 - nextHour * 2).fill(0).map((_, i)=>`${Math.floor((i + nextHour * 2) / 2).toString().padStart(2, '0')}:${i % 2 ? '30' : '00'}`);
        if (baseTime.getMinutes() < 30) // If current time is in first half of the hour, add {currentHour:30} to the time array
        timesArray.unshift(`${baseHour.toString().padStart(2, '0')}:30`);
        return timesArray;
    } else // User selected future day, return all times array
    return $431bc41fbb9babca$var$ALL_TIMES_ARRAY;
};
const $431bc41fbb9babca$export$6195456a656da885 = (date, time)=>{
    return date && time && (0, $esV19.default)(date) && (0, $esV19.default)(time) ? new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes(), time.getSeconds()) : undefined;
};
const $431bc41fbb9babca$export$9295f91b059cbee5 = ({ contentId: contentId, schedulePublishDate: schedulePublishDate, fragmentWriterInterop: fragmentWriterInterop })=>{
    try {
        fragmentWriterInterop({
            fragmentId: `Content:${contentId}`,
            data: {
                schedulePublishInfo: {
                    __typename: 'SchedulePublishInfo',
                    date: schedulePublishDate,
                    minorEdit: false,
                    targetType: 'page',
                    versionComment: ''
                },
                __typename: 'Content'
            }
        });
    } catch  {}
};
const $431bc41fbb9babca$export$19a3e0c18ebaf6e6 = async ({ validationMessage: validationMessage, isTitleEmpty: isTitleEmpty, flags: flags, formatMessage: formatMessage, publish: publish, isAIEnabledForContent: isAIEnabledForContent, isLivePage: isLivePage })=>{
    let flagErrorId;
    // Will show a generic error flag if these three conditions not met
    // The validation query results do not differentiate b/w blank and whitespace title so we use isTitleEmpty to do so on the frontend side
    if (isTitleEmpty && validationMessage === (0, $c6abH.PublishErrorFlagKeys).TITLE_IS_BLANK && isAIEnabledForContent && !isLivePage && (0, $6mKj3.expValEquals)('confluence_ai_title_generation', 'cohort', 'test')) flagErrorId = (0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE;
    else if (isTitleEmpty && validationMessage === (0, $c6abH.PublishErrorFlagKeys).TITLE_IS_BLANK) flagErrorId = (0, $1mHQU.ALLOWED_FLAG_MESSAGES).TITLE_REQUIRED;
    else if (validationMessage === (0, $c6abH.PublishErrorFlagKeys).TITLE_IS_BLANK) flagErrorId = (0, $1mHQU.ALLOWED_FLAG_MESSAGES).INVALID_PAGE_TITLE;
    else if (validationMessage === (0, $c6abH.PublishErrorFlagKeys).DUPLICATE_TITLE) flagErrorId = (0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE;
    const flagMessage = (0, $cHfGW.buildEditorFlagMessage)({
        errorData: {
            [flagErrorId]: true
        },
        formatMessage: formatMessage
    });
    if (flagErrorId === (0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE) {
        await flags.hideFlag('ai-generated-title-flag');
        await flags.showCustomFlag({
            id: 'ai-generated-title-flag',
            title: flagMessage?.title,
            description: flagMessage?.description,
            customIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                paddingBlockStart: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.RovoIcon), {
                label: "",
                size: "xsmall"
            })),
            actions: [
                {
                    content: formatMessage($431bc41fbb9babca$var$i18n.acceptTitle),
                    onClick: publish
                }
            ]
        });
    } else await flags.showErrorFlag({
        title: flagMessage?.title,
        description: flagMessage?.description
    });
};
const $431bc41fbb9babca$export$13107e6716590163 = (gqlRestrictionsInput)=>{
    if (!gqlRestrictionsInput) return undefined;
    return gqlRestrictionsInput;
};
const $431bc41fbb9babca$export$7521340df7373a8f = (scheduledRestrictions)=>{
    const readRestriction = scheduledRestrictions?.read;
    const updateRestriction = scheduledRestrictions?.update;
    const usersWithReadRestriction = readRestriction?.user?.edges ?? [];
    const groupsWithReadRestriction = readRestriction?.group?.edges ?? [];
    const usersWithUpdateRestriction = updateRestriction?.user?.edges ?? [];
    const groupsWithUpdateRestriction = updateRestriction?.group?.edges ?? [];
    const processUserEdgesArray = (userEdgesArray)=>userEdgesArray.map((element)=>(0, $8mrqR.transformUserToREST)({
                ...element.node,
                hasSpaceEditPermission: true,
                hasSpaceViewPermission: true
            }));
    const processGroupEdgesArray = (groupEdgesArray)=>groupEdgesArray.map((element)=>(0, $8mrqR.transformGroupToREST)(element.node));
    const createRestrictionsObject = (operation, users, groups)=>({
            operation: operation,
            restrictions: {
                user: {
                    results: processUserEdgesArray(users)
                },
                group: {
                    results: processGroupEdgesArray(groups)
                }
            }
        });
    const readObj = createRestrictionsObject('read', usersWithReadRestriction, groupsWithReadRestriction);
    const updateObj = createRestrictionsObject('update', usersWithUpdateRestriction, groupsWithUpdateRestriction);
    return [
        readObj,
        updateObj
    ];
};
const $431bc41fbb9babca$export$756388d4cc11ef74 = (scheduledRestrictions)=>{
    const readRestriction = scheduledRestrictions?.read;
    const updateRestriction = scheduledRestrictions?.update;
    const usersWithReadRestriction = readRestriction?.user?.edges ?? [];
    const groupsWithReadRestriction = readRestriction?.group?.edges ?? [];
    const usersWithUpdateRestriction = updateRestriction?.user?.edges ?? [];
    const groupsWithUpdateRestriction = updateRestriction?.group?.edges ?? [];
    return {
        read: {
            user: usersWithReadRestriction.filter((edge)=>edge?.node != null).map((edge)=>({
                    id: edge?.node?.accountId ?? ''
                })),
            group: groupsWithReadRestriction.filter((edge)=>edge?.node != null).map((edge)=>({
                    name: edge?.node?.name ?? '',
                    id: edge?.node?.id || undefined
                }))
        },
        update: {
            user: usersWithUpdateRestriction.filter((edge)=>edge?.node != null).map((edge)=>({
                    id: edge?.node?.accountId ?? ''
                })),
            group: groupsWithUpdateRestriction.filter((edge)=>edge?.node != null).map((edge)=>({
                    name: edge?.node?.name ?? '',
                    id: edge?.node?.id || undefined
                }))
        }
    };
};
module.exports["getTimesArray"] = $431bc41fbb9babca$export$b182675d91dd4643;
module.exports["mergeDateTime"] = $431bc41fbb9babca$export$6195456a656da885;
module.exports["cacheSchedulePublishTime"] = $431bc41fbb9babca$export$9295f91b059cbee5;
module.exports["displayPublishErrorFlag"] = $431bc41fbb9babca$export$19a3e0c18ebaf6e6;
module.exports["getRestrictionsForPublish"] = $431bc41fbb9babca$export$13107e6716590163;
module.exports["convertRestrictionsObjFromSchedulePublishInfo"] = $431bc41fbb9babca$export$7521340df7373a8f;
module.exports["convertGqlRestrictionsInputFromSchedulePublishInfo"] = $431bc41fbb9babca$export$756388d4cc11ef74;

});

parcelRegister("k5sGX", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9fa87e3de3aa88c$export$2e2bcd8739ae039);

var $jO73f = parcelRequire("jO73f");


var $3yGK6 = parcelRequire("3yGK6");


var $kr6hK = parcelRequire("kr6hK");

function $e9fa87e3de3aa88c$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $3yGK6.default)(1, arguments);
    var additionalDigits = (0, $kr6hK.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $e9fa87e3de3aa88c$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $e9fa87e3de3aa88c$var$parseYear(dateStrings.date, additionalDigits);
        date = $e9fa87e3de3aa88c$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $e9fa87e3de3aa88c$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $e9fa87e3de3aa88c$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $e9fa87e3de3aa88c$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $e9fa87e3de3aa88c$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $e9fa87e3de3aa88c$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $e9fa87e3de3aa88c$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $e9fa87e3de3aa88c$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($e9fa87e3de3aa88c$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($e9fa87e3de3aa88c$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($e9fa87e3de3aa88c$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $e9fa87e3de3aa88c$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $e9fa87e3de3aa88c$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $e9fa87e3de3aa88c$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($e9fa87e3de3aa88c$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $e9fa87e3de3aa88c$var$parseDateUnit(captures[1]);
    var month = $e9fa87e3de3aa88c$var$parseDateUnit(captures[2]) - 1;
    var day = $e9fa87e3de3aa88c$var$parseDateUnit(captures[3]);
    var week = $e9fa87e3de3aa88c$var$parseDateUnit(captures[4]);
    var dayOfWeek = $e9fa87e3de3aa88c$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$e9fa87e3de3aa88c$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $e9fa87e3de3aa88c$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$e9fa87e3de3aa88c$var$validateDate(year, month, day) || !$e9fa87e3de3aa88c$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $e9fa87e3de3aa88c$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $e9fa87e3de3aa88c$var$parseTime(timeString) {
    var captures = timeString.match($e9fa87e3de3aa88c$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $e9fa87e3de3aa88c$var$parseTimeUnit(captures[1]);
    var minutes = $e9fa87e3de3aa88c$var$parseTimeUnit(captures[2]);
    var seconds = $e9fa87e3de3aa88c$var$parseTimeUnit(captures[3]);
    if (!$e9fa87e3de3aa88c$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $jO73f.millisecondsInHour) + minutes * (0, $jO73f.millisecondsInMinute) + seconds * 1000;
}
function $e9fa87e3de3aa88c$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $e9fa87e3de3aa88c$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($e9fa87e3de3aa88c$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$e9fa87e3de3aa88c$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $jO73f.millisecondsInHour) + minutes * (0, $jO73f.millisecondsInMinute));
}
function $e9fa87e3de3aa88c$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $e9fa87e3de3aa88c$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $e9fa87e3de3aa88c$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $e9fa87e3de3aa88c$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($e9fa87e3de3aa88c$var$daysInMonths[month] || ($e9fa87e3de3aa88c$var$isLeapYearIndex(year) ? 29 : 28));
}
function $e9fa87e3de3aa88c$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($e9fa87e3de3aa88c$var$isLeapYearIndex(year) ? 366 : 365);
}
function $e9fa87e3de3aa88c$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $e9fa87e3de3aa88c$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $e9fa87e3de3aa88c$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("hP2NR", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf995fbf1bdbe48c$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $bUJkW = parcelRequire("bUJkW");


var $3yGK6 = parcelRequire("3yGK6");

var $cf995fbf1bdbe48c$var$MILLISECONDS_IN_MINUTE = 60000;
function $cf995fbf1bdbe48c$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    return (0, $bUJkW.default)(dirtyDate, amount * $cf995fbf1bdbe48c$var$MILLISECONDS_IN_MINUTE);
}

});

parcelRegister("cHfGW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $4aRua = parcelRequire("4aRua");


var $9wGTI = parcelRequire("9wGTI");


var $jlIaF = parcelRequire("jlIaF");


var $jhwJP = parcelRequire("jhwJP");


var $1mHQU = parcelRequire("1mHQU");

// eslint-disable-next-line check-i18n-id-prefix/i18n-id-prefix-with-package-name-defineMessages
const $d33bb643a38eaa5e$var$i18nBase = (0, $kSwu1.defineMessages)({
    duplicatePageTitleHeader: {
        id: "editor-flags.save.page.exist.content.title",
        defaultMessage: "Give your page a unique name"
    },
    duplicateLivePageTitleHeader: {
        id: "editor-flags.save.live.page.exist.content.title",
        defaultMessage: "Give your doc a unique name"
    },
    duplicatePageTitleMessage: {
        id: "editor-flags.save.page.exist.message",
        defaultMessage: "Page names have to be unique within a space. Give your page a different name to publish it."
    },
    duplicateLivePageTitleMessage: {
        id: "editor-flags.save.live.page.exist.message",
        defaultMessage: "Live docs need unique names within a space. Give your doc a different name. "
    },
    duplicateUpdatePageTitleMessage: {
        id: "editor-flags.save.update-page.exist.message",
        defaultMessage: "Page names have to be unique within a space. Give your page a different name to update it."
    },
    pageTitleInvalidTitleHeader: {
        id: "editor-flags.page.title.invalid.header",
        defaultMessage: "Invalid title - try again."
    },
    pageTitleUpdateInvalidTitleHeader: {
        id: "editor-flags.update-page.title.invalid.header",
        defaultMessage: "We can\u2019t update the page with that name."
    },
    pageTitleInvalidTitleMessage: {
        id: "editor-flags.page.title.invalid.message",
        defaultMessage: "Try another title, up to 255 characters."
    },
    pageTitleTooLongHeader: {
        id: "editor-flags.title.too.long.title",
        defaultMessage: "Your title is too long."
    },
    pageTitleTooLongMessage: {
        id: "editor-flags.title.too.long",
        defaultMessage: "The limit for titles is 255 characters."
    },
    duplicateTemplateTitleHeader: {
        id: "editor-flags.template.can.not.save.error.title.duplicate.title",
        defaultMessage: "A template with this name already exists"
    },
    duplicateTemplateTitleMessage: {
        id: "editor-flags.template.can.not.save.error.title.duplicate",
        defaultMessage: "Template names must be unique within a space. Give your template a different name to save it."
    },
    pageTooBigHeader: {
        id: "editor-flags.page.is.too.big.title",
        defaultMessage: "We can\u2019t save your content"
    },
    pageTooBigMessage: {
        id: "editor-flags.page.is.too.big",
        defaultMessage: "Pages larger than the 2MB limit are slow to load. Break your content into a couple pages and use the Include Page macro to display the content here."
    },
    templateTooBigHeader: {
        id: "editor-flags.template.is.too.big.title",
        defaultMessage: "We can\u2019t save your template"
    },
    templateTooBigMessage: {
        id: "editor-flags.template.is.too.big",
        defaultMessage: "Templates larger than the 2MB limit are slow to load. Break your content into a couple of templates."
    },
    connectionErrorHeader: {
        id: "editor-flags.offline.save.error.title",
        defaultMessage: "We\u2019re having trouble connecting right now"
    },
    connectionErrorMessage: {
        id: "editor-flags.offline.save.error",
        defaultMessage: "Give us a few seconds to reconnect, and you can resume your work."
    },
    templateConnectionParsingFailHeader: {
        id: "editor-flags.template.can.not.parse.content.title",
        defaultMessage: "We can\u2019t open this template"
    },
    templateConnectionParsingFailMessage: {
        id: "editor-flags.template.can.not.parse.content",
        defaultMessage: "This happens when a template contains broken or unsupported elements."
    },
    publishIsTakingTooLongHeader: {
        id: "editor-flags.error.delayed.publishing.title",
        defaultMessage: "We\u2019re having trouble publishing"
    },
    updateIsTakingTooLongHeader: {
        id: "editor-flags.error.delayed.updating.title",
        defaultMessage: "We\u2019re having trouble updating"
    },
    publishIsTakingTooLongMessage: {
        id: "editor-flags.error.delayed.publishing",
        defaultMessage: "We\u2019ll continue trying to publish. If it\u2019s taking too long, refresh the page and click {buttonText}."
    },
    updateIsTakingTooLongMessage: {
        id: "editor-flags.error.delayed.updating",
        defaultMessage: "We\u2019ll continue trying to update. If it\u2019s taking too long, refresh the page and click {buttonText}."
    },
    publishText: {
        id: "editor-flags.error.delayed.publishText",
        defaultMessage: "Publish"
    },
    updateText: {
        id: "editor-flags.error.delayed.updateText",
        defaultMessage: "Update"
    },
    schedulePublishErrorHeader: {
        id: "editor-flags.error.schedule.publish.title",
        defaultMessage: "We had an issue setting the schedule time"
    },
    schedulePublishErrorMessage: {
        id: "editor-flags.error.schedule.publish",
        defaultMessage: "Refresh the page and try again."
    },
    cancelScheduledPublishErrorHeader: {
        id: "editor-flags.error.cancel.scheduled.publish.title",
        defaultMessage: "We had an issue cancelling this scheduled publish"
    },
    cancelScheduledUpdateErrorHeader: {
        id: "editor-flags.error.cancel.scheduled.update.title",
        defaultMessage: "We had an issue cancelling this scheduled update"
    },
    cancelScheduledPublishErrorMessage: {
        id: "editor-flags.error.cancel.scheduled.publish",
        defaultMessage: "Refresh the page and try again."
    },
    schedulePublishNoHeaderErrorHeader: {
        id: "editor-flags.error.scheduled.publish.no-title-error.title",
        defaultMessage: "Your page needs a name"
    },
    schedulePublishNoHeaderErrorMessage: {
        id: "editor-flags.error.scheduled.publish.no-title-error",
        defaultMessage: "Add a title, and you can set a date and time for publishing."
    },
    scheduleUpdateNoHeaderErrorMessage: {
        id: "editor-flags.error.scheduled.update.no-title-error",
        defaultMessage: "Add a title, and you can set a date and time for updating."
    },
    defaultPublishErrorHeader: {
        id: "editor-flags.offline.save.error.generic.title",
        defaultMessage: "Your work is safe, but there\u2019s an issue"
    },
    defaultPublishErrorMessage: {
        id: "editor-flags.offline.save.error.generic",
        defaultMessage: "Refresh the page, and click Publish again."
    },
    defaultUpdateErrorMessage: {
        id: "editor-flags.offline.update.save.error.generic",
        defaultMessage: "Refresh the page, and click Update again."
    },
    defaultTemplateSaveErrorHeader: {
        id: "editor-flags.template.save.error.generic.title",
        defaultMessage: "There\u2019s an issue saving your template"
    },
    defaultTemplateSaveErrorMessage: {
        id: "editor-flags.template.save.error.generic.message",
        defaultMessage: "Try clicking Save again."
    },
    duplicateBlogTitleFromEditPageErrorHeader: {
        id: "editor-flags.error.edit-page.duplicate-blog-title-error.title",
        defaultMessage: "A blog with this name already exists"
    },
    duplicateBlogTitleFromEditPageErrorMessage: {
        id: "editor-flags.error.edit-page.duplicate-blog-title-error.message",
        defaultMessage: "Rename the page before publishing it as a blog."
    },
    duplicateUpdateBlogTitleFromEditPageErrorMessage: {
        id: "editor-flags.error.edit-page.update.duplicate-blog-title-error.message",
        defaultMessage: "Rename the page before updating it as a blog."
    },
    duplicateBlogTitleFromViewPageErrorHeader: {
        id: "editor-flags.error.view-page.duplicate-blog-title-error.title",
        defaultMessage: "A blog with this name already exists"
    },
    duplicateBlogTitleFromViewPageErrorMessage: {
        id: "editor-flags.error.view-page.duplicate-blog-title-error.message",
        defaultMessage: "Rename the page before converting it to a blog."
    },
    noAuthorizeMessage: {
        id: "editor-flags.error.no.authorize.message",
        defaultMessage: "Your session has expired. You\u2019ll need to log in again or switch to another account to keep working. {loginLink}"
    },
    loginLink: {
        id: "editor-flags.error.login.link",
        defaultMessage: "Log in or switch to another account"
    },
    noAccessMessage: {
        id: "editor-flags.error.no.access.message",
        defaultMessage: "Your session may have expired. You\u2019ll need to log in again or switch to another account to keep working. {loginLink}"
    },
    pageIsTrashedMessage: {
        id: "editor-flags.error.page.trashed.message",
        defaultMessage: "Copy your content, then add it to a new page or <link>restore this page from the trash</link> and try again."
    },
    livePageIsTrashedMessage: {
        id: "editor-flags.error.live.page.trashed.message",
        defaultMessage: "Copy your content, then add it to a new doc or <link>restore this doc from the trash</link> and try again."
    },
    pageIsTrashedMessageLink: {
        id: "editor-flags.error.page.trashed.message.link",
        defaultMessage: "Restore this content from the trash"
    },
    invalidTemplateVariableMessage: {
        id: "editor-flags.error.invalid.template.variable.message",
        defaultMessage: "Multiple template variables which have the same name \u201C{variableNames}\u201D but different parameters."
    },
    cantRevertPageTitle: {
        id: "editor.discard-to-published.error.title",
        defaultMessage: "Can\u2019t revert to last published version"
    },
    cantRevertPageMessage: {
        id: "editor.discard-to-published.error.message",
        defaultMessage: "We can\u2019t get the last published version of the page at the moment. Give it a few moments then try discarding the draft again."
    },
    parentNotPublishedHeader: {
        id: "editor-flags.error.edit-page.parent-not-published.title",
        defaultMessage: "This draft can\u2019t be published"
    },
    parentNotPublishedMessage: {
        id: "editor-flags.error.edit-page.parent-not-published.message",
        defaultMessage: "A published page can\u2019t exist under a page in the draft state. Publish the <link>parent page</link> first, then publish this page."
    },
    titleRequiredHeader: {
        id: "editor-flags.page.title.required.header",
        defaultMessage: "Title required"
    },
    titleRequiredMessage: {
        id: "editor-flags.page.title.required.message",
        defaultMessage: "Add a title before publishing."
    },
    titleRequiredUpdateMessage: {
        id: "editor-flags.update.page.title.required.update.message",
        defaultMessage: "Add a title before updating."
    },
    titleGeneratedAI: {
        id: "editor-flags.generate.ai.title",
        defaultMessage: "Review your AI-generated title"
    },
    titleGeneratedAIDescription: {
        id: "editor-flags.generate.ai.description",
        defaultMessage: "Rovo is generating a title for this page, as a title is required to publish. Select <bold>Accept</bold> to publish the page with this title or edit the title and publish manually. <Link>Content quality may vary.</Link>"
    },
    titleGeneratedFromPasteAI: {
        id: "editor-flags.generate.ai.from.paste.title",
        defaultMessage: "Rovo wrote a title for you"
    },
    titleGeneratedFromPasteAIDescription: {
        id: "editor-flags.generate.ai.from.paste.description",
        defaultMessage: "It\u2019s based on the text you pasted. <Link>Uses AI. Verify results.</Link>"
    },
    titleGeneratedAIError: {
        id: "editor-flags.generate.ai.error.title",
        defaultMessage: "We couldn\u2019t generate a title for you"
    },
    titleGeneratedAIErrorDescription: {
        id: "editor-flags.generate.ai.error.description",
        defaultMessage: "Rovo was unable to generate a title for you at this time. You can add a title and publish the page manually instead. <Link>Why did this happen?</Link>"
    },
    refreshPageConflictHeader: {
        id: "editor-flags.error.conflict.refresh-page.header",
        defaultMessage: "Refresh this page in order to publish"
    },
    refreshPageUpdateConflictHeader: {
        id: "editor-flags.error.update.conflict.refresh-page.header",
        defaultMessage: "Refresh in order to update"
    },
    refreshPageConflictMessage: {
        id: "editor-flags.error.conflict.refresh-page.message",
        defaultMessage: "This version has been updated by another user. Refresh the page in order to sync and publish your changes."
    },
    refreshUpdatePageConflictMessage: {
        id: "editor-flags.error.update.conflict.refresh-page.message",
        defaultMessage: "This version has been updated by another user. Refresh now in order to sync your changes."
    },
    draftConflictHeader: {
        id: "editor-flags.error.conflict.draft.header",
        defaultMessage: "Unable to publish draft"
    },
    draftConflictMessage: {
        id: "editor-flags.error.conflict.draft.message",
        defaultMessage: "Due to a server error, this draft can\u2019t be published. Copy and paste this content into a new draft in order to publish it."
    },
    duplicatePageNameWithinEditorErrorTitle: {
        id: "editor-flags.move-error.duplicate-page-name-within-editor.title",
        defaultMessage: "Give this page a unique title to move"
    },
    duplicateLivePageNameWithinEditorErrorTitle: {
        id: "editor-flags.move-error.duplicate-live-page-name-within-editor.title",
        defaultMessage: "Give this doc a unique title to move"
    },
    duplicatePageNameWithinEditorErrorDescription: {
        id: "editor-flags.move-error.duplicate-page-name-within-editor.description",
        defaultMessage: "To move this page to the {destinationSpace} space, give it a unique title and publish it first."
    },
    duplicateLivePageNameWithinEditorErrorDescription: {
        id: "editor-flags.move-error.duplicate-live-page-name-within-editor.description",
        defaultMessage: "To move this live doc to the {destinationSpace} space, give it a unique title."
    },
    duplicatePageNameWithinEditorUpdateErrorDescription: {
        id: "editor-flags.move-error.duplicate-page-name-within-editor.update.description",
        defaultMessage: "To move this page to the {destinationSpace} space, give it a unique title and update it first."
    },
    duplicateLivePageNameWithinEditorUpdateErrorDescription: {
        id: "editor-flags.move-error.duplicate-live-page-name-within-editor.update.description",
        defaultMessage: "To move this live doc to the {destinationSpace} space, give it a unique title and update it first."
    },
    collabStatusErrorTitle: {
        id: "editor-flags.collab-status-error.title",
        defaultMessage: "Can\u2019t save changes"
    },
    collabStatusErrorDescription: {
        id: "editor-flags.collab-status-error.description",
        defaultMessage: "Copy your work, then refresh, and we\u2019ll try to reconnect."
    },
    invalidSpaceKeyHeader: {
        id: "editor-flags.template.save.error.spacekey.invalid.header",
        defaultMessage: "There was an issue creating a template in this space"
    },
    invalidSpaceKeyMessage: {
        id: "editor-flags.template.save.error.spacekey.invalid.message",
        defaultMessage: "Check if the space exists and if you have admin permissions to create templates."
    },
    templateBlankTitleErrorHeader: {
        id: "editor-flags.template.can.not.save.error.title.blank.header",
        defaultMessage: "We can\u2019t save this template"
    },
    templateBlankTitleErrorMessage: {
        id: "editor-flags.template.can.not.save.error.title.blank.message",
        defaultMessage: "Templates can\u2019t have blank titles. Give your template a title to publish."
    }
});
const $d33bb643a38eaa5e$var$i18nLiveDocs = (0, $kSwu1.defineMessages)({
    pageTooBigMessage: {
        id: "editor-flags.page.is.too.big.livedocs",
        defaultMessage: "Content that is larger than the 2MB limit is slow to load. Break your content into a couple of pages or live docs and use the Include Page macro to display the content here."
    }
});
const $d33bb643a38eaa5e$var$i18n = (0, $jhwJP.mergeLiveDocI18n)($d33bb643a38eaa5e$var$i18nBase, $d33bb643a38eaa5e$var$i18nLiveDocs);
const $d33bb643a38eaa5e$var$BOLD_BUTTON_TEXT = ({ isUnpublishedDraft: isUnpublishedDraft })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.publishText : $d33bb643a38eaa5e$var$i18n.updateText));
const $d33bb643a38eaa5e$var$LOGIN_LINK = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: "/login?application=confluence"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $d33bb643a38eaa5e$var$i18n.loginLink)));
const $d33bb643a38eaa5e$var$TRASH_LINK = ({ spaceKey: spaceKey, text: text })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: `${(0, $jlIaF.CONTEXT_PATH)}/pages/viewtrash.action?key=${spaceKey}`,
        target: "_blank"
    }, text));
const $d33bb643a38eaa5e$var$PARENT_LINK = ({ parentPageId: parentPageId, text: text })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, parentPageId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: `${(0, $jlIaF.CONTEXT_PATH)}/pages/resumedraft.action?draftId=${parentPageId}`,
        target: "_blank"
    }, text) : text);
const $d33bb643a38eaa5e$var$i18nInitializer = (formatMessage, isLivePage)=>({
        DUPLICATE_PAGE_TITLE: (isUnpublishedDraft)=>{
            const duplicatePageTitleMessage = isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? $d33bb643a38eaa5e$var$i18n.duplicateLivePageTitleMessage : $d33bb643a38eaa5e$var$i18n.duplicatePageTitleMessage;
            return {
                title: isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? formatMessage($d33bb643a38eaa5e$var$i18n.duplicateLivePageTitleHeader) : formatMessage($d33bb643a38eaa5e$var$i18n.duplicatePageTitleHeader),
                description: formatMessage(isUnpublishedDraft ? duplicatePageTitleMessage : $d33bb643a38eaa5e$var$i18n.duplicateUpdatePageTitleMessage)
            };
        },
        TITLE_TOO_LONG: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.pageTitleTooLongHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.pageTitleTooLongMessage)
            }),
        DUPLICATE_TEMPLATE_TITLE: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.duplicateTemplateTitleHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.duplicateTemplateTitleMessage)
            }),
        PARENT_NOT_PUBLISHED: (parentPageId)=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.parentNotPublishedHeader),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...$d33bb643a38eaa5e$var$i18n.parentNotPublishedMessage,
                    values: {
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d33bb643a38eaa5e$var$PARENT_LINK, {
                                parentPageId: parentPageId,
                                text: chunks
                            })
                    }
                })
            }),
        NO_AUTHORIZE: ()=>({
                title: formatMessage({
                    id: "editor.offline.save.noauthorized.title"
                }),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...$d33bb643a38eaa5e$var$i18n.noAuthorizeMessage,
                    values: {
                        loginLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d33bb643a38eaa5e$var$LOGIN_LINK, null)
                    }
                })
            }),
        PAGE_CANNOT_BE_ACCESSED: ()=>({
                title: formatMessage({
                    id: "editor.page.can.not.be.accessed.title"
                }),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...$d33bb643a38eaa5e$var$i18n.noAccessMessage,
                    values: {
                        loginLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d33bb643a38eaa5e$var$LOGIN_LINK, null)
                    }
                })
            }),
        PAGE_CONFLICT_REFRESH: (isUnpublishedDraft)=>({
                title: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.refreshPageConflictHeader : $d33bb643a38eaa5e$var$i18n.refreshPageUpdateConflictHeader),
                description: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.refreshPageConflictMessage : $d33bb643a38eaa5e$var$i18n.refreshUpdatePageConflictMessage)
            }),
        PAGE_CONFLICT_DRAFT: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.draftConflictHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.draftConflictMessage)
            }),
        PAGE_TRASHED: (spaceKey)=>({
                title: formatMessage({
                    id: "editor.page.is.trashed.title"
                }),
                description: isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...$d33bb643a38eaa5e$var$i18n.livePageIsTrashedMessage,
                    values: {
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d33bb643a38eaa5e$var$TRASH_LINK, {
                                spaceKey: spaceKey,
                                text: chunks
                            })
                    }
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...$d33bb643a38eaa5e$var$i18n.pageIsTrashedMessage,
                    values: {
                        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d33bb643a38eaa5e$var$TRASH_LINK, {
                                spaceKey: spaceKey,
                                text: chunks
                            })
                    }
                })
            }),
        PAGE_TOO_BIG: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.pageTooBigHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.pageTooBigMessage)
            }),
        TEMPLATE_TOO_BIG: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.templateTooBigHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.templateTooBigMessage)
            }),
        OFFLINE_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.connectionErrorHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.connectionErrorMessage)
            }),
        TEMPLATE_CONTENT_PARSING_FAILURE: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.templateConnectionParsingFailHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.templateConnectionParsingFailMessage)
            }),
        EMPTY_TITLE: ()=>({
                title: formatMessage({
                    id: "editor.title.is.empty.title"
                }),
                description: formatMessage({
                    id: "editor.title.is.empty"
                })
            }),
        DUPLICATE_EDIT_PAGE_BLOG_TITLE: (isUnpublishedDraft)=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.duplicateBlogTitleFromEditPageErrorHeader),
                description: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.duplicateBlogTitleFromEditPageErrorMessage : $d33bb643a38eaa5e$var$i18n.duplicateUpdateBlogTitleFromEditPageErrorMessage)
            }),
        DUPLICATE_VIEW_PAGE_BLOG_TITLE: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.duplicateBlogTitleFromViewPageErrorHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.duplicateBlogTitleFromViewPageErrorMessage)
            }),
        MEDIA_FAILED: ()=>({
                title: formatMessage({
                    id: "editor.cant.publish.changes"
                }),
                description: formatMessage({
                    id: "editor.files.may.be.uploading"
                })
            }),
        INVALID_TEMPLATE_VARIABLE: (errorData)=>({
                title: formatMessage({
                    id: "fabric.template.can.not.save.error.title"
                }),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...$d33bb643a38eaa5e$var$i18n.invalidTemplateVariableMessage,
                    values: {
                        variableNames: errorData.i18nOptions.variableNames
                    }
                })
            }),
        DUPLICATE_PAGE_TITLE_WITHIN_EDITOR: (destinationSpace, isUnpublishedDraft)=>({
                title: formatMessage(isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? $d33bb643a38eaa5e$var$i18n.duplicateLivePageNameWithinEditorErrorTitle : $d33bb643a38eaa5e$var$i18n.duplicatePageNameWithinEditorErrorTitle),
                description: isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.duplicateLivePageNameWithinEditorErrorDescription : $d33bb643a38eaa5e$var$i18n.duplicateLivePageNameWithinEditorUpdateErrorDescription,
                    values: {
                        destinationSpace: destinationSpace
                    }
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.duplicatePageNameWithinEditorErrorDescription : $d33bb643a38eaa5e$var$i18n.duplicatePageNameWithinEditorUpdateErrorDescription,
                    values: {
                        destinationSpace: destinationSpace
                    }
                })
            }),
        RECONCILIATION_ERROR: (errorData, nextTryIn)=>{
            const title = formatMessage({
                id: "editor.content.reconciliation.error.title"
            });
            if (nextTryIn != null) return {
                title: title,
                description: (secondsLeft)=>formatMessage({
                        id: "editor.content.reconciliation.error.retrying"
                    }, {
                        0: `${secondsLeft}`
                    })
            };
            const showStagingError = false;
            const messageEnv = showStagingError ? 'staging' : 'prod';
            const i18nDescriptionMessage = {
                id: `editor.content.reconciliation.error.fatal.${messageEnv}`
            };
            const description = formatMessage(i18nDescriptionMessage);
            const details = `${formatMessage({
                id: "editor.content.reconciliation.error.details"
            })} ${errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).CONTENT_RECONCILIATION]}`;
            return {
                title: title,
                description: description,
                details: details
            };
        },
        PUBLISH_TIME_TOO_LONG_ERROR: (isUnpublishedDraft)=>({
                title: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.publishIsTakingTooLongHeader : $d33bb643a38eaa5e$var$i18n.updateIsTakingTooLongHeader),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.publishIsTakingTooLongMessage : $d33bb643a38eaa5e$var$i18n.updateIsTakingTooLongMessage,
                    values: {
                        buttonText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d33bb643a38eaa5e$var$BOLD_BUTTON_TEXT, {
                            isUnpublishedDraft: isUnpublishedDraft
                        })
                    }
                })
            }),
        SCHEDULE_PUBLISH_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.schedulePublishErrorHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.schedulePublishErrorMessage)
            }),
        CANCEL_SCHEDULE_PUBLISH_ERROR: (isUnpublishedDraft)=>({
                title: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.cancelScheduledPublishErrorHeader : $d33bb643a38eaa5e$var$i18n.cancelScheduledUpdateErrorHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.cancelScheduledPublishErrorMessage)
            }),
        SCHEDULE_PUBLISH_WITH_NO_TITLE_ERROR: (isUnpublishedDraft)=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.schedulePublishNoHeaderErrorHeader),
                description: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.schedulePublishNoHeaderErrorMessage : $d33bb643a38eaa5e$var$i18n.scheduleUpdateNoHeaderErrorMessage)
            }),
        DEFAULT_PUBLISH_ERROR: (isUnpublishedDraft)=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.defaultPublishErrorHeader),
                description: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.defaultPublishErrorMessage : $d33bb643a38eaa5e$var$i18n.defaultUpdateErrorMessage)
            }),
        DEFAULT_TEMPLATE_SAVE_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.defaultTemplateSaveErrorHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.defaultTemplateSaveErrorMessage)
            }),
        REVERT_CONTENT_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.cantRevertPageTitle),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.cantRevertPageMessage)
            }),
        PUBLISH_CONDITION_ERROR: (errorMsg)=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.defaultPublishErrorHeader),
                description: errorMsg
            }),
        INVALID_PAGE_TITLE_ERROR: (isUnpublishedDraft)=>({
                title: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.pageTitleInvalidTitleHeader : $d33bb643a38eaa5e$var$i18n.pageTitleUpdateInvalidTitleHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.pageTitleInvalidTitleMessage)
            }),
        TITLE_REQUIRED: (isUnpublishedDraft)=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.titleRequiredHeader),
                description: formatMessage(isUnpublishedDraft ? $d33bb643a38eaa5e$var$i18n.titleRequiredMessage : $d33bb643a38eaa5e$var$i18n.titleRequiredUpdateMessage)
            }),
        AI_GENERATED_TITLE: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.titleGeneratedAI),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.titleGeneratedAIDescription, {
                    Link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                            target: "_blank",
                            href: "https://www.atlassian.com/trust/atlassian-intelligence",
                            appearance: "subtle"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("u", null, chunks)),
                    bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
                            weight: "bold"
                        }, " ", chunks, " ")
                })
            }),
        AI_GENERATED_TITLE_FROM_PASTE: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.titleGeneratedFromPasteAI),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.titleGeneratedFromPasteAIDescription, {
                    Link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                            target: "_blank",
                            href: "https://www.atlassian.com/trust/atlassian-intelligence",
                            appearance: "subtle"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("u", null, chunks)),
                    bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
                            weight: "bold"
                        }, " ", chunks, " ")
                })
            }),
        AI_GENERATED_TITLE_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.titleGeneratedAIError),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.titleGeneratedAIErrorDescription, {
                    Link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                            target: "_blank",
                            href: "https://support.atlassian.com/organization-administration/docs/troubleshoot-atlassian-intelligence/",
                            appearance: "subtle"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("u", null, chunks))
                })
            }),
        COLLAB_STATUS_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.collabStatusErrorTitle),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.collabStatusErrorDescription)
            }),
        INVALID_SPACEKEY_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.invalidSpaceKeyHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.invalidSpaceKeyMessage)
            }),
        TEMPLATE_BLANK_TITLE_ERROR: ()=>({
                title: formatMessage($d33bb643a38eaa5e$var$i18n.templateBlankTitleErrorHeader),
                description: formatMessage($d33bb643a38eaa5e$var$i18n.templateBlankTitleErrorMessage)
            })
    });
const $d33bb643a38eaa5e$export$cda5b5526dda47f7 = ({ errorData: errorData, statusCode: statusCode, spaceKey: spaceKey, parentPageId: parentPageId, nextTryIn: nextTryIn, formatMessage: formatMessage, isTemplateEditor: isTemplateEditor = false, isUnpublishedDraft: isUnpublishedDraft = true, isLivePage: isLivePage = false })=>{
    if (!errorData || !Object.keys(errorData).length) return null;
    const i18nFormatter = $d33bb643a38eaa5e$var$i18nInitializer(formatMessage, isLivePage);
    // Http errors from the content api when publishing
    if (statusCode != null) switch(statusCode){
        case 400:
            if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE] || // have to check instead of doing errorData[ALLOWED_FLAG_MESSAGES.DUPLICATE_TITLE_WITH_BAD_EXCEPTION]
            // because BE message would sometimes have extra words at the end of A page with this title already exists
            // eg com.atlassian.confluence.api.service.exceptions.api.BadRequestException: A page with this title already exists:
            // A page already exists with the title <PAGE_TITLE> in the space with key <SPACE_KEY>
            Object.keys(errorData)[0].indexOf((0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE_WITH_BAD_EXCEPTION) !== -1) return i18nFormatter.DUPLICATE_PAGE_TITLE(isUnpublishedDraft);
            else if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).INVALID_PAGE_TITLE]) return i18nFormatter.INVALID_PAGE_TITLE_ERROR(isUnpublishedDraft);
            else if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).TITLE_TOO_LONG]) return i18nFormatter.TITLE_TOO_LONG();
            else if (Object.keys(errorData)[0].indexOf((0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE_TEMPLATE) !== -1) return i18nFormatter.DUPLICATE_TEMPLATE_TITLE();
            else if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).PARENT_NOT_PUBLISHED]) return i18nFormatter.PARENT_NOT_PUBLISHED(parentPageId);
            else if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).TEMPLATE_INVALID_SPACEKEY_ERROR]) return i18nFormatter.INVALID_SPACEKEY_ERROR();
            else if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).TEMPLATE_BLANK_TITLE_ERROR]) return i18nFormatter.TEMPLATE_BLANK_TITLE_ERROR();
            else if (// BadRequestException means something wrong with the request. BE throws this exception on request validation fail
            // This BadRequestException has a message attached to it and we should use it as default message if non of above conditions are met.
            // That's why make sure this "if" block should say at last.
            // We are adding this as part of our PublishCondition implementation. Please go through: https://hello.atlassian.net/wiki/spaces/CCECO/pages/1289257589/Custom+publishing+flow
            // For any further questions please contact ecosystem-ini team.
            Object.keys(errorData)[0].indexOf((0, $1mHQU.ALLOWED_FLAG_MESSAGES).ERROR_MESSAGE_WITH_BAD_EXCEPTION) !== -1) {
                // positive look-behind "(?<=expression)" is not supported with str.match() so end up using below pattern.
                const patt = '[^com.atlassian.confluence.api.service.exceptions.api.BadRequestException:].*';
                const errorMsg = Object.keys(errorData)[0].match(patt);
                return i18nFormatter.PUBLISH_CONDITION_ERROR(errorMsg);
            }
            break;
        case 403:
            return i18nFormatter.NO_AUTHORIZE();
        case 404:
            return i18nFormatter.PAGE_CANNOT_BE_ACCESSED();
        case 409:
            if (Object.keys(errorData)[0].indexOf((0, $1mHQU.ALLOWED_FLAG_MESSAGES).CONFLICT_DRAFT_VERSIONING) !== -1) return i18nFormatter.PAGE_CONFLICT_DRAFT();
            return i18nFormatter.PAGE_CONFLICT_REFRESH(isUnpublishedDraft);
        case 410:
            if (isTemplateEditor) return i18nFormatter.DEFAULT_TEMPLATE_SAVE_ERROR();
            return i18nFormatter.PAGE_TRASHED(spaceKey);
        case 413:
            return isTemplateEditor ? i18nFormatter.TEMPLATE_TOO_BIG() : i18nFormatter.PAGE_TOO_BIG();
        case 0:
        case 500:
        case 503:
            return i18nFormatter.OFFLINE_ERROR();
    }
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).TEMPLATE_CONTENT_PARSING_FAILURE]) return i18nFormatter.TEMPLATE_CONTENT_PARSING_FAILURE();
    // editor errors triggered from within the fabric editor
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).EMPTY_TITLE]) return i18nFormatter.EMPTY_TITLE();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_VIEW_PAGE_BLOG_TITLE]) return i18nFormatter.DUPLICATE_VIEW_PAGE_BLOG_TITLE();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE_WITHIN_EDITOR]) return i18nFormatter.DUPLICATE_PAGE_TITLE_WITHIN_EDITOR(errorData.destinationSpace, isUnpublishedDraft);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_EDIT_PAGE_BLOG_TITLE]) return i18nFormatter.DUPLICATE_EDIT_PAGE_BLOG_TITLE(isUnpublishedDraft);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE_TEMPLATE]) return i18nFormatter.DUPLICATE_TEMPLATE_TITLE();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).MEDIA_FAILED]) return i18nFormatter.MEDIA_FAILED();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).FOUND_INVALID_TEMPLATE_VARIABLE]) return i18nFormatter.INVALID_TEMPLATE_VARIABLE(errorData);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).CONTENT_RECONCILIATION]) return i18nFormatter.RECONCILIATION_ERROR(errorData, nextTryIn);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).PUBLISH_TIME_TOO_LONG_ERROR]) return i18nFormatter.PUBLISH_TIME_TOO_LONG_ERROR(isUnpublishedDraft);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).SCHEDULE_PUBLISH_ERROR]) return i18nFormatter.SCHEDULE_PUBLISH_ERROR();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).CANCEL_SCHEDULE_PUBLISH_ERROR]) return i18nFormatter.CANCEL_SCHEDULE_PUBLISH_ERROR(isUnpublishedDraft);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).SCHEDULE_PUBLISH_WITH_NO_TITLE_ERROR]) return i18nFormatter.SCHEDULE_PUBLISH_WITH_NO_TITLE_ERROR(isUnpublishedDraft);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).REVERT_CONTENT_ERROR]) return i18nFormatter.REVERT_CONTENT_ERROR();
    // UX https://product-fabric.atlassian.net/browse/CEMS-2468
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).COLLAB_INIT_TIMEOUT_TAKING_TOO_LONG]) return i18nFormatter.OFFLINE_ERROR();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).TITLE_REQUIRED]) return i18nFormatter.TITLE_REQUIRED(isUnpublishedDraft);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE]) return i18nFormatter.AI_GENERATED_TITLE();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE_FROM_PASTE]) return i18nFormatter.AI_GENERATED_TITLE_FROM_PASTE();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).AI_GENERATED_TITLE_ERROR]) return i18nFormatter.AI_GENERATED_TITLE_ERROR();
    // Adding duplicate and invalid page errors outside of status code 400 for use with publish modal buttons (they do not send requests)
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE] || // have to check instead of doing errorData[ALLOWED_FLAG_MESSAGES.DUPLICATE_TITLE_WITH_BAD_EXCEPTION]
    // because BE message would sometimes have extra words at the end of A page with this title already exists
    // eg com.atlassian.confluence.api.service.exceptions.api.BadRequestException: A page with this title already exists:
    // A page already exists with the title <PAGE_TITLE> in the space with key <SPACE_KEY>
    Object.keys(errorData)[0].indexOf((0, $1mHQU.ALLOWED_FLAG_MESSAGES).DUPLICATE_TITLE_WITH_BAD_EXCEPTION) !== -1) return i18nFormatter.DUPLICATE_PAGE_TITLE(isUnpublishedDraft);
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).INVALID_PAGE_TITLE]) return i18nFormatter.INVALID_PAGE_TITLE_ERROR(isUnpublishedDraft);
    if (isTemplateEditor) return i18nFormatter.DEFAULT_TEMPLATE_SAVE_ERROR();
    if (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).COLLAB_STATUS_ERROR]) return i18nFormatter.COLLAB_STATUS_ERROR();
    return i18nFormatter.DEFAULT_PUBLISH_ERROR(isUnpublishedDraft);
};
module.exports["buildEditorFlagMessage"] = $d33bb643a38eaa5e$export$cda5b5526dda47f7;

});

parcelRegister("1mHQU", function(module, exports) {
const $bacd8f7695bdf465$export$c4d5263a0e2e072d = {
    DUPLICATE_TITLE: 'A page with this title already exists',
    DUPLICATE_TITLE_WITHIN_EDITOR: 'Give this page a unique title to move',
    DUPLICATE_EDIT_PAGE_BLOG_TITLE: 'Cannot convert draft, a blog with this title already exists',
    DUPLICATE_VIEW_PAGE_BLOG_TITLE: 'Cannot convert page, a blog with this title already exists',
    EMPTY_TITLE: 'empty-title',
    TITLE_REQUIRED: 'title-required',
    AI_GENERATED_TITLE: 'Review your AI-generated title',
    AI_GENERATED_TITLE_FROM_PASTE: 'AI generated title from paste',
    AI_GENERATED_TITLE_ERROR: "We couldn\u2019t generate a title for you",
    INVALID_PAGE_TITLE: 'You need to include the title to update a page.',
    // this error message is returned with status 400 in fabric editor when page with duplicate title is published
    DUPLICATE_TITLE_WITH_BAD_EXCEPTION: 'com.atlassian.confluence.api.service.exceptions.api.BadRequestException: A page with this title already exists',
    OTHER_PUBLISH: 'other-publish',
    OTHER_RESTORE: 'other-restore',
    CONTENT_RECONCILIATION: 'content-reconciliation',
    TITLE_TOO_LONG: 'Title cannot be longer than 255 characters.',
    MEDIA_FAILED: "Can't publish changes",
    SYNCHRONY_WAS_NOT_CONNECTED_ERROR: 'An unexpected error occurred after connecting to editing services.',
    SYNCHRONY_WAS_NOT_INITIALIZED_ERROR: 'An unexpected error occurred when connecting to editing services.',
    SYNCHRONY_ACK_MISSING_ERROR: 'An unexpected error occurred after requesting the final editor state.',
    FOUND_INVALID_TEMPLATE_VARIABLE: 'Found multiple variables with the same name but different types',
    DUPLICATE_TITLE_TEMPLATE: 'Template title already used, please use a different name.',
    TEMPLATE_CONTENT_PARSING_FAILURE: 'template-content-parsing-failure',
    SYNCHRONY_UNEXPECTED_ERROR: 'An unexpected error occurred while requesting the final editor state.',
    PUBLISH_TIME_TOO_LONG_ERROR: 'An error occurred and it took too long to publish the page.',
    SCHEDULE_PUBLISH_ERROR: 'An error occurred when scheduling the publish.',
    CANCEL_SCHEDULE_PUBLISH_ERROR: 'An error occured when cancelling the scheduled publish.',
    SCHEDULE_PUBLISH_WITH_NO_TITLE_ERROR: 'Add a title, and you can set a date and time for publishing.',
    REVERT_CONTENT_ERROR: 'An error occurred while trying to revert the page.',
    PARENT_NOT_PUBLISHED: 'com.atlassian.confluence.api.service.exceptions.api.BadRequestException: Could not publish draft. Parent page has not been published.',
    RESTORE_CONTENT_SUCCESS: 'Page/blogpost has been reverted to last version',
    BLOGIFY_BLOGPOST_SUCCESS: 'Page converted to a blog post',
    TEMPLATE_PUBLISH_TAKING_LONG: 'Bear with us, this is taking a moment.',
    COLLAB_INIT_TIMEOUT_TAKING_TOO_LONG: 'Collab init event is taking too long',
    ERROR_MESSAGE_WITH_BAD_EXCEPTION: 'com.atlassian.confluence.api.service.exceptions.api.BadRequestException:',
    CONFLICT_DRAFT_VERSIONING: 'Draft versioning is not supported.',
    COLLAB_STATUS_ERROR: "Can't save changes.",
    TEMPLATE_INVALID_SPACEKEY_ERROR: 'Invalid spaceKeys.',
    TEMPLATE_BLANK_TITLE_ERROR: 'Template title cannot be null or empty string',
    CREATED_FROM_EXTENSION: 'Draft created from create page extension'
};
module.exports["ALLOWED_FLAG_MESSAGES"] = $bacd8f7695bdf465$export$c4d5263a0e2e072d;

});

parcelRegister("8mrqR", function(module, exports) {

var $f8dGE = parcelRequire("f8dGE");


var $c4ECQ = parcelRequire("c4ECQ");


var $9lU4Z = parcelRequire("9lU4Z");

class $5c6f8af6b02c47e8$var$InvalidRestrictionsObjectError extends Error {
    constructor(){
        super("Invalid restrictions object provided.  Restrictions objects must contain a 'read' ContentRestriction and an 'update' ContentRestriction.");
    }
}
class $5c6f8af6b02c47e8$var$InvalidGraphQLRestrictionsError extends Error {
    constructor(){
        super('Invalid restrictions were fetched from GraphQL.');
    }
}
const $5c6f8af6b02c47e8$var$restrictionIsEmpty = (contentRestriction)=>{
    return contentRestriction.restrictions.user.results.length === 0 && contentRestriction.restrictions.group.results.length === 0;
};
const $5c6f8af6b02c47e8$export$54aeac99fafa79ed = (restObj)=>{
    const readRestriction = restObj.find((obj)=>obj.operation === 'read');
    const updateRestriction = restObj.find((obj)=>obj.operation === 'update');
    if (readRestriction === undefined || updateRestriction === undefined) throw new $5c6f8af6b02c47e8$var$InvalidRestrictionsObjectError();
    if ($5c6f8af6b02c47e8$var$restrictionIsEmpty(readRestriction) && $5c6f8af6b02c47e8$var$restrictionIsEmpty(updateRestriction)) return (0, $c4ECQ.ContentRestrictionType).NO_RESTRICTIONS;
    else if ($5c6f8af6b02c47e8$var$restrictionIsEmpty(readRestriction)) return (0, $c4ECQ.ContentRestrictionType).RESTRICT_EDIT;
    else return (0, $c4ECQ.ContentRestrictionType).RESTRICT_VIEW;
};
const $5c6f8af6b02c47e8$export$b1e5e678c0890199 = (restObj, newRestrictionType, currentUser)=>{
    // This function applies a restrictionType to a RestrictionsRESTObj.
    // Some of the logic here is duplicated by `getPermissionsGroupsBasedOnRestrictionsType`
    // in RestrictionsDialog/restrictions-data-transform-helpers.tsx
    // Be sure that any changes you make to how this logic works are also made in that file.
    const oldRestrictionType = $5c6f8af6b02c47e8$export$54aeac99fafa79ed(restObj);
    const currentUserObj = {
        type: 'known',
        // The `as "known"` is needed to satisfy a Typescript error, since `type` gets assigned the type "string"
        accountId: currentUser.id,
        profilePicture: {
            path: currentUser.profilePicture.path
        },
        displayName: currentUser.displayName,
        publicName: currentUser.displayName,
        isExternalCollaborator: false
    };
    // First make a deep copy of the restObj.
    const restObjCopy = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(restObj);
    const readRestriction = restObjCopy.find((obj)=>obj.operation === 'read');
    const updateRestriction = restObjCopy.find((obj)=>obj.operation === 'update');
    if (readRestriction === undefined || updateRestriction === undefined) throw new $5c6f8af6b02c47e8$var$InvalidRestrictionsObjectError();
    if (newRestrictionType === (0, $c4ECQ.ContentRestrictionType).NO_RESTRICTIONS) {
        // Empty out update and read arrays.
        readRestriction.restrictions.user.results = [];
        readRestriction.restrictions.group.results = [];
        updateRestriction.restrictions.user.results = [];
        updateRestriction.restrictions.group.results = [];
        return restObjCopy;
    } else if (newRestrictionType === (0, $c4ECQ.ContentRestrictionType).RESTRICT_EDIT) {
        if (oldRestrictionType === (0, $c4ECQ.ContentRestrictionType).RESTRICT_VIEW) {
            readRestriction.restrictions.user.results = [];
            readRestriction.restrictions.group.results = [];
            return restObjCopy;
        } else if (oldRestrictionType === (0, $c4ECQ.ContentRestrictionType).RESTRICT_EDIT) return restObjCopy;
        else {
            // oldRestrictionType === ContentRestrictionType.NO_RESTRICTIONS
            updateRestriction.restrictions.user.results.push(currentUserObj);
            return restObjCopy;
        }
    } else {
        // newRestrictionType === ContentRestrictionType.RESTRICT_VIEW
        if (oldRestrictionType === (0, $c4ECQ.ContentRestrictionType).RESTRICT_VIEW) return restObjCopy;
        else if (oldRestrictionType === (0, $c4ECQ.ContentRestrictionType).RESTRICT_EDIT) {
            readRestriction.restrictions.user.results.push(currentUserObj);
            return restObjCopy;
        } else {
            // oldRestrictionType === ContentRestrictionType.NO_RESTRICTIONS
            readRestriction.restrictions.user.results.push(currentUserObj);
            updateRestriction.restrictions.user.results.push(currentUserObj);
            return restObjCopy;
        }
    }
// Permissions levels:
// NO_RESTRICTIONS
// RESTRICT_EDIT
// RESTRICT_VIEW
//
// To move upwards on that list, just empty out the restrictions arrays.
// To move downwards on that list, you have to add the current user into the correct restrictions segment.
};
const $5c6f8af6b02c47e8$var$convertRESTUser = (restUser)=>{
    return {
        key: `USER-${restUser.accountId}`,
        entityType: (0, $c4ECQ.EntityType).USER,
        permissions: [],
        displayName: restUser.displayName,
        accountId: restUser.accountId,
        profilePicture: {
            path: restUser.profilePicture.path
        },
        hasSpaceViewPermission: restUser?.hasSpaceViewPermission ?? true,
        hasSpaceEditPermission: restUser?.hasSpaceEditPermission ?? true,
        permissionType: restUser.isExternalCollaborator ? (0, $9lU4Z.SitePermissionType).EXTERNAL : (0, $9lU4Z.SitePermissionType).INTERNAL
    };
};
const $5c6f8af6b02c47e8$var$convertRESTGroup = (restGroup)=>{
    return {
        key: `GROUP-${restGroup.id}`,
        entityType: (0, $c4ECQ.EntityType).GROUP,
        permissions: [],
        name: restGroup.name,
        permissionType: (0, $9lU4Z.SitePermissionType).INTERNAL
    };
};
const $5c6f8af6b02c47e8$export$a9b84852f592ee6c = (restObj)=>{
    const readRestriction = restObj.find((obj)=>obj.operation === 'read');
    const updateRestriction = restObj.find((obj)=>obj.operation === 'update');
    if (readRestriction === undefined || updateRestriction === undefined) throw new $5c6f8af6b02c47e8$var$InvalidRestrictionsObjectError();
    // TODO It may be possible to re-use some of the logic in
    // restrictions-data-transform-helpers.tsx here.
    // First, make a map from accountIds or group ids to their corresponding objects.
    const userGroupMap = new Map();
    for (const user of readRestriction.restrictions.user.results){
        if (!userGroupMap.has(user.accountId)) userGroupMap.set(user.accountId, $5c6f8af6b02c47e8$var$convertRESTUser(user));
        userGroupMap.get(user.accountId).permissions.push((0, $c4ECQ.PermissionType).VIEW);
    }
    for (const group of readRestriction.restrictions.group.results){
        if (!userGroupMap.has(group.id)) userGroupMap.set(group.id, $5c6f8af6b02c47e8$var$convertRESTGroup(group));
        userGroupMap.get(group.id).permissions.push((0, $c4ECQ.PermissionType).VIEW);
    }
    for (const user of updateRestriction.restrictions.user.results){
        if (!userGroupMap.has(user.accountId)) userGroupMap.set(user.accountId, $5c6f8af6b02c47e8$var$convertRESTUser(user));
        userGroupMap.get(user.accountId).permissions.push((0, $c4ECQ.PermissionType).EDIT);
    }
    for (const group of updateRestriction.restrictions.group.results){
        if (!userGroupMap.has(group.id)) userGroupMap.set(group.id, $5c6f8af6b02c47e8$var$convertRESTGroup(group));
        userGroupMap.get(group.id).permissions.push((0, $c4ECQ.PermissionType).EDIT);
    }
    // Return an array out of all the values from the map.
    // This matches the format of the usersAndGroups object.
    return Array.from(userGroupMap).map(([, value])=>value);
};
const $5c6f8af6b02c47e8$export$dfb1e6e2e25bf061 = (user)=>{
    return {
        type: 'known',
        accountId: user?.accountId ?? '',
        publicName: user?.publicName ?? '',
        profilePicture: {
            path: user?.profilePicture?.path ?? ''
        },
        email: user?.email ?? '',
        displayName: user?.displayName ?? '',
        hasSpaceViewPermission: user?.hasSpaceViewPermission ?? true,
        hasSpaceEditPermission: user?.hasSpaceEditPermission ?? true,
        isExternalCollaborator: user.permissionType === (0, $9lU4Z.SitePermissionType).EXTERNAL
    };
};
const $5c6f8af6b02c47e8$export$354ad6f5846ff4ac = (group)=>{
    return {
        type: 'group',
        name: group?.name ?? '',
        id: group?.id ?? '',
        usageType: group?.usageType ?? null
    };
};
const $5c6f8af6b02c47e8$var$isDefined = (value)=>{
    return value != null;
};
const $5c6f8af6b02c47e8$export$a57b08835223f9b8 = (queryData)=>{
    const readRestriction = queryData?.content?.nodes?.[0]?.restrictions?.read?.restrictions;
    const updateRestriction = queryData?.content?.nodes?.[0]?.restrictions?.update?.restrictions;
    if (readRestriction === undefined || updateRestriction === undefined) throw new $5c6f8af6b02c47e8$var$InvalidGraphQLRestrictionsError();
    const readObj = {
        operation: 'read',
        restrictions: {
            user: {
                results: []
            },
            group: {
                results: []
            }
        }
    };
    const updateObj = {
        operation: 'update',
        restrictions: {
            user: {
                results: []
            },
            group: {
                results: []
            }
        }
    };
    readObj.restrictions.user.results = (readRestriction?.userWithRestrictions?.nodes ?? []).filter($5c6f8af6b02c47e8$var$isDefined).map((user)=>$5c6f8af6b02c47e8$export$dfb1e6e2e25bf061(user));
    readObj.restrictions.group.results = (readRestriction?.groupWithRestrictions?.nodes ?? []).filter($5c6f8af6b02c47e8$var$isDefined).map((group)=>$5c6f8af6b02c47e8$export$354ad6f5846ff4ac(group));
    updateObj.restrictions.user.results = (updateRestriction?.userWithRestrictions?.nodes ?? []).filter($5c6f8af6b02c47e8$var$isDefined).map((user)=>$5c6f8af6b02c47e8$export$dfb1e6e2e25bf061(user));
    updateObj.restrictions.group.results = (updateRestriction?.groupWithRestrictions?.nodes ?? []).filter($5c6f8af6b02c47e8$var$isDefined).map((group)=>$5c6f8af6b02c47e8$export$354ad6f5846ff4ac(group));
    return [
        readObj,
        updateObj
    ];
};
const $5c6f8af6b02c47e8$export$9281fb4d0a89ade8 = (restObj)=>{
    const readRestriction = restObj.find((obj)=>obj.operation === 'read');
    const updateRestriction = restObj.find((obj)=>obj.operation === 'update');
    if (readRestriction === undefined || updateRestriction === undefined) throw new $5c6f8af6b02c47e8$var$InvalidRestrictionsObjectError();
    const onlyOneUserCanRead = readRestriction.restrictions.user.results.length === 1;
    const noGroupsCanRead = readRestriction.restrictions.group.results.length === 0;
    const onlyOneUserCanUpdate = updateRestriction.restrictions.user.results.length === 1;
    const noGroupsCanUpdate = updateRestriction.restrictions.group.results.length === 0;
    return onlyOneUserCanRead && noGroupsCanRead && onlyOneUserCanUpdate && noGroupsCanUpdate;
};
module.exports["getRestrictionsTypeFromRESTObj"] = $5c6f8af6b02c47e8$export$54aeac99fafa79ed;
module.exports["getUsersAndGroupsFromRESTObj"] = $5c6f8af6b02c47e8$export$a9b84852f592ee6c;
module.exports["transformUserToREST"] = $5c6f8af6b02c47e8$export$dfb1e6e2e25bf061;
module.exports["transformGroupToREST"] = $5c6f8af6b02c47e8$export$354ad6f5846ff4ac;
module.exports["transformGraphQLQueryToRESTObj"] = $5c6f8af6b02c47e8$export$a57b08835223f9b8;
module.exports["restrictionsArePrivateToYouOnly"] = $5c6f8af6b02c47e8$export$9281fb4d0a89ade8;

});

parcelRegister("f8dGE", function(module, exports) {

var $hGc5T = parcelRequire("hGc5T");

/** Used to compose bitmasks for cloning. */ var $b042384c0682c153$var$CLONE_DEEP_FLAG = 1, $b042384c0682c153$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $b042384c0682c153$var$cloneDeep(value) {
    return $hGc5T(value, $b042384c0682c153$var$CLONE_DEEP_FLAG | $b042384c0682c153$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $b042384c0682c153$var$cloneDeep;

});

parcelRegister("c4ECQ", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $e40ae21eed558c2b$export$91111a1ebace330 = /*#__PURE__*/ function(ContentRestrictionType) {
    ContentRestrictionType["NO_RESTRICTIONS"] = "NO_RESTRICTIONS";
    ContentRestrictionType["RESTRICT_EDIT"] = "RESTRICT_EDIT";
    ContentRestrictionType["RESTRICT_VIEW"] = "RESTRICT_VIEW";
    return ContentRestrictionType;
}({});
var $e40ae21eed558c2b$export$7602248773d1f745 = /*#__PURE__*/ function(RestrictionFrom) {
    RestrictionFrom["DIRECT"] = "DIRECT";
    RestrictionFrom["MULTIPLE"] = "MULTIPLE";
    RestrictionFrom["NONE"] = "NONE";
    RestrictionFrom["PAGE_INHERITED"] = "PAGE_INHERITED";
    RestrictionFrom["SPACE"] = "SPACE";
    return RestrictionFrom;
}({});
var $e40ae21eed558c2b$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["GROUP"] = "GROUP";
    EntityType["USER"] = "USER";
    return EntityType;
}({});
var $e40ae21eed558c2b$export$af2022a36dc13b47 = /*#__PURE__*/ function(PermissionType) {
    PermissionType["EDIT"] = "EDIT";
    PermissionType["VIEW"] = "VIEW";
    return PermissionType;
}({});
var $e40ae21eed558c2b$export$efe8384a5aa2f235 = /*#__PURE__*/ function(ErrorMessageType) {
    ErrorMessageType["NO_ANCESTOR_VIEW"] = "NO_ANCESTOR_VIEW";
    ErrorMessageType["NO_SPACE_VIEW"] = "NO_SPACE_VIEW";
    ErrorMessageType["NO_SPACE_EDIT"] = "NO_SPACE_EDIT";
    return ErrorMessageType;
}({});
var $e40ae21eed558c2b$export$4ecc254c2ddad822 = /*#__PURE__*/ function(OpenDialogType) {
    OpenDialogType["INSPECT_PERMISSIONS"] = "INSPECT_PERMISSIONS";
    OpenDialogType["ACCESS_DETAILS"] = "ACCESS_DETAILS";
    OpenDialogType["RESTRICTIONS"] = "RESTRICTIONS";
    OpenDialogType["PUBLIC_LINKS_VALIDATION"] = "PUBLIC_LINKS_VALIDATION";
    return OpenDialogType;
}({});
module.exports["ContentRestrictionType"] = $e40ae21eed558c2b$export$91111a1ebace330;
module.exports["RestrictionFrom"] = $e40ae21eed558c2b$export$7602248773d1f745;
module.exports["EntityType"] = $e40ae21eed558c2b$export$8eda7e02f8f033b2;
module.exports["PermissionType"] = $e40ae21eed558c2b$export$af2022a36dc13b47;
module.exports["ErrorMessageType"] = $e40ae21eed558c2b$export$efe8384a5aa2f235;
module.exports["OpenDialogType"] = $e40ae21eed558c2b$export$4ecc254c2ddad822;

});

parcelRegister("9lU4Z", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $4fac0aee9a82e652$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
var $4fac0aee9a82e652$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["SitePermissionType"] = $4fac0aee9a82e652$export$8995abb8169b2cb8;

});

parcelRegister("c6abH", function(module, exports) {
const $39da9b0f89d8b5d0$export$e089b3c2861d2024 = '9:00';
const $39da9b0f89d8b5d0$export$c4e1e4e065ff5bd8 = 'HH:mm';
const $39da9b0f89d8b5d0$export$ec93f019c59056da = 5;
const $39da9b0f89d8b5d0$export$45c85543ba71221d = 'yyyy-MM-dd';
var $39da9b0f89d8b5d0$export$377e0d8530a6da1a = /*#__PURE__*/ function(PublishErrorFlagKeys) {
    PublishErrorFlagKeys["TITLE_IS_BLANK"] = "TITLE_IS_BLANK";
    PublishErrorFlagKeys["DUPLICATE_TITLE"] = "TITLE_EXISTS_IN_SPACE";
    return PublishErrorFlagKeys;
}({});
const $39da9b0f89d8b5d0$export$9467f27273d92816 = {
    PMF1: 'PMF1',
    PMF2: 'PMF2',
    USB1: 'USB1',
    PBWMO1: 'PBWMO1',
    PBWMO2: 'PBWMO2',
    PBWMO3: 'PBWMO3',
    PBWMO4: 'PBWMO4',
    PBWMO5: 'PBWMO5',
    PMKS1: 'PMKS1',
    PMKS2: 'PMKS2'
};
module.exports["DEFAULT_TIME"] = $39da9b0f89d8b5d0$export$e089b3c2861d2024;
module.exports["TIME_FORMAT"] = $39da9b0f89d8b5d0$export$c4e1e4e065ff5bd8;
module.exports["MINUTES_IN_FUTURE"] = $39da9b0f89d8b5d0$export$ec93f019c59056da;
module.exports["DATE_FORMAT"] = $39da9b0f89d8b5d0$export$45c85543ba71221d;
module.exports["PublishErrorFlagKeys"] = $39da9b0f89d8b5d0$export$377e0d8530a6da1a;
module.exports["SHORTCUT_KEYS"] = $39da9b0f89d8b5d0$export$9467f27273d92816;

});

parcelRegister("6pob4", function(module, exports) {

var $62JnS = parcelRequire("62JnS");

const $11195e31c84c0d05$export$7cf94392fd4ac5a6 = (0, $62JnS.usePublishModalMountStore);
const $11195e31c84c0d05$export$19811b111083a6d = (0, $62JnS.usePublishModalMountActions);
module.exports["usePublishModalMountStore"] = $11195e31c84c0d05$export$7cf94392fd4ac5a6;
module.exports["usePublishModalMountActions"] = $11195e31c84c0d05$export$19811b111083a6d;

});

parcelRegister("62JnS", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $7394919b17a3f65f$export$f2a208b9886d2628 = (0, $8s9DV.createStore)({
    name: 'PublishModalMountStore',
    initialState: {
        shouldDisplayPublishModal: false,
        initialFocusTarget: undefined,
        modalSource: undefined
    },
    actions: {
        openPublishModal: (modalSource)=>({ setState: setState })=>setState({
                    shouldDisplayPublishModal: true,
                    modalSource: modalSource
                }),
        closePublishModal: ()=>({ setState: setState })=>setState({
                    shouldDisplayPublishModal: false,
                    modalSource: undefined
                }),
        setInitialFocusTarget: (newFocusTarget)=>({ setState: setState })=>setState({
                    initialFocusTarget: newFocusTarget
                })
    }
});
const $7394919b17a3f65f$export$7cf94392fd4ac5a6 = (0, $kBr4q.createStateHook)($7394919b17a3f65f$export$f2a208b9886d2628);
const $7394919b17a3f65f$export$19811b111083a6d = (0, $kBr4q.createActionsHook)($7394919b17a3f65f$export$f2a208b9886d2628);
module.exports["usePublishModalMountStore"] = $7394919b17a3f65f$export$7cf94392fd4ac5a6;
module.exports["usePublishModalMountActions"] = $7394919b17a3f65f$export$19811b111083a6d;

});

parcelRegister("jARmo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $85mU8 = parcelRequire("85mU8");


var $e18Ro = parcelRequire("e18Ro");


var $i7cz5 = parcelRequire("i7cz5");


var $iPlb2 = parcelRequire("iPlb2");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");

const $7a91ce8e942450a2$export$ee581ede78ce7214 = ()=>{
    const clientRef = (0, $cozmU.useRef)(null);
    const nativeEmbedParams = (0, $cozmU.useMemo)(()=>{
        const isNativeEmbedEnabled = (0, $6mKj3.UNSAFE_expValNoExposure)('cc-maui-experiment', 'isEnabled', false) || (0, $9wGTI.fg)('platform_native_embeds_rollout_non_maui_experience');
        if (!isNativeEmbedEnabled || typeof window === 'undefined') return null;
        return (0, $i7cz5.maybeParseNativeEmbedParams)(new URLSearchParams(window.location.search));
    }, []);
    const isNativeEmbed = !!nativeEmbedParams;
    (0, $cozmU.useEffect)(()=>{
        if (!nativeEmbedParams) return;
        const bridge = (0, $85mU8.getBrowserBridgeAPI)();
        const { childClientId: childClientId, parentClientId: parentClientId } = nativeEmbedParams;
        const supportedFeatures = new Set([
            (0, $iPlb2.NativeEmbedCoreFeature).NotifyHostClick
        ]);
        const client = (0, $e18Ro.createNativeEmbedChildClient)(bridge, childClientId, parentClientId, supportedFeatures);
        clientRef.current = client;
        return ()=>{
            client.destroy();
            clientRef.current = null;
        };
    }, [
        nativeEmbedParams
    ]);
    const sendChildCommand = (0, $cozmU.useCallback)((command)=>{
        clientRef.current?.sendChildCommand(command);
    }, []);
    const triggerToggleFullScreen = (0, $cozmU.useCallback)(()=>{
        clientRef.current?.sendToggleFullScreen();
    }, []);
    return {
        sendChildCommand: sendChildCommand,
        triggerToggleFullScreen: triggerToggleFullScreen,
        isNativeEmbed: isNativeEmbed
    };
};
module.exports["usePageNativeEmbedClient"] = $7a91ce8e942450a2$export$ee581ede78ce7214;

});

parcelRegister("e18Ro", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");


var $haNN4 = parcelRequire("haNN4");


var $ixfCV = parcelRequire("ixfCV");


var $1r5s7 = parcelRequire("1r5s7");


var $feawE = parcelRequire("feawE");


var $iPlb2 = parcelRequire("iPlb2");


var $l9VEJ = parcelRequire("l9VEJ");


var $5CUnL = parcelRequire("5CUnL");




function $08b26111ee8a1f26$export$a0386ba7bfa2e425() {
    return {
        bind (handler) {
            const doc = (0, $haNN4.getDocument)();
            if (!doc) return ()=>{};
            const listener = ()=>{
                handler();
            };
            return (0, $cbY7C.bind)(doc, {
                type: 'click',
                listener: listener,
                options: {
                    capture: true
                }
            });
        }
    };
}
function $08b26111ee8a1f26$export$3e97a25517c2bf33(bridge, childClientId, parentClientId, supportedFeatures) {
    return new $08b26111ee8a1f26$export$fcfa04793dda7c9d(bridge, childClientId, parentClientId, new (0, $l9VEJ.SupportedFeatures)(supportedFeatures), $08b26111ee8a1f26$export$a0386ba7bfa2e425());
}
class $08b26111ee8a1f26$export$fcfa04793dda7c9d {
    /**
   * Single handler for selected-change: runs any user callback from onSelectedChange.
   * We register once so that calling onSelectedChange does not overwrite the
   * internal handler (bridges typically allow one handler per command).
   */ setupSelectedChangeListener() {
        this.bridge.on(this.childClientId, (0, $5CUnL.NativeEmbedSelectedChangeCommand), (params)=>{
            this.onSelectedChangeCallback?.({
                selected: params.selected
            });
        });
    }
    /**
   * Single handler for header-visibility-change: runs any user callback from
   * onHeaderVisibilityChange.
   */ setupHeaderVisibilityChangeListener() {
        this.bridge.on(this.childClientId, (0, $5CUnL.NativeEmbedHeaderVisibilityChangeCommand), (params)=>{
            this.onHeaderVisibilityChangeCallback?.({
                state: params.state
            });
        });
    }
    /**
   * Single handler for always-show-title-change: runs any user callback from
   * onAlwaysShowTitleChange. Registered in the constructor so the bridge handler
   * is in place before the handshake completes, preventing dropped messages.
   */ setupAlwaysShowTitleChangeListener() {
        this.bridge.on(this.childClientId, (0, $5CUnL.NativeEmbedAlwaysShowTitleChangeCommand), (params)=>{
            this.onAlwaysShowTitleChangeCallback?.({
                alwaysShowTitle: params.alwaysShowTitle
            });
        });
    }
    setupFeatureHandshakeListener() {
        this.bridge.on(this.childClientId, (0, $5CUnL.NativeEmbedFeatureHandshakeCommand), (params)=>{
            this.supportedFeatures.completeWithAgreedFeatures(new Set(params.features));
        });
    }
    setupReadContentListener() {
        if (!(0, $ixfCV.fg)('maui_remixable_page_native_embeds')) return;
        this.bridge.on(this.childClientId, (0, $1r5s7.ReadContentCommand), (params)=>{
            return this.onReadContentCallback?.(params);
        });
    }
    sendFeatureHandshake() {
        this.bridge.send((0, $5CUnL.NativeEmbedFeatureHandshakeCommand), {
            senderId: this.childClientId,
            receiverId: this.parentClientId,
            features: Array.from(this.supportedFeatures.getLocalSupportedFeatures())
        });
    }
    sendClickEventToHost() {
        this.bridge.send((0, $5CUnL.NativeEmbedClickEventCommand), {
            senderId: this.childClientId,
            receiverId: this.parentClientId
        });
    }
    onPendingReplayFeaturesResolved(features) {
        if (this.destroyed) return;
        if (!features.has((0, $iPlb2.NativeEmbedCoreFeature).NotifyHostClick)) {
            this.hasPendingClickBeforeFeatureAgreement = false;
            this.clickCaptureCleanup?.();
            return;
        }
        this.isNotifyHostClickEnabled = true;
        if (this.hasPendingClickBeforeFeatureAgreement) {
            this.hasPendingClickBeforeFeatureAgreement = false;
            this.sendClickEventToHost();
        }
    }
    /**
   * When agreed features include notify-host-click, capture click events
   * and send them to the parent so the host can select this embed.
   */ setupClickCaptureWhenEnabled() {
        const handler = ()=>{
            if (this.destroyed) return;
            if (this.isNotifyHostClickEnabled) {
                this.sendClickEventToHost();
                return;
            }
            this.hasPendingClickBeforeFeatureAgreement = true;
        };
        const unbind = this.clickCaptureBinder.bind(handler);
        this.clickCaptureCleanup = ()=>{
            unbind();
            this.clickCaptureCleanup = null;
        };
        this.supportedFeatures.getFeaturesPromise().then((features)=>{
            this.onPendingReplayFeaturesResolved(features);
        });
    }
    onNativeEmbedCommand(handler) {
        this.bridge.on(this.childClientId, (0, $5CUnL.NativeEmbedBridgeCommand), handler);
    }
    /**
   * Subscribe to selected-change events from the parent.
   * Only emitted when the SelectedChange feature is agreed in the handshake.
   */ onSelectedChange(handler) {
        this.onSelectedChangeCallback = handler;
    }
    /**
   * Subscribe to view-mode-change events from the parent.
   * Only emitted when the ViewModeChange feature is agreed in the handshake.
   */ onViewModeChange(handler) {
        this.bridge.on(this.childClientId, (0, $5CUnL.NativeEmbedViewModeChangeCommand), (params)=>handler({
                viewMode: params.viewMode
            }));
    }
    /**
   * Subscribe to header-visibility-change events from the parent.
   * Only emitted when the HeaderVisibilityChange feature is agreed in the handshake.
   * Calling this multiple times replaces the previous handler.
   */ onHeaderVisibilityChange(handler) {
        this.onHeaderVisibilityChangeCallback = handler;
    }
    /**
   * Subscribe to always-show-title-change events from the parent.
   * Emitted when the user toggles the always-show-title option.
   */ onAlwaysShowTitleChange(handler) {
        this.onAlwaysShowTitleChangeCallback = handler;
    }
    /**
   * Subscribe to read-content events from the parent.
   * Emitted when the user reads the content of the embed like when remixing the embed.
   */ onReadContent(handler) {
        this.onReadContentCallback = handler;
    }
    sendChildCommand(command) {
        this.bridge.send((0, $5CUnL.NativeEmbedChildBridgeCommand), {
            senderId: this.childClientId,
            receiverId: this.parentClientId,
            ...command
        });
    }
    /**
   * Request the host to toggle the full-screen dialog.
   * Only effective when the ToggleFullScreen feature is agreed in the handshake.
   */ sendToggleFullScreen() {
        this.bridge.send((0, $5CUnL.NativeEmbedToggleFullScreenCommand), {
            senderId: this.childClientId,
            receiverId: this.parentClientId
        });
    }
    /**
   * Request the host to resize the embed container to the given pixel dimensions.
   *
   * When `options.local` is `true` the host treats the request as an
   * ephemeral, in-memory size override and MUST NOT persist the dimensions
   * to the ADF node parameters.
   * Only effective when the RequestResize feature is agreed in the handshake.
   */ sendRequestResize(width, height, options) {
        this.bridge.send((0, $5CUnL.NativeEmbedRequestResizeCommand), {
            senderId: this.childClientId,
            receiverId: this.parentClientId,
            width: width,
            height: height,
            local: options?.local
        });
    }
    /**
   * Signal the host that this embed's content is fully rendered and visible.
   *
   * Call this once the initial data has loaded and the first meaningful frame
   * has been painted. The host uses it to dismiss its loading overlay, hiding
   * any internal loading state that would otherwise flash between the iframe
   * `load` event and this first render.
   */ sendContentReady() {
        this.bridge.send((0, $5CUnL.NativeEmbedContentReadyCommand), {
            senderId: this.childClientId,
            receiverId: this.parentClientId
        });
    }
    nativeEmbedFeatures() {
        return this.supportedFeatures.getFeaturesPromise();
    }
    /**
   * Removes click capture listeners.
   * Call when the child client is no longer needed.
   */ destroy() {
        this.destroyed = true;
        this.isNotifyHostClickEnabled = false;
        this.hasPendingClickBeforeFeatureAgreement = false;
        this.clickCaptureCleanup?.();
        this.bridge.teardown((0, $feawE.client)(this.childClientId));
    }
    constructor(bridge, childClientId, parentClientId, supportedFeatures, clickCaptureBinder){
        this.bridge = void 0;
        this.childClientId = void 0;
        this.parentClientId = void 0;
        this.supportedFeatures = void 0;
        this.clickCaptureBinder = void 0;
        this.clickCaptureCleanup = null;
        this.destroyed = false;
        this.isNotifyHostClickEnabled = false;
        this.hasPendingClickBeforeFeatureAgreement = false;
        this.onSelectedChangeCallback = null;
        this.onHeaderVisibilityChangeCallback = null;
        this.onAlwaysShowTitleChangeCallback = null;
        this.onReadContentCallback = null;
        this.bridge = bridge;
        this.childClientId = childClientId;
        this.parentClientId = parentClientId;
        this.supportedFeatures = supportedFeatures;
        this.clickCaptureBinder = clickCaptureBinder;
        this.setupFeatureHandshakeListener();
        this.setupClickCaptureWhenEnabled();
        this.setupSelectedChangeListener();
        this.setupHeaderVisibilityChangeListener();
        this.setupAlwaysShowTitleChangeListener();
        this.setupReadContentListener();
        // Register as ready before sending the handshake so the bridge can deliver the message.
        this.bridge.ready((0, $feawE.client)(this.childClientId));
        this.sendFeatureHandshake();
    }
}
module.exports["createNativeEmbedChildClient"] = $08b26111ee8a1f26$export$3e97a25517c2bf33;

});

parcelRegister("l9VEJ", function(module, exports) {
class $e6f821d864c1ec53$export$1d19c2585ceee427 {
    setLocalSupportedFeatures(features) {
        this.localSupportedFeatures = features;
    }
    getLocalSupportedFeatures() {
        return this.localSupportedFeatures;
    }
    getFeaturesPromise() {
        return this.deferred.promise;
    }
    /**
   * Completes the handshake with the agreed feature set (call from host after computing intersection, or from child when host responds).
   */ completeWithAgreedFeatures(agreed) {
        this.deferred.resolve(agreed);
    }
    constructor(localSupportedFeatures = new Set()){
        this.localSupportedFeatures = void 0;
        this.deferred = void 0;
        this.localSupportedFeatures = localSupportedFeatures;
        this.deferred = {};
        this.deferred.promise = new Promise((resolve)=>{
            this.deferred.resolve = resolve;
        });
    }
}
module.exports["SupportedFeatures"] = $e6f821d864c1ec53$export$1d19c2585ceee427;

});

parcelRegister("5CUnL", function(module, exports) {

var $dSoGR = parcelRequire("dSoGR");

const $7569910c569caaf1$export$6fa96f9e61f5bb99 = (0, $dSoGR.createCommand)('native-embed-command');
const $7569910c569caaf1$export$1ee701ffff9b762 = (0, $dSoGR.createCommand)('native-embed-child-command');
const $7569910c569caaf1$export$2eb498d58c22456f = (0, $dSoGR.createCommand)('native-embed-feature-handshake-command');
const $7569910c569caaf1$export$91600996d49f0b0a = (0, $dSoGR.createCommand)('native-embed-selected-change-command');
const $7569910c569caaf1$export$57a04bf1e92410f2 = (0, $dSoGR.createCommand)('native-embed-view-mode-change-command');
const $7569910c569caaf1$export$939d45358a26a835 = (0, $dSoGR.createCommand)('native-embed-header-visibility-change-command');
const $7569910c569caaf1$export$aa53f645e6beb7d2 = (0, $dSoGR.createCommand)('native-embed-request-delete-command');
const $7569910c569caaf1$export$478f68dcfd854b21 = (0, $dSoGR.createCommand)('native-embed-click-event-command');
const $7569910c569caaf1$export$e1f68fdfa2b498fc = (0, $dSoGR.createCommand)('native-embed-always-show-title-change-command');
const $7569910c569caaf1$export$66deedc198182b99 = (0, $dSoGR.createCommand)('native-embed-toggle-full-screen-command');
const $7569910c569caaf1$export$604bbec515403568 = (0, $dSoGR.createCommand)('native-embed-request-resize-command');
const $7569910c569caaf1$export$e4b4c117b71df581 = (0, $dSoGR.createCommand)('native-embed-content-ready-command');
module.exports["NativeEmbedBridgeCommand"] = $7569910c569caaf1$export$6fa96f9e61f5bb99;
module.exports["NativeEmbedChildBridgeCommand"] = $7569910c569caaf1$export$1ee701ffff9b762;
module.exports["NativeEmbedFeatureHandshakeCommand"] = $7569910c569caaf1$export$2eb498d58c22456f;
module.exports["NativeEmbedSelectedChangeCommand"] = $7569910c569caaf1$export$91600996d49f0b0a;
module.exports["NativeEmbedViewModeChangeCommand"] = $7569910c569caaf1$export$57a04bf1e92410f2;
module.exports["NativeEmbedHeaderVisibilityChangeCommand"] = $7569910c569caaf1$export$939d45358a26a835;
module.exports["NativeEmbedRequestDeleteCommand"] = $7569910c569caaf1$export$aa53f645e6beb7d2;
module.exports["NativeEmbedClickEventCommand"] = $7569910c569caaf1$export$478f68dcfd854b21;
module.exports["NativeEmbedAlwaysShowTitleChangeCommand"] = $7569910c569caaf1$export$e1f68fdfa2b498fc;
module.exports["NativeEmbedToggleFullScreenCommand"] = $7569910c569caaf1$export$66deedc198182b99;
module.exports["NativeEmbedRequestResizeCommand"] = $7569910c569caaf1$export$604bbec515403568;
module.exports["NativeEmbedContentReadyCommand"] = $7569910c569caaf1$export$e4b4c117b71df581;

});

parcelRegister("i7cz5", function(module, exports) {
const $1b581ea1c80d4d76$var$ROVO_RECEIVER_ID_DATA_ATTR = 'data-rovo-receiver-id';
const $1b581ea1c80d4d76$var$ROVO_CHILD_ID_QUERY_PARAM_KEY = 'nativeEmbedChildId';
const $1b581ea1c80d4d76$var$ROVO_PARENT_ID_QUERY_PARAM_KEY = 'nativeEmbedParentId';
function $1b581ea1c80d4d76$export$d5ca420e0d8fc785(bridgeParams) {
    const { embedClientId: embedClientId, hostClientId: hostClientId } = bridgeParams;
    return {
        clientId: embedClientId,
        getQueryParams: ()=>({
                [$1b581ea1c80d4d76$var$ROVO_CHILD_ID_QUERY_PARAM_KEY]: embedClientId,
                [$1b581ea1c80d4d76$var$ROVO_PARENT_ID_QUERY_PARAM_KEY]: hostClientId
            }),
        getIframeDataAttributes: ()=>({
                [$1b581ea1c80d4d76$var$ROVO_RECEIVER_ID_DATA_ATTR]: embedClientId
            })
    };
}
function $1b581ea1c80d4d76$export$a5e60906cc8da6df(params) {
    const id = params.get($1b581ea1c80d4d76$var$ROVO_CHILD_ID_QUERY_PARAM_KEY);
    const parentId = params.get($1b581ea1c80d4d76$var$ROVO_PARENT_ID_QUERY_PARAM_KEY);
    if (!id || id.length === 0 || !parentId || parentId.length === 0) return undefined;
    return {
        childClientId: id,
        parentClientId: parentId
    };
}
module.exports["createNativeEmbedClientIframeIntegrator"] = $1b581ea1c80d4d76$export$d5ca420e0d8fc785;
module.exports["maybeParseNativeEmbedParams"] = $1b581ea1c80d4d76$export$a5e60906cc8da6df;

});

parcelRegister("40pD8", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $512bc11813ea6463$var$ClassificationModalContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    isClassificationModalOpen: false
});
$512bc11813ea6463$var$ClassificationModalContext.displayName = 'ClassificationModalContext';
const $512bc11813ea6463$export$ed3f7b1d90b3e679 = /*#__PURE__*/ (0, $cozmU.createContext)({
    setIsClassificationModalOpen: ()=>{}
});
$512bc11813ea6463$export$ed3f7b1d90b3e679.displayName = 'ClassificationModalDispatchContext';
const $512bc11813ea6463$export$dd63fef46bf243c2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children } = t0;
    const [isClassificationModalOpen, setIsClassificationModalOpen] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== isClassificationModalOpen) {
        t1 = {
            isClassificationModalOpen: isClassificationModalOpen
        };
        $[0] = isClassificationModalOpen;
        $[1] = t1;
    } else t1 = $[1];
    const contextValue = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            setIsClassificationModalOpen: (value)=>setIsClassificationModalOpen(value)
        };
        $[2] = t2;
    } else t2 = $[2];
    const dispatchContextValue = t2;
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($512bc11813ea6463$export$ed3f7b1d90b3e679.Provider, {
            value: dispatchContextValue
        }, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== contextValue || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($512bc11813ea6463$var$ClassificationModalContext.Provider, {
            value: contextValue
        }, t3);
        $[5] = contextValue;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ children: children })=>{
    const [isClassificationModalOpen, setIsClassificationModalOpen] = (0, $cozmU.useState)(false);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            isClassificationModalOpen: isClassificationModalOpen
        }), [
        isClassificationModalOpen
    ]);
    const dispatchContextValue = (0, $cozmU.useMemo)(()=>({
            setIsClassificationModalOpen: (value)=>setIsClassificationModalOpen(value)
        }), [
        setIsClassificationModalOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($512bc11813ea6463$var$ClassificationModalContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($512bc11813ea6463$export$ed3f7b1d90b3e679.Provider, {
        value: dispatchContextValue
    }, children));
};
const $512bc11813ea6463$export$3e27c86e4ac00950 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($512bc11813ea6463$var$ClassificationModalContext);
} : ()=>{
    return (0, $cozmU.useContext)($512bc11813ea6463$var$ClassificationModalContext);
};
const $512bc11813ea6463$export$6c62639a7ca504f5 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($512bc11813ea6463$export$ed3f7b1d90b3e679);
} : ()=>{
    return (0, $cozmU.useContext)($512bc11813ea6463$export$ed3f7b1d90b3e679);
};
module.exports["ClassificationModalContextProvider"] = $512bc11813ea6463$export$dd63fef46bf243c2;
module.exports["useClassificationModalContext"] = $512bc11813ea6463$export$3e27c86e4ac00950;
module.exports["useClassificationModalDispatchContext"] = $512bc11813ea6463$export$6c62639a7ca504f5;

});

parcelRegister("88Nzy", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $2ZJmt = parcelRequire("2ZJmt");


var $bHWAG = parcelRequire("bHWAG");

const $86935ecd4293d578$var$i18n = (0, $kSwu1.defineMessages)({
    lockoutMessage: {
        id: "pdf-print-utils.navigation-lockout-message",
        defaultMessage: "You have unsaved changes. Please save before printing."
    }
});
function $86935ecd4293d578$var$tryGetAtlToken() {
    try {
        return (0, $bHWAG.getLiveAtlToken)();
    } catch  {
        return null;
    }
}
async function $86935ecd4293d578$export$94dac1f6a6cc2b5b(maxTries = 12, interval = 250) {
    let tries = 0;
    for(;;){
        const t = $86935ecd4293d578$var$tryGetAtlToken();
        if (t) return t;
        tries += 1;
        if (tries >= maxTries) throw new Error('atlToken not available');
        await new Promise((r)=>setTimeout(r, interval));
    }
}
function $86935ecd4293d578$export$36438d970303153({ enabled: enabled, shouldBlockPrint: shouldBlockPrint, onPrintBlocked: onPrintBlocked }) {
    const attachedRef = (0, $cozmU.useRef)(false);
    const shouldBlockPrintRef = (0, $cozmU.useRef)(shouldBlockPrint);
    const [showLockout, setShowLockout] = (0, $cozmU.useState)(false);
    const intl = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        shouldBlockPrintRef.current = shouldBlockPrint;
    }, [
        shouldBlockPrint
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!enabled) return;
        if (attachedRef.current) return;
        attachedRef.current = true;
        if ((0, $bHWAG.isInsideIframe)()) return;
        const handler = async (e)=>{
            const key = typeof e.key === 'string' ? e.key : '';
            const isMac = /Mac|iPod|iPhone|iPad/.test(navigator.platform);
            const isPrintCombo = isMac ? e.metaKey && (key === 'p' || key === 'P' // mac: only cmd+P
            ) : e.ctrlKey && (key === 'p' || key === 'P'); // windows/linux: only ctrl+P
            if (!isPrintCombo) return;
            const shouldBlock = shouldBlockPrintRef.current ? shouldBlockPrintRef.current() : false;
            if (shouldBlock) {
                e.preventDefault();
                e.stopImmediatePropagation();
                e.stopPropagation();
                setShowLockout(true);
                onPrintBlocked?.();
                return;
            }
            if (!(0, $bHWAG.isPageViewRoute)(window.location.pathname)) return;
            const pageId = (0, $bHWAG.getPageId)(window.location.pathname);
            if (!pageId) return;
            let atlToken = $86935ecd4293d578$var$tryGetAtlToken();
            if (!atlToken) try {
                atlToken = await $86935ecd4293d578$export$94dac1f6a6cc2b5b();
            } catch  {
                return;
            }
            if (!atlToken || !pageId) return;
            e.preventDefault();
            e.stopImmediatePropagation();
            e.stopPropagation();
            const params = new URLSearchParams({
                pageId: pageId,
                atl_token: atlToken,
                showPdfBanner: 'true'
            });
            const url = `${window.location.origin}/wiki/spaces/flyingpdf/pdfpageexport.action?${params.toString()}`;
            window.location.assign(url);
        };
        const opts = {
            capture: true,
            passive: false
        };
        window.addEventListener('keydown', handler, opts);
        document.addEventListener('keydown', handler, opts);
        return ()=>{
            window.removeEventListener('keydown', handler, opts);
            document.removeEventListener('keydown', handler, opts);
            attachedRef.current = false;
        };
    }, [
        enabled,
        onPrintBlocked
    ]);
    const lockoutComponent = showLockout ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2ZJmt.NavigationLockout), {
        message: intl.formatMessage($86935ecd4293d578$var$i18n.lockoutMessage)
    }) : null;
    return lockoutComponent;
}
module.exports["usePrintIntercept"] = $86935ecd4293d578$export$36438d970303153;

});

parcelRegister("2ZJmt", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $caa92877b3f564cd$export$e2ddff3a4a4594f0 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "gjoA6",
    name: "NavigationLockout",
    loader: async ()=>(await (parcelRequire("ki0qk"))).NavigationLockout
});
module.exports["NavigationLockout"] = $caa92877b3f564cd$export$e2ddff3a4a4594f0;

});

parcelRegister("ki0qk", function(module, exports) {

let $ec55d139e213cdf9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ec55d139e213cdf9$var$load("hwiu3").then(()=>parcelRequire('jUOfU'));

});

parcelRegister("bHWAG", function(module, exports) {
function $661369be983dfb69$export$7b6f372ddaf80f4a() {
    // in SSR or non-browser contexts there is no document
    if (typeof document === 'undefined') return null;
    // try the meta tag first: <meta name="ajs-atl-token" content="...">
    // use a typed querySelector so .content is available on HTMLMetaElement
    const metaToken = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector('meta[name="ajs-atl-token"]')?.content ?? // fallback to attribute read in case DOM typings differ
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector('meta[name="ajs-atl-token"]')?.getAttribute('content');
    if (metaToken) return metaToken;
    // fallback to cookies if readable in this environment
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const m = document.cookie.match(/(?:^|;\s*)(atl\.xsrf\.token|atlassian\.account\.xsrf\.token)=([^;]+)/);
    // group 2 is the token value
    return m ? m[2] : null;
}
function $661369be983dfb69$export$2ce6e339a89daf7a(path) {
    const m = path.match(/\/pages\/(\d+)/);
    return m ? m[1] : null;
}
function $661369be983dfb69$export$1ae14b4842b49ade(path) {
    // Manual pathname check instead of using VIEW_PAGE.match() to avoid circular dependency
    // Using @confluence/named-routes -> @confluence/view-page-common creates a circular dependency:
    // @confluence/content-renderer -> @confluence/pdf-export -> @confluence/view-page-common -> @confluence/content-renderer
    // Pattern matches: /spaces/:spaceKey/pages/:contentId(digits)/:contentSlug?
    return path.match(/\/spaces\/[^/]+\/pages\/\d+/) !== null;
}
function $661369be983dfb69$export$bc4e1d0ebda8ad2c() {
    try {
        return window.self !== window.top;
    } catch (e) {
        // accessing window.top can throw in some cross-origin scenarios
        return true;
    }
}
const $661369be983dfb69$export$d8536155e595e20f = (imagePath)=>{
    const img = new Image();
    img.src = imagePath;
};
module.exports["getLiveAtlToken"] = $661369be983dfb69$export$7b6f372ddaf80f4a;
module.exports["getPageId"] = $661369be983dfb69$export$2ce6e339a89daf7a;
module.exports["isPageViewRoute"] = $661369be983dfb69$export$1ae14b4842b49ade;
module.exports["isInsideIframe"] = $661369be983dfb69$export$bc4e1d0ebda8ad2c;
module.exports["preloadImage"] = $661369be983dfb69$export$d8536155e595e20f;

});

parcelRegister("dA1Sn", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");

const $18ccf8477934fc9e$export$2a8604960d7d23d9 = 30000;
const $18ccf8477934fc9e$var$useTwoStageHydration = (name, enabled)=>{
    const fullCycleOutput = window.__FULLCYCLE__?.[name];
    const isNoFullCycleOutput = (0, $6mKj3.expValEquals)('platform_editor_editor_ssr_streaming', 'isEnabled', true) ? fullCycleOutput === undefined : !fullCycleOutput;
    const isNoSSR = !window.__SSR_RENDERED__;
    // Rely on a normal hydration/rendering flow when it's a transition or there's no full cycle output
    // or when experience is not hydratable
    const [hydrated, setHydrated] = (0, $cozmU.useState)(isNoSSR || isNoFullCycleOutput || !window.__HYDRATABLE__ || !enabled);
    (0, $cozmU.useEffect)(()=>{
        setHydrated(true);
        const cleanup = ()=>{
            delete window.__FULLCYCLE__?.[name];
        };
        // Arbitrary 30s CLEANUP_TIMEOUT to allow for the element to be rendered before removal
        // to not force an unecessary re-render or flash of blank content, even in slowest cases
        setTimeout(cleanup, $18ccf8477934fc9e$export$2a8604960d7d23d9);
        return cleanup;
    }, [
        name
    ]);
    return {
        hydrated: hydrated,
        fullCycleOutput: fullCycleOutput
    };
};
const $18ccf8477934fc9e$export$ca5d80b93e3e21b2 = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals -- the saveFullCycleOutput() only runs in the browser
    const nodesForPartialHydration = document.querySelectorAll('[data-fullcycle-name]');
    if (nodesForPartialHydration.length > 0) window.__FULLCYCLE__ = Array.from(nodesForPartialHydration).reduce((acc, node)=>{
        acc[node.dataset.fullcycleName] = node.innerHTML;
        return acc;
    }, {});
};
const $18ccf8477934fc9e$export$137b13ff1789fa49 = (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { style: style, name: name, children: children, enabled: t1, ssrPlaceholder: t2 } = t0;
    const enabled = t1 === undefined ? false : t1;
    const ssrPlaceholder = t2 === undefined ? false : t2;
    const { hydrated: hydrated, fullCycleOutput: fullCycleOutput } = $18ccf8477934fc9e$var$useTwoStageHydration(name, enabled);
    if ((0, $6mKj3.expValEquals)("cc_fix_hydration_ttvc", "isEnabled", true)) {
        if (!enabled) return children;
        if (hydrated) {
            let t3;
            if ($[0] !== name || $[1] !== ssrPlaceholder) {
                t3 = ssrPlaceholder ? {
                    "data-ssr-placeholder": name,
                    "data-ssr-placeholder-replace": name
                } : {};
                $[0] = name;
                $[1] = ssrPlaceholder;
                $[2] = t3;
            } else t3 = $[2];
            let t4;
            if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
                t4 = {
                    position: "relative",
                    height: "100%",
                    width: "100%"
                };
                $[3] = t4;
            } else t4 = $[3];
            let t5;
            if ($[4] !== children || $[5] !== name || $[6] !== t3) {
                t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    "data-testid": "two-stage-hydration",
                    "data-fullcycle-name": name,
                    ...t3,
                    style: t4
                }, children);
                $[4] = children;
                $[5] = name;
                $[6] = t3;
                $[7] = t5;
            } else t5 = $[7];
            return t5;
        }
        const innerHTML = fullCycleOutput;
        let t3;
        if ($[8] !== name || $[9] !== ssrPlaceholder) {
            t3 = ssrPlaceholder ? {
                "data-ssr-placeholder": name,
                "data-ssr-placeholder-replace": name
            } : {};
            $[8] = name;
            $[9] = ssrPlaceholder;
            $[10] = t3;
        } else t3 = $[10];
        let t4;
        if ($[11] !== innerHTML) {
            t4 = {
                __html: innerHTML
            };
            $[11] = innerHTML;
            $[12] = t4;
        } else t4 = $[12];
        let t5;
        if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
            t5 = {
                position: "relative",
                height: "100%",
                width: "100%"
            };
            $[13] = t5;
        } else t5 = $[13];
        let t6;
        if ($[14] !== name || $[15] !== t3 || $[16] !== t4) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "data-testid": "two-stage-hydration",
                "data-fullcycle-name": name,
                ...t3,
                dangerouslySetInnerHTML: t4,
                style: t5
            });
            $[14] = name;
            $[15] = t3;
            $[16] = t4;
            $[17] = t6;
        } else t6 = $[17];
        return t6;
    }
    if (!enabled || hydrated) return children;
    const innerHTML_0 = fullCycleOutput;
    let t3;
    if ($[22] !== innerHTML_0) {
        t3 = {
            __html: innerHTML_0
        };
        $[22] = innerHTML_0;
        $[23] = t3;
    } else t3 = $[23];
    let t4;
    if ($[24] !== name || $[25] !== style || $[26] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: style,
            "data-testid": "two-stage-hydration",
            "data-fullcycle-name": name,
            dangerouslySetInnerHTML: t3
        });
        $[24] = name;
        $[25] = style;
        $[26] = t3;
        $[27] = t4;
    } else t4 = $[27];
    return t4;
};
const $18ccf8477934fc9e$export$b6db8e1e111c3550 = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { name: name, style: style, children: children, enabled: t1, ssrPlaceholder: t2 } = t0;
    const enabled = t1 === undefined ? true : t1;
    const ssrPlaceholder = t2 === undefined ? false : t2;
    let t3;
    if ($[0] !== children || $[1] !== enabled || $[2] !== name || $[3] !== ssrPlaceholder || $[4] !== style) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($18ccf8477934fc9e$export$137b13ff1789fa49, {
            name: name,
            style: style,
            enabled: enabled,
            ssrPlaceholder: ssrPlaceholder
        }, children);
        $[0] = children;
        $[1] = enabled;
        $[2] = name;
        $[3] = ssrPlaceholder;
        $[4] = style;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
};
module.exports["saveFullCycleOutput"] = $18ccf8477934fc9e$export$ca5d80b93e3e21b2;
module.exports["TwoStageHydration"] = $18ccf8477934fc9e$export$b6db8e1e111c3550;

});

parcelRegister("8HrX3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");


var $dPJCf = parcelRequire("dPJCf");

const $a7f86182a225a9f3$var$useFocusedTaskIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('focusedTaskId');
const $a7f86182a225a9f3$var$TaskScrollComponentInner = ()=>{
    const focusedTaskId = $a7f86182a225a9f3$var$useFocusedTaskIdQueryParam();
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    if (focusedTaskId) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const taskElement = document.querySelector(`[data-task-local-id="${focusedTaskId}"]`);
        if (taskElement) {
            taskElement.scrollIntoView({
                behavior: 'instant',
                inline: 'center',
                block: 'center'
            });
            // Remove the query param immediately after task scroll is complete
            setQueryParams({
                focusedTaskId: undefined
            });
        }
    }
    return null;
};
const $a7f86182a225a9f3$export$d9ea3940454347d1 = ()=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_focused-task-scroll')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a7f86182a225a9f3$var$TaskScrollComponentInner, null);
};
module.exports["TaskScrollComponent"] = $a7f86182a225a9f3$export$d9ea3940454347d1;

});

parcelRegister("1AJi3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kQqCc = parcelRequire("kQqCc");


var $dPoYT = parcelRequire("dPoYT");


var $93Gae = parcelRequire("93Gae");


var $2bR8c = parcelRequire("2bR8c");


var $jln20 = parcelRequire("jln20");

const $ca70225f28efd254$export$a81c3fee0d63dde7 = ()=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { panelId: panelId } = rightSidebarContext.getCurrent() || {};
    const { mode: mode, isMiniModalAvailable: isMiniModalAvailable, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, openConversationAssistantUIMode: openConversationAssistantUIMode } = (0, $93Gae.useRovoExperienceAPIStore)();
    const isConversationAssistantSidebarActive = panelId === (0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_ID);
    const sidebarApi = (0, $2bR8c.useCreateRovoExperienceSidebarController)();
    const toggleConversationAssistant = (0, $cozmU.useCallback)((openChatMode = 'sidebar')=>{
        toggleConversationAssistantUIMode({
            targetMode: openChatMode === 'mini-modal' && isMiniModalAvailable ? (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL : (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR,
            sidebarApi: sidebarApi
        });
    }, [
        toggleConversationAssistantUIMode,
        sidebarApi,
        isMiniModalAvailable
    ]);
    const openConversationAssistant = (0, $cozmU.useCallback)((openChatMode = 'sidebar')=>{
        openConversationAssistantUIMode({
            targetMode: openChatMode === 'mini-modal' && isMiniModalAvailable ? (0, $dPoYT.ConversationAssistantUIModes).MINI_MODAL : (0, $dPoYT.ConversationAssistantUIModes).SIDEBAR,
            sidebarApi: sidebarApi
        });
    }, [
        openConversationAssistantUIMode,
        sidebarApi,
        isMiniModalAvailable
    ]);
    return (0, $cozmU.useMemo)(()=>({
            mode: mode,
            toggleConversationAssistant: toggleConversationAssistant,
            openConversationAssistant: openConversationAssistant,
            isConversationAssistantSidebarActive: isConversationAssistantSidebarActive
        }), [
        mode,
        toggleConversationAssistant,
        openConversationAssistant,
        isConversationAssistantSidebarActive
    ]);
};
module.exports["useToggleConversationAssistant"] = $ca70225f28efd254$export$a81c3fee0d63dde7;

});

parcelRegister("kQqCc", function(module, exports) {
// Exported through entry point /src/utils.
/**
 * Used as the identifier for container on the consumer side.
 *
 * Example:
 * ```
 * <div id={CONVERSATION_ASSISTANT_CONTAINER_ID}>
 *  <ConversationAssistant />
 * </div>
 * ```
 */ const $d52db76b74818184$export$dffb4ed44e20ea9a = 'ai-mate-container';
const $d52db76b74818184$export$64aee74ba59709e5 = 439; // px
const $d52db76b74818184$export$1c07393c5bb1bc27 = 439; // px
const $d52db76b74818184$export$aa3478deee7adbeb = 350; // px
const $d52db76b74818184$export$21e515a86cd1733b = 'Chat';
const $d52db76b74818184$export$e942bf04e23ff966 = 'Rovo';
module.exports["CONVERSATION_ASSISTANT_CONTAINER_ID"] = $d52db76b74818184$export$dffb4ed44e20ea9a;
module.exports["CONVERSATION_ASSISTANT_CONTAINER_WIDTH"] = $d52db76b74818184$export$64aee74ba59709e5;
module.exports["CONVERSATION_ASSISTANT_MINIMUM_HEIGHT"] = $d52db76b74818184$export$aa3478deee7adbeb;
module.exports["CONVERSATION_ASSISTANT_BRAND_NAME"] = $d52db76b74818184$export$21e515a86cd1733b;
module.exports["DEFAULT_PAGE_TITLE"] = $d52db76b74818184$export$e942bf04e23ff966;

});

parcelRegister("93Gae", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $6UvXN = parcelRequire("6UvXN");

const $081573ec09156b80$var$initialState = {
    mode: undefined,
    isMiniModalAvailable: false,
    isSidebarAvailable: true,
    isFullScreenModalAvailable: false,
    initialPrompt: undefined,
    openWithChatHistory: false,
    wasAutoOpened: false
};
const $081573ec09156b80$var$store = (0, $8s9DV.createStore)({
    name: 'rovoExperienceAPIStore',
    initialState: $081573ec09156b80$var$initialState,
    actions: {
        // created for resetting store during tests
        reset: ()=>({ setState: setState })=>{
                setState($081573ec09156b80$var$initialState);
            },
        setMode: (mode)=>({ setState: setState })=>{
                setState({
                    mode: mode,
                    wasAutoOpened: false
                });
            },
        clearInitialPrompt: ()=>({ setState: setState })=>{
                setState({
                    initialPrompt: undefined
                });
            },
        setOpenWithChatHistory: (openWithChatHistory)=>({ setState: setState })=>{
                setState({
                    openWithChatHistory: openWithChatHistory
                });
            },
        setWasAutoOpened: (wasAutoOpened)=>({ setState: setState })=>{
                setState({
                    wasAutoOpened: wasAutoOpened
                });
            },
        toggleConversationAssistantUIMode: ({ targetMode: targetMode, sidebarApi: sidebarApi, initialPrompt: initialPrompt })=>({ getState: getState, setState: setState })=>{
                const { mode: currentMode } = getState();
                // If no target mode is provided, close any open modes
                if (!targetMode) {
                    setState({
                        mode: undefined,
                        wasAutoOpened: false
                    });
                    if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                    return;
                }
                // Toggle mode functionality
                if (currentMode === targetMode) switch(targetMode){
                    case (0, $6UvXN.ConversationAssistantUIModes).SIDEBAR:
                        /* Handles the edge case where the sidebar space is taken by another panel
              which results in currentMode = 'sidebar' && sidebarApi.isSidebarOpen() = false */ if (!sidebarApi.isSidebarOpen()) {
                            sidebarApi.openSidebar();
                            return;
                        }
                        sidebarApi.closeSidebar();
                        setState({
                            mode: undefined,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $6UvXN.ConversationAssistantUIModes).MINI_MODAL:
                        setState({
                            mode: undefined,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $6UvXN.ConversationAssistantUIModes).FULL_SCREEN_MODAL:
                        setState({
                            mode: undefined,
                            wasAutoOpened: false
                        });
                        return;
                    default:
                        return;
                }
                // Switch mode functionality
                switch(targetMode){
                    case (0, $6UvXN.ConversationAssistantUIModes).SIDEBAR:
                        if (!sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                        setState({
                            mode: (0, $6UvXN.ConversationAssistantUIModes).SIDEBAR,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $6UvXN.ConversationAssistantUIModes).MINI_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        setState({
                            mode: (0, $6UvXN.ConversationAssistantUIModes).MINI_MODAL,
                            initialPrompt: initialPrompt,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $6UvXN.ConversationAssistantUIModes).FULL_SCREEN_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        setState({
                            mode: (0, $6UvXN.ConversationAssistantUIModes).FULL_SCREEN_MODAL,
                            initialPrompt: initialPrompt,
                            wasAutoOpened: false
                        });
                        return;
                }
            },
        openConversationAssistantUIMode: ({ targetMode: targetMode, sidebarApi: sidebarApi, initialPrompt: initialPrompt })=>({ getState: getState, setState: setState })=>{
                const { mode: currentMode } = getState();
                // Already in the desired mode — ensure the sidebar is actually
                // visible (it may have been displaced by another panel) but
                // otherwise treat this as a no-op.
                if (currentMode === targetMode) {
                    if (targetMode === (0, $6UvXN.ConversationAssistantUIModes).SIDEBAR && !sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                    return;
                }
                // Switch to the target mode
                switch(targetMode){
                    case (0, $6UvXN.ConversationAssistantUIModes).SIDEBAR:
                        if (!sidebarApi.isSidebarOpen()) sidebarApi.openSidebar();
                        setState({
                            mode: (0, $6UvXN.ConversationAssistantUIModes).SIDEBAR,
                            wasAutoOpened: false
                        });
                        return;
                    case (0, $6UvXN.ConversationAssistantUIModes).MINI_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        // wasAutoOpened is managed by the dedicated setWasAutoOpened action and reset on close/toggle/setMode.
                        setState({
                            mode: (0, $6UvXN.ConversationAssistantUIModes).MINI_MODAL,
                            initialPrompt: initialPrompt
                        });
                        return;
                    case (0, $6UvXN.ConversationAssistantUIModes).FULL_SCREEN_MODAL:
                        if (sidebarApi.isSidebarOpen()) sidebarApi.closeSidebar();
                        setState({
                            mode: (0, $6UvXN.ConversationAssistantUIModes).FULL_SCREEN_MODAL,
                            initialPrompt: initialPrompt
                        });
                        return;
                }
            },
        setIsMiniModalAvailable: (isMiniModalAvailable)=>({ setState: setState })=>{
                setState({
                    isMiniModalAvailable: isMiniModalAvailable
                });
            },
        setIsSidebarAvailable: (isSidebarAvailable)=>({ setState: setState })=>{
                setState({
                    isSidebarAvailable: isSidebarAvailable
                });
            },
        setIsFullScreenModalAvailable: (isFullScreenModalAvailable)=>({ setState: setState })=>{
                setState({
                    isFullScreenModalAvailable: isFullScreenModalAvailable
                });
            }
    }
});
const $081573ec09156b80$var$useStore = (0, $kBr4q.createHook)($081573ec09156b80$var$store);
const $081573ec09156b80$export$37440b51449f7ac6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(17);
    const [t0, t1] = $081573ec09156b80$var$useStore();
    const { mode: mode, isMiniModalAvailable: isMiniModalAvailable, isSidebarAvailable: isSidebarAvailable, isFullScreenModalAvailable: isFullScreenModalAvailable, initialPrompt: initialPrompt, openWithChatHistory: openWithChatHistory, wasAutoOpened: wasAutoOpened } = t0;
    const { reset: reset, clearInitialPrompt: clearInitialPrompt, setOpenWithChatHistory: setOpenWithChatHistory, setWasAutoOpened: setWasAutoOpened, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, openConversationAssistantUIMode: openConversationAssistantUIMode, setIsMiniModalAvailable: setIsMiniModalAvailable, setIsSidebarAvailable: setIsSidebarAvailable, setIsFullScreenModalAvailable: setIsFullScreenModalAvailable } = t1;
    let t2;
    if ($[0] !== clearInitialPrompt || $[1] !== initialPrompt || $[2] !== isFullScreenModalAvailable || $[3] !== isMiniModalAvailable || $[4] !== isSidebarAvailable || $[5] !== mode || $[6] !== openConversationAssistantUIMode || $[7] !== openWithChatHistory || $[8] !== reset || $[9] !== setIsFullScreenModalAvailable || $[10] !== setIsMiniModalAvailable || $[11] !== setIsSidebarAvailable || $[12] !== setOpenWithChatHistory || $[13] !== setWasAutoOpened || $[14] !== toggleConversationAssistantUIMode || $[15] !== wasAutoOpened) {
        t2 = {
            mode: mode,
            initialPrompt: initialPrompt,
            openWithChatHistory: openWithChatHistory,
            wasAutoOpened: wasAutoOpened,
            reset: reset,
            clearInitialPrompt: clearInitialPrompt,
            setOpenWithChatHistory: setOpenWithChatHistory,
            setWasAutoOpened: setWasAutoOpened,
            toggleConversationAssistantUIMode: toggleConversationAssistantUIMode,
            openConversationAssistantUIMode: openConversationAssistantUIMode,
            setIsMiniModalAvailable: setIsMiniModalAvailable,
            setIsSidebarAvailable: setIsSidebarAvailable,
            setIsFullScreenModalAvailable: setIsFullScreenModalAvailable,
            isMiniModalAvailable: isMiniModalAvailable,
            isSidebarAvailable: isSidebarAvailable,
            isFullScreenModalAvailable: isFullScreenModalAvailable
        };
        $[0] = clearInitialPrompt;
        $[1] = initialPrompt;
        $[2] = isFullScreenModalAvailable;
        $[3] = isMiniModalAvailable;
        $[4] = isSidebarAvailable;
        $[5] = mode;
        $[6] = openConversationAssistantUIMode;
        $[7] = openWithChatHistory;
        $[8] = reset;
        $[9] = setIsFullScreenModalAvailable;
        $[10] = setIsMiniModalAvailable;
        $[11] = setIsSidebarAvailable;
        $[12] = setOpenWithChatHistory;
        $[13] = setWasAutoOpened;
        $[14] = toggleConversationAssistantUIMode;
        $[15] = wasAutoOpened;
        $[16] = t2;
    } else t2 = $[16];
    return t2;
} : ()=>{
    const [{ mode: mode, isMiniModalAvailable: isMiniModalAvailable, isSidebarAvailable: isSidebarAvailable, isFullScreenModalAvailable: isFullScreenModalAvailable, initialPrompt: initialPrompt, openWithChatHistory: openWithChatHistory, wasAutoOpened: wasAutoOpened }, { reset: reset, clearInitialPrompt: clearInitialPrompt, setOpenWithChatHistory: setOpenWithChatHistory, setWasAutoOpened: setWasAutoOpened, toggleConversationAssistantUIMode: toggleConversationAssistantUIMode, openConversationAssistantUIMode: openConversationAssistantUIMode, setIsMiniModalAvailable: setIsMiniModalAvailable, setIsSidebarAvailable: setIsSidebarAvailable, setIsFullScreenModalAvailable: setIsFullScreenModalAvailable }] = $081573ec09156b80$var$useStore();
    return {
        mode: mode,
        initialPrompt: initialPrompt,
        openWithChatHistory: openWithChatHistory,
        wasAutoOpened: wasAutoOpened,
        reset: reset,
        clearInitialPrompt: clearInitialPrompt,
        setOpenWithChatHistory: setOpenWithChatHistory,
        setWasAutoOpened: setWasAutoOpened,
        toggleConversationAssistantUIMode: toggleConversationAssistantUIMode,
        openConversationAssistantUIMode: openConversationAssistantUIMode,
        setIsMiniModalAvailable: setIsMiniModalAvailable,
        setIsSidebarAvailable: setIsSidebarAvailable,
        setIsFullScreenModalAvailable: setIsFullScreenModalAvailable,
        isMiniModalAvailable: isMiniModalAvailable,
        isSidebarAvailable: isSidebarAvailable,
        isFullScreenModalAvailable: isFullScreenModalAvailable
    };
};
const $081573ec09156b80$export$66cf76b7e04da11f = (0, $kBr4q.createActionsHook)($081573ec09156b80$var$store);
module.exports["useRovoExperienceAPIStore"] = $081573ec09156b80$export$37440b51449f7ac6;

});

parcelRegister("6UvXN", function(module, exports) {
/* Duplicates ConversationAssistantUIModes from conversation-assistant package
   to avoid circular dependencies. Any changes here should be mirrored in
	 platform/packages/ai-mate/conversation-assistant/src/types.ts
*/ const $7c0481f515a47ac9$export$bc36ebf73899a71d = {
    SIDEBAR: 'sidebar',
    MINI_MODAL: 'mini-modal',
    FULL_SCREEN_MODAL: 'full-screen-modal'
};
module.exports["ConversationAssistantUIModes"] = $7c0481f515a47ac9$export$bc36ebf73899a71d;

});

parcelRegister("2bR8c", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kQqCc = parcelRequire("kQqCc");


var $jln20 = parcelRequire("jln20");

const $da7293b7c8deb7d1$export$c27f18f8bab3d8b9 = ()=>{
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const { panelId: panelId } = rightSidebarContext.getCurrent() || {};
    const isConversationAssistantSidebarActive = panelId === (0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_ID);
    return (0, $cozmU.useMemo)(()=>{
        return {
            isSidebarOpen: ()=>{
                return isConversationAssistantSidebarActive;
            },
            openSidebar: ()=>{
                rightSidebarContext.open((0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_ID), (0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_WIDTH));
            },
            closeSidebar: ()=>{
                if (isConversationAssistantSidebarActive) rightSidebarContext.close((0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_ID));
            }
        };
    }, [
        isConversationAssistantSidebarActive,
        rightSidebarContext
    ]);
};
module.exports["useCreateRovoExperienceSidebarController"] = $da7293b7c8deb7d1$export$c27f18f8bab3d8b9;

});

parcelRegister("fGDv8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $ixfCV = parcelRequire("ixfCV");


var $b8pma = parcelRequire("b8pma");


var $7Myh3 = parcelRequire("7Myh3");

const $11be68f9ade9fe63$var$conversationAssistantLazy = (0, $cozmU.lazy)(()=>(0, $7Myh3.importConversationAssistant)().then((module)=>({
            default: module.ConversationAssistant
        })));
const $11be68f9ade9fe63$var$createLoadingComponent = ()=>{
    return (0, $b8pma.default)({
        name: 'LoadingConversationAssistantBundle'
    });
};
const $11be68f9ade9fe63$var$conversationAssistantLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "hDEDK",
    name: "conversationAssistantLoadable",
    loader: ()=>(0, $7Myh3.importConversationAssistant)().then((m)=>m.ConversationAssistant),
    loading: $11be68f9ade9fe63$var$createLoadingComponent
});
const $11be68f9ade9fe63$var$AsyncConversationAssistant = Object.assign((props)=>{
    if ((0, $ixfCV.fg)('aimate_conversation_assistant_async_loading')) return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: $11be68f9ade9fe63$var$createLoadingComponent()
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($11be68f9ade9fe63$var$conversationAssistantLazy, props));
    if (props.useChildrenAsLoadingFallback && props.overridingChildren && (0, $ixfCV.fg)('ai_agent_sessions_warming_cache')) return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: props.overridingChildren
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($11be68f9ade9fe63$var$conversationAssistantLazy, props));
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($11be68f9ade9fe63$var$conversationAssistantLoadable, props);
}, {
    preload: ()=>{
        // React.lazy has no preload API, so warm the shared chunk directly on the R19
        // lazy path; keep react-loadable's preload (which also marks it loaded) otherwise.
        if ((0, $ixfCV.fg)('aimate_conversation_assistant_async_loading')) (0, $7Myh3.importConversationAssistant)();
        else $11be68f9ade9fe63$var$conversationAssistantLoadable.preload();
    }
});
var $11be68f9ade9fe63$export$2e2bcd8739ae039 = $11be68f9ade9fe63$var$AsyncConversationAssistant;
module.exports["default"] = $11be68f9ade9fe63$export$2e2bcd8739ae039;

});

parcelRegister("7Myh3", function(module, exports) {
// Single-source dynamic import factory for the conversation-assistant chunk.
// Mirrors the chunk-name used by the live lazy()/loadable() boundaries so preload
// and the live boundaries share the same chunk identity.

const $9d88e303fe02f351$export$24a887167476720c = ()=>(parcelRequire("bABMv"));
module.exports["importConversationAssistant"] = $9d88e303fe02f351$export$24a887167476720c;

});

parcelRegister("bABMv", function(module, exports) {

let $87005d181f4711e6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $87005d181f4711e6$var$load("7TnhR"),
    $87005d181f4711e6$var$load("hUbK8"),
    $87005d181f4711e6$var$load("gwGEC"),
    $87005d181f4711e6$var$load("l5nRU"),
    $87005d181f4711e6$var$load("bx5S2"),
    $87005d181f4711e6$var$load("7fsAO"),
    $87005d181f4711e6$var$load("1tkCm"),
    $87005d181f4711e6$var$load("ipIDQ"),
    $87005d181f4711e6$var$load("7eTC9"),
    $87005d181f4711e6$var$load("agv3Q"),
    $87005d181f4711e6$var$load("garBx"),
    $87005d181f4711e6$var$load("2CrXe"),
    $87005d181f4711e6$var$load("beMmd"),
    $87005d181f4711e6$var$load("l4MHo"),
    $87005d181f4711e6$var$load("k97np"),
    $87005d181f4711e6$var$load("3cN9G"),
    $87005d181f4711e6$var$load("j3345"),
    $87005d181f4711e6$var$load("2J2X1"),
    $87005d181f4711e6$var$load("iBQFK"),
    $87005d181f4711e6$var$load("jgxNN"),
    $87005d181f4711e6$var$load("e7Dyr"),
    $87005d181f4711e6$var$load("ig9dh"),
    $87005d181f4711e6$var$load("hA8hA"),
    $87005d181f4711e6$var$load("6cD8V"),
    $87005d181f4711e6$var$load("2NEDA"),
    $87005d181f4711e6$var$load("dxcsb"),
    $87005d181f4711e6$var$load("gbejv"),
    $87005d181f4711e6$var$load("GD9EA"),
    $87005d181f4711e6$var$load("2hLAI"),
    $87005d181f4711e6$var$load("dCilB"),
    $87005d181f4711e6$var$load("1T8H1"),
    $87005d181f4711e6$var$load("fyKFO"),
    $87005d181f4711e6$var$load("d9sg7"),
    $87005d181f4711e6$var$load("l0N35"),
    $87005d181f4711e6$var$load("gnocL"),
    $87005d181f4711e6$var$load("Kj0I8"),
    $87005d181f4711e6$var$load("5xnun"),
    $87005d181f4711e6$var$load("1Zk4x"),
    $87005d181f4711e6$var$load("8exG0"),
    $87005d181f4711e6$var$load("kT6dz"),
    $87005d181f4711e6$var$load("jZMUd"),
    $87005d181f4711e6$var$load("iUXaE"),
    $87005d181f4711e6$var$load("lTkx9"),
    $87005d181f4711e6$var$load("6wr18"),
    $87005d181f4711e6$var$load("bpmjT"),
    $87005d181f4711e6$var$load("hZVEi"),
    $87005d181f4711e6$var$load("ekVH8"),
    $87005d181f4711e6$var$load("ffEVr"),
    $87005d181f4711e6$var$load("eCXJR"),
    $87005d181f4711e6$var$load("1VTX2"),
    $87005d181f4711e6$var$load("ddvkk"),
    $87005d181f4711e6$var$load("3upHR"),
    $87005d181f4711e6$var$load("hhss7"),
    $87005d181f4711e6$var$load("Wowvf"),
    $87005d181f4711e6$var$load("eRhBr"),
    $87005d181f4711e6$var$load("hZ2FX"),
    $87005d181f4711e6$var$load("cKDij"),
    $87005d181f4711e6$var$load("7EorR"),
    $87005d181f4711e6$var$load("ce05o")
]).then(()=>parcelRequire('iuVKP'));

});

parcelRegister("aXWtB", function(module, exports) {

var $b8pma = parcelRequire("b8pma");


var $jmjWc = parcelRequire("jmjWc");

const $35c87ab817b10787$var$createLoadingComponent = ()=>{
    return (0, $b8pma.default)({
        name: 'LoadingConfluenceConversationAssistantBundle'
    });
};

const $35c87ab817b10787$export$3ca68d91b1a1bca2 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "HQN7e",
    name: "ConfluenceConversationAssistant",
    loader: async ()=>(await (parcelRequire("jghA2"))).ConfluenceConversationAssistant,
    loading: $35c87ab817b10787$var$createLoadingComponent
});
module.exports["ConfluenceConversationAssistant"] = $35c87ab817b10787$export$3ca68d91b1a1bca2;

});

parcelRegister("jghA2", function(module, exports) {

let $e05d260853dfbe47$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e05d260853dfbe47$var$load("iUXaE"),
    $e05d260853dfbe47$var$load("lTkx9"),
    $e05d260853dfbe47$var$load("k1meQ"),
    $e05d260853dfbe47$var$load("aoJPa")
]).then(()=>parcelRequire('kaQDe'));

});

parcelRegister("hQaiX", function(module, exports) {

let $cfcf49499479cab2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cfcf49499479cab2$var$load("6wr18"),
    $cfcf49499479cab2$var$load("ffEVr"),
    $cfcf49499479cab2$var$load("iBQFK"),
    $cfcf49499479cab2$var$load("hZVEi"),
    $cfcf49499479cab2$var$load("k90dx"),
    $cfcf49499479cab2$var$load("RMzu0"),
    $cfcf49499479cab2$var$load("dgWVQ"),
    $cfcf49499479cab2$var$load("amIJr"),
    $cfcf49499479cab2$var$load("4ZzjZ"),
    $cfcf49499479cab2$var$load("5tJYH"),
    $cfcf49499479cab2$var$load("huBNP"),
    $cfcf49499479cab2$var$load("3lk6X"),
    $cfcf49499479cab2$var$load("26c2h"),
    $cfcf49499479cab2$var$load("9BBvG"),
    $cfcf49499479cab2$var$load("jZMUd"),
    $cfcf49499479cab2$var$load("cYv6T"),
    $cfcf49499479cab2$var$load("3cJjP"),
    $cfcf49499479cab2$var$load("11yNG"),
    $cfcf49499479cab2$var$load("gQYVn"),
    $cfcf49499479cab2$var$load("9RGBF"),
    $cfcf49499479cab2$var$load("2iL13"),
    $cfcf49499479cab2$var$load("cpTbC"),
    $cfcf49499479cab2$var$load("fhT77"),
    $cfcf49499479cab2$var$load("jvUhP"),
    $cfcf49499479cab2$var$load("7sOKp"),
    $cfcf49499479cab2$var$load("7Ysw6"),
    $cfcf49499479cab2$var$load("3xL2F"),
    $cfcf49499479cab2$var$load("kMyku"),
    $cfcf49499479cab2$var$load("hG1ar"),
    $cfcf49499479cab2$var$load("kUBpV"),
    $cfcf49499479cab2$var$load("eNHPW"),
    $cfcf49499479cab2$var$load("2GC7K"),
    $cfcf49499479cab2$var$load("cklhl"),
    $cfcf49499479cab2$var$load("bLIUJ"),
    $cfcf49499479cab2$var$load("kobFT"),
    $cfcf49499479cab2$var$load("701fE"),
    $cfcf49499479cab2$var$load("8qNIV"),
    $cfcf49499479cab2$var$load("gpIIT"),
    $cfcf49499479cab2$var$load("cHAvQ"),
    $cfcf49499479cab2$var$load("5d2zd"),
    $cfcf49499479cab2$var$load("frCen"),
    $cfcf49499479cab2$var$load("2MOvO"),
    $cfcf49499479cab2$var$load("407Jg"),
    $cfcf49499479cab2$var$load("3BeCY"),
    $cfcf49499479cab2$var$load("hZzel"),
    $cfcf49499479cab2$var$load("2zKe1"),
    $cfcf49499479cab2$var$load("hUZCM"),
    $cfcf49499479cab2$var$load("7zQG2"),
    $cfcf49499479cab2$var$load("1HPRy"),
    $cfcf49499479cab2$var$load("bFpW7")
]).then(()=>parcelRequire('l8Gbi'));

});

parcelRegister("l7WpP", function(module, exports) {

let $f617908b9a5636e5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f617908b9a5636e5$var$load("inTWi").then(()=>parcelRequire('9qb5A'));

});

parcelRegister("amg3z", function(module, exports) {
/**
 * Patterns for detecting integration links
 */ const $25b5f997878fea60$var$LINK_PATTERNS = {
    slack: /https?:\/\/[a-z0-9-]+\.slack\.com\/.*/i,
    // Microsoft integration: Teams + SharePoint/OneDrive + Outlook
    microsoft: /https?:\/\/(teams\.microsoft\.com|outlook\.office\.com|outlook\.live\.com|[a-z0-9-]+\.sharepoint\.com|1drv\.ms|onedrive\.live\.com)\/.*/i
};
/**
 * Type guard to check if a node has attrs
 */ const $25b5f997878fea60$var$hasAttrs = (node)=>{
    return node && typeof node === 'object' && 'attrs' in node;
};
/**
 * Type guard to check if a node has marks
 */ const $25b5f997878fea60$var$hasMarks = (node)=>{
    return node && typeof node === 'object' && 'marks' in node && Array.isArray(node.marks);
};
/**
 * Extract all links from ADF content iteratively using a queue
 * Uses 'any' type for node parameter because ADF child nodes have different types
 * than DocNode (text, inlineCard, blockCard, etc.)
 */ const $25b5f997878fea60$var$extractLinksFromAdf = (rootNode)=>{
    if (!rootNode || typeof rootNode !== 'object') return [];
    const links = [];
    const queue = [
        rootNode
    ];
    while(queue.length > 0){
        const node = queue.shift();
        if (!node || typeof node !== 'object') continue;
        // Check if current node is a text node with link marks, or plain-text URLs.
        if (node.type === 'text') {
            const linkMark = $25b5f997878fea60$var$hasMarks(node) ? node.marks.find((mark)=>mark.type === 'link' && mark.attrs?.href) : undefined;
            if (linkMark) links.push(linkMark.attrs.href);
            else if (typeof node.text === 'string') {
                const urlMatches = node.text.match(/https?:\/\/[^\s)\]}>,"']+/gi);
                if (urlMatches) links.push(...urlMatches);
            }
        }
        // Check for smart card nodes (inlineCard, blockCard, embedCard)
        if (node.type === 'inlineCard' || node.type === 'blockCard' || node.type === 'embedCard') {
            if ($25b5f997878fea60$var$hasAttrs(node) && node.attrs.url) links.push(node.attrs.url);
        }
        // Add child nodes to queue
        if (node.content && Array.isArray(node.content)) queue.push(...node.content);
    }
    return links;
};
const $25b5f997878fea60$export$d060694f7c9f2b3a = (slice)=>{
    if (!slice || !slice.content) return [];
    const links = [];
    const queue = [];
    // Add all top-level nodes from the slice to the queue
    slice.content.forEach((node)=>{
        queue.push(node);
    });
    // Process nodes using BFS (same logic as extractLinksFromAdf)
    while(queue.length > 0){
        const node = queue.shift();
        if (!node) continue;
        // Check for text nodes with link marks, or plain-text URLs.
        if (node.type.name === 'text') {
            const linkMark = node.marks?.find((mark)=>mark.type.name === 'link' && mark.attrs?.href);
            if (linkMark) links.push(linkMark.attrs.href);
            else if (typeof node.text === 'string') {
                // Some paste flows provide plain text without a link mark.
                // Best-effort: pull out URLs from the text.
                const urlMatches = node.text.match(/https?:\/\/[^\s)\]}>,"']+/gi);
                if (urlMatches) links.push(...urlMatches);
            }
        }
        // Check for smart card nodes (inlineCard, blockCard, embedCard)
        const nodeName = node.type.name;
        if (nodeName === 'inlineCard' || nodeName === 'blockCard' || nodeName === 'embedCard') {
            if (node.attrs?.url) links.push(node.attrs.url);
        }
        // Add child nodes to queue
        if (node.content) // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
        node.content.forEach((childNode)=>{
            queue.push(childNode);
        });
    }
    return links;
};
/**
 * Determine the type of a link based on URL patterns
 */ const $25b5f997878fea60$var$classifyLink = (url)=>{
    for (const [type, pattern] of Object.entries($25b5f997878fea60$var$LINK_PATTERNS)){
        if (pattern.test(url)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return type;
    }
    return 'other';
};
const $25b5f997878fea60$export$a533cc92068f97c3 = (urls)=>{
    const uniqueUrls = new Set(urls);
    const result = [];
    for (const url of uniqueUrls){
        const type = $25b5f997878fea60$var$classifyLink(url);
        if (type !== 'other') result.push({
            url: url,
            type: type
        });
    }
    return result;
};
const $25b5f997878fea60$export$c3604445bd868cb2 = (adfValue)=>{
    const allLinks = $25b5f997878fea60$var$extractLinksFromAdf(adfValue);
    return $25b5f997878fea60$export$a533cc92068f97c3(allLinks);
};
const $25b5f997878fea60$export$f6b1cd37615f37cd = (links)=>{
    if (links.length === 0) return null;
    // Build a set of available types for O(1) lookup
    const availableTypes = new Set(links.map((link)=>link.type));
    // Priority order: Slack > Microsoft
    const priority = [
        'slack',
        'microsoft'
    ];
    for (const type of priority){
        if (availableTypes.has(type)) return type;
    }
    return links[0].type;
};
const $25b5f997878fea60$export$196e8d4958925ab2 = (links)=>{
    const uniqueTypes = new Set();
    for (const link of links)if (link.type !== 'other') uniqueTypes.add(link.type);
    // Return in priority order: Slack, Microsoft
    const priority = [
        'slack',
        'microsoft'
    ];
    return priority.filter((type)=>uniqueTypes.has(type));
};
const $25b5f997878fea60$export$6888e547c88384f6 = (currentLinks, initialLinkTypes)=>{
    const currentTypes = $25b5f997878fea60$export$196e8d4958925ab2(currentLinks);
    const initialSet = new Set(initialLinkTypes);
    // Filter to only include types that weren't in initial content
    return currentTypes.filter((type)=>!initialSet.has(type));
};
module.exports["extractLinksFromSlice"] = $25b5f997878fea60$export$d060694f7c9f2b3a;
module.exports["getDetectedLinksFromUrls"] = $25b5f997878fea60$export$a533cc92068f97c3;
module.exports["detectIntegrationLinks"] = $25b5f997878fea60$export$c3604445bd868cb2;

});

parcelRegister("eWgCZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");


var $amg3z = parcelRequire("amg3z");

const $f85b39b36f718f58$export$8d9836a43c68a9f6 = ()=>{
    const [detectedLinks, setDetectedLinks] = (0, $cozmU.useState)([]);
    const [newLinkTypes, setNewLinkTypes] = (0, $cozmU.useState)([]);
    const [newLinks, setNewLinks] = (0, $cozmU.useState)([]);
    const [shouldShowSpotlight, setShouldShowSpotlight] = (0, $cozmU.useState)(false);
    // Track what URLs existed when editor opened (initial state)
    // This enables URL-level delta detection
    const initialUrlsRef = (0, $cozmU.useRef)(new Set());
    /**
   * Set the initial content when editor opens
   * Call with existing ADF for edit mode, or null for new content
   */ const setInitialContent = (0, $cozmU.useCallback)((adfValue)=>{
        if (!(0, $9wGTI.fg)('link-paste-spotlight-experiment-gate')) return;
        const initialLinks = (0, $amg3z.detectIntegrationLinks)(adfValue);
        const initialUrls = new Set(initialLinks.map((link)=>link.url));
        initialUrlsRef.current = initialUrls;
    }, []);
    /**
   * Handle save event - detect NEW links (URL-level) compared to initial content
   * Key change: If user adds a second Slack link, Slack is still "newly eligible"
   */ const handleSave = (0, $cozmU.useCallback)((adfValue)=>{
        if (!(0, $9wGTI.fg)('link-paste-spotlight-experiment-gate')) return;
        // Detect all integration links in saved content
        const currentLinks = (0, $amg3z.detectIntegrationLinks)(adfValue);
        // Get initial URLs
        const initialUrls = initialUrlsRef.current;
        // Find newly added URLs (not in initial set)
        const newlyAddedLinks = currentLinks.filter((link)=>!initialUrls.has(link.url));
        if (newlyAddedLinks.length > 0) {
            // Get unique types from newly added links
            const newTypes = [
                ...new Set(newlyAddedLinks.map((link)=>link.type))
            ];
            setDetectedLinks(currentLinks);
            setNewLinks(newlyAddedLinks);
            setNewLinkTypes(newTypes);
            setShouldShowSpotlight(true);
        }
    }, []);
    /**
   * Handle pasted integration links - detect NEW links (URL-level) compared to initial content
   * More efficient than handleSave as it only processes pasted links, not entire document
   */ const handlePastedLinks = (0, $cozmU.useCallback)((links)=>{
        if (links.length === 0 || !(0, $9wGTI.fg)('link-paste-spotlight-experiment-gate')) return;
        // Get initial URLs
        const initialUrls = initialUrlsRef.current;
        // Find newly added URLs (not in initial set) - DELTA LOGIC
        const newlyAddedLinks = links.filter((link)=>!initialUrls.has(link.url));
        if (newlyAddedLinks.length > 0) {
            // Get unique types from newly added links
            const newTypes = [
                ...new Set(newlyAddedLinks.map((link)=>link.type))
            ];
            setDetectedLinks(newlyAddedLinks);
            setNewLinks(newlyAddedLinks);
            setNewLinkTypes(newTypes);
            setShouldShowSpotlight(true);
        }
    }, []);
    /**
   * Close the spotlight
   */ const closeSpotlight = (0, $cozmU.useCallback)(()=>{
        setShouldShowSpotlight(false);
        setDetectedLinks([]);
        setNewLinkTypes([]);
        setNewLinks([]);
    }, []);
    return {
        detectedLinks: detectedLinks,
        newLinkTypes: newLinkTypes,
        newLinks: newLinks,
        shouldShowSpotlight: shouldShowSpotlight,
        handleSave: handleSave,
        handlePastedLinks: handlePastedLinks,
        closeSpotlight: closeSpotlight,
        setInitialContent: setInitialContent
    };
};
module.exports["useIntegrationLinkSpotlight"] = $f85b39b36f718f58$export$8d9836a43c68a9f6;

});

parcelRegister("fvl6L", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $VUk2d = parcelRequire("VUk2d");


var $4wqa6 = parcelRequire("4wqa6");


var $3qHV3 = parcelRequire("3qHV3");


var $1jt54 = parcelRequire("1jt54");


var $j2n0Y = parcelRequire("j2n0Y");


var $kcIQr = parcelRequire("kcIQr");


var $ep3mz = parcelRequire("ep3mz");


var $kqIWy = parcelRequire("kqIWy");


var $1ApN2 = parcelRequire("1ApN2");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $2pqKH = parcelRequire("2pqKH");


var $br2TZ = parcelRequire("br2TZ");


var $kFfmO = parcelRequire("kFfmO");


var $kOnoQ = parcelRequire("kOnoQ");

// Gated hook wrappers — defined at module level so React's rules of hooks are
// satisfied (hook call order is stable) while avoiding the work when the gate is off.
const $3e66a0beddd545cb$var$useInviteServiceGated = (0, $VUk2d.functionUnionWithCondition)(()=>(0, $9wGTI.fg)('twcg-853-3p-in-1p-link-gate'), (service)=>(0, $1ApN2.useService)(service), ()=>null);
const $3e66a0beddd545cb$var$usePageSpaceKeyGated = (0, $VUk2d.functionUnionWithCondition)(()=>(0, $9wGTI.fg)('twcg-853-3p-in-1p-link-gate'), (0, $ep3mz.usePageSpaceKey), ()=>[
        undefined
    ]);
const $3e66a0beddd545cb$var$useSpaceDetailGated = (0, $VUk2d.functionUnionWithCondition)(()=>(0, $9wGTI.fg)('twcg-853-3p-in-1p-link-gate'), (0, $kqIWy.useSpaceDetail), ()=>({
        data: undefined,
        loading: false
    }));
/**
 * Classify a list of URLs into slack/mailto buckets, excluding any that appear
 * in `startingLinks`.
 */ const $3e66a0beddd545cb$var$classifyNewLinks = (urls, startingLinks)=>{
    const pastedSlackLinks = [];
    const pastedMailtoLinks = [];
    for (const link of urls){
        if (startingLinks.has(link)) continue;
        if ((0, $2pqKH.isSlackLink)(link)) pastedSlackLinks.push(link);
        else if ((0, $2pqKH.isMailtoLink)(link)) pastedMailtoLinks.push(link);
    }
    return {
        pastedSlackLinks: pastedSlackLinks,
        pastedMailtoLinks: pastedMailtoLinks
    };
};
const $3e66a0beddd545cb$export$3f425f5138bde373 = (flags)=>{
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const { userId: userId, orgId: orgId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [spaceKey] = $3e66a0beddd545cb$var$usePageSpaceKeyGated();
    const { data: spaceDetail } = $3e66a0beddd545cb$var$useSpaceDetailGated(spaceKey);
    const invite = $3e66a0beddd545cb$var$useInviteServiceGated((0, $4wqa6.invite));
    const inviteFlagSourcesRef = (0, $cozmU.useRef)(new Map());
    // Traits are fetched lazily on the first paste that reaches triggerSpotlight,
    // then cached for the lifetime of the hook. This avoids an eager TAP network
    // request on every editor mount when no 3P link is ever pasted.
    // null = not yet fetched; {} = fetched (possibly empty on error/no traits)
    const invite3pTraitsCacheRef = (0, $cozmU.useRef)(null);
    const invite3pTraitsFetchingRef = (0, $cozmU.useRef)(false);
    // Track what URLs existed when editor opened (initial state)
    // This enables URL-level delta detection
    const initialLinksRef = (0, $cozmU.useRef)(new Set());
    /**
   * Set the initial content when editor opens
   */ const setInitialLinks = (0, $cozmU.useCallback)((adfValue)=>{
        if (!((0, $9wGTI.fg)('twcg-853-3p-in-1p-aa-test-gate') || (0, $9wGTI.fg)('twcg-853-3p-in-1p-link-gate')) || !adfValue) return;
        const initialLinks = (0, $2pqKH.getAllLinks)(adfValue);
        initialLinksRef.current = initialLinks;
    }, []);
    const fireAnalytics = (0, $cozmU.useCallback)(({ pastedSlackLinks: pastedSlackLinks, pastedMailtoLinks: pastedMailtoLinks })=>{
        // 3P in 1P exp eligibility check flow
        if (pastedSlackLinks.length === 0 && pastedMailtoLinks.length === 0 || !(0, $9wGTI.fg)('twcg-853-3p-in-1p-aa-test-gate')) return;
        // Exposure fired here
        const twcg3pIn1pAATestCohort = (0, $6mKj3.expValEquals)('twcg-853-3p-in-1p-aa-test', 'isEnabled', true) ? 'variation' : 'control';
        createEvent({
            type: 'sendUIEvent',
            data: {
                action: 'pasted',
                actionSubject: '3PLink',
                actionSubjectId: 'editorPaste',
                source: 'inviteOnLinkInsert',
                attributes: {
                    slackLinks: pastedSlackLinks,
                    channelIds: pastedSlackLinks.map((0, $2pqKH.getChannelIdFromSlackLink)),
                    mailtoLinkCount: pastedMailtoLinks.length,
                    orgId: orgId,
                    accountId: userId,
                    twcg3pIn1pAATestCohort: twcg3pIn1pAATestCohort
                }
            }
        }).fire();
    }, [
        createEvent,
        userId,
        orgId
    ]);
    const triggerSpotlight = (0, $cozmU.useCallback)(async (pastedSlackLinks, pastedMailtoLinks)=>{
        if (!(0, $9wGTI.fg)('twcg-853-3p-in-1p-link-gate')) return;
        const fireSpotlightError = (stage)=>{
            createEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'inviteOn3rdPartyLinkSpotlight',
                    source: 'inviteOnThirdPartyLinkFlag',
                    attributes: {
                        stage: stage,
                        product: 'confluence',
                        growthInitiative: 'virality'
                    },
                    tags: [
                        'measurement',
                        'growth',
                        'hasCustomAttributes'
                    ]
                }
            }).fire();
        };
        const hasThirdPartyInviteCandidates = pastedSlackLinks.length > 0 || pastedMailtoLinks.length > 0;
        if (hasThirdPartyInviteCandidates && flags && invite && userId && (0, $9wGTI.fg)('twcg-853-3p-in-1p-link-gate')) {
            // ── TRAIT LAYER: mirrors IntegrationLinkSpotlightComponent LAYER 2 & 3 ──
            // LAYER 3: Per-type trait eligibility (stage + hard-dismiss check).
            // Traits are fetched lazily on the first paste to avoid an eager mount-time
            // TAP network request. If a fetch is already in flight, skip this paste and
            // let the next save/paste attempt use the cached result.
            if (invite3pTraitsCacheRef.current === null) {
                if (invite3pTraitsFetchingRef.current) return;
                invite3pTraitsFetchingRef.current = true;
                try {
                    invite3pTraitsCacheRef.current = await (0, $br2TZ.fetchIntegrationTraits)(userId ?? '');
                } catch  {
                    invite3pTraitsCacheRef.current = {}; // fail open — treat as stage 0 eligible
                    fireSpotlightError('traitFetch');
                } finally{
                    invite3pTraitsFetchingRef.current = false;
                }
            }
            const traits = invite3pTraitsCacheRef.current;
            const storedDismissState = (0, $kFfmO.check3pIn1pDismissState)();
            const filteredSlackLinks = (0, $kOnoQ.is3pInviteEligible)('slack', traits, storedDismissState) ? pastedSlackLinks : [];
            const filteredMailtoLinks = (0, $kOnoQ.is3pInviteEligible)('mailto', traits, storedDismissState) ? pastedMailtoLinks : [];
            if (filteredSlackLinks.length === 0 && filteredMailtoLinks.length === 0) return; // Both types trait-gated out — skip API calls entirely
            // ── END TRAIT LAYER ──
            const slackEligibilityUrls = Array.from(new Set(filteredSlackLinks));
            const pastedEmails = filteredMailtoLinks.flatMap((0, $2pqKH.getEmailsFromMailtoLink));
            try {
                const [piSettled, emailSettled] = await Promise.allSettled([
                    slackEligibilityUrls.length > 0 ? Promise.allSettled(slackEligibilityUrls.map((url)=>(0, $j2n0Y.fetchPiSlackLinkEligibleUsers)(url, 'confluence'))) : Promise.resolve([]),
                    pastedEmails.length > 0 ? (0, $1jt54.fetchEligibleEmails)(pastedEmails, 'confluence') : Promise.resolve({})
                ]);
                const piSettledResults = piSettled.status === 'fulfilled' ? piSettled.value : [];
                const piEligibilityResults = piSettledResults.flatMap((r)=>r.status === 'fulfilled' ? [
                        r.value
                    ] : []);
                const hadSlackError = piSettled.status === 'rejected' || piSettledResults.some((r)=>r.status === 'rejected');
                if (hadSlackError) fireSpotlightError('slackEligibility');
                const eligibleEmailsResults = emailSettled.status === 'fulfilled' ? emailSettled.value : {};
                if (emailSettled.status === 'rejected') fireSpotlightError('emailEligibility');
                const eligibleEmailCount = eligibleEmailsResults.eligibleEmails?.length ?? 0;
                const eligibleSlackCount = piEligibilityResults.reduce((acc, result)=>acc + (result?.eligibleUsers?.length ?? 0), 0);
                const hasInviteEligibleUsers = eligibleEmailCount + eligibleSlackCount > 0;
                if (hasInviteEligibleUsers) createEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'eligibilityChecked',
                        actionSubject: 'inviteOn3rdPartyLinkExperiment',
                        source: 'inviteOnThirdPartyLinkFlag',
                        attributes: {
                            eligibleEmailCount: eligibleEmailCount,
                            eligibleSlackCount: eligibleSlackCount,
                            twcg8533pIn1pLinkCohort: (0, $6mKj3.expVal)('twcg-853-3p-in-1p-link', 'cohort', 'not-enrolled')
                        }
                    }
                }).fire();
                if (hasInviteEligibleUsers && (0, $6mKj3.expValEquals)('twcg-853-3p-in-1p-link', 'cohort', 'variation')) {
                    const slackDismissType = (0, $kOnoQ.getInviteOn3pDismissType)('slack', storedDismissState, traits);
                    const mailtoDismissType = (0, $kOnoQ.getInviteOn3pDismissType)('mailto', storedDismissState, traits);
                    // Adapt Confluence FlagsStateContainer to the renderer contract expected by showInviteFlags.
                    const showFlag = (args)=>{
                        flags.showFlag({
                            id: args.id,
                            customComponent: ()=>args.render({
                                    onDismiss: (flagId, dismissMethod)=>{
                                        const key = String(flagId);
                                        const flagInfo = inviteFlagSourcesRef.current.get(key);
                                        const linkType = flagInfo?.source ?? 'mailto';
                                        const currentDismissType = flagInfo?.dismissType ?? 0;
                                        inviteFlagSourcesRef.current.delete(key);
                                        const dismissState = dismissMethod === 'dontShowAgainButton' ? 3 : currentDismissType + 1;
                                        const inviteType = linkType === 'slack' ? 'slack' : 'mailto';
                                        (0, $kFfmO.set3pIn1pDismissState)(Date.now(), inviteType, dismissState);
                                        createEvent({
                                            type: 'sendUIEvent',
                                            data: {
                                                action: 'dismissed',
                                                actionSubject: `${linkType}InviteOn3rdPartyLinkFlag`,
                                                source: 'inviteOnThirdPartyLinkFlag',
                                                attributes: {
                                                    twcg8533pIn1pLinkCohort: 'variation',
                                                    growthInitiative: 'virality',
                                                    linkType: linkType,
                                                    product: 'confluence',
                                                    dismissType: dismissState
                                                },
                                                tags: [
                                                    'measurement',
                                                    'growth',
                                                    'hasCustomAttributes'
                                                ]
                                            }
                                        }).fire();
                                        flags.hideFlag(flagId);
                                    }
                                })
                        });
                    };
                    const dismissFlag = (id)=>{
                        flags.hideFlag(id);
                    };
                    const shownFlags = (0, $3qHV3.showInviteFlags)({
                        cloudId: cloudId,
                        dismissFlag: dismissFlag,
                        eligibleEmailsResults: eligibleEmailsResults,
                        invite: invite,
                        piEligibilityResults: piEligibilityResults,
                        productName: 'Confluence',
                        showDontShowAgain: {
                            slack: slackDismissType >= 2,
                            mailto: mailtoDismissType >= 2
                        },
                        showFlag: showFlag,
                        spaceName: spaceDetail?.name ?? 'Confluence',
                        onActioned: (source)=>{
                            createEvent({
                                type: 'sendUIEvent',
                                data: {
                                    action: 'actioned',
                                    actionSubject: `${source}InviteOn3rdPartyLinkFlag`,
                                    source: 'inviteOnThirdPartyLinkFlag',
                                    attributes: {
                                        twcg8533pIn1pLinkCohort: 'variation',
                                        growthInitiative: 'virality',
                                        linkType: source,
                                        product: 'confluence'
                                    },
                                    tags: [
                                        'measurement',
                                        'growth',
                                        'hasCustomAttributes'
                                    ]
                                }
                            }).fire();
                        }
                    });
                    if (shownFlags.length > 0) shownFlags.forEach((flag)=>{
                        const flagInviteType = flag.source === 'slack' ? 'slack' : 'mailto';
                        const currentDismissType = (0, $kOnoQ.getInviteOn3pDismissType)(flagInviteType, storedDismissState, traits);
                        inviteFlagSourcesRef.current.set(flag.flagId, {
                            source: flag.source,
                            dismissType: currentDismissType
                        });
                        createEvent({
                            type: 'sendUIEvent',
                            data: {
                                action: 'viewed',
                                actionSubject: `${flag.source}InviteOn3rdPartyLinkFlag`,
                                source: 'inviteOnThirdPartyLinkFlag',
                                attributes: {
                                    twcg8533pIn1pLinkCohort: 'variation',
                                    growthInitiative: 'virality',
                                    linkType: flag.source,
                                    product: 'confluence'
                                },
                                tags: [
                                    'measurement',
                                    'growth',
                                    'hasCustomAttributes'
                                ]
                            }
                        }).fire();
                    });
                }
            } catch  {
                fireSpotlightError('unknown');
            }
        }
    }, [
        cloudId,
        flags,
        invite,
        spaceDetail?.name,
        createEvent,
        userId
    ]);
    /**
   * Save-time strategy: traverses the full ADF document to find links not
   * present in `startingLinks`. Used by comment editors and usePublish, which
   * already receive the full saved ADF at their natural save point.
   */ const handleSave = (0, $cozmU.useCallback)((content)=>{
        if (!content) return;
        const classifiedLinks = $3e66a0beddd545cb$var$classifyNewLinks((0, $2pqKH.getAllLinks)(content), initialLinksRef.current);
        fireAnalytics(classifiedLinks);
        triggerSpotlight(classifiedLinks.pastedSlackLinks, classifiedLinks.pastedMailtoLinks).catch((_)=>{
        //no-op
        });
    }, [
        fireAnalytics,
        triggerSpotlight
    ]);
    /**
   * Paste-time strategy: accepts a pre-extracted list of URLs from only the
   * pasted slice (no full-document traversal). Used by the live-page editor.
   */ const handlePastedLinks = (pastedUrls)=>{
        // Early return if no pasted links or gate is off
        if (pastedUrls.length === 0) return;
        // Get the starting links from the ref
        const startingLinks = initialLinksRef.current;
        const classifiedLinks = $3e66a0beddd545cb$var$classifyNewLinks(pastedUrls, startingLinks);
        fireAnalytics(classifiedLinks);
        triggerSpotlight(classifiedLinks.pastedSlackLinks, classifiedLinks.pastedMailtoLinks).catch((_)=>{
        //no-op
        });
        // Add new links to the initial links ref so the flag doesn't spam on duplicate links
        Object.values(classifiedLinks).flat().forEach((link)=>initialLinksRef.current.add(link));
    };
    return {
        handleSave: handleSave,
        handlePastedLinks: handlePastedLinks,
        setInitialLinks: setInitialLinks
    };
};
module.exports["useDetectPastedThirdPartyLinks"] = $3e66a0beddd545cb$export$3f425f5138bde373;

});

parcelRegister("4wqa6", function(module, exports) {
/**
 * This file defines the invite() service.
 */ 
var $8QJDy = parcelRequire("8QJDy");


var $ixfCV = parcelRequire("ixfCV");


var $7avaU = parcelRequire("7avaU");


var $2LYjf = parcelRequire("2LYjf");


var $kMx7n = parcelRequire("kMx7n");


var $6R9dB = parcelRequire("6R9dB");


var $5I0tl = parcelRequire("5I0tl");


var $zmhwl = parcelRequire("zmhwl");

const $6109888518200d9b$export$ff8f647a32d0f23c = [
    'INVITED',
    'USER_EXISTS',
    'INVITED_PENDING_APPROVAL',
    'PENDING_INVITE_EXISTS',
    'NOT_INVITED',
    'ERROR'
];
// Dependencies - generally common to all invites:
const $6109888518200d9b$var$dependencies = {
    fetchJSON: $6R9dB.fetchJSON,
    createAnalyticsEvent: $kMx7n.createAnalyticsEvent,
    fireErrorAnalytics: $5I0tl.fireErrorAnalytics,
    getStargateURL: $kMx7n.getStargateURL,
    getCurrentUserId: $kMx7n.getCurrentUserId,
    getCurrentCloudId: $kMx7n.getCurrentCloudId,
    getCurrentProduct: $kMx7n.getCurrentProduct
};
const $6109888518200d9b$export$dd37b42f82fee9c3 = Object.assign($6109888518200d9b$var$inviteImpl, {
    dependencies: $6109888518200d9b$var$dependencies
});
async function $6109888518200d9b$var$inviteImpl(input, context) {
    const deps = context.dependencies();
    let results;
    const touchpoint = input.touchpoint === (0, $kMx7n.EnablementTouchpoint).UNKNOWN ? input.integration : input.touchpoint;
    const usersWithOrigin = input.users.map((user)=>{
        const origin = new (0, $8QJDy.default)({
            product: deps.getCurrentProduct()
        });
        const continueUrl = (0, $zmhwl.getContinueUrlWithOrigin)(input.continueUrl, input.resources, origin, touchpoint.replace(/ /g, '_'));
        return {
            user: {
                ...user,
                continueUrl: continueUrl
            },
            origin: origin
        };
    });
    const users = usersWithOrigin.map(({ user: user })=>user);
    try {
        const fetchResponse = await deps.fetchJSON({
            url: deps.getStargateURL('/v3/invitations/invite'),
            method: 'POST',
            credentials: 'include',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                ...input.recaptchaOptions?.recaptchaToken ? {
                    'G-Recaptcha-Token': input.recaptchaOptions.recaptchaToken
                } : {},
                ...input.recaptchaOptions?.recaptchaAction ? {
                    'Recaptcha-Action': input.recaptchaOptions.recaptchaAction
                } : {}
            },
            body: JSON.stringify({
                users: users,
                resources: input.resources.map((resource)=>resource.toString()),
                metadata: {
                    ...input.touchpoint === (0, $kMx7n.EnablementTouchpoint).UNKNOWN ? {} : {
                        touchpoint: input.touchpoint
                    },
                    sourceProduct: deps.getCurrentProduct(),
                    ...input.notes && {
                        notes: input.notes
                    }
                }
            })
        });
        results = $6109888518200d9b$export$aa38717ddd608a8e(fetchResponse.data, usersWithOrigin, input.touchpoint, input.integration, fetchResponse.traceId);
    } catch (error) {
        const errorReason = (0, $kMx7n.getErrorDetails)(error);
        const { code: code, message: message, status: status } = errorReason;
        const attributes = {
            code: code,
            message: message,
            status: status
        };
        if (!(0, $kMx7n.isAcceptableFailure)(message, status)) {
            if ((0, $ixfCV.fg)('expansion-services-invite-capabilities')) // No targetProduct/targetTenantId/userAaid here: the whole request can span
            // multiple resources (products/tenants) and multiple users, so there's no
            // single target or invitee to attribute this failure to.
            deps.fireErrorAnalytics({
                error: new Error(message),
                meta: {
                    id: 'sloInviteRequest'
                },
                attributes: {
                    ...input.getAdditionalAttributes?.() ?? {},
                    ...attributes,
                    integration: input.integration,
                    touchpoint: input.touchpoint,
                    actorAaid: deps.getCurrentUserId(),
                    sourceProduct: deps.getCurrentProduct(),
                    sourceTenantId: deps.getCurrentCloudId()
                }
            });
            else $6109888518200d9b$var$inviteFailedSLO(input.touchpoint, attributes, context);
        }
        results = [
            {
                inviteStatus: null,
                error: (0, $2LYjf.toError)(error),
                errorReason: errorReason
            }
        ];
    }
    results.forEach((result)=>$6109888518200d9b$var$fireInviteAnalytics(result, context, input.getAdditionalAttributes));
    return results;
}
const $6109888518200d9b$export$aa38717ddd608a8e = (response, usersWithOrigin, touchpoint, integration, traceId)=>response.flatMap((user)=>{
        const origin = usersWithOrigin.find((userWithOrigin)=>userWithOrigin.user.id === user.id || userWithOrigin.user.email === user.email)?.origin;
        return Object.keys(user.results).map((resource)=>{
            const inviteStatus = user.results[resource];
            const resourceAri = (0, $7avaU.AnyAri).parse(resource);
            const common = {
                id: user.id,
                email: user.email,
                origin: origin,
                integration: integration,
                touchpoint: touchpoint,
                resource: resourceAri,
                traceId: traceId
            };
            if (inviteStatus === 'ERROR') return {
                ...common,
                inviteStatus: inviteStatus,
                // errorReasons should always be present for error responses
                error: user.errorReasons?.[resource] ?? {
                    code: 'UNKNOWN_ERROR',
                    message: 'Unknown error'
                }
            };
            return {
                ...common,
                inviteStatus: inviteStatus,
                error: null
            };
        });
    });
const $6109888518200d9b$var$isInvited = (res)=>{
    return res.inviteStatus === 'INVITED' || res.inviteStatus === 'USER_EXISTS';
};
const $6109888518200d9b$var$isRequested = (res)=>{
    return res.inviteStatus === 'INVITED_PENDING_APPROVAL' || res.inviteStatus === 'PENDING_INVITE_EXISTS';
};
const $6109888518200d9b$var$isError = (res)=>{
    return res.inviteStatus === 'NOT_INVITED' || res.inviteStatus === 'ERROR';
};
const $6109888518200d9b$export$e0d12419555d8733 = (result)=>result.reduce((accumulator, res)=>{
        switch(res.inviteStatus){
            case 'INVITED':
            case 'USER_EXISTS':
                $6109888518200d9b$var$isInvited(res) && accumulator.invited.push(res);
                break;
            case 'INVITED_PENDING_APPROVAL':
            case 'PENDING_INVITE_EXISTS':
                $6109888518200d9b$var$isRequested(res) && accumulator.requested.push(res);
                break;
            case 'NOT_INVITED':
            case 'ERROR':
                $6109888518200d9b$var$isError(res) && accumulator.error.push(res);
                break;
            default:
                accumulator.failure = res;
        }
        return accumulator;
    }, {
        invited: [],
        requested: [],
        error: [],
        failure: undefined
    });
// Analytics functions for these common events might later become
// exported for standalone use
function $6109888518200d9b$var$fireInviteAnalytics(result, context, getAdditionalAttributes) {
    if (result.inviteStatus === null) // Whole-request failures are handled directly in inviteImpl's catch block.
    return;
    const { integration: integration, resource: resource, touchpoint: touchpoint, traceId: traceId } = result;
    const baseAttributes = {
        ...getAdditionalAttributes?.(result) ?? {},
        actorAaid: context.dependencies().getCurrentUserId(),
        integration: integration,
        sourceProduct: context.dependencies().getCurrentProduct(),
        sourceTenantId: context.dependencies().getCurrentCloudId(),
        targetProduct: resource.resourceOwner,
        targetTenantId: resource.resourceId,
        touchpoint: touchpoint,
        ...traceId ? {
            traceId: traceId
        } : {}
    };
    if (!result.error) {
        const originAttributes = result.origin?.toAnalyticsAttributes({
            hasGeneratedId: true
        }) ?? {};
        const attributes = {
            ...originAttributes,
            ...baseAttributes,
            // The id is always present for success responses
            userAaid: result.id,
            inviteStatus: result.inviteStatus
        };
        if ((0, $ixfCV.fg)('expansion-services-invite-capabilities')) $6109888518200d9b$var$inviteSucceededSLO(attributes, context);
        else $6109888518200d9b$var$inviteSucceededSLO({
            touchpoint: result.touchpoint
        }, context);
        if (result.inviteStatus === 'INVITED') $6109888518200d9b$var$fireUserInvited(attributes, context);
        if (result.inviteStatus === 'INVITED_PENDING_APPROVAL') $6109888518200d9b$var$fireProductAccessRequested(attributes, context);
        return;
    }
    const failure = result.error;
    // There should not be a failure SLO event if the error is a user network failure error
    if ((0, $kMx7n.isAcceptableFailureForUserInvite)(failure)) return;
    if (!(0, $kMx7n.shouldReportFailedInvite)(failure)) {
        if ((0, $ixfCV.fg)('expansion-services-invite-capabilities')) $6109888518200d9b$var$inviteSucceededSLO({
            ...baseAttributes,
            ...result.id ? {
                userAaid: result.id
            } : {}
        }, context);
        else $6109888518200d9b$var$inviteSucceededSLO({
            touchpoint: result.touchpoint
        }, context);
        return;
    }
    if ((0, $ixfCV.fg)('expansion-services-invite-capabilities')) context.dependencies().fireErrorAnalytics({
        error: new Error(failure.message),
        meta: {
            id: 'sloInviteRequest'
        },
        attributes: {
            ...failure,
            ...baseAttributes,
            ...result.id ? {
                userAaid: result.id
            } : {}
        }
    });
    else $6109888518200d9b$var$inviteFailedSLO(result.touchpoint, failure, context);
}
function $6109888518200d9b$var$fireProductAccessRequested(attributes, context) {
    context.dependencies().createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'productAccess',
            action: 'requested',
            actionSubjectId: attributes.targetProduct,
            source: attributes.touchpoint,
            attributes: attributes,
            tags: [
                'growth'
            ]
        }
    }).fire();
}
function $6109888518200d9b$var$fireUserInvited(attributes, context) {
    context.dependencies().createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'user',
            action: 'invited',
            actionSubjectId: attributes.userAaid,
            source: attributes.touchpoint,
            attributes: attributes,
            tags: [
                'growth'
            ]
        }
    }).fire();
}
const $6109888518200d9b$var$inviteFailedSLO = (touchpoint, attributes, context)=>{
    context.dependencies().createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            actionSubject: 'sloInviteRequest',
            action: 'failed',
            source: touchpoint,
            attributes: {
                ...attributes,
                touchpoint: touchpoint
            },
            tags: [
                'growth'
            ]
        }
    }).fire();
};
const $6109888518200d9b$var$inviteSucceededSLO = (attributes, context)=>{
    context.dependencies().createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            actionSubject: 'sloInviteRequest',
            action: 'succeeded',
            source: attributes.touchpoint,
            attributes: attributes,
            tags: [
                'growth'
            ]
        }
    }).fire();
};
module.exports["invite"] = $6109888518200d9b$export$dd37b42f82fee9c3;
module.exports["mapInviteResult"] = $6109888518200d9b$export$e0d12419555d8733;

});

parcelRegister("2LYjf", function(module, exports) {
const $7ff17f6787cd1620$export$4094c5185600bd73 = (maybeService)=>typeof maybeService === 'function' && 'dependencies' in maybeService;
const $7ff17f6787cd1620$export$6e9f7b680f09bab1 = (serviceName)=>Object.assign((_input)=>{
        throw TypeError(`Unimplemented abstract service: ${serviceName}`);
    }, {
        abstract: true
    });
const $7ff17f6787cd1620$export$cc3b967c039ed3e7 = (maybeError)=>{
    if (maybeError instanceof Error) return maybeError;
    return new TypeError('Service Error: ' + maybeError);
};
module.exports["isServiceWithDeps"] = $7ff17f6787cd1620$export$4094c5185600bd73;
module.exports["unimplementedAbstractService"] = $7ff17f6787cd1620$export$6e9f7b680f09bab1;
module.exports["toError"] = $7ff17f6787cd1620$export$cc3b967c039ed3e7;

});

parcelRegister("kMx7n", function(module, exports) {
/**
 * This file contains declaration of smaller services,
 * commonly used as building blocks to create more specific
 * endpoint wrapping services
 */ 
var $2LYjf = parcelRequire("2LYjf");

const $d1fa119fb73e6e08$export$c7904a8284e43beb = (url)=>`/gateway/api${url}`;
const $d1fa119fb73e6e08$export$ddb1688281a3443e = (0, $2LYjf.unimplementedAbstractService)('getCurrentCloudId');
const $d1fa119fb73e6e08$export$7a2d3e6a9f4c0016 = (0, $2LYjf.unimplementedAbstractService)('getCurrentOrgId');
const $d1fa119fb73e6e08$export$5ebc6cb2748e1881 = (0, $2LYjf.unimplementedAbstractService)('getCurrentUserId');
const $d1fa119fb73e6e08$export$d01408ed6f850a64 = (0, $2LYjf.unimplementedAbstractService)('getCurrentProduct');
const $d1fa119fb73e6e08$export$a48841c0475a8073 = (0, $2LYjf.unimplementedAbstractService)('createAnalyticsEvent');
class $d1fa119fb73e6e08$export$26e841bcf1aeb894 extends Error {
    constructor(action, responseCode, response, responseJson, errorType){
        if (responseJson?.message) {
            super(responseJson.message);
            this.responseCode = void 0;
            this.errorType = void 0;
            this.response = void 0;
            this.responseJson = void 0;
        } else {
            super(`Received error response during action ${action}: ${response.statusText}`);
            this.responseCode = void 0;
            this.errorType = void 0;
            this.response = void 0;
            this.responseJson = void 0;
        }
        this.name = 'FetchError';
        this.responseCode = responseCode;
        this.response = response;
        this.responseJson = responseJson;
        this.errorType = errorType;
    }
}
const $d1fa119fb73e6e08$export$33e83b6fee5d732d = (err)=>({
        code: err instanceof Error ? err.name : 'UNKNOWN',
        message: err instanceof Error ? err.message : String(err),
        status: $d1fa119fb73e6e08$var$getErrorStatus(err)
    });
const $d1fa119fb73e6e08$var$getErrorStatus = (error)=>{
    if (!error) return undefined;
    const e = error;
    return e.statusCode ?? e.status ?? e.responseCode ?? e.response?.status;
};
const $d1fa119fb73e6e08$export$678d91a98f79a24d = (errorMessage, statusCode)=>!statusCode && $d1fa119fb73e6e08$export$e1b6bb1617649e83(errorMessage) || statusCode === 401;
const $d1fa119fb73e6e08$export$1f2663aaa83f036d = 'Failed to fetch';
const $d1fa119fb73e6e08$export$65e55894e6e38a89 = 'NetworkError when attempting to fetch resource.';
const $d1fa119fb73e6e08$export$f25400ad927aa79c = 'A server with the specified hostname could not be found.';
const $d1fa119fb73e6e08$export$6827a0909c1bf12f = [
    $d1fa119fb73e6e08$export$1f2663aaa83f036d,
    $d1fa119fb73e6e08$export$65e55894e6e38a89,
    $d1fa119fb73e6e08$export$f25400ad927aa79c
];
const $d1fa119fb73e6e08$export$e1b6bb1617649e83 = (errorMessage)=>$d1fa119fb73e6e08$export$6827a0909c1bf12f.some((failureMessage)=>errorMessage?.includes(failureMessage));
const $d1fa119fb73e6e08$export$c53f16dd5442ef61 = 'EMAIL_BLOCKED';
const $d1fa119fb73e6e08$export$e27975535396141b = 'REACHED_MAX_NUMBER_OF_EMAIL_ALIAS_SIGNUPS';
const $d1fa119fb73e6e08$var$INVALID_EMAIL = 'INVALID_EMAIL';
const $d1fa119fb73e6e08$var$MISSING_USERNAME = 'MISSING_USERNAME';
const $d1fa119fb73e6e08$var$EMPTY_USERNAME = 'EMPTY_USERNAME';
const $d1fa119fb73e6e08$var$USERNAME_MUST_BE_EMAIL = 'USERNAME_MUST_BE_EMAIL';
const $d1fa119fb73e6e08$export$80a3c1a1eb6f063 = 'noDefaultGroup';
const $d1fa119fb73e6e08$export$e089e1d2018847da = 'Default group for the requested resource not found.';
const $d1fa119fb73e6e08$export$cb3290253184cb70 = (message, error)=>{
    try {
        const badRequestResponse = JSON.parse(message);
        return badRequestResponse.some((val)=>val.errorCodes.userName.includes(error));
    } catch (_ignoredError) {
        return false;
    }
};
const $d1fa119fb73e6e08$export$395f41a02d6a8be0 = (errorKey, errorMessage)=>errorKey === $d1fa119fb73e6e08$export$80a3c1a1eb6f063 || errorMessage === $d1fa119fb73e6e08$export$e089e1d2018847da;
const $d1fa119fb73e6e08$export$1c4c1f7e2d529330 = (response)=>{
    const { key: key, message: message, status: status } = response;
    return $d1fa119fb73e6e08$export$678d91a98f79a24d(message, status) || status === 400 && ($d1fa119fb73e6e08$export$cb3290253184cb70(message, $d1fa119fb73e6e08$export$c53f16dd5442ef61) || $d1fa119fb73e6e08$export$cb3290253184cb70(message, $d1fa119fb73e6e08$export$e27975535396141b)) || status === 412 && $d1fa119fb73e6e08$export$395f41a02d6a8be0(key, message);
};
const $d1fa119fb73e6e08$export$9de493bcd9b1d977 = 'bad-request';
const $d1fa119fb73e6e08$export$e5254cb9f7678ab9 = 'licence-exceeded';
const $d1fa119fb73e6e08$export$90cda429f609d666 = (response)=>{
    const { code: code, message: message } = response;
    if (code === $d1fa119fb73e6e08$export$9de493bcd9b1d977 && message === 'User cannot invite themselves') return false;
    if (code === $d1fa119fb73e6e08$export$e5254cb9f7678ab9) return false;
    return true;
};
const $d1fa119fb73e6e08$export$ba588e0ff1c8ed38 = {
    CROSSJOIN_NUDGE: 'Crossjoin Nudge',
    DIRECT_ACCESS_JOIN: 'Direct Access - Join',
    DIRECT_ACCESS_AUTOJOIN: 'Direct Access - AutoJoin',
    DIRECT_ACCESS_INVITE_LINKS: 'Direct Access - Invite Links',
    REQUEST_ACCESS: 'Request Access Screen',
    ASSIGNS: 'Assigns',
    CORE_INVITES: 'Core Invites',
    MENTIONS: 'Mentions',
    NAV4_TEAMS_ADD: 'Nav4 Teams Add',
    PEOPLE_DIRECTORY: 'People Directory',
    PROMPT_INVITE_ON_LINK_INSERT: 'Prompt invite on link insert',
    SHARE_DIALOG: 'Share Dialog',
    SPACES: 'Spaces',
    TEAMS_MENU: 'Teams Menu',
    USER_INVITE_DRAWER: 'User Invite Drawer',
    UNKNOWN: 'unknown'
};
module.exports["getStargateURL"] = $d1fa119fb73e6e08$export$c7904a8284e43beb;
module.exports["getCurrentCloudId"] = $d1fa119fb73e6e08$export$ddb1688281a3443e;
module.exports["getCurrentUserId"] = $d1fa119fb73e6e08$export$5ebc6cb2748e1881;
module.exports["getCurrentProduct"] = $d1fa119fb73e6e08$export$d01408ed6f850a64;
module.exports["createAnalyticsEvent"] = $d1fa119fb73e6e08$export$a48841c0475a8073;
module.exports["getErrorDetails"] = $d1fa119fb73e6e08$export$33e83b6fee5d732d;
module.exports["isAcceptableFailure"] = $d1fa119fb73e6e08$export$678d91a98f79a24d;
module.exports["isAcceptableFailureForUserInvite"] = $d1fa119fb73e6e08$export$1c4c1f7e2d529330;
module.exports["shouldReportFailedInvite"] = $d1fa119fb73e6e08$export$90cda429f609d666;
module.exports["EnablementTouchpoint"] = $d1fa119fb73e6e08$export$ba588e0ff1c8ed38;

});

parcelRegister("6R9dB", function(module, exports) {

var $2LYjf = parcelRequire("2LYjf");

const $f6ff9e76ba25bd46$export$81bec6e38e8b706b = // XXX: This is a generic function - careful with types!
// TypeScript has limitations when transforming generic functions.
// Here, the function signature will pass through our helper unimplementedAbstractService()
// untouched, which TypeScript can handle.
(0, $2LYjf.unimplementedAbstractService)('fetchJSON');
module.exports["fetchJSON"] = $f6ff9e76ba25bd46$export$81bec6e38e8b706b;

});

parcelRegister("5I0tl", function(module, exports) {
/**
 * This file defines the fireErrorAnalytics() service.
 */ 
var $kMx7n = parcelRequire("kMx7n");

const $af309de29559f4fc$var$fireErrorAnalyticsDependencies = {
    createAnalyticsEvent: $kMx7n.createAnalyticsEvent
};
const $af309de29559f4fc$export$a27c21aa3ed8f0f1 = Object.assign($af309de29559f4fc$var$fireErrorAnalyticsImpl, {
    dependencies: $af309de29559f4fc$var$fireErrorAnalyticsDependencies
});
// Still allows an async override of fireErrorAnalytics, but the default implementation is synchronous.
function $af309de29559f4fc$var$fireErrorAnalyticsImpl(input, context) {
    const touchpoint = input.attributes?.touchpoint;
    context.dependencies().createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            actionSubject: input.meta.id,
            action: 'failed',
            ...touchpoint ? {
                source: touchpoint
            } : {},
            attributes: {
                ...input.attributes,
                ...input.error && {
                    message: input.error.message
                }
            },
            tags: [
                'growth'
            ]
        }
    }).fire();
}
module.exports["fireErrorAnalytics"] = $af309de29559f4fc$export$a27c21aa3ed8f0f1;

});

parcelRegister("zmhwl", function(module, exports) {
const $1e189752d41c437c$var$getInstanceUrl = ()=>{
    return window.location.origin;
};
const $1e189752d41c437c$var$landingPathMap = {
    confluence: '/wiki',
    compass: '/compass',
    avp: '/analytics',
    mercury: '/focus'
};
const $1e189752d41c437c$var$getLandingPathByProduct = (product)=>$1e189752d41c437c$var$landingPathMap[product] ?? '';
const $1e189752d41c437c$export$ab36e4577f8d8354 = (continueUrl, resources, origin, source)=>{
    const instanceUrl = $1e189752d41c437c$var$getInstanceUrl();
    let productContinueUrl = continueUrl;
    const targetProducts = resources.map((resource)=>resource.resourceOwner);
    if (continueUrl && origin.containsOrigin(continueUrl)) throw new Error('continueUrl contains Origin Tracing query parameter');
    if (!productContinueUrl) productContinueUrl = resources.length === 1 ? `${instanceUrl}${$1e189752d41c437c$var$getLandingPathByProduct(targetProducts[0])}` : instanceUrl;
    // Also try to find urls that forward newly invited users to jira setting pages and redirect them to a product landing page instead.
    // We should do this so newly invited users are not seeing a permission denied screen when accessing restricted pages.
    if (productContinueUrl.match(/.*\/jira.*\/settings/gim)) productContinueUrl = targetProducts.length === 1 ? `${instanceUrl}${$1e189752d41c437c$var$getLandingPathByProduct(targetProducts[0])}` : instanceUrl;
    const productContinueUrlWithOrigin = origin.addToUrl(productContinueUrl);
    return `${productContinueUrlWithOrigin}&source=${source}`;
};
module.exports["getContinueUrlWithOrigin"] = $1e189752d41c437c$export$ab36e4577f8d8354;

});

parcelRegister("3qHV3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7avaU = parcelRequire("7avaU");


var $4wqa6 = parcelRequire("4wqa6");


var $6hsOq = parcelRequire("6hsOq");


var $7aAWd = parcelRequire("7aAWd");


var $3b21M = parcelRequire("3b21M");

const $053543f2b8f0c6ab$var$resourceOwnerByProduct = {
    Jira: 'jira-software',
    Confluence: 'confluence'
};
const $053543f2b8f0c6ab$export$8a888a4b6cdffdf5 = ({ flagId: flagId, cloudId: cloudId, onActioned: onActioned, productName: productName, showDontShowAgain: showDontShowAgain, source: source, usersWithoutAccess: usersWithoutAccess, showFlag: showFlag, dismissFlag: dismissFlag, spaceName: spaceName, invite: invite })=>{
    showFlag({
        id: flagId,
        render: (props)=>{
            const inviteFlagProps = {
                id: flagId,
                onDismiss: (_id, _dismissMethod)=>dismissFlag(flagId)
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aAWd.InviteOnThirdPartyLinkFlag), {
                ...inviteFlagProps,
                ...props,
                onActioned: onActioned ? ()=>onActioned(source, flagId) : undefined,
                showDontShowAgain: showDontShowAgain,
                spaceName: spaceName,
                productName: productName,
                source: source,
                usersWithoutAccess: usersWithoutAccess,
                onInvite: async ()=>{
                    // Optimistically dismiss the invite flag
                    dismissFlag(flagId);
                    let response;
                    try {
                        response = await invite({
                            users: usersWithoutAccess.map((user)=>({
                                    ...user.email ? {
                                        email: user.email
                                    } : {}
                                })),
                            integration: 'twcg-853-3p-in-1p-link',
                            // GROOT-1304 Add enablement touchpoint in expansion services https://hello.jira.atlassian.cloud/browse/GROOT-1304
                            touchpoint: 'unknown',
                            resources: cloudId ? [
                                (0, $7avaU.AnyAri).create({
                                    resourceOwner: $053543f2b8f0c6ab$var$resourceOwnerByProduct[productName],
                                    resourceType: 'site',
                                    resourceId: cloudId
                                })
                            ] : []
                        });
                    } catch  {
                        showFlag({
                            id: `${flagId}-error`,
                            render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6hsOq.InviteOnThirdPartyLinkErrorFlag), {
                                    id: `${flagId}-error`,
                                    onDismiss: ()=>dismissFlag(`${flagId}-error`)
                                })
                        });
                        return;
                    }
                    const { error: error, failure: failure, invited: invited, requested: requested } = (0, $4wqa6.mapInviteResult)(response);
                    if (error.length > 0 || failure) {
                        showFlag({
                            id: `${flagId}-error`,
                            render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6hsOq.InviteOnThirdPartyLinkErrorFlag), {
                                    id: `${flagId}-error`,
                                    onDismiss: ()=>dismissFlag(`${flagId}-error`)
                                })
                        });
                        return;
                    }
                    showFlag({
                        id: `${flagId}-sent`,
                        render: ({ onDismiss: _ignoredOnDismiss, ...sentProps })=>{
                            const sentFlagProps = {
                                id: `${flagId}-sent`,
                                onDismiss: ()=>dismissFlag(`${flagId}-sent`),
                                hasRequestAccess: requested.length > 0,
                                inviteCount: invited.length + requested.length,
                                productName: productName
                            };
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3b21M.InviteOnThirdPartyLinkInvitesSentFlag), {
                                ...sentProps,
                                ...sentFlagProps
                            });
                        }
                    });
                }
            });
        }
    });
};
const $053543f2b8f0c6ab$export$57e1603a1dc23442 = (users = [])=>users.filter((user)=>Boolean(user.email)).map((user)=>({
            id: user.atlassianAccountId || user.email,
            email: user.email,
            name: user?.displayName,
            avatar: user.avatarUrl
        }));
const $053543f2b8f0c6ab$export$1b83a517d3fa14f = ({ cloudId: cloudId, dismissFlag: dismissFlag, eligibleEmailsResults: eligibleEmailsResults, invite: invite, onActioned: onActioned, piEligibilityResults: piEligibilityResults, productName: productName, showDontShowAgain: showDontShowAgain, spaceName: spaceName, showFlag: showFlag })=>{
    let shown = [];
    // One flag per Slack link that returned eligible users
    piEligibilityResults.forEach(({ eligibleUsers: eligibleUsers }, i)=>{
        if (!eligibleUsers?.length) return;
        const candidates = $053543f2b8f0c6ab$export$57e1603a1dc23442(eligibleUsers);
        if (candidates.length === 0) return;
        $053543f2b8f0c6ab$export$8a888a4b6cdffdf5({
            flagId: `invite-on-third-party-slack-link-${i}`,
            cloudId: cloudId ?? '',
            productName: productName,
            showDontShowAgain: showDontShowAgain?.slack,
            source: 'slack',
            usersWithoutAccess: candidates,
            showFlag: showFlag,
            dismissFlag: dismissFlag,
            invite: invite,
            onActioned: onActioned,
            spaceName: spaceName
        });
        shown.push({
            flagId: `invite-on-third-party-slack-link-${i}`,
            source: 'slack',
            userCount: candidates.length
        });
    });
    // One grouped flag for all eligible mailto users
    const mailtoUsers = eligibleEmailsResults?.eligibleEmails?.map((user)=>{
        const thirdPartyUser = {
            email: user.email,
            avatar: user.avatarUrl,
            name: user?.email,
            id: user.email
        };
        return thirdPartyUser;
    });
    if (mailtoUsers && mailtoUsers.length > 0) {
        $053543f2b8f0c6ab$export$8a888a4b6cdffdf5({
            flagId: 'invite-on-third-party-mailto-link',
            cloudId: cloudId ?? '',
            productName: productName,
            showDontShowAgain: showDontShowAgain?.mailto,
            source: 'mailto',
            usersWithoutAccess: mailtoUsers,
            showFlag: showFlag,
            dismissFlag: dismissFlag,
            invite: invite,
            onActioned: onActioned,
            spaceName: spaceName
        });
        shown.push({
            flagId: 'invite-on-third-party-mailto-link',
            source: 'mailto',
            userCount: mailtoUsers.length
        });
    }
    return shown;
};
module.exports["showInviteFlags"] = $053543f2b8f0c6ab$export$1b83a517d3fa14f;

});

parcelRegister("6hsOq", function(module, exports) {
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $FKQbh = parcelRequire("FKQbh");


var $24dy7 = parcelRequire("24dy7");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $bCGJJ = parcelRequire("bCGJJ");


var $k9fi6 = parcelRequire("k9fi6");

const $fe15bc39f1c634bb$var$SUPPORT_LINK = 'https://support.atlassian.com/contact/';
const $fe15bc39f1c634bb$export$8063fcb3fd518318 = ({ onDismiss: onDismiss, ...props })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $FKQbh.default), {
        ...props,
        testId: "invite-on-third-party-link-error-flag",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
            spacing: "spacious",
            label: "Error",
            color: "var(--ds-icon-danger, #C9372C)"
        }),
        onDismissed: onDismiss,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            as: "p"
        }, formatMessage((0, $k9fi6.messages).title)),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            as: "p"
        }, formatMessage((0, $k9fi6.messages).description)),
        actions: [
            {
                content: formatMessage((0, $k9fi6.messages).action),
                href: $fe15bc39f1c634bb$var$SUPPORT_LINK,
                target: '_blank'
            }
        ]
    });
};
const $fe15bc39f1c634bb$export$f219c69d02927f9f = (0, $bCGJJ.withLocalIntl)($fe15bc39f1c634bb$export$8063fcb3fd518318);
module.exports["InviteOnThirdPartyLinkErrorFlag"] = $fe15bc39f1c634bb$export$f219c69d02927f9f;

});

parcelRegister("bCGJJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $j0mAv = parcelRequire("j0mAv");

const $0d1962e2b5191962$export$2a4cd3780f93f2ef = (ComponentToWrap)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0d1962e2b5191962$export$9deb723ab5a74946, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentToWrap, props));
const $0d1962e2b5191962$export$9deb723ab5a74946 = ({ children: children })=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const { messages: messages } = (0, $j0mAv.useFetchMessagesByLocale)(locale);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        messages: messages,
        key: locale,
        locale: locale
    }, children);
};
module.exports["withLocalIntl"] = $0d1962e2b5191962$export$2a4cd3780f93f2ef;

});

parcelRegister("j0mAv", function(module, exports) {
/* eslint-disable import/dynamic-import-chunkname */ 
var $cozmU = parcelRequire("cozmU");

function $c0efea985bd710e1$export$5ac26fa9b941854e(locale) {
    const [messages, setMessages] = (0, $cozmU.useState)({});
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        let isMounted = true;
        async function startToFetchMessagesByLocale() {
            // Intl.Locale doesn't like underscores
            const finalLocale = new Intl.Locale(locale.replace('_', '-')).toString();
            try {
                setIsLoading(true);
                const module = await $c0efea985bd710e1$export$c08b58fa4727b0d2(finalLocale);
                const newMessages = module.default || module;
                if (isMounted) setMessages(newMessages);
            } catch (e) {
            // fail to download message and do nothing because UI will use default language (English) to render
            } finally{
                if (isMounted) setIsLoading(false);
            }
        }
        startToFetchMessagesByLocale();
        return ()=>{
            isMounted = false;
        };
    }, [
        locale
    ]);
    return {
        messages: messages,
        isLoading: isLoading
    };
}

























function $c0efea985bd710e1$export$c08b58fa4727b0d2(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return (parcelRequire("QlgrO"));
        case 'da-DK':
        case 'da':
            return (parcelRequire("i6ClN"));
        case 'de-DE':
        case 'de':
            return (parcelRequire("imG2i"));
        case 'en-GB':
            return (parcelRequire("hC9tF"));
        case 'en-US':
        case 'en':
            return (parcelRequire("l4pie"));
        case 'es-ES':
        case 'es':
            return (parcelRequire("ldmDY"));
        case 'fi-FI':
        case 'fi':
            return (parcelRequire("go6sK"));
        case 'fr-FR':
        case 'fr':
            return (parcelRequire("fGohQ"));
        case 'hu-HU':
        case 'hu':
            return (parcelRequire("crKAs"));
        case 'it-IT':
        case 'it':
            return (parcelRequire("ip1wY"));
        case 'ja-JP':
        case 'ja':
            return (parcelRequire("ggcYo"));
        case 'ko-KR':
        case 'ko':
            return (parcelRequire("fjod6"));
        case 'nb-NB':
        case 'nb':
            return (parcelRequire("6RX7E"));
        case 'nl-NL':
        case 'nl':
            return (parcelRequire("hexeV"));
        case 'pl-PL':
        case 'pl':
            return (parcelRequire("kDiPg"));
        case 'pt-BR':
        case 'pt':
            return (parcelRequire("4vTx9"));
        case 'ru-RU':
        case 'ru':
            return (parcelRequire("j72BF"));
        case 'sv-SE':
        case 'sv':
            return (parcelRequire("2uGsY"));
        case 'th-TH':
        case 'th':
            return (parcelRequire("kB3E2"));
        case 'tr-TR':
        case 'tr':
            return (parcelRequire("6SBDz"));
        case 'uk-UA':
        case 'uk':
            return (parcelRequire("aCdAQ"));
        case 'vi-VN':
        case 'vi':
            return (parcelRequire("1Qv2r"));
        case 'zh-TW':
            return (parcelRequire("ixISE"));
        case 'zh-CN':
        case 'zh':
            return (parcelRequire("5RKfG"));
        default:
            return (parcelRequire("l4pie"));
    }
}
module.exports["useFetchMessagesByLocale"] = $c0efea985bd710e1$export$5ac26fa9b941854e;

});

parcelRegister("QlgrO", function(module, exports) {

let $09d55a1641a9c876$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $09d55a1641a9c876$var$load("bg8Ff"),
    $09d55a1641a9c876$var$load("h9vhI")
]).then(()=>parcelRequire('fiVEH'));

});

parcelRegister("i6ClN", function(module, exports) {

let $d2e6892cfdba12cc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d2e6892cfdba12cc$var$load("bg8Ff"),
    $d2e6892cfdba12cc$var$load("1sUk9")
]).then(()=>parcelRequire('aRWE0'));

});

parcelRegister("imG2i", function(module, exports) {

let $d5eae3932b0d9983$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d5eae3932b0d9983$var$load("bg8Ff"),
    $d5eae3932b0d9983$var$load("jMEeD")
]).then(()=>parcelRequire('ffPbQ'));

});

parcelRegister("hC9tF", function(module, exports) {

let $cd2d56521d1dec17$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cd2d56521d1dec17$var$load("bg8Ff"),
    $cd2d56521d1dec17$var$load("hrQ3P")
]).then(()=>parcelRequire('7mHVC'));

});

parcelRegister("l4pie", function(module, exports) {

let $f56d975bf78ed925$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f56d975bf78ed925$var$load("bg8Ff").then(()=>parcelRequire('ibrwD'));

});

parcelRegister("ldmDY", function(module, exports) {

let $f71c607587cae592$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f71c607587cae592$var$load("bg8Ff"),
    $f71c607587cae592$var$load("j4lDO")
]).then(()=>parcelRequire('ccMcK'));

});

parcelRegister("go6sK", function(module, exports) {

let $bee3e69c57389e4e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bee3e69c57389e4e$var$load("bg8Ff"),
    $bee3e69c57389e4e$var$load("607iN")
]).then(()=>parcelRequire('aoe4x'));

});

parcelRegister("fGohQ", function(module, exports) {

let $b6ad9e23069c56ae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b6ad9e23069c56ae$var$load("bg8Ff"),
    $b6ad9e23069c56ae$var$load("gPrqo")
]).then(()=>parcelRequire('6Msb1'));

});

parcelRegister("crKAs", function(module, exports) {

let $90fc24e19eea9398$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $90fc24e19eea9398$var$load("bg8Ff"),
    $90fc24e19eea9398$var$load("kxHLR")
]).then(()=>parcelRequire('lwcU7'));

});

parcelRegister("ip1wY", function(module, exports) {

let $d65bbfcbdd4404d4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d65bbfcbdd4404d4$var$load("bg8Ff"),
    $d65bbfcbdd4404d4$var$load("lPZYE")
]).then(()=>parcelRequire('79gYg'));

});

parcelRegister("ggcYo", function(module, exports) {

let $030e115b796d65d5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $030e115b796d65d5$var$load("bg8Ff"),
    $030e115b796d65d5$var$load("pD3Q1")
]).then(()=>parcelRequire('708JR'));

});

parcelRegister("fjod6", function(module, exports) {

let $b25b6903f1af9cfc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b25b6903f1af9cfc$var$load("bg8Ff"),
    $b25b6903f1af9cfc$var$load("21jyh")
]).then(()=>parcelRequire('9kb87'));

});

parcelRegister("6RX7E", function(module, exports) {

let $50058dcbea6aa346$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $50058dcbea6aa346$var$load("bg8Ff"),
    $50058dcbea6aa346$var$load("2ZmaB")
]).then(()=>parcelRequire('3U8ps'));

});

parcelRegister("hexeV", function(module, exports) {

let $c8bd873421eb800a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c8bd873421eb800a$var$load("bg8Ff"),
    $c8bd873421eb800a$var$load("hGZkH")
]).then(()=>parcelRequire('gvAiQ'));

});

parcelRegister("kDiPg", function(module, exports) {

let $f0560d90eba41a85$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f0560d90eba41a85$var$load("bg8Ff"),
    $f0560d90eba41a85$var$load("cWQA6")
]).then(()=>parcelRequire('2MVAL'));

});

parcelRegister("4vTx9", function(module, exports) {

let $3495227d8dbd810d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3495227d8dbd810d$var$load("bg8Ff"),
    $3495227d8dbd810d$var$load("37eFt")
]).then(()=>parcelRequire('5TMUb'));

});

parcelRegister("j72BF", function(module, exports) {

let $dea0b15f270042d1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $dea0b15f270042d1$var$load("bg8Ff"),
    $dea0b15f270042d1$var$load("2Zvfr")
]).then(()=>parcelRequire('7azb2'));

});

parcelRegister("2uGsY", function(module, exports) {

let $1d0f5304524cfc52$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1d0f5304524cfc52$var$load("bg8Ff"),
    $1d0f5304524cfc52$var$load("gJsFu")
]).then(()=>parcelRequire('lXXzI'));

});

parcelRegister("kB3E2", function(module, exports) {

let $efea1723c38fc53d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $efea1723c38fc53d$var$load("bg8Ff"),
    $efea1723c38fc53d$var$load("1zolY")
]).then(()=>parcelRequire('lDIiV'));

});

parcelRegister("6SBDz", function(module, exports) {

let $5024fb3180a2f6df$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5024fb3180a2f6df$var$load("bg8Ff"),
    $5024fb3180a2f6df$var$load("dWGne")
]).then(()=>parcelRequire('8n76D'));

});

parcelRegister("aCdAQ", function(module, exports) {

let $7ba7ff528f820f53$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7ba7ff528f820f53$var$load("bg8Ff"),
    $7ba7ff528f820f53$var$load("bCTn7")
]).then(()=>parcelRequire('edzZq'));

});

parcelRegister("1Qv2r", function(module, exports) {

let $1582b955d5faf7f4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1582b955d5faf7f4$var$load("bg8Ff"),
    $1582b955d5faf7f4$var$load("5yFE2")
]).then(()=>parcelRequire('e0miV'));

});

parcelRegister("ixISE", function(module, exports) {

let $d7fe1f64a187a7fa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d7fe1f64a187a7fa$var$load("bg8Ff"),
    $d7fe1f64a187a7fa$var$load("aRaEo")
]).then(()=>parcelRequire('hPhX7'));

});

parcelRegister("5RKfG", function(module, exports) {

let $4455c7aa40d7de61$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4455c7aa40d7de61$var$load("bg8Ff"),
    $4455c7aa40d7de61$var$load("28gBf")
]).then(()=>parcelRequire('gJ86N'));

});

parcelRegister("k9fi6", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $b087f0566bb95583$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    title: {
        id: "invite-on-third-party-link.invite-error-flag.title",
        defaultMessage: "Something went wrong"
    },
    description: {
        id: "invite-on-third-party-link.invite-error-flag.description",
        defaultMessage: "Try inviting your teammates again. If the problem persists, contact support."
    },
    action: {
        id: "invite-on-third-party-link.invite-error-flag.action",
        defaultMessage: "Contact support"
    }
});
module.exports["messages"] = $b087f0566bb95583$export$defe85febe8b728c;

});

parcelRegister("7aAWd", function(module, exports) {
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7zsi1 = parcelRequire("7zsi1");


var $bcDqz = parcelRequire("bcDqz");


var $FKQbh = parcelRequire("FKQbh");


var $iMnC5 = parcelRequire("iMnC5");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $bCGJJ = parcelRequire("bCGJJ");


var $bBCy7 = parcelRequire("bBCy7");


var $4XQXn = parcelRequire("4XQXn");


var $2KW1v = parcelRequire("2KW1v");


var $9A30E = parcelRequire("9A30E");


var $6eWaG = parcelRequire("6eWaG");


var $bQuWd = parcelRequire("bQuWd");


var $f57An = parcelRequire("f57An");


var $dxDFB = parcelRequire("dxDFB");


var $9W3iZ = parcelRequire("9W3iZ");

const $d2662eadf49776f1$var$MAX_AVATARS = 5;
const $d2662eadf49776f1$var$styles = {
    avatarBackground: null,
    avatarInitial: null
};
const $d2662eadf49776f1$var$toAvatarData = (users)=>users.map((user)=>{
        const displayName = user.name ?? user.email ?? '';
        return user.avatar ? {
            key: user.id,
            name: displayName,
            src: user.avatar
        } : {
            key: user.id,
            name: displayName,
            borderColor: "var(--ds-border-inverse, #FFFFFF)",
            children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7zsi1.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: (0, $hekY6.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1osq _4t3i1osq _bfhk1856"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                className: (0, $hekY6.default)([
                    "_syaz15cr _k48p1pd9 _y3gn1h6o"
                ])
            }, displayName.trim()[0]?.toUpperCase() ?? '')))
        };
    });
const $d2662eadf49776f1$var$ICON_MATRIX = {
    mailto: {
        Jira: {
            light: (0, (/*@__PURE__*/$parcel$interopDefault($9A30E))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($2KW1v)))
        },
        Confluence: {
            light: (0, (/*@__PURE__*/$parcel$interopDefault($4XQXn))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($bBCy7)))
        }
    },
    slack: {
        Jira: {
            light: (0, (/*@__PURE__*/$parcel$interopDefault($dxDFB))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($f57An)))
        },
        Confluence: {
            light: (0, (/*@__PURE__*/$parcel$interopDefault($bQuWd))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($6eWaG)))
        }
    }
}; /**
              * InviteOnThirdPartyLinkFlag
              *
              * Shown when a Slack or mailto link is pasted in Jira or Confluence,
              * and there are users in that context that don't have access to the current
              * product.
              * Renders a composite Slack or mailto + product icon, a stacked avatar group
              * of the affected teammates, a contextual title / description, and an invite
              * / dismiss action pair.
              *
              */ 
const $d2662eadf49776f1$export$2c38401f39649bd5 = ({ usersWithoutAccess: usersWithoutAccess, onActioned: onActioned, onInvite: onInvite, onDismiss: onDismiss, productIcon: productIcon, productName: productName, showDontShowAgain: showDontShowAgain, spaceName: spaceName, source: source, ...props })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const isDark = colorMode === 'dark'; // Early return for empty usersWithoutAccess array.
    if (usersWithoutAccess.length === 0) return null;
    const iconSet = $d2662eadf49776f1$var$ICON_MATRIX[source][productName];
    const flagIcon = isDark ? iconSet.dark : iconSet.light;
    const userCount = usersWithoutAccess.length;
    const isSingleUser = userCount === 1;
    const firstUser = usersWithoutAccess[0];
    const isNonUser = source === 'mailto' && !firstUser.id;
    const showUserIdentity = isSingleUser && source === 'slack';
    const singleUserName = firstUser.name || firstUser.email;
    const singleUserTitle = showUserIdentity ? singleUserName : formatMessage((0, $9W3iZ.messages).fallbackSingleUserTitle);
    const singleUserTitleForDescription = showUserIdentity ? singleUserName : firstUser.email;
    const avatarData = $d2662eadf49776f1$var$toAvatarData(usersWithoutAccess);
    const actions = [
        {
            content: formatMessage((0, $9W3iZ.messages).ctaInvite, {
                userCount: userCount
            }),
            onClick: ()=>{
                onActioned?.();
                return onInvite?.();
            }
        },
        ...showDontShowAgain ? [
            {
                content: formatMessage((0, $9W3iZ.messages).ctaDontShowAgain),
                onClick: ()=>onDismiss?.(props.id, 'dontShowAgainButton')
            }
        ] : [
            {
                content: formatMessage((0, $9W3iZ.messages).ctaNotNow),
                onClick: ()=>onDismiss?.(props.id, 'notNowButton')
            }
        ]
    ];
    const titleText = formatMessage((0, $9W3iZ.messages).titleInviteUser, {
        userCount: userCount,
        ...isSingleUser ? {
            singleUserTitle: singleUserTitle
        } : {},
        productName: productName
    });
    const descriptionText = !isNonUser ? formatMessage((0, $9W3iZ.messages).descriptionInviteUser, {
        userCount: userCount,
        ...isSingleUser ? {
            singleUserTitle: singleUserTitleForDescription
        } : {},
        source: source,
        spaceName: spaceName
    }) : formatMessage((0, $9W3iZ.messages).descriptionInviteNonUser, {
        email: firstUser?.email,
        productName: productName,
        spaceName: spaceName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $FKQbh.default), {
        ...props,
        testId: `invite-on-third-party-${source}-link-flag`,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            src: flagIcon,
            alt: productName
        }),
        onDismissed: (id)=>onDismiss?.(id, 'closeButton'),
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            alignInline: "start"
        }, !isSingleUser && avatarData.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bcDqz.default), {
            appearance: "stack",
            size: "small",
            maxCount: $d2662eadf49776f1$var$MAX_AVATARS,
            data: avatarData,
            label: formatMessage((0, $9W3iZ.messages).avatarGroupLabel),
            testId: `invite-on-third-party-${source}-link-flag-avatars`,
            shouldPopupRenderToParent: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            as: "p"
        }, titleText)),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            as: "p"
        }, descriptionText),
        actions: actions
    });
};
const $d2662eadf49776f1$export$dc7633a471e7e3b2 = (0, $bCGJJ.withLocalIntl)($d2662eadf49776f1$export$2c38401f39649bd5);
module.exports["InviteOnThirdPartyLinkFlag"] = $d2662eadf49776f1$export$dc7633a471e7e3b2;

});

parcelRegister("bcDqz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $arQY7 = parcelRequire("arQY7");


var $fM984 = parcelRequire("fM984");


var $dpsRj = parcelRequire("dpsRj");


var $aRyr7 = parcelRequire("aRyr7");


var $6JrSr = parcelRequire("6JrSr");


var $8FgJC = parcelRequire("8FgJC");


var $iFlah = parcelRequire("iFlah");


var $ixfCV = parcelRequire("ixfCV");


var $5wHqn = parcelRequire("5wHqn");


var $lpNn5 = parcelRequire("lpNn5");


var $flNGL = parcelRequire("flNGL");


var $j9iLd = parcelRequire("j9iLd");


var $91JJR = parcelRequire("91JJR");


var $f4ONb = parcelRequire("f4ONb");


var $6oFjM = parcelRequire("6oFjM");


var $eyQF5 = parcelRequire("eyQF5");


var $942TG = parcelRequire("942TG");


var $68jmg = parcelRequire("68jmg");


var $g2o3j = parcelRequire("g2o3j");

const $6574fd66b51c7dea$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $6574fd66b51c7dea$var$AvatarGroup = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { appearance: t1, moreIndicatorAppearance: moreIndicatorAppearance, avatar: t2, borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: t3, size: t4, testId: testId, label: t5, moreIndicatorLabel: moreIndicatorLabel, tooltipPosition: t6, shouldPopupRenderToParent: t7 } = t0;
    const appearance = t1 === undefined ? "stack" : t1;
    const avatar = t2 === undefined ? (0, $arQY7.default) : t2;
    const showMoreButtonProps = t3 === undefined ? {} : t3;
    const size = t4 === undefined ? "medium" : t4;
    const label = t5 === undefined ? "avatar group" : t5;
    const tooltipPosition = t6 === undefined ? "bottom" : t6;
    const shouldPopupRenderToParent = t7 === undefined ? false : t7;
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $cozmU.useState)(false);
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    let t8;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = ()=>setIsOpen(false);
        $[0] = t8;
    } else t8 = $[0];
    const onClose = t8;
    let t9;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (event)=>{
            const { clientX: clientX, clientY: clientY, type: type } = event;
            if (type === "keydown" || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
            setIsOpen($6574fd66b51c7dea$var$_temp);
        };
        $[1] = t9;
    } else t9 = $[1];
    const handleTriggerClicked = t9;
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $aRyr7.default)();
    const { AvatarGroupItem: avatarGroupItemOverrides, Avatar: avatarOverrides, MoreIndicator: moreIndicatorOverrides } = (0, $91JJR.getOverrides)(overrides);
    let t10;
    let t11;
    if ($[2] !== isFocused || $[3] !== isOpen) {
        t10 = ()=>{
            if (!isOpen) setTriggeredUsingKeyboard(false);
            if ((0, $ixfCV.fg)("platform-dst-top-layer")) return 0, $dpsRj.default;
            if (!isFocused) return 0, $dpsRj.default;
            if (isOpen) return 0, $dpsRj.default;
            (0, $cbY7C.bind)(window, {
                type: "keydown",
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $fM984.KEY_DOWN)) {
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
            const unbind = ()=>{
                (0, $cbY7C.bind)(window, {
                    type: "keydown",
                    listener: function openOnKeyDown(e_0) {
                        if (e_0.key === (0, $fM984.KEY_DOWN)) {
                            e_0.preventDefault();
                            handleTriggerClicked(e_0);
                        }
                    }
                });
            };
            return unbind;
        };
        t11 = [
            isFocused,
            isOpen,
            handleTriggerClicked
        ];
        $[2] = isFocused;
        $[3] = isOpen;
        $[4] = t10;
        $[5] = t11;
    } else {
        t10 = $[4];
        t11 = $[5];
    }
    (0, $cozmU.useEffect)(t10, t11);
    const renderMoreDropdown = function renderMoreDropdown(max, total, labelId) {
        if (total <= max) return null;
        const renderMoreButton = (t12)=>{
            const { "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup, onClick: onClick, ...props } = t12;
            return moreIndicatorOverrides.render((0, $942TG.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                moreIndicatorLabel: moreIndicatorLabel,
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                onClick: onClick,
                ...props,
                ...(0, $ixfCV.fg)("jira-ai-agent-stack") && {
                    appearance: moreIndicatorAppearance
                }
            });
        };
        if (typeof onMoreClick === "function") return renderMoreButton({
            onClick: onMoreClick
        });
        if ((0, $ixfCV.fg)("platform-dst-top-layer")) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j9iLd.MoreDropdownTopLayer), {
            isOpen: isOpen,
            onClose: onClose,
            isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
            data: data,
            max: max,
            overrides: overrides,
            onAvatarClick: onAvatarClick,
            testId: testId,
            labelId: labelId,
            renderMoreButton: renderMoreButton,
            handleTriggerClicked: handleTriggerClicked,
            bindFocus: bindFocus
        });
        const boundary = boundariesElement === "scrollParent" ? "clippingParents" : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === "scrollParent") return;
            return boundariesElement === "window" ? "document" : "viewport";
        })();
        const avatarComponent = avatar && (0, $ixfCV.fg)("platform-avatar-group-pass-avatar-to-item") ? avatar : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: 510,
            shouldRenderToParent: shouldPopupRenderToParent,
            content: (t13)=>{
                const { setInitialFocusRef: setInitialFocusRef } = t13;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6oFjM.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eyQF5.default), {
                    onClick: $6574fd66b51c7dea$var$_temp2,
                    minWidth: 250,
                    maxHeight: 300,
                    setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
                    titleId: labelId,
                    testId: `${testId}--section`
                }, data.slice(max).map((avatarData, index)=>avatarGroupItemOverrides.render((0, $flNGL.default), {
                        avatar: avatarData,
                        avatarComponent: avatarComponent,
                        onAvatarClick: onAvatarClick,
                        avatarOverrides: avatarOverrides,
                        testId: testId && `${testId}--avatar-group-item-${index + max}`,
                        index: index + max
                    }, index + max)))));
            },
            trigger: (triggerProps)=>(0, $ixfCV.fg)("platform-dst-motion-uplift") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iFlah.default), {
                    enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
                    exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
                }, renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                })) : renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    };
    const max_0 = maxCount === undefined || maxCount === 0 ? $6574fd66b51c7dea$var$MAX_COUNT[appearance] : maxCount;
    const total_0 = data.length;
    const maxAvatar = total_0 > max_0 ? max_0 - 1 : max_0;
    const groupId = (0, $6JrSr.useId)();
    return appearance === "stack" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $68jmg.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        size: size
    }, data.slice(0, maxAvatar).map((avatarData_0, idx)=>{
        const callback = avatarData_0.onClick || onAvatarClick;
        const finalAvatar = avatarOverrides.render(avatar, {
            ...avatarData_0,
            size: size,
            borderColor: borderColor || avatarData_0.borderColor,
            testId: testId && `${testId}--avatar-${idx}`,
            onClick: callback ? (event_0, analyticsEvent)=>{
                callback(event_0, analyticsEvent, idx);
            } : undefined,
            stackIndex: max_0 - idx
        }, idx);
        if ((0, $ixfCV.fg)("platform-dst-motion-uplift")) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iFlah.default), {
            enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
            key: (0, $g2o3j.composeUniqueKey)(avatarData_0, idx)
        }, !isTooltipDisabled && !avatarData_0.isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: avatarData_0.name,
            testId: testId && `${testId}--tooltip-${idx}`,
            position: tooltipPosition
        }, finalAvatar) : finalAvatar);
        else return !isTooltipDisabled && !avatarData_0.isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            key: (0, $g2o3j.composeUniqueKey)(avatarData_0, idx),
            content: avatarData_0.name,
            testId: testId && `${testId}--tooltip-${idx}`,
            position: tooltipPosition
        }, finalAvatar) : finalAvatar;
    }), renderMoreDropdown(+maxAvatar, total_0, groupId)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f4ONb.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label
    }, data.slice(0, maxAvatar).map((avatarData_1, idx_0)=>{
        const callback_0 = avatarData_1.onClick || onAvatarClick;
        const finalAvatar_0 = avatarOverrides.render(avatar, {
            ...avatarData_1,
            size: size,
            borderColor: borderColor || avatarData_1.borderColor,
            testId: testId && `${testId}--avatar-${idx_0}`,
            onClick: callback_0 ? (event_1, analyticsEvent_0)=>{
                callback_0(event_1, analyticsEvent_0, idx_0);
            } : undefined,
            stackIndex: max_0 - idx_0
        }, idx_0);
        if ((0, $ixfCV.fg)("platform-dst-motion-uplift")) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iFlah.default), {
            enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
            key: (0, $g2o3j.composeUniqueKey)(avatarData_1, idx_0)
        }, !isTooltipDisabled && !avatarData_1.isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: avatarData_1.name,
            testId: testId && `${testId}--tooltip-${idx_0}`,
            position: tooltipPosition
        }, finalAvatar_0) : finalAvatar_0);
        else return !isTooltipDisabled && !avatarData_1.isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            key: (0, $g2o3j.composeUniqueKey)(avatarData_1, idx_0),
            content: avatarData_1.name,
            testId: testId && `${testId}--tooltip-${idx_0}`,
            position: tooltipPosition
        }, finalAvatar_0) : finalAvatar_0;
    }), renderMoreDropdown(+maxAvatar, total_0, groupId));
} : ({ appearance: appearance = 'stack', moreIndicatorAppearance: moreIndicatorAppearance, avatar: avatar = (0, $arQY7.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', moreIndicatorLabel: moreIndicatorLabel, tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $cozmU.useState)(false);
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const onClose = (0, $cozmU.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $cozmU.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen_0)=>!isOpen_0);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $aRyr7.default)();
    const { AvatarGroupItem: avatarGroupItemOverrides, Avatar: avatarOverrides, MoreIndicator: moreIndicatorOverrides } = (0, $91JJR.getOverrides)(overrides);
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow.
    // Skipped when top-layer is enabled — DropdownMenu/top-layer handles
    // ArrowDown-to-open and arrow key navigation internally.
    (0, $cozmU.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Top-layer path: ArrowDown-to-open is handled by the menu's
        // own focus management, so skip the parent's ArrowDown handler.
        if ((0, $ixfCV.fg)('platform-dst-top-layer')) return 0, $dpsRj.default;
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $dpsRj.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $dpsRj.default;
        (0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $fM984.KEY_DOWN)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $cbY7C.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e_0) {
                    if (e_0.key === (0, $fM984.KEY_DOWN)) {
                        // prevent page scroll
                        e_0.preventDefault();
                        handleTriggerClicked(e_0);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total, labelId) {
        if (total <= max) return null;
        const renderMoreButton = ({ 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, onClick: onClick, ...props })=>moreIndicatorOverrides.render((0, $942TG.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                moreIndicatorLabel: moreIndicatorLabel,
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                onClick: onClick,
                ...props,
                ...(0, $ixfCV.fg)('jira-ai-agent-stack') && {
                    appearance: moreIndicatorAppearance
                }
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        if ((0, $ixfCV.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j9iLd.MoreDropdownTopLayer), {
            isOpen: isOpen,
            onClose: onClose,
            isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
            data: data,
            max: max,
            // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
            overrides: overrides,
            onAvatarClick: onAvatarClick,
            testId: testId,
            labelId: labelId,
            renderMoreButton: renderMoreButton,
            handleTriggerClicked: handleTriggerClicked,
            bindFocus: bindFocus
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        const avatarComponent = avatar && (0, $ixfCV.fg)('platform-avatar-group-pass-avatar-to-item') ? avatar : undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: 510,
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6oFjM.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eyQF5.default), {
                    onClick: (e_1)=>e_1.stopPropagation(),
                    minWidth: 250,
                    maxHeight: 300,
                    setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
                    titleId: labelId,
                    testId: `${testId}--section`
                }, data.slice(max).map((avatarData, index)=>avatarGroupItemOverrides.render((0, $flNGL.default), {
                        avatar: avatarData,
                        avatarComponent: avatarComponent,
                        onAvatarClick: onAvatarClick,
                        avatarOverrides: avatarOverrides,
                        testId: testId && `${testId}--avatar-group-item-${index + max}`,
                        index: index + max
                    }, // This index holds the true index,
                    // adding up the index of non-overflowed avatars and overflowed avatars.
                    index + max))))),
            trigger: (triggerProps)=>(0, $ixfCV.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iFlah.default), {
                    enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
                    exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)"
                }, renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                })) : renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max_0 = maxCount === undefined || maxCount === 0 ? $6574fd66b51c7dea$var$MAX_COUNT[appearance] : maxCount;
    const total_0 = data.length;
    const maxAvatar = total_0 > max_0 ? max_0 - 1 : max_0;
    const groupId = (0, $6JrSr.useId)();
    return appearance === 'stack' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $68jmg.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label,
        size: size
    }, data.slice(0, maxAvatar).map((avatarData_0, idx)=>{
        const callback = avatarData_0.onClick || onAvatarClick;
        const finalAvatar = avatarOverrides.render(avatar, {
            ...avatarData_0,
            size: size,
            borderColor: borderColor || avatarData_0.borderColor,
            testId: testId && `${testId}--avatar-${idx}`,
            onClick: callback ? (event_0, analyticsEvent)=>{
                callback(event_0, analyticsEvent, idx);
            } : undefined,
            stackIndex: max_0 - idx
        }, idx);
        if ((0, $ixfCV.fg)('platform-dst-motion-uplift')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iFlah.default), {
            enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
            key: (0, $g2o3j.composeUniqueKey)(avatarData_0, idx)
        }, !isTooltipDisabled && !avatarData_0.isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: avatarData_0.name,
            testId: testId && `${testId}--tooltip-${idx}`,
            position: tooltipPosition
        }, finalAvatar) : finalAvatar);
        else return !isTooltipDisabled && !avatarData_0.isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            key: (0, $g2o3j.composeUniqueKey)(avatarData_0, idx),
            content: avatarData_0.name,
            testId: testId && `${testId}--tooltip-${idx}`,
            position: tooltipPosition
        }, finalAvatar) : finalAvatar;
    }), renderMoreDropdown(+maxAvatar, total_0, groupId)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f4ONb.default), {
        id: groupId,
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label
    }, data.slice(0, maxAvatar).map((avatarData_1, idx_0)=>{
        const callback_0 = avatarData_1.onClick || onAvatarClick;
        const finalAvatar_0 = avatarOverrides.render(avatar, {
            ...avatarData_1,
            size: size,
            borderColor: borderColor || avatarData_1.borderColor,
            testId: testId && `${testId}--avatar-${idx_0}`,
            onClick: callback_0 ? (event_1, analyticsEvent_0)=>{
                callback_0(event_1, analyticsEvent_0, idx_0);
            } : undefined,
            stackIndex: max_0 - idx_0
        }, idx_0);
        if ((0, $ixfCV.fg)('platform-dst-motion-uplift')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iFlah.default), {
            enteringAnimation: "var(--ds-avatar-enter, 150ms cubic-bezier(0.4, 1, 0.6, 1) ScaleIn80to100, 150ms cubic-bezier(0.4, 1, 0.6, 1) FadeIn0to100)",
            exitingAnimation: "var(--ds-avatar-exit, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) ScaleOut100to80, 100ms cubic-bezier(0.6, 0, 0.8, 0.6) FadeOut100to0)",
            key: (0, $g2o3j.composeUniqueKey)(avatarData_1, idx_0)
        }, !isTooltipDisabled && !avatarData_1.isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: avatarData_1.name,
            testId: testId && `${testId}--tooltip-${idx_0}`,
            position: tooltipPosition
        }, finalAvatar_0) : finalAvatar_0);
        else return !isTooltipDisabled && !avatarData_1.isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            key: (0, $g2o3j.composeUniqueKey)(avatarData_1, idx_0),
            content: avatarData_1.name,
            testId: testId && `${testId}--tooltip-${idx_0}`,
            position: tooltipPosition
        }, finalAvatar_0) : finalAvatar_0;
    }), renderMoreDropdown(+maxAvatar, total_0, groupId));
};
var $6574fd66b51c7dea$export$2e2bcd8739ae039 = $6574fd66b51c7dea$var$AvatarGroup;
function $6574fd66b51c7dea$var$_temp(isOpen_0) {
    return !isOpen_0;
}
function $6574fd66b51c7dea$var$_temp2(e_1) {
    return e_1.stopPropagation();
}
module.exports["default"] = $6574fd66b51c7dea$export$2e2bcd8739ae039;

});

parcelRegister("aRyr7", function(module, exports) {
$parcel$export(module.exports, "default", () => $09649a4f36a12f35$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $09649a4f36a12f35$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $cozmU.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $cozmU.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $cozmU.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("flNGL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $arQY7 = parcelRequire("arQY7");


var $lmzCg = parcelRequire("lmzCg");


var $9d7Pd = parcelRequire("9d7Pd");

var $kD4eB = parcelRequire("kD4eB");

var $8oBbn = parcelRequire("8oBbn");


var $ixfCV = parcelRequire("ixfCV");


var $81Xw1 = parcelRequire("81Xw1");

const $74934c00a5cc9b19$var$AvatarGroupItem = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(24);
    const { avatar: avatar, avatarComponent: avatarComponent, index: index, onAvatarClick: onAvatarClick, testId: testId, avatarOverrides: avatarOverrides, role: role } = props;
    const { analyticsContext: analyticsContext, appearance: appearance, as: as, borderColor: _borderColor, children: children, href: href, isDisabled: isDisabled, key: _key, label: label, name: name, onClick: onClick, presence: presence, size: _size, src: src, stackIndex: stackIndex, status: status, tabIndex: tabIndex, target: target, testId: _groupItemTestId, ...rest } = avatar;
    const itemRef = (0, $81Xw1.default)();
    let t0;
    if ($[0] !== role) {
        t0 = (t1)=>{
            const { children: children_0, className: className, disabled: disabled, draggable: draggable, onClick: onClick_0, onDragStart: onDragStart, onMouseDown: onMouseDown, ref: ref_0, tabIndex: tabIndex_0, "data-testid": testId_0, ...props_0 } = t1;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
                type: "button",
                className: className,
                disabled: disabled,
                draggable: draggable,
                onClick: onClick_0,
                onDragStart: onDragStart,
                onMouseDown: onMouseDown,
                ref: ref_0,
                tabIndex: tabIndex_0,
                "data-testid": testId_0,
                role: role,
                ...props_0
            }, children_0);
        };
        $[0] = role;
        $[1] = t0;
    } else t0 = $[1];
    const CustomComponent = t0;
    const AvatarComponent = (0, $ixfCV.fg)("platform-avatar-group-pass-avatar-to-item") ? avatarComponent ?? (0, $arQY7.default) : (0, $arQY7.default);
    const AvatarIcon = avatarOverrides && (0, $ixfCV.fg)("platform-avatar-group-pass-avatar-to-item") ? avatarOverrides.render(AvatarComponent, {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: "transparent",
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: "",
        presence: presence,
        size: "small",
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    }, 0) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(AvatarComponent, {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: "transparent",
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: "",
        presence: presence,
        size: "small",
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    });
    const callback = onClick || onAvatarClick;
    let t1;
    if ($[2] !== AvatarIcon || $[3] !== callback || $[4] !== href || $[5] !== index || $[6] !== itemRef || $[7] !== name || $[8] !== ref || $[9] !== role || $[10] !== target || $[11] !== testId) {
        t1 = Symbol.for("react.early_return_sentinel");
        bb0: {
            if (href) {
                let t2;
                if ($[13] !== callback || $[14] !== index) {
                    t2 = (event)=>callback && callback(event, undefined, index);
                    $[13] = callback;
                    $[14] = index;
                    $[15] = t2;
                } else t2 = $[15];
                t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8oBbn.default), {
                    ref: (0, $lmzCg.default)([
                        ref,
                        itemRef
                    ]),
                    href: href,
                    target: target,
                    rel: target === "_blank" ? "noopener noreferrer" : undefined,
                    iconBefore: AvatarIcon,
                    testId: testId,
                    role: role,
                    onClick: t2
                }, name);
                break bb0;
            }
            if (typeof callback === "function") {
                let t2;
                if ($[16] !== callback || $[17] !== index) {
                    t2 = (event_0)=>callback && callback(event_0, undefined, index);
                    $[16] = callback;
                    $[17] = index;
                    $[18] = t2;
                } else t2 = $[18];
                t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                    ref: (0, $lmzCg.default)([
                        ref,
                        itemRef
                    ]),
                    onClick: t2,
                    iconBefore: AvatarIcon,
                    testId: testId,
                    role: role
                }, name);
                break bb0;
            }
        }
        $[2] = AvatarIcon;
        $[3] = callback;
        $[4] = href;
        $[5] = index;
        $[6] = itemRef;
        $[7] = name;
        $[8] = ref;
        $[9] = role;
        $[10] = target;
        $[11] = testId;
        $[12] = t1;
    } else t1 = $[12];
    if (t1 !== Symbol.for("react.early_return_sentinel")) return t1;
    let t2;
    if ($[19] !== AvatarIcon || $[20] !== CustomComponent || $[21] !== name || $[22] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kD4eB.default), {
            iconBefore: AvatarIcon,
            component: CustomComponent,
            testId: testId
        }, name);
        $[19] = AvatarIcon;
        $[20] = CustomComponent;
        $[21] = name;
        $[22] = testId;
        $[23] = t2;
    } else t2 = $[23];
    return t2;
} : (props, ref)=>{
    const { avatar: avatar, avatarComponent: avatarComponent, index: index, onAvatarClick: onAvatarClick, testId: testId, avatarOverrides: avatarOverrides, role: role } = props;
    const { analyticsContext: analyticsContext, appearance: appearance, as: as, borderColor: _borderColor, children: children, href: href, isDisabled: isDisabled, key: _key, label: label, name: name, onClick: onClick, presence: presence, size: _size, src: src, stackIndex: stackIndex, status: status, tabIndex: tabIndex, target: target, testId: _groupItemTestId, ...rest } = avatar;
    const itemRef = (0, $81Xw1.default)();
    const CustomComponent = ({ children: children_0, className: className, disabled: disabled, draggable: draggable, onClick: onClick_0, onDragStart: onDragStart, onMouseDown: onMouseDown, ref: ref_0, tabIndex: tabIndex_0, 'data-testid': testId_0, ...props_0 })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
            type: "button",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            disabled: disabled,
            draggable: draggable,
            onClick: onClick_0,
            // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
            onDragStart: onDragStart,
            onMouseDown: onMouseDown,
            ref: ref_0,
            tabIndex: tabIndex_0,
            "data-testid": testId_0,
            role: role,
            ...props_0
        }, children_0);
    };
    const AvatarComponent = (0, $ixfCV.fg)('platform-avatar-group-pass-avatar-to-item') ? avatarComponent ?? (0, $arQY7.default) : (0, $arQY7.default);
    const AvatarIcon = avatarOverrides && (0, $ixfCV.fg)('platform-avatar-group-pass-avatar-to-item') ? avatarOverrides.render(AvatarComponent, {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: 'transparent',
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: '',
        presence: presence,
        size: 'small',
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    }, 0) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(AvatarComponent, {
        ...rest,
        analyticsContext: analyticsContext,
        appearance: appearance,
        as: as,
        borderColor: "transparent",
        children: children,
        isDisabled: isDisabled,
        label: label,
        name: "",
        presence: presence,
        size: "small",
        src: src,
        stackIndex: stackIndex,
        status: status,
        tabIndex: tabIndex,
        testId: testId && `${testId}--avatar`
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8oBbn.default), {
        ref: (0, $lmzCg.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        role: role,
        onClick: (event)=>callback && callback(event, undefined, index)
    }, name);
    if (typeof callback === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        ref: (0, $lmzCg.default)([
            ref,
            itemRef
        ]),
        onClick: (event_0)=>callback && callback(event_0, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId,
        role: role
    }, name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kD4eB.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId
    }, name);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$74934c00a5cc9b19$export$2e2bcd8739ae039 = $74934c00a5cc9b19$var$AvatarGroupItem;
module.exports["default"] = $74934c00a5cc9b19$export$2e2bcd8739ae039;

});

parcelRegister("81Xw1", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kVHjt = parcelRequire("kVHjt");

// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
const $f5ac5fe41e50defd$var$useRegisterItemWithFocusManager = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useRegisterItemWithFocusManager() {
    const $ = (0, $bDgLe.c)(3);
    const { registerRef: registerRef } = (0, $cozmU.useContext)((0, $kVHjt.FocusManagerContext));
    const itemRef = (0, $cozmU.useRef)(null);
    let t0;
    let t1;
    if ($[0] !== registerRef) {
        t0 = ()=>{
            if (itemRef.current !== null) registerRef(itemRef.current);
        };
        t1 = [
            registerRef
        ];
        $[0] = registerRef;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return itemRef;
} : function useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $cozmU.useContext)((0, $kVHjt.FocusManagerContext));
    const itemRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
};
var $f5ac5fe41e50defd$export$2e2bcd8739ae039 = $f5ac5fe41e50defd$var$useRegisterItemWithFocusManager;
module.exports["default"] = $f5ac5fe41e50defd$export$2e2bcd8739ae039;

});

parcelRegister("kVHjt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");

const $b95dd4fa661016c8$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $cozmU.createContext)({
    menuItemRefs: [],
    registerRef: (0, $dpsRj.default)
});
module.exports["FocusManagerContext"] = $b95dd4fa661016c8$export$f18c1d4fc7326096;

});

parcelRegister("j9iLd", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $fM984 = parcelRequire("fM984");


var $6IL1T = parcelRequire("6IL1T");

var $8FgJC = parcelRequire("8FgJC");


var $lBMxH = parcelRequire("lBMxH");


var $aRDbl = parcelRequire("aRDbl");


var $kVXS3 = parcelRequire("kVXS3");


var $juXYb = parcelRequire("juXYb");


var $97Yf0 = parcelRequire("97Yf0");


var $iNWdN = parcelRequire("iNWdN");


var $1unCm = parcelRequire("1unCm");


var $flNGL = parcelRequire("flNGL");

const $d2c81e37a1471dd1$var$topLayerPlacement = (0, $aRDbl.fromLegacyPlacement)({
    legacy: 'bottom-end'
});
function $d2c81e37a1471dd1$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                    key: index,
                    ...props
                }),
            ...overrides?.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                    key: index,
                    ...props
                }),
            ...overrides?.Avatar
        },
        MoreIndicator: {
            render: (Component, props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props),
            ...overrides?.MoreIndicator
        }
    };
}
function $d2c81e37a1471dd1$export$36ea40361987a72d({ isOpen: isOpen, onClose: onClose, isTriggeredUsingKeyboard: _isTriggeredUsingKeyboard, data: data, max: max, overrides: overrides, onAvatarClick: onAvatarClick, testId: testId, labelId: labelId, renderMoreButton: renderMoreButton, handleTriggerClicked: handleTriggerClicked, bindFocus: _bindFocus }) {
    const handleOnClose = (0, $cozmU.useCallback)(({ reason: _reason })=>{
        onClose();
    }, [
        onClose
    ]);
    const triggerRef = (0, $cozmU.useRef)(null);
    const popoverRef = (0, $cozmU.useRef)(null);
    const menuRef = (0, $cozmU.useRef)(null);
    const overflowMenuTestId = testId ? `${testId}--overflow-menu` : undefined;
    const popoverId = (0, $1unCm.usePopoverId)();
    (0, $97Yf0.useAnchorPosition)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: $d2c81e37a1471dd1$var$topLayerPlacement,
        isOpen: isOpen
    });
    // Arrow key navigation inside the open menu
    (0, $iNWdN.useArrowNavigation)({
        containerRef: menuRef,
        onClose: onClose,
        isEnabled: isOpen
    });
    // ArrowDown-to-open: when the trigger is focused and the menu is closed,
    // pressing ArrowDown opens the menu (WAI-ARIA menu button pattern).
    //
    // Bind the keydown listener directly to the trigger element via its ref so
    // that opening the menu does not trigger a focus-driven re-render of the
    // host component, which would unmount and remount the menu items and drop
    // menuitem focus.
    (0, $cozmU.useEffect)(()=>{
        const trigger = triggerRef.current;
        if (!trigger || isOpen) return;
        return (0, $cbY7C.bind)(trigger, {
            type: 'keydown',
            listener: function openOnArrowDown(event) {
                if (event.key === (0, $fM984.KEY_DOWN)) {
                    // Prevent page scroll when opening the menu via ArrowDown.
                    event.preventDefault();
                    handleTriggerClicked(event);
                }
            }
        });
    }, [
        isOpen,
        handleTriggerClicked
    ]);
    const triggerAria = (0, $lBMxH.getAriaForTrigger)({
        role: 'menu',
        isOpen: isOpen,
        popoverId: popoverId
    });
    const setTriggerRef = (0, $cozmU.useCallback)((node)=>{
        triggerRef.current = node;
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderMoreButton({
        ref: setTriggerRef,
        ...triggerAria,
        onClick: handleTriggerClicked
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kVXS3.Popover), {
        ref: popoverRef,
        id: popoverId,
        role: "menu",
        label: "avatar group",
        isOpen: isOpen,
        onClose: handleOnClose,
        animate: true,
        placement: $d2c81e37a1471dd1$var$topLayerPlacement,
        testId: overflowMenuTestId ? `${overflowMenuTestId}--content` : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $juXYb.PopoverSurface), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: menuRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), {
        minWidth: 250,
        maxHeight: 300
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
        titleId: labelId,
        testId: testId ? `${testId}--section` : undefined
    }, data.slice(max).map((avatar, index)=>$d2c81e37a1471dd1$var$getOverrides(overrides).AvatarGroupItem.render((0, $flNGL.default), {
            avatar: avatar,
            onAvatarClick: onAvatarClick,
            testId: testId ? `${testId}--avatar-group-item-${index + max}` : undefined,
            index: index + max,
            role: 'menuitem'
        }, index + max))))))));
}
module.exports["MoreDropdownTopLayer"] = $d2c81e37a1471dd1$export$36ea40361987a72d;

});

parcelRegister("iNWdN", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $haNN4 = parcelRequire("haNN4");


var $fM984 = parcelRequire("fM984");


var $3hJ5V = parcelRequire("3hJ5V");


var $7MWxP = parcelRequire("7MWxP");


var $jzRXW = parcelRequire("jzRXW");

const $341d868aa0ec42f2$var$menuScope = '[role="menu"]';
const $341d868aa0ec42f2$export$23dfbae28e0cc453 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useArrowNavigation(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { containerRef: containerRef, onClose: onClose, onNestedOpen: onNestedOpen, onNestedClose: onNestedClose, isEnabled: t1, filter: filter } = t0;
    const isEnabled = t1 === undefined ? true : t1;
    let t2;
    if ($[0] !== containerRef || $[1] !== filter || $[2] !== onClose || $[3] !== onNestedClose || $[4] !== onNestedOpen) {
        t2 = (event)=>{
            const container = containerRef.current;
            if (!container) return;
            const focused = (0, $haNN4.getDocument)()?.activeElement;
            if (focused instanceof HTMLElement) {
                if (filter) {
                    if (!filter(focused, container)) return;
                }
                if (!filter && container.getAttribute("role") === "menu" && focused.closest($341d868aa0ec42f2$var$menuScope) !== container) return;
            }
            if (event.key === (0, $fM984.KEY_DOWN)) {
                event.preventDefault();
                (0, $jzRXW.getNextFocusable)({
                    container: container,
                    direction: "forwards",
                    filter: filter
                })?.focus();
                return;
            }
            if (event.key === (0, $fM984.KEY_UP)) {
                event.preventDefault();
                (0, $jzRXW.getNextFocusable)({
                    container: container,
                    direction: "backwards",
                    filter: filter
                })?.focus();
                return;
            }
            if (event.key === (0, $fM984.KEY_HOME)) {
                event.preventDefault();
                (0, $3hJ5V.getFirstFocusable)({
                    container: container,
                    filter: filter
                })?.focus();
                return;
            }
            if (event.key === (0, $fM984.KEY_END)) {
                event.preventDefault();
                (0, $7MWxP.getLastFocusable)({
                    container: container,
                    filter: filter
                })?.focus();
                return;
            }
            if (event.key === (0, $fM984.KEY_TAB)) {
                onClose();
                return;
            }
            if (event.key === "ArrowRight") {
                if (onNestedOpen && focused instanceof HTMLElement && focused.hasAttribute("aria-haspopup")) {
                    event.preventDefault();
                    onNestedOpen({
                        trigger: focused
                    });
                }
                return;
            }
            if (event.key === "ArrowLeft") {
                if (onNestedClose) {
                    const isNested = container.parentElement?.closest($341d868aa0ec42f2$var$menuScope) !== null;
                    if (isNested) {
                        event.preventDefault();
                        onNestedClose();
                    }
                }
                return;
            }
        };
        $[0] = containerRef;
        $[1] = filter;
        $[2] = onClose;
        $[3] = onNestedClose;
        $[4] = onNestedOpen;
        $[5] = t2;
    } else t2 = $[5];
    const handleKeyDown = t2;
    let t3;
    let t4;
    if ($[6] !== containerRef || $[7] !== handleKeyDown || $[8] !== isEnabled) {
        t3 = ()=>{
            const container_0 = containerRef.current;
            if (!container_0 || !isEnabled) return;
            return (0, $cbY7C.bind)(container_0, {
                type: "keydown",
                listener: handleKeyDown
            });
        };
        t4 = [
            containerRef,
            handleKeyDown,
            isEnabled
        ];
        $[6] = containerRef;
        $[7] = handleKeyDown;
        $[8] = isEnabled;
        $[9] = t3;
        $[10] = t4;
    } else {
        t3 = $[9];
        t4 = $[10];
    }
    (0, $cozmU.useEffect)(t3, t4);
} : function useArrowNavigation({ containerRef: containerRef, onClose: onClose, onNestedOpen: onNestedOpen, onNestedClose: onNestedClose, isEnabled: isEnabled = true, filter: filter }) {
    const handleKeyDown = (0, $cozmU.useCallback)((event)=>{
        const container = containerRef.current;
        if (!container) return;
        // Guard: only handle the event if the currently focused element
        // belongs to this menu level. The focused element's closest
        // [role="menu"] must be this container (not a nested sub-menu).
        // When no filter is provided, fall back to the closest-menu check
        // if the container has role="menu".
        const focused = (0, $haNN4.getDocument)()?.activeElement;
        if (focused instanceof HTMLElement) {
            if (filter) {
                if (!filter(focused, container)) return;
            }
            if (!filter && container.getAttribute('role') === 'menu' && focused.closest($341d868aa0ec42f2$var$menuScope) !== container) return;
        }
        if (event.key === (0, $fM984.KEY_DOWN)) {
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (0, $jzRXW.getNextFocusable)({
                container: container,
                direction: 'forwards',
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $fM984.KEY_UP)) {
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (0, $jzRXW.getNextFocusable)({
                container: container,
                direction: 'backwards',
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $fM984.KEY_HOME)) {
            // Prevent browser default (e.g. scrolling to top of page).
            event.preventDefault();
            (0, $3hJ5V.getFirstFocusable)({
                container: container,
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $fM984.KEY_END)) {
            // Prevent browser default (e.g. scrolling to bottom of page).
            event.preventDefault();
            (0, $7MWxP.getLastFocusable)({
                container: container,
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $fM984.KEY_TAB)) {
            onClose();
            return;
        }
        // ── Nested menu navigation (WAI-ARIA menu pattern) ──
        // ArrowRight on a menuitem with aria-haspopup opens the submenu.
        if (event.key === 'ArrowRight') {
            if (onNestedOpen && focused instanceof HTMLElement && focused.hasAttribute('aria-haspopup')) {
                event.preventDefault();
                onNestedOpen({
                    trigger: focused
                });
            }
            return;
        }
        // ArrowLeft closes the current menu if it is nested inside a parent menu.
        if (event.key === 'ArrowLeft') {
            if (onNestedClose) {
                // Only close if this container is inside another role="menu"
                // (i.e. it is a submenu, not the top-level menu).
                // Walk up from the parent to avoid matching the container itself.
                const isNested = container.parentElement?.closest($341d868aa0ec42f2$var$menuScope) !== null;
                if (isNested) {
                    event.preventDefault();
                    onNestedClose();
                }
            }
            return;
        }
    }, [
        containerRef,
        onClose,
        onNestedOpen,
        onNestedClose,
        filter
    ]);
    (0, $cozmU.useEffect)(()=>{
        const container_0 = containerRef.current;
        if (!container_0 || !isEnabled) return;
        return (0, $cbY7C.bind)(container_0, {
            type: 'keydown',
            listener: handleKeyDown
        });
    }, [
        containerRef,
        handleKeyDown,
        isEnabled
    ]);
};
module.exports["useArrowNavigation"] = $341d868aa0ec42f2$export$23dfbae28e0cc453;

});

parcelRegister("91JJR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $g2o3j = parcelRequire("g2o3j");

function $5c29a548ea0a79f9$export$f525cc57d37ca574(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                    ...props,
                    key: (0, $g2o3j.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>//@ts-ignore - TS2604/TS2786: Component type union causing issues for help-center local consumption with TS 5.9.2
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
                    ...props,
                    key: (0, $g2o3j.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        },
        MoreIndicator: {
            render: (Component, props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props),
            ...overrides && overrides.MoreIndicator
        }
    };
}
module.exports["getOverrides"] = $5c29a548ea0a79f9$export$f525cc57d37ca574;

});

parcelRegister("g2o3j", function(module, exports) {
const $c51da9a7df49a1b0$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};
module.exports["composeUniqueKey"] = $c51da9a7df49a1b0$export$b067756944994c79;

});

parcelRegister("f4ONb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iODl6 = parcelRequire("iODl6");


var $ixfCV = parcelRequire("ixfCV");

const $1c9c95ebce1b3e9c$var$gutter = "var(--ds-space-negative-050, -4px)";
const $1c9c95ebce1b3e9c$var$listStyles = null;
const $1c9c95ebce1b3e9c$var$listStylesFlagged = null;
const $1c9c95ebce1b3e9c$var$listItemStyles = null;
const $1c9c95ebce1b3e9c$var$Grid = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { id: id, children: children, testId: testId, "aria-label": label } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1e0c1txw _1bah1y6m _1n261g80 _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2r5cr _ahbqr5cr _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            (0, $ixfCV.fg)("platform-avatar-group-spacing-fix") && "_6rth1b66 _y4tiv77o _bozgv77o"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = (0, $ixfCV.fg)("platform-dst-motion-uplift") ? /*#__PURE__*/ $cozmU.createElement((0, $iODl6.default), {
            exitThenEnter: true
        }, (0, $cozmU.Children).map(children, $1c9c95ebce1b3e9c$var$_temp)) : (0, $cozmU.Children).map(children, $1c9c95ebce1b3e9c$var$_temp2);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== id || $[4] !== label || $[5] !== t2 || $[6] !== testId) {
        t3 = /*#__PURE__*/ $cozmU.createElement("ul", {
            id: id,
            "data-testid": testId,
            "aria-label": label,
            className: t1
        }, t2);
        $[3] = id;
        $[4] = label;
        $[5] = t2;
        $[6] = testId;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ id: id, children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ $cozmU.createElement("ul", {
        id: id,
        "data-testid": testId,
        "aria-label": label,
        className: (0, $hekY6.default)([
            "_1e0c1txw _1bah1y6m _1n261g80 _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2r5cr _ahbqr5cr _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            (0, $ixfCV.fg)('platform-avatar-group-spacing-fix') && "_6rth1b66 _y4tiv77o _bozgv77o"
        ])
    }, (0, $ixfCV.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ $cozmU.createElement((0, $iODl6.default), {
        exitThenEnter: true
    }, (0, $cozmU.Children).map(children, (child)=>child && /*#__PURE__*/ $cozmU.createElement("li", {
            className: (0, $hekY6.default)([
                "_6rthu2gc _1pfhze3t _12l2ze3t _ahbqze3t _y4ti1b66 _bozg1b66"
            ])
        }, child))) : (0, $cozmU.Children).map(children, (child_0)=>child_0 && /*#__PURE__*/ $cozmU.createElement("li", {
            className: (0, $hekY6.default)([
                "_6rthu2gc _1pfhze3t _12l2ze3t _ahbqze3t _y4ti1b66 _bozg1b66"
            ])
        }, child_0))); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $1c9c95ebce1b3e9c$export$2e2bcd8739ae039 = $1c9c95ebce1b3e9c$var$Grid;
function $1c9c95ebce1b3e9c$var$_temp(child) {
    return child && /*#__PURE__*/ $cozmU.createElement("li", {
        className: (0, $hekY6.default)([
            "_6rthu2gc _1pfhze3t _12l2ze3t _ahbqze3t _y4ti1b66 _bozg1b66"
        ])
    }, child);
}
function $1c9c95ebce1b3e9c$var$_temp2(child_0) {
    return child_0 && /*#__PURE__*/ $cozmU.createElement("li", {
        className: (0, $hekY6.default)([
            "_6rthu2gc _1pfhze3t _12l2ze3t _ahbqze3t _y4ti1b66 _bozg1b66"
        ])
    }, child_0);
}
module.exports["default"] = $1c9c95ebce1b3e9c$export$2e2bcd8739ae039;

});

parcelRegister("6oFjM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $7Dop9 = parcelRequire("7Dop9");


var $kVHjt = parcelRequire("kVHjt");

// TODO: Fill in the component {description} and ensure links point to the correct {packageName} location.
// Remove links that the component does not have (such as usage). If there are no links remove them all.
/**
 * __Focus manager__
 *
 * A focus manager {description}.
 *
 * - [Examples](https://atlassian.design/components/{packageName}/examples)
 * - [Code](https://atlassian.design/components/{packageName}/code)
 * - [Usage](https://atlassian.design/components/{packageName}/usage)
 */ const $c01bf7a5c9b76ffa$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $cozmU.useRef)([]);
    const registerRef = (0, $cozmU.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $cozmU.useEffect)(()=>{
        (0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener: (0, $7Dop9.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $cbY7C.bind)(window, {
                type: 'keydown',
                listener: (0, $7Dop9.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kVHjt.FocusManagerContext).Provider, {
        value: contextValue
    }, children);
};
var $c01bf7a5c9b76ffa$export$2e2bcd8739ae039 = $c01bf7a5c9b76ffa$var$FocusManager;
module.exports["default"] = $c01bf7a5c9b76ffa$export$2e2bcd8739ae039;

});

parcelRegister("7Dop9", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b50f6255090ed60$export$2e2bcd8739ae039);

var $fM984 = parcelRequire("fM984");

const $7b50f6255090ed60$var$actionMap = {
    [(0, $fM984.KEY_DOWN)]: 'next',
    [(0, $fM984.KEY_UP)]: 'prev',
    [(0, $fM984.KEY_HOME)]: 'first',
    [(0, $fM984.KEY_END)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $7b50f6255090ed60$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
    return;
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $7b50f6255090ed60$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
    return;
};
function $7b50f6255090ed60$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $7b50f6255090ed60$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $7b50f6255090ed60$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $7b50f6255090ed60$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $7b50f6255090ed60$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $7b50f6255090ed60$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});

parcelRegister("eyQF5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6IL1T = parcelRequire("6IL1T");


var $kVHjt = parcelRequire("kVHjt");

/**
 * It sets focus to the first avatar when popup is open.
 */ const $949efbfeb67fe748$var$PopupAvatarGroup = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    let children;
    let isLoading;
    let maxHeight;
    let minHeight;
    let onClick;
    let rest;
    let role;
    let setInitialFocusRef;
    let spacing;
    let t1;
    let t2;
    let testId;
    if ($[0] !== t0) {
        ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: t1, minHeight: minHeight, minWidth: t2, onClick: onClick, role: role, setInitialFocusRef: setInitialFocusRef, spacing: spacing, testId: testId, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = isLoading;
        $[3] = maxHeight;
        $[4] = minHeight;
        $[5] = onClick;
        $[6] = rest;
        $[7] = role;
        $[8] = setInitialFocusRef;
        $[9] = spacing;
        $[10] = t1;
        $[11] = t2;
        $[12] = testId;
    } else {
        children = $[1];
        isLoading = $[2];
        maxHeight = $[3];
        minHeight = $[4];
        onClick = $[5];
        rest = $[6];
        role = $[7];
        setInitialFocusRef = $[8];
        spacing = $[9];
        t1 = $[10];
        t2 = $[11];
        testId = $[12];
    }
    const maxWidth = t1 === undefined ? 800 : t1;
    const minWidth = t2 === undefined ? 320 : t2;
    const { menuItemRefs: menuItemRefs } = (0, $cozmU.useContext)((0, $kVHjt.FocusManagerContext));
    let t3;
    let t4;
    if ($[13] !== menuItemRefs || $[14] !== setInitialFocusRef) {
        t3 = ()=>{
            setInitialFocusRef?.(menuItemRefs[0]);
        };
        t4 = [
            menuItemRefs,
            setInitialFocusRef
        ];
        $[13] = menuItemRefs;
        $[14] = setInitialFocusRef;
        $[15] = t3;
        $[16] = t4;
    } else {
        t3 = $[15];
        t4 = $[16];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[17] !== children || $[18] !== isLoading || $[19] !== maxHeight || $[20] !== maxWidth || $[21] !== minHeight || $[22] !== minWidth || $[23] !== onClick || $[24] !== rest || $[25] !== role || $[26] !== spacing || $[27] !== testId) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), {
            isLoading: isLoading,
            maxHeight: maxHeight,
            maxWidth: maxWidth,
            minHeight: minHeight,
            minWidth: minWidth,
            onClick: onClick,
            role: role,
            spacing: spacing,
            testId: testId,
            ...rest
        }, children);
        $[17] = children;
        $[18] = isLoading;
        $[19] = maxHeight;
        $[20] = maxWidth;
        $[21] = minHeight;
        $[22] = minWidth;
        $[23] = onClick;
        $[24] = rest;
        $[25] = role;
        $[26] = spacing;
        $[27] = testId;
        $[28] = t5;
    } else t5 = $[28];
    return t5;
} : ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth = 800, minHeight: minHeight, minWidth: minWidth = 320, onClick: onClick, role: role, setInitialFocusRef: setInitialFocusRef, spacing: spacing, testId: testId, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $cozmU.useContext)((0, $kVHjt.FocusManagerContext));
    (0, $cozmU.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        minHeight: minHeight,
        minWidth: minWidth,
        onClick: onClick,
        role: role,
        spacing: spacing,
        testId: testId,
        ...rest
    }, children);
};
var $949efbfeb67fe748$export$2e2bcd8739ae039 = $949efbfeb67fe748$var$PopupAvatarGroup;
module.exports["default"] = $949efbfeb67fe748$export$2e2bcd8739ae039;

});

parcelRegister("942TG", function(module, exports) {
/* more-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $ixfCV = parcelRequire("ixfCV");

const $de57968bf9fddf7d$var$boxShadowCssVar = '--avatar-box-shadow';
const $de57968bf9fddf7d$var$styles = {
    root: "_19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _v564ieh6 _1e0c1txw _vchh1ntv _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _4cvr1fhb _1bah1h6o _2lx21bp4 _80omtlke _bfhki8nm _syazi7uo _16qs1nhn _t9ec1aqe _1ejjglyw _mizu1v1w _ra3xnqa1 _1ah3yh40 _128myh40 _irr3plhp _30l3i7uo _1di61gdz _9h8hi7uo _jlxit94y",
    circle: "_2rko1qll",
    active: "_bfhk15s3 _16qsdfwd _syaz6x5g _irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    disabled: "_80om13gf _1peq2wxo _1hfkvuon",
    hexagon: "_mkrz1k6g"
};
const $de57968bf9fddf7d$var$widthHeightMap = {
    xsmall: "_1bsb7vkz _4t3i7vkz",
    small: "_1bsb1tcg _4t3i1tcg",
    medium: "_1bsbzwfg _4t3izwfg",
    large: "_1bsb1ylp _4t3i1ylp",
    xlarge: "_1bsb16xz _4t3i16xz",
    xxlarge: "_1bsb1qr7 _4t3i1qr7"
};
const $de57968bf9fddf7d$var$borderRadiusMap = {
    xsmall: "_2rkolb4i _14mjlb4i",
    small: "_2rkolb4i _14mjlb4i",
    medium: "_2rkofajl _14mjfajl",
    large: "_2rkofajl _14mjfajl",
    xlarge: "_2rko1qi0 _14mj1qi0",
    xxlarge: "_2rkopb1k _14mjpb1k"
};
const $de57968bf9fddf7d$var$fontMap = {
    small: "_11c8wadc",
    medium: "_11c8wadc",
    large: "_11c8wadc",
    xlarge: "_11c81d4k",
    xxlarge: "_11c81d4k"
};
const $de57968bf9fddf7d$var$MAX_DISPLAY_COUNT = 99;
const $de57968bf9fddf7d$var$MoreIndicator = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ appearance: appearance = 'circle', borderColor: borderColor = "var(--ds-surface, #FFFFFF)", size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, moreIndicatorLabel: moreIndicatorLabel, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $cozmU.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    const displayCount = count > $de57968bf9fddf7d$var$MAX_DISPLAY_COUNT ? $de57968bf9fddf7d$var$MAX_DISPLAY_COUNT : count;
    const providedAriaLabel = moreIndicatorLabel || buttonProps['aria-label'];
    const ariaLabel = providedAriaLabel ? providedAriaLabel : `${displayCount} more people`;
    return /*#__PURE__*/ $cozmU.createElement("button", {
        type: "submit",
        ...buttonProps,
        onClick: onClickHander,
        ref: ref,
        "data-testid": testId,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHaspopup,
        "aria-label": ariaLabel,
        style: {
            [$de57968bf9fddf7d$var$boxShadowCssVar]: `0 0 0 2px ${borderColor}`
        },
        className: (0, $hekY6.default)([
            $de57968bf9fddf7d$var$styles.root,
            $de57968bf9fddf7d$var$borderRadiusMap[size],
            appearance === 'circle' && $de57968bf9fddf7d$var$styles.circle,
            appearance === 'hexagon' && (0, $ixfCV.fg)('jira-ai-agent-stack') && $de57968bf9fddf7d$var$styles.hexagon,
            $de57968bf9fddf7d$var$widthHeightMap[size],
            $de57968bf9fddf7d$var$fontMap[size],
            isActive && $de57968bf9fddf7d$var$styles.active
        ])
    }, "+", displayCount);
});
$de57968bf9fddf7d$var$MoreIndicator.displayName = 'MoreIndicator'; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $de57968bf9fddf7d$export$2e2bcd8739ae039 = $de57968bf9fddf7d$var$MoreIndicator;
module.exports["default"] = $de57968bf9fddf7d$export$2e2bcd8739ae039;

});

parcelRegister("68jmg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iODl6 = parcelRequire("iODl6");


var $ixfCV = parcelRequire("ixfCV");

const $ca3d6afcd04eeed9$var$listStyles = null;
const $ca3d6afcd04eeed9$var$listSmallStyles = null;
const $ca3d6afcd04eeed9$var$listItemStyles = null;
const $ca3d6afcd04eeed9$var$listItemSmallStyles = null;
const $ca3d6afcd04eeed9$var$Stack = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { id: id, children: children, testId: testId, "aria-label": label, size: size } = t0;
    let t1;
    if ($[0] !== size) {
        t1 = (0, $hekY6.default)([
            "_1e0c1txw _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2u2gc _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            size === "small" && (0, $ixfCV.fg)("platform-avatar-group-spacing-fix") && "_12l21b66"
        ]);
        $[0] = size;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== size) {
        t2 = (0, $ixfCV.fg)("platform-dst-motion-uplift") ? /*#__PURE__*/ $cozmU.createElement((0, $iODl6.default), {
            exitThenEnter: true
        }, (0, $cozmU.Children).map(children, (child)=>child && /*#__PURE__*/ $cozmU.createElement("li", {
                className: (0, $hekY6.default)([
                    "_6rthze3t _1pfhze3t _12l2x0bf _ahbqze3t",
                    size === "small" && (0, $ixfCV.fg)("platform-avatar-group-spacing-fix") && "_12l2r5cr"
                ])
            }, child))) : (0, $cozmU.Children).map(children, (child_0)=>child_0 && /*#__PURE__*/ $cozmU.createElement("li", {
                className: (0, $hekY6.default)([
                    "_6rthze3t _1pfhze3t _12l2x0bf _ahbqze3t",
                    size === "small" && (0, $ixfCV.fg)("platform-avatar-group-spacing-fix") && "_12l2r5cr"
                ])
            }, child_0));
        $[2] = children;
        $[3] = size;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== id || $[6] !== label || $[7] !== t1 || $[8] !== t2 || $[9] !== testId) {
        t3 = /*#__PURE__*/ $cozmU.createElement("ul", {
            id: id,
            "data-testid": testId,
            "aria-label": label,
            className: t1
        }, t2);
        $[5] = id;
        $[6] = label;
        $[7] = t1;
        $[8] = t2;
        $[9] = testId;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ id: id, children: children, testId: testId, 'aria-label': label, size: size })=>/*#__PURE__*/ $cozmU.createElement("ul", {
        id: id,
        "data-testid": testId,
        "aria-label": label,
        className: (0, $hekY6.default)([
            "_1e0c1txw _19121cl4 _vwz4kb7n _2mzuagmp _6rthze3t _1pfhze3t _12l2u2gc _ahbqze3t _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            size === 'small' && (0, $ixfCV.fg)('platform-avatar-group-spacing-fix') && "_12l21b66"
        ])
    }, (0, $ixfCV.fg)('platform-dst-motion-uplift') ? /*#__PURE__*/ $cozmU.createElement((0, $iODl6.default), {
        exitThenEnter: true
    }, (0, $cozmU.Children).map(children, (child)=>child && /*#__PURE__*/ $cozmU.createElement("li", {
            className: (0, $hekY6.default)([
                "_6rthze3t _1pfhze3t _12l2x0bf _ahbqze3t",
                size === 'small' && (0, $ixfCV.fg)('platform-avatar-group-spacing-fix') && "_12l2r5cr"
            ])
        }, child))) : (0, $cozmU.Children).map(children, (child_0)=>child_0 && /*#__PURE__*/ $cozmU.createElement("li", {
            className: (0, $hekY6.default)([
                "_6rthze3t _1pfhze3t _12l2x0bf _ahbqze3t",
                size === 'small' && (0, $ixfCV.fg)('platform-avatar-group-spacing-fix') && "_12l2r5cr"
            ])
        }, child_0))); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $ca3d6afcd04eeed9$export$2e2bcd8739ae039 = $ca3d6afcd04eeed9$var$Stack;
module.exports["default"] = $ca3d6afcd04eeed9$export$2e2bcd8739ae039;

});

parcelRegister("bBCy7", function(module, exports) {
module.exports = new URL("mailto-to-confluence-icon-dark.8e4e57e2.svg", import.meta.url).toString();

});

parcelRegister("4XQXn", function(module, exports) {
module.exports = new URL("mailto-to-confluence-icon.6d8738a4.svg", import.meta.url).toString();

});

parcelRegister("2KW1v", function(module, exports) {
module.exports = new URL("mailto-to-jira-icon-dark.8731f26d.svg", import.meta.url).toString();

});

parcelRegister("9A30E", function(module, exports) {
module.exports = new URL("mailto-to-jira-icon.ad7dabf6.svg", import.meta.url).toString();

});

parcelRegister("6eWaG", function(module, exports) {
module.exports = new URL("slack-to-confluence-icon-dark.de55c7d1.svg", import.meta.url).toString();

});

parcelRegister("bQuWd", function(module, exports) {
module.exports = new URL("slack-to-confluence-icon.db053234.svg", import.meta.url).toString();

});

parcelRegister("f57An", function(module, exports) {
module.exports = new URL("slack-to-jira-icon-dark.66d9455a.svg", import.meta.url).toString();

});

parcelRegister("dxDFB", function(module, exports) {
module.exports = new URL("slack-to-jira-icon.389cc36a.svg", import.meta.url).toString();

});

parcelRegister("9W3iZ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $b8047cedbb1a9818$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    titleInviteUser: {
        id: "invite-on-third-party-link.invite-on-third-party-link-flag.title.invite-user",
        defaultMessage: "{userCount, plural, one {{singleUserTitle} needs} other {Teammates need}} access to {productName}"
    },
    descriptionInviteUser: {
        id: "invite-on-third-party-link.invite-on-third-party-link-flag.description.invite-user",
        defaultMessage: "{userCount, plural,\n\t\t\t\tone { {source, select,\n\t\t\t\t\tslack  {We noticed {singleUserTitle} is in your Slack thread but doesn''t have access to {spaceName}. Invite them to join you.}\n\t\t\t\t\tmailto {{singleUserTitle} doesn''t have access to {spaceName}. Invite them to join you.}\n\t\t\t\t\tother  {Invite them to join you.}\n\t\t\t\t\t} }\n\t\t\t\tother { Invite teammates from your {source, select, slack {Slack channel} mailto {emails} other {link}} who may need access to collaborate with you in {spaceName}. }\n\t\t\t}"
    },
    descriptionInviteNonUser: {
        id: "invite-on-third-party-link.invite-on-third-party-link-flag.description.invite-non-user",
        defaultMessage: "{email} needs access to {productName}. Invite them to start collaborating in {spaceName}."
    },
    ctaInvite: {
        id: "invite-on-third-party-link.invite-on-third-party-link-flag.cta.invite",
        defaultMessage: "{userCount, plural, one {Invite} other {Add {userCount} people}}"
    },
    ctaNotNow: {
        id: "invite-on-third-party-link.invite-on-third-party-link-flag.cta.not-now",
        defaultMessage: "Not now"
    },
    ctaDontShowAgain: {
        id: "invite-on-third-party-link.invite-on-third-party-link-flag.cta.dont-show-again",
        defaultMessage: "Don't show again"
    },
    avatarGroupLabel: {
        id: "invite-on-third-party-link.invite-on-third-party-link-flag.avatar-group.label",
        defaultMessage: "Teammates without access"
    },
    fallbackSingleUserTitle: {
        id: "invite-on-third-party-link.invite-on-third-party-link-flag.fallback-single-user-title",
        defaultMessage: "Someone"
    }
});
module.exports["messages"] = $b8047cedbb1a9818$export$defe85febe8b728c;

});

parcelRegister("3b21M", function(module, exports) {
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $FKQbh = parcelRequire("FKQbh");


var $chu6R = parcelRequire("chu6R");


var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $bCGJJ = parcelRequire("bCGJJ");


var $jNvI6 = parcelRequire("jNvI6");

const $c449cb8755bef2c5$export$e4f2447e3ef68b74 = ({ onDismiss: onDismiss, inviteCount: inviteCount, productName: productName, hasRequestAccess: hasRequestAccess, ...props })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $FKQbh.default), {
        ...props,
        testId: "invite-on-third-party-link-invites-sent-flag",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
            spacing: "spacious",
            label: formatMessage((0, $jNvI6.messages).titleInvitesSent, {
                inviteCount: inviteCount
            }),
            color: "var(--ds-icon-success, #6A9A23)"
        }),
        onDismissed: onDismiss,
        title: formatMessage((0, $jNvI6.messages).titleInvitesSent, {
            inviteCount: inviteCount
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            as: "p"
        }, formatMessage((0, $jNvI6.messages).descriptionInvitesSent, {
            inviteCount: inviteCount,
            productName: productName
        })), hasRequestAccess && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            as: "p"
        }, formatMessage((0, $jNvI6.messages).descriptionRequestAccess, {
            productName: productName
        })))
    });
};
const $c449cb8755bef2c5$export$731dde0599561262 = (0, $bCGJJ.withLocalIntl)($c449cb8755bef2c5$export$e4f2447e3ef68b74);
module.exports["InviteOnThirdPartyLinkInvitesSentFlag"] = $c449cb8755bef2c5$export$731dde0599561262;

});

parcelRegister("jNvI6", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $17833f2884d4107a$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    titleInvitesSent: {
        id: "invite-on-third-party-link.flag.title.invites-sent",
        defaultMessage: "{inviteCount, plural, one {Invite successfully sent} other {Invites successfully sent}}"
    },
    descriptionInvitesSent: {
        id: "invite-on-third-party-link.flag.description.invites-sent",
        defaultMessage: "{inviteCount} {inviteCount, plural, one {teammate} other {teammates}} will get an email inviting them to {productName}."
    },
    descriptionRequestAccess: {
        id: "invite-on-third-party-link.flag.description.invites-sent-with-request-access",
        defaultMessage: "Admin may need to approve some teammates before they can join {productName}."
    }
});
module.exports["messages"] = $17833f2884d4107a$export$defe85febe8b728c;

});

parcelRegister("1jt54", function(module, exports) {
const $3265de94055fbb3a$var$THIRD_PARTY_WITHIN_ONE_P_ELIGIBILITY_PATH = '/gateway/api/growth/3p-within-1p/email-eligibility';
const $3265de94055fbb3a$export$d9212b99d97f61c4 = async (emails, productId)=>{
    const response = await fetch($3265de94055fbb3a$var$THIRD_PARTY_WITHIN_ONE_P_ELIGIBILITY_PATH, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            emails: emails,
            productId: productId
        })
    });
    if (!response.ok) throw new Error(`HTTP error ${response.status}`);
    return await response.json() ?? {};
};
module.exports["fetchEligibleEmails"] = $3265de94055fbb3a$export$d9212b99d97f61c4;

});

parcelRegister("j2n0Y", function(module, exports) {
const $37fc3f67f128df62$var$PI_SLACK_LINK_ELIGIBILITY_PATH = '/gateway/api/pi-gateway/frontend/api/1/accessNotifications/slackLinkEligibleUsers';
const $37fc3f67f128df62$export$634e05052ff38af1 = async (slackLink, productId)=>{
    const response = await fetch($37fc3f67f128df62$var$PI_SLACK_LINK_ELIGIBILITY_PATH, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            slackLink: slackLink,
            product: productId
        })
    });
    if (!response.ok) throw new Error(`HTTP error ${response.status}`);
    const eligibility = await response.json() ?? {};
    return {
        slackLink: slackLink,
        eligibleUsers: eligibility?.eligibleUsers
    };
};
module.exports["fetchPiSlackLinkEligibleUsers"] = $37fc3f67f128df62$export$634e05052ff38af1;

});

parcelRegister("kcIQr", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $9DHhW = parcelRequire("9DHhW");

const $8f5ec29d1cc276d5$export$b8af4dbcbdf99d70 = ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (payload)=>createAnalyticsEvent(payload);
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const createEvent = t0;
    let t1;
    if ($[2] !== createEvent) {
        t1 = {
            createEvent: createEvent
        };
        $[2] = createEvent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["useConfluenceAnalyticsEvents"] = $8f5ec29d1cc276d5$export$b8af4dbcbdf99d70;

});

parcelRegister("kqIWy", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $4ZxLt = parcelRequire("4ZxLt");


var $jtuBN = parcelRequire("jtuBN");

const $bbbfebced5e36727$export$7081570f83890156 = (spaceKey, t0)=>{
    const $ = (0, $bDgLe.c)(12);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { includeSpaceTypeSettings: t2 } = t1;
    const includeSpaceTypeSettings = t2 === undefined ? false : t2;
    let t3;
    if ($[2] !== includeSpaceTypeSettings || $[3] !== spaceKey) {
        t3 = {
            variables: {
                spaceKey: spaceKey,
                includeSpaceTypeSettings: includeSpaceTypeSettings
            }
        };
        $[2] = includeSpaceTypeSettings;
        $[3] = spaceKey;
        $[4] = t3;
    } else t3 = $[4];
    const options = t3;
    const { loading: loading, data: data, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $4ZxLt.default), {
        ...options,
        __callerPackage__: "space-utils"
    });
    let t4;
    if ($[5] !== data || $[6] !== includeSpaceTypeSettings) {
        t4 = data ? {
            spaceId: data.space?.id,
            type: data.space?.type,
            name: data.space?.name,
            dataClassificationTags: data.space?.dataClassificationTags,
            alias: data.space?.alias,
            homepage: data.space?.homepage,
            iconPath: data.space?.icon?.path,
            typeSettings: includeSpaceTypeSettings && data.space?.spaceTypeSettings ? {
                enabledContentTypes: {
                    ...data.space.spaceTypeSettings.enabledContentTypes
                }
            } : undefined
        } : undefined;
        $[5] = data;
        $[6] = includeSpaceTypeSettings;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== error || $[9] !== loading || $[10] !== t4) {
        t5 = {
            loading: loading,
            data: t4,
            error: error
        };
        $[8] = error;
        $[9] = loading;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
};
module.exports["useSpaceDetail"] = $bbbfebced5e36727$export$7081570f83890156;

});

parcelRegister("1ApN2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $1HeZJ = parcelRequire("1HeZJ");


var $bQm3c = parcelRequire("bQm3c");


var $iOeRE = parcelRequire("iOeRE");

const $491f9b9b48c755f6$export$20714212a4575904 = ()=>{
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    return (0, $cozmU.useMemo)(()=>({
            createAnalyticsEvent: createAnalyticsEvent,
            fetchJSON: (0, $iOeRE.cfetchJSON),
            getCurrentCloudId: ()=>cloudId,
            getCurrentProduct: ()=>'confluence',
            getCurrentUserId: ()=>userId
        }), [
        createAnalyticsEvent,
        cloudId,
        userId
    ]);
};
const $491f9b9b48c755f6$export$6de4685a6c88b4e9 = (service, providedDeps)=>{
    const environmentDeps = $491f9b9b48c755f6$export$20714212a4575904();
    const deps = (0, $cozmU.useMemo)(()=>({
            ...environmentDeps,
            ...providedDeps
        }), [
        environmentDeps,
        providedDeps
    ]);
    return (0, $1HeZJ.useService)(service, deps);
};
module.exports["useService"] = $491f9b9b48c755f6$export$6de4685a6c88b4e9;

});

parcelRegister("1HeZJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fVsXG = parcelRequire("fVsXG");

const $1ac5d6c80bc49835$export$6de4685a6c88b4e9 = (service, depsOverrides)=>{
    const memoizedRef = (0, $cozmU.useRef)({
        service: undefined,
        depsOverrides: undefined,
        result: undefined
    });
    const memoized = memoizedRef.current;
    if (!memoized || memoized.service !== service || !$1ac5d6c80bc49835$var$areObjectsEqualShallow(memoized.depsOverrides, depsOverrides)) {
        memoizedRef.current.result = (0, $fVsXG.resolveService)(service, depsOverrides);
        memoizedRef.current.depsOverrides = depsOverrides;
        memoizedRef.current.service = service;
    }
    return memoizedRef.current.result;
};
const $1ac5d6c80bc49835$var$DIFFERENT = false;
const $1ac5d6c80bc49835$var$EQUAL = true;
const $1ac5d6c80bc49835$var$areObjectsEqualShallow = (prevObject, nextObject)=>{
    if (nextObject === prevObject) return $1ac5d6c80bc49835$var$EQUAL;
    if (!prevObject || !nextObject) return $1ac5d6c80bc49835$var$DIFFERENT;
    else {
        const prevKeys = Object.keys(prevObject);
        const keys = Object.keys(nextObject);
        if (keys.length !== prevKeys.length) return $1ac5d6c80bc49835$var$DIFFERENT;
        else for (let key of keys){
            if (nextObject[key] !== prevObject[key]) return $1ac5d6c80bc49835$var$DIFFERENT;
        }
        return $1ac5d6c80bc49835$var$EQUAL;
    }
};
module.exports["useService"] = $1ac5d6c80bc49835$export$6de4685a6c88b4e9;

});

parcelRegister("fVsXG", function(module, exports) {

var $2LYjf = parcelRequire("2LYjf");

function $65b2e4c93b6838a7$export$388f24d19a29b0a2(service, providedDeps) {
    if (typeof service === 'function' && (0, $2LYjf.isServiceWithDeps)(service)) return (input)=>{
        return service(input, $65b2e4c93b6838a7$var$ResolvedServiceDependencyContext(service.dependencies, providedDeps ?? {}));
    };
    return service;
}
const $65b2e4c93b6838a7$var$ResolvedServiceDependencyContext = (declaredDependencies, depsOverrides)=>{
    let resolvedDeps = undefined;
    return {
        dependencies () {
            if (resolvedDeps) return resolvedDeps;
            resolvedDeps = {};
            for (let [k, dependency] of Object.entries(declaredDependencies)){
                const key = k;
                resolvedDeps[key] = // TODO is this type-safe?
                // TODO resolve the override dep as well?
                key in depsOverrides ? depsOverrides[key] : $65b2e4c93b6838a7$export$388f24d19a29b0a2(dependency, depsOverrides);
            }
            return resolvedDeps;
        }
    };
}; // TODO: support multiple services to be resolved with common deps
 // export function resolveServices<DeclaredServices extends DeclaredServicesBase>(
 // 	services: DeclaredServices,
 // 	deps: any /*TODO*/,
 // ) {
 // 	return services as ResolvedServices<DeclaredServices>;
 // }
module.exports["resolveService"] = $65b2e4c93b6838a7$export$388f24d19a29b0a2;

});

parcelRegister("iOeRE", function(module, exports) {

var $8eID1 = parcelRequire("8eID1");


var $f7B1p = parcelRequire("f7B1p");

const $d0f24b4cc757a7af$export$54b4f9494a7ca022 = async (input)=>{
    const { url: url, ...options } = input;
    try {
        const response = await (0, $f7B1p.cfetch)(url, options);
        if (response.ok) {
            const data = await response.json();
            const traceId = (0, $8eID1.getTraceId)(response);
            return {
                data: data,
                traceId: traceId
            };
        } else throw new Error(`Fetch failed with status ${response.status}`);
    } catch (error) {
        if (error instanceof Error) error.message = `Error while fetching: ${error.message}`;
        throw error;
    }
};
module.exports["cfetchJSON"] = $d0f24b4cc757a7af$export$54b4f9494a7ca022;

});

parcelRegister("8eID1", function(module, exports) {
/**
 * Shared utility to extract trace ID from HTTP response headers.
 * Checks headers in order: 'atl-traceid', 'x-trace-id'
 * Returns undefined for missing or empty trace IDs.
 */ const $f183e457a4a7c6a4$export$e88cb5bfb57ce9c4 = (response)=>{
    const TRACE_ID_HEADERS = [
        'atl-traceid',
        'x-trace-id'
    ];
    const traceIdHeader = TRACE_ID_HEADERS.find((header)=>response.headers.has(header));
    if (traceIdHeader === undefined) return undefined;
    const value = response.headers.get(traceIdHeader);
    // Normalize empty strings to undefined
    return value && value.length > 0 ? value : undefined;
};
module.exports["getTraceId"] = $f183e457a4a7c6a4$export$e88cb5bfb57ce9c4;

});

parcelRegister("2pqKH", function(module, exports) {

var $jTt8P = parcelRequire("jTt8P");

const $e946c8cf1e828200$var$SLACK_LINK_REGEX = /^https?:\/\/[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.slack\.com\/archives\/([A-Z0-9]+)(?:\/p\d+)?(?:\?.*)?$/i;
const $e946c8cf1e828200$var$MAILTO_REGEX = /^mailto:/i;
const $e946c8cf1e828200$var$MAILTO_EXTRACT_REGEX = /^mailto:([^?]+)(?:\?.*)?$/i;
const $e946c8cf1e828200$var$EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const $e946c8cf1e828200$export$805c0f552a132acf = (url)=>{
    if (!url) return false;
    return $e946c8cf1e828200$var$SLACK_LINK_REGEX.test(url);
};
const $e946c8cf1e828200$export$29c00f7413dfd376 = (link)=>{
    const match = link.match($e946c8cf1e828200$var$SLACK_LINK_REGEX);
    return match ? match[1] : '';
};
const $e946c8cf1e828200$export$afd9e99d55776191 = (url)=>{
    if (!url) return false;
    return $e946c8cf1e828200$var$MAILTO_REGEX.test(url);
};
const $e946c8cf1e828200$export$b4618f428080f5b3 = (url)=>{
    if (!url) return [];
    const match = url.match($e946c8cf1e828200$var$MAILTO_EXTRACT_REGEX);
    if (!match) return [];
    return match[1].split(',').flatMap((email)=>{
        const decoded = decodeURIComponent(email).trim();
        return $e946c8cf1e828200$var$EMAIL_REGEX.test(decoded) ? [
            decoded
        ] : [];
    });
};
const $e946c8cf1e828200$var$getAllSmartLinks = (content)=>{
    const links = new Set();
    const handleCard = (node)=>{
        const url = node.attrs?.url;
        if (url) links.add(url);
    };
    (0, $jTt8P.traverse)(content, {
        inlineCard: handleCard,
        blockCard: handleCard,
        embedCard: handleCard
    });
    return links;
};
const $e946c8cf1e828200$export$776644da31ab517e = (content)=>{
    const links = $e946c8cf1e828200$var$getAllSmartLinks(content);
    (0, $jTt8P.traverse)(content, {
        text: (node)=>{
            const linkMark = (node.marks ?? []).find((mark)=>mark.type === 'link');
            if (linkMark?.attrs?.href) links.add(linkMark.attrs.href);
        }
    });
    return links;
};
module.exports["isSlackLink"] = $e946c8cf1e828200$export$805c0f552a132acf;
module.exports["getChannelIdFromSlackLink"] = $e946c8cf1e828200$export$29c00f7413dfd376;
module.exports["isMailtoLink"] = $e946c8cf1e828200$export$afd9e99d55776191;
module.exports["getEmailsFromMailtoLink"] = $e946c8cf1e828200$export$b4618f428080f5b3;
module.exports["getAllLinks"] = $e946c8cf1e828200$export$776644da31ab517e;

});

parcelRegister("br2TZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $f7B1p = parcelRequire("f7B1p");

function $5f0af0ba2bb52d3d$var$parseIntegrationTraits(data) {
    if (!data?.attributes) return {};
    const traits = {};
    data.attributes.forEach((attr)=>{
        if (attr.name.startsWith('confluence_ui_integrationspotlight') || attr.name.startsWith('confluence_ui_slack3pwithin1p') || attr.name.startsWith('confluence_ui_mailto3pwithin1p')) traits[attr.name] = attr.value;
    });
    return traits;
}
const $5f0af0ba2bb52d3d$export$c8f78aa437a258ba = async (atlassianAccountId)=>{
    const res = await (0, $f7B1p.cfetch)(// eslint-disable-next-line confluence-targeting-usage/no-legacy-tap-personalization-api -- Intentionally bypasses SSR cache: spotlight eligibility requires fresh data. See ACTIVATION-2527
    `/gateway/api/tap-delivery/api/v3/personalization/user/${atlassianAccountId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    const data = await res.json();
    return $5f0af0ba2bb52d3d$var$parseIntegrationTraits(data);
};
const $5f0af0ba2bb52d3d$export$80552dc6c11605da = (atlassianAccountId)=>{
    const [integrationTraits, setIntegrationTraits] = (0, $cozmU.useState)({});
    const [loading, setLoading] = (0, $cozmU.useState)(!!atlassianAccountId);
    const [error, setError] = (0, $cozmU.useState)(null);
    const hasFetchedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!atlassianAccountId || hasFetchedRef.current) return;
        hasFetchedRef.current = true;
        const fetchTraits = async ()=>{
            try {
                const traits = await $5f0af0ba2bb52d3d$export$c8f78aa437a258ba(atlassianAccountId);
                setIntegrationTraits(traits);
            } catch (err) {
                setError(err instanceof Error ? err : new Error(String(err)));
            } finally{
                setLoading(false);
            }
        };
        fetchTraits();
    }, [
        atlassianAccountId
    ]);
    return {
        integrationTraits: integrationTraits,
        loading: loading,
        error: error
    };
};
module.exports["fetchIntegrationTraits"] = $5f0af0ba2bb52d3d$export$c8f78aa437a258ba;
module.exports["useSpotlightTraits"] = $5f0af0ba2bb52d3d$export$80552dc6c11605da;

});

parcelRegister("kFfmO", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $hnHkA = parcelRequire("hnHkA");


var $gDtSO = parcelRequire("gDtSO");

const $5bc5d67c740d63b1$export$58fb4d2c94c892e6 = ()=>{
    try {
        const lastShownStr = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $hnHkA.LAST_FLAG_SHOWN_TIMESTAMP_KEY));
        if (!lastShownStr) return true; // No previous flag shown, eligible
        const lastShown = parseInt(lastShownStr, 10);
        const timeSince = Date.now() - lastShown;
        if (timeSince < (0, $gDtSO.TIME_WINDOWS).GLOBAL_THROTTLE) return false;
        return true;
    } catch (e) {
        return true; // Allow on error
    }
};
const $5bc5d67c740d63b1$export$c0351d1f69ef1963 = (timestamp)=>{
    try {
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $hnHkA.LAST_FLAG_SHOWN_TIMESTAMP_KEY), timestamp.toString());
    } catch (e) {
    // Silent fail
    }
};
const $5bc5d67c740d63b1$export$1a26a4b2067b34f7 = ()=>{
    const defaultResponse = {
        slack: undefined,
        mailto: undefined
    };
    try {
        const state = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $hnHkA.STORAGE_3P_FLAG_SHOWN_ELIGIBILITY_KEY));
        if (!state) return defaultResponse;
        const parsedState = JSON.parse(state);
        if (typeof parsedState === 'object' && parsedState !== null) {
            const slackVal = parsedState.slack?.state;
            const mailtoVal = parsedState.mailto?.state;
            return {
                slack: Number(slackVal) || undefined,
                mailto: Number(mailtoVal) || undefined
            };
        }
        return defaultResponse;
    } catch  {
        return defaultResponse;
    }
};
const $5bc5d67c740d63b1$export$a74592077a3efa7c = (shownAtTimestamp, type, dismissType)=>{
    try {
        // Read the raw stored object so we can preserve the other type's timestamp
        // independently. Using check3pIn1pDismissState() would lose the timestamps.
        let existing = {};
        try {
            const raw = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $hnHkA.STORAGE_3P_FLAG_SHOWN_ELIGIBILITY_KEY));
            if (raw) {
                const parsed = JSON.parse(raw);
                if (typeof parsed === 'object' && parsed !== null) existing = parsed;
            }
        } catch  {
        // If we can't read existing, we'll just write the new entry
        }
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $hnHkA.STORAGE_3P_FLAG_SHOWN_ELIGIBILITY_KEY), JSON.stringify({
            ...existing,
            // Only overwrite the entry for the type that was just dismissed
            [type]: {
                state: dismissType,
                timestamp: shownAtTimestamp
            }
        }));
    } catch  {
    // No-op: storage failures should not block spotlight display
    }
};
const $5bc5d67c740d63b1$export$678871b39d2178f3 = (eligibleTypes, newLinks)=>{
    if (eligibleTypes.length === 0) return null;
    if (eligibleTypes.length === 1) return eligibleTypes[0];
    // Primary: First pasted link type wins
    for (const link of newLinks){
        if (eligibleTypes.includes(link.type)) return link.type;
    }
    // Fallback: Priority order
    const priority = [
        'microsoft',
        'slack'
    ];
    for (const type of priority){
        if (eligibleTypes.includes(type)) return type;
    }
    return eligibleTypes[0];
};
module.exports["checkGlobalThrottle"] = $5bc5d67c740d63b1$export$58fb4d2c94c892e6;
module.exports["updateGlobalThrottle"] = $5bc5d67c740d63b1$export$c0351d1f69ef1963;
module.exports["check3pIn1pDismissState"] = $5bc5d67c740d63b1$export$1a26a4b2067b34f7;
module.exports["set3pIn1pDismissState"] = $5bc5d67c740d63b1$export$a74592077a3efa7c;
module.exports["selectSingleType"] = $5bc5d67c740d63b1$export$678871b39d2178f3;

});

parcelRegister("hnHkA", function(module, exports) {
/**
 * Trait names for integration link spotlight
 *
 * TWO-TRAIT SYSTEM:
 * 1. STATE trait: JSON format with stage and timestamp (e.g., '{"stage":1,"timestamp":1704512000000}')
 * 2. HARD_DISMISS trait: 'true' or 'false'
 *
 * This separation allows analytics events to update traits independently:
 * - "Shown" event → updates STATE trait
 * - "Hard Dismiss" event → updates HARD_DISMISS trait
 */ // STATE traits: store stage + lastShownTimestamp
const $81834013a9cc2e90$export$4449fa078c931505 = {
    SLACK: 'confluence_ui_integrationspotlightshownforslack_viewed_changed',
    TEAMS: 'confluence_ui_integrationspotlightshownforteams_viewed_changed',
    INVITE_ON_3P_SLACK: 'confluence_ui_slack3pwithin1pspotlightshown_viewed_changed',
    INVITE_ON_3P_MAILTO: 'confluence_ui_mailto3pwithin1pspotlightshown_viewed_changed'
};
const $81834013a9cc2e90$export$ffe8acccdf55807d = {
    SLACK: 'confluence_ui_integrationspotlightdismissedforslack_clicked_changed',
    TEAMS: 'confluence_ui_integrationspotlightdismissedforteams_clicked_changed',
    INVITE_ON_3P_SLACK: 'confluence_ui_slack3pwithin1pspotlightdismissed_clicked_changed',
    INVITE_ON_3P_MAILTO: 'confluence_ui_mailto3pwithin1pspotlightdismissed_clicked_changed'
};
const $81834013a9cc2e90$export$cec8860a0c7ae635 = 'integration_spotlight_last_shown_timestamp';
const $81834013a9cc2e90$export$90cee0974e61d39a = 'growth.experiment.confluence.3p-within-1p-spotlight-eligibility';
module.exports["TRAIT_NAMES_STATE"] = $81834013a9cc2e90$export$4449fa078c931505;
module.exports["TRAIT_NAMES_HARD_DISMISS"] = $81834013a9cc2e90$export$ffe8acccdf55807d;
module.exports["LAST_FLAG_SHOWN_TIMESTAMP_KEY"] = $81834013a9cc2e90$export$cec8860a0c7ae635;
module.exports["STORAGE_3P_FLAG_SHOWN_ELIGIBILITY_KEY"] = $81834013a9cc2e90$export$90cee0974e61d39a;

});

parcelRegister("gDtSO", function(module, exports) {
/**
 * Time windows configuration
 *
 * - GLOBAL_THROTTLE: 15 minutes - prevents showing spotlight within 15 minutes of last shown
 * - STAGE_1_TO_2: 7 days - after first nudge, wait 7 days before showing second
 * - STAGE_2_TO_3: 30 days - after second nudge, wait 30 days before showing third
 * - STAGE_3_PLUS: 90 days - after third+ nudge, wait 90 days before showing again
 */ const $8f15a6ae12e0bdbb$export$cb200f3389adec40 = {
    GLOBAL_THROTTLE: 900000,
    // 15 minutes
    STAGE_1_TO_2: 604800000,
    // 7 days
    STAGE_2_TO_3: 2592000000,
    // 30 days
    STAGE_3_PLUS: 7776000000 // 90 days
};
module.exports["TIME_WINDOWS"] = $8f15a6ae12e0bdbb$export$cb200f3389adec40;

});

parcelRegister("kOnoQ", function(module, exports) {

var $gDtSO = parcelRequire("gDtSO");


var $hnHkA = parcelRequire("hnHkA");

/**
 * Map of link types to their STATE trait names
 */ const $6174ef28a494fd7a$var$STATE_TRAIT_MAP = {
    slack: (0, $hnHkA.TRAIT_NAMES_STATE).SLACK,
    microsoft: (0, $hnHkA.TRAIT_NAMES_STATE).TEAMS,
    other: '' // Not used for 'other' type
};
/**
 * Map of link types to their HARD_DISMISS trait names
 */ const $6174ef28a494fd7a$var$HARD_DISMISS_TRAIT_MAP = {
    slack: (0, $hnHkA.TRAIT_NAMES_HARD_DISMISS).SLACK,
    microsoft: (0, $hnHkA.TRAIT_NAMES_HARD_DISMISS).TEAMS,
    other: '' // Not used for 'other' type
};
/**
 * Get STATE trait name for a specific link type
 */ const $6174ef28a494fd7a$var$getStateTraitNameForType = (linkType)=>{
    return $6174ef28a494fd7a$var$STATE_TRAIT_MAP[linkType];
};
/**
 * Get HARD_DISMISS trait name for a specific link type
 */ const $6174ef28a494fd7a$var$getHardDismissTraitNameForType = (linkType)=>{
    return $6174ef28a494fd7a$var$HARD_DISMISS_TRAIT_MAP[linkType];
};
const $6174ef28a494fd7a$export$2334dba0776559d = (stage, timestamp)=>{
    return JSON.stringify({
        stage: stage,
        timestamp: timestamp
    });
};
const $6174ef28a494fd7a$export$505adab9e86a88df = (hardDismiss)=>{
    // Serialized as JSON to keep parity with analytics attribute `traitValue`
    // (e.g. '{"hardDismiss":true}')
    return JSON.stringify({
        hardDismiss: hardDismiss
    });
};
/**
 * Deserialize STATE trait value from JSON format
 * Format: JSON string with stage and timestamp
 * Returns default (stage 0, timestamp 0) if parsing fails or trait is missing
 *
 * Stage 0 = never shown before (first-time user)
 * Stage 1 = shown once
 * Stage 2 = shown twice
 * etc.
 */ const $6174ef28a494fd7a$var$deserializeStateTrait = (traitValue)=>{
    if (!traitValue) // First-time user: stage 0 (never shown), will be eligible immediately
    return {
        stage: 0,
        lastShownTimestamp: 0
    };
    try {
        const parsed = JSON.parse(traitValue);
        return {
            stage: parsed.stage || 0,
            lastShownTimestamp: parsed.timestamp || 0
        };
    } catch (error) {
        return {
            stage: 0,
            lastShownTimestamp: 0
        };
    }
};
/**
 * Deserialize HARD_DISMISS trait value
 * Returns: boolean (defaults to false if missing)
 */ const $6174ef28a494fd7a$var$deserializeHardDismissTrait = (traitValue)=>{
    // Always default to false if not present
    if (!traitValue) return false;
    try {
        const parsed = JSON.parse(traitValue);
        return parsed?.hardDismiss === true;
    } catch (e) {
        return false;
    }
};
const $6174ef28a494fd7a$export$38d9414ada291cac = (linkType, traits)=>{
    const stateTraitName = $6174ef28a494fd7a$var$getStateTraitNameForType(linkType);
    const hardDismissTraitName = $6174ef28a494fd7a$var$getHardDismissTraitNameForType(linkType);
    const stateValue = traits[stateTraitName];
    const hardDismissValue = traits[hardDismissTraitName];
    const { stage: stage, lastShownTimestamp: lastShownTimestamp } = $6174ef28a494fd7a$var$deserializeStateTrait(stateValue);
    const hardDismiss = $6174ef28a494fd7a$var$deserializeHardDismissTrait(hardDismissValue);
    return {
        stage: stage,
        lastShownTimestamp: lastShownTimestamp,
        hardDismiss: hardDismiss
    };
};
const $6174ef28a494fd7a$export$7e4745d153439f = (linkType, traits, now = Date.now())=>{
    const state = $6174ef28a494fd7a$export$38d9414ada291cac(linkType, traits);
    // 1. Hard dismiss check
    if (state.hardDismiss) return false;
    // 2. Stage-based time window check
    const timeSinceLastShown = now - state.lastShownTimestamp;
    // First time showing (stage 0) - always eligible
    if (state.stage === 0) return true;
    // Stage 1: Need 7 days before showing 2nd nudge
    if (state.stage === 1 && timeSinceLastShown < (0, $gDtSO.TIME_WINDOWS).STAGE_1_TO_2) return false;
    // Stage 2: Need 30 days before showing 3rd nudge
    if (state.stage === 2 && timeSinceLastShown < (0, $gDtSO.TIME_WINDOWS).STAGE_2_TO_3) return false;
    // Stage 3+: Need 90 days before showing next nudge
    if (state.stage >= 3 && timeSinceLastShown < (0, $gDtSO.TIME_WINDOWS).STAGE_3_PLUS) return false;
    // Passed all checks - eligible to show
    return true;
};
const $6174ef28a494fd7a$var$INVITE_3P_HARD_DISMISS_TRAIT_MAP = {
    slack: (0, $hnHkA.TRAIT_NAMES_HARD_DISMISS).INVITE_ON_3P_SLACK,
    mailto: (0, $hnHkA.TRAIT_NAMES_HARD_DISMISS).INVITE_ON_3P_MAILTO
};
const $6174ef28a494fd7a$export$3b654f7078900cce = (type, storedDismissState, traits)=>{
    const storedValue = storedDismissState[type];
    if (storedValue !== undefined) return storedValue;
    // Fall back to the TAP hard-dismiss trait stored as a numeric string
    const traitName = $6174ef28a494fd7a$var$INVITE_3P_HARD_DISMISS_TRAIT_MAP[type];
    const traitValue = Number(traits[traitName]);
    return Number.isNaN(traitValue) ? 0 : traitValue;
};
const $6174ef28a494fd7a$export$a99dd248a8b91662 = (type, traits, storedDismissState)=>{
    const dismissType = $6174ef28a494fd7a$export$3b654f7078900cce(type, storedDismissState, traits);
    // Permanently dismissed — never show again
    if (dismissType >= 3) return false;
    return true;
};
module.exports["serializeStateForTrait"] = $6174ef28a494fd7a$export$2334dba0776559d;
module.exports["serializeHardDismissForTrait"] = $6174ef28a494fd7a$export$505adab9e86a88df;
module.exports["getIntegrationState"] = $6174ef28a494fd7a$export$38d9414ada291cac;
module.exports["isIntegrationEligible"] = $6174ef28a494fd7a$export$7e4745d153439f;
module.exports["getInviteOn3pDismissType"] = $6174ef28a494fd7a$export$3b654f7078900cce;
module.exports["is3pInviteEligible"] = $6174ef28a494fd7a$export$a99dd248a8b91662;

});

parcelRegister("ltwhQ", function(module, exports) {

let $fa2559e93ce3737f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fa2559e93ce3737f$var$load("cKqFC").then(()=>parcelRequire('f337l'));

});

parcelRegister("jyA9t", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $691f60820ad9b181$var$initialState = {
    showSmartCreationModal: false,
    isLoomRecorderOpen: false,
    attachedLoomVideo: null,
    submittedWithLoomAttachment: false,
    spaceKey: '',
    parentContent: {
        id: '',
        title: '',
        contentType: ''
    },
    content: undefined,
    stagingAreaActive: false,
    isFloating: false,
    shouldShowBackButton: undefined,
    entryPoint: 'confluenceUnknown',
    initialPrompt: undefined,
    initialOutcomeType: undefined,
    lockInitialOutcomeType: false,
    remixConversationId: null,
    onboardingData: undefined,
    onOnboardingSubmit: undefined,
    totalSteps: undefined,
    submitCallback: undefined,
    onCloseCallback: undefined,
    onOpenCallback: undefined
};
const $691f60820ad9b181$export$e324594224ef24da = {
    openModal: ({ entryPoint: entryPoint, spaceKey: spaceKey, parentContent: parentContent, stagingAreaActive: stagingAreaActive, isFloating: isFloating, shouldShowBackButton: shouldShowBackButton, content: content, initialPrompt: initialPrompt, initialOutcomeType: initialOutcomeType, lockInitialOutcomeType: lockInitialOutcomeType, submitCallback: submitCallback, onCloseCallback: onCloseCallback, onOpenCallback: onOpenCallback, remixConversationId: remixConversationIdFromOpen, onboardingData: onboardingData, onOnboardingSubmit: onOnboardingSubmit, totalSteps: totalSteps })=>({ setState: setState })=>{
            const floating = isFloating ?? false;
            const remixConversationId = floating && remixConversationIdFromOpen !== undefined && remixConversationIdFromOpen !== null && remixConversationIdFromOpen !== '' ? remixConversationIdFromOpen : null;
            setState({
                showSmartCreationModal: true,
                // A fresh open is never behind the recorder; clearing here also
                // recovers if a prior recorder session left the flag stuck on.
                isLoomRecorderOpen: false,
                // A fresh open never carries a prior session's attachment.
                attachedLoomVideo: null,
                submittedWithLoomAttachment: false,
                entryPoint: entryPoint,
                spaceKey: spaceKey,
                parentContent: parentContent ?? {
                    id: '',
                    title: '',
                    contentType: ''
                },
                content: content ?? undefined,
                stagingAreaActive: stagingAreaActive ?? false,
                isFloating: floating,
                shouldShowBackButton: shouldShowBackButton ?? undefined,
                initialPrompt: initialPrompt,
                initialOutcomeType: initialOutcomeType ?? undefined,
                // Lock requires an initial outcome type — guard against misuse.
                lockInitialOutcomeType: Boolean(initialOutcomeType && lockInitialOutcomeType),
                remixConversationId: remixConversationId,
                onboardingData: onboardingData ?? undefined,
                onOnboardingSubmit: onOnboardingSubmit ?? undefined,
                totalSteps: totalSteps ?? undefined,
                submitCallback: submitCallback ?? undefined,
                onCloseCallback: onCloseCallback ?? undefined,
                onOpenCallback: onOpenCallback ?? undefined
            });
        },
    closeModal: ()=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: false,
                isLoomRecorderOpen: false,
                attachedLoomVideo: null,
                submittedWithLoomAttachment: false,
                content: undefined,
                stagingAreaActive: false,
                isFloating: false,
                shouldShowBackButton: undefined,
                entryPoint: 'confluenceUnknown',
                initialPrompt: undefined,
                initialOutcomeType: undefined,
                lockInitialOutcomeType: false,
                remixConversationId: null,
                onboardingData: undefined,
                onOnboardingSubmit: undefined,
                onCloseCallback: undefined,
                onOpenCallback: undefined
            });
        },
    setLoomRecorderOpen: (isLoomRecorderOpen)=>({ setState: setState })=>{
            setState({
                isLoomRecorderOpen: isLoomRecorderOpen
            });
        },
    setAttachedLoomVideo: (attachedLoomVideo)=>({ setState: setState })=>{
            setState({
                attachedLoomVideo: attachedLoomVideo
            });
        },
    setSubmittedWithLoomAttachment: (submittedWithLoomAttachment)=>({ setState: setState })=>{
            setState({
                submittedWithLoomAttachment: submittedWithLoomAttachment
            });
        },
    // Atomically reads-and-clears the marker from live store state (not a
    // render-lagged hook value) so the create/finalize step sees the value set
    // by the submit that immediately preceded it, and never fires twice or leaks
    // onto a later create.
    consumeSubmittedWithLoomAttachment: ()=>({ getState: getState, setState: setState })=>{
            const submitted = getState().submittedWithLoomAttachment;
            if (submitted) setState({
                submittedWithLoomAttachment: false
            });
            return submitted;
        },
    // Attaches a just-recorded Loom and forces the modal open. A recording can
    // finish after the modal was closed mid-record (reopened via global create,
    // then dismissed); the orphaned SDK "Add to prompt" callback fires here, so
    // reopening lets the attachment land on a visible modal instead of nowhere.
    attachLoomVideoAndOpenModal: (attachedLoomVideo)=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: true,
                attachedLoomVideo: attachedLoomVideo
            });
        }
};
const $691f60820ad9b181$export$390f32400eaf98c9 = (0, $8s9DV.createStore)({
    initialState: $691f60820ad9b181$var$initialState,
    actions: $691f60820ad9b181$export$e324594224ef24da,
    name: 'smartCreationModalStore'
});
const $691f60820ad9b181$export$137abd744dc8b433 = (0, $kBr4q.createHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$809bddce75a17b3 = (0, $kBr4q.createActionsHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$46ab492df7c46301 = (0, $kBr4q.createStateHook)($691f60820ad9b181$export$390f32400eaf98c9);
module.exports["useSmartCreationModalStore"] = $691f60820ad9b181$export$137abd744dc8b433;
module.exports["useSmartCreationModalActions"] = $691f60820ad9b181$export$809bddce75a17b3;
module.exports["useSmartCreationModalState"] = $691f60820ad9b181$export$46ab492df7c46301;

});

parcelRegister("i7PFh", function(module, exports) {

let $d320f5058154f467$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d320f5058154f467$var$load("lD32v").then(()=>parcelRequire('k5Y9p'));

});

parcelRegister("fzhfU", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $JTIzG = parcelRequire("JTIzG");

const $e4992c54b0e0da53$export$ede5d3bbbf3ec238 = (0, $3u0dr.isReactCompilerActiveV2)() ? (isAIEnabledForContent)=>{
    const { isAIPolicyAndBrowserSupportEnabled: isAIPolicyAndBrowserSupportEnabled, isAudioV3Enabled: isAudioV3Enabled, isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled } = (0, $JTIzG.useAudioFeatureFlags)();
    return isAIEnabledForContent && isAIPolicyAndBrowserSupportEnabled && (!isAudioV3Enabled || !isAudioBylineEntrypointEnabled);
} : (isAIEnabledForContent)=>{
    const { isAIPolicyAndBrowserSupportEnabled: isAIPolicyAndBrowserSupportEnabled, isAudioV3Enabled: isAudioV3Enabled, isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled } = (0, $JTIzG.useAudioFeatureFlags)();
    // Only show audio entrypoint in sidebar if:
    // 1. AI is Enabled for content
    // 2. AI Policy and browser support are enabled AND
    // 3. [Audio V3 is disabled] OR [Audio Byline Entrypoint is disabled]
    //
    // Truthy cases:
    // - AI Enabled; Audio & AI Policy supported; Audio V3 disabled; Audio Byline Entrypoint disabled => Audio V2 experience
    // - AI Enabled; Audio & AI Policy supported; Audio V3 disabled; Audio Byline Entrypoint enabled  => Audio V2 experience
    // - AI Enabled; Audio & AI Policy supported; Audio V3 enabled; Audio Byline Entrypoint disabled  => Audio V3 experience
    //
    // Falsy cases:
    // - AI disabed;													  							  => No audio entrypoint
    // - Audio & AI Policy disabled;									  							  => No audio entrypoint
    // - AI Enabled; Audio & AI Policy supported; Audio V3 enabled; Audio Byline Entrypoint enabled   => Audio V3-Byline experience
    return isAIEnabledForContent && isAIPolicyAndBrowserSupportEnabled && (!isAudioV3Enabled || !isAudioBylineEntrypointEnabled);
};
module.exports["useHasAudioButton"] = $e4992c54b0e0da53$export$ede5d3bbbf3ec238;

});

parcelRegister("JTIzG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");

var $27a67c702eae1a5a$export$419c8aa8913e9327 = /*#__PURE__*/ function(BriefingNudgeExperimentState) {
    BriefingNudgeExperimentState["CONTROL"] = "control";
    BriefingNudgeExperimentState["NUDGE"] = "nudge";
    BriefingNudgeExperimentState["NUDGE_AUTOPLAY"] = "nudge_autoplay";
    return BriefingNudgeExperimentState;
}({});
const $27a67c702eae1a5a$export$df5bf03825b93c3d = ()=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled, isAtlassianHostedLLMOnlyEnabled: isAtlassianHostedLLMOnlyEnabled } = (0, $bQm3c.useSessionData)();
    // Deferred: MediaSource is unavailable during SSR
    const [audioSupportedByBrowser, setAudioSupportedByBrowser] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        setAudioSupportedByBrowser(typeof MediaSource !== 'undefined' && MediaSource.isTypeSupported('audio/mpeg'));
    }, []);
    const isAHMOnlyEnabled = (0, $cozmU.useMemo)(()=>isAtlassianHostedLLMOnlyEnabled && (0, $6mKj3.isExperimentEnabled)('confluence_audio_disable_if_ahm_enabled'), [
        isAtlassianHostedLLMOnlyEnabled
    ]);
    const isAIPolicyAndBrowserSupportEnabled = (0, $cozmU.useMemo)(()=>isAdminHubAIEnabled && // AdminHub AI is enabled
        isAIEarlyAccessEnabled && // AI Early Access is enabled
        audioSupportedByBrowser && // Audio is supported by browser
        !isAHMOnlyEnabled, [
        isAdminHubAIEnabled,
        isAIEarlyAccessEnabled,
        audioSupportedByBrowser,
        isAHMOnlyEnabled
    ]);
    const isAudioV3Enabled = (0, $cozmU.useMemo)(()=>isAIPolicyAndBrowserSupportEnabled && (0, $6mKj3.isExperimentEnabled)('confluence_audio_v3'), [
        isAIPolicyAndBrowserSupportEnabled
    ]);
    const isAudioBylineEntrypointEnabled = (0, $cozmU.useMemo)(()=>isAIPolicyAndBrowserSupportEnabled && (0, $6mKj3.isExperimentEnabled)('confluence_ai_consumption_byline'), [
        isAIPolicyAndBrowserSupportEnabled
    ]);
    const audioBriefingNudgeExperimentState = (0, $cozmU.useMemo)(()=>{
        if (!isAudioV3Enabled) return "control";
        if ((0, $6mKj3.expValEquals)('confluence_audio_v3_briefing_nudge', 'variant', 'nudge')) return "nudge";
        else if ((0, $6mKj3.expValEquals)('confluence_audio_v3_briefing_nudge', 'variant', 'nudge_autoplay')) return "nudge_autoplay";
        else return "control";
    }, [
        isAudioV3Enabled
    ]);
    return {
        isAIPolicyAndBrowserSupportEnabled: isAIPolicyAndBrowserSupportEnabled,
        isAudioV3Enabled: isAudioV3Enabled,
        isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled,
        audioBriefingNudgeExperimentState: audioBriefingNudgeExperimentState
    };
};
module.exports["BriefingNudgeExperimentState"] = $27a67c702eae1a5a$export$419c8aa8913e9327;
module.exports["useAudioFeatureFlags"] = $27a67c702eae1a5a$export$df5bf03825b93c3d;

});

parcelRegister("fWGpT", function(module, exports) {

var $jiJCD = parcelRequire("jiJCD");


var $1UWNP = parcelRequire("1UWNP");


var $81GPJ = parcelRequire("81GPJ");


var $lTECB = parcelRequire("lTECB");


var $04e9M = parcelRequire("04e9M");


var $6mKj3 = parcelRequire("6mKj3");


var $9137z = parcelRequire("9137z");


var $j8hiR = parcelRequire("j8hiR");


var $1VB1N = parcelRequire("1VB1N");


var $8VXwD = parcelRequire("8VXwD");


var $bNHtR = parcelRequire("bNHtR");


var $gNjy8 = parcelRequire("gNjy8");

const $6e4f6ea8730b931f$export$1504d130127dbc5f = (options)=>{
    const cloudId = options?.cloudId ?? '';
    const contentId = options?.contentId ?? '';
    const contentType = options?.contentType ?? '';
    const fetchUsersClient = options?.fetchUsersClient ?? '';
    return `${cloudId}_${contentId}_${contentType}_${fetchUsersClient}`;
};
const $6e4f6ea8730b931f$export$3c298c8b4091db27 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((options)=>{
    // start measuring duration for initializing the provider
    (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_INIT);
    (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_FETCH);
    const { contentId: contentId, cloudId: cloudId, activationId: activationId, contentType: contentType, permissionTokenRefresh: permissionTokenRefresh, initialDraft: initialDraft, isLivePage: isLivePage, onUserFetchError: onUserFetchError, presenceId: presenceId, presenceActivity: presenceActivity, userId: userId, fetchUsersClient: fetchUsersClient } = options;
    const url = (0, $1VB1N.getCollabProviderUrl)();
    const path = (0, $6mKj3.expVal)('platform_editor_to_use_pmr_for_collab_edit_none_ic', 'isEnabled', false) ? (0, $1VB1N.getCollabEditServicePath)(cloudId, activationId) : undefined;
    const isEmbeddedConfluence = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    const product = isEmbeddedConfluence ? 'embeddedConfluence' : 'confluence';
    const documentAri = `ari:cloud:confluence:${cloudId}:${contentType}/${contentId}`;
    const subProduct = isEmbeddedConfluence ? (0, $jiJCD.parse)(location.search, true).query.parentProduct : isLivePage ? 'live' : undefined;
    const fetchAnonymousAssetCallback = async (id)=>{
        try {
            return await (0, $gNjy8.fetchAnonymousAsset)(id);
        } catch (error) {
            onUserFetchError?.(error);
        }
        return undefined;
    };
    // In order to support deduplication of the collaborator, presenceId will be set to the userId if it exists.
    // This means that anonymous users will still rely on presenceId and not get deduplicated.
    const collaboratorPresenceId = userId ?? presenceId;
    (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_FETCH);
    (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_CREATED);
    // DO NOT add any asynchronous calls/behavior to the collab provider creation. This has caused incidents
    // in the past where the provider promise never resolves and editing breaks.
    // Context: https://hello.atlassian.net/wiki/spaces/~589311246/pages/2554442259/Investigate+async+issue+HOT-103180
    return (0, $81GPJ.createSocketIOCollabProvider)({
        documentAri: documentAri,
        url: url,
        path: path,
        batchProps: {
            getUsers: fetchUsersClient === 'agg' ? (0, $8VXwD.fetchNativeCollabAGGUsers) : (0, $bNHtR.fetchNativeCollabConfluenceUsers),
            batchSize: 50,
            onError: onUserFetchError
        },
        getAnalyticsWebClient: (0, $04e9M.getAnalyticsWebClient)(),
        permissionTokenRefresh: permissionTokenRefresh,
        need404: true,
        productInfo: {
            product: product,
            subProduct: Array.isArray(subProduct) ? subProduct.join('-') : subProduct
        },
        // either pass the initialDraft that was fetched on hover, or the draftResponse that was fetched on click
        initialDraft: initialDraft || undefined,
        isBufferingEnabled: Boolean(initialDraft),
        __livePage: isLivePage,
        presenceId: collaboratorPresenceId,
        presenceActivity: presenceActivity,
        throwOnNotConnected: true,
        fetchAnonymousAsset: fetchAnonymousAssetCallback
    });
}, $6e4f6ea8730b931f$export$1504d130127dbc5f);
module.exports["getCollabEditProvider"] = $6e4f6ea8730b931f$export$3c298c8b4091db27;

});

parcelRegister("81GPJ", function(module, exports) {

var $eeFmb = parcelRequire("eeFmb");


var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");


var $7Hrb0 = parcelRequire("7Hrb0");


var $g4l86 = parcelRequire("g4l86");


var $aykoi = parcelRequire("aykoi");

function $93fe0632c88c0901$export$2326b022d5973f36(url, auth, productInfo, isPresenceOnly, analyticsHelper, path, documentAri) {
    const { pathname: pathname, hostname: hostname } = new URL(url);
    let socketIOOptions = (0, $aykoi.SOCKET_IO_OPTIONS);
    // Polling first
    let transports = [
        'polling',
        'websocket'
    ];
    let usePMR = false;
    if (isPresenceOnly) {
        // Presence-specific configuration
        if ((0, $ixfCV.fg)('platform-editor-presence-websocket-only')) // https://socket.io/docs/v4/client-options/#transports
        // WebSocket first, if fails, try polling
        transports = [
            'websocket'
        ];
        socketIOOptions = (0, $aykoi.SOCKET_IO_OPTIONS_WITH_HIGH_JITTER);
        usePMR = true;
    } else {
        // PMR routing for edit traffic
        if ((0, $ieeJu.expValEquals)('platform_editor_to_use_pmr_for_collab_edit_none_ic', 'isEnabled', true, false)) usePMR = true;
        if ((0, $g4l86.isGCPtenant)(hostname) && (0, $ixfCV.fg)('collab_edit_via_websocket_only_for_gcp')) transports = [
            'websocket'
        ];
    }
    const extraHeaders = {
        'x-product': (0, $g4l86.getProduct)(productInfo),
        'x-subproduct': (0, $g4l86.getSubProduct)(productInfo),
        'x-client-platform': 'web'
    };
    const client = (0, $eeFmb.io)(url, {
        reconnectionDelayMax: socketIOOptions.RECONNECTION_DELAY_MAX,
        reconnectionDelay: socketIOOptions.RECONNECTION_DELAY,
        randomizationFactor: socketIOOptions.RANDOMIZATION_FACTOR,
        closeOnBeforeunload: false,
        withCredentials: true,
        transports: transports,
        path: usePMR && path ? `${path}/socket.io` : `/${pathname.split('/')[1]}/socket.io`,
        auth: auth,
        extraHeaders: extraHeaders,
        query: {
            sourceId: documentAri?.split('/')[1]
        }
    });
    return client;
}
function $93fe0632c88c0901$export$a301b940c71eb349(config) {
    return new (0, $7Hrb0.Provider)({
        ...config,
        createSocket: $93fe0632c88c0901$export$2326b022d5973f36
    });
}
module.exports["createSocketIOCollabProvider"] = $93fe0632c88c0901$export$a301b940c71eb349;

});

parcelRegister("eeFmb", function(module, exports) {

var $aaWnS = parcelRequire("aaWnS");


var $dHQr7 = parcelRequire("dHQr7");


var $35i9r = parcelRequire("35i9r");


var $bKjvH = parcelRequire("bKjvH");

/**
 * Managers cache.
 */ const $a5d274195a5fe76d$var$cache = {};
function $a5d274195a5fe76d$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $aaWnS.url)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $a5d274195a5fe76d$var$cache[id] && path in $a5d274195a5fe76d$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $dHQr7.Manager)(source, opts);
    else {
        if (!$a5d274195a5fe76d$var$cache[id]) $a5d274195a5fe76d$var$cache[id] = new (0, $dHQr7.Manager)(source, opts);
        io = $a5d274195a5fe76d$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($a5d274195a5fe76d$export$841407ceb083bd74, {
    Manager: $dHQr7.Manager,
    Socket: $35i9r.Socket,
    io: $a5d274195a5fe76d$export$841407ceb083bd74,
    connect: $a5d274195a5fe76d$export$841407ceb083bd74
});
module.exports["io"] = $a5d274195a5fe76d$export$841407ceb083bd74;

});

parcelRegister("aaWnS", function(module, exports) {
parcelRequire("l3L0C");
var $63chG = parcelRequire("63chG");

function $76882072eb95378c$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, $63chG.parse)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}
module.exports["url"] = $76882072eb95378c$export$128fa18b7194ef;

});

parcelRegister("l3L0C", function(module, exports) {
$parcel$export(module.exports, "Socket", () => (parcelRequire("1vmek")).Socket);
$parcel$export(module.exports, "installTimerFunctions", () => (parcelRequire("kV1Jf")).installTimerFunctions);
$parcel$export(module.exports, "parse", () => (parcelRequire("63chG")).parse);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("jdri8")).nextTick);

var $1vmek = parcelRequire("1vmek");


var $iqTos = parcelRequire("iqTos");


var $dywwS = parcelRequire("dywwS");


var $kV1Jf = parcelRequire("kV1Jf");


var $63chG = parcelRequire("63chG");


var $jdri8 = parcelRequire("jdri8");

const $f54e57c8e4b1d6a3$export$a51d6b395ff4c65a = (0, $1vmek.Socket).protocol;

});

parcelRegister("1vmek", function(module, exports) {

var $dywwS = parcelRequire("dywwS");


var $kV1Jf = parcelRequire("kV1Jf");


var $dQmDk = parcelRequire("dQmDk");


var $63chG = parcelRequire("63chG");


var $9MAwi = parcelRequire("9MAwi");


var $fJuQC = parcelRequire("fJuQC");


var $jdri8 = parcelRequire("jdri8");

class $1189ee225b4341e2$export$4798917dbf149b79 extends (0, $9MAwi.Emitter) {
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $fJuQC.protocol);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new (0, $dywwS.transports)[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ open() {
        let transport;
        if (this.opts.rememberUpgrade && $1189ee225b4341e2$export$4798917dbf149b79.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1) transport = "websocket";
        else if (0 === this.transports.length) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        } else transport = this.transports[0];
        this.readyState = "opening";
        // Retry with the next transport if the transport is disabled (jsonp: false)
        try {
            transport = this.createTransport(transport);
        } catch (e) {
            this.transports.shift();
            this.open();
            return;
        }
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this.onDrain.bind(this)).on("packet", this.onPacket.bind(this)).on("error", this.onError.bind(this)).on("close", (reason)=>this.onClose("transport close", reason));
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $1189ee225b4341e2$export$4798917dbf149b79.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $1189ee225b4341e2$export$4798917dbf149b79.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this.upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") // favor WebTransport
        this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        $1189ee225b4341e2$export$4798917dbf149b79.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
        // we check for `readyState` in case an `open`
        // listener already closed the socket
        if ("open" === this.readyState && this.opts.upgrade) {
            let i = 0;
            const l = this.upgrades.length;
            for(; i < l; i++)this.probe(this.upgrades[i]);
        }
    }
    /**
     * Handles a packet.
     *
     * @private
     */ onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            this.resetPingTimeout();
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this.sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this.onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this.upgrades = this.filterUpgrades(data.upgrades);
        this.pingInterval = data.pingInterval;
        this.pingTimeout = data.pingTimeout;
        this.maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this.resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ resetPingTimeout() {
        this.clearTimeoutFn(this.pingTimeoutTimer);
        this.pingTimeoutTimer = this.setTimeoutFn(()=>{
            this.onClose("ping timeout");
        }, this.pingInterval + this.pingTimeout);
        if (this.opts.autoUnref) this.pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ onDrain() {
        this.writeBuffer.splice(0, this.prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this.prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this.getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this.prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ getWritablePackets() {
        const shouldCheckPayloadSize = this.maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, $kV1Jf.byteLength)(data);
            if (i > 0 && payloadSize > this.maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this.sendPacket("message", msg, options, fn);
        return this;
    }
    send(msg, options, fn) {
        this.sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this.onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ onError(err) {
        $1189ee225b4341e2$export$4798917dbf149b79.priorWebsocketSuccess = false;
        this.emitReserved("error", err);
        this.onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this.pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if (typeof removeEventListener === "function") {
                removeEventListener("beforeunload", this.beforeunloadEventListener, false);
                removeEventListener("offline", this.offlineEventListener, false);
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this.prevBufferLen = 0;
        }
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        let i = 0;
        const j = upgrades.length;
        for(; i < j; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */ constructor(uri, opts = {}){
        super();
        this.binaryType = (0, $jdri8.defaultBinaryType);
        this.writeBuffer = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            uri = (0, $63chG.parse)(uri);
            opts.hostname = uri.host;
            opts.secure = uri.protocol === "https" || uri.protocol === "wss";
            opts.port = uri.port;
            if (uri.query) opts.query = uri.query;
        } else if (opts.host) opts.hostname = (0, $63chG.parse)(opts.host).host;
        (0, $kV1Jf.installTimerFunctions)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = opts.transports || [
            "polling",
            "websocket",
            "webtransport"
        ];
        this.writeBuffer = [];
        this.prevBufferLen = 0;
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, $dQmDk.decode)(this.opts.query);
        // set on handshake
        this.id = null;
        this.upgrades = null;
        this.pingInterval = null;
        this.pingTimeout = null;
        // set on heartbeat
        this.pingTimeoutTimer = null;
        if (typeof addEventListener === "function") {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this.beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this.beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this.offlineEventListener = ()=>{
                    this.onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                addEventListener("offline", this.offlineEventListener, false);
            }
        }
        this.open();
    }
}
$1189ee225b4341e2$export$4798917dbf149b79.protocol = (0, $fJuQC.protocol);
module.exports["Socket"] = $1189ee225b4341e2$export$4798917dbf149b79;

});

parcelRegister("dywwS", function(module, exports) {

var $i1sKU = parcelRequire("i1sKU");


var $fv37s = parcelRequire("fv37s");


var $2rMFK = parcelRequire("2rMFK");

const $9de7aefd18065336$export$46dec00755c1153b = {
    websocket: (0, $fv37s.WS),
    webtransport: (0, $2rMFK.WT),
    polling: (0, $i1sKU.Polling)
};
module.exports["transports"] = $9de7aefd18065336$export$46dec00755c1153b;

});

parcelRegister("i1sKU", function(module, exports) {

var $iqTos = parcelRequire("iqTos");


var $824hD = parcelRequire("824hD");


var $fJuQC = parcelRequire("fJuQC");


var $cSNeQ = parcelRequire("cSNeQ");


var $9MAwi = parcelRequire("9MAwi");


var $kV1Jf = parcelRequire("kV1Jf");


var $6jmrP = parcelRequire("6jmrP");

function $d1eea043e1d0d93b$var$empty() {}
const $d1eea043e1d0d93b$var$hasXHR2 = function() {
    const xhr = new (0, $cSNeQ.XHR)({
        xdomain: false
    });
    return null != xhr.responseType;
}();
class $d1eea043e1d0d93b$export$265ee5eefd4c309b extends (0, $iqTos.Transport) {
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this.poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this.polling || !this.writable) {
            let total = 0;
            if (this.polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ poll() {
        this.polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $fJuQC.decodePayload)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this.polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this.poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, $fJuQC.encodePayload)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $824hD.yeast)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
    /**
     * Creates a request.
     *
     * @param {String} method
     * @private
     */ request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd,
            cookieJar: this.cookieJar
        }, this.opts);
        return new $d1eea043e1d0d93b$export$7fa6c5b6f8193917(this.uri(), opts);
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        this.polling = false;
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
        /**
         * XHR supports binary
         */ const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $d1eea043e1d0d93b$var$hasXHR2 && !forceBase64;
        if (this.opts.withCredentials) this.cookieJar = (0, $cSNeQ.createCookieJar)();
    }
}
class $d1eea043e1d0d93b$export$7fa6c5b6f8193917 extends (0, $9MAwi.Emitter) {
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ create() {
        var _a;
        const opts = (0, $kV1Jf.pick)(this.opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this.opts.xd;
        const xhr = this.xhr = new (0, $cSNeQ.XHR)(opts);
        try {
            xhr.open(this.method, this.uri, true);
            try {
                if (this.opts.extraHeaders) {
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this.opts.extraHeaders)if (this.opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this.opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this.method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            (_a = this.opts.cookieJar) === null || _a === void 0 || _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this.opts.withCredentials;
            if (this.opts.requestTimeout) xhr.timeout = this.opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a;
                if (xhr.readyState === 3) (_a = this.opts.cookieJar) === null || _a === void 0 || _a.parseCookies(xhr);
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this.onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this.onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this.data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this.onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this.index = $d1eea043e1d0d93b$export$7fa6c5b6f8193917.requestsCount++;
            $d1eea043e1d0d93b$export$7fa6c5b6f8193917.requests[this.index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ onError(err) {
        this.emitReserved("error", err, this.xhr);
        this.cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ cleanup(fromError) {
        if ("undefined" === typeof this.xhr || null === this.xhr) return;
        this.xhr.onreadystatechange = $d1eea043e1d0d93b$var$empty;
        if (fromError) try {
            this.xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $d1eea043e1d0d93b$export$7fa6c5b6f8193917.requests[this.index];
        this.xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ onLoad() {
        const data = this.xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this.cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this.cleanup();
    }
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(uri, opts){
        super();
        (0, $kV1Jf.installTimerFunctions)(this, opts);
        this.opts = opts;
        this.method = opts.method || "GET";
        this.uri = uri;
        this.data = undefined !== opts.data ? opts.data : null;
        this.create();
    }
}
$d1eea043e1d0d93b$export$7fa6c5b6f8193917.requestsCount = 0;
$d1eea043e1d0d93b$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $d1eea043e1d0d93b$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $6jmrP.globalThisShim) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $d1eea043e1d0d93b$var$unloadHandler, false);
    }
}
function $d1eea043e1d0d93b$var$unloadHandler() {
    for(let i in $d1eea043e1d0d93b$export$7fa6c5b6f8193917.requests)if ($d1eea043e1d0d93b$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $d1eea043e1d0d93b$export$7fa6c5b6f8193917.requests[i].abort();
}
module.exports["Polling"] = $d1eea043e1d0d93b$export$265ee5eefd4c309b;

});

parcelRegister("iqTos", function(module, exports) {
parcelRequire("fJuQC");
var $aVJg7 = parcelRequire("aVJg7");


var $9MAwi = parcelRequire("9MAwi");


var $kV1Jf = parcelRequire("kV1Jf");


var $dQmDk = parcelRequire("dQmDk");

class $d6b59fb1935513d3$export$8e68de6fb26f2236 extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class $d6b59fb1935513d3$export$86495b081fef8e52 extends (0, $9MAwi.Emitter) {
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new $d6b59fb1935513d3$export$8e68de6fb26f2236(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, $aVJg7.decodePacket)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = (0, $dQmDk.encode)(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $kV1Jf.installTimerFunctions)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
    }
}
module.exports["Transport"] = $d6b59fb1935513d3$export$86495b081fef8e52;

});

parcelRegister("fJuQC", function(module, exports) {
$parcel$export(module.exports, "encodePacket", () => (parcelRequire("av4wX")).encodePacket);
$parcel$export(module.exports, "decodePacket", () => (parcelRequire("aVJg7")).decodePacket);

var $av4wX = parcelRequire("av4wX");


var $aVJg7 = parcelRequire("aVJg7");


var $2A5bJ = parcelRequire("2A5bJ");

const $b742fcadcbdf6f1c$var$SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const $b742fcadcbdf6f1c$export$144d64fe58dad441 = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, $av4wX.encodePacket)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join($b742fcadcbdf6f1c$var$SEPARATOR));
        });
    });
};
const $b742fcadcbdf6f1c$export$d10cc2e7f7566a2d = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($b742fcadcbdf6f1c$var$SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, $aVJg7.decodePacket)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
function $b742fcadcbdf6f1c$export$a525fb718e9c623a() {
    // @ts-expect-error
    return new TransformStream({
        transform (packet, controller) {
            (0, $av4wX.encodePacketToBinary)(packet, (encodedPacket)=>{
                const payloadLength = encodedPacket.length;
                let header;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") header[0] |= 0x80;
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
let $b742fcadcbdf6f1c$var$TEXT_DECODER;
function $b742fcadcbdf6f1c$var$totalLength(chunks) {
    return chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
}
function $b742fcadcbdf6f1c$var$concatChunks(chunks, size) {
    if (chunks[0].length === size) return chunks.shift();
    const buffer = new Uint8Array(size);
    let j = 0;
    for(let i = 0; i < size; i++){
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) chunks[0] = chunks[0].slice(j);
    return buffer;
}
function $b742fcadcbdf6f1c$export$552d20aac7500f47(maxPayload, binaryType) {
    if (!$b742fcadcbdf6f1c$var$TEXT_DECODER) $b742fcadcbdf6f1c$var$TEXT_DECODER = new TextDecoder();
    const chunks = [];
    let state = 0 /* READ_HEADER */ ;
    let expectedLength = -1;
    let isBinary = false;
    // @ts-expect-error
    return new TransformStream({
        transform (chunk, controller) {
            chunks.push(chunk);
            while(true){
                if (state === 0 /* READ_HEADER */ ) {
                    if ($b742fcadcbdf6f1c$var$totalLength(chunks) < 1) break;
                    const header = $b742fcadcbdf6f1c$var$concatChunks(chunks, 1);
                    isBinary = (header[0] & 0x80) === 0x80;
                    expectedLength = header[0] & 0x7f;
                    if (expectedLength < 126) state = 3 /* READ_PAYLOAD */ ;
                    else if (expectedLength === 126) state = 1 /* READ_EXTENDED_LENGTH_16 */ ;
                    else state = 2 /* READ_EXTENDED_LENGTH_64 */ ;
                } else if (state === 1 /* READ_EXTENDED_LENGTH_16 */ ) {
                    if ($b742fcadcbdf6f1c$var$totalLength(chunks) < 2) break;
                    const headerArray = $b742fcadcbdf6f1c$var$concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3 /* READ_PAYLOAD */ ;
                } else if (state === 2 /* READ_EXTENDED_LENGTH_64 */ ) {
                    if ($b742fcadcbdf6f1c$var$totalLength(chunks) < 8) break;
                    const headerArray = $b742fcadcbdf6f1c$var$concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n = view.getUint32(0);
                    if (n > Math.pow(2, 21) - 1) {
                        // the maximum safe integer in JavaScript is 2^53 - 1
                        controller.enqueue((0, $2A5bJ.ERROR_PACKET));
                        break;
                    }
                    expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                    state = 3 /* READ_PAYLOAD */ ;
                } else {
                    if ($b742fcadcbdf6f1c$var$totalLength(chunks) < expectedLength) break;
                    const data = $b742fcadcbdf6f1c$var$concatChunks(chunks, expectedLength);
                    controller.enqueue((0, $aVJg7.decodePacket)(isBinary ? data : $b742fcadcbdf6f1c$var$TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* READ_HEADER */ ;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue((0, $2A5bJ.ERROR_PACKET));
                    break;
                }
            }
        }
    });
}
const $b742fcadcbdf6f1c$export$a51d6b395ff4c65a = 4;
module.exports["encodePayload"] = $b742fcadcbdf6f1c$export$144d64fe58dad441;
module.exports["decodePayload"] = $b742fcadcbdf6f1c$export$d10cc2e7f7566a2d;
module.exports["createPacketEncoderStream"] = $b742fcadcbdf6f1c$export$a525fb718e9c623a;
module.exports["createPacketDecoderStream"] = $b742fcadcbdf6f1c$export$552d20aac7500f47;
module.exports["protocol"] = $b742fcadcbdf6f1c$export$a51d6b395ff4c65a;

});

parcelRegister("av4wX", function(module, exports) {

var $2A5bJ = parcelRequire("2A5bJ");

const $7a5050550fe46e87$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const $7a5050550fe46e87$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const $7a5050550fe46e87$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const $7a5050550fe46e87$export$57852049361a8e62 = ({ type: type, data: data }, supportsBinary, callback)=>{
    if ($7a5050550fe46e87$var$withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return $7a5050550fe46e87$var$encodeBlobAsBase64(data, callback);
    } else if ($7a5050550fe46e87$var$withNativeArrayBuffer && (data instanceof ArrayBuffer || $7a5050550fe46e87$var$isView(data))) {
        if (supportsBinary) return callback(data);
        else return $7a5050550fe46e87$var$encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, $2A5bJ.PACKET_TYPES)[type] + (data || ""));
};
const $7a5050550fe46e87$var$encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function $7a5050550fe46e87$var$toArray(data) {
    if (data instanceof Uint8Array) return data;
    else if (data instanceof ArrayBuffer) return new Uint8Array(data);
    else return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
}
let $7a5050550fe46e87$var$TEXT_ENCODER;
function $7a5050550fe46e87$export$ec0c9b9013ee0ef5(packet, callback) {
    if ($7a5050550fe46e87$var$withNativeBlob && packet.data instanceof Blob) return packet.data.arrayBuffer().then($7a5050550fe46e87$var$toArray).then(callback);
    else if ($7a5050550fe46e87$var$withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || $7a5050550fe46e87$var$isView(packet.data))) return callback($7a5050550fe46e87$var$toArray(packet.data));
    $7a5050550fe46e87$export$57852049361a8e62(packet, false, (encoded)=>{
        if (!$7a5050550fe46e87$var$TEXT_ENCODER) $7a5050550fe46e87$var$TEXT_ENCODER = new TextEncoder();
        callback($7a5050550fe46e87$var$TEXT_ENCODER.encode(encoded));
    });
}
module.exports["encodePacket"] = $7a5050550fe46e87$export$57852049361a8e62;
module.exports["encodePacketToBinary"] = $7a5050550fe46e87$export$ec0c9b9013ee0ef5;

});

parcelRegister("2A5bJ", function(module, exports) {
const $1e12f7d10549161c$export$c169aefb7330cccb = Object.create(null); // no Map = no polyfill
$1e12f7d10549161c$export$c169aefb7330cccb["open"] = "0";
$1e12f7d10549161c$export$c169aefb7330cccb["close"] = "1";
$1e12f7d10549161c$export$c169aefb7330cccb["ping"] = "2";
$1e12f7d10549161c$export$c169aefb7330cccb["pong"] = "3";
$1e12f7d10549161c$export$c169aefb7330cccb["message"] = "4";
$1e12f7d10549161c$export$c169aefb7330cccb["upgrade"] = "5";
$1e12f7d10549161c$export$c169aefb7330cccb["noop"] = "6";
const $1e12f7d10549161c$export$47791e8004edd485 = Object.create(null);
Object.keys($1e12f7d10549161c$export$c169aefb7330cccb).forEach((key)=>{
    $1e12f7d10549161c$export$47791e8004edd485[$1e12f7d10549161c$export$c169aefb7330cccb[key]] = key;
});
const $1e12f7d10549161c$export$c718b5840781f8a7 = {
    type: "error",
    data: "parser error"
};
module.exports["PACKET_TYPES"] = $1e12f7d10549161c$export$c169aefb7330cccb;
module.exports["PACKET_TYPES_REVERSE"] = $1e12f7d10549161c$export$47791e8004edd485;
module.exports["ERROR_PACKET"] = $1e12f7d10549161c$export$c718b5840781f8a7;

});

parcelRegister("aVJg7", function(module, exports) {

var $2A5bJ = parcelRequire("2A5bJ");


var $jBpqH = parcelRequire("jBpqH");

const $7f5255c188724aca$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $7f5255c188724aca$export$4647901878f33f31 = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $7f5255c188724aca$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $7f5255c188724aca$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, $2A5bJ.PACKET_TYPES_REVERSE)[type];
    if (!packetType) return 0, $2A5bJ.ERROR_PACKET;
    return encodedPacket.length > 1 ? {
        type: (0, $2A5bJ.PACKET_TYPES_REVERSE)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, $2A5bJ.PACKET_TYPES_REVERSE)[type]
    };
};
const $7f5255c188724aca$var$decodeBase64Packet = (data, binaryType)=>{
    if ($7f5255c188724aca$var$withNativeArrayBuffer) {
        const decoded = (0, $jBpqH.decode)(data);
        return $7f5255c188724aca$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data
    }; // fallback for old browsers
};
const $7f5255c188724aca$var$mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            if (data instanceof Blob) // from WebSocket + binaryType "blob"
            return data;
            else // from HTTP long-polling or WebTransport
            return new Blob([
                data
            ]);
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
            return data;
            else // from WebTransport (Uint8Array)
            return data.buffer;
    }
};
module.exports["decodePacket"] = $7f5255c188724aca$export$4647901878f33f31;

});

parcelRegister("jBpqH", function(module, exports) {
// imported from https://github.com/socketio/base64-arraybuffer
const $e45532d719058451$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
const $e45532d719058451$var$lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for(let i = 0; i < $e45532d719058451$var$chars.length; i++)$e45532d719058451$var$lookup[$e45532d719058451$var$chars.charCodeAt(i)] = i;
const $e45532d719058451$export$c564cdbbe6da493 = (arraybuffer)=>{
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for(i = 0; i < len; i += 3){
        base64 += $e45532d719058451$var$chars[bytes[i] >> 2];
        base64 += $e45532d719058451$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $e45532d719058451$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $e45532d719058451$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
const $e45532d719058451$export$2f872c0f2117be69 = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $e45532d719058451$var$lookup[base64.charCodeAt(i)];
        encoded2 = $e45532d719058451$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $e45532d719058451$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $e45532d719058451$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};
module.exports["decode"] = $e45532d719058451$export$2f872c0f2117be69;

});

parcelRegister("9MAwi", function(module, exports) {
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $71f4ecd9ff8bd726$export$4293555f241ae35a(obj) {
    if (obj) return $71f4ecd9ff8bd726$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $71f4ecd9ff8bd726$var$mixin(obj) {
    for(var key in $71f4ecd9ff8bd726$export$4293555f241ae35a.prototype)obj[key] = $71f4ecd9ff8bd726$export$4293555f241ae35a.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $71f4ecd9ff8bd726$export$4293555f241ae35a.prototype.on = $71f4ecd9ff8bd726$export$4293555f241ae35a.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $71f4ecd9ff8bd726$export$4293555f241ae35a.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $71f4ecd9ff8bd726$export$4293555f241ae35a.prototype.off = $71f4ecd9ff8bd726$export$4293555f241ae35a.prototype.removeListener = $71f4ecd9ff8bd726$export$4293555f241ae35a.prototype.removeAllListeners = $71f4ecd9ff8bd726$export$4293555f241ae35a.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks['$' + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks['$' + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $71f4ecd9ff8bd726$export$4293555f241ae35a.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks['$' + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
$71f4ecd9ff8bd726$export$4293555f241ae35a.prototype.emitReserved = $71f4ecd9ff8bd726$export$4293555f241ae35a.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $71f4ecd9ff8bd726$export$4293555f241ae35a.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $71f4ecd9ff8bd726$export$4293555f241ae35a.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};
module.exports["Emitter"] = $71f4ecd9ff8bd726$export$4293555f241ae35a;

});

parcelRegister("kV1Jf", function(module, exports) {

var $6jmrP = parcelRequire("6jmrP");

function $f3aa78cc35de7d17$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $f3aa78cc35de7d17$var$NATIVE_SET_TIMEOUT = (0, $6jmrP.globalThisShim).setTimeout;
const $f3aa78cc35de7d17$var$NATIVE_CLEAR_TIMEOUT = (0, $6jmrP.globalThisShim).clearTimeout;
function $f3aa78cc35de7d17$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $f3aa78cc35de7d17$var$NATIVE_SET_TIMEOUT.bind((0, $6jmrP.globalThisShim));
        obj.clearTimeoutFn = $f3aa78cc35de7d17$var$NATIVE_CLEAR_TIMEOUT.bind((0, $6jmrP.globalThisShim));
    } else {
        obj.setTimeoutFn = (0, $6jmrP.globalThisShim).setTimeout.bind((0, $6jmrP.globalThisShim));
        obj.clearTimeoutFn = (0, $6jmrP.globalThisShim).clearTimeout.bind((0, $6jmrP.globalThisShim));
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const $f3aa78cc35de7d17$var$BASE64_OVERHEAD = 1.33;
function $f3aa78cc35de7d17$export$a48f0734ac7c2329(obj) {
    if (typeof obj === "string") return $f3aa78cc35de7d17$var$utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * $f3aa78cc35de7d17$var$BASE64_OVERHEAD);
}
function $f3aa78cc35de7d17$var$utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}
module.exports["pick"] = $f3aa78cc35de7d17$export$357523c63a2253b9;
module.exports["installTimerFunctions"] = $f3aa78cc35de7d17$export$2f67576668b97183;
module.exports["byteLength"] = $f3aa78cc35de7d17$export$a48f0734ac7c2329;

});

parcelRegister("6jmrP", function(module, exports) {
const $4985ee142113656c$export$394f9358f6231289 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();
module.exports["globalThisShim"] = $4985ee142113656c$export$394f9358f6231289;

});

parcelRegister("dQmDk", function(module, exports) {
// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ function $a141b02f2319c020$export$c564cdbbe6da493(obj) {
    let str = '';
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += '&';
        str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
    return str;
}
function $a141b02f2319c020$export$2f872c0f2117be69(qs) {
    let qry = {};
    let pairs = qs.split('&');
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split('=');
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}
module.exports["encode"] = $a141b02f2319c020$export$c564cdbbe6da493;
module.exports["decode"] = $a141b02f2319c020$export$2f872c0f2117be69;

});

parcelRegister("824hD", function(module, exports) {
// imported from https://github.com/unshiftio/yeast
'use strict';
const $5d91d541921c95e7$var$alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_'.split(''), $5d91d541921c95e7$var$length = 64, $5d91d541921c95e7$var$map = {};
let $5d91d541921c95e7$var$seed = 0, $5d91d541921c95e7$var$i = 0, $5d91d541921c95e7$var$prev;
function $5d91d541921c95e7$export$c564cdbbe6da493(num) {
    let encoded = '';
    do {
        encoded = $5d91d541921c95e7$var$alphabet[num % $5d91d541921c95e7$var$length] + encoded;
        num = Math.floor(num / $5d91d541921c95e7$var$length);
    }while (num > 0);
    return encoded;
}
function $5d91d541921c95e7$export$2f872c0f2117be69(str) {
    let decoded = 0;
    for($5d91d541921c95e7$var$i = 0; $5d91d541921c95e7$var$i < str.length; $5d91d541921c95e7$var$i++)decoded = decoded * $5d91d541921c95e7$var$length + $5d91d541921c95e7$var$map[str.charAt($5d91d541921c95e7$var$i)];
    return decoded;
}
function $5d91d541921c95e7$export$5bb64b92cb4135a() {
    const now = $5d91d541921c95e7$export$c564cdbbe6da493(+new Date());
    if (now !== $5d91d541921c95e7$var$prev) return $5d91d541921c95e7$var$seed = 0, $5d91d541921c95e7$var$prev = now;
    return now + '.' + $5d91d541921c95e7$export$c564cdbbe6da493($5d91d541921c95e7$var$seed++);
}
//
// Map each character to its index.
//
for(; $5d91d541921c95e7$var$i < $5d91d541921c95e7$var$length; $5d91d541921c95e7$var$i++)$5d91d541921c95e7$var$map[$5d91d541921c95e7$var$alphabet[$5d91d541921c95e7$var$i]] = $5d91d541921c95e7$var$i;
module.exports["yeast"] = $5d91d541921c95e7$export$5bb64b92cb4135a;

});

parcelRegister("cSNeQ", function(module, exports) {
// browser shim for xmlhttprequest module

var $3c1bf = parcelRequire("3c1bf");


var $6jmrP = parcelRequire("6jmrP");

function $9610b8e4d3dd8a9f$export$a2d42eb087c10497(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, $3c1bf.hasCORS))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $6jmrP.globalThisShim)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}
function $9610b8e4d3dd8a9f$export$19413efcf2fac759() {}
module.exports["XHR"] = $9610b8e4d3dd8a9f$export$a2d42eb087c10497;
module.exports["createCookieJar"] = $9610b8e4d3dd8a9f$export$19413efcf2fac759;

});

parcelRegister("3c1bf", function(module, exports) {
// imported from https://github.com/component/has-cors
let $2533687d4953a7a4$var$value = false;
try {
    $2533687d4953a7a4$var$value = typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const $2533687d4953a7a4$export$5235bbd4a1ef06e = $2533687d4953a7a4$var$value;
module.exports["hasCORS"] = $2533687d4953a7a4$export$5235bbd4a1ef06e;

});

parcelRegister("fv37s", function(module, exports) {

var $iqTos = parcelRequire("iqTos");


var $824hD = parcelRequire("824hD");


var $kV1Jf = parcelRequire("kV1Jf");


var $jdri8 = parcelRequire("jdri8");

parcelRequire("fJuQC");
var $av4wX = parcelRequire("av4wX");


var $e9nC3 = parcelRequire("e9nC3");

var $b48c2baca25186d3$require$Buffer = $e9nC3.Buffer;
// detect ReactNative environment
const $b48c2baca25186d3$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $b48c2baca25186d3$export$911baa0677ac404c extends (0, $iqTos.Transport) {
    get name() {
        return "websocket";
    }
    doOpen() {
        if (!this.check()) // let probe timeout
        return;
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $b48c2baca25186d3$var$isReactNative ? {} : (0, $kV1Jf.pick)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = (0, $jdri8.usingBrowserWebSocket) && !$b48c2baca25186d3$var$isReactNative ? protocols ? new (0, $jdri8.WebSocket)(uri, protocols) : new (0, $jdri8.WebSocket)(uri) : new (0, $jdri8.WebSocket)(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $av4wX.encodePacket)(packet, this.supportsBinary, (data)=>{
                // always create a new object (GH-437)
                const opts = {};
                if (!(0, $jdri8.usingBrowserWebSocket)) {
                    if (packet.options) opts.compress = packet.options.compress;
                    if (this.opts.perMessageDeflate) {
                        const len = // @ts-ignore
                        "string" === typeof data ? $b48c2baca25186d3$require$Buffer.byteLength(data) : data.length;
                        if (len < this.opts.perMessageDeflate.threshold) opts.compress = false;
                    }
                }
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    if (0, $jdri8.usingBrowserWebSocket) // TypeError is thrown when passing the second argument on Safari
                    this.ws.send(data);
                    else this.ws.send(data, opts);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $jdri8.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $824hD.yeast)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
    /**
     * Feature detection for WebSocket.
     *
     * @return {Boolean} whether this transport is available.
     * @private
     */ check() {
        return !!(0, $jdri8.WebSocket);
    }
    /**
     * WebSocket transport constructor.
     *
     * @param {Object} opts - connection options
     * @protected
     */ constructor(opts){
        super(opts);
        this.supportsBinary = !opts.forceBase64;
    }
}
module.exports["WS"] = $b48c2baca25186d3$export$911baa0677ac404c;

});

parcelRegister("jdri8", function(module, exports) {

var $6jmrP = parcelRequire("6jmrP");

const $dfd466b7d390ee8a$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $dfd466b7d390ee8a$export$3909fb301d3dc8c9 = (0, $6jmrP.globalThisShim).WebSocket || (0, $6jmrP.globalThisShim).MozWebSocket;
const $dfd466b7d390ee8a$export$3407ba5dfb7a683d = true;
const $dfd466b7d390ee8a$export$790dcbc41e2d75d5 = "arraybuffer";
module.exports["nextTick"] = $dfd466b7d390ee8a$export$bdd553fddd433dcb;
module.exports["WebSocket"] = $dfd466b7d390ee8a$export$3909fb301d3dc8c9;
module.exports["usingBrowserWebSocket"] = $dfd466b7d390ee8a$export$3407ba5dfb7a683d;
module.exports["defaultBinaryType"] = $dfd466b7d390ee8a$export$790dcbc41e2d75d5;

});

parcelRegister("2rMFK", function(module, exports) {

var $iqTos = parcelRequire("iqTos");


var $jdri8 = parcelRequire("jdri8");


var $fJuQC = parcelRequire("fJuQC");

class $1c83dbae146f69b9$export$961c930859384407 extends (0, $iqTos.Transport) {
    get name() {
        return "webtransport";
    }
    doOpen() {
        // @ts-ignore
        if (typeof WebTransport !== "function") return;
        // @ts-ignore
        this.transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        this.transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this.transport.ready.then(()=>{
            this.transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = (0, $fJuQC.createPacketDecoderStream)(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = (0, $fJuQC.createPacketEncoderStream)();
                encoderStream.readable.pipeTo(stream.writable);
                this.writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done: done, value: value })=>{
                        if (done) return;
                        this.onPacket(value);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this.writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this.writer.write(packet).then(()=>{
                if (lastPacket) (0, $jdri8.nextTick)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a;
        (_a = this.transport) === null || _a === void 0 || _a.close();
    }
}
module.exports["WT"] = $1c83dbae146f69b9$export$961c930859384407;

});

parcelRegister("63chG", function(module, exports) {
// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ const $467c8d4af5e8856a$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const $467c8d4af5e8856a$var$parts = [
    'source',
    'protocol',
    'authority',
    'userInfo',
    'user',
    'password',
    'host',
    'port',
    'relative',
    'path',
    'directory',
    'file',
    'query',
    'anchor'
];
function $467c8d4af5e8856a$export$98e6a39c04603d36(str) {
    if (str.length > 2000) throw "URI too long";
    const src = str, b = str.indexOf('['), e = str.indexOf(']');
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    let m = $467c8d4af5e8856a$var$re.exec(str || ''), uri = {}, i = 14;
    while(i--)uri[$467c8d4af5e8856a$var$parts[i]] = m[i] || '';
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }
    uri.pathNames = $467c8d4af5e8856a$var$pathNames(uri, uri['path']);
    uri.queryKey = $467c8d4af5e8856a$var$queryKey(uri, uri['query']);
    return uri;
}
function $467c8d4af5e8856a$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == '/' || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == '/') names.splice(names.length - 1, 1);
    return names;
}
function $467c8d4af5e8856a$var$queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}
module.exports["parse"] = $467c8d4af5e8856a$export$98e6a39c04603d36;

});

parcelRegister("dHQr7", function(module, exports) {
parcelRequire("l3L0C");
var $kV1Jf = parcelRequire("kV1Jf");
var $jdri8 = parcelRequire("jdri8");
var $1vmek = parcelRequire("1vmek");


var $35i9r = parcelRequire("35i9r");


var $bKjvH = parcelRequire("bKjvH");


var $l7Ll3 = parcelRequire("l7Ll3");


var $4ZWvp = parcelRequire("4ZWvp");


var $9MAwi = parcelRequire("9MAwi");

class $9fa7f74dac57e8bf$export$d0d38e7dec7a1a61 extends (0, $9MAwi.Emitter) {
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $1vmek.Socket)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $l7Ll3.on)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            this.maybeReconnectOnOpen();
        };
        // emit `error`
        const errorSub = (0, $l7Ll3.on)(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $l7Ll3.on)(socket, "ping", this.onping.bind(this)), (0, $l7Ll3.on)(socket, "data", this.ondata.bind(this)), (0, $l7Ll3.on)(socket, "error", this.onerror.bind(this)), (0, $l7Ll3.on)(socket, "close", this.onclose.bind(this)), (0, $l7Ll3.on)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, $jdri8.nextTick)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $35i9r.Socket)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
        if (this.engine) this.engine.close();
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called upon engine close.
     *
     * @private
     */ onclose(reason, description) {
        this.cleanup();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $kV1Jf.installTimerFunctions)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, $4ZWvp.Backoff)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $bKjvH;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
}
module.exports["Manager"] = $9fa7f74dac57e8bf$export$d0d38e7dec7a1a61;

});

parcelRegister("35i9r", function(module, exports) {

var $bKjvH = parcelRequire("bKjvH");


var $l7Ll3 = parcelRequire("l7Ll3");


var $9MAwi = parcelRequire("9MAwi");

/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $23efeb308b223684$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $23efeb308b223684$export$4798917dbf149b79 extends (0, $9MAwi.Emitter) {
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $l7Ll3.on)(io, "open", this.onopen.bind(this)),
            (0, $l7Ll3.on)(io, "packet", this.onpacket.bind(this)),
            (0, $l7Ll3.on)(io, "error", this.onerror.bind(this)),
            (0, $l7Ll3.on)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        if ($23efeb308b223684$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, $bKjvH.PacketType).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = this.io.engine && this.io.engine.transport && this.io.engine.transport.writable;
        const discardPacket = this.flags.volatile && (!isTransportWritable || !this.connected);
        if (discardPacket) ;
        else if (this.connected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        const fn = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, args);
        };
        fn.withError = true;
        this.acks[id] = fn;
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        return new Promise((resolve, reject)=>{
            const fn = (arg1, arg2)=>{
                return arg1 ? reject(arg1) : resolve(arg2);
            };
            fn.withError = true;
            args.push(fn);
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            if (packet !== this._queue[0]) // the packet has already been acknowledged
            return;
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, $bKjvH.PacketType).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
        this._clearAcks();
    }
    /**
     * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
     * the server.
     *
     * @private
     */ _clearAcks() {
        Object.keys(this.acks).forEach((id)=>{
            const isBuffered = this.sendBuffer.some((packet)=>String(packet.id) === id);
            if (!isBuffered) {
                // note: handlers that do not accept an error as first argument are ignored here
                const ack = this.acks[id];
                delete this.acks[id];
                if (ack.withError) ack.call(this, new Error("socket has been disconnected"));
            }
        });
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $bKjvH.PacketType).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $bKjvH.PacketType).EVENT:
            case (0, $bKjvH.PacketType).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $bKjvH.PacketType).ACK:
            case (0, $bKjvH.PacketType).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $bKjvH.PacketType).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $bKjvH.PacketType).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $bKjvH.PacketType).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowledgement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if (typeof ack !== "function") return;
        delete this.acks[packet.id];
        // @ts-ignore FIXME ack is incorrectly inferred as 'never'
        if (ack.withError) packet.data.unshift(null);
        // @ts-ignore
        ack.apply(this, packet.data);
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this.emitReserved("connect");
        this._drainQueue(true);
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $bKjvH.PacketType).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        /**
         * A map containing acknowledgement handlers.
         *
         * The `withError` attribute is used to differentiate handlers that accept an error as first argument:
         *
         * - `socket.emit("test", (err, value) => { ... })` with `ackTimeout` option
         * - `socket.timeout(5000).emit("test", (err, value) => { ... })`
         * - `const value = await socket.emitWithAck("test")`
         *
         * From those that don't:
         *
         * - `socket.emit("test", (value) => { ... });`
         *
         * In the first case, the handlers will be called with an error when:
         *
         * - the timeout is reached
         * - the socket gets disconnected
         *
         * In the second case, the handlers will be simply discarded upon disconnection, since the client will never receive
         * an acknowledgement from the server.
         *
         * @private
         */ this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
}
module.exports["Socket"] = $23efeb308b223684$export$4798917dbf149b79;

});

parcelRegister("bKjvH", function(module, exports) {
$parcel$export(module.exports, "PacketType", () => $88d31ff246a38937$export$84d4095e16c6fc19);

var $9MAwi = parcelRequire("9MAwi");


var $iQtFH = parcelRequire("iQtFH");


var $5znJD = parcelRequire("5znJD");

/**
 * These strings must not be used as event names, as they have a special meaning.
 */ const $88d31ff246a38937$var$RESERVED_EVENTS = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
];
const $88d31ff246a38937$export$a51d6b395ff4c65a = 5;
var $88d31ff246a38937$export$84d4095e16c6fc19;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})($88d31ff246a38937$export$84d4095e16c6fc19 || ($88d31ff246a38937$export$84d4095e16c6fc19 = {}));
class $88d31ff246a38937$export$a50aceb0e02a00aa {
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === $88d31ff246a38937$export$84d4095e16c6fc19.EVENT || obj.type === $88d31ff246a38937$export$84d4095e16c6fc19.ACK) {
            if ((0, $5znJD.hasBinary)(obj)) return this.encodeAsBinary({
                type: obj.type === $88d31ff246a38937$export$84d4095e16c6fc19.EVENT ? $88d31ff246a38937$export$84d4095e16c6fc19.BINARY_EVENT : $88d31ff246a38937$export$84d4095e16c6fc19.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === $88d31ff246a38937$export$84d4095e16c6fc19.BINARY_EVENT || obj.type === $88d31ff246a38937$export$84d4095e16c6fc19.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, $iQtFH.deconstructPacket)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */ constructor(replacer){
        this.replacer = replacer;
    }
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function $88d31ff246a38937$var$isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
class $88d31ff246a38937$export$f9de6ca0bc043724 extends (0, $9MAwi.Emitter) {
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === $88d31ff246a38937$export$84d4095e16c6fc19.BINARY_EVENT;
            if (isBinaryEvent || packet.type === $88d31ff246a38937$export$84d4095e16c6fc19.BINARY_ACK) {
                packet.type = isBinaryEvent ? $88d31ff246a38937$export$84d4095e16c6fc19.EVENT : $88d31ff246a38937$export$84d4095e16c6fc19.ACK;
                // binary packet's json
                this.reconstructor = new $88d31ff246a38937$var$BinaryReconstructor(packet);
                // no attachments, labeled binary but no binary data to follow
                if (packet.attachments === 0) super.emitReserved("decoded", packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, $5znJD.isBinary)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if ($88d31ff246a38937$export$84d4095e16c6fc19[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === $88d31ff246a38937$export$84d4095e16c6fc19.BINARY_EVENT || p.type === $88d31ff246a38937$export$84d4095e16c6fc19.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            p.attachments = Number(buf);
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if ($88d31ff246a38937$export$f9de6ca0bc043724.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.reviver);
        } catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $88d31ff246a38937$export$84d4095e16c6fc19.CONNECT:
                return $88d31ff246a38937$var$isObject(payload);
            case $88d31ff246a38937$export$84d4095e16c6fc19.DISCONNECT:
                return payload === undefined;
            case $88d31ff246a38937$export$84d4095e16c6fc19.CONNECT_ERROR:
                return typeof payload === "string" || $88d31ff246a38937$var$isObject(payload);
            case $88d31ff246a38937$export$84d4095e16c6fc19.EVENT:
            case $88d31ff246a38937$export$84d4095e16c6fc19.BINARY_EVENT:
                return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $88d31ff246a38937$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
            case $88d31ff246a38937$export$84d4095e16c6fc19.ACK:
            case $88d31ff246a38937$export$84d4095e16c6fc19.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
    /**
     * Decoder constructor
     *
     * @param {function} reviver - custom reviver to pass down to JSON.stringify
     */ constructor(reviver){
        super();
        this.reviver = reviver;
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class $88d31ff246a38937$var$BinaryReconstructor {
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, $iQtFH.reconstructPacket)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
}
module.exports["protocol"] = $88d31ff246a38937$export$a51d6b395ff4c65a;
module.exports["Encoder"] = $88d31ff246a38937$export$a50aceb0e02a00aa;
module.exports["Decoder"] = $88d31ff246a38937$export$f9de6ca0bc043724;

});

parcelRegister("iQtFH", function(module, exports) {

var $5znJD = parcelRequire("5znJD");

function $db84197660fb1d37$export$ac2edb9eb7af56f6(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $db84197660fb1d37$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function $db84197660fb1d37$var$_deconstructPacket(data, buffers) {
    if (!data) return data;
    if ((0, $5znJD.isBinary)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = $db84197660fb1d37$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = $db84197660fb1d37$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function $db84197660fb1d37$export$a00da3b1ec037a04(packet, buffers) {
    packet.data = $db84197660fb1d37$var$_reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function $db84197660fb1d37$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = $db84197660fb1d37$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = $db84197660fb1d37$var$_reconstructPacket(data[key], buffers);
    }
    return data;
}
module.exports["deconstructPacket"] = $db84197660fb1d37$export$ac2edb9eb7af56f6;
module.exports["reconstructPacket"] = $db84197660fb1d37$export$a00da3b1ec037a04;

});

parcelRegister("5znJD", function(module, exports) {
const $40e2a1ef663eb432$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $40e2a1ef663eb432$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const $40e2a1ef663eb432$var$toString = Object.prototype.toString;
const $40e2a1ef663eb432$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && $40e2a1ef663eb432$var$toString.call(Blob) === "[object BlobConstructor]";
const $40e2a1ef663eb432$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $40e2a1ef663eb432$var$toString.call(File) === "[object FileConstructor]";
function $40e2a1ef663eb432$export$37488ff1135b1696(obj) {
    return $40e2a1ef663eb432$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $40e2a1ef663eb432$var$isView(obj)) || $40e2a1ef663eb432$var$withNativeBlob && obj instanceof Blob || $40e2a1ef663eb432$var$withNativeFile && obj instanceof File;
}
function $40e2a1ef663eb432$export$5234c529abdb5610(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if ($40e2a1ef663eb432$export$5234c529abdb5610(obj[i])) return true;
        }
        return false;
    }
    if ($40e2a1ef663eb432$export$37488ff1135b1696(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $40e2a1ef663eb432$export$5234c529abdb5610(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $40e2a1ef663eb432$export$5234c529abdb5610(obj[key])) return true;
    }
    return false;
}
module.exports["isBinary"] = $40e2a1ef663eb432$export$37488ff1135b1696;
module.exports["hasBinary"] = $40e2a1ef663eb432$export$5234c529abdb5610;

});

parcelRegister("l7Ll3", function(module, exports) {
function $f60ef8de63d196a7$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}
module.exports["on"] = $f60ef8de63d196a7$export$af631764ddc44097;

});

parcelRegister("4ZWvp", function(module, exports) {
/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $3a3a3de97783c425$export$2d38012449449c89(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $3a3a3de97783c425$export$2d38012449449c89.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $3a3a3de97783c425$export$2d38012449449c89.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $3a3a3de97783c425$export$2d38012449449c89.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $3a3a3de97783c425$export$2d38012449449c89.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $3a3a3de97783c425$export$2d38012449449c89.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};
module.exports["Backoff"] = $3a3a3de97783c425$export$2d38012449449c89;

});

parcelRegister("7Hrb0", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $kHija = parcelRequire("kHija");


var $2Cd9j = parcelRequire("2Cd9j");


var $6qdmg = parcelRequire("6qdmg");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $g4l86 = parcelRequire("g4l86");


var $6GwjM = parcelRequire("6GwjM");


var $lncF6 = parcelRequire("lncF6");


var $6VDNG = parcelRequire("6VDNG");


var $dLe3j = parcelRequire("dLe3j");


var $2okgV = parcelRequire("2okgV");


var $gJ15u = parcelRequire("gJ15u");


var $gUfAY = parcelRequire("gUfAY");


var $6s3KO = parcelRequire("6s3KO");


var $5x7ii = parcelRequire("5x7ii");


var $jq7Zs = parcelRequire("jq7Zs");


var $kunUR = parcelRequire("kunUR");


var $J4uEo = parcelRequire("J4uEo");


var $h5yLp = parcelRequire("h5yLp");


var $6f2MR = parcelRequire("6f2MR");


var $adbeL = parcelRequire("adbeL");


var $4JFj6 = parcelRequire("4JFj6");

const $0c84cf950b3b173e$var$logger = (0, $g4l86.createLogger)('Provider', 'black');
const $0c84cf950b3b173e$var$OUT_OF_SYNC_PERIOD = 3000; // 3 seconds
const $0c84cf950b3b173e$export$5330735bb8365155 = 15;
const $0c84cf950b3b173e$export$5124359d21eb0335 = 2;
class $0c84cf950b3b173e$export$2881499e37b75b9a extends (0, $2Cd9j.Emitter) {
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * Initialisation logic, called by Jira with a dummy getState function, deprecated in favour of the setup method which allows more configuration
   * @param {Function} getState Function that returns the editor state, used to retrieve collab-edit properties and to interact with prosemirror-collab
   * @throws {ProviderInitialisationError} Something went wrong during provider initialisation
   * @deprecated Use setup method instead
   */ initialize(getState) {
        return this.setup({
            getState: getState
        });
    }
    /**
   * Initialisation logic, called by the editor in the collab-edit plugin.
   *
   * @param {Function} options.getState Function that returns the editor state, used to retrieve collab-edit properties and to interact with prosemirror-collab
   * @param options.editorApi
   * @param {SyncUpErrorFunction} options.onSyncUpError (Optional) Function that gets called when the sync of steps fails after retrying 30 times, used by Editor to log to analytics
   * @throws {ProviderInitialisationError} Something went wrong during provider initialisation
   */ setup({ getState: getState, editorApi: _editorApi, onSyncUpError: // eslint says unused vars should start with _
    onSyncUpError }) {
        this.checkForCookies();
        try {
            if (!getState) throw new (0, $6VDNG.ProviderInitialisationError)('Collab provider attempted to initialise, but getState is required');
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const collabPlugin = getState().plugins.find((p)=>p.key === 'collab$');
            if (collabPlugin === undefined) throw new (0, $6VDNG.ProviderInitialisationError)('Collab provider attempted to initialise, but Editor state is missing collab plugin');
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.clientId = collabPlugin.spec.config.clientID;
            // generate a temporary id as clientId when it is undefined
            // prefix temp-cp- indicates collab-provider
            if (!this.clientId) // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            this.clientId = `temp-cp-${(0, $kHija.v4)()}`;
            this.documentService.setup({
                getState: getState,
                onSyncUpError: onSyncUpError,
                clientId: this.clientId
            });
            if (this.isBufferingEnabled && this.initialDraft && !this.isProviderInitialized) {
                const { document: document, version: version, metadata: metadata } = this.initialDraft;
                this.updateDocumentAndMetadata({
                    doc: document,
                    version: version,
                    metadata: metadata,
                    caller: 'Provider.setup'
                });
                this.analyticsHelper?.sendActionEvent((0, $J4uEo.EVENT_ACTION).PROVIDER_INITIALIZED, (0, $J4uEo.EVENT_STATUS).INFO, {
                    isBuffered: true
                });
            }
            if (!this.isChannelInitialized) {
                this.initializeChannel();
                this.isChannelInitialized = true;
            }
        } catch (initError) {
            this.analyticsHelper?.sendErrorEvent(initError, 'Error while initialising the provider');
            // Throw error so consumers are aware the initialisation failed when initialising themselves
            throw new (0, $6VDNG.ProviderInitialisationError)('Provider initialisation error', initError);
        }
        return this;
    }
    // Only used for the presence - opts out of the document service and api service
    setupForPresenceOnly(clientId) {
        this.clientId = clientId;
        this.checkForCookies();
        try {
            if (!this.isChannelInitialized) {
                this.initializeChannel();
                this.isChannelInitialized = true;
            }
        } catch (initError) {
            this.analyticsHelper?.sendErrorEvent(initError, 'Error while initialising the provider');
            // Throw error so consumers are aware the initialisation failed when initialising themselves
            throw new (0, $6VDNG.ProviderInitialisationError)('Provider initialisation error', initError);
        }
        return this;
    }
    checkForCookies() {
        if (!$parcel$global.navigator.cookieEnabled) {
            const initError = new (0, $6VDNG.ProviderInitialisationError)('Cookies are not enabled. Please enable cookies to use collaborative editing.');
            this.analyticsHelper?.sendErrorEvent(initError, 'Error while initialising the provider - cookies disabled');
            throw new (0, $6VDNG.ProviderInitialisationError)('Provider initialisation error - cookies disabled', initError);
        }
    }
    /**
   * Send steps from transaction to NCS (and as a consequence to other participants), called from the collab-edit plugin in the editor
   * @param {Transaction} _tr Deprecated, included to keep API consistent with Synchrony provider
   * @param {EditorState} _oldState Deprecated, included to keep API consistent with Synchrony provider
   * @param {EditorState} newState The editor state after applying the transaction
   * @throws {SendTransactionError} Something went wrong while sending the steps for this transaction
   */ send(_tr, _oldState, newState) {
        try {
            if (this.isViewOnly()) {
                const error = {
                    message: 'Attempted to send steps in view only mode',
                    data: {
                        code: (0, $kunUR.INTERNAL_ERROR_CODE).VIEW_ONLY_STEPS_ERROR
                    }
                };
                (0, $g4l86.logObfuscatedSteps)(_oldState, newState).then((attributes)=>{
                    const stepAttributes = attributes instanceof (0, $6VDNG.CustomError) ? {} : {
                        ...attributes
                    };
                    const stepsError = new (0, $6VDNG.CustomError)(error.message, error, {
                        ...stepAttributes
                    });
                    this.analyticsHelper?.sendErrorEvent(stepsError, stepsError.message);
                }).catch((err)=>this.analyticsHelper?.sendErrorEvent(err, err.message));
                return;
            }
            // Don't send steps while the document is locked (eg. when restoring the document)
            if (this.namespaceService.getIsNamespaceLocked()) {
                $0c84cf950b3b173e$var$logger('The document is temporary locked');
                return;
            }
            this.documentService.send(_tr, _oldState, newState);
        } catch (error) {
            this.analyticsHelper?.sendErrorEvent(error, 'Error while sending steps for a transaction');
            throw new (0, $6VDNG.SendTransactionError)('Error while sending steps for a transaction', error);
        }
    }
    isViewOnly() {
        return this.permit && // isPermittedToEdit or isPermittedToView can be undefined, must use `===` here.
        this.permit.isPermittedToEdit === false && this.permit.isPermittedToView === true;
    }
    /**
   * Send messages, such as telepointers,  and AI provider changes to NCS and other participants.
   * Only used for telepointer data (text and node selections) in the editor and JWM.
   * JWM does some weird serialisation stuff on the node selections.
   * Silently fails if an error occurs, since Presence isn't a critical functionality and self-restores over time.
   *
   * @param {CollabTelepointerPayload} data Data you want to send to NCS / the other participants
   * @param {string} data.type Can only be 'telepointer' for now, we don't support anything else yet
   * @param {CollabSendableSelection} data.selection Object representing the selected element
   * @param {string} data.sessionId Identifier identifying the session
   */ sendMessage(data) {
        const basePayload = {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            userId: this.userId,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            sessionId: this.sessionId,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            clientId: this.clientId,
            permit: this.permit
        };
        try {
            if (data?.type === 'telepointer') this.channel.broadcast('participant:telepointer', {
                ...basePayload,
                selection: data.selection
            }, (0, $6f2MR.shouldTelepointerBeSampled)() ? (0, $lncF6.telepointerCallback)(this.config.documentAri) : undefined);
            else if (data?.type === 'ai-provider:change') this.participantsService.sendAIProviderChanged({
                ...basePayload,
                ...data
            });
            else if (data?.type === 'participant:activity') {
                this.setPresenceActivity(data.activity);
                this.participantsService.sendPresenceActivityChanged();
            }
        } catch (error) {
            // We don't want to throw errors for Presence features as they tend to self-restore
            this.analyticsHelper?.sendErrorEvent(error, 'Error while sending message - telepointer');
        }
    }
    setAIProviderActiveIds(ids = []) {
        this.aiProviderActiveIds = ids;
    }
    /**
   * "Destroy" the provider, disconnect it's connection to the back-end service and unsubscribe all event listeners on the provider.
   * Used by Jira products (JWM, JPD) to disable the provider
   * @throws {DestroyError} Something went wrong while shutting down the collab provider
   */ destroy() {
        return this.unsubscribeAll();
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * Disconnect the provider, disconnect it's connection to the back-end service and unsubscribe all event listeners on the provider.
   * Used by Confluence to disable the provider when a user doesn't have access to a resource.
   * @deprecated use destroy instead, it does the same thing
   * @throws {DestroyError} Something went wrong while shutting down the collab provider
   */ disconnect() {
        return this.unsubscribeAll();
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * Disconnect the provider's connection to the back-end service and unsubscribe from all events emitted by this provider. Kept to keep roughly aligned to Synchrony API, which you need to call for each event.
   * @deprecated use destroy instead, it does the same thing
   * @throws {DestroyError} Something went wrong while shutting down the collab provider
   */ unsubscribeAll() {
        try {
            super.unsubscribeAll();
            this.channel.disconnect();
            if (this.sendStepsTimer) {
                clearInterval(this.sendStepsTimer);
                this.sendStepsTimer = undefined;
            }
        } catch (error) {
            this.analyticsHelper?.sendErrorEvent(error, 'Error while shutting down the collab provider');
            throw new (0, $6VDNG.DestroyError)('Error while shutting down the collab provider', error);
        }
        this.clearTimers();
        return this;
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * Update the title of the document in the collab provider and optionally broadcast it to other participants and NCS
   * @deprecated use setMetadata instead, it does the same thing
   * @param {string} title Title you want to set on the document
   * @param {boolean} broadcast (Optional) Flag indicating whether you want to broadcast the title change to the other participants, always true for now (otherwise we would lose title changes)
   * @throws {SetTitleError} Something went wrong while setting the title
   */ setTitle(title, broadcast) {
        try {
            if (this.isViewOnly()) return;
            this.metadataService.setTitle(title, broadcast);
        } catch (error) {
            this.analyticsHelper?.sendErrorEvent(error, 'Error while setting title');
            throw new (0, $6VDNG.SetTitleError)('Error while setting title', error);
        }
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * Set editor width, not used any more
   * @deprecated use setMetadata instead, it does the same thing
   * @param {string} editorWidth string? indicating the editor width
   * @param {boolean} broadcast (Optional) Flag indicating whether you want to broadcast the editor width change
   * @throws {SetEditorWidthError} Something went wrong while setting the editor width
   */ setEditorWidth(editorWidth, broadcast) {
        try {
            this.metadataService.setEditorWidth(editorWidth, broadcast);
        } catch (error) {
            this.analyticsHelper?.sendErrorEvent(error, 'Error while setting editor width');
            throw new (0, $6VDNG.SetEditorWidthError)('Error while setting editor width', error);
        }
    }
    /**
   * Set the editor width and title and distribute it to all participants. Used by Confluence
   * @param {Metadata} metadata The metadata you want to update
   * @throws {ExampleError} Something went wrong while setting the metadata
   */ setMetadata(metadata) {
        try {
            if (this.isViewOnly()) return;
            this.metadataService.setMetadata(metadata);
        } catch (error) {
            this.analyticsHelper?.sendErrorEvent(error, 'Error while setting metadata');
            // Don't re-throw for transient connectivity/initialization errors.
            // (e.g. socket not yet ready, user momentarily offline)
            if ((error instanceof (0, $6VDNG.NotInitializedError) || error instanceof (0, $6VDNG.NotConnectedError)) && (0, $ieeJu.expValEquals)('platform_editor_ignore_metadata_connection_errors', 'isEnabled', true)) return;
            throw new (0, $6VDNG.SetMetadataError)('Error while setting metadata', error);
        }
    }
    /**
   * Returns the namespace locking status via true/false
   */ getIsNamespaceLocked() {
        return this.namespaceService.getIsNamespaceLocked();
    }
    constructor(config){
        super();
        this.api = void 0;
        this.channel = void 0;
        this.config = void 0;
        this.analyticsHelper = void 0;
        this.isChannelInitialized = false;
        this.initialDraft = void 0;
        this.isProviderInitialized = false;
        this.isBuffered = false;
        /**
     * Cache of the last `init` payload, populated when the document and metadata
     * are first applied. Returned by {@link getInitPayload} so that late
     * subscribers (e.g. a freshly-attached collab plugin view after editor
     * preset reconfigure) can be seeded without waiting for the `init` event
     * which is only emitted once per session.
     */ this.lastInitPayload = void 0;
        // User permit is used to determine if the user is allowed to view, comment or edit the document
        // Therefore, the initial value is false for all three
        this.permit = {
            isPermittedToView: false,
            isPermittedToComment: false,
            isPermittedToEdit: false
        };
        // isBufferingEnabled is a boolean value passed to the config during provider creation.
        // It determines if the provider should initialize immediately and will only be true if:
        // the feature flag is enabled and the initial draft fetched from NCS is also passed in the config.
        this.isBufferingEnabled = false;
        // SessionID is the unique socket-session.
        this.sessionId = void 0;
        // ClientID is the unique ID for a prosemirror client. Used for step-rebasing.
        this.clientId = void 0;
        // UserID is the users actual account id.
        this.userId = void 0;
        // PresenceId is used to correlate to independent websocket connections together (presence and editor)
        this.presenceId = void 0;
        // PresenceActivity is used to determine if the user is a viewer or editor, only used in the presence connection
        this.presenceActivity = void 0;
        this.presenceUpdateTimeout = void 0;
        this.disconnectedAt = void 0;
        this.sendStepsTimer = void 0;
        this.participantsService = void 0;
        this.metadataService = void 0;
        this.documentService = void 0;
        this.namespaceService = void 0;
        // Local IDs of active AI Providers
        this.aiProviderActiveIds = [];
        /**
     * Wrapper for this.emit, it binds scope for callbacks and waits for initialising of the editor before emitting events.
     * Waiting for the collab provider to become connected to the editor ensures the editor doesn't miss any events.
     * @param evt - Event name to emit to subscribers
     * @param data - Event data to emit to subscribers
     */ // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.emitCallback = (evt, data)=>this.emit(evt, data);
        /**
     * Wrapper to update document and metadata.
     * Catches and logs any errors thrown by document service's updateDocument and updateMetadata methods and destroys the provider in case of errors.
     * Passing the document, metadata, version (either from the initial draft or from collab service)
     */ this.updateDocumentAndMetadata = ({ doc: doc, version: version, metadata: metadata, caller: caller })=>{
            try {
                this.documentService.updateDocument({
                    doc: doc,
                    version: version,
                    metadata: metadata,
                    caller: caller
                });
                this.metadataService.updateMetadata(metadata);
                this.isProviderInitialized = true;
                // Cache the init payload so late subscribers (e.g. plugin views attached
                // after an editor preset reconfigure) can be seeded via getInitPayload().
                this.lastInitPayload = {
                    doc: doc,
                    version: version,
                    metadata: metadata,
                    caller: caller
                };
            } catch (e) {
                this.analyticsHelper?.sendErrorEvent(e, 'Failed to update with the init document, destroying provider');
                // Stop events and connections to step us trying to talk to the backend with an invalid state.
                this.destroy();
            }
        };
        this.initializeChannel = ()=>{
            this.emit('connecting', {
                initial: true
            });
            // shouldSkipDocumentInit will bypass the NCS draft fetch if the initial draft is passed to the provider
            const shouldSkipDocumentInit = Boolean(this.initialDraft);
            this.channel.on('connected', ({ sid: sid, initialized: initialized })=>{
                this.sessionId = sid;
                this.emit('connected', {
                    sid: sid,
                    initial: !initialized
                });
                const unconfirmedStepsLength = this.documentService.getUnconfirmedSteps()?.length;
                // if buffering is enabled and the provider is initialized before connection,
                // send any unconfirmed steps
                if (this.isBufferingEnabled && this.isProviderInitialized && !this.isBuffered) {
                    this.isBuffered = true; // setting buffering to true so that the sending of unconfirmed steps happens only on first connection
                    this.documentService.sendStepsFromCurrentState(true);
                }
                // Early initialization with initial draft passed via provider
                if (this.initialDraft && initialized && !this.isProviderInitialized) {
                    const { document: document, version: version, metadata: metadata } = this.initialDraft;
                    this.updateDocumentAndMetadata({
                        doc: document,
                        version: version,
                        metadata: metadata,
                        caller: 'connectedHandler'
                    });
                }
                // If already initialized, `connected` means reconnected
                const shouldBypassOutOfSyncGracePeriod = (0, $ieeJu.expValEquals)('collab_bypass_out_of_sync_period_experiment', 'isEnabled', true, false);
                if (initialized && this.disconnectedAt && // Offline longer than `OUT_OF_SYNC_PERIOD`
                (shouldBypassOutOfSyncGracePeriod || Date.now() - this.disconnectedAt >= $0c84cf950b3b173e$var$OUT_OF_SYNC_PERIOD)) this.documentService.throttledCatchupv2((0, $J4uEo.CatchupEventReason).RECONNECTED, {
                    disconnectionPeriodSeconds: Math.floor((Date.now() - this.disconnectedAt) / 1000),
                    offlineStepsLength: (0, $fqVYq.editorExperiment)('platform_editor_offline_editing_web', true) ? (0, $4JFj6.getOfflineStepsLength)(this.documentService.getUnconfirmedSteps(), this.documentService.getUnconfirmedStepsOrigins()) : undefined,
                    offlineReplaceStepsLength: (0, $fqVYq.editorExperiment)('platform_editor_offline_editing_web', true) ? (0, $4JFj6.getOfflineReplaceStepsLength)(this.documentService.getUnconfirmedSteps(), this.documentService.getUnconfirmedStepsOrigins()) : undefined,
                    unconfirmedStepsLength: unconfirmedStepsLength
                }, this.sessionId);
                else if ((0, $ieeJu.expValEquals)('platform_editor_early_exit_return_draft', 'isEnabled', true)) {
                    // Conditionally run catchup based on CollabDraftMetadata.relevance
                    // Only catch up when relevance is 'STALE' or absent
                    // Skip catchup when relevance is 'LATEST' (draft is up-to-date)
                    const relevance = this.initialDraft?.metadata?.relevance;
                    if (relevance === 'STALE' || relevance === undefined) this.documentService.throttledCatchupv2((0, $J4uEo.CatchupEventReason).PROCESS_STEPS);
                }
                this.participantsService.startInactiveRemover(this.sessionId);
                if (this.config.batchProps) {
                    if (this.config.getUser) throw new (0, $6VDNG.ProviderInitialisationError)('Cannot supply getUser and batchProps together');
                    this.participantsService.initializeFirstBatchFetchUsers();
                }
                this.disconnectedAt = undefined;
            }).on('init', ({ doc: doc, version: version, metadata: metadata })=>{
                // Initial document and version
                this.updateDocumentAndMetadata({
                    doc: doc,
                    version: version,
                    metadata: metadata,
                    caller: 'initHandler'
                });
            }).on('restore', this.documentService.onRestore).on('permission', (permit)=>{
                this.permit = Object.assign(this.permit, permit);
                this.emit('permission', permit);
            }).on('steps:added', this.documentService.onStepsAdded).on('metadata:changed', this.metadataService.onMetadataChanged).on('participant:telepointer', (payload)=>this.participantsService.onParticipantTelepointer(payload, this.sessionId)).on('presence:joined', this.participantsService.onPresenceJoined).on('presence', this.participantsService.onPresence).on('participant:left', this.participantsService.onParticipantLeft).on('participant:updated', this.participantsService.onParticipantUpdated).on('disconnect', this.onDisconnected.bind(this)).on('error', this.onErrorHandled).on('status', async (status)=>{
                await this.namespaceService.onNamespaceStatusChanged(status);
                const isLocked = this.namespaceService.getIsNamespaceLocked();
                this.emit('namespace-lock:check', {
                    isLocked: isLocked
                });
            }).connect(shouldSkipDocumentInit);
        };
        this.setUserId = (id)=>{
            this.userId = id;
        };
        this.getPresenceData = ()=>{
            return {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                sessionId: this.sessionId,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                userId: this.userId,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                clientId: this.clientId,
                permit: this.permit,
                presenceId: this.presenceId,
                presenceActivity: this.presenceActivity
            };
        };
        this.setPresenceActivity = (activity)=>{
            this.presenceActivity = activity;
        };
        /**
     * @param {InternalError} error The error to handle
     */ this.onErrorHandled = (error)=>{
            // User tried committing steps but they were rejected because:
            // HEAD_VERSION_UPDATE_FAILED: the collab service's latest stored step tail version didn't correspond to the head version of the first step submitted
            // VERSION_NUMBER_ALREADY_EXISTS: while storing the steps there was a conflict meaning someone else wrote steps into the database more quickly
            if (error.data?.code === (0, $dLe3j.NCS_ERROR_CODE).HEAD_VERSION_UPDATE_FAILED || error.data?.code === (0, $dLe3j.NCS_ERROR_CODE).VERSION_NUMBER_ALREADY_EXISTS) this.documentService.onStepRejectedError();
            else {
                this.analyticsHelper?.sendErrorEvent(error, error.message);
                const mappedError = (0, $jq7Zs.errorCodeMapper)(error);
                // Only emit errors to Confluence very intentionally because they will disconnect the collab provider
                if (mappedError) {
                    this.analyticsHelper?.sendProviderErrorEvent(mappedError);
                    this.emit('error', mappedError);
                }
            }
        };
        this.getAIProviderActiveIds = ()=>{
            return this.aiProviderActiveIds;
        };
        // Note: this gets triggered on page reload for Firefox (not other browsers) because of closeOnBeforeunload: false
        this.onDisconnected = ({ reason: reason })=>{
            this.disconnectedAt = Date.now();
            this.participantsService.disconnect(reason, this.sessionId);
        };
        /**
     * Returns the documents metadata
     */ this.getMetadata = ()=>{
            return this.metadataService.getMetaData();
        };
        /**
     * Returns the cached `init` payload if the provider has already initialised
     * the document, otherwise `undefined`.
     *
     * Used by the collab plugin's `view()` factory to seed a freshly-attached
     * plugin view (e.g. after editor preset reconfigure or full EditorView
     * recreation) with the same `init` data the original subscribers received.
     * Without this, late subscribers never receive `init` (it is emitted only
     * once per session) and the editor stays in `!isReady`, silently dropping
     * doc-changing transactions.
     */ this.getInitPayload = ()=>{
            if (!this.isProviderInitialized) return undefined;
            return this.lastInitPayload;
        };
        /**
     * Return the ADF version of the current draft document, together with it's title and the current step version.
     * Used for draft sync, a process running every 5s for the first editor of a document to sync the document to the Confluence back-end.
     * @throws {GetCurrentStateError} Something went wrong while returning the current state
     */ this.getCurrentState = async ()=>{
            try {
                return await this.documentService.getCurrentState();
            } catch (error) {
                this.analyticsHelper?.sendErrorEvent(error, 'Error while returning ADF version of current draft document');
                throw new (0, $6VDNG.GetCurrentStateError)('Error while returning the current state of the draft document', error); // Reject the promise so the consumer can react to it failing
            }
        };
        /**
     * Return the final acknowledged (by NCS) ADF version of the current draft document, together with it's title and the current step version.
     * Used when returning the document to Confluence on publish.
     * @throws {GetFinalAcknowledgedStateError} Something went wrong while returning the acknowledged state
     */ this.getFinalAcknowledgedState = async (reason)=>{
            try {
                return await this.documentService.getFinalAcknowledgedState(reason);
            } catch (error) {
                this.analyticsHelper?.sendErrorEvent(error, 'Error while returning ADF version of the final draft document');
                throw new (0, $6VDNG.GetFinalAcknowledgedStateError)('Error while returning the final acknowledged state of the draft document', error); // Reject the promise so the consumer can react to it failing
            }
        };
        this.getUnconfirmedSteps = ()=>{
            return this.documentService.getUnconfirmedSteps();
        };
        /**
     * Provides a synchronous method to retreive the version from the Document Service / Editor State
     *
     * @returns {number} Returns the current ProseMirror version from the Editor State
     */ this.getCurrentPmVersion = ()=>{
            return this.documentService.getCurrentPmVersion();
        };
        /**
     * Used when the provider is disconnected or destroyed to prevent perpetual timers from continuously running
     */ this.clearTimers = ()=>{
            clearTimeout(this.presenceUpdateTimeout);
            this.participantsService.clearTimers();
        };
        this.getParticipants = ()=>{
            return this.participantsService.getParticipants();
        };
        this.getUniqueParticipantSize = ()=>{
            return this.participantsService.getUniqueParticipantSize();
        };
        this.getUniqueParticipants = ()=>{
            return this.participantsService.getUniqueParticipants({
                isHydrated: false
            });
        };
        this.getUniqueHydratedParticipants = ()=>{
            return this.participantsService.getUniqueParticipants({
                isHydrated: true
            });
        };
        this.getAIProviderParticipants = ()=>{
            return this.participantsService.getAIProviderParticipants();
        };
        this.fetchMore = async (props)=>{
            if (this.config.batchProps) await this.participantsService.enrichParticipants({
                ...this.config.batchProps,
                batchSize: props?.fetchSize ?? this.config.batchProps.batchSize
            });
            else throw new Error('Must provide batch properties to use fetchMore');
        };
        this.getSessionId = ()=>{
            return this.sessionId;
        };
        this.getDocumentAri = ()=>{
            return this.config.documentAri;
        };
        this.config = config;
        this.analyticsHelper = new (0, $6GwjM.default)(this.config.documentAri, this.config.productInfo?.subProduct, this.config.analyticsClient, this.config.getAnalyticsWebClient);
        this.channel = new (0, $6qdmg.Channel)(config, this.analyticsHelper);
        this.isChannelInitialized = false;
        this.initialDraft = this.config.initialDraft;
        this.isBufferingEnabled = Boolean(this.config.isBufferingEnabled);
        this.isProviderInitialized = false;
        this.participantsService = new (0, $5x7ii.ParticipantsService)(this.analyticsHelper, undefined, this.emitCallback, this.config.getUser, this.config.batchProps, this.channel.broadcast, this.channel.sendPresenceJoined, this.getPresenceData, this.setUserId, this.getAIProviderActiveIds, this.config.fetchAnonymousAsset);
        this.metadataService = new (0, $2okgV.MetadataService)(this.emitCallback, this.channel.sendMetadata);
        this.namespaceService = new (0, $6s3KO.NamespaceService)();
        this.presenceId = this.config.presenceId;
        this.presenceActivity = this.config.presenceActivity;
        if (config.isPresenceOnly) {
            // this check is specifically for the presence only
            // This presence feature is only for the confluence view page & jira presence which do not need the document service or api
            this.documentService = new (0, $gUfAY.NullDocumentService)();
            this.api = new (0, $adbeL.NullApi)();
        } else {
            this.documentService = new (0, $gJ15u.DocumentService)(this.participantsService, this.analyticsHelper, this.channel.fetchCatchupv2, this.channel.fetchReconcile, this.channel.fetchGeneratedDiffSteps, this.emitCallback, this.channel.broadcast, ()=>this.userId, this.onErrorHandled, this.metadataService, this.namespaceService.getIsNamespaceLocked.bind(this.namespaceService), this.config.enableErrorOnFailedDocumentApply, {
                __livePage: this.config.__livePage || false
            }, this.channel.getConnected);
            this.api = new (0, $h5yLp.Api)(config, this.documentService, this.channel);
        }
        this.sendStepsTimer = setInterval(()=>{
            $0c84cf950b3b173e$var$logger('Intervally sendStepsFromCurrentState');
            this.documentService.sendStepsFromCurrentState(true, undefined);
        }, 5000);
    }
}
module.exports["MAX_STEP_REJECTED_ERROR"] = $0c84cf950b3b173e$export$5330735bb8365155;
module.exports["MAX_STEP_REJECTED_ERROR_AGGRESSIVE"] = $0c84cf950b3b173e$export$5124359d21eb0335;
module.exports["Provider"] = $0c84cf950b3b173e$export$2881499e37b75b9a;

});

parcelRegister("2Cd9j", function(module, exports) {

var $7XeMy = parcelRequire("7XeMy");

class $14b6e8e92f543e3b$export$4293555f241ae35a {
    /**
   * Emit events to subscribers
   */ emit(evt, data) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.eventEmitter.emit(evt, data);
        return this;
    }
    /**
   * Subscribe to events emitted by this provider
   */ on(evt, handler) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.eventEmitter.on(evt, handler);
        return this;
    }
    /**
   * Unsubscribe from events emitted by this provider
   */ off(evt, handler) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.eventEmitter.off(evt, handler);
        return this;
    }
    /**
   * Unsubscribe from all events emitted by this provider.
   */ unsubscribeAll(evt) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.eventEmitter.removeAllListeners(evt);
        return this;
    }
    constructor(){
        this.eventEmitter = new (0, $7XeMy.EventEmitter2)();
    }
}
module.exports["Emitter"] = $14b6e8e92f543e3b$export$4293555f241ae35a;

});

parcelRegister("6qdmg", function(module, exports) {

var $gABt9 = parcelRequire("gABt9");


var $2Cd9j = parcelRequire("2Cd9j");


var $g4l86 = parcelRequire("g4l86");


var $6f2MR = parcelRequire("6f2MR");


var $J4uEo = parcelRequire("J4uEo");


var $hCWnd = parcelRequire("hCWnd");


var $8ciNw = parcelRequire("8ciNw");


var $1Gjof = parcelRequire("1Gjof");


var $4pCX8 = parcelRequire("4pCX8");


var $kunUR = parcelRequire("kunUR");


var $dLe3j = parcelRequire("dLe3j");


var $6VDNG = parcelRequire("6VDNG");


var $cbY7C = parcelRequire("cbY7C");

const $f1b270f0f3c4c8c1$var$logger = (0, $g4l86.createLogger)('Channel', 'green');
class $f1b270f0f3c4c8c1$export$cfdacaa37f9b4dd7 extends (0, $2Cd9j.Emitter) {
    /**
   * Connect to collab service using websockets
   */ connect(shouldInitialize = false) {
        (0, $6f2MR.startMeasure)((0, $6f2MR.MEASURE_NAME).SOCKET_CONNECT, this.analyticsHelper);
        // If provider already has access to the initial draft, explicitly set channel as initialized
        // to bypass BE doc retrieval
        if (shouldInitialize) this.initialized = true;
        if (!this.initialized) {
            (0, $6f2MR.startMeasure)((0, $6f2MR.MEASURE_NAME).DOCUMENT_INIT, this.analyticsHelper);
            this.initExperience?.start();
        }
        const { documentAri: documentAri, url: url, path: path, createSocket: createSocket, permissionTokenRefresh: permissionTokenRefresh } = this.config;
        let auth;
        if (permissionTokenRefresh) auth = async (cb)=>{
            // Rebuild authData to ensure values are current
            const authData = {
                // The initialized status. If false, BE will send document, otherwise not.
                initialized: this.initialized,
                // ESS-1009 Allow to opt-in into 404 response
                need404: this.config.need404
            };
            try {
                const token = await permissionTokenRefresh();
                if (token) authData.token = token;
                else authData.token = undefined;
                cb(authData);
            } catch (error) {
                // Pass the error back to the consumers so they can deal with exceptional cases themselves (eg. no permissions because the page was deleted)
                const authenticationError = {
                    message: 'Insufficient editing permissions',
                    data: {
                        status: 403,
                        code: (0, $kunUR.INTERNAL_ERROR_CODE).TOKEN_PERMISSION_ERROR,
                        meta: {
                            originalError: error,
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            reason: error?.data?.meta?.reason // Should always be 'RESOURCE_DELETED' Temporary, until Confluence Cloud removes their hack
                        }
                    }
                };
                this.emit('error', authenticationError);
            }
        };
        else // Ignored via go/ees005
        // eslint-disable-next-line require-await
        auth = async (cb)=>{
            // Rebuild authData to ensure values are current
            const authData = {
                // The initialized status. If false, BE will send document, otherwise not.
                initialized: this.initialized,
                // ESS-1009 Allow to opt-in into 404 response
                need404: this.config.need404
            };
            cb(authData);
        };
        this.socket = createSocket(`${url}/session/${documentAri}`, auth, this.config.productInfo, this.config.isPresenceOnly, this.analyticsHelper, path, documentAri);
        // Due to https://github.com/socketio/socket.io-client/issues/1473,
        // reconnect no longer fired on the socket.
        // We should use `connect` for better cross platform compatibility(Mobile/Web).
        this.socket.on('connect', this.onConnect);
        this.socket.on('data', this.onReceiveData);
        this.socket.on('permission', (permit)=>{
            this.emit('permission', permit);
        });
        this.socket.on('steps:added', (data)=>{
            this.emit('steps:added', data);
        });
        this.socket.on('participant:telepointer', ({ timestamp: timestamp, data: data })=>{
            // data is TelepointerPayload without timestamp
            this.emit('participant:telepointer', {
                timestamp: timestamp,
                ...data
            });
        });
        this.socket.on('presence:joined', (data)=>{
            this.emit('presence:joined', data);
        });
        this.socket.on('presence', (data)=>{
            this.emit('presence', data);
        });
        this.socket.on('participant:left', (data)=>{
            this.emit('participant:left', data);
        });
        this.socket.on('participant:updated', ({ sessionId: sessionId, timestamp: timestamp, data: data, clientId: clientId })=>{
            this.emit('participant:updated', {
                sessionId: sessionId,
                timestamp: timestamp,
                clientId: clientId,
                ...data
            });
        });
        this.socket.on('metadata:changed', (payload)=>{
            this.emit('metadata:changed', payload);
        });
        // ESS-2916 namespace status event - lock/unlock
        this.socket.on('status', (data)=>{
            this.emit('status', data);
        });
        // Ignored via go/ees005
        // eslint-disable-next-line require-await
        this.socket.on('disconnect', async (reason)=>{
            this.connected = false;
            $f1b270f0f3c4c8c1$var$logger(`disconnect reason: ${reason}`);
            this.emit('disconnect', {
                reason: reason
            });
            if (reason === (0, $1Gjof.socketIOReasons).IO_SERVER_DISCONNECT && this.socket) // The disconnection was initiated by the server, we need to reconnect manually.
            try {
                this.socket.connect();
            } catch (error) {
                this.analyticsHelper?.sendErrorEvent(error, 'Error while reconnecting the channel');
                const reconnectionError = {
                    message: 'Caught error during reconnection',
                    data: {
                        status: 500,
                        code: (0, $kunUR.INTERNAL_ERROR_CODE).RECONNECTION_ERROR
                    }
                };
                this.emit('error', reconnectionError);
            }
        });
        // Socket error, including errors from `packetMiddleware`, `controllers` and `onconnect` and more. Parameter is a plain JSON object.
        this.socket.on('error', (socketError)=>{
            this.emit('error', socketError);
        });
        // `connect_error`'s parameter type is `Error`.
        // Ensure the error emit to the provider has the same structure, so we can handle them unified.
        this.socket.on('connect_error', this.onConnectError);
        this.socket.on('permission:invalidateToken', this.handlePermissionInvalidateToken);
        this.socket.onAnyOutgoing((_, ...args)=>this.onAnyOutgoingHandler(Date.now(), args));
        // To trigger reconnection when browser comes back online
        if (!this.network) this.network = new (0, $4pCX8.default)({
            onlineCallback: this.onOnlineHandler
        });
        // Helper class to track reconnection issues, to emit an error if too many failed reconnection attempts happen
        this.reconnectHelper = new (0, $hCWnd.default)();
        // Fired upon a reconnection attempt error (from Socket.IO Manager)
        this.socket.io.on('reconnect_error', this.onReconnectError);
        // Automatic disconnect on tab background with delay, to keep presence UX accurate
        // and reduce wasted connections. Reconnects upon tab becoming active again
        this.addVisiblityListener();
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onAnyOutgoingHandler(currentTimeMs, args) {
        const rateLimitType = this.config.rateLimitType || this.RATE_LIMIT_TYPE_NONE;
        if (rateLimitType === this.RATE_LIMIT_TYPE_NONE) return;
        const stepLimit = this.config.rateLimitStepCount || 0;
        const stepSizeLimit = this.config.rateLimitTotalStepSize || 0;
        const maxStepSizeLimit = this.config.rateLimitMaxStepSize || 0;
        for (const arg of args)if (arg.type === 'steps:commit') {
            if (currentTimeMs - this.rateLimitWindowStartMs > this.rateLimitWindowDurationMs) {
                // Start a new window
                this.rateLimitWindowStartMs = currentTimeMs;
                this.stepCounter = 0;
                this.stepSizeCounter = 0;
                this.maxStepSize = 0;
            }
            this.stepCounter += arg.steps.length;
            for (const step of arg.steps){
                const stepSize = JSON.stringify(step).length;
                this.stepSizeCounter += stepSize;
                if (stepSize > this.maxStepSize) this.maxStepSize = stepSize;
            }
            if (this.isLimitExceeded(stepLimit, stepSizeLimit, maxStepSizeLimit)) {
                const rateLimitError = {
                    message: 'Rate limited',
                    data: {
                        code: (0, $dLe3j.NCS_ERROR_CODE).RATE_LIMIT_ERROR,
                        status: 500,
                        meta: {
                            rateLimitType: rateLimitType,
                            maxStepSize: this.maxStepSize,
                            stepSizeCounter: this.stepSizeCounter,
                            stepCounter: this.stepCounter
                        }
                    }
                };
                if (rateLimitType === this.RATE_LIMIT_TYPE_HARD) {
                    this.emit('error', rateLimitError);
                    throw new Error();
                } else if (rateLimitType === this.RATE_LIMIT_TYPE_SOFT) this.analyticsHelper?.sendErrorEvent(rateLimitError, 'Rate limited');
            }
        }
    }
    async commonHeaders() {
        return {
            ...this.config.permissionTokenRefresh ? {
                'x-token': await this.getChannelToken()
            } : {},
            'x-product': (0, $g4l86.getProduct)(this.config.productInfo),
            'x-subproduct': (0, $g4l86.getSubProduct)(this.config.productInfo)
        };
    }
    isLimitExceeded(stepLimit, stepSizeLimit, maxStepSizeLimit) {
        return stepLimit > 0 && this.stepCounter > stepLimit || stepSizeLimit > 0 && this.stepSizeCounter > stepSizeLimit || maxStepSizeLimit > 0 && this.maxStepSize > maxStepSizeLimit;
    }
    /**
   * Adds an event listener for visibilitychange events to automatically close the socket
   * connection  if tab is in background for longer than disconnectDelay
   */ addVisiblityListener() {
        const disconnectDelay = 60;
        if (this.config.isPresenceOnly) this.unbindVisibilityListener = (0, $cbY7C.bind)(document, {
            type: 'visibilitychange',
            listener: ()=>{
                this.disconnectTimer = this.autoDisconnect(this.disconnectTimer, disconnectDelay);
            }
        });
    }
    disconnect() {
        this.unsubscribeAll();
        this.cleanupAutoDisconnect();
        this.network?.destroy();
        this.network = null;
        if (this.socket) {
            this.socket.close();
            this.socket = null;
            this.reconnectHelper?.destroy();
        }
    }
    constructor(config, analyticsHelper){
        super();
        this.RATE_LIMIT_TYPE_NONE = 0;
        this.RATE_LIMIT_TYPE_SOFT = 1;
        this.RATE_LIMIT_TYPE_HARD = 2;
        this.connected = false;
        this.config = void 0;
        this.socket = null;
        this.reconnectHelper = null;
        this.initialized = false;
        this.analyticsHelper = void 0;
        this.initExperience = void 0;
        this.token = void 0;
        this.network = null;
        this.disconnectTimer = void 0;
        this.rateLimitWindowDurationMs = 60000;
        this.rateLimitWindowStartMs = 0;
        this.stepCounter = 0;
        this.stepSizeCounter = 0;
        this.maxStepSize = 0;
        // read-only getters used for tests
        this.getInitialized = ()=>this.initialized;
        this.getConnected = ()=>this.connected;
        this.getSocket = ()=>this.socket;
        this.getToken = ()=>this.token;
        // Used to retrieve the x-token for API requests
        this.getChannelToken = async ()=>{
            if (this.token) return this.token;
            if (!this.config.permissionTokenRefresh) return undefined;
            const token = await this.config.permissionTokenRefresh() ?? undefined;
            return token;
        };
        this.handlePermissionInvalidateToken = (data)=>{
            $f1b270f0f3c4c8c1$var$logger('Received permission invalidate event ', data);
            this.analyticsHelper?.sendActionEvent((0, $J4uEo.EVENT_ACTION).INVALIDATE_TOKEN, (0, $J4uEo.EVENT_STATUS).SUCCESS, {
                reason: data.reason,
                // Potentially incorrect when value of token changes between connecting and connect.
                // See: https://bitbucket.org/atlassian/%7Bc8e2f021-38d2-46d0-9b7a-b3f7b428f724%7D/pull-requests/29905#comment-375308874
                usedCachedToken: !!this.token
            });
        };
        this.onConnectError = (error)=>{
            const measure = (0, $6f2MR.stopMeasure)((0, $6f2MR.MEASURE_NAME).SOCKET_CONNECT, this.analyticsHelper);
            this.analyticsHelper?.sendActionEvent((0, $J4uEo.EVENT_ACTION).CONNECTION, (0, $J4uEo.EVENT_STATUS).FAILURE, {
                latency: measure?.duration,
                // Potentially incorrect when value of token changes between connecting and connect.
                // See: https://bitbucket.org/atlassian/%7Bc8e2f021-38d2-46d0-9b7a-b3f7b428f724%7D/pull-requests/29905#comment-375308874
                usedCachedToken: !!this.token
            });
            this.analyticsHelper?.sendErrorEvent(error, 'Error while establishing connection');
            // If error received with `data`, it means the connection is rejected
            // by the server on purpose for example no permission, so no need to
            // keep the underneath connection, need to close. But some error like
            // `xhr polling error` needs to retry.
            const errorData = error.data;
            if (errorData) this.socket?.close();
            const connectionError = {
                message: error.message ?? 'Connection error without message',
                data: {
                    // @ts-expect-error I bet we'll see some connection errors, for the Socket IO errors
                    code: errorData?.code ?? (0, $kunUR.INTERNAL_ERROR_CODE).CONNECTION_ERROR,
                    ...errorData
                }
            };
            this.emit('error', connectionError);
        };
        this.onReconnectError = (error)=>{
            this.reconnectHelper?.countReconnectError();
            if (this.reconnectHelper?.isLikelyNetworkIssue()) {
                this.analyticsHelper?.sendErrorEvent(error, 'Likely network issue while reconnecting the channel');
                const reconnectionError = {
                    message: 'Reconnection failed 8 times when browser was offline, likely there was a network issue',
                    data: {
                        code: (0, $kunUR.INTERNAL_ERROR_CODE).RECONNECTION_NETWORK_ISSUE
                    }
                };
                this.emit('error', reconnectionError);
            }
        };
        this.onConnect = ()=>{
            this.connected = true;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            $f1b270f0f3c4c8c1$var$logger('Connected.', this.socket.id);
            const measure = (0, $6f2MR.stopMeasure)((0, $6f2MR.MEASURE_NAME).SOCKET_CONNECT, this.analyticsHelper);
            this.analyticsHelper?.sendActionEvent((0, $J4uEo.EVENT_ACTION).CONNECTION, (0, $J4uEo.EVENT_STATUS).SUCCESS, {
                latency: measure?.duration,
                // Potentially incorrect when value of token changes between connecting and connect.
                // See: https://bitbucket.org/atlassian/%7Bc8e2f021-38d2-46d0-9b7a-b3f7b428f724%7D/pull-requests/29905#comment-375308874
                usedCachedToken: !!this.token
            });
            this.emit('connected', {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                sid: this.socket.id,
                initialized: this.initialized
            });
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onReceiveData = (data)=>{
            $f1b270f0f3c4c8c1$var$logger('Received data', data);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            $f1b270f0f3c4c8c1$var$logger('Session ID is', this.socket.id);
            if (data.type === 'initial') {
                if (!this.initialized) {
                    const { doc: doc, version: version, userId: userId, metadata: metadata } = data;
                    const measure = (0, $6f2MR.stopMeasure)((0, $6f2MR.MEASURE_NAME).DOCUMENT_INIT, this.analyticsHelper);
                    this.initExperience?.success();
                    this.analyticsHelper?.sendActionEvent((0, $J4uEo.EVENT_ACTION).DOCUMENT_INIT, // TODO: ED-26957 - detect when document init fails and fire corresponding event for it
                    (0, $J4uEo.EVENT_STATUS).SUCCESS, {
                        latency: measure?.duration,
                        resetReason: data.resetReason,
                        hasTitle: !!data.metadata?.title
                    });
                    this.initialized = true;
                    this.emit('init', {
                        doc: doc,
                        version: version,
                        userId: userId,
                        metadata: metadata
                    });
                } else {
                    // Page has just been restored, need to fix all the participants as well.
                    const { doc: doc, version: version, userId: userId, metadata: metadata, targetClientId: targetClientId } = data;
                    this.emit('restore', {
                        doc: doc,
                        version: version,
                        userId: userId,
                        metadata: metadata,
                        targetClientId: targetClientId
                    });
                }
            } else this.emit('steps:added', data);
        };
        this.fetchCatchupv2 = async (fromVersion, clientId, catchUpOutofSync, reason, sessionId)=>{
            try {
                const { steps: steps, metadata: metadata } = await (0, $gABt9.utils).requestService(this.config, {
                    path: `document/${encodeURIComponent(this.config.documentAri)}/catchupv2`,
                    queryParams: {
                        version: fromVersion,
                        clientId: clientId,
                        catchUpOutofSync: catchUpOutofSync,
                        reason: reason,
                        sessionId: sessionId
                    },
                    requestInit: {
                        headers: await this.commonHeaders()
                    }
                });
                return {
                    steps: steps,
                    metadata: metadata
                };
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                if (error.code === 404) {
                    const errorNotFound = {
                        message: 'The requested document is not found',
                        data: {
                            status: error.code,
                            code: (0, $kunUR.INTERNAL_ERROR_CODE).DOCUMENT_NOT_FOUND
                        }
                    };
                    this.emit('error', errorNotFound);
                    return {};
                }
                $f1b270f0f3c4c8c1$var$logger("Can't fetch the catchupv2", error.message);
                const errorCatchupv2 = {
                    message: 'Cannot fetch catchupv2 from collab service',
                    data: {
                        status: error.status,
                        code: (0, $kunUR.INTERNAL_ERROR_CODE).CATCHUP_FAILED
                    }
                };
                this.emit('error', errorCatchupv2);
                throw error;
            }
        };
        this.fetchReconcile = async (currentStateDoc, reason)=>{
            try {
                const reqBody = JSON.stringify({
                    doc: currentStateDoc,
                    productId: 'ccollab',
                    reason: reason
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const reconcileResponse = await (0, $gABt9.utils).requestService(this.config, {
                    path: `document/${encodeURIComponent(this.config.documentAri)}/reconcile`,
                    requestInit: {
                        headers: {
                            ...await this.commonHeaders(),
                            'Content-Type': 'application/json'
                        },
                        method: 'POST',
                        body: reqBody
                    }
                });
                return reconcileResponse;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                this.analyticsHelper?.sendErrorEvent(error, 'Error while fetching reconciled document');
                throw error;
            }
        };
        /**
     * Fetch generated diff steps from the back-end service
     * @param currentStateDoc - The current state document
     * @param reason - The reason for generating diff steps
     * @returns {Promise<GenerateDiffStepsResponseBody>} - The generated diff steps response body
     */ this.fetchGeneratedDiffSteps = async (currentStateDoc, reason)=>{
            try {
                const reqBody = JSON.stringify({
                    doc: currentStateDoc,
                    productId: 'ccollab',
                    reason: reason
                });
                const reconcileResponse = await (0, $gABt9.utils).requestService(this.config, {
                    path: `document/${encodeURIComponent(this.config.documentAri)}/generate-diff-steps`,
                    requestInit: {
                        headers: {
                            ...await this.commonHeaders(),
                            'Content-Type': 'application/json'
                        },
                        method: 'POST',
                        body: reqBody
                    }
                });
                return reconcileResponse;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                this.analyticsHelper?.sendErrorEvent(error, 'Error while fetching generated steps from the BE server');
                throw error;
            }
        };
        /**
     * Send message to the back-end service over the channel. Timestamp will be added server side.
     * @throws {NotInitializedError} Channel not initialized
     * @throws {NotConnectedError} Channel not connected
     */ this.broadcast = (type, data, callback)=>{
            if (!this.socket) throw new (0, $6VDNG.NotInitializedError)('Cannot broadcast, not initialized yet');
            if (!this.connected) {
                if (this.config.throwOnNotConnected) throw new (0, $6VDNG.NotConnectedError)('Cannot broadcast, currently offline.');
                return;
            }
            this.socket.emit('broadcast', {
                type: type,
                ...data
            }, callback);
        };
        /**
     * Send metadata to the back-end service over the channel
     * @throws {NotInitializedError} Channel not initialized
     * @throws {NotConnectedError} Channel not connected
     */ this.sendMetadata = (metadata)=>{
            if (!this.socket) throw new (0, $6VDNG.NotInitializedError)('Cannot send metadata, not initialized yet');
            if (!this.connected) {
                if (this.config.throwOnNotConnected) throw new (0, $6VDNG.NotConnectedError)('Cannot send metadata, currently offline.');
            }
            this.socket.emit('metadata', metadata);
        };
        this.sendPresenceJoined = ()=>{
            if (!this.connected || !this.socket) return;
            this.socket.emit('presence:joined');
        };
        this.onOnlineHandler = ()=>{
            // Force an immediate reconnect, the socket must first be closed to reset reconnection delay logic
            if (!this.connected) {
                this.socket?.close();
                this.socket?.connect();
            }
        };
        /**
     * Unbinds event listeners and timers used when handling connection auto-close when tab is hidden
     */ this.cleanupAutoDisconnect = ()=>{
            this.unbindVisibilityListener();
            if (this.disconnectTimer) {
                clearTimeout(this.disconnectTimer);
                this.disconnectTimer = undefined;
            }
        };
        /**
     * Cleanup the visiblitychange listener upon Collab Provider destroy
     * Value set when the listener is binded in addVisiblityListener
     */ this.unbindVisibilityListener = ()=>{};
        this.autoDisconnect = (disconnectTimer, disconnectDelay)=>{
            if (document.hidden) {
                $f1b270f0f3c4c8c1$var$logger('visibilitychange: hidden');
                return setTimeout(()=>{
                    $f1b270f0f3c4c8c1$var$logger('visibilitychange: closing connection');
                    this.socket?.close();
                }, disconnectDelay || disconnectDelay === 0 ? disconnectDelay * 1000 : 60000);
            } else {
                $f1b270f0f3c4c8c1$var$logger('visibilitychange: visible');
                if (disconnectTimer) clearTimeout(disconnectTimer);
                $f1b270f0f3c4c8c1$var$logger('visibilitychange: re-connecting');
                this.socket?.connect();
                return;
            }
        };
        this.config = config;
        this.analyticsHelper = analyticsHelper;
        this.initExperience = (0, $8ciNw.createDocInitExp)(this.analyticsHelper);
    }
}
module.exports["Channel"] = $f1b270f0f3c4c8c1$export$cfdacaa37f9b4dd7;

});

parcelRegister("g4l86", function(module, exports) {

var $5t3vq = parcelRequire("5t3vq");


var $7TcbF = parcelRequire("7TcbF");


var $6VDNG = parcelRequire("6VDNG");


var $e9nC3 = parcelRequire("e9nC3");

var $6fd880663a42771d$require$Buffer = $e9nC3.Buffer;
// eslint-disable-next-line require-unicode-regexp
const $6fd880663a42771d$var$GCP_TENANT_PATTERN = /^.*-cdp-\w+\.jira-dev\.com$/;
const $6fd880663a42771d$export$fe2e61603b61130d = (prefix, color = 'blue')=>// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (msg, data = null)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (window.COLLAB_PROVIDER_LOGGER) // eslint-disable-next-line no-console
        console.log(`%cCollab-${prefix}: ${msg}`, `color: ${color}; font-weight: bold`, data);
    };
function $6fd880663a42771d$export$e772c8ff12451969(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
const $6fd880663a42771d$export$5cf1c5fc6dfa8400 = (id)=>typeof id === 'string' && id.startsWith('agent:');
const $6fd880663a42771d$export$e2005c9600188ac7 = (productInfo)=>productInfo?.product ?? 'unknown';
const $6fd880663a42771d$export$1cc4a77342446611 = (productInfo)=>productInfo?.subProduct ?? (!!productInfo?.product ? 'none' : 'unknown');
const $6fd880663a42771d$export$cbe99aded6131d03 = (step)=>{
    let stepJson;
    try {
        stepJson = step.toJSON();
    } catch (e) {
        return {
            type: 'unknown',
            contentTypes: '',
            stepSizeInBytes: $6fd880663a42771d$require$Buffer.byteLength(JSON.stringify(step))
        };
    }
    let contentTypes = '';
    if (stepJson.slice?.content && Array.isArray(stepJson.slice?.content)) contentTypes = stepJson.slice.content// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((c)=>{
        return c?.type || 'unknown';
    }).join(', ');
    return {
        type: stepJson.stepType || 'unknown',
        contentTypes: contentTypes,
        stepSizeInBytes: $6fd880663a42771d$require$Buffer.byteLength(JSON.stringify(step))
    };
};
const $6fd880663a42771d$var$stepWithNextDocument = (stepJson)=>{
    return stepJson.stepType === 'override-document' && 'nextDocument' in stepJson;
};
const $6fd880663a42771d$var$stepWithMark = (stepJson)=>{
    return stepJson.stepType === 'addMark' || stepJson.stepType === 'addNodeMark';
};
const $6fd880663a42771d$var$stepWithAttrs = (stepJson)=>{
    return stepJson.stepType === 'setAttrs' && 'attrs' in stepJson;
};
const $6fd880663a42771d$var$stepWithBatchAttrs = (stepJson)=>{
    return stepJson.stepType === 'batchAttrs' && 'data' in stepJson;
};
const $6fd880663a42771d$var$stepWithFromTo = (stepJson)=>{
    return 'from' in stepJson && typeof stepJson.from === 'number' && 'to' in stepJson && typeof stepJson.to === 'number';
};
const $6fd880663a42771d$var$stepWithGapFromTo = (stepJson)=>{
    return 'gapFrom' in stepJson && typeof stepJson.gapFrom === 'number' && 'gapTo' in stepJson && typeof stepJson.gapTo === 'number';
};
const $6fd880663a42771d$var$stepWithInsert = (stepJson)=>{
    return 'insert' in stepJson && typeof stepJson.insert === 'number';
};
const $6fd880663a42771d$var$stepWithPos = (stepJson)=>{
    return 'pos' in stepJson && typeof stepJson.pos === 'number';
};
const $6fd880663a42771d$var$stepWithSlice = (stepJson)=>{
    return 'slice' in stepJson && Array.isArray(stepJson.slice?.content);
};
const $6fd880663a42771d$export$c3999f755e5119b6 = (stepJson)=>{
    let contentTypes = null;
    if ($6fd880663a42771d$var$stepWithSlice(stepJson)) contentTypes = stepJson.slice.content.map((c)=>{
        return c?.type || 'unknown';
    }).join(', ');
    return {
        type: stepJson.stepType || 'unknown',
        contentTypes: contentTypes
    };
};
const $6fd880663a42771d$export$5a4db1b11509b097 = (stepJson)=>{
    const stepContentAsAdf = $6fd880663a42771d$var$stepToAdf(stepJson);
    if (!stepContentAsAdf) return null;
    const scrubbedSteps = stepContentAsAdf.map((adf)=>(0, $5t3vq.default)(adf)).filter((adf)=>!!adf);
    return scrubbedSteps;
};
const $6fd880663a42771d$export$c34327e5d6b409e1 = (doc)=>{
    const docJson = doc.toJSON();
    const scrubbedDoc = (0, $5t3vq.default)(docJson);
    if (!scrubbedDoc) return null;
    return scrubbedDoc;
};
const $6fd880663a42771d$export$2afb2cb2393bffc = (docJson)=>{
    const scrubbedDoc = (0, $5t3vq.default)(docJson);
    if (!scrubbedDoc) return null;
    return scrubbedDoc;
};
const $6fd880663a42771d$export$5332347b0103ece3 = (stepJson)=>{
    return {
        ...$6fd880663a42771d$var$stepWithFromTo(stepJson) && {
            from: stepJson.from,
            to: stepJson.to
        },
        ...$6fd880663a42771d$var$stepWithGapFromTo(stepJson) && {
            gapFrom: stepJson.gapFrom,
            gapTo: stepJson.gapTo
        },
        ...$6fd880663a42771d$var$stepWithInsert(stepJson) && {
            insert: stepJson.insert
        },
        ...$6fd880663a42771d$var$stepWithPos(stepJson) && {
            pos: stepJson.pos
        }
    };
};
/**
 * Returns the metadata for Step
 * @description metadata is applied by transform overrides [here](https://bitbucket.org/atlassian/adf-schema/src/e13bbece84ede8f245067dc53dd7ce694f427eda/packages/editor-prosemirror/src/transform-override.ts#lines-12)
 */ const $6fd880663a42771d$var$getStepMetadata = (stepJson)=>{
    return stepJson.metadata;
};
const $6fd880663a42771d$export$4b189f5a6c196cb1 = (steps, endIndex)=>{
    return steps.slice(0, endIndex).map((step)=>{
        return {
            stepType: $6fd880663a42771d$export$c3999f755e5119b6(step),
            stepContent: $6fd880663a42771d$export$5a4db1b11509b097(step),
            stepPositions: $6fd880663a42771d$export$5332347b0103ece3(step),
            stepMetadata: $6fd880663a42771d$var$getStepMetadata(step)
        };
    });
};
const $6fd880663a42771d$var$stepToAdf = (step)=>{
    if ($6fd880663a42771d$var$stepWithSlice(step)) return [
        {
            type: 'doc',
            content: step.slice.content.filter((el)=>el !== null)
        }
    ];
    else if ($6fd880663a42771d$var$stepWithNextDocument(step)) return [
        {
            type: 'doc',
            content: step.nextDocument.content
        }
    ];
    else if ($6fd880663a42771d$var$stepWithMark(step) && step.mark) return [
        {
            type: 'doc',
            marks: [
                {
                    type: step.mark.type || 'unknown',
                    attrs: step.mark.attrs
                }
            ]
        }
    ];
    else if ($6fd880663a42771d$var$stepWithAttrs(step)) return [
        {
            type: 'doc',
            attrs: step.attrs
        }
    ];
    else if ($6fd880663a42771d$var$stepWithBatchAttrs(step)) return step.data.map((stepData)=>{
        return {
            type: 'doc',
            attrs: stepData.attrs
        };
    });
    return [];
};
async function $6fd880663a42771d$export$66e82726d1c3b152(oldState, newState) {
    try {
        let stepsFromOldState = '', stepsFromNewState = '';
        const states = {
            old: oldState ? (0, $7TcbF.sendableSteps)(oldState) : null,
            new: (0, $7TcbF.sendableSteps)(newState)
        };
        if (states.new?.steps) stepsFromNewState = await $6fd880663a42771d$export$86b85b7b97208cd9(states.new.steps);
        if (states.old?.steps) stepsFromOldState = await $6fd880663a42771d$export$86b85b7b97208cd9(states.old.steps);
        return {
            stepsFromOldState: stepsFromOldState,
            stepsFromNewState: stepsFromNewState
        };
    } catch (err) {
        return new (0, $6VDNG.CustomError)('Failed to obfuscate steps', err);
    }
}
async function $6fd880663a42771d$export$86b85b7b97208cd9(steps) {
    const _steps = await Promise.resolve(steps.slice().map((s)=>s.toJSON()));
    return JSON.stringify($6fd880663a42771d$export$4b189f5a6c196cb1(_steps));
}
function $6fd880663a42771d$export$1e98abd71682b665(hostname) {
    if (!hostname) return false;
    return $6fd880663a42771d$var$GCP_TENANT_PATTERN.test(hostname);
}
module.exports["createLogger"] = $6fd880663a42771d$export$fe2e61603b61130d;
module.exports["sleep"] = $6fd880663a42771d$export$e772c8ff12451969;
module.exports["isAIProviderID"] = $6fd880663a42771d$export$5cf1c5fc6dfa8400;
module.exports["getProduct"] = $6fd880663a42771d$export$e2005c9600188ac7;
module.exports["getSubProduct"] = $6fd880663a42771d$export$1cc4a77342446611;
module.exports["getStepUGCFreeDetails"] = $6fd880663a42771d$export$cbe99aded6131d03;
module.exports["getDocAdfWithObfuscation"] = $6fd880663a42771d$export$c34327e5d6b409e1;
module.exports["getDocAdfWithObfuscationFromJSON"] = $6fd880663a42771d$export$2afb2cb2393bffc;
module.exports["getObfuscatedSteps"] = $6fd880663a42771d$export$4b189f5a6c196cb1;
module.exports["logObfuscatedSteps"] = $6fd880663a42771d$export$66e82726d1c3b152;
module.exports["isGCPtenant"] = $6fd880663a42771d$export$1e98abd71682b665;

});

parcelRegister("5t3vq", function(module, exports) {
$parcel$export(module.exports, "default", () => $16b7047da811fae2$export$2e2bcd8739ae039);

var $jTt8P = parcelRequire("jTt8P");


var $dvybL = parcelRequire("dvybL");


var $bkqrA = parcelRequire("bkqrA");


var $iwwPm = parcelRequire("iwwPm");

var $16b7047da811fae2$export$2e2bcd8739ae039 = (adf, options = {})=>{
    const nodeReplacements = {
        ...(0, $bkqrA.defaultNodeReplacements),
        ...options.nodeReplacements
    };
    const valueReplacements = {
        ...(0, $iwwPm.defaultValueReplacements),
        ...options.valueReplacements
    };
    return (0, $jTt8P.traverse)(adf, {
        any: (node, parent)=>{
            const replacement = nodeReplacements[node.type];
            if (typeof replacement === 'function') {
                const result = replacement(node, {
                    parent: parent,
                    valueReplacements: valueReplacements
                });
                if (result !== false) return result;
            }
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const updatedNode = {};
            Object.entries(node).forEach(([key, value])=>{
                if ([
                    'version',
                    'type',
                    'content',
                    'marks'
                ].includes(key)) updatedNode[key] = value;
            });
            if (node.text && node.marks) updatedNode.marks = (0, $dvybL.scrubLink)(node.marks ?? [], {
                valueReplacements: valueReplacements
            });
            if (node.text) updatedNode.text = (0, $dvybL.scrubStr)(node.text);
            if (node.attrs) updatedNode.attrs = (0, $dvybL.scrubAttrs)(node.type, node.attrs);
            return updatedNode;
        }
    });
};

});

parcelRegister("dvybL", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");

const $c41cd4a02adf9be0$var$DUMMY_TEXT = `Lorem ipsum dolor sit amet consectetur adipiscing elit sed do eiusmod tempor incididunt ut labore et dolore magna aliqua Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur Excepteur sint occaecat cupidatat non proident sunt in culpa qui officia deserunt mollit anim id est laborum`;
// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
const $c41cd4a02adf9be0$var$DECIMAL_DIGIT_REGEX = RegExp("^\\p{Nd}$", "u");
// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
const $c41cd4a02adf9be0$var$OTHER_SYMBOL_REGEX = RegExp("^\\p{So}$", "u");
// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
const $c41cd4a02adf9be0$var$CURRENCY_SYMBOL_REGEX = RegExp("^\\p{Sc}$", "u");
// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
const $c41cd4a02adf9be0$var$PUNCT_SEP_CONTROL_REGEX = RegExp("^[\\p{P}\\p{Z}\\p{C}]$", "u");
const $c41cd4a02adf9be0$var$DUMMY_DIGITS = [
    '2',
    '7',
    '4',
    '3',
    '5',
    '9',
    '1',
    '8',
    '0',
    '5'
];
const $c41cd4a02adf9be0$var$BYPASS_ATTR_LIST = {
    bodiedExtension: [
        'extensionKey',
        'extensionType',
        'layout'
    ],
    codeBlock: [
        'language'
    ],
    decisionItem: [
        'state'
    ],
    embedCard: [
        'layout',
        'originalHeight',
        'originalWidth',
        'width'
    ],
    extension: [
        'extensionKey',
        'extensionType',
        'layout',
        'type'
    ],
    heading: [
        'level'
    ],
    inlineExtension: [
        'extensionKey',
        'extensionType',
        'layout'
    ],
    layoutColumn: [
        'width'
    ],
    media: [
        '__fileMimeType',
        '__fileSize',
        'height',
        'width',
        'type'
    ],
    mediaSingle: [
        'layout',
        'width',
        'widthType'
    ],
    orderedList: [
        'order'
    ],
    panel: [
        'panelType'
    ],
    status: [
        'color',
        'style'
    ],
    table: [
        'isNumberColumnEnabled',
        'layout',
        'width'
    ],
    tableCell: [
        'background',
        'colspan',
        'colwidth',
        'defaultMarks',
        'rowspan'
    ],
    tableHeader: [
        'background',
        'colspan',
        'colwidth',
        'defaultMarks',
        'rowspan'
    ],
    tableRow: [
        'defaultMarks'
    ],
    taskItem: [
        'state'
    ],
    blockTaskItem: [
        'state'
    ]
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c41cd4a02adf9be0$var$fromEntries = (iterable)=>{
    return [
        ...iterable
    ].reduce((obj, [key, val])=>{
        obj[key] = val;
        return obj;
    }, {});
};
const $c41cd4a02adf9be0$var$scrubNum = (val, start = 0)=>{
    return parseInt(val.toString().split('').map((_, index)=>{
        const base = start + index;
        const len = $c41cd4a02adf9be0$var$DUMMY_DIGITS.length - 1;
        return $c41cd4a02adf9be0$var$DUMMY_DIGITS[base % len];
    }).join(''), 10);
};
const $c41cd4a02adf9be0$export$f8a660e92bd813ff = (val, offset = 0)=>{
    const base = $c41cd4a02adf9be0$var$DUMMY_TEXT.repeat(Math.ceil((offset + val.length) / $c41cd4a02adf9be0$var$DUMMY_TEXT.length));
    // using [...val] splits emoji character pairs correctly, compared to
    // something like "".split('')
    return [
        ...val
    ].map((char, index, chars)=>{
        if ($c41cd4a02adf9be0$var$DECIMAL_DIGIT_REGEX.test(char)) // Decimal digits
        return $c41cd4a02adf9be0$var$scrubNum(parseInt(char, 10), index).toString();
        else if ($c41cd4a02adf9be0$var$OTHER_SYMBOL_REGEX.test(char)) // Emoji
        return chars[index - 1]?.codePointAt(0) === 8205 ? '' : "\u2B50\uFE0F";
        else if ($c41cd4a02adf9be0$var$CURRENCY_SYMBOL_REGEX.test(char)) // Currency
        return '$';
        else if ($c41cd4a02adf9be0$var$PUNCT_SEP_CONTROL_REGEX.test(char)) // Punctuation, Seperators, Control
        return char;
        else if (char.codePointAt(0) === 65039 && $c41cd4a02adf9be0$var$OTHER_SYMBOL_REGEX.test(chars[index - 1])) // Ingore compound emoji control char
        return '';
        else {
            // Everything else
            // modulo to ensure wrapping occurs around base string (no OOB access)
            const correction = base[offset % base.length] === ' ' ? 1 : 0;
            const raw = (0, $ixfCV.fg)('platform_adf-utils_fix-dummy-text-index-oob') ? base[(offset + correction) % base.length] : base[offset + correction];
            const isLower = char.toLowerCase() === char;
            const result = isLower ? raw.toLowerCase() : raw.toUpperCase();
            offset += 1 + correction;
            return result;
        }
    }).join('');
};
const $c41cd4a02adf9be0$export$efa6f3a45942fa49 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
marks, { valueReplacements: valueReplacements })=>{
    return marks.map((mark)=>{
        if (mark.type === 'link' && mark.attrs.href) return {
            ...mark,
            attrs: {
                ...mark.attrs,
                href: valueReplacements.href(mark.attrs.href)
            }
        };
        return mark;
    });
};
const $c41cd4a02adf9be0$var$scrubObj = (nodeType, attrsObj)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const entries = Object.entries(attrsObj).map(([key, value])=>$c41cd4a02adf9be0$var$BYPASS_ATTR_LIST[nodeType]?.includes(key) ? [
            key,
            value
        ] : [
            key,
            $c41cd4a02adf9be0$export$e7384e231c3a8592(nodeType, value)
        ]);
    return $c41cd4a02adf9be0$var$fromEntries(entries);
};
const $c41cd4a02adf9be0$export$e7384e231c3a8592 = (nodeType, attrs, offset = 0)=>{
    if (typeof attrs === 'number') return $c41cd4a02adf9be0$var$scrubNum(attrs, offset);
    if (typeof attrs === 'string') return $c41cd4a02adf9be0$export$f8a660e92bd813ff(attrs, offset);
    if (typeof attrs === 'boolean') return attrs;
    if (!attrs) return attrs;
    const attrsObj = attrs;
    if (attrsObj && attrsObj.constructor === Object && Object.keys(attrsObj).length === 0) return {};
    if (typeof attrsObj === 'object' && !Array.isArray(attrsObj)) return $c41cd4a02adf9be0$var$scrubObj(nodeType, attrsObj);
    if (Array.isArray(attrsObj)) return attrsObj.map((el)=>{
        return typeof el === 'object' ? $c41cd4a02adf9be0$var$scrubObj(nodeType, el) : $c41cd4a02adf9be0$export$e7384e231c3a8592(nodeType, el);
    });
    throw new TypeError(`scrubAttrs: encountered unsupported attributes type "${typeof attrsObj}"
    of value ${JSON.stringify(attrsObj)}`);
};
module.exports["scrubStr"] = $c41cd4a02adf9be0$export$f8a660e92bd813ff;
module.exports["scrubLink"] = $c41cd4a02adf9be0$export$efa6f3a45942fa49;
module.exports["scrubAttrs"] = $c41cd4a02adf9be0$export$e7384e231c3a8592;

});

parcelRegister("bkqrA", function(module, exports) {

var $dvybL = parcelRequire("dvybL");

const $c57f46750a252cbb$var$card = (node, { valueReplacements: valueReplacements })=>({
        type: node.type,
        attrs: {
            ...node.attrs || {},
            url: valueReplacements.href(node.attrs?.url)
        }
    });
const $c57f46750a252cbb$var$mediaParent = (node)=>({
        type: node.type,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: node.attrs ? (0, $dvybL.scrubAttrs)(node.type, node.attrs) : undefined,
        content: node.content?.filter((c)=>c?.type === 'media')
    });
const $c57f46750a252cbb$export$9ead654a0051b376 = {
    emoji: ()=>({
            type: 'emoji',
            attrs: {
                shortName: ':blue_star:',
                id: 'atlassian-blue_star',
                text: ':blue_star:'
            }
        }),
    date: ()=>({
            type: 'date',
            attrs: {
                timestamp: new Date('2020-01-01').getTime()
            }
        }),
    mention: ()=>({
            type: 'mention',
            attrs: {
                id: 'error:NotFound',
                text: '@Nemo',
                accessLevel: 'CONTAINER'
            }
        }),
    inlineCard: $c57f46750a252cbb$var$card,
    blockCard: $c57f46750a252cbb$var$card,
    mediaSingle: $c57f46750a252cbb$var$mediaParent,
    mediaGroup: $c57f46750a252cbb$var$mediaParent,
    media: (node, { parent: parent })=>{
        const defaults = parent.node?.type === 'mediaSingle' ? {
            width: 600,
            height: 400
        } : {
            width: 150,
            height: 125
        };
        const width = node.attrs?.width ?? defaults.width;
        const height = node.attrs?.height ?? defaults.height;
        return {
            type: 'media',
            attrs: {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                ...(0, $dvybL.scrubAttrs)('media', node.attrs),
                type: 'external',
                url: `https://dummyimage.com/${width}x${height}/f4f5f7/a5adba`
            }
        };
    }
};
module.exports["defaultNodeReplacements"] = $c57f46750a252cbb$export$9ead654a0051b376;

});

parcelRegister("iwwPm", function(module, exports) {

var $cisoA = parcelRequire("cisoA");

const $cf7a25d2537e8090$export$be3aa623e32b055f = {
    href: (href)=>`https://hello.atlassian.net/wiki/spaces/ET/pages/968692273?${(0, $cisoA.hash)(href)}`
};
module.exports["defaultValueReplacements"] = $cf7a25d2537e8090$export$be3aa623e32b055f;

});

parcelRegister("cisoA", function(module, exports) {
// djb2 hashing algorithm www.cse.yorku.ca/~oz/hash.html
const $b336a124cd409be4$export$d6af199866bfb566 = (input)=>{
    let result = 5381;
    let index = input.length;
    while(index > 0)result = result * 33 ^ input.charCodeAt(--index);
    return (result >>> 0).toString();
};
module.exports["hash"] = $b336a124cd409be4$export$d6af199866bfb566;

});

parcelRegister("7TcbF", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $kHija = parcelRequire("kHija");


var $kCECX = parcelRequire("kCECX");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $932sd = parcelRequire("932sd");

class $0596fc14d46b40f6$export$c6d36d70c8e9d8cd {
    constructor(step, inverted, origin){
        this.step = step;
        this.inverted = inverted;
        this.origin = origin;
    }
}
function $0596fc14d46b40f6$export$bced9e015fcf3afa(steps, over, transform) {
    for(let i = steps.length - 1; i >= 0; i--)transform.step(steps[i].inverted);
    for(let i = 0; i < over.length; i++)transform.step(over[i]);
    const result = [];
    for(let i = 0, mapFrom = steps.length; i < steps.length; i++){
        const mapped = steps[i].step.map(transform.mapping.slice(mapFrom));
        const movedStep = (0, $fqVYq.editorExperiment)('platform_editor_offline_editing_web', true) ? (0, $932sd.mapStep)(steps, transform, i, mapped) : undefined;
        mapFrom--;
        if (mapped && !transform.maybeStep(mapped).failed) {
            // Open ticket for setMirror https://github.com/ProseMirror/prosemirror/issues/869
            // @ts-expect-error
            transform.mapping.setMirror(mapFrom, transform.steps.length - 1);
            result.push(new $0596fc14d46b40f6$export$c6d36d70c8e9d8cd(mapped, mapped.invert(transform.docs[transform.docs.length - 1]), steps[i].origin));
        }
        // If the step is a "move" step - apply the additional step
        if ((0, $fqVYq.editorExperiment)('platform_editor_offline_editing_web', true)) {
            if (movedStep && !transform.maybeStep(movedStep).failed) result.push(new $0596fc14d46b40f6$export$c6d36d70c8e9d8cd(movedStep, movedStep.invert(transform.docs[transform.docs.length - 1]), transform));
        }
    }
    return result;
}
// This state field accumulates changes that have to be sent to the
// central authority in the collaborating group and makes it possible
// to integrate changes made by peers into our local document. It is
// defined by the plugin, and will be available as the `collab` field
// in the resulting editor state.
class $0596fc14d46b40f6$var$CollabState {
    constructor(// The version number of the last update received from the central
    // authority. Starts at 0 or the value of the `version` property
    // in the option object, for the editor's value when the option
    // was enabled.
    version, // The local steps that havent been successfully sent to the
    // server yet.
    unconfirmed){
        this.version = version;
        this.unconfirmed = unconfirmed;
    }
}
function $0596fc14d46b40f6$var$unconfirmedFrom(transform) {
    const result = [];
    for(let i = 0; i < transform.steps.length; i++)result.push(new $0596fc14d46b40f6$export$c6d36d70c8e9d8cd(transform.steps[i], transform.steps[i].invert(transform.docs[i]), transform));
    return result;
}
const $0596fc14d46b40f6$var$collabKey = new (0, $kCECX.PluginKey)('collab');
function $0596fc14d46b40f6$export$995d9de96d1b2e26(config = {}) {
    const conf = {
        version: config.version || 0,
        clientID: // eslint-disable-next-line eqeqeq
        // generate a temporary id as clientId when it is null or undefined
        // prefix temp-pc- indicates prosemirror-collab
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        config.clientID == null || !config.clientID ? `temp-pc-${(0, $kHija.v4)()}` : config.clientID
    };
    const transformUnconfirmed = config.transformUnconfirmed ?? ((steps)=>steps);
    return new (0, $kCECX.Plugin)({
        key: $0596fc14d46b40f6$var$collabKey,
        state: {
            init: ()=>new $0596fc14d46b40f6$var$CollabState(conf.version, []),
            apply (tr, collab) {
                const newState = tr.getMeta($0596fc14d46b40f6$var$collabKey);
                if (newState) {
                    if ((0, $fqVYq.editorExperiment)('platform_editor_offline_editing_web', true) || (0, $ieeJu.expValEquals)('platform_editor_enable_single_player_step_merging', 'isEnabled', true)) return new $0596fc14d46b40f6$var$CollabState(newState.version, transformUnconfirmed(newState.unconfirmed));
                    else return newState;
                }
                if (tr.docChanged) return new $0596fc14d46b40f6$var$CollabState(collab.version, transformUnconfirmed(collab.unconfirmed.concat($0596fc14d46b40f6$var$unconfirmedFrom(tr))));
                return collab;
            }
        },
        config: conf,
        // This is used to notify the history plugin to not merge steps,
        // so that the history can be rebased.
        historyPreserveItems: true
    });
}
function $0596fc14d46b40f6$export$5af1c9a2797f6d8e(state) {
    const tr = state.tr;
    const { version: version, unconfirmed: unconfirmed } = $0596fc14d46b40f6$var$collabKey.getState(state) ?? {};
    if (version === undefined || !unconfirmed) return tr.doc;
    // undo unconfirmed steps
    for(let i = unconfirmed.length - 1; i >= 0; i--)tr.step(unconfirmed[i].inverted);
    return tr.doc;
}
function $0596fc14d46b40f6$export$852bd88de4de2d35(state, version, // eslint-disable-next-line @typescript-eslint/no-explicit-any
docJSON, unconfirmedSteps) {
    const tr = state.tr;
    const doc = state.schema.nodeFromJSON(docJSON);
    const { from: from, to: to } = tr.selection;
    tr.replaceWith(0, state.doc.content.size, doc);
    // apply new unconfirmed steps to doc
    for(let i = 0; i < unconfirmedSteps.length; i++)tr.step(unconfirmedSteps[i]);
    const offset = 1; // offset by 1 to account for the initial replace step
    const newUnconfirmed = tr.steps.slice(offset).map((step, i)=>{
        const index = i + offset;
        const doc = tr.docs[index];
        return new $0596fc14d46b40f6$export$c6d36d70c8e9d8cd(step, step.invert(doc), tr);
    });
    // Because we are replacing the entire document from 0 to end, the selection mapping is incorrect.
    // For now, the best we can do is set the selection to the original positions. Otherwise, it will move to the end of the doc on every change.
    tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, Math.min(from, tr.doc.content.size), Math.min(to, tr.doc.content.size)));
    return tr.setMeta('addToHistory', false).setMeta($0596fc14d46b40f6$var$collabKey, new $0596fc14d46b40f6$var$CollabState(version, newUnconfirmed));
}
function $0596fc14d46b40f6$export$7581d8ca0d559ec6(state, steps, clientIDs, options = {}) {
    // Pushes a set of steps (received from the central authority) into
    // the editor state (which should have the collab plugin enabled).
    // Will recognize its own changes, and confirm unconfirmed steps as
    // appropriate. Remaining unconfirmed steps will be rebased over
    // remote steps.
    const collabState = $0596fc14d46b40f6$var$collabKey.getState(state);
    const version = (collabState?.version || 0) + steps.length;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion,  @typescript-eslint/no-explicit-any
    const ourID = $0596fc14d46b40f6$var$collabKey.get(state).spec.config.clientID;
    // Find out which prefix of the steps originated with us
    let ours = 0;
    // eslint-disable-next-line eqeqeq
    while(ours < clientIDs.length && clientIDs[ours] == ourID)++ours;
    let unconfirmed = collabState?.unconfirmed.slice(ours) || [];
    steps = ours ? steps.slice(ours) : steps;
    // If all steps originated with us, we're done.
    if (!steps.length) return state.tr.setMeta($0596fc14d46b40f6$var$collabKey, new $0596fc14d46b40f6$var$CollabState(version, unconfirmed));
    const nUnconfirmed = unconfirmed.length;
    const tr = state.tr;
    if (nUnconfirmed) unconfirmed = $0596fc14d46b40f6$export$bced9e015fcf3afa(unconfirmed, steps, tr);
    else {
        for(let i = 0; i < steps.length; i++)tr.step(steps[i]);
        unconfirmed = [];
    }
    const newCollabState = new $0596fc14d46b40f6$var$CollabState(version, unconfirmed);
    if (options && options.mapSelectionBackward && state.selection instanceof (0, $kCECX.TextSelection)) {
        tr.setSelection(new (0, $kCECX.TextSelection)(tr.doc.resolve(tr.mapping.map(state.selection.anchor, -1)), tr.doc.resolve(tr.mapping.map(state.selection.head, -1))));
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        tr.updated &= -2;
    }
    return tr.setMeta('rebased', nUnconfirmed).setMeta('rebasedData', {
        unconfirmedSteps: collabState?.unconfirmed.slice(ours) || [],
        remoteSteps: steps,
        stepsAfterRebase: unconfirmed,
        versionBefore: version
    }).setMeta('addToHistory', false).setMeta($0596fc14d46b40f6$var$collabKey, newCollabState);
}
function $0596fc14d46b40f6$export$4da2109e7644e6c2(state) {
    const collabState = $0596fc14d46b40f6$var$collabKey.getState(state);
    if (!collabState) return null;
    // eslint-disable-next-line eqeqeq
    if (collabState.unconfirmed.length == 0) return null;
    return {
        version: collabState.version,
        steps: collabState.unconfirmed.map((s)=>s.step),
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-explicit-any
        clientID: $0596fc14d46b40f6$var$collabKey.get(state).spec.config.clientID,
        get origins () {
            return(// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._origins || (// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._origins = collabState?.unconfirmed.map((s)=>s.origin)));
        }
    };
}
function $0596fc14d46b40f6$export$971539697c176258(state) {
    return $0596fc14d46b40f6$var$collabKey.getState(state);
}
module.exports["Rebaseable"] = $0596fc14d46b40f6$export$c6d36d70c8e9d8cd;
module.exports["rebaseSteps"] = $0596fc14d46b40f6$export$bced9e015fcf3afa;
module.exports["collab"] = $0596fc14d46b40f6$export$995d9de96d1b2e26;
module.exports["getDocBeforeUnconfirmedSteps"] = $0596fc14d46b40f6$export$5af1c9a2797f6d8e;
module.exports["syncFromAnotherSource"] = $0596fc14d46b40f6$export$852bd88de4de2d35;
module.exports["receiveTransaction"] = $0596fc14d46b40f6$export$7581d8ca0d559ec6;
module.exports["sendableSteps"] = $0596fc14d46b40f6$export$4da2109e7644e6c2;
module.exports["getCollabState"] = $0596fc14d46b40f6$export$971539697c176258;

});

parcelRegister("932sd", function(module, exports) {

var $l5rX3 = parcelRequire("l5rX3");


var $aPdNQ = parcelRequire("aPdNQ");


var $eOaGc = parcelRequire("eOaGc");

// Iterate from the specified starting index down to 0
const $b353c4f64821ca1d$var$findPreviousStepInverseIndex = (steps, startIndex = steps.length - 1)=>{
    for(let i = startIndex; i >= 0; i--){
        if (!(steps[i] instanceof (0, $l5rX3.AnalyticsStep))) return i;
    }
};
const $b353c4f64821ca1d$export$798cdecdcbbf9755 = (steps, transform, index, mapped)=>{
    if (index < 1) return undefined;
    const previousRebaseableStepIndex = $b353c4f64821ca1d$var$findPreviousStepInverseIndex(steps.map((s)=>s.step), index - 1);
    // This checks the local steps are a "move" sequence
    if (previousRebaseableStepIndex !== undefined && $b353c4f64821ca1d$export$17bbdbb89ac2acbd(steps[previousRebaseableStepIndex], steps[index].step)) {
        const previousStepInverseIndex = $b353c4f64821ca1d$var$findPreviousStepInverseIndex(transform.steps);
        // Creates a new step based on the "current" steps (partially through the rebase)
        if (previousStepInverseIndex !== undefined) return $b353c4f64821ca1d$export$ad07b298545ed98d(mapped, transform.steps[previousStepInverseIndex], transform, previousStepInverseIndex);
    }
};
// Only consider ReplaceStep (ReplaceAroundStep do not occur for moves)
const $b353c4f64821ca1d$var$isReplaceTypeStep = (step)=>step instanceof (0, $eOaGc.ReplaceStep);
const $b353c4f64821ca1d$export$17bbdbb89ac2acbd = (previousRebaseableStep, currentStep)=>{
    if (// The both steps are replace
    $b353c4f64821ca1d$var$isReplaceTypeStep(previousRebaseableStep.step) && $b353c4f64821ca1d$var$isReplaceTypeStep(currentStep) && // The current step is a deletion
    previousRebaseableStep.step.slice.size === 0 && // The following step is an insertion with the same length that was deleted by the current step
    Math.abs(previousRebaseableStep.step.to - previousRebaseableStep.step.from) === currentStep.slice.size) {
        // Ensure we're getting the doc before our step changes so we can compare node contents
        const originStepIndex = previousRebaseableStep.origin.steps.findIndex((s)=>s === previousRebaseableStep.step);
        if (originStepIndex === -1) return false;
        const originalDoc = previousRebaseableStep.origin.docs[originStepIndex];
        if (!originalDoc) return false;
        const currentSlice = originalDoc.slice(previousRebaseableStep.step.from, previousRebaseableStep.step.to);
        // The content from the deleted + inserted slice is exactly the same (cut + paste or drag + drop)
        if (currentSlice.eq(currentStep.slice)) return true;
    }
    return false;
};
const $b353c4f64821ca1d$export$ad07b298545ed98d = (mapped, previousStep, transform, previousStepIndex)=>{
    if (!$b353c4f64821ca1d$var$isReplaceTypeStep(previousStep) || mapped && !$b353c4f64821ca1d$var$isReplaceTypeStep(mapped) || !mapped || // Ensure previous step index is valid
    !(previousStepIndex >= 0 && previousStepIndex < transform.docs.length && typeof previousStep?.from === 'number')) return undefined;
    const newSlice = transform.docs[previousStepIndex].slice(previousStep?.from, previousStep?.to);
    const diff = $b353c4f64821ca1d$var$getDiffRange(mapped.slice.content, newSlice.content);
    if (diff === undefined) return undefined;
    const start = mapped.from + diff.start;
    const offset = newSlice.content.size - mapped.slice.content.size === 0 ? diff.end - diff.start : 0;
    // If the new slice is smaller then we're doing a deletion of content - this needs
    // to be a replace step with empty content to delete content
    if (newSlice.content.size - mapped.slice.content.size < 0) return new (0, $eOaGc.ReplaceStep)(start, start + mapped.slice.content.size - newSlice.content.size, (0, $aPdNQ.Slice).empty);
    // Replace the diff range with the latest content in the document (at the old position)
    return new (0, $eOaGc.ReplaceStep)(start, start + offset, transform.docs[previousStepIndex].slice(previousStep?.from + diff.start, previousStep?.from + diff.end));
};
/**
 * Get start and end diff position values for two fragments (old, new).
 * @param {Fragment} before - content that is planned to move
 * @param {Fragment} after - content that was in paragraph being deleted (updated content)
 * @returns {object} - { start, end }
 */ function $b353c4f64821ca1d$var$getDiffRange(before, after) {
    // https://prosemirror.net/docs/ref/#model.Fragment.findDiffStart
    const start = before.findDiffStart(after);
    // Important: diffEnd value is {a,b} object since end pos will differ.
    // https://prosemirror.net/docs/ref/#model.Fragment.findDiffEnd
    const diffEnd = before.findDiffEnd(after);
    if (start === null || diffEnd === null) return undefined;
    // WARNING: diffEnd may be lower than diffStart.
    // If so, add overlap to get correct range.
    // https://discuss.prosemirror.net/t/overlap-handling-of-finddiffstart-and-finddiffend/2856
    const overlap = start - Math.min(diffEnd.a, diffEnd.b);
    let end = diffEnd.b;
    if (overlap > 0) end += overlap;
    return {
        start: start,
        end: end
    };
}
module.exports["mapStep"] = $b353c4f64821ca1d$export$798cdecdcbbf9755;

});

parcelRegister("6VDNG", function(module, exports) {
class $c86a7288127bd6c5$export$f7a70f5f17339408 extends Error {
    toJSON() {
        return {
            name: this.name,
            message: this.message
        };
    }
    constructor(message, error, extraEventAttributes){
        super(message);
        this.extraEventAttributes = void 0;
        this.getExtraErrorEventAttributes = ()=>this.extraEventAttributes;
        if (typeof error?.message === 'string') this.message = error.message;
        if (extraEventAttributes) this.extraEventAttributes = extraEventAttributes;
    }
}
class $c86a7288127bd6c5$export$ee94a7f51f58b1f0 extends $c86a7288127bd6c5$export$f7a70f5f17339408 {
    constructor(...args){
        super(...args);
        this.name = 'NotConnectedError';
    }
}
class $c86a7288127bd6c5$export$92624542437ba748 extends $c86a7288127bd6c5$export$f7a70f5f17339408 {
    constructor(...args){
        super(...args);
        this.name = 'NotInitializedError';
    }
}
class $c86a7288127bd6c5$export$f96efbf9586f7f39 extends $c86a7288127bd6c5$export$f7a70f5f17339408 {
    constructor(...args){
        super(...args);
        this.name = 'ProviderInitialisationError';
    }
}
class $c86a7288127bd6c5$export$121e803f723b3045 extends $c86a7288127bd6c5$export$f7a70f5f17339408 {
    constructor(...args){
        super(...args);
        this.name = 'SendTransactionError';
    }
}
class $c86a7288127bd6c5$export$be0713d3b74f5c22 extends $c86a7288127bd6c5$export$f7a70f5f17339408 {
    constructor(...args){
        super(...args);
        this.name = 'DestroyError';
    }
}
class $c86a7288127bd6c5$export$a444b7fe9d0904eb extends $c86a7288127bd6c5$export$f7a70f5f17339408 {
    constructor(...args){
        super(...args);
        this.name = 'SetTitleError';
    }
}
class $c86a7288127bd6c5$export$70274e29104db434 extends $c86a7288127bd6c5$export$f7a70f5f17339408 {
    constructor(...args){
        super(...args);
        this.name = 'SetEditorWidthError';
    }
}
class $c86a7288127bd6c5$export$c72e7ac58ad6e295 extends $c86a7288127bd6c5$export$f7a70f5f17339408 {
    constructor(...args){
        super(...args);
        this.name = 'SetMetadataError';
    }
}
class $c86a7288127bd6c5$export$29880dc4d51a91ac extends $c86a7288127bd6c5$export$f7a70f5f17339408 {
    constructor(...args){
        super(...args);
        this.name = 'GetCurrentStateError';
    }
}
class $c86a7288127bd6c5$export$5d0dd2f3f3417c74 extends $c86a7288127bd6c5$export$f7a70f5f17339408 {
    constructor(...args){
        super(...args);
        this.name = 'GetFinalAcknowledgedStateError';
    }
}
class $c86a7288127bd6c5$export$b8b1b847e9447ca7 extends $c86a7288127bd6c5$export$f7a70f5f17339408 {
    constructor(message, extraAttributes){
        super(message, undefined, extraAttributes);
        this.name = 'UpdateDocumentError';
    }
}
class $c86a7288127bd6c5$export$a2465e73e4ff8efe extends $c86a7288127bd6c5$export$f7a70f5f17339408 {
    constructor(message, extraAttributes){
        super(message, undefined, extraAttributes);
        this.name = 'CantSyncUpError';
    }
}
module.exports["CustomError"] = $c86a7288127bd6c5$export$f7a70f5f17339408;
module.exports["NotConnectedError"] = $c86a7288127bd6c5$export$ee94a7f51f58b1f0;
module.exports["NotInitializedError"] = $c86a7288127bd6c5$export$92624542437ba748;
module.exports["ProviderInitialisationError"] = $c86a7288127bd6c5$export$f96efbf9586f7f39;
module.exports["SendTransactionError"] = $c86a7288127bd6c5$export$121e803f723b3045;
module.exports["DestroyError"] = $c86a7288127bd6c5$export$be0713d3b74f5c22;
module.exports["SetTitleError"] = $c86a7288127bd6c5$export$a444b7fe9d0904eb;
module.exports["SetEditorWidthError"] = $c86a7288127bd6c5$export$70274e29104db434;
module.exports["SetMetadataError"] = $c86a7288127bd6c5$export$c72e7ac58ad6e295;
module.exports["GetCurrentStateError"] = $c86a7288127bd6c5$export$29880dc4d51a91ac;
module.exports["GetFinalAcknowledgedStateError"] = $c86a7288127bd6c5$export$5d0dd2f3f3417c74;
module.exports["UpdateDocumentError"] = $c86a7288127bd6c5$export$b8b1b847e9447ca7;
module.exports["CantSyncUpError"] = $c86a7288127bd6c5$export$a2465e73e4ff8efe;

});

parcelRegister("6f2MR", function(module, exports) {
// Initialize the random sampling rate
const $383e8ec4fa29202d$var$TELEPOINTER_SAMPLE_RATE = 0.0001;
var $383e8ec4fa29202d$export$5cb1f459478c70e = /*#__PURE__*/ function(MEASURE_NAME) {
    MEASURE_NAME["SOCKET_CONNECT"] = "socketConnect";
    MEASURE_NAME["DOCUMENT_INIT"] = "documentInit";
    MEASURE_NAME["COMMIT_UNCONFIRMED_STEPS"] = "commitUnconfirmedSteps";
    MEASURE_NAME["PUBLISH_PAGE"] = "publishPage";
    MEASURE_NAME["GET_CURRENT_STATE"] = "getCurrentState";
    return MEASURE_NAME;
}({});
const $383e8ec4fa29202d$export$b5717a625dd4a3eb = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (api)=>!!performance[api]);
};
const $383e8ec4fa29202d$export$3ebda12358c8b9c = new Map();
function $383e8ec4fa29202d$export$b62aa2130c86b59b(measureName, analyticsHelper) {
    try {
        if (!$383e8ec4fa29202d$export$b5717a625dd4a3eb()) return;
        performance.mark(`${measureName}::start`);
        $383e8ec4fa29202d$export$3ebda12358c8b9c.set(measureName, performance.now());
    } catch (error) {
        analyticsHelper?.sendErrorEvent(error, 'Error while measuring performance when marking the start');
    }
}
function $383e8ec4fa29202d$export$37c25be427bec097(measureName, analyticsHelper, onMeasureComplete) {
    let start;
    try {
        if (!$383e8ec4fa29202d$export$b5717a625dd4a3eb()) return;
        // `startMeasure` is not called with `measureName` before.
        if (!$383e8ec4fa29202d$export$3ebda12358c8b9c.get(measureName)) return;
        performance.mark(`${measureName}::end`);
        start = onMeasureComplete ? $383e8ec4fa29202d$export$3ebda12358c8b9c.get(measureName) : undefined;
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {
        analyticsHelper?.sendErrorEvent(error, 'Error while measuring performance when marking the end');
    }
    try {
        const entry = performance.getEntriesByName(measureName).pop();
        $383e8ec4fa29202d$var$clearMeasure(measureName);
        let measure;
        if (entry) measure = {
            duration: entry.duration,
            startTime: entry.startTime
        };
        else if (start) measure = {
            duration: performance.now() - start,
            startTime: start
        };
        if (measure && onMeasureComplete) onMeasureComplete(measure.duration, measure.startTime);
        return measure;
    } catch (error) {
        analyticsHelper?.sendErrorEvent(error, 'Error while measuring performance when completing the measurement');
    }
}
function $383e8ec4fa29202d$var$clearMeasure(measureName) {
    if (!$383e8ec4fa29202d$export$b5717a625dd4a3eb()) return;
    $383e8ec4fa29202d$export$3ebda12358c8b9c.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}
const $383e8ec4fa29202d$export$2afa64d53a381f1a = ()=>// At peak usage, telepointer we had 200M events per day. The goal is to sample 1:10000 of the events. (20k per day)
    // Math.random() generates a random floating-point number between 0 (inclusive) and 1 (exclusive).
    // The condition Math.random() < TELEPOINTER_SAMPLE_RATE (0.0001) will be true approximately 0.01% of the time.
    // This means that approximately 1 in 10,000 events will be sampled.
    Math.random() < $383e8ec4fa29202d$var$TELEPOINTER_SAMPLE_RATE;
module.exports["MEASURE_NAME"] = $383e8ec4fa29202d$export$5cb1f459478c70e;
module.exports["startMeasure"] = $383e8ec4fa29202d$export$b62aa2130c86b59b;
module.exports["stopMeasure"] = $383e8ec4fa29202d$export$37c25be427bec097;
module.exports["shouldTelepointerBeSampled"] = $383e8ec4fa29202d$export$2afa64d53a381f1a;

});

parcelRegister("J4uEo", function(module, exports) {
var $b310e4459e8b1895$export$9282cde89f62615f = /*#__PURE__*/ function(EVENT_ACTION) {
    EVENT_ACTION["CONNECTION"] = "connection";
    EVENT_ACTION["CATCHUP"] = "catchup";
    EVENT_ACTION["DOCUMENT_INIT"] = "documentInit";
    EVENT_ACTION["ADD_STEPS"] = "addSteps";
    EVENT_ACTION["UPDATE_PARTICIPANTS"] = "updateParticipants";
    EVENT_ACTION["UPDATE_DOCUMENT"] = "updateDocument";
    EVENT_ACTION["COMMIT_UNCONFIRMED_STEPS"] = "commitUnconfirmedSteps";
    EVENT_ACTION["REINITIALISE_DOCUMENT"] = "reinitialiseDocument";
    EVENT_ACTION["ERROR"] = "error";
    EVENT_ACTION["PUBLISH_PAGE"] = "publishPage";
    EVENT_ACTION["GET_CURRENT_STATE"] = "getCurrentState";
    EVENT_ACTION["INVALIDATE_TOKEN"] = "invalidateToken";
    EVENT_ACTION["SEND_STEPS_RETRY"] = "sendStepsRetry";
    EVENT_ACTION["CATCHUP_AFTER_MAX_SEND_STEPS_RETRY"] = "catchupAfterMaxSendStepsRetry";
    EVENT_ACTION["DROPPED_STEPS"] = "droppedStepInCatchup";
    EVENT_ACTION["WEBSOCKET_MESSAGE_VOLUME_METRIC"] = "websocketMessageVolumeMetric";
    EVENT_ACTION["PROVIDER_INITIALIZED"] = "providerInitialized";
    EVENT_ACTION["RECONNECTION"] = "providerReconnection";
    EVENT_ACTION["PROVIDER_SETUP"] = "providerSetup";
    EVENT_ACTION["HAS_UNCONFIRMED_STEPS"] = "hasUnconfirmedSteps";
    EVENT_ACTION["OUT_OF_SYNC"] = "outOfSync";
    EVENT_ACTION["STEPS_REBASED"] = "stepsRebased";
    EVENT_ACTION["POLLING_FALLBACK"] = "pollingFallback";
    EVENT_ACTION["PROCESS_STEPS"] = "processSteps";
    return EVENT_ACTION;
}({});
var $b310e4459e8b1895$export$5ab9b99d22ba6de0 = /*#__PURE__*/ function(EVENT_STATUS) {
    EVENT_STATUS["SUCCESS"] = "SUCCESS";
    EVENT_STATUS["FAILURE"] = "FAILURE";
    EVENT_STATUS["INFO"] = "INFO";
    EVENT_STATUS["SUCCESS_10x_SAMPLED"] = "SUCCESS_10x_SAMPLED";
    return EVENT_STATUS;
}({});
var $b310e4459e8b1895$export$4026f1a4d5b398bb = /*#__PURE__*/ function(ADD_STEPS_TYPE) {
    ADD_STEPS_TYPE["ACCEPTED"] = "ACCEPTED";
    ADD_STEPS_TYPE["REJECTED"] = "REJECTED";
    ADD_STEPS_TYPE["ERROR"] = "ERROR";
    return ADD_STEPS_TYPE;
}({});
const $b310e4459e8b1895$export$20f6a175f3aa35a2 = 60;
const $b310e4459e8b1895$export$c811f21c9ad05dc2 = 'confluence';
var $b310e4459e8b1895$export$2df0974445100a00 = /*#__PURE__*/ function(CatchupEventReason) {
    CatchupEventReason["STEPS_ADDED"] = "onStepsAdded";
    CatchupEventReason["STEPS_REJECTED"] = "onStepsRejected";
    CatchupEventReason["PROCESS_STEPS"] = "processSteps";
    CatchupEventReason["RECONNECTED"] = "reconnected";
    return CatchupEventReason;
}({});
module.exports["EVENT_ACTION"] = $b310e4459e8b1895$export$9282cde89f62615f;
module.exports["EVENT_STATUS"] = $b310e4459e8b1895$export$5ab9b99d22ba6de0;
module.exports["ADD_STEPS_TYPE"] = $b310e4459e8b1895$export$4026f1a4d5b398bb;
module.exports["ACK_MAX_TRY"] = $b310e4459e8b1895$export$20f6a175f3aa35a2;
module.exports["CatchupEventReason"] = $b310e4459e8b1895$export$2df0974445100a00;

});

parcelRegister("hCWnd", function(module, exports) {

var $4pCX8 = parcelRequire("4pCX8");


var $3nxtu = parcelRequire("3nxtu");

// Calculation for max 8 offline reconnect attempts, with reconnection delay 200ms, randomization factor 0.5, reconnection delay max 128s
// Min: 800ms, Avg: 51s, Max: 6m
const $b579e8d660099ec7$var$FAILED_RECONNECTS_WHILE_OFFLINE_THRESHOLD = 8;
class $b579e8d660099ec7$export$2e2bcd8739ae039 {
    countReconnectError() {
        // Only count the reconnection attempts when offline
        if ((0, $3nxtu.network).getStatus() === (0, $4pCX8.NetworkStatus).OFFLINE) this.failedReconnectCount++;
    }
    isLikelyNetworkIssue() {
        const isLikelyNetworkIssue = this.failedReconnectCount >= $b579e8d660099ec7$var$FAILED_RECONNECTS_WHILE_OFFLINE_THRESHOLD;
        return isLikelyNetworkIssue;
    }
    destroy() {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('online', this.onlineHandler);
    }
    constructor(){
        this.failedReconnectCount = 0;
        this.onlineHandler = ()=>{
            this.failedReconnectCount = 0;
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('online', this.onlineHandler);
    }
}
module.exports["default"] = $b579e8d660099ec7$export$2e2bcd8739ae039;

});

parcelRegister("4pCX8", function(module, exports) {
var $8b3d6aac41360c15$export$bd096ddbd246c79c = /*#__PURE__*/ function(NetworkStatus) {
    NetworkStatus["ONLINE"] = "ONLINE";
    NetworkStatus["OFFLINE"] = "OFFLINE";
    return NetworkStatus;
}({});
class $8b3d6aac41360c15$export$2e2bcd8739ae039 {
    getStatus() {
        return this.status || null;
    }
    destroy() {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('offline', this.offlineHandler);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('online', this.onlineHandler);
    }
    constructor(props){
        this.status = void 0;
        this.onlineCallback = void 0;
        this.offlineHandler = ()=>{
            this.status = "OFFLINE";
        };
        this.onlineHandler = ()=>{
            this.status = "ONLINE";
            if (this.onlineCallback) this.onlineCallback();
        };
        if (props?.initialStatus) this.status = props.initialStatus;
        if (props?.onlineCallback) this.onlineCallback = props.onlineCallback;
        if (typeof window !== 'undefined') {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.addEventListener('offline', this.offlineHandler);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.addEventListener('online', this.onlineHandler);
        }
    }
}
module.exports["NetworkStatus"] = $8b3d6aac41360c15$export$bd096ddbd246c79c;
module.exports["default"] = $8b3d6aac41360c15$export$2e2bcd8739ae039;

});

parcelRegister("3nxtu", function(module, exports) {

var $4pCX8 = parcelRequire("4pCX8");

// Assume the connection is established at first
const $21fa80ccaa855a23$export$21fcfd9d5c6ebbd4 = new (0, $4pCX8.default)({
    initialStatus: (0, $4pCX8.NetworkStatus).ONLINE
});
module.exports["network"] = $21fa80ccaa855a23$export$21fcfd9d5c6ebbd4;

});

parcelRegister("8ciNw", function(module, exports) {

var $4MiWC = parcelRequire("4MiWC");

var $cNAch = parcelRequire("cNAch");

const $fff44da8978cc55c$var$createDocumentInitExperience = ()=>new (0, $cNAch.UFOExperience)('collab-provider.document-init', {
        type: (0, $4MiWC.ExperienceTypes).Load,
        performanceType: (0, $4MiWC.ExperiencePerformanceTypes).Custom,
        performanceConfig: {
            histogram: {
                [(0, $4MiWC.ExperiencePerformanceTypes).Custom]: {
                    duration: '250_500_1000_1500_2000_3000_4000'
                }
            }
        }
    });
const $fff44da8978cc55c$var$withErrorHandling = (createExperience, analyticsHelper)=>{
    let initExperience;
    try {
        initExperience = createExperience();
    } catch (error) {
        analyticsHelper?.sendErrorEvent(error, 'Error while initialising a UFO experience');
    }
    return initExperience;
};
const $fff44da8978cc55c$export$41daeddae2dd4619 = (analyticsHelper)=>$fff44da8978cc55c$var$withErrorHandling($fff44da8978cc55c$var$createDocumentInitExperience, analyticsHelper);
module.exports["createDocInitExp"] = $fff44da8978cc55c$export$41daeddae2dd4619;

});

parcelRegister("1Gjof", function(module, exports) {

var $jbOus = parcelRequire("jbOus");

const $39b225ec5681a9cf$export$f9a0e0c2c8938695 = {
    IO_CLIENT_DISCONNECT: 'io client disconnect',
    IO_SERVER_DISCONNECT: 'io server disconnect',
    TRANSPORT_CLOSED: 'transport close',
    TRANSPORT_ERROR: 'transport error',
    PING_TIMEOUT: 'ping timeout'
};
const $39b225ec5681a9cf$export$5a38c81d972d63e3 = (reason)=>{
    switch(reason){
        case $39b225ec5681a9cf$export$f9a0e0c2c8938695.IO_CLIENT_DISCONNECT:
            return (0, $jbOus.DisconnectReason).CLIENT_DISCONNECT;
        case $39b225ec5681a9cf$export$f9a0e0c2c8938695.IO_SERVER_DISCONNECT:
            return (0, $jbOus.DisconnectReason).SERVER_DISCONNECT;
        case $39b225ec5681a9cf$export$f9a0e0c2c8938695.TRANSPORT_CLOSED:
            return (0, $jbOus.DisconnectReason).SOCKET_CLOSED;
        case $39b225ec5681a9cf$export$f9a0e0c2c8938695.TRANSPORT_ERROR:
            return (0, $jbOus.DisconnectReason).SOCKET_ERROR;
        case $39b225ec5681a9cf$export$f9a0e0c2c8938695.PING_TIMEOUT:
            return (0, $jbOus.DisconnectReason).SOCKET_TIMEOUT;
        default:
            return (0, $jbOus.DisconnectReason).UNKNOWN_DISCONNECT;
    }
};
module.exports["socketIOReasons"] = $39b225ec5681a9cf$export$f9a0e0c2c8938695;
module.exports["disconnectedReasonMapper"] = $39b225ec5681a9cf$export$5a38c81d972d63e3;

});

parcelRegister("kunUR", function(module, exports) {
var $dc9b73a247b41223$export$c14aa697065dcc24 = /*#__PURE__*/ function(INTERNAL_ERROR_CODE) {
    INTERNAL_ERROR_CODE["TOKEN_PERMISSION_ERROR"] = "TOKEN_PERMISSION_ERROR";
    INTERNAL_ERROR_CODE["RECONNECTION_NETWORK_ISSUE"] = "RECONNECTION_NETWORK_ISSUE";
    INTERNAL_ERROR_CODE["CONNECTION_ERROR"] = "CONNECTION_ERROR";
    INTERNAL_ERROR_CODE["RECONNECTION_ERROR"] = "RECONNECTION_ERROR";
    INTERNAL_ERROR_CODE["DOCUMENT_NOT_FOUND"] = "DOCUMENT_NOT_FOUND";
    INTERNAL_ERROR_CODE["CATCHUP_FAILED"] = "CATCHUP_FAILED";
    INTERNAL_ERROR_CODE["DOCUMENT_RESTORE_ERROR"] = "DOCUMENT_RESTORE_ERROR";
    INTERNAL_ERROR_CODE["ADD_STEPS_ERROR"] = "ADD_STEPS_ERROR";
    INTERNAL_ERROR_CODE["DOCUMENT_UPDATE_ERROR"] = "DOCUMENT_UPDATE_ERROR";
    INTERNAL_ERROR_CODE["VIEW_ONLY_STEPS_ERROR"] = "VIEW_ONLY_STEPS_ERROR";
    INTERNAL_ERROR_CODE["OUT_OF_SYNC_CLIENT_DATA_LOSS_EVENT"] = "OUT_OF_SYNC_CLIENT_DATA_LOSS_EVENT";
    return INTERNAL_ERROR_CODE;
}({});
 /*
 * This is what a generic ProviderError type would look like:
 * type ProviderError = {
 *   // Unique code, identifies the specific emitted error
 *   // Also exposed as a PROVIDER_ERROR_CODE enum to allow subscribers to use them
 *   code: PROVIDER_ERROR_CODE;
 *   // Informative message describing what went wrong
 *   message: string;
 *   // Flag indicating whether an error is recoverable or not
 *   // used by consumers to disable the provider and show an error message
 *   recoverable: boolean;
 *   // A reason code used to give more detail about why a certain error was thrown
 *   reason?: string;
 * }
 */ module.exports["INTERNAL_ERROR_CODE"] = $dc9b73a247b41223$export$c14aa697065dcc24;

});

parcelRegister("dLe3j", function(module, exports) {
// NCS error coded (generated by NCS)
var $d670f8fb0b65893e$export$168e5dfca773ce7a = /*#__PURE__*/ function(NCS_ERROR_CODE) {
    NCS_ERROR_CODE["HEAD_VERSION_UPDATE_FAILED"] = "HEAD_VERSION_UPDATE_FAILED";
    NCS_ERROR_CODE["VERSION_NUMBER_ALREADY_EXISTS"] = "VERSION_NUMBER_ALREADY_EXISTS";
    NCS_ERROR_CODE["INSUFFICIENT_EDITING_PERMISSION"] = "INSUFFICIENT_EDITING_PERMISSION";
    NCS_ERROR_CODE["FORBIDDEN_USER_TOKEN"] = "FORBIDDEN_USER_TOKEN";
    NCS_ERROR_CODE["DOCUMENT_NOT_FOUND"] = "DOCUMENT_NOT_FOUND";
    NCS_ERROR_CODE["INIT_DATA_LOAD_FAILED"] = "INIT_DATA_LOAD_FAILED";
    NCS_ERROR_CODE["ERROR_MAPPING_ERROR"] = "ERROR_MAPPING_ERROR";
    NCS_ERROR_CODE["NAMESPACE_INVALID"] = "NAMESPACE_INVALID";
    NCS_ERROR_CODE["NAMESPACE_NOT_FOUND"] = "NAMESPACE_NOT_FOUND";
    NCS_ERROR_CODE["TENANT_INSTANCE_MAINTENANCE"] = "TENANT_INSTANCE_MAINTENANCE";
    NCS_ERROR_CODE["LOCKED_DOCUMENT"] = "LOCKED_DOCUMENT";
    NCS_ERROR_CODE["EMPTY_BROADCAST"] = "EMPTY_BROADCAST";
    NCS_ERROR_CODE["DYNAMO_ERROR"] = "DYNAMO_ERROR";
    NCS_ERROR_CODE["INVALID_ACTIVATION_ID"] = "INVALID_ACTIVATION_ID";
    NCS_ERROR_CODE["INVALID_DOCUMENT_ARI"] = "INVALID_DOCUMENT_ARI";
    NCS_ERROR_CODE["INVALID_CLOUD_ID"] = "INVALID_CLOUD_ID";
    NCS_ERROR_CODE["RATE_LIMIT_ERROR"] = "RATE_LIMIT_ERROR";
    NCS_ERROR_CODE["PROSEMIRROR_SCHEMA_VALIDATION_ERROR"] = "PROSEMIRROR_SCHEMA_VALIDATION_ERROR";
    return NCS_ERROR_CODE;
}({});
module.exports["NCS_ERROR_CODE"] = $d670f8fb0b65893e$export$168e5dfca773ce7a;

});

parcelRegister("6GwjM", function(module, exports) {

var $J4uEo = parcelRequire("J4uEo");


var $02H7x = parcelRequire("02H7x");


var $3nxtu = parcelRequire("3nxtu");


var $6VDNG = parcelRequire("6VDNG");

const $68ea9437d28f84af$var$EVENT_SUBJECT = 'collab';
const $68ea9437d28f84af$var$loggableErrorName = [
    'RangeError',
    'TypeError',
    'TransformError',
    'NodeNestingTransformError'
];
var $68ea9437d28f84af$var$COLLAB_SERVICE = /*#__PURE__*/ function(COLLAB_SERVICE) {
    COLLAB_SERVICE["NCS"] = "ncs";
    COLLAB_SERVICE["SYNCHRONY"] = "synchrony";
    return COLLAB_SERVICE;
}($68ea9437d28f84af$var$COLLAB_SERVICE || {});
const $68ea9437d28f84af$var$triggerAnalyticsEvent = (analyticsEvent, analyticsClient)=>{
    if (!analyticsClient) return;
    const payload = {
        actionSubject: $68ea9437d28f84af$var$EVENT_SUBJECT,
        attributes: {
            packageName: $02H7x.name,
            packageVersion: $02H7x.version,
            collabService: "ncs",
            network: {
                status: (0, $3nxtu.network).getStatus()
            },
            ...analyticsEvent.attributes
        },
        tags: [
            'editor'
        ],
        action: analyticsEvent.eventAction,
        source: 'unknown' // Adds zero analytics value, but event validation throws an error if you don't add it :-(
    };
    if (analyticsEvent.eventAction === (0, $J4uEo.EVENT_ACTION).ERROR) {
        payload.nonPrivacySafeAttributes = analyticsEvent.nonPrivacySafeAttributes;
        try {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const requestIdleCallbackFunction = window.requestIdleCallback;
            const runItLater = typeof requestIdleCallbackFunction === 'function' ? requestIdleCallbackFunction : window.requestAnimationFrame;
            runItLater(()=>{
                analyticsClient.sendTrackEvent(payload);
            });
        } catch (error) {
        // silently fail for now https://product-fabric.atlassian.net/browse/ESS-3112
        }
    } else // Let the browser figure out
    // when it should send those events
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const requestIdleCallbackFunction = window.requestIdleCallback;
        const runItLater = typeof requestIdleCallbackFunction === 'function' ? requestIdleCallbackFunction : window.requestAnimationFrame;
        runItLater(()=>{
            analyticsClient.sendOperationalEvent(payload);
        });
    } catch (error) {
    // silently fail for now https://product-fabric.atlassian.net/browse/ESS-3112
    }
};
class $68ea9437d28f84af$export$2e2bcd8739ae039 {
    sendErrorEvent(error, errorMessage) {
        let errorExtraAttributes = {};
        if (error instanceof (0, $6VDNG.CustomError)) errorExtraAttributes = error.getExtraErrorEventAttributes() || {};
        const errorAnalyticsEvent = {
            eventAction: (0, $J4uEo.EVENT_ACTION).ERROR,
            attributes: {
                documentAri: this.documentAri,
                subProduct: this.subProduct,
                errorMessage: errorMessage,
                errorName: error instanceof Error ? error.name : undefined,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                errorCode: error.data?.code ?? undefined,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                errorStatus: error.data?.status ?? undefined,
                errorStack: error instanceof Error && $68ea9437d28f84af$var$loggableErrorName.includes(error.name) ? error.stack : undefined,
                originalErrorMessage: this.getUGCFreeErrorMessage(error),
                ...errorExtraAttributes
            },
            nonPrivacySafeAttributes: {
                error: error
            }
        };
        this.sendEvent(errorAnalyticsEvent);
    }
    sendProviderErrorEvent(error) {
        const errorAnalyticsEvent = {
            eventAction: (0, $J4uEo.EVENT_ACTION).ERROR,
            attributes: {
                documentAri: this.documentAri,
                subProduct: this.subProduct,
                errorMessage: 'Error emitted',
                originalErrorMessage: error.message,
                errorCode: error.code,
                mappedError: error
            }
        };
        this.sendEvent(errorAnalyticsEvent);
    }
    sendActionEvent(action, status, attributes // This breaks discriminated unions, because there is no obvious field to discriminate against any more
    ) {
        const analyticsEvent = {
            eventAction: action,
            attributes: {
                documentAri: this.documentAri,
                subProduct: this.subProduct,
                eventStatus: status,
                ...attributes
            }
        };
        this.sendEvent(analyticsEvent);
    }
    async sendEvent(event) {
        if (this.getAnalyticsClient && !this.analyticsClient) try {
            this.analyticsClient = await this.getAnalyticsClient;
        } catch (error) {
        // fail silently
        }
        $68ea9437d28f84af$var$triggerAnalyticsEvent(event, this.analyticsClient);
    }
    getUGCFreeErrorMessage(error) {
        if (error instanceof Error && $68ea9437d28f84af$var$loggableErrorName.includes(error.name)) return error.message;
        else return undefined;
    }
    constructor(documentAri, subProduct, analyticsClient, getAnalyticsClient){
        this.analyticsClient = void 0;
        this.getAnalyticsClient = void 0;
        this.documentAri = void 0;
        this.subProduct = void 0;
        this.documentAri = documentAri;
        this.subProduct = subProduct;
        this.analyticsClient = analyticsClient;
        this.getAnalyticsClient = getAnalyticsClient;
    }
}
module.exports["default"] = $68ea9437d28f84af$export$2e2bcd8739ae039;

});

parcelRegister("02H7x", function(module, exports) {
const $0a369ab479bb3bef$export$a8ff84c12d48cfa6 = "platform-pkg";
const $0a369ab479bb3bef$export$83d89fbfd8236492 = "0.0.0-use.local";
const $0a369ab479bb3bef$export$49a9c95426e73961 = ()=>{
    return [
        Number($0a369ab479bb3bef$export$83d89fbfd8236492.split('.')[0]) + 1,
        0,
        0
    ].join('.');
};
module.exports["name"] = $0a369ab479bb3bef$export$a8ff84c12d48cfa6;
module.exports["version"] = $0a369ab479bb3bef$export$83d89fbfd8236492;

});

parcelRegister("lncF6", function(module, exports) {

var $g4l86 = parcelRequire("g4l86");


var $4MiWC = parcelRequire("4MiWC");

var $cNAch = parcelRequire("cNAch");


var $eFNck = parcelRequire("eFNck");

const $fc3c772f32a965d7$var$logger = (0, $g4l86.createLogger)('Telepointer', 'green');
const $fc3c772f32a965d7$export$eaaa064fda0476c4 = (participants, step)=>{
    const [participant] = participants.filter((p)=>p.clientId === step.clientId);
    if (participant) {
        const { stepType: stepType, to: to, from: from, slice: slice = {
            content: []
        } } = step;
        const [node] = slice.content;
        if (to && from && stepType === 'replace' && to === from && slice.content.length === 1 && node?.type === 'text' && node?.text?.length === 1) return {
            sessionId: participant.sessionId,
            selection: {
                type: 'textSelection',
                anchor: from + 1,
                head: to + 1
            },
            type: 'telepointer'
        };
    }
};
const $fc3c772f32a965d7$export$8aee63d4597b3f93 = (documentAri)=>{
    const telepointerExperience = new (0, $cNAch.UFOExperience)('collab-provider.telepointer', {
        type: (0, $4MiWC.ExperienceTypes).Operation,
        performanceType: (0, $4MiWC.ExperiencePerformanceTypes).Custom,
        performanceConfig: {
            histogram: {
                [(0, $4MiWC.ExperiencePerformanceTypes).Custom]: {
                    duration: '250_500_1000_1500_2000_3000_4000'
                }
            }
        }
    });
    telepointerExperience.addMetadata({
        documentAri: documentAri
    });
    telepointerExperience.start();
    return (response)=>{
        if (response.type === (0, $eFNck.AcknowledgementResponseTypes).SUCCESS) telepointerExperience.success();
        else if (response.type === (0, $eFNck.AcknowledgementResponseTypes).ERROR) {
            const errorMessage = response.error;
            telepointerExperience.addMetadata({
                error: errorMessage
            });
            $fc3c772f32a965d7$var$logger('Error from collab service with telepointer broadcast', errorMessage);
            telepointerExperience.failure();
        } else {
            $fc3c772f32a965d7$var$logger('Invalid ACK from collab service with telepointer broadcast');
            telepointerExperience.addMetadata({
                error: 'Invalid ACK from collab service with telepointer broadcast'
            });
            telepointerExperience.failure();
        }
    };
};
module.exports["telepointerFromStep"] = $fc3c772f32a965d7$export$eaaa064fda0476c4;
module.exports["telepointerCallback"] = $fc3c772f32a965d7$export$8aee63d4597b3f93;

});

parcelRegister("eFNck", function(module, exports) {
var $1cb7ee24f09d438f$export$49ed9ecf1b22773d = /*#__PURE__*/ function(AcknowledgementResponseTypes) {
    AcknowledgementResponseTypes["SUCCESS"] = "SUCCESS";
    AcknowledgementResponseTypes["ERROR"] = "ERROR";
    return AcknowledgementResponseTypes;
}({});
module.exports["AcknowledgementResponseTypes"] = $1cb7ee24f09d438f$export$49ed9ecf1b22773d;

});

parcelRegister("2okgV", function(module, exports) {

var $3u5lg = parcelRequire("3u5lg");

class $90b6ceff44c1485d$export$b732ab16be80c4ec {
    setTitle(title, broadcast) {
        if (broadcast) this.broadcastMetadata({
            title: title
        });
        this.metadata.title = title;
    }
    setEditorWidth(editorWidth, broadcast) {
        if (broadcast) this.broadcastMetadata({
            editorWidth: editorWidth
        });
        this.metadata.editorWidth = editorWidth;
    }
    constructor(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    providerEmitCallback, broadcastMetadata){
        this.providerEmitCallback = providerEmitCallback;
        this.broadcastMetadata = broadcastMetadata;
        this.metadata = {};
        this.getMetaData = ()=>this.metadata;
        this.getTitle = ()=>{
            return this.metadata.title?.toString();
        };
        /**
     * Called when a metadata is changed externally from other clients/backend.
     */ this.onMetadataChanged = (metadata)=>{
            if (metadata !== undefined && !(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(this.metadata, metadata) && Object.keys(metadata).length > 0) {
                this.metadata = metadata;
                this.providerEmitCallback('metadata:changed', metadata);
            }
        };
        /**
     * Updates the local metadata and broadcasts the metadata to other clients/backend.
     * @param metadata
     */ this.setMetadata = (metadata)=>{
            this.broadcastMetadata(metadata);
            this.metadata = metadata;
        };
        /**
     * Emits a change in document's metadata
     * @param metadata
     */ this.updateMetadata = (metadata)=>{
            if (metadata && Object.keys(metadata).length > 0) {
                this.metadata = metadata;
                this.providerEmitCallback('metadata:changed', metadata);
            }
        };
    }
}
module.exports["MetadataService"] = $90b6ceff44c1485d$export$b732ab16be80c4ec;

});

parcelRegister("gJ15u", function(module, exports) {

var $kmQhR = parcelRequire("kmQhR");


var $5aU9U = parcelRequire("5aU9U");


var $7TcbF = parcelRequire("7TcbF");


var $kCECX = parcelRequire("kCECX");


var $3xuv0 = parcelRequire("3xuv0");


var $fqVYq = parcelRequire("fqVYq");


var $ieeJu = parcelRequire("ieeJu");


var $J4uEo = parcelRequire("J4uEo");


var $6f2MR = parcelRequire("6f2MR");


var $kunUR = parcelRequire("kunUR");


var $g4l86 = parcelRequire("g4l86");


var $7Hrb0 = parcelRequire("7Hrb0");


var $i68DM = parcelRequire("i68DM");


var $6VDNG = parcelRequire("6VDNG");


var $kL1DJ = parcelRequire("kL1DJ");


var $kB8eL = parcelRequire("kB8eL");


var $jQP9V = parcelRequire("jQP9V");

const $56e8761e06a95e15$var$CATCHUP_THROTTLE = 1000; // 1 second
const $56e8761e06a95e15$var$noop = ()=>{};
const $56e8761e06a95e15$var$logger = (0, $g4l86.createLogger)('documentService', 'red');
class $56e8761e06a95e15$export$136703b96b9b8f33 {
    getVersionFromCollabState(state, resource) {
        const collabState = (0, $7TcbF.getCollabState)(state);
        if (!collabState) {
            this.analyticsHelper?.sendErrorEvent(new Error('No collab state when calling ProseMirror function'), `${resource} called without collab state`);
            return 0;
        }
        // This should not happen in usual, just add error event in case it happens
        if (collabState.version === undefined) {
            this.analyticsHelper?.sendErrorEvent(new Error('Collab state missing version info when calling ProseMirror function'), `${resource} called with collab state missing version info`);
            return 0;
        }
        return collabState.version;
    }
    /**
   * In the event we reconnect check if we have existing unconfirmed steps and if so
   * notify the editor that we have a potential conflict to resolve on the frontend.
   *
   * @param data remote steps payload
   * @param steps
   * @example
   */ notifyReconnectionConflict(steps) {
        if ((0, $fqVYq.editorExperiment)('platform_editor_offline_editing_web', false)) return;
        const state = this.getState?.();
        const unconfirmedSteps = state ? (0, $7TcbF.getCollabState)(state)?.unconfirmed : undefined;
        if (steps.length > 0 && state && unconfirmedSteps && unconfirmedSteps.length > 0) {
            const { schema: schema, tr: tr } = state;
            const remoteSteps = steps.map((s)=>(0, $5aU9U.Step).fromJSON(schema, s));
            const conflicts = (0, $jQP9V.getConflictChanges)({
                localSteps: unconfirmedSteps,
                remoteSteps: remoteSteps,
                tr: tr
            });
            if (conflicts.deleted.length > 0 || conflicts.inserted.length > 0) this.providerEmitCallback('data:conflict', {
                offlineDoc: state.doc,
                ...conflicts
            });
        }
    }
    processQueue() {
        if (this.stepQueue.isPaused()) {
            $56e8761e06a95e15$var$logger(`Queue is paused. Aborting.`);
            return;
        }
        $56e8761e06a95e15$var$logger(`Looking for processable data.`);
        if (this.stepQueue.getQueue().length > 0) {
            const firstItem = this.stepQueue.shift();
            const currentVersion = this.getCurrentPmVersion();
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const expectedVersion = currentVersion + firstItem.steps.length;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            if (firstItem.version === expectedVersion) {
                $56e8761e06a95e15$var$logger(`Applying data from queue!`);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.processSteps(firstItem);
                // recur
                this.processQueue();
            }
        }
    }
    processSteps(data) {
        const { version: version, steps: steps } = data;
        $56e8761e06a95e15$var$logger(`Processing data. Version "${version}".`);
        if (steps?.length) try {
            const clientIds = steps.map(({ clientId: clientId })=>clientId);
            this.providerEmitCallback('data', {
                json: steps,
                version: version,
                userIds: clientIds
            });
            // If steps can apply to local editor successfully, no need to accumulate the error counter.
            this.stepRejectCounter = 0;
            this.participantsService.emitTelepointersFromSteps(steps);
            // Resend local steps if none of the received steps originated with us!
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            if (clientIds.indexOf(this.clientId) === -1) setTimeout(()=>this.sendStepsFromCurrentState(), 100);
            this.analyticsHelper?.sendActionEvent((0, $J4uEo.EVENT_ACTION).PROCESS_STEPS, (0, $J4uEo.EVENT_STATUS).SUCCESS);
        } catch (error) {
            // ESS-6421: log if error processing steps when there are steps from the same userId but not the same clientId
            const userIdMatch = this.isStepsFromNewClientIdForSameUserId(steps);
            $56e8761e06a95e15$var$logger(`Processing steps failed with error: ${error}. Triggering catch up call.`);
            this.analyticsHelper?.sendErrorEvent(error, userIdMatch ? `Error while processing steps with new clientId` : `Error while processing steps`);
            this.throttledCatchupv2((0, $J4uEo.CatchupEventReason).PROCESS_STEPS);
        }
    }
    /**
   *
   * @example
   */ getIsNamespaceLocked() {
        return this.isNameSpaceLocked();
    }
    /**
   *
   * @param root0
   * @param root0.getState
   * @param root0.onSyncUpError
   * @param root0.clientId
   * @example
   */ setup({ getState: getState, onSyncUpError: onSyncUpError, clientId: clientId }) {
        this.getState = getState;
        this.onSyncUpError = onSyncUpError || $56e8761e06a95e15$var$noop;
        this.clientId = clientId;
        return this;
    }
    /**
   * We can use this function to throttle/delay
   * Any send steps operation
   *
   * The getState function will return the current EditorState
   * from the EditorView.
   * @param sendAnalyticsEvent
   * @param reason
   * @example
   */ sendStepsFromCurrentState(sendAnalyticsEvent, reason) {
        const state = this.getState?.();
        if (!state) {
            this.analyticsHelper?.sendErrorEvent(new Error('Editor state is undefined'), 'sendStepsFromCurrentState called without state');
            return;
        }
        this.send(null, null, state, sendAnalyticsEvent, reason);
    }
    /**
   * Send steps from transaction to other participants
   * It needs the superfluous arguments because we keep the interface of the send API the same as the Synchrony plugin
   * @param tr
   * @param _oldState
   * @param newState
   * @param sendAnalyticsEvent
   * @param reason
   * @example
   */ send(tr, _oldState, _newState, sendAnalyticsEvent, reason // only used for publish and draft-sync events - when called through getFinalAcknowledgedState
    ) {
        const offlineEditingEnabled = (0, $fqVYq.editorExperiment)('platform_editor_offline_editing_web', true);
        const onlineStepMergingEnabled = (0, $ieeJu.expValEquals)('platform_editor_enable_single_player_step_merging', 'isEnabled', true);
        // We don't trust `_newState` not to be stale
        // ED-29051 - the `onEditorViewStateUpdated` can have a stale state in edge cases. We need
        // to always ensure we're sending the latest state and unconfirmed steps so we use the state
        // from editorView directly (via getState).
        const newState = onlineStepMergingEnabled ? this.getState?.() ?? _newState : _newState;
        // Don't send any steps before we're ready.
        if (offlineEditingEnabled || onlineStepMergingEnabled) {
            const enableOnlineStepMerging = onlineStepMergingEnabled && !this.commitStepService.getReadyToCommitStatus();
            if (!this.getConnected() || enableOnlineStepMerging) return;
        }
        const unconfirmedStepsData = (0, $7TcbF.sendableSteps)(newState);
        const version = this.getVersionFromCollabState(newState, 'collab-provider: send');
        if (!unconfirmedStepsData) return;
        if (offlineEditingEnabled || onlineStepMergingEnabled) this.lockStepOrigins(unconfirmedStepsData.origins);
        const unconfirmedSteps = unconfirmedStepsData.steps;
        // sendAnalyticsEvent is only true when buffering is enabled,
        // to ensure that analytics events with the number of unconfirmed steps is only
        // sent once on connection (as opposed to on every step)
        if (sendAnalyticsEvent) this.analyticsHelper?.sendActionEvent((0, $J4uEo.EVENT_ACTION).HAS_UNCONFIRMED_STEPS, (0, $J4uEo.EVENT_STATUS).INFO, {
            numUnconfirmedSteps: unconfirmedSteps?.length || 0
        });
        if (!unconfirmedSteps?.length) return;
        const rebased = tr?.getMeta('rebasedData');
        if (rebased) {
            const obfuscatedUnconfirmedSteps = this.obfuscateStepsAndState(rebased.unconfirmedSteps).obfuscatedSteps;
            const obfuscatedRemoteSteps = this.obfuscateStepsAndState(rebased.remoteSteps);
            const obfuscatedRebasedSteps = this.obfuscateStepsAndState(unconfirmedSteps).obfuscatedSteps;
            // send analtyics on unconfirmed steps
            this.analyticsHelper?.sendActionEvent((0, $J4uEo.EVENT_ACTION).STEPS_REBASED, (0, $J4uEo.EVENT_STATUS).INFO, {
                obfuscatedUnconfirmedSteps: obfuscatedUnconfirmedSteps,
                obfuscatedRemoteSteps: obfuscatedRemoteSteps,
                obfuscatedRebasedSteps: obfuscatedRebasedSteps,
                clientID: this.clientId,
                userId: this.getUserId(),
                versionBefore: rebased.versionBefore,
                versionAfter: version
            });
        }
        if ((0, $fqVYq.editorExperiment)('platform_editor_offline_editing_web', true)) {
            const containsOfflineSteps = unconfirmedStepsData?.origins.some((tr)=>{
                return tr instanceof (0, $kCECX.Transaction) ? tr.getMeta('isOffline') ?? false : false;
            });
            if (containsOfflineSteps && !this.timeoutExceeded) {
                // Only start timer if we're online and don't already have one running
                if (this.getConnected() && !this.timeout) this.timeout = setTimeout(()=>{
                    // If the timer expires and we're still online, handle the offline steps.
                    // Otherwise, clear the timer so it can restart when we're online again.
                    if (this.getConnected()) {
                        this.timeoutExceeded = true;
                        const updatedUnconfirmedStepsData = (0, $7TcbF.sendableSteps)(newState);
                        updatedUnconfirmedStepsData?.origins.forEach((origin)=>{
                            if (origin instanceof (0, $kCECX.Transaction) && origin.getMeta('isOffline')) origin.setMeta('isOffline', false);
                        });
                    } else this.timeout = undefined;
                }, 6000);
                return;
            } else if (this.timeoutExceeded) {
                this.timeoutExceeded = false;
                if (this.timeout) {
                    clearTimeout(this.timeout);
                    this.timeout = undefined;
                }
            }
        }
        // Avoid reference issues using a
        // method outside of the provider
        // scope
        this.commitStepService.commitStepQueue({
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            userId: this.getUserId(),
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            clientId: this.clientId,
            steps: unconfirmedSteps,
            version: version,
            onStepsAdded: this.onStepsAdded,
            __livePage: this.options.__livePage,
            hasRecovered: this.hasRecovered,
            collabMode: this.participantsService.getCollabMode(),
            reason: reason,
            lockSteps: this.lockSteps,
            stepOrigins: unconfirmedStepsData.origins
        });
    }
    /**
   *
   * @param participantsService - The participants service, used when users are detected active when making changes to the document
   * and to emit their telepointers from steps they add
   * @param analyticsHelper - Helper for analytics events
   * @param fetchCatchupv2 - Step based - Function to fetch "catchupv2" data, data required to rebase current steps to the latest version.
   * @param fetchReconcile - Function to call "reconcile" from NCS backend
   * @param fetchGeneratedDiffSteps - Function to call "generateDiffSteps" from NCS backend
   * @param providerEmitCallback - Callback for emitting events to listeners on the provider
   * @param broadcast - Callback for broadcasting events to other clients
   * @param getUserId - Callback to fetch the current user's ID
   * @param onErrorHandled - Callback to handle
   * @param metadataService
   * @param isNameSpaceLocked
   * @param enableErrorOnFailedDocumentApply - Enable failed document update exceptions.
   * @param options.__livePage
   * @param options
   * @param getConnected - if the channel is currently connected
   * @example
   */ constructor(participantsService, analyticsHelper, fetchCatchupv2, fetchReconcile, fetchGeneratedDiffSteps, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    providerEmitCallback, broadcast, getUserId, onErrorHandled, metadataService, isNameSpaceLocked, enableErrorOnFailedDocumentApply = false, options = {
        __livePage: false
    }, getConnected){
        this.participantsService = participantsService;
        this.analyticsHelper = analyticsHelper;
        this.fetchCatchupv2 = fetchCatchupv2;
        this.fetchReconcile = fetchReconcile;
        this.fetchGeneratedDiffSteps = fetchGeneratedDiffSteps;
        this.providerEmitCallback = providerEmitCallback;
        this.broadcast = broadcast;
        this.getUserId = getUserId;
        this.metadataService = metadataService;
        this.isNameSpaceLocked = isNameSpaceLocked;
        this.enableErrorOnFailedDocumentApply = enableErrorOnFailedDocumentApply;
        this.options = options;
        this.getConnected = getConnected;
        this.getState = void 0;
        // Fires analytics to editor when collab editor cannot sync up
        this.onSyncUpError = void 0;
        this.stepQueue = void 0;
        this.stepRejectCounter = 0;
        this.aggressiveCatchup = false;
        this.catchUpOutofSync = false;
        this.hasRecovered = false;
        this.commitStepService = void 0;
        this.timeout = void 0;
        this.timeoutExceeded = false;
        // ClientID is the unique ID for a prosemirror client. Used for step-rebasing.
        this.clientId = void 0;
        this.onErrorHandled = void 0;
        /**
     * To prevent calling catchup to often, use lodash throttle to reduce the frequency
     * @param reason - optional reason to attach.
     */ this.throttledCatchupv2 = (0, (/*@__PURE__*/$parcel$interopDefault($kmQhR)))((reason, reconnectionMetadata, sessionId)=>this.catchupv2(reason, reconnectionMetadata, sessionId), $56e8761e06a95e15$var$CATCHUP_THROTTLE, {
            leading: false,
            // TODO: ED-26957 - why shouldn't this be leading?
            trailing: true
        });
        /**
     * Called when:
     *   * session established(offline -> online)
     *   * try to accept steps but version is behind.
     * @param reason - optional reason to attach.
     * @param reconnectionMetadata
     * @example
     */ this.catchupv2 = async (reason, reconnectionMetadata, sessionId)=>{
            const start = new Date().getTime();
            // if the queue is already paused, we are busy with something else, so don't proceed.
            if (this.stepQueue.isPaused()) {
                $56e8761e06a95e15$var$logger(`Queue is paused. Aborting.`);
                return;
            }
            /**
       * If the database is in a transitionary state (i.e locked),
       * it likely that another user may already be in the process of catching up.
       *
       * If multiple users are trying to catch up at the same time, it can lead to
       * the database being stuck in a transitionary state due to duplicated page recovery requests.
       * We don't wanna be stuck in a transitionary state as that will cause issues with
       * content reconciliation and other operations.
       */ // check if the document is locked -> noop
            if (this.isNameSpaceLocked()) {
                $56e8761e06a95e15$var$logger(`catchupv2: Document is locked. Aborting.`);
                return;
            }
            this.stepQueue.pauseQueue();
            try {
                /**
         * We have two options when out of sync:
         * - Check a boolean that ensures we reset the document next time we catchup
         * - Immediately catchup
         *
         * Immediately catching up has some complexity invovled with it - do we call catchupv2 again, fetchCatchupv2 again, or documentService.catchupV2 again?
         * If we call either catchupv2 or documentService.catchupv2, we run the risk of creating an infinite loop of reset catchup requests.
         * We can slow down the loop by calling throttledCatchupv2, and can add booleans that check if we're already doing a reset catchup request.
         *
         * But this all adds complexity that can be avoided by choosing the first option.
         * Collab provider will already call catchup again, so this time we can ensure we call it with reset.
         */ this.catchUpOutofSync = await (0, $kL1DJ.catchupv2)({
                    getCurrentPmVersion: this.getCurrentPmVersion,
                    fetchCatchupv2: this.fetchCatchupv2,
                    updateMetadata: this.metadataService.updateMetadata,
                    analyticsHelper: this.analyticsHelper,
                    clientId: this.clientId,
                    onStepsAdded: this.onStepsAdded,
                    catchUpOutofSync: this.catchUpOutofSync,
                    reason: reason,
                    sessionId: sessionId,
                    onCatchupComplete: (steps)=>{
                        // We want to capture the number of steps made while offline vs. online
                        if (reason === (0, $J4uEo.CatchupEventReason).RECONNECTED) {
                            this.analyticsHelper?.sendActionEvent((0, $J4uEo.EVENT_ACTION).RECONNECTION, (0, $J4uEo.EVENT_STATUS).INFO, {
                                ...reconnectionMetadata,
                                remoteStepsLength: steps?.length ?? 0
                            });
                            this.notifyReconnectionConflict(steps);
                        }
                    },
                    getState: this.getState
                });
                const latency = new Date().getTime() - start;
                this.analyticsHelper?.sendActionEvent((0, $J4uEo.EVENT_ACTION).CATCHUP, (0, $J4uEo.EVENT_STATUS).SUCCESS, {
                    latency: latency,
                    version: this.getCurrentPmVersion()
                });
            } catch (error) {
                const latency = new Date().getTime() - start;
                // Skip client side errors; TypeErrors are client side errors https://developer.mozilla.org/en-US/docs/Web/API/Window/fetch
                const errorMessage = error instanceof Error ? error.message : String(error);
                if (!errorMessage.includes('TypeError') && !(error instanceof TypeError)) this.analyticsHelper?.sendActionEvent((0, $J4uEo.EVENT_ACTION).CATCHUP, (0, $J4uEo.EVENT_STATUS).FAILURE, {
                    latency: latency,
                    reason: reason,
                    unconfirmedStepsLength: reconnectionMetadata?.unconfirmedStepsLength,
                    disconnectionPeriodSeconds: reconnectionMetadata?.disconnectionPeriodSeconds
                });
            } finally{
                this.stepQueue.resumeQueue();
                this.processQueue();
                this.sendStepsFromCurrentState(); // this will eventually retry catchup as it calls throttledCommitStep which will either catchup on onStepsAdded or onErrorHandled
                this.stepRejectCounter = 0;
            }
        };
        this.getCurrentPmVersion = ()=>{
            const state = this.getState?.();
            if (!state) {
                this.analyticsHelper?.sendErrorEvent(new Error('No editor state when calling ProseMirror function'), 'getCurrentPmVersion called without state');
                return 0;
            }
            return this.getVersionFromCollabState(state, 'collab-provider: getCurrentPmVersion');
        };
        // Ignored via go/ees005
        // eslint-disable-next-line require-await
        this.getCurrentState = async ()=>{
            try {
                (0, $6f2MR.startMeasure)((0, $6f2MR.MEASURE_NAME).GET_CURRENT_STATE, this.analyticsHelper);
                // Convert ProseMirror document in Editor state to ADF document
                if (!this.getState?.()) this.analyticsHelper?.sendErrorEvent(new Error('Editor state is undefined'), 'getCurrentState called without state');
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const state = this.getState();
                const adfDocument = new (0, $3xuv0.JSONTransformer)().encode(state.doc);
                const version = this.getVersionFromCollabState(state, 'collab-provider: getCurrentState');
                const currentState = {
                    content: adfDocument,
                    title: this.metadataService.getTitle(),
                    stepVersion: version
                };
                const measure = (0, $6f2MR.stopMeasure)((0, $6f2MR.MEASURE_NAME).GET_CURRENT_STATE, this.analyticsHelper);
                this.analyticsHelper?.sendActionEvent((0, $J4uEo.EVENT_ACTION).GET_CURRENT_STATE, (0, $J4uEo.EVENT_STATUS).SUCCESS, {
                    latency: measure?.duration
                });
                return currentState;
            } catch (error) {
                const measure = (0, $6f2MR.stopMeasure)((0, $6f2MR.MEASURE_NAME).GET_CURRENT_STATE, this.analyticsHelper);
                this.analyticsHelper?.sendActionEvent((0, $J4uEo.EVENT_ACTION).GET_CURRENT_STATE, (0, $J4uEo.EVENT_STATUS).FAILURE, {
                    latency: measure?.duration
                });
                this.analyticsHelper?.sendErrorEvent(error, 'Error while returning ADF version of current draft document');
                throw error; // Reject the promise so the consumer can react to it failing
            }
        };
        this.isStepsFromNewClientIdForSameUserId = (steps)=>{
            try {
                if (!Array.isArray(steps) || steps.length === 0) return false;
                const clientIds = new Set(steps.map(({ clientId: clientId })=>clientId));
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (!clientIds.has(this.clientId)) {
                    const userIds = new Set(steps.map(({ userId: userId })=>userId));
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    if (userIds.has(this.getUserId())) return true;
                }
                return false;
            } catch (err) {
                this.analyticsHelper?.sendErrorEvent(err, 'Error while checking for new clientId for same userId in steps');
                return false;
            }
        };
        this.getUnconfirmedStepsOrigins = ()=>{
            const state = this.getState?.();
            if (!state) {
                this.analyticsHelper?.sendErrorEvent(new Error('No editor state when calling ProseMirror function'), 'getUnconfirmedStepsOrigins called without state');
                return;
            }
            return (0, $7TcbF.sendableSteps)(state)?.origins;
        };
        this.getUnconfirmedSteps = ()=>{
            const state = this.getState?.();
            if (!state) {
                this.analyticsHelper?.sendErrorEvent(new Error('No editor state when calling ProseMirror function'), 'getUnconfirmedSteps called without state');
                return;
            }
            return (0, $7TcbF.sendableSteps)(state)?.steps;
        };
        this.applyLocalSteps = (steps)=>{
            // Re-apply local steps
            this.providerEmitCallback('local-steps', {
                steps: steps
            });
        };
        /**
     * Called when we receive steps from the service
     * @param data
     * @example
     */ this.onStepsAdded = (data)=>{
            $56e8761e06a95e15$var$logger(`Received steps`, {
                steps: data.steps,
                version: data.version
            });
            if (!data.steps) {
                $56e8761e06a95e15$var$logger(`No steps.. waiting..`);
                return;
            }
            const ADD_STEPS_PROVIDER_ERROR_MSG = 'Error while adding steps in the provider';
            try {
                const currentVersion = this.getCurrentPmVersion();
                const expectedVersion = currentVersion + data.steps.length;
                if (data.version <= currentVersion) $56e8761e06a95e15$var$logger(`Received steps we already have. Ignoring.`);
                else if (data.version === expectedVersion) this.processSteps(data);
                else if (data.version > expectedVersion) {
                    $56e8761e06a95e15$var$logger(`Version too high. Expected "${expectedVersion}" but got "${data.version}. Current local version is ${currentVersion}.`);
                    this.stepQueue.queueSteps(data);
                    this.throttledCatchupv2((0, $J4uEo.CatchupEventReason).STEPS_ADDED);
                }
                this.participantsService.updateLastActive(data.steps.map(({ userId: userId })=>userId));
            } catch (stepsAddedError) {
                this.analyticsHelper?.sendErrorEvent(stepsAddedError, ADD_STEPS_PROVIDER_ERROR_MSG);
                this.onErrorHandled({
                    message: ADD_STEPS_PROVIDER_ERROR_MSG,
                    data: {
                        status: 500,
                        // Meaningless, remove when we review error structure
                        code: (0, $kunUR.INTERNAL_ERROR_CODE).ADD_STEPS_ERROR
                    }
                });
                // eslint-disable-next-line no-console
                console.error(ADD_STEPS_PROVIDER_ERROR_MSG);
            }
        };
        this.obfuscateStepsAndState = (unconfirmedSteps, currentState)=>{
            let obfuscatedSteps;
            try {
                obfuscatedSteps = unconfirmedSteps ? (0, $g4l86.getObfuscatedSteps)(unconfirmedSteps.map((pmStep)=>pmStep.toJSON())) : 'None';
            } catch (error) {
                // Note that we do not log this error immediately - this string will be logged later.
                // This avoids double logging and keeps this function pure.
                obfuscatedSteps = 'Failed to obfuscate steps';
            }
            let obfuscatedDoc;
            if (currentState) try {
                obfuscatedDoc = (0, $g4l86.getDocAdfWithObfuscationFromJSON)(currentState.content);
            } catch (error) {
                obfuscatedDoc = 'Failed to obfuscate doc';
            }
            return {
                obfuscatedSteps: obfuscatedSteps,
                obfuscatedDoc: obfuscatedDoc
            };
        };
        // Triggered when page recovery has emitted an 'init' event on a page client is currently connected to.
        this.onRestore = async ({ doc: doc, version: version, metadata: metadata, targetClientId: targetClientId })=>{
            if (!targetClientId) this.hasRecovered = true;
            if (targetClientId && this.clientId !== targetClientId) return;
            // We preserve these as they will be lost apon this.updateDocument. This is because we are using document recovery.
            // We can then reconcile the document with the preserved state.
            const unconfirmedSteps = this.getUnconfirmedSteps();
            const currentState = await this.getCurrentState();
            let useReconcile = Boolean(unconfirmedSteps?.length && currentState && !targetClientId);
            const { obfuscatedSteps: obfuscatedSteps, obfuscatedDoc: obfuscatedDoc } = this.obfuscateStepsAndState(unconfirmedSteps, currentState);
            try {
                // Reset the editor,
                //  - Replace the document, keep in sync with the server
                //  - Replace the version number, so editor is in sync with NCS server and can commit new changes.
                //  - Replace the metadata
                //  - Reserve the cursor position, in case a cursor jump.
                this.updateDocument({
                    doc: doc,
                    version: version,
                    metadata: metadata,
                    reserveCursor: true,
                    caller: 'onRestore'
                });
                this.metadataService.updateMetadata(metadata);
                try {
                    this.analyticsHelper?.sendActionEvent((0, $J4uEo.EVENT_ACTION).REINITIALISE_DOCUMENT, (0, $J4uEo.EVENT_STATUS).INFO, {
                        numUnconfirmedSteps: unconfirmedSteps?.length,
                        obfuscatedSteps: obfuscatedSteps,
                        obfuscatedDoc: obfuscatedDoc,
                        hasTitle: !!metadata?.title,
                        clientId: this.clientId,
                        targetClientId: targetClientId,
                        triggeredByCatchup: !!targetClientId
                    });
                    if (unconfirmedSteps?.length) this.applyLocalSteps(unconfirmedSteps);
                } catch (applyLocalStepsError) {
                    // Extract generatedSteps from fetchReconcile response
                    // and apply them to the editor state.
                    this.onErrorHandled({
                        message: `Content synced with your team's edits. You may want to check for conflicting edits that could override your changes.`,
                        data: {
                            code: (0, $kunUR.INTERNAL_ERROR_CODE).OUT_OF_SYNC_CLIENT_DATA_LOSS_EVENT,
                            meta: {
                                reason: 'fe-restore-fetch-generated-steps'
                            }
                        }
                    });
                    useReconcile = false;
                    try {
                        const generatedDiffStepsResponse = await this.fetchGeneratedDiffSteps(JSON.stringify(currentState.content), 'fe-restore-fetch-generated-steps');
                        const { generatedSteps: generatedSteps } = generatedDiffStepsResponse;
                        const state = this.getState?.();
                        if (state?.schema) {
                            const stepsToBeApplied = generatedSteps?.map((s)=>(0, $5aU9U.Step).fromJSON(state.schema, s));
                            if (stepsToBeApplied && stepsToBeApplied.length > 0) {
                                this.analyticsHelper?.sendActionEvent((0, $J4uEo.EVENT_ACTION).REINITIALISE_DOCUMENT, (0, $J4uEo.EVENT_STATUS).INFO, {
                                    stepsCount: stepsToBeApplied.length
                                });
                                this.applyLocalSteps(stepsToBeApplied);
                            } else this.analyticsHelper?.sendActionEvent((0, $J4uEo.EVENT_ACTION).REINITIALISE_DOCUMENT, (0, $J4uEo.EVENT_STATUS).INFO, {
                                reason: 'fetchGeneratedDiffSteps returned no steps'
                            });
                        }
                    } catch (reconcileError) {
                        this.analyticsHelper?.sendErrorEvent(reconcileError, `Error fetchGeneratedDiffSteps with steps-only mode`);
                    }
                }
                this.analyticsHelper?.sendActionEvent((0, $J4uEo.EVENT_ACTION).REINITIALISE_DOCUMENT, (0, $J4uEo.EVENT_STATUS).SUCCESS, {
                    numUnconfirmedSteps: unconfirmedSteps?.length,
                    hasTitle: !!metadata?.title,
                    useReconcile: useReconcile,
                    clientId: this.clientId,
                    targetClientId: targetClientId,
                    triggeredByCatchup: !!targetClientId
                });
            } catch (restoreError) {
                this.analyticsHelper?.sendActionEvent((0, $J4uEo.EVENT_ACTION).REINITIALISE_DOCUMENT, (0, $J4uEo.EVENT_STATUS).FAILURE, {
                    numUnconfirmedSteps: unconfirmedSteps?.length,
                    useReconcile: useReconcile,
                    clientId: this.clientId,
                    targetClientId: targetClientId,
                    triggeredByCatchup: !!targetClientId
                });
                this.analyticsHelper?.sendErrorEvent(restoreError, `Error while reinitialising document. Use Reconcile: ${useReconcile}`);
                this.onErrorHandled({
                    message: 'Caught error while trying to recover the document',
                    data: {
                        status: 500,
                        // Meaningless, remove when we review error structure
                        code: (0, $kunUR.INTERNAL_ERROR_CODE).DOCUMENT_RESTORE_ERROR
                    }
                });
            }
        };
        this.getFinalAcknowledgedState = async (reason)=>{
            this.aggressiveCatchup = true;
            try {
                (0, $6f2MR.startMeasure)((0, $6f2MR.MEASURE_NAME).PUBLISH_PAGE, this.analyticsHelper);
                let finalAcknowledgedState;
                try {
                    await this.commitUnconfirmedSteps(reason);
                    finalAcknowledgedState = await this.getCurrentState();
                } catch (error) {
                    // if fails to commit unconfirmed steps, send reconcile request to NCS BE and return the doc to CC
                    const currentState = await this.getCurrentState();
                    const reconcileResponse = await this.fetchReconcile(JSON.stringify(currentState.content), 'fe-final-ack');
                    finalAcknowledgedState = {
                        content: JSON.parse(reconcileResponse.document),
                        title: currentState.title,
                        stepVersion: reconcileResponse.version
                    };
                }
                const measure = (0, $6f2MR.stopMeasure)((0, $6f2MR.MEASURE_NAME).PUBLISH_PAGE, this.analyticsHelper);
                this.analyticsHelper?.sendActionEvent((0, $J4uEo.EVENT_ACTION).PUBLISH_PAGE, (0, $J4uEo.EVENT_STATUS).SUCCESS, {
                    latency: measure?.duration
                });
                this.aggressiveCatchup = false;
                return finalAcknowledgedState;
            } catch (error) {
                this.aggressiveCatchup = false;
                const measure = (0, $6f2MR.stopMeasure)((0, $6f2MR.MEASURE_NAME).PUBLISH_PAGE, this.analyticsHelper);
                this.analyticsHelper?.sendActionEvent((0, $J4uEo.EVENT_ACTION).PUBLISH_PAGE, (0, $J4uEo.EVENT_STATUS).FAILURE, {
                    latency: measure?.duration
                });
                this.analyticsHelper?.sendErrorEvent(error, 'Error while returning ADF version of the final draft document');
                throw error; // Reject the promise so the consumer can react to it failing
            }
        };
        this.updateDocument = ({ doc: doc, version: version, metadata: metadata, reserveCursor: reserveCursor, caller: caller })=>{
            this.providerEmitCallback('init', {
                doc: doc,
                version: version,
                metadata: metadata,
                ...reserveCursor ? {
                    reserveCursor: reserveCursor
                } : {}
            });
            this.updateDocumentAnalytics(doc, version, caller);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.updateDocumentAnalytics = (doc, version, caller)=>{
            const updatedVersion = this.getCurrentPmVersion();
            const isDocContentValid = this.validatePMJSONDocument(doc);
            // ESS-5023: only emit error event if updated client version is still behind server version
            // client version could become higher than server version due to user editing or plugin adding steps
            if (updatedVersion < version) {
                const error = new (0, $6VDNG.UpdateDocumentError)('Failed to update the document', {
                    newVersion: version,
                    editorVersion: updatedVersion,
                    isDocTruthy: !!doc,
                    docHasContent: doc?.content?.length >= 1,
                    isDocContentValid: isDocContentValid,
                    caller: caller
                });
                this.analyticsHelper?.sendErrorEvent(error, 'Failed to update the document in document service');
                if (this.enableErrorOnFailedDocumentApply) {
                    this.onErrorHandled({
                        message: 'The provider failed to apply changes to the editor',
                        data: {
                            code: (0, $kunUR.INTERNAL_ERROR_CODE).DOCUMENT_UPDATE_ERROR,
                            meta: {
                                newVersion: version,
                                editorVersion: updatedVersion
                            },
                            status: 500
                        }
                    });
                    throw error;
                }
            // Otherwise just fail silently for now
            } else this.analyticsHelper?.sendActionEvent((0, $J4uEo.EVENT_ACTION).UPDATE_DOCUMENT, (0, $J4uEo.EVENT_STATUS).SUCCESS, {
                newVersion: version,
                editorVersion: updatedVersion,
                isDocTruthy: !!doc,
                docHasContent: doc?.content?.length >= 1,
                isDocContentValid: isDocContentValid
            });
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.validatePMJSONDocument = (doc)=>{
            try {
                if (!this.getState?.()) this.analyticsHelper?.sendErrorEvent(new Error('Editor state is undefined'), 'validatePMJSONDocument called without state');
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const state = this.getState();
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const content = (doc.content || []).map((child)=>state.schema.nodeFromJSON(child));
                return content.every((node)=>{
                    try {
                        node.check(); // this will throw an error if the node is invalid
                    } catch (error) {
                        return false;
                    }
                    return true;
                });
            } catch (e) {
                return false;
            }
        };
        /**
     * Commit the unconfirmed local steps to the back-end service
     * @param reason
     * @throws {Error} Couldn't sync the steps after retrying 30 times
     * @example
     */ this.commitUnconfirmedSteps = async (reason)=>{
            const unconfirmedSteps = this.getUnconfirmedSteps();
            try {
                if (unconfirmedSteps?.length) {
                    (0, $6f2MR.startMeasure)((0, $6f2MR.MEASURE_NAME).COMMIT_UNCONFIRMED_STEPS, this.analyticsHelper);
                    let count = 0;
                    // We use origins here as steps can be rebased. When steps are rebased a new step is created.
                    // This means that we can not track if it has been removed from the unconfirmed array or not.
                    // Origins points to the original transaction that the step was created in. This is never changed
                    // and gets passed down when a step is rebased.
                    const unconfirmedTrs = this.getUnconfirmedStepsOrigins();
                    const lastTr = unconfirmedTrs?.[unconfirmedTrs.length - 1];
                    let isLastTrConfirmed = false;
                    if (!this.getState?.()) this.analyticsHelper?.sendErrorEvent(new Error('Editor state is undefined'), 'commitUnconfirmedSteps called without state');
                    while(!isLastTrConfirmed){
                        // this makes all commitUnconfirmedSteps skip the waiting time, which means draft-sync is sped up too.
                        this.sendStepsFromCurrentState(undefined, 'publish');
                        await (0, $g4l86.sleep)(500);
                        const nextUnconfirmedSteps = this.getUnconfirmedSteps();
                        if (nextUnconfirmedSteps?.length) {
                            const nextUnconfirmedTrs = this.getUnconfirmedStepsOrigins();
                            isLastTrConfirmed = !nextUnconfirmedTrs?.some((tr)=>tr === lastTr);
                        } else isLastTrConfirmed = true;
                        if (!isLastTrConfirmed && count++ >= (0, $J4uEo.ACK_MAX_TRY)) {
                            if (this.onSyncUpError) {
                                // Ignored via go/ees005
                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                const state = this.getState();
                                const version = this.getVersionFromCollabState(state, 'collab-provider: commitUnconfirmedSteps');
                                this.onSyncUpError({
                                    lengthOfUnconfirmedSteps: nextUnconfirmedSteps?.length,
                                    tries: count,
                                    maxRetries: (0, $J4uEo.ACK_MAX_TRY),
                                    clientId: this.clientId,
                                    version: version
                                });
                            }
                            const unconfirmedStepsInfoUGCRemoved = this.getUnconfirmedSteps()?.map((step)=>(0, $g4l86.getStepUGCFreeDetails)(step));
                            const error = new (0, $6VDNG.CantSyncUpError)("Can't sync up with Collab Service: unable to send unconfirmed steps and max retry reached", {
                                unconfirmedStepsInfo: unconfirmedStepsInfoUGCRemoved ? JSON.stringify(unconfirmedStepsInfoUGCRemoved) : 'Unable to generate UGC removed step info'
                            });
                            throw error;
                        }
                    }
                    const measure = (0, $6f2MR.stopMeasure)((0, $6f2MR.MEASURE_NAME).COMMIT_UNCONFIRMED_STEPS, this.analyticsHelper);
                    this.analyticsHelper?.sendActionEvent((0, $J4uEo.EVENT_ACTION).COMMIT_UNCONFIRMED_STEPS, (0, $J4uEo.EVENT_STATUS).SUCCESS, {
                        latency: measure?.duration,
                        // upon success, emit the total number of unconfirmed steps we synced
                        numUnconfirmedSteps: unconfirmedSteps?.length
                    });
                }
            } catch (error) {
                const measure = (0, $6f2MR.stopMeasure)((0, $6f2MR.MEASURE_NAME).COMMIT_UNCONFIRMED_STEPS, this.analyticsHelper);
                this.analyticsHelper?.sendActionEvent((0, $J4uEo.EVENT_ACTION).COMMIT_UNCONFIRMED_STEPS, (0, $J4uEo.EVENT_STATUS).FAILURE, {
                    latency: measure?.duration,
                    numUnconfirmedSteps: unconfirmedSteps?.length
                });
                this.analyticsHelper?.sendErrorEvent(error, 'Error while committing unconfirmed steps');
                throw error;
            }
        };
        this.onStepRejectedError = ()=>{
            this.stepRejectCounter++;
            $56e8761e06a95e15$var$logger(`Steps rejected (tries=${this.stepRejectCounter})`);
            this.analyticsHelper?.sendActionEvent((0, $J4uEo.EVENT_ACTION).SEND_STEPS_RETRY, (0, $J4uEo.EVENT_STATUS).INFO, {
                count: this.stepRejectCounter
            });
            const maxRetries = this.aggressiveCatchup ? (0, $7Hrb0.MAX_STEP_REJECTED_ERROR_AGGRESSIVE) : (0, $7Hrb0.MAX_STEP_REJECTED_ERROR);
            if (this.stepRejectCounter >= maxRetries) {
                $56e8761e06a95e15$var$logger(`The steps were rejected too many times (tries=${this.stepRejectCounter}, limit=${(0, $7Hrb0.MAX_STEP_REJECTED_ERROR)}). Trying to catch-up.`);
                this.analyticsHelper?.sendActionEvent((0, $J4uEo.EVENT_ACTION).CATCHUP_AFTER_MAX_SEND_STEPS_RETRY, (0, $J4uEo.EVENT_STATUS).INFO);
                this.throttledCatchupv2((0, $J4uEo.CatchupEventReason).STEPS_REJECTED);
            } else // If committing steps failed try again automatically in 1s
            // This makes it more likely that unconfirmed steps trigger a catch-up
            // within 15s even if there is no one editing actively (or draft sync polling)
            // reducing the risk of data loss at the expense of step commits
            setTimeout(()=>this.sendStepsFromCurrentState(), 1000);
        };
        /**
     * If we are going to commit unconfirmed steps
     * we need to lock them to ensure they don't get
     * mutated in: `packages/editor/editor-plugin-collab-edit/src/pm-plugins/mergeUnconfirmed.ts`
     */ this.lockSteps = ()=>{
            if ((0, $fqVYq.editorExperiment)('platform_editor_offline_editing_web', true) || (0, $ieeJu.expValEquals)('platform_editor_enable_single_player_step_merging', 'isEnabled', true)) {
                const currentState = this.getState?.();
                if (currentState) this.lockStepOrigins((0, $7TcbF.sendableSteps)(currentState)?.origins ?? []);
            }
        };
        this.lockStepOrigins = (origins)=>{
            origins?.forEach((origin)=>{
                if (origin instanceof (0, $kCECX.Transaction)) return origin.setMeta('mergeIsLocked', true);
            });
        };
        this.stepQueue = new (0, $kB8eL.StepQueueState)();
        this.onErrorHandled = onErrorHandled;
        this.commitStepService = new (0, $i68DM.CommitStepService)(this.broadcast, this.analyticsHelper, this.providerEmitCallback, this.onErrorHandled);
    }
}
module.exports["DocumentService"] = $56e8761e06a95e15$export$136703b96b9b8f33;

});

parcelRegister("i68DM", function(module, exports) {

var $cs4hy = parcelRequire("cs4hy");


var $J4uEo = parcelRequire("J4uEo");


var $eFNck = parcelRequire("eFNck");


var $dLe3j = parcelRequire("dLe3j");


var $g4l86 = parcelRequire("g4l86");


var $ieeJu = parcelRequire("ieeJu");

const $bbad37441d44d65c$var$logger = (0, $g4l86.createLogger)('commit-step', 'black');
const $bbad37441d44d65c$export$e52e10f4c6d18d66 = 5000;
class $bbad37441d44d65c$export$1507ea63539b16e5 {
    commitStepQueue({ steps: steps, version: version, userId: userId, clientId: clientId, onStepsAdded: onStepsAdded, __livePage: __livePage, hasRecovered: hasRecovered, collabMode: collabMode, reason: reason, lockSteps: lockSteps, stepOrigins: stepOrigins }) {
        // this timer is for waiting to send the next batch in between acks from the BE
        let commitWaitTimer;
        // if publishing and not waiting for an ACK, then clear the commit timer and proceed, skipping the timer
        if (reason === 'publish' && this.lastBroadcastRequestAcked) {
            clearTimeout(commitWaitTimer);
            lockSteps();
            this.readyToCommit = true;
        }
        if (!this.readyToCommit) {
            $bbad37441d44d65c$var$logger('Not ready to commit, skip');
            return;
        }
        // Block other sending request, before ACK
        this.readyToCommit = false;
        this.lastBroadcastRequestAcked = false;
        // this timer is a fallback for if an ACK from BE is lost - stop the queue from getting indefinitely locked
        const fallbackTimer = setTimeout(()=>{
            lockSteps();
            this.readyToCommit = true;
            this.lastBroadcastRequestAcked = true;
            $bbad37441d44d65c$var$logger('reset readyToCommit by timer');
        }, $bbad37441d44d65c$export$e52e10f4c6d18d66);
        let stepsWithClientAndUserId = steps.map((step)=>({
                ...step.toJSON(),
                clientId: clientId,
                userId: userId
            }));
        // Mutate steps to ignore expand expand/collapse changes in live pages
        // This is expected to be a temporary divergence from standard editor behaviour
        // and will be removed in Q4 when editor and live view pages align on a single
        // behaviour for expands.
        // While not recommended by the Editor content services team, this has been discussed
        // as being low risk as the expand change via a setAttrs step;
        // - doesn't impact any indexes,
        // - is setup for last write wins,
        // - and is just a boolean -- so no real risk of data loss.
        if (__livePage) stepsWithClientAndUserId = stepsWithClientAndUserId.map((step)=>{
            if (this.isExpandChangeStep(step)) // The title is also updated via this step, which we do want to send to the server.
            // so we strip out the __expanded attribute from the step.
            return {
                ...step,
                attrs: {
                    title: step.attrs.title
                }
            };
            return step;
        });
        // tag unconfirmed steps sent after page has been recovered during client's editing session
        if (hasRecovered) stepsWithClientAndUserId = stepsWithClientAndUserId.map((step)=>{
            step.metadata = {
                ...step.metadata,
                unconfirmedStepAfterRecovery: true
            };
            return step;
        });
        if ((0, $ieeJu.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true)) stepsWithClientAndUserId = this.addOfflineMetadata(stepsWithClientAndUserId, stepOrigins);
        const start = new Date().getTime();
        const ADD_STEPS_ACKNOWLEDGEMENT_ERROR_MSG = 'Error while adding steps - Invalid Acknowledgement';
        const ADD_STEPS_BROADCAST_ERROR_MSG = 'Error while adding steps - Broadcast threw exception';
        this.emit('commit-status', {
            status: 'attempt',
            version: version
        });
        try {
            this.broadcast('steps:commit', {
                collabMode: collabMode,
                steps: stepsWithClientAndUserId,
                version: version,
                userId: userId
            }, (response)=>{
                this.lastBroadcastRequestAcked = true;
                const latency = new Date().getTime() - start;
                // this most closely replicates the BE ack delay behaviour. 500ms hardcoded + 180ms network delay (tested on hello)
                // more context: https://hello.atlassian.net/wiki/spaces/CEPS/pages/5020556010/Spike+Moving+BE+delay+to+the+FE
                // to be switched over to backpressure delay sent from the BE in https://hello.jira.atlassian.cloud/browse/CEPS-1030
                let delay = latency < 680 ? 680 - latency : 1;
                if (response.delay) delay = response.delay;
                 // if backpressure delay is sent, overwrite it
                clearTimeout(fallbackTimer); // clear the fallback timer, ack was successfully sent/recieved
                commitWaitTimer = setTimeout(()=>{
                    lockSteps();
                    // unlock the queue after waiting for delay
                    this.readyToCommit = true;
                    $bbad37441d44d65c$var$logger('reset readyToCommit');
                }, delay);
                if (response.type === (0, $eFNck.AcknowledgementResponseTypes).SUCCESS) {
                    onStepsAdded({
                        steps: stepsWithClientAndUserId,
                        version: response.version
                    });
                    this.sendSuccessAnalytics(latency, stepsWithClientAndUserId);
                    this.emit('commit-status', {
                        status: 'success',
                        version: response.version
                    });
                } else if (response.type === (0, $eFNck.AcknowledgementResponseTypes).ERROR) {
                    this.onErrorHandled(response.error);
                    this.sendFailureAnalytics(response, latency);
                    this.emit('commit-status', {
                        status: 'failure',
                        version: version
                    });
                    // eslint-disable-next-line no-console
                    console.error(ADD_STEPS_ACKNOWLEDGEMENT_ERROR_MSG);
                } else {
                    this.analyticsHelper?.sendErrorEvent(// @ts-expect-error We didn't type the invalid type case
                    new Error(`Response type: ${response?.type || 'No response type'}`), ADD_STEPS_ACKNOWLEDGEMENT_ERROR_MSG);
                    this.emit('commit-status', {
                        status: 'failure',
                        version: version
                    });
                    // eslint-disable-next-line no-console
                    console.error(ADD_STEPS_ACKNOWLEDGEMENT_ERROR_MSG);
                }
            });
        } catch (error) {
            // if the broadcast failed for any reason, we shouldn't keep the queue locked as the BE has not recieved any message
            lockSteps();
            this.readyToCommit = true;
            this.analyticsHelper?.sendErrorEvent(error, ADD_STEPS_BROADCAST_ERROR_MSG);
            this.emit('commit-status', {
                status: 'failure',
                version: version
            });
            // eslint-disable-next-line no-console
            console.error(ADD_STEPS_BROADCAST_ERROR_MSG);
        }
    }
    isExpandChangeStep(step) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (step.stepType === 'setAttrs' && '__expanded' in step.attrs) return true;
        return false;
    }
    addOfflineMetadata(stepsWithClientAndUserId, origins) {
        if (origins.some((s)=>s.getMeta('isOffline') === true || s.getMeta('wasOffline') === true)) return stepsWithClientAndUserId.map((step, idx)=>{
            const origin = origins[idx];
            if (!origin) return step;
            const createdOffline = origin.getMeta('isOffline') || origin.getMeta('wasOffline');
            if (createdOffline === true) step.metadata = {
                ...step.metadata,
                createdOffline: createdOffline
            };
            return step;
        });
        return stepsWithClientAndUserId;
    }
    sendSuccessAnalytics(latency, stepsWithClientAndUserId) {
        // Sample only 10% of add steps events to avoid overwhelming the analytics
        if (Math.random() < 0.1) this.analyticsHelper?.sendActionEvent((0, $J4uEo.EVENT_ACTION).ADD_STEPS, (0, $J4uEo.EVENT_STATUS).SUCCESS_10x_SAMPLED, {
            type: (0, $J4uEo.ADD_STEPS_TYPE).ACCEPTED,
            latency: latency,
            stepType: (0, (/*@__PURE__*/$parcel$interopDefault($cs4hy)))(stepsWithClientAndUserId, // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (stepWithClientAndUserId)=>stepWithClientAndUserId.stepType)
        });
    }
    sendFailureAnalytics(response, latency) {
        this.analyticsHelper?.sendActionEvent((0, $J4uEo.EVENT_ACTION).ADD_STEPS, (0, $J4uEo.EVENT_STATUS).FAILURE, {
            // User tried committing steps but they were rejected because:
            // - HEAD_VERSION_UPDATE_FAILED: the collab service's latest stored step tail version didn't correspond to the head version of the first step submitted
            // - VERSION_NUMBER_ALREADY_EXISTS: while storing the steps there was a conflict meaning someone else wrote steps into the database more quickly
            type: response.error.data.code === (0, $dLe3j.NCS_ERROR_CODE).HEAD_VERSION_UPDATE_FAILED || response.error.data.code === (0, $dLe3j.NCS_ERROR_CODE).VERSION_NUMBER_ALREADY_EXISTS ? (0, $J4uEo.ADD_STEPS_TYPE).REJECTED : (0, $J4uEo.ADD_STEPS_TYPE).ERROR,
            latency: latency
        });
        this.analyticsHelper?.sendErrorEvent(response.error, 'Error while adding steps - Acknowledgement Error');
    }
    getReadyToCommitStatus() {
        return this.readyToCommit;
    }
    /**
   * @param broadcast - Callback for broadcasting events to other clients
   * @param analyticsHelper - Helper for analytics events
   * @param emit - Callback for emitting events to listeners on the provider
   * @param onErrorHandled - Callback to handle
   */ constructor(broadcast, analyticsHelper, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    emit, onErrorHandled){
        this.broadcast = broadcast;
        this.analyticsHelper = analyticsHelper;
        this.emit = emit;
        this.onErrorHandled = onErrorHandled;
        this.readyToCommit = void 0;
        this.lastBroadcastRequestAcked = void 0;
        this.readyToCommit = true;
        this.lastBroadcastRequestAcked = true;
    }
}
module.exports["CommitStepService"] = $bbad37441d44d65c$export$1507ea63539b16e5;

});

parcelRegister("cs4hy", function(module, exports) {

var $bsTU9 = parcelRequire("bsTU9");


var $aYr7p = parcelRequire("aYr7p");

/** Used for built-in method references. */ var $910b6be6b190898d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $910b6be6b190898d$var$hasOwnProperty = $910b6be6b190898d$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the number of times the key was returned by `iteratee`. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.countBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': 1, '6': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.countBy(['one', 'two', 'three'], 'length');
 * // => { '3': 2, '5': 1 }
 */ var $910b6be6b190898d$var$countBy = $aYr7p(function(result, value, key) {
    if ($910b6be6b190898d$var$hasOwnProperty.call(result, key)) ++result[key];
    else $bsTU9(result, key, 1);
});
module.exports = $910b6be6b190898d$var$countBy;

});

parcelRegister("aYr7p", function(module, exports) {

var $aQVxe = parcelRequire("aQVxe");


var $gvTsE = parcelRequire("gvTsE");


var $j6gAQ = parcelRequire("j6gAQ");


var $1ScXu = parcelRequire("1ScXu");

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $7fd48b25632d9305$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = $1ScXu(collection) ? $aQVxe : $gvTsE, accumulator = initializer ? initializer() : {};
        return func(collection, setter, $j6gAQ(iteratee, 2), accumulator);
    };
}
module.exports = $7fd48b25632d9305$var$createAggregator;

});

parcelRegister("aQVxe", function(module, exports) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $7e6b63f27d697568$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = $7e6b63f27d697568$var$arrayAggregator;

});

parcelRegister("gvTsE", function(module, exports) {

var $bNHBU = parcelRequire("bNHBU");

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $c05a9000df9c8764$var$baseAggregator(collection, setter, iteratee, accumulator) {
    $bNHBU(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = $c05a9000df9c8764$var$baseAggregator;

});

parcelRegister("bNHBU", function(module, exports) {

var $lFjE5 = parcelRequire("lFjE5");


var $923lQ = parcelRequire("923lQ");

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $8976196cdeddb1dc$var$baseEach = $923lQ($lFjE5);
module.exports = $8976196cdeddb1dc$var$baseEach;

});

parcelRegister("lFjE5", function(module, exports) {

var $comu1 = parcelRequire("comu1");


var $f14Rr = parcelRequire("f14Rr");

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $fc5caa85fb423e25$var$baseForOwn(object, iteratee) {
    return object && $comu1(object, iteratee, $f14Rr);
}
module.exports = $fc5caa85fb423e25$var$baseForOwn;

});

parcelRegister("923lQ", function(module, exports) {

var $9pMwd = parcelRequire("9pMwd");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $6936e67b6e4d0605$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$9pMwd(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $6936e67b6e4d0605$var$createBaseEach;

});

parcelRegister("kL1DJ", function(module, exports) {

var $J4uEo = parcelRequire("J4uEo");


var $g4l86 = parcelRequire("g4l86");

const $d3cd2646202c7a8e$var$logger = (0, $g4l86.createLogger)('Catchupv2', 'red');
const $d3cd2646202c7a8e$export$f32ba3eea9c226f8 = async (opt)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let steps;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let metadata;
    const fromVersion = opt.getCurrentPmVersion();
    try {
        ({ steps: steps, metadata: metadata } = await opt.fetchCatchupv2(fromVersion, opt.clientId, opt.catchUpOutofSync, opt.reason, opt.sessionId));
    } catch (error) {
        opt.analyticsHelper?.sendErrorEvent(error, 'Error while fetching catchupv2 from server');
        $d3cd2646202c7a8e$var$logger(`Fetch catchupv2 from server failed:`, error.message);
        throw error;
    }
    try {
        opt.onCatchupComplete?.(steps);
        // skip onStepsAdded if steps are undefined or empty
        if (!steps || steps.length === 0) {
            opt.updateMetadata(metadata);
            return false;
        }
        const version = fromVersion + steps.length;
        const stepsPayload = {
            version: version,
            steps: steps
        };
        opt.onStepsAdded(stepsPayload);
        opt.updateMetadata(metadata);
        const clientOutOfSync = Boolean(opt.clientId && $d3cd2646202c7a8e$export$f11b7fb226059e83(fromVersion, opt.getCurrentPmVersion(), steps, opt.clientId));
        if (clientOutOfSync) $d3cd2646202c7a8e$var$logObfuscatedSteps(steps, opt);
        return clientOutOfSync;
    } catch (error) {
        opt.analyticsHelper?.sendErrorEvent(error, 'Failed to apply catchupv2 result in the editor');
        $d3cd2646202c7a8e$var$logger(`Apply catchupv2 steps failed:`, error.message);
        throw error;
    }
};
const $d3cd2646202c7a8e$var$logObfuscatedSteps = (steps, opt)=>{
    const state = opt.getState?.();
    opt.analyticsHelper?.sendActionEvent((0, $J4uEo.EVENT_ACTION).OUT_OF_SYNC, (0, $J4uEo.EVENT_STATUS).FAILURE, {
        obfuscatedSteps: (0, $g4l86.getObfuscatedSteps)(steps),
        obfuscatedDoc: state ? (0, $g4l86.getDocAdfWithObfuscation)(state.doc) : null,
        catchupReason: opt.reason
    });
};
const $d3cd2646202c7a8e$export$f11b7fb226059e83 = (fromVersion, currentVersion, steps, clientId)=>// If version number hasn't increased, and steps are not from our client, we're out of sync
    Boolean(fromVersion >= currentVersion && steps.some((step)=>step.clientId !== clientId));
module.exports["catchupv2"] = $d3cd2646202c7a8e$export$f32ba3eea9c226f8;

});

parcelRegister("kB8eL", function(module, exports) {

var $g4l86 = parcelRequire("g4l86");

const $3259b2622b6d7967$var$logger = (0, $g4l86.createLogger)('documentService-queue', 'black');
class $3259b2622b6d7967$export$ec73f9ac65128a78 {
    queueSteps(data) {
        $3259b2622b6d7967$var$logger(`Queueing data for version "${data.version}".`);
        const orderedQueue = [
            ...this.queue,
            data
        ].sort((a, b)=>a.version > b.version ? 1 : -1);
        this.queue = orderedQueue;
    }
    constructor(){
        this.queuePaused = false;
        this.queue = [];
        this.getQueue = ()=>{
            return this.queue;
        };
        this.filterQueue = (condition)=>{
            this.queue = this.queue.filter(condition);
        };
        /**
     * Get whether the document service has stopped processing new steps whilst it carries out processes such as catchup.
     * Exposed for testing
     */ this.isPaused = ()=>this.queuePaused;
        this.pauseQueue = ()=>{
            this.queuePaused = true;
        };
        this.resumeQueue = ()=>{
            this.queuePaused = false;
        };
        this.shift = ()=>{
            return this.queue.shift();
        };
    }
}
module.exports["StepQueueState"] = $3259b2622b6d7967$export$ec73f9ac65128a78;

});

parcelRegister("jQP9V", function(module, exports) {

var $dFI5z = parcelRequire("dFI5z");


var $7TcbF = parcelRequire("7TcbF");

const $2b085e92a48888aa$var$simplifySteps = (steps)=>{
    return steps.reduce((acc, step)=>{
        const lastStep = acc[acc.length - 1];
        if (lastStep) {
            const mergedStep = lastStep.merge(step);
            if (mergedStep) {
                acc[acc.length - 1] = mergedStep;
                return acc;
            }
        }
        return acc.concat(step);
    }, []);
};
function $2b085e92a48888aa$var$findContentChanges(doc, steps) {
    let changes = (0, $dFI5z.ChangeSet).create(doc);
    let latestDoc = doc;
    $2b085e92a48888aa$var$simplifySteps(steps).forEach((step, index)=>{
        const stepResult = step.apply(latestDoc);
        if (stepResult.failed !== null || stepResult.doc === null) return;
        latestDoc = stepResult.doc;
        changes = changes.addSteps(latestDoc, [
            step.getMap()
        ], {
            step: index
        });
    });
    return changes;
}
/**
 * Iterate through the changesets to find overlapping regions that indicate conflicting
 * changes
 */ const $2b085e92a48888aa$var$getConflicts = ({ localChanges: localChanges, localDoc: localDoc, remoteChanges: remoteChanges, remoteDoc: remoteDoc })=>{
    const conflictingChanges = [];
    localChanges.changes.forEach((localChange)=>{
        remoteChanges.changes.forEach((remoteChange)=>{
            if (// Local change is inside remote change
            localChange.fromA >= remoteChange.fromA && localChange.toA <= remoteChange.toA || // Remote change is inside local change
            remoteChange.fromA >= localChange.fromA && remoteChange.toA <= localChange.toA || // Partial overlap with the end
            localChange.fromA >= remoteChange.fromA && localChange.fromA < remoteChange.toA && localChange.toA > remoteChange.toA || // Partial overlap with the start
            localChange.fromA < remoteChange.fromA && localChange.toA > remoteChange.fromA && localChange.toA <= remoteChange.toA || // One of the edges match
            localChange.fromA === remoteChange.toA || remoteChange.fromA === localChange.toA) {
                const remoteSlice = remoteDoc.slice(remoteChange.fromB, remoteChange.toB);
                const isDeletion = remoteSlice.size === 0;
                conflictingChanges.push({
                    from: Math.min(localChange.fromA, remoteChange.fromA),
                    to: Math.max(localChange.toA, remoteChange.toA),
                    // We only want to capture the exact slice deleted (without parents) so we can display and insert as expected
                    local: localDoc.slice(localChange.fromB, localChange.toB, !isDeletion),
                    remote: remoteSlice
                });
            }
        });
    });
    return conflictingChanges;
};
/**
 * This runs a collab rebase (that is run synchronously after this)
 * and extracts the local doc (before changes), remote doc and the
 * mapping to determine any conflicts.
 * See: `packages/editor/prosemirror-collab/src/index.ts`
 */ const $2b085e92a48888aa$var$rebaseSteps = ({ localSteps: localSteps, remoteSteps: remoteSteps, tr: tr })=>{
    const originalMapsLength = tr.mapping.maps?.length;
    const originalDocsLength = tr.docs.length;
    (0, $7TcbF.rebaseSteps)(localSteps, remoteSteps, tr);
    /**
	 * `tr.docs` contains the documents before each change.
	 *
	 * To get "originalDoc" we need to get the document immediately after the local steps are inverted
	 * which is the equal to the number of local steps. If there are no remote steps this will be undefined and
	 * the most current document is appropriate
	 *
	 * To get the "remoteDoc" we need to get the document immediately after the local steps have been inverted
	 * and the remote steps re-applied. If there are no local steps or they are all lost in rebase this will be
	 * undefined and the most current document is appropriate
	 *
	 */ const originalDoc = tr.docs[originalDocsLength + localSteps.length] ?? tr.doc;
    const remoteDoc = tr.docs[originalDocsLength + localSteps.length + remoteSteps.length] ?? tr.doc;
    const mapStart = originalMapsLength + localSteps.length;
    return {
        mapStart: mapStart,
        originalDoc: originalDoc,
        remoteDoc: remoteDoc
    };
};
function $2b085e92a48888aa$export$daa1eb0d72f5b266({ localSteps: localSteps, remoteSteps: remoteSteps, tr: tr }) {
    const localDoc = tr.doc;
    const { originalDoc: originalDoc, remoteDoc: remoteDoc, mapStart: mapStart } = $2b085e92a48888aa$var$rebaseSteps({
        localSteps: localSteps,
        remoteSteps: remoteSteps,
        tr: tr
    });
    const localChanges = $2b085e92a48888aa$var$findContentChanges(originalDoc, localSteps.map((s)=>s.step));
    const remoteChanges = $2b085e92a48888aa$var$findContentChanges(originalDoc, remoteSteps);
    // This is the mapping between the original document and our final one which can be used to
    // map conflict positions (which are based on the original doc)
    const mapping = tr.mapping.slice(mapStart);
    // Find the overlapping conflicts - these are based on the positions of the original document so are
    // common to both local and remote documents.
    // The above mapping allows us to bring these positions to where they are in the current document
    const conflictingChanges = $2b085e92a48888aa$var$getConflicts({
        localChanges: localChanges,
        localDoc: localDoc,
        remoteDoc: remoteDoc,
        remoteChanges: remoteChanges
    });
    const isConflictChange = (value)=>Boolean(value);
    // Prevent duplicate ranges occuring
    const seenInsertions = new Set();
    return {
        inserted: conflictingChanges.filter((i)=>i.remote.size !== 0).map((i)=>({
                ...i,
                from: mapping.map(i.from, -1),
                to: mapping.map(i.to)
            })).filter((i)=>{
            const identifier = `${i.from}-${i.to}`;
            if (seenInsertions.has(identifier)) return false;
            seenInsertions.add(identifier);
            return isConflictChange(i);
        }),
        deleted: conflictingChanges.filter((d)=>d.remote.size === 0).map((d)=>({
                ...d,
                from: mapping.map(d.from),
                to: mapping.map(d.to)
            })).filter(isConflictChange)
    };
}
module.exports["getConflictChanges"] = $2b085e92a48888aa$export$daa1eb0d72f5b266;

});

parcelRegister("dFI5z", function(module, exports) {
function $9f414dcece7e66a3$var$typeID(type) {
    let cache = type.schema.cached.changeSetIDs || (type.schema.cached.changeSetIDs = Object.create(null));
    let id = cache[type.name];
    if (id == null) cache[type.name] = id = Object.keys(type.schema.nodes).indexOf(type.name) + 1;
    return id;
}
// The default token encoder, which encodes node open tokens are
// encoded as strings holding the node name, characters as their
// character code, and node close tokens as negative numbers.
const $9f414dcece7e66a3$var$DefaultEncoder = {
    encodeCharacter: (char)=>char,
    encodeNodeStart: (node)=>node.type.name,
    encodeNodeEnd: (node)=>-$9f414dcece7e66a3$var$typeID(node.type),
    compareTokens: (a, b)=>a === b
};
// Convert the given range of a fragment to tokens.
function $9f414dcece7e66a3$var$tokens(frag, encoder, start, end, target) {
    for(let i = 0, off = 0; i < frag.childCount; i++){
        let child = frag.child(i), endOff = off + child.nodeSize;
        let from = Math.max(off, start), to = Math.min(endOff, end);
        if (from < to) {
            if (child.isText) for(let j = from; j < to; j++)target.push(encoder.encodeCharacter(child.text.charCodeAt(j - off), child.marks));
            else if (child.isLeaf) target.push(encoder.encodeNodeStart(child));
            else {
                if (from == off) target.push(encoder.encodeNodeStart(child));
                $9f414dcece7e66a3$var$tokens(child.content, encoder, Math.max(off + 1, from) - off - 1, Math.min(endOff - 1, to) - off - 1, target);
                if (to == endOff) target.push(encoder.encodeNodeEnd(child));
            }
        }
        off = endOff;
    }
    return target;
}
// The code below will refuse to compute a diff with more than 5000
// insertions or deletions, which takes about 300ms to reach on my
// machine. This is a safeguard against runaway computations.
const $9f414dcece7e66a3$var$MAX_DIFF_SIZE = 5000;
// This obscure mess of constants computes the minimum length of an
// unchanged range (not at the start/end of the compared content). The
// idea is to make it higher in bigger replacements, so that you don't
// get a diff soup of coincidentally identical letters when replacing
// a paragraph.
function $9f414dcece7e66a3$var$minUnchanged(sizeA, sizeB) {
    return Math.min(15, Math.max(2, Math.floor(Math.max(sizeA, sizeB) / 10)));
}
function $9f414dcece7e66a3$var$computeDiff(fragA, fragB, range, encoder = $9f414dcece7e66a3$var$DefaultEncoder) {
    let tokA = $9f414dcece7e66a3$var$tokens(fragA, encoder, range.fromA, range.toA, []);
    let tokB = $9f414dcece7e66a3$var$tokens(fragB, encoder, range.fromB, range.toB, []);
    // Scan from both sides to cheaply eliminate work
    let start = 0, endA = tokA.length, endB = tokB.length;
    let cmp = encoder.compareTokens;
    while(start < tokA.length && start < tokB.length && cmp(tokA[start], tokB[start]))start++;
    if (start == tokA.length && start == tokB.length) return [];
    while(endA > start && endB > start && cmp(tokA[endA - 1], tokB[endB - 1]))endA--, endB--;
    // If the result is simple _or_ too big to cheaply compute, return
    // the remaining region as the diff
    if (endA == start || endB == start || endA == endB && endA == start + 1) return [
        range.slice(start, endA, start, endB)
    ];
    // This is an implementation of Myers' diff algorithm
    // See https://neil.fraser.name/writing/diff/myers.pdf and
    // https://blog.jcoglan.com/2017/02/12/the-myers-diff-algorithm-part-1/
    let lenA = endA - start, lenB = endB - start;
    let max = Math.min($9f414dcece7e66a3$var$MAX_DIFF_SIZE, lenA + lenB), off = max + 1;
    let history = [];
    let frontier = [];
    for(let len = off * 2, i = 0; i < len; i++)frontier[i] = -1;
    for(let size = 0; size <= max; size++){
        for(let diag = -size; diag <= size; diag += 2){
            let next = frontier[diag + 1 + max], prev = frontier[diag - 1 + max];
            let x = next < prev ? prev : next + 1, y = x + diag;
            while(x < lenA && y < lenB && cmp(tokA[start + x], tokB[start + y]))x++, y++;
            frontier[diag + max] = x;
            // Found a match
            if (x >= lenA && y >= lenB) {
                // Trace back through the history to build up a set of changed ranges.
                let diff = [], minSpan = $9f414dcece7e66a3$var$minUnchanged(endA - start, endB - start);
                // Used to add steps to a diff one at a time, back to front, merging
                // ones that are less than minSpan tokens apart
                let fromA = -1, toA = -1, fromB = -1, toB = -1;
                let add = (fA, tA, fB, tB)=>{
                    if (fromA > -1 && fromA < tA + minSpan) {
                        fromA = fA;
                        fromB = fB;
                    } else {
                        if (fromA > -1) diff.push(range.slice(fromA, toA, fromB, toB));
                        fromA = fA;
                        toA = tA;
                        fromB = fB;
                        toB = tB;
                    }
                };
                for(let i = size - 1; i >= 0; i--){
                    let next = frontier[diag + 1 + max], prev = frontier[diag - 1 + max];
                    if (next < prev) {
                        diag--;
                        x = prev + start;
                        y = x + diag;
                        add(x, x, y, y + 1);
                    } else {
                        diag++;
                        x = next + start;
                        y = x + diag;
                        add(x, x + 1, y, y);
                    }
                    frontier = history[i >> 1];
                }
                if (fromA > -1) diff.push(range.slice(fromA, toA, fromB, toB));
                return diff.reverse();
            }
        }
        // Since only either odd or even diagonals are read from each
        // frontier, we only copy them every other iteration.
        if (size % 2 == 0) history.push(frontier.slice());
    }
    // The loop exited, meaning the maximum amount of work was done.
    // Just return a change spanning the entire range.
    return [
        range.slice(start, endA, start, endB)
    ];
}
/**
Stores metadata for a part of a change.
*/ class $9f414dcece7e66a3$export$5f1714a13ed34c01 {
    /**
    @internal
    */ cut(length) {
        return length == this.length ? this : new $9f414dcece7e66a3$export$5f1714a13ed34c01(length, this.data);
    }
    /**
    @internal
    */ static slice(spans, from, to) {
        if (from == to) return $9f414dcece7e66a3$export$5f1714a13ed34c01.none;
        if (from == 0 && to == $9f414dcece7e66a3$export$5f1714a13ed34c01.len(spans)) return spans;
        let result = [];
        for(let i = 0, off = 0; off < to; i++){
            let span = spans[i], end = off + span.length;
            let overlap = Math.min(to, end) - Math.max(from, off);
            if (overlap > 0) result.push(span.cut(overlap));
            off = end;
        }
        return result;
    }
    /**
    @internal
    */ static join(a, b, combine) {
        if (a.length == 0) return b;
        if (b.length == 0) return a;
        let combined = combine(a[a.length - 1].data, b[0].data);
        if (combined == null) return a.concat(b);
        let result = a.slice(0, a.length - 1);
        result.push(new $9f414dcece7e66a3$export$5f1714a13ed34c01(a[a.length - 1].length + b[0].length, combined));
        for(let i = 1; i < b.length; i++)result.push(b[i]);
        return result;
    }
    /**
    @internal
    */ static len(spans) {
        let len = 0;
        for(let i = 0; i < spans.length; i++)len += spans[i].length;
        return len;
    }
    /**
    @internal
    */ constructor(/**
    The length of this span.
    */ length, /**
    The data associated with this span.
    */ data){
        this.length = length;
        this.data = data;
    }
}
/**
@internal
*/ $9f414dcece7e66a3$export$5f1714a13ed34c01.none = [];
/**
A replaced range with metadata associated with it.
*/ class $9f414dcece7e66a3$export$fb8e829a68c430bd {
    /**
    @internal
    */ get lenA() {
        return this.toA - this.fromA;
    }
    /**
    @internal
    */ get lenB() {
        return this.toB - this.fromB;
    }
    /**
    @internal
    */ slice(startA, endA, startB, endB) {
        if (startA == 0 && startB == 0 && endA == this.toA - this.fromA && endB == this.toB - this.fromB) return this;
        return new $9f414dcece7e66a3$export$fb8e829a68c430bd(this.fromA + startA, this.fromA + endA, this.fromB + startB, this.fromB + endB, $9f414dcece7e66a3$export$5f1714a13ed34c01.slice(this.deleted, startA, endA), $9f414dcece7e66a3$export$5f1714a13ed34c01.slice(this.inserted, startB, endB));
    }
    /**
    This merges two changesets (the end document of x should be the
    start document of y) into a single one spanning the start of x to
    the end of y.
    */ static merge(x, y, combine) {
        if (x.length == 0) return y;
        if (y.length == 0) return x;
        let result = [];
        // Iterate over both sets in parallel, using the middle coordinate
        // system (B in x, A in y) to synchronize.
        for(let iX = 0, iY = 0, curX = x[0], curY = y[0];;){
            if (!curX && !curY) return result;
            else if (curX && (!curY || curX.toB < curY.fromA)) {
                let off = iY ? y[iY - 1].toB - y[iY - 1].toA : 0;
                result.push(off == 0 ? curX : new $9f414dcece7e66a3$export$fb8e829a68c430bd(curX.fromA, curX.toA, curX.fromB + off, curX.toB + off, curX.deleted, curX.inserted));
                curX = iX++ == x.length ? null : x[iX];
            } else if (curY && (!curX || curY.toA < curX.fromB)) {
                let off = iX ? x[iX - 1].toB - x[iX - 1].toA : 0;
                result.push(off == 0 ? curY : new $9f414dcece7e66a3$export$fb8e829a68c430bd(curY.fromA - off, curY.toA - off, curY.fromB, curY.toB, curY.deleted, curY.inserted));
                curY = iY++ == y.length ? null : y[iY];
            } else {
                // The rules for merging ranges are that deletions from the
                // old set and insertions from the new are kept. Areas of the
                // middle document covered by a but not by b are insertions
                // from a that need to be added, and areas covered by b but
                // not a are deletions from b that need to be added.
                let pos = Math.min(curX.fromB, curY.fromA);
                let fromA = Math.min(curX.fromA, curY.fromA - (iX ? x[iX - 1].toB - x[iX - 1].toA : 0)), toA = fromA;
                let fromB = Math.min(curY.fromB, curX.fromB + (iY ? y[iY - 1].toB - y[iY - 1].toA : 0)), toB = fromB;
                let deleted = $9f414dcece7e66a3$export$5f1714a13ed34c01.none, inserted = $9f414dcece7e66a3$export$5f1714a13ed34c01.none;
                // Used to prevent appending ins/del range for the same Change twice
                let enteredX = false, enteredY = false;
                // Need to have an inner loop since any number of further
                // ranges might be touching this group
                for(;;){
                    let nextX = !curX ? 2e8 : pos >= curX.fromB ? curX.toB : curX.fromB;
                    let nextY = !curY ? 2e8 : pos >= curY.fromA ? curY.toA : curY.fromA;
                    let next = Math.min(nextX, nextY);
                    let inX = curX && pos >= curX.fromB, inY = curY && pos >= curY.fromA;
                    if (!inX && !inY) break;
                    if (inX && pos == curX.fromB && !enteredX) {
                        deleted = $9f414dcece7e66a3$export$5f1714a13ed34c01.join(deleted, curX.deleted, combine);
                        toA += curX.lenA;
                        enteredX = true;
                    }
                    if (inX && !inY) {
                        inserted = $9f414dcece7e66a3$export$5f1714a13ed34c01.join(inserted, $9f414dcece7e66a3$export$5f1714a13ed34c01.slice(curX.inserted, pos - curX.fromB, next - curX.fromB), combine);
                        toB += next - pos;
                    }
                    if (inY && pos == curY.fromA && !enteredY) {
                        inserted = $9f414dcece7e66a3$export$5f1714a13ed34c01.join(inserted, curY.inserted, combine);
                        toB += curY.lenB;
                        enteredY = true;
                    }
                    if (inY && !inX) {
                        deleted = $9f414dcece7e66a3$export$5f1714a13ed34c01.join(deleted, $9f414dcece7e66a3$export$5f1714a13ed34c01.slice(curY.deleted, pos - curY.fromA, next - curY.fromA), combine);
                        toA += next - pos;
                    }
                    if (inX && next == curX.toB) {
                        curX = iX++ == x.length ? null : x[iX];
                        enteredX = false;
                    }
                    if (inY && next == curY.toA) {
                        curY = iY++ == y.length ? null : y[iY];
                        enteredY = false;
                    }
                    pos = next;
                }
                if (fromA < toA || fromB < toB) result.push(new $9f414dcece7e66a3$export$fb8e829a68c430bd(fromA, toA, fromB, toB, deleted, inserted));
            }
        }
    }
    /**
    @internal
    */ constructor(/**
    The start of the range deleted/replaced in the old document.
    */ fromA, /**
    The end of the range in the old document.
    */ toA, /**
    The start of the range inserted in the new document.
    */ fromB, /**
    The end of the range in the new document.
    */ toB, /**
    Data associated with the deleted content. The length of these
    spans adds up to `this.toA - this.fromA`.
    */ deleted, /**
    Data associated with the inserted content. Length adds up to
    `this.toB - this.fromB`.
    */ inserted){
        this.fromA = fromA;
        this.toA = toA;
        this.fromB = fromB;
        this.toB = toB;
        this.deleted = deleted;
        this.inserted = inserted;
    }
}
let $9f414dcece7e66a3$var$letter;
// If the runtime support unicode properties in regexps, that's a good
// source of info on whether something is a letter.
try {
    $9f414dcece7e66a3$var$letter = new RegExp("[\\p{Alphabetic}_]", "u");
} catch (_) {}
// Otherwise, we see if the character changes when upper/lowercased,
// or if it is part of these common single-case scripts.
const $9f414dcece7e66a3$var$nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
function $9f414dcece7e66a3$var$isLetter(code) {
    if (code < 128) return code >= 48 && code <= 57 || code >= 65 && code <= 90 || code >= 79 && code <= 122;
    let ch = String.fromCharCode(code);
    if ($9f414dcece7e66a3$var$letter) return $9f414dcece7e66a3$var$letter.test(ch);
    return ch.toUpperCase() != ch.toLowerCase() || $9f414dcece7e66a3$var$nonASCIISingleCaseWordChar.test(ch);
}
// Convert a range of document into a string, so that we can easily
// access characters at a given position. Treat non-text tokens as
// spaces so that they aren't considered part of a word.
function $9f414dcece7e66a3$var$getText(frag, start, end) {
    let out = "";
    function convert(frag, start, end) {
        for(let i = 0, off = 0; i < frag.childCount; i++){
            let child = frag.child(i), endOff = off + child.nodeSize;
            let from = Math.max(off, start), to = Math.min(endOff, end);
            if (from < to) {
                if (child.isText) out += child.text.slice(Math.max(0, start - off), Math.min(child.text.length, end - off));
                else if (child.isLeaf) out += " ";
                else {
                    if (from == off) out += " ";
                    convert(child.content, Math.max(0, from - off - 1), Math.min(child.content.size, end - off));
                    if (to == endOff) out += " ";
                }
            }
            off = endOff;
        }
    }
    convert(frag, start, end);
    return out;
}
// The distance changes have to be apart for us to not consider them
// candidates for merging.
const $9f414dcece7e66a3$var$MAX_SIMPLIFY_DISTANCE = 30;
/**
Simplifies a set of changes for presentation. This makes the
assumption that having both insertions and deletions within a word
is confusing, and, when such changes occur without a word boundary
between them, they should be expanded to cover the entire set of
words (in the new document) they touch. An exception is made for
single-character replacements.
*/ function $9f414dcece7e66a3$export$eaf5c9077675701a(changes, doc) {
    let result = [];
    for(let i = 0; i < changes.length; i++){
        let end = changes[i].toB, start = i;
        while(i < changes.length - 1 && changes[i + 1].fromB <= end + $9f414dcece7e66a3$var$MAX_SIMPLIFY_DISTANCE)end = changes[++i].toB;
        $9f414dcece7e66a3$var$simplifyAdjacentChanges(changes, start, i + 1, doc, result);
    }
    return result;
}
function $9f414dcece7e66a3$var$simplifyAdjacentChanges(changes, from, to, doc, target) {
    let start = Math.max(0, changes[from].fromB - $9f414dcece7e66a3$var$MAX_SIMPLIFY_DISTANCE);
    let end = Math.min(doc.content.size, changes[to - 1].toB + $9f414dcece7e66a3$var$MAX_SIMPLIFY_DISTANCE);
    let text = $9f414dcece7e66a3$var$getText(doc.content, start, end);
    for(let i = from; i < to; i++){
        let startI = i, last = changes[i], deleted = last.lenA, inserted = last.lenB;
        while(i < to - 1){
            let next = changes[i + 1], boundary = false;
            let prevLetter = last.toB == end ? false : $9f414dcece7e66a3$var$isLetter(text.charCodeAt(last.toB - 1 - start));
            for(let pos = last.toB; !boundary && pos < next.fromB; pos++){
                let nextLetter = pos == end ? false : $9f414dcece7e66a3$var$isLetter(text.charCodeAt(pos - start));
                if ((!prevLetter || !nextLetter) && pos != changes[startI].fromB) boundary = true;
                prevLetter = nextLetter;
            }
            if (boundary) break;
            deleted += next.lenA;
            inserted += next.lenB;
            last = next;
            i++;
        }
        if (inserted > 0 && deleted > 0 && !(inserted == 1 && deleted == 1)) {
            let from = changes[startI].fromB, to = changes[i].toB;
            if (from < end && $9f414dcece7e66a3$var$isLetter(text.charCodeAt(from - start))) while(from > start && $9f414dcece7e66a3$var$isLetter(text.charCodeAt(from - 1 - start)))from--;
            if (to > start && $9f414dcece7e66a3$var$isLetter(text.charCodeAt(to - 1 - start))) while(to < end && $9f414dcece7e66a3$var$isLetter(text.charCodeAt(to - start)))to++;
            let joined = $9f414dcece7e66a3$var$fillChange(changes.slice(startI, i + 1), from, to);
            let last = target.length ? target[target.length - 1] : null;
            if (last && last.toA == joined.fromA) target[target.length - 1] = new $9f414dcece7e66a3$export$fb8e829a68c430bd(last.fromA, joined.toA, last.fromB, joined.toB, last.deleted.concat(joined.deleted), last.inserted.concat(joined.inserted));
            else target.push(joined);
        } else for(let j = startI; j <= i; j++)target.push(changes[j]);
    }
    return changes;
}
function $9f414dcece7e66a3$var$combine(a, b) {
    return a === b ? a : null;
}
function $9f414dcece7e66a3$var$fillChange(changes, fromB, toB) {
    let fromA = changes[0].fromA - (changes[0].fromB - fromB);
    let last = changes[changes.length - 1];
    let toA = last.toA + (toB - last.toB);
    let deleted = $9f414dcece7e66a3$export$5f1714a13ed34c01.none, inserted = $9f414dcece7e66a3$export$5f1714a13ed34c01.none;
    let delData = (changes[0].deleted.length ? changes[0].deleted : changes[0].inserted)[0].data;
    let insData = (changes[0].inserted.length ? changes[0].inserted : changes[0].deleted)[0].data;
    for(let posA = fromA, posB = fromB, i = 0;; i++){
        let next = i == changes.length ? null : changes[i];
        let endA = next ? next.fromA : toA, endB = next ? next.fromB : toB;
        if (endA > posA) deleted = $9f414dcece7e66a3$export$5f1714a13ed34c01.join(deleted, [
            new $9f414dcece7e66a3$export$5f1714a13ed34c01(endA - posA, delData)
        ], $9f414dcece7e66a3$var$combine);
        if (endB > posB) inserted = $9f414dcece7e66a3$export$5f1714a13ed34c01.join(inserted, [
            new $9f414dcece7e66a3$export$5f1714a13ed34c01(endB - posB, insData)
        ], $9f414dcece7e66a3$var$combine);
        if (!next) break;
        deleted = $9f414dcece7e66a3$export$5f1714a13ed34c01.join(deleted, next.deleted, $9f414dcece7e66a3$var$combine);
        inserted = $9f414dcece7e66a3$export$5f1714a13ed34c01.join(inserted, next.inserted, $9f414dcece7e66a3$var$combine);
        if (deleted.length) delData = deleted[deleted.length - 1].data;
        if (inserted.length) insData = inserted[inserted.length - 1].data;
        posA = next.toA;
        posB = next.toB;
    }
    return new $9f414dcece7e66a3$export$fb8e829a68c430bd(fromA, toA, fromB, toB, deleted, inserted);
}
/**
A change set tracks the changes to a document from a given point
in the past. It condenses a number of step maps down to a flat
sequence of replacements, and simplifies replacments that
partially undo themselves by comparing their content.
*/ class $9f414dcece7e66a3$export$29d7fbdcb1f8b71c {
    /**
    Computes a new changeset by adding the given step maps and
    metadata (either as an array, per-map, or as a single value to be
    associated with all maps) to the current set. Will not mutate the
    old set.
    
    Note that due to simplification that happens after each add,
    incrementally adding steps might create a different final set
    than adding all those changes at once, since different document
    tokens might be matched during simplification depending on the
    boundaries of the current changed ranges.
    */ addSteps(newDoc, maps, data) {
        // This works by inspecting the position maps for the changes,
        // which indicate what parts of the document were replaced by new
        // content, and the size of that new content. It uses these to
        // build up Change objects.
        //
        // These change objects are put in sets and merged together using
        // Change.merge, giving us the changes created by the new steps.
        // Those changes can then be merged with the existing set of
        // changes.
        //
        // For each change that was touched by the new steps, we recompute
        // a diff to try to minimize the change by dropping matching
        // pieces of the old and new document from the change.
        let stepChanges = [];
        // Add spans for new steps.
        for(let i = 0; i < maps.length; i++){
            let d = Array.isArray(data) ? data[i] : data;
            let off = 0;
            maps[i].forEach((fromA, toA, fromB, toB)=>{
                stepChanges.push(new $9f414dcece7e66a3$export$fb8e829a68c430bd(fromA + off, toA + off, fromB, toB, fromA == toA ? $9f414dcece7e66a3$export$5f1714a13ed34c01.none : [
                    new $9f414dcece7e66a3$export$5f1714a13ed34c01(toA - fromA, d)
                ], fromB == toB ? $9f414dcece7e66a3$export$5f1714a13ed34c01.none : [
                    new $9f414dcece7e66a3$export$5f1714a13ed34c01(toB - fromB, d)
                ]));
                off = toB - fromB - (toA - fromA);
            });
        }
        if (stepChanges.length == 0) return this;
        let newChanges = $9f414dcece7e66a3$var$mergeAll(stepChanges, this.config.combine);
        let changes = $9f414dcece7e66a3$export$fb8e829a68c430bd.merge(this.changes, newChanges, this.config.combine);
        let updated = changes;
        // Minimize changes when possible
        for(let i = 0; i < updated.length; i++){
            let change = updated[i];
            if (change.fromA == change.toA || change.fromB == change.toB || // Only look at changes that touch newly added changed ranges
            !newChanges.some((r)=>r.toB > change.fromB && r.fromB < change.toB)) continue;
            let diff = $9f414dcece7e66a3$var$computeDiff(this.config.doc.content, newDoc.content, change, this.config.encoder);
            // Fast path: If they are completely different, don't do anything
            if (diff.length == 1 && diff[0].fromB == 0 && diff[0].toB == change.toB - change.fromB) continue;
            if (updated == changes) updated = changes.slice();
            if (diff.length == 1) updated[i] = diff[0];
            else {
                updated.splice(i, 1, ...diff);
                i += diff.length - 1;
            }
        }
        return new $9f414dcece7e66a3$export$29d7fbdcb1f8b71c(this.config, updated);
    }
    /**
    The starting document of the change set.
    */ get startDoc() {
        return this.config.doc;
    }
    /**
    Map the span's data values in the given set through a function
    and construct a new set with the resulting data.
    */ map(f) {
        let mapSpan = (span)=>{
            let newData = f(span);
            return newData === span.data ? span : new $9f414dcece7e66a3$export$5f1714a13ed34c01(span.length, newData);
        };
        return new $9f414dcece7e66a3$export$29d7fbdcb1f8b71c(this.config, this.changes.map((ch)=>{
            return new $9f414dcece7e66a3$export$fb8e829a68c430bd(ch.fromA, ch.toA, ch.fromB, ch.toB, ch.deleted.map(mapSpan), ch.inserted.map(mapSpan));
        }));
    }
    /**
    Compare two changesets and return the range in which they are
    changed, if any. If the document changed between the maps, pass
    the maps for the steps that changed it as second argument, and
    make sure the method is called on the old set and passed the new
    set. The returned positions will be in new document coordinates.
    */ changedRange(b, maps) {
        if (b == this) return null;
        let touched = maps && $9f414dcece7e66a3$var$touchedRange(maps);
        let moved = touched ? touched.toB - touched.fromB - (touched.toA - touched.fromA) : 0;
        function map(p) {
            return !touched || p <= touched.fromA ? p : p + moved;
        }
        let from = touched ? touched.fromB : 2e8, to = touched ? touched.toB : -200000000;
        function add(start, end = start) {
            from = Math.min(start, from);
            to = Math.max(end, to);
        }
        let rA = this.changes, rB = b.changes;
        for(let iA = 0, iB = 0; iA < rA.length && iB < rB.length;){
            let rangeA = rA[iA], rangeB = rB[iB];
            if (rangeA && rangeB && $9f414dcece7e66a3$var$sameRanges(rangeA, rangeB, map)) {
                iA++;
                iB++;
            } else if (rangeB && (!rangeA || map(rangeA.fromB) >= rangeB.fromB)) {
                add(rangeB.fromB, rangeB.toB);
                iB++;
            } else {
                add(map(rangeA.fromB), map(rangeA.toB));
                iA++;
            }
        }
        return from <= to ? {
            from: from,
            to: to
        } : null;
    }
    /**
    Create a changeset with the given base object and configuration.
    
    The `combine` function is used to compare and combine metadata—it
    should return null when metadata isn't compatible, and a combined
    version for a merged range when it is.
    
    When given, a token encoder determines how document tokens are
    serialized and compared when diffing the content produced by
    changes. The default is to just compare nodes by name and text
    by character, ignoring marks and attributes.
    */ static create(doc, combine = (a, b)=>a === b ? a : null, tokenEncoder = $9f414dcece7e66a3$var$DefaultEncoder) {
        return new $9f414dcece7e66a3$export$29d7fbdcb1f8b71c({
            combine: combine,
            doc: doc,
            encoder: tokenEncoder
        }, []);
    }
    /**
    @internal
    */ constructor(/**
    @internal
    */ config, /**
    Replaced regions.
    */ changes){
        this.config = config;
        this.changes = changes;
    }
}
/**
Exported for testing @internal
*/ $9f414dcece7e66a3$export$29d7fbdcb1f8b71c.computeDiff = $9f414dcece7e66a3$var$computeDiff;
// Divide-and-conquer approach to merging a series of ranges.
function $9f414dcece7e66a3$var$mergeAll(ranges, combine, start = 0, end = ranges.length) {
    if (end == start + 1) return [
        ranges[start]
    ];
    let mid = start + end >> 1;
    return $9f414dcece7e66a3$export$fb8e829a68c430bd.merge($9f414dcece7e66a3$var$mergeAll(ranges, combine, start, mid), $9f414dcece7e66a3$var$mergeAll(ranges, combine, mid, end), combine);
}
function $9f414dcece7e66a3$var$endRange(maps) {
    let from = 2e8, to = -200000000;
    for(let i = 0; i < maps.length; i++){
        let map = maps[i];
        if (from != 2e8) {
            from = map.map(from, -1);
            to = map.map(to, 1);
        }
        map.forEach((_s, _e, start, end)=>{
            from = Math.min(from, start);
            to = Math.max(to, end);
        });
    }
    return from == 2e8 ? null : {
        from: from,
        to: to
    };
}
function $9f414dcece7e66a3$var$touchedRange(maps) {
    let b = $9f414dcece7e66a3$var$endRange(maps);
    if (!b) return null;
    let a = $9f414dcece7e66a3$var$endRange(maps.map((m)=>m.invert()).reverse());
    return {
        fromA: a.from,
        toA: a.to,
        fromB: b.from,
        toB: b.to
    };
}
function $9f414dcece7e66a3$var$sameRanges(a, b, map) {
    return map(a.fromB) == b.fromB && map(a.toB) == b.toB && $9f414dcece7e66a3$var$sameSpans(a.deleted, b.deleted) && $9f414dcece7e66a3$var$sameSpans(a.inserted, b.inserted);
}
function $9f414dcece7e66a3$var$sameSpans(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (a[i].length != b[i].length || a[i].data !== b[i].data) return false;
    return true;
}
module.exports["simplifyChanges"] = $9f414dcece7e66a3$export$eaf5c9077675701a;
module.exports["ChangeSet"] = $9f414dcece7e66a3$export$29d7fbdcb1f8b71c;

});

parcelRegister("gUfAY", function(module, exports) {
class $7a3ffdfa423ddc95$export$e38ee16b142fca71 {
    updateDocument() {}
    onRestore() {}
    onStepsAdded() {}
    onStepRejectedError() {}
    send() {}
    sendStepsFromCurrentState() {}
    throttledCatchupv2() {}
    getCurrentState() {
        return Promise.resolve({});
    }
    getFinalAcknowledgedState(reason) {
        return Promise.resolve({});
    }
    getIsNamespaceLocked() {
        return false;
    }
    getUnconfirmedSteps() {
        return undefined;
    }
    getUnconfirmedStepsOrigins() {
        return undefined;
    }
    getCurrentPmVersion() {
        return -1;
    }
    constructor(){
        this.setup = ()=>{
            return this;
        };
        this.onErrorHandled = ()=>{};
    }
}
module.exports["NullDocumentService"] = $7a3ffdfa423ddc95$export$e38ee16b142fca71;

});

parcelRegister("6s3KO", function(module, exports) {

var $g4l86 = parcelRequire("g4l86");

const $e2aa91feb09c3d99$var$logger = (0, $g4l86.createLogger)('Provider', 'orange');
class $e2aa91feb09c3d99$export$a3879ef7b3971bae {
    constructor(isNamespaceLocked = false){
        this.isNamespaceLocked = isNamespaceLocked;
        // Primitive values are always copied
        this.getIsNamespaceLocked = ()=>this.isNamespaceLocked;
        /**
     * ESS-2916 namespace status event- lock/unlock
     */ // Ignored via go/ees005
        // eslint-disable-next-line require-await
        this.onNamespaceStatusChanged = async ({ isLocked: isLocked, waitTimeInMs: waitTimeInMs, timestamp: timestamp })=>{
            const start = Date.now();
            $e2aa91feb09c3d99$var$logger(`Received a namespace status changed event `, {
                isLocked: isLocked,
                waitTimeInMs: waitTimeInMs,
                timestamp: timestamp
            });
            if (isLocked && waitTimeInMs) {
                this.isNamespaceLocked = true;
                $e2aa91feb09c3d99$var$logger(`Received a namespace status change event `, {
                    isLocked: isLocked
                });
                // To protect the collab editing process from locked out due to BE
                setTimeout(()=>{
                    $e2aa91feb09c3d99$var$logger(`The namespace lock has expired`, {
                        waitTime: Date.now() - start,
                        timestamp: timestamp
                    });
                    this.isNamespaceLocked = false;
                }, waitTimeInMs);
                return;
            }
            this.isNamespaceLocked = false;
            $e2aa91feb09c3d99$var$logger(`The page lock has expired`);
        };
    }
}
module.exports["NamespaceService"] = $e2aa91feb09c3d99$export$a3879ef7b3971bae;

});

parcelRegister("5x7ii", function(module, exports) {

var $1Gjof = parcelRequire("1Gjof");


var $J4uEo = parcelRequire("J4uEo");


var $lncF6 = parcelRequire("lncF6");


var $eDnTv = parcelRequire("eDnTv");


var $jaIJZ = parcelRequire("jaIJZ");


var $g4l86 = parcelRequire("g4l86");

const $1af1d2f3bcb6be37$var$logger = (0, $g4l86.createLogger)('PresenceService', 'pink');
const $1af1d2f3bcb6be37$var$SEND_PRESENCE_INTERVAL = 150000; // 150 seconds
const $1af1d2f3bcb6be37$var$DEFAULT_FETCH_USERS_INTERVAL = 500; // 0.5 second
const $1af1d2f3bcb6be37$var$UNIDENTIFIED = 'unidentified';
const $1af1d2f3bcb6be37$export$b293c70097dddf3c = 'single';
const $1af1d2f3bcb6be37$export$e39d952916d6fd50 = 'collab';
class $1af1d2f3bcb6be37$export$b15b55f2d386264 {
    /**
   * Called on receiving steps, emits each step's telepointer
   * @param steps Steps to extract telepointers from
   * @example
   */ emitTelepointersFromSteps(steps) {
        steps.forEach((step)=>{
            const event = (0, $lncF6.telepointerFromStep)(this.participantsState.getParticipants(), step);
            if (event) this.emitTelepointer(event, 'emitting telepointers from steps');
        });
    }
    /**
   * Wrapper function to emit with error handling and analytics
   * @param data Data to emit
   * @param errorMessage Error message for analytics
   * @example
   */ emitPresenceActivityChange(data, errorMessage) {
        try {
            this.emit('presence:changed', data);
        } catch (error) {
            // We don't want to throw errors for Presence features as they tend to self-restore
            this.analyticsHelper?.sendErrorEvent(error, `Error while ${errorMessage}`);
        }
    }
    /**
   * constructor
   *
   * @param analyticsHelper
   * @param participantsState
   * @param emit
   * @param getUser
   * @param batchProps
   * @param channelBroadcast
   * @param sendPresenceJoined
   * @param getPresenceData
   * @param setUserId
   * @param getAIProviderActiveIds
   * @param fetchAnonymousAsset
   * @example
   */ constructor(analyticsHelper, participantsState, emit, getUser, batchProps, channelBroadcast, sendPresenceJoined, getPresenceData, setUserId, getAIProviderActiveIds, fetchAnonymousAsset){
        this.analyticsHelper = analyticsHelper;
        this.emit = emit;
        this.getUser = getUser;
        this.batchProps = batchProps;
        this.channelBroadcast = channelBroadcast;
        this.sendPresenceJoined = sendPresenceJoined;
        this.getPresenceData = getPresenceData;
        this.setUserId = setUserId;
        this.getAIProviderActiveIds = getAIProviderActiveIds;
        this.fetchAnonymousAsset = fetchAnonymousAsset;
        this.participantUpdateTimeout = void 0;
        this.presenceUpdateTimeout = void 0;
        this.presenceFetchTimeout = void 0;
        this.currentlyPollingFetchUsers = true;
        this.hasBatchFetchError = false;
        // Initialized in the constructor body; declared here so the parameter
        // can be optional without requiring the type to include `undefined`
        // (avoids TS9025 under `--isolatedDeclarations`).
        this.participantsState = void 0;
        this.sendPresenceActivityChanged = ()=>{
            this.sendPresence();
        };
        this.sendAIProviderChanged = (payload)=>{
            if (payload.providerId) {
                for(const propKey in payload.permit)if (payload.permit.hasOwnProperty(propKey)) payload.permit[propKey] = false;
                const presencePayload = this.buildAIProviderPresencePayload(payload.providerId);
                if (payload.action === 'add') this.sendAIProviderParticipantUpdated(presencePayload);
                else if (payload.action === 'remove') this.sendAIProviderParticipantLeft(presencePayload);
            }
        };
        this.buildAIProviderPresencePayload = (providerId)=>{
            const defaultPresenceData = this.getPresenceData();
            const presencePayload = {
                sessionId: `${providerId}::${defaultPresenceData.sessionId}`,
                userId: providerId,
                clientId: `${providerId}::${defaultPresenceData.clientId}`,
                permit: {
                    isPermittedToComment: false,
                    isPermittedToEdit: false,
                    isPermittedToView: false
                },
                timestamp: Date.now()
            };
            return presencePayload;
        };
        this.sendAIProviderParticipantUpdated = (payload)=>{
            this.channelBroadcast('participant:updated', payload);
        };
        this.sendAIProviderParticipantLeft = (payload)=>{
            this.channelBroadcast('participant:left', payload);
        };
        // Refresh current AI providers
        this.sendAIProvidersPresence = ()=>{
            if (this.getAIProviderActiveIds) this.getAIProviderActiveIds().forEach((aiProviderId)=>{
                const presenceData = this.buildAIProviderPresencePayload(aiProviderId);
                this.sendAIProviderParticipantUpdated(presenceData);
            });
        };
        this.hasPresenceActivityChanged = (previous, current)=>{
            return previous.presenceActivity !== current.presenceActivity;
        };
        this.handleAnonymousUser = async (payload)=>{
            const { sessionId: sessionId } = payload;
            const previousParticipant = this.participantsState.getBySessionId(sessionId);
            let asset;
            let name = previousParticipant?.name ?? '';
            if (!previousParticipant && this.fetchAnonymousAsset) {
                try {
                    asset = await this.fetchAnonymousAsset(payload.presenceId);
                } catch (error) {
                    this.analyticsHelper?.sendErrorEvent(error, 'Error while fetching anonymous assets');
                }
                name = asset?.name ?? name;
            }
            const participant = {
                ...payload,
                lastActive: payload.timestamp,
                name: name,
                avatar: previousParticipant?.avatar ?? asset?.src ?? '',
                email: '',
                userId: $1af1d2f3bcb6be37$var$UNIDENTIFIED,
                isHydrated: true
            };
            this.participantsState.setBySessionId(sessionId, participant);
            this.emitPresence({
                joined: [
                    participant
                ]
            }, 'handling updated anonymous participant');
        };
        /**
     * Carries out 3 things: 1) enriches the participant with user data, 2) updates the participantsState, 3) emits the presence event
     * @param payload Payload from incoming socket event
     * @example
     */ this.updateParticipantEager = async (payload)=>{
            const { userId: userId } = payload;
            if (!userId || userId === $1af1d2f3bcb6be37$var$UNIDENTIFIED) {
                await this.handleAnonymousUser(payload);
                return;
            }
            let participant;
            // getUser is a failable callback, hence try-catch
            try {
                participant = await (0, $eDnTv.createParticipantFromPayload)(// userId _must_ be defined, this lets the compiler know
                {
                    ...payload,
                    userId: userId
                }, this.getUser);
            } catch (error) {
                // We don't want to throw errors for Presence features as they tend to self-restore
                this.analyticsHelper?.sendErrorEvent(error, 'Error while enriching participant');
            }
            if (!participant) return;
            const previousParticipant = this.participantsState.getBySessionId(participant.sessionId);
            this.participantsState.setBySessionId(participant.sessionId, participant);
            if (previousParticipant) {
                if (this.hasPresenceActivityChanged(previousParticipant, participant)) this.emitPresenceActivityChange({
                    type: 'participant:activity',
                    activity: participant.presenceActivity
                }, 'handling participant activity changed event');
                return;
            }
            // Only emit the joined presence event if this is a new participant
            this.emitPresence({
                joined: [
                    participant
                ]
            }, 'handling participant updated event');
        };
        /**
     * Will update participant state without attempting to hydrate the participant, which is handled in {@link #batchFetchUsers}
     * Here's the TLDR of what this method handles
     *
     * 1. If participant that joined is anonymous, update state, emit event and return
     * 2. If incoming participant is new, update state and emit event
     * 3. If incoming participant is not new, update previous state with new values (timestamp, activity)
     *
     * @param payload Payload from incoming socket event
     * @example
     */ this.updateParticipantLazy = async (payload)=>{
            const { userId: userId, sessionId: sessionId } = payload;
            // anonymous users always skip hydration but are marked as hydrated since we don't want to attempt to fetch data
            // this can cause interesting behavior if batchProps.participantsLimit exists
            // for example if limit = 5 and we've hydrated 5 real users and 2 anonymous users join, it'll look like we've hydrated 7 users
            if (!userId || userId === $1af1d2f3bcb6be37$var$UNIDENTIFIED) {
                await this.handleAnonymousUser(payload);
                return;
            }
            const previousParticipant = this.participantsState.getBySessionId(sessionId);
            if (!previousParticipant) {
                const participant = {
                    ...payload,
                    lastActive: payload.timestamp,
                    name: '',
                    avatar: '',
                    email: '',
                    userId: userId
                };
                this.participantsState.setBySessionId(sessionId, participant);
                if ((0, $g4l86.isAIProviderID)(userId)) {
                    this.emitPresence({
                        joined: [
                            participant
                        ]
                    }, 'handling updated new agent lazy');
                    return;
                }
                // prevent running multiple debounces concurrently
                if (!this.currentlyPollingFetchUsers) this.batchFetchUsers();
                // while this doesn't completely eliminate extra events from firing, it does help reduce it.
                // batchFetchUsers will always emitPresence when no participantsLimit is present;
                // however, if the limit has been reached, we need to ensure we emit the joined participants
                // current alternatives to this logic would add even more complexity
                if (this.batchProps?.participantsLimit) this.emitPresence({
                    joined: [
                        participant
                    ]
                }, 'handling updated new participant lazy');
                return;
            }
            // would handle activity and lastActive changes
            const participant = {
                ...previousParticipant,
                presenceActivity: payload.presenceActivity,
                lastActive: payload.timestamp
            };
            if (this.hasPresenceActivityChanged(previousParticipant, participant)) {
                this.participantsState.setBySessionId(sessionId, participant);
                this.emitPresenceActivityChange({
                    type: 'participant:activity',
                    activity: participant.presenceActivity
                }, 'handling participant activity changed event');
            }
            return;
        };
        this.onParticipantUpdated = async (payload)=>{
            if (this.batchProps) this.updateParticipantLazy(payload);
            else await this.updateParticipantEager(payload);
        };
        /**
     * Called when a participant leaves the session.
     * We emit the `presence` event to update the active avatars in the editor.
     * @param payload
     * @example
     */ this.onParticipantLeft = (payload)=>{
            let sessionId = payload.sessionId;
            // When an agent leaves a session, the backend service returns the original user's
            // session ID accompanied by a payload containing the agent's session ID.
            // If the user session leaves, we also want to remove all agent sessions associated.
            if (payload?.data?.sessionId && (0, $g4l86.isAIProviderID)(payload.data.sessionId)) sessionId = payload.data.sessionId;
            else {
                const associatedAgents = this.getAIProviderParticipants().filter((ap)=>ap.sessionId.endsWith(sessionId));
                associatedAgents.forEach((agent)=>{
                    this.onParticipantLeft({
                        sessionId: sessionId,
                        timestamp: payload.timestamp,
                        data: agent,
                        userId: undefined,
                        clientId: ''
                    });
                });
            }
            this.participantsState.removeBySessionId(sessionId);
            this.emitPresence({
                left: [
                    {
                        sessionId: sessionId
                    }
                ]
            }, 'participant leaving');
        };
        this.disconnect = (reason, sessionId)=>{
            const left = this.participantsState.getParticipants();
            this.participantsState.clear();
            try {
                this.emit('disconnected', {
                    reason: (0, $1Gjof.disconnectedReasonMapper)(reason),
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    sid: sessionId
                });
            } catch (error) {
                // We don't want to throw errors for Presence features as they tend to self-restore
                this.analyticsHelper?.sendErrorEvent(error, 'Error while emitting disconnected data');
            }
            if (left.length) this.emitPresence({
                left: left
            }, 'emitting presence update on disconnect');
        };
        /**
     * Updates when users were last active
     * @param userIds Users in most recent steps
     * @example
     */ this.updateLastActive = (userIds = [])=>this.participantsState.updateLastActive(Date.now(), userIds);
        /**
     * Called when we receive a telepointer update from another
     * participant.
     * @param payload
     * @param thisSessionId
     * @example
     */ this.onParticipantTelepointer = (payload, thisSessionId)=>{
            const { sessionId: sessionId, selection: selection, timestamp: timestamp } = payload;
            const participant = this.participantsState.getBySessionId(sessionId);
            if (sessionId === thisSessionId || // Ignore old telepointer events
            participant && participant.lastActive > timestamp) return;
            const userId = payload.userId ? [
                payload.userId
            ] : undefined;
            // Set last active
            this.updateLastActive(userId);
            this.emitTelepointer({
                type: 'telepointer',
                selection: selection,
                sessionId: sessionId
            }, 'handling participant telepointer event');
        };
        /**
     * Every 5 minutes (PARTICIPANT_UPDATE_INTERVAL), removes inactive participants and emits the update to other participants.
     * Needs to be kicked off in the Provider.
     * @param sessionId SessionId from provider's connection
     * @example
     */ this.startInactiveRemover = (sessionId)=>{
            clearTimeout(this.participantUpdateTimeout);
            try {
                this.filterInactive(sessionId);
            } catch (err) {
                this.analyticsHelper?.sendErrorEvent(err, 'Failed filtering inactive participants');
            }
            this.participantUpdateTimeout = window.setTimeout(()=>this.startInactiveRemover(sessionId), (0, $eDnTv.PARTICIPANT_UPDATE_INTERVAL));
        };
        this.enrichParticipants = async (props)=>{
            try {
                const participants = await (0, $eDnTv.fetchParticipants)(this.participantsState, props);
                if (participants.length) this.emitPresence({
                    joined: participants
                }, 'handling participant updated event');
            } catch (err) {
                props.onError?.(err);
                this.hasBatchFetchError = true;
                this.analyticsHelper?.sendErrorEvent(err, 'Failed while fetching participants');
            }
        };
        /**
     * a debounce so we can wait until participants join before hydrating the user and perform batch calls in a timely manner.
     *
     * if {@link BatchProps#participantsLimit} is supplied
     *  1. Fetch users until we've reached the participantsLimit
     *  2. If there are no more participants to hydrate and we haven't reached the participantsLimit, stop polling
     *  3. If we've reached our participantLimit, stop polling
     *
     * if no {@link BatchProps#participantsLimit} is supplied
     *  1. Fetch users until there are no more participants to hydrate
     * @example
     */ this.batchFetchUsers = async ()=>{
            if (!this.batchProps) return;
            if (this.hasBatchFetchError) {
                // no retry logic yet
                $1af1d2f3bcb6be37$var$logger('Cannot continue to fetch users due to fetch error');
                clearTimeout(this.presenceFetchTimeout);
                return;
            }
            this.currentlyPollingFetchUsers = true;
            clearTimeout(this.presenceFetchTimeout);
            const { debounceTime: debounceTime, participantsLimit: participantsLimit } = this.batchProps;
            if (participantsLimit) {
                const size = this.participantsState.getUniqueParticipants({
                    isHydrated: true
                }).length;
                if (size < participantsLimit) {
                    await this.enrichParticipants({
                        ...this.batchProps,
                        batchSize: participantsLimit
                    });
                    this.currentlyPollingFetchUsers = this.participantsState.hasMoreParticipantsToHydrate();
                } else this.currentlyPollingFetchUsers = false;
            } else if (!participantsLimit) {
                await this.enrichParticipants(this.batchProps);
                this.currentlyPollingFetchUsers = this.participantsState.hasMoreParticipantsToHydrate();
            }
            if (this.currentlyPollingFetchUsers) this.presenceFetchTimeout = window.setTimeout(()=>this.batchFetchUsers(), debounceTime ?? $1af1d2f3bcb6be37$var$DEFAULT_FETCH_USERS_INTERVAL);
        };
        /**
     * We want to give some time for users to initially join before attempting to fetch users
     * otherwise we'll always make at least 2 calls if there's more than 1 participant
     * @example
     */ this.initializeFirstBatchFetchUsers = async ()=>{
            await new Promise((r)=>window.setTimeout(r, this.batchProps?.debounceTime ?? $1af1d2f3bcb6be37$var$DEFAULT_FETCH_USERS_INTERVAL));
            this.batchFetchUsers();
        };
        /**
     * Keep list of participants up to date. Filter out inactive users etc.
     * @param sessionId
     * @example
     */ this.filterInactive = (sessionId)=>{
            const now = Date.now();
            const left = this.participantsState.getParticipants().filter((p)=>p.sessionId !== sessionId && now - p.lastActive > (0, $eDnTv.PARTICIPANT_UPDATE_INTERVAL));
            left.forEach((p)=>this.participantsState.removeBySessionId(p.sessionId));
            left.length && this.emitPresence({
                left: left
            }, 'filtering inactive participants');
        };
        /**
     * Wrapper function to emit with error handling and analytics
     * @param data Data to emit
     * @param emit Emit function from Provider
     * @param errorMessage
     * @example
     */ this.emitPresence = (data, errorMessage)=>{
            try {
                this.emit('presence', data);
                this.analyticsHelper?.sendActionEvent((0, $J4uEo.EVENT_ACTION).UPDATE_PARTICIPANTS, (0, $J4uEo.EVENT_STATUS).SUCCESS, {
                    participants: this.participantsState.size()
                });
            } catch (error) {
                // We don't want to throw errors for Presence features as they tend to self-restore
                this.analyticsHelper?.sendErrorEvent(error, `Error while ${errorMessage}`);
            }
        };
        /**
     * Wrapper function to emit with error handling and analytics
     * @param data Data to emit
     * @param emit Emit function from Provider
     * @param errorMessage
     * @example
     */ this.emitTelepointer = (data, errorMessage)=>{
            try {
                this.emit('telepointer', data);
            } catch (error) {
                // We don't want to throw errors for Presence features as they tend to self-restore
                this.analyticsHelper?.sendErrorEvent(error, `Error while ${errorMessage}`);
            }
        };
        /**
     * Used when the provider is disconnected or destroyed to prevent perpetual timers from continuously running
     * @example
     */ this.clearTimers = ()=>{
            clearTimeout(this.participantUpdateTimeout);
            clearTimeout(this.presenceFetchTimeout);
        };
        this.sendPresence = ()=>{
            try {
                clearTimeout(this.presenceUpdateTimeout);
                const data = this.getPresenceData();
                this.channelBroadcast('participant:updated', data);
                this.presenceUpdateTimeout = window.setTimeout(()=>this.sendPresence(), $1af1d2f3bcb6be37$var$SEND_PRESENCE_INTERVAL);
                // Expose existing AI providers to the newly joined user
                this.sendAIProvidersPresence();
            } catch (error) {
                // We don't want to throw errors for Presence features as they tend to self-restore
                this.analyticsHelper?.sendErrorEvent(error, 'Error while sending presence');
            }
        };
        /**
     * Called when a participant joins the session.
     *
     * We keep track of participants internally, and emit the `presence` event to update
     * the active avatars in the editor.
     * This method will be triggered from backend to notify all participants to exchange presence
     * @param payload
     * @example
     */ this.onPresenceJoined = (payload)=>{
            try {
                $1af1d2f3bcb6be37$var$logger('Participant joined with session: ', payload.sessionId);
                // This expose existing users to the newly joined user
                this.sendPresence();
            } catch (error) {
                // We don't want to throw errors for Presence features as they tend to self-restore
                this.analyticsHelper?.sendErrorEvent(error, 'Error while joining presence');
            }
        };
        /**
     * Called when the current user joins the session.
     *
     * This will send both a 'presence' event and a 'participant:updated' event.
     * This updates both the avatars and the participants list.
     * @param payload
     * @example
     */ this.onPresence = (payload)=>{
            try {
                $1af1d2f3bcb6be37$var$logger('onPresence userId: ', payload.userId);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.setUserId(payload.userId);
                this.sendPresence();
                this.sendPresenceJoined();
            } catch (error) {
                // We don't want to throw errors for Presence features as they tend to self-restore
                this.analyticsHelper?.sendErrorEvent(error, 'Error while receiving presence');
            }
        };
        this.getParticipants = ()=>{
            return this.participantsState.getParticipants();
        };
        this.getUniqueParticipantSize = ()=>{
            return this.participantsState.getUniqueParticipantSize();
        };
        this.getUniqueParticipants = (filter)=>{
            return this.participantsState.getUniqueParticipants(filter);
        };
        this.getAIProviderParticipants = ()=>{
            return this.participantsState.getAIProviderParticipants();
        };
        this.getCollabMode = ()=>{
            return this.participantsState.size() > 1 ? $1af1d2f3bcb6be37$export$e39d952916d6fd50 : $1af1d2f3bcb6be37$export$b293c70097dddf3c;
        };
        this.participantsState = participantsState ?? new (0, $jaIJZ.ParticipantsState)();
    }
}
module.exports["ParticipantsService"] = $1af1d2f3bcb6be37$export$b15b55f2d386264;

});

parcelRegister("eDnTv", function(module, exports) {
const $2ee5c54840754ad4$export$488470c175a39c99 = 300000; // 300 seconds
const $2ee5c54840754ad4$var$DEFAULT_BATCH_FETCH_SIZE = 25;
const $2ee5c54840754ad4$export$8c7e237b2e82904f = async (// userId must be defined, unlike in PresencePayload
payload, getUser)=>{
    const { sessionId: sessionId, timestamp: timestamp, clientId: clientId, userId: userId, permit: permit, presenceId: presenceId, presenceActivity: presenceActivity } = payload;
    const user = await getUser?.(userId);
    const participant = {
        name: user?.name || '',
        avatar: user?.avatar || '',
        email: user?.email || '',
        sessionId: sessionId,
        lastActive: timestamp,
        userId: userId,
        clientId: clientId,
        permit: permit,
        isGuest: user?.isGuest,
        presenceId: presenceId,
        presenceActivity: presenceActivity,
        isHydrated: !!user
    };
    return participant;
};
const $2ee5c54840754ad4$export$f481f329110b897f = async (participantsState, batchProps)=>{
    const { batchSize: batchSize = $2ee5c54840754ad4$var$DEFAULT_BATCH_FETCH_SIZE, getUsers: getUsers } = batchProps;
    const participantsToHydrate = participantsState.getUniqueParticipants({
        isHydrated: false
    });
    const participants = participantsToHydrate.splice(0, batchSize);
    if (!participants.length) return [];
    const aaids = new Set();
    participants.forEach((p)=>{
        aaids.add(p.userId);
    });
    const users = await getUsers?.([
        ...aaids.values()
    ]);
    const hydratedParticipants = [];
    users?.forEach((user)=>{
        // find all sessions of the user we just hydrated and populate data
        participantsState.getParticipants().filter((p)=>p.userId === user.userId).forEach((participant)=>{
            const { sessionId: sessionId } = participant;
            const hydratedParticipant = {
                name: user.name,
                avatar: user.avatar,
                email: user.email,
                userId: user.userId,
                isGuest: user.isGuest,
                sessionId: sessionId,
                lastActive: participant.lastActive,
                clientId: participant.clientId,
                permit: participant.permit,
                presenceId: participant.presenceId,
                presenceActivity: participant.presenceActivity,
                isHydrated: true
            };
            participantsState.setBySessionId(sessionId, hydratedParticipant);
            hydratedParticipants.push(hydratedParticipant);
        });
    });
    return hydratedParticipants;
};
module.exports["PARTICIPANT_UPDATE_INTERVAL"] = $2ee5c54840754ad4$export$488470c175a39c99;
module.exports["createParticipantFromPayload"] = $2ee5c54840754ad4$export$8c7e237b2e82904f;
module.exports["fetchParticipants"] = $2ee5c54840754ad4$export$f481f329110b897f;

});

parcelRegister("jaIJZ", function(module, exports) {

var $g4l86 = parcelRequire("g4l86");

class $30afdfea3d80625a$export$a4f3536b6f975d50 {
    constructor(baseParticipants = new Map()){
        this.participants = void 0;
        this.getBySessionId = (sessionId)=>{
            const participant = this.participants.get(sessionId);
            // Spread to ensure we get a deep copy
            return participant ? {
                ...participant
            } : undefined;
        };
        this.setBySessionId = (sessionId, participant)=>{
            this.participants.set(sessionId, participant);
        };
        this.getParticipants = ()=>// Spread to get deep copy
            [
                ...this.participants.values()
            ].filter((p)=>!(0, $g4l86.isAIProviderID)(p.userId)).map((p)=>({
                    ...p
                }));
        this.getAIProviderParticipants = ()=>// Spread to get deep copy
            [
                ...this.participants.values()
            ].filter((p)=>(0, $g4l86.isAIProviderID)(p.userId)).map((p)=>({
                    ...p
                }));
        /**
     * A user may contain multiple sessions, only return the unique users based on aaid.
     * If multiple participants with same aaid exist, will return the most recent entry
     * @param filter additional filter to narrow down results
     * @param filter.isHydrated
     */ this.getUniqueParticipants = ({ isHydrated: isHydrated = false })=>{
            const uniqueParticipants = new Map();
            const participants = this.getParticipants();
            participants.forEach((p)=>{
                if (!!p.isHydrated === isHydrated) {
                    const previous = uniqueParticipants.get(p.userId);
                    uniqueParticipants.set(p.userId, previous ? {
                        ...previous,
                        lastActive: p.lastActive,
                        sessionId: p.sessionId,
                        presenceActivity: p.presenceActivity
                    } : p);
                }
            });
            return [
                ...uniqueParticipants.values()
            ];
        };
        this.hasMoreParticipantsToHydrate = ()=>{
            return this.getUniqueParticipants({
                isHydrated: false
            }).length > 0;
        };
        this.removeBySessionId = (sessionId)=>this.participants.delete(sessionId);
        this.clear = ()=>this.participants.clear();
        this.doesntHave = (sessionId)=>!this.participants.has(sessionId);
        this.size = ()=>this.participants.size;
        this.getUniqueParticipantSize = ()=>{
            const result = new Set();
            this.getParticipants().forEach((p)=>result.add(p.userId));
            return result.size;
        };
        // If userId of participant in userIds, set lastActive to now
        this.updateLastActive = (now, userIds)=>this.participants.forEach((p)=>{
                p.lastActive = userIds.includes(p.userId) ? now : p.lastActive;
            });
        this.participants = baseParticipants;
    }
}
module.exports["ParticipantsState"] = $30afdfea3d80625a$export$a4f3536b6f975d50;

});

parcelRegister("jq7Zs", function(module, exports) {

var $dLe3j = parcelRequire("dLe3j");


var $kunUR = parcelRequire("kunUR");


var $jbOus = parcelRequire("jbOus");

const $d99c7dc4c42a24bb$export$b222f35b2c811336 = (error)=>{
    switch(error.data?.code){
        case (0, $dLe3j.NCS_ERROR_CODE).HEAD_VERSION_UPDATE_FAILED:
        case (0, $dLe3j.NCS_ERROR_CODE).VERSION_NUMBER_ALREADY_EXISTS:
            // This should never be called with these errors
            return;
        case (0, $kunUR.INTERNAL_ERROR_CODE).ADD_STEPS_ERROR:
        case (0, $kunUR.INTERNAL_ERROR_CODE).RECONNECTION_ERROR:
        case (0, $kunUR.INTERNAL_ERROR_CODE).CONNECTION_ERROR:
            // These errors shouldn't be emitted, we're hoping the provider self-recovers over time
            return;
        case (0, $dLe3j.NCS_ERROR_CODE).INSUFFICIENT_EDITING_PERMISSION:
        case (0, $kunUR.INTERNAL_ERROR_CODE).TOKEN_PERMISSION_ERROR:
            return {
                code: (0, $jbOus.PROVIDER_ERROR_CODE).NO_PERMISSION_ERROR,
                message: 'User does not have permissions to access this document or document is not found',
                reason: error.data.meta.reason,
                recoverable: true,
                status: 403
            };
        case (0, $dLe3j.NCS_ERROR_CODE).FORBIDDEN_USER_TOKEN:
            return {
                code: (0, $jbOus.PROVIDER_ERROR_CODE).INVALID_USER_TOKEN,
                message: 'The user token was invalid',
                recoverable: true,
                status: 403
            };
        case (0, $kunUR.INTERNAL_ERROR_CODE).DOCUMENT_NOT_FOUND:
            return {
                code: (0, $jbOus.PROVIDER_ERROR_CODE).DOCUMENT_NOT_FOUND,
                message: 'The requested document is not found',
                recoverable: true,
                status: 404
            };
        case (0, $dLe3j.NCS_ERROR_CODE).TENANT_INSTANCE_MAINTENANCE:
            return {
                code: (0, $jbOus.PROVIDER_ERROR_CODE).LOCKED,
                message: 'The document is currently not available, please try again later',
                recoverable: true,
                status: 423
            };
        case (0, $dLe3j.NCS_ERROR_CODE).LOCKED_DOCUMENT:
            return {
                code: (0, $jbOus.PROVIDER_ERROR_CODE).LOCKED,
                message: 'The document is currently not available, please try again later',
                recoverable: true
            };
        case (0, $dLe3j.NCS_ERROR_CODE).DYNAMO_ERROR:
            return {
                code: (0, $jbOus.PROVIDER_ERROR_CODE).FAIL_TO_SAVE,
                message: 'Collab service is not able to save changes',
                recoverable: false,
                status: 500
            };
        case (0, $kunUR.INTERNAL_ERROR_CODE).DOCUMENT_RESTORE_ERROR:
            return {
                code: (0, $jbOus.PROVIDER_ERROR_CODE).DOCUMENT_RESTORE_ERROR,
                message: 'Collab service unable to restore document',
                recoverable: false,
                status: 500
            };
        case (0, $dLe3j.NCS_ERROR_CODE).INIT_DATA_LOAD_FAILED:
            return {
                code: (0, $jbOus.PROVIDER_ERROR_CODE).INITIALISATION_ERROR,
                message: "The initial document couldn't be loaded from the collab service",
                recoverable: false,
                status: 500
            };
        case (0, $dLe3j.NCS_ERROR_CODE).PROSEMIRROR_SCHEMA_VALIDATION_ERROR:
            return {
                code: (0, $jbOus.PROVIDER_ERROR_CODE).INITIALISATION_ERROR,
                message: "The initial document couldn't be loaded from the collab service due to a prosemirror schema validation error",
                recoverable: false
            };
        case (0, $kunUR.INTERNAL_ERROR_CODE).DOCUMENT_UPDATE_ERROR:
            return {
                code: (0, $jbOus.PROVIDER_ERROR_CODE).DOCUMENT_UPDATE_ERROR,
                message: 'The provider failed to apply changes to the editor',
                recoverable: false,
                status: 500
            };
        case (0, $kunUR.INTERNAL_ERROR_CODE).RECONNECTION_NETWORK_ISSUE:
            return {
                code: (0, $jbOus.PROVIDER_ERROR_CODE).NETWORK_ISSUE,
                message: "Couldn't reconnect to the collab service due to network issues",
                recoverable: true,
                status: 500
            };
        case (0, $dLe3j.NCS_ERROR_CODE).NAMESPACE_INVALID:
        case (0, $dLe3j.NCS_ERROR_CODE).INVALID_ACTIVATION_ID:
        case (0, $dLe3j.NCS_ERROR_CODE).INVALID_DOCUMENT_ARI:
        case (0, $dLe3j.NCS_ERROR_CODE).INVALID_CLOUD_ID:
            return {
                code: (0, $jbOus.PROVIDER_ERROR_CODE).INVALID_PROVIDER_CONFIGURATION,
                message: 'Invalid provider configuration',
                recoverable: false,
                reason: error.data?.code,
                status: 400
            };
        case (0, $dLe3j.NCS_ERROR_CODE).NAMESPACE_NOT_FOUND:
        case (0, $dLe3j.NCS_ERROR_CODE).ERROR_MAPPING_ERROR:
        case (0, $dLe3j.NCS_ERROR_CODE).EMPTY_BROADCAST:
            return {
                code: (0, $jbOus.PROVIDER_ERROR_CODE).INTERNAL_SERVICE_ERROR,
                message: 'Collab Provider experienced an unrecoverable error',
                recoverable: true,
                reason: error.data?.code,
                status: 500
            };
        case (0, $kunUR.INTERNAL_ERROR_CODE).CATCHUP_FAILED:
            return {
                code: (0, $jbOus.PROVIDER_ERROR_CODE).INTERNAL_SERVICE_ERROR,
                message: 'Collab Provider experienced an unrecoverable error',
                recoverable: true,
                reason: error.data?.code,
                status: 500
            };
        case (0, $dLe3j.NCS_ERROR_CODE).RATE_LIMIT_ERROR:
            return {
                code: (0, $jbOus.PROVIDER_ERROR_CODE).FAIL_TO_SAVE,
                message: 'Document rate limit',
                recoverable: false
            };
        default:
            return;
    }
};
module.exports["errorCodeMapper"] = $d99c7dc4c42a24bb$export$b222f35b2c811336;

});

parcelRegister("h5yLp", function(module, exports) {

var $g4l86 = parcelRequire("g4l86");


var $c9IWh = parcelRequire("c9IWh");

const $b12c039b414596f9$var$logger = (0, $g4l86.createLogger)('Api', 'blue');
class $b12c039b414596f9$var$AddCommentError extends Error {
    constructor(message, status, meta){
        super(message);
        this.status = void 0;
        this.meta = void 0;
        this.name = 'AddCommentError';
        this.status = status;
        this.meta = meta;
    }
}
class $b12c039b414596f9$export$bf71da7aebe9ddc1 {
    async addComment(steps) {
        const stepVersion = this.documentService.getCurrentPmVersion();
        try {
            const response = await this.submitComment(steps, stepVersion);
            const status = response.status;
            const { message: message, meta: meta } = await response.json();
            // If the HTTP status code is 201, then the operation was successful
            if (status === 201) {
                $b12c039b414596f9$var$logger(`NCS response: ${message}`);
                return {
                    message: message
                };
            }
            // If the HTTP status code is between 400 and 499, then there was a client error
            if (status >= 400 && status <= 499) {
                $b12c039b414596f9$var$logger(`NCS error meta: ${JSON.stringify(meta)}`);
                // Include details in error response
                throw new $b12c039b414596f9$var$AddCommentError(`Failed to add comment - Client error: ${message}`, status, JSON.stringify(meta));
            }
            // If the code execution reaches this point, then there was a server error
            throw new $b12c039b414596f9$var$AddCommentError(`Failed to add comment - Server error`, status);
        } catch (err) {
            if (err instanceof $b12c039b414596f9$var$AddCommentError) throw err;
            else throw new Error(`Error submitting comment: ${err}`);
        }
    }
    constructor(config, documentService, channel){
        this.config = void 0;
        this.documentService = void 0;
        this.channel = void 0;
        this.submitComment = async (steps, version)=>{
            const reqBody = JSON.stringify({
                productId: 'ccollab',
                version: version,
                steps: steps
            });
            const url = `${this.config.url}/document/${encodeURIComponent(this.config.documentAri)}/comment`;
            $b12c039b414596f9$var$logger(`Request url: `, url);
            const tracingHeaders = (0, $c9IWh.getActiveTraceHttpRequestHeaders)(url);
            const fetchOptions = {
                credentials: 'include',
                headers: {
                    ...this.config.permissionTokenRefresh ? {
                        'x-token': await this.channel.getChannelToken()
                    } : {},
                    'x-product': (0, $g4l86.getProduct)(this.config.productInfo),
                    'x-subproduct': (0, $g4l86.getSubProduct)(this.config.productInfo),
                    'Content-Type': 'application/json',
                    ...tracingHeaders
                },
                method: 'POST',
                body: reqBody
            };
            return await fetch(url, fetchOptions);
        };
        this.config = config;
        this.documentService = documentService;
        this.channel = channel;
    }
}
module.exports["Api"] = $b12c039b414596f9$export$bf71da7aebe9ddc1;

});

parcelRegister("adbeL", function(module, exports) {
// A mock for the actual Api class designed for the experiment teammate presence (ATLAS-53155)
class $c647bce5364deb1a$export$fe345bbcb4b3b9fe {
    // Ignored via go/ees005
    // eslint-disable-next-line require-await
    async addComment() {
        return;
    }
}
module.exports["NullApi"] = $c647bce5364deb1a$export$fe345bbcb4b3b9fe;

});

parcelRegister("4JFj6", function(module, exports) {

var $eOaGc = parcelRequire("eOaGc");

function $2e50b5b57dddaac8$var$getOfflineSteps(steps, origins) {
    if (!steps || !origins || steps.length !== origins.length) return undefined;
    if (origins.some((s)=>s?.getMeta('isOffline') === true || s?.getMeta('wasOffline') === true)) {
        const mapped = steps.filter((step, idx)=>{
            const origin = origins[idx];
            if (!origin) return false;
            const createdOffline = origin.getMeta('isOffline') || origin.getMeta('wasOffline');
            return createdOffline;
        });
        return mapped;
    }
}
function $2e50b5b57dddaac8$export$4cdf4b1fc99387ca(steps, origins) {
    return $2e50b5b57dddaac8$var$getOfflineSteps(steps, origins)?.length;
}
function $2e50b5b57dddaac8$export$4d647e09fb4b200d(steps, origins) {
    return $2e50b5b57dddaac8$var$getOfflineSteps(steps, origins)?.filter((s)=>s instanceof (0, $eOaGc.ReplaceStep)).length;
}
module.exports["getOfflineStepsLength"] = $2e50b5b57dddaac8$export$4cdf4b1fc99387ca;
module.exports["getOfflineReplaceStepsLength"] = $2e50b5b57dddaac8$export$4d647e09fb4b200d;

});

parcelRegister("aykoi", function(module, exports) {
/**
 * https://socket.io/docs/v4/client-options/#randomizationfactor
 * 1st reconnection attempt happens between 100 - 300 ms
 * 2nd reconnection attempt happens between 200 - 600 ms
 * 3rd reconnection attempt happens between 400 - 1200 ms
 * 4th 800 - 2400 ms
 * 5th 1600 - 4800 ms
 * 6th 3200 - 9600 ms
 * 7th 6400 - 19200 ms
 * 8th 12800 - 38400 ms
 * 9th 25600 - 76800 ms
 * 10th 51200 - 128000 ms (capped at max delay)
 * nth 128000 ms
 */ const $1ae672f62e41da9b$export$33eb5f668d5e0d74 = {
    RECONNECTION_DELAY_MAX: 128000,
    RECONNECTION_DELAY: 200,
    RANDOMIZATION_FACTOR: 0.5
};
const $1ae672f62e41da9b$export$273323b1c5196ad5 = {
    RECONNECTION_DELAY_MAX: 128000,
    RECONNECTION_DELAY: 1000,
    RANDOMIZATION_FACTOR: 0.75
};
module.exports["SOCKET_IO_OPTIONS"] = $1ae672f62e41da9b$export$33eb5f668d5e0d74;
module.exports["SOCKET_IO_OPTIONS_WITH_HIGH_JITTER"] = $1ae672f62e41da9b$export$273323b1c5196ad5;

});

parcelRegister("9137z", function(module, exports) {

var $kGrzq = parcelRequire("kGrzq");

const $e77725a58fc80757$export$d93492bf620814be = new (0, $kGrzq.BaseMeasures)();
module.exports["CollabEditProviderMeasures"] = $e77725a58fc80757$export$d93492bf620814be;

});

parcelRegister("j8hiR", function(module, exports) {
var $fbca710eb28c4147$export$d0a57beabaefb993 = /*#__PURE__*/ function(COLLAB_EDIT_PROVIDER_MEASURES) {
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_FETCH"] = "collabEditProviderAnalyticsFetch";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_CREATED"] = "collabEditProviderCreated";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_DISABLED"] = "collabEditProviderDisabled";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_INIT"] = "collabEditProviderInitialized";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_PRE_CONNECTED"] = "collabEditProviderPreconnected";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_CONNECTED"] = "collabEditProviderConnected";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_INIT_DOC"] = "collabEditProviderInitDoc";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_FETCH_NCS_DRAFT"] = "collabEditProviderFetchNCSDraft";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_PRELOAD_NCS_DRAFT"] = "collabEditProviderPreloadNCSDraft";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_PRELOAD_NCS_DRAFT_TIMEOUT"] = "collabEditProviderPreloadNCSDraftTimeout";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_PERMS_TOKEN_FETCH"] = "collabEditProviderPermsTokenFetch";
    return COLLAB_EDIT_PROVIDER_MEASURES;
}({});
module.exports["COLLAB_EDIT_PROVIDER_MEASURES"] = $fbca710eb28c4147$export$d0a57beabaefb993;

});

parcelRegister("1VB1N", function(module, exports) {
const $aa17610eab1e6010$var$COLLAB_PATH = 'ccollab'; // the extra c is for Confluence
const $aa17610eab1e6010$export$33a46e9ce425ca1f = ()=>{
    return `${window.location.origin}/${$aa17610eab1e6010$var$COLLAB_PATH}`;
};
const $aa17610eab1e6010$export$2fa932d5a7c03848 = (cloudId, activationId)=>{
    const editPrefix = '/ncs';
    return `${editPrefix}/${cloudId}/${activationId}/confluence`;
};
module.exports["getCollabProviderUrl"] = $aa17610eab1e6010$export$33a46e9ce425ca1f;
module.exports["getCollabEditServicePath"] = $aa17610eab1e6010$export$2fa932d5a7c03848;

});

parcelRegister("8VXwD", function(module, exports) {

var $iifuv = parcelRequire("iifuv");


var $c0rhi = parcelRequire("c0rhi");

const $b6adfd51a2226747$export$c510c686c47533e5 = (accountIds)=>{
    return (0, $c0rhi.queryInterop)({
        query: (0, $iifuv.default),
        interopApolloAggClient: true,
        variables: {
            accountIds: accountIds
        },
        __callerPackage__: "fabric-providers"
    }).then(({ data: data })=>{
        return data?.users?.filter((user)=>user?.accountId).map((user)=>({
                avatar: user.picture ?? '',
                email: '',
                id: user.id,
                name: user.name ?? '',
                userId: user.accountId
            })) ?? [];
    });
};
module.exports["fetchNativeCollabAGGUsers"] = $b6adfd51a2226747$export$c510c686c47533e5;

});

parcelRegister("iifuv", function(module, exports) {
/**
 * @generated SignedSource<<c6742c1a6c0a36b02bd646f3af0784d0>>
 * @relayHash 0fd4072175c8fe4b70be5b778b8275d1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d99fca6262af9031d992216d6a26bb187ea304a8a6bd9a8187762df24a999afe
const $a9e245ecc19d863b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "fetchNativeCollabAGGUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "fetchNativeCollabAGGUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "users",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "0fd4072175c8fe4b70be5b778b8275d1",
            "id": "d99fca6262af9031d992216d6a26bb187ea304a8a6bd9a8187762df24a999afe",
            "metadata": {},
            "name": "fetchNativeCollabAGGUsersQuery",
            "operationKind": "query",
            "text": "query fetchNativeCollabAGGUsersQuery($accountIds:[ID!]!){users(accountIds:$accountIds){__typename,accountId,name,picture,id}}"
        }
    };
}();
$a9e245ecc19d863b$var$node.hash = "06df0642dffe62239e8db6cdf41fa76d";
var $a9e245ecc19d863b$export$2e2bcd8739ae039 = $a9e245ecc19d863b$var$node;
module.exports["default"] = $a9e245ecc19d863b$export$2e2bcd8739ae039;

});

parcelRegister("bNHtR", function(module, exports) {

var $cpHSm = parcelRequire("cpHSm");


var $c0rhi = parcelRequire("c0rhi");

const $5bd57447223249dc$export$1db9c46a0728e686 = (accountIds)=>{
    return (0, $c0rhi.queryInterop)({
        query: (0, $cpHSm.default),
        variables: {
            accountIds: accountIds
        },
        __callerPackage__: "fabric-providers"
    }).then(({ data: data })=>{
        return data?.confluenceUsers?.nodes?.filter((user)=>user?.accountId).map((user)=>({
                avatar: user.profilePicture?.path ?? '',
                email: '',
                isGuest: undefined,
                name: user.displayName ?? '',
                userId: user.accountId
            })) ?? [];
    });
};
module.exports["fetchNativeCollabConfluenceUsers"] = $5bd57447223249dc$export$1db9c46a0728e686;

});

parcelRegister("cpHSm", function(module, exports) {
/**
 * @generated SignedSource<<f882b6f4293194349490a8cfc1678017>>
 * @relayHash 323b4708c921b4390cda5d42e5653f96
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 36ccd9407258ecbab8e4d25ef3d8dd06ef957b601b4a6430917e55a6d8c81331
const $e40b2bace6883fb5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountIds",
            "variableName": "accountIds"
        }
    ], v2 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isDefault"
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "RELATIVE"
                    }
                ],
                "kind": "ScalarField",
                "name": "path",
                "storageKey": "path(type:\"RELATIVE\")"
            }
        ]
    }, v3 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v4 = {
        "kind": "InlineFragment",
        "selections": v3 /*: any*/ ,
        "type": "KnownUser"
    }, v5 = {
        "kind": "InlineFragment",
        "selections": v3 /*: any*/ ,
        "type": "UnknownUser"
    }, v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "fetchNativeCollabConfluenceUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedPersonList",
                    "kind": "LinkedField",
                    "name": "confluenceUsers",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "fetchNativeCollabConfluenceUsersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedPersonList",
                    "kind": "LinkedField",
                    "name": "confluenceUsers",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                v2 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "323b4708c921b4390cda5d42e5653f96",
            "id": "36ccd9407258ecbab8e4d25ef3d8dd06ef957b601b4a6430917e55a6d8c81331",
            "metadata": {},
            "name": "fetchNativeCollabConfluenceUsersQuery",
            "operationKind": "query",
            "text": "query fetchNativeCollabConfluenceUsersQuery($accountIds:[String]){confluenceUsers(accountIds:$accountIds){nodes{__typename,profilePicture{isDefault,path(type:RELATIVE)},...on KnownUser{accountId},...on UnknownUser{accountId},displayName}}}"
        }
    };
}();
$e40b2bace6883fb5$var$node.hash = "e9ca85d4f438ea6a9fa558a7a23119a8";
var $e40b2bace6883fb5$export$2e2bcd8739ae039 = $e40b2bace6883fb5$var$node;
module.exports["default"] = $e40b2bace6883fb5$export$2e2bcd8739ae039;

});

parcelRegister("gNjy8", function(module, exports) {

var $6e6qw = parcelRequire("6e6qw");


var $7Y8M5 = parcelRequire("7Y8M5");


var $bNhgs = parcelRequire("bNhgs");

const $f7e4e12795ac08a6$export$e42cca8419da94fc = (presenceId)=>{
    const hashCode = presenceId ? (0, $6e6qw.getHashCode)(presenceId) : 0;
    const primaryIndex = hashCode;
    const secondaryIndex = hashCode % (0, $7Y8M5.participantColors).length;
    const svgBackgroundColor = (0, $7Y8M5.participantColors)[secondaryIndex].svgBackgroundColor;
    return (0, $bNhgs.getAnonymousAvatarWithStyling)({
        styleProperties: {
            'background-color': svgBackgroundColor
        },
        index: primaryIndex
    });
};
module.exports["fetchAnonymousAsset"] = $f7e4e12795ac08a6$export$e42cca8419da94fc;

});

parcelRegister("6e6qw", function(module, exports) {

var $7Y8M5 = parcelRequire("7Y8M5");

function $c454c81005f3f72e$export$c14f61804029af13(str) {
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        /* eslint-disable no-bitwise */ hash = (hash << 5) - hash + str.charCodeAt(i);
        hash = (hash & hash) >>> 0;
    /* eslint-enable no-bitwise */ }
    return hash;
}
function $c454c81005f3f72e$export$60ba61eca4eb64f2(str) {
    const index = $c454c81005f3f72e$export$c14f61804029af13(str) % (0, $7Y8M5.participantColors).length;
    return {
        index: index,
        color: (0, $7Y8M5.participantColors)[index]
    };
}
module.exports["getHashCode"] = $c454c81005f3f72e$export$c14f61804029af13;
module.exports["getParticipantColor"] = $c454c81005f3f72e$export$60ba61eca4eb64f2;

});

parcelRegister("bNhgs", function(module, exports) {

var $dpu2n = parcelRequire("dpu2n");


var $ecHHC = parcelRequire("ecHHC");


var $9mfmQ = parcelRequire("9mfmQ");

const $099bc251bcbff389$export$101d00feadd67b75 = (svgRoot)=>{
    // by this point we have a safe SVG string: we can safely string interpolate to encode as a
    // data:image to enable passing it to an <img> src attribute
    return `data:image/svg+xml;base64,${btoa(new XMLSerializer().serializeToString(svgRoot))}`;
};
const $099bc251bcbff389$export$ad5dfe87b2150403 = (cssProperties)=>{
    let styleString = '';
    Object.keys(cssProperties).forEach((key)=>{
        styleString += `${key}: ${cssProperties[key]}; `;
    });
    return styleString;
};
const $099bc251bcbff389$export$1ce458cf91bd8e41 = (svgRoot, cssProperties)=>{
    const styleRule = new CSSStyleSheet();
    const styleString = $099bc251bcbff389$export$ad5dfe87b2150403(cssProperties);
    // even if styling is malicious, it will be sanitized by the CSSStyleSheet with the string being empty, ensuring safety
    styleRule.insertRule(`svg { ${styleString} }`);
    // we need to cast to CSSStyleRule to access the .style property
    const styleRuleString = styleRule.cssRules[0].style.cssText;
    svgRoot.setAttribute('style', styleRuleString);
};
const $099bc251bcbff389$export$7572e098f6cf1a37 = (index)=>{
    return index !== undefined ? index % (0, $dpu2n.ANONYMOUS_ASSETS).length : Math.floor(Math.random() * (0, $dpu2n.ANONYMOUS_ASSETS).length);
};
const $099bc251bcbff389$export$e79675c646a31542 = (svgString)=>{
    return new DOMParser().parseFromString(svgString, 'image/svg+xml');
};
const $099bc251bcbff389$export$65fe496f5eb91c21 = async (props)=>{
    const index = $099bc251bcbff389$export$7572e098f6cf1a37(props?.index);
    const { id: id, messageDescriptor: messageDescriptor, src: src } = (0, $dpu2n.ANONYMOUS_ASSETS)[index];
    const intl = await (0, $ecHHC.getIntl)();
    const response = await (0, $9mfmQ.fetchWithRetry)({
        url: src,
        shouldRetryOnApiError: true,
        retries: props.retries || 3,
        options: props.options,
        baseDelay: props.baseDelay,
        maxDelay: props.maxDelay
    });
    const svgString = await response.result?.text();
    if (!response.success) throw new Error(`Error while fetching svg ${id} with src ${src}`);
    if (!svgString) throw new Error(`svg returned null with svg ${id} with src ${src}`);
    const doc = $099bc251bcbff389$export$e79675c646a31542(svgString);
    const svg = doc.documentElement;
    $099bc251bcbff389$export$1ce458cf91bd8e41(svg, props.styleProperties);
    return {
        id: id,
        name: intl.formatMessage(messageDescriptor),
        src: $099bc251bcbff389$export$101d00feadd67b75(svg)
    };
};
const $099bc251bcbff389$export$da26b707e2b53fcf = async (props)=>{
    const index = $099bc251bcbff389$export$7572e098f6cf1a37(props?.index);
    const asset = (0, $dpu2n.ANONYMOUS_ASSETS)[index];
    const intl = await (0, $ecHHC.getIntl)();
    return {
        ...asset,
        name: intl.formatMessage(asset.messageDescriptor)
    };
};
const $099bc251bcbff389$export$aa51d138a7f855d7 = async ()=>{
    const intl = await (0, $ecHHC.getIntl)();
    return (0, $dpu2n.ANONYMOUS_ASSETS).map((asset)=>({
            id: asset.id,
            name: intl.formatMessage(asset.messageDescriptor),
            src: asset.src
        }));
};
module.exports["getAnonymousAvatarWithStyling"] = $099bc251bcbff389$export$65fe496f5eb91c21;

});

parcelRegister("dpu2n", function(module, exports) {

var $6RZbK = parcelRequire("6RZbK");


var $hDQT9 = parcelRequire("hDQT9");

var $01Y7m = parcelRequire("01Y7m");

var $hYUzZ = parcelRequire("hYUzZ");

var $iuR2u = parcelRequire("iuR2u");

var $kkbx9 = parcelRequire("kkbx9");

var $cFEKY = parcelRequire("cFEKY");

var $6Ytc9 = parcelRequire("6Ytc9");

var $6I2hp = parcelRequire("6I2hp");

var $9jRbs = parcelRequire("9jRbs");

var $doHfX = parcelRequire("doHfX");

var $iQQz2 = parcelRequire("iQQz2");

var $6aQGf = parcelRequire("6aQGf");

var $rKSC9 = parcelRequire("rKSC9");

var $1HhEl = parcelRequire("1HhEl");

var $59SWb = parcelRequire("59SWb");

var $sNNnf = parcelRequire("sNNnf");

var $3lBYI = parcelRequire("3lBYI");

var $4xgJQ = parcelRequire("4xgJQ");

var $h2x1V = parcelRequire("h2x1V");

var $dpF2z = parcelRequire("dpF2z");

var $1sURO = parcelRequire("1sURO");

var $97Vlu = parcelRequire("97Vlu");

var $kVpsY = parcelRequire("kVpsY");

var $hCuul = parcelRequire("hCuul");

var $fuLed = parcelRequire("fuLed");

var $3kpwJ = parcelRequire("3kpwJ");

var $ei5ou = parcelRequire("ei5ou");

var $jveHG = parcelRequire("jveHG");

var $kG0T4 = parcelRequire("kG0T4");

var $iq6me = parcelRequire("iq6me");

var $amt9P = parcelRequire("amt9P");

var $unK7p = parcelRequire("unK7p");

var $7myjl = parcelRequire("7myjl");

var $c3CGq = parcelRequire("c3CGq");

var $73XLd = parcelRequire("73XLd");

var $4O6RS = parcelRequire("4O6RS");

var $1GH6m = parcelRequire("1GH6m");

var $1HXyl = parcelRequire("1HXyl");

var $htAoo = parcelRequire("htAoo");

var $0547j = parcelRequire("0547j");

var $cgVUh = parcelRequire("cgVUh");

var $cQ8lp = parcelRequire("cQ8lp");

var $5JQ20 = parcelRequire("5JQ20");

var $2YPi6 = parcelRequire("2YPi6");

var $cdkwi = parcelRequire("cdkwi");

var $kh1OZ = parcelRequire("kh1OZ");

var $8Sl6f = parcelRequire("8Sl6f");

var $9Qn7m = parcelRequire("9Qn7m");

var $3vrZh = parcelRequire("3vrZh");

var $2InqY = parcelRequire("2InqY");

var $dWYu6 = parcelRequire("dWYu6");

var $e4PgN = parcelRequire("e4PgN");

var $19hVO = parcelRequire("19hVO");

var $2UNgz = parcelRequire("2UNgz");

var $fVzqf = parcelRequire("fVzqf");

var $lj2Ls = parcelRequire("lj2Ls");

var $fr7Nb = parcelRequire("fr7Nb");

var $3Xksf = parcelRequire("3Xksf");

var $bBmIz = parcelRequire("bBmIz");

var $gYk9S = parcelRequire("gYk9S");

var $iii2c = parcelRequire("iii2c");

var $2AIpZ = parcelRequire("2AIpZ");

var $apAKP = parcelRequire("apAKP");

var $eHyqm = parcelRequire("eHyqm");

var $3qxDD = parcelRequire("3qxDD");

var $eHLy0 = parcelRequire("eHLy0");

var $kdS3N = parcelRequire("kdS3N");

var $1Sij2 = parcelRequire("1Sij2");

var $3pGfT = parcelRequire("3pGfT");

var $4LuNj = parcelRequire("4LuNj");

var $9gWob = parcelRequire("9gWob");

var $dRNzY = parcelRequire("dRNzY");

var $iMJSX = parcelRequire("iMJSX");

var $5cLsu = parcelRequire("5cLsu");

var $iN75X = parcelRequire("iN75X");

var $dKZNQ = parcelRequire("dKZNQ");

var $3N5nT = parcelRequire("3N5nT");

var $gAbKd = parcelRequire("gAbKd");

var $3KwZg = parcelRequire("3KwZg");

var $53QJP = parcelRequire("53QJP");

var $3tNjt = parcelRequire("3tNjt");

var $1QOVp = parcelRequire("1QOVp");

var $8BdMq = parcelRequire("8BdMq");

var $kzKxq = parcelRequire("kzKxq");

var $2bFMn = parcelRequire("2bFMn");

var $1mGLL = parcelRequire("1mGLL");

var $6hNPs = parcelRequire("6hNPs");

var $swN6A = parcelRequire("swN6A");

var $jlxMa = parcelRequire("jlxMa");

var $hY9h4 = parcelRequire("hY9h4");

var $21edV = parcelRequire("21edV");

var $i42iL = parcelRequire("i42iL");

var $5brqg = parcelRequire("5brqg");

var $55gO3 = parcelRequire("55gO3");

var $2cB6n = parcelRequire("2cB6n");

var $drBaG = parcelRequire("drBaG");

var $6OMjq = parcelRequire("6OMjq");

var $8MYut = parcelRequire("8MYut");

var $j8C9j = parcelRequire("j8C9j");

var $6yJEz = parcelRequire("6yJEz");

var $dtUp6 = parcelRequire("dtUp6");

var $isP63 = parcelRequire("isP63");

var $9lleE = parcelRequire("9lleE");

var $5uWd9 = parcelRequire("5uWd9");

var $iIHIG = parcelRequire("iIHIG");

const $357db4d5f3da3ec7$export$4522d3d70312bbdc = [
    {
        id: 'alligator',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iq6me))),
        messageDescriptor: (0, $6RZbK.messages).alligator
    },
    {
        id: 'alpaca',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lj2Ls))),
        messageDescriptor: (0, $6RZbK.messages).alpaca
    },
    {
        id: 'ape',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3qxDD))),
        messageDescriptor: (0, $6RZbK.messages).ape
    },
    {
        id: 'apple',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hDQT9))),
        messageDescriptor: (0, $6RZbK.messages).apple
    },
    {
        id: 'avocado',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($01Y7m))),
        messageDescriptor: (0, $6RZbK.messages).avocado
    },
    {
        id: 'baboon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3qxDD))),
        messageDescriptor: (0, $6RZbK.messages).baboon
    },
    {
        id: 'badger',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hYUzZ))),
        messageDescriptor: (0, $6RZbK.messages).badger
    },
    {
        id: 'bat',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iuR2u))),
        messageDescriptor: (0, $6RZbK.messages).bat
    },
    {
        id: 'bear',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kkbx9))),
        messageDescriptor: (0, $6RZbK.messages).bear
    },
    {
        id: 'beaver',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cFEKY))),
        messageDescriptor: (0, $6RZbK.messages).beaver
    },
    {
        id: 'bee',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6Ytc9))),
        messageDescriptor: (0, $6RZbK.messages).bee
    },
    {
        id: 'bird',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kdS3N))),
        messageDescriptor: (0, $6RZbK.messages).bird
    },
    {
        id: 'bison',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6I2hp))),
        messageDescriptor: (0, $6RZbK.messages).bison
    },
    {
        id: 'blobfish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($0547j))),
        messageDescriptor: (0, $6RZbK.messages).blobfish
    },
    {
        id: 'blossom',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9jRbs))),
        messageDescriptor: (0, $6RZbK.messages).blossom
    },
    {
        id: 'blowfish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($doHfX))),
        messageDescriptor: (0, $6RZbK.messages).blowfish
    },
    {
        id: 'blueberries',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iQQz2))),
        messageDescriptor: (0, $6RZbK.messages).blueberries
    },
    {
        id: 'boar',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6aQGf))),
        messageDescriptor: (0, $6RZbK.messages).boar
    },
    {
        id: 'broccoli',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($rKSC9))),
        messageDescriptor: (0, $6RZbK.messages).broccoli
    },
    {
        id: 'buffalo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6I2hp))),
        messageDescriptor: (0, $6RZbK.messages).buffalo
    },
    {
        id: 'bug',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1HhEl))),
        messageDescriptor: (0, $6RZbK.messages).bug
    },
    {
        id: 'bull',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jveHG))),
        messageDescriptor: (0, $6RZbK.messages).bull
    },
    {
        id: 'bunny',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gAbKd))),
        messageDescriptor: (0, $6RZbK.messages).bunny
    },
    {
        id: 'butterfly',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1HhEl))),
        messageDescriptor: (0, $6RZbK.messages).butterfly
    },
    {
        id: 'cactus',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($59SWb))),
        messageDescriptor: (0, $6RZbK.messages).cactus
    },
    {
        id: 'camel',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($sNNnf))),
        messageDescriptor: (0, $6RZbK.messages).camel
    },
    {
        id: 'candy',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3lBYI))),
        messageDescriptor: (0, $6RZbK.messages).candy
    },
    {
        id: 'cantaloupe',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bBmIz))),
        messageDescriptor: (0, $6RZbK.messages).cantaloupe
    },
    {
        id: 'capsicum',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4xgJQ))),
        messageDescriptor: (0, $6RZbK.messages).capsicum
    },
    {
        id: 'carrot',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($h2x1V))),
        messageDescriptor: (0, $6RZbK.messages).carrot
    },
    {
        id: 'cat',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dpF2z))),
        messageDescriptor: (0, $6RZbK.messages).cat
    },
    {
        id: 'caterpiller',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1sURO))),
        messageDescriptor: (0, $6RZbK.messages).caterpiller
    },
    {
        id: 'chameleon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fVzqf))),
        messageDescriptor: (0, $6RZbK.messages).chameleon
    },
    {
        id: 'cherry',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($97Vlu))),
        messageDescriptor: (0, $6RZbK.messages).cherry
    },
    {
        id: 'chili',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kVpsY))),
        messageDescriptor: (0, $6RZbK.messages).chili
    },
    {
        id: 'chimp',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gYk9S))),
        messageDescriptor: (0, $6RZbK.messages).chimp
    },
    {
        id: 'chimpanzee',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gYk9S))),
        messageDescriptor: (0, $6RZbK.messages).chimpanzee
    },
    {
        id: 'clover',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hCuul))),
        messageDescriptor: (0, $6RZbK.messages).clover
    },
    {
        id: 'clownfish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6yJEz))),
        messageDescriptor: (0, $6RZbK.messages).clownfish
    },
    {
        id: 'cobra',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hY9h4))),
        messageDescriptor: (0, $6RZbK.messages).cobra
    },
    {
        id: 'coconut',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fuLed))),
        messageDescriptor: (0, $6RZbK.messages).coconut
    },
    {
        id: 'cod',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($0547j))),
        messageDescriptor: (0, $6RZbK.messages).cod
    },
    {
        id: 'cookie',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3kpwJ))),
        messageDescriptor: (0, $6RZbK.messages).cookie
    },
    {
        id: 'corn',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ei5ou))),
        messageDescriptor: (0, $6RZbK.messages).corn
    },
    {
        id: 'cow',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jveHG))),
        messageDescriptor: (0, $6RZbK.messages).cow
    },
    {
        id: 'crab',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kG0T4))),
        messageDescriptor: (0, $6RZbK.messages).crab
    },
    {
        id: 'crocodile',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iq6me))),
        messageDescriptor: (0, $6RZbK.messages).crocodile
    },
    {
        id: 'deer',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($amt9P))),
        messageDescriptor: (0, $6RZbK.messages).deer
    },
    {
        id: 'dinosaur',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($unK7p))),
        messageDescriptor: (0, $6RZbK.messages).dinosaur
    },
    {
        id: 'dodo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7myjl))),
        messageDescriptor: (0, $6RZbK.messages).dodo
    },
    {
        id: 'dog',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c3CGq))),
        messageDescriptor: (0, $6RZbK.messages).dog
    },
    {
        id: 'dolphin',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($73XLd))),
        messageDescriptor: (0, $6RZbK.messages).dolphin
    },
    {
        id: 'donut',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4O6RS))),
        messageDescriptor: (0, $6RZbK.messages).donut
    },
    {
        id: 'dragon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1GH6m))),
        messageDescriptor: (0, $6RZbK.messages).dragon
    },
    {
        id: 'duck',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1HXyl))),
        messageDescriptor: (0, $6RZbK.messages).duck
    },
    {
        id: 'elephant',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($htAoo))),
        messageDescriptor: (0, $6RZbK.messages).elephant
    },
    {
        id: 'elk',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($amt9P))),
        messageDescriptor: (0, $6RZbK.messages).elk
    },
    {
        id: 'fish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($0547j))),
        messageDescriptor: (0, $6RZbK.messages).fish
    },
    {
        id: 'flamingo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cgVUh))),
        messageDescriptor: (0, $6RZbK.messages).flamingo
    },
    {
        id: 'fox',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cQ8lp))),
        messageDescriptor: (0, $6RZbK.messages).fox
    },
    {
        id: 'frog',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5JQ20))),
        messageDescriptor: (0, $6RZbK.messages).frog
    },
    {
        id: 'gecko',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fVzqf))),
        messageDescriptor: (0, $6RZbK.messages).gecko
    },
    {
        id: 'giraffe',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2YPi6))),
        messageDescriptor: (0, $6RZbK.messages).giraffe
    },
    {
        id: 'gorilla',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($cdkwi))),
        messageDescriptor: (0, $6RZbK.messages).gorilla
    },
    {
        id: 'grape',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kh1OZ))),
        messageDescriptor: (0, $6RZbK.messages).grape
    },
    {
        id: 'hammerhead',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2bFMn))),
        messageDescriptor: (0, $6RZbK.messages).hammerhead
    },
    {
        id: 'hedgehog',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8Sl6f))),
        messageDescriptor: (0, $6RZbK.messages).hedgehog
    },
    {
        id: 'hippo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9Qn7m))),
        messageDescriptor: (0, $6RZbK.messages).hippo
    },
    {
        id: 'kangaroo',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3vrZh))),
        messageDescriptor: (0, $6RZbK.messages).kangaroo
    },
    {
        id: 'kitten',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dpF2z))),
        messageDescriptor: (0, $6RZbK.messages).kitten
    },
    {
        id: 'kiwi',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2InqY))),
        messageDescriptor: (0, $6RZbK.messages).kiwi
    },
    {
        id: 'koala',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dWYu6))),
        messageDescriptor: (0, $6RZbK.messages).koala
    },
    {
        id: 'lemon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($e4PgN))),
        messageDescriptor: (0, $6RZbK.messages).lemon
    },
    {
        id: 'leopard',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($drBaG))),
        messageDescriptor: (0, $6RZbK.messages).leopard
    },
    {
        id: 'lettuce',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($19hVO))),
        messageDescriptor: (0, $6RZbK.messages).lettuce
    },
    {
        id: 'lion',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2UNgz))),
        messageDescriptor: (0, $6RZbK.messages).lion
    },
    {
        id: 'lizard',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fVzqf))),
        messageDescriptor: (0, $6RZbK.messages).lizard
    },
    {
        id: 'llama',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lj2Ls))),
        messageDescriptor: (0, $6RZbK.messages).llama
    },
    {
        id: 'lobster',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fr7Nb))),
        messageDescriptor: (0, $6RZbK.messages).lobster
    },
    {
        id: 'macaque',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gYk9S))),
        messageDescriptor: (0, $6RZbK.messages).macaque
    },
    {
        id: 'mango',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3Xksf))),
        messageDescriptor: (0, $6RZbK.messages).mango
    },
    {
        id: 'melon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9lleE))),
        messageDescriptor: (0, $6RZbK.messages).melon
    },
    {
        id: 'millipede',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1sURO))),
        messageDescriptor: (0, $6RZbK.messages).millipede
    },
    {
        id: 'monkey',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gYk9S))),
        messageDescriptor: (0, $6RZbK.messages).monkey
    },
    {
        id: 'mouse',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iii2c))),
        messageDescriptor: (0, $6RZbK.messages).mouse
    },
    {
        id: 'octopus',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2AIpZ))),
        messageDescriptor: (0, $6RZbK.messages).octopus
    },
    {
        id: 'olive',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($apAKP))),
        messageDescriptor: (0, $6RZbK.messages).olive
    },
    {
        id: 'orange',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eHyqm))),
        messageDescriptor: (0, $6RZbK.messages).orange
    },
    {
        id: 'orangutan',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3qxDD))),
        messageDescriptor: (0, $6RZbK.messages).orangutan
    },
    {
        id: 'otter',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eHLy0))),
        messageDescriptor: (0, $6RZbK.messages).otter
    },
    {
        id: 'owl',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kdS3N))),
        messageDescriptor: (0, $6RZbK.messages).owl
    },
    {
        id: 'ox',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1Sij2))),
        messageDescriptor: (0, $6RZbK.messages).ox
    },
    {
        id: 'oyster',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3pGfT))),
        messageDescriptor: (0, $6RZbK.messages).oyster
    },
    {
        id: 'panda',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4LuNj))),
        messageDescriptor: (0, $6RZbK.messages).panda
    },
    {
        id: 'parrot',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9gWob))),
        messageDescriptor: (0, $6RZbK.messages).parrot
    },
    {
        id: 'peacock',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dRNzY))),
        messageDescriptor: (0, $6RZbK.messages).peacock
    },
    {
        id: 'pear',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iMJSX))),
        messageDescriptor: (0, $6RZbK.messages).pear
    },
    {
        id: 'penguin',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5cLsu))),
        messageDescriptor: (0, $6RZbK.messages).penguin
    },
    {
        id: 'pig',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iN75X))),
        messageDescriptor: (0, $6RZbK.messages).pig
    },
    {
        id: 'pineapple',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dKZNQ))),
        messageDescriptor: (0, $6RZbK.messages).pineapple
    },
    {
        id: 'poodle',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3N5nT))),
        messageDescriptor: (0, $6RZbK.messages).poodle
    },
    {
        id: 'puppy',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c3CGq))),
        messageDescriptor: (0, $6RZbK.messages).puppy
    },
    {
        id: 'python',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hY9h4))),
        messageDescriptor: (0, $6RZbK.messages).python
    },
    {
        id: 'rabbit',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gAbKd))),
        messageDescriptor: (0, $6RZbK.messages).rabbit
    },
    {
        id: 'raccoon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3KwZg))),
        messageDescriptor: (0, $6RZbK.messages).raccoon
    },
    {
        id: 'rat',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iii2c))),
        messageDescriptor: (0, $6RZbK.messages).rat
    },
    {
        id: 'rhino',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($53QJP))),
        messageDescriptor: (0, $6RZbK.messages).rhino
    },
    {
        id: 'robot',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3tNjt))),
        messageDescriptor: (0, $6RZbK.messages).robot
    },
    {
        id: 'rose',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1QOVp))),
        messageDescriptor: (0, $6RZbK.messages).rose
    },
    {
        id: 'seal',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8BdMq))),
        messageDescriptor: (0, $6RZbK.messages).seal
    },
    {
        id: 'seedling',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kzKxq))),
        messageDescriptor: (0, $6RZbK.messages).seedling
    },
    {
        id: 'shark',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2bFMn))),
        messageDescriptor: (0, $6RZbK.messages).shark
    },
    {
        id: 'shrimp',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($1mGLL))),
        messageDescriptor: (0, $6RZbK.messages).shrimp
    },
    {
        id: 'skunk',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6hNPs))),
        messageDescriptor: (0, $6RZbK.messages).skunk
    },
    {
        id: 'sloth',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($swN6A))),
        messageDescriptor: (0, $6RZbK.messages).sloth
    },
    {
        id: 'snail',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jlxMa))),
        messageDescriptor: (0, $6RZbK.messages).snail
    },
    {
        id: 'snake',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($hY9h4))),
        messageDescriptor: (0, $6RZbK.messages).snake
    },
    {
        id: 'snowman',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($21edV))),
        messageDescriptor: (0, $6RZbK.messages).snowman
    },
    {
        id: 'squid',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($i42iL))),
        messageDescriptor: (0, $6RZbK.messages).squid
    },
    {
        id: 'squirrel',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5brqg))),
        messageDescriptor: (0, $6RZbK.messages).squirrel
    },
    {
        id: 'strawberry',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($55gO3))),
        messageDescriptor: (0, $6RZbK.messages).strawberry
    },
    {
        id: 'sunfish',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6yJEz))),
        messageDescriptor: (0, $6RZbK.messages).sunfish
    },
    {
        id: 'sunflower',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2cB6n))),
        messageDescriptor: (0, $6RZbK.messages).sunflower
    },
    {
        id: 'tiger',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($drBaG))),
        messageDescriptor: (0, $6RZbK.messages).tiger
    },
    {
        id: 'tomato',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6OMjq))),
        messageDescriptor: (0, $6RZbK.messages).tomato
    },
    {
        id: 'tortoise',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($isP63))),
        messageDescriptor: (0, $6RZbK.messages).tortoise
    },
    {
        id: 'tree',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8MYut))),
        messageDescriptor: (0, $6RZbK.messages).tree
    },
    {
        id: 'trex',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($j8C9j))),
        messageDescriptor: (0, $6RZbK.messages).trex
    },
    {
        id: 'trout',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($0547j))),
        messageDescriptor: (0, $6RZbK.messages).trout
    },
    {
        id: 'turkey',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($dtUp6))),
        messageDescriptor: (0, $6RZbK.messages).turkey
    },
    {
        id: 'turtle',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($isP63))),
        messageDescriptor: (0, $6RZbK.messages).turtle
    },
    {
        id: 'wasp',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6Ytc9))),
        messageDescriptor: (0, $6RZbK.messages).wasp
    },
    {
        id: 'watermelon',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9lleE))),
        messageDescriptor: (0, $6RZbK.messages).watermelon
    },
    {
        id: 'whale',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5uWd9))),
        messageDescriptor: (0, $6RZbK.messages).whale
    },
    {
        id: 'wolf',
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iIHIG))),
        messageDescriptor: (0, $6RZbK.messages).wolf
    }
];
module.exports["ANONYMOUS_ASSETS"] = $357db4d5f3da3ec7$export$4522d3d70312bbdc;

});

parcelRegister("6RZbK", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $52c1b6ebf0043fde$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    alligator: {
        id: "platform.anonymous-asset-name.alligator",
        defaultMessage: "Anonymous Alligator"
    },
    alpaca: {
        id: "platform.anonymous-asset-name.alpaca",
        defaultMessage: "Anonymous Alpaca"
    },
    ape: {
        id: "platform.anonymous-asset-name.ape",
        defaultMessage: "Anonymous Ape"
    },
    apple: {
        id: "platform.anonymous-asset-name.apple",
        defaultMessage: "Anonymous Apple"
    },
    avocado: {
        id: "platform.anonymous-asset-name.avocado",
        defaultMessage: "Anonymous Avocado"
    },
    baboon: {
        id: "platform.anonymous-asset-name.baboon",
        defaultMessage: "Anonymous Baboon"
    },
    badger: {
        id: "platform.anonymous-asset-name.badger",
        defaultMessage: "Anonymous Badger"
    },
    bat: {
        id: "platform.anonymous-asset-name.bat",
        defaultMessage: "Anonymous Bat"
    },
    bear: {
        id: "platform.anonymous-asset-name.bear",
        defaultMessage: "Anonymous Bear"
    },
    beaver: {
        id: "platform.anonymous-asset-name.beaver",
        defaultMessage: "Anonymous Beaver"
    },
    bee: {
        id: "platform.anonymous-asset-name.bee",
        defaultMessage: "Anonymous Bee"
    },
    bird: {
        id: "platform.anonymous-asset-name.bird",
        defaultMessage: "Anonymous Bird"
    },
    bison: {
        id: "platform.anonymous-asset-name.bison",
        defaultMessage: "Anonymous Bison"
    },
    blobfish: {
        id: "platform.anonymous-asset-name.blobfish",
        defaultMessage: "Anonymous Blobfish"
    },
    blossom: {
        id: "platform.anonymous-asset-name.blossom",
        defaultMessage: "Anonymous Blossom"
    },
    blowfish: {
        id: "platform.anonymous-asset-name.blowfish",
        defaultMessage: "Anonymous Blowfish"
    },
    blueberries: {
        id: "platform.anonymous-asset-name.blueberries",
        defaultMessage: "Anonymous Blueberries"
    },
    boar: {
        id: "platform.anonymous-asset-name.boar",
        defaultMessage: "Anonymous Boar"
    },
    broccoli: {
        id: "platform.anonymous-asset-name.broccoli",
        defaultMessage: "Anonymous Broccoli"
    },
    buffalo: {
        id: "platform.anonymous-asset-name.buffalo",
        defaultMessage: "Anonymous Buffalo"
    },
    bug: {
        id: "platform.anonymous-asset-name.bug",
        defaultMessage: "Anonymous Bug"
    },
    bull: {
        id: "platform.anonymous-asset-name.bull",
        defaultMessage: "Anonymous Bull"
    },
    bunny: {
        id: "platform.anonymous-asset-name.bunny",
        defaultMessage: "Anonymous Bunny"
    },
    butterfly: {
        id: "platform.anonymous-asset-name.butterfly",
        defaultMessage: "Anonymous Butterfly"
    },
    cactus: {
        id: "platform.anonymous-asset-name.cactus",
        defaultMessage: "Anonymous Cactus"
    },
    camel: {
        id: "platform.anonymous-asset-name.camel",
        defaultMessage: "Anonymous Camel"
    },
    candy: {
        id: "platform.anonymous-asset-name.candy",
        defaultMessage: "Anonymous Candy"
    },
    cantaloupe: {
        id: "platform.anonymous-asset-name.cantaloupe",
        defaultMessage: "Anonymous Cantaloupe"
    },
    capsicum: {
        id: "platform.anonymous-asset-name.capsicum",
        defaultMessage: "Anonymous Capsicum"
    },
    carrot: {
        id: "platform.anonymous-asset-name.carrot",
        defaultMessage: "Anonymous Carrot"
    },
    cat: {
        id: "platform.anonymous-asset-name.cat",
        defaultMessage: "Anonymous Cat"
    },
    caterpiller: {
        id: "platform.anonymous-asset-name.caterpiller",
        defaultMessage: "Anonymous Caterpiller"
    },
    chameleon: {
        id: "platform.anonymous-asset-name.chameleon",
        defaultMessage: "Anonymous Chameleon"
    },
    cherry: {
        id: "platform.anonymous-asset-name.cherry",
        defaultMessage: "Anonymous Cherry"
    },
    chili: {
        id: "platform.anonymous-asset-name.chili",
        defaultMessage: "Anonymous Chili"
    },
    chimp: {
        id: "platform.anonymous-asset-name.chimp",
        defaultMessage: "Anonymous Chimp"
    },
    chimpanzee: {
        id: "platform.anonymous-asset-name.chimpanzee",
        defaultMessage: "Anonymous Chimpanzee"
    },
    clover: {
        id: "platform.anonymous-asset-name.clover",
        defaultMessage: "Anonymous Clover"
    },
    clownfish: {
        id: "platform.anonymous-asset-name.clownfish",
        defaultMessage: "Anonymous Clownfish"
    },
    cobra: {
        id: "platform.anonymous-asset-name.cobra",
        defaultMessage: "Anonymous Cobra"
    },
    coconut: {
        id: "platform.anonymous-asset-name.coconut",
        defaultMessage: "Anonymous Coconut"
    },
    cod: {
        id: "platform.anonymous-asset-name.cod",
        defaultMessage: "Anonymous Cod"
    },
    cookie: {
        id: "platform.anonymous-asset-name.cookie",
        defaultMessage: "Anonymous Cookie"
    },
    corn: {
        id: "platform.anonymous-asset-name.corn",
        defaultMessage: "Anonymous Corn"
    },
    cow: {
        id: "platform.anonymous-asset-name.cow",
        defaultMessage: "Anonymous Cow"
    },
    crab: {
        id: "platform.anonymous-asset-name.crab",
        defaultMessage: "Anonymous Crab"
    },
    crocodile: {
        id: "platform.anonymous-asset-name.crocodile",
        defaultMessage: "Anonymous Crocodile"
    },
    deer: {
        id: "platform.anonymous-asset-name.deer",
        defaultMessage: "Anonymous Deer"
    },
    dinosaur: {
        id: "platform.anonymous-asset-name.dinosaur",
        defaultMessage: "Anonymous Dinosaur"
    },
    dodo: {
        id: "platform.anonymous-asset-name.dodo",
        defaultMessage: "Anonymous Dodo"
    },
    dog: {
        id: "platform.anonymous-asset-name.dog",
        defaultMessage: "Anonymous Dog"
    },
    dolphin: {
        id: "platform.anonymous-asset-name.dolphin",
        defaultMessage: "Anonymous Dolphin"
    },
    donut: {
        id: "platform.anonymous-asset-name.donut",
        defaultMessage: "Anonymous Donut"
    },
    dragon: {
        id: "platform.anonymous-asset-name.dragon",
        defaultMessage: "Anonymous Dragon"
    },
    duck: {
        id: "platform.anonymous-asset-name.duck",
        defaultMessage: "Anonymous Duck"
    },
    elephant: {
        id: "platform.anonymous-asset-name.elephant",
        defaultMessage: "Anonymous Elephant"
    },
    elk: {
        id: "platform.anonymous-asset-name.elk",
        defaultMessage: "Anonymous Elk"
    },
    fish: {
        id: "platform.anonymous-asset-name.fish",
        defaultMessage: "Anonymous Fish"
    },
    flamingo: {
        id: "platform.anonymous-asset-name.flamingo",
        defaultMessage: "Anonymous Flamingo"
    },
    fox: {
        id: "platform.anonymous-asset-name.fox",
        defaultMessage: "Anonymous Fox"
    },
    frog: {
        id: "platform.anonymous-asset-name.frog",
        defaultMessage: "Anonymous Frog"
    },
    gecko: {
        id: "platform.anonymous-asset-name.gecko",
        defaultMessage: "Anonymous Gecko"
    },
    giraffe: {
        id: "platform.anonymous-asset-name.giraffe",
        defaultMessage: "Anonymous Giraffe"
    },
    gorilla: {
        id: "platform.anonymous-asset-name.gorilla",
        defaultMessage: "Anonymous Gorilla"
    },
    grape: {
        id: "platform.anonymous-asset-name.grape",
        defaultMessage: "Anonymous Grape"
    },
    hammerhead: {
        id: "platform.anonymous-asset-name.hammerhead",
        defaultMessage: "Anonymous Hammerhead"
    },
    hedgehog: {
        id: "platform.anonymous-asset-name.hedgehog",
        defaultMessage: "Anonymous Hedgehog"
    },
    hippo: {
        id: "platform.anonymous-asset-name.hippo",
        defaultMessage: "Anonymous Hippo"
    },
    kangaroo: {
        id: "platform.anonymous-asset-name.kangaroo",
        defaultMessage: "Anonymous Kangaroo"
    },
    kitten: {
        id: "platform.anonymous-asset-name.kitten",
        defaultMessage: "Anonymous Kitten"
    },
    kiwi: {
        id: "platform.anonymous-asset-name.kiwi",
        defaultMessage: "Anonymous Kiwi"
    },
    koala: {
        id: "platform.anonymous-asset-name.koala",
        defaultMessage: "Anonymous Koala"
    },
    lemon: {
        id: "platform.anonymous-asset-name.lemon",
        defaultMessage: "Anonymous Lemon"
    },
    leopard: {
        id: "platform.anonymous-asset-name.leopard",
        defaultMessage: "Anonymous Leopard"
    },
    lettuce: {
        id: "platform.anonymous-asset-name.lettuce",
        defaultMessage: "Anonymous Lettuce"
    },
    lion: {
        id: "platform.anonymous-asset-name.lion",
        defaultMessage: "Anonymous Lion"
    },
    lizard: {
        id: "platform.anonymous-asset-name.lizard",
        defaultMessage: "Anonymous Lizard"
    },
    llama: {
        id: "platform.anonymous-asset-name.llama",
        defaultMessage: "Anonymous Llama"
    },
    lobster: {
        id: "platform.anonymous-asset-name.lobster",
        defaultMessage: "Anonymous Lobster"
    },
    macaque: {
        id: "platform.anonymous-asset-name.macaque",
        defaultMessage: "Anonymous Macaque"
    },
    mango: {
        id: "platform.anonymous-asset-name.mango",
        defaultMessage: "Anonymous Mango"
    },
    melon: {
        id: "platform.anonymous-asset-name.melon",
        defaultMessage: "Anonymous Melon"
    },
    millipede: {
        id: "platform.anonymous-asset-name.millipede",
        defaultMessage: "Anonymous Millipede"
    },
    monkey: {
        id: "platform.anonymous-asset-name.monkey",
        defaultMessage: "Anonymous Monkey"
    },
    mouse: {
        id: "platform.anonymous-asset-name.mouse",
        defaultMessage: "Anonymous Mouse"
    },
    octopus: {
        id: "platform.anonymous-asset-name.octopus",
        defaultMessage: "Anonymous Octopus"
    },
    olive: {
        id: "platform.anonymous-asset-name.olive",
        defaultMessage: "Anonymous Olive"
    },
    orange: {
        id: "platform.anonymous-asset-name.orange",
        defaultMessage: "Anonymous Orange"
    },
    orangutan: {
        id: "platform.anonymous-asset-name.orangutan",
        defaultMessage: "Anonymous Orangutan"
    },
    otter: {
        id: "platform.anonymous-asset-name.otter",
        defaultMessage: "Anonymous Otter"
    },
    owl: {
        id: "platform.anonymous-asset-name.owl",
        defaultMessage: "Anonymous Owl"
    },
    ox: {
        id: "platform.anonymous-asset-name.ox",
        defaultMessage: "Anonymous Ox"
    },
    oyster: {
        id: "platform.anonymous-asset-name.oyster",
        defaultMessage: "Anonymous Oyster"
    },
    panda: {
        id: "platform.anonymous-asset-name.panda",
        defaultMessage: "Anonymous Panda"
    },
    parrot: {
        id: "platform.anonymous-asset-name.parrot",
        defaultMessage: "Anonymous Parrot"
    },
    peacock: {
        id: "platform.anonymous-asset-name.peacock",
        defaultMessage: "Anonymous Peacock"
    },
    pear: {
        id: "platform.anonymous-asset-name.pear",
        defaultMessage: "Anonymous Pear"
    },
    penguin: {
        id: "platform.anonymous-asset-name.penguin",
        defaultMessage: "Anonymous Penguin"
    },
    pig: {
        id: "platform.anonymous-asset-name.pig",
        defaultMessage: "Anonymous Pig"
    },
    pineapple: {
        id: "platform.anonymous-asset-name.pineapple",
        defaultMessage: "Anonymous Pineapple"
    },
    poodle: {
        id: "platform.anonymous-asset-name.poodle",
        defaultMessage: "Anonymous Poodle"
    },
    puppy: {
        id: "platform.anonymous-asset-name.puppy",
        defaultMessage: "Anonymous Puppy"
    },
    python: {
        id: "platform.anonymous-asset-name.python",
        defaultMessage: "Anonymous Python"
    },
    rabbit: {
        id: "platform.anonymous-asset-name.rabbit",
        defaultMessage: "Anonymous Rabbit"
    },
    raccoon: {
        id: "platform.anonymous-asset-name.raccoon",
        defaultMessage: "Anonymous Raccoon"
    },
    rat: {
        id: "platform.anonymous-asset-name.rat",
        defaultMessage: "Anonymous Rat"
    },
    rhino: {
        id: "platform.anonymous-asset-name.rhino",
        defaultMessage: "Anonymous Rhino"
    },
    robot: {
        id: "platform.anonymous-asset-name.robot",
        defaultMessage: "Anonymous Robot"
    },
    rose: {
        id: "platform.anonymous-asset-name.rose",
        defaultMessage: "Anonymous Rose"
    },
    seal: {
        id: "platform.anonymous-asset-name.seal",
        defaultMessage: "Anonymous Seal"
    },
    seedling: {
        id: "platform.anonymous-asset-name.seedling",
        defaultMessage: "Anonymous Seedling"
    },
    shark: {
        id: "platform.anonymous-asset-name.shark",
        defaultMessage: "Anonymous Shark"
    },
    shrimp: {
        id: "platform.anonymous-asset-name.shrimp",
        defaultMessage: "Anonymous Shrimp"
    },
    skunk: {
        id: "platform.anonymous-asset-name.skunk",
        defaultMessage: "Anonymous Skunk"
    },
    sloth: {
        id: "platform.anonymous-asset-name.sloth",
        defaultMessage: "Anonymous Sloth"
    },
    snail: {
        id: "platform.anonymous-asset-name.snail",
        defaultMessage: "Anonymous Snail"
    },
    snake: {
        id: "platform.anonymous-asset-name.snake",
        defaultMessage: "Anonymous Snake"
    },
    snowman: {
        id: "platform.anonymous-asset-name.snowman",
        defaultMessage: "Anonymous Snowman"
    },
    squid: {
        id: "platform.anonymous-asset-name.squid",
        defaultMessage: "Anonymous Squid"
    },
    squirrel: {
        id: "platform.anonymous-asset-name.squirrel",
        defaultMessage: "Anonymous Squirrel"
    },
    strawberry: {
        id: "platform.anonymous-asset-name.strawberry",
        defaultMessage: "Anonymous Strawberry"
    },
    sunfish: {
        id: "platform.anonymous-asset-name.sunfish",
        defaultMessage: "Anonymous Sunfish"
    },
    sunflower: {
        id: "platform.anonymous-asset-name.sunflower",
        defaultMessage: "Anonymous Sunflower"
    },
    tiger: {
        id: "platform.anonymous-asset-name.tiger",
        defaultMessage: "Anonymous Tiger"
    },
    tomato: {
        id: "platform.anonymous-asset-name.tomato",
        defaultMessage: "Anonymous Tomato"
    },
    tortoise: {
        id: "platform.anonymous-asset-name.tortoise",
        defaultMessage: "Anonymous Tortoise"
    },
    tree: {
        id: "platform.anonymous-asset-name.tree",
        defaultMessage: "Anonymous Tree"
    },
    trex: {
        id: "platform.anonymous-asset-name.trex",
        defaultMessage: "Anonymous T-rex"
    },
    trout: {
        id: "platform.anonymous-asset-name.trout",
        defaultMessage: "Anonymous Trout"
    },
    turkey: {
        id: "platform.anonymous-asset-name.turkey",
        defaultMessage: "Anonymous Turkey"
    },
    turtle: {
        id: "platform.anonymous-asset-name.turtle",
        defaultMessage: "Anonymous Turtle"
    },
    wasp: {
        id: "platform.anonymous-asset-name.wasp",
        defaultMessage: "Anonymous Wasp"
    },
    watermelon: {
        id: "platform.anonymous-asset-name.watermelon",
        defaultMessage: "Anonymous Watermelon"
    },
    whale: {
        id: "platform.anonymous-asset-name.whale",
        defaultMessage: "Anonymous Whale"
    },
    wolf: {
        id: "platform.anonymous-asset-name.wolf",
        defaultMessage: "Anonymous Wolf"
    }
});
module.exports["messages"] = $52c1b6ebf0043fde$export$defe85febe8b728c;

});

parcelRegister("hDQT9", function(module, exports) {
module.exports = new URL("apple.ee886279.svg", import.meta.url).toString();

});

parcelRegister("01Y7m", function(module, exports) {
module.exports = new URL("avocado.8855629b.svg", import.meta.url).toString();

});

parcelRegister("hYUzZ", function(module, exports) {
module.exports = new URL("badger.0fb3ff8d.svg", import.meta.url).toString();

});

parcelRegister("iuR2u", function(module, exports) {
module.exports = new URL("bat.3a3e8172.svg", import.meta.url).toString();

});

parcelRegister("kkbx9", function(module, exports) {
module.exports = new URL("bear.6250dade.svg", import.meta.url).toString();

});

parcelRegister("cFEKY", function(module, exports) {
module.exports = new URL("beaver.72239cbc.svg", import.meta.url).toString();

});

parcelRegister("6Ytc9", function(module, exports) {
module.exports = new URL("bee.1d8bfe50.svg", import.meta.url).toString();

});

parcelRegister("6I2hp", function(module, exports) {
module.exports = new URL("bison.4fe77735.svg", import.meta.url).toString();

});

parcelRegister("9jRbs", function(module, exports) {
module.exports = new URL("blossom.90b2a1c3.svg", import.meta.url).toString();

});

parcelRegister("doHfX", function(module, exports) {
module.exports = new URL("blowfish.8afad7f1.svg", import.meta.url).toString();

});

parcelRegister("iQQz2", function(module, exports) {
module.exports = new URL("blueberries.688d225d.svg", import.meta.url).toString();

});

parcelRegister("6aQGf", function(module, exports) {
module.exports = new URL("boar.15310caf.svg", import.meta.url).toString();

});

parcelRegister("rKSC9", function(module, exports) {
module.exports = new URL("broccoli.fa9fd55e.svg", import.meta.url).toString();

});

parcelRegister("1HhEl", function(module, exports) {
module.exports = new URL("butterfly.f41d19d4.svg", import.meta.url).toString();

});

parcelRegister("59SWb", function(module, exports) {
module.exports = new URL("cactus.0c5c265c.svg", import.meta.url).toString();

});

parcelRegister("sNNnf", function(module, exports) {
module.exports = new URL("camel.6111d481.svg", import.meta.url).toString();

});

parcelRegister("3lBYI", function(module, exports) {
module.exports = new URL("candy.ffd5e59f.svg", import.meta.url).toString();

});

parcelRegister("4xgJQ", function(module, exports) {
module.exports = new URL("capsicum.30f76734.svg", import.meta.url).toString();

});

parcelRegister("h2x1V", function(module, exports) {
module.exports = new URL("carrot.6193f6d7.svg", import.meta.url).toString();

});

parcelRegister("dpF2z", function(module, exports) {
module.exports = new URL("cat.154e1595.svg", import.meta.url).toString();

});

parcelRegister("1sURO", function(module, exports) {
module.exports = new URL("caterpiller.1b6fd239.svg", import.meta.url).toString();

});

parcelRegister("97Vlu", function(module, exports) {
module.exports = new URL("cherry.087938da.svg", import.meta.url).toString();

});

parcelRegister("kVpsY", function(module, exports) {
module.exports = new URL("chili.27401d1a.svg", import.meta.url).toString();

});

parcelRegister("hCuul", function(module, exports) {
module.exports = new URL("clover.296ea840.svg", import.meta.url).toString();

});

parcelRegister("fuLed", function(module, exports) {
module.exports = new URL("coconut.69480f00.svg", import.meta.url).toString();

});

parcelRegister("3kpwJ", function(module, exports) {
module.exports = new URL("cookie.099bb841.svg", import.meta.url).toString();

});

parcelRegister("ei5ou", function(module, exports) {
module.exports = new URL("corn.f527dc60.svg", import.meta.url).toString();

});

parcelRegister("jveHG", function(module, exports) {
module.exports = new URL("cow.e41482e6.svg", import.meta.url).toString();

});

parcelRegister("kG0T4", function(module, exports) {
module.exports = new URL("crab.39812367.svg", import.meta.url).toString();

});

parcelRegister("iq6me", function(module, exports) {
module.exports = new URL("crocodile.221fa99c.svg", import.meta.url).toString();

});

parcelRegister("amt9P", function(module, exports) {
module.exports = new URL("deer.3662e324.svg", import.meta.url).toString();

});

parcelRegister("unK7p", function(module, exports) {
module.exports = new URL("dinosaur.e5c6efb5.svg", import.meta.url).toString();

});

parcelRegister("7myjl", function(module, exports) {
module.exports = new URL("dodo.a7114237.svg", import.meta.url).toString();

});

parcelRegister("c3CGq", function(module, exports) {
module.exports = new URL("dog.6630bd37.svg", import.meta.url).toString();

});

parcelRegister("73XLd", function(module, exports) {
module.exports = new URL("dolphin.3052ec02.svg", import.meta.url).toString();

});

parcelRegister("4O6RS", function(module, exports) {
module.exports = new URL("donut.e4649522.svg", import.meta.url).toString();

});

parcelRegister("1GH6m", function(module, exports) {
module.exports = new URL("dragon.4b6d8278.svg", import.meta.url).toString();

});

parcelRegister("1HXyl", function(module, exports) {
module.exports = new URL("duck.e8819dfa.svg", import.meta.url).toString();

});

parcelRegister("htAoo", function(module, exports) {
module.exports = new URL("elephant.f64545b1.svg", import.meta.url).toString();

});

parcelRegister("0547j", function(module, exports) {
module.exports = new URL("fish.91063cf4.svg", import.meta.url).toString();

});

parcelRegister("cgVUh", function(module, exports) {
module.exports = new URL("flamingo.2d59f884.svg", import.meta.url).toString();

});

parcelRegister("cQ8lp", function(module, exports) {
module.exports = new URL("fox.c1068dfa.svg", import.meta.url).toString();

});

parcelRegister("5JQ20", function(module, exports) {
module.exports = new URL("frog.4c69f05a.svg", import.meta.url).toString();

});

parcelRegister("2YPi6", function(module, exports) {
module.exports = new URL("giraffe.65216e18.svg", import.meta.url).toString();

});

parcelRegister("cdkwi", function(module, exports) {
module.exports = new URL("gorilla.51f05093.svg", import.meta.url).toString();

});

parcelRegister("kh1OZ", function(module, exports) {
module.exports = new URL("grapes.6a50728f.svg", import.meta.url).toString();

});

parcelRegister("8Sl6f", function(module, exports) {
module.exports = new URL("hedgehog.4cc9668b.svg", import.meta.url).toString();

});

parcelRegister("9Qn7m", function(module, exports) {
module.exports = new URL("hippo.81684e99.svg", import.meta.url).toString();

});

parcelRegister("3vrZh", function(module, exports) {
module.exports = new URL("kangaroo.099f9dd4.svg", import.meta.url).toString();

});

parcelRegister("2InqY", function(module, exports) {
module.exports = new URL("kiwi.13ce1a05.svg", import.meta.url).toString();

});

parcelRegister("dWYu6", function(module, exports) {
module.exports = new URL("koala.730a01eb.svg", import.meta.url).toString();

});

parcelRegister("e4PgN", function(module, exports) {
module.exports = new URL("lemon.7d7dfe19.svg", import.meta.url).toString();

});

parcelRegister("19hVO", function(module, exports) {
module.exports = new URL("lettuce.39b86ec6.svg", import.meta.url).toString();

});

parcelRegister("2UNgz", function(module, exports) {
module.exports = new URL("lion.191125b1.svg", import.meta.url).toString();

});

parcelRegister("fVzqf", function(module, exports) {
module.exports = new URL("lizard.de3c3103.svg", import.meta.url).toString();

});

parcelRegister("lj2Ls", function(module, exports) {
module.exports = new URL("llama.d767d641.svg", import.meta.url).toString();

});

parcelRegister("fr7Nb", function(module, exports) {
module.exports = new URL("lobster.2b4a4d94.svg", import.meta.url).toString();

});

parcelRegister("3Xksf", function(module, exports) {
module.exports = new URL("mango.6b9252cb.svg", import.meta.url).toString();

});

parcelRegister("bBmIz", function(module, exports) {
module.exports = new URL("melon.9c97f1e1.svg", import.meta.url).toString();

});

parcelRegister("gYk9S", function(module, exports) {
module.exports = new URL("monkey.423f2177.svg", import.meta.url).toString();

});

parcelRegister("iii2c", function(module, exports) {
module.exports = new URL("mouse.3d0aefe8.svg", import.meta.url).toString();

});

parcelRegister("2AIpZ", function(module, exports) {
module.exports = new URL("octopus.2c0d1056.svg", import.meta.url).toString();

});

parcelRegister("apAKP", function(module, exports) {
module.exports = new URL("olive.3e3e2c53.svg", import.meta.url).toString();

});

parcelRegister("eHyqm", function(module, exports) {
module.exports = new URL("orange.ed5e97f9.svg", import.meta.url).toString();

});

parcelRegister("3qxDD", function(module, exports) {
module.exports = new URL("orangutan.9fa13362.svg", import.meta.url).toString();

});

parcelRegister("eHLy0", function(module, exports) {
module.exports = new URL("otter.1b9e17fe.svg", import.meta.url).toString();

});

parcelRegister("kdS3N", function(module, exports) {
module.exports = new URL("owl.13d3c4d9.svg", import.meta.url).toString();

});

parcelRegister("1Sij2", function(module, exports) {
module.exports = new URL("ox.0ed06fd3.svg", import.meta.url).toString();

});

parcelRegister("3pGfT", function(module, exports) {
module.exports = new URL("oyster.ad23795d.svg", import.meta.url).toString();

});

parcelRegister("4LuNj", function(module, exports) {
module.exports = new URL("panda.0b0047af.svg", import.meta.url).toString();

});

parcelRegister("9gWob", function(module, exports) {
module.exports = new URL("parrot.6fd92eec.svg", import.meta.url).toString();

});

parcelRegister("dRNzY", function(module, exports) {
module.exports = new URL("peacock.80ac60a6.svg", import.meta.url).toString();

});

parcelRegister("iMJSX", function(module, exports) {
module.exports = new URL("pear.c8d37fb0.svg", import.meta.url).toString();

});

parcelRegister("5cLsu", function(module, exports) {
module.exports = new URL("penguin.6577e559.svg", import.meta.url).toString();

});

parcelRegister("iN75X", function(module, exports) {
module.exports = new URL("pig.2ba131ea.svg", import.meta.url).toString();

});

parcelRegister("dKZNQ", function(module, exports) {
module.exports = new URL("pineapple.61ebb967.svg", import.meta.url).toString();

});

parcelRegister("3N5nT", function(module, exports) {
module.exports = new URL("poodle.b40487d6.svg", import.meta.url).toString();

});

parcelRegister("gAbKd", function(module, exports) {
module.exports = new URL("rabbit.b4ce71c1.svg", import.meta.url).toString();

});

parcelRegister("3KwZg", function(module, exports) {
module.exports = new URL("raccoon.16b4372e.svg", import.meta.url).toString();

});

parcelRegister("53QJP", function(module, exports) {
module.exports = new URL("rhino.6dcdebb2.svg", import.meta.url).toString();

});

parcelRegister("3tNjt", function(module, exports) {
module.exports = new URL("robot.fdf311ba.svg", import.meta.url).toString();

});

parcelRegister("1QOVp", function(module, exports) {
module.exports = new URL("rose.22a6e8e6.svg", import.meta.url).toString();

});

parcelRegister("8BdMq", function(module, exports) {
module.exports = new URL("seal.de226e3b.svg", import.meta.url).toString();

});

parcelRegister("kzKxq", function(module, exports) {
module.exports = new URL("seedling.562f3bc0.svg", import.meta.url).toString();

});

parcelRegister("2bFMn", function(module, exports) {
module.exports = new URL("shark.af44e0c5.svg", import.meta.url).toString();

});

parcelRegister("1mGLL", function(module, exports) {
module.exports = new URL("shrimp.116d9eea.svg", import.meta.url).toString();

});

parcelRegister("6hNPs", function(module, exports) {
module.exports = new URL("skunk.a5578a4f.svg", import.meta.url).toString();

});

parcelRegister("swN6A", function(module, exports) {
module.exports = new URL("sloth.f3e9da22.svg", import.meta.url).toString();

});

parcelRegister("jlxMa", function(module, exports) {
module.exports = new URL("snail.06380b65.svg", import.meta.url).toString();

});

parcelRegister("hY9h4", function(module, exports) {
module.exports = new URL("snake.3ead898b.svg", import.meta.url).toString();

});

parcelRegister("21edV", function(module, exports) {
module.exports = new URL("snowman.cdcd9574.svg", import.meta.url).toString();

});

parcelRegister("i42iL", function(module, exports) {
module.exports = new URL("squid.0638299b.svg", import.meta.url).toString();

});

parcelRegister("5brqg", function(module, exports) {
module.exports = new URL("squirrel.e3a31ee3.svg", import.meta.url).toString();

});

parcelRegister("55gO3", function(module, exports) {
module.exports = new URL("strawberry.4111dfb6.svg", import.meta.url).toString();

});

parcelRegister("2cB6n", function(module, exports) {
module.exports = new URL("sunflower.ff291a55.svg", import.meta.url).toString();

});

parcelRegister("drBaG", function(module, exports) {
module.exports = new URL("tiger.2ba2da26.svg", import.meta.url).toString();

});

parcelRegister("6OMjq", function(module, exports) {
module.exports = new URL("tomato.e755033f.svg", import.meta.url).toString();

});

parcelRegister("8MYut", function(module, exports) {
module.exports = new URL("tree.e62f2602.svg", import.meta.url).toString();

});

parcelRegister("j8C9j", function(module, exports) {
module.exports = new URL("t-rex.d85831fb.svg", import.meta.url).toString();

});

parcelRegister("6yJEz", function(module, exports) {
module.exports = new URL("tropical-fish.797d455e.svg", import.meta.url).toString();

});

parcelRegister("dtUp6", function(module, exports) {
module.exports = new URL("turkey.a79defab.svg", import.meta.url).toString();

});

parcelRegister("isP63", function(module, exports) {
module.exports = new URL("turtle.acbe0058.svg", import.meta.url).toString();

});

parcelRegister("9lleE", function(module, exports) {
module.exports = new URL("watermelon.199e013c.svg", import.meta.url).toString();

});

parcelRegister("5uWd9", function(module, exports) {
module.exports = new URL("whale.cc048b8e.svg", import.meta.url).toString();

});

parcelRegister("iIHIG", function(module, exports) {
module.exports = new URL("wolf.a39956da.svg", import.meta.url).toString();

});

parcelRegister("ecHHC", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $haNN4 = parcelRequire("haNN4");


var $2EIXa = parcelRequire("2EIXa");


var $1XjTg = parcelRequire("1XjTg");

const $3bd1d010186fe7d0$var$localeMap = {
    pt: 'pt-BR',
    'pt-PT': 'pt-BR',
    'en-AU': 'en-GB'
};
const $3bd1d010186fe7d0$var$intlCacheMap = new Map();
const $3bd1d010186fe7d0$export$51771ec7613ad564 = async ()=>{
    const key = (0, $haNN4.getDocument)()?.documentElement?.lang || 'en-US';
    if (!$3bd1d010186fe7d0$var$intlCacheMap.has(key)) {
        const messages = await $3bd1d010186fe7d0$var$fetchMessages(key);
        const cache = (0, $kSwu1.createIntlCache)();
        const intl = (0, $kSwu1.createIntl)({
            locale: key,
            messages: messages
        }, cache);
        $3bd1d010186fe7d0$var$intlCacheMap.set(key, intl);
    }
    return $3bd1d010186fe7d0$var$intlCacheMap.get(key);
};
const $3bd1d010186fe7d0$var$fetchMessages = async (locale)=>{
    try {
        const targetLocale = ($3bd1d010186fe7d0$var$localeMap[locale] ?? locale ?? '').replace('-', '_');
        if (targetLocale in (0, $2EIXa.locales)) {
            const messages = await (0, $2EIXa.locales)[targetLocale]();
            return messages.default;
        }
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $2EIXa.locales)) {
            const messages = await (0, $2EIXa.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    /**
   * English bundled by default as this is the majority of users
   */ return 0, $1XjTg.default;
};
module.exports["getIntl"] = $3bd1d010186fe7d0$export$51771ec7613ad564;

});

parcelRegister("2EIXa", function(module, exports) {




























const $85bfd356356e38c7$export$df1c34db1371eeed = {
    en: ()=>Promise.resolve((parcelRequire("1XjTg"))),
    cs: ()=>(parcelRequire("c5iVz")),
    da: ()=>(parcelRequire("cKTv6")),
    de: ()=>(parcelRequire("ba7qQ")),
    en_GB: ()=>(parcelRequire("fIKLP")),
    en_ZZ: ()=>(parcelRequire("lVpcM")),
    es: ()=>(parcelRequire("5MC3a")),
    fi: ()=>(parcelRequire("lbr9Z")),
    fr: ()=>(parcelRequire("gfgLh")),
    hr: ()=>(parcelRequire("icWxs")),
    hu: ()=>(parcelRequire("l4lhV")),
    it: ()=>(parcelRequire("8txuZ")),
    ja: ()=>(parcelRequire("lcXoz")),
    ko: ()=>(parcelRequire("e5NrO")),
    nb: ()=>(parcelRequire("b8oPP")),
    nl: ()=>(parcelRequire("imK3v")),
    pl: ()=>(parcelRequire("lvXZc")),
    pt_BR: ()=>(parcelRequire("fojwr")),
    ru: ()=>(parcelRequire("g4Br4")),
    sr_RS: ()=>(parcelRequire("hnd9o")),
    sr_YR: ()=>(parcelRequire("hILXZ")),
    sv: ()=>(parcelRequire("lejHX")),
    th: ()=>(parcelRequire("ka0If")),
    tr: ()=>(parcelRequire("36Auo")),
    uk: ()=>(parcelRequire("9eUA6")),
    vi: ()=>(parcelRequire("kytde")),
    zh: ()=>(parcelRequire("4xtb4")),
    zh_TW: ()=>(parcelRequire("c0Rct"))
};
module.exports["locales"] = $85bfd356356e38c7$export$df1c34db1371eeed;

});

parcelRegister("c5iVz", function(module, exports) {

let $8cc4a2443282ceff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8cc4a2443282ceff$var$load("8QW6R").then(()=>parcelRequire('4mdX2'));

});

parcelRegister("cKTv6", function(module, exports) {

let $9494d53681d834cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9494d53681d834cb$var$load("awxdk").then(()=>parcelRequire('eyLXS'));

});

parcelRegister("ba7qQ", function(module, exports) {

let $820664b746ea9374$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $820664b746ea9374$var$load("5mEC2").then(()=>parcelRequire('55NFn'));

});

parcelRegister("fIKLP", function(module, exports) {

let $b71f3eb9195aa892$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b71f3eb9195aa892$var$load("fu2xp").then(()=>parcelRequire('czahw'));

});

parcelRegister("lVpcM", function(module, exports) {

let $ff62790ade421c02$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ff62790ade421c02$var$load("5zM7C").then(()=>parcelRequire('dTXdc'));

});

parcelRegister("5MC3a", function(module, exports) {

let $435ef369ce6bcd83$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $435ef369ce6bcd83$var$load("batm0").then(()=>parcelRequire('4u9wg'));

});

parcelRegister("lbr9Z", function(module, exports) {

let $f6bfb18052abcbf3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f6bfb18052abcbf3$var$load("3AVnS").then(()=>parcelRequire('4ntN9'));

});

parcelRegister("gfgLh", function(module, exports) {

let $bd3b0c896a7b5931$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bd3b0c896a7b5931$var$load("51j60").then(()=>parcelRequire('02VrM'));

});

parcelRegister("icWxs", function(module, exports) {

let $d416c18bc8da1813$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d416c18bc8da1813$var$load("2b71C").then(()=>parcelRequire('9tr0O'));

});

parcelRegister("l4lhV", function(module, exports) {

let $f56a7c183817b9d7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f56a7c183817b9d7$var$load("2JFq0").then(()=>parcelRequire('fQhwW'));

});

parcelRegister("8txuZ", function(module, exports) {

let $62bb0457f716dbd3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $62bb0457f716dbd3$var$load("5f16k").then(()=>parcelRequire('gdp3a'));

});

parcelRegister("lcXoz", function(module, exports) {

let $f708ca9bf4c70287$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f708ca9bf4c70287$var$load("56V0s").then(()=>parcelRequire('8GtTX'));

});

parcelRegister("e5NrO", function(module, exports) {

let $a427e3982aeb4a03$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a427e3982aeb4a03$var$load("l8lGz").then(()=>parcelRequire('aYRuH'));

});

parcelRegister("b8oPP", function(module, exports) {

let $81b3b4c4c8461dbb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $81b3b4c4c8461dbb$var$load("hlqmT").then(()=>parcelRequire('14Tag'));

});

parcelRegister("imK3v", function(module, exports) {

let $d5ee01ba6cbe8436$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d5ee01ba6cbe8436$var$load("2s2yj").then(()=>parcelRequire('iMXzI'));

});

parcelRegister("lvXZc", function(module, exports) {

let $fa9b0632ba688ead$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fa9b0632ba688ead$var$load("8ozt0").then(()=>parcelRequire('h20wn'));

});

parcelRegister("fojwr", function(module, exports) {

let $b3483da11a3b950e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b3483da11a3b950e$var$load("g88j4").then(()=>parcelRequire('8J3ag'));

});

parcelRegister("g4Br4", function(module, exports) {

let $bb3a0efcec506624$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bb3a0efcec506624$var$load("fev14").then(()=>parcelRequire('hWxo6'));

});

parcelRegister("hnd9o", function(module, exports) {

let $ca5ec90f467ce7de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ca5ec90f467ce7de$var$load("9PBHw").then(()=>parcelRequire('9hkS6'));

});

parcelRegister("hILXZ", function(module, exports) {

let $ce6bc0e0a0642b0c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ce6bc0e0a0642b0c$var$load("1L95h").then(()=>parcelRequire('cDAjj'));

});

parcelRegister("lejHX", function(module, exports) {

let $f74a3165a8a03385$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f74a3165a8a03385$var$load("jtWXB").then(()=>parcelRequire('gblRe'));

});

parcelRegister("ka0If", function(module, exports) {

let $ead54b51938002ef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ead54b51938002ef$var$load("hY0sT").then(()=>parcelRequire('kCJ7N'));

});

parcelRegister("36Auo", function(module, exports) {

let $242e3c9e966f6b26$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $242e3c9e966f6b26$var$load("itQsm").then(()=>parcelRequire('aOIVH'));

});

parcelRegister("9eUA6", function(module, exports) {

let $6ba14fb6b210bd41$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6ba14fb6b210bd41$var$load("jMJn5").then(()=>parcelRequire('iW3aI'));

});

parcelRegister("kytde", function(module, exports) {

let $ef6da49931e0d3f3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ef6da49931e0d3f3$var$load("1wgqd").then(()=>parcelRequire('evzRl'));

});

parcelRegister("4xtb4", function(module, exports) {

let $34e0e0881054a2f0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $34e0e0881054a2f0$var$load("fv30i").then(()=>parcelRequire('lWYHM'));

});

parcelRegister("c0Rct", function(module, exports) {

let $0241c94c98c6e436$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0241c94c98c6e436$var$load("hL7rW").then(()=>parcelRequire('3cYOH'));

});

parcelRegister("1XjTg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $e1e566f32a0c97fd$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $hkAF2 = parcelRequire("hkAF2");

var $e1e566f32a0c97fd$export$2e2bcd8739ae039 = (0, $hkAF2.default);

});

parcelRegister("hkAF2", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4e8f77ee27d7e3a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $a4e8f77ee27d7e3a$export$2e2bcd8739ae039 = {
    'platform.anonymous-asset-name.alligator': 'Anonymous Alligator',
    'platform.anonymous-asset-name.alpaca': 'Anonymous Alpaca',
    'platform.anonymous-asset-name.ape': 'Anonymous Ape',
    'platform.anonymous-asset-name.apple': 'Anonymous Apple',
    'platform.anonymous-asset-name.avocado': 'Anonymous Avocado',
    'platform.anonymous-asset-name.baboon': 'Anonymous Baboon',
    'platform.anonymous-asset-name.badger': 'Anonymous Badger',
    'platform.anonymous-asset-name.bat': 'Anonymous Bat',
    'platform.anonymous-asset-name.bear': 'Anonymous Bear',
    'platform.anonymous-asset-name.beaver': 'Anonymous Beaver',
    'platform.anonymous-asset-name.bee': 'Anonymous Bee',
    'platform.anonymous-asset-name.bird': 'Anonymous Bird',
    'platform.anonymous-asset-name.bison': 'Anonymous Bison',
    'platform.anonymous-asset-name.blobfish': 'Anonymous Blobfish',
    'platform.anonymous-asset-name.blossom': 'Anonymous Blossom',
    'platform.anonymous-asset-name.blowfish': 'Anonymous Blowfish',
    'platform.anonymous-asset-name.blueberries': 'Anonymous Blueberries',
    'platform.anonymous-asset-name.boar': 'Anonymous Boar',
    'platform.anonymous-asset-name.broccoli': 'Anonymous Broccoli',
    'platform.anonymous-asset-name.buffalo': 'Anonymous Buffalo',
    'platform.anonymous-asset-name.bug': 'Anonymous Bug',
    'platform.anonymous-asset-name.bull': 'Anonymous Bull',
    'platform.anonymous-asset-name.bunny': 'Anonymous Bunny',
    'platform.anonymous-asset-name.butterfly': 'Anonymous Butterfly',
    'platform.anonymous-asset-name.cactus': 'Anonymous Cactus',
    'platform.anonymous-asset-name.camel': 'Anonymous Camel',
    'platform.anonymous-asset-name.candy': 'Anonymous Candy',
    'platform.anonymous-asset-name.cantaloupe': 'Anonymous Cantaloupe',
    'platform.anonymous-asset-name.capsicum': 'Anonymous Capsicum',
    'platform.anonymous-asset-name.carrot': 'Anonymous Carrot',
    'platform.anonymous-asset-name.cat': 'Anonymous Cat',
    'platform.anonymous-asset-name.caterpiller': 'Anonymous Caterpiller',
    'platform.anonymous-asset-name.chameleon': 'Anonymous Chameleon',
    'platform.anonymous-asset-name.cherry': 'Anonymous Cherry',
    'platform.anonymous-asset-name.chili': 'Anonymous Chili',
    'platform.anonymous-asset-name.chimp': 'Anonymous Chimp',
    'platform.anonymous-asset-name.chimpanzee': 'Anonymous Chimpanzee',
    'platform.anonymous-asset-name.clover': 'Anonymous Clover',
    'platform.anonymous-asset-name.clownfish': 'Anonymous Clownfish',
    'platform.anonymous-asset-name.cobra': 'Anonymous Cobra',
    'platform.anonymous-asset-name.coconut': 'Anonymous Coconut',
    'platform.anonymous-asset-name.cod': 'Anonymous Cod',
    'platform.anonymous-asset-name.cookie': 'Anonymous Cookie',
    'platform.anonymous-asset-name.corn': 'Anonymous Corn',
    'platform.anonymous-asset-name.cow': 'Anonymous Cow',
    'platform.anonymous-asset-name.crab': 'Anonymous Crab',
    'platform.anonymous-asset-name.crocodile': 'Anonymous Crocodile',
    'platform.anonymous-asset-name.deer': 'Anonymous Deer',
    'platform.anonymous-asset-name.dinosaur': 'Anonymous Dinosaur',
    'platform.anonymous-asset-name.dodo': 'Anonymous Dodo',
    'platform.anonymous-asset-name.dog': 'Anonymous Dog',
    'platform.anonymous-asset-name.dolphin': 'Anonymous Dolphin',
    'platform.anonymous-asset-name.donut': 'Anonymous Donut',
    'platform.anonymous-asset-name.dragon': 'Anonymous Dragon',
    'platform.anonymous-asset-name.duck': 'Anonymous Duck',
    'platform.anonymous-asset-name.elephant': 'Anonymous Elephant',
    'platform.anonymous-asset-name.elk': 'Anonymous Elk',
    'platform.anonymous-asset-name.fish': 'Anonymous Fish',
    'platform.anonymous-asset-name.flamingo': 'Anonymous Flamingo',
    'platform.anonymous-asset-name.fox': 'Anonymous Fox',
    'platform.anonymous-asset-name.frog': 'Anonymous Frog',
    'platform.anonymous-asset-name.gecko': 'Anonymous Gecko',
    'platform.anonymous-asset-name.giraffe': 'Anonymous Giraffe',
    'platform.anonymous-asset-name.gorilla': 'Anonymous Gorilla',
    'platform.anonymous-asset-name.grape': 'Anonymous Grape',
    'platform.anonymous-asset-name.hammerhead': 'Anonymous Hammerhead',
    'platform.anonymous-asset-name.hedgehog': 'Anonymous Hedgehog',
    'platform.anonymous-asset-name.hippo': 'Anonymous Hippo',
    'platform.anonymous-asset-name.kangaroo': 'Anonymous Kangaroo',
    'platform.anonymous-asset-name.kitten': 'Anonymous Kitten',
    'platform.anonymous-asset-name.kiwi': 'Anonymous Kiwi',
    'platform.anonymous-asset-name.koala': 'Anonymous Koala',
    'platform.anonymous-asset-name.lemon': 'Anonymous Lemon',
    'platform.anonymous-asset-name.leopard': 'Anonymous Leopard',
    'platform.anonymous-asset-name.lettuce': 'Anonymous Lettuce',
    'platform.anonymous-asset-name.lion': 'Anonymous Lion',
    'platform.anonymous-asset-name.lizard': 'Anonymous Lizard',
    'platform.anonymous-asset-name.llama': 'Anonymous Llama',
    'platform.anonymous-asset-name.lobster': 'Anonymous Lobster',
    'platform.anonymous-asset-name.macaque': 'Anonymous Macaque',
    'platform.anonymous-asset-name.mango': 'Anonymous Mango',
    'platform.anonymous-asset-name.melon': 'Anonymous Melon',
    'platform.anonymous-asset-name.millipede': 'Anonymous Millipede',
    'platform.anonymous-asset-name.monkey': 'Anonymous Monkey',
    'platform.anonymous-asset-name.mouse': 'Anonymous Mouse',
    'platform.anonymous-asset-name.octopus': 'Anonymous Octopus',
    'platform.anonymous-asset-name.olive': 'Anonymous Olive',
    'platform.anonymous-asset-name.orange': 'Anonymous Orange',
    'platform.anonymous-asset-name.orangutan': 'Anonymous Orangutan',
    'platform.anonymous-asset-name.otter': 'Anonymous Otter',
    'platform.anonymous-asset-name.owl': 'Anonymous Owl',
    'platform.anonymous-asset-name.ox': 'Anonymous Ox',
    'platform.anonymous-asset-name.oyster': 'Anonymous Oyster',
    'platform.anonymous-asset-name.panda': 'Anonymous Panda',
    'platform.anonymous-asset-name.parrot': 'Anonymous Parrot',
    'platform.anonymous-asset-name.peacock': 'Anonymous Peacock',
    'platform.anonymous-asset-name.pear': 'Anonymous Pear',
    'platform.anonymous-asset-name.penguin': 'Anonymous Penguin',
    'platform.anonymous-asset-name.pig': 'Anonymous Pig',
    'platform.anonymous-asset-name.pineapple': 'Anonymous Pineapple',
    'platform.anonymous-asset-name.poodle': 'Anonymous Poodle',
    'platform.anonymous-asset-name.puppy': 'Anonymous Puppy',
    'platform.anonymous-asset-name.python': 'Anonymous Python',
    'platform.anonymous-asset-name.rabbit': 'Anonymous Rabbit',
    'platform.anonymous-asset-name.raccoon': 'Anonymous Raccoon',
    'platform.anonymous-asset-name.rat': 'Anonymous Rat',
    'platform.anonymous-asset-name.rhino': 'Anonymous Rhino',
    'platform.anonymous-asset-name.robot': 'Anonymous Robot',
    'platform.anonymous-asset-name.rose': 'Anonymous Rose',
    'platform.anonymous-asset-name.seal': 'Anonymous Seal',
    'platform.anonymous-asset-name.seedling': 'Anonymous Seedling',
    'platform.anonymous-asset-name.shark': 'Anonymous Shark',
    'platform.anonymous-asset-name.shrimp': 'Anonymous Shrimp',
    'platform.anonymous-asset-name.skunk': 'Anonymous Skunk',
    'platform.anonymous-asset-name.sloth': 'Anonymous Sloth',
    'platform.anonymous-asset-name.snail': 'Anonymous Snail',
    'platform.anonymous-asset-name.snake': 'Anonymous Snake',
    'platform.anonymous-asset-name.snowman': 'Anonymous Snowman',
    'platform.anonymous-asset-name.squid': 'Anonymous Squid',
    'platform.anonymous-asset-name.squirrel': 'Anonymous Squirrel',
    'platform.anonymous-asset-name.strawberry': 'Anonymous Strawberry',
    'platform.anonymous-asset-name.sunfish': 'Anonymous Sunfish',
    'platform.anonymous-asset-name.sunflower': 'Anonymous Sunflower',
    'platform.anonymous-asset-name.tiger': 'Anonymous Tiger',
    'platform.anonymous-asset-name.tomato': 'Anonymous Tomato',
    'platform.anonymous-asset-name.tortoise': 'Anonymous Tortoise',
    'platform.anonymous-asset-name.tree': 'Anonymous Tree',
    'platform.anonymous-asset-name.trex': 'Anonymous T-rex',
    'platform.anonymous-asset-name.trout': 'Anonymous Trout',
    'platform.anonymous-asset-name.turkey': 'Anonymous Turkey',
    'platform.anonymous-asset-name.turtle': 'Anonymous Turtle',
    'platform.anonymous-asset-name.wasp': 'Anonymous Wasp',
    'platform.anonymous-asset-name.watermelon': 'Anonymous Watermelon',
    'platform.anonymous-asset-name.whale': 'Anonymous Whale',
    'platform.anonymous-asset-name.wolf': 'Anonymous Wolf'
};

});

parcelRegister("9mfmQ", function(module, exports) {
const $3f8e2a2fed025998$export$435a991cb82816ff = (retryCount, initialDelay = 1000, maxDelay = 30000, factor = 2)=>{
    // Calculate exponential backoff
    const delay = Math.min(initialDelay * Math.pow(factor, retryCount), maxDelay);
    // Add random jitter (between 0 and current delay value)
    return Math.floor(Math.random() * delay);
};
const $3f8e2a2fed025998$export$cffaac380b94df26 = async ({ url: url, options: options, shouldRetryOnApiError: shouldRetryOnApiError, retries: retries = 3, baseDelay: baseDelay = 300, maxDelay: maxDelay = 10000 })=>{
    try {
        const response = await fetch(url, options);
        if (response.ok) return {
            success: true,
            result: response
        };
        if (shouldRetryOnApiError) throw new Error('Failed request with an error');
        const errorBody = await response.json();
        return {
            success: false,
            error: new Error(errorBody)
        };
    } catch (error) {
        if (retries > 0) {
            const retryDelay = $3f8e2a2fed025998$export$435a991cb82816ff(retries, baseDelay, maxDelay);
            await new Promise((resolve)=>setTimeout(resolve, retryDelay));
            return $3f8e2a2fed025998$export$cffaac380b94df26({
                url: url,
                options: options,
                shouldRetryOnApiError: shouldRetryOnApiError,
                retries: retries - 1,
                baseDelay: baseDelay,
                maxDelay: maxDelay
            });
        }
        const newError = error instanceof Error ? error : new Error('An unknown error occurred');
        return {
            success: false,
            error: newError
        };
    }
};
module.exports["fetchWithRetry"] = $3f8e2a2fed025998$export$cffaac380b94df26;

});

parcelRegister("5Za2S", function(module, exports) {

var $hBkCm = parcelRequire("hBkCm");


var $04e9M = parcelRequire("04e9M");


var $9137z = parcelRequire("9137z");


var $j8hiR = parcelRequire("j8hiR");


var $747ya = parcelRequire("747ya");


var $iby4Y = parcelRequire("iby4Y");

const $8ae4f0f25e352c24$var$STATUS_NOT_FOUND = 404;
const $8ae4f0f25e352c24$var$performRecovery = async (contentId)=>{
    return (0, $iby4Y.experimentalResetCollabServiceMutate)({
        variables: {
            behind: 'COLLAB',
            contentId: contentId
        }
    });
};
const $8ae4f0f25e352c24$var$fireDraftFailureEvent = (error, recoverySucceeded, recoveryError)=>{
    (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
        client.sendOperationalEvent({
            source: 'NativeCollabProvider',
            action: 'getDraft',
            actionSubject: 'failure',
            attributes: {
                error: error,
                recoverySucceeded: recoverySucceeded,
                recoveryError: recoveryError
            }
        });
    });
};
const $8ae4f0f25e352c24$var$fireDraftFetchEvent = (state)=>{
    (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
        client.sendOperationalEvent({
            source: 'NativeCollabProvider',
            action: 'sentRequest',
            actionSubject: 'NcsDraftEndpoint',
            attributes: {
                state: state
            }
        });
    });
};
const $8ae4f0f25e352c24$var$fetchDraftPromiseWithMetrics = (fetchDraftPromise)=>{
    return fetchDraftPromise.then((response)=>{
        if (response.error) $8ae4f0f25e352c24$var$fireDraftFetchEvent('failure');
        else $8ae4f0f25e352c24$var$fireDraftFetchEvent('success');
        return response;
    }).catch((error)=>{
        $8ae4f0f25e352c24$var$fireDraftFetchEvent('failure');
        throw error;
    });
};
const $8ae4f0f25e352c24$export$1a473231c51c1d5b = (contentId, draftShareId)=>$8ae4f0f25e352c24$export$9a3b244f90691dba(contentId, (0, $747ya.fetchDraft)(contentId, draftShareId));
const $8ae4f0f25e352c24$export$9a3b244f90691dba = (contentId, fetchDraftPromise)=>{
    (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_FETCH_NCS_DRAFT);
    return $8ae4f0f25e352c24$var$fetchDraftPromiseWithMetrics(fetchDraftPromise).then(async ({ draft: draft })=>{
        (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_FETCH_NCS_DRAFT);
        if (draft) {
            const version = draft?.version;
            if (!version) {
                (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                    client.sendOperationalEvent({
                        source: 'NativeCollabProvider',
                        action: 'getDraft',
                        actionSubject: 'version is 0',
                        attributes: {
                            version: version
                        }
                    });
                });
                return null;
            }
            return draft;
        }
        return null;
    }).catch((error)=>{
        (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_FETCH_NCS_DRAFT);
        if (error instanceof (0, $hBkCm.BadStatusError) && error?.response?.status === $8ae4f0f25e352c24$var$STATUS_NOT_FOUND) return $8ae4f0f25e352c24$var$performRecovery(contentId).then((_recoveryResponse)=>{
            $8ae4f0f25e352c24$var$fireDraftFailureEvent(error, true);
            return null;
        }).catch((recoveryError)=>{
            $8ae4f0f25e352c24$var$fireDraftFailureEvent(error, false, recoveryError);
            return null;
        });
        $8ae4f0f25e352c24$var$fireDraftFailureEvent(error, null);
        return null;
    });
};
module.exports["getDraft"] = $8ae4f0f25e352c24$export$1a473231c51c1d5b;
module.exports["getDraftFromPromise"] = $8ae4f0f25e352c24$export$9a3b244f90691dba;

});

parcelRegister("747ya", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");


var $6mKj3 = parcelRequire("6mKj3");


var $fqIt3 = parcelRequire("fqIt3");


var $nIvaQ = parcelRequire("nIvaQ");

async function $67d2826966f59cb2$export$af6160a01d539948(contentId, draftShareId) {
    // Use cache-first only if SSR rendered AND cache is not stale (within TTL)
    // This prevents stale data during SPA transitions while still benefiting from SSR cache
    const shouldUseCache = (0, $6mKj3.expValEquals)('platform_editor_collabdraft_query_improvements', 'isEnabled', true) ? window.__SSR_RENDERED__ || !(0, $fqIt3.isCollabDraftCacheStale)(contentId, draftShareId) : window.__SSR_RENDERED__;
    const response = await (0, $c0rhi.queryInterop)({
        query: (0, $nIvaQ.getCollabDraftQuery)(),
        variables: {
            id: contentId,
            hydrateAdf: true,
            ...draftShareId ? {
                draftShareId: draftShareId
            } : undefined
        },
        fetchPolicy: shouldUseCache ? 'cache-first' : 'network-only',
        __callerPackage__: "fabric-providers"
    });
    const { data: data, error: error } = response;
    if (error || !data?.collabDraft) return {
        draft: null,
        response: response
    };
    const { document: document, version: version, metadata: metadata } = data.collabDraft;
    const draft = {
        version: version,
        metadata: $67d2826966f59cb2$var$excludeTypename(metadata),
        document: JSON.parse(document || '')
    };
    return {
        draft: draft,
        response: response
    };
}
function $67d2826966f59cb2$var$excludeTypename(metadata) {
    if (!metadata) return metadata;
    const { __typename: __typename, ...rest } = metadata;
    return rest;
}
module.exports["fetchDraft"] = $67d2826966f59cb2$export$af6160a01d539948;

});

parcelRegister("iby4Y", function(module, exports) {

var $4GGNn = parcelRequire("4GGNn");


var $aBfpe = parcelRequire("aBfpe");


var $hBkCm = parcelRequire("hBkCm");

var $9kGfD = parcelRequire("9kGfD");


var $b4EKK = parcelRequire("b4EKK");

const $41df7c78720ad922$export$6d7c9d246960833d = ({ variables: variables })=>{
    return (0, $4GGNn.experimentalMutate)({
        url: `/wiki/rest/collab/1.0/content/${variables.contentId}/reset?behind=${variables.behind || 'COLLAB'}`,
        method: 'PUT',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        variables: variables,
        parseResponseOnSuccess: (response)=>({
                traceId: (0, $9kGfD.getTraceIdFromResponse)(response) ?? ''
            }),
        parseResult: (response)=>({
                experimentalResetCollabService: {
                    traceId: response.traceId
                }
            })
    }).catch(async (error)=>{
        const response = error instanceof (0, $hBkCm.BadStatusError) ? error.response : undefined;
        if (response) throw (0, $b4EKK.getErrorWithResponse)(error, response);
        throw error;
    });
};
module.exports["experimentalResetCollabServiceMutate"] = $41df7c78720ad922$export$6d7c9d246960833d;

});

parcelRegister("b4EKK", function(module, exports) {
function $9a7b0181c65e47f8$export$d882ca6820b0f4f3(error, response) {
    // Don't swallow the Response object, attach it to the error so the rest of
    // the app has a chance to see it e.g. OnErrorLink:
    if (typeof error === 'object' && error) {
        // At times our various resolver implementations interpret the JSON body of
        // non-OK responses as errors. And sometimes these errors contain a response
        // property (which may be an empty object) that leads to the loss of
        // Response information such as trace ID.
        if ('response' in error) {
            const existingErrorResponse = error.response;
            // Try to attach at least the trace ID to the existing error response:
            if (typeof existingErrorResponse === 'object' && existingErrorResponse) {
                // OnError's getResponseFromError needs the status property:
                if (!('status' in existingErrorResponse)) existingErrorResponse.status = response.status;
                // getTraceIdFromResponse needs the headers property:
                if (!('headers' in existingErrorResponse)) existingErrorResponse.headers = response.headers;
            }
        } else error.response = response;
    }
    return error;
}
module.exports["getErrorWithResponse"] = $9a7b0181c65e47f8$export$d882ca6820b0f4f3;

});

parcelRegister("j7xMJ", function(module, exports) {

var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");

const $8264c3c0961f9494$export$5ca6730fa0e353e8 = ()=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const isGuest = (0, $8Lx5S.useIsGuest)();
    const client = isGuest || !isLoggedIn || !isLicensed ? 'agg' : 'ccgraphql';
    return {
        client: client
    };
};
module.exports["useFetchUsersClient"] = $8264c3c0961f9494$export$5ca6730fa0e353e8;

});

parcelRegister("2VZOl", function(module, exports) {

var $j8on0 = parcelRequire("j8on0");

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $9HkI0 = parcelRequire("9HkI0");

const $a3221c0e46c131d6$export$cd763072e62a98fa = (0, $j8on0.createContainer)();
const $a3221c0e46c131d6$var$Store = (0, $8s9DV.createStore)({
    containedBy: $a3221c0e46c131d6$export$cd763072e62a98fa,
    initialState: {
        presenceId: ''
    },
    actions: {},
    handlers: {
        onInit: ()=>({ setState: setState })=>{
                setState({
                    presenceId: (0, $9HkI0.v4)()
                });
            }
    }
});
const $a3221c0e46c131d6$export$f529db6cceb299f5 = (0, $kBr4q.createHook)($a3221c0e46c131d6$var$Store);
module.exports["NativeCollabPresenceStateContainer"] = $a3221c0e46c131d6$export$cd763072e62a98fa;
module.exports["useNativeCollabPresenceState"] = $a3221c0e46c131d6$export$f529db6cceb299f5;

});

parcelRegister("8KbKw", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $04e9M = parcelRequire("04e9M");


var $9137z = parcelRequire("9137z");


var $j8hiR = parcelRequire("j8hiR");


var $6mKj3 = parcelRequire("6mKj3");


var $7Sm4c = parcelRequire("7Sm4c");


var $c0rhi = parcelRequire("c0rhi");


var $aMcHK = parcelRequire("aMcHK");


var $lR7wI = parcelRequire("lR7wI");


var $1sAC2 = parcelRequire("1sAC2");

const $6f395e426fb151a0$var$isContentNotFoundError = (error)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some((graphQLError)=>graphQLError.message.includes('Invalid content id'));
    return false;
};
const $6f395e426fb151a0$export$e344958ab47793df = (0, $dOBRD.default)((contentId, draftShareId)=>async ()=>{
        const permissionsTokenState = (0, $1sAC2.nativeCollabPermissionsTokenState).getPermissionsTokenState(contentId);
        if (permissionsTokenState) {
            const { getToken: getToken, isUsedForDraftFetch: isUsedForDraftFetch, isUsedForWSInitialization: isUsedForWSInitialization } = permissionsTokenState;
            // fetchCollabPermissionToken should only return the token if it is valid and has successfully been passed to the getDraft call
            if (isUsedForDraftFetch && !isUsedForWSInitialization) {
                const token = await getToken;
                if (token) {
                    (0, $1sAC2.nativeCollabPermissionsTokenState).setIsUsedForWSInitialization(contentId, true);
                    return token;
                }
            }
        }
        try {
            (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_PERMS_TOKEN_FETCH);
            const result = await (0, $c0rhi.queryInterop)({
                query: (0, $lR7wI.default),
                variables: {
                    contentId: contentId,
                    ...draftShareId && {
                        draftShareId: draftShareId
                    }
                },
                fetchPolicy: 'network-only',
                context: {
                    fetchOptions: {
                        // If we have a "no network error" this will never resolve and subsequent calls will
                        // be in limbo. This means we are unable to ever connect to NCS again (requiring a page reset)
                        ignoreNoNetworkError: true
                    }
                },
                __callerPackage__: "native-collab"
            });
            (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_PERMS_TOKEN_FETCH);
            const token = result.data?.collabToken?.token ?? null; // if token is null, collab service will fall back to permissions service check
            if (token === null && (0, $6mKj3.expVal)('platform_editor_emit_null_token_event', 'isEnabled', false)) (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                client.sendOperationalEvent({
                    action: 'nullTokenReturned',
                    actionSubject: 'collabPermissionToken',
                    source: 'fetchCollabPermissionToken',
                    attributes: {
                        reason: 'emptyResponse'
                    }
                });
            });
            return token;
        } catch (e) {
            (0, $7Sm4c.markErrorAsHandled)(e);
            if ($6f395e426fb151a0$var$isContentNotFoundError(e)) // nasty fragile hack, mimic 404 exception which goes through collab-provider, then gets wrapped and emitted and handled in `useError`.
            // collab provider simply emits errors thrown in permissionTokenRefresh directly on its internal channel, so we have to conform to their error type
            // prettier-ignore
            throw {
                message: "Content not found",
                data: {
                    status: 404,
                    code: "INSUFFICIENT_EDITING_PERMISSION",
                    meta: {
                        description: "RESOURCE_DELETED",
                        reason: "RESOURCE_DELETED"
                    }
                }
            };
            else if (e?.networkError?.response?.status === 503) // prettier-ignore
            throw {
                message: "Service unavailable",
                data: {
                    meta: {
                        reason: "RESOURCE_DELETED"
                    }
                }
            }; // temporary hack to ensure draft cannot be edited during tenant migration, but we should throw TENANT_INSTANCE_MAINTENANCE once supported by collab-provider
            if ((0, $6mKj3.expVal)('platform_editor_emit_null_token_event', 'isEnabled', false)) {
                const statusCode = (0, $aMcHK.getStatusCodeError)(e);
                (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                    client.sendOperationalEvent({
                        action: 'nullTokenReturned',
                        actionSubject: 'collabPermissionToken',
                        source: 'fetchCollabPermissionToken',
                        attributes: {
                            reason: 'fetchError',
                            statusCode: statusCode ?? 'unknown'
                        }
                    });
                });
            }
            return null;
        }
    });
module.exports["fetchCollabPermissionToken"] = $6f395e426fb151a0$export$e344958ab47793df;

});

parcelRegister("lR7wI", function(module, exports) {
/**
 * @generated SignedSource<<a61063136e57f7cd39e5b8a983d46e87>>
 * @relayHash bd2d61cdca16378a4f1f566700b1fb56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d8d52b5f773a7bba3b6756bcb3b14fd5aaf52c1ee303a82c5d4a9aaccc6af69
const $4abe7e20c4ebe0be$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "draftShareId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "CollabTokenResponse",
            "kind": "LinkedField",
            "name": "collabToken",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "token"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CollabPermissionTokenQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CollabPermissionTokenQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "bd2d61cdca16378a4f1f566700b1fb56",
            "id": "5d8d52b5f773a7bba3b6756bcb3b14fd5aaf52c1ee303a82c5d4a9aaccc6af69",
            "metadata": {},
            "name": "CollabPermissionTokenQuery",
            "operationKind": "query",
            "text": "query CollabPermissionTokenQuery($contentId:ID!,$draftShareId:String){collabToken(id:$contentId,draftShareId:$draftShareId){token}}"
        }
    };
}();
$4abe7e20c4ebe0be$var$node.hash = "f88c8dd0f4e61065305cc9c5b9a3253b";
var $4abe7e20c4ebe0be$export$2e2bcd8739ae039 = $4abe7e20c4ebe0be$var$node;
module.exports["default"] = $4abe7e20c4ebe0be$export$2e2bcd8739ae039;

});

parcelRegister("1sAC2", function(module, exports) {
class $3f756fb591e8330c$export$88b5d10ee0ed72d9 {
    getPermissionsTokenState(contentId) {
        return this.tokenState[contentId];
    }
    setToken(contentId, tokenPromise = Promise.resolve(null)) {
        // clear any existing tokens/bools in state
        this.tokenState[contentId] = {
            getToken: tokenPromise,
            isUsedForDraftFetch: false,
            isUsedForWSInitialization: false
        };
    }
    setIsUsedForDraftFetch(contentId, isUsedForDraftFetch) {
        if (!this.tokenState[contentId]) return;
        this.tokenState[contentId].isUsedForDraftFetch = isUsedForDraftFetch;
    }
    setIsUsedForWSInitialization(contentId, isUsedForWSInitialization) {
        if (!this.tokenState[contentId]) return;
        this.tokenState[contentId].isUsedForWSInitialization = isUsedForWSInitialization;
    }
    setTimestamp(contentId) {
        if (!this.tokenState[contentId]) return;
        this.tokenState[contentId].timestamp = performance.now();
    }
    clearPermissionsTokenState(contentId) {
        if (this.tokenState[contentId]) delete this.tokenState[contentId];
    }
    constructor(){
        this.tokenState = {};
    }
}
const $3f756fb591e8330c$export$8e63d30e585828b3 = new $3f756fb591e8330c$export$88b5d10ee0ed72d9();
module.exports["nativeCollabPermissionsTokenState"] = $3f756fb591e8330c$export$8e63d30e585828b3;

});

parcelRegister("7PuC4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bQm3c = parcelRequire("bQm3c");


var $lSOAM = parcelRequire("lSOAM");

var $i3c1S = parcelRequire("i3c1S");


var $jX1qB = parcelRequire("jX1qB");

var $1UCmC = parcelRequire("1UCmC");


var $6VdZc = parcelRequire("6VdZc");

var $7fw2E = parcelRequire("7fw2E");


var $7sK8i = parcelRequire("7sK8i");


var $8w1c1 = parcelRequire("8w1c1");


var $1q7H7 = parcelRequire("1q7H7");


var $gw4Bt = parcelRequire("gw4Bt");


var $aWrnw = parcelRequire("aWrnw");


var $fgdVB = parcelRequire("fgdVB");


var $5qUgM = parcelRequire("5qUgM");


var $3VbV8 = parcelRequire("3VbV8");

const $dcbb265953b20b9a$var$baseConfig = {
    histogram: {
        initial: {
            fmp: '5000_6000_7000_8000_10000_12000_14000',
            tti: '5000_6000_7000_8000_10000_12000_14000'
        },
        transition: {
            fmp: '2000_2500_3000_3500_4000_4500_5000',
            tti: '2000_2500_3000_3500_4000_4500_5000'
        }
    },
    timings: [
        // breakdowns in order of occurrence
        {
            key: 'html',
            endMark: 'html'
        },
        {
            key: 'appLoad',
            startMark: 'html',
            endMark: 'app'
        },
        {
            key: 'appRootRender',
            startMark: 'app',
            endMark: 'root-component-render'
        },
        {
            key: 'routerMatched',
            startMark: 'root-component-render',
            endMark: 'route-manager-initialized'
        }
    ]
};
const $dcbb265953b20b9a$var$NOOP = ()=>{};
const $dcbb265953b20b9a$export$2d5e2a82ee58820b = ({ isAnonymous: isAnonymous, isInitialLoad: isInitialLoad, viewMode: viewMode })=>{
    const segments = [
        (0, $3VbV8.EDITOR_METRIC)
    ];
    segments.push((0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC), (0, $5qUgM.OBJECT_HEADER_SEGMENT_METRIC));
    if (isInitialLoad) segments.push((0, $8w1c1.APP_NAVIGATION_METRIC), (0, $aWrnw.SPACE_NAVIGATION_METRIC), (0, $1q7H7.PAGE_TREE_METRIC));
    if (!isAnonymous && viewMode === false) segments.push((0, $gw4Bt.SHARE_BUTTON_PAGE_SEGMENT_LOAD));
    return segments;
};
/**
 * fmpAsUntilStopTimeMetrics
 *
 * UPDATE 2025-04-29: TTI is deprecated. Going forward, new segments should be included here by default in order to
 * preserve the original TTI definition. Segments should be included even if they are not minimally interactive.
 *
 * What is minimally interactive?
 * Minimally interactive during the SSR phase at it's core, is determined if the component/element is clickable,
 * can register the action, and display a visual response that the action has been received.
 * The SSR phase can be stalled by appending ?NO_SPA=1 at the end of a CONNIE url.
 *
 * I.E. If you click on an inline comment/highlight, the click is registered, and displays a loading sidebar component.
 *
 * If a required segment is SSR'd and determined to be minimally interactive at FMP, ADD TO THIS LIST
 * If a required segment is SSR'd but determined to NOT be minimally interactive at FMP, DO NOT ADD TO THIS LIST
 * If a required segment is yet to be SSR'd, this config will not update TTI for that segment, by default is OFF.
 *
 * CONTEXT
 * the returned segments are considered to be minimally interactive during SSR
 * hence we want to use FMP (ssr-ttr mark)
 *
 * PageSegment TTI is measured: useFmpAsUntilStopTime ? FMP : Eventual load time
 * Content-renderer TTI: macros are SSRed ? FMP : Eventual Load Time
 *
 * View Page TTI is measured: Math.max(Non SSR PageSegments TTI, Content-renderer TTI)
 *
 */ const $dcbb265953b20b9a$var$fmpAsUntilStopTimeMetrics = ()=>{
    return [
        (0, $jX1qB.APP_NAVIGATION_SEGMENT_KEY),
        (0, $jX1qB.SPACE_NAVIGATION_SEGMENT_KEY),
        (0, $jX1qB.PAGE_TREE_SEGMENT_KEY),
        (0, $jX1qB.OBJECT_HEADER_SEGMENT_KEY),
        (0, $jX1qB.OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY),
        (0, $jX1qB.SHARE_BUTTON_SEGMENT_KEY)
    ];
};
const $dcbb265953b20b9a$export$53cdaf364e318f0b = ({ viewMode: viewMode, userId: userId })=>{
    const _isInitialLoad = (0, $6VdZc.isInitial)();
    const expectedPageSegments = $dcbb265953b20b9a$export$2d5e2a82ee58820b({
        isAnonymous: Boolean(!userId),
        isInitialLoad: _isInitialLoad,
        viewMode: viewMode
    });
    const untilExperienceMetricNames = $dcbb265953b20b9a$var$fmpAsUntilStopTimeMetrics();
    // Create a list of untilPageSegments
    // This wraps the segments into an UntilExperience, so that @atlassian/browser-metrics can handle useFmpAsUntilStopTime gracefully
    // Note - this only affect initial load since transitions are not SSR'd, hence page-segments do not have fmp marks
    // More information why useFmpAsUntilStopTime can be found here
    // https://hello.atlassian.net/wiki/spaces/~484600559/pages/1515596554/Toolings+Update+Browser-Metrics+FMP+TTI
    const untilPageSegments = expectedPageSegments.map((segment)=>({
            experience: segment,
            useFmpAsUntilStopTime: untilExperienceMetricNames.includes(segment.key)
        }));
    const pageLoadMetric = (0, $lSOAM.createPageLoadMetric)({
        ...$dcbb265953b20b9a$var$baseConfig,
        key: (0, $1UCmC.LIVE_PAGE_LOAD_KEY),
        timings: [
            ...$dcbb265953b20b9a$var$baseConfig.timings,
            ...(0, $i3c1S.getWaterfallTimings)(expectedPageSegments)
        ],
        include: expectedPageSegments,
        until: untilPageSegments,
        reactUFOName: (0, $1UCmC.LIVE_PAGE_REACT_UFO_LOAD_KEY)
    });
    if (!_isInitialLoad) // Make sure all segments are re-started and not currently marked as finished from a previous navigation
    expectedPageSegments.forEach((m)=>m.startFromPageLoad());
    pageLoadMetric.startPageLoad();
    pageLoadMetric.onStop(()=>{
        (0, $7fw2E.markBrowserMetricEnd)(pageLoadMetric);
    }, $dcbb265953b20b9a$var$NOOP);
    pageLoadMetric.onStop((0, $7sK8i.resumeLowPriorityEvents), (0, $7sK8i.resumeLowPriorityEvents));
    return pageLoadMetric;
};
const $dcbb265953b20b9a$export$22d97e8b0fdc8888 = ({ contentId: contentId, viewMode: viewMode })=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    (0, $cozmU.useEffect)(()=>{
        const pageLoadMetric = $dcbb265953b20b9a$export$53cdaf364e318f0b({
            viewMode: viewMode,
            userId: userId ?? undefined
        });
        return ()=>{
            pageLoadMetric?.cancel();
        };
    }, [
        contentId,
        userId,
        viewMode
    ]);
    return null;
};
module.exports["startLivePageLoadMetrics"] = $dcbb265953b20b9a$export$53cdaf364e318f0b;
module.exports["StartLivePageLoad"] = $dcbb265953b20b9a$export$22d97e8b0fdc8888;

});

parcelRegister("jX1qB", function(module, exports) {
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$7416ef7ed24ec47f = 'media';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';
const $fa0ea3428ec5aa62$export$b64d520f9b37dcd7 = 'comments-panel-open-view';
const $fa0ea3428ec5aa62$export$50553e47471a0f5e = 'comments-panel-unread-view';
const $fa0ea3428ec5aa62$export$40d92ab0c1cc5298 = 'comments-panel-deleted-content-view';
const $fa0ea3428ec5aa62$export$f2a6407ac901fd8d = 'comments-panel-resolved-view';
const $fa0ea3428ec5aa62$export$b3aade49b91bdeba = 'comments-panel-mentions-me-view';
module.exports["APP_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$9e40500efe28ac9e;
module.exports["BLOG_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$38b273cdbbf56c26;
module.exports["BYLINE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1ac23cd5807df863;
module.exports["READ_TIME_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$5bbb36bee09a5671;
module.exports["CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$a79607497a4a710c;
module.exports["CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c56a99673f1bb7bb;
module.exports["CONTENT_RENDERER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$140a493a9e781fe2;
module.exports["CONTENT_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1285ccb0399c01;
module.exports["FAVOURITE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$eb5bb54418693284;
module.exports["FOCUSED_INLINE_COMMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3fde425dbc74423b;
module.exports["INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6a58cce6529da40e;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$8910bc840e3ee4ce;
module.exports["RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf572571ca036b67;
module.exports["EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$644778267d4a4a82;
module.exports["MEDIA_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7416ef7ed24ec47f;
module.exports["PAGE_COMMENTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e4ff10a0a39a7217;
module.exports["PAGE_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6648c9be174e6923;
module.exports["FEED_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d3d6144128aaee3;
module.exports["PAGE_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499;
module.exports["RESTRICTIONS_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d1dfca9e0eb45581;
module.exports["GLOBAL_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$312db7b759bad970;
module.exports["SPACE_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$cf2a6bf49e73b304;
module.exports["SPACE_APPS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$84f6b5717c3fb962;
module.exports["WATCH_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1a423f2548c46be3;
module.exports["HOME_OVERVIEW_RECENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6426c6941656619;
module.exports["HOME_OVERVIEW_FEED_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$14f30a91623dfcf3;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c6926beb57b60636;
module.exports["HOME_OVERVIEW_SPACES_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$687913e127f52cc3;
module.exports["HOME_RECENTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0;
module.exports["HOME_STARRED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$76243e8aa4afaa0b;
module.exports["HOME_DRAFTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1df6f3f29083f48;
module.exports["END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7b32848c9413526a;
module.exports["IN_EDITOR_TEMPLATES_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$58fbb0ba50341103;
module.exports["NCS_CONNECTED_FMP_KEY"] = $fa0ea3428ec5aa62$export$4f481f063369df3c;
module.exports["ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1b9793e009e605;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$90bda069d4bf981b;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f11e1d4269141c0e;
module.exports["DATABASE_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$f0298cbab4a44998;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$cf2f52fec740bdea;
module.exports["OBJECT_HEADER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$52050233077a1838;
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1ab333f0b70b317;
module.exports["WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4;
module.exports["DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b95bd4bfc46932fc;
module.exports["SHARE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf838b84ba2f7b95;
module.exports["VIEW_PAGE_LABELS_METRIC_KEY"] = $fa0ea3428ec5aa62$export$79910402df6be117;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d86af34f7dc194b4;
module.exports["CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb;
module.exports["SPACE_PERMISSIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1939caa7fae28ef5;
module.exports["VIEW_PAGE_CONTAINER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3f06ee123a5ad183;
module.exports["EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$37da6122cd60d332;
module.exports["EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3437c1f145cfce19;
module.exports["EDITOR_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7903037283afbce0;
module.exports["OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$31d10d7597db11d3;
module.exports["COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b64d520f9b37dcd7;
module.exports["COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$50553e47471a0f5e;
module.exports["COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$40d92ab0c1cc5298;
module.exports["COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f2a6407ac901fd8d;
module.exports["COMMENTS_PANEL_MENTIONS_ME_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b3aade49b91bdeba;

});

parcelRegister("1UCmC", function(module, exports) {
const $00aca2e58bbddd9e$export$9ee3c9e81070f140 = 'admin-announcement-banner-setting-page';
const $00aca2e58bbddd9e$export$162462d8f302c50a = 'advanced-search';
const $00aca2e58bbddd9e$export$17e011598d6a739d = 'unified-search';
const $00aca2e58bbddd9e$export$a88513891a2ab6b7 = 'confluence-home';
const $00aca2e58bbddd9e$export$5614199f62986e3b = 'all-drafts';
const $00aca2e58bbddd9e$export$3bbaa81ece500746 = 'recent-pages';
const $00aca2e58bbddd9e$export$b634edee624f5dc2 = 'starred-pages';
const $00aca2e58bbddd9e$export$5946c48030569b81 = 'content-history';
const $00aca2e58bbddd9e$export$1eefb862c6c6ce00 = 'edit-page';
const $00aca2e58bbddd9e$export$e164999ba8681ff6 = 'edit-template';
const $00aca2e58bbddd9e$export$6cdf3f4614ddd679 = 'edit-template-old';
const $00aca2e58bbddd9e$export$8faa34d8ba45e128 = 'embedded-view-page';
const $00aca2e58bbddd9e$export$3fb3338cf2b36704 = 'embedded-edit-page';
const $00aca2e58bbddd9e$export$779fbc1a16a8cb5d = 'global-permissions';
const $00aca2e58bbddd9e$export$9d8c586f3355f180 = 'inaccessible-page';
const $00aca2e58bbddd9e$export$a0c73183bde575ec = 'not-found';
const $00aca2e58bbddd9e$export$6d480c75094dbd7f = 'space-directory';
const $00aca2e58bbddd9e$export$8d0f9920174f22b4 = 'space-overview';
const $00aca2e58bbddd9e$export$228f2841a225e5ad = 'space-pages';
const $00aca2e58bbddd9e$export$fe4f0edc4d6532a8 = 'tasks-home';
const $00aca2e58bbddd9e$export$cc53520b570e0a46 = 'content-manager';
const $00aca2e58bbddd9e$export$bdc26b2b517231a = 'space-manager';
const $00aca2e58bbddd9e$export$b6d237d1e8f12e5d = 'template-gallery';
const $00aca2e58bbddd9e$export$a715ad00b824ec3f = 'view-page';
const $00aca2e58bbddd9e$export$132f38e0c19c02b6 = 'embedded-marketplace';
const $00aca2e58bbddd9e$export$d2dddf4422ad7ae8 = 'create-content';
const $00aca2e58bbddd9e$export$9c7a9f4f853f6fba = 'public-link-shared-page';
const $00aca2e58bbddd9e$export$643b9c181748da38 = 'public-link-site-setting-page';
const $00aca2e58bbddd9e$export$4716363caa82a23b = 'public-links-space-settings-page';
const $00aca2e58bbddd9e$export$75726af5c0ee9402 = 'whiteboard-view-page';
const $00aca2e58bbddd9e$export$afe76b61b3f9aaa8 = 'database-view-page';
const $00aca2e58bbddd9e$export$dd63a13fc6c1ba34 = 'embed-view-page';
const $00aca2e58bbddd9e$export$16aeb03ec0c24b89 = 'live-page';
const $00aca2e58bbddd9e$export$ce4e0f6f3d614d45 = 'live-edit';
const $00aca2e58bbddd9e$export$ecea02b4eaa314f3 = 'team-calendars';
const $00aca2e58bbddd9e$export$726cbfa087a55101 = 'admin-team-calendars';
const $00aca2e58bbddd9e$export$2f245ed7ebaea89 = 'admin-general-configuration';
const $00aca2e58bbddd9e$export$2af60fefae96902b = 'admin-configure-code-macro';
const $00aca2e58bbddd9e$export$fbea00ed02ef2502 = 'admin-default-space-logo-config';
const $00aca2e58bbddd9e$export$6e9c07174668ae36 = 'admin-header-and-footer';
const $00aca2e58bbddd9e$export$51fdddeccf175d74 = 'admin-security-configuration';
const $00aca2e58bbddd9e$export$2d0370cc7d14b72e = 'admin-templates-and-blueprints';
const $00aca2e58bbddd9e$export$a8d02dbd84c83dd = 'admin-import-spaces';
const $00aca2e58bbddd9e$export$1d91ea2ef976728a = 'admin-trashed-spaces';
const $00aca2e58bbddd9e$export$a13bfc71dc6b7924 = 'admin-application-navigator';
const $00aca2e58bbddd9e$export$3ba6335cd90d2e59 = 'admin-themes';
const $00aca2e58bbddd9e$export$cb4b6b707a32ee92 = 'admin-jira-macro-repair';
const $00aca2e58bbddd9e$export$5cb6689cb672a5c0 = 'admin-pdf-export';
const $00aca2e58bbddd9e$export$fff7d33fb1514c44 = 'admin-macro-usage';
const $00aca2e58bbddd9e$export$d4aa60a3ffc18652 = 'admin-user-access';
const $00aca2e58bbddd9e$export$52c0c13179848b50 = 'CONTENT_ANALYTICS';
const $00aca2e58bbddd9e$export$40dab65f060e1231 = 'SPACE_ANALYTICS';
const $00aca2e58bbddd9e$export$b682ed6d6fa429fb = 'INSTANCE_ANALYTICS';
const $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1 = 'space-details';
const $00aca2e58bbddd9e$export$2633c6986b98b723 = 'pdf-export-route';
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9ee3c9e81070f140;
module.exports["ADVANCED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$162462d8f302c50a;
module.exports["UNIFIED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$17e011598d6a739d;
module.exports["CONFLUENCE_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$a88513891a2ab6b7;
module.exports["CONFLUENCE_DRAFTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$5614199f62986e3b;
module.exports["CONFLUENCE_RECENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$3bbaa81ece500746;
module.exports["CONFLUENCE_STARRED_LOAD_KEY"] = $00aca2e58bbddd9e$export$b634edee624f5dc2;
module.exports["CONTENT_HISTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$5946c48030569b81;
module.exports["EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$1eefb862c6c6ce00;
module.exports["EDIT_TEMPLATE_LOAD_KEY"] = $00aca2e58bbddd9e$export$e164999ba8681ff6;
module.exports["EDIT_TEMPLATE_OLD_LOAD_KEY"] = $00aca2e58bbddd9e$export$6cdf3f4614ddd679;
module.exports["EMBEDDED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$8faa34d8ba45e128;
module.exports["EMBEDDED_EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$3fb3338cf2b36704;
module.exports["GLOBAL_PERMISSIONS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$779fbc1a16a8cb5d;
module.exports["INACCESSIBLE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9d8c586f3355f180;
module.exports["NOT_FOUND_LOAD_KEY"] = $00aca2e58bbddd9e$export$a0c73183bde575ec;
module.exports["SPACE_DIRECTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$6d480c75094dbd7f;
module.exports["SPACE_OVERVIEW_LOAD_KEY"] = $00aca2e58bbddd9e$export$8d0f9920174f22b4;
module.exports["SPACE_PAGES_LOAD_KEY"] = $00aca2e58bbddd9e$export$228f2841a225e5ad;
module.exports["TASKS_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$fe4f0edc4d6532a8;
module.exports["CONTENT_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$cc53520b570e0a46;
module.exports["SPACE_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$bdc26b2b517231a;
module.exports["TEMPLATE_GALLERY_LOAD_KEY"] = $00aca2e58bbddd9e$export$b6d237d1e8f12e5d;
module.exports["VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$a715ad00b824ec3f;
module.exports["EMBEDDED_MARKETPLACE_LOAD_KEY"] = $00aca2e58bbddd9e$export$132f38e0c19c02b6;
module.exports["CREATE_CONTENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$d2dddf4422ad7ae8;
module.exports["PUBLIC_LINK_SHARED_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9c7a9f4f853f6fba;
module.exports["PUBLIC_LINK_SITE_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$643b9c181748da38;
module.exports["WHITEBOARD_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$75726af5c0ee9402;
module.exports["DATABASE_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$afe76b61b3f9aaa8;
module.exports["EMBED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$dd63a13fc6c1ba34;
module.exports["LIVE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$16aeb03ec0c24b89;
module.exports["LIVE_PAGE_REACT_UFO_LOAD_KEY"] = $00aca2e58bbddd9e$export$ce4e0f6f3d614d45;
module.exports["TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$ecea02b4eaa314f3;
module.exports["ADMIN_TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$726cbfa087a55101;
module.exports["ADMIN_GENERAL_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$2f245ed7ebaea89;
module.exports["ADMIN_CONFIGURE_CODE_MACRO_LOAD_KEY"] = $00aca2e58bbddd9e$export$2af60fefae96902b;
module.exports["ADMIN_DEFAULT_SPACE_LOGO_CONFIG_LOAD_KEY"] = $00aca2e58bbddd9e$export$fbea00ed02ef2502;
module.exports["ADMIN_HEADER_AND_FOOTER_LOAD_KEY"] = $00aca2e58bbddd9e$export$6e9c07174668ae36;
module.exports["ADMIN_SECURITY_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$51fdddeccf175d74;
module.exports["ADMIN_TEMPLATES_AND_BLUEPRINTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$2d0370cc7d14b72e;
module.exports["ADMIN_IMPORT_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$a8d02dbd84c83dd;
module.exports["ADMIN_TRASHED_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$1d91ea2ef976728a;
module.exports["ADMIN_APPLICATION_NAVIGATOR_KEY"] = $00aca2e58bbddd9e$export$a13bfc71dc6b7924;
module.exports["ADMIN_THEMES_LOAD_KEY"] = $00aca2e58bbddd9e$export$3ba6335cd90d2e59;
module.exports["ADMIN_JIRA_MACRO_REPAIR_LOAD_KEY"] = $00aca2e58bbddd9e$export$cb4b6b707a32ee92;
module.exports["ADMIN_PDF_EXPORT_LOAD_KEY"] = $00aca2e58bbddd9e$export$5cb6689cb672a5c0;
module.exports["ADMIN_MACRO_USAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$fff7d33fb1514c44;
module.exports["ADMIN_USER_ACCESS_KEY"] = $00aca2e58bbddd9e$export$d4aa60a3ffc18652;
module.exports["PAGE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$52c0c13179848b50;
module.exports["SPACE_ANALYTICS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$40dab65f060e1231;
module.exports["SITE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$b682ed6d6fa429fb;
module.exports["SPACE_DETAILS_LOAD_KEY"] = $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1;
module.exports["PDF_EXPORT_ROUTE_LOAD_KEY"] = $00aca2e58bbddd9e$export$2633c6986b98b723;

});

parcelRegister("7fw2E", function(module, exports) {

var $6VdZc = parcelRequire("6VdZc");

const $4bc3b2e76c18c48c$export$94f26401757ac8e7 = (metric)=>{
    let params;
    try {
        if ((0, $6VdZc.isInitial)()) {
            if (metric) {
                const data = metric.getData?.();
                const start = data?.start || 0;
                const stop = data?.stop || 0;
                params = [
                    {
                        duration: stop - start,
                        end: 'browser-metric.end'
                    }
                ];
            } else params = [
                undefined,
                'browser-metric.end'
            ];
        } else params = [
            'browser-metric.start',
            'browser-metric.end'
        ];
        performance.mark('browser-metric.end');
        performance.measure('browser-metric:tti', ...params);
    } catch (e) {
    // Suppress error when performance API failed.
    // Note: in MicrosoftEdge version 18 and prior, performance.measure(name, startMark, endMark) API will throw SyntaxError if startMark is undefined.
    // That's why wrap with try catch statement.
    }
};
module.exports["markBrowserMetricEnd"] = $4bc3b2e76c18c48c$export$94f26401757ac8e7;

});

parcelRegister("8w1c1", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $73e19354f9924125$export$d9a22aa9387ada7a = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.APP_NAVIGATION_SEGMENT_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined
});
module.exports["APP_NAVIGATION_METRIC"] = $73e19354f9924125$export$d9a22aa9387ada7a;

});

parcelRegister("1q7H7", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");

var $fQ3iN = parcelRequire("fQ3iN");


var $jIOyV = parcelRequire("jIOyV");

var $jX1qB = parcelRequire("jX1qB");

const $108e3019fffb7b94$export$6e28125ef9389dc6 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.PAGE_TREE_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $108e3019fffb7b94$export$45b21bbf8961b519 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.MOVE_PAGE_DIALOG_INTERACTION)
});
module.exports["PAGE_TREE_METRIC"] = $108e3019fffb7b94$export$6e28125ef9389dc6;
module.exports["MOVE_PAGE_DIALOG_INTERACTION_METRIC"] = $108e3019fffb7b94$export$45b21bbf8961b519;

});

parcelRegister("jIOyV", function(module, exports) {
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$eb06363d6ef3b8dd = 'restrictions-dialog';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';
const $4fa41f80373a2ebe$export$576b15c3bba51667 = 'ai-audio-briefing';
module.exports["MORE_ACTIONS_DROPDOWN_INTERACTION"] = $4fa41f80373a2ebe$export$f49429c67898bd15;
module.exports["MOVE_PAGE_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$daaf73616fe91ce9;
module.exports["CONTENT_ANALYTICS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$d4222bce9029f393;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION"] = $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c;
module.exports["RESTRICTIONS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$eb06363d6ef3b8dd;
module.exports["QUICK_SUMMARY_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$ef2fb65c026ab7d3;
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$8122cf0ca2968a7b;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$ea9696a28a6fbc61;
module.exports["COMMENTS_SUMMARY_COMPONENT_INTERACTION"] = $4fa41f80373a2ebe$export$e561726b92a6162d;
module.exports["CREATE_SPACE_DRAWER_INTERACTION"] = $4fa41f80373a2ebe$export$e348981755bdab67;
module.exports["AI_CONTENT_CATCHUP_INTERACTION"] = $4fa41f80373a2ebe$export$7f72b8ffbbbfef58;
module.exports["AI_AUDIO_BRIEFING_INTERACTION"] = $4fa41f80373a2ebe$export$576b15c3bba51667;

});

parcelRegister("gw4Bt", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $08e48bbb9421afc0$export$8fdec53caa79133c = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SHARE_BUTTON_SEGMENT_KEY)
});
module.exports["SHARE_BUTTON_PAGE_SEGMENT_LOAD"] = $08e48bbb9421afc0$export$8fdec53caa79133c;

});

parcelRegister("aWrnw", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");


var $1Hqbt = parcelRequire("1Hqbt");

const $d4615ab6ca7803f7$export$b9931e60e47a0122 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SPACE_NAVIGATION_SEGMENT_KEY),
    ssr: (0, $1Hqbt.ssrConfig)()
});
const $d4615ab6ca7803f7$export$618f453a5683e37b = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SPACE_APPS_SEGMENT_KEY),
    ssr: (0, $1Hqbt.ssrConfig)()
});
module.exports["SPACE_NAVIGATION_METRIC"] = $d4615ab6ca7803f7$export$b9931e60e47a0122;
module.exports["SPACE_APPS_METRIC"] = $d4615ab6ca7803f7$export$618f453a5683e37b;

});

parcelRegister("1Hqbt", function(module, exports) {
const $a75b16828791e7fd$export$ea92d4e542ec02b3 = ()=>window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined;
module.exports["ssrConfig"] = $a75b16828791e7fd$export$ea92d4e542ec02b3;

});

parcelRegister("fgdVB", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $70b3fb0961586b52$export$ac619e1da09d5f80 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["OBJECT_SIDEBAR_CONTROL_METRIC"] = $70b3fb0961586b52$export$ac619e1da09d5f80;

});

parcelRegister("5qUgM", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");


var $14SPd = parcelRequire("14SPd");


var $7d41Y = parcelRequire("7d41Y");


var $gw4Bt = parcelRequire("gw4Bt");

const $325dcacdd45838d0$export$fd9c234c55ebf87b = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined
});
const $325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS = [
    $325dcacdd45838d0$export$fd9c234c55ebf87b,
    (0, $7d41Y.FAVOURITE_BUTTON_METRIC),
    (0, $14SPd.RESTRICTIONS_BUTTON_METRIC)
];
const $325dcacdd45838d0$export$31dafa10be5579b1 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.OBJECT_HEADER_SEGMENT_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined
});
const $325dcacdd45838d0$export$13d0f4f758cb96f = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS
];
const $325dcacdd45838d0$export$2afecd1facfcf464 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.DATABASE_HEADER_SEGMENT_METRIC_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$13d0f4f758cb96f
});
const $325dcacdd45838d0$export$48a0148c0fcdf96 = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS,
    (0, $gw4Bt.SHARE_BUTTON_PAGE_SEGMENT_LOAD)
];
const $325dcacdd45838d0$export$a8f0e1718c3ba46b = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$48a0148c0fcdf96
});
const $325dcacdd45838d0$export$585906e42509a641 = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS,
    (0, $gw4Bt.SHARE_BUTTON_PAGE_SEGMENT_LOAD)
];
const $325dcacdd45838d0$export$de21700de0084df7 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.WHITEBOARD_HEADER_SEGMENT_METRIC_KEY),
    ssr: window.__SSR_RENDERED__ ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$585906e42509a641
});
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT"] = $325dcacdd45838d0$export$fd9c234c55ebf87b;
module.exports["OBJECT_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$31dafa10be5579b1;
module.exports["DATABASE_HEADER_SUBSEGMENT_METRICS"] = $325dcacdd45838d0$export$13d0f4f758cb96f;
module.exports["DATABASE_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$2afecd1facfcf464;
module.exports["SMART_LINK_EMBED_HEADER_SUBSEGMENT_METRICS"] = $325dcacdd45838d0$export$48a0148c0fcdf96;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$a8f0e1718c3ba46b;
module.exports["WHITEBOARD_HEADER_SUBSEGMENT_METRICS"] = $325dcacdd45838d0$export$585906e42509a641;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC"] = $325dcacdd45838d0$export$de21700de0084df7;

});

parcelRegister("14SPd", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

var $jIOyV = parcelRequire("jIOyV");

const $8ab24ab9418ac89d$export$34cc51d2a4e5cf67 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RESTRICTIONS_BUTTON_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        }
    ]
});
const $8ab24ab9418ac89d$export$2ba38536ff91e2a7 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.RESTRICTIONS_DIALOG_INTERACTION)
});
module.exports["RESTRICTIONS_BUTTON_METRIC"] = $8ab24ab9418ac89d$export$34cc51d2a4e5cf67;
module.exports["RESTRICTIONS_DIALOG_METRIC"] = $8ab24ab9418ac89d$export$2ba38536ff91e2a7;

});

parcelRegister("7d41Y", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $9b3034aec76dfadd$export$ecb802558c1ba05e = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.FAVOURITE_BUTTON_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["FAVOURITE_BUTTON_METRIC"] = $9b3034aec76dfadd$export$ecb802558c1ba05e;

});

parcelRegister("3VbV8", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");

var $fQ3iN = parcelRequire("fQ3iN");


var $1UCmC = parcelRequire("1UCmC");

var $jX1qB = parcelRequire("jX1qB");

var $fd6g2 = parcelRequire("fd6g2");

const $3fce579e2620525b$export$dfd790981c086398 = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.FABRIC_PUBLISH_PAGE_KEY),
    histogram: {
        duration: '1000_2000_3000_4000_5000_6000_7000_8000_9000'
    }
});
const $3fce579e2620525b$export$5ac2615d36b4500c = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.EDIT_PAGE_LOAD_KEY),
    timings: [
        {
            key: 'onBeforeEditor',
            endMark: 'onBeforeEditor'
        },
        {
            key: 'editorRendered',
            startMark: 'onBeforeEditor'
        }
    ]
});
const $3fce579e2620525b$export$c5146b9e6a61ee5f = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.EDITOR_SEGMENT_KEY)
});
const $3fce579e2620525b$export$af294f5bd71dc2d = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.NCS_CONNECTED_FMP_KEY)
});
const $3fce579e2620525b$export$f9b776b1c66e5f0e = (0, $lSOAM.createPageLoadMetric)({
    key: (0, $1UCmC.EMBEDDED_EDIT_PAGE_LOAD_KEY)
});
module.exports["FABRIC_PUBLISH_PAGE_METRIC"] = $3fce579e2620525b$export$dfd790981c086398;
module.exports["EDIT_PAGE_LOAD"] = $3fce579e2620525b$export$5ac2615d36b4500c;
module.exports["EDITOR_METRIC"] = $3fce579e2620525b$export$c5146b9e6a61ee5f;
module.exports["EMBEDDED_EDIT_PAGE_LOAD"] = $3fce579e2620525b$export$f9b776b1c66e5f0e;

});

parcelRegister("7sfG4", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $b8665882fb9937b5$var$actions = {
    setIsPageBeingRemoved: (isPageBeingRemoved)=>({ setState: setState })=>{
            setState({
                isPageBeingRemoved: isPageBeingRemoved
            });
        }
};
const $b8665882fb9937b5$var$pageRemovalStore = (0, $8s9DV.createStore)({
    initialState: {
        isPageBeingRemoved: false
    },
    actions: $b8665882fb9937b5$var$actions,
    name: 'pageRemovalState'
});
const $b8665882fb9937b5$export$119fb6f7943a4824 = (0, $kBr4q.createHook)($b8665882fb9937b5$var$pageRemovalStore);
const $b8665882fb9937b5$export$8b0a971a28ad31af = (0, $kBr4q.createActionsHook)($b8665882fb9937b5$var$pageRemovalStore);
module.exports["usePageRemovalState"] = $b8665882fb9937b5$export$119fb6f7943a4824;
module.exports["usePageRemovalStateActions"] = $b8665882fb9937b5$export$8b0a971a28ad31af;

});

parcelRegister("9ohnn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $j8hiR = parcelRequire("j8hiR");


var $9137z = parcelRequire("9137z");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $hYoU4 = parcelRequire("hYoU4");


var $1sAC2 = parcelRequire("1sAC2");

const $173e9417c57854b2$export$2257bd3a33884363 = (collabEditProvider, contentId, onConnected)=>{
    const [{ collabEditConnected: collabEditConnected }, nativeCollabActions] = (0, $hYoU4.useNativeCollabConnected)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $cozmU.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleConnected = ()=>{
            nativeCollabActions.setCollabEditConnected(true);
            (0, $1sAC2.nativeCollabPermissionsTokenState).clearPermissionsTokenState(contentId);
            (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_CONNECTED);
            // tracking time between when 'init' event is fired and connection has been established
            (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_EDIT_PROVIDER_INIT_DOC);
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE),
                message: 'NCS Connected'
            });
            onConnected?.();
        };
        collabEditProvider.on('connected', handleConnected);
        return ()=>{
            collabEditProvider.off('connected', handleConnected);
        };
    }, [
        collabEditProvider,
        nativeCollabActions,
        contentId,
        experienceTracker,
        onConnected
    ]);
    return {
        isCollabProviderConnected: collabEditConnected
    };
};
module.exports["useConnected"] = $173e9417c57854b2$export$2257bd3a33884363;

});

parcelRegister("9uAPw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $9DHhW = parcelRequire("9DHhW");


var $8aF6s = parcelRequire("8aF6s");


var $bQm3c = parcelRequire("bQm3c");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $7dgT3 = parcelRequire("7dgT3");


var $cl98v = parcelRequire("cl98v");


var $jHGaM = parcelRequire("jHGaM");


var $4R3wx = parcelRequire("4R3wx");

const $a5710166add0079d$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    errorTitleCannotStart: {
        id: "loom-utils.error-flag.title.cannot-start",
        defaultMessage: "We couldn\u2019t start your recording"
    },
    errorTitleRecordingAlreadyInProgress: {
        id: "loom-utils.error-flag.title.recording-already-in-progress",
        defaultMessage: "Recording already in progress"
    },
    errorTitleNotReady: {
        id: "loom-utils.error-flag.title.not-ready",
        defaultMessage: "The Loom recorder wasn\u2019t ready"
    },
    errorIncompatibleBrowser: {
        id: "loom-utils.error-flag.description.incompatible-browser",
        defaultMessage: "The browser you\u2019re currently using isn\u2019t compatible with Loom (or you could be trying to use it in private/incognito mode). <a>Which browsers are compatible?</a>"
    },
    errorThirdPartyCookieDisabled: {
        id: "loom-utils.error-flag.description.third-party-cookie-disabled",
        defaultMessage: "Check that you have third-party cookies enabled, then try again."
    },
    errorNoMediaStreamSupport: {
        id: "loom-utils.error-flag.description.no-media-stream-support",
        defaultMessage: "You might need to try a different browser. <a>Which browsers are compatible?</a>"
    },
    errorSDKNotInitialized: {
        id: "loom-utils.error-flag.description.sdk-not-initialized",
        defaultMessage: "Try to start recording again now."
    },
    errorBackendFFNotEnabledYet: {
        id: "loom-utils.error-flag.description.be-ff-not-enabled-yet",
        defaultMessage: "Loom was recently enabled. Try again in a few minutes."
    },
    errorUnexpectedAuthTokenFailure: {
        id: "loom-utils.error-flag.description.unexpected-auth-token-failure",
        defaultMessage: "Something went wrong with the Loom recorder. Try again later, or contact Atlassian Support for help."
    },
    errorLoomUserNotCreatedYet: {
        id: "loom-utils.error-flag.description.loom-user-not-created-yet",
        defaultMessage: "Loom is enabled, just give us a few minutes to set everything up. You can try recording again in a bit."
    },
    errorSDKFailedToInitialize: {
        id: "loom-utils.error-flag.description.sdk-failed-to-initialize",
        defaultMessage: "Give it a moment and then refresh to try again."
    },
    errorRecordingAlreadyInProgress: {
        id: "loom-utils.error-flag.description.recording-already-in-progress",
        defaultMessage: "Finish your current Loom video so you can start another."
    }
});
const $a5710166add0079d$var$LoomSDKSupportLink = 'https://support.loom.com/hc/en-us/articles/360020667617-loomSDK-FAQ';
function $a5710166add0079d$var$getUnsupportedSDKErrorDescription(error) {
    if (error === 'third-party-cookies-disabled') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorThirdPartyCookieDisabled);
    else if (error === 'no-media-streams-support') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$a5710166add0079d$export$a7357cdd1f0b0168.errorNoMediaStreamSupport,
        values: {
            a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: $a5710166add0079d$var$LoomSDKSupportLink,
                    target: "_blank"
                }, chunks)
        }
    });
    else if (error === 'incompatible-browser') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$a5710166add0079d$export$a7357cdd1f0b0168.errorIncompatibleBrowser,
        values: {
            a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: $a5710166add0079d$var$LoomSDKSupportLink,
                    target: "_blank"
                }, chunks)
        }
    });
}
const $a5710166add0079d$export$c8d9dc913e9e33ec = ({ entryPointLocation: entryPointLocation, flags: flags, resetInsertFunctionOnUnmount: resetInsertFunctionOnUnmount = false })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { cloudId: cloudId, environment: environment } = (0, $bQm3c.useSessionData)();
    const { entryPointVariant: entryPointVariant } = (0, $4R3wx.useLoomEntryPointVariant)();
    const [singletonLoomSDK, { initLoomSDK: initLoomSDK }] = (0, $jHGaM.useLoomEntryPointGlobalState)();
    const [isOpeningRecorder, setIsOpeningRecorder] = (0, $cozmU.useState)(false);
    const runningSDKButton = (0, $cozmU.useRef)(null);
    // the call site for openLoomRecorder might be outside of React lifecycle
    // (e.g. editor DOM button onclick) so we need to ensure we maintain reference
    const singletonLoomSDKRef = (0, $cozmU.useRef)(singletonLoomSDK);
    singletonLoomSDKRef.current = singletonLoomSDK;
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (entryPointVariant === 'BETA' || entryPointVariant === 'CO_USE') initLoomSDK({
            cloudId: cloudId,
            environment: environment,
            entryPointLocation: entryPointLocation
        });
    }, [
        initLoomSDK,
        cloudId,
        createAnalyticsEvent,
        environment,
        entryPointVariant,
        entryPointLocation
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (resetInsertFunctionOnUnmount && runningSDKButton.current && singletonLoomSDKRef.current.initializedLoomSDK) {
                singletonLoomSDKRef.current.initializedLoomSDK.updateConfig({
                    config: {
                        insertButtonText: 'Open on Loom'
                    }
                });
                runningSDKButton.current.off('insert-click');
                runningSDKButton.current.on('insert-click', (video)=>{
                    window.open(video.sharedUrl, '_blank');
                    experienceTracker.succeed({
                        name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                        attributes: {
                            inserted: true,
                            insertFunctionWasReset: true
                        }
                    });
                    /**
           * Why do we need to add sendUIEvent if we are already sending a experienceTracker.succeed(ui taskSuccess) event?
           * "ui taskSuccess" does not have Statsig as destination, so we need to send a sendUIEvent to Statsig
           */ createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            source: entryPointLocation,
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'insertVideoLink',
                            attributes: {
                                insertFunctionWasReset: true
                            }
                        }
                    }).fire();
                });
            }
        };
    }, [
        entryPointLocation,
        resetInsertFunctionOnUnmount,
        experienceTracker,
        createAnalyticsEvent
    ]);
    const openLoomRecorder = (0, $cozmU.useCallback)(async (loomRecorderParams)=>{
        if (singletonLoomSDKRef.current.initializedLoomSDK && singletonLoomSDKRef.current.initializedLoomSDK.status().state === 'active-recording') {
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleRecordingAlreadyInProgress),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorRecordingAlreadyInProgress)
            });
            return;
        }
        experienceTracker.start({
            name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
            attributes: {
                entryPointLocation: entryPointLocation
            }
        });
        if (singletonLoomSDKRef.current.isInitializing) {
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleNotReady),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorSDKNotInitialized)
            });
            experienceTracker.abort({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                reason: 'SDK has not been configured yet.'
            });
            return;
        }
        // TODO CTIA- 2019: fire a clicked UI event here
        if (singletonLoomSDKRef.current.isLoomSDKSupportedError) {
            const description = $a5710166add0079d$var$getUnsupportedSDKErrorDescription(singletonLoomSDKRef.current.isLoomSDKSupportedError);
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                description: description
            });
            experienceTracker.abort({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                reason: `SDK not supported: ${singletonLoomSDKRef.current.isLoomSDKSupportedError}.`
            });
            return;
        }
        if (!singletonLoomSDKRef.current.hasRecordingAccess) {
            const noRecordingAccessReason = singletonLoomSDKRef.current.noRecordingAccessReason;
            if (noRecordingAccessReason === 'backendFF') {
                flags.showInfoFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorBackendFFNotEnabledYet)
                });
                experienceTracker.abort({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    reason: 'loom enablement in progress'
                });
            } else if (noRecordingAccessReason === 'not-created') {
                flags.showInfoFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorLoomUserNotCreatedYet)
                });
                experienceTracker.abort({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    reason: 'user not created yet'
                });
            } else if (noRecordingAccessReason === 'not-mastered' || noRecordingAccessReason === 'not-mastered-enterprise') {
                // mastering for enterprise users is not available until M3
                const isMasteringFlowEnabledForEdition = noRecordingAccessReason !== 'not-mastered-enterprise';
                showModal((0, $7dgT3.NonMasteredUserModalLoader), {
                    isMasteringFlowEnabled: isMasteringFlowEnabledForEdition
                });
                experienceTracker.abort({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    reason: 'Does not have access to record looms from Confluence.',
                    attributes: {
                        noRecordingAccessReason: noRecordingAccessReason
                    }
                });
            } else {
                flags.showInfoFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorUnexpectedAuthTokenFailure)
                });
                experienceTracker.fail({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    error: singletonLoomSDKRef.current.authTokenError || new Error('unexpected error from Loom auth token or Loom user status')
                });
            }
            return;
        }
        if (!singletonLoomSDKRef.current.initializedLoomSDK || !singletonLoomSDKRef.current.initializedLoomSDK.status().success) {
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a5710166add0079d$export$a7357cdd1f0b0168.errorSDKFailedToInitialize)
            });
            experienceTracker.fail({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                error: singletonLoomSDKRef.current.initializedLoomSDKError || new Error('Loom SDK did not successfully initialize.'),
                attributes: {
                    loomSDKSuccessStatus: singletonLoomSDKRef.current.initializedLoomSDK?.status()?.success
                }
            });
            return;
        }
        (0, $cl98v.OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC).start();
        setIsOpeningRecorder(true);
        createAnalyticsEvent({
            // a track event is fired once recorder is opened, this event is speficially used for monitoring in StatSig
            type: 'sendTrackEvent',
            data: {
                source: entryPointLocation,
                action: 'opened',
                actionSubject: 'loomSdkRecorder'
            }
        }).fire();
        const { configureButton: configureButton, updateConfig: updateConfig } = singletonLoomSDKRef.current.initializedLoomSDK;
        const sdkButton = configureButton();
        updateConfig({
            config: {
                insertButtonText: loomRecorderParams ? loomRecorderParams.insertButtonText : undefined,
                entryPointName: entryPointLocation
            }
        });
        if (loomRecorderParams) sdkButton.on('insert-click', async (video_0)=>{
            // TODO CTIA-2019: fire a inserted track event here
            loomRecorderParams.onInsert(video_0.sharedUrl, video_0);
            experienceTracker.succeed({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                attributes: {
                    inserted: true
                }
            });
            /**
         * Why do we need to add sendUIEvent if we are already sending a experienceTracker.succeed(ui taskSuccess) event?
         * "ui taskSuccess" does not have Statsig as destination, so we need to send a sendUIEvent to Statsig
         */ createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: entryPointLocation,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'insertVideoLink',
                    attributes: {
                        insertFunctionWasReset: false
                    }
                }
            }).fire();
        });
        sdkButton.on('start', ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: entryPointLocation,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'loomRecordingStart'
                }
            }).fire();
        });
        sdkButton.on('recording-start', ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: entryPointLocation,
                    action: 'started',
                    actionSubject: 'loomRecording'
                }
            }).fire();
        });
        sdkButton.on('cancel', ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: entryPointLocation,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'loomRecordingCancel'
                }
            }).fire();
        });
        sdkButton.on('complete', ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: entryPointLocation,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'loomRecordingComplete',
                    attributes: {
                        location: loomRecorderParams?.location
                    }
                }
            }).fire();
        });
        sdkButton.on('recording-complete', ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: entryPointLocation,
                    action: 'completed',
                    actionSubject: 'loomRecording',
                    attributes: {
                        location: loomRecorderParams?.location
                    }
                }
            }).fire();
        });
        sdkButton.on('upload-complete', ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: entryPointLocation,
                    action: 'uploaded',
                    actionSubject: 'loomRecording'
                }
            }).fire();
        });
        sdkButton.on('lifecycle-update', (lifecycleState)=>{
            if (lifecycleState === 'pre-recording') {
                (0, $cl98v.OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC).stop();
                setIsOpeningRecorder(false);
                // `lifecycle-update` re-enters 'pre-recording' on the SDK's
                // "Record again", so this fires on every re-record — consumers
                // tracking recorder visibility (e.g. to keep a host modal
                // hidden across re-records) need each transition. Callers that
                // want a once-per-session signal (e.g. analytics) dedupe their
                // side. Failures surface via the entry-point experience since
                // this callback is part of its contract.
                try {
                    loomRecorderParams?.onRecorderVisible?.();
                } catch (error) {
                    experienceTracker.fail({
                        name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                }
            } else if (lifecycleState === 'closed') {
                runningSDKButton.current = null;
                // Run the consumer callback first so a throw fails the
                // entry-point experience (instead of silently succeeding
                // then swallowing the error).
                try {
                    loomRecorderParams?.onRecorderHidden?.();
                    experienceTracker.succeed({
                        name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                        attributes: {
                            closed: true,
                            insertFunctionDefined: loomRecorderParams !== undefined
                        }
                    });
                } catch (error_0) {
                    experienceTracker.fail({
                        name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                        error: error_0 instanceof Error ? error_0 : new Error(String(error_0))
                    });
                }
            } else if (lifecycleState === 'cascaded') experienceTracker.succeed({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                attributes: {
                    cascaded: true,
                    entryPointLocation: entryPointLocation
                }
            });
        });
        sdkButton.openPreRecordPanel();
        runningSDKButton.current = sdkButton;
    }, [
        entryPointLocation,
        experienceTracker,
        flags,
        showModal,
        createAnalyticsEvent
    ]);
    return {
        openLoomRecorder: openLoomRecorder,
        isOpeningRecorder: isOpeningRecorder,
        isLoomRecorderInitialized: !singletonLoomSDKRef.current.isInitializing,
        hasRecordingAccess: singletonLoomSDKRef.current.hasRecordingAccess
    };
};
module.exports["useLoomRecorderEntryPoint"] = $a5710166add0079d$export$c8d9dc913e9e33ec;

});

parcelRegister("7dgT3", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $e2faf2da1cbb0cf6$export$fc2bc837ff93e32f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "n2Ktr",
    name: "NonMasteredUserModalLoader",
    loader: async ()=>(await (parcelRequire("iPOCX"))).NonMasteredUserModal
});
module.exports["NonMasteredUserModalLoader"] = $e2faf2da1cbb0cf6$export$fc2bc837ff93e32f;

});

parcelRegister("iPOCX", function(module, exports) {

let $db6442fa103badb0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $db6442fa103badb0$var$load("hhss7"),
    $db6442fa103badb0$var$load("np2ZB")
]).then(()=>parcelRequire('6i2Ga'));

});

parcelRegister("cl98v", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jIOyV = parcelRequire("jIOyV");

const $dd21d598b55c38cc$export$873f91e3be81ab94 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.OPEN_LOOM_RECORDER_SDK_INTERACTION)
});
const $dd21d598b55c38cc$export$bf1068aa9f020d8f = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION)
});
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC"] = $dd21d598b55c38cc$export$873f91e3be81ab94;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC"] = $dd21d598b55c38cc$export$bf1068aa9f020d8f;

});

parcelRegister("jHGaM", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $cl98v = parcelRequire("cl98v");


var $3d6VZ = parcelRequire("3d6VZ");


var $gmNpb = parcelRequire("gmNpb");


var $38NxZ = parcelRequire("38NxZ");

const $82feff28757ef801$var$initialState = {
    isInitializing: true,
    initializedLoomSDK: null,
    _hasLoomSDKInitializationStarted: false,
    hasRecordingAccess: false,
    noRecordingAccessReason: undefined,
    authTokenError: undefined,
    isLoomSDKSupportedError: undefined,
    initializedLoomSDKError: null
};


const $82feff28757ef801$var$initSDK = ({ cloudId: cloudId, environment: environment, entryPointLocation: entryPointLocation })=>async ({ getState: getState, setState: setState })=>{
        if (getState().initializedLoomSDK || getState()._hasLoomSDKInitializationStarted) // singleton: only want 1 Loom SDK instance
        return;
        setState({
            _hasLoomSDKInitializationStarted: true
        });
        (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).start();
        try {
            const { isSupported: isSupported } = await (parcelRequire("49kj1"));
            const { supported: supported, error: isLoomSDKSupportedError } = await isSupported();
            if (!supported) {
                setState({
                    isLoomSDKSupportedError: isLoomSDKSupportedError,
                    isInitializing: false
                });
                (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
                return;
            }
        } catch  {
            // If SDK isSupported import/exec fails: treat as incompatible browser
            setState({
                isLoomSDKSupportedError: 'incompatible-browser',
                isInitializing: false
            });
            (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
            return;
        }
        const { recorderToken: recorderToken, tokenError: tokenError } = await (0, $3d6VZ.getAuthToken)();
        if (!recorderToken || tokenError) {
            const noRecordingAccessReason = await (0, $38NxZ.getNoRecordingAccessReason)(tokenError);
            setState({
                isInitializing: false,
                noRecordingAccessReason: noRecordingAccessReason,
                authTokenError: tokenError
            });
            (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
            return;
        }
        setState({
            hasRecordingAccess: true
        });
        try {
            const { createInstance: createInstance } = await (parcelRequire("22Bhu"));
            const initializedLoomSDK = await createInstance((0, $gmNpb.getLoomInstanceDataByEnvironment)({
                environment: environment,
                jws: recorderToken,
                siteId: cloudId,
                entryPointName: entryPointLocation
            }));
            setState({
                initializedLoomSDK: initializedLoomSDK,
                isInitializing: false
            });
            (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).stop();
        } catch (err) {
            setState({
                isInitializing: false,
                initializedLoomSDKError: err
            });
            (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
        }
    };
const $82feff28757ef801$var$actions = {
    initLoomSDK: $82feff28757ef801$var$initSDK
};
const $82feff28757ef801$export$6f57813fe9f31bf9 = (0, $8s9DV.createStore)({
    initialState: $82feff28757ef801$var$initialState,
    actions: $82feff28757ef801$var$actions,
    name: 'loomEntryPointGlobalStateStore'
});
const $82feff28757ef801$export$160753b85ca93fc7 = (0, $kBr4q.createHook)($82feff28757ef801$export$6f57813fe9f31bf9);
module.exports["useLoomEntryPointGlobalState"] = $82feff28757ef801$export$160753b85ca93fc7;

});

parcelRegister("3d6VZ", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $e01Lp = parcelRequire("e01Lp");


var $55UbZ = parcelRequire("55UbZ");

const $000d418a80b56fba$export$38e1f53b76ec7fed = async ()=>{
    try {
        const tokenQuery = await (0, $c0rhi.queryInterop)({
            query: (0, $e01Lp.LoomAuthTokenQuery),
            fetchPolicy: 'network-only',
            __callerPackage__: "loom-utils"
        });
        return {
            recorderToken: tokenQuery.data.loomToken?.token
        };
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return {
            tokenError: e
        };
    }
};
const $000d418a80b56fba$export$36491da625b5403b = async ()=>{
    try {
        const authStateQuery = await (0, $c0rhi.queryInterop)({
            query: (0, $55UbZ.LoomAuthStateQuery),
            __callerPackage__: "loom-utils"
        });
        return authStateQuery.data.loomUserStatus ?? undefined;
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return undefined;
    }
};
module.exports["getAuthToken"] = $000d418a80b56fba$export$38e1f53b76ec7fed;
module.exports["getAuthState"] = $000d418a80b56fba$export$36491da625b5403b;

});

parcelRegister("e01Lp", function(module, exports) {

var $ja27m = parcelRequire("ja27m");

const $eeb31b52c8d53ac0$export$68069cc596b806b = (0, $ja27m.default);
module.exports["LoomAuthTokenQuery"] = $eeb31b52c8d53ac0$export$68069cc596b806b;

});

parcelRegister("ja27m", function(module, exports) {
/**
 * @generated SignedSource<<a767a13b18c3ec998970c2ba30768a2a>>
 * @relayHash c1b04759e5b09153deee6b2b9fb9afcf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9f8fd21eba2cf790d782ed412c437c5ce11bf46de81ad10141889884adef0374
const $4984e0489bd92eb4$var$node = function() {
    var v0 = [
        {
            "concreteType": "LoomToken",
            "kind": "LinkedField",
            "name": "loomToken",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "token"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "LoomAuthTokenQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "LoomAuthTokenQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "c1b04759e5b09153deee6b2b9fb9afcf",
            "id": "9f8fd21eba2cf790d782ed412c437c5ce11bf46de81ad10141889884adef0374",
            "metadata": {},
            "name": "LoomAuthTokenQuery",
            "operationKind": "query",
            "text": "query LoomAuthTokenQuery{loomToken{token}}"
        }
    };
}();
$4984e0489bd92eb4$var$node.hash = "cc249b7610e84f631da05d42ccd02363";
var $4984e0489bd92eb4$export$2e2bcd8739ae039 = $4984e0489bd92eb4$var$node;
module.exports["default"] = $4984e0489bd92eb4$export$2e2bcd8739ae039;

});

parcelRegister("55UbZ", function(module, exports) {

var $bj1zQ = parcelRequire("bj1zQ");

const $80afd1194d3d0c84$export$ee3fd3c5221b99c = (0, $bj1zQ.default);
module.exports["LoomAuthStateQuery"] = $80afd1194d3d0c84$export$ee3fd3c5221b99c;

});

parcelRegister("bj1zQ", function(module, exports) {
/**
 * @generated SignedSource<<5d9434e7e3e0611c30d0a597a2a1e57f>>
 * @relayHash 92b5f865f5d3e169ae4c9331a8c93231
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b9901a7bacba0bde9d9d42c3a13ce1a30e9b0aebeb702a0094b5f8ca8c6efa63
const $c5c9d2025b35af51$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "loomUserStatus"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "LoomAuthStateQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "LoomAuthStateQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "92b5f865f5d3e169ae4c9331a8c93231",
            "id": "b9901a7bacba0bde9d9d42c3a13ce1a30e9b0aebeb702a0094b5f8ca8c6efa63",
            "metadata": {},
            "name": "LoomAuthStateQuery",
            "operationKind": "query",
            "text": "query LoomAuthStateQuery{loomUserStatus}"
        }
    };
}();
$c5c9d2025b35af51$var$node.hash = "b0b71e4c1a4d03a9f0016476ce67cefb";
var $c5c9d2025b35af51$export$2e2bcd8739ae039 = $c5c9d2025b35af51$var$node;
module.exports["default"] = $c5c9d2025b35af51$export$2e2bcd8739ae039;

});

parcelRegister("gmNpb", function(module, exports) {
const $39913087ba6f73e2$var$PUBLIC_APP_IDS = {
    noBackend: 'a3f31403-5892-4b68-baf9-a8b1c1f9ef80',
    staging: '811e05d4-b0aa-4ec9-80e4-68cf5e924102',
    production: {
        development: 'dba4f6db-8419-44f6-ac25-32b6fc352747',
        userFacing: '8e345daf-482a-4abf-a612-cb6457110817'
    }
};
const $39913087ba6f73e2$export$c150e4a8d8a3ab35 = ({ environment: environment, jws: jws, siteId: siteId, entryPointName: entryPointName })=>{
    const commonParams = {
        jws: jws,
        siteId: siteId,
        config: {
            enableNewUi: true,
            productName: 'Confluence',
            entryPointName: entryPointName
        }
    };
    if (environment === 'DEVELOPMENT') return {
        ...commonParams,
        mode: 'standard',
        publicAppId: $39913087ba6f73e2$var$PUBLIC_APP_IDS.noBackend,
        environment: 'production' // TODO CTIA-2116: importing the enum as a value causes a big jump in package size (250kb).
    };
    if (environment === 'STAGING') return {
        ...commonParams,
        mode: 'first-party',
        publicAppId: $39913087ba6f73e2$var$PUBLIC_APP_IDS.staging,
        environment: 'staging' // TODO CTIA-2116: importing the enum as a value causes a big jump in package size (250kb).
    };
    return {
        ...commonParams,
        mode: 'first-party',
        publicAppId: (0, $39913087ba6f73e2$var$PUBLIC_APP_IDS.production.userFacing),
        environment: 'production' // TODO CTIA-2116: importing the enum as a value causes a big jump in package size (250kb).
    };
};
module.exports["getLoomInstanceDataByEnvironment"] = $39913087ba6f73e2$export$c150e4a8d8a3ab35;

});

parcelRegister("38NxZ", function(module, exports) {

var $3d6VZ = parcelRequire("3d6VZ");


var $dn8bs = parcelRequire("dn8bs");

const $0e5a08ec05b30096$var$graphqlErrorHasMessage = (error, messageMatch)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some(({ message: message })=>message.includes(messageMatch));
    return false;
};
const $0e5a08ec05b30096$var$FF_DISABLED_MESSAGE = 'Attempted to fetch Loom token without feature flag enabled';
const $0e5a08ec05b30096$var$UNFOUND_OR_UNMASTERED_USER_MESSAGE = 'Failed to fetch loom auth token. Status code: 404';
const $0e5a08ec05b30096$export$5a9a2c39ccb5534c = async (tokenError)=>{
    if ($0e5a08ec05b30096$var$graphqlErrorHasMessage(tokenError, $0e5a08ec05b30096$var$FF_DISABLED_MESSAGE)) return 'backendFF';
    if ($0e5a08ec05b30096$var$graphqlErrorHasMessage(tokenError, $0e5a08ec05b30096$var$UNFOUND_OR_UNMASTERED_USER_MESSAGE)) {
        const authState = await (0, $3d6VZ.getAuthState)();
        if (authState === (0, $dn8bs.LoomUserStatus).NOT_FOUND) return 'not-created';
        if (authState === (0, $dn8bs.LoomUserStatus).LINKED) return 'not-mastered';
        if (authState === (0, $dn8bs.LoomUserStatus).LINKED_ENTERPRISE) return 'not-mastered-enterprise';
    }
    return 'unexpected';
};
module.exports["getNoRecordingAccessReason"] = $0e5a08ec05b30096$export$5a9a2c39ccb5534c;

});

parcelRegister("dn8bs", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $80735413f00f04fc$export$9d643cbb1392f8e6 = /*#__PURE__*/ function(LoomUserStatus) {
    LoomUserStatus["LINKED"] = "LINKED";
    LoomUserStatus["LINKED_ENTERPRISE"] = "LINKED_ENTERPRISE";
    LoomUserStatus["MASTERED"] = "MASTERED";
    LoomUserStatus["NOT_FOUND"] = "NOT_FOUND";
    return LoomUserStatus;
}({});
module.exports["LoomUserStatus"] = $80735413f00f04fc$export$9d643cbb1392f8e6;

});

parcelRegister("49kj1", function(module, exports) {

let $3057c0fc56a94a3e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3057c0fc56a94a3e$var$load("7p6A4"),
    $3057c0fc56a94a3e$var$load("2a8Ft")
]).then(()=>parcelRequire('gzwHi'));

});

parcelRegister("22Bhu", function(module, exports) {

let $17c8afed44a41d98$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $17c8afed44a41d98$var$load("iUXaE"),
    $17c8afed44a41d98$var$load("lTkx9"),
    $17c8afed44a41d98$var$load("6wr18"),
    $17c8afed44a41d98$var$load("fYEgh"),
    $17c8afed44a41d98$var$load("8GFi1"),
    $17c8afed44a41d98$var$load("81e2B"),
    $17c8afed44a41d98$var$load("k0Z8C"),
    $17c8afed44a41d98$var$load("9WjlD"),
    $17c8afed44a41d98$var$load("jV9Gs"),
    $17c8afed44a41d98$var$load("aOIZj"),
    $17c8afed44a41d98$var$load("lFmKr"),
    $17c8afed44a41d98$var$load("eGGci"),
    $17c8afed44a41d98$var$load("83jZ2"),
    $17c8afed44a41d98$var$load("jzUgs"),
    $17c8afed44a41d98$var$load("jfuL6"),
    $17c8afed44a41d98$var$load("kHs7I"),
    $17c8afed44a41d98$var$load("7p6A4"),
    $17c8afed44a41d98$var$load("9I1GN"),
    $17c8afed44a41d98$var$load("ffEVr"),
    $17c8afed44a41d98$var$load("ddvkk"),
    $17c8afed44a41d98$var$load("3upHR"),
    $17c8afed44a41d98$var$load("hZ2FX"),
    $17c8afed44a41d98$var$load("7EorR"),
    $17c8afed44a41d98$var$load("eiF7i"),
    $17c8afed44a41d98$var$load("cvmv4")
]).then(()=>parcelRequire('77IPU'));

});

parcelRegister("4R3wx", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $9wGTI = parcelRequire("9wGTI");


var $932VV = parcelRequire("932VV");


var $cYe4v = parcelRequire("cYe4v");


var $dpJII = parcelRequire("dpJII");


var $eNjW4 = parcelRequire("eNjW4");

const $c8aabf9b2e3d2d10$export$62184c98af916d7a = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(10);
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    let t0;
    if ($[0] !== isBetaEnabled || $[1] !== isLoomDisabled || $[2] !== isLoomEntryPointsEnabled) {
        t0 = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)("confluence_frontend_loom_cross_sell");
        $[0] = isBetaEnabled;
        $[1] = isLoomDisabled;
        $[2] = isLoomEntryPointsEnabled;
        $[3] = t0;
    } else t0 = $[3];
    const skipPermsCheck = t0;
    const t1 = skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__);
    let t2;
    if ($[4] !== t1) {
        t2 = {
            skip: t1
        };
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)(t2);
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) {
        let t3;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[6] = t3;
        } else t3 = $[6];
        return t3;
    }
    if (isBetaEnabled) {
        let t3;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "BETA"
            };
            $[7] = t3;
        } else t3 = $[7];
        return t3;
    }
    if (!(0, $9wGTI.fg)("confluence_frontend_loom_cross_sell")) {
        let t3;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[8] = t3;
        } else t3 = $[8];
        return t3;
    }
    if (loomEntryPointVariant.entryPointVariant === "CROSS_FLOW" && (0, $9wGTI.fg)("confluence_frontend_loom_cross_flow_ads_opt_out")) {
        let t3;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[9] = t3;
        } else t3 = $[9];
        return t3;
    }
    return loomEntryPointVariant;
} : ()=>{
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    // This can be replaced entirely by `isLoomDisabled` once Loom Beta is cleaned up
    const skipPermsCheck = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell');
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)({
        // If the entry point variant has been SSRd, use that result and skip the permissions check
        skip: skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__)
    });
    // If the entry point already exists via SSR, return that value in the hook here (no need to check anything else)
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) return {
        entryPointVariant: 'DISABLED'
    };
    if (isBetaEnabled) return {
        entryPointVariant: 'BETA'
    };
    // This should be moved into useIsLoomDisabled once Loom Beta is cleaned up.
    // For now, we have to do the Beta check first because `confluence_frontend_loom_cross_sell` is
    // not enabled on Beta sites
    if (!(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell')) return {
        entryPointVariant: 'DISABLED'
    };
    if (loomEntryPointVariant.entryPointVariant === 'CROSS_FLOW' && (0, $9wGTI.fg)('confluence_frontend_loom_cross_flow_ads_opt_out')) return {
        entryPointVariant: 'DISABLED'
    };
    return loomEntryPointVariant;
};
module.exports["useLoomEntryPointVariant"] = $c8aabf9b2e3d2d10$export$62184c98af916d7a;

});

parcelRegister("932VV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $dHiKK = parcelRequire("dHiKK");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $7Sm4c = parcelRequire("7Sm4c");


var $i8Ofl = parcelRequire("i8Ofl");

const $45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery = (0, $dHiKK.default);
const $45094daeb894a50e$export$5d821a9fc4b7faa = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(11);
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t0;
    if ($[0] !== cloudId) {
        t0 = {
            cloudId: cloudId
        };
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== activationId || $[3] !== cloudId) {
        t1 = (0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId);
        $[2] = activationId;
        $[3] = cloudId;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== t1) {
        t2 = {
            headers: {
                ...t1
            }
        };
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    const t3 = shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__);
    let t4;
    if ($[7] !== t0 || $[8] !== t2 || $[9] !== t3) {
        t4 = {
            variables: t0,
            context: t2,
            skip: t3
        };
        $[7] = t0;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, {
        ...t4,
        __callerPackage__: "loom-utils"
    });
    if (window.__SSR_LOOM_ENTRY_POINT__) return;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
} : ()=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, {
        variables: {
            cloudId: cloudId
        },
        context: {
            headers: {
                ...(0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId)
            }
        },
        skip: shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__),
        __callerPackage__: "loom-utils"
    });
    if (window.__SSR_LOOM_ENTRY_POINT__) return undefined;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
};
module.exports["useIsLoomEntryPointsEnabled"] = $45094daeb894a50e$export$5d821a9fc4b7faa;

});

parcelRegister("dHiKK", function(module, exports) {
/**
 * @generated SignedSource<<d3a959f3c995162dd3e589ad8c39797e>>
 * @relayHash 255e1eee858b61b7fb061e8b9eb8fbc9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52be4f1688dfc9b763d15d15e543dcc1f7fa631a706f30d258877564a282dbc0
const $dc96dcb71a986382$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceLoomEntryPoints",
            "kind": "LinkedField",
            "name": "confluence_loomEntryPoints",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isLoomEntryPointsEnabled"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "255e1eee858b61b7fb061e8b9eb8fbc9",
            "id": "52be4f1688dfc9b763d15d15e543dcc1f7fa631a706f30d258877564a282dbc0",
            "metadata": {},
            "name": "useIsLoomEntryPointsEnabledQuery",
            "operationKind": "query",
            "text": "query useIsLoomEntryPointsEnabledQuery($cloudId:ID!){confluence_loomEntryPoints(cloudId:$cloudId){isLoomEntryPointsEnabled}}"
        }
    };
}();
$dc96dcb71a986382$var$node.hash = "767e6480b08dd1cf6643fe7ca065c357";
var $dc96dcb71a986382$export$2e2bcd8739ae039 = $dc96dcb71a986382$var$node;
module.exports["default"] = $dc96dcb71a986382$export$2e2bcd8739ae039;

});

parcelRegister("i8Ofl", function(module, exports) {
const $bde9a1914731baf3$var$PRODUCT = 'Confluence Cloud';
const $bde9a1914731baf3$var$buildWorkspaceId = (tenantId, activationId)=>{
    return `ari:cloud:confluence:${tenantId}:workspace/${activationId}`;
};
const $bde9a1914731baf3$export$14ef296862e3705e = (tenantId, activationId)=>{
    const atlAttributionHeader = {
        atlWorkspaceId: $bde9a1914731baf3$var$buildWorkspaceId(tenantId, activationId),
        tenantId: tenantId,
        product: $bde9a1914731baf3$var$PRODUCT,
        service: 'cc-fe-bifrost'
    };
    return {
        'atl-attribution': JSON.stringify(atlAttributionHeader)
    };
};
module.exports["createAtlAttributionHeader"] = $bde9a1914731baf3$export$14ef296862e3705e;

});

parcelRegister("cYe4v", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $8dwdz = parcelRequire("8dwdz");

const $9ecfddb6136413dc$export$a3777efa0eef336c = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
        $[0] = t0;
    } else t0 = $[0];
    const isMobileDeviceOrMobileWeb = t0;
    let t1;
    if ($[1] !== isConfluenceLicensed) {
        t1 = isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)("confluence_loom_beta_enabled");
        $[1] = isConfluenceLicensed;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    const isMobileDeviceOrMobileWeb = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    return isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)('confluence_loom_beta_enabled');
};
module.exports["useIsLoomBetaEnabled"] = $9ecfddb6136413dc$export$a3777efa0eef336c;

});

parcelRegister("dpJII", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bQm3c = parcelRequire("bQm3c");


var $5CUwy = parcelRequire("5CUwy");

const $42c1694041a86183$export$da228976f78945fd = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { skip: t2 } = t1;
    const skip = t2 === undefined ? false : t2;
    const { cloudId: cloudId, userId: userId, environment: environment } = (0, $bQm3c.useSessionData)();
    const [t3, t4] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { loomEntryPointVariant: loomEntryPointVariant } = t3;
    const { initLoomEntryPointVariant: initLoomEntryPointVariant } = t4;
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    let t5;
    let t6;
    if ($[2] !== cloudId || $[3] !== entryPointVariant || $[4] !== environment || $[5] !== initLoomEntryPointVariant || $[6] !== loading || $[7] !== skip || $[8] !== userId) {
        t5 = ()=>{
            if (skip) return;
            if (entryPointVariant === "NONE" && !loading) initLoomEntryPointVariant(cloudId, userId, environment);
        };
        t6 = [
            cloudId,
            initLoomEntryPointVariant,
            loading,
            entryPointVariant,
            skip,
            userId,
            environment
        ];
        $[2] = cloudId;
        $[3] = entryPointVariant;
        $[4] = environment;
        $[5] = initLoomEntryPointVariant;
        $[6] = loading;
        $[7] = skip;
        $[8] = userId;
        $[9] = t5;
        $[10] = t6;
    } else {
        t5 = $[9];
        t6 = $[10];
    }
    (0, $cozmU.useEffect)(t5, t6);
    if (entryPointVariant === "NONE") {
        let t7;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = {
                entryPointVariant: "NONE",
                loading: true
            };
            $[11] = t7;
        } else t7 = $[11];
        return t7;
    }
    return loomEntryPointVariant;
} : ({ skip: skip = false } = {})=>{
    const { cloudId: cloudId, userId: userId, environment: environment } = (0, $bQm3c.useSessionData)();
    const [{ loomEntryPointVariant: loomEntryPointVariant }, { initLoomEntryPointVariant: initLoomEntryPointVariant }] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    (0, $cozmU.useEffect)(()=>{
        if (skip) return;
        if (entryPointVariant === 'NONE' && !loading) initLoomEntryPointVariant(cloudId, userId, environment);
    }, [
        cloudId,
        initLoomEntryPointVariant,
        loading,
        entryPointVariant,
        skip,
        userId,
        environment
    ]);
    if (entryPointVariant === 'NONE') return {
        entryPointVariant: 'NONE',
        loading: true
    };
    return loomEntryPointVariant;
};
module.exports["useLoomPermissionStatus"] = $42c1694041a86183$export$da228976f78945fd;

});

parcelRegister("5CUwy", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $3PNw6 = parcelRequire("3PNw6");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");



var $6mKj3 = parcelRequire("6mKj3");


var $8999o = parcelRequire("8999o");


var $lnyJf = parcelRequire("lnyJf");


var $8J8QJ = parcelRequire("8J8QJ");


var $3uzFB = parcelRequire("3uzFB");


var $2gAEP = parcelRequire("2gAEP");

var $9633e2f0bea217d1$export$ebe749be4eb13ac4 = /*#__PURE__*/ function(LoomTenantProvisionStatus) {
    LoomTenantProvisionStatus["PROVISIONED"] = "provisioned";
    LoomTenantProvisionStatus["NOT_PROVISIONED"] = "not-provisioned";
    LoomTenantProvisionStatus["ERROR"] = "error,";
    return LoomTenantProvisionStatus;
}({});
var $9633e2f0bea217d1$export$7909e54672d1c423 = /*#__PURE__*/ function(LoomUserPermissionStatus) {
    LoomUserPermissionStatus["PERMITTED"] = "permitted";
    LoomUserPermissionStatus["NOT_PERMITTED"] = "not-permitted";
    LoomUserPermissionStatus["ERROR"] = "error,";
    return LoomUserPermissionStatus;
}({});
const $9633e2f0bea217d1$var$getLoomTenantProvisionStatus = async ()=>{
    try {
        const licensedProducts = await (0, $c0rhi.queryInterop)({
            query: (0, $2gAEP.default),
            __callerPackage__: "loom-utils"
        });
        const isTenantLicensed = licensedProducts.data.confluence_tenantContext?.licensedProducts.some((product)=>product.productKey === 'loom' && product.licenseStatus === 'ACTIVE');
        return isTenantLicensed ? "provisioned" : "not-provisioned";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$export$85de6c803181afa9 = async (cloudId, userId, environment)=>{
    if ((0, $6mKj3.isExperimentEnabled)('confluence_frontend_loom_agg_perm_check_exp')) return $9633e2f0bea217d1$var$getLoomUserAggPermissionStatus(cloudId, userId);
    return $9633e2f0bea217d1$export$4fb5a1b2348fe5c4(cloudId, userId, environment);
};
const $9633e2f0bea217d1$export$4fb5a1b2348fe5c4 = async (cloudId, userId, environment)=>{
    const resourceId = `ari:cloud:loom::site/${cloudId}`;
    try {
        let permitted;
        {
            const response = await (0, $8J8QJ.postJson)(`/gateway/api/permissions/permitted`, {
                permissionId: 'write',
                resourceId: resourceId,
                checkProductStatus: true
            });
            permitted = response?.permitted;
        }
        return !!permitted ? "permitted" : "not-permitted";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$var$getLoomUserAggPermissionStatus = async (cloudId, userId)=>{
    if (!userId) return "not-permitted";
    const variables = (0, $3uzFB.getLoomUserPermissionQueryVariables)(cloudId, userId);
    try {
        const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
            query: (0, $3uzFB.LoomUserPermissionQuery),
            variables: variables,
            errorPolicy: 'all',
            interopApolloAggClient: true,
            __callerPackage__: "loom-utils"
        });
        if (error) throw error;
        return (0, $3uzFB.hasExactLoomUserPermission)(data, variables) ? "permitted" : "not-permitted";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$var$initialState = {
    loomEntryPointVariant: window.__SSR_LOOM_ENTRY_POINT__ ? window.__SSR_LOOM_ENTRY_POINT__ : {
        entryPointVariant: 'NONE'
    }
};
const $9633e2f0bea217d1$export$cbb01c57ec9c933e = {
    initLoomEntryPointVariant: (cloudId, userId, environment)=>async ({ getState: getState, setState: setState })=>{
            const state = getState();
            if (state.loomEntryPointVariant.entryPointVariant !== 'NONE') return;
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_FLOW',
                    loading: true
                }
            });
            const loomTenantProvisionStatus = await $9633e2f0bea217d1$var$getLoomTenantProvisionStatus();
            if (loomTenantProvisionStatus === "not-provisioned") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW'
                    }
                });
                return;
            }
            if (loomTenantProvisionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_JOIN',
                    loading: true
                }
            });
            const loomUserPermissionStatus = await $9633e2f0bea217d1$export$85de6c803181afa9(cloudId, userId, environment);
            if (loomUserPermissionStatus === "not-permitted") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN'
                    }
                });
                return;
            }
            if (loomUserPermissionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CO_USE'
                }
            });
        },
    crossFlowSuccessCheck: ({ cloudId: cloudId, onCrossflowFailure: onCrossflowFailure, createAnalyticsEvent: createAnalyticsEvent, sourceComponent: sourceComponent })=>async ({ setState: setState })=>{
            // refetch license information since TCS doesn't update automatically
            try {
                const { ok: hasLoom, tries: tries } = await (0, $8999o.waitUntil)({
                    fn: ()=>(0, $lnyJf.fetchLicenseInformation)(cloudId),
                    condition: (info)=>info.products['loom']?.state === 'ACTIVE',
                    maxTries: 2,
                    // arbitrarily deciding on just 1 retry until we have more data to understand the eventual consistency here
                    retryWait: 500
                });
                (0, $3PNw6.addUFOCustomData)({
                    pollingTries: tries,
                    hasLoom: hasLoom
                });
                if (hasLoom) {
                    // don't bother getLoomUserPermissionStatus here, we assume if the site has loom, the admin will have been given a license during provisioning
                    setState({
                        loomEntryPointVariant: {
                            entryPointVariant: 'CO_USE'
                        }
                    });
                    //This is needed for SSR to work correctly, since we skip logic in useLoomEntryPointVariant.ts if the entry point was SSR-ed
                    window.__SSR_LOOM_ENTRY_POINT__ = {
                        entryPointVariant: 'CO_USE'
                    };
                } else onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'success',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            hasLoom: hasLoom,
                            tries: tries,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            } catch (error) {
                onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'fail',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            error: error.message,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            }
        }
};
const $9633e2f0bea217d1$var$loomEntryPointVariantStore = (0, $8s9DV.createStore)({
    initialState: $9633e2f0bea217d1$var$initialState,
    actions: $9633e2f0bea217d1$export$cbb01c57ec9c933e,
    name: 'loomEntryPointVariantState'
});
const $9633e2f0bea217d1$export$9d93351985de2290 = (0, $kBr4q.createHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
const $9633e2f0bea217d1$export$fd0650c7a15c6ef2 = (0, $kBr4q.createActionsHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
module.exports["LoomTenantProvisionStatus"] = $9633e2f0bea217d1$export$ebe749be4eb13ac4;
module.exports["LoomUserPermissionStatus"] = $9633e2f0bea217d1$export$7909e54672d1c423;
module.exports["getLoomUserLegacyPermissionStatus"] = $9633e2f0bea217d1$export$4fb5a1b2348fe5c4;
module.exports["useLoomEntryPointVariantState"] = $9633e2f0bea217d1$export$9d93351985de2290;

});

parcelRegister("8999o", function(module, exports) {
const $887bf6ed89c38788$export$4e57ed416e50788e = async ({ fn: fn, condition: condition, retryWait: retryWait, maxTries: maxTries })=>{
    let tries = 0;
    while(true){
        tries++;
        const result = await fn();
        const ok = condition(result);
        if (tries === maxTries || ok) return {
            ok: ok,
            result: result,
            tries: tries
        };
        await new Promise((resolve)=>setTimeout(resolve, retryWait));
    }
};
module.exports["waitUntil"] = $887bf6ed89c38788$export$4e57ed416e50788e;

});

parcelRegister("lnyJf", function(module, exports) {

var $8J8QJ = parcelRequire("8J8QJ");

const $1f2e3e69723febb9$export$a573b79a27d213cc = (cloudId)=>(0, $8J8QJ.fetchJSON)(`/gateway/api/xflow/${cloudId}/license-information`);
module.exports["fetchLicenseInformation"] = $1f2e3e69723febb9$export$a573b79a27d213cc;

});

parcelRegister("8J8QJ", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $d6NtA = parcelRequire("d6NtA");

const $a326082f26863093$export$c776284ef4b1209a = (url, data)=>{
    const fetchOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
const $a326082f26863093$export$81bec6e38e8b706b = (url)=>{
    const fetchOptions = {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ...Boolean(undefined) && Boolean(undefined) && !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': 'identity-platform'
            } : {}
        }
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
module.exports["postJson"] = $a326082f26863093$export$c776284ef4b1209a;
module.exports["fetchJSON"] = $a326082f26863093$export$81bec6e38e8b706b;

});

parcelRegister("3uzFB", function(module, exports) {

var $keH2u = parcelRequire("keH2u");

const $9ee481529bbe8b4d$export$a4bb6b905bc500e2 = (0, $keH2u.default);
const $9ee481529bbe8b4d$export$8d50de945dbf45ca = (cloudId, userId)=>({
        principalId: `ari:cloud:identity::user/${userId}`,
        loomResourceId: `ari:cloud:loom::site/${cloudId}`
    });
const $9ee481529bbe8b4d$export$b048e9c33b8e482 = (data, variables)=>{
    const matchingRows = data?.bulkPermitted?.filter((row)=>row?.principalId === variables.principalId && row?.resourceId === variables.loomResourceId && row?.permissionId === 'write') ?? [];
    if (matchingRows.length < 1) return false;
    return matchingRows.every((row)=>row?.permitted === true);
};
module.exports["LoomUserPermissionQuery"] = $9ee481529bbe8b4d$export$a4bb6b905bc500e2;
module.exports["getLoomUserPermissionQueryVariables"] = $9ee481529bbe8b4d$export$8d50de945dbf45ca;
module.exports["hasExactLoomUserPermission"] = $9ee481529bbe8b4d$export$b048e9c33b8e482;

});

parcelRegister("keH2u", function(module, exports) {
/**
 * @generated SignedSource<<9936c66f475f5b5cae80af06b548f8cb>>
 * @relayHash 1246767ea7fb9149278e67c3ec09752c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b59faaba67fb092ef603e9f684b1d3e070c6185add127d90ea41320066a6b1e5
const $ebcff904befcd9cb$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "loomResourceId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "principalId"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "permissionIds",
                    "value": [
                        "write"
                    ]
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "principalIds.0",
                            "variableName": "principalId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "principalIds"
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "resourceIds.0",
                            "variableName": "loomResourceId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "resourceIds"
                }
            ],
            "concreteType": "BulkPermittedResponse",
            "kind": "LinkedField",
            "name": "bulkPermitted",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "principalId"
                },
                {
                    "kind": "ScalarField",
                    "name": "resourceId"
                },
                {
                    "kind": "ScalarField",
                    "name": "permissionId"
                },
                {
                    "kind": "ScalarField",
                    "name": "permitted"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "loomUserPermissionQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "loomUserPermissionQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "1246767ea7fb9149278e67c3ec09752c",
            "id": "b59faaba67fb092ef603e9f684b1d3e070c6185add127d90ea41320066a6b1e5",
            "metadata": {},
            "name": "loomUserPermissionQuery",
            "operationKind": "query",
            "text": "query loomUserPermissionQuery($principalId:String!,$loomResourceId:String!){bulkPermitted(principalIds:[$principalId],resourceIds:[$loomResourceId],permissionIds:[\"write\"]){principalId,resourceId,permissionId,permitted}}"
        }
    };
}();
$ebcff904befcd9cb$var$node.hash = "714c5537c580f754bda23bcf99534b30";
var $ebcff904befcd9cb$export$2e2bcd8739ae039 = $ebcff904befcd9cb$var$node;
module.exports["default"] = $ebcff904befcd9cb$export$2e2bcd8739ae039;

});

parcelRegister("2gAEP", function(module, exports) {
/**
 * @generated SignedSource<<7e1563bf12c221b07284eee871d1f539>>
 * @relayHash e7355c15b066e2e1bf0badd5083ad1e0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af
const $936b36fbe81f4fb7$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "e7355c15b066e2e1bf0badd5083ad1e0",
            "id": "828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af",
            "metadata": {},
            "name": "useLoomTenantProvisionStatusQuery",
            "operationKind": "query",
            "text": "query useLoomTenantProvisionStatusQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}"
        }
    };
}();
$936b36fbe81f4fb7$var$node.hash = "21c387cdafea215b61e4183319580a69";
var $936b36fbe81f4fb7$export$2e2bcd8739ae039 = $936b36fbe81f4fb7$var$node;
module.exports["default"] = $936b36fbe81f4fb7$export$2e2bcd8739ae039;

});

parcelRegister("eNjW4", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $3ricL = parcelRequire("3ricL");


var $8dwdz = parcelRequire("8dwdz");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $a42f1b873e59961a$export$9cca7cb3443dfd1 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    const isLoomFeatureEnabled = (0, $3ricL.isFeatureEnabled)("confluence", "confluence-loom-integration");
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    if (!isLoomFeatureEnabled) return true;
    if (isMobile) return true;
    return false;
} : ()=>{
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    const isLoomFeatureEnabled = (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-loom-integration');
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    // Disable when feature is not enabled in current environment/evaluation
    if (!isLoomFeatureEnabled) return true;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    if (isMobile) return true;
    return false;
};
module.exports["useIsLoomDisabled"] = $a42f1b873e59961a$export$9cca7cb3443dfd1;

});

parcelRegister("9Zt9E", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $4R3wx = parcelRequire("4R3wx");

const $bd6eb7a689d25f96$var$shouldRenderButton = (entryPointVariant, appearance)=>{
    if (appearance === 'comment') return entryPointVariant !== 'NONE' && entryPointVariant !== 'CROSS_FLOW';
    return entryPointVariant !== 'NONE';
};
const $bd6eb7a689d25f96$export$4e56214a02095203 = ({ EditorButtonComponent: EditorButtonComponent, editorAPIRef: editorAPIRef, editorShouldShowToolbarLoomButton: editorShouldShowToolbarLoomButton, appearance: appearance })=>{
    const { entryPointVariant: entryPointVariant } = (0, $4R3wx.useLoomEntryPointVariant)();
    const entryPointVariantRef = (0, $cozmU.useRef)(entryPointVariant);
    /**
   * The Loom plugin should be enabled for all non-disabled Loom entrypoints.
   *
   * This has to be determined on the initial call of the hook (due to the way plugin initialization works).
   * It should also still be OK if the plugin is enabled even for edge cases where the entrypoint is
   * asynchronously determined to be disabled (e.g., when a site has opted out of cross-flow ads) because:
   *
   * `useInitializeLoomPlugin` will handle the conditions for initializing the plugin (to enable recording) and
   * `EditorButtonComponent` will handle conditional rendering (in some cases, even returning `null` to dynamically
   * hide the button)
   */ const isPluginEnabled = entryPointVariant !== 'DISABLED';
    // [ED-27497] IMPORTANT: If you change the code below, please also update the
    // platform/packages/editor/editor-presets-confluence/src/presets/full-page/loomPluginOptions.ts
    const pluginOptions = (0, $cozmU.useMemo)(()=>{
        return {
            renderButton: (ButtonComponent)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(EditorButtonComponent, {
                    buttonComponent: ButtonComponent,
                    editorAPIRef: editorAPIRef
                });
            },
            shouldRenderButton: (0, $6mKj3.expVal)('platform_editor_toolbar_hide_overflow_menu', 'isEnabled', false) ? ()=>$bd6eb7a689d25f96$var$shouldRenderButton(entryPointVariantRef.current, appearance) : undefined,
            ...editorShouldShowToolbarLoomButton !== undefined ? {
                shouldShowToolbarButton: editorShouldShowToolbarLoomButton
            } : {}
        };
    // Intentionally not recreating/updating the plugin options in order to remain consistent with
    // the behavior of the editor preset that uses this hook to generate the loom plugin options
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        isPluginEnabled: isPluginEnabled,
        pluginOptions: pluginOptions
    };
};
module.exports["useLoomPluginOptions"] = $bd6eb7a689d25f96$export$4e56214a02095203;

});

parcelRegister("3GtBN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cnJLk = parcelRequire("cnJLk");


var $4R3wx = parcelRequire("4R3wx");

const $3144bf078b5ec5f7$export$a8d5ff7665612fc7 = ({ loomPlugin: loomPlugin, providerConfig: providerConfig })=>{
    const hasInitialized = (0, $cozmU.useRef)(false);
    const { entryPointVariant: entryPointVariant } = (0, $4R3wx.useLoomEntryPointVariant)();
    const isLoomRecordingEligible = [
        'BETA',
        'CO_USE'
    ].includes(entryPointVariant);
    const initLoom = loomPlugin?.actions.initLoom;
    (0, $cozmU.useEffect)(()=>{
        if (!hasInitialized.current && initLoom && isLoomRecordingEligible) {
            hasInitialized.current = true;
            initLoom({
                loomProvider: (0, $cnJLk.getLoomProvider)(providerConfig)
            });
        }
    }, [
        initLoom,
        isLoomRecordingEligible,
        providerConfig
    ]);
};
module.exports["useInitializeLoomPlugin"] = $3144bf078b5ec5f7$export$a8d5ff7665612fc7;

});

parcelRegister("cnJLk", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");

const $7ac005878fa67dea$export$c58a153e42b1c02d = (0, $dOBRD.default)((config)=>{
    return {
        getClient: async ()=>({
                status: 'loaded',
                client: {
                    attachToButton: ({ button: button, onInsert: onInsert })=>{
                        button.addEventListener('click', ()=>{
                            config.openLoomRecorder({
                                onInsert: (_, video)=>{
                                    onInsert(video);
                                },
                                // intentionally not localized because Loom RecordSDK does not support i18n
                                insertButtonText: 'Insert Loom video'
                            });
                        });
                    }
                }
            })
    };
});
module.exports["getLoomProvider"] = $7ac005878fa67dea$export$c58a153e42b1c02d;

});

parcelRegister("yuV6Z", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");

const $378a693b2c26358e$export$ca6dda5263526f75 = '/gateway/api/emoji';
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $378a693b2c26358e$var$isServerEnvironment = ()=>false; // "1" true || "" false || undefined false
const $378a693b2c26358e$var$isClientEnvironment = ()=>!!window.__SSR_RENDERED__;
const $378a693b2c26358e$export$2e27ba8337eb718f = '/gateway/api/elements/emoji';
const $378a693b2c26358e$export$756c07819e5ddb69 = (cloudId, emojiId, scale)=>{
    const baseUrl = (0, $ixfCV.fg)('use-elements-stargate-emoji-path') ? $378a693b2c26358e$export$2e27ba8337eb718f : $378a693b2c26358e$export$ca6dda5263526f75;
    return `${baseUrl}/${cloudId}/${emojiId}/path?scale=${scale ?? 'MDPI'}`;
};
const $378a693b2c26358e$export$761bef4dd134445c = (params)=>{
    const { isSSR: isSSR, hasCloudId: hasCloudId, isGuestUser: isGuestUser } = params;
    const ssrEnabled = !!(isSSR && hasCloudId);
    // SSR Not Supported
    if (!ssrEnabled || isGuestUser) return false;
    // SSR For Logged in Users
    return true;
};
const $378a693b2c26358e$export$fc7d38d59502d4a6 = ({ onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail })=>{
    if (!onEmojiLoadSuccess && !onEmojiLoadFail) return undefined;
    return {
        onEmojiLoadSuccess: onEmojiLoadSuccess,
        onEmojiLoadFail: onEmojiLoadFail
    };
};
const $378a693b2c26358e$export$91e66df277b39831 = (emojiId)=>{
    const { id: id, shortName: shortName } = emojiId;
    const regexp = new RegExp(/:([^:]+):/g); // tests and takes the value between two colons
    if (id) return id;
    if (regexp.test(shortName)) return shortName.replaceAll(':', '');
    return shortName;
};
const $378a693b2c26358e$export$1dcae2834e6255a2 = (params)=>{
    // Feature enabled flags
    const isSSR = $378a693b2c26358e$var$isServerEnvironment() || $378a693b2c26358e$var$isClientEnvironment();
    const isGuestUser = !params.isLicensed || !params.isLoggedIn;
    // Transform parameters
    const cloudId = params?.cloudId ?? '';
    const userId = params?.userId ?? undefined;
    const disableUpload = params?.disableUpload;
    const emojiSSRConfig = params?.emojiSSRConfig ?? {};
    // Enable emoji ssr
    const useEmojiSSR = $378a693b2c26358e$export$761bef4dd134445c({
        isSSR: isSSR,
        hasCloudId: !!cloudId,
        isGuestUser: isGuestUser
    });
    // Default emoji SSR interface
    const emojiSSRConfigOverride = useEmojiSSR ? {
        optimisticImageApi: {
            getUrl: (emojiId)=>$378a693b2c26358e$export$756c07819e5ddb69(cloudId, $378a693b2c26358e$export$91e66df277b39831(emojiId))
        },
        ...emojiSSRConfig
    } : undefined;
    // Enable emoji load callbacks
    const emojiLoadCallbacks = $378a693b2c26358e$export$fc7d38d59502d4a6({
        onEmojiLoadSuccess: params?.onEmojiLoadSuccess,
        onEmojiLoadFail: params?.onEmojiLoadFail
    });
    return {
        cloudId: cloudId,
        userId: userId,
        disableUpload: disableUpload,
        ...useEmojiSSR && {
            emojiSSRConfig: emojiSSRConfigOverride
        },
        emojiLoadCallbacks: emojiLoadCallbacks
    };
};
module.exports["getOptimisticImageURL"] = $378a693b2c26358e$export$756c07819e5ddb69;
module.exports["getEmojiSSRSupport"] = $378a693b2c26358e$export$761bef4dd134445c;
module.exports["createEmojiProviderParameters"] = $378a693b2c26358e$export$1dcae2834e6255a2;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("3b6WO", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $kSwu1 = parcelRequire("kSwu1");


var $cozmU = parcelRequire("cozmU");


var $d5Ozc = parcelRequire("d5Ozc");


var $hzmpb = parcelRequire("hzmpb");


var $9wGTI = parcelRequire("9wGTI");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $kqIWy = parcelRequire("kqIWy");


var $bFDX4 = parcelRequire("bFDX4");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $6qkXi = parcelRequire("6qkXi");

const $8eb9026be26e0c85$export$cab421e039d23b2 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: t1, skipQuery: t2, spaceContextOnly: spaceContextOnly, attachmentId: attachmentId, contentId: providedContentId, spaceKey: providedSpaceKey } = t0;
    const returnBlockedExtensions = t1 === undefined ? false : t1;
    const skipQuery = t2 === undefined ? false : t2;
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceKey = providedSpaceKey || pageSpaceKey;
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = providedContentId || pageContentId;
    const resolvedAttachmentId = (0, $9wGTI.fg)("forge_attachment_display_conditions") ? attachmentId : undefined;
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    let t3;
    if ($[0] !== cloudId || $[1] !== contentId || $[2] !== locale || $[3] !== moduleType || $[4] !== queryOptions || $[5] !== resolvedAttachmentId || $[6] !== returnBlockedExtensions || $[7] !== skipQuery || $[8] !== spaceContextOnly || $[9] !== spaceKey) {
        t3 = (0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            ...resolvedAttachmentId ? {
                attachmentId: resolvedAttachmentId
            } : {},
            spaceContextOnly: spaceContextOnly
        });
        $[0] = cloudId;
        $[1] = contentId;
        $[2] = locale;
        $[3] = moduleType;
        $[4] = queryOptions;
        $[5] = resolvedAttachmentId;
        $[6] = returnBlockedExtensions;
        $[7] = skipQuery;
        $[8] = spaceContextOnly;
        $[9] = spaceKey;
        $[10] = t3;
    } else t3 = $[10];
    const options = t3;
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    let t4;
    let t5;
    if ($[11] !== extsError || $[12] !== spaceError) {
        t4 = ()=>{
            if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
            if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
        };
        t5 = [
            extsError,
            spaceError
        ];
        $[11] = extsError;
        $[12] = spaceError;
        $[13] = t4;
        $[14] = t5;
    } else {
        t4 = $[13];
        t5 = $[14];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[15] !== extsData || $[16] !== extsError || $[17] !== extsLoading) {
        t6 = {
            extensions: extsData,
            loading: extsLoading,
            error: extsError
        };
        $[15] = extsData;
        $[16] = extsError;
        $[17] = extsLoading;
        $[18] = t6;
    } else t6 = $[18];
    return t6;
} : ({ moduleType: moduleType, queryOptions: queryOptions, returnBlockedExtensions: returnBlockedExtensions = false, skipQuery: skipQuery = false, spaceContextOnly: spaceContextOnly, attachmentId: attachmentId, contentId: providedContentId, spaceKey: providedSpaceKey })=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [pageSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const spaceKey = providedSpaceKey || pageSpaceKey;
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = providedContentId || pageContentId;
    const resolvedAttachmentId = (0, $9wGTI.fg)('forge_attachment_display_conditions') ? attachmentId : undefined;
    const { error: spaceError } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const options = (0, $cozmU.useMemo)(()=>(0, $6qkXi.getUsePrefilteredExtensionListOptions)({
            cloudId: cloudId,
            locale: locale,
            moduleType: moduleType,
            queryOptions: {
                ...queryOptions,
                skip: skipQuery
            },
            includeHidden: returnBlockedExtensions,
            spaceKey: spaceKey,
            contentId: contentId,
            ...resolvedAttachmentId ? {
                attachmentId: resolvedAttachmentId
            } : {},
            spaceContextOnly: spaceContextOnly
        }), [
        cloudId,
        locale,
        moduleType,
        queryOptions,
        returnBlockedExtensions,
        skipQuery,
        spaceKey,
        contentId,
        resolvedAttachmentId,
        spaceContextOnly
    ]);
    const { extensions: extsData, loading: extsLoading, error: extsError } = $8eb9026be26e0c85$var$usePrefilteredExtensionList(options);
    (0, $cozmU.useEffect)(()=>{
        // suppress 403 errors as we can't do much with them
        if (extsError && (0, $1uFM6.isUnauthorizedError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        // suppress 429 errors for offending users
        if ((0, $bFDX4.isTooManyRequestsError)(extsError)) (0, $7Sm4c.markErrorAsHandled)(extsError);
        if (spaceError) (0, $7Sm4c.markErrorAsHandled)(spaceError);
    }, [
        extsError,
        spaceError
    ]);
    return {
        extensions: extsData,
        loading: extsLoading,
        error: extsError
    };
};
const $8eb9026be26e0c85$var$usePrefilteredExtensionList = (0, $d5Ozc.conditionalHooksFactory)(()=>(0, $9wGTI.fg)('forge-ui-migrate-extension-list-query-to-relay'), (0, $hzmpb.usePrefilteredExtensionListRelay), (0, $hzmpb.usePrefilteredExtensionList));
module.exports["useExtensionList"] = $8eb9026be26e0c85$export$cab421e039d23b2;

});

parcelRegister("hzmpb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $gGKeL = parcelRequire("gGKeL");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $7EPz1 = parcelRequire("7EPz1");


var $ix7El = parcelRequire("ix7El");


var $DIyeF = parcelRequire("DIyeF");


var $2rD5H = parcelRequire("2rD5H");


var $9DHhW = parcelRequire("9DHhW");


var $852mP = parcelRequire("852mP");


var $4K6lC = parcelRequire("4K6lC");


var $iGKcz = parcelRequire("iGKcz");


var $jGizm = parcelRequire("jGizm");

const $c7be4ab3ad813948$export$7f11ec46a05c7477 = (cloudId, context, client, types, locale, includeHidden, queryOptions, contextIds = [
    cloudId
])=>{
    const variables = {
        cloudId: cloudId,
        context: context,
        includeHidden: includeHidden ?? false,
        types: types,
        locale: locale
    };
    return {
        variables: variables,
        ...queryOptions,
        client: client,
        /**
     * We don't want to set 'ignore' because that discards errors and we need to inspect
     * them for SLI reporting. We also need 'all' so we don't discard data on errors:http://go/j/AUX-317
     * https://www.apollographql.com/docs/react/data/error-handling/
     */ errorPolicy: 'all',
        context: {
            headers: {
                'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)(contextIds.sort().join())
            },
            allowOnExternalPage: true
        }
    };
};
const $c7be4ab3ad813948$export$88e0391b02a3c5c9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types, client: client, queryOptions: queryOptions } = t0;
    let t1;
    if ($[0] !== client || $[1] !== cloudId || $[2] !== context || $[3] !== includeHidden || $[4] !== locale || $[5] !== queryOptions || $[6] !== types) {
        t1 = $c7be4ab3ad813948$export$7f11ec46a05c7477(cloudId, context, client, types, locale, includeHidden, queryOptions);
        $[0] = client;
        $[1] = cloudId;
        $[2] = context;
        $[3] = includeHidden;
        $[4] = locale;
        $[5] = queryOptions;
        $[6] = types;
        $[7] = t1;
    } else t1 = $[7];
    const requestOptions = t1;
    const { error: error, loading: loading, data: data } = (0, $7EPz1.useQuery)((0, $2rD5H.FetchPreFilteredForgeAppsQuery), requestOptions);
    let t2;
    if ($[8] !== data || $[9] !== loading) {
        t2 = $c7be4ab3ad813948$export$55348c7eb6377fe1({
            loading: loading,
            data: data
        });
        $[8] = data;
        $[9] = loading;
        $[10] = t2;
    } else t2 = $[10];
    const extensions = t2;
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t3;
    let t4;
    if ($[11] !== createAnalyticsEvent || $[12] !== extensions || $[13] !== page) {
        t3 = ()=>{
            if (extensions) createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: "succeeded",
                    actionSubject: "forge.ui.webClient",
                    source: page,
                    tags: [
                        "forge"
                    ],
                    attributes: {
                        target: "usePrefilteredExtensionList"
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        };
        t4 = [
            extensions,
            page,
            createAnalyticsEvent
        ];
        $[11] = createAnalyticsEvent;
        $[12] = extensions;
        $[13] = page;
        $[14] = t3;
        $[15] = t4;
    } else {
        t3 = $[14];
        t4 = $[15];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[16] !== createAnalyticsEvent || $[17] !== error || $[18] !== extensions || $[19] !== page) {
        t5 = ()=>{
            if (!extensions && error && error.graphQLErrors.length > 0) {
                const err_0 = error.graphQLErrors.find($c7be4ab3ad813948$var$_temp);
                createAnalyticsEvent({
                    eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                    data: {
                        action: "failed",
                        actionSubject: "forge.ui.webClient",
                        source: page,
                        tags: [
                            "forge"
                        ],
                        attributes: {
                            target: "usePrefilteredExtensionList",
                            errorName: err_0 ? (0, $ix7El.isGQLUnderlyingServiceError)(err_0) ? "componentApi" : "componentGraphQL" : "uncaught"
                        }
                    }
                }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
            }
        };
        t6 = [
            extensions,
            error,
            page,
            createAnalyticsEvent
        ];
        $[16] = createAnalyticsEvent;
        $[17] = error;
        $[18] = extensions;
        $[19] = page;
        $[20] = t5;
        $[21] = t6;
    } else {
        t5 = $[20];
        t6 = $[21];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[22] !== extensions) {
        t7 = extensions || [];
        $[22] = extensions;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== error || $[25] !== loading || $[26] !== t7) {
        t8 = {
            error: error,
            extensions: t7,
            loading: loading
        };
        $[24] = error;
        $[25] = loading;
        $[26] = t7;
        $[27] = t8;
    } else t8 = $[27];
    return t8;
} : ({ cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types, client: client, queryOptions: queryOptions })=>{
    const requestOptions = $c7be4ab3ad813948$export$7f11ec46a05c7477(cloudId, context, client, types, locale, includeHidden, queryOptions);
    const { error: error, loading: loading, data: data } = (0, $7EPz1.useQuery)((0, $2rD5H.FetchPreFilteredForgeAppsQuery), requestOptions);
    const extensions = $c7be4ab3ad813948$export$55348c7eb6377fe1({
        loading: loading,
        data: data
    });
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'usePrefilteredExtensionList'
                }
            }
        }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && error.graphQLErrors.length > 0) {
            const err_0 = error.graphQLErrors.find((err)=>(0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'usePrefilteredExtensionList',
                        errorName: err_0 ? (0, $ix7El.isGQLUnderlyingServiceError)(err_0) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        error: error,
        extensions: extensions || [],
        loading: loading
    };
};
const $c7be4ab3ad813948$export$55348c7eb6377fe1 = ({ loading: loading, data: data })=>{
    const extensions = data?.confluence_forgeExtensionsByType || [];
    if (!loading && extensions.length > 0) return (0, $jGizm.transformPreFilteredExtensions)(extensions);
    return null;
};
const $c7be4ab3ad813948$var$fetchRequests = new Map();
const $c7be4ab3ad813948$export$f55e1916fecb1860 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types } = t0;
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const [extensions, setExtensions] = (0, $cozmU.useState)(null);
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    let t2;
    if ($[0] !== cloudId || $[1] !== context || $[2] !== environment || $[3] !== includeHidden || $[4] !== locale || $[5] !== types) {
        t1 = ()=>{
            const cacheKey = JSON.stringify({
                cloudId: cloudId,
                context: context,
                includeHidden: includeHidden,
                locale: locale,
                types: types
            });
            if (!$c7be4ab3ad813948$var$fetchRequests.has(cacheKey)) {
                const extensions_0 = new Promise((resolve, reject)=>{
                    (0, $6SsN4.fetchQuery)(environment, (0, $gGKeL.default), {
                        cloudId: cloudId,
                        context: context,
                        includeHidden: includeHidden,
                        locale: locale,
                        types: types
                    }, {
                        networkCacheConfig: {
                            metadata: {
                                headers: {
                                    "atl-attribution": (0, $iGKcz.createAtlAttributionHeader)(cloudId)
                                },
                                allowOnExternalPage: true
                            }
                        }
                    }).subscribe({
                        next: (data)=>{
                            resolve($c7be4ab3ad813948$export$55348c7eb6377fe1({
                                data: data,
                                loading: false
                            }));
                        },
                        error: (error_0)=>{
                            $c7be4ab3ad813948$var$fetchRequests.delete(cacheKey);
                            reject(error_0);
                        }
                    });
                });
                $c7be4ab3ad813948$var$fetchRequests.set(cacheKey, extensions_0);
            }
            $c7be4ab3ad813948$var$fetchRequests.get(cacheKey).then((extensions_1)=>{
                setExtensions(extensions_1);
                setLoading(false);
            }).catch((error_1)=>{
                setError(error_1);
                setLoading(false);
            });
        };
        t2 = [
            cloudId,
            context,
            includeHidden,
            locale,
            types,
            environment
        ];
        $[0] = cloudId;
        $[1] = context;
        $[2] = environment;
        $[3] = includeHidden;
        $[4] = locale;
        $[5] = types;
        $[6] = t1;
        $[7] = t2;
    } else {
        t1 = $[6];
        t2 = $[7];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[8] !== createAnalyticsEvent || $[9] !== extensions || $[10] !== page) {
        t3 = ()=>{
            if (extensions) createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: "succeeded",
                    actionSubject: "forge.ui.webClient",
                    source: page,
                    tags: [
                        "forge"
                    ],
                    attributes: {
                        target: "usePrefilteredExtensionList"
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        };
        t4 = [
            extensions,
            page,
            createAnalyticsEvent
        ];
        $[8] = createAnalyticsEvent;
        $[9] = extensions;
        $[10] = page;
        $[11] = t3;
        $[12] = t4;
    } else {
        t3 = $[11];
        t4 = $[12];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[13] !== createAnalyticsEvent || $[14] !== error || $[15] !== extensions || $[16] !== page) {
        t5 = ()=>{
            if (!extensions && error && (0, $ix7El.isRelayNetworkError)(error)) {
                const err_0 = error.source.errors.find($c7be4ab3ad813948$var$_temp2);
                createAnalyticsEvent({
                    eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                    data: {
                        action: "failed",
                        actionSubject: "forge.ui.webClient",
                        source: page,
                        tags: [
                            "forge"
                        ],
                        attributes: {
                            target: "useExtensionList",
                            errorName: err_0 ? (0, $ix7El.isGQLUnderlyingServiceError)(err_0) ? "componentApi" : "componentGraphQL" : "uncaught"
                        }
                    }
                }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
            }
        };
        t6 = [
            extensions,
            error,
            page,
            createAnalyticsEvent
        ];
        $[13] = createAnalyticsEvent;
        $[14] = error;
        $[15] = extensions;
        $[16] = page;
        $[17] = t5;
        $[18] = t6;
    } else {
        t5 = $[17];
        t6 = $[18];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[19] !== extensions) {
        t7 = extensions || [];
        $[19] = extensions;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== error || $[22] !== loading || $[23] !== t7) {
        t8 = {
            extensions: t7,
            loading: loading,
            error: error
        };
        $[21] = error;
        $[22] = loading;
        $[23] = t7;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
} : ({ cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types })=>{
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const [extensions, setExtensions] = (0, $cozmU.useState)(null);
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        const cacheKey = JSON.stringify({
            cloudId: cloudId,
            context: context,
            includeHidden: includeHidden,
            locale: locale,
            types: types
        });
        if (!$c7be4ab3ad813948$var$fetchRequests.has(cacheKey)) {
            const extensions_0 = new Promise((resolve, reject)=>{
                (0, $6SsN4.fetchQuery)(environment, (0, $gGKeL.default), {
                    cloudId: cloudId,
                    context: // @ts-ignore - the generated types convert GQL Long to a number, which may truncate the id. The type will be changed to string
                    context,
                    includeHidden: includeHidden,
                    locale: locale,
                    types: types
                }, {
                    networkCacheConfig: {
                        metadata: {
                            headers: {
                                'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)(cloudId)
                            },
                            allowOnExternalPage: true
                        }
                    }
                }).subscribe({
                    next: (data)=>{
                        resolve($c7be4ab3ad813948$export$55348c7eb6377fe1({
                            data: data,
                            loading: false
                        }));
                    },
                    error: (error_0)=>{
                        $c7be4ab3ad813948$var$fetchRequests.delete(cacheKey);
                        reject(error_0);
                    }
                });
            });
            $c7be4ab3ad813948$var$fetchRequests.set(cacheKey, extensions_0);
        }
        $c7be4ab3ad813948$var$fetchRequests.get(cacheKey).then((extensions_1)=>{
            setExtensions(extensions_1);
            setLoading(false);
        }).catch((error_1)=>{
            setError(error_1);
            setLoading(false);
        });
    }, [
        cloudId,
        context,
        includeHidden,
        locale,
        types,
        environment
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'usePrefilteredExtensionList'
                }
            }
        }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && (0, $ix7El.isRelayNetworkError)(error)) {
            const err_0 = error.source.errors.find((err)=>(0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'useExtensionList',
                        errorName: err_0 ? (0, $ix7El.isGQLUnderlyingServiceError)(err_0) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        extensions: extensions || [],
        loading: loading,
        error: error
    };
};
function $c7be4ab3ad813948$var$_temp(err) {
    return (0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err);
}
function $c7be4ab3ad813948$var$_temp2(err) {
    return (0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err);
}
module.exports["createUsePrefilteredExtensionListQueryOptions"] = $c7be4ab3ad813948$export$7f11ec46a05c7477;
module.exports["usePrefilteredExtensionList"] = $c7be4ab3ad813948$export$88e0391b02a3c5c9;
module.exports["getPrefilteredExtensionsGQLResult"] = $c7be4ab3ad813948$export$55348c7eb6377fe1;
module.exports["usePrefilteredExtensionListRelay"] = $c7be4ab3ad813948$export$f55e1916fecb1860;

});

parcelRegister("gGKeL", function(module, exports) {
/**
 * @generated SignedSource<<34b9bd3d4874799a2e3dfbdec507c380>>
 * @relayHash 57057313f17699c6ffabb286b9a1141a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 849f20631fa84f3517a0c2c9b324c8769fe830778f9926f3c77e8c60cb80034b
const $57d2af88a889106f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "context"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeHidden"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "types"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "key"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "context",
                    "variableName": "context"
                },
                {
                    "kind": "Variable",
                    "name": "includeHidden",
                    "variableName": "includeHidden"
                },
                {
                    "kind": "Variable",
                    "name": "locale",
                    "variableName": "locale"
                },
                {
                    "kind": "Variable",
                    "name": "types",
                    "variableName": "types"
                }
            ],
            "concreteType": "ConfluenceForgeExtension",
            "kind": "LinkedField",
            "name": "confluence_forgeExtensionsByType",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "appId"
                },
                {
                    "kind": "ScalarField",
                    "name": "appVersion"
                },
                {
                    "kind": "ScalarField",
                    "name": "appOwner"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentType"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "consentUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "migrationKey"
                },
                {
                    "concreteType": "ConfluenceUserAccess",
                    "kind": "LinkedField",
                    "name": "userAccess",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "enabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasAccess"
                        }
                    ]
                },
                v1 /*: any*/ ,
                {
                    "concreteType": "KeyValueHierarchyMap",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceExtensionEgressDeclaration",
                    "kind": "LinkedField",
                    "name": "egress",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "addresses"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "inScopeEUD"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "scopes"
                },
                {
                    "concreteType": "ConfluenceAppInstallationLicense",
                    "kind": "LinkedField",
                    "name": "license",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "active"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "capabilitySet"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "billingPeriod"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementSlug"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isEvaluation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionEndDate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "trialEndDate"
                        },
                        v2 /*: any*/ 
                    ]
                },
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "installationId"
                },
                {
                    "kind": "ScalarField",
                    "name": "hiddenBy"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePrefilteredExtensionList_forge_ui_Query",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePrefilteredExtensionList_forge_ui_Query",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "id": "849f20631fa84f3517a0c2c9b324c8769fe830778f9926f3c77e8c60cb80034b",
            "metadata": {},
            "name": "usePrefilteredExtensionList_forge_ui_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$57d2af88a889106f$var$node.hash = "d028e6b4d01b71cf67c24b6983fbfddf";
var $57d2af88a889106f$export$2e2bcd8739ae039 = $57d2af88a889106f$var$node;
module.exports["default"] = $57d2af88a889106f$export$2e2bcd8739ae039;

});

parcelRegister("ix7El", function(module, exports) {
var $04c5b557f78447f3$export$d76ef0f862d061a6 = /*#__PURE__*/ function(GQLExtensionContextsFilterType) {
    GQLExtensionContextsFilterType["Container"] = "CONTAINER";
    GQLExtensionContextsFilterType["DataClassificationTag"] = "DATA_CLASSIFICATION_TAG";
    GQLExtensionContextsFilterType["ExtensionType"] = "EXTENSION_TYPE";
    GQLExtensionContextsFilterType["PrincipalType"] = "PRINCIPAL_TYPE";
    GQLExtensionContextsFilterType["AppIdEnvironmentId"] = "APP_ID_ENVIRONMENT_ID";
    return GQLExtensionContextsFilterType;
}({});
const $04c5b557f78447f3$export$1a949ef92fd30eca = (error)=>{
    return error instanceof Error && error.name === 'RelayNetwork' && 'source' in error && Array.isArray(error.source?.errors);
};
const $04c5b557f78447f3$export$8d1c210bc17223c1 = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'GRAPHQL_GATEWAY';
const $04c5b557f78447f3$export$9c0545f564a8227f = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'UNDERLYING_SERVICE';
module.exports["GQLExtensionContextsFilterType"] = $04c5b557f78447f3$export$d76ef0f862d061a6;
module.exports["isRelayNetworkError"] = $04c5b557f78447f3$export$1a949ef92fd30eca;
module.exports["isGQLGatewayError"] = $04c5b557f78447f3$export$8d1c210bc17223c1;
module.exports["isGQLUnderlyingServiceError"] = $04c5b557f78447f3$export$9c0545f564a8227f;

});

parcelRegister("DIyeF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5xQdV = parcelRequire("5xQdV");


var $6ojvx = parcelRequire("6ojvx");

const $5577a309d6f3499e$export$b438ce9ad9530ae5 = /*#__PURE__*/ (0, $cozmU.createContext)({
    environment: undefined,
    product: '',
    page: ''
});
const $5577a309d6f3499e$export$163ecee29aa3a8f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { value: value, children: children } = t0;
    const envFromContext = (0, $cozmU.useContext)((0, $6ojvx.EnvironmentContext));
    const { product: product, page: page, environment: environment } = value;
    let t1;
    let t2;
    if ($[0] !== envFromContext || $[1] !== environment || $[2] !== page || $[3] !== product) {
        t1 = ()=>({
                environment: environment ?? envFromContext,
                product: product,
                page: page
            });
        t2 = [
            page,
            environment,
            envFromContext,
            product
        ];
        $[0] = envFromContext;
        $[1] = environment;
        $[2] = page;
        $[3] = product;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    const memoedValue = (0, $5xQdV.useMemoOne)(t1, t2);
    let t3;
    if ($[6] !== children || $[7] !== memoedValue) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5577a309d6f3499e$export$b438ce9ad9530ae5.Provider, {
            value: memoedValue
        }, children);
        $[6] = children;
        $[7] = memoedValue;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ value: value, children: children })=>{
    const envFromContext = (0, $cozmU.useContext)((0, $6ojvx.EnvironmentContext));
    const { product: product, page: page, environment: environment } = value;
    const memoedValue = (0, $5xQdV.useMemoOne)(()=>{
        return {
            environment: environment ?? envFromContext,
            product: product,
            page: page
        };
    }, [
        page,
        environment,
        envFromContext,
        product
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5577a309d6f3499e$export$b438ce9ad9530ae5.Provider, {
        value: memoedValue
    }, children);
};
const $5577a309d6f3499e$export$dba2dab0d0f39612 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($5577a309d6f3499e$export$b438ce9ad9530ae5);
} : ()=>{
    return (0, $cozmU.useContext)($5577a309d6f3499e$export$b438ce9ad9530ae5);
};
module.exports["MetricsContext"] = $5577a309d6f3499e$export$b438ce9ad9530ae5;
module.exports["MetricsContextProvider"] = $5577a309d6f3499e$export$163ecee29aa3a8f;
module.exports["useMetricsContext"] = $5577a309d6f3499e$export$dba2dab0d0f39612;

});

parcelRegister("6ojvx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

parcelRequire("bLswh");
var $hBxDy = parcelRequire("hBxDy");

const $59e5036a3fbf2e2e$export$6a671bebd9daad64 = (0, $cozmU.createContext)((0, $hBxDy.ProductEnvironment).PRODUCTION);
module.exports["EnvironmentContext"] = $59e5036a3fbf2e2e$export$6a671bebd9daad64;

});

parcelRegister("bLswh", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("hBxDy")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("hBxDy")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2zscg")).ExtensionEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2zscg")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2zscg")).JiraExtension);
parcelRequire("9iaDP");
var $2zscg = parcelRequire("2zscg");
var $hBxDy = parcelRequire("hBxDy");

parcelRequire("gwrSD");
var $hcYP2 = parcelRequire("hcYP2");
var $31kME = parcelRequire("31kME");
var $d8yi8 = parcelRequire("d8yi8");


});

parcelRegister("9iaDP", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("hBxDy")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("hBxDy")).ForgeCDNEnvironment);
$parcel$export(module.exports, "BitbucketExtension", () => (parcelRequire("2zscg")).BitbucketExtension);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2zscg")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2zscg")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2zscg")).JiraExtension);

var $2y56N = parcelRequire("2y56N");


var $hBxDy = parcelRequire("hBxDy");


var $iztBQ = parcelRequire("iztBQ");


var $2zscg = parcelRequire("2zscg");


});

parcelRegister("2y56N", function(module, exports) {
const $43f88a3108220757$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $43f88a3108220757$export$3ee8c58bb87b9685 = [
    ...$43f88a3108220757$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];

});

parcelRegister("iztBQ", function(module, exports) {
const $6db1db68019c99c9$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2zscg", function(module, exports) {
var $a413c718e4c7bf40$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $a413c718e4c7bf40$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    FULL_PAGE: 'confluence:fullPage',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $a413c718e4c7bf40$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    FULL_PAGE: 'jira:fullPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
const $a413c718e4c7bf40$export$586232a3e4271798 = {
    CUSTOM_MERGE_CHECK: 'bitbucket:mergeCheck',
    DYNAMIC_PIPELINES_PROVIDER: 'bitbucket:dynamicPipelinesProvider',
    REPOSITORY_CODE_FILE_VIEWER: 'bitbucket:repoCodeFileViewer',
    REPOSITORY_CODE_OVERVIEW_CARD: 'bitbucket:repoCodeOverviewCard',
    REPOSITORY_CODE_OVERVIEW_ACTION: 'bitbucket:repoCodeOverviewAction',
    REPOSITORY_CODE_OVERVIEW_PANEL: 'bitbucket:repoCodeOverviewPanel',
    REPOSITORY_PULL_REQUEST_CARD: 'bitbucket:repoPullRequestCard',
    REPOSITORY_PULL_REQUEST_ACTION: 'bitbucket:repoPullRequestAction',
    REPOSITORY_PULL_REQUEST_OVERVIEW_PANEL: 'bitbucket:repoPullRequestOverviewPanel',
    REPOSITORY_MAIN_MENU_PAGE: 'bitbucket:repoMainMenuPage',
    REPOSITORY_SETTINGS_MENU_PAGE: 'bitbucket:repoSettingsMenuPage',
    PROJECT_SETTINGS_MENU_PAGE: 'bitbucket:projectSettingsMenuPage',
    WORKSPACE_GLOBAL_PAGE: 'bitbucket:workspaceGlobalPage',
    WORKSPACE_PERSONAL_SETTINGS_PAGE: 'bitbucket:workspacePersonalSettingsPage',
    WORKSPACE_SETTINGS_MENU_PAGE: 'bitbucket:workspaceSettingsMenuPage'
};
module.exports["ExtensionEnvironment"] = $a413c718e4c7bf40$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $a413c718e4c7bf40$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $a413c718e4c7bf40$export$f06ffa3aa6bfec95;
module.exports["BitbucketExtension"] = $a413c718e4c7bf40$export$586232a3e4271798;

});

parcelRegister("gwrSD", function(module, exports) {

var $d8yi8 = parcelRequire("d8yi8");


var $31kME = parcelRequire("31kME");


var $hcYP2 = parcelRequire("hcYP2");


});

parcelRegister("d8yi8", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $487f0b3478e8e725$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $487f0b3478e8e725$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $487f0b3478e8e725$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $487f0b3478e8e725$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $487f0b3478e8e725$export$20b9f6acb0888554(effect) {
    return $487f0b3478e8e725$export$7e816460364ed464(effect) || $487f0b3478e8e725$export$eb5bd7f371e458af(effect) || $487f0b3478e8e725$export$f632ad3064955f31(effect);
}

});

parcelRegister("31kME", function(module, exports) {
const $7d3783c6a9539d7e$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $7d3783c6a9539d7e$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $7d3783c6a9539d7e$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $7d3783c6a9539d7e$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $7d3783c6a9539d7e$export$caa8cab0db5b0a61(effect) {
    return $7d3783c6a9539d7e$export$65d7078e01574f24(effect) || $7d3783c6a9539d7e$export$709a27a9f80556b8(effect) || $7d3783c6a9539d7e$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("hcYP2", function(module, exports) {
// From forge.ts
const $1da5394af23f0a63$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $1da5394af23f0a63$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $1da5394af23f0a63$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $1da5394af23f0a63$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $1da5394af23f0a63$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $1da5394af23f0a63$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $1da5394af23f0a63$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $1da5394af23f0a63$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $1da5394af23f0a63$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $1da5394af23f0a63$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $1da5394af23f0a63$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("2rD5H", function(module, exports) {

var $iLX84 = parcelRequire("iLX84");


var $ixfCV = parcelRequire("ixfCV");

const $2571750a7eec7dec$var$convertDataClassificationTagsToString = (dataClassificationTagIds)=>{
    return `[
    ${dataClassificationTagIds.map((id)=>`"${id}"`).join(', ')}
  ]`;
};
const $2571750a7eec7dec$export$b4649e379af92913 = (expandAppOwner, moduleTypes, dataClassificationTagIds)=>{
    const modules = moduleTypes?.map((m)=>`"${m}"`) || [
        '$type'
    ];
    const userAccessField = (0, $ixfCV.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!${moduleTypes ? '' : ', $type: String!'}, $locale: String) {
    extensionContexts(contextIds: $contextIds) {
      id
      ${modules.map((m)=>`
        extensionsByType(type: ${m}, locale: $locale ) {
          id
          appId
          key
          ${expandAppOwner ? `appOwner {
            name
          }` : ''}
          environmentId
          environmentType
          environmentKey
          properties
          license {
            active
            type
            supportEntitlementNumber
            trialEndDate
            subscriptionEndDate
            isEvaluation
            billingPeriod
            ccpEntitlementId
            ccpEntitlementSlug
						capabilitySet
            modes
          }
          ${userAccessField}
          type
          appVersion
          installationId
          migrationKey
					installationConfig {
						key
						value
					}
          egress {
            type
            addresses
						category
						inScopeEUD
          }
					scopes
					consentUrl
					currentUserConsent {
						user {
							aaid
						}
						appEnvironmentVersion {
							id
						}
						consentedAt
					}
					requiresUserConsent
          ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
                dataClassificationPolicyDecision(input: {
                  dataClassificationTags: ${$2571750a7eec7dec$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
                }) {
                  status
                }
              ` : ''}
        }`).join('')}
    }
  }`;
    return (0, $iLX84.default)`${query}`;
};
const $2571750a7eec7dec$export$23f6ad93bea7724 = (expandAppOwner, dataClassificationTagIds)=>{
    const userAccessField = (0, $ixfCV.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!, $filter: [ExtensionContextsFilter!]!, $locale: String ) {
    extensionContexts(contextIds: $contextIds) {
      id
      extensions(filter: $filter, locale: $locale) @optIn(to: "Access-Narrowing") {
        id
        appId
        key
        ${expandAppOwner ? `appOwner {
          name
        }` : ''}
        environmentId
        environmentType
        environmentKey
        properties
        license {
          active
          type
          supportEntitlementNumber
          trialEndDate
          subscriptionEndDate
          isEvaluation
          billingPeriod
          ccpEntitlementId
          ccpEntitlementSlug
					capabilitySet
          modes
        }
        ${userAccessField}
        type
        appVersion
        installationId
        migrationKey
				installationConfig {
					key
					value
				}
        egress {
          type
          addresses
					category
					inScopeEUD
        }
				scopes
				consentUrl
				currentUserConsent {
					user {
						aaid
					}
					appEnvironmentVersion {
						id
					}
					consentedAt
				}
				requiresUserConsent
        ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
              dataClassificationPolicyDecision(input: {
                dataClassificationTags: ${$2571750a7eec7dec$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
              }) {
                status
              }
            ` : ''}
      },
    }
  }`;
    return (0, $iLX84.default)`${query}`;
};
const $2571750a7eec7dec$export$54ff27488d768aba = (0, $iLX84.default)`query FetchPreFilteredForgeAppsQuery($cloudId:ID!$context:ConfluenceExtensionRenderingContextInput$includeHidden:Boolean$locale:String$types:[String]){confluence_forgeExtensionsByType(cloudId:$cloudId context:$context includeHidden:$includeHidden locale:$locale types:$types){id appId appVersion appOwner environmentId environmentType environmentKey consentUrl migrationKey userAccess{enabled hasAccess}key properties{key value}egress{addresses category type inScopeEUD}scopes license{active capabilitySet billingPeriod ccpEntitlementId ccpEntitlementSlug isEvaluation subscriptionEndDate trialEndDate type}type installationId hiddenBy}}`;
module.exports["getExtensionListQueryOld"] = $2571750a7eec7dec$export$b4649e379af92913;
module.exports["getExtensionListQuery"] = $2571750a7eec7dec$export$23f6ad93bea7724;
module.exports["FetchPreFilteredForgeAppsQuery"] = $2571750a7eec7dec$export$54ff27488d768aba;

});

parcelRegister("4K6lC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3d3WW = parcelRequire("3d3WW");


var $852mP = parcelRequire("852mP");

const $a3a18abb8f8abee5$export$d28801614368e543 = 'forge-ui';
const $a3a18abb8f8abee5$export$7329bcdc3edcd90e = (client)=>(event)=>{
        switch(event.eventType){
            case 0, $852mP.UI_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendUIEvent(event));
                break;
            case 0, $852mP.OPERATIONAL_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendOperationalEvent(event));
                break;
            case 0, $852mP.TRACK_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendTrackEvent(event));
                break;
            case 0, $852mP.SCREEN_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendScreenEvent(event));
                break;
        }
    };
/** extract the attributes from event context which should be in the top-level payload */ function $a3a18abb8f8abee5$var$getPayloadAttributesFromContext(contexts) {
    return (contexts.find((obj)=>obj && obj.forgeUIAnalyticsContext) ?? {}).forgeUIAnalyticsContext ?? {};
}
const $a3a18abb8f8abee5$var$ForgeUIAnalyticsListener = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children, client: client, commonAttributes: t1 } = t0;
    let t2;
    if ($[0] !== t1) {
        t2 = t1 === undefined ? {} : t1;
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const commonAttributes = t2;
    let t3;
    if ($[2] !== client || $[3] !== commonAttributes) {
        t3 = (event)=>{
            const { eventType: eventType, data: data } = event.payload;
            const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, tags: tags, source: sourceFromEvent } = data;
            const forgeUIAnalyticsContext = $a3a18abb8f8abee5$var$getPayloadAttributesFromContext(event.context);
            const source = sourceFromEvent ?? forgeUIAnalyticsContext.source ?? "unknown";
            const payload = {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                ...forgeUIAnalyticsContext,
                source: source,
                attributes: {
                    ...commonAttributes,
                    ...event.context.reduce($a3a18abb8f8abee5$var$_temp, {}),
                    ...attributes
                },
                tags: tags
            };
            $a3a18abb8f8abee5$export$7329bcdc3edcd90e(client)({
                eventType: eventType,
                ...payload
            });
        };
        $[2] = client;
        $[3] = commonAttributes;
        $[4] = t3;
    } else t3 = $[4];
    const listenerHandler = t3;
    let t4;
    if ($[5] !== children || $[6] !== listenerHandler) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
            onEvent: listenerHandler,
            channel: $a3a18abb8f8abee5$export$d28801614368e543
        }, children);
        $[5] = children;
        $[6] = listenerHandler;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ children: children, client: client, commonAttributes: commonAttributes = {} })=>{
    const listenerHandler = (event)=>{
        const { eventType: eventType, data: data } = event.payload;
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, tags: tags, source: sourceFromEvent } = data;
        const forgeUIAnalyticsContext = $a3a18abb8f8abee5$var$getPayloadAttributesFromContext(event.context);
        const source = sourceFromEvent ?? forgeUIAnalyticsContext.source ?? 'unknown';
        const payload = {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            ...forgeUIAnalyticsContext,
            source: source,
            attributes: {
                ...commonAttributes,
                ...event.context.reduce((prev, curr)=>{
                    // Only extract attributes passed as an object via the forgeUIAttributes key
                    const forgeUIAttributes = curr && curr.forgeUIAttributes && typeof curr.forgeUIAttributes === 'object' ? curr.forgeUIAttributes : {};
                    return {
                        ...prev,
                        ...forgeUIAttributes
                    };
                }, {}),
                ...attributes
            },
            tags: tags
        };
        $a3a18abb8f8abee5$export$7329bcdc3edcd90e(client)({
            eventType: eventType,
            ...payload
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: listenerHandler,
        channel: $a3a18abb8f8abee5$export$d28801614368e543
    }, children);
};
var $a3a18abb8f8abee5$export$2e2bcd8739ae039 = $a3a18abb8f8abee5$var$ForgeUIAnalyticsListener;
function $a3a18abb8f8abee5$var$_temp(prev, curr) {
    const forgeUIAttributes = curr && curr.forgeUIAttributes && typeof curr.forgeUIAttributes === "object" ? curr.forgeUIAttributes : {};
    return {
        ...prev,
        ...forgeUIAttributes
    };
}
module.exports["FORGE_UI_ANALYTICS_CHANNEL"] = $a3a18abb8f8abee5$export$d28801614368e543;
module.exports["sendEvent"] = $a3a18abb8f8abee5$export$7329bcdc3edcd90e;
module.exports["default"] = $a3a18abb8f8abee5$export$2e2bcd8739ae039;

});

parcelRegister("iGKcz", function(module, exports) {
// our service
const $fa265340e5382bcc$var$SERVICE = 'forge-ui';
const $fa265340e5382bcc$export$14ef296862e3705e = (workspaceAri)=>{
    return JSON.stringify({
        atlWorkspaceAri: workspaceAri,
        service: $fa265340e5382bcc$var$SERVICE
    });
};
module.exports["createAtlAttributionHeader"] = $fa265340e5382bcc$export$14ef296862e3705e;

});

parcelRegister("jGizm", function(module, exports) {
parcelRequire("bLswh");
var $2zscg = parcelRequire("2zscg");

const $04d4b8463fee3aa7$var$extensionCache = new WeakMap();
const $04d4b8463fee3aa7$export$9ff84ea1b2ab439c = (extensions)=>{
    if (!extensions || extensions.length === 0) return [];
    if ($04d4b8463fee3aa7$var$extensionCache.has(extensions)) return $04d4b8463fee3aa7$var$extensionCache.get(extensions);
    const result = (extensions || []).flatMap((extension)=>{
        if (!extension) return [];
        if (!extension.environmentKey) return [];
        return [
            {
                id: extension.id,
                appId: extension.appId,
                key: extension.key,
                environmentId: extension.environmentId,
                environmentType: extension.environmentType === (0, $2zscg.ExtensionEnvironment).DEVELOPMENT || extension.environmentType === (0, $2zscg.ExtensionEnvironment).STAGING || extension.environmentType === (0, $2zscg.ExtensionEnvironment).PRODUCTION ? extension.environmentType : (0, $2zscg.ExtensionEnvironment).DEVELOPMENT,
                environmentKey: extension.environmentKey,
                properties: extension.properties.reduce((acc, property)=>{
                    if (!property.value || !property.key) return acc;
                    try {
                        const jsonValue = JSON.parse(property.value);
                        acc[property.key] = jsonValue;
                    } catch (_error) {
                        acc[property.key] = property.value;
                    }
                    return acc;
                }, {}),
                license: extension.license ? {
                    ...extension.license,
                    capabilitySet: $04d4b8463fee3aa7$var$mapCapabilitySet(extension.license.capabilitySet)
                } : null,
                userAccess: extension.userAccess ? {
                    hasAccess: extension.userAccess.hasAccess ?? false,
                    enabled: extension.userAccess.enabled ?? false
                } : null,
                type: extension.type,
                installationId: extension.installationId,
                appVersion: extension.appVersion ?? undefined,
                consentUrl: extension.consentUrl ?? undefined,
                migrationKey: extension.migrationKey ?? undefined,
                egress: extension.egress?.flatMap((egress)=>{
                    if (!egress.type || !egress.addresses) return [];
                    return [
                        {
                            type: egress.type,
                            addresses: egress.addresses?.flatMap((address)=>address ?? []),
                            category: egress.category ?? undefined,
                            inScopeEUD: egress.inScopeEUD ?? undefined
                        }
                    ];
                }) ?? undefined,
                scopes: extension.scopes ?? undefined,
                installationConfig: extension.installationConfig?.flatMap((config)=>{
                    if (!config?.key || config.value === null) return [];
                    return [
                        {
                            key: config.key,
                            value: config.value
                        }
                    ];
                }) ?? undefined,
                dataClassificationPolicyDecision: {
                    status: extension.hiddenBy === 'APP_ACCESS_RULES' ? 'BLOCKED' : 'ALLOWED'
                }
            }
        ];
    });
    const IS_TESTING_ENV = false;
    if (!IS_TESTING_ENV) $04d4b8463fee3aa7$var$extensionCache.set(extensions, result);
    return result;
};
const $04d4b8463fee3aa7$var$mapCapabilitySet = (capabilitySet)=>{
    switch(capabilitySet){
        case 'CAPABILITY_ADVANCED':
            return 'capabilityAdvanced';
        default:
            return 'capabilityStandard';
    }
};
module.exports["transformPreFilteredExtensions"] = $04d4b8463fee3aa7$export$9ff84ea1b2ab439c;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("6qkXi", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $gKr8t = parcelRequire("gKr8t");

const $26379cee560cb131$export$4b3c44afb1a70b38 = ({ cloudId: cloudId, locale: locale, moduleType: moduleType, queryOptions: queryOptions, includeHidden: includeHidden, spaceKey: spaceKey, contentId: contentId, attachmentId: attachmentId, spaceContextOnly: spaceContextOnly = false })=>{
    const context = spaceContextOnly ? {
        spaceKey: spaceKey
    } : {
        spaceKey: spaceKey,
        contentId: contentId,
        ...attachmentId && (0, $9wGTI.fg)('forge_attachment_display_conditions') ? {
            attachmentId: attachmentId
        } : {}
    };
    const options = {
        client: (0, $gKr8t.getAGGClient)(),
        cloudId: cloudId,
        types: [
            moduleType
        ],
        queryOptions: {
            ...queryOptions
        },
        locale: locale,
        context: context,
        includeHidden: includeHidden
    };
    return options;
};
module.exports["getUsePrefilteredExtensionListOptions"] = $26379cee560cb131$export$4b3c44afb1a70b38;

});

parcelRegister("6ld6a", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $iKWdo = parcelRequire("iKWdo");


var $1wIeS = parcelRequire("1wIeS");


var $jtuBN = parcelRequire("jtuBN");


var $8wW9d = parcelRequire("8wW9d");


var $9wGTI = parcelRequire("9wGTI");


var $kxhju = parcelRequire("kxhju");


var $62BfR = parcelRequire("62BfR");

const $f64809aa9d8f3ca2$export$13a30d244c53e90d = (t0)=>{
    const $ = (0, $bDgLe.c)(26);
    const { location: location, contentId: t1, spaceKey: t2, version: t3, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, skipQuery: skipQuery, skipFetchIfCached: skipFetchIfCached } = t0;
    const contentId = t1 === undefined ? null : t1;
    const spaceKey = t2 === undefined ? null : t2;
    const version = t3 === undefined ? null : t3;
    const t4 = Array.isArray(location) ? null : location;
    let t5;
    if ($[0] !== location) {
        t5 = Array.isArray(location) ? location : [];
        $[0] = location;
        $[1] = t5;
    } else t5 = $[1];
    let t6;
    if ($[2] !== contentId || $[3] !== spaceKey || $[4] !== t4 || $[5] !== t5 || $[6] !== version) {
        t6 = {
            location: t4,
            locations: t5,
            contentId: contentId,
            spaceKey: spaceKey,
            version: version
        };
        $[2] = contentId;
        $[3] = spaceKey;
        $[4] = t4;
        $[5] = t5;
        $[6] = version;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== skipFetchIfCached || $[9] !== skipQuery || $[10] !== t6) {
        t7 = {
            variables: t6,
            skip: skipQuery,
            skipFetchIfCached: skipFetchIfCached
        };
        $[8] = skipFetchIfCached;
        $[9] = skipQuery;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    const baseQueryOptions = t7;
    const { data: data, loading: loading, error: error } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $kxhju.WebItemLocationQuery), {
        ...baseQueryOptions,
        __callerPackage__: "web-item-location"
    });
    if (!data) {
        let t8;
        let t9;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
            t8 = [];
            t9 = [];
            $[12] = t8;
            $[13] = t9;
        } else {
            t8 = $[12];
            t9 = $[13];
        }
        let t10;
        if ($[14] !== error || $[15] !== loading) {
            t10 = {
                loading: loading,
                error: error,
                webItems: t8,
                webSections: t9
            };
            $[14] = error;
            $[15] = loading;
            $[16] = t10;
        } else t10 = $[16];
        return t10;
    }
    let webItems;
    let webSections;
    if ($[17] !== allowedWebItems || $[18] !== data || $[19] !== notAllowedWebItems) {
        webItems = $f64809aa9d8f3ca2$var$getWebItems((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? [], {
            allowedWebItems: allowedWebItems,
            notAllowedWebItems: notAllowedWebItems
        });
        webSections = (0, (/*@__PURE__*/$parcel$interopDefault($1wIeS)))(webItems.map($f64809aa9d8f3ca2$var$_temp));
        webItems.sort($f64809aa9d8f3ca2$var$sortWebItems);
        if ((0, $9wGTI.fg)("cc_record_non_content_macros")) (0, $8wW9d.recordNonContentAppKeys)(webItems.map($f64809aa9d8f3ca2$var$_temp2));
        $[17] = allowedWebItems;
        $[18] = data;
        $[19] = notAllowedWebItems;
        $[20] = webItems;
        $[21] = webSections;
    } else {
        webItems = $[20];
        webSections = $[21];
    }
    let t8;
    if ($[22] !== error || $[23] !== webItems || $[24] !== webSections) {
        t8 = {
            loading: false,
            error: error,
            webItems: webItems,
            webSections: webSections
        };
        $[22] = error;
        $[23] = webItems;
        $[24] = webSections;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
};
const $f64809aa9d8f3ca2$var$getWebItems = (webItemSections, webItemFilterOptions)=>{
    const webItems = webItemSections.flatMap((section)=>{
        return section.items.filter($f64809aa9d8f3ca2$var$filterWebItem(webItemFilterOptions)).map($f64809aa9d8f3ca2$var$transformWebItem(section));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($iKWdo)))(webItems, 'completeKey');
};
const $f64809aa9d8f3ca2$var$filterWebItem = ({ allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems })=>(item)=>{
        if (!item || !item.completeKey) return false;
        const isAllowed = !allowedWebItems || allowedWebItems.includes(item.completeKey);
        const isDisallowed = notAllowedWebItems?.includes(item.completeKey);
        return isAllowed && !isDisallowed;
    };
const $f64809aa9d8f3ca2$var$transformWebItem = (section)=>(rawItem)=>({
            ...rawItem,
            params: $f64809aa9d8f3ca2$var$getParamsObject(rawItem),
            webSection: $f64809aa9d8f3ca2$var$getWebSection(rawItem),
            parentSection: {
                label: section.label || section.styleClass
            }
        });
const $f64809aa9d8f3ca2$var$sortWebItems = (webItemA, webItemB)=>{
    if (!webItemA.weight || !webItemB.weight || !webItemA.label || !webItemB.label) return 0;
    if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
    else return webItemA.weight - webItemB.weight;
};
const $f64809aa9d8f3ca2$var$getWebSection = (item)=>{
    if (item.section && item.section.indexOf('/') !== -1) {
        const parts = item.section.split('/');
        return parts[1];
    }
};
const $f64809aa9d8f3ca2$var$getParamsObject = (item)=>{
    const paramObj = {};
    item.params?.forEach((param)=>{
        if (param?.key) paramObj[param.key] = param.value ?? '';
    });
    return paramObj;
};
function $f64809aa9d8f3ca2$var$_temp(webItem) {
    return webItem.section;
}
function $f64809aa9d8f3ca2$var$_temp2(webItem_0) {
    return webItem_0.completeKey;
}
module.exports["useWebItemLocation"] = $f64809aa9d8f3ca2$export$13a30d244c53e90d;

});

parcelRegister("iKWdo", function(module, exports) {

var $j6gAQ = parcelRequire("j6gAQ");


var $1Rned = parcelRequire("1Rned");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $da79ae2b1521df52$var$uniqBy(array, iteratee) {
    return array && array.length ? $1Rned(array, $j6gAQ(iteratee, 2)) : [];
}
module.exports = $da79ae2b1521df52$var$uniqBy;

});

parcelRegister("1Rned", function(module, exports) {

var $dLza3 = parcelRequire("dLza3");


var $gqaVn = parcelRequire("gqaVn");


var $3wyDU = parcelRequire("3wyDU");


var $jG16D = parcelRequire("jG16D");


var $4sYWJ = parcelRequire("4sYWJ");


var $j8WYy = parcelRequire("j8WYy");

/** Used as the size to enable large array optimizations. */ var $15acc2503c30cdc7$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $15acc2503c30cdc7$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $gqaVn, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $3wyDU;
    } else if (length >= $15acc2503c30cdc7$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $4sYWJ(array);
        if (set) return $j8WYy(set);
        isCommon = false;
        includes = $jG16D;
        seen = new $dLza3;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $15acc2503c30cdc7$var$baseUniq;

});

parcelRegister("gqaVn", function(module, exports) {

var $62lK8 = parcelRequire("62lK8");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $bf478c6b28a93eba$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $62lK8(array, value, 0) > -1;
}
module.exports = $bf478c6b28a93eba$var$arrayIncludes;

});

parcelRegister("62lK8", function(module, exports) {

var $7jN2X = parcelRequire("7jN2X");


var $4Jcz7 = parcelRequire("4Jcz7");


var $jMyMb = parcelRequire("jMyMb");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $4653cbb84a510850$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $jMyMb(array, value, fromIndex) : $7jN2X(array, $4Jcz7, fromIndex);
}
module.exports = $4653cbb84a510850$var$baseIndexOf;

});

parcelRegister("7jN2X", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $55405a69ad8b093d$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $55405a69ad8b093d$var$baseFindIndex;

});

parcelRegister("4Jcz7", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $37151c9a2b945fe4$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $37151c9a2b945fe4$var$baseIsNaN;

});

parcelRegister("jMyMb", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e66d79db7455d8ea$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $e66d79db7455d8ea$var$strictIndexOf;

});

parcelRegister("3wyDU", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $290f3b94ccd981c7$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $290f3b94ccd981c7$var$arrayIncludesWith;

});

parcelRegister("4sYWJ", function(module, exports) {

var $lE8ES = parcelRequire("lE8ES");


var $jEK83 = parcelRequire("jEK83");


var $j8WYy = parcelRequire("j8WYy");

/** Used as references for various `Number` constants. */ var $34090d9ff4ab3dd6$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $34090d9ff4ab3dd6$var$createSet = !($lE8ES && 1 / $j8WYy(new $lE8ES([
    ,
    -0
]))[1] == $34090d9ff4ab3dd6$var$INFINITY) ? $jEK83 : function(values) {
    return new $lE8ES(values);
};
module.exports = $34090d9ff4ab3dd6$var$createSet;

});

parcelRegister("jEK83", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $e4f588fe3a77f67d$var$noop() {
// No operation performed.
}
module.exports = $e4f588fe3a77f67d$var$noop;

});

parcelRegister("1wIeS", function(module, exports) {

var $1Rned = parcelRequire("1Rned");

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $11cb188fd562c44b$var$uniq(array) {
    return array && array.length ? $1Rned(array) : [];
}
module.exports = $11cb188fd562c44b$var$uniq;

});

parcelRegister("kxhju", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $iEfsZ = parcelRequire("iEfsZ");


var $cozmU = parcelRequire("cozmU");


var $iKWdo = parcelRequire("iKWdo");


var $1wIeS = parcelRequire("1wIeS");


var $bavCP = parcelRequire("bavCP");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $8wW9d = parcelRequire("8wW9d");


var $9wGTI = parcelRequire("9wGTI");


var $1gjU5 = parcelRequire("1gjU5");


var $62BfR = parcelRequire("62BfR");


var $3QyBm = parcelRequire("3QyBm");

const $b5245263a8ff7a10$export$abf96c374bfacb58 = (0, $iEfsZ.default);
class $b5245263a8ff7a10$export$14318d199449e2e3 extends (0, $cozmU.Component) {
    render() {
        const { location: location, children: children, onLoad: onLoad, hasMultipleSections: hasMultipleSections, renderWhenLoading: renderWhenLoading, allowedWebItems: allowedWebItems, notAllowedWebItems: notAllowedWebItems, fetchPolicy: fetchPolicy = 'cache-and-network', spaceKey: spaceKey, contentId: contentId, id: id, className: className, style: style, tagName: tagName, version: version, waitForSuperBatch: waitForSuperBatch } = this.props;
        const variables = {
            // GraphQL doesn't cache single location strings properly when passed to locations
            // unless we're using multiple locations we should be using the location variable
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            contentId: contentId || null,
            spaceKey: spaceKey || null,
            version: version || null
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
            query: $b5245263a8ff7a10$export$abf96c374bfacb58,
            variables: variables,
            fetchPolicy: fetchPolicy,
            __callerPackage__: "web-item-location"
        }, ({ data: data, loading: loading, error: error })=>{
            // Since the default fetchPolicy is cache-and-network
            // loading field will be true, false, true (background refetch), false
            // Thus destroying and rebuilding the children
            // Here we only block rendering on the very first loading.
            if (loading && !data) {
                if (renderWhenLoading && typeof children === 'function') {
                    // Render wrapper to keep DOM structure consistent while loading
                    const wrapperProps = {
                        'data-webitem-location': location,
                        'data-content-id': contentId,
                        children: children({
                            loading: loading,
                            webItems: [],
                            webSections: []
                        })
                    };
                    if (id) wrapperProps.id = id;
                    if (className) wrapperProps.className = className;
                    if (style) wrapperProps.style = style;
                    const wrapperTag = tagName || 'div';
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(wrapperTag, wrapperProps);
                } else return null;
            }
            if (error) {
                if ((0, $1uFM6.isUnauthorizedError)(error)) {
                    (0, $7Sm4c.markErrorAsHandled)(error);
                    return null;
                }
                // TODO: unknown errors should have a nicer UI within `<ErrorDisplay>`, but we don't have such UI for now
                // so returning empty `<ErrorDisplay>` here.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: error
                });
            }
            // replace any instances of {atlTokenPlaceholderWillBeReplacedInFrontend}
            // with the atlToken in all section items
            let webItems = ((0, $62BfR.replaceAtlTokenPlaceholder)(data)?.webItemSections ?? []).reduce((items, section)=>{
                return items.concat((section.items || []).map((item)=>({
                        ...item,
                        parentSection: {
                            label: section.label || section.styleClass
                        }
                    })));
            }, []);
            webItems = (0, (/*@__PURE__*/$parcel$interopDefault($iKWdo)))(webItems, 'completeKey');
            if (allowedWebItems) webItems = webItems.filter((webItem)=>allowedWebItems.includes(webItem.completeKey));
            if (notAllowedWebItems) webItems = webItems.filter((webItem)=>!notAllowedWebItems.includes(webItem.completeKey));
            webItems = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, webItems);
            webItems.forEach((item)=>{
                const paramObj = {};
                if (Array.isArray(item.params)) {
                    item.params.forEach((param)=>{
                        paramObj[param.key] = param.value;
                    });
                    item.params = paramObj;
                }
                if (item.section && item.section.indexOf('/') !== -1) {
                    const parts = item.section.split('/');
                    item.webSection = parts[1];
                }
            });
            const formattedWebItems = webItems;
            // Instrument the presence of non-content 3P connect apps so their keys
            // are folded into the page-load `connectAppKeys` telemetry.
            if ((0, $9wGTI.fg)('cc_record_non_content_macros')) (0, $8wW9d.recordNonContentAppKeys)(formattedWebItems.map((webItem)=>webItem.completeKey));
            let webSections = [];
            if (hasMultipleSections) webSections = (0, (/*@__PURE__*/$parcel$interopDefault($1wIeS)))(formattedWebItems.map((webItem)=>webItem.section));
            formattedWebItems.sort((webItemA, webItemB)=>{
                if (webItemA.weight - webItemB.weight === 0) return webItemA.label.localeCompare(webItemB.label);
                else return webItemA.weight - webItemB.weight;
            });
            if (!loading) this.experienceSuccess(true);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1gjU5.WebItemLocationComponent), {
                id: id,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: className,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: style,
                tagName: tagName,
                location: location,
                webItems: formattedWebItems,
                webSections: webSections,
                onLoad: onLoad,
                waitForSuperBatch: waitForSuperBatch
            }, children);
        });
    }
    constructor(...args){
        super(...args);
        this.experienceSuccess = (result)=>{
            if (this.props.experienceSuccess) this.props.experienceSuccess(result);
        };
    }
}
const $b5245263a8ff7a10$export$ab308e916c09580 = (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b5245263a8ff7a10$export$14318d199449e2e3, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
module.exports["WebItemLocationQuery"] = $b5245263a8ff7a10$export$abf96c374bfacb58;
module.exports["WebItemLocation"] = $b5245263a8ff7a10$export$ab308e916c09580;

});

parcelRegister("iEfsZ", function(module, exports) {
/**
 * @generated SignedSource<<50efd21e0db5811e6867b792d80a2f0a>>
 * @relayHash 0006505c7639efb87b37fdf9e06ba577
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 80be86e03026fa8a830d5e044cf1c52c928ef2f41b95e7043d2c72827ef95173
const $7f80a392f18860bd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "location"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locations"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "version"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "label"
    }, v7 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v8 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "location",
                    "variableName": "location"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "locations"
                },
                {
                    "kind": "Variable",
                    "name": "version",
                    "variableName": "version"
                }
            ],
            "concreteType": "WebSection",
            "kind": "LinkedField",
            "name": "webItemSections",
            "plural": true,
            "selections": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "cacheKey"
                },
                v7 /*: any*/ ,
                {
                    "concreteType": "WebItem",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accessKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "completeKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasCondition"
                        },
                        v5 /*: any*/ ,
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "height"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "width"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        {
                            "concreteType": "MapOfStringToString",
                            "kind": "LinkedField",
                            "name": "params",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        },
                        v6 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "moduleKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "section"
                        },
                        v7 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "tooltip"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "urlWithoutContextPath"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "weight"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WebItemLocationQuery",
            "selections": v8 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WebItemLocationQuery",
            "selections": v8 /*: any*/ 
        },
        "params": {
            "cacheID": "0006505c7639efb87b37fdf9e06ba577",
            "id": "80be86e03026fa8a830d5e044cf1c52c928ef2f41b95e7043d2c72827ef95173",
            "metadata": {},
            "name": "WebItemLocationQuery",
            "operationKind": "query",
            "text": "query WebItemLocationQuery($location:String,$locations:[String],$contentId:ID,$spaceKey:String,$version:Int){webItemSections(location:$location,locations:$locations,contentId:$contentId,key:$spaceKey,version:$version){id,label,cacheKey,styleClass,items{accessKey,completeKey,hasCondition,id,icon{height,width,path},params{key,value},label,moduleKey,section,styleClass,tooltip,url,urlWithoutContextPath,weight}}}"
        }
    };
}();
$7f80a392f18860bd$var$node.hash = "8e88912bf23040d88bbeb5c8cadae7c2";
var $7f80a392f18860bd$export$2e2bcd8739ae039 = $7f80a392f18860bd$var$node;
module.exports["default"] = $7f80a392f18860bd$export$2e2bcd8739ae039;

});

parcelRegister("1gjU5", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $8SfNq = parcelRequire("8SfNq");

function $4c9fd42c224286dd$var$_defineProperty(e, r, t) {
    return (r = $4c9fd42c224286dd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $4c9fd42c224286dd$var$_toPropertyKey(t) {
    var i = $4c9fd42c224286dd$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $4c9fd42c224286dd$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4c9fd42c224286dd$var$StyledWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1e0c1o8l _yduxfajl _oun6145i _uggw1qyo _gcxqd0cv _10v91r31 _62naglyw _7b6anqa1 _e8hjusvi _t1661o8l _18411kw7 _qjtikklf _1cg81q9y _1gxg1q9c _15y51o8l _4wh61h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
class $4c9fd42c224286dd$export$e83681c8b6998cea extends (0, $cozmU.Component) {
    componentDidMount() {
        this.mounted = true;
        const { webItems: webItems, onLoad: onLoad, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (onLoad) onLoad({
            webItems: webItems
        });
        if (waitForSuperBatch) (0, $8SfNq.requireSuperBatch)().then(()=>{
            if (this.mounted) this.setState({
                superBatchLoaded: true
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { id: id, tagName: tagName, className: className, style: style, children: children, webItems: webItems, webSections: webSections, location: location, contentId: contentId, waitForSuperBatch: waitForSuperBatch } = this.props;
        if (waitForSuperBatch && !this.state.superBatchLoaded) return null;
        const wrapperProps = {
            'data-webitem-location': location,
            'data-content-id': contentId,
            children: typeof children === 'function' ? children({
                webItems: webItems,
                webSections: webSections
            }) : null
        };
        if (id) wrapperProps.id = id;
        if (className) wrapperProps.className = className;
        if (style) wrapperProps.style = style;
         // Addon icons are broken during SSR, this is because we do not SSR legacy styles.
        // In order for styles to match during SSR and SPA for addon icons, we need to
        // declare a styled component such as emotion/styled. This way we can pass css to their children via wrapper.
        // Until superbatch is loaded, the styles for addon icons would still be broken.
        if (wrapperProps?.children?.props?.buttonType === 'aui-button-subtle') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4c9fd42c224286dd$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(tagName, wrapperProps));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(tagName, wrapperProps);
    }
    constructor(...args){
        super(...args);
        $4c9fd42c224286dd$var$_defineProperty(this, "state", {
            superBatchLoaded: false
        });
        $4c9fd42c224286dd$var$_defineProperty(this, "mounted", false);
    }
}
$4c9fd42c224286dd$var$_defineProperty($4c9fd42c224286dd$export$e83681c8b6998cea, "defaultProps", {
    tagName: 'div'
});
module.exports["WebItemLocationComponent"] = $4c9fd42c224286dd$export$e83681c8b6998cea;

});

parcelRegister("62BfR", function(module, exports) {
function $d97d2e8640b15cc8$export$87286345b169ae5e(data) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const atlToken = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector('meta[name="ajs-atl-token"]')?.content;
    if (!atlToken || !data || !data.webItemSections) return data;
    return {
        ...data,
        webItemSections: data.webItemSections.map((section)=>{
            if (section) return {
                ...section,
                items: section?.items.map((sectionItem)=>{
                    if (sectionItem) return {
                        ...sectionItem,
                        url: sectionItem.url?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.url,
                        urlWithoutContextPath: sectionItem.urlWithoutContextPath?.replace('{atlTokenPlaceholderWillBeReplacedInFrontend}', atlToken) ?? sectionItem.urlWithoutContextPath
                    };
                    else return null;
                })
            };
            else return null;
        })
    };
}
module.exports["replaceAtlTokenPlaceholder"] = $d97d2e8640b15cc8$export$87286345b169ae5e;

});

parcelRegister("2Awp2", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $kNIYN = parcelRequire("kNIYN");


var $ad7Ou = parcelRequire("ad7Ou");


var $6t3CY = parcelRequire("6t3CY");


var $lslMH = parcelRequire("lslMH");


var $eDtFr = parcelRequire("eDtFr");


var $a1ZzW = parcelRequire("a1ZzW");


var $5AKbu = parcelRequire("5AKbu");


var $cE5a1 = parcelRequire("cE5a1");


var $gFEZF = parcelRequire("gFEZF");








var $bltJZ = parcelRequire("bltJZ");


var $fqVYq = parcelRequire("fqVYq");


var $lpNn5 = parcelRequire("lpNn5");


var $1B9Aq = parcelRequire("1B9Aq");


var $kx3q1 = parcelRequire("kx3q1");

var $8Iwqw = parcelRequire("8Iwqw");

var $8lt1a = parcelRequire("8lt1a");


var $9DHhW = parcelRequire("9DHhW");


var $29vMs = parcelRequire("29vMs");


var $lTECB = parcelRequire("lTECB");


var $3N2DH = parcelRequire("3N2DH");


var $kQqCc = parcelRequire("kQqCc");


var $i8Nmr = parcelRequire("i8Nmr");


var $aWwYt = parcelRequire("aWwYt");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");

var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $eSLr0 = parcelRequire("eSLr0");


var $kxhju = parcelRequire("kxhju");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $9wGTI = parcelRequire("9wGTI");


var $7Ndnw = parcelRequire("7Ndnw");


var $dizL5 = parcelRequire("dizL5");


var $2A8CJ = parcelRequire("2A8CJ");


var $hrAmX = parcelRequire("hrAmX");


var $hl1Kw = parcelRequire("hl1Kw");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $brNvA = parcelRequire("brNvA");


var $cMvMc = parcelRequire("cMvMc");


var $dANtQ = parcelRequire("dANtQ");


var $kRW4Y = parcelRequire("kRW4Y");


var $jmjWc = parcelRequire("jmjWc");


var $7W8i8 = parcelRequire("7W8i8");


var $2Jxlo = parcelRequire("2Jxlo");


var $a3Fla = parcelRequire("a3Fla");

parcelRequire("9ikgN");
var $cR1lV = parcelRequire("cR1lV");
var $9ikgN = parcelRequire("9ikgN");


var $7rLBD = parcelRequire("7rLBD");


var $bjVRl = parcelRequire("bjVRl");


var $9oxdN = parcelRequire("9oxdN");


var $7Sm4c = parcelRequire("7Sm4c");


var $eDk57 = parcelRequire("eDk57");


var $98CLM = parcelRequire("98CLM");

parcelRequire("aiS08");
var $1L1jV = parcelRequire("1L1jV");


var $jln20 = parcelRequire("jln20");


var $7mpOv = parcelRequire("7mpOv");


var $lJlG6 = parcelRequire("lJlG6");


var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $cZa7r = parcelRequire("cZa7r");


var $b0EGa = parcelRequire("b0EGa");


var $aKDZB = parcelRequire("aKDZB");


var $erJgi = parcelRequire("erJgi");


var $dnbZ2 = parcelRequire("dnbZ2");


var $3b5i6 = parcelRequire("3b5i6");


var $4DJgG = parcelRequire("4DJgG");


var $6W81y = parcelRequire("6W81y");


var $4oXkq = parcelRequire("4oXkq");


var $9ujb2 = parcelRequire("9ujb2");


var $lEDve = parcelRequire("lEDve");


var $bEdUx = parcelRequire("bEdUx");


var $2W2Mk = parcelRequire("2W2Mk");


var $l4eiF = parcelRequire("l4eiF");


var $2zMIV = parcelRequire("2zMIV");


var $b1ynj = parcelRequire("b1ynj");


var $dj3mI = parcelRequire("dj3mI");


var $6zmDz = parcelRequire("6zmDz");


var $97kfW = parcelRequire("97kfW");


var $joYQz = parcelRequire("joYQz");


var $8jXZv = parcelRequire("8jXZv");


var $9Zall = parcelRequire("9Zall");


var $dOlTT = parcelRequire("dOlTT");

const $9755f908a54a6c5b$var$builtInActionsStyles = null;
const $9755f908a54a6c5b$var$builtInActionsWithoutOtherActionsStyles = null;
const $9755f908a54a6c5b$var$POPUP_MOUSEUP_DISTANCE_THRESHOLD = 100;
const $9755f908a54a6c5b$var$BUILT_IN_ITEMS = [
    'com.atlassian.confluence.plugins.confluence-jira-content:create-JIRA-issue-summary',
    'com.atlassian.confluence.plugins.confluence-trello-content:create-trello-card-quick-capture'
];
const $9755f908a54a6c5b$export$9205c47465d0942 = [
    'com.atlassian.confluence.plugins.confluence-inline-comments:create-inline-comment',
    'com.atlassian.confluence.plugins.confluence-jira-content:create-JIRA-issue-summary'
];
const $9755f908a54a6c5b$var$INLINE_VIEW_PAGE_CREATION_CONTEXT_PARAMS = {
    experience: 'inline_view',
    contentTypes: [
        'page'
    ]
};
const $9755f908a54a6c5b$var$i18n = (0, $kSwu1.defineMessages)({
    commentTooltip: {
        id: "highlight-actions.inline.comment.tooltip",
        defaultMessage: "Comment"
    },
    defineTooltip: {
        id: "highlight-actions.define.tooltip",
        defaultMessage: "Define"
    }
});
const $9755f908a54a6c5b$var$logger = (0, $7W8i8.getLogger)('inline-comment');

const $9755f908a54a6c5b$var$ForgeAction = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "wTC7w",
    name: "ForgeAction",
    loader: async ()=>(await (parcelRequire("3QARf"))).ForgeAction
});

const $9755f908a54a6c5b$var$DefinitionAction = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "wKsW8",
    name: "DefinitionAction",
    loader: async ()=>(await (parcelRequire("iUfh3"))).DefinitionAction
});
const $9755f908a54a6c5b$export$c1823fc1996a2ebd = (evt)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const highlightActionsToolbar = document.querySelector('[data-testid="highlightActionsPopup"]'); // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const focusedElement = document.activeElement;
    if (highlightActionsToolbar && !highlightActionsToolbar?.contains(focusedElement) && evt.key === 'Tab' && !evt.ctrlKey && !evt.altKey) {
        evt.preventDefault(); // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.querySelector('[data-testid="createInlineCommentButton"]')?.focus();
    }
};
function $9755f908a54a6c5b$var$trapFocusInSelectionToolbar(event) {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const highlightActionsToolbar = document.querySelector('#highlightActionsPopup');
    if (highlightActionsToolbar && event.key === 'Tab' && !event.ctrlKey && !event.altKey) {
        event.preventDefault();
        event.stopPropagation(); // Get all focusable elements in the toolbar
        const elements = Array.from(highlightActionsToolbar.querySelectorAll('button, a')).filter((curr)=>{
            if (curr instanceof HTMLButtonElement) return !curr.disabled;
            if (curr instanceof HTMLAnchorElement) return !!curr.href;
            return false;
        }); // Find the index of the currently focused element
        let idx = event.shiftKey ? elements.length : -1; // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const focusedElement = document.activeElement;
        if (highlightActionsToolbar.contains(focusedElement)) {
            for(let i = 0; i < elements.length; i++)if (elements[i] === focusedElement) {
                idx = i;
                break;
            }
        } // Focus the next element to focus
        event.shiftKey ? idx-- : idx++;
        if (idx < 0) idx = elements.length - 1;
        else if (idx >= elements.length) idx = 0;
        const next = elements[idx];
        if (next && (next instanceof HTMLButtonElement || next instanceof HTMLAnchorElement)) next.focus();
    }
} // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9755f908a54a6c5b$var$CustomLineWrapTooltip = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $1B9Aq.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1yt41ppf _zulpu2gc _11q71aqn _2rkofajl _11c8wadc _1e0c1txw _2lx2vrvc _4cvr1y6m _kqswh2mm _syaz15cr _k48pi7a9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = (0, $1B9Aq.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt41ppf _zulpu2gc _11q71aqn _2rkofajl _11c8wadc _1e0c1txw _2lx2vrvc _4cvr1y6m _kqswh2mm _syaz15cr _k48pi7a9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9755f908a54a6c5b$var$CustomLineWrapTooltipUpdated = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $1B9Aq.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1yt41ppf _zulpu2gc _11q71aqn _2rko12b0 _11c8wadc _1e0c1txw _2lx2vrvc _4cvr1y6m _kqswh2mm _syaz15cr _k48pi7a9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = (0, $1B9Aq.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt41ppf _zulpu2gc _11q71aqn _2rko12b0 _11c8wadc _1e0c1txw _2lx2vrvc _4cvr1y6m _kqswh2mm _syaz15cr _k48pi7a9",
            __cmplp.className
        ])
    });
});
const $9755f908a54a6c5b$export$c0b63e9f99a74f33 = (components, hasOtherActions)=>{
    const dividerLast = (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6zmDz.Divider), {
        key: "divider-last",
        "data-testid": "divider-last"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6zmDz.DividerOld), {
        key: "divider-last",
        "data-testid": "divider-last"
    });
    return components.reduce((result, component, i)=>{
        // Add the current component
        result.push(component); // Add a divider after each component except the last one
        if (i < components.length - 1) result.push((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6zmDz.Divider), {
            key: `divider-${i}`,
            "data-testid": "divider"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6zmDz.DividerOld), {
            key: `divider-${i}`,
            "data-testid": "divider"
        }));
        return result; // If there are other actions, add a divider at the end
    }, []).concat(hasOtherActions ? dividerLast : []);
};
const $9755f908a54a6c5b$var$getIsHighlightValid = ({ content: content, isFabric: isFabric, isAnnotationAllowed: isAnnotationAllowed, contentId: contentId })=>{
    if (!content) return false;
    if (isFabric) return Boolean(isAnnotationAllowed);
    return (0, $2zMIV.isHighlightValidForInlineComment)(content, contentId);
};
const $9755f908a54a6c5b$export$a6299569dd2a354f = ({ contentId: contentId, children: children, hasInlineComments: hasInlineComments = true, actions: actions, lastModifiedDate: lastModifiedDate, isArchived: isArchived, contentStatusError: contentStatusError, range: range, isAnnotationAllowed: isAnnotationAllowed, onCommentButtonPress: onCommentButtonPress, onRemixButtonPress: onRemixButtonPress, remixDisabledReason: remixDisabledReason, isRemixInProgress: isRemixInProgressProp, isFabric: isFabric, contentType: contentType, inlineNodeTypes: inlineNodeTypes, onCommentButtonMount: onCommentButtonMount, snippetSlots: snippetSlots })=>{
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const isRemixAvailable = (0, $dnbZ2.useIsRemixAvailable)();
    const [actionStates, setActionStates] = (0, $cozmU.useState)({
        firstHighlightShown: false,
        show: false,
        top: 0,
        left: 0,
        forgeExtension: null,
        activeSelection: null,
        selectionRect: null,
        isReadingAidsOpen: false,
        readingAidsChangeboardingStep: 'disabled'
    });
    const [position, setPosition] = (0, $cozmU.useState)(null);
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { createComment: createComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { commentToReattach: commentToReattach, isInReattachMode: isInReattachMode } = (0, $brNvA.useReattachComment)();
    const { setReattachHighlight: setReattachHighlight } = (0, $brNvA.useReattachCommentDispatch)();
    const { lastModificationDate: lastModificationDate } = (0, $cozmU.useContext)((0, $2A8CJ.ContentBodyContext));
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { canAddComments: canAddComments, contentQueryError: contentQueryError } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId);
    const [{ searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics }] = (0, $hl1Kw.useSearchSessionId)();
    const { documentNeedsUpdate: documentNeedsUpdate, currentDocumentVersion: currentDocumentVersion, publishedDocumentVersion: publishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatus)();
    const commentShortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR)
    });
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const [isWarningDialogOpen, setIsWarningDialogOpen] = (0, $cozmU.useState)(false);
    const [recordedClick, setRecordedClick] = (0, $cozmU.useState)();
    const shouldDisableCommentWhenDocumentNeedsUpdate = inlineNodeTypes?.length === 1 && [
        'status',
        'date',
        'mention',
        'inlineCard'
    ].includes(inlineNodeTypes[0]);
    const needsUpdateToComment = shouldDisableCommentWhenDocumentNeedsUpdate && (Boolean(documentNeedsUpdate) || currentDocumentVersion !== publishedDocumentVersion && (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)); // Flag to trigger text comment creation after media comment cleanup
    const [pendingTextComment, setPendingTextComment] = (0, $cozmU.useState)(false);
    const { setDefineDefinitionOpen: setDefineDefinitionOpen } = (0, $bjVRl.useReadingAidsActions)();
    const { hoverProps: hoverProps } = (0, $cZa7r.useAnnotations)();
    const { setHoverProps: setHoverProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const { isRemixing: isRemixingFromContext } = (0, $aKDZB.useRendererRemixContext)();
    const isRemixing = isRemixInProgressProp || isRemixingFromContext;
    const isNewToolbarEnabled = (0, $9wGTI.fg)('aifc_create_enabled') || (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_confluence', 'isEnabled', true);
    const { firstHighlightShown: firstHighlightShown, show: show, top: top, left: left, forgeExtension: forgeExtension, activeSelection: activeSelection, selectionRect: selectionRect, isReadingAidsOpen: isReadingAidsOpen, readingAidsChangeboardingStep: readingAidsChangeboardingStep } = actionStates;
    const mountedRef = (0, $cozmU.useRef)(false);
    const screenEventFiredRef = (0, $cozmU.useRef)(false);
    const highlightActionsShownRef = (0, $cozmU.useRef)(false);
    const content = (0, $cozmU.useRef)(typeof document !== 'undefined' ? document.querySelector('div#content') : null);
    const [showReadingAidsChangeboarding, stopReadingAidsChangeboarding] = (0, $9oxdN.useFeatureDiscovery)('highlight-actions.reading-aids.changeboarding');
    const isReadingAidsChangeboardingActive = readingAidsChangeboardingStep.match(/^modal|spotlight/); // Sync popup visibility to OmniBar's visibility store (counter-based)
    const { requestHideOmniBar: requestHideOmniBar, releaseHideOmniBar: releaseHideOmniBar } = (0, $b0EGa.useOmniBarVisibilityActions)();
    const shouldHideOmniBar = show || isReadingAidsOpen || !!forgeExtension;
    (0, $cozmU.useLayoutEffect)(()=>{
        if (shouldHideOmniBar && (0, $9wGTI.fg)('cc-engagement-omnibar-hide-highlight-actions')) {
            requestHideOmniBar();
            return ()=>releaseHideOmniBar();
        }
    }, [
        shouldHideOmniBar,
        requestHideOmniBar,
        releaseHideOmniBar
    ]);
    const highlightActionsContextValue = (0, $cozmU.useMemo)(()=>({
            firstHighlightShown: firstHighlightShown
        }), [
        firstHighlightShown
    ]); // start the reading aids changeboarding
    (0, $cozmU.useEffect)(()=>{
        setActionStates((prevState)=>({
                ...prevState,
                readingAidsChangeboardingStep: showReadingAidsChangeboarding && isAIEnabledForContent ? 'idle' : 'disabled'
            }));
    }, [
        showReadingAidsChangeboarding,
        isAIEnabledForContent
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Manually trigger resize to ensure spotlight is properly aligned
        window.setTimeout(()=>window.dispatchEvent(new Event('resize')), 0);
        if (!show) {
            // Force a redraw of portalContainer, which fixes an issue where the popup is removed from DOM but is
            // still visible on the page __in Safari__. (https://product-fabric.atlassian.net/browse/COMMENTS-5335)
            // This rendering issue occurring in Safari's WebKit engine seems to be known and has a long history.
            // Only do this when `show === false`, since the issue only occurs when attepmting to hide the popup.
            const portalContainer = document.querySelector(`#${(0, $bEdUx.popupPortalContainerId)}`);
            if (portalContainer) {
                portalContainer.style.transform = 'translateZ(0)'; // This line below reads this layout property, which triggers a reflow + redraw as side effect.
                portalContainer.offsetHeight; // NOSONAR - Sonar would complain: "Expected an assignment or function call and instead saw an expression"
                portalContainer.style.transform = '';
            }
        }
    }, [
        show
    ]); // freeze the user's selection while reading aids changeboarding is active
    (0, $cozmU.useEffect)(()=>{
        const akPortalContainer = document.querySelector('.atlaskit-portal-container');
        if (akPortalContainer) {
            if (isReadingAidsChangeboardingActive) {
                akPortalContainer.style.userSelect = 'none';
                return ()=>{
                    akPortalContainer.style.userSelect = 'auto';
                };
            } else akPortalContainer.style.userSelect = 'auto';
        }
    }, [
        isReadingAidsChangeboardingActive
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) {
            document.addEventListener('keydown', $9755f908a54a6c5b$var$trapFocusInSelectionToolbar);
            return ()=>{
                document.removeEventListener('keydown', $9755f908a54a6c5b$var$trapFocusInSelectionToolbar);
            };
        }
    }, []);
    (0, $cozmU.useEffect)(()=>{
        window.addEventListener('mouseup', onMouseUp);
        window.addEventListener('highlight-actions.container.resized', onContainerResized);
        return ()=>{
            window.removeEventListener('mouseup', onMouseUp);
            window.removeEventListener('highlight-actions.container.resized', onContainerResized);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        commentToReattach,
        isReadingAidsChangeboardingActive,
        isRemixing
    ]); /* When nudgebar improvement is on: hide toolbar when selection was set by comment nudge (e.g. on hover). */ 
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $6mKj3.expValEquals)('confluence_comment_nudgebar_improvement', 'isEnabled', true)) return;
        const onSelectionChange = ()=>{
            if (document.body?.getAttribute?.('data-nudge-selection-active') === 'true' && mountedRef.current) setActionStates((prev)=>({
                    ...prev,
                    show: false
                }));
        };
        document.addEventListener('selectionchange', onSelectionChange);
        return ()=>document.removeEventListener('selectionchange', onSelectionChange);
    }, []); // Close reading aids popup when navigating to another page
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            setDefineDefinitionOpen({
                defineDefinitionOpen: false
            });
            setActionStates((prevState)=>({
                    ...prevState,
                    isReadingAidsOpen: false
                }));
        };
    }, [
        contentId,
        setDefineDefinitionOpen
    ]); // Handle text comment creation after media comment cleanup is complete
    (0, $cozmU.useEffect)(()=>{
        if (pendingTextComment && !hoverProps) {
            setPendingTextComment(false);
            if (isFabric) onCommentButtonPress?.();
            else createComment((0, $4DJgG.getLegacyConvertedSelectionObj)({
                content: content,
                contentId: contentId,
                commentToReattach: commentToReattach,
                actions: actions
            }));
        }
    }, [
        pendingTextComment,
        hoverProps,
        isFabric,
        onCommentButtonPress,
        createComment,
        content,
        contentId,
        commentToReattach,
        actions
    ]);
    const onContainerResized = ()=>{
        setActionStates((prevState)=>({
                ...prevState,
                show: false,
                forgeExtension: null
            }));
    };
    function getScrollParent(node) {
        if (!node) return null;
        if (node.nodeType !== Node.TEXT_NODE && node.scrollWidth > node.clientWidth) return node;
        else return getScrollParent(node.parentNode);
    }
    function getParentNode(node) {
        if (!node) return null;
        if (node.nodeType !== Node.TEXT_NODE) return node;
        else return getParentNode(node.parentNode);
    }
    const getPosition = (range)=>{
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const portalContainer = document.querySelector(`#${(0, $bEdUx.popupPortalContainerId)}`);
        const portalRect = portalContainer?.getBoundingClientRect() || {
            left: 0,
            top: 0
        };
        const { left: leftRect, top: topRect, width: width, height: height } = range.getBoundingClientRect(); // Popup can't be rendered outside the body area
        const contentRect = getParentNode(range.commonAncestorContainer).getBoundingClientRect();
        let leftLimit = contentRect.left;
        let rightLimit = contentRect.right; // If the selected text has a parent that is scrollable for example like text inside table.
        // The popup is limited to be shown within the scrollable area.
        const firstParentThatCanScroll = getScrollParent(range.startContainer);
        if (firstParentThatCanScroll) {
            const scrollParentRect = firstParentThatCanScroll.getBoundingClientRect();
            leftLimit = Math.max(leftLimit, scrollParentRect.left);
            rightLimit = Math.min(rightLimit, scrollParentRect.right);
        }
        let x = width / 2 + leftRect;
        if (!(0, $9wGTI.fg)('kd_definitions_skip_displacement_computation')) x = Math.max(leftLimit, Math.min(rightLimit, x));
        return {
            pos: {
                left: x - portalRect.left,
                top: topRect - portalRect.top
            },
            selectionRect: {
                left: x - portalRect.left,
                top: topRect - portalRect.top,
                width: width,
                height: height
            }
        };
    };
    (0, $cozmU.useEffect)(()=>{
        if (range) {
            /* When nudgebar improvement is on, never show toolbar for selection set by nudge (range can come from parent when we set selection on comment hover). */ if (document.body?.getAttribute?.('data-nudge-selection-active') === 'true' && (0, $6mKj3.expValEquals)('confluence_comment_nudgebar_improvement', 'isEnabled', true)) {
                setPosition(null);
                setActionStates((prevState)=>({
                        ...prevState,
                        show: false
                    }));
                return;
            }
            const { pos: pos, selectionRect: selectionRectangle } = getPosition(range);
            highlightActionsShownRef.current = false;
            setPosition(pos);
            setActionStates((prevState)=>({
                    ...prevState,
                    selectionRect: selectionRectangle,
                    show: true
                }));
        } else {
            setPosition(null);
            setActionStates((prevState)=>({
                    ...prevState,
                    show: false
                }));
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        range
    ]);
    const updatePosition = (0, $cozmU.useCallback)(()=>{
        if (range) {
            const { pos: pos } = getPosition(range);
            setPosition(pos);
            return pos;
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        range
    ]);
    const prepareAndSetHighlightForReattachMode = ()=>{
        const convertedSelectionObj = (0, $4DJgG.getLegacyConvertedSelectionObj)({
            content: content,
            contentId: contentId,
            commentToReattach: commentToReattach,
            actions: actions
        }); // Only set the highlight if it's valid
        if (convertedSelectionObj.numMatches > 0 && convertedSelectionObj.matchIndex !== -1) setReattachHighlight(convertedSelectionObj);
    };
    const isDatasourceHighlighted = (range)=>{
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const datasourceContainers = document.querySelectorAll('.datasource-table');
        return Array.from(datasourceContainers).some((container)=>container.contains(range.startContainer) || container.contains(range.endContainer));
    };
    const onMouseUp = (e)=>{
        return requestAnimationFrame(()=>{
            if (!mountedRef.current) return;
            if ((0, $9wGTI.fg)('quick_capture_trello_inbox')) (0, $9ujb2.prefetchTrelloAccess)();
            const range = (0, $2zMIV.getRange)(); // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const portalContainer = document.querySelector(`#${(0, $bEdUx.popupPortalContainerId)}`); // WS-1576/WS-2355 - Ignore any highlights in the Inline Comments sidebar
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const inlineCommentSidebarContainer = document.querySelector('#inline-comment-sidebar'); // InlineCommentNudge handles its own content selection and opening of the Comment Editor.
            // Check both event target and element under cursor so we don't show toolbar when pointer is over nudge (e.g. portal/overlay edge cases).
            const elementUnderCursor = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            typeof document.elementFromPoint === 'function' ? // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            document.elementFromPoint(e.clientX, e.clientY) : null;
            const isOverCommentNudge = e.target && e.target.closest?.('#inline-comment-nudge') || elementUnderCursor && elementUnderCursor.closest?.('#inline-comment-nudge');
            const isOverRemixNudge = e.target && e.target.closest?.('#inline-remix-nudge') || elementUnderCursor && elementUnderCursor.closest?.('#inline-remix-nudge');
            if (isOverCommentNudge) return;
            if (isOverRemixNudge && (0, $9wGTI.fg)('confluence_remix_button_right_side_block_fg')) return;
             // When nudgebar improvement is on, only show toolbar when user selected text (not when selection was set by nudge hover).
            if (// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            document.body?.getAttribute?.('data-nudge-selection-active') === 'true' && (0, $6mKj3.expValEquals)('confluence_comment_nudgebar_improvement', 'isEnabled', true)) return;
             // freeze the actions popup if reading aids changeboarding is active
            if (isReadingAidsChangeboardingActive) return;
             // freeze the actions popup if the input is clicked in the rovo chat more options popup
            if (e.target.closest('#context-menu-rovo-chat-custom-prompt')) return;
            const isCommentButtonDisabledAndClicked = e.target.closest('button[disabled]');
            const isContextMenuOtherAppsButtonClicked = e.target.closest('#context-menu-other-apps');
            const isCreateJiraIssueButtonClicked = e.target.closest('#create-jira-issue-trigger');
            const isRovoChatMoreOptionsButtonClicked = e.target.closest('#context-menu-rovo-chat-more-options');
            const isNotesButtonClicked = e.target.closest('#highlight-actions-notes-button');
            const shouldHideContextMenu = !(isCommentButtonDisabledAndClicked || isContextMenuOtherAppsButtonClicked || isCreateJiraIssueButtonClicked || isRovoChatMoreOptionsButtonClicked || isNotesButtonClicked);
            if (!range || !portalContainer || !content.current || inlineCommentSidebarContainer?.contains(range.startContainer) || inlineCommentSidebarContainer?.contains(range.endContainer) || isDatasourceHighlighted(range) || !content.current.contains(e.target) && content.current !== e.target && shouldHideContextMenu) {
                if (isInReattachMode()) setReattachHighlight(null);
                setActionStates((prevState)=>({
                        ...prevState,
                        show: false
                    }));
                return;
            } // COMMENTS-332 - In reattach mode, skip the measuring of the screen, just set the mode with the highlight
            if (isInReattachMode()) {
                prepareAndSetHighlightForReattachMode();
                setActionStates((prevState)=>({
                        ...prevState,
                        show: false
                    }));
                return;
            }
            const portalRect = portalContainer.getBoundingClientRect();
            const contentRect = content.current.getBoundingClientRect();
            const rects = range.getClientRects();
            if (!rects || !rects.length) {
                setActionStates((prevState)=>({
                        ...prevState,
                        show: false
                    }));
                return;
            } // Find first selection area that width is not 0
            // Sometimes there is a chance that user is selecting an empty DOM node.
            const rect = Array.from(rects).find((rect)=>rect.width !== 0 && rect.height !== 0);
            if (rect) {
                const { left: left, right: right, top: top, width: width, height: height } = rect;
                const mouseUpX = e.clientX; // This is a LEGACY disable statement after rule addition. Use `Math.floor(width/2)` next time
                // eslint-disable-next-line no-bitwise
                const selectedLineCenter = left + (width >> 1); // Popup can't be rendered outside the body area
                let leftLimit = contentRect.left;
                let rightLimit = contentRect.right; // If the selected text has a parent that is scrollable for example like text inside table.
                // The popup is limited to be shown within the scrollable area.
                const firstParentThatCanScroll = getScrollParent(range.startContainer);
                if (firstParentThatCanScroll) {
                    const scrollParentRect = firstParentThatCanScroll.getBoundingClientRect();
                    leftLimit = Math.max(leftLimit, scrollParentRect.left);
                    rightLimit = Math.min(rightLimit, scrollParentRect.right);
                } // Use the X-axis position if the center of selected line is POPUP_MOUSEUP_DISTANCE_THRESHOLD away from mouse up position.
                // POPUP_MOUSEUP_DISTANCE_THRESHOLD is an arbitrary number I made up.
                // The idea is the popup will always show up within POPUP_MOUSEUP_DISTANCE_THRESHOLD of the end of the selection.
                // Right near what user selects. However when the selection is too short - like a phase,
                // it will show up at the middle of the selection because it looks better.
                let x = Math.abs(mouseUpX - selectedLineCenter) > $9755f908a54a6c5b$var$POPUP_MOUSEUP_DISTANCE_THRESHOLD && left <= mouseUpX && mouseUpX <= right ? mouseUpX : selectedLineCenter; // However it is still bounded by the left and right boundary of the first line.
                // This is because the mouse up can be off screen.
                // For example: Make selection, then drag on a scroll bar.
                if (!(0, $9wGTI.fg)('kd_definitions_skip_displacement_computation')) x = Math.max(leftLimit, Math.min(rightLimit, x));
                if (!isFabric) highlightActionsShownRef.current = false;
                setActionStates((prevState)=>({
                        ...prevState,
                        firstHighlightShown: true,
                        // COMMENTS-332 - Don't show the popup when a selection is made in reattach mode
                        show: !isInReattachMode(),
                        left: x - portalRect.left,
                        top: top - portalRect.top,
                        selectionRect: {
                            left: x - portalRect.left,
                            top: top - portalRect.top,
                            width: width,
                            height: height
                        }
                    }));
            }
        });
    };
    const createReactInlineCommentHighlight = ()=>{
        if (isObjectSidebarShown) hideObjectSidebar();
         // Close any existing media create comment when opening a text comment
        if ((0, $6mKj3.expValEquals)('confluence_comment_unmount_onmedia_selection', 'isEnabled', true)) {
            if (hoverProps) {
                // Remove draft annotation from media element if it exists
                hoverProps.removeDraftMode?.(); // Close the hover component (calls renderer's onClose)
                hoverProps.onClose?.(); // Clear hoverProps from context
                setHoverProps(null); // Flag to trigger text comment creation after hoverProps is cleared
                setPendingTextComment(true);
                return;
            }
        } // Proceed with text comment creation immediately if no media comment to clean up
        if (isFabric) onCommentButtonPress?.();
        else createComment((0, $4DJgG.getLegacyConvertedSelectionObj)({
            content: content,
            contentId: contentId,
            commentToReattach: commentToReattach,
            actions: actions
        }));
    };
    const handleCommentButtonClick = (dialogs)=>{
        if (hasContentChanged) dialogs.showDialog((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>createReactInlineCommentHighlight()
        });
        else createReactInlineCommentHighlight();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'inlineCommentFromInlineToolbar',
                action: 'clicked',
                actionSubject: 'button',
                type: 'ui',
                attributes: {
                    contentId: contentId,
                    pageMode: 'view',
                    searchSessionId: searchSessionId,
                    ...additionalAnalytics
                }
            }
        }).fire();
    };
    const extractNodeDetailsToString = (node)=>{
        if (!node) return '';
        while(node?.nodeType === Node.TEXT_NODE || node.tagName === 'MARK')node = node?.parentNode;
        if (node) {
            const elem = node;
            const classListStr = Array.from(elem.classList).join(',');
            let attrListStr = '';
            Object.entries(elem.dataset).forEach((attrEntry, idx)=>{
                if (idx > 0) attrListStr += ',';
                 // COMMENTS-1916 - Remove any emails that are in any values for attributes
                if (attrEntry.length > 1) {
                    const field = attrEntry[0];
                    if (field && field.includes('testMediaName')) attrEntry[1] = '';
                }
                attrListStr += attrEntry.join('=');
            }); // Get the tag name and stringify the class list and attribute list
            return `${elem.tagName}${classListStr.length ? `.${classListStr}` : ''}${attrListStr.length ? `[${attrListStr}]` : ''}`;
        }
        return '';
    };
    const CreateInlineCommentButton = ()=>{
        (0, $cozmU.useEffect)(()=>{
            if (!(0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) {
                document.addEventListener('keydown', $9755f908a54a6c5b$export$c1823fc1996a2ebd);
                return ()=>{
                    document.removeEventListener('keydown', $9755f908a54a6c5b$export$c1823fc1996a2ebd);
                };
            }
        }, []);
        (0, $cozmU.useEffect)(()=>{
            onCommentButtonMount && onCommentButtonMount();
        }, []);
        if (!content.current) return null;
        const isHighlightValid = $9755f908a54a6c5b$var$getIsHighlightValid({
            content: content.current,
            isFabric: isFabric,
            isAnnotationAllowed: isAnnotationAllowed,
            contentId: contentId
        }); // Cases where we want to disable the create button:
        // 1. The content is archived.
        // 2. The user does not have the "Comment - Add" permission.
        // 3. The highlight was invalid (over elements we don't support commenting on).
        // 4. The document needs to be updated (i.e. is outdated) AND selected node is one of [status, date, mention, inlineCard].
        // This order matters when communicating to users, as checking "Comment - Add" permission for archived pages
        // will return false.
        const isCreateButtonEnabled = !isArchived && canAddComments && !needsUpdateToComment && isHighlightValid; // Check if the comment is on a selection that includes an non-text inline node
        const isNonTextInlineNodeIncludedInComment = (inlineNodeTypes ?? []).filter((nodeType)=>nodeType !== 'text').length > 0; // Track the nodes in which the highlight was made on to send in the event
        if (!highlightActionsShownRef.current) {
            highlightActionsShownRef.current = true;
            try {
                const selection = window.getSelection();
                const startingNode = extractNodeDetailsToString(selection?.anchorNode);
                const endingNode = extractNodeDetailsToString(selection?.focusNode); // Track when the menu is shown to users and if it's disabled
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        source: 'highlightActionsMenu',
                        action: 'shown',
                        actionSubject: 'toolbar',
                        actionSubjectId: 'highlightActionsMenu',
                        attributes: {
                            isDisabled: !isCreateButtonEnabled,
                            pageMode: 'view',
                            startingNode: startingNode,
                            endingNode: endingNode,
                            inlineNodeTypes: inlineNodeTypes,
                            isNonTextInlineNodeIncludedInComment: /**
               * This attribute is used as the trigger to display an engagement platform promotion message
               * when isNonTextInlineNodeIncludedInComment is true, and isDisabled is false,
               * A spotlight/flag will be shown to the user to encourage them to comment on inline nodes.
               */ isNonTextInlineNodeIncludedInComment
                        }
                    }
                }).fire();
            } catch (e) {
                $9755f908a54a6c5b$var$logger.error`Unable to send highlight actions event; ${e}`;
            }
        }
        const createButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: [
                (0, $kRW4Y.DialogsStateContainer)
            ]
        }, (dialogs)=>{
            const commonCreateButtonProps = {
                'data-key': 'com.atlassian.confluence.plugins.confluence-inline-comments:create-inline-comment',
                // Needed for integration tests
                isDisabled: !isCreateButtonEnabled,
                testId: 'createInlineCommentButton',
                interactionName: 'start-inline-comment-action',
                onClick: ()=>{
                    handleCommentButtonClick(dialogs);
                },
                id: 'create-inline-comment-button'
            };
            return isNewToolbarEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AKbu.ToolbarButtonGroup), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6t3CY.ToolbarButton), {
                ...commonCreateButtonProps,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
                    label: "",
                    size: "small"
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                id: "highlight-actions.inline-comments.comment",
                defaultMessage: "Comment"
            }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                ...commonCreateButtonProps,
                appearance: "subtle",
                iconBefore: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
                        label: ""
                    })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                id: "highlight-actions.inline-comments.comment",
                defaultMessage: "Comment"
            })));
        }); // WS-2802 - We need to wrap the disabled button and put a transparent absolute overlay over the button
        //           in order to show the tooltip correctly as the disabled button swallows all events on the element
        //           and ADG doesn't allow tooltips on disabled buttons for accessibility reasons...
        if (isNewToolbarEnabled) return isCreateButtonEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), {
            key: "inline-comment-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
            content: formatMessage($9755f908a54a6c5b$var$i18n.commentTooltip),
            shortcut: commentShortcutStrings
        }, createButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
            delay: 0,
            content: (0, $dj3mI.getCreateButtonDisabledMessage)(isArchived, canAddComments, needsUpdateToComment, contentType)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6zmDz.DisabledButtonWrapper), {
            key: "inline-comment-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6zmDz.DisabledButtonOverlay), null), createButton));
        return isCreateButtonEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), {
            key: "inline-comment-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: formatMessage($9755f908a54a6c5b$var$i18n.commentTooltip),
            shortcut: commentShortcutStrings
        }, createButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            delay: 0,
            position: "top",
            content: (0, $dj3mI.getCreateButtonDisabledMessage)(isArchived, canAddComments, needsUpdateToComment, contentType)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6zmDz.DisabledButtonWrapper), {
            key: "inline-comment-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6zmDz.DisabledButtonOverlay), null), createButton));
    };
    const createJiraIssueButton = (completeKey)=>{
        if (!content.current || (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)() || (0, $lJlG6.isMobileApp_DO_NOT_USE)()) return null;
        if (!(0, $1xpoY.default).getBoolean('confluence_legacy_single_jira_work_create', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eDk57.SingleIssueCreateProvidersWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $29vMs.AIEventsInstrumentationProvider), {
            config: {
                // Required configuration
                product: 'confluence',
                subproduct: 'jira',
                aiFeatureName: 'confluenceAiWorkCreation',
                proactiveGeneratedAI: 0,
                userGeneratedAI: 1,
                // Optional configuration
                source: 'highlightActionsMenu',
                skipAISessionValidation: true
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6W81y.CreateJiraIssueActions), {
            activeSelection: window.getSelection(),
            completeKey: completeKey,
            container: content.current,
            contentId: contentId,
            contentType: contentType,
            lastModified: lastModifiedDate || lastModificationDate,
            showCreateMultipleIssuesButton: (0, $2zMIV.isHighlightValidForBulkCreateJiraIssues)(),
            setRecordedClick: setRecordedClick,
            setIsWarningDialogOpen: setIsWarningDialogOpen
        })));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            iconBefore: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
                    label: ""
                }),
            "data-key": completeKey,
            testId: "createJiraIssueButton",
            onClick: (0, $2W2Mk.createJiraIssueSummaryHandle)(content.current, contentId, lastModifiedDate || lastModificationDate)
        }, (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "highlight-actions.create-issue-issue-term-refresh",
            defaultMessage: "Create work item"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "highlight-actions.create-issue",
            defaultMessage: "Create issue"
        }));
    };
    const createTrelloInboxButton = (completeKey)=>{
        if (!content.current || (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)() || (0, $lJlG6.isMobileApp_DO_NOT_USE)()) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4oXkq.AddToTrelloInboxActions), {
            activeSelection: window.getSelection(),
            completeKey: completeKey,
            contentId: contentId
        });
    };
    const createReadingAidsDefineButton = ({ selectedRange: selectedRange, selectedText: selectedText, isOverWordLimit: isOverWordLimit })=>{
        if (!content.current) return null;
        const isDisabled = isOverWordLimit && readingAidsChangeboardingStep === 'disabled' || // only check word limit when changeboarding is disabled
        readingAidsChangeboardingStep === 'spotlight'; // always disable when spotlight is active
        const commonDefineButtonProps = {
            testId: 'defineButton',
            isDisabled: isDisabled,
            onClick: ()=>{
                if (!selectedRange) return;
                if (!selectedText) return;
                if (isAIEnabledForContent || isRovoEnabledForContent) experienceTracker.start({
                    name: (0, $irVI7.READING_AIDS_EXPERIENCE),
                    attributes: {
                        contentId: contentId,
                        source: 'defineButton'
                    }
                });
                setDefineDefinitionOpen({
                    defineDefinitionOpen: true
                });
                setActionStates((prevState)=>({
                        ...prevState,
                        ...isOverWordLimit && readingAidsChangeboardingStep === 'idle' ? {
                            readingAidsChangeboardingStep: 'modal-word-count'
                        } : {
                            isReadingAidsOpen: true
                        },
                        show: false,
                        activeSelection: {
                            selectedText: selectedText,
                            selectedRange: selectedRange
                        }
                    }));
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        source: 'highlightActionsMenu',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'defineButton',
                        type: 'ui',
                        attributes: {
                            contentId: contentId,
                            isAIOptedIn: isAIEnabledForContent
                        }
                    }
                }).fire();
            }
        };
        const oldDefineButtonIcon = isRovoEnabledForContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.RovoIcon), {
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $97kfW.AtlassianIntelligenceIcon), {
            size: "large",
            greyed: isDisabled
        });
        const defineButtonIcon = (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))), {
            label: ""
        }) : oldDefineButtonIcon;
        const defineButtonContent = isNewToolbarEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
            content: formatMessage($9755f908a54a6c5b$var$i18n.defineTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AKbu.ToolbarButtonGroup), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6t3CY.ToolbarButton), {
            ...commonDefineButtonProps,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))), {
                label: "",
                size: "small"
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "highlight-actions.define",
            defaultMessage: "Define"
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            ...commonDefineButtonProps,
            appearance: "subtle",
            iconBefore: ()=>defineButtonIcon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "highlight-actions.define",
            defaultMessage: "Define"
        }));
        const defineButton = (0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, defineButtonContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Iwqw.default), {
            name: (0, $cR1lV.READING_AIDS_CHANGEBOARDING_SPOTLIGHT_ID)
        }, defineButtonContent);
        return isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            delay: 0,
            position: "top",
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                id: "highlight-actions.define.unsupported",
                defaultMessage: "Highlight a term, acronym, or abbreviation"
            }),
            component: (0, $9wGTI.fg)('confluence_comment_border_migration') ? $9755f908a54a6c5b$var$CustomLineWrapTooltipUpdated : $9755f908a54a6c5b$var$CustomLineWrapTooltip
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6zmDz.DisabledButtonWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6zmDz.DisabledButtonOverlay), null), defineButton)) : defineButton;
    };
    const handleClickChat = (0, $cozmU.useCallback)(()=>{
        const { panelId: panelId } = rightSidebarContext.getCurrent() || {};
        const isChatActive = panelId === (0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_ID);
        if (!isChatActive) rightSidebarContext.open((0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_ID), (0, $kQqCc.CONVERSATION_ASSISTANT_CONTAINER_WIDTH));
    }, [
        rightSidebarContext
    ]);
    const createRovoChatHighlightActionsButton = (selectedADFContent)=>{
        if ((0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)() || (0, $lJlG6.isMobileApp_DO_NOT_USE)()) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3N2DH.RovoChatHighlightActions), {
            selectedContent: selectedADFContent,
            product: "confluence",
            onClickChat: handleClickChat,
            creationContextParams: $9755f908a54a6c5b$var$INLINE_VIEW_PAGE_CREATION_CONTEXT_PARAMS
        });
    };
    const renderBuiltInWebItemActionsOld = (builtInWebItems, hasOtherActions)=>{
        const isHighlightValid = $9755f908a54a6c5b$var$getIsHighlightValid({
            content: content.current,
            isFabric: isFabric,
            isAnnotationAllowed: isAnnotationAllowed,
            contentId: contentId
        });
        const isReactionAllowed = !isArchived && canAddComments && !needsUpdateToComment && isHighlightValid;
        const baseComponents = [];
        if (isRemixAvailable && !(0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)()) baseComponents.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3b5i6.RemixAction), {
            isNewToolbarEnabled: isNewToolbarEnabled,
            onClick: onRemixButtonPress,
            isDisabled: !onRemixButtonPress,
            isRemixInProgress: isRemixing,
            remixDisabledReason: remixDisabledReason
        }));
        if (hasInlineComments && !(0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) baseComponents.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CreateInlineCommentButton, null));
        if (snippetSlots?.button && (0, $6mKj3.expValEquals)('platform_editor_blocks_conf', 'isEnabled', true)) baseComponents.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), {
            key: "SnippetButton"
        }, snippetSlots.button));
        const selectedRange = (0, $2zMIV.getRange)();
        const selectedText = (0, $2zMIV.textNormalize)(String(window.getSelection())).replace(/\n/, ' ').trim();
        const wordCount = selectedText.split(/\s+/).length;
        const isOverWordLimit = wordCount > (0, $7rLBD.READING_AIDS_MAX_WORD_COUNT);
        const showReadingAidsDefineButton = isAIEnabledForContent || isRovoEnabledForContent;
        if (isRovoEnabledForContent) {
            const selectionString = (0, $joYQz.getHTMLString)(window.getSelection());
            const selectedADFContent = (0, $i8Nmr.htmlToADF)(selectionString);
            const itemToPush = isOverWordLimit ? createRovoChatHighlightActionsButton(selectedADFContent) : createReadingAidsDefineButton({
                selectedRange: selectedRange,
                selectedText: selectedText,
                isOverWordLimit: isOverWordLimit
            });
            baseComponents.push(itemToPush);
        } else if (showReadingAidsDefineButton) baseComponents.push(createReadingAidsDefineButton({
            selectedRange: selectedRange,
            selectedText: selectedText,
            isOverWordLimit: isOverWordLimit
        }));
        const builtInComponents = builtInWebItems.map((item)=>{
            const { completeKey: completeKey } = item;
            if (completeKey === 'com.atlassian.confluence.plugins.confluence-jira-content:create-JIRA-issue-summary') return createJiraIssueButton(completeKey);
            else if (completeKey === 'com.atlassian.confluence.plugins.confluence-trello-content:create-trello-card-quick-capture') return createTrelloInboxButton(completeKey);
            return null;
        }).filter(Boolean);
        if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6zmDz.BuiltInActionsPatch), {
            key: "built-in-actions"
        }, $9755f908a54a6c5b$export$c0b63e9f99a74f33([
            ...baseComponents,
            ...builtInComponents,
            ...isRemixAvailable && !(0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)() ? [
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3b5i6.RemixAction), {
                    key: "RemixButton",
                    isNewToolbarEnabled: isNewToolbarEnabled,
                    onClick: onRemixButtonPress,
                    isDisabled: !onRemixButtonPress,
                    isRemixInProgress: isRemixing,
                    remixDisabledReason: remixDisabledReason
                })
            ] : [],
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CreateInlineCommentButton, {
                key: "CreateInlineCommentButton"
            }),
            ...(0, $6mKj3.expValEquals)('confluence_inline_reactions', 'isEnabled', true) ? [
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $erJgi.InlineReactionAction), {
                    key: "InlineReactionAction",
                    isAnnotationAllowed: isReactionAllowed,
                    disabledTooltip: !isReactionAllowed ? (0, $dj3mI.getReactionButtonDisabledMessage)(isArchived, canAddComments, needsUpdateToComment, contentType) : undefined
                })
            ] : []
        ], hasOtherActions));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6zmDz.BuiltInActionsOld), {
            key: "built-in-actions"
        }, $9755f908a54a6c5b$export$c0b63e9f99a74f33([
            ...baseComponents,
            ...builtInComponents,
            ...(0, $6mKj3.expValEquals)('confluence_inline_reactions', 'isEnabled', true) ? [
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $erJgi.InlineReactionAction), {
                    key: "InlineReactionAction",
                    isAnnotationAllowed: isReactionAllowed,
                    disabledTooltip: !isReactionAllowed ? (0, $dj3mI.getReactionButtonDisabledMessage)(isArchived, canAddComments, needsUpdateToComment, contentType) : undefined
                })
            ] : []
        ], hasOtherActions));
    };
    const renderBuiltInWebItemActions = (builtInWebItems, hasOtherActions)=>{
        const isHighlightValid = $9755f908a54a6c5b$var$getIsHighlightValid({
            content: content.current,
            isFabric: isFabric,
            isAnnotationAllowed: isAnnotationAllowed,
            contentId: contentId
        });
        const isReactionAllowed = !isArchived && canAddComments && !needsUpdateToComment && isHighlightValid;
        const componentsAI = [];
        const components = [];
        const showMoreActions = [];
        let defineButton = null;
        const selectedRange = (0, $2zMIV.getRange)();
        const selectedText = (0, $2zMIV.textNormalize)(String(window.getSelection())).replace(/\n/, ' ').trim();
        const wordCount = selectedText.split(/\s+/).length;
        const isOverWordLimit = wordCount > (0, $7rLBD.READING_AIDS_MAX_WORD_COUNT);
        const showReadingAidsDefineButton = isAIEnabledForContent || isRovoEnabledForContent;
        const selectionString = (0, $joYQz.getHTMLString)(window.getSelection());
        const selectedADFContent = (0, $i8Nmr.htmlToADF)(selectionString);
        if (isNewToolbarEnabled) {
            if (isRovoEnabledForContent) {
                const askRovoButton = createRovoChatHighlightActionsButton(selectedADFContent);
                if (askRovoButton) {
                    if ((0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true)) componentsAI.push(askRovoButton);
                    else components.push(askRovoButton);
                }
            }
            if (showReadingAidsDefineButton && !isOverWordLimit) {
                const defineButton = createReadingAidsDefineButton({
                    selectedRange: selectedRange,
                    selectedText: selectedText,
                    isOverWordLimit: isOverWordLimit
                });
                if (defineButton) {
                    if ((0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true)) componentsAI.push(defineButton);
                    else components.push(defineButton);
                }
            }
        } else {
            if (isRovoEnabledForContent) defineButton = isOverWordLimit ? createRovoChatHighlightActionsButton(selectedADFContent) : createReadingAidsDefineButton({
                selectedRange: selectedRange,
                selectedText: selectedText,
                isOverWordLimit: isOverWordLimit
            });
            else if (showReadingAidsDefineButton) defineButton = createReadingAidsDefineButton({
                selectedRange: selectedRange,
                selectedText: selectedText,
                isOverWordLimit: isOverWordLimit
            });
            if (defineButton) components.push(defineButton);
        }
        if (isRemixAvailable && !(0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)()) {
            const remixButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3b5i6.RemixAction), {
                key: "RemixButton",
                isNewToolbarEnabled: isNewToolbarEnabled,
                onClick: onRemixButtonPress,
                isDisabled: !onRemixButtonPress,
                isRemixInProgress: isRemixing,
                remixDisabledReason: remixDisabledReason
            });
            if (isNewToolbarEnabled && (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true)) componentsAI.push(remixButton);
            else components.push(remixButton);
        }
        const commentButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CreateInlineCommentButton, {
            key: "CreateInlineCommentButton"
        });
        components.push(commentButton);
        if ((0, $6mKj3.expValEquals)('confluence_inline_reactions', 'isEnabled', true)) components.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $erJgi.InlineReactionAction), {
            key: "InlineReactionAction",
            isAnnotationAllowed: isReactionAllowed,
            disabledTooltip: !isReactionAllowed ? (0, $dj3mI.getReactionButtonDisabledMessage)(isArchived, canAddComments, needsUpdateToComment, contentType) : undefined
        }));
        let jiraButton = null;
        let trelloButton = null;
        builtInWebItems.forEach((item)=>{
            const { completeKey: completeKey } = item;
            if (completeKey === 'com.atlassian.confluence.plugins.confluence-jira-content:create-JIRA-issue-summary') jiraButton = createJiraIssueButton(completeKey);
            else if (completeKey === 'com.atlassian.confluence.plugins.confluence-trello-content:create-trello-card-quick-capture') trelloButton = createTrelloInboxButton(completeKey);
        });
        if (snippetSlots?.dropdownItem && (0, $6mKj3.expValEquals)('platform_editor_blocks_conf', 'isEnabled', true)) showMoreActions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), {
            key: "SnippetDropdownItem"
        }, snippetSlots.dropdownItem));
        if (jiraButton) showMoreActions.push(jiraButton);
        if (trelloButton) showMoreActions.push(trelloButton);
        const _hasOtherActions = Boolean(hasOtherActions || showMoreActions.length > 0);
        if (isNewToolbarEnabled) {
            if (componentsAI.length > 0 && (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true)) // if there are AI components, render them in a ToolbarSection with a separator at the end
            return {
                builtInActions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cE5a1.ToolbarSection), {
                    key: "built-in-actions-ai",
                    hasSeparator: (0, $cE5a1.SeparatorPosition).END
                }, componentsAI), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cE5a1.ToolbarSection), {
                    key: "built-in-actions"
                }, components)),
                showMoreActions: showMoreActions
            };
            return {
                builtInActions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cE5a1.ToolbarSection), {
                    key: "built-in-actions"
                }, components),
                showMoreActions: showMoreActions
            };
        }
        return {
            builtInActions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                key: "built-in-actions",
                className: (0, $hekY6.default)([
                    "_1e0c1txw _ca0q1b66 _n3td1b66 _19bv1b66",
                    !_hasOtherActions && "_u5f31b66"
                ])
            }, $9755f908a54a6c5b$export$c0b63e9f99a74f33(components, _hasOtherActions)),
            showMoreActions: showMoreActions
        };
    };
    const getComponentsForPopup = (webItems, forgeItems = [])=>{
        const webItemsWithTrello = (0, $9wGTI.fg)('quick_capture_trello_inbox') ? [
            ...webItems,
            {
                completeKey: 'com.atlassian.confluence.plugins.confluence-trello-content:create-trello-card-quick-capture'
            }
        ] : webItems;
        const builtInWebItems = webItemsWithTrello.filter((item)=>$9755f908a54a6c5b$var$BUILT_IN_ITEMS.includes(item.completeKey));
        const connectItems = webItems.filter((item)=>!$9755f908a54a6c5b$export$9205c47465d0942.includes(item.completeKey));
        const hasOtherActions = (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? Boolean(forgeItems?.length || connectItems?.length) : forgeItems?.length || connectItems?.length;
        const { builtInActions: builtInActions, showMoreActions: showMoreActions } = renderBuiltInWebItemActions(builtInWebItems, hasOtherActions);
        const otherActions = (0, $6mKj3.expValEquals)('platform_editor_renderer_toolbar_updates', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cE5a1.ToolbarSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AKbu.ToolbarButtonGroup), {
            key: "other-components"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b1ynj.OtherActions), {
            builtInActions: showMoreActions,
            connectItems: connectItems,
            forgeItems: forgeItems,
            selectForgeExtension: (forgeExtension)=>{
                const selectedRange = (0, $2zMIV.getRange)();
                if (!selectedRange) return;
                const selectedText = (0, $2zMIV.textNormalize)(String(selectedRange)).trim();
                if (!selectedText) return;
                setActionStates((prevState)=>({
                        ...prevState,
                        forgeExtension: forgeExtension,
                        activeSelection: {
                            selectedText: selectedText,
                            selectedRange: selectedRange
                        }
                    }));
            }
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AKbu.ToolbarButtonGroup), {
            key: "other-components"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b1ynj.OtherActions), {
            builtInActions: showMoreActions,
            connectItems: connectItems,
            forgeItems: forgeItems,
            selectForgeExtension: (forgeExtension)=>{
                const selectedRange = (0, $2zMIV.getRange)();
                if (!selectedRange) return;
                const selectedText = (0, $2zMIV.textNormalize)(String(selectedRange)).trim();
                if (!selectedText) return;
                setActionStates((prevState)=>({
                        ...prevState,
                        forgeExtension: forgeExtension,
                        activeSelection: {
                            selectedText: selectedText,
                            selectedRange: selectedRange
                        }
                    }));
            }
        }));
        if (isNewToolbarEnabled) return [
            builtInActions,
            otherActions
        ];
        return [
            (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? builtInActions : renderBuiltInWebItemActionsOld(builtInWebItems, hasOtherActions),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b1ynj.OtherActions), {
                key: "other-components",
                builtInActions: (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? showMoreActions : undefined,
                connectItems: connectItems,
                forgeItems: forgeItems,
                selectForgeExtension: (forgeExtension)=>{
                    const selectedRange = (0, $2zMIV.getRange)();
                    if (!selectedRange) return;
                    const selectedText = (0, $2zMIV.textNormalize)(String(selectedRange)).trim();
                    if (!selectedText) return;
                    setActionStates((prevState)=>({
                            ...prevState,
                            forgeExtension: forgeExtension,
                            activeSelection: {
                                selectedText: selectedText,
                                selectedRange: selectedRange
                            }
                        }));
                }
            })
        ];
    };
    const renderPopup = (components)=>components.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: [
                (0, $hrAmX.BannerStateContainer)
            ]
        }, (bannerState)=>{
            // if there's a sticky header we want to position the toolbar below
            // the nav, the page header (if visible) and the sticky header
            let stickyHeaderHeight = 0;
            const range = (0, $2zMIV.getRange)();
            if (range) {
                const header = (0, $2zMIV.findStickyHeader)(range.commonAncestorContainer);
                if (header && bannerState) stickyHeaderHeight = bannerState.getTotalHeight() + header.clientHeight;
            }
            if (!screenEventFiredRef.current) createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'highlightActionsMenu',
                    attributes: {
                        contentId: contentId
                    }
                }
            }).fire();
            screenEventFiredRef.current = true;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lEDve.Popup), {
                top: stickyHeaderHeight + (position?.top ?? top),
                left: position?.left ?? left,
                updatePosition: updatePosition
            }, components), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
                name: (0, $irVI7.VIEW_PAGE_CONTEXT_MENU_EXPERIENCE)
            }));
        }) : null;
    const isCreateSingleJiraIssueHandleParams = (params)=>{
        return params?.fireAiAnalytics === undefined;
    };
    const handleConfirm = (0, $cozmU.useCallback)(async ()=>{
        const callRightSidebarClose = async ()=>rightSidebarContext.close((0, $1L1jV.ISSUE_CREATE_SIDE_PANEL_ID)); // Need to make sure sidebar is closed before creating a new one issue
        await callRightSidebarClose(); // Sorry this block sucks because of TS types
        if (isCreateSingleJiraIssueHandleParams(recordedClick)) (0, $joYQz.createSingleJiraIssueHandle)(recordedClick);
        else recordedClick && (0, $joYQz.createSingleAiJiraIssueHandle)(recordedClick);
        setIsWarningDialogOpen(false);
    }, [
        setIsWarningDialogOpen,
        recordedClick,
        rightSidebarContext
    ]);
    const handleCancel = (0, $cozmU.useCallback)(()=>{
        setIsWarningDialogOpen(false);
    }, [
        setIsWarningDialogOpen
    ]);
    const contentSection = !isFabric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l4eiF.HighlightActionsContext).Provider, {
        value: highlightActionsContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        key: "content-container",
        ref: content
    }, children));
    const popupSection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, show ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
        id: contentId,
        name: (0, $irVI7.VIEW_PAGE_CONTEXT_MENU_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kxhju.WebItemLocation), {
        key: "action-panel",
        contentId: contentId,
        location: (0, $eSLr0.ACTION_PANEL),
        fetchPolicy: "cache-first"
    }, ({ webItems: webItems })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dizL5.LazyForgeUIExtensions), {
            moduleType: (0, $7Ndnw.FORGE_MODULE_CONTEXT_MENU),
            render: (forgeItems, loading, error)=>{
                if (loading) return null;
                if (error) {
                    if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                        error: error
                    });
                    return null;
                }
                return renderPopup(getComponentsForPopup(webItems, forgeItems));
            }
        }))) : null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, isWarningDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $98CLM.IssueCreateWarningDialog), {
        onConfirm: handleConfirm,
        onCancel: handleCancel
    }), contentStatusError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: contentStatusError
    }), contentQueryError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: contentQueryError
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dizL5.LazyForgeUIExtensions), {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTEXT_MENU),
        render: (_apps, _loading, error)=>{
            if (error && !(0, $7Sm4c.isErrorMarkedAsHandled)(error)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            });
            return null;
        }
    }), forgeExtension && activeSelection && !show && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9755f908a54a6c5b$var$ForgeAction, {
        content: content.current,
        contentId: contentId,
        forgeExtension: forgeExtension,
        activeSelection: activeSelection,
        onClose: ()=>{
            setActionStates((prevState)=>({
                    ...prevState,
                    forgeExtension: null
                }));
        }
    }), (0, $9wGTI.fg)('kd_definitions_confluence_enable_platform') ? isReadingAidsOpen && activeSelection && !show && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9755f908a54a6c5b$var$DefinitionAction, {
        contentId: contentId,
        contentType: contentType,
        onClose: ()=>{
            setActionStates((prevState)=>({
                    ...prevState,
                    isReadingAidsOpen: false
                }));
        },
        selectedText: activeSelection.selectedText,
        selectionRect: selectionRect
    }) : isReadingAidsOpen && activeSelection && !show && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Jxlo.ReadingAidsPopup), {
        selectedText: activeSelection.selectedText,
        selectionRange: activeSelection.selectedRange,
        selectionRect: selectionRect,
        isReadingAidsOpen: isReadingAidsOpen,
        onClose: ()=>{
            setDefineDefinitionOpen({
                defineDefinitionOpen: false
            });
            setActionStates((prevState)=>({
                    ...prevState,
                    isReadingAidsOpen: false
                }));
        },
        contentId: contentId,
        popupPortalContainerId: (0, $bEdUx.popupPortalContainerId),
        onResult: (result)=>{
            if (readingAidsChangeboardingStep === 'idle') {
                if (result?.nlpSearch?.errorState?.startsWith('NO_ANSWER')) setActionStates((prevState)=>({
                        ...prevState,
                        isReadingAidsOpen: false,
                        readingAidsChangeboardingStep: 'modal-undefined'
                    }));
                else stopReadingAidsChangeboarding();
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kx3q1.default), null, readingAidsChangeboardingStep.startsWith('modal') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a3Fla.ReadingAidsChangeboardingModal), {
        onNextClick: ()=>{
            setActionStates((prevState)=>({
                    ...prevState,
                    readingAidsChangeboardingStep: 'spotlight',
                    show: true
                }));
        },
        modalVersion: readingAidsChangeboardingStep,
        contentId: contentId
    }) : null), (0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dOlTT.PopoverContent), {
        isVisible: readingAidsChangeboardingStep === 'spotlight',
        placement: "bottom-start",
        dismiss: ()=>void stopReadingAidsChangeboarding()
    }, readingAidsChangeboardingStep === 'spotlight' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ikgN.ReadingAidsChangeboardingSpotlight), {
        contentId: contentId,
        onGotItClick: stopReadingAidsChangeboarding
    })), contentSection, popupSection) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lt1a.default), null, readingAidsChangeboardingStep === 'spotlight' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ikgN.ReadingAidsChangeboardingSpotlight), {
        contentId: contentId,
        onGotItClick: stopReadingAidsChangeboarding
    }) : null), contentSection, popupSection));
};
module.exports["DROPDOWN_EXCLUDED_ITEMS"] = $9755f908a54a6c5b$export$9205c47465d0942;
module.exports["HighlightActions"] = $9755f908a54a6c5b$export$a6299569dd2a354f;

});

parcelRegister("kx3q1", function(module, exports) {
$parcel$export(module.exports, "default", () => $96ca290bd1749542$export$2e2bcd8739ae039);
/**
 * We re-export this because products may have multiple versions of
 * `@atlaskit/modal-dialog`.
 *
 * If a consumer uses the onboarding `Modal` with the `ModalTransition` from an
 * incompatible version of `@atlaskit/modal-dialog`, then the modal can get
 * stuck in an open state.
 *
 * See https://product-fabric.atlassian.net/browse/DSP-796 for more details
 * and a reproduction.
 *
 */ 
var $aRGok = parcelRequire("aRGok");

var /**
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ $96ca290bd1749542$export$2e2bcd8739ae039 = (0, $aRGok.default);

});

parcelRegister("29vMs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1np6T = parcelRequire("1np6T");


var $hBkQ2 = parcelRequire("hBkQ2");


var $aZXY4 = parcelRequire("aZXY4");

const $61be62ccfa3ec333$var$validateAIEventsConfig = (config)=>{
    if (!config.aiFeatureName.match(/^[a-z][A-Za-z]*$/)) // eslint-disable-next-line no-console
    console.error('[@atlassian/ai-analytics]: please set aiFeatureName in camelCase');
};
const $61be62ccfa3ec333$export$b5d4bc85dfbaa4f8 = ({ children: children, config: config })=>{
    const { refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = (0, $aZXY4.useAIInstrumentationSetup)(config.singleInstrumentationID);
    const contextValue = (0, $cozmU.useMemo)(()=>{
        $61be62ccfa3ec333$var$validateAIEventsConfig(config);
        return {
            config: {
                ...(0, $hBkQ2.defaultAIEventsInstrumentationConfigValues),
                ...config,
                product: config.product.toLowerCase()
            },
            refreshSingleInstrumentationID: refreshSingleInstrumentationID,
            getSingleInstrumentationID: getSingleInstrumentationID,
            setAISessionState: setAISessionState,
            getAISessionState: getAISessionState
        };
    }, [
        config,
        refreshSingleInstrumentationID,
        getSingleInstrumentationID,
        setAISessionState,
        getAISessionState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1np6T.AIEventsInstrumentationContext).Provider, {
        value: contextValue
    }, children);
};
module.exports["AIEventsInstrumentationProvider"] = $61be62ccfa3ec333$export$b5d4bc85dfbaa4f8;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("i2HVB"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("i2HVB", function(module, exports) {

let $d22a7d17917e1bac$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d22a7d17917e1bac$var$load("1NGPq"),
    $d22a7d17917e1bac$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("2A8CJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $dae2c2bf6a5fe745$export$6d9b0a4fb48787a7 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    lastModificationDate: null
});
$dae2c2bf6a5fe745$export$6d9b0a4fb48787a7.displayName = 'ContentBodyContext';
module.exports["ContentBodyContext"] = $dae2c2bf6a5fe745$export$6d9b0a4fb48787a7;

});

parcelRegister("hrAmX", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");


var $i3jcY = parcelRequire("i3jcY");


var $6mKj3 = parcelRequire("6mKj3");

const $6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME = 'ServerRenderedBanners';
const $6ee3834dea9f6c5c$export$f7df67e8f3ba0620 = (name, inArray)=>inArray.indexOf(inArray.filter((banner)=>banner.name === name)[0]);
class $6ee3834dea9f6c5c$export$bbac707b3ebb5681 extends (0, $kNIYN.Container) {
    constructor(props = {}){
        super();
        // Nav4 is fully rolled out; top nav height is always 48px unless FHS is enabled
        this.topNavHeight = void 0;
        this.state = {
            banners: []
        };
        this._updateServerRenderedBanners = (spaBannerHeight)=>{
            if (spaBannerHeight === 0) this.hide($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME);
            else this.show($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME, spaBannerHeight);
        };
        /**
     * Adds or updates the specified banner in the list of visible banners.
     * Add the banner is not already in the list, otherwise update the banner's height
     *
     * @param {string} name Unique name of the banner
     * @param {number} height Height of the banner, in pixels
     */ this.show = (name, height)=>{
            if ((0, $i3jcY.isStableUIEnabledForTests)()) return;
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index === -1) return {
                    ...state,
                    banners: [
                        ...state.banners,
                        {
                            name: name,
                            height: height
                        }
                    ]
                };
                else if (state.banners[index].height !== height) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray[index].height = height;
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Removes the specified banner from the list of visible banners
     * Remove the banner if it is in the list, do nothing it is not
     *
     * @param {string} name Unique name of the banner
     */ this.hide = (name)=>{
            this.setState((state)=>{
                const index = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620(name, state.banners);
                if (index > -1) {
                    const newArray = [
                        ...state.banners
                    ];
                    newArray.splice(index, 1);
                    return {
                        ...state,
                        banners: newArray
                    };
                }
            });
        };
        /**
     * Returns the combined height of all banners in the list.
     * @param {boolean} includeTopNav Include `TOP_NAV_HEIGHT` in the calculation
     * if not `false`
     * @returns {number} Combined height of all visible banners
     */ this.getTotalHeight = (includeTopNav)=>this.state.banners.reduce((totalOffset, banner)=>totalOffset + banner.height, includeTopNav !== false ? this.topNavHeight : 0);
        /**
     * Returns list of all banners in visible list in "-" seperated string.
     * @returns {string} Combined names of all banners in visible list seperated by "-"
     */ this.getBannerList = ()=>this.state.banners.map((banner)=>banner.name).join('-');
        let navHeight = 48;
        if (// The increased height change is only applied when FHS is enabled.
        // Ideally we could check `useIsFhsEnabled()` but we can't use hooks here.
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expVal)('navx-full-height-sidebar-exp', 'isEnabled', false)) navHeight = 56;
        this.topNavHeight = props.hasTopNav === false ? 0 : navHeight;
        this.state.banners = (0, $i3jcY.isStableUIEnabledForTests)() ? [] : props.initialState?.banners || [];
    }
}
module.exports["findBanner"] = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620;
module.exports["BannerStateContainer"] = $6ee3834dea9f6c5c$export$bbac707b3ebb5681;

});

parcelRegister("2Jxlo", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $8c38d1311bce6ee3$export$15b21f0ead27e4bf = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "qNGEh",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("21PIP"))).ReadingAidsPopup
});
module.exports["ReadingAidsPopup"] = $8c38d1311bce6ee3$export$15b21f0ead27e4bf;

});

parcelRegister("21PIP", function(module, exports) {

let $17a3cbb27cd0e01d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $17a3cbb27cd0e01d$var$load("kT6dz"),
    $17a3cbb27cd0e01d$var$load("bpmjT"),
    $17a3cbb27cd0e01d$var$load("ig9dh"),
    $17a3cbb27cd0e01d$var$load("hA8hA"),
    $17a3cbb27cd0e01d$var$load("gbejv"),
    $17a3cbb27cd0e01d$var$load("GD9EA"),
    $17a3cbb27cd0e01d$var$load("7TnhR"),
    $17a3cbb27cd0e01d$var$load("hUbK8"),
    $17a3cbb27cd0e01d$var$load("eSqZD"),
    $17a3cbb27cd0e01d$var$load("2PFjC"),
    $17a3cbb27cd0e01d$var$load("gwGEC"),
    $17a3cbb27cd0e01d$var$load("l5nRU"),
    $17a3cbb27cd0e01d$var$load("fcAaN"),
    $17a3cbb27cd0e01d$var$load("2CrXe"),
    $17a3cbb27cd0e01d$var$load("beMmd"),
    $17a3cbb27cd0e01d$var$load("1rM9D"),
    $17a3cbb27cd0e01d$var$load("3cN9G"),
    $17a3cbb27cd0e01d$var$load("7oMW2"),
    $17a3cbb27cd0e01d$var$load("j3345"),
    $17a3cbb27cd0e01d$var$load("2J2X1"),
    $17a3cbb27cd0e01d$var$load("do0Fh"),
    $17a3cbb27cd0e01d$var$load("1Gr4q"),
    $17a3cbb27cd0e01d$var$load("4RsKm"),
    $17a3cbb27cd0e01d$var$load("7oAXW"),
    $17a3cbb27cd0e01d$var$load("3RQq6"),
    $17a3cbb27cd0e01d$var$load("iOfkQ"),
    $17a3cbb27cd0e01d$var$load("dxcsb"),
    $17a3cbb27cd0e01d$var$load("9ZFGK"),
    $17a3cbb27cd0e01d$var$load("2hLAI"),
    $17a3cbb27cd0e01d$var$load("dCilB"),
    $17a3cbb27cd0e01d$var$load("1T8H1"),
    $17a3cbb27cd0e01d$var$load("fyKFO"),
    $17a3cbb27cd0e01d$var$load("d9sg7"),
    $17a3cbb27cd0e01d$var$load("l0N35"),
    $17a3cbb27cd0e01d$var$load("cmmpX"),
    $17a3cbb27cd0e01d$var$load("ekVH8"),
    $17a3cbb27cd0e01d$var$load("c1gk3"),
    $17a3cbb27cd0e01d$var$load("Kj0I8"),
    $17a3cbb27cd0e01d$var$load("5xnun"),
    $17a3cbb27cd0e01d$var$load("cyTuQ"),
    $17a3cbb27cd0e01d$var$load("jqoep"),
    $17a3cbb27cd0e01d$var$load("6wr18"),
    $17a3cbb27cd0e01d$var$load("59hV4"),
    $17a3cbb27cd0e01d$var$load("8zMmc"),
    $17a3cbb27cd0e01d$var$load("4x9Jx"),
    $17a3cbb27cd0e01d$var$load("a8glC"),
    $17a3cbb27cd0e01d$var$load("eCXJR"),
    $17a3cbb27cd0e01d$var$load("1VTX2"),
    $17a3cbb27cd0e01d$var$load("ffEVr"),
    $17a3cbb27cd0e01d$var$load("gzrfp"),
    $17a3cbb27cd0e01d$var$load("2EIkU"),
    $17a3cbb27cd0e01d$var$load("ddvkk"),
    $17a3cbb27cd0e01d$var$load("3upHR"),
    $17a3cbb27cd0e01d$var$load("iUXaE"),
    $17a3cbb27cd0e01d$var$load("lTkx9"),
    $17a3cbb27cd0e01d$var$load("Wowvf"),
    $17a3cbb27cd0e01d$var$load("eRhBr"),
    $17a3cbb27cd0e01d$var$load("hZ2FX"),
    $17a3cbb27cd0e01d$var$load("hhss7"),
    $17a3cbb27cd0e01d$var$load("7EorR"),
    $17a3cbb27cd0e01d$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});

parcelRegister("a3Fla", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $371bfa624b8f4825$export$d9088a53cb7c38b4 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "W_5EK",
    name: "ReadingAidsChangeboardingModal",
    loader: async ()=>(await (parcelRequire("bEks9"))).ReadingAidsChangeboardingModal
});
module.exports["ReadingAidsChangeboardingModal"] = $371bfa624b8f4825$export$d9088a53cb7c38b4;

});

parcelRegister("bEks9", function(module, exports) {

let $87b34bb162383a9c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $87b34bb162383a9c$var$load("6wr18"),
    $87b34bb162383a9c$var$load("ffEVr"),
    $87b34bb162383a9c$var$load("kwiXK")
]).then(()=>parcelRequire('iPt4B'));

});

parcelRegister("9ikgN", function(module, exports) {
$parcel$export(module.exports, "READING_AIDS_CHANGEBOARDING_SPOTLIGHT_ID", () => (parcelRequire("cR1lV")).READING_AIDS_CHANGEBOARDING_SPOTLIGHT_ID);

var $jmjWc = parcelRequire("jmjWc");


var $cR1lV = parcelRequire("cR1lV");


const $ade6da7539ba5902$export$1942ca99b3c33b66 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "B2kdC",
    name: "ReadingAidsChangeboardingSpotlight",
    loader: async ()=>(await Promise.resolve((parcelRequire("cR1lV")))).ReadingAidsChangeboardingSpotlight
});
module.exports["ReadingAidsChangeboardingSpotlight"] = $ade6da7539ba5902$export$1942ca99b3c33b66;

});

parcelRegister("cR1lV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $lsxnT = parcelRequire("lsxnT");

const $83df18abc582ef5a$export$a21884ebed08a664 = 'reading-aids-spotlight';
const $83df18abc582ef5a$var$i18n = (0, $kSwu1.defineMessages)({
    changeboardingSpotlightGotItButton: {
        id: "contextual-reading-aids.changeboarding-spotlight.got-it-button",
        defaultMessage: "Got it"
    },
    changeboardingSpotlightText: {
        id: "contextual-reading-aids.changeboarding-spotlight.text",
        defaultMessage: "Remember, this feature works best when you select specific terms, acronyms, or internal project/team names."
    }
});
const $83df18abc582ef5a$export$1942ca99b3c33b66 = ({ contentId: contentId, onGotItClick: onGotItClick })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleOnClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'readingAidsSpotlightChangeboarding',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'readingAidsSpotlightGotItButton',
                attributes: {
                    contentId: contentId
                }
            }
        });
        onGotItClick();
    };
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Spotlight, {
        actions: [
            {
                text: intl.formatMessage($83df18abc582ef5a$var$i18n.changeboardingSpotlightGotItButton),
                onClick: handleOnClick
            }
        ],
        target: $83df18abc582ef5a$export$a21884ebed08a664,
        targetRadius: 4
    }, intl.formatMessage($83df18abc582ef5a$var$i18n.changeboardingSpotlightText));
};
module.exports["READING_AIDS_CHANGEBOARDING_SPOTLIGHT_ID"] = $83df18abc582ef5a$export$a21884ebed08a664;
module.exports["ReadingAidsChangeboardingSpotlight"] = $83df18abc582ef5a$export$1942ca99b3c33b66;

});

parcelRegister("7rLBD", function(module, exports) {

var $hpFQM = parcelRequire("hpFQM");

const $40851a06f2d6c64a$export$cd08f5c9e05f94dd = (contentId, cloudID, contentType)=>{
    if (!contentType) return '';
    return `ari:cloud:confluence:${cloudID}:${contentType}/${contentId}`;
};
const $40851a06f2d6c64a$export$8530183f316e301c = (activationId, cloudId)=>`ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
const $40851a06f2d6c64a$export$b381579634332aed = (curatedDefinition)=>{
    const curatedDefinitionReference = curatedDefinition.confluenceEntity;
    return {
        nlpResult: curatedDefinition.definition,
        uniqueSources: curatedDefinitionReference ? [
            {
                id: curatedDefinitionReference?.id || '',
                title: curatedDefinitionReference?.title || '',
                url: curatedDefinition.referenceUrl || '',
                type: curatedDefinitionReference?.type || '',
                product: 'Confluence',
                lastModified: '',
                iconUrl: '',
                spaceName: curatedDefinitionReference?.space?.name || '',
                spaceUrl: null
            }
        ] : [],
        nlpResultEditor: curatedDefinition.editor?.name ? {
            name: curatedDefinition.editor.name || '',
            id: curatedDefinition.editor.accountId || ''
        } : undefined,
        disclaimer: null,
        errorState: null,
        format: (0, $hpFQM.NLPSearchResultFormat).MARKDOWN
    };
};
const $40851a06f2d6c64a$export$479750843803fc13 = 5;
const $40851a06f2d6c64a$export$f600f3124ea5916b = (nodes)=>{
    const categories = new Map();
    try {
        nodes.forEach((node)=>{
            const curCategoryCount = categories.get(node.category);
            if (!!curCategoryCount) categories.set(node.category, curCategoryCount + 1);
            else categories.set(node.category, 1);
        });
    } catch  {
        return undefined;
    }
    return Object.fromEntries(categories);
};
module.exports["generatePageARI"] = $40851a06f2d6c64a$export$cd08f5c9e05f94dd;
module.exports["generateWorkspaceId"] = $40851a06f2d6c64a$export$8530183f316e301c;
module.exports["READING_AIDS_MAX_WORD_COUNT"] = $40851a06f2d6c64a$export$479750843803fc13;
module.exports["getHighlightCategories"] = $40851a06f2d6c64a$export$f600f3124ea5916b;

});

parcelRegister("hpFQM", function(module, exports) {
var $5a473958e6bef57b$export$e20550b618a28239 = /*#__PURE__*/ function(NLPSearchResultFormat) {
    NLPSearchResultFormat["PLAINTEXT"] = "PLAIN_TEXT";
    NLPSearchResultFormat["ADF"] = "ADF";
    NLPSearchResultFormat["JSON"] = "JSON";
    NLPSearchResultFormat["MARKDOWN"] = "MARKDOWN";
    return NLPSearchResultFormat;
}({});
module.exports["NLPSearchResultFormat"] = $5a473958e6bef57b$export$e20550b618a28239;

});

parcelRegister("bjVRl", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $d2a35dc366472da4$var$initialState = {
    portalContainerRef: null,
    autohighlightText: '',
    autohighlightContext: '',
    sessionId: '',
    autohighlightSelectionRect: {
        top: 0,
        left: 0,
        width: 0,
        height: 0
    },
    autohighlightHovered: false,
    showPopup: false,
    popupLoading: false,
    showSpotlight: false,
    existingMap: new Map(),
    lastAcronymReset: ()=>{},
    defineDefinitionOpen: false
};
const $d2a35dc366472da4$export$e324594224ef24da = {
    showAutohighlightPopup: ({ autohighlightText: autohighlightText, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, lastAcronymReset: lastAcronymReset, sessionId: sessionId })=>({ setState: setState })=>{
            setState({
                autohighlightText: autohighlightText,
                autohighlightContext: autohighlightContext,
                autohighlightSelectionRect: autohighlightSelectionRect,
                lastAcronymReset: lastAcronymReset,
                sessionId: sessionId,
                showPopup: true,
                popupLoading: true
            });
        },
    hideAutohighlightPopup: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                showPopup: false,
                popupLoading: false
            });
        },
    setDefineDefinitionOpen: ({ defineDefinitionOpen: defineDefinitionOpen })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                defineDefinitionOpen: defineDefinitionOpen
            });
        },
    setAutohighlightPopupLoaded: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                popupLoading: false
            });
        },
    setAutohighlightHovered: ({ autohighlightHovered: autohighlightHovered })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                autohighlightHovered: autohighlightHovered
            });
        },
    showAutohighlightSpotlight: ({ autohighlightSelectionRect: autohighlightSelectionRect })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                showSpotlight: true,
                autohighlightSelectionRect: autohighlightSelectionRect
            });
        },
    setPortalContainerRef: ({ portalContainerRef: portalContainerRef })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                portalContainerRef: portalContainerRef
            });
        }
};
const $d2a35dc366472da4$export$f24428a461500521 = (0, $8s9DV.createStore)({
    initialState: $d2a35dc366472da4$var$initialState,
    actions: $d2a35dc366472da4$export$e324594224ef24da,
    name: 'readingAidsStore'
});
const $d2a35dc366472da4$export$c6f45fcecbb3630d = (0, $kBr4q.createActionsHook)($d2a35dc366472da4$export$f24428a461500521);
const $d2a35dc366472da4$export$94639db5354ca53c = (0, $kBr4q.createStateHook)($d2a35dc366472da4$export$f24428a461500521);
module.exports["useReadingAidsActions"] = $d2a35dc366472da4$export$c6f45fcecbb3630d;
module.exports["useReadingAidsState"] = $d2a35dc366472da4$export$94639db5354ca53c;

});

parcelRegister("9oxdN", function(module, exports) {

var $h1PDd = parcelRequire("h1PDd");


var $iaK3p = parcelRequire("iaK3p");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $fEmGS = parcelRequire("fEmGS");


var $l1uFv = parcelRequire("l1uFv");


var $7W8i8 = parcelRequire("7W8i8");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery = (0, $iaK3p.default);
const $112f5732a615f62f$var$useFeatureDiscoveryMarkFeatureDiscoveredMutation = (0, $h1PDd.default);
const $112f5732a615f62f$var$logger = (0, $7W8i8.getLogger)('useFeatureDiscovery');
const $112f5732a615f62f$export$2dd355223baa0569 = 'com.atlassian.confluence.plugins.confluence-frontend-support';
const $112f5732a615f62f$var$updateCache = (_, { data: data })=>{
    const newMarkedFeature = data?.markFeatureDiscovered;
    if (!newMarkedFeature) return;
    const cachedFeatureData = (0, $l1uFv.readQueryInterop)({
        query: $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery,
        __callerPackage__: "feature-discovery"
    });
    if (!cachedFeatureData?.featureDiscovery) return;
    (0, $fEmGS.writeQueryInterop)({
        query: $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery,
        data: {
            featureDiscovery: cachedFeatureData.featureDiscovery.concat(newMarkedFeature)
        },
        __callerPackage__: "feature-discovery"
    });
};
const $112f5732a615f62f$var$getLocalOverrideValue = (featureKey)=>{
    try {
        if ((0, $17wUi.confluenceSessionStorageInstance).getItem((0, $9wGTI.fg)('confluence_browser_storage_prepended_keys') ? `${featureKey}-featureDiscoveryOverride` : `${(0, $1UApO.keys).FEATURE_DISCOVERY_OVERRIDE_PREFIX}-${featureKey}`)) return true;
    } catch (e) {
        $112f5732a615f62f$var$logger.error(e);
    }
    return false;
};
const $112f5732a615f62f$var$noop = ()=>{};
const $112f5732a615f62f$export$6de1a7573792d1a9 = (featureKey, skip)=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const skipFeatureDiscoveryQuery = !isLoggedIn || skip;
    const { data: data, loading: queryLoading, error: queryError } = (0, $jMyy4.useQueryInterop)($112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery, {
        skip: skipFeatureDiscoveryQuery,
        __callerPackage__: "feature-discovery"
    });
    const [markFeatureDiscovered, { loading: mutationLoading, error: mutationError }] = (0, $308Wd.useMutationInterop)($112f5732a615f62f$var$useFeatureDiscoveryMarkFeatureDiscoveredMutation, {
        variables: {
            featureKey: featureKey,
            pluginKey: $112f5732a615f62f$export$2dd355223baa0569
        },
        update: $112f5732a615f62f$var$updateCache,
        __callerPackage__: "feature-discovery"
    });
    const loading = queryLoading || mutationLoading;
    const error = queryError || mutationError;
    const showFeature = !loading && !error && !data?.featureDiscovery?.some((feature)=>feature?.pluginKey === $112f5732a615f62f$export$2dd355223baa0569 && feature?.featureKey === featureKey);
    const handleStop = (0, $cozmU.useCallback)(()=>{
        if (showFeature) // error is handled in the useMutation result
        markFeatureDiscovered().catch(()=>{});
    }, [
        showFeature,
        markFeatureDiscovered
    ]);
    if (skipFeatureDiscoveryQuery) return [
        false,
        $112f5732a615f62f$var$noop,
        undefined
    ];
    // this is for dev/testing, since we cant easily remove data from the featureDiscovery array
    const forceShowFeature = showFeature || $112f5732a615f62f$var$getLocalOverrideValue(featureKey);
    return [
        forceShowFeature,
        handleStop,
        error
    ];
};
module.exports["useFeatureDiscovery"] = $112f5732a615f62f$export$6de1a7573792d1a9;

});

parcelRegister("h1PDd", function(module, exports) {
/**
 * @generated SignedSource<<de9fe90553f5e4890bae7c7ad707e3ad>>
 * @relayHash 7e3a97b41907f84e881bf7535b1379ce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aded1ac8c4d8c5f52bbd0e95ce0857860d2f9ccb92e721ad18f7b30caef06081
const $fca31db58911eb73$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "featureKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pluginKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "featureKey",
                    "variableName": "featureKey"
                },
                {
                    "kind": "Variable",
                    "name": "pluginKey",
                    "variableName": "pluginKey"
                }
            ],
            "concreteType": "FeatureDiscoveryPayload",
            "kind": "LinkedField",
            "name": "markFeatureDiscovered",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pluginKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "featureKey"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7e3a97b41907f84e881bf7535b1379ce",
            "id": "aded1ac8c4d8c5f52bbd0e95ce0857860d2f9ccb92e721ad18f7b30caef06081",
            "metadata": {},
            "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
            "operationKind": "mutation",
            "text": "mutation useFeatureDiscoveryMarkFeatureDiscoveredMutation($featureKey:String!,$pluginKey:String!){markFeatureDiscovered(featureKey:$featureKey,pluginKey:$pluginKey){pluginKey,featureKey}}"
        }
    };
}();
$fca31db58911eb73$var$node.hash = "55ae5a7186fb2a98e37da374a9b9784e";
var $fca31db58911eb73$export$2e2bcd8739ae039 = $fca31db58911eb73$var$node;
module.exports["default"] = $fca31db58911eb73$export$2e2bcd8739ae039;

});

parcelRegister("iaK3p", function(module, exports) {
/**
 * @generated SignedSource<<77901a4d26c14ce3e165e61f1fbc7d81>>
 * @relayHash 5f15c23509e6cb7f2874b0f92de8a11b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8c70e28d771c617ecf7c58416cff6761443cf9b61782cdb47a1bb82fdf95ba9f
const $8d30006ecab20121$var$node = function() {
    var v0 = [
        {
            "concreteType": "DiscoveredFeature",
            "kind": "LinkedField",
            "name": "featureDiscovery",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pluginKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "featureKey"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "5f15c23509e6cb7f2874b0f92de8a11b",
            "id": "8c70e28d771c617ecf7c58416cff6761443cf9b61782cdb47a1bb82fdf95ba9f",
            "metadata": {},
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "operationKind": "query",
            "text": "query useFeatureDiscoveryFeatureDiscoveryQuery{featureDiscovery{pluginKey,featureKey}}"
        }
    };
}();
$8d30006ecab20121$var$node.hash = "8577be880df828fbee71c90a7701eddf";
var $8d30006ecab20121$export$2e2bcd8739ae039 = $8d30006ecab20121$var$node;
module.exports["default"] = $8d30006ecab20121$export$2e2bcd8739ae039;

});

parcelRegister("eDk57", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4aiCO = parcelRequire("4aiCO");


var $1mDVg = parcelRequire("1mDVg");

const $45dbb5af31f3f8d0$export$bc90850968906652 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1mDVg.IssueCreateSidePanelContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aiCO.IssueCreateWarningDialogContainer), null, children));
};
module.exports["SingleIssueCreateProvidersWrapper"] = $45dbb5af31f3f8d0$export$bc90850968906652;

});

parcelRegister("aiS08", function(module, exports) {
$parcel$export(module.exports, "ISSUE_CREATE_SIDE_PANEL_ID", () => (parcelRequire("1L1jV")).ISSUE_CREATE_SIDE_PANEL_ID);

var $jmjWc = parcelRequire("jmjWc");


var $1L1jV = parcelRequire("1L1jV");


const $8c03994ca3756429$export$808956d96594cb81 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "dU97j",
    name: "IssueCreateSidePanel",
    loader: async ()=>(await Promise.resolve((parcelRequire("1L1jV")))).IssueCreateSidePanel
});
module.exports["IssueCreateSidePanel"] = $8c03994ca3756429$export$808956d96594cb81;

});

parcelRegister("1L1jV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $9DHhW = parcelRequire("9DHhW");


var $29vMs = parcelRequire("29vMs");


var $cXLoX = parcelRequire("cXLoX");


var $7aRa9 = parcelRequire("7aRa9");


var $ai7NK = parcelRequire("ai7NK");


var $3yh4a = parcelRequire("3yh4a");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $98CLM = parcelRequire("98CLM");


var $kJYUO = parcelRequire("kJYUO");


var $1mDVg = parcelRequire("1mDVg");


var $eDk57 = parcelRequire("eDk57");


var $5Ew1A = parcelRequire("5Ew1A");


var $jwedr = parcelRequire("jwedr");


var $3AAT8 = parcelRequire("3AAT8");


var $hib1D = parcelRequire("hib1D");


var $6pbwW = parcelRequire("6pbwW");

const $7dea7a25aec9b259$export$3318bd9d18742c1e = 'issue-create-side-panel';
const $7dea7a25aec9b259$export$e760a8f02240cc6d = 'issue-create-side-panel';
const $7dea7a25aec9b259$export$d030b92b162b528d = 320;
const $7dea7a25aec9b259$var$sidePanelStyle = (0, $buxP3.xcss)({
    position: 'relative'
});
const $7dea7a25aec9b259$var$IssueCreateSidePanelComponent = ({ onClose: onClose, flags: flags })=>{
    const { showSidePanel: showSidePanel, hideSidePanel: hideSidePanel } = (0, $ai7NK.useSidePanelStateActions)();
    const { isWarningDialogOpen: isWarningDialogOpen, handleConfirm: handleConfirm, handleCancel: handleCancel } = (0, $jwedr.useGetWarningDialogActions)(onClose);
    const [state, actions] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { aiState: aiState, isCreatedWithAi: isCreatedWithAi, aiAnalyticsContext: aiAnalyticsContext, isCreatedFromActionItems: isCreatedFromActionItems } = state;
    const aiIssueCreationEnablement = (0, $1mDVg.useAiIssueCreationEnablementState)();
    const { trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $cXLoX.useAIEventsInstrumentation)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const shouldShowAiFooter = isCreatedWithAi && aiState !== 'error';
    const isAiLoading = aiState === 'loading';
    const handleOnClose = (0, $cozmU.useCallback)((isCreateSuccess)=>{
        if (isCreatedWithAi && !isCreateSuccess) trackAIInteractionDismiss({
            attributes: aiAnalyticsContext
        });
        if (!isCreateSuccess) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'confluenceHighlightIssueCreate',
                action: 'closed',
                actionSubject: 'modalDialog',
                actionSubjectId: 'linkCreate',
                type: 'ui',
                attributes: {
                    isManuallyCreated: !isCreatedWithAi,
                    isCreatedWithAi: isCreatedWithAi,
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    isAiLoading: isAiLoading,
                    aiEnablement: aiIssueCreationEnablement?.enablement,
                    isCreatedFromActionItems: isCreatedFromActionItems,
                    // We don't invoke table creation from highlighting a single row
                    isCreatedFromTable: false
                }
            }
        }).fire();
        hideSidePanel();
        onClose();
        actions.setAiState('idle');
    }, [
        isCreatedWithAi,
        hideSidePanel,
        onClose,
        actions,
        trackAIInteractionDismiss,
        aiAnalyticsContext,
        createAnalyticsEvent,
        state.pageMode,
        isAiLoading,
        aiIssueCreationEnablement?.enablement,
        state.hasEditPermission,
        isCreatedFromActionItems
    ]);
    const handleOnConfirm = (0, $cozmU.useCallback)(()=>{
        actions.setAiState('idle');
        handleConfirm();
    }, [
        actions,
        handleConfirm
    ]);
    (0, $cozmU.useEffect)(()=>{
        showSidePanel();
    }, [
        showSidePanel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        testId: $7dea7a25aec9b259$export$3318bd9d18742c1e,
        xcss: $7dea7a25aec9b259$var$sidePanelStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Ew1A.SidePanelWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kJYUO.IssueCreateAiLoadingSidebar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6pbwW.IssueCreateSidePanelHeader), {
        onClose: handleOnClose
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3AAT8.IssueCreateSidePanelBody), {
        onClose: handleOnClose,
        flags: flags
    }), shouldShowAiFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hib1D.IssueCreateSidePanelFooter), null))), isWarningDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $98CLM.IssueCreateWarningDialog), {
        onCancel: handleCancel,
        onConfirm: handleOnConfirm,
        issuesCount: 1
    }));
};
const $7dea7a25aec9b259$var$IssueCreateSidePanelComponentWithProvider = ({ onClose: onClose, flags: flags })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eDk57.SingleIssueCreateProvidersWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $29vMs.AIEventsInstrumentationProvider), {
        config: {
            // Required configruation
            product: 'confluence',
            subproduct: 'jira',
            aiFeatureName: 'confluenceAiWorkCreation',
            proactiveGeneratedAI: 0,
            userGeneratedAI: 1,
            // Optional configuration
            source: 'confluenceHighlightIssueCreate',
            skipAISessionValidation: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7dea7a25aec9b259$var$IssueCreateSidePanelComponent, {
        onClose: onClose,
        flags: flags
    })));
};
const $7dea7a25aec9b259$var$IssueCreateSidePanelWithFlags = (0, $7aRa9.withFlags)($7dea7a25aec9b259$var$IssueCreateSidePanelComponentWithProvider);
const $7dea7a25aec9b259$var$IssueCreateSidePanelWithErrorBoundary = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).INTEGRATIONS
})($7dea7a25aec9b259$var$IssueCreateSidePanelWithFlags);
const $7dea7a25aec9b259$export$808956d96594cb81 = (0, $3yh4a.componentWithFG)('jira_ai_aiwc_in_confluence_set_up_error_boundary', $7dea7a25aec9b259$var$IssueCreateSidePanelWithErrorBoundary, $7dea7a25aec9b259$var$IssueCreateSidePanelWithFlags);
module.exports["sidePanelTestId"] = $7dea7a25aec9b259$export$3318bd9d18742c1e;
module.exports["ISSUE_CREATE_SIDE_PANEL_ID"] = $7dea7a25aec9b259$export$e760a8f02240cc6d;
module.exports["ISSUE_CREATE_SIDE_PANEL_WIDTH"] = $7dea7a25aec9b259$export$d030b92b162b528d;
module.exports["IssueCreateSidePanel"] = $7dea7a25aec9b259$export$808956d96594cb81;

});

parcelRegister("ai7NK", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $30dd91193859fc54$export$4f97fa3245bb0e31 = {
    isSidePanelOpen: false
};
const $30dd91193859fc54$export$e324594224ef24da = {
    showSidePanel: ()=>({ setState: setState })=>{
            setState({
                isSidePanelOpen: true
            });
        },
    hideSidePanel: ()=>({ setState: setState })=>{
            setState({
                isSidePanelOpen: false
            });
        }
};
const $30dd91193859fc54$var$Store = (0, $8s9DV.createStore)({
    initialState: $30dd91193859fc54$export$4f97fa3245bb0e31,
    actions: $30dd91193859fc54$export$e324594224ef24da,
    name: 'SidePanelState'
});
const $30dd91193859fc54$export$d4bcf572fecd48f5 = (0, $kBr4q.createActionsHook)($30dd91193859fc54$var$Store);
const $30dd91193859fc54$export$f3f6191f6fee6235 = (0, $kBr4q.createStateHook)($30dd91193859fc54$var$Store, {
    selector: (state)=>state.isSidePanelOpen
});
module.exports["useSidePanelStateActions"] = $30dd91193859fc54$export$d4bcf572fecd48f5;
module.exports["useIsSidePanelOpen"] = $30dd91193859fc54$export$f3f6191f6fee6235;

});

parcelRegister("3yh4a", function(module, exports) {

var $8YePs = parcelRequire("8YePs");


var $9wGTI = parcelRequire("9wGTI");

const $d415184962066c9b$export$cf56d0f54cfcce4 = (gateName, ComponentTrue, ComponentFalse)=>(0, $8YePs.componentWithCondition)(()=>(0, $9wGTI.fg)(gateName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $d415184962066c9b$export$cf56d0f54cfcce4;

});

parcelRegister("8YePs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $b3ddd992633db411$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>// @ts-expect-error - Added during @types/react@~18.3.24 upgrade.
        condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $b3ddd992633db411$export$6e8ea24b15199873;

});

parcelRegister("kJYUO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $1mDVg = parcelRequire("1mDVg");


var $hq2Sz = parcelRequire("hq2Sz");


var $1uJpg = parcelRequire("1uJpg");

const $e4ab54f04ea47f96$export$dcc317fc4f9228b3 = ({ children: children })=>{
    const [{ aiState: aiState, pageMode: pageMode, hasEditPermission: hasEditPermission }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const [{ isCreatedFromActionItems: isCreatedFromActionItems, isCreatedFromTable: isCreatedFromTable }] = (0, $hq2Sz.useBulkCreateContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const aiIssueCreationEnablement = (0, $1mDVg.useAiIssueCreationEnablementState)();
    const isAiLoading = aiState === 'loading';
    const aiEnablement = aiIssueCreationEnablement?.enablement;
    (0, $cozmU.useEffect)(()=>{
        if (isAiLoading) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'AI loading state',
                source: 'confluenceHighlightIssueCreate',
                attributes: {
                    aiEnablement: aiEnablement,
                    pageMode: pageMode,
                    hasEditPermission: hasEditPermission,
                    isCreatedFromActionItems: isCreatedFromActionItems,
                    isCreatedFromTable: isCreatedFromTable
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isAiLoading,
        aiEnablement,
        pageMode,
        hasEditPermission,
        isCreatedFromActionItems,
        isCreatedFromTable
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1uJpg.RainbowLoadingSidebar), {
        isShown: isAiLoading
    }, children);
};
module.exports["IssueCreateAiLoadingSidebar"] = $e4ab54f04ea47f96$export$dcc317fc4f9228b3;

});

parcelRegister("3AAT8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $9DHhW = parcelRequire("9DHhW");


var $iNyje = parcelRequire("iNyje");


var $cXLoX = parcelRequire("cXLoX");


var $bQm3c = parcelRequire("bQm3c");


var $9wGTI = parcelRequire("9wGTI");


var $1mDVg = parcelRequire("1mDVg");


var $5FJ5W = parcelRequire("5FJ5W");


var $3E5yu = parcelRequire("3E5yu");


var $1Q0l6 = parcelRequire("1Q0l6");


var $9K9na = parcelRequire("9K9na");


var $2ay9q = parcelRequire("2ay9q");


var $bImpr = parcelRequire("bImpr");


var $kcLnq = parcelRequire("kcLnq");


var $bZC8A = parcelRequire("bZC8A");


var $jE0Gg = parcelRequire("jE0Gg");


var $aXkRG = parcelRequire("aXkRG");


var $dAg4H = parcelRequire("dAg4H");

const $889e5fc4cfbacead$var$aiContentWrapperBaseStyles = (0, $buxP3.xcss)({
    display: 'inherit',
    flexGrow: 1
});
const $889e5fc4cfbacead$var$aiContentWrapperHiddenStyles = (0, $buxP3.xcss)({
    display: 'none'
});
const $889e5fc4cfbacead$export$b5988d25d9f45521 = ({ onClose: onClose, flags: flags })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [state, actions] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const { contentId: contentId, contentType: contentType, summary: summary, descriptionAdf: descriptionAdf, aiState: aiState, isCreatedWithAi: isCreatedWithAi, highlightedText: highlightedText, selectedAdf: selectedAdf, insertStorageFragmentRequestPayload: insertStorageFragmentRequestPayload, totalRetries: totalRetries, firstAttempt: firstAttempt, aiAnalyticsContext: aiAnalyticsContext, currentSiteSelection: currentSiteSelection, currentProjectSelection: currentProjectSelection, isGicIframeReady: isGicIframeReady, isCreatedFromActionItems: isCreatedFromActionItems, editorAPI: editorAPI } = state;
    const aiIssueCreationEnablement = (0, $1mDVg.useAiIssueCreationEnablementState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultError: trackAIResultError, trackAIResultView: trackAIResultView, trackAIResultAction: trackAIResultAction } = (0, $cXLoX.useAIEventsInstrumentation)();
    (0, $dAg4H.useIsAIIssueCreationAllowed)({
        contentId: contentId,
        isBulkCreate: false
    });
    const aiError = aiState === 'error';
    // no need to override if it's the same site
    const persistedOverrideCloudId = (0, $2ay9q.getPersistedOverrideCloudId)();
    const [overrideCloudIdForSitePicker, setOverrideCloudIdForSitePicker] = (0, $cozmU.useState)(persistedOverrideCloudId !== cloudId ? persistedOverrideCloudId : undefined);
    const [overrideProjectId, setOverrideProjectId] = (0, $cozmU.useState)(undefined);
    const [showCreateWithAiToggle, setShowCreateWithAiToggle] = (0, $cozmU.useState)(false);
    const defaultErrorMessage = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).singleCreateAiErrorDescriptionIssueTermRefreshRebrandToRovo : (0, $3E5yu.messages).singleCreateAiErrorDescriptionRebrandToRovo;
    const [errorMessage, setErrorMessage] = (0, $cozmU.useState)(defaultErrorMessage);
    const [errorMessageValues, setErrorMessageValues] = (0, $cozmU.useState)();
    const [hideTryAgain, setHideTryAgain] = (0, $cozmU.useState)(false);
    (0, $jE0Gg.useMessageListener)();
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'linkCreateScreen',
                attributes: {
                    isManuallyCreated: !isCreatedWithAi,
                    isCreatedWithAi: isCreatedWithAi,
                    isCreatedFromActionItems: isCreatedFromActionItems,
                    // We don't invoke table creation from highlighting a single row
                    isCreatedFromTable: false,
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    aiEnablement: aiIssueCreationEnablement?.enablement
                },
                source: 'confluenceHighlightIssueCreate'
            }
        }).fire();
    }, [
        isCreatedWithAi,
        createAnalyticsEvent,
        aiIssueCreationEnablement?.enablement,
        state.pageMode,
        state.hasEditPermission,
        isCreatedFromActionItems
    ]);
    const isAiLoading = aiState === 'loading';
    const triggerFlag = (0, $9K9na.useTriggerFlagIssueCreated)(flags);
    const handleTryAgain = (0, $cozmU.useCallback)(()=>{
        actions.setTotalRetries();
        actions.setFirstAttempt(false);
        actions.setAiState('idle');
        // trigger a new AI interaction init event retries
        trackAIInteractionInit({
            attributes: {
                pageMode: state.pageMode,
                totalRetries: totalRetries + 1,
                firstAttempt: false,
                aiEnablement: aiIssueCreationEnablement?.enablement
            }
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'issueCreateSidePanelErrorScreen',
                action: 'retry',
                actionSubject: 'issueCreate',
                attributes: {
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    createManually: !isCreatedWithAi,
                    tryAgainWithAi: isCreatedWithAi,
                    totalRetries: totalRetries + 1,
                    firstAttempt: false,
                    ...aiAnalyticsContext
                }
            }
        }).fire();
    }, [
        actions,
        trackAIInteractionInit,
        totalRetries,
        aiIssueCreationEnablement?.enablement,
        createAnalyticsEvent,
        state.pageMode,
        isCreatedWithAi,
        aiAnalyticsContext,
        state.hasEditPermission
    ]);
    const handleCreateManually = (0, $cozmU.useCallback)(()=>{
        actions.setIsCreatedWithAi(false);
        actions.setAiState('idle');
        setShowCreateWithAiToggle(false);
    }, [
        actions
    ]);
    const handleCreateWithAi = (0, $cozmU.useCallback)(()=>{
        actions.setIsCreatedWithAi(true);
        actions.setAiState('loading');
        setShowCreateWithAiToggle(false);
    }, [
        actions
    ]);
    const handleCreateManuallyAfterError = (0, $cozmU.useCallback)(()=>{
        actions.setTotalRetries();
        actions.setFirstAttempt(false);
        actions.setIsCreateManuallyPressed(true);
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'issueCreateSidePanelErrorScreen',
                action: 'retry',
                actionSubject: 'issueCreate',
                attributes: {
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    createManually: true,
                    tryAgainWithAi: false,
                    totalRetries: totalRetries + 1,
                    firstAttempt: false,
                    ...aiAnalyticsContext
                }
            }
        }).fire();
        handleCreateManually();
    }, [
        actions,
        createAnalyticsEvent,
        state.pageMode,
        state.hasEditPermission,
        totalRetries,
        aiAnalyticsContext,
        handleCreateManually
    ]);
    const onIssueCreateInit = (0, $cozmU.useCallback)(()=>{
        setShowCreateWithAiToggle(aiIssueCreationEnablement?.isEnabled ?? false);
        /*
     * When ConfluenceAI=OFF & JiraAI=ON this component will manually create the issue first until
     * selected site & project info is available to check Jira's AI enablement.  If JiraAI=ON then
     * we can setIsCreatedWithAi to what the user's personal AI enablement to trigger a rerender.
     */ if (aiIssueCreationEnablement?.isEnabled) actions.setIsCreatedWithAi((0, $2ay9q.getIsCreateIssueWithAiEnabledByUser)());
        else actions.setIsCreatedWithAi(false);
        if (!(0, $2ay9q.getIsCreateIssueWithAiEnabledByUser)()) return;
        /*
     * requiresComponentChange is important since we are switching between manaul create (GicAnywhere) and
     * ConfluenceAiIssueCreate (which uses GicAnywhere under the hood).  The GicAnywhere has limitations where
     * changes to overrideCloudId after initial load can cause iframe rendering issues.  A component swap happens only when
     * the isCreatedWithAi state is changed so we can bundle these prop updates together.
     */ const requiresComponentChange = aiIssueCreationEnablement?.isEnabled !== isCreatedWithAi;
        if (requiresComponentChange) {
            setOverrideCloudIdForSitePicker(currentSiteSelection);
            setOverrideProjectId(currentProjectSelection?.selectedProjectId);
            // During component switch the iframe will be replaced and there is no event for this.
            // We need to reset it here manually.
            actions.setIsGicIframeReady(false);
        }
        if (currentSiteSelection && currentSiteSelection !== overrideCloudIdForSitePicker) setOverrideProjectId(currentProjectSelection?.selectedProjectId);
    }, [
        aiIssueCreationEnablement?.isEnabled,
        isCreatedWithAi,
        currentSiteSelection,
        overrideCloudIdForSitePicker,
        actions,
        currentProjectSelection?.selectedProjectId
    ]);
    const onAiIssueCreateInit = (0, $cozmU.useCallback)(()=>{
        onIssueCreateInit();
        const analyticAttributes = {
            attributes: {
                ...aiAnalyticsContext,
                aiEnablement: aiIssueCreationEnablement?.enablement,
                pageMode: state.pageMode,
                hasEditPermission: state.hasEditPermission
            }
        };
        trackAIInteractionInit(analyticAttributes);
        trackAIResultView({
            actionSubjectId: 'aiIssueCreatOnInitComplete',
            ...analyticAttributes
        });
    }, [
        onIssueCreateInit,
        aiAnalyticsContext,
        aiIssueCreationEnablement?.enablement,
        state.pageMode,
        trackAIInteractionInit,
        trackAIResultView,
        state.hasEditPermission
    ]);
    const isSuggestedIssuesErrorMessage = (error)=>{
        return error && typeof error === 'object' && 'message_template' in error;
    };
    const onFailure = (0, $cozmU.useCallback)((error)=>{
        // reset
        if (hideTryAgain) {
            setHideTryAgain(false);
            setErrorMessage((0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).singleCreateAiErrorDescriptionIssueTermRefreshRebrandToRovo : (0, $3E5yu.messages).singleCreateAiErrorDescriptionRebrandToRovo);
            setErrorMessageValues({});
        }
        if (isSuggestedIssuesErrorMessage(error)) {
            const aiIssueCreateError = (0, $bZC8A.handleAiIssueCreateError)(error);
            if (aiIssueCreateError !== undefined) {
                setErrorMessage(aiIssueCreateError.errorMessage);
                setErrorMessageValues(aiIssueCreateError.errorMessageValues);
                setHideTryAgain(aiIssueCreateError.hideTryAgain);
            }
        }
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'confluenceHighlightIssueCreate',
                action: 'error',
                actionSubject: 'globalIssueCreate',
                attributes: {
                    isManuallyCreated: !isCreatedWithAi,
                    isCreatedWithAi: isCreatedWithAi,
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    error: error,
                    aiEnablement: aiIssueCreationEnablement?.enablement
                }
            }
        }).fire();
        if (isCreatedWithAi) trackAIResultError({
            aiErrorMessage: error.message
        }, {
            attributes: {
                pageMode: state.pageMode,
                hasEditPermission: state.hasEditPermission,
                totalRetries: totalRetries,
                firstAttempt: firstAttempt,
                ...aiAnalyticsContext
            }
        });
    }, [
        hideTryAgain,
        createAnalyticsEvent,
        isCreatedWithAi,
        state.pageMode,
        state.hasEditPermission,
        aiIssueCreationEnablement?.enablement,
        trackAIResultError,
        totalRetries,
        firstAttempt,
        aiAnalyticsContext
    ]);
    const onSuccess = (0, $cozmU.useCallback)((payload)=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'confluenceHighlightIssueCreate',
                action: 'created',
                actionSubject: 'issue',
                actionSubjectId: 'confluenceIssueCreate',
                attributes: {
                    isManuallyCreated: !isCreatedWithAi,
                    isCreatedWithAi: isCreatedWithAi,
                    // We don't invoke table creation from highlighting a single row
                    isCreatedFromTable: false,
                    isCreatedFromActionItems: isCreatedFromActionItems,
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    aiEnablement: aiIssueCreationEnablement?.enablement
                }
            }
        }).fire();
        if (isCreatedWithAi) trackAIResultAction('issue created', {
            attributes: {
                pageMode: state.pageMode,
                hasEditPermission: state.hasEditPermission,
                isCreatedFromActionItems: isCreatedFromActionItems,
                // We don't invoke table creation from highlighting a single row
                isCreatedFromTable: false,
                totalRetries: totalRetries,
                firstAttempt: firstAttempt,
                issueId: payload?.issueId || '',
                aiEnablement: aiIssueCreationEnablement?.enablement,
                ...aiAnalyticsContext
            }
        });
        triggerFlag(payload, 'success-circle', (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).sidePanelSingleIssueCreateSuccessFlagTitleIssueTermRefresh : (0, $3E5yu.messages).sidePanelSingleIssueCreateSuccessFlagTitle);
        // Save the cloud id in localStorage if an issue is created
        (0, $2ay9q.saveCloudIdToLocalStorage)(payload);
        if (insertStorageFragmentRequestPayload && state.hasEditPermission) {
            insertStorageFragmentRequestPayload.xmlModification = isCreatedFromActionItems && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items') ? (0, $1Q0l6.constructBreakContainerTag)((0, $1Q0l6.constructSmartlinkTag)(payload.link)) : (0, $1Q0l6.constructSmartlinkTag)(payload.link);
            (0, $1Q0l6.updateLastFetchTimeIfNotViewMode)(insertStorageFragmentRequestPayload, state.pageMode);
            const insertPromise = (0, $1Q0l6.insertSingleWorkItemToEndOfSelection)({
                insertStorageFragmentRequestPayload: insertStorageFragmentRequestPayload,
                pageMode: state.pageMode ?? (0, $1mDVg.PageMode).VIEW,
                selectedAdf: selectedAdf,
                editorAPI: editorAPI,
                workItemUrl: payload.link
            });
            insertPromise.then((data)=>{
                // There is a case where the API response is OK, but the response data is false.
                // When this happens, the backend has trouble inserting the ticket to the page and we should show an error toast.
                if (data === false) throw new Error('Failed to insert storage fragment');
                return createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        source: 'confluenceHighlightIssueCreate',
                        action: 'created',
                        actionSubject: 'link',
                        actionSubjectId: 'confluenceIssueCreate',
                        attributes: {
                            isManuallyCreated: !isCreatedWithAi,
                            isCreatedWithAi: isCreatedWithAi,
                            pageMode: state.pageMode,
                            hasEditPermission: state.hasEditPermission
                        }
                    }
                }).fire();
            }).then(()=>{
                // Refresh the page only if the current mode is VIEW, as other modes receive live updates.
                if (state.pageMode === (0, $1mDVg.PageMode).VIEW) (0, $1Q0l6.refreshPageWithTimeout)();
            }).catch((_error)=>triggerFlag(payload, 'error', (0, $3E5yu.messages).sidePanelIssueCreateInsertionFailed));
        }
    }, [
        createAnalyticsEvent,
        isCreatedWithAi,
        isCreatedFromActionItems,
        state.pageMode,
        state.hasEditPermission,
        aiIssueCreationEnablement?.enablement,
        triggerFlag,
        insertStorageFragmentRequestPayload,
        selectedAdf,
        editorAPI,
        trackAIResultAction,
        totalRetries,
        firstAttempt,
        aiAnalyticsContext
    ]);
    const handleStateChange = (0, $cozmU.useCallback)((state, source)=>{
        // Keep loading animation active when get Confluence page completes but field suggestions are still loading
        if (source === 'aiIssueCreateGetConfluencePageState' && (state === 'idle' || state === 'loading')) return;
        actions.setAiState(state);
    }, [
        actions
    ]);
    const onAiToggleChange = (0, $cozmU.useCallback)((enabled)=>{
        if (enabled) {
            trackAIInteractionInit({
                attributes: {
                    pageMode: state.pageMode,
                    hasEditPermission: state.hasEditPermission,
                    aiEnablement: aiIssueCreationEnablement?.enablement
                }
            });
            handleCreateWithAi();
        } else handleCreateManually();
    }, [
        trackAIInteractionInit,
        state.pageMode,
        state.hasEditPermission,
        aiIssueCreationEnablement?.enablement,
        handleCreateWithAi,
        handleCreateManually
    ]);
    if (aiError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aXkRG.WorkItemCreationError), {
        creationSource: "confluenceHighlightIssueCreate",
        errorMessage: errorMessage,
        errorMessageValues: hideTryAgain ? errorMessageValues : undefined,
        onTryAgain: hideTryAgain ? undefined : handleTryAgain,
        onCreateManually: handleCreateManuallyAfterError,
        isCreatedWithAi: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, !isAiLoading && isGicIframeReady && showCreateWithAiToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bImpr.IssueCreateWithAiToggle), {
        onChange: onAiToggleChange
    }), isCreatedWithAi ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isAiLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5FJ5W.IssueCreateAiLoading), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: [
            $889e5fc4cfbacead$var$aiContentWrapperBaseStyles,
            isAiLoading && $889e5fc4cfbacead$var$aiContentWrapperHiddenStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kcLnq.ConfluenceAiIssueCreate), {
        cloudId: cloudId,
        contentType: contentType,
        pageId: contentId,
        highlightedTextAdf: highlightedText,
        consumer: "confluence-highlight-issue-create-ai",
        onInit: onAiIssueCreateInit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onClose: onClose,
        onStateChange: handleStateChange,
        overrideCloudIdForSitePicker: overrideCloudIdForSitePicker,
        overrideProjectIdForProjectPicker: overrideProjectId,
        setAiAnalyticsContext: actions.setAiAnalyticsContext,
        aIIssueCreationEnablement: aiIssueCreationEnablement
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iNyje.GicAnywhere), {
        cloudId: cloudId,
        consumer: "confluence-highlight-issue-create",
        onInit: onIssueCreateInit,
        onSuccess: onSuccess,
        onClose: onClose,
        onFailure: onFailure,
        summary: summary,
        descriptionAdf: descriptionAdf,
        overrideCloudId: overrideCloudIdForSitePicker,
        isPayloadReady: true,
        projectId: overrideProjectId
    }));
};
module.exports["IssueCreateSidePanelBody"] = $889e5fc4cfbacead$export$b5988d25d9f45521;

});

parcelRegister("iNyje", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $6e6HL = parcelRequire("6e6HL");


var $9DHhW = parcelRequire("9DHhW");


var $eKMV3 = parcelRequire("eKMV3");


var $w6R6I = parcelRequire("w6R6I");


var $RfroO = parcelRequire("RfroO");


var $cXtTj = parcelRequire("cXtTj");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $b8pma = parcelRequire("b8pma");


var $lfoFx = parcelRequire("lfoFx");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $lQXDC = parcelRequire("lQXDC");

var $hcOES = parcelRequire("hcOES");

var $jYwtP = parcelRequire("jYwtP");


var $7rqhv = parcelRequire("7rqhv");


var $d62s5 = parcelRequire("d62s5");


var $5TKGH = parcelRequire("5TKGH");


var $iXoLm = parcelRequire("iXoLm");


var $hRkxy = parcelRequire("hRkxy");


var $gkYOG = parcelRequire("gkYOG");

const $386fe214b22f2cd3$var$phases = {
    loading: 'loading',
    timeout: 'timeout',
    error: 'error',
    idle: 'idle'
};
const $386fe214b22f2cd3$export$9af19a1ca8685214 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5TKGH.AnalyticsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lQXDC.ContextWrapper), {
        sourceType: (0, $jYwtP.MODAL),
        sourceName: "gicAnywhere"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($386fe214b22f2cd3$export$c43a9e8a05acb520, props)));
};
const $386fe214b22f2cd3$var$styles = {
    hiddenDisplay: "_1e0cglyw",
    gicAnywhere: "_1bsb1osq _4t3i1osq",
    loadingScreen: "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _y3gn1h6o"
};
const $386fe214b22f2cd3$export$c43a9e8a05acb520 = ({ cloudId: cloudId, overrideCloudId: overrideCloudId, configuration: configuration, summary: summary, assignee: assignee, descriptionAdf: descriptionAdf, consumer: consumer, timeoutMs: timeoutMs = (0, $hRkxy.DEFAULT_TIMEOUT), onInit: onInit, onSuccess: onSuccess, onFailure: onFailure, onClose: onClose, onTimeout: onTimeout, parentIssueId: parentIssueId, projectId: projectId, issueTypeId: issueTypeId, issueTypes: issueTypes, isPayloadReady: isPayloadReady = false, additionalMappedFields: additionalMappedFields, baseUrlForAvailableSites: baseUrlForAvailableSites, onSaveEditsWithoutIssueCreation: onSaveEditsWithoutIssueCreation })=>{
    const { availableSites: availableSites, domainName: domainName, isOverrideSiteAvailable: isOverrideSiteAvailable } = (0, $iXoLm.useGetDomainAndAvailableSites)({
        cloudId: cloudId,
        overrideCloudId: overrideCloudId,
        baseUrlForAvailableSites: baseUrlForAvailableSites
    });
    const displaySitePicker = availableSites && availableSites.length > 1;
    const [phase, setPhase] = (0, $cozmU.useState)($386fe214b22f2cd3$var$phases.loading);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        const timeout = (()=>{
            switch(phase){
                case $386fe214b22f2cd3$var$phases.loading:
                    return setTimeout(()=>{
                        (0, $hcOES.fireOperationalAnalytics)(createAnalyticsEvent({}), 'globalIssueCreateEmbed timedOut', {
                            consumer: consumer,
                            timeoutMs: timeoutMs
                        });
                        setPhase($386fe214b22f2cd3$var$phases.timeout);
                        onTimeout?.();
                    }, timeoutMs);
                case $386fe214b22f2cd3$var$phases.timeout:
                    // if timeoutMs passes again after initial timeout, assume GIC is not loading and set to error state
                    return setTimeout(()=>{
                        (0, $hcOES.fireOperationalAnalytics)(createAnalyticsEvent({}), 'globalIssueCreateEmbed error', {
                            consumer: consumer,
                            timeoutMs: timeoutMs * 2
                        });
                        setPhase($386fe214b22f2cd3$var$phases.error);
                        onFailure(new Error('GIC has timed out'));
                    }, timeoutMs);
            }
        })(); // set Timeout for loading, reset for any other state.
        return ()=>timeout && clearTimeout(timeout);
    }, [
        consumer,
        createAnalyticsEvent,
        onFailure,
        onTimeout,
        phase,
        timeoutMs
    ]); // we mimic "external callback" for our needs
    const onGICReady = (0, $cozmU.useCallback)(()=>{
        setPhase($386fe214b22f2cd3$var$phases.idle);
        return {
            summary: summary ?? 'No summary provided',
            descriptionAdf: descriptionAdf || (0, $6e6HL.getEmptyADF)(),
            projectId: projectId,
            parentIssueId: parentIssueId,
            issueTypeId: issueTypeId,
            issueTypes: issueTypes?.join(','),
            assignee: assignee,
            fieldData: additionalMappedFields
        };
    }, [
        summary,
        descriptionAdf,
        projectId,
        parentIssueId,
        issueTypeId,
        issueTypes,
        assignee,
        additionalMappedFields
    ]);
    const renderPhaseInformation = (0, $cozmU.useMemo)(()=>{
        switch(phase){
            case $386fe214b22f2cd3$var$phases.timeout:
            case $386fe214b22f2cd3$var$phases.loading:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                    testId: "gic-anywhere-loading",
                    xcss: (0, $w6R6I.cx)($386fe214b22f2cd3$var$styles.gicAnywhere, $386fe214b22f2cd3$var$styles.loadingScreen)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
                    size: "large"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, formatMessage(phase === $386fe214b22f2cd3$var$phases.timeout ? (0, $gkYOG.messages).iFrameSlowLoading : (0, $gkYOG.messages).iFrameLoading, {
                    br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("br", null)
                })));
            case $386fe214b22f2cd3$var$phases.error:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                    testId: "gic-anywhere-error",
                    xcss: $386fe214b22f2cd3$var$styles.gicAnywhere
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $RfroO.default), {
                    header: formatMessage((0, $gkYOG.messages).errorHeader),
                    description: formatMessage((0, $gkYOG.messages).errorBody),
                    primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
                        onClick: ()=>{
                            onClose();
                        },
                        href: domainName || '/',
                        target: "_blank",
                        appearance: "primary"
                    }, formatMessage((0, $gkYOG.messages).openInJiraButton)),
                    imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($7rqhv))),
                    imageWidth: (0, $hRkxy.MAX_ERROR_IMAGE_WIDTH),
                    maxImageWidth: (0, $hRkxy.MAX_ERROR_IMAGE_WIDTH),
                    maxImageHeight: (0, $hRkxy.MAX_ERROR_IMAGE_HEIGHT)
                }));
            default:
                return undefined;
        }
    }, [
        phase,
        formatMessage,
        domainName,
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderPhaseInformation, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "gic-anywhere-iframe-loading",
        hold: phase === $386fe214b22f2cd3$var$phases.loading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: phase !== $386fe214b22f2cd3$var$phases.idle ? $386fe214b22f2cd3$var$styles.hiddenDisplay : $386fe214b22f2cd3$var$styles.gicAnywhere
    }, domainName !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($386fe214b22f2cd3$export$ae3b6dcb03669e81, {
        domainName: domainName,
        consumer: consumer,
        onGICReady: onGICReady,
        onInit: onInit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onClose: onClose,
        configuration: configuration,
        displaySitePicker: displaySitePicker,
        isPayloadReady: isPayloadReady,
        overrideCloudId: isOverrideSiteAvailable ? overrideCloudId : undefined,
        ...(0, $cXtTj.default).getExperimentValue('jira-aifc-workflow-resumption-ui-updates', 'isEnabled', false, {
            fireExperimentExposure: false
        }) ? {
            onSaveEditsWithoutIssueCreation: onSaveEditsWithoutIssueCreation
        } : {}
    })));
};
const $386fe214b22f2cd3$export$ae3b6dcb03669e81 = ({ onGICReady: onGICReady, consumer: consumer, domainName: domainName, overrideCloudId: overrideCloudId, onClose: onClose, onFailure: onFailure, onSuccess: onSuccess, onInit: onInit, configuration: configuration, displaySitePicker: displaySitePicker = true, isPayloadReady: isPayloadReady = false, onSaveEditsWithoutIssueCreation: onSaveEditsWithoutIssueCreation })=>{
    (0, $6cFsl.di)($386fe214b22f2cd3$export$b32b5f1ee4493319);
    const iframeRef = (0, $cozmU.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const [isCreateSuccess, setIsCreateSuccess] = (0, $cozmU.useState)(false);
    const [isGicReady, setIsGicReady] = (0, $cozmU.useState)(false);
    const isGicReadyRef = (0, $cozmU.useRef)(isGicReady); // we will react on this event only once
    // we dont want to reattach handlers on every render
    const onGICReadyRef = (0, $cozmU.useRef)(onGICReady);
    onGICReadyRef.current = onGICReady;
    const params = (0, $cozmU.useMemo)(()=>({
            product: consumer,
            actionSource: 'issue-create-anywhere-embed'
        }), [
        consumer
    ]); // Create a debounced version of onInit that will only execute the latest call after 2 seconds
    const debouncedOnInit = (0, $cozmU.useMemo)(()=>{
        if (!onInit) return undefined;
        return (0, $5TKGH.debounce)(()=>onInit(), 2000);
    }, [
        onInit
    ]); // Cleanup the debounced function on unmount
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            const debouncedFn = debouncedOnInit; // Only call cancel if debouncedOnInit is actually a debounced function
            if (debouncedFn && typeof debouncedFn.cancel === 'function') debouncedFn.cancel();
        };
    }, [
        debouncedOnInit
    ]);
    (0, $cozmU.useEffect)(()=>{
        const messageHandler = async (message)=>{
            const iframe = iframeRef.current?.contentWindow;
            if (!iframe) return;
            const eventName = message?.data?.event;
            const event = createAnalyticsEvent({});
            switch(eventName){
                case 0, $d62s5.JIRA_EMBED_ISSUE_CREATE_READY:
                    (0, $hcOES.fireOperationalAnalytics)(event, 'globalIssueCreateEmbed initialised', {
                        consumer: consumer
                    });
                    setIsGicReady(true);
                    break;
                case 0, $d62s5.JIRA_EMBED_ISSUE_CREATE_SUCCESS:
                    setIsCreateSuccess(true);
                    onSuccess(message.data.payload);
                    (0, $hcOES.fireTrackAnalytics)(event, 'globalIssueCreateEmbed succeeded', {
                        consumer: consumer
                    });
                    break;
                case 0, $d62s5.JIRA_EMBED_ISSUE_CREATE_FAILURE:
                    onFailure(new Error('issueCreate failed to save'));
                    (0, $hcOES.fireOperationalAnalytics)(event, 'globalIssueCreateEmbed failed', {
                        consumer: consumer
                    });
                    break;
                case 0, $d62s5.JIRA_EMBED_ISSUE_CREATE_CLOSE:
                    onClose(isCreateSuccess); // GIC sends a closeEvent even when created succesfully. Hence
                    // checking if no issue was created
                    if (!isCreateSuccess) (0, $hcOES.fireUIAnalytics)(event, 'globalIssueCreateEmbed closed', {
                        consumer: consumer
                    });
                    break;
                case 0, $d62s5.JIRA_EMBED_ISSUE_SAVE_WITHOUT_CREATION:
                    if ((0, $cXtTj.default).getExperimentValue('jira-aifc-workflow-resumption-ui-updates', 'isEnabled', false, {
                        fireExperimentExposure: false
                    })) onSaveEditsWithoutIssueCreation?.(message.data.payload);
                    break;
                default:
            }
        }; // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('message', messageHandler);
        return ()=>{
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('message', messageHandler);
        };
    }, [
        iframeRef,
        consumer,
        createAnalyticsEvent,
        onInit,
        onClose,
        onFailure,
        onSuccess,
        isCreateSuccess,
        setIsCreateSuccess,
        setIsGicReady,
        onSaveEditsWithoutIssueCreation
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isPayloadReady && isGicReady) // Only resolve the Promise if isPayloadReady is true, and the message has been received
        Promise.resolve(onGICReadyRef.current()).then((issuePayload)=>{
            const iframe = iframeRef.current?.contentWindow;
            if (iframe) {
                const { fieldData: fieldData, ...defaultValues } = issuePayload ?? {}; // Send GIC data used for initialization
                iframe.postMessage({
                    event: (0, $d62s5.JIRA_EMBED_ISSUE_CREATE_INIT),
                    payload: {
                        defaultValues: defaultValues,
                        ...fieldData && {
                            fieldData: {
                                ...fieldData,
                                ...defaultValues
                            }
                        }
                    }
                }, // Broadcast this message to all listeners for now
                '*');
                debouncedOnInit?.();
            }
        });
    }, [
        isPayloadReady,
        isGicReady,
        onGICReadyRef,
        debouncedOnInit
    ]);
    const iframeSrc = (0, $5TKGH.getIframeSrc)({
        colorMode: colorMode,
        domainName: domainName,
        params: params,
        displaySitePicker: displaySitePicker,
        ...configuration,
        overrideCloudId: overrideCloudId,
        ...(0, $cXtTj.default).getExperimentValue('jira-aifc-workflow-resumption-ui-updates', 'isEnabled', false, {
            fireExperimentExposure: false
        }) ? {
            onSaveEditsWithoutIssueCreation: onSaveEditsWithoutIssueCreation
        } : {}
    });
    (0, $cozmU.useEffect)(()=>{
        isGicReadyRef.current = isGicReady;
    }, [
        isGicReady
    ]);
    (0, $cozmU.useEffect)(()=>{
        // We need to reset the isGicReady state to avoid sending another postMessage to the GIC iframe window
        setIsGicReady(false);
    }, [
        iframeSrc
    ]);
    (0, $cozmU.useEffect)(()=>{
        const TIMEOUT_10_SECONDS = 10000;
        const timeout = setTimeout(()=>{
            // We need to use a ref to check if GIC is ready because the isGicReady state is updated asynchronously
            if (!isGicReadyRef.current) // This is a fallback for the case when the GIC iframe window is not initialized
            throw new Error('jira-ai/gic-anywhere: The latest GIC iframe window was not initialized');
        }, TIMEOUT_10_SECONDS);
        return ()=>clearTimeout(timeout);
    }, [
        iframeSrc
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($386fe214b22f2cd3$export$b32b5f1ee4493319, {
        name: "gic-anywhere-iframe",
        sandbox: undefined,
        ref: iframeRef,
        height: "100%",
        width: "100%",
        frameBorder: 0,
        // onError={}
        src: iframeSrc,
        "data-testid": "gic-anywhere"
    });
};
const $386fe214b22f2cd3$export$b32b5f1ee4493319 = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("iframe", {
        title: "Jira Embed Global Issue Create",
        ref: ref,
        ...props
    });
});
module.exports["GicAnywhere"] = $386fe214b22f2cd3$export$9af19a1ca8685214;

});

parcelRegister("lQXDC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $emZLc = parcelRequire("emZLc");


var $66Bcq = parcelRequire("66Bcq");


var $gBjHb = parcelRequire("gBjHb");

const $71fb2a898293aa35$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($66Bcq)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($emZLc))));
};
const $71fb2a898293aa35$export$34282a1f95511a11 = (props)=>{
    const data = $71fb2a898293aa35$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, props.children));
};
module.exports["ContextWrapper"] = $71fb2a898293aa35$export$34282a1f95511a11;

});

parcelRegister("emZLc", function(module, exports) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $a763071343fcb354$var$isUndefined(value) {
    return value === undefined;
}
module.exports = $a763071343fcb354$var$isUndefined;

});

parcelRegister("hcOES", function(module, exports) {

var $gO1os = parcelRequire("gO1os");


var $jYwtP = parcelRequire("jYwtP");


var $5sm3M = parcelRequire("5sm3M");

const $2b7c6f2b383d7d91$export$34ac71ce24cddec2 = (event, type, payload)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const clonedEvent = castedEvent.clone();
    if (!clonedEvent) throw new Error("Cannot clone an event after it's been fired.");
    clonedEvent.update({
        ...payload,
        analyticsType: type
    }).fire((0, $jYwtP.ANALYTICS_BRIDGE_CHANNEL));
};
const $2b7c6f2b383d7d91$var$getActionSubjectFromContext = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    return (0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))(castedEvent.context.map((i)=>i.component || i.componentName).filter(Boolean));
};
const $2b7c6f2b383d7d91$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in UI event');
    const { action: argumentsAction, actionSubject: argumentsActionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $5sm3M.getImperativeAnalyticsDataFromArguments)(rest);
    const castedEvent = event;
    const action = event.payload && event.payload.action || argumentsAction;
    const actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || $2b7c6f2b383d7d91$var$getActionSubjectFromContext(castedEvent);
    if (!action) throw new Error('Mandatory "action" field is missing from UI event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from UI event');
    $2b7c6f2b383d7d91$export$34ac71ce24cddec2(event, (0, $jYwtP.UI_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $2b7c6f2b383d7d91$export$13990ad4625571ed = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Track event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $5sm3M.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Track event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Track event');
    $2b7c6f2b383d7d91$export$34ac71ce24cddec2(event, (0, $jYwtP.TRACK_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $2b7c6f2b383d7d91$export$79f423cc3fd39762 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Operational event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $5sm3M.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Operational event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Operational event');
    $2b7c6f2b383d7d91$export$34ac71ce24cddec2(event, (0, $jYwtP.OPERATIONAL_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $2b7c6f2b383d7d91$export$6f46fb37ad7d962b = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Screen event');
    const { attributes: attributes } = (0, $5sm3M.getImperativeAnalyticsDataFromArguments)(rest);
    $2b7c6f2b383d7d91$export$34ac71ce24cddec2(event, (0, $jYwtP.SCREEN_EVENT_TYPE), {
        attributes: attributes
    });
};
module.exports["fireAnalytics"] = $2b7c6f2b383d7d91$export$34ac71ce24cddec2;
module.exports["fireUIAnalytics"] = $2b7c6f2b383d7d91$export$5d00cd31b1bf8e94;
module.exports["fireTrackAnalytics"] = $2b7c6f2b383d7d91$export$13990ad4625571ed;
module.exports["fireOperationalAnalytics"] = $2b7c6f2b383d7d91$export$79f423cc3fd39762;

});

parcelRegister("jYwtP", function(module, exports) {
const $fec988d562d5bfbb$export$f636b5b56f1d624a = 'Screen';
const $fec988d562d5bfbb$export$9d2de6eebf7462b5 = 'Drawer';
const $fec988d562d5bfbb$export$1171103ea9083ffa = 'Modal';
const $fec988d562d5bfbb$export$cae2783c9279926 = 'InlineDialog';
const $fec988d562d5bfbb$export$d1123261ca8831d2 = 'Dropdown';
const $fec988d562d5bfbb$export$a1562d08625f5d7e = 'UI';
const $fec988d562d5bfbb$export$947dac6c72b26f81 = 'TRACK';
const $fec988d562d5bfbb$export$f1d537d508d2945a = 'SCREEN';
const $fec988d562d5bfbb$export$12346a674644c156 = 'OPERATIONAL';
const $fec988d562d5bfbb$export$2ceccf177fae277c = 'analyticsBridge';
module.exports["SCREEN"] = $fec988d562d5bfbb$export$f636b5b56f1d624a;
module.exports["MODAL"] = $fec988d562d5bfbb$export$1171103ea9083ffa;
module.exports["UI_EVENT_TYPE"] = $fec988d562d5bfbb$export$a1562d08625f5d7e;
module.exports["TRACK_EVENT_TYPE"] = $fec988d562d5bfbb$export$947dac6c72b26f81;
module.exports["SCREEN_EVENT_TYPE"] = $fec988d562d5bfbb$export$f1d537d508d2945a;
module.exports["OPERATIONAL_EVENT_TYPE"] = $fec988d562d5bfbb$export$12346a674644c156;
module.exports["ANALYTICS_BRIDGE_CHANNEL"] = $fec988d562d5bfbb$export$2ceccf177fae277c;

});

parcelRegister("5sm3M", function(module, exports) {
const $8f4a194f3d46df20$var$extractDataFromStringAttribute = (string)=>{
    const arr = string.split(' ');
    switch(arr.length){
        case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const $8f4a194f3d46df20$var$extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return $8f4a194f3d46df20$var$extractDataFromStringAttribute(one);
    if (typeof one === 'object') return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
    throw Error('Event of this type is not supported');
};
const $8f4a194f3d46df20$var$extractDataFromTwoAttribute = (one, two)=>{
    if (typeof one === 'string' && typeof two === 'string') {
        const { action: action, actionSubject: actionSubject } = $8f4a194f3d46df20$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: undefined
        };
    }
    if (typeof one === 'string' && typeof two === 'object') {
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $8f4a194f3d46df20$var$extractDataFromStringAttribute(one);
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: two
        };
    }
    throw Error('Event of this type is not supported');
};
const $8f4a194f3d46df20$var$extractDataFromThreeAttribute = (one, two, three)=>{
    if (typeof one === 'string' && typeof two === 'string' && typeof three === 'object') {
        const { action: action, actionSubject: actionSubject } = $8f4a194f3d46df20$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: three
        };
    }
    throw Error('Event of this type is not supported');
};
const $8f4a194f3d46df20$export$e6baab532ef8c6bf = (args)=>{
    switch(args.length){
        case 0:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: undefined,
                attributes: undefined
            };
        case 1:
            return $8f4a194f3d46df20$var$extractDataFromOneAttribute(args[0]);
        case 2:
            return $8f4a194f3d46df20$var$extractDataFromTwoAttribute(args[0], args[1]);
        case 3:
            return $8f4a194f3d46df20$var$extractDataFromThreeAttribute(args[0], args[1], args[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};
module.exports["getImperativeAnalyticsDataFromArguments"] = $8f4a194f3d46df20$export$e6baab532ef8c6bf;

});

parcelRegister("7rqhv", function(module, exports) {
module.exports = new URL("error.5fbc7fe9.png", import.meta.url).toString();

});

parcelRegister("d62s5", function(module, exports) {
// Error messages
const $fc941d96b9cf15df$export$bdb28edf034fd38 = 'Jira GIC Anywhere - Iframe Source character limit exceeded';
const $fc941d96b9cf15df$export$b342b407e829290 = 'jiraEmbedIssueCreateInit';
const $fc941d96b9cf15df$export$fa02f6b8f65042dd = 'jiraEmbedIssueCreateReady';
const $fc941d96b9cf15df$export$8679ecb6b6b13aa9 = 'jiraEmbedIssueCreateSuccess';
const $fc941d96b9cf15df$export$c1caf9536ed579cc = 'jiraEmbedIssueCreateAppFailed';
const $fc941d96b9cf15df$export$a402043ad8e6699 = 'jiraEmbedIssueCreateClose';
const $fc941d96b9cf15df$export$89aca4b41c88286e = 'jiraEmbedIssueSaveWithoutCreation';
module.exports["ERROR_IFRAME_SOURCE_CHAR_LIMIT_EXCEEDED"] = $fc941d96b9cf15df$export$bdb28edf034fd38;
module.exports["JIRA_EMBED_ISSUE_CREATE_INIT"] = $fc941d96b9cf15df$export$b342b407e829290;
module.exports["JIRA_EMBED_ISSUE_CREATE_READY"] = $fc941d96b9cf15df$export$fa02f6b8f65042dd;
module.exports["JIRA_EMBED_ISSUE_CREATE_SUCCESS"] = $fc941d96b9cf15df$export$8679ecb6b6b13aa9;
module.exports["JIRA_EMBED_ISSUE_CREATE_FAILURE"] = $fc941d96b9cf15df$export$c1caf9536ed579cc;
module.exports["JIRA_EMBED_ISSUE_CREATE_CLOSE"] = $fc941d96b9cf15df$export$a402043ad8e6699;
module.exports["JIRA_EMBED_ISSUE_SAVE_WITHOUT_CREATION"] = $fc941d96b9cf15df$export$89aca4b41c88286e;

});

parcelRegister("5TKGH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $NF6kd = parcelRequire("NF6kd");


var $3d3WW = parcelRequire("3d3WW");


var $cXtTj = parcelRequire("cXtTj");


var $ixfCV = parcelRequire("ixfCV");


var $jYwtP = parcelRequire("jYwtP");

var $k8V2e = parcelRequire("k8V2e");


var $d62s5 = parcelRequire("d62s5");

const $19ceb46128b62655$var$analyticsClientInfo = {
    env: 'prod',
    product: 'jira'
};
const $19ceb46128b62655$var$LIGHT_MODE = 'light';
const $19ceb46128b62655$var$DARK_MODE = 'dark';
const $19ceb46128b62655$var$AUTO = 'auto';
const $19ceb46128b62655$var$AVAILABLE_SITES_PATH = '/gateway/api/available-sites';
const $19ceb46128b62655$var$AVAILABLE_SITES_UNIT_COMPLIANT_PATH = '/gateway/api/experimental/available-sites';
const $19ceb46128b62655$export$a31dd10290664cf6 = 2048;
const $19ceb46128b62655$export$584bd4ae64a8d7e2 = ({ colorMode: colorMode = $19ceb46128b62655$var$AUTO, domainName: domainName = '', overrideCloudId: overrideCloudId, params: params, onFailure: onFailure, displaySitePicker: displaySitePicker, disableProjectDropdown: disableProjectDropdown, displayOnlyRequiredFields: displayOnlyRequiredFields, onSaveEditsWithoutIssueCreation: onSaveEditsWithoutIssueCreation })=>{
    const iframeParams = new URLSearchParams(params);
    iframeParams.append('postMessageInit', '1');
    if (displaySitePicker === false) iframeParams.append('displaySitePicker', 'false');
    if (disableProjectDropdown) iframeParams.append('disableProjectDropdown', 'true');
    if (displayOnlyRequiredFields) iframeParams.append('displayOnlyRequiredFields', 'true');
    if (colorMode) iframeParams.append('themeMode', colorMode);
    if (overrideCloudId) iframeParams.append('overrideCloudId', overrideCloudId);
    if (onSaveEditsWithoutIssueCreation && (0, $cXtTj.default).getExperimentValue('jira-aifc-workflow-resumption-ui-updates', 'isEnabled', false, {
        fireExperimentExposure: false
    })) iframeParams.append('submitBehaviour', 'saveEditsWithoutIssueCreation');
    /**
   * We want to use the postMessageInit param to instruct the Jira embed iframe
   * to wait before mounting Issue Create.
   * It will send a message back to us when it's ready to receive the init message
   */ let srcUrl = `${domainName}/jira/issues/create/embed?${iframeParams}`;
    if ((0, $cXtTj.default).getExperimentValue('jira-aifc-workflow-resumption-ui-updates', 'isEnabled', false, {
        fireExperimentExposure: false
    })) {
        const localHostName = window.origin;
    }
    if (srcUrl.length > $19ceb46128b62655$export$a31dd10290664cf6) onFailure?.(new Error((0, $d62s5.ERROR_IFRAME_SOURCE_CHAR_LIMIT_EXCEEDED)));
    return srcUrl;
};
const $19ceb46128b62655$export$61874183278c256e = [
    'jira-software.ondemand',
    'jira-core.ondemand',
    'jira-servicedesk.ondemand',
    'jira-product-discovery'
];
async function $19ceb46128b62655$export$5e195155111b6846(baseUrlForAvailableSites) {
    const requestConfig = {
        method: 'POST',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            products: $19ceb46128b62655$export$61874183278c256e
        })
    };
    const base = baseUrlForAvailableSites ? baseUrlForAvailableSites.replace(/\/$/, '') : '';
    const availableSitesPath = (0, $ixfCV.fg)('issue_create_modal_site_picker_api_unit_compliant') ? $19ceb46128b62655$var$AVAILABLE_SITES_UNIT_COMPLIANT_PATH : $19ceb46128b62655$var$AVAILABLE_SITES_PATH;
    const response = await fetch(`${base}${availableSitesPath}`, requestConfig);
    if (response.ok) return response.json();
    throw response;
}
const $19ceb46128b62655$export$1b581a2ec13e37f1 = (props)=>{
    const analyticsClient = (0, $cozmU.useRef)(new (0, $NF6kd.default)($19ceb46128b62655$var$analyticsClientInfo, {}));
    const sendEvent = (0, $cozmU.useCallback)((event)=>{
        const { type: type, payload: payload } = event;
        switch(type){
            case 0, $jYwtP.UI_EVENT_TYPE:
                // @ts-expect-error - Argument of type 'Record<string, any>' is not assignable to parameter of type 'UITrackAndOperationalEventPayload'
                analyticsClient.current.sendUIEvent(payload);
                break;
            case 0, $jYwtP.TRACK_EVENT_TYPE:
                // @ts-expect-error - Argument of type 'Record<string, any>' is not assignable to parameter of type 'UITrackAndOperationalEventPayload'
                analyticsClient.current.sendTrackEvent(payload);
                break;
            case 0, $jYwtP.OPERATIONAL_EVENT_TYPE:
                // @ts-expect-error - Argument of type 'Record<string, any>' is not assignable to parameter of type 'UITrackAndOperationalEventPayload'
                analyticsClient.current.sendOperationalEvent(payload);
                break;
            case 0, $jYwtP.SCREEN_EVENT_TYPE:
                analyticsClient.current.sendScreenEvent(payload.name, null, payload.attributes);
                break;
            default:
                break;
        }
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        channel: (0, $jYwtP.ANALYTICS_BRIDGE_CHANNEL),
        onEvent: (event)=>sendEvent((0, $k8V2e.extractAWCDataFromEvent)(event))
    }, props.children);
};
const $19ceb46128b62655$export$61fc7d43ac8f84b0 = (func, wait)=>{
    let timeout;
    const debounced = (...args)=>{
        const later = ()=>{
            timeout = undefined;
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
    debounced.cancel = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
};
module.exports["getIframeSrc"] = $19ceb46128b62655$export$584bd4ae64a8d7e2;
module.exports["getAvailableJiraSites"] = $19ceb46128b62655$export$5e195155111b6846;
module.exports["AnalyticsProvider"] = $19ceb46128b62655$export$1b581a2ec13e37f1;
module.exports["debounce"] = $19ceb46128b62655$export$61fc7d43ac8f84b0;

});

parcelRegister("k8V2e", function(module, exports) {
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $emZLc = parcelRequire("emZLc");


var $66Bcq = parcelRequire("66Bcq");


var $jYwtP = parcelRequire("jYwtP");


var $8El2z = parcelRequire("8El2z");

const $035dbde6912e4d4c$export$1c850cf68c053906 = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const analyticsType = (0, $8El2z.getAnalyticsType)(castedEvent);
    const attributes = (0, $8El2z.getAttributes)(castedEvent);
    const source = (0, $8El2z.getSource)(castedEvent);
    const actionSubject = (0, $8El2z.getActionSubject)(castedEvent);
    if (analyticsType === (0, $jYwtP.SCREEN_EVENT_TYPE)) return {
        type: (0, $jYwtP.SCREEN_EVENT_TYPE),
        payload: {
            name: source,
            attributes: attributes
        }
    };
    switch(analyticsType){
        case 0, $jYwtP.UI_EVENT_TYPE:
        case 0, $jYwtP.TRACK_EVENT_TYPE:
        case 0, $jYwtP.OPERATIONAL_EVENT_TYPE:
            {
                const action = (0, $8El2z.getAction)(castedEvent);
                const actionSubjectId = (0, $8El2z.getActionSubjectId)(castedEvent);
                const containerId = (0, $8El2z.getContainerId)(castedEvent);
                const containerType = (0, $8El2z.getContainerType)(castedEvent);
                const objectId = (0, $8El2z.getObjectId)(castedEvent);
                const objectType = (0, $8El2z.getObjectType)(castedEvent);
                const tags = (0, $8El2z.getTags)(castedEvent);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($66Bcq)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerType: containerType,
                        containerId: containerId,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($emZLc))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes
                },
                type: undefined
            };
    }
};
module.exports["extractAWCDataFromEvent"] = $035dbde6912e4d4c$export$1c850cf68c053906;

});

parcelRegister("8El2z", function(module, exports) {

var $lyW2B = parcelRequire("lyW2B");


var $emZLc = parcelRequire("emZLc");


var $gO1os = parcelRequire("gO1os");


var $lYpJw = parcelRequire("lYpJw");


var $66Bcq = parcelRequire("66Bcq");


var $1wIeS = parcelRequire("1wIeS");

const $c9f6533ef6431d6e$var$extractFromContext = (event, property)=>event.context.map((item)=>item[property]);
const $c9f6533ef6431d6e$export$a3569ac53b82a914 = (event)=>event.payload.analyticsType;
const $c9f6533ef6431d6e$export$fe94072fee8a6976 = (event)=>{
    const contextAttributes = $c9f6533ef6431d6e$var$extractFromContext(event, 'attributes');
    const payloadAttributes = event.payload.attributes;
    const allAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lYpJw)))(contextAttributes.reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($lYpJw)))(result, extraAttributes), {}), payloadAttributes);
    const sources = $c9f6533ef6431d6e$var$extractFromContext(event, 'source');
    const namespaces = sources.filter(Boolean).join('.');
    return (0, (/*@__PURE__*/$parcel$interopDefault($66Bcq)))({
        ...allAttributes,
        namespaces: namespaces
    }, (0, (/*@__PURE__*/$parcel$interopDefault($emZLc))));
};
const $c9f6533ef6431d6e$export$dd2b6e807fb37ba3 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'source').filter(Boolean));
const $c9f6533ef6431d6e$export$6f40cdf6d42c018d = (event)=>{
    const { actionSubject: actionSubject } = event.payload;
    if (actionSubject) return actionSubject;
    const component = (0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'component').filter(Boolean)) || (0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'componentName').filter(Boolean));
    return component;
};
const $c9f6533ef6431d6e$export$6ca3170acb89054 = (event)=>event.payload.action;
const $c9f6533ef6431d6e$export$b6f8db3ad0711b02 = (event)=>event.payload.actionSubjectId;
const $c9f6533ef6431d6e$export$7c8178cc9001d237 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'containerId').filter(Boolean));
const $c9f6533ef6431d6e$export$acc6f3e19803b3dc = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'containerType').filter(Boolean));
const $c9f6533ef6431d6e$export$fa986b91291934c7 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'objectId').filter(Boolean));
const $c9f6533ef6431d6e$export$11cc42aebef2ef3a = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'objectType').filter(Boolean));
const $c9f6533ef6431d6e$export$af63d7414243dad3 = (event)=>{
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($1wIeS)))((0, (/*@__PURE__*/$parcel$interopDefault($lyW2B)))($c9f6533ef6431d6e$var$extractFromContext(event, 'tags'))).filter(Boolean);
    return tags.length ? tags : undefined;
};
module.exports["getAnalyticsType"] = $c9f6533ef6431d6e$export$a3569ac53b82a914;
module.exports["getAttributes"] = $c9f6533ef6431d6e$export$fe94072fee8a6976;
module.exports["getSource"] = $c9f6533ef6431d6e$export$dd2b6e807fb37ba3;
module.exports["getActionSubject"] = $c9f6533ef6431d6e$export$6f40cdf6d42c018d;
module.exports["getAction"] = $c9f6533ef6431d6e$export$6ca3170acb89054;
module.exports["getActionSubjectId"] = $c9f6533ef6431d6e$export$b6f8db3ad0711b02;
module.exports["getContainerId"] = $c9f6533ef6431d6e$export$7c8178cc9001d237;
module.exports["getContainerType"] = $c9f6533ef6431d6e$export$acc6f3e19803b3dc;
module.exports["getObjectId"] = $c9f6533ef6431d6e$export$fa986b91291934c7;
module.exports["getObjectType"] = $c9f6533ef6431d6e$export$11cc42aebef2ef3a;
module.exports["getTags"] = $c9f6533ef6431d6e$export$af63d7414243dad3;

});

parcelRegister("iXoLm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $5TKGH = parcelRequire("5TKGH");

const $58abbbf3766fa385$export$930bddfd3ad23bb7 = ({ preferredCloudId: preferredCloudId, onComplete: onComplete, onError: onError })=>{
    (0, $6cFsl.di)((0, $5TKGH.getAvailableJiraSites));
    const [domain, setDomain] = (0, $cozmU.useState)(undefined);
    const [availableSites, setAvailableSites] = (0, $cozmU.useState)([]);
    const [loading, setLoading] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    (0, $cozmU.useEffect)(()=>{
        const fetchAvailableJiraSites = async ()=>{
            setLoading(true);
            try {
                const { sites: sites } = await (0, $5TKGH.getAvailableJiraSites)();
                setAvailableSites(sites ?? []);
                const computedDomain = (sites.find((site)=>site.cloudId === preferredCloudId) ?? sites[0])?.url ?? '';
                setDomain(computedDomain);
                onComplete?.({
                    domain: computedDomain,
                    availableSites: sites
                });
            } catch (e) {
                onError && onError(e);
                setError(e.message);
            } finally{
                setLoading(false);
            }
        };
        fetchAvailableJiraSites();
    }, [
        preferredCloudId,
        onComplete,
        onError
    ]);
    return {
        domain: domain,
        availableSites: availableSites,
        loading: loading,
        error: error
    };
};
const $58abbbf3766fa385$export$7872bb66f9195035 = ({ onComplete: onComplete, onError: onError, baseUrlForAvailableSites: baseUrlForAvailableSites })=>{
    (0, $6cFsl.di)((0, $5TKGH.getAvailableJiraSites));
    const [availableSites, setAvailableSites] = (0, $cozmU.useState)([]);
    const [loading, setLoading] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const hasMount = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (hasMount.current) return;
        setLoading(true);
        const fetchAvailableJiraSites = async ()=>{
            try {
                const { sites: sites } = await (0, $5TKGH.getAvailableJiraSites)(baseUrlForAvailableSites);
                setAvailableSites(sites ?? []);
                onComplete?.({
                    availableSites: sites
                });
            } catch (e) {
                onError && onError(e);
                setError(e.message);
            } finally{
                setLoading(false);
            }
        };
        fetchAvailableJiraSites();
        hasMount.current = true;
    }, [
        baseUrlForAvailableSites,
        onComplete,
        onError
    ]);
    return {
        availableSites: availableSites,
        loading: loading,
        error: error
    };
};
const $58abbbf3766fa385$export$60b2cad7400d36b3 = ({ sites: sites, preferredCloudId: preferredCloudId })=>{
    const domain = (sites.find((site)=>site.cloudId === preferredCloudId) ?? sites[0])?.url ?? '';
    return {
        domain: domain
    };
};
const $58abbbf3766fa385$export$48ca77029c1208c2 = ({ cloudId: cloudId, overrideCloudId: overrideCloudId, baseUrlForAvailableSites: baseUrlForAvailableSites })=>{
    const { availableSites: availableSites, loading: loading, error: error } = $58abbbf3766fa385$export$7872bb66f9195035({
        baseUrlForAvailableSites: baseUrlForAvailableSites
    });
    const { domain: domainName } = $58abbbf3766fa385$export$60b2cad7400d36b3({
        sites: availableSites,
        preferredCloudId: cloudId
    });
    const { domain: isOverrideSiteAvailable } = $58abbbf3766fa385$export$60b2cad7400d36b3({
        sites: availableSites,
        preferredCloudId: overrideCloudId
    });
    if (error) throw new Error('Failed to fetch available sites');
    return loading ? {
        availableSites: [],
        domainName: undefined,
        isOverrideSiteAvailable: undefined
    } : {
        availableSites: availableSites,
        domainName: domainName,
        isOverrideSiteAvailable: isOverrideSiteAvailable
    };
};
module.exports["useGetFirstAvailableSiteDomain"] = $58abbbf3766fa385$export$930bddfd3ad23bb7;
module.exports["useGetDomainAndAvailableSites"] = $58abbbf3766fa385$export$48ca77029c1208c2;

});

parcelRegister("hRkxy", function(module, exports) {
const $3c0a544666aac42c$export$7bd623b29ec8e1eb = 7000; // 7s timeout, typical GIC load is ~3s
const $3c0a544666aac42c$export$6dfc55fc5e2544ae = 188;
const $3c0a544666aac42c$export$85d8afb0902718e2 = 250;
module.exports["DEFAULT_TIMEOUT"] = $3c0a544666aac42c$export$7bd623b29ec8e1eb;
module.exports["MAX_ERROR_IMAGE_WIDTH"] = $3c0a544666aac42c$export$6dfc55fc5e2544ae;
module.exports["MAX_ERROR_IMAGE_HEIGHT"] = $3c0a544666aac42c$export$85d8afb0902718e2;

});

parcelRegister("gkYOG", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $dcfad1e373bc3d13$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    iFrameLoading: {
        id: "jira-ai.gic-anywhere.iframe-loading",
        defaultMessage: "Loading work item details, this might take a few seconds."
    },
    iFrameSlowLoading: {
        id: "jira-ai.gic-anywhere.iframe-slow-loading",
        defaultMessage: "It is taking longer than usual to load your work item.{br}Give it a few more seconds, or try again later."
    },
    openInJiraButton: {
        id: "jira-ai.gic-anywhere.open-in-jira-button",
        defaultMessage: "Log in to Jira to view"
    },
    errorHeader: {
        id: "jira-ai.gic-anywhere.error-header",
        defaultMessage: "Something's gone wrong"
    },
    errorBody: {
        id: "jira-ai.gic-anywhere.error-body",
        defaultMessage: "Try opening this in Jira. If the problem persists, please contact Atlassian support."
    }
});
module.exports["messages"] = $dcfad1e373bc3d13$export$defe85febe8b728c;

});

parcelRegister("9K9na", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7vK9E = parcelRequire("7vK9E");

const $c2473cc34e5c9c56$export$8ecee5edd581c23a = (flags)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return (0, $cozmU.useCallback)((payload, flagType, message)=>{
        flags.showFlag({
            type: flagType,
            title: formatMessage(message, {
                issueKey: payload?.issueKey,
                issueSummary: payload?.summary,
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.default), {
                        href: payload?.link,
                        target: "_blank"
                    }, chunks)
            }),
            close: 'auto'
        });
    }, [
        flags,
        formatMessage
    ]);
};
module.exports["useTriggerFlagIssueCreated"] = $c2473cc34e5c9c56$export$8ecee5edd581c23a;

});

parcelRegister("kcLnq", function(module, exports) {
/* ConfluenceAiIssueCreate.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $4AavA = parcelRequire("4AavA");


var $c8cGy = parcelRequire("c8cGy");


var $iMnC5 = parcelRequire("iMnC5");


var $b8pma = parcelRequire("b8pma");


var $4n04n = parcelRequire("4n04n");


var $htTUm = parcelRequire("htTUm");


var $29vMs = parcelRequire("29vMs");


var $iNyje = parcelRequire("iNyje");


var $7JWNS = parcelRequire("7JWNS");


var $l4gv5 = parcelRequire("l4gv5");


var $kfViO = parcelRequire("kfViO");


var $9BGuq = parcelRequire("9BGuq");


var $arvSz = parcelRequire("arvSz");


var $gqQUx = parcelRequire("gqQUx");

const $0aab3fed706492b4$export$7bd623b29ec8e1eb = 7000; // 7s timeout, typical GIC load is ~3s
const $0aab3fed706492b4$var$style = {
    aiIssueCreateWrapper: "_16jlkb7n"
};
const $0aab3fed706492b4$export$fbdfb25d3cad524a = ({ confluencePage: confluencePage, highlightedText: highlightedText, isReady: isReady, overrideXProduct: overrideXProduct, handleAiSuggestedFieldsStateChange: handleAiSuggestedFieldsStateChange })=>{
    const streamingHookProps = (0, $arvSz.useStreamingHookProps)({
        confluencePage: confluencePage,
        highlightedText: highlightedText,
        overrideXProduct: overrideXProduct
    });
    const { suggestions: suggestions, isStreaming: isStreaming, error: error, onAIResultView: onAIResultView } = (0, $7JWNS.useAiWorkSuggestionStreaming)(streamingHookProps); // Transform streaming suggestions to match the expected fields format
    const transformedFields = (0, $cozmU.useMemo)(()=>{
        // Only use suggestions when streaming is complete
        if (isStreaming) return {
            summary: '',
            description: ''
        };
        return {
            summary: suggestions?.[0]?.field_values?.Summary || '',
            description: suggestions?.[0]?.field_values?.Description || ''
        };
    }, [
        suggestions,
        isStreaming
    ]);
    const getServiceState = ()=>{
        if (error) return 'error';
        if (isStreaming) return 'loading';
        return 'idle';
    };
    (0, $cozmU.useEffect)(()=>{
        if (error) handleAiSuggestedFieldsStateChange({
            state: 'error',
            error: $0aab3fed706492b4$export$98d40c5fd23ef716(error)
        });
        else if (isStreaming) handleAiSuggestedFieldsStateChange({
            state: 'loading',
            fields: transformedFields
        });
        else handleAiSuggestedFieldsStateChange({
            state: 'idle',
            fields: transformedFields
        });
    }, [
        error,
        isStreaming,
        transformedFields,
        handleAiSuggestedFieldsStateChange
    ]);
    if (!isReady) return {
        state: 'loading',
        fields: null
    };
    return {
        state: getServiceState(),
        fields: transformedFields,
        onAIResultView: onAIResultView,
        suggestions: suggestions,
        isStreaming: isStreaming
    };
};
const $0aab3fed706492b4$export$98d40c5fd23ef716 = (error)=>{
    return {
        message_template: error?.message?.message_template,
        statusCode: error?.message?.status_code,
        message: error?.message?.content,
        content: error?.message?.content
    };
};
const $0aab3fed706492b4$export$a653b3ac3dd182f4 = ({ cloudId: cloudId, overrideCloudIdForSitePicker: overrideCloudIdForSitePicker, overrideProjectIdForProjectPicker: overrideProjectIdForProjectPicker, contentType: contentType, pageId: pageId, pageMode: pageMode, highlightedTextAdf: highlightedTextAdf, timeoutMs: timeoutMs = $0aab3fed706492b4$export$7bd623b29ec8e1eb, onInit: onInit, onSuccess: onSuccess, onFailure: onFailure, onClose: onClose, onTimeout: onTimeout, testId: testId, onStateChange: onStateChange, consumer: consumer, setAiAnalyticsContext: setAiAnalyticsContext, aIIssueCreationEnablement: aIIssueCreationEnablement })=>{
    const { fireTrack: fireTrack } = (0, $9BGuq.useAiIssueCreateAnalytics)();
    const [confluencePage, setConfluencePage] = (0, $cozmU.useState)('');
    const [idMap, setIdMap] = (0, $cozmU.useState)({});
    const [isIdMapReady, setIsIdMapReady] = (0, $cozmU.useState)(false); // Custom handler to wrap multiple onStateChange calls
    const handleStateChange = (0, $cozmU.useCallback)((source, state)=>{
        // trigger error if any state is errored
        if (onFailure && state?.state === 'error') {
            onFailure(state.error, state.message_template);
            fireTrack(`${source} failed`);
        }
        if (onStateChange) {
            onStateChange(state.state, source);
            fireTrack(`${source} updated`, {
                state: state.state
            });
        }
    }, [
        onFailure,
        onStateChange,
        fireTrack
    ]);
    const handleConfluencePageStateChange = (0, $cozmU.useCallback)((newState)=>handleStateChange('aiIssueCreateGetConfluencePageState', newState), [
        handleStateChange
    ]); // Fetch confluence page
    const { state: confluencePageState, confluencePage: confluencePageAsAdf } = (0, $gqQUx.useGetConfluencePage)({
        cloudId: cloudId,
        contentType: contentType,
        experienceId: 'ai-issue-create-confluence-single',
        pageId: pageId,
        pageMode: pageMode,
        onStateChange: handleConfluencePageStateChange
    }); // Effect to transform confluence page ADF to markdown after fetching
    (0, $cozmU.useEffect)(()=>{
        if (confluencePageState === 'idle' && confluencePageAsAdf) {
            const { markdown: markdown, idMap: newIdMap } = (0, $4n04n.adfToMarkdownPlus)(confluencePageAsAdf, {
                markdownPlusUseNextLayoutSection: true
            });
            setAiAnalyticsContext && setAiAnalyticsContext('pageContextLength', (0, $kfViO.countADFChars)(confluencePageAsAdf));
            setConfluencePage(markdown);
            setIdMap(newIdMap);
            setIsIdMapReady(true); // Set idMap ready when it's set
        }
    }, [
        confluencePageState,
        confluencePageAsAdf,
        setAiAnalyticsContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $0aab3fed706492b4$var$style.aiIssueCreateWrapper,
        testId: testId ?? 'default-confluence-ai-issue-create'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "ai-issue-create.adf-to-markdown-plus",
        hold: confluencePageState !== 'loading' && !isIdMapReady
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "ai-issue-create.confluence-page-loading",
        hold: confluencePageState === 'loading'
    }), isIdMapReady ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aab3fed706492b4$export$9da61cee87ff5851, {
        handleStateChange: handleStateChange,
        confluencePageState: confluencePageState,
        confluencePage: confluencePage,
        idMap: idMap,
        useService: $0aab3fed706492b4$export$fbdfb25d3cad524a,
        cloudId: cloudId,
        contentType: contentType,
        pageId: pageId,
        pageMode: pageMode,
        highlightedTextAdf: highlightedTextAdf,
        timeoutMs: timeoutMs,
        onInit: onInit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onClose: onClose,
        onTimeout: onTimeout,
        onStateChange: onStateChange,
        consumer: consumer,
        setAiAnalyticsContext: setAiAnalyticsContext,
        aIIssueCreationEnablement: aIIssueCreationEnablement,
        overrideCloudIdForSitePicker: overrideCloudIdForSitePicker,
        overrideProjectIdForProjectPicker: overrideProjectIdForProjectPicker
    }) : null));
};
const $0aab3fed706492b4$export$9da61cee87ff5851 = ({ cloudId: cloudId, overrideCloudIdForSitePicker: overrideCloudIdForSitePicker, highlightedTextAdf: highlightedTextAdf = (0, $4AavA.doc)((0, $c8cGy.paragraph)('')), timeoutMs: timeoutMs = $0aab3fed706492b4$export$7bd623b29ec8e1eb, onInit: onInit, onSuccess: onSuccess, idMap: idMap, confluencePage: confluencePage, confluencePageState: confluencePageState, handleStateChange: handleStateChange, onFailure: onFailure, onClose: onClose, onTimeout: onTimeout, consumer: consumer, setAiAnalyticsContext: setAiAnalyticsContext, useService: useService, aIIssueCreationEnablement: aIIssueCreationEnablement, overrideProjectIdForProjectPicker: overrideProjectIdForProjectPicker })=>{
    const handleAiSuggestedFieldsStateChange = (0, $cozmU.useCallback)((newState)=>handleStateChange('aiIssueCreateFetchSuggestedFieldsState', newState), [
        handleStateChange
    ]);
    const highlightedText = (0, $cozmU.useMemo)(()=>{
        return (0, $4n04n.adfToMarkdownPlus)(highlightedTextAdf, {
            markdownPlusUseNextLayoutSection: true
        }, idMap).markdown;
    }, [
        highlightedTextAdf,
        idMap
    ]); // Only call SuggestionComponent when highlightedText is ready
    const { state: suggestedFieldsState, fields: fields, onAIResultView: onAIResultView, isStreaming: isStreaming, suggestions: suggestions } = useService({
        cloudId: cloudId,
        confluencePage: confluencePage,
        highlightedText: highlightedText,
        handleAiSuggestedFieldsStateChange: handleAiSuggestedFieldsStateChange,
        isReady: highlightedText !== '',
        overrideXProduct: aIIssueCreationEnablement?.enablement
    });
    const isLoading = confluencePageState === 'loading' || suggestedFieldsState === 'loading';
    const isErrored = confluencePageState === 'error' || suggestedFieldsState === 'error';
    const isPayloadReady = confluencePageState === 'idle' && suggestedFieldsState === 'idle';
    const descriptionADF = (0, $cozmU.useMemo)(()=>{
        if (isLoading || isErrored || !fields?.description) return (0, $4AavA.doc)((0, $c8cGy.paragraph)(''));
        return (0, $htTUm.markdownPlusToAdf)({
            markdown: fields.description,
            idMap: idMap
        });
    }, [
        isLoading,
        isErrored,
        fields,
        idMap
    ]);
    (0, $cozmU.useEffect)(()=>{
        setAiAnalyticsContext && setAiAnalyticsContext('aiResponseLength', (0, $kfViO.countADFChars)(descriptionADF));
    }, [
        descriptionADF,
        setAiAnalyticsContext
    ]);
    (0, $cozmU.useEffect)(()=>{
        setAiAnalyticsContext && setAiAnalyticsContext('highlightedTextLength', (0, $kfViO.countADFChars)(highlightedTextAdf));
    }, [
        highlightedTextAdf,
        setAiAnalyticsContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "ai-issue-create.suggested-fields-loading",
        hold: suggestedFieldsState === 'loading'
    }), !isErrored && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iNyje.GicAnywhere), {
        cloudId: cloudId,
        summary: fields?.summary || '',
        descriptionAdf: descriptionADF,
        timeoutMs: timeoutMs,
        onInit: onInit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onClose: onClose,
        onTimeout: onTimeout,
        consumer: consumer,
        isPayloadReady: isPayloadReady,
        overrideCloudId: overrideCloudIdForSitePicker,
        projectId: overrideProjectIdForProjectPicker
    }), !isStreaming && Boolean(suggestions?.length) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l4gv5.MountEvent), {
        onMount: onAIResultView
    }));
};
const $0aab3fed706492b4$export$56bb8aafd9fb646e = ({ cloudId: cloudId, contentType: contentType, pageId: pageId, pageMode: pageMode, overrideCloudIdForSitePicker: overrideCloudIdForSitePicker, overrideProjectIdForProjectPicker: overrideProjectIdForProjectPicker, highlightedTextAdf: highlightedTextAdf = (0, $4AavA.doc)((0, $c8cGy.paragraph)('')), timeoutMs: timeoutMs = $0aab3fed706492b4$export$7bd623b29ec8e1eb, onInit: onInit, onSuccess: onSuccess, onFailure: onFailure, onClose: onClose, onTimeout: onTimeout, testId: testId, onStateChange: onStateChange, consumer: consumer = 'confluenceHighlight', setAiAnalyticsContext: setAiAnalyticsContext, aIIssueCreationEnablement: aIIssueCreationEnablement })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $29vMs.AIEventsInstrumentationProvider), {
        config: {
            // Required configruation
            product: 'confluence',
            subproduct: 'jira',
            aiFeatureName: 'confluenceAiWorkCreation',
            proactiveGeneratedAI: 0,
            userGeneratedAI: 1,
            // Optional configuration
            source: 'confluenceHighlightIssueCreate',
            skipAISessionValidation: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aab3fed706492b4$export$a653b3ac3dd182f4, {
        cloudId: cloudId,
        contentType: contentType,
        pageId: pageId,
        pageMode: pageMode,
        highlightedTextAdf: highlightedTextAdf,
        timeoutMs: timeoutMs,
        onInit: onInit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        onClose: onClose,
        onTimeout: onTimeout,
        testId: testId,
        onStateChange: onStateChange,
        consumer: consumer,
        overrideCloudIdForSitePicker: overrideCloudIdForSitePicker,
        overrideProjectIdForProjectPicker: overrideProjectIdForProjectPicker,
        setAiAnalyticsContext: setAiAnalyticsContext,
        aIIssueCreationEnablement: aIIssueCreationEnablement
    }));
};
module.exports["ConfluenceAiIssueCreate"] = $0aab3fed706492b4$export$56bb8aafd9fb646e;

});

parcelRegister("4n04n", function(module, exports) {
/**
 * This file was cloned from https://bitbucket.org/atlassian/pf-adf-service/src/master/src/lib/converters/adf-to-markdownPlus.ts and slightly modified to work in the browser.
 */ 
var $8OOZ2 = parcelRequire("8OOZ2");


var $6OV8L = parcelRequire("6OV8L");


var $4XbfY = parcelRequire("4XbfY");


var $3xuv0 = parcelRequire("3xuv0");


var $9DPMp = parcelRequire("9DPMp");

const $41ee172e87bea8b0$var$defaultSerializer = new (0, $3xuv0.JSONTransformer)();
function $41ee172e87bea8b0$export$bd172d9b9473ac80(adf, featureToggles, idMap) {
    // Default to markdownPlus being enabled unless explicitly disabled
    if (featureToggles === undefined) featureToggles = {};
    if (featureToggles?.markdownPlus === undefined) featureToggles.markdownPlus = true;
    if (featureToggles?.markdownPlusAvoidDuplicatedIdCounter === undefined) featureToggles.markdownPlusAvoidDuplicatedIdCounter = true;
    let serializer = $41ee172e87bea8b0$var$defaultSerializer;
    if (featureToggles.markdownPlusUseNextLayoutSection) serializer = new (0, $3xuv0.JSONTransformer)((0, $8OOZ2.createSchema)({
        ...(0, $4XbfY.defaultSchemaConfig),
        customNodeSpecs: {
            layoutSection: (0, $6OV8L.layoutSectionWithSingleColumn)
        }
    }));
    // Convert ADF to ProseMirrorNode
    const proseMirrorNode = serializer.parse(adf);
    // Generate the mentionMap required for correctly returning @mention strings in Markdown+
    const mentionMap = $41ee172e87bea8b0$var$getMentionMap(serializer.encode(proseMirrorNode));
    // Convert ProseMirrorNode to markdown-plus
    const { markdown: markdown, idMap: newIdMap } = (0, $9DPMp.convertProsemirrorNodeToMarkdown)({
        node: proseMirrorNode,
        featureToggles: featureToggles,
        mentionMap: mentionMap,
        idMap: idMap
    });
    return {
        markdown: markdown,
        idMap: newIdMap
    };
}
function $41ee172e87bea8b0$var$getMentionMap(jsonNode) {
    const mentionMap = {};
    function findMentions(node) {
        if (node.type === 'mention') {
            const userValues = $41ee172e87bea8b0$var$getUserMentionValues(node);
            if (userValues) // Stripping '@' from the mention as Markdown+ automatically adds it back for each map value
            mentionMap[userValues.id] = userValues.text.replace('@', '');
        }
        node.content?.forEach((childNode)=>{
            if (childNode) findMentions(childNode);
        });
    }
    findMentions(jsonNode);
    return mentionMap;
}
function $41ee172e87bea8b0$var$getUserMentionValues(node) {
    if (node.attrs && $41ee172e87bea8b0$var$hasTextAndIdFields(node.attrs)) return {
        text: node.attrs.text,
        id: node.attrs.id
    };
    return null;
}
function $41ee172e87bea8b0$var$hasTextAndIdFields(attrs) {
    return 'text' in attrs && 'id' in attrs && typeof attrs.text === 'string' && typeof attrs.id === 'string';
}
module.exports["adfToMarkdownPlus"] = $41ee172e87bea8b0$export$bd172d9b9473ac80;

});

parcelRegister("9DPMp", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $bjg0G = parcelRequire("bjg0G");


var $3cHXJ = parcelRequire("3cHXJ");


var $h2a2b = parcelRequire("h2a2b");

/**
 * If the first node is a paragraph we need to wrap it in a paragraph node for the markdown conversion to work properly
 */ function $b6f242e395dcdf98$var$createTextWrapper(editorView, fragment) {
    const { schema: schema } = editorView.state;
    const { $from: $from } = editorView.state.selection;
    const parent = (0, $bjg0G.findParentNodeClosestToPos)($from, (node)=>{
        return node.type.name === 'paragraph' || node.type.name === 'heading';
    })?.node;
    if (parent) return schema.nodes.doc.createChecked(null, schema.nodes[parent.type.name].createChecked(parent.attrs, fragment));
    else // If the node is a paragraph we need the parent to be a doc for the conversion to work correctly
    return schema.nodes.doc.createChecked(null, schema.nodes.paragraph.createChecked(null, fragment));
}
/**
 * This finds the closest list item parent to the current selection
 * Once found it will create a new list with the current fragment as its children
 */ function $b6f242e395dcdf98$var$createListItemWrapper(editorView, fragment) {
    const { schema: schema } = editorView.state;
    const { $from: $from } = editorView.state.selection;
    const parent = (0, $bjg0G.findParentNodeClosestToPos)($from, (node)=>node.type.name === 'bulletList' || node.type.name === 'orderedList')?.node;
    if (parent) return schema.nodes[parent.type.name].createChecked(parent.attrs, fragment);
    return fragment;
}
/**
 * If the first node is a task item we need to wrap it in a task list node for the markdown conversion to work properly
 */ function $b6f242e395dcdf98$var$createTaskItemWrapper(schema, fragment) {
    return schema.nodes.doc.createChecked(null, schema.nodes.taskList.createChecked(null, fragment));
}
function $b6f242e395dcdf98$var$createLayoutColumnWrapper(editorView, fragment) {
    const { schema: schema } = editorView.state;
    const parentSection = (0, $bjg0G.findParentNodeOfType)(schema.nodes.layoutSection)(editorView.state.selection);
    if (parentSection) // Needs to be a doc for the serializer to work as it
    // loops through the fragments children to render
    return schema.nodes.doc.createChecked(null, schema.nodes.layoutSection.createChecked(parentSection.node.attrs, fragment));
    return fragment;
}
/**
 * This function handles partial selections and it will fix any incomplete fragments that won't be converted properly
 * If you do a partial selection, it will not select the parent node of certain nodes text, listItems etc so once it hits the serializer
 * the serializer will just fallback to plain text and not convert the node properly.
 *
 * This function checks the first child of the current selection, if its a node that needs a parent it will find the closest parent
 * and create a new fragment that will be converted properly by the serializer
 */ function $b6f242e395dcdf98$var$checkFragment(editorView, schema, fragment) {
    switch(fragment?.firstChild?.type?.name){
        case 'text':
            return $b6f242e395dcdf98$var$createTextWrapper(editorView, fragment);
        case 'listItem':
            return $b6f242e395dcdf98$var$createListItemWrapper(editorView, fragment);
        case 'taskItem':
            return $b6f242e395dcdf98$var$createTaskItemWrapper(schema, fragment);
        case 'layoutColumn':
            return $b6f242e395dcdf98$var$createLayoutColumnWrapper(editorView, fragment);
        default:
            return fragment;
    }
}
function $b6f242e395dcdf98$export$cc6cac500a4da966({ editorView: editorView, fragment: fragment, featureToggles: featureToggles = {}, mentionMap: mentionMap = {}, idMap: idMap = {} }) {
    fragment = $b6f242e395dcdf98$var$checkFragment(editorView, editorView.state.schema, fragment);
    return $b6f242e395dcdf98$export$3d24004275aefeab({
        node: fragment,
        featureToggles: featureToggles,
        mentionMap: mentionMap,
        idMap: idMap
    });
}
function $b6f242e395dcdf98$export$3d24004275aefeab({ node: node, featureToggles: featureToggles = {}, mentionMap: mentionMap = {}, idMap: idMap = {} }) {
    const markdownSerializerState = new (0, $h2a2b.MarkdownSerializerState)(featureToggles, mentionMap, idMap);
    markdownSerializerState.renderContent(node);
    const pmStats = new (0, $3cHXJ.ProseMirrorContentStatistics)(node);
    const contentStatistics = pmStats.collectStatistics();
    const markdown = markdownSerializerState.out === '\u200c' ? '' : markdownSerializerState.out;
    return {
        markdown: markdown,
        fallbackState: markdownSerializerState.fallbackState,
        nonErrorFallbackState: markdownSerializerState.nonErrorFallbackState,
        idMap: markdownSerializerState.idMap,
        contentStatistics: contentStatistics
    };
}
module.exports["convertProsemirrorToMarkdown"] = $b6f242e395dcdf98$export$cc6cac500a4da966;
module.exports["convertProsemirrorNodeToMarkdown"] = $b6f242e395dcdf98$export$3d24004275aefeab;

});

parcelRegister("3cHXJ", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");

class $c4cbf946cacc0222$export$acf14785d7d5b1be {
    /**
   * Calculate statistics for the ProseMirror content such as node counts, mark counts and total character count.
   */ collectStatistics() {
        const { nodeCounts: nodeCounts, markCounts: markCounts, linksCount: linksCount, mentionsCount: mentionsCount } = this.countNodesAndMarks();
        const { totalCharacterCount: totalCharacterCount } = this.calculateCharacterCounts();
        return {
            nodeCounts: nodeCounts,
            markCounts: markCounts,
            linksCount: linksCount,
            mentionsCount: mentionsCount,
            totalCharacterCount: totalCharacterCount,
            contextSelectionScope: undefined
        };
    }
    countNodesAndMarks() {
        const nodeCounts = new Map();
        const markCounts = new Map();
        let linksCount = 0;
        let mentionsCount = 0;
        this.content.descendants((node)=>{
            nodeCounts.set(node.type.name, (nodeCounts.get(node.type.name) || 0) + 1);
            const marks = node.marks;
            marks.forEach((mark)=>{
                markCounts.set(mark.type.name, (markCounts.get(mark.type.name) || 0) + 1);
            });
            const { nodes: { inlineCard: inlineCard, mention: mention }, marks: { link: link } } = node.type.schema;
            if (node.type === mention) mentionsCount++;
            if (node.type === inlineCard && node.attrs.url) linksCount++;
            if (marks.find((mark)=>mark.type === link)) linksCount++;
        });
        return {
            nodeCounts: Object.fromEntries(nodeCounts),
            markCounts: Object.fromEntries(markCounts),
            linksCount: linksCount,
            mentionsCount: mentionsCount
        };
    }
    calculateCharacterCounts() {
        let allTextContent = '';
        if (this.content instanceof (0, $aPdNQ.Node)) allTextContent = this.content.textContent;
        else this.content.forEach((child)=>{
            allTextContent += child.textContent;
        });
        return {
            totalCharacterCount: allTextContent.length
        };
    }
    constructor(content){
        this.content = void 0;
        this.content = content;
    }
}
module.exports["ProseMirrorContentStatistics"] = $c4cbf946cacc0222$export$acf14785d7d5b1be;

});

parcelRegister("h2a2b", function(module, exports) {

var $2jzwX = parcelRequire("2jzwX");


var $aPdNQ = parcelRequire("aPdNQ");


var $9bzIP = parcelRequire("9bzIP");


var $9t7Od = parcelRequire("9t7Od");


var $jOZYJ = parcelRequire("jOZYJ");


var $2MdWj = parcelRequire("2MdWj");

// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $63a440ce8b406510$var$AT_BLANK_REGEX = /(^|\n)$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $63a440ce8b406510$var$TRAILING_WHITESPACE_REGEX = /\s+$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $63a440ce8b406510$var$INLINE_WHITESPACE_REGEX = /^(\s*)(.*?)(\s*)$/m;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $63a440ce8b406510$var$LEADING_BACKTICK_REGEX = /^`/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $63a440ce8b406510$var$TRAILING_BACKTICK_REGEX = /`$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $63a440ce8b406510$var$FOUR_SPACES_REGEX = /^\s{4}/;
const $63a440ce8b406510$export$1c401dbe379e8c65 = (()=>{
    function getMaxLength(text) {
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const matches = text.match(/`+/g) || [];
        return matches.reduce((prev, val)=>val.length > prev.length ? val : prev, '').length;
    }
    return function(text, minLength = 1) {
        const length = Math.max(minLength, getMaxLength(text) + 1);
        return (0, $2MdWj.stringRepeat)('`', length);
    };
})();
class $63a440ce8b406510$export$61055fa707e69319 extends (0, $2jzwX.MarkdownSerializerState) {
    /**
   *
   * @param state: MarkdownSerializerState
   * @param targetType: string
   * @param targetAttributes: Record<string, unknown>
   * @returns id of the state if the state is found in the idMap, otherwise returns null
   */ findStateIdMap(state, targetType, targetAttributes) {
        // eslint-disable-next-line guard-for-in
        for(const key in state.idMap){
            const { type: type, attributes: attributes } = state.idMap[key];
            // Check type first for early exit
            if (type !== targetType) continue;
            // Check if attributes match
            let attributesMatch = true;
            for(const attrKey in targetAttributes)// localId is a special attribute that is used to identify the node in the markdown and should be ignored on match
            if (attrKey !== 'localId' && targetAttributes[attrKey] !== attributes[attrKey]) {
                attributesMatch = false;
                break; // No need to check other attributes
            }
            if (attributesMatch) return key;
        }
        return null;
    }
    /**
   *
   * @param state: MarkdownSerializerState
   * @param type: string
   * @param attributes: Record<string, unknown>
   * @returns `id-[id]idMap` if the id is not found in the state
   */ getIdBasedOnIdMap(state, type, attributes) {
        const id = state.findStateIdMap(state, type, attributes);
        if (id) return id;
        return `id-${state.idCounter++}`;
    }
    updateFallbackState(error, child) {
        if (error instanceof Error) {
            const childTypeName = child.type.name;
            const errorMessage = error.message;
            const childFallbackState = this.fallbackState?.[childTypeName];
            Object.assign(this.fallbackState, {
                [childTypeName]: {
                    ...childFallbackState,
                    [errorMessage]: (childFallbackState?.[errorMessage] || 0) + 1
                }
            });
        } else throw error;
    }
    updateNonErrorFallbackState(node) {
        Object.assign(this.nonErrorFallbackState, {
            [node.type.name]: (this.nonErrorFallbackState[node.type.name] || 0) + 1
        });
    }
    /**
   * Defines the internal atBlank method used in the markdown serializer
   * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts#L241
   */ atBlank() {
        return $63a440ce8b406510$var$AT_BLANK_REGEX.test(this.out);
    }
    /**
   * Defines the internal flushClose method used in the markdown serializer
   * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts#L202
   */ flushClose(size = 2) {
        if (this.closed) {
            if (!this.atBlank()) this.out += '\n';
            if (size > 1) {
                let delimMin = this.delim;
                const trim = $63a440ce8b406510$var$TRAILING_WHITESPACE_REGEX.exec(delimMin);
                if (trim) delimMin = delimMin.slice(0, delimMin.length - trim[0].length);
                for(let i = 1; i < size; i++)this.out += delimMin + '\n';
            }
            this.closed = null;
        }
    }
    /**
   * This method overide adds support for "options"
   * options is an object that can be used to pass additional information to the node serializer
   *
   * This is useful when a grandparent node has information that needs to be passed to a grandchild node
   *
   * For example, a table node has information about whether or not the table has a header row
   * This information needs to be passed to the tableRow and tableCell node serializers so that it can render the correct markdown
   * @see MarkdownSerializerState.render()
   */ render(node, parent, index, options) {
        if (!this.nodes[node.type.name]) throw new Error(`Token type \`${node.type.name}\` not supported by Markdown renderer`);
        if (options?.skipFallback) this.nodes[node.type.name].serialize({
            state: this,
            node: node,
            parent: parent,
            index: index,
            options: options
        });
        else try {
            this.nodes[node.type.name].serialize({
                state: this,
                node: node,
                parent: parent,
                index: index,
                options: options
            });
        } catch (error) {
            this.updateFallbackState(error, node);
            return this.nodes.fallback.serialize({
                state: this,
                node: node,
                parent: parent,
                index: index
            });
        }
    }
    renderContent(parent) {
        parent.forEach((child, _offset, index)=>{
            if (// If child is an empty Textblock we need to insert a zwnj-character in order to preserve that line in markdown
            child.isTextblock && !child.textContent && // If child is a Codeblock we need to handle this separately as we want to preserve empty code blocks
            !(child.type.name === 'codeBlock') && !(child.content && child.content.size > 0)) return this.nodes.empty_line.serialize({
                state: this,
                node: child,
                parent: parent,
                index: index
            });
            try {
                return this.render(child, parent, index);
            } catch (error) {
                this.updateFallbackState(error, child);
                return this.nodes.fallback.serialize({
                    state: this,
                    node: child,
                    parent: parent,
                    index: index
                });
            }
        });
    }
    /**
   * This method override will properly escape backticks in text nodes with "code" mark enabled.
   * Bitbucket uses python-markdown which does not honor escaped backtick escape sequences \`
   * inside a backtick fence.
   *
   * @see MarkdownSerializerState.renderInline()
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderInline(parent, options) {
        const active = [];
        let trailing = '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const progress = (node, _, index)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            let marks = node ? node.marks.filter((mark)=>this.marks[mark.type.name]) : [];
            let leading = trailing;
            trailing = '';
            // If whitespace has to be expelled from the node, adjust
            // leading and trailing accordingly.
            if (node && node.isText && marks.some((mark)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const info = this.marks[mark.type.name];
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return info && info.expelEnclosingWhitespace;
            })) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const [, lead, inner, trail] = $63a440ce8b406510$var$INLINE_WHITESPACE_REGEX.exec(node.text);
                leading += lead;
                trailing = trail;
                if (lead || trail) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    node = inner ? node.withText(inner) : null;
                    if (!node) marks = active;
                }
            }
            const code = marks.length && marks[marks.length - 1].type.name === 'code' && marks[marks.length - 1];
            const len = marks.length - (code ? 1 : 0);
            // Try to reorder 'mixable' marks, such as em and strong, which
            // in Markdown may be opened and closed in different order, so
            // that order of the marks for the token matches the order in
            // active.
            // eslint-disable-next-line no-labels
            outer: for(let i = 0; i < len; i++){
                const mark = marks[i];
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (!this.marks[mark.type.name].mixable) break;
                for(let j = 0; j < active.length; j++){
                    const other = active[j];
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    if (!this.marks[other.type.name].mixable) break;
                    if (mark.eq(other)) {
                        if (i > j) marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));
                        else if (j > i) marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
                        continue outer;
                    }
                }
            }
            // Find the prefix of the mark set that didn't change
            let keep = 0;
            while(keep < Math.min(active.length, len) && marks[keep].eq(active[keep]))++keep;
            // Close the marks that need to be closed
            while(keep < active.length)// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.text(this.markString(active.pop(), false, parent, index), false);
            // Output any previously expelled trailing whitespace outside the marks
            if (leading) this.text(leading);
            // Open the marks that need to be opened
            while(active.length < len){
                const add = marks[active.length];
                active.push(add);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.text(this.markString(add, true, parent, index), false);
            }
            if (node) {
                if (!code || !node.isText) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                this.render(node, parent, index);
                else if (node.text) {
                    // Generate valid monospace, fenced with series of backticks longer that backtick series inside it.
                    let text = node.text;
                    const backticks = $63a440ce8b406510$export$1c401dbe379e8c65(node.text, 1);
                    // Make sure there is a space between fences, otherwise python-markdown renderer will get confused
                    if (text.match($63a440ce8b406510$var$LEADING_BACKTICK_REGEX)) text = ' ' + text;
                    if (text.match($63a440ce8b406510$var$TRAILING_BACKTICK_REGEX)) text += ' ';
                    this.text(backticks + text + backticks, false);
                }
            }
        };
        parent.forEach((child, _offset, index)=>{
            if (options?.skipFallback) progress(child, parent, index);
            else try {
                progress(child, parent, index);
            } catch (error) {
                this.updateFallbackState(error, child);
            }
        });
        progress(null);
    }
    addBlockMarks(state, node, renderFunction) {
        const closingTags = [];
        // This is temporary, only adding the marks that we support, once we get full support this will be removed
        const markFilters = [
            'alignment',
            'breakout',
            'border'
        ];
        const marks = node.marks.filter((mark)=>markFilters.includes(mark.type.name));
        if (marks.length === 0) {
            renderFunction();
            return;
        }
        marks.forEach((mark)=>{
            const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, mark.type.name, mark.attrs) : `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: mark.type.name,
                attributes: mark.attrs
            };
            state.write(`<custom data-type="${mark.type.name}_open" data-id="${id}" />\n\n`);
            closingTags.unshift(`<custom data-type="${mark.type.name}_close" />\n\n`);
        });
        renderFunction();
        state.write(closingTags.join(''));
    }
    constructor(featureToggles, mentionMap, idMap){
        // @ts-ignore -next-line
        super($63a440ce8b406510$export$695720b7e7a61533, $63a440ce8b406510$export$3a8025f2f3e0c64, {});
        // ignoring as generated types for node serializer is inaccurate
        // parent and index in node serializers should be optional
        // Typing this as a string -- to override the PMMarkdownSerializerState type of any
        // In the confluence build -- this results in the out property being set to undefined in the constructor
        // whereas in the dev server this is stripped when the code is transpiled.
        // When it is used in transpilation -- "undefined" is added to the start of the generated text
        // out: string;
        this.idMap = {};
        this.idCounter = 0;
        this.nodes = void 0;
        this.marks = void 0;
        this.featureToggles = {};
        this.mentionMap = {};
        /**
     * Defines the internal variables used in the markdown serializer
     * @see https://github.com/ProseMirror/prosemirror-markdown/blob/master/src/to_markdown.ts#L172
     */ this.delim = '';
        this.out = '';
        this.closed = null;
        /**
     * This is used to track the number of times a node has failed to render
     * This is useful for debugging purposes
     * - the key is the node type name
     * - the value is an object with
     *   - the error message as the key
     *   - and the number of times it has failed to render with that message as the value.
     */ this.fallbackState = {};
        /**
     * This is used to track the number of times a node has rendered
     * but has not completely converted to markdown
     * For example: Tables are supported in markdown, however we currently do not have full support
     * So we fallback to the simplest version of the node that our serializer can support
     */ this.nonErrorFallbackState = {};
        this.context = {
            insideTable: false
        };
        this.nodes = $63a440ce8b406510$export$695720b7e7a61533;
        this.marks = $63a440ce8b406510$export$3a8025f2f3e0c64;
        this.featureToggles = featureToggles || {};
        this.mentionMap = mentionMap || {};
        this.idMap = idMap || {};
        this.idCounter = Object.keys(this.idMap).length;
    }
}
const $63a440ce8b406510$var$editorNodes = {
    blockquote: {
        serialize ({ state: state, node: node }) {
            state.wrapBlock('> ', null, node, ()=>state.renderContent(node));
        },
        support: 'full'
    },
    codeBlock: {
        serialize ({ state: state, node: node }) {
            const backticks = $63a440ce8b406510$export$1c401dbe379e8c65(node.textContent, 3);
            state.write(backticks + (node.attrs.language || '') + '\n');
            state.text(node.textContent ? node.textContent : '\u200c', false);
            state.ensureNewLine();
            state.write(backticks);
            state.closeBlock(node);
        },
        support: 'full'
    },
    heading: {
        serialize ({ state: state, node: node }) {
            state.write(state.repeat('#', node.attrs.level) + ' ');
            state.renderInline(node);
            state.closeBlock(node);
        },
        support: 'full'
    },
    rule: {
        serialize ({ state: state, node: node }) {
            state.write(node.attrs.markup || '---');
            state.closeBlock(node);
        },
        support: 'full'
    },
    bulletList: {
        serialize ({ state: state, node: node }) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'full'
    },
    orderedList: {
        serialize ({ state: state, node: node }) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'full'
    },
    listItem: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            const order = (0, $jOZYJ.getOrderFromMaybeOrderedListNode)(parent);
            const delimiter = parent.type.name === 'bulletList' ? '* ' : `${order + index}. `;
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                // if at second child or more of list item, add a newline
                if (i > 0) state.write('\n');
                // if at first child of list item, add delimiter (e.g "1.").
                // if at second child or more of list item, only add spacing (not delimiter)
                if (i === 0) state.wrapBlock('  ', delimiter, node, ()=>state.render(child, parent, i));
                else state.wrapBlock('    ', null, node, ()=>state.render(child, parent, i));
                if (child.type.name === 'paragraph' && i > 0) state.write('\n');
                state.flushClose(1);
            }
            // if we're at the final list item, add a final closing newline
            if (index === parent.childCount - 1) state.write('\n');
        },
        support: 'full'
    },
    taskList: {
        serialize ({ state: state, node: node }) {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
                state.write('\n');
            }
            state.write('\n');
        },
        support: 'full'
    },
    taskItem: {
        serialize ({ state: state, node: node }) {
            const taskItemState = node.attrs.state;
            state.write(taskItemState === 'TODO' ? '- [ ] ' : '- [x] ');
            state.renderInline(node);
        },
        support: 'full'
    },
    paragraph: {
        serialize ({ state: state, node: node }) {
            state.renderInline(node);
            state.closeBlock(node);
        },
        support: 'full'
    },
    mediaGroup: {
        serialize ({ state: state, node: node }) {
            state.updateNonErrorFallbackState(node);
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'fallback'
    },
    mediaInline: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'mediaInline',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="mediaInline" data-id="${id}"></custom>`);
            });
        },
        support: 'preview'
    },
    mediaSingle: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'mediaSingle', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'mediaSingle',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="media_single_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="media_single_close" />\n\n`);
            });
            else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
                /**
         * Currently, if the parent is a node we assume that mediaSingle is nested (e.g. inside a
         * table or list). In these cases we only output \n as there is often already new lines added
         * by the parent node.
         * Otherwise, if mediaSingle is not nested we add an extra new line.
         */ if (parent instanceof (0, $aPdNQ.Node)) state.write('\n');
                else state.write('\n\n');
            }
        },
        support: 'preview'
    },
    caption: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'caption', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'caption',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="caption_open" data-id="${id}" />\n\n`);
                try {
                    state.renderInline(node, {
                        skipFallback: true
                    });
                } catch (error) {
                    state.updateFallbackState(error, node);
                    state.nodes.fallback.serialize({
                        state: state,
                        node: node,
                        parent: parent,
                        index: index
                    });
                }
                // captions do not contain paragraphs, so we need to add a newline after the content
                state.write(`\n\n<custom data-type="caption_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                state.write(node.textContent);
            }
        },
        support: 'preview'
    },
    media: {
        serialize ({ state: state, node: node }) {
            // Creating this fake URl allows us to pass the media attributes to the markdown without using markdown plus
            // Which allows image retention when using rovo since it doesn't support markdown plus
            const baseUrl = `blob:${(0, $9t7Od.MEDIA_BASE_URL_STAGING)}/?`;
            const queryString = Object.entries(node.attrs).map(([key, value])=>key !== 'alt' ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` : ``).join('&');
            const fakeUrl = `${baseUrl}${queryString}`;
            state.write(`![](${fakeUrl})${state.featureToggles.markdownPlusAddComplexNodes ? '\n\n' : ''}`);
        },
        support: 'full'
    },
    image: {
        serialize ({ state: state, node: node }) {
            // Note: the 'title' is not escaped in this flavor of markdown.
            state.write('![' + (0, $2MdWj.escapeMarkdown)(node.attrs.alt) + '](' + node.attrs.src + (node.attrs.title ? ` '${(0, $2MdWj.escapeMarkdown)(node.attrs.title)}'` : '') + ')');
        },
        support: 'full'
    },
    hardBreak: {
        serialize ({ state: state }) {
            state.write('  \n');
        },
        support: 'full'
    },
    text: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            const previousNode = index === 0 ? null : parent.child(index - 1);
            let text = node.textContent;
            // BB converts 4 spaces at the beginning of the line to code block
            // that's why we escape 4 spaces with zero-width-non-joiner
            const fourSpaces = '    ';
            if (!previousNode && $63a440ce8b406510$var$FOUR_SPACES_REGEX.test(node.textContent)) text = node.textContent.replace(fourSpaces, '\u200c' + fourSpaces);
            const lines = text.split('\n');
            for(let i = 0; i < lines.length; i++){
                const startOfLine = state.atBlank() || !!state.closed;
                state.write();
                state.out += (0, $2MdWj.escapeMarkdown)(lines[i], startOfLine, state.context.insideTable);
                if (i !== lines.length - 1) {
                    if (lines[i] && lines[i].length && lines[i + 1] && lines[i + 1].length) state.out += '  ';
                    state.out += '\n';
                }
            }
            // This is so we can determine which marks are most used that aren't being converted to markdown
            node.marks.forEach((mark)=>{
                // @ts-expect-error
                if (!$63a440ce8b406510$export$3a8025f2f3e0c64[mark.type.name]) state.updateNonErrorFallbackState(mark);
            });
        },
        support: 'full'
    },
    empty_line: {
        serialize ({ state: state, node: node }) {
            state.write('\u200c'); // zero-width-non-joiner
            state.closeBlock(node);
        },
        support: 'full'
    },
    placeholder: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'placeholder', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'placeholder',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="placeholder" data-id="${id}">${node.attrs.text}</custom>`);
            }
        },
        support: 'custom'
    },
    mention: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            const isLastNode = parent.childCount === index + 1;
            let delimiter = '';
            if (!isLastNode) {
                const nextNode = parent.child(index + 1);
                const nextNodeHasLeadingSpace = nextNode.textContent.indexOf(' ') === 0;
                delimiter = nextNodeHasLeadingSpace ? '' : ' ';
            }
            // Get the name from the map
            const name = state.mentionMap[node.attrs.id] || '';
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'mention', {
                    ...node.attrs,
                    text: `@${name}`
                }) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'mention',
                    // Update the attributes to include resolved name
                    attributes: {
                        ...node.attrs,
                        text: `@${name}`
                    }
                };
                if (state.featureToggles.markdownPlusAttributeTest) {
                    // @ts-expect-error
                    node.attrs.text = `@${name}`;
                    state.write(`<custom data-type="mention" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">@${name}</custom>`);
                } else state.write(`<custom data-type="mention" data-id="${id}">@${name}</custom>`);
            } else state.write(`${name}${delimiter}`);
        },
        support: 'custom'
    },
    date: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'date', node.attrs) : `id-${state.idCounter++}`;
                // Ensure localId is explicitly set to null if not present
                const attributes = {
                    ...node.attrs,
                    localId: node.attrs.localId ?? null
                };
                state.idMap[id] = {
                    type: 'date',
                    attributes: attributes
                };
                if (state.featureToggles.markdownPlusAttributeTest) state.write(`<custom data-type="date" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">${new Intl.DateTimeFormat().format(Number(node.attrs.timestamp))}</custom>`);
                else state.write(`<custom data-type="date" data-id="${id}">${new Intl.DateTimeFormat().format(Number(node.attrs.timestamp))}</custom>`);
            } else state.write(new Intl.DateTimeFormat().format(Number(node.attrs.timestamp)));
        },
        support: 'custom'
    },
    emoji: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'emoji', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'emoji',
                    attributes: node.attrs
                };
                if (state.featureToggles.markdownPlusAttributeTest) state.write(`<custom data-type="emoji" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">${node.attrs.shortName}</custom>`);
                else state.write(`<custom data-type="emoji" data-id="${id}">${node.attrs.shortName}</custom>`);
            } else state.write(node.attrs.shortName);
        },
        support: 'custom'
    },
    inlineCard: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'inlineCard', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'inlineCard',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="smartlink" data-id="${id}">${node.attrs.url}</custom>`);
            } else state.write(`[${node.attrs.url}](${node.attrs.url})`);
        },
        support: 'custom'
    },
    status: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'status', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'status',
                    attributes: node.attrs
                };
                if (state.featureToggles.markdownPlusAttributeTest) state.write(`<custom data-type="status" data-id="${id}" data-attrs="${JSON.stringify(node.attrs)}">${node.attrs.text}</custom>`);
                else state.write(`<custom data-type="status" data-id="${id}">${node.attrs.text}</custom>`);
            } else // this will trigger the fallback conversion (text)
            throw new Error('Token type `status` not supported by Markdown renderer');
        },
        support: 'custom'
    },
    layoutSection: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'layoutSection', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'layoutSection',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="layoutSection_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="layoutSection_close" />\n\n`);
            });
            else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    layoutColumn: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'layoutColumn', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'layoutColumn',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="layoutColumn_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="layoutColumn_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    expand: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) state.addBlockMarks(state, node, ()=>{
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'expand', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'expand',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="expand_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="expand_close" />\n\n`);
            });
            else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    nestedExpand: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'nestedExpand', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'nestedExpand',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="nestedExpand_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="nestedExpand_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'preview'
    },
    panel: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusPanels) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'panel', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'panel',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="panel_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="panel_close" />\n\n`);
            } else {
                state.updateNonErrorFallbackState(node);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
            }
        },
        support: 'custom'
    },
    blockCard: {
        serialize ({ state: state, node: node }) {
            state.write(`[${node.attrs.url}](${node.attrs.url})`);
        },
        support: 'full'
    },
    embedCard: {
        serialize ({ state: state, node: node }) {
            state.write(`[${node.attrs.url}](${node.attrs.url})`);
        },
        support: 'full'
    },
    decisionList: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusDecisions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'decisionList', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'decisionList',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="decisionList_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
                state.write(`<custom data-type="decisionList_close" />\n\n`);
            } else {
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    state.render(child, node, i);
                }
                state.write(`\n\n`);
            }
        },
        support: 'custom'
    },
    decisionItem: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusDecisions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'decisionItem', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'decisionItem',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="decisionItem_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`\n\n<custom data-type="decisionItem_close" />\n\n`);
            } else for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'custom'
    },
    extension: {
        serialize ({ state: state, node: node }) {
            // For native embed extension nodes, output the embedded URL as a markdown link
            // so that it's visible to Rovo (same as embedCard/blockCard serialization)
            if (node.attrs.extensionKey?.startsWith('native-embed:')) {
                const url = node.attrs.parameters?.macroParams?.url?.value;
                if (url) {
                    state.write(`[${url}](${url})`);
                    return;
                }
            }
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'extension', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'extension',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="extension" data-id="${id}" />\n\n`);
            }
        },
        support: 'custom'
    },
    inlineExtension: {
        serialize ({ state: state, node: node }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'inlineExtension', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'inlineExtension',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="inlineExtension" data-id="${id}"></custom>`);
            }
        },
        support: 'custom'
    },
    bodiedExtension: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusExtensions) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'bodiedExtension', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'bodiedExtension',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="bodiedExtension_open" data-id="${id}" />\n\n`);
                for(let i = 0; i < node.childCount; i++){
                    const child = node.child(i);
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                }
                state.write(`<custom data-type="bodiedExtension_close" />\n\n`);
            } else for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
        },
        support: 'custom'
    },
    fallback: {
        serialize ({ state: state, node: node }) {
            // If PMNode is an unhandled block node, we need to add a newline
            // after the content to prevent the next line from being rendered as
            // part of the block node.
            if (node.isBlock) state.write(`${node.textContent || node.attrs.text || ''}\n\n`);
            else state.write(node.textContent || node.attrs.text || '');
        },
        support: 'fallback'
    }
};
const $63a440ce8b406510$export$695720b7e7a61533 = {
    ...$63a440ce8b406510$var$editorNodes,
    ...(0, $9bzIP.default)
};
const $63a440ce8b406510$export$3a8025f2f3e0c64 = {
    em: {
        open: '_',
        close: '_',
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strong: {
        open: '**',
        close: '**',
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strike: {
        open: '~~',
        close: '~~',
        mixable: true,
        expelEnclosingWhitespace: true
    },
    link: {
        open: '[',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        close (_state, mark) {
            return '](' + mark.attrs['href'] + ')';
        }
    },
    code: {
        open: '`',
        close: '`'
    }
};
module.exports["MarkdownSerializerState"] = $63a440ce8b406510$export$61055fa707e69319;

});

parcelRegister("9bzIP", function(module, exports) {

var $3nCzG = parcelRequire("3nCzG");

const $3b8284ec19aad1fa$var$isHeaderRow = (row)=>row.child(0).type.name === 'tableHeader';
const $3b8284ec19aad1fa$var$isFirstRow = (row, parent)=>parent.content.child(0) === row;
const $3b8284ec19aad1fa$var$isHeaderRowPresent = (table)=>{
    let headerRowPresent = false;
    table.content.forEach((row)=>{
        if ($3b8284ec19aad1fa$var$isHeaderRow(row)) headerRowPresent = true;
    });
    return headerRowPresent;
};
const $3b8284ec19aad1fa$var$renderNode = (state, node, index)=>{
    if (index > 0) state.write(' ');
    node.content.forEach((child, i)=>{
        if (child.isTextblock || child.type.name === 'mediaSingle') {
            if (i > 0) state.write(' ');
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            state.context.insideTable = true;
            state.renderInline(child);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            state.context.insideTable = false;
        } else $3b8284ec19aad1fa$var$renderNode(state, child, i);
    });
};
const $3b8284ec19aad1fa$var$renderInlineContent = ({ state: state, node: node })=>{
    state.write('| ');
    $3b8284ec19aad1fa$var$renderNode(state, node, 0);
    state.write(' ');
};
const $3b8284ec19aad1fa$var$tableNodes = {
    table: {
        serialize ({ state: state, node: node, parent: parent, index: index }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="table_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>state.render(child, node, i));
                state.write(`<custom data-type="table_close" />\n\n`);
            } else {
                if (!(0, $3nCzG.attributesMatchDefault)(node, state.featureToggles, {
                    layout: node.attrs.layout,
                    localId: node.attrs.localId,
                    width: 760
                })) state.updateNonErrorFallbackState(node);
                const headerRowPresent = $3b8284ec19aad1fa$var$isHeaderRowPresent(node);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            headerRowPresent: headerRowPresent,
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.closeBlock(node);
            }
        },
        support: 'partial'
    },
    tableRow: {
        serialize ({ state: state, node: node, parent: parent, index: index, options: options }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="tr_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="tr_close" />\n\n`);
            } else {
                if (!(0, $3nCzG.attributesMatchDefault)(node, state.featureToggles)) state.updateNonErrorFallbackState(node);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            ...options,
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write('|');
                state.ensureNewLine();
                if ($3b8284ec19aad1fa$var$isHeaderRow(node) || $3b8284ec19aad1fa$var$isFirstRow(node, parent)) {
                    for(let i = 0; i < node.childCount; i++)state.write('| --- ');
                    state.write('|');
                    state.ensureNewLine();
                }
            }
        },
        support: 'partial'
    },
    tableHeader: {
        serialize ({ state: state, node: node, parent: parent, index: index, options: options }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="th_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="th_close" />\n\n`);
            } else {
                if (!(0, $3nCzG.attributesMatchDefault)(node, state.featureToggles)) state.updateNonErrorFallbackState(node);
                $3b8284ec19aad1fa$var$renderInlineContent({
                    state: state,
                    node: node,
                    parent: parent,
                    index: index,
                    options: options
                });
            }
        },
        support: 'partial'
    },
    tableCell: {
        serialize ({ state: state, node: node, parent: parent, index: index, options: options }) {
            if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusAddComplexNodes) {
                const id = state.featureToggles.markdownPlusAvoidDuplicatedIdCounter ? state.getIdBasedOnIdMap(state, 'table', node.attrs) : `id-${state.idCounter++}`;
                state.idMap[id] = {
                    type: 'table',
                    attributes: node.attrs
                };
                state.write(`<custom data-type="td_open" data-id="${id}" />\n\n`);
                node.content.forEach((child, i)=>{
                    try {
                        state.render(child, node, i, {
                            skipFallback: true
                        });
                    } catch (error) {
                        state.updateFallbackState(error, node);
                        state.nodes.fallback.serialize({
                            state: state,
                            node: node,
                            parent: parent,
                            index: index
                        });
                    }
                });
                state.write(`<custom data-type="td_close" />\n\n`);
            } else {
                if (!(0, $3nCzG.attributesMatchDefault)(node, state.featureToggles)) state.updateNonErrorFallbackState(node);
                $3b8284ec19aad1fa$var$renderInlineContent({
                    state: state,
                    node: node,
                    parent: parent,
                    index: index,
                    options: options
                });
            }
        },
        support: 'partial'
    }
};
var $3b8284ec19aad1fa$export$2e2bcd8739ae039 = $3b8284ec19aad1fa$var$tableNodes;
module.exports["default"] = $3b8284ec19aad1fa$export$2e2bcd8739ae039;

});

parcelRegister("3nCzG", function(module, exports) {
const $1a2f04a85d2bd5e4$export$5be26e657c035da4 = (node, featureToggles, overrideDefaults = {})=>{
    if (!featureToggles.allowAttributesMatchDefault) return true;
    // @ts-expect-error - node.type.attrs does not exist in nodeType type, but it does exist.
    const nodeTypeAttrs = node.type.attrs;
    if (!nodeTypeAttrs || Object.keys(nodeTypeAttrs).length === 0 && Object.keys(node.attrs).length === 0) return true;
    const defaultAttrs = {};
    Object.keys(nodeTypeAttrs).forEach((key)=>{
        defaultAttrs[key] = nodeTypeAttrs[key].default;
    });
    // The actual node defaults don't match the node defaults when interacting with a page
    // So we override for a correct comparison
    Object.keys(overrideDefaults).forEach((key)=>{
        defaultAttrs[key] = overrideDefaults[key];
    });
    // Compare the node attributes to the default attributes
    for(const key in node.attrs){
        if (node.attrs[key] !== defaultAttrs[key]) return false;
    }
    return true;
};
module.exports["attributesMatchDefault"] = $1a2f04a85d2bd5e4$export$5be26e657c035da4;

});

parcelRegister("9t7Od", function(module, exports) {
const $3e354f9230625cfb$export$53fd140c96bc558 = 'https://media.staging.atl-paas.net';
module.exports["MEDIA_BASE_URL_STAGING"] = $3e354f9230625cfb$export$53fd140c96bc558;

});

parcelRegister("jOZYJ", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");

const $2fc5fefa720a7491$export$8ef94ae42a3729bd = 1;
const $2fc5fefa720a7491$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $2fc5fefa720a7491$export$4ea3c6bbdf8f7944 = (maybeOrderedListNode)=>{
    if (!(maybeOrderedListNode instanceof (0, $aPdNQ.Node))) return $2fc5fefa720a7491$export$8ef94ae42a3729bd;
    const order = maybeOrderedListNode?.attrs?.order;
    return $2fc5fefa720a7491$export$d445360e2a3c026b(order) ?? $2fc5fefa720a7491$export$8ef94ae42a3729bd;
};
module.exports["getOrderFromMaybeOrderedListNode"] = $2fc5fefa720a7491$export$4ea3c6bbdf8f7944;

});

parcelRegister("2MdWj", function(module, exports) {
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e99fb8d9fbca0ae0$var$USERNAME_MATCH_REGEX = /^@(.*?)$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e99fb8d9fbca0ae0$var$EMOJI_SHORTNAME_REGEX = /([^\/]+)\.[^\/]+$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e99fb8d9fbca0ae0$var$WORD_CHAR_REGEX = /\w/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e99fb8d9fbca0ae0$var$ESCAPE_LINE_START_REGEX = /^(\+[ ]|[\-*>])/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e99fb8d9fbca0ae0$var$ESCAPE_HEADING_REGEX = /^(\s*)(#{1,6})(\s|$)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e99fb8d9fbca0ae0$var$ESCAPE_ORDERED_LIST_REGEX = /^(\s*\d+)\.\s/;
function $e99fb8d9fbca0ae0$export$345d822805ab3239(text, length) {
    let result = '';
    for(let x = 0; x < length; x++)result += text;
    return result;
}
function $e99fb8d9fbca0ae0$export$560888d6fe0cfe97(str, startOfLine, insideTable) {
    let strToEscape = str || '';
    // Ignored via go/ees005, go/ees019
    // eslint-disable-next-line require-unicode-regexp, e18e/prefer-static-regex
    strToEscape = strToEscape.replace(/[`*\\~\[\]_]/g, (m, i)=>m === '_' && i > 0 && i + 1 < str.length && str[i - 1].match($e99fb8d9fbca0ae0$var$WORD_CHAR_REGEX) && str[i + 1].match($e99fb8d9fbca0ae0$var$WORD_CHAR_REGEX) ? m : '\\' + m);
    if (startOfLine) strToEscape = strToEscape.replace($e99fb8d9fbca0ae0$var$ESCAPE_LINE_START_REGEX, '\\$&').replace($e99fb8d9fbca0ae0$var$ESCAPE_HEADING_REGEX, '$1\\$2$3').replace($e99fb8d9fbca0ae0$var$ESCAPE_ORDERED_LIST_REGEX, '$1\\. ');
    if (insideTable) // Ignored via go/ees005, go/ees019
    // eslint-disable-next-line require-unicode-regexp, e18e/prefer-static-regex
    strToEscape = strToEscape.replace(/[|]/g, '\\$&');
    return strToEscape;
}
function $e99fb8d9fbca0ae0$var$removeSpecialCharacters(node) {
    if (node.nodeType === 3 && node.textContent) // Ignored via go/ees005, go/ees019
    // eslint-disable-next-line require-unicode-regexp, e18e/prefer-static-regex
    node.textContent = node.textContent.replace(/\u200c|↵/g, '');
    Array.from(node.childNodes).forEach((child)=>$e99fb8d9fbca0ae0$var$removeSpecialCharacters(child));
}
function $e99fb8d9fbca0ae0$export$9c95763b5a419f4c(html, options) {
    const el = document.createElement('div');
    el.innerHTML = html;
    // Remove zero-width-non-joiner
    Array.from(el.querySelectorAll('p')).forEach((p)=>{
        $e99fb8d9fbca0ae0$var$removeSpecialCharacters(p);
    });
    // Convert mention containers, i.e.:
    //   <a href="/abodera/" rel="nofollow" title="@abodera" class="mention mention-me">Artur Bodera</a>
    Array.from(el.querySelectorAll('a.mention, a.ap-mention')).forEach((a)=>{
        const span = document.createElement('span');
        span.setAttribute('class', 'editor-entity-mention');
        span.setAttribute('contenteditable', 'false');
        const atlassianId = a.getAttribute('data-atlassian-id') || '';
        if (atlassianId) // Atlassian ID is wrapped in curlies so that it get serialized as @{aid-id} instead of @aid-id
        span.setAttribute('data-mention-id', `{${atlassianId}}`);
        else {
            const title = a.getAttribute('title') || '';
            if (title) {
                const usernameMatch = title.match($e99fb8d9fbca0ae0$var$USERNAME_MATCH_REGEX);
                if (usernameMatch) {
                    const username = usernameMatch[1];
                    span.setAttribute('data-mention-id', username);
                }
            }
        }
        const text = a.textContent || '';
        if (text.indexOf('@') === 0) span.textContent = a.textContent;
        else span.textContent = `@${a.textContent}`;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        a.parentNode.insertBefore(span, a);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        a.parentNode.removeChild(a);
    });
    // Convert mention containers, i.e.:
    //   <span class="ap-mention" data-atlassian-id="5c09bf77ec71bd223bbe866f">@Scott Demo</span>
    Array.from(el.querySelectorAll('span.ap-mention')).forEach((s)=>{
        const span = document.createElement('span');
        span.setAttribute('class', 'editor-entity-mention');
        span.setAttribute('contenteditable', 'false');
        const atlassianId = s.getAttribute('data-atlassian-id') || '';
        span.setAttribute('data-mention-id', `{${atlassianId}}`);
        const text = s.textContent || '';
        span.textContent = text.indexOf('@') === 0 ? text : `@${text}`;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        s.parentNode.insertBefore(span, s);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        s.parentNode.removeChild(s);
    });
    // Parse emojis i.e.
    //     <img src="https://d301sr5gafysq2.cloudfront.net/207268dc597d/emoji/img/diamond_shape_with_a_dot_inside.svg" alt="diamond shape with a dot inside" title="diamond shape with a dot inside" class="emoji">
    Array.from(el.querySelectorAll('img.emoji')).forEach((img)=>{
        const span = document.createElement('span');
        let shortName = img.getAttribute('data-emoji-short-name') || '';
        if (!shortName) {
            // Fallback to parsing Bitbucket's src attributes to find the
            // short name
            const src = img.getAttribute('src');
            const idMatch = !src ? false : src.match($e99fb8d9fbca0ae0$var$EMOJI_SHORTNAME_REGEX);
            if (idMatch) shortName = `:${decodeURIComponent(idMatch[1])}:`;
        }
        if (shortName) span.setAttribute('data-emoji-short-name', shortName);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.insertBefore(span, img);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.removeChild(img);
    });
    if (!options.disableBitbucketLinkStripping) // Convert all automatic links to plain text, because they will be re-created on render by the server
    Array.from(el.querySelectorAll('a'))// Don't convert external links (i.e. not automatic links)
    .filter((a)=>a.getAttribute('data-is-external-link') !== 'true' && a.getAttribute('data-inline-card') === null).forEach((a)=>{
        Array.from(a.childNodes).forEach((child)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            a.parentNode.insertBefore(child, a);
        });
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        a.parentNode.removeChild(a);
    });
    // Parse images
    // Not using :pseudo because of IE11 bug:
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/16104908/
    Array.from(el.querySelectorAll('img')).filter((img)=>!img.classList.contains('emoji')).forEach((img)=>{
        const { parentNode: parentNode } = img;
        if (!parentNode) return;
        /**
     * Lift image node if parent isn't the root-element
     */ if (parentNode !== el) {
            const isValidPath = validateImageNodeParent(parentNode);
            if (!isValidPath) liftImageNode(parentNode, img);
        }
        /**
     * Replace image with media node
     */ const mediaSingle = document.createElement('div');
        mediaSingle.setAttribute('data-node-type', 'mediaSingle');
        const media = document.createElement('div');
        media.setAttribute('data-node-type', 'media');
        media.setAttribute('data-type', 'external');
        media.setAttribute('data-alt', img.getAttribute('alt') || '');
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        media.setAttribute('data-url', img.getAttribute('src'));
        mediaSingle.appendChild(media);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.insertBefore(mediaSingle, img);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        img.parentNode.removeChild(img);
    });
    function validateImageNodeParent(node) {
        const ALLOWED_PARENTS = [
            'LI',
            'UL',
            'OL',
            'TD',
            'TH',
            'TR',
            'TBODY',
            'THEAD',
            'TABLE'
        ];
        if (node === el) return true;
        if (ALLOWED_PARENTS.indexOf(node.nodeName) === -1) return false;
        if (!node.parentNode) return false;
        return validateImageNodeParent(node.parentNode);
    }
    function liftImageNode(node, img) {
        let foundParent = false;
        let parent = node;
        while(!foundParent){
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            foundParent = validateImageNodeParent(parent.parentNode);
            if (!foundParent) // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            parent = parent.parentNode;
        }
        const cloned = parent.cloneNode();
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const target = parent !== el ? parent.parentNode : el;
        while(img.nextSibling)cloned.appendChild(img.nextSibling);
        if (node !== parent) while(node.nextSibling)cloned.appendChild(node.nextSibling);
        if (parent.nextSibling) {
            target.insertBefore(cloned, parent.nextSibling);
            target.insertBefore(img, cloned);
        } else {
            target.appendChild(img);
            target.appendChild(cloned);
        }
        /**
     * If the splitting operation results in
     * the old parent being empty, remove it
     */ if (node.childNodes.length === 0) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        node.parentNode.removeChild(node);
        /**
     * Remove cloned element if it's empty.
     */ if (cloned.childNodes.length === 0) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        cloned.parentNode.removeChild(cloned);
    }
    return el;
}
module.exports["stringRepeat"] = $e99fb8d9fbca0ae0$export$345d822805ab3239;
module.exports["escapeMarkdown"] = $e99fb8d9fbca0ae0$export$560888d6fe0cfe97;

});

parcelRegister("htTUm", function(module, exports) {
/**
 * This file was cloned from https://bitbucket.org/atlassian/pf-adf-service/src/master/src/lib/converters/markdownPlus-to-adf.ts and slightly modified to work in the browser.
 */ 
var $4XbfY = parcelRequire("4XbfY");


var $3xuv0 = parcelRequire("3xuv0");


var $97CWy = parcelRequire("97CWy");

const $ecada00de6215dbb$var$serializer = new (0, $3xuv0.JSONTransformer)();
function $ecada00de6215dbb$export$dfca419434f7e5a8({ markdown: markdown, idMap: idMap = {}, editorSchema: editorSchema, featureToggles: featureToggles = {
    markdownPlus: true
} }) {
    // Default to markdownPlus being enabled unless explicitly disabled
    if (featureToggles === undefined) featureToggles = {};
    if (featureToggles?.markdownPlus === undefined) featureToggles.markdownPlus = true;
    // Convert markdown-plus to ProseMirrorNode
    const proseMirrorNode = (0, $97CWy.backendConvertMarkdownToProsemirrorNode)({
        markdown: markdown,
        schema: editorSchema || (0, $4XbfY.defaultSchema),
        idMap: idMap,
        featureToggles: featureToggles
    });
    // Convert ProseMirrorNode to ADF
    return $ecada00de6215dbb$var$serializer.encode(proseMirrorNode);
}
module.exports["markdownPlusToAdf"] = $ecada00de6215dbb$export$dfca419434f7e5a8;

});

parcelRegister("7JWNS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cXLoX = parcelRequire("cXLoX");


var $a90fH = parcelRequire("a90fH");


var $hoMYc = parcelRequire("hoMYc");

const $34ab1c719efd5788$export$5fe969aa6ed2f349 = ({ analyticsConfig: analyticsConfig, issueConfig: issueConfig, onCompletion: onCompletion, customExperienceTracker: customExperienceTracker, requestHeaderOverrides: requestHeaderOverrides, ...streamingProps })=>{
    // **** setup ****
    const { updateSuggestions: updateSuggestions, suggestions: suggestions, fullSuggestionList: fullSuggestionList, reset: resetSuggestion, hideSuggestion: hideSuggestion } = (0, $a90fH.useSuggestions)();
    const [error, setError] = (0, $cozmU.useState)();
    const analyticsContext = {
        ...analyticsConfig,
        proactiveGeneratedAI: 0,
        userGeneratedAI: 1,
        isAIFeature: 1
    };
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIInteractionDismiss: trackAIInteractionDismiss, trackAIResultView: trackAIResultView, trackAIResultAction: trackAIResultAction, trackAIResultError: trackAIResultError, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $cXLoX.useAIEventsInstrumentation)(analyticsContext);
    const onStreamError = (0, $cozmU.useCallback)((error)=>{
        customExperienceTracker?.fail?.(error);
        trackAIResultError({
            aiErrorCode: error.message.status_code,
            aiErrorMessage: error.message.message_template
        }, !(0, $hoMYc.isWhitelistedSLOError)(error) ? {
            attributes: {
                aiResultErrorCategory: 'server-error'
            }
        } : undefined);
        setError(error);
    }, [
        trackAIResultError,
        customExperienceTracker
    ]);
    const onStreamInit = (0, $cozmU.useCallback)((retryCount)=>{
        resetSuggestion();
        setError(undefined);
        customExperienceTracker?.start?.();
        trackAIInteractionInit({
            attributes: {
                totalRetries: retryCount
            }
        });
    }, [
        trackAIInteractionInit,
        resetSuggestion,
        customExperienceTracker
    ]);
    const onStreamAborted = (0, $cozmU.useCallback)(()=>{
        customExperienceTracker?.abort?.();
        trackAIInteractionDismiss();
    }, [
        trackAIInteractionDismiss,
        customExperienceTracker
    ]);
    const { isStreaming: isStreaming, isInitiating: isInitiatingStreaming, reset: resetStreaming, refetch: refetch, getIsStreamingRef: getIsStreamingRef } = (0, $hoMYc.useStreaming)({
        analyticsContext: analyticsContext,
        streamingProps: streamingProps,
        issueConfig: issueConfig,
        requestHeaderOverrides: requestHeaderOverrides,
        onSuggestionStreamUpdated: updateSuggestions,
        onStreamError: onStreamError,
        onStreamInit: onStreamInit,
        onStreamAbortedByInitNew: onStreamAborted
    });
    // **** callbacks ****
    const terminate = (0, $cozmU.useCallback)(()=>{
        if (isStreaming) // stream aborted by terminating service
        onStreamAborted();
        resetSuggestion();
        resetStreaming();
        setError(undefined);
    // leave for side effect to invoke `onCompletion`
    }, [
        onStreamAborted,
        isStreaming,
        resetSuggestion,
        resetStreaming
    ]);
    const hideSuggestions = (0, $cozmU.useCallback)((ids, action)=>{
        if (action) ids.forEach((_)=>trackAIResultAction(action));
        ids.forEach((id)=>hideSuggestion(id));
    }, [
        trackAIResultAction,
        hideSuggestion
    ]);
    // **** event handlers ****
    const onAIResultView = (0, $cozmU.useCallback)(()=>{
        customExperienceTracker?.succeed?.();
        trackAIResultView({
            attributes: {
                suggestedNumber: suggestions.length
            }
        });
    }, [
        trackAIResultView,
        suggestions.length,
        customExperienceTracker
    ]);
    // **** side effects ****
    (0, $cozmU.useEffect)(()=>{
        // work is considered done, if
        // - no suggestions are available
        // - no error exist
        // - no streaming is active
        if (!isInitiatingStreaming && !isStreaming && !error && suggestions.length === 0) onCompletion();
    }, [
        error,
        suggestions,
        isStreaming,
        onCompletion,
        isInitiatingStreaming
    ]);
    // report aborted on unmount if still streaming
    (0, $cozmU.useEffect)(()=>()=>{
            if (getIsStreamingRef.current()) onStreamAborted();
        }, [
        onStreamAborted,
        getIsStreamingRef
    ]);
    return {
        suggestions: suggestions,
        fullSuggestionList: fullSuggestionList,
        isStreaming: isStreaming,
        error: error,
        // event handlers
        onAIResultView: onAIResultView,
        onAIFeedbackSubmit: trackAIFeedbackSubmit,
        // callbacks
        refetch: refetch,
        hideSuggestions: hideSuggestions,
        terminate: terminate
    };
};
module.exports["useAiWorkSuggestionStreaming"] = $34ab1c719efd5788$export$5fe969aa6ed2f349;

});

parcelRegister("a90fH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kHija = parcelRequire("kHija");

const $babb2fde9f8d1a07$export$378f0080e636ce63 = ()=>{
    const [hiddenSuggestionIds, setHiddenSuggestionIds] = (0, $cozmU.useState)(new Set());
    const [fullSuggestionList, setFullSuggestionList] = (0, $cozmU.useState)([]);
    // used to avoid calling `setSuggestions` too many times during streaming - could break devtools
    const streamedIssueCount = (0, $cozmU.useRef)(0);
    const suggestions = (0, $cozmU.useMemo)(()=>fullSuggestionList.filter((suggestion)=>!hiddenSuggestionIds.has(suggestion.localId)), [
        fullSuggestionList,
        hiddenSuggestionIds
    ]);
    const hideSuggestion = (0, $cozmU.useCallback)((id)=>{
        setHiddenSuggestionIds((set)=>new Set(set).add(id));
    }, []);
    const reset = (0, $cozmU.useCallback)(()=>{
        setFullSuggestionList([]);
        setHiddenSuggestionIds(new Set());
        streamedIssueCount.current = 0;
    }, []);
    const addSuggestion = (0, $cozmU.useCallback)((suggestion)=>{
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        setFullSuggestionList((suggestions)=>[
                ...suggestions,
                {
                    ...suggestion,
                    localId: (0, $kHija.v4)()
                }
            ]);
    }, []);
    const updateSuggestions = (0, $cozmU.useCallback)((newSuggestionList)=>{
        while(streamedIssueCount.current < newSuggestionList.length){
            addSuggestion(newSuggestionList[streamedIssueCount.current]);
            streamedIssueCount.current++;
        }
    }, [
        addSuggestion
    ]);
    return {
        fullSuggestionList: fullSuggestionList,
        suggestions: suggestions,
        hideSuggestion: hideSuggestion,
        updateSuggestions: updateSuggestions,
        reset: reset
    };
};
module.exports["useSuggestions"] = $babb2fde9f8d1a07$export$378f0080e636ce63;

});

parcelRegister("hoMYc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6ahXt = parcelRequire("6ahXt");

var $aJxVU = parcelRequire("aJxVU");

var $h3M3Y = parcelRequire("h3M3Y");

const $d8716fac23f14718$export$4177e9b841c72d1e = (error)=>{
    const whitelistedSLOErrors = [
        (0, $6ahXt.ConvoAIErrorMessage).ACCEPTABLE_USE_VIOLATIONS,
        (0, $6ahXt.ConvoAIErrorMessage).NOT_ENOUGH_CONTENT_ERROR,
        (0, $6ahXt.ConvoAIErrorMessage).ANSWER_UNAVAILABLE_FOR_CONTENT,
        (0, $6ahXt.ConvoAIErrorMessage).NOT_FOUND,
        (0, $6ahXt.ConvoAIErrorMessage).BAD_REQUEST
    ];
    return whitelistedSLOErrors.includes(error.message.message_template);
};
const $d8716fac23f14718$var$TIMEOUT_DELAY = 60000;
const $d8716fac23f14718$export$734279c1f8caf5b9 = ({ analyticsContext: analyticsContext, issueConfig: issueConfig, streamingProps: streamingProps, requestHeaderOverrides: requestHeaderOverrides, onSuggestionStreamUpdated: onSuggestionStreamUpdated, onStreamError: onStreamError, onStreamInit: onStreamInit, onStreamAbortedByInitNew: onStreamAbortedByInitNew })=>{
    const [isStreaming, setIsStreaming] = (0, $cozmU.useState)(false);
    const [isInitiating, setIsInitiating] = (0, $cozmU.useState)(true);
    const prevResponseState = (0, $cozmU.useRef)(null);
    const streamCountRef = (0, $cozmU.useRef)(0);
    const getIsStreamingRef = (0, $cozmU.useRef)(()=>false);
    getIsStreamingRef.current = ()=>isStreaming;
    const streamingRequest = (0, $cozmU.useMemo)(()=>({
            ai_feature_input: {
                ...streamingProps.input,
                suggested_issues_config: issueConfig
            }
        }), [
        issueConfig,
        streamingProps.input
    ]);
    const streamingConfig = (0, $cozmU.useMemo)(()=>({
            apiPath: `v2/ai-feature/jira/issue/source-type/${streamingProps.sourceType}/suggestions/stream`,
            enablePartialJson: true,
            enableFollowUp: false,
            headers: {
                'x-experience-id': streamingProps.experienceId,
                'x-product': requestHeaderOverrides?.overrideXProduct ?? analyticsContext.product,
                'x-channel-id': streamingProps?.channelId
            },
            skip: streamingProps.skip ?? false,
            timeoutDelay: $d8716fac23f14718$var$TIMEOUT_DELAY
        }), [
        analyticsContext.product,
        streamingProps.experienceId,
        streamingProps.sourceType,
        requestHeaderOverrides?.overrideXProduct,
        streamingProps?.channelId,
        streamingProps?.skip
    ]);
    const onStateChange = (0, $cozmU.useCallback)((state)=>{
        if (prevResponseState.current !== state.responseState) {
            if (state.responseState === (0, $aJxVU.ConvoAIResponseState).Initialization) {
                if (isStreaming) onStreamAbortedByInitNew();
                onStreamInit(streamCountRef.current); // argument is "retryCount", so before self-increment
                setIsStreaming(true);
                if (isInitiating) setIsInitiating(false);
                streamCountRef.current++;
            }
            prevResponseState.current = state.responseState;
        }
        if (!isStreaming) return;
        switch(state.responseState){
            case (0, $aJxVU.ConvoAIResponseState).AnswerPart:
                {
                    const fullyFormedIssues = state.content?.suggested_issues?.slice?.(0, -1) ?? [];
                    onSuggestionStreamUpdated(fullyFormedIssues);
                    break;
                }
            case (0, $aJxVU.ConvoAIResponseState).FinalResponse:
                setIsStreaming(false);
                // builds kept failing when using ConvoAIErrorMessage.SOME_ERROR
                // fixed by typecasting as ConvoAIErrorMessage
                if (!('suggested_issues' in state.content)) {
                    // if there are are no suggested_issues, it's potentially due to bad json
                    // log as an unexpected error as we are unsure if this pops up in ConvoAI
                    onStreamError({
                        type: 'ERROR',
                        message: {
                            message_template: 'UNEXPECTED',
                            content: `Bad JSON: ${Object.keys(state.content).toString()}`,
                            status_code: 500
                        }
                    });
                    break;
                }
                if (state.content?.suggested_issues.length === 0) {
                    // no child issue information came back from the LLM
                    // we clasify this as a not engouh information error
                    onStreamError({
                        type: 'ERROR',
                        message: {
                            message_template: 'NOT_ENOUGH_CONTENT_ERROR',
                            content: 'Not enough content to generate work items from Confluence link.',
                            status_code: 400
                        }
                    });
                    break;
                }
                onSuggestionStreamUpdated(state.content?.suggested_issues);
                break;
            case (0, $aJxVU.ConvoAIResponseState).Error:
                setIsStreaming(false);
                onStreamError(state.error);
                break;
            default:
        }
    }, [
        onSuggestionStreamUpdated,
        onStreamError,
        isStreaming,
        isInitiating,
        onStreamAbortedByInitNew,
        onStreamInit
    ]);
    const [_, refetch] = (0, $h3M3Y.useConvoAIStreaming)(streamingRequest, streamingConfig, onStateChange);
    const reset = (0, $cozmU.useCallback)(()=>{
        setIsStreaming(false);
    }, []);
    return {
        isInitiating: isInitiating,
        isStreaming: isStreaming,
        getIsStreamingRef: getIsStreamingRef,
        refetch: refetch,
        reset: reset
    };
};
module.exports["isWhitelistedSLOError"] = $d8716fac23f14718$export$4177e9b841c72d1e;
module.exports["useStreaming"] = $d8716fac23f14718$export$734279c1f8caf5b9;

});

parcelRegister("l4gv5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lzgC6 = parcelRequire("lzgC6");

class $e65ab88bda38d309$var$MountEventComponent extends (0, $cozmU.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
const $e65ab88bda38d309$var$MountEventComponentWithHOC = (0, $lzgC6.default)()($e65ab88bda38d309$var$MountEventComponent);
const $e65ab88bda38d309$export$2c6963927dbc68f1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e65ab88bda38d309$var$MountEventComponentWithHOC, props);
module.exports["MountEvent"] = $e65ab88bda38d309$export$2c6963927dbc68f1;

});

parcelRegister("kfViO", function(module, exports) {

var $jTt8P = parcelRequire("jTt8P");

const $1716be1127a34d35$export$2d424d3a12064a81 = (value)=>{
    if (!value) return 0;
    let chars = 0;
    (0, $jTt8P.traverse)(value, {
        text: (node)=>{
            if (node.text) chars += node.text.length;
        },
        emoji: ({ attrs: attrs })=>{
            if (attrs?.text) chars += attrs.text.length;
        },
        paragraph: ()=>{
            chars += 1;
        },
        mention: ({ attrs: attrs })=>{
            if (attrs?.text) chars += attrs.text.length;
        }
    });
    // Subtract 1 due to doc node
    return chars ? chars - 1 : chars;
};
module.exports["countADFChars"] = $1716be1127a34d35$export$2d424d3a12064a81;

});

parcelRegister("9BGuq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $1mDVg = parcelRequire("1mDVg");

const $8d6a0c1fb56b5ffe$export$f6ae4d64a1b3fc6e = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [{ pageMode: pageMode, hasEditPermission: hasEditPermission }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    return (0, $cozmU.useMemo)(()=>({
            fireTrack: (name, attributes)=>{
                const source = 'aiIssueCreate';
                const [actionSubject, action] = name.split(' ');
                const eventAttributes = {
                    pageMode: pageMode,
                    hasEditPermission: hasEditPermission,
                    ...attributes
                };
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        source: source,
                        action: action,
                        actionSubject: actionSubject,
                        attributes: eventAttributes
                    }
                }).fire();
            }
        }), [
        createAnalyticsEvent,
        pageMode,
        hasEditPermission
    ]);
};
module.exports["useAiIssueCreateAnalytics"] = $8d6a0c1fb56b5ffe$export$f6ae4d64a1b3fc6e;

});

parcelRegister("arvSz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6ahXt = parcelRequire("6ahXt");


var $9BGuq = parcelRequire("9BGuq");

const $5dcd84d787afdff9$export$4177e9b841c72d1e = (error)=>{
    const whitelistedSLOErrors = [
        (0, $6ahXt.ConvoAIErrorMessage).ACCEPTABLE_USE_VIOLATIONS,
        (0, $6ahXt.ConvoAIErrorMessage).NOT_ENOUGH_CONTENT_ERROR,
        (0, $6ahXt.ConvoAIErrorMessage).ANSWER_UNAVAILABLE_FOR_CONTENT,
        (0, $6ahXt.ConvoAIErrorMessage).NOT_FOUND,
        (0, $6ahXt.ConvoAIErrorMessage).BAD_REQUEST
    ];
    return whitelistedSLOErrors.includes(error.message.message_template);
};
const $5dcd84d787afdff9$export$8b355f71d361cab7 = ({ confluencePage: confluencePage, highlightedText: highlightedText, overrideXProduct: overrideXProduct })=>{
    const { fireTrack: fireTrack } = (0, $9BGuq.useAiIssueCreateAnalytics)();
    const { locale: locale } = (0, $kSwu1.useIntl)();
    return (0, $cozmU.useMemo)(()=>({
            analyticsConfig: {
                aiFeatureName: 'confluenceAiWorkCreationConvoAI',
                product: 'confluence',
                subproduct: 'jira',
                useDefaultGASv3EventSchema: false,
                source: 'highlightActionsMenu',
                skipAISessionValidation: true
            },
            requestHeaderOverrides: {
                overrideXProduct: overrideXProduct
            },
            issueConfig: {
                max_issues: 1,
                suggested_issue_field_types: [
                    {
                        issue_type: 'Task',
                        fields: [
                            {
                                field_name: 'Summary',
                                field_type: 'Short-Text'
                            },
                            {
                                field_name: 'Description',
                                field_type: 'Paragraph'
                            }
                        ]
                    }
                ]
            },
            experienceId: 'ai-issue-create-confluence-single',
            sourceType: 'documentation',
            input: {
                source: 'CONFLUENCE',
                context: {
                    primary_text: confluencePage,
                    highlighted_text: highlightedText
                },
                locale: locale
            },
            onCompletion: ()=>{},
            customExperienceTracker: {
                start: ()=>{
                    fireTrack('aiIssueCreateFetchSuggestedFieldsRequest start', {
                        locale: locale
                    });
                },
                succeed: ()=>{
                    fireTrack('aiIssueCreateFetchSuggestedFieldsRequest complete', {
                        haveResult: true,
                        locale: locale
                    });
                },
                fail: (convoAIStreamError)=>{
                    fireTrack('aiIssueCreateFetchSuggestedFieldsRequest fail', {
                        errorMessage: convoAIStreamError?.message?.content,
                        statusCode: convoAIStreamError?.message?.status_code,
                        message_template: convoAIStreamError?.message?.message_template,
                        shouldSlo: !$5dcd84d787afdff9$export$4177e9b841c72d1e(convoAIStreamError),
                        locale: locale
                    });
                },
                abort: ()=>{
                    fireTrack('aiIssueCreateFetchSuggestedFieldsRequest abort', {
                        locale: locale
                    });
                }
            }
        }), [
        confluencePage,
        highlightedText,
        overrideXProduct,
        fireTrack,
        locale
    ]);
};
module.exports["useStreamingHookProps"] = $5dcd84d787afdff9$export$8b355f71d361cab7;

});

parcelRegister("gqQUx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7oI9Y = parcelRequire("7oI9Y");


var $kDhla = parcelRequire("kDhla");


var $1mDVg = parcelRequire("1mDVg");


var $9BGuq = parcelRequire("9BGuq");


var $iT03Z = parcelRequire("iT03Z");

const $1a87d70e3d885601$var$getConfluencePageAdf = async ({ cloudId: cloudId, contentType: contentType, pageId: pageId, pageMode: pageMode = (0, $1mDVg.PageMode).VIEW, signal: signal, product: product = 'confluence', experienceId: experienceId = 'ai-issue-create', editorApi: editorApi })=>{
    if (pageMode === (0, $1mDVg.PageMode).EDIT || pageMode === (0, $1mDVg.PageMode).LIVE_EDIT || pageMode === (0, $1mDVg.PageMode).LIVE_VIEW) return (0, $iT03Z.getConfluencePageAdfFromEditor)(editorApi);
    // 'folder' is not a supported content type in ai-issue-create; fall back to no contentType
    const apiContentType = contentType !== 'folder' ? contentType : 'page';
    return (0, $7oI9Y.getConfluencePageAdfFromApi)({
        cloudId: cloudId,
        contentType: apiContentType,
        pageId: pageId,
        signal: signal,
        product: product,
        experienceId: experienceId
    });
};
const $1a87d70e3d885601$export$e411256f856842c7 = ({ cloudId: cloudId, contentType: contentType, experienceId: experienceId, pageId: pageId, pageMode: pageMode, product: product, onStateChange: onStateChange })=>{
    const { fireTrack: fireTrack } = (0, $9BGuq.useAiIssueCreateAnalytics)();
    const { fullPageEditorPresetAPI: fullPageEditorPresetAPI } = (0, $kDhla.useFullPageEditorApiState)();
    const [fetchState, setGetConfluencePageState] = (0, $cozmU.useState)({
        state: 'loading',
        confluencePage: undefined
    });
    const abortControllerRef = (0, $cozmU.useRef)(null);
    const fetchConfluencePage = (0, $cozmU.useCallback)(async ()=>{
        if (abortControllerRef.current) abortControllerRef.current.abort();
        abortControllerRef.current = new AbortController();
        const currentAbortController = abortControllerRef.current;
        setGetConfluencePageState({
            state: 'loading',
            confluencePage: undefined
        });
        try {
            fireTrack('issueCreateSidePanelGetConfluencePageRequest start');
            const confluencePage = await $1a87d70e3d885601$var$getConfluencePageAdf({
                cloudId: cloudId,
                contentType: contentType,
                experienceId: experienceId,
                pageId: pageId,
                pageMode: pageMode,
                product: product,
                signal: currentAbortController.signal,
                editorApi: fullPageEditorPresetAPI
            });
            fireTrack('issueCreateSidePanelGetConfluencePageRequest complete', {
                haveResult: !!confluencePage
            });
            if (currentAbortController.signal.aborted) {
                setGetConfluencePageState({
                    state: 'abort',
                    confluencePage: undefined
                });
                return;
            }
            if (confluencePage) setGetConfluencePageState({
                state: 'idle',
                confluencePage: confluencePage
            });
            else setGetConfluencePageState({
                state: 'error',
                error: new Error('Error on getting confluence page as ADF'),
                confluencePage: undefined
            });
        } catch (e) {
            fireTrack('issueCreateSidePanelGetConfluencePageRequest fail', {
                message: e.message
            });
            if (currentAbortController.signal.aborted) {
                setGetConfluencePageState({
                    state: 'abort',
                    confluencePage: undefined
                });
                return;
            }
            setGetConfluencePageState({
                state: 'error',
                error: e,
                confluencePage: undefined
            });
        }
    }, [
        cloudId,
        contentType,
        experienceId,
        pageId,
        product,
        setGetConfluencePageState,
        fireTrack,
        pageMode,
        fullPageEditorPresetAPI
    ]);
    (0, $cozmU.useEffect)(()=>{
        fetchConfluencePage();
        return ()=>{
            if (abortControllerRef.current) abortControllerRef.current.abort();
        };
    }, [
        fetchConfluencePage
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (onStateChange) onStateChange(fetchState);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fetchState.state,
        fetchState.confluencePage,
        onStateChange
    ]);
    return {
        ...fetchState,
        trigger: fetchConfluencePage
    };
};
module.exports["useGetConfluencePage"] = $1a87d70e3d885601$export$e411256f856842c7;

});

parcelRegister("7oI9Y", function(module, exports) {
const $7dda225bb6e8bde3$export$9ae725848caea23f = async ({ cloudId: cloudId, contentType: contentType, pageId: pageId, signal: signal, product: product = 'confluence', experienceId: experienceId = 'ai-issue-create' })=>{
    try {
        const endpointAPI = contentType === 'blogpost' ? `blogposts` : `pages`;
        const response = await fetch(`/wiki/api/v2/${endpointAPI}/${pageId}?body-format=atlas_doc_format`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'X-Experience-Id': experienceId,
                'X-Product': product,
                'Atl-CloudId': cloudId
            },
            credentials: 'include',
            signal: signal
        });
        const data = await response.json();
        if (!data.body?.atlas_doc_format) throw new Error('No atlas doc format found in confluence page');
        return JSON.parse(data.body.atlas_doc_format.value);
    } catch (error) {
        throw new Error('Request to get confluence page failed');
    }
};
module.exports["getConfluencePageAdfFromApi"] = $7dda225bb6e8bde3$export$9ae725848caea23f;

});

parcelRegister("iT03Z", function(module, exports) {
const $12940757b485c304$export$21b6e0bf8d10cc8 = async (editorApi)=>{
    return new Promise((resolve)=>{
        editorApi?.core.actions.requestDocument((doc)=>{
            if (!doc) throw new Error('No adf document found in editor');
            resolve(doc);
        });
    });
};
module.exports["getConfluencePageAdfFromEditor"] = $12940757b485c304$export$21b6e0bf8d10cc8;

});

parcelRegister("bZC8A", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $i1t43 = parcelRequire("i1t43");


var $9wGTI = parcelRequire("9wGTI");


var $3E5yu = parcelRequire("3E5yu");

const $d2ef8f1ef1cac15d$export$844cd257c85281a = (error)=>{
    let errorMessage = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).singleCreateAiErrorDescriptionIssueTermRefreshRebrandToRovo : (0, $3E5yu.messages).singleCreateAiErrorDescriptionRebrandToRovo;
    let errorMessageValues;
    let hideTryAgain = false;
    if (error.message_template !== undefined && [
        'ACCEPTABLE_USE_VIOLATIONS',
        'ACCEPTABLE_USE_EVALUATION_EXCEPTION'
    ].includes(error.message_template)) {
        errorMessage = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).ethicalViolationErrorDescriptionIssueTermRefresh : (0, $3E5yu.messages).ethicalViolationErrorDescription;
        errorMessageValues = {
            link: (anchorText)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: "https://www.atlassian.com/legal/acceptable-use-policy",
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, anchorText)
        };
        hideTryAgain = true;
        return {
            errorMessage: errorMessage,
            errorMessageValues: errorMessageValues,
            hideTryAgain: hideTryAgain
        };
    }
    if (error.message_template === 'RATE_LIMIT') {
        errorMessage = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).rateLimitErrorDescriptionIssueTermRefreshRebrandToRovo : (0, $3E5yu.messages).rateLimitErrorDescriptionRebrandToRovo;
        errorMessageValues = {
            link: (anchorText)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: "https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/",
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, anchorText)
        };
        hideTryAgain = true;
        return {
            errorMessage: errorMessage,
            errorMessageValues: errorMessageValues,
            hideTryAgain: hideTryAgain
        };
    }
    if (error.message_template === 'FE_REQUEST_EXCEEDING_TOKEN_LENGTH') {
        errorMessage = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).exceedingTokenLimitDescriptionIssueTermRefreshRebrandToRovo : (0, $3E5yu.messages).exceedingTokenLimitDescriptionRebrandToRovo;
        hideTryAgain = true;
        return {
            errorMessage: errorMessage,
            errorMessageValues: errorMessageValues,
            hideTryAgain: hideTryAgain
        };
    }
    if (error.message_template === 'NO_ANSWER_SUGGESTED_ISSUES') {
        errorMessage = (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).noAnswerSuggestedIssuesIssueTermRefresh : (0, $3E5yu.messages).noAnswerSuggestedIssues;
        hideTryAgain = true;
    }
    return {
        errorMessage: errorMessage,
        errorMessageValues: errorMessageValues,
        hideTryAgain: hideTryAgain
    };
};
module.exports["handleAiIssueCreateError"] = $d2ef8f1ef1cac15d$export$844cd257c85281a;

});

parcelRegister("jE0Gg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3E5yu = parcelRequire("3E5yu");


var $1mDVg = parcelRequire("1mDVg");

const $3fdc1d9372d96a0e$export$2ac688f17b22f89f = ()=>{
    const [{ currentSiteSelection: currentSiteSelection }, { setCurrentSiteSelection: setCurrentSiteSelection, setCurrentProjectSelection: setCurrentProjectSelection, setAiIssueCreationEnablement: setAiIssueCreationEnablement, setIsGicIframeReady: setIsGicIframeReady }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    (0, $cozmU.useEffect)(()=>{
        const messageHandler = (message)=>{
            const eventName = message?.data?.event;
            const payload = message.data?.payload;
            switch(eventName){
                // Recieve message from GIC anywhere component for current site selection since it is in an inner iframe.
                case 0, $3E5yu.JIRA_EMBED_ISSUE_CREATE_SITE_SELECTED:
                    if (payload?.selectedCloudId && payload?.selectedCloudId !== '') {
                        // reset currentProjectSelection on site change since projects are tied per site
                        if (currentSiteSelection && payload?.selectedCloudId !== currentSiteSelection) setCurrentProjectSelection(undefined);
                        setCurrentSiteSelection(payload.selectedCloudId);
                    }
                    break;
                case 0, $3E5yu.JIRA_EMBED_ISSUE_CREATE_PROJECT_SELECTED:
                    const project = {
                        selectedProjectType: payload?.selectedProjectType,
                        selectedProjectId: payload?.selectedProjectId,
                        selectedProjectKey: payload?.selectedProjectKey
                    };
                    setCurrentProjectSelection(project);
                    break;
                case 0, $3E5yu.JIRA_EMBED_ISSUE_CREATE_READY:
                    setIsGicIframeReady(true);
                    break;
                case 0, $3E5yu.JIRA_EMBED_ISSUE_CREATE_CLOSE:
                    setIsGicIframeReady(false);
                    break;
                default:
            }
        };
        window.addEventListener('message', messageHandler);
        return ()=>{
            window.removeEventListener('message', messageHandler);
        };
    }, [
        setCurrentSiteSelection,
        setCurrentProjectSelection,
        currentSiteSelection,
        setAiIssueCreationEnablement,
        setIsGicIframeReady
    ]);
};
module.exports["useMessageListener"] = $3fdc1d9372d96a0e$export$2ac688f17b22f89f;

});

parcelRegister("hib1D", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2wCqQ = parcelRequire("2wCqQ");


var $buxP3 = parcelRequire("buxP3");


var $74xbC = parcelRequire("74xbC");


var $1mDVg = parcelRequire("1mDVg");


var $hiixe = parcelRequire("hiixe");

const $c160271417b290c8$var$footerContainerStyle = (0, $buxP3.xcss)({
    backgroundColor: 'elevation.surface.sunken'
});
const $c160271417b290c8$var$SINGLE_ISSUE_CREATE_FEEDBACK_ENTRYPOINT_ID = '5dd040e8-af22-4ef1-803e-136f659a1092';
const $c160271417b290c8$export$5e203ab8a2a5043e = ()=>{
    const [{ contentId: contentId }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        xcss: $c160271417b290c8$var$footerContainerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $74xbC.IssueCreateAiFeedback), {
        contentId: contentId,
        entrypointId: $c160271417b290c8$var$SINGLE_ISSUE_CREATE_FEEDBACK_ENTRYPOINT_ID
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hiixe.AiSubFooter), null));
};
module.exports["IssueCreateSidePanelFooter"] = $c160271417b290c8$export$5e203ab8a2a5043e;

});

parcelRegister("6pbwW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kA6Zo = parcelRequire("kA6Zo");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $I7hWB = parcelRequire("I7hWB");


var $l3wuH = parcelRequire("l3wuH");


var $1sCHt = parcelRequire("1sCHt");


var $bltJZ = parcelRequire("bltJZ");


var $4WZFP = parcelRequire("4WZFP");


var $9wGTI = parcelRequire("9wGTI");


var $3E5yu = parcelRequire("3E5yu");

const $47081d53dba235a2$var$headerMessageStyle = (0, $buxP3.xcss)({
    paddingInline: 'space.100',
    font: "var(--ds-font-heading-small, normal 653 16px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    paddingBottom: 'space.025'
});
const $47081d53dba235a2$export$7b151ed3fccdded0 = ({ onClose: onClose })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4WZFP.SidePanelHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "medium",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        direction: "row",
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.JiraIcon), {
        size: "small",
        appearance: "brand"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $47081d53dba235a2$var$headerMessageStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? (0, $3E5yu.messages).sidePanelHeaderIssueTermRefresh : (0, $3E5yu.messages).sidePanelHeader)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                label: "close-icon",
                spacing: "none"
            }),
        appearance: "subtle",
        label: "close",
        onClick: ()=>onClose(),
        testId: "close-issue-create-panel-button"
    })));
};
module.exports["IssueCreateSidePanelHeader"] = $47081d53dba235a2$export$7b151ed3fccdded0;

});

parcelRegister("4WZFP", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $72d7920b18bf3596$export$70e0922268f2e08b = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            paddingBlock: "space.100",
            paddingInlineStart: "space.300",
            paddingInlineEnd: "space.150"
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
module.exports["SidePanelHeader"] = $72d7920b18bf3596$export$70e0922268f2e08b;

});

parcelRegister("b0EGa", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $6d5fb7464c13acdf$var$initialState = {
    hideRequestCount: 0,
    hasReceivedHideRequest: false
};
const $6d5fb7464c13acdf$var$actions = {
    /**
	 * Request to hide the OmniBar. Call this when your component/popup opens.
	 * Must be paired with releaseHideOmniBar when the component closes.
	 */ requestHideOmniBar: ()=>({ setState: setState, getState: getState })=>{
            const { hideRequestCount: hideRequestCount } = getState();
            setState({
                hideRequestCount: hideRequestCount + 1,
                hasReceivedHideRequest: true
            });
        },
    /**
	 * Release a hide request. Call this when your component/popup closes.
	 * Must be paired with a previous requestHideOmniBar call.
	 */ releaseHideOmniBar: ()=>({ setState: setState, getState: getState })=>{
            const { hideRequestCount: hideRequestCount } = getState();
            if (hideRequestCount > 0) setState({
                hideRequestCount: hideRequestCount - 1
            });
        }
};
const $6d5fb7464c13acdf$export$11b4e542b178c9bc = (0, $8s9DV.createStore)({
    initialState: $6d5fb7464c13acdf$var$initialState,
    actions: $6d5fb7464c13acdf$var$actions,
    name: 'OmniBarVisibilityStore'
});
const $6d5fb7464c13acdf$export$c640b7434448a8d = (0, $kBr4q.createStateHook)($6d5fb7464c13acdf$export$11b4e542b178c9bc, {
    selector: (state)=>state.hideRequestCount > 0
});
const $6d5fb7464c13acdf$export$13aafec54f1ab41c = (0, $kBr4q.createStateHook)($6d5fb7464c13acdf$export$11b4e542b178c9bc, {
    selector: (state)=>state.hasReceivedHideRequest
});
const $6d5fb7464c13acdf$export$6c29083870fa1fac = (0, $kBr4q.createActionsHook)($6d5fb7464c13acdf$export$11b4e542b178c9bc);
module.exports["useShouldHideOmniBar"] = $6d5fb7464c13acdf$export$c640b7434448a8d;
module.exports["useHasReceivedOmniBarHideRequest"] = $6d5fb7464c13acdf$export$13aafec54f1ab41c;
module.exports["useOmniBarVisibilityActions"] = $6d5fb7464c13acdf$export$6c29083870fa1fac;

});

parcelRegister("aKDZB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ixfCV = parcelRequire("ixfCV");


var $irnO2 = parcelRequire("irnO2");


var $bjY3F = parcelRequire("bjY3F");


var $8akfd = parcelRequire("8akfd");


var $8GyO5 = parcelRequire("8GyO5");


var $aXWtB = parcelRequire("aXWtB");


var $1AJi3 = parcelRequire("1AJi3");


var $jyA9t = parcelRequire("jyA9t");


var $3rRes = parcelRequire("3rRes");


var $fj6ez = parcelRequire("fj6ez");


var $koSDQ = parcelRequire("koSDQ");


var $7eOZ4 = parcelRequire("7eOZ4");


var $jNS1v = parcelRequire("jNS1v");

const $c9c8b9d550aa1c05$var$constructDynamicUiSource = (adfDocument, selectionContext)=>{
    const fragmentAdf = (0, $3rRes.filterRemixFragmentNodes)(selectionContext?.selectionFragment ?? null);
    return {
        contentType: 'page',
        startLocalId: selectionContext?.localIds?.[0] ?? '',
        endLocalId: selectionContext?.localIds?.[selectionContext.localIds.length - 1] ?? '',
        startIndex: selectionContext?.startIndex ?? 0,
        endIndex: selectionContext?.endIndex ?? -1,
        // When the entire page is selected (e.g. cmd+a), selectionContext is null and
        // selectionFragment is not populated. Fall back to the full document content
        // so that Remix still receives the source content it needs.
        fragmentAdf: fragmentAdf ?? adfDocument.content,
        fullAdf: adfDocument
    };
};
const $c9c8b9d550aa1c05$var$RendererRemixModal = ({ adfDocument: adfDocument, selectionContext: selectionContext, interactionSource: interactionSource, onClose: onClose, onStartThinking: onStartThinking, onStopThinking: onStopThinking, isEphemeralViewVisible: isEphemeralViewVisible, currentContentId: currentContentId })=>{
    const isRemixCancelled = (0, $cozmU.useRef)(false);
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const openAIFCStagingModalRef = (0, $cozmU.useRef)(()=>{});
    const selectedSubTypeRef = (0, $cozmU.useRef)(undefined);
    const conversationIdRef = (0, $cozmU.useRef)(undefined);
    const remixOriginContentIdRef = (0, $cozmU.useRef)(undefined);
    const { dynamicUiType: dynamicUiType } = (0, $8akfd.useStagingAreaState)();
    const { openConversationAssistant: openConversationAssistant } = (0, $1AJi3.useToggleConversationAssistant)();
    const dismissRendererRemixUiAfterNavigation = (0, $cozmU.useCallback)(()=>{
        const reason = 'User navigated away before renderer remix preview opened';
        isRemixCancelled.current = true;
        experienceTracker.abort({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            reason: reason,
            attributes: {
                reason: reason
            }
        });
        (0, $irnO2.remixGeneratePreviewExperience).abort({
            metadata: {
                reason: reason
            }
        });
        onStopThinking();
        onClose();
    }, [
        experienceTracker,
        onClose,
        onStopThinking
    ]);
    const shouldOpenPreview = (0, $cozmU.useCallback)(()=>{
        if (!(0, $ixfCV.fg)('cc-maui-phase-3')) return true;
        const originContentId = remixOriginContentIdRef.current;
        return !originContentId || !currentContentId || originContentId === currentContentId;
    }, [
        currentContentId
    ]);
    // Collapse the highlight overlay after the preview opens.
    const onAfterOpenPreview = (0, $cozmU.useCallback)(()=>{
        onClose({
            preserveHighlight: true
        });
    }, [
        onClose
    ]);
    const { showProgressBar: showProgressBar, isComplete: isComplete, onCompleteAnimationFinished: onCompleteAnimationFinished, onActionReady: onActionReady, resetCompletion: resetCompletion } = (0, $koSDQ.useRemixPreviewFlow)({
        entryPoint: 'renderer',
        experienceTracker: experienceTracker,
        dynamicUiType: dynamicUiType,
        selectedSubTypeRef: selectedSubTypeRef,
        openAIFCStagingModalRef: openAIFCStagingModalRef,
        isRemixCancelledRef: isRemixCancelled,
        conversationIdRef: conversationIdRef,
        shouldOpenPreview: shouldOpenPreview,
        onAfterOpenPreview: onAfterOpenPreview
    });
    const { sendAIFCPrompt: sendAIFCPrompt, stopRemixing: stopRemixing, isRemixError: isRemixError, isRemixAborted: isRemixAborted, remixStoreError: remixStoreError, openAIFCStagingModal: openAIFCStagingModal, closeAIFCStagingModal: closeAIFCStagingModal, resetRemixConversationId: resetRemixConversationId } = (0, $7eOZ4.useRemixToAIFC)({
        onActionReady: onActionReady
    });
    openAIFCStagingModalRef.current = openAIFCStagingModal;
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $ixfCV.fg)('cc-maui-phase-3')) return;
        const originContentId = remixOriginContentIdRef.current;
        if (!originContentId || !currentContentId || originContentId === currentContentId) return;
        dismissRendererRemixUiAfterNavigation();
    }, [
        currentContentId,
        dismissRendererRemixUiAfterNavigation
    ]);
    // Abort experience on unmount (overlay closed without selecting an option).
    // Uses a ref so the cleanup always calls the latest tracker reference.
    const experienceTrackerRef = (0, $cozmU.useRef)(experienceTracker);
    experienceTrackerRef.current = experienceTracker;
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            experienceTrackerRef.current.abort({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                reason: 'User closed remix overlay',
                attributes: {
                    reason: 'User closed remix overlay'
                }
            });
        };
    }, []);
    const onRemixFlowActiveChange = (0, $cozmU.useCallback)((active)=>{
        if (active) {
            isRemixCancelled.current = false;
            // Clear stale completion state from any previous flow.
            resetCompletion();
            onStartThinking();
        } else {
            isRemixCancelled.current = true;
            // Abort the current experience before stopping
            experienceTracker.abort({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                reason: 'User cancelled remix thinking',
                attributes: {
                    reason: 'User cancelled remix thinking'
                }
            });
            (0, $irnO2.remixGeneratePreviewExperience).abort({
                metadata: {
                    reason: 'User cancelled remix thinking'
                }
            });
            remixOriginContentIdRef.current = undefined;
            stopRemixing();
            if ((0, $ixfCV.fg)('platform_editor_ai_remix_close_modal_on_stop')) onClose();
            else {
                // Start a new experience for the reopened overlay
                experienceTracker.start({
                    name: (0, $irnO2.ExperienceName).REMIX_START,
                    id: (0, $irnO2.ExperienceName).REMIX_START,
                    attributes: {
                        entryPoint: 'renderer',
                        remixSource: 'cancelledRemixThinking',
                        originalRemixSource: 'selectionToolbar',
                        product: 'confluence'
                    }
                });
                onStopThinking({
                    reopenModal: true
                });
            }
        }
    }, [
        onStartThinking,
        stopRemixing,
        onClose,
        onStopThinking,
        experienceTracker,
        resetCompletion
    ]);
    // Fail experience and clean up thinking UI when Rovo encounters an error
    const prevIsRemixError = (0, $cozmU.useRef)(isRemixError);
    (0, $cozmU.useEffect)(()=>{
        if (!prevIsRemixError.current && isRemixError && !isRemixCancelled.current) {
            const errorMessage = remixStoreError?.content ?? 'Rovo agent error during remix';
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).REMIX_START,
                error: new Error(errorMessage),
                attributes: {
                    errorType: remixStoreError?.errorType,
                    traceId: remixStoreError?.traceId,
                    errorStatusCode: remixStoreError?.status_code
                }
            });
            (0, $irnO2.remixGeneratePreviewExperience).failure({
                metadata: {
                    errorType: remixStoreError?.errorType,
                    traceId: remixStoreError?.traceId
                }
            });
            onStopThinking({
                reopenModal: true
            });
        }
        prevIsRemixError.current = isRemixError;
    }, [
        isRemixError,
        remixStoreError,
        onStopThinking,
        experienceTracker
    ]);
    // When an error occurs during remix, close the thinking bar and ephemeral
    // preview, then open the Rovo chat sidebar so the user can see the error.
    (0, $cozmU.useEffect)(()=>{
        if (!isRemixCancelled.current && isRemixError) {
            // Close the ephemeral preview (staging modal) if it is open
            if (isEphemeralViewVisible) closeAIFCStagingModal();
            // Close the thinking bar and dismiss the remix UI
            onStopThinking();
            onClose();
            // Open the Rovo chat sidebar to display the error information.
            // `openConversationAssistant` is idempotent (no-op if already
            // open), so it is safe to call on every render where
            // `isRemixError` is true — no infinite toggle loop.
            openConversationAssistant('sidebar');
            resetRemixConversationId();
        }
    }, [
        isRemixError,
        isEphemeralViewVisible,
        closeAIFCStagingModal,
        onStopThinking,
        onClose,
        openConversationAssistant,
        resetRemixConversationId
    ]);
    // Dismiss the thinking bar and clear the selection highlight when the user
    // stops the remix from the Rovo side chat.
    (0, $cozmU.useEffect)(()=>{
        if (isRemixAborted && !isRemixCancelled.current) {
            if (isEphemeralViewVisible) closeAIFCStagingModal();
            onStopThinking();
            onClose();
        }
    }, [
        isRemixAborted,
        isEphemeralViewVisible,
        closeAIFCStagingModal,
        onStopThinking,
        onClose
    ]);
    const handleOptionSelect = (0, $cozmU.useCallback)(async ({ type: type, subType: subType, userPrompt: userPrompt })=>{
        remixOriginContentIdRef.current = currentContentId;
        selectedSubTypeRef.current = subType;
        experienceTracker.updateAttributes({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            attributes: {
                remixType: type,
                remixSubtype: subType,
                includesFreegenPrompt: !!userPrompt
            }
        });
        (0, $irnO2.remixGeneratePreviewExperience).start();
        (0, $irnO2.remixGeneratePreviewExperience).mark((0, $irnO2.REMIX_GENERATE_PREVIEW_MARKS).SUBMIT);
        (0, $irnO2.remixGeneratePreviewExperience).addMetadata({
            product: 'confluence',
            interactionSource: interactionSource,
            entryPoint: 'renderer',
            remixType: type,
            remixSubtype: subType,
            includesFreegenPrompt: !!userPrompt
        });
        const dynamicUiSource = $c9c8b9d550aa1c05$var$constructDynamicUiSource(adfDocument, selectionContext);
        const conversationChannelId = await sendAIFCPrompt({
            userPrompt: userPrompt,
            dynamicUiType: type,
            dynamicUiSubtype: subType,
            dynamicUiSource: dynamicUiSource,
            interactionSource: interactionSource
        });
        // Stash the conversationId so `useRemixPreviewFlow` can include it as
        // `conversationChannelId` on the REMIX_RENDERS_IN_MODAL start attributes
        // once `onActionReady` fires.
        conversationIdRef.current = conversationChannelId;
        experienceTracker.updateAttributes({
            name: (0, $irnO2.ExperienceName).REMIX_START,
            attributes: {
                conversationChannelId: conversationChannelId
            }
        });
    }, [
        sendAIFCPrompt,
        adfDocument,
        selectionContext,
        interactionSource,
        experienceTracker,
        currentContentId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8GyO5.RemixContainer), {
        onClose: ()=>onClose(),
        onOptionSelect: handleOptionSelect,
        onRemixFlowActiveChange: onRemixFlowActiveChange,
        isEphemeralViewVisible: isEphemeralViewVisible,
        showProgressBar: showProgressBar,
        isComplete: isComplete,
        onCompleteAnimationFinished: onCompleteAnimationFinished
    });
};
const $c9c8b9d550aa1c05$var$RendererRemixContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    openRemixModal: ()=>{},
    clearRemixHighlight: ()=>{},
    isRemixDisabled: false,
    isRemixing: false,
    registerOnModalClose: ()=>()=>{}
});
const $c9c8b9d550aa1c05$export$c881c5d3c5870780 = ()=>{
    return (0, $cozmU.useContext)($c9c8b9d550aa1c05$var$RendererRemixContext);
};
const $c9c8b9d550aa1c05$var$RendererRemixContainerImpl = ({ children: children, contentId: contentId })=>{
    const [isModalOpen, setIsModalOpen] = (0, $cozmU.useState)(false);
    const [adfDocument, setAdfDocument] = (0, $cozmU.useState)(null);
    const [selectionContext, setSelectionContext] = (0, $cozmU.useState)(null);
    const [isThinking, setIsThinking] = (0, $cozmU.useState)(false);
    const interactionSourceRef = (0, $cozmU.useRef)(undefined);
    const { startHighlight: startHighlight, clearHighlight: clearHighlight } = (0, $jNS1v.useRendererRemixHighlight)();
    const { showSmartCreationModal: showSmartCreationModal } = (0, $jyA9t.useSmartCreationModalState)();
    const onModalCloseCallbacks = (0, $cozmU.useRef)(new Set());
    const registerOnModalClose = (0, $cozmU.useCallback)((callback)=>{
        onModalCloseCallbacks.current.add(callback);
        return ()=>{
            onModalCloseCallbacks.current.delete(callback);
        };
    }, []);
    const prevShowSmartCreationModal = (0, $cozmU.useRef)(showSmartCreationModal);
    (0, $cozmU.useEffect)(()=>{
        if (prevShowSmartCreationModal.current && !showSmartCreationModal) clearHighlight();
        prevShowSmartCreationModal.current = showSmartCreationModal;
    }, [
        showSmartCreationModal,
        clearHighlight
    ]);
    const openModal = (0, $cozmU.useCallback)((newAdfDocument, selection, interactionSource)=>{
        setAdfDocument(newAdfDocument);
        startHighlight();
        setSelectionContext(selection);
        interactionSourceRef.current = interactionSource;
        setIsModalOpen(true);
    }, [
        startHighlight
    ]);
    const closeModal = (0, $cozmU.useCallback)((options)=>{
        if (!options?.preserveHighlight) clearHighlight();
        onModalCloseCallbacks.current.forEach((cb)=>cb());
        setAdfDocument(null);
        setSelectionContext(null);
        interactionSourceRef.current = undefined;
        setIsModalOpen(false);
        setIsThinking(false);
    }, [
        clearHighlight
    ]);
    const onStartThinking = (0, $cozmU.useCallback)(()=>{
        setIsThinking(true);
        setIsModalOpen(false);
    }, []);
    const onStopThinking = (0, $cozmU.useCallback)((options)=>{
        setIsThinking(false);
        if (options?.reopenModal) setIsModalOpen(true);
    }, []);
    const context = (0, $cozmU.useMemo)(()=>{
        const isRemixing = isModalOpen || isThinking || showSmartCreationModal;
        return {
            openRemixModal: openModal,
            clearRemixHighlight: clearHighlight,
            isRemixDisabled: false,
            isRemixing: isRemixing,
            registerOnModalClose: registerOnModalClose
        };
    }, [
        openModal,
        clearHighlight,
        isModalOpen,
        isThinking,
        showSmartCreationModal,
        registerOnModalClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$RendererRemixContext.Provider, {
        value: context
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fj6ez.RendererRemixHighlightStyles), null), children, (isModalOpen || isThinking) && adfDocument && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aXWtB.ConfluenceConversationAssistant), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$RendererRemixModal, {
        adfDocument: adfDocument,
        selectionContext: selectionContext,
        interactionSource: interactionSourceRef.current,
        onClose: closeModal,
        onStartThinking: onStartThinking,
        onStopThinking: onStopThinking,
        isEphemeralViewVisible: showSmartCreationModal,
        currentContentId: contentId
    })));
};
const $c9c8b9d550aa1c05$var$makeDisabledRemixContextValue = (reason)=>({
        openRemixModal: ()=>{},
        clearRemixHighlight: ()=>{},
        isRemixDisabled: true,
        isRemixing: false,
        remixDisabledReason: reason,
        registerOnModalClose: ()=>()=>{}
    });
const $c9c8b9d550aa1c05$var$disabledRemixContextValue = $c9c8b9d550aa1c05$var$makeDisabledRemixContextValue();
const $c9c8b9d550aa1c05$export$62131e16a1db8364 = ({ children: children, contentId: contentId, isDisabled: isDisabled, remixDisabledReason: remixDisabledReason })=>{
    if (isDisabled) {
        const contextValue = remixDisabledReason ? $c9c8b9d550aa1c05$var$makeDisabledRemixContextValue(remixDisabledReason) : $c9c8b9d550aa1c05$var$disabledRemixContextValue;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$RendererRemixContext.Provider, {
            value: contextValue
        }, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9c8b9d550aa1c05$var$RendererRemixContainerImpl, {
        contentId: contentId
    }, children);
};
module.exports["useRendererRemixContext"] = $c9c8b9d550aa1c05$export$c881c5d3c5870780;
module.exports["RendererRemixContainer"] = $c9c8b9d550aa1c05$export$62131e16a1db8364;

});

parcelRegister("8akfd", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $d9cc5462c799c5c3$var$initialState = {
    messageIdSelectedForPreview: null,
    invocationIdSelectedForPreview: null,
    stagingAreaMode: undefined,
    stagingAreaEntryPoint: '',
    prompt: '',
    dynamicUiType: undefined,
    dynamicUiSubtype: undefined,
    userSelectedDynamicUiSubtype: undefined,
    dynamicUiSource: undefined,
    interactionSource: undefined,
    isRemixUpdating: false,
    forceSkipAutoConversationSelection: false,
    currentDisplayMessageId: undefined
};
const $d9cc5462c799c5c3$var$actions = {
    setMessageIdSelectedForPreview: (messageId)=>({ setState: setState })=>{
            setState({
                messageIdSelectedForPreview: messageId
            });
        },
    getMessageIdSelectedForPreview: ()=>({ getState: getState })=>{
            return getState().messageIdSelectedForPreview;
        },
    setStagingAreaMode: (mode, entryPoint)=>({ setState: setState })=>{
            setState({
                stagingAreaMode: mode,
                stagingAreaEntryPoint: entryPoint ?? ''
            });
        },
    setStagingAreaEntryPoint: (entryPoint)=>({ setState: setState })=>{
            setState({
                stagingAreaEntryPoint: entryPoint ?? ''
            });
        },
    setPrompt: (prompt)=>({ setState: setState })=>{
            setState({
                prompt: prompt
            });
        },
    setInvocationIdSelectedForPreview: (invocationId)=>({ setState: setState })=>{
            setState({
                invocationIdSelectedForPreview: invocationId
            });
        },
    getInvocationIdSelectedForPreview: ()=>({ getState: getState })=>{
            return getState().invocationIdSelectedForPreview;
        },
    setIsRemixUpdating: (isUpdating)=>({ setState: setState })=>{
            setState({
                isRemixUpdating: isUpdating
            });
        },
    setDynamicUiContext: (dynamicUiType, dynamicUiSubtype, dynamicUiSource)=>({ setState: setState })=>{
            setState({
                dynamicUiType: dynamicUiType,
                dynamicUiSubtype: dynamicUiSubtype,
                dynamicUiSource: dynamicUiSource
            });
        },
    setUserSelectedDynamicUiSubtype: (userSelectedDynamicUiSubtype)=>({ setState: setState })=>{
            setState({
                userSelectedDynamicUiSubtype: userSelectedDynamicUiSubtype
            });
        },
    setInteractionSource: (interactionSource)=>({ setState: setState })=>{
            setState({
                interactionSource: interactionSource
            });
        },
    resetStagingArea: ()=>({ setState: setState })=>{
            setState({
                messageIdSelectedForPreview: null,
                invocationIdSelectedForPreview: null,
                isRemixUpdating: false,
                stagingAreaMode: undefined,
                stagingAreaEntryPoint: '',
                dynamicUiType: undefined,
                dynamicUiSubtype: undefined,
                userSelectedDynamicUiSubtype: undefined,
                dynamicUiSource: undefined,
                interactionSource: undefined,
                forceSkipAutoConversationSelection: false,
                currentDisplayMessageId: undefined
            });
        },
    setForceSkipAutoConversationSelection: (forceSkip)=>({ setState: setState })=>{
            setState({
                forceSkipAutoConversationSelection: forceSkip
            });
        },
    setCurrentDisplayMessageId: (messageId)=>({ setState: setState })=>{
            setState({
                currentDisplayMessageId: messageId
            });
        }
};
const $d9cc5462c799c5c3$var$store = (0, $8s9DV.createStore)({
    initialState: $d9cc5462c799c5c3$var$initialState,
    actions: $d9cc5462c799c5c3$var$actions
});
const $d9cc5462c799c5c3$export$a2795b51ce92008f = (0, $kBr4q.createHook)($d9cc5462c799c5c3$var$store, {
    selector: (state)=>state.messageIdSelectedForPreview
});
const $d9cc5462c799c5c3$export$916334da9df8d04 = (0, $kBr4q.createHook)($d9cc5462c799c5c3$var$store);
const $d9cc5462c799c5c3$export$8f9a13b17bec42d5 = (0, $kBr4q.createActionsHook)($d9cc5462c799c5c3$var$store);
const $d9cc5462c799c5c3$export$5a57f796673aabea = (0, $kBr4q.createStateHook)($d9cc5462c799c5c3$var$store);
module.exports["useMessageIdSelectedForPreview"] = $d9cc5462c799c5c3$export$a2795b51ce92008f;
module.exports["useStagingArea"] = $d9cc5462c799c5c3$export$916334da9df8d04;
module.exports["useStagingAreaActions"] = $d9cc5462c799c5c3$export$8f9a13b17bec42d5;
module.exports["useStagingAreaState"] = $d9cc5462c799c5c3$export$5a57f796673aabea;

});

parcelRegister("8GyO5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $ixfCV = parcelRequire("ixfCV");


var $crsgV = parcelRequire("crsgV");


var $b6QLO = parcelRequire("b6QLO");

function $1babe6d267af7ec0$export$d2a66369b43f5d65({ onClose: onClose, onOptionSelect: onOptionSelect, onRemixFlowActiveChange: onRemixFlowActiveChange, hideThinkingBar: hideThinkingBar = false, isEphemeralViewVisible: isEphemeralViewVisible = false, skipThinkingTypes: skipThinkingTypes, options: options, hiddenOptions: hiddenOptions, subtitle: subtitle, presentation: presentation = 'modal', trigger: trigger, popupPlacement: popupPlacement, popupOffset: popupOffset, isPopupOpen: isPopupOpen = true, popupRepositionKey: popupRepositionKey, showProgressBar: showProgressBar = false, isComplete: isComplete = false, isThinking: controlledIsThinking, onCompleteAnimationFinished: onCompleteAnimationFinished, contentType: contentType, autoSubmitUserPrompt: autoSubmitUserPrompt, onStopThinking: onStopThinking, isRemixEntrance: isRemixEntrance = true }) {
    // for editor, isThinking will be passed in, which is stored in editor state
    // When autoSubmitUserPrompt is set, initialise to true so the option-picker overlay is
    // never rendered on the first frame — the prompt is submitted immediately.
    const [localIsThinking, setLocalIsThinking] = (0, $cozmU.useState)(!!autoSubmitUserPrompt);
    const isThinking = controlledIsThinking ?? localIsThinking;
    const [selectedOptionType, setSelectedOptionType] = (0, $cozmU.useState)();
    // When autoSubmitUserPrompt is set and the flow is cancelled, prevent RemixOptionsOverlay
    // from flashing by tracking whether the flow has been stopped.
    const [isCancelledAutoSubmit, setIsCancelledAutoSubmit] = (0, $cozmU.useState)(false);
    const showThinkingBar = isThinking && !isEphemeralViewVisible && !hideThinkingBar;
    const handleOptionSelect = (0, $cozmU.useCallback)((params)=>{
        if (!skipThinkingTypes?.has(params.type)) setLocalIsThinking(true);
        setSelectedOptionType(params.type);
        onRemixFlowActiveChange?.(true);
        onOptionSelect?.(params);
    }, [
        onOptionSelect,
        onRemixFlowActiveChange,
        skipThinkingTypes
    ]);
    const handleStopThinking = (0, $cozmU.useCallback)(()=>{
        if ((0, $ixfCV.fg)('platform_editor_ai_remix_toolbar')) onStopThinking?.();
        setLocalIsThinking(false);
        if (autoSubmitUserPrompt) setIsCancelledAutoSubmit(true);
        // for insertion, when cancel, the logic is from ProseMirror, we'll show the modal again and
        // - we call onRemixFlowActiveChange in useEffect to cancel the request
        // but for update, when cancel, the logic is from UI, we have to call onRemixFlowActiveChange manually
        // - cause the component tree will be unmounted and the useEffect will not be called
        onRemixFlowActiveChange?.(false);
    }, [
        autoSubmitUserPrompt,
        onRemixFlowActiveChange,
        onStopThinking
    ]);
    // only when show the thinking bar, we handle the escape key to stop the thinking
    // when the thinking bar is rendered in editor, the escape will also be handled by editor
    (0, $cozmU.useEffect)(()=>{
        if ((0, $ixfCV.fg)('platform_editor_ai_remix_toolbar')) {
            if (!showThinkingBar) return;
        } else {
            if ((0, $ixfCV.fg)('platform_editor_ai_remix_in_editor_loading')) return;
            if (!isThinking) return;
        }
        return (0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener: (e)=>{
                if (e.key === 'Escape') handleStopThinking();
            }
        });
    }, [
        isThinking,
        handleStopThinking,
        showThinkingBar
    ]);
    // In popup mode, the trigger must always be rendered so the popup can anchor to it.
    // The popup content visibility is controlled by isPopupOpen.
    if (presentation === 'popup' && trigger) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $crsgV.RemixPopup), {
        isOpen: isPopupOpen && !isThinking,
        onClose: onClose,
        trigger: trigger,
        placement: popupPlacement,
        offset: popupOffset,
        onOptionSelect: handleOptionSelect,
        options: options,
        hiddenOptions: hiddenOptions,
        subtitle: subtitle,
        repositionKey: popupRepositionKey
    }), showThinkingBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6QLO.RemixThinkingBar), {
        onStop: handleStopThinking,
        optionType: selectedOptionType,
        showProgressBar: showProgressBar,
        isComplete: isComplete,
        onCompleteAnimationFinished: onCompleteAnimationFinished,
        contentType: contentType,
        isRemixEntrance: isRemixEntrance
    }));
    // Modal mode (default)
    // While thinking: show thinking bar only when ephemeral is not yet visible; otherwise show nothing
    if (isThinking) {
        if (!isEphemeralViewVisible && !hideThinkingBar) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6QLO.RemixThinkingBar), {
            onStop: handleStopThinking,
            optionType: selectedOptionType,
            showProgressBar: showProgressBar,
            isComplete: isComplete,
            onCompleteAnimationFinished: onCompleteAnimationFinished,
            contentType: contentType,
            isRemixEntrance: isRemixEntrance
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
    }
    // Suppress the option-picker if the flow was auto-submitted (pre-supplied prompt)
    // and then cancelled — the caller handles reopening via onCancel callback.
    if (isCancelledAutoSubmit) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $crsgV.RemixOverlay), {
        onClose: onClose,
        onOptionSelect: handleOptionSelect,
        options: options,
        hiddenOptions: hiddenOptions,
        subtitle: subtitle
    });
}
module.exports["RemixContainer"] = $1babe6d267af7ec0$export$d2a66369b43f5d65;

});

parcelRegister("crsgV", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $dTHYM = parcelRequire("dTHYM");


var $I7hWB = parcelRequire("I7hWB");


var $2Fmt9 = parcelRequire("2Fmt9");


var $f6cdQ = parcelRequire("f6cdQ");


var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");


var $cJ0FD = parcelRequire("cJ0FD");


var $9KSWX = parcelRequire("9KSWX");


var $7aRdF = parcelRequire("7aRdF");

var $fEPJS = parcelRequire("fEPJS");

var $aRGok = parcelRequire("aRGok");


var $2LyZS = parcelRequire("2LyZS");


var $ixfCV = parcelRequire("ixfCV");


var $5wHqn = parcelRequire("5wHqn");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $e3Wrf = parcelRequire("e3Wrf");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $lpNn5 = parcelRequire("lpNn5");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $HvNsc = parcelRequire("HvNsc");


var $1LRKz = parcelRequire("1LRKz");


var $czfXc = parcelRequire("czfXc");


var $loej8 = parcelRequire("loej8");

const $be6de585ac044839$var$headerOuterStyle = null;
const $be6de585ac044839$var$headerOuterMinimizedStyle = null;
const $be6de585ac044839$var$labsPositionStyle = null;
const $be6de585ac044839$var$headerIconWrapperStyle = null;
const $be6de585ac044839$var$headerIconWrapperMinimizedStyle = null; // 92px = space.300 (24px top padding) + 64px icon + 4px gap
const $be6de585ac044839$var$headerHeadingStyle = null; // left: 16px (space.200) + 48px icon + 8px gap = 72px
// top: vertically centered with 48px icon — icon center is at 16px + 24px = 40px,
// heading line-height ~24px, so top = 40px - 12px = 28px
const $be6de585ac044839$var$headerHeadingMinimizedStyle = null; // 120px = 92px heading top + ~28px heading height
const $be6de585ac044839$var$headerSubtitleStyle = null; // Hide subtitle in minimized state — fast fade out, delayed fade in handled by base style
const $be6de585ac044839$var$headerSubtitleMinimizedStyle = null;
const $be6de585ac044839$var$subtitleStyle = null; // 113px = 64px icon + 4px gap + ~28px heading + ~4px gap + ~13px subtitle
const $be6de585ac044839$var$headerSpacerStyle = null; // 48px = minimized icon height (no subtitle in minimized state)
const $be6de585ac044839$var$headerSpacerMinimizedStyle = null; // ── RemixSubTypeGrid styles ────────────────────────────────────────────────
const $be6de585ac044839$var$gridStyles = {
    grid: "_zulpu2gc _1e0c11p5 _yv0e16hb _1bsb1osq _1q51u2gc",
    tile: "_2rko1mok _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1l7x _1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1wqb _bfhk1bhr _80omtlke _4cvx1j28 _irr319i6"
}; // ── RemixAccordionOption styles ────────────────────────────────────────────
const $be6de585ac044839$var$accordionStyles = {
    accordionWrapper: "_2rko1mok _189ee4h9 _1dqonqa1 _1h6d1l7x _1bsb1osq",
    accordionHeader: "_2rko1mok _189eidpf _1rjcu2gc _1bsb1osq _4t3ickbl _1e0c1txw _4cvr1h6o _1bah1yb4 _bfhksm61 _bozgutpp _y4tiutpp _80omtlke",
    expandedContent: "_18zrutpp _85i5ze3t",
    pickForMeWrapper: "_18zr12x7 _1q5112x7 _85i512x7 _uwhke4h9 _15a5nqa1 _1i531l7x _1pfhutpp"
};
const $be6de585ac044839$var$accordionCollapsedStyle = null;
const $be6de585ac044839$var$accordionExpandedStyle = null;
const $be6de585ac044839$var$revealContentStyle = null;
const $be6de585ac044839$var$pickForMeButtonStyle = null; // ── RemixOverlay styles ────────────────────────────────────────────────────
const $be6de585ac044839$var$modalContentWrapperStyle = null; // ── RemixPopup styles ──────────────────────────────────────────────────────
const $be6de585ac044839$var$subtleSlideIn = null;
const $be6de585ac044839$var$popupEnterAnimationStyle = null;
const $be6de585ac044839$var$popupStyles = {
    contentWrapper: "_1reo15vq _18m915vq _2rko1mok _1e0c1txw _2lx21bp4 _1bsbnklw _bfhkhfxm",
    body: "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _1e0c1txw _2lx21bp4"
};
const $be6de585ac044839$var$scrollableBodyStyle = null;
const $be6de585ac044839$var$remixStyles = {
    describeInputBorderWrapper: "_1bsb1osq _uwhke4h9 _15a5nqa1 _1i531l7x",
    describeInputWrapper: "_1rjcutpp _18zrpxbi _1bsb1osq _bfhkhfxm",
    describePromptRow: "_zulp12x7 _1e0c1txw _2lx2vrvc _4cvresu3 _1bsb1osq",
    describeTextAreaWrapper: "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf",
    modalBodyPadding: "_18zrpxbi _1q511b66 _85i5pxbi",
    remixOptionsStack: "_1bsb1osq"
}; // ── RemixOverlayHeader ─────────────────────────────────────────────────────
function $be6de585ac044839$var$RemixOverlayHeader({ subtitle: subtitle, isMinimized: isMinimized = false }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const subtitleMessage = subtitle ?? (0, $czfXc.default).subtitle; // Track minimized state changes to trigger the icon fade-out/fade-in animation.
    // When isMinimized changes, quickly fade out at the start, then fade back in
    // near the end of the 200ms position transition.
    const iconRef = (0, $cozmU.useRef)(null);
    const prevMinimizedRef = (0, $cozmU.useRef)(isMinimized);
    (0, $cozmU.useEffect)(()=>{
        if (prevMinimizedRef.current !== isMinimized) {
            prevMinimizedRef.current = isMinimized;
            const el = iconRef.current;
            if (el) {
                // Gently fade out (uses the 100ms ease-out opacity transition from the base style)
                el.style.opacity = '0'; // Near the end of the 200ms position transition, fade back in
                const timer = setTimeout(()=>{
                    el.style.opacity = '1';
                }, 130);
                return ()=>clearTimeout(timer);
            }
        }
    }, [
        isMinimized
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_v564gl98 _kqswh2mm _1bsb1osq _1q511ejb _85i51ejb",
            isMinimized && "_1q51pxbi _85i5pxbi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage((0, $czfXc.default).labsLozengeTooltip),
        position: "top",
        delay: 0
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_kqswstnw _154ipxbi _1xi2pxbi _80om73ad _1pbykb7n"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
            ...tooltipProps,
            justifyContent: "end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: "new"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $czfXc.default).labsLozenge))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: iconRef,
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            "_v5641020 _kqswstnw _1ltv1ssb _154i1ejb _t9eczr6s _1bsbvbgk _4t3ivbgk",
            isMinimized && "_1ltvpxbi _154ipxbi _t9ecz12g _1bsbckbl _4t3ickbl"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($HvNsc))),
        alt: formatMessage((0, $czfXc.default).remixIconAlt),
        width: "100%"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_v564aquj _kqswstnw _1ltv1ssb _154iucft _t9eczr6s _o5721q9c",
            isMinimized && "_1ltv9r46 _154i1f4h _t9ecz12g"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: isMinimized ? 'medium' : 'large'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $czfXc.default).heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_v5641v7a _kqswstnw _1ltv1ssb _154i68cl _t9eczr6s _o5721q9c",
            isMinimized && "_v5641axt _tzy4idpf _lcxvglyw",
            "_syaz1rpy"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), subtitleMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_v564bxu9 _4t3i1nlq",
            isMinimized && "_4t3ickbl"
        ])
    }));
} // ── RemixSubTypeGrid ───────────────────────────────────────────────────────
function $be6de585ac044839$var$RemixSubTypeGrid({ subTypes: subTypes, onSubTypeSelect: onSubTypeSelect }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $be6de585ac044839$var$gridStyles.grid
    }, subTypes.map((subType)=>{
        const IconComponent = (0, $1LRKz.SUB_TYPE_ICON_MAP)[subType.value];
        const label = formatMessage(subType.labelMessage);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            key: subType.value,
            content: label,
            position: "top",
            delay: 0,
            ignoreTooltipPointerEvents: true
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
                ...tooltipProps,
                xcss: $be6de585ac044839$var$gridStyles.tile,
                onClick: ()=>onSubTypeSelect(subType.value),
                testId: subType.testId,
                "aria-label": label
            }, IconComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
                alt: label
            }) : null));
    }));
} // ── RemixAccordionOption ───────────────────────────────────────────────────
const $be6de585ac044839$var$animationConfig = {
    duration: ()=>450
}; // Tracks which option types have already been preloaded to avoid duplicate work.
const $be6de585ac044839$var$preloadedTypes = new Set(); /**
                                                    * Preloads sub-type icon images for a remix option so they display instantly
                                                    * when the accordion expands. Only fetches icons for the active color mode.
                                                    */ 
function $be6de585ac044839$var$preloadSubTypeIcons(option, colorMode) {
    if ($be6de585ac044839$var$preloadedTypes.has(option.type)) return;
    $be6de585ac044839$var$preloadedTypes.add(option.type);
    const isDark = colorMode === 'dark';
    for (const subType of option.subTypes){
        const urls = (0, $1LRKz.SUB_TYPE_ICON_URLS)[subType.value];
        if (urls) {
            const img = new window.Image();
            img.src = isDark ? urls.dark : urls.light;
        }
    }
}
const $be6de585ac044839$var$renderOptionIcon = (option, alt)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Fmt9.IconTile), {
        icon: option.icon,
        label: alt,
        appearance: option.iconTileAppearance ?? 'gray',
        size: "small"
    });
};
function $be6de585ac044839$var$RemixAccordionOption({ option: option, isExpanded: isExpanded, onToggle: onToggle, onSubTypeSelect: onSubTypeSelect, onPickForMe: onPickForMe, colorMode: colorMode }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const smoothResizer = (0, $2LyZS.useResizingHeight)($be6de585ac044839$var$animationConfig);
    const handleToggle = (0, $cozmU.useCallback)(()=>{
        onToggle(option.type);
    }, [
        onToggle,
        option.type
    ]);
    const handleMouseEnter = (0, $cozmU.useCallback)(()=>{
        $be6de585ac044839$var$preloadSubTypeIcons(option, colorMode);
    }, [
        option,
        colorMode
    ]);
    const handleSubTypeSelect = (0, $cozmU.useCallback)((subTypeValue)=>{
        if ((0, $ixfCV.fg)('cc-maui-phase-3')) {
            const subTypeDef = option.subTypes.find((st)=>st.value === subTypeValue);
            onSubTypeSelect(subTypeDef?.emitType ?? option.type, subTypeValue);
            return;
        }
        onSubTypeSelect(option.type, subTypeValue);
    }, [
        onSubTypeSelect,
        option.type,
        option.subTypes
    ]);
    const handlePickForMe = (0, $cozmU.useCallback)(()=>{
        onPickForMe(option.type);
    }, [
        onPickForMe,
        option.type
    ]);
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))) : (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX)));
    const optionIconAlt = formatMessage(option.iconAltMessage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            isExpanded ? "_2rko1mok _bfhk1bhr" : "_v5641s6b _2rko1mok _bfhk1bhr _irr319i6 _1dbz130s"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        xcss: $be6de585ac044839$var$accordionStyles.accordionWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
        xcss: $be6de585ac044839$var$accordionStyles.accordionHeader,
        onClick: handleToggle,
        onMouseEnter: handleMouseEnter,
        testId: option.testId,
        "aria-expanded": isExpanded,
        "aria-label": formatMessage(option.labelMessage)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
        alignItems: "center",
        gap: "space.100"
    }, $be6de585ac044839$var$renderOptionIcon(option, optionIconAlt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        weight: "medium"
    }, formatMessage(option.labelMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ChevronIcon, {
        label: "",
        color: "var(--ds-icon, #292A2E)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: smoothResizer.ref,
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq"
        ])
    }, isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $be6de585ac044839$var$accordionStyles.expandedContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixSubTypeGrid, {
        subTypes: option.subTypes,
        onSubTypeSelect: handleSubTypeSelect
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $be6de585ac044839$var$accordionStyles.pickForMeWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_zs1212b0 _1q9ti7a9 _14hp1osq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        spacing: "compact",
        onClick: handlePickForMe,
        testId: `${option.testId}-pick-for-me`
    }, formatMessage((0, $czfXc.default).pickForMe))))))));
}
const $be6de585ac044839$var$RemixFlatOption = ({ option: option, onSelect: onSelect })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleClick = (0, $cozmU.useCallback)(()=>{
        onSelect(option.type);
    }, [
        onSelect,
        option.type
    ]);
    const optionIconAlt = formatMessage(option.iconAltMessage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_v5641s6b _2rko1mok _bfhk1bhr _irr319i6 _1dbz130s"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        xcss: $be6de585ac044839$var$accordionStyles.accordionWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
        xcss: $be6de585ac044839$var$accordionStyles.accordionHeader,
        onClick: handleClick,
        testId: option.testId,
        "aria-label": formatMessage(option.labelMessage)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
        alignItems: "center",
        gap: "space.100"
    }, $be6de585ac044839$var$renderOptionIcon(option, optionIconAlt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        weight: "medium"
    }, formatMessage(option.labelMessage))))));
};
function $be6de585ac044839$export$ced6b2e82a17b9f6({ onOptionSelect: onOptionSelect, options: options, hiddenOptions: hiddenOptions, subtitle: subtitle }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const [describeValue, setDescribeValue] = (0, $cozmU.useState)('');
    const [expandedOption, setExpandedOption] = (0, $cozmU.useState)(null);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const describeTextAreaRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        // Use requestAnimationFrame to auto-focus on the describe text area after the modal fully mounts.
        // This deselects the highlighted text in the editor.
        const raf = requestAnimationFrame(()=>{
            if ((0, $ixfCV.fg)('maui-autofocus-on-remix-modal')) describeTextAreaRef.current?.focus();
        });
        return ()=>cancelAnimationFrame(raf);
    }, []);
    const resolvedOptions = (0, $cozmU.useMemo)(()=>{
        const base = options ?? (0, $loej8.REMIX_OPTIONS);
        const infographicSubTypes = (0, $loej8.getInfographicSubTypes)();
        const visualAidSubTypes = (0, $loej8.getVisualAidSubTypes)();
        return (0, $loej8.getVisibleRemixOptions)(base, hiddenOptions).map((opt)=>{
            if (opt.type === 'infographic') return {
                ...opt,
                subTypes: infographicSubTypes
            };
            if (opt.type === 'visual-aid') return {
                ...opt,
                subTypes: visualAidSubTypes
            };
            return opt;
        });
    }, [
        hiddenOptions,
        options
    ]);
    const handleDescribeSubmit = (0, $cozmU.useCallback)(()=>{
        if (describeValue?.trim()) onOptionSelect?.({
            type: 'custom',
            userPrompt: describeValue
        });
    }, [
        describeValue,
        onOptionSelect
    ]);
    const handleDescribeKeyDown = (0, $cozmU.useCallback)((e)=>{
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleDescribeSubmit();
        }
    }, [
        handleDescribeSubmit
    ]);
    const handleToggle = (0, $cozmU.useCallback)((type)=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'remixOverlaySection',
            attributes: {
                sectionType: type
            }
        });
        setExpandedOption((prev)=>prev === type ? null : type);
    }, [
        sendAnalyticsEvent
    ]);
    const handleSubTypeSelect = (0, $cozmU.useCallback)((type, subType)=>{
        const trimmedDescribe = describeValue?.trim();
        const userPrompt = trimmedDescribe && (0, $ixfCV.fg)('confluence_remix_combine_describe_and_option') ? trimmedDescribe : undefined;
        onOptionSelect?.({
            type: type,
            subType: subType,
            userPrompt: userPrompt
        });
    }, [
        onOptionSelect,
        describeValue
    ]);
    const handlePickForMe = (0, $cozmU.useCallback)((type)=>{
        onOptionSelect?.({
            type: type
        });
    }, [
        onOptionSelect
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixOverlayHeader, {
        subtitle: subtitle,
        isMinimized: expandedOption !== null
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _18m91wug"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $be6de585ac044839$var$remixStyles.modalBodyPadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.100",
        alignInline: "stretch",
        xcss: $be6de585ac044839$var$remixStyles.remixOptionsStack
    }, resolvedOptions.map((option)=>option.subTypes.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixAccordionOption, {
            key: option.type,
            option: option,
            isExpanded: expandedOption === option.type,
            onToggle: handleToggle,
            onSubTypeSelect: handleSubTypeSelect,
            onPickForMe: handlePickForMe,
            colorMode: colorMode
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$RemixFlatOption, {
            key: option.type,
            option: option,
            onSelect: handlePickForMe
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $be6de585ac044839$var$remixStyles.describeInputBorderWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $be6de585ac044839$var$remixStyles.describeInputWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: handleDescribeSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
        xcss: $be6de585ac044839$var$remixStyles.describePromptRow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $be6de585ac044839$var$remixStyles.describeTextAreaWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
        ref: describeTextAreaRef,
        appearance: "none",
        placeholder: formatMessage((0, $czfXc.default).describePlaceholder),
        value: describeValue,
        onChange: (e)=>setDescribeValue(e.currentTarget.value),
        onKeyDown: handleDescribeKeyDown,
        isCompact: true,
        minimumRows: 1,
        maxHeight: "200px",
        resize: "smart",
        "aria-label": formatMessage((0, $czfXc.default).describePlaceholder),
        testId: "remix-overlay-describe-input",
        name: "remix-overlay-describe"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        type: "submit",
        appearance: "primary",
        isDisabled: !describeValue?.trim(),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))),
        label: formatMessage((0, $czfXc.default).describeSubmitLabel),
        testId: "remix-overlay-describe-submit"
    }))))));
} /**
   * RemixOverlay — centered ADS Modal presentation
   */ 
function $be6de585ac044839$export$48a746fedb7ffb({ onClose: onClose, onOptionSelect: onOptionSelect, options: options, hiddenOptions: hiddenOptions, subtitle: subtitle }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        onClose: onClose,
        width: 320,
        testId: "remix-overlay",
        shouldReturnFocus: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _2rko1kw7 _1e0c1txw _2lx21bp4 _bfhkhfxm"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), {
        hasInlinePadding: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$export$ced6b2e82a17b9f6, {
        onOptionSelect: onOptionSelect,
        options: options,
        hiddenOptions: hiddenOptions,
        subtitle: subtitle
    })))));
} /**
   * Calls the Popup `update` function to reposition the popup whenever `repositionKey` changes.
   */ 
function $be6de585ac044839$var$PopupRepositionOnKeyChange({ repositionKey: repositionKey, update: update }) {
    const prevKey = (0, $cozmU.useRef)(repositionKey);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (prevKey.current !== repositionKey) {
            prevKey.current = repositionKey;
            update();
        }
    }, [
        repositionKey,
        update
    ]);
    return null;
} /**
   * RemixPopup — anchored ADS Popup presentation for contextual entry points (e.g. object-level sidebar).
   * No blanket, anchored to a trigger element.
   */ 
function $be6de585ac044839$export$a8b0b54f368ecbb0({ isOpen: isOpen, onClose: onClose, trigger: trigger, onOptionSelect: onOptionSelect, options: options, hiddenOptions: hiddenOptions, subtitle: subtitle, placement: placement = 'left-end', offset: offset = [
    8,
    16
], repositionKey: repositionKey }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        isOpen: isOpen,
        onClose: onClose,
        placement: placement,
        offset: offset,
        label: formatMessage((0, $czfXc.default).heading),
        role: "dialog",
        content: ({ update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$var$PopupRepositionOnKeyChange, {
                repositionKey: repositionKey,
                update: update
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: (0, $hekY6.default)([
                    "_j7hqjd5d _5sagfnf5 _1pgl1r3m _1o51eoah _1bumglyw"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                xcss: $be6de585ac044839$var$popupStyles.contentWrapper,
                testId: "remix-popup"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                xcss: $be6de585ac044839$var$popupStyles.body
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be6de585ac044839$export$ced6b2e82a17b9f6, {
                onOptionSelect: onOptionSelect,
                options: options,
                hiddenOptions: hiddenOptions,
                subtitle: subtitle
            }))))),
        trigger: (triggerProps)=>trigger(triggerProps)
    });
}
module.exports["RemixOverlay"] = $be6de585ac044839$export$48a746fedb7ffb;
module.exports["RemixPopup"] = $be6de585ac044839$export$a8b0b54f368ecbb0;

});

parcelRegister("2LyZS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4j4gm = parcelRequire("4j4gm");


var $4dGdo = parcelRequire("4dGdo");


var $jlWUB = parcelRequire("jlWUB");


var $lrDw7 = parcelRequire("lrDw7");


var $7BVQi = parcelRequire("7BVQi");


var $g3XYx = parcelRequire("g3XYx");


var $1U6E9 = parcelRequire("1U6E9");


var $jhrdR = parcelRequire("jhrdR");

const $88dfee758a89de6e$export$da99457d6430d83 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { duration: t2, timingFunction: t3 } = t1;
    let t4;
    if ($[2] !== t2) {
        t4 = t2 === undefined ? $88dfee758a89de6e$var$_temp : t2;
        $[2] = t2;
        $[3] = t4;
    } else t4 = $[3];
    const calcDuration = t4;
    let t5;
    if ($[4] !== t3) {
        t5 = t3 === undefined ? $88dfee758a89de6e$var$_temp2 : t3;
        $[4] = t3;
        $[5] = t5;
    } else t5 = $[5];
    const calcTimingFunction = t5;
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = {
            cleanup: "next-effect"
        };
        $[6] = t6;
    } else t6 = $[6];
    const setTimeout = (0, $1U6E9.useSetTimeout)(t6);
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    let t7;
    if ($[7] !== element) {
        t7 = ()=>{
            if ((0, $jlWUB.isReducedMotion)() || !element) return;
            prevDimensions.current = element.getBoundingClientRect();
        };
        $[7] = element;
        $[8] = t7;
    } else t7 = $[8];
    (0, $jhrdR.useSnapshotBeforeUpdate)(t7);
    let t8;
    if ($[9] !== calcDuration || $[10] !== calcTimingFunction || $[11] !== element || $[12] !== requestAnimationFrame || $[13] !== setTimeout) {
        t8 = ()=>{
            if ((0, $jlWUB.isReducedMotion)() || !element || !prevDimensions.current) return;
            element.setAttribute("style", "");
            const nextDimensions = element.getBoundingClientRect();
            if (nextDimensions.height === prevDimensions.current.height) return;
            const duration = calcDuration(prevDimensions.current.height, nextDimensions.height);
            const newStyles = {
                height: `${prevDimensions.current.height}px`,
                willChange: "height",
                transitionProperty: "height",
                transitionDuration: `${duration}ms`,
                boxSizing: "border-box",
                transitionTimingFunction: calcTimingFunction(prevDimensions.current.height, nextDimensions.height, duration)
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (!element) return;
                    element.style.height = `${nextDimensions.height}px`;
                    setTimeout(()=>{
                        if (!element) return;
                        element.setAttribute("style", "");
                    }, duration);
                });
            });
        };
        $[9] = calcDuration;
        $[10] = calcTimingFunction;
        $[11] = element;
        $[12] = requestAnimationFrame;
        $[13] = setTimeout;
        $[14] = t8;
    } else t8 = $[14];
    (0, $7BVQi.useLayoutEffect)(t8);
    let t9;
    if ($[15] !== setElementRef) {
        t9 = {
            ref: setElementRef
        };
        $[15] = setElementRef;
        $[16] = t9;
    } else t9 = $[16];
    return t9;
} : ({ duration: calcDuration = ()=>(0, $4dGdo.durations).medium, timingFunction: calcTimingFunction = ()=>(0, $4j4gm.easeInOut) } = {})=>{
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    // We cleanup on the next effect to prevent the previous timeout being called during
    // the next motion - as now the timeout has essentially been extended!
    const setTimeout = (0, $1U6E9.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    (0, $jhrdR.useSnapshotBeforeUpdate)(()=>{
        if ((0, $jlWUB.isReducedMotion)() || !element) return;
        prevDimensions.current = element.getBoundingClientRect();
    });
    (0, $7BVQi.useLayoutEffect)(()=>{
        if ((0, $jlWUB.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination height first.
        element.setAttribute('style', '');
        const nextDimensions = element.getBoundingClientRect();
        if (nextDimensions.height === prevDimensions.current.height) return;
        const duration = calcDuration(prevDimensions.current.height, nextDimensions.height);
        const newStyles = {
            height: `${prevDimensions.current.height}px`,
            willChange: 'height',
            transitionProperty: 'height',
            transitionDuration: `${duration}ms`,
            boxSizing: 'border-box',
            transitionTimingFunction: calcTimingFunction(prevDimensions.current.height, nextDimensions.height, duration)
        };
        Object.assign(element.style, newStyles);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                }, duration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
function $88dfee758a89de6e$var$_temp() {
    return (0, $4dGdo.durations).medium;
}
function $88dfee758a89de6e$var$_temp2() {
    return 0, $4j4gm.easeInOut;
}
module.exports["useResizingHeight"] = $88dfee758a89de6e$export$da99457d6430d83;

});

parcelRegister("lrDw7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6a66563ef19581ba$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $cozmU.useRef)(null);
    const setRef = (0, $cozmU.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $6a66563ef19581ba$export$ff879f35a69d56b7;

});

parcelRegister("g3XYx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $f8fe10123ae9dc81$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $f8fe10123ae9dc81$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $cozmU.useRef)([]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $f8fe10123ae9dc81$var$getHookDeps(opts));
    return (0, $cozmU.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
module.exports["useRequestAnimationFrame"] = $f8fe10123ae9dc81$export$1775f27e7c8051ca;

});

parcelRegister("jhrdR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7BVQi = parcelRequire("7BVQi");

const $8584e1bffd64d1d0$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $cozmU.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $7BVQi.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $8584e1bffd64d1d0$export$9e95200239cd148b;

});

parcelRegister("HvNsc", function(module, exports) {
module.exports = new URL("Remix-Illustration.7b8c03b3.svg", import.meta.url).toString();

});

parcelRegister("1LRKz", function(module, exports) {
/* constants.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $ixfCV = parcelRequire("ixfCV");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $jdqQM = parcelRequire("jdqQM");


var $a3xS2 = parcelRequire("a3xS2");


var $1qKb1 = parcelRequire("1qKb1");


var $dZaRy = parcelRequire("dZaRy");


var $i6pum = parcelRequire("i6pum");


var $hT2Mn = parcelRequire("hT2Mn");


var $7vmkU = parcelRequire("7vmkU");


var $7K13i = parcelRequire("7K13i");


var $b5QJc = parcelRequire("b5QJc");


var $5QH2j = parcelRequire("5QH2j");


var $g8eHJ = parcelRequire("g8eHJ");


var $aoAJG = parcelRequire("aoAJG");


var $6A6ao = parcelRequire("6A6ao");


var $gg5rm = parcelRequire("gg5rm");


var $av9Cl = parcelRequire("av9Cl");


var $kuWlT = parcelRequire("kuWlT");


var $7mMw3 = parcelRequire("7mMw3");


var $gP7CA = parcelRequire("gP7CA");


var $l0Xml = parcelRequire("l0Xml");


var $h7GLM = parcelRequire("h7GLM");


var $lE1xe = parcelRequire("lE1xe");


var $4VjKY = parcelRequire("4VjKY");


var $7ZPjf = parcelRequire("7ZPjf");


var $5nwSN = parcelRequire("5nwSN");


var $jDDGi = parcelRequire("jDDGi");


var $h4zH8 = parcelRequire("h4zH8");


var $5udvx = parcelRequire("5udvx");


var $glBZK = parcelRequire("glBZK");


var $eCw66 = parcelRequire("eCw66");


var $g5RPh = parcelRequire("g5RPh");


var $iAb2S = parcelRequire("iAb2S");


var $9oYVI = parcelRequire("9oYVI");


var $l1bw1 = parcelRequire("l1bw1");


var $3Mo2w = parcelRequire("3Mo2w");


var $aBRLd = parcelRequire("aBRLd");


var $gpmJ3 = parcelRequire("gpmJ3");


var $aIlia = parcelRequire("aIlia");


var $9WcaJ = parcelRequire("9WcaJ");


var $iGdgz = parcelRequire("iGdgz");


var $8IXk3 = parcelRequire("8IXk3");

const $1624994978f78343$var$iconStyles = null; // Negative margins to counteract the default padding from the Pressable tile component,
// allowing the image icon to extend edge-to-edge within the tile.
const $1624994978f78343$var$edgeToEdgeIconStyles = null;
const $1624994978f78343$var$SubTypeIcon = ({ src: src, srcDark: srcDark, alt: alt })=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const resolvedSrc = colorMode === 'dark' ? srcDark : src;
    return /*#__PURE__*/ $cozmU.createElement("img", {
        src: resolvedSrc,
        alt: alt,
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            "_1bsb1osq _4t3i1osq _5ral1dfr _1e0c1ule"
        ])
    });
};
const $1624994978f78343$export$e0452922cbc2989f = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($g5RPh))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($5QH2j))),
        alt: alt
    });
const $1624994978f78343$export$b08434c95e3df48d = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($lE1xe))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($jdqQM))),
        alt: alt
    });
const $1624994978f78343$export$472946dc5493045a = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4VjKY))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($a3xS2))),
        alt: alt
    });
const $1624994978f78343$export$ccba00b0f4d667f3 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($h4zH8))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($hT2Mn))),
        alt: alt
    });
const $1624994978f78343$export$b86b18d4ddcc0181 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aBRLd))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($av9Cl))),
        alt: alt
    });
const $1624994978f78343$export$a95ef668d7975f40 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5udvx))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($7vmkU))),
        alt: alt
    });
const $1624994978f78343$export$4f7cb0192e7b1016 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iAb2S))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($g8eHJ))),
        alt: alt
    });
const $1624994978f78343$export$2df60ac16db5f072 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($jDDGi))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($i6pum))),
        alt: alt
    });
const $1624994978f78343$export$77864082aab0bbe3 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($l1bw1))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($6A6ao))),
        alt: alt
    });
const $1624994978f78343$export$6fa49d5d85aab725 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7ZPjf))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($1qKb1))),
        alt: alt
    });
const $1624994978f78343$export$b8c6412fcf2fe65d = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9WcaJ))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($gP7CA))),
        alt: alt
    });
const $1624994978f78343$export$73f1bfda08325f1c = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aIlia))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($7mMw3))),
        alt: alt
    });
const $1624994978f78343$export$1968847f71768cdf = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9oYVI))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($aoAJG))),
        alt: alt
    });
const $1624994978f78343$export$c02ff6805d67acb2 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5nwSN))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($dZaRy))),
        alt: alt
    });
const $1624994978f78343$export$368b8c86d4677a50 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($gpmJ3))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($kuWlT))),
        alt: alt
    });
const $1624994978f78343$export$23e94ddbc9d88fae = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($8IXk3))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($h7GLM))),
        alt: alt
    });
const $1624994978f78343$export$e5aa73ddcf9d62e8 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($iGdgz))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($l0Xml))),
        alt: alt
    });
const $1624994978f78343$export$a18ea9af6c181602 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($glBZK))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($7K13i))),
        alt: alt
    });
const $1624994978f78343$export$84442c0324e009f8 = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3Mo2w))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($gg5rm))),
        alt: alt
    });
const $1624994978f78343$var$ImageIcon = ({ alt: alt })=>/*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_19pk1n1a _2hwxyjp0 _otyr1n1a _18u0yjp0"
        ])
    }, /*#__PURE__*/ $cozmU.createElement($1624994978f78343$var$SubTypeIcon, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($eCw66))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($b5QJc))),
        alt: alt
    }));
const $1624994978f78343$export$65d7e4b11d55029 = {
    // Charts
    'line-chart': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($g5RPh))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($5QH2j)))
    },
    'area-chart': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($lE1xe))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($jdqQM)))
    },
    'bar-chart': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($4VjKY))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($a3xS2)))
    },
    'funnel-chart': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($h4zH8))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($hT2Mn)))
    },
    'pie-chart': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($aBRLd))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($av9Cl)))
    },
    'gantt-chart': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($5udvx))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($7vmkU)))
    },
    // Diagrams
    mindmap: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($iAb2S))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($g8eHJ)))
    },
    flowchart: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($jDDGi))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($i6pum)))
    },
    // Infographics
    'corporate-modern': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($l1bw1))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($6A6ao)))
    },
    'corporate-doodle': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($aIlia))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($7mMw3)))
    },
    charlie: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($7ZPjf))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($1qKb1)))
    },
    minimalist: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($9oYVI))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($aoAJG)))
    },
    // Visual aids
    'flip-card': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($5nwSN))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($dZaRy)))
    },
    quadrant: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($gpmJ3))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($kuWlT)))
    },
    'tree-map': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($8IXk3))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($h7GLM)))
    },
    'horizontal-timeline': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($iGdgz))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($l0Xml)))
    },
    map: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($glBZK))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($7K13i)))
    },
    'org-chart': {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($3Mo2w))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($gg5rm)))
    },
    image: {
        light: (0, (/*@__PURE__*/$parcel$interopDefault($eCw66))),
        dark: (0, (/*@__PURE__*/$parcel$interopDefault($b5QJc)))
    }
};
const $1624994978f78343$export$ebd45e32b7708bfa = {
    // Charts
    'line-chart': $1624994978f78343$export$e0452922cbc2989f,
    'area-chart': $1624994978f78343$export$b08434c95e3df48d,
    'bar-chart': $1624994978f78343$export$472946dc5493045a,
    'funnel-chart': $1624994978f78343$export$ccba00b0f4d667f3,
    'pie-chart': $1624994978f78343$export$b86b18d4ddcc0181,
    'gantt-chart': $1624994978f78343$export$a95ef668d7975f40,
    // Diagrams
    mindmap: $1624994978f78343$export$4f7cb0192e7b1016,
    flowchart: $1624994978f78343$export$2df60ac16db5f072,
    // Infographics
    'corporate-modern': $1624994978f78343$export$77864082aab0bbe3,
    'corporate-doodle': (props)=>(0, $ixfCV.fg)('cc-maui-phase-2') ? /*#__PURE__*/ $cozmU.createElement($1624994978f78343$export$73f1bfda08325f1c, props) : /*#__PURE__*/ $cozmU.createElement($1624994978f78343$export$b8c6412fcf2fe65d, props),
    charlie: $1624994978f78343$export$6fa49d5d85aab725,
    minimalist: $1624994978f78343$export$1968847f71768cdf,
    // Visual aids
    'flip-card': $1624994978f78343$export$c02ff6805d67acb2,
    quadrant: $1624994978f78343$export$368b8c86d4677a50,
    'tree-map': $1624994978f78343$export$23e94ddbc9d88fae,
    'horizontal-timeline': $1624994978f78343$export$e5aa73ddcf9d62e8,
    map: $1624994978f78343$export$a18ea9af6c181602,
    'org-chart': $1624994978f78343$export$84442c0324e009f8,
    image: $1624994978f78343$var$ImageIcon
};
module.exports["SUB_TYPE_ICON_URLS"] = $1624994978f78343$export$65d7e4b11d55029;
module.exports["SUB_TYPE_ICON_MAP"] = $1624994978f78343$export$ebd45e32b7708bfa;

});

parcelRegister("jdqQM", function(module, exports) {
module.exports = new URL("area-chart.55f6e465.svg", import.meta.url).toString();

});

parcelRegister("a3xS2", function(module, exports) {
module.exports = new URL("bar-chart.fd78c047.svg", import.meta.url).toString();

});

parcelRegister("1qKb1", function(module, exports) {
module.exports = new URL("bold.2cc98dbc.svg", import.meta.url).toString();

});

parcelRegister("dZaRy", function(module, exports) {
module.exports = new URL("flip-cards.5ca8ff0a.svg", import.meta.url).toString();

});

parcelRegister("i6pum", function(module, exports) {
module.exports = new URL("flowchart.be00d296.svg", import.meta.url).toString();

});

parcelRegister("hT2Mn", function(module, exports) {
module.exports = new URL("funnel-chart.c5c5ee8c.svg", import.meta.url).toString();

});

parcelRegister("7vmkU", function(module, exports) {
module.exports = new URL("gantt-chart.a8acacb3.svg", import.meta.url).toString();

});

parcelRegister("7K13i", function(module, exports) {
module.exports = new URL("geographical-map.8aed36b5.svg", import.meta.url).toString();

});

parcelRegister("b5QJc", function(module, exports) {
module.exports = new URL("image-option-dark.4ef2b9c9.png", import.meta.url).toString();

});

parcelRegister("5QH2j", function(module, exports) {
module.exports = new URL("line-chart.170f1aac.svg", import.meta.url).toString();

});

parcelRegister("g8eHJ", function(module, exports) {
module.exports = new URL("mindmap.3d2ae695.svg", import.meta.url).toString();

});

parcelRegister("aoAJG", function(module, exports) {
module.exports = new URL("minimalist.5f043ef2.svg", import.meta.url).toString();

});

parcelRegister("6A6ao", function(module, exports) {
module.exports = new URL("modern.b9c52e72.svg", import.meta.url).toString();

});

parcelRegister("gg5rm", function(module, exports) {
module.exports = new URL("org-chart.4294f091.svg", import.meta.url).toString();

});

parcelRegister("av9Cl", function(module, exports) {
module.exports = new URL("pie-chart.51f3bebf.svg", import.meta.url).toString();

});

parcelRegister("kuWlT", function(module, exports) {
module.exports = new URL("quadrant.199f7d1e.svg", import.meta.url).toString();

});

parcelRegister("7mMw3", function(module, exports) {
module.exports = new URL("sketch-v2.a013bb92.svg", import.meta.url).toString();

});

parcelRegister("gP7CA", function(module, exports) {
module.exports = new URL("sketch.450eefc9.svg", import.meta.url).toString();

});

parcelRegister("l0Xml", function(module, exports) {
module.exports = new URL("timeline.6ae6674b.svg", import.meta.url).toString();

});

parcelRegister("h7GLM", function(module, exports) {
module.exports = new URL("treemap.1a39a30f.svg", import.meta.url).toString();

});

parcelRegister("lE1xe", function(module, exports) {
module.exports = new URL("area-chart.5c4ca07f.svg", import.meta.url).toString();

});

parcelRegister("4VjKY", function(module, exports) {
module.exports = new URL("bar-chart.958c9357.svg", import.meta.url).toString();

});

parcelRegister("7ZPjf", function(module, exports) {
module.exports = new URL("bold.1787aad2.svg", import.meta.url).toString();

});

parcelRegister("5nwSN", function(module, exports) {
module.exports = new URL("flip-cards.429027cc.svg", import.meta.url).toString();

});

parcelRegister("jDDGi", function(module, exports) {
module.exports = new URL("flowchart.77339b70.svg", import.meta.url).toString();

});

parcelRegister("h4zH8", function(module, exports) {
module.exports = new URL("funnel-chart.12ecbc63.svg", import.meta.url).toString();

});

parcelRegister("5udvx", function(module, exports) {
module.exports = new URL("gantt-chart.1c11810d.svg", import.meta.url).toString();

});

parcelRegister("glBZK", function(module, exports) {
module.exports = new URL("geographical-map.ac5f4483.svg", import.meta.url).toString();

});

parcelRegister("eCw66", function(module, exports) {
module.exports = new URL("image-option.51f3f511.png", import.meta.url).toString();

});

parcelRegister("g5RPh", function(module, exports) {
module.exports = new URL("line-chart.57ecd877.svg", import.meta.url).toString();

});

parcelRegister("iAb2S", function(module, exports) {
module.exports = new URL("mindmap.d452b507.svg", import.meta.url).toString();

});

parcelRegister("9oYVI", function(module, exports) {
module.exports = new URL("minimalist.cbf91eb3.svg", import.meta.url).toString();

});

parcelRegister("l1bw1", function(module, exports) {
module.exports = new URL("modern.4ca836a7.svg", import.meta.url).toString();

});

parcelRegister("3Mo2w", function(module, exports) {
module.exports = new URL("org-chart.694f44ab.svg", import.meta.url).toString();

});

parcelRegister("aBRLd", function(module, exports) {
module.exports = new URL("pie-chart.0477082d.svg", import.meta.url).toString();

});

parcelRegister("gpmJ3", function(module, exports) {
module.exports = new URL("quadrant.5175de07.svg", import.meta.url).toString();

});

parcelRegister("aIlia", function(module, exports) {
module.exports = new URL("sketch-v2.79c71454.svg", import.meta.url).toString();

});

parcelRegister("9WcaJ", function(module, exports) {
module.exports = new URL("sketch.35e2121b.svg", import.meta.url).toString();

});

parcelRegister("iGdgz", function(module, exports) {
module.exports = new URL("timeline.3d28aa4e.svg", import.meta.url).toString();

});

parcelRegister("8IXk3", function(module, exports) {
module.exports = new URL("treemap.1a39a30f.svg", import.meta.url).toString();

});

parcelRegister("czfXc", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $b0a9658e5a4289f5$var$messages = (0, $kSwu1.defineMessages)({
    // ── Header ──────────────────────────────────────────────────────────────
    heading: {
        id: "malleable-ui-components.remix.heading",
        defaultMessage: "Remix"
    },
    subtitle: {
        id: "malleable-ui-components.remix.subtitle",
        defaultMessage: "View this content in a new form"
    },
    labsLozenge: {
        id: "malleable-ui-components.remix.labs-lozenge.updated",
        defaultMessage: "Labs"
    },
    labsLozengeTooltip: {
        id: "malleable-ui-components.remix.option.lozenge-tooltip",
        defaultMessage: "Beta: This feature is still in development."
    },
    remixIconAlt: {
        id: "malleable-ui-components.remix.icon-alt",
        defaultMessage: "Remix icon"
    },
    // ── Describe input ─────────────────────────────────────────────────────
    describePlaceholder: {
        id: "malleable-ui-components.remix.describe-placeholder",
        defaultMessage: "Or describe your remix..."
    },
    describeSubmitLabel: {
        id: "malleable-ui-components.remix.describe-submit-label",
        defaultMessage: "Submit"
    },
    // ── Top-level option labels ────────────────────────────────────────────
    remixOptionChart: {
        id: "malleable-ui-components.remix.option.chart",
        defaultMessage: "Charts"
    },
    remixOptionDiagram: {
        id: "malleable-ui-components.remix.option.diagram",
        defaultMessage: "Diagrams"
    },
    remixOptionInfographic: {
        id: "malleable-ui-components.remix.option.infographic",
        defaultMessage: "Infographics"
    },
    remixOptionVisualization: {
        id: "malleable-ui-components.remix.option.visualization",
        defaultMessage: "Visualizations"
    },
    // ── Top-level option icon alts ─────────────────────────────────────────
    chartIconAlt: {
        id: "malleable-ui-components.remix.option.chart-icon-alt",
        defaultMessage: "Chart icon"
    },
    diagramIconAlt: {
        id: "malleable-ui-components.remix.option.diagram-icon-alt",
        defaultMessage: "Diagram icon"
    },
    infographicIconAlt: {
        id: "malleable-ui-components.remix.option.infographic-icon-alt",
        defaultMessage: "Infographic icon"
    },
    visualizationIconAlt: {
        id: "malleable-ui-components.remix.option.visualization-icon-alt",
        defaultMessage: "Visualization icon"
    },
    // ── Top-level option tooltips ──────────────────────────────────────────
    chartTooltip: {
        id: "malleable-ui-components.remix.option.chart-tooltip",
        defaultMessage: "View your data as a chart or graph"
    },
    diagramTooltip: {
        id: "malleable-ui-components.remix.option.diagram-tooltip",
        defaultMessage: "Show relationships with a diagram"
    },
    infographicTooltip: {
        id: "malleable-ui-components.remix.option.infographic-tooltip",
        defaultMessage: "Summarize key points with an infographic"
    },
    visualizationTooltip: {
        id: "malleable-ui-components.remix.option.visualization-tooltip",
        defaultMessage: "Bring your content to life with a bespoke visual"
    },
    // ── Sub-type labels (charts) ───────────────────────────────────────────
    subTypeLineChart: {
        id: "malleable-ui-components.remix.sub-type.line-chart",
        defaultMessage: "Line chart"
    },
    subTypeAreaChart: {
        id: "malleable-ui-components.remix.sub-type.area-chart",
        defaultMessage: "Area chart"
    },
    subTypeBarChart: {
        id: "malleable-ui-components.remix.sub-type.bar-chart",
        defaultMessage: "Bar chart"
    },
    subTypeFunnelChart: {
        id: "malleable-ui-components.remix.sub-type.funnel-chart",
        defaultMessage: "Funnel chart"
    },
    subTypePieChart: {
        id: "malleable-ui-components.remix.sub-type.pie-chart",
        defaultMessage: "Pie chart"
    },
    subTypeGanttChart: {
        id: "malleable-ui-components.remix.sub-type.gantt-chart",
        defaultMessage: "Gantt chart"
    },
    // ── Sub-type labels (diagrams) ─────────────────────────────────────────
    subTypeMindMap: {
        id: "malleable-ui-components.remix.sub-type.mind-map",
        defaultMessage: "Mindmap"
    },
    subTypeFlowChart: {
        id: "malleable-ui-components.remix.sub-type.flow-chart",
        defaultMessage: "Flowchart"
    },
    // ── Sub-type labels (infographics) ─────────────────────────────────────
    subTypeModernStyle: {
        id: "malleable-ui-components.remix.sub-type.modern-style",
        defaultMessage: "Modern style"
    },
    subTypeBoldStyle: {
        id: "malleable-ui-components.remix.sub-type.bold-style",
        defaultMessage: "Bold style"
    },
    subTypeSketchStyle: {
        id: "malleable-ui-components.remix.sub-type.sketch-style",
        defaultMessage: "Sketch style"
    },
    subTypeMinimalistStyle: {
        id: "malleable-ui-components.remix.sub-type.minimalist-style",
        defaultMessage: "Minimalist style"
    },
    // ── Sub-type labels (visual aids) ──────────────────────────────────────
    subTypeFlipCard: {
        id: "malleable-ui-components.remix.sub-type.flip-card",
        defaultMessage: "Flip card"
    },
    subTypeQuadrant: {
        id: "malleable-ui-components.remix.sub-type.quadrant",
        defaultMessage: "Quadrant"
    },
    subTypeTreeMap: {
        id: "malleable-ui-components.remix.sub-type.tree-map",
        defaultMessage: "Tree map"
    },
    subTypeTimeline: {
        id: "malleable-ui-components.remix.sub-type.timeline",
        defaultMessage: "Timeline"
    },
    subTypeGeographicalMap: {
        id: "malleable-ui-components.remix.sub-type.geographical-map",
        defaultMessage: "Geographical map"
    },
    subTypeOrgChart: {
        id: "malleable-ui-components.remix.sub-type.org-chart",
        defaultMessage: "Org chart"
    },
    subTypeImage: {
        id: "malleable-ui-components.remix.sub-type.image",
        defaultMessage: "Image"
    },
    pageRemixSubtitle: {
        id: "malleable-ui-components.remix.page-remix-subtitle",
        defaultMessage: "Create content inspired by this work"
    },
    remixOptionSlides: {
        id: "malleable-ui-components.remix.option.slides",
        defaultMessage: "Slides"
    },
    remixOptionWhiteboard: {
        id: "malleable-ui-components.remix.option.whiteboard",
        defaultMessage: "Whiteboard"
    },
    remixOptionDatabase: {
        id: "malleable-ui-components.remix.option.database",
        defaultMessage: "Database"
    },
    slidesIconAlt: {
        id: "malleable-ui-components.remix.option.slides-icon-alt",
        defaultMessage: "Slides icon"
    },
    whiteboardIconAlt: {
        id: "malleable-ui-components.remix.option.whiteboard-icon-alt",
        defaultMessage: "Whiteboard icon"
    },
    databaseIconAlt: {
        id: "malleable-ui-components.remix.option.database-icon-alt",
        defaultMessage: "Database icon"
    },
    slidesTooltip: {
        id: "malleable-ui-components.remix.option.slides-tooltip",
        defaultMessage: "Transform your page into a slide deck"
    },
    whiteboardTooltip: {
        id: "malleable-ui-components.remix.option.whiteboard-tooltip",
        defaultMessage: "Visualize your page on a whiteboard"
    },
    databaseTooltip: {
        id: "malleable-ui-components.remix.option.database-tooltip",
        defaultMessage: "Structure your page content as a database"
    },
    // ── Pick for me ────────────────────────────────────────────────────────
    pickForMe: {
        id: "malleable-ui-components.remix.pick-for-me",
        defaultMessage: "Pick for me"
    },
    // ── Unused legacy keys kept for i18n backwards compat ──────────────────
    selectedContent: {
        id: "malleable-ui-components.remix.selected-content",
        defaultMessage: "Selected content"
    },
    noContent: {
        id: "malleable-ui-components.remix.no-content",
        defaultMessage: "No content selected"
    }
});
var $b0a9658e5a4289f5$export$2e2bcd8739ae039 = $b0a9658e5a4289f5$var$messages;
module.exports["default"] = $b0a9658e5a4289f5$export$2e2bcd8739ae039;

});

parcelRegister("loej8", function(module, exports) {

var $gJ798 = parcelRequire("gJ798");


var $eFBG8 = parcelRequire("eFBG8");


var $2lF67 = parcelRequire("2lF67");


var $lBKFk = parcelRequire("lBKFk");


var $a79Sy = parcelRequire("a79Sy");


var $9KPiA = parcelRequire("9KPiA");


var $bDjVc = parcelRequire("bDjVc");


var $ixfCV = parcelRequire("ixfCV");


var $czfXc = parcelRequire("czfXc");

/**
 * All available remix options with their sub-types (variants).
 *
 * Sub-type values match the backend `dynamicUiSubtype` parameter
 * used in the remix-content minion (see edit-with-rovo-bar).
 */ const $1b429d4516497df0$var$defaultInfographicSubTypes = [
    {
        value: 'corporate-modern',
        displayName: 'modern style infographic',
        labelMessage: (0, $czfXc.default).subTypeModernStyle,
        testId: 'remix-sub-type-corporate-modern'
    },
    {
        value: 'corporate-doodle',
        displayName: 'sketch style infographic',
        labelMessage: (0, $czfXc.default).subTypeSketchStyle,
        testId: 'remix-sub-type-corporate-doodle'
    }
];
const $1b429d4516497df0$var$newInfographicSubTypes = [
    {
        value: 'charlie',
        displayName: 'bold style infographic',
        labelMessage: (0, $czfXc.default).subTypeBoldStyle,
        testId: 'remix-sub-type-charlie'
    },
    {
        value: 'minimalist',
        displayName: 'minimalist style infographic',
        labelMessage: (0, $czfXc.default).subTypeMinimalistStyle,
        testId: 'remix-sub-type-minimalist'
    },
    {
        value: 'corporate-doodle',
        displayName: 'sketch style infographic',
        labelMessage: (0, $czfXc.default).subTypeSketchStyle,
        testId: 'remix-sub-type-corporate-doodle'
    }
];
function $1b429d4516497df0$export$b867d47ced1865f7() {
    return (0, $ixfCV.fg)('cc-maui-phase-2') ? $1b429d4516497df0$var$newInfographicSubTypes : $1b429d4516497df0$var$defaultInfographicSubTypes;
}
const $1b429d4516497df0$var$defaultVisualAidSubTypes = [
    {
        value: 'flip-card',
        displayName: 'flip card',
        labelMessage: (0, $czfXc.default).subTypeFlipCard,
        testId: 'remix-sub-type-flip-card'
    },
    {
        value: 'quadrant',
        displayName: 'quadrant',
        labelMessage: (0, $czfXc.default).subTypeQuadrant,
        testId: 'remix-sub-type-quadrant'
    },
    {
        value: 'tree-map',
        displayName: 'tree map',
        labelMessage: (0, $czfXc.default).subTypeTreeMap,
        testId: 'remix-sub-type-tree-map'
    },
    {
        value: 'horizontal-timeline',
        displayName: 'timeline',
        labelMessage: (0, $czfXc.default).subTypeTimeline,
        testId: 'remix-sub-type-horizontal-timeline'
    },
    {
        value: 'map',
        displayName: 'map',
        labelMessage: (0, $czfXc.default).subTypeGeographicalMap,
        testId: 'remix-sub-type-map'
    },
    {
        value: 'org-chart',
        displayName: 'org chart',
        labelMessage: (0, $czfXc.default).subTypeOrgChart,
        testId: 'remix-sub-type-org-chart'
    }
];
const $1b429d4516497df0$var$imageSubType = {
    value: 'image',
    displayName: 'image',
    labelMessage: (0, $czfXc.default).subTypeImage,
    testId: 'remix-sub-type-image',
    emitType: 'image'
};
function $1b429d4516497df0$export$b9ec4f683b57ea1d() {
    return (0, $ixfCV.fg)('cc-maui-phase-3') ? [
        ...$1b429d4516497df0$var$defaultVisualAidSubTypes,
        $1b429d4516497df0$var$imageSubType
    ] : $1b429d4516497df0$var$defaultVisualAidSubTypes;
}
const $1b429d4516497df0$export$f0ba07b8deaf6c2d = [
    {
        type: 'chart',
        displayName: 'chart',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gJ798))),
        labelMessage: (0, $czfXc.default).remixOptionChart,
        iconAltMessage: (0, $czfXc.default).chartIconAlt,
        tooltipMessage: (0, $czfXc.default).chartTooltip,
        testId: 'remix-overlay-option-chart',
        subTypes: [
            {
                value: 'line-chart',
                displayName: 'line chart',
                labelMessage: (0, $czfXc.default).subTypeLineChart,
                testId: 'remix-sub-type-line-chart'
            },
            {
                value: 'area-chart',
                displayName: 'area chart',
                labelMessage: (0, $czfXc.default).subTypeAreaChart,
                testId: 'remix-sub-type-area-chart'
            },
            {
                value: 'bar-chart',
                displayName: 'bar chart',
                labelMessage: (0, $czfXc.default).subTypeBarChart,
                testId: 'remix-sub-type-bar-chart'
            },
            {
                value: 'funnel-chart',
                displayName: 'funnel chart',
                labelMessage: (0, $czfXc.default).subTypeFunnelChart,
                testId: 'remix-sub-type-funnel-chart'
            },
            {
                value: 'pie-chart',
                displayName: 'pie chart',
                labelMessage: (0, $czfXc.default).subTypePieChart,
                testId: 'remix-sub-type-pie-chart'
            },
            {
                value: 'gantt-chart',
                displayName: 'Gantt chart',
                labelMessage: (0, $czfXc.default).subTypeGanttChart,
                testId: 'remix-sub-type-gantt-chart'
            }
        ]
    },
    {
        type: 'diagram',
        displayName: 'diagram',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eFBG8))),
        labelMessage: (0, $czfXc.default).remixOptionDiagram,
        iconAltMessage: (0, $czfXc.default).diagramIconAlt,
        tooltipMessage: (0, $czfXc.default).diagramTooltip,
        testId: 'remix-overlay-option-diagram',
        subTypes: [
            {
                value: 'mindmap',
                displayName: 'mind map',
                labelMessage: (0, $czfXc.default).subTypeMindMap,
                testId: 'remix-sub-type-mindmap'
            },
            {
                value: 'flowchart',
                displayName: 'flowchart',
                labelMessage: (0, $czfXc.default).subTypeFlowChart,
                testId: 'remix-sub-type-flowchart'
            }
        ]
    },
    {
        type: 'infographic',
        displayName: 'infographic',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2lF67))),
        labelMessage: (0, $czfXc.default).remixOptionInfographic,
        iconAltMessage: (0, $czfXc.default).infographicIconAlt,
        tooltipMessage: (0, $czfXc.default).infographicTooltip,
        testId: 'remix-overlay-option-infographic',
        subTypes: $1b429d4516497df0$var$defaultInfographicSubTypes
    },
    {
        type: 'visual-aid',
        displayName: 'visualization',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($a79Sy))),
        labelMessage: (0, $czfXc.default).remixOptionVisualization,
        iconAltMessage: (0, $czfXc.default).visualizationIconAlt,
        tooltipMessage: (0, $czfXc.default).visualizationTooltip,
        testId: 'remix-overlay-option-visual-aid',
        subTypes: $1b429d4516497df0$var$defaultVisualAidSubTypes
    }
];
const $1b429d4516497df0$export$839e8948e17d6e68 = [
    {
        type: 'slides',
        displayName: 'slides',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9KPiA))),
        labelMessage: (0, $czfXc.default).remixOptionSlides,
        iconAltMessage: (0, $czfXc.default).slidesIconAlt,
        tooltipMessage: (0, $czfXc.default).slidesTooltip,
        testId: 'remix-overlay-option-slides',
        subTypes: [],
        iconTileAppearance: 'green'
    },
    {
        type: 'whiteboard',
        displayName: 'whiteboard',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
        labelMessage: (0, $czfXc.default).remixOptionWhiteboard,
        iconAltMessage: (0, $czfXc.default).whiteboardIconAlt,
        tooltipMessage: (0, $czfXc.default).whiteboardTooltip,
        testId: 'remix-overlay-option-whiteboard',
        subTypes: [],
        iconTileAppearance: 'teal'
    },
    {
        type: 'database',
        displayName: 'database',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
        labelMessage: (0, $czfXc.default).remixOptionDatabase,
        iconAltMessage: (0, $czfXc.default).databaseIconAlt,
        tooltipMessage: (0, $czfXc.default).databaseTooltip,
        testId: 'remix-overlay-option-database',
        subTypes: [],
        iconTileAppearance: 'purple'
    },
    {
        type: 'infographic',
        displayName: 'infographic',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2lF67))),
        labelMessage: (0, $czfXc.default).remixOptionInfographic,
        iconAltMessage: (0, $czfXc.default).infographicIconAlt,
        tooltipMessage: (0, $czfXc.default).infographicTooltip,
        testId: 'remix-overlay-option-infographic',
        subTypes: $1b429d4516497df0$var$defaultInfographicSubTypes
    }
];
/**
 * Builds a combined list of all remix options with FG-gated infographic subtypes.
 * Called at render time to ensure feature flags are resolved.
 */ function $1b429d4516497df0$var$getAllOptions() {
    const infographicSubTypes = $1b429d4516497df0$export$b867d47ced1865f7();
    const visualAidSubTypes = $1b429d4516497df0$export$b9ec4f683b57ea1d();
    return [
        ...$1b429d4516497df0$export$f0ba07b8deaf6c2d,
        ...$1b429d4516497df0$export$839e8948e17d6e68
    ].map((opt)=>{
        if (opt.type === 'infographic') return {
            ...opt,
            subTypes: infographicSubTypes
        };
        if (opt.type === 'visual-aid') return {
            ...opt,
            subTypes: visualAidSubTypes
        };
        return opt;
    });
}
function $1b429d4516497df0$export$cf3073d90a2d0bae(options, hiddenOptions) {
    if (!hiddenOptions?.length) return options;
    const hiddenOptionSet = new Set(hiddenOptions);
    return options.filter((option)=>option.type === 'custom' || !hiddenOptionSet.has(option.type));
}
function $1b429d4516497df0$export$b3104233810c1e93(typeValue) {
    const match = $1b429d4516497df0$var$getAllOptions().find((option)=>option.type === typeValue);
    return match?.displayName ?? typeValue.replace(/-/g, ' ');
}
function $1b429d4516497df0$export$ca76798d0446453(subTypeValue) {
    for (const option of $1b429d4516497df0$var$getAllOptions()){
        const match = option.subTypes.find((st)=>st.value === subTypeValue);
        if (match) return match.displayName;
    }
    return subTypeValue.replace(/-/g, ' ');
}
function $1b429d4516497df0$export$bd80fc308a7bbe16(dynamicUiType, dynamicUiSubtype) {
    const allOptions = $1b429d4516497df0$var$getAllOptions();
    // First, try to find the category by matching the dynamicUiType directly.
    let matchedOption = allOptions.find((opt)=>opt.type === dynamicUiType);
    // If the direct match doesn't contain the requested sub-type (e.g. the
    // node's emitType points to a different category than where the sub-type
    // actually lives), or if no category matched at all, fall back to scanning
    // all categories for a sub-type whose value or emitType matches.
    if (dynamicUiSubtype) {
        const subtypeInMatch = matchedOption?.subTypes.some((st)=>st.value === dynamicUiSubtype);
        if (!matchedOption || !subtypeInMatch) {
            const fallback = allOptions.find((opt)=>opt.subTypes.some((st)=>st.value === dynamicUiSubtype || st.emitType === dynamicUiType));
            if (fallback) matchedOption = fallback;
        }
    } else if (!matchedOption) {
        // No subtype provided and no direct category match — the dynamicUiType
        // may be an emitType override (e.g. 'image' which is a sub-type in
        // 'visual-aid' with emitType: 'image'). Scan all categories for a
        // sub-type whose emitType matches.
        const fallback = allOptions.find((opt)=>opt.subTypes.some((st)=>st.emitType === dynamicUiType));
        if (fallback) matchedOption = fallback;
    }
    // No matching category, or category has no sub-types (e.g. slides, whiteboard)
    if (!matchedOption || matchedOption.subTypes.length === 0) return null;
    const groupLabel = matchedOption.labelMessage.defaultMessage ?? '';
    const groupLabelMessage = matchedOption.labelMessage;
    // Find the current sub-type within the matched category.
    // When dynamicUiSubtype is provided, match by value directly.
    // When only dynamicUiType is provided (no subtype), try to find a sub-type
    // whose emitType matches dynamicUiType (e.g. emitType: 'image' → the 'image' sub-type).
    let currentSubType = dynamicUiSubtype ? matchedOption.subTypes.find((st)=>st.value === dynamicUiSubtype) : matchedOption.subTypes.find((st)=>st.emitType === dynamicUiType);
    // If a subtype was provided but not found in this category, return null
    // to avoid showing a broken dropdown.
    if (dynamicUiSubtype && !currentSubType) return null;
    // Variants with `emitType` are only selectable from the remix-overlay.
    // When the active subtype has an emitType override, hide the switcher
    // entirely so the user cannot switch away from it.
    if (currentSubType?.emitType) return null;
    // Filter out emitType variants from the switcher — they should only
    // appear in the remix-overlay, not in the editor toolbar dropdown.
    const filteredSubTypes = matchedOption.subTypes.filter((st)=>!st.emitType);
    if (filteredSubTypes.length === 0) return null;
    // Fall back to category-level label if no sub-type is set
    // (e.g. "Pick for me" was used).
    const currentLabel = currentSubType ? currentSubType.labelMessage.defaultMessage ?? '' : groupLabel;
    const currentLabelMessage = currentSubType ? currentSubType.labelMessage : groupLabelMessage;
    return {
        groupLabel: groupLabel,
        groupLabelMessage: groupLabelMessage,
        currentLabel: currentLabel,
        currentLabelMessage: currentLabelMessage,
        siblingSubTypes: filteredSubTypes
    };
}
module.exports["getInfographicSubTypes"] = $1b429d4516497df0$export$b867d47ced1865f7;
module.exports["getVisualAidSubTypes"] = $1b429d4516497df0$export$b9ec4f683b57ea1d;
module.exports["REMIX_OPTIONS"] = $1b429d4516497df0$export$f0ba07b8deaf6c2d;
module.exports["PAGE_REMIX_OPTIONS"] = $1b429d4516497df0$export$839e8948e17d6e68;
module.exports["getVisibleRemixOptions"] = $1b429d4516497df0$export$cf3073d90a2d0bae;
module.exports["getTypeDisplayName"] = $1b429d4516497df0$export$b3104233810c1e93;
module.exports["getSubTypeDisplayName"] = $1b429d4516497df0$export$ca76798d0446453;
module.exports["getRemixSwitcherInfo"] = $1b429d4516497df0$export$bd80fc308a7bbe16;

});

parcelRegister("b6QLO", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ixfCV = parcelRequire("ixfCV");


var $iMnC5 = parcelRequire("iMnC5");


var $kb1I3 = parcelRequire("kb1I3");


var $3sXr4 = parcelRequire("3sXr4");

const $79c6915ee8b28dcd$var$messages = (0, $kSwu1.defineMessages)({
    rovoIsThinking: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.rovo-is-thinking",
        defaultMessage: "Rovo is thinking"
    },
    analyzingContent: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.analyzing-content",
        defaultMessage: "Analyzing your content"
    },
    puttingPiecesTogether: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.putting-pieces-together",
        defaultMessage: "Putting the pieces together"
    },
    structuringRemix: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.structuring-remix",
        defaultMessage: "Structuring your remix"
    },
    designingRemix: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.designing-remix",
        defaultMessage: "Designing your remix"
    },
    addingItAllTogether: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.adding-it-all-together",
        defaultMessage: "Adding it all together"
    },
    applyingFinalTouches: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.applying-final-touches",
        defaultMessage: "Applying the final touches"
    },
    almostDone: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.almost-done",
        defaultMessage: "Almost done"
    }
});
const $79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance = (0, $kSwu1.defineMessages)({
    rovoIsImagining: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.rovo-is-imagining",
        defaultMessage: "Rovo is dreaming it up"
    },
    sketchingSomeIdeas: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.sketching-some-ideas",
        defaultMessage: "Sketching ideas"
    },
    mixingTheColors: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.mixing-the-colors",
        defaultMessage: "Mixing colors"
    },
    findingTheRightStyle: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.finding-the-right-style",
        defaultMessage: "Finding the right style"
    },
    bringingItToLife: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.bringing-it-to-life",
        defaultMessage: "Bringing it to life"
    },
    addingTheDetails: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.adding-the-details",
        defaultMessage: "Adding details"
    },
    applyingTheFinalTouches: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.applying-the-final-touches",
        defaultMessage: "Applying final touches"
    },
    almostDone: {
        id: "malleable-ui-components.remix-thinking-bar.rotating.image-almost-done",
        defaultMessage: "Almost done"
    }
});
const $79c6915ee8b28dcd$var$styles = {
    rovoWrapperFixed: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _kqsw1n9t _94n5pxbi _1ltv1b66 _1xi21b66 _1bsb1ns9 _1pbyni7l",
    rovoWrapperAbsolute: "_19pkidpf _2hwx1wug _otyridpf _18u01wug _kqswstnw _94n5pxbi _1ltv1b66 _1xi21b66 _1bsb1ns9 _1pbyni7l",
    rovoWrapperRelative: "_kqswh2mm _ca0qpxbi _n3tdpxbi"
};
function $79c6915ee8b28dcd$export$d6f2d83daf5efc44({ onStop: onStop, optionType: _optionType, isRelative: isRelative = false, showProgressBar: showProgressBar = false, isComplete: isComplete = false, onCompleteAnimationFinished: onCompleteAnimationFinished, contentType: contentType, isRemixEntrance: isRemixEntrance = true }) {
    const positionAbsolute = contentType === 'jira.issue';
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const thinkingTexts = [
        formatMessage($79c6915ee8b28dcd$var$messages.rovoIsThinking),
        formatMessage($79c6915ee8b28dcd$var$messages.analyzingContent),
        formatMessage($79c6915ee8b28dcd$var$messages.puttingPiecesTogether),
        formatMessage($79c6915ee8b28dcd$var$messages.structuringRemix),
        formatMessage($79c6915ee8b28dcd$var$messages.designingRemix),
        formatMessage($79c6915ee8b28dcd$var$messages.addingItAllTogether),
        formatMessage($79c6915ee8b28dcd$var$messages.applyingFinalTouches),
        formatMessage($79c6915ee8b28dcd$var$messages.almostDone)
    ];
    const thinkingTextsNonRemixEntrance = [
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.rovoIsImagining),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.sketchingSomeIdeas),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.mixingTheColors),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.findingTheRightStyle),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.bringingItToLife),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.addingTheDetails),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.applyingTheFinalTouches),
        formatMessage($79c6915ee8b28dcd$var$rotatingMessagesNonRemixEntrance.almostDone)
    ];
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: // eslint-disable-next-line no-nested-ternary
        isRelative ? $79c6915ee8b28dcd$var$styles.rovoWrapperRelative : positionAbsolute ? $79c6915ee8b28dcd$var$styles.rovoWrapperAbsolute : $79c6915ee8b28dcd$var$styles.rovoWrapperFixed,
        style: {
            minWidth: (0, $ixfCV.fg)('platform_maui_jira_ui_fix') ? 'min(400px, 100%)' : '400px'
        },
        testId: "remix-thinking-bar-gradient-border"
    }, /*#__PURE__*/ $cozmU.createElement((0, $3sXr4.RovoThinkingBarWrapper), {
        isThinking: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $kb1I3.RovoThinkingBar), {
        onStop: onStop,
        showProgressBar: showProgressBar,
        isComplete: isComplete,
        onCompleteAnimationFinished: onCompleteAnimationFinished,
        useRotatingTitle: true,
        customRotatingMessages: isRemixEntrance ? thinkingTexts : thinkingTextsNonRemixEntrance
    })));
}
module.exports["RemixThinkingBar"] = $79c6915ee8b28dcd$export$d6f2d83daf5efc44;

});

parcelRegister("3rRes", function(module, exports) {

var $jTt8P = parcelRequire("jTt8P");


var $1qYXT = parcelRequire("1qYXT");

const $b43257b5198523a8$export$cee0b7c2921c06e1 = (nodes)=>{
    if (nodes === null) return null;
    const result = [];
    for (const node of nodes){
        const filtered = (0, $jTt8P.traverse)(node, {
            any: (adfNode)=>{
                if ((0, $1qYXT.isRemixRestrictedNodeType)(adfNode.type)) return false;
            }
        });
        if (filtered !== false) result.push(filtered);
    }
    return result;
};
module.exports["filterRemixFragmentNodes"] = $b43257b5198523a8$export$cee0b7c2921c06e1;

});

parcelRegister("1qYXT", function(module, exports) {
/** Node types we never show Remix for. */ const $f654d7d76017903f$export$7004846771b000c0 = [
    'mediaSingle',
    'mediaGroup',
    'media',
    'image',
    'extension',
    'bodiedExtension',
    'multiBodiedExtension',
    'embedCard',
    'blockCard',
    'inlineCard',
    // Source blocks
    'bodiedSyncBlock',
    // Reference blocks
    'syncBlock',
    'expand',
    'nestedExpand'
];
const $f654d7d76017903f$var$DENY_SET = new Set($f654d7d76017903f$export$7004846771b000c0);
const $f654d7d76017903f$export$bf9aef57175a93a2 = (nodeType)=>$f654d7d76017903f$var$DENY_SET.has(nodeType);
const $f654d7d76017903f$export$a7b703a84f6e523d = (extensionKey, allowList)=>extensionKey !== undefined && allowList.includes(extensionKey);
module.exports["REMIX_DENY_LIST_V1"] = $f654d7d76017903f$export$7004846771b000c0;
module.exports["isRemixRestrictedNodeType"] = $f654d7d76017903f$export$bf9aef57175a93a2;
module.exports["isAllowedMBEExtensionForRemix"] = $f654d7d76017903f$export$a7b703a84f6e523d;

});

parcelRegister("fj6ez", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $3jLHL = parcelRequire("3jLHL");

function $738409fb11353f61$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $738409fb11353f61$var$rendererHighlightStyles = {
    name: "18r8tnl",
    styles: "::highlight(remix-thinking-renderer){background-color:var(--ds-background-accent-purple-subtler, #EED7FC);text-decoration:underline;text-decoration-style:dotted;text-decoration-thickness:var(--ds-space-025, 2px);text-decoration-color:var(--ds-border-accent-purple, #AF59E1);text-decoration-skip-ink:none;}"
};
const $738409fb11353f61$export$533b8d7a5499bf49 = ()=>{
    return /*#__PURE__*/ (0, $3jLHL.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, $3jLHL.jsx)((0, $3jLHL.Global), {
        styles: $738409fb11353f61$var$rendererHighlightStyles
    }));
};
module.exports["RendererRemixHighlightStyles"] = $738409fb11353f61$export$533b8d7a5499bf49;

});

parcelRegister("3jLHL", function(module, exports) {
$parcel$export(module.exports, "jsx", () => $26a826a6de57547f$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("fXXXK")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("fXXXK")).w);

var $fXXXK = parcelRequire("fXXXK");


var $cozmU = parcelRequire("cozmU");


var $lxV8r = parcelRequire("lxV8r");


var $gE1ec = parcelRequire("gE1ec");


var $fp2Bc = parcelRequire("fp2Bc");

parcelRequire("e7SVr");

parcelRequire("eb3ax");

parcelRequire("doWRd");


parcelRequire("aH9xZ");

var $26a826a6de57547f$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $fXXXK.h).call(props, 'css')) return $cozmU.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $fXXXK.E);
    createElementArgArray[1] = (0, $fXXXK.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $cozmU.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($26a826a6de57547f$export$c8a8987d4410bf2d || ($26a826a6de57547f$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $26a826a6de57547f$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $fXXXK.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $fp2Bc.serializeStyles)([
        styles
    ], undefined, $cozmU.useContext((0, $fXXXK.T)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $cozmU.useRef();
    (0, $gE1ec.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $gE1ec.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $lxV8r.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $26a826a6de57547f$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $fp2Bc.serializeStyles)(args);
}
function $26a826a6de57547f$export$d25ddfdf17c3ad3e() {
    var insertable = $26a826a6de57547f$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $26a826a6de57547f$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $26a826a6de57547f$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $lxV8r.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $26a826a6de57547f$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $gE1ec.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $lxV8r.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $26a826a6de57547f$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $fXXXK.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $fXXXK.i)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $fp2Bc.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $lxV8r.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $fXXXK.i)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $26a826a6de57547f$var$merge(cache.registered, css, $26a826a6de57547f$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $cozmU.useContext((0, $fXXXK.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement($26a826a6de57547f$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
module.exports["Global"] = $26a826a6de57547f$export$98f03c5d19621d70;
module.exports["css"] = $26a826a6de57547f$export$dbf350e5966cf602;
module.exports["keyframes"] = $26a826a6de57547f$export$d25ddfdf17c3ad3e;

});

parcelRegister("koSDQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $irnO2 = parcelRequire("irnO2");


var $caVF7 = parcelRequire("caVF7");

const $2e4059893c92a637$export$654bbdda10638776 = ({ entryPoint: entryPoint, experienceTracker: experienceTracker, dynamicUiType: dynamicUiType, selectedSubTypeRef: selectedSubTypeRef, openAIFCStagingModalRef: openAIFCStagingModalRef, isRemixCancelledRef: isRemixCancelledRef, conversationIdRef: conversationIdRef, shouldOpenPreview: shouldOpenPreview, onAfterOpenPreview: onAfterOpenPreview })=>{
    const openPreview = (0, $cozmU.useCallback)(()=>{
        experienceTracker.succeed({
            name: (0, $irnO2.ExperienceName).REMIX_START
        });
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).REMIX_RENDERS_IN_MODAL,
            id: (0, $irnO2.ExperienceName).REMIX_RENDERS_IN_MODAL,
            attributes: {
                product: 'confluence',
                remixType: dynamicUiType,
                remixSubtype: selectedSubTypeRef.current,
                entryPoint: entryPoint,
                conversationChannelId: conversationIdRef?.current
            }
        });
        openAIFCStagingModalRef.current();
        onAfterOpenPreview?.();
    }, [
        entryPoint,
        experienceTracker,
        dynamicUiType,
        selectedSubTypeRef,
        openAIFCStagingModalRef,
        conversationIdRef,
        onAfterOpenPreview
    ]);
    const openPreviewIfAllowed = (0, $cozmU.useCallback)(()=>{
        if (shouldOpenPreview?.() === false) return;
        openPreview();
    }, [
        openPreview,
        shouldOpenPreview
    ]);
    const { showProgressBar: showProgressBar, isComplete: isComplete, onCompleteAnimationFinished: onCompleteAnimationFinished, signalActionReady: signalActionReady, resetCompletion: resetCompletion } = (0, $caVF7.useRemixThinkingBarProgress)({
        onOpenPreview: openPreviewIfAllowed
    });
    const onActionReady = (0, $cozmU.useCallback)(()=>{
        if (!isRemixCancelledRef.current) {
            (0, $irnO2.remixGeneratePreviewExperience).mark((0, $irnO2.REMIX_GENERATE_PREVIEW_MARKS).ACTION_COMPLETE_RECEIVED);
            signalActionReady();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- ref identity is stable; reading .current does not need to be a dep
    }, [
        signalActionReady
    ]);
    return {
        showProgressBar: showProgressBar,
        isComplete: isComplete,
        onCompleteAnimationFinished: onCompleteAnimationFinished,
        onActionReady: onActionReady,
        resetCompletion: resetCompletion
    };
};
module.exports["useRemixPreviewFlow"] = $2e4059893c92a637$export$654bbdda10638776;

});

parcelRegister("caVF7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $1118b6b7a2cd5d89$export$c8a930cce8a67fba = ({ onOpenPreview: onOpenPreview })=>{
    const [isComplete, setIsComplete] = (0, $cozmU.useState)(false);
    const signalActionReady = (0, $cozmU.useCallback)(()=>{
        // Defer opening the preview until the progress bar fills to 100%.
        setIsComplete(true);
    }, []);
    const resetCompletion = (0, $cozmU.useCallback)(()=>{
        setIsComplete(false);
    }, []);
    return (0, $cozmU.useMemo)(()=>({
            showProgressBar: true,
            isComplete: isComplete,
            onCompleteAnimationFinished: onOpenPreview,
            signalActionReady: signalActionReady,
            resetCompletion: resetCompletion
        }), [
        isComplete,
        onOpenPreview,
        signalActionReady,
        resetCompletion
    ]);
};
module.exports["useRemixThinkingBarProgress"] = $1118b6b7a2cd5d89$export$c8a930cce8a67fba;

});

parcelRegister("7eOZ4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kyKWe = parcelRequire("kyKWe");


var $ixfCV = parcelRequire("ixfCV");


var $kNXXO = parcelRequire("kNXXO");


var $c5wKe = parcelRequire("c5wKe");


var $i7OAD = parcelRequire("i7OAD");


var $aYC8J = parcelRequire("aYC8J");


var $igOtY = parcelRequire("igOtY");


var $iW40i = parcelRequire("iW40i");


var $8akfd = parcelRequire("8akfd");


var $lTU4O = parcelRequire("lTU4O");


var $loej8 = parcelRequire("loej8");


var $ew8wg = parcelRequire("ew8wg");


var $6mKj3 = parcelRequire("6mKj3");


var $3jwuS = parcelRequire("3jwuS");


var $ep3mz = parcelRequire("ep3mz");


var $htsj6 = parcelRequire("htsj6");


var $ficwO = parcelRequire("ficwO");


var $jyA9t = parcelRequire("jyA9t");

const $1e31de274ed01603$var$isActionComplete = (chatMessages)=>{
    // Scan backwards to find ACTION_COMPLETE in the latest turn.
    // If we encounter a HUMAN message first, that marks a turn boundary —
    // any ACTION_COMPLETE before it belongs to a previous turn.
    let hasActionCompleteStep = false;
    for(let i = chatMessages.length - 1; i >= 0; i--){
        const message = chatMessages[i];
        if (message.type === 'ACTION_COMPLETE') {
            hasActionCompleteStep = true;
            break;
        }
        if ((0, $igOtY.isStoreHuman)(message)) break;
    }
    const lastPlannedAIFCAction = (0, $kNXXO.findLastAssistantAction)(chatMessages, (action)=>(0, $i7OAD.isAIFCAction)(action) && action.status === 'planned');
    const hasCompletedAction = lastPlannedAIFCAction !== undefined;
    if ((0, $ixfCV.fg)('remix_product_modal_rovo_chat')) return hasActionCompleteStep || hasCompletedAction;
    else return hasActionCompleteStep;
};
/**
 * True when the latest turn contains ACTION_PREPARE but no ACTION_COMPLETE.
 * This happens when AdfEditorMinion early-exits with "no operations returned
 * by LLM" — the stream completes but the action is never sealed.
 */ const $1e31de274ed01603$var$hasActionPrepareWithoutComplete = (chatMessages)=>{
    let hasActionPrepare = false;
    for(let i = chatMessages.length - 1; i >= 0; i--){
        const message = chatMessages[i];
        if (message.type === 'ACTION_COMPLETE') return false;
        if (message.type === 'ACTION_PREPARE') hasActionPrepare = !!message.action && (0, $aYC8J.isRemixGeneratedFlow)(message.action);
        if ((0, $igOtY.isStoreHuman)(message)) break;
    }
    return hasActionPrepare;
};
function $1e31de274ed01603$var$shouldOpenEphemeralPreview(chatMessages) {
    for(let i = chatMessages.length - 1; i >= 0; i--){
        const message = chatMessages[i];
        if (message.type === 'ACTION_PREPARE') {
            if (!message.action) return false;
            if (!(0, $aYC8J.isRemixGeneratedFlow)(message.action)) return false;
            if ($1e31de274ed01603$var$isWhiteboardRemixActionKey(message.action.key) && !(0, $aYC8J.getDynamicUiSubtype)(message.action)) return false;
            return true;
        }
    }
    return false;
}
const $1e31de274ed01603$var$isWhiteboardRemixActionKey = (key)=>key === (0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_CREATE_KEY) || key === (0, $aYC8J.CONFLUENCE_AIFC_WHITEBOARD_UPDATE_KEY);
/**
 * True when the latest matching assistant action is a whiteboard create/update
 * and checks if the action is in the ACTION_PART streaming status.
 * (`MessageAction.status === 'streaming'`).
 */ const $1e31de274ed01603$var$hasWhiteboardRemixActionStreaming = (chatMessages)=>(0, $kNXXO.findLastAssistantAction)(chatMessages, (action)=>$1e31de274ed01603$var$isWhiteboardRemixActionKey(action.key) && action.status?.toLowerCase() === 'streaming') !== undefined;
const $1e31de274ed01603$export$cca9e2432f59b3f8 = ({ onActionReady: onActionReady, stagingAreaTargetMode: stagingAreaTargetMode = 'current-content' } = {})=>{
    const { sendMessage: sendMessage, createConversationOptimistically: createConversationOptimistically, abortRequests: abortRequests, activeConversation: activeConversation, setSelectedConversation: setSelectedConversation } = (0, $c5wKe.useSmartCreationChatStoreApi)();
    const { setPrompt: setPrompt, setDynamicUiContext: setDynamicUiContext, setUserSelectedDynamicUiSubtype: setUserSelectedDynamicUiSubtype, setInteractionSource: setInteractionSource, setForceSkipAutoConversationSelection: setForceSkipAutoConversationSelection } = (0, $8akfd.useStagingAreaActions)();
    const { preferences: preferences } = (0, $lTU4O.useUserPreferences)();
    const { openModal: openModal, closeModal: closeModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { title: contentTitle } = (0, $ew8wg.usePageTitle)({
        contentId: contentId ?? ''
    });
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const isDraftPage = contentStatus === 'draft';
    // Track the conversation ID created by this remix flow. Only when the
    // store's activeConversation matches this ID do we consider it "ours".
    // Stored as state so that setting it triggers a rerender, ensuring
    // derived values (activeRemixConversation, chatMessages, etc.) update
    // immediately rather than waiting for an external rerender.
    const [remixConversationId, setRemixConversationId] = (0, $cozmU.useState)(undefined);
    const resetRemixConversationId = (0, $cozmU.useCallback)(()=>{
        setRemixConversationId(undefined);
    }, []);
    const activeRemixConversation = activeConversation?.id && activeConversation.id === remixConversationId ? activeConversation : null;
    const [chatMessages] = (0, $iW40i.useChatMessages)({
        conversationId: activeRemixConversation?.id ?? ''
    });
    // Extract the first StoreError from chatMessages so callers can surface
    // the specific Rovo error message as an experience attribute.
    const remixStoreError = chatMessages.find((message)=>(0, $igOtY.isStoreError)(message)) ?? null;
    // Detect whether Rovo encountered an error while processing a remix request.
    // This covers ACTION_ERROR at any stage — both before the ephemeral preview
    // opens (during awaitingResponse) and while it is loading (during typingResponse).
    // Uses the same isStoreError check as the smart-creation staging area.
    const isRemixError = activeRemixConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).deactivatedAgentError || remixStoreError !== null;
    const isRemixAborted = !isRemixError && activeRemixConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).idle && !$1e31de274ed01603$var$isActionComplete(chatMessages) && !$1e31de274ed01603$var$hasActionPrepareWithoutComplete(chatMessages) && chatMessages.some((0, $igOtY.isStoreAssistant));
    // Track whether the onActionReady callback has already been fired for the
    // current conversation to avoid duplicate invocations.
    const actionReadyFired = (0, $cozmU.useRef)(false);
    // Reset the fired flag when the active remix conversation changes (new remix flow).
    const prevConversationId = (0, $cozmU.useRef)(activeRemixConversation?.id);
    (0, $cozmU.useEffect)(()=>{
        if (prevConversationId.current !== activeRemixConversation?.id) {
            actionReadyFired.current = false;
            prevConversationId.current = activeRemixConversation?.id;
        }
    }, [
        activeRemixConversation?.id
    ]);
    // Fire onActionReady when the appropriate message arrives:
    // - For whiteboard create/update: when the action is `streaming` (early trigger so
    //   the whiteboard preview can start rendering while data is still arriving).
    // - For all other actions: when FINAL_RESPONSE is received from the stream,
    //   indicated by the conversation status transitioning to `idle`.
    // - Fallback: when the stream completed (idle) with ACTION_PREPARE but no
    //   ACTION_COMPLETE (AdfEditorMinion early-exit).
    (0, $cozmU.useEffect)(()=>{
        if (actionReadyFired.current || !onActionReady) return;
        const whiteboardStreamingDetected = $1e31de274ed01603$var$hasWhiteboardRemixActionStreaming(chatMessages);
        const finalResponseReceived = activeRemixConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).idle && $1e31de274ed01603$var$isActionComplete(chatMessages);
        const actionPreparedButNotCompleted = activeRemixConversation?.status === (0, $igOtY.CHAT_STORE_STATUS).idle && $1e31de274ed01603$var$hasActionPrepareWithoutComplete(chatMessages);
        if (whiteboardStreamingDetected || finalResponseReceived || actionPreparedButNotCompleted) {
            actionReadyFired.current = true;
            onActionReady();
        }
    }, [
        chatMessages,
        onActionReady,
        activeRemixConversation?.status
    ]);
    const stopRemixing = (0, $cozmU.useCallback)(()=>{
        abortRequests?.({
            conversationId: activeRemixConversation?.id
        });
    }, [
        abortRequests,
        activeRemixConversation?.id
    ]);
    const openAIFCStagingModal = (0, $cozmU.useCallback)((options)=>{
        setForceSkipAutoConversationSelection(true);
        // Open the Confluence Smart Creation Modal with stagingAreaActive=true
        // to skip the prompt screen and go straight to the staging area preview.
        //
        // Only keep the ephemeral preview for remix-generated preview content.
        // The shared helper currently treats dynamic UI, image-based remix flows,
        // and remix-generated whiteboards/diagrams as ephemeral-preview candidates.
        // All other ACTION_PREPARE results should open the full AIFC modal.
        //
        // Pass forceFullModal: true to bypass this check
        const shouldUseEphemeralPreview = options?.forceFullModal ? false : $1e31de274ed01603$var$shouldOpenEphemeralPreview(chatMessages);
        openModal({
            entryPoint: 'dynamicUi',
            spaceKey: spaceKey ?? undefined,
            parentContent: contentId && !isDraftPage ? {
                id: contentId,
                title: contentTitle ?? '',
                contentType: contentType ?? 'page'
            } : undefined,
            stagingAreaActive: true,
            isFloating: shouldUseEphemeralPreview,
            shouldShowBackButton: false,
            ...activeRemixConversation?.id && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) ? {
                remixConversationId: activeRemixConversation.id
            } : {},
            // `stagingAreaTargetMode` decides whether the current content is also
            // registered as staging-area content, or preserved only as parent/source
            // context for generated-content flows.
            ...stagingAreaTargetMode === 'current-content' && contentId ? {
                content: {
                    id: contentId,
                    type: contentType ?? 'page',
                    subType: isLivePage ? 'live' : null
                }
            } : {},
            // Pass a submitCallback only for ephemeral (floating) previews to
            // prevent navigating away from the current page. For the full modal flow
            // (e.g. "Add to Confluence"), omit the callback so the default
            // handleSubmitSmartCreate handler runs and redirects to the newly created content.
            ...shouldUseEphemeralPreview ? {
                submitCallback: async ()=>{
                    // Refresh the page tree for ephemeral previews only when the experiment is enabled.
                    if (!(0, $6mKj3.expVal)('cc-maui-refresh-page-tree-with-diagram', 'isEnabled', false)) return;
                    if (contentId) (0, $ficwO.publishMessage)((0, $ficwO.Message).PageTreeRefreshRequested, {
                        parentId: contentId
                    });
                }
            } : {}
        });
    }, [
        openModal,
        spaceKey,
        contentId,
        contentType,
        contentTitle,
        isLivePage,
        isDraftPage,
        activeRemixConversation?.id,
        setForceSkipAutoConversationSelection,
        chatMessages,
        stagingAreaTargetMode
    ]);
    const sendAIFCPrompt = (0, $cozmU.useCallback)(async ({ userPrompt: userPrompt, promptText: promptTextOverride, dynamicUiSubtype: dynamicUiSubtype, dynamicUiType: dynamicUiType, dynamicUiSource: dynamicUiSource, interactionSource: interactionSource, forcedContentType: forcedContentType, additionalCreationContextParams: additionalCreationContextParams })=>{
        const defaultPromptText = 'Remix the selected content';
        const selectedDisplayName = dynamicUiSubtype ? (0, $loej8.getSubTypeDisplayName)(dynamicUiSubtype) : (0, $loej8.getTypeDisplayName)(dynamicUiType);
        const autoText = promptTextOverride ?? `Remix the selected content as a ${selectedDisplayName}`;
        let promptText;
        if (dynamicUiType === 'custom') promptText = userPrompt ?? defaultPromptText;
        else promptText = userPrompt ? `${autoText}. ${userPrompt}` : autoText;
        // Build the ADF DocNode prompt.
        const prompt = {
            type: 'doc',
            version: 1,
            content: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: promptText
                        }
                    ]
                }
            ]
        };
        const newConversationId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        // Store the ID so we can identify this conversation as the active remix.
        setRemixConversationId(newConversationId);
        actionReadyFired.current = false;
        await createConversationOptimistically({
            id: newConversationId
        });
        let creationContextExperienceParams = {};
        if (!additionalCreationContextParams) {
            if (dynamicUiType === 'custom') creationContextExperienceParams = {
                experience: 'remix_custom'
            };
            else creationContextExperienceParams = {
                experience: 'remix',
                blocks: [
                    dynamicUiType
                ]
            };
        }
        // Send the message to Rovo
        sendMessage({
            prompt: prompt,
            storeUserMessages: preferences.storeUserMessages,
            conversationId: newConversationId,
            messageSources: {
                interactionSource: interactionSource,
                // Use the same source for follow-ups: Remix doesn't have a separate follow-up entry point, but the "viewed" AIMAU analytics event uses `followUpSource`.
                followUpSource: interactionSource
            },
            productKey: 'confluence',
            contentContext: 'staging-area',
            creationContextParams: {
                dynamicUiType: dynamicUiType,
                dynamicUiSubtype: dynamicUiSubtype,
                dynamicUiSource: dynamicUiSource,
                source: 'remix',
                ...creationContextExperienceParams,
                ...forcedContentType ? {
                    forcedContentType: forcedContentType
                } : {},
                ...additionalCreationContextParams
            }
        });
        // Store the prompt text for display in the staging area header.
        // Always show "Remix" regardless of the user's custom prompt.
        setPrompt('Remix');
        // Persist the dynamic UI context so the update flow can use
        // the original type/source when sending remix adjustment messages
        setDynamicUiContext(dynamicUiType, dynamicUiSubtype, dynamicUiSource);
        // Keep the user's pick; setDynamicUiContext above gets overwritten with the
        // backend subtype on response, and EditWithRovoBar needs both to flag a mismatch.
        setUserSelectedDynamicUiSubtype(dynamicUiSubtype);
        setInteractionSource(interactionSource);
        return newConversationId;
    }, [
        createConversationOptimistically,
        sendMessage,
        setPrompt,
        setDynamicUiContext,
        setUserSelectedDynamicUiSubtype,
        setInteractionSource,
        preferences.storeUserMessages
    ]);
    return {
        sendAIFCPrompt: sendAIFCPrompt,
        stopRemixing: stopRemixing,
        isRemixError: isRemixError,
        isRemixAborted: isRemixAborted,
        remixStoreError: remixStoreError,
        openAIFCStagingModal: openAIFCStagingModal,
        closeAIFCStagingModal: closeModal,
        remixConversationId: remixConversationId,
        resetRemixConversationId: resetRemixConversationId,
        setSelectedConversation: setSelectedConversation
    };
};
module.exports["useRemixToAIFC"] = $1e31de274ed01603$export$cca9e2432f59b3f8;

});

parcelRegister("c5wKe", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $gjWe2 = parcelRequire("gjWe2");


var $n71o5 = parcelRequire("n71o5");


var $3TxKn = parcelRequire("3TxKn");

const $3f23c49d3b1dd7cc$export$5650c329b9f287fb = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useSmartCreationChatStoreApi() {
    const $ = (0, $bDgLe.c)(8);
    const [t0] = (0, $n71o5.useChatStore)();
    const { currentConversationId: currentConversationId, conversations: conversations } = t0;
    const { createConversationOptimistically: createConversationOptimistically, setSelectedConversation: setSelectedConversation, sendMessage: sendMessage, abortRequests: abortRequests, seedConversation: seedConversation } = (0, $3TxKn.useChatStoreActions)();
    const activeConversation = conversations[currentConversationId];
    let t1;
    if ($[0] !== abortRequests || $[1] !== activeConversation || $[2] !== createConversationOptimistically || $[3] !== currentConversationId || $[4] !== seedConversation || $[5] !== sendMessage || $[6] !== setSelectedConversation) {
        t1 = {
            createConversationOptimistically: createConversationOptimistically,
            setSelectedConversation: setSelectedConversation,
            abortRequests: abortRequests,
            activeConversationId: currentConversationId,
            activeConversation: activeConversation,
            sendMessage: sendMessage,
            seedConversation: seedConversation,
            processConversationMessages: $gjWe2.processConversationMessages
        };
        $[0] = abortRequests;
        $[1] = activeConversation;
        $[2] = createConversationOptimistically;
        $[3] = currentConversationId;
        $[4] = seedConversation;
        $[5] = sendMessage;
        $[6] = setSelectedConversation;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
} : function useSmartCreationChatStoreApi() {
    const [{ currentConversationId: currentConversationId, conversations: conversations }] = (0, $n71o5.useChatStore)();
    const { createConversationOptimistically: createConversationOptimistically, setSelectedConversation: setSelectedConversation, sendMessage: sendMessage, abortRequests: abortRequests, seedConversation: seedConversation } = (0, $3TxKn.useChatStoreActions)();
    const activeConversation = conversations[currentConversationId];
    return {
        createConversationOptimistically: createConversationOptimistically,
        setSelectedConversation: setSelectedConversation,
        abortRequests: abortRequests,
        activeConversationId: currentConversationId,
        activeConversation: activeConversation,
        sendMessage: sendMessage,
        seedConversation: seedConversation,
        processConversationMessages: $gjWe2.processConversationMessages
    };
};
module.exports["useSmartCreationChatStoreApi"] = $3f23c49d3b1dd7cc$export$5650c329b9f287fb;

});

parcelRegister("igOtY", function(module, exports) {
var $318bcc25577ef9d7$export$69799355b7de2229 = /*#__PURE__*/ function(StoreActionLoggableName) {
    StoreActionLoggableName["addStoreChatItem"] = "addStoreChatItem";
    StoreActionLoggableName["addHumanMessage"] = "addHumanMessage";
    StoreActionLoggableName["addAssistantMessage"] = "addAssistantMessage";
    StoreActionLoggableName["clearFollowUpMessages"] = "clearFollowUpMessages";
    StoreActionLoggableName["sendMessage"] = "sendMessage";
    StoreActionLoggableName["sendMessageConfirmedTools"] = "sendMessageConfirmedTools";
    StoreActionLoggableName["removeMessage"] = "removeMessage";
    StoreActionLoggableName["truncateFromLastHumanMessage"] = "truncateFromLastHumanMessage";
    StoreActionLoggableName["fetchConversation"] = "fetchConversation";
    StoreActionLoggableName["prefetchConversationMessages"] = "prefetchConversationMessages";
    StoreActionLoggableName["reconnectToInProgressStream"] = "reconnectToInProgressStream";
    StoreActionLoggableName["abortRequests"] = "abortRequests";
    StoreActionLoggableName["answerNow"] = "answerNow";
    StoreActionLoggableName["addErrorMessage"] = "addErrorMessage";
    StoreActionLoggableName["fetchConversationChannelsData"] = "fetchConversationChannelsData";
    StoreActionLoggableName["loadMoreConversationChannelsData"] = "loadMoreConversationChannelsData";
    StoreActionLoggableName["hydrateConversation"] = "hydrateConversation";
    StoreActionLoggableName["addAgentMessage"] = "addAgentMessage";
    StoreActionLoggableName["handleChatOpenPubsubAction"] = "handleChatOpenPubsubAction";
    StoreActionLoggableName["createConversationOptimistically"] = "createConversationOptimistically";
    StoreActionLoggableName["createSeededConversation"] = "createSeededConversation";
    StoreActionLoggableName["updateActionInvocationStatus"] = "updateActionInvocationStatus";
    StoreActionLoggableName["updateActionData"] = "updateActionData";
    StoreActionLoggableName["resolveConversationAction"] = "resolveConversationAction";
    StoreActionLoggableName["bulkResolveConversationActions"] = "bulkResolveConversationActions";
    StoreActionLoggableName["bulkResolveConversationUIActions"] = "bulkResolveConversationUIActions";
    StoreActionLoggableName["setSelectedConversation"] = "setSelectedConversation";
    StoreActionLoggableName["warmConversationCache"] = "warmConversationCache";
    StoreActionLoggableName["hasConversationMessages"] = "hasConversationMessages";
    StoreActionLoggableName["stopTask"] = "stopTask";
    return StoreActionLoggableName;
}({});
const $318bcc25577ef9d7$export$61e8a5ac076d12b3 = {
    nextCursor: null,
    hasMore: false,
    isLoadingMore: false,
    loadMoreError: null,
    isConversationListMounted: false
};
const $318bcc25577ef9d7$export$8ec4190061b584d5 = (status)=>status?.type === 'AVAILABLE';
const $318bcc25577ef9d7$export$fe950e85847f6d5d = {
    AVAILABLE: 'AVAILABLE',
    SWITCHING: 'SWITCHING',
    SWITCHING_REQUESTED: 'SWITCHING_REQUESTED',
    SWITCHED: 'SWITCHED',
    ERRORED: 'ERRORED'
};
var $318bcc25577ef9d7$export$817d6b1b984afeb7 = /*#__PURE__*/ function(CHAT_STORE_STATUS) {
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["idle"] = 0] = "idle";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["loadingChat"] = 1] = "loadingChat";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["awaitingResponse"] = 2] = "awaitingResponse";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["typingResponse"] = 3] = "typingResponse";
    CHAT_STORE_STATUS[CHAT_STORE_STATUS["deactivatedAgentError"] = 4] = "deactivatedAgentError";
    return CHAT_STORE_STATUS;
}({});
const $318bcc25577ef9d7$var$TERMINAL_TASK_STATES = [
    'Completed',
    'Failed',
    'Cancelled'
];
const $318bcc25577ef9d7$export$e87901ebf76c08a1 = (state)=>$318bcc25577ef9d7$var$TERMINAL_TASK_STATES.includes(state);
const $318bcc25577ef9d7$export$75e97486ff2b4c62 = (message)=>'type' in message && message.type === 'HUMAN';
const $318bcc25577ef9d7$export$d99f52ae2a325014 = (message)=>'type' in message && message.type === 'ASSISTANT';
const $318bcc25577ef9d7$export$9e2d714e96946d26 = (message)=>'type' in message && message.type === 'ERROR';
const $318bcc25577ef9d7$export$f2b8d80523e7041 = (message)=>$318bcc25577ef9d7$export$75e97486ff2b4c62(message) || $318bcc25577ef9d7$export$d99f52ae2a325014(message);
const $318bcc25577ef9d7$export$61c7dbb423a56ae7 = (message)=>'type' in message && message.type === 'MEMORY_UPDATE';
const $318bcc25577ef9d7$export$7c65a4fb7b6131a1 = (message)=>'type' in message && message.type === 'FOLLOW_UP';
const $318bcc25577ef9d7$export$2e85f4812cb59241 = (message)=>'type' in message && message.type === 'LIVE_CHAT';
const $318bcc25577ef9d7$export$20f0f8aded5b11e5 = (message)=>'type' in message && message.type === 'TWILIO_LIVE_CHAT_AGENT';
const $318bcc25577ef9d7$export$908578fde1b22b55 = (message)=>$318bcc25577ef9d7$export$75e97486ff2b4c62(message) && message.source === 'TWILIO_LIVE_CHAT';
const $318bcc25577ef9d7$export$3db8a80b25c44828 = (message)=>$318bcc25577ef9d7$export$20f0f8aded5b11e5(message) || $318bcc25577ef9d7$export$908578fde1b22b55(message);
const $318bcc25577ef9d7$export$d15e7fe0f58ee5d0 = (message)=>message.type === 'ACTION_PREPARE';
const $318bcc25577ef9d7$export$533a80cec0f4f28f = (message)=>message.type === 'GUARD_BLOCK';
const $318bcc25577ef9d7$export$155f16100a67670d = (message)=>'type' in message && message.type === 'USAGE_HINT';
const $318bcc25577ef9d7$export$3070678f252266e3 = (invocationId, invokedActions)=>invokedActions && invokedActions[invocationId] || 'idle';
module.exports["StoreActionLoggableName"] = $318bcc25577ef9d7$export$69799355b7de2229;
module.exports["DEFAULT_CONVERSATION_PAGINATION"] = $318bcc25577ef9d7$export$61e8a5ac076d12b3;
module.exports["isAnswerNowAvailable"] = $318bcc25577ef9d7$export$8ec4190061b584d5;
module.exports["AnswerNowStatusType"] = $318bcc25577ef9d7$export$fe950e85847f6d5d;
module.exports["CHAT_STORE_STATUS"] = $318bcc25577ef9d7$export$817d6b1b984afeb7;
module.exports["isTerminalTaskState"] = $318bcc25577ef9d7$export$e87901ebf76c08a1;
module.exports["isStoreHuman"] = $318bcc25577ef9d7$export$75e97486ff2b4c62;
module.exports["isStoreAssistant"] = $318bcc25577ef9d7$export$d99f52ae2a325014;
module.exports["isStoreError"] = $318bcc25577ef9d7$export$9e2d714e96946d26;
module.exports["isStoreMessage"] = $318bcc25577ef9d7$export$f2b8d80523e7041;
module.exports["isStoreFollowUp"] = $318bcc25577ef9d7$export$7c65a4fb7b6131a1;
module.exports["isStoreGuardBlock"] = $318bcc25577ef9d7$export$533a80cec0f4f28f;
module.exports["isStoreUsageHint"] = $318bcc25577ef9d7$export$155f16100a67670d;
module.exports["getActionInvocationStatus"] = $318bcc25577ef9d7$export$3070678f252266e3;

});

parcelRegister("lTU4O", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $cXtTj = parcelRequire("cXtTj");


var $2TZSo = parcelRequire("2TZSo");


var $isp1U = parcelRequire("isp1U");

const $1dccc6823e49008a$export$205c270e325a7524 = (aaid)=>{
    const preferences = JSON.parse(// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    localStorage.getItem((0, $2TZSo.LS_USER_PREFERENCES_KEY)) || '{}');
    return preferences[aaid];
};
const $1dccc6823e49008a$var$store = (0, $8s9DV.createStore)({
    initialState: {
        preferences: {
            // ideally we want to set the preference in the react component because
            // FF evaluated in module level may not resolve to correct value during SSR
            // however because there is localStorage setting and `firstLoad`, it requires a bit of refactoring to do it
            // this feature is only needed for dogfooding, so may not worth the refactor
            storeUserMessages: // eslint-disable-next-line @atlaskit/platform/no-module-level-eval
            (0, $cXtTj.default).initializeCalled() && (0, $cXtTj.default).checkGate('ai_mate_show_store_messages'),
            // default is undefined because we do not want migration to be started until we read from local storage value
            storeUserMessageMigratedToBE: undefined,
            useEditorContext: true
        },
        firstLoad: true
    },
    actions: {
        updatePreferences: (data)=>({ setState: setState, getState: getState })=>{
                setState({
                    preferences: {
                        ...getState().preferences,
                        ...data
                    },
                    firstLoad: false
                });
            }
    }
});
const $1dccc6823e49008a$var$useStore = (0, $kBr4q.createHook)($1dccc6823e49008a$var$store);
const $1dccc6823e49008a$export$b6472e0d8983f5f5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(27);
    const { aaid: aaid } = (0, $isp1U.useProfileController)();
    const [t0, t1] = $1dccc6823e49008a$var$useStore();
    const { preferences: preferences, firstLoad: firstLoad } = t0;
    const { updatePreferences: storeUpdatePreferences } = t1;
    let t2;
    if ($[0] !== aaid || $[1] !== preferences || $[2] !== storeUpdatePreferences) {
        t2 = (data)=>{
            if (!aaid) return;
            storeUpdatePreferences(data);
            localStorage.setItem((0, $2TZSo.LS_USER_PREFERENCES_KEY), JSON.stringify({
                [aaid]: {
                    ...preferences,
                    ...data
                }
            }));
        };
        $[0] = aaid;
        $[1] = preferences;
        $[2] = storeUpdatePreferences;
        $[3] = t2;
    } else t2 = $[3];
    const updatePreferences = t2;
    let t3;
    if ($[4] !== updatePreferences) {
        t3 = (storeUserMessages)=>{
            updatePreferences({
                storeUserMessages: storeUserMessages
            });
        };
        $[4] = updatePreferences;
        $[5] = t3;
    } else t3 = $[5];
    const setStoreUserMessages = t3;
    let t4;
    if ($[6] !== updatePreferences) {
        t4 = (useEditorContext)=>{
            updatePreferences({
                useEditorContext: useEditorContext
            });
        };
        $[6] = updatePreferences;
        $[7] = t4;
    } else t4 = $[7];
    const setUseEditorContext = t4;
    let t5;
    if ($[8] !== aaid || $[9] !== updatePreferences) {
        t5 = ()=>{
            if (!aaid) return;
            updatePreferences({
                storeUserMessageMigratedToBE: true
            });
        };
        $[8] = aaid;
        $[9] = updatePreferences;
        $[10] = t5;
    } else t5 = $[10];
    const markStoreUserMessageMigratedToBE = t5;
    let t6;
    if ($[11] !== updatePreferences) {
        t6 = (hasSeenFeedbackOptInPrompt)=>{
            updatePreferences({
                hasSeenFeedbackOptInPrompt: hasSeenFeedbackOptInPrompt
            });
        };
        $[11] = updatePreferences;
        $[12] = t6;
    } else t6 = $[12];
    const setHasSeenFeedbackOptInPrompt = t6;
    let t7;
    let t8;
    if ($[13] !== aaid || $[14] !== firstLoad || $[15] !== updatePreferences) {
        t7 = ()=>{
            if (aaid && firstLoad) {
                const preferences_0 = $1dccc6823e49008a$export$205c270e325a7524(aaid);
                if (preferences_0) updatePreferences({
                    ...preferences_0,
                    ...preferences_0.storeUserMessageMigratedToBE ? {} : {
                        storeUserMessageMigratedToBE: false
                    }
                });
            }
        };
        t8 = [
            aaid,
            firstLoad,
            updatePreferences
        ];
        $[13] = aaid;
        $[14] = firstLoad;
        $[15] = updatePreferences;
        $[16] = t7;
        $[17] = t8;
    } else {
        t7 = $[16];
        t8 = $[17];
    }
    (0, $cozmU.useEffect)(t7, t8);
    const t9 = aaid ? preferences.storeUserMessageMigratedToBE : undefined;
    let t10;
    if ($[18] !== preferences || $[19] !== t9) {
        t10 = {
            ...preferences,
            storeUserMessageMigratedToBE: t9
        };
        $[18] = preferences;
        $[19] = t9;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== markStoreUserMessageMigratedToBE || $[22] !== setHasSeenFeedbackOptInPrompt || $[23] !== setStoreUserMessages || $[24] !== setUseEditorContext || $[25] !== t10) {
        t11 = {
            preferences: t10,
            setStoreUserMessages: setStoreUserMessages,
            setUseEditorContext: setUseEditorContext,
            setHasSeenFeedbackOptInPrompt: setHasSeenFeedbackOptInPrompt,
            markStoreUserMessageMigratedToBE: markStoreUserMessageMigratedToBE
        };
        $[21] = markStoreUserMessageMigratedToBE;
        $[22] = setHasSeenFeedbackOptInPrompt;
        $[23] = setStoreUserMessages;
        $[24] = setUseEditorContext;
        $[25] = t10;
        $[26] = t11;
    } else t11 = $[26];
    return t11;
} : ()=>{
    const { aaid: aaid } = (0, $isp1U.useProfileController)();
    const [{ preferences: preferences, firstLoad: firstLoad }, { updatePreferences: storeUpdatePreferences }] = $1dccc6823e49008a$var$useStore();
    const updatePreferences = (0, $cozmU.useCallback)((data)=>{
        if (!aaid) return;
        storeUpdatePreferences(data);
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage.setItem((0, $2TZSo.LS_USER_PREFERENCES_KEY), JSON.stringify({
            [aaid]: {
                ...preferences,
                ...data
            }
        }));
    }, [
        aaid,
        preferences,
        storeUpdatePreferences
    ]);
    const setStoreUserMessages = (0, $cozmU.useCallback)((storeUserMessages)=>{
        updatePreferences({
            storeUserMessages: storeUserMessages
        });
    }, [
        updatePreferences
    ]);
    const setUseEditorContext = (0, $cozmU.useCallback)((useEditorContext)=>{
        updatePreferences({
            useEditorContext: useEditorContext
        });
    }, [
        updatePreferences
    ]);
    const markStoreUserMessageMigratedToBE = (0, $cozmU.useCallback)(()=>{
        if (!aaid) return;
        updatePreferences({
            storeUserMessageMigratedToBE: true
        });
    }, [
        updatePreferences,
        aaid
    ]);
    const setHasSeenFeedbackOptInPrompt = (0, $cozmU.useCallback)((hasSeenFeedbackOptInPrompt)=>{
        updatePreferences({
            hasSeenFeedbackOptInPrompt: hasSeenFeedbackOptInPrompt
        });
    }, [
        updatePreferences
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (aaid && firstLoad) {
            const preferences_0 = $1dccc6823e49008a$export$205c270e325a7524(aaid);
            if (preferences_0) updatePreferences({
                ...preferences_0,
                ...preferences_0.storeUserMessageMigratedToBE ? {} : {
                    storeUserMessageMigratedToBE: false
                }
            });
        }
    }, [
        aaid,
        firstLoad,
        updatePreferences
    ]);
    return {
        preferences: {
            ...preferences,
            storeUserMessageMigratedToBE: aaid ? preferences.storeUserMessageMigratedToBE : undefined
        },
        setStoreUserMessages: setStoreUserMessages,
        setUseEditorContext: setUseEditorContext,
        setHasSeenFeedbackOptInPrompt: setHasSeenFeedbackOptInPrompt,
        markStoreUserMessageMigratedToBE: markStoreUserMessageMigratedToBE
    };
};
module.exports["useUserPreferences"] = $1dccc6823e49008a$export$b6472e0d8983f5f5;

});

parcelRegister("2TZSo", function(module, exports) {
const $9ca4df0845d80c9e$export$97d0beb2ccc70a4d = 'aiMateUserPreferences';
module.exports["LS_USER_PREFERENCES_KEY"] = $9ca4df0845d80c9e$export$97d0beb2ccc70a4d;

});

parcelRegister("isp1U", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dOBRD = parcelRequire("dOBRD");


var $2A9fJ = parcelRequire("2A9fJ");

const $2def26aed08f588d$var$fetchProfileData = (0, $dOBRD.default)(async ()=>{
    const data = await (0, $2A9fJ.me)();
    return {
        aaid: data.account_id,
        name: data.name || '',
        displayName: data.nickname,
        avatarUrl: data.picture,
        email: data.email,
        organization: data.extended_profile?.organization
    };
});
const $2def26aed08f588d$export$3c814b55c7cbb1fb = (0, $cozmU.createContext)(null);
const $2def26aed08f588d$var$emptyProfileData = {
    name: '',
    displayName: '',
    avatarUrl: ''
};
const $2def26aed08f588d$export$68afc71177137005 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (preFetchedProfileData)=>{
    const $ = (0, $bDgLe.c)(4);
    const [profileData, setProfileData] = (0, $cozmU.useState)($2def26aed08f588d$var$emptyProfileData);
    const profileContextData = (0, $cozmU.useContext)($2def26aed08f588d$export$3c814b55c7cbb1fb);
    let t0;
    let t1;
    if ($[0] !== preFetchedProfileData || $[1] !== profileContextData) {
        t0 = ()=>{
            if (preFetchedProfileData) setProfileData(preFetchedProfileData);
            else if (profileContextData) setProfileData(profileContextData);
            else $2def26aed08f588d$var$fetchProfileData().then((data)=>setProfileData(data)).catch(()=>setProfileData($2def26aed08f588d$var$emptyProfileData));
        };
        t1 = [
            setProfileData,
            profileContextData,
            preFetchedProfileData
        ];
        $[0] = preFetchedProfileData;
        $[1] = profileContextData;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return profileData;
} : (preFetchedProfileData)=>{
    const [profileData, setProfileData] = (0, $cozmU.useState)($2def26aed08f588d$var$emptyProfileData);
    const profileContextData = (0, $cozmU.useContext)($2def26aed08f588d$export$3c814b55c7cbb1fb);
    (0, $cozmU.useEffect)(()=>{
        if (preFetchedProfileData) setProfileData(preFetchedProfileData);
        else if (profileContextData) setProfileData(profileContextData);
        else $2def26aed08f588d$var$fetchProfileData().then((data)=>setProfileData(data)).catch(()=>setProfileData($2def26aed08f588d$var$emptyProfileData));
    }, [
        setProfileData,
        profileContextData,
        preFetchedProfileData
    ]);
    return profileData;
};
module.exports["useProfileController"] = $2def26aed08f588d$export$68afc71177137005;

});

parcelRegister("2A9fJ", function(module, exports) {

var $jTKfH = parcelRequire("jTKfH");

const $baf5ee02956fd5a8$export$3e32638432616b6 = async ()=>{
    const response = await (0, $jTKfH.performHttpFetch)({
        path: '/gateway/api/me',
        options: {
            method: 'GET'
        }
    });
    return response;
};
module.exports["me"] = $baf5ee02956fd5a8$export$3e32638432616b6;

});

parcelRegister("ew8wg", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $duklN = parcelRequire("duklN");


var $cozmU = parcelRequire("cozmU");


var $1uFM6 = parcelRequire("1uFM6");


var $95rLf = parcelRequire("95rLf");


var $7Sm4c = parcelRequire("7Sm4c");


var $jMyy4 = parcelRequire("jMyy4");

const $df587a746afa9e84$export$4882d379d640c470 = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { contentId: contentId } = t0;
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            variables: {
                contentId: contentId
            }
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $duklN.default), {
        ...t1,
        __callerPackage__: "content-title"
    });
    let t2;
    let t3;
    if ($[2] !== error) {
        t2 = ()=>{
            if (error && ((0, $1uFM6.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error))) (0, $7Sm4c.markErrorAsHandled)(error);
        };
        t3 = [
            error
        ];
        $[2] = error;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $cozmU.useEffect)(t2, t3);
    const t4 = data?.singleContent?.title;
    let t5;
    if ($[5] !== error || $[6] !== t4) {
        t5 = {
            title: t4,
            error: error
        };
        $[5] = error;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
};
module.exports["usePageTitle"] = $df587a746afa9e84$export$4882d379d640c470;

});

parcelRegister("duklN", function(module, exports) {
/**
 * @generated SignedSource<<cc7770e3fb2fd979845343325dfb00a2>>
 * @relayHash 512d3c288e476ca23b45061d9102b2d6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2afb2ac9c484784fd55eb2fcafbcb54d438eef15f40b0e4c160a6b625de2a3b
const $78d6c4b2c14ab559$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePageTitlePageTitleQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePageTitlePageTitleQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "512d3c288e476ca23b45061d9102b2d6",
            "id": "e2afb2ac9c484784fd55eb2fcafbcb54d438eef15f40b0e4c160a6b625de2a3b",
            "metadata": {},
            "name": "usePageTitlePageTitleQuery",
            "operationKind": "query",
            "text": "query usePageTitlePageTitleQuery($contentId:ID!){singleContent(id:$contentId){id,title}}"
        }
    };
}();
$78d6c4b2c14ab559$var$node.hash = "49163e20c25d3da0c01ad2e924f87c37";
var $78d6c4b2c14ab559$export$2e2bcd8739ae039 = $78d6c4b2c14ab559$var$node;
module.exports["default"] = $78d6c4b2c14ab559$export$2e2bcd8739ae039;

});

parcelRegister("ficwO", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

var $6c05dda517103510$export$f69c19e57285b83a = /*#__PURE__*/ function(Message) {
    Message[Message["ContentCreated"] = 0] = "ContentCreated";
    Message[Message["ContentUnarchived"] = 1] = "ContentUnarchived";
    Message[Message["SmartFolderSyncStateChanged"] = 2] = "SmartFolderSyncStateChanged";
    Message[Message["PageTreeRefreshRequested"] = 3] = "PageTreeRefreshRequested";
    return Message;
}({});
class $6c05dda517103510$var$MessageBus {
    publish(type, data) {
        if (!this.subscribers[type]) return;
        this.subscribers[type].forEach((subscriber)=>subscriber(data));
    }
    subscribe(type, callback) {
        if (!this.subscribers[type]) this.subscribers[type] = [];
        this.subscribers[type].push(callback);
    }
    unsubscribe(type, callback) {
        this.subscribers[type] = this.subscribers[type].filter((subscriber)=>subscriber !== callback);
    }
    constructor(){
        this.subscribers = {};
    }
}
const $6c05dda517103510$var$messageBus = new $6c05dda517103510$var$MessageBus();
const $6c05dda517103510$export$c4ca85b4851515e2 = (type)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== type) {
        t0 = (data)=>{
            $6c05dda517103510$var$messageBus.publish(type, data);
        };
        $[0] = type;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $6c05dda517103510$export$5ecf0545a6d326d0 = (type, data)=>{
    $6c05dda517103510$var$messageBus.publish(type, data);
};
const $6c05dda517103510$export$99473f2ba2f9f18 = (type, callback)=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    let t1;
    if ($[0] !== callback || $[1] !== type) {
        t0 = ()=>{
            $6c05dda517103510$var$messageBus.subscribe(type, callback);
            return ()=>{
                $6c05dda517103510$var$messageBus.unsubscribe(type, callback);
            };
        };
        t1 = [
            callback,
            type
        ];
        $[0] = callback;
        $[1] = type;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
};
module.exports["Message"] = $6c05dda517103510$export$f69c19e57285b83a;
module.exports["useMessagePublisher"] = $6c05dda517103510$export$c4ca85b4851515e2;
module.exports["publishMessage"] = $6c05dda517103510$export$5ecf0545a6d326d0;
module.exports["useMessageSubscriber"] = $6c05dda517103510$export$99473f2ba2f9f18;

});

parcelRegister("jNS1v", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $5ae98e04c533e5e9$var$HIGHLIGHT_NAME = 'remix-thinking-renderer';
const $5ae98e04c533e5e9$export$443e8aeb4c392a84 = ()=>{
    const savedRangeRef = (0, $cozmU.useRef)(null);
    const [isHighlighting, setIsHighlighting] = (0, $cozmU.useState)(false);
    const startHighlight = (0, $cozmU.useCallback)(()=>{
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const sel = document.getSelection();
        if (!sel || sel.rangeCount === 0 || sel.isCollapsed) return;
        const range = sel.getRangeAt(0).cloneRange();
        savedRangeRef.current = range;
        if (typeof Highlight !== 'undefined' && 'highlights' in CSS) {
            const highlight = new Highlight(range);
            CSS.highlights.set($5ae98e04c533e5e9$var$HIGHLIGHT_NAME, highlight);
            sel.removeAllRanges();
            setIsHighlighting(true);
        }
    }, []);
    const clearHighlight = (0, $cozmU.useCallback)(()=>{
        if (typeof Highlight !== 'undefined' && 'highlights' in CSS) CSS.highlights.delete($5ae98e04c533e5e9$var$HIGHLIGHT_NAME);
        savedRangeRef.current = null;
        setIsHighlighting(false);
    }, []);
    return {
        startHighlight: startHighlight,
        clearHighlight: clearHighlight,
        isHighlighting: isHighlighting,
        savedRange: savedRangeRef
    };
};
module.exports["useRendererRemixHighlight"] = $5ae98e04c533e5e9$export$443e8aeb4c392a84;

});

parcelRegister("erJgi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $b35Wv = parcelRequire("b35Wv");


var $6t3CY = parcelRequire("6t3CY");


var $5AKbu = parcelRequire("5AKbu");


var $lslMH = parcelRequire("lslMH");


var $9DHhW = parcelRequire("9DHhW");


var $ep3mz = parcelRequire("ep3mz");


var $aSsfA = parcelRequire("aSsfA");


var $dklIa = parcelRequire("dklIa");

const $96891b810f2a7438$var$messages = (0, $kSwu1.defineMessages)({
    reactTooltip: {
        id: "experiment-inline-reactions.inline-reaction.tooltip",
        defaultMessage: "React"
    },
    reactLabel: {
        id: "experiment-inline-reactions.inline-reaction.label",
        defaultMessage: "React"
    }
});
const $96891b810f2a7438$export$9e9c4b5df2f723ad = ({ isAnnotationAllowed: isAnnotationAllowed = true, disabledTooltip: disabledTooltip })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [pageId] = (0, $ep3mz.usePageContentId)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { triggerOpen: triggerOpen } = (0, $dklIa.useInlineReactionActions)();
    const tooltipContent = !isAnnotationAllowed && disabledTooltip ? disabledTooltip : formatMessage($96891b810f2a7438$var$messages.reactTooltip);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AKbu.ToolbarButtonGroup), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6t3CY.ToolbarButton), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b35Wv))), {
            label: "",
            size: "small"
        }),
        testId: "highlight-actions-react",
        onClick: ()=>{
            if (pageId) createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'createInlineReactionFromHighlightActionsMenu',
                    source: 'highlightActionsMenu',
                    attributes: {
                        contentId: pageId,
                        pageMode: pageMode,
                        isInlineReaction: true
                    }
                }
            }).fire();
            triggerOpen();
        },
        isDisabled: !isAnnotationAllowed
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $96891b810f2a7438$var$messages.reactLabel))));
};
module.exports["InlineReactionAction"] = $96891b810f2a7438$export$9e9c4b5df2f723ad;

});

parcelRegister("dnbZ2", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");

const $2a69d40b2e0abea7$export$4739f60b2e0ffe71 = ()=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    return isRovoLLMEnabled && (0, $6mKj3.isExperimentEnabled)('cc-maui-experiment');
};
module.exports["useIsRemixAvailable"] = $2a69d40b2e0abea7$export$4739f60b2e0ffe71;

});

parcelRegister("3b5i6", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $1pCE4 = parcelRequire("1pCE4");


var $6t3CY = parcelRequire("6t3CY");


var $5AKbu = parcelRequire("5AKbu");


var $lslMH = parcelRequire("lslMH");

const $62937d50f24b4234$var$messages = (0, $kSwu1.defineMessages)({
    remixInProgressTooltip: {
        id: "highlight-actions.remix-action.in-progress-tooltip",
        defaultMessage: "Remix in progress..."
    },
    remixToolbarTooltip: {
        id: "highlight-actions.remix-action.toolbar-tooltip",
        defaultMessage: "Remix"
    },
    remixToolbarLabel: {
        id: "highlight-actions.remix-action.toolbar-label",
        defaultMessage: "Remix"
    },
    remixDisabledTooltipArchived: {
        id: "highlight-actions.remix-action.disabled-tooltip-archived",
        defaultMessage: "Content on archived pages can't be remixed"
    },
    remixDisabledTooltipVersionHistory: {
        id: "highlight-actions.remix-action.disabled-tooltip-version-history",
        defaultMessage: "Remix is unavailable in version history"
    }
});
const $62937d50f24b4234$var$getRemixDisabledTooltip = (formatMessage, reason)=>{
    switch(reason){
        case 'version-history':
            return formatMessage($62937d50f24b4234$var$messages.remixDisabledTooltipVersionHistory);
        case 'archived':
        default:
            return formatMessage($62937d50f24b4234$var$messages.remixDisabledTooltipArchived);
    }
};
const $62937d50f24b4234$export$750386901eee7bd0 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { isNewToolbarEnabled: isNewToolbarEnabled, onClick: onClick, isDisabled: isDisabled, isRemixInProgress: isRemixInProgress, remixDisabledReason: remixDisabledReason } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage || $[1] !== isDisabled || $[2] !== isRemixInProgress || $[3] !== remixDisabledReason) {
        t1 = isRemixInProgress ? formatMessage($62937d50f24b4234$var$messages.remixInProgressTooltip) : isDisabled ? $62937d50f24b4234$var$getRemixDisabledTooltip(formatMessage, remixDisabledReason) : formatMessage($62937d50f24b4234$var$messages.remixToolbarTooltip);
        $[0] = formatMessage;
        $[1] = isDisabled;
        $[2] = isRemixInProgress;
        $[3] = remixDisabledReason;
        $[4] = t1;
    } else t1 = $[4];
    const tooltipContent = t1;
    let t2;
    if ($[5] !== isDisabled || $[6] !== isNewToolbarEnabled || $[7] !== isRemixInProgress || $[8] !== onClick || $[9] !== tooltipContent) {
        t2 = isNewToolbarEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
            content: tooltipContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AKbu.ToolbarButtonGroup), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6t3CY.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))), {
                label: "",
                size: "small"
            }),
            testId: "highlight-actions-remix",
            onClick: onClick,
            isDisabled: isDisabled || isRemixInProgress
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $62937d50f24b4234$var$messages.remixToolbarLabel)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
            content: tooltipContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))),
            testId: "highlight-actions-remix",
            onClick: onClick,
            isDisabled: isDisabled || isRemixInProgress
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $62937d50f24b4234$var$messages.remixToolbarLabel)));
        $[5] = isDisabled;
        $[6] = isNewToolbarEnabled;
        $[7] = isRemixInProgress;
        $[8] = onClick;
        $[9] = tooltipContent;
        $[10] = t2;
    } else t2 = $[10];
    return t2;
} : ({ isNewToolbarEnabled: isNewToolbarEnabled, onClick: onClick, isDisabled: isDisabled, isRemixInProgress: isRemixInProgress, remixDisabledReason: remixDisabledReason })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const tooltipContent = isRemixInProgress ? formatMessage($62937d50f24b4234$var$messages.remixInProgressTooltip) : isDisabled ? $62937d50f24b4234$var$getRemixDisabledTooltip(formatMessage, remixDisabledReason) : formatMessage($62937d50f24b4234$var$messages.remixToolbarTooltip);
    return isNewToolbarEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AKbu.ToolbarButtonGroup), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6t3CY.ToolbarButton), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))), {
            label: "",
            size: "small"
        }),
        testId: "highlight-actions-remix",
        onClick: onClick,
        isDisabled: isDisabled || isRemixInProgress
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $62937d50f24b4234$var$messages.remixToolbarLabel)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($1pCE4))),
        testId: "highlight-actions-remix",
        onClick: onClick,
        isDisabled: isDisabled || isRemixInProgress
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $62937d50f24b4234$var$messages.remixToolbarLabel)));
};
module.exports["RemixAction"] = $62937d50f24b4234$export$750386901eee7bd0;

});

parcelRegister("6W81y", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $is1T6 = parcelRequire("is1T6");


var $gFEZF = parcelRequire("gFEZF");


var $iRFKG = parcelRequire("iRFKG");


var $f1iv3 = parcelRequire("f1iv3");


var $9DHhW = parcelRequire("9DHhW");


var $1o3CH = parcelRequire("1o3CH");


var $fqVYq = parcelRequire("fqVYq");


var $dVKvM = parcelRequire("dVKvM");








var $cXLoX = parcelRequire("cXLoX");


var $jln20 = parcelRequire("jln20");


var $hq2Sz = parcelRequire("hq2Sz");


var $1mDVg = parcelRequire("1mDVg");


var $frJep = parcelRequire("frJep");


var $cSSgB = parcelRequire("cSSgB");


var $ai7NK = parcelRequire("ai7NK");


var $9wGTI = parcelRequire("9wGTI");


var $cAdj8 = parcelRequire("cAdj8");


var $1xpoY = parcelRequire("1xpoY");


var $6mKj3 = parcelRequire("6mKj3");


var $2W2Mk = parcelRequire("2W2Mk");


var $joYQz = parcelRequire("joYQz");

const $ae4b6329110effd0$export$67bda1dbd5f0074c = {
    SINGLE_ISSUE: 'SINGLE_ISSUE',
    MULTIPLE_ISSUE: 'MULTIPLE_ISSUE',
    AI_ISSUE: 'AI_ISSUE'
};
// Helper function to find the parent <table> element of a given node
const $ae4b6329110effd0$var$findParentTable = (node)=>{
    let currentNode = node;
    while(currentNode){
        if (currentNode.nodeType === Node.ELEMENT_NODE && currentNode.tagName === 'TABLE') return currentNode;
        currentNode = currentNode.parentNode;
    }
    return null;
};
// Use this helper function when we have the modernized bulk create ready.
const $ae4b6329110effd0$var$isMultiRowTableSelection = (selection)=>{
    if (!selection || selection.rangeCount === 0) return false;
    const range = selection.getRangeAt(0);
    const startContainer = range.startContainer;
    const endContainer = range.endContainer;
    // Helper function to find the parent <tr> element of a given node
    const findParentTableRow = (node)=>{
        while(node){
            if (node.tagName === 'TR') return node;
            node = node.parentNode;
        }
        return null;
    };
    // Find the closest <tr> ancestor for both start and end of the selection
    const startRow = findParentTableRow(startContainer);
    const endRow = findParentTableRow(endContainer);
    if (!startRow || !endRow) return false;
    // If the start and end are not in the same row, it's a multi-row selection
    return startRow !== endRow;
};
/**
 * isTableSelection: returns true if the user highlights over only
 * table content.
 * @param selection
 * @returns {boolean}
 */ const $ae4b6329110effd0$var$isTableSelection = (selection)=>{
    if (!selection || selection.rangeCount === 0) return false;
    const range = selection.getRangeAt(0);
    const startContainer = range.startContainer;
    const endContainer = range.endContainer;
    // Check if both the start and end container are within a table
    const startInTable = $ae4b6329110effd0$var$findParentTable(startContainer) !== null;
    const endInTable = $ae4b6329110effd0$var$findParentTable(endContainer) !== null;
    return startInTable && endInTable;
};
const $ae4b6329110effd0$export$50d84a2be082120 = (selection)=>{
    if (!selection || selection.rangeCount === 0) return 0;
    const range = selection.getRangeAt(0);
    if (range.collapsed) return 0;
    const startContainer = range.startContainer;
    const endContainer = range.endContainer;
    const startInActionContainer = (0, $cSSgB.findActionItemElement)(startContainer);
    const endInActionContainer = (0, $cSSgB.findActionItemElement)(endContainer);
    let commonAncestor;
    if (startInActionContainer || endInActionContainer) {
        const actionItemRange = range.cloneRange();
        actionItemRange.setStart(startInActionContainer || startContainer, 0);
        actionItemRange.setEnd(endInActionContainer || endContainer, 0);
        commonAncestor = actionItemRange.commonAncestorContainer;
    } else // the selection might span across different containers
    // or be in between the start and end highlight
    commonAncestor = range.commonAncestorContainer;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const walker = document.createTreeWalker(commonAncestor, NodeFilter.SHOW_ELEMENT, null);
    let node = walker.currentNode;
    let actionItemsInSelection = 0;
    while(node){
        if (range.intersectsNode(node)) {
            const element = node;
            if (element.dataset?.taskLocalId !== undefined) actionItemsInSelection++;
        }
        node = walker.nextNode();
    }
    return actionItemsInSelection;
};
const $ae4b6329110effd0$var$getIssueCreationType = ({ isAIIssueCreationEnabled: isAIIssueCreationEnabled })=>{
    if (isAIIssueCreationEnabled) return $ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE;
    else return $ae4b6329110effd0$export$67bda1dbd5f0074c.SINGLE_ISSUE;
};
const $ae4b6329110effd0$var$userHasEditPermission = (pageInfo)=>{
    if (!pageInfo) return false;
    const contentType = pageInfo.type;
    return pageInfo.operations?.some((op)=>op?.operation === 'update' && op?.targetType === contentType) || false;
};
const $ae4b6329110effd0$var$ConsolidatedCreateJiraIssueButton = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { completeKey: completeKey, handleCreateIssueItemClicked: handleCreateIssueItemClicked, isAIIssueCreationEnabled: isAIIssueCreationEnabled, isSelectionMultipleRows: isSelectionMultipleRows } = t0;
    let t1;
    let t2;
    if ($[0] !== completeKey || $[1] !== handleCreateIssueItemClicked || $[2] !== isAIIssueCreationEnabled || $[3] !== isSelectionMultipleRows) {
        t2 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const issueCreationType = isSelectionMultipleRows ? $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE : $ae4b6329110effd0$var$getIssueCreationType({
                isAIIssueCreationEnabled: isAIIssueCreationEnabled
            });
            const getIcon = (iconProps)=>{
                if (issueCreationType === $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f1iv3))), {
                    ...iconProps,
                    label: ""
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
                    ...iconProps,
                    label: ""
                });
            };
            const getIconAIFC = (iconProps_0)=>{
                if (issueCreationType === $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f1iv3))), {
                    ...iconProps_0,
                    size: "small",
                    label: ""
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
                    ...iconProps_0,
                    size: "small",
                    label: ""
                });
            };
            const getButtonText = ()=>{
                if (issueCreationType === $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    id: "highlight-actions.create-multiple-jira-work-items",
                    defaultMessage: "Create Jira work items"
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    id: "highlight-actions.create-jira-work-item",
                    defaultMessage: "Create Jira work item"
                });
            };
            if ((0, $9wGTI.fg)("aifc_create_enabled") || (0, $6mKj3.expValEquals)("platform_editor_toolbar_aifc_confluence", "isEnabled", true)) {
                let t3;
                if ($[6] !== getIconAIFC) {
                    t3 = getIconAIFC({});
                    $[6] = getIconAIFC;
                    $[7] = t3;
                } else t3 = $[7];
                const t4 = handleCreateIssueItemClicked(issueCreationType);
                let t5;
                if ($[8] !== getButtonText) {
                    t5 = getButtonText();
                    $[8] = getButtonText;
                    $[9] = t5;
                } else t5 = $[9];
                t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
                    testId: "consolidated-create-jira-issue-button",
                    "data-key": completeKey,
                    shouldTitleWrap: false,
                    elemBefore: t3,
                    onClick: t4
                }, t5);
                break bb0;
            }
            t1 = (0, $fqVYq.editorExperiment)("platform_editor_controls", "variant1") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                testId: "consolidated-create-jira-issue-button",
                "data-key": completeKey,
                shouldTitleWrap: false,
                elemBefore: getIcon({}),
                onClick: handleCreateIssueItemClicked(issueCreationType)
            }, getButtonText()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                id: "create-jira-issue-button",
                appearance: "subtle",
                iconBefore: $ae4b6329110effd0$var$_temp,
                "data-key": completeKey,
                testId: "consolidated-create-jira-issue-button",
                onClick: handleCreateIssueItemClicked(isSelectionMultipleRows ? "MULTIPLE_ISSUE" : $ae4b6329110effd0$var$getIssueCreationType({
                    isAIIssueCreationEnabled: isAIIssueCreationEnabled
                })),
                spacing: "compact"
            }, (0, $9wGTI.fg)("confluence-issue-terminology-refresh") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                id: "highlight-actions.create-jira-issue-issue-term-refresh",
                defaultMessage: "Jira work item"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                id: "highlight-actions.create-jira-issue",
                defaultMessage: "Jira issue"
            }));
        }
        $[0] = completeKey;
        $[1] = handleCreateIssueItemClicked;
        $[2] = isAIIssueCreationEnabled;
        $[3] = isSelectionMultipleRows;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    if (t2 !== Symbol.for("react.early_return_sentinel")) return t2;
    return t1;
} : ({ completeKey: completeKey, handleCreateIssueItemClicked: handleCreateIssueItemClicked, isAIIssueCreationEnabled: isAIIssueCreationEnabled, isSelectionMultipleRows: isSelectionMultipleRows })=>{
    const issueCreationType = isSelectionMultipleRows ? $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE : $ae4b6329110effd0$var$getIssueCreationType({
        isAIIssueCreationEnabled: isAIIssueCreationEnabled
    });
    const getIcon = (iconProps)=>{
        if (issueCreationType === $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f1iv3))), {
            ...iconProps,
            label: ""
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
            ...iconProps,
            label: ""
        });
    };
    const getIconAIFC = (iconProps_0)=>{
        if (issueCreationType === $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f1iv3))), {
            ...iconProps_0,
            size: "small",
            label: ""
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
            ...iconProps_0,
            size: "small",
            label: ""
        });
    };
    const getButtonText = ()=>{
        if (issueCreationType === $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "highlight-actions.create-multiple-jira-work-items",
            defaultMessage: "Create Jira work items"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "highlight-actions.create-jira-work-item",
            defaultMessage: "Create Jira work item"
        });
    };
    if ((0, $9wGTI.fg)('aifc_create_enabled') || (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_confluence', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        testId: "consolidated-create-jira-issue-button",
        "data-key": completeKey,
        shouldTitleWrap: false,
        elemBefore: getIconAIFC({}),
        onClick: handleCreateIssueItemClicked(issueCreationType)
    }, getButtonText());
    return (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        testId: "consolidated-create-jira-issue-button",
        "data-key": completeKey,
        shouldTitleWrap: false,
        elemBefore: getIcon({}),
        onClick: handleCreateIssueItemClicked(issueCreationType)
    }, getButtonText()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        id: "create-jira-issue-button",
        appearance: "subtle",
        iconBefore: (iconProps_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
                ...iconProps_1,
                label: ""
            }),
        "data-key": completeKey,
        testId: "consolidated-create-jira-issue-button",
        onClick: handleCreateIssueItemClicked(isSelectionMultipleRows ? 'MULTIPLE_ISSUE' : $ae4b6329110effd0$var$getIssueCreationType({
            isAIIssueCreationEnabled: isAIIssueCreationEnabled
        })),
        spacing: "compact"
    }, (0, $9wGTI.fg)('confluence-issue-terminology-refresh') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "highlight-actions.create-jira-issue-issue-term-refresh",
        defaultMessage: "Jira work item"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "highlight-actions.create-jira-issue",
        defaultMessage: "Jira issue"
    }));
};
const $ae4b6329110effd0$export$f91cf3aef874f6f = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(42);
    const { activeSelection: activeSelection, completeKey: completeKey, container: container, contentId: contentId, contentType: contentType, lastModified: lastModified, setRecordedClick: setRecordedClick, setIsWarningDialogOpen: setIsWarningDialogOpen } = t0;
    const { trackAIInteractionInit: trackAIInteractionInit } = (0, $cXLoX.useAIEventsInstrumentation)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const pressTracing = (0, $1o3CH.default)("highlight-actions.ai-issue-create.dropdown-item-click");
    const [, actions] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const setIsCreatedWithAi = (0, $hq2Sz.useSetIsCreatedWithAi)();
    const setIsCreatedFromTable = (0, $hq2Sz.useSetIsCreatedFromTable)();
    const setIsCreatedFromActionItems = (0, $hq2Sz.useSetIsCreatedFromActionItems)();
    const isSidePanelOpen = (0, $ai7NK.useIsSidePanelOpen)();
    const isAIIssueCreationEnabled = (0, $frJep.useIsAIIssueCreationEnabled)();
    let t1;
    if ($[0] !== activeSelection) {
        t1 = $ae4b6329110effd0$var$isTableSelection(activeSelection);
        $[0] = activeSelection;
        $[1] = t1;
    } else t1 = $[1];
    const isSelectionInTable = t1;
    const actionItemsInSelection = $ae4b6329110effd0$export$50d84a2be082120(activeSelection);
    let t2;
    if ($[2] !== actionItemsInSelection || $[3] !== isSelectionInTable) {
        t2 = actionItemsInSelection > 0 && !isSelectionInTable && (0, $9wGTI.fg)("confluence-create-work-items-from-action-items");
        $[2] = actionItemsInSelection;
        $[3] = isSelectionInTable;
        $[4] = t2;
    } else t2 = $[4];
    const isActionItemInSelection = t2;
    let t3;
    if ($[5] !== actionItemsInSelection || $[6] !== isSelectionInTable) {
        t3 = actionItemsInSelection > 1 && !isSelectionInTable && (0, $9wGTI.fg)("confluence-create-work-items-from-action-items");
        $[5] = actionItemsInSelection;
        $[6] = isSelectionInTable;
        $[7] = t3;
    } else t3 = $[7];
    const isMultiActionItemsInSelection = t3;
    let t4;
    if ($[8] !== activeSelection || $[9] !== isMultiActionItemsInSelection) {
        t4 = $ae4b6329110effd0$var$isMultiRowTableSelection(activeSelection) || isMultiActionItemsInSelection;
        $[8] = activeSelection;
        $[9] = isMultiActionItemsInSelection;
        $[10] = t4;
    } else t4 = $[10];
    const isSelectionMultipleRows = t4;
    let t5;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            fetchPolicy: "cache-first"
        };
        $[11] = t5;
    } else t5 = $[11];
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)(t5);
    let t6;
    if ($[12] !== pageInfo) {
        t6 = $ae4b6329110effd0$var$userHasEditPermission(pageInfo);
        $[12] = pageInfo;
        $[13] = t6;
    } else t6 = $[13];
    const hasEditPermission = t6;
    let t7;
    if ($[14] !== createAnalyticsEvent || $[15] !== hasEditPermission) {
        t7 = (issueCreationType, isCreatedFromTable, isCreatedFromActionItems)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "confluenceHighlightActionsMenu",
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "jiraIssueLink",
                    type: "ui",
                    attributes: {
                        issueCreationType: issueCreationType,
                        isDropdownItem: false,
                        isCreatedFromTable: isCreatedFromTable,
                        isCreatedFromActionItems: isCreatedFromActionItems,
                        hasEditPermission: hasEditPermission,
                        pageMode: (0, $1mDVg.PageMode).VIEW
                    }
                }
            }).fire();
        };
        $[14] = createAnalyticsEvent;
        $[15] = hasEditPermission;
        $[16] = t7;
    } else t7 = $[16];
    const fireCreateIssueButtonClickedAnalytics = t7;
    let t8;
    if ($[17] !== actions || $[18] !== activeSelection || $[19] !== container || $[20] !== contentId || $[21] !== contentType || $[22] !== fireCreateIssueButtonClickedAnalytics || $[23] !== hasEditPermission || $[24] !== isActionItemInSelection || $[25] !== isSelectionInTable || $[26] !== isSidePanelOpen || $[27] !== lastModified || $[28] !== pressTracing || $[29] !== rightSidebarContext || $[30] !== setIsCreatedFromActionItems || $[31] !== setIsCreatedFromTable || $[32] !== setIsCreatedWithAi || $[33] !== setIsWarningDialogOpen || $[34] !== setRecordedClick || $[35] !== trackAIInteractionInit) {
        t8 = (issueCreationType_0)=>()=>{
                if (!isSidePanelOpen) bb29: switch(issueCreationType_0){
                    case $ae4b6329110effd0$export$67bda1dbd5f0074c.SINGLE_ISSUE:
                        fireCreateIssueButtonClickedAnalytics($ae4b6329110effd0$export$67bda1dbd5f0074c.SINGLE_ISSUE, isSelectionInTable, isActionItemInSelection);
                        (0, $joYQz.createSingleJiraIssueHandle)({
                            rightSidebarContext: rightSidebarContext,
                            actions: actions,
                            activeSelection: activeSelection,
                            contentId: contentId,
                            contentType: contentType,
                            container: container,
                            lastModified: lastModified,
                            hasEditPermission: hasEditPermission,
                            isActionItemInSelection: isActionItemInSelection,
                            pageMode: (0, $1mDVg.PageMode).VIEW
                        });
                        break bb29;
                    case $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE:
                        fireCreateIssueButtonClickedAnalytics($ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE, isSelectionInTable, isActionItemInSelection);
                        !(0, $1xpoY.default).getBoolean("confluence_legacy_bulk_jira_work_create", false) ? (0, $joYQz.createMultipleJiraIssuesHandleModernized)({
                            rightSidebarContext: rightSidebarContext,
                            pressTracing: pressTracing,
                            activeSelection: activeSelection,
                            actions: actions,
                            setIsCreatedWithAi: setIsCreatedWithAi,
                            setIsCreatedFromTable: setIsCreatedFromTable,
                            setIsCreatedFromActionItems: setIsCreatedFromActionItems,
                            contentId: contentId,
                            container: container,
                            lastModified: lastModified,
                            hasEditPermission: hasEditPermission,
                            pageMode: (0, $1mDVg.PageMode).VIEW
                        }) : (0, $2W2Mk.createMultipleJiraIssuesHandle)(container, contentId, lastModified);
                        break bb29;
                    case $ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE:
                        fireCreateIssueButtonClickedAnalytics($ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE, isSelectionInTable, isActionItemInSelection);
                        (0, $joYQz.createSingleAiJiraIssueHandle)({
                            rightSidebarContext: rightSidebarContext,
                            actions: actions,
                            activeSelection: activeSelection,
                            contentId: contentId,
                            contentType: contentType,
                            container: container,
                            fireAiAnalytics: trackAIInteractionInit,
                            lastModified: lastModified,
                            hasEditPermission: hasEditPermission,
                            pageMode: (0, $1mDVg.PageMode).VIEW,
                            isActionItemInSelection: isActionItemInSelection
                        });
                        pressTracing();
                }
                else {
                    const aiData = {
                        contentType: contentType,
                        fireAiAnalytics: trackAIInteractionInit
                    };
                    const tempData = {
                        rightSidebarContext: rightSidebarContext,
                        actions: actions,
                        activeSelection: activeSelection,
                        contentId: contentId,
                        container: container,
                        lastModified: lastModified,
                        hasEditPermission: hasEditPermission,
                        ...issueCreationType_0 === $ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE ? aiData : {}
                    };
                    setRecordedClick(tempData);
                    setIsWarningDialogOpen(true);
                }
            };
        $[17] = actions;
        $[18] = activeSelection;
        $[19] = container;
        $[20] = contentId;
        $[21] = contentType;
        $[22] = fireCreateIssueButtonClickedAnalytics;
        $[23] = hasEditPermission;
        $[24] = isActionItemInSelection;
        $[25] = isSelectionInTable;
        $[26] = isSidePanelOpen;
        $[27] = lastModified;
        $[28] = pressTracing;
        $[29] = rightSidebarContext;
        $[30] = setIsCreatedFromActionItems;
        $[31] = setIsCreatedFromTable;
        $[32] = setIsCreatedWithAi;
        $[33] = setIsWarningDialogOpen;
        $[34] = setRecordedClick;
        $[35] = trackAIInteractionInit;
        $[36] = t8;
    } else t8 = $[36];
    const handleCreateIssueItemClicked = t8;
    let t9;
    if ($[37] !== completeKey || $[38] !== handleCreateIssueItemClicked || $[39] !== isAIIssueCreationEnabled || $[40] !== isSelectionMultipleRows) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae4b6329110effd0$var$ConsolidatedCreateJiraIssueButton, {
            completeKey: completeKey,
            handleCreateIssueItemClicked: handleCreateIssueItemClicked,
            isAIIssueCreationEnabled: isAIIssueCreationEnabled,
            isSelectionMultipleRows: isSelectionMultipleRows
        });
        $[37] = completeKey;
        $[38] = handleCreateIssueItemClicked;
        $[39] = isAIIssueCreationEnabled;
        $[40] = isSelectionMultipleRows;
        $[41] = t9;
    } else t9 = $[41];
    return t9;
} : ({ activeSelection: activeSelection, completeKey: completeKey, container: container, contentId: contentId, contentType: contentType, lastModified: lastModified, setRecordedClick: setRecordedClick, setIsWarningDialogOpen: setIsWarningDialogOpen })=>{
    const { trackAIInteractionInit: trackAIInteractionInit } = (0, $cXLoX.useAIEventsInstrumentation)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const pressTracing = (0, $1o3CH.default)('highlight-actions.ai-issue-create.dropdown-item-click');
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [, actions] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    const setIsCreatedWithAi = (0, $hq2Sz.useSetIsCreatedWithAi)();
    const setIsCreatedFromTable = (0, $hq2Sz.useSetIsCreatedFromTable)();
    const setIsCreatedFromActionItems = (0, $hq2Sz.useSetIsCreatedFromActionItems)();
    const isSidePanelOpen = (0, $ai7NK.useIsSidePanelOpen)();
    const isAIIssueCreationEnabled = (0, $frJep.useIsAIIssueCreationEnabled)();
    const isSelectionInTable = $ae4b6329110effd0$var$isTableSelection(activeSelection);
    // table creation has higher priority than action item creation
    const actionItemsInSelection = $ae4b6329110effd0$export$50d84a2be082120(activeSelection);
    const isActionItemInSelection = actionItemsInSelection > 0 && !isSelectionInTable && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items');
    const isMultiActionItemsInSelection = actionItemsInSelection > 1 && !isSelectionInTable && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items');
    const isSelectionMultipleRows = $ae4b6329110effd0$var$isMultiRowTableSelection(activeSelection) || isMultiActionItemsInSelection;
    const { pageInfo: pageInfo } = (0, $cAdj8.usePageInfo)({
        fetchPolicy: 'cache-first'
    });
    const hasEditPermission = (0, $cozmU.useMemo)(()=>$ae4b6329110effd0$var$userHasEditPermission(pageInfo), [
        pageInfo
    ]);
    const fireCreateIssueButtonClickedAnalytics = (0, $cozmU.useCallback)((issueCreationType, isCreatedFromTable, isCreatedFromActionItems)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'confluenceHighlightActionsMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'jiraIssueLink',
                type: 'ui',
                attributes: {
                    issueCreationType: issueCreationType,
                    isDropdownItem: false,
                    isCreatedFromTable: isCreatedFromTable,
                    isCreatedFromActionItems: isCreatedFromActionItems,
                    hasEditPermission: hasEditPermission,
                    pageMode: (0, $1mDVg.PageMode).VIEW
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        hasEditPermission
    ]);
    const handleCreateIssueItemClicked = (0, $cozmU.useCallback)((issueCreationType_0)=>()=>{
            if (!isSidePanelOpen) switch(issueCreationType_0){
                case $ae4b6329110effd0$export$67bda1dbd5f0074c.SINGLE_ISSUE:
                    fireCreateIssueButtonClickedAnalytics($ae4b6329110effd0$export$67bda1dbd5f0074c.SINGLE_ISSUE, isSelectionInTable, isActionItemInSelection);
                    (0, $joYQz.createSingleJiraIssueHandle)({
                        rightSidebarContext: rightSidebarContext,
                        actions: actions,
                        activeSelection: activeSelection,
                        contentId: contentId,
                        contentType: contentType,
                        container: container,
                        lastModified: lastModified,
                        hasEditPermission: hasEditPermission,
                        isActionItemInSelection: isActionItemInSelection,
                        pageMode: (0, $1mDVg.PageMode).VIEW
                    });
                    break;
                case $ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE:
                    fireCreateIssueButtonClickedAnalytics($ae4b6329110effd0$export$67bda1dbd5f0074c.MULTIPLE_ISSUE, isSelectionInTable, isActionItemInSelection);
                    !(0, $1xpoY.default).getBoolean('confluence_legacy_bulk_jira_work_create', false) ? (0, $joYQz.createMultipleJiraIssuesHandleModernized)({
                        rightSidebarContext: rightSidebarContext,
                        pressTracing: pressTracing,
                        activeSelection: activeSelection,
                        actions: actions,
                        setIsCreatedWithAi: setIsCreatedWithAi,
                        setIsCreatedFromTable: setIsCreatedFromTable,
                        setIsCreatedFromActionItems: setIsCreatedFromActionItems,
                        contentId: contentId,
                        container: container,
                        lastModified: lastModified,
                        hasEditPermission: hasEditPermission,
                        pageMode: (0, $1mDVg.PageMode).VIEW
                    }) : (0, $2W2Mk.createMultipleJiraIssuesHandle)(container, contentId, lastModified);
                    break;
                case $ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE:
                    fireCreateIssueButtonClickedAnalytics($ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE, isSelectionInTable, isActionItemInSelection);
                    (0, $joYQz.createSingleAiJiraIssueHandle)({
                        rightSidebarContext: rightSidebarContext,
                        actions: actions,
                        activeSelection: activeSelection,
                        contentId: contentId,
                        contentType: contentType,
                        container: container,
                        fireAiAnalytics: trackAIInteractionInit,
                        lastModified: lastModified,
                        hasEditPermission: hasEditPermission,
                        pageMode: (0, $1mDVg.PageMode).VIEW,
                        isActionItemInSelection: isActionItemInSelection
                    });
                    pressTracing();
                    break;
            }
            else {
                // ai specific data
                const aiData = {
                    contentType: contentType,
                    fireAiAnalytics: trackAIInteractionInit
                };
                // record temp data
                const tempData = {
                    rightSidebarContext: rightSidebarContext,
                    actions: actions,
                    activeSelection: activeSelection,
                    contentId: contentId,
                    container: container,
                    lastModified: lastModified,
                    hasEditPermission: hasEditPermission,
                    ...issueCreationType_0 === $ae4b6329110effd0$export$67bda1dbd5f0074c.AI_ISSUE ? aiData : {}
                };
                setRecordedClick(tempData);
                setIsWarningDialogOpen(true);
            }
        }, [
        isSidePanelOpen,
        fireCreateIssueButtonClickedAnalytics,
        isSelectionInTable,
        rightSidebarContext,
        actions,
        activeSelection,
        contentId,
        contentType,
        container,
        lastModified,
        pressTracing,
        setIsCreatedWithAi,
        setIsCreatedFromTable,
        setIsCreatedFromActionItems,
        trackAIInteractionInit,
        setRecordedClick,
        setIsWarningDialogOpen,
        hasEditPermission,
        isActionItemInSelection
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae4b6329110effd0$var$ConsolidatedCreateJiraIssueButton, {
        completeKey: completeKey,
        handleCreateIssueItemClicked: handleCreateIssueItemClicked,
        isAIIssueCreationEnabled: isAIIssueCreationEnabled,
        isSelectionMultipleRows: isSelectionMultipleRows
    });
};
function $ae4b6329110effd0$var$_temp(iconProps_1) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))), {
        ...iconProps_1,
        label: ""
    });
}
module.exports["CreateJiraIssueActions"] = $ae4b6329110effd0$export$f91cf3aef874f6f;

});

parcelRegister("is1T6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lmzCg = parcelRequire("lmzCg");


var $9d7Pd = parcelRequire("9d7Pd");


var $kD4eB = parcelRequire("kD4eB");


var $8oBbn = parcelRequire("8oBbn");


var $imIsb = parcelRequire("imIsb");

/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ const $94fa0e4252415620$var$DropdownMenuItem = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, role: role, ...rest }, ref)=>{
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    const itemRef = (0, $imIsb.default)(!!rest['aria-haspopup']);
    const handleItemClick = (0, $cozmU.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kD4eB.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $lmzCg.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8oBbn.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $lmzCg.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName,
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $lmzCg.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest
    }, children);
});
var $94fa0e4252415620$export$2e2bcd8739ae039 = $94fa0e4252415620$var$DropdownMenuItem;
module.exports["default"] = $94fa0e4252415620$export$2e2bcd8739ae039;

});

parcelRegister("imIsb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ixfCV = parcelRequire("ixfCV");


var $6nHMa = parcelRequire("6nHMa");

// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
const $ab7ed338ade85dc7$var$useRegisterItemWithFocusManager = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useRegisterItemWithFocusManager(t0) {
    const $ = (0, $bDgLe.c)(4);
    const hasPopup = t0 === undefined ? false : t0;
    const { registerRef: registerRef } = (0, $cozmU.useContext)((0, $6nHMa.FocusManagerContext));
    const itemRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== hasPopup || $[1] !== registerRef) {
        t1 = ()=>{
            if (hasPopup && (0, $ixfCV.fg)("select-avoid-duplicated-registered-ref")) return;
            registerRef(itemRef);
        };
        t2 = [
            registerRef,
            hasPopup
        ];
        $[0] = hasPopup;
        $[1] = registerRef;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return itemRef;
} : function useRegisterItemWithFocusManager(hasPopup = false) {
    const { registerRef: registerRef } = (0, $cozmU.useContext)((0, $6nHMa.FocusManagerContext));
    const itemRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (hasPopup && (0, $ixfCV.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
};
var $ab7ed338ade85dc7$export$2e2bcd8739ae039 = $ab7ed338ade85dc7$var$useRegisterItemWithFocusManager;
module.exports["default"] = $ab7ed338ade85dc7$export$2e2bcd8739ae039;

});

parcelRegister("6nHMa", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");

const $f526bd1b7b92569a$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $cozmU.createContext)({
    menuItemRefs: [],
    registerRef: (0, $dpsRj.default)
});
module.exports["FocusManagerContext"] = $f526bd1b7b92569a$export$f18c1d4fc7326096;

});

parcelRegister("frJep", function(module, exports) {

var $1mDVg = parcelRequire("1mDVg");


var $dAg4H = parcelRequire("dAg4H");


var $2ay9q = parcelRequire("2ay9q");

const $ae678835b2293c93$export$58de3335a79e10d3 = ()=>{
    const [{ contentId: contentId }] = (0, $1mDVg.useIssueCreateSidePanelContext)();
    (0, $dAg4H.useIsAIIssueCreationAllowed)({
        contentId: contentId
    });
    const aiIssueCreationEnablement = (0, $1mDVg.useAiIssueCreationEnablementState)();
    const isAiEnabled = aiIssueCreationEnablement?.isEnabled ?? false;
    const isCreateIssueWithAiEnabledByUser = (0, $2ay9q.getIsCreateIssueWithAiEnabledByUser)();
    return isAiEnabled && isCreateIssueWithAiEnabledByUser;
};
module.exports["useIsAIIssueCreationEnabled"] = $ae678835b2293c93$export$58de3335a79e10d3;

});

parcelRegister("2W2Mk", function(module, exports) {

var $04e9M = parcelRequire("04e9M");


var $aUTn5 = parcelRequire("aUTn5");

const $fc9c79783a6d919a$export$b5c53601259f278e = (container, contentId, lastModified)=>()=>{
        const selection = window.getSelection();
        if (selection) {
            // Send an event to track the user clicking the JIRA Link
            (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                client.sendUIEvent({
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'jiraIssueLink',
                    source: 'HighlightContextMenu'
                });
            });
            window.dispatchEvent(new CustomEvent('create-jira-issue-summary', // Convert window.getSelection() to legacy format used in jira issue summary.
            // Once we Reactified it this should be deleted.
            {
                detail: (0, $aUTn5.convertSelectionToLegacyFormat)(container, selection.getRangeAt(0), contentId, lastModified)
            }));
        }
    };
const $fc9c79783a6d919a$export$92ec81e7ac5e7973 = (container, contentId, lastModified)=>{
    const selection = window.getSelection();
    if (selection) {
        window.dispatchEvent(new CustomEvent('create-jira-issue-summary', {
            detail: (0, $aUTn5.convertSelectionToLegacyFormat)(container, selection.getRangeAt(0), contentId, lastModified)
        }));
        const observer = new MutationObserver((_mutations, observer)=>{
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const createMultipleButton = document.querySelector('.aui-button.aui-button-link.js-text-suggestion.js-go-to-create-multiple-issues');
            if (createMultipleButton) {
                createMultipleButton.click();
                observer.disconnect();
            }
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const createSingleButton = document.querySelector('.aui-button.aui-button-link.js-text-suggestion.js-go-to-create-single-issue');
            if (createSingleButton) createSingleButton.style.display = 'none';
        });
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
};
module.exports["createJiraIssueSummaryHandle"] = $fc9c79783a6d919a$export$b5c53601259f278e;
module.exports["createMultipleJiraIssuesHandle"] = $fc9c79783a6d919a$export$92ec81e7ac5e7973;

});

parcelRegister("joYQz", function(module, exports) {

var $i8Nmr = parcelRequire("i8Nmr");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $3TWPv = parcelRequire("3TWPv");


var $cSSgB = parcelRequire("cSSgB");


var $euVTc = parcelRequire("euVTc");


var $1Q0l6 = parcelRequire("1Q0l6");


var $2ViZo = parcelRequire("2ViZo");


var $UNr39 = parcelRequire("UNr39");


var $aUTn5 = parcelRequire("aUTn5");

const $4d90dab75b68bf7b$export$a25c0fd63a5cc834 = (activeSelection)=>{
    if (!activeSelection || 'rangeCount' in activeSelection && activeSelection.rangeCount === 0) return '';
    const range = 'getRangeAt' in activeSelection ? activeSelection.getRangeAt(0) : activeSelection;
    const docFragment = range.cloneContents();
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const tempDiv = document.createElement('div');
    tempDiv.appendChild(docFragment);
    return tempDiv.innerHTML;
};
const $4d90dab75b68bf7b$export$233a92718b28d19e = 254;
const $4d90dab75b68bf7b$export$2878cc467c8be8fe = (text, maxLength)=>{
    const horizontalEllipsis = "\u2026";
    if (text.length <= maxLength) return [
        text,
        ''
    ];
    // Calculate the length of the first part without including the ellipsis
    const firstPartLength = maxLength - horizontalEllipsis.length;
    // Split the text into two parts
    const firstPart = text.substring(0, firstPartLength);
    const firstPartWithHorizontalEllipis = firstPart + horizontalEllipsis;
    return [
        firstPartWithHorizontalEllipis,
        text
    ];
};
const $4d90dab75b68bf7b$export$5645fd1d37220db2 = (activeSelection)=>{
    const selectionString = activeSelection?.toString() || '';
    const htmlString = $4d90dab75b68bf7b$export$a25c0fd63a5cc834(activeSelection);
    const [summary] = $4d90dab75b68bf7b$export$2878cc467c8be8fe(selectionString, $4d90dab75b68bf7b$export$233a92718b28d19e);
    /*
   The regex matches one or more occurrences of any line break (\r, \n) or tab (\t)
   and replaces them all with a single space. (We only consider whitespace characters because
   these are the only ones that ultimately stick when parsing the summary.)
   */ const summaryWithoutFormatting = summary.replace(/[\r\n\t]+/g, ' ');
    // Convert the full HTML content to ADF for the description
    const descriptionAdf = (0, $i8Nmr.htmlToADF)(htmlString);
    return [
        summaryWithoutFormatting,
        descriptionAdf
    ];
};
const $4d90dab75b68bf7b$export$358d16442308a1f3 = ({ rightSidebarContext: rightSidebarContext, actions: actions, activeSelection: activeSelection, contentId: contentId, contentType: contentType, container: container, lastModified: lastModified, hasEditPermission: hasEditPermission, pageMode: pageMode, isActionItemInSelection: isActionItemInSelection })=>{
    actions.setIsCreatedWithAi(false);
    actions.setHasEditPermission(hasEditPermission);
    (0, $3TWPv.openSingleIssueSidePanelWithSelection)({
        actions: actions,
        rightSidebarContext: rightSidebarContext,
        activeSelection: activeSelection,
        contentId: contentId,
        contentType: contentType,
        container: container,
        lastModified: lastModified,
        pageMode: pageMode,
        isActionItemInSelection: isActionItemInSelection,
        convertSelectionToLegacyFormat: $aUTn5.convertSelectionToLegacyFormat
    });
};
const $4d90dab75b68bf7b$export$5378c6b60bde04bf = ({ rightSidebarContext: rightSidebarContext, actions: actions, activeSelection: activeSelection, contentId: contentId, contentType: contentType, container: container, fireAiAnalytics: fireAiAnalytics, lastModified: lastModified, pressTracing: pressTracing, hasEditPermission: hasEditPermission, pageMode: pageMode, isActionItemInSelection: isActionItemInSelection })=>{
    fireAiAnalytics();
    actions.setIsCreatedWithAi(true);
    actions.setHasEditPermission(hasEditPermission);
    (0, $3TWPv.openSingleIssueSidePanelWithSelection)({
        actions: actions,
        rightSidebarContext: rightSidebarContext,
        activeSelection: activeSelection,
        contentId: contentId,
        contentType: contentType,
        container: container,
        lastModified: lastModified,
        pageMode: pageMode,
        isActionItemInSelection: isActionItemInSelection,
        convertSelectionToLegacyFormat: $aUTn5.convertSelectionToLegacyFormat
    });
    pressTracing?.();
};
const $4d90dab75b68bf7b$export$83a48a684a9c82ca = ({ actions: actions, setIsCreatedWithAi: setIsCreatedWithAi, setIsCreatedFromTable: setIsCreatedFromTable, setIsCreatedFromActionItems: setIsCreatedFromActionItems, rightSidebarContext: rightSidebarContext, pressTracing: pressTracing, activeSelection: activeSelection, contentId: contentId, container: container, lastModified: lastModified, hasEditPermission: hasEditPermission, pageMode: pageMode })=>{
    if ((0, $6mKj3.expVal)('confluence-bulk-work-create-editor', 'isEnabled', false)) {
        const result = (0, $2ViZo.prepareBulkCreateFromSelection)({
            actions: actions,
            activeSelection: activeSelection,
            contentId: contentId,
            pageMode: pageMode,
            hasEditPermission: hasEditPermission,
            container: container,
            lastModified: lastModified,
            setIsCreatedFromTable: setIsCreatedFromTable,
            setIsCreatedFromActionItems: setIsCreatedFromActionItems,
            convertSelectionToLegacyFormat: $aUTn5.convertSelectionToLegacyFormat
        });
        if (result === (0, $2ViZo.BulkSelectionResult).None) return;
    } else {
        const selectedActionList = (0, $cSSgB.getClosestActionListFromSelection)(activeSelection, pageMode);
        const selectedTable = (0, $euVTc.getClosestTableFromSelection)(activeSelection);
        if (!selectedTable && !selectedActionList && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items')) // We have checks to ensure that the activeSelection is in a table or contains action items, so this should never happen.
        return;
        if (selectedTable) {
            actions.setSelectedTable(selectedTable);
            const insertStorageColumnTableRequestPayload = (0, $1Q0l6.constructInsertStorageColumnTableRequestPayload)(contentId, (0, $aUTn5.convertSelectionToLegacyFormat), (0, $1Q0l6.getValidRange)(activeSelection?.getRangeAt(0)), container, lastModified);
            actions.setInsertStorageColumnTableRequestPayload(insertStorageColumnTableRequestPayload);
            setIsCreatedFromTable(true);
            $4d90dab75b68bf7b$var$resetActionItemsState(setIsCreatedFromActionItems, actions);
        } else if (selectedActionList && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items')) {
            actions.setSelectedActionItems(selectedActionList);
            const actionItems = selectedActionList.querySelectorAll('div[data-task-local-id]:not([data-task-local-id=""])');
            const ranges = [];
            actionItems.forEach((actionItem)=>{
                const range = new Range();
                range.selectNodeContents(actionItem);
                const validRange = (0, $1Q0l6.getValidRangeForActionItem)(range);
                if (validRange) ranges.push(validRange);
            });
            const insertMultipleStorageFragmentsRequestPayload = (0, $1Q0l6.constructInsertMultipleStorageFragmentsRequestPayload)(contentId, (0, $aUTn5.convertSelectionToLegacyFormat), ranges, container, lastModified);
            actions.setInsertMultipleStorageFragmentsRequestPayload(insertMultipleStorageFragmentsRequestPayload);
            setIsCreatedFromActionItems(true);
            $4d90dab75b68bf7b$var$resetTableState(setIsCreatedFromTable, actions);
        }
        actions.setContentId(contentId);
        actions.setPageMode(pageMode);
        actions.setHasEditPermission(hasEditPermission);
        setIsCreatedWithAi(false);
    }
    rightSidebarContext.open((0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_ID), (0, $UNr39.BULK_ISSUE_CREATE_SIDE_PANEL_WIDTH));
    pressTracing?.();
};
const $4d90dab75b68bf7b$var$resetTableState = (setIsCreatedFromTable, actions)=>{
    setIsCreatedFromTable(false);
    actions.setSelectedTable(undefined);
    actions.setInsertStorageColumnTableRequestPayload(undefined);
};
const $4d90dab75b68bf7b$var$resetActionItemsState = (setIsCreatedFromActionItems, actions)=>{
    setIsCreatedFromActionItems(false);
    actions.setSelectedActionItems(undefined);
    actions.setInsertMultipleStorageFragmentsRequestPayload(undefined);
};
module.exports["getHTMLString"] = $4d90dab75b68bf7b$export$a25c0fd63a5cc834;
module.exports["createSingleJiraIssueHandle"] = $4d90dab75b68bf7b$export$358d16442308a1f3;
module.exports["createSingleAiJiraIssueHandle"] = $4d90dab75b68bf7b$export$5378c6b60bde04bf;
module.exports["createMultipleJiraIssuesHandleModernized"] = $4d90dab75b68bf7b$export$83a48a684a9c82ca;

});

parcelRegister("3TWPv", function(module, exports) {

var $i8Nmr = parcelRequire("i8Nmr");


var $9wGTI = parcelRequire("9wGTI");


var $1Q0l6 = parcelRequire("1Q0l6");


var $1mDVg = parcelRequire("1mDVg");


var $1L1jV = parcelRequire("1L1jV");


var $cSSgB = parcelRequire("cSSgB");


var $9uzSK = parcelRequire("9uzSK");

const $918fba8df3fbcc13$export$233a92718b28d19e = 254;
const $918fba8df3fbcc13$var$getHTMLString = (activeSelection)=>{
    if (!activeSelection || 'rangeCount' in activeSelection && activeSelection.rangeCount === 0) return '';
    const range = 'getRangeAt' in activeSelection ? activeSelection.getRangeAt(0) : activeSelection;
    const docFragment = range.cloneContents();
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const tempDiv = document.createElement('div');
    tempDiv.appendChild(docFragment);
    return tempDiv.innerHTML;
};
const $918fba8df3fbcc13$export$db5a8500f6b6286e = (text, maxLength)=>{
    const horizontalEllipsis = "\u2026";
    if (text.length <= maxLength) return [
        text,
        ''
    ];
    const firstPartLength = maxLength - horizontalEllipsis.length;
    const firstPart = text.substring(0, firstPartLength);
    const firstPartWithHorizontalEllipsis = firstPart + horizontalEllipsis;
    return [
        firstPartWithHorizontalEllipsis,
        text
    ];
};
const $918fba8df3fbcc13$export$5645fd1d37220db2 = (activeSelection)=>{
    const selectionString = activeSelection?.toString() || '';
    const htmlString = $918fba8df3fbcc13$var$getHTMLString(activeSelection);
    const [summary] = $918fba8df3fbcc13$export$db5a8500f6b6286e(selectionString, $918fba8df3fbcc13$export$233a92718b28d19e);
    const summaryWithoutFormatting = summary.replace(/[\r\n\t]+/g, ' ');
    const descriptionAdf = (0, $i8Nmr.htmlToADF)(htmlString);
    return [
        summaryWithoutFormatting,
        descriptionAdf
    ];
};
const $918fba8df3fbcc13$export$41bb5569f66eae2a = ({ actions: actions, rightSidebarContext: rightSidebarContext, activeSelection: activeSelection, selectionAdfResult: selectionAdfResult, contentId: contentId, contentType: contentType, container: container, lastModified: lastModified, pageMode: pageMode, isActionItemInSelection: isActionItemInSelection, convertSelectionToLegacyFormat: convertSelectionToLegacyFormat })=>{
    const { updatedSelection: updatedSelection, activeSelectionRange: activeSelectionRange } = $918fba8df3fbcc13$var$expandSelectionIfActionItemsSelected({
        activeSelection: activeSelection,
        pageMode: pageMode,
        isActionItemInSelection: isActionItemInSelection
    });
    const shouldUseSelectionAdf = pageMode !== (0, $1mDVg.PageMode).VIEW && !!selectionAdfResult?.selectedNodeAdf;
    const selectionAdf = shouldUseSelectionAdf ? (0, $9uzSK.extractSelectedAdfSlice)(selectionAdfResult) : undefined;
    const highlightedText = shouldUseSelectionAdf ? (0, $9uzSK.normalizeToDocNode)(selectionAdf) : (0, $i8Nmr.htmlToADF)($918fba8df3fbcc13$var$getHTMLString(updatedSelection));
    const insertStorageFragmentRequestPayload = (0, $1Q0l6.constructInsertStorageFragmentRequestPayload)(contentId, convertSelectionToLegacyFormat, activeSelectionRange, container, lastModified);
    const [summaryWithoutFormatting, descriptionAdf] = shouldUseSelectionAdf ? (0, $9uzSK.getSummaryAndDescriptionFromSelectionAdfResult)(selectionAdfResult, $918fba8df3fbcc13$export$233a92718b28d19e) : $918fba8df3fbcc13$export$5645fd1d37220db2(updatedSelection);
    actions.setSummary(summaryWithoutFormatting);
    actions.setDescriptionAdf(descriptionAdf);
    actions.setContentId(contentId);
    contentType && actions.setContentType(contentType);
    actions.setHighlightedText(highlightedText);
    actions.setInsertStorageFragmentRequestPayload(insertStorageFragmentRequestPayload);
    actions.setIsCreatedFromActionItem(!!isActionItemInSelection);
    actions.setPageMode(pageMode);
    rightSidebarContext.open((0, $1L1jV.ISSUE_CREATE_SIDE_PANEL_ID), (0, $1L1jV.ISSUE_CREATE_SIDE_PANEL_WIDTH));
};
const $918fba8df3fbcc13$var$expandSelectionIfActionItemsSelected = ({ activeSelection: activeSelection, pageMode: pageMode, isActionItemInSelection: isActionItemInSelection })=>{
    let updatedSelection = activeSelection;
    let activeSelectionRange = (0, $1Q0l6.getValidRange)(activeSelection?.getRangeAt(0));
    if (isActionItemInSelection && (0, $9wGTI.fg)('confluence-create-work-items-from-action-items')) {
        const updatedActiveSelection = (0, $cSSgB.includeEntireActionItemInSelection)(activeSelection, pageMode);
        if (updatedActiveSelection instanceof Range) {
            updatedSelection = updatedActiveSelection;
            activeSelectionRange = (0, $1Q0l6.getValidRangeForActionItem)(updatedActiveSelection);
        } else activeSelectionRange = activeSelection && 'getRangeAt' in activeSelection ? (0, $1Q0l6.getValidRange)(activeSelection.getRangeAt(0)) : undefined;
    }
    return {
        updatedSelection: updatedSelection,
        activeSelectionRange: activeSelectionRange
    };
};
module.exports["openSingleIssueSidePanelWithSelection"] = $918fba8df3fbcc13$export$41bb5569f66eae2a;

});

parcelRegister("4oXkq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $is1T6 = parcelRequire("is1T6");


var $9DHhW = parcelRequire("9DHhW");


var $fqVYq = parcelRequire("fqVYq");


var $dVKvM = parcelRequire("dVKvM");


var $9wGTI = parcelRequire("9wGTI");


var $7W8i8 = parcelRequire("7W8i8");


var $6mKj3 = parcelRequire("6mKj3");


var $7aRa9 = parcelRequire("7aRa9");


var $lpGuF = parcelRequire("lpGuF");


var $dMbwP = parcelRequire("dMbwP");


var $9ujb2 = parcelRequire("9ujb2");

const $ed7cf63fc877d47c$var$logger = (0, $7W8i8.getLogger)('highlight-action');
const $ed7cf63fc877d47c$var$getHighlightedText = (selection)=>{
    if (!selection || selection.rangeCount === 0) return '';
    return selection.toString().trim();
};
const $ed7cf63fc877d47c$var$i18n = (0, $kSwu1.defineMessages)({
    trelloLabel: {
        id: "highlight-actions.create-trello-card",
        defaultMessage: "Send to your Trello Inbox"
    },
    errorTitle: {
        id: "highlight-actions.trello.create.error",
        defaultMessage: "Couldn't create Trello card. Try again later."
    },
    successTitle: {
        id: "highlight-actions.trello.create.success",
        defaultMessage: "Trello card created"
    },
    openCard: {
        id: "highlight-actions.trello.openCard",
        defaultMessage: "Open card"
    }
});
const $ed7cf63fc877d47c$var$AddToTrelloInboxActionsComponent = ({ activeSelection: activeSelection, completeKey: completeKey, contentId: contentId, flags: flags })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const intl = (0, $kSwu1.useIntl)();
    const { hasTrelloAccess: hasTrelloAccess, loading: trelloAccessLoading } = (0, $9ujb2.useTrelloAccess)();
    const fireTrelloCardCreatedAnalytics = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'confluenceHighlightActionsMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'trelloInboxCard',
                type: 'ui',
                attributes: {
                    contentId: contentId,
                    hasSelection: Boolean(activeSelection && activeSelection.toString().trim())
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        activeSelection
    ]);
    const showCreateErrorFlag = (0, $cozmU.useCallback)(()=>{
        flags.showFlag({
            id: 'trello-inbox-create-error',
            type: 'error',
            title: intl.formatMessage($ed7cf63fc877d47c$var$i18n.errorTitle),
            close: 'auto'
        });
    }, [
        flags,
        intl
    ]);
    const makeHandleCreateTrelloCardClick = (0, $cozmU.useCallback)(async ()=>{
        const highlightedText = $ed7cf63fc877d47c$var$getHighlightedText(activeSelection);
        if (!highlightedText) return;
        try {
            fireTrelloCardCreatedAnalytics();
            const result = await (0, $lpGuF.createTrelloCardHandle)({
                text: highlightedText,
                contentId: contentId
            });
            if (result && result.success) {
                const actions = result.cardUrl ? [
                    {
                        content: intl.formatMessage($ed7cf63fc877d47c$var$i18n.openCard),
                        href: result.cardUrl,
                        target: '_blank'
                    }
                ] : undefined;
                flags.showFlag({
                    id: 'trello-inbox-create-success',
                    type: 'success-circle',
                    title: intl.formatMessage($ed7cf63fc877d47c$var$i18n.successTitle),
                    actions: actions,
                    close: 'auto'
                });
            } else showCreateErrorFlag();
        } catch  {
            $ed7cf63fc877d47c$var$logger.error`Error creating Trello card for contentId=${contentId}`;
            showCreateErrorFlag();
        }
    }, [
        activeSelection,
        contentId,
        fireTrelloCardCreatedAnalytics,
        flags,
        showCreateErrorFlag,
        intl
    ]);
    if (!(0, $9wGTI.fg)('quick_capture_trello_inbox')) return null;
    if (trelloAccessLoading) return null;
    if (!hasTrelloAccess) return null;
    if ((0, $9wGTI.fg)('aifc_create_enabled') || (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_confluence', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        testId: "create-trello-card-button",
        "data-key": completeKey,
        shouldTitleWrap: false,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dMbwP.TrelloInboxIcon), {
            label: intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel),
            size: "small"
        }),
        onClick: makeHandleCreateTrelloCardClick
    }, intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel));
    return (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        testId: "create-trello-card-button",
        "aria-label": intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel),
        "data-key": completeKey,
        shouldTitleWrap: false,
        title: intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dMbwP.TrelloInboxIcon), {
            label: intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel)
        }),
        onClick: makeHandleCreateTrelloCardClick
    }, intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        id: "create-trello-card-button",
        appearance: "subtle",
        iconBefore: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dMbwP.TrelloInboxIcon), {
                label: intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel)
            }),
        "data-key": completeKey,
        testId: "create-trello-card-button",
        onClick: makeHandleCreateTrelloCardClick,
        spacing: "compact"
    }, intl.formatMessage($ed7cf63fc877d47c$var$i18n.trelloLabel));
};
const $ed7cf63fc877d47c$export$12f6e4d1b0812953 = (0, $7aRa9.withFlags)($ed7cf63fc877d47c$var$AddToTrelloInboxActionsComponent);
module.exports["AddToTrelloInboxActions"] = $ed7cf63fc877d47c$export$12f6e4d1b0812953;

});

parcelRegister("lpGuF", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");

const $988c838c2543c991$var$logger = (0, $7W8i8.getLogger)('highlight-action');
const $988c838c2543c991$var$CREATE_TRELLO_CARD_ENDPOINT = '/wiki/api/v2/trello/inbox/card';
const $988c838c2543c991$var$CARD_NAME_MAX_LENGTH = 254;
const $988c838c2543c991$var$HORIZONTAL_ELLIPSIS = "\u2026";
const $988c838c2543c991$var$toPayloadSafeName = (raw, maxLength = $988c838c2543c991$var$CARD_NAME_MAX_LENGTH)=>{
    const normalized = String(raw).replace(/[\r\n\t]+/g, ' ').trim();
    if (normalized.length <= maxLength) return normalized;
    const firstPartLength = Math.max(0, maxLength - $988c838c2543c991$var$HORIZONTAL_ELLIPSIS.length);
    return normalized.substring(0, firstPartLength) + $988c838c2543c991$var$HORIZONTAL_ELLIPSIS;
};
const $988c838c2543c991$export$750e0c983aee1f51 = async ({ text: text, contentId: contentId })=>{
    const payload = {
        name: $988c838c2543c991$var$toPayloadSafeName(text, $988c838c2543c991$var$CARD_NAME_MAX_LENGTH),
        description: text || 'Created via Confluence',
        sourceContentId: contentId,
        sourceUrl: typeof location !== 'undefined' ? location.href : undefined
    };
    try {
        const resp = await fetch($988c838c2543c991$var$CREATE_TRELLO_CARD_ENDPOINT, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify(payload)
        });
        if (!resp.ok) {
            $988c838c2543c991$var$logger.error`Failed to create Trello card for contentId=${contentId} status=${resp.status}`;
            return null;
        }
        const data = await resp.json();
        const idCandidate = data.cardId;
        const urlCandidate = data.cardUrl;
        if (!idCandidate || !urlCandidate) {
            $988c838c2543c991$var$logger.error`Invalid Trello response for contentId=${contentId}`;
            return null;
        }
        const response = {
            cardId: idCandidate || '',
            cardUrl: urlCandidate || '',
            success: true
        };
        return response;
    } catch  {
        $988c838c2543c991$var$logger.error`Error creating Trello card for contentId=${contentId}`;
        return null;
    }
};
module.exports["createTrelloCardHandle"] = $988c838c2543c991$export$750e0c983aee1f51;

});

parcelRegister("dMbwP", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $QJ7O4 = parcelRequire("QJ7O4");

const $aa74cc1d9c17d5e2$export$65b41c6aab3a46a7 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $QJ7O4.default), {
            name: "TrelloInboxIcon",
            dangerouslySetGlyph: "<path fill=\"currentcolor\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.3356 1H2.66436C1.74525 1 1 1.74525 1 2.66436V13.3356C1 14.2548 1.74525 15 2.66436 15H13.3356C14.2548 15 15 14.2548 15 13.3356V2.66436C15 1.74525 14.2548 1 13.3356 1ZM7.0307 11.0836C7.0307 11.3892 6.783 11.6365 6.4777 11.6365H4.13768C3.83203 11.6365 3.58475 11.3888 3.58475 11.0836V4.13768C3.58475 3.83203 3.83245 3.58475 4.13768 3.58475H6.4777C6.7834 3.58475 7.0307 3.83245 7.0307 4.13768V11.0836ZM12.4152 7.8948C12.4152 8.2005 12.1675 8.4477 11.8623 8.4477H9.5223C9.2166 8.4477 8.9693 8.2 8.9693 7.8948V4.13768C8.9693 3.83203 9.217 3.58475 9.5223 3.58475H11.8623C12.168 3.58475 12.4152 3.83245 12.4152 4.13768V7.8948Z\"/>",
            ...props
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $QJ7O4.default), {
        name: "TrelloInboxIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" clip-rule="evenodd" d="M13.3356 1H2.66436C1.74525 1 1 1.74525 1 2.66436V13.3356C1 14.2548 1.74525 15 2.66436 15H13.3356C14.2548 15 15 14.2548 15 13.3356V2.66436C15 1.74525 14.2548 1 13.3356 1ZM7.0307 11.0836C7.0307 11.3892 6.783 11.6365 6.4777 11.6365H4.13768C3.83203 11.6365 3.58475 11.3888 3.58475 11.0836V4.13768C3.58475 3.83203 3.83245 3.58475 4.13768 3.58475H6.4777C6.7834 3.58475 7.0307 3.83245 7.0307 4.13768V11.0836ZM12.4152 7.8948C12.4152 8.2005 12.1675 8.4477 11.8623 8.4477H9.5223C9.2166 8.4477 8.9693 8.2 8.9693 7.8948V4.13768C8.9693 3.83203 9.217 3.58475 9.5223 3.58475H11.8623C12.168 3.58475 12.4152 3.83245 12.4152 4.13768V7.8948Z"/>`,
        ...props
    });
module.exports["TrelloInboxIcon"] = $aa74cc1d9c17d5e2$export$65b41c6aab3a46a7;

});

parcelRegister("9ujb2", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7W8i8 = parcelRequire("7W8i8");

const $26b2f47c8bb8be0c$var$logger = (0, $7W8i8.getLogger)('highlight-action');
const $26b2f47c8bb8be0c$var$TRELLO_HAS_ACCESS_ENDPOINT = '/wiki/api/v2/trello/inbox/has-access';
let $26b2f47c8bb8be0c$var$cachedResult = null;
let $26b2f47c8bb8be0c$var$fetchPromise = null;
function $26b2f47c8bb8be0c$export$66160e11912cf1e6() {
    $26b2f47c8bb8be0c$var$cachedResult = null;
    $26b2f47c8bb8be0c$var$fetchPromise = null;
}
function $26b2f47c8bb8be0c$var$cacheErrorResult() {
    const result = {
        hasTrelloAccess: false,
        loading: false,
        error: true
    };
    $26b2f47c8bb8be0c$var$cachedResult = result;
    return result;
}
function $26b2f47c8bb8be0c$export$52c51aee2d49bb7f() {
    if (!$26b2f47c8bb8be0c$var$fetchPromise) $26b2f47c8bb8be0c$var$fetchPromise = Promise.resolve().then(()=>fetch($26b2f47c8bb8be0c$var$TRELLO_HAS_ACCESS_ENDPOINT, {
            method: 'GET',
            credentials: 'include',
            headers: {
                Accept: 'application/json'
            }
        })).then(async (response)=>{
        if (!response.ok) {
            $26b2f47c8bb8be0c$var$logger.warn`Failed to check Trello access: status=${response.status}`;
            return $26b2f47c8bb8be0c$var$cacheErrorResult();
        }
        const data = await response.json();
        const result = {
            hasTrelloAccess: Boolean(data.hasTrelloAccess),
            loading: false,
            error: false
        };
        $26b2f47c8bb8be0c$var$cachedResult = result;
        return result;
    }).catch((error)=>{
        $26b2f47c8bb8be0c$var$logger.error`Error checking Trello access: ${error}`;
        return $26b2f47c8bb8be0c$var$cacheErrorResult();
    });
    return $26b2f47c8bb8be0c$var$fetchPromise;
}
const $26b2f47c8bb8be0c$export$955874e1badc4683 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const [state, setState] = (0, $cozmU.useState)($26b2f47c8bb8be0c$var$_temp);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            if ($26b2f47c8bb8be0c$var$cachedResult) {
                setState($26b2f47c8bb8be0c$var$cachedResult);
                return;
            }
            let cancelled = false;
            $26b2f47c8bb8be0c$export$52c51aee2d49bb7f().then((result)=>{
                if (!cancelled) setState(result);
            });
            return ()=>{
                cancelled = true;
            };
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return state;
} : ()=>{
    const [state, setState] = (0, $cozmU.useState)(()=>$26b2f47c8bb8be0c$var$cachedResult ?? {
            hasTrelloAccess: false,
            loading: true,
            error: false
        });
    (0, $cozmU.useEffect)(()=>{
        if ($26b2f47c8bb8be0c$var$cachedResult) {
            setState($26b2f47c8bb8be0c$var$cachedResult);
            return;
        }
        let cancelled = false;
        $26b2f47c8bb8be0c$export$52c51aee2d49bb7f().then((result)=>{
            if (!cancelled) setState(result);
        });
        return ()=>{
            cancelled = true;
        };
    }, []);
    return state;
};
function $26b2f47c8bb8be0c$var$_temp() {
    return $26b2f47c8bb8be0c$var$cachedResult ?? {
        hasTrelloAccess: false,
        loading: true,
        error: false
    };
}
module.exports["prefetchTrelloAccess"] = $26b2f47c8bb8be0c$export$52c51aee2d49bb7f;
module.exports["useTrelloAccess"] = $26b2f47c8bb8be0c$export$955874e1badc4683;

});

parcelRegister("lEDve", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $9kbTQ = parcelRequire("9kbTQ");


var $9GVkD = parcelRequire("9GVkD");


var $bR6es = parcelRequire("bR6es");


var $6mKj3 = parcelRequire("6mKj3");


var $id4ij = parcelRequire("id4ij");


var $9wGTI = parcelRequire("9wGTI");


var $bEdUx = parcelRequire("bEdUx");

const $709c5a5818d3675c$var$popupAnimation = null;
const $709c5a5818d3675c$var$popupPanelStyles = null;
const $709c5a5818d3675c$var$popupTransition = null;
const $709c5a5818d3675c$var$buttonContainerStyle = null;
const $709c5a5818d3675c$var$buttonContainerBorderUpdated = null;
const $709c5a5818d3675c$var$toolbarContainerStyle = null;
const $709c5a5818d3675c$var$i18n = (0, $kSwu1.defineMessages)({
    toolbarAlert: {
        id: "highlight-actions.toolbar.alert",
        defaultMessage: "Floating toolbar is available. Press tab to access it"
    }
});
const $709c5a5818d3675c$export$129a32eedafa97c5 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { children: children, top: top, left: left, needTransition: t1, onMouseLeave: onMouseLeave, onMouseEnter: onMouseEnter, updatePosition: updatePosition } = t0;
    const needTransition = t1 === undefined ? true : t1;
    const popupContainerRef = (0, $cozmU.useRef)(null);
    $709c5a5818d3675c$var$useAdjustedTop(updatePosition, popupContainerRef);
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $9wGTI.fg)("aifc_create_enabled") || (0, $6mKj3.expValEquals)("platform_editor_toolbar_aifc_confluence", "isEnabled", true);
        $[0] = t2;
    } else t2 = $[0];
    const isNewToolbarEnabled = t2;
    const popupRef = (0, $cozmU.useRef)(null);
    const popupLeft = $709c5a5818d3675c$var$useAdjustedLeft(left, popupRef);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [];
        $[1] = t3;
    } else t3 = $[1];
    (0, $cozmU.useEffect)($709c5a5818d3675c$var$_temp2, t3);
    let t4;
    if ($[2] !== children || $[3] !== formatMessage || $[4] !== needTransition || $[5] !== onMouseEnter || $[6] !== onMouseLeave || $[7] !== popupLeft || $[8] !== top) {
        const portalContainer_0 = document.getElementById((0, $bEdUx.popupPortalContainerId));
        let t5;
        if ($[10] !== onMouseEnter || $[11] !== onMouseLeave) {
            t5 = onMouseEnter && onMouseLeave && {
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave
            };
            $[10] = onMouseEnter;
            $[11] = onMouseLeave;
            $[12] = t5;
        } else t5 = $[12];
        const mouseMoveHandlers = t5;
        t4 = portalContainer_0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(/*#__PURE__*/ $cozmU.createElement("div", {
            ref: popupContainerRef,
            style: {
                top: top
            },
            ...mouseMoveHandlers,
            className: (0, $hekY6.default)([
                "_y44vlq9g _kqswstnw",
                needTransition && "_v564zagr"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), {
            id: "toolbar-alert"
        }, formatMessage($709c5a5818d3675c$var$i18n.toolbarAlert)), isNewToolbarEnabled ? /*#__PURE__*/ $cozmU.createElement("div", {
            ref: popupRef,
            style: {
                left: `${popupLeft || 0}px`
            },
            "data-testid": "highlightActionsPopup",
            id: "highlightActionsPopup",
            className: (0, $hekY6.default)([
                "_t9ecm79d _kqswstnw _154iidpf"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $bR6es.Toolbar), {
            label: "Renderer toolbar"
        }, children)) : /*#__PURE__*/ $cozmU.createElement("div", {
            ref: popupRef,
            style: {
                left: `${popupLeft || 0}px`
            },
            "data-testid": "highlightActionsPopup",
            id: "highlightActionsPopup",
            className: (0, $hekY6.default)([
                "_2rkofajl _t9ecm79d _16qs130s _kqswstnw _154iidpf _bfhk1bhr _1e0c1txw",
                (0, $9wGTI.fg)("confluence_comment_border_migration") && "_2rko12b0"
            ])
        }, children)), portalContainer_0) : null;
        $[2] = children;
        $[3] = formatMessage;
        $[4] = needTransition;
        $[5] = onMouseEnter;
        $[6] = onMouseLeave;
        $[7] = popupLeft;
        $[8] = top;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ({ children: children, top: top, left: left, needTransition: needTransition = true, onMouseLeave: onMouseLeave, onMouseEnter: onMouseEnter, updatePosition: updatePosition })=>{
    const popupContainerRef = (0, $cozmU.useRef)(null);
    $709c5a5818d3675c$var$useAdjustedTop(updatePosition, popupContainerRef);
    const isNewToolbarEnabled = (0, $9wGTI.fg)('aifc_create_enabled') || (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_confluence', 'isEnabled', true);
    const popupRef = (0, $cozmU.useRef)(null);
    const popupLeft = $709c5a5818d3675c$var$useAdjustedLeft(left, popupRef);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        const portalContainer = document.getElementById((0, $bEdUx.popupPortalContainerId));
        if (!portalContainer) return;
        const screenreaderCb = (_mutationsList, observer)=>{
            //These accessibility attributes are added dynamically here rather than directly on the VisuallyHidden element because it did not get read by the NVDA screenreader properly on Firefox. This is due to the screenreader sometimes only reading content when there has been a dynamic change to an element
            const accessibleDiv = document.getElementById('toolbar-alert');
            if (accessibleDiv instanceof HTMLElement) {
                accessibleDiv?.setAttribute('role', 'alert');
                accessibleDiv?.setAttribute('aria-live', 'polite');
                observer.disconnect();
            }
        };
        const observer_0 = new MutationObserver(screenreaderCb);
        observer_0.observe(portalContainer, {
            childList: true,
            subtree: true
        });
        return ()=>{
            observer_0.disconnect();
        };
    }, []); // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const portalContainer_0 = document.getElementById((0, $bEdUx.popupPortalContainerId));
    const mouseMoveHandlers = onMouseEnter && onMouseLeave && {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    };
    return portalContainer_0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(/*#__PURE__*/ $cozmU.createElement("div", {
        ref: popupContainerRef,
        style: {
            top: top
        },
        ...mouseMoveHandlers,
        className: (0, $hekY6.default)([
            "_y44vlq9g _kqswstnw",
            needTransition && "_v564zagr"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), {
        id: "toolbar-alert"
    }, formatMessage($709c5a5818d3675c$var$i18n.toolbarAlert)), isNewToolbarEnabled ? /*#__PURE__*/ $cozmU.createElement("div", {
        ref: popupRef,
        style: {
            left: `${popupLeft || 0}px`
        },
        "data-testid": "highlightActionsPopup",
        id: "highlightActionsPopup",
        className: (0, $hekY6.default)([
            "_t9ecm79d _kqswstnw _154iidpf"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $bR6es.Toolbar), {
        label: "Renderer toolbar"
    }, children)) : /*#__PURE__*/ $cozmU.createElement("div", {
        ref: popupRef,
        style: {
            left: `${popupLeft || 0}px`
        },
        "data-testid": "highlightActionsPopup",
        id: "highlightActionsPopup",
        className: (0, $hekY6.default)([
            "_2rkofajl _t9ecm79d _16qs130s _kqswstnw _154iidpf _bfhk1bhr _1e0c1txw",
            (0, $9wGTI.fg)('confluence_comment_border_migration') && "_2rko12b0"
        ])
    }, children)), portalContainer_0) : null;
};
const $709c5a5818d3675c$var$useAdjustedLeft = (0, $3u0dr.isReactCompilerActiveV2)() ? function useAdjustedLeft(left, popupRef) {
    const $ = (0, $bDgLe.c)(4);
    const [adjustedLeft, setAdjustedLeft] = (0, $cozmU.useState)(left);
    const [adjustedLeftOrigin, setAdjustedLeftOrigin] = (0, $cozmU.useState)(left);
    let t0;
    let t1;
    if ($[0] !== left || $[1] !== popupRef) {
        t0 = ()=>{
            if (!popupRef.current) return;
            const { left: elementLeft, right: right } = (0, $id4ij.getElementBounds)(popupRef.current);
            const windowWidth = window.innerWidth;
            let containerBounds = {
                left: 0,
                right: windowWidth
            };
            const nav4ContentContainer = document.getElementById("AkMainContent");
            if (nav4ContentContainer) containerBounds = (0, $id4ij.getElementBounds)(nav4ContentContainer);
            if (elementLeft < containerBounds.left) setAdjustedLeft(left + (containerBounds.left - elementLeft) + 20);
            else if (right > containerBounds.right) setAdjustedLeft(left - (right - containerBounds.right) - 20);
            else setAdjustedLeft(left);
            setAdjustedLeftOrigin(left);
        };
        t1 = [
            left,
            popupRef
        ];
        $[0] = left;
        $[1] = popupRef;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useLayoutEffect)(t0, t1);
    return adjustedLeftOrigin === left ? adjustedLeft : left;
} : function useAdjustedLeft(left, popupRef) {
    const WINDOW_PADDING = 20;
    const [adjustedLeft, setAdjustedLeft] = (0, $cozmU.useState)(left);
    const [adjustedLeftOrigin, setAdjustedLeftOrigin] = (0, $cozmU.useState)(left);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!popupRef.current) return;
        const { left: elementLeft, right: right } = (0, $id4ij.getElementBounds)(popupRef.current);
        const windowWidth = window.innerWidth;
        let containerBounds = {
            left: 0,
            right: windowWidth
        }; // When nav4 container doesn't exist, the window is the container
        const nav4ContentContainer = document.getElementById('AkMainContent');
        if (nav4ContentContainer) containerBounds = (0, $id4ij.getElementBounds)(nav4ContentContainer);
         // WS-1703 - If the popup menu is off either side of the screen or outside of the scrollable content area
        // set it so it's inside the WINDOW_PADDING
        if (elementLeft < containerBounds.left) setAdjustedLeft(left + (containerBounds.left - elementLeft) + WINDOW_PADDING);
        else if (right > containerBounds.right) setAdjustedLeft(left - (right - containerBounds.right) - WINDOW_PADDING);
        else setAdjustedLeft(left);
        setAdjustedLeftOrigin(left);
    }, [
        left,
        popupRef
    ]); // Only use the adjustedLeft if it was calculated relative to the current left prop
    return adjustedLeftOrigin === left ? adjustedLeft : left;
};
/**
 * `popupPortalContainerId` is after the ADF renderer in the HTML DOM.
 * Consequently, when there is vertical layout shift before `popupPortalContainerId` such as in the ADF renderer, the `Popup` will automatically shift away from the selected range.
 * This automatic shift is undesirable and `useAdjustedTop` is attempting to undo it in a way as imperceptible to the user as possible.
 *
 * Inspired by {@link https://floating-ui.com/} which is "The Future of Popper". Both Popper and Floating UI are used by Design System to deal with popups including to reposition them.
 */ const $709c5a5818d3675c$var$useAdjustedTop = (0, $3u0dr.isReactCompilerActiveV2)() ? function useAdjustedTop(updatePosition, popupContainerRef) {
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = document.getElementById((0, $bEdUx.popupPortalContainerId));
        $[0] = t0;
    } else t0 = $[0];
    const portalContainer = t0;
    let t1;
    let t2;
    if ($[1] !== popupContainerRef || $[2] !== updatePosition) {
        t1 = ()=>{
            if (!portalContainer || !updatePosition || !("ResizeObserver" in window)) return;
            const { parentElement: parentElement } = portalContainer;
            if (!parentElement) return;
            const observer = new ResizeObserver(()=>{
                if (!popupContainerRef.current) return;
                const newPosition = updatePosition();
                if (!newPosition) return;
                const { style: style } = popupContainerRef.current;
                const newTop = `${newPosition.top}px`;
                if (style.top !== newTop) {
                    style.transition = "none";
                    style.top = newTop;
                }
            });
            observer.observe(parentElement);
            return ()=>{
                observer.disconnect();
            };
        };
        t2 = [
            popupContainerRef,
            portalContainer,
            updatePosition
        ];
        $[1] = popupContainerRef;
        $[2] = updatePosition;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
} : function useAdjustedTop(updatePosition, popupContainerRef) {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const portalContainer = document.getElementById((0, $bEdUx.popupPortalContainerId));
    (0, $cozmU.useEffect)(()=>{
        if (!portalContainer || !updatePosition || !('ResizeObserver' in window)) return; // The position of `popupPortalContainerId` relative to the selected range will change when the parent element of `popupPortalContainerId` is resized.
        const { parentElement: parentElement } = portalContainer;
        if (!parentElement) return;
        const observer = new ResizeObserver(()=>{
            if (!popupContainerRef.current) return;
            const newPosition = updatePosition();
            if (!newPosition) return;
            const { style: style } = popupContainerRef.current;
            const newTop = `${newPosition.top}px`;
            if (style.top !== newTop) {
                // `popupPortalContainerId` moved and automatically shifted `popupContainerRef` away from the selected range.
                // This automatic shift is undesirable and here we're attempting to undo it in a way as imperceptible to the user as possible.
                // Imperceptible here means that a transition animation cannot be used.
                style.transition = 'none';
                style.top = newTop;
            }
        });
        observer.observe(parentElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        popupContainerRef,
        portalContainer,
        updatePosition
    ]);
};
function $709c5a5818d3675c$var$_temp(_mutationsList, observer) {
    const accessibleDiv = document.getElementById("toolbar-alert");
    if (accessibleDiv instanceof HTMLElement) {
        accessibleDiv?.setAttribute("role", "alert");
        accessibleDiv?.setAttribute("aria-live", "polite");
        observer.disconnect();
    }
}
function $709c5a5818d3675c$var$_temp2() {
    const portalContainer = document.getElementById((0, $bEdUx.popupPortalContainerId));
    if (!portalContainer) return;
    const screenreaderCb = $709c5a5818d3675c$var$_temp;
    const observer_0 = new MutationObserver(screenreaderCb);
    observer_0.observe(portalContainer, {
        childList: true,
        subtree: true
    });
    return ()=>{
        observer_0.disconnect();
    };
}
module.exports["Popup"] = $709c5a5818d3675c$export$129a32eedafa97c5;

});

parcelRegister("bR6es", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $b2jdX = parcelRequire("b2jdX");


var $gMrzi = parcelRequire("gMrzi");


var $jEaFE = parcelRequire("jEaFE");


var $2Wuyj = parcelRequire("2Wuyj");

const $726c97f63f4e2017$var$styles = {
    toolbarBase: "_2rko1qi0 _zulp1b66 _1e0c1txw _4cvr1h6o",
    toolbar: "_bfhk1bhr _4t3i14no _u5f31b66 _19bv1b66 _16qs130s",
    toolbarResponsive: "_195gpxbi",
    primaryToolbar: "_bfhkvuon _1tkezwfg",
    toolbarSeparator: "_1mj714no",
    hiddenSelectors: "_fy9oglyw _18shglyw _ze7rglyw",
    hiddenSelectorsPatch: "_z5m7glyw"
};
const $726c97f63f4e2017$export$4c260019440d418f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { children: children, label: label, actionSubjectId: actionSubjectId, testId: testId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $w6R6I.cx)($726c97f63f4e2017$var$styles.toolbarBase, $726c97f63f4e2017$var$styles.toolbar, $726c97f63f4e2017$var$styles.toolbarResponsive, $726c97f63f4e2017$var$styles.hiddenSelectors, $726c97f63f4e2017$var$styles.toolbarSeparator, $726c97f63f4e2017$var$styles.hiddenSelectorsPatch);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== actionSubjectId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Wuyj.ViewEventEmitter), {
            actionSubject: (0, $2Wuyj.ACTION_SUBJECT).TOOLBAR,
            actionSubjectId: actionSubjectId
        });
        $[1] = actionSubjectId;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== children || $[4] !== label || $[5] !== t2 || $[6] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: t1,
            "aria-label": label,
            testId: testId,
            "data-toolbar-type": "inline"
        }, t2, children);
        $[3] = children;
        $[4] = label;
        $[5] = t2;
        $[6] = testId;
        $[7] = t3;
    } else t3 = $[7];
    const toolbar = t3;
    let wrappedToolbar = toolbar;
    const { keyboardNavigation: keyboardNavigation } = (0, $b2jdX.useToolbarUI)();
    if (keyboardNavigation) {
        const { childComponentSelector: childComponentSelector, dom: dom, handleEscape: handleEscape, handleFocus: handleFocus, isShortcutToFocusToolbar: isShortcutToFocusToolbar, ariaControls: ariaControls, ariaLabel: ariaLabel } = keyboardNavigation;
        let t4;
        if ($[8] !== ariaControls || $[9] !== ariaLabel || $[10] !== childComponentSelector || $[11] !== dom || $[12] !== handleEscape || $[13] !== handleFocus || $[14] !== isShortcutToFocusToolbar || $[15] !== toolbar) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jEaFE.ToolbarKeyboardNavigationProvider), {
                childComponentSelector: childComponentSelector,
                dom: dom,
                isShortcutToFocusToolbar: isShortcutToFocusToolbar,
                handleEscape: handleEscape,
                handleFocus: handleFocus,
                ariaControls: ariaControls,
                ariaLabel: ariaLabel
            }, toolbar);
            $[8] = ariaControls;
            $[9] = ariaLabel;
            $[10] = childComponentSelector;
            $[11] = dom;
            $[12] = handleEscape;
            $[13] = handleFocus;
            $[14] = isShortcutToFocusToolbar;
            $[15] = toolbar;
            $[16] = t4;
        } else t4 = $[16];
        wrappedToolbar = t4;
    }
    let t4;
    if ($[17] !== wrappedToolbar) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMrzi.ResponsiveWrapper), null, wrappedToolbar);
        $[17] = wrappedToolbar;
        $[18] = t4;
    } else t4 = $[18];
    return t4;
} : ({ children: children, label: label, actionSubjectId: actionSubjectId, testId: testId })=>{
    const toolbar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($726c97f63f4e2017$var$styles.toolbarBase, $726c97f63f4e2017$var$styles.toolbar, $726c97f63f4e2017$var$styles.toolbarResponsive, $726c97f63f4e2017$var$styles.hiddenSelectors, $726c97f63f4e2017$var$styles.toolbarSeparator, $726c97f63f4e2017$var$styles.hiddenSelectorsPatch),
        "aria-label": label,
        testId: testId,
        "data-toolbar-type": "inline"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Wuyj.ViewEventEmitter), {
        actionSubject: (0, $2Wuyj.ACTION_SUBJECT).TOOLBAR,
        actionSubjectId: actionSubjectId
    }), children);
    let wrappedToolbar = toolbar;
    const { keyboardNavigation: keyboardNavigation } = (0, $b2jdX.useToolbarUI)();
    if (keyboardNavigation) {
        const { childComponentSelector: childComponentSelector, dom: dom, handleEscape: handleEscape, handleFocus: handleFocus, isShortcutToFocusToolbar: isShortcutToFocusToolbar, ariaControls: ariaControls, ariaLabel: ariaLabel } = keyboardNavigation;
        wrappedToolbar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jEaFE.ToolbarKeyboardNavigationProvider), {
            childComponentSelector: childComponentSelector,
            dom: dom,
            isShortcutToFocusToolbar: isShortcutToFocusToolbar,
            handleEscape: handleEscape,
            handleFocus: handleFocus,
            ariaControls: ariaControls,
            ariaLabel: ariaLabel
        }, toolbar);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMrzi.ResponsiveWrapper), null, wrappedToolbar);
};
const $726c97f63f4e2017$export$7469f9986edfc2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, label: label, breakpointPreset: breakpointPreset } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $w6R6I.cx)($726c97f63f4e2017$var$styles.toolbarBase, $726c97f63f4e2017$var$styles.primaryToolbar, $726c97f63f4e2017$var$styles.hiddenSelectors);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== label) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: t1,
            "aria-label": label,
            "data-toolbar-type": "primary"
        }, children);
        $[1] = children;
        $[2] = label;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== breakpointPreset || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMrzi.ResponsiveContainer), {
            breakpointPreset: breakpointPreset
        }, t2);
        $[4] = breakpointPreset;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ children: children, label: label, breakpointPreset: breakpointPreset })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMrzi.ResponsiveContainer), {
        breakpointPreset: breakpointPreset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($726c97f63f4e2017$var$styles.toolbarBase, $726c97f63f4e2017$var$styles.primaryToolbar, $726c97f63f4e2017$var$styles.hiddenSelectors),
        "aria-label": label,
        "data-toolbar-type": "primary"
    }, children));
};
module.exports["Toolbar"] = $726c97f63f4e2017$export$4c260019440d418f;
module.exports["PrimaryToolbar"] = $726c97f63f4e2017$export$7469f9986edfc2;

});

parcelRegister("gMrzi", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");

const $a746760df070e426$var$styles = {
    responsiveContainer: "_1bsb1osq _7cca15wb _1f38ptqj _1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _1ir3glyw _1vp2glyw _1eadglyw _a6zzglyw",
    responsiveContainerFullPage: "_1bsb1ns9 _1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _1ir3glyw _1vp2glyw _1eadglyw _a6zzglyw",
    fullpage: "_luoiglyw _2ojp1ule _11uvglyw _fj2k1ule _1nqyglyw _jd611ule _syrzglyw _fr6v1ule _1je21ule _1btx1ule _biad1ule _1ana1ule",
    fullpageUpdated: "_1nfkglyw _wne21ule _aw2dglyw _1gtx1ule _11uvglyw _fj2k1ule _1nqyglyw _jd611ule _1mri1ule _17b71ule _1btx1ule _gbo31ule",
    reduced: "_kkyiglyw _1dj81ule _1cg81ule _j3qgglyw _xh1i1ule _oj3l1ule _13s9glyw _4nul1ule _wt211ule _tzm6glyw _ktne1ule _87bn1ule",
    jiraIssue: "_152xglyw _1cn41ule _4cj71ule _afriglyw _ozjb1ule _w81r1ule _1mckglyw _r2nv1ule _1ym01ule _tzm6glyw _ktne1ule _87bn1ule",
    jiraIssueUpdated: "_152xglyw _1cn41ule _1j4d1ule _1n52glyw _1nd71ule _lf431ule _103bglyw _1p0z1ule _g5yu1ule _tzm6glyw _ktne1ule _87bn1ule",
    jsmComment: "_s2iiglyw _o4331ule _1jvu1ule _lankglyw _1xpy1ule _1vu31ule _1b07glyw _1meg1ule _1bqk1ule _tzm6glyw _ktne1ule _87bn1ule",
    jsmCommentUpdated: "_s2iiglyw _o4331ule _1u301ule _u7j1glyw _c7al1ule _14ob1ule _1b07glyw _1meg1ule _1bqk1ule _tzm6glyw _ktne1ule _87bn1ule",
    confluenceComment: "_15nrglyw _cm5a1ule _7qjy1ule _13ioglyw _8urt1ule _cpaf1ule _18zmglyw _1uj01ule _1oqh1ule _tzm6glyw _ktne1ule _87bn1ule",
    responsiveRulesWrapper: "_1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _33p2glyw _1dre1ule _u47mglyw _rut51ule _fj5dglyw _5wt61ule _hmx4glyw _1rrm1ule _ut18glyw _1nwo1ule _19fzglyw _1r831ule"
};
const $a746760df070e426$var$presetStyleMap = {
    fullpage: $a746760df070e426$var$styles.fullpage,
    reduced: $a746760df070e426$var$styles.reduced,
    'jira-issue': $a746760df070e426$var$styles.jiraIssue,
    'jsm-comment': $a746760df070e426$var$styles.jsmComment,
    'confluence-comment': $a746760df070e426$var$styles.confluenceComment
};
const $a746760df070e426$var$updatedPresetStyleMap = {
    fullpage: $a746760df070e426$var$styles.fullpageUpdated,
    'jira-issue': $a746760df070e426$var$styles.jiraIssueUpdated,
    'jsm-comment': $a746760df070e426$var$styles.jsmCommentUpdated
};
const $a746760df070e426$export$e60a4704009a0009 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, breakpointPreset: breakpointPreset } = t0;
    let t1;
    bb0: {
        if (breakpointPreset === "fullpage") {
            t1 = (0, $anBbz.expValEqualsNoExposure)("platform_editor_ai_improve_formatting_toolbar", "isEnabled", true);
            break bb0;
        }
        t1 = (0, $ieeJu.expValEquals)("platform_editor_toolbar_update_jira_config", "isEnabled", true) && breakpointPreset in $a746760df070e426$var$updatedPresetStyleMap;
    }
    const isUpdatedConfig = t1;
    const t2 = breakpointPreset === "fullpage" ? $a746760df070e426$var$styles.responsiveContainerFullPage : $a746760df070e426$var$styles.responsiveContainer;
    const t3 = isUpdatedConfig ? $a746760df070e426$var$updatedPresetStyleMap[breakpointPreset] : $a746760df070e426$var$presetStyleMap[breakpointPreset];
    let t4;
    if ($[0] !== t2 || $[1] !== t3) {
        t4 = (0, $w6R6I.cx)(t2, t3);
        $[0] = t2;
        $[1] = t3;
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== children || $[4] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: t4
        }, children);
        $[3] = children;
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    return t5;
} : ({ children: children, breakpointPreset: breakpointPreset })=>{
    const isUpdatedConfig = (()=>{
        if (breakpointPreset === 'fullpage') return (0, $anBbz.expValEqualsNoExposure)('platform_editor_ai_improve_formatting_toolbar', 'isEnabled', true);
        return (0, $ieeJu.expValEquals)('platform_editor_toolbar_update_jira_config', 'isEnabled', true) && breakpointPreset in $a746760df070e426$var$updatedPresetStyleMap;
    })();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)(breakpointPreset === 'fullpage' ? $a746760df070e426$var$styles.responsiveContainerFullPage : $a746760df070e426$var$styles.responsiveContainer, isUpdatedConfig ? $a746760df070e426$var$updatedPresetStyleMap[breakpointPreset] : $a746760df070e426$var$presetStyleMap[breakpointPreset])
    }, children);
}; /**
    * A wrapper that supports responsiveness with media queries. It needs to used together with Show component
    */ 
const $a746760df070e426$export$fa6e408d6a7d6214 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $a746760df070e426$var$styles.responsiveRulesWrapper
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $a746760df070e426$var$styles.responsiveRulesWrapper
    }, children);
};
module.exports["ResponsiveContainer"] = $a746760df070e426$export$e60a4704009a0009;
module.exports["ResponsiveWrapper"] = $a746760df070e426$export$fa6e408d6a7d6214;

});

parcelRegister("jEaFE", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $haNN4 = parcelRequire("haNN4");

const $3dd4b47fb9e5cae4$export$881345eb2554ea9e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { children: children, childComponentSelector: childComponentSelector, dom: dom, isShortcutToFocusToolbar: isShortcutToFocusToolbar, handleFocus: handleFocus, handleEscape: handleEscape, ariaLabel: ariaLabel, ariaControls: ariaControls } = t0;
    const wrapperRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== childComponentSelector || $[1] !== dom || $[2] !== handleEscape || $[3] !== handleFocus || $[4] !== isShortcutToFocusToolbar) {
        t1 = ()=>{
            if (!wrapperRef.current) return;
            const { current: element } = wrapperRef;
            const getFocusableElements = ()=>{
                if (!element) return [];
                const focusableSelectors = [
                    "button:not([disabled])",
                    "[role=\"button\"]:not([disabled])",
                    "[tabindex]:not([tabindex=\"-1\"])"
                ].join(",");
                const allFocusable = Array.from(element.querySelectorAll(focusableSelectors));
                return allFocusable.filter((el)=>{
                    if (!el.closest(`${childComponentSelector}`)) return false;
                    let currentEl = el;
                    while(currentEl && currentEl !== element){
                        const computedStyle = window.getComputedStyle(currentEl);
                        if (computedStyle.display === "none" || computedStyle.visibility === "hidden") return false;
                        currentEl = currentEl.parentElement;
                    }
                    return true;
                });
            };
            const moveFocus = (direction)=>{
                const focusableElements = getFocusableElements();
                if (focusableElements.length === 0) return;
                const doc = (0, $haNN4.getDocument)();
                const currentIndex = focusableElements.findIndex((el_0)=>el_0 === doc?.activeElement);
                let nextIndex;
                if (currentIndex === -1) nextIndex = 0;
                else if (direction === "right") nextIndex = (currentIndex + 1) % focusableElements.length;
                else nextIndex = currentIndex === 0 ? focusableElements.length - 1 : currentIndex - 1;
                focusableElements[nextIndex]?.focus();
            };
            const handleTab = ()=>{
                const focusableElements_0 = getFocusableElements();
                if (focusableElements_0.length === 0) return;
                const doc_0 = (0, $haNN4.getDocument)();
                let index = doc_0?.activeElement ? focusableElements_0.findIndex((el_1)=>el_1 === doc_0?.activeElement) : 0;
                if (index < 0) index = 0;
                focusableElements_0.forEach($3dd4b47fb9e5cae4$var$_temp);
                focusableElements_0[index].setAttribute("tabindex", "0");
            };
            const handleKeyDown = (event)=>{
                const targetElement = event.target;
                if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
                bb86: switch(event.key){
                    case "Escape":
                        handleEscape(event);
                        break bb86;
                    case "ArrowLeft":
                        event.preventDefault();
                        moveFocus("left");
                        break bb86;
                    case "ArrowRight":
                        event.preventDefault();
                        moveFocus("right");
                        break bb86;
                    case "Tab":
                        handleTab();
                        break bb86;
                    default:
                }
            };
            const globalKeyDownHandler = (event_0)=>{
                if (isShortcutToFocusToolbar && isShortcutToFocusToolbar(event_0)) handleFocus(event_0);
            };
            element?.addEventListener("keydown", handleKeyDown);
            dom?.addEventListener("keydown", globalKeyDownHandler);
            return ()=>{
                element?.removeEventListener("keydown", handleKeyDown);
                dom?.removeEventListener("keydown", globalKeyDownHandler);
            };
        };
        t2 = [
            wrapperRef,
            childComponentSelector,
            dom,
            isShortcutToFocusToolbar,
            handleFocus,
            handleEscape
        ];
        $[0] = childComponentSelector;
        $[1] = dom;
        $[2] = handleEscape;
        $[3] = handleFocus;
        $[4] = isShortcutToFocusToolbar;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    if ($[7] !== ariaControls || $[8] !== ariaLabel || $[9] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: "custom-key-handler-wrapper",
            ref: wrapperRef,
            role: "toolbar",
            "aria-label": ariaLabel,
            "aria-controls": ariaControls
        }, children);
        $[7] = ariaControls;
        $[8] = ariaLabel;
        $[9] = children;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ children: children, childComponentSelector: childComponentSelector, dom: dom, isShortcutToFocusToolbar: isShortcutToFocusToolbar, handleFocus: handleFocus, handleEscape: handleEscape, ariaLabel: ariaLabel, ariaControls: ariaControls })=>{
    const wrapperRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!wrapperRef.current) return;
        const { current: element } = wrapperRef;
        const getFocusableElements = ()=>{
            if (!element) return [];
            // Find all focusable elements within the toolbar that match the child component selector
            const focusableSelectors = [
                'button:not([disabled])',
                '[role="button"]:not([disabled])',
                '[tabindex]:not([tabindex="-1"])'
            ].join(',');
            const allFocusable = Array.from(element.querySelectorAll(focusableSelectors));
            // Filter to only include elements that are:
            // 1. Within the child component selector
            // 2. Visible (not hidden by display:none on itself or any parent)
            return allFocusable.filter((el)=>{
                if (!el.closest(`${childComponentSelector}`)) return false;
                // Check if the element or any of its parents have display: none
                let currentEl = el;
                while(currentEl && currentEl !== element){
                    const computedStyle = window.getComputedStyle(currentEl);
                    if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden') return false;
                    currentEl = currentEl.parentElement;
                }
                return true;
            });
        };
        const moveFocus = (direction)=>{
            const focusableElements = getFocusableElements();
            if (focusableElements.length === 0) return;
            const doc = (0, $haNN4.getDocument)();
            const currentIndex = focusableElements.findIndex((el_0)=>el_0 === doc?.activeElement);
            let nextIndex;
            if (currentIndex === -1) // No element currently focused, focus the first one
            nextIndex = 0;
            else if (direction === 'right') // Move right, wrap to beginning if at end
            nextIndex = (currentIndex + 1) % focusableElements.length;
            else // Move left, wrap to end if at beginning
            nextIndex = currentIndex === 0 ? focusableElements.length - 1 : currentIndex - 1;
            focusableElements[nextIndex]?.focus();
        };
        const handleTab = ()=>{
            const focusableElements_0 = getFocusableElements();
            if (focusableElements_0.length === 0) return;
            const doc_0 = (0, $haNN4.getDocument)();
            let index = doc_0?.activeElement ? focusableElements_0.findIndex((el_1)=>el_1 === doc_0?.activeElement) : 0;
            if (index < 0) index = 0;
            focusableElements_0.forEach((el_2)=>el_2.setAttribute('tabindex', '-1'));
            focusableElements_0[index].setAttribute('tabindex', '0');
        };
        const handleKeyDown = (event)=>{
            const targetElement = event.target;
            if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
            switch(event.key){
                case 'Escape':
                    handleEscape(event);
                    break;
                case 'ArrowLeft':
                    event.preventDefault();
                    moveFocus('left');
                    break;
                case 'ArrowRight':
                    event.preventDefault();
                    moveFocus('right');
                    break;
                case 'Tab':
                    handleTab();
                    break;
                default:
            }
        };
        const globalKeyDownHandler = (event_0)=>{
            if (isShortcutToFocusToolbar && isShortcutToFocusToolbar(event_0)) handleFocus(event_0);
        };
        // ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleKeyDown);
        // ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        dom?.addEventListener('keydown', globalKeyDownHandler);
        return ()=>{
            // ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleKeyDown);
            // ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            dom?.removeEventListener('keydown', globalKeyDownHandler);
        };
    }, [
        wrapperRef,
        childComponentSelector,
        dom,
        isShortcutToFocusToolbar,
        handleFocus,
        handleEscape
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- ignored via go/DSP-18766
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        role: "toolbar",
        "aria-label": ariaLabel,
        "aria-controls": ariaControls
    }, children);
};
function $3dd4b47fb9e5cae4$var$_temp(el_2) {
    return el_2.setAttribute("tabindex", "-1");
}
module.exports["ToolbarKeyboardNavigationProvider"] = $3dd4b47fb9e5cae4$export$881345eb2554ea9e;

});

parcelRegister("2Wuyj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $b2jdX = parcelRequire("b2jdX");

const $171e330111381e98$export$7525482b5931e326 = {
    TOOLBAR: 'toolbar',
    TOOLBAR_DROPDOWN_MENU: 'toolbarDropdownMenu'
};
const $171e330111381e98$export$58d0f383acf77599 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { actionSubjectId: actionSubjectId, actionSubject: actionSubject } = t0;
    const isMountedRef = (0, $cozmU.useRef)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $b2jdX.useToolbarUI)();
    let t1;
    let t2;
    if ($[0] !== actionSubject || $[1] !== actionSubjectId || $[2] !== fireAnalyticsEvent) {
        t1 = ()=>{
            if (isMountedRef.current) return;
            isMountedRef.current = true;
            const payload = {
                action: "viewed",
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                eventType: "ui"
            };
            fireAnalyticsEvent && fireAnalyticsEvent(payload);
        };
        t2 = [
            actionSubjectId,
            actionSubject,
            fireAnalyticsEvent
        ];
        $[0] = actionSubject;
        $[1] = actionSubjectId;
        $[2] = fireAnalyticsEvent;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
} : ({ actionSubjectId: actionSubjectId, actionSubject: actionSubject })=>{
    const isMountedRef = (0, $cozmU.useRef)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $b2jdX.useToolbarUI)();
    (0, $cozmU.useEffect)(()=>{
        if (isMountedRef.current) return;
        isMountedRef.current = true;
        const payload = {
            action: 'viewed',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            eventType: 'ui'
        };
        fireAnalyticsEvent && fireAnalyticsEvent(payload);
    }, [
        actionSubjectId,
        actionSubject,
        fireAnalyticsEvent
    ]);
    return null;
};
module.exports["ACTION_SUBJECT"] = $171e330111381e98$export$7525482b5931e326;
module.exports["ViewEventEmitter"] = $171e330111381e98$export$58d0f383acf77599;

});

parcelRegister("bEdUx", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $1LXnB = parcelRequire("1LXnB");


var $9wGTI = parcelRequire("9wGTI");


var $e4o8D = parcelRequire("e4o8D");

const $cef29f59925fac19$var$baseStyles = null; // This z-index value is higher than the sticky table header
const $cef29f59925fac19$var$zIndex11Styles = null; // This z-index value is higher than the content header
const $cef29f59925fac19$var$zIndex13Styles = null;
const $cef29f59925fac19$export$873f34bfb1875202 = 'highlight-actions-portal-container';
let $cef29f59925fac19$var$popupPortalContainerWidth;
function $cef29f59925fac19$var$onResize(width) {
    // Hide popup when the container is resized.
    if (width !== $cef29f59925fac19$var$popupPortalContainerWidth) {
        $cef29f59925fac19$var$popupPortalContainerWidth = width;
        window.dispatchEvent(new CustomEvent('highlight-actions.container.resized'));
    }
}
const $cef29f59925fac19$export$8b383aca014c1850 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement("div", {
            id: $cef29f59925fac19$export$873f34bfb1875202,
            className: (0, $hekY6.default)([
                "_1reoewfl _18m9ewfl _kqswh2mm",
                (0, $9wGTI.fg)("confluence_highlight_actions_zindex_fix") ? "_1pbyibnn" : "_1pbyilow"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $1LXnB.default), {
            setWidth: $cef29f59925fac19$var$onResize
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        id: $cef29f59925fac19$export$873f34bfb1875202,
        className: (0, $hekY6.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm",
            (0, $9wGTI.fg)('confluence_highlight_actions_zindex_fix') ? "_1pbyibnn" : "_1pbyilow"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $1LXnB.default), {
        setWidth: $cef29f59925fac19$var$onResize
    }));
}; // Only renders the Highlight Actions Provider if we're using Nav4
const $cef29f59925fac19$export$68a992a5cacaa78b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    if (renderServerPlaceholder) return null;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement($cef29f59925fac19$export$8b383aca014c1850, null);
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)(); // render null for first render during hydration to prevent mismatch
    if (renderServerPlaceholder) return null;
    return /*#__PURE__*/ $cozmU.createElement($cef29f59925fac19$export$8b383aca014c1850, null);
};
module.exports["popupPortalContainerId"] = $cef29f59925fac19$export$873f34bfb1875202;
module.exports["HighlightActionsProviderForNav4"] = $cef29f59925fac19$export$68a992a5cacaa78b;

});

parcelRegister("1LXnB", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $69NJe = parcelRequire("69NJe");

/**
 * This component will observer the current width,
 * and it will call the `setWidth` callback every time this changes.
 *
 * The only required is the parent HTMLElement should have `position: relative`
 * because this is an absolute element.
 */ const $12a75cc47e499450$var$WidthObserver = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props.offscreen || $[1] !== props.setWidth) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $69NJe.WidthDetectorObserver), {
            setWidth: props.setWidth,
            offscreen: props.offscreen
        });
        $[0] = props.offscreen;
        $[1] = props.setWidth;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $69NJe.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $12a75cc47e499450$export$2e2bcd8739ae039 = $12a75cc47e499450$var$WidthObserver;
module.exports["default"] = $12a75cc47e499450$export$2e2bcd8739ae039;

});

parcelRegister("69NJe", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1zgpZ = parcelRequire("1zgpZ");

const $00e8152189e344b1$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { setWidth: setWidth, offscreen: offscreen } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            threshold: 0
        };
        $[0] = t1;
    } else t1 = $[0];
    const [inViewRef, inView, target] = (0, $1zgpZ.useInView)(t1);
    let t2;
    if ($[1] !== setWidth) {
        t2 = ()=>{
            if (typeof window === "undefined") return null;
            return new ResizeObserver((entries)=>{
                if (!Array.isArray(entries) || !entries.length) return;
                const { width: width } = entries[0].contentRect;
                setWidth(Math.round(width));
            });
        };
        $[1] = setWidth;
        $[2] = t2;
    } else t2 = $[2];
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(t2);
    let t3;
    let t4;
    if ($[3] !== inView || $[4] !== offscreen || $[5] !== target) {
        t3 = ()=>{
            const { current: currentObserver } = observer;
            const resizeObserver = currentObserver();
            if (resizeObserver === null) return;
            if (target) {
                if (inView || offscreen) resizeObserver.observe(target);
                else resizeObserver.unobserve(target);
            }
            return ()=>{
                resizeObserver.disconnect();
            };
        };
        t4 = [
            target,
            inView,
            offscreen
        ];
        $[3] = inView;
        $[4] = offscreen;
        $[5] = target;
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t3, t4);
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            display: "block",
            width: "100%",
            position: "absolute"
        };
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== inViewRef) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: t5,
            ref: inViewRef
        });
        $[9] = inViewRef;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
} : ({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $1zgpZ.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});
module.exports["WidthDetectorObserver"] = $00e8152189e344b1$export$ff983d2a2b6112ea;

});

parcelRegister("1zgpZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $cbd0258ef583969a$export$2f62ee6831462844 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useInView(t0) {
    const $ = (0, $bDgLe.c)(14);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const options = t1;
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            inView: false,
            entry: undefined,
            target: undefined
        };
        $[2] = t2;
    } else t2 = $[2];
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(t2);
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    let t3;
    if ($[3] !== root || $[4] !== rootMargin || $[5] !== threshold) {
        t3 = (node)=>{
            observerInstance.current = new IntersectionObserver((entries)=>{
                if (entries && entries.length) {
                    const intersection = entries[0];
                    const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                    if (intersectionRatio >= 0) {
                        const numericThreshold = typeof threshold === "number" ? threshold : 0;
                        let inView = intersectionRatio >= numericThreshold;
                        if (isIntersecting !== undefined) inView = inView && isIntersecting;
                        setState({
                            inView: inView,
                            entry: intersection,
                            target: node
                        });
                    }
                }
            }, {
                threshold: threshold,
                root: root,
                rootMargin: rootMargin
            });
            if (ref.current) observerInstance.current.unobserve(ref.current);
            if (node) observerInstance.current.observe(node);
            ref.current = node;
        };
        $[3] = root;
        $[4] = rootMargin;
        $[5] = threshold;
        $[6] = t3;
    } else t3 = $[6];
    const setRef = t3;
    let t4;
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>()=>{
                if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
            };
        t5 = [];
        $[7] = t4;
        $[8] = t5;
    } else {
        t4 = $[7];
        t5 = $[8];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t4, t5);
    let t6;
    if ($[9] !== setRef || $[10] !== state.entry || $[11] !== state.inView || $[12] !== state.target) {
        t6 = [
            setRef,
            state.inView,
            state.target,
            state.entry
        ];
        $[9] = setRef;
        $[10] = state.entry;
        $[11] = state.inView;
        $[12] = state.target;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
} : function useInView(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
   * Unsubscribe IntersectionObserver before unmounting a component.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
};
module.exports["useInView"] = $cbd0258ef583969a$export$2f62ee6831462844;

});

parcelRegister("l4eiF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $79f107ddc4d1b489$var$defaultState = {
    firstHighlightShown: false
};
const $79f107ddc4d1b489$export$ca9047e33beaf8b2 = (0, $cozmU.createContext)($79f107ddc4d1b489$var$defaultState);
$79f107ddc4d1b489$export$ca9047e33beaf8b2.displayName = 'HighlightActionsContext';
module.exports["HighlightActionsContext"] = $79f107ddc4d1b489$export$ca9047e33beaf8b2;

});

parcelRegister("b1ynj", function(module, exports) {
/* OtherActions.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $7sJoX = parcelRequire("7sJoX");


var $5SGpQ = parcelRequire("5SGpQ");


var $1sCHt = parcelRequire("1sCHt");


var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $4ez2K = parcelRequire("4ez2K");


var $6TaGl = parcelRequire("6TaGl");


var $6Ec6w = parcelRequire("6Ec6w");


var $jmUhx = parcelRequire("jmUhx");


var $5wHqn = parcelRequire("5wHqn");


var $fqVYq = parcelRequire("fqVYq");


var $lpNn5 = parcelRequire("lpNn5");


var $cJ0FD = parcelRequire("cJ0FD");


var $9DHhW = parcelRequire("9DHhW");


var $lslMH = parcelRequire("lslMH");


var $jgJIe = parcelRequire("jgJIe");


var $dVKvM = parcelRequire("dVKvM");


var $a6nzD = parcelRequire("a6nzD");





var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4vC63 = parcelRequire("4vC63");


var $9fBoq = parcelRequire("9fBoq");


var $4GDP8 = parcelRequire("4GDP8");


var $1mDVg = parcelRequire("1mDVg");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");

const $f5df649ae1312176$var$i18n = (0, $kSwu1.defineMessages)({
    selectApp: {
        id: "highlight-actions.select.app",
        defaultMessage: "Select app"
    },
    apps: {
        id: "highlight-actions.dropdown-group.apps",
        defaultMessage: "Apps"
    }
});
const $f5df649ae1312176$var$oldDropdownTriggerWrapperStyle = null;
const $f5df649ae1312176$var$dropdownTriggerWrapperStyle = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5df649ae1312176$var$PopupPaddingContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt44ar7",
            __cmplp.className
        ])
    });
});
const $f5df649ae1312176$var$dropdownComponentListStyle = null;
const $f5df649ae1312176$var$iconImageStyle = null;
const $f5df649ae1312176$var$noIconWrapperStyle = null;
const $f5df649ae1312176$export$c01fdef1354c759b = ({ builtInActions: builtInActions = [], connectItems: connectItems, forgeItems: forgeItems = [], selectForgeExtension: selectForgeExtension = ()=>{} })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isNewToolbarEnabled = (0, $9wGTI.fg)('aifc_create_enabled') || (0, $6mKj3.expValEquals)('platform_editor_toolbar_aifc_confluence', 'isEnabled', true);
    const fireOverflowMenuAnalytics = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                name: 'button clicked - highlightActionsMenuOverflow',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'highlightActionsMenuOverflow',
                source: 'highlightActionsMenu',
                type: 'ui',
                attributes: {
                    pageMode: (0, $1mDVg.PageMode).VIEW
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onClose = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const connectComponents = (0, $cozmU.useMemo)(()=>connectItems.map((item)=>{
            if ((0, $6mKj3.expValEquals)('platform_editor_renderer_toolbar_updates', 'isEnabled', true)) return /*#__PURE__*/ $cozmU.createElement((0, $dVKvM.ToolbarDropdownItem), {
                key: item.completeKey,
                "data-vc": "link-item",
                "data-key": item.completeKey,
                href: item.url,
                title: item.label,
                shouldTitleWrap: false,
                elemBefore: item?.icon?.path ? /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
                    src: item.icon.path,
                    alt: item.label,
                    className: (0, $hekY6.default)([
                        "_4t3i1tcg _1bsb1tcg"
                    ])
                }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Ec6w))), {
                    size: "small",
                    label: ""
                })
            }, item.label);
            return (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ $cozmU.createElement("div", {
                className: item.styleClass
            }, /*#__PURE__*/ $cozmU.createElement((0, $is1T6.default), {
                key: item.completeKey,
                "data-key": item.completeKey,
                href: item.url,
                title: item.label,
                shouldTitleWrap: false,
                elemBefore: item?.icon?.path ? /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
                    src: item.icon.path,
                    className: (0, $hekY6.default)([
                        "_4t3i1tcg _1bsb1tcg"
                    ])
                }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Ec6w))), {
                    label: ""
                })
            }, item.label)) : /*#__PURE__*/ $cozmU.createElement((0, $5SGpQ.default), {
                iconBefore: item?.icon?.path ? /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
                    src: item.icon.path,
                    className: (0, $hekY6.default)([
                        "_4t3i1tcg _1bsb1tcg"
                    ])
                }) : /*#__PURE__*/ $cozmU.createElement("div", {
                    className: (0, $hekY6.default)([
                        "_2rko1rr0 _1bsb1tcg _4t3i1tcg _bfhk187o _1e0c1txw _4cvr1h6o _1bah1b1v"
                    ])
                }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Ec6w))), {
                    label: "No icon",
                    color: "var(--ds-icon-disabled, #080F214A)"
                })),
                key: item.completeKey,
                appearance: "subtle",
                "data-key": item.completeKey,
                className: item.styleClass,
                href: item.url,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    textAlign: 'left',
                    // we can't wrap Button with `styled` as inner styles override this
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    borderRadius: 0
                },
                shouldFitContainer: true,
                title: item.label
            }, item.label);
        }), [
        connectItems
    ]);
    const forgeComponents = (0, $cozmU.useMemo)(()=>forgeItems.map((item)=>{
            const appTitle = (0, $9fBoq.extensionTitle)(item);
            if ((0, $6mKj3.expValEquals)('platform_editor_renderer_toolbar_updates', 'isEnabled', true)) return /*#__PURE__*/ $cozmU.createElement((0, $4vC63.ForgeKeyboardShortcutVisualizer), {
                key: item.id,
                module: item
            }, /*#__PURE__*/ $cozmU.createElement((0, $dVKvM.ToolbarDropdownItem), {
                key: item.id,
                title: appTitle,
                shouldTitleWrap: false,
                elemBefore: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Ec6w))), {
                    size: "small",
                    label: ""
                }),
                onClick: ()=>{
                    experienceTracker.start({
                        name: (0, $irVI7.VIEW_PAGE_CONTEXT_MENU_FORGE_EXPERIENCE),
                        id: item.id,
                        timeout: 10000
                    });
                    selectForgeExtension(item);
                }
            }, appTitle));
            return (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ $cozmU.createElement((0, $4vC63.ForgeKeyboardShortcutVisualizer), {
                key: item.id,
                module: item
            }, /*#__PURE__*/ $cozmU.createElement((0, $is1T6.default), {
                key: item.id,
                title: appTitle,
                shouldTitleWrap: false,
                elemBefore: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Ec6w))), {
                    label: ""
                }),
                onClick: ()=>{
                    experienceTracker.start({
                        name: (0, $irVI7.VIEW_PAGE_CONTEXT_MENU_FORGE_EXPERIENCE),
                        id: item.id,
                        timeout: 10000
                    });
                    selectForgeExtension(item);
                }
            }, appTitle)) : /*#__PURE__*/ $cozmU.createElement((0, $4vC63.ForgeKeyboardShortcutVisualizer), {
                key: item.id,
                module: item
            }, /*#__PURE__*/ $cozmU.createElement((0, $5SGpQ.default), {
                key: item.id,
                id: item.id,
                appearance: "subtle",
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    textAlign: 'left',
                    // we can't wrap Button with `styled` as inner styles override this
                    paddingLeft: connectItems.length ? '40px' : '8px',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    borderRadius: 0
                },
                onClick: ()=>{
                    experienceTracker.start({
                        name: (0, $irVI7.VIEW_PAGE_CONTEXT_MENU_FORGE_EXPERIENCE),
                        id: item.id,
                        timeout: 10000
                    });
                    selectForgeExtension(item);
                },
                shouldFitContainer: true,
                title: appTitle
            }, appTitle));
        }), [
        connectItems,
        forgeItems,
        selectForgeExtension,
        experienceTracker
    ]);
    const forgeKeyboardShortcuts = (0, $cozmU.useMemo)(()=>forgeItems.map((module)=>/*#__PURE__*/ $cozmU.createElement((0, $4vC63.ForgeKeyboardShortcut), {
                key: module.id,
                module: module,
                action: ()=>{
                    (0, $4GDP8.openContextMenuClick)();
                    (0, $4GDP8.simulateItemClick)(module.id);
                    (0, $4GDP8.simulateItemMouseOver)(module.id);
                }
            })), [
        forgeItems
    ]);
    const dropDownComponents = (0, $cozmU.useMemo)(()=>{
        const oldToolbarComponents = (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "context-menu-dropdown-groups"
        }, builtInActions.length > 0 && /*#__PURE__*/ $cozmU.createElement((0, $9erVg.default), {
            testId: "context-menu-dropdown-group-builtin"
        }, builtInActions), Boolean(connectItems.length || forgeItems.length) && /*#__PURE__*/ $cozmU.createElement((0, $9erVg.default), {
            hasSeparator: builtInActions.length > 0,
            title: intl.formatMessage($f5df649ae1312176$var$i18n.apps),
            testId: "context-menu-dropdown-group-apps"
        }, connectComponents, forgeComponents)) : /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_18s8ax2b _1e0c1txw _2lx21bp4 _ca0qu2gc _n3tdu2gc _18m91wug _c71l1mjv _p12f1mjv"
            ])
        }, connectComponents, forgeComponents);
        return isNewToolbarEnabled ? /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "context-menu-dropdown-groups"
        }, builtInActions.length > 0 && /*#__PURE__*/ $cozmU.createElement((0, $jgJIe.ToolbarDropdownItemSection), {
            testId: "context-menu-dropdown-group-builtin"
        }, builtInActions), Boolean(connectItems.length || forgeItems.length) && /*#__PURE__*/ $cozmU.createElement((0, $jgJIe.ToolbarDropdownItemSection), {
            hasSeparator: builtInActions.length > 0,
            title: intl.formatMessage($f5df649ae1312176$var$i18n.apps),
            testId: "context-menu-dropdown-group-apps"
        }, connectComponents, forgeComponents)) : oldToolbarComponents;
    }, [
        isNewToolbarEnabled,
        builtInActions,
        connectItems.length,
        forgeItems.length,
        intl,
        connectComponents,
        forgeComponents
    ]);
    if (isNewToolbarEnabled) {
        if (!connectItems.length && !forgeItems.length && !builtInActions.length) return null;
        if ((0, $6mKj3.expValEquals)('platform_editor_renderer_toolbar_updates', 'isEnabled', true)) return /*#__PURE__*/ $cozmU.createElement((0, $a6nzD.ToolbarDropdownMenu), {
            iconBefore: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
                label: intl.formatMessage($f5df649ae1312176$var$i18n.selectApp),
                size: "small"
            }),
            id: "context-menu-other-apps",
            testId: "context-menu-other-apps",
            onClick: fireOverflowMenuAnalytics,
            tooltipComponent: /*#__PURE__*/ $cozmU.createElement((0, $lslMH.ToolbarTooltip), {
                content: intl.formatMessage($f5df649ae1312176$var$i18n.selectApp)
            })
        }, dropDownComponents, forgeKeyboardShortcuts);
        return /*#__PURE__*/ $cozmU.createElement((0, $lslMH.ToolbarTooltip), {
            content: intl.formatMessage($f5df649ae1312176$var$i18n.selectApp)
        }, /*#__PURE__*/ $cozmU.createElement((0, $3vgx3.default), {
            shouldRenderToParent: true,
            placement: "bottom-start",
            isOpen: isOpen,
            onOpenChange: (attrs)=>{
                setIsOpen(attrs.isOpen);
            },
            trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ $cozmU.createElement("div", {
                    ...triggerProps,
                    ref: triggerRef,
                    id: "context-menu-other-apps",
                    "data-testid": "context-menu-other-apps",
                    className: (0, $hekY6.default)([
                        "_1e0c1txw _4cvr1h6o _ca0q1b66 _n3td1b66 _u5f31b66"
                    ])
                }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                    appearance: "subtle",
                    isSelected: isOpen,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                    isTooltipDisabled: false,
                    label: intl.formatMessage($f5df649ae1312176$var$i18n.selectApp),
                    testId: "highlight-actions-show-more",
                    onClick: fireOverflowMenuAnalytics
                }), forgeKeyboardShortcuts)
        }, dropDownComponents));
    }
    if ((0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1')) {
        if (!connectItems.length && !forgeItems.length && !builtInActions.length) return null;
    } else {
        if (!connectItems.length && !forgeItems.length) return null;
    }
    return (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ $cozmU.createElement((0, $3vgx3.default), {
        shouldRenderToParent: true,
        placement: "bottom-start",
        isOpen: isOpen,
        onOpenChange: (attrs)=>{
            setIsOpen(attrs.isOpen);
        },
        trigger: (triggerProps)=>/*#__PURE__*/ $cozmU.createElement("div", {
                ...triggerProps,
                ref: triggerProps.triggerRef,
                id: "context-menu-other-apps",
                "data-testid": "context-menu-other-apps",
                className: (0, $hekY6.default)([
                    "_1e0c1txw _4cvr1h6o _ca0q1b66 _n3td1b66 _u5f31b66"
                ])
            }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                appearance: "subtle",
                isSelected: isOpen,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                isTooltipDisabled: false,
                label: intl.formatMessage($f5df649ae1312176$var$i18n.selectApp),
                testId: "highlight-actions-show-more",
                onClick: fireOverflowMenuAnalytics
            }), forgeKeyboardShortcuts)
    }, dropDownComponents) : /*#__PURE__*/ $cozmU.createElement((0, $5wHqn.default), {
        placement: "bottom-start",
        isOpen: isOpen,
        onClose: onClose,
        autoFocus: false,
        content: ()=>/*#__PURE__*/ $cozmU.createElement($f5df649ae1312176$var$PopupPaddingContainer, null, dropDownComponents),
        trigger: (triggerProps)=>/*#__PURE__*/ $cozmU.createElement("div", {
                ...triggerProps,
                className: (0, $hekY6.default)([
                    (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') && "_1yt4v77o _1e0c1txw _4cvr1h6o _f7xt1osq _16711osq _5jgi1h6o _1d841h6o"
                ])
            }, /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
                content: intl.formatMessage($f5df649ae1312176$var$i18n.selectApp)
            }, (tooltipProps)=>/*#__PURE__*/ $cozmU.createElement((0, $5SGpQ.default), {
                    ...tooltipProps,
                    id: "context-menu-other-apps",
                    "aria-expanded": isOpen,
                    appearance: "subtle",
                    isSelected: isOpen,
                    onClick: ()=>setIsOpen(!isOpen),
                    iconBefore: (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
                        label: "",
                        spacing: "spacious",
                        testId: "highlight-actions-show-more"
                    }) : /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.default), {
                        alignItems: "center",
                        gap: "space.050"
                    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jmUhx))), {
                        label: ""
                    }), /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                        label: "Drop down",
                        testId: "highlight-actions-show-more",
                        size: "small"
                    })),
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        margin: (0, $fqVYq.editorExperiment)('platform_editor_controls', 'variant1') ? undefined : "var(--ds-space-025, 2px)",
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        marginLeft: "var(--ds-space-negative-025, -2px)"
                    },
                    testId: "context-menu-other-apps"
                })), forgeKeyboardShortcuts),
        shouldRenderToParent: true
    });
};
module.exports["OtherActions"] = $f5df649ae1312176$export$c01fdef1354c759b;

});

parcelRegister("3vgx3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $ad7Ou = parcelRequire("ad7Ou");


var $fM984 = parcelRequire("fM984");


var $lmzCg = parcelRequire("lmzCg");


var $dpsRj = parcelRequire("dpsRj");


var $5Dlqn = parcelRequire("5Dlqn");


var $aRyr7 = parcelRequire("aRyr7");


var $7sJoX = parcelRequire("7sJoX");


var $4CEP6 = parcelRequire("4CEP6");


var $ixfCV = parcelRequire("ixfCV");


var $5wHqn = parcelRequire("5wHqn");


var $jp2Q3 = parcelRequire("jp2Q3");


var $eLJVM = parcelRequire("eLJVM");


var $iv7mf = parcelRequire("iv7mf");


var $94Dr9 = parcelRequire("94Dr9");


var $ggC1G = parcelRequire("ggC1G");


var $imIsb = parcelRequire("imIsb");


var $eEek6 = parcelRequire("eEek6");

const $53393d8413cfd6c9$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $53393d8413cfd6c9$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $53393d8413cfd6c9$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$53393d8413cfd6c9$var$opposites[crossAxis]}`,
            `${$53393d8413cfd6c9$var$opposites[mainAxis]}-${crossAxis}`,
            `${$53393d8413cfd6c9$var$opposites[mainAxis]}`,
            `${$53393d8413cfd6c9$var$opposites[mainAxis]}-${$53393d8413cfd6c9$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$53393d8413cfd6c9$var$opposites[mainAxis]}`,
        `${$53393d8413cfd6c9$var$opposites[mainAxis]}-start`,
        `${$53393d8413cfd6c9$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
function $53393d8413cfd6c9$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * Legacy Popper/Popup implementation (hooks run unconditionally when this component mounts).
 */ const $53393d8413cfd6c9$var$DropdownMenuLegacy = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DropdownMenuLegacy(t0) {
    const $ = (0, $bDgLe.c)(63);
    const { autoFocus: t1, children: children, defaultOpen: t2, isLoading: t3, isOpen: isOpen, onOpenChange: t4, placement: t5, shouldFitContainer: t6, shouldFlip: t7, shouldRenderToParent: t8, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: t9, label: label, interactionName: interactionName, strategy: strategy, menuLabel: menuLabel, shouldPreventEscapePropagation: t10, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent } = t0;
    const autoFocus = t1 === undefined ? false : t1;
    const defaultOpen = t2 === undefined ? false : t2;
    const isLoading = t3 === undefined ? false : t3;
    const onOpenChange = t4 === undefined ? (0, $dpsRj.default) : t4;
    const placement = t5 === undefined ? "bottom-start" : t5;
    const shouldFitContainer = t6 === undefined ? false : t6;
    const shouldFlip = t7 === undefined ? true : t7;
    const shouldRenderToParent = t8 === undefined ? false : t8;
    let t11;
    if ($[0] !== t9) {
        t11 = t9 === undefined ? (0, $jp2Q3.layers).modal() : t9;
        $[0] = t9;
        $[1] = t11;
    } else t11 = $[1];
    const zIndex = t11;
    const shouldPreventEscapePropagation = t10 === undefined ? false : t10;
    let t12;
    if ($[2] !== defaultOpen) {
        t12 = ()=>defaultOpen;
        $[2] = defaultOpen;
        $[3] = t12;
    } else t12 = $[3];
    const [isLocalOpen, setLocalIsOpen] = (0, $5Dlqn.default)(isOpen, t12);
    const triggerRef = (0, $cozmU.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $cozmU.useState)(false);
    const id = (0, $eEek6.default)();
    const itemRef = (0, $imIsb.default)();
    const { currentLevel: currentLevel } = (0, $4CEP6.useLayering)();
    let t13;
    if ($[4] !== placement) {
        t13 = $53393d8413cfd6c9$var$getFallbackPlacements(placement);
        $[4] = placement;
        $[5] = t13;
    } else t13 = $[5];
    const fallbackPlacements = t13;
    let t14;
    if ($[6] !== isLocalOpen || $[7] !== itemRef || $[8] !== onOpenChange || $[9] !== setLocalIsOpen) {
        t14 = (event)=>{
            const newValue = !isLocalOpen;
            const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
            if (type === "keydown") setTriggeredUsingKeyboard(true);
            else {
                if (clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
                else if (detail === 0) setTriggeredUsingKeyboard(true);
                else {
                    itemRef?.current?.focus();
                    setTriggeredUsingKeyboard(false);
                }
            }
            setLocalIsOpen(newValue);
            onOpenChange({
                isOpen: newValue,
                event: event
            });
        };
        $[6] = isLocalOpen;
        $[7] = itemRef;
        $[8] = onOpenChange;
        $[9] = setLocalIsOpen;
        $[10] = t14;
    } else t14 = $[10];
    const handleTriggerClicked = t14;
    let t15;
    if ($[11] !== itemRef || $[12] !== onOpenChange || $[13] !== returnFocusRef || $[14] !== setLocalIsOpen || $[15] !== shouldPreventEscapePropagation) {
        t15 = (event_0, currentLevel_0)=>{
            const isTabLeftOrEscapeKey = $53393d8413cfd6c9$var$isKeyboardEvent(event_0) && (event_0.key === "Tab" || event_0.key === "Escape" || event_0.key === (0, $fM984.KEY_LEFT));
            if (shouldPreventEscapePropagation && $53393d8413cfd6c9$var$isKeyboardEvent(event_0) && (event_0.key === "Escape" || event_0.key === (0, $fM984.KEY_LEFT))) event_0.stopPropagation();
            if (event_0 !== null && !isTabLeftOrEscapeKey && event_0.target instanceof HTMLElement && event_0.target.closest?.(`[id^=${(0, $eEek6.PREFIX)}] [aria-haspopup]`)) {
                if (!currentLevel_0) return;
                const toCloseLevel = itemRef.current?.dataset["ds-Level"];
                if (toCloseLevel && Number(toCloseLevel) < currentLevel_0) return;
            }
            if (returnFocusRef) requestAnimationFrame(()=>{
                returnFocusRef.current?.focus();
            });
            else {
                if ($53393d8413cfd6c9$var$isKeyboardEvent(event_0) && (event_0.key === "Tab" && event_0.shiftKey || event_0.key === "Escape" || event_0.key === (0, $fM984.KEY_LEFT))) requestAnimationFrame(()=>{
                    itemRef.current?.focus();
                });
                else if (triggerRef.current) {
                    const isClickOutsideMenu = event_0?.target instanceof HTMLElement && event_0.target.closest?.("[role=\"menu\"]") === null;
                    const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body;
                    if (!shouldPreventFocus) requestAnimationFrame(()=>{
                        triggerRef.current?.focus();
                    });
                }
            }
            setLocalIsOpen(false);
            onOpenChange({
                isOpen: false,
                event: event_0
            });
        };
        $[11] = itemRef;
        $[12] = onOpenChange;
        $[13] = returnFocusRef;
        $[14] = setLocalIsOpen;
        $[15] = shouldPreventEscapePropagation;
        $[16] = t15;
    } else t15 = $[16];
    const handleOnClose = t15;
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $aRyr7.default)();
    let t16;
    let t17;
    if ($[17] !== handleOnClose || $[18] !== handleTriggerClicked || $[19] !== isFocused || $[20] !== isLocalOpen) {
        t16 = ()=>{
            if (!isFocused) return 0, $dpsRj.default;
            if (isLocalOpen) return 0, $dpsRj.default;
            return (0, $cbY7C.bind)(window, {
                type: "keydown",
                listener: function openOnKeyDown(e) {
                    let isNestedTriggerButton;
                    if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $eEek6.PREFIX)}] [aria-haspopup]`);
                    if (e.key === (0, $fM984.KEY_DOWN) && !isNestedTriggerButton) {
                        e.preventDefault();
                        handleTriggerClicked(e);
                    } else {
                        if ((e.code === (0, $fM984.KEY_SPACE) || e.key === (0, $fM984.KEY_ENTER)) && e.detail === 0) setTriggeredUsingKeyboard(true);
                        else if (e.key === (0, $fM984.KEY_TAB) && isNestedTriggerButton) handleOnClose(e);
                    }
                }
            });
        };
        t17 = [
            isFocused,
            isLocalOpen,
            handleTriggerClicked,
            handleOnClose
        ];
        $[17] = handleOnClose;
        $[18] = handleTriggerClicked;
        $[19] = isFocused;
        $[20] = isLocalOpen;
        $[21] = t16;
        $[22] = t17;
    } else {
        t16 = $[21];
        t17 = $[22];
    }
    (0, $cozmU.useEffect)(t16, t17);
    let t18;
    if ($[23] !== shouldFitContainer || $[24] !== shouldRenderToParent || $[25] !== strategy) {
        t18 = shouldFitContainer ? {
            shouldFitContainer: shouldFitContainer,
            strategy: strategy !== "fixed" ? strategy : undefined
        } : {
            shouldRenderToParent: shouldRenderToParent,
            strategy: strategy
        };
        $[23] = shouldFitContainer;
        $[24] = shouldRenderToParent;
        $[25] = strategy;
        $[26] = t18;
    } else t18 = $[26];
    const conditionalProps = t18;
    const t19 = isLocalOpen ? id : undefined;
    const t20 = returnFocusRef === undefined;
    const t21 = shouldRenderToParent && currentLevel > 0 ? "group" : undefined;
    const t22 = testId && `${testId}--content`;
    let t23;
    if ($[27] !== bindFocus || $[28] !== handleTriggerClicked || $[29] !== interactionName || $[30] !== isLocalOpen || $[31] !== itemRef || $[32] !== label || $[33] !== testId || $[34] !== trigger) {
        t23 = (t24)=>{
            const { ref: ref, "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup, ...rest } = t24;
            if (typeof trigger === "function") return trigger({
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $lmzCg.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                ...bindFocus,
                ref: (0, $lmzCg.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: $53393d8413cfd6c9$var$_temp,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label,
                interactionName: interactionName
            }, trigger);
        };
        $[27] = bindFocus;
        $[28] = handleTriggerClicked;
        $[29] = interactionName;
        $[30] = isLocalOpen;
        $[31] = itemRef;
        $[32] = label;
        $[33] = testId;
        $[34] = trigger;
        $[35] = t23;
    } else t23 = $[35];
    let t24;
    if ($[36] !== autoFocus || $[37] !== children || $[38] !== handleOnClose || $[39] !== isLoading || $[40] !== isTriggeredUsingKeyboard || $[41] !== menuLabel || $[42] !== shouldFitContainer || $[43] !== shouldRenderToParent || $[44] !== spacing || $[45] !== statusLabel || $[46] !== testId) {
        t24 = (t25)=>{
            const { setInitialFocusRef: setInitialFocusRef, update: update } = t25;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iv7mf.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $94Dr9.default), {
                spacing: spacing,
                maxHeight: $53393d8413cfd6c9$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && `${testId}--menu-wrapper`,
                menuLabel: menuLabel
            }, children));
        };
        $[36] = autoFocus;
        $[37] = children;
        $[38] = handleOnClose;
        $[39] = isLoading;
        $[40] = isTriggeredUsingKeyboard;
        $[41] = menuLabel;
        $[42] = shouldFitContainer;
        $[43] = shouldRenderToParent;
        $[44] = spacing;
        $[45] = statusLabel;
        $[46] = testId;
        $[47] = t24;
    } else t24 = $[47];
    let t25;
    if ($[48] !== conditionalProps || $[49] !== fallbackPlacements || $[50] !== handleOnClose || $[51] !== isLocalOpen || $[52] !== placement || $[53] !== shouldFlip || $[54] !== shouldIgnoreCloseEvent || $[55] !== t19 || $[56] !== t20 || $[57] !== t21 || $[58] !== t22 || $[59] !== t23 || $[60] !== t24 || $[61] !== zIndex) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ggC1G.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
            id: t19,
            shouldFlip: shouldFlip,
            isOpen: isLocalOpen,
            shouldReturnFocus: t20,
            onClose: handleOnClose,
            zIndex: zIndex,
            placement: placement,
            role: t21,
            fallbackPlacements: fallbackPlacements,
            testId: t22,
            shouldUseCaptureOnOutsideClick: true,
            shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
            ...conditionalProps,
            shouldDisableFocusLock: true,
            trigger: t23,
            content: t24
        }));
        $[48] = conditionalProps;
        $[49] = fallbackPlacements;
        $[50] = handleOnClose;
        $[51] = isLocalOpen;
        $[52] = placement;
        $[53] = shouldFlip;
        $[54] = shouldIgnoreCloseEvent;
        $[55] = t19;
        $[56] = t20;
        $[57] = t21;
        $[58] = t22;
        $[59] = t23;
        $[60] = t24;
        $[61] = zIndex;
        $[62] = t25;
    } else t25 = $[62];
    return t25;
} : function DropdownMenuLegacy({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $dpsRj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $jp2Q3.layers).modal(), label: label, interactionName: interactionName, strategy: strategy, menuLabel: menuLabel, shouldPreventEscapePropagation: shouldPreventEscapePropagation = false, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent }) {
    const [isLocalOpen, setLocalIsOpen] = (0, $5Dlqn.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $cozmU.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $cozmU.useState)(false);
    const id = (0, $eEek6.default)();
    const itemRef = (0, $imIsb.default)();
    const { currentLevel: currentLevel } = (0, $4CEP6.useLayering)();
    const fallbackPlacements = (0, $cozmU.useMemo)(()=>$53393d8413cfd6c9$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $cozmU.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    const handleOnClose = (0, $cozmU.useCallback)((event_0, currentLevel_0)=>{
        const isTabLeftOrEscapeKey = $53393d8413cfd6c9$var$isKeyboardEvent(event_0) && (event_0.key === 'Tab' || event_0.key === 'Escape' || event_0.key === (0, $fM984.KEY_LEFT));
        // Stop propagation on ESCAPE or Left arrow if shouldPreventEscapePropagation is true
        if (shouldPreventEscapePropagation && $53393d8413cfd6c9$var$isKeyboardEvent(event_0) && (event_0.key === 'Escape' || event_0.key === (0, $fM984.KEY_LEFT))) event_0.stopPropagation();
        if (event_0 !== null && !isTabLeftOrEscapeKey && event_0.target instanceof HTMLElement && event_0.target.closest?.(`[id^=${(0, $eEek6.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel_0) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel_0) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if ($53393d8413cfd6c9$var$isKeyboardEvent(event_0) && (event_0.key === 'Tab' && event_0.shiftKey || event_0.key === 'Escape' || event_0.key === (0, $fM984.KEY_LEFT))) requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) {
            // Don't focus the trigger if the click was outside of the menu
            const isClickOutsideMenu = event_0?.target instanceof HTMLElement && event_0.target.closest?.('[role="menu"]') === null;
            const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(()=>{
                triggerRef.current?.focus();
            });
        }
        const newValue_0 = false;
        setLocalIsOpen(newValue_0);
        onOpenChange({
            isOpen: newValue_0,
            event: event_0
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen,
        shouldPreventEscapePropagation
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $aRyr7.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $cozmU.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $dpsRj.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $dpsRj.default;
        return (0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $eEek6.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $fM984.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $fM984.KEY_SPACE) || e.key === (0, $fM984.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $fM984.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
   * The Popup component requires either:
   * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
   * or
   * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
   *
   * But not:
   * - shouldFitContainer={true} and shouldRenderToParent={false}
   *
   * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
   * types are satisfied.
   */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ggC1G.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
        // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
        returnFocusRef === undefined,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        role: shouldRenderToParent && currentLevel > 0 ? 'group' : undefined,
        fallbackPlacements: fallbackPlacements,
        testId: testId && `${testId}--content`,
        shouldUseCaptureOnOutsideClick: true,
        shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
        ...conditionalProps,
        shouldDisableFocusLock: true,
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
        ...rest })=>{
            if (typeof trigger === 'function') return trigger({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $lmzCg.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                ...bindFocus,
                ref: (0, $lmzCg.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                        ...iconProps,
                        size: "small"
                    }),
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label,
                interactionName: interactionName
            }, trigger);
        },
        content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iv7mf.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $94Dr9.default), {
                spacing: spacing,
                maxHeight: $53393d8413cfd6c9$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && `${testId}--menu-wrapper`,
                menuLabel: menuLabel
            }, children))
    }));
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ function $53393d8413cfd6c9$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        ...iconProps,
        size: "small"
    });
}
const $53393d8413cfd6c9$var$DropdownMenu = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(19);
    const { autoFocus: t0, children: children, defaultOpen: t1, isLoading: t2, isOpen: isOpen, onOpenChange: t3, placement: t4, shouldFitContainer: t5, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel } = props;
    const autoFocus = t0 === undefined ? false : t0;
    const defaultOpen = t1 === undefined ? false : t1;
    const isLoading = t2 === undefined ? false : t2;
    const onOpenChange = t3 === undefined ? (0, $dpsRj.default) : t3;
    const placement = t4 === undefined ? "bottom-start" : t4;
    const shouldFitContainer = t5 === undefined ? false : t5;
    if ((0, $ixfCV.fg)("platform-dst-top-layer")) {
        let t6;
        if ($[0] !== autoFocus || $[1] !== children || $[2] !== defaultOpen || $[3] !== interactionName || $[4] !== isLoading || $[5] !== isOpen || $[6] !== label || $[7] !== menuLabel || $[8] !== onOpenChange || $[9] !== placement || $[10] !== returnFocusRef || $[11] !== shouldFitContainer || $[12] !== spacing || $[13] !== statusLabel || $[14] !== testId || $[15] !== trigger) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eLJVM.default), {
                autoFocus: autoFocus,
                children: children,
                defaultOpen: defaultOpen,
                isLoading: isLoading,
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                placement: placement,
                shouldFitContainer: shouldFitContainer,
                returnFocusRef: returnFocusRef,
                spacing: spacing,
                statusLabel: statusLabel,
                testId: testId,
                trigger: trigger,
                label: label,
                interactionName: interactionName,
                menuLabel: menuLabel
            });
            $[0] = autoFocus;
            $[1] = children;
            $[2] = defaultOpen;
            $[3] = interactionName;
            $[4] = isLoading;
            $[5] = isOpen;
            $[6] = label;
            $[7] = menuLabel;
            $[8] = onOpenChange;
            $[9] = placement;
            $[10] = returnFocusRef;
            $[11] = shouldFitContainer;
            $[12] = spacing;
            $[13] = statusLabel;
            $[14] = testId;
            $[15] = trigger;
            $[16] = t6;
        } else t6 = $[16];
        return t6;
    }
    let t6;
    if ($[17] !== props) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($53393d8413cfd6c9$var$DropdownMenuLegacy, props);
        $[17] = props;
        $[18] = t6;
    } else t6 = $[18];
    return t6;
} : (props)=>{
    const { autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $dpsRj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel } = props;
    if ((0, $ixfCV.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eLJVM.default), {
        autoFocus: autoFocus,
        children: children,
        defaultOpen: defaultOpen,
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        placement: placement,
        shouldFitContainer: shouldFitContainer,
        returnFocusRef: returnFocusRef,
        spacing: spacing,
        statusLabel: statusLabel,
        testId: testId,
        trigger: trigger,
        label: label,
        interactionName: interactionName,
        menuLabel: menuLabel
    });
    // Forward full public props to the legacy Popper/Popup implementation unchanged.
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props -- wrapper delegates entire DropdownMenuProps API
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($53393d8413cfd6c9$var$DropdownMenuLegacy, props);
};
var $53393d8413cfd6c9$export$2e2bcd8739ae039 = $53393d8413cfd6c9$var$DropdownMenu;
module.exports["default"] = $53393d8413cfd6c9$export$2e2bcd8739ae039;

});

parcelRegister("5Dlqn", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a527e5bb9222c5e$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $4a527e5bb9222c5e$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $cozmU.useState)(getDefaultPropValue);
    const isControlledRef = (0, $cozmU.useRef)(isControlled);
    (0, $cozmU.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $cozmU.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("eLJVM", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $cbY7C = parcelRequire("cbY7C");


var $ad7Ou = parcelRequire("ad7Ou");


var $fM984 = parcelRequire("fM984");


var $lmzCg = parcelRequire("lmzCg");


var $dpsRj = parcelRequire("dpsRj");


var $5Dlqn = parcelRequire("5Dlqn");


var $aRyr7 = parcelRequire("aRyr7");


var $7sJoX = parcelRequire("7sJoX");


var $6IL1T = parcelRequire("6IL1T");


var $lfoFx = parcelRequire("lfoFx");


var $lBMxH = parcelRequire("lBMxH");


var $aRDbl = parcelRequire("aRDbl");


var $kVXS3 = parcelRequire("kVXS3");


var $97Yf0 = parcelRequire("97Yf0");


var $1unCm = parcelRequire("1unCm");


var $hPK4E = parcelRequire("hPK4E");


var $ggC1G = parcelRequire("ggC1G");


var $3hJ5V = parcelRequire("3hJ5V");

var $fb8lP = parcelRequire("fb8lP");

var $iNWdN = parcelRequire("iNWdN");

const $f516bc94b8de2bc9$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $f516bc94b8de2bc9$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _1q51v47k _y4tiv47k _85i5v47k _bozgv47k",
    menuContent: "_2rkofajl _bfhk1bhr _16qs130s"
}; /**
    * Event types produced by trigger interactions.
    *
    * - `React.MouseEvent<Element>`: from the trigger's `onClick` handler
    * - `React.KeyboardEvent<Element>`: from the trigger's `onClick` when activated via keyboard
    * - `KeyboardEvent`: native event from the ArrowDown `bind(window, ...)` listener
    */ 
function $f516bc94b8de2bc9$var$isKeyboardTriggered(event) {
    if (event.type === 'keydown') return true;
    if ('clientX' in event && (event.clientX === 0 || event.clientY === 0)) return true;
    if (event.detail === 0) return true;
    return false;
} /**
   * Loading indicator for the dropdown menu.
   */ 
const $f516bc94b8de2bc9$var$LoadingIndicator = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LoadingIndicator(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { statusLabel: t1, testId: testId } = t0;
    const statusLabel = t1 === undefined ? "Loading" : t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $f516bc94b8de2bc9$var$styles.spinnerContainer
        ]);
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== statusLabel || $[2] !== testId) {
        t3 = /*#__PURE__*/ $cozmU.createElement("div", {
            role: "menuitem",
            className: t2
        }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        }));
        $[1] = statusLabel;
        $[2] = testId;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : function LoadingIndicator({ statusLabel: statusLabel = 'Loading', testId: testId }) {
    return /*#__PURE__*/ $cozmU.createElement("div", {
        role: "menuitem",
        className: (0, $hekY6.default)([
            $f516bc94b8de2bc9$var$styles.spinnerContainer
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
};
/**
 * Top-layer implementation of DropdownMenu.
 *
 * Replaces the legacy `@atlaskit/popup` + `@atlaskit/portal` + `@atlaskit/layering` pipeline
 * with the native Popover API via `@atlaskit/top-layer`.
 *
 * What is no longer needed:
 * - Portal: top layer handles stacking natively
 * - FocusLock / react-focus-lock: popover=auto provides light dismiss
 * - z-index: top layer is always above everything
 * - FocusManager (ref registration): replaced by DOM-query-based `useArrowNavigation`
 * - handle-focus.tsx: replaced by `useArrowNavigation`
 * - Layering context: top layer nesting is handled by the browser
 * - Fallback placements / Popper: CSS Anchor Positioning handles positioning
 */ function $f516bc94b8de2bc9$var$DropdownMenuTopLayer({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpenProp, onOpenChange: onOpenChange = (0, $dpsRj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel }) {
    const [isLocalOpen, setLocalIsOpen] = (0, $5Dlqn.default)(isOpenProp, ()=>defaultOpen);
    const triggerRef = (0, $cozmU.useRef)(null);
    const popoverRef = (0, $cozmU.useRef)(null);
    const menuRef = (0, $cozmU.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $cozmU.useState)(false);
    const popoverId = (0, $1unCm.usePopoverId)();
    const topLayerPlacement = (0, $cozmU.useMemo)(()=>(0, $aRDbl.fromLegacyPlacement)({
            legacy: placement
        }), [
        placement
    ]);
    (0, $97Yf0.useAnchorPosition)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isLocalOpen
    });
    (0, $hPK4E.useWidthFromAnchor)({
        mode: shouldFitContainer ? 'min-anchor' : 'none',
        popoverRef: popoverRef,
        anchorRef: triggerRef,
        isOpen: isLocalOpen
    }); // Close handling.
    // Focus restoration is handled natively by the Popover API:
    //   - Escape: browser restores focus to the trigger automatically
    //   - Click-outside: browser does NOT restore (correct behavior)
    //
    // The only custom focus handling needed is `returnFocusRef`: when provided,
    // we redirect focus to a different element than the trigger. We do this
    // in the onClose callback via rAF, which runs after the browser's native
    // restoration, effectively overriding it.
    const handleOnClose = (0, $cozmU.useCallback)(({ reason: _reason })=>{
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        setLocalIsOpen(false);
        onOpenChange({
            isOpen: false,
            event: null
        });
    }, [
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]); // Trigger click handling.
    const handleTriggerClicked = (0, $cozmU.useCallback)((event)=>{
        const newValue = !isLocalOpen;
        setTriggeredUsingKeyboard($f516bc94b8de2bc9$var$isKeyboardTriggered(event));
        setLocalIsOpen(newValue); // Extract the native DOM event for onOpenChange
        const nativeEvent = 'nativeEvent' in event ? event.nativeEvent : event;
        onOpenChange({
            isOpen: newValue,
            event: nativeEvent
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $aRyr7.default)(); // When trigger is focused, open dropdown on ArrowDown (top-level only).
    // Per WAI-ARIA, ArrowDown opens a menu from a menubar/button trigger,
    // but inside a vertical submenu, ArrowDown navigates between siblings
    // and ArrowRight opens nested menus instead.
    (0, $cozmU.useEffect)(()=>{
        if (!isFocused || isLocalOpen) return 0, $dpsRj.default;
         // Do not open on ArrowDown if this trigger is inside a parent menu.
        // Nested menus should only be opened via ArrowRight or Enter.
        const isNestedTrigger = triggerRef.current?.closest('[role="menu"]') != null;
        return (0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $fM984.KEY_DOWN) && !isNestedTrigger) {
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $fM984.KEY_SPACE) || e.key === (0, $fM984.KEY_ENTER)) && e.detail === 0) setTriggeredUsingKeyboard(true);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked
    ]); // Arrow navigation.
    // useArrowNavigation handles ArrowUp/Down, Home/End, and Tab-to-close
    // by querying focusable elements in the menu DOM container.
    const handleArrowClose = (0, $cozmU.useCallback)(()=>{
        handleOnClose({
            reason: 'escape'
        });
    }, [
        handleOnClose
    ]);
    const handleNestedOpen = (0, $cozmU.useCallback)(({ trigger: trigger_0 })=>{
        trigger_0.click();
    }, []);
    const handleNestedClose = (0, $cozmU.useCallback)(()=>{
        handleOnClose({
            reason: 'escape'
        });
    }, [
        handleOnClose
    ]);
    (0, $iNWdN.useArrowNavigation)({
        containerRef: menuRef,
        onClose: handleArrowClose,
        onNestedOpen: handleNestedOpen,
        onNestedClose: handleNestedClose,
        isEnabled: isLocalOpen,
        filter: (0, $fb8lP.isAtCurrentMenuLevel)
    }); // Auto-focus first item on open.
    (0, $cozmU.useEffect)(()=>{
        if (!isLocalOpen || !isTriggeredUsingKeyboard && !autoFocus) return;
        requestAnimationFrame(()=>{
            const menu = menuRef.current;
            if (!menu) return;
            const firstItem = (0, $3hJ5V.getFirstFocusable)({
                container: menu
            });
            firstItem?.focus();
        });
    }, [
        isLocalOpen,
        isTriggeredUsingKeyboard,
        autoFocus
    ]); // Close on menu item click.
    // Close when a regular menuitem is clicked, but not checkboxes/radios
    // and not nested triggers (items with aria-haspopup).
    const handleMenuClick = (0, $cozmU.useCallback)((e_0)=>{
        const target = e_0.target;
        const menuItem = target.closest?.('[role="menuitem"], [role="menuitemcheckbox"], [role="menuitemradio"]');
        if (!menuItem) return;
        const isCheckboxOrRadio = menuItem.getAttribute('role') === 'menuitemcheckbox' || menuItem.getAttribute('role') === 'menuitemradio'; // Do not close the menu when clicking a nested trigger (aria-haspopup).
        // The nested dropdown will handle its own open/close.
        const isNestedTrigger_0 = menuItem.hasAttribute('aria-haspopup');
        if (!isCheckboxOrRadio && !isNestedTrigger_0) {
            setLocalIsOpen(false);
            onOpenChange({
                isOpen: false,
                event: e_0.nativeEvent
            });
        }
    }, [
        setLocalIsOpen,
        onOpenChange
    ]);
    const ariaAttributes = (0, $lBMxH.getAriaForTrigger)({
        role: 'menu',
        isOpen: isLocalOpen,
        popoverId: popoverId
    }); // FUDGE(top-layer-api): cast `aria-haspopup` to the narrow shape that adopter
    // public types expect. `@atlaskit/top-layer` types `aria-haspopup` as the wider
    // WAI-ARIA union, but the public `CustomTriggerProps` (extending `@atlaskit/popup`
    // `TriggerProps`) is intentionally kept narrow (`boolean | 'dialog'`) because the
    // top-layer API surface is not yet settled. The runtime value is unchanged; only
    // the TypeScript-visible type is narrowed at this boundary.
    const narrowAriaAttributes = ariaAttributes;
    const renderTrigger = ()=>{
        const setRef = (node)=>{
            triggerRef.current = node;
        };
        const combinedRef = (0, $lmzCg.default)([
            setRef
        ]);
        if (typeof trigger === 'function') return trigger({
            ...narrowAriaAttributes,
            ...bindFocus,
            triggerRef: combinedRef,
            isSelected: isLocalOpen,
            onClick: handleTriggerClicked,
            testId: testId && `${testId}--trigger`
        });
        return /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            ...bindFocus,
            ref: combinedRef,
            ...narrowAriaAttributes,
            isSelected: isLocalOpen,
            iconAfter: (iconProps)=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    ...iconProps,
                    size: "small"
                }),
            onClick: handleTriggerClicked,
            testId: testId && `${testId}--trigger`,
            "aria-label": label,
            interactionName: interactionName
        }, trigger);
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $ggC1G.default), null, renderTrigger(), /*#__PURE__*/ $cozmU.createElement((0, $kVXS3.Popover), {
        ref: popoverRef,
        id: popoverId,
        role: "menu",
        label: menuLabel ?? label ?? (typeof trigger === 'string' ? trigger : 'Menu'),
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        animate: true,
        placement: topLayerPlacement,
        testId: testId && `${testId}--content`
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        ref: menuRef,
        className: (0, $hekY6.default)([
            $f516bc94b8de2bc9$var$styles.menuContent
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $6IL1T.default), {
        isLoading: isLoading,
        maxHeight: $f516bc94b8de2bc9$var$MAX_HEIGHT,
        maxWidth: shouldFitContainer ? undefined : 800,
        onClick: handleMenuClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-wrapper--menu-group`,
        menuLabel: menuLabel
    }, isLoading ? /*#__PURE__*/ $cozmU.createElement($f516bc94b8de2bc9$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--menu-wrapper--loading-indicator`
    }) : children))));
}
var $f516bc94b8de2bc9$export$2e2bcd8739ae039 = $f516bc94b8de2bc9$var$DropdownMenuTopLayer;
module.exports["default"] = $f516bc94b8de2bc9$export$2e2bcd8739ae039;

});

parcelRegister("ggC1G", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lOWpM = parcelRequire("lOWpM");

/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $885bea270958798f$var$SelectionStore = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = props;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {};
        $[0] = t0;
    } else t0 = $[0];
    const store = (0, $cozmU.useRef)(t0);
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group_0, id_0)=>{
                if (!store.current[group_0]) return;
                return store.current[group_0][id_0];
            },
            setGroupState: (group_1, value_0)=>{
                store.current[group_1] = value_0;
            },
            getGroupState: (group_2)=>store.current[group_2] || {}
        };
        $[1] = t1;
    } else t1 = $[1];
    const context = t1;
    let t2;
    if ($[2] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lOWpM.SelectionStoreContext).Provider, {
            value: context
        }, children);
        $[2] = children;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : (props)=>{
    const { children: children } = props;
    const store = (0, $cozmU.useRef)({});
    const context = (0, $cozmU.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group_0, id_0)=>{
                if (!store.current[group_0]) return undefined;
                return store.current[group_0][id_0];
            },
            setGroupState: (group_1, value_0)=>{
                store.current[group_1] = value_0;
            },
            getGroupState: (group_2)=>{
                return store.current[group_2] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lOWpM.SelectionStoreContext).Provider, {
        value: context
    }, children);
};
var $885bea270958798f$export$2e2bcd8739ae039 = $885bea270958798f$var$SelectionStore;
module.exports["default"] = $885bea270958798f$export$2e2bcd8739ae039;

});

parcelRegister("lOWpM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");

const $db8a5bf4c7b230f3$export$756f795847463ebd = /*#__PURE__*/ (0, $cozmU.createContext)({
    setItemState: (0, $dpsRj.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $dpsRj.default),
    getGroupState: ()=>({})
});
module.exports["SelectionStoreContext"] = $db8a5bf4c7b230f3$export$756f795847463ebd;

});

parcelRegister("fb8lP", function(module, exports) {
const $6bfdddcadf7826ef$var$menuScope = '[role="menu"]';
/**
 * Recursively walks from `node` toward `container`, returning `true` when
 * `container` is reached without crossing another `role="menu"` ancestor.
 *
 * Used by `isAtCurrentMenuLevel` (pattern 2) to determine if the
 * `closestMenu` is owned by the wrapper container directly. Recursion
 * avoids a mutable `let parent` walk and keeps the function body linear.
 */ function $6bfdddcadf7826ef$var$reachesContainerWithoutNestedMenu(node, container) {
    if (!node || node === container) return node === container;
    if (node.getAttribute('role') === 'menu') return false;
    return $6bfdddcadf7826ef$var$reachesContainerWithoutNestedMenu(node.parentElement, container);
}
function $6bfdddcadf7826ef$export$f1bba0ef464d60af(element, container) {
    const closestMenu = element.closest($6bfdddcadf7826ef$var$menuScope);
    // Container itself has role="menu". Element belongs to this level
    // if its closest menu is the container.
    if (container.getAttribute('role') === 'menu') return closestMenu === container;
    // Container is a wrapper without role="menu" (e.g. dropdown-menu
    // wraps a MenuGroup). The element belongs to the top level if its
    // closest role="menu" ancestor is a direct child of the container,
    // i.e. there is no nested role="menu" between them.
    if (closestMenu === null) return true;
    // Walk up from the closest menu to see if it is "owned" by this
    // container without passing through another role="menu" first.
    return $6bfdddcadf7826ef$var$reachesContainerWithoutNestedMenu(closestMenu.parentElement, container);
}
module.exports["isAtCurrentMenuLevel"] = $6bfdddcadf7826ef$export$f1bba0ef464d60af;

});

parcelRegister("iv7mf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $4CEP6 = parcelRequire("4CEP6");


var $2Bag3 = parcelRequire("2Bag3");


var $6nHMa = parcelRequire("6nHMa");

/**
 * Focus manager logic.
 */ const $f5a399746fdfd30b$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $cozmU.useRef)([]);
    // Used to force a re-render only
    const [refresh, setRefresh] = (0, $cozmU.useState)(0);
    const registerMode = (0, $cozmU.useRef)('ordered');
    registerMode.current = 'ordered';
    const registerRef = (0, $cozmU.useCallback)((ref)=>{
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error(`Unexpected case of ${registerMode.current}`);
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $4CEP6.useLayering)();
    // Root menu (from a button) is at level 1; first submenu is at level 2. ARIA: Left only closes submenus.
    const isNestedMenu = currentLevel > 1;
    // Intentionally rebinding on each render
    (0, $cozmU.useEffect)(()=>{
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $cozmU.useEffect)(()=>(0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener: (0, $2Bag3.default)(menuItemRefs, isLayerDisabled, onClose, isNestedMenu)
        }), [
        isLayerDisabled,
        onClose,
        isNestedMenu
    ]);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6nHMa.FocusManagerContext).Provider, {
        value: contextValue
    }, children);
};
var $f5a399746fdfd30b$export$2e2bcd8739ae039 = $f5a399746fdfd30b$var$FocusManager;
module.exports["default"] = $f5a399746fdfd30b$export$2e2bcd8739ae039;

});

parcelRegister("2Bag3", function(module, exports) {
$parcel$export(module.exports, "default", () => $b55ec80e24a5f4b9$export$2e2bcd8739ae039);

var $fM984 = parcelRequire("fM984");


var $ixfCV = parcelRequire("ixfCV");


var $eEek6 = parcelRequire("eEek6");

const $b55ec80e24a5f4b9$var$actionMap = {
    [(0, $fM984.KEY_DOWN)]: 'next',
    [(0, $fM984.KEY_UP)]: 'prev',
    [(0, $fM984.KEY_HOME)]: 'first',
    [(0, $fM984.KEY_END)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $b55ec80e24a5f4b9$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $b55ec80e24a5f4b9$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $b55ec80e24a5f4b9$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose, isNestedMenu = false) {
    return (e)=>{
        const currentRefs = refs.current ?? [];
        const currentFocusedIdx = currentRefs.findIndex(({ current: el })=>el && document.activeElement?.isSameNode(el));
        if ((0, $ixfCV.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $eEek6.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $fM984.KEY_TAB) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $fM984.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        // Left arrow: only in a submenu — close and return focus to parent. No navigation within menu.
        if (e.key === (0, $fM984.KEY_LEFT)) {
            e.preventDefault();
            if (isNestedMenu) onClose(e);
            return;
        }
        // Right arrow: only when item has submenu — open it. No navigation within menu.
        if (e.key === (0, $fM984.KEY_RIGHT)) {
            const activeElement = document.activeElement;
            if (activeElement instanceof HTMLElement && (activeElement.getAttribute('aria-haspopup') === 'true' || activeElement.getAttribute('aria-haspopup') === 'menu')) {
                e.preventDefault();
                activeElement.click();
            }
            return;
        }
        const action = $b55ec80e24a5f4b9$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const nextFocusableElement = $b55ec80e24a5f4b9$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement?.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const prevFocusableElement = $b55ec80e24a5f4b9$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement?.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const firstFocusableElement = $b55ec80e24a5f4b9$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const lastFocusableElement = $b55ec80e24a5f4b9$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});

parcelRegister("eEek6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $6JrSr = parcelRequire("6JrSr");

const $bcf8a6c8e532b2af$export$8a682ae47622dbb9 = 'ds--dropdown--';
/**
 * useGeneratedId generates a random string which remains constant across
 * renders when called without any parameter.
 */ const $bcf8a6c8e532b2af$var$useGeneratedId = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useGeneratedId() {
    const id = (0, $6JrSr.useId)();
    return `${$bcf8a6c8e532b2af$export$8a682ae47622dbb9}${id}`;
} : function useGeneratedId() {
    const id = (0, $6JrSr.useId)();
    return `${$bcf8a6c8e532b2af$export$8a682ae47622dbb9}${id}`;
};
var $bcf8a6c8e532b2af$export$2e2bcd8739ae039 = $bcf8a6c8e532b2af$var$useGeneratedId;
module.exports["PREFIX"] = $bcf8a6c8e532b2af$export$8a682ae47622dbb9;
module.exports["default"] = $bcf8a6c8e532b2af$export$2e2bcd8739ae039;

});

parcelRegister("94Dr9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6IL1T = parcelRequire("6IL1T");


var $ixfCV = parcelRequire("ixfCV");


var $iMnC5 = parcelRequire("iMnC5");


var $lfoFx = parcelRequire("lfoFx");


var $gsYt4 = parcelRequire("gsYt4");


var $2zAfh = parcelRequire("2zAfh");


var $6nHMa = parcelRequire("6nHMa");

const $9c09f45d8ede8a3c$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _1q51v47k _y4tiv47k _85i5v47k _bozgv47k"
};
const $9c09f45d8ede8a3c$var$LoadingIndicator = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { statusLabel: t1, testId: testId } = t0;
    const statusLabel = t1 === undefined ? "Loading" : t1;
    let t2;
    if ($[0] !== statusLabel || $[1] !== testId) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: $9c09f45d8ede8a3c$var$styles.spinnerContainer,
            role: "menuitem"
        }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        }));
        $[0] = statusLabel;
        $[1] = testId;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $9c09f45d8ede8a3c$var$styles.spinnerContainer,
        role: "menuitem"
    }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    })); /**
          *
          * MenuWrapper wraps all the menu items.
          * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
          * if a CheckboxItem or RadioItem is clicked.
          * It also sets focus to the first menu item when opened.
          */ 
const $9c09f45d8ede8a3c$var$MenuWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus, menuLabel: menuLabel } = t0;
    const { menuItemRefs: menuItemRefs } = (0, $cozmU.useContext)((0, $6nHMa.FocusManagerContext));
    let t1;
    if ($[0] !== menuItemRefs || $[1] !== onClose) {
        t1 = (e)=>{
            const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
                const { current: menuItem } = menuItemRef;
                if (!menuItem) return false;
                const isCheckboxOrRadio = (0, $gsYt4.default)(menuItem) || (0, $2zAfh.default)(menuItem);
                return menuItem.contains(e.target) && !isCheckboxOrRadio;
            });
            if (isTargetMenuItemOrDescendant && onClose) onClose(e);
        };
        $[0] = menuItemRefs;
        $[1] = onClose;
        $[2] = t1;
    } else t1 = $[2];
    const closeOnMenuItemClick = t1;
    let t2;
    if ($[3] !== onUpdate) {
        t2 = ()=>{
            onUpdate();
        };
        $[3] = onUpdate;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== isLoading || $[6] !== onUpdate) {
        t3 = [
            isLoading,
            onUpdate
        ];
        $[5] = isLoading;
        $[6] = onUpdate;
        $[7] = t3;
    } else t3 = $[7];
    (0, $cozmU.useLayoutEffect)(t2, t3);
    let t4;
    let t5;
    if ($[8] !== autoFocus || $[9] !== isTriggeredUsingKeyboard || $[10] !== menuItemRefs || $[11] !== setInitialFocusRef || $[12] !== shouldRenderToParent) {
        t4 = ()=>{
            const firstFocusableRef = menuItemRefs.map($9c09f45d8ede8a3c$var$_temp).find($9c09f45d8ede8a3c$var$_temp2) ?? null;
            if (((0, $ixfCV.fg)("platform_dst_menu_item_focus") || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
            setInitialFocusRef?.(firstFocusableRef);
        };
        t5 = [
            menuItemRefs,
            setInitialFocusRef,
            autoFocus,
            shouldRenderToParent,
            isTriggeredUsingKeyboard
        ];
        $[8] = autoFocus;
        $[9] = isTriggeredUsingKeyboard;
        $[10] = menuItemRefs;
        $[11] = setInitialFocusRef;
        $[12] = shouldRenderToParent;
        $[13] = t4;
        $[14] = t5;
    } else {
        t4 = $[13];
        t5 = $[14];
    }
    (0, $cozmU.useEffect)(t4, t5);
    const t6 = testId && `${testId}--menu-group`;
    let t7;
    if ($[15] !== children || $[16] !== isLoading || $[17] !== statusLabel || $[18] !== testId) {
        t7 = isLoading ? /*#__PURE__*/ $cozmU.createElement($9c09f45d8ede8a3c$var$LoadingIndicator, {
            statusLabel: statusLabel,
            testId: testId && `${testId}--loading-indicator`
        }) : children;
        $[15] = children;
        $[16] = isLoading;
        $[17] = statusLabel;
        $[18] = testId;
        $[19] = t7;
    } else t7 = $[19];
    let t8;
    if ($[20] !== closeOnMenuItemClick || $[21] !== isLoading || $[22] !== maxHeight || $[23] !== maxWidth || $[24] !== menuLabel || $[25] !== spacing || $[26] !== t6 || $[27] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $6IL1T.default), {
            isLoading: isLoading,
            maxHeight: maxHeight,
            maxWidth: maxWidth,
            onClick: closeOnMenuItemClick,
            role: "menu",
            spacing: spacing,
            testId: t6,
            menuLabel: menuLabel
        }, t7);
        $[20] = closeOnMenuItemClick;
        $[21] = isLoading;
        $[22] = maxHeight;
        $[23] = maxWidth;
        $[24] = menuLabel;
        $[25] = spacing;
        $[26] = t6;
        $[27] = t7;
        $[28] = t8;
    } else t8 = $[28];
    return t8;
} : ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus, menuLabel: menuLabel })=>{
    const { menuItemRefs: menuItemRefs } = (0, $cozmU.useContext)((0, $6nHMa.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
            const { current: menuItem } = menuItemRef;
            if (!menuItem) return false;
            const isCheckboxOrRadio = (0, $gsYt4.default)(menuItem) || (0, $2zAfh.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        }); // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $cozmU.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $cozmU.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.map(({ current: current })=>current).find((el)=>!!el && !el.hasAttribute('disabled')) ?? null;
        if (((0, $ixfCV.fg)('platform_dst_menu_item_focus') || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $6IL1T.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`,
        menuLabel: menuLabel
    }, isLoading ? /*#__PURE__*/ $cozmU.createElement($9c09f45d8ede8a3c$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--loading-indicator`
    }) : children);
};
var $9c09f45d8ede8a3c$export$2e2bcd8739ae039 = $9c09f45d8ede8a3c$var$MenuWrapper;
function $9c09f45d8ede8a3c$var$_temp(t0) {
    const { current: current } = t0;
    return current;
}
function $9c09f45d8ede8a3c$var$_temp2(el) {
    return !!el && !el.hasAttribute("disabled");
}
module.exports["default"] = $9c09f45d8ede8a3c$export$2e2bcd8739ae039;

});

parcelRegister("gsYt4", function(module, exports) {
$parcel$export(module.exports, "default", () => $363009d7887a30e5$export$2e2bcd8739ae039);
function $363009d7887a30e5$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("2zAfh", function(module, exports) {
$parcel$export(module.exports, "default", () => $364a1a3a4c98073c$export$2e2bcd8739ae039);
function $364a1a3a4c98073c$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});

parcelRegister("9erVg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6JrSr = parcelRequire("6JrSr");


var $8FgJC = parcelRequire("8FgJC");


var $eiIYc = parcelRequire("eiIYc");

/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $e544827bc46159a5$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(23);
    let children;
    let hasSeparator;
    let id;
    let isList;
    let isScrollable;
    let rest;
    let testId;
    let title;
    if ($[0] !== t0) {
        ({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = hasSeparator;
        $[3] = id;
        $[4] = isList;
        $[5] = isScrollable;
        $[6] = rest;
        $[7] = testId;
        $[8] = title;
    } else {
        children = $[1];
        hasSeparator = $[2];
        id = $[3];
        isList = $[4];
        isScrollable = $[5];
        rest = $[6];
        testId = $[7];
        title = $[8];
    }
    const uid = (0, $6JrSr.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    const t1 = title ? titleId : undefined;
    let t2;
    if ($[9] !== title || $[10] !== titleId) {
        t2 = title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eiIYc.default), {
            id: titleId,
            title: title
        });
        $[9] = title;
        $[10] = titleId;
        $[11] = t2;
    } else t2 = $[11];
    let t3;
    if ($[12] !== children || $[13] !== hasSeparator || $[14] !== id || $[15] !== isList || $[16] !== isScrollable || $[17] !== ref || $[18] !== rest || $[19] !== t1 || $[20] !== t2 || $[21] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
            id: id,
            ref: ref,
            isList: isList,
            isScrollable: isScrollable,
            hasSeparator: hasSeparator,
            testId: testId,
            titleId: t1,
            ...rest
        }, t2, children);
        $[12] = children;
        $[13] = hasSeparator;
        $[14] = id;
        $[15] = isList;
        $[16] = isScrollable;
        $[17] = ref;
        $[18] = rest;
        $[19] = t1;
        $[20] = t2;
        $[21] = testId;
        $[22] = t3;
    } else t3 = $[22];
    return t3;
} : ({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest }, ref)=>{
    const uid = (0, $6JrSr.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eiIYc.default), {
        id: titleId,
        title: title
    }), children);
});
var $e544827bc46159a5$export$2e2bcd8739ae039 = $e544827bc46159a5$var$DropdownMenuItemGroup;
module.exports["default"] = $e544827bc46159a5$export$2e2bcd8739ae039;

});

parcelRegister("eiIYc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $c2ad6d0f9690e679$var$styles = {
    heading: "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups.
 *
 * Pre-existing a11y note: uses `role="menuitem"` with `aria-hidden="true"`.
 * WAI-ARIA APG recommends `role="presentation"` for non-interactive group
 * headings, with the group linked via `aria-labelledby`. Out of scope for
 * the top-layer migration — this is legacy behavior.
 *
 * @internal
 */ const $c2ad6d0f9690e679$var$GroupTitle = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { id: id, title: title } = t0;
    let t1;
    if ($[0] !== id || $[1] !== title) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            "data-ds--menu--heading-item": true,
            role: "menuitem",
            id: id,
            "aria-hidden": "true",
            xcss: $c2ad6d0f9690e679$var$styles.heading
        }, title);
        $[0] = id;
        $[1] = title;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ id: id, title: title })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $c2ad6d0f9690e679$var$styles.heading
    }, title);
var $c2ad6d0f9690e679$export$2e2bcd8739ae039 = $c2ad6d0f9690e679$var$GroupTitle;
module.exports["default"] = $c2ad6d0f9690e679$export$2e2bcd8739ae039;

});

parcelRegister("4vC63", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lpNn5 = parcelRequire("lpNn5");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $bflGB = parcelRequire("bflGB");


var $1k6sE = parcelRequire("1k6sE");

const $c1fece3650e281b8$var$getAccelerator = (module)=>module?.properties?.keyboardShortcut?.accelerator ?? '';
const $c1fece3650e281b8$export$b804abdac3f5f117 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { module: module, tooltip: t1, children: children } = t0;
    const tooltip = t1 === undefined ? "" : t1;
    let accelerator;
    let t2;
    if ($[0] !== module) {
        accelerator = $c1fece3650e281b8$var$getAccelerator(module);
        t2 = accelerator && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator);
        $[0] = module;
        $[1] = accelerator;
        $[2] = t2;
    } else {
        accelerator = $[1];
        t2 = $[2];
    }
    if (t2) {
        const t3 = `forge-keyboard-shortcut-visualizer-${accelerator}`;
        let t4;
        if ($[3] !== accelerator || $[4] !== tooltip) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: accelerator,
                contentBefore: tooltip,
                isTooltip: true
            });
            $[3] = accelerator;
            $[4] = tooltip;
            $[5] = t4;
        } else t4 = $[5];
        let t5;
        if ($[6] !== children || $[7] !== t3 || $[8] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                tag: "span",
                testId: t3,
                content: t4
            }, children);
            $[6] = children;
            $[7] = t3;
            $[8] = t4;
            $[9] = t5;
        } else t5 = $[9];
        return t5;
    }
    let t3;
    if ($[10] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[10] = children;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
} : ({ module: module, tooltip: tooltip = '', children: children })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        tag: "span",
        testId: `forge-keyboard-shortcut-visualizer-${accelerator}`,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: accelerator,
            contentBefore: tooltip,
            isTooltip: true
        })
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
const $c1fece3650e281b8$export$4e51bfd8ba3e71ef = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { module: module, action: action } = t0;
    let accelerator;
    let t1;
    if ($[0] !== action || $[1] !== module) {
        accelerator = $c1fece3650e281b8$var$getAccelerator(module);
        t1 = accelerator && action && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator);
        $[0] = action;
        $[1] = module;
        $[2] = accelerator;
        $[3] = t1;
    } else {
        accelerator = $[2];
        t1 = $[3];
    }
    if (t1) {
        const t2 = `forge-keyboard-shortcut-${accelerator}`;
        let t3;
        if ($[4] !== accelerator || $[5] !== action) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
                accelerator: accelerator,
                listener: action,
                shortcutType: (0, $bflGB.ShortcutType).Forge
            });
            $[4] = accelerator;
            $[5] = action;
            $[6] = t3;
        } else t3 = $[6];
        let t4;
        if ($[7] !== t2 || $[8] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                "data-testid": t2
            }, t3);
            $[7] = t2;
            $[8] = t3;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    return null;
} : ({ module: module, action: action })=>{
    const accelerator = $c1fece3650e281b8$var$getAccelerator(module);
    if (accelerator && action && !(0, $1k6sE.RESERVED_SHORTCUTS).includes(accelerator)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": `forge-keyboard-shortcut-${accelerator}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: accelerator,
        listener: action,
        shortcutType: (0, $bflGB.ShortcutType).Forge
    }));
    return null;
};
module.exports["ForgeKeyboardShortcutVisualizer"] = $c1fece3650e281b8$export$b804abdac3f5f117;
module.exports["ForgeKeyboardShortcut"] = $c1fece3650e281b8$export$4e51bfd8ba3e71ef;

});

parcelRegister("bflGB", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EemN = parcelRequire("9EemN");

parcelRequire("1syzX");


var $l65Bo = parcelRequire("l65Bo");


var $7aRa9 = parcelRequire("7aRa9");


var $1k6sE = parcelRequire("1k6sE");


var $4q9NN = parcelRequire("4q9NN");

if (typeof window !== 'undefined') {
    // allow to track events on specific elements
    const originalStopCallback = (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).prototype.stopCallback;
    // Note here should be function instead of arrow function as we want to preserve the context of this
    (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).prototype.stopCallback = function(...[e, element, combo]) {
        const isAllowed = (0, $1k6sE.MOUSETRAP_ALLOWED_ELEMENTS).map((className)=>element.classList.contains(className)).some((truthful)=>truthful);
        const isAllowedInModal = (0, $1k6sE.MOUSETRAP_ALLOWED_MODALS).map((className)=>element.closest(`.${className}`)).some((truthful)=>truthful);
        return isAllowed || isAllowedInModal ? false : originalStopCallback.call(this, e, element, combo);
    };
}
const $299ae5ea83dc6310$var$ALLOWED_MIN_TIME = 150;
var $299ae5ea83dc6310$export$99058db374262376 = /*#__PURE__*/ function(ShortcutType) {
    ShortcutType["Confluence"] = "Confluence";
    ShortcutType["Forge"] = "Forge";
    return ShortcutType;
}({});
class $299ae5ea83dc6310$export$d29b063d6e86bfeb extends (0, $cozmU.PureComponent) {
    componentDidMount() {
        const { accelerator: accelerator, shortcutType: shortcutType = "Confluence" } = this.props;
        this.checkConflictThenBindAccelerator(accelerator, shortcutType);
    }
    componentDidUpdate(prevProps) {
        const { accelerator: prevAccelerator } = prevProps;
        const { accelerator: accelerator, shortcutType: shortcutType = "Confluence" } = this.props;
        const prevAccelerators = this.getAccelerators(prevAccelerator);
        // Using JSON.stringify to compare because accelerator may be a list of strings
        if (JSON.stringify(prevAccelerator) !== JSON.stringify(accelerator)) {
            this.unbindAccelerators(prevAccelerators);
            this.checkConflictThenBindAccelerator(accelerator, shortcutType);
        }
    }
    componentWillUnmount() {
        const { accelerator: accelerator } = this.props;
        const accelerators = this.getAccelerators(accelerator);
        this.unbindAccelerators(accelerators);
    }
    getAccelerators(accelerator) {
        return Array.isArray(accelerator) ? accelerator : [
            accelerator
        ];
    }
    getShortcutConflicts(accelerators) {
        return accelerators.map((a)=>({
                accelerator: a,
                conflictType: $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a]
            })).filter((o)=>o.conflictType);
    }
    isConfluenceShortcutAndAllConflictsAreForgeShortcuts(shortcutType, shortcutConflicts) {
        return shortcutType === "Confluence" && shortcutConflicts.every((o)=>o.conflictType === "Forge");
    }
    checkConflictThenBindAccelerator(accelerator, shortcutType) {
        const accelerators = this.getAccelerators(accelerator);
        const shortcutConflicts = this.getShortcutConflicts(accelerators);
        if (!shortcutConflicts.length) this.bindAccelerators(accelerators, shortcutType);
        else if (this.isConfluenceShortcutAndAllConflictsAreForgeShortcuts(shortcutType, shortcutConflicts)) {
            shortcutConflicts.forEach((c)=>(0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).unbind(c.accelerator));
            this.bindAccelerators(accelerators, shortcutType);
        }
    }
    bindAccelerators(accelerators, shortcutType) {
        accelerators.forEach((a)=>{
            if (a.includes('+') && shortcutType !== "Forge" && typeof (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).bindGlobal === 'function') // bindGlobal allows shortcut to work when a input field is focused, see https://github.com/ccampbell/mousetrap/blob/master/plugins/global-bind/README.md
            // This allows user to use shortcut to publish the page when focusing on editor title
            (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).bindGlobal(a, this._call);
            else (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).bind(a, this._call);
            $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a] = shortcutType;
        });
    }
    unbindAccelerators(accelerators) {
        accelerators.forEach((a)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).unbind(a);
            delete $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a];
        });
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        this.listeners = {};
        this.lastFired = 0;
        this._call = (e, combo)=>{
            // User can only fire a shortcut event in every 150ms
            // This can avoid a part of sequence being recognized as a single key shortcut
            // eg: "s" will be triggered when user enters "g s" without this
            const now = Date.now();
            if (now - this.lastFired >= $299ae5ea83dc6310$var$ALLOWED_MIN_TIME) {
                if (this.props.allowInDialog || !(0, $l65Bo.isDialogShown)()) {
                    this.lastFired = now;
                    this.props.listener(e, combo);
                }
            }
        };
    }
}
$299ae5ea83dc6310$export$d29b063d6e86bfeb.defaultProps = {
    allowInDialog: false,
    shortcutType: "Confluence"
};
$299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners = {};
const $299ae5ea83dc6310$var$ShortcutListenerFC = (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    let accelerator;
    let deprecatedAccelerator;
    let flags;
    let listener;
    let otherProps;
    if ($[0] !== t0) {
        ({ flags: flags, deprecatedAccelerator: deprecatedAccelerator, accelerator: accelerator, listener: listener, ...otherProps } = t0);
        $[0] = t0;
        $[1] = accelerator;
        $[2] = deprecatedAccelerator;
        $[3] = flags;
        $[4] = listener;
        $[5] = otherProps;
    } else {
        accelerator = $[1];
        deprecatedAccelerator = $[2];
        flags = $[3];
        listener = $[4];
        otherProps = $[5];
    }
    let t1;
    if ($[6] !== accelerator || $[7] !== deprecatedAccelerator || $[8] !== flags || $[9] !== listener) {
        t1 = (e, combo)=>{
            (0, $4q9NN.maybeShowDeprecatedShortcutFlag)({
                flags: flags,
                acceleratorTriggered: combo,
                accelerator: accelerator,
                deprecatedAccelerator: deprecatedAccelerator
            });
            listener(e, combo);
        };
        $[6] = accelerator;
        $[7] = deprecatedAccelerator;
        $[8] = flags;
        $[9] = listener;
        $[10] = t1;
    } else t1 = $[10];
    const deprecatedListener = t1;
    let t2;
    if ($[11] !== deprecatedAccelerator || $[12] !== deprecatedListener || $[13] !== otherProps) {
        t2 = deprecatedAccelerator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($299ae5ea83dc6310$export$d29b063d6e86bfeb, {
            accelerator: deprecatedAccelerator,
            listener: deprecatedListener,
            ...otherProps
        });
        $[11] = deprecatedAccelerator;
        $[12] = deprecatedListener;
        $[13] = otherProps;
        $[14] = t2;
    } else t2 = $[14];
    let t3;
    if ($[15] !== accelerator || $[16] !== listener || $[17] !== otherProps) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($299ae5ea83dc6310$export$d29b063d6e86bfeb, {
            accelerator: accelerator,
            listener: listener,
            ...otherProps
        });
        $[15] = accelerator;
        $[16] = listener;
        $[17] = otherProps;
        $[18] = t3;
    } else t3 = $[18];
    let t4;
    if ($[19] !== t2 || $[20] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t2, t3);
        $[19] = t2;
        $[20] = t3;
        $[21] = t4;
    } else t4 = $[21];
    return t4;
};
const $299ae5ea83dc6310$export$52e6eadeebf8c534 = (0, $7aRa9.withFlags)($299ae5ea83dc6310$var$ShortcutListenerFC);
module.exports["ShortcutType"] = $299ae5ea83dc6310$export$99058db374262376;
module.exports["ShortcutListener"] = $299ae5ea83dc6310$export$52e6eadeebf8c534;

});

parcelRegister("9EemN", function(module, exports) {
/*global define:false */ /**
 * Copyright 2012-2017 Craig Campbell
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Mousetrap is a simple keyboard shortcut library for Javascript with
 * no external dependencies
 *
 * @version 1.6.5
 * @url craig.is/killing/mice
 */ (function(window1, document1, undefined) {
    // Check if mousetrap is used inside browser, if not, return
    if (!window1) return;
    /**
     * mapping of special keycodes to their corresponding keys
     *
     * everything in this dictionary cannot use keypress events
     * so it has to be here to map to the correct keycodes for
     * keyup/keydown events
     *
     * @type {Object}
     */ var _MAP = {
        8: 'backspace',
        9: 'tab',
        13: 'enter',
        16: 'shift',
        17: 'ctrl',
        18: 'alt',
        20: 'capslock',
        27: 'esc',
        32: 'space',
        33: 'pageup',
        34: 'pagedown',
        35: 'end',
        36: 'home',
        37: 'left',
        38: 'up',
        39: 'right',
        40: 'down',
        45: 'ins',
        46: 'del',
        91: 'meta',
        93: 'meta',
        224: 'meta'
    };
    /**
     * mapping for special characters so they can support
     *
     * this dictionary is only used incase you want to bind a
     * keyup or keydown event to one of these keys
     *
     * @type {Object}
     */ var _KEYCODE_MAP = {
        106: '*',
        107: '+',
        109: '-',
        110: '.',
        111: '/',
        186: ';',
        187: '=',
        188: ',',
        189: '-',
        190: '.',
        191: '/',
        192: '`',
        219: '[',
        220: '\\',
        221: ']',
        222: '\''
    };
    /**
     * this is a mapping of keys that require shift on a US keypad
     * back to the non shift equivelents
     *
     * this is so you can use keyup events with these keys
     *
     * note that this will only work reliably on US keyboards
     *
     * @type {Object}
     */ var _SHIFT_MAP = {
        '~': '`',
        '!': '1',
        '@': '2',
        '#': '3',
        '$': '4',
        '%': '5',
        '^': '6',
        '&': '7',
        '*': '8',
        '(': '9',
        ')': '0',
        '_': '-',
        '+': '=',
        ':': ';',
        '\"': '\'',
        '<': ',',
        '>': '.',
        '?': '/',
        '|': '\\'
    };
    /**
     * this is a list of special strings you can use to map
     * to modifier keys when you specify your keyboard shortcuts
     *
     * @type {Object}
     */ var _SPECIAL_ALIASES = {
        'option': 'alt',
        'command': 'meta',
        'return': 'enter',
        'escape': 'esc',
        'plus': '+',
        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
    };
    /**
     * variable to store the flipped version of _MAP from above
     * needed to check if we should use keypress or not when no action
     * is specified
     *
     * @type {Object|undefined}
     */ var _REVERSE_MAP;
    /**
     * loop through the f keys, f1 to f19 and add them to the map
     * programatically
     */ for(var i = 1; i < 20; ++i)_MAP[111 + i] = 'f' + i;
    /**
     * loop through to map numbers on the numeric keypad
     */ for(i = 0; i <= 9; ++i)// This needs to use a string cause otherwise since 0 is falsey
    // mousetrap will never fire for numpad 0 pressed as part of a keydown
    // event.
    //
    // @see https://github.com/ccampbell/mousetrap/pull/258
    _MAP[i + 96] = i.toString();
    /**
     * cross browser add event method
     *
     * @param {Element|HTMLDocument} object
     * @param {string} type
     * @param {Function} callback
     * @returns void
     */ function _addEvent(object, type, callback) {
        if (object.addEventListener) {
            object.addEventListener(type, callback, false);
            return;
        }
        object.attachEvent('on' + type, callback);
    }
    /**
     * takes the event and returns the key character
     *
     * @param {Event} e
     * @return {string}
     */ function _characterFromEvent(e) {
        // for keypress events we should return the character as is
        if (e.type == 'keypress') {
            var character = String.fromCharCode(e.which);
            // if the shift key is not pressed then it is safe to assume
            // that we want the character to be lowercase.  this means if
            // you accidentally have caps lock on then your key bindings
            // will continue to work
            //
            // the only side effect that might not be desired is if you
            // bind something like 'A' cause you want to trigger an
            // event when capital A is pressed caps lock will no longer
            // trigger the event.  shift+a will though.
            if (!e.shiftKey) character = character.toLowerCase();
            return character;
        }
        // for non keypress events the special maps are needed
        if (_MAP[e.which]) return _MAP[e.which];
        if (_KEYCODE_MAP[e.which]) return _KEYCODE_MAP[e.which];
        // if it is not in the special map
        // with keydown and keyup events the character seems to always
        // come in as an uppercase character whether you are pressing shift
        // or not.  we should make sure it is always lowercase for comparisons
        return String.fromCharCode(e.which).toLowerCase();
    }
    /**
     * checks if two arrays are equal
     *
     * @param {Array} modifiers1
     * @param {Array} modifiers2
     * @returns {boolean}
     */ function _modifiersMatch(modifiers1, modifiers2) {
        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
    }
    /**
     * takes a key event and figures out what the modifiers are
     *
     * @param {Event} e
     * @returns {Array}
     */ function _eventModifiers(e) {
        var modifiers = [];
        if (e.shiftKey) modifiers.push('shift');
        if (e.altKey) modifiers.push('alt');
        if (e.ctrlKey) modifiers.push('ctrl');
        if (e.metaKey) modifiers.push('meta');
        return modifiers;
    }
    /**
     * prevents default for this event
     *
     * @param {Event} e
     * @returns void
     */ function _preventDefault(e) {
        if (e.preventDefault) {
            e.preventDefault();
            return;
        }
        e.returnValue = false;
    }
    /**
     * stops propogation for this event
     *
     * @param {Event} e
     * @returns void
     */ function _stopPropagation(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
            return;
        }
        e.cancelBubble = true;
    }
    /**
     * determines if the keycode specified is a modifier key or not
     *
     * @param {string} key
     * @returns {boolean}
     */ function _isModifier(key) {
        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
    }
    /**
     * reverses the map lookup so that we can look for specific keys
     * to see what can and can't use keypress
     *
     * @return {Object}
     */ function _getReverseMap() {
        if (!_REVERSE_MAP) {
            _REVERSE_MAP = {};
            for(var key in _MAP){
                // pull out the numeric keypad from here cause keypress should
                // be able to detect the keys from the character
                if (key > 95 && key < 112) continue;
                if (_MAP.hasOwnProperty(key)) _REVERSE_MAP[_MAP[key]] = key;
            }
        }
        return _REVERSE_MAP;
    }
    /**
     * picks the best action based on the key combination
     *
     * @param {string} key - character for key
     * @param {Array} modifiers
     * @param {string=} action passed in
     */ function _pickBestAction(key, modifiers, action) {
        // if no action was picked in we should try to pick the one
        // that we think would work best for this key
        if (!action) action = _getReverseMap()[key] ? 'keydown' : 'keypress';
        // modifier keys don't work as expected with keypress,
        // switch to keydown
        if (action == 'keypress' && modifiers.length) action = 'keydown';
        return action;
    }
    /**
     * Converts from a string key combination to an array
     *
     * @param  {string} combination like "command+shift+l"
     * @return {Array}
     */ function _keysFromString(combination) {
        if (combination === '+') return [
            '+'
        ];
        combination = combination.replace(/\+{2}/g, '+plus');
        return combination.split('+');
    }
    /**
     * Gets info for a specific key combination
     *
     * @param  {string} combination key combination ("command+s" or "a" or "*")
     * @param  {string=} action
     * @returns {Object}
     */ function _getKeyInfo(combination, action) {
        var keys;
        var key;
        var i;
        var modifiers = [];
        // take the keys from this pattern and figure out what the actual
        // pattern is all about
        keys = _keysFromString(combination);
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            // normalize key names
            if (_SPECIAL_ALIASES[key]) key = _SPECIAL_ALIASES[key];
            // if this is not a keypress event then we should
            // be smart about using shift keys
            // this will only work for US keyboards however
            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
                key = _SHIFT_MAP[key];
                modifiers.push('shift');
            }
            // if this key is a modifier then add it to the list of modifiers
            if (_isModifier(key)) modifiers.push(key);
        }
        // depending on what the key combination is
        // we will try to pick the best event for it
        action = _pickBestAction(key, modifiers, action);
        return {
            key: key,
            modifiers: modifiers,
            action: action
        };
    }
    function _belongsTo(element, ancestor) {
        if (element === null || element === document1) return false;
        if (element === ancestor) return true;
        return _belongsTo(element.parentNode, ancestor);
    }
    function Mousetrap(targetElement) {
        var self = this;
        targetElement = targetElement || document1;
        if (!(self instanceof Mousetrap)) return new Mousetrap(targetElement);
        /**
         * element to attach key events to
         *
         * @type {Element}
         */ self.target = targetElement;
        /**
         * a list of all the callbacks setup via Mousetrap.bind()
         *
         * @type {Object}
         */ self._callbacks = {};
        /**
         * direct map of string combinations to callbacks used for trigger()
         *
         * @type {Object}
         */ self._directMap = {};
        /**
         * keeps track of what level each sequence is at since multiple
         * sequences can start out with the same sequence
         *
         * @type {Object}
         */ var _sequenceLevels = {};
        /**
         * variable to store the setTimeout call
         *
         * @type {null|number}
         */ var _resetTimer;
        /**
         * temporary state where we will ignore the next keyup
         *
         * @type {boolean|string}
         */ var _ignoreNextKeyup = false;
        /**
         * temporary state where we will ignore the next keypress
         *
         * @type {boolean}
         */ var _ignoreNextKeypress = false;
        /**
         * are we currently inside of a sequence?
         * type of action ("keyup" or "keydown" or "keypress") or false
         *
         * @type {boolean|string}
         */ var _nextExpectedAction = false;
        /**
         * resets all sequence counters except for the ones passed in
         *
         * @param {Object} doNotReset
         * @returns void
         */ function _resetSequences(doNotReset) {
            doNotReset = doNotReset || {};
            var activeSequences = false, key;
            for(key in _sequenceLevels){
                if (doNotReset[key]) {
                    activeSequences = true;
                    continue;
                }
                _sequenceLevels[key] = 0;
            }
            if (!activeSequences) _nextExpectedAction = false;
        }
        /**
         * finds all callbacks that match based on the keycode, modifiers,
         * and action
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event|Object} e
         * @param {string=} sequenceName - name of the sequence we are looking for
         * @param {string=} combination
         * @param {number=} level
         * @returns {Array}
         */ function _getMatches(character, modifiers, e, sequenceName, combination, level) {
            var i;
            var callback;
            var matches = [];
            var action = e.type;
            // if there are no events related to this keycode
            if (!self._callbacks[character]) return [];
            // if a modifier key is coming up on its own we should allow it
            if (action == 'keyup' && _isModifier(character)) modifiers = [
                character
            ];
            // loop through all callbacks for the key that was pressed
            // and see if any of them match
            for(i = 0; i < self._callbacks[character].length; ++i){
                callback = self._callbacks[character][i];
                // if a sequence name is not specified, but this is a sequence at
                // the wrong level then move onto the next match
                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) continue;
                // if the action we are looking for doesn't match the action we got
                // then we should keep going
                if (action != callback.action) continue;
                // if this is a keypress event and the meta key and control key
                // are not pressed that means that we need to only look at the
                // character, otherwise check the modifiers as well
                //
                // chrome will not fire a keypress if meta or control is down
                // safari will fire a keypress if meta or meta+shift is down
                // firefox will fire a keypress if meta or control is down
                if (action == 'keypress' && !e.metaKey && !e.ctrlKey || _modifiersMatch(modifiers, callback.modifiers)) {
                    // when you bind a combination or sequence a second time it
                    // should overwrite the first one.  if a sequenceName or
                    // combination is specified in this call it does just that
                    //
                    // @todo make deleting its own method?
                    var deleteCombo = !sequenceName && callback.combo == combination;
                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
                    if (deleteCombo || deleteSequence) self._callbacks[character].splice(i, 1);
                    matches.push(callback);
                }
            }
            return matches;
        }
        /**
         * actually calls the callback function
         *
         * if your callback function returns false this will use the jquery
         * convention - prevent default and stop propogation on the event
         *
         * @param {Function} callback
         * @param {Event} e
         * @returns void
         */ function _fireCallback(callback, e, combo, sequence) {
            // if this event should not happen stop here
            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) return;
            if (callback(e, combo) === false) {
                _preventDefault(e);
                _stopPropagation(e);
            }
        }
        /**
         * handles a character key event
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event} e
         * @returns void
         */ self._handleKey = function(character, modifiers, e) {
            var callbacks = _getMatches(character, modifiers, e);
            var i;
            var doNotReset = {};
            var maxLevel = 0;
            var processedSequenceCallback = false;
            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
            for(i = 0; i < callbacks.length; ++i)if (callbacks[i].seq) maxLevel = Math.max(maxLevel, callbacks[i].level);
            // loop through matching callbacks for this key event
            for(i = 0; i < callbacks.length; ++i){
                // fire for all sequence callbacks
                // this is because if for example you have multiple sequences
                // bound such as "g i" and "g t" they both need to fire the
                // callback for matching g cause otherwise you can only ever
                // match the first one
                if (callbacks[i].seq) {
                    // only fire callbacks for the maxLevel to prevent
                    // subsequences from also firing
                    //
                    // for example 'a option b' should not cause 'option b' to fire
                    // even though 'option b' is part of the other sequence
                    //
                    // any sequences that do not match here will be discarded
                    // below by the _resetSequences call
                    if (callbacks[i].level != maxLevel) continue;
                    processedSequenceCallback = true;
                    // keep a list of which sequences were matches for later
                    doNotReset[callbacks[i].seq] = 1;
                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
                    continue;
                }
                // if there were no sequence matches but we are still here
                // that means this is a regular match so we should fire that
                if (!processedSequenceCallback) _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
            }
            // if the key you pressed matches the type of sequence without
            // being a modifier (ie "keyup" or "keypress") then we should
            // reset all sequences that were not matched by this event
            //
            // this is so, for example, if you have the sequence "h a t" and you
            // type "h e a r t" it does not match.  in this case the "e" will
            // cause the sequence to reset
            //
            // modifier keys are ignored because you can have a sequence
            // that contains modifiers such as "enter ctrl+space" and in most
            // cases the modifier key will be pressed before the next key
            //
            // also if you have a sequence such as "ctrl+b a" then pressing the
            // "b" key will trigger a "keypress" and a "keydown"
            //
            // the "keydown" is expected when there is a modifier, but the
            // "keypress" ends up matching the _nextExpectedAction since it occurs
            // after and that causes the sequence to reset
            //
            // we ignore keypresses in a sequence that directly follow a keydown
            // for the same character
            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) _resetSequences(doNotReset);
            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
        };
        /**
         * handles a keydown event
         *
         * @param {Event} e
         * @returns void
         */ function _handleKeyEvent(e) {
            // normalize e.which for key events
            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
            if (typeof e.which !== 'number') e.which = e.keyCode;
            var character = _characterFromEvent(e);
            // no character found then stop
            if (!character) return;
            // need to use === for the character check because the character can be 0
            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
                _ignoreNextKeyup = false;
                return;
            }
            self.handleKey(character, _eventModifiers(e), e);
        }
        /**
         * called to set a 1 second timeout on the specified sequence
         *
         * this is so after each key press in the sequence you have 1 second
         * to press the next key before you have to start over
         *
         * @returns void
         */ function _resetSequenceTimer() {
            clearTimeout(_resetTimer);
            _resetTimer = setTimeout(_resetSequences, 1000);
        }
        /**
         * binds a key sequence to an event
         *
         * @param {string} combo - combo specified in bind call
         * @param {Array} keys
         * @param {Function} callback
         * @param {string=} action
         * @returns void
         */ function _bindSequence(combo, keys, callback, action) {
            // start off by adding a sequence level record for this combination
            // and setting the level to 0
            _sequenceLevels[combo] = 0;
            /**
             * callback to increase the sequence level for this sequence and reset
             * all other sequences that were active
             *
             * @param {string} nextAction
             * @returns {Function}
             */ function _increaseSequence(nextAction) {
                return function() {
                    _nextExpectedAction = nextAction;
                    ++_sequenceLevels[combo];
                    _resetSequenceTimer();
                };
            }
            /**
             * wraps the specified callback inside of another function in order
             * to reset all sequence counters as soon as this sequence is done
             *
             * @param {Event} e
             * @returns void
             */ function _callbackAndReset(e) {
                _fireCallback(callback, e, combo);
                // we should ignore the next key up if the action is key down
                // or keypress.  this is so if you finish a sequence and
                // release the key the final key will not trigger a keyup
                if (action !== 'keyup') _ignoreNextKeyup = _characterFromEvent(e);
                // weird race condition if a sequence ends with the key
                // another sequence begins with
                setTimeout(_resetSequences, 10);
            }
            // loop through keys one at a time and bind the appropriate callback
            // function.  for any key leading up to the final one it should
            // increase the sequence. after the final, it should reset all sequences
            //
            // if an action is specified in the original bind call then that will
            // be used throughout.  otherwise we will pass the action that the
            // next key in the sequence should match.  this allows a sequence
            // to mix and match keypress and keydown events depending on which
            // ones are better suited to the key provided
            for(var i = 0; i < keys.length; ++i){
                var isFinal = i + 1 === keys.length;
                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
                _bindSingle(keys[i], wrappedCallback, action, combo, i);
            }
        }
        /**
         * binds a single keyboard combination
         *
         * @param {string} combination
         * @param {Function} callback
         * @param {string=} action
         * @param {string=} sequenceName - name of sequence if part of sequence
         * @param {number=} level - what part of the sequence the command is
         * @returns void
         */ function _bindSingle(combination, callback, action, sequenceName, level) {
            // store a direct mapped reference for use with Mousetrap.trigger
            self._directMap[combination + ':' + action] = callback;
            // make sure multiple spaces in a row become a single space
            combination = combination.replace(/\s+/g, ' ');
            var sequence = combination.split(' ');
            var info;
            // if this pattern is a sequence of keys then run through this method
            // to reprocess each pattern one key at a time
            if (sequence.length > 1) {
                _bindSequence(combination, sequence, callback, action);
                return;
            }
            info = _getKeyInfo(combination, action);
            // make sure to initialize array if this is the first time
            // a callback is added for this key
            self._callbacks[info.key] = self._callbacks[info.key] || [];
            // remove an existing match if there is one
            _getMatches(info.key, info.modifiers, {
                type: info.action
            }, sequenceName, combination, level);
            // add this call back to the array
            // if it is a sequence put it at the beginning
            // if not put it at the end
            //
            // this is important because the way these are processed expects
            // the sequence ones to come first
            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
                callback: callback,
                modifiers: info.modifiers,
                action: info.action,
                seq: sequenceName,
                level: level,
                combo: combination
            });
        }
        /**
         * binds multiple combinations to the same callback
         *
         * @param {Array} combinations
         * @param {Function} callback
         * @param {string|undefined} action
         * @returns void
         */ self._bindMultiple = function(combinations, callback, action) {
            for(var i = 0; i < combinations.length; ++i)_bindSingle(combinations[i], callback, action);
        };
        // start!
        _addEvent(targetElement, 'keypress', _handleKeyEvent);
        _addEvent(targetElement, 'keydown', _handleKeyEvent);
        _addEvent(targetElement, 'keyup', _handleKeyEvent);
    }
    /**
     * binds an event to mousetrap
     *
     * can be a single key, a combination of keys separated with +,
     * an array of keys, or a sequence of keys separated by spaces
     *
     * be sure to list the modifier keys first to make sure that the
     * correct key ends up getting bound (the last key in the pattern)
     *
     * @param {string|Array} keys
     * @param {Function} callback
     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
     * @returns void
     */ Mousetrap.prototype.bind = function(keys, callback, action) {
        var self = this;
        keys = keys instanceof Array ? keys : [
            keys
        ];
        self._bindMultiple.call(self, keys, callback, action);
        return self;
    };
    /**
     * unbinds an event to mousetrap
     *
     * the unbinding sets the callback function of the specified key combo
     * to an empty function and deletes the corresponding key in the
     * _directMap dict.
     *
     * TODO: actually remove this from the _callbacks dictionary instead
     * of binding an empty function
     *
     * the keycombo+action has to be exactly the same as
     * it was defined in the bind method
     *
     * @param {string|Array} keys
     * @param {string} action
     * @returns void
     */ Mousetrap.prototype.unbind = function(keys, action) {
        var self = this;
        return self.bind.call(self, keys, function() {}, action);
    };
    /**
     * triggers an event that has already been bound
     *
     * @param {string} keys
     * @param {string=} action
     * @returns void
     */ Mousetrap.prototype.trigger = function(keys, action) {
        var self = this;
        if (self._directMap[keys + ':' + action]) self._directMap[keys + ':' + action]({}, keys);
        return self;
    };
    /**
     * resets the library back to its initial state.  this is useful
     * if you want to clear out the current keyboard shortcuts and bind
     * new ones - for example if you switch to another page
     *
     * @returns void
     */ Mousetrap.prototype.reset = function() {
        var self = this;
        self._callbacks = {};
        self._directMap = {};
        return self;
    };
    /**
     * should we stop this event before firing off callbacks
     *
     * @param {Event} e
     * @param {Element} element
     * @return {boolean}
     */ Mousetrap.prototype.stopCallback = function(e, element) {
        var self = this;
        // if the element has the class "mousetrap" then no need to stop
        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) return false;
        if (_belongsTo(element, self.target)) return false;
        // Events originating from a shadow DOM are re-targetted and `e.target` is the shadow host,
        // not the initial event target in the shadow tree. Note that not all events cross the
        // shadow boundary.
        // For shadow trees with `mode: 'open'`, the initial event target is the first element in
        // the event’s composed path. For shadow trees with `mode: 'closed'`, the initial event
        // target cannot be obtained.
        if ('composedPath' in e && typeof e.composedPath === 'function') {
            // For open shadow trees, update `element` so that the following check works.
            var initialEventTarget = e.composedPath()[0];
            if (initialEventTarget !== e.target) element = initialEventTarget;
        }
        // stop for input, select, and textarea
        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
    };
    /**
     * exposes _handleKey publicly so it can be overwritten by extensions
     */ Mousetrap.prototype.handleKey = function() {
        var self = this;
        return self._handleKey.apply(self, arguments);
    };
    /**
     * allow custom key mappings
     */ Mousetrap.addKeycodes = function(object) {
        for(var key in object)if (object.hasOwnProperty(key)) _MAP[key] = object[key];
        _REVERSE_MAP = null;
    };
    /**
     * Init the global mousetrap functions
     *
     * This method is needed to allow the global mousetrap functions to work
     * now that mousetrap is a constructor function.
     */ Mousetrap.init = function() {
        var documentMousetrap = Mousetrap(document1);
        for(var method in documentMousetrap)if (method.charAt(0) !== '_') Mousetrap[method] = function(method) {
            return function() {
                return documentMousetrap[method].apply(documentMousetrap, arguments);
            };
        }(method);
    };
    Mousetrap.init();
    // expose mousetrap to the global object
    window1.Mousetrap = Mousetrap;
    // expose as a common js module
    if (module.exports) module.exports = Mousetrap;
    // expose mousetrap as an AMD module
    if (typeof define === 'function' && define.amd) define(function() {
        return Mousetrap;
    });
})(typeof window !== 'undefined' ? window : null, typeof window !== 'undefined' ? document : null);

});

parcelRegister("1syzX", function(module, exports) {
/**
 * adds a bindGlobal method to Mousetrap that allows you to
 * bind specific keyboard shortcuts that will still work
 * inside a text input field
 *
 * usage:
 * Mousetrap.bindGlobal('ctrl+s', _saveChanges);
 */ /* global Mousetrap:true */ (function(Mousetrap1) {
    if (!Mousetrap1) return;
    var _globalCallbacks = {};
    var _originalStopCallback = Mousetrap1.prototype.stopCallback;
    Mousetrap1.prototype.stopCallback = function(e, element, combo, sequence) {
        var self = this;
        if (self.paused) return true;
        if (_globalCallbacks[combo] || _globalCallbacks[sequence]) return false;
        return _originalStopCallback.call(self, e, element, combo);
    };
    Mousetrap1.prototype.bindGlobal = function(keys, callback, action) {
        var self = this;
        self.bind(keys, callback, action);
        if (keys instanceof Array) {
            for(var i = 0; i < keys.length; i++)_globalCallbacks[keys[i]] = true;
            return;
        }
        _globalCallbacks[keys] = true;
    };
    Mousetrap1.init();
})(typeof Mousetrap !== "undefined" ? Mousetrap : undefined);

});

parcelRegister("l65Bo", function(module, exports) {
// we'd like to be able to check if the dialog is displaying right now
const $0afa19b4dc37db45$export$f0b76e53a3d1db73 = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const portals = Array.from(document.getElementsByClassName('atlaskit-portal')).filter((portal)=>portal.firstChild);
    const isAtlaskitDialogShown = Boolean(portals.filter((item)=>item.querySelectorAll('[role="dialog"]').length).length);
    const isLoomRecorderDialogShown = Boolean(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.getElementById('loom-sdk-record-overlay-shadow-root-id')?.shadowRoot?.getElementById('preview-recording'));
    return isAtlaskitDialogShown || isLoomRecorderDialogShown;
};
module.exports["isDialogShown"] = $0afa19b4dc37db45$export$f0b76e53a3d1db73;

});

parcelRegister("1k6sE", function(module, exports) {

var $gnkil = parcelRequire("gnkil");


var $9aQ0J = parcelRequire("9aQ0J");

const $ca7c59da1dc6c0fe$export$d05888cf23195902 = 'shortcuts-are-allowed';
const $ca7c59da1dc6c0fe$export$ccca490433ac184a = 'shortcuts-are-allowed-in-modal';
const $ca7c59da1dc6c0fe$export$95466aa5e4023a13 = [
    'ProseMirror-focused',
    $ca7c59da1dc6c0fe$export$d05888cf23195902
];
const $ca7c59da1dc6c0fe$export$eca1f9acdad825ae = [
    $ca7c59da1dc6c0fe$export$ccca490433ac184a
];
const $ca7c59da1dc6c0fe$export$a6834c81db6fbcc7 = Object.values($gnkil).reduce((0, $9aQ0J.getShortcutValues), []);
module.exports["ALLOW_SHORTCUTS_CLASS"] = $ca7c59da1dc6c0fe$export$d05888cf23195902;
module.exports["ALLOW_SHORTCUTS_CLASS_IN_MODAL"] = $ca7c59da1dc6c0fe$export$ccca490433ac184a;
module.exports["MOUSETRAP_ALLOWED_ELEMENTS"] = $ca7c59da1dc6c0fe$export$95466aa5e4023a13;
module.exports["MOUSETRAP_ALLOWED_MODALS"] = $ca7c59da1dc6c0fe$export$eca1f9acdad825ae;
module.exports["RESERVED_SHORTCUTS"] = $ca7c59da1dc6c0fe$export$a6834c81db6fbcc7;

});

parcelRegister("9aQ0J", function(module, exports) {
const $a5d5607ba4daeddb$export$58cbf3bcb054e9cd = (accumulated, current)=>{
    if (typeof current === 'string') accumulated.push(current);
    else if (typeof current === 'object') accumulated.push(...Object.values(current).reduce($a5d5607ba4daeddb$export$58cbf3bcb054e9cd, []));
    return accumulated;
};
module.exports["getShortcutValues"] = $a5d5607ba4daeddb$export$58cbf3bcb054e9cd;

});

parcelRegister("4q9NN", function(module, exports) {
/* DeprecatedShortcutFlag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $4tOXV = parcelRequire("4tOXV");

const $3c4669a4d8882aac$var$i18n = (0, $kSwu1.defineMessages)({
    deprecatedShortcutFlagTitle: {
        id: "shortcuts.deprecated-shortcut-flag.title",
        defaultMessage: "This shortcut is about to change"
    },
    deprecatedShortcutFlagDescription: {
        id: "shortcuts.deprecated-shortcut-flag.description",
        defaultMessage: "Shortcuts are switching to a <supportLink>universal format</supportLink>. <inline>{oldShortcut} will now be {newShortcut}</inline>"
    },
    remindMeLaterButton: {
        id: "shortcuts.deprecated-shortcut-flag.button.remind-me-later",
        defaultMessage: "Remind me later"
    },
    dontTellMeAgainButton: {
        id: "shortcuts.deprecated-shortcut-flag.button.dont-tell-me-again",
        defaultMessage: "Don\u2019t tell me again"
    }
});
const $3c4669a4d8882aac$var$KEYBOARD_SHORTCUTS_SUPPORT_LINK = 'https://support.atlassian.com/confluence-cloud/docs/keyboard-shortcuts-markdown-and-autocomplete/';
const $3c4669a4d8882aac$var$shortcutSentenceCss = null;
const $3c4669a4d8882aac$var$getShortcutDescription = ({ oldShortcut: oldShortcut, newShortcut: newShortcut, acceleratorTriggered: acceleratorTriggered })=>{
    let newS = Array.isArray(newShortcut) ? newShortcut[0] : newShortcut; // ShortcutListener allows for multiple accelerators to be specified for one callback.  Ex. ["a", "mod+9"].
    // If any of those are triggerred, the callback will activate.
    // This makes it a little tricky to figure out what accelerator to recommend as a replacement.
    // Ex. deprecatedAccelerator: ["a", "b"], accelerator: ["mod+a", "mod+b"]
    // - If multiple accelerators are available in `newShortcut`, we default to the first one.
    // - However, if an equal number of accelerators are available in `oldShortcut` and `newShortcut`,
    //   then we look for the accelerator corresponding with the one that was actually triggered,
    //   based on array index.
    if (Array.isArray(oldShortcut) && Array.isArray(newShortcut) && oldShortcut.length === newShortcut.length) {
        const triggeredIndex = oldShortcut.indexOf(acceleratorTriggered);
        if (triggeredIndex >= 0 && triggeredIndex < newShortcut.length) newS = newShortcut[triggeredIndex];
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$3c4669a4d8882aac$var$i18n.deprecatedShortcutFlagDescription,
        values: {
            supportLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    target: "_blank",
                    href: $3c4669a4d8882aac$var$KEYBOARD_SHORTCUTS_SUPPORT_LINK
                }, chunks),
            oldShortcut: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: acceleratorTriggered
            }),
            newShortcut: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: newS
            }),
            inline: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    className: (0, $hekY6.default)([
                        "_zulpv77o _1e0c1txw _4cvr1h6o"
                    ])
                }, chunks)
        }
    });
};
const $3c4669a4d8882aac$var$FOREVER = 'forever';
const $3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID = 'deprecatedShortcutFlag';
const $3c4669a4d8882aac$var$shouldShowDeprecationFlag = ()=>{
    const hiddenUntilTime = (0, $17wUi.confluenceLocalStorageInstance)?.getItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL) || '';
    if (hiddenUntilTime === $3c4669a4d8882aac$var$FOREVER) return false;
    else if (hiddenUntilTime !== '') {
        const hiddenUntilTimeInMs = Number(hiddenUntilTime);
        if (!isNaN(hiddenUntilTimeInMs)) return Date.now() > hiddenUntilTimeInMs;
    }
    return true;
};
const $3c4669a4d8882aac$export$799f01f4b30e66c7 = ({ flags: flags, acceleratorTriggered: acceleratorTriggered, accelerator: accelerator, deprecatedAccelerator: deprecatedAccelerator })=>{
    if ($3c4669a4d8882aac$var$shouldShowDeprecationFlag()) flags.showFlag({
        id: $3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3c4669a4d8882aac$var$i18n.deprecatedShortcutFlagTitle),
        description: $3c4669a4d8882aac$var$getShortcutDescription({
            oldShortcut: deprecatedAccelerator,
            newShortcut: accelerator,
            acceleratorTriggered: acceleratorTriggered
        }),
        type: 'success',
        close: 'never',
        // Needed to bypass the flags.hideAllFlags() that happens on some page transitions.
        actions: [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3c4669a4d8882aac$var$i18n.remindMeLaterButton),
                onClick: ()=>{
                    // Hide the prompt for 7 days.
                    (0, $17wUi.confluenceLocalStorageInstance)?.setItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL, Date.now() + 1000 * 60 * 60 * 24 * 7);
                    flags.hideFlag($3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID);
                }
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3c4669a4d8882aac$var$i18n.dontTellMeAgainButton),
                onClick: ()=>{
                    (0, $17wUi.confluenceLocalStorageInstance)?.setItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL, $3c4669a4d8882aac$var$FOREVER);
                    flags.hideFlag($3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID);
                }
            }
        ]
    });
};
module.exports["maybeShowDeprecatedShortcutFlag"] = $3c4669a4d8882aac$export$799f01f4b30e66c7;

});

parcelRegister("4GDP8", function(module, exports) {
function $d27310b4a47ce627$var$keepTrying(fn, times, interval) {
    if (!fn() && times) setTimeout(()=>$d27310b4a47ce627$var$keepTrying(fn, times - 1, interval), interval);
}
function $d27310b4a47ce627$var$waitForDom(itemId) {
    return new Promise((resolve)=>{
        function lookForItem() {
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const targetItem = document.querySelector(itemId);
            if (targetItem) {
                clearInterval(checkInterval);
                resolve(true);
            }
        }
        // Start an interval to check for the item every 10ms
        const checkInterval = setInterval(lookForItem, 10);
        // Fail silently if the item isn't found after 5000ms
        setTimeout(()=>{
            clearInterval(checkInterval);
            resolve(false);
        }, 5000);
    });
}
function $d27310b4a47ce627$var$isForgeModule(itemId) {
    return itemId.startsWith('ari:cloud:ecosystem::extension');
}
function $d27310b4a47ce627$var$escapeForgeModuleKey(itemId) {
    return itemId.replace(/\//g, '\\/').replace(/:/g, '\\:');
}
function $d27310b4a47ce627$var$getItemSelector(itemId) {
    if (!itemId || !itemId.length) return;
    let itemSelector = itemId[0] === '#' ? itemId : `#${itemId}`;
    if ($d27310b4a47ce627$var$isForgeModule(itemId)) itemSelector = $d27310b4a47ce627$var$escapeForgeModuleKey(itemSelector);
    return itemSelector;
}
async function $d27310b4a47ce627$export$6bd4cdcdf3940391({ parentmenuId: parentmenuId, submenuId: submenuId, forgeItemId: forgeItemId }) {
    // Make sure the forge item has a valid id
    const forgeItemSelector = $d27310b4a47ce627$var$getItemSelector(forgeItemId);
    if (!forgeItemSelector) return;
    $d27310b4a47ce627$var$openMenu(parentmenuId);
    const foundSubmenu = await $d27310b4a47ce627$var$waitForDom(submenuId);
    if (!foundSubmenu) return;
    $d27310b4a47ce627$var$openMenu(submenuId);
    const foundForgeItem = await $d27310b4a47ce627$var$waitForDom(forgeItemSelector);
    if (!foundForgeItem) return;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const forgeItem = document.querySelector(forgeItemSelector);
    forgeItem?.click();
}
function $d27310b4a47ce627$var$openMenu(menuId) {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const triggerButton = document.querySelector(menuId);
    if (!triggerButton) return;
    const isOpen = triggerButton.getAttribute('aria-expanded') === 'true';
    //only care about closed case, otherwise let legacy event listener handle
    if (!isOpen) triggerButton.click();
}
function $d27310b4a47ce627$export$73ebde48694f32cd(itemId) {
    const itemSelector = $d27310b4a47ce627$var$getItemSelector(itemId);
    if (!itemSelector) return;
    $d27310b4a47ce627$var$keepTrying(()=>{
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const item = document.querySelector(itemSelector);
        if (item) {
            item.click();
            return true;
        }
    }, 100, 5);
}
function $d27310b4a47ce627$export$96aa6f6c7286ecb4(itemId) {
    const itemSelector = $d27310b4a47ce627$var$getItemSelector(itemId);
    if (!itemSelector) return;
    const event = new MouseEvent('mouseup', {
        bubbles: true,
        cancelable: true
    });
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector(itemSelector)?.dispatchEvent(event);
}
function $d27310b4a47ce627$export$1d6f959e29b7f60d() {
    $d27310b4a47ce627$var$openMenu('#tools-menu-trigger');
}
function $d27310b4a47ce627$export$3d4ff948da3c7dd3() {
    $d27310b4a47ce627$var$openMenu('#context-menu-other-apps');
}
function $d27310b4a47ce627$export$94323a98da3bb62c() {
    $d27310b4a47ce627$var$openMenu('#more-actions-trigger');
}
module.exports["openForgeAppFromSubmenu"] = $d27310b4a47ce627$export$6bd4cdcdf3940391;
module.exports["simulateItemClick"] = $d27310b4a47ce627$export$73ebde48694f32cd;
module.exports["simulateItemMouseOver"] = $d27310b4a47ce627$export$96aa6f6c7286ecb4;
module.exports["openMenuClick"] = $d27310b4a47ce627$export$1d6f959e29b7f60d;
module.exports["openContextMenuClick"] = $d27310b4a47ce627$export$3d4ff948da3c7dd3;
module.exports["openMoreActionsMenuClick"] = $d27310b4a47ce627$export$94323a98da3bb62c;

});

parcelRegister("dj3mI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

const $54a4a16d7bb73c56$export$35ad57ac36645074 = (isContentArchived, canAddComments, needsUpdateToComment, contentType)=>{
    if (isContentArchived) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "highlight-actions.inline-reactions.react.unsupported.archive",
        defaultMessage: "Reactions can't be added to archived content"
    });
    else if (!canAddComments) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "highlight-actions.inline-reactions.react.no.permission",
        defaultMessage: "{contentType, select, blogpost {You do not have permission to add reactions to this blogpost} page {You do not have permission to add reactions to this page} other {You do not have permission to add reactions to this page}}",
        values: {
            contentType: contentType
        }
    });
    else if (needsUpdateToComment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "highlight-actions.inline-reactions.react.needs.update",
        defaultMessage: "Page is outdated, refresh to react"
    });
    else if ((0, $6mKj3.expVal)('platform_synced_block', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "highlight-actions.inline-reactions.react.unable.to.create",
        defaultMessage: "Unable to react to this element"
    });
    else return (0, $9wGTI.fg)('editor_inline_comments_on_inline_nodes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "highlight-actions.inline-reactions.react.create.disabled",
        defaultMessage: "You can only react to text, headings, emojis, dates, mentions, links, and statuses."
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "highlight-actions.inline-reactions.react.unsupported",
        defaultMessage: "Reactions can only be added to text that doesn't contain an emoji, a macro, or an @mention"
    });
};
const $54a4a16d7bb73c56$export$52cdeba2896092f6 = (isContentArchived, userCanAddComments, needsUpdateToComment, contentType)=>{
    if (isContentArchived) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "highlight-actions.inline-comments.comment.unsupported.archive",
        defaultMessage: "Comments can\u2019t be added to archived items"
    });
    else if (!userCanAddComments) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "highlight-actions.inline-comments.comment.no.permission",
        defaultMessage: "{contentType, select, blogpost {You do not have permission to add comments to this blogpost} page {You do not have permission to add comments to this page} other {You do not have permission to add comments to this page}}",
        values: {
            contentType: contentType
        }
    });
    else if (needsUpdateToComment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "highlight-actions.inline-comments.comment.needs.update",
        defaultMessage: "Page is outdated, refresh to comment"
    });
    else if ((0, $6mKj3.expVal)('platform_synced_block', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "highlight-actions.inline-comments.comment.unable.to.create",
        defaultMessage: "Unable to comment on this element"
    });
    else return (0, $9wGTI.fg)('editor_inline_comments_on_inline_nodes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "highlight-actions.inline-comments.comment.create.disabled",
        defaultMessage: "You can only comment on text, headings, emojis, dates, mentions, links, and statuses."
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "highlight-actions.inline-comments.comment.unsupported",
        defaultMessage: "Comments can only be added to text that doesn\u2019t contain an emoji, a macro, or an @mention"
    });
};
module.exports["getReactionButtonDisabledMessage"] = $54a4a16d7bb73c56$export$35ad57ac36645074;
module.exports["getCreateButtonDisabledMessage"] = $54a4a16d7bb73c56$export$52cdeba2896092f6;

});

parcelRegister("6zmDz", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $164fd7006e7d8160$export$c5fb2fd13b5122a = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1yt4v77o _1e0c1txw _f7xt1kw7 _16711kw7 _1msb1txw _11ik1txw _5jgi1h6o _1d841h6o _3nzugktf _l4g2gktf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt4v77o _1e0c1txw _f7xt1kw7 _16711kw7 _1msb1txw _11ik1txw _5jgi1h6o _1d841h6o _3nzugktf _l4g2gktf",
            __cmplp.className
        ])
    });
});
const $164fd7006e7d8160$export$8729c6345a54240d = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1yt4v77o _1e0c1txw _f7xt1kw7 _16711kw7 _1msb1txw _11ik1txw _5jgi1h6o _1d841h6o _wzf91osq _9uby1osq _1dbr1txw _14ts1txw _1mu51h6o _wfjv1h6o _3nzugktf _l4g2gktf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt4v77o _1e0c1txw _f7xt1kw7 _16711kw7 _1msb1txw _11ik1txw _5jgi1h6o _1d841h6o _wzf91osq _9uby1osq _1dbr1txw _14ts1txw _1mu51h6o _wfjv1h6o _3nzugktf _l4g2gktf",
            __cmplp.className
        ])
    });
}); // remove this when cleanup platform_editor_controls
const $164fd7006e7d8160$export$d7f009f4a3abb74 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1yt41b66 _1e0c1txw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt41b66 _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $164fd7006e7d8160$var$disabledButtonWrapperStyle = null;
const $164fd7006e7d8160$export$b065c4c0e869841d = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_kqswh2mm"
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ $cozmU.createElement("div", {
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ $cozmU.createElement("div", {
        ...props,
        className: (0, $hekY6.default)([
            "_kqswh2mm"
        ])
    });
const $164fd7006e7d8160$var$disabledButtonOverlayStyle = null;
const $164fd7006e7d8160$export$dea79eb12e1f6e1f = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_kqswstnw _1bsb1osq _4t3i1osq _1pby15gg _bfhk1j28 _80om13gf"
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ $cozmU.createElement("div", {
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ $cozmU.createElement("div", {
        ...props,
        className: (0, $hekY6.default)([
            "_kqswstnw _1bsb1osq _4t3i1osq _1pby15gg _bfhk1j28 _80om13gf"
        ])
    });
const $164fd7006e7d8160$var$dividerStyleOld = null;
const $164fd7006e7d8160$export$fb1f035d38cc4d20 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_18s81o9c _1bsbt94y _bfhk1l7x"
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ $cozmU.createElement("div", {
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ $cozmU.createElement("div", {
        ...props,
        className: (0, $hekY6.default)([
            "_18s81o9c _1bsbt94y _bfhk1l7x"
        ])
    });
const $164fd7006e7d8160$var$dividerStyle = null;
const $164fd7006e7d8160$export$2e0a83ec2e27ecbb = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_1bsbt94y _bfhk1l7x _18u01b66 _2hwx1b66 _19pkr5cr _otyrr5cr"
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ $cozmU.createElement("div", {
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ $cozmU.createElement("div", {
        ...props,
        className: (0, $hekY6.default)([
            "_1bsbt94y _bfhk1l7x _18u01b66 _2hwx1b66 _19pkr5cr _otyrr5cr"
        ])
    });
module.exports["BuiltInActionsOld"] = $164fd7006e7d8160$export$c5fb2fd13b5122a;
module.exports["BuiltInActionsPatch"] = $164fd7006e7d8160$export$8729c6345a54240d;
module.exports["BuiltInActionsSimple"] = $164fd7006e7d8160$export$d7f009f4a3abb74;
module.exports["DisabledButtonWrapper"] = $164fd7006e7d8160$export$b065c4c0e869841d;
module.exports["DisabledButtonOverlay"] = $164fd7006e7d8160$export$dea79eb12e1f6e1f;
module.exports["DividerOld"] = $164fd7006e7d8160$export$fb1f035d38cc4d20;
module.exports["Divider"] = $164fd7006e7d8160$export$2e0a83ec2e27ecbb;

});

parcelRegister("97kfW", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $12914a8fd53705f4$var$lightBlueColor = '#2684FF';
const $12914a8fd53705f4$var$blueColor = '#0052CC';
const $12914a8fd53705f4$var$greyColor = "var(--ds-icon-disabled, #080F214A)";
const $12914a8fd53705f4$export$eaf821108be3620b = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(53);
    const { greyed: t1, size: t2 } = t0;
    const greyed = t1 === undefined ? false : t1;
    const size = t2 === undefined ? "small" : t2;
    const t3 = size === "smaller" ? "16" : size === "small" ? "18" : "24";
    const t4 = size === "smaller" ? "16" : size === "small" ? "18" : "24";
    let t5;
    let t6;
    let t7;
    let t8;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.1699 12C17.1699 11.4477 17.6176 11 18.1699 11H19.9999C20.5522 11 20.9999 11.4477 20.9999 12C20.9999 12.5523 20.5522 13 19.9999 13H18.1699C17.6176 13 17.1699 12.5523 17.1699 12Z",
            fill: "url(#paint0_linear_1733_293438)"
        });
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
            fill: "url(#paint1_linear_1733_293438)"
        });
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
            fill: "url(#paint2_linear_1733_293438)"
        });
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 17.1699C12.5523 17.1699 13 17.6176 13 18.1699V19.9999C13 20.5522 12.5523 20.9999 12 20.9999C11.4477 20.9999 11 20.5522 11 19.9999V18.1699C11 17.6176 11.4477 17.1699 12 17.1699Z",
            fill: "url(#paint3_linear_1733_293438)"
        });
        $[0] = t5;
        $[1] = t6;
        $[2] = t7;
        $[3] = t8;
    } else {
        t5 = $[0];
        t6 = $[1];
        t7 = $[2];
        t8 = $[3];
    }
    const t9 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor;
    let t10;
    if ($[4] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.2929 14.2929C14.6834 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0976 18.6834 20.0976 19.3166 19.7071 19.7071C19.3166 20.0976 18.6834 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
            fill: t9
        });
        $[4] = t9;
        $[5] = t10;
    } else t10 = $[5];
    const t11 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor;
    let t12;
    if ($[6] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.7071 4.29289C20.0976 4.68342 20.0976 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6834 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6834 3.90237 19.3166 3.90237 19.7071 4.29289Z",
            fill: t11
        });
        $[6] = t11;
        $[7] = t12;
    } else t12 = $[7];
    const t13 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor;
    let t14;
    if ($[8] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
            fill: t13
        });
        $[8] = t13;
        $[9] = t14;
    } else t14 = $[9];
    const t15 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor;
    let t16;
    if ($[10] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
            fill: t15
        });
        $[10] = t15;
        $[11] = t16;
    } else t16 = $[11];
    const t17 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor;
    let t18;
    if ($[12] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.270833",
            stopColor: t17
        });
        $[12] = t17;
        $[13] = t18;
    } else t18 = $[13];
    const t19 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$blueColor;
    let t20;
    if ($[14] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "1",
            stopColor: t19
        });
        $[14] = t19;
        $[15] = t20;
    } else t20 = $[15];
    let t21;
    if ($[16] !== t18 || $[17] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
            id: "paint0_linear_1733_293438",
            x1: "20.9999",
            y1: "12",
            x2: "17.4999",
            y2: "12",
            gradientUnits: "userSpaceOnUse"
        }, t18, t20);
        $[16] = t18;
        $[17] = t20;
        $[18] = t21;
    } else t21 = $[18];
    const t22 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor;
    let t23;
    if ($[19] !== t22) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.1875",
            stopColor: t22
        });
        $[19] = t22;
        $[20] = t23;
    } else t23 = $[20];
    const t24 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$blueColor;
    let t25;
    if ($[21] !== t24) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "1",
            stopColor: t24
        });
        $[21] = t24;
        $[22] = t25;
    } else t25 = $[22];
    let t26;
    if ($[23] !== t23 || $[24] !== t25) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
            id: "paint1_linear_1733_293438",
            x1: "12.5",
            y1: "3",
            x2: "12.5",
            y2: "6.5",
            gradientUnits: "userSpaceOnUse"
        }, t23, t25);
        $[23] = t23;
        $[24] = t25;
        $[25] = t26;
    } else t26 = $[25];
    const t27 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$blueColor;
    let t28;
    if ($[26] !== t27) {
        t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            stopColor: t27
        });
        $[26] = t27;
        $[27] = t28;
    } else t28 = $[27];
    const t29 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor;
    let t30;
    if ($[28] !== t29) {
        t30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.791667",
            stopColor: t29
        });
        $[28] = t29;
        $[29] = t30;
    } else t30 = $[29];
    let t31;
    if ($[30] !== t28 || $[31] !== t30) {
        t31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
            id: "paint2_linear_1733_293438",
            x1: "6.82996",
            y1: "12",
            x2: "3.32996",
            y2: "12",
            gradientUnits: "userSpaceOnUse"
        }, t28, t30);
        $[30] = t28;
        $[31] = t30;
        $[32] = t31;
    } else t31 = $[32];
    const t32 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$blueColor;
    let t33;
    if ($[33] !== t32) {
        t33 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            stopColor: t32
        });
        $[33] = t32;
        $[34] = t33;
    } else t33 = $[34];
    const t34 = greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor;
    let t35;
    if ($[35] !== t34) {
        t35 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
            offset: "0.802083",
            stopColor: t34
        });
        $[35] = t34;
        $[36] = t35;
    } else t35 = $[36];
    let t36;
    if ($[37] !== t33 || $[38] !== t35) {
        t36 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
            id: "paint3_linear_1733_293438",
            x1: "12.5",
            y1: "16.9999",
            x2: "12.5",
            y2: "20.9999",
            gradientUnits: "userSpaceOnUse"
        }, t33, t35);
        $[37] = t33;
        $[38] = t35;
        $[39] = t36;
    } else t36 = $[39];
    let t37;
    if ($[40] !== t21 || $[41] !== t26 || $[42] !== t31 || $[43] !== t36) {
        t37 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, t21, t26, t31, t36);
        $[40] = t21;
        $[41] = t26;
        $[42] = t31;
        $[43] = t36;
        $[44] = t37;
    } else t37 = $[44];
    let t38;
    if ($[45] !== t10 || $[46] !== t12 || $[47] !== t14 || $[48] !== t16 || $[49] !== t3 || $[50] !== t37 || $[51] !== t4) {
        t38 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: t3,
            height: t4,
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, t5, t6, t7, t8, t10, t12, t14, t16, t37);
        $[45] = t10;
        $[46] = t12;
        $[47] = t14;
        $[48] = t16;
        $[49] = t3;
        $[50] = t37;
        $[51] = t4;
        $[52] = t38;
    } else t38 = $[52];
    return t38;
} : ({ greyed: greyed = false, size: size = 'small' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: size === 'smaller' ? '16' : size === 'small' ? '18' : '24',
        height: size === 'smaller' ? '16' : size === 'small' ? '18' : '24',
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.1699 12C17.1699 11.4477 17.6176 11 18.1699 11H19.9999C20.5522 11 20.9999 11.4477 20.9999 12C20.9999 12.5523 20.5522 13 19.9999 13H18.1699C17.6176 13 17.1699 12.5523 17.1699 12Z",
        fill: "url(#paint0_linear_1733_293438)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
        fill: "url(#paint1_linear_1733_293438)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
        fill: "url(#paint2_linear_1733_293438)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 17.1699C12.5523 17.1699 13 17.6176 13 18.1699V19.9999C13 20.5522 12.5523 20.9999 12 20.9999C11.4477 20.9999 11 20.5522 11 19.9999V18.1699C11 17.6176 11.4477 17.1699 12 17.1699Z",
        fill: "url(#paint3_linear_1733_293438)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.2929 14.2929C14.6834 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0976 18.6834 20.0976 19.3166 19.7071 19.7071C19.3166 20.0976 18.6834 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
        fill: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.7071 4.29289C20.0976 4.68342 20.0976 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6834 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6834 3.90237 19.3166 3.90237 19.7071 4.29289Z",
        fill: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
        fill: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
        fill: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint0_linear_1733_293438",
        x1: "20.9999",
        y1: "12",
        x2: "17.4999",
        y2: "12",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.270833",
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$blueColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint1_linear_1733_293438",
        x1: "12.5",
        y1: "3",
        x2: "12.5",
        y2: "6.5",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.1875",
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$blueColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint2_linear_1733_293438",
        x1: "6.82996",
        y1: "12",
        x2: "3.32996",
        y2: "12",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$blueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.791667",
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint3_linear_1733_293438",
        x1: "12.5",
        y1: "16.9999",
        x2: "12.5",
        y2: "20.9999",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$blueColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.802083",
        stopColor: greyed ? $12914a8fd53705f4$var$greyColor : $12914a8fd53705f4$var$lightBlueColor
    }))));
module.exports["AtlassianIntelligenceIcon"] = $12914a8fd53705f4$export$eaf821108be3620b;

});

parcelRegister("3QARf", function(module, exports) {

let $2cd2d1a3be80073f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2cd2d1a3be80073f$var$load("hpN5y").then(()=>parcelRequire('jhEjP'));

});

parcelRegister("iUfh3", function(module, exports) {

let $dc394e17996c5bca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $dc394e17996c5bca$var$load("6wr18"),
    $dc394e17996c5bca$var$load("ffEVr"),
    $dc394e17996c5bca$var$load("gzrfp"),
    $dc394e17996c5bca$var$load("aSmvL")
]).then(()=>parcelRequire('1TWCG'));

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("6CGpi"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("fNLhu"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("l9I6S"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("1FlCb"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("2AXad"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("8nHhG"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("2oWhn"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("8hNmW"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("5d3mC"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("6BkVH"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("2v3uL"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("gUEvs"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("6CGpi", function(module, exports) {

let $4d272fd6858b43aa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4d272fd6858b43aa$var$load("hUbK8"),
    $4d272fd6858b43aa$var$load("eNXrl"),
    $4d272fd6858b43aa$var$load("2CrXe"),
    $4d272fd6858b43aa$var$load("beMmd"),
    $4d272fd6858b43aa$var$load("1Gr4q"),
    $4d272fd6858b43aa$var$load("ig9dh"),
    $4d272fd6858b43aa$var$load("hA8hA"),
    $4d272fd6858b43aa$var$load("7G12e"),
    $4d272fd6858b43aa$var$load("7oAXW"),
    $4d272fd6858b43aa$var$load("LWh5V"),
    $4d272fd6858b43aa$var$load("gbejv"),
    $4d272fd6858b43aa$var$load("GD9EA"),
    $4d272fd6858b43aa$var$load("h4Nf7"),
    $4d272fd6858b43aa$var$load("4XkGy"),
    $4d272fd6858b43aa$var$load("kHXvF"),
    $4d272fd6858b43aa$var$load("fuOfV"),
    $4d272fd6858b43aa$var$load("iZR3N"),
    $4d272fd6858b43aa$var$load("jXM1T"),
    $4d272fd6858b43aa$var$load("cvcNg"),
    $4d272fd6858b43aa$var$load("4N1MY"),
    $4d272fd6858b43aa$var$load("jL1Ke"),
    $4d272fd6858b43aa$var$load("5MQ0D"),
    $4d272fd6858b43aa$var$load("Kj0I8"),
    $4d272fd6858b43aa$var$load("5xnun"),
    $4d272fd6858b43aa$var$load("6wr18"),
    $4d272fd6858b43aa$var$load("59hV4"),
    $4d272fd6858b43aa$var$load("8zMmc"),
    $4d272fd6858b43aa$var$load("4x9Jx"),
    $4d272fd6858b43aa$var$load("ffEVr"),
    $4d272fd6858b43aa$var$load("eCXJR"),
    $4d272fd6858b43aa$var$load("1VTX2"),
    $4d272fd6858b43aa$var$load("jZMUd"),
    $4d272fd6858b43aa$var$load("2EIkU"),
    $4d272fd6858b43aa$var$load("7TnhR"),
    $4d272fd6858b43aa$var$load("ddvkk"),
    $4d272fd6858b43aa$var$load("3upHR"),
    $4d272fd6858b43aa$var$load("iUXaE"),
    $4d272fd6858b43aa$var$load("lTkx9"),
    $4d272fd6858b43aa$var$load("Wowvf"),
    $4d272fd6858b43aa$var$load("eRhBr"),
    $4d272fd6858b43aa$var$load("6HpsR"),
    $4d272fd6858b43aa$var$load("N3oqb"),
    $4d272fd6858b43aa$var$load("hZ2FX"),
    $4d272fd6858b43aa$var$load("hhss7"),
    $4d272fd6858b43aa$var$load("1NGPq"),
    $4d272fd6858b43aa$var$load("lnKog"),
    $4d272fd6858b43aa$var$load("kT6dz"),
    $4d272fd6858b43aa$var$load("aAWLw"),
    $4d272fd6858b43aa$var$load("7EorR"),
    $4d272fd6858b43aa$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("fNLhu", function(module, exports) {

let $b8101bae2f01cc7f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b8101bae2f01cc7f$var$load("hUbK8"),
    $b8101bae2f01cc7f$var$load("eNXrl"),
    $b8101bae2f01cc7f$var$load("2CrXe"),
    $b8101bae2f01cc7f$var$load("beMmd"),
    $b8101bae2f01cc7f$var$load("1Gr4q"),
    $b8101bae2f01cc7f$var$load("ig9dh"),
    $b8101bae2f01cc7f$var$load("hA8hA"),
    $b8101bae2f01cc7f$var$load("7G12e"),
    $b8101bae2f01cc7f$var$load("7oAXW"),
    $b8101bae2f01cc7f$var$load("LWh5V"),
    $b8101bae2f01cc7f$var$load("gbejv"),
    $b8101bae2f01cc7f$var$load("GD9EA"),
    $b8101bae2f01cc7f$var$load("h4Nf7"),
    $b8101bae2f01cc7f$var$load("4XkGy"),
    $b8101bae2f01cc7f$var$load("kHXvF"),
    $b8101bae2f01cc7f$var$load("fuOfV"),
    $b8101bae2f01cc7f$var$load("iZR3N"),
    $b8101bae2f01cc7f$var$load("jXM1T"),
    $b8101bae2f01cc7f$var$load("cvcNg"),
    $b8101bae2f01cc7f$var$load("4N1MY"),
    $b8101bae2f01cc7f$var$load("jL1Ke"),
    $b8101bae2f01cc7f$var$load("5MQ0D"),
    $b8101bae2f01cc7f$var$load("Kj0I8"),
    $b8101bae2f01cc7f$var$load("5xnun"),
    $b8101bae2f01cc7f$var$load("6wr18"),
    $b8101bae2f01cc7f$var$load("59hV4"),
    $b8101bae2f01cc7f$var$load("8zMmc"),
    $b8101bae2f01cc7f$var$load("4x9Jx"),
    $b8101bae2f01cc7f$var$load("ffEVr"),
    $b8101bae2f01cc7f$var$load("eCXJR"),
    $b8101bae2f01cc7f$var$load("1VTX2"),
    $b8101bae2f01cc7f$var$load("jZMUd"),
    $b8101bae2f01cc7f$var$load("2EIkU"),
    $b8101bae2f01cc7f$var$load("7TnhR"),
    $b8101bae2f01cc7f$var$load("ddvkk"),
    $b8101bae2f01cc7f$var$load("3upHR"),
    $b8101bae2f01cc7f$var$load("iUXaE"),
    $b8101bae2f01cc7f$var$load("lTkx9"),
    $b8101bae2f01cc7f$var$load("Wowvf"),
    $b8101bae2f01cc7f$var$load("eRhBr"),
    $b8101bae2f01cc7f$var$load("6HpsR"),
    $b8101bae2f01cc7f$var$load("N3oqb"),
    $b8101bae2f01cc7f$var$load("hZ2FX"),
    $b8101bae2f01cc7f$var$load("hhss7"),
    $b8101bae2f01cc7f$var$load("1NGPq"),
    $b8101bae2f01cc7f$var$load("lnKog"),
    $b8101bae2f01cc7f$var$load("kT6dz"),
    $b8101bae2f01cc7f$var$load("aAWLw"),
    $b8101bae2f01cc7f$var$load("7EorR"),
    $b8101bae2f01cc7f$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("l9I6S", function(module, exports) {

let $f66ca78fc2377f8b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f66ca78fc2377f8b$var$load("hUbK8"),
    $f66ca78fc2377f8b$var$load("eNXrl"),
    $f66ca78fc2377f8b$var$load("2CrXe"),
    $f66ca78fc2377f8b$var$load("beMmd"),
    $f66ca78fc2377f8b$var$load("1Gr4q"),
    $f66ca78fc2377f8b$var$load("ig9dh"),
    $f66ca78fc2377f8b$var$load("hA8hA"),
    $f66ca78fc2377f8b$var$load("7G12e"),
    $f66ca78fc2377f8b$var$load("7oAXW"),
    $f66ca78fc2377f8b$var$load("LWh5V"),
    $f66ca78fc2377f8b$var$load("gbejv"),
    $f66ca78fc2377f8b$var$load("GD9EA"),
    $f66ca78fc2377f8b$var$load("h4Nf7"),
    $f66ca78fc2377f8b$var$load("4XkGy"),
    $f66ca78fc2377f8b$var$load("kHXvF"),
    $f66ca78fc2377f8b$var$load("fuOfV"),
    $f66ca78fc2377f8b$var$load("iZR3N"),
    $f66ca78fc2377f8b$var$load("jXM1T"),
    $f66ca78fc2377f8b$var$load("cvcNg"),
    $f66ca78fc2377f8b$var$load("4N1MY"),
    $f66ca78fc2377f8b$var$load("jL1Ke"),
    $f66ca78fc2377f8b$var$load("5MQ0D"),
    $f66ca78fc2377f8b$var$load("Kj0I8"),
    $f66ca78fc2377f8b$var$load("5xnun"),
    $f66ca78fc2377f8b$var$load("6wr18"),
    $f66ca78fc2377f8b$var$load("59hV4"),
    $f66ca78fc2377f8b$var$load("8zMmc"),
    $f66ca78fc2377f8b$var$load("4x9Jx"),
    $f66ca78fc2377f8b$var$load("ffEVr"),
    $f66ca78fc2377f8b$var$load("eCXJR"),
    $f66ca78fc2377f8b$var$load("1VTX2"),
    $f66ca78fc2377f8b$var$load("jZMUd"),
    $f66ca78fc2377f8b$var$load("2EIkU"),
    $f66ca78fc2377f8b$var$load("7TnhR"),
    $f66ca78fc2377f8b$var$load("ddvkk"),
    $f66ca78fc2377f8b$var$load("3upHR"),
    $f66ca78fc2377f8b$var$load("iUXaE"),
    $f66ca78fc2377f8b$var$load("lTkx9"),
    $f66ca78fc2377f8b$var$load("Wowvf"),
    $f66ca78fc2377f8b$var$load("eRhBr"),
    $f66ca78fc2377f8b$var$load("6HpsR"),
    $f66ca78fc2377f8b$var$load("N3oqb"),
    $f66ca78fc2377f8b$var$load("hZ2FX"),
    $f66ca78fc2377f8b$var$load("hhss7"),
    $f66ca78fc2377f8b$var$load("1NGPq"),
    $f66ca78fc2377f8b$var$load("lnKog"),
    $f66ca78fc2377f8b$var$load("kT6dz"),
    $f66ca78fc2377f8b$var$load("aAWLw"),
    $f66ca78fc2377f8b$var$load("7EorR"),
    $f66ca78fc2377f8b$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("1FlCb", function(module, exports) {

let $136a630400913884$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $136a630400913884$var$load("hUbK8"),
    $136a630400913884$var$load("2CrXe"),
    $136a630400913884$var$load("beMmd"),
    $136a630400913884$var$load("1Gr4q"),
    $136a630400913884$var$load("ig9dh"),
    $136a630400913884$var$load("hA8hA"),
    $136a630400913884$var$load("7G12e"),
    $136a630400913884$var$load("7oAXW"),
    $136a630400913884$var$load("gbejv"),
    $136a630400913884$var$load("GD9EA"),
    $136a630400913884$var$load("h4Nf7"),
    $136a630400913884$var$load("kHXvF"),
    $136a630400913884$var$load("iZR3N"),
    $136a630400913884$var$load("jXM1T"),
    $136a630400913884$var$load("cvcNg"),
    $136a630400913884$var$load("6wr18"),
    $136a630400913884$var$load("4N1MY"),
    $136a630400913884$var$load("8zMmc"),
    $136a630400913884$var$load("4x9Jx"),
    $136a630400913884$var$load("ffEVr"),
    $136a630400913884$var$load("eCXJR"),
    $136a630400913884$var$load("1VTX2"),
    $136a630400913884$var$load("jZMUd"),
    $136a630400913884$var$load("2EIkU"),
    $136a630400913884$var$load("1NGPq"),
    $136a630400913884$var$load("7TnhR"),
    $136a630400913884$var$load("ddvkk"),
    $136a630400913884$var$load("3upHR"),
    $136a630400913884$var$load("iUXaE"),
    $136a630400913884$var$load("lTkx9"),
    $136a630400913884$var$load("Wowvf"),
    $136a630400913884$var$load("eRhBr"),
    $136a630400913884$var$load("6HpsR"),
    $136a630400913884$var$load("N3oqb"),
    $136a630400913884$var$load("hZ2FX"),
    $136a630400913884$var$load("hhss7"),
    $136a630400913884$var$load("kT6dz"),
    $136a630400913884$var$load("aAWLw"),
    $136a630400913884$var$load("7EorR"),
    $136a630400913884$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("2AXad", function(module, exports) {

let $1e3cd63f9461560d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1e3cd63f9461560d$var$load("hUbK8"),
    $1e3cd63f9461560d$var$load("2CrXe"),
    $1e3cd63f9461560d$var$load("beMmd"),
    $1e3cd63f9461560d$var$load("1Gr4q"),
    $1e3cd63f9461560d$var$load("ig9dh"),
    $1e3cd63f9461560d$var$load("hA8hA"),
    $1e3cd63f9461560d$var$load("7G12e"),
    $1e3cd63f9461560d$var$load("7oAXW"),
    $1e3cd63f9461560d$var$load("gbejv"),
    $1e3cd63f9461560d$var$load("GD9EA"),
    $1e3cd63f9461560d$var$load("h4Nf7"),
    $1e3cd63f9461560d$var$load("kHXvF"),
    $1e3cd63f9461560d$var$load("iZR3N"),
    $1e3cd63f9461560d$var$load("jXM1T"),
    $1e3cd63f9461560d$var$load("cvcNg"),
    $1e3cd63f9461560d$var$load("6wr18"),
    $1e3cd63f9461560d$var$load("4N1MY"),
    $1e3cd63f9461560d$var$load("8zMmc"),
    $1e3cd63f9461560d$var$load("4x9Jx"),
    $1e3cd63f9461560d$var$load("ffEVr"),
    $1e3cd63f9461560d$var$load("eCXJR"),
    $1e3cd63f9461560d$var$load("1VTX2"),
    $1e3cd63f9461560d$var$load("jZMUd"),
    $1e3cd63f9461560d$var$load("2EIkU"),
    $1e3cd63f9461560d$var$load("1NGPq"),
    $1e3cd63f9461560d$var$load("7TnhR"),
    $1e3cd63f9461560d$var$load("ddvkk"),
    $1e3cd63f9461560d$var$load("3upHR"),
    $1e3cd63f9461560d$var$load("iUXaE"),
    $1e3cd63f9461560d$var$load("lTkx9"),
    $1e3cd63f9461560d$var$load("Wowvf"),
    $1e3cd63f9461560d$var$load("eRhBr"),
    $1e3cd63f9461560d$var$load("6HpsR"),
    $1e3cd63f9461560d$var$load("N3oqb"),
    $1e3cd63f9461560d$var$load("hZ2FX"),
    $1e3cd63f9461560d$var$load("hhss7"),
    $1e3cd63f9461560d$var$load("kT6dz"),
    $1e3cd63f9461560d$var$load("aAWLw"),
    $1e3cd63f9461560d$var$load("7EorR"),
    $1e3cd63f9461560d$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("8nHhG", function(module, exports) {

let $61a20c0a0c16fe11$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $61a20c0a0c16fe11$var$load("hUbK8"),
    $61a20c0a0c16fe11$var$load("2CrXe"),
    $61a20c0a0c16fe11$var$load("beMmd"),
    $61a20c0a0c16fe11$var$load("1Gr4q"),
    $61a20c0a0c16fe11$var$load("ig9dh"),
    $61a20c0a0c16fe11$var$load("hA8hA"),
    $61a20c0a0c16fe11$var$load("7G12e"),
    $61a20c0a0c16fe11$var$load("7oAXW"),
    $61a20c0a0c16fe11$var$load("gbejv"),
    $61a20c0a0c16fe11$var$load("GD9EA"),
    $61a20c0a0c16fe11$var$load("h4Nf7"),
    $61a20c0a0c16fe11$var$load("kHXvF"),
    $61a20c0a0c16fe11$var$load("iZR3N"),
    $61a20c0a0c16fe11$var$load("jXM1T"),
    $61a20c0a0c16fe11$var$load("cvcNg"),
    $61a20c0a0c16fe11$var$load("6wr18"),
    $61a20c0a0c16fe11$var$load("4N1MY"),
    $61a20c0a0c16fe11$var$load("8zMmc"),
    $61a20c0a0c16fe11$var$load("4x9Jx"),
    $61a20c0a0c16fe11$var$load("ffEVr"),
    $61a20c0a0c16fe11$var$load("eCXJR"),
    $61a20c0a0c16fe11$var$load("1VTX2"),
    $61a20c0a0c16fe11$var$load("jZMUd"),
    $61a20c0a0c16fe11$var$load("2EIkU"),
    $61a20c0a0c16fe11$var$load("1NGPq"),
    $61a20c0a0c16fe11$var$load("7TnhR"),
    $61a20c0a0c16fe11$var$load("ddvkk"),
    $61a20c0a0c16fe11$var$load("3upHR"),
    $61a20c0a0c16fe11$var$load("iUXaE"),
    $61a20c0a0c16fe11$var$load("lTkx9"),
    $61a20c0a0c16fe11$var$load("Wowvf"),
    $61a20c0a0c16fe11$var$load("eRhBr"),
    $61a20c0a0c16fe11$var$load("6HpsR"),
    $61a20c0a0c16fe11$var$load("N3oqb"),
    $61a20c0a0c16fe11$var$load("hZ2FX"),
    $61a20c0a0c16fe11$var$load("hhss7"),
    $61a20c0a0c16fe11$var$load("kT6dz"),
    $61a20c0a0c16fe11$var$load("aAWLw"),
    $61a20c0a0c16fe11$var$load("7EorR"),
    $61a20c0a0c16fe11$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("2oWhn", function(module, exports) {

let $1bfb07b00ca46462$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1bfb07b00ca46462$var$load("hUbK8"),
    $1bfb07b00ca46462$var$load("2CrXe"),
    $1bfb07b00ca46462$var$load("beMmd"),
    $1bfb07b00ca46462$var$load("1Gr4q"),
    $1bfb07b00ca46462$var$load("ig9dh"),
    $1bfb07b00ca46462$var$load("hA8hA"),
    $1bfb07b00ca46462$var$load("7G12e"),
    $1bfb07b00ca46462$var$load("7oAXW"),
    $1bfb07b00ca46462$var$load("gbejv"),
    $1bfb07b00ca46462$var$load("GD9EA"),
    $1bfb07b00ca46462$var$load("h4Nf7"),
    $1bfb07b00ca46462$var$load("kHXvF"),
    $1bfb07b00ca46462$var$load("iZR3N"),
    $1bfb07b00ca46462$var$load("jXM1T"),
    $1bfb07b00ca46462$var$load("cvcNg"),
    $1bfb07b00ca46462$var$load("6wr18"),
    $1bfb07b00ca46462$var$load("4N1MY"),
    $1bfb07b00ca46462$var$load("8zMmc"),
    $1bfb07b00ca46462$var$load("4x9Jx"),
    $1bfb07b00ca46462$var$load("ffEVr"),
    $1bfb07b00ca46462$var$load("eCXJR"),
    $1bfb07b00ca46462$var$load("1VTX2"),
    $1bfb07b00ca46462$var$load("jZMUd"),
    $1bfb07b00ca46462$var$load("2EIkU"),
    $1bfb07b00ca46462$var$load("7TnhR"),
    $1bfb07b00ca46462$var$load("ddvkk"),
    $1bfb07b00ca46462$var$load("3upHR"),
    $1bfb07b00ca46462$var$load("iUXaE"),
    $1bfb07b00ca46462$var$load("lTkx9"),
    $1bfb07b00ca46462$var$load("Wowvf"),
    $1bfb07b00ca46462$var$load("eRhBr"),
    $1bfb07b00ca46462$var$load("6HpsR"),
    $1bfb07b00ca46462$var$load("N3oqb"),
    $1bfb07b00ca46462$var$load("hZ2FX"),
    $1bfb07b00ca46462$var$load("hhss7"),
    $1bfb07b00ca46462$var$load("1NGPq"),
    $1bfb07b00ca46462$var$load("lnKog"),
    $1bfb07b00ca46462$var$load("kT6dz"),
    $1bfb07b00ca46462$var$load("aAWLw"),
    $1bfb07b00ca46462$var$load("7EorR"),
    $1bfb07b00ca46462$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("8hNmW", function(module, exports) {

let $608634f1fe836d95$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $608634f1fe836d95$var$load("hUbK8"),
    $608634f1fe836d95$var$load("2CrXe"),
    $608634f1fe836d95$var$load("beMmd"),
    $608634f1fe836d95$var$load("1Gr4q"),
    $608634f1fe836d95$var$load("ig9dh"),
    $608634f1fe836d95$var$load("hA8hA"),
    $608634f1fe836d95$var$load("7G12e"),
    $608634f1fe836d95$var$load("7oAXW"),
    $608634f1fe836d95$var$load("gbejv"),
    $608634f1fe836d95$var$load("GD9EA"),
    $608634f1fe836d95$var$load("h4Nf7"),
    $608634f1fe836d95$var$load("4XkGy"),
    $608634f1fe836d95$var$load("kHXvF"),
    $608634f1fe836d95$var$load("fuOfV"),
    $608634f1fe836d95$var$load("iZR3N"),
    $608634f1fe836d95$var$load("jXM1T"),
    $608634f1fe836d95$var$load("cvcNg"),
    $608634f1fe836d95$var$load("4N1MY"),
    $608634f1fe836d95$var$load("jL1Ke"),
    $608634f1fe836d95$var$load("5MQ0D"),
    $608634f1fe836d95$var$load("Kj0I8"),
    $608634f1fe836d95$var$load("5xnun"),
    $608634f1fe836d95$var$load("6wr18"),
    $608634f1fe836d95$var$load("59hV4"),
    $608634f1fe836d95$var$load("8zMmc"),
    $608634f1fe836d95$var$load("4x9Jx"),
    $608634f1fe836d95$var$load("ffEVr"),
    $608634f1fe836d95$var$load("eCXJR"),
    $608634f1fe836d95$var$load("1VTX2"),
    $608634f1fe836d95$var$load("jZMUd"),
    $608634f1fe836d95$var$load("2EIkU"),
    $608634f1fe836d95$var$load("7TnhR"),
    $608634f1fe836d95$var$load("ddvkk"),
    $608634f1fe836d95$var$load("3upHR"),
    $608634f1fe836d95$var$load("iUXaE"),
    $608634f1fe836d95$var$load("lTkx9"),
    $608634f1fe836d95$var$load("Wowvf"),
    $608634f1fe836d95$var$load("eRhBr"),
    $608634f1fe836d95$var$load("6HpsR"),
    $608634f1fe836d95$var$load("N3oqb"),
    $608634f1fe836d95$var$load("hZ2FX"),
    $608634f1fe836d95$var$load("hhss7"),
    $608634f1fe836d95$var$load("1NGPq"),
    $608634f1fe836d95$var$load("lnKog"),
    $608634f1fe836d95$var$load("kT6dz"),
    $608634f1fe836d95$var$load("aAWLw"),
    $608634f1fe836d95$var$load("7EorR"),
    $608634f1fe836d95$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("5d3mC", function(module, exports) {

let $3cb0c69fb35852a4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3cb0c69fb35852a4$var$load("hUbK8"),
    $3cb0c69fb35852a4$var$load("2CrXe"),
    $3cb0c69fb35852a4$var$load("beMmd"),
    $3cb0c69fb35852a4$var$load("1Gr4q"),
    $3cb0c69fb35852a4$var$load("ig9dh"),
    $3cb0c69fb35852a4$var$load("hA8hA"),
    $3cb0c69fb35852a4$var$load("7G12e"),
    $3cb0c69fb35852a4$var$load("7oAXW"),
    $3cb0c69fb35852a4$var$load("gbejv"),
    $3cb0c69fb35852a4$var$load("GD9EA"),
    $3cb0c69fb35852a4$var$load("h4Nf7"),
    $3cb0c69fb35852a4$var$load("4XkGy"),
    $3cb0c69fb35852a4$var$load("kHXvF"),
    $3cb0c69fb35852a4$var$load("fuOfV"),
    $3cb0c69fb35852a4$var$load("iZR3N"),
    $3cb0c69fb35852a4$var$load("jXM1T"),
    $3cb0c69fb35852a4$var$load("cvcNg"),
    $3cb0c69fb35852a4$var$load("4N1MY"),
    $3cb0c69fb35852a4$var$load("jL1Ke"),
    $3cb0c69fb35852a4$var$load("5MQ0D"),
    $3cb0c69fb35852a4$var$load("Kj0I8"),
    $3cb0c69fb35852a4$var$load("5xnun"),
    $3cb0c69fb35852a4$var$load("6wr18"),
    $3cb0c69fb35852a4$var$load("59hV4"),
    $3cb0c69fb35852a4$var$load("8zMmc"),
    $3cb0c69fb35852a4$var$load("4x9Jx"),
    $3cb0c69fb35852a4$var$load("ffEVr"),
    $3cb0c69fb35852a4$var$load("eCXJR"),
    $3cb0c69fb35852a4$var$load("1VTX2"),
    $3cb0c69fb35852a4$var$load("jZMUd"),
    $3cb0c69fb35852a4$var$load("2EIkU"),
    $3cb0c69fb35852a4$var$load("7TnhR"),
    $3cb0c69fb35852a4$var$load("ddvkk"),
    $3cb0c69fb35852a4$var$load("3upHR"),
    $3cb0c69fb35852a4$var$load("iUXaE"),
    $3cb0c69fb35852a4$var$load("lTkx9"),
    $3cb0c69fb35852a4$var$load("Wowvf"),
    $3cb0c69fb35852a4$var$load("eRhBr"),
    $3cb0c69fb35852a4$var$load("6HpsR"),
    $3cb0c69fb35852a4$var$load("N3oqb"),
    $3cb0c69fb35852a4$var$load("hZ2FX"),
    $3cb0c69fb35852a4$var$load("hhss7"),
    $3cb0c69fb35852a4$var$load("1NGPq"),
    $3cb0c69fb35852a4$var$load("lnKog"),
    $3cb0c69fb35852a4$var$load("kT6dz"),
    $3cb0c69fb35852a4$var$load("aAWLw"),
    $3cb0c69fb35852a4$var$load("7EorR"),
    $3cb0c69fb35852a4$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("6BkVH", function(module, exports) {

let $4ce66ef519d4efbb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4ce66ef519d4efbb$var$load("hUbK8"),
    $4ce66ef519d4efbb$var$load("2CrXe"),
    $4ce66ef519d4efbb$var$load("beMmd"),
    $4ce66ef519d4efbb$var$load("1Gr4q"),
    $4ce66ef519d4efbb$var$load("ig9dh"),
    $4ce66ef519d4efbb$var$load("hA8hA"),
    $4ce66ef519d4efbb$var$load("7G12e"),
    $4ce66ef519d4efbb$var$load("7oAXW"),
    $4ce66ef519d4efbb$var$load("gbejv"),
    $4ce66ef519d4efbb$var$load("GD9EA"),
    $4ce66ef519d4efbb$var$load("h4Nf7"),
    $4ce66ef519d4efbb$var$load("kHXvF"),
    $4ce66ef519d4efbb$var$load("iZR3N"),
    $4ce66ef519d4efbb$var$load("jXM1T"),
    $4ce66ef519d4efbb$var$load("cvcNg"),
    $4ce66ef519d4efbb$var$load("6wr18"),
    $4ce66ef519d4efbb$var$load("4N1MY"),
    $4ce66ef519d4efbb$var$load("8zMmc"),
    $4ce66ef519d4efbb$var$load("4x9Jx"),
    $4ce66ef519d4efbb$var$load("ffEVr"),
    $4ce66ef519d4efbb$var$load("eCXJR"),
    $4ce66ef519d4efbb$var$load("1VTX2"),
    $4ce66ef519d4efbb$var$load("jZMUd"),
    $4ce66ef519d4efbb$var$load("2EIkU"),
    $4ce66ef519d4efbb$var$load("1NGPq"),
    $4ce66ef519d4efbb$var$load("7TnhR"),
    $4ce66ef519d4efbb$var$load("ddvkk"),
    $4ce66ef519d4efbb$var$load("3upHR"),
    $4ce66ef519d4efbb$var$load("iUXaE"),
    $4ce66ef519d4efbb$var$load("lTkx9"),
    $4ce66ef519d4efbb$var$load("Wowvf"),
    $4ce66ef519d4efbb$var$load("eRhBr"),
    $4ce66ef519d4efbb$var$load("6HpsR"),
    $4ce66ef519d4efbb$var$load("N3oqb"),
    $4ce66ef519d4efbb$var$load("hZ2FX"),
    $4ce66ef519d4efbb$var$load("hhss7"),
    $4ce66ef519d4efbb$var$load("kT6dz"),
    $4ce66ef519d4efbb$var$load("aAWLw"),
    $4ce66ef519d4efbb$var$load("7EorR"),
    $4ce66ef519d4efbb$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("2v3uL", function(module, exports) {

let $1d21301e43e98b0a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1d21301e43e98b0a$var$load("hUbK8"),
    $1d21301e43e98b0a$var$load("2CrXe"),
    $1d21301e43e98b0a$var$load("beMmd"),
    $1d21301e43e98b0a$var$load("1Gr4q"),
    $1d21301e43e98b0a$var$load("ig9dh"),
    $1d21301e43e98b0a$var$load("hA8hA"),
    $1d21301e43e98b0a$var$load("7G12e"),
    $1d21301e43e98b0a$var$load("7oAXW"),
    $1d21301e43e98b0a$var$load("gbejv"),
    $1d21301e43e98b0a$var$load("GD9EA"),
    $1d21301e43e98b0a$var$load("h4Nf7"),
    $1d21301e43e98b0a$var$load("kHXvF"),
    $1d21301e43e98b0a$var$load("iZR3N"),
    $1d21301e43e98b0a$var$load("jXM1T"),
    $1d21301e43e98b0a$var$load("cvcNg"),
    $1d21301e43e98b0a$var$load("6wr18"),
    $1d21301e43e98b0a$var$load("4N1MY"),
    $1d21301e43e98b0a$var$load("8zMmc"),
    $1d21301e43e98b0a$var$load("4x9Jx"),
    $1d21301e43e98b0a$var$load("ffEVr"),
    $1d21301e43e98b0a$var$load("eCXJR"),
    $1d21301e43e98b0a$var$load("1VTX2"),
    $1d21301e43e98b0a$var$load("jZMUd"),
    $1d21301e43e98b0a$var$load("2EIkU"),
    $1d21301e43e98b0a$var$load("7TnhR"),
    $1d21301e43e98b0a$var$load("ddvkk"),
    $1d21301e43e98b0a$var$load("3upHR"),
    $1d21301e43e98b0a$var$load("iUXaE"),
    $1d21301e43e98b0a$var$load("lTkx9"),
    $1d21301e43e98b0a$var$load("Wowvf"),
    $1d21301e43e98b0a$var$load("eRhBr"),
    $1d21301e43e98b0a$var$load("6HpsR"),
    $1d21301e43e98b0a$var$load("N3oqb"),
    $1d21301e43e98b0a$var$load("hZ2FX"),
    $1d21301e43e98b0a$var$load("hhss7"),
    $1d21301e43e98b0a$var$load("1NGPq"),
    $1d21301e43e98b0a$var$load("lnKog"),
    $1d21301e43e98b0a$var$load("kT6dz"),
    $1d21301e43e98b0a$var$load("aAWLw"),
    $1d21301e43e98b0a$var$load("7EorR"),
    $1d21301e43e98b0a$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("gUEvs", function(module, exports) {

let $c5014c02df28b2c3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c5014c02df28b2c3$var$load("hUbK8"),
    $c5014c02df28b2c3$var$load("2CrXe"),
    $c5014c02df28b2c3$var$load("beMmd"),
    $c5014c02df28b2c3$var$load("1Gr4q"),
    $c5014c02df28b2c3$var$load("ig9dh"),
    $c5014c02df28b2c3$var$load("hA8hA"),
    $c5014c02df28b2c3$var$load("7G12e"),
    $c5014c02df28b2c3$var$load("7oAXW"),
    $c5014c02df28b2c3$var$load("gbejv"),
    $c5014c02df28b2c3$var$load("GD9EA"),
    $c5014c02df28b2c3$var$load("h4Nf7"),
    $c5014c02df28b2c3$var$load("kHXvF"),
    $c5014c02df28b2c3$var$load("iZR3N"),
    $c5014c02df28b2c3$var$load("jXM1T"),
    $c5014c02df28b2c3$var$load("cvcNg"),
    $c5014c02df28b2c3$var$load("6wr18"),
    $c5014c02df28b2c3$var$load("4N1MY"),
    $c5014c02df28b2c3$var$load("8zMmc"),
    $c5014c02df28b2c3$var$load("4x9Jx"),
    $c5014c02df28b2c3$var$load("ffEVr"),
    $c5014c02df28b2c3$var$load("eCXJR"),
    $c5014c02df28b2c3$var$load("1VTX2"),
    $c5014c02df28b2c3$var$load("jZMUd"),
    $c5014c02df28b2c3$var$load("2EIkU"),
    $c5014c02df28b2c3$var$load("7TnhR"),
    $c5014c02df28b2c3$var$load("ddvkk"),
    $c5014c02df28b2c3$var$load("3upHR"),
    $c5014c02df28b2c3$var$load("iUXaE"),
    $c5014c02df28b2c3$var$load("lTkx9"),
    $c5014c02df28b2c3$var$load("Wowvf"),
    $c5014c02df28b2c3$var$load("eRhBr"),
    $c5014c02df28b2c3$var$load("6HpsR"),
    $c5014c02df28b2c3$var$load("N3oqb"),
    $c5014c02df28b2c3$var$load("hZ2FX"),
    $c5014c02df28b2c3$var$load("hhss7"),
    $c5014c02df28b2c3$var$load("1NGPq"),
    $c5014c02df28b2c3$var$load("lnKog"),
    $c5014c02df28b2c3$var$load("kT6dz"),
    $c5014c02df28b2c3$var$load("aAWLw"),
    $c5014c02df28b2c3$var$load("7EorR"),
    $c5014c02df28b2c3$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("i5zxs", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");


var $jVylI = parcelRequire("jVylI");

class $e6a27c260ce1aef4$export$edf095fb7f09a5c0 extends (0, $kNIYN.Container) {
    constructor(...args){
        super(...args);
        this.state = {
            hasCoverPicture: false,
            isUploadingPicture: false,
            isModalOpen: false,
            isRemovingPicture: false,
            isRepositioningPicture: false,
            isAddHeaderImageButtonFocused: false,
            coverPictureId: '',
            shouldShowReposition: false,
            isChangingPicture: false,
            coverPictureWidth: (0, $jVylI.COVERPICTUREWIDTH).FULL,
            shouldShowAIImageAcceptanceFlow: false,
            lastAIGenerationParams: null,
            isCurrentAIFCAutoImage: false
        };
        this.setHasCoverPicture = (hasCoverPicture)=>this.setState({
                hasCoverPicture: hasCoverPicture
            });
        this.toggleCoverPictureWidthButton = (coverPictureWidth)=>this.setState({
                coverPictureWidth: coverPictureWidth
            });
        this.setCoverPictureId = (coverPictureId)=>this.setState({
                coverPictureId: coverPictureId
            });
        this.setIsUploadingPicture = (isUploadingPicture)=>this.setState({
                isUploadingPicture: isUploadingPicture
            });
        this.setIsModalOpen = (isModalOpen)=>this.setState({
                isModalOpen: isModalOpen
            });
        this.setIsChangingPicture = (isChangingPicture)=>this.setState({
                isChangingPicture: isChangingPicture
            });
        this.setIsRemovingPicture = (isRemovingPicture)=>this.setState({
                isRemovingPicture: isRemovingPicture
            });
        this.setIsRepositioningPicture = (isRepositioningPicture)=>this.setState({
                isRepositioningPicture: isRepositioningPicture
            });
        this.setShouldShowReposition = (shouldShowReposition)=>this.setState({
                shouldShowReposition: shouldShowReposition
            });
        this.setIsAddHeaderImageButtonFocused = (isAddHeaderImageButtonFocused)=>this.setState({
                isAddHeaderImageButtonFocused: isAddHeaderImageButtonFocused
            });
        this.setShouldShowAIImageAcceptanceFlow = (shouldShowAIImageAcceptanceFlow)=>this.setState({
                shouldShowAIImageAcceptanceFlow: shouldShowAIImageAcceptanceFlow
            });
        this.setLastAIGenerationParams = (lastAIGenerationParams)=>this.setState({
                lastAIGenerationParams: lastAIGenerationParams
            });
        this.setIsCurrentAIFCAutoImage = (isCurrentAIFCAutoImage)=>this.setState({
                isCurrentAIFCAutoImage: isCurrentAIFCAutoImage
            });
        this.resetToDefaults = ()=>{
            this.setIsModalOpen(false);
            this.setIsAddHeaderImageButtonFocused(false);
            this.setIsUploadingPicture(false);
            this.setIsChangingPicture(false);
            this.setIsRemovingPicture(false);
            this.setShouldShowReposition(false);
            this.toggleCoverPictureWidthButton((0, $jVylI.COVERPICTUREWIDTH).FULL);
            this.setShouldShowAIImageAcceptanceFlow(false);
            this.setLastAIGenerationParams(null);
            this.setIsCurrentAIFCAutoImage(false);
        };
    }
}
module.exports["CoverPictureStateContainer"] = $e6a27c260ce1aef4$export$edf095fb7f09a5c0;

});

parcelRegister("jVylI", function(module, exports) {
var $341ba7bb7f83b82d$export$18feebdc268a3ef1 = /*#__PURE__*/ function(TitleAlignmentType) {
    TitleAlignmentType["LEFT"] = "LEFT";
    TitleAlignmentType["CENTER"] = "CENTER";
    return TitleAlignmentType;
}({});
const $341ba7bb7f83b82d$export$f5c76f9de4274e9b = {
    titleLayoutAlignment: "LEFT",
    titlePropertySubtitle: '',
    titlePropertySubtitleEnabled: false,
    titlePropertyBylineEnabled: false,
    titlePropertyEmojiEnabled: true,
    headerImageStylingEnabled: false
};
var $341ba7bb7f83b82d$export$f84f565b1b747c24 = /*#__PURE__*/ function(COVERPICTUREWIDTH) {
    COVERPICTUREWIDTH["FULL"] = "full";
    COVERPICTUREWIDTH["FIXED"] = "fixed";
    return COVERPICTUREWIDTH;
}({});
module.exports["TitleAlignmentType"] = $341ba7bb7f83b82d$export$18feebdc268a3ef1;
module.exports["defaultPropertyValue"] = $341ba7bb7f83b82d$export$f5c76f9de4274e9b;
module.exports["COVERPICTUREWIDTH"] = $341ba7bb7f83b82d$export$f84f565b1b747c24;

});

parcelRegister("2pBiX", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $e5ba90f4b97bd7c1$var$i18n = (0, $kSwu1.defineMessages)({
    errorTitleCannotStart: {
        id: "loom-utils.error-flag.title.cannot-start",
        defaultMessage: "We couldn\u2019t start your recording"
    },
    errorSDKFailedToInitialize: {
        id: "loom-utils.error-flag.description.sdk-failed-to-initialize",
        defaultMessage: "Give it a moment and then refresh to try again."
    }
});
const $e5ba90f4b97bd7c1$export$b8f10a3122c10d73 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { flags: flags } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== flags || $[1] !== intl) {
        t1 = ()=>{
            flags.showInfoFlag({
                title: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorTitleCannotStart),
                description: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorSDKFailedToInitialize)
            });
        };
        $[0] = flags;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ flags: flags })=>{
    const intl = (0, $kSwu1.useIntl)();
    return (0, $cozmU.useCallback)(()=>{
        flags.showInfoFlag({
            title: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorTitleCannotStart),
            description: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorSDKFailedToInitialize)
        });
    }, [
        flags,
        intl
    ]);
};
module.exports["useLoomEntryPointErrorCallback"] = $e5ba90f4b97bd7c1$export$b8f10a3122c10d73;

});

parcelRegister("hMfsx", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $ej7WH = parcelRequire("ej7WH");


var $k0DFC = parcelRequire("k0DFC");


var $f5Ulo = parcelRequire("f5Ulo");

const $985cb37370034aac$var$crossFlowAdType = 'crossFlow';
const $985cb37370034aac$var$crossJoinAdType = 'crossJoin';
const $985cb37370034aac$export$26447b7789af7a96 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { buttonComponent: ButtonComponent, sourceActionSubjectId: sourceActionSubjectId, entryPointId: entryPointId, sourceComponent: sourceComponent, sourceContext: sourceContext } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== sourceComponent || $[1] !== sourceContext) {
        t1 = {
            sourceComponent: sourceComponent,
            sourceContext: sourceContext
        };
        $[0] = sourceComponent;
        $[1] = sourceContext;
        $[2] = t1;
    } else t1 = $[2];
    const triggerCrossFlow = (0, $ej7WH.useLoomCrossFlowRequestAccessCallback)(t1);
    let t2;
    if ($[3] !== entryPointId) {
        t2 = {
            touchpoint: entryPointId
        };
        $[3] = entryPointId;
        $[4] = t2;
    } else t2 = $[4];
    const { isInterestedInLoom: isInterestedInLoom } = (0, $k0DFC.useLoomAdControlState)(t2);
    let t3;
    if ($[5] !== createAnalyticsEvent || $[6] !== entryPointId || $[7] !== sourceActionSubjectId || $[8] !== triggerCrossFlow) {
        t3 = async (triggerName)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: triggerName,
                    source: triggerName === "tryNow" ? "loomCrossFlowPopupCard" : sourceActionSubjectId,
                    attributes: {
                        adType: $985cb37370034aac$var$crossFlowAdType,
                        entrypoint: entryPointId
                    }
                }
            }).fire();
            await triggerCrossFlow();
        };
        $[5] = createAnalyticsEvent;
        $[6] = entryPointId;
        $[7] = sourceActionSubjectId;
        $[8] = triggerCrossFlow;
        $[9] = t3;
    } else t3 = $[9];
    const onCrossFlowTriggerClick = t3;
    if (!isInterestedInLoom) return null;
    let t4;
    if ($[10] !== onCrossFlowTriggerClick || $[11] !== sourceActionSubjectId) {
        t4 = ()=>onCrossFlowTriggerClick(sourceActionSubjectId);
        $[10] = onCrossFlowTriggerClick;
        $[11] = sourceActionSubjectId;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== ButtonComponent || $[14] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ButtonComponent, {
            onClickBeforeInit: t4
        });
        $[13] = ButtonComponent;
        $[14] = t4;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
} : ({ buttonComponent: ButtonComponent, sourceActionSubjectId: sourceActionSubjectId, entryPointId: entryPointId, sourceComponent: sourceComponent, sourceContext: sourceContext })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const triggerCrossFlow = (0, $ej7WH.useLoomCrossFlowRequestAccessCallback)({
        sourceComponent: sourceComponent,
        sourceContext: sourceContext
    });
    const { isInterestedInLoom: isInterestedInLoom } = (0, $k0DFC.useLoomAdControlState)({
        touchpoint: entryPointId
    });
    const onCrossFlowTriggerClick = (0, $cozmU.useCallback)(async (triggerName)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: triggerName,
                source: triggerName === 'tryNow' ? 'loomCrossFlowPopupCard' : sourceActionSubjectId,
                attributes: {
                    adType: $985cb37370034aac$var$crossFlowAdType,
                    entrypoint: entryPointId
                }
            }
        }).fire();
        await triggerCrossFlow();
    }, [
        createAnalyticsEvent,
        entryPointId,
        triggerCrossFlow,
        sourceActionSubjectId
    ]);
    if (!isInterestedInLoom) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ButtonComponent, {
        onClickBeforeInit: ()=>onCrossFlowTriggerClick(sourceActionSubjectId)
    });
};
const $985cb37370034aac$export$53b6c16ae8132c96 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { buttonComponent: ButtonComponent, sourceActionSubjectId: sourceActionSubjectId, entryPointId: entryPointId, sourceComponent: sourceComponent } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const crossJoinHref = (0, $f5Ulo.useLoomCrossJoinUrl)();
    let t1;
    if ($[0] !== entryPointId || $[1] !== experienceTracker) {
        t1 = ()=>{
            experienceTracker.succeed({
                name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
                attributes: {
                    sourceComponent: entryPointId,
                    adType: $985cb37370034aac$var$crossJoinAdType
                }
            });
        };
        $[0] = entryPointId;
        $[1] = experienceTracker;
        $[2] = t1;
    } else t1 = $[2];
    const onCrossJoinSuccess = t1;
    let t2;
    if ($[3] !== createAnalyticsEvent || $[4] !== entryPointId || $[5] !== onCrossJoinSuccess || $[6] !== sourceActionSubjectId || $[7] !== sourceComponent) {
        t2 = async ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: sourceActionSubjectId,
                    source: sourceActionSubjectId,
                    attributes: {
                        adType: $985cb37370034aac$var$crossJoinAdType,
                        entrypoint: entryPointId,
                        sourceComponent: sourceComponent
                    }
                }
            }).fire();
            onCrossJoinSuccess();
        };
        $[3] = createAnalyticsEvent;
        $[4] = entryPointId;
        $[5] = onCrossJoinSuccess;
        $[6] = sourceActionSubjectId;
        $[7] = sourceComponent;
        $[8] = t2;
    } else t2 = $[8];
    const onCrossJoinTriggerClick = t2;
    let t3;
    if ($[9] !== ButtonComponent || $[10] !== crossJoinHref || $[11] !== onCrossJoinTriggerClick) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ButtonComponent, {
            onClickBeforeInit: onCrossJoinTriggerClick,
            href: crossJoinHref,
            target: "_blank",
            rel: "noreferrer"
        });
        $[9] = ButtonComponent;
        $[10] = crossJoinHref;
        $[11] = onCrossJoinTriggerClick;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
} : ({ buttonComponent: ButtonComponent, sourceActionSubjectId: sourceActionSubjectId, entryPointId: entryPointId, sourceComponent: sourceComponent })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const crossJoinHref = (0, $f5Ulo.useLoomCrossJoinUrl)();
    const onCrossJoinSuccess = (0, $cozmU.useCallback)(()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
            attributes: {
                sourceComponent: entryPointId,
                adType: $985cb37370034aac$var$crossJoinAdType
            }
        });
    }, [
        entryPointId,
        experienceTracker
    ]);
    const onCrossJoinTriggerClick = (0, $cozmU.useCallback)(async ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: sourceActionSubjectId,
                source: sourceActionSubjectId,
                attributes: {
                    adType: $985cb37370034aac$var$crossJoinAdType,
                    entrypoint: entryPointId,
                    sourceComponent: sourceComponent
                }
            }
        }).fire();
        onCrossJoinSuccess();
    }, [
        createAnalyticsEvent,
        entryPointId,
        onCrossJoinSuccess,
        sourceActionSubjectId,
        sourceComponent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ButtonComponent, {
        onClickBeforeInit: onCrossJoinTriggerClick,
        href: crossJoinHref,
        target: "_blank",
        rel: "noreferrer"
    });
};
module.exports["CrossFlowMenuItem"] = $985cb37370034aac$export$26447b7789af7a96;
module.exports["CrossJoinMenuItem"] = $985cb37370034aac$export$53b6c16ae8132c96;

});

parcelRegister("ej7WH", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

parcelRequire("63sT2");
var $dYn3u = parcelRequire("dYn3u");
var $8NccQ = parcelRequire("8NccQ");
parcelRequire("kgHuu");
var $3qdJ0 = parcelRequire("3qdJ0");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $a763567c6da5be00$export$fa70eeb8352dd55e = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { sourceComponent: sourceComponent, sourceContext: sourceContext } = t0;
    const crossFlow = (0, $8NccQ.useCrossFlow)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    if ($[0] !== crossFlow.apiV1 || $[1] !== crossFlow.isEnabled || $[2] !== experienceTracker || $[3] !== sourceComponent || $[4] !== sourceContext) {
        t1 = async ()=>{
            if (!crossFlow.isEnabled) {
                experienceTracker.fail({
                    name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
                    error: new Error("Loom crossflow is not enabled"),
                    attributes: {
                        sourceComponent: sourceComponent,
                        adType: "crossFlow"
                    }
                });
                return;
            }
            experienceTracker.succeed({
                name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
                attributes: {
                    sourceComponent: sourceComponent,
                    adType: "crossFlow"
                }
            });
            try {
                await crossFlow.apiV1.open({
                    journey: (0, $dYn3u.Journeys).GET_STARTED,
                    sourceComponent: sourceComponent,
                    sourceContext: sourceContext,
                    targetProduct: (0, $3qdJ0.Targets).LOOM,
                    v1: true
                });
            } catch (t2) {
                const error = t2;
                (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
                });
            }
        };
        $[0] = crossFlow.apiV1;
        $[1] = crossFlow.isEnabled;
        $[2] = experienceTracker;
        $[3] = sourceComponent;
        $[4] = sourceContext;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ({ sourceComponent: sourceComponent, sourceContext: sourceContext })=>{
    const crossFlow = (0, $8NccQ.useCrossFlow)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    return (0, $cozmU.useCallback)(async ()=>{
        if (!crossFlow.isEnabled) {
            experienceTracker.fail({
                name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
                error: new Error('Loom crossflow is not enabled'),
                attributes: {
                    sourceComponent: sourceComponent,
                    adType: 'crossFlow'
                }
            });
            return;
        }
        experienceTracker.succeed({
            name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
            attributes: {
                sourceComponent: sourceComponent,
                adType: 'crossFlow'
            }
        });
        try {
            /**
       * Additionally, if the user *does* go through cross-flow, they'll be navigated to Loom.com and
       * not return to this code path.
       */ await crossFlow.apiV1.open({
                journey: (0, $dYn3u.Journeys).GET_STARTED,
                sourceComponent: sourceComponent,
                sourceContext: sourceContext,
                targetProduct: (0, $3qdJ0.Targets).LOOM,
                v1: true
            });
        } catch (error) {
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
            });
        }
    }, [
        crossFlow,
        sourceComponent,
        experienceTracker,
        sourceContext
    ]);
};
module.exports["useLoomCrossFlowRequestAccessCallback"] = $a763567c6da5be00$export$fa70eeb8352dd55e;

});

parcelRegister("63sT2", function(module, exports) {
$parcel$export(module.exports, "BaseCrossFlowApiProvider", () => (parcelRequire("8NccQ")).BaseCrossFlowApiProvider);
$parcel$export(module.exports, "useCrossFlow", () => (parcelRequire("8NccQ")).useCrossFlow);
$parcel$export(module.exports, "withCrossFlow", () => (parcelRequire("8NccQ")).withCrossFlow);
$parcel$export(module.exports, "Journeys", () => (parcelRequire("dYn3u")).Journeys);
$parcel$export(module.exports, "Reasons", () => (parcelRequire("dYn3u")).Reasons);

var $8NccQ = parcelRequire("8NccQ");


var $dYn3u = parcelRequire("dYn3u");


});

parcelRegister("8NccQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $h9Y0D = parcelRequire("h9Y0D");


var $6j5v3 = parcelRequire("6j5v3");


var $dYn3u = parcelRequire("dYn3u");

const $95842fb34f191a76$var$LATEST_VERSION = (0, $6j5v3.VERSION);
/**
 * Private Cross Flow context
 *
 * Not to be used directly other than by useCrossFlow and BaseCrossFlowApiProvider
 */ const $95842fb34f191a76$var$CrossFlowContext = /*#__PURE__*/ (0, $cozmU.createContext)(()=>({
        isEnabled: false,
        reason: (0, $dYn3u.Reasons).NO_PROVIDER
    }));
const $95842fb34f191a76$export$59ce2d27e6cd8c9 = (onOpen)=>(version)=>{
        switch(version){
            case 0, $6j5v3.VERSION:
                return {
                    isEnabled: true,
                    api: (0, $h9Y0D.createAPIv0)(onOpen),
                    apiV1: (0, $6j5v3.createAPIv1)(onOpen)
                };
            default:
                return {
                    isEnabled: false,
                    reason: (0, $dYn3u.Reasons).NO_API_SUPPORT
                };
        }
    };
const $95842fb34f191a76$export$c0ddec072762f62a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { onOpen: onOpen, children: children } = t0;
    let t1;
    if ($[0] !== onOpen) {
        t1 = $95842fb34f191a76$export$59ce2d27e6cd8c9(onOpen);
        $[0] = onOpen;
        $[1] = t1;
    } else t1 = $[1];
    const negotiateApi = t1;
    let t2;
    if ($[2] !== children || $[3] !== negotiateApi) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($95842fb34f191a76$var$CrossFlowContext.Provider, {
            value: negotiateApi
        }, children);
        $[2] = children;
        $[3] = negotiateApi;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ onOpen: onOpen, children: children })=>{
    const negotiateApi = (0, $cozmU.useMemo)(()=>$95842fb34f191a76$export$59ce2d27e6cd8c9(onOpen), [
        onOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($95842fb34f191a76$var$CrossFlowContext.Provider, {
        value: negotiateApi
    }, children);
};
const $95842fb34f191a76$export$6e7a10fe635a0dfc = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const negotiateApi = (0, $cozmU.useContext)($95842fb34f191a76$var$CrossFlowContext);
    let t0;
    if ($[0] !== negotiateApi) {
        t0 = negotiateApi($95842fb34f191a76$var$LATEST_VERSION);
        $[0] = negotiateApi;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const negotiateApi = (0, $cozmU.useContext)($95842fb34f191a76$var$CrossFlowContext);
    return (0, $cozmU.useMemo)(()=>negotiateApi($95842fb34f191a76$var$LATEST_VERSION), [
        negotiateApi
    ]);
};
function $95842fb34f191a76$export$655b6c19a0daddb8(//component coming in here has no crossflow type yet, but expects it
WrappedComponent) {
    const ComponentWithCrossFlow = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
        const $ = (0, $bDgLe.c)(3);
        const crossFlow = $95842fb34f191a76$export$6e7a10fe635a0dfc();
        let t0;
        if ($[0] !== crossFlow || $[1] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                ...props,
                crossFlow: crossFlow
            });
            $[0] = crossFlow;
            $[1] = props;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    } : (props)=>{
        const crossFlow = $95842fb34f191a76$export$6e7a10fe635a0dfc();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
            ...props,
            crossFlow: crossFlow
        });
    };
    ComponentWithCrossFlow.displayName = `withCrossFlow(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return ComponentWithCrossFlow;
}
module.exports["BaseCrossFlowApiProvider"] = $95842fb34f191a76$export$c0ddec072762f62a;
module.exports["useCrossFlow"] = $95842fb34f191a76$export$6e7a10fe635a0dfc;
module.exports["withCrossFlow"] = $95842fb34f191a76$export$655b6c19a0daddb8;

});

parcelRegister("h9Y0D", function(module, exports) {
const $dac2ee632762edd0$export$a4ad2735b021c132 = 0;
const $dac2ee632762edd0$export$9ff7368ac93fcf2d = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });
module.exports["createAPIv0"] = $dac2ee632762edd0$export$9ff7368ac93fcf2d;

});

parcelRegister("6j5v3", function(module, exports) {
const $146c188c19063c17$export$a4ad2735b021c132 = 1;
const $146c188c19063c17$export$8fd5792fc468459f = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });
module.exports["VERSION"] = $146c188c19063c17$export$a4ad2735b021c132;
module.exports["createAPIv1"] = $146c188c19063c17$export$8fd5792fc468459f;

});

parcelRegister("dYn3u", function(module, exports) {
const $f5b6049530406f9f$export$3411873bfd520bb6 = {
    GET_STARTED: 'get-started',
    DECIDE: 'decide',
    DISCOVER: 'discover'
};
const $f5b6049530406f9f$export$da2d4f2f250d6f84 = {
    NO_API_SUPPORT: 'Could not provide requested API version',
    NO_PROVIDER: 'Provider not found'
};
module.exports["Journeys"] = $f5b6049530406f9f$export$3411873bfd520bb6;
module.exports["Reasons"] = $f5b6049530406f9f$export$da2d4f2f250d6f84;

});

parcelRegister("kgHuu", function(module, exports) {
$parcel$export(module.exports, "CrossFlowExtensions", () => (parcelRequire("6ROIE")).CrossFlowExtensions);
$parcel$export(module.exports, "Targets", () => (parcelRequire("3qdJ0")).Targets);

var $6ROIE = parcelRequire("6ROIE");


var $3qdJ0 = parcelRequire("3qdJ0");


});

parcelRegister("6ROIE", function(module, exports) {
class $f31eace768ed80b8$export$a5e53d1dcbd6eb61 {
    constructor(options){
        Object.assign(this, options);
        Object.freeze(this);
    }
}
module.exports["CrossFlowExtensions"] = $f31eace768ed80b8$export$a5e53d1dcbd6eb61;

});

parcelRegister("3qdJ0", function(module, exports) {
/**
 * We are keeping a manual list of targets for the purposes of type safety.
 */ const $8c8615b3f214c36e$export$59a8eb9cff113544 = {
    CONFLUENCE: 'confluence.ondemand',
    JIRA_CORE: 'jira-core.ondemand',
    JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
    JIRA_SOFTWARE: 'jira-software.ondemand',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
    JIRA_CUSTOMER_SERVICE: 'jira-customer-service',
    BITBUCKET: 'bitbucket.ondemand',
    TRELLO: 'trello',
    OPSGENIE: 'opsgenie',
    STATUSPAGE: 'statuspage',
    /**
	 * @private
	 * @deprecated Use ATLAS instead
	 */ TEAM_CENTRAL: 'townsquare',
    ATLAS: 'townsquare',
    /**
	 * @private
	 * @deprecated
	 */ AVOCADO: 'avocado',
    ANALYTICS: 'atlassian-analytics-free',
    COMPASS: 'compass',
    LOOM: 'loom',
    ROVO: 'rovo.ondemand',
    TEAMWORK_COLLECTION: 'teamwork-collection'
};
module.exports["Targets"] = $8c8615b3f214c36e$export$59a8eb9cff113544;

});

parcelRegister("k0DFC", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $bQm3c = parcelRequire("bQm3c");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $66b8bcdb334754ff$var$getCachedValuesArray = ()=>{
    try {
        const cachedValues = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_FLOW_AD_CONTROL_NOT_INTERESTED);
        if (cachedValues !== null && cachedValues !== 'undefined') return String(cachedValues).split(',');
    } catch (e) {} // Swallow any errors and return empty array
    return [];
};
const $66b8bcdb334754ff$export$83d1e1540840fcd3 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { touchpoint: touchpoint } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const valueToBeCached = `${touchpoint}.${userId}.${cloudId}`;
    let t1;
    let t2;
    if ($[0] !== valueToBeCached) {
        const cachedValuesArray = $66b8bcdb334754ff$var$getCachedValuesArray();
        t1 = (0, $cozmU.useState);
        t2 = !cachedValuesArray || !cachedValuesArray.includes(valueToBeCached);
        $[0] = valueToBeCached;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    const [isInterestedInLoom, setIsInterestedInLoom] = t1(t2);
    let t3;
    if ($[3] !== createAnalyticsEvent || $[4] !== isInterestedInLoom || $[5] !== touchpoint || $[6] !== valueToBeCached) {
        t3 = async ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "notInterested",
                    source: "loomAdControlDropdown",
                    attributes: {
                        adType: "crossFlow",
                        entrypoint: touchpoint
                    }
                }
            }).fire();
            if (!isInterestedInLoom) return;
            const freshCachedValuesArray = $66b8bcdb334754ff$var$getCachedValuesArray();
            freshCachedValuesArray.push(valueToBeCached);
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_FLOW_AD_CONTROL_NOT_INTERESTED, freshCachedValuesArray);
            setIsInterestedInLoom(false);
        };
        $[3] = createAnalyticsEvent;
        $[4] = isInterestedInLoom;
        $[5] = touchpoint;
        $[6] = valueToBeCached;
        $[7] = t3;
    } else t3 = $[7];
    const notInterestedInLoomCallback = t3;
    let t4;
    if ($[8] !== isInterestedInLoom || $[9] !== notInterestedInLoomCallback) {
        t4 = {
            isInterestedInLoom: isInterestedInLoom,
            notInterestedInLoomCallback: notInterestedInLoomCallback
        };
        $[8] = isInterestedInLoom;
        $[9] = notInterestedInLoomCallback;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ({ touchpoint: touchpoint })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const valueToBeCached = `${touchpoint}.${userId}.${cloudId}`;
    const cachedValuesArray = $66b8bcdb334754ff$var$getCachedValuesArray();
    const [isInterestedInLoom, setIsInterestedInLoom] = (0, $cozmU.useState)(!cachedValuesArray || !cachedValuesArray.includes(valueToBeCached));
    const notInterestedInLoomCallback = (0, $cozmU.useCallback)(async ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'notInterested',
                source: 'loomAdControlDropdown',
                attributes: {
                    adType: 'crossFlow',
                    entrypoint: touchpoint
                }
            }
        }).fire();
        // Avoid duplicate values being added to cache
        if (!isInterestedInLoom) return;
        // Ensure fresh cache values array by reading from storage
        const freshCachedValuesArray = $66b8bcdb334754ff$var$getCachedValuesArray();
        freshCachedValuesArray.push(valueToBeCached);
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_FLOW_AD_CONTROL_NOT_INTERESTED, freshCachedValuesArray);
        setIsInterestedInLoom(false);
    }, [
        isInterestedInLoom,
        valueToBeCached,
        createAnalyticsEvent,
        touchpoint
    ]);
    return {
        isInterestedInLoom: isInterestedInLoom,
        notInterestedInLoomCallback: notInterestedInLoomCallback
    };
};
module.exports["useLoomAdControlState"] = $66b8bcdb334754ff$export$83d1e1540840fcd3;

});

parcelRegister("f5Ulo", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $2VNj8 = parcelRequire("2VNj8");


var $bQm3c = parcelRequire("bQm3c");

const $3326fe0c1f9a5868$var$environmentMap = {
    DEVELOPMENT: 'dev',
    STAGING: 'stg',
    PRODUCTION: 'prod'
};
const $3326fe0c1f9a5868$export$80677895f41c9591 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const { cloudId: cloudId, environment: environment } = (0, $bQm3c.useSessionData)();
    const t0 = $3326fe0c1f9a5868$var$environmentMap[environment];
    let t1;
    if ($[0] !== t0) {
        t1 = (0, $2VNj8.getATLContextDomain)("id", [
            t0,
            "commercial"
        ]);
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const identityDomain = t1;
    const loomResourceAri = `ari:cloud:loom::site/${cloudId}`;
    const continueUrl = environment === "PRODUCTION" ? "https://loom.com/api/auth/atlassian" : "https://stage.loom.com/api/auth/atlassian";
    const userAccessUrl = encodeURIComponent(`https://${identityDomain}/join/user-access?resource=${loomResourceAri}&continue=${continueUrl}`);
    return `https://${identityDomain}/login?continue=${userAccessUrl}`;
} : ()=>{
    const { cloudId: cloudId, environment: environment } = (0, $bQm3c.useSessionData)();
    // Using `environment` from session data (rather than letting `getATLContextDomain` determine it
    // internally) in order to better support local development that can be targeted at different
    // Confluence BE environments
    const identityDomain = (0, $2VNj8.getATLContextDomain)('id', [
        $3326fe0c1f9a5868$var$environmentMap[environment],
        'commercial'
    ]);
    const loomResourceAri = `ari:cloud:loom::site/${cloudId}`;
    const continueUrl = environment === 'PRODUCTION' ? 'https://loom.com/api/auth/atlassian' : 'https://stage.loom.com/api/auth/atlassian';
    const userAccessUrl = encodeURIComponent(`https://${identityDomain}/join/user-access?resource=${loomResourceAri}&continue=${continueUrl}`);
    return `https://${identityDomain}/login?continue=${userAccessUrl}`;
};
module.exports["useLoomCrossJoinUrl"] = $3326fe0c1f9a5868$export$80677895f41c9591;

});

parcelRegister("8Q0mA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $9DHhW = parcelRequire("9DHhW");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $gd8AW = parcelRequire("gd8AW");


var $erVVf = parcelRequire("erVVf");


var $cnQgR = parcelRequire("cnQgR");

const $012e0fafda229e4e$var$sourceAdType = 'crossJoin';
const $012e0fafda229e4e$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    crossJoinCTA: {
        id: "loom-utils.loom-cross-sell-popup-card.crossJoinCTA",
        defaultMessage: "Try now"
    },
    requestAccessSuccessFlagTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-success-flag.title",
        defaultMessage: "Your admins were notified of your request"
    },
    requestAccessSuccessFlagDescription: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-success-flag.description",
        defaultMessage: "You\u2019ll receive an email once they\u2019ve approved it."
    },
    requestAccessErrorFlagTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.title",
        defaultMessage: "We couldn't add you to Loom"
    },
    requestAccessErrorFlagDescription: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.description",
        defaultMessage: "Try again in a few minutes. If you still aren't able to join, "
    },
    requestAccessErrorFlagActionTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.action.title",
        defaultMessage: "contact support"
    }
});
const $012e0fafda229e4e$export$9937e9f99bf53911 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(40);
    const { description: description, entryPointId: entryPointId, placement: placement, shouldRenderToParent: shouldRenderToParent, sourceActionSubjectId: sourceActionSubjectId, sourceComponent: sourceComponent, title: title, triggerLink: triggerLink, flags: flags } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const intl = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { stopPulse: stopPulse } = (0, $gd8AW.useDiscoverabilityPulseActions)();
    let t1;
    if ($[0] !== entryPointId || $[1] !== flags || $[2] !== sourceComponent) {
        t1 = {
            entryPointId: entryPointId,
            flags: flags,
            source: "loomCrossJoinPopupCard",
            sourceAdType: $012e0fafda229e4e$var$sourceAdType,
            sourceComponent: sourceComponent
        };
        $[0] = entryPointId;
        $[1] = flags;
        $[2] = sourceComponent;
        $[3] = t1;
    } else t1 = $[3];
    const streamliningCrossJoinOnButtonClicked = (0, $erVVf.useStreamliningCrossJoin)(t1);
    let t2;
    if ($[4] !== stopPulse) {
        t2 = ()=>{
            stopPulse();
        };
        $[4] = stopPulse;
        $[5] = t2;
    } else t2 = $[5];
    const stopDiscoverabilityPulse = t2;
    let t3;
    if ($[6] !== entryPointId || $[7] !== experienceTracker || $[8] !== stopDiscoverabilityPulse) {
        t3 = ()=>{
            stopDiscoverabilityPulse();
            experienceTracker.succeed({
                name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
                attributes: {
                    sourceComponent: entryPointId,
                    adType: $012e0fafda229e4e$var$sourceAdType
                }
            });
        };
        $[6] = entryPointId;
        $[7] = experienceTracker;
        $[8] = stopDiscoverabilityPulse;
        $[9] = t3;
    } else t3 = $[9];
    const onCrossJoinSuccess = t3;
    let t4;
    if ($[10] !== createAnalyticsEvent || $[11] !== entryPointId || $[12] !== onCrossJoinSuccess || $[13] !== sourceComponent || $[14] !== streamliningCrossJoinOnButtonClicked) {
        t4 = async ()=>{
            await streamliningCrossJoinOnButtonClicked(false);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "tryNow",
                    source: "loomCrossJoinPopupCard",
                    attributes: {
                        adType: $012e0fafda229e4e$var$sourceAdType,
                        entrypoint: entryPointId,
                        sourceComponent: sourceComponent
                    }
                }
            }).fire();
            onCrossJoinSuccess();
        };
        $[10] = createAnalyticsEvent;
        $[11] = entryPointId;
        $[12] = onCrossJoinSuccess;
        $[13] = sourceComponent;
        $[14] = streamliningCrossJoinOnButtonClicked;
        $[15] = t4;
    } else t4 = $[15];
    const onTryNowButtonClick = t4;
    let t5;
    if ($[16] !== createAnalyticsEvent || $[17] !== entryPointId || $[18] !== onCrossJoinSuccess || $[19] !== sourceActionSubjectId || $[20] !== sourceComponent || $[21] !== streamliningCrossJoinOnButtonClicked) {
        t5 = async ()=>{
            await streamliningCrossJoinOnButtonClicked(true);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: sourceActionSubjectId,
                    source: sourceActionSubjectId,
                    attributes: {
                        adType: $012e0fafda229e4e$var$sourceAdType,
                        entrypoint: entryPointId,
                        sourceComponent: sourceComponent
                    }
                }
            }).fire();
            onCrossJoinSuccess();
        };
        $[16] = createAnalyticsEvent;
        $[17] = entryPointId;
        $[18] = onCrossJoinSuccess;
        $[19] = sourceActionSubjectId;
        $[20] = sourceComponent;
        $[21] = streamliningCrossJoinOnButtonClicked;
        $[22] = t5;
    } else t5 = $[22];
    const onCrossJoinTriggerClick = t5;
    let t6;
    if ($[23] !== intl) {
        t6 = intl.formatMessage($012e0fafda229e4e$export$a7357cdd1f0b0168.crossJoinCTA);
        $[23] = intl;
        $[24] = t6;
    } else t6 = $[24];
    let t7;
    if ($[25] !== onTryNowButtonClick || $[26] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "discovery",
            onClick: onTryNowButtonClick
        }, t6);
        $[25] = onTryNowButtonClick;
        $[26] = t6;
        $[27] = t7;
    } else t7 = $[27];
    let t8;
    if ($[28] !== onCrossJoinTriggerClick || $[29] !== triggerLink) {
        t8 = (popupTriggerProps)=>triggerLink("", {
                ...popupTriggerProps,
                onClick: onCrossJoinTriggerClick
            });
        $[28] = onCrossJoinTriggerClick;
        $[29] = triggerLink;
        $[30] = t8;
    } else t8 = $[30];
    let t9;
    if ($[31] !== description || $[32] !== entryPointId || $[33] !== placement || $[34] !== shouldRenderToParent || $[35] !== sourceComponent || $[36] !== t7 || $[37] !== t8 || $[38] !== title) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cnQgR.BaseLoomPopupCard), {
            actions: t7,
            description: description,
            entryPointId: entryPointId,
            placement: placement,
            shouldRenderToParent: shouldRenderToParent,
            title: title,
            trigger: t8,
            sourceAdType: $012e0fafda229e4e$var$sourceAdType,
            sourceComponent: sourceComponent
        });
        $[31] = description;
        $[32] = entryPointId;
        $[33] = placement;
        $[34] = shouldRenderToParent;
        $[35] = sourceComponent;
        $[36] = t7;
        $[37] = t8;
        $[38] = title;
        $[39] = t9;
    } else t9 = $[39];
    return t9;
} : ({ description: description, entryPointId: entryPointId, placement: placement, shouldRenderToParent: shouldRenderToParent, sourceActionSubjectId: sourceActionSubjectId, sourceComponent: sourceComponent, title: title, triggerLink: triggerLink, flags: flags })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const intl = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { stopPulse: stopPulse } = (0, $gd8AW.useDiscoverabilityPulseActions)();
    const streamliningCrossJoinOnButtonClicked = (0, $erVVf.useStreamliningCrossJoin)({
        entryPointId: entryPointId,
        flags: flags,
        source: 'loomCrossJoinPopupCard',
        sourceAdType: $012e0fafda229e4e$var$sourceAdType,
        sourceComponent: sourceComponent
    });
    const stopDiscoverabilityPulse = (0, $cozmU.useCallback)(()=>{
        stopPulse();
    }, [
        stopPulse
    ]);
    const onCrossJoinSuccess = (0, $cozmU.useCallback)(()=>{
        stopDiscoverabilityPulse();
        experienceTracker.succeed({
            name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
            attributes: {
                sourceComponent: entryPointId,
                adType: $012e0fafda229e4e$var$sourceAdType
            }
        });
    }, [
        entryPointId,
        experienceTracker,
        stopDiscoverabilityPulse
    ]);
    const onTryNowButtonClick = (0, $cozmU.useCallback)(async ()=>{
        await streamliningCrossJoinOnButtonClicked(false);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'tryNow',
                source: 'loomCrossJoinPopupCard',
                attributes: {
                    adType: $012e0fafda229e4e$var$sourceAdType,
                    entrypoint: entryPointId,
                    sourceComponent: sourceComponent
                }
            }
        }).fire();
        onCrossJoinSuccess();
    }, [
        createAnalyticsEvent,
        entryPointId,
        onCrossJoinSuccess,
        sourceComponent,
        streamliningCrossJoinOnButtonClicked
    ]);
    const onCrossJoinTriggerClick = (0, $cozmU.useCallback)(async ()=>{
        await streamliningCrossJoinOnButtonClicked(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: sourceActionSubjectId,
                source: sourceActionSubjectId,
                attributes: {
                    adType: $012e0fafda229e4e$var$sourceAdType,
                    entrypoint: entryPointId,
                    sourceComponent: sourceComponent
                }
            }
        }).fire();
        onCrossJoinSuccess();
    }, [
        createAnalyticsEvent,
        entryPointId,
        onCrossJoinSuccess,
        sourceActionSubjectId,
        sourceComponent,
        streamliningCrossJoinOnButtonClicked
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cnQgR.BaseLoomPopupCard), {
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "discovery",
            onClick: onTryNowButtonClick
        }, intl.formatMessage($012e0fafda229e4e$export$a7357cdd1f0b0168.crossJoinCTA)),
        description: description,
        entryPointId: entryPointId,
        placement: placement,
        shouldRenderToParent: shouldRenderToParent,
        title: title,
        trigger: (popupTriggerProps)=>// the plain link behaviour is disabled here; clicks are routed through
            // streamliningCrossJoinOnButtonClicked instead
            triggerLink('', {
                ...popupTriggerProps,
                onClick: onCrossJoinTriggerClick
            }),
        sourceAdType: $012e0fafda229e4e$var$sourceAdType,
        sourceComponent: sourceComponent
    });
};
module.exports["LoomCrossJoinPopupCard"] = $012e0fafda229e4e$export$9937e9f99bf53911;

});

parcelRegister("gd8AW", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $f4d1b21b30388c2e$export$48bd74b0cdc86564 = ()=>{
    return !!(0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED);
};
const $f4d1b21b30388c2e$export$675fdafde077272f = ()=>{
    return (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED, true);
};
const $f4d1b21b30388c2e$var$initialState = {
    activeMessageId: null,
    entryPointIds: [],
    clickTrackingHandler: null,
    dismissHandler: null,
    wasDismissedByUser: false
};
const $f4d1b21b30388c2e$var$actions = {
    startPulse: (entryPointId, messageId, handlers)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const nextState = state.activeMessageId !== messageId ? {
                activeMessageId: messageId,
                entryPointIds: [
                    entryPointId
                ],
                clickTrackingHandler: handlers?.onClick ?? null,
                dismissHandler: handlers?.onDismiss ?? null,
                wasDismissedByUser: false
            } : {
                activeMessageId: messageId,
                entryPointIds: state.entryPointIds.includes(entryPointId) ? state.entryPointIds : [
                    ...state.entryPointIds,
                    entryPointId
                ],
                clickTrackingHandler: handlers?.onClick ?? state.clickTrackingHandler,
                dismissHandler: handlers?.onDismiss ?? state.dismissHandler,
                wasDismissedByUser: false
            };
            const hasEntryPointListChanged = nextState.entryPointIds !== state.entryPointIds;
            const hasClickHandlerChanged = nextState.clickTrackingHandler !== state.clickTrackingHandler;
            const hasDismissHandlerChanged = nextState.dismissHandler !== state.dismissHandler;
            const hasMessageChanged = nextState.activeMessageId !== state.activeMessageId;
            const hasDismissalReset = state.wasDismissedByUser;
            if (!hasEntryPointListChanged && !hasClickHandlerChanged && !hasDismissHandlerChanged && !hasMessageChanged && !hasDismissalReset) return;
            setState(nextState);
        },
    stopPulse: ()=>({ getState: getState, setState: setState })=>{
            const state = getState();
            state.clickTrackingHandler?.();
            state.dismissHandler?.();
            if (!$f4d1b21b30388c2e$export$48bd74b0cdc86564()) $f4d1b21b30388c2e$export$675fdafde077272f();
            if (state.activeMessageId === null && state.entryPointIds.length === 0 && state.dismissHandler === null && state.clickTrackingHandler === null && state.wasDismissedByUser) return;
            setState({
                activeMessageId: null,
                entryPointIds: [],
                clickTrackingHandler: null,
                dismissHandler: null,
                wasDismissedByUser: true
            });
        }
};
const $f4d1b21b30388c2e$var$Store = (0, $8s9DV.createStore)({
    initialState: $f4d1b21b30388c2e$var$initialState,
    actions: $f4d1b21b30388c2e$var$actions,
    name: 'LoomEntryPointsDiscoverabilityPulse'
});
const $f4d1b21b30388c2e$export$e812389786ffbfd0 = (0, $kBr4q.createStateHook)($f4d1b21b30388c2e$var$Store, {
    selector: (state, entryPointId)=>state.entryPointIds.includes(entryPointId) && !state.wasDismissedByUser
});
const $f4d1b21b30388c2e$export$5628ed37e6d9f626 = (0, $kBr4q.createActionsHook)($f4d1b21b30388c2e$var$Store);
module.exports["havePulsesEnded"] = $f4d1b21b30388c2e$export$48bd74b0cdc86564;
module.exports["endPulses"] = $f4d1b21b30388c2e$export$675fdafde077272f;
module.exports["useIsPulseActive"] = $f4d1b21b30388c2e$export$e812389786ffbfd0;
module.exports["useDiscoverabilityPulseActions"] = $f4d1b21b30388c2e$export$5628ed37e6d9f626;

});

parcelRegister("erVVf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $eKMV3 = parcelRequire("eKMV3");


var $f5Ulo = parcelRequire("f5Ulo");


var $64hvi = parcelRequire("64hvi");

const $7197be9efeb6a957$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    requestAccessSuccessFlagTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-success-flag.title",
        defaultMessage: "Your admins were notified of your request"
    },
    requestAccessSuccessFlagDescription: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-success-flag.description",
        defaultMessage: "You\u2019ll receive an email once they\u2019ve approved it."
    },
    requestAccessErrorFlagTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.title",
        defaultMessage: "We couldn't add you to Loom"
    },
    requestAccessErrorFlagDescription: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.description",
        defaultMessage: "Try again in a few minutes. If you still aren't able to join, "
    },
    requestAccessErrorFlagActionTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.action.title",
        defaultMessage: "contact support"
    },
    requestAccessNote: {
        id: "loom-utils.use-streamlining-cross-join.request-access-note.content",
        defaultMessage: "Hi, admin \uD83D\uDC4B I'd like to use Loom to collaborate with my team."
    }
});
const $7197be9efeb6a957$export$76d3f97e5e2f022d = ({ entryPointId: entryPointId, flags: flags, source: source, sourceAdType: sourceAdType, sourceComponent: sourceComponent })=>{
    const intl = (0, $kSwu1.useIntl)();
    const crossJoinHref = (0, $f5Ulo.useLoomCrossJoinUrl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const requestAccess = (0, $64hvi.useRequestAccessService)({
        entryPointId: entryPointId,
        source: source,
        sourceAdType: sourceAdType,
        note: intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessNote)
    });
    const fetchRequestAccessCapability = (0, $64hvi.useFetchRequestAccessCapability)({
        entryPointId: entryPointId,
        source: source,
        sourceAdType: sourceAdType
    });
    return (0, $cozmU.useCallback)(async (fromTrigger = false)=>{
        const capability = await fetchRequestAccessCapability();
        if (capability === 'REQUEST_ACCESS') {
            if (fromTrigger) // do nothing for the trigger click; the request-access flow below handles it
            return;
            try {
                const requestedAccess = await requestAccess();
                if (requestedAccess) {
                    flags && flags.showSuccessFlag({
                        title: intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessSuccessFlagTitle),
                        description: intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessSuccessFlagDescription)
                    });
                    // after successful access request, we do not proceed to open the cross join link
                    return;
                }
            } catch (error) {
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'failed',
                        actionSubject: 'requestAccess',
                        source: source,
                        attributes: {
                            adType: sourceAdType,
                            entrypoint: entryPointId,
                            sourceComponent: sourceComponent,
                            error: error instanceof Error ? error.message : 'unknown'
                        }
                    }
                }).fire();
                flags && flags.showErrorFlag({
                    title: intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessErrorFlagTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessErrorFlagDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
                        href: "https://support.atlassian.com/contact",
                        target: "_blank",
                        rel: "noreferrer"
                    }, intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessErrorFlagActionTitle)))
                });
            }
        }
        // for other capability, we bring back the default link behaviour here
        // as we have disabled the default link behaviour for the trigger button
        window && window.open(crossJoinHref, '_blank');
    }, [
        createAnalyticsEvent,
        crossJoinHref,
        entryPointId,
        fetchRequestAccessCapability,
        flags,
        intl,
        requestAccess,
        source,
        sourceAdType,
        sourceComponent
    ]);
};
module.exports["useStreamliningCrossJoin"] = $7197be9efeb6a957$export$76d3f97e5e2f022d;

});

parcelRegister("64hvi", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $VUk2d = parcelRequire("VUk2d");


var $1HeZJ = parcelRequire("1HeZJ");


var $5QBwN = parcelRequire("5QBwN");


var $6eMp2 = parcelRequire("6eMp2");


var $1ApN2 = parcelRequire("1ApN2");


var $9wGTI = parcelRequire("9wGTI");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");

const $92f7d7126b973070$var$fetchJson = async (input)=>{
    const { url: url, ...options } = input;
    const response = await (0, $f7B1p.cfetch)(url, options);
    return response.json();
};
const $92f7d7126b973070$var$useRequestAccessServiceLegacy = ({ entryPointId: entryPointId, note: note, source: source, sourceAdType: sourceAdType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const deps = (0, $cozmU.useMemo)(()=>({
            createAnalyticsEvent: ({ type: type, data: data })=>createAnalyticsEvent({
                    type: type,
                    data: {
                        source: source,
                        ...data
                    }
                }),
            fetchJSON: $92f7d7126b973070$var$fetchJson,
            getCurrentCloudId: ()=>cloudId,
            getCurrentUserId: ()=>userId ?? '',
            getCurrentProduct: ()=>'confluence'
        }), [
        createAnalyticsEvent,
        cloudId,
        source,
        userId
    ]);
    const requestAccess = (0, $1HeZJ.useService)((0, $5QBwN.requestAccess), deps);
    return (0, $cozmU.useCallback)(async ()=>{
        try {
            const { result: result = '' } = await requestAccess({
                product: 'loom',
                integration: entryPointId,
                note: note
            });
            const success = result === 'PENDING_REQUEST_CREATED';
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'succeeded',
                    actionSubject: 'fetch',
                    actionSubjectId: 'requestAccess',
                    source: source,
                    attributes: {
                        adType: sourceAdType,
                        entrypoint: entryPointId,
                        result: result,
                        success: success
                    }
                }
            }).fire();
            return success;
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'fetch',
                    actionSubjectId: 'requestAccess',
                    source: source,
                    attributes: {
                        adType: sourceAdType,
                        entrypoint: entryPointId,
                        error: error instanceof Error ? error.message : 'unknown',
                        result: undefined,
                        success: false
                    }
                }
            }).fire();
            throw error;
        }
    }, [
        entryPointId,
        note,
        requestAccess,
        source,
        sourceAdType,
        createAnalyticsEvent
    ]);
};
const $92f7d7126b973070$var$useRequestAccessServiceGated = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { entryPointId: entryPointId, note: note, sourceAdType: sourceAdType } = t0;
    const requestAccess = (0, $1ApN2.useService)((0, $5QBwN.requestAccess));
    let t1;
    if ($[0] !== entryPointId || $[1] !== note || $[2] !== requestAccess || $[3] !== sourceAdType) {
        t1 = async ()=>{
            const { error: error, result: result } = await requestAccess({
                product: "loom",
                integration: entryPointId,
                note: note,
                getAdditionalAttributes: (requestAccessResult)=>({
                        adType: sourceAdType,
                        entrypoint: requestAccessResult?.integration,
                        result: requestAccessResult?.result,
                        success: requestAccessResult?.result === "PENDING_REQUEST_CREATED"
                    })
            });
            if (error) return false;
            return result === "PENDING_REQUEST_CREATED";
        };
        $[0] = entryPointId;
        $[1] = note;
        $[2] = requestAccess;
        $[3] = sourceAdType;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ entryPointId: entryPointId, note: note, sourceAdType: sourceAdType })=>{
    const requestAccess = (0, $1ApN2.useService)((0, $5QBwN.requestAccess));
    return (0, $cozmU.useCallback)(async ()=>{
        const { error: error, result: result } = await requestAccess({
            product: 'loom',
            integration: entryPointId,
            note: note,
            getAdditionalAttributes: (requestAccessResult)=>({
                    adType: sourceAdType,
                    entrypoint: requestAccessResult?.integration,
                    result: requestAccessResult?.result,
                    success: requestAccessResult?.result === 'PENDING_REQUEST_CREATED'
                })
        });
        if (error) // The platform service handles error analytics; we surface false to callers
        // instead of re-throwing to match the platform service's error contract.
        return false;
        return result === 'PENDING_REQUEST_CREATED';
    }, [
        entryPointId,
        note,
        requestAccess,
        sourceAdType
    ]);
};
const $92f7d7126b973070$export$1c1d3bfbd79d853f = (0, $VUk2d.functionWithCondition)(()=>(0, $9wGTI.fg)('expansion_services_loom_cross_join'), $92f7d7126b973070$var$useRequestAccessServiceGated, $92f7d7126b973070$var$useRequestAccessServiceLegacy);
const $92f7d7126b973070$var$useFetchRequestAccessCapabilityLegacy = ({ entryPointId: entryPointId, source: source, sourceAdType: sourceAdType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    return (0, $cozmU.useCallback)(async ()=>{
        const resource = `ari:cloud:loom::site/${cloudId}`;
        try {
            const params = new URLSearchParams({
                resource: resource
            });
            const url = `/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`;
            const response = await $92f7d7126b973070$var$fetchJson({
                url: url
            });
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'succeeded',
                    actionSubject: 'fetch',
                    actionSubjectId: 'requestAccessCapability',
                    source: source,
                    attributes: {
                        adType: sourceAdType,
                        entrypoint: entryPointId,
                        resource: resource
                    }
                }
            }).fire();
            return response.results[resource] || undefined;
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'fetch',
                    actionSubjectId: 'requestAccessCapability',
                    source: source,
                    attributes: {
                        adType: sourceAdType,
                        entrypoint: entryPointId,
                        error: error instanceof Error ? error.message : 'unknown',
                        resource: resource
                    }
                }
            }).fire();
        }
        return undefined;
    }, [
        cloudId,
        createAnalyticsEvent,
        entryPointId,
        source,
        sourceAdType
    ]);
};
const $92f7d7126b973070$var$useFetchRequestAccessCapabilityGated = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { entryPointId: entryPointId, sourceAdType: sourceAdType } = t0;
    const capabilitiesService = (0, $1ApN2.useService)((0, $6eMp2.fetchAccessRequestsCapabilities));
    let t1;
    if ($[0] !== capabilitiesService || $[1] !== entryPointId || $[2] !== sourceAdType) {
        t1 = async ()=>{
            const { error: error, result: result } = await capabilitiesService({
                product: "loom",
                integration: entryPointId,
                touchpoint: "Crossjoin Nudge",
                getAdditionalAttributes: (capabilitiesResult)=>({
                        adType: sourceAdType,
                        entrypoint: capabilitiesResult?.integration,
                        resource: capabilitiesResult?.resource
                    })
            });
            if (error) return;
            return result ?? undefined;
        };
        $[0] = capabilitiesService;
        $[1] = entryPointId;
        $[2] = sourceAdType;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ entryPointId: entryPointId, sourceAdType: sourceAdType })=>{
    const capabilitiesService = (0, $1ApN2.useService)((0, $6eMp2.fetchAccessRequestsCapabilities));
    return (0, $cozmU.useCallback)(async ()=>{
        const { error: error, result: result } = await capabilitiesService({
            product: 'loom',
            integration: entryPointId,
            touchpoint: 'Crossjoin Nudge',
            getAdditionalAttributes: (capabilitiesResult)=>({
                    adType: sourceAdType,
                    entrypoint: capabilitiesResult?.integration,
                    resource: capabilitiesResult?.resource
                })
        });
        if (error) return undefined;
        return result ?? undefined;
    }, [
        capabilitiesService,
        entryPointId,
        sourceAdType
    ]);
};
const $92f7d7126b973070$export$a74078d93650d63f = (0, $VUk2d.functionWithCondition)(()=>(0, $9wGTI.fg)('expansion_services_loom_cross_join'), $92f7d7126b973070$var$useFetchRequestAccessCapabilityGated, $92f7d7126b973070$var$useFetchRequestAccessCapabilityLegacy);
module.exports["useRequestAccessService"] = $92f7d7126b973070$export$1c1d3bfbd79d853f;
module.exports["useFetchRequestAccessCapability"] = $92f7d7126b973070$export$a74078d93650d63f;

});

parcelRegister("5QBwN", function(module, exports) {
/**
 * This file defines the requestAccess() service.
 */ 
var $ixfCV = parcelRequire("ixfCV");


var $7avaU = parcelRequire("7avaU");


var $2LYjf = parcelRequire("2LYjf");


var $kMx7n = parcelRequire("kMx7n");


var $6R9dB = parcelRequire("6R9dB");


var $5I0tl = parcelRequire("5I0tl");

// Dependencies - generally common to all RA's/joins:
const $611fd99d6a2b394a$var$dependencies = {
    fetchJSON: $6R9dB.fetchJSON,
    createAnalyticsEvent: $kMx7n.createAnalyticsEvent,
    fireErrorAnalytics: $5I0tl.fireErrorAnalytics,
    getStargateURL: $kMx7n.getStargateURL,
    getCurrentUserId: $kMx7n.getCurrentUserId,
    getCurrentCloudId: $kMx7n.getCurrentCloudId,
    getCurrentProduct: $kMx7n.getCurrentProduct
};
const $611fd99d6a2b394a$export$cd9e5995821603e1 = Object.assign($611fd99d6a2b394a$var$requestAccessImpl, {
    dependencies: $611fd99d6a2b394a$var$dependencies
});
async function $611fd99d6a2b394a$var$requestAccessImpl(input, context) {
    const deps = context.dependencies();
    const cloudId = input.cloudId ?? deps.getCurrentCloudId();
    const userId = deps.getCurrentUserId();
    let result;
    const resource = (0, $7avaU.AnyAri).create({
        resourceType: 'site',
        resourceId: cloudId,
        resourceOwner: input.product
    }).toString();
    try {
        // https://developer.atlassian.com/platform/identity/rest/v1/api-group-access-requests/#api-v2-access-requests-request-post
        const fetchResponse = await deps.fetchJSON({
            url: deps.getStargateURL('/invitations/v1/access-requests/request'),
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                resource: resource,
                ...input.note ? {
                    note: input.note
                } : {},
                metadata: {
                    sourceProduct: deps.getCurrentProduct(),
                    ...input.touchpoint ? {
                        touchpoint: input.touchpoint
                    } : {}
                }
            })
        });
        result = $611fd99d6a2b394a$var$mapRequestAccessResponse(fetchResponse.data, {
            resource: resource,
            userId: userId,
            ...input,
            traceId: fetchResponse.traceId
        });
    } catch (error) {
        result = {
            error: (0, $2LYjf.toError)(error),
            ...input,
            result: null,
            action: null,
            resource: resource,
            userId: userId
        };
    }
    $611fd99d6a2b394a$var$fireRequestAccessAnalytics(result, context, input.getAdditionalAttributes);
    return result;
}
function $611fd99d6a2b394a$var$mapStatusToAction(status) {
    if (status === 'ACCESS_GRANTED') return 'joined';
    if (status === 'PENDING_REQUEST_CREATED') return 'requested';
    return null;
}
function $611fd99d6a2b394a$var$mapRequestAccessResponse(response, input) {
    const result = response.results[input.resource];
    return {
        error: null,
        result: result,
        action: $611fd99d6a2b394a$var$mapStatusToAction(result),
        ...input
    };
}
// Analytics functions for these common events might later become
// exported for standalone use
function $611fd99d6a2b394a$var$fireRequestAccessAnalytics(requestAccessResult, context, getAdditionalAttributes) {
    const { error: error, product: product, result: result, traceId: traceId, integration: integration, touchpoint: touchpoint, cloudId: cloudId } = requestAccessResult;
    const currentUserId = context.dependencies().getCurrentUserId();
    const baseAttributes = {
        userAaid: currentUserId,
        actorAaid: currentUserId,
        roleName: 'product/member',
        sourceProduct: context.dependencies().getCurrentProduct(),
        sourceTenantId: context.dependencies().getCurrentCloudId(),
        targetProduct: product,
        targetTenantId: cloudId ?? context.dependencies().getCurrentCloudId(),
        integration: integration,
        ...traceId ? {
            traceId: traceId
        } : {}
    };
    // touchpoint is deliberately excluded from product.joined / productAccess.requested's
    // nested `attributes`. Will consolidate when 'expansion-services-invite-capabilities' is
    // cleaned up.
    if (error) {
        if ((0, $ixfCV.fg)('expansion-services-invite-capabilities')) context.dependencies().fireErrorAnalytics({
            error: error,
            meta: {
                id: 'requestAccess'
            },
            attributes: {
                ...getAdditionalAttributes?.(requestAccessResult) ?? {},
                ...baseAttributes,
                ...touchpoint ? {
                    touchpoint: touchpoint
                } : {}
            }
        });
        return;
    }
    if ((0, $ixfCV.fg)('expansion-services-invite-capabilities')) $611fd99d6a2b394a$var$fireRequestAccessSucceeded({
        ...getAdditionalAttributes?.(requestAccessResult) ?? {},
        ...baseAttributes,
        ...touchpoint ? {
            touchpoint: touchpoint
        } : {}
    }, context);
    const attributes = {
        ...baseAttributes,
        inviteStatus: result
    };
    if (result === 'ACCESS_GRANTED') {
        $611fd99d6a2b394a$var$fireProductJoined(attributes, context, touchpoint);
        return;
    }
    if (!(0, $ixfCV.fg)('expansion-services-invite-capabilities') || result === 'PENDING_REQUEST_CREATED') {
        $611fd99d6a2b394a$var$fireProductAccessRequested(attributes, context, touchpoint);
        return;
    }
}
function $611fd99d6a2b394a$var$fireProductAccessRequested(attributes, context, touchpoint) {
    context.dependencies().createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'productAccess',
            action: 'requested',
            actionSubjectId: attributes.targetProduct,
            source: touchpoint ?? (0, $kMx7n.EnablementTouchpoint).UNKNOWN,
            attributes: attributes,
            tags: [
                'growth'
            ]
        }
    }).fire();
}
function $611fd99d6a2b394a$var$fireProductJoined(attributes, context, touchpoint) {
    context.dependencies().createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'product',
            action: 'joined',
            actionSubjectId: attributes.targetProduct,
            source: touchpoint ?? (0, $kMx7n.EnablementTouchpoint).UNKNOWN,
            attributes: attributes,
            tags: [
                'growth'
            ]
        }
    }).fire();
}
function $611fd99d6a2b394a$var$fireRequestAccessSucceeded(attributes, context) {
    context.dependencies().createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            actionSubject: 'requestAccess',
            action: 'succeeded',
            source: attributes.touchpoint ?? (0, $kMx7n.EnablementTouchpoint).UNKNOWN,
            attributes: attributes,
            tags: [
                'growth'
            ]
        }
    }).fire();
}
module.exports["requestAccess"] = $611fd99d6a2b394a$export$cd9e5995821603e1;

});

parcelRegister("6eMp2", function(module, exports) {
/**
 * This file defines the fetchAccessRequestsCapabilities() service.
 * https://hello.atlassian.net/wiki/spaces/ETRUST/pages/626729299/API+Guide+-+v1+access-requests+capabilities
 */ 
var $ixfCV = parcelRequire("ixfCV");


var $7avaU = parcelRequire("7avaU");


var $2LYjf = parcelRequire("2LYjf");


var $kMx7n = parcelRequire("kMx7n");


var $6R9dB = parcelRequire("6R9dB");


var $5I0tl = parcelRequire("5I0tl");

const $e13ee81b60f2c25b$export$142e3ccf43b34609 = (accessMode, verificationStatus)=>{
    switch(accessMode){
        case 'ACCESS_EXISTS':
            return 'ACCESS_EXISTS';
        case 'DIRECT_ACCESS':
            return verificationStatus === 'REQUIRED' ? 'VERIFICATION_REQUIRED' : 'CAN_JOIN';
        case 'REQUEST_ACCESS':
            return verificationStatus === 'REQUIRED' ? 'VERIFICATION_REQUIRED' : 'CAN_REQUEST';
        default:
            return 'CANNOT_REQUEST_ACCESS';
    }
};
// Dependencies
const $e13ee81b60f2c25b$var$dependencies = {
    fetchJSON: $6R9dB.fetchJSON,
    createAnalyticsEvent: $kMx7n.createAnalyticsEvent,
    getCurrentCloudId: $kMx7n.getCurrentCloudId,
    getCurrentProduct: $kMx7n.getCurrentProduct,
    getCurrentUserId: $kMx7n.getCurrentUserId,
    getStargateURL: $kMx7n.getStargateURL
};
const $e13ee81b60f2c25b$export$bf3c7ce8c1124ff = Object.assign($e13ee81b60f2c25b$var$fetchAccessRequestsCapabilitiesImpl, {
    dependencies: $e13ee81b60f2c25b$var$dependencies
});
async function $e13ee81b60f2c25b$var$fetchAccessRequestsCapabilitiesImpl(input, context) {
    const deps = context.dependencies();
    const cloudId = input.cloudId ?? deps.getCurrentCloudId();
    const userId = deps.getCurrentUserId();
    const role = input.role ?? 'product/member';
    let result;
    const resource = (0, $7avaU.AnyAri).create({
        resourceType: 'site',
        resourceId: cloudId,
        resourceOwner: input.product
    }).toString();
    try {
        const url = deps.getStargateURL(`/invitations/v1/access-requests/capabilities?resource=${resource}`);
        const response = await deps.fetchJSON({
            url: url
        });
        result = $e13ee81b60f2c25b$var$mapAccessRequestsCapabilitiesResponse(response.data, {
            ...input,
            resource: resource,
            userId: userId,
            role: role,
            traceId: response.traceId
        });
    } catch (error) {
        result = {
            error: (0, $2LYjf.toError)(error),
            ...input,
            resource: resource,
            userId: userId,
            role: role,
            result: null,
            capability: null
        };
    }
    $e13ee81b60f2c25b$var$fireAccessRequestsCapabilitiesAnalytics(result, context);
    return result;
}
function $e13ee81b60f2c25b$var$fireAccessRequestsCapabilitiesAnalytics(result, context) {
    const { error: error, result: accessMode, product: product, integration: integration, role: role, userId: userId, touchpoint: touchpoint, traceId: traceId, getAdditionalAttributes: getAdditionalAttributes } = result;
    const targetTenantId = result.cloudId ?? context.dependencies().getCurrentCloudId();
    const baseAttributes = {
        ...getAdditionalAttributes?.(result) ?? {},
        actorAaid: userId,
        integration: integration,
        roleName: role,
        sourceProduct: context.dependencies().getCurrentProduct(),
        sourceTenantId: context.dependencies().getCurrentCloudId(),
        targetProduct: product,
        targetTenantId: targetTenantId,
        touchpoint: touchpoint,
        ...traceId ? {
            traceId: traceId
        } : {},
        userAaid: userId
    };
    if (error) {
        $e13ee81b60f2c25b$var$fireAccessRequestsCapabilitiesFailed(baseAttributes, context, error);
        return;
    }
    $e13ee81b60f2c25b$var$fireAccessRequestsCapabilitiesSucceeded({
        ...baseAttributes,
        accessMode: accessMode
    }, context);
    return;
}
function $e13ee81b60f2c25b$var$fireAccessRequestsCapabilitiesSucceeded(attributes, context) {
    context.dependencies().createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            actionSubject: 'fetchAccessRequestsCapabilities',
            action: 'succeeded',
            source: attributes.touchpoint,
            attributes: attributes,
            tags: [
                'growth'
            ]
        }
    }).fire();
}
function $e13ee81b60f2c25b$var$fireAccessRequestsCapabilitiesFailed(attributes, context, error) {
    if ((0, $ixfCV.fg)('expansion-services-invite-capabilities')) {
        (0, $5I0tl.fireErrorAnalytics)({
            error: error,
            meta: {
                id: 'fetchAccessRequestsCapabilities'
            },
            attributes: attributes
        }, context);
        return;
    }
    const fireErrorAnalytics = context.dependencies().fireErrorAnalytics;
    if (fireErrorAnalytics) {
        fireErrorAnalytics({
            error: error,
            meta: {
                id: 'fetchAccessRequestsCapabilities'
            },
            attributes: attributes
        });
        return;
    }
    context.dependencies().createAnalyticsEvent({
        type: 'sendOperationalEvent',
        data: {
            actionSubject: 'fetchAccessRequestsCapabilities',
            action: 'failed',
            source: attributes.touchpoint,
            attributes: {
                ...attributes,
                message: error.message
            },
            tags: [
                'growth'
            ]
        }
    }).fire();
}
function $e13ee81b60f2c25b$var$mapAccessRequestsCapabilitiesResponse(response, input) {
    const result = response.resultsV2[input.resource]?.find(({ role: role })=>role === input.role)?.accessMode;
    if (!result) return {
        error: new Error(`No access request capability found for the given resource: ${input.resource} and role: ${input.role}`),
        result: null,
        capability: null,
        ...input
    };
    return {
        error: null,
        result: result,
        capability: $e13ee81b60f2c25b$export$142e3ccf43b34609(result, response.verificationStatus),
        ...input
    };
}
module.exports["fetchAccessRequestsCapabilities"] = $e13ee81b60f2c25b$export$bf3c7ce8c1124ff;

});

parcelRegister("cnQgR", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4nIKB = parcelRequire("4nIKB");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $I7hWB = parcelRequire("I7hWB");


var $cJ0FD = parcelRequire("cJ0FD");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $bltJZ = parcelRequire("bltJZ");


var $5wHqn = parcelRequire("5wHqn");


var $3izAL = parcelRequire("3izAL");


var $kz1Yj = parcelRequire("kz1Yj");


var $2wCqQ = parcelRequire("2wCqQ");


var $6Pqow = parcelRequire("6Pqow");


var $buxP3 = parcelRequire("buxP3");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $9aU7l = parcelRequire("9aU7l");


var $ehWBB = parcelRequire("ehWBB");


var $8unIh = parcelRequire("8unIh");


var $l3ydK = parcelRequire("l3ydK");


var $2K2hA = parcelRequire("2K2hA");


var $6OwHS = parcelRequire("6OwHS");


var $6VFk2 = parcelRequire("6VFk2");


var $2Vz7H = parcelRequire("2Vz7H");


var $4AC39 = parcelRequire("4AC39");


var $gi4qj = parcelRequire("gi4qj");


var $uyMbP = parcelRequire("uyMbP");


var $3eYzF = parcelRequire("3eYzF");


var $8jXZv = parcelRequire("8jXZv");


var $9Zall = parcelRequire("9Zall");


var $dOlTT = parcelRequire("dOlTT");

const $282df3a04f7add9c$export$e4ecefef0a48fd72 = 400;
const $282df3a04f7add9c$var$i18n = (0, $kSwu1.defineMessages)({
    tryNow: {
        id: "loom-utils.loom-cross-sell-popup-card.tryNow",
        defaultMessage: "Try now"
    }
});
const $282df3a04f7add9c$var$cardStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.small',
    overflow: 'auto',
    width: '352px'
});
const $282df3a04f7add9c$var$cardContentStyles = (0, $buxP3.xcss)({
    padding: 'space.300'
});
const $282df3a04f7add9c$var$imageContainerStyles = (0, $buxP3.xcss)({
    height: '201px'
});
const $282df3a04f7add9c$var$spotlightContentContainerStyles = (0, $buxP3.xcss)({
    position: 'fixed'
});
const $282df3a04f7add9c$export$48e89f1cdc429537 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(83);
    const { actions: actions, description: description, entryPointId: entryPointId, placement: placement, spotlightPlacement: spotlightPlacement, shouldRenderToParent: t1, title: title, trigger: trigger, sourceAdType: sourceAdType, sourceComponent: sourceComponent, primaryOnClick: primaryOnClick, adControl: adControl } = t0;
    const shouldRenderToParent = t1 === undefined ? true : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const isDarkMode = colorMode === "dark";
    const intl = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const hasStartedPreloadingImage = (0, $cozmU.useRef)(false);
    const closePopupTimerRef = (0, $cozmU.useRef)(null);
    const openPopupTimerRef = (0, $cozmU.useRef)(null);
    const contentWrapperElementRef = (0, $cozmU.useRef)(null);
    const triggerElementRef = (0, $cozmU.useRef)(null);
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            if (closePopupTimerRef.current) {
                clearTimeout(closePopupTimerRef.current);
                closePopupTimerRef.current = null;
            }
        };
        $[0] = t2;
    } else t2 = $[0];
    const clearClosePopupTimer = t2;
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            if (openPopupTimerRef.current) {
                clearTimeout(openPopupTimerRef.current);
                openPopupTimerRef.current = null;
            }
        };
        $[1] = t3;
    } else t3 = $[1];
    const clearOpenPopupTimer = t3;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t4;
    let t5;
    if ($[2] !== entryPointId || $[3] !== experienceTracker || $[4] !== isOpen || $[5] !== sourceAdType) {
        t4 = ()=>{
            if (isOpen) experienceTracker.start({
                name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
                attributes: {
                    sourceComponent: entryPointId,
                    adType: sourceAdType
                }
            });
        };
        t5 = [
            entryPointId,
            experienceTracker,
            isOpen,
            sourceAdType
        ];
        $[2] = entryPointId;
        $[3] = experienceTracker;
        $[4] = isOpen;
        $[5] = sourceAdType;
        $[6] = t4;
        $[7] = t5;
    } else {
        t4 = $[6];
        t5 = $[7];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[8] !== entryPointId || $[9] !== experienceTracker || $[10] !== sourceAdType) {
        t6 = ()=>{
            setIsOpen(false);
            experienceTracker.abort({
                name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
                reason: "Loom pop up closed",
                attributes: {
                    sourceComponent: entryPointId,
                    adType: sourceAdType
                }
            });
        };
        $[8] = entryPointId;
        $[9] = experienceTracker;
        $[10] = sourceAdType;
        $[11] = t6;
    } else t6 = $[11];
    const safeClosePopup = t6;
    let t7;
    if ($[12] !== safeClosePopup) {
        t7 = ()=>{
            clearOpenPopupTimer();
            if (!closePopupTimerRef.current) closePopupTimerRef.current = setTimeout(()=>{
                safeClosePopup();
                closePopupTimerRef.current = null;
            }, $282df3a04f7add9c$export$e4ecefef0a48fd72);
        };
        $[12] = safeClosePopup;
        $[13] = t7;
    } else t7 = $[13];
    const startClosePopupTimer = t7;
    let t8;
    if ($[14] !== createAnalyticsEvent || $[15] !== entryPointId || $[16] !== sourceAdType || $[17] !== sourceComponent) {
        t8 = ()=>{
            clearClosePopupTimer();
            if (!hasStartedPreloadingImage.current) {
                hasStartedPreloadingImage.current = true;
                const img = new Image();
                img.src = (0, (/*@__PURE__*/$parcel$interopDefault($9aU7l)));
            }
            if (!openPopupTimerRef.current) openPopupTimerRef.current = setTimeout(()=>{
                createAnalyticsEvent({
                    type: "sendScreenEvent",
                    data: {
                        name: "loomAdPopupCard",
                        attributes: {
                            adType: sourceAdType,
                            entrypoint: entryPointId,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
                setIsOpen(true);
                openPopupTimerRef.current = null;
            }, $282df3a04f7add9c$export$e4ecefef0a48fd72);
        };
        $[14] = createAnalyticsEvent;
        $[15] = entryPointId;
        $[16] = sourceAdType;
        $[17] = sourceComponent;
        $[18] = t8;
    } else t8 = $[18];
    const startOpenPopupTimer = t8;
    let t9;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = ()=>{
            clearOpenPopupTimer();
        };
        $[19] = t9;
    } else t9 = $[19];
    const handleTriggerBlur = t9;
    let t10;
    if ($[20] !== startOpenPopupTimer) {
        t10 = ()=>{
            startOpenPopupTimer();
        };
        $[20] = startOpenPopupTimer;
        $[21] = t10;
    } else t10 = $[21];
    const handleTriggerMouseEnter = t10;
    let t11;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = ()=>{
            clearClosePopupTimer();
        };
        $[22] = t11;
    } else t11 = $[22];
    const handleCardMouseEnter = t11;
    let t12;
    if ($[23] !== startClosePopupTimer) {
        t12 = ()=>{
            if (!contentWrapperElementRef.current?.contains(document.activeElement) && document.activeElement !== triggerElementRef.current) startClosePopupTimer();
        };
        $[23] = startClosePopupTimer;
        $[24] = t12;
    } else t12 = $[24];
    const handleMouseLeave = t12;
    let t13;
    if ($[25] !== actions || $[26] !== description || $[27] !== handleMouseLeave || $[28] !== title) {
        t13 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                onMouseEnter: handleCardMouseEnter,
                onMouseLeave: handleMouseLeave,
                ref: contentWrapperElementRef,
                xcss: $282df3a04f7add9c$var$cardStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $282df3a04f7add9c$var$imageContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
                alt: "",
                height: "201px",
                width: "352px",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($9aU7l)))
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
                space: "space.300",
                xcss: $282df3a04f7add9c$var$cardContentStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
                as: "h2",
                size: "small"
            }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
                as: "p",
                color: "color.text.subtle"
            }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
                alignBlock: "center",
                spread: "space-between"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.LoomAttributionLogo), {
                appearance: "brand",
                size: "medium"
            }), actions)));
        $[25] = actions;
        $[26] = description;
        $[27] = handleMouseLeave;
        $[28] = title;
        $[29] = t13;
    } else t13 = $[29];
    const content = t13;
    if (sourceAdType === "crossFlow") {
        let t14;
        if ($[30] !== handleMouseLeave || $[31] !== handleTriggerMouseEnter || $[32] !== isOpen || $[33] !== trigger) {
            t14 = trigger({
                ref: triggerElementRef,
                isSelected: isOpen,
                onBlur: handleTriggerBlur,
                onMouseEnter: handleTriggerMouseEnter,
                onMouseLeave: handleMouseLeave,
                "aria-expanded": isOpen,
                "aria-haspopup": true
            });
            $[30] = handleMouseLeave;
            $[31] = handleTriggerMouseEnter;
            $[32] = isOpen;
            $[33] = trigger;
            $[34] = t14;
        } else t14 = $[34];
        let t15;
        if ($[35] !== t14) {
            t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, t14);
            $[35] = t14;
            $[36] = t15;
        } else t15 = $[36];
        const t16 = spotlightPlacement || "left-start";
        let t17;
        if ($[37] !== title) {
            t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
                as: "span",
                size: "xsmall"
            }, title);
            $[37] = title;
            $[38] = t17;
        } else t17 = $[38];
        let t18;
        if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
            t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l3ydK.SpotlightDismissControl), null);
            $[39] = t18;
        } else t18 = $[39];
        let t19;
        if ($[40] !== adControl) {
            t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AC39.SpotlightControls), null, t18, adControl);
            $[40] = adControl;
            $[41] = t19;
        } else t19 = $[41];
        let t20;
        if ($[42] !== t17 || $[43] !== t19) {
            t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6VFk2.SpotlightHeader), null, t17, t19);
            $[42] = t17;
            $[43] = t19;
            $[44] = t20;
        } else t20 = $[44];
        const t21 = isDarkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($8unIh))) : (0, (/*@__PURE__*/$parcel$interopDefault($ehWBB)));
        let t22;
        if ($[45] !== t21) {
            t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OwHS.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
                alt: "",
                src: t21
            }));
            $[45] = t21;
            $[46] = t22;
        } else t22 = $[46];
        let t23;
        if ($[47] !== description) {
            t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyMbP.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
                as: "p"
            }, description));
            $[47] = description;
            $[48] = t23;
        } else t23 = $[48];
        let t24;
        if ($[49] !== intl) {
            t24 = intl.formatMessage($282df3a04f7add9c$var$i18n.tryNow);
            $[49] = intl;
            $[50] = t24;
        } else t24 = $[50];
        let t25;
        if ($[51] !== primaryOnClick || $[52] !== t24) {
            t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Vz7H.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eYzF.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2K2hA.SpotlightPrimaryAction), {
                onClick: primaryOnClick
            }, t24)));
            $[51] = primaryOnClick;
            $[52] = t24;
            $[53] = t25;
        } else t25 = $[53];
        let t26;
        if ($[54] !== t20 || $[55] !== t22 || $[56] !== t23 || $[57] !== t25) {
            t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gi4qj.SpotlightCard), {
                testId: "loom-cross-sell-spotlight-content-card"
            }, t20, t22, t23, t25);
            $[54] = t20;
            $[55] = t22;
            $[56] = t23;
            $[57] = t25;
            $[58] = t26;
        } else t26 = $[58];
        let t27;
        if ($[59] !== isOpen || $[60] !== safeClosePopup || $[61] !== t16 || $[62] !== t26) {
            t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dOlTT.PopoverContent), {
                isVisible: isOpen,
                placement: t16,
                dismiss: safeClosePopup,
                testId: "loom-cross-sell-spotlight-content",
                strategy: "absolute",
                shouldDismissOnClickOutside: false
            }, t26);
            $[59] = isOpen;
            $[60] = safeClosePopup;
            $[61] = t16;
            $[62] = t26;
            $[63] = t27;
        } else t27 = $[63];
        let t28;
        if ($[64] !== handleMouseLeave || $[65] !== t27) {
            t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                ref: triggerElementRef,
                testId: "loom-cross-sell-spotlight-content-container",
                onMouseEnter: handleCardMouseEnter,
                onMouseLeave: handleMouseLeave,
                xcss: $282df3a04f7add9c$var$spotlightContentContainerStyles
            }, t27);
            $[64] = handleMouseLeave;
            $[65] = t27;
            $[66] = t28;
        } else t28 = $[66];
        let t29;
        if ($[67] !== t15 || $[68] !== t28) {
            t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, t15, t28);
            $[67] = t15;
            $[68] = t28;
            $[69] = t29;
        } else t29 = $[69];
        return t29;
    }
    const t14 = placement || "auto";
    let t15;
    if ($[70] !== handleMouseLeave || $[71] !== handleTriggerMouseEnter || $[72] !== isOpen || $[73] !== trigger) {
        t15 = (popupTriggerProps)=>trigger({
                ...popupTriggerProps,
                isSelected: isOpen,
                onBlur: handleTriggerBlur,
                onMouseEnter: handleTriggerMouseEnter,
                onMouseLeave: handleMouseLeave,
                ref: (0, $4nIKB.mergeRefs)([
                    popupTriggerProps.ref,
                    triggerElementRef
                ])
            });
        $[70] = handleMouseLeave;
        $[71] = handleTriggerMouseEnter;
        $[72] = isOpen;
        $[73] = trigger;
        $[74] = t15;
    } else t15 = $[74];
    let t16;
    if ($[75] !== content || $[76] !== isOpen || $[77] !== safeClosePopup || $[78] !== shouldRenderToParent || $[79] !== t14 || $[80] !== t15 || $[81] !== title) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
            autoFocus: false,
            content: content,
            isOpen: isOpen,
            label: title,
            onClose: safeClosePopup,
            placement: t14,
            role: "dialog",
            shouldRenderToParent: shouldRenderToParent,
            trigger: t15
        });
        $[75] = content;
        $[76] = isOpen;
        $[77] = safeClosePopup;
        $[78] = shouldRenderToParent;
        $[79] = t14;
        $[80] = t15;
        $[81] = title;
        $[82] = t16;
    } else t16 = $[82];
    return t16;
} : ({ actions: actions, description: description, entryPointId: entryPointId, placement: placement, spotlightPlacement: spotlightPlacement, shouldRenderToParent: shouldRenderToParent = true, title: title, trigger: trigger, sourceAdType: sourceAdType, sourceComponent: sourceComponent, primaryOnClick: primaryOnClick, adControl: adControl })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const isDarkMode = colorMode === 'dark';
    const intl = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const hasStartedPreloadingImage = (0, $cozmU.useRef)(false);
    const closePopupTimerRef = (0, $cozmU.useRef)(null);
    const openPopupTimerRef = (0, $cozmU.useRef)(null);
    const contentWrapperElementRef = (0, $cozmU.useRef)(null);
    const triggerElementRef = (0, $cozmU.useRef)(null);
    const clearClosePopupTimer = (0, $cozmU.useCallback)(()=>{
        if (closePopupTimerRef.current) {
            clearTimeout(closePopupTimerRef.current);
            closePopupTimerRef.current = null;
        }
    }, []);
    const clearOpenPopupTimer = (0, $cozmU.useCallback)(()=>{
        if (openPopupTimerRef.current) {
            clearTimeout(openPopupTimerRef.current);
            openPopupTimerRef.current = null;
        }
    }, []);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $cozmU.useEffect)(()=>{
        if (isOpen) experienceTracker.start({
            name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
            attributes: {
                sourceComponent: entryPointId,
                adType: sourceAdType
            }
        });
    }, [
        entryPointId,
        experienceTracker,
        isOpen,
        sourceAdType
    ]);
    const safeClosePopup = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
        experienceTracker.abort({
            name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
            reason: 'Loom pop up closed',
            attributes: {
                sourceComponent: entryPointId,
                adType: sourceAdType
            }
        });
    }, [
        entryPointId,
        experienceTracker,
        sourceAdType
    ]);
    const startClosePopupTimer = (0, $cozmU.useCallback)(()=>{
        clearOpenPopupTimer();
        if (!closePopupTimerRef.current) closePopupTimerRef.current = setTimeout(()=>{
            safeClosePopup();
            closePopupTimerRef.current = null;
        }, $282df3a04f7add9c$export$e4ecefef0a48fd72);
    }, [
        clearOpenPopupTimer,
        safeClosePopup
    ]);
    /**
   * Don't open the popup card immediately on hover or focus
   *
   * 1) Focus: We want KB users to be able to quickly navigate through areas with entrypoints that
   * are alongside many other UI controls (e.g., Page Header, Page Editor Toolbar) without triggering
   * the popup card and getting "stuck" (needing to hit "esc" to continue).
   *
   * 2) Hover: We don't want users to feel like the popup card gets in their way of clicking other
   * things in the UI just because their mouse briefly brushed over the entrypoint button.
   *
   * This was heavily inspired by the hover cards used in the Page Tree (`useHoverPageCard`)
   */ const startOpenPopupTimer = (0, $cozmU.useCallback)(()=>{
        clearClosePopupTimer();
        if (!hasStartedPreloadingImage.current) {
            hasStartedPreloadingImage.current = true;
            const img = new Image();
            img.src = (0, (/*@__PURE__*/$parcel$interopDefault($9aU7l)));
        }
        if (!openPopupTimerRef.current) openPopupTimerRef.current = setTimeout(()=>{
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'loomAdPopupCard',
                    attributes: {
                        adType: sourceAdType,
                        entrypoint: entryPointId,
                        sourceComponent: sourceComponent
                    }
                }
            }).fire();
            setIsOpen(true);
            openPopupTimerRef.current = null;
        }, $282df3a04f7add9c$export$e4ecefef0a48fd72);
    }, [
        clearClosePopupTimer,
        createAnalyticsEvent,
        entryPointId,
        sourceAdType,
        sourceComponent
    ]);
    const handleTriggerBlur = (0, $cozmU.useCallback)(()=>{
        clearOpenPopupTimer();
    }, [
        clearOpenPopupTimer
    ]);
    const handleTriggerMouseEnter = (0, $cozmU.useCallback)(()=>{
        startOpenPopupTimer();
    }, [
        startOpenPopupTimer
    ]);
    const handleCardMouseEnter = (0, $cozmU.useCallback)(()=>{
        clearClosePopupTimer();
    }, [
        clearClosePopupTimer
    ]);
    const handleMouseLeave = (0, $cozmU.useCallback)(()=>{
        /**
     * Don't close the popup card when moving the mouse outside of it (or the trigger) if something
     * inside it (or the trigger itself) is focused
     */ if (// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        !contentWrapperElementRef.current?.contains(document.activeElement) && // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.activeElement !== triggerElementRef.current) startClosePopupTimer();
    }, [
        startClosePopupTimer
    ]);
    const content = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            onMouseEnter: handleCardMouseEnter,
            onMouseLeave: handleMouseLeave,
            ref: contentWrapperElementRef,
            xcss: $282df3a04f7add9c$var$cardStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $282df3a04f7add9c$var$imageContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            alt: "",
            height: "201px",
            width: "352px",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($9aU7l)))
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            space: "space.300",
            xcss: $282df3a04f7add9c$var$cardContentStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h2",
            size: "small"
        }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
            as: "p",
            color: "color.text.subtle"
        }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            alignBlock: "center",
            spread: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.LoomAttributionLogo), {
            appearance: "brand",
            size: "medium"
        }), actions)));
    if (sourceAdType === 'crossFlow') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, trigger({
        ref: triggerElementRef,
        isSelected: isOpen,
        onBlur: handleTriggerBlur,
        onMouseEnter: handleTriggerMouseEnter,
        onMouseLeave: handleMouseLeave,
        'aria-expanded': isOpen,
        'aria-haspopup': true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        ref: triggerElementRef,
        testId: "loom-cross-sell-spotlight-content-container",
        onMouseEnter: handleCardMouseEnter,
        onMouseLeave: handleMouseLeave,
        xcss: $282df3a04f7add9c$var$spotlightContentContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dOlTT.PopoverContent), {
        isVisible: isOpen,
        placement: spotlightPlacement || 'left-start',
        dismiss: safeClosePopup,
        testId: "loom-cross-sell-spotlight-content",
        strategy: "absolute",
        shouldDismissOnClickOutside: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gi4qj.SpotlightCard), {
        testId: "loom-cross-sell-spotlight-content-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6VFk2.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "span",
        size: "xsmall"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AC39.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l3ydK.SpotlightDismissControl), null), adControl)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OwHS.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        alt: "",
        src: isDarkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($8unIh))) : (0, (/*@__PURE__*/$parcel$interopDefault($ehWBB)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyMbP.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        as: "p"
    }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Vz7H.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eYzF.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2K2hA.SpotlightPrimaryAction), {
        onClick: primaryOnClick
    }, intl.formatMessage($282df3a04f7add9c$var$i18n.tryNow))))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        autoFocus: false,
        content: content,
        isOpen: isOpen,
        /**
   * Using `titleId` and adding the same value as an `id` to the Heading in the popup content
   * does not announce properly in macOS VoiceOver
   */ label: title,
        onClose: safeClosePopup,
        placement: placement || 'auto',
        role: "dialog",
        shouldRenderToParent: shouldRenderToParent,
        trigger: (popupTriggerProps)=>trigger({
                ...popupTriggerProps,
                isSelected: isOpen,
                onBlur: handleTriggerBlur,
                onMouseEnter: handleTriggerMouseEnter,
                onMouseLeave: handleMouseLeave,
                ref: (0, $4nIKB.mergeRefs)([
                    popupTriggerProps.ref,
                    triggerElementRef
                ])
            })
    });
};
module.exports["BaseLoomPopupCard"] = $282df3a04f7add9c$export$48e89f1cdc429537;

});

parcelRegister("9aU7l", function(module, exports) {
module.exports = new URL("LoomCrossSellPopupCardImage.6e60c328.png", import.meta.url).toString();

});

parcelRegister("ehWBB", function(module, exports) {
module.exports = new URL("LoomCrossSellPopupCardImageNewVisual_Light.55587eef.png", import.meta.url).toString();

});

parcelRegister("8unIh", function(module, exports) {
module.exports = new URL("LoomCrossSellPopupCardImageNewVisual_Dark.c1c1769c.png", import.meta.url).toString();

});

parcelRegister("6T0Pj", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $ad7Ou = parcelRequire("ad7Ou");


var $1l0kj = parcelRequire("1l0kj");


var $6AG3B = parcelRequire("6AG3B");


var $b5YqG = parcelRequire("b5YqG");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $gd8AW = parcelRequire("gd8AW");


var $ej7WH = parcelRequire("ej7WH");


var $jkI1v = parcelRequire("jkI1v");


var $k0DFC = parcelRequire("k0DFC");


var $cnQgR = parcelRequire("cnQgR");


var $5TQHv = parcelRequire("5TQHv");

const $9bb41a4fe26f7df4$var$sourceAdType = 'crossFlow';
const $9bb41a4fe26f7df4$var$i18n = (0, $kSwu1.defineMessages)({
    tryNow: {
        id: "loom-utils.loom-cross-sell-popup-card.tryNow",
        defaultMessage: "Try now"
    }
});
const $9bb41a4fe26f7df4$var$env = 'prod';
const $9bb41a4fe26f7df4$var$LOOM_CCP_PRODUCT_ID = (0, $6AG3B.FIRST_PARTY_CCP_PRODUCT_IDS)[$9bb41a4fe26f7df4$var$env].loom;
const $9bb41a4fe26f7df4$var$getCrossFlowInteractionSource = (entrypointId)=>{
    switch(entrypointId){
        case 'loom-confluence-inline-comment':
            return 'loomConfluenceInlineCommentButton';
        case 'loom-confluence-page-editor-toolbar':
            return 'loomConfluencePageEditorToolbarButton';
        case 'loom-confluence-page-header':
            return 'loomConfluencePageHeaderButton';
        default:
            return null;
    }
};
const $9bb41a4fe26f7df4$export$7232e4c8af3c9680 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(56);
    const { description: description, entryPointId: entryPointId, spotlightPlacement: spotlightPlacement, sourceActionSubjectId: sourceActionSubjectId, title: title, trigger: trigger, sourceComponent: sourceComponent, sourceContext: sourceContext } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { fireViewedUIEvent: fireViewedUIEvent, fireInteractedUIEvent: fireInteractedUIEvent } = (0, $b5YqG.useFireCrossFlowAnalyticsEvents)();
    const intl = (0, $kSwu1.useIntl)();
    const ctaRef = (0, $cozmU.useRef)(null);
    let t1;
    if ($[0] !== sourceComponent || $[1] !== sourceContext) {
        t1 = {
            sourceComponent: sourceComponent,
            sourceContext: sourceContext
        };
        $[0] = sourceComponent;
        $[1] = sourceContext;
        $[2] = t1;
    } else t1 = $[2];
    const triggerCrossFlow = (0, $ej7WH.useLoomCrossFlowRequestAccessCallback)(t1);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t2;
    if ($[3] !== entryPointId) {
        t2 = {
            touchpoint: entryPointId
        };
        $[3] = entryPointId;
        $[4] = t2;
    } else t2 = $[4];
    const { isInterestedInLoom: isInterestedInLoom, notInterestedInLoomCallback: notInterestedInLoomCallback } = (0, $k0DFC.useLoomAdControlState)(t2);
    const { stopPulse: stopPulse } = (0, $gd8AW.useDiscoverabilityPulseActions)();
    let t3;
    if ($[5] !== stopPulse) {
        t3 = ()=>{
            stopPulse();
        };
        $[5] = stopPulse;
        $[6] = t3;
    } else t3 = $[6];
    const stopDiscoverabilityPulse = t3;
    let t4;
    let t5;
    if ($[7] !== entryPointId || $[8] !== fireViewedUIEvent || $[9] !== sourceComponent) {
        t4 = ()=>{
            fireViewedUIEvent({
                action: "viewed",
                actionSubject: "button",
                actionSubjectId: sourceComponent
            }, {
                source: entryPointId,
                recommendedProductIds: [
                    $9bb41a4fe26f7df4$var$LOOM_CCP_PRODUCT_ID
                ]
            });
        };
        t5 = [
            fireViewedUIEvent,
            sourceComponent,
            entryPointId
        ];
        $[7] = entryPointId;
        $[8] = fireViewedUIEvent;
        $[9] = sourceComponent;
        $[10] = t4;
        $[11] = t5;
    } else {
        t4 = $[10];
        t5 = $[11];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[12] !== createAnalyticsEvent || $[13] !== entryPointId || $[14] !== fireInteractedUIEvent || $[15] !== sourceActionSubjectId || $[16] !== sourceContext || $[17] !== stopDiscoverabilityPulse || $[18] !== triggerCrossFlow) {
        t6 = async (triggerName)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: triggerName,
                    source: triggerName === "tryNow" ? "loomCrossFlowPopupCard" : sourceActionSubjectId,
                    attributes: {
                        adType: $9bb41a4fe26f7df4$var$sourceAdType,
                        entrypoint: entryPointId
                    }
                }
            }).fire();
            const crossFlowInteractionSource = $9bb41a4fe26f7df4$var$getCrossFlowInteractionSource(entryPointId);
            crossFlowInteractionSource && fireInteractedUIEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: sourceContext
            }, {
                source: crossFlowInteractionSource,
                recommendedProductIds: [
                    $9bb41a4fe26f7df4$var$LOOM_CCP_PRODUCT_ID
                ],
                targetProductId: $9bb41a4fe26f7df4$var$LOOM_CCP_PRODUCT_ID
            });
            stopDiscoverabilityPulse();
            await triggerCrossFlow();
        };
        $[12] = createAnalyticsEvent;
        $[13] = entryPointId;
        $[14] = fireInteractedUIEvent;
        $[15] = sourceActionSubjectId;
        $[16] = sourceContext;
        $[17] = stopDiscoverabilityPulse;
        $[18] = triggerCrossFlow;
        $[19] = t6;
    } else t6 = $[19];
    const onCrossFlowTriggerClick = t6;
    let t7;
    if ($[20] !== entryPointId || $[21] !== experienceTracker || $[22] !== notInterestedInLoomCallback || $[23] !== stopDiscoverabilityPulse) {
        t7 = async ()=>{
            experienceTracker.abort({
                name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
                reason: "User not interested in Loom",
                attributes: {
                    sourceComponent: entryPointId,
                    adType: $9bb41a4fe26f7df4$var$sourceAdType
                }
            });
            stopDiscoverabilityPulse();
            await notInterestedInLoomCallback();
        };
        $[20] = entryPointId;
        $[21] = experienceTracker;
        $[22] = notInterestedInLoomCallback;
        $[23] = stopDiscoverabilityPulse;
        $[24] = t7;
    } else t7 = $[24];
    const handleNotInterested = t7;
    if (!isInterestedInLoom) return null;
    let t8;
    if ($[25] !== entryPointId || $[26] !== handleNotInterested) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jkI1v.LoomAdControl), {
            onDismiss: handleNotInterested,
            entryPointId: entryPointId
        });
        $[25] = entryPointId;
        $[26] = handleNotInterested;
        $[27] = t8;
    } else t8 = $[27];
    let t9;
    if ($[28] !== onCrossFlowTriggerClick) {
        t9 = ()=>onCrossFlowTriggerClick("tryNow");
        $[28] = onCrossFlowTriggerClick;
        $[29] = t9;
    } else t9 = $[29];
    let t10;
    if ($[30] !== intl) {
        t10 = intl.formatMessage($9bb41a4fe26f7df4$var$i18n.tryNow);
        $[30] = intl;
        $[31] = t10;
    } else t10 = $[31];
    let t11;
    if ($[32] !== t10 || $[33] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "discovery",
            onClick: t9,
            ref: ctaRef
        }, t10);
        $[32] = t10;
        $[33] = t9;
        $[34] = t11;
    } else t11 = $[34];
    let t12;
    if ($[35] !== t11 || $[36] !== t8) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            space: "space.100"
        }, t8, t11);
        $[35] = t11;
        $[36] = t8;
        $[37] = t12;
    } else t12 = $[37];
    let t13;
    if ($[38] !== onCrossFlowTriggerClick || $[39] !== sourceActionSubjectId || $[40] !== trigger) {
        t13 = (popupTriggerProps)=>trigger({
                ...popupTriggerProps,
                onClick: ()=>onCrossFlowTriggerClick(sourceActionSubjectId),
                onKeyDown: (e)=>{
                    if (e.key === "Tab") ctaRef.current?.focus();
                }
            });
        $[38] = onCrossFlowTriggerClick;
        $[39] = sourceActionSubjectId;
        $[40] = trigger;
        $[41] = t13;
    } else t13 = $[41];
    let t14;
    if ($[42] !== onCrossFlowTriggerClick) {
        t14 = ()=>onCrossFlowTriggerClick("tryNow");
        $[42] = onCrossFlowTriggerClick;
        $[43] = t14;
    } else t14 = $[43];
    let t15;
    if ($[44] !== entryPointId || $[45] !== handleNotInterested) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jkI1v.LoomAdControl), {
            onDismiss: handleNotInterested,
            entryPointId: entryPointId,
            customTrigger: $9bb41a4fe26f7df4$var$_temp
        });
        $[44] = entryPointId;
        $[45] = handleNotInterested;
        $[46] = t15;
    } else t15 = $[46];
    let t16;
    if ($[47] !== description || $[48] !== entryPointId || $[49] !== spotlightPlacement || $[50] !== t12 || $[51] !== t13 || $[52] !== t14 || $[53] !== t15 || $[54] !== title) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cnQgR.BaseLoomPopupCard), {
            actions: t12,
            description: description,
            entryPointId: entryPointId,
            title: title,
            trigger: t13,
            sourceAdType: $9bb41a4fe26f7df4$var$sourceAdType,
            spotlightPlacement: spotlightPlacement,
            primaryOnClick: t14,
            adControl: t15
        });
        $[47] = description;
        $[48] = entryPointId;
        $[49] = spotlightPlacement;
        $[50] = t12;
        $[51] = t13;
        $[52] = t14;
        $[53] = t15;
        $[54] = title;
        $[55] = t16;
    } else t16 = $[55];
    return t16;
} : ({ description: description, entryPointId: entryPointId, spotlightPlacement: spotlightPlacement, sourceActionSubjectId: sourceActionSubjectId, title: title, trigger: trigger, sourceComponent: sourceComponent, sourceContext: sourceContext })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { fireViewedUIEvent: fireViewedUIEvent, fireInteractedUIEvent: fireInteractedUIEvent } = (0, $b5YqG.useFireCrossFlowAnalyticsEvents)();
    const intl = (0, $kSwu1.useIntl)();
    const ctaRef = (0, $cozmU.useRef)(null);
    const triggerCrossFlow = (0, $ej7WH.useLoomCrossFlowRequestAccessCallback)({
        sourceComponent: sourceComponent,
        sourceContext: sourceContext
    });
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isInterestedInLoom: isInterestedInLoom, notInterestedInLoomCallback: notInterestedInLoomCallback } = (0, $k0DFC.useLoomAdControlState)({
        touchpoint: entryPointId
    });
    const { stopPulse: stopPulse } = (0, $gd8AW.useDiscoverabilityPulseActions)();
    const stopDiscoverabilityPulse = (0, $cozmU.useCallback)(()=>{
        stopPulse();
    }, [
        stopPulse
    ]);
    // View event for go/BMD crossflow funnel
    (0, $cozmU.useEffect)(()=>{
        fireViewedUIEvent({
            action: 'viewed',
            actionSubject: 'button',
            actionSubjectId: sourceComponent
        }, {
            source: entryPointId,
            recommendedProductIds: [
                $9bb41a4fe26f7df4$var$LOOM_CCP_PRODUCT_ID
            ]
        });
    }, [
        fireViewedUIEvent,
        sourceComponent,
        entryPointId
    ]);
    const onCrossFlowTriggerClick = (0, $cozmU.useCallback)(async (triggerName)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: triggerName,
                source: triggerName === 'tryNow' ? 'loomCrossFlowPopupCard' : sourceActionSubjectId,
                attributes: {
                    adType: $9bb41a4fe26f7df4$var$sourceAdType,
                    entrypoint: entryPointId
                }
            }
        }).fire();
        // Interaction event for go/BMD crossflow funnel. Only fire if entryPointId is registered in @atlassian/surface-analytics-specs package
        const crossFlowInteractionSource = $9bb41a4fe26f7df4$var$getCrossFlowInteractionSource(entryPointId);
        crossFlowInteractionSource && fireInteractedUIEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: sourceContext
        }, {
            source: crossFlowInteractionSource,
            recommendedProductIds: [
                $9bb41a4fe26f7df4$var$LOOM_CCP_PRODUCT_ID
            ],
            targetProductId: $9bb41a4fe26f7df4$var$LOOM_CCP_PRODUCT_ID
        });
        stopDiscoverabilityPulse();
        await triggerCrossFlow();
    }, [
        createAnalyticsEvent,
        entryPointId,
        triggerCrossFlow,
        sourceActionSubjectId,
        sourceContext,
        fireInteractedUIEvent,
        stopDiscoverabilityPulse
    ]);
    const handleNotInterested = (0, $cozmU.useCallback)(async ()=>{
        experienceTracker.abort({
            name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
            reason: 'User not interested in Loom',
            attributes: {
                sourceComponent: entryPointId,
                adType: $9bb41a4fe26f7df4$var$sourceAdType
            }
        });
        stopDiscoverabilityPulse();
        await notInterestedInLoomCallback();
    }, [
        entryPointId,
        experienceTracker,
        notInterestedInLoomCallback,
        stopDiscoverabilityPulse
    ]);
    if (!isInterestedInLoom) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cnQgR.BaseLoomPopupCard), {
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jkI1v.LoomAdControl), {
            onDismiss: handleNotInterested,
            entryPointId: entryPointId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "discovery",
            onClick: ()=>onCrossFlowTriggerClick('tryNow'),
            ref: ctaRef
        }, intl.formatMessage($9bb41a4fe26f7df4$var$i18n.tryNow))),
        description: description,
        entryPointId: entryPointId,
        title: title,
        trigger: (popupTriggerProps)=>trigger({
                ...popupTriggerProps,
                onClick: ()=>onCrossFlowTriggerClick(sourceActionSubjectId),
                onKeyDown: (e)=>{
                    if (e.key === 'Tab') ctaRef.current?.focus();
                }
            }),
        sourceAdType: $9bb41a4fe26f7df4$var$sourceAdType,
        spotlightPlacement: spotlightPlacement,
        primaryOnClick: ()=>onCrossFlowTriggerClick('tryNow'),
        adControl: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jkI1v.LoomAdControl), {
            onDismiss: handleNotInterested,
            entryPointId: entryPointId,
            customTrigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5TQHv.SpotlightShowMoreControl), {
                    testId: triggerProps.testId,
                    ref: triggerProps.triggerRef,
                    onClick: triggerProps.onClick
                })
        })
    });
};
function $9bb41a4fe26f7df4$var$_temp(triggerProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5TQHv.SpotlightShowMoreControl), {
        testId: triggerProps.testId,
        ref: triggerProps.triggerRef,
        onClick: triggerProps.onClick
    });
}
module.exports["LoomCrossFlowPopupCard"] = $9bb41a4fe26f7df4$export$7232e4c8af3c9680;

});

parcelRegister("6AG3B", function(module, exports) {
const $ad71aceb64f29d5c$export$31048cb2a0753b12 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $ad71aceb64f29d5c$export$9d8f18312db80469 = {
    jira_software_cloud: 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
    jira_work_management_cloud: '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
    jira_service_management_cloud: 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
    jira_product_discovery: 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
    confluence_cloud: '6aab3f4e-cc71-474d-8d28-abef8b057808',
    opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
    teamwork_collection: '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
    loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
};
const $ad71aceb64f29d5c$export$6c053e1694ef181c = {
    prod: $ad71aceb64f29d5c$export$31048cb2a0753b12,
    staging: $ad71aceb64f29d5c$export$9d8f18312db80469
};
const $ad71aceb64f29d5c$export$54e3fc09a2a3347a = {
    products: {
        'confluence.ondemand': '6aab3f4e-cc71-474d-8d28-abef8b057808',
        'jira-software.ondemand': 'd8a847a4-cde4-4c50-8ea1-dc3d4193214f',
        'jira-servicedesk.ondemand': 'de63a248-1f93-46ed-b6ea-ab8e38af1c88',
        'jira-core.ondemand': '46ccaa9e-cdb0-4995-8886-5827a5ff162b',
        opsgenie: 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551',
        statuspage: '0b8ea1e2-52df-11ea-8d77-2e728ce88125',
        townsquare: '7c917705-866d-4b6b-b266-0fc7633e8342',
        compass: '6bce2ccb-4f57-46f5-812a-9dbf02dc28f2',
        'jira-product-discovery': 'a6f908c8-709c-45f4-9e2d-eca25b93b94a',
        beacon: '0a0a31b0-3f5f-4693-b231-9a753bee012e',
        'atlassian-analytics-free': 'f44da23e-5907-4d81-8a78-33bedee10969',
        mercury: 'd16a2ba8-445f-4e83-9c7b-9bcf349ff905',
        'teamwork-collection': '3503c251-c247-4b55-a6ed-d4c8c3257b8b',
        loom: '7683a73e-423d-41a1-b43f-d497656f8b5d'
    }
};
module.exports["FIRST_PARTY_CCP_PRODUCT_IDS"] = $ad71aceb64f29d5c$export$6c053e1694ef181c;
module.exports["SURFACE_ANALYTICS_PRODUCT_MAP"] = $ad71aceb64f29d5c$export$54e3fc09a2a3347a;

});

parcelRegister("b5YqG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $6AG3B = parcelRequire("6AG3B");


var $hnuQ8 = parcelRequire("hnuQ8");

function $a68332960b9f5309$export$c2095165ae2bdcda() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const firedViewedScreenEventName = (0, $cozmU.useRef)();
    const firedViewedUIEventId = (0, $cozmU.useRef)();
    const mapToCcpProductKeys = (0, $cozmU.useCallback)((recommendedProductIds, targetProductId)=>{
        const ccpProductIds = recommendedProductIds.reduce((acc, curr)=>{
            acc.push((0, $6AG3B.SURFACE_ANALYTICS_PRODUCT_MAP).products[curr] ?? curr);
            return acc;
        }, []);
        const ccpTargetProductId = targetProductId && (0, $6AG3B.SURFACE_ANALYTICS_PRODUCT_MAP).products[targetProductId];
        return {
            recommendedProductIds: ccpProductIds,
            targetProductId: ccpTargetProductId ?? targetProductId
        };
    }, []);
    const fireViewedScreenEvent = (0, $cozmU.useCallback)((name, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedScreenEventName.current === name) return;
        const { recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $hnuQ8.eventTypes).SCREEN,
            name: name,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $hnuQ8.CROSS_FLOW_CHANNEL));
        // Record the screen name so we don't fire it again
        firedViewedScreenEventName.current = name;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireViewedUIEvent = (0, $cozmU.useCallback)((event, commonAttributes, attributes)=>{
        // Prevent duplicate events from firing
        if (firedViewedUIEventId.current === event.actionSubjectId) return;
        const { source: source, recommendedProductIds: recommendedProductIds, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds } = mapToCcpProductKeys(recommendedProductIds);
        createAnalyticsEvent({
            eventType: (0, $hnuQ8.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                ...rest,
                ...attributes
            }
        }).fire((0, $hnuQ8.CROSS_FLOW_CHANNEL));
        firedViewedUIEventId.current = event.actionSubjectId;
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    const fireInteractedUIEvent = (0, $cozmU.useCallback)((event, commonAttributes, attributes)=>{
        const { source: source, recommendedProductIds: recommendedProductIds, targetProductId: targetProductId, ...rest } = commonAttributes;
        const { recommendedProductIds: ccpProductIds, targetProductId: ccpTargetProductId } = mapToCcpProductKeys(recommendedProductIds ?? [], targetProductId);
        createAnalyticsEvent({
            eventType: (0, $hnuQ8.eventTypes).UI,
            ...event,
            source: source,
            attributes: {
                recommendedProductIds: ccpProductIds,
                targetProductId: ccpTargetProductId,
                ...rest,
                ...attributes
            }
        }).fire((0, $hnuQ8.CROSS_FLOW_CHANNEL));
    }, [
        createAnalyticsEvent,
        mapToCcpProductKeys
    ]);
    return {
        fireViewedScreenEvent: fireViewedScreenEvent,
        fireViewedUIEvent: fireViewedUIEvent,
        fireInteractedUIEvent: fireInteractedUIEvent
    };
}
module.exports["useFireCrossFlowAnalyticsEvents"] = $a68332960b9f5309$export$c2095165ae2bdcda;

});

parcelRegister("hnuQ8", function(module, exports) {
const $a675bd78c3704abb$export$c536a7e29a0739b8 = 'crossFlow';
var $a675bd78c3704abb$export$285f3d0989f9023f = /*#__PURE__*/ function(eventTypes) {
    eventTypes["UI"] = "ui";
    eventTypes["SCREEN"] = "screen";
    return eventTypes;
}({});
module.exports["CROSS_FLOW_CHANNEL"] = $a675bd78c3704abb$export$c536a7e29a0739b8;
module.exports["eventTypes"] = $a675bd78c3704abb$export$285f3d0989f9023f;

});

parcelRegister("jkI1v", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $l8Rhq = parcelRequire("l8Rhq");


var $3izAL = parcelRequire("3izAL");


var $6Pqow = parcelRequire("6Pqow");


var $buxP3 = parcelRequire("buxP3");


var $9DHhW = parcelRequire("9DHhW");


var $1sCHt = parcelRequire("1sCHt");


var $6TaGl = parcelRequire("6TaGl");


var $uLkdG = parcelRequire("uLkdG");


var $ccwbz = parcelRequire("ccwbz");


var $bZygI = parcelRequire("bZygI");


var $9C8xw = parcelRequire("9C8xw");

const $8b615b773eb5cff4$export$aefe1c8741b24a28 = 'https://www.atlassian.com/legal/privacy-policy';
const $8b615b773eb5cff4$export$81624a1cb6914931 = (0, $kSwu1.defineMessages)({
    dismissFlagTitle: {
        id: "loom-utils.loom-ad-control.dismiss-flag-title",
        defaultMessage: "Got it, thanks for letting us know"
    },
    dismissFlagDescription: {
        id: "loom-utils.loom-ad-control.dismiss-flag-description",
        defaultMessage: "You won\u2019t see this here as often."
    },
    reasonsModalTitle: {
        id: "loom-utils.loom-ad-control.reasons-modal-title",
        defaultMessage: "Why am I seeing this?"
    },
    reasonsModalExplanation: {
        id: "loom-utils.loom-ad-control.reasons-modal-explanation",
        defaultMessage: "We think that <strong>Loom</strong> will improve your team\u2019s productivity. The recommendation is based on:"
    },
    reasonsModalBulletOne: {
        id: "loom-utils.loom-ad-control.reasons-modal-bullet-one",
        defaultMessage: "the size of your team"
    },
    reasonsModalBulletTwo: {
        id: "loom-utils.loom-ad-control.reasons-modal-bullet-two",
        defaultMessage: "your existing Atlassian products"
    },
    privacyPolicy: {
        id: "loom-utils.loom-ad-control.privacy-policy",
        defaultMessage: "Learn more about your data privacy with Atlassian"
    }
});
const $8b615b773eb5cff4$var$linkStyles = (0, $buxP3.xcss)({
    marginTop: 'space.150'
});
const $8b615b773eb5cff4$var$moreIconStyles = (0, $buxP3.xcss)({
    alignSelf: 'center'
});
const $8b615b773eb5cff4$var$LoomAdControlReasonModalBody = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { entryPointId: entryPointId } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== entryPointId) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "loomAdControlReasonsModal",
                    attributes: {
                        adType: "crossFlow",
                        entrypoint: entryPointId
                    }
                }
            }).fire();
        };
        t2 = [
            createAnalyticsEvent,
            entryPointId
        ];
        $[0] = createAnalyticsEvent;
        $[1] = entryPointId;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[4] !== formatMessage) {
        t3 = formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.reasonsModalExplanation, {
            strong: $8b615b773eb5cff4$var$_temp
        });
        $[4] = formatMessage;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
            color: "color.text"
        }, t3);
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== formatMessage) {
        t5 = formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.reasonsModalBulletOne);
        $[8] = formatMessage;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", null, t5);
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== formatMessage) {
        t7 = formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.reasonsModalBulletTwo);
        $[12] = formatMessage;
        $[13] = t7;
    } else t7 = $[13];
    let t8;
    if ($[14] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", null, t7);
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== t6 || $[17] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", null, t6, t8);
        $[16] = t6;
        $[17] = t8;
        $[18] = t9;
    } else t9 = $[18];
    let t10;
    if ($[19] !== formatMessage) {
        t10 = formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.privacyPolicy);
        $[19] = formatMessage;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $8b615b773eb5cff4$var$linkStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8Rhq.default), {
            href: $8b615b773eb5cff4$export$aefe1c8741b24a28,
            target: "_blank"
        }, t10));
        $[21] = t10;
        $[22] = t11;
    } else t11 = $[22];
    let t12;
    if ($[23] !== t11 || $[24] !== t4 || $[25] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t4, t9, t11);
        $[23] = t11;
        $[24] = t4;
        $[25] = t9;
        $[26] = t12;
    } else t12 = $[26];
    return t12;
} : ({ entryPointId: entryPointId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'loomAdControlReasonsModal',
                attributes: {
                    adType: 'crossFlow',
                    entrypoint: entryPointId
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        entryPointId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        color: "color.text"
    }, formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.reasonsModalExplanation, {
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
                weight: "bold",
                color: "color.text"
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", null, formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.reasonsModalBulletOne)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", null, formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.reasonsModalBulletTwo))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $8b615b773eb5cff4$var$linkStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8Rhq.default), {
        href: $8b615b773eb5cff4$export$aefe1c8741b24a28,
        target: "_blank"
    }, formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.privacyPolicy))));
};
const $8b615b773eb5cff4$export$5922fd76035890d5 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { onDismiss: onDismiss, entryPointId: entryPointId, spacing: t1, customTrigger: customTrigger } = t0;
    const spacing = t1 === undefined ? "compact" : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== entryPointId) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "toggleLoomAdControlDropdown",
                    source: "loomCrossFlowPopupCard",
                    attributes: {
                        adType: "crossFlow",
                        entrypoint: entryPointId
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = entryPointId;
        $[2] = t2;
    } else t2 = $[2];
    const fireTriggerClickAnalyticsEvent = t2;
    let t3;
    if ($[3] !== customTrigger || $[4] !== fireTriggerClickAnalyticsEvent || $[5] !== spacing) {
        t3 = (t4)=>{
            const { triggerRef: triggerRef, ...props } = t4;
            return customTrigger ? customTrigger({
                testId: "loom-utils.loom-ad-control.custom-button",
                triggerRef: triggerRef,
                onClick: (e)=>{
                    fireTriggerClickAnalyticsEvent();
                    props.onClick?.(e);
                }
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $8b615b773eb5cff4$var$moreIconStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...props,
                onClick: (e_0)=>{
                    fireTriggerClickAnalyticsEvent();
                    props.onClick?.(e_0);
                },
                appearance: "subtle",
                spacing: spacing,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                ref: triggerRef,
                label: "LoomAdControl",
                testId: "loom-utils.loom-ad-control.button"
            }));
        };
        $[3] = customTrigger;
        $[4] = fireTriggerClickAnalyticsEvent;
        $[5] = spacing;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== createAnalyticsEvent || $[8] !== entryPointId || $[9] !== formatMessage || $[10] !== onDismiss) {
        t4 = (props_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZygI.default), {
                ...props_0,
                flagProps: {
                    title: formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.dismissFlagTitle),
                    description: formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.dismissFlagDescription)
                },
                onClick: onDismiss
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9C8xw.default), {
                ...props_0,
                onClick: ()=>{
                    createAnalyticsEvent({
                        type: "sendUIEvent",
                        data: {
                            action: "clicked",
                            actionSubject: "button",
                            actionSubjectId: "toggleLoomAdControlReasonsModal",
                            source: "loomAdControlDropdown",
                            attributes: {
                                adType: "crossFlow",
                                entrypoint: entryPointId
                            }
                        }
                    }).fire();
                },
                modalProps: {
                    title: formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.reasonsModalTitle),
                    body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8b615b773eb5cff4$var$LoomAdControlReasonModalBody, {
                        entryPointId: entryPointId
                    })
                }
            }));
        $[7] = createAnalyticsEvent;
        $[8] = entryPointId;
        $[9] = formatMessage;
        $[10] = onDismiss;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== t3 || $[13] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uLkdG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ccwbz.default), {
            itemId: "loom-ad-controls",
            placement: "top-end",
            trigger: t3,
            strategy: "absolute"
        }, t4));
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
} : ({ onDismiss: onDismiss, entryPointId: entryPointId, spacing: spacing = 'compact', customTrigger: customTrigger })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const fireTriggerClickAnalyticsEvent = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'toggleLoomAdControlDropdown',
                source: 'loomCrossFlowPopupCard',
                attributes: {
                    adType: 'crossFlow',
                    entrypoint: entryPointId
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        entryPointId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uLkdG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ccwbz.default), {
        itemId: "loom-ad-controls",
        placement: "top-end",
        trigger: ({ triggerRef: triggerRef, ...props })=>customTrigger ? customTrigger({
                testId: 'loom-utils.loom-ad-control.custom-button',
                triggerRef: triggerRef,
                onClick: (e)=>{
                    fireTriggerClickAnalyticsEvent();
                    props.onClick?.(e);
                }
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $8b615b773eb5cff4$var$moreIconStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...props,
                onClick: (e_0)=>{
                    fireTriggerClickAnalyticsEvent();
                    props.onClick?.(e_0);
                },
                appearance: "subtle",
                spacing: spacing,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                ref: triggerRef,
                label: "LoomAdControl",
                testId: "loom-utils.loom-ad-control.button"
            })),
        strategy: "absolute"
    }, (props_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZygI.default), {
            ...props_0,
            flagProps: {
                title: formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.dismissFlagTitle),
                description: formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.dismissFlagDescription)
            },
            onClick: onDismiss
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9C8xw.default), {
            ...props_0,
            onClick: ()=>{
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'toggleLoomAdControlReasonsModal',
                        source: 'loomAdControlDropdown',
                        attributes: {
                            adType: 'crossFlow',
                            entrypoint: entryPointId
                        }
                    }
                }).fire();
            },
            modalProps: {
                title: formatMessage($8b615b773eb5cff4$export$81624a1cb6914931.reasonsModalTitle),
                body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8b615b773eb5cff4$var$LoomAdControlReasonModalBody, {
                    entryPointId: entryPointId
                })
            }
        }))));
};
function $8b615b773eb5cff4$var$_temp(chunks) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        weight: "bold",
        color: "color.text"
    }, chunks);
}
module.exports["LoomAdControl"] = $8b615b773eb5cff4$export$5922fd76035890d5;

});

parcelRegister("uLkdG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $99o35 = parcelRequire("99o35");


var $figLC = parcelRequire("figLC");


var $fWlRQ = parcelRequire("fWlRQ");


var $8ghvK = parcelRequire("8ghvK");


var $g8zAQ = parcelRequire("g8zAQ");

const $e3f008f9351f7b1d$var$AdControlProvider = ({ children: children, onEvents: onEvents = ()=>{}, shouldShowDismissFlag: shouldShowDismissFlag = true })=>{
    const [state, dispatch] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useReducer((0, $figLC.adControlProviderReducer), (0, $figLC.initialAdControlProviderState));
    const modalPropsRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const modalProps = modalPropsRef.current ?? {
        body: '',
        title: '',
        hasCloseButton: true
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fWlRQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $99o35.AdControlContext).Provider, {
        value: {
            state: state,
            modalPropsRef: modalPropsRef,
            dispatch: dispatch,
            onEvents: onEvents,
            shouldShowDismissFlag: shouldShowDismissFlag
        }
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g8zAQ.default), {
        itemId: state.modalItemId,
        ...modalProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8ghvK.default), null)));
};
var $e3f008f9351f7b1d$export$2e2bcd8739ae039 = $e3f008f9351f7b1d$var$AdControlProvider;
module.exports["default"] = $e3f008f9351f7b1d$export$2e2bcd8739ae039;

});

parcelRegister("99o35", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $figLC = parcelRequire("figLC");

const $487a144e0c1a0dd4$export$554b2f9bd0a293df = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    state: {
        ...(0, $figLC.initialAdControlProviderState)
    },
    modalPropsRef: undefined,
    dispatch: ()=>{},
    onEvents: ()=>{},
    shouldShowDismissFlag: true
});
module.exports["AdControlContext"] = $487a144e0c1a0dd4$export$554b2f9bd0a293df;

});

parcelRegister("figLC", function(module, exports) {
const $b8ded30a3cdc456e$export$22776e7a42f7089d = {
    flags: new Map()
};
const $b8ded30a3cdc456e$export$5f3557676ca801eb = (state, action)=>{
    switch(action.type){
        case 'ADD_FLAG':
            return {
                ...state,
                flags: new Map(state.flags).set(action.payload.itemId, action.payload.flagProps)
            };
        case 'REMOVE_FLAG':
            {
                // Clone the flags map and delete the flag
                const flags = new Map(state.flags);
                flags.delete(action.payload);
                return {
                    ...state,
                    flags: flags
                };
            }
        case 'OPEN_MODAL':
            return {
                ...state,
                modalItemId: action.payload
            };
        case 'CLOSE_MODAL':
            return {
                ...state,
                modalItemId: undefined
            };
        default:
            return state;
    }
};
module.exports["initialAdControlProviderState"] = $b8ded30a3cdc456e$export$22776e7a42f7089d;
module.exports["adControlProviderReducer"] = $b8ded30a3cdc456e$export$5f3557676ca801eb;

});

parcelRegister("fWlRQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $64VTj = parcelRequire("64VTj");


var $dXcdA = parcelRequire("dXcdA");


var $bpnpX = parcelRequire("bpnpX");

const $8abb24b973ab290a$var$ActIntlProvider = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $64VTj.default), {
        defaultMessages: (0, $bpnpX.default),
        loaderFn: (0, $dXcdA.fetchMessagesForLocale)
    }, children);
};
var $8abb24b973ab290a$export$2e2bcd8739ae039 = $8abb24b973ab290a$var$ActIntlProvider;
module.exports["default"] = $8abb24b973ab290a$export$2e2bcd8739ae039;

});

parcelRegister("64VTj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fKN6m = parcelRequire("fKN6m");


var $471nw = parcelRequire("471nw");

const $8ae958986c8c799d$var$IntlMessagesProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IntlMessagesProvider(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { loaderFn: loaderFn, children: children, defaultMessages: defaultMessages } = t0;
    const intl = (0, $471nw.useSafeIntl)();
    const messages = (0, $fKN6m.useMessages)(intl.locale, loaderFn);
    let t1;
    if ($[0] !== defaultMessages || $[1] !== intl.messages || $[2] !== messages) {
        t1 = {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
        $[0] = defaultMessages;
        $[1] = intl.messages;
        $[2] = messages;
        $[3] = t1;
    } else t1 = $[3];
    const mergedMessages = t1;
    let t2;
    if ($[4] !== children || $[5] !== intl.locale || $[6] !== intl.onError || $[7] !== mergedMessages) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            defaultLocale: "en",
            locale: intl.locale,
            onError: intl.onError,
            messages: mergedMessages
        }, children);
        $[4] = children;
        $[5] = intl.locale;
        $[6] = intl.onError;
        $[7] = mergedMessages;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : function IntlMessagesProvider({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $471nw.useSafeIntl)();
    const messages = (0, $fKN6m.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the Intl context (via useSafeIntl) and pass them downstream
   * This prevents the missing messages error.
   */ const mergedMessages = (0, $cozmU.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages
    }, children);
};
var $8ae958986c8c799d$export$2e2bcd8739ae039 = $8ae958986c8c799d$var$IntlMessagesProvider;
module.exports["default"] = $8ae958986c8c799d$export$2e2bcd8739ae039;

});

parcelRegister("fKN6m", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ezgjU = parcelRequire("ezgjU");

const $8781597542fb3a9a$export$4d17e2d9c5348842 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useMessages(locale, loaderFn) {
    const $ = (0, $bDgLe.c)(4);
    const [localeState, setLocaleState] = (0, $cozmU.useState)((0, $ezgjU.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $cozmU.useRef)(localeState.locale);
    let t0;
    let t1;
    if ($[0] !== loaderFn || $[1] !== locale) {
        t0 = ()=>{
            if (locale === loadedLocaleRef.current) return;
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) {
                    loadedLocaleRef.current = locale;
                    setLocaleState({
                        locale: locale,
                        messages: messages ?? {}
                    });
                }
            }, $8781597542fb3a9a$var$_temp);
            return ()=>{
                current = false;
            };
        };
        t1 = [
            loaderFn,
            locale
        ];
        $[0] = loaderFn;
        $[1] = locale;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return localeState.messages;
} : function useMessages(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, $cozmU.useState)((0, $ezgjU.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $cozmU.useRef)(localeState.locale);
    (0, $cozmU.useEffect)(()=>{
        // Skip if we already have messages for this locale
        if (locale === loadedLocaleRef.current) return;
        let current = true;
        loaderFn(locale).then((messages)=>{
            if (current) {
                loadedLocaleRef.current = locale;
                setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            }
        }, (error)=>{
            // Handle or log error appropriately
            console.error('Failed to load i18n messages via intl-messages-provider', error);
        });
        return ()=>{
            current = false;
        };
    }, [
        loaderFn,
        locale
    ]);
    return localeState.messages;
};
function $8781597542fb3a9a$var$_temp(error) {
    console.error("Failed to load i18n messages via intl-messages-provider", error);
}
module.exports["useMessages"] = $8781597542fb3a9a$export$4d17e2d9c5348842;

});

parcelRegister("ezgjU", function(module, exports) {
const $c69670c8f17f7b27$export$79618bef82c02d4c = {
    locale: 'en-US',
    messages: undefined
};
module.exports["DEFAULT_LOCALE_STATE"] = $c69670c8f17f7b27$export$79618bef82c02d4c;

});

parcelRegister("471nw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ezgjU = parcelRequire("ezgjU");

// Prevents memory leaks
const $2a38add47fc8c1ad$var$cache = (0, $kSwu1.createIntlCache)();
const $2a38add47fc8c1ad$export$f752ac21ea3960a5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    const context = (0, $cozmU.useContext)((0, $kSwu1.IntlContext));
    if (!context) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = (0, $kSwu1.createIntl)((0, $ezgjU.DEFAULT_LOCALE_STATE), $2a38add47fc8c1ad$var$cache);
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    return context;
} : ()=>{
    const context = (0, $cozmU.useContext)((0, $kSwu1.IntlContext));
    if (!context) return (0, $kSwu1.createIntl)((0, $ezgjU.DEFAULT_LOCALE_STATE), $2a38add47fc8c1ad$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $2a38add47fc8c1ad$export$f752ac21ea3960a5;

});

parcelRegister("dXcdA", function(module, exports) {

var $deQjJ = parcelRequire("deQjJ");


var $bpnpX = parcelRequire("bpnpX");

const $b5bda805f1b05c7c$var$localeMap = {
    pt: 'pt-BR',
    'pt-PT': 'pt-BR',
    'en-AU': 'en-GB'
};
const $b5bda805f1b05c7c$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const targetLocale = ($b5bda805f1b05c7c$var$localeMap[locale] ?? locale ?? '').replace('-', '_');
        if (targetLocale in (0, $deQjJ.locales)) {
            const messages = await (0, $deQjJ.locales)[targetLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $deQjJ.locales)) {
            const messages = await (0, $deQjJ.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    /**
	 * English bundled by default as this is the majority of users
	 */ return 0, $bpnpX.default;
};
module.exports["fetchMessagesForLocale"] = $b5bda805f1b05c7c$export$2b153a2030b0feb2;

});

parcelRegister("deQjJ", function(module, exports) {


























const $a1d9dc7aeb54fc32$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("fn8fQ")),
    da: ()=>(parcelRequire("dP9dB")),
    de: ()=>(parcelRequire("pqId8")),
    en_GB: ()=>(parcelRequire("lVwW4")),
    en_ZZ: ()=>(parcelRequire("fNBmQ")),
    en: ()=>Promise.resolve((parcelRequire("bpnpX"))),
    es: ()=>(parcelRequire("6RPsb")),
    fi: ()=>(parcelRequire("dtwgC")),
    fr: ()=>(parcelRequire("MQC81")),
    hu: ()=>(parcelRequire("8afli")),
    it: ()=>(parcelRequire("gYVcC")),
    ja: ()=>(parcelRequire("yPBwq")),
    ko: ()=>(parcelRequire("dylKN")),
    nb: ()=>(parcelRequire("dLZIh")),
    nl: ()=>(parcelRequire("8qOKF")),
    pl: ()=>(parcelRequire("jOVAU")),
    pt_BR: ()=>(parcelRequire("dwGKN")),
    ru: ()=>(parcelRequire("kqShj")),
    sv: ()=>(parcelRequire("dF0xW")),
    th: ()=>(parcelRequire("boPTh")),
    tr: ()=>(parcelRequire("ffuQp")),
    uk: ()=>(parcelRequire("cGbbQ")),
    vi: ()=>(parcelRequire("2OAKw")),
    zh_TW: ()=>(parcelRequire("b8VuI")),
    zh: ()=>(parcelRequire("2sri5"))
};
module.exports["locales"] = $a1d9dc7aeb54fc32$export$df1c34db1371eeed;

});

parcelRegister("bpnpX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $2c6f5d5e318d9e82$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $6pdST = parcelRequire("6pdST");

var $2c6f5d5e318d9e82$export$2e2bcd8739ae039 = (0, $6pdST.default);

});

parcelRegister("6pdST", function(module, exports) {
$parcel$export(module.exports, "default", () => $a15bee5793174824$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $a15bee5793174824$export$2e2bcd8739ae039 = {
    'act.action.dismissalMessage.common.text': "You won\u2019t see this here as often.",
    'act.action.notInterested.button.text': 'Not interested',
    'act.action.notInterestedFlag.flag.text': 'Got it, thanks for letting us know',
    'act.action.reasonsModalOkButton.common.text': 'OK',
    'act.action.showReasons.common.text': 'Why am I seeing this?'
};

});

parcelRegister("fn8fQ", function(module, exports) {

let $b30f6829b06dd290$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b30f6829b06dd290$var$load("fqFZd").then(()=>parcelRequire('5uA04'));

});

parcelRegister("dP9dB", function(module, exports) {

let $a107305b1b310e45$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a107305b1b310e45$var$load("aHKyp").then(()=>parcelRequire('lDbPr'));

});

parcelRegister("pqId8", function(module, exports) {

let $04c70e605ca93242$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $04c70e605ca93242$var$load("6wc6E").then(()=>parcelRequire('6fKt8'));

});

parcelRegister("lVwW4", function(module, exports) {

let $ff6878297327410b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ff6878297327410b$var$load("apszh").then(()=>parcelRequire('9k7OG'));

});

parcelRegister("fNBmQ", function(module, exports) {

let $b8086b0a2e886c41$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b8086b0a2e886c41$var$load("fsNHF").then(()=>parcelRequire('Zm0Il'));

});

parcelRegister("6RPsb", function(module, exports) {

let $4fff9ae872d2f5ff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4fff9ae872d2f5ff$var$load("97oR5").then(()=>parcelRequire('EswDV'));

});

parcelRegister("dtwgC", function(module, exports) {

let $9cf7035e39d81eb3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9cf7035e39d81eb3$var$load("4C0M8").then(()=>parcelRequire('bs2mK'));

});

parcelRegister("MQC81", function(module, exports) {

let $092d4bd9482829b6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $092d4bd9482829b6$var$load("kCi2D").then(()=>parcelRequire('4mpll'));

});

parcelRegister("8afli", function(module, exports) {

let $5f1b289d68f9eca9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5f1b289d68f9eca9$var$load("cvq9d").then(()=>parcelRequire('t0llw'));

});

parcelRegister("gYVcC", function(module, exports) {

let $c5ce9f2a19ad96fe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c5ce9f2a19ad96fe$var$load("evjMs").then(()=>parcelRequire('h2Zno'));

});

parcelRegister("yPBwq", function(module, exports) {

let $068b349bc77f791e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $068b349bc77f791e$var$load("i2lQX").then(()=>parcelRequire('3IE6W'));

});

parcelRegister("dylKN", function(module, exports) {

let $9ddf532d14a76448$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9ddf532d14a76448$var$load("1CuUG").then(()=>parcelRequire('iUJN0'));

});

parcelRegister("dLZIh", function(module, exports) {

let $a06f8915f14210a4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a06f8915f14210a4$var$load("3jnaT").then(()=>parcelRequire('PyWp2'));

});

parcelRegister("8qOKF", function(module, exports) {

let $62381eabbd80471b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $62381eabbd80471b$var$load("6QkPn").then(()=>parcelRequire('9rzrU'));

});

parcelRegister("jOVAU", function(module, exports) {

let $e6df5cdef36e5980$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e6df5cdef36e5980$var$load("1ABKB").then(()=>parcelRequire('84tCh'));

});

parcelRegister("dwGKN", function(module, exports) {

let $9d8f6d8488ea9654$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9d8f6d8488ea9654$var$load("fPtg0").then(()=>parcelRequire('g5uGP'));

});

parcelRegister("kqShj", function(module, exports) {

let $ee0056e173a97b94$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ee0056e173a97b94$var$load("3UPyG").then(()=>parcelRequire('l9rkw'));

});

parcelRegister("dF0xW", function(module, exports) {

let $9f1f873abd396d23$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9f1f873abd396d23$var$load("ioDtW").then(()=>parcelRequire('7L975'));

});

parcelRegister("boPTh", function(module, exports) {

let $84ca2ffc1ed35719$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $84ca2ffc1ed35719$var$load("hTj5A").then(()=>parcelRequire('7tGMU'));

});

parcelRegister("ffuQp", function(module, exports) {

let $b1a02ebe7fcb393e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b1a02ebe7fcb393e$var$load("gNYsO").then(()=>parcelRequire('7WCcG'));

});

parcelRegister("cGbbQ", function(module, exports) {

let $93b2166974eff4cf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $93b2166974eff4cf$var$load("dImFZ").then(()=>parcelRequire('g6EGN'));

});

parcelRegister("2OAKw", function(module, exports) {

let $20ccc1f4d7954774$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $20ccc1f4d7954774$var$load("90VPn").then(()=>parcelRequire('24w4T'));

});

parcelRegister("b8VuI", function(module, exports) {

let $81cd0a3f72498208$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $81cd0a3f72498208$var$load("2hMWS").then(()=>parcelRequire('L4bzi'));

});

parcelRegister("2sri5", function(module, exports) {

let $1ca35daaa65b28fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1ca35daaa65b28fc$var$load("bbwgN").then(()=>parcelRequire('Avwk5'));

});

parcelRegister("8ghvK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $a2foB = parcelRequire("a2foB");

var $lqtHz = parcelRequire("lqtHz");


var $iZMIZ = parcelRequire("iZMIZ");


var $iMnC5 = parcelRequire("iMnC5");


var $cat13 = parcelRequire("cat13");


var $fT9w9 = parcelRequire("fT9w9");


var $5TJfk = parcelRequire("5TJfk");


var $5V7NW = parcelRequire("5V7NW");


var $fOZz8 = parcelRequire("fOZz8");

const $08df806fc60de75d$var$ACT_FLAG_WRAPPER = 'act-flag-wrapper';
const $08df806fc60de75d$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'adControlsFlagClose'
};
const $08df806fc60de75d$var$DismissalFlagGroup = ()=>{
    (0, $fOZz8.overridePortalIndex)($08df806fc60de75d$var$ACT_FLAG_WRAPPER);
    const { state: { flags: flags }, createEventDispatcher: createEventDispatcher } = (0, $5TJfk.useAdControlProvider)();
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $fT9w9.default)();
    const handleOnDismissed = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((id)=>{
        createEventDispatcher(id).dispatch((0, $cat13.FLAG_DISMISSED), createInteractedUIEvent($08df806fc60de75d$var$interactedUIEventAction));
    }, [
        createEventDispatcher,
        createInteractedUIEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lqtHz.default), {
        onDismissed: handleOnDismissed
    }, Array.from(flags.entries()).map(([itemId, { actions: actions = [], ...flagProps } = {
        actions: []
    }], i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            key: i,
            id: $08df806fc60de75d$var$ACT_FLAG_WRAPPER
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a2foB.default), {
            id: itemId,
            testId: `act-flag-${itemId}`,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iZMIZ))), {
                label: "Success",
                spacing: "spacious",
                color: "var(--ds-icon-success, #6A9A23)"
            }),
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5V7NW.messages).notInterestedFlag),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5V7NW.messages).dismissalMessage),
            ...flagProps,
            actions: actions.map((action)=>({
                    ...action,
                    onClick: (e)=>{
                        action.onClick?.(e, ()=>handleOnDismissed(itemId));
                    }
                }))
        }))));
};
var $08df806fc60de75d$export$2e2bcd8739ae039 = $08df806fc60de75d$var$DismissalFlagGroup;
module.exports["default"] = $08df806fc60de75d$export$2e2bcd8739ae039;

});

parcelRegister("cat13", function(module, exports) {
// ACT Event types
// AdControlDropdownMenu
const $4b9db30241704045$export$17ff257e1f6e39f5 = 'AD_CONTROL_DROP_DOWN_MENU_OPENED';
const $4b9db30241704045$export$7fc09cf740f33ed4 = 'AD_CONTROL_DROP_DOWN_MENU_CLOSED';
const $4b9db30241704045$export$e33200507ac1d20a = 'DISMISS_STARTED';
const $4b9db30241704045$export$103f41d1f3bf374e = 'DISMISS_SUCCEEDED';
const $4b9db30241704045$export$6d3088110036f124 = 'DISMISS_FAILED';
const $4b9db30241704045$export$5595c6967e83d351 = 'REASONS_BUTTON_CLICKED';
const $4b9db30241704045$export$ff50ad60f08a4bc0 = 'REASONS_MODAL_SHOWN';
const $4b9db30241704045$export$6bd2d8eacca15ce1 = 'REASONS_MODAL_DISMISSED';
const $4b9db30241704045$export$5c5fc6956b7600ea = 'FLAG_DISMISSED';
module.exports["AD_CONTROL_DROP_DOWN_MENU_OPENED"] = $4b9db30241704045$export$17ff257e1f6e39f5;
module.exports["AD_CONTROL_DROP_DOWN_MENU_CLOSED"] = $4b9db30241704045$export$7fc09cf740f33ed4;
module.exports["DISMISS_STARTED"] = $4b9db30241704045$export$e33200507ac1d20a;
module.exports["DISMISS_SUCCEEDED"] = $4b9db30241704045$export$103f41d1f3bf374e;
module.exports["DISMISS_FAILED"] = $4b9db30241704045$export$6d3088110036f124;
module.exports["REASONS_BUTTON_CLICKED"] = $4b9db30241704045$export$5595c6967e83d351;
module.exports["REASONS_MODAL_SHOWN"] = $4b9db30241704045$export$ff50ad60f08a4bc0;
module.exports["REASONS_MODAL_DISMISSED"] = $4b9db30241704045$export$6bd2d8eacca15ce1;
module.exports["FLAG_DISMISSED"] = $4b9db30241704045$export$5c5fc6956b7600ea;

});

parcelRegister("fT9w9", function(module, exports) {
$parcel$export(module.exports, "default", () => $07b6eadceb869d68$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $852mP = parcelRequire("852mP");


var $9DHhW = parcelRequire("9DHhW");

function $07b6eadceb869d68$export$2e2bcd8739ae039() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const createInteractedUIEvent = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((action)=>createAnalyticsEvent({
            eventType: (0, $852mP.UI_EVENT_TYPE),
            ...action
        }), [
        createAnalyticsEvent
    ]);
    const createScreenUIEvent = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((name)=>createAnalyticsEvent({
            eventType: (0, $852mP.SCREEN_EVENT_TYPE),
            name: name
        }), [
        createAnalyticsEvent
    ]);
    return {
        createInteractedUIEvent: createInteractedUIEvent,
        createScreenUIEvent: createScreenUIEvent
    };
}

});

parcelRegister("5TJfk", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cat13 = parcelRequire("cat13");


var $fBOC0 = parcelRequire("fBOC0");


var $j4rrt = parcelRequire("j4rrt");

function $20cfee0c39b41377$export$450072b04d50916() {
    const { state: state, modalPropsRef: modalPropsRef, dispatch: dispatch, onEvents: onEvents, shouldShowDismissFlag: shouldShowDismissFlag } = (0, $j4rrt.useAdControlContext)();
    /**
	 * Add a flag with flagProps to state for the item was dismissed
	 * {@link https://atlassian.design/components/flag/examples}
	 */ const addFlag = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((itemId, flagProps)=>{
        dispatch({
            type: 'ADD_FLAG',
            payload: {
                itemId: itemId,
                flagProps: flagProps
            }
        });
    }, [
        dispatch
    ]);
    /**
	 * Open a modal and set the modal props reference
	 */ const openModal = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((modalProps, modalItemId)=>{
        modalPropsRef.current = modalProps;
        dispatch({
            type: 'OPEN_MODAL',
            payload: modalItemId
        });
    }, [
        dispatch,
        modalPropsRef
    ]);
    /**
	 * Close a modal and clear the modal props reference
	 */ const closeModal = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        modalPropsRef.current = undefined;
        dispatch({
            type: 'CLOSE_MODAL'
        });
    }, [
        dispatch,
        modalPropsRef
    ]);
    /**
	 * The internal event handler that is used by the ACTEventDispatcher
	 */ const handleOnEvents = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((event)=>{
        // Handle the events that have side effects on the state.
        switch(event.type){
            case 0, $cat13.FLAG_DISMISSED:
                dispatch({
                    type: 'REMOVE_FLAG',
                    payload: event.itemId
                });
                break;
        }
        // Call the onEvents handler that is passed from the consumer.
        onEvents(event);
    }, [
        dispatch,
        onEvents
    ]);
    /**
	 * Create an event dispatcher for the given item id
	 */ const createEventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((itemId)=>{
        return new (0, $fBOC0.default)(itemId, handleOnEvents);
    }, [
        handleOnEvents
    ]);
    return {
        state: state,
        openModal: openModal,
        closeModal: closeModal,
        createEventDispatcher: createEventDispatcher,
        addFlag: addFlag,
        shouldShowDismissFlag: shouldShowDismissFlag
    };
}
module.exports["useAdControlProvider"] = $20cfee0c39b41377$export$450072b04d50916;

});

parcelRegister("fBOC0", function(module, exports) {
class $f4e9aa69336aea97$export$2e2bcd8739ae039 {
    dispatch(type, analyticsEvent) {
        this._dispatch({
            type: type,
            itemId: this.itemId,
            analyticsEvent: analyticsEvent
        });
    }
    dispatchError(type, error) {
        this._dispatch({
            type: type,
            itemId: this.itemId,
            error: error
        });
    }
    _dispatch(event) {
        if (this.handler) this.handler(event);
    }
    constructor(itemId, handler){
        this.itemId = itemId;
        this.handler = handler;
    }
}
module.exports["default"] = $f4e9aa69336aea97$export$2e2bcd8739ae039;

});

parcelRegister("j4rrt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $99o35 = parcelRequire("99o35");

function $cf0c69620042a840$export$4e82dc865a56141b() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $99o35.AdControlContext));
}
module.exports["useAdControlContext"] = $cf0c69620042a840$export$4e82dc865a56141b;

});

parcelRegister("5V7NW", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $bf3868040c8762ae$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    notInterested: {
        id: "act.action.notInterested.button.text",
        defaultMessage: "Not interested"
    },
    notInterestedFlag: {
        id: "act.action.notInterestedFlag.flag.text",
        defaultMessage: "Got it, thanks for letting us know"
    },
    showReasons: {
        id: "act.action.showReasons.common.text",
        defaultMessage: "Why am I seeing this?"
    },
    dismissalMessage: {
        id: "act.action.dismissalMessage.common.text",
        defaultMessage: "You won\u2019t see this here as often."
    },
    reasonsModalOkButton: {
        id: "act.action.reasonsModalOkButton.common.text",
        defaultMessage: "OK"
    }
});
module.exports["messages"] = $bf3868040c8762ae$export$defe85febe8b728c;

});

parcelRegister("fOZz8", function(module, exports) {
const $1ecbeb39909835ce$export$335243096683aa37 = 900;
function $1ecbeb39909835ce$export$61df98316049b30(elementId, index = $1ecbeb39909835ce$export$335243096683aa37) {
    setTimeout(()=>{
        if (typeof document !== 'undefined') {
            const parentPortal = $1ecbeb39909835ce$export$148feac3be949786(document.getElementById(elementId), '.atlaskit-portal');
            if (parentPortal) parentPortal.setAttribute('style', `z-index:${index};`);
        }
    }, 0);
}
function $1ecbeb39909835ce$var$collectionHas(all, curr) {
    for(let i = 0, len = all.length; i < len; i++){
        if (all[i] === curr) return true;
    }
    return false;
}
function $1ecbeb39909835ce$export$148feac3be949786(elm, selector) {
    let all = document.querySelectorAll(selector);
    let cur = elm?.parentNode;
    while(cur && !$1ecbeb39909835ce$var$collectionHas(all, cur))cur = cur.parentNode;
    return cur;
}
module.exports["DEFAULT_PORTAL_OVERRIDE_INDEX"] = $1ecbeb39909835ce$export$335243096683aa37;
module.exports["overridePortalIndex"] = $1ecbeb39909835ce$export$61df98316049b30;

});

parcelRegister("g8zAQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $7aRdF = parcelRequire("7aRdF");

var $fEPJS = parcelRequire("fEPJS");

var $eQiT1 = parcelRequire("eQiT1");

var $9Umtx = parcelRequire("9Umtx");

var $jq995 = parcelRequire("jq995");

var $aRGok = parcelRequire("aRGok");


var $iMnC5 = parcelRequire("iMnC5");


var $cat13 = parcelRequire("cat13");


var $fT9w9 = parcelRequire("fT9w9");


var $5TJfk = parcelRequire("5TJfk");


var $5V7NW = parcelRequire("5V7NW");


var $fOZz8 = parcelRequire("fOZz8");

const $17285365cea0a3c8$var$adControlScreenName = 'adControlsReasonsModal';
const $17285365cea0a3c8$var$ACT_MODAL_CONTENT = 'ACT_MODAL_CONTENT';
const $17285365cea0a3c8$var$ReasonsModal = ({ body: body, itemId: itemId, title: title, zIndexOverride: zIndexOverride = (0, $fOZz8.DEFAULT_PORTAL_OVERRIDE_INDEX), hasCloseButton: hasCloseButton = true, ...props })=>{
    const { closeModal: closeModal, createEventDispatcher: createEventDispatcher } = (0, $5TJfk.useAdControlProvider)();
    const { createScreenUIEvent: createScreenUIEvent } = (0, $fT9w9.default)();
    const isMounted = (0, $cozmU.useRef)(false);
    const eventDispatcherRef = (0, $cozmU.useRef)();
    eventDispatcherRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>itemId !== undefined ? createEventDispatcher(itemId) : eventDispatcherRef.current, [
        createEventDispatcher,
        itemId
    ]);
    const isOpen = itemId !== undefined;
    (0, $cozmU.useEffect)(()=>{
        const eventDispatcher = eventDispatcherRef.current;
        if (!eventDispatcher) return;
        if (isOpen) eventDispatcher.dispatch((0, $cat13.REASONS_MODAL_SHOWN), createScreenUIEvent($17285365cea0a3c8$var$adControlScreenName));
        else if (isMounted.current && !isOpen) eventDispatcher.dispatch((0, $cat13.REASONS_MODAL_DISMISSED), createScreenUIEvent($17285365cea0a3c8$var$adControlScreenName));
    }, [
        createScreenUIEvent,
        isOpen
    ]);
    (0, $cozmU.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
    if (isOpen && zIndexOverride) (0, $fOZz8.overridePortalIndex)($17285365cea0a3c8$var$ACT_MODAL_CONTENT, zIndexOverride);
    // DO NOT MODIFY CODE BLOCK - temp fix for z-index issue in confluence
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        shouldCloseOnEscapePress: true,
        onClose: closeModal,
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        id: $17285365cea0a3c8$var$ACT_MODAL_CONTENT
    }, title !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: hasCloseButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, title ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5V7NW.messages).showReasons))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, body), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: closeModal,
        autoFocus: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5V7NW.messages).reasonsModalOkButton))))));
};
var $17285365cea0a3c8$export$2e2bcd8739ae039 = $17285365cea0a3c8$var$ReasonsModal;
module.exports["default"] = $17285365cea0a3c8$export$2e2bcd8739ae039;

});

parcelRegister("ccwbz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3vgx3 = parcelRequire("3vgx3");

var $9erVg = parcelRequire("9erVg");


var $cat13 = parcelRequire("cat13");


var $fT9w9 = parcelRequire("fT9w9");


var $5TJfk = parcelRequire("5TJfk");

const $fc4e37d87367c721$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'adControlsDropdown'
};
const $fc4e37d87367c721$var$AdControlDropdownMenu = ({ children: children, itemId: itemId, onOpenChange: onOpenChange = ()=>{}, ...rest })=>{
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $fT9w9.default)();
    const { createEventDispatcher: createEventDispatcher } = (0, $5TJfk.useAdControlProvider)();
    const eventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>createEventDispatcher(itemId), [
        createEventDispatcher,
        itemId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        ...rest,
        onOpenChange: (onOpenChangeArgs)=>{
            eventDispatcher.dispatch(onOpenChangeArgs.isOpen ? (0, $cat13.AD_CONTROL_DROP_DOWN_MENU_OPENED) : (0, $cat13.AD_CONTROL_DROP_DOWN_MENU_CLOSED), createInteractedUIEvent($fc4e37d87367c721$var$interactedUIEventAction));
            onOpenChange(onOpenChangeArgs);
        },
        shouldFitContainer: false,
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, typeof children === 'function' ? children({
        itemId: itemId
    }) : children));
};
var $fc4e37d87367c721$export$2e2bcd8739ae039 = $fc4e37d87367c721$var$AdControlDropdownMenu;
module.exports["default"] = $fc4e37d87367c721$export$2e2bcd8739ae039;

});

parcelRegister("bZygI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $is1T6 = parcelRequire("is1T6");


var $cat13 = parcelRequire("cat13");


var $fT9w9 = parcelRequire("fT9w9");


var $5TJfk = parcelRequire("5TJfk");


var $5V7NW = parcelRequire("5V7NW");

const $c6122f8ce82af84f$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'notInterested'
};
const $c6122f8ce82af84f$var$DismissalButton = ({ itemId: itemId, onClick: onClick, children: children, flagProps: flagProps, ...props })=>{
    const { addFlag: addFlag, createEventDispatcher: createEventDispatcher, shouldShowDismissFlag: shouldShowDismissFlag } = (0, $5TJfk.useAdControlProvider)();
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $fT9w9.default)();
    const eventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>createEventDispatcher(itemId), [
        createEventDispatcher,
        itemId
    ]);
    const handleOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(async (e)=>{
        eventDispatcher.dispatch((0, $cat13.DISMISS_STARTED), createInteractedUIEvent($c6122f8ce82af84f$var$interactedUIEventAction));
        shouldShowDismissFlag && addFlag(itemId, flagProps);
        try {
            await onClick?.(e, itemId);
            eventDispatcher.dispatch((0, $cat13.DISMISS_SUCCEEDED));
        } catch (e) {
            eventDispatcher.dispatchError((0, $cat13.DISMISS_FAILED), e);
        }
    }, [
        addFlag,
        createInteractedUIEvent,
        eventDispatcher,
        flagProps,
        itemId,
        onClick,
        shouldShowDismissFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        onClick: handleOnClick,
        ...props
    }, children ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5V7NW.messages).notInterested));
};
var $c6122f8ce82af84f$export$2e2bcd8739ae039 = $c6122f8ce82af84f$var$DismissalButton;
module.exports["default"] = $c6122f8ce82af84f$export$2e2bcd8739ae039;

});

parcelRegister("9C8xw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $is1T6 = parcelRequire("is1T6");


var $cat13 = parcelRequire("cat13");


var $fT9w9 = parcelRequire("fT9w9");


var $5TJfk = parcelRequire("5TJfk");


var $5V7NW = parcelRequire("5V7NW");

const $64fb2acc65b83f8a$var$interactedUIEventAction = {
    action: 'clicked',
    actionSubject: 'button',
    actionSubjectId: 'adControlsReasons'
};
const $64fb2acc65b83f8a$var$ReasonsButton = ({ children: children, itemId: itemId, modalProps: modalProps, onClick: onClick, ...props })=>{
    const { createEventDispatcher: createEventDispatcher, openModal: openModal } = (0, $5TJfk.useAdControlProvider)();
    const { createInteractedUIEvent: createInteractedUIEvent } = (0, $fT9w9.default)();
    const eventDispatcher = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>createEventDispatcher(itemId), [
        createEventDispatcher,
        itemId
    ]);
    const handleOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((e)=>{
        eventDispatcher.dispatch((0, $cat13.REASONS_BUTTON_CLICKED), createInteractedUIEvent($64fb2acc65b83f8a$var$interactedUIEventAction));
        openModal(modalProps, itemId);
        onClick?.(e, itemId);
    }, [
        createInteractedUIEvent,
        eventDispatcher,
        itemId,
        modalProps,
        onClick,
        openModal
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        onClick: handleOnClick,
        ...props
    }, children ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5V7NW.messages).showReasons));
};
var $64fb2acc65b83f8a$export$2e2bcd8739ae039 = $64fb2acc65b83f8a$var$ReasonsButton;
module.exports["default"] = $64fb2acc65b83f8a$export$2e2bcd8739ae039;

});

parcelRegister("5TQHv", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6TaGl = parcelRequire("6TaGl");


var $hBYtq = parcelRequire("hBYtq");

const $743ae054c57a0d09$var$styles = {
    root: "_2rko12b0 _1rjc12x7 _syaz15cr _bfhk1aqn _irr31ibz _1di6of27"
};
const $743ae054c57a0d09$export$b97a88aea1fe9a05 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(5);
    const { onClick: onClick, testId: testId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
            label: "Show more"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== onClick || $[2] !== ref || $[3] !== testId) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.default), {
            xcss: $743ae054c57a0d09$var$styles.root,
            onClick: onClick,
            ref: ref,
            testId: testId
        }, t1);
        $[1] = onClick;
        $[2] = ref;
        $[3] = testId;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ onClick: onClick, testId: testId }, ref)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.default), {
        xcss: $743ae054c57a0d09$var$styles.root,
        onClick: onClick,
        ref: ref,
        testId: testId
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
        label: "Show more"
    }));
});
module.exports["SpotlightShowMoreControl"] = $743ae054c57a0d09$export$b97a88aea1fe9a05;

});

parcelRegister("5i3ci", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gWLTH = parcelRequire("gWLTH");


var $9wGTI = parcelRequire("9wGTI");


var $aFmsO = parcelRequire("aFmsO");


var $8jXZv = parcelRequire("8jXZv");


var $9Zall = parcelRequire("9Zall");

const $9fbe62170cacfcf3$export$d6e697640576fe29 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, entryPointId: entryPointId, isCircle: isCircle } = t0;
    const { isPulseActive: isPulseActive } = (0, $aFmsO.useDiscoverabilityPulse)(entryPointId);
    if (!isPulseActive) return children;
    if ((0, $9wGTI.fg)("confluence_frontend_spotlight_ads_migration")) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, children));
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    const t1 = isCircle ? 24 : 3;
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWLTH.Pulse), {
            radius: t1,
            testId: "loom-cross-sell-discoverability-pulse"
        }, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ children: children, entryPointId: entryPointId, isCircle: isCircle })=>{
    const { isPulseActive: isPulseActive } = (0, $aFmsO.useDiscoverabilityPulse)(entryPointId);
    if (!isPulseActive) return children;
    // Feature-gated migration from @atlaskit/onboarding to @atlaskit/spotlight
    if ((0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWLTH.Pulse), {
        radius: isCircle ? 24 : 3,
        testId: "loom-cross-sell-discoverability-pulse"
    }, children);
};
module.exports["DiscoverabilityPulse"] = $9fbe62170cacfcf3$export$d6e697640576fe29;

});

parcelRegister("aFmsO", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6m3nS = parcelRequire("6m3nS");


var $gd8AW = parcelRequire("gd8AW");

const $9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS = [
    'cc-loom-x-sell-discoverability-pulse-1',
    'cc-loom-x-sell-discoverability-pulse-2',
    'cc-loom-x-sell-discoverability-pulse-3',
    'cc-loom-x-sell-discoverability-pulse-4',
    'cc-loom-x-sell-discoverability-pulse-5'
];
const $9c43e73b872d5b9c$var$TIMEOUT_MS = 300;
const $9c43e73b872d5b9c$var$LAST_PULSE_INDEX = $9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS.length - 1;
const $9c43e73b872d5b9c$var$requestNextPulse = (nextIndex, pulseHooks, hasRequestedRef, lastRequestedRef)=>{
    if (nextIndex < pulseHooks.length && !hasRequestedRef.current.has(nextIndex)) {
        hasRequestedRef.current.add(nextIndex);
        lastRequestedRef.current = {
            index: nextIndex,
            timestamp: Date.now()
        };
        pulseHooks[nextIndex].requestMessageStart();
    }
};
const $9c43e73b872d5b9c$export$2002ab0670152c89 = (0, $3u0dr.isReactCompilerActiveV2)() ? (entryPointId)=>{
    const $ = (0, $bDgLe.c)(74);
    const isPulseActive = (0, $gd8AW.useIsPulseActive)(entryPointId);
    const { startPulse: startPulse } = (0, $gd8AW.useDiscoverabilityPulseActions)();
    let t0;
    if ($[0] !== isPulseActive) {
        t0 = isPulseActive && (0, $gd8AW.havePulsesEnded)();
        $[0] = isPulseActive;
        $[1] = t0;
    } else t0 = $[1];
    const skipRefreshPulseStatus = t0;
    const pulse1 = (0, $6m3nS.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[0]);
    const pulse2 = (0, $6m3nS.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[1]);
    const pulse3 = (0, $6m3nS.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[2]);
    const pulse4 = (0, $6m3nS.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[3]);
    const pulse5 = (0, $6m3nS.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[4]);
    let t1;
    if ($[2] !== pulse1 || $[3] !== pulse2 || $[4] !== pulse3 || $[5] !== pulse4 || $[6] !== pulse5) {
        t1 = [
            pulse1,
            pulse2,
            pulse3,
            pulse4,
            pulse5
        ];
        $[2] = pulse1;
        $[3] = pulse2;
        $[4] = pulse3;
        $[5] = pulse4;
        $[6] = pulse5;
        $[7] = t1;
    } else t1 = $[7];
    const pulseHooks = t1;
    let t2;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = new Set();
        $[8] = t2;
    } else t2 = $[8];
    const hasRequestedRef = (0, $cozmU.useRef)(t2);
    const lastRequestedRef = (0, $cozmU.useRef)(null);
    const lastStartedIndexRef = (0, $cozmU.useRef)(null);
    const [timeoutTrigger, setTimeoutTrigger] = (0, $cozmU.useState)(0);
    let t3;
    if ($[9] !== pulseHooks || $[10] !== skipRefreshPulseStatus) {
        t3 = ()=>{
            if (skipRefreshPulseStatus) return;
            for(let i = 0; i < pulseHooks.length; i++){
                const pulseHook = pulseHooks[i];
                if (pulseHook.hasMessageStarted) {
                    lastRequestedRef.current = null;
                    lastStartedIndexRef.current = i;
                    break;
                }
                if (!hasRequestedRef.current.has(i)) {
                    hasRequestedRef.current.add(i);
                    lastRequestedRef.current = {
                        index: i,
                        timestamp: Date.now()
                    };
                    pulseHook.requestMessageStart();
                    break;
                }
            }
        };
        $[9] = pulseHooks;
        $[10] = skipRefreshPulseStatus;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== pulse1.handleClickTracking || $[13] !== pulse1.hasMessageStarted || $[14] !== pulse1.requestMessageStart || $[15] !== pulse2.handleClickTracking || $[16] !== pulse2.hasMessageStarted || $[17] !== pulse2.requestMessageStart || $[18] !== pulse3.handleClickTracking || $[19] !== pulse3.hasMessageStarted || $[20] !== pulse3.requestMessageStart || $[21] !== pulse4.handleClickTracking || $[22] !== pulse4.hasMessageStarted || $[23] !== pulse4.requestMessageStart || $[24] !== pulse5.handleClickTracking || $[25] !== pulse5.hasMessageStarted || $[26] !== pulse5.requestMessageStart || $[27] !== pulseHooks || $[28] !== skipRefreshPulseStatus) {
        t4 = [
            skipRefreshPulseStatus,
            pulseHooks,
            pulse1.hasMessageStarted,
            pulse2.hasMessageStarted,
            pulse3.hasMessageStarted,
            pulse4.hasMessageStarted,
            pulse5.hasMessageStarted,
            pulse1.requestMessageStart,
            pulse2.requestMessageStart,
            pulse3.requestMessageStart,
            pulse4.requestMessageStart,
            pulse5.requestMessageStart,
            pulse1.handleClickTracking,
            pulse2.handleClickTracking,
            pulse3.handleClickTracking,
            pulse4.handleClickTracking,
            pulse5.handleClickTracking
        ];
        $[12] = pulse1.handleClickTracking;
        $[13] = pulse1.hasMessageStarted;
        $[14] = pulse1.requestMessageStart;
        $[15] = pulse2.handleClickTracking;
        $[16] = pulse2.hasMessageStarted;
        $[17] = pulse2.requestMessageStart;
        $[18] = pulse3.handleClickTracking;
        $[19] = pulse3.hasMessageStarted;
        $[20] = pulse3.requestMessageStart;
        $[21] = pulse4.handleClickTracking;
        $[22] = pulse4.hasMessageStarted;
        $[23] = pulse4.requestMessageStart;
        $[24] = pulse5.handleClickTracking;
        $[25] = pulse5.hasMessageStarted;
        $[26] = pulse5.requestMessageStart;
        $[27] = pulseHooks;
        $[28] = skipRefreshPulseStatus;
        $[29] = t4;
    } else t4 = $[29];
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[30] !== isPulseActive || $[31] !== pulseHooks || $[32] !== skipRefreshPulseStatus) {
        t5 = ()=>{
            if (skipRefreshPulseStatus || !lastRequestedRef.current || isPulseActive) return;
            const { index: index, timestamp: timestamp } = lastRequestedRef.current;
            const pulseHook_0 = pulseHooks[index];
            if (pulseHook_0.hasMessageStarted) {
                lastRequestedRef.current = null;
                return;
            }
            const elapsed = Date.now() - timestamp;
            if (elapsed >= $9c43e73b872d5b9c$var$TIMEOUT_MS) {
                lastRequestedRef.current = null;
                $9c43e73b872d5b9c$var$requestNextPulse(index + 1, pulseHooks, hasRequestedRef, lastRequestedRef);
            } else {
                const remainingTime = $9c43e73b872d5b9c$var$TIMEOUT_MS - elapsed;
                const timeoutId = setTimeout(()=>{
                    setTimeoutTrigger($9c43e73b872d5b9c$var$_temp);
                }, remainingTime);
                return ()=>clearTimeout(timeoutId);
            }
        };
        $[30] = isPulseActive;
        $[31] = pulseHooks;
        $[32] = skipRefreshPulseStatus;
        $[33] = t5;
    } else t5 = $[33];
    let t6;
    if ($[34] !== isPulseActive || $[35] !== pulse1.hasMessageStarted || $[36] !== pulse2.hasMessageStarted || $[37] !== pulse3.hasMessageStarted || $[38] !== pulse4.hasMessageStarted || $[39] !== pulse5.hasMessageStarted || $[40] !== pulseHooks || $[41] !== skipRefreshPulseStatus || $[42] !== timeoutTrigger) {
        t6 = [
            skipRefreshPulseStatus,
            isPulseActive,
            timeoutTrigger,
            pulseHooks,
            pulse1.hasMessageStarted,
            pulse2.hasMessageStarted,
            pulse3.hasMessageStarted,
            pulse4.hasMessageStarted,
            pulse5.hasMessageStarted
        ];
        $[34] = isPulseActive;
        $[35] = pulse1.hasMessageStarted;
        $[36] = pulse2.hasMessageStarted;
        $[37] = pulse3.hasMessageStarted;
        $[38] = pulse4.hasMessageStarted;
        $[39] = pulse5.hasMessageStarted;
        $[40] = pulseHooks;
        $[41] = skipRefreshPulseStatus;
        $[42] = timeoutTrigger;
        $[43] = t6;
    } else t6 = $[43];
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[44] !== entryPointId || $[45] !== pulseHooks || $[46] !== skipRefreshPulseStatus || $[47] !== startPulse) {
        t7 = ()=>{
            if (skipRefreshPulseStatus) return;
            for(let i_0 = 0; i_0 < pulseHooks.length; i_0++){
                const pulseHook_1 = pulseHooks[i_0];
                const messageId = $9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[i_0];
                if (pulseHook_1.hasMessageStarted) {
                    lastStartedIndexRef.current = i_0;
                    startPulse(entryPointId, messageId, {
                        onDismiss: ()=>pulseHook_1.dismissMessage(),
                        onClick: ()=>pulseHook_1.handleClickTracking?.()
                    });
                    if (i_0 === $9c43e73b872d5b9c$var$LAST_PULSE_INDEX) (0, $gd8AW.endPulses)();
                    break;
                }
            }
        };
        $[44] = entryPointId;
        $[45] = pulseHooks;
        $[46] = skipRefreshPulseStatus;
        $[47] = startPulse;
        $[48] = t7;
    } else t7 = $[48];
    let t8;
    if ($[49] !== entryPointId || $[50] !== pulse1.hasMessageStarted || $[51] !== pulse2.hasMessageStarted || $[52] !== pulse3.hasMessageStarted || $[53] !== pulse4.hasMessageStarted || $[54] !== pulse5.hasMessageStarted || $[55] !== pulseHooks || $[56] !== skipRefreshPulseStatus || $[57] !== startPulse) {
        t8 = [
            skipRefreshPulseStatus,
            entryPointId,
            startPulse,
            pulseHooks,
            pulse1.hasMessageStarted,
            pulse2.hasMessageStarted,
            pulse3.hasMessageStarted,
            pulse4.hasMessageStarted,
            pulse5.hasMessageStarted
        ];
        $[49] = entryPointId;
        $[50] = pulse1.hasMessageStarted;
        $[51] = pulse2.hasMessageStarted;
        $[52] = pulse3.hasMessageStarted;
        $[53] = pulse4.hasMessageStarted;
        $[54] = pulse5.hasMessageStarted;
        $[55] = pulseHooks;
        $[56] = skipRefreshPulseStatus;
        $[57] = startPulse;
        $[58] = t8;
    } else t8 = $[58];
    (0, $cozmU.useEffect)(t7, t8);
    let t9;
    if ($[59] !== isPulseActive || $[60] !== pulseHooks || $[61] !== skipRefreshPulseStatus) {
        t9 = ()=>{
            if (skipRefreshPulseStatus || lastStartedIndexRef.current === null || isPulseActive) return;
            const startedIndex = lastStartedIndexRef.current;
            const startedPulseHook = pulseHooks[startedIndex];
            if (!startedPulseHook.hasMessageStarted) {
                hasRequestedRef.current.delete(startedIndex);
                lastStartedIndexRef.current = null;
                $9c43e73b872d5b9c$var$requestNextPulse(startedIndex + 1, pulseHooks, hasRequestedRef, lastRequestedRef);
            }
        };
        $[59] = isPulseActive;
        $[60] = pulseHooks;
        $[61] = skipRefreshPulseStatus;
        $[62] = t9;
    } else t9 = $[62];
    let t10;
    if ($[63] !== isPulseActive || $[64] !== pulse1.hasMessageStarted || $[65] !== pulse2.hasMessageStarted || $[66] !== pulse3.hasMessageStarted || $[67] !== pulse4.hasMessageStarted || $[68] !== pulse5.hasMessageStarted || $[69] !== pulseHooks || $[70] !== skipRefreshPulseStatus) {
        t10 = [
            skipRefreshPulseStatus,
            isPulseActive,
            pulseHooks,
            pulse1.hasMessageStarted,
            pulse2.hasMessageStarted,
            pulse3.hasMessageStarted,
            pulse4.hasMessageStarted,
            pulse5.hasMessageStarted
        ];
        $[63] = isPulseActive;
        $[64] = pulse1.hasMessageStarted;
        $[65] = pulse2.hasMessageStarted;
        $[66] = pulse3.hasMessageStarted;
        $[67] = pulse4.hasMessageStarted;
        $[68] = pulse5.hasMessageStarted;
        $[69] = pulseHooks;
        $[70] = skipRefreshPulseStatus;
        $[71] = t10;
    } else t10 = $[71];
    (0, $cozmU.useEffect)(t9, t10);
    let t11;
    if ($[72] !== isPulseActive) {
        t11 = {
            isPulseActive: isPulseActive
        };
        $[72] = isPulseActive;
        $[73] = t11;
    } else t11 = $[73];
    return t11;
} : (entryPointId)=>{
    // All hooks must be called unconditionally (Rules of Hooks)
    const isPulseActive = (0, $gd8AW.useIsPulseActive)(entryPointId);
    const { startPulse: startPulse } = (0, $gd8AW.useDiscoverabilityPulseActions)();
    const skipRefreshPulseStatus = isPulseActive && (0, $gd8AW.havePulsesEnded)();
    // Call hooks at the top level for all message IDs
    const pulse1 = (0, $6m3nS.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[0]);
    const pulse2 = (0, $6m3nS.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[1]);
    const pulse3 = (0, $6m3nS.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[2]);
    const pulse4 = (0, $6m3nS.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[3]);
    const pulse5 = (0, $6m3nS.usePostOfficeExernalMessageProxy)($9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[4]);
    const pulseHooks = (0, $cozmU.useMemo)(()=>[
            pulse1,
            pulse2,
            pulse3,
            pulse4,
            pulse5
        ], [
        pulse1,
        pulse2,
        pulse3,
        pulse4,
        pulse5
    ]);
    // Track which messages we've requested to avoid duplicate requests
    const hasRequestedRef = (0, $cozmU.useRef)(new Set());
    // Track the last requested message index and when it was requested (for timeout)
    const lastRequestedRef = (0, $cozmU.useRef)(null);
    // Track which message index was last started (to detect dismissal)
    const lastStartedIndexRef = (0, $cozmU.useRef)(null);
    // State trigger to force re-evaluation when timeout expires
    const [timeoutTrigger, setTimeoutTrigger] = (0, $cozmU.useState)(0);
    // Request messages sequentially - only request the next one if previous ones haven't started
    (0, $cozmU.useEffect)(()=>{
        if (skipRefreshPulseStatus) return;
        // Find the first message that hasn't started and request it
        // If a previous message has started, we stop (handled by the other effect)
        for(let i = 0; i < pulseHooks.length; i++){
            const pulseHook = pulseHooks[i];
            // If this message has started, we're done - don't request any more
            if (pulseHook.hasMessageStarted) {
                // Clear the timeout tracking since we found an active message
                lastRequestedRef.current = null;
                // Track which message is started (will be set by the activation effect, but set here too for consistency)
                lastStartedIndexRef.current = i;
                break;
            }
            // If we haven't requested this one yet, request it and stop
            // The effect will re-run when hasMessageStarted changes, allowing us to move to the next one
            if (!hasRequestedRef.current.has(i)) {
                hasRequestedRef.current.add(i);
                lastRequestedRef.current = {
                    index: i,
                    timestamp: Date.now()
                };
                pulseHook.requestMessageStart();
                break;
            }
        }
    }, [
        skipRefreshPulseStatus,
        pulseHooks,
        pulse1.hasMessageStarted,
        pulse2.hasMessageStarted,
        pulse3.hasMessageStarted,
        pulse4.hasMessageStarted,
        pulse5.hasMessageStarted,
        pulse1.requestMessageStart,
        pulse2.requestMessageStart,
        pulse3.requestMessageStart,
        pulse4.requestMessageStart,
        pulse5.requestMessageStart,
        pulse1.handleClickTracking,
        pulse2.handleClickTracking,
        pulse3.handleClickTracking,
        pulse4.handleClickTracking,
        pulse5.handleClickTracking
    ]);
    // Timeout handler: if a requested message hasn't started after a delay, try the next one
    // Note: If a message was already dismissed, Post Office filters it before page load
    // so we only need time for the initial load and state updates (~200-300ms)
    (0, $cozmU.useEffect)(()=>{
        if (skipRefreshPulseStatus || !lastRequestedRef.current || isPulseActive) return;
        const { index: index, timestamp: timestamp } = lastRequestedRef.current;
        const pulseHook_0 = pulseHooks[index];
        // If the message has started, clear the timeout tracking
        if (pulseHook_0.hasMessageStarted) {
            lastRequestedRef.current = null;
            return;
        }
        // If enough time has passed and the message still hasn't started, move to the next one
        const elapsed = Date.now() - timestamp;
        if (elapsed >= $9c43e73b872d5b9c$var$TIMEOUT_MS) {
            // Clear the current request tracking
            lastRequestedRef.current = null;
            // Try the next message if available
            $9c43e73b872d5b9c$var$requestNextPulse(index + 1, pulseHooks, hasRequestedRef, lastRequestedRef);
        } else {
            // Set a timeout to trigger re-evaluation when the timeout period elapses
            const remainingTime = $9c43e73b872d5b9c$var$TIMEOUT_MS - elapsed;
            const timeoutId = setTimeout(()=>{
                setTimeoutTrigger((prev)=>prev + 1);
            }, remainingTime);
            return ()=>clearTimeout(timeoutId);
        }
    }, [
        skipRefreshPulseStatus,
        isPulseActive,
        timeoutTrigger,
        pulseHooks,
        pulse1.hasMessageStarted,
        pulse2.hasMessageStarted,
        pulse3.hasMessageStarted,
        pulse4.hasMessageStarted,
        pulse5.hasMessageStarted
    ]);
    // Reactively respond when a message starts - activate the pulse
    (0, $cozmU.useEffect)(()=>{
        if (skipRefreshPulseStatus) return;
        // Check each pulse in sequence - activate the first one that has started
        for(let i_0 = 0; i_0 < pulseHooks.length; i_0++){
            const pulseHook_1 = pulseHooks[i_0];
            const messageId = $9c43e73b872d5b9c$var$PULSE_MESSAGE_IDS[i_0];
            if (pulseHook_1.hasMessageStarted) {
                lastStartedIndexRef.current = i_0;
                startPulse(entryPointId, messageId, {
                    onDismiss: ()=>pulseHook_1.dismissMessage(),
                    onClick: ()=>pulseHook_1.handleClickTracking?.()
                });
                // If this is the last pulse, mark pulses as ended
                if (i_0 === $9c43e73b872d5b9c$var$LAST_PULSE_INDEX) /**
           * Mark the EP message as "complete" and disable Loom discoverability in localStorage
           * immediately after showing the final pulse. Otherwise, if a user ignores the entrypoints
           * entirely and never clicks on one while it's pulsing, they'll:
           *
           * - Remain in the TAP audience forever
           * - Continue to check the EP messages every time an entrypoint renders
           *
           * This will technically unlock EP to show other messages, but the pulse is subtle enough that
           * this shouldn't result in poor UX
           */ (0, $gd8AW.endPulses)();
                break;
            }
        }
    }, [
        skipRefreshPulseStatus,
        entryPointId,
        startPulse,
        pulseHooks,
        pulse1.hasMessageStarted,
        pulse2.hasMessageStarted,
        pulse3.hasMessageStarted,
        pulse4.hasMessageStarted,
        pulse5.hasMessageStarted
    ]);
    // Handle message dismissal: if a started message becomes not started, request the next one
    (0, $cozmU.useEffect)(()=>{
        if (skipRefreshPulseStatus || lastStartedIndexRef.current === null || isPulseActive) return;
        const startedIndex = lastStartedIndexRef.current;
        const startedPulseHook = pulseHooks[startedIndex];
        // If the message that was started is no longer started, it was dismissed
        if (!startedPulseHook.hasMessageStarted) {
            // Clear the tracking for this message so we can move forward
            hasRequestedRef.current.delete(startedIndex);
            lastStartedIndexRef.current = null;
            // Request the next message if available
            $9c43e73b872d5b9c$var$requestNextPulse(startedIndex + 1, pulseHooks, hasRequestedRef, lastRequestedRef);
        }
    }, [
        skipRefreshPulseStatus,
        isPulseActive,
        pulseHooks,
        pulse1.hasMessageStarted,
        pulse2.hasMessageStarted,
        pulse3.hasMessageStarted,
        pulse4.hasMessageStarted,
        pulse5.hasMessageStarted
    ]);
    return {
        isPulseActive: isPulseActive
    };
};
function $9c43e73b872d5b9c$var$_temp(prev) {
    return prev + 1;
}
module.exports["useDiscoverabilityPulse"] = $9c43e73b872d5b9c$export$2002ab0670152c89;

});

parcelRegister("6m3nS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $e71ebdc70c2ecd2e$var$initialActiveTriggerState = {
    activeTriggerState: {}
};
const $e71ebdc70c2ecd2e$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $e71ebdc70c2ecd2e$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($e71ebdc70c2ecd2e$var$initialActiveTriggerState);
const $e71ebdc70c2ecd2e$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($e71ebdc70c2ecd2e$var$initialTriggerDispatchState);
const $e71ebdc70c2ecd2e$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [recordState, setRecordState] = (0, $cozmU.useState)({});
    const setTriggerState = (0, $cozmU.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setRecordState((current)=>{
            if (!!current[triggerId] === isActive) return current;
            if (isActive) return {
                ...current,
                [triggerId]: true
            };
            const { [triggerId]: excludedTrigger, ...rest } = current;
            return rest;
        });
    }, []);
    const triggerContextValue = (0, $cozmU.useMemo)(()=>({
            activeTriggerState: recordState
        }), [
        recordState
    ]);
    const triggerContexDispatchValue = (0, $cozmU.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e71ebdc70c2ecd2e$var$TriggerContext.Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e71ebdc70c2ecd2e$var$TriggerDispatchContext.Provider, {
        value: triggerContexDispatchValue
    }, children));
};
const $e71ebdc70c2ecd2e$export$454c1d7c35958f5e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerContext);
} : ()=>(0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerContext);
const $e71ebdc70c2ecd2e$export$23cbf084e08bdb93 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerDispatchContext);
} : ()=>(0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerDispatchContext);
const $e71ebdc70c2ecd2e$export$3b196fe93a948c18 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (triggerId)=>{
    const $ = (0, $bDgLe.c)(3);
    const { activeTriggerState: activeTriggerState } = $e71ebdc70c2ecd2e$export$454c1d7c35958f5e();
    let t0;
    if ($[0] !== activeTriggerState || $[1] !== triggerId) {
        t0 = triggerId ? {
            isActive: !!activeTriggerState[triggerId]
        } : {
            isActive: undefined
        };
        $[0] = activeTriggerState;
        $[1] = triggerId;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $e71ebdc70c2ecd2e$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: !!activeTriggerState[triggerId]
    } : {
        isActive: undefined
    };
};
const $e71ebdc70c2ecd2e$export$83b33e5fe4cce64 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { triggerId: triggerId } = t0;
    const { setTriggerState: setContextTriggerState } = $e71ebdc70c2ecd2e$export$23cbf084e08bdb93();
    let t1;
    if ($[0] !== setContextTriggerState || $[1] !== triggerId) {
        t1 = (t2)=>{
            const { isActive: isActive } = t2;
            return setContextTriggerState({
                triggerId: triggerId,
                isActive: isActive
            });
        };
        $[0] = setContextTriggerState;
        $[1] = triggerId;
        $[2] = t1;
    } else t1 = $[2];
    const fireTrigger = t1;
    let t2;
    if ($[3] !== fireTrigger) {
        t2 = {
            fireTrigger: fireTrigger
        };
        $[3] = fireTrigger;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $e71ebdc70c2ecd2e$export$23cbf084e08bdb93();
    const fireTrigger = (0, $cozmU.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $e71ebdc70c2ecd2e$export$e45375ff75169f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (messageId)=>{
    const $ = (0, $bDgLe.c)(17);
    const { isActive: hasMessageStarted } = $e71ebdc70c2ecd2e$export$3b196fe93a948c18(`${messageId}-started`);
    const t0 = `${messageId}-start`;
    let t1;
    if ($[0] !== t0) {
        t1 = {
            triggerId: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { fireTrigger: requestMessageStartTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t1);
    const t2 = `${messageId}-dismiss`;
    let t3;
    if ($[2] !== t2) {
        t3 = {
            triggerId: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const { fireTrigger: fireDismissClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t3);
    const t4 = `${messageId}-cta-click`;
    let t5;
    if ($[4] !== t4) {
        t5 = {
            triggerId: t4
        };
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    const { fireTrigger: fireCtaClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t5);
    let t6;
    if ($[6] !== requestMessageStartTrigger) {
        t6 = ()=>{
            requestMessageStartTrigger({
                isActive: true
            });
        };
        $[6] = requestMessageStartTrigger;
        $[7] = t6;
    } else t6 = $[7];
    const requestMessageStart = t6;
    let t7;
    if ($[8] !== fireDismissClickTrigger) {
        t7 = ()=>{
            fireDismissClickTrigger({
                isActive: true
            });
        };
        $[8] = fireDismissClickTrigger;
        $[9] = t7;
    } else t7 = $[9];
    const dismissMessage = t7;
    let t8;
    if ($[10] !== fireCtaClickTrigger) {
        t8 = ()=>{
            fireCtaClickTrigger({
                isActive: true
            });
        };
        $[10] = fireCtaClickTrigger;
        $[11] = t8;
    } else t8 = $[11];
    const handlePostOfficeClickTracking = t8;
    let t9;
    if ($[12] !== dismissMessage || $[13] !== handlePostOfficeClickTracking || $[14] !== hasMessageStarted || $[15] !== requestMessageStart) {
        t9 = {
            hasMessageStarted: hasMessageStarted,
            requestMessageStart: requestMessageStart,
            dismissMessage: dismissMessage,
            handlePostOfficeClickTracking: handlePostOfficeClickTracking
        };
        $[12] = dismissMessage;
        $[13] = handlePostOfficeClickTracking;
        $[14] = hasMessageStarted;
        $[15] = requestMessageStart;
        $[16] = t9;
    } else t9 = $[16];
    return t9;
} : (messageId)=>{
    // listeners
    const { isActive: hasMessageStarted } = $e71ebdc70c2ecd2e$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $cozmU.useCallback)(()=>{
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger
    ]);
    const dismissMessage = (0, $cozmU.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $cozmU.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};
module.exports["TriggerContextProvider"] = $e71ebdc70c2ecd2e$export$e80a5720bb4c8fe3;
module.exports["useTrigger"] = $e71ebdc70c2ecd2e$export$3b196fe93a948c18;
module.exports["useFirePostOfficeTrigger"] = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64;
module.exports["usePostOfficeExernalMessageProxy"] = $e71ebdc70c2ecd2e$export$e45375ff75169f;

});

parcelRegister("sqzF4", function(module, exports) {

var $a31lS = parcelRequire("a31lS");


var $7eCZG = parcelRequire("7eCZG");


var $1CaNG = parcelRequire("1CaNG");


var $gLxaI = parcelRequire("gLxaI");


var $60Pfj = parcelRequire("60Pfj");


var $7Upsh = parcelRequire("7Upsh");


var $cX2jD = parcelRequire("cX2jD");


var $lK9Pz = parcelRequire("lK9Pz");


var $jLogi = parcelRequire("jLogi");


var $fKdaf = parcelRequire("fKdaf");


var $fLS6B = parcelRequire("fLS6B");


var $40ukF = parcelRequire("40ukF");


var $5VZEy = parcelRequire("5VZEy");


var $ifkCZ = parcelRequire("ifkCZ");


var $kaUwk = parcelRequire("kaUwk");


var $bkj40 = parcelRequire("bkj40");


var $gh55E = parcelRequire("gh55E");


var $e6Dq9 = parcelRequire("e6Dq9");


var $e4SgJ = parcelRequire("e4SgJ");


var $82I6D = parcelRequire("82I6D");


var $8PVlW = parcelRequire("8PVlW");


var $l5MIu = parcelRequire("l5MIu");


var $1ZhW4 = parcelRequire("1ZhW4");


var $7gk7g = parcelRequire("7gk7g");


var $2QN3e = parcelRequire("2QN3e");


var $e273U = parcelRequire("e273U");


var $iFdOW = parcelRequire("iFdOW");


var $gXOst = parcelRequire("gXOst");


var $47YIB = parcelRequire("47YIB");


var $3gmKQ = parcelRequire("3gmKQ");


var $h0KOi = parcelRequire("h0KOi");


var $5tMpU = parcelRequire("5tMpU");


var $4Kyof = parcelRequire("4Kyof");


var $7iL2d = parcelRequire("7iL2d");


var $iVGec = parcelRequire("iVGec");


var $laiso = parcelRequire("laiso");


var $6WRJZ = parcelRequire("6WRJZ");


var $3HCXM = parcelRequire("3HCXM");


var $5HQgD = parcelRequire("5HQgD");


var $jT02V = parcelRequire("jT02V");


var $e1OCV = parcelRequire("e1OCV");


var $hFvHs = parcelRequire("hFvHs");


var $eEseG = parcelRequire("eEseG");


var $5bzSg = parcelRequire("5bzSg");


var $7gEjc = parcelRequire("7gEjc");


var $4OMM6 = parcelRequire("4OMM6");


var $hYOOW = parcelRequire("hYOOW");


var $f3DNZ = parcelRequire("f3DNZ");


var $hBGxo = parcelRequire("hBGxo");


var $hHtwA = parcelRequire("hHtwA");


var $2hEu6 = parcelRequire("2hEu6");


var $3VDvd = parcelRequire("3VDvd");


var $fb3SZ = parcelRequire("fb3SZ");


var $dvcAA = parcelRequire("dvcAA");


var $3RHCI = parcelRequire("3RHCI");


var $dxDD9 = parcelRequire("dxDD9");


var $5JZoZ = parcelRequire("5JZoZ");


var $ljXAk = parcelRequire("ljXAk");


var $gUZEQ = parcelRequire("gUZEQ");


var $jIG3b = parcelRequire("jIG3b");


var $grjTL = parcelRequire("grjTL");


var $4gNvG = parcelRequire("4gNvG");


var $1171P = parcelRequire("1171P");


var $d1HsG = parcelRequire("d1HsG");


var $ctVsO = parcelRequire("ctVsO");


var $abOD2 = parcelRequire("abOD2");


var $cjuKO = parcelRequire("cjuKO");


var $4lpx1 = parcelRequire("4lpx1");


var $5C5Mq = parcelRequire("5C5Mq");


var $lfQQe = parcelRequire("lfQQe");


var $93ZX6 = parcelRequire("93ZX6");


var $irqyl = parcelRequire("irqyl");


var $7Krw2 = parcelRequire("7Krw2");


var $1sOYw = parcelRequire("1sOYw");


var $7pyfy = parcelRequire("7pyfy");


var $axCbT = parcelRequire("axCbT");


var $bveWD = parcelRequire("bveWD");


var $9ta51 = parcelRequire("9ta51");

parcelRequire("bw7eK");
var $7rgfa = parcelRequire("7rgfa");


var $83dR4 = parcelRequire("83dR4");


var $2H7bJ = parcelRequire("2H7bJ");


var $b0PJa = parcelRequire("b0PJa");


var $emOXs = parcelRequire("emOXs");


var $b11Eg = parcelRequire("b11Eg");


var $hYVYG = parcelRequire("hYVYG");


var $458fo = parcelRequire("458fo");


var $gGfnN = parcelRequire("gGfnN");


var $2j2nv = parcelRequire("2j2nv");


var $37pZs = parcelRequire("37pZs");


var $ccSax = parcelRequire("ccSax");


var $21YtE = parcelRequire("21YtE");


var $j9XhP = parcelRequire("j9XhP");


var $1aAo1 = parcelRequire("1aAo1");


var $6HTz8 = parcelRequire("6HTz8");


var $UzlxI = parcelRequire("UzlxI");


var $lMcW5 = parcelRequire("lMcW5");


var $5gRoW = parcelRequire("5gRoW");


var $dUIcZ = parcelRequire("dUIcZ");


var $n7lIn = parcelRequire("n7lIn");


var $1oaTe = parcelRequire("1oaTe");


var $k1Nk4 = parcelRequire("k1Nk4");


var $6fxhr = parcelRequire("6fxhr");


var $3psuc = parcelRequire("3psuc");


var $fqvyt = parcelRequire("fqvyt");


var $19EZx = parcelRequire("19EZx");


var $7OeAC = parcelRequire("7OeAC");


var $18rHt = parcelRequire("18rHt");


var $aMwfi = parcelRequire("aMwfi");


var $bslVh = parcelRequire("bslVh");


var $78oCu = parcelRequire("78oCu");


var $3rW2U = parcelRequire("3rW2U");


var $8o1oU = parcelRequire("8o1oU");


var $1JkrY = parcelRequire("1JkrY");


var $gLRz8 = parcelRequire("gLRz8");


var $5S8Qw = parcelRequire("5S8Qw");


var $1cNjj = parcelRequire("1cNjj");


var $9ph8N = parcelRequire("9ph8N");


var $4C8JA = parcelRequire("4C8JA");


var $cySgy = parcelRequire("cySgy");


var $crhNi = parcelRequire("crhNi");


var $h9jUa = parcelRequire("h9jUa");


var $a5Ohw = parcelRequire("a5Ohw");


var $7cvtX = parcelRequire("7cvtX");


var $d1OC7 = parcelRequire("d1OC7");

function $95f3bbda8aba5631$export$248e5cf9534b5ba1(props) {
    const { intl: intl, markdownMode: markdownMode, providers: providers, enabledOptionalPlugins: enabledOptionalPlugins } = props;
    // We remove all `never` properties from the FullPagePresetProps.pluginOptions,
    // we need to return them back.
    const pluginOptions = props.pluginOptions;
    return new (0, $a31lS.EditorPresetBuilder)()// ── Foundational / lifecycle ────────────────────────────────────
    .maybeAdd([
        (0, $e1OCV.limitedModePlugin),
        (0, $19EZx.limitedModePluginOptions)({
            options: pluginOptions.limitedMode
        })
    ], !pluginOptions.limitedMode.killSwitchEnabled).add([
        (0, $h0KOi.featureFlagsPlugin),
        (0, $k1Nk4.featureFlagsPluginOptions)({
            options: pluginOptions.featureFlags
        })
    ]).add([
        (0, $1CaNG.analyticsPlugin),
        (0, $hYVYG.analyticsPluginOptions)({
            options: pluginOptions.analytics
        })
    ]).add((0, $lK9Pz.betterTypeHistoryPlugin)).add([
        (0, $hYOOW.pastePlugin),
        (0, $aMwfi.pastePluginOptions)({
            options: pluginOptions.paste,
            providers: providers
        })
    ]).add((0, $ifkCZ.default)).add((0, $4Kyof.focusPlugin)).add((0, $e6Dq9.compositionPlugin)).add([
        (0, $7Upsh.default),
        (0, $2j2nv.basePluginOptions)({
            options: pluginOptions.base
        })
    ]).maybeAdd([
        (0, $5C5Mq.userPreferencesPlugin),
        (0, $d1OC7.userPreferencesPluginOptions)({
            providers: providers,
            options: pluginOptions.userPreferencesPlugin
        })
    ], enabledOptionalPlugins.userPreferences).add((0, $2QN3e.decorationsPlugin)).add([
        (0, $d1HsG.typeAheadPlugin),
        (0, $7cvtX.typeAheadPluginOptions)({
            options: pluginOptions.typeAhead
        })
    ]).add((0, $6WRJZ.default))// ── Toolbar / chrome ────────────────────────────────────────────
    .add([
        (0, $hBGxo.primaryToolbarPlugin),
        (0, $78oCu.primaryToolbarPluginOptions)({
            options: pluginOptions.primaryToolbar
        })
    ]).maybeAdd([
        (0, $4gNvG.toolbarPlugin),
        (0, $a5Ohw.toolbarPluginOptions)({
            options: pluginOptions.toolbar
        })
    ], Boolean(enabledOptionalPlugins.toolbar)).add([
        (0, $jLogi.blockMenuPlugin),
        {
            getLinkPath: pluginOptions.blockMenu?.getLinkPath,
            blockLinkHashPrefix: pluginOptions.blockMenu?.blockLinkHashPrefix
        }
    ]).add((0, $abOD2.undoRedoPlugin)).add([
        (0, $dxDD9.selectionToolbarPlugin),
        (0, $1cNjj.selectionToolbarPluginOptions)({
            options: pluginOptions.selectionToolbar,
            providers: providers
        })
    ])// ── Content (GFM-safe) ──────────────────────────────────────────
    .add([
        (0, $3HCXM.hyperlinkPlugin),
        (0, $3psuc.hyperlinkPluginOptions)({
            options: pluginOptions.hyperlink
        })
    ]).add([
        (0, $grjTL.textFormattingPlugin),
        {
            ...(0, $h9jUa.textFormattingPluginOptions)({
                options: pluginOptions.textFormatting
            }),
            // Underline, subscript and superscript have no GFM equivalent and
            // cannot round-trip through markdown, so hide them from the toolbar.
            disableUnderline: true,
            disableSuperscriptAndSubscript: true
        }
    ]).add([
        (0, $fKdaf.blockTypePlugin),
        (0, $37pZs.blockTypePluginOptions)({
            options: pluginOptions.blockType
        })
    ]).add((0, $5VZEy.clearMarksOnEmptyDocPlugin)).add((0, $lfQQe.widthPlugin)).add([
        (0, $hHtwA.quickInsertPlugin),
        {
            ...(0, $3rW2U.quickInsertPluginOptions)({
                options: pluginOptions.quickInsert
            }),
            itemFilter: (item)=>{
                // Restrict the / menu and element browser to
                // GFM-compatible items before applying any consumer itemFilter.
                if (!(0, $9ta51.isMarkdownCompatibleQuickInsertItem)(item)) return false;
                return typeof pluginOptions.quickInsert.quickInsert === 'object' ? pluginOptions.quickInsert.quickInsert.itemFilter?.(item) ?? true : true;
            }
        }
    ]).add([
        (0, $f3DNZ.placeholderPlugin),
        (0, $bslVh.placeholderPluginOptions)({
            intl: intl,
            options: pluginOptions.placeholder
        })
    ]).add((0, $cjuKO.unsupportedContentPlugin)).add([
        (0, $e273U.editorDisabledPlugin),
        (0, $5gRoW.editorDisabledPluginOptions)({
            options: pluginOptions.editorDisabled
        })
    ]).add([
        (0, $ljXAk.submitEditorPlugin),
        (0, $4C8JA.submitEditorPluginOptions)({
            options: pluginOptions.submitEditor
        })
    ]).add((0, $1ZhW4.copyButtonPlugin)).maybeAdd((0, $5tMpU.floatingToolbarPlugin), enabledOptionalPlugins.floatingToolbar ?? true).maybeAdd((0, $jT02V.interactionPlugin), Boolean(enabledOptionalPlugins.interaction)).add([
        (0, $fb3SZ.selectionPlugin),
        (0, $5S8Qw.selectionPluginOptions)({
            options: pluginOptions.selection
        })
    ]).add([
        (0, $bkj40.default),
        (0, $1aAo1.codeBlockPluginOptions)({
            providers: providers
        })
    ]).add((0, $ctVsO.ufoPlugin)).add((0, $7gk7g.dataConsumerPlugin)).add((0, $7eCZG.accessibilityUtilsPlugin)).add((0, $8PVlW.contentInsertionPlugin)).add((0, $cX2jD.batchAttributeUpdatesPlugin)).add((0, $hFvHs.listPlugin)).add([
        (0, $1171P.toolbarListsIndentationPlugin),
        {
            // indentationPlugin is intentionally excluded from markdown mode
            // (indentation has no GFM equivalent), so disable the indent/outdent
            // buttons and only surface the bullet/ordered list buttons.
            showIndentationButtons: false,
            allowHeadingAndParagraphIndentation: false
        }
    ]).add((0, $2hEu6.rulePlugin))// ── Media (markdown image syntax) ───────────────────────────────
    // gridPlugin is a structural dependency of mediaPlugin even though
    // grid layouts themselves aren't markdown-compatible.
    .add((0, $iVGec.gridPlugin))// breakoutPlugin is included for *schema compatibility only* —
    // stored rich-mode pages may carry a `breakout` mark on code blocks
    // (and other block nodes) which would otherwise cause the collab
    // `Node.fromJSON` path to throw `RangeError: There is no mark type
    // breakout in this schema`. We don't surface the breakout UI in
    // markdown mode (no toolbar button is wired); the mark just sits
    // inert until the user re-saves the page.
    .add([
        (0, $fLS6B.breakoutPlugin),
        (0, $ccSax.breakoutPluginOptions)({
            options: {
                editorAppearance: 'full-page'
            }
        })
    ]).add([
        (0, $5bzSg.mediaPlugin),
        (0, $7OeAC.mediaPluginOptions)({
            intl: intl,
            options: pluginOptions.media,
            providers: providers
        })
    ]).add((0, $7gEjc.mediaInsertPlugin)).maybeAdd([
        (0, $1sOYw.aiImageGenerationPlugin),
        (0, $2H7bJ.aiImageGenerationPluginOptions)({
            options: pluginOptions.aiImageGeneration
        })
    ], enabledOptionalPlugins.aiImageGeneration)// ── Tables, tasks/decisions, annotations ────────────────────────
    .add([
        (0, $gUZEQ.default),
        (0, $cySgy.tablePluginOptions)({
            options: pluginOptions.table
        })
    ]).add([
        (0, $jIG3b.tasksAndDecisionsPlugin),
        (0, $crhNi.tasksAndDecisionsPluginOptions)({
            options: pluginOptions.tasksAndDecisions,
            providers: providers
        })
    ]).add([
        (0, $laiso.helpDialogPlugin),
        (0, $6fxhr.helpDialogPluginOptions)({
            options: {
                imageUploadProviderExists: false,
                aiEnabled: enabledOptionalPlugins.aiExperience
            }
        })
    ]).maybeAdd([
        (0, $gh55E.collabEditPlugin),
        (0, $6HTz8.collabEditPluginOptions)({
            options: pluginOptions.collabEdit,
            providers: providers
        })
    ], Boolean(pluginOptions.collabEdit.collabEdit))// ── Misc UI / utility plugins ───────────────────────────────────
    .add([
        (0, $l5MIu.contextPanelPlugin),
        (0, $lMcW5.contextPanelPluginOptions)({
            options: pluginOptions.contextPanel
        })
    ]).add([
        (0, $3gmKQ.extensionPlugin),
        (0, $1oaTe.extensionPluginOptions)({
            options: pluginOptions.extension ?? {}
        })
    ]).add((0, $3VDvd.scrollIntoViewPlugin)).add([
        (0, $5HQgD.insertBlockPlugin),
        {
            ...(0, $fqvyt.insertBlockPluginOptions)({
                options: pluginOptions.insertBlock
            }),
            itemFilter: (item)=>{
                const name = item.value.name;
                // Decisions and statuses have no GFM equivalent, so hide them
                // from the pre-'View More' suggestions.
                if (name === 'decision' || name === 'status') return false;
                return pluginOptions.insertBlock?.itemFilter?.(item) ?? true;
            }
        }
    ]).add([
        (0, $60Pfj.avatarGroupPlugin),
        (0, $gGfnN.avatarGroupPluginOptions)({
            options: pluginOptions.avatarGroup
        })
    ]).add((0, $7iL2d.fragmentPlugin)).add([
        (0, $kaUwk.codeBidiWarningPlugin),
        (0, $j9XhP.codeBidiWarningPluginOptions)({
            options: pluginOptions.codeBidiWarning
        })
    ])// ── Referentiality (link-tracking) ──────────────────────────────
    .maybeAdd([
        (0, $7rgfa.referentialityPlugin),
        enabledOptionalPlugins.referentiality ? (0, $8o1oU.referentialityPluginOptions)({
            options: pluginOptions.referentiality
        }) : undefined
    ], enabledOptionalPlugins.referentiality)// ── View mode (markdown / source / preview toggle) ──────────────
    .add([
        (0, $iFdOW.editorViewModePlugin),
        (0, $dUIcZ.editorViewModePluginOptions)({
            options: pluginOptions.editorViewMode
        })
    ]).add((0, $gXOst.editorViewModeEffectsPlugin))// ── AI ──────────────────────────────────────────────────────────
    // `aiDefinitionsPlugin` depends on `editorViewModePlugin`, so
    // it is added after it.
    .maybeAdd([
        (0, $7Krw2.aiDefinitionsPlugin),
        (0, $83dR4.aiDefinitionsPluginOptions)({
            options: pluginOptions.aiDefinitions
        })
    ], enabledOptionalPlugins.aiDefinitions).maybeAdd([
        (0, $irqyl.aiPlugin),
        (0, $b0PJa.aiPluginOptions)({
            options: pluginOptions.ai
        })
    ], enabledOptionalPlugins.aiExperience).maybeAdd([
        (0, $7pyfy.aiStreamingOrchestratorPlugin),
        (0, $emOXs.aiStreamingOrchestratorPluginOptions)({
            options: pluginOptions.aiStreamingOrchestrator
        })
    ], enabledOptionalPlugins.aiStreamingOrchestrator).maybeAdd((0, $93ZX6.aiSpeechToTextPlugin), enabledOptionalPlugins.aiSpeechToText).maybeAdd([
        (0, $axCbT.aiSuggestionsPlugin),
        (0, $b11Eg.aiSuggestionsOptions)({
            options: pluginOptions.aiSuggestions
        })
    ], enabledOptionalPlugins.aiSuggestions)// ── Selection / engagement / metrics / connectivity ─────────────
    .add([
        (0, $3RHCI.selectionMarkerPlugin),
        (0, $gLRz8.selectionMarkerPluginOptions)({
            options: pluginOptions.selectionMarker
        })
    ]).add([
        (0, $47YIB.engagementPlatformPlugin),
        (0, $n7lIn.engagementPlatformPluginOptions)({
            options: pluginOptions.engagementPlatform
        })
    ]).maybeAdd((0, $e4SgJ.connectivityPlugin), enabledOptionalPlugins.connectivity).maybeAdd([
        (0, $4OMM6.metricsPlugin),
        (0, $18rHt.metricsPluginOptions)({
            options: pluginOptions.metrics
        })
    ], enabledOptionalPlugins.metrics).maybeAdd([
        (0, $82I6D.contentFormatPlugin),
        (0, $UzlxI.contentFormatPluginOptions)({
            options: pluginOptions.contentFormat
        })
    ], enabledOptionalPlugins.contentFormat).maybeAdd([
        (0, $dvcAA.selectionExtensionPlugin),
        (0, $1JkrY.selectionExtensionPluginOptions)({
            options: pluginOptions.selectionExtension
        })
    ], enabledOptionalPlugins.selectionExtension).add((0, $4lpx1.userIntentPlugin)).maybeAdd([
        (0, $5JZoZ.showDiffPlugin),
        (0, $9ph8N.showDiffPluginOptions)({
            options: pluginOptions.showDiff
        })
    ], enabledOptionalPlugins.showDiff).maybeAdd((0, $eEseG.localIdPlugin), enabledOptionalPlugins.localId)// ── Annotations (inline comments) ───────────────────────────────
    // annotationPluginOptions returns undefined when no provider is supplied,
    // in which case the plugin is added without options (schema mark still
    // registers, but comment creation UI is not activated — correct behaviour
    // for pages where inline comments are disabled).
    .add([
        (0, $gLxaI.annotationPlugin),
        (0, $458fo.annotationPluginOptions)({
            options: pluginOptions.annotation ?? {
                annotationManager: undefined,
                createCommentExperience: undefined,
                selectCommentExperience: undefined
            },
            providers: providers
        })
    ])// ── Smart Links (inline only) ───────────────────────────────────
    // Markdown mode renders only inline cards: blockCard/embedCard have
    // no markdown surface and stay out of the schema entirely via
    // `onlyInlineCards`. Added after editorViewMode and annotation so
    // its optional dependencies resolve. Skipped when callers don't
    // supply `pluginOptions.card`, since cardPluginOptions needs an
    // editorAppearance and a provider to do anything useful.
    .maybeAdd([
        (0, $40ukF.cardPlugin),
        pluginOptions.card ? {
            ...(0, $21YtE.cardPluginOptions)({
                options: pluginOptions.card,
                providers: providers
            }),
            onlyInlineCards: true
        } : undefined
    ], Boolean(pluginOptions.card))/*
			 * ── Intentionally excluded ────────────────────────────────────────
			 * Adding a plugin to this preset is a deliberate compatibility
			 * statement — if a new plugin lands in `fullPagePreset` it is *not*
			 * automatically picked up here. Keep this list curated.
			 *
			 * Confluence-specific rich-only nodes (no GFM equivalent):
			 *   - panelPlugin
			 *   - expandPlugin
			 *   - layoutPlugin
			 *   - syncedBlockPlugin
			 *   - statusPlugin
			 *   - datePlugin
			 *   - guidelinePlugin          (image sizing guides — no markdown
			 *                              syntax for image dimensions)
			 *   - loomPlugin               (embedded Loom playback nodes)
			 *
			 * Marks with no GFM equivalent:
			 *   - alignmentPlugin
			 *   - textColorPlugin
			 *   - highlightPlugin
			 *   - borderPlugin
			 *   - indentationPlugin
			 *
			 * revisit: planned to add once stable / once their persistence story
			 * supports markdown round-tripping:
			 *   - captionPlugin            (figure captions under media)
			 *   - mentionsPlugin           (@-mentions)
			 *   - emojiPlugin              (emoji nodes)
			 */ // ── Markdown mode itself (added last so dependencies resolve) ───
    .add([
        (0, $bveWD.markdownModePlugin),
        markdownMode
    ]);
}
module.exports["markdownPreset"] = $95f3bbda8aba5631$export$248e5cf9534b5ba1;

});

parcelRegister("jLogi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $anBbz = parcelRequire("anBbz");


var $4K3WD = parcelRequire("4K3WD");


var $451nH = parcelRequire("451nH");


var $d59RG = parcelRequire("d59RG");


var $4p59H = parcelRequire("4p59H");


var $kAEz0 = parcelRequire("kAEz0");


var $8059h = parcelRequire("8059h");


var $db6yu = parcelRequire("db6yu");


var $dzhlK = parcelRequire("dzhlK");


var $b4364 = parcelRequire("b4364");


var $2Cg6W = parcelRequire("2Cg6W");

const $70ade72bc5421184$export$dfc601443ba8de15 = ({ api: api, config: config })=>{
    const registry = (0, $4K3WD.createBlockMenuRegistry)();
    registry.register((0, $dzhlK.getBlockMenuComponents)({
        api: api,
        config: config
    }));
    const refs = {};
    return {
        name: 'blockMenu',
        pmPlugins () {
            return [
                {
                    name: 'blockMenuPlugin',
                    plugin: ()=>(0, $8059h.createPlugin)(api)
                },
                {
                    name: 'blockMenuKeymap',
                    plugin: ()=>(0, $kAEz0.keymapPlugin)(api, config)
                },
                ...(0, $anBbz.expValEqualsNoExposure)('platform_editor_experience_tracking_observer', 'isEnabled', true) ? [
                    {
                        name: 'blockMenuExperiences',
                        plugin: ()=>(0, $4p59H.getBlockMenuExperiencesPlugin)({
                                refs: refs,
                                dispatchAnalyticsEvent: (payload)=>api?.analytics?.actions?.fireAnalyticsEvent(payload)
                            })
                    }
                ] : []
            ];
        },
        actions: {
            registerBlockMenuComponents: (blockMenuComponents)=>{
                registry.register(blockMenuComponents);
            },
            getBlockMenuComponents: ()=>{
                return registry.components;
            },
            isTransformOptionDisabled: (optionNodeTypeName, optionNodeTypeAttrs)=>{
                const preservedSelection = api?.blockControls?.sharedState.currentState()?.preservedSelection;
                const selection = api?.selection?.sharedState?.currentState()?.selection;
                const currentSelection = preservedSelection || selection;
                if (!currentSelection) return true;
                return (0, $451nH.isTransformToTargetDisabled)({
                    selection: currentSelection,
                    targetNodeTypeName: optionNodeTypeName,
                    targetNodeTypeAttrs: optionNodeTypeAttrs
                });
            }
        },
        commands: {
            transformNode: (targetType, metadata)=>{
                return (0, $d59RG.transformNode)(api)(targetType, metadata);
            }
        },
        getSharedState (editorState) {
            const useStandardNodeWidth = config?.useStandardNodeWidth ?? false;
            if (!editorState) return {
                currentSelectedNodeName: undefined,
                showFlag: false,
                useStandardNodeWidth: useStandardNodeWidth
            };
            // Get the menuTriggerBy from blockControls plugin if available
            const currentSelectedNodeName = api?.blockControls?.sharedState.currentState()?.menuTriggerBy;
            // Get the showFlag from plugin state
            const pluginState = (0, $8059h.blockMenuPluginKey).getState(editorState);
            const showFlag = pluginState?.showFlag ?? false;
            return {
                currentSelectedNodeName: currentSelectedNodeName,
                showFlag: showFlag,
                useStandardNodeWidth: useStandardNodeWidth
            };
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
            refs.popupsMountPoint = popupsMountPoint || undefined;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b4364.BlockMenuProvider), {
                api: api,
                editorView: editorView
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $db6yu.default), {
                editorView: editorView,
                api: api,
                mountTo: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Cg6W.Flag), {
                api: api
            }));
        }
    };
};
module.exports["blockMenuPlugin"] = $70ade72bc5421184$export$dfc601443ba8de15;

});

parcelRegister("4K3WD", function(module, exports) {
const $9937845fc86a2a61$export$b5eca477c47c935a = ()=>{
    const components = [];
    const register = (blockMenuComponents)=>{
        components.push(...blockMenuComponents);
    };
    return {
        register: register,
        components: components
    };
};
module.exports["createBlockMenuRegistry"] = $9937845fc86a2a61$export$b5eca477c47c935a;

});

parcelRegister("451nH", function(module, exports) {

var $lVAkE = parcelRequire("lVAkE");


var $aPdNQ = parcelRequire("aPdNQ");


var $88s8W = parcelRequire("88s8W");


var $jbhmw = parcelRequire("jbhmw");


var $gnxj8 = parcelRequire("gnxj8");

const $592987645a8409c6$export$abccbeb211b45a84 = (schema, selectedNodeTypeName, parentNode, nodeTypeName, nodeTypeAttrs)=>{
    const adjustedNodeTypeName = (0, $gnxj8.getTargetNodeTypeNameInContext)(nodeTypeName, true, parentNode, schema);
    if (!adjustedNodeTypeName) return false;
    const nodeType = schema.nodes[adjustedNodeTypeName];
    let content = null;
    const nodesThatCantBeNestedInNestedExpand = [
        'blockCard',
        'embedCard',
        'table'
    ];
    if (nodesThatCantBeNestedInNestedExpand.includes(selectedNodeTypeName) && (adjustedNodeTypeName === 'expand' || adjustedNodeTypeName === 'nestedExpand')) {
        const node = schema.nodes[selectedNodeTypeName];
        content = node.createAndFill();
    }
    return parentNode.type.validContent((0, $aPdNQ.Fragment).from(nodeType.createAndFill(nodeTypeAttrs, content)));
};
const $592987645a8409c6$var$isHeadingToHeadingTransformEnabled = (selectedNode, targetNodeTypeAttrs)=>{
    const selectedLevel = selectedNode.attrs?.level;
    const targetLevel = targetNodeTypeAttrs?.level;
    if (selectedLevel === undefined || targetLevel === undefined) return false;
    return selectedLevel !== targetLevel;
};
const $592987645a8409c6$var$isTransformEnabledForNode = (node, targetNodeTypeName, targetNodeTypeAttrs, isNested, parent, schema)=>{
    const selectedNodeTypeName = (0, $jbhmw.toNodeTypeValue)(node.type.name);
    if (!selectedNodeTypeName) return false;
    const isDisabledByStepsConfig = (0, $88s8W.isTransformDisabledBasedOnStepsConfig)(selectedNodeTypeName, targetNodeTypeName);
    if (isDisabledByStepsConfig) return false;
    if (selectedNodeTypeName === 'heading' && targetNodeTypeName === 'heading') return $592987645a8409c6$var$isHeadingToHeadingTransformEnabled(node, targetNodeTypeAttrs);
    if (isNested && !$592987645a8409c6$export$abccbeb211b45a84(schema, selectedNodeTypeName, parent, targetNodeTypeName, targetNodeTypeAttrs)) return false;
    return true;
};
const $592987645a8409c6$export$ed52055465d881d8 = ({ selection: selection, targetNodeTypeName: targetNodeTypeName, targetNodeTypeAttrs: targetNodeTypeAttrs })=>{
    const { range: range } = (0, $lVAkE.expandSelectionToBlockRange)(selection);
    if (!range) return false;
    const selectedNodes = (0, $gnxj8.getBlockNodesInRange)(range);
    const parent = range.parent;
    const isNested = range.depth >= 1;
    const { schema: schema } = selection.$from.doc.type;
    const supportedTargetNodeTypeName = (0, $jbhmw.toNodeTypeValue)(targetNodeTypeName);
    if (!supportedTargetNodeTypeName) return true;
    const isEnabledForAnyNode = selectedNodes.some((node)=>$592987645a8409c6$var$isTransformEnabledForNode(node, supportedTargetNodeTypeName, targetNodeTypeAttrs, isNested, parent, schema));
    return !isEnabledForAnyNode;
};
module.exports["isTransformToTargetDisabled"] = $592987645a8409c6$export$ed52055465d881d8;

});

parcelRegister("88s8W", function(module, exports) {

var $57Rmq = parcelRequire("57Rmq");


var $ieeJu = parcelRequire("ieeJu");


var $gnxj8 = parcelRequire("gnxj8");


var $cFgp4 = parcelRequire("cFgp4");


var $jbhmw = parcelRequire("jbhmw");

const $826ec5ab3725cb1a$export$d51f879aeee57aee = (nodes, parentNode, schema)=>{
    if (!schema.nodes['panel_c1'] || !(0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) return nodes;
    return nodes.map((node)=>{
        if (node.type.name === 'panel') {
            const shouldUsePanelC1 = !parentNode || (0, $57Rmq.isNodeTypeValidChildOf)('panel_c1', parentNode, schema);
            if (shouldUsePanelC1) return schema.nodes['panel_c1'].createAndFill(node.attrs, node.content, node.marks) ?? node;
        }
        return node;
    });
};
const $826ec5ab3725cb1a$export$643addcbe529babf = ({ sourceNodes: sourceNodes, targetNodeType: targetNodeType, schema: schema, isNested: isNested, targetAttrs: targetAttrs, parentNode: parentNode })=>{
    const sourceNode = sourceNodes.at(0);
    if (!sourceNode) return sourceNodes;
    const selectedNodeTypeName = (0, $jbhmw.toNodeTypeValue)((0, $jbhmw.getNodeName)(sourceNodes));
    const initialTargetNodeTypeName = (0, $jbhmw.toNodeTypeValue)(targetNodeType.name);
    const targetNodeTypeName = (0, $gnxj8.getTargetNodeTypeNameInContext)(initialTargetNodeTypeName, isNested, parentNode, schema);
    if (!selectedNodeTypeName || !targetNodeTypeName) return sourceNodes;
    const steps = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $cFgp4.TRANSFORMATION_MATRIX_PANEL_C1)[selectedNodeTypeName][targetNodeTypeName] : (0, $cFgp4.TRANSFORMATION_MATRIX)[selectedNodeTypeName][targetNodeTypeName];
    const context = {
        // sourceNode is incorrect now - what to do here?
        fromNode: sourceNode,
        targetNodeTypeName: targetNodeTypeName,
        schema: schema,
        targetAttrs: targetAttrs
    };
    if (!steps || steps.length === 0) return sourceNodes;
    const resultNodes = steps.reduce((nodes, step)=>{
        return step(nodes, context);
    }, sourceNodes);
    return $826ec5ab3725cb1a$export$d51f879aeee57aee(resultNodes, parentNode, schema);
};
const $826ec5ab3725cb1a$export$9370deb718b26b1b = (selectedNodeType, targetNodeType)=>{
    const steps = (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $cFgp4.TRANSFORMATION_MATRIX_PANEL_C1)[selectedNodeType][targetNodeType] : (0, $cFgp4.TRANSFORMATION_MATRIX)[selectedNodeType][targetNodeType];
    return !steps || steps.length === 0;
};
module.exports["convertNodesToTargetType"] = $826ec5ab3725cb1a$export$643addcbe529babf;
module.exports["isTransformDisabledBasedOnStepsConfig"] = $826ec5ab3725cb1a$export$9370deb718b26b1b;

});

parcelRegister("gnxj8", function(module, exports) {

var $57Rmq = parcelRequire("57Rmq");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");


var $8HW7o = parcelRequire("8HW7o");


var $ieeJu = parcelRequire("ieeJu");


var $jbhmw = parcelRequire("jbhmw");

const $0076a543987ed8f3$export$ccbedd67ef6e9417 = (node)=>{
    const category = (0, $jbhmw.NODE_CATEGORY_BY_TYPE)[node.type.name];
    return category === 'text';
};
const $0076a543987ed8f3$export$a7d7d2b9ba4d4dbb = (node)=>{
    return [
        'bulletList',
        'orderedList',
        'taskList'
    ].includes(node.type.name);
};
const $0076a543987ed8f3$export$da5a91481a5e4aa3 = (selection)=>{
    if (selection instanceof (0, $kCECX.NodeSelection)) return {
        node: selection.node,
        pos: selection.$from.pos,
        start: 0,
        depth: selection.$from.depth
    };
    if (selection instanceof (0, $8HW7o.CellSelection)) {
        const tableSelected = (0, $bjg0G.findParentNodeOfType)(selection.$from.doc.type.schema.nodes.table)(selection);
        return tableSelected;
    }
    if (selection instanceof (0, $kCECX.TextSelection)) {
        const { blockquote: blockquote, bulletList: bulletList, orderedList: orderedList, taskList: taskList, codeBlock: codeBlock, paragraph: paragraph, heading: heading } = selection.$from.doc.type.schema.nodes;
        const quoteSelected = (0, $bjg0G.findParentNodeOfType)([
            blockquote
        ])(selection);
        if (quoteSelected) return quoteSelected;
        const codeBlockSelected = (0, $bjg0G.findParentNodeOfType)([
            codeBlock
        ])(selection);
        if (codeBlockSelected) return codeBlockSelected;
        const listSelected = (0, $bjg0G.findParentNodeOfType)([
            bulletList,
            taskList,
            orderedList
        ])(selection);
        if (listSelected) return listSelected;
        const paragraphOrHeading = (0, $bjg0G.findParentNodeOfType)([
            paragraph,
            heading
        ])(selection);
        if (paragraphOrHeading) return paragraphOrHeading;
    }
    return undefined;
};
const $0076a543987ed8f3$export$4126f65c98e68a18 = (nodeTypeName, isNested, parentNode, schema)=>{
    if (parentNode && isNested && (parentNode.type.name === 'layoutColumn' || parentNode.type.name === 'bodiedSyncBlock')) return nodeTypeName;
    if (nodeTypeName === 'expand' && isNested) return 'nestedExpand';
    if (nodeTypeName === 'panel' && schema?.nodes['panel_c1'] && (0, $ieeJu.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) {
        if (!parentNode || (0, $57Rmq.isNodeTypeValidChildOf)('panel_c1', parentNode, schema)) return 'panel_c1';
    }
    return nodeTypeName;
};
const $0076a543987ed8f3$export$3f28f32259ef3cd = (node, schema)=>{
    const expandType = schema.nodes.expand;
    if (!expandType) return null;
    return expandType.createAndFill({
        title: node.attrs?.title || '',
        localId: crypto.randomUUID()
    }, node.content);
};
const $0076a543987ed8f3$export$46a467eba720c02e = (node, schema)=>{
    const nestedExpandType = schema.nodes.nestedExpand;
    if (!nestedExpandType) return null;
    return nestedExpandType.createAndFill({
        title: node.attrs?.title || '',
        localId: crypto.randomUUID()
    }, node.content);
};
const $0076a543987ed8f3$export$da315ff7968a4b6e = (node, schema)=>{
    // If it's already a paragraph, return as-is
    if (node.type.name === 'paragraph') return node;
    // Convert heading (or other text node) to paragraph with same inline content
    return schema.nodes.paragraph.createAndFill({}, node.content) ?? null;
};
const $0076a543987ed8f3$export$4a1a21434bd3128 = (range)=>{
    if (range.startIndex === range.endIndex) return [];
    if (range.endIndex - range.startIndex <= 1) return [
        range.parent.child(range.startIndex)
    ];
    const blockNodes = [];
    for(let i = range.startIndex; i < range.endIndex; i++)if (range.parent.child(i).isBlock) blockNodes.push(range.parent.child(i));
    return blockNodes;
};
const $0076a543987ed8f3$export$acfd0d6af597f7c = (node)=>{
    const textContent = node.children.map((child)=>{
        if (child.isText) return child.text;
        else if (child.type.name === 'hardBreak') return '\n';
        return '';
    });
    return textContent.join('');
};
module.exports["isTextNode"] = $0076a543987ed8f3$export$ccbedd67ef6e9417;
module.exports["isListNode"] = $0076a543987ed8f3$export$a7d7d2b9ba4d4dbb;
module.exports["getTargetNodeTypeNameInContext"] = $0076a543987ed8f3$export$4126f65c98e68a18;
module.exports["convertNestedExpandToExpand"] = $0076a543987ed8f3$export$3f28f32259ef3cd;
module.exports["convertExpandToNestedExpand"] = $0076a543987ed8f3$export$46a467eba720c02e;
module.exports["convertTextNodeToParagraph"] = $0076a543987ed8f3$export$da315ff7968a4b6e;
module.exports["getBlockNodesInRange"] = $0076a543987ed8f3$export$4a1a21434bd3128;
module.exports["createTextContent"] = $0076a543987ed8f3$export$acfd0d6af597f7c;

});

parcelRegister("jbhmw", function(module, exports) {
const $06f4f892ccc89d19$export$46b8389d01fc568c = {
    blockquote: 'container',
    blockCard: 'atomic',
    bodiedExtension: 'atomic',
    bulletList: 'list',
    codeBlock: 'container',
    decisionList: 'list',
    embedCard: 'atomic',
    expand: 'container',
    extension: 'atomic',
    heading: 'text',
    layoutSection: 'container',
    media: 'atomic',
    mediaGroup: 'atomic',
    mediaSingle: 'atomic',
    multiBodiedExtension: 'atomic',
    orderedList: 'list',
    panel: 'container',
    panel_c1: 'container',
    paragraph: 'text',
    nestedExpand: 'container',
    taskList: 'list',
    table: 'atomic',
    multi: 'multi'
};
const $06f4f892ccc89d19$export$8b255fd4814375b4 = (value)=>value in $06f4f892ccc89d19$export$46b8389d01fc568c;
const $06f4f892ccc89d19$export$708f29fc6944bd7f = (value)=>value && $06f4f892ccc89d19$export$8b255fd4814375b4(value) ? value : null;
const $06f4f892ccc89d19$export$651544f548703224 = (nodes)=>{
    return nodes.length > 1 ? 'multi' : nodes.at(0)?.type.name;
};
module.exports["NODE_CATEGORY_BY_TYPE"] = $06f4f892ccc89d19$export$46b8389d01fc568c;
module.exports["toNodeTypeValue"] = $06f4f892ccc89d19$export$708f29fc6944bd7f;
module.exports["getNodeName"] = $06f4f892ccc89d19$export$651544f548703224;

});

parcelRegister("cFgp4", function(module, exports) {

var $eiPUm = parcelRequire("eiPUm");


var $96P9R = parcelRequire("96P9R");


var $khsPj = parcelRequire("khsPj");


var $g742n = parcelRequire("g742n");


var $2ZTDz = parcelRequire("2ZTDz");


var $9raHw = parcelRequire("9raHw");


var $jLMlm = parcelRequire("jLMlm");


var $bIBXS = parcelRequire("bIBXS");


var $cShRs = parcelRequire("cShRs");


var $880Pu = parcelRequire("880Pu");


var $6yigg = parcelRequire("6yigg");


var $8lpIu = parcelRequire("8lpIu");


var $i4v8d = parcelRequire("i4v8d");


var $hZH0W = parcelRequire("hZH0W");


var $6cNnr = parcelRequire("6cNnr");


var $edxij = parcelRequire("edxij");

/**
 * Creates the transformation matrix for all node type pairs.
 * When includePanelC1 is true (platform_editor_nest_table_in_panel experiment on),
 * panel_c1 entries are included as both source and target types.
 * If a transformation is not defined (undefined), it is not available.
 */ const $0d573f0d656dcbe1$var$createTransformationMatrix = (includePanelC1)=>({
        paragraph: {
            heading: [
                (0, $2ZTDz.flattenStep),
                (0, $eiPUm.applyTargetTextTypeStep)
            ],
            blockquote: [
                (0, $6cNnr.wrapMixedContentStep)
            ],
            codeBlock: [
                (0, $6cNnr.wrapMixedContentStep)
            ],
            expand: [
                (0, $6cNnr.wrapMixedContentStep)
            ],
            nestedExpand: [
                (0, $6cNnr.wrapMixedContentStep)
            ],
            layoutSection: [
                (0, $6cNnr.wrapMixedContentStep)
            ],
            panel: [
                (0, $6cNnr.wrapMixedContentStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $6cNnr.wrapMixedContentStep)
                ]
            } : {},
            bulletList: [
                (0, $hZH0W.wrapIntoListStep)
            ],
            orderedList: [
                (0, $hZH0W.wrapIntoListStep)
            ],
            taskList: [
                (0, $hZH0W.wrapIntoListStep)
            ],
            decisionList: [
                (0, $hZH0W.wrapIntoListStep)
            ]
        },
        heading: {
            heading: [
                (0, $2ZTDz.flattenStep),
                (0, $eiPUm.applyTargetTextTypeStep)
            ],
            paragraph: [
                (0, $2ZTDz.flattenStep),
                (0, $eiPUm.applyTargetTextTypeStep)
            ],
            blockquote: [
                (0, $6cNnr.wrapMixedContentStep)
            ],
            codeBlock: [
                (0, $6cNnr.wrapMixedContentStep)
            ],
            expand: [
                (0, $6cNnr.wrapMixedContentStep)
            ],
            nestedExpand: [
                (0, $6cNnr.wrapMixedContentStep)
            ],
            layoutSection: [
                (0, $6cNnr.wrapMixedContentStep)
            ],
            panel: [
                (0, $6cNnr.wrapMixedContentStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $6cNnr.wrapMixedContentStep)
                ]
            } : {},
            bulletList: [
                (0, $hZH0W.wrapIntoListStep)
            ],
            orderedList: [
                (0, $hZH0W.wrapIntoListStep)
            ],
            taskList: [
                (0, $hZH0W.wrapIntoListStep)
            ],
            decisionList: [
                (0, $hZH0W.wrapIntoListStep)
            ]
        },
        panel: {
            blockquote: [
                (0, $8lpIu.unwrapStep),
                (0, $6cNnr.wrapMixedContentStep)
            ],
            codeBlock: [
                (0, $8lpIu.unwrapStep),
                (0, $6cNnr.wrapMixedContentStep)
            ],
            expand: [
                (0, $8lpIu.unwrapStep),
                (0, $edxij.wrapStep)
            ],
            nestedExpand: [
                (0, $8lpIu.unwrapStep),
                (0, $edxij.wrapStep)
            ],
            layoutSection: [
                (0, $8lpIu.unwrapStep),
                (0, $6cNnr.wrapMixedContentStep)
            ],
            paragraph: [
                (0, $8lpIu.unwrapStep)
            ]
        },
        panel_c1: includePanelC1 ? {
            blockquote: [
                (0, $8lpIu.unwrapStep),
                (0, $6cNnr.wrapMixedContentStep)
            ],
            codeBlock: [
                (0, $8lpIu.unwrapStep),
                (0, $6cNnr.wrapMixedContentStep)
            ],
            expand: [
                (0, $8lpIu.unwrapStep),
                (0, $edxij.wrapStep)
            ],
            nestedExpand: [
                (0, $8lpIu.unwrapStep),
                (0, $edxij.wrapStep)
            ],
            layoutSection: [
                (0, $8lpIu.unwrapStep),
                (0, $6cNnr.wrapMixedContentStep)
            ],
            paragraph: [
                (0, $8lpIu.unwrapStep)
            ]
        } : {},
        expand: {
            panel: [
                (0, $cShRs.unwrapExpandStep),
                (0, $6cNnr.wrapMixedContentStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $cShRs.unwrapExpandStep),
                    (0, $6cNnr.wrapMixedContentStep)
                ]
            } : {},
            blockquote: [
                (0, $cShRs.unwrapExpandStep),
                (0, $6cNnr.wrapMixedContentStep)
            ],
            layoutSection: [
                (0, $cShRs.unwrapExpandStep),
                (0, $6cNnr.wrapMixedContentStep)
            ],
            nestedExpand: [
                (0, $cShRs.unwrapExpandStep),
                (0, $edxij.wrapStep)
            ],
            paragraph: [
                (0, $cShRs.unwrapExpandStep)
            ]
        },
        nestedExpand: {
            panel: [
                (0, $cShRs.unwrapExpandStep),
                (0, $6cNnr.wrapMixedContentStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $cShRs.unwrapExpandStep),
                    (0, $6cNnr.wrapMixedContentStep)
                ]
            } : {},
            blockquote: [
                (0, $cShRs.unwrapExpandStep),
                (0, $6cNnr.wrapMixedContentStep)
            ],
            layoutSection: [
                (0, $cShRs.unwrapExpandStep),
                (0, $6cNnr.wrapMixedContentStep)
            ],
            paragraph: [
                (0, $cShRs.unwrapExpandStep)
            ]
        },
        blockquote: {
            expand: [
                (0, $edxij.wrapStep)
            ],
            nestedExpand: [
                (0, $edxij.wrapStep)
            ],
            layoutSection: [
                (0, $6cNnr.wrapMixedContentStep)
            ],
            panel: [
                (0, $8lpIu.unwrapStep),
                (0, $edxij.wrapStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $8lpIu.unwrapStep),
                    (0, $edxij.wrapStep)
                ]
            } : {},
            paragraph: [
                (0, $8lpIu.unwrapStep)
            ],
            decisionList: [
                (0, $8lpIu.unwrapStep),
                (0, $i4v8d.wrapBlockquoteToDecisionListStep)
            ]
        },
        layoutSection: {
            blockquote: [
                (0, $880Pu.unwrapLayoutStep),
                (0, $6cNnr.wrapMixedContentStep)
            ],
            expand: [
                (0, $880Pu.unwrapLayoutStep),
                (0, $edxij.wrapStep)
            ],
            nestedExpand: [
                (0, $880Pu.unwrapLayoutStep),
                (0, $edxij.wrapStep)
            ],
            panel: [
                (0, $880Pu.unwrapLayoutStep),
                (0, $6cNnr.wrapMixedContentStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $880Pu.unwrapLayoutStep),
                    (0, $6cNnr.wrapMixedContentStep)
                ]
            } : {},
            paragraph: [
                (0, $880Pu.unwrapLayoutStep)
            ]
        },
        codeBlock: {
            blockquote: [
                (0, $edxij.wrapStep)
            ],
            expand: [
                (0, $edxij.wrapStep)
            ],
            nestedExpand: [
                (0, $edxij.wrapStep)
            ],
            layoutSection: [
                (0, $6cNnr.wrapMixedContentStep)
            ],
            panel: [
                (0, $edxij.wrapStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $edxij.wrapStep)
                ]
            } : {},
            paragraph: [
                (0, $eiPUm.applyTargetTextTypeStep)
            ]
        },
        bulletList: {
            orderedList: [
                (0, $jLMlm.listToListStep)
            ],
            taskList: [
                (0, $jLMlm.listToListStep)
            ],
            decisionList: [
                (0, $g742n.flattenListStep),
                (0, $9raHw.listToDecisionListStep)
            ],
            blockquote: [
                (0, $edxij.wrapStep)
            ],
            expand: [
                (0, $edxij.wrapStep)
            ],
            nestedExpand: [
                (0, $edxij.wrapStep)
            ],
            layoutSection: [
                (0, $6cNnr.wrapMixedContentStep)
            ],
            panel: [
                (0, $edxij.wrapStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $edxij.wrapStep)
                ]
            } : {},
            paragraph: [
                (0, $g742n.flattenListStep),
                (0, $6yigg.unwrapListStep),
                (0, $eiPUm.applyTargetTextTypeStep)
            ]
        },
        orderedList: {
            bulletList: [
                (0, $jLMlm.listToListStep)
            ],
            taskList: [
                (0, $jLMlm.listToListStep)
            ],
            decisionList: [
                (0, $g742n.flattenListStep),
                (0, $9raHw.listToDecisionListStep)
            ],
            blockquote: [
                (0, $edxij.wrapStep)
            ],
            expand: [
                (0, $edxij.wrapStep)
            ],
            nestedExpand: [
                (0, $edxij.wrapStep)
            ],
            layoutSection: [
                (0, $6cNnr.wrapMixedContentStep)
            ],
            panel: [
                (0, $edxij.wrapStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $edxij.wrapStep)
                ]
            } : {},
            paragraph: [
                (0, $g742n.flattenListStep),
                (0, $6yigg.unwrapListStep),
                (0, $eiPUm.applyTargetTextTypeStep)
            ]
        },
        taskList: {
            bulletList: [
                (0, $jLMlm.listToListStep)
            ],
            orderedList: [
                (0, $jLMlm.listToListStep)
            ],
            decisionList: [
                (0, $g742n.flattenListStep),
                (0, $9raHw.listToDecisionListStep)
            ],
            expand: [
                (0, $edxij.wrapStep)
            ],
            nestedExpand: [
                (0, $edxij.wrapStep)
            ],
            layoutSection: [
                (0, $6cNnr.wrapMixedContentStep)
            ],
            panel: [
                (0, $edxij.wrapStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $edxij.wrapStep)
                ]
            } : {},
            paragraph: [
                (0, $g742n.flattenListStep),
                (0, $6yigg.unwrapListStep),
                (0, $eiPUm.applyTargetTextTypeStep)
            ]
        },
        table: {
            expand: [
                (0, $edxij.wrapStep)
            ],
            nestedExpand: [
                (0, $edxij.wrapStep)
            ],
            layoutSection: [
                (0, $6cNnr.wrapMixedContentStep)
            ]
        },
        mediaSingle: {
            blockquote: [
                (0, $edxij.wrapStep)
            ],
            expand: [
                (0, $edxij.wrapStep)
            ],
            nestedExpand: [
                (0, $edxij.wrapStep)
            ],
            layoutSection: [
                (0, $6cNnr.wrapMixedContentStep)
            ],
            panel: [
                (0, $edxij.wrapStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $edxij.wrapStep)
                ]
            } : {},
            bulletList: [
                (0, $hZH0W.wrapIntoListStep)
            ],
            orderedList: [
                (0, $hZH0W.wrapIntoListStep)
            ]
        },
        mediaGroup: {
            blockquote: [
                (0, $edxij.wrapStep)
            ],
            expand: [
                (0, $edxij.wrapStep)
            ],
            nestedExpand: [
                (0, $edxij.wrapStep)
            ],
            layoutSection: [
                (0, $6cNnr.wrapMixedContentStep)
            ],
            panel: [
                (0, $edxij.wrapStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $edxij.wrapStep)
                ]
            } : {}
        },
        media: {
            blockquote: [
                (0, $edxij.wrapStep)
            ],
            codeBlock: [
                (0, $edxij.wrapStep)
            ],
            expand: [
                (0, $edxij.wrapStep)
            ],
            nestedExpand: [
                (0, $edxij.wrapStep)
            ],
            layoutSection: [
                (0, $edxij.wrapStep)
            ],
            panel: [
                (0, $edxij.wrapStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $edxij.wrapStep)
                ]
            } : {},
            bulletList: [
                (0, $hZH0W.wrapIntoListStep)
            ],
            orderedList: [
                (0, $hZH0W.wrapIntoListStep)
            ],
            taskList: [
                (0, $hZH0W.wrapIntoListStep)
            ],
            decisionList: [
                (0, $hZH0W.wrapIntoListStep)
            ]
        },
        decisionList: {
            bulletList: [
                (0, $khsPj.decisionListToListStep)
            ],
            orderedList: [
                (0, $khsPj.decisionListToListStep)
            ],
            taskList: [
                (0, $khsPj.decisionListToListStep)
            ],
            blockquote: [
                (0, $6yigg.unwrapListStep),
                (0, $edxij.wrapStep)
            ],
            expand: [
                (0, $edxij.wrapStep)
            ],
            nestedExpand: [
                (0, $edxij.wrapStep)
            ],
            layoutSection: [
                (0, $6cNnr.wrapMixedContentStep)
            ],
            panel: [
                (0, $edxij.wrapStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $edxij.wrapStep)
                ]
            } : {},
            paragraph: [
                (0, $g742n.flattenListStep),
                (0, $6yigg.unwrapListStep),
                (0, $eiPUm.applyTargetTextTypeStep)
            ],
            heading: [
                (0, $g742n.flattenListStep),
                (0, $6yigg.unwrapListStep),
                (0, $eiPUm.applyTargetTextTypeStep)
            ]
        },
        blockCard: {
            expand: [
                (0, $edxij.wrapStep)
            ],
            nestedExpand: [
                (0, $edxij.wrapStep)
            ],
            layoutSection: [
                (0, $6cNnr.wrapMixedContentStep)
            ],
            panel: [
                (0, $edxij.wrapStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $edxij.wrapStep)
                ]
            } : {}
        },
        embedCard: {
            expand: [
                (0, $edxij.wrapStep)
            ],
            nestedExpand: [
                (0, $edxij.wrapStep)
            ],
            layoutSection: [
                (0, $6cNnr.wrapMixedContentStep)
            ]
        },
        extension: {
            blockquote: [
                (0, $edxij.wrapStep)
            ],
            expand: [
                (0, $edxij.wrapStep)
            ],
            nestedExpand: [
                (0, $edxij.wrapStep)
            ],
            layoutSection: [
                (0, $6cNnr.wrapMixedContentStep)
            ],
            panel: [
                (0, $edxij.wrapStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $edxij.wrapStep)
                ]
            } : {}
        },
        bodiedExtension: {
            nestedExpand: [
                (0, $edxij.wrapStep)
            ],
            layoutSection: [
                (0, $6cNnr.wrapMixedContentStep)
            ]
        },
        multiBodiedExtension: {
            blockquote: [
                (0, $edxij.wrapStep)
            ],
            codeBlock: [
                (0, $edxij.wrapStep)
            ],
            expand: [
                (0, $edxij.wrapStep)
            ],
            nestedExpand: [
                (0, $edxij.wrapStep)
            ],
            layoutSection: [
                (0, $edxij.wrapStep)
            ],
            panel: [
                (0, $edxij.wrapStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $edxij.wrapStep)
                ]
            } : {},
            bulletList: [
                (0, $hZH0W.wrapIntoListStep)
            ],
            orderedList: [
                (0, $hZH0W.wrapIntoListStep)
            ],
            taskList: [
                (0, $hZH0W.wrapIntoListStep)
            ],
            decisionList: [
                (0, $hZH0W.wrapIntoListStep)
            ]
        },
        multi: {
            blockquote: [
                (0, $6cNnr.wrapMixedContentStep)
            ],
            codeBlock: [
                (0, $6cNnr.wrapMixedContentStep)
            ],
            expand: [
                (0, $6cNnr.wrapMixedContentStep)
            ],
            nestedExpand: [
                (0, $6cNnr.wrapMixedContentStep)
            ],
            layoutSection: [
                (0, $6cNnr.wrapMixedContentStep)
            ],
            panel: [
                (0, $6cNnr.wrapMixedContentStep)
            ],
            ...includePanelC1 ? {
                panel_c1: [
                    (0, $6cNnr.wrapMixedContentStep)
                ]
            } : {},
            bulletList: [
                (0, $96P9R.convertEachNodeStep),
                (0, $bIBXS.mergeNeighbourListsStep)
            ],
            orderedList: [
                (0, $96P9R.convertEachNodeStep),
                (0, $bIBXS.mergeNeighbourListsStep)
            ],
            taskList: [
                (0, $96P9R.convertEachNodeStep),
                (0, $bIBXS.mergeNeighbourListsStep)
            ],
            decisionList: [
                (0, $96P9R.convertEachNodeStep),
                (0, $bIBXS.mergeNeighbourListsStep)
            ],
            paragraph: [
                (0, $96P9R.convertEachNodeStep)
            ],
            heading: [
                (0, $eiPUm.applyTargetTextTypeStep)
            ]
        }
    });
const $0d573f0d656dcbe1$export$1afd37dec4d41179 = $0d573f0d656dcbe1$var$createTransformationMatrix(false);
const $0d573f0d656dcbe1$export$de222f5888011a02 = $0d573f0d656dcbe1$var$createTransformationMatrix(true);
module.exports["TRANSFORMATION_MATRIX"] = $0d573f0d656dcbe1$export$1afd37dec4d41179;
module.exports["TRANSFORMATION_MATRIX_PANEL_C1"] = $0d573f0d656dcbe1$export$de222f5888011a02;

});

parcelRegister("eiPUm", function(module, exports) {
const $c48062071a09a0d8$export$2765a2ea32feab70 = (nodes, context)=>{
    const { schema: schema, targetNodeTypeName: targetNodeTypeName, targetAttrs: targetAttrs } = context;
    if (targetNodeTypeName !== 'heading' && targetNodeTypeName !== 'paragraph') return nodes;
    const targetType = schema.nodes[targetNodeTypeName];
    if (!targetType) return nodes;
    return nodes.map((node)=>{
        // If codeblock, return nodes as is
        if (targetNodeTypeName === 'heading' && node.type.name === 'codeBlock') return node;
        if (node.isTextblock) {
            // Convert textblock nodes to the target type with content preserved
            let attrs = {};
            if (targetNodeTypeName === 'heading') {
                const level = typeof targetAttrs?.level === 'number' ? targetAttrs.level : 1;
                attrs = {
                    level: level
                };
            }
            // Filter out marks that aren't allowed on paragraph/heading nodes
            // Remove 'breakout' mark when converting to paragraph/heading as these nodes don't support breakout
            const filteredMarks = node.marks.filter((mark)=>{
                // breakout marks should be removed when converting to paragraph or heading
                if (mark.type.name === 'breakout') return false;
                // Keep all other marks (alignment, indentation, etc.)
                return true;
            });
            return targetType.create(attrs, node.content, filteredMarks);
        }
        // Non-textblock nodes are left unchanged
        return node;
    });
};
module.exports["applyTargetTextTypeStep"] = $c48062071a09a0d8$export$2765a2ea32feab70;

});

parcelRegister("96P9R", function(module, exports) {

var $88s8W = parcelRequire("88s8W");

/**
 * Handles the edge case where transforming multi-selection to decisionList results in
 * all content breaking out (no valid children for the target). In this case, creates an empty
 * decisionList to ensure the target type exists.
 *
 * Similar to handleEmptyContainerEdgeCase in wrapMixedContentStep, but specifically for
 * multi-to-decisionList transformations where blockquotes break out.
 *
 * @param result - The current result nodes after processing
 * @param hasCreatedDecisionList - Whether a decisionList was already created during processing
 * @param targetNodeTypeName - The target node type name
 * @param schema - The schema
 * @returns The result nodes with an empty decisionList prepended if needed, or the original result
 */ const $4646e2b9a67b0ffe$var$handleEmptyDecisionListEdgeCase = (result, hasCreatedDecisionList, targetNodeTypeName, schema)=>{
    // Only apply this edge case for decisionList target
    if (targetNodeTypeName !== 'decisionList') return result;
    // If no decisionList was created but we have nodes in result, all content broke out
    const allContentBrokeOut = !hasCreatedDecisionList && result.length > 0;
    if (!allContentBrokeOut) return result;
    // Create an empty decisionList
    const decisionListType = schema.nodes.decisionList;
    const decisionItemType = schema.nodes.decisionItem;
    if (decisionListType && decisionItemType) {
        const emptyDecisionItem = decisionItemType.createAndFill();
        if (emptyDecisionItem) {
            const emptyDecisionList = decisionListType.createAndFill({}, [
                emptyDecisionItem
            ]);
            if (emptyDecisionList) return [
                emptyDecisionList,
                ...result
            ];
        }
    }
    return result;
};
const $4646e2b9a67b0ffe$export$ec839c7f5e301db8 = (nodes, context)=>{
    const { schema: schema, targetNodeTypeName: targetNodeTypeName, targetAttrs: targetAttrs } = context;
    const targetNodeType = schema.nodes[targetNodeTypeName];
    if (!targetNodeType) return nodes;
    const blockquoteType = schema.nodes.blockquote;
    const resultNodes = [];
    let hasCreatedDecisionList = false;
    for (const node of nodes){
        // Edge case: blockquotes should break out when transforming to decisionList
        if (targetNodeTypeName === 'decisionList' && blockquoteType && node.type === blockquoteType) {
            resultNodes.push(node);
            continue;
        }
        const transformedNodes = (0, $88s8W.convertNodesToTargetType)({
            sourceNodes: [
                node
            ],
            targetNodeType: targetNodeType,
            schema: schema,
            isNested: false,
            targetAttrs: targetAttrs
        });
        if (transformedNodes.length > 0) {
            resultNodes.push(...transformedNodes);
            // Track if we created a decisionList
            if (targetNodeTypeName === 'decisionList' && transformedNodes.some((n)=>n.type === targetNodeType)) hasCreatedDecisionList = true;
        } else resultNodes.push(node);
    }
    // Handle edge case: if no decisionList was created, create an empty one
    const finalResult = $4646e2b9a67b0ffe$var$handleEmptyDecisionListEdgeCase(resultNodes, hasCreatedDecisionList, targetNodeTypeName, schema);
    return finalResult;
};
module.exports["convertEachNodeStep"] = $4646e2b9a67b0ffe$export$ec839c7f5e301db8;

});

parcelRegister("khsPj", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");

const $59550e551c2a7a06$var$targets = (targetNodeTypeName, schema)=>{
    let targetListType;
    let targetItemType;
    switch(targetNodeTypeName){
        case 'bulletList':
            targetListType = schema.nodes.bulletList;
            targetItemType = schema.nodes.listItem;
            break;
        case 'orderedList':
            targetListType = schema.nodes.orderedList;
            targetItemType = schema.nodes.listItem;
            break;
        case 'taskList':
            targetListType = schema.nodes.taskList;
            targetItemType = schema.nodes.taskItem;
            break;
        default:
    }
    return {
        targetListType: targetListType,
        targetItemType: targetItemType
    };
};
const $59550e551c2a7a06$export$6d5588752dacfe72 = (nodes, context)=>{
    const { schema: schema, targetNodeTypeName: targetNodeTypeName } = context;
    const paragraphType = schema.nodes.paragraph;
    return nodes.map((node)=>{
        if (node.type !== schema.nodes.decisionList) return node;
        const { targetListType: targetListType, targetItemType: targetItemType } = $59550e551c2a7a06$var$targets(targetNodeTypeName, schema);
        if (!targetListType || !targetItemType) return node;
        const newItems = [];
        node.forEach((decisionItem)=>{
            const newItem = targetItemType.inlineContent ? targetItemType.create({}, decisionItem.children) : targetItemType.create({}, paragraphType.create({}, decisionItem.children));
            if (newItem) newItems.push(newItem);
        });
        const newList = targetListType.create({}, (0, $aPdNQ.Fragment).from(newItems));
        return newList || node;
    });
};
module.exports["decisionListToListStep"] = $59550e551c2a7a06$export$6d5588752dacfe72;

});

parcelRegister("g742n", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");


var $27Ysc = parcelRequire("27Ysc");

const $ce76caf8dc173b8c$var$extractNestedLists = (node, schema)=>{
    const items = [];
    const paragraph = schema.nodes.paragraph;
    const itemTypes = [
        schema.nodes.listItem,
        schema.nodes.taskItem,
        schema.nodes.decisionItem
    ];
    const extract = (currentNode)=>{
        currentNode.forEach((child)=>{
            if (itemTypes.some((type)=>child.type === type)) {
                const contentWithoutNestedLists = [];
                const nestedLists = [];
                // Check if this item type expects inline content (taskItem, decisionItem)
                // vs block content (listItem) based on the schema definition
                const isInlineItem = child.type.inlineContent;
                child.forEach((grandChild)=>{
                    if ((0, $27Ysc.isListWithIndentation)(grandChild.type.name, schema)) nestedLists.push(grandChild);
                    else if (grandChild.isInline) {
                        // For taskItem/decisionItem, keep text as-is (they support inline content)
                        // For listItem, wrap text in paragraph (they require block content)
                        if (isInlineItem) contentWithoutNestedLists.push(grandChild);
                        else contentWithoutNestedLists.push(paragraph.createAndFill({}, grandChild));
                    } else contentWithoutNestedLists.push(grandChild);
                });
                items.push(child.copy((0, $aPdNQ.Fragment).from(contentWithoutNestedLists)));
                nestedLists.forEach((nestedList)=>{
                    extract(nestedList);
                });
            } else if ((0, $27Ysc.isListWithIndentation)(child.type.name, schema)) extract(child);
        });
    };
    extract(node);
    return items;
};
const $ce76caf8dc173b8c$export$74774d2fcc242aef = (nodes, context)=>{
    return nodes.map((node)=>{
        if ((0, $27Ysc.isListWithIndentation)(node.type.name, context.schema)) return node.copy((0, $aPdNQ.Fragment).from($ce76caf8dc173b8c$var$extractNestedLists(node, context.schema)));
        return node;
    });
};
module.exports["flattenListStep"] = $ce76caf8dc173b8c$export$74774d2fcc242aef;

});

parcelRegister("27Ysc", function(module, exports) {
const $b4f5bf1865454704$export$a821b73688083c0 = (nodeTypeName, schema)=>{
    const lists = [
        schema.nodes.taskList,
        schema.nodes.bulletList,
        schema.nodes.orderedList
    ];
    return lists.some((list)=>list.name === nodeTypeName);
};
const $b4f5bf1865454704$export$21440f5b448ca9f3 = (nodeTypeName, schema)=>{
    const lists = [
        schema.nodes.taskList,
        schema.nodes.decisionList
    ];
    return lists.some((list)=>list.name === nodeTypeName);
};
module.exports["isListWithIndentation"] = $b4f5bf1865454704$export$a821b73688083c0;
module.exports["isListWithTextContentOnly"] = $b4f5bf1865454704$export$21440f5b448ca9f3;

});

parcelRegister("2ZTDz", function(module, exports) {
const $4d0fe81319c2510c$export$2d058988e0d92b68 = (nodes, context)=>{
    const { schema: schema, targetNodeTypeName: targetNodeTypeName } = context;
    const { paragraph: paragraph } = schema.nodes;
    const targetNodeType = schema.nodes[targetNodeTypeName];
    if (!targetNodeType || !paragraph) return nodes;
    return nodes.map((node)=>{
        const isValidWithin = targetNodeType.validContent(node.content);
        if (!isValidWithin) return node;
        return paragraph.create({}, node.content, node.marks);
    });
};
module.exports["flattenStep"] = $4d0fe81319c2510c$export$2d058988e0d92b68;

});

parcelRegister("9raHw", function(module, exports) {

var $27Ysc = parcelRequire("27Ysc");

const $43e83a97d3438b11$export$e95e25b492330619 = (nodes, context)=>{
    const { schema: schema } = context;
    const paragraphType = schema.nodes.paragraph;
    const unsupportedContent = [];
    const transformedNodes = nodes.map((node)=>{
        if (!(0, $27Ysc.isListWithIndentation)(node.type.name, schema)) return node;
        const decisionItems = [];
        node.forEach((item)=>{
            const itemContent = [];
            item.forEach((child)=>{
                if (child.type === paragraphType) // paragraph may contain hard breaks etc.
                itemContent.push(...child.children);
                else if (child.isInline) itemContent.push(child);
                else if (!(0, $27Ysc.isListWithIndentation)(child.type.name, schema)) unsupportedContent.push(child);
            });
            const decisionItem = schema.nodes.decisionItem.create({}, itemContent);
            decisionItems.push(decisionItem);
        });
        const decisionList = schema.nodes.decisionList.create({}, decisionItems);
        return decisionList || node;
    });
    return [
        ...transformedNodes,
        ...unsupportedContent
    ];
};
module.exports["listToDecisionListStep"] = $43e83a97d3438b11$export$e95e25b492330619;

});

parcelRegister("jLMlm", function(module, exports) {

var $kPKLu = parcelRequire("kPKLu");


var $aPdNQ = parcelRequire("aPdNQ");


var $ieeJu = parcelRequire("ieeJu");


var $27Ysc = parcelRequire("27Ysc");

/**
 * Recursively converts nested lists to the target list type.
 * This function handles the conversion of both the list container and its items,
 * including any nested lists within those items.
 *
 * Important: taskList has a different nesting structure than bulletList/orderedList:
 * - taskList: nested taskLists are SIBLINGS of taskItems in the parent taskList
 * - bulletList/orderedList: nested lists are CHILDREN of listItems
 */ const $5aea90c0537bdc2f$var$transformList = (node, targetListType, targetItemType, unsupportedContent)=>{
    const schema = node.type.schema;
    const taskListType = schema.nodes.taskList;
    const isSourceTaskList = node.type === taskListType;
    const isTargetTaskList = targetListType === taskListType.name;
    const convertFromTaskListStructure = (node, targetListType, targetItemType)=>{
        const schema = node.type.schema;
        const targetListNodeType = schema.nodes[targetListType];
        const transformedContent = [];
        node.forEach((child)=>{
            if ((0, $27Ysc.isListWithIndentation)(child.type.name, schema)) // This is a nested list - it should become a child of the previous item
            {
                if (transformedContent.length > 0) {
                    const previousItem = transformedContent[transformedContent.length - 1];
                    // Convert the nested list and add it to the previous item's content
                    const transformedNestedList = $5aea90c0537bdc2f$var$transformList(child, targetListType, targetItemType, unsupportedContent);
                    const newContent = previousItem.content.append((0, $aPdNQ.Fragment).from([
                        transformedNestedList
                    ]));
                    const updatedItem = previousItem.type.create(previousItem.attrs, newContent);
                    transformedContent[transformedContent.length - 1] = updatedItem;
                }
            } else {
                const transformedItem = transformListItem(child, targetListType, targetItemType);
                if (transformedItem) transformedContent.push(transformedItem);
            }
        });
        return targetListNodeType.create(node.attrs, transformedContent);
    };
    const convertToTaskListStructure = (node, targetListType, targetItemType)=>{
        const schema = node.type.schema;
        const targetListNodeType = schema.nodes[targetListType];
        const transformedContent = [];
        node.forEach((itemNode)=>{
            const transformedItem = transformListItem(itemNode, targetListType, targetItemType, true);
            if (transformedItem) transformedContent.push(transformedItem);
            itemNode.forEach((child)=>{
                if ((0, $27Ysc.isListWithIndentation)(child.type.name, schema)) transformedContent.push($5aea90c0537bdc2f$var$transformList(child, targetListType, targetItemType, unsupportedContent));
            });
        });
        return targetListNodeType.create(node.attrs, transformedContent);
    };
    const transformListItem = (itemNode, targetListType, targetItemType, excludeNestedLists = false)=>{
        const schema = itemNode.type.schema;
        const targetItemNodeType = schema.nodes[targetItemType];
        const isTargetTaskItem = targetItemType === 'taskItem';
        const isSourceTaskItem = itemNode.type.name === 'taskItem';
        const paragraphType = schema.nodes.paragraph;
        if (isTargetTaskItem) {
            const inlineContent = [];
            let blockMarks = itemNode.marks;
            itemNode.forEach((child)=>{
                if (child.type === paragraphType) {
                    inlineContent.push(...child.children);
                    if (child.marks.length > 0) blockMarks = child.marks;
                } else if (child.isInline) inlineContent.push(child);
                else if (!(0, $27Ysc.isListWithIndentation)(child.type.name, schema)) unsupportedContent.push(child);
            });
            const { blockTaskItem: blockTaskItem } = schema.nodes;
            if (blockTaskItem && blockMarks.length > 0 && (0, $ieeJu.expValEquals)('platform_editor_small_font_size', 'isEnabled', true)) return (0, $kPKLu.createBlockTaskItem)({
                content: inlineContent,
                marks: blockMarks,
                schema: schema
            });
            return targetItemNodeType.create({}, inlineContent);
        }
        const transformedContent = [];
        if (isSourceTaskItem) transformedContent.push(paragraphType.create(null, itemNode.content));
        else itemNode.forEach((child)=>{
            if ((0, $27Ysc.isListWithIndentation)(child.type.name, schema)) {
                if (excludeNestedLists) // Skip nested lists - they will be handled separately as siblings
                return;
                transformedContent.push($5aea90c0537bdc2f$var$transformList(child, targetListType, targetItemType, unsupportedContent));
            } else transformedContent.push(child);
        });
        if (transformedContent.length === 0) transformedContent.push(paragraphType.create());
        return targetItemNodeType.create({}, transformedContent);
    };
    const convertList = (node, schema, targetListType, targetItemType)=>{
        const targetListNodeType = schema.nodes[targetListType];
        const transformedContent = [];
        node.forEach((childNode)=>{
            const transformedItem = (0, $27Ysc.isListWithIndentation)(childNode.type.name, schema) ? $5aea90c0537bdc2f$var$transformList(childNode, targetListType, targetItemType, unsupportedContent) : transformListItem(childNode, targetListType, targetItemType);
            if (transformedItem) transformedContent.push(transformedItem);
        });
        return targetListNodeType.create(node.attrs, transformedContent);
    };
    if (isSourceTaskList && !isTargetTaskList) return convertFromTaskListStructure(node, targetListType, targetItemType);
    else if (!isSourceTaskList && isTargetTaskList) return convertToTaskListStructure(node, targetListType, targetItemType);
    return convertList(node, schema, targetListType, targetItemType);
};
const $5aea90c0537bdc2f$export$46abc3e1699028ef = (nodes, context)=>{
    const { schema: schema, targetNodeTypeName: targetNodeTypeName } = context;
    const unsupportedContent = [];
    const transformedNodes = nodes.map((node)=>{
        if ((0, $27Ysc.isListWithIndentation)(node.type.name, schema)) {
            const targetItemType = targetNodeTypeName === 'taskList' ? 'taskItem' : 'listItem';
            return $5aea90c0537bdc2f$var$transformList(node, targetNodeTypeName, targetItemType, unsupportedContent);
        }
        return node;
    });
    return [
        ...transformedNodes,
        ...unsupportedContent
    ];
};
module.exports["listToListStep"] = $5aea90c0537bdc2f$export$46abc3e1699028ef;

});

parcelRegister("bIBXS", function(module, exports) {

var $27Ysc = parcelRequire("27Ysc");

const $d064be4d13331499$export$6dc131b629e53cb8 = (nodes, context)=>{
    if (nodes.length === 0) return nodes;
    const { schema: schema } = context;
    const resultNodes = [];
    let currentList = null;
    // Check if a node is any type of list (including decisionList)
    const isList = (node)=>{
        return (0, $27Ysc.isListWithIndentation)(node.type.name, schema) || node.type.name === 'decisionList';
    };
    for (const node of nodes)// Check if this node is any type of list
    if (isList(node)) {
        if (currentList && currentList.type === node.type) {
            // Merge with the current list by combining their children
            const mergedContent = currentList.content.append(node.content);
            currentList = currentList.type.create(currentList.attrs, mergedContent);
        } else {
            // Start a new list or switch to a different list type
            if (currentList) resultNodes.push(currentList);
            currentList = node;
        }
    } else {
        // Non-list node - push any accumulated list and then this node
        if (currentList) {
            resultNodes.push(currentList);
            currentList = null;
        }
        resultNodes.push(node);
    }
    // Don't forget the last list if we ended with one
    if (currentList) resultNodes.push(currentList);
    return resultNodes;
};
module.exports["mergeNeighbourListsStep"] = $d064be4d13331499$export$6dc131b629e53cb8;

});

parcelRegister("cShRs", function(module, exports) {

var $gnxj8 = parcelRequire("gnxj8");


var $8lpIu = parcelRequire("8lpIu");

const $99d18c3723b196d4$export$c0de2fe9771a255e = (nodes, context)=>{
    const { schema: schema } = context;
    const outputNodes = [];
    const { expand: expand, nestedExpand: nestedExpand } = schema.nodes;
    nodes.forEach((node)=>{
        const isExpand = node.type.name === expand.name || node.type.name === nestedExpand.name;
        if (isExpand) {
            const title = node.attrs?.title;
            // Create a paragraph from the title if it exists
            if (title) {
                const titleParagraph = schema.nodes.paragraph.createAndFill({}, schema.text(title));
                if (titleParagraph) outputNodes.push(titleParagraph);
            }
            // Add the children, converting any nestedExpands to regular expands
            // since nestedExpand can only exist inside an expand
            node.children.forEach((child)=>{
                if (child.type.name === nestedExpand.name) {
                    const expandNode = (0, $gnxj8.convertNestedExpandToExpand)(child, schema);
                    if (expandNode) outputNodes.push(expandNode);
                    else outputNodes.push(child);
                } else outputNodes.push(child);
            });
        } else (0, $8lpIu.unwrapStep)([
            node
        ], context);
    });
    return outputNodes;
};
module.exports["unwrapExpandStep"] = $99d18c3723b196d4$export$c0de2fe9771a255e;

});

parcelRegister("8lpIu", function(module, exports) {
const $8e053fff72575c23$export$7583c29c75ec1903 = (nodes)=>{
    const outputNodes = [];
    nodes.forEach((node)=>{
        // we may want to just skip the original instead of using it
        if (node.children.length === 0) outputNodes.push(node);
        else outputNodes.push(...node.children);
    });
    return outputNodes;
};
module.exports["unwrapStep"] = $8e053fff72575c23$export$7583c29c75ec1903;

});

parcelRegister("880Pu", function(module, exports) {
const $da7b5e592ac9298d$export$54edaa1aeed2418a = (nodes)=>{
    const outputNodes = [];
    nodes.forEach((node)=>{
        const isLayoutSection = node.type.name === 'layoutSection';
        if (isLayoutSection) node.children.forEach((column)=>{
            const isLayoutColumn = column.type.name === 'layoutColumn';
            if (isLayoutColumn) outputNodes.push(...column.children);
        });
    });
    if (outputNodes.length === 0) return nodes;
    return outputNodes;
};
module.exports["unwrapLayoutStep"] = $da7b5e592ac9298d$export$54edaa1aeed2418a;

});

parcelRegister("6yigg", function(module, exports) {
const $51fe44223ee741e2$export$503819a1224039d8 = (nodes, context)=>{
    const listTypes = [
        context.schema.nodes.bulletList,
        context.schema.nodes.orderedList,
        context.schema.nodes.taskList,
        context.schema.nodes.decisionList
    ];
    return nodes.flatMap((node)=>{
        if (listTypes.some((type)=>node.type === type)) {
            const listItems = [];
            node.forEach((listItem)=>{
                // if isTaskItem or isDecisionItem, convert to paragraph
                if (listItem.type.name === 'taskItem' || listItem.type.name === 'decisionItem') listItems.push(context.schema.nodes.paragraph.create({}, listItem.content));
                else listItems.push(...listItem.children);
            });
            return listItems;
        }
        return node;
    });
};
module.exports["unwrapListStep"] = $51fe44223ee741e2$export$503819a1224039d8;

});

parcelRegister("i4v8d", function(module, exports) {

var $gnxj8 = parcelRequire("gnxj8");

/**
 * Creates a decisionItem with the given inline content.
 */ const $6c619f940ee3c5a1$var$createDecisionItem = (inlineContent, schema)=>{
    const decisionItemType = schema.nodes.decisionItem;
    if (!decisionItemType) return null;
    const canContentBeWrappedInDecisionItem = decisionItemType.validContent(inlineContent);
    // Check if the content is valid for decisionItem
    if (!canContentBeWrappedInDecisionItem) return null;
    return decisionItemType.createAndFill({}, inlineContent);
};
/**
 * Creates a decisionList containing the given decisionItems.
 */ const $6c619f940ee3c5a1$var$createDecisionListWithItems = (decisionItems, schema)=>{
    const decisionListType = schema.nodes.decisionList;
    if (!decisionListType || decisionItems.length === 0) return null;
    return decisionListType.createAndFill({}, decisionItems);
};
const $6c619f940ee3c5a1$export$90c0437e8a9cfef9 = (nodes, context)=>{
    const { schema: schema } = context;
    const decisionItemType = schema.nodes.decisionItem;
    if (!decisionItemType) return nodes;
    const result = [];
    let currentDecisionItems = [];
    const flushCurrentDecisionList = ()=>{
        if (currentDecisionItems.length > 0) {
            const decisionList = $6c619f940ee3c5a1$var$createDecisionListWithItems(currentDecisionItems, schema);
            if (decisionList) result.push(decisionList);
            currentDecisionItems = [];
        }
    };
    nodes.forEach((node)=>{
        const decisionItem = (0, $gnxj8.isTextNode)(node) ? $6c619f940ee3c5a1$var$createDecisionItem(node.content, schema) : null;
        if (decisionItem) // Accumulate consecutive decisionItems
        currentDecisionItems.push(decisionItem);
        else {
            // Content can't be wrapped in decisionItem - break out the node
            flushCurrentDecisionList();
            result.push(node);
        }
    });
    // Flush any remaining decisionItems
    flushCurrentDecisionList();
    return result.length > 0 ? result : nodes;
};
module.exports["wrapBlockquoteToDecisionListStep"] = $6c619f940ee3c5a1$export$90c0437e8a9cfef9;

});

parcelRegister("hZH0W", function(module, exports) {

var $27Ysc = parcelRequire("27Ysc");


var $gnxj8 = parcelRequire("gnxj8");

const $160e50d9d5725b99$var$wrapIntoTaskOrDecisionList = (nodes, targetNodeTypeName, schema)=>{
    const itemNodeType = targetNodeTypeName === 'taskList' ? schema.nodes.taskItem : schema.nodes.decisionItem;
    const inlineContent = nodes.flatMap((node)=>{
        if (node.isTextblock) return node.children;
        else if (node.isText) return [
            node
        ];
        return [];
    });
    const itemNode = itemNodeType.create({}, inlineContent);
    const outputNode = schema.nodes[targetNodeTypeName].createAndFill({}, itemNode);
    return outputNode ? [
        outputNode
    ] : nodes;
};
const $160e50d9d5725b99$var$wrapIntoBulletOrOrderedList = (nodes, targetNodeTypeName, schema)=>{
    const listItemNodes = nodes.map((node)=>schema.nodes.listItem.createAndFill({}, node.isTextblock ? (0, $gnxj8.convertTextNodeToParagraph)(node, schema) : node)).filter((node)=>node !== null);
    if (listItemNodes.length === 0) return nodes;
    const outputNode = schema.nodes[targetNodeTypeName].createAndFill({}, listItemNodes);
    return outputNode ? [
        outputNode
    ] : nodes;
};
const $160e50d9d5725b99$export$d3906b3c22029af7 = (nodes, context)=>{
    const { schema: schema, targetNodeTypeName: targetNodeTypeName } = context;
    return (0, $27Ysc.isListWithTextContentOnly)(targetNodeTypeName, schema) ? $160e50d9d5725b99$var$wrapIntoTaskOrDecisionList(nodes, targetNodeTypeName, schema) : $160e50d9d5725b99$var$wrapIntoBulletOrOrderedList(nodes, targetNodeTypeName, schema);
};
module.exports["wrapIntoListStep"] = $160e50d9d5725b99$export$d3906b3c22029af7;

});

parcelRegister("6cNnr", function(module, exports) {

var $6gBg9 = parcelRequire("6gBg9");


var $hy0gD = parcelRequire("hy0gD");


var $aPdNQ = parcelRequire("aPdNQ");


var $ieeJu = parcelRequire("ieeJu");


var $lDzT5 = parcelRequire("lDzT5");


var $jbhmw = parcelRequire("jbhmw");


var $gnxj8 = parcelRequire("gnxj8");

/**
 * Creates a layout section with two columns, where the first column contains the provided content.
 * Preserves breakout marks if provided.
 */ const $608f6f6247f553b2$var$createLayoutSection = (content, layoutSection, layoutColumn, marks)=>{
    const columnOne = layoutColumn.createAndFill({}, (0, $lDzT5.removeDisallowedMarks)(content, layoutColumn));
    const columnTwo = layoutColumn.createAndFill();
    if (!columnOne || !columnTwo) return null;
    return layoutSection.createAndFill({}, [
        columnOne,
        columnTwo
    ], marks);
};
/**
 * Creates a container with text content (for codeblocks).
 */ const $608f6f6247f553b2$var$createTextContentContainer = (textContentArray, targetNodeType, schema)=>{
    const textContent = textContentArray.join('\n');
    const textNode = textContent ? schema.text(textContent) : null;
    const attrs = targetNodeType.name === 'codeBlock' ? (0, $6gBg9.getDefaultCodeBlockAttrs)() : {};
    return targetNodeType.createAndFill(attrs, textNode);
};
/**
 * Creates a regular container with node content.
 */ const $608f6f6247f553b2$var$createNodeContentContainer = (nodeContent, targetNodeType)=>{
    const isExpandType = targetNodeType.name === 'expand' || targetNodeType.name === 'nestedExpand';
    const nodeAttrs = isExpandType ? {
        localId: crypto.randomUUID()
    } : {};
    return targetNodeType.createAndFill(nodeAttrs, nodeContent);
};
/**
 * Handles the edge case where transforming from a container to another container results in
 * all content breaking out (no valid children for the target). In this case, creates an empty
 * container to ensure the target container type is created.
 *
 * We can determine if there were no valid children by checking if no container was created
 * (`!hasCreatedContainer`) and there are nodes in the result (`result.length > 0`), which
 * means all content broke out rather than being wrapped.
 *
 * @param result - The current result nodes after processing
 * @param hasCreatedContainer - Whether a container was already created during processing
 * @param fromNode - The original source node (before unwrapping)
 * @param targetNodeType - The target container type
 * @param targetNodeTypeName - The target container type name
 * @param schema - The schema
 * @returns The result nodes with an empty container prepended if needed, or the original result
 */ const $608f6f6247f553b2$var$handleEmptyContainerEdgeCase = (result, hasCreatedContainer, fromNode, targetNodeType, targetNodeTypeName, schema)=>{
    const isFromContainer = (0, $jbhmw.NODE_CATEGORY_BY_TYPE)[fromNode.type.name] === 'container';
    const isTargetContainer = (0, $jbhmw.NODE_CATEGORY_BY_TYPE)[targetNodeTypeName] === 'container';
    // If no container was created but we have nodes in result, all content broke out
    // (meaning there were no valid children that could be wrapped)
    const allContentBrokeOut = !hasCreatedContainer && result.length > 0;
    const shouldCreateEmptyTarget = isFromContainer && isTargetContainer && allContentBrokeOut;
    if (!shouldCreateEmptyTarget) return result;
    if (targetNodeTypeName === schema.nodes.codeBlock.name) {
        const emptyCodeBlock = $608f6f6247f553b2$var$createTextContentContainer([], schema.nodes.codeBlock, schema);
        return emptyCodeBlock ? [
            emptyCodeBlock,
            ...result
        ] : result;
    }
    const emptyParagraph = schema.nodes.paragraph.create();
    const isExpandType = targetNodeTypeName === 'expand' || targetNodeTypeName === 'nestedExpand';
    const emptyContainerAttrs = isExpandType ? {
        localId: crypto.randomUUID()
    } : {};
    const emptyContainer = targetNodeType.create(emptyContainerAttrs, emptyParagraph);
    return [
        emptyContainer,
        ...result
    ];
};
const $608f6f6247f553b2$export$46a3aa15af7139ee = (nodes, context)=>{
    const { schema: schema, targetNodeTypeName: targetNodeTypeName, fromNode: fromNode } = context;
    const targetNodeType = schema.nodes[targetNodeTypeName];
    if (!targetNodeType) return nodes;
    const isLayout = targetNodeTypeName === 'layoutSection';
    const isCodeblock = targetNodeTypeName === 'codeBlock';
    const { layoutSection: layoutSection, layoutColumn: layoutColumn } = schema.nodes;
    // platform_editor_lovability_resize_dividers_panels supports breakout resizing on panels and rules,
    // but rule is NOT a supported transform source/target
    const breakoutResizableNodesList = (0, $ieeJu.expValEquals)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true) ? [
        ...(0, $hy0gD.breakoutResizableNodes),
        'panel'
    ] : (0, $hy0gD.breakoutResizableNodes);
    const sourceSupportsBreakout = breakoutResizableNodesList.includes(fromNode.type.name);
    const targetSupportsBreakout = breakoutResizableNodesList.includes(targetNodeTypeName);
    const shouldPreserveBreakout = sourceSupportsBreakout && targetSupportsBreakout;
    let breakoutMark;
    if (shouldPreserveBreakout) breakoutMark = fromNode.marks.find((mark)=>mark.type.name === 'breakout');
    const result = [];
    let currentContainerContent = [];
    let hasCreatedContainer = false;
    const flushCurrentContainer = ()=>{
        if (currentContainerContent.length === 0) return;
        let container = null;
        if (isLayout) container = $608f6f6247f553b2$var$createLayoutSection(currentContainerContent, layoutSection, layoutColumn, breakoutMark ? [
            breakoutMark
        ] : undefined);
        else if (isCodeblock) container = $608f6f6247f553b2$var$createTextContentContainer(currentContainerContent, targetNodeType, schema);
        else container = $608f6f6247f553b2$var$createNodeContentContainer(currentContainerContent, targetNodeType);
        if (container) {
            result.push(container);
            hasCreatedContainer = true;
        }
        currentContainerContent = [];
    };
    const canNodeBeWrapped = (node)=>{
        const validationType = isLayout ? layoutColumn : targetNodeType;
        return validationType.validContent((0, $aPdNQ.Fragment).from((0, $lDzT5.removeDisallowedMarks)([
            node
        ], validationType)));
    };
    const handleWrappableNode = (node)=>{
        const validationType = isLayout ? layoutColumn : targetNodeType;
        currentContainerContent.push(...(0, $lDzT5.removeDisallowedMarks)([
            node
        ], validationType));
    };
    const handleCodeblockTextNode = (node)=>{
        currentContainerContent.push((0, $gnxj8.createTextContent)(node));
    };
    const handleConvertibleTextNode = (node)=>{
        const paragraph = (0, $gnxj8.convertTextNodeToParagraph)(node, schema);
        if (paragraph) currentContainerContent.push(paragraph);
    };
    const handleUnsupportedNode = (node)=>{
        flushCurrentContainer();
        result.push(node);
    };
    const processNode = (node)=>{
        if (canNodeBeWrapped(node)) {
            handleWrappableNode(node);
            return;
        }
        if ((0, $gnxj8.isTextNode)(node) && isCodeblock) {
            handleCodeblockTextNode(node);
            return;
        }
        if ((0, $gnxj8.isTextNode)(node)) {
            handleConvertibleTextNode(node);
            return;
        }
        // All other nodes that cannot be wrapped in the target node - break out
        // Examples: same-type containers, layoutSections in layouts
        handleUnsupportedNode(node);
    };
    nodes.forEach(processNode);
    flushCurrentContainer();
    if (isLayout) return result.length > 0 ? result : nodes;
    const finalResult = $608f6f6247f553b2$var$handleEmptyContainerEdgeCase(result, hasCreatedContainer, fromNode, targetNodeType, targetNodeTypeName, schema);
    return finalResult.length > 0 ? finalResult : nodes;
};
module.exports["wrapMixedContentStep"] = $608f6f6247f553b2$export$46a3aa15af7139ee;

});

parcelRegister("lDzT5", function(module, exports) {
const $fdc34db32699d5a8$export$1b4937b79128e5f7 = (nodes, targetNode)=>{
    return nodes.map((node)=>node.mark(targetNode.allowedMarks(node.marks)));
};
module.exports["removeDisallowedMarks"] = $fdc34db32699d5a8$export$1b4937b79128e5f7;

});

parcelRegister("edxij", function(module, exports) {

var $6gBg9 = parcelRequire("6gBg9");


var $hy0gD = parcelRequire("hy0gD");


var $ieeJu = parcelRequire("ieeJu");


var $lDzT5 = parcelRequire("lDzT5");


var $gnxj8 = parcelRequire("gnxj8");

const $c6901635313937a0$export$4465c5391021ef03 = (nodes, context)=>{
    const { schema: schema, targetNodeTypeName: targetNodeTypeName, fromNode: fromNode } = context;
    // When wrapping into expand, convert any expand children to nestedExpand
    // since expand cannot be a direct child of expand
    let processedNodes = nodes;
    if (targetNodeTypeName === 'expand') processedNodes = nodes.map((node)=>{
        if (node.type.name === 'expand') {
            const nestedExpandNode = (0, $gnxj8.convertExpandToNestedExpand)(node, schema);
            return nestedExpandNode ?? node;
        }
        return node;
    });
    const targetNodeType = schema.nodes[targetNodeTypeName];
    const isExpandType = targetNodeTypeName === 'expand' || targetNodeTypeName === 'nestedExpand';
    const isCodeBlock = targetNodeTypeName === 'codeBlock';
    const nodeAttrs = isExpandType ? {
        localId: crypto.randomUUID()
    } : isCodeBlock ? (0, $6gBg9.getDefaultCodeBlockAttrs)() : {};
    // platform_editor_lovability_resize_dividers_panels supports breakout resizing on panels and rules,
    // but rule is NOT a supported transform source/target
    const breakoutResizableNodesList = (0, $ieeJu.expValEquals)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true) ? [
        ...(0, $hy0gD.breakoutResizableNodes),
        'panel'
    ] : (0, $hy0gD.breakoutResizableNodes);
    const sourceSupportsBreakout = breakoutResizableNodesList.includes(fromNode.type.name);
    const targetSupportsBreakout = breakoutResizableNodesList.includes(targetNodeType.name);
    const shouldPreserveBreakout = sourceSupportsBreakout && targetSupportsBreakout;
    let marks;
    if (shouldPreserveBreakout) {
        const breakoutMark = fromNode.marks.find((mark)=>mark.type.name === 'breakout');
        if (breakoutMark) marks = [
            breakoutMark
        ];
    }
    const outputNode = targetNodeType.createAndFill(nodeAttrs, (0, $lDzT5.removeDisallowedMarks)(processedNodes, schema.nodes[targetNodeTypeName]), marks);
    return outputNode ? [
        outputNode
    ] : nodes;
};
module.exports["wrapStep"] = $c6901635313937a0$export$4465c5391021ef03;

});

parcelRegister("d59RG", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $8QOo3 = parcelRequire("8QOo3");


var $jv11C = parcelRequire("jv11C");


var $hiQdW = parcelRequire("hiQdW");


var $lVAkE = parcelRequire("lVAkE");


var $kCECX = parcelRequire("kCECX");


var $eOaGc = parcelRequire("eOaGc");


var $8HW7o = parcelRequire("8HW7o");


var $rtnjh = parcelRequire("rtnjh");


var $88s8W = parcelRequire("88s8W");


var $gnxj8 = parcelRequire("gnxj8");

const $a42e6573958261d0$export$eb9a5497877a817a = (api)=>(targetType, metadata)=>({ tr: tr })=>{
            const preservedSelection = api?.blockControls?.sharedState.currentState()?.preservedSelection;
            if (!preservedSelection) return tr;
            const measureId = `transformNode_${targetType.name}_${Date.now()}`;
            (0, $hiQdW.startMeasure)(measureId);
            const { nodes: nodes } = tr.doc.type.schema;
            const { $from: $from, $to: $to } = (0, $lVAkE.expandSelectionToBlockRange)(preservedSelection);
            const selectedParent = $from.parent;
            const isParentLayout = selectedParent.type === nodes.layoutColumn;
            const isNested = (0, $rtnjh.isNestedNode)(preservedSelection, '') && !isParentLayout;
            const isList = (0, $gnxj8.isListNode)(selectedParent);
            const sourceNodes = (0, $lVAkE.getSourceNodesFromSelectionRange)(tr, preservedSelection);
            const sourceNodeTypes = {};
            sourceNodes.forEach((node)=>{
                const typeName = node.type.name;
                sourceNodeTypes[typeName] = (sourceNodeTypes[typeName] || 0) + 1;
            });
            // Check if source node is empty paragraph or heading
            const isEmptyLine = sourceNodes.length === 1 && (sourceNodes[0].type === nodes.paragraph || sourceNodes[0].type === nodes.heading) && (sourceNodes[0].content.size === 0 || sourceNodes[0].textContent.trim() === '');
            const isSuggested = Boolean(metadata?.isSuggested);
            try {
                const resultNodes = (0, $88s8W.convertNodesToTargetType)({
                    sourceNodes: sourceNodes,
                    targetNodeType: targetType,
                    schema: tr.doc.type.schema,
                    isNested: isNested,
                    targetAttrs: metadata?.targetAttrs,
                    parentNode: selectedParent
                });
                const content = resultNodes.length > 0 ? resultNodes : sourceNodes;
                const sliceStart = isList ? $from.pos - 1 : $from.pos;
                const { expand: expand, nestedExpand: nestedExpand } = nodes;
                content.forEach((node)=>{
                    if (node.type === expand || node.type === nestedExpand) (0, $8QOo3.expandedState).set(node, true);
                });
                if (preservedSelection instanceof (0, $kCECX.NodeSelection) && preservedSelection.node.type === nodes.mediaSingle) {
                    // when node is media single, use tr.replaceWith freeze editor, if modify position, tr.replaceWith creates duplicats
                    const deleteFrom = $from.pos;
                    const deleteTo = $to.pos;
                    tr.delete(deleteFrom, deleteTo);
                    // After deletion, recalculate the insertion position to ensure it's valid
                    // especially when mediaSingle with caption is at the bottom of the document
                    const insertPos = Math.min(deleteFrom, tr.doc.content.size);
                    tr.insert(insertPos, content);
                    // when we replace and insert content, we need to manually map the preserved selection
                    // through the transaction, otherwise it will treat the selection as having been deleted
                    // and stop preserving it
                    const oldSize = sourceNodes.reduce((sum, node)=>sum + node.nodeSize, 0);
                    const newSize = content.reduce((sum, node)=>sum + node.nodeSize, 0);
                    api?.blockControls?.commands.mapPreservedSelection(new (0, $eOaGc.Mapping)([
                        new (0, $eOaGc.StepMap)([
                            0,
                            oldSize,
                            newSize
                        ])
                    ]))({
                        tr: tr
                    });
                } else tr.replaceWith(sliceStart, $to.pos, content);
                if (preservedSelection instanceof (0, $8HW7o.CellSelection)) {
                    const insertedNode = tr.doc.nodeAt($from.pos);
                    const isSelectable = insertedNode && (0, $kCECX.NodeSelection).isSelectable(insertedNode);
                    if (isSelectable) {
                        const nodeSelection = (0, $kCECX.NodeSelection).create(tr.doc, $from.pos);
                        tr.setSelection(nodeSelection);
                        api?.blockControls?.commands.startPreservingSelection()({
                            tr: tr
                        });
                    }
                }
                api?.blockControls?.commands.toggleBlockMenu({
                    closeMenu: true
                })({
                    tr: tr
                });
                (0, $hiQdW.stopMeasure)(measureId, (duration, startTime)=>{
                    api?.analytics?.actions?.attachAnalyticsEvent({
                        action: (0, $krYZG.ACTION).TRANSFORMED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).ELEMENT,
                        attributes: {
                            duration: duration,
                            isEmptyLine: isEmptyLine,
                            isNested: isNested,
                            isSuggested: isSuggested,
                            sourceNodesCount: sourceNodes.length,
                            sourceNodesCountByType: sourceNodeTypes,
                            sourceNodeType: sourceNodes.length === 1 ? sourceNodes[0].type.name : 'multiple',
                            startTime: startTime,
                            targetNodeType: targetType.name,
                            outputNodesCount: content.length,
                            inputMethod: (0, $krYZG.INPUT_METHOD).BLOCK_MENU
                        },
                        eventType: (0, $krYZG.EVENT_TYPE).TRACK
                    })(tr);
                });
            } catch (error) {
                (0, $hiQdW.stopMeasure)(measureId);
                (0, $jv11C.logException)(error, {
                    location: 'editor-plugin-block-menu'
                });
                api?.analytics?.actions?.attachAnalyticsEvent({
                    action: (0, $krYZG.ACTION).ERRORED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).ELEMENT,
                    actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).TRANSFORM,
                    eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        docSize: tr.doc.nodeSize,
                        error: error.message,
                        errorStack: error.stack,
                        from: sourceNodes.length === 1 ? sourceNodes[0].type.name : 'multiple',
                        inputMethod: (0, $krYZG.INPUT_METHOD).BLOCK_MENU,
                        selection: preservedSelection.toJSON(),
                        to: targetType.name
                    }
                })(tr);
            }
            return tr;
        };
module.exports["transformNode"] = $a42e6573958261d0$export$eb9a5497877a817a;

});

parcelRegister("rtnjh", function(module, exports) {

var $kCECX = parcelRequire("kCECX");


var $8HW7o = parcelRequire("8HW7o");

const $f31ca4b729cf58a7$export$721178bb4de8b79 = (selection, menuTriggerBy)=>{
    if (!selection) return false;
    const { $from: $from } = selection;
    const depth = $from.depth;
    // When a file is in card view, selection.$from has a depth of 1, but it is not a nested node, should return false
    if ($from.depth === 1 && selection instanceof (0, $kCECX.NodeSelection) && selection.node.type.name === 'media' && selection.node.attrs.type === 'file') return false;
    if ($from.depth > 0 && selection instanceof (0, $kCECX.NodeSelection)) return true;
    // Depth 0-1: Always top-level
    if (depth <= 1) return false;
    // Depth 4+: Always nested
    if (depth > 4) return true;
    // Special case for table selection
    if (selection instanceof (0, $8HW7o.CellSelection)) return depth > 3;
    // Check parent node type for depth 2-3
    const parentNode = $from.node(depth - 1);
    if (!parentNode) return true;
    const parentType = parentNode.type.name;
    const isTriggeredByBlockquote = menuTriggerBy.includes('blockquote');
    // Special cases where content is still top-level
    if (parentType === 'listItem' && depth === 3 || parentType === 'blockquote' && depth === 2 && isTriggeredByBlockquote || parentType === 'taskList' && depth === 2 || parentType === 'listItem' && depth === 4 && isTriggeredByBlockquote) return false;
    // Everything else at depth 2-3 is nested
    return true;
};
module.exports["isNestedNode"] = $f31ca4b729cf58a7$export$721178bb4de8b79;

});

parcelRegister("4p59H", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");


var $krYZG = parcelRequire("krYZG");


var $8i6M6 = parcelRequire("8i6M6");


var $dp5Fv = parcelRequire("dp5Fv");

var $ezEf7 = parcelRequire("ezEf7");

var $brnfH = parcelRequire("brnfH");

var $iil4f = parcelRequire("iil4f");

var $6NW7h = parcelRequire("6NW7h");

var $jw4KW = parcelRequire("jw4KW");

var $bYHr8 = parcelRequire("bYHr8");


var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $c7mu2 = parcelRequire("c7mu2");

const $db51f0de2bbdb2ae$var$TIMEOUT_DURATION = 1000;
const $db51f0de2bbdb2ae$var$PORTAL_TEST_ID = {
    LINK_COPIED_TO_CLIPBOARD: 'link-copied-to-clipboard',
    SYNC_BLOCK_DELETE_CONFIRMATION: 'sync-block-delete-confirmation'
};
const $db51f0de2bbdb2ae$var$pluginKey = new (0, $kCECX.PluginKey)('blockMenuExperiences');
const $db51f0de2bbdb2ae$var$START_METHOD = {
    DRAG_HANDLE_CLICK: 'dragHandleClick',
    KEYBOARD: 'keyboard'
};
const $db51f0de2bbdb2ae$var$ABORT_REASON = {
    USER_CANCELED: 'userCanceled',
    EDITOR_DESTROYED: 'editorDestroyed'
};
const $db51f0de2bbdb2ae$export$4372671be2bee317 = ({ refs: refs, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    let popupTargetEl;
    let editorView;
    const getPopupsTarget = ()=>{
        if (!popupTargetEl) popupTargetEl = refs.popupsMountPoint || (0, $jw4KW.getPopupContainerFromEditorView)(editorView?.dom);
        return popupTargetEl;
    };
    const getEditorDom = ()=>{
        if (editorView?.dom instanceof HTMLElement) return editorView.dom;
        return null;
    };
    const blockMenuOpenExperience = new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).MENU_OPEN, {
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).BLOCK_MENU,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $db51f0de2bbdb2ae$var$TIMEOUT_DURATION
            }),
            new (0, $iil4f.ExperienceCheckPopupMutation)({
                nestedElementQuery: `[data-testid="${(0, $8i6M6.BLOCK_MENU_TEST_ID)}"]`,
                getTarget: getPopupsTarget,
                type: 'editorContent'
            })
        ]
    });
    const observeConfigs = ()=>{
        const narrowTarget = (0, $bYHr8.getSelectionAncestorDOM)(editorView);
        const editorDom = getEditorDom();
        return [
            ...narrowTarget ? [
                {
                    target: narrowTarget,
                    options: {
                        childList: true,
                        subtree: true
                    }
                }
            ] : [],
            ...editorDom ? [
                {
                    target: editorDom,
                    options: {
                        childList: true
                    }
                }
            ] : []
        ];
    };
    const blockMoveUpExperience = new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).MENU_ACTION, {
        action: (0, $krYZG.ACTION).MOVED,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).MOVE_UP_BLOCK,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $db51f0de2bbdb2ae$var$TIMEOUT_DURATION
            }),
            new (0, $brnfH.ExperienceCheckDomMutation)({
                onDomMutation: (0, $c7mu2.handleMoveDomMutation),
                observeConfig: observeConfigs
            })
        ]
    });
    const blockMoveDownExperience = new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).MENU_ACTION, {
        action: (0, $krYZG.ACTION).MOVED,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).MOVE_DOWN_BLOCK,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $db51f0de2bbdb2ae$var$TIMEOUT_DURATION
            }),
            new (0, $brnfH.ExperienceCheckDomMutation)({
                onDomMutation: (0, $c7mu2.handleMoveDomMutation),
                observeConfig: observeConfigs
            })
        ]
    });
    const blockDeleteExperience = new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).MENU_ACTION, {
        action: (0, $krYZG.ACTION).DELETED,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).DELETE_BLOCK,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $db51f0de2bbdb2ae$var$TIMEOUT_DURATION
            }),
            new (0, $brnfH.ExperienceCheckDomMutation)({
                onDomMutation: (0, $c7mu2.handleDeleteDomMutation),
                observeConfig: observeConfigs
            }),
            new (0, $iil4f.ExperienceCheckPopupMutation)({
                nestedElementQuery: `[data-testid="${$db51f0de2bbdb2ae$var$PORTAL_TEST_ID.SYNC_BLOCK_DELETE_CONFIRMATION}"]`,
                type: 'portalRoot'
            })
        ]
    });
    const blockTransformExperience = new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).MENU_ACTION, {
        action: (0, $krYZG.ACTION).TRANSFORMED,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).TRANSFORM_BLOCK,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $db51f0de2bbdb2ae$var$TIMEOUT_DURATION
            }),
            new (0, $brnfH.ExperienceCheckDomMutation)({
                onDomMutation: (0, $c7mu2.handleTransformDomMutation),
                observeConfig: observeConfigs
            })
        ]
    });
    const blockCopyLinkExperience = new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).MENU_ACTION, {
        action: (0, $krYZG.ACTION).COPIED,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).COPY_LINK_TO_BLOCK,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $db51f0de2bbdb2ae$var$TIMEOUT_DURATION
            }),
            new (0, $iil4f.ExperienceCheckPopupMutation)({
                nestedElementQuery: `[data-testid="${$db51f0de2bbdb2ae$var$PORTAL_TEST_ID.LINK_COPIED_TO_CLIPBOARD}"]`,
                type: 'portalRoot'
            })
        ]
    });
    const handleMenuOpened = (method)=>{
        // Don't start if block menu is already visible
        if ((0, $c7mu2.isBlockMenuVisible)(getPopupsTarget())) return;
        blockMenuOpenExperience.start({
            method: method
        });
    };
    const handleTransformActioned = (target)=>{
        if (!target.closest('[data-testid="editor-turn-into-menu--content"]') || // Skip experience tracking when the clicked item is an extension menu item
        // (e.g. Jira macro, etc.) - they don't perform block transforms
        target.closest(`[data-testid="${(0, $8i6M6.EXTENSION_MENU_ITEM_TEST_ID)}"]`)) return false;
        const turnIntoButton = target.closest('button');
        if (turnIntoButton && turnIntoButton instanceof HTMLElement && !turnIntoButton.hasAttribute('disabled') && turnIntoButton.getAttribute('aria-disabled') !== 'true') blockTransformExperience.start();
        return true;
    };
    const handleItemActioned = (target)=>{
        if (handleTransformActioned(target)) return;
        const button = target.closest('button[data-testid]');
        if (!button || !(button instanceof HTMLButtonElement) || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
        const testId = button.dataset.testid;
        if (!testId) return;
        switch(testId){
            case (0, $8i6M6.BLOCK_MENU_ACTION_TEST_ID).MOVE_UP:
                blockMoveUpExperience.start();
                break;
            case (0, $8i6M6.BLOCK_MENU_ACTION_TEST_ID).MOVE_DOWN:
                blockMoveDownExperience.start();
                break;
            case (0, $8i6M6.BLOCK_MENU_ACTION_TEST_ID).DELETE:
                blockDeleteExperience.start();
                break;
            case (0, $8i6M6.BLOCK_MENU_ACTION_TEST_ID).COPY_LINK:
                blockCopyLinkExperience.start();
                break;
        }
    };
    const unbindClickListener = (0, $cbY7C.bind)(document, {
        type: 'click',
        listener: (event)=>{
            const target = event.target;
            if (!(target instanceof HTMLElement)) return;
            if ((0, $c7mu2.isDragHandleElement)(target)) handleMenuOpened($db51f0de2bbdb2ae$var$START_METHOD.DRAG_HANDLE_CLICK);
            else handleItemActioned(target);
        },
        options: {
            capture: true
        }
    });
    const unbindKeydownListener = (0, $cbY7C.bind)(document, {
        type: 'keydown',
        listener: (event)=>{
            const target = event.target;
            if (!(target instanceof HTMLElement)) return;
            // Check if Enter or Space is pressed on a drag handle
            if ((event.key === 'Enter' || event.key === ' ') && (0, $c7mu2.isDragHandleElement)(target)) handleMenuOpened($db51f0de2bbdb2ae$var$START_METHOD.KEYBOARD);
            // Abort on Escape key if block menu is not yet visible
            if (event.key === 'Escape' && !(0, $c7mu2.isBlockMenuVisible)(getPopupsTarget())) blockMenuOpenExperience.abort({
                reason: $db51f0de2bbdb2ae$var$ABORT_REASON.USER_CANCELED
            });
        },
        options: {
            capture: true
        }
    });
    return new (0, $kpCD8.SafePlugin)({
        key: $db51f0de2bbdb2ae$var$pluginKey,
        view: (view)=>{
            editorView = view;
            return {
                destroy: ()=>{
                    blockMenuOpenExperience.abort({
                        reason: $db51f0de2bbdb2ae$var$ABORT_REASON.EDITOR_DESTROYED
                    });
                    blockMoveUpExperience.abort({
                        reason: $db51f0de2bbdb2ae$var$ABORT_REASON.EDITOR_DESTROYED
                    });
                    blockMoveDownExperience.abort({
                        reason: $db51f0de2bbdb2ae$var$ABORT_REASON.EDITOR_DESTROYED
                    });
                    blockDeleteExperience.abort({
                        reason: $db51f0de2bbdb2ae$var$ABORT_REASON.EDITOR_DESTROYED
                    });
                    blockTransformExperience.abort({
                        reason: $db51f0de2bbdb2ae$var$ABORT_REASON.EDITOR_DESTROYED
                    });
                    blockCopyLinkExperience.abort({
                        reason: $db51f0de2bbdb2ae$var$ABORT_REASON.EDITOR_DESTROYED
                    });
                    editorView = undefined;
                    unbindClickListener();
                    unbindKeydownListener();
                }
            };
        }
    });
};
module.exports["getBlockMenuExperiencesPlugin"] = $db51f0de2bbdb2ae$export$4372671be2bee317;

});

parcelRegister("c7mu2", function(module, exports) {

var $8i6M6 = parcelRequire("8i6M6");


var $6X62h = parcelRequire("6X62h");

const $6bae54d95d127a2d$export$6aa2a05df3516dfe = (element)=>{
    return !!element?.closest('[data-editor-block-ctrl-drag-handle]');
};
const $6bae54d95d127a2d$export$da6fa229035f8640 = (popupsTarget)=>{
    if (!popupsTarget) return false;
    return (0, $6X62h.popupWithNestedElement)(popupsTarget, `[data-testid="${(0, $8i6M6.BLOCK_MENU_TEST_ID)}"]`) !== null;
};
const $6bae54d95d127a2d$var$isBlockMenuAddedInMutation = ({ type: type, addedNodes: addedNodes })=>{
    return type === 'childList' && [
        ...addedNodes
    ].some($6bae54d95d127a2d$var$isBlockMenuWithinNode);
};
const $6bae54d95d127a2d$var$isBlockMenuWithinNode = (node)=>{
    return (0, $6X62h.popupWithNestedElement)(node, `[data-testid="${(0, $8i6M6.BLOCK_MENU_TEST_ID)}"]`) !== null;
};
const $6bae54d95d127a2d$export$848164ca7017e3ef = ({ mutations: mutations })=>{
    // Look for a mutation that added the block menu
    for (const mutation of mutations){
        if ($6bae54d95d127a2d$var$isBlockMenuAddedInMutation(mutation)) return {
            status: 'success'
        };
    }
    return undefined;
};
const $6bae54d95d127a2d$export$98aa59cf060bb46f = ({ mutations: mutations })=>{
    const removeMutation = mutations.find((m)=>m.type === 'childList' && m.removedNodes.length > 0);
    const addMutation = mutations.find((m)=>m.type === 'childList' && m.addedNodes.length > 0);
    if (removeMutation && addMutation && removeMutation.removedNodes.length === addMutation.addedNodes.length) return {
        status: 'success'
    };
    return undefined;
};
const $6bae54d95d127a2d$export$d0c875b9d557ee38 = ({ mutations: mutations })=>{
    // Delete action produces a single childList mutation with only removedNodes
    const childListMutations = mutations.filter((m)=>m.type === 'childList');
    // Check for at least one mutation with removedNodes but no addedNodes
    if (childListMutations.some((m)=>m.removedNodes.length > 0 && m.addedNodes.length === 0)) return {
        status: 'success'
    };
    return undefined;
};
const $6bae54d95d127a2d$export$7ed4b3067980a591 = ({ mutations: mutations })=>{
    const hasRemovedNodes = mutations.some((m)=>m.type === 'childList' && m.removedNodes.length > 0);
    const hasAddedNodes = mutations.some((m)=>m.type === 'childList' && m.addedNodes.length > 0);
    if (hasRemovedNodes && hasAddedNodes) return {
        status: 'success'
    };
    return undefined;
};
module.exports["isDragHandleElement"] = $6bae54d95d127a2d$export$6aa2a05df3516dfe;
module.exports["isBlockMenuVisible"] = $6bae54d95d127a2d$export$da6fa229035f8640;
module.exports["handleMoveDomMutation"] = $6bae54d95d127a2d$export$98aa59cf060bb46f;
module.exports["handleDeleteDomMutation"] = $6bae54d95d127a2d$export$d0c875b9d557ee38;
module.exports["handleTransformDomMutation"] = $6bae54d95d127a2d$export$7ed4b3067980a591;

});

parcelRegister("kAEz0", function(module, exports) {

var $ldqjS = parcelRequire("ldqjS");

var $eBSR7 = parcelRequire("eBSR7");


var $lVAkE = parcelRequire("lVAkE");


var $ixfCV = parcelRequire("ixfCV");


var $hQ7KE = parcelRequire("hQ7KE");


var $8059h = parcelRequire("8059h");


var $1Hjlq = parcelRequire("1Hjlq");

function $12f7b82e2313a8af$export$e832373cff8dec22(api, config) {
    const list = {};
    const copyLinkToBlockCommand = (state, dispatch)=>{
        // Check if feature flag is enabled
        if (!(0, $ixfCV.fg)('platform_editor_adf_with_localid')) return false;
        // Get the preserved selection (only works when block menu is open and selection is preserved)
        const selection = api?.blockControls?.sharedState.currentState()?.preservedSelection;
        if (!selection) return false;
        // Check if the selection has a valid block range with localId
        const blockRange = (0, $lVAkE.expandSelectionToBlockRange)(selection);
        if (!blockRange) return false;
        const node = blockRange.$from.nodeAfter;
        if (!node?.attrs?.localId) return false;
        // Execute the copy link action
        const { getLinkPath: getLinkPath, blockLinkHashPrefix: blockLinkHashPrefix } = config || {};
        (0, $1Hjlq.copyLink)({
            getLinkPath: getLinkPath,
            blockLinkHashPrefix: blockLinkHashPrefix,
            selection: selection
        }).then((success)=>{
            if (success && dispatch) dispatch(state.tr.setMeta((0, $8059h.blockMenuPluginKey), {
                showFlag: (0, $hQ7KE.FLAG_ID).LINK_COPIED_TO_CLIPBOARD
            }));
        });
        return true;
    };
    // Ignored via go/ees005
    (0, $ldqjS.bindKeymapWithCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.copyLinkToBlock).common, copyLinkToBlockCommand, list);
    return (0, $eBSR7.keymap)(list);
}
module.exports["keymapPlugin"] = $12f7b82e2313a8af$export$e832373cff8dec22;

});

parcelRegister("hQ7KE", function(module, exports) {
var $c8391477bc84d879$export$5881677fb314e6d9 = /*#__PURE__*/ function(FLAG_ID) {
    FLAG_ID["LINK_COPIED_TO_CLIPBOARD"] = "link-copied-to-clipboard";
    return FLAG_ID;
}({});
module.exports["FLAG_ID"] = $c8391477bc84d879$export$5881677fb314e6d9;

});

parcelRegister("8059h", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $2vess = parcelRequire("2vess");

const $5228e9f9c6bc0f61$export$8750eaa816e9a19a = new (0, $kCECX.PluginKey)('blockMenuPlugin');
const $5228e9f9c6bc0f61$export$ae829ec7b2625219 = (api)=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $5228e9f9c6bc0f61$export$8750eaa816e9a19a,
        state: {
            init () {
                return {
                    showFlag: false
                };
            },
            apply: (tr, currentPluginState)=>{
                const meta = tr.getMeta($5228e9f9c6bc0f61$export$8750eaa816e9a19a);
                return {
                    showFlag: meta?.showFlag ?? currentPluginState.showFlag
                };
            }
        },
        props: {
            handleKeyDown: (_editorView, event)=>{
                const blockMenuOpen = api?.userIntent?.sharedState.currentState()?.currentUserIntent === 'blockMenuOpen';
                // Exit early and do nothing when block menu is closed
                if (!blockMenuOpen) return false;
                // Block further handling of key events when block menu is open
                // Except for backspace/delete/copy/cut/paste/undo/redo/copy-link-to-selection which should be handled by the selection preservation plugin
                return (0, $2vess.shouldSuppressKeyboardEvent)(event);
            }
        }
    });
};
module.exports["blockMenuPluginKey"] = $5228e9f9c6bc0f61$export$8750eaa816e9a19a;
module.exports["createPlugin"] = $5228e9f9c6bc0f61$export$ae829ec7b2625219;

});

parcelRegister("2vess", function(module, exports) {
/**
 * Determines whether keyboard events should be suppressed when the block menu is open.
 *
 * When the block menu is open, we want to block most keyboard events to prevent
 * unintended interactions. However, certain actions should still be allowed:
 * - Backspace/Delete: Allow deleting selected content
 * - Copy/Cut/Paste: Allow clipboard operations (Cmd/Ctrl+C, Cmd/Ctrl+X, Cmd/Ctrl+V)
 * - Undo/Redo: Allow undo/redo operations (Cmd/Ctrl+Z, Cmd/Ctrl+Y)
 * - Copy Link to Selection: Allow the keyboard shortcut (Cmd/Ctrl+Alt+A)
 *
 * @param event - The keyboard event to check
 * @returns true if the event should be suppressed, false if it should be allowed
 */ const $c70abac5f218a451$export$1cbe0677ce5bfb51 = (event)=>{
    const key = event.key.toLowerCase();
    const code = event.code.toLowerCase();
    const isMetaCtrl = event.metaKey || event.ctrlKey;
    const isAlt = event.altKey;
    // Check for allowed keyboard shortcuts
    const isBackspaceDelete = [
        'backspace',
        'delete'
    ].includes(key);
    const isCopyCutPaste = isMetaCtrl && [
        'c',
        'x',
        'v'
    ].includes(key);
    const isUndoRedo = isMetaCtrl && [
        'z',
        'y'
    ].includes(key);
    // Use event.code to detect physical key 'A' because on macOS Option+A produces 'å'
    const isCopyLinkToBlock = isMetaCtrl && isAlt && code === 'keya';
    // Suppress all events except the allowed ones
    const suppressNativeHandling = !isCopyCutPaste && !isBackspaceDelete && !isUndoRedo && !isCopyLinkToBlock;
    return suppressNativeHandling;
};
module.exports["shouldSuppressKeyboardEvent"] = $c70abac5f218a451$export$1cbe0677ce5bfb51;

});

parcelRegister("1Hjlq", function(module, exports) {

var $cwk3g = parcelRequire("cwk3g");


var $jfFbl = parcelRequire("jfFbl");


var $jv11C = parcelRequire("jv11C");


var $lVAkE = parcelRequire("lVAkE");

const $c625224b5223f962$export$9030f1f7cf11a203 = async ({ getLinkPath: getLinkPath, blockLinkHashPrefix: blockLinkHashPrefix = (0, $cwk3g.DEFAULT_BLOCK_LINK_HASH_PREFIX), selection: selection })=>{
    const blockRange = (0, $lVAkE.expandSelectionToBlockRange)(selection);
    if (!blockRange) return false;
    // get the link to the first node in the selection
    const node = blockRange.$from.nodeAfter;
    if (!node || !node.attrs || !node.attrs.localId) return false;
    const path = getLinkPath?.() || location.pathname;
    try {
        const url = new URL(location.origin + path);
        url.hash = (0, $cwk3g.createBlockLinkHashValue)(node.attrs.localId, blockLinkHashPrefix);
        const href = url.toString();
        await (0, $jfFbl.copyToClipboard)(href);
    } catch (error) {
        (0, $jv11C.logException)(error, {
            location: 'editor-plugin-block-menu'
        });
        return false;
    }
    return true;
};
module.exports["copyLink"] = $c625224b5223f962$export$9030f1f7cf11a203;

});

parcelRegister("db6yu", function(module, exports) {
/* block-menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $krYZG = parcelRequire("krYZG");


var $8i6M6 = parcelRequire("8i6M6");


var $h75sz = parcelRequire("h75sz");


var $3k5Tv = parcelRequire("3k5Tv");


var $kAPZe = parcelRequire("kAPZe");


var $7XIuB = parcelRequire("7XIuB");


var $g9ric = parcelRequire("g9ric");

var $9RT19 = parcelRequire("9RT19");


var $uyXFl = parcelRequire("uyXFl");

var $9Muxb = parcelRequire("9Muxb");


var $7Y8M5 = parcelRequire("7Y8M5");


var $dQrHJ = parcelRequire("dQrHJ");


var $ixfCV = parcelRequire("ixfCV");


var $iMnC5 = parcelRequire("iMnC5");


var $di3bZ = parcelRequire("di3bZ");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $b4364 = parcelRequire("b4364");


var $lnrwQ = parcelRequire("lnrwQ");

const $49a840a7f8a2f026$var$styles = {
    base: "_2rko12b0 _bfhk1bhr _16qs130s",
    maxWidthStyles: "_p12fnklw",
    emptyMenuSectionStyles: "_1cc0glyw _1k2yglyw"
};
const $49a840a7f8a2f026$var$DEFAULT_MENU_WIDTH = 230;
const $49a840a7f8a2f026$var$DRAG_HANDLE_OFFSET_PADDING = 5;
const $49a840a7f8a2f026$var$FALLBACK_MENU_HEIGHT = 300;
const $49a840a7f8a2f026$var$PopupWithListeners = (0, $9Muxb.default)((0, $7XIuB.default));
const $49a840a7f8a2f026$var$useConditionalBlockMenuEffect = ({ api: api, isMenuOpen: isMenuOpen, menuTriggerBy: menuTriggerBy, selectedByShortcutOrDragHandle: selectedByShortcutOrDragHandle, hasFocus: hasFocus, openedViaKeyboard: openedViaKeyboard, prevIsMenuOpenRef: prevIsMenuOpenRef })=>{
    /**
   * NOTE: do not add `currentUserIntent` to dependency array as it causes unnecessary re-renders and messes with the user intent state
   */ (0, $cozmU.useEffect)(()=>{
        if (!isMenuOpen || !menuTriggerBy || !selectedByShortcutOrDragHandle || !hasFocus) return;
         // Fire analytics event when block menu opens (only on first transition from closed to open)
        if (!prevIsMenuOpenRef.current && isMenuOpen) api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).OPENED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).BLOCK_MENU,
            eventType: (0, $krYZG.EVENT_TYPE).UI,
            attributes: {
                inputMethod: openedViaKeyboard ? (0, $krYZG.INPUT_METHOD).KEYBOARD : (0, $krYZG.INPUT_METHOD).MOUSE
            }
        });
         // Update the previous state
        prevIsMenuOpenRef.current = isMenuOpen;
        api?.core.actions.execute(api?.userIntent?.commands.setCurrentUserIntent('blockMenuOpen'));
    }, [
        api,
        isMenuOpen,
        menuTriggerBy,
        selectedByShortcutOrDragHandle,
        hasFocus,
        openedViaKeyboard,
        prevIsMenuOpenRef
    ]);
};
const $49a840a7f8a2f026$var$isSelectionWithinCodeBlock = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    return $from.sameParent($to) && $from.parent.type === state.schema.nodes.codeBlock;
};
const $49a840a7f8a2f026$var$useCloseBlockMenuOnResize = ({ isEnabled: isEnabled, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement, closeMenu: closeMenu })=>{
    (0, $cozmU.useEffect)(()=>{
        if (!isEnabled || typeof ResizeObserver === 'undefined') return;
        const observedElements = Array.from(new Set([
            mountTo,
            boundariesElement,
            scrollableElement
        ].filter((element)=>Boolean(element))));
        if (observedElements.length === 0) return;
        const pendingInitialResizeElements = new Set(observedElements);
        const resizeObserver = new ResizeObserver((entries)=>{
            const hasResizeAfterInitialObservation = entries.some(({ target: target })=>{
                if (target instanceof HTMLElement && pendingInitialResizeElements.has(target)) {
                    pendingInitialResizeElements.delete(target);
                    return false;
                }
                return true;
            });
            if (hasResizeAfterInitialObservation) closeMenu();
        });
        observedElements.forEach((element)=>resizeObserver.observe(element));
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        boundariesElement,
        closeMenu,
        isEnabled,
        mountTo,
        scrollableElement
    ]);
};
const $49a840a7f8a2f026$var$BlockMenuContent = ({ api: api, setRef: setRef })=>{
    const blockMenuComponents = api?.blockMenu?.actions.getBlockMenuComponents();
    const setOutsideClickTargetRef = (0, $cozmU.useContext)((0, $uyXFl.OutsideClickTargetRefContext));
    const ref = (el)=>{
        setOutsideClickTargetRef(el);
        setRef?.(el);
    };
    const shouldDisableArrowKeyNavigation = (event)=>{
        if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown') return false;
        const target = event.target;
        if (!(target instanceof HTMLElement)) return false;
        return target.closest('[data-toolbar-nested-dropdown-menu]') !== null;
    };
    if ((0, $ieeJu.expValEquals)('platform_editor_menu_radius_update', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQrHJ.ToolbarMenuContainer), {
        testId: (0, $8i6M6.BLOCK_MENU_TEST_ID),
        ref: ref,
        xcss: $49a840a7f8a2f026$var$styles.maxWidthStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g9ric.ArrowKeyNavigationProvider), {
        type: (0, $9RT19.ArrowKeyNavigationType).MENU,
        handleClose: (e)=>e.preventDefault(),
        disableArrowKeyNavigation: shouldDisableArrowKeyNavigation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lnrwQ.BlockMenuRenderer), {
        allRegisteredComponents: blockMenuComponents || []
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        testId: (0, $8i6M6.BLOCK_MENU_TEST_ID),
        role: (0, $ieeJu.expValEquals)('platform_editor_enghealth_a11y_jan_fixes', 'isEnabled', true) ? 'menu' : undefined,
        ref: ref,
        xcss: (0, $w6R6I.cx)($49a840a7f8a2f026$var$styles.base, $49a840a7f8a2f026$var$styles.maxWidthStyles, (0, $fqVYq.editorExperiment)('platform_synced_block', true) && $49a840a7f8a2f026$var$styles.emptyMenuSectionStyles)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g9ric.ArrowKeyNavigationProvider), {
        type: (0, $9RT19.ArrowKeyNavigationType).MENU,
        handleClose: (e)=>e.preventDefault(),
        disableArrowKeyNavigation: shouldDisableArrowKeyNavigation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lnrwQ.BlockMenuRenderer), {
        allRegisteredComponents: blockMenuComponents || []
    })));
};
const $49a840a7f8a2f026$var$BlockMenu = ({ editorView: editorView, api: api, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement })=>{
    const { menuTriggerBy: menuTriggerBy, isSelectedViaDragHandle: isSelectedViaDragHandle, isMenuOpen: isMenuOpen, currentUserIntent: currentUserIntent, openedViaKeyboard: openedViaKeyboard } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'blockControls',
        'userIntent'
    ], (states)=>({
            menuTriggerBy: states.blockControlsState?.menuTriggerBy,
            isSelectedViaDragHandle: states.blockControlsState?.isSelectedViaDragHandle,
            isMenuOpen: states.blockControlsState?.isMenuOpen,
            currentUserIntent: states.userIntentState?.currentUserIntent,
            openedViaKeyboard: states.blockControlsState?.blockMenuOptions?.openedViaKeyboard
        }));
    const { onDropdownOpenChanged: onDropdownOpenChanged } = (0, $b4364.useBlockMenu)();
    const targetHandleRef = editorView?.dom?.querySelector((0, $kAPZe.DRAG_HANDLE_SELECTOR));
    const closeMenu = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            api?.blockControls?.commands.toggleBlockMenu({
                closeMenu: true
            })({
                tr: tr
            });
            onDropdownOpenChanged(false);
            api?.userIntent?.commands.setCurrentUserIntent(currentUserIntent === 'blockMenuOpen' ? 'default' : currentUserIntent || 'default')({
                tr: tr
            });
            return tr;
        });
    }, [
        api,
        currentUserIntent,
        onDropdownOpenChanged
    ]);
    $49a840a7f8a2f026$var$useCloseBlockMenuOnResize({
        isEnabled: Boolean(isMenuOpen),
        mountTo: mountTo,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        closeMenu: closeMenu
    });
    const prevIsMenuOpenRef = (0, $cozmU.useRef)(false);
    const popupRef = (0, $cozmU.useRef)(undefined);
    const [menuHeight, setMenuHeight] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(0);
    const targetHandleHeightOffset = -(targetHandleRef?.clientHeight || 0);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useLayoutEffect(()=>{
        if (!isMenuOpen) return;
        setMenuHeight(popupRef.current?.clientHeight || $49a840a7f8a2f026$var$FALLBACK_MENU_HEIGHT);
    }, [
        isMenuOpen
    ]);
    const hasFocus = (editorView?.hasFocus() || // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    document.activeElement === targetHandleRef || popupRef.current && // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    (popupRef.current.contains(document.activeElement) || // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    popupRef.current === document.activeElement)) ?? false;
    const selectedByShortcutOrDragHandle = !!isSelectedViaDragHandle || !!openedViaKeyboard; // Use conditional hook based on feature flag
    $49a840a7f8a2f026$var$useConditionalBlockMenuEffect({
        api: api,
        isMenuOpen: isMenuOpen,
        menuTriggerBy: menuTriggerBy,
        selectedByShortcutOrDragHandle: selectedByShortcutOrDragHandle,
        hasFocus: hasFocus,
        openedViaKeyboard: openedViaKeyboard,
        prevIsMenuOpenRef: prevIsMenuOpenRef
    });
    if (!isMenuOpen) return null;
    const handleKeyDown = (event)=>{
        // When the editor view has focus, the keydown will be handled by the
        // selection preservation plugin – exit early to avoid double handling
        // Also exit if selection is within a code block to avoid double handling when code block got focus when the node after it is deleted
        if (!editorView || editorView?.hasFocus() || $49a840a7f8a2f026$var$isSelectionWithinCodeBlock(editorView.state)) return;
        const key = event.key.toLowerCase();
        const isMetaCtrl = event.metaKey || event.ctrlKey;
        const isDelete = [
            'backspace',
            'delete'
        ].includes(key);
        const isUndo = isMetaCtrl && key === 'z' && !event.shiftKey;
        const isRedo = isMetaCtrl && (key === 'y' || key === 'z' && event.shiftKey); // Necessary to prevent the editor from handling the delete natively
        if (isDelete || isUndo || isRedo) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (isUndo) (0, $di3bZ.undo)(editorView.state, editorView.dispatch);
        else if (isRedo) (0, $di3bZ.redo)(editorView.state, editorView.dispatch);
        api?.core?.actions.execute(api?.blockControls?.commands?.handleKeyDownWithPreservedSelection(event));
    };
    const handleClickOutside = (e)=>{
        // check if the clicked element was another drag handle or nested dropdown menu, if so don't close the menu
        if (e.target instanceof HTMLElement && (e.target.closest((0, $kAPZe.DRAG_HANDLE_SELECTOR)) || e.target.closest((0, $kAPZe.NESTED_DROPDOWN_MENU)) && (0, $ixfCV.fg)('platform_editor_block_menu_jira_patch_5'))) return;
        closeMenu();
    };
    if (!menuTriggerBy || !selectedByShortcutOrDragHandle || !hasFocus || [
        'resizing',
        'dragging'
    ].includes(currentUserIntent || '')) {
        closeMenu();
        return null;
    }
    const setRef = (el)=>{
        if (el) popupRef.current = el;
    };
    if (!(targetHandleRef instanceof HTMLElement)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h75sz.ErrorBoundary), {
        component: (0, $krYZG.ACTION_SUBJECT).BLOCK_MENU,
        dispatchAnalyticsEvent: api?.analytics?.actions.fireAnalyticsEvent,
        fallbackComponent: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($49a840a7f8a2f026$var$PopupWithListeners, {
        alignX: 'right',
        alignY: 'start',
        handleClickOutside: handleClickOutside,
        handleEscapeKeydown: closeMenu,
        handleKeyDown: handleKeyDown,
        mountTo: mountTo,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        target: targetHandleRef,
        zIndex: (0, $7Y8M5.akEditorFloatingOverlapPanelZIndex),
        fitWidth: $49a840a7f8a2f026$var$DEFAULT_MENU_WIDTH,
        fitHeight: menuHeight,
        preventOverflow: true,
        stick: true,
        offset: [
            (0, $kAPZe.DRAG_HANDLE_WIDTH) + $49a840a7f8a2f026$var$DRAG_HANDLE_OFFSET_PADDING,
            targetHandleHeightOffset
        ],
        focusTrap: openedViaKeyboard ? // Only enable focus trap when opened via keyboard to make sure the focus is on the first focusable menu item
        {
            initialFocus: undefined
        } : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($49a840a7f8a2f026$var$BlockMenuContent, {
        api: api,
        setRef: setRef
    })));
};
// eslint-disable-next-line @typescript-eslint/ban-types
const $49a840a7f8a2f026$var$_default_1 = (0, $kSwu1.injectIntl)($49a840a7f8a2f026$var$BlockMenu);
var $49a840a7f8a2f026$export$2e2bcd8739ae039 = $49a840a7f8a2f026$var$_default_1;
module.exports["default"] = $49a840a7f8a2f026$export$2e2bcd8739ae039;

});

parcelRegister("b4364", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $78eb69cdcd557e7b$var$BlockMenuContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    onDropdownOpenChanged: ()=>{},
    moveDownRef: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef(),
    moveUpRef: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef(),
    getFirstSelectedDomNode: ()=>undefined
});
const $78eb69cdcd557e7b$export$348c130ef35bd15f = ()=>{
    const context = (0, $cozmU.useContext)($78eb69cdcd557e7b$var$BlockMenuContext);
    if (!context) throw new Error('useBlockMenu must be used within BlockMenuProvider');
    return context;
};
const $78eb69cdcd557e7b$export$b01e53fc0770b652 = ({ children: children, api: api, editorView: editorView })=>{
    const moveUpRef = (0, $cozmU.useRef)(null);
    const moveDownRef = (0, $cozmU.useRef)(null);
    const getFirstSelectedDomNode = (0, $cozmU.useCallback)(()=>{
        const from = api?.selection?.sharedState.currentState()?.selection?.from;
        if (from !== undefined) {
            const nodeDOM = editorView?.nodeDOM(from);
            if (nodeDOM instanceof Element) return nodeDOM;
        }
    }, [
        api,
        editorView
    ]);
    const onDropdownOpenChanged = (0, $cozmU.useCallback)((isOpen)=>{
        if (!isOpen) // On Dropdown closed, return focus to editor
        setTimeout(()=>requestAnimationFrame(()=>{
                api?.core.actions.focus({
                    scrollIntoView: false
                });
            }), 1);
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($78eb69cdcd557e7b$var$BlockMenuContext.Provider, {
        // eslint-disable-next-line @atlassian/perf-linting/no-inline-context-value, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        value: {
            onDropdownOpenChanged: onDropdownOpenChanged,
            moveDownRef: moveDownRef,
            moveUpRef: moveUpRef,
            getFirstSelectedDomNode: getFirstSelectedDomNode
        }
    }, children);
};
module.exports["useBlockMenu"] = $78eb69cdcd557e7b$export$348c130ef35bd15f;
module.exports["BlockMenuProvider"] = $78eb69cdcd557e7b$export$b01e53fc0770b652;

});

parcelRegister("lnrwQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6xO4G = parcelRequire("6xO4G");


var $kFZVu = parcelRequire("kFZVu");


var $amBkk = parcelRequire("amBkk");

const $9278f9ef1733ed2b$export$31e93a060be203b5 = ({ allRegisteredComponents: allRegisteredComponents, fallbacks: fallbacks = (0, $kFZVu.BLOCK_MENU_FALLBACKS) })=>{
    const { childrenMap: childrenMap, topLevelSections: topLevelSections } = (0, $cozmU.useMemo)(()=>({
            childrenMap: (0, $amBkk.buildChildrenMap)(allRegisteredComponents),
            topLevelSections: (0, $amBkk.getSortedTopLevelSections)(allRegisteredComponents)
        }), [
        allRegisteredComponents
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6xO4G.BlockMenuComponents), {
        registeredComponents: topLevelSections,
        childrenMap: childrenMap,
        fallbacks: fallbacks
    });
};
module.exports["BlockMenuRenderer"] = $9278f9ef1733ed2b$export$31e93a060be203b5;

});

parcelRegister("6xO4G", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7O9JH = parcelRequire("7O9JH");

const $f91c85b55fe93078$export$de5057065abc3ddb = ({ registeredComponents: registeredComponents, childrenMap: childrenMap, fallbacks: fallbacks })=>{
    if (!registeredComponents?.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, registeredComponents.map((registeredComponent)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7O9JH.BlockMenuComponent), {
            key: registeredComponent.key,
            registeredComponent: registeredComponent,
            childrenMap: childrenMap,
            fallbacks: fallbacks
        })));
};
module.exports["BlockMenuComponents"] = $f91c85b55fe93078$export$de5057065abc3ddb;

});

parcelRegister("7O9JH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6xO4G = parcelRequire("6xO4G");


var $amBkk = parcelRequire("amBkk");

const $338e66e33e07e4ad$export$f37396fcdf7aa078 = ({ registeredComponent: registeredComponent, childrenMap: childrenMap, fallbacks: fallbacks })=>{
    if (!(0, $amBkk.willComponentRender)(registeredComponent, childrenMap)) return null;
    if (registeredComponent.type === 'block-menu-item') {
        const ItemComponent = registeredComponent.component || fallbacks['block-menu-item'];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemComponent, {
            key: registeredComponent.key
        });
    }
    const ParentComponent = registeredComponent.component || fallbacks[registeredComponent.type];
    const childrenMapKey = (0, $amBkk.getChildrenMapKey)(registeredComponent.key, registeredComponent.type);
    const registeredComponents = childrenMap.get(childrenMapKey);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ParentComponent, {
        key: registeredComponent.key
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6xO4G.BlockMenuComponents), {
        registeredComponents: registeredComponents,
        childrenMap: childrenMap,
        fallbacks: fallbacks
    }));
};
module.exports["BlockMenuComponent"] = $338e66e33e07e4ad$export$f37396fcdf7aa078;

});

parcelRegister("amBkk", function(module, exports) {
/**
 * Type guard to check if a component has a parent
 *
 * @param component The block menu component to check
 * @returns True if the component has a parent, false otherwise
 */ const $6fa5b5a3a44b9cb6$var$hasParent = (component)=>{
    return 'parent' in component && !!component.parent;
};
/**
 * Type guard to identify top-level sections (sections without a parent)
 *
 * @param component The block menu component to check
 * @returns True if the component is a top-level section, false otherwise
 */ const $6fa5b5a3a44b9cb6$var$isTopLevelSection = (component)=>{
    return component.type === 'block-menu-section' && !$6fa5b5a3a44b9cb6$var$hasParent(component);
};
const $6fa5b5a3a44b9cb6$export$c21fbbc4028db8fb = (components)=>{
    return components.filter($6fa5b5a3a44b9cb6$var$isTopLevelSection).sort((a, b)=>(a.rank || 0) - (b.rank || 0));
};
const $6fa5b5a3a44b9cb6$export$78a1be09e8c33cbb = (key, type)=>{
    return `${type}:${key}`;
};
const $6fa5b5a3a44b9cb6$export$93e686d60d327014 = (components)=>{
    const childrenMap = new Map();
    for (const component of components)// Only components with parents can be children
    if ('parent' in component && !!component.parent) {
        const childrenMapKey = $6fa5b5a3a44b9cb6$export$78a1be09e8c33cbb(component.parent.key, component.parent.type);
        const existing = childrenMap.get(childrenMapKey) || [];
        existing.push(component);
        childrenMap.set(childrenMapKey, existing);
    }
    // Sort children by their rank within their parent
    for (const [, children] of childrenMap.entries())children.sort((a, b)=>{
        const rankA = $6fa5b5a3a44b9cb6$var$hasParent(a) ? a.parent.rank || 0 : 0;
        const rankB = $6fa5b5a3a44b9cb6$var$hasParent(b) ? b.parent.rank || 0 : 0;
        return rankA - rankB;
    });
    return childrenMap;
};
const $6fa5b5a3a44b9cb6$export$51a8f8a5d7877637 = (registeredComponent, childrenMap)=>{
    if (registeredComponent.type === 'block-menu-item') return !registeredComponent?.isHidden?.();
    const childrenMapKey = $6fa5b5a3a44b9cb6$export$78a1be09e8c33cbb(registeredComponent.key, registeredComponent.type);
    const registeredComponents = childrenMap.get(childrenMapKey) || [];
    return registeredComponents.some((childComponent)=>$6fa5b5a3a44b9cb6$export$51a8f8a5d7877637(childComponent, childrenMap));
};
module.exports["getSortedTopLevelSections"] = $6fa5b5a3a44b9cb6$export$c21fbbc4028db8fb;
module.exports["getChildrenMapKey"] = $6fa5b5a3a44b9cb6$export$78a1be09e8c33cbb;
module.exports["buildChildrenMap"] = $6fa5b5a3a44b9cb6$export$93e686d60d327014;
module.exports["willComponentRender"] = $6fa5b5a3a44b9cb6$export$51a8f8a5d7877637;

});

parcelRegister("kFZVu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3FYPH = parcelRequire("3FYPH");


var $dVKvM = parcelRequire("dVKvM");

var $jgJIe = parcelRequire("jgJIe");

var $gk3KR = parcelRequire("gk3KR");


var $aDSIl = parcelRequire("aDSIl");

const $512650e5a615b9a2$var$FallbackNestedMenu = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gk3KR.ToolbarNestedDropdownMenu), {
        elemBefore: undefined,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
            label: "",
            size: "small"
        }),
        text: formatMessage((0, $3FYPH.messages).fallbackNestedMenu),
        enableMaxHeight: true,
        shouldFitContainer: true
    }, children);
};
const $512650e5a615b9a2$var$FallbackMenuItem = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), null, formatMessage((0, $3FYPH.messages).fallbackMenuItem));
};
const $512650e5a615b9a2$export$5b562d75078c479b = {
    'block-menu-nested': $512650e5a615b9a2$var$FallbackNestedMenu,
    'block-menu-section': ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), null, children),
    'block-menu-item': $512650e5a615b9a2$var$FallbackMenuItem
};
module.exports["BLOCK_MENU_FALLBACKS"] = $512650e5a615b9a2$export$5b562d75078c479b;

});

parcelRegister("dzhlK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8i6M6 = parcelRequire("8i6M6");

var $cCXFd = parcelRequire("cCXFd");


var $3FYPH = parcelRequire("3FYPH");


var $jgJIe = parcelRequire("jgJIe");


var $amBkk = parcelRequire("amBkk");


var $eCTkH = parcelRequire("eCTkH");


var $3AuJS = parcelRequire("3AuJS");


var $gmOz9 = parcelRequire("gmOz9");


var $7o5s6 = parcelRequire("7o5s6");


var $VOsgf = parcelRequire("VOsgf");


var $8H0C5 = parcelRequire("8H0C5");


var $9Q8hQ = parcelRequire("9Q8hQ");


var $6Edc5 = parcelRequire("6Edc5");


var $eUIQd = parcelRequire("eUIQd");


var $4go67 = parcelRequire("4go67");


var $lk85x = parcelRequire("lk85x");


var $3Zhnz = parcelRequire("3Zhnz");


var $hIpbV = parcelRequire("hIpbV");


var $ihHNx = parcelRequire("ihHNx");


var $gDoPM = parcelRequire("gDoPM");

const $4e8adb76ce9b4b67$var$MIN_NUMBER_OF_AVAILABLE_NATIVE_TRANSFORMS = 7;
const $4e8adb76ce9b4b67$var$getTotalNumberOfAvailableNativeTransforms = (blockMenuComponents)=>{
    if (!blockMenuComponents) return 0;
    const childrenMap = (0, $amBkk.buildChildrenMap)(blockMenuComponents);
    const headingsKey = (0, $amBkk.getChildrenMapKey)((0, $8i6M6.TRANSFORM_HEADINGS_MENU_SECTION).key, 'block-menu-section');
    const structureKey = (0, $amBkk.getChildrenMapKey)((0, $8i6M6.TRANSFORM_STRUCTURE_MENU_SECTION).key, 'block-menu-section');
    const headingsChildren = childrenMap.get(headingsKey) || [];
    const structureChildren = childrenMap.get(structureKey) || [];
    return [
        ...headingsChildren,
        ...structureChildren
    ].filter((c)=>(0, $amBkk.willComponentRender)(c, childrenMap)).length;
};
const $4e8adb76ce9b4b67$var$getMoveUpMoveDownMenuComponents = (api)=>{
    return [
        {
            type: 'block-menu-item',
            key: (0, $8i6M6.POSITION_MOVE_UP_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.POSITION_MENU_SECTION).key,
                rank: (0, $cCXFd.POSITION_MENU_SECTION_RANK)[(0, $8i6M6.POSITION_MOVE_UP_MENU_ITEM).key]
            },
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eUIQd.MoveUpDropdownItem), {
                    api: api
                })
        },
        {
            type: 'block-menu-item',
            key: (0, $8i6M6.POSITION_MOVE_DOWN_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.POSITION_MENU_SECTION).key,
                rank: (0, $cCXFd.POSITION_MENU_SECTION_RANK)[(0, $8i6M6.POSITION_MOVE_DOWN_MENU_ITEM).key]
            },
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Edc5.MoveDownDropdownItem), {
                    api: api
                })
        }
    ];
};
const $4e8adb76ce9b4b67$var$getTurnIntoMenuComponents = (api)=>{
    return [
        {
            type: 'block-menu-nested',
            key: (0, $8i6M6.TRANSFORM_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.TRANSFORM_MENU_SECTION).key,
                rank: (0, $cCXFd.TRANSFORM_MENU_SECTION_RANK)[(0, $8i6M6.TRANSFORM_MENU_ITEM).key]
            },
            component: ({ children: children } = {
                children: null
            })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $VOsgf.FormatMenuComponent), {
                    api: api
                }, children);
            },
            isHidden: ()=>(0, $hIpbV.checkIsFormatMenuHidden)(api)
        },
        {
            type: 'block-menu-section',
            key: (0, $8i6M6.TRANSFORM_SUGGESTED_MENU_SECTION).key,
            parent: {
                type: 'block-menu-nested',
                key: (0, $8i6M6.TRANSFORM_MENU_ITEM).key,
                rank: (0, $cCXFd.TRANSFORM_MENU_ITEM_RANK)[(0, $8i6M6.TRANSFORM_SUGGESTED_MENU_SECTION).key]
            },
            component: ({ children: children } = {
                children: null
            })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4go67.SuggestedItemsMenuSection), {
                    api: api
                }, children)
        },
        {
            type: 'block-menu-item',
            key: (0, $8i6M6.TRANSFORM_SUGGESTED_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.TRANSFORM_SUGGESTED_MENU_SECTION).key,
                rank: (0, $cCXFd.TRANSFORM_SUGGESTED_MENU_SECTION_RANK)[(0, $8i6M6.TRANSFORM_SUGGESTED_MENU_ITEM).key]
            },
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lk85x.SuggestedMenuItems), {
                    api: api
                }),
            isHidden: ()=>{
                const blockMenuComponents = api?.blockMenu?.actions.getBlockMenuComponents();
                if ($4e8adb76ce9b4b67$var$getTotalNumberOfAvailableNativeTransforms(blockMenuComponents) < $4e8adb76ce9b4b67$var$MIN_NUMBER_OF_AVAILABLE_NATIVE_TRANSFORMS) return true;
                const menuItemsMap = (0, $ihHNx.createMenuItemsMap)(blockMenuComponents);
                const selection = api?.selection?.sharedState.currentState()?.selection;
                const preservedSelection = api?.blockControls?.sharedState.currentState()?.preservedSelection;
                const currentSelection = preservedSelection || selection;
                const suggestedItems = (0, $gDoPM.getSuggestedItemsFromSelection)(menuItemsMap, currentSelection);
                return suggestedItems.length === 0;
            }
        },
        {
            type: 'block-menu-section',
            key: (0, $8i6M6.TRANSFORM_CREATE_MENU_SECTION).key,
            parent: {
                type: 'block-menu-nested',
                key: (0, $8i6M6.TRANSFORM_MENU_ITEM).key,
                rank: (0, $cCXFd.TRANSFORM_MENU_ITEM_RANK)[(0, $8i6M6.TRANSFORM_CREATE_MENU_SECTION).key]
            },
            component: ({ children: children } = {
                children: null
            })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Q8hQ.MenuSection), {
                    title: (0, $3FYPH.messages).create,
                    hasSeparator: (0, $3Zhnz.hasContentBeforeCreate)(api)
                }, children);
            }
        },
        {
            type: 'block-menu-section',
            key: (0, $8i6M6.TRANSFORM_STRUCTURE_MENU_SECTION).key,
            parent: {
                type: 'block-menu-nested',
                key: (0, $8i6M6.TRANSFORM_MENU_ITEM).key,
                rank: (0, $cCXFd.TRANSFORM_MENU_ITEM_RANK)[(0, $8i6M6.TRANSFORM_STRUCTURE_MENU_SECTION).key]
            },
            component: ({ children: children } = {
                children: null
            })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Q8hQ.MenuSection), {
                    title: (0, $3FYPH.messages).structure,
                    hasSeparator: (0, $3Zhnz.hasContentBeforeStructure)(api)
                }, children);
            }
        },
        {
            type: 'block-menu-section',
            key: (0, $8i6M6.TRANSFORM_HEADINGS_MENU_SECTION).key,
            parent: {
                type: 'block-menu-nested',
                key: (0, $8i6M6.TRANSFORM_MENU_ITEM).key,
                rank: (0, $cCXFd.TRANSFORM_MENU_ITEM_RANK)[(0, $8i6M6.TRANSFORM_HEADINGS_MENU_SECTION).key]
            },
            component: ({ children: children } = {
                children: null
            })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Q8hQ.MenuSection), {
                    title: (0, $3FYPH.messages).headings,
                    hasSeparator: (0, $3Zhnz.hasContentBeforeHeadings)(api)
                }, children);
            }
        },
        {
            type: 'block-menu-section',
            key: (0, $8i6M6.TRANSFORM_MENU_SECTION).key,
            rank: (0, $cCXFd.MAIN_BLOCK_MENU_SECTION_RANK)[(0, $8i6M6.TRANSFORM_MENU_SECTION).key],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8H0C5.FormatMenuSection), {
                    api: api
                }, children);
            }
        }
    ];
};
const $4e8adb76ce9b4b67$export$b1be7b75e24fc24b = ({ api: api, config: config })=>{
    return [
        ...$4e8adb76ce9b4b67$var$getTurnIntoMenuComponents(api),
        {
            type: 'block-menu-section',
            key: (0, $8i6M6.BLOCK_ACTIONS_MENU_SECTION).key,
            rank: (0, $cCXFd.MAIN_BLOCK_MENU_SECTION_RANK)[(0, $8i6M6.BLOCK_ACTIONS_MENU_SECTION).key],
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3AuJS.CopySection), null, children)
        },
        {
            type: 'block-menu-section',
            key: (0, $8i6M6.BLOCK_ACTIONS_COPY_MENU_SECTION).key,
            rank: (0, $cCXFd.MAIN_BLOCK_MENU_SECTION_RANK)[(0, $8i6M6.BLOCK_ACTIONS_COPY_MENU_SECTION).key],
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), {
                    hasSeparator: true
                }, children)
        },
        {
            type: 'block-menu-item',
            key: (0, $8i6M6.BLOCK_ACTIONS_COPY_LINK_TO_BLOCK_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.BLOCK_ACTIONS_COPY_MENU_SECTION).key,
                rank: (0, $cCXFd.BLOCK_ACTIONS_COPY_MENU_SECTION_RANK)[(0, $8i6M6.BLOCK_ACTIONS_COPY_LINK_TO_BLOCK_MENU_ITEM).key]
            },
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCTkH.CopyLinkDropdownItem), {
                    api: api,
                    config: config
                })
        },
        {
            type: 'block-menu-section',
            key: (0, $8i6M6.POSITION_MENU_SECTION).key,
            rank: (0, $cCXFd.MAIN_BLOCK_MENU_SECTION_RANK)[(0, $8i6M6.POSITION_MENU_SECTION).key],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), {
                    hasSeparator: true
                }, children);
            }
        },
        ...$4e8adb76ce9b4b67$var$getMoveUpMoveDownMenuComponents(api),
        {
            type: 'block-menu-section',
            key: (0, $8i6M6.DELETE_MENU_SECTION).key,
            rank: (0, $cCXFd.MAIN_BLOCK_MENU_SECTION_RANK)[(0, $8i6M6.DELETE_MENU_SECTION).key],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7o5s6.DeleteSection), null, children);
            }
        },
        {
            type: 'block-menu-item',
            key: (0, $8i6M6.DELETE_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $8i6M6.DELETE_MENU_SECTION).key,
                rank: (0, $cCXFd.DELETE_MENU_SECTION_RANK)[(0, $8i6M6.DELETE_MENU_ITEM).key]
            },
            component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gmOz9.DeleteDropdownItem), {
                    api: api
                })
        }
    ];
};
module.exports["getBlockMenuComponents"] = $4e8adb76ce9b4b67$export$b1be7b75e24fc24b;

});

parcelRegister("eCTkH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $krYZG = parcelRequire("krYZG");


var $8i6M6 = parcelRequire("8i6M6");


var $3k5Tv = parcelRequire("3k5Tv");


var $ldqjS = parcelRequire("ldqjS");


var $3FYPH = parcelRequire("3FYPH");


var $dVKvM = parcelRequire("dVKvM");

var $i9j2V = parcelRequire("i9j2V");


var $kTb7m = parcelRequire("kTb7m");


var $ixfCV = parcelRequire("ixfCV");


var $hQ7KE = parcelRequire("hQ7KE");


var $8059h = parcelRequire("8059h");


var $b4364 = parcelRequire("b4364");


var $fMb2n = parcelRequire("fMb2n");


var $1Hjlq = parcelRequire("1Hjlq");

const $fd09b2b019b3f5a1$var$CopyLinkDropdownItemContent = ({ api: api, config: config })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { onDropdownOpenChanged: onDropdownOpenChanged } = (0, $b4364.useBlockMenu)();
    const { getLinkPath: getLinkPath, blockLinkHashPrefix: blockLinkHashPrefix } = config || {};
    const shortcut = (0, $ldqjS.formatShortcut)((0, $ldqjS.copyLinkToBlock));
    const { preservedSelection: preservedSelection, defaultSelection: defaultSelection } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'blockControls',
        'selection'
    ], ({ blockControlsState: blockControlsState, selectionState: selectionState })=>{
        return {
            preservedSelection: blockControlsState?.preservedSelection,
            defaultSelection: selectionState?.selection
        };
    });
    const selection = preservedSelection || defaultSelection;
    const handleClick = (0, $cozmU.useCallback)(()=>{
        if (!selection) return;
        api?.core.actions.execute(({ tr: tr })=>{
            const payload = {
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).BLOCK_MENU_ITEM,
                attributes: {
                    menuItemName: (0, $fMb2n.BLOCK_MENU_ITEM_NAME).COPY_LINK_TO_BLOCK
                },
                eventType: (0, $krYZG.EVENT_TYPE).UI
            };
            api?.analytics?.actions?.attachAnalyticsEvent(payload)(tr);
            api?.blockControls?.commands?.toggleBlockMenu({
                closeMenu: true
            })({
                tr: tr
            });
            return tr;
        });
        onDropdownOpenChanged(false);
        (0, $1Hjlq.copyLink)({
            getLinkPath: getLinkPath,
            blockLinkHashPrefix: blockLinkHashPrefix,
            selection: selection
        }).then((success)=>{
            if (success) api?.core.actions.execute(({ tr: tr })=>{
                tr.setMeta((0, $8059h.blockMenuPluginKey), {
                    showFlag: (0, $hQ7KE.FLAG_ID).LINK_COPIED_TO_CLIPBOARD
                });
                return tr;
            });
        });
    }, [
        api,
        blockLinkHashPrefix,
        getLinkPath,
        onDropdownOpenChanged,
        selection
    ]);
    // Hide copy link when `platform_editor_adf_with_localid` feature flag is off
    if (!(0, $ixfCV.fg)('platform_editor_adf_with_localid')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
            label: "",
            size: "small"
        }),
        elemAfter: shortcut ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i9j2V.ToolbarKeyboardShortcutHint), {
            shortcut: shortcut
        }) : undefined,
        ariaKeyshortcuts: shortcut,
        testId: (0, $8i6M6.BLOCK_MENU_ACTION_TEST_ID).COPY_LINK
    }, formatMessage((0, $3FYPH.messages).copyLinkToSelection));
};
const $fd09b2b019b3f5a1$export$86b0dd217bb75f55 = (0, $kSwu1.injectIntl)($fd09b2b019b3f5a1$var$CopyLinkDropdownItemContent);
module.exports["CopyLinkDropdownItem"] = $fd09b2b019b3f5a1$export$86b0dd217bb75f55;

});

parcelRegister("fMb2n", function(module, exports) {
const $637ed6a17a53fc38$export$3049469618923b43 = 'Editor Block Menu';
const $637ed6a17a53fc38$export$659b32b68ac9a52b = {
    COPY_LINK_TO_BLOCK: 'copyLinkToBlock',
    MOVE_UP: 'moveUp',
    MOVE_DOWN: 'moveDown',
    DELETE: 'delete',
    FORMAT_MENU: 'formatMenu'
};
module.exports["BLOCK_MENU_ITEM_NAME"] = $637ed6a17a53fc38$export$659b32b68ac9a52b;

});

parcelRegister("3AuJS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jgJIe = parcelRequire("jgJIe");

const $e19ff2d730d20a22$export$ec4637f07afe304 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), {
        hasSeparator: true
    }, children);
};
module.exports["CopySection"] = $e19ff2d730d20a22$export$ec4637f07afe304;

});

parcelRegister("gmOz9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $krYZG = parcelRequire("krYZG");


var $8i6M6 = parcelRequire("8i6M6");


var $3FYPH = parcelRequire("3FYPH");


var $lVAkE = parcelRequire("lVAkE");


var $dVKvM = parcelRequire("dVKvM");


var $iDfTs = parcelRequire("iDfTs");


var $3izAL = parcelRequire("3izAL");


var $6Pqow = parcelRequire("6Pqow");


var $fMb2n = parcelRequire("fMb2n");

const $12b0fb4a70c7f64c$var$DeleteDropdownItemContent = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const onClick = ()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            const payload = {
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).BLOCK_MENU_ITEM,
                attributes: {
                    menuItemName: (0, $fMb2n.BLOCK_MENU_ITEM_NAME).DELETE
                },
                eventType: (0, $krYZG.EVENT_TYPE).UI
            };
            api?.analytics?.actions?.attachAnalyticsEvent(payload)(tr);
            // Extract node information before deletion
            const preservedSelection = api?.blockControls?.sharedState.currentState()?.preservedSelection;
            const selection = preservedSelection || tr.selection;
            const sourceNodes = (0, $lVAkE.getSourceNodesFromSelectionRange)(tr, selection);
            const nodeCount = sourceNodes.length;
            // Fire node deletion analytics event if nodes are being deleted
            if (nodeCount > 0) {
                const nodeType = sourceNodes.length === 1 ? sourceNodes[0].type.name : 'multiple';
                const nodeDeletedPayload = {
                    action: (0, $krYZG.ACTION).DELETED,
                    actionSubject: (0, $krYZG.ACTION_SUBJECT).ELEMENT,
                    attributes: {
                        inputMethod: (0, $krYZG.INPUT_METHOD).BLOCK_MENU,
                        nodeType: nodeType,
                        nodeCount: nodeCount
                    },
                    eventType: (0, $krYZG.EVENT_TYPE).TRACK
                };
                api?.analytics?.actions?.attachAnalyticsEvent(nodeDeletedPayload)(tr);
            }
            (0, $lVAkE.deleteSelectedRange)(tr, preservedSelection);
            api?.blockControls?.commands?.toggleBlockMenu({
                closeMenu: true
            })({
                tr: tr
            });
            if (preservedSelection) api?.blockControls?.commands?.stopPreservingSelection()({
                tr: tr
            });
            return tr;
        });
        api?.core.actions.focus();
    };
    const onShowHoverDecoration = (0, $cozmU.useCallback)(()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            const preservedSelection = api?.blockControls?.sharedState.currentState()?.preservedSelection;
            api?.decorations?.commands?.hoverDecoration?.({
                add: true,
                selection: preservedSelection
            })({
                tr: tr
            });
            return tr;
        });
    }, [
        api
    ]);
    const onRemoveHoverDecoration = (0, $cozmU.useCallback)(()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            api?.decorations?.commands?.removeDecoration?.()({
                tr: tr
            });
            return tr;
        });
    }, [
        api
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            // clean up hover decoration when unmounting
            onRemoveHoverDecoration();
        };
    }, [
        onRemoveHoverDecoration
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        onMouseEnter: onShowHoverDecoration,
        onMouseLeave: onRemoveHoverDecoration,
        onFocus: onShowHoverDecoration,
        onBlur: onRemoveHoverDecoration
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
            color: "var(--ds-icon-danger, #C9372C)",
            label: "",
            size: "small"
        }),
        onClick: onClick,
        testId: (0, $8i6M6.BLOCK_MENU_ACTION_TEST_ID).DELETE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        as: "span",
        color: "color.text.danger"
    }, formatMessage((0, $3FYPH.messages).deleteBlock))));
};
const $12b0fb4a70c7f64c$export$920a93f5040e5764 = (0, $kSwu1.injectIntl)($12b0fb4a70c7f64c$var$DeleteDropdownItemContent);
module.exports["DeleteDropdownItem"] = $12b0fb4a70c7f64c$export$920a93f5040e5764;

});

parcelRegister("7o5s6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jgJIe = parcelRequire("jgJIe");

const $cc639058324b1de9$export$b65e02347f5cba52 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), {
        hasSeparator: true
    }, children);
};
module.exports["DeleteSection"] = $cc639058324b1de9$export$b65e02347f5cba52;

});

parcelRegister("VOsgf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $krYZG = parcelRequire("krYZG");


var $3FYPH = parcelRequire("3FYPH");


var $gk3KR = parcelRequire("gk3KR");


var $lCTy3 = parcelRequire("lCTy3");


var $aDSIl = parcelRequire("aDSIl");


var $ixfCV = parcelRequire("ixfCV");


var $fMb2n = parcelRequire("fMb2n");

const $70f7f5d30074ff32$var$BLOCK_MENU_TRANSFORM_SPOTLIGHT_PORTAL_SELECTOR = '[data-test-id="block-menu-transform-spotlight-portal-container"]';
const $70f7f5d30074ff32$var$shouldIgnoreBlockMenuTransformSpotlightCloseEvent = (event)=>event.target instanceof Element && event.target.closest($70f7f5d30074ff32$var$BLOCK_MENU_TRANSFORM_SPOTLIGHT_PORTAL_SELECTOR) !== null;
const $70f7f5d30074ff32$export$d1e6269624c4d543 = ({ api: api, children: children })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const formatMenuLabel = (0, $3FYPH.messages).changeFormat;
    const handleClick = (0, $cozmU.useCallback)(()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            const payload = {
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).BLOCK_MENU_ITEM,
                attributes: {
                    menuItemName: (0, $fMb2n.BLOCK_MENU_ITEM_NAME).FORMAT_MENU
                },
                eventType: (0, $krYZG.EVENT_TYPE).UI
            };
            api?.analytics?.actions?.attachAnalyticsEvent(payload)(tr);
            return tr;
        });
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gk3KR.ToolbarNestedDropdownMenu), {
        text: formatMessage(formatMenuLabel),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))), {
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
            label: "",
            size: "small"
        }),
        enableMaxHeight: true,
        onClick: handleClick,
        dropdownTestId: "editor-turn-into-menu",
        testId: (0, $ixfCV.fg)('cc_blocks_changeboarding') ? 'turn-into-block-menu-btn' : undefined,
        shouldFitContainer: true,
        shouldIgnoreCloseEvent: (0, $ixfCV.fg)('cc_blocks_changeboarding') ? $70f7f5d30074ff32$var$shouldIgnoreBlockMenuTransformSpotlightCloseEvent : undefined
    }, children);
};
module.exports["FormatMenuComponent"] = $70f7f5d30074ff32$export$d1e6269624c4d543;

});

parcelRegister("8H0C5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jgJIe = parcelRequire("jgJIe");


var $anBbz = parcelRequire("anBbz");


var $hIpbV = parcelRequire("hIpbV");

const $ee727c19ac2272f0$export$c21c1480ef33ab5 = ({ children: children, api: api })=>{
    const isFormatMenuHidden = (0, $cozmU.useCallback)(()=>{
        return (0, $hIpbV.checkIsFormatMenuHidden)(api);
    }, [
        api
    ]);
    if (isFormatMenuHidden()) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), {
        hasSeparator: (0, $anBbz.expValEqualsNoExposure)('platform_editor_ai_blockmenu_integration', 'isEnabled', true)
    }, children);
};
module.exports["FormatMenuSection"] = $ee727c19ac2272f0$export$c21c1480ef33ab5;

});

parcelRegister("hIpbV", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $bjg0G = parcelRequire("bjg0G");


var $ixfCV = parcelRequire("ixfCV");

const $33ccaf51e9f72830$var$getDisabledNodeTypes = (0, $dOBRD.default)((nodes)=>[
        nodes.rule,
        ...(0, $ixfCV.fg)('confluence_frontend_native_tabs_extension') ? [
            nodes.multiBodiedExtension
        ] : []
    ]);
const $33ccaf51e9f72830$var$getIsFormatMenuHidden = (selection, schema)=>{
    const nodes = schema.nodes;
    if (!nodes) return false;
    const disabledNode = (0, $bjg0G.findSelectedNodeOfType)($33ccaf51e9f72830$var$getDisabledNodeTypes(nodes))(selection);
    return !!disabledNode;
};
const $33ccaf51e9f72830$export$b9b8afbbcc99cd12 = (api)=>{
    const selection = api?.selection?.sharedState?.currentState()?.selection;
    const schema = api?.core.sharedState.currentState()?.schema;
    const menuTriggerBy = api?.blockControls?.sharedState.currentState()?.menuTriggerBy;
    if (!selection || !schema || !menuTriggerBy) return false;
    return $33ccaf51e9f72830$var$getIsFormatMenuHidden(selection, schema);
};
module.exports["checkIsFormatMenuHidden"] = $33ccaf51e9f72830$export$b9b8afbbcc99cd12;

});

parcelRegister("9Q8hQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $jgJIe = parcelRequire("jgJIe");

const $50b12c000401bf4a$export$4b1545b4f2016d26 = ({ children: children, title: title, hasSeparator: hasSeparator })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), {
        title: formatMessage(title),
        hasSeparator: hasSeparator
    }, children);
};
module.exports["MenuSection"] = $50b12c000401bf4a$export$4b1545b4f2016d26;

});

parcelRegister("6Edc5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $haNN4 = parcelRequire("haNN4");


var $krYZG = parcelRequire("krYZG");


var $8i6M6 = parcelRequire("8i6M6");


var $3k5Tv = parcelRequire("3k5Tv");


var $3FYPH = parcelRequire("3FYPH");


var $1xYQH = parcelRequire("1xYQH");


var $dVKvM = parcelRequire("dVKvM");


var $fS8Zl = parcelRequire("fS8Zl");


var $b4364 = parcelRequire("b4364");


var $fMb2n = parcelRequire("fMb2n");


var $5mCNw = parcelRequire("5mCNw");

const $33c7c756efc87a32$var$MoveDownDropdownItemContent = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { moveUpRef: moveUpRef, moveDownRef: moveDownRef, getFirstSelectedDomNode: getFirstSelectedDomNode } = (0, $b4364.useBlockMenu)();
    const { canMoveDown: canMoveDown } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'blockControls'
    ], ({ blockControlsState: blockControlsState })=>{
        return {
            canMoveDown: blockControlsState?.blockMenuOptions?.canMoveDown
        };
    });
    // Maybe don't need this
    (0, $cozmU.useEffect)(()=>{
        const doc = (0, $haNN4.getDocument)();
        if (!canMoveDown && moveDownRef.current && doc && moveDownRef.current === doc.activeElement && moveUpRef.current) moveUpRef.current.focus();
    }, [
        canMoveDown,
        moveUpRef,
        moveDownRef
    ]);
    const handleClick = ()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            const payload = {
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).BLOCK_MENU_ITEM,
                attributes: {
                    menuItemName: (0, $fMb2n.BLOCK_MENU_ITEM_NAME).MOVE_DOWN
                },
                eventType: (0, $krYZG.EVENT_TYPE).UI
            };
            api?.analytics?.actions?.attachAnalyticsEvent(payload)(tr);
            api?.blockControls?.commands?.moveNodeWithBlockMenu((0, $1xYQH.DIRECTION).DOWN)({
                tr: tr
            });
            return tr;
        });
        requestAnimationFrame(()=>{
            const newFirstNode = getFirstSelectedDomNode();
            (0, $5mCNw.fixBlockMenuPositionAndScroll)(newFirstNode);
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        triggerRef: moveDownRef,
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fS8Zl))), {
            label: "",
            size: "small"
        }),
        isDisabled: !canMoveDown,
        testId: (0, $8i6M6.BLOCK_MENU_ACTION_TEST_ID).MOVE_DOWN
    }, formatMessage((0, $3FYPH.messages).moveDownBlock));
};
const $33c7c756efc87a32$export$bae9e9a61a4ab27d = (0, $kSwu1.injectIntl)($33c7c756efc87a32$var$MoveDownDropdownItemContent);
module.exports["MoveDownDropdownItem"] = $33c7c756efc87a32$export$bae9e9a61a4ab27d;

});

parcelRegister("5mCNw", function(module, exports) {

var $haNN4 = parcelRequire("haNN4");


var $8i6M6 = parcelRequire("8i6M6");

const $ae931fe84820c8fd$export$c178f82ad1bfa2e5 = (firstSelectedNode)=>{
    const doc = (0, $haNN4.getDocument)();
    if (!doc) return;
    const blockMenuEl = doc.querySelector(`[data-testid="${(0, $8i6M6.BLOCK_MENU_TEST_ID)}"]`);
    if (!blockMenuEl?.parentElement) return;
    const scrollableContainer = doc.querySelector('[data-testid="editor-content-container"]');
    if (!firstSelectedNode || !scrollableContainer) return;
    const parentElement = blockMenuEl.parentElement;
    const currentTop = parentElement.getBoundingClientRect().top;
    const distance = firstSelectedNode.getBoundingClientRect().top - blockMenuEl.getBoundingClientRect().top;
    scrollableContainer.scrollBy({
        behavior: 'instant',
        top: distance
    });
    const newTop = parentElement.getBoundingClientRect().top;
    const topDifference = currentTop - newTop;
    const hasTopProperty = parentElement.style.top !== '';
    const hasBottomProperty = parentElement.style.bottom !== '';
    if (hasBottomProperty && !hasTopProperty) {
        const currentBottomValue = parseFloat(parentElement.style.bottom || '0');
        parentElement.style.bottom = `${currentBottomValue - topDifference}px`;
    } else {
        const currentTopValue = parseFloat(parentElement.style.top || '0');
        parentElement.style.top = `${currentTopValue + topDifference}px`;
    }
};
module.exports["fixBlockMenuPositionAndScroll"] = $ae931fe84820c8fd$export$c178f82ad1bfa2e5;

});

parcelRegister("eUIQd", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $haNN4 = parcelRequire("haNN4");


var $krYZG = parcelRequire("krYZG");


var $8i6M6 = parcelRequire("8i6M6");


var $3k5Tv = parcelRequire("3k5Tv");


var $3FYPH = parcelRequire("3FYPH");


var $1xYQH = parcelRequire("1xYQH");


var $dVKvM = parcelRequire("dVKvM");


var $f6cdQ = parcelRequire("f6cdQ");


var $b4364 = parcelRequire("b4364");


var $fMb2n = parcelRequire("fMb2n");


var $5mCNw = parcelRequire("5mCNw");

const $953a086cb19f12d4$var$MoveUpDropdownItemContent = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { moveUpRef: moveUpRef, moveDownRef: moveDownRef, getFirstSelectedDomNode: getFirstSelectedDomNode } = (0, $b4364.useBlockMenu)();
    const { canMoveUp: canMoveUp } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'blockControls'
    ], ({ blockControlsState: blockControlsState })=>{
        return {
            canMoveUp: blockControlsState?.blockMenuOptions?.canMoveUp
        };
    });
    (0, $cozmU.useEffect)(()=>{
        const doc = (0, $haNN4.getDocument)();
        if (!canMoveUp && moveUpRef.current && doc && moveUpRef.current === doc.activeElement && moveDownRef.current) moveDownRef.current.focus();
    }, [
        canMoveUp,
        moveDownRef,
        moveUpRef
    ]);
    const handleClick = ()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            const payload = {
                action: (0, $krYZG.ACTION).CLICKED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).BLOCK_MENU_ITEM,
                attributes: {
                    menuItemName: (0, $fMb2n.BLOCK_MENU_ITEM_NAME).MOVE_UP
                },
                eventType: (0, $krYZG.EVENT_TYPE).UI
            };
            api?.analytics?.actions?.attachAnalyticsEvent(payload)(tr);
            api?.blockControls?.commands?.moveNodeWithBlockMenu((0, $1xYQH.DIRECTION).UP)({
                tr: tr
            });
            return tr;
        });
        requestAnimationFrame(()=>{
            const newFirstNode = getFirstSelectedDomNode();
            (0, $5mCNw.fixBlockMenuPositionAndScroll)(newFirstNode);
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        triggerRef: moveUpRef,
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))), {
            label: "",
            size: "small"
        }),
        isDisabled: !canMoveUp,
        testId: (0, $8i6M6.BLOCK_MENU_ACTION_TEST_ID).MOVE_UP
    }, formatMessage((0, $3FYPH.messages).moveUpBlock));
};
const $953a086cb19f12d4$export$bed5c407f49c1363 = (0, $kSwu1.injectIntl)($953a086cb19f12d4$var$MoveUpDropdownItemContent);
module.exports["MoveUpDropdownItem"] = $953a086cb19f12d4$export$bed5c407f49c1363;

});

parcelRegister("4go67", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3FYPH = parcelRequire("3FYPH");


var $jgJIe = parcelRequire("jgJIe");


var $i0GqV = parcelRequire("i0GqV");


var $3Zhnz = parcelRequire("3Zhnz");

const $58ef7f8eccc40165$export$3ccae8d9afcf2256 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ api: api, children: children })=>{
    const suggestedItems = (0, $i0GqV.useSuggestedItems)(api);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (suggestedItems.length === 0) return null;
    const hasSeparator = (0, $3Zhnz.hasCreateSectionContent)(api) || (0, $3Zhnz.hasStructureSectionContent)(api);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), {
        title: formatMessage((0, $3FYPH.messages).suggested),
        hasSeparator: hasSeparator
    }, children);
});
module.exports["SuggestedItemsMenuSection"] = $58ef7f8eccc40165$export$3ccae8d9afcf2256;

});

parcelRegister("i0GqV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3k5Tv = parcelRequire("3k5Tv");


var $ihHNx = parcelRequire("ihHNx");


var $gDoPM = parcelRequire("gDoPM");

const $479db1b1f6d35d3d$export$e7773a638c2f1d4c = (api)=>{
    const { preservedSelection: preservedSelection, selection: selection } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'blockControls',
        'selection'
    ], (states)=>({
            preservedSelection: states.blockControlsState?.preservedSelection,
            selection: states.selectionState?.selection
        }));
    const blockMenuComponents = api?.blockMenu?.actions.getBlockMenuComponents();
    const menuItemsMap = (0, $cozmU.useMemo)(()=>{
        return (0, $ihHNx.createMenuItemsMap)(blockMenuComponents);
    }, [
        blockMenuComponents
    ]);
    const suggestedItems = (0, $cozmU.useMemo)(()=>{
        const currentSelection = preservedSelection || selection;
        return (0, $gDoPM.getSuggestedItemsFromSelection)(menuItemsMap, currentSelection);
    }, [
        menuItemsMap,
        preservedSelection,
        selection
    ]);
    return suggestedItems;
};
module.exports["useSuggestedItems"] = $479db1b1f6d35d3d$export$e7773a638c2f1d4c;

});

parcelRegister("ihHNx", function(module, exports) {
const $86e319e5e700a4f6$export$9c09a74c46b5b186 = (blockMenuComponents)=>{
    if (!blockMenuComponents) return new Map();
    return new Map(blockMenuComponents.filter((c)=>c.type === 'block-menu-item').map((item)=>[
            item.key,
            item
        ]));
};
module.exports["createMenuItemsMap"] = $86e319e5e700a4f6$export$9c09a74c46b5b186;

});

parcelRegister("gDoPM", function(module, exports) {

var $lVAkE = parcelRequire("lVAkE");


var $gnxj8 = parcelRequire("gnxj8");


var $7VcYz = parcelRequire("7VcYz");

const $9fb902d68861260d$export$199c6fc3d931fd5e = (menuItemsMap, currentSelection)=>{
    if (menuItemsMap.size === 0 || !currentSelection) return [];
    const { range: range } = (0, $lVAkE.expandSelectionToBlockRange)(currentSelection);
    if (!range) return [];
    const blockNodes = (0, $gnxj8.getBlockNodesInRange)(range);
    if (blockNodes.length === 0) return [];
    const firstNodeType = blockNodes[0].type.name;
    const allSameType = blockNodes.every((node)=>node.type.name === firstNodeType);
    if (!allSameType) return [];
    const nodeTypeName = firstNodeType;
    const sortedKeys = (0, $7VcYz.getSortedSuggestedItems)(nodeTypeName);
    return sortedKeys.map((key)=>menuItemsMap.get(key)).filter((item)=>item !== undefined && !item.isHidden?.());
};
module.exports["getSuggestedItemsFromSelection"] = $9fb902d68861260d$export$199c6fc3d931fd5e;

});

parcelRegister("7VcYz", function(module, exports) {
/**
 * Suggested transformations mapping for each block type.
 * Based on the Block Menu Compatibility Matrix:
 * https://hello.atlassian.net/wiki/spaces/egcuc/pages/5868774224/Block+Menu+Compatibility+Matrix#Suggested-for-each-block-type
 *
 * This mapping defines which transform items should appear in the TRANSFORM_SUGGESTED_MENU_SECTION
 * for each block type, ranked by priority (lower rank = higher priority).
 *
 * Structure:
 * {
 *   [sourceNodeType]: {
 *     [targetMenuItemKey]: rank
 *   }
 * }
 */ 
var $8i6M6 = parcelRequire("8i6M6");

const $7c313822fab2cab3$export$3dc4cfed1502c18 = {
    PARAGRAPH: 'paragraph',
    EXPAND: 'expand',
    BLOCKQUOTE: 'blockquote',
    LAYOUT_SECTION: 'layoutSection',
    PANEL: 'panel',
    CODE_BLOCK: 'codeBlock',
    DECISION: 'decisionList',
    BULLET_LIST: 'bulletList',
    ORDERED_LIST: 'orderedList',
    HEADING: 'heading',
    TASK_LIST: 'taskList',
    MEDIA_SINGLE: 'mediaSingle',
    EXTENSION: 'extension',
    BODIED_EXTENSION: 'bodiedExtension',
    BLOCK_CARD: 'blockCard',
    EMBED_CARD: 'embedCard',
    TABLE: 'table'
};
const $7c313822fab2cab3$export$651a8624ef7a76eb = {
    [$7c313822fab2cab3$export$3dc4cfed1502c18.PARAGRAPH]: {
        [(0, $8i6M6.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 100,
        [(0, $8i6M6.TRANSFORM_HEADINGS_H1_MENU_ITEM).key]: 200,
        [(0, $8i6M6.TRANSFORM_HEADINGS_H2_MENU_ITEM).key]: 300
    },
    [$7c313822fab2cab3$export$3dc4cfed1502c18.EXPAND]: {
        [(0, $8i6M6.TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM).key]: 100,
        [(0, $8i6M6.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 200,
        [(0, $8i6M6.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key]: 300
    },
    [$7c313822fab2cab3$export$3dc4cfed1502c18.BLOCKQUOTE]: {
        [(0, $8i6M6.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key]: 100,
        [(0, $8i6M6.TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM).key]: 200,
        [(0, $8i6M6.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 300
    },
    [$7c313822fab2cab3$export$3dc4cfed1502c18.LAYOUT_SECTION]: {
        [(0, $8i6M6.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 100,
        [(0, $8i6M6.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key]: 200,
        [(0, $8i6M6.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key]: 300
    },
    [$7c313822fab2cab3$export$3dc4cfed1502c18.PANEL]: {
        [(0, $8i6M6.TRANSFORM_STRUCTURE_QUOTE_MENU_ITEM).key]: 100,
        [(0, $8i6M6.TRANSFORM_STRUCTURE_CODE_BLOCK_MENU_ITEM).key]: 200,
        [(0, $8i6M6.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key]: 300
    },
    [$7c313822fab2cab3$export$3dc4cfed1502c18.CODE_BLOCK]: {
        [(0, $8i6M6.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key]: 100,
        [(0, $8i6M6.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 200,
        [(0, $8i6M6.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key]: 300
    },
    [$7c313822fab2cab3$export$3dc4cfed1502c18.DECISION]: {
        [(0, $8i6M6.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 100,
        [(0, $8i6M6.TRANSFORM_STRUCTURE_QUOTE_MENU_ITEM).key]: 200,
        [(0, $8i6M6.TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM).key]: 300
    },
    [$7c313822fab2cab3$export$3dc4cfed1502c18.BULLET_LIST]: {
        [(0, $8i6M6.TRANSFORM_STRUCTURE_NUMBERED_LIST_MENU_ITEM).key]: 100,
        [(0, $8i6M6.TRANSFORM_STRUCTURE_QUOTE_MENU_ITEM).key]: 200,
        [(0, $8i6M6.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 300
    },
    [$7c313822fab2cab3$export$3dc4cfed1502c18.ORDERED_LIST]: {
        [(0, $8i6M6.TRANSFORM_STRUCTURE_TASK_LIST_MENU_ITEM).key]: 100,
        [(0, $8i6M6.TRANSFORM_STRUCTURE_BULLETED_LIST_MENU_ITEM).key]: 200,
        [(0, $8i6M6.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 300
    },
    [$7c313822fab2cab3$export$3dc4cfed1502c18.HEADING]: {
        [(0, $8i6M6.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key]: 100,
        [(0, $8i6M6.TRANSFORM_STRUCTURE_BULLETED_LIST_MENU_ITEM).key]: 200,
        [(0, $8i6M6.TRANSFORM_STRUCTURE_QUOTE_MENU_ITEM).key]: 300
    },
    [$7c313822fab2cab3$export$3dc4cfed1502c18.TASK_LIST]: {
        [(0, $8i6M6.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 100,
        [(0, $8i6M6.TRANSFORM_STRUCTURE_NUMBERED_LIST_MENU_ITEM).key]: 200,
        [(0, $8i6M6.TRANSFORM_STRUCTURE_BULLETED_LIST_MENU_ITEM).key]: 300
    },
    [$7c313822fab2cab3$export$3dc4cfed1502c18.MEDIA_SINGLE]: {
        [(0, $8i6M6.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 100,
        [(0, $8i6M6.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key]: 200,
        [(0, $8i6M6.TRANSFORM_STRUCTURE_QUOTE_MENU_ITEM).key]: 300
    },
    [$7c313822fab2cab3$export$3dc4cfed1502c18.EXTENSION]: {
        [(0, $8i6M6.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key]: 100,
        [(0, $8i6M6.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 200,
        [(0, $8i6M6.TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM).key]: 300
    }
};
const $7c313822fab2cab3$export$af576b484f6dbef1 = (nodeType)=>{
    return $7c313822fab2cab3$export$651a8624ef7a76eb[nodeType];
};
const $7c313822fab2cab3$export$5a70f53de53a8267 = (nodeType)=>{
    const suggestions = $7c313822fab2cab3$export$af576b484f6dbef1(nodeType);
    if (!suggestions) return [];
    return Object.entries(suggestions).sort(([, rankA], [, rankB])=>rankA - rankB).map(([key])=>key);
};
module.exports["getSortedSuggestedItems"] = $7c313822fab2cab3$export$5a70f53de53a8267;

});

parcelRegister("3Zhnz", function(module, exports) {

var $8i6M6 = parcelRequire("8i6M6");


var $amBkk = parcelRequire("amBkk");

/**
 * Checks if a section has any visible content (items that will render)
 */ const $56b6010d86a8a86a$var$hasSectionContent = (sectionKey, api)=>{
    const blockMenuComponents = api?.blockMenu?.actions.getBlockMenuComponents();
    if (!blockMenuComponents) return false;
    const childrenMap = (0, $amBkk.buildChildrenMap)(blockMenuComponents);
    const sectionMapKey = (0, $amBkk.getChildrenMapKey)(sectionKey, 'block-menu-section');
    const sectionChildren = childrenMap.get(sectionMapKey) || [];
    return sectionChildren.some((child)=>(0, $amBkk.willComponentRender)(child, childrenMap));
};
const $56b6010d86a8a86a$export$761e0048084c1c43 = (api)=>{
    return $56b6010d86a8a86a$var$hasSectionContent((0, $8i6M6.TRANSFORM_SUGGESTED_MENU_SECTION).key, api);
};
const $56b6010d86a8a86a$export$3cacaf84fd07b7b3 = (api)=>{
    return $56b6010d86a8a86a$var$hasSectionContent((0, $8i6M6.TRANSFORM_CREATE_MENU_SECTION).key, api);
};
const $56b6010d86a8a86a$export$633de4ec9855cbed = (api)=>{
    return $56b6010d86a8a86a$var$hasSectionContent((0, $8i6M6.TRANSFORM_STRUCTURE_MENU_SECTION).key, api);
};
const $56b6010d86a8a86a$export$8f788dc27a6f5b7d = (api)=>{
    return $56b6010d86a8a86a$export$761e0048084c1c43(api);
};
const $56b6010d86a8a86a$export$efe26e6796f95688 = (api)=>{
    return $56b6010d86a8a86a$export$3cacaf84fd07b7b3(api) || $56b6010d86a8a86a$export$761e0048084c1c43(api);
};
const $56b6010d86a8a86a$export$1ad0a715a8fd69d9 = (api)=>{
    return $56b6010d86a8a86a$export$633de4ec9855cbed(api) || $56b6010d86a8a86a$export$3cacaf84fd07b7b3(api) || $56b6010d86a8a86a$export$761e0048084c1c43(api);
};
module.exports["hasCreateSectionContent"] = $56b6010d86a8a86a$export$3cacaf84fd07b7b3;
module.exports["hasStructureSectionContent"] = $56b6010d86a8a86a$export$633de4ec9855cbed;
module.exports["hasContentBeforeCreate"] = $56b6010d86a8a86a$export$8f788dc27a6f5b7d;
module.exports["hasContentBeforeStructure"] = $56b6010d86a8a86a$export$efe26e6796f95688;
module.exports["hasContentBeforeHeadings"] = $56b6010d86a8a86a$export$1ad0a715a8fd69d9;

});

parcelRegister("lk85x", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $i0GqV = parcelRequire("i0GqV");

const $8afb282e07777a37$export$a038b8788149eebb = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ api: api })=>{
    const suggestedItems = (0, $i0GqV.useSuggestedItems)(api);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, suggestedItems.map((item)=>{
        const ItemComponent = item.component;
        return ItemComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemComponent, {
            key: item.key,
            isSuggested: true
        }) : null;
    }));
});
module.exports["SuggestedMenuItems"] = $8afb282e07777a37$export$a038b8788149eebb;

});

parcelRegister("2Cg6W", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3k5Tv = parcelRequire("3k5Tv");


var $3FYPH = parcelRequire("3FYPH");


var $a2foB = parcelRequire("a2foB");

var $FKQbh = parcelRequire("FKQbh");

var $lqtHz = parcelRequire("lqtHz");


var $iZMIZ = parcelRequire("iZMIZ");


var $hQ7KE = parcelRequire("hQ7KE");


var $8059h = parcelRequire("8059h");

const $720563a9850f6d16$var$flagMap = {
    [(0, $hQ7KE.FLAG_ID).LINK_COPIED_TO_CLIPBOARD]: {
        title: (0, $3FYPH.messages).linkCopiedToClipboard,
        autoDismiss: true
    }
};
const $720563a9850f6d16$export$48ea269755562084 = ({ api: api })=>{
    const { showFlag: showFlag } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'blockMenu'
    ], (states)=>{
        return {
            showFlag: states.blockMenuState?.showFlag
        };
    });
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!showFlag) return;
    const { title: title } = $720563a9850f6d16$var$flagMap[showFlag];
    const onDismissed = ()=>{
        api?.core.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $8059h.blockMenuPluginKey), {
                showFlag: false
            });
            return tr;
        });
        api?.core.actions.focus();
    };
    const FlagComponent = $720563a9850f6d16$var$flagMap[showFlag].autoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lqtHz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(FlagComponent, {
        onDismissed: onDismissed,
        title: formatMessage(title),
        id: showFlag,
        testId: showFlag,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iZMIZ))), {
            label: "",
            color: "var(--ds-icon-success, #6A9A23)",
            size: "small"
        })
    }));
};
module.exports["Flag"] = $720563a9850f6d16$export$48ea269755562084;

});

parcelRegister("gh55E", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $iLrhi = parcelRequire("iLrhi");


var $3xuv0 = parcelRequire("3xuv0");


var $eOaGc = parcelRequire("eOaGc");


var $ixfCV = parcelRequire("ixfCV");


var $7TcbF = parcelRequire("7TcbF");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $aQ9Nh = parcelRequire("aQ9Nh");


var $6rAEj = parcelRequire("6rAEj");


var $a8NwW = parcelRequire("a8NwW");


var $eEHpO = parcelRequire("eEHpO");


var $k5ilr = parcelRequire("k5ilr");


var $jkbED = parcelRequire("jkbED");


var $alVJS = parcelRequire("alVJS");


var $jm7OT = parcelRequire("jm7OT");


var $6ixNC = parcelRequire("6ixNC");


var $auTW7 = parcelRequire("auTW7");


var $g5VrR = parcelRequire("g5VrR");


var $89tlI = parcelRequire("89tlI");


var $fkzSG = parcelRequire("fkzSG");


var $03X0Y = parcelRequire("03X0Y");

const $337191a1934f18d7$var$providerBuilder = (collabEditProviderPromise)=>async (codeToExecute, onError)=>{
        try {
            const provider = await collabEditProviderPromise;
            if (provider) return codeToExecute(provider);
        } catch (err) {
            if (onError) onError(err);
            else // eslint-disable-next-line no-console
            console.error(err);
        }
    };
const $337191a1934f18d7$var$createAddInlineCommentMark = (providerPromise)=>({ from: from, to: to, mark: mark })=>{
        providerPromise.then((provider)=>{
            const commentMark = new (0, $eOaGc.AddMarkStep)(Math.min(from, to), Math.max(from, to), mark);
            // @ts-expect-error 2339: Property 'api' does not exist on type 'CollabEditProvider<CollabEvents>'.
            provider.api?.addComment([
                commentMark
            ]);
        });
        return false;
    };
const $337191a1934f18d7$var$createAddInlineCommentNodeMark = (providerPromise)=>({ pos: pos, mark: mark })=>{
        providerPromise.then((provider)=>{
            const commentMark = new (0, $eOaGc.AddNodeMarkStep)(pos, mark);
            // @ts-expect-error 2339: Property 'api' does not exist on type 'CollabEditProvider<CollabEvents>'.
            provider.api?.addComment([
                commentMark
            ]);
        });
        return false;
    };
const $337191a1934f18d7$export$7b59344e4e475116 = ({ config: options, api: api })=>{
    const featureFlags = api?.featureFlags?.sharedState.currentState() || {};
    let providerResolver = ()=>{};
    const editorViewRef = {
        current: null
    };
    const collabEditProviderPromise = new Promise((_providerResolver)=>{
        providerResolver = _providerResolver;
    });
    const executeProviderCode = $337191a1934f18d7$var$providerBuilder(collabEditProviderPromise);
    return {
        name: 'collabEdit',
        getSharedState (state) {
            if (!state) return {
                initialised: {
                    collabInitialisedAt: null,
                    firstChangeAfterInitAt: null,
                    firstContentBodyChangeAfterInitAt: null,
                    lastLocalOrganicChangeAt: null,
                    lastRemoteOrganicChangeAt: null,
                    lastLocalOrganicBodyChangeAt: null,
                    lastRemoteOrganicBodyChangeAt: null
                },
                activeParticipants: undefined,
                sessionId: undefined,
                lastReconnectionConflictMetadata: undefined
            };
            const collabPluginState = (0, $k5ilr.pluginKey).getState(state);
            const metadata = (0, $g5VrR.trackNCSInitializationPluginKey).getState(state);
            const lastOrganicChangeState = (0, $auTW7.trackLastOrganicChangePluginKey).getState(state);
            const lastRemoteConflict = (0, $89tlI.trackLastRemoteConflictPluginKey).getState(state);
            return {
                activeParticipants: collabPluginState?.activeParticipants,
                sessionId: collabPluginState?.sessionId,
                initialised: {
                    collabInitialisedAt: metadata?.collabInitialisedAt || null,
                    firstChangeAfterInitAt: metadata?.firstChangeAfterInitAt || null,
                    firstContentBodyChangeAfterInitAt: metadata?.firstContentBodyChangeAfterInitAt || null,
                    lastLocalOrganicChangeAt: lastOrganicChangeState?.lastLocalOrganicChangeAt || null,
                    lastRemoteOrganicChangeAt: lastOrganicChangeState?.lastRemoteOrganicChangeAt || null,
                    lastLocalOrganicBodyChangeAt: lastOrganicChangeState?.lastLocalOrganicBodyChangeAt || null,
                    lastRemoteOrganicBodyChangeAt: lastOrganicChangeState?.lastRemoteOrganicBodyChangeAt || null
                },
                lastReconnectionConflictMetadata: lastRemoteConflict
            };
        },
        actions: {
            getAvatarColor: $03X0Y.getAvatarColor,
            addInlineCommentMark: $337191a1934f18d7$var$createAddInlineCommentMark(collabEditProviderPromise),
            addInlineCommentNodeMark: $337191a1934f18d7$var$createAddInlineCommentNodeMark(collabEditProviderPromise),
            isRemoteReplaceDocumentTransaction: (tr)=>tr.getMeta('isRemote') && tr.getMeta('replaceDocument'),
            getCurrentCollabState: ()=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const adfDocument = new (0, $3xuv0.JSONTransformer)().encode(editorViewRef.current.state.doc);
                return {
                    content: adfDocument,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    version: (0, $7TcbF.getCollabState)(editorViewRef.current.state)?.version || 0,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    sendableSteps: (0, $7TcbF.sendableSteps)(editorViewRef.current.state)
                };
            },
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            validatePMJSONDocument: (doc)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const content = (doc.content || []).map((child)=>// Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    editorViewRef.current.state.schema.nodeFromJSON(child));
                return content.every((node)=>{
                    try {
                        node.check(); // this will throw an error if the node is invalid
                    } catch  {
                        return false;
                    }
                    return true;
                });
            }
        },
        pmPlugins () {
            const { useNativePlugin: useNativePlugin = false, userId: userId = null } = options || {};
            const transformUnconfirmed = (steps)=>{
                let transformed = steps;
                if ((0, $fqVYq.editorExperiment)('platform_editor_reduce_noisy_steps_ncs', true, {
                    exposure: true
                })) transformed = (0, $a8NwW.filterAnalyticsSteps)(transformed);
                if ((0, $fqVYq.editorExperiment)('platform_editor_offline_editing_web', true) || (0, $ieeJu.expValEquals)('platform_editor_enable_single_player_step_merging', 'isEnabled', true)) transformed = (0, $jkbED.mergeUnconfirmedSteps)(transformed, api);
                return transformed;
            };
            const plugins = [
                ...useNativePlugin ? [
                    {
                        name: 'pmCollab',
                        plugin: ()=>(0, $7TcbF.collab)({
                                clientID: userId,
                                transformUnconfirmed: transformUnconfirmed
                            })
                    },
                    {
                        name: 'nativeCollabProviderPlugin',
                        plugin: ()=>(0, $jm7OT.nativeCollabProviderPlugin)({
                                providerPromise: collabEditProviderPromise
                            })
                    }
                ] : [],
                {
                    name: 'collab',
                    plugin: ({ dispatch: dispatch, providerFactory: providerFactory })=>{
                        return (0, $eEHpO.createPlugin)(dispatch, providerFactory, providerResolver, executeProviderCode, options, featureFlags, api);
                    }
                },
                {
                    name: 'collabTrackNCSInitializationPlugin',
                    plugin: (0, $g5VrR.createPlugin)
                }
            ];
            plugins.push({
                name: 'trackAndFilterSpammingSteps',
                plugin: ()=>(0, $6ixNC.createPlugin)((tr)=>{
                        const sanitizedSteps = tr.steps.map((step)=>(0, $6ixNC.sanitizeFilteredStep)(step));
                        api?.analytics?.actions?.fireAnalyticsEvent({
                            action: (0, $krYZG.ACTION).STEPS_FILTERED,
                            actionSubject: (0, $krYZG.ACTION_SUBJECT).COLLAB,
                            attributes: {
                                steps: sanitizedSteps
                            },
                            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
                        });
                    })
            });
            plugins.push({
                name: 'collabTrackLastOrganicChangePlugin',
                plugin: (0, $auTW7.createPlugin)
            });
            if ((0, $fqVYq.editorExperiment)('platform_editor_offline_editing_web', true)) plugins.push({
                name: 'trackLastRemoteConflictPlugin',
                plugin: (0, $89tlI.createPlugin)
            });
            return plugins;
        },
        onEditorViewStateUpdated (props) {
            const addErrorAnalytics = (0, $aQ9Nh.addSynchronyErrorAnalytics)(props.newEditorState, props.newEditorState.tr, featureFlags, api?.analytics?.actions);
            const isEmptyDoc = (0, $iLrhi.isEmptyDocument)(props.newEditorState.doc);
            const viewMode = api?.editorViewMode?.sharedState.currentState()?.mode;
            executeProviderCode((0, $6rAEj.sendTransaction)({
                originalTransaction: props.originalTransaction,
                transactions: props.transactions,
                oldEditorState: props.oldEditorState,
                newEditorState: props.newEditorState,
                useNativePlugin: options.useNativePlugin ?? false,
                hideTelecursorOnLoad: !isEmptyDoc && (options.hideTelecursorOnLoad ?? false),
                viewMode: viewMode
            }), addErrorAnalytics);
            if (!(0, $ieeJu.expValEquals)('platform_editor_remove_collab_step_metrics', 'isEnabled', true)) (0, $fkzSG.track)({
                api: api,
                ...props,
                onTrackDataProcessed: (steps)=>{
                    api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $krYZG.ACTION).STEPS_TRACKED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).COLLAB,
                        attributes: {
                            steps: steps
                        },
                        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
                    });
                }
            });
            if ((0, $ixfCV.fg)('platform_editor_collab_organic_change_reporting')) (0, $alVJS.monitorOrganic)({
                api: api,
                ...props,
                onDataProcessed: (data)=>{
                    api?.analytics?.actions?.fireAnalyticsEvent({
                        action: (0, $krYZG.ACTION).ORGANIC_CHANGES_TRACKED,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).COLLAB,
                        attributes: {
                            organicChanges: data
                        },
                        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
                    });
                }
            });
        },
        commands: {
            nudgeTelepointer: (sessionId)=>({ tr: tr })=>{
                    tr.setMeta('nudgeTelepointer', {
                        sessionId: sessionId
                    });
                    return tr;
                }
        }
    };
};
module.exports["collabEditPlugin"] = $337191a1934f18d7$export$7b59344e4e475116;

});

parcelRegister("aQ9Nh", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $8ROsu = parcelRequire("8ROsu");


var $26lLV = parcelRequire("26lLV");

const $7cf676f4d1e8bc54$export$8c408a1f4e12c948 = (state, tr, featureFlags, editorAnalyticsApi)=>{
    return (error)=>{
        const browserExtensions = (0, $26lLV.sniffUserBrowserExtensions)({
            extensions: [
                'grammarly'
            ]
        });
        const payload = {
            action: (0, $krYZG.ACTION).SYNCHRONY_ERROR,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: error,
                browserExtensions: browserExtensions
            }
        };
        if (featureFlags.synchronyErrorDocStructure) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        payload.attributes.docStructure = (0, $8ROsu.getDocStructure)(state.doc, {
            compact: true
        });
        editorAnalyticsApi?.attachAnalyticsEvent(payload)(tr);
        return tr;
    };
};
const $7cf676f4d1e8bc54$export$31cf0e3f119813a1 = (state, tr)=>{
    return (type, editorAnalyticsApi)=>{
        editorAnalyticsApi?.attachAnalyticsEvent({
            action: type === 'error' ? (0, $krYZG.ACTION).SYNCHRONY_ENTITY_ERROR : (0, $krYZG.ACTION).SYNCHRONY_DISCONNECTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                // https://developer.mozilla.org/en-US/docs/Web/API/NavigatorOnLine/onLine
                onLine: navigator.onLine,
                visibilityState: document.visibilityState
            }
        })(tr);
        return tr;
    };
};
module.exports["addSynchronyErrorAnalytics"] = $7cf676f4d1e8bc54$export$8c408a1f4e12c948;
module.exports["addSynchronyEntityAnalytics"] = $7cf676f4d1e8bc54$export$31cf0e3f119813a1;

});

parcelRegister("6rAEj", function(module, exports) {

var $l5rX3 = parcelRequire("l5rX3");


var $fqVYq = parcelRequire("fqVYq");


var $8ZYbW = parcelRequire("8ZYbW");


var $k5ilr = parcelRequire("k5ilr");

const $a38ec21fd2b3cec9$export$8e0e7ffc78696d30 = ({ originalTransaction: originalTransaction, transactions: transactions, oldEditorState: oldEditorState, newEditorState: newEditorState, useNativePlugin: useNativePlugin, viewMode: viewMode, hideTelecursorOnLoad: hideTelecursorOnLoad })=>(provider)=>{
        const docChangedTransaction = transactions.find((tr)=>tr.docChanged);
        const currentPluginState = (0, $k5ilr.pluginKey).getState(newEditorState);
        const trNoAnalytics = oldEditorState.tr;
        docChangedTransaction?.steps.forEach((step)=>{
            if (!(step instanceof (0, $l5rX3.AnalyticsStep))) trNoAnalytics.step(step);
        });
        if (!currentPluginState?.isReady) return;
        const newTransaction = (0, $fqVYq.editorExperiment)('platform_editor_reduce_noisy_steps_ncs', true, {
            exposure: true
        }) ? trNoAnalytics : docChangedTransaction;
        const shouldSendStepForSynchronyCollabProvider = !originalTransaction.getMeta('isRemote') && // TODO: ED-8995 - We need to do this check to reduce the number of race conditions when working with tables.
        // This metadata is coming from the scaleTable command in table-resizing plugin
        !originalTransaction.getMeta('scaleTable') && ((0, $fqVYq.editorExperiment)('platform_editor_reduce_noisy_steps_ncs', true) ? newTransaction?.docChanged : true);
        if (useNativePlugin || shouldSendStepForSynchronyCollabProvider) provider.send(newTransaction, oldEditorState, newEditorState);
        const prevPluginState = (0, $k5ilr.pluginKey).getState(oldEditorState);
        const { activeParticipants: prevActiveParticipants } = prevPluginState || {};
        const { activeParticipants: activeParticipants, sessionId: sessionId } = currentPluginState;
        const selectionChanged = !oldEditorState.selection.eq(newEditorState.selection);
        const participantsChanged = prevActiveParticipants && !prevActiveParticipants.eq(activeParticipants);
        if (!sessionId || viewMode !== 'edit') return;
        // uiEvent is standard metdata (docs: https://prosemirror.net/docs/ref/#state.Transaction)
        const isPaste = docChangedTransaction?.getMeta('uiEvent') === 'paste';
        // If this metadata is truthy then it means a selection bookmark might be declared as the meta value OR the transaction
        // doesn't want the tr.selection to be sent to remote users at all.
        const remoteSelectionBookmark = originalTransaction.getMeta('useSelectionBookmarkForRemote');
        if (!!remoteSelectionBookmark) {
            if (remoteSelectionBookmark !== true && 'resolve' in remoteSelectionBookmark) {
                const selection = remoteSelectionBookmark.resolve(newEditorState.doc);
                const message = {
                    type: 'telepointer',
                    selection: (0, $8ZYbW.getSendableSelection)(selection),
                    sessionId: sessionId
                };
                provider.sendMessage(message);
            }
        } else if (// Broadcast the position if the selection has changed, and the doc hasn't changed (it is mapped
        // by the receiver).
        // If we're pasting content though make an exception (as doc has changed)
        // as on a ranged selection it results in not clearing the ranged selection after the paste
        selectionChanged && (!docChangedTransaction || isPaste) || participantsChanged && !hideTelecursorOnLoad) {
            const selection = (0, $8ZYbW.getSendableSelection)(newEditorState.selection);
            const message = {
                type: 'telepointer',
                selection: selection,
                sessionId: sessionId
            };
            provider.sendMessage(message);
        }
    };
module.exports["sendTransaction"] = $a38ec21fd2b3cec9$export$8e0e7ffc78696d30;

});

parcelRegister("8ZYbW", function(module, exports) {
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace

var $aqgkf = parcelRequire("aqgkf");


var $aOSDg = parcelRequire("aOSDg");


var $kCECX = parcelRequire("kCECX");


var $5aU9U = parcelRequire("5aU9U");


var $7TcbF = parcelRequire("7TcbF");


var $03X0Y = parcelRequire("03X0Y");

const $666505553c33095c$export$d970973925859b8e = ()=>{
    Object.entries($aOSDg).forEach(()=>{});
    Object.entries($aqgkf).forEach(()=>{});
};
const $666505553c33095c$export$a04a448cc866246 = (initData, view, options, editorAnalyticsApi)=>{
    const { doc: doc, json: json, version: version, reserveCursor: reserveCursor } = initData;
    if (doc) {
        const { state: state } = view;
        const tr = (0, $03X0Y.replaceDocument)(doc, state, version, options, reserveCursor, editorAnalyticsApi);
        tr.setMeta('isRemote', true);
        view.dispatch(tr);
    } else if (json) $666505553c33095c$export$ff4f2767b9e99aa9(json, view);
};
const $666505553c33095c$export$cf9a0dcadb173615 = (connectionData, view)=>{
    const { state: { tr: tr } } = view;
    view.dispatch(tr.setMeta('sessionId', connectionData));
};
const $666505553c33095c$export$f9db5387b510d6c = (presenceData, view)=>{
    const { state: { tr: tr } } = view;
    view.dispatch(tr.setMeta('presence', presenceData));
};
const $666505553c33095c$export$c6643a6a2625d22c = (remoteData, view, options)=>{
    const { json: json, userIds: userIds = [] } = remoteData;
    if (json) $666505553c33095c$export$ff4f2767b9e99aa9(json, view, userIds, options);
};
const $666505553c33095c$export$ff4f2767b9e99aa9 = (// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
json, view, userIds, options)=>{
    if (!json || !json.length) return;
    const { state: state, state: { schema: schema } } = view;
    const steps = json.map((step)=>(0, $5aU9U.Step).fromJSON(schema, step));
    let tr;
    if (options && options.useNativePlugin && userIds) tr = (0, $7TcbF.receiveTransaction)(state, steps, userIds, {
        mapSelectionBackward: true
    });
    else {
        tr = state.tr;
        steps.forEach((step)=>tr.step(step));
    }
    if (tr) {
        tr.setMeta('addToHistory', false);
        tr.setMeta('isRemote', true);
        /*
		 * Persist marks across transactions. Fixes an issue where
		 * marks are lost if remote transactions are dispatched
		 * between a user creating the mark and typing.
		 */ if (state.tr.storedMarks) tr.setStoredMarks(state.tr.storedMarks);
        view.dispatch(tr);
    }
};
const $666505553c33095c$export$abfa80d838a68fd6 = (telepointerData, view)=>{
    const { state: { tr: tr } } = view;
    view.dispatch(tr.setMeta('telepointer', telepointerData));
};
function $666505553c33095c$var$isAllSelection(selection) {
    return selection instanceof (0, $kCECX.AllSelection);
}
function $666505553c33095c$var$isNodeSelection(selection) {
    return selection instanceof (0, $kCECX.NodeSelection);
}
const $666505553c33095c$export$b95b91cb8577b1db = (selection)=>{
    /**
	 * <kbd>CMD + A</kbd> triggers a AllSelection
	 * <kbd>escape</kbd> triggers a NodeSelection
	 */ return {
        type: 'textSelection',
        anchor: selection.anchor,
        head: $666505553c33095c$var$isAllSelection(selection) || $666505553c33095c$var$isNodeSelection(selection) ? selection.head - 1 : selection.head
    };
};
module.exports["handleInit"] = $666505553c33095c$export$a04a448cc866246;
module.exports["handleConnection"] = $666505553c33095c$export$cf9a0dcadb173615;
module.exports["handlePresence"] = $666505553c33095c$export$f9db5387b510d6c;
module.exports["applyRemoteData"] = $666505553c33095c$export$c6643a6a2625d22c;
module.exports["handleTelePointer"] = $666505553c33095c$export$abfa80d838a68fd6;
module.exports["getSendableSelection"] = $666505553c33095c$export$b95b91cb8577b1db;

});

parcelRegister("03X0Y", function(module, exports) {

var $l5rX3 = parcelRequire("l5rX3");

var $hdvEd = parcelRequire("hdvEd");

var $1A89X = parcelRequire("1A89X");


var $krYZG = parcelRequire("krYZG");


var $jbOus = parcelRequire("jbOus");


var $5Qi6J = parcelRequire("5Qi6J");


var $fngNp = parcelRequire("fngNp");


var $kCECX = parcelRequire("kCECX");


var $eOaGc = parcelRequire("eOaGc");


var $8nvEM = parcelRequire("8nvEM");


var $6e6qw = parcelRequire("6e6qw");


var $73BU4 = parcelRequire("73BU4");

const $c09ce8c88f088fff$export$cc7116c03c331d66 = (id, decorations)=>decorations.find().reduce((arr, deco)=>deco.spec.pointer.presenceId === id ? arr.concat(deco) : arr, []);
function $c09ce8c88f088fff$var$style(options) {
    const color = options && options.color || "var(--ds-border, #0B120E24)";
    const borderWidth = "var(--ds-border-width-focused, 2px)";
    return `border-right: ${borderWidth} solid ${color}; margin-right: calc(-1 * ${borderWidth}); z-index: 1`;
}
function $c09ce8c88f088fff$export$90c6ee000c44ff4a(str) {
    const participantColor = (0, $6e6qw.getParticipantColor)(str);
    return {
        index: participantColor.index,
        backgroundColor: participantColor.color.backgroundColor,
        textColor: participantColor.color.textColor
    };
}
const $c09ce8c88f088fff$export$8f868fb36fe42fe8 = (from, to, sessionId, isSelection, initial, presenceId, fullName, isNudged)=>{
    const decorations = [];
    const avatarColor = $c09ce8c88f088fff$export$90c6ee000c44ff4a(presenceId);
    const color = avatarColor.index.toString();
    if (isSelection) {
        const className = `telepointer color-${color} telepointer-selection`;
        decorations.push((0, $8nvEM.Decoration).inline(from, to, {
            class: className
        }, {
            pointer: {
                sessionId: sessionId,
                presenceId: presenceId
            }
        }));
    }
    const spaceJoinerBefore = document.createElement('span');
    spaceJoinerBefore.textContent = (0, $fngNp.ZERO_WIDTH_JOINER);
    const spaceJoinerAfter = document.createElement('span');
    spaceJoinerAfter.textContent = (0, $fngNp.ZERO_WIDTH_JOINER);
    const cursor = document.createElement('span');
    cursor.textContent = (0, $fngNp.ZERO_WIDTH_JOINER);
    cursor.className = `telepointer color-${color} telepointer-selection-badge`;
    cursor.style.cssText = `${$c09ce8c88f088fff$var$style({
        color: avatarColor.backgroundColor
    })};`;
    cursor.setAttribute('aria-label', `${fullName} cursor position`);
    cursor.setAttribute('role', 'button');
    cursor.setAttribute((0, $jbOus.TELEPOINTER_DATA_SESSION_ID_ATTR), sessionId);
    // If there is an ongoing expand animation, we'll keep the telepointer expanded
    // until the keyframe animation is complete. Please note that this will restart the anim timer
    // from 0 everytime it's re-added.
    if (isNudged) cursor.classList.add((0, $jbOus.TELEPOINTER_PULSE_DURING_TR_CLASS));
    const fullNameEl = document.createElement('span');
    fullNameEl.textContent = fullName;
    fullNameEl.className = 'telepointer-fullname';
    fullNameEl.style.backgroundColor = avatarColor.backgroundColor;
    fullNameEl.style.color = avatarColor.textColor;
    fullNameEl.setAttribute('aria-hidden', 'true');
    cursor.appendChild(fullNameEl);
    const initialEl = document.createElement('span');
    initialEl.textContent = initial;
    initialEl.className = 'telepointer-initial';
    initialEl.style.backgroundColor = avatarColor.backgroundColor;
    initialEl.style.color = avatarColor.textColor;
    initialEl.setAttribute('aria-hidden', 'true');
    cursor.appendChild(initialEl);
    return decorations.concat((0, $8nvEM.Decoration).widget(to, spaceJoinerAfter, {
        pointer: {
            sessionId: sessionId,
            presenceId: presenceId
        },
        key: `telepointer-${sessionId}-zero`
    })).concat((0, $8nvEM.Decoration).widget(to, cursor, {
        pointer: {
            sessionId: sessionId,
            presenceId: presenceId
        },
        key: `telepointer-${sessionId}`
    })).concat((0, $8nvEM.Decoration).widget(to, spaceJoinerBefore, {
        pointer: {
            sessionId: sessionId,
            presenceId: presenceId
        },
        key: `telepointer-${sessionId}-zero`
    }));
};
const $c09ce8c88f088fff$export$fe10d6bdd551e45e = (doc, state, version, options, reserveCursor, editorAnalyticsAPI)=>{
    const { schema: schema, tr: tr } = state;
    const parsedDoc = (0, $5Qi6J.processRawValueWithoutValidation)(schema, doc, editorAnalyticsAPI?.fireAnalyticsEvent);
    const hasContent = !!parsedDoc?.childCount;
    const content = parsedDoc?.content;
    if (hasContent && content) {
        const preservedContent = (0, $73BU4.preserveNodeIdentity)(state.doc.content, content);
        // If the entire content is identical, skip the replaceWith entirely
        // and just update collab metadata. This avoids triggering a full
        // document reconciliation for no-op replacements.
        if (preservedContent === state.doc.content) {
            tr.setMeta('addToHistory', false);
            if (version !== undefined && options && options.useNativePlugin) {
                const collabState = {
                    version: version,
                    unconfirmed: []
                };
                tr.setMeta('collab$', collabState);
            }
            return tr;
        }
        // Use the preserved fragment (reuses old node references for unchanged nodes)
        // rather than the raw parsed content, so ProseMirror's view reconciliation
        // can fast-match unchanged subtrees via referential identity (===).
        tr.setMeta('addToHistory', false);
        tr.replaceWith(0, state.doc.nodeSize - 2, preservedContent);
        const selection = state.selection;
        if (reserveCursor) {
            if (selection.to < tr.doc.content.size - 2) {
                const $from = tr.doc.resolve(selection.from);
                const $to = tr.doc.resolve(selection.to);
                const newselection = new (0, $kCECX.TextSelection)($from, $to);
                tr.setSelection(newselection);
            }
        } else tr.setSelection((0, $kCECX.Selection).atStart(tr.doc));
        tr.setMeta('replaceDocument', true);
        if (version !== undefined && options && options.useNativePlugin) {
            const collabState = {
                version: version,
                unconfirmed: []
            };
            tr.setMeta('collab$', collabState);
        }
    } else if (hasContent) {
        tr.setMeta('addToHistory', false);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        tr.replaceWith(0, state.doc.nodeSize - 2, content);
        const selection = state.selection;
        if (reserveCursor) // If the cursor is still in the range of the new document,
        // keep where it was.
        {
            if (selection.to < tr.doc.content.size - 2) {
                const $from = tr.doc.resolve(selection.from);
                const $to = tr.doc.resolve(selection.to);
                const newselection = new (0, $kCECX.TextSelection)($from, $to);
                tr.setSelection(newselection);
            }
        } else tr.setSelection((0, $kCECX.Selection).atStart(tr.doc));
        tr.setMeta('replaceDocument', true);
        if (options && options.useNativePlugin) {
            const collabState = {
                version: version,
                unconfirmed: []
            };
            tr.setMeta('collab$', collabState);
        }
    }
    return tr;
};
const $c09ce8c88f088fff$export$82e6f13680c85057 = (editorView, participants, sessionId, index, editorAnalyticsAPI)=>{
    const selectedUser = participants[index];
    if (selectedUser && selectedUser.cursorPos !== undefined && selectedUser.sessionId !== sessionId) {
        const { state: state } = editorView;
        const tr = state.tr;
        const analyticsPayload = {
            action: (0, $krYZG.ACTION).MATCHED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).SELECTION,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        };
        tr.setSelection((0, $kCECX.Selection).near(tr.doc.resolve(selectedUser.cursorPos)));
        editorAnalyticsAPI?.attachAnalyticsEvent(analyticsPayload)(tr);
        tr.scrollIntoView();
        editorView.dispatch(tr);
        if (!editorView.hasFocus()) editorView.focus();
    }
};
const $c09ce8c88f088fff$export$4d66b240d6166074 = (sessionId, decorationSet)=>{
    let scrollPosition;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    decorationSet.find().forEach((deco)=>{
        if (deco.type.spec.pointer.sessionId === sessionId) scrollPosition = deco.from;
    });
    return scrollPosition;
};
const $c09ce8c88f088fff$export$94600c572c12bcd6 = (step)=>step instanceof (0, $eOaGc.ReplaceStep);
const $c09ce8c88f088fff$export$b8c92cc7dad49da = (transaction, metaTag)=>{
    const hasMetaTag = Boolean(transaction.getMeta(metaTag));
    if (hasMetaTag) return true;
    const appendedTransaction = transaction.getMeta('appendedTransaction');
    if (appendedTransaction instanceof (0, $kCECX.Transaction)) return $c09ce8c88f088fff$export$b8c92cc7dad49da(appendedTransaction, metaTag);
    return false;
};
/**
 * This list contains step attributes that do not result from a user action.
 * All steps that contain ONLY the blocked attribute are considered automated steps
 * and should not be recognised as organic change.
 *
 * `attr_colwidth` is an exception to above explanation. Resizing the column
 * currently creates too many steps and is therefore also on this list.
 *
 * Steps analycs dashboard: https://atlassian-discover.cloud.databricks.com/dashboardsv3/01ef4d3c8aa916c8b0cb5332a9f37caf/published?o=4482001201517624
 */ const $c09ce8c88f088fff$var$blockedAttrsList = [
    '__contextId',
    'localId',
    '__autoSize',
    'attr_colwidth',
    'originalHeight',
    'originalWidth'
];
const $c09ce8c88f088fff$export$227edb0398ff0ff6 = (tr)=>{
    // If document has not been marked as `docChanged` by PM, skip the rest of the logic
    if (!tr.docChanged) return false;
    return tr.steps.some((step)=>{
        // If a step is an instance of AnalyticsStep, it is not considered organic
        if (step instanceof (0, $l5rX3.AnalyticsStep)) return false;
        // editor-plugin-local-id uses AttrStep to set the localId attribute
        if (step instanceof (0, $eOaGc.AttrStep) && step.attr === 'localId') return false;
        // editor-plugin-local-id uses BatchAttrStep to set the localId attribute
        if (step instanceof (0, $hdvEd.BatchAttrsStep)) {
            const allAttributes = step.data.map((data)=>Object.keys(data.attrs)).flat();
            return allAttributes.some((attr)=>!$c09ce8c88f088fff$var$blockedAttrsList.includes(attr)) && !tr.doc.eq(tr.before);
        }
        // If a step is not an instance of SetAttrsStep, it is considered organic
        if (!(step instanceof (0, $1A89X.SetAttrsStep))) return true;
        const allAttributes = Object.keys(step.attrs);
        // If a step is an instance of SetAttrsStep, it checks if the attributes in the step
        // are not in the `blockedAttributes`. If one of the attributes not on the list, it considers the change
        // organic but only if the entire document is not equal to the previous state.
        return allAttributes.some((attr)=>!$c09ce8c88f088fff$var$blockedAttrsList.includes(attr)) && !tr.doc.eq(tr.before);
    });
};
const $c09ce8c88f088fff$export$6a7a563833bcd8 = (sessionId, nudgeAnimations)=>{
    const nudgeAnimStartTime = nudgeAnimations.get(sessionId);
    let hasExistingNudge = false;
    if (nudgeAnimStartTime) {
        const timeElapsed = Date.now() - nudgeAnimStartTime;
        hasExistingNudge = timeElapsed < (0, $jbOus.TELEPOINTER_PULSE_DURING_TR_DURATION_MS);
    }
    return hasExistingNudge;
};
module.exports["findPointers"] = $c09ce8c88f088fff$export$cc7116c03c331d66;
module.exports["getAvatarColor"] = $c09ce8c88f088fff$export$90c6ee000c44ff4a;
module.exports["createTelepointers"] = $c09ce8c88f088fff$export$8f868fb36fe42fe8;
module.exports["replaceDocument"] = $c09ce8c88f088fff$export$fe10d6bdd551e45e;
module.exports["getPositionOfTelepointer"] = $c09ce8c88f088fff$export$4d66b240d6166074;
module.exports["isReplaceStep"] = $c09ce8c88f088fff$export$94600c572c12bcd6;
module.exports["originalTransactionHasMeta"] = $c09ce8c88f088fff$export$b8c92cc7dad49da;
module.exports["isOrganicChange"] = $c09ce8c88f088fff$export$227edb0398ff0ff6;
module.exports["hasExistingNudge"] = $c09ce8c88f088fff$export$6a7a563833bcd8;

});

parcelRegister("73BU4", function(module, exports) {

var $aPdNQ = parcelRequire("aPdNQ");

function $310f7ef6cdc3c4ee$export$e0776a297562f4e0(oldFragment, newFragment) {
    // Fast path: referentially identical — nothing to do
    if (oldFragment === newFragment) return oldFragment;
    // Fast path: structurally equal — reuse old fragment entirely.
    // This covers the common SSR case where collab init sends the same doc.
    if (oldFragment.eq(newFragment)) return oldFragment;
    // Walk children position-by-position and preserve what we can
    const oldCount = oldFragment.childCount;
    const newCount = newFragment.childCount;
    let changed = false;
    const children = [];
    for(let i = 0; i < newCount; i++){
        const newChild = newFragment.child(i);
        if (i < oldCount) {
            const oldChild = oldFragment.child(i);
            if (oldChild === newChild) // Already referentially identical
            children.push(newChild);
            else if (oldChild.eq(newChild)) // Structurally equal — reuse old reference (THE KEY OPERATION)
            children.push(oldChild);
            else if (oldChild.type === newChild.type && oldChild.sameMarkup(newChild) && oldChild.content.childCount > 0 && newChild.content.childCount > 0) {
                // Same type and markup but different content — recurse into children
                const preservedContent = $310f7ef6cdc3c4ee$export$e0776a297562f4e0(oldChild.content, newChild.content);
                if (preservedContent === oldChild.content) // All content was preserved — reuse old node entirely
                children.push(oldChild);
                else {
                    // Partially changed — create node with preserved content
                    children.push(oldChild.copy(preservedContent));
                    changed = true;
                }
            } else {
                // Completely different node — use new
                children.push(newChild);
                changed = true;
            }
        } else {
            // New child beyond old count — use as-is (insertion)
            children.push(newChild);
            changed = true;
        }
    }
    // If nothing changed and counts match, return old fragment directly
    // (avoids creating a new Fragment object)
    if (!changed && oldCount === newCount) return oldFragment;
    return (0, $aPdNQ.Fragment).from(children);
}
module.exports["preserveNodeIdentity"] = $310f7ef6cdc3c4ee$export$e0776a297562f4e0;

});

parcelRegister("k5ilr", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $2955bb74975a5428$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('collabEditPlugin');
module.exports["pluginKey"] = $2955bb74975a5428$export$18d4026d1ea86bb1;

});

parcelRegister("a8NwW", function(module, exports) {

var $l5rX3 = parcelRequire("l5rX3");


var $7TcbF = parcelRequire("7TcbF");

function $293a9c6514990e26$export$75962d04b28eb982(steps) {
    const filteredSteps = steps.reduce((acc, rebaseable)=>{
        if (!(rebaseable.step instanceof (0, $l5rX3.AnalyticsStep))) acc.push(new (0, $7TcbF.Rebaseable)(rebaseable.step, rebaseable.inverted, rebaseable.origin));
        return acc;
    }, []);
    return filteredSteps;
}
module.exports["filterAnalyticsSteps"] = $293a9c6514990e26$export$75962d04b28eb982;

});

parcelRegister("eEHpO", function(module, exports) {
// It is important to get all steps in that package
// Ignored via go/ees005
// eslint-disable-next-line import/no-namespace

var $aqgkf = parcelRequire("aqgkf");


var $aOSDg = parcelRequire("aOSDg");


var $krYZG = parcelRequire("krYZG");

var $fdQKX = parcelRequire("fdQKX");


var $kpCD8 = parcelRequire("kpCD8");


var $5aU9U = parcelRequire("5aU9U");


var $aQ9Nh = parcelRequire("aQ9Nh");


var $kl8Qm = parcelRequire("kl8Qm");


var $k5ilr = parcelRequire("k5ilr");


var $euTSg = parcelRequire("euTSg");

const $4e5bb196f2fe3a0b$var$enforceCustomStepRegisters = ()=>{
    const tryToRegisterStep = (obj)=>{
        for (const customStep of Object.values(obj)){
            // I know this seems awful
            // But unfortunate ProseMirror does not expose the jsonID property p
            // @ts-expect-error
            const id = customStep?.prototype?.jsonID;
            if (typeof id === 'string') try {
                // We are trying to re-register the steps here
                // in the normal flow, those custom step should be already registred
                // So, it should throw an expeception
                // @ts-expect-error
                (0, $5aU9U.Step).jsonID(id, customStep);
            } catch (e) {
            // This mean the step was already registred.
            // It is ok to ignore this exception.
            }
        }
    };
    // @ts-expect-error
    tryToRegisterStep($aOSDg);
    // @ts-expect-error
    tryToRegisterStep($aqgkf);
};
const $4e5bb196f2fe3a0b$export$ae829ec7b2625219 = (dispatch, providerFactory, providerResolver, collabProviderCallback, options, featureFlags, pluginInjectionApi)=>{
    $4e5bb196f2fe3a0b$var$enforceCustomStepRegisters();
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $k5ilr.pluginKey),
        state: {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            init (config) {
                return (0, $euTSg.PluginState).init(config);
            },
            apply (transaction, prevPluginState, _oldEditorState, _newEditorState) {
                const pluginState = prevPluginState.apply(transaction);
                dispatch((0, $k5ilr.pluginKey), pluginState);
                return pluginState;
            }
        },
        props: {
            decorations (state) {
                return (0, $k5ilr.pluginKey).getState(state)?.decorations;
            },
            handleDOMEvents: {
                click (view, event) {
                    if (!(event.target instanceof HTMLElement)) return false;
                    if (!view.state.selection.empty) return false;
                    const { pos: pos } = view.state.tr.selection.$from;
                    if (!pos) return false;
                    // check if the pos is the same pos as a telepointer decoration
                    const decorations = (0, $k5ilr.pluginKey).getState(view.state)?.decorations?.find(pos, pos);
                    if (!decorations?.length) return false;
                    // analytics to track telepointer clicks as they sometimes cause broken selections
                    const fireAnalyticsCallback = (0, $fdQKX.fireAnalyticsEvent)(pluginInjectionApi?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined);
                    fireAnalyticsCallback({
                        payload: {
                            action: (0, $krYZG.ACTION).CLICKED,
                            actionSubject: (0, $krYZG.ACTION_SUBJECT).TELEPOINTER,
                            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).TELEPOINTER,
                            eventType: (0, $krYZG.EVENT_TYPE).TRACK
                        }
                    });
                }
            }
        },
        filterTransaction (tr, state) {
            const pluginState = (0, $k5ilr.pluginKey).getState(state);
            const collabInitialiseTr = tr.getMeta('collabInitialised');
            // Don't allow transactions that modifies the document before
            // collab-plugin is ready.
            if (collabInitialiseTr) return true;
            if (!pluginState?.isReady && tr.docChanged) return false;
            return true;
        },
        view (view) {
            const addErrorAnalytics = (0, $aQ9Nh.addSynchronyErrorAnalytics)(view.state, view.state.tr, featureFlags, pluginInjectionApi?.analytics?.actions);
            const onSyncUpError = (attributes)=>{
                const fireAnalyticsCallback = (0, $fdQKX.fireAnalyticsEvent)(pluginInjectionApi?.analytics?.sharedState.currentState()?.createAnalyticsEvent ?? undefined);
                fireAnalyticsCallback({
                    payload: {
                        action: (0, $krYZG.ACTION).NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS,
                        actionSubject: (0, $krYZG.ACTION_SUBJECT).EDITOR,
                        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
                        attributes: attributes
                    }
                });
            };
            options.onSyncUpError = onSyncUpError;
            const cleanup = collabProviderCallback((0, $kl8Qm.initialize)({
                view: view,
                options: options,
                providerFactory: providerFactory,
                featureFlags: featureFlags,
                pluginInjectionApi: pluginInjectionApi,
                editorAnalyticsApi: pluginInjectionApi?.analytics?.actions
            }), addErrorAnalytics);
            providerFactory && providerFactory.subscribe('collabEditProvider', (_name, providerPromise)=>{
                if (providerPromise) providerPromise.then((provider)=>providerResolver(provider));
            });
            return {
                destroy () {
                    providerFactory.unsubscribeAll('collabEditProvider');
                    if (cleanup) cleanup.then((unsubscribe)=>{
                        if (unsubscribe) unsubscribe();
                    });
                }
            };
        }
    });
};
module.exports["createPlugin"] = $4e5bb196f2fe3a0b$export$ae829ec7b2625219;

});

parcelRegister("kl8Qm", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $5aU9U = parcelRequire("5aU9U");


var $ieeJu = parcelRequire("ieeJu");


var $k5ilr = parcelRequire("k5ilr");


var $g5VrR = parcelRequire("g5VrR");


var $3ozmx = parcelRequire("3ozmx");

const $f68e6042357b791f$var$initCollab = (collabEditProvider, view)=>{
    if (collabEditProvider.initialize) collabEditProvider.initialize(()=>view.state, (json)=>(0, $5aU9U.Step).fromJSON(view.state.schema, json));
};
const $f68e6042357b791f$var$initNewCollab = (collabEditProvider, view, editorApi, onSyncUpError)=>{
    collabEditProvider.setup({
        getState: ()=>view.state,
        editorApi: editorApi,
        onSyncUpError: onSyncUpError
    });
};
const $f68e6042357b791f$var$initCollabMemo = (0, $dOBRD.default)($f68e6042357b791f$var$initCollab);
const $f68e6042357b791f$export$2a47f398eeff8b01 = ({ options: options, providerFactory: providerFactory, view: view, featureFlags: featureFlags, editorAnalyticsApi: editorAnalyticsApi, pluginInjectionApi: pluginInjectionApi })=>(provider)=>{
        // eslint-disable-next-line prefer-const
        let cleanup;
        const pluginState = (0, $k5ilr.pluginKey).getState(view.state);
        if (pluginState?.isReady && cleanup) cleanup();
        cleanup = (0, $3ozmx.subscribe)(view, provider, options, featureFlags, providerFactory, editorAnalyticsApi);
        // Initialize provider
        if (options.useNativePlugin) // ED-13912 For NCS we don't want to use memoizeOne because it causes
        // infinite text while changing page-width
        $f68e6042357b791f$var$initNewCollab(provider, view, pluginInjectionApi, options.onSyncUpError);
        else /**
			 * We only want to initialise once, if we reload/reconfigure this plugin
			 * We dont want to re-init collab, it would break existing sessions
			 */ $f68e6042357b791f$var$initCollabMemo(provider, view);
        // Rebind path: if the provider has already initialised (i.e. this view()
        // is running because the editor preset was reconfigured or the EditorView
        // was recreated mid-session, e.g. on a rich-text → markdown-mode flip),
        // the provider's `init` event has already fired and won't fire again.
        // Without intervention the freshly-attached collab plugin view never sees
        // `collabInitialised`, so `filterTransaction` silently drops every
        // doc-changing transaction and the editor appears read-only.
        //
        // PM `state.reconfigure` preserves plugin state by key, so in many cases
        // the plugin state survives and no action is needed; we only seed when
        // state was actually lost (e.g. EditorView recreated from scratch).
        //
        // Gated behind `cc-markdown-mode` (the same experiment that drives the
        // preset rebuild on convert); when off, behaviour is unchanged. Uses
        // `expValEquals` (not `*NoExposure`) so the editor's statsig client
        // enrols the user — otherwise an early rebind can race the FE-side
        // exposure and read the default (false), defeating the gate. The
        // experiment check is last so legacy providers (no `getInitPayload`)
        // short-circuit and don't fire an exposure.
        if (provider.getInitPayload && (0, $ieeJu.expValEquals)('cc-markdown-mode', 'isEnabled', true)) {
            const cachedInit = provider.getInitPayload();
            if (cachedInit) // Defer one microtask so the new pluginView is fully registered
            // before we dispatch (mirrors the timing of a real `init` event).
            Promise.resolve().then(()=>{
                if (view.isDestroyed) return;
                const currentCollabState = (0, $k5ilr.pluginKey).getState(view.state);
                const currentTrackState = (0, $g5VrR.trackNCSInitializationPluginKey).getState(view.state);
                // State was preserved across reconfigure → nothing to do.
                if (currentCollabState?.isReady && currentTrackState?.collabInitialisedAt) return;
                // Seed the freshly-attached pluginView so `isReady` flips to true,
                // `data-has-collab-initialised` becomes "true", and downstream
                // listeners (analytics, sweet-state, track-ncs) re-receive init.
                // Note: we intentionally do NOT replay `handleInit` (which would
                // call `replaceDocument`) — the document is already in the editor
                // and replacing it would clobber any in-flight local steps.
                view.dispatch(view.state.tr.setMeta('collabInitialised', true));
            });
        }
        return cleanup;
    };
module.exports["initialize"] = $f68e6042357b791f$export$2a47f398eeff8b01;

});

parcelRegister("g5VrR", function(module, exports) {

var $jbOus = parcelRequire("jbOus");


var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $eOaGc = parcelRequire("eOaGc");


var $03X0Y = parcelRequire("03X0Y");

const $7482f28e0a2bd480$export$a79cdfb4b852386b = new (0, $kCECX.PluginKey)('collabTrackNCSInitializationPlugin');
const $7482f28e0a2bd480$export$ae829ec7b2625219 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $7482f28e0a2bd480$export$a79cdfb4b852386b,
        state: {
            init () {
                return {
                    collabInitialisedAt: null,
                    firstChangeAfterInitAt: null,
                    firstContentBodyChangeAfterInitAt: null
                };
            },
            apply (transaction, prevPluginState, oldState) {
                if (Boolean(transaction.getMeta('collabInitialised'))) return {
                    collabInitialisedAt: Date.now(),
                    firstChangeAfterInitAt: null,
                    firstContentBodyChangeAfterInitAt: null
                };
                const shouldCheckDocument = prevPluginState.collabInitialisedAt && !prevPluginState.firstContentBodyChangeAfterInitAt;
                if (!shouldCheckDocument) return prevPluginState;
                const isRemote = (0, $03X0Y.originalTransactionHasMeta)(transaction, 'isRemote');
                const isDocumentReplaceFromRemote = isRemote && (0, $03X0Y.originalTransactionHasMeta)(transaction, 'replaceDocument');
                if (isDocumentReplaceFromRemote) return prevPluginState;
                if ((0, $jbOus.isDirtyTransaction)(transaction)) return prevPluginState;
                if (transaction.docChanged && !transaction.doc.eq(oldState.doc)) {
                    // For analytics purposes, inline comment annotations are not considered as edits to the document body
                    // Transaction may contain other steps, but we know that they won't be user-generated (non synthetic) steps
                    // Additionally, for analytics purposes we do not want to trigger on other participants' changes (i.e. remote changes)
                    const isAnnotationStep = !!transaction.steps.find((step)=>step instanceof (0, $eOaGc.AddMarkStep) && step.mark?.type?.name === 'annotation');
                    return {
                        collabInitialisedAt: prevPluginState.collabInitialisedAt,
                        firstChangeAfterInitAt: Date.now(),
                        firstContentBodyChangeAfterInitAt: isAnnotationStep || isRemote ? prevPluginState.firstContentBodyChangeAfterInitAt : Date.now()
                    };
                }
                return prevPluginState;
            }
        },
        props: {
            attributes (editorState) {
                const trackPluginState = $7482f28e0a2bd480$export$a79cdfb4b852386b.getState(editorState);
                return {
                    ['data-has-collab-initialised']: `${Boolean(trackPluginState?.collabInitialisedAt)}`
                };
            }
        }
    });
};
module.exports["trackNCSInitializationPluginKey"] = $7482f28e0a2bd480$export$a79cdfb4b852386b;
module.exports["createPlugin"] = $7482f28e0a2bd480$export$ae829ec7b2625219;

});

parcelRegister("3ozmx", function(module, exports) {

var $8ZYbW = parcelRequire("8ZYbW");


var $aQ9Nh = parcelRequire("aQ9Nh");


var $89tlI = parcelRequire("89tlI");

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $98128c88e4bb0942$var$effect = (fn, eq)=>{
    let previousDeps;
    let cleanup;
    return (...currentDeps)=>{
        if (cleanup && eq(previousDeps, currentDeps)) return cleanup;
        cleanup = fn(...currentDeps);
        previousDeps = currentDeps;
        return cleanup;
    };
};
const $98128c88e4bb0942$export$ec068583843480e7 = $98128c88e4bb0942$var$effect((view, provider, options, featureFlags, _providerFactory, editorAnalyticsApi)=>{
    let entityRef;
    const entityHandlers = {
        disconnectedHandler: ()=>{
            (0, $aQ9Nh.addSynchronyEntityAnalytics)(view.state, view.state.tr)('disconnected', editorAnalyticsApi);
        },
        errorHandler: ()=>{
            (0, $aQ9Nh.addSynchronyEntityAnalytics)(view.state, view.state.tr)('error', editorAnalyticsApi);
        }
    };
    const unsubscribeSynchronyEntity = ()=>{
        if (entityRef) {
            entityRef.off('disconnected', entityHandlers.disconnectedHandler);
            entityRef.off('error', entityHandlers.errorHandler);
        }
    };
    const handlers = {
        initHandler: (data)=>{
            view.dispatch(view.state.tr.setMeta('collabInitialised', true));
            (0, $8ZYbW.handleInit)(data, view, options, editorAnalyticsApi);
        },
        connectedHandler: (data)=>(0, $8ZYbW.handleConnection)(data, view),
        dataHandler: (data)=>(0, $8ZYbW.applyRemoteData)(data, view, options),
        presenceHandler: (data)=>(0, $8ZYbW.handlePresence)(data, view),
        telepointerHandler: (data)=>(0, $8ZYbW.handleTelePointer)(data, view),
        localStepsHandler: (data)=>{
            const { steps: steps } = data;
            const { state: state } = view;
            const { tr: tr } = state;
            steps.forEach((step)=>tr.step(step));
            view.dispatch(tr);
        },
        errorHandler: (error)=>{
            (0, $aQ9Nh.addSynchronyErrorAnalytics)(view.state, view.state.tr, featureFlags, editorAnalyticsApi)(error);
        },
        entityHandler: ({ entity: entity })=>{
            unsubscribeSynchronyEntity();
            if (options.EXPERIMENTAL_allowInternalErrorAnalytics) {
                entity.on('disconnected', entityHandlers.disconnectedHandler);
                entity.on('error', entityHandlers.errorHandler);
                entityRef = entity;
            }
        },
        dataConflictHandler: (data)=>{
            view.dispatch(view.state.tr.setMeta((0, $89tlI.trackLastRemoteConflictPluginKey), data));
        }
    };
    provider.on('init', handlers.initHandler).on('connected', handlers.connectedHandler).on('data', handlers.dataHandler).on('presence', handlers.presenceHandler).on('telepointer', handlers.telepointerHandler).on('local-steps', handlers.localStepsHandler).on('error', handlers.errorHandler).on('entity', handlers.entityHandler).on('data:conflict', handlers.dataConflictHandler);
    return ()=>{
        unsubscribeSynchronyEntity();
        provider.off('init', handlers.initHandler).off('connected', handlers.connectedHandler).off('data', handlers.dataHandler).off('presence', handlers.presenceHandler).off('telepointer', handlers.telepointerHandler).off('local-steps', handlers.localStepsHandler).off('error', handlers.errorHandler).off('entity', handlers.entityHandler).off('data:conflict', handlers.dataConflictHandler);
    };
}, (previousDeps, currentDeps)=>currentDeps && currentDeps.every((dep, i)=>dep === previousDeps[i]));
module.exports["subscribe"] = $98128c88e4bb0942$export$ec068583843480e7;

});

parcelRegister("89tlI", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");

const $9f98dc1e1d0f84b5$export$1fa2affd5117a057 = new (0, $kCECX.PluginKey)('trackLastRemoteConflict');
const $9f98dc1e1d0f84b5$export$ae829ec7b2625219 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $9f98dc1e1d0f84b5$export$1fa2affd5117a057,
        state: {
            init () {
                return undefined;
            },
            apply (transaction, prevPluginState) {
                const metadata = transaction.getMeta($9f98dc1e1d0f84b5$export$1fa2affd5117a057);
                if (metadata) return metadata;
                return prevPluginState;
            }
        }
    });
};
module.exports["trackLastRemoteConflictPluginKey"] = $9f98dc1e1d0f84b5$export$1fa2affd5117a057;
module.exports["createPlugin"] = $9f98dc1e1d0f84b5$export$ae829ec7b2625219;

});

parcelRegister("euTSg", function(module, exports) {

var $8dxef = parcelRequire("8dxef");


var $jbOus = parcelRequire("jbOus");


var $kCECX = parcelRequire("kCECX");


var $8nvEM = parcelRequire("8nvEM");


var $1mAej = parcelRequire("1mAej");


var $03X0Y = parcelRequire("03X0Y");

const $fe2c13f286900d8a$export$1e860daa85a829a5 = (tr, pos)=>{
    const endOfDocPos = tr.doc.nodeSize - 2;
    if (pos <= endOfDocPos) {
        const resolvedPos = tr.doc.resolve(pos);
        const backwardSelection = (0, $kCECX.Selection).findFrom(resolvedPos, -1, true);
        // if there's no correct cursor position before the `pos`, we try to find it after the `pos`
        const forwardSelection = (0, $kCECX.Selection).findFrom(resolvedPos, 1, true);
        return backwardSelection ? backwardSelection.from : forwardSelection ? forwardSelection.from : pos;
    }
    return endOfDocPos;
};
class $fe2c13f286900d8a$export$d8e4bc17e84598c5 {
    get decorations() {
        return this.decorationSet;
    }
    get activeParticipants() {
        return this.participants;
    }
    get sessionId() {
        return this.sid;
    }
    getFullName(sessionId) {
        const participant = this.participants.get(sessionId);
        return participant ? participant.name : 'X';
    }
    getInitial(sessionId) {
        return this.getFullName(sessionId).substring(0, 1).toUpperCase();
    }
    getPresenceId(sessionId) {
        const participant = this.participants.get(sessionId);
        return participant?.presenceId ?? sessionId;
    }
    apply(tr) {
        // Ignored via go/ees005
        // eslint-disable-next-line prefer-const
        let { participants: participants, sid: sid, isReady: isReady } = this;
        const presenceData = tr.getMeta('presence');
        const telepointerData = tr.getMeta('telepointer');
        const nudgeTelepointerData = tr.getMeta('nudgeTelepointer');
        const sessionIdData = tr.getMeta('sessionId');
        let collabInitialised = tr.getMeta('collabInitialised');
        if (typeof collabInitialised !== 'boolean') collabInitialised = isReady;
        if (sessionIdData) sid = sessionIdData.sid;
        let add = [];
        let remove = [];
        if (presenceData) {
            const { joined: joined = [], left: left = [] } = presenceData;
            participants = participants.remove(left.map((i)=>i.sessionId));
            participants = participants.add(joined);
            // Remove telepointers for users that left
            left.forEach((i)=>{
                const pointers = (0, $03X0Y.findPointers)(this.getPresenceId(i.sessionId), this.decorationSet);
                if (pointers) remove = remove.concat(pointers);
            });
        }
        if (telepointerData) {
            const { sessionId: sessionId } = telepointerData;
            if (participants.get(sessionId) && sessionId !== sid) {
                const oldPointers = (0, $03X0Y.findPointers)(this.getPresenceId(sessionId), this.decorationSet);
                if (oldPointers) remove = remove.concat(oldPointers);
                const endOfDocPos = tr.doc.nodeSize - 2;
                const anchor = telepointerData.selection.anchor;
                const head = telepointerData.selection.head;
                let rawFrom = anchor < head ? anchor : head;
                let rawTo = anchor >= head ? anchor : head;
                if (rawFrom > endOfDocPos) rawFrom = endOfDocPos;
                if (rawTo > endOfDocPos) rawTo = endOfDocPos;
                const isSelection = rawTo - rawFrom > 0;
                let from = 1;
                let to = 1;
                try {
                    from = $fe2c13f286900d8a$export$1e860daa85a829a5(tr, isSelection ? Math.max(rawFrom, 0) : rawFrom);
                    to = isSelection ? $fe2c13f286900d8a$export$1e860daa85a829a5(tr, rawTo) : from;
                } catch (err) {
                    this.onError(err);
                }
                add = add.concat((0, $03X0Y.createTelepointers)(from, to, sessionId, isSelection, this.getInitial(sessionId), this.getPresenceId(sessionId), this.getFullName(sessionId), (0, $03X0Y.hasExistingNudge)(sessionId, this.nudgeAnimations)));
            }
        }
        if (tr.docChanged) // Adjust decoration positions to changes made by the transaction
        try {
            this.decorationSet = this.decorationSet.map(tr.mapping, tr.doc, {
                // Reapplies decorators those got removed by the state change
                onRemove: (spec)=>{
                    if (spec.pointer && spec.pointer.sessionId && spec.key === `telepointer-${spec.pointer.sessionId}`) {
                        const step = tr.steps.filter((0, $03X0Y.isReplaceStep))[0];
                        if (step) {
                            const { sessionId: sessionId, presenceId: presenceId } = spec.pointer;
                            const { slice: { content: { size: size } }, from: from } = step;
                            const pos = $fe2c13f286900d8a$export$1e860daa85a829a5(tr, size ? Math.min(from + size, tr.doc.nodeSize - 3) : Math.max(from, 1));
                            add = add.concat((0, $03X0Y.createTelepointers)(pos, pos, sessionId, false, this.getInitial(sessionId), presenceId, this.getFullName(sessionId), (0, $03X0Y.hasExistingNudge)(sessionId, this.nudgeAnimations)));
                        }
                    }
                }
            });
        } catch (err) {
            this.onError(err);
        }
        const { selection: selection } = tr;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.decorationSet.find().forEach((deco)=>{
            if (deco.type.toDOM) {
                const hasTelepointerDimClass = deco.type.toDOM.classList.contains((0, $jbOus.TELEPOINTER_DIM_CLASS));
                const browser = (0, $8dxef.getBrowserInfo)();
                if (deco.from === selection.from && deco.to === selection.to) {
                    if (!hasTelepointerDimClass) deco.type.toDOM.classList.add((0, $jbOus.TELEPOINTER_DIM_CLASS));
                    // Browser condition here to fix ED-14722 where telepointer
                    // decorations with side -1 in Firefox causes backspace issues.
                    // This is likely caused by contenteditable quirks in Firefox
                    if (!browser.gecko) deco.type.side = -1;
                } else {
                    if (hasTelepointerDimClass) deco.type.toDOM.classList.remove((0, $jbOus.TELEPOINTER_DIM_CLASS));
                    deco.type.side = 0;
                }
            }
        });
        if (nudgeTelepointerData) {
            const nudgeSessionId = nudgeTelepointerData?.sessionId;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.decorationSet.find().forEach((deco)=>{
                if (deco.type.toDOM && participants.get(nudgeSessionId) && deco.spec?.pointer?.sessionId === nudgeSessionId && deco.spec?.key === `telepointer-${nudgeSessionId}`) {
                    // Restart animation by removing and re-adding the class
                    deco.type.toDOM.classList.remove((0, $jbOus.TELEPOINTER_PULSE_DURING_TR_CLASS));
                    deco.type.toDOM.classList.remove((0, $jbOus.TELEPOINTER_PULSE_CLASS));
                    deco.type.toDOM.offsetWidth; // Force reflow
                    deco.type.toDOM.classList.add((0, $jbOus.TELEPOINTER_PULSE_CLASS));
                    this.nudgeAnimations.set(nudgeSessionId, Date.now());
                }
            });
        }
        if (remove.length) this.decorationSet = this.decorationSet.remove(remove);
        if (add.length) this.decorationSet = this.decorationSet.add(tr.doc, add);
        // This piece needs to be after the decorationSet adjustments,
        // otherwise it's always one step behind where the cursor is
        if (telepointerData) {
            const { sessionId: sessionId } = telepointerData;
            if (participants.get(sessionId)) {
                const positionForScroll = (0, $03X0Y.getPositionOfTelepointer)(sessionId, this.decorationSet);
                if (positionForScroll) participants = participants.updateCursorPos(sessionId, positionForScroll);
            }
        }
        const nextState = new $fe2c13f286900d8a$export$d8e4bc17e84598c5(this.decorationSet, participants, sid, collabInitialised, this.onError, this.nudgeAnimations);
        return $fe2c13f286900d8a$export$d8e4bc17e84598c5.eq(nextState, this) ? this : nextState;
    }
    static eq(a, b) {
        return a.participants === b.participants && a.sessionId === b.sessionId && a.isReady === b.isReady;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static init(config) {
        const { doc: doc, onError: onError } = config;
        return new $fe2c13f286900d8a$export$d8e4bc17e84598c5((0, $8nvEM.DecorationSet).create(doc, []), new (0, $1mAej.Participants)(), undefined, undefined, onError);
    }
    constructor(decorations, participants, sessionId, collabInitalised = false, onError, nudgeAnimations = new Map()){
        this.decorationSet = void 0;
        this.participants = void 0;
        this.nudgeAnimations = void 0;
        // eslint-disable-next-line no-console
        this.onError = (error)=>console.error(error);
        this.sid = void 0;
        this.isReady = void 0;
        this.decorationSet = decorations;
        this.participants = participants;
        this.sid = sessionId;
        this.isReady = collabInitalised;
        this.onError = onError || this.onError;
        this.nudgeAnimations = nudgeAnimations;
    }
}
module.exports["PluginState"] = $fe2c13f286900d8a$export$d8e4bc17e84598c5;

});

parcelRegister("1mAej", function(module, exports) {
class $af6e3560ecdbcf4a$export$3ebbcd8e174d58e4 {
    add(data) {
        const newSet = new Map(this.participants);
        data.forEach((participant)=>{
            newSet.set(participant.sessionId, participant);
        });
        return new $af6e3560ecdbcf4a$export$3ebbcd8e174d58e4(newSet);
    }
    remove(sessionIds) {
        const newSet = new Map(this.participants);
        sessionIds.forEach((sessionId)=>{
            newSet.delete(sessionId);
        });
        return new $af6e3560ecdbcf4a$export$3ebbcd8e174d58e4(newSet);
    }
    update(sessionId, lastActive) {
        const newSet = new Map(this.participants);
        const data = newSet.get(sessionId);
        if (!data) return this;
        newSet.set(sessionId, {
            ...data,
            lastActive: lastActive
        });
        return new $af6e3560ecdbcf4a$export$3ebbcd8e174d58e4(newSet);
    }
    updateCursorPos(sessionId, cursorPos) {
        const newSet = new Map(this.participants);
        const data = newSet.get(sessionId);
        if (!data) return this;
        newSet.set(sessionId, {
            ...data,
            cursorPos: cursorPos
        });
        return new $af6e3560ecdbcf4a$export$3ebbcd8e174d58e4(newSet);
    }
    toArray() {
        return Array.from(this.participants.values());
    }
    get(sessionId) {
        return this.participants.get(sessionId);
    }
    size() {
        return this.participants.size;
    }
    eq(other) {
        const left = this.toArray().map((p)=>p.sessionId).sort((a, b)=>a > b ? -1 : 1).join('');
        const right = other.toArray().map((p)=>p.sessionId).sort((a, b)=>a > b ? -1 : 1).join('');
        return left === right;
    }
    constructor(participants = new Map()){
        this.participants = void 0;
        this.participants = participants;
    }
}
module.exports["Participants"] = $af6e3560ecdbcf4a$export$3ebbcd8e174d58e4;

});

parcelRegister("jkbED", function(module, exports) {

var $6Ixg8 = parcelRequire("6Ixg8");


var $kCECX = parcelRequire("kCECX");


var $7TcbF = parcelRequire("7TcbF");


var $ieeJu = parcelRequire("ieeJu");

const $3f4c2e14e00f350f$var$isLocked = (step)=>{
    if (step.origin instanceof (0, $kCECX.Transaction)) return step.origin.getMeta('mergeIsLocked');
    return false;
};
function $3f4c2e14e00f350f$export$8e3092acded15d5d(steps, api) {
    const mergedSteps = steps.reduce((acc, rebaseable)=>{
        const lastStep = acc[acc.length - 1];
        const isOffline = (0, $6Ixg8.isOfflineMode)(api?.connectivity?.sharedState.currentState()?.mode);
        const isOnlineMergeEnabled = (0, $ieeJu.expValEquals)('platform_editor_enable_single_player_step_merging', 'isEnabled', true);
        const isMergingEnabled = isOffline || isOnlineMergeEnabled;
        if (isMergingEnabled && lastStep && !$3f4c2e14e00f350f$var$isLocked(lastStep) && !$3f4c2e14e00f350f$var$isLocked(rebaseable)) {
            const mergedStep = lastStep.step.merge(rebaseable.step);
            const inverted = rebaseable.inverted.merge(lastStep.inverted);
            // Always take the origin of the new step.
            // We use this in packages/editor/collab-provider/src/document/document-service.ts:commitUnconfirmedSteps
            // to confirm that the last transaction has been sent. Since we're taking the latest this still works as expected
            // As we want to wait until all the transactions have been pushed through
            const origin = lastStep.origin;
            if (mergedStep && inverted) {
                acc[acc.length - 1] = new (0, $7TcbF.Rebaseable)(mergedStep, inverted, origin instanceof (0, $kCECX.Transaction) ? origin.setMeta('isOffline', origin.getMeta('isOffline') === true || isOffline) : origin);
                return acc;
            }
        }
        acc.push(new (0, $7TcbF.Rebaseable)(rebaseable.step, rebaseable.inverted, rebaseable.origin instanceof (0, $kCECX.Transaction) ? rebaseable.origin.setMeta('isOffline', rebaseable.origin.getMeta('isOffline') === true || isOffline) : rebaseable.origin));
        return acc;
    }, []);
    return mergedSteps;
}
module.exports["mergeUnconfirmedSteps"] = $3f4c2e14e00f350f$export$8e3092acded15d5d;

});

parcelRegister("alVJS", function(module, exports) {

var $l5rX3 = parcelRequire("l5rX3");


var $auTW7 = parcelRequire("auTW7");


var $fkzSG = parcelRequire("fkzSG");

// This is essentially a queue of cached events. When the background task runs to send these items then this queue is flushed.
const $258b55880d613071$var$organicReportingCache = [];
// Every ten seconds we will try to process the step data.
const $258b55880d613071$var$LOW_PRIORITY_DELAY = 10000;
const $258b55880d613071$export$5cff7ac265db316a = (// Our TypeScript configuration isn't ready for the Scheduler API https://developer.mozilla.org/en-US/docs/Web/API/Scheduler/ (yet)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
obj)=>{
    if (!obj) return null;
    if ('scheduler' in obj) return obj.scheduler;
    return null;
};
/**
 * Processes the steps metadata from the cache and calls the callback function with the processed data.
 *
 * @param {OrganicCacheType} cache - A cache containing steps metadata.
 * @param {(data: OrganicMetadataAnalytics[]) => void} onDataProcessed - Callback function to be called with the processed data.
 */ const $258b55880d613071$var$task = (cache, onDataProcessed)=>{
    const data = [];
    for (const item of cache){
        const { steps: steps, ...rest } = item;
        // We'll use the same grouping and sanitize logic from the track-steps util
        const stepTypesAmount = (0, $fkzSG.groupSteps)(steps.map((0, $fkzSG.sanitizeStep)));
        data.push({
            ...rest,
            stepTypesAmount: stepTypesAmount
        });
    }
    // clear the cache.
    cache.length = 0;
    if (data.length > 0) onDataProcessed(data);
};
const $258b55880d613071$export$41ae48ec4a268424 = ({ newEditorState: newEditorState, oldEditorState: oldEditorState, transactions: transactions, onDataProcessed: onDataProcessed })=>{
    // We can exclude analytic steps since they should never trigger an organic change.
    const newSteps = transactions.flatMap((t)=>t.steps).filter((step)=>!(step instanceof (0, $l5rX3.AnalyticsStep)));
    const scheduler = $258b55880d613071$export$5cff7ac265db316a(window);
    if (!newSteps.length || !scheduler) return;
    // We know that an organic change during startup will trigger a draft sync which will;
    // fire editor edited event ->  confluence/next/packages/editor-features/src/hooks/useDraftSync/useDraftSync.tsx
    // and call triggerUpdate() notifying the BE that user edited the page -> confluence/next/packages/editor-features/src/hooks/useDraftSync/useEditorDraftSyncAction.tsx
    // This can cause a problem with statsig metrics if organic changes are being incorrectly reported, ie an automated change
    // occurs which contributes the user towards editing a page when in fact they didn't edit the page.
    //
    const oldPluginState = (0, $auTW7.trackLastOrganicChangePluginKey).getState(oldEditorState);
    const newPluginState = (0, $auTW7.trackLastOrganicChangePluginKey).getState(newEditorState);
    if (newSteps.length && oldPluginState?.lastLocalOrganicBodyChangeAt !== newPluginState?.lastLocalOrganicBodyChangeAt) {
        const now = Date.now();
        const isFirstChange = !oldPluginState?.lastLocalOrganicBodyChangeAt;
        // Check if we should compact with the previous entry (within 2 seconds) this means with a possible 10sec delay
        // due to the postTask we could have a potential 5 grouped organic changes listed.
        const shouldCompact = $258b55880d613071$var$organicReportingCache.length > 0 && now - $258b55880d613071$var$organicReportingCache[$258b55880d613071$var$organicReportingCache.length - 1].startedAt < 2000;
        if (shouldCompact) {
            // Compact with previous entry
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const prev = $258b55880d613071$var$organicReportingCache.pop(); // We know it exists due to shouldCompact check
            // tr.docChanged
            $258b55880d613071$var$organicReportingCache.push({
                transactions: prev.transactions + 1,
                startedAt: prev.startedAt,
                endedAt: now,
                isFirstChange: prev.isFirstChange || isFirstChange,
                steps: prev.steps.concat(newSteps)
            });
        } else // Add new entry
        $258b55880d613071$var$organicReportingCache.push({
            transactions: 1,
            startedAt: now,
            endedAt: now,
            isFirstChange: isFirstChange,
            steps: newSteps
        });
        if ($258b55880d613071$var$organicReportingCache.length === 1) scheduler.postTask(()=>{
            $258b55880d613071$var$task($258b55880d613071$var$organicReportingCache, onDataProcessed);
        }, {
            priority: 'background',
            delay: $258b55880d613071$var$LOW_PRIORITY_DELAY
        });
    }
};
module.exports["monitorOrganic"] = $258b55880d613071$export$41ae48ec4a268424;

});

parcelRegister("auTW7", function(module, exports) {

var $jbOus = parcelRequire("jbOus");


var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $eOaGc = parcelRequire("eOaGc");


var $03X0Y = parcelRequire("03X0Y");

const $ce42e57f255e75ac$export$e968e014d3efd8b6 = new (0, $kCECX.PluginKey)('collabTrackLastOrganicChangePlugin');
const $ce42e57f255e75ac$export$ae829ec7b2625219 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $ce42e57f255e75ac$export$e968e014d3efd8b6,
        state: {
            init () {
                return {
                    lastLocalOrganicChangeAt: null,
                    lastRemoteOrganicChangeAt: null,
                    lastLocalOrganicBodyChangeAt: null,
                    lastRemoteOrganicBodyChangeAt: null
                };
            },
            apply (transaction, prevPluginState) {
                if (Boolean(transaction.getMeta('appendedTransaction'))) return prevPluginState;
                const isRemote = Boolean(transaction.getMeta('isRemote'));
                const isDocumentReplaceFromRemote = isRemote && Boolean(transaction.getMeta('replaceDocument'));
                // Inline comment annotations are not considered as edits to the document body
                const isAnnotationStep = !!transaction.steps.find((step)=>(step instanceof (0, $eOaGc.AddMarkStep) || step instanceof (0, $eOaGc.RemoveMarkStep)) && step.mark?.type?.name === 'annotation');
                if (isDocumentReplaceFromRemote) return prevPluginState;
                if ((0, $jbOus.isDirtyTransaction)(transaction)) return prevPluginState;
                if ((0, $03X0Y.isOrganicChange)(transaction)) {
                    if (isRemote) return {
                        lastLocalOrganicChangeAt: prevPluginState.lastLocalOrganicChangeAt,
                        lastRemoteOrganicChangeAt: Date.now(),
                        lastLocalOrganicBodyChangeAt: prevPluginState.lastLocalOrganicBodyChangeAt,
                        lastRemoteOrganicBodyChangeAt: isAnnotationStep ? prevPluginState.lastRemoteOrganicBodyChangeAt : Date.now()
                    };
                    return {
                        lastLocalOrganicChangeAt: Date.now(),
                        lastRemoteOrganicChangeAt: prevPluginState.lastRemoteOrganicChangeAt,
                        lastLocalOrganicBodyChangeAt: isAnnotationStep ? prevPluginState.lastLocalOrganicBodyChangeAt : Date.now(),
                        lastRemoteOrganicBodyChangeAt: prevPluginState.lastRemoteOrganicBodyChangeAt
                    };
                }
                return prevPluginState;
            }
        }
    });
};
module.exports["trackLastOrganicChangePluginKey"] = $ce42e57f255e75ac$export$e968e014d3efd8b6;
module.exports["createPlugin"] = $ce42e57f255e75ac$export$ae829ec7b2625219;

});

parcelRegister("fkzSG", function(module, exports) {
// delete this file when cleaning up platform_editor_remove_collab_step_metrics

var $l5rX3 = parcelRequire("l5rX3");

var $hdvEd = parcelRequire("hdvEd");

var $1A89X = parcelRequire("1A89X");


var $eOaGc = parcelRequire("eOaGc");


var $7TcbF = parcelRequire("7TcbF");


var $fqVYq = parcelRequire("fqVYq");


var $jq5Q3 = parcelRequire("jq5Q3");

function $ea00a46645b09ae6$var$groupBy(array, keyGetter) {
    // Check group by exists, and that it's a function. If so, use the native browser code
    if ('groupBy' in Object && typeof Object.groupBy === 'function') // @ts-ignore TS2322 - Type 'Partial<Record<string, T[]>>' is not assignable to type 'Record<string, T[]>'.
    return Object.groupBy(array, keyGetter);
    // Fallback to custom implementation
    const map = {};
    array.forEach((item)=>{
        const key = keyGetter(item);
        if (!map[key]) map[key] = [];
        map[key].push(item);
    });
    return map;
}
const $ea00a46645b09ae6$export$685b976035d234a6 = (step)=>{
    const serializedStep = step.toJSON();
    const sanitizedStep = {
        stepType: serializedStep.stepType
    };
    if (step instanceof (0, $eOaGc.AttrStep) || step instanceof (0, $eOaGc.DocAttrStep)) sanitizedStep.attr = step.attr;
    else if (step instanceof (0, $1A89X.SetAttrsStep)) // Combines all attrs keys separated by _ to one single string
    sanitizedStep.attr = Object.keys(step.attrs).sort().join('_');
    else if (step instanceof (0, $eOaGc.AddMarkStep) || step instanceof (0, $eOaGc.RemoveMarkStep) || step instanceof (0, $eOaGc.RemoveNodeMarkStep) || step instanceof (0, $eOaGc.AddNodeMarkStep)) sanitizedStep.markType = step.mark.type.name;
    else if (step instanceof (0, $hdvEd.BatchAttrsStep)) {
        const batched = step.data.map(({ nodeType: nodeType, attrs: attrs })=>`${nodeType}_${Object.keys(attrs).sort().join('_')}`);
        sanitizedStep.attr = batched.sort().join('_');
    }
    return sanitizedStep;
};
const $ea00a46645b09ae6$export$cb21deee7d469afa = (sanitizedSteps)=>{
    const grouped = $ea00a46645b09ae6$var$groupBy(sanitizedSteps, (e)=>Object.values(e).join('_'));
    return Object.entries(grouped).reduce((acc, [key, value])=>{
        acc[key] = Array.isArray(value) ? value.length : 0;
        return acc;
    }, {});
};
const $ea00a46645b09ae6$export$94e939b87ca64fb4 = (cache, onTrackDataProcessed)=>{
    const stepsMetadata = [];
    for (const entry of cache.values()){
        const { startedAt: startedAt, endedAt: endedAt, steps: steps } = entry;
        const stepTypesAmount = $ea00a46645b09ae6$export$cb21deee7d469afa(steps.map($ea00a46645b09ae6$export$685b976035d234a6));
        stepsMetadata.push({
            startedAt: startedAt,
            endedAt: endedAt,
            stepTypesAmount: stepTypesAmount
        });
    }
    cache.clear();
    if (stepsMetadata.length > 0) onTrackDataProcessed(stepsMetadata);
};
const $ea00a46645b09ae6$var$stepsSentCache = new Map();
// Every ten seconds we will try to process the step data.
const $ea00a46645b09ae6$var$LOW_PRIORITY_DELAY = 10000;
const $ea00a46645b09ae6$var$getScheduler = (// Our TypeScript configuration isn't ready for the Scheduler API https://developer.mozilla.org/en-US/docs/Web/API/Scheduler/ (yet)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
obj)=>{
    if (!obj) return null;
    if ('scheduler' in obj) return obj.scheduler;
    return null;
};
const $ea00a46645b09ae6$export$6b2a7d5132615086 = ({ api: api, newEditorState: newEditorState, transactions: transactions, onTrackDataProcessed: onTrackDataProcessed })=>{
    const newSteps = transactions.flatMap((t)=>t.steps);
    const collabState = (0, $7TcbF.sendableSteps)(newEditorState);
    const scheduler = $ea00a46645b09ae6$var$getScheduler(window);
    if (!newSteps.length || !scheduler || !collabState) return;
    const { version: version } = collabState;
    const buffer = $ea00a46645b09ae6$var$stepsSentCache.get(version);
    const startedAt = buffer?.startedAt || Date.now();
    const endedAt = Date.now();
    const steps = (buffer?.steps || []).concat(newSteps);
    $ea00a46645b09ae6$var$stepsSentCache.set(version, {
        startedAt: startedAt,
        endedAt: endedAt,
        steps: steps
    });
    (0, $jq5Q3.updateNcsSessionStepMetrics)({
        api: api,
        steps: (0, $fqVYq.editorExperiment)('platform_editor_reduce_noisy_steps_ncs', true) ? newSteps.filter((step)=>!(step instanceof (0, $l5rX3.AnalyticsStep))) : newSteps
    });
    scheduler.postTask(()=>{
        $ea00a46645b09ae6$export$94e939b87ca64fb4($ea00a46645b09ae6$var$stepsSentCache, onTrackDataProcessed);
    }, {
        priority: 'background',
        delay: $ea00a46645b09ae6$var$LOW_PRIORITY_DELAY
    });
};
module.exports["sanitizeStep"] = $ea00a46645b09ae6$export$685b976035d234a6;
module.exports["groupSteps"] = $ea00a46645b09ae6$export$cb21deee7d469afa;
module.exports["track"] = $ea00a46645b09ae6$export$6b2a7d5132615086;

});

parcelRegister("jq5Q3", function(module, exports) {

var $a1TCB = parcelRequire("a1TCB");


var $6YrB3 = parcelRequire("6YrB3");

const $289cf17f76da8b8b$var$storageClient = new (0, $6YrB3.default)((0, $a1TCB.NCS_STORAGE).NCS_STORAGE_CLIENT_KEY);
const $289cf17f76da8b8b$export$4fe9abcf7996805c = (metrics, sessionId, steps)=>{
    const current = metrics[sessionId] ?? {
        ncsSessionId: sessionId,
        totalStepSize: 0,
        numberOfSteps: 0,
        maxStepSize: 0,
        stepSizeSumForP90: []
    };
    steps.forEach((step)=>{
        const stepSize = JSON.stringify(step).length;
        current.totalStepSize += stepSize;
        current.numberOfSteps += 1;
        current.maxStepSize = Math.max(current.maxStepSize, stepSize || 0);
        current.stepSizeSumForP90.push(stepSize || 0);
    });
    return current;
};
const $289cf17f76da8b8b$export$bc7fe0d8ce4c3c0a = (sessionId)=>{
    const currentActiveSessions = JSON.parse($289cf17f76da8b8b$var$storageClient.getItem((0, $a1TCB.NCS_STORAGE).NCS_ACTIVE_SESSIONS) || '{}');
    if (!currentActiveSessions[sessionId]) $289cf17f76da8b8b$var$storageClient.setItemWithExpiry((0, $a1TCB.NCS_STORAGE).NCS_ACTIVE_SESSIONS, JSON.stringify({
        ...currentActiveSessions,
        [sessionId]: true
    }));
};
const $289cf17f76da8b8b$export$defdcaf9cc1c87fe = ({ api: api, steps: steps })=>{
    const sessionId = api?.collabEdit?.sharedState.currentState()?.sessionId;
    if (!sessionId) return;
    const existingMetrics = JSON.parse($289cf17f76da8b8b$var$storageClient.getItem((0, $a1TCB.NCS_STORAGE).NCS_SESSION_STEP_METRICS) || '{}');
    const ncsSessionStepMetrics = $289cf17f76da8b8b$export$4fe9abcf7996805c(existingMetrics, sessionId, steps);
    $289cf17f76da8b8b$var$storageClient.setItemWithExpiry((0, $a1TCB.NCS_STORAGE).NCS_SESSION_STEP_METRICS, JSON.stringify({
        ...existingMetrics,
        [sessionId]: ncsSessionStepMetrics
    }));
    $289cf17f76da8b8b$export$bc7fe0d8ce4c3c0a(sessionId);
};
module.exports["updateNcsSessionStepMetrics"] = $289cf17f76da8b8b$export$defdcaf9cc1c87fe;

});

parcelRegister("a1TCB", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ var $a362193e7f71cc60$export$d173f08296df529 = /*#__PURE__*/ function(NCS_STORAGE) {
    // remove step metrics keys when cleaning up platform_editor_remove_collab_step_metrics
    NCS_STORAGE["NCS_STORAGE_CLIENT_KEY"] = "ncs-session-step-metrics-storage";
    NCS_STORAGE["NCS_SESSION_STEP_METRICS"] = "ncsSessionStepMetrics";
    NCS_STORAGE["NCS_ACTIVE_SESSIONS"] = "ncsActiveSessions";
    return NCS_STORAGE;
}({});
module.exports["NCS_STORAGE"] = $a362193e7f71cc60$export$d173f08296df529;

});

parcelRegister("jm7OT", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");

const $847ae5ee06d6088f$var$nativeCollabProviderPluginKey = new (0, $kCECX.PluginKey)('nativeCollabProviderPlugin');
const $847ae5ee06d6088f$export$ad653665b59b3ffd = ({ providerPromise: providerPromise })=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $847ae5ee06d6088f$var$nativeCollabProviderPluginKey,
        state: {
            init: ()=>null,
            apply: (tr, currentPluginState)=>{
                const provider = tr.getMeta($847ae5ee06d6088f$var$nativeCollabProviderPluginKey);
                return provider ? provider : currentPluginState;
            }
        },
        view: (editorView)=>{
            providerPromise.then((provider)=>{
                const { dispatch: dispatch, state: state } = editorView;
                const tr = state.tr;
                tr.setMeta($847ae5ee06d6088f$var$nativeCollabProviderPluginKey, provider);
                dispatch(tr);
            });
            return {};
        }
    });
};
const $847ae5ee06d6088f$export$82feb779db31f396 = (editorState)=>{
    return $847ae5ee06d6088f$var$nativeCollabProviderPluginKey.getState(editorState);
};
module.exports["nativeCollabProviderPlugin"] = $847ae5ee06d6088f$export$ad653665b59b3ffd;

});

parcelRegister("6ixNC", function(module, exports) {

var $l5rX3 = parcelRequire("l5rX3");

var $gT4iv = parcelRequire("gT4iv");

var $73Kv0 = parcelRequire("73Kv0");

var $1A89X = parcelRequire("1A89X");


var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $eOaGc = parcelRequire("eOaGc");

const $30d605db108db527$var$THRESHOLD = 50; // 50 milliseconds
const $30d605db108db527$export$2d791416d1075a3b = (step)=>{
    const serializedStep = step.toJSON();
    const sanitizedStep = {
        stepType: serializedStep.stepType,
        stepInstance: 'unknown'
    };
    if (step instanceof (0, $eOaGc.AttrStep)) {
        sanitizedStep.attr = step.attr;
        sanitizedStep.stepInstance = 'AttrStep';
    } else if (step instanceof (0, $eOaGc.DocAttrStep)) {
        sanitizedStep.attr = step.attr;
        sanitizedStep.stepInstance = 'DocAttrStep';
    } else if (step instanceof (0, $1A89X.SetAttrsStep)) {
        // Combines all attrs keys separated by _ to one single string
        sanitizedStep.attr = Object.keys(step.attrs).sort().join('_');
        sanitizedStep.stepInstance = 'SetAttrsStep';
    } else if (step instanceof (0, $eOaGc.AddMarkStep)) {
        sanitizedStep.markType = step.mark.type.name;
        sanitizedStep.stepInstance = 'AddMarkStep';
    } else if (step instanceof (0, $eOaGc.RemoveMarkStep)) {
        sanitizedStep.markType = step.mark.type.name;
        sanitizedStep.stepInstance = 'RemoveMarkStep';
    } else if (step instanceof (0, $eOaGc.RemoveNodeMarkStep)) {
        sanitizedStep.markType = step.mark.type.name;
        sanitizedStep.stepInstance = 'RemoveNodeMarkStep';
    } else if (step instanceof (0, $eOaGc.AddNodeMarkStep)) {
        sanitizedStep.markType = step.mark.type.name;
        sanitizedStep.stepInstance = 'AddNodeMarkStep';
    } else if (step instanceof (0, $eOaGc.ReplaceStep)) sanitizedStep.stepInstance = 'ReplaceStep';
    else if (step instanceof (0, $eOaGc.ReplaceAroundStep)) sanitizedStep.stepInstance = 'ReplaceAroundStep';
    else if (step instanceof (0, $l5rX3.AnalyticsStep)) sanitizedStep.stepInstance = 'AnalyticsStep';
    else if (step instanceof (0, $gT4iv.InsertTypeAheadStep)) sanitizedStep.stepInstance = 'InsertTypeAheadStep';
    else if (step instanceof (0, $73Kv0.LinkMetaStep)) sanitizedStep.stepInstance = 'LinkMetaStep';
    return sanitizedStep;
};
const $30d605db108db527$export$4bff6ad17bbfeba7 = (recentTransactionsTimestamps, trackFilteredTransaction)=>{
    return (tr)=>{
        if (Boolean(tr.getMeta('appendTransaction'))) return true;
        const isRemote = Boolean(tr.getMeta('isRemote'));
        if (isRemote) return true;
        const containsExcludedSteps = tr.steps.some((step)=>{
            return step instanceof (0, $l5rX3.AnalyticsStep) || step instanceof (0, $eOaGc.ReplaceStep) || step instanceof (0, $eOaGc.ReplaceAroundStep) || step instanceof (0, $73Kv0.LinkMetaStep);
        });
        if (containsExcludedSteps) return true;
        if (tr.docChanged && tr.doc.eq(tr.before)) {
            const transactionKey = $30d605db108db527$export$16b712be60324104(tr);
            if (!transactionKey) return true;
            //Clean up tracked transactions when time over threshold
            recentTransactionsTimestamps.forEach((value, key)=>{
                if (tr.time - value.timestamp > $30d605db108db527$var$THRESHOLD) // Delete tracked transaction when over threshold
                recentTransactionsTimestamps.delete(key);
            });
            const lastTransactionEntry = recentTransactionsTimestamps.get(transactionKey);
            if (!lastTransactionEntry) {
                // If no timestamp exists for the given transaction, allow transaction and add an entry
                recentTransactionsTimestamps.set(transactionKey, {
                    timestamp: tr.time,
                    steps: tr.steps
                });
                return true;
            }
            // Track analytics for the filtered transaction
            trackFilteredTransaction(tr);
            // Filter transaction
            return false;
        }
        return true; // Allow the transaction
    };
};
function $30d605db108db527$export$16b712be60324104(tr) {
    const stepPositions = tr.steps.map((step)=>{
        if (step instanceof (0, $eOaGc.RemoveNodeMarkStep) || step instanceof (0, $eOaGc.AddNodeMarkStep) || step instanceof (0, $1A89X.SetAttrsStep) || step instanceof (0, $eOaGc.AttrStep)) {
            if (step.pos !== undefined) return `${step.pos}`;
        } else if (step instanceof (0, $eOaGc.AddMarkStep) || step instanceof (0, $eOaGc.RemoveMarkStep)) return `from_${step.from}_to_${step.to}`;
        else if (step instanceof (0, $gT4iv.InsertTypeAheadStep)) return `insertTypeAheadStep`;
        return '';
    });
    if (stepPositions.some((step)=>Boolean(step))) return stepPositions.join('_');
    return '';
}
const $30d605db108db527$export$ea2d2436326e1247 = new (0, $kCECX.PluginKey)('trackAndFilterSpammingStepsPluginKey');
const $30d605db108db527$export$ae829ec7b2625219 = (trackFilteredTransaction)=>{
    const recentTransactionsTimestamps = new Map();
    return new (0, $kpCD8.SafePlugin)({
        key: $30d605db108db527$export$ea2d2436326e1247,
        filterTransaction: $30d605db108db527$export$4bff6ad17bbfeba7(recentTransactionsTimestamps, trackFilteredTransaction)
    });
};
module.exports["sanitizeFilteredStep"] = $30d605db108db527$export$2d791416d1075a3b;
module.exports["createPlugin"] = $30d605db108db527$export$ae829ec7b2625219;

});

parcelRegister("82I6D", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");

const $8270ecf1c6f2ab4a$export$43594b7b1d8b2d04 = new (0, $kCECX.PluginKey)('contentFormat');
const $8270ecf1c6f2ab4a$export$ae829ec7b2625219 = ({ initialContentMode: initialContentMode })=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $8270ecf1c6f2ab4a$export$43594b7b1d8b2d04,
        state: {
            init: ()=>({
                    contentMode: initialContentMode ?? 'standard'
                }),
            apply: (tr, currentPluginState)=>{
                const meta = tr.getMeta($8270ecf1c6f2ab4a$export$43594b7b1d8b2d04);
                if (meta) {
                    const { contentMode: contentMode } = meta;
                    return {
                        contentMode: contentMode ?? currentPluginState.contentMode
                    };
                }
                return currentPluginState;
            }
        }
    });
};
const $8270ecf1c6f2ab4a$export$c0bae1e3feda2109 = ({ config: options })=>{
    let previousContentMode;
    return {
        name: 'contentFormat',
        getSharedState (editorState) {
            if (!editorState) return {
                contentMode: options?.initialContentMode ?? 'standard'
            };
            const pluginState = $8270ecf1c6f2ab4a$export$43594b7b1d8b2d04.getState(editorState);
            return {
                contentMode: pluginState?.contentMode ?? 'standard'
            };
        },
        commands: {
            updateContentMode: (contentMode)=>({ tr: tr })=>{
                    if (contentMode === previousContentMode) return null;
                    previousContentMode = contentMode;
                    return tr.setMeta($8270ecf1c6f2ab4a$export$43594b7b1d8b2d04, {
                        contentMode: contentMode
                    });
                }
        },
        pmPlugins () {
            return [
                {
                    name: 'contentFormat',
                    plugin: ()=>$8270ecf1c6f2ab4a$export$ae829ec7b2625219({
                            initialContentMode: options?.initialContentMode ?? 'standard'
                        })
                }
            ];
        }
    };
};
module.exports["contentFormatPlugin"] = $8270ecf1c6f2ab4a$export$c0bae1e3feda2109;

});

parcelRegister("bw7eK", function(module, exports) {
$parcel$export(module.exports, "referentialityPlugin", () => (parcelRequire("7rgfa")).referentialityPlugin);
$parcel$export(module.exports, "dataSourceResolver", () => (parcelRequire("joQDI")).dataSourceResolver);
$parcel$export(module.exports, "ADFReferenceTypes", () => (parcelRequire("gkua4")).ADFReferenceTypes);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $7rgfa = parcelRequire("7rgfa");


var $joQDI = parcelRequire("joQDI");


var $czge2 = parcelRequire("czge2");


var $3CKU8 = parcelRequire("3CKU8");


var $gkua4 = parcelRequire("gkua4");


var $e745x = parcelRequire("e745x");


});

parcelRegister("joQDI", function(module, exports) {

var $kCECX = parcelRequire("kCECX");


var $51GYa = parcelRequire("51GYa");

const $d3ccfabdcdf5c228$export$5e2881449d7cf240 = (editorActions)=>{
    const state = editorActions?._privateGetEditorView()?.state;
    if (!state) return null;
    const selection = state.selection;
    if (selection instanceof (0, $kCECX.NodeSelection)) {
        const dataSourceId = selection.node.marks?.find((mark)=>mark.type === state.schema?.marks?.dataConsumer)?.attrs?.sources[0];
        if (!dataSourceId) return null;
        const dataSourceProvider = (0, $51GYa.getPluginState)(state)?.dataSourceProvider;
        return dataSourceProvider?.get(dataSourceId);
    }
};
module.exports["dataSourceResolver"] = $d3ccfabdcdf5c228$export$5e2881449d7cf240;

});

parcelRegister("5wfVt", function(module, exports) {

var $iLrhi = parcelRequire("iLrhi");

const $cadd3bfd971d84fd$export$67504bcc111d98ac = ()=>({
        name: 'empty',
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return {
                editorIsEmpty: (0, $iLrhi.isEmptyDocument)(editorState.doc)
            };
        }
    });
module.exports["emptyStatePlugin"] = $cadd3bfd971d84fd$export$67504bcc111d98ac;

});

parcelRegister("fayTW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::46a94e1addf026bfebe08b8e272a8c2a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0b2dcda52076574$var$_react = $b0b2dcda52076574$var$_interopRequireDefault((parcelRequire("cozmU")));

var $b0b2dcda52076574$var$_baseNew = $b0b2dcda52076574$var$_interopRequireDefault((parcelRequire("gElAV")));
function $b0b2dcda52076574$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsSchema".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing schema in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b0b2dcda52076574$var$AssetsSchemaIcon = (props)=>/*#__PURE__*/ $b0b2dcda52076574$var$_react.default.createElement($b0b2dcda52076574$var$_baseNew.default, Object.assign({
        name: "AssetsSchemaIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.75 11a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5m0-8a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5M3 13.5a2 2 0 0 1-2-2V0h1.5v4H8v1.5H2.5v6a.5.5 0 0 0 .5.5h5v1.5zm9.75-4a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5m0-8a3.25 3.25 0 1 1 0 6.5 3.25 3.25 0 0 1 0-6.5"/>`
    }, props));
$b0b2dcda52076574$var$AssetsSchemaIcon.displayName = 'AssetsSchemaIcon';
var $b0b2dcda52076574$var$_default = module.exports.default = $b0b2dcda52076574$var$AssetsSchemaIcon;

});

parcelRegister("cS4kb", function(module, exports) {
const $5b142abb1411e5f7$var$UNKNOWN = 'unknown';
function $5b142abb1411e5f7$var$sanitizeUrl(url) {
    try {
        const urlObject = new URL(url);
        const hostname = urlObject.hostname;
        const pathname = urlObject.pathname;
        const firstPathSegment = pathname.split('/')[1];
        return firstPathSegment ? `${hostname}/${firstPathSegment}` : hostname;
    } catch  {
        return '';
    }
}
function $5b142abb1411e5f7$export$8071740a02e53ce2(link) {
    if (link.includes('/jira/') || link.includes('/servicedesk/') || link.includes('/helpcenter/') || link.includes('/projects/')) return 'jira';
    else if (link.includes('/wiki/')) return 'confluence';
    else if (link.includes('bitbucket')) return 'bitbucket';
    else if (link.includes('atlassian') || link.includes('jira-dev')) {
        // eslint-disable-next-line no-console
        console.log(`Resolving other atlassian link type: ${$5b142abb1411e5f7$var$sanitizeUrl(link)}`);
        return 'otherAtlassian';
    }
    return 'thirdParty';
}
function $5b142abb1411e5f7$export$70b802114e3b3d52(smartLinks) {
    return Object.values(smartLinks.reduce((acc, smartLink)=>{
        try {
            var _acc, _hostname;
            const hostname = new URL(smartLink.resourceUrl).hostname;
            ((_acc = acc)[_hostname = hostname] || (_acc[_hostname] = [])).push(smartLink);
        // eslint-disable-next-line no-unused-vars
        } catch (e) {
            var _acc1, _UNKNOWN;
            ((_acc1 = acc)[_UNKNOWN = $5b142abb1411e5f7$var$UNKNOWN] || (_acc1[_UNKNOWN] = [])).push(smartLink);
        }
        return acc;
    }, {}));
}
function $5b142abb1411e5f7$export$9f4b5e6e623e6720(smartLinksGroups, max) {
    const result = [];
    for (const smartLinks of smartLinksGroups){
        if (smartLinks.length <= max) result.push(smartLinks);
        else for(let i = 0; i < smartLinks.length; i += max)result.push(smartLinks.slice(i, i + max));
    }
    return result;
}
function $5b142abb1411e5f7$export$3e7fb54d0ef2df07(smartLinksGroups, min) {
    const result = [];
    const smallThirdPartyBatches = [];
    for (const smartLinks of smartLinksGroups)if (smartLinks.length >= min || $5b142abb1411e5f7$export$8071740a02e53ce2(smartLinks[0].resourceUrl) !== 'thirdParty') result.push(smartLinks);
    else smallThirdPartyBatches.push(...smartLinks);
    if (smallThirdPartyBatches.length > 0) result.push(smallThirdPartyBatches);
    return result;
}
function $5b142abb1411e5f7$export$8c4674ec524aaf2c(resourceUrl) {
    const type = $5b142abb1411e5f7$export$8071740a02e53ce2(resourceUrl);
    switch(type){
        case 'jira':
        case 'confluence':
        case 'bitbucket':
        case 'otherAtlassian':
            return true;
        default:
            return false;
    }
}
module.exports["getLinkType"] = $5b142abb1411e5f7$export$8071740a02e53ce2;
module.exports["groupSmartLinksByHostname"] = $5b142abb1411e5f7$export$70b802114e3b3d52;
module.exports["splitLinksIntoBatches"] = $5b142abb1411e5f7$export$9f4b5e6e623e6720;
module.exports["mergeSmallThirdPartyBatches"] = $5b142abb1411e5f7$export$3e7fb54d0ef2df07;
module.exports["isFirstPartyLink"] = $5b142abb1411e5f7$export$8c4674ec524aaf2c;

});

parcelRegister("Wsgbu", function(module, exports) {

var $4yccB = parcelRequire("4yccB");


var $hQnHK = parcelRequire("hQnHK");


var $1NBp8 = parcelRequire("1NBp8");

parcelRequire("ayS0g");
var $laZ2J = parcelRequire("laZ2J");
var $5y1g5 = parcelRequire("5y1g5");
var $aVk5V = parcelRequire("aVk5V");


var $lJDEI = parcelRequire("lJDEI");


var $6s78L = parcelRequire("6s78L");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $jqe2L = parcelRequire("jqe2L");


var $1yME3 = parcelRequire("1yME3");


var $jSIHW = parcelRequire("jSIHW");


var $6jFZl = parcelRequire("6jFZl");


var $460Q4 = parcelRequire("460Q4");


var $rmocb = parcelRequire("rmocb");


var $dkIiA = parcelRequire("dkIiA");


var $kjahF = parcelRequire("kjahF");

const $e1195a14cbc438cf$var$NEW_DATABASE_QUERY_PARAM = 'isNewDatabase';
const $e1195a14cbc438cf$export$a9e04d3794c981d4 = 60;
const $e1195a14cbc438cf$var$_createWhiteboardMutation = async (variables)=>{
    const { spaceKey: spaceKey, parentId: parentId, paywallStatus: paywallStatus, deactivationIdentifier: deactivationIdentifier, restoreVersionContentId: restoreVersionContentId, title: title } = variables;
    const contentSpecificCreateInput = [];
    if (paywallStatus) contentSpecificCreateInput.push({
        key: 'defaultPaywallStatus',
        value: paywallStatus
    });
    if (deactivationIdentifier) contentSpecificCreateInput.push({
        key: 'deactivationIdentifier',
        value: deactivationIdentifier
    });
    if (restoreVersionContentId) contentSpecificCreateInput.push({
        key: 'restoreVersionContentId',
        value: restoreVersionContentId
    });
    const result = await (0, $6s78L.mutateInterop)({
        mutation: (0, $jSIHW.CreateWhiteboardMutation),
        variables: {
            spaceKey: spaceKey,
            parentId: parentId,
            contentSpecificCreateInput: contentSpecificCreateInput,
            title: title
        },
        __callerPackage__: "create-blank-fabric-page"
    });
    return result.data;
};
const $e1195a14cbc438cf$export$666bdd08b67471d3 = async (mutationVariables, urlParams = {})=>{
    const result = await $e1195a14cbc438cf$var$_createWhiteboardMutation(mutationVariables);
    const space = result.createContentContextual?.space;
    const contentId = result.createContentContextual?.id;
    const { deactivationIdentifier: deactivationIdentifier, restoreVersionContentId: restoreVersionContentId } = mutationVariables || {};
    const url = (0, $1NBp8.WHITEBOARD_BOARD).toUrl({
        spaceKey: space?.alias || space?.key,
        contentId: contentId
    }, {
        query: {
            [(0, $hQnHK.NEW_WHITEBOARD_QUERY_PARAM)]: true,
            [(0, $hQnHK.TEMPLATE_PICKER_QUERY_PARAM)]: true,
            ...urlParams,
            ...deactivationIdentifier && {
                [(0, $hQnHK.PAYWALL_DEACTIVATION_IDENTIFIER)]: deactivationIdentifier
            },
            ...restoreVersionContentId && {
                flow: 'restoreVersion'
            }
        }
    });
    return {
        contentId: contentId,
        spaceId: space?.id,
        url: url,
        collabService: 'canvas-relay'
    };
};
const $e1195a14cbc438cf$var$_createDatabaseMutation = async (variables)=>{
    const result = await (0, $6s78L.mutateInterop)({
        mutation: (0, $6jFZl.CreateDatabaseMutation),
        variables: variables,
        __callerPackage__: "create-blank-fabric-page"
    });
    return result.data;
};
const $e1195a14cbc438cf$export$4d121d93f1254a51 = async ({ spaceKey: spaceKey, parentId: parentId })=>{
    const result = await $e1195a14cbc438cf$var$_createDatabaseMutation({
        spaceKey: spaceKey,
        parentId: parentId
    });
    const space = result.createContentContextual?.space;
    const contentId = result.createContentContextual?.id;
    const url = (0, $1NBp8.DATABASE_VIEW).toUrl({
        spaceKey: space?.alias || space?.key,
        contentId: contentId
    }, {
        query: {
            [$e1195a14cbc438cf$var$NEW_DATABASE_QUERY_PARAM]: true
        }
    });
    return {
        contentId: contentId,
        spaceId: space?.id,
        url: url,
        collabService: 'canvas-relay'
    };
};
const $e1195a14cbc438cf$var$_CreateSmartLinkEmbedMutation = async (variables)=>{
    const result = await (0, $6s78L.mutateInterop)({
        mutation: (0, $460Q4.CreateSmartLinkEmbedMutation),
        variables: variables,
        __callerPackage__: "create-blank-fabric-page"
    });
    return result.data;
};
const $e1195a14cbc438cf$export$a514f232a71e48c1 = async ({ createAnalyticsEvent: createAnalyticsEvent, createSource: createSource, spaceKey: spaceKey, parentId: parentId, embedUrl: embedUrl })=>{
    let contentSpecificCreateInput;
    let product;
    let title;
    let embedExtensionKey;
    let embedResourceType;
    let normalizedEmbedUrl;
    if (embedUrl) {
        const cardClient = new (0, $4yccB.default)();
        cardClient.setProduct('CONFLUENCE');
        normalizedEmbedUrl = (0, $aVk5V.normalizeAndValidateUrl)(embedUrl);
        if (!normalizedEmbedUrl) throw new Error('Invalid smart link embed URL');
        const { meta: meta, parsedEmbedData: parsedEmbedData } = await (0, $laZ2J.fetchDataFromORS)({
            cardClient: cardClient,
            createAnalyticsEvent: createAnalyticsEvent,
            embedUrl: normalizedEmbedUrl
        });
        title = parsedEmbedData.title && parsedEmbedData.title.length > $e1195a14cbc438cf$export$a9e04d3794c981d4 && (0, $9wGTI.fg)('cc_drag_and_drop_smart_link_from_content_to_tree') ? `${parsedEmbedData.title.slice(0, $e1195a14cbc438cf$export$a9e04d3794c981d4 - 3)}...` : parsedEmbedData.title;
        product = parsedEmbedData.product || undefined;
        embedExtensionKey = meta?.extensionKey ?? null;
        embedResourceType = meta?.resourceType ?? null;
        contentSpecificCreateInput = [];
        if (parsedEmbedData.iconURL) contentSpecificCreateInput.push({
            key: 'embedIconUrl',
            value: parsedEmbedData.iconURL
        });
        // We should use the URL returned by ORS if possible since it will return the URL in
        // the most normalized form (e.g. it can reformat URLs that contain unicode characters
        // such that BE will accept them)
        contentSpecificCreateInput.push({
            key: 'embedUrl',
            value: parsedEmbedData.url ?? normalizedEmbedUrl
        });
        if (product) contentSpecificCreateInput.push({
            key: 'product',
            value: product
        });
        if (createSource) contentSpecificCreateInput.push({
            key: 'createSource',
            value: createSource
        });
    }
    // smart link embeds go through blank creation flow so no initial URL is provided to the mutation
    const smartLinkResult = await $e1195a14cbc438cf$var$_CreateSmartLinkEmbedMutation({
        ...contentSpecificCreateInput ? {
            contentSpecificCreateInput: contentSpecificCreateInput
        } : {},
        ...title ? {
            title: title
        } : {},
        type: 'embed',
        status: (0, $kjahF.GraphQLContentStatus).CURRENT,
        parentId: parentId,
        spaceKey: spaceKey
    });
    const space = smartLinkResult.createContentContextual?.space;
    const contentId = smartLinkResult.createContentContextual?.id;
    const query = {};
    // This query paramter is used to display the dot grid background when new *blank* embeds
    // are created. If there's an embedUrl already provided, it's not a blank embed.
    if (!embedUrl) query[0, $5y1g5.IS_NEW_EMBED_QUERY_PARAM_KEY] = true;
    const url = (0, $1NBp8.EMBED_VIEW).toUrl({
        spaceKey: space?.alias || space?.key,
        contentId: contentId
    }, {
        query: query
    });
    return {
        analyticsAttributes: {
            extensionKey: embedExtensionKey,
            destinationObjectType: embedResourceType
        },
        nonPrivacySafeAttributes: {
            linkDomain: product,
            url: normalizedEmbedUrl
        },
        collabService: 'no-collab-for-smart-link-embeds',
        contentId: contentId,
        spaceId: space?.id,
        url: url
    };
};
const $e1195a14cbc438cf$var$_CreateFolderMutation = async (variables)=>{
    const result = await (0, $6s78L.mutateInterop)({
        mutation: (0, $rmocb.CreateFolderMutation),
        variables: variables,
        __callerPackage__: "create-blank-fabric-page"
    });
    return result.data;
};
const $e1195a14cbc438cf$export$3e830820234ed44d = async ({ spaceKey: spaceKey, parentId: parentId })=>{
    const folderResult = await $e1195a14cbc438cf$var$_CreateFolderMutation({
        type: 'folder',
        status: (0, $kjahF.GraphQLContentStatus).CURRENT,
        parentId: parentId,
        spaceKey: spaceKey
    });
    const space = folderResult.createContentContextual?.space;
    const contentId = folderResult.createContentContextual?.id;
    const folderViewUrl = spaceKey && contentId && (0, $6mKj3.expVal)('confluence_folder_view', 'isEnabled', false) ? (0, $1NBp8.FOLDER_VIEW).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    }) : undefined;
    return {
        contentId: contentId,
        spaceId: space?.id,
        url: folderViewUrl ? (0, $jqe2L.appendQueryParams)(folderViewUrl, {
            inlineTitleEdit: 'true'
        }) : undefined,
        collabService: 'no-collab-for-folders'
    };
};
const $e1195a14cbc438cf$var$_createBlankContentMutation = async (variables)=>{
    const result = await (0, $6s78L.mutateInterop)({
        mutation: (0, $1yME3.CreateContentMutation),
        variables: variables,
        __callerPackage__: "create-blank-fabric-page"
    });
    return result.data;
};
const $e1195a14cbc438cf$var$createContentGQL = async ({ subType: subType, spaceKey: spaceKey, parentPage: parentPage, title: title, linkCreation: linkCreation, fabricEditorModeCacheStoreActions: fabricEditorModeCacheStoreActions, templateKey: templateKey, shouldOpenTemplatesGallery: shouldOpenTemplatesGallery, shouldOpenImportTab: shouldOpenImportTab, type: type })=>{
    const status = subType === (0, $dkIiA.ConfluencePageSubType).LIVE ? (0, $dkIiA.GraphQLContentStatus).CURRENT : (0, $dkIiA.GraphQLContentStatus).DRAFT;
    const contentSpecificCreateInput = templateKey ? $e1195a14cbc438cf$var$getTemplateContentSpecificInput(templateKey) : undefined;
    const variables = {
        subType: subType,
        spaceKey: spaceKey,
        parentId: parentPage,
        title: title,
        status: status,
        contentSpecificCreateInput: contentSpecificCreateInput,
        type: type
    };
    const pageData = await $e1195a14cbc438cf$var$_createBlankContentMutation(variables);
    const contentId = pageData.createContentContextual?.id;
    const spaceId = pageData.createContentContextual?.space?.id;
    const editui = pageData.createContentContextual?.links?.editui || '';
    const collabService = pageData.createContentContextual?.metadata?.frontend?.collabService;
    const returnedSubType = pageData.createContentContextual?.subType;
    const returnedSpaceKey = pageData.createContentContextual?.space?.alias || pageData.createContentContextual?.space?.key;
    const context = pageData.createContentContextual?.links?.context || '';
    let url = subType === (0, $dkIiA.ConfluencePageSubType).LIVE ? (0, $jqe2L.processDraftUrl)(editui) : (0, $jqe2L.getEditPageUrl)({
        spaceKey: returnedSpaceKey,
        contentId: contentId,
        url: context + editui,
        type: type
    });
    if (linkCreation) url = (0, $jqe2L.appendQueryParams)(url, {
        linkCreation: linkCreation
    }, fabricEditorModeCacheStoreActions?.setFabricEditorMode);
    if (shouldOpenTemplatesGallery) url = (0, $jqe2L.appendQueryParams)(url, {
        [(0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_PARAM_NAME)]: (0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_OPEN)
    }, fabricEditorModeCacheStoreActions?.setFabricEditorMode);
    if (shouldOpenImportTab) url = (0, $jqe2L.appendQueryParams)(url, {
        [(0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_PARAM_NAME)]: (0, $lJDEI.IN_EDITOR_TEMPLATES_QUERY_OPEN),
        [(0, $lJDEI.CONTEXT_PANEL_TAB_TARGET)]: (0, $lJDEI.CONTEXT_PANEL_TAB_TARGET_IMPORT)
    }, fabricEditorModeCacheStoreActions?.setFabricEditorMode);
    return {
        contentId: contentId,
        spaceId: spaceId,
        url: url,
        collabService: collabService,
        returnedSubType: returnedSubType,
        returnedStatus: status
    };
};
const $e1195a14cbc438cf$export$715e7bf6a2288b1a = async (args)=>{
    return $e1195a14cbc438cf$var$createContentGQL({
        ...args,
        type: 'page'
    });
};
const $e1195a14cbc438cf$export$82ee0f89675e8b1a = async (spaceKey)=>{
    return $e1195a14cbc438cf$var$createContentGQL({
        spaceKey: spaceKey,
        type: 'blogpost'
    });
};
// Template configuration mapping
const $e1195a14cbc438cf$var$TEMPLATE_CONFIG = {
    'meeting-notes-blueprint': {
        key: 'templateId',
        plugin: 'confluence-business-blueprints'
    },
    'projectplan-blueprint': {
        key: 'templateId',
        plugin: 'confluence-business-blueprints'
    },
    'requirements-blueprint': {
        key: 'templateId',
        plugin: 'confluence-software-blueprints'
    },
    'marketing-campaign-blueprint': {
        key: 'templateId',
        plugin: 'confluence-business-blueprints'
    },
    'marketing-blueprint': {
        key: 'templateId',
        plugin: 'confluence-business-blueprints'
    },
    'design-decision-blueprint': {
        key: 'templateId',
        plugin: 'confluence-business-blueprints'
    },
    'standard-operating-procedure-sop-blueprint': {
        key: 'templateId',
        plugin: 'confluence-business-blueprints'
    },
    'business-status-update-blueprint': {
        key: 'templateId',
        plugin: 'confluence-business-blueprints'
    },
    'kb-how-to-article-blueprint': {
        key: 'templateId',
        plugin: 'confluence-knowledge-base'
    },
    'fundraising-database-blueprint': {
        key: 'templateId',
        plugin: 'confluence-business-blueprints'
    },
    'employee-handbook-blueprint': {
        key: 'templateId',
        plugin: 'confluence-business-blueprints'
    },
    'hiring-process-blueprint': {
        key: 'templateId',
        plugin: 'confluence-business-blueprints'
    },
    'business-strategy-blueprint': {
        key: 'templateId',
        plugin: 'confluence-business-blueprints'
    },
    'account-planning-for-sales-blueprint': {
        key: 'templateId',
        plugin: 'confluence-business-blueprints'
    }
};
const $e1195a14cbc438cf$var$TEMPLATE_REGEX = /^com\.atlassian\.confluence\.plugins\.confluence(-[0-9a-z]+)(-[0-9a-z]+)*-blueprints:([0-9a-z]+)(-[0-9a-z]+)*-blueprint$/;
/**
 * Generates the contentSpecificCreateInput for a given template key
 * @param templateKey - The template key (e.g., 'meeting-notes-blueprint')
 * @returns ContentSpecificCreateInput array or undefined if template not found
 */ const $e1195a14cbc438cf$var$getTemplateContentSpecificInput = (templateKey)=>{
    const config = $e1195a14cbc438cf$var$TEMPLATE_CONFIG[templateKey];
    if (!config) {
        // Support full template keys
        if ($e1195a14cbc438cf$var$TEMPLATE_REGEX.test(templateKey)) return [
            {
                key: 'templateId',
                value: templateKey
            }
        ];
        // Return undefined for unknown templates
        return undefined;
    }
    return [
        {
            key: config.key,
            value: `com.atlassian.confluence.plugins.${config.plugin}:${templateKey}`
        }
    ];
};
module.exports["MAX_SMART_LINK_EMBED_TITLE_LENGTH"] = $e1195a14cbc438cf$export$a9e04d3794c981d4;
module.exports["createWhiteboardContent"] = $e1195a14cbc438cf$export$666bdd08b67471d3;
module.exports["createDatabaseContent"] = $e1195a14cbc438cf$export$4d121d93f1254a51;
module.exports["createSmartLinkEmbedContent"] = $e1195a14cbc438cf$export$a514f232a71e48c1;
module.exports["createFolderContent"] = $e1195a14cbc438cf$export$3e830820234ed44d;
module.exports["createPageContent"] = $e1195a14cbc438cf$export$715e7bf6a2288b1a;
module.exports["createBlogContent"] = $e1195a14cbc438cf$export$82ee0f89675e8b1a;

});

parcelRegister("hQnHK", function(module, exports) {
const $0037b6bfd6daf741$export$8cda2e6ee87e510b = 'openTemplatePicker';
const $0037b6bfd6daf741$export$2deb4fd8c7cecd6b = 'isNewWhiteboard';
const $0037b6bfd6daf741$export$58465f9d39dce215 = 'insertTemplateWithKey';
const $0037b6bfd6daf741$export$6b4bb9c01a5ea809 = 'headless';
const $0037b6bfd6daf741$export$fe7e318da6d65170 = 'canvas-server';
const $0037b6bfd6daf741$export$f356f97db9b96f17 = 'canvas-relay';
const $0037b6bfd6daf741$export$1cebfc86ac630bb9 = 'whiteboard-frame';
const $0037b6bfd6daf741$export$3078341395c8cb8e = 'whiteboard-locale';
const $0037b6bfd6daf741$export$8103f24eb51911e7 = 'whiteboard-linked-object';
const $0037b6bfd6daf741$export$d7fb875e30263264 = 'initial-theme';
const $0037b6bfd6daf741$export$abce116b94c493f9 = 'bifrost-override';
const $0037b6bfd6daf741$export$d3cf0d39019c8c7f = 'deactivationIdentifier';
const $0037b6bfd6daf741$export$390fc29767c845fc = 'whiteboardPaywallUpsellButton';
const $0037b6bfd6daf741$export$7864364f55e7d48e = 'whiteboardPaywallLearnMoreButton';
const $0037b6bfd6daf741$export$4541324acb17bf12 = 'whiteboardCreationPaywall-';
const $0037b6bfd6daf741$export$c896c362d8b74a87 = 'openJiraImportTool';
const $0037b6bfd6daf741$export$54b9795b714f5c18 = 'autoImportJiraIssues';
const $0037b6bfd6daf741$export$321c00d8e9c04c4f = 'jiraImportJql';
const $0037b6bfd6daf741$export$72b22303fb080064 = 'openMiroImportTool';
const $0037b6bfd6daf741$export$1ef18edc28f65989 = 'openMuralImportTool';
const $0037b6bfd6daf741$export$cbbd90bf5df877bd = 'cloudId';
const $0037b6bfd6daf741$export$2f0c01c772bbe851 = 'projectUuid';
const $0037b6bfd6daf741$export$f045456260cdfa6f = new Date('2024-02-29T00:00Z');
const $0037b6bfd6daf741$export$1c237a39a0b4e9d9 = 'parentProduct';
const $0037b6bfd6daf741$export$2fe42b7bd8ad9641 = 'parentDomain';
const $0037b6bfd6daf741$export$e75d2079ca761674 = 'presentationMode';
const $0037b6bfd6daf741$export$6c706ba208a447e = 'themeState';
const $0037b6bfd6daf741$export$8b639ae03e233763 = 'visualRefresh';
const $0037b6bfd6daf741$export$628c002e5c2252ee = 'createdAt';
const $0037b6bfd6daf741$export$cab138e355452790 = 'focusedCommentId';
const $0037b6bfd6daf741$export$fc53afa4d35a37cf = 'focusedMentionId';
const $0037b6bfd6daf741$export$95e280144fb6ae44 = 'replyToComment';
const $0037b6bfd6daf741$export$4f5dbfe1c54c9e86 = 'version';
const $0037b6bfd6daf741$export$4b9f8234d01d21e9 = 'createdFromSlug';
const $0037b6bfd6daf741$export$8718ad6f6cf65056 = 'debugLayouts';
const $0037b6bfd6daf741$export$326bc0b4b25bc0cb = 'racing';
const $0037b6bfd6daf741$export$148d5c0fade1be8d = 'slides';
const $0037b6bfd6daf741$export$8896acdfcdaf8f6d = 'hideBorder';
const $0037b6bfd6daf741$export$39abeb28b3f870c6 = 'embed';
const $0037b6bfd6daf741$export$f0568a870cb93dbd = 'nativeEmbedView';
module.exports["TEMPLATE_PICKER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8cda2e6ee87e510b;
module.exports["NEW_WHITEBOARD_QUERY_PARAM"] = $0037b6bfd6daf741$export$2deb4fd8c7cecd6b;
module.exports["INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM"] = $0037b6bfd6daf741$export$58465f9d39dce215;
module.exports["HEADLESS_QUERY_PARAM"] = $0037b6bfd6daf741$export$6b4bb9c01a5ea809;
module.exports["SERVER_SPOT_PARAM"] = $0037b6bfd6daf741$export$fe7e318da6d65170;
module.exports["RELAY_SPOT_PARAM"] = $0037b6bfd6daf741$export$f356f97db9b96f17;
module.exports["WHITEBOARD_IFRAME_TITLE"] = $0037b6bfd6daf741$export$1cebfc86ac630bb9;
module.exports["WHITEBOARD_LOCALE"] = $0037b6bfd6daf741$export$3078341395c8cb8e;
module.exports["WHITEBOARD_LINKED_OBJECT"] = $0037b6bfd6daf741$export$8103f24eb51911e7;
module.exports["INITIAL_THEME_PARAM"] = $0037b6bfd6daf741$export$d7fb875e30263264;
module.exports["BIFROST_OVERRIDE_PARAM"] = $0037b6bfd6daf741$export$abce116b94c493f9;
module.exports["PAYWALL_DEACTIVATION_IDENTIFIER"] = $0037b6bfd6daf741$export$d3cf0d39019c8c7f;
module.exports["WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$390fc29767c845fc;
module.exports["WHITEBOARD_PAYWALL_INFO_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$7864364f55e7d48e;
module.exports["WHITEBOARD_CREATION_PAYWALL_SOURCE_PREFIX"] = $0037b6bfd6daf741$export$4541324acb17bf12;
module.exports["JIRA_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$c896c362d8b74a87;
module.exports["AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM"] = $0037b6bfd6daf741$export$54b9795b714f5c18;
module.exports["JIRA_IMPORT_JQL"] = $0037b6bfd6daf741$export$321c00d8e9c04c4f;
module.exports["MIRO_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$72b22303fb080064;
module.exports["MURAL_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$1ef18edc28f65989;
module.exports["CLOUD_ID"] = $0037b6bfd6daf741$export$cbbd90bf5df877bd;
module.exports["PROJECT_UUID"] = $0037b6bfd6daf741$export$2f0c01c772bbe851;
module.exports["PARENT_PRODUCT_QUERY_PARAM"] = $0037b6bfd6daf741$export$1c237a39a0b4e9d9;
module.exports["PARENT_DOMAIN_QUERY_PARAM"] = $0037b6bfd6daf741$export$2fe42b7bd8ad9641;
module.exports["PRESENTATION_MODE_QUERY_PARAM"] = $0037b6bfd6daf741$export$e75d2079ca761674;
module.exports["EMBEDDED_THEME_STATE"] = $0037b6bfd6daf741$export$6c706ba208a447e;
module.exports["VISUAL_REFRESH_PARAM"] = $0037b6bfd6daf741$export$8b639ae03e233763;
module.exports["EMBEDDED_WHITEBOARD_CREATED_AT_QUERY_PARAM"] = $0037b6bfd6daf741$export$628c002e5c2252ee;
module.exports["FOCUSED_COMMENT_ID"] = $0037b6bfd6daf741$export$cab138e355452790;
module.exports["FOCUSED_MENTION_ID"] = $0037b6bfd6daf741$export$fc53afa4d35a37cf;
module.exports["REPLY_TO_COMMENT"] = $0037b6bfd6daf741$export$95e280144fb6ae44;
module.exports["WHITEBOARD_VERSION_ID"] = $0037b6bfd6daf741$export$4f5dbfe1c54c9e86;
module.exports["CREATED_FROM_SLUG"] = $0037b6bfd6daf741$export$4b9f8234d01d21e9;
module.exports["DEBUG_LAYOUTS_QUERY_PARAM"] = $0037b6bfd6daf741$export$8718ad6f6cf65056;
module.exports["RACING_QUERY_PARAM"] = $0037b6bfd6daf741$export$326bc0b4b25bc0cb;
module.exports["SLIDES_QUERY_PARAM"] = $0037b6bfd6daf741$export$148d5c0fade1be8d;
module.exports["HIDE_BORDER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8896acdfcdaf8f6d;
module.exports["EMBED_QUERY_PARAM"] = $0037b6bfd6daf741$export$39abeb28b3f870c6;
module.exports["NATIVE_EMBED_VIEW_QUERY_PARAM"] = $0037b6bfd6daf741$export$f0568a870cb93dbd;

});

parcelRegister("ayS0g", function(module, exports) {
$parcel$export(module.exports, "PERMISSIONS_INFO_BANNER_QUERY_PARAM_KEY", () => (parcelRequire("5y1g5")).PERMISSIONS_INFO_BANNER_QUERY_PARAM_KEY);
$parcel$export(module.exports, "IS_NEW_EMBED_QUERY_PARAM_KEY", () => (parcelRequire("5y1g5")).IS_NEW_EMBED_QUERY_PARAM_KEY);
$parcel$export(module.exports, "DotGridBackground", () => (parcelRequire("fnyki")).DotGridBackground);
$parcel$export(module.exports, "normalizeAndValidateUrl", () => (parcelRequire("aVk5V")).normalizeAndValidateUrl);
$parcel$export(module.exports, "fetchDataFromORS", () => (parcelRequire("laZ2J")).fetchDataFromORS);
$parcel$export(module.exports, "useFetchDataFromORS", () => (parcelRequire("laZ2J")).useFetchDataFromORS);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $5y1g5 = parcelRequire("5y1g5");


var $fnyki = parcelRequire("fnyki");


var $l01bG = parcelRequire("l01bG");


var $9QoCS = parcelRequire("9QoCS");


var $aVk5V = parcelRequire("aVk5V");


var $laZ2J = parcelRequire("laZ2J");


var $eaBPu = parcelRequire("eaBPu");


});

parcelRegister("5y1g5", function(module, exports) {
const $a7a321c00b90eef4$export$387a295dc04f5f90 = 'showPermissionsBanner';
const $a7a321c00b90eef4$export$3738b9a85a6948a6 = 'isNewBlankEmbed';
module.exports["PERMISSIONS_INFO_BANNER_QUERY_PARAM_KEY"] = $a7a321c00b90eef4$export$387a295dc04f5f90;
module.exports["IS_NEW_EMBED_QUERY_PARAM_KEY"] = $a7a321c00b90eef4$export$3738b9a85a6948a6;

});

parcelRegister("fnyki", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kA6Zo = parcelRequire("kA6Zo");


var $buxP3 = parcelRequire("buxP3");

const $f37f7bd9b125a5e3$var$fullHeightContainer = (0, $buxP3.xcss)({
    height: 'calc(100vh - var(--bannerHeight, 0px) - var(--topNavigationHeight, 0px))'
});
const $f37f7bd9b125a5e3$var$dotGridBackground = (0, $buxP3.xcss)({
    backgroundImage: `radial-gradient(circle at 2px 2px, ${"var(--ds-surface-overlay-hovered, #F0F1F2)"} 2px, transparent 0)`,
    backgroundSize: '20px 20px'
});
const $f37f7bd9b125a5e3$export$b520b551d14c6a6e = ({ showDottedBackground: showDottedBackground, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        direction: "column",
        xcss: [
            $f37f7bd9b125a5e3$var$fullHeightContainer,
            showDottedBackground && $f37f7bd9b125a5e3$var$dotGridBackground
        ]
    }, children);
};
module.exports["DotGridBackground"] = $f37f7bd9b125a5e3$export$b520b551d14c6a6e;

});

parcelRegister("l01bG", function(module, exports) {

var $jawC3 = parcelRequire("jawC3");

const $f493076f7b61f977$export$b8af48de83cf2008 = (url)=>{
    const httpPattern = /^https?:\/\/[^\s]*$/im;
    return httpPattern.test(url);
};
const $f493076f7b61f977$export$285f8e8582d94002 = (data)=>{
    /*
	 * data.generator.icon.url is where provider icon is and
	 * data.icon.url is where the link icon usually is. In most cases,
	 * they are the same thing but some providers have specific icons
	 * for specific links. For example, a Google Sheet link from
	 * google-object-provider would return Google Drive icon as a provider
	 * icon (data.generator.icon.url) but would return Google Sheets icon
	 * as link icon (data.icon.url).
	 */ const generatorIconObj = data.generator?.icon;
    const iconObj = data.icon;
    const generatorIcon = generatorIconObj && (0, $jawC3.extractUrlFromIconJsonLd)(generatorIconObj) || '';
    const icon = iconObj && (0, $jawC3.extractUrlFromIconJsonLd)(iconObj) || '';
    // TEMP: calling isValidScheme here is a workaround to
    // ensure data URIs for favicons don't make it through
    // (BE fails as it expects a http(s) scheme). Long term,
    // we should support inlined data URI favicons.
    // https://hello.jira.atlassian.cloud/browse/CTIA-1918
    return $f493076f7b61f977$export$b8af48de83cf2008(icon) && icon || $f493076f7b61f977$export$b8af48de83cf2008(generatorIcon) && generatorIcon || '';
};
module.exports["extractIconUrl"] = $f493076f7b61f977$export$285f8e8582d94002;

});

parcelRegister("9QoCS", function(module, exports) {

var $jawC3 = parcelRequire("jawC3");

// Gets a more specific product for the URL if we know that a provider can cover
// multiple products
const $9b10c9a9aeeff07b$var$getSpecificProduct = (hostname, providerName)=>{
    if (providerName === 'OneDrive' && hostname.includes('sharepoint')) return 'SharePoint';
    else return providerName;
};
const $9b10c9a9aeeff07b$export$a6859be1cfc01481 = (embedUrl, data)=>{
    const url = new URL(embedUrl);
    const urlHostname = url.hostname;
    // we want to remove the "www." at the beginning of the URL if it exists
    // so that the analytics are receiving domains in a consistent format
    const parsedHostname = urlHostname.replace(/^www\./, '');
    if (!data) return parsedHostname;
    const provider = (0, $jawC3.extractProvider)(data);
    const providerName = provider?.text;
    const embedProduct = $9b10c9a9aeeff07b$var$getSpecificProduct(urlHostname, providerName);
    const providerIsHostname = embedProduct !== undefined && embedProduct.includes(parsedHostname);
    // ORS will sometimes return the urlHostname as the provider so use
    // the parsedHostname is there is no providerName or if the provider
    // contains the hostname
    if (!embedProduct || providerIsHostname) return parsedHostname;
    return embedProduct;
};
module.exports["extractProduct"] = $9b10c9a9aeeff07b$export$a6859be1cfc01481;

});

parcelRegister("aVk5V", function(module, exports) {

var $1F2YI = parcelRequire("1F2YI");

// regex to check that the url entered is at least of this format "://example.com"
const $9509ca2c76fbd4db$var$REGEX = /:\/\/(.*\.)?.+\..+/;
const $9509ca2c76fbd4db$export$53289a1e3dd02563 = (url)=>{
    const normalizedUrl = (0, $1F2YI.normalizeUrl)(url.trim());
    // `isSafeUrl()` treats a string with just the protocol (e.g. "http://") as a valid url so we need additional check
    const isValid = !!normalizedUrl && (0, $1F2YI.isSafeUrl)(normalizedUrl) && $9509ca2c76fbd4db$var$REGEX.test(normalizedUrl);
    return isValid ? normalizedUrl : null;
};
module.exports["normalizeAndValidateUrl"] = $9509ca2c76fbd4db$export$53289a1e3dd02563;

});

parcelRegister("laZ2J", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cMyWi = parcelRequire("cMyWi");


var $jawC3 = parcelRequire("jawC3");


var $9DHhW = parcelRequire("9DHhW");


var $l01bG = parcelRequire("l01bG");


var $aUoHg = parcelRequire("aUoHg");


var $eaBPu = parcelRequire("eaBPu");

const $07e4518f8509fec5$var$extractEmbedData = ({ createAnalyticsEvent: createAnalyticsEvent, data: data, embedUrl: embedUrl })=>{
    return {
        iconURL: data ? (0, $l01bG.extractIconUrl)(data) : undefined,
        product: (0, $eaBPu.extractEmbedProduct)({
            createAnalyticsEvent: createAnalyticsEvent,
            embedUrl: embedUrl,
            data: data
        }),
        title: data ? (0, $jawC3.extractTitle)(data) : undefined,
        url: data ? (0, $jawC3.extractLink)(data) : undefined
    };
};
const $07e4518f8509fec5$export$7053598ec03d6366 = async ({ cardClient: cardClient, createAnalyticsEvent: createAnalyticsEvent, embedUrl: embedUrl, includeAuthHandling: includeAuthHandling })=>{
    try {
        const details = await cardClient.fetchData(embedUrl);
        let data = details && details.data;
        let meta = details && details.meta;
        if (includeAuthHandling) {
            const authURL = meta.auth?.[0]?.url;
            if (meta.access === 'unauthorized' && authURL) {
                try {
                    await (0, $aUoHg.handleEmbedAuthentication)({
                        authURL: authURL
                    });
                } catch (error) {
                    createAnalyticsEvent({
                        type: 'sendOperationalEvent',
                        data: {
                            action: 'failed',
                            actionSubject: 'outboundAuthFlow',
                            source: 'smartLinkEmbedAuthentication',
                            attributes: {
                                error: error.type || 'unknown',
                                extensionKey: meta?.key ?? null,
                                destinationObjectType: meta?.resourceType ?? null,
                                contentType: 'embed'
                            },
                            nonPrivacySafeAttributes: {
                                linkDomain: (0, $eaBPu.extractEmbedProduct)({
                                    createAnalyticsEvent: createAnalyticsEvent,
                                    data: data,
                                    embedUrl: embedUrl
                                })
                            }
                        }
                    }).fire();
                    return {
                        data: data,
                        meta: meta,
                        parsedEmbedData: $07e4518f8509fec5$var$extractEmbedData({
                            createAnalyticsEvent: createAnalyticsEvent,
                            data: data,
                            embedUrl: embedUrl
                        }),
                        error: null
                    };
                }
                // We have successfully authenticated with the URL, so lets refetch to get all the
                // proper data.
                const refetchedDetails = await cardClient.fetchData(embedUrl);
                meta = refetchedDetails && refetchedDetails.meta;
                if (refetchedDetails && refetchedDetails.data) data = refetchedDetails.data;
            }
        }
        return {
            data: data,
            meta: meta,
            parsedEmbedData: $07e4518f8509fec5$var$extractEmbedData({
                createAnalyticsEvent: createAnalyticsEvent,
                data: data,
                embedUrl: embedUrl
            }),
            error: null
        };
    } catch (error) {
        return {
            data: undefined,
            meta: undefined,
            parsedEmbedData: $07e4518f8509fec5$var$extractEmbedData({
                createAnalyticsEvent: createAnalyticsEvent,
                data: undefined,
                embedUrl: embedUrl
            }),
            error: error
        };
    }
};
const $07e4518f8509fec5$export$22fdc6a4626c032 = ()=>{
    const { connections: connections } = (0, $cMyWi.useSmartLinkContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fetchEmbedData = (0, $cozmU.useCallback)(async ({ embedUrl: embedUrl, includeAuthHandling: includeAuthHandling })=>{
        return $07e4518f8509fec5$export$7053598ec03d6366({
            cardClient: connections.client,
            createAnalyticsEvent: createAnalyticsEvent,
            embedUrl: embedUrl,
            includeAuthHandling: includeAuthHandling
        });
    }, [
        connections.client,
        createAnalyticsEvent
    ]);
    return {
        fetchEmbedData: fetchEmbedData
    };
};
module.exports["fetchDataFromORS"] = $07e4518f8509fec5$export$7053598ec03d6366;
module.exports["useFetchDataFromORS"] = $07e4518f8509fec5$export$22fdc6a4626c032;

});

parcelRegister("aUoHg", function(module, exports) {
parcelRequire("kMzDv");
var $eEPSE = parcelRequire("eEPSE");

const $1d0cc37ef4affcea$export$2b381fecab5b3691 = async ({ authURL: authURL })=>{
    const POPUP_HEIGHT = 600;
    const POPUP_WIDTH = 720;
    const BROWSER_SIZE_THRESHOLD = 48;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    // Center the popup window
    const left = (vw - POPUP_WIDTH) / 2;
    const top = (vh - POPUP_HEIGHT) / 2;
    // Open a popup if there's enough space in the viewport
    // Otherwise, fall back to the default behavior (opening in a new tab)
    const windowFeatures = vw > POPUP_WIDTH + BROWSER_SIZE_THRESHOLD && vh > POPUP_HEIGHT + BROWSER_SIZE_THRESHOLD ? `width=${POPUP_WIDTH},height=${POPUP_HEIGHT}},left=${left},top=${top}` : undefined;
    await (0, $eEPSE.auth)(authURL, windowFeatures);
};
module.exports["handleEmbedAuthentication"] = $1d0cc37ef4affcea$export$2b381fecab5b3691;

});

parcelRegister("kMzDv", function(module, exports) {
$parcel$export(module.exports, "auth", () => (parcelRequire("eEPSE")).auth);
$parcel$export(module.exports, "AuthError", () => (parcelRequire("7zxJs")).AuthError);

var $eEPSE = parcelRequire("eEPSE");


var $7zxJs = parcelRequire("7zxJs");


});

parcelRegister("eEPSE", function(module, exports) {

var $7zxJs = parcelRequire("7zxJs");


var $75u2V = parcelRequire("75u2V");

function $4e31e5414e67a93e$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $75u2V.isOfTypeAuthError)(errorType)) reject(new (0, $7zxJs.AuthError)(data.message, errorType));
                    else reject(new (0, $7zxJs.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $7zxJs.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}
module.exports["auth"] = $4e31e5414e67a93e$export$73693bad9f5880b0;

});

parcelRegister("7zxJs", function(module, exports) {
class $dd3fe40c981b3bd9$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message), this.message = message, this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}
module.exports["AuthError"] = $dd3fe40c981b3bd9$export$145273558d58e0ac;

});

parcelRegister("75u2V", function(module, exports) {
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $6f56de9d96dc4f7f$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};
module.exports["isOfTypeAuthError"] = $6f56de9d96dc4f7f$export$400e64c8451aa84f;

});

parcelRegister("eaBPu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $9QoCS = parcelRequire("9QoCS");

const $86c9e03e9bf37880$export$c6a11f4b62c81749 = ({ createAnalyticsEvent: createAnalyticsEvent, data: data, embedUrl: embedUrl })=>{
    try {
        return (0, $9QoCS.extractProduct)(embedUrl, data || undefined);
    } catch (error) {
        createAnalyticsEvent?.({
            type: 'sendOperationalEvent',
            data: {
                action: 'failed',
                actionSubject: 'embedProductExtraction',
                source: 'smartLinkEmbedProductExtraction',
                attributes: {
                    contentType: 'embed'
                }
            }
        }).fire();
        return null;
    }
};
const $86c9e03e9bf37880$export$fe632efa34893174 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const _extractEmbedProduct = (0, $cozmU.useCallback)(({ data: data, embedUrl: embedUrl })=>{
        return $86c9e03e9bf37880$export$c6a11f4b62c81749({
            createAnalyticsEvent: createAnalyticsEvent,
            data: data,
            embedUrl: embedUrl
        });
    }, [
        createAnalyticsEvent
    ]);
    return {
        extractEmbedProduct: _extractEmbedProduct
    };
};
module.exports["extractEmbedProduct"] = $86c9e03e9bf37880$export$c6a11f4b62c81749;

});

parcelRegister("jqe2L", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $jiJCD = parcelRequire("jiJCD");


var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");


var $9wGTI = parcelRequire("9wGTI");

const $350735cb5bb3c1ba$var$isCreateBlankPageInFabricEnabled = ()=>{
    return (0, $9wGTI.fg)('confluence_frontend_fabric_editor_blank_page') || (0, $9wGTI.fg)('confluence_frontend_fabric_editor_all_pages');
};
const $350735cb5bb3c1ba$export$9d03777b293b05ce = ()=>{
    return $350735cb5bb3c1ba$var$isCreateBlankPageInFabricEnabled();
};
const $350735cb5bb3c1ba$export$c8780cd30055dcb8 = (parentPageResponse, creationSpaceKey)=>{
    // parent page is in the selected space
    const spaceKey = parentPageResponse?.content?.nodes?.[0]?.space?.key;
    if (spaceKey !== creationSpaceKey) return false;
    // ancestors must be of the same content Type
    const contentType = parentPageResponse?.content?.nodes?.[0]?.type;
    if (contentType !== 'page') return false;
    // parent page must not be archived
    const status = parentPageResponse?.content?.nodes?.[0]?.status;
    if (status === 'archived') return false;
    // must have create access under the parent page
    const operations = parentPageResponse?.content?.nodes?.[0]?.operations;
    const hasCreateOperation = operations && operations.find((op)=>op?.targetType === 'page' && op.operation === 'create');
    return !!hasCreateOperation;
};
const $350735cb5bb3c1ba$export$4c6171230e6eef02 = (overrideValue, defaultValue)=>{
    return {
        value: overrideValue || defaultValue,
        usedOverride: !!overrideValue
    };
};
const $350735cb5bb3c1ba$export$a0b32aef6b0d7373 = (urlToChange, params, updateEditorMode)=>{
    updateEditorMode?.('create-page');
    const urlComponents = (0, $jiJCD.parse)(urlToChange, true);
    return (0, $jiJCD.format)({
        ...urlComponents,
        // remove `search`, otherwise
        // `query` will be ignored
        search: undefined,
        query: {
            ...urlComponents.query,
            ...params
        }
    });
};
const $350735cb5bb3c1ba$export$f59f47d22cf7d84d = (url)=>{
    if (!url) throw new Error('No url for new content');
    if (url.startsWith((0, $jlIaF.CONTEXT_PATH))) return url;
    return `${0, $jlIaF.CONTEXT_PATH}${url}`;
};
const $350735cb5bb3c1ba$export$cca9db3da8f2e4f8 = ({ spaceKey: spaceKey, contentId: contentId, url: url, type: type = 'page' })=>{
    const legacyDraftRouteMatch = (0, $1NBp8.RESUME_DRAFT_LEGACY).match(url);
    const draftShareId = legacyDraftRouteMatch?.query?.draftShareId || '';
    const editV2Url = type === 'blogpost' ? (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        contentType: 'blog',
        spaceKey: spaceKey,
        contentId: contentId
    }, {
        query: {
            draftShareId: draftShareId
        }
    }) : (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        contentType: 'pages',
        spaceKey: spaceKey,
        contentId: contentId
    }, {
        query: {
            draftShareId: draftShareId
        }
    });
    return $350735cb5bb3c1ba$export$f59f47d22cf7d84d(editV2Url);
};
const $350735cb5bb3c1ba$export$b47a1345d675bf12 = (error, messageMatches)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some(({ message: message })=>messageMatches.some((messageMatch)=>message.includes(messageMatch)));
    return false;
};
module.exports["isCreateBlankFabricPageEnabled"] = $350735cb5bb3c1ba$export$9d03777b293b05ce;
module.exports["appendQueryParams"] = $350735cb5bb3c1ba$export$a0b32aef6b0d7373;
module.exports["processDraftUrl"] = $350735cb5bb3c1ba$export$f59f47d22cf7d84d;
module.exports["getEditPageUrl"] = $350735cb5bb3c1ba$export$cca9db3da8f2e4f8;
module.exports["graphqlErrorHasMessage"] = $350735cb5bb3c1ba$export$b47a1345d675bf12;

});

parcelRegister("1yME3", function(module, exports) {

var $iMzrp = parcelRequire("iMzrp");

const $046beff7efc875dc$export$a65aa4a12188edb1 = (0, $iMzrp.default);
module.exports["CreateContentMutation"] = $046beff7efc875dc$export$a65aa4a12188edb1;

});

parcelRegister("iMzrp", function(module, exports) {
/**
 * @generated SignedSource<<958af5ccbbf239e235c834efc18547dc>>
 * @relayHash e33ffe6be783218f5cfc2bcdf60c2bd4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a4d71e9d10553df176b5de5e5f79502b970da53471ef25f517d1d3342af03f24
const $8386a27251608882$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentSpecificCreateInput"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "parentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "subType"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "title"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "type"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentSpecificCreateInput",
                            "variableName": "contentSpecificCreateInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "parentId",
                            "variableName": "parentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "status",
                            "variableName": "status"
                        },
                        {
                            "kind": "Variable",
                            "name": "subType",
                            "variableName": "subType"
                        },
                        {
                            "kind": "Variable",
                            "name": "title",
                            "variableName": "title"
                        },
                        {
                            "kind": "Variable",
                            "name": "type",
                            "variableName": "type"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "createContentContextual",
            "plural": false,
            "selections": [
                v7 /*: any*/ ,
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        }
                    ]
                },
                {
                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "context"
                        }
                    ]
                },
                {
                    "concreteType": "ContentMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                            "kind": "LinkedField",
                            "name": "frontend",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "collabService"
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "subType"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CreateContentMutation",
            "selections": v8 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CreateContentMutation",
            "selections": v8 /*: any*/ 
        },
        "params": {
            "cacheID": "e33ffe6be783218f5cfc2bcdf60c2bd4",
            "id": "a4d71e9d10553df176b5de5e5f79502b970da53471ef25f517d1d3342af03f24",
            "metadata": {},
            "name": "CreateContentMutation",
            "operationKind": "mutation",
            "text": "mutation CreateContentMutation($subType:ConfluencePageSubType,$spaceKey:String!,$parentId:ID,$title:String,$status:GraphQLContentStatus!,$contentSpecificCreateInput:[ContentSpecificCreateInput!],$type:String!){createContentContextual(input:{spaceKey:$spaceKey,parentId:$parentId,status:$status,type:$type,subType:$subType,title:$title,contentSpecificCreateInput:$contentSpecificCreateInput}){id,space{id,alias,key},links{editui,context},metadata{frontend{collabService}},subType}}"
        }
    };
}();
$8386a27251608882$var$node.hash = "1b1fef8d6670f5c0a944347d37faef55";
var $8386a27251608882$export$2e2bcd8739ae039 = $8386a27251608882$var$node;
module.exports["default"] = $8386a27251608882$export$2e2bcd8739ae039;

});

parcelRegister("jSIHW", function(module, exports) {

var $hAbb8 = parcelRequire("hAbb8");

const $c512c174205999eb$export$c38d501b92148141 = (0, $hAbb8.default);
module.exports["CreateWhiteboardMutation"] = $c512c174205999eb$export$c38d501b92148141;

});

parcelRegister("hAbb8", function(module, exports) {
/**
 * @generated SignedSource<<9223e6d261a4908e34eedb8356396454>>
 * @relayHash b7c794d725ced4845d1bb9a59073c524
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2005579a94ce4be7573532442ba5ad55205f8ec6475e96e2ea73ef75a1d94071
const $388b2212ff4a70b2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentSpecificCreateInput"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "parentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "title"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentSpecificCreateInput",
                            "variableName": "contentSpecificCreateInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "parentId",
                            "variableName": "parentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        },
                        {
                            "kind": "Literal",
                            "name": "status",
                            "value": "CURRENT"
                        },
                        {
                            "kind": "Variable",
                            "name": "title",
                            "variableName": "title"
                        },
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "whiteboard"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "createContentContextual",
            "plural": false,
            "selections": [
                v4 /*: any*/ ,
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CreateWhiteboardMutation",
            "selections": v5 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CreateWhiteboardMutation",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "b7c794d725ced4845d1bb9a59073c524",
            "id": "2005579a94ce4be7573532442ba5ad55205f8ec6475e96e2ea73ef75a1d94071",
            "metadata": {},
            "name": "CreateWhiteboardMutation",
            "operationKind": "mutation",
            "text": "mutation CreateWhiteboardMutation($spaceKey:String!,$parentId:ID,$contentSpecificCreateInput:[ContentSpecificCreateInput!],$title:String){createContentContextual(input:{spaceKey:$spaceKey,parentId:$parentId,contentSpecificCreateInput:$contentSpecificCreateInput,status:CURRENT,type:\"whiteboard\",title:$title}){id,space{id,key,alias}}}"
        }
    };
}();
$388b2212ff4a70b2$var$node.hash = "e930261bfff63c39536ae377f7405d1c";
var $388b2212ff4a70b2$export$2e2bcd8739ae039 = $388b2212ff4a70b2$var$node;
module.exports["default"] = $388b2212ff4a70b2$export$2e2bcd8739ae039;

});

parcelRegister("6jFZl", function(module, exports) {

var $e0gw3 = parcelRequire("e0gw3");

const $29119e35f4ff5b90$export$d4de9ea7d8369445 = (0, $e0gw3.default);
module.exports["CreateDatabaseMutation"] = $29119e35f4ff5b90$export$d4de9ea7d8369445;

});

parcelRegister("e0gw3", function(module, exports) {
/**
 * @generated SignedSource<<1974e428bce57816dbc5eecbfef855b6>>
 * @relayHash 44d33734a57fe8c7f7a99327ed1b3bb6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8e7cb5c5d4b068992bf4e3a9165ddeb4b80a8a2a7069f0d32e866e7c37c7206e
const $bf029c866a37e3cc$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "parentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "parentId",
                            "variableName": "parentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        },
                        {
                            "kind": "Literal",
                            "name": "status",
                            "value": "CURRENT"
                        },
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "database"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "createContentContextual",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CreateDatabaseMutation",
            "selections": v3 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CreateDatabaseMutation",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "44d33734a57fe8c7f7a99327ed1b3bb6",
            "id": "8e7cb5c5d4b068992bf4e3a9165ddeb4b80a8a2a7069f0d32e866e7c37c7206e",
            "metadata": {},
            "name": "CreateDatabaseMutation",
            "operationKind": "mutation",
            "text": "mutation CreateDatabaseMutation($spaceKey:String!,$parentId:ID){createContentContextual(input:{parentId:$parentId,spaceKey:$spaceKey,status:CURRENT,type:\"database\"}){id,space{id,key,alias}}}"
        }
    };
}();
$bf029c866a37e3cc$var$node.hash = "73166918266ac70a8951e44091e9370f";
var $bf029c866a37e3cc$export$2e2bcd8739ae039 = $bf029c866a37e3cc$var$node;
module.exports["default"] = $bf029c866a37e3cc$export$2e2bcd8739ae039;

});

parcelRegister("460Q4", function(module, exports) {

var $1h5n1 = parcelRequire("1h5n1");

const $8568ce27a8746db6$export$d09493f3e16a9c6d = (0, $1h5n1.default);
module.exports["CreateSmartLinkEmbedMutation"] = $8568ce27a8746db6$export$d09493f3e16a9c6d;

});

parcelRegister("1h5n1", function(module, exports) {
/**
 * @generated SignedSource<<11f1293793c081a54679c5f133455032>>
 * @relayHash 21e9e53b2348b2584c57975e0a8089b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 144480b55dc7e0d1d2ae38d1081acaf41287b703093144186663da48f81c8f0c
const $9a1c787417a2f79b$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentSpecificCreateInput"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "parentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "title"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "type"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentSpecificCreateInput",
                            "variableName": "contentSpecificCreateInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "parentId",
                            "variableName": "parentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "status",
                            "variableName": "status"
                        },
                        {
                            "kind": "Variable",
                            "name": "title",
                            "variableName": "title"
                        },
                        {
                            "kind": "Variable",
                            "name": "type",
                            "variableName": "type"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "createContentContextual",
            "plural": false,
            "selections": [
                v6 /*: any*/ ,
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CreateSmartLinkEmbedMutation",
            "selections": v7 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CreateSmartLinkEmbedMutation",
            "selections": v7 /*: any*/ 
        },
        "params": {
            "cacheID": "21e9e53b2348b2584c57975e0a8089b1",
            "id": "144480b55dc7e0d1d2ae38d1081acaf41287b703093144186663da48f81c8f0c",
            "metadata": {},
            "name": "CreateSmartLinkEmbedMutation",
            "operationKind": "mutation",
            "text": "mutation CreateSmartLinkEmbedMutation($contentSpecificCreateInput:[ContentSpecificCreateInput!],$parentId:ID,$spaceKey:String,$title:String,$type:String!,$status:GraphQLContentStatus!){createContentContextual(input:{contentSpecificCreateInput:$contentSpecificCreateInput,parentId:$parentId,spaceKey:$spaceKey,title:$title,type:$type,status:$status}){id,space{id,key,alias}}}"
        }
    };
}();
$9a1c787417a2f79b$var$node.hash = "5eab7a8e9a9ef38299fc481acc494cd9";
var $9a1c787417a2f79b$export$2e2bcd8739ae039 = $9a1c787417a2f79b$var$node;
module.exports["default"] = $9a1c787417a2f79b$export$2e2bcd8739ae039;

});

parcelRegister("rmocb", function(module, exports) {

var $4KM9t = parcelRequire("4KM9t");

const $6a0daa54a010453b$export$a7615bda3487c658 = (0, $4KM9t.default);
module.exports["CreateFolderMutation"] = $6a0daa54a010453b$export$a7615bda3487c658;

});

parcelRegister("4KM9t", function(module, exports) {
/**
 * @generated SignedSource<<bcc4bf9c81f201532479648553047242>>
 * @relayHash 9d445e2657f9945895b2072fb08d4bf6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bf72d8ced51af8a9f0328598749df823c690f570e58079f2ddd0aea69e6f5869
const $4cd27bb6f16c3f50$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "parentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "type"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "parentId",
                            "variableName": "parentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "status",
                            "variableName": "status"
                        },
                        {
                            "kind": "Variable",
                            "name": "type",
                            "variableName": "type"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "createContentContextual",
            "plural": false,
            "selections": [
                v4 /*: any*/ ,
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CreateFolderMutation",
            "selections": v5 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CreateFolderMutation",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "9d445e2657f9945895b2072fb08d4bf6",
            "id": "bf72d8ced51af8a9f0328598749df823c690f570e58079f2ddd0aea69e6f5869",
            "metadata": {},
            "name": "CreateFolderMutation",
            "operationKind": "mutation",
            "text": "mutation CreateFolderMutation($parentId:ID,$spaceKey:String,$type:String!,$status:GraphQLContentStatus!){createContentContextual(input:{parentId:$parentId,spaceKey:$spaceKey,type:$type,status:$status}){id,space{id,key,alias}}}"
        }
    };
}();
$4cd27bb6f16c3f50$var$node.hash = "054e3d1c47dd9ab5ce172441f711e827";
var $4cd27bb6f16c3f50$export$2e2bcd8739ae039 = $4cd27bb6f16c3f50$var$node;
module.exports["default"] = $4cd27bb6f16c3f50$export$2e2bcd8739ae039;

});

parcelRegister("dkIiA", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $ee5b1a976329bd8a$export$c5ec0cc4d455d1c8 = /*#__PURE__*/ function(ConfluencePageSubType) {
    ConfluencePageSubType["LIVE"] = "LIVE";
    return ConfluencePageSubType;
}({});
var $ee5b1a976329bd8a$export$b634e5de755b7d35 = /*#__PURE__*/ function(GraphQLContentStatus) {
    GraphQLContentStatus["ARCHIVED"] = "ARCHIVED";
    GraphQLContentStatus["CURRENT"] = "CURRENT";
    GraphQLContentStatus["DELETED"] = "DELETED";
    GraphQLContentStatus["DRAFT"] = "DRAFT";
    return GraphQLContentStatus;
}({});
module.exports["ConfluencePageSubType"] = $ee5b1a976329bd8a$export$c5ec0cc4d455d1c8;
module.exports["GraphQLContentStatus"] = $ee5b1a976329bd8a$export$b634e5de755b7d35;

});

parcelRegister("kjahF", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $259859bb7693671c$export$b634e5de755b7d35 = /*#__PURE__*/ function(GraphQLContentStatus) {
    GraphQLContentStatus["ARCHIVED"] = "ARCHIVED";
    GraphQLContentStatus["CURRENT"] = "CURRENT";
    GraphQLContentStatus["DELETED"] = "DELETED";
    GraphQLContentStatus["DRAFT"] = "DRAFT";
    return GraphQLContentStatus;
}({});
module.exports["GraphQLContentStatus"] = $259859bb7693671c$export$b634e5de755b7d35;

});

parcelRegister("dncjA", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

var $42d2cbe129156e29$export$a35ea3343c58b478 = /*#__PURE__*/ function(OutboundPageTreeMessage) {
    OutboundPageTreeMessage[OutboundPageTreeMessage["ContentUpdated"] = 0] = "ContentUpdated";
    return OutboundPageTreeMessage;
}({});
class $42d2cbe129156e29$var$OutboundPageTreeMessageBus {
    publish(type, data) {
        if (!this.subscribers[type]) return;
        this.subscribers[type].forEach((subscriber)=>subscriber(data));
    }
    subscribe(type, callback) {
        if (!this.subscribers[type]) this.subscribers[type] = [];
        this.subscribers[type].push(callback);
    }
    unsubscribe(type, callback) {
        if (!this.subscribers[type]) return;
        this.subscribers[type] = this.subscribers[type].filter((subscriber)=>subscriber !== callback);
    }
    constructor(){
        this.subscribers = {};
    }
}
const $42d2cbe129156e29$var$outboundPageTreeBus = new $42d2cbe129156e29$var$OutboundPageTreeMessageBus();
const $42d2cbe129156e29$export$6aa2f5cad92d6f47 = (type)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== type) {
        t0 = (data)=>{
            $42d2cbe129156e29$var$outboundPageTreeBus.publish(type, data);
        };
        $[0] = type;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $42d2cbe129156e29$export$4a84af3f2bf2e18a = (type, callback)=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    let t1;
    if ($[0] !== callback || $[1] !== type) {
        t0 = ()=>{
            $42d2cbe129156e29$var$outboundPageTreeBus.subscribe(type, callback);
            return ()=>{
                $42d2cbe129156e29$var$outboundPageTreeBus.unsubscribe(type, callback);
            };
        };
        t1 = [
            callback,
            type
        ];
        $[0] = callback;
        $[1] = type;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
};
module.exports["OutboundPageTreeMessage"] = $42d2cbe129156e29$export$a35ea3343c58b478;
module.exports["useOutboundPageTreeUpdatePublisher"] = $42d2cbe129156e29$export$6aa2f5cad92d6f47;
module.exports["useOutboundPageTreeUpdateSubscriber"] = $42d2cbe129156e29$export$4a84af3f2bf2e18a;

});

parcelRegister("6IQoR", function(module, exports) {
const $735c346be3f362a2$var$GENERIC_FAILURE_MESSAGE = "We couldn't duplicate this component. Please try again.";
const $735c346be3f362a2$var$MISSING_ID_MESSAGE = "We couldn't duplicate this component. The server did not return a new component ID.";
async function $735c346be3f362a2$var$sendDuplicateRequest(url, body) {
    const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        },
        body: body
    });
    if (!response.ok) {
        let errorBody;
        try {
            errorBody = await response.json();
        } catch  {
            errorBody = undefined;
        }
        const fallbackMessage = response.status === 403 ? 'You do not have permission to duplicate this component.' : $735c346be3f362a2$var$GENERIC_FAILURE_MESSAGE;
        const error = new Error(errorBody?.error?.message || fallbackMessage);
        error.code = errorBody?.error?.code;
        error.status = response.status;
        error.statusCode = response.status;
        throw error;
    }
    const data = await response.json().catch(()=>undefined);
    if (!data?.id) {
        const error = new Error($735c346be3f362a2$var$MISSING_ID_MESSAGE);
        error.statusCode = response.status;
        throw error;
    }
    return {
        id: data.id,
        statusCode: response.status
    };
}
async function $735c346be3f362a2$export$2cee355049cb72e4(appId, options) {
    let containerAri;
    if ('containerAri' in options) containerAri = options.containerAri;
    else {
        const ariContentType = options.contentType === 'blogpost' ? 'blogpost' : 'page';
        containerAri = options.cloudId ? `ari:cloud:confluence:${options.cloudId}:${ariContentType}/${options.containerContentId}` : options.containerContentId;
    }
    const url = `/gateway/api/remix/api/v1/ui/${encodeURIComponent(appId)}/duplicate`;
    const body = JSON.stringify({
        containerAri: containerAri
    });
    const attempts = options.shouldRetry === false ? 2 : 1;
    try {
        const { id: id, statusCode: statusCode } = await $735c346be3f362a2$var$sendDuplicateRequest(url, body);
        return {
            id: id,
            statusCode: statusCode,
            attempts: attempts
        };
    } catch (error) {
        if (typeof error === 'object' && error !== null) error.attempts = attempts;
        const statusCode = error?.statusCode;
        if (statusCode !== 403 && options.shouldRetry !== false) return $735c346be3f362a2$export$2cee355049cb72e4(appId, {
            ...options,
            shouldRetry: false
        });
        throw error;
    }
}
module.exports["duplicateMauiApp"] = $735c346be3f362a2$export$2cee355049cb72e4;

});

parcelRegister("cauOq", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $8m50u = parcelRequire("8m50u");


var $jmjWc = parcelRequire("jmjWc");


var $6mKj3 = parcelRequire("6mKj3");


const $5d7856924c94f859$var$EditorHelpCenterBackground = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "hR0dw",
    name: "EditorHelpCenterBackground",
    loader: async ()=>(await (parcelRequire("8OdB9"))).EditorHelpCenter
});

const $5d7856924c94f859$var$EditorHelpCenterOnPaint = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "V131B",
    name: "EditorHelpCenterOnPaint",
    loader: async ()=>(await (parcelRequire("8OdB9"))).EditorHelpCenter
});
const $5d7856924c94f859$export$8ffe1e824479312f = (0, $8m50u.componentWithCondition)(()=>(0, $6mKj3.expValEquals)('platform_editor_help_center_background_load', 'variant', 'test'), $5d7856924c94f859$var$EditorHelpCenterBackground, $5d7856924c94f859$var$EditorHelpCenterOnPaint);
module.exports["EditorHelpCenter"] = $5d7856924c94f859$export$8ffe1e824479312f;

});

parcelRegister("8m50u", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

function $fb7caad66dba5065$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
        const $ = (0, $bDgLe.c)(3);
        let t0;
        if ($[0] !== props || $[1] !== ref) {
            t0 = condition() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentTrue, {
                ...props,
                ref: ref
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentFalse, {
                ...props,
                ref: ref
            });
            $[0] = props;
            $[1] = ref;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    } : (props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $fb7caad66dba5065$export$6e8ea24b15199873;

});

parcelRegister("8OdB9", function(module, exports) {

let $669d8a8c169c4be6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $669d8a8c169c4be6$var$load("4X1QD"),
    $669d8a8c169c4be6$var$load("dxcsb"),
    $669d8a8c169c4be6$var$load("99ObF"),
    $669d8a8c169c4be6$var$load("2nk6f")
]).then(()=>parcelRequire('cix6s'));

});

parcelRegister("7WFax", function(module, exports) {
/* HelpWidget.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $kyJuy = parcelRequire("kyJuy");


var $lpNn5 = parcelRequire("lpNn5");


var $aRGok = parcelRequire("aRGok");


var $6wrL8 = parcelRequire("6wrL8");


var $dcvq8 = parcelRequire("dcvq8");


var $lx6jn = parcelRequire("lx6jn");


var $8ViO5 = parcelRequire("8ViO5");

const $42fef2b06f093364$var$styles = {
    root: "_kqswstnw _94n51ejb _1ltvv47k _1pby1nn1",
    markdownModeRoot: "_94n5xncg"
};
const $42fef2b06f093364$var$i18n = (0, $kSwu1.defineMessages)({
    helpName: {
        id: "editor-help.help.name",
        defaultMessage: "Help"
    }
});
const $42fef2b06f093364$export$c7125cce544d6ba9 = /*#__PURE__*/ (0, $cozmU.memo)(({ openHelpDialog: openHelpDialog, contentId: contentId, isNCSEditor: isNCSEditor, isTemplateEditor: isTemplateEditor, isCompanyHub: isCompanyHub, setIsOpen: setIsOpen, isOpen: isOpen, isMarkdownMode: isMarkdownMode, isMarkdownModeSyntaxViewToggled: isMarkdownModeSyntaxViewToggled })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [shouldShowDevTools, setShouldShowDevTools] = (0, $cozmU.useState)(false);
    const [shouldShowGlobalFeedbackCollector, setShouldShowGlobalFeedbackCollector] = (0, $cozmU.useState)(false);
    const triggerRef = (0, $cozmU.useRef)(null);
    const handleButtonClick = (0, $cozmU.useCallback)((e)=>{
        e.stopPropagation();
        setIsOpen?.(!isOpen);
    }, [
        isOpen,
        setIsOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "help-widget",
        className: (0, $hekY6.default)([
            $42fef2b06f093364$var$styles.root,
            isMarkdownMode && isMarkdownModeSyntaxViewToggled && $42fef2b06f093364$var$styles.markdownModeRoot
        ])
    }, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8ViO5.HelpMenu), {
        openHelpDialog: openHelpDialog,
        contentId: contentId,
        isNCSEditor: isNCSEditor,
        isTemplateEditor: isTemplateEditor,
        isCompanyHub: isCompanyHub,
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        setShouldShowDevTools: setShouldShowDevTools,
        setShouldShowGlobalFeedbackCollector: setShouldShowGlobalFeedbackCollector,
        triggerRef: triggerRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage($42fef2b06f093364$var$i18n.helpName),
        position: "right",
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        ref: triggerRef,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kyJuy))),
        shape: "circle",
        appearance: "subtle",
        label: formatMessage($42fef2b06f093364$var$i18n.helpName),
        testId: "help-menu-icon-button",
        onClick: handleButtonClick,
        isSelected: isOpen,
        "aria-expanded": isOpen,
        "aria-haspopup": "menu",
        color: "color.icon.subtlest"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, shouldShowDevTools && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wrL8.LazyDevToolsDialog), {
        onClose: ()=>setShouldShowDevTools(false)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, shouldShowGlobalFeedbackCollector && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dcvq8.LazyGlobalFeedbackCollector), {
        feedbackSource: (0, $lx6jn.FeedbackSource).EDITOR,
        onClose: ()=>setShouldShowGlobalFeedbackCollector(false),
        onCloseComplete: ()=>{},
        contentType: "page"
    })));
});
module.exports["HelpWidget"] = $42fef2b06f093364$export$c7125cce544d6ba9;

});

parcelRegister("6wrL8", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c2828397bc04eb44$export$23eed8de2215911d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ltMJ3",
    name: "DevToolsDialog",
    loader: async ()=>(await (parcelRequire("lPg5a"))).DevToolsDialog
});

const $c2828397bc04eb44$export$edf3a07292eacd91 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "f62AJ",
    name: "LazyDevToolsDialog",
    loader: async ()=>(await (parcelRequire("lPg5a"))).DevToolsDialog
});

const $c2828397bc04eb44$export$a08fb8aab8d5eb82 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "xzcSO",
    name: "DevToolsBanner",
    loader: async ()=>(await (parcelRequire("gsBOn"))).DevToolsBanner
});
module.exports["DevToolsDialog"] = $c2828397bc04eb44$export$23eed8de2215911d;
module.exports["LazyDevToolsDialog"] = $c2828397bc04eb44$export$edf3a07292eacd91;
module.exports["DevToolsBanner"] = $c2828397bc04eb44$export$a08fb8aab8d5eb82;

});

parcelRegister("lPg5a", function(module, exports) {

let $fe3ad608f3597c89$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fe3ad608f3597c89$var$load("jzUgs"),
    $fe3ad608f3597c89$var$load("8zMmc"),
    $fe3ad608f3597c89$var$load("6wr18"),
    $fe3ad608f3597c89$var$load("ilUG7"),
    $fe3ad608f3597c89$var$load("efUj2"),
    $fe3ad608f3597c89$var$load("iWnyc"),
    $fe3ad608f3597c89$var$load("ffEVr"),
    $fe3ad608f3597c89$var$load("hhss7"),
    $fe3ad608f3597c89$var$load("Wowvf"),
    $fe3ad608f3597c89$var$load("eRhBr"),
    $fe3ad608f3597c89$var$load("7EorR"),
    $fe3ad608f3597c89$var$load("fYNhh")
]).then(()=>parcelRequire('bFmys'));

});

parcelRegister("gsBOn", function(module, exports) {

let $bfbc976fa724bf2c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bfbc976fa724bf2c$var$load("C72jX").then(()=>parcelRequire('5uV65'));

});

parcelRegister("dcvq8", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $28c0ce898ab65517$export$7bd982897ab56fe5 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1kdap",
    name: "GlobalFeedbackCollector",
    loader: async ()=>(await (parcelRequire("lAEBa"))).GlobalFeedbackCollector
});

const $28c0ce898ab65517$export$76de8e4d628aac4a = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "7vDuP",
    name: "LazyGlobalFeedbackCollector",
    loader: async ()=>(await (parcelRequire("lAEBa"))).GlobalFeedbackCollector
});
module.exports["GlobalFeedbackCollector"] = $28c0ce898ab65517$export$7bd982897ab56fe5;
module.exports["LazyGlobalFeedbackCollector"] = $28c0ce898ab65517$export$76de8e4d628aac4a;

});

parcelRegister("lAEBa", function(module, exports) {

let $fb7c73c1e480b8f7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fb7c73c1e480b8f7$var$load("kHXvF"),
    $fb7c73c1e480b8f7$var$load("7gL7H"),
    $fb7c73c1e480b8f7$var$load("hhss7"),
    $fb7c73c1e480b8f7$var$load("dGk3x")
]).then(()=>parcelRequire('liJpy'));

});

parcelRegister("8ViO5", function(module, exports) {
/* HelpMenu.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable check-i18n-id-prefix/i18n-id-prefix-with-package-name-FormattedMessage */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $V3JOP = parcelRequire("V3JOP");


var $9d7Pd = parcelRequire("9d7Pd");


var $8oBbn = parcelRequire("8oBbn");


var $6IL1T = parcelRequire("6IL1T");


var $8FgJC = parcelRequire("8FgJC");


var $bavCP = parcelRequire("bavCP");


var $4tOXV = parcelRequire("4tOXV");


var $bw3p5 = parcelRequire("bw3p5");


var $lHIow = parcelRequire("lHIow");


var $jmjWc = parcelRequire("jmjWc");


var $lREFo = parcelRequire("lREFo");


var $6mKj3 = parcelRequire("6mKj3");


var $79V5c = parcelRequire("79V5c");


var $gi8bo = parcelRequire("gi8bo");


var $ep7kE = parcelRequire("ep7kE");

const $9fef5514b8b73423$var$styles = {
    base: "_2rko12b0 _1rjc12x7 _1mouu2gc _195g1wug _bfhk1bhr _16qs130s _p12fnklw",
    shortcut: "_syaz1rpy"
};
const $9fef5514b8b73423$export$d3e032c62ea2d293 = ({ openHelpDialog: openHelpDialog, contentId: contentId, isNCSEditor: isNCSEditor, isTemplateEditor: isTemplateEditor, isCompanyHub: isCompanyHub, isOpen: isOpen, setIsOpen: setIsOpen, setShouldShowDevTools: setShouldShowDevTools, setShouldShowGlobalFeedbackCollector: setShouldShowGlobalFeedbackCollector, triggerRef: triggerRef })=>{
    const containerRef = (0, $cozmU.useRef)(null);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const blueprintType = (0, $lREFo.useBlueprintType)(contentId, isTemplateEditor);
    const handleCloseHelpMenu = (0, $cozmU.useCallback)(()=>{
        setIsOpen?.(false);
    }, [
        setIsOpen
    ]); // Callback ref to focus the menu container when it mounts for a11y
    const setContainerRef = (0, $cozmU.useCallback)((node)=>{
        containerRef.current = node;
        if (node) // Focus the menu container directly - it has tabIndex={-1} to receive programmatic focus
        node.focus();
    }, []); // Arrow key navigation for keyboard a11y
    // Implemented manually here because this is not yet supported by the AK Menu component
    // and the DropdownMenu is avoided for performance reasons
    const handleKeyDown = (0, $cozmU.useCallback)((event)=>{
        if (!containerRef.current) return;
        const items = containerRef.current.querySelectorAll('button, a, [role="menuitem"]');
        if (!items.length) return;
         // Check if focus is on the container itself (not on a menu item)
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const focusOnContainer = document.activeElement === containerRef.current;
        const currentIndex = focusOnContainer ? -1 : // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        Array.from(items).findIndex((item)=>item === document.activeElement);
        switch(event.key){
            case 'ArrowDown':
                event.preventDefault();
                if (focusOnContainer || currentIndex === -1) // Focus first item when pressing down from container
                items[0].focus();
                else {
                    const nextIndex = currentIndex < items.length - 1 ? currentIndex + 1 : 0;
                    items[nextIndex].focus();
                }
                break;
            case 'ArrowUp':
                event.preventDefault();
                if (focusOnContainer || currentIndex === -1) // Focus last item when pressing up from container
                items[items.length - 1].focus();
                else {
                    const prevIndex = currentIndex > 0 ? currentIndex - 1 : items.length - 1;
                    items[prevIndex].focus();
                }
                break;
            case 'Tab':
                event.preventDefault();
                if (event.shiftKey) {
                    // Shift+Tab - move backwards
                    if (focusOnContainer || currentIndex === -1) items[items.length - 1].focus();
                    else {
                        const prevIndex = currentIndex > 0 ? currentIndex - 1 : items.length - 1;
                        items[prevIndex].focus();
                    }
                } else // Tab - move forwards
                if (focusOnContainer || currentIndex === -1) items[0].focus();
                else {
                    const nextIndex = currentIndex < items.length - 1 ? currentIndex + 1 : 0;
                    items[nextIndex].focus();
                }
                break;
            case 'Escape':
                event.preventDefault();
                handleCloseHelpMenu(); // Return focus to trigger button
                triggerRef?.current?.focus();
                break;
        }
    }, [
        containerRef,
        handleCloseHelpMenu,
        triggerRef
    ]);
    const handleClickOutside = (0, $cozmU.useCallback)((event)=>{
        const target = event.target;
        const targetIsNotUnmountedByReact = target.offsetParent;
        if (isOpen && targetIsNotUnmountedByReact && !(0, $79V5c.isDescendant)(containerRef.current, target)) handleCloseHelpMenu();
    }, [
        isOpen,
        handleCloseHelpMenu
    ]);
    (0, $cozmU.useEffect)(()=>{
        window.document.addEventListener('click', handleClickOutside);
        return ()=>{
            window.document.removeEventListener('click', handleClickOutside);
        };
    }, [
        handleClickOutside
    ]);
    const onItemClick = (0, $cozmU.useCallback)((_event, callback)=>{
        if (callback) return ()=>{
            handleCloseHelpMenu();
            triggerRef?.current?.focus(); // Wrap callback in requestAnimationFrame to ensure it is triggered async after focus is moved
            // This allows focus to return to the help icon after the opened modal is closed for a11y
            requestAnimationFrame(()=>{
                callback();
            });
        };
        handleCloseHelpMenu();
    }, [
        handleCloseHelpMenu,
        triggerRef
    ]);
    const renderHelpShortcutDropDownItem = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ $cozmU.createElement((0, $9d7Pd.default), {
            onClick: onItemClick(null, openHelpDialog),
            iconAfter: /*#__PURE__*/ $cozmU.createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: "mod+/"
            })
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
            id: "editor.shortcuts"
        })), [
        onItemClick,
        openHelpDialog
    ]);
    const renderHelpCenter = (0, $cozmU.useMemo)(()=>{
        return !(0, $6mKj3.expVal)('cc_fd_help_center_no_changeboarding', 'isEnabled', false) && /*#__PURE__*/ $cozmU.createElement((0, $ep7kE.HelpMenuHelpCenterItem), {
            closeHelpMenu: handleCloseHelpMenu
        });
    }, [
        handleCloseHelpMenu
    ]);
    const renderBlueprintTypeBasedDropdownItems = (0, $cozmU.useMemo)(()=>{
        if ((0, $gi8bo.CONTEXTUAL_EDITOR_HELP_LINKS).hasOwnProperty(blueprintType)) {
            const i18nMessage = {
                id: (0, $gi8bo.PREDEFINED_BLUEPRINT_TYPES_TITLES)[blueprintType]
            };
            const blueprintTitle = formatMessage(i18nMessage);
            return (0, $gi8bo.CONTEXTUAL_EDITOR_HELP_LINKS)[blueprintType].map((item, index)=>/*#__PURE__*/ $cozmU.createElement((0, $8oBbn.default), {
                    key: index,
                    onClick: (e)=>onItemClick(e, null),
                    href: item.href,
                    target: "_blank"
                }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                    id: "editor.help.how.to.use.blueprint",
                    values: {
                        blueprintType: blueprintTitle
                    }
                })));
        }
        return null;
    }, [
        blueprintType,
        formatMessage,
        onItemClick
    ]);
    const renderDevTools = (0, $cozmU.useMemo)(()=>{
        return /*#__PURE__*/ $cozmU.createElement((0, $bavCP.QueryInterop), {
            query: (0, $lHIow.default),
            __callerPackage__: "editor-help"
        }, ({ data: data })=>{
            const atlassianStaff = (0, $bw3p5.isAtlassianStaff)(data);
            const showDevTools = ()=>setShouldShowDevTools?.(true);
            return atlassianStaff ? /*#__PURE__*/ $cozmU.createElement((0, $9d7Pd.default), {
                onClick: onItemClick(null, showDevTools)
            }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                id: "editor.help.dev-tools",
                defaultMessage: "Dev Tools"
            })) : null;
        });
    }, [
        setShouldShowDevTools,
        onItemClick
    ]);
    const renderExternalLinkItems = (0, $cozmU.useMemo)(()=>{
        if (isTemplateEditor) return null;
        return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $8oBbn.default), {
            href: (0, $gi8bo.EDITOR_IMPROVEMENTS_URL),
            target: "_blank",
            iconAfter: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
                color: "currentColor",
                label: formatMessage({
                    id: "help.name"
                })
            })
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
            id: "editor.help.updates"
        })), !isCompanyHub ? /*#__PURE__*/ $cozmU.createElement((0, $8oBbn.default), {
            href: (0, $gi8bo.EDITOR_TEMPLATES_URL),
            target: "_blank",
            iconAfter: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
                color: "currentColor",
                label: formatMessage({
                    id: "help.name"
                })
            })
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
            id: "editor.help.templates",
            defaultMessage: "Use page templates"
        })) : null);
    }, [
        isTemplateEditor,
        isCompanyHub,
        formatMessage
    ]);
    const renderNCSSynchronyIndicator = (0, $cozmU.useMemo)(()=>/*#__PURE__*/ $cozmU.createElement((0, $bavCP.QueryInterop), {
            query: (0, $lHIow.default),
            __callerPackage__: "editor-help"
        }, ({ data: data })=>{
            const atlassianStaff = (0, $bw3p5.isAtlassianStaff)(data);
            if (!atlassianStaff) return null;
            if (isTemplateEditor) return null;
            const indicator = isNCSEditor ? /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                id: "editor.help.dev-only-ncs-editor",
                defaultMessage: "DEV ONLY: NCS editor"
            }) : /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                id: "editor.help.dev-only-synchrony-editor",
                defaultMessage: "DEV ONLY: Synchrony editor"
            });
            return /*#__PURE__*/ $cozmU.createElement((0, $9d7Pd.default), null, indicator);
        }), [
        isNCSEditor,
        isTemplateEditor
    ]);
    const renderFeedbackItem = (0, $cozmU.useMemo)(()=>{
        const openGlobalFeedbackCollector = ()=>{
            setShouldShowGlobalFeedbackCollector?.(true);
        };
        return /*#__PURE__*/ $cozmU.createElement((0, $9d7Pd.default), {
            onClick: onItemClick(null, openGlobalFeedbackCollector)
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
            id: "editor-help.fabric.help.center.feedback.item",
            defaultMessage: "Feedback"
        }));
    }, [
        onItemClick,
        setShouldShowGlobalFeedbackCollector
    ]);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "help-menu-component",
        ref: setContainerRef,
        role: "menu",
        "aria-label": formatMessage({
            id: "editor-help.help.name",
            defaultMessage: "Help menu"
        }),
        onKeyDown: handleKeyDown,
        tabIndex: -1,
        className: (0, $hekY6.default)([
            $9fef5514b8b73423$var$styles.base
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $6IL1T.default), {
        role: "none"
    }, /*#__PURE__*/ $cozmU.createElement((0, $8FgJC.default), null, renderNCSSynchronyIndicator, renderDevTools, renderHelpShortcutDropDownItem, renderExternalLinkItems, renderHelpCenter, renderBlueprintTypeBasedDropdownItems, renderFeedbackItem)));
};

const $9fef5514b8b73423$export$c95a604f5f13c815 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "P9Lue",
    name: "HelpMenu",
    loader: async ()=>(await Promise.resolve(module.exports)).HelpMenuComponent
});
module.exports["HelpMenuComponent"] = $9fef5514b8b73423$export$d3e032c62ea2d293;
module.exports["HelpMenu"] = $9fef5514b8b73423$export$c95a604f5f13c815;

});

parcelRegister("bw3p5", function(module, exports) {
const $94cc6fb69dc46872$export$c447f2d04f7089f6 = (data)=>{
    return data?.user?.emails?.some((email)=>email?.value && (email.value.endsWith('@atlassian.com') || email.value.endsWith('@atlassian.com.invalid') || email.value.endsWith('@usersinbuckets.com'))) || false;
};
module.exports["isAtlassianStaff"] = $94cc6fb69dc46872$export$c447f2d04f7089f6;

});

parcelRegister("lHIow", function(module, exports) {
/**
 * @generated SignedSource<<4946794a47276ece2c3618b700760251>>
 * @relayHash c99e2808a228eb92727148803707fdaf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7ec205f40b7500fb7c7a9b071c68e81d587fa99bea362fe137a7dc948eb646b5
const $c2fc5189fb45f020$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserEmail",
                    "kind": "LinkedField",
                    "name": "emails",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isPrimary"
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "UserContextQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "UserContextQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "c99e2808a228eb92727148803707fdaf",
            "id": "7ec205f40b7500fb7c7a9b071c68e81d587fa99bea362fe137a7dc948eb646b5",
            "metadata": {},
            "name": "UserContextQuery",
            "operationKind": "query",
            "text": "query UserContextQuery{user:confluence_atlassianUser(current:true){id,displayName,emails{value,isPrimary}}}"
        }
    };
}();
$c2fc5189fb45f020$var$node.hash = "5aa8ba909d08e6a2648a02f59bca880f";
var $c2fc5189fb45f020$export$2e2bcd8739ae039 = $c2fc5189fb45f020$var$node;
module.exports["default"] = $c2fc5189fb45f020$export$2e2bcd8739ae039;

});

parcelRegister("79V5c", function(module, exports) {
const $61ebe33edfdd9c82$export$8503f9d2928f9a64 = (parent, child)=>{
    let node = child.parentNode;
    while(node !== null){
        if (node === parent) return true;
        node = node.parentNode;
    }
    return false;
};
module.exports["isDescendant"] = $61ebe33edfdd9c82$export$8503f9d2928f9a64;

});

parcelRegister("gi8bo", function(module, exports) {
const $b321bf2443957350$export$94242db98fef807c = 'fabric-editor-onboarding-spotlight';
const $b321bf2443957350$export$29775c4096cc1552 = 'editor.help.center.spotlight.on.help.menu';
const $b321bf2443957350$export$d9e6ed86eee859f9 = 'https://confluence.atlassian.com/confcloud/confluence-editing-improvements-945107733.html';
const $b321bf2443957350$export$27957730b2c962c0 = 'https://confluence.atlassian.com/display/ConfCloud/Create+a+page+from+a+template';
const $b321bf2443957350$export$4b54359533b49a0a = {
    EDITING_IMPROVEMENTS: 'https://confluence.atlassian.com/display/ConfCloud/Confluence+Editing+Improvements',
    MEETING_NOTES: 'https://www.atlassian.com/software/confluence/templates/meeting-notes',
    BLOGS_UPDATE: 'https://confluence.atlassian.com/display/ConfCloud/Confluence+Editing+Improvements#ConfluenceEditingImprovements-blogposts',
    MEETING_NOTES_UPDATE: 'https://confluence.atlassian.com/display/ConfCloud/Confluence+Editing+Improvements#ConfluenceEditingImprovements-meetingnotes'
};
const $b321bf2443957350$export$8ef3900260e04cce = {
    'meeting-notes': [
        {
            href: $b321bf2443957350$export$4b54359533b49a0a.MEETING_NOTES,
            title: 'editor.help.how.to.use.blueprint'
        }
    ]
};
const $b321bf2443957350$export$3e2a3fad4e0315ba = {
    'meeting-notes': 'content.kind.meeting-notes',
    decisions: 'content.kind.decisions',
    'kb-how-to-article': 'content.kind.kb-how-to-article',
    'file-list': 'content.kind.file-list',
    retrospective: 'content.kind.retrospective',
    requirements: 'content.kind.product-requirements',
    'shared-links': 'content.kind.shared-links',
    'kb-troubleshooting-article': 'content.kind.kb-troubleshooting-article',
    'task-report': 'content.kind.task-report',
    jirareport: 'content.kind.jirareport'
};
module.exports["HELP_MENU_SPOTLIGHT"] = $b321bf2443957350$export$29775c4096cc1552;
module.exports["EDITOR_IMPROVEMENTS_URL"] = $b321bf2443957350$export$d9e6ed86eee859f9;
module.exports["EDITOR_TEMPLATES_URL"] = $b321bf2443957350$export$27957730b2c962c0;
module.exports["CONTEXTUAL_EDITOR_HELP_LINKS"] = $b321bf2443957350$export$8ef3900260e04cce;
module.exports["PREDEFINED_BLUEPRINT_TYPES_TITLES"] = $b321bf2443957350$export$3e2a3fad4e0315ba;

});

parcelRegister("ep7kE", function(module, exports) {
/* eslint-disable check-i18n-id-prefix/i18n-id-prefix-with-package-name-FormattedMessage */ /*
This component represents the help center list item in the editor help menu
(currently in the bottom left of the editor view).

It is broken out as a component because of the need to add/remove a listener in
componentDidUpdate.
 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $is1T6 = parcelRequire("is1T6");


var $lzgC6 = parcelRequire("lzgC6");


var $giS6h = parcelRequire("giS6h");


var $3RNrC = parcelRequire("3RNrC");


var $gi8bo = parcelRequire("gi8bo");


var $29Qpd = parcelRequire("29Qpd");

const $763e12daea84475e$var$HelpMenuHelpCenterItemWithContext = (props)=>{
    const classicEditorContext = (0, $cozmU.useContext)((0, $giS6h.ClassicEditorContext));
    const helpMenuClassicContext = (0, $cozmU.useContext)((0, $3RNrC.HelpMenuClassicContext));
    // The next editor uses the ClassicEditorContext, while classic uses the HelpMenuClassicContext
    const { Changeboarding: Changeboarding } = classicEditorContext.Changeboarding ? classicEditorContext : helpMenuClassicContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($763e12daea84475e$var$HelpMenuHelpCenterItemClass, {
        ...props,
        Changeboarding: Changeboarding
    });
};
const $763e12daea84475e$var$HelpMenuHelpCenterItemClass = ({ closeHelpMenu: closeHelpMenu, createAnalyticsEvent: createAnalyticsEvent, Changeboarding: Changeboarding })=>{
    const [helpCenterSweetState, { openHelpCenter: openHelpCenter, hideHelpMenuSpotlight: hideHelpMenuSpotlight }] = (0, $29Qpd.useHelpMenuState)();
    const onOpenHelpCenter = ()=>{
        openHelpCenter();
        closeHelpMenu();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'helpMenuItemForEditorHelpCenter',
                source: 'editorHelpMenu'
            }
        }).fire();
    };
    /**
   * When the last changeboard in the current sequence is closed, call this
   * callback to set the state of the spotlight in helpCenterState.
   * @param helpCenterState
   */ const changeboardingFinished = ()=>{
        hideHelpMenuSpotlight();
        closeHelpMenu();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'spotlightForEditorHelpCenter',
                source: 'editor help menu spotlight'
            }
        }).fire();
    };
    const isHelpCenterOpen = helpCenterSweetState.isHelpCenterOpen;
    return helpCenterSweetState.shouldShowHelpMenuSpotlight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Changeboarding, {
        spotlightId: (0, $gi8bo.HELP_MENU_SPOTLIGHT),
        delaySpotlight: 200,
        changeboardFlowFinished: changeboardingFinished
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        isDisabled: isHelpCenterOpen,
        onClick: onOpenHelpCenter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "fabric.help.center.menuitem.title"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        testId: "help-center-menuitem-title",
        isDisabled: isHelpCenterOpen,
        onClick: onOpenHelpCenter
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "fabric.help.center.menuitem.title"
    }));
};
const $763e12daea84475e$export$9fbf8d846e1f1108 = (0, $lzgC6.default)()($763e12daea84475e$var$HelpMenuHelpCenterItemWithContext);
module.exports["HelpMenuHelpCenterItem"] = $763e12daea84475e$export$9fbf8d846e1f1108;

});

parcelRegister("3RNrC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $d5243bcfa2782ca1$export$c6b672e180f71a34 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(undefined);
module.exports["HelpMenuClassicContext"] = $d5243bcfa2782ca1$export$c6b672e180f71a34;

});

parcelRegister("29Qpd", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $cdc66bc83bc87cd7$var$initialState = {
    isHelpCenterOpen: false,
    isHelpCenterManuallyOpened: false,
    shouldShowHelpMenuSpotlight: null,
    isFeatureDiscovered: false
};
const $cdc66bc83bc87cd7$export$e324594224ef24da = {
    openHelpCenter: (isHelpCenterManuallyOpened = false)=>({ setState: setState })=>{
            setState({
                isHelpCenterOpen: true,
                isHelpCenterManuallyOpened: isHelpCenterManuallyOpened
            });
        },
    closeHelpCenter: ()=>({ setState: setState })=>{
            setState({
                isHelpCenterOpen: false,
                isHelpCenterManuallyOpened: false
            });
        },
    showHelpMenuSpotlight: ()=>({ setState: setState })=>{
            setState({
                shouldShowHelpMenuSpotlight: true
            });
        },
    hideHelpMenuSpotlight: ()=>({ setState: setState })=>{
            setState({
                shouldShowHelpMenuSpotlight: false
            });
        },
    setFeatureDiscovered: (discoveryState)=>({ setState: setState })=>{
            setState({
                isFeatureDiscovered: discoveryState
            });
        }
};
const $cdc66bc83bc87cd7$var$store = (0, $8s9DV.createStore)({
    initialState: $cdc66bc83bc87cd7$var$initialState,
    actions: $cdc66bc83bc87cd7$export$e324594224ef24da
});
const $cdc66bc83bc87cd7$export$cfc41c159d64eee0 = (0, $kBr4q.createHook)($cdc66bc83bc87cd7$var$store);
const $cdc66bc83bc87cd7$export$e72a86a116ee4bad = (0, $kBr4q.createActionsHook)($cdc66bc83bc87cd7$var$store);
module.exports["useHelpMenuState"] = $cdc66bc83bc87cd7$export$cfc41c159d64eee0;
module.exports["useHelpMenuActions"] = $cdc66bc83bc87cd7$export$e72a86a116ee4bad;

});

parcelRegister("hQDqA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $2iJbI = parcelRequire("2iJbI");


var $Uf8ZT = parcelRequire("Uf8ZT");


var $6ZneI = parcelRequire("6ZneI");


var $1wNUR = parcelRequire("1wNUR");

const $ebcc6a166a2bc753$export$fb51ab5e8dce5cd = (props)=>{
    const { contentId: contentId, version: version, isShowingOfflineBanner: isShowingOfflineBanner, spaceKey: spaceKey, editorActions: editorActions, setIsOnboardingBannerDataLoaded: setIsOnboardingBannerDataLoaded, handleTitleChange: handleTitleChange, onClickOpenContentCreationPanel: onClickOpenContentCreationPanel } = props;
    const { isVisible: isVisible, setIsVisible: setIsVisible, isLandInEditorBannerShown: isLandInEditorBannerShown, showingOfflineBanner: showingOfflineBanner, onboardingStateData: onboardingStateData, onboardingStateError: onboardingStateError, deserializedData: deserializedData, editorOnboardingEligiblity: editorOnboardingEligiblity, wasDraftBannerSeen: wasDraftBannerSeen, labelsError: labelsError, hasQueryErrors: hasQueryErrors } = (0, $1wNUR.useOnboardingBannerLogic)({
        contentId: contentId,
        version: version,
        isShowingOfflineBanner: isShowingOfflineBanner,
        spaceKey: spaceKey,
        setIsOnboardingBannerDataLoaded: setIsOnboardingBannerDataLoaded
    });
    (0, $cozmU.useEffect)(()=>{
        if (!isVisible) {
            // TODO: Manage logic in a separate component https://hello.atlassian.net/browse/CONFONBO-1674
            // These are all conditions where we should not block the Editor Help Center from rendering
            const finishedLoading = // there are any errors in the queries
            onboardingStateError || labelsError || hasQueryErrors || // the user is not eligible for the experiment
            onboardingStateData && !editorOnboardingEligiblity || wasDraftBannerSeen;
            if (finishedLoading) setIsOnboardingBannerDataLoaded(true);
        }
    }, [
        isVisible,
        onboardingStateError,
        labelsError,
        hasQueryErrors,
        onboardingStateData,
        editorOnboardingEligiblity,
        wasDraftBannerSeen,
        setIsOnboardingBannerDataLoaded
    ]);
    const { shouldHideFeatureForWacTemplateUsers: shouldHideFeatureForWacTemplateUsers, isLoading: isLoadingShouldHideFeatureForWacTemplateUsers } = (0, $2iJbI.useShouldHideFeatureForWacTemplateUsers)();
    // note: unauthorized errors are handled in the queries themselves
    if (onboardingStateError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: onboardingStateError
    });
    else if (labelsError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: labelsError
    });
    if (isLoadingShouldHideFeatureForWacTemplateUsers || shouldHideFeatureForWacTemplateUsers) return null;
    if (!isVisible) return null;
    const [BannerComponent, experienceName] = isLandInEditorBannerShown ? [
        (0, $6ZneI.LandInEditorBanner),
        (0, $irVI7.ONBOARDING_LAND_IN_EDITOR_BANNER_EXPERIENCE)
    ] : [
        (0, $Uf8ZT.EditorDraftBanner),
        (0, $irVI7.ONBOARDING_EDITOR_DRAFT_BANNER_EXPERIENCE)
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isLandInEditorBannerShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
        name: experienceName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BannerComponent, {
        ...props,
        showingOfflineBanner: showingOfflineBanner,
        setIsVisible: setIsVisible,
        deserializedData: onboardingStateData && deserializedData,
        editorActions: editorActions,
        onClickOpenContentCreationPanel: onClickOpenContentCreationPanel,
        handleTitleChange: handleTitleChange
    }));
};
const $ebcc6a166a2bc753$export$d450ceafc6a31d4 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).CE_MAU
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ebcc6a166a2bc753$export$fb51ab5e8dce5cd, props));
};
module.exports["OnboardingEditorBanner"] = $ebcc6a166a2bc753$export$d450ceafc6a31d4;

});

parcelRegister("2iJbI", function(module, exports) {

var $9kdHI = parcelRequire("9kdHI");

const $f4a73ae29c7bb36d$export$75ba00a1e24e646 = ()=>{
    const { templateOnboardingViewedTime: templateOnboardingViewedTime, isLoading: isLoading } = (0, $9kdHI.useGetTemplateOnboardingViewedTime)();
    if (isLoading) return {
        isLoading: true,
        shouldHideFeatureForWacTemplateUsers: undefined
    };
    const msSinceOnboardingViewed = Date.now() - templateOnboardingViewedTime;
    const daysSinceOnboardingViewed = Math.floor(msSinceOnboardingViewed / 86400000);
    return {
        isLoading: isLoading,
        shouldHideFeatureForWacTemplateUsers: daysSinceOnboardingViewed === 0
    };
};
module.exports["useShouldHideFeatureForWacTemplateUsers"] = $f4a73ae29c7bb36d$export$75ba00a1e24e646;

});

parcelRegister("9kdHI", function(module, exports) {

var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");

const $d1bc8a4175482375$export$51c1a6087b7be3d9 = ()=>{
    const { data: onboardingStateData, loading: isLoading, error: error } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.ONBOARDING_EXPERIENCES).TEMPLATE_ONBOARDING_VIEWED_TIME
    ]);
    if (error) return {
        isLoading: false,
        templateOnboardingViewedTime: 0
    };
    if (isLoading) return {
        isLoading: isLoading,
        templateOnboardingViewedTime: 0
    };
    const { templateOnboardingViewedTime: templateOnboardingViewedTime } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const templateOnboardingViewedTimeNumber = +templateOnboardingViewedTime;
    return {
        isLoading: false,
        templateOnboardingViewedTime: Number.isNaN(templateOnboardingViewedTimeNumber) ? 0 : templateOnboardingViewedTimeNumber
    };
};
const $d1bc8a4175482375$export$ab4c942452c94059 = ()=>{
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    return {
        setTemplateOnboardingViewedNow: ()=>{
            const now = Date.now().toString();
            setOnboardingState({
                key: (0, $dBcar.ONBOARDING_EXPERIENCES).TEMPLATE_ONBOARDING_VIEWED_TIME,
                value: now
            });
        }
    };
};
module.exports["useGetTemplateOnboardingViewedTime"] = $d1bc8a4175482375$export$51c1a6087b7be3d9;
module.exports["useSetTemplateOnboardingViewedTime"] = $d1bc8a4175482375$export$ab4c942452c94059;

});

parcelRegister("Uf8ZT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $l3wuH = parcelRequire("l3wuH");


var $9DHhW = parcelRequire("9DHhW");


var $ivb8S = parcelRequire("ivb8S");


var $5cryL = parcelRequire("5cryL");


var $2Csej = parcelRequire("2Csej");


var $lf5Wg = parcelRequire("lf5Wg");

const $3f811c71e472125a$var$i18n = (0, $kSwu1.defineMessages)({
    bannerMessage: {
        id: "onboarding-editor.draft.banner",
        defaultMessage: "{boldedUnpublishedDraftText} Only you can see it until you publish it or give someone the link. {learnMoreLink}"
    },
    unpublishedDraftText: {
        id: "onboarding-editor.unpublished.draft",
        defaultMessage: "<b>This is an unpublished draft.</b>"
    },
    learnMore: {
        id: "onboarding-editor.learn.more",
        defaultMessage: "Learn more"
    }
});
const $3f811c71e472125a$export$b786d9c272de6a0b = (props)=>{
    const { isContentCreationPanelOpen: isContentCreationPanelOpen, showingOfflineBanner: showingOfflineBanner, setIsVisible: setIsVisible, deserializedData: { wasDraftBannerSeen: wasDraftBannerSeen } = {}, setIsOnboardingBannerDataLoaded: setIsOnboardingBannerDataLoaded } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!wasDraftBannerSeen) {
            const editorNode = document.querySelector('.ak-editor-content-area');
            if (editorNode) editorNode.style.marginTop = '52px';
            return ()=>{
                if (editorNode) editorNode.style.marginTop = '0';
            };
        }
    }, [
        wasDraftBannerSeen
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!wasDraftBannerSeen) {
            setOnboardingState([
                {
                    key: (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).WAS_DRAFT_BANNER_SEEN,
                    value: 'true'
                },
                {
                    key: (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).IS_DRAFT_BANNER_VISIBLE,
                    value: 'true'
                }
            ]);
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'onboardingEditorDraft'
                }
            }).fire();
            // TODO: Refactor https://hello.atlassian.net/browse/CONFONBO-1674
            setTimeout(()=>{
                setIsOnboardingBannerDataLoaded(true);
            }, 0);
        }
    }, [
        createAnalyticsEvent,
        setIsOnboardingBannerDataLoaded,
        setOnboardingState,
        wasDraftBannerSeen
    ]);
    const _onDismiss = ()=>{
        setIsVisible(false);
        // Move all the content back up 52px to adjust for the banner disappearing
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const editorNode = document.querySelector('.ak-editor-content-area');
        if (editorNode) editorNode.style.marginTop = '0px';
    };
    // compiled shouldn't handle a complicated runtime CSS, hence the inlined style
    const calculatedTop = (0, $cozmU.useMemo)(()=>(0, $2Csej.getAdjustedTopPropertyValue)(showingOfflineBanner), [
        showingOfflineBanner
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lf5Wg.BannerContainer), {
        style: {
            top: calculatedTop
        },
        isContentCreationPanelOpen: isContentCreationPanelOpen,
        "data-testid": "onboarding-editor-draft-banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lf5Wg.Banner), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$3f811c71e472125a$var$i18n.bannerMessage,
        values: {
            boldedUnpublishedDraftText: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...$3f811c71e472125a$var$i18n.unpublishedDraftText,
                values: {
                    b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks)
                }
            }),
            learnMoreLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                href: "https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/",
                target: "_blank"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3f811c71e472125a$var$i18n.learnMore))
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lf5Wg.IconContainer), {
        "data-testid": "onboarding-editor-close-banner",
        onClick: _onDismiss
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        label: "dismiss"
    }))));
};
module.exports["EditorDraftBanner"] = $3f811c71e472125a$export$b786d9c272de6a0b;

});

parcelRegister("2Csej", function(module, exports) {

var $7Y8M5 = parcelRequire("7Y8M5");

const $962512f38cbacac9$export$4b0deb0da32f3c86 = (userOffline)=>{
    const offlineBannerHeight = 32;
    let toolbarHeight = (0, $7Y8M5.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)();
    if (userOffline) toolbarHeight = `calc(${toolbarHeight} + ${offlineBannerHeight}px)`;
    return toolbarHeight;
};
module.exports["getAdjustedTopPropertyValue"] = $962512f38cbacac9$export$4b0deb0da32f3c86;

});

parcelRegister("lf5Wg", function(module, exports) {
/* EditorDraftBannerStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ // File excluded from token migration due to dynamic nature
// https://atlassian.slack.com/archives/CFJ9DU39U/p1709665443238399

var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $50c9ab69d3957b00$export$f316edcbf748c37b = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isContentCreationPanelOpen: isContentCreationPanelOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11q71nm4 _v564rftg _4t3i1ex1 _kqswstnw _1ltvidpf _1pbyb4wl",
            __cmplp.isContentCreationPanelOpen ? "_1xi2nklw" : "_1xi2idpf",
            __cmplp.className
        ])
    });
});
const $50c9ab69d3957b00$export$3b4e64e77073e307 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt41gu9 _kqswh2mm _1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1osq _1bsb1osq _y3gn1h6o _vchhusvi",
            __cmplp.className
        ])
    });
});
const $50c9ab69d3957b00$export$8f314e512d92575f = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_kqswstnw _1xi2v47k _154ipxbi _80omtlke _1pbyb4wl",
            __cmplp.className
        ])
    });
});
module.exports["BannerContainer"] = $50c9ab69d3957b00$export$f316edcbf748c37b;
module.exports["Banner"] = $50c9ab69d3957b00$export$3b4e64e77073e307;
module.exports["IconContainer"] = $50c9ab69d3957b00$export$8f314e512d92575f;

});

parcelRegister("6ZneI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $l3wuH = parcelRequire("l3wuH");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $9DHhW = parcelRequire("9DHhW");


var $1l0kj = parcelRequire("1l0kj");


var $7ZB0A = parcelRequire("7ZB0A");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $ivb8S = parcelRequire("ivb8S");


var $5cryL = parcelRequire("5cryL");


var $hl0fg = parcelRequire("hl0fg");


var $2Csej = parcelRequire("2Csej");


var $2vb0O = parcelRequire("2vb0O");


var $2FB93 = parcelRequire("2FB93");

var $lf5Wg = parcelRequire("lf5Wg");


var $dz5dy = parcelRequire("dz5dy");


var $btiwl = parcelRequire("btiwl");


var $k1IGe = parcelRequire("k1IGe");

const $f8787e8012c53a80$var$i18n = (0, $kSwu1.defineMessages)({
    bannerTitle: {
        id: "onboarding-editor.land-in-editor.banner.title",
        defaultMessage: "There\u2019s a template for that"
    },
    bannerDescription: {
        id: "onboarding-editor.land-in-editor.banner.description",
        defaultMessage: "Based on your responses, here\u2019s a template best suited to help you get started."
    },
    exploreCTA: {
        id: "onboarding-editor.land-in-editor.explore-templates",
        defaultMessage: "Explore all templates"
    },
    blankPageCTA: {
        id: "onboarding-editor.land-in-editor.blank-page",
        defaultMessage: "Start with a blank page"
    }
});
const $f8787e8012c53a80$export$8cf2982a68e0098c = (props)=>{
    const { isContentCreationPanelOpen: isContentCreationPanelOpen, showingOfflineBanner: showingOfflineBanner, setIsVisible: setIsVisible, deserializedData: { isLandInEditorBannerVisible: isLandInEditorBannerVisible } = {}, setIsOnboardingBannerDataLoaded: setIsOnboardingBannerDataLoaded, editorActions: editorActions, onClickOpenContentCreationPanel: onClickOpenContentCreationPanel, handleTitleChange: handleTitleChange } = props;
    const { setHasLandInEditorBannerVisible: setHasLandInEditorBannerVisible } = (0, $dz5dy.useOnboardingEditorActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    (0, $cozmU.useEffect)(()=>{
        if (isLandInEditorBannerVisible) {
            setOnboardingState([
                {
                    key: (0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS).IS_LAND_IN_EDITOR_BANNER_VISIBLE,
                    value: 'false'
                }
            ]);
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'landInEditorBanner'
                }
            }).fire();
            setHasLandInEditorBannerVisible(true);
        }
        // TODO: Refactor https://hello.atlassian.net/browse/CONFONBO-1674
        setTimeout(()=>{
            setIsOnboardingBannerDataLoaded(true);
        }, 0);
    }, [
        setOnboardingState,
        isLandInEditorBannerVisible,
        createAnalyticsEvent,
        setIsOnboardingBannerDataLoaded,
        setHasLandInEditorBannerVisible
    ]);
    const { width: windowWidth } = (0, $hl0fg.useWindowSize)();
    // Apply margin-top with useLayoutEffect (before paint). This prevents TTVC mutations.
    (0, $cozmU.useLayoutEffect)(()=>{
        const editorNode = document.querySelector('.ak-editor-content-area');
        // shift the editor content down for different banner breakpoints
        if (editorNode) {
            if (windowWidth <= 375) editorNode.style.marginTop = '300px';
            else if (windowWidth <= 1024 || isContentCreationPanelOpen && windowWidth <= 1024 + (0, $2FB93.templateSidebarWidth)) editorNode.style.marginTop = '291px';
            else editorNode.style.marginTop = '174px';
        }
        return ()=>{
            if (editorNode) editorNode.style.marginTop = '0';
        };
    }, [
        windowWidth,
        isContentCreationPanelOpen
    ]);
    const handleExploreCTA = async ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'lieBannerExploreTemplates',
                source: 'landInEditorBanner'
            }
        }).fire();
        onClickOpenContentCreationPanel();
        setIsVisible(false);
    };
    const handleBlankPageCTA = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'lieBannerBlankPage',
                source: 'landInEditorBanner'
            }
        }).fire();
        onClickOpenContentCreationPanel();
        editorActions.clear();
        setIsVisible(false);
        handleTitleChange('');
    };
    const _onDismiss = ()=>{
        // this will start the animation, and onAnimationEnd we should hide the component
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'lieBannerDismiss',
                source: 'landInEditorBanner'
            }
        }).fire();
        setIsVisible(false);
    };
    // compiled shouldn't handle a complicated runtime CSS, hence the inlined style
    const calculatedTop = (0, $cozmU.useMemo)(()=>(0, $2Csej.getAdjustedTopPropertyValue)(showingOfflineBanner), [
        showingOfflineBanner
    ]);
    const theme = (0, $IQ4Dz.default)();
    const backgroundImageUrl = theme.colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($k1IGe))) : (0, (/*@__PURE__*/$parcel$interopDefault($btiwl)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2FB93.TemplateBannerContainer), {
        style: {
            top: calculatedTop,
            backgroundImage: `url(${backgroundImageUrl})`
        },
        isContentCreationPanelOpen: isContentCreationPanelOpen,
        "data-testid": "onboarding-land-in-editor-banner",
        fade: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2FB93.LeftWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2vb0O.TemplateBannerIllustration), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2FB93.RightWrapper), {
        isContentCreationPanelOpen: isContentCreationPanelOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2FB93.TitleWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f8787e8012c53a80$var$i18n.bannerTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2FB93.BodyWrapper), {
        isContentCreationPanelOpen: isContentCreationPanelOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f8787e8012c53a80$var$i18n.bannerDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2FB93.StyledButton), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: 'fit-content'
        },
        onClick: handleExploreCTA
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f8787e8012c53a80$var$i18n.exploreCTA)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        onClick: handleBlankPageCTA
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f8787e8012c53a80$var$i18n.blankPageCTA)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lf5Wg.IconContainer), {
        "data-testid": "onboarding-land-in-editor-banner-close",
        onClick: _onDismiss
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        label: "dismiss"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.ONBOARDING_LAND_IN_EDITOR_BANNER_EXPERIENCE)
    }));
};
module.exports["LandInEditorBanner"] = $f8787e8012c53a80$export$8cf2982a68e0098c;

});

parcelRegister("2vb0O", function(module, exports) {
/* TemplateBannerIllustration.tsx generated by @compiled/babel-plugin v0.36.1 */ // File excluded from token migration due to custom illustration
// https://atlassian.slack.com/archives/CFJ9DU39U/p1709665443238399

var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $cJ0FD = parcelRequire("cJ0FD");


var $1179k = parcelRequire("1179k");


var $9orOv = parcelRequire("9orOv");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $936e99c91b0f8b74$var$IllustrationContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2rko14xi _n7zljaz9 _1bsbp2n4 _4t3i1w81 _19pk1ejb _bfhkvuon _3okf1ejb _534poahv",
            __cmplp.className
        ])
    });
});
const $936e99c91b0f8b74$export$f60cdccc39dd0674 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($936e99c91b0f8b74$var$IllustrationContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9orOv))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($1179k))),
        alt: "",
        testId: "template-banner-illustration"
    }));
};
module.exports["TemplateBannerIllustration"] = $936e99c91b0f8b74$export$f60cdccc39dd0674;

});

parcelRegister("1179k", function(module, exports) {
module.exports = new URL("LandInEditorIllustrationDark.2f9f7913.svg", import.meta.url).toString();

});

parcelRegister("9orOv", function(module, exports) {
module.exports = new URL("LandInEditorIllustrationLight.28460c36.svg", import.meta.url).toString();

});

parcelRegister("2FB93", function(module, exports) {
/* EditorTemplateBannerStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ // File excluded from token migration due to dynamic nature
// https://atlassian.slack.com/archives/CFJ9DU39U/p1709665443238399

var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $7ZB0A = parcelRequire("7ZB0A");

const $4923552e618c34e5$export$edc250a38d698468 = 320;
const $4923552e618c34e5$var$shrinkUp = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $4923552e618c34e5$export$37a12d5fd88d0bab = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isContentCreationPanelOpen: isContentCreationPanelOpen, fade: fade, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _4t3ic4ae _1lrw1dfr _12vemgnk _kqswstnw _1ltvidpf _1pbyb4wl _l60l1sxn _1gwz14u9 _n7es1mjv",
            __cmplp.isContentCreationPanelOpen ? "_1xi2nklw" : "_1xi2idpf",
            __cmplp.isContentCreationPanelOpen && "_16q81sxn",
            __cmplp.isContentCreationPanelOpen && "_1dwk14u9",
            __cmplp.fade && "",
            __cmplp.fade && "_y44v1m2i",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $4923552e618c34e5$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $7ZB0A.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_nup9u5tj _1w901gfe _w1ap146b _ge1rfqeg _1fh11gfe _r7sm1f1m _1l5a1gfe",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $4923552e618c34e5$export$c3d2343a748f64d3 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _kqswh2mm _4t3i1osq _1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $4923552e618c34e5$export$8e62e599821d99ec = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isContentCreationPanelOpen: isContentCreationPanelOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _1bah1y6m _ca0q1ejb _1nzlidpf _1w22idpf _n71r1wug _1lzu1ejb _1ehg1ejb",
            __cmplp.isContentCreationPanelOpen && "_c5lf1tcg",
            __cmplp.isContentCreationPanelOpen && "_yy4t1tcg",
            __cmplp.isContentCreationPanelOpen && "_1oz9idpf _sxtsidpf _33eu1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $4923552e618c34e5$export$585a3b23e887288b = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11c81af2 _syazi7uo _otyr1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $4923552e618c34e5$export$14966827497f4695 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isContentCreationPanelOpen: isContentCreationPanelOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11c8fhey _syazi7uo _otyrpxbi _1bsb1osq _1i4q1hna _slp31hna _p12f13jv _1428glyw",
            __cmplp.isContentCreationPanelOpen && "_5aflglyw",
            __cmplp.className
        ])
    });
});
module.exports["templateSidebarWidth"] = $4923552e618c34e5$export$edc250a38d698468;
module.exports["TemplateBannerContainer"] = $4923552e618c34e5$export$37a12d5fd88d0bab;
module.exports["StyledButton"] = $4923552e618c34e5$export$2d5d2ba3c7c8c40b;
module.exports["LeftWrapper"] = $4923552e618c34e5$export$c3d2343a748f64d3;
module.exports["RightWrapper"] = $4923552e618c34e5$export$8e62e599821d99ec;
module.exports["TitleWrapper"] = $4923552e618c34e5$export$585a3b23e887288b;
module.exports["BodyWrapper"] = $4923552e618c34e5$export$14966827497f4695;

});

parcelRegister("dz5dy", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $f3a77a444e363c9b$var$Store = (0, $8s9DV.createStore)({
    initialState: {
        /**
     * The user has published their first page ever in the current session
     * If they publish more than one page, this condition is invalidated
     */ hasMetPublishNudgeConditions: false,
        hasLandInEditorBannerVisible: false
    },
    actions: {
        setHasMetPublishNudgeConditions: (hasMetPublishNudgeConditions)=>({ setState: setState })=>{
                setState({
                    hasMetPublishNudgeConditions: hasMetPublishNudgeConditions
                });
            },
        setHasLandInEditorBannerVisible: (hasLandInEditorBannerVisible)=>({ setState: setState })=>{
                setState({
                    hasLandInEditorBannerVisible: hasLandInEditorBannerVisible
                });
            }
    },
    name: 'useOnboardingEditorState'
});
const $f3a77a444e363c9b$export$b4e2284668311d45 = (0, $kBr4q.createStateHook)($f3a77a444e363c9b$var$Store, {
    selector: (state)=>({
            hasMetPublishNudgeConditions: state.hasMetPublishNudgeConditions,
            hasLandInEditorBannerVisible: state.hasLandInEditorBannerVisible
        })
});
const $f3a77a444e363c9b$export$e1d5565bc8c0d054 = (0, $kBr4q.createActionsHook)($f3a77a444e363c9b$var$Store);
module.exports["useOnboardingEditorState"] = $f3a77a444e363c9b$export$b4e2284668311d45;
module.exports["useOnboardingEditorActions"] = $f3a77a444e363c9b$export$e1d5565bc8c0d054;

});

parcelRegister("btiwl", function(module, exports) {
module.exports = new URL("LandInEditorBannerBackgroundLight.5f156b32.svg", import.meta.url).toString();

});

parcelRegister("k1IGe", function(module, exports) {
module.exports = new URL("LandInEditorBannerBackgroundDark.f8ccb0f3.svg", import.meta.url).toString();

});

parcelRegister("1wNUR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gci8t = parcelRequire("gci8t");


var $5cryL = parcelRequire("5cryL");


var $ivb8S = parcelRequire("ivb8S");


var $66Dsm = parcelRequire("66Dsm");


var $bQm3c = parcelRequire("bQm3c");

const $550262a7e0b7f3e1$var$DELAY_TIMEOUT = 3000;
const $550262a7e0b7f3e1$export$d80357b11b6fd623 = ({ contentId: contentId, version: version, isShowingOfflineBanner: isShowingOfflineBanner, spaceKey: spaceKey, setIsOnboardingBannerDataLoaded: setIsOnboardingBannerDataLoaded })=>{
    const { locale: locale } = (0, $bQm3c.useSessionData)();
    const [isVisible, setIsVisible] = (0, $cozmU.useState)(false);
    const [isLandInEditorBannerShown, setIsLandInEditorBannerShown] = (0, $cozmU.useState)(false);
    const [showingOfflineBanner, setShowingOfflineBanner] = (0, $cozmU.useState)(false);
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)(Object.values((0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS)), version !== 1 && version?.number !== 1);
    const deserializedData = (0, $ivb8S.deserializeState)(onboardingStateData);
    const { editorOnboardingEligiblity: editorOnboardingEligiblity, wasDraftBannerSeen: wasDraftBannerSeen, isLandInEditorBannerVisible: isLandInEditorBannerVisible } = deserializedData;
    // Only check the labels, if they are eligible for the tutorial experiment to begin with.
    const skip = !onboardingStateData || onboardingStateLoading || Boolean(onboardingStateError) || /* Check to see if they are a new user */ !editorOnboardingEligiblity || isLandInEditorBannerVisible; //Skip if user is eligible for Land In Editor Banner
    const { isTemplate: isTemplate, isOnboardingTemplate: isOnboardingTemplate, labelsData: labelsData, labelsLoading: labelsLoading, labelsError: labelsError } = (0, $gci8t.useCheckIfOnboardingEditorTemplate)({
        contentId: contentId,
        skip: skip
    });
    const { shouldIncludeEditorTutorialTemplate: shouldIncludeEditorTutorialTemplate, hasQueryErrors: hasQueryErrors } = (0, $66Dsm.useIncludeEditorTutorialTemplate)();
    // Connection banner height has a delay to appear, adjust the draft banner height to reflect this delay
    (0, $cozmU.useEffect)(()=>{
        const delayTimeout = setTimeout(()=>setShowingOfflineBanner(isShowingOfflineBanner), $550262a7e0b7f3e1$var$DELAY_TIMEOUT);
        return ()=>clearTimeout(delayTimeout);
    }, [
        isShowingOfflineBanner
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (labelsData && !labelsLoading) {
            // the original onboarding template should not have the draft banner
            if (isOnboardingTemplate || !shouldIncludeEditorTutorialTemplate) {
                setIsOnboardingBannerDataLoaded(true);
                return;
            }
            if (!wasDraftBannerSeen) setIsVisible(true);
        // land in editor banner has no labelsData
        } else if (isLandInEditorBannerVisible) {
            setIsVisible(true);
            setIsLandInEditorBannerShown(true);
        }
    }, [
        isOnboardingTemplate,
        isTemplate,
        labelsData,
        labelsLoading,
        locale,
        shouldIncludeEditorTutorialTemplate,
        setIsOnboardingBannerDataLoaded,
        spaceKey,
        wasDraftBannerSeen,
        isLandInEditorBannerVisible
    ]);
    return {
        isVisible: isVisible,
        setIsVisible: setIsVisible,
        isLandInEditorBannerShown: isLandInEditorBannerShown,
        showingOfflineBanner: showingOfflineBanner,
        onboardingStateData: onboardingStateData,
        onboardingStateLoading: onboardingStateLoading,
        onboardingStateError: onboardingStateError,
        deserializedData: deserializedData,
        editorOnboardingEligiblity: editorOnboardingEligiblity,
        wasDraftBannerSeen: wasDraftBannerSeen,
        isLandInEditorBannerVisible: isLandInEditorBannerVisible,
        isTemplate: isTemplate,
        isOnboardingTemplate: isOnboardingTemplate,
        labelsData: labelsData,
        labelsLoading: labelsLoading,
        labelsError: labelsError,
        shouldIncludeEditorTutorialTemplate: shouldIncludeEditorTutorialTemplate,
        hasQueryErrors: hasQueryErrors
    };
};
module.exports["useOnboardingBannerLogic"] = $550262a7e0b7f3e1$export$d80357b11b6fd623;

});

parcelRegister("gci8t", function(module, exports) {

var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $jMyy4 = parcelRequire("jMyy4");


var $5cryL = parcelRequire("5cryL");


var $egBAV = parcelRequire("egBAV");

const $36eef014bcae96ba$export$9870b3b3798cc923 = ({ contentId: contentId, skip: skip })=>{
    const { data: labelsData, loading: labelsLoading, error: labelsError } = (0, $jMyy4.useQueryInterop)((0, $egBAV.default), {
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ]
        },
        skip: skip,
        __callerPackage__: "onboarding-helpers"
    });
    const labels = labelsData?.content?.nodes?.[0]?.labels?.nodes || [];
    const sourceTemplateEntityId = labelsData?.content?.nodes?.[0]?.metadata?.sourceTemplateEntityId || undefined;
    // If the current editor is NOT the onboarding editor tutorial, show the draft banner.
    const isOnboardingTemplate = Boolean(labels.find((label)=>label?.label === (0, $5cryL.ONBOARDING_TUTORIAL_LABEL)));
    if (labelsError && (0, $1uFM6.isUnauthorizedError)(labelsError)) (0, $7Sm4c.markErrorAsHandled)(labelsError);
    return {
        isTemplate: !!sourceTemplateEntityId,
        isOnboardingTemplate: isOnboardingTemplate,
        labelsData: labelsData,
        labelsLoading: labelsLoading,
        labelsError: labelsError
    };
};
module.exports["useCheckIfOnboardingEditorTemplate"] = $36eef014bcae96ba$export$9870b3b3798cc923;

});

parcelRegister("egBAV", function(module, exports) {
/**
 * @generated SignedSource<<8e4aec7abf730bd9b6c121fe604b0e66>>
 * @relayHash 8e5d7297ac72007aa9e919d94f58ca50
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0dd8c0bea74358700187666c444b804d534af0e1f62c2f7a034d57dadc90a2fc
const $a1b85ba19a33fc50$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "PaginatedLabelList",
                            "kind": "LinkedField",
                            "name": "labels",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "Label",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "label"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "sourceTemplateEntityId"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "OnboardingLabelsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "OnboardingLabelsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "8e5d7297ac72007aa9e919d94f58ca50",
            "id": "0dd8c0bea74358700187666c444b804d534af0e1f62c2f7a034d57dadc90a2fc",
            "metadata": {},
            "name": "OnboardingLabelsQuery",
            "operationKind": "query",
            "text": "query OnboardingLabelsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,labels{nodes{id,label}},metadata{sourceTemplateEntityId}}}}"
        }
    };
}();
$a1b85ba19a33fc50$var$node.hash = "535b83781f732e1b83acf14984cbe0ed";
var $a1b85ba19a33fc50$export$2e2bcd8739ae039 = $a1b85ba19a33fc50$var$node;
module.exports["default"] = $a1b85ba19a33fc50$export$2e2bcd8739ae039;

});

parcelRegister("66Dsm", function(module, exports) {

var $aUp28 = parcelRequire("aUp28");


var $6KWXd = parcelRequire("6KWXd");


var $bQm3c = parcelRequire("bQm3c");


var $1JEqL = parcelRequire("1JEqL");


var $5cryL = parcelRequire("5cryL");


var $ivb8S = parcelRequire("ivb8S");


var $jMyy4 = parcelRequire("jMyy4");

const $13240525381ea71e$export$10e7c37d48e20bae = 11;
const $13240525381ea71e$export$d227e9a2756e8472 = 7;
const $13240525381ea71e$export$d18f171722e15763 = ()=>{
    const { isLicensed: isLicensed, userId: userId, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const { data: editorOnboardingData, loading: editorOnboardingLoading, error: editorOnboardingError } = (0, $ivb8S.useGetOnboardingState)(Object.values((0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS)));
    const { data: userContentData, loading: userContentLoading, error: userContentError } = (0, $jMyy4.useQueryInterop)((0, $6KWXd.default), {
        variables: {
            cql: `type = 'page' AND creator = '${userId}'`
        },
        skip: !isLicensed || !isLoggedIn,
        __callerPackage__: "onboarding-helpers"
    });
    const { data: privilegeData, loading: privilegeLoading, error: privilegeError } = (0, $jMyy4.useQueryInterop)((0, $aUp28.default), {
        __callerPackage__: "onboarding-helpers"
    });
    // Onboarding related variables
    const deserializedEditorOnboardingState = (0, $ivb8S.deserializeState)(editorOnboardingData);
    const { editorOnboardingEligiblity: editorOnboardingEligiblity } = deserializedEditorOnboardingState;
    const queriesLoadingOrErrored = editorOnboardingLoading || Boolean(editorOnboardingError) || userContentLoading || Boolean(userContentError) || privilegeLoading || Boolean(privilegeError);
    const isProductOrSiteAdmin = (0, $1JEqL.getIsProductOrSiteAdminFromQuery)(privilegeData);
    const hasQueryErrors = Boolean(editorOnboardingError) || Boolean(userContentError) || Boolean(privilegeError);
    // Admins get automatically created 9 pages, while Nth users only get created 5.
    const publishedPagesThreshold = isProductOrSiteAdmin ? $13240525381ea71e$export$10e7c37d48e20bae : $13240525381ea71e$export$d227e9a2756e8472;
    // If there is no data on how many pages they published, then assume that the template shouldn't be visible.
    const numberOfPagesPublished = userContentData?.search?.count ?? publishedPagesThreshold;
    const shouldIncludeEditorTutorialTemplate = !queriesLoadingOrErrored && // Show the template if onboarding state is not loading / has an error
    Boolean(editorOnboardingEligiblity) && // Has to be onboarding eligible (new user)
    numberOfPagesPublished < publishedPagesThreshold; // Don't show if they have published 2 pages (excluding the auto-generated pages)
    return {
        shouldIncludeEditorTutorialTemplate: shouldIncludeEditorTutorialTemplate,
        userContentError: userContentError,
        editorOnboardingError: editorOnboardingError,
        privilegeError: privilegeError,
        isProductOrSiteAdmin: isProductOrSiteAdmin,
        queriesLoadingOrErrored: queriesLoadingOrErrored,
        hasQueryErrors: hasQueryErrors
    };
};
module.exports["useIncludeEditorTutorialTemplate"] = $13240525381ea71e$export$d18f171722e15763;

});

parcelRegister("aUp28", function(module, exports) {
/**
 * @generated SignedSource<<1469c48163eef1d6872c9ec34d9975f0>>
 * @relayHash b0859ec85298cdcc3abeeb1b76428f06
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 370ec9eee83808f99e9887355ed073323a91ceb9d4f67e1676c11d34f8e236d1
const $7b4771bbfec2ff2e$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        },
        {
            "kind": "ScalarField",
            "name": "isSiteAdmin"
        },
        {
            "kind": "ScalarField",
            "name": "hasUserAccessAdminRole"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useIncludeEditorTutorialTemplateGetUserPrivilegesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useIncludeEditorTutorialTemplateGetUserPrivilegesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "b0859ec85298cdcc3abeeb1b76428f06",
            "id": "370ec9eee83808f99e9887355ed073323a91ceb9d4f67e1676c11d34f8e236d1",
            "metadata": {},
            "name": "useIncludeEditorTutorialTemplateGetUserPrivilegesQuery",
            "operationKind": "query",
            "text": "query useIncludeEditorTutorialTemplateGetUserPrivilegesQuery{user:confluence_atlassianUser(current:true){id,confluence{operations{operation,targetType}}},isSiteAdmin,hasUserAccessAdminRole}"
        }
    };
}();
$7b4771bbfec2ff2e$var$node.hash = "f89395b5bfa711d4abb146bb5f205ba7";
var $7b4771bbfec2ff2e$export$2e2bcd8739ae039 = $7b4771bbfec2ff2e$var$node;
module.exports["default"] = $7b4771bbfec2ff2e$export$2e2bcd8739ae039;

});

parcelRegister("6KWXd", function(module, exports) {
/**
 * @generated SignedSource<<d0088fed8d9bb47d7856217380291ada>>
 * @relayHash 01fffd726d239a3885cdda05ee671cfc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5e63e2c8ebfdf4d965dba277c3c32a8a04deda6abf4222f96546f817f5440d4d
const $fe23f76b0dba2c1c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cql"
        }
    ], v1 = [
        {
            "alias": "search",
            "args": [
                {
                    "kind": "Variable",
                    "name": "cql",
                    "variableName": "cql"
                },
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 12
                }
            ],
            "concreteType": "ConfluenceSearchConnection",
            "kind": "LinkedField",
            "name": "confluence_search",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "count"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "isSiteAdmin"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIncludeEditorTutorialTemplateGetUserContentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIncludeEditorTutorialTemplateGetUserContentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "01fffd726d239a3885cdda05ee671cfc",
            "id": "5e63e2c8ebfdf4d965dba277c3c32a8a04deda6abf4222f96546f817f5440d4d",
            "metadata": {},
            "name": "useIncludeEditorTutorialTemplateGetUserContentQuery",
            "operationKind": "query",
            "text": "query useIncludeEditorTutorialTemplateGetUserContentQuery($cql:String!){search:confluence_search(cql:$cql,first:12){count},isSiteAdmin}"
        }
    };
}();
$fe23f76b0dba2c1c$var$node.hash = "faa88759211e6aba8a9b90c957005513";
var $fe23f76b0dba2c1c$export$2e2bcd8739ae039 = $fe23f76b0dba2c1c$var$node;
module.exports["default"] = $fe23f76b0dba2c1c$export$2e2bcd8739ae039;

});

parcelRegister("1JEqL", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $eJhXX = parcelRequire("eJhXX");


var $icMDs = parcelRequire("icMDs");

function $e18808c613ab8370$export$138f02318593ab4(queryData) {
    const userPrivilege = (0, $eJhXX.getUserPrivilegeFromQuery)(queryData);
    return userPrivilege === (0, $icMDs.UserPrivilege).PRODUCT_ADMIN || userPrivilege === (0, $icMDs.UserPrivilege).SITE_ADMIN;
}
module.exports["getIsProductOrSiteAdminFromQuery"] = $e18808c613ab8370$export$138f02318593ab4;

});

parcelRegister("eJhXX", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $fWkVZ = parcelRequire("fWkVZ");


var $w033M = parcelRequire("w033M");


var $icMDs = parcelRequire("icMDs");

function $a7000458c02582d2$export$d036114e4ad5c4c3(queryData) {
    const isSiteAdmin = (0, $w033M.getIsSiteAdminFromQuery)(queryData);
    const isProductAdmin = (0, $fWkVZ.getIsProductAdminFromQuery)(queryData);
    return typeof queryData === 'undefined' ? undefined : isSiteAdmin ? (0, $icMDs.UserPrivilege).SITE_ADMIN : isProductAdmin ? (0, $icMDs.UserPrivilege).PRODUCT_ADMIN : (0, $icMDs.UserPrivilege).NON_ADMIN;
}
module.exports["getUserPrivilegeFromQuery"] = $a7000458c02582d2$export$d036114e4ad5c4c3;

});

parcelRegister("fWkVZ", function(module, exports) {
const $b7fc105cb96f63fd$export$7ed4faccc7e85b7f = (queryData)=>Boolean(queryData?.user?.confluence?.operations?.some((o)=>o?.operation === 'administer' && o?.targetType === 'application'));
module.exports["getIsProductAdminFromQuery"] = $b7fc105cb96f63fd$export$7ed4faccc7e85b7f;

});

parcelRegister("icMDs", function(module, exports) {
var $296e2d91f769f195$export$fa8745fb6d256802 = /*#__PURE__*/ function(UserPrivilege) {
    UserPrivilege["NON_ADMIN"] = "nonAdmin";
    UserPrivilege["PRODUCT_ADMIN"] = "productAdmin";
    UserPrivilege["SITE_ADMIN"] = "siteAdmin";
    return UserPrivilege;
}({});
module.exports["UserPrivilege"] = $296e2d91f769f195$export$fa8745fb6d256802;

});

parcelRegister("u7mpJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");


var $dBcar = parcelRequire("dBcar");


var $ivb8S = parcelRequire("ivb8S");

const $f20decd2af09ad63$export$5ff0b879ab65d0b0 = 'd1';
const $f20decd2af09ad63$export$46c1c92549715335 = 'loading';
const $f20decd2af09ad63$export$61c0af74ec47d243 = 'd0';
const $f20decd2af09ad63$export$f883a24d5edde77c = 'none';
const $f20decd2af09ad63$var$CREATION_FOCUSED_NAV_DELAY_MINUTES = 1440; // 1440 minutes (24 hours)
const $f20decd2af09ad63$export$b23a5dfe95342477 = (updateState = false)=>{
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const delayInMinutes = $f20decd2af09ad63$var$CREATION_FOCUSED_NAV_DELAY_MINUTES;
    const hasUpdatedState = (0, $cozmU.useRef)(false);
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)(// eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $9wGTI.fg)('cc_activation_simplify_nav_preloader_enabled') ? (0, $9wGTI.fg)('cfind_5565_creation_focused_nav_xflow_preload') ? [
        ...(0, $dBcar.NAV_EXPERIMENT_ONBOARDING_KEYS),
        (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).CHECKED_ELIGIBLE,
        (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).START_AT
    ] : [
        ...(0, $dBcar.NAV_EXPERIMENT_ONBOARDING_KEYS)
    ] : [
        (0, $dBcar.CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT),
        (0, $dBcar.CREATION_FOCUSED_NAV_START_TIME)
    ]);
    const spotlightShown = ()=>{
        setOnboardingState({
            key: (0, $dBcar.CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT),
            value: 'false'
        });
    };
    if (onboardingStateLoading) // Simplify nav and hide banners while loading, to minimize flashing
    return {
        isSpotlightVisible: false,
        areBannersHidden: true,
        navCustomization: $f20decd2af09ad63$export$46c1c92549715335
    };
    if (onboardingStateError) // Fallback behavior if there are any errors
    return {
        isSpotlightVisible: false,
        areBannersHidden: false,
        navCustomization: $f20decd2af09ad63$export$f883a24d5edde77c
    };
    const { shouldShowSpotlight: shouldShowSpotlight, startTime: startTime } = (0, $ivb8S.deserializeState)(onboardingStateData);
    if ($f20decd2af09ad63$var$isSiteOlderThanDelay(delayInMinutes, startTime)) {
        if (shouldShowSpotlight) // Spotlight ready to show --> Show spotlight, bring nav features back, but don't bring banners back
        return {
            isSpotlightVisible: true,
            areBannersHidden: true,
            navCustomization: $f20decd2af09ad63$export$5ff0b879ab65d0b0,
            onSpotlightShown: spotlightShown
        };
        else if (shouldShowSpotlight === false) // Spotlight has already shown --> Don't show spotlight, bring nav features back, but don't bring banners back
        return {
            isSpotlightVisible: false,
            areBannersHidden: true,
            navCustomization: $f20decd2af09ad63$export$5ff0b879ab65d0b0
        };
        // This account was created before the feature was enabled, so we won't change anything
        return {
            isSpotlightVisible: false,
            areBannersHidden: false,
            navCustomization: $f20decd2af09ad63$export$f883a24d5edde77c
        };
    } else if (shouldShowSpotlight === undefined && updateState && !hasUpdatedState.current) {
        hasUpdatedState.current = true;
        setOnboardingState({
            key: (0, $dBcar.CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT),
            value: 'true'
        });
    }
    return {
        isSpotlightVisible: false,
        areBannersHidden: true,
        navCustomization: $f20decd2af09ad63$export$61c0af74ec47d243
    };
};
const $f20decd2af09ad63$var$isSiteOlderThanDelay = (delayInMinutes, siteActivationDateString)=>{
    if (!siteActivationDateString) return true; // If site has no activation date, assume it is old
    const siteActivationDateNumber = Number(siteActivationDateString);
    const siteActivationDate = new Date(siteActivationDateNumber ?? '');
    if (isNaN(siteActivationDate.getTime())) return true; // If site has no activation date, assume it is old
    const createdAtTimestamp = siteActivationDate.getTime();
    const millisecondsSinceCreation = Date.now() - createdAtTimestamp;
    const secondsPerMinute = 60;
    const millisecondsPerSecond = 1000;
    const millisecondsInDelayTime = delayInMinutes * secondsPerMinute * millisecondsPerSecond;
    return millisecondsSinceCreation > millisecondsInDelayTime;
};
module.exports["d1"] = $f20decd2af09ad63$export$5ff0b879ab65d0b0;
module.exports["loading"] = $f20decd2af09ad63$export$46c1c92549715335;
module.exports["d0"] = $f20decd2af09ad63$export$61c0af74ec47d243;
module.exports["useCreationFocusedNavLand"] = $f20decd2af09ad63$export$b23a5dfe95342477;

});

parcelRegister("41KFX", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $dBcar = parcelRequire("dBcar");


var $ivb8S = parcelRequire("ivb8S");


var $6Dfc9 = parcelRequire("6Dfc9");


var $879OR = parcelRequire("879OR");

const $73d6907ec9f8e642$export$fce5991a3cbd7c5a = new Set([
    'default-templates',
    'pin-templates'
]);
const $73d6907ec9f8e642$var$DEFAULT_RESULT = {
    navStyle: 'control',
    isWithinD0: false,
    source: null
};
function $73d6907ec9f8e642$export$9e39472fc9788dd0() {
    if ((0, $9wGTI.fg)('cfind_5565_creation_focused_nav_xflow_preload')) return [
        ...(0, $dBcar.NAV_EXPERIMENT_ONBOARDING_KEYS),
        (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).CHECKED_ELIGIBLE,
        (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).START_AT
    ];
    return [
        ...(0, $dBcar.NAV_EXPERIMENT_ONBOARDING_KEYS)
    ];
}
const $73d6907ec9f8e642$export$aed714501b2c585 = ()=>{
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)($73d6907ec9f8e642$export$9e39472fc9788dd0(), !(0, $9wGTI.fg)('cc_activation_simplify_nav_preloader_enabled'));
    const { isEligible: isEligibleForSimplifyNavXflow, isLoading: isLoadingIsEligibleForSimplifyNavXflow, hasError: hasEligibleForSimplifyNavXflowError, isWithinD0Window: isWithinD0WindowForSimplifyNavXflow } = (0, $879OR.useIsEligibleForSimplifyNavXflow)({
        onboardingStateData: onboardingStateData,
        onboardingStateLoading: onboardingStateLoading,
        onboardingStateError: onboardingStateError,
        skip: !(0, $9wGTI.fg)('cfind_5565_creation_focused_nav_xflow_preload')
    });
    if (onboardingStateLoading) {
        if ((0, $9wGTI.fg)('cc_activation_simplify_nav_preloader_enabled')) return {
            navStyle: 'loading',
            isWithinD0: false,
            source: null
        };
        return $73d6907ec9f8e642$var$DEFAULT_RESULT;
    }
    if (onboardingStateError) return $73d6907ec9f8e642$var$DEFAULT_RESULT;
    const entries = onboardingStateData?.onboardingState;
    if (!entries) return $73d6907ec9f8e642$var$DEFAULT_RESULT;
    const eligibleEntry = entries.find((s)=>s.key === (0, $dBcar.SIMPLIFY_NAV_NEW_USER).NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE);
    if (eligibleEntry?.value !== 'true') {
        // Not eligible for new user experiment, but might be for xflow.
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $9wGTI.fg)('cfind_5565_creation_focused_nav_xflow_preload')) {
            if (isLoadingIsEligibleForSimplifyNavXflow) // This may happen if TAP traits are loading, although they should generally be preloaded.
            // Case of onboarding state loading is handled in previous conditionals.
            return {
                navStyle: 'loading',
                isWithinD0: false,
                source: null
            };
            if (hasEligibleForSimplifyNavXflowError) return $73d6907ec9f8e642$var$DEFAULT_RESULT;
            if (isEligibleForSimplifyNavXflow) {
                const navStyle = (0, $6mKj3.expVal)('cfind_5565_creation_focused_nav_xflow', 'cohort', 'control');
                if ($73d6907ec9f8e642$export$fce5991a3cbd7c5a.has(navStyle)) return {
                    navStyle: navStyle,
                    isWithinD0: isWithinD0WindowForSimplifyNavXflow,
                    source: 'xflow'
                };
            }
        }
        return $73d6907ec9f8e642$var$DEFAULT_RESULT;
    }
    const navStyle = (0, $6mKj3.expVal)('cc_activation_simplify_nav_new_user', 'cohort', 'control');
    if (!$73d6907ec9f8e642$export$fce5991a3cbd7c5a.has(navStyle)) return $73d6907ec9f8e642$var$DEFAULT_RESULT;
    const startAtEntry = entries.find((s)=>s.key === (0, $dBcar.SIMPLIFY_NAV_NEW_USER).NTH_USER_D0_SIMPLIFIED_NAV_START_AT);
    return {
        navStyle: navStyle,
        isWithinD0: (0, $6Dfc9.isWithinD0Window)(startAtEntry?.value),
        source: 'new-user'
    };
};
module.exports["TREATMENT_COHORTS"] = $73d6907ec9f8e642$export$fce5991a3cbd7c5a;
module.exports["useSimplifiedNavNewUsers"] = $73d6907ec9f8e642$export$aed714501b2c585;

});

parcelRegister("6Dfc9", function(module, exports) {

var $bg9GW = parcelRequire("bg9GW");

var $esV19 = parcelRequire("esV19");

var $k5sGX = parcelRequire("k5sGX");

function $e250b9cfd6dd2931$export$46cbbdfdd4d2fcb(isoTimestamp) {
    if (!isoTimestamp) return false;
    const parsed = (0, $k5sGX.default)(isoTimestamp);
    return (0, $esV19.default)(parsed) && (0, $bg9GW.default)(new Date(), parsed) < 24;
}
function $e250b9cfd6dd2931$export$193a557a4d23c9aa(epochMs) {
    const date = new Date(epochMs);
    return (0, $esV19.default)(date) && (0, $bg9GW.default)(new Date(), date) < 24;
}
module.exports["isWithinD0Window"] = $e250b9cfd6dd2931$export$46cbbdfdd4d2fcb;

});

parcelRegister("879OR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $kOUwv = parcelRequire("kOUwv");


var $dBcar = parcelRequire("dBcar");


var $ivb8S = parcelRequire("ivb8S");


var $1KHQh = parcelRequire("1KHQh");


var $6Dfc9 = parcelRequire("6Dfc9");

const $1f55678574e67c8a$var$FIRST_ACTIVATION_DATE_TRAIT = 'firstActivationDate';
// Use a module-level variable to ensure the effect only fires once per app lifecycle,
// even if the hook is called from multiple places simultaneously.
let $1f55678574e67c8a$var$hasRunEffect = false;
function $1f55678574e67c8a$export$5b324fbcfda94020() {
    $1f55678574e67c8a$var$hasRunEffect = false;
}
const $1f55678574e67c8a$export$bbe7d46982302b03 = ({ onboardingStateData: onboardingStateData, onboardingStateLoading: onboardingStateLoading, onboardingStateError: onboardingStateError, skip: skip })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    const { data: siteTraitsData, loading: siteTraitsDataLoading, error: siteTraitsDataError } = (0, $kOUwv.useSiteTraits)({
        skipBootstrap: skip
    });
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const entries = onboardingStateData?.onboardingState;
    const isInCfindLandCreationFocusedNavExperiment = !!entries?.find((s)=>s.key === (0, $dBcar.CREATION_FOCUSED_NAV_START_TIME))?.value;
    const isInActivationExperiment = entries?.find(({ key: key })=>key === (0, $dBcar.SIMPLIFY_NAV_NEW_USER).NTH_USER_D0_SIMPLIFIED_NAV_ELIGIBLE)?.value === 'true';
    const isOnboardingStateForExperimentSet = entries?.find(({ key: key })=>key === (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).CHECKED_ELIGIBLE)?.value === 'true';
    const xflowStartAt = entries?.find(({ key: key })=>key === (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).START_AT)?.value;
    // We checked the user's eligibility at one point and determined they were not in treatment.
    const isReturningControlUser = isOnboardingStateForExperimentSet && !xflowStartAt;
    // A user who already has a START_AT recorded is a returning enrolled user and is always eligible.
    const isReturningEnrolledUser = !!xflowStartAt;
    const siteActivationDateTrait = siteTraitsData?.attributes?.find(({ name: name })=>name === $1f55678574e67c8a$var$FIRST_ACTIVATION_DATE_TRAIT)?.value;
    // TAP site traits data is only needed when the user might be a first-time eligible user.
    // If onboarding state alone can determine eligibility, don't wait for TAP data to load —
    // this avoids an unnecessary loading state that hides navigation items.
    const canDetermineWithoutTap = skip || !hasLicensedAccess || isInCfindLandCreationFocusedNavExperiment || isInActivationExperiment || isReturningControlUser || isReturningEnrolledUser;
    const isLoading = !!(onboardingStateLoading || !canDetermineWithoutTap && siteTraitsDataLoading);
    const hasError = !!(onboardingStateError || !canDetermineWithoutTap && siteTraitsDataError);
    // A new user is eligible if their site's firstActivationDate is non-null and
    // after the experiment start date. Returning enrolled users are always eligible.
    const isSiteActivationAfterExperimentStart = ()=>{
        if (!siteActivationDateTrait) return false;
        const experimentStartDate = (0, $1KHQh.getXflowExperimentStartDate)();
        if (!experimentStartDate) return false;
        try {
            return new Date(siteActivationDateTrait) >= experimentStartDate;
        } catch  {
            return false;
        }
    };
    const isEligible = !skip && !isLoading && !hasError && hasLicensedAccess && !isInCfindLandCreationFocusedNavExperiment && !isInActivationExperiment && !isReturningControlUser && (isReturningEnrolledUser || isSiteActivationAfterExperimentStart());
    (0, $cozmU.useEffect)(()=>{
        if (!isEligible || isOnboardingStateForExperimentSet || $1f55678574e67c8a$var$hasRunEffect) return;
        $1f55678574e67c8a$var$hasRunEffect = true;
        if ((0, $6mKj3.expValEquals)('cfind_5565_creation_focused_nav_xflow', 'cohort', 'pin-templates')) setOnboardingState([
            {
                key: (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).CHECKED_ELIGIBLE,
                value: 'true'
            },
            {
                key: (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).START_AT,
                value: new Date().toISOString()
            }
        ]);
        else setOnboardingState({
            key: (0, $dBcar.CFIND_5565_CREATION_FOCUSED_NAV_XFLOW).CHECKED_ELIGIBLE,
            value: 'true'
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'eligible',
                actionSubject: 'cfind-5565-simplify-nav-xflow',
                actionSubjectId: 'cfind-5565-simplify-nav-xflow',
                source: 'cfind-5565-simplify-nav-xflow',
                attributes: {
                    siteActivationDate: siteActivationDateTrait
                }
            }
        }).fire();
    }, [
        isEligible,
        isOnboardingStateForExperimentSet,
        setOnboardingState,
        siteActivationDateTrait,
        createAnalyticsEvent
    ]);
    return {
        isLoading: isLoading,
        hasError: hasError,
        isEligible: isEligible,
        // For returning enrolled users, use their START_AT timestamp to determine if they're
        // within the D0 window. For first-time users (no START_AT yet), they're implicitly
        // within their D0 window if and only if they're eligible.
        isWithinD0Window: xflowStartAt ? (0, $6Dfc9.isWithinD0Window)(xflowStartAt) : isEligible
    };
};
module.exports["useIsEligibleForSimplifyNavXflow"] = $1f55678574e67c8a$export$bbe7d46982302b03;

});

parcelRegister("1KHQh", function(module, exports) {
// eslint-disable-next-line confluence-feature-gating/unsafe-no-exposure

var $6mKj3 = parcelRequire("6mKj3");

/**
 * Reads the experimentStartDate param from the cfind_5565_creation_focused_nav_xflow
 * experiment config without firing an exposure. Falls back to 2026-05-07 (the gate
 * rollout date) if the param is missing. Returns null only if the value is not a valid date.
 */ // eslint-disable-next-line confluence-feature-gating/unsafe-no-exposure
const $47ca1d22622dd352$var$XFLOW_EXPERIMENT_START_DATE_FALLBACK = '2026-05-07';
const $47ca1d22622dd352$export$9aeee5d7687bf679 = ()=>{
    // eslint-disable-next-line confluence-feature-gating/unsafe-no-exposure
    const [expConfig] = (0, $6mKj3.UNSAFE_noExposureExp)('cfind_5565_creation_focused_nav_xflow'); // Experiment exposure is fired elsewhere
    const rawValue = expConfig.get('experimentStartDate', $47ca1d22622dd352$var$XFLOW_EXPERIMENT_START_DATE_FALLBACK);
    const date = new Date(rawValue);
    return isNaN(date.getTime()) ? null : date;
};
module.exports["getXflowExperimentStartDate"] = $47ca1d22622dd352$export$9aeee5d7687bf679;

});

parcelRegister("eLnQS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");

const $5e22f724447894e7$export$367f35882b7b4a5b = ()=>{
    // IMPORTANT: If you add a new feature flag here, please make sure to add it to the
    // `featureFlagsPluginOptions` function in 'packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/featureFlagsPluginOptions.ts`.
    return (0, $cozmU.useMemo)(()=>({
            'table-drag-and-drop': (0, $6mKj3.expVal)('platform_editor_tables_drag_and_drop', 'isEnabled', false),
            'table-selector': (0, $6mKj3.expVal)('platform_editor_tables_table_selector', 'isEnabled', false),
            'macro-interaction-updates': true,
            'table-with-fixed-column-widths-option': true,
            'more-elements-in-quick-insert-view': true
        }), []);
};
module.exports["useEditorFullPageExperiments"] = $5e22f724447894e7$export$367f35882b7b4a5b;

});

parcelRegister("7vJCW", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $3bfd7e130592105d$export$18f927573c4993d5 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-VTjB",
    name: "EditorBreadcrumbs",
    loader: async ()=>{
        const { EditorBreadcrumbsComponent: EditorBreadcrumbsComponent } = await (parcelRequire("eaUY8"));
        return EditorBreadcrumbsComponent;
    }
});
module.exports["EditorBreadcrumbs"] = $3bfd7e130592105d$export$18f927573c4993d5;

});

parcelRegister("eaUY8", function(module, exports) {

let $a51e30b72dcb800d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a51e30b72dcb800d$var$load("bYzij"),
    $a51e30b72dcb800d$var$load("6wr18"),
    $a51e30b72dcb800d$var$load("1xRFJ"),
    $a51e30b72dcb800d$var$load("7EorR"),
    $a51e30b72dcb800d$var$load("8zMmc"),
    $a51e30b72dcb800d$var$load("el56J"),
    $a51e30b72dcb800d$var$load("ffEVr"),
    $a51e30b72dcb800d$var$load("lbsQO"),
    $a51e30b72dcb800d$var$load("ayJxT"),
    $a51e30b72dcb800d$var$load("hhss7"),
    $a51e30b72dcb800d$var$load("aIkc8")
]).then(()=>parcelRequire('aNZDi'));

});

parcelRegister("5RPbY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $9ee3ba3f5fa2cebc$export$b00e22884b6dd9a = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1hM5R",
    name: "EditorAppearanceButtonNext",
    loader: async ()=>{
        const { EditorAppearanceButtonNext: EditorAppearanceButtonNext } = await (parcelRequire("hjkJu"));
        return EditorAppearanceButtonNext;
    }
});
module.exports["EditorAppearanceButtonNext"] = $9ee3ba3f5fa2cebc$export$b00e22884b6dd9a;

});

parcelRegister("hjkJu", function(module, exports) {

let $c9a44b14995a6dfa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c9a44b14995a6dfa$var$load("6wr18"),
    $c9a44b14995a6dfa$var$load("dlm6q"),
    $c9a44b14995a6dfa$var$load("ffEVr"),
    $c9a44b14995a6dfa$var$load("7EorR"),
    $c9a44b14995a6dfa$var$load("8zMmc"),
    $c9a44b14995a6dfa$var$load("7GtpA")
]).then(()=>parcelRequire('Vjn6T'));

});

parcelRegister("9iTNj", function(module, exports) {
/* TitleAreaContentComponents.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $jmjWc = parcelRequire("jmjWc");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $554a9c527b7ebc79$var$EmptyTitleArea = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTemplateEditor: isTemplateEditor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1bsb1osq",
            __cmplp.isTemplateEditor ? "_4t3ibi2l" : "_4t3i1nlq",
            __cmplp.className
        ])
    });
});

const $554a9c527b7ebc79$export$24c87f0cb1dfb811 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-4zEr",
    name: "TitleAreaContentComponents",
    loader: async ()=>(await (parcelRequire("2IZb9"))).TitleAreaContentComponents,
    loading: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($554a9c527b7ebc79$var$EmptyTitleArea, {
            isTemplateEditor: props.isTemplateEditor
        })
});

const $554a9c527b7ebc79$export$94a078f0640d9238 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "JPi6Y",
    name: "SmartCreateTitleAreaContentComponents",
    loader: async ()=>(await (parcelRequire("98OV2"))).SmartCreateTitleAreaContentComponents,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($554a9c527b7ebc79$var$EmptyTitleArea, null)
});
module.exports["TitleAreaContentComponents"] = $554a9c527b7ebc79$export$24c87f0cb1dfb811;

});

parcelRegister("2IZb9", function(module, exports) {

let $1fbf25b19a30b613$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1fbf25b19a30b613$var$load("houtd"),
    $1fbf25b19a30b613$var$load("6HpsR"),
    $1fbf25b19a30b613$var$load("N3oqb"),
    $1fbf25b19a30b613$var$load("hZ2FX"),
    $1fbf25b19a30b613$var$load("6wr18"),
    $1fbf25b19a30b613$var$load("h7PET"),
    $1fbf25b19a30b613$var$load("dlm6q"),
    $1fbf25b19a30b613$var$load("ffEVr"),
    $1fbf25b19a30b613$var$load("dtpmo"),
    $1fbf25b19a30b613$var$load("gLFJS"),
    $1fbf25b19a30b613$var$load("35X59"),
    $1fbf25b19a30b613$var$load("idSqX"),
    $1fbf25b19a30b613$var$load("iWnyc"),
    $1fbf25b19a30b613$var$load("cmmpX"),
    $1fbf25b19a30b613$var$load("7EorR"),
    $1fbf25b19a30b613$var$load("8zMmc"),
    $1fbf25b19a30b613$var$load("el56J"),
    $1fbf25b19a30b613$var$load("guVy6"),
    $1fbf25b19a30b613$var$load("3kVph"),
    $1fbf25b19a30b613$var$load("aIddG"),
    $1fbf25b19a30b613$var$load("jZMUd"),
    $1fbf25b19a30b613$var$load("kFiBp"),
    $1fbf25b19a30b613$var$load("daX4F"),
    $1fbf25b19a30b613$var$load("hhss7"),
    $1fbf25b19a30b613$var$load("bYzij"),
    $1fbf25b19a30b613$var$load("hbc6v")
]).then(()=>parcelRequire('bbYj5'));

});

parcelRegister("98OV2", function(module, exports) {

let $6a7c5bdee9fcb146$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6a7c5bdee9fcb146$var$load("houtd"),
    $6a7c5bdee9fcb146$var$load("6HpsR"),
    $6a7c5bdee9fcb146$var$load("N3oqb"),
    $6a7c5bdee9fcb146$var$load("6wr18"),
    $6a7c5bdee9fcb146$var$load("h7PET"),
    $6a7c5bdee9fcb146$var$load("dlm6q"),
    $6a7c5bdee9fcb146$var$load("ffEVr"),
    $6a7c5bdee9fcb146$var$load("gLFJS"),
    $6a7c5bdee9fcb146$var$load("35X59"),
    $6a7c5bdee9fcb146$var$load("idSqX"),
    $6a7c5bdee9fcb146$var$load("cmmpX"),
    $6a7c5bdee9fcb146$var$load("7EorR"),
    $6a7c5bdee9fcb146$var$load("8zMmc"),
    $6a7c5bdee9fcb146$var$load("el56J"),
    $6a7c5bdee9fcb146$var$load("3kVph"),
    $6a7c5bdee9fcb146$var$load("jZMUd"),
    $6a7c5bdee9fcb146$var$load("hhss7"),
    $6a7c5bdee9fcb146$var$load("bYzij"),
    $6a7c5bdee9fcb146$var$load("dUTj8")
]).then(()=>parcelRequire('fKhxN'));

});

parcelRegister("gjEAi", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $44846349058524ee$export$9e2285f96d44792b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Swb7P",
    name: 'ApprovalBannerLoadable',
    loader: async ()=>(await (parcelRequire("4Fj7F"))).ApprovalBanner
});
module.exports["ApprovalBanner"] = $44846349058524ee$export$9e2285f96d44792b;

});

parcelRegister("4Fj7F", function(module, exports) {

let $3659d31ae85dd569$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3659d31ae85dd569$var$load("35X59"),
    $3659d31ae85dd569$var$load("guVy6"),
    $3659d31ae85dd569$var$load("8gmaR")
]).then(()=>parcelRequire('hbQeG'));

});

parcelRegister("38qvz", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $kqIWy = parcelRequire("kqIWy");

const $f0e4954369e4b2a4$export$6c92cd4e39d5997c = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { spaceKey: spaceKey } = t0;
    const { data: spaceData } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const t1 = spaceData?.type;
    const t2 = spaceData?.type === "knowledge_base";
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = {
            spaceType: t1,
            isKnowledgeBaseSpace: t2
        };
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    return t3;
} : ({ spaceKey: spaceKey })=>{
    const { data: spaceData } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    return {
        spaceType: spaceData?.type,
        isKnowledgeBaseSpace: spaceData?.type === 'knowledge_base'
    };
};
module.exports["useSpaceType"] = $f0e4954369e4b2a4$export$6c92cd4e39d5997c;

});

parcelRegister("bMPhU", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $7SV4J = parcelRequire("7SV4J");


var $ep3mz = parcelRequire("ep3mz");


var $jMyy4 = parcelRequire("jMyy4");

const $337a96ad81fe0f87$export$a1e0cd72fc64ef6 = (spaceKey)=>{
    const $ = (0, $bDgLe.c)(5);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    spaceKey = spaceKey ?? pageContextSpaceKey;
    let t0;
    if ($[0] !== spaceKey) {
        t0 = {
            spaceKey: spaceKey
        };
        $[0] = spaceKey;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = !spaceKey;
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
        t2 = {
            variables: t0,
            skip: t1
        };
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $7SV4J.default), {
        ...t2,
        __callerPackage__: "space-utils"
    });
    return data?.space?.homepage?.id || undefined;
};
module.exports["useSpaceHomepageId"] = $337a96ad81fe0f87$export$a1e0cd72fc64ef6;

});

parcelRegister("7SV4J", function(module, exports) {
/**
 * @generated SignedSource<<9c89aa0352f7d1dca5a5a1271100cc40>>
 * @relayHash be53943df43514309a4d7c908c1c0fa2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5
const $6972c51ac50ce9bf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                },
                v1 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "be53943df43514309a4d7c908c1c0fa2",
            "id": "7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5",
            "metadata": {},
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "operationKind": "query",
            "text": "query useSpaceHomepageIdSpaceHomepageIdQuery($spaceKey:String){space(key:$spaceKey){homepage{id},id}}"
        }
    };
}();
$6972c51ac50ce9bf$var$node.hash = "008609f21691e19f9c101d43e2e78e81";
var $6972c51ac50ce9bf$export$2e2bcd8739ae039 = $6972c51ac50ce9bf$var$node;
module.exports["default"] = $6972c51ac50ce9bf$export$2e2bcd8739ae039;

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $bDgLe.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $cozmU.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("j5cB3", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $IQ4Dz = parcelRequire("IQ4Dz");


const $43c705326a57355f$export$c720381daa58fcbb = ()=>{
    const $ = (0, $bDgLe.c)(2);
    const adsTheme = (0, $IQ4Dz.default)();
    let t0;
    if ($[0] !== adsTheme) {
        t0 = adsTheme;
        $[0] = adsTheme;
        $[1] = t0;
    } else t0 = $[1];
    const effectiveTheme = t0;
    return effectiveTheme?.colorMode === "dark";
};
module.exports["useIsDarkMode"] = $43c705326a57355f$export$c720381daa58fcbb;

});

parcelRegister("mr7nI", function(module, exports) {
$parcel$export(module.exports, "default", () => $0437174526e2cd74$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $0437174526e2cd74$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var dateToCompare = (0, $dkBOe.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("7LI3Q", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $02289dc82bb02982$export$55152de1f925fd05 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '401');
module.exports["isUnauthorizedError"] = $02289dc82bb02982$export$55152de1f925fd05;

});

parcelRegister("lrMxq", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7boqA = parcelRequire("7boqA");


var $jmjWc = parcelRequire("jmjWc");


var $fgdVB = parcelRequire("fgdVB");


const $172892494f392667$var$ObjectSidebarControlLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "liSnz",
    name: "ObjectSidebarControlLoader",
    loader: async ()=>(await (parcelRequire("1KJyY"))).ObjectSidebarControl
});
const $172892494f392667$export$3fab07431350539e = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
            metric: (0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC)
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($172892494f392667$var$ObjectSidebarControlLoader, props));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
        metric: (0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($172892494f392667$var$ObjectSidebarControlLoader, props));
module.exports["ObjectSidebarControl"] = $172892494f392667$export$3fab07431350539e;

});

parcelRegister("7boqA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $l6Cdg = parcelRequire("l6Cdg");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $18R9N = parcelRequire("18R9N");

const $e6e452b898a1ec38$var$noop = ()=>{};
const $e6e452b898a1ec38$var$EMBEDDED_PREFIX = 'embedded-';
const $e6e452b898a1ec38$var$PageSegmentLoadStartComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { onComplete: onComplete = $e6e452b898a1ec38$var$noop, timing: timing = (0, $N1nBh.ActionTiming).RENDER_BODY } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of PageSegmentLoadStartProps guarantees that exactly one of
    // `metricKey` or `metric` is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$e6e452b898a1ec38$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const handleSegmentLoadStart = (0, $cozmU.useCallback)(()=>{
        (0, $l6Cdg.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${prefixedKey}`);
        onComplete();
    }, [
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadStart, timing);
    return null;
});
const $e6e452b898a1ec38$export$f11db193fdaffcc9 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($e6e452b898a1ec38$var$PageSegmentLoadStartComponent);
module.exports["PageSegmentLoadStart"] = $e6e452b898a1ec38$export$f11db193fdaffcc9;

});

parcelRegister("N1nBh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
   * This will perform the given action at a scheduled time after the
   * component has painted.
   *
   * This is the default behavior.
   */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
   * This will perform the given action at the next animation frame (after the
   * component has been painted).
   */ ActionTiming["PAINT"] = "PAINT";
    /**
   * This will perform the given action at the moment its render function
   * fires.
   *
   * NOTE: This is called _within_ the render body, making it unpure. The
   * component is memoized, so it will fire this only once for a given set
   * of props. Be careful when using this, since it is unsafe.
   */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $cozmU.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $cozmU.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};
module.exports["ActionTiming"] = $4fef2d066feab689$export$6a673e74e98cdf55;
module.exports["usePerformanceAction"] = $4fef2d066feab689$export$454639fd58f598bd;

});

parcelRegister("18R9N", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6b4f0c0629e8427f$export$fda153f959d0066f = /*#__PURE__*/ (0, $cozmU.createContext)(false);
const $6b4f0c0629e8427f$export$b6c7102a78eb7f7f = ()=>(0, $cozmU.useContext)($6b4f0c0629e8427f$export$fda153f959d0066f);
module.exports["EmbeddedConfluenceTrackingContext"] = $6b4f0c0629e8427f$export$fda153f959d0066f;
module.exports["useIsEmbeddedTracking"] = $6b4f0c0629e8427f$export$b6c7102a78eb7f7f;

});

parcelRegister("1KJyY", function(module, exports) {

let $146d6e3590ce7e04$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $146d6e3590ce7e04$var$load("4W6oq"),
    $146d6e3590ce7e04$var$load("1bT50"),
    $146d6e3590ce7e04$var$load("jgxNN"),
    $146d6e3590ce7e04$var$load("icfaw"),
    $146d6e3590ce7e04$var$load("ig9dh"),
    $146d6e3590ce7e04$var$load("hA8hA"),
    $146d6e3590ce7e04$var$load("6wr18"),
    $146d6e3590ce7e04$var$load("hVgF8"),
    $146d6e3590ce7e04$var$load("iw9z8"),
    $146d6e3590ce7e04$var$load("kfogw"),
    $146d6e3590ce7e04$var$load("kujst"),
    $146d6e3590ce7e04$var$load("7Vdd5"),
    $146d6e3590ce7e04$var$load("3fdX4"),
    $146d6e3590ce7e04$var$load("bb3WM"),
    $146d6e3590ce7e04$var$load("jdmfD"),
    $146d6e3590ce7e04$var$load("i3R6S"),
    $146d6e3590ce7e04$var$load("l1HBI"),
    $146d6e3590ce7e04$var$load("1ZFzv"),
    $146d6e3590ce7e04$var$load("hSDwk"),
    $146d6e3590ce7e04$var$load("b0ARW"),
    $146d6e3590ce7e04$var$load("diMTQ"),
    $146d6e3590ce7e04$var$load("aMUi4"),
    $146d6e3590ce7e04$var$load("7oMW2"),
    $146d6e3590ce7e04$var$load("fGNCf"),
    $146d6e3590ce7e04$var$load("k6TzV"),
    $146d6e3590ce7e04$var$load("iN26T"),
    $146d6e3590ce7e04$var$load("bSZcP"),
    $146d6e3590ce7e04$var$load("7EorR"),
    $146d6e3590ce7e04$var$load("8GFi1"),
    $146d6e3590ce7e04$var$load("gy5DL"),
    $146d6e3590ce7e04$var$load("hOaAV"),
    $146d6e3590ce7e04$var$load("66GvX"),
    $146d6e3590ce7e04$var$load("1qlDN"),
    $146d6e3590ce7e04$var$load("1yVM6"),
    $146d6e3590ce7e04$var$load("dxcsb"),
    $146d6e3590ce7e04$var$load("99ObF"),
    $146d6e3590ce7e04$var$load("fINdN"),
    $146d6e3590ce7e04$var$load("6XCf4"),
    $146d6e3590ce7e04$var$load("ekVH8"),
    $146d6e3590ce7e04$var$load("ffEVr"),
    $146d6e3590ce7e04$var$load("aRRyd"),
    $146d6e3590ce7e04$var$load("hHIPg")
]).then(()=>parcelRequire('lVF98'));

});

parcelRegister("gAcLU", function(module, exports) {

var $lTECB = parcelRequire("lTECB");


var $9wGTI = parcelRequire("9wGTI");

const $162d85f7d3762fcf$export$4ac233f7b686bff9 = 'allowRovoSystemSpace';
const $162d85f7d3762fcf$export$736f471ffe80ff46 = ({ isEditorPage: isEditorPage, location: location })=>{
    if (isEditorPage || !location || !(0, $9wGTI.fg)('confluence_frontend_allow_embedded_rovo_space_view')) return false;
    const locationWithSearch = {
        search: location.search ?? ''
    };
    if (!(0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)(locationWithSearch)) return false;
    return new URLSearchParams(locationWithSearch.search).has($162d85f7d3762fcf$export$4ac233f7b686bff9);
};
module.exports["isEmbeddedRovoSystemSpaceAccessAllowed"] = $162d85f7d3762fcf$export$736f471ffe80ff46;

});

parcelRegister("8Psje", function(module, exports) {
const $5c0c9a15440579bc$export$fb74cd09fc20f0c3 = (spaceKey)=>{
    if (!spaceKey) return false;
    return spaceKey.startsWith('~ROVO') && spaceKey.endsWith('~');
};
module.exports["isRovoSystemSpaceKey"] = $5c0c9a15440579bc$export$fb74cd09fc20f0c3;

});

parcelRegister("wtSEP", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $251dbde4d6244b59$export$271f9f08425019c7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "pM5to",
    name: "NotFound",
    loader: async ()=>// eslint-disable-next-line
        (await (parcelRequire("3vgBg"))).NotFound
});
module.exports["NotFound"] = $251dbde4d6244b59$export$271f9f08425019c7;

});

parcelRegister("3vgBg", function(module, exports) {

let $28d124cb44ea2931$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $28d124cb44ea2931$var$load("k0Z8C"),
    $28d124cb44ea2931$var$load("85Ack"),
    $28d124cb44ea2931$var$load("7EorR"),
    $28d124cb44ea2931$var$load("hhss7"),
    $28d124cb44ea2931$var$load("gEi5K")
]).then(()=>parcelRequire('3nvKi'));

});

parcelRegister("essql", function(module, exports) {

var $hG1iq = parcelRequire("hG1iq");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $4L9ve = parcelRequire("4L9ve");


var $8i27m = parcelRequire("8i27m");


var $aUU0C = parcelRequire("aUU0C");


var $bQm3c = parcelRequire("bQm3c");


var $8WQTF = parcelRequire("8WQTF");


var $htsj6 = parcelRequire("htsj6");


var $aqBZ0 = parcelRequire("aqBZ0");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $6fil2 = parcelRequire("6fil2");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $fHAwL = parcelRequire("fHAwL");


var $d3bcC = parcelRequire("d3bcC");


var $9nXVV = parcelRequire("9nXVV");


var $3bH25 = parcelRequire("3bH25");


var $9SEzS = parcelRequire("9SEzS");


var $e4kZB = parcelRequire("e4kZB");

const $2524304961e9b056$var$MAX_UNREAD_COMMENTS_SUPPORTED = 1000;
const $2524304961e9b056$var$unreadCommentsQuery = (0, $hG1iq.default);
const $2524304961e9b056$export$3c5a4187b7dbe412 = ({ pageId: pageId, pageContentTypeProps: pageContentTypeProps, onCommentRead: onCommentRead })=>{
    const [{ isUpdatingUnreadComments: isUpdatingUnreadComments }, { setIsUpdatingUnreadComments: setIsUpdatingUnreadComments, setIsUnreadQueryLoading: setIsUnreadQueryLoading, updateUnreadCommentIDSet: updateUnreadCommentIDSet, setShouldClearVisibleThreads: setShouldClearVisibleThreads }] = (0, $fHAwL.useUnreadComments)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    // Setup observer for unread comments
    (0, $9nXVV.useUnreadCommentsObserverSetup)({
        pageId: pageId,
        onCommentRead: onCommentRead
    });
    // Destructure pageContentTypeProps with defaults
    const { pageMode: pageMode } = pageContentTypeProps || {};
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    // Get comments data directly from comments-data package (for pages only)
    // This fixes the circular dependency issue
    const [{ orderedActiveAnnotationIdList: orderedActiveAnnotationIdList = [], commentsDataMap: legacyCommentsDataMap = {
        inline: {},
        general: {}
    } }, { addNewCommentThreads: addNewCommentThreads }] = (0, $8i27m.useCommentsData)();
    const commentsDataMap = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? processedCommentsData.commentsDataMap : legacyCommentsDataMap;
    const { isDanglingCallback: isDanglingCallback } = (0, $3bH25.useIsDanglingCallback)({
        pageMode: pageMode
    });
    // We still need these for the logic in handleUpdateUnreadComments
    const [editorAnnotationsState] = (0, $aUU0C.useEditorAnnotations)();
    const { annotations: annotations, pageId: editorPageId } = editorAnnotationsState;
    const isRenderer = pageMode === 'view';
    const rendererActionsResult = (0, $8WQTF.useRendererActions)();
    const { rendererActions: rendererActions, pageId: rendererPageId } = rendererActionsResult || {};
    const { getViewedCommentsFresh: getViewedCommentsFresh } = (0, $d3bcC.useViewedComments)({
        pageId: pageId || ''
    });
    const legacyQueryResult = (0, $jMyy4.useQueryInterop)($2524304961e9b056$var$unreadCommentsQuery, {
        variables: {
            pageId: pageId || '',
            contentStatus: !isRenderer ? [
                (0, $9SEzS.GraphQLContentStatus).CURRENT,
                (0, $9SEzS.GraphQLContentStatus).DRAFT
            ] : [
                (0, $9SEzS.GraphQLContentStatus).CURRENT
            ]
        },
        skip: !pageId || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false),
        __callerPackage__: "unread-comments"
    });
    const loading = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? !processedCommentsData.isDataProcessed : legacyQueryResult.loading;
    const error = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? processedCommentsData.error : legacyQueryResult.error;
    (0, $cozmU.useEffect)(()=>{
        // isUnreadQueryLoading is used in other areas of the code to make sure unread logic is processed before further logic
        setIsUnreadQueryLoading(loading);
    }, [
        loading,
        setIsUnreadQueryLoading
    ]);
    // Handle GraphQL query errors with proper error handling
    (0, $cozmU.useEffect)(()=>{
        if (!error || !pageId) return;
        // Handle expected errors (403/unauthorized, network errors) - just mark as handled
        if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $6fil2.containsNetworkError)(error)) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return;
        }
        // Handle unexpected errors (including 500) - track them with context
        (0, $fJlJm.setContentErrorAttributes)(error, {
            objectId: pageId,
            objectType: 'page'
        });
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).COMMENTS
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }, [
        error,
        pageId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (pageId) {
            updateUnreadCommentIDSet(new Set(), 'removeAll');
            setShouldClearVisibleThreads(false);
            // reset so we can recreate the set for the page that the user is changing to
            setIsUpdatingUnreadComments(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pageId
    ]);
    const resetStates = (0, $cozmU.useCallback)(()=>{
        setIsUpdatingUnreadComments(false);
    }, [
        setIsUpdatingUnreadComments
    ]);
    const handleUpdateUnreadComments = (0, $cozmU.useCallback)(async ()=>{
        if (userId && isUpdatingUnreadComments) {
            if (loading) return [];
            if (!pageId) return;
            const currentAllCommentsFromQuery = (()=>{
                // When feature flag is enabled, use data from ProcessedCommentsDataStore
                if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return processedCommentsData.openComments || [];
                // Legacy path: use data from unreadCommentsQuery
                // Validate that the query was executed for the current page
                if (legacyQueryResult.variables?.pageId !== pageId) return [];
                const filteredNodes = legacyQueryResult.data?.comments?.nodes?.filter((node)=>node !== null) || [];
                if (filteredNodes.length === 0) return [];
                return filteredNodes;
            })();
            if (currentAllCommentsFromQuery.length === 0) {
                resetStates(); // we no longer need to create the set if there are no comments on the page
                return;
            }
            // Skip if renderer actions or editor annotations are for different page
            if (pageMode && (isRenderer && rendererActions && rendererPageId !== pageId || !isRenderer && annotations && editorPageId !== pageId)) return; // Wait for next rerender when rendererActions / annotations are updated for the current page
            const rendererAnnotations = rendererActions?.getAnnotationMarks() || [];
            const annotationsInEditorDoc = new Set(annotations || []);
            if (currentAllCommentsFromQuery.length < $2524304961e9b056$var$MAX_UNREAD_COMMENTS_SUPPORTED) {
                const isArchived = contentStatus === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED);
                const hasPageComments = currentAllCommentsFromQuery.some((comment)=>comment?.location?.type === 'FOOTER');
                // skip creating unread comments set if the page is archived
                // or if there are no page comments and inline comments
                if (isArchived || pageMode && !hasPageComments && (isRenderer && rendererAnnotations?.length === 0 || !isRenderer && annotationsInEditorDoc?.size === 0)) return;
                // continuing here means one of these 3 scenarios are true so we do want to check for unread comments
                // 1. no inline comments, yes page comments
                // 2. yes inline comments, no page comments
                // 3. yes inline comments, yes page comments
                const viewedComments = await getViewedCommentsFresh();
                if (viewedComments.success && viewedComments.data) (0, $e4kZB.createUnreadCommentsSet)({
                    allComments: currentAllCommentsFromQuery,
                    currentUserId: userId,
                    pageId: pageId,
                    updateUnreadCommentIDSet: updateUnreadCommentIDSet,
                    resetStates: resetStates,
                    viewedComments: viewedComments.data,
                    isDanglingCallback: isDanglingCallback,
                    addNewCommentThreads: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? undefined : addNewCommentThreads
                });
            }
        }
    }, [
        userId,
        isUpdatingUnreadComments,
        loading,
        pageId,
        pageMode,
        isRenderer,
        rendererActions,
        rendererPageId,
        annotations,
        editorPageId,
        legacyQueryResult.variables?.pageId,
        legacyQueryResult.data?.comments?.nodes,
        processedCommentsData.openComments,
        resetStates,
        contentStatus,
        getViewedCommentsFresh,
        updateUnreadCommentIDSet,
        isDanglingCallback,
        addNewCommentThreads
    ]);
    (0, $3bH25.useDanglingAndResolvedHandler)({
        orderedActiveAnnotationIdList: orderedActiveAnnotationIdList,
        commentsDataMap: commentsDataMap,
        userId: userId || '',
        pageId: pageId || '',
        isDanglingCallback: pageMode ? isDanglingCallback : undefined // use dangling callback if content type is a page
    });
    (0, $cozmU.useEffect)(()=>{
        const isNotPageContentType = !pageContentTypeProps;
        if (isNotPageContentType && !(0, $9wGTI.fg)('cc-whiteboards-consolidating-comments-unread')) return;
        handleUpdateUnreadComments();
    }, [
        handleUpdateUnreadComments,
        rendererActions,
        annotations,
        pageContentTypeProps
    ]);
};
module.exports["useUnreadCommentsSetup"] = $2524304961e9b056$export$3c5a4187b7dbe412;

});

parcelRegister("hG1iq", function(module, exports) {
/**
 * @generated SignedSource<<33802f664d2ade47817e729f9ef52cf5>>
 * @relayHash d39dbd59eb9fb721eb22ceae8c220866
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f388e03eec4876c6337191ddf420d23450f78db7d52b381220875c59f39116d
const $66270afabeec0762$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "inlineMarkerRef"
    }, v6 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v7 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v3 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionType"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    }
                ],
                "type": "KnownUser"
            }
        ]
    }, v8 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    }, v9 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Literal",
                    "name": "depth",
                    "value": "ROOT"
                },
                {
                    "kind": "Variable",
                    "name": "pageId",
                    "variableName": "pageId"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "UNRESOLVED"
                }
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "location",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "concreteType": "InlineCommentResolveProperties",
                                            "kind": "LinkedField",
                                            "name": "inlineResolveProperties",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isDangling"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "InlineComment"
                                }
                            ]
                        },
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "concreteType": "InlineCommentResolveProperties",
                                                    "kind": "LinkedField",
                                                    "name": "inlineResolveProperties",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "InlineComment"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useUnreadCommentsSetupQuery",
            "selections": v9 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useUnreadCommentsSetupQuery",
            "selections": v9 /*: any*/ 
        },
        "params": {
            "cacheID": "d39dbd59eb9fb721eb22ceae8c220866",
            "id": "2f388e03eec4876c6337191ddf420d23450f78db7d52b381220875c59f39116d",
            "metadata": {},
            "name": "useUnreadCommentsSetupQuery",
            "operationKind": "query",
            "text": "query useUnreadCommentsSetupQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus]){comments(pageId:$pageId,contentStatus:$contentStatus,type:UNRESOLVED,depth:ROOT){nodes{id,location{__typename,type,...on InlineComment{inlineMarkerRef,inlineResolveProperties{resolved,isDangling}}},author{__typename,permissionType,...on KnownUser{accountId}},createdAt{value},replies{id,author{__typename,permissionType,...on KnownUser{accountId}},createdAt{value},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineResolveProperties{resolved}}}}},totalCount}}"
        }
    };
}();
$66270afabeec0762$var$node.hash = "7519f4245d619aa0e9791a4d4979af13";
var $66270afabeec0762$export$2e2bcd8739ae039 = $66270afabeec0762$var$node;
module.exports["default"] = $66270afabeec0762$export$2e2bcd8739ae039;

});

parcelRegister("9nXVV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");


var $c1UWH = parcelRequire("c1UWH");


var $fHAwL = parcelRequire("fHAwL");


var $1czFr = parcelRequire("1czFr");


var $d3bcC = parcelRequire("d3bcC");

const $b14365a28be63efb$var$MARK_COMMENTS_AS_READ_DEBOUNCE_MS = 1000;
const $b14365a28be63efb$export$d5d84acfffa9b3ca = ({ pageId: pageId, onCommentRead: onCommentRead })=>{
    const { updateUnreadCommentIDSet: updateUnreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsActions)();
    const { debouncedMarkCommentsAsRead: debouncedMarkCommentsAsRead, flushPendingComments: flushPendingComments } = (0, $1czFr.useDebouncedMarkCommentsAsRead)($b14365a28be63efb$var$MARK_COMMENTS_AS_READ_DEBOUNCE_MS);
    const { updateViewedCommentsCache: updateViewedCommentsCache } = (0, $d3bcC.useViewedComments)({
        pageId: pageId || ''
    });
    const intersectionCallback = (0, $cozmU.useCallback)((commentId)=>{
        if (commentId) {
            updateUnreadCommentIDSet(new Set([
                commentId
            ]), 'remove');
            debouncedMarkCommentsAsRead(commentId);
            updateViewedCommentsCache([
                commentId
            ]);
            if ((0, $9wGTI.fg)('cc-whiteboards-consolidating-comments-unread')) // Notify external systems about the comment being read (e.g. content types, whiteboards, databases)
            onCommentRead?.([
                commentId
            ]);
        }
    }, [
        updateUnreadCommentIDSet,
        debouncedMarkCommentsAsRead,
        updateViewedCommentsCache,
        onCommentRead
    ]);
    // Create refs to avoid stale closures in useEffect
    const intersectionCallbackRef = (0, $cozmU.useRef)(intersectionCallback);
    intersectionCallbackRef.current = intersectionCallback;
    const flushPendingCommentsRef = (0, $cozmU.useRef)(flushPendingComments);
    flushPendingCommentsRef.current = flushPendingComments;
    (0, $cozmU.useEffect)(()=>{
        if (!pageId) return;
        const observer = (0, $c1UWH.getUnreadCommentsIntersectionObserver)();
        observer.registerIntersectionCallback((commentId)=>{
            intersectionCallbackRef.current(commentId);
        });
        return ()=>{
            observer.disconnect();
            flushPendingCommentsRef.current();
        };
    }, [
        pageId
    ]);
};
module.exports["useUnreadCommentsObserverSetup"] = $b14365a28be63efb$export$d5d84acfffa9b3ca;

});

parcelRegister("c1UWH", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");

class $992a1265dc051ead$var$UnreadCommentsIntersectionObserver {
    createObserver() {
        try {
            if (typeof IntersectionObserver === 'undefined') return;
            const observer = new IntersectionObserver((entries)=>{
                entries.forEach((entry)=>{
                    const commentId = entry.target.getAttribute('data-comment-id');
                    if (!commentId) return;
                    if (entry.isIntersecting) {
                        // Comment became visible - set new timer for this specific comment
                        const timer = setTimeout(()=>{
                            this.intersectionCallbacks.forEach((callback)=>{
                                callback(commentId);
                            });
                            // Clear the timer for this comment
                            this.commentTimersMap.delete(commentId);
                            // Unobserve this element since it's been processed
                            if (this.observer && typeof this.observer.unobserve === 'function') {
                                this.observer.unobserve(entry.target);
                                this.observedElementsSet.delete(entry.target);
                            }
                        }, 2000); // 2 seconds default
                        this.commentTimersMap.set(commentId, timer);
                    } else // Comment became invisible - clear timer for this comment
                    if (this.commentTimersMap.has(commentId)) {
                        clearTimeout(this.commentTimersMap.get(commentId));
                        this.commentTimersMap.delete(commentId);
                    }
                });
            }, {
                threshold: [
                    0.25
                ],
                // add a bottom root margin to account for sticky elements at the bottom of the observable viewport such as the sticky footer
                // this is because the intersection observer doesn't know about elements that are above the observed comments, and so we can avoid
                // marking comments as read when they're not actually visible to the user. this is a best effort approach
                rootMargin: '0px 0px -65px 0px',
                // Add a custom name to identify this as the unread comments observer
                // This helps in tests to distinguish it from other intersection observers
                name: 'unreadCommentsObserver'
            });
            // Only set observer if it has the required methods
            if (observer && typeof observer.disconnect === 'function' && typeof observer.observe === 'function' && typeof observer.unobserve === 'function') this.observer = observer;
            else this.observer = null;
        } catch  {
            this.observer = null;
        }
    }
    observeComment(targetElement) {
        // don't observe if the observer is not initialized
        if (!this.observer) return;
        // don't observe if the targetElement is not a valid element
        if (!targetElement) return;
        // don't observe the same element twice
        if (this.observedElementsSet.has(targetElement)) return;
        this.observer.observe(targetElement);
        this.observedElementsSet.add(targetElement);
    }
    unobserveComment(targetElement) {
        // don't unobserve if the observer is not initialized
        if (!this.observer) return;
        // don't unobserve if the targetElement is not a valid element
        if (!targetElement) return;
        // only unobserve if we're actually observing this element
        if (!this.observedElementsSet.has(targetElement)) return;
        // Clear any running timer for this comment
        const commentId = targetElement.getAttribute('data-comment-id');
        if (commentId && this.commentTimersMap.has(commentId)) {
            clearTimeout(this.commentTimersMap.get(commentId));
            this.commentTimersMap.delete(commentId);
        }
        this.observer.unobserve(targetElement);
        this.observedElementsSet.delete(targetElement);
    }
    // By exposing this function, we allow consumers to register callbacks
    registerIntersectionCallback(callback) {
        this.intersectionCallbacks.push(callback);
    }
    deregisterIntersectionCallback(callback) {
        this.intersectionCallbacks = this.intersectionCallbacks.filter((cb)=>cb !== callback);
    }
    // Reconnect the observer if it was disconnected
    reconnect() {
        if (!this.observer) this.createObserver();
    }
    // Clean up method
    disconnect() {
        if (this.observer && typeof this.observer.disconnect === 'function') {
            this.observer.disconnect();
            this.observer = null;
        }
        // Clear all timers
        this.commentTimersMap.forEach((timer)=>clearTimeout(timer));
        this.commentTimersMap.clear();
        // Clear observed elements
        this.observedElementsSet.clear();
        // Clear callbacks
        this.intersectionCallbacks = [];
    }
    constructor(){
        this.observer = null;
        this.commentTimersMap = new Map();
        this.observedElementsSet = new Set();
        this.intersectionCallbacks = [];
        this.createObserver();
    }
}
// memoize ensures an IntersectionObserver is instantiated only once
const $992a1265dc051ead$var$getStableIntersectionObserver = (0, $dOBRD.default)(()=>{
    return new $992a1265dc051ead$var$UnreadCommentsIntersectionObserver();
});
const $992a1265dc051ead$export$ad65f5516d9692ed = ()=>{
    const intersectionObserver = $992a1265dc051ead$var$getStableIntersectionObserver();
    intersectionObserver.reconnect();
    return intersectionObserver;
};
module.exports["getUnreadCommentsIntersectionObserver"] = $992a1265dc051ead$export$ad65f5516d9692ed;

});

parcelRegister("1czFr", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gi0WF = parcelRequire("gi0WF");

const $e63c8ea486e09ced$export$faaf0da9552bb131 = (debounceMs = 1000)=>{
    const markCommentsAsRead = (0, $gi0WF.useMarkCommentsAsRead)();
    const pendingCommentIds = (0, $cozmU.useRef)(new Set());
    const timeoutRef = (0, $cozmU.useRef)(null);
    const beforeUnloadHandlerRef = (0, $cozmU.useRef)(null);
    const debouncedMarkCommentsAsRead = (0, $cozmU.useCallback)((commentId)=>{
        // Add the comment ID to the pending set
        pendingCommentIds.current.add(commentId);
        // Clear any existing timeout
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        // Set a new timeout to batch and send the request
        timeoutRef.current = setTimeout(()=>{
            const commentIdsToMark = Array.from(pendingCommentIds.current);
            // Clear the pending set
            pendingCommentIds.current.clear();
            // Reset the timeout ref
            timeoutRef.current = null;
            // Only call the mutation if there are comments to mark
            if (commentIdsToMark.length > 0) markCommentsAsRead(commentIdsToMark);
        }, debounceMs);
    }, [
        markCommentsAsRead,
        debounceMs
    ]);
    // Function to send pending comment IDs
    const sendPendingComments = (0, $cozmU.useCallback)(()=>{
        const commentIdsToMark = Array.from(pendingCommentIds.current);
        if (commentIdsToMark.length === 0) return;
        // Clear the pending set
        pendingCommentIds.current.clear();
        // Just call the existing mutation function
        markCommentsAsRead(commentIdsToMark);
    }, [
        markCommentsAsRead
    ]);
    // Beforeunload event handler (e.g. when the user closes the tab or window)
    const handleBeforeUnload = (0, $cozmU.useCallback)((_event)=>{
        sendPendingComments();
    }, [
        sendPendingComments
    ]);
    // Set up beforeunload event listener
    (0, $cozmU.useEffect)(()=>{
        beforeUnloadHandlerRef.current = handleBeforeUnload;
        window.addEventListener('beforeunload', handleBeforeUnload);
        return ()=>{
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [
        handleBeforeUnload
    ]);
    // Flush pending comments and clear timeout
    const flushPendingComments = (0, $cozmU.useCallback)(()=>{
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        // Send any pending comments
        sendPendingComments();
    }, [
        sendPendingComments
    ]);
    return {
        debouncedMarkCommentsAsRead: debouncedMarkCommentsAsRead,
        flushPendingComments: flushPendingComments
    };
};
module.exports["useDebouncedMarkCommentsAsRead"] = $e63c8ea486e09ced$export$faaf0da9552bb131;

});

parcelRegister("gi0WF", function(module, exports) {

var $8rdFk = parcelRequire("8rdFk");


var $cozmU = parcelRequire("cozmU");


var $308Wd = parcelRequire("308Wd");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $6fil2 = parcelRequire("6fil2");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $bMmYR = parcelRequire("bMmYR");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");

const $170c9bba7ed44542$var$markCommentsAsReadMutation = (0, $8rdFk.default);
const $170c9bba7ed44542$export$db614d7d47784b95 = ()=>{
    const [markCommentsAsRead] = (0, $308Wd.useMutationInterop)($170c9bba7ed44542$var$markCommentsAsReadMutation, {
        __callerPackage__: "unread-comments"
    });
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const markCommentsAsReadFn = (0, $cozmU.useCallback)(async (commentIds)=>{
        if (commentIds.length === 0) return;
        // Start experience tracking for marking comments as read
        experienceTracker.start({
            name: (0, $irVI7.MARK_COMMENTS_AS_READ_EXPERIENCE),
            attributes: {
                commentIds: commentIds,
                commentCount: commentIds.length
            }
        });
        let attemptNumber = 1;
        try {
            const result = await (0, $bMmYR.retry)(async (attempt)=>{
                attemptNumber = attempt + 1;
                return await markCommentsAsRead({
                    variables: {
                        commentIds: commentIds
                    }
                });
            }, {}, async (error)=>{
                // Don't retry for expected errors (403/unauthorized, network errors)
                return !(0, $1uFM6.isUnauthorizedError)(error) && !(0, $6fil2.containsNetworkError)(error);
            });
            // Check if the mutation succeeded
            if (result?.data?.markCommentsAsRead?.success) // Mark experience as successful
            experienceTracker.succeed({
                name: (0, $irVI7.MARK_COMMENTS_AS_READ_EXPERIENCE),
                attributes: {
                    commentIds: commentIds,
                    commentCount: commentIds.length,
                    attemptNumber: attemptNumber
                }
            });
            else // Backend returned success: false
            experienceTracker.fail({
                name: (0, $irVI7.MARK_COMMENTS_AS_READ_EXPERIENCE),
                error: new Error('Backend returned success: false'),
                attributes: {
                    attemptNumber: attemptNumber
                }
            });
        } catch (err) {
            // Handle expected errors (403/unauthorized, network errors) - abort experience tracking
            if ((0, $1uFM6.isUnauthorizedError)(err) || (0, $6fil2.containsNetworkError)(err)) {
                experienceTracker.abort({
                    name: (0, $irVI7.MARK_COMMENTS_AS_READ_EXPERIENCE),
                    reason: 'Expected error (unauthorized or network error)'
                });
                (0, $7Sm4c.markErrorAsHandled)(err);
                return;
            }
            // Mark experience as failed for unexpected errors
            experienceTracker.fail({
                name: (0, $irVI7.MARK_COMMENTS_AS_READ_EXPERIENCE),
                error: err,
                attributes: {
                    attemptNumber: attemptNumber
                }
            });
            // Handle unexpected errors (including 500) - track them with context
            (0, $fJlJm.setContentErrorAttributes)(err, {
                objectType: 'comment'
            });
            (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                attribution: (0, $3IBnw.Attribution).COMMENTS
            });
            (0, $7Sm4c.markErrorAsHandled)(err);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- experienceTracker from context doesn't need to be in deps
    [
        markCommentsAsRead
    ]);
    return markCommentsAsReadFn;
};
module.exports["useMarkCommentsAsRead"] = $170c9bba7ed44542$export$db614d7d47784b95;

});

parcelRegister("8rdFk", function(module, exports) {
/**
 * @generated SignedSource<<fede2250a28c1036d502c7a0d09fbbf6>>
 * @relayHash 446a6fa3fbbe8bbb4444e858a1c7626c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2666786691a2a90a6a0d6434d55d4758dfc395b6e9ba53c0598118cccde4da14
const $4a78b10481ac8443$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentIds"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "commentIds",
                            "variableName": "commentIds"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "MarkCommentsAsReadPayload",
            "kind": "LinkedField",
            "name": "markCommentsAsRead",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "kind": "ScalarField",
                    "name": "errors"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useMarkCommentsAsReadMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useMarkCommentsAsReadMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "446a6fa3fbbe8bbb4444e858a1c7626c",
            "id": "2666786691a2a90a6a0d6434d55d4758dfc395b6e9ba53c0598118cccde4da14",
            "metadata": {},
            "name": "useMarkCommentsAsReadMutation",
            "operationKind": "mutation",
            "text": "mutation useMarkCommentsAsReadMutation($commentIds:[ID!]!){markCommentsAsRead(input:{commentIds:$commentIds}){success,errors}}"
        }
    };
}();
$4a78b10481ac8443$var$node.hash = "d155280f920b93703b5ae452997bdcaf";
var $4a78b10481ac8443$export$2e2bcd8739ae039 = $4a78b10481ac8443$var$node;
module.exports["default"] = $4a78b10481ac8443$export$2e2bcd8739ae039;

});

parcelRegister("3bH25", function(module, exports) {
/* eslint-disable object-shorthand */ 
var $cozmU = parcelRequire("cozmU");


var $aUU0C = parcelRequire("aUU0C");


var $8WQTF = parcelRequire("8WQTF");


var $fHAwL = parcelRequire("fHAwL");


var $d3bcC = parcelRequire("d3bcC");


var $e4kZB = parcelRequire("e4kZB");

const $280745ffe1b8b376$export$30b625574e8a38c7 = ({ pageMode: pageMode })=>{
    const [editorAnnotationsState] = (0, $aUU0C.useEditorAnnotations)();
    const { annotations: annotations } = editorAnnotationsState;
    const rendererActionsResult = (0, $8WQTF.useRendererActions)();
    const { rendererActions: rendererActions } = rendererActionsResult || {};
    const isDanglingCallback = (0, $cozmU.useCallback)((markerRef)=>{
        if (!pageMode) return false;
        return (0, $e4kZB.commentIsDangling)({
            pageMode: pageMode,
            annotationsInEditorDoc: new Set(annotations),
            rendererAnnotations: new Set(rendererActions?.getAnnotationMarks()?.map((ann)=>ann.attrs.id).filter(Boolean) || [])
        })(markerRef);
    }, [
        annotations,
        rendererActions,
        pageMode
    ]);
    return {
        isDanglingCallback: isDanglingCallback
    };
};
// Helper function to process added annotations (reopened / undangled)
const $280745ffe1b8b376$var$processAddedAnnotations = ({ currentList: currentList, previousThreadKeys: previousThreadKeys, commentsDataMap: commentsDataMap, viewedComments: viewedComments, userId: userId, isDanglingCallback: isDanglingCallback })=>{
    const addedCommentIds = new Set();
    for (const annotation of currentList)if (!previousThreadKeys.has(annotation.threadKey)) {
        const commentData = commentsDataMap.inline[annotation.threadKey];
        if (commentData) {
            // Early return if comment is already viewed
            if (viewedComments.has(commentData.id)) return addedCommentIds;
            // Add the main comment ID if it's a valid unread comment
            if ((0, $e4kZB.isValidUnreadComment)({
                comment: commentData,
                currentUserId: userId,
                viewedComments: viewedComments,
                isDanglingCallback: isDanglingCallback
            })) addedCommentIds.add(commentData.id);
            // Add all reply IDs if they're valid unread comments
            commentData.replies?.forEach((reply)=>{
                if (reply) {
                    // Skip if reply is already viewed
                    if (viewedComments.has(reply.id)) return;
                    if ((0, $e4kZB.isValidUnreadComment)({
                        comment: reply,
                        currentUserId: userId,
                        viewedComments: viewedComments,
                        isDanglingCallback: isDanglingCallback
                    })) addedCommentIds.add(reply.id);
                }
            });
        }
    }
    return addedCommentIds;
};
// Helper function to process removed annotations (resolved / dangled)
const $280745ffe1b8b376$var$processRemovedAnnotations = ({ previousList: previousList, currentThreadKeys: currentThreadKeys, commentsDataMap: commentsDataMap })=>{
    const removedCommentIds = new Set();
    for (const annotation of previousList)if (!currentThreadKeys.has(annotation.threadKey)) {
        const commentData = commentsDataMap.inline[annotation.threadKey];
        if (commentData) {
            // Add the main comment ID
            removedCommentIds.add(commentData.id);
            // Add all reply IDs
            commentData.replies?.forEach((reply)=>{
                if (reply) removedCommentIds.add(reply.id);
            });
        }
    }
    return removedCommentIds;
};
const $280745ffe1b8b376$export$ce2ddc24e5a132d = ({ orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, commentsDataMap: commentsDataMap, userId: userId, pageId: pageId, isDanglingCallback: isDanglingCallback })=>{
    const [{ isUpdatingUnreadComments: isUpdatingUnreadComments }, { updateUnreadCommentIDSet: updateUnreadCommentIDSet }] = (0, $fHAwL.useUnreadComments)();
    const { getViewedCommentsCacheOnly: getViewedCommentsCacheOnly } = (0, $d3bcC.useViewedComments)({
        pageId: pageId
    });
    // Keep track of the previous orderedActiveAnnotationIdList
    const previousOrderedActiveAnnotationIdListRef = (0, $cozmU.useRef)(orderedActiveAnnotationIdList);
    // Handle the async getViewedComments call
    const processAnnotations = (0, $cozmU.useCallback)(async ()=>{
        const previousList = previousOrderedActiveAnnotationIdListRef.current;
        const currentList = orderedActiveAnnotationIdList;
        // Early exit if lists are identical (same length)
        if (previousList.length === currentList.length) return;
        // Build thread key sets for processing
        const previousThreadKeys = new Set(previousList.map((annotation)=>annotation.threadKey));
        const currentThreadKeys = new Set(currentList.map((annotation)=>annotation.threadKey));
        const viewedCommentsResult = getViewedCommentsCacheOnly();
        if (!viewedCommentsResult.success || !viewedCommentsResult.data) return;
        const viewedComments = viewedCommentsResult.data;
        // Process added annotations (reopened / undangled)
        const addedCommentIds = $280745ffe1b8b376$var$processAddedAnnotations({
            currentList: currentList,
            previousThreadKeys: previousThreadKeys,
            commentsDataMap: commentsDataMap,
            viewedComments: viewedComments,
            userId: userId,
            isDanglingCallback: isDanglingCallback
        });
        // Process removed annotations (resolved / dangled)
        const removedCommentIds = $280745ffe1b8b376$var$processRemovedAnnotations({
            previousList: previousList,
            currentThreadKeys: currentThreadKeys,
            commentsDataMap: commentsDataMap
        });
        // Update unread comment ID set for added annotations
        if (addedCommentIds.size > 0) updateUnreadCommentIDSet(addedCommentIds, 'add');
        // Update unread comment ID set for removed annotations
        if (removedCommentIds.size > 0) updateUnreadCommentIDSet(removedCommentIds, 'remove');
        // Update the previous list ref to current list for next comparison
        previousOrderedActiveAnnotationIdListRef.current = currentList;
    }, [
        orderedActiveAnnotationIdList,
        commentsDataMap,
        userId,
        isDanglingCallback,
        getViewedCommentsCacheOnly,
        updateUnreadCommentIDSet
    ]);
    (0, $cozmU.useEffect)(()=>{
        // skip entirely if:
        // - feature flag is disabled
        // - isDanglingCallback check is not enabled
        // - isUpdatingUnreadComments being true means the unread query and viewed comments query are not complete yet, which means we shouldn't process the annotations yet
        if (!isDanglingCallback || isUpdatingUnreadComments) return;
        processAnnotations();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- exclude commentsDataMap because we don't need to rerun this hook when it changes
    }, [
        processAnnotations,
        isUpdatingUnreadComments
    ]);
};
module.exports["useIsDanglingCallback"] = $280745ffe1b8b376$export$30b625574e8a38c7;
module.exports["useDanglingAndResolvedHandler"] = $280745ffe1b8b376$export$ce2ddc24e5a132d;

});

parcelRegister("9SEzS", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $6771fdd733157350$export$b634e5de755b7d35 = /*#__PURE__*/ function(GraphQLContentStatus) {
    GraphQLContentStatus["ARCHIVED"] = "ARCHIVED";
    GraphQLContentStatus["CURRENT"] = "CURRENT";
    GraphQLContentStatus["DELETED"] = "DELETED";
    GraphQLContentStatus["DRAFT"] = "DRAFT";
    return GraphQLContentStatus;
}({});
var $6771fdd733157350$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["GraphQLContentStatus"] = $6771fdd733157350$export$b634e5de755b7d35;

});

parcelRegister("hycHC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4fqm1 = parcelRequire("4fqm1");


var $ixfCV = parcelRequire("ixfCV");


var $9XB2W = parcelRequire("9XB2W");

const $19f67db039a615a7$var$ACTIONED_EVENT_DELAY = 10000;
const $19f67db039a615a7$var$AI_GENERATED_TITLE_CHANGE_PERCENTAGE_THRESHOLD = 50;
const $19f67db039a615a7$export$ff041132f32feaf3 = ({ enabled: enabled, title: title, handleNewTitle: handleNewTitle, canFireUnifiedAIAnalyticsEvent: canFireUnifiedAIAnalyticsEvent })=>{
    const canFireActionedEvent = canFireUnifiedAIAnalyticsEvent && (0, $ixfCV.fg)('platform_editor_ai_suggest_title_actioned_event');
    const currentTitleRef = (0, $cozmU.useRef)(title);
    (0, $cozmU.useEffect)(()=>{
        currentTitleRef.current = title;
    }, [
        title
    ]);
    const currentAnalyticsEventDataRef = (0, $cozmU.useRef)(null);
    const fireAnalyticEvent = (0, $cozmU.useCallback)((currentTitle)=>{
        if (!canFireActionedEvent) return;
        if (currentAnalyticsEventDataRef.current && currentAnalyticsEventDataRef.current.isFinal) {
            const titleChangePercentage = $19f67db039a615a7$export$1c6b9baa0047190(currentAnalyticsEventDataRef.current.aiGeneratingTitle, currentTitle);
            if (titleChangePercentage < $19f67db039a615a7$var$AI_GENERATED_TITLE_CHANGE_PERCENTAGE_THRESHOLD) currentAnalyticsEventDataRef.current.fireUnifiedAnalyticsEvent('actioned');
            else currentAnalyticsEventDataRef.current.fireUnifiedAnalyticsEvent('discarded');
            // currentAnalyticsEventDataRef.current to null to avoid duplicate events.
            currentAnalyticsEventDataRef.current = null;
        }
    }, [
        canFireActionedEvent
    ]);
    const currentTimerIdRef = (0, $cozmU.useRef)(undefined);
    const createTimerToFireActionedEvent = (0, $cozmU.useCallback)(()=>{
        if (currentTimerIdRef.current) window.clearTimeout(currentTimerIdRef.current);
        currentTimerIdRef.current = window.setTimeout(()=>{
            fireAnalyticEvent(currentTitleRef.current);
        }, $19f67db039a615a7$var$ACTIONED_EVENT_DELAY);
    }, [
        fireAnalyticEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!enabled) return;
        const { unsubscribe: unsubscribe } = (0, $9XB2W.eventHub).subscribe({
            event: 'replace title in confluence',
            callback: (data)=>{
                const aiGeneratingTitle = data.title;
                if (canFireActionedEvent && data.isFinal !== undefined && data.fireUnifiedAnalyticsEvent) {
                    /**
           * This callback is called multiple times, for single replace title event
           * 	because of streaming api.
           *
           * So if only currentTimerIdRef.current is not undefined,
           * 	that means user has clicked on suggest title button again
           * 	within ACTIONED_EVENT_DELAY.
           *
           * That means user didn't like previously generated title,
           * 	so we will pass empty string, so that dismissed event is fired.
           */ if (currentTimerIdRef.current) {
                        fireAnalyticEvent('');
                        window.clearTimeout(currentTimerIdRef.current);
                        currentTimerIdRef.current = undefined;
                    }
                    currentAnalyticsEventDataRef.current = {
                        aiGeneratingTitle: aiGeneratingTitle,
                        isFinal: data.isFinal,
                        fireUnifiedAnalyticsEvent: data.fireUnifiedAnalyticsEvent
                    };
                    // When final stream arrives, we will set timer to fire actioned/dismissed event.
                    if (data.isFinal) createTimerToFireActionedEvent();
                }
                handleNewTitle(aiGeneratingTitle);
            }
        });
        return ()=>{
            unsubscribe();
            window.clearTimeout(currentTimerIdRef.current);
        };
    }, [
        createTimerToFireActionedEvent,
        enabled,
        fireAnalyticEvent,
        handleNewTitle,
        canFireActionedEvent
    ]);
};
const $19f67db039a615a7$export$1c6b9baa0047190 = (aiGeneratedTitle, currentTitle)=>{
    if (aiGeneratedTitle.length === 0) return 0;
    const distance = (0, $4fqm1.distance)(aiGeneratedTitle, currentTitle);
    return distance / aiGeneratedTitle.length * 100;
};
module.exports["useEditorAIReplacingTitle"] = $19f67db039a615a7$export$ff041132f32feaf3;

});

parcelRegister("4fqm1", function(module, exports) {
const $317d0183692131b1$var$peq = new Uint32Array(0x10000);
const $317d0183692131b1$var$myers_32 = (a, b)=>{
    const n = a.length;
    const m = b.length;
    const lst = 1 << n - 1;
    let pv = -1;
    let mv = 0;
    let sc = n;
    let i = n;
    while(i--)$317d0183692131b1$var$peq[a.charCodeAt(i)] |= 1 << i;
    for(i = 0; i < m; i++){
        let eq = $317d0183692131b1$var$peq[b.charCodeAt(i)];
        const xv = eq | mv;
        eq |= (eq & pv) + pv ^ pv;
        mv |= ~(eq | pv);
        pv &= eq;
        if (mv & lst) sc++;
        if (pv & lst) sc--;
        mv = mv << 1 | 1;
        pv = pv << 1 | ~(xv | mv);
        mv &= xv;
    }
    i = n;
    while(i--)$317d0183692131b1$var$peq[a.charCodeAt(i)] = 0;
    return sc;
};
const $317d0183692131b1$var$myers_x = (b, a)=>{
    const n = a.length;
    const m = b.length;
    const mhc = [];
    const phc = [];
    const hsize = Math.ceil(n / 32);
    const vsize = Math.ceil(m / 32);
    for(let i = 0; i < hsize; i++){
        phc[i] = -1;
        mhc[i] = 0;
    }
    let j = 0;
    for(; j < vsize - 1; j++){
        let mv = 0;
        let pv = -1;
        const start = j * 32;
        const vlen = Math.min(32, m) + start;
        for(let k = start; k < vlen; k++)$317d0183692131b1$var$peq[b.charCodeAt(k)] |= 1 << k;
        for(let i = 0; i < n; i++){
            const eq = $317d0183692131b1$var$peq[a.charCodeAt(i)];
            const pb = phc[i / 32 | 0] >>> i & 1;
            const mb = mhc[i / 32 | 0] >>> i & 1;
            const xv = eq | mv;
            const xh = ((eq | mb) & pv) + pv ^ pv | eq | mb;
            let ph = mv | ~(xh | pv);
            let mh = pv & xh;
            if (ph >>> 31 ^ pb) phc[i / 32 | 0] ^= 1 << i;
            if (mh >>> 31 ^ mb) mhc[i / 32 | 0] ^= 1 << i;
            ph = ph << 1 | pb;
            mh = mh << 1 | mb;
            pv = mh | ~(xv | ph);
            mv = ph & xv;
        }
        for(let k = start; k < vlen; k++)$317d0183692131b1$var$peq[b.charCodeAt(k)] = 0;
    }
    let mv = 0;
    let pv = -1;
    const start = j * 32;
    const vlen = Math.min(32, m - start) + start;
    for(let k = start; k < vlen; k++)$317d0183692131b1$var$peq[b.charCodeAt(k)] |= 1 << k;
    let score = m;
    for(let i = 0; i < n; i++){
        const eq = $317d0183692131b1$var$peq[a.charCodeAt(i)];
        const pb = phc[i / 32 | 0] >>> i & 1;
        const mb = mhc[i / 32 | 0] >>> i & 1;
        const xv = eq | mv;
        const xh = ((eq | mb) & pv) + pv ^ pv | eq | mb;
        let ph = mv | ~(xh | pv);
        let mh = pv & xh;
        score += ph >>> m - 1 & 1;
        score -= mh >>> m - 1 & 1;
        if (ph >>> 31 ^ pb) phc[i / 32 | 0] ^= 1 << i;
        if (mh >>> 31 ^ mb) mhc[i / 32 | 0] ^= 1 << i;
        ph = ph << 1 | pb;
        mh = mh << 1 | mb;
        pv = mh | ~(xv | ph);
        mv = ph & xv;
    }
    for(let k = start; k < vlen; k++)$317d0183692131b1$var$peq[b.charCodeAt(k)] = 0;
    return score;
};
const $317d0183692131b1$export$9f17032d917177de = (a, b)=>{
    if (a.length < b.length) {
        const tmp = b;
        b = a;
        a = tmp;
    }
    if (b.length === 0) return a.length;
    if (a.length <= 32) return $317d0183692131b1$var$myers_32(a, b);
    return $317d0183692131b1$var$myers_x(a, b);
};
const $317d0183692131b1$export$ff7f7c97cdce86e = (str, arr)=>{
    let min_distance = Infinity;
    let min_index = 0;
    for(let i = 0; i < arr.length; i++){
        const dist = $317d0183692131b1$export$9f17032d917177de(str, arr[i]);
        if (dist < min_distance) {
            min_distance = dist;
            min_index = i;
        }
    }
    return arr[min_index];
};
module.exports["distance"] = $317d0183692131b1$export$9f17032d917177de;
module.exports["closest"] = $317d0183692131b1$export$ff7f7c97cdce86e;

});

parcelRegister("9XB2W", function(module, exports) {
class $8fc43f5e489bb303$var$EventHub {
    /**
   * Subscribes to a specific Editor AI event, registering a callback function that will be invoked whenever the event is published.
   *
   * @param {object} params - The subscription parameters.
   * @param {T} params.event - The name of the event to subscribe to.
   * @param {(data: EventDataMap[T]) => void} params.callback - The callback function to invoke when the event is published.
   * It receives the event data as its parameter.
   * @returns {object} An object containing the `unsubscribe` method to remove the subscription when it's no longer needed.
   *
   * @example
   * // Subscribing to an event
   * const subscription = eventHub.subscribe({
   *   event: 'start prompt',
   *   callback: (data) => {
   *     console.log('Received start prompt event:', data);
   *   },
   * });
   *
   * // Later, to unsubscribe
   * subscription.unsubscribe();
   */ subscribe({ event: event, callback: callback }) {
        const callbacks = this.subscribers.get(event) || [];
        this.subscribers.set(event, [
            ...callbacks,
            callback
        ]);
        return {
            unsubscribe: ()=>{
                const callbacks = this.subscribers.get(event)?.filter((sub)=>sub !== callback) || [];
                if (callbacks.length > 0) this.subscribers.set(event, callbacks);
                else this.subscribers.delete(event);
            }
        };
    }
    /**
   * Publishes an Editor AI event to a target editor. (This will usually be an event like 'start prompt').
   *
   * @param {object} params - The event parameters.
   * @param {T} params.event - The name of the event to publish.
   * @param {ToEditorEventDataMap[T]} params.data - The data associated with the event, specific to the event type.
   * @returns {void}
   *
   * @example
   * // Publishing an event to the editor
   * eventHub.publishToEditor({
   *   event: 'start prompt',
   *   data: {
   *     prompt: 'issue reformatter',
   *     targetEditorId,
   *     analyticSourceId: 'jiraIssueReformatterExternalButton',
   *   },
   * });
   */ publishToEditor({ event: event, data: data }) {
        const callbacks = this.subscribers.get(event) || [];
        callbacks.forEach((callback)=>{
            callback(data);
        });
    }
    /**
   * Publishes an event originating from the editor, invoking all registered subscribers for that event.
   *
   * @param {object} params - The event parameters.
   * @param {T} params.event - The name of the event to publish.
   * @param {FromEditorEventDataMap[T]} params.data - The data associated with the event, specific to the event type.
   * @returns {void}
   *
   * @example
   * // Publishing an event from the editor
   * eventHub.publishFromEditor({
   *   event: 'replace title in confluence',
   *   data: {
   *     analyticSourceId: 'confluenceTitleToolbar',
   *     sourceEditorId,
   *     title: textContent,
   *   },
   * });
   */ publishFromEditor({ event: event, data: data }) {
        const callbacks = this.subscribers.get(event) || [];
        callbacks.forEach((callback)=>{
            callback(data);
        });
    }
    constructor(){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.subscribers = new Map();
        this.subscribers = new Map();
    }
}
const $8fc43f5e489bb303$export$e17a52e5da72c4cb = new $8fc43f5e489bb303$var$EventHub();
module.exports["eventHub"] = $8fc43f5e489bb303$export$e17a52e5da72c4cb;

});

parcelRegister("202oG", function(module, exports) {

var $3xuv0 = parcelRequire("3xuv0");

function $2cfd9ea7d82f1add$export$dbad71934afee167(node, headingIds) {
    if (!node?.content?.length) return;
    // We are not use node.textContent here, because we would like to handle cases where
    // headings only contain inline blocks like emoji, status and date.
    const nodeContent = node.content.reduce((acc, currentNode)=>acc.concat($2cfd9ea7d82f1add$var$getText(currentNode) || ''), '').trim().replace(/\s/g, '-');
    if (!nodeContent) return;
    return $2cfd9ea7d82f1add$var$getUniqueHeadingId(nodeContent, headingIds);
}
const $2cfd9ea7d82f1add$var$getText = (node)=>{
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : ''}]`;
};
function $2cfd9ea7d82f1add$var$getUniqueHeadingId(baseId, headingIds, counter = 0) {
    if (counter === 0 && !headingIds.has(baseId)) {
        headingIds.add(baseId);
        return baseId;
    } else if (counter !== 0) {
        const headingId = `${baseId}.${counter}`;
        if (!headingIds.has(headingId)) {
            headingIds.add(headingId);
            return headingId;
        }
    }
    return $2cfd9ea7d82f1add$var$getUniqueHeadingId(baseId, headingIds, counter + 1);
}
const $2cfd9ea7d82f1add$var$HEADINGS = new Set([
    'H1',
    'H2',
    'H3',
    'H4',
    'H5',
    'H6'
]);
function* $2cfd9ea7d82f1add$var$getHeadingIds() {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const editorElement = document.getElementById('ak-editor-textarea');
    const children = editorElement?.getElementsByTagName('*') ?? [];
    const headingIds = new Set();
    const editorTransformer = new (0, $3xuv0.JSONTransformer)();
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($2cfd9ea7d82f1add$var$HEADINGS.has(child.tagName)) {
            const pmNode = child.pmViewDesc?.node;
            if (!pmNode) continue;
            // Copied from TOC
            const adf = editorTransformer.encode(pmNode);
            let adfObject = adf;
            if (typeof adf === 'string') try {
                adfObject = JSON.parse(adf);
            } catch (err) {
            // Swallow the error as ADF format error handling is expected to be done earlier,
            // in the component that renders the entire content
            }
            const headingId = $2cfd9ea7d82f1add$export$dbad71934afee167(adfObject, headingIds);
            if (!headingId) continue;
            yield [
                headingId,
                child,
                pmNode
            ];
        }
    }
}
const $2cfd9ea7d82f1add$export$817005c72dc2688 = ()=>{
    const headingIdToElement = new Map();
    for (const [headingId, child, _] of $2cfd9ea7d82f1add$var$getHeadingIds()){
        headingIdToElement.set(headingId, child);
        // A bit inefficient, but there's sometimes a discrepancy between the hashed ID and the generated ID. The least impactful solution is to just add both.
        headingIdToElement.set(encodeURIComponent(headingId), child);
    }
    return headingIdToElement;
};
const $2cfd9ea7d82f1add$export$e2a78e613c648859 = (node)=>{
    for (const [headingId, _, pmNode] of $2cfd9ea7d82f1add$var$getHeadingIds()){
        if (node === pmNode) return headingId;
    }
    return undefined;
};
module.exports["getHeadingId"] = $2cfd9ea7d82f1add$export$dbad71934afee167;
module.exports["getHeadingIdsToElements"] = $2cfd9ea7d82f1add$export$817005c72dc2688;
module.exports["getHeadingIdForNode"] = $2cfd9ea7d82f1add$export$e2a78e613c648859;

});

parcelRegister("iwNka", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7zgzO = parcelRequire("7zgzO");


var $fFk4O = parcelRequire("fFk4O");

const $54ae78ae571a596a$export$1a20dd7f74852e6b = ()=>{
    // Linter is forcing us to use getHref instead of window.location.href to retrieve href and it isn't the full href - it doesn't include origin
    const { getHref: getHref } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    (0, $cozmU.useEffect)(()=>{
        // https://atlassian.slack.com/archives/C0131PNA4GL/p1723738281832269
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if ('setCaptureHandleConfig' in (navigator?.mediaDevices ?? {})) {
            const href = getHref();
            (0, $fFk4O.appendGoogleMeetScreenSharingScript)(href);
        }
    // Only execute on initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
module.exports["useExposeGoogleMeetScreenShare"] = $54ae78ae571a596a$export$1a20dd7f74852e6b;

});

parcelRegister("fFk4O", function(module, exports) {

var $9ICY6 = parcelRequire("9ICY6");

const $1cd0e9177e768135$export$449f0d0bb2c2424b = 'https://www.gstatic.com/meetjs/addons/1.1.0/meet.addons.js';
const $1cd0e9177e768135$export$8ea5dba186347383 = (href)=>{
    // Create script
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const script = document.createElement('script');
    script.src = $1cd0e9177e768135$export$449f0d0bb2c2424b;
    script.async = true;
    // When script is done loading, run the Google Meet screenshare method
    script.onload = ()=>{
        (0, $9ICY6.exposeToMeetWhenScreensharing)(href);
    };
    // Add script to DOM
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.head.appendChild(script);
};
module.exports["appendGoogleMeetScreenSharingScript"] = $1cd0e9177e768135$export$8ea5dba186347383;

});

parcelRegister("9ICY6", function(module, exports) {

var $hph5e = parcelRequire("hph5e");

var $f29836a0ec4c93d3$export$eab8e91f09e6d84a = /*#__PURE__*/ function(ProjectNumber) {
    ProjectNumber["staging"] = "1017113233545";
    ProjectNumber["production"] = "118174936708";
    return ProjectNumber;
}({});
var $f29836a0ec4c93d3$export$73691bb86ec75a9 = /*#__PURE__*/ function(Hostname) {
    Hostname["staging"] = "cc-embedded-pages-integ-ui.stg-east.frontend.public.atl-paas.net";
    Hostname["production"] = "cc-embedded-pages-integ.atlassian.com";
    return Hostname;
}({});
const $f29836a0ec4c93d3$export$8446085e93adc95b = (hostname, queryParams)=>`https://${hostname}/google-meet/page?${queryParams}`;
const $f29836a0ec4c93d3$export$7973aed45b22124c = (href)=>{
    const buildUrl = `${window.location.origin}${href}`;
    const parsedURL = (0, $hph5e.parseUrl)(buildUrl) ?? {};
    return new URLSearchParams(parsedURL).toString();
};
const $f29836a0ec4c93d3$export$88041f03017aa037 = (href)=>{
    const currentEnv = "production";
    // Create the correct query params for the main stage url - based on confluence embedded page
    const queryParams = $f29836a0ec4c93d3$export$7973aed45b22124c(href);
    // Grab hardcoded hostname and project number based on current env
    const hostname = $f29836a0ec4c93d3$export$73691bb86ec75a9[currentEnv] ?? "cc-embedded-pages-integ-ui.stg-east.frontend.public.atl-paas.net";
    const cloudProjectNumber = $f29836a0ec4c93d3$export$eab8e91f09e6d84a[currentEnv] ?? "1017113233545";
    // Fire the Google add-on method to allow promotion and add-on use when screensharing
    // startActivityOnOpen needs to be set to true as long as we use mainstageUrl
    // See docs for additional info: https://developers.google.com/meet/add-ons/reference/websdk/screenshare_api.addonscreenshareinfo.startactivityonopen
    window?.meet?.addon?.screensharing?.exposeToMeetWhenScreensharing({
        cloudProjectNumber: cloudProjectNumber,
        startActivityOnOpen: true,
        mainStageUrl: $f29836a0ec4c93d3$export$8446085e93adc95b(hostname, queryParams)
    });
};
module.exports["exposeToMeetWhenScreensharing"] = $f29836a0ec4c93d3$export$88041f03017aa037;

});

parcelRegister("7oCdN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fRQ3t = parcelRequire("fRQ3t");


var $kSwu1 = parcelRequire("kSwu1");


var $izCjj = parcelRequire("izCjj");


var $iEYBu = parcelRequire("iEYBu");


var $bHWAG = parcelRequire("bHWAG");

const $3b7fa3742d344605$var$TARGET_SELECTOR = '#AkMainContent';
const $3b7fa3742d344605$var$COVER_ID = 'print-cover-page';
const $3b7fa3742d344605$var$STYLE_DATA_ATTR = 'data-print-cover-style';
function $3b7fa3742d344605$var$ensurePrintStyles() {
    if (typeof document === 'undefined') return;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (document.head.querySelector(`style[${$3b7fa3742d344605$var$STYLE_DATA_ATTR}="true"]`)) return;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const style = document.createElement('style');
    style.setAttribute($3b7fa3742d344605$var$STYLE_DATA_ATTR, 'true');
    style.textContent = `
				/* Hidden on screen; visible when printing */
				#${$3b7fa3742d344605$var$COVER_ID} { display: none; }

				@media print {
				#${$3b7fa3742d344605$var$COVER_ID} {
					display: block !important;
					break-after: page;        /* modern */
					page-break-after: always; /* legacy */
				}
					
				/* Hide only the layout header when printing */
					header[data-layout-slot="true"] {
						display: none !important;
						visibility: hidden !important;
				}
			}`;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.head.appendChild(style);
}
function $3b7fa3742d344605$export$4b3266eb0ec6c746(enabled, intl) {
    const rootRef = (0, $cozmU.useRef)(null);
    const hostRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!enabled || typeof window === 'undefined' || typeof document === 'undefined') return;
        $3b7fa3742d344605$var$ensurePrintStyles();
        (0, $bHWAG.preloadImage)((0, (/*@__PURE__*/$parcel$interopDefault($izCjj))));
        const before = ()=>{
            if (!(0, $bHWAG.isPageViewRoute)(window.location.pathname)) return;
            // find the main content container where we'll inject the cover page
            const target = document.querySelector($3b7fa3742d344605$var$TARGET_SELECTOR);
            // exit early if target element doesn't exist
            if (!target) return;
            // check if the cover page host container already exists in the DOM
            let host = document.getElementById($3b7fa3742d344605$var$COVER_ID);
            if (!host) {
                // Create a new host container if it doesn't exist
                host = document.createElement('div');
                host.id = $3b7fa3742d344605$var$COVER_ID;
            }
            /* insert the host as the first child of target so the cover page prints before content
      only insert if it's not already the first child (prevents duplicate insertions) */ if (target.firstChild !== host) target.insertBefore(host, target.firstChild);
            /* create a React root for the host container if it doesn't exist yet
      This allows us to render React components into this DOM node */ if (!rootRef.current) rootRef.current = (0, $fRQ3t.createRoot)(host);
            // render the cover page component with internationalization support
            // wrap it in IntlProvider to provide translations from the parent app
            rootRef.current.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
                locale: intl.locale,
                messages: intl.messages,
                defaultLocale: "en"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iEYBu.CoverPageComponent), null)));
            // store reference to the host element for cleanup later
            hostRef.current = host;
        };
        const after = ()=>{
            // clean up the React root to prevent memory leaks
            if (rootRef.current) {
                // unmount the React component tree from the DOM
                rootRef.current.unmount();
                rootRef.current = null;
            }
            // remove the host container from the DOM if it exists and has a parent
            if (hostRef.current?.parentNode) // remove the cover page element from its parent node
            hostRef.current.parentNode.removeChild(hostRef.current);
            // clear the host element reference
            hostRef.current = null;
        };
        window.addEventListener('beforeprint', before);
        window.addEventListener('afterprint', after);
        // safety: some browsers may skip afterprint on cancel
        const onVisibility = ()=>{
            if (document.visibilityState === 'visible') after();
        };
        document.addEventListener('visibilitychange', onVisibility);
        return ()=>{
            window.removeEventListener('beforeprint', before);
            window.removeEventListener('afterprint', after);
            document.removeEventListener('visibilitychange', onVisibility);
            after();
        };
    }, [
        enabled,
        intl
    ]);
}
module.exports["usePrintCoverInjector"] = $3b7fa3742d344605$export$4b3266eb0ec6c746;

});

parcelRegister("izCjj", function(module, exports) {
module.exports = new URL("PDFexport.298a755d.png", import.meta.url).toString();

});

parcelRegister("iEYBu", function(module, exports) {
/* PrintCoverComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $izCjj = parcelRequire("izCjj");

const $182813799a742845$export$d7f7fd46ad566704 = (0, $kSwu1.defineMessages)({
    printCoverHeader: {
        id: "pdf-print-utils.print-cover.header",
        defaultMessage: "Your page may not be formatted properly if you print now."
    },
    printCoverSubheader: {
        id: "pdf-print-utils.print-cover.subheader",
        defaultMessage: "To maintain your page's format, export it as a PDF before printing - either with \u2318P/Ctrl+P or by following these steps:"
    },
    printStep1: {
        id: "pdf-print-utils.print-cover.step1",
        defaultMessage: "Close this window"
    },
    printStep2: {
        id: "pdf-print-utils.print-cover.step2",
        defaultMessage: "Select More actions (\u2022\u2022\u2022) in the upper right."
    },
    printStep3: {
        id: "pdf-print-utils.print-cover.step3",
        defaultMessage: "Select Export > Export as PDF."
    },
    printStep4: {
        id: "pdf-print-utils.print-cover.step4",
        defaultMessage: "Download and open the PDF to print."
    },
    imageAlt: {
        id: "pdf-print-utils.print-cover.image-alt",
        defaultMessage: "PDF export instructions diagram"
    }
});
const $182813799a742845$var$coverWrapperStyles = (0, $buxP3.xcss)({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    width: '100%',
    padding: 'space.500',
    boxSizing: 'border-box',
    marginTop: 'space.100'
});
const $182813799a742845$var$headingStyles = null;
const $182813799a742845$var$subHeadingStyles = null;
const $182813799a742845$var$imgContStyles = (0, $buxP3.xcss)({
    marginTop: 'space.300',
    marginBottom: 'space.100',
    borderRadius: 'radius.large',
    overflow: 'hidden',
    boxShadow: 'elevation.shadow.overlay'
});
const $182813799a742845$var$imageStyles = null;
const $182813799a742845$var$listStyles = null;
const $182813799a742845$var$listItemStyles = null;
const $182813799a742845$export$a01b7b078c69ca5a = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $182813799a742845$var$coverWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("h1", {
        className: (0, $hekY6.default)([
            "_1wybldb6 _k48p1wq8 _syaz1kyx"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $182813799a742845$export$d7f7fd46ad566704.printCoverHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("h1", {
        className: (0, $hekY6.default)([
            "_1wyb1ou6 _19pk1ejb _k48p1wq8 _syaz1kyx"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $182813799a742845$export$d7f7fd46ad566704.printCoverSubheader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $182813799a742845$var$imgContStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        alt: intl.formatMessage($182813799a742845$export$d7f7fd46ad566704.imageAlt),
        src: (0, (/*@__PURE__*/$parcel$interopDefault($izCjj))),
        className: (0, $hekY6.default)([
            "_1bsb1osq _1e0c1ule"
        ])
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ol", {
        className: (0, $hekY6.default)([
            "_19pku2gc _bozgxy5q"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
        className: (0, $hekY6.default)([
            "_1wyb1gkc _yqp11wq8 _19pkv47k _bt1j1o8a _syaz1kyx"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $182813799a742845$export$d7f7fd46ad566704.printStep1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
        className: (0, $hekY6.default)([
            "_1wyb1gkc _yqp11wq8 _19pkv47k _bt1j1o8a _syaz1kyx"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $182813799a742845$export$d7f7fd46ad566704.printStep2)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
        className: (0, $hekY6.default)([
            "_1wyb1gkc _yqp11wq8 _19pkv47k _bt1j1o8a _syaz1kyx"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $182813799a742845$export$d7f7fd46ad566704.printStep3)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
        className: (0, $hekY6.default)([
            "_1wyb1gkc _yqp11wq8 _19pkv47k _bt1j1o8a _syaz1kyx"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $182813799a742845$export$d7f7fd46ad566704.printStep4))));
};
module.exports["CoverPageComponent"] = $182813799a742845$export$a01b7b078c69ca5a;

});

parcelRegister("02cx8", function(module, exports) {
/* eslint-disable object-shorthand */ 
var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $4c5988c837301b49$export$d4c72bab9d6cc13a = {
    actions: [],
    agentMentionId: null,
    agentMentionInsertionCount: 0,
    resolvedAgentMentionId: null,
    agentMentionContext: null,
    agentMentionPrompt: null,
    agentMentionName: null,
    agentMentionParentNodeType: null
};
const $4c5988c837301b49$export$e324594224ef24da = {
    setActions: (actions)=>({ setState: setState })=>{
            setState({
                actions: actions
            });
        },
    setContext: (context)=>({ setState: setState })=>{
            setState({
                context: context
            });
        },
    removeContext: ()=>({ setState: setState })=>{
            setState({
                context: undefined
            });
        },
    removeActions: ()=>({ setState: setState })=>{
            setState({
                actions: []
            });
        },
    setAgentMentionState: (state)=>({ setState: setState, getState: getState })=>{
            // Only reset resolvedAgentMentionId when the agent itself changes — not when
            // agentMentionContext updates (user typing after the mention) — to prevent the nudge
            // from flashing on every keystroke while the resolved UUID is already available.
            const current = getState();
            // Reset resolvedAgentMentionId when the agent changes OR when a new insertion
            // is made for the same agent — the insertion count increase means a new fetch
            // is about to start, and the old resolved UUID should not persist if it fails.
            const shouldResetResolved = state.agentMentionId !== current.agentMentionId || state.agentMentionInsertionCount !== current.agentMentionInsertionCount;
            setState({
                ...state,
                ...shouldResetResolved ? {
                    resolvedAgentMentionId: null
                } : {}
            });
        },
    setResolvedAgentMentionId: (resolvedAgentMentionId)=>({ setState: setState })=>{
            setState({
                resolvedAgentMentionId: resolvedAgentMentionId
            });
        }
};
const $4c5988c837301b49$export$e72cf4a64160987e = (0, $8s9DV.createStore)({
    initialState: $4c5988c837301b49$export$d4c72bab9d6cc13a,
    actions: $4c5988c837301b49$export$e324594224ef24da,
    name: 'EditorRovoButtonActionsStore'
});
const $4c5988c837301b49$export$b95031893a3d9d63 = (0, $kBr4q.createActionsHook)($4c5988c837301b49$export$e72cf4a64160987e);
const $4c5988c837301b49$export$c693678b9cc11679 = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.actions
});
const $4c5988c837301b49$export$59213a5c9f9d59b8 = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.context
});
const $4c5988c837301b49$export$f47243b349b78626 = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionId
});
const $4c5988c837301b49$export$65c1c9c4f5245bef = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionInsertionCount
});
const $4c5988c837301b49$export$c4372fb8872a2f0b = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.resolvedAgentMentionId
});
const $4c5988c837301b49$export$5c060a79a26e7361 = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionContext
});
const $4c5988c837301b49$export$4f371676b9a398fe = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionPrompt
});
const $4c5988c837301b49$export$95a191dd4fa0d1fd = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionName
});
const $4c5988c837301b49$export$f79a54b315516f9f = (0, $kBr4q.createStateHook)($4c5988c837301b49$export$e72cf4a64160987e, {
    selector: (state)=>state.agentMentionParentNodeType
});
module.exports["useEditorRovoButtonActions"] = $4c5988c837301b49$export$b95031893a3d9d63;
module.exports["useEditorRovoButtonActionsActions"] = $4c5988c837301b49$export$c693678b9cc11679;
module.exports["useEditorRovoButtonActionsContext"] = $4c5988c837301b49$export$59213a5c9f9d59b8;
module.exports["useEditorRovoButtonAgentMentionId"] = $4c5988c837301b49$export$f47243b349b78626;
module.exports["useEditorRovoButtonAgentMentionInsertionCount"] = $4c5988c837301b49$export$65c1c9c4f5245bef;
module.exports["useEditorRovoButtonResolvedAgentMentionId"] = $4c5988c837301b49$export$c4372fb8872a2f0b;
module.exports["useEditorRovoButtonAgentMentionContext"] = $4c5988c837301b49$export$5c060a79a26e7361;
module.exports["useEditorRovoButtonAgentMentionPrompt"] = $4c5988c837301b49$export$4f371676b9a398fe;
module.exports["useEditorRovoButtonAgentMentionName"] = $4c5988c837301b49$export$95a191dd4fa0d1fd;
module.exports["useEditorRovoButtonAgentMentionParentNodeType"] = $4c5988c837301b49$export$f79a54b315516f9f;

});

parcelRegister("ikPi2", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $2748374594b3931f$var$Store = (0, $8s9DV.createStore)({
    initialState: {
        fullPageEditorLoomUrl: undefined,
        pageCommentEditorLoomUrl: undefined,
        inlineCommentEditorLoomUrl: undefined
    },
    actions: {
        updateFullPageEditorLoomUrl: (video)=>({ setState: setState })=>{
                setState({
                    fullPageEditorLoomUrl: video
                });
            },
        updatePageCommentEditorLoomUrl: (video)=>({ setState: setState })=>{
                setState({
                    pageCommentEditorLoomUrl: video
                });
            }
    },
    name: 'loomUrlToInsert'
});
const $2748374594b3931f$export$f76207310d699374 = (0, $kBr4q.createHook)($2748374594b3931f$var$Store);
const $2748374594b3931f$export$b51bf851d750866c = ()=>$2748374594b3931f$export$f76207310d699374()[1];
module.exports["useLoomInsertUrlState"] = $2748374594b3931f$export$f76207310d699374;

});

parcelRegister("lJgYU", function(module, exports) {
let $56dfc7f357d53088$var$AP = null;

// simple-xdm relies on window object. It is not available in SSR.
if (typeof window !== 'undefined') {
    // @atlaskit/simple-xdm/plugin is an ES-module default export, so when loaded via require(), we need to read `.default` (otherwise we get the module namespace object)
    const requiredAP = (parcelRequire("kRpYm"));
    $56dfc7f357d53088$var$AP = requiredAP?.default ?? requiredAP;
}
function $56dfc7f357d53088$export$a5e99ae7010041ac(name) {
    if (!$56dfc7f357d53088$var$AP) return null;
    let requiredModule;
    try {
        $56dfc7f357d53088$var$AP.require(name, (module)=>{
            requiredModule = module;
        });
    } catch  {
        requiredModule = null;
    }
    return requiredModule;
}
module.exports["requireModule"] = $56dfc7f357d53088$export$a5e99ae7010041ac;

});

parcelRegister("kRpYm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
// @ts-nocheck

var $hTT73 = parcelRequire("hTT73");

const $25c7b5119159750b$var$_default_1 = new (0, $hTT73.default)();
var $25c7b5119159750b$export$2e2bcd8739ae039 = $25c7b5119159750b$var$_default_1;
module.exports["default"] = $25c7b5119159750b$export$2e2bcd8739ae039;

});

parcelRegister("hTT73", function(module, exports) {
// @ts-nocheck

var $9dHm9 = parcelRequire("9dHm9");


var $cyOhz = parcelRequire("cyOhz");


var $5gcue = parcelRequire("5gcue");


var $dZtJz = parcelRequire("dZtJz");


var $oQXlF = parcelRequire("oQXlF");


var $lh5PN = parcelRequire("lh5PN");


var $cm04U = parcelRequire("cm04U");


var $6InZw = parcelRequire("6InZw");


var $h7BEu = parcelRequire("h7BEu");

const $7bcf2feb883969e6$var$POSSIBLE_MODIFIER_KEYS = [
    'ctrl',
    'shift',
    'alt',
    'meta'
];
class $7bcf2feb883969e6$var$AP extends (0, $9dHm9.default) {
    _getHostFrame(offset) {
        // Climb up the iframe tree to find the real host
        if (offset && typeof offset === 'number') {
            var hostFrame = window;
            for(var i = 0; i < offset; i++)hostFrame = hostFrame.parent;
            return hostFrame;
        } else return this._top;
    }
    _isEmbeddedConfluenceUsage() {
        try {
            const uniqueKey = new URL(window.location.href).searchParams.get('uniqueKey');
            return uniqueKey !== null && uniqueKey.includes('embedded-confluence-iframe');
        } catch (e) {
            return false;
        }
    }
    _verifyHostFrameOffset() {
        // Asynchronously verify the host frame option with this._top
        var callback = (e)=>{
            if (e.source === this._top && e.data && typeof e.data.hostFrameOffset === 'number') {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                window.removeEventListener('message', callback);
                if (this._getHostFrame(e.data.hostFrameOffset) !== this._topHost) {
                    const isEmbeddedConfluence = this._isEmbeddedConfluenceUsage();
                    if (isEmbeddedConfluence) (0, $cyOhz.default).log('hostFrameOffset tampering detected in embedded-confluence context, but preserving current host frame');
                    else {
                        (0, $cyOhz.default).error('hostFrameOffset tampering detected, setting host frame to top window');
                        this._topHost = this._top;
                    }
                }
            }
        };
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('message', callback);
        this._top.postMessage({
            type: 'get_host_offset'
        }, this._hostOrigin);
    }
    _handleApiTamper(event) {
        if (event.data.tampered !== false) {
            this._host = undefined;
            this._apiTampered = true;
            (0, $cyOhz.default).error('XDM API tampering detected, api disabled');
        } else {
            this._apiTampered = false;
            this._onConfirmedFns.forEach(function(cb) {
                cb.apply(null);
            });
        }
        this._onConfirmedFns = [];
    }
    _registerOnUnload() {
        (0, $cm04U.default).bind(window, 'unload', (0, $cyOhz.default)._bind(this, function() {
            this._sendUnload(this._host, this._data.origin);
            if (this._isSubIframe) this._sendUnload(this._topHost, this._hostOrigin);
        }));
    }
    _sendUnload(frame, origin) {
        frame.postMessage({
            eid: this._data.extension_id,
            type: 'unload'
        }, origin || '*');
    }
    _bindKeyDown() {
        if (!this._isKeyDownBound) {
            (0, $cm04U.default).bind(window, 'keydown', (0, $cyOhz.default)._bind(this, this._handleKeyDownDomEvent));
            this._isKeyDownBound = true;
        }
    }
    _autoResizer() {
        this._enableAutoResize = Boolean((0, $dZtJz.default).get('autoresize'));
        if ((0, $oQXlF.default).get('resize') === false || (0, $oQXlF.default).get('sizeToParent') === true) this._enableAutoResize = false;
        if (this._enableAutoResize) this._initResize();
    }
    /**
   * The initialization data is passed in when the iframe is created as its 'name' attribute.
   * Example:
   * {
   *   extension_id: The ID of this iframe as defined by the host
   *   origin: 'https://example.org'  // The parent's window origin
   *   api: {
   *     _globals: { ... },
   *     messages = {
   *       clear: {},
   *       ...
   *     },
   *     ...
   *   }
   * }
   **/ _parseInitData(data) {
        try {
            return JSON.parse(data || window.name);
        } catch (e) {
            return {};
        }
    }
    _findTarget(moduleName, methodName) {
        return this._data.options && this._data.options.targets && this._data.options.targets[moduleName] && this._data.options.targets[moduleName][methodName] ? this._data.options.targets[moduleName][methodName] : 'top';
    }
    _createModule(moduleName, api) {
        return Object.getOwnPropertyNames(api).reduce((accumulator, memberName)=>{
            const member = api[memberName];
            if (member.hasOwnProperty('constructor')) accumulator[memberName] = this._createProxy(moduleName, member, memberName);
            else accumulator[memberName] = this._createMethodHandler({
                mod: moduleName,
                fn: memberName,
                returnsPromise: member.returnsPromise
            });
            return accumulator;
        }, {});
    }
    _setupAPI(api) {
        this._hostModules = Object.getOwnPropertyNames(api).reduce((accumulator, moduleName)=>{
            accumulator[moduleName] = this._createModule(moduleName, api[moduleName], api[moduleName]._options);
            return accumulator;
        }, {});
        Object.getOwnPropertyNames(this._hostModules._globals || {}).forEach((global)=>{
            this[global] = this._hostModules._globals[global];
        });
    }
    _setupAPIWithoutRequire(api) {
        Object.getOwnPropertyNames(api).forEach((moduleName)=>{
            if (typeof this[moduleName] !== 'undefined') throw new Error('XDM module: ' + moduleName + ' will collide with existing variable');
            this[moduleName] = this._createModule(moduleName, api[moduleName]);
        }, this);
    }
    _pendingCallback(mid, fn, metaData) {
        if (metaData) Object.getOwnPropertyNames(metaData).forEach((metaDataName)=>{
            fn[metaDataName] = metaData[metaDataName];
        });
        this._pendingCallbacks[mid] = fn;
    }
    _createProxy(moduleName, api, className) {
        const module = this._createModule(moduleName, api);
        function Cls(args) {
            if (!(this instanceof Cls)) return new Cls(arguments);
            this._cls = className;
            this._id = (0, $cyOhz.default).randomString();
            module.constructor.apply(this, args);
            return this;
        }
        Object.getOwnPropertyNames(module).forEach((methodName)=>{
            if (methodName !== 'constructor') Cls.prototype[methodName] = module[methodName];
        });
        return Cls;
    }
    _createMethodHandler(methodData) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let that = this;
        return function() {
            const args = (0, $cyOhz.default).argumentsToArray(arguments);
            const data = {
                eid: that._data.extension_id,
                type: 'req',
                mod: methodData.mod,
                fn: methodData.fn
            };
            var targetOrigin;
            var target;
            let xdmPromise;
            const mid = (0, $cyOhz.default).randomString();
            if (that._findTarget(methodData.mod, methodData.fn) === 'top') {
                target = that._topHost;
                targetOrigin = that._hostOrigin;
            } else {
                target = that._host;
                targetOrigin = that._data.origin;
            }
            if ((0, $cyOhz.default).hasCallback(args)) {
                data.mid = mid;
                that._pendingCallback(data.mid, args.pop(), {
                    useCallback: true,
                    isPromiseMethod: Boolean(methodData.returnsPromise)
                });
            } else if (methodData.returnsPromise) {
                data.mid = mid;
                xdmPromise = new Promise((resolve, reject)=>{
                    that._pendingCallback(data.mid, function(err, result) {
                        if (err || typeof result === 'undefined' && typeof err === 'undefined') reject(err);
                        else resolve(result);
                    }, {
                        useCallback: false,
                        isPromiseMethod: Boolean(methodData.returnsPromise)
                    });
                });
                xdmPromise.catch((err)=>{
                    (0, $cyOhz.default).warn(`Failed promise: ${err}`);
                });
            }
            if (this && this._cls) {
                data._cls = this._cls;
                data._id = this._id;
            }
            data.args = (0, $cyOhz.default).sanitizeStructuredClone(args);
            if (that._isSubIframe && typeof that._apiTampered === 'undefined') that._onConfirmedFns.push(function() {
                target.postMessage(data, targetOrigin);
            });
            else target.postMessage(data, targetOrigin);
            if (xdmPromise) return xdmPromise;
        };
    }
    _handleResponse(event) {
        var data = event.data;
        if (!data.forPlugin) return;
        var pendingCallback = this._pendingCallbacks[data.mid];
        if (pendingCallback) {
            delete this._pendingCallbacks[data.mid];
            try {
                // Promise methods always return error result as first arg
                // If a promise method is invoked using callbacks, strip first arg.
                if (pendingCallback.useCallback && pendingCallback.isPromiseMethod) data.args.shift();
                pendingCallback.apply(window, data.args);
            } catch (e) {
                (0, $cyOhz.default).error(e.message, e.stack);
            }
        }
    }
    _handleEvent(event) {
        var sendResponse = function() {
            var args = (0, $cyOhz.default).argumentsToArray(arguments);
            event.source.postMessage({
                eid: this._data.extension_id,
                mid: event.data.mid,
                type: 'resp',
                args: args
            }, this._data.origin);
        };
        var data = event.data;
        sendResponse = (0, $cyOhz.default)._bind(this, sendResponse);
        sendResponse._context = {
            eventName: data.etyp
        };
        function toArray(handlers) {
            if (handlers) {
                if (!Array.isArray(handlers)) handlers = [
                    handlers
                ];
                return handlers;
            }
            return [];
        }
        var handlers = toArray(this._eventHandlers[data.etyp]);
        handlers = handlers.concat(toArray(this._eventHandlers._any));
        handlers.forEach((handler)=>{
            try {
                handler(data.evnt, sendResponse);
            } catch (e) {
                (0, $cyOhz.default).error('exception thrown in event callback for:' + data.etyp);
            }
        }, this);
        if (data.mid) sendResponse();
    }
    _handleKeyDownDomEvent(event) {
        var modifiers = [];
        $7bcf2feb883969e6$var$POSSIBLE_MODIFIER_KEYS.forEach((modifierKey)=>{
            if (event[modifierKey + 'Key']) modifiers.push(modifierKey);
        }, this);
        var keyListenerId = this._keyListenerId(event.keyCode, modifiers);
        var requestedKey = this._keyListeners.indexOf(keyListenerId);
        if (requestedKey >= 0) this._host.postMessage({
            eid: this._data.extension_id,
            keycode: event.keyCode,
            modifiers: modifiers,
            type: 'key_triggered'
        }, this._data.origin);
    }
    _keyListenerId(keycode, modifiers) {
        var keyListenerId = keycode;
        if (modifiers) {
            if (typeof modifiers === 'string') modifiers = [
                modifiers
            ];
            modifiers.sort();
            modifiers.forEach((modifier)=>{
                keyListenerId += '$$' + modifier;
            }, this);
        }
        return keyListenerId;
    }
    _handleKeyListen(postMessageEvent) {
        var keyListenerId = this._keyListenerId(postMessageEvent.data.keycode, postMessageEvent.data.modifiers);
        if (postMessageEvent.data.action === 'remove') {
            var index = this._keyListeners.indexOf(keyListenerId);
            this._keyListeners.splice(index, 1);
        } else if (postMessageEvent.data.action === 'add') {
            // only bind onKeyDown once a key is registered.
            this._bindKeyDown();
            this._keyListeners.push(keyListenerId);
        }
    }
    _checkOrigin(event) {
        let no_source_types = [
            'api_tamper'
        ];
        if (event.data && no_source_types.indexOf(event.data.type) > -1) return true;
        if (this._isSubIframe && event.source === this._topHost) return true;
        return event.origin === this._data.origin && event.source === this._host;
    }
    _handleInitReceived() {
        this._initReceived = true;
    }
    _sendInit(frame, origin) {
        var targets;
        if (frame === this._topHost && this._topHost !== window.parent) targets = (0, $dZtJz.default).get('targets');
        frame.postMessage({
            eid: this._data.extension_id,
            type: 'init',
            targets: targets
        }, origin || '*');
        this._initCheck && this._data.options.globalOptions.check_init && setTimeout(()=>{
            if (!this._initReceived) throw new Error('Initialization message not received');
        }, this._initTimeout);
    }
    broadcast(event, evnt) {
        if (!(0, $cyOhz.default).isString(event)) throw new Error('Event type must be string');
        this._host.postMessage({
            eid: this._data.extension_id,
            type: 'broadcast',
            etyp: event,
            evnt: evnt
        }, this._data.origin);
    }
    require(modules, callback) {
        let requiredModules = Array.isArray(modules) ? modules : [
            modules
        ], args = requiredModules.map((module)=>{
            return this._hostModules[module] || this._hostModules._globals[module];
        });
        callback.apply(window, args);
    }
    register(handlers) {
        if (typeof handlers === 'object') {
            this._eventHandlers = {
                ...this._eventHandlers,
                ...handlers
            };
            this._host.postMessage({
                eid: this._data.extension_id,
                type: 'event_query',
                args: Object.getOwnPropertyNames(handlers)
            }, this._data.origin);
        }
    }
    registerAny(handlers) {
        this.register({
            _any: handlers
        });
    }
    _initResize() {
        requestAnimationFrame(()=>this.resize());
        var autoresize = new (0, $5gcue.default)(this.resize);
        (0, $6InZw.default).add((0, $cyOhz.default)._bind(autoresize, autoresize.triggered));
    }
    constructor(options, initCheck = true){
        super();
        (0, $dZtJz.default).set(options);
        this._data = this._parseInitData();
        (0, $dZtJz.default).set(this._data.options);
        this._data.options = this._data.options || {};
        this._hostOrigin = this._data.options.hostOrigin || '*';
        this._top = window.top;
        this._host = window.parent || window;
        this._topHost = this._getHostFrame(this._data.options.hostFrameOffset);
        if (this._topHost !== this._top) this._verifyHostFrameOffset();
        this._initTimeout = 5000;
        this._initReceived = false;
        this._initCheck = initCheck;
        this._isKeyDownBound = false;
        this._hostModules = {};
        this._eventHandlers = {};
        this._pendingCallbacks = {};
        this._keyListeners = [];
        this._version = '%%GULP_INJECT_VERSION%%';
        this._apiTampered = undefined;
        this._isSubIframe = this._topHost !== window.parent;
        this._onConfirmedFns = [];
        this._promise = Promise;
        if (this._data.api) {
            this._setupAPI(this._data.api);
            this._setupAPIWithoutRequire(this._data.api);
        }
        this._messageHandlers = {
            init_received: this._handleInitReceived,
            resp: this._handleResponse,
            evt: this._handleEvent,
            key_listen: this._handleKeyListen,
            api_tamper: this._handleApiTamper
        };
        if (this._data.origin) {
            this._sendInit(this._host, this._data.origin);
            if (this._isSubIframe) this._sendInit(this._topHost, this._hostOrigin);
        }
        this._registerOnUnload();
        this.resize = (0, $cyOhz.default)._bind(this, (width, height)=>{
            if (!(0, $lh5PN.default)()) {
                (0, $cyOhz.default).warn('resize called before container or body appeared, ignoring');
                return;
            }
            var dimensions = (0, $h7BEu.default)();
            if (!width) width = dimensions.w;
            if (!height) height = dimensions.h;
            if (this._hostModules.env && this._hostModules.env.resize) this._hostModules.env.resize(width, height);
        });
        (0, $cm04U.default)((0, $cyOhz.default)._bind(this, this._autoResizer));
        this.container = (0, $lh5PN.default);
        this.size = (0, $h7BEu.default);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('click', (e)=>{
            this._host.postMessage({
                eid: this._data.extension_id,
                type: 'addon_clicked'
            }, this._hostOrigin);
        });
    }
}
var $7bcf2feb883969e6$export$2e2bcd8739ae039 = $7bcf2feb883969e6$var$AP;
module.exports["default"] = $7bcf2feb883969e6$export$2e2bcd8739ae039;

});

parcelRegister("5gcue", function(module, exports) {
// @ts-nocheck

var $cyOhz = parcelRequire("cyOhz");


var $h7BEu = parcelRequire("h7BEu");

class $33ff9e0081423b28$var$AutoResizeAction {
    _setVal(val, type, time) {
        this.dimensionStores[type] = this.dimensionStores[type].filter(function(entry) {
            return time - entry.setAt < 400;
        });
        this.dimensionStores[type].push({
            val: parseInt(val, 10),
            setAt: time
        });
    }
    _isFlicker(val, type) {
        return this.dimensionStores[type].length >= 5;
    }
    triggered(dimensions) {
        dimensions = dimensions || (0, $h7BEu.default)();
        let now = Date.now();
        this._setVal(dimensions.w, 'width', now);
        this._setVal(dimensions.h, 'height', now);
        var isFlickerWidth = this._isFlicker(dimensions.w, 'width', now);
        var isFlickerHeight = this._isFlicker(dimensions.h, 'height', now);
        if (isFlickerWidth) {
            dimensions.w = '100%';
            this.resizeError('SIMPLE XDM: auto resize flickering width detected, setting to 100%');
        }
        if (isFlickerHeight) {
            var vals = this.dimensionStores['height'].map((x)=>{
                return x.val;
            });
            dimensions.h = Math.max.apply(null, vals) + 'px';
            this.resizeError('SIMPLE XDM: auto resize flickering height detected, setting to: ' + dimensions.h);
        }
        this.callback(dimensions.w, dimensions.h);
    }
    constructor(callback){
        this.resizeError = (0, $cyOhz.default).throttle(function(msg) {
            // eslint-disable-next-line no-console
            console.info(msg);
        }, 1000);
        this.dimensionStores = {
            width: [],
            height: []
        };
        this.callback = callback;
    }
}
var $33ff9e0081423b28$export$2e2bcd8739ae039 = $33ff9e0081423b28$var$AutoResizeAction;
module.exports["default"] = $33ff9e0081423b28$export$2e2bcd8739ae039;

});

parcelRegister("h7BEu", function(module, exports) {
// @ts-nocheck

var $cyOhz = parcelRequire("cyOhz");


var $dZtJz = parcelRequire("dZtJz");


var $lh5PN = parcelRequire("lh5PN");

var $ca52132c9736667f$var$size = function(width, height, container) {
    var verticalScrollbarWidth = function() {
        var sbWidth = window.innerWidth - container.clientWidth;
        // sanity check only
        sbWidth = sbWidth < 0 ? 0 : sbWidth;
        sbWidth = sbWidth > 50 ? 50 : sbWidth;
        return sbWidth;
    };
    var horizontalScrollbarHeight = function() {
        var sbHeight = window.innerHeight - Math.min(container.clientHeight, document.documentElement.clientHeight);
        // sanity check only
        sbHeight = sbHeight < 0 ? 0 : sbHeight;
        sbHeight = sbHeight > 50 ? 50 : sbHeight;
        return sbHeight;
    };
    var w = width == null ? '100%' : width, h, docHeight;
    var widthInPx = Boolean((0, $dZtJz.default).get('widthinpx'));
    container = container || (0, $lh5PN.default)();
    if (!container) (0, $cyOhz.default).warn('size called before container or body appeared, ignoring');
    if (widthInPx && typeof w === 'string' && w.search('%') !== -1) w = Math.max(container.scrollWidth, container.offsetWidth, container.clientWidth);
    if (height) h = height;
    else {
        // Determine height of document element
        docHeight = Math.max(container.scrollHeight, document.documentElement.scrollHeight, container.offsetHeight, document.documentElement.offsetHeight, container.clientHeight, document.documentElement.clientHeight);
        if (container === document.body) h = docHeight;
        else {
            var computed = window.getComputedStyle(container);
            h = container.getBoundingClientRect().height;
            if (h === 0) h = docHeight;
            else {
                var additionalProperties = [
                    'margin-top',
                    'margin-bottom'
                ];
                additionalProperties.forEach(function(property) {
                    var floated = parseFloat(computed[property]);
                    h += floated;
                });
            }
        }
    }
    // Include iframe scroll bars if visible and using exact dimensions
    w = typeof w === 'number' && Math.min(container.scrollHeight, document.documentElement.scrollHeight) > Math.min(container.clientHeight, document.documentElement.clientHeight) ? w + verticalScrollbarWidth() : w;
    h = typeof h === 'number' && container.scrollWidth > container.clientWidth ? h + horizontalScrollbarHeight() : h;
    return {
        w: w,
        h: h
    };
};
var $ca52132c9736667f$export$2e2bcd8739ae039 = $ca52132c9736667f$var$size;
module.exports["default"] = $ca52132c9736667f$export$2e2bcd8739ae039;

});

parcelRegister("dZtJz", function(module, exports) {
// @ts-nocheck
/**
 * Extension wide configuration values
 */ class $b2bf9f594c34ad65$var$ConfigurationOptions {
    _flush() {
        this.options = {};
    }
    get(item) {
        return item ? this.options[item] : this.options;
    }
    set(data, value) {
        if (!data) return;
        if (value) data = {
            [data]: value
        };
        var keys = Object.getOwnPropertyNames(data);
        keys.forEach((key)=>{
            this.options[key] = data[key];
        }, this);
    }
    constructor(){
        this.options = {};
    }
}
const $b2bf9f594c34ad65$var$_default_1 = new $b2bf9f594c34ad65$var$ConfigurationOptions();
var $b2bf9f594c34ad65$export$2e2bcd8739ae039 = $b2bf9f594c34ad65$var$_default_1;
module.exports["default"] = $b2bf9f594c34ad65$export$2e2bcd8739ae039;

});

parcelRegister("lh5PN", function(module, exports) {
// @ts-nocheck

var $cm04U = parcelRequire("cm04U");

function $eb1a632455abaab6$var$getContainer() {
    // Look for these two selectors first... you need these to allow for the auto-shrink to work
    // Otherwise, it'll default to document.body which can't auto-grow or auto-shrink
    var container = (0, $cm04U.default)('.ac-content, #content');
    return container.length > 0 ? container[0] : document.body;
}
var $eb1a632455abaab6$export$2e2bcd8739ae039 = $eb1a632455abaab6$var$getContainer;
module.exports["default"] = $eb1a632455abaab6$export$2e2bcd8739ae039;

});

parcelRegister("cm04U", function(module, exports) {
// @ts-nocheck

var $cyOhz = parcelRequire("cyOhz");

var $75451bb44e2c6f58$var$each = (0, $cyOhz.default).each, $75451bb44e2c6f58$var$document = window.document;
const $75451bb44e2c6f58$var$$ = function(sel, context) {
    context = context || $75451bb44e2c6f58$var$document;
    var els = [];
    if (sel) {
        if (typeof sel === 'string') {
            var results = context.querySelectorAll(sel), arr_results = Array.prototype.slice.call(results);
            Array.prototype.push.apply(els, arr_results);
        } else if (sel.nodeType === 1) els.push(sel);
        else if (sel === window) els.push(sel);
        else if (typeof sel === 'function') $75451bb44e2c6f58$var$$.onDomLoad(sel);
    }
    (0, $cyOhz.default).extend(els, {
        each: function(it) {
            $75451bb44e2c6f58$var$each(this, it);
            return this;
        },
        bind: function(name, callback) {
            this.each(function(i, el) {
                this.bind(el, name, callback);
            });
        },
        attr: function(k) {
            var v;
            this.each(function(i, el) {
                v = el[k] || el.getAttribute && el.getAttribute(k);
                return !v;
            });
            return v;
        },
        removeClass: function(className) {
            return this.each(function(i, el) {
                if (el.className) el.className = el.className.replace(new RegExp('(^|\\s)' + className + '(\\s|$)'), ' ');
            });
        },
        html: function(html) {
            return this.each(function(i, el) {
                el.innerHTML = html;
            });
        },
        append: function(spec) {
            return this.each(function(i, to) {
                var el = context.createElement(spec.tag);
                $75451bb44e2c6f58$var$each(spec, function(k, v) {
                    if (k === '$text') {
                        if (el.styleSheet) // style tags in ie
                        el.styleSheet.cssText = v;
                        else el.appendChild(context.createTextNode(v));
                    } else if (k !== 'tag') el[k] = v;
                });
                to.appendChild(el);
            });
        }
    });
    return els;
};
function $75451bb44e2c6f58$var$binder(std, odd) {
    std += 'EventListener';
    odd += 'Event';
    return function(el, e, fn) {
        if (el[std]) el[std](e, fn, false);
        else if (el[odd]) el[odd]('on' + e, fn);
    };
}
$75451bb44e2c6f58$var$$.bind = $75451bb44e2c6f58$var$binder('add', 'attach');
$75451bb44e2c6f58$var$$.unbind = $75451bb44e2c6f58$var$binder('remove', 'detach');
$75451bb44e2c6f58$var$$.onDomLoad = function(func) {
    var w = window, readyState = w.document.readyState;
    if (readyState === 'complete') func.call(w);
    else $75451bb44e2c6f58$var$$.bind(w, 'load', function() {
        func.call(w);
    });
};
var $75451bb44e2c6f58$export$2e2bcd8739ae039 = $75451bb44e2c6f58$var$$;
module.exports["default"] = $75451bb44e2c6f58$export$2e2bcd8739ae039;

});

parcelRegister("oQXlF", function(module, exports) {
// @ts-nocheck

var $cm04U = parcelRequire("cm04U");

class $8d9cf5d3bcef67a3$var$ConsumerOptions {
    _elementExists($el) {
        return $el && $el.length === 1;
    }
    _elementOptions($el) {
        return $el.attr('data-options');
    }
    _getConsumerOptions() {
        var options = {}, $optionElement = (0, $cm04U.default)('#ac-iframe-options'), $scriptElement = (0, $cm04U.default)("script[src*='/atlassian-connect/all']"), $cdnScriptElement = (0, $cm04U.default)("script[src*='/connect-cdn.atl-paas.net/all']"), $fedrampCdnScriptElement = (0, $cm04U.default)("script[src*='/connect-alljs-cdn-bifrost.frontend.cdn.atlassian-us-gov-mod.com/assets/all']");
        if (!this._elementExists($optionElement) || !this._elementOptions($optionElement)) {
            if (this._elementExists($scriptElement)) $optionElement = $scriptElement;
            else if (this._elementExists($cdnScriptElement)) $optionElement = $cdnScriptElement;
            else if (this._elementExists($fedrampCdnScriptElement)) $optionElement = $fedrampCdnScriptElement;
        }
        if (this._elementExists($optionElement)) {
            // get its data-options attribute, if any
            var optStr = this._elementOptions($optionElement);
            if (optStr) // if found, parse the value into kv pairs following the format of a style element
            optStr.split(';').forEach((nvpair)=>{
                nvpair = nvpair.trim();
                if (nvpair) {
                    var nv = nvpair.split(':'), k = nv[0].trim(), v = nv[1].trim();
                    if (k && v != null) options[k] = v === 'true' || v === 'false' ? v === 'true' : v;
                }
            });
        }
        return options;
    }
    _flush() {
        delete this._options;
    }
    get(key) {
        if (!this._options) this._options = this._getConsumerOptions();
        if (key) return this._options[key];
        return this._options;
    }
}
const $8d9cf5d3bcef67a3$var$_default_1 = new $8d9cf5d3bcef67a3$var$ConsumerOptions();
var $8d9cf5d3bcef67a3$export$2e2bcd8739ae039 = $8d9cf5d3bcef67a3$var$_default_1;
module.exports["default"] = $8d9cf5d3bcef67a3$export$2e2bcd8739ae039;

});

parcelRegister("6InZw", function(module, exports) {
$parcel$export(module.exports, "default", () => $c577383934ab64c1$export$2e2bcd8739ae039);
// @ts-nocheck

var $lh5PN = parcelRequire("lh5PN");

function $c577383934ab64c1$var$EventQueue() {
    this.q = [];
    this.add = function(ev) {
        this.q.push(ev);
    };
    var i, j;
    this.call = function() {
        for(i = 0, j = this.q.length; i < j; i++)this.q[i].call();
    };
}
function $c577383934ab64c1$var$attachResizeEvent(element, resized) {
    if (!element.resizedAttached) {
        element.resizedAttached = new $c577383934ab64c1$var$EventQueue();
        element.resizedAttached.add(resized);
    } else if (element.resizedAttached) {
        element.resizedAttached.add(resized);
        return;
    }
    // padding / margins on the body causes numerous resizing bugs.
    if (element.nodeName === 'BODY') [
        'padding',
        'margin'
    ].forEach((attr)=>{
        element.style[attr + '-bottom'] = '0px';
        element.style[attr + '-top'] = '0px';
    }, this);
    element.resizeSensor = document.createElement('div');
    element.resizeSensor.className = 'ac-resize-sensor';
    var style = 'position: absolute; left: 0; top: 0; right: 0; bottom: 0; overflow: scroll; z-index: -1; visibility: hidden;';
    var styleChild = 'position: absolute; left: 0; top: 0;';
    element.resizeSensor.style.cssText = style;
    var expand = document.createElement('div');
    expand.className = 'ac-resize-sensor-expand';
    expand.style.cssText = style;
    var expandChild = document.createElement('div');
    expand.appendChild(expandChild);
    expandChild.style.cssText = styleChild;
    var shrink = document.createElement('div');
    shrink.className = 'ac-resize-sensor-shrink';
    shrink.style.cssText = style;
    var shrinkChild = document.createElement('div');
    shrink.appendChild(shrinkChild);
    shrinkChild.style.cssText = styleChild + ' width: 200%; height: 200%';
    element.resizeSensor.appendChild(expand);
    element.resizeSensor.appendChild(shrink);
    element.appendChild(element.resizeSensor);
    // https://bugzilla.mozilla.org/show_bug.cgi?id=548397
    // do not set body to relative
    if (element.nodeName !== 'BODY' && window.getComputedStyle && window.getComputedStyle(element).position === 'static') element.style.position = 'relative';
    var lastWidth, lastHeight;
    var reset = function() {
        expandChild.style.width = expand.offsetWidth + 10 + 'px';
        expandChild.style.height = expand.offsetHeight + 10 + 'px';
        expand.scrollLeft = expand.scrollWidth;
        expand.scrollTop = expand.scrollHeight;
        shrink.scrollLeft = shrink.scrollWidth;
        shrink.scrollTop = shrink.scrollHeight;
        lastWidth = element.offsetWidth;
        lastHeight = element.offsetHeight;
    };
    reset();
    var changed = function() {
        if (element.resizedAttached) element.resizedAttached.call();
    };
    var onScroll = function() {
        if (element.offsetWidth !== lastWidth || element.offsetHeight !== lastHeight) changed();
        reset();
    };
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    expand.addEventListener('scroll', onScroll);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    shrink.addEventListener('scroll', onScroll);
    var observerConfig = {
        attributes: true,
        attributeFilter: [
            'style'
        ]
    };
    var observer = new MutationObserver(onScroll);
    element.resizeObserver = observer;
    observer.observe(element, observerConfig);
}
var $c577383934ab64c1$export$2e2bcd8739ae039 = {
    add: function(fn) {
        var container = (0, $lh5PN.default)();
        $c577383934ab64c1$var$attachResizeEvent(container, fn);
    },
    remove: function() {
        var container = (0, $lh5PN.default)();
        if (container.resizeSensor) {
            container.resizeObserver.disconnect();
            container.removeChild(container.resizeSensor);
            delete container.resizeSensor;
            delete container.resizedAttached;
        }
    }
};

});

parcelRegister("dNj8O", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $2QUbq = parcelRequire("2QUbq");

const $dbbc9dfadaa1b3f4$export$fdc305387ebecd56 = ({ contentId: contentId, contentType: contentType, createAnalyticsEvent: createAnalyticsEvent, disallowFirstPublish: disallowFirstPublish, isLivePage: isLivePage })=>{
    const [isLiveDocConversionBlockedModalOpen, setIsLiveDocConversionBlockedModalOpen] = (0, $cozmU.useState)(false);
    const isLiveDocConversionBlockedModalOpenRef = (0, $cozmU.useRef)(false);
    const shouldBlockLiveDocConversion = isLivePage && disallowFirstPublish === true && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) && (0, $6mKj3.expValEquals)('confluence_approvals_live_doc_conversion_block_exp', 'isEnabled', true);
    const handleCloseLiveDocConversionBlockedModal = (0, $cozmU.useCallback)(()=>{
        isLiveDocConversionBlockedModalOpenRef.current = false;
        setIsLiveDocConversionBlockedModalOpen(false);
    }, []);
    const handleLiveDocConversionBlockedByApproval = (0, $cozmU.useCallback)(()=>{
        if (!isLiveDocConversionBlockedModalOpenRef.current) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'liveDocConversionBlockedScreen',
                source: (0, $2QUbq.APPROVALS_ANALYTICS_SOURCE),
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    isLivePage: isLivePage,
                    conversionSource: 'liveDocToPage'
                }
            }
        }).fire();
        isLiveDocConversionBlockedModalOpenRef.current = true;
        setIsLiveDocConversionBlockedModalOpen(true);
    }, [
        contentId,
        contentType,
        createAnalyticsEvent,
        isLivePage
    ]);
    return {
        handleCloseLiveDocConversionBlockedModal: handleCloseLiveDocConversionBlockedModal,
        handleLiveDocConversionBlockedByApproval: handleLiveDocConversionBlockedByApproval,
        isLiveDocConversionBlockedModalOpen: isLiveDocConversionBlockedModalOpen,
        shouldBlockLiveDocConversion: shouldBlockLiveDocConversion
    };
};
module.exports["useLiveDocConversionBlockedModal"] = $dbbc9dfadaa1b3f4$export$fdc305387ebecd56;

});

parcelRegister("3jM74", function(module, exports) {

let $26a877b0c5780756$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $26a877b0c5780756$var$load("garBx"),
    $26a877b0c5780756$var$load("c1gk3"),
    $26a877b0c5780756$var$load("l4MHo"),
    $26a877b0c5780756$var$load("k97np"),
    $26a877b0c5780756$var$load("9NRga"),
    $26a877b0c5780756$var$load("6wr18"),
    $26a877b0c5780756$var$load("c8Gsg"),
    $26a877b0c5780756$var$load("1SVGS"),
    $26a877b0c5780756$var$load("lUtW2"),
    $26a877b0c5780756$var$load("9twRG"),
    $26a877b0c5780756$var$load("cXgsM"),
    $26a877b0c5780756$var$load("j4lHi"),
    $26a877b0c5780756$var$load("1Pi84"),
    $26a877b0c5780756$var$load("c0XG0"),
    $26a877b0c5780756$var$load("hSDwk"),
    $26a877b0c5780756$var$load("3C5MX"),
    $26a877b0c5780756$var$load("5c2ir"),
    $26a877b0c5780756$var$load("8LtYa"),
    $26a877b0c5780756$var$load("4t77a"),
    $26a877b0c5780756$var$load("diyjB"),
    $26a877b0c5780756$var$load("i4oYl"),
    $26a877b0c5780756$var$load("ignwK"),
    $26a877b0c5780756$var$load("7eTC9"),
    $26a877b0c5780756$var$load("iErjZ"),
    $26a877b0c5780756$var$load("dJM6M"),
    $26a877b0c5780756$var$load("agv3Q"),
    $26a877b0c5780756$var$load("47s9y"),
    $26a877b0c5780756$var$load("1rM9D"),
    $26a877b0c5780756$var$load("3cN9G"),
    $26a877b0c5780756$var$load("dZYhM"),
    $26a877b0c5780756$var$load("6Xt27"),
    $26a877b0c5780756$var$load("hxVzR"),
    $26a877b0c5780756$var$load("Tjs4D"),
    $26a877b0c5780756$var$load("7EorR"),
    $26a877b0c5780756$var$load("hOaAV"),
    $26a877b0c5780756$var$load("66GvX"),
    $26a877b0c5780756$var$load("1qlDN"),
    $26a877b0c5780756$var$load("1yVM6"),
    $26a877b0c5780756$var$load("fINdN"),
    $26a877b0c5780756$var$load("6XCf4"),
    $26a877b0c5780756$var$load("Wowvf"),
    $26a877b0c5780756$var$load("9ZFGK"),
    $26a877b0c5780756$var$load("2hLAI"),
    $26a877b0c5780756$var$load("dCilB"),
    $26a877b0c5780756$var$load("1T8H1"),
    $26a877b0c5780756$var$load("fyKFO"),
    $26a877b0c5780756$var$load("d9sg7"),
    $26a877b0c5780756$var$load("l0N35"),
    $26a877b0c5780756$var$load("bU9L5"),
    $26a877b0c5780756$var$load("ekVH8"),
    $26a877b0c5780756$var$load("ffEVr"),
    $26a877b0c5780756$var$load("hhss7"),
    $26a877b0c5780756$var$load("gA528"),
    $26a877b0c5780756$var$load("iq6Zv")
]).then(()=>parcelRequire('8pP5E'));

});

parcelRegister("dkxaU", function(module, exports) {

var $75Ax4 = parcelRequire("75Ax4");

const $17b31ae3aa6020db$export$6a5c726aaec5b09 = (width)=>{
    const imgHeight = Math.floor(width / (0, $75Ax4.COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO));
    if (imgHeight < (0, $75Ax4.MIN_DYNAMIC_COVER_IMAGE_HEIGHT)) return 0, $75Ax4.MIN_DYNAMIC_COVER_IMAGE_HEIGHT;
    else if (imgHeight >= (0, $75Ax4.MAX_DYNAMIC_COVER_IMAGE_HEIGHT)) return 0, $75Ax4.MAX_DYNAMIC_COVER_IMAGE_HEIGHT;
    else return imgHeight;
};
module.exports["calcDynamicCoverImageHeight"] = $17b31ae3aa6020db$export$6a5c726aaec5b09;

});

parcelRegister("75Ax4", function(module, exports) {
const $4cdfc0aeee394c11$export$5a7e63ae23cefcb = 50;
const $4cdfc0aeee394c11$export$535fddacdd1506a3 = '?utm_source=Confluence&utm_medium=referral';
const $4cdfc0aeee394c11$export$41f496cb75ebdbf4 = 140;
const $4cdfc0aeee394c11$export$e1a10bbd512cde25 = 750;
const $4cdfc0aeee394c11$export$e63c70235aab4f60 = 38 / 7;
const $4cdfc0aeee394c11$export$a9612492250fd8ea = 'min(max(calc(calc( 100vw - var(--leftPanelWidth, 0px) - var(--leftSidebarWidth, 0px) - var(--rightPanelWidth, 0px) - var(--rightSidebarWidth, 0px) ) * (7 / 38)), 140px), 750px)';
const $4cdfc0aeee394c11$export$b143b999ce4b353a = `round(down, calc(100cqw / (${$4cdfc0aeee394c11$export$e63c70235aab4f60})), 1px)`;
const $4cdfc0aeee394c11$export$f94fb8385ddeea1f = 800;
const $4cdfc0aeee394c11$export$f60e801aad1e2af5 = 147;
const $4cdfc0aeee394c11$export$a682f4bbb3650e11 = 200;
module.exports["DEFAULT_POSITION_VALUE"] = $4cdfc0aeee394c11$export$5a7e63ae23cefcb;
module.exports["REFERRAL_LINK"] = $4cdfc0aeee394c11$export$535fddacdd1506a3;
module.exports["MIN_DYNAMIC_COVER_IMAGE_HEIGHT"] = $4cdfc0aeee394c11$export$41f496cb75ebdbf4;
module.exports["MAX_DYNAMIC_COVER_IMAGE_HEIGHT"] = $4cdfc0aeee394c11$export$e1a10bbd512cde25;
module.exports["COVER_IMAGE_WIDTH_TO_HEIGHT_RATIO"] = $4cdfc0aeee394c11$export$e63c70235aab4f60;
module.exports["CALCULATE_SCALED_COVER_IMAGE_HEIGHT_FOR_EDIT_PAGE"] = $4cdfc0aeee394c11$export$b143b999ce4b353a;
module.exports["COVER_IMAGE_FIXED_WIDTH"] = $4cdfc0aeee394c11$export$f94fb8385ddeea1f;
module.exports["COVER_IMAGE_FIXED_HEIGHT"] = $4cdfc0aeee394c11$export$f60e801aad1e2af5;
module.exports["SMART_SPACE_OVERVIEW_FIXED_HEIGHT_FULL_WIDTH"] = $4cdfc0aeee394c11$export$a682f4bbb3650e11;

});

parcelRegister("eieXD", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $02af7510cb9721a1$export$99d02219d259eb94);
$parcel$export(module.exports, "Transports", () => (parcelRequire("a2lmi")));

var $fbwmZ = parcelRequire("fbwmZ");


var $dcw8o = parcelRequire("dcw8o");


var $ilRwI = parcelRequire("ilRwI");


var $6NrTk = parcelRequire("6NrTk");


var $eIjjl = parcelRequire("eIjjl");


var $a2lmi = parcelRequire("a2lmi");

var $02af7510cb9721a1$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $02af7510cb9721a1$var$_window = (0, $6NrTk.getGlobalObject)();
if ($02af7510cb9721a1$var$_window.Sentry && $02af7510cb9721a1$var$_window.Sentry.Integrations) $02af7510cb9721a1$var$windowIntegrations = $02af7510cb9721a1$var$_window.Sentry.Integrations;
var $02af7510cb9721a1$export$99d02219d259eb94 = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, $02af7510cb9721a1$var$windowIntegrations), (0, $ilRwI)), $eIjjl);
$parcel$exportWildcard(module.exports, $dcw8o);

});

parcelRegister("dcw8o", function(module, exports) {
$parcel$export(module.exports, "Severity", () => (parcelRequire("dtZ6d")).Severity);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("hkv0W")).addGlobalEventProcessor);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("9HPf3")).addBreadcrumb);
$parcel$export(module.exports, "captureException", () => (parcelRequire("9HPf3")).captureException);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("9HPf3")).captureEvent);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("9HPf3")).captureMessage);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("9HPf3")).configureScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("amM2J")).getHubFromCarrier);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("amM2J")).getCurrentHub);
$parcel$export(module.exports, "Hub", () => (parcelRequire("amM2J")).Hub);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("amM2J")).makeMain);
$parcel$export(module.exports, "Scope", () => (parcelRequire("hkv0W")).Scope);
$parcel$export(module.exports, "Session", () => (parcelRequire("dQl3s")).Session);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("9HPf3")).startTransaction);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("a953x")).SDK_VERSION);
$parcel$export(module.exports, "setContext", () => (parcelRequire("9HPf3")).setContext);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("9HPf3")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("9HPf3")).setExtras);
$parcel$export(module.exports, "setTag", () => (parcelRequire("9HPf3")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("9HPf3")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("9HPf3")).setUser);
$parcel$export(module.exports, "withScope", () => (parcelRequire("9HPf3")).withScope);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("e9HlS")).BrowserClient);
$parcel$export(module.exports, "injectReportDialog", () => (parcelRequire("9whyS")).injectReportDialog);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("l17tw")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("l17tw")).eventFromMessage);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("eAdCn")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("eAdCn")).forceLoad);
$parcel$export(module.exports, "init", () => (parcelRequire("eAdCn")).init);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("eAdCn")).lastEventId);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("eAdCn")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("eAdCn")).showReportDialog);
$parcel$export(module.exports, "flush", () => (parcelRequire("eAdCn")).flush);
$parcel$export(module.exports, "close", () => (parcelRequire("eAdCn")).close);
$parcel$export(module.exports, "wrap", () => (parcelRequire("eAdCn")).wrap);
$parcel$export(module.exports, "SDK_NAME", () => (parcelRequire("7iBHc")).SDK_NAME);

var $dtZ6d = parcelRequire("dtZ6d");


var $9HPf3 = parcelRequire("9HPf3");

var $hkv0W = parcelRequire("hkv0W");

var $amM2J = parcelRequire("amM2J");

var $a953x = parcelRequire("a953x");

var $dQl3s = parcelRequire("dQl3s");


var $e9HlS = parcelRequire("e9HlS");


var $9whyS = parcelRequire("9whyS");


var $l17tw = parcelRequire("l17tw");


var $eAdCn = parcelRequire("eAdCn");


var $7iBHc = parcelRequire("7iBHc");


});

parcelRegister("7iBHc", function(module, exports) {
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var $55077470b8523cd3$export$ca61d37259221480 = 'sentry.javascript.browser';
module.exports["SDK_NAME"] = $55077470b8523cd3$export$ca61d37259221480;

});

parcelRegister("eIjjl", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("cEELl")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("51FBI")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("bNfZ4")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("6oUta")).LinkedErrors);
$parcel$export(module.exports, "UserAgent", () => (parcelRequire("aMh6Y")).UserAgent);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("lBiNe")).Dedupe);

var $cEELl = parcelRequire("cEELl");


var $51FBI = parcelRequire("51FBI");


var $bNfZ4 = parcelRequire("bNfZ4");


var $6oUta = parcelRequire("6oUta");


var $aMh6Y = parcelRequire("aMh6Y");


var $lBiNe = parcelRequire("lBiNe");


});

parcelRegister("a2lmi", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => (parcelRequire("l2hU1")).BaseTransport);
$parcel$export(module.exports, "FetchTransport", () => (parcelRequire("9yqZL")).FetchTransport);
$parcel$export(module.exports, "XHRTransport", () => (parcelRequire("5a5jw")).XHRTransport);
$parcel$export(module.exports, "makeNewFetchTransport", () => (parcelRequire("hu9Hi")).makeNewFetchTransport);
$parcel$export(module.exports, "makeNewXHRTransport", () => (parcelRequire("3FUEv")).makeNewXHRTransport);

var $l2hU1 = parcelRequire("l2hU1");


var $9yqZL = parcelRequire("9yqZL");


var $5a5jw = parcelRequire("5a5jw");


var $hu9Hi = parcelRequire("hu9Hi");


var $3FUEv = parcelRequire("3FUEv");


});

parcelRegister("9eE57", function(module, exports) {

var $ge2sX = parcelRequire("ge2sX");


var $04e9M = parcelRequire("04e9M");


var $5ZqQS = parcelRequire("5ZqQS");

const $e8c3b9e45ae9a31e$export$1a717feb4df1a945 = (names)=>{
    if (window.performance?.clearMarks) names.forEach((name)=>window.performance.clearMarks(name));
};
const $e8c3b9e45ae9a31e$export$1c64491a086778ac = (name)=>{
    if (window.performance?.getEntriesByType) {
        const entries = window.performance.getEntriesByType(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce = (name)=>{
    if (window.performance?.getEntriesByName) {
        const entries = window.performance.getEntriesByName(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d = (a, b)=>{
    const entryA = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(a);
    const entryB = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(b);
    if (entryA && entryB) return Math.abs(entryA.startTime - entryB.startTime);
    return undefined;
};
const $e8c3b9e45ae9a31e$export$f45af69d005a6ed = (name)=>{
    const mark = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(name);
    if (mark) return mark.startTime;
    return undefined;
};
const $e8c3b9e45ae9a31e$export$91b34dd9e71ad666 = ({ subject: subject, subjectId: subjectId = '' })=>{
    const startMark = `${subject}.${subjectId}.start`;
    const endMark = `${subject}.${subjectId}.end`;
    $e8c3b9e45ae9a31e$export$1a717feb4df1a945([
        startMark,
        endMark
    ]);
    window.performance?.mark?.(startMark);
};
// Filter out feature flags with falsy values to save user bandwidth
const $e8c3b9e45ae9a31e$var$filterFeatureFlags = (flags = {})=>Object.keys(flags).filter((key)=>flags[key]).reduce((acc, key)=>{
        acc[key] = flags[key];
        return acc;
    }, {});
const $e8c3b9e45ae9a31e$var$performanceEnd = async ({ details: details, subject: subject, subjectId: subjectId, includeFeatureFlags: includeFeatureFlags })=>{
    const endMark = `${subject}.${subjectId}.end`;
    window.performance?.mark?.(endMark);
    const duration = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d(`${subject}.${subjectId}.start`, endMark);
    if (duration === undefined) return;
    try {
        const analyticsClientPromise = (0, $04e9M.getAnalyticsWebClient)();
        const sessionDataPromise = includeFeatureFlags ? (0, $ge2sX.getSessionData)() : Promise.resolve({
            featureFlags: {}
        });
        const [client, { featureFlags: featureFlags }] = await Promise.all([
            analyticsClientPromise,
            sessionDataPromise
        ]);
        const filteredFeatureFlags = $e8c3b9e45ae9a31e$var$filterFeatureFlags(featureFlags);
        client.sendOperationalEvent({
            tags: [
                'performance'
            ],
            source: 'confluence-frontend',
            action: 'done',
            actionSubject: subject,
            actionSubjectId: subjectId,
            attributes: {
                featureFlags: filteredFeatureFlags,
                duration: duration,
                ...details
            }
        });
    } catch (ex) {
        // This is a catch-all no-op, to prevent analytics component from screwing
        // up the user experience in case of any unexpected errors.
        (0, $5ZqQS.getMonitoringClient)().submitError(ex, {
            attribution: 'unknown'
        });
    }
};
const $e8c3b9e45ae9a31e$export$9cbdebb35a11386 = ({ subject: subject, subjectId: subjectId = '', details: details = {}, includeFeatureFlags: includeFeatureFlags = false })=>{
    const endMarkExists = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(`${subject}.${subjectId}.end`);
    if (!endMarkExists) $e8c3b9e45ae9a31e$var$performanceEnd({
        details: details,
        includeFeatureFlags: includeFeatureFlags,
        subject: subject,
        subjectId: subjectId
    });
};
module.exports["clearMarks"] = $e8c3b9e45ae9a31e$export$1a717feb4df1a945;
module.exports["getEntryByName"] = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce;
module.exports["measureMarks"] = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d;
module.exports["getMark"] = $e8c3b9e45ae9a31e$export$f45af69d005a6ed;
module.exports["perfMarkStart"] = $e8c3b9e45ae9a31e$export$91b34dd9e71ad666;
module.exports["perfMarkEnd"] = $e8c3b9e45ae9a31e$export$9cbdebb35a11386;

});

parcelRegister("dtDUi", function(module, exports) {
/* eslint-disable prefer-template */ 
var $64KID = parcelRequire("64KID");


var $fMEnQ = parcelRequire("fMEnQ");

const $dab54f7f733e6dc2$var$DOC_LINK = 'https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4848884799/Debugging+Hydration+Mismatches';
const $dab54f7f733e6dc2$export$476b9d1d68660527 = [
    {
        matchers: [
            /Hydration failed because the initial UI does not match what was rendered on the server/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /The server could not finish this Suspense boundary, likely due to an error during server rendering/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This root received an early update, before anything was able hydrate. Switched the entire root to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Text content does not match server-rendered HTML./
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating this Suspense boundary. Switched to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    //Production errors
    {
        matchers: [
            /Minified React error #418/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server in production. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #419/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #421/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #422/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #423/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #424/
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #425/
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    }
];
const $dab54f7f733e6dc2$export$5796b97ecb5a412 = (errorString)=>{
    for (const { matchers: matchers, friendlyError: friendlyError, hydrationFailed: hydrationFailed } of $dab54f7f733e6dc2$export$476b9d1d68660527){
        if (matchers.some((matcher)=>matcher.test(errorString))) return {
            ...friendlyError,
            originalString: errorString,
            hydrationFailed: hydrationFailed
        };
    }
    return {
        friendlyMessage: 'An additional error occurred, attached below.',
        docLink: '',
        fallback: true,
        originalString: errorString,
        hydrationFailed: false
    };
};
const $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2 = (url)=>{
    const match = (0, $fMEnQ.Route).matchFirst(Object.values((0, $64KID.namedRoutes)), url);
    return {
        error: new Error(`Hydration failed on route ${match?.name}`),
        route: match?.name || 'unknown'
    };
};
function $dab54f7f733e6dc2$export$260985b5e8a6fce6({ source: source, route: route, errorWithRoute: errorWithRoute, isSSRReactStreaming: isSSRReactStreaming }) {
    const attribution = isSSRReactStreaming ? 'streaming-hydration' : 'hydration';
    const error = $dab54f7f733e6dc2$var$trimTextLength(errorWithRoute.message || String(errorWithRoute), 1000);
    return {
        type: 'sendOperationalEvent',
        data: {
            source: source,
            route: route,
            action: 'failed',
            actionSubject: 'hydration',
            attributes: {
                error: error,
                route: route,
                attribution: attribution,
                isSSRReactStreaming: isSSRReactStreaming
            }
        }
    };
}
function $dab54f7f733e6dc2$var$trimTextLength(text, maxLength) {
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
}
module.exports["matchHydrationError"] = $dab54f7f733e6dc2$export$5796b97ecb5a412;
module.exports["getHydrationErrorWithRoute"] = $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2;
module.exports["getHydrationFailureOperationalEvent"] = $dab54f7f733e6dc2$export$260985b5e8a6fce6;

});

parcelRegister("ir4h8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $ac2J9 = parcelRequire("ac2J9");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $abc73c6f5c74c436$var$useRouterLink = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $abc73c6f5c74c436$export$2e2bcd8739ae039 = $abc73c6f5c74c436$var$useRouterLink;
module.exports["default"] = $abc73c6f5c74c436$export$2e2bcd8739ae039;

});

parcelRegister("ac2J9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b797161b98bd0492$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $cozmU.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b797161b98bd0492$var$RouterLinkProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
            value: t1
        }, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        }
    }, children);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b797161b98bd0492$export$2e2bcd8739ae039 = $b797161b98bd0492$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $b797161b98bd0492$export$2931e0ee690eee88;

});

parcelRegister("lyWac", function(module, exports) {

var $3mugH = parcelRequire("3mugH");

function $6e8f7926b945fe5e$var$expandErrorToErrors(error) {
    // Error from createDataFetcherForSuspense might have nested errors
    const errors = [
        error
    ];
    if (Array.isArray(error.otherErrors)) errors.push(...error.otherErrors);
    delete error.otherErrors;
    return errors;
}
async function $6e8f7926b945fe5e$export$ba9c3910d56be969(values) {
    if (!Array.isArray(values)) values = [
        values
    ];
    return Promise.allSettled(values).then((results)=>{
        const errors = [];
        for (const result of results){
            if (result.status === 'rejected') errors.push(...$6e8f7926b945fe5e$var$expandErrorToErrors(result.reason));
            else if (result.status === 'fulfilled') {
                const fulfilledValue = result.value;
                if (fulfilledValue instanceof Error) errors.push(...$6e8f7926b945fe5e$var$expandErrorToErrors(fulfilledValue));
                else if (Array.isArray(fulfilledValue)) {
                    const filteredErrors = fulfilledValue.filter((value)=>value instanceof Error);
                    errors.push(...filteredErrors.flatMap($6e8f7926b945fe5e$var$expandErrorToErrors));
                }
            }
        }
        if (errors.length > 0) {
            // Errors on preloader functions are not meant to break anything.
            // But we still want to know them...
            for (const error of errors)(0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Error caught by waitForAllReturnWhenError: ${error.message}`));
            return errors;
        }
    });
}
module.exports["waitForAllReturnWhenError"] = $6e8f7926b945fe5e$export$ba9c3910d56be969;

});

parcelRegister("3mugH", function(module, exports) {

var $lrjR8 = parcelRequire("lrjR8");

const $d967841d02dde0d1$export$17bc715070d0e7ef = new (0, $lrjR8.SSRPrepareErrorsClient)();
module.exports["ssrPrepareErrorsClient"] = $d967841d02dde0d1$export$17bc715070d0e7ef;

});

parcelRegister("lrjR8", function(module, exports) {
class $7cc20c0ac0ad5b24$export$622a2782a1f9c63 {
    submitError(e, errorData = {}) {
        let additional = {};
        // Not actually importing the error class to avoid circular dependency
        const response = // RateLimitedError or BadStatusError
        e?.response || // Apollo Error
        e?.networkError?.response;
        if (response) additional = {
            response: {
                url: response.url,
                status: response.status,
                statusText: response.statusText
            }
        };
        this.errors.push({
            error: {
                message: e.message,
                stack: e.stack
            },
            meta: errorData,
            ...additional
        });
    }
    getErrors() {
        return this.errors;
    }
    constructor(){
        this.errors = void 0;
        this.errors = [];
    }
}
module.exports["SSRPrepareErrorsClient"] = $7cc20c0ac0ad5b24$export$622a2782a1f9c63;

});

parcelRegister("2iGHk", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b090c2970a43735$export$2e2bcd8739ae039);
var $3b090c2970a43735$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("4Uejl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jlWUB = parcelRequire("jlWUB");


var $lrDw7 = parcelRequire("lrDw7");


var $7BVQi = parcelRequire("7BVQi");


var $g3XYx = parcelRequire("g3XYx");


var $1U6E9 = parcelRequire("1U6E9");


var $jhrdR = parcelRequire("jhrdR");

/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $8b8583a0a90649e3$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $8b8583a0a90649e3$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $8b8583a0a90649e3$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $8b8583a0a90649e3$export$a300664a1a230956 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion } = t0;
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            cleanup: "next-effect"
        };
        $[0] = t1;
    } else t1 = $[0];
    const setTimeout = (0, $1U6E9.useSetTimeout)(t1);
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    let t2;
    if ($[1] !== element) {
        t2 = ()=>{
            if ((0, $jlWUB.isReducedMotion)() || !element) return;
            const rect = element.getBoundingClientRect();
            prevDimensions.current = {
                width: rect.width,
                height: rect.height
            };
        };
        $[1] = element;
        $[2] = t2;
    } else t2 = $[2];
    (0, $jhrdR.useSnapshotBeforeUpdate)(t2);
    let t3;
    if ($[3] !== dimension || $[4] !== duration || $[5] !== easing || $[6] !== element || $[7] !== onFinishMotion || $[8] !== requestAnimationFrame || $[9] !== setTimeout) {
        t3 = ()=>{
            if ((0, $jlWUB.isReducedMotion)() || !element || !prevDimensions.current) return;
            element.setAttribute("style", "");
            const rect_0 = element.getBoundingClientRect();
            const nextDimensions = {
                width: rect_0.width,
                height: rect_0.height
            };
            if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
                onFinishMotion?.();
                return;
            }
            const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
            const newStyles = {
                willChange: propertyList,
                transitionProperty: propertyList,
                transitionDuration: duration,
                boxSizing: "border-box",
                transitionTimingFunction: easing
            };
            if (dimension === "width" || dimension === "both") newStyles.width = `${prevDimensions.current.width}px`;
            if (dimension === "height" || dimension === "both") newStyles.height = `${prevDimensions.current.height}px`;
            Object.assign(element.style, newStyles);
            const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (!element) return;
                    if (dimension === "width" || dimension === "both") element.style.width = `${nextDimensions.width}px`;
                    if (dimension === "height" || dimension === "both") element.style.height = `${nextDimensions.height}px`;
                    setTimeout(()=>{
                        if (!element) return;
                        element.setAttribute("style", "");
                        onFinishMotion?.();
                    }, resolvedDuration);
                });
            });
        };
        $[3] = dimension;
        $[4] = duration;
        $[5] = easing;
        $[6] = element;
        $[7] = onFinishMotion;
        $[8] = requestAnimationFrame;
        $[9] = setTimeout;
        $[10] = t3;
    } else t3 = $[10];
    (0, $7BVQi.useLayoutEffect)(t3);
    let t4;
    if ($[11] !== setElementRef) {
        t4 = {
            ref: setElementRef
        };
        $[11] = setElementRef;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion })=>{
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    const setTimeout = (0, $1U6E9.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    (0, $jhrdR.useSnapshotBeforeUpdate)(()=>{
        if ((0, $jlWUB.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $7BVQi.useLayoutEffect)(()=>{
        if ((0, $jlWUB.isReducedMotion)() || !element || !prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect_0 = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect_0.width,
            height: rect_0.height
        };
        if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
module.exports["useResizing"] = $8b8583a0a90649e3$export$a300664a1a230956;

});

parcelRegister("4vyfK", function(module, exports) {

var $dAxoX = parcelRequire("dAxoX");


var $dYU3e = parcelRequire("dYU3e");


var $fEmGS = parcelRequire("fEmGS");


var $6mKj3 = parcelRequire("6mKj3");


var $iEfsZ = parcelRequire("iEfsZ");


var $eSLr0 = parcelRequire("eSLr0");

const $2272f3d6a41ef128$var$preloadWebItemLocationWithSpaceKeyQuery = (0, $dAxoX.default);
const $2272f3d6a41ef128$var$isSystemBatchLocation = (location)=>location.length === 2 && location.includes((0, $eSLr0.SYSTEM_HEADER_LEFT)) && location.includes((0, $eSLr0.SYSTEM_USER));
// Keep this in sync with the editorToolbarLocations batched by
// load-edit-page/src/preload/preloadEditorData.ts.
const $2272f3d6a41ef128$var$CONTENT_BATCH_REQUIRED_LOCATIONS = [
    (0, $eSLr0.TOOLS_MENU_CONTAINER),
    (0, $eSLr0.SYSTEM_EDITOR_PRECURSOR_BUTTONS)
];
const $2272f3d6a41ef128$var$CONTENT_BATCH_ALLOWED_LOCATIONS = new Set([
    ...$2272f3d6a41ef128$var$CONTENT_BATCH_REQUIRED_LOCATIONS,
    (0, $eSLr0.PAGE_BUTTONS)
]);
const $2272f3d6a41ef128$var$isContentBatchLocation = (location)=>{
    const locationSet = new Set(location);
    return $2272f3d6a41ef128$var$CONTENT_BATCH_REQUIRED_LOCATIONS.every((requiredLocation)=>locationSet.has(requiredLocation)) && [
        ...locationSet
    ].every((candidateLocation)=>$2272f3d6a41ef128$var$CONTENT_BATCH_ALLOWED_LOCATIONS.has(candidateLocation));
};
const $2272f3d6a41ef128$var$filterSectionsByLocations = (webItemSections, locations)=>webItemSections.filter((section)=>locations.some((location)=>section?.id?.startsWith(`${location}/`)));
const $2272f3d6a41ef128$var$writeWebItemLocationCache = ({ locations: locations, contentId: contentId, spaceKey: spaceKey, version: version, webItemSections: webItemSections })=>{
    (0, $fEmGS.writeQueryInterop)({
        query: (0, $iEfsZ.default),
        variables: {
            location: null,
            locations: locations,
            contentId: contentId,
            spaceKey: spaceKey,
            version: version
        },
        data: {
            webItemSections: webItemSections
        },
        __callerPackage__: "web-item-location"
    });
};
const $2272f3d6a41ef128$var$writeWebItemLocationEntries = ({ locations: locations, contentId: contentId, spaceKey: spaceKey, version: version, webItemSections: webItemSections })=>{
    locations.forEach((location)=>{
        (0, $fEmGS.writeQueryInterop)({
            query: (0, $iEfsZ.default),
            variables: {
                location: location,
                locations: [],
                contentId: contentId,
                spaceKey: spaceKey,
                version: version
            },
            data: {
                webItemSections: $2272f3d6a41ef128$var$filterSectionsByLocations(webItemSections, [
                    location
                ])
            },
            __callerPackage__: "web-item-location"
        });
    });
};
function $2272f3d6a41ef128$export$8120ee10837c1dd({ location: location = null, contentId: contentId = null, spaceKey: spaceKey = null, version: version = null, context: context } = {}) {
    if (!contentId && spaceKey) return (0, $dYU3e.query)({
        query: $2272f3d6a41ef128$var$preloadWebItemLocationWithSpaceKeyQuery,
        variables: {
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            spaceKey: spaceKey,
            version: version
        },
        context: context,
        __callerPackage__: "web-item-location"
    }).then(({ data: data })=>{
        if (data?.space?.homepageId) (0, $fEmGS.writeQueryInterop)({
            query: (0, $iEfsZ.default),
            variables: {
                location: Array.isArray(location) ? null : location,
                locations: Array.isArray(location) ? location : [],
                contentId: data?.space?.homepageId,
                spaceKey: null,
                version: version
            },
            data: {
                webItemSections: data?.space?.homepageWebSections || []
            },
            __callerPackage__: "web-item-location"
        });
    });
    const variables = {
        // GraphQL doesn't cache single location strings properly when passed to locations
        // unless we're using multiple locations we should be using the location variable
        location: Array.isArray(location) ? null : location,
        locations: Array.isArray(location) ? location : [],
        contentId: contentId,
        spaceKey: spaceKey,
        version: version
    };
    const result = (0, $dYU3e.query)({
        query: (0, $iEfsZ.default),
        variables: variables,
        context: context,
        __callerPackage__: "web-item-location"
    });
    if (Array.isArray(location)) {
        const shouldWriteSystemBatchEntries = (0, $6mKj3.expValEquals)('web_item_query_batch_system_call', 'isEnabled', true) && $2272f3d6a41ef128$var$isSystemBatchLocation(location);
        const shouldWriteContentBatchEntries = $2272f3d6a41ef128$var$isContentBatchLocation(location) && (0, $6mKj3.expValEquals)('web_item_query_batch_content_call', 'isEnabled', true);
        if (shouldWriteSystemBatchEntries || shouldWriteContentBatchEntries) result.then(({ data: data })=>{
            if (!data?.webItemSections) return;
            $2272f3d6a41ef128$var$writeWebItemLocationCache({
                locations: location,
                contentId: contentId,
                spaceKey: spaceKey,
                version: version,
                webItemSections: data.webItemSections
            });
            $2272f3d6a41ef128$var$writeWebItemLocationEntries({
                locations: location,
                contentId: contentId,
                spaceKey: spaceKey,
                version: version,
                webItemSections: data.webItemSections
            });
            if (shouldWriteContentBatchEntries && location.includes((0, $eSLr0.PAGE_BUTTONS))) {
                const liveEllipsisLocations = [
                    (0, $eSLr0.TOOLS_MENU_CONTAINER),
                    (0, $eSLr0.PAGE_BUTTONS)
                ];
                $2272f3d6a41ef128$var$writeWebItemLocationCache({
                    locations: liveEllipsisLocations,
                    contentId: contentId,
                    spaceKey: spaceKey,
                    version: version,
                    webItemSections: $2272f3d6a41ef128$var$filterSectionsByLocations(data.webItemSections, liveEllipsisLocations)
                });
            }
        });
    }
    return result;
}
module.exports["preloadWebItemLocation"] = $2272f3d6a41ef128$export$8120ee10837c1dd;

});

parcelRegister("dAxoX", function(module, exports) {
/**
 * @generated SignedSource<<723e491a15ec21972dd962ca0e8f8ba8>>
 * @relayHash c407d329f5154dd3cb147b16d24f7f21
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3d78827b45ffa00d23f59d49283e3186acd1fae25701669aff456c7a90416511
const $074c400385fc6141$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "location"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locations"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "version"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "label"
    }, v3 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "homepageId"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "location",
                            "variableName": "location"
                        },
                        {
                            "kind": "Variable",
                            "name": "locations",
                            "variableName": "locations"
                        },
                        {
                            "kind": "Variable",
                            "name": "version",
                            "variableName": "version"
                        }
                    ],
                    "concreteType": "WebSection",
                    "kind": "LinkedField",
                    "name": "homepageWebSections",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "cacheKey"
                        },
                        v3 /*: any*/ ,
                        {
                            "concreteType": "WebItem",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "accessKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "completeKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasCondition"
                                },
                                v1 /*: any*/ ,
                                {
                                    "concreteType": "Icon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "height"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "width"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "path"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "MapOfStringToString",
                                    "kind": "LinkedField",
                                    "name": "params",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                },
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "moduleKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "section"
                                },
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "tooltip"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "url"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "urlWithoutContextPath"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "weight"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "c407d329f5154dd3cb147b16d24f7f21",
            "id": "3d78827b45ffa00d23f59d49283e3186acd1fae25701669aff456c7a90416511",
            "metadata": {},
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "operationKind": "query",
            "text": "query preloadWebItemLocationWithSpaceKeyQuery($location:String,$locations:[String],$spaceKey:String,$version:Int){space(key:$spaceKey){id,homepageId,homepageWebSections(location:$location,locations:$locations,version:$version){id,label,cacheKey,styleClass,items{accessKey,completeKey,hasCondition,id,icon{height,width,path},params{key,value},label,moduleKey,section,styleClass,tooltip,url,urlWithoutContextPath,weight}}}}"
        }
    };
}();
$074c400385fc6141$var$node.hash = "fb9ef136f5257fc82dc16b8dc37de41b";
var $074c400385fc6141$export$2e2bcd8739ae039 = $074c400385fc6141$var$node;
module.exports["default"] = $074c400385fc6141$export$2e2bcd8739ae039;

});

parcelRegister("2Zz3q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $g4vf3 = parcelRequire("g4vf3");

function $9d9e360fdbb0177e$export$954628993bf3188e(timeLeft) {
    if (timeLeft === null || timeLeft === undefined) return undefined;
    if (timeLeft <= 0) return 0;
    // Use Math.ceil to round up for fractional days
    return Math.ceil(timeLeft / (0, $g4vf3.MILLISECONDS_IN_A_DAY));
}
function $9d9e360fdbb0177e$export$165abb069513be0e(trialEndTime) {
    if (trialEndTime === null || trialEndTime === undefined) return undefined;
    return $9d9e360fdbb0177e$export$954628993bf3188e(trialEndTime - Date.now());
}
function $9d9e360fdbb0177e$export$bc3e0c760835aa1e(trialEndTime) {
    return (0, $cozmU.useMemo)(()=>$9d9e360fdbb0177e$export$165abb069513be0e(trialEndTime), [
        trialEndTime
    ]);
}
function $9d9e360fdbb0177e$export$ee6c4faab08346c(trialEndDate) {
    if (trialEndDate === null || trialEndDate === undefined) return undefined;
    // The expected format is YYYY-MM-DD, which is treated as UTC by the JS Date constructor
    return $9d9e360fdbb0177e$export$954628993bf3188e(new Date(trialEndDate).getTime() - Date.now());
}
function $9d9e360fdbb0177e$export$f13e974fb2ad4415(trialEndDate) {
    return (0, $cozmU.useMemo)(()=>$9d9e360fdbb0177e$export$ee6c4faab08346c(trialEndDate), [
        trialEndDate
    ]);
}
module.exports["getTrialDaysLeft"] = $9d9e360fdbb0177e$export$954628993bf3188e;
module.exports["getTrialDaysLeftFromTrialEndTime"] = $9d9e360fdbb0177e$export$165abb069513be0e;
module.exports["getTrialDaysLeftFromTrialEndDate"] = $9d9e360fdbb0177e$export$ee6c4faab08346c;

});

parcelRegister("g4vf3", function(module, exports) {
const $d163a47e1480b111$export$98a7370239de6730 = 86400000;
module.exports["MILLISECONDS_IN_A_DAY"] = $d163a47e1480b111$export$98a7370239de6730;

});

parcelRegister("wPrRK", function(module, exports) {


var $9WAeG = parcelRequire("9WAeG");


var $1xpoY = parcelRequire("1xpoY");



const $0a25e88d230f5014$export$df0dc85e162077fe = 500;
const $0a25e88d230f5014$export$e4579551e9b7b973 = async (name, task, timeout, skipSignal)=>{
    let timer = null;
    const slowQueryGuardTimeout = (0, $1xpoY.default).getNumber('confluence_frontend_slow_query_guard_timeout', $0a25e88d230f5014$export$df0dc85e162077fe);
    const finalTimeout = Math.max(timeout, slowQueryGuardTimeout);
    const timeoutPromise = new Promise((resolve)=>{
        timer = setTimeout(()=>{
            resolve(false);
        }, finalTimeout);
    });
    const runTask = async ()=>{
        const run = async ()=>{
            await (0, $9WAeG.SSRMeasures).run(`ssr-app/prepare/preloadQuery/slowQueryGuard:${name}`, task);
            if (timer) clearTimeout(timer);
            return true;
        };
        return run();
    };
    return Promise.race(skipSignal ? [
        timeoutPromise,
        skipSignal.then(()=>true),
        runTask()
    ] : [
        timeoutPromise,
        runTask()
    ]);
};
module.exports["SLOW_QUERY_DEFAULT_TIMEOUT"] = $0a25e88d230f5014$export$df0dc85e162077fe;
module.exports["slowQueryGuard"] = $0a25e88d230f5014$export$e4579551e9b7b973;

});

parcelRegister("4YBSq", function(module, exports) {
/**
 * @generated SignedSource<<9700b2b14bf1783e20ed515703a9c457>>
 * @relayHash f85bb73042ebe75e2cb50dec93f9b7c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ea06e652012418baf02c0133f828dbef03e488a63e53403257a821a52af7d139
const $16e983e3bee16ecd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fabricEditorSupported"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "embedded"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "collabService"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subType"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditContentButtonQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditContentButtonQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "f85bb73042ebe75e2cb50dec93f9b7c4",
            "id": "ea06e652012418baf02c0133f828dbef03e488a63e53403257a821a52af7d139",
            "metadata": {},
            "name": "EditContentButtonQuery",
            "operationKind": "query",
            "text": "query EditContentButtonQuery($contentId:ID!){content(id:$contentId){nodes{id,type,operations{operation,targetType},metadata{frontend{fabricEditorSupported,embedded,collabService}},subType,space{id,key}}}}"
        }
    };
}();
$16e983e3bee16ecd$var$node.hash = "94b096c536d2633f3df010c4409c1c2a";
var $16e983e3bee16ecd$export$2e2bcd8739ae039 = $16e983e3bee16ecd$var$node;
module.exports["default"] = $16e983e3bee16ecd$export$2e2bcd8739ae039;

});

parcelRegister("kwDQA", function(module, exports) {
/**
 * @generated SignedSource<<c4c634ffb5984138b240a2bcc61996d1>>
 * @relayHash 68505bc224ec19edfba49afd43c7d907
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7618a04782001a87f52f617aa9203459f640bc016a7615579a83c2dc59caaf99
const $377c093245c44338$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentAnalyticsViewers",
            "kind": "LinkedField",
            "name": "contentAnalyticsViewers",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "count"
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAnalyticsByLineQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAnalyticsByLineQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "68505bc224ec19edfba49afd43c7d907",
            "id": "7618a04782001a87f52f617aa9203459f640bc016a7615579a83c2dc59caaf99",
            "metadata": {},
            "name": "useAnalyticsByLineQuery",
            "operationKind": "query",
            "text": "query useAnalyticsByLineQuery($contentId:ID!){contentAnalyticsViewers(contentId:$contentId){count},user:confluence_atlassianUser(current:true){id,confluence{permissionType}}}"
        }
    };
}();
$377c093245c44338$var$node.hash = "1059930ceaf11a1fca0cb8f2f9d20c27";
var $377c093245c44338$export$2e2bcd8739ae039 = $377c093245c44338$var$node;
module.exports["default"] = $377c093245c44338$export$2e2bcd8739ae039;

});

parcelRegister("3cpum", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $6mKj3 = parcelRequire("6mKj3");


var $3lWl0 = parcelRequire("3lWl0");

function $3c6dabb2bbdb2dae$export$fd17b4d4de258fd0({ contentId: contentId, useCache: useCache, shouldGetDraftVersion: shouldGetDraftVersion }) {
    return (0, $dYU3e.query)({
        query: (0, $3lWl0.default),
        variables: {
            contentId: contentId,
            isDraft: shouldGetDraftVersion,
            shouldSkipContentStateLastUpdated: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) ? false : shouldGetDraftVersion,
            isApprovalsFgOn: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true),
            format: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) ? 'MILLIS' : 'USER_FRIENDLY'
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        __callerPackage__: "content-state"
    });
}
module.exports["preloadEditorContentState"] = $3c6dabb2bbdb2dae$export$fd17b4d4de258fd0;

});

parcelRegister("3lWl0", function(module, exports) {
/**
 * @generated SignedSource<<f94631fe88bfaea1f9346228f17314d1>>
 * @relayHash e78f45ef84b0309b46cad2982bdd129a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d9dbad7f6be18f479464c7740ecc608e88f02669cea51d9e028e75b6b84f4eb9
const $34dd87dd4e33f987$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "format"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isApprovalsFgOn"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldSkipAvailableContentStates"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldSkipContentStateLastUpdated"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldSkipEditOnlyFields"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "Variable",
        "name": "isDraft",
        "variableName": "isDraft"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "color"
    }, v11 = {
        "kind": "ScalarField",
        "name": "restrictionLevel"
    }, v12 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v7 /*: any*/ ,
                {
                    "args": [
                        v8 /*: any*/ 
                    ],
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "contentState",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        {
                            "condition": "shouldSkipEditOnlyFields",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isCallerPermitted"
                                }
                            ]
                        },
                        {
                            "condition": "isApprovalsFgOn",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "lastModifierAaid"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "shouldSkipContentStateLastUpdated",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "format",
                                    "variableName": "format"
                                },
                                v8 /*: any*/ 
                            ],
                            "concreteType": "ConfluenceDate",
                            "kind": "LinkedField",
                            "name": "contentStateLastUpdated",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "condition": "shouldSkipAvailableContentStates",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        }
                    ],
                    "concreteType": "AvailableContentStates",
                    "kind": "LinkedField",
                    "name": "availableContentStates",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentState",
                            "kind": "LinkedField",
                            "name": "customContentStates",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "ContentState",
                            "kind": "LinkedField",
                            "name": "spaceContentStates",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v7 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EditorContentStateQuery",
            "selections": v12 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EditorContentStateQuery",
            "selections": v12 /*: any*/ 
        },
        "params": {
            "cacheID": "e78f45ef84b0309b46cad2982bdd129a",
            "id": "d9dbad7f6be18f479464c7740ecc608e88f02669cea51d9e028e75b6b84f4eb9",
            "metadata": {},
            "name": "EditorContentStateQuery",
            "operationKind": "query",
            "text": "query EditorContentStateQuery($contentId:ID!,$isDraft:Boolean!,$isApprovalsFgOn:Boolean!,$format:GraphQLDateFormat!,$shouldSkipContentStateLastUpdated:Boolean!,$shouldSkipAvailableContentStates:Boolean=false,$shouldSkipEditOnlyFields:Boolean=false){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel,isCallerPermitted@skip(if:$shouldSkipEditOnlyFields),lastModifierAaid@include(if:$isApprovalsFgOn)},contentStateLastUpdated(format:$format,isDraft:$isDraft)@skip(if:$shouldSkipContentStateLastUpdated){value}},availableContentStates(contentId:$contentId)@skip(if:$shouldSkipAvailableContentStates){customContentStates{name,color,id},spaceContentStates{name,color,id,restrictionLevel}}}"
        }
    };
}();
$34dd87dd4e33f987$var$node.hash = "f76426744ff28f16601d3ae4d51a17fb";
var $34dd87dd4e33f987$export$2e2bcd8739ae039 = $34dd87dd4e33f987$var$node;
module.exports["default"] = $34dd87dd4e33f987$export$2e2bcd8739ae039;

});

parcelRegister("8EyOs", function(module, exports) {
/**
 * @generated SignedSource<<dd6200b047aed134b0d9af6a992daf7b>>
 * @relayHash 0c7e59589b279881378fc2baf2dcf71b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0dfd28d4a6a045f36efbb873be6de601dedb01632d322cff86c74287f8c186bb
const $231a29dfed7a7165$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "format"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isDraft",
                            "variableName": "isDraft"
                        }
                    ],
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "contentState",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "color"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "restrictionLevel"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "format",
                            "variableName": "format"
                        }
                    ],
                    "concreteType": "ConfluenceDate",
                    "kind": "LinkedField",
                    "name": "contentStateLastUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RendererContentStateQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RendererContentStateQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "0c7e59589b279881378fc2baf2dcf71b",
            "id": "0dfd28d4a6a045f36efbb873be6de601dedb01632d322cff86c74287f8c186bb",
            "metadata": {},
            "name": "RendererContentStateQuery",
            "operationKind": "query",
            "text": "query RendererContentStateQuery($contentId:ID!,$isDraft:Boolean!,$format:GraphQLDateFormat){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel},contentStateLastUpdated(format:$format){value}}}"
        }
    };
}();
$231a29dfed7a7165$var$node.hash = "a7f67982771d8fe760ba232b1260bced";
var $231a29dfed7a7165$export$2e2bcd8739ae039 = $231a29dfed7a7165$var$node;
module.exports["default"] = $231a29dfed7a7165$export$2e2bcd8739ae039;

});

parcelRegister("fxLAA", function(module, exports) {
/**
 * @generated SignedSource<<5cfab304ad9ee3e16291d55920b40235>>
 * @relayHash 912984cf5d8abb90acd2bf551dbccf8d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8b18eb1569f7e426cf298e33613a511d64fe4329ae6b5415b3a8a585452b18b3
const $d3bfdb752c338d80$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "embeddedContentRender"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeDevDocsBylineConnection"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isMarkdownModeEnabled"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useNewContentTopper"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionOverride"
    }, v9 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
    }, v10 = [
        {
            "kind": "Variable",
            "name": "embeddedContentRender",
            "variableName": "embeddedContentRender"
        },
        v9 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "status",
            "variableName": "status"
        },
        {
            "kind": "Variable",
            "name": "version",
            "variableName": "versionOverride"
        }
    ], v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = {
        "kind": "ScalarField",
        "name": "type"
    }, v13 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v14 = {
        "kind": "ScalarField",
        "name": "title"
    }, v15 = {
        "kind": "ScalarField",
        "name": "status"
    }, v16 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v17 = {
        "kind": "ScalarField",
        "name": "key"
    }, v18 = {
        "kind": "ScalarField",
        "name": "value"
    }, v19 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v11 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ 
            ]
        }
    ], v20 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "devdocsProperties",
                    "smartFolderProperties"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v19 /*: any*/ ,
        "storageKey": "properties(keys:[\"devdocsProperties\",\"smartFolderProperties\"])"
    }, v21 = {
        "kind": "ScalarField",
        "name": "number"
    }, v22 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v11 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        v21 /*: any*/ 
                    ]
                }
            ]
        }
    ], v23 = {
        "alias": "appearancePublished",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "content-appearance-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v22 /*: any*/ ,
        "storageKey": "properties(key:\"content-appearance-published\")"
    }, v24 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v26 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v27 = [
        v12 /*: any*/ ,
        v16 /*: any*/ ,
        v25 /*: any*/ ,
        v26 /*: any*/ 
    ], v28 = {
        "alias": "emojiTitlePublished",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v22 /*: any*/ ,
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v29 = {
        "condition": "useNewContentTopper",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": "pageTitlePublished",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "page-title-property-published"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v22 /*: any*/ ,
                "storageKey": "properties(key:\"page-title-property-published\")"
            }
        ]
    }, v30 = {
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "editor"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v19 /*: any*/ ,
        "storageKey": "properties(key:\"editor\")"
    }, v31 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "homepageId"
            }
        ]
    }, v32 = {
        "kind": "ScalarField",
        "name": "message"
    }, v33 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v34 = {
        "kind": "ScalarField",
        "name": "when"
    }, v35 = {
        "kind": "ScalarField",
        "name": "contentTypeModified"
    }, v36 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "generatedBy"
                    },
                    {
                        "condition": "isMarkdownModeEnabled",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isMarkdownMode"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v37 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "sourceTemplateEntityId"
            },
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                "kind": "LinkedField",
                "name": "frontend",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "fabricEditorSupported"
                    },
                    {
                        "condition": "useNewContentTopper",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "coverPictureWidth"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v38 = [
        v9 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        }
    ], v39 = {
        "kind": "ScalarField",
        "name": "count"
    }, v40 = {
        "kind": "ScalarField",
        "name": "isCurrentUserContributor"
    }, v41 = {
        "kind": "ScalarField",
        "name": "isOwnerContributor"
    }, v42 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "spaceKey"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            {
                "concreteType": "Theme",
                "kind": "LinkedField",
                "name": "theme",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "themeKey"
                    }
                ]
            },
            {
                "concreteType": "LookAndFeel",
                "kind": "LinkedField",
                "name": "lookAndFeel",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "MapOfStringToString",
                        "kind": "LinkedField",
                        "name": "headings",
                        "plural": true,
                        "selections": [
                            v17 /*: any*/ ,
                            v18 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "ContentLookAndFeel",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "ContainerLookAndFeel",
                                "kind": "LinkedField",
                                "name": "header",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "background"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundAttachment"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundBlendMode"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundClip"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundColor"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundImage"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundOrigin"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundPosition"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundRepeat"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundSize"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "borderRadius"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "padding"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v43 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v44 = [
        v43 /*: any*/ ,
        v12 /*: any*/ ,
        v16 /*: any*/ ,
        v25 /*: any*/ ,
        v26 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ContentHeaderUnifiedQuery",
            "selections": [
                {
                    "args": v10 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                {
                                    "condition": "includeDevDocsBylineConnection",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "ancestors",
                                            "plural": true,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v14 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                {
                                                    "concreteType": "History",
                                                    "kind": "LinkedField",
                                                    "name": "history",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "createdBy",
                                                            "plural": false,
                                                            "selections": [
                                                                v16 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v20 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v23 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        v24 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": v27 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v27 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "lastOwnedBy",
                                            "plural": false,
                                            "selections": v27 /*: any*/ 
                                        }
                                    ]
                                },
                                v28 /*: any*/ ,
                                v29 /*: any*/ ,
                                v30 /*: any*/ ,
                                v31 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v32 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v27 /*: any*/ 
                                        },
                                        v33 /*: any*/ ,
                                        v34 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v35 /*: any*/ 
                                    ]
                                },
                                v36 /*: any*/ ,
                                v37 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v38 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        v39 /*: any*/ ,
                        v40 /*: any*/ ,
                        v41 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v27 /*: any*/ 
                        }
                    ]
                },
                v42 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v5 /*: any*/ ,
                v8 /*: any*/ ,
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v7 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ContentHeaderUnifiedQuery",
            "selections": [
                {
                    "args": v10 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                {
                                    "condition": "includeDevDocsBylineConnection",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "ancestors",
                                            "plural": true,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v14 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                {
                                                    "concreteType": "History",
                                                    "kind": "LinkedField",
                                                    "name": "history",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "createdBy",
                                                            "plural": false,
                                                            "selections": [
                                                                v43 /*: any*/ ,
                                                                v16 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v20 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v23 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        v24 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": v44 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v44 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "lastOwnedBy",
                                            "plural": false,
                                            "selections": v44 /*: any*/ 
                                        }
                                    ]
                                },
                                v28 /*: any*/ ,
                                v29 /*: any*/ ,
                                v30 /*: any*/ ,
                                v31 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v32 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v44 /*: any*/ 
                                        },
                                        v33 /*: any*/ ,
                                        v34 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v35 /*: any*/ 
                                    ]
                                },
                                v36 /*: any*/ ,
                                v37 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v38 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        v39 /*: any*/ ,
                        v40 /*: any*/ ,
                        v41 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v44 /*: any*/ 
                        }
                    ]
                },
                v42 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "912984cf5d8abb90acd2bf551dbccf8d",
            "id": "8b18eb1569f7e426cf298e33613a511d64fe4329ae6b5415b3a8a585452b18b3",
            "metadata": {},
            "name": "ContentHeaderUnifiedQuery",
            "operationKind": "query",
            "text": "query ContentHeaderUnifiedQuery($contentId:ID!,$spaceKey:String,$versionOverride:Int,$embeddedContentRender:String,$limit:Int,$useNewContentTopper:Boolean=false,$isMarkdownModeEnabled:Boolean=false,$includeDevDocsBylineConnection:Boolean=false,$status:[String]){content(id:$contentId,version:$versionOverride,embeddedContentRender:$embeddedContentRender,status:$status){nodes{id,type,subType,title,status,ancestors@include(if:$includeDevDocsBylineConnection){id,title,type,subType,history{createdBy{__typename,displayName}},properties(keys:[\"devdocsProperties\",\"smartFolderProperties\"]){nodes{id,key,value}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},ownedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},properties(key:\"editor\"){nodes{id,key,value}},space{id,name,homepageId},version{message,by{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},friendlyWhen,when,number,contentTypeModified},contentProperties{latest{generatedBy,isMarkdownMode@include(if:$isMarkdownModeEnabled)}},metadata{sourceTemplateEntityId,lastModifiedDate,frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}}}},contentContributors(id:$contentId,limit:$limit){count,isCurrentUserContributor,isOwnerContributor,nodes{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},space(key:$spaceKey){id,theme{themeKey},lookAndFeel{headings{key,value},content{header{background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundRepeat,backgroundSize,borderRadius,padding}}}}}"
        }
    };
}();
$d3bfdb752c338d80$var$node.hash = "47f727e8d11fb190751ef8e60f6dbbbb";
var $d3bfdb752c338d80$export$2e2bcd8739ae039 = $d3bfdb752c338d80$var$node;
module.exports["default"] = $d3bfdb752c338d80$export$2e2bcd8739ae039;

});

parcelRegister("80xNa", function(module, exports) {
const $5d488939c8bec967$export$21191b0c00ca25f4 = 4;
const $5d488939c8bec967$export$4b915fb24c39b396 = {
    //copied from change-edition. Was not allowed to import it into preloadContentHeader + to prevent bundle size increase.
    FREE: 'FREE',
    PREMIUM: 'PREMIUM',
    STANDARD: 'STANDARD'
};
module.exports["DEFAULT_CONTRIBUTORS_FETCH_LIMIT"] = $5d488939c8bec967$export$21191b0c00ca25f4;
module.exports["CONFLUENCE_EDITION"] = $5d488939c8bec967$export$4b915fb24c39b396;

});

parcelRegister("568fA", function(module, exports) {
/**
 * @generated SignedSource<<e2045cb4c83675e7e407c2efe51efbe1>>
 * @relayHash f5377fb7a336ea197d2d8df561c3c35e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ba569705dcebdc323e95a461524d3052a4257acdc1042d3187378b46031e68ee
const $0dc90704ec36fa39$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "useObjectHeader"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "status",
            "value": [
                "archived",
                "current",
                "draft"
            ]
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "type"
    }, v8 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v9 = {
        "kind": "ScalarField",
        "name": "status"
    }, v10 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "smartFolderProperties"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"smartFolderProperties\"])"
    }, v11 = {
        "kind": "ScalarField",
        "name": "contentTypeModified"
    }, v12 = {
        "kind": "ScalarField",
        "name": "number"
    }, v13 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v14 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v15 = {
        "kind": "ScalarField",
        "name": "when"
    }, v16 = [
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                v14 /*: any*/ 
            ]
        },
        v15 /*: any*/ 
    ], v17 = [
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                v14 /*: any*/ 
            ]
        },
        v15 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentTypesHeaderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "condition": "useObjectHeader",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": v16 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "draftVersion",
                                            "plural": false,
                                            "selections": v16 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentTypesHeaderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "condition": "useObjectHeader",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": v17 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "draftVersion",
                                            "plural": false,
                                            "selections": v17 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "f5377fb7a336ea197d2d8df561c3c35e",
            "id": "ba569705dcebdc323e95a461524d3052a4257acdc1042d3187378b46031e68ee",
            "metadata": {},
            "name": "ContentTypesHeaderQuery",
            "operationKind": "query",
            "text": "query ContentTypesHeaderQuery($contentId:ID,$useObjectHeader:Boolean!){content(id:$contentId,status:[\"archived\",\"current\",\"draft\"]){nodes{id,title,operations{operation,targetType},space{id,name,key,alias},type,subType,status,properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version@include(if:$useObjectHeader){contentTypeModified,number,friendlyWhen,by{__typename,displayName},when}\n      draftVersion@include(if:$useObjectHeader){contentTypeModified,number,friendlyWhen,by{__typename,displayName},when}}}}"
        }
    };
}();
$0dc90704ec36fa39$var$node.hash = "2abb5d91a30df68c545d69974a9ee651";
var $0dc90704ec36fa39$export$2e2bcd8739ae039 = $0dc90704ec36fa39$var$node;
module.exports["default"] = $0dc90704ec36fa39$export$2e2bcd8739ae039;

});

parcelRegister("lPNkm", function(module, exports) {
/**
 * @generated SignedSource<<fcf122e4a0dd12a263fab6061b3a36dd>>
 * @relayHash 19081691cac2c634716f82092efd5e14
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3d5dc74f8943db901b65da9952c21aedcb442dbab7bde8fc78fddd85434811f3
const $98f50c7d6961f0d8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "html"
        },
        {
            "kind": "ScalarField",
            "name": "js"
        },
        {
            "kind": "ScalarField",
            "name": "css"
        },
        {
            "concreteType": "SpaUnfriendlyMacro",
            "kind": "LinkedField",
            "name": "spaUnfriendlyMacros",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceSettings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SpaceSettingsMetadata",
                            "kind": "LinkedField",
                            "name": "customHeaderAndFooter",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "HtmlMeta",
                                    "kind": "LinkedField",
                                    "name": "header",
                                    "plural": false,
                                    "selections": v1 /*: any*/ 
                                },
                                {
                                    "concreteType": "HtmlMeta",
                                    "kind": "LinkedField",
                                    "name": "footer",
                                    "plural": false,
                                    "selections": v1 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CustomHeaderFooterQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CustomHeaderFooterQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "19081691cac2c634716f82092efd5e14",
            "id": "3d5dc74f8943db901b65da9952c21aedcb442dbab7bde8fc78fddd85434811f3",
            "metadata": {},
            "name": "CustomHeaderFooterQuery",
            "operationKind": "query",
            "text": "query CustomHeaderFooterQuery($spaceKey:String){space(key:$spaceKey){id,settings{customHeaderAndFooter{header{html,js,css,spaUnfriendlyMacros{name}},footer{html,js,css,spaUnfriendlyMacros{name}}}}}}"
        }
    };
}();
$98f50c7d6961f0d8$var$node.hash = "deed3f087b4973bd7d276b1389cfb125";
var $98f50c7d6961f0d8$export$2e2bcd8739ae039 = $98f50c7d6961f0d8$var$node;
module.exports["default"] = $98f50c7d6961f0d8$export$2e2bcd8739ae039;

});

parcelRegister("fyUox", function(module, exports) {

var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $1Y111 = parcelRequire("1Y111");


var $zalpJ = parcelRequire("zalpJ");

const $bf604cb6b214d1ef$var$preloadHomepageId = async (spaceKey)=>{
    const res = await (0, $dYU3e.query)({
        query: (0, $zalpJ.PreloadHomepageIdQuery),
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "content-topper"
    });
    return res?.data?.space?.homepage?.id;
};
const $bf604cb6b214d1ef$var$preloadTitleContentProperty = (contentId, fetchPolicy = 'cache-first')=>(0, $dYU3e.query)({
        query: (0, $1Y111.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'archived',
                'draft'
            ]
        },
        fetchPolicy: fetchPolicy,
        __callerPackage__: "content-topper"
    });
const $bf604cb6b214d1ef$export$a65164d365713802 = async ({ contentId: contentId, contentIdPromise: contentIdPromise, spaceKey: spaceKey, fetchPolicy: fetchPolicy = 'cache-first' })=>{
    const promises = [];
    if (!contentId) {
        const homepageIdPromise = contentIdPromise || $bf604cb6b214d1ef$var$preloadHomepageId(spaceKey);
        promises.push(homepageIdPromise.then((homepageId)=>{
            return homepageId ? $bf604cb6b214d1ef$var$preloadTitleContentProperty(homepageId) : Promise.resolve({});
        }));
    } else promises.push($bf604cb6b214d1ef$var$preloadTitleContentProperty(contentId, fetchPolicy));
    return (0, $lyWac.waitForAllReturnWhenError)(promises);
};
module.exports["preloadPageTitleContentProperties"] = $bf604cb6b214d1ef$export$a65164d365713802;

});

parcelRegister("1Y111", function(module, exports) {
/**
 * @generated SignedSource<<c93173dea6bc8ed379cb4b9b29fb2a88>>
 * @relayHash 6af15886385d86202fbacd0200dc99eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ea0830d2908f5128944c3441d9d519bbd473f098af90ea4fb9f9816c899f8a0
const $66bccefa41a7dece$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "alias": "pageTitlePublished",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-published\")"
                        },
                        {
                            "alias": "pageTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-draft\")"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "coverPictureWidth"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "6af15886385d86202fbacd0200dc99eb",
            "id": "2ea0830d2908f5128944c3441d9d519bbd473f098af90ea4fb9f9816c899f8a0",
            "metadata": {},
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForPublishedPageQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}}}"
        }
    };
}();
$66bccefa41a7dece$var$node.hash = "9a5b243b4d944acf33577dfb16711cea";
var $66bccefa41a7dece$export$2e2bcd8739ae039 = $66bccefa41a7dece$var$node;
module.exports["default"] = $66bccefa41a7dece$export$2e2bcd8739ae039;

});

parcelRegister("zalpJ", function(module, exports) {

var $4lSsc = parcelRequire("4lSsc");


var $1Y111 = parcelRequire("1Y111");


var $jtuBN = parcelRequire("jtuBN");


var $jVylI = parcelRequire("jVylI");


var $gzIc1 = parcelRequire("gzIc1");

'use no memo';
const $20e32f1deb8c1fe0$var$UseTitleContentPropertiesForPublishedPageQuery = (0, $1Y111.default);
const $20e32f1deb8c1fe0$export$c9b63bbfd869a91 = (0, $4lSsc.default);
const $20e32f1deb8c1fe0$export$cef8b8531fa62d5f = (data)=>{
    const titlePropertyContent = data?.content?.nodes?.[0]?.pageTitlePublished?.nodes?.find((node)=>node?.key == 'page-title-property-published');
    const coverPictureWidth = data?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
    if (titlePropertyContent?.value) try {
        return {
            titleContentProperties: (0, $gzIc1.contentPropertyHelper)(titlePropertyContent),
            coverPictureWidth: coverPictureWidth
        };
    } catch  {
        return {
            titleContentProperties: (0, $jVylI.defaultPropertyValue),
            coverPictureWidth: coverPictureWidth
        };
    }
    else return {
        titleContentProperties: (0, $jVylI.defaultPropertyValue),
        coverPictureWidth: coverPictureWidth
    };
};
const $20e32f1deb8c1fe0$var$QUERY_OPTIONS = (contentId)=>({
        variables: {
            contentId: contentId,
            status: [
                'current',
                'archived',
                'draft'
            ]
        },
        fetchPolicy: 'cache-first'
    });
const $20e32f1deb8c1fe0$export$9e9d248809e028e8 = ({ contentId: contentId })=>{
    const options = $20e32f1deb8c1fe0$var$QUERY_OPTIONS(contentId);
    const { data: data, error: error, loading: loading } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($20e32f1deb8c1fe0$var$UseTitleContentPropertiesForPublishedPageQuery, {
        variables: options.variables,
        skip: !contentId,
        __callerPackage__: "content-topper"
    });
    if (!loading && data && !error) {
        const { titleContentProperties: titleContentProperties, coverPictureWidth: coverPictureWidth } = $20e32f1deb8c1fe0$export$cef8b8531fa62d5f(data);
        return {
            titleContentProperties: titleContentProperties,
            coverPictureWidth: coverPictureWidth
        };
    }
    return {
        titleContentProperties: (0, $jVylI.defaultPropertyValue),
        coverPictureWidth: (0, $jVylI.COVERPICTUREWIDTH).FULL
    };
};
module.exports["PreloadHomepageIdQuery"] = $20e32f1deb8c1fe0$export$c9b63bbfd869a91;
module.exports["getTitleContentProperty"] = $20e32f1deb8c1fe0$export$cef8b8531fa62d5f;
module.exports["useTitleContentPropertiesForPublishedPage"] = $20e32f1deb8c1fe0$export$9e9d248809e028e8;

});

parcelRegister("4lSsc", function(module, exports) {
/**
 * @generated SignedSource<<27d66eab829e89ba017f17104702246d>>
 * @relayHash 9a31bcd84d31650a9d9bf2ee5045af08
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d71357cc47e8209b6702e84965f7bc95e5209b869d1f811a6841b17bccc364cb
const $f70a6e2cb787614b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "9a31bcd84d31650a9d9bf2ee5045af08",
            "id": "d71357cc47e8209b6702e84965f7bc95e5209b869d1f811a6841b17bccc364cb",
            "metadata": {},
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery($spaceKey:String!){space(key:$spaceKey){id,homepage{id}}}"
        }
    };
}();
$f70a6e2cb787614b$var$node.hash = "57678666b7eece7bec595c782b54d686";
var $f70a6e2cb787614b$export$2e2bcd8739ae039 = $f70a6e2cb787614b$var$node;
module.exports["default"] = $f70a6e2cb787614b$export$2e2bcd8739ae039;

});

parcelRegister("gzIc1", function(module, exports) {

var $jVylI = parcelRequire("jVylI");

const $bda1e030ddde07df$export$e2d610ec02a291e1 = (jsonProperty)=>{
    let value;
    try {
        value = JSON.parse(jsonProperty.value);
        // objects returned from the content property can be double stringified
        const quoteMatches = value.match(/"/g);
        const quoteCount = quoteMatches ? quoteMatches.length : 0;
        // if quoteCount != null this means that the object is double wrapped as a string and needs to be parsed again
        if (quoteCount) try {
            value = JSON.parse(value);
        } catch (error) {
            value = (0, $jVylI.defaultPropertyValue);
            throw new Error(`unable to parse value: ${error.message}`);
        }
    } catch (error) {
        value = (0, $jVylI.defaultPropertyValue);
        throw error;
    }
    return value;
};
module.exports["contentPropertyHelper"] = $bda1e030ddde07df$export$e2d610ec02a291e1;

});

parcelRegister("1i2qc", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $dYU3e = parcelRequire("dYU3e");


var $iTcHJ = parcelRequire("iTcHJ");


var $6IsMq = parcelRequire("6IsMq");

const $ab4965c7462ff107$export$86e2470edfebdc54 = async (issueAri)=>{
    const response = await (0, $dYU3e.queryAgg)({
        query: (0, $6IsMq.default),
        variables: {
            issueAri: issueAri,
            maxTokenLength: 65536
        },
        __callerPackage__: "fabric-media-support"
    });
    return response;
};
const $ab4965c7462ff107$export$2d12daceb0197048 = async (contentId)=>{
    const response = await (0, $dYU3e.query)({
        query: (0, $iTcHJ.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft',
                'archived'
            ]
        },
        __callerPackage__: "fabric-media-support"
    });
    return response;
};
module.exports["preloadJiraMediaToken"] = $ab4965c7462ff107$export$86e2470edfebdc54;
module.exports["preloadMediaToken"] = $ab4965c7462ff107$export$2d12daceb0197048;

});

parcelRegister("k5dl6", function(module, exports) {
/**
 * @generated SignedSource<<6dc466aba14c78f3432cf6d35f092a95>>
 * @relayHash 9f9cb3b101c0d783a0151d795ee8a444
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 97db17732754f14f8a0a3024abfd1a748e416b71742d827d0bfd273f20b59b06
const $bff977656480fdfe$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v3 = {
        "args": [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "contentId"
            }
        ],
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v2 /*: any*/ 
                        ]
                    },
                    v2 /*: any*/ 
                ]
            }
        ]
    }, v4 = [
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        },
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ALL"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "UNRESOLVED"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "value"
    }, v6 = [
        v5 /*: any*/ 
    ], v7 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v6 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v8 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v6 /*: any*/ 
    }, v9 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v10 = {
        "kind": "ScalarField",
        "name": "isInlineComment"
    }, v11 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v13 = {
        "kind": "ScalarField",
        "name": "when"
    }, v14 = {
        "kind": "ScalarField",
        "name": "number"
    }, v15 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v12 /*: any*/ 
                ]
            },
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ]
    }, v16 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v17 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v20 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v21 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "replies",
        "plural": true,
        "selections": [
            v1 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v15 /*: any*/ ,
            v16 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v22 = {
        "alias": "user",
        "args": [
            {
                "kind": "Literal",
                "name": "current",
                "value": true
            }
        ],
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
            v1 /*: any*/ ,
            v12 /*: any*/ ,
            {
                "concreteType": "AtlassianUserPhoto",
                "kind": "LinkedField",
                "name": "photos",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isPrimary"
                    }
                ]
            }
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
    }, v23 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v24 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v23 /*: any*/ ,
                    v12 /*: any*/ 
                ]
            },
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ]
    }, v25 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v23 /*: any*/ ,
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v26 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "replies",
        "plural": true,
        "selections": [
            v1 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v24 /*: any*/ ,
            v16 /*: any*/ ,
            v25 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "InlineCommentsFocusedInlineCommentQuery",
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                },
                                v1 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ 
                            ]
                        }
                    ]
                },
                v22 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "InlineCommentsFocusedInlineCommentQuery",
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ 
                                    ]
                                },
                                v1 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v24 /*: any*/ ,
                                v16 /*: any*/ ,
                                v25 /*: any*/ ,
                                v26 /*: any*/ 
                            ]
                        }
                    ]
                },
                v22 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "9f9cb3b101c0d783a0151d795ee8a444",
            "id": "97db17732754f14f8a0a3024abfd1a748e416b71742d827d0bfd273f20b59b06",
            "metadata": {},
            "name": "InlineCommentsFocusedInlineCommentQuery",
            "operationKind": "query",
            "text": "query InlineCommentsFocusedInlineCommentQuery($commentId:ID!,$contentId:ID){content(id:$contentId){nodes{id,type,space{id,operations{operation,targetType}},operations{operation,targetType}}},comments(commentId:$commentId,depth:ALL,type:UNRESOLVED){nodes{ancestors{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}},id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}}},user:confluence_atlassianUser(current:true){id,displayName,photos{value,isPrimary}}}"
        }
    };
}();
$bff977656480fdfe$var$node.hash = "c6bc55705b1b90c4e9cb60ee0b5a4650";
var $bff977656480fdfe$export$2e2bcd8739ae039 = $bff977656480fdfe$var$node;
module.exports["default"] = $bff977656480fdfe$export$2e2bcd8739ae039;

});

parcelRegister("cvj7x", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $7W8i8 = parcelRequire("7W8i8");


var $65pdw = parcelRequire("65pdw");


var $1TElT = parcelRequire("1TElT");


var $3cpum = parcelRequire("3cpum");


var $7PLO8 = parcelRequire("7PLO8");


var $irrTO = parcelRequire("irrTO");


var $9sGCn = parcelRequire("9sGCn");


var $4trRg = parcelRequire("4trRg");

parcelRequire("kGDoD");
var $9nGwZ = parcelRequire("9nGwZ");


var $1c0dB = parcelRequire("1c0dB");


var $kDt9L = parcelRequire("kDt9L");


var $4vyfK = parcelRequire("4vyfK");


var $cRQNp = parcelRequire("cRQNp");


var $eSLr0 = parcelRequire("eSLr0");


var $8CHHT = parcelRequire("8CHHT");


var $7Ndnw = parcelRequire("7Ndnw");


var $lyWac = parcelRequire("lyWac");


var $fqIt3 = parcelRequire("fqIt3");


var $7K6Nt = parcelRequire("7K6Nt");


var $9OYfw = parcelRequire("9OYfw");


var $hr9NW = parcelRequire("hr9NW");

const $c13994d6914d469f$var$logger = (0, $7W8i8.getLogger)('load-edit-page');
async function $c13994d6914d469f$export$1149cf9041c3e7b8({ spaceKey: spaceKey, contentId: contentId, shouldPreloadMentionsProvider: shouldPreloadMentionsProvider = false, useCache: useCache = false, catchFn: // use cache for native editor data
catchFn, isBlog: isBlog, cloudId: cloudId, isLivePage: isLivePage = false }) {
    // note: explicitly casting to Promise<any> to avoid typescript incorrectly inferring tuple types; although we don't use the return value of this function regardless
    $c13994d6914d469f$var$logger.debug`Calling preloadEditorData ${performance.now() / 1000}`;
    const draftShareId = (0, $7PLO8.getDraftShareIdFromQueryParam)();
    // preload queries shared by Synchrony and Native Collab editors
    const immediateResultsPromises = [
        (0, $irrTO.preloadDraftContentAppearance)(contentId, useCache)
    ];
    // specific native collab editor queries
    if (!!contentId) {
        if ((0, $6mKj3.expValEquals)('web_item_query_batch_content_call', 'isEnabled', true)) {
            const editorToolbarLocations = isLivePage ? [
                (0, $eSLr0.TOOLS_MENU_CONTAINER),
                (0, $eSLr0.PAGE_BUTTONS),
                (0, $eSLr0.SYSTEM_EDITOR_PRECURSOR_BUTTONS)
            ] : [
                (0, $eSLr0.TOOLS_MENU_CONTAINER),
                (0, $eSLr0.SYSTEM_EDITOR_PRECURSOR_BUTTONS)
            ];
            immediateResultsPromises.push((0, $4vyfK.preloadWebItemLocation)({
                contentId: contentId,
                location: editorToolbarLocations
            }));
        }
        const collabDraftPromise = (0, $9OYfw.preloadCollabDraftContent)(contentId, draftShareId, (0, $6mKj3.expValEquals)('platform_editor_collabdraft_query_improvements', 'isEnabled', true) ? useCache || !(0, $fqIt3.isCollabDraftCacheStale)(contentId, draftShareId) : useCache);
        immediateResultsPromises.push(collabDraftPromise);
        immediateResultsPromises.push((0, $7K6Nt.preloadMacroDataFromCollabDraft)({
            collabDraftPromise: collabDraftPromise,
            context: {
                contentId: contentId,
                spaceKey: spaceKey || ''
            },
            route: isLivePage ? 'live' : 'edit'
        }));
        immediateResultsPromises.push((0, $hr9NW.preloadEditorNodeDataProvidersData)(contentId, cloudId, isBlog));
        const { isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(contentId ?? undefined);
        immediateResultsPromises.push((0, $4trRg.preloadContentMode)({
            contentId: contentId,
            isDraft: !isLivePage,
            useCache: useCache,
            isArchived: isArchived
        }));
        immediateResultsPromises.push((0, $1TElT.preloadEmojiTitle)(contentId, draftShareId, useCache), (0, $9OYfw.preloadNativeCollab)(contentId, draftShareId, useCache));
    }
    immediateResultsPromises.push((0, $65pdw.preloadEditorPageCoverPicture)(contentId, draftShareId, useCache), (0, $3cpum.preloadEditorContentState)({
        contentId: contentId,
        useCache: useCache,
        shouldGetDraftVersion: !isLivePage
    }));
    if (isLivePage) {
        // Pre-loading apps in the byline area for live pages. Currently only live pages have extension point apps and not classic editor.
        immediateResultsPromises.push((0, $4vyfK.preloadWebItemLocation)({
            contentId: contentId,
            location: (0, $eSLr0.SYSTEM_CONTENT_BYLINE)
        }), // For some reason the addition of the filter (uses new Forge query) is causing SSR to timeout - workaround by skipping the filter
        (0, $8CHHT.preloadUseExtensionList)({
            spaceKey: spaceKey || '',
            moduleType: (0, $7Ndnw.FORGE_MODULE_BYLINE)
        }));
        immediateResultsPromises.push((0, $9nGwZ.preloadLastUpdated)(contentId, useCache));
        immediateResultsPromises.push((0, $cRQNp.preloadReadTime)({
            contentId: contentId,
            useCache: useCache
        }));
    }
    if (shouldPreloadMentionsProvider) immediateResultsPromises.push((0, $kDt9L.preloadMentionsProvider)());
    immediateResultsPromises.push((0, $1c0dB.preloadEditorPageTitleContentProperties)({
        contentId: contentId,
        draftShareId: draftShareId,
        useCache: useCache
    }));
    await (0, $lyWac.waitForAllReturnWhenError)(immediateResultsPromises.map((p)=>!!catchFn ? p?.catch(catchFn) : p));
    $c13994d6914d469f$var$logger.debug`preloadEditorData complete ${performance.now() / 1000}`;
}
module.exports["preloadEditorData"] = $c13994d6914d469f$export$1149cf9041c3e7b8;

});

parcelRegister("65pdw", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $lC6Qd = parcelRequire("lC6Qd");

function $4e9d3c2f55d09139$export$cca2a63dd6cc6345(contentId, draftShareId, useCache) {
    return (0, $dYU3e.query)({
        query: (0, $lC6Qd.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            draftShareId: draftShareId
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        __callerPackage__: "page-cover-picture"
    });
}
module.exports["preloadEditorPageCoverPicture"] = $4e9d3c2f55d09139$export$cca2a63dd6cc6345;

});

parcelRegister("lC6Qd", function(module, exports) {
/**
 * @generated SignedSource<<809e2044c3792f08e4a1f1fd3c386e1c>>
 * @relayHash eca6e9d325c97f4fd5880178ecc63561
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2e9338430096a14321d43ffc4d7c87126164ce6f2d44ea4ede01d437b0ec12d
const $03de5ecc01e321ee$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "cover-picture-id-draft",
                                        "cover-picture-id-published"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "number"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CoverPictureQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CoverPictureQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "eca6e9d325c97f4fd5880178ecc63561",
            "id": "e2e9338430096a14321d43ffc4d7c87126164ce6f2d44ea4ede01d437b0ec12d",
            "metadata": {},
            "name": "CoverPictureQuery",
            "operationKind": "query",
            "text": "query CoverPictureQuery($contentId:ID,$status:[String],$draftShareId:String){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"]){nodes{id,key,value,version{number}}}}}}"
        }
    };
}();
$03de5ecc01e321ee$var$node.hash = "cbe85309884dfe8220661d705f977e0f";
var $03de5ecc01e321ee$export$2e2bcd8739ae039 = $03de5ecc01e321ee$var$node;
module.exports["default"] = $03de5ecc01e321ee$export$2e2bcd8739ae039;

});

parcelRegister("1TElT", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $5DJsZ = parcelRequire("5DJsZ");

const $0272cf4ae0232c26$export$a9fe7043b42a1476 = (contentId, draftShareId, useCache)=>{
    return (0, $dYU3e.query)({
        query: (0, $5DJsZ.default),
        variables: {
            contentId: contentId,
            draftShareId: draftShareId,
            status: [
                'current',
                'draft'
            ],
            skipPublishedFragment: false
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        __callerPackage__: "emoji-title"
    });
};
module.exports["preloadEmojiTitle"] = $0272cf4ae0232c26$export$a9fe7043b42a1476;

});

parcelRegister("irrTO", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $9o4Fw = parcelRequire("9o4Fw");

const $e1546bd447729439$export$f4a1f447ac6a7a9a = (contentId, useCache = true)=>{
    return (0, $dYU3e.query)({
        query: (0, $9o4Fw.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            ...!useCache ? {
                cacheBuster: Date.now()
            } : {}
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        __callerPackage__: "content-appearance"
    });
};
module.exports["preloadDraftContentAppearance"] = $e1546bd447729439$export$f4a1f447ac6a7a9a;

});

parcelRegister("4trRg", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $flWvL = parcelRequire("flWvL");


var $joyRP = parcelRequire("joyRP");

const $b51af1b6a5dfb3b5$export$79f4fda3b987b044 = ({ contentId: contentId, isDraft: isDraft, useCache: useCache = false, isArchived: isArchived })=>{
    const status = (0, $flWvL.queryStatusFor)(isDraft, isArchived);
    return (0, $dYU3e.query)({
        query: (0, $joyRP.default),
        variables: {
            contentId: contentId,
            isDraft: isDraft,
            status: [
                status
            ]
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        __callerPackage__: "editor-content-mode-button"
    });
};
module.exports["preloadContentMode"] = $b51af1b6a5dfb3b5$export$79f4fda3b987b044;

});

parcelRegister("kGDoD", function(module, exports) {
$parcel$export(module.exports, "preloadLastUpdated", () => (parcelRequire("9nGwZ")).preloadLastUpdated);

var $9nGwZ = parcelRequire("9nGwZ");


var $9BupY = parcelRequire("9BupY");


});

parcelRegister("9nGwZ", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $9BupY = parcelRequire("9BupY");

function $693a95aca15bff58$export$e7a15421d1327843(contentId, useCache) {
    return (0, $dYU3e.query)({
        query: (0, $9BupY.default),
        variables: {
            contentId: contentId
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        __callerPackage__: "content-header"
    });
}
module.exports["preloadLastUpdated"] = $693a95aca15bff58$export$e7a15421d1327843;

});

parcelRegister("9BupY", function(module, exports) {
/**
 * @generated SignedSource<<6cd69bb600740f6a687eaabe82eab755>>
 * @relayHash 596c33f2627461693b923b812b6e225f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a6f2f69ce739ced471a1cd1301a6cc419fb9a9219690e4c2e066d590fc835235
const $173882722a7c2e36$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "when"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "LivePagesByLineLastUpdatedQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "LivePagesByLineLastUpdatedQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "596c33f2627461693b923b812b6e225f",
            "id": "a6f2f69ce739ced471a1cd1301a6cc419fb9a9219690e4c2e066d590fc835235",
            "metadata": {},
            "name": "LivePagesByLineLastUpdatedQuery",
            "operationKind": "query",
            "text": "query LivePagesByLineLastUpdatedQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,version{friendlyWhen,when}}}}"
        }
    };
}();
$173882722a7c2e36$var$node.hash = "4e6df5756d13dcdcef29e05d538280a7";
var $173882722a7c2e36$export$2e2bcd8739ae039 = $173882722a7c2e36$var$node;
module.exports["default"] = $173882722a7c2e36$export$2e2bcd8739ae039;

});

parcelRegister("1c0dB", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $kae7O = parcelRequire("kae7O");

const $cb49cba09ddc32ea$export$2ea86854c75d3ec8 = async ({ contentId: contentId, draftShareId: draftShareId, useCache: useCache })=>{
    const variables = {
        contentId: contentId,
        status: [
            'current',
            'draft',
            'archived'
        ],
        draftShareId: draftShareId,
        fetchPolicy: useCache ? 'cache-first' : 'network-only'
    };
    return (0, $dYU3e.query)({
        query: (0, $kae7O.default),
        variables: variables,
        __callerPackage__: "content-topper"
    });
};
module.exports["preloadEditorPageTitleContentProperties"] = $cb49cba09ddc32ea$export$2ea86854c75d3ec8;

});

parcelRegister("kae7O", function(module, exports) {
/**
 * @generated SignedSource<<235e2f4f1cae802c5b7683463fdf34f9>>
 * @relayHash 177df4e8b836b390b9636d650c93a7b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 73afdec0b7224f93dd9771ff4d32ef23242471659162b27d31de856f0e22f612
const $99e3ac9ccccf9f94$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "alias": "pageTitlePublished",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-published\")"
                        },
                        {
                            "alias": "pageTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-draft\")"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "coverPictureWidth"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForEditorQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForEditorQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "177df4e8b836b390b9636d650c93a7b2",
            "id": "73afdec0b7224f93dd9771ff4d32ef23242471659162b27d31de856f0e22f612",
            "metadata": {},
            "name": "useTitleContentPropertiesForEditorQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForEditorQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}}}"
        }
    };
}();
$99e3ac9ccccf9f94$var$node.hash = "cdd7743e3348e4dc97a35c6808323ae0";
var $99e3ac9ccccf9f94$export$2e2bcd8739ae039 = $99e3ac9ccccf9f94$var$node;
module.exports["default"] = $99e3ac9ccccf9f94$export$2e2bcd8739ae039;

});

parcelRegister("kDt9L", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $dYU3e = parcelRequire("dYU3e");


var $89CKS = parcelRequire("89CKS");

const $6bd71bdc26599ad9$export$45c648ba9bf4e12f = async ()=>(0, $dYU3e.query)({
        query: (0, $89CKS.default),
        __callerPackage__: "fabric-media-support"
    });
module.exports["preloadMentionsProvider"] = $6bd71bdc26599ad9$export$45c648ba9bf4e12f;

});

parcelRegister("89CKS", function(module, exports) {
/**
 * @generated SignedSource<<29d02a00238e986613f78bcab9812352>>
 * @relayHash 1c39b72e16854d19d11c51ceef0122b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 57a186e10000ef184bec3a0e71a8dec9c1b57a66702d145178c98368d5d78434
const $76fac522acc3b282$var$node = function() {
    var v0 = [
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ExternalCollaboratorFeature",
                    "kind": "LinkedField",
                    "name": "externalCollaborator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "fetchMentionsProviderDataQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "fetchMentionsProviderDataQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "1c39b72e16854d19d11c51ceef0122b1",
            "id": "57a186e10000ef184bec3a0e71a8dec9c1b57a66702d145178c98368d5d78434",
            "metadata": {},
            "name": "fetchMentionsProviderDataQuery",
            "operationKind": "query",
            "text": "query fetchMentionsProviderDataQuery{entitlements{externalCollaborator{isEntitled}}}"
        }
    };
}();
$76fac522acc3b282$var$node.hash = "97f5ab279ca8162d7d39b760a9aa8808";
var $76fac522acc3b282$export$2e2bcd8739ae039 = $76fac522acc3b282$var$node;
module.exports["default"] = $76fac522acc3b282$export$2e2bcd8739ae039;

});

parcelRegister("cRQNp", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $j25oo = parcelRequire("j25oo");

function $345f814d0887da7c$export$8301c585ee328ce0({ contentId: contentId, includeContentBody: includeContentBody = true, status: status, useCache: useCache }) {
    return (0, $dYU3e.query)({
        query: (0, $j25oo.default),
        variables: {
            contentId: contentId,
            includeContentBody: includeContentBody,
            status: status
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        __callerPackage__: "read-time"
    });
}
module.exports["preloadReadTime"] = $345f814d0887da7c$export$8301c585ee328ce0;

});

parcelRegister("j25oo", function(module, exports) {
/**
 * @generated SignedSource<<b0ed3f943392beb78acd9d9ea9b42788>>
 * @relayHash 24201b9545ec89a2ece8511e9a2a8999
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b3c5854ab0548b89c651d5a1e8fc47a2aa65f94c49e96a88597856cd78fc203c
const $6b1bc0e8ad61af00$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "includeContentBody"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "condition": "includeContentBody",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "dynamic",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "representation"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useReadTimeQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useReadTimeQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "24201b9545ec89a2ece8511e9a2a8999",
            "id": "b3c5854ab0548b89c651d5a1e8fc47a2aa65f94c49e96a88597856cd78fc203c",
            "metadata": {},
            "name": "useReadTimeQuery",
            "operationKind": "query",
            "text": "query useReadTimeQuery($contentId:ID,$status:[String],$includeContentBody:Boolean=true){content(id:$contentId,status:$status){nodes{id,type,body@include(if:$includeContentBody){dynamic{value,representation}},operations{operation,targetType}}}}"
        }
    };
}();
$6b1bc0e8ad61af00$var$node.hash = "1de89fa5a6335c6c91c524557c055ef1";
var $6b1bc0e8ad61af00$export$2e2bcd8739ae039 = $6b1bc0e8ad61af00$var$node;
module.exports["default"] = $6b1bc0e8ad61af00$export$2e2bcd8739ae039;

});

parcelRegister("8CHHT", function(module, exports) {

var $9WAeG = parcelRequire("9WAeG");


var $xwvlW = parcelRequire("xwvlW");


var $3mugH = parcelRequire("3mugH");


var $7Sm4c = parcelRequire("7Sm4c");


var $6fil2 = parcelRequire("6fil2");


var $8n0y0 = parcelRequire("8n0y0");

const $23196774779b9db8$var$setWindowExtensions = (moduleType, extensions, error)=>{
    window.__SSR_FORGE_EXTENSIONS__ = window.__SSR_FORGE_EXTENSIONS__ || {};
    window.__SSR_FORGE_EXTENSIONS__[moduleType] = {
        extensions: extensions,
        error: error
    };
};
async function $23196774779b9db8$export$afb6180712276ba1({ contentId: contentId, spaceKey: spaceKey, moduleType: moduleType, includeHidden: includeHidden = false }) {
    const { cloudId: cloudId, locale: locale } = (0, $xwvlW.getPreloaderFnContext)();
    return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/fetch:ForgeExtensionList', async ()=>{
        try {
            const extensions = await (0, $8n0y0.preloadForgeApps)({
                cloudId: cloudId,
                locale: locale,
                types: [
                    moduleType
                ],
                context: {
                    spaceKey: spaceKey,
                    contentId: contentId != null ? Number(contentId) : undefined
                },
                includeHidden: includeHidden
            });
            if (extensions) $23196774779b9db8$var$setWindowExtensions(moduleType, extensions, undefined);
        } catch (e) {
            // Want to handle network errors to not affect experience SLA
            if ((0, $6fil2.containsNetworkError)(e)) (0, $7Sm4c.markErrorAsHandled)(e);
            else (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Filed to get forge extension list: ${e.message}`));
        }
    });
}
module.exports["preloadUseExtensionList"] = $23196774779b9db8$export$afb6180712276ba1;

});

parcelRegister("8n0y0", function(module, exports) {

var $klHST = parcelRequire("klHST");


var $jGizm = parcelRequire("jGizm");


var $dYU3e = parcelRequire("dYU3e");

// Inlined from platform/packages/forge/forge-ui/src/utils/createAtlAttributionHeader.ts
// (not available as a public entry point of @atlassian/forge-ui)
const $0469ff9a24207ab9$var$createAtlAttributionHeader = (workspaceAri)=>JSON.stringify({
        atlWorkspaceAri: workspaceAri,
        service: 'forge-ui'
    });
const $0469ff9a24207ab9$export$e95a50d7f0e263b5 = async ({ cloudId: cloudId, locale: locale, types: types, context: context, includeHidden: includeHidden })=>{
    const { data: data } = await (0, $dYU3e.queryAgg)({
        query: (0, $klHST.default),
        // copied from platform/packages/forge/forge-ui/src/web-client/hooks/usePrefilteredExtensionList.ts:createUsePrefilteredExtensionListQueryOptions()
        variables: {
            cloudId: cloudId,
            context: context,
            includeHidden: includeHidden ?? false,
            types: types,
            locale: locale
        },
        /**
     * We don't want to set 'ignore' because that discards errors and we need to inspect
     * them for SLI reporting. We also need 'all' so we don't discard data on errors:http://go/j/AUX-317
     * https://www.apollographql.com/docs/react/data/error-handling/
     */ errorPolicy: 'all',
        context: {
            headers: {
                'atl-attribution': $0469ff9a24207ab9$var$createAtlAttributionHeader(cloudId)
            },
            allowOnExternalPage: true
        },
        __callerPackage__: "forge-ui"
    });
    // @ts-expect-error - FIXME: This error was surfaced after enabling the `typescriptExcludeUndefinedFromNullableUnion`
    // Relay compiler option. Previously, `undefined` was incorrectly included in nullable unions in generated types; this option removes it. The owning team should fix this properly.
    const extensions = data?.confluence_forgeExtensionsByType || [];
    if (extensions.length > 0) return (0, $jGizm.transformPreFilteredExtensions)(extensions);
    return null;
};
module.exports["preloadForgeApps"] = $0469ff9a24207ab9$export$e95a50d7f0e263b5;

});

parcelRegister("klHST", function(module, exports) {
/**
 * @generated SignedSource<<f9ea6c5dc173397e0deec2c9c61e408d>>
 * @relayHash ed5f81a23070bbd7a269663fafbee425
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 208bb10d6151e8c79ff890f81580ca160b8daad9625597cd7e7540aeac36d728
const $8dbf49233d9310af$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "context"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeHidden"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "types"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "key"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "context",
                    "variableName": "context"
                },
                {
                    "kind": "Variable",
                    "name": "includeHidden",
                    "variableName": "includeHidden"
                },
                {
                    "kind": "Variable",
                    "name": "locale",
                    "variableName": "locale"
                },
                {
                    "kind": "Variable",
                    "name": "types",
                    "variableName": "types"
                }
            ],
            "concreteType": "ConfluenceForgeExtension",
            "kind": "LinkedField",
            "name": "confluence_forgeExtensionsByType",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "appId"
                },
                {
                    "kind": "ScalarField",
                    "name": "appVersion"
                },
                {
                    "kind": "ScalarField",
                    "name": "appOwner"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentType"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "consentUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "migrationKey"
                },
                {
                    "concreteType": "ConfluenceUserAccess",
                    "kind": "LinkedField",
                    "name": "userAccess",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "enabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasAccess"
                        }
                    ]
                },
                v1 /*: any*/ ,
                {
                    "concreteType": "KeyValueHierarchyMap",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceExtensionEgressDeclaration",
                    "kind": "LinkedField",
                    "name": "egress",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "addresses"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "inScopeEUD"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "scopes"
                },
                {
                    "concreteType": "ConfluenceAppInstallationLicense",
                    "kind": "LinkedField",
                    "name": "license",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "active"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "capabilitySet"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "billingPeriod"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementSlug"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isEvaluation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionEndDate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "trialEndDate"
                        },
                        v2 /*: any*/ 
                    ]
                },
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "installationId"
                },
                {
                    "kind": "ScalarField",
                    "name": "hiddenBy"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadForgeApps_FetchPreFilteredForgeAppsQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadForgeApps_FetchPreFilteredForgeAppsQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "ed5f81a23070bbd7a269663fafbee425",
            "id": "208bb10d6151e8c79ff890f81580ca160b8daad9625597cd7e7540aeac36d728",
            "metadata": {},
            "name": "preloadForgeApps_FetchPreFilteredForgeAppsQuery",
            "operationKind": "query",
            "text": "query preloadForgeApps_FetchPreFilteredForgeAppsQuery($cloudId:ID!,$context:ConfluenceExtensionRenderingContextInput,$includeHidden:Boolean,$locale:String,$types:[String]){confluence_forgeExtensionsByType(cloudId:$cloudId,context:$context,includeHidden:$includeHidden,locale:$locale,types:$types){id,appId,appVersion,appOwner,environmentId,environmentType,environmentKey,consentUrl,migrationKey,userAccess{enabled,hasAccess},key,properties{key,value},egress{addresses,category,type,inScopeEUD},scopes,license{active,capabilitySet,billingPeriod,ccpEntitlementId,ccpEntitlementSlug,isEvaluation,subscriptionEndDate,trialEndDate,type},type,installationId,hiddenBy}}"
        }
    };
}();
$8dbf49233d9310af$var$node.hash = "d99aeaa2aa86bf313f505de4d4d482e6";
var $8dbf49233d9310af$export$2e2bcd8739ae039 = $8dbf49233d9310af$var$node;
module.exports["default"] = $8dbf49233d9310af$export$2e2bcd8739ae039;

});

parcelRegister("7K6Nt", function(module, exports) {

var $llqlc = parcelRequire("llqlc");


var $ceVeI = parcelRequire("ceVeI");


var $1xpoY = parcelRequire("1xpoY");


var $3vv78 = parcelRequire("3vv78");


var $c4twg = parcelRequire("c4twg");


var $959F7 = parcelRequire("959F7");


var $lLjor = parcelRequire("lLjor");


var $6nf8t = parcelRequire("6nf8t");


var $eM1QC = parcelRequire("eM1QC");


var $9hg2I = parcelRequire("9hg2I");


var $gaqfB = parcelRequire("gaqfB");


var $2jr6j = parcelRequire("2jr6j");


var $j9Zer = parcelRequire("j9Zer");


var $eOfv4 = parcelRequire("eOfv4");


var $hwhSw = parcelRequire("hwhSw");


var $aEHCA = parcelRequire("aEHCA");


var $ivpnt = parcelRequire("ivpnt");

const $527158a32e078a3d$var$EXTENSION_TYPES = new Set([
    'extension',
    'bodiedExtension',
    'inlineExtension'
]);
/**
 * Returns a map of extensionKey → handler for all active macro preload
 * handlers based on current experiment gates and the current route.
 *
 * A handler is considered active when:
 *  - its underlying migration experiment is enabled
 *    (`isMigratedMacroImplEnabled`), AND
 *  - its `routes` configuration includes the current `route`.
 */ const $527158a32e078a3d$var$getActiveHandlers = (route)=>{
    const handlers = new Map();
    const register = (handler)=>{
        if (!handler.routes.includes(route)) return;
        if (!(0, $ceVeI.isMigratedMacroImplEnabled)(handler.extensionKey)) return;
        handlers.set(handler.extensionKey, handler);
    };
    register((0, $3vv78.blogPostsPreloadHandler));
    register((0, $c4twg.changeHistoryPreloadHandler));
    register((0, $959F7.contentByLabelPreloadHandler));
    register((0, $lLjor.contributorsPreloadHandler));
    register((0, $6nf8t.detailsSummaryPreloadHandler));
    register((0, $eM1QC.pageIncludePreloadHandler));
    register((0, $9hg2I.recentlyUpdatedPreloadHandler));
    register((0, $j9Zer.popularLabelsPreloadHandler));
    register((0, $gaqfB.pagetreePreloadHandler));
    register((0, $2jr6j.pagetreeSearchPreloadHandler));
    register((0, $eOfv4.profilePicturePreloadHandler));
    register((0, $hwhSw.userProfilePreloadHandler));
    register((0, $aEHCA.viewPdfPreloadHandler));
    register((0, $ivpnt.tasksReportPreloadHandler));
    return handlers;
};
/**
 * Resolves content nodes (which may be a promise), validates the body structure,
 * and parses the ADF JSON into a document object.
 *
 * Returns null if the content nodes are invalid, the representation is not
 * 'atlas_doc_format', or the ADF JSON cannot be parsed.
 */ const $527158a32e078a3d$var$resolveAndParseADF = async (contentNodes)=>{
    const resolvedNodes = contentNodes && typeof contentNodes.then === 'function' ? await contentNodes : contentNodes;
    if (!resolvedNodes?.[0]?.body?.dynamic?.value) return null;
    if (resolvedNodes[0].body.dynamic.representation !== 'atlas_doc_format') return null;
    try {
        return JSON.parse(resolvedNodes[0].body.dynamic.value);
    } catch  {
        return null;
    }
};
// Maximum number of JSON.parse iterations to apply to a stringified
// document. In practice the wire shape is at most double-encoded, so 3
// iterations gives us headroom while still bounding the loop.
const $527158a32e078a3d$var$MAX_DOCUMENT_DECODE_PASSES = 3;
const $527158a32e078a3d$export$c237b35d986a7858 = (document)=>{
    if (document == null) return null;
    let candidate = document;
    for(let pass = 0; pass < $527158a32e078a3d$var$MAX_DOCUMENT_DECODE_PASSES; pass++){
        if (typeof candidate !== 'string') break;
        try {
            candidate = JSON.parse(candidate);
        } catch  {
            return null;
        }
    }
    // Still a string after exhausting all decode passes, or resolved to a
    // non-object primitive (number, boolean, etc.) — give up.
    if (typeof candidate !== 'object') return null;
    return candidate;
};
/**
 * Resolves a `preloadCollabDraftContent` promise, extracts the document
 * field, and decodes it to an ADF object via {@link decodeCollabDraftDocument}.
 *
 * Returns `null` when the promise rejects, when the result has no
 * `data.collabDraft.document`, or when the document cannot be decoded.
 */ const $527158a32e078a3d$var$resolveCollabDraftToADF = async (collabDraftPromise)=>{
    let result;
    try {
        result = await collabDraftPromise;
    } catch  {
        return null;
    }
    return $527158a32e078a3d$export$c237b35d986a7858(result?.data?.collabDraft?.document);
};
/**
 * Parses the comma-separated blocklist string from Statsig into a list of
 * trimmed, non-empty regex pattern strings.
 */ const $527158a32e078a3d$var$getBlocklist = ()=>{
    const raw = (0, $1xpoY.default).getString('confluence-extensions-server-render-blocklist', '');
    const entries = raw.split(',');
    const result = [];
    for(let i = 0; i < entries.length; i++){
        const trimmed = entries[i].trim();
        if (trimmed) result.push(trimmed);
    }
    return result;
};
/**
 * Returns true when `extensionKey` is present in the blocklist.
 *
 * The blocklist is sourced from a single Statsig dynamic config
 * (`confluence-extensions-server-render-blocklist`) so it controls both SSR
 * macro query preloading and supplementary macro data preloading.
 */ const $527158a32e078a3d$var$isBlocklisted = (blocklist, extensionKey)=>{
    if (blocklist.length === 0) return false;
    return blocklist.includes(extensionKey);
};
/**
 * Default cap on the number of extensions preloaded per content node when
 * the `cc_ssr_max_extensions_to_preload` Statsig dynamic config is not set.
 */ const $527158a32e078a3d$var$DEFAULT_MAX_EXTENSIONS_TO_PRELOAD = 8;
/**
 * Default cap on the number of ADF nodes traversed when scanning the
 * document for preloadable extensions, used when the
 * `cc_ssr_macros_max_nodes_to_iterative_over` Statsig dynamic config is
 * not set.
 */ const $527158a32e078a3d$var$DEFAULT_MAX_NODES_TO_ITERATE_OVER = -1;
/**
 * Returns the maximum number of extensions to preload, sourced from the
 * `cc_ssr_max_extensions_to_preload` Statsig dynamic config.
 *
 * A non-positive or non-finite value is treated as "no limit" and is
 * returned as the sentinel `-1` so callers can opt out by configuring `0`
 * (or any negative value).
 */ const $527158a32e078a3d$var$getMaxExtensionsToPreload = ()=>{
    const value = (0, $1xpoY.default).getNumber('cc_ssr_max_extensions_to_preload', $527158a32e078a3d$var$DEFAULT_MAX_EXTENSIONS_TO_PRELOAD);
    if (!Number.isFinite(value) || value < 0) return -1;
    return Math.floor(value);
};
/**
 * Returns the maximum number of ADF nodes to iterate over when searching
 * for preloadable extension nodes, sourced from the
 * `cc_ssr_macros_max_nodes_to_iterative_over` Statsig dynamic config.
 *
 * A non-positive or non-finite value is treated as "no limit" and is
 * returned as the sentinel `-1` so callers can opt out by configuring `0`
 * (or any negative value).
 */ const $527158a32e078a3d$var$getMaxNodesToIterateOver = ()=>{
    const value = (0, $1xpoY.default).getNumber('cc_ssr_macros_max_nodes_to_iterative_over', $527158a32e078a3d$var$DEFAULT_MAX_NODES_TO_ITERATE_OVER);
    if (!Number.isFinite(value) || value < 0) return -1;
    return Math.floor(value);
};
/**
 * Filters extension nodes from the parsed ADF document that have a
 * registered preload handler and are not excluded by the SSR extension
 * blocklist.
 *
 * Two Statsig dynamic configs control the work done here:
 * - `cc_ssr_macros_max_nodes_to_iterative_over` caps the number of ADF
 *   nodes visited during traversal (default -1). A value of `-1` means
 *   no limit.
 * - `cc_ssr_max_extensions_to_preload` caps the number of matched
 *   extensions returned (default 8). A value of `-1` means no limit.
 */ const $527158a32e078a3d$var$getPreloadableMacroNodes = (documentADF, handlersByKey)=>{
    const blocklist = $527158a32e078a3d$var$getBlocklist();
    const maxNodesToIterateOver = $527158a32e078a3d$var$getMaxNodesToIterateOver();
    // Track how many ADF nodes the traversal has visited so we can short-
    // circuit once `cc_ssr_macros_max_nodes_to_iterative_over` is reached.
    // `filter` from @atlaskit/adf-utils/traverse walks the full document tree
    // (the document object itself is not an array), unlike `Array#filter`.
    let visited = 0;
    const matched = (0, $llqlc.filter)(documentADF, (node)=>{
        if (maxNodesToIterateOver !== -1 && visited >= maxNodesToIterateOver) return false;
        visited++;
        const extensionKey = node.attrs?.extensionKey;
        return $527158a32e078a3d$var$EXTENSION_TYPES.has(node.type) && typeof extensionKey === 'string' && handlersByKey.has(extensionKey) && !$527158a32e078a3d$var$isBlocklisted(blocklist, extensionKey);
    });
    const maxExtensionsToPreload = $527158a32e078a3d$var$getMaxExtensionsToPreload();
    if (maxExtensionsToPreload === -1 || matched.length <= maxExtensionsToPreload) return matched;
    return matched.slice(0, maxExtensionsToPreload);
};
/**
 * Shared execution core: walks the already-resolved ADF document through the
 * active handler pipeline for the given route.
 */ const $527158a32e078a3d$var$runPreloadHandlers = async (documentADF, handlersByKey, context)=>{
    const matchedNodes = $527158a32e078a3d$var$getPreloadableMacroNodes(documentADF, handlersByKey);
    if (matchedNodes.length === 0) return;
    // eslint-disable-next-line check-preloaders/no-promise-all
    await Promise.all(matchedNodes.map((node)=>{
        const handler = handlersByKey.get(node.attrs.extensionKey);
        return handler.preload(node, context);
    }));
};
const $527158a32e078a3d$export$dbda8fb8d4a3a2ff = async ({ contentNodes: contentNodes, context: context, route: route })=>{
    const handlersByKey = $527158a32e078a3d$var$getActiveHandlers(route);
    if (handlersByKey.size === 0) return;
    const documentADF = await $527158a32e078a3d$var$resolveAndParseADF(contentNodes);
    if (!documentADF) return;
    await $527158a32e078a3d$var$runPreloadHandlers(documentADF, handlersByKey, context);
};
const $527158a32e078a3d$export$50f56fb621d37e3a = async ({ collabDraftPromise: collabDraftPromise, context: context, route: route })=>{
    const handlersByKey = $527158a32e078a3d$var$getActiveHandlers(route);
    if (handlersByKey.size === 0) return;
    const documentADF = await $527158a32e078a3d$var$resolveCollabDraftToADF(collabDraftPromise);
    if (!documentADF) return;
    await $527158a32e078a3d$var$runPreloadHandlers(documentADF, handlersByKey, context);
};
module.exports["preloadMacroData"] = $527158a32e078a3d$export$dbda8fb8d4a3a2ff;
module.exports["preloadMacroDataFromCollabDraft"] = $527158a32e078a3d$export$50f56fb621d37e3a;

});

parcelRegister("llqlc", function(module, exports) {

var $jTt8P = parcelRequire("jTt8P");

function $64e7b9256d090f27$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $jTt8P.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}
module.exports["filter"] = $64e7b9256d090f27$export$3dea766d36a8935f;

});

parcelRegister("3vv78", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $f9Oe5 = parcelRequire("f9Oe5");


var $gLc6G = parcelRequire("gLc6G");

const $fcca944fa3da51db$export$fcb441b1b4fb38e5 = {
    extensionKey: 'blog-posts',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, context)=>{
        try {
            const macroParams = node.attrs?.parameters?.macroParams ?? {};
            const variables = (0, $gLc6G.buildQueryVariables)(macroParams, context.spaceKey);
            await (0, $wPrRK.slowQueryGuard)('blogPostsPreload', ()=>(0, $dYU3e.query)({
                    query: (0, $f9Oe5.default),
                    variables: variables,
                    context: {
                        single: true
                    },
                    __callerPackage__: "preload-macros"
                }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
        } catch  {
            return;
        }
    }
};
module.exports["blogPostsPreloadHandler"] = $fcca944fa3da51db$export$fcb441b1b4fb38e5;

});

parcelRegister("f9Oe5", function(module, exports) {
/**
 * @generated SignedSource<<e2eef557d077fd416e405ad8813adcf0>>
 * @relayHash fef787c2e6d812e72220d382c04bd44c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 58d7df1bc883468554242bf1644d752239212384434b7e48ef0155e9af178cba
const $496608589e77ac6e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeAdfMediaToken"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeEntireBody"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeExcerpt"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "cql",
            "variableName": "cql"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "count"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "title"
    }, v10 = {
        "kind": "ScalarField",
        "name": "type"
    }, v11 = {
        "condition": "includeExcerpt",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "length",
                        "value": 500
                    }
                ],
                "kind": "ScalarField",
                "name": "excerpt",
                "storageKey": "excerpt(length:500)"
            },
            {
                "concreteType": "ConfluenceMacroExcerptBody",
                "kind": "LinkedField",
                "name": "macroExcerpt",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "fallbackToBody",
                                "value": false
                            }
                        ],
                        "kind": "ScalarField",
                        "name": "atlasDocFormat",
                        "storageKey": "atlasDocFormat(fallbackToBody:false)"
                    }
                ]
            }
        ]
    }, v12 = {
        "concreteType": "ContentBodyPerRepresentation",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
            {
                "condition": "includeAdfMediaToken",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "ContentBody",
                        "kind": "LinkedField",
                        "name": "atlas_doc_format",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "includeEntireBody",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "value"
                                    }
                                ]
                            },
                            {
                                "concreteType": "EmbeddedMediaToken",
                                "kind": "LinkedField",
                                "name": "mediaToken",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "token"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "name"
    }, v14 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "base"
            }
        ]
    }, v15 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            v13 /*: any*/ 
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v17 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v18 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            },
            v16 /*: any*/ ,
            v17 /*: any*/ 
        ],
        "type": "KnownUser"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            v16 /*: any*/ ,
            v17 /*: any*/ 
        ],
        "type": "UnknownUser"
    }, v20 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v21 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "lastUpdated",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "when"
            }
        ]
    }, v22 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            },
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useBlogPostsQueryQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v6 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v18 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                },
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v22 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useBlogPostsQueryQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v6 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v18 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                },
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v22 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "fef787c2e6d812e72220d382c04bd44c",
            "id": "58d7df1bc883468554242bf1644d752239212384434b7e48ef0155e9af178cba",
            "metadata": {},
            "name": "useBlogPostsQueryQuery",
            "operationKind": "query",
            "text": "query useBlogPostsQueryQuery($after:String,$cql:String!,$first:Int,$includeEntireBody:Boolean!,$includeExcerpt:Boolean!,$includeAdfMediaToken:Boolean!){search:confluence_search(cql:$cql,first:$first,after:$after){count,nodes{content{id,title,type,excerpt(length:500)@include(if:$includeExcerpt)\n        macroExcerpt@include(if:$includeExcerpt){atlasDocFormat(fallbackToBody:false)},body{atlas_doc_format@include(if:$includeAdfMediaToken){value@include(if:$includeEntireBody),mediaToken{token}}},labels{nodes{name,id}},links{webui,base},space{id,key,name},history{createdBy{__typename,...on KnownUser{accountId,displayName,profilePicture{path}},...on UnknownUser{displayName,profilePicture{path}}},createdDate,lastUpdated{when}}}},pageInfo{endCursor,hasNextPage}}}"
        }
    };
}();
$496608589e77ac6e$var$node.hash = "be8af94549bdf95f1c5815a896900346";
var $496608589e77ac6e$export$2e2bcd8739ae039 = $496608589e77ac6e$var$node;
module.exports["default"] = $496608589e77ac6e$export$2e2bcd8739ae039;

});

parcelRegister("gLc6G", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $eZ4zi = parcelRequire("eZ4zi");

const $90f568a5a6c2eff6$var$DAY = 86400000;
const $90f568a5a6c2eff6$var$DEFAULT_MAX = 100;
const $90f568a5a6c2eff6$var$MAX_LIMIT = 200;
const $90f568a5a6c2eff6$export$134cc4e90fdbc9cf = 5;
const $90f568a5a6c2eff6$var$splitMacroValues = (value)=>value.split(',').flatMap((item)=>{
        const trimmed = item.trim();
        return trimmed ? [
            trimmed
        ] : [];
    });
// Splits on commas and whitespace, for closer parity to legacy param parsing
const $90f568a5a6c2eff6$var$splitMacroValuesFixed = (value)=>value.split(/[,\s]+/).flatMap((item)=>{
        const trimmed = item.trim();
        return trimmed ? [
            trimmed
        ] : [];
    });
const $90f568a5a6c2eff6$var$quoteCqlValue = (value)=>`'${value}'`;
const $90f568a5a6c2eff6$var$createSpaceTypeClause = (spaceType, operator = '=')=>`space.type ${operator} ${spaceType}`;
const $90f568a5a6c2eff6$var$createSpaceIncludeClause = (spaces, spaceTypeClauses)=>{
    const clauses = [
        ...spaceTypeClauses
    ];
    if (spaces.length > 0) clauses.push(`space IN (${spaces.map($90f568a5a6c2eff6$var$quoteCqlValue).join(',')})`);
    if (clauses.length === 0) return null;
    return clauses.length === 1 ? clauses[0] : `(${clauses.join(' OR ')})`;
};
const $90f568a5a6c2eff6$var$addSpaceClauses = (clauses, spacesValue, currentSpaceKey)=>{
    const spaceKeys = $90f568a5a6c2eff6$var$splitMacroValues(spacesValue);
    let includeSpaces = [];
    let excludeSpaces = [];
    for (const key of spaceKeys){
        if (key === '@all') {
            includeSpaces = [];
            excludeSpaces = [];
            break;
        } else if (key === '@self' && currentSpaceKey) includeSpaces.push(currentSpaceKey);
        else if (key.startsWith('-')) excludeSpaces.push(key.slice(1));
        else includeSpaces.push(key);
    }
    if (includeSpaces.length > 0) {
        const spaceList = includeSpaces.map($90f568a5a6c2eff6$var$quoteCqlValue).join(',');
        clauses.push(`space IN (${spaceList})`);
    }
    for (const excludeSpace of excludeSpaces)clauses.push(`space != ${$90f568a5a6c2eff6$var$quoteCqlValue(excludeSpace)}`);
};
const $90f568a5a6c2eff6$var$addFixedSpaceClauses = (clauses, spacesValue, currentSpaceKey)=>{
    const spaceKeys = $90f568a5a6c2eff6$var$splitMacroValuesFixed(spacesValue);
    const includeSpaces = [];
    const includeSpaceTypeClauses = [];
    const requiredSpaces = [];
    const requiredSpaceTypeClauses = [];
    const excludeSpaces = [];
    const excludeSpaceTypeClauses = [];
    let includeAllSpaces = false;
    const addSpaceFilter = (rawKey)=>{
        const prefix = rawKey[0] === '+' || rawKey[0] === '-' ? rawKey[0] : '';
        const key = prefix ? rawKey.slice(1) : rawKey;
        const targetSpaces = prefix === '+' ? requiredSpaces : prefix === '-' ? excludeSpaces : includeSpaces;
        const targetSpaceTypeClauses = prefix === '+' ? requiredSpaceTypeClauses : prefix === '-' ? excludeSpaceTypeClauses : includeSpaceTypeClauses;
        const spaceTypeOperator = prefix === '-' ? '!=' : '=';
        if (key === '@all' || key === '*') {
            if (prefix === '-') {
                includeAllSpaces = false;
                targetSpaces.length = 0;
                targetSpaceTypeClauses.length = 0;
            } else includeAllSpaces = true;
        } else if (key === '@self') {
            if (currentSpaceKey) targetSpaces.push(currentSpaceKey);
        } else if (key === '@personal') targetSpaceTypeClauses.push($90f568a5a6c2eff6$var$createSpaceTypeClause('personal', spaceTypeOperator));
        else if (key === '@global') targetSpaceTypeClauses.push($90f568a5a6c2eff6$var$createSpaceTypeClause('global', spaceTypeOperator));
        else if (key === '@favorite' || key === '@favourite') targetSpaceTypeClauses.push($90f568a5a6c2eff6$var$createSpaceTypeClause('favorite', spaceTypeOperator));
        else if (key) targetSpaces.push(key);
    };
    for (const key of spaceKeys)addSpaceFilter(key);
    const includeClause = $90f568a5a6c2eff6$var$createSpaceIncludeClause(requiredSpaces, requiredSpaceTypeClauses) ?? (includeAllSpaces ? null : $90f568a5a6c2eff6$var$createSpaceIncludeClause(includeSpaces, includeSpaceTypeClauses));
    if (includeClause) clauses.push(includeClause);
    if (excludeSpaces.length > 0) clauses.push(`space NOT IN (${excludeSpaces.map($90f568a5a6c2eff6$var$quoteCqlValue).join(',')})`);
    clauses.push(...excludeSpaceTypeClauses);
};
const $90f568a5a6c2eff6$var$addLabelClauses = (clauses, labelsValue, matchLabels)=>{
    const labels = $90f568a5a6c2eff6$var$splitMacroValuesFixed(labelsValue);
    const requireLabels = [];
    const excludeLabels = [];
    const anyLabels = [];
    for (const label of labels){
        if (label.startsWith('+')) requireLabels.push(label.slice(1));
        else if (label.startsWith('-')) excludeLabels.push(label.slice(1));
        else anyLabels.push(label);
    }
    for (const label of requireLabels)clauses.push(`label = ${$90f568a5a6c2eff6$var$quoteCqlValue(label)}`);
    for (const label of excludeLabels)clauses.push(`label != ${$90f568a5a6c2eff6$var$quoteCqlValue(label)}`);
    if (anyLabels.length > 0) {
        if (matchLabels === 'all') for (const label of anyLabels)clauses.push(`label = ${$90f568a5a6c2eff6$var$quoteCqlValue(label)}`);
        else {
            const labelList = anyLabels.map($90f568a5a6c2eff6$var$quoteCqlValue).join(',');
            clauses.push(`label IN (${labelList})`);
        }
    }
};
const $90f568a5a6c2eff6$var$addFixedLabelClauses = (clauses, labelsValue, matchLabels)=>{
    const labels = $90f568a5a6c2eff6$var$splitMacroValues(labelsValue);
    const requireLabels = [];
    const excludeLabels = [];
    const anyLabels = [];
    for (const label of labels){
        if (label.startsWith('+')) requireLabels.push(label.slice(1));
        else if (label.startsWith('-')) excludeLabels.push(label.slice(1));
        else anyLabels.push(label);
    }
    for (const label of requireLabels)clauses.push(`label = ${$90f568a5a6c2eff6$var$quoteCqlValue(label)}`);
    if (excludeLabels.length > 0) clauses.push(`label NOT IN (${excludeLabels.map($90f568a5a6c2eff6$var$quoteCqlValue).join(',')})`);
    if (anyLabels.length > 0) {
        if (matchLabels === 'all') for (const label of anyLabels)clauses.push(`label = ${$90f568a5a6c2eff6$var$quoteCqlValue(label)}`);
        else {
            const labelList = anyLabels.map($90f568a5a6c2eff6$var$quoteCqlValue).join(',');
            clauses.push(`label IN (${labelList})`);
        }
    }
};
/**
 * Parses a relative time string like "7d", "14d", "1w", "2h" etc.
 * and returns milliseconds.
 */ const $90f568a5a6c2eff6$var$parseRelativeTime = (time)=>{
    const match = time.match(/^(\d+)([smhdwMy])$/);
    if (!match) return null;
    const value = parseInt(match[1], 10);
    const unit = match[2];
    const multipliers = {
        s: 1000,
        m: 60000,
        h: 3600000,
        d: 86400000,
        w: 604800000,
        M: 2592000000,
        y: 31536000000
    };
    return value * (multipliers[unit] ?? 0);
};
const $90f568a5a6c2eff6$export$fe3a78908f9d9349 = (params, currentSpaceKey)=>{
    const clauses = [
        "type = 'blogpost'"
    ];
    // Space filter
    const spacesValue = params.spaces?.value ?? params.space?.value;
    if (spacesValue) {
        if ((0, $9wGTI.fg)('cc_rewrite_blog_posts_legacy_macro_fix_param_bug')) $90f568a5a6c2eff6$var$addFixedSpaceClauses(clauses, spacesValue, currentSpaceKey);
        else $90f568a5a6c2eff6$var$addSpaceClauses(clauses, spacesValue, currentSpaceKey);
    } else if (currentSpaceKey) // Default: current space
    clauses.push(`space = ${$90f568a5a6c2eff6$var$quoteCqlValue(currentSpaceKey)}`);
    // Labels filter
    const labelsValue = params.labels?.value ?? params.label?.value;
    const matchLabels = params['match-labels']?.value ?? 'any';
    if (labelsValue) {
        if ((0, $9wGTI.fg)('cc_rewrite_blog_posts_legacy_macro_fix_param_bug')) $90f568a5a6c2eff6$var$addFixedLabelClauses(clauses, labelsValue, matchLabels);
        else $90f568a5a6c2eff6$var$addLabelClauses(clauses, labelsValue, matchLabels);
    }
    // Time filter
    const timeValue = params.time?.value;
    if (timeValue) {
        const ms = $90f568a5a6c2eff6$var$parseRelativeTime(timeValue);
        if (ms) {
            // Ensures date calculation matches in SPA context, if SSR rendered,
            // such that resulting cql matches
            const currentTime = window['__SSR_CURRENT_DATE__'] || Date.now();
            const then = new Date(currentTime - ms);
            clauses.push(`lastModified >= '${then.toISOString().split('T')[0]}'`);
        }
    }
    // Author filter
    const authorValue = params.author?.value;
    if (authorValue) {
        const authors = $90f568a5a6c2eff6$var$splitMacroValues(authorValue);
        if (authors.length === 1) clauses.push(`creator = ${$90f568a5a6c2eff6$var$quoteCqlValue(authors[0])}`);
        else if (authors.length > 1) {
            const authorList = authors.map($90f568a5a6c2eff6$var$quoteCqlValue).join(',');
            clauses.push(`creator IN (${authorList})`);
        }
    }
    // Sort
    const sortValue = params.sort?.value;
    const reverseValue = params.reverse?.value === 'true';
    let orderClause = 'ORDER BY created DESC'; // default
    if (sortValue === 'title') orderClause = `ORDER BY title ${reverseValue ? 'DESC' : 'ASC'}`;
    else if (sortValue === 'creation') orderClause = `ORDER BY created ${reverseValue ? 'DESC' : 'ASC'}`;
    else if (sortValue === 'modified') orderClause = `ORDER BY lastModified ${reverseValue ? 'DESC' : 'ASC'}`;
    return `${clauses.join(' AND ')} ${orderClause}`;
};
const $90f568a5a6c2eff6$export$9a3cee82e7cc08ff = (params, currentSpaceKey)=>{
    const contentMode = params.content?.value ?? 'entire';
    const max = $90f568a5a6c2eff6$export$152d338deb24dc62(params);
    const cql = $90f568a5a6c2eff6$export$fe3a78908f9d9349(params, currentSpaceKey);
    const includeEntireBody = contentMode === 'entire';
    const includeExcerpt = contentMode === 'excerpts';
    const includeAdfMediaToken = includeEntireBody || includeExcerpt;
    const first = includeEntireBody ? Math.min(max, $90f568a5a6c2eff6$export$134cc4e90fdbc9cf) : max;
    return {
        after: undefined,
        cql: cql,
        first: first,
        includeEntireBody: includeEntireBody,
        includeExcerpt: includeExcerpt,
        includeAdfMediaToken: includeAdfMediaToken
    };
};
const $90f568a5a6c2eff6$export$152d338deb24dc62 = (params)=>{
    const maxValue = params.max?.value ?? params.maxResults?.value ?? String($90f568a5a6c2eff6$var$DEFAULT_MAX);
    return Math.min(parseInt(maxValue, 10) || $90f568a5a6c2eff6$var$DEFAULT_MAX, $90f568a5a6c2eff6$var$MAX_LIMIT);
};
const $90f568a5a6c2eff6$export$c01426de3d995a88 = (node)=>node != null;
const $90f568a5a6c2eff6$export$701669137e89de62 = (node)=>{
    const links = node.content?.links;
    if (links?.webui) return `/wiki${links.webui}`;
    return '#';
};
const $90f568a5a6c2eff6$export$3b339b277f9d309a = (node)=>{
    const spaceKey = node.content?.space?.key;
    if (spaceKey) return `/wiki/spaces/${spaceKey}`;
    return '#';
};
const $90f568a5a6c2eff6$export$2c8f257f76f536e9 = (node)=>node.content?.history?.createdBy?.displayName ?? 'Unknown';
const $90f568a5a6c2eff6$export$5879f87d8125a540 = (node)=>{
    const createdBy = node.content?.history?.createdBy;
    if (createdBy && 'accountId' in createdBy) return createdBy.accountId ?? undefined;
    return undefined;
};
const $90f568a5a6c2eff6$export$6d333a56ff392766 = (node)=>{
    const accountId = $90f568a5a6c2eff6$export$5879f87d8125a540(node);
    if (accountId) return `/wiki/people/${accountId}?ref=confluence`;
    return '#';
};
const $90f568a5a6c2eff6$export$b6704bab7c727398 = (node)=>{
    const createdBy = node.content?.history?.createdBy;
    if (createdBy && 'profilePicture' in createdBy) return createdBy.profilePicture?.path ?? undefined;
    return undefined;
};
const $90f568a5a6c2eff6$export$1028703a6dee32c7 = (node)=>node.content?.history?.createdDate ?? '';
const $90f568a5a6c2eff6$export$f81a3ec2bfb3f287 = (node)=>{
    const result = [];
    const nodes = node.content?.labels?.nodes;
    if (!nodes) return result;
    for (const label of nodes)if (label?.name) result.push(label.name);
    return result;
};
const $90f568a5a6c2eff6$export$1187b1706349df3e = (label, spaceKey)=>{
    if (spaceKey) return `/wiki/label/${spaceKey}/${encodeURIComponent(label)}`;
    return `/wiki/label/${encodeURIComponent(label)}`;
};
const $90f568a5a6c2eff6$export$1e76b7005bbc55d6 = (dateString, intl)=>{
    const date = new Date(dateString);
    return intl.formatDate(date, {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });
};
const $90f568a5a6c2eff6$export$d1f5a2f86fcde3b5 = (dateString, intl)=>{
    const timestamp = new Date(dateString).getTime();
    const diff = Date.now() - timestamp;
    if (diff < $90f568a5a6c2eff6$var$DAY) return (0, $eZ4zi.getRelativeTime)(timestamp, intl);
    return $90f568a5a6c2eff6$export$1e76b7005bbc55d6(dateString, intl);
};
module.exports["ENTIRE_MODE_PAGE_SIZE"] = $90f568a5a6c2eff6$export$134cc4e90fdbc9cf;
module.exports["buildQueryVariables"] = $90f568a5a6c2eff6$export$9a3cee82e7cc08ff;
module.exports["getMaxResults"] = $90f568a5a6c2eff6$export$152d338deb24dc62;
module.exports["isBlogPostNode"] = $90f568a5a6c2eff6$export$c01426de3d995a88;
module.exports["getContentUrl"] = $90f568a5a6c2eff6$export$701669137e89de62;
module.exports["getSpaceUrl"] = $90f568a5a6c2eff6$export$3b339b277f9d309a;
module.exports["getAuthorName"] = $90f568a5a6c2eff6$export$2c8f257f76f536e9;
module.exports["getAuthorAccountId"] = $90f568a5a6c2eff6$export$5879f87d8125a540;
module.exports["getAuthorAvatarUrl"] = $90f568a5a6c2eff6$export$b6704bab7c727398;
module.exports["getCreatedDate"] = $90f568a5a6c2eff6$export$1028703a6dee32c7;
module.exports["getLabels"] = $90f568a5a6c2eff6$export$f81a3ec2bfb3f287;
module.exports["getLabelUrl"] = $90f568a5a6c2eff6$export$1187b1706349df3e;
module.exports["formatBlogDate"] = $90f568a5a6c2eff6$export$1e76b7005bbc55d6;
module.exports["formatSmartDate"] = $90f568a5a6c2eff6$export$d1f5a2f86fcde3b5;

});

parcelRegister("eZ4zi", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $dce38ffecfe5cc1b$var$MINUTE = 60000;
const $dce38ffecfe5cc1b$var$HOUR = 3600000;
const $dce38ffecfe5cc1b$var$DAY = 86400000;
const $dce38ffecfe5cc1b$var$WEEK = 604800000;
const $dce38ffecfe5cc1b$var$MONTH = 2592000000;
const $dce38ffecfe5cc1b$var$YEAR = 31536000000;
const $dce38ffecfe5cc1b$export$5a00511f040384d7 = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: '2-digit'
});
const $dce38ffecfe5cc1b$export$406508d2ca449bd = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
});
const $dce38ffecfe5cc1b$export$d2d0bf9c4d577e53 = (0, $kSwu1.defineMessages)({
    justNow: {
        id: "macro-utils.relative-time-just-now",
        defaultMessage: "just now"
    },
    minutesAgo: {
        id: "macro-utils.relative-time-minutes-ago",
        defaultMessage: "{minuteCount, plural, one {{minuteCount} minute ago} other {{minuteCount} minutes ago}}"
    },
    hoursAgo: {
        id: "macro-utils.relative-time-hours-ago",
        defaultMessage: "{hourCount, plural, one {{hourCount} hour ago} other {{hourCount} hours ago}}"
    },
    daysAgo: {
        id: "macro-utils.relative-time-days-ago",
        defaultMessage: "{dayCount, plural, one {{dayCount} day ago} other {{dayCount} days ago}}"
    },
    weeksAgo: {
        id: "macro-utils.relative-time-weeks-ago",
        defaultMessage: "{weekCount, plural, one {{weekCount} week ago} other {{weekCount} weeks ago}}"
    },
    monthsAgo: {
        id: "macro-utils.relative-time-months-ago",
        defaultMessage: "{monthCount, plural, one {{monthCount} month ago} other {{monthCount} months ago}}"
    },
    yearsAgo: {
        id: "macro-utils.relative-time-years-ago",
        defaultMessage: "{yearCount, plural, one {{yearCount} year ago} other {{yearCount} years ago}}"
    },
    justAMomentAgo: {
        id: "macro-utils.relative-time-just-a-moment-ago",
        defaultMessage: "just a moment ago"
    },
    lessThanAMinuteAgo: {
        id: "macro-utils.relative-time-less-than-a-minute-ago",
        defaultMessage: "less than a minute ago"
    },
    aMinuteAgo: {
        id: "macro-utils.relative-time-a-minute-ago",
        defaultMessage: "a minute ago"
    },
    contentReportMinutesAgo: {
        id: "macro-utils.content-report-minutes-ago",
        defaultMessage: "{minuteCount, plural, one {{minuteCount} minute ago} other {{minuteCount} minutes ago}}"
    },
    aboutAnHourAgo: {
        id: "macro-utils.relative-time-about-an-hour-ago",
        defaultMessage: "about an hour ago"
    },
    contentReportHoursAgo: {
        id: "macro-utils.content-report-hours-ago",
        defaultMessage: "{hourCount, plural, one {about {hourCount} hour ago} other {about {hourCount} hours ago}}"
    },
    yesterdayAt: {
        id: "macro-utils.relative-time-yesterday-at",
        defaultMessage: "yesterday at {time}"
    }
});
const $dce38ffecfe5cc1b$var$formatBucketMessage = (bucket, diffMs, intl)=>{
    if (bucket.valueName && bucket.unitMs) {
        const count = bucket.countCalculator ? bucket.countCalculator(diffMs) : Math.floor(diffMs / bucket.unitMs);
        return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53[bucket.message], {
            [bucket.valueName]: count
        });
    }
    return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53[bucket.message]);
};
const $dce38ffecfe5cc1b$export$bfc1ce7d5853041b = {
    buckets: [
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$MINUTE,
            message: 'justNow'
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$HOUR,
            message: 'minutesAgo',
            valueName: 'minuteCount',
            unitMs: $dce38ffecfe5cc1b$var$MINUTE
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$DAY,
            message: 'hoursAgo',
            valueName: 'hourCount',
            unitMs: $dce38ffecfe5cc1b$var$HOUR
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$WEEK,
            message: 'daysAgo',
            valueName: 'dayCount',
            unitMs: $dce38ffecfe5cc1b$var$DAY
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$MONTH,
            message: 'weeksAgo',
            valueName: 'weekCount',
            unitMs: $dce38ffecfe5cc1b$var$WEEK
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$YEAR,
            message: 'monthsAgo',
            valueName: 'monthCount',
            unitMs: $dce38ffecfe5cc1b$var$MONTH
        },
        {
            maxDiffMs: Number.POSITIVE_INFINITY,
            message: 'yearsAgo',
            valueName: 'yearCount',
            unitMs: $dce38ffecfe5cc1b$var$YEAR
        }
    ]
};
const $dce38ffecfe5cc1b$export$409646d2c0c56892 = {
    buckets: [
        {
            maxDiffMs: 4000,
            message: 'justAMomentAgo'
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$MINUTE,
            message: 'lessThanAMinuteAgo'
        },
        {
            maxDiffMs: 2 * $dce38ffecfe5cc1b$var$MINUTE,
            message: 'aMinuteAgo'
        },
        {
            maxDiffMs: 50 * $dce38ffecfe5cc1b$var$MINUTE,
            message: 'contentReportMinutesAgo',
            valueName: 'minuteCount',
            unitMs: $dce38ffecfe5cc1b$var$MINUTE,
            countCalculator: (diffMs)=>Math.round(diffMs / $dce38ffecfe5cc1b$var$MINUTE)
        },
        {
            maxDiffMs: 90 * $dce38ffecfe5cc1b$var$MINUTE,
            message: 'aboutAnHourAgo'
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$DAY,
            message: 'contentReportHoursAgo',
            valueName: 'hourCount',
            unitMs: $dce38ffecfe5cc1b$var$HOUR,
            countCalculator: (diffMs)=>Math.round(diffMs / $dce38ffecfe5cc1b$var$HOUR)
        }
    ],
    specialCase: ({ timestampMs: timestampMs, nowMs: nowMs, diffMs: diffMs, intl: intl })=>{
        const savedTime = new Date(timestampMs);
        const now = new Date(nowMs);
        if ($dce38ffecfe5cc1b$export$221990270ebfe867(savedTime, now) && diffMs > 5 * $dce38ffecfe5cc1b$var$HOUR) return $dce38ffecfe5cc1b$export$fc16bfc40f160b09(savedTime, intl);
        return null;
    },
    fallback: ({ timestampMs: timestampMs })=>$dce38ffecfe5cc1b$export$359f3c271cd167e3(new Date(timestampMs))
};
const $dce38ffecfe5cc1b$export$e22324fe17cb0dfe = (timestamp, intl, config)=>{
    const nowMs = Date.now();
    const diffMs = nowMs - timestamp;
    if (config.specialCase) {
        const specialResult = config.specialCase({
            timestampMs: timestamp,
            nowMs: nowMs,
            diffMs: diffMs,
            intl: intl
        });
        if (specialResult !== null) return specialResult;
    }
    for (const bucket of config.buckets){
        if (diffMs < bucket.maxDiffMs) return $dce38ffecfe5cc1b$var$formatBucketMessage(bucket, diffMs, intl);
    }
    if (config.fallback) return config.fallback({
        timestampMs: timestamp,
        nowMs: nowMs,
        diffMs: diffMs,
        intl: intl
    });
    return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.justNow);
};
const $dce38ffecfe5cc1b$export$493c11ff22f45a24 = (timestamp, intl)=>{
    const now = Date.now();
    const diff = now - timestamp;
    if (diff < $dce38ffecfe5cc1b$var$MINUTE) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.justNow);
    else if (diff < $dce38ffecfe5cc1b$var$HOUR) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.minutesAgo, {
        minuteCount: Math.floor(diff / $dce38ffecfe5cc1b$var$MINUTE)
    });
    else if (diff < $dce38ffecfe5cc1b$var$DAY) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.hoursAgo, {
        hourCount: Math.floor(diff / $dce38ffecfe5cc1b$var$HOUR)
    });
    else if (diff < $dce38ffecfe5cc1b$var$WEEK) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.daysAgo, {
        dayCount: Math.floor(diff / $dce38ffecfe5cc1b$var$DAY)
    });
    else if (diff < $dce38ffecfe5cc1b$var$MONTH) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.weeksAgo, {
        weekCount: Math.floor(diff / $dce38ffecfe5cc1b$var$WEEK)
    });
    else if (diff < $dce38ffecfe5cc1b$var$YEAR) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.monthsAgo, {
        monthCount: Math.floor(diff / $dce38ffecfe5cc1b$var$MONTH)
    });
    else return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.yearsAgo, {
        yearCount: Math.floor(diff / $dce38ffecfe5cc1b$var$YEAR)
    });
};
const $dce38ffecfe5cc1b$export$221990270ebfe867 = (date, now)=>{
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    return yesterday.toLocaleDateString() === date.toLocaleDateString();
};
const $dce38ffecfe5cc1b$export$fc16bfc40f160b09 = (date, intl)=>{
    return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.yesterdayAt, {
        time: $dce38ffecfe5cc1b$export$5a00511f040384d7.format(date)
    });
};
const $dce38ffecfe5cc1b$export$359f3c271cd167e3 = (date)=>{
    return $dce38ffecfe5cc1b$export$406508d2ca449bd.format(date);
};
const $dce38ffecfe5cc1b$export$505b35374c01d686 = (timestamp, intl)=>{
    return $dce38ffecfe5cc1b$export$e22324fe17cb0dfe(timestamp, intl, $dce38ffecfe5cc1b$export$409646d2c0c56892);
};
module.exports["getRelativeTime"] = $dce38ffecfe5cc1b$export$493c11ff22f45a24;
module.exports["formatContentReportEpochTime"] = $dce38ffecfe5cc1b$export$505b35374c01d686;

});

parcelRegister("c4twg", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $k0BFU = parcelRequire("k0BFU");


var $eqmIR = parcelRequire("eqmIR");

const $3264be4c944b64e2$export$367ea2b94b2f04d6 = {
    extensionKey: 'change-history',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (_node, context)=>{
        try {
            const variables = (0, $eqmIR.buildChangeHistoryDataQueryVariables)(context.contentId);
            await (0, $wPrRK.slowQueryGuard)('changeHistoryPreload', ()=>(0, $dYU3e.query)({
                    query: (0, $k0BFU.default),
                    variables: variables,
                    context: {
                        single: true
                    },
                    __callerPackage__: "preload-macros"
                }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
        } catch  {
            return;
        }
    }
};
module.exports["changeHistoryPreloadHandler"] = $3264be4c944b64e2$export$367ea2b94b2f04d6;

});

parcelRegister("k0BFU", function(module, exports) {
/**
 * @generated SignedSource<<6484e80b10b3e5b20ff1afdd3170a413>>
 * @relayHash d1f64712a6cd002694c18cfcfd5effc1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 78263e7aa84b79fc56acc881110e93ddfe4d32b8a74d09138dec9e6fa1f4af12
const $70dced0078029077$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v4 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v5 = {
        "kind": "InlineFragment",
        "selections": v4 /*: any*/ ,
        "type": "KnownUser"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": v4 /*: any*/ ,
        "type": "UnknownUser"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v9 = {
        "kind": "ScalarField",
        "name": "when"
    }, v10 = {
        "kind": "ScalarField",
        "name": "message"
    }, v11 = {
        "kind": "ScalarField",
        "name": "number"
    }, v12 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v13 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "status",
            "value": [
                "current",
                "archived"
            ]
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "type"
    }, v15 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v16 = {
        "kind": "ScalarField",
        "name": "key"
    }, v17 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useChangeHistoryDataQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedContentHistoryList",
                    "kind": "LinkedField",
                    "name": "contentHistory",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentHistory",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                },
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        },
                        v12 /*: any*/ 
                    ]
                },
                {
                    "args": v13 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v16 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useChangeHistoryDataQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedContentHistoryList",
                    "kind": "LinkedField",
                    "name": "contentHistory",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentHistory",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                },
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        },
                        v12 /*: any*/ 
                    ]
                },
                {
                    "args": v13 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v16 /*: any*/ ,
                                v17 /*: any*/ 
                            ]
                        },
                        v17 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "d1f64712a6cd002694c18cfcfd5effc1",
            "id": "78263e7aa84b79fc56acc881110e93ddfe4d32b8a74d09138dec9e6fa1f4af12",
            "metadata": {},
            "name": "useChangeHistoryDataQuery",
            "operationKind": "query",
            "text": "query useChangeHistoryDataQuery($contentId:ID!,$after:String,$first:Long){contentHistory(contentId:$contentId,after:$after,first:$first){nodes{by{__typename,...on KnownUser{accountId},...on UnknownUser{accountId},displayName},friendlyWhen,when,message,number},pageInfo{hasNextPage,endCursor}},singleContent(id:$contentId,status:[\"current\",\"archived\"]){type,subType,space{key,id},id}}"
        }
    };
}();
$70dced0078029077$var$node.hash = "c0c612fe849b83d73ce7d10f80a28adc";
var $70dced0078029077$export$2e2bcd8739ae039 = $70dced0078029077$var$node;
module.exports["default"] = $70dced0078029077$export$2e2bcd8739ae039;

});

parcelRegister("eqmIR", function(module, exports) {
const $5dff6ba48bb7564d$export$9266850431e06b56 = 100;
const $5dff6ba48bb7564d$export$70f9f93372f73c04 = (contentId)=>({
        contentId: contentId,
        after: null,
        first: $5dff6ba48bb7564d$export$9266850431e06b56
    });
module.exports["CHANGE_HISTORY_PAGE_SIZE"] = $5dff6ba48bb7564d$export$9266850431e06b56;
module.exports["buildChangeHistoryDataQueryVariables"] = $5dff6ba48bb7564d$export$70f9f93372f73c04;

});

parcelRegister("959F7", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $9wGTI = parcelRequire("9wGTI");


var $6T2gk = parcelRequire("6T2gk");


var $lTGWQ = parcelRequire("lTGWQ");

const $4f6b1e9f682bf5b0$export$8981cb49f72a0f44 = {
    extensionKey: 'contentbylabel',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, context)=>{
        const variables = (0, $lTGWQ.composeMacroParamsForQuery)(node.attrs?.parameters?.macroParams, context.spaceKey, context.contentId);
        if (!variables.cql) return;
        await (0, $wPrRK.slowQueryGuard)('contentByLabelPreload', ()=>(0, $dYU3e.query)({
                query: (0, $6T2gk.default),
                variables: {
                    ...variables,
                    skipSearchTitle: (0, $9wGTI.fg)('cc_rewrite_macros_use_content_not_search_title'),
                    skipContentTitle: !(0, $9wGTI.fg)('cc_rewrite_macros_use_content_not_search_title')
                },
                context: {
                    single: true
                },
                __callerPackage__: "preload-macros"
            }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    }
};
module.exports["contentByLabelPreloadHandler"] = $4f6b1e9f682bf5b0$export$8981cb49f72a0f44;

});

parcelRegister("6T2gk", function(module, exports) {
/**
 * @generated SignedSource<<c992094e27c12637342e9b3907846e3b>>
 * @relayHash bfbb6c3ddb371c332b9342698d38a267
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2c6ce0a18111de36b11a6a397ec0778e80faa16dec4ad6ee75ad0922a01f8093
const $fed9f45d550b7e93$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cql"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fallbackToBody"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeExcerpt"
    }, v4 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "skipContentTitle"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "skipSearchTitle"
    }, v6 = [
        {
            "kind": "ScalarField",
            "name": "title"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "name"
    }, v9 = [
        {
            "alias": "search",
            "args": [
                {
                    "kind": "Variable",
                    "name": "cql",
                    "variableName": "cql"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                }
            ],
            "concreteType": "ConfluenceSearchConnection",
            "kind": "LinkedField",
            "name": "confluence_search",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceSearchResponse",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "condition": "skipSearchTitle",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": v6 /*: any*/ 
                        },
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "lastModified"
                        },
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "condition": "skipContentTitle",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": v6 /*: any*/ 
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "subType"
                                },
                                {
                                    "condition": "includeExcerpt",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceMacroExcerptBody",
                                            "kind": "LinkedField",
                                            "name": "macroExcerpt",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "fallbackToBody",
                                                            "variableName": "fallbackToBody"
                                                        },
                                                        {
                                                            "kind": "Literal",
                                                            "name": "maxBlocks",
                                                            "value": 3
                                                        }
                                                    ],
                                                    "kind": "ScalarField",
                                                    "name": "atlasDocFormat"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "ContentBodyPerRepresentation",
                                            "kind": "LinkedField",
                                            "name": "body",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "ContentBody",
                                                    "kind": "LinkedField",
                                                    "name": "atlas_doc_format",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "EmbeddedMediaToken",
                                                            "kind": "LinkedField",
                                                            "name": "mediaToken",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "token"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        v8 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "PaginatedLabelList",
                                    "kind": "LinkedField",
                                    "name": "labels",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "Label",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useContentByLabelDataQuery",
            "selections": v9 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useContentByLabelDataQuery",
            "selections": v9 /*: any*/ 
        },
        "params": {
            "cacheID": "bfbb6c3ddb371c332b9342698d38a267",
            "id": "2c6ce0a18111de36b11a6a397ec0778e80faa16dec4ad6ee75ad0922a01f8093",
            "metadata": {},
            "name": "useContentByLabelDataQuery",
            "operationKind": "query",
            "text": "query useContentByLabelDataQuery($cql:String!,$first:Int,$includeExcerpt:Boolean!,$fallbackToBody:Boolean!,$skipSearchTitle:Boolean=false,$skipContentTitle:Boolean=true){search:confluence_search(cql:$cql,first:$first){nodes{title@skip(if:$skipSearchTitle),url,lastModified,content{id,title@skip(if:$skipContentTitle),type,subType,macroExcerpt@include(if:$includeExcerpt){atlasDocFormat(fallbackToBody:$fallbackToBody,maxBlocks:3)}\n        body@include(if:$includeExcerpt){atlas_doc_format{mediaToken{token}}},space{id,key,name},labels{nodes{id,name}}}}}}"
        }
    };
}();
$fed9f45d550b7e93$var$node.hash = "7f66210a52807e1348a6380bb503b426";
var $fed9f45d550b7e93$export$2e2bcd8739ae039 = $fed9f45d550b7e93$var$node;
module.exports["default"] = $fed9f45d550b7e93$export$2e2bcd8739ae039;

});

parcelRegister("lTGWQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5fi0G = parcelRequire("5fi0G");

const $67a1e9c4dba455ef$var$MAX_RESULTS_CAP = 500;
const $67a1e9c4dba455ef$var$DEFAULT_MAX_RESULTS = 15;
var $67a1e9c4dba455ef$export$b769d4fd9dd3feec = /*#__PURE__*/ function(ExcerptType) {
    ExcerptType["None"] = "none";
    ExcerptType["Simple"] = "simple";
    ExcerptType["RichContent"] = "rich content";
    return ExcerptType;
}({});
var $67a1e9c4dba455ef$export$9c8b9f8fac4b24ab = /*#__PURE__*/ function(SortOption) {
    SortOption["Creation"] = "created";
    SortOption["Title"] = "title";
    SortOption["Modified"] = "modified";
    return SortOption;
}({});
const $67a1e9c4dba455ef$var$SORT_PARAM_TO_CQL = {
    creation: "created",
    title: "title",
    modified: "modified"
};
function $67a1e9c4dba455ef$var$parseSortOption(value) {
    if (!value) return undefined;
    return $67a1e9c4dba455ef$var$SORT_PARAM_TO_CQL[value];
}
function $67a1e9c4dba455ef$var$parseBoolean(value, defaultValue) {
    if (value === undefined || value === '') return defaultValue;
    return value === 'true';
}
function $67a1e9c4dba455ef$var$parseMax(value, maxCheckbox) {
    if (maxCheckbox === 'true') return {
        max: $67a1e9c4dba455ef$var$MAX_RESULTS_CAP,
        maxParseError: false
    };
    if (value === undefined || value === '') return {
        max: $67a1e9c4dba455ef$var$DEFAULT_MAX_RESULTS,
        maxParseError: false
    };
    const parsed = parseInt(value, 10);
    if (isNaN(parsed)) return {
        max: $67a1e9c4dba455ef$var$DEFAULT_MAX_RESULTS,
        maxParseError: true
    };
    if (parsed <= 0) return {
        max: $67a1e9c4dba455ef$var$DEFAULT_MAX_RESULTS,
        maxParseError: false
    };
    return {
        max: Math.min(parsed, $67a1e9c4dba455ef$var$MAX_RESULTS_CAP),
        maxParseError: false
    };
}
function $67a1e9c4dba455ef$var$buildOrderByClause(sort, reverse) {
    if (!sort) return '';
    const direction = reverse ? 'desc' : 'asc';
    return ` order by ${sort} ${direction}`;
}
function $67a1e9c4dba455ef$var$parseExcerptType(value) {
    if (value === "simple") return "simple";
    if (value === "rich content") return "rich content";
    return "none";
}
function $67a1e9c4dba455ef$export$8f0d03faf499ec50(macroParams, currentSpaceKey, currentContentId) {
    const rawCql = macroParams?.cql?.value ?? '';
    const sort = $67a1e9c4dba455ef$var$parseSortOption(macroParams?.sort?.value);
    const reverse = $67a1e9c4dba455ef$var$parseBoolean(macroParams?.reverse?.value, false);
    const { max: max } = $67a1e9c4dba455ef$var$parseMax(macroParams?.max?.value ?? macroParams?.maxResults?.value, macroParams?.maxCheckbox?.value);
    const resolvedCql = (0, $5fi0G.resolveQueryShorthands)(rawCql, {
        currentSpaceKey: currentSpaceKey,
        currentContentId: currentContentId
    });
    const orderByClause = $67a1e9c4dba455ef$var$buildOrderByClause(sort, reverse);
    const cql = resolvedCql + orderByClause;
    const excerptType = $67a1e9c4dba455ef$var$parseExcerptType(macroParams?.excerptType?.value);
    return {
        cql: cql,
        first: max,
        includeExcerpt: excerptType === "simple" || excerptType === "rich content",
        fallbackToBody: excerptType === "rich content"
    };
}
function $67a1e9c4dba455ef$export$2f9066b0466085e(macroParams, currentSpaceKey, currentContentId) {
    return (0, $cozmU.useMemo)(()=>{
        const sort = $67a1e9c4dba455ef$var$parseSortOption(macroParams?.sort?.value);
        const reverse = $67a1e9c4dba455ef$var$parseBoolean(macroParams?.reverse?.value, false);
        const { max: max, maxParseError: maxParseError } = $67a1e9c4dba455ef$var$parseMax(macroParams?.max?.value ?? macroParams?.maxResults?.value, macroParams?.maxCheckbox?.value);
        const title = macroParams?.title?.value ?? '';
        const showLabels = $67a1e9c4dba455ef$var$parseBoolean(macroParams?.showLabels?.value, true);
        const showSpace = $67a1e9c4dba455ef$var$parseBoolean(macroParams?.showSpace?.value, true);
        const excerptType = $67a1e9c4dba455ef$var$parseExcerptType(macroParams?.excerptType?.value);
        const macroParamsForQuery = $67a1e9c4dba455ef$export$8f0d03faf499ec50(macroParams, currentSpaceKey, currentContentId);
        const cql = macroParamsForQuery.cql;
        const limitLabelLinksToSpace = cql.includes('space = ');
        return {
            cql: cql,
            sort: sort,
            reverse: reverse,
            max: max,
            maxParseError: maxParseError,
            title: title,
            showLabels: showLabels,
            showSpace: showSpace,
            excerptType: excerptType,
            limitLabelLinksToSpace: limitLabelLinksToSpace,
            macroParamsForQuery: macroParamsForQuery
        };
    }, [
        macroParams,
        currentSpaceKey,
        currentContentId
    ]);
}
module.exports["ExcerptType"] = $67a1e9c4dba455ef$export$b769d4fd9dd3feec;
module.exports["composeMacroParamsForQuery"] = $67a1e9c4dba455ef$export$8f0d03faf499ec50;
module.exports["useParsedMacroParams"] = $67a1e9c4dba455ef$export$2f9066b0466085e;

});

parcelRegister("5fi0G", function(module, exports) {
// Matches both bare and quoted variants of the supported sentinels
// (`currentSpace()` / `currentContent()`), tolerating optional whitespace
// before and inside the parentheses (e.g. `currentSpace ( )`). Some macro
// authors / older clients persist `"currentSpace()"` as a string literal, so
// we accept both forms. The sentinel name is captured so the resolver can
// look up the corresponding substitution value.
const $bbef8c560cd45789$var$SHORTHAND_REGEX = /"?(currentSpace|currentContent)\s*\(\s*\)"?/g;
const $bbef8c560cd45789$export$61a94fb63540ef7c = (rawCql, { currentSpaceKey: currentSpaceKey, currentContentId: currentContentId })=>{
    if (!rawCql) return rawCql;
    return rawCql.replace($bbef8c560cd45789$var$SHORTHAND_REGEX, (match, sentinel)=>{
        switch(sentinel){
            case 'currentSpace':
                return currentSpaceKey == undefined ? match : `"${currentSpaceKey}"`;
            case 'currentContent':
                return currentContentId == undefined ? match : `"${currentContentId}"`;
            default:
                return match;
        }
    });
};
module.exports["resolveQueryShorthands"] = $bbef8c560cd45789$export$61a94fb63540ef7c;

});

parcelRegister("lLjor", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $i8KfB = parcelRequire("i8KfB");


var $f21pt = parcelRequire("f21pt");

const $36b2e12d8caeb47e$var$buildVariables = (node, contentId)=>{
    const macroParams = node.attrs?.parameters?.macroParams;
    return {
        contentId: contentId,
        contentStatus: [
            'current'
        ],
        contributorsMacroParameters: macroParams ? (0, $f21pt.composeMacroParamsForQuery)(macroParams) : undefined
    };
};
const $36b2e12d8caeb47e$export$8cfaa971235f65b5 = {
    extensionKey: 'contributors',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, context)=>{
        const variables = $36b2e12d8caeb47e$var$buildVariables(node, context.contentId);
        await (0, $wPrRK.slowQueryGuard)('contributorsPreload', ()=>(0, $dYU3e.query)({
                query: (0, $i8KfB.default),
                variables: variables,
                context: {
                    single: true
                },
                __callerPackage__: "preload-macros"
            }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    }
};
module.exports["contributorsPreloadHandler"] = $36b2e12d8caeb47e$export$8cfaa971235f65b5;

});

parcelRegister("i8KfB", function(module, exports) {
/**
 * @generated SignedSource<<ec07190fb98e0f971c23bf5f1ea3300a>>
 * @relayHash ca950652c375632e8e3242fc2e8e313a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d88382e64959d1d1b6df52cae90f2de3c6d19c72e1d6376f573e550ea308fff3
const $2e401621b9e1fde0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentStatus"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contributorsMacroParameters"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "contentStatus"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "contributorsMacroParameters",
                            "variableName": "contributorsMacroParameters"
                        }
                    ],
                    "concreteType": "ConfluenceContributorsRankings",
                    "kind": "LinkedField",
                    "name": "contributorsMacro",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceAuthorRanking",
                            "kind": "LinkedField",
                            "name": "authorRankingList",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "idString"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "fullNameString"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "edits"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "comments"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "labels"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "watches"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "lastEditTime"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "lastCommentTime"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "lastLabelTime"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContributorsDataQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContributorsDataQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "ca950652c375632e8e3242fc2e8e313a",
            "id": "d88382e64959d1d1b6df52cae90f2de3c6d19c72e1d6376f573e550ea308fff3",
            "metadata": {},
            "name": "useContributorsDataQuery",
            "operationKind": "query",
            "text": "query useContributorsDataQuery($contentId:ID,$contentStatus:[String],$contributorsMacroParameters:ConfluenceContributorsMacroParametersModel){singleContent(id:$contentId,status:$contentStatus){id,contributorsMacro(contributorsMacroParameters:$contributorsMacroParameters){authorRankingList{idString,fullNameString,edits,comments,labels,watches,lastEditTime,lastCommentTime,lastLabelTime}}}}"
        }
    };
}();
$2e401621b9e1fde0$var$node.hash = "2b1ea1963eb971919228dd0de7168930";
var $2e401621b9e1fde0$export$2e2bcd8739ae039 = $2e401621b9e1fde0$var$node;
module.exports["default"] = $2e401621b9e1fde0$export$2e2bcd8739ae039;

});

parcelRegister("f21pt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $66904c9443eb5472$export$8bf632d40c0a848b = (value)=>{
    if (!value) return [
        'authors'
    ];
    return value.split(',').map((s)=>s.trim());
};
const $66904c9443eb5472$export$4c17d9c0cb17e4cf = (value)=>{
    const validOrders = [
        'count',
        'name',
        'update',
        'edits',
        'editTime'
    ];
    if (value && validOrders.includes(value)) return value;
    return 'count';
};
const $66904c9443eb5472$export$3fb54149990fb5b5 = (value)=>{
    return value === 'true';
};
const $66904c9443eb5472$export$a122018e819bbb5 = (value)=>{
    if (!value) return -1;
    const parsed = parseInt(value, 10);
    return isNaN(parsed) ? -1 : Math.max(parsed, -1);
};
const $66904c9443eb5472$export$8f0d03faf499ec50 = (macroParams)=>{
    const reverse = $66904c9443eb5472$export$3fb54149990fb5b5(macroParams?.reverse?.value);
    const showAnonymous = $66904c9443eb5472$export$3fb54149990fb5b5(macroParams?.showAnonymous?.value);
    return {
        include: macroParams?.include?.value,
        order: macroParams?.order?.value,
        reverse: reverse,
        showAnonymous: showAnonymous,
        page: macroParams?.page?.value,
        labels: macroParams?.labels?.value,
        label: macroParams?.label?.value,
        spaces: macroParams?.spaces?.value,
        space: macroParams?.space?.value,
        contentType: macroParams?.contentType?.value,
        publishDate: macroParams?.publishDate?.value,
        scope: macroParams?.scope?.value
    };
};
const $66904c9443eb5472$export$2f9066b0466085e = (macroParams)=>{
    return (0, $cozmU.useMemo)(()=>{
        const include = $66904c9443eb5472$export$8bf632d40c0a848b(macroParams?.include?.value);
        const order = $66904c9443eb5472$export$4c17d9c0cb17e4cf(macroParams?.order?.value);
        const reverse = $66904c9443eb5472$export$3fb54149990fb5b5(macroParams?.reverse?.value);
        const limit = $66904c9443eb5472$export$a122018e819bbb5(macroParams?.limit?.value);
        const mode = macroParams?.mode?.value === 'list' ? 'list' : 'inline';
        const showAnonymous = $66904c9443eb5472$export$3fb54149990fb5b5(macroParams?.showAnonymous?.value);
        const showCount = $66904c9443eb5472$export$3fb54149990fb5b5(macroParams?.showCount?.value);
        const showTime = $66904c9443eb5472$export$3fb54149990fb5b5(macroParams?.showLastTime?.value);
        const noneFoundMessage = macroParams?.noneFoundMessage?.value;
        const macroParamsForQuery = $66904c9443eb5472$export$8f0d03faf499ec50(macroParams);
        return {
            include: include,
            order: order,
            reverse: reverse,
            limit: limit,
            mode: mode,
            showAnonymous: showAnonymous,
            showCount: showCount,
            showTime: showTime,
            noneFoundMessage: noneFoundMessage,
            macroParamsForQuery: macroParamsForQuery
        };
    }, [
        macroParams
    ]);
};
module.exports["composeMacroParamsForQuery"] = $66904c9443eb5472$export$8f0d03faf499ec50;
module.exports["useParsedMacroParams"] = $66904c9443eb5472$export$2f9066b0466085e;

});

parcelRegister("6nf8t", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $cXk0q = parcelRequire("cXk0q");


var $3WUt7 = parcelRequire("3WUt7");

const $467c80d7f40ed92f$var$buildVariables = (node, contentId, spaceKey)=>{
    const macroParams = node.attrs?.parameters?.macroParams;
    const macroId = node.attrs?.parameters?.macroMetadata?.macroId?.value || '';
    return (0, $3WUt7.buildDetailsSummaryVariables)({
        macroParams: macroParams,
        contentId: contentId,
        spaceKey: spaceKey,
        macroId: macroId
    });
};
const $467c80d7f40ed92f$export$69acddabbc0e6f95 = {
    extensionKey: 'detailssummary',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, context)=>{
        try {
            const variables = $467c80d7f40ed92f$var$buildVariables(node, context.contentId, context.spaceKey);
            await (0, $wPrRK.slowQueryGuard)('detailsSummaryPreload', ()=>(0, $dYU3e.query)({
                    query: (0, $cXk0q.DetailsSummaryADFQuery),
                    variables: variables,
                    context: {
                        single: true
                    },
                    __callerPackage__: "preload-macros"
                }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
        } catch  {
            return;
        }
    }
};
module.exports["detailsSummaryPreloadHandler"] = $467c80d7f40ed92f$export$69acddabbc0e6f95;

});

parcelRegister("cXk0q", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $6FBXU = parcelRequire("6FBXU");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $7zgzO = parcelRequire("7zgzO");


var $3WUt7 = parcelRequire("3WUt7");

const $8b4cd8637684b33c$export$4aa63971c7cdd461 = (0, $6FBXU.default);
const $8b4cd8637684b33c$export$3a7ba9dcd3d890e8 = (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { macroDefaultProps: macroDefaultProps, macroParams: macroParams } = t0;
    const [pageIndex, setPageIndex] = (0, $cozmU.useState)(0);
    const { location: location } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setPageIndex(0);
        };
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== macroParams) {
        t2 = [
            macroParams
        ];
        $[1] = macroParams;
        $[2] = t2;
    } else t2 = $[2];
    (0, $cozmU.useEffect)(t1, t2);
    let isPDFExport;
    let t3;
    let t4;
    let t5;
    if ($[3] !== location?.pathname || $[4] !== macroDefaultProps.attributes?.macroId || $[5] !== macroDefaultProps.contentId || $[6] !== macroDefaultProps.spaceKey || $[7] !== macroParams || $[8] !== pageIndex) {
        isPDFExport = location?.pathname.startsWith("/wiki/pdf/");
        t4 = (0, $jMyy4.useQueryInterop);
        t5 = $8b4cd8637684b33c$export$4aa63971c7cdd461;
        t3 = (0, $3WUt7.buildDetailsSummaryVariables)({
            macroParams: macroParams,
            contentId: macroDefaultProps.contentId,
            spaceKey: macroDefaultProps.spaceKey,
            macroId: macroDefaultProps?.attributes?.macroId?.toString() || "",
            pageIndex: pageIndex,
            isPDFExport: isPDFExport
        });
        $[3] = location?.pathname;
        $[4] = macroDefaultProps.attributes?.macroId;
        $[5] = macroDefaultProps.contentId;
        $[6] = macroDefaultProps.spaceKey;
        $[7] = macroParams;
        $[8] = pageIndex;
        $[9] = isPDFExport;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else {
        isPDFExport = $[9];
        t3 = $[10];
        t4 = $[11];
        t5 = $[12];
    }
    let t6;
    if ($[13] !== t3) {
        t6 = {
            variables: t3,
            fetchPolicy: "cache-first"
        };
        $[13] = t3;
        $[14] = t6;
    } else t6 = $[14];
    const { data: data, error: error, loading: loading } = t4(t5, t6);
    const isInitialLoad = loading && !data;
    let t7;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (_, pageNumber)=>{
            setPageIndex(pageNumber - 1);
        };
        $[15] = t7;
    } else t7 = $[15];
    const paginateTable = t7;
    const t8 = data?.detailsLines?.totalPages || 0;
    let t9;
    if ($[16] !== data || $[17] !== error || $[18] !== isInitialLoad || $[19] !== isPDFExport || $[20] !== loading || $[21] !== pageIndex || $[22] !== t8) {
        t9 = {
            data: data,
            error: error,
            loading: loading,
            isInitialLoad: isInitialLoad,
            isPDFExport: isPDFExport,
            pageIndex: pageIndex,
            paginateTable: paginateTable,
            totalPages: t8
        };
        $[16] = data;
        $[17] = error;
        $[18] = isInitialLoad;
        $[19] = isPDFExport;
        $[20] = loading;
        $[21] = pageIndex;
        $[22] = t8;
        $[23] = t9;
    } else t9 = $[23];
    return t9;
};
module.exports["DetailsSummaryADFQuery"] = $8b4cd8637684b33c$export$4aa63971c7cdd461;
module.exports["useDetailsSummaryADFQuery"] = $8b4cd8637684b33c$export$3a7ba9dcd3d890e8;

});

parcelRegister("6FBXU", function(module, exports) {
/**
 * @generated SignedSource<<61b269fc5c97af6ef6d28bc446a0eec0>>
 * @relayHash 81e0ec3084120c0be1f11ccafd133340
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d12d7ebbccf4878f0dfbd2b2e4f86b05fa695f03a27498a938b402a9f5529b9a
const $fa83278cc1200055$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": "atlas_doc_format",
        "kind": "LocalArgument",
        "name": "contentRepresentation"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "countComments"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "countLikes"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "countUnresolvedComments"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cql"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "detailsId"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "headings"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "macroId"
    }, v9 = {
        "defaultValue": 0,
        "kind": "LocalArgument",
        "name": "pageIndex"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageSize"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "reverseSort"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "showCreator"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "showLastModified"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "showPageLabels"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v17 = {
        "kind": "ScalarField",
        "name": "macroId"
    }, v18 = {
        "kind": "ScalarField",
        "name": "name"
    }, v19 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentRepresentation",
                    "variableName": "contentRepresentation"
                },
                {
                    "kind": "Variable",
                    "name": "countComments",
                    "variableName": "countComments"
                },
                {
                    "kind": "Variable",
                    "name": "countLikes",
                    "variableName": "countLikes"
                },
                {
                    "kind": "Variable",
                    "name": "countUnresolvedComments",
                    "variableName": "countUnresolvedComments"
                },
                {
                    "kind": "Variable",
                    "name": "cql",
                    "variableName": "cql"
                },
                {
                    "kind": "Variable",
                    "name": "detailsId",
                    "variableName": "detailsId"
                },
                {
                    "kind": "Variable",
                    "name": "headings",
                    "variableName": "headings"
                },
                {
                    "kind": "Variable",
                    "name": "macroId",
                    "variableName": "macroId"
                },
                {
                    "kind": "Variable",
                    "name": "pageIndex",
                    "variableName": "pageIndex"
                },
                {
                    "kind": "Variable",
                    "name": "pageSize",
                    "variableName": "pageSize"
                },
                {
                    "kind": "Variable",
                    "name": "reverseSort",
                    "variableName": "reverseSort"
                },
                {
                    "kind": "Variable",
                    "name": "showCreator",
                    "variableName": "showCreator"
                },
                {
                    "kind": "Variable",
                    "name": "showLastModified",
                    "variableName": "showLastModified"
                },
                {
                    "kind": "Variable",
                    "name": "showPageLabels",
                    "variableName": "showPageLabels"
                },
                {
                    "kind": "Variable",
                    "name": "sortBy",
                    "variableName": "sortBy"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "DetailsSummaryLines",
            "kind": "LinkedField",
            "name": "detailsLines",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "currentPage"
                },
                {
                    "kind": "ScalarField",
                    "name": "totalPages"
                },
                {
                    "kind": "ScalarField",
                    "name": "renderedHeadings"
                },
                v17 /*: any*/ ,
                {
                    "concreteType": "DetailLine",
                    "kind": "LinkedField",
                    "name": "detailLines",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "relativeLink"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "details"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "reactionsCount"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "commentsCount"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "rowId"
                        },
                        v17 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "unresolvedCommentsCount"
                        },
                        {
                            "concreteType": "DetailLabels",
                            "kind": "LinkedField",
                            "name": "labels",
                            "plural": true,
                            "selections": [
                                v18 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "displayTitle"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "urlPath"
                                }
                            ]
                        },
                        {
                            "concreteType": "DetailCreator",
                            "kind": "LinkedField",
                            "name": "creator",
                            "plural": false,
                            "selections": [
                                v18 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "accountId"
                                }
                            ]
                        },
                        {
                            "concreteType": "DetailLastModified",
                            "kind": "LinkedField",
                            "name": "lastModified",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyModificationDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "sortableDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useDetailsSummaryADFQueryQuery",
            "selections": v19 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v15 /*: any*/ ,
                v11 /*: any*/ ,
                v16 /*: any*/ ,
                v0 /*: any*/ ,
                v10 /*: any*/ ,
                v9 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v14 /*: any*/ ,
                v13 /*: any*/ ,
                v12 /*: any*/ ,
                v7 /*: any*/ ,
                v1 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useDetailsSummaryADFQueryQuery",
            "selections": v19 /*: any*/ 
        },
        "params": {
            "cacheID": "81e0ec3084120c0be1f11ccafd133340",
            "id": "d12d7ebbccf4878f0dfbd2b2e4f86b05fa695f03a27498a938b402a9f5529b9a",
            "metadata": {},
            "name": "useDetailsSummaryADFQueryQuery",
            "operationKind": "query",
            "text": "query useDetailsSummaryADFQueryQuery($cql:String,$detailsId:String,$sortBy:String,$reverseSort:Boolean,$spaceKey:String!,$contentId:ID!,$pageSize:Int,$pageIndex:Int=0,$countComments:Boolean,$countUnresolvedComments:Boolean,$countLikes:Boolean,$showPageLabels:Boolean,$showLastModified:Boolean,$showCreator:Boolean,$headings:String,$contentRepresentation:String=\"atlas_doc_format\",$macroId:String){detailsLines(cql:$cql,detailsId:$detailsId,sortBy:$sortBy,reverseSort:$reverseSort,spaceKey:$spaceKey,contentId:$contentId,pageSize:$pageSize,pageIndex:$pageIndex,countComments:$countComments,countUnresolvedComments:$countUnresolvedComments,countLikes:$countLikes,showPageLabels:$showPageLabels,showLastModified:$showLastModified,showCreator:$showCreator,headings:$headings,contentRepresentation:$contentRepresentation,macroId:$macroId){currentPage,totalPages,renderedHeadings,macroId,detailLines{id,title,relativeLink,details,reactionsCount,commentsCount,rowId,macroId,unresolvedCommentsCount,labels{name,displayTitle,urlPath},creator{name,accountId},lastModified{friendlyModificationDate,sortableDate}}}}"
        }
    };
}();
$fa83278cc1200055$var$node.hash = "e2f904ef103ed055ad0661a39595ea5b";
var $fa83278cc1200055$export$2e2bcd8739ae039 = $fa83278cc1200055$var$node;
module.exports["default"] = $fa83278cc1200055$export$2e2bcd8739ae039;

});

parcelRegister("3WUt7", function(module, exports) {

var $isgNA = parcelRequire("isgNA");

const $2969a01dbaf01c74$var$isTrue = (params, key)=>params?.[key]?.value === 'true';
/**
 * Resolve the effective `pageSize` query variable for the details-summary
 * macro.
 *
 * Rules (kept in one place so the runtime hook, the SSR preload-macros
 * handler, and the legacy SSR preload all behave identically):
 *
 * - When rendering inside a PDF export, always request the maximum page size
 *   (`MAX_PDF_PAGE_SIZE`) so the exported document contains every row.
 * - Otherwise, parse the user-supplied `pageSize` macro param as a base-10
 *   integer. Missing / unparseable values fall back to the default
 *   (`DEFAULT_MAX_PAGE_SIZE`).
 * - The parsed value is then clamped to `DEFAULT_MAX_PAGE_SIZE` so a macro
 *   author cannot accidentally request a larger page than the server is
 *   tuned for.
 */ const $2969a01dbaf01c74$var$resolvePageSize = (macroParams, isPDFExport)=>{
    if (isPDFExport) return 0, $isgNA.MAX_PDF_PAGE_SIZE;
    const rawValue = macroParams?.['pageSize']?.value;
    const parsed = parseInt(rawValue || `${0, $isgNA.DEFAULT_MAX_PAGE_SIZE}`, 10);
    if (Number.isNaN(parsed)) return 0, $isgNA.DEFAULT_MAX_PAGE_SIZE;
    return Math.min(parsed, (0, $isgNA.DEFAULT_MAX_PAGE_SIZE));
};
const $2969a01dbaf01c74$export$1b64d6545318c754 = ({ macroParams: macroParams, contentId: contentId, spaceKey: spaceKey, macroId: macroId, pageIndex: pageIndex = 0, isPDFExport: isPDFExport = false })=>({
        // `_parentId` is the source page where the macro was inserted; it is
        // present when nested inside of other macros and should be used instead of
        // the current page contentId.
        contentId: macroParams?.['_parentId']?.value || contentId,
        cql: macroParams?.['cql']?.value,
        detailsId: macroParams?.['id']?.value,
        headings: macroParams?.['headings']?.value,
        sortBy: macroParams?.['sortBy']?.value,
        spaceKey: spaceKey,
        countLikes: $2969a01dbaf01c74$var$isTrue(macroParams, 'showLikesCount'),
        reverseSort: $2969a01dbaf01c74$var$isTrue(macroParams, 'reverseSort'),
        countComments: $2969a01dbaf01c74$var$isTrue(macroParams, 'showCommentsCount'),
        countUnresolvedComments: $2969a01dbaf01c74$var$isTrue(macroParams, 'showUnresolvedCommentsCount'),
        showPageLabels: $2969a01dbaf01c74$var$isTrue(macroParams, 'showPageLabels'),
        showLastModified: $2969a01dbaf01c74$var$isTrue(macroParams, 'showLastModified'),
        showCreator: $2969a01dbaf01c74$var$isTrue(macroParams, 'showCreator'),
        pageIndex: pageIndex,
        macroId: macroId,
        pageSize: $2969a01dbaf01c74$var$resolvePageSize(macroParams, isPDFExport)
    });
module.exports["buildDetailsSummaryVariables"] = $2969a01dbaf01c74$export$1b64d6545318c754;

});

parcelRegister("isgNA", function(module, exports) {
const $38e46c834876fccf$export$38d4334417be6de4 = [
    'showCreator',
    'showLastModified',
    'showPageLabels',
    'showCommentsCount',
    'showUnresolvedCommentsCount',
    'showLikesCount'
];
const $38e46c834876fccf$export$89486cb0536270a1 = 30;
const $38e46c834876fccf$export$bcb403f7710dd1db = 500;
module.exports["optionalTableHeaderParams"] = $38e46c834876fccf$export$38d4334417be6de4;
module.exports["DEFAULT_MAX_PAGE_SIZE"] = $38e46c834876fccf$export$89486cb0536270a1;
module.exports["MAX_PDF_PAGE_SIZE"] = $38e46c834876fccf$export$bcb403f7710dd1db;

});

parcelRegister("eM1QC", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $oDAuM = parcelRequire("oDAuM");


var $7AKam = parcelRequire("7AKam");


var $6K7Y4 = parcelRequire("6K7Y4");

const $7a5f1a746a9c082d$var$preloadById = (variables)=>(0, $wPrRK.slowQueryGuard)('pageIncludeByIdPreload', ()=>(0, $dYU3e.query)({
            query: (0, $oDAuM.default),
            variables: variables,
            context: {
                single: true
            },
            __callerPackage__: "preload-macros"
        }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
const $7a5f1a746a9c082d$var$preloadByTitle = (variables)=>(0, $wPrRK.slowQueryGuard)('pageIncludeByTitlePreload', ()=>(0, $dYU3e.query)({
            query: (0, $7AKam.default),
            variables: variables,
            context: {
                single: true
            },
            __callerPackage__: "preload-macros"
        }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
const $7a5f1a746a9c082d$export$918221fb7aa02f2c = {
    extensionKey: 'include',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, context)=>{
        const parsedTarget = (0, $6K7Y4.parseMacroTarget)(node.attrs?.parameters?.macroParams);
        const queryTarget = (0, $6K7Y4.getPageIncludeQueryTarget)(parsedTarget, context.spaceKey);
        if (queryTarget.kind === 'by-id') {
            await $7a5f1a746a9c082d$var$preloadById(queryTarget.variables);
            return;
        }
        if (queryTarget.kind === 'by-title') await $7a5f1a746a9c082d$var$preloadByTitle(queryTarget.variables);
    }
};
module.exports["pageIncludePreloadHandler"] = $7a5f1a746a9c082d$export$918221fb7aa02f2c;

});

parcelRegister("oDAuM", function(module, exports) {
/**
 * @generated SignedSource<<1c0c89d79fe77d1b063869de36dc5dd5>>
 * @relayHash 29bcc67d3111f4f97c3c431cc81c9399
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e6bb19ae6a019c7084d957bb2ca18f4a8866b288d1764e44f293dc9cd1f7ff53
const $8e0b9375d7694fe5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ContentBodyPerRepresentation",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentBody",
                            "kind": "LinkedField",
                            "name": "atlas_doc_format",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                },
                                {
                                    "concreteType": "EmbeddedMediaToken",
                                    "kind": "LinkedField",
                                    "name": "mediaToken",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "token"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePageIncludeMacroQueryByIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePageIncludeMacroQueryByIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "29bcc67d3111f4f97c3c431cc81c9399",
            "id": "e6bb19ae6a019c7084d957bb2ca18f4a8866b288d1764e44f293dc9cd1f7ff53",
            "metadata": {},
            "name": "usePageIncludeMacroQueryByIdQuery",
            "operationKind": "query",
            "text": "query usePageIncludeMacroQueryByIdQuery($contentId:ID!){singleContent(id:$contentId){id,title,type,space{key,id},body{atlas_doc_format{value,mediaToken{token}}}}}"
        }
    };
}();
$8e0b9375d7694fe5$var$node.hash = "983fd7d5b2c3bedd36acf332a4d2a21e";
var $8e0b9375d7694fe5$export$2e2bcd8739ae039 = $8e0b9375d7694fe5$var$node;
module.exports["default"] = $8e0b9375d7694fe5$export$2e2bcd8739ae039;

});

parcelRegister("7AKam", function(module, exports) {
/**
 * @generated SignedSource<<1bce5b35349cd4550da965c94478b555>>
 * @relayHash 8f72766dbc3288a69e1f166ec6dfe741
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4236b4cf1f397110e6c228b217491c94eb02fc762436d65d8a1a2ac4ef224bd0
const $74df5cfe1a2e5d0a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "blogSpaceKey"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "blogTitle"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeBlog"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeRaw"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeSplit"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "postingDay"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "rawSpaceKey"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "rawTitle"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "splitSpaceKey"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "splitTitle"
    }, v10 = {
        "kind": "Literal",
        "name": "first",
        "value": 1
    }, v11 = {
        "kind": "Literal",
        "name": "type",
        "value": "page"
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    }, v13 = [
        {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v12 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        v12 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ContentBodyPerRepresentation",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentBody",
                            "kind": "LinkedField",
                            "name": "atlas_doc_format",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                },
                                {
                                    "concreteType": "EmbeddedMediaToken",
                                    "kind": "LinkedField",
                                    "name": "mediaToken",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "token"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v14 = [
        {
            "condition": "includeRaw",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "alias": "rawContent",
                    "args": [
                        v10 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "rawSpaceKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "title",
                            "variableName": "rawTitle"
                        },
                        v11 /*: any*/ 
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v13 /*: any*/ 
                }
            ]
        },
        {
            "condition": "includeSplit",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "alias": "splitContent",
                    "args": [
                        v10 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "splitSpaceKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "title",
                            "variableName": "splitTitle"
                        },
                        v11 /*: any*/ 
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v13 /*: any*/ 
                }
            ]
        },
        {
            "condition": "includeBlog",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "alias": "blogContent",
                    "args": [
                        v10 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "postingDay",
                            "variableName": "postingDay"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "blogSpaceKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "title",
                            "variableName": "blogTitle"
                        },
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "blogpost"
                        }
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v13 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "usePageIncludeMacroQueryByTitleQuery",
            "selections": v14 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v3 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "usePageIncludeMacroQueryByTitleQuery",
            "selections": v14 /*: any*/ 
        },
        "params": {
            "cacheID": "8f72766dbc3288a69e1f166ec6dfe741",
            "id": "4236b4cf1f397110e6c228b217491c94eb02fc762436d65d8a1a2ac4ef224bd0",
            "metadata": {},
            "name": "usePageIncludeMacroQueryByTitleQuery",
            "operationKind": "query",
            "text": "query usePageIncludeMacroQueryByTitleQuery($rawSpaceKey:String!,$rawTitle:String!,$includeRaw:Boolean!,$splitSpaceKey:String!,$splitTitle:String!,$includeSplit:Boolean!,$blogSpaceKey:String!,$blogTitle:String!,$postingDay:String!,$includeBlog:Boolean!){rawContent:content(spaceKey:$rawSpaceKey,title:$rawTitle,type:\"page\",first:1)@include(if:$includeRaw){nodes{id,title,type,space{key,id},body{atlas_doc_format{value,mediaToken{token}}}}},splitContent:content(spaceKey:$splitSpaceKey,title:$splitTitle,type:\"page\",first:1)@include(if:$includeSplit){nodes{id,title,type,space{key,id},body{atlas_doc_format{value,mediaToken{token}}}}},blogContent:content(spaceKey:$blogSpaceKey,title:$blogTitle,type:\"blogpost\",postingDay:$postingDay,first:1)@include(if:$includeBlog){nodes{id,title,type,space{key,id},body{atlas_doc_format{value,mediaToken{token}}}}}}"
        }
    };
}();
$74df5cfe1a2e5d0a$var$node.hash = "f95c0a76906580963b7866b01f678dd2";
var $74df5cfe1a2e5d0a$export$2e2bcd8739ae039 = $74df5cfe1a2e5d0a$var$node;
module.exports["default"] = $74df5cfe1a2e5d0a$export$2e2bcd8739ae039;

});

parcelRegister("6K7Y4", function(module, exports) {
const $397b91bd2abb6c3a$export$bcd93dab64989992 = (macroParams)=>{
    const referencedContentId = macroParams?.['_referencedContentId']?.value ?? null;
    const parentId = macroParams?.['_parentId']?.value ?? null;
    // 1. Modern typed parameter (key is "")
    const typedValue = macroParams?.['']?.value?.trim();
    if (typedValue) return {
        location: typedValue,
        referencedContentId: referencedContentId,
        parentId: parentId,
        error: null
    };
    // 2. Legacy pageTitle (takes precedence over "0")
    const pageTitle = macroParams?.['pageTitle']?.value?.trim();
    if (pageTitle) {
        const spaceKey = macroParams?.['spaceKey']?.value?.trim();
        const location = spaceKey ? `${spaceKey}:${pageTitle}` : pageTitle;
        return {
            location: location,
            referencedContentId: referencedContentId,
            parentId: parentId,
            error: null
        };
    }
    // 3. Legacy untyped default parameter "0"
    const legacyDefault = macroParams?.['0']?.value?.trim();
    if (legacyDefault) return {
        location: legacyDefault,
        referencedContentId: referencedContentId,
        parentId: parentId,
        error: null
    };
    // No target configured
    return {
        location: null,
        referencedContentId: referencedContentId,
        parentId: parentId,
        error: 'missing-target'
    };
};
const $397b91bd2abb6c3a$var$extractContentIdFromTypedValue = (value)=>{
    const match = value.match(/confluence-content:\/\/[^/]+\/(\d+)/);
    return match ? match[1] : null;
};
const $397b91bd2abb6c3a$var$BLOG_POST_LINK_REGEX = /^(?:([\w]+):)?\/(\d{4}\/\d{2}\/\d{2})\/(.+)$/;
const $397b91bd2abb6c3a$var$isValidSpaceKey = (spaceKey)=>{
    if (!spaceKey) return false;
    if (spaceKey.startsWith('~')) return true;
    return spaceKey.length <= 255 && /^[A-Za-z0-9]+$/.test(spaceKey);
};
const $397b91bd2abb6c3a$var$parseSplitPageCandidate = (location)=>{
    const colonIdx = location.indexOf(':');
    if (colonIdx < 0) return null;
    const spaceKey = location.slice(0, colonIdx);
    const title = location.slice(colonIdx + 1);
    if (!$397b91bd2abb6c3a$var$isValidSpaceKey(spaceKey) || title.startsWith(' ')) return null;
    return {
        spaceKey: spaceKey,
        title: title
    };
};
const $397b91bd2abb6c3a$var$parseBlogPostCandidate = (location, hostSpaceKey)=>{
    const match = location.match($397b91bd2abb6c3a$var$BLOG_POST_LINK_REGEX);
    if (!match) return null;
    const spaceKey = match[1] || hostSpaceKey;
    const postingDay = match[2].replace(/\//g, '-');
    const title = match[3];
    if (!spaceKey || !title) return null;
    return {
        spaceKey: spaceKey,
        title: title,
        postingDay: postingDay
    };
};
const $397b91bd2abb6c3a$export$fc5689613a273ab4 = (parsedTarget, hostSpaceKey)=>{
    if (!parsedTarget.location) return {
        kind: 'missing-target'
    };
    const idFromTyped = $397b91bd2abb6c3a$var$extractContentIdFromTypedValue(parsedTarget.location);
    if (idFromTyped) return {
        kind: 'by-id',
        variables: {
            contentId: idFromTyped
        }
    };
    if (parsedTarget.referencedContentId) return {
        kind: 'by-id',
        variables: {
            contentId: parsedTarget.referencedContentId
        }
    };
    const rawTitle = parsedTarget.location.trim();
    if (!rawTitle) return {
        kind: 'missing-target'
    };
    const splitPageCandidate = $397b91bd2abb6c3a$var$parseSplitPageCandidate(rawTitle);
    const blogPostCandidate = $397b91bd2abb6c3a$var$parseBlogPostCandidate(rawTitle, hostSpaceKey);
    const includeRaw = !!hostSpaceKey;
    if (!includeRaw && !splitPageCandidate && !blogPostCandidate) return {
        kind: 'missing-target'
    };
    return {
        kind: 'by-title',
        variables: {
            rawSpaceKey: hostSpaceKey ?? '',
            rawTitle: rawTitle,
            includeRaw: includeRaw,
            splitSpaceKey: splitPageCandidate?.spaceKey ?? '',
            splitTitle: splitPageCandidate?.title ?? '',
            includeSplit: !!splitPageCandidate,
            blogSpaceKey: blogPostCandidate?.spaceKey ?? '',
            blogTitle: blogPostCandidate?.title ?? '',
            postingDay: blogPostCandidate?.postingDay ?? '',
            includeBlog: !!blogPostCandidate
        }
    };
};
module.exports["parseMacroTarget"] = $397b91bd2abb6c3a$export$bcd93dab64989992;
module.exports["getPageIncludeQueryTarget"] = $397b91bd2abb6c3a$export$fc5689613a273ab4;

});

parcelRegister("9hg2I", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $3WQHM = parcelRequire("3WQHM");


var $8mra2 = parcelRequire("8mra2");

const $476f3d09a54732a7$var$buildVariables = (node, context)=>{
    const macroParams = node.attrs?.parameters?.macroParams ?? {};
    const params = {
        types: macroParams['types']?.value,
        spaces: macroParams['spaces']?.value,
        labels: macroParams['labels']?.value,
        author: macroParams['author']?.value,
        max: Number(macroParams['max']?.value) || undefined
    };
    const spaceKey = params.spaces ?? context.spaceKey ?? '';
    return (0, $8mra2.buildRecentlyUpdatedQueryVariables)(params, spaceKey);
};
const $476f3d09a54732a7$export$86adfac79e0861a1 = {
    extensionKey: 'recently-updated',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, context)=>{
        const variables = $476f3d09a54732a7$var$buildVariables(node, context);
        await (0, $wPrRK.slowQueryGuard)('recentlyUpdatedPreload', ()=>(0, $dYU3e.query)({
                query: (0, $3WQHM.default),
                variables: variables,
                context: {
                    single: true
                },
                __callerPackage__: "preload-macros"
            }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    }
};
module.exports["recentlyUpdatedPreloadHandler"] = $476f3d09a54732a7$export$86adfac79e0861a1;

});

parcelRegister("3WQHM", function(module, exports) {
/**
 * @generated SignedSource<<d93dcd7c10f7020beaca89b6f3698114>>
 * @relayHash 727c301958baf0a557d685e96bfcc728
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 70f8f49eb25e63b9c9a990b2097d7d2d64224f24bdfd36245da31052e0822ddd
const $0db13d9be330dd35$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cqlcontext"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "cql",
            "variableName": "cql"
        },
        {
            "kind": "Variable",
            "name": "cqlcontext",
            "variableName": "cqlcontext"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "url"
    }, v6 = {
        "kind": "ScalarField",
        "name": "lastModified"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "type"
    }, v9 = {
        "kind": "ScalarField",
        "name": "title"
    }, v10 = {
        "kind": "ScalarField",
        "name": "status"
    }, v11 = {
        "kind": "ScalarField",
        "name": "key"
    }, v12 = {
        "kind": "ScalarField",
        "name": "name"
    }, v13 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v14 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ContributionStatusSummary",
                        "kind": "LinkedField",
                        "name": "lastcontributed",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "when"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "number"
    }, v16 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v17 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v18 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v19 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RecentlyUpdatedMacroQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v4 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "Space",
                                            "kind": "LinkedField",
                                            "name": "space",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ 
                                            ]
                                        },
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v19 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RecentlyUpdatedMacroQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v4 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "Space",
                                            "kind": "LinkedField",
                                            "name": "space",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                v15 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v19 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "727c301958baf0a557d685e96bfcc728",
            "id": "70f8f49eb25e63b9c9a990b2097d7d2d64224f24bdfd36245da31052e0822ddd",
            "metadata": {},
            "name": "RecentlyUpdatedMacroQuery",
            "operationKind": "query",
            "text": "query RecentlyUpdatedMacroQuery($cql:String!,$cqlcontext:String!,$first:Int,$after:String){search:confluence_search(cql:$cql,cqlcontext:$cqlcontext,first:$first,after:$after){nodes{url,lastModified,content{id,type,title,status,space{key,name,id},links{webui},metadata{currentuser{lastcontributed{when}}},version{number,by{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$0db13d9be330dd35$var$node.hash = "7e6233c32402f853522988d79db44911";
var $0db13d9be330dd35$export$2e2bcd8739ae039 = $0db13d9be330dd35$var$node;
module.exports["default"] = $0db13d9be330dd35$export$2e2bcd8739ae039;

});

parcelRegister("8mra2", function(module, exports) {
const $9f74d735080597cb$export$e2092582db731ff4 = 15;
const $9f74d735080597cb$export$31a1864be1d33bad = [
    'page',
    'blogpost',
    'comment',
    'attachment',
    'whiteboard',
    'database',
    'embed',
    'folder'
];
const $9f74d735080597cb$var$TYPE_ALIASES = {
    news: 'blogpost',
    blog: 'blogpost',
    blogs: 'blogpost',
    'blog-post': 'blogpost',
    blogposts: 'blogpost',
    'blog-posts': 'blogpost',
    pages: 'page',
    comments: 'comment',
    attachments: 'attachment'
};
const $9f74d735080597cb$var$SUPPORTED_TYPES = new Set($9f74d735080597cb$export$31a1864be1d33bad);
function $9f74d735080597cb$var$isContentType(type) {
    return $9f74d735080597cb$var$SUPPORTED_TYPES.has(type);
}
function $9f74d735080597cb$var$normalizeType(rawType) {
    const normalized = $9f74d735080597cb$var$TYPE_ALIASES[rawType] ?? rawType;
    return $9f74d735080597cb$var$isContentType(normalized) ? normalized : undefined;
}
function $9f74d735080597cb$var$parseCommaSeparatedValues(value) {
    if (!value) return [];
    const parts = value.split(',');
    const result = [];
    for (const part of parts){
        const trimmed = part.trim();
        if (trimmed.length > 0) result.push(trimmed);
    }
    return result;
}
function $9f74d735080597cb$var$formatQuotedCqlValues(values) {
    return values.map((v)=>`"${v}"`).join(', ');
}
function $9f74d735080597cb$export$bbd572e80a63521b(max) {
    const parsed = Number(max);
    return Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : $9f74d735080597cb$export$e2092582db731ff4;
}
function $9f74d735080597cb$export$6a81e704675faae5(params, spaceKey) {
    const clauses = [];
    // Content types
    const typeSet = new Set();
    if (params.types) for (const part of $9f74d735080597cb$var$parseCommaSeparatedValues(String(params.types))){
        const normalizedType = $9f74d735080597cb$var$normalizeType(part.toLowerCase());
        if (normalizedType) typeSet.add(normalizedType);
    }
    else for (const t of $9f74d735080597cb$export$31a1864be1d33bad)typeSet.add(t);
    if (typeSet.size > 0) clauses.push(`type in (${[
        ...typeSet
    ].join(', ')})`);
    // Space keys — defaults to current space
    if (spaceKey) {
        const spaceKeys = $9f74d735080597cb$var$parseCommaSeparatedValues(spaceKey);
        if (spaceKeys.length === 1) clauses.push(`space = "${spaceKeys[0]}"`);
        else if (spaceKeys.length > 1) clauses.push(`space in (${$9f74d735080597cb$var$formatQuotedCqlValues(spaceKeys)})`);
    }
    // Labels
    if (params.labels) {
        const labelList = String(params.labels).split(',').map((l)=>`"${l.trim()}"`).join(', ');
        clauses.push(`label in (${labelList})`);
    }
    // Following users / contributors (author param — comma-separated account IDs)
    if (params.author) {
        const users = String(params.author).split(',').map((u)=>`"${u.trim()}"`).join(', ');
        clauses.push(`contributor in (${users})`);
    }
    return `${clauses.join(' AND ')} order by lastmodified desc`;
}
function $9f74d735080597cb$export$ae985ad2d8a37df8(params, spaceKey, after = '') {
    const maxItems = $9f74d735080597cb$export$bbd572e80a63521b(params.max);
    return {
        cql: $9f74d735080597cb$export$6a81e704675faae5(params, spaceKey),
        cqlcontext: '{"contentStatuses":["draft", "current"]}',
        first: maxItems,
        after: after
    };
}
module.exports["buildRecentlyUpdatedQueryVariables"] = $9f74d735080597cb$export$ae985ad2d8a37df8;

});

parcelRegister("gaqfB", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $eDO9L = parcelRequire("eDO9L");


var $6SH28 = parcelRequire("6SH28");


var $49vfa = parcelRequire("49vfa");


var $gzvFl = parcelRequire("gzvFl");


var $jvHsR = parcelRequire("jvHsR");


var $bEk7g = parcelRequire("bEk7g");

const $466aaf75a85fc8d1$export$6843d2ec6a82b03e = {
    extensionKey: 'pagetree',
    routes: [
        'view',
        'space-overview'
    ],
    preload: async (node, context)=>{
        const { rootParam: rootParam, spaceKey: spaceKey } = (0, $bEk7g.parseMacroParams)(node.attrs?.parameters?.macroParams, context.spaceKey);
        const rootType = (0, $bEk7g.parseRootType)(rootParam);
        if (!spaceKey) return;
        // Step 1: Resolve root via the appropriate query
        let homepageData;
        let ancestorData;
        let searchData;
        // All resolution queries are wrapped in slowQueryGuard so a slow
        // preload cannot hold SSR open past the configured timeout. On
        // timeout the captured `*Data` variable stays undefined, downstream
        // `resolveRootId` falls back to its safe defaults, and the renderer
        // fetches whatever it needs on the client.
        switch(rootType){
            case 'self':
                break;
            case 'title':
                if (rootParam) {
                    const pageTitle = (0, $bEk7g.parsePageTitle)(rootParam);
                    const cql = (0, $bEk7g.buildTitleSearchCql)(pageTitle, spaceKey);
                    searchData = await $466aaf75a85fc8d1$var$preloadSearchByTitle(cql);
                }
                break;
            case 'parent':
                ancestorData = await $466aaf75a85fc8d1$var$preloadAncestors(context.contentId);
                break;
            case 'home':
                homepageData = await $466aaf75a85fc8d1$var$preloadSpaceHomepage(spaceKey);
                break;
            case 'none':
                await $466aaf75a85fc8d1$var$preloadRootLevel(spaceKey);
                break;
        }
        // Derive rootId and preload its children
        const rootId = (0, $bEk7g.resolveRootId)({
            rootType: rootType,
            contentId: context.contentId,
            homepageData: homepageData,
            ancestorData: ancestorData,
            searchData: searchData
        });
        // Step 2: Fetch children + ancestors in parallel.
        // Children needs rootId, ancestors needs context.contentId — independent.
        const allTasks = [];
        if (rootId && (0, $bEk7g.needsRootChildren)(rootType)) allTasks.push($466aaf75a85fc8d1$var$preloadChildren(rootId));
        if ((0, $bEk7g.needsAncestorExpansion)(rootType)) allTasks.push($466aaf75a85fc8d1$var$preloadAncestors(context.contentId));
        if (allTasks.length > 0) await Promise.all(allTasks);
    }
};
/**
 * Preload search-by-title result for the title rootType. Returns the query data, or undefined on timeout.
 */ const $466aaf75a85fc8d1$var$preloadSearchByTitle = async (cql)=>{
    let result;
    await (0, $wPrRK.slowQueryGuard)('pageTreeSearchByTitlePreload', async ()=>{
        result = await (0, $dYU3e.query)({
            query: (0, $jvHsR.default),
            variables: {
                cql: cql
            },
            context: {
                single: true
            },
            __callerPackage__: "preload-macros"
        });
    }, (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    return result?.data;
};
/**
 * Preload space homepage for the home rootType. Returns the query data, or undefined on timeout.
 */ const $466aaf75a85fc8d1$var$preloadSpaceHomepage = async (spaceKey)=>{
    let result;
    await (0, $wPrRK.slowQueryGuard)('pageTreeSpaceHomepagePreload', async ()=>{
        result = await (0, $dYU3e.query)({
            query: (0, $49vfa.default),
            variables: {
                spaceKey: spaceKey
            },
            context: {
                single: true
            },
            __callerPackage__: "preload-macros"
        });
    }, (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    return result?.data;
};
/**
 * Preload root-level pages for the none rootType.
 */ const $466aaf75a85fc8d1$var$preloadRootLevel = (spaceKey)=>(0, $wPrRK.slowQueryGuard)('pageTreeRootLevelPreload', ()=>(0, $dYU3e.query)({
            query: (0, $gzvFl.default),
            variables: {
                spaceKey: spaceKey
            },
            context: {
                single: true
            },
            __callerPackage__: "preload-macros"
        }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
/**
 * Preload children for a page.
 */ const $466aaf75a85fc8d1$var$preloadChildren = (contentId)=>(0, $wPrRK.slowQueryGuard)('pageTreeChildrenPreload', ()=>(0, $dYU3e.query)({
            query: (0, $eDO9L.default),
            variables: {
                contentId: contentId,
                first: (0, $bEk7g.CHILDREN_PAGE_SIZE),
                after: null
            },
            context: {
                single: true
            },
            __callerPackage__: "preload-macros"
        }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
/**
 * Preload ancestor IDs for a page. Returns the query data, or undefined on timeout.
 */ const $466aaf75a85fc8d1$var$preloadAncestors = async (contentId)=>{
    let result;
    await (0, $wPrRK.slowQueryGuard)('pageTreeAncestorsPreload', async ()=>{
        result = await (0, $dYU3e.query)({
            query: (0, $6SH28.default),
            variables: {
                contentId: contentId
            },
            context: {
                single: true
            },
            __callerPackage__: "preload-macros"
        });
    }, (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    return result?.data;
};
module.exports["pagetreePreloadHandler"] = $466aaf75a85fc8d1$export$6843d2ec6a82b03e;

});

parcelRegister("eDO9L", function(module, exports) {
/**
 * @generated SignedSource<<5fb9bb2937ec97b73a42ea47b9d58e3e>>
 * @relayHash d1f76f7240783decafa55490bef87b1b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7205a6bc6cf45eb6816c5b240722b387293327e14b66466957a2a961320932d7
const $3b030073abdce2d6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "kind": "Literal",
            "name": "format",
            "value": "MILLIS"
        }
    ], v5 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "after",
                            "variableName": "after"
                        },
                        {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "first"
                        }
                    ],
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "title"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasChildren"
                                },
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "ConfluenceDate",
                                    "kind": "LinkedField",
                                    "name": "createdDate",
                                    "plural": false,
                                    "selections": v5 /*: any*/ ,
                                    "storageKey": "createdDate(format:\"MILLIS\")"
                                },
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "ConfluenceDate",
                                    "kind": "LinkedField",
                                    "name": "lastUpdatedDate",
                                    "plural": false,
                                    "selections": v5 /*: any*/ ,
                                    "storageKey": "lastUpdatedDate(format:\"MILLIS\")"
                                },
                                {
                                    "concreteType": "Map_LinkType_String",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "webui"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "PTPageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PageTreeMacroChildrenQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PageTreeMacroChildrenQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "d1f76f7240783decafa55490bef87b1b",
            "id": "7205a6bc6cf45eb6816c5b240722b387293327e14b66466957a2a961320932d7",
            "metadata": {},
            "name": "PageTreeMacroChildrenQuery",
            "operationKind": "query",
            "text": "query PageTreeMacroChildrenQuery($contentId:ID!,$first:Int,$after:String){ptpage(id:$contentId){id,children(first:$first,after:$after){nodes{id,title,hasChildren,createdDate(format:MILLIS){value},lastUpdatedDate(format:MILLIS){value},links{webui}},pageInfo{hasNextPage,endCursor}}}}"
        }
    };
}();
$3b030073abdce2d6$var$node.hash = "59283a106a3d4f2872ded3860b4892b7";
var $3b030073abdce2d6$export$2e2bcd8739ae039 = $3b030073abdce2d6$var$node;
module.exports["default"] = $3b030073abdce2d6$export$2e2bcd8739ae039;

});

parcelRegister("6SH28", function(module, exports) {
/**
 * @generated SignedSource<<6ed9797be759e375a531e38a2af48352>>
 * @relayHash 1cb037b815e517bd7984595b20d124af
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID acb8b4b0c8e9ce55d652b28f502d52dd391de7c55bdb32f248dbeb8199940cbc
const $7e0dd4f7164e5968$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "nearestAncestors",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PageTreeMacroAncestorsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PageTreeMacroAncestorsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "1cb037b815e517bd7984595b20d124af",
            "id": "acb8b4b0c8e9ce55d652b28f502d52dd391de7c55bdb32f248dbeb8199940cbc",
            "metadata": {},
            "name": "PageTreeMacroAncestorsQuery",
            "operationKind": "query",
            "text": "query PageTreeMacroAncestorsQuery($contentId:ID!){ptpage(id:$contentId){id,nearestAncestors{nodes{id}}}}"
        }
    };
}();
$7e0dd4f7164e5968$var$node.hash = "87b0f0557adb9a0866c0ecd4aae73da8";
var $7e0dd4f7164e5968$export$2e2bcd8739ae039 = $7e0dd4f7164e5968$var$node;
module.exports["default"] = $7e0dd4f7164e5968$export$2e2bcd8739ae039;

});

parcelRegister("49vfa", function(module, exports) {
/**
 * @generated SignedSource<<c76673347537b0257d7eb27040ca82b3>>
 * @relayHash c61a430f42dfefbb095b2ca84bb4127d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7a06f8ee0d26e27379e1824924505981b4e94348246f357fc7c17901ddf02d7f
const $21b326e4a95ad923$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "spaceKey"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "homepage",
        "plural": false,
        "selections": [
            v2 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PageTreeMacroSpaceHomepageQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PageTreeMacroSpaceHomepageQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "c61a430f42dfefbb095b2ca84bb4127d",
            "id": "7a06f8ee0d26e27379e1824924505981b4e94348246f357fc7c17901ddf02d7f",
            "metadata": {},
            "name": "PageTreeMacroSpaceHomepageQuery",
            "operationKind": "query",
            "text": "query PageTreeMacroSpaceHomepageQuery($spaceKey:String!){space(key:$spaceKey){homepage{id},id}}"
        }
    };
}();
$21b326e4a95ad923$var$node.hash = "97d54ae520df0edd2399fe104d2017bf";
var $21b326e4a95ad923$export$2e2bcd8739ae039 = $21b326e4a95ad923$var$node;
module.exports["default"] = $21b326e4a95ad923$export$2e2bcd8739ae039;

});

parcelRegister("gzvFl", function(module, exports) {
/**
 * @generated SignedSource<<b9b39b07bf56ad31c1c3d1a28791c1c9>>
 * @relayHash 423919d13d57653b2e9c3769e68f2b09
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8179a69028770ff58fa99c72360f926b70fb1edb5f40282d66611c913a793e9a
const $bd17eac6cecb59ef$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "title"
    }, v3 = {
        "kind": "ScalarField",
        "name": "hasChildren"
    }, v4 = [
        {
            "kind": "Literal",
            "name": "format",
            "value": "MILLIS"
        }
    ], v5 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v6 = {
        "args": v4 /*: any*/ ,
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdDate",
        "plural": false,
        "selections": v5 /*: any*/ ,
        "storageKey": "createdDate(format:\"MILLIS\")"
    }, v7 = {
        "args": v4 /*: any*/ ,
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "lastUpdatedDate",
        "plural": false,
        "selections": v5 /*: any*/ ,
        "storageKey": "lastUpdatedDate(format:\"MILLIS\")"
    }, v8 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v9 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "followingSiblings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "PTPageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PageTreeMacroRootLevelQuery",
            "selections": v9 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PageTreeMacroRootLevelQuery",
            "selections": v9 /*: any*/ 
        },
        "params": {
            "cacheID": "423919d13d57653b2e9c3769e68f2b09",
            "id": "8179a69028770ff58fa99c72360f926b70fb1edb5f40282d66611c913a793e9a",
            "metadata": {},
            "name": "PageTreeMacroRootLevelQuery",
            "operationKind": "query",
            "text": "query PageTreeMacroRootLevelQuery($spaceKey:String!){ptpage(spaceKey:$spaceKey){id,title,hasChildren,createdDate(format:MILLIS){value},lastUpdatedDate(format:MILLIS){value},links{webui},followingSiblings{nodes{id,title,hasChildren,createdDate(format:MILLIS){value},lastUpdatedDate(format:MILLIS){value},links{webui}},pageInfo{hasNextPage}}}}"
        }
    };
}();
$bd17eac6cecb59ef$var$node.hash = "719bdc5b722e95ed2bdf030fecc89213";
var $bd17eac6cecb59ef$export$2e2bcd8739ae039 = $bd17eac6cecb59ef$var$node;
module.exports["default"] = $bd17eac6cecb59ef$export$2e2bcd8739ae039;

});

parcelRegister("jvHsR", function(module, exports) {
/**
 * @generated SignedSource<<7ce6cc193cc37b4484da707ada8e906b>>
 * @relayHash 2eb5932fe57eda221f60bf95729cc781
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d26dc563aec2070c8c92491642682e66884032b661b2c5862a9e3c2f83bcc352
const $6c3ffceca1ec4cfc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cql"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cql",
                    "variableName": "cql"
                },
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                }
            ],
            "concreteType": "ConfluenceSearchConnection",
            "kind": "LinkedField",
            "name": "confluence_search",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceSearchResponse",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PageTreeMacroSearchByTitleQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PageTreeMacroSearchByTitleQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "2eb5932fe57eda221f60bf95729cc781",
            "id": "d26dc563aec2070c8c92491642682e66884032b661b2c5862a9e3c2f83bcc352",
            "metadata": {},
            "name": "PageTreeMacroSearchByTitleQuery",
            "operationKind": "query",
            "text": "query PageTreeMacroSearchByTitleQuery($cql:String!){confluence_search(cql:$cql,first:1){nodes{content{id}}}}"
        }
    };
}();
$6c3ffceca1ec4cfc$var$node.hash = "42441e185ca1b3e501257c64db0a4892";
var $6c3ffceca1ec4cfc$export$2e2bcd8739ae039 = $6c3ffceca1ec4cfc$var$node;
module.exports["default"] = $6c3ffceca1ec4cfc$export$2e2bcd8739ae039;

});

parcelRegister("bEk7g", function(module, exports) {

var $jlIaF = parcelRequire("jlIaF");

const $26e80ddf91af379c$export$9921da6540a2b156 = (node)=>({
        id: node.id,
        title: node.title,
        hasChildren: node.hasChildren,
        url: node.links?.webui ? `${0, $jlIaF.CONTEXT_PATH}${node.links.webui}` : '',
        createdDate: node.createdDate?.value ? Number(node.createdDate.value) : undefined,
        lastModifiedDate: node.lastUpdatedDate?.value ? Number(node.lastUpdatedDate.value) : undefined
    });
// ---------------------------------------------------------------------------
// Client-side sorting
// ---------------------------------------------------------------------------
const $26e80ddf91af379c$var$naturalCompare = (a, b)=>{
    return a.localeCompare(b, undefined, {
        numeric: true,
        sensitivity: 'base'
    });
};
const $26e80ddf91af379c$export$96d07f33920abf3e = (nodes, sort, reverse)=>{
    const sorted = [
        ...nodes
    ];
    switch(sort){
        case 'bitwise':
            sorted.sort((a, b)=>a.title.localeCompare(b.title));
            break;
        case 'natural':
            sorted.sort((a, b)=>$26e80ddf91af379c$var$naturalCompare(a.title, b.title));
            break;
        case 'creation':
            sorted.sort((a, b)=>(a.createdDate || 0) - (b.createdDate || 0));
            break;
        case 'modified':
            sorted.sort((a, b)=>(a.lastModifiedDate || 0) - (b.lastModifiedDate || 0));
            break;
        case 'position':
        default:
            break;
    }
    if (reverse) sorted.reverse();
    return sorted;
};
const $26e80ddf91af379c$export$3cf9a7263d7d2d28 = 100;
const $26e80ddf91af379c$export$7db02a6ccf4cb65a = (data, sort, reverse)=>{
    const children = data?.ptpage?.children?.nodes;
    if (!children) return null;
    const nodes = [];
    for (const n of children)if (n != null) nodes.push($26e80ddf91af379c$export$9921da6540a2b156(n));
    return $26e80ddf91af379c$export$96d07f33920abf3e(nodes, sort, reverse);
};
const $26e80ddf91af379c$export$487d62996e3b3023 = async (refetchChildren, parentId, sort, reverse)=>{
    const batches = [];
    let after = null;
    let hasMore = true;
    let iteration = 0;
    while(hasMore && iteration < 100){
        const result = await refetchChildren({
            contentId: parentId,
            first: $26e80ddf91af379c$export$3cf9a7263d7d2d28,
            after: after
        });
        const children = result?.data?.ptpage?.children;
        if (!children?.nodes) break;
        batches.push(children.nodes);
        if (children.pageInfo?.hasNextPage && children.pageInfo?.endCursor !== after) after = children.pageInfo.endCursor ?? null;
        else hasMore = false;
        iteration++;
    }
    const rawNodes = batches.flat().filter((n)=>n != null);
    return $26e80ddf91af379c$export$96d07f33920abf3e(rawNodes.map($26e80ddf91af379c$export$9921da6540a2b156), sort, reverse);
};
const $26e80ddf91af379c$export$bdc9b163c4d0f3de = (value)=>{
    return value.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
};
const $26e80ddf91af379c$var$isValidSort = (value)=>[
        'natural',
        'bitwise',
        'position',
        'creation',
        'modified'
    ].includes(value);
const $26e80ddf91af379c$export$66770a7e7da42ecb = (macroParams, defaultSpaceKey)=>{
    const rootParam = macroParams?.root?.value ?? null;
    const spaceKey = macroParams?.spaces?.value ?? defaultSpaceKey;
    const showExcerpt = macroParams?.excerpt?.value === 'true';
    const sortValue = macroParams?.sort?.value ?? 'position';
    const sort = $26e80ddf91af379c$var$isValidSort(sortValue) ? sortValue : 'position';
    const reverse = macroParams?.reverse?.value === 'true';
    const showSearchBox = macroParams?.searchBox?.value === 'true';
    const showExpandCollapseAll = macroParams?.expandCollapseAll?.value === 'true';
    const startDepthStr = macroParams?.startDepth?.value ?? '0';
    const startDepth = /^\d+$/.test(startDepthStr) ? parseInt(startDepthStr, 10) : 0;
    return {
        rootParam: rootParam,
        spaceKey: spaceKey,
        showExcerpt: showExcerpt,
        sort: sort,
        reverse: reverse,
        showSearchBox: showSearchBox,
        showExpandCollapseAll: showExpandCollapseAll,
        startDepth: startDepth
    };
};
const $26e80ddf91af379c$export$b364eed1315822f9 = (params)=>JSON.stringify({
        root: params.rootParam,
        spaces: params.spaceKey,
        excerpt: String(params.showExcerpt),
        sort: params.sort,
        reverse: String(params.reverse),
        searchBox: String(params.showSearchBox),
        expandCollapseAll: String(params.showExpandCollapseAll),
        startDepth: String(params.startDepth)
    });
const $26e80ddf91af379c$export$b7bc6229bead1c21 = (rootParam)=>{
    if (!rootParam) return 'home';
    const lower = rootParam.toLowerCase();
    switch(lower){
        case '@self':
            return 'self';
        case '@parent':
            return 'parent';
        case '@home':
            return 'home';
        case '@none':
            return 'none';
        default:
            return 'title';
    }
};
const $26e80ddf91af379c$export$eca7683f8ecceb76 = (data)=>data?.content?.nodes?.[0]?.macroExcerpt?.atlasDocFormat ?? undefined;
const $26e80ddf91af379c$export$a8a6626948b501bd = (data)=>data?.content?.nodes?.[0]?.body?.atlas_doc_format?.mediaToken?.token ?? undefined;
const $26e80ddf91af379c$export$31e03f73732334a0 = (data)=>{
    const rawNodes = data?.content?.nodes;
    const nodes = [];
    if (rawNodes) for (const node of rawNodes){
        if (!node?.id) continue;
        nodes.push({
            id: node.id,
            adfString: node.macroExcerpt?.atlasDocFormat ?? undefined,
            mediaToken: node.body?.atlas_doc_format?.mediaToken?.token ?? undefined
        });
    }
    const rawPageInfo = data?.content?.pageInfo;
    const pageInfo = rawPageInfo ? {
        hasNextPage: rawPageInfo.hasNextPage,
        endCursor: rawPageInfo.endCursor ?? null
    } : null;
    return {
        nodes: nodes,
        pageInfo: pageInfo
    };
};
const $26e80ddf91af379c$export$2bcabf930da035c4 = (data)=>{
    const children = data?.ptpage?.children?.nodes;
    if (!children) return [];
    const ids = [];
    for (const child of children)if (child?.id) ids.push(child.id);
    return ids;
};
const $26e80ddf91af379c$export$27ca14a7672351ca = (data)=>data?.space?.homepage?.id ?? undefined;
const $26e80ddf91af379c$export$f0abfa7ade6f050b = (data)=>data?.ptpage?.nearestAncestors?.nodes?.[0]?.id ?? undefined;
const $26e80ddf91af379c$export$af332464b727c9e9 = (data)=>data?.confluence_search?.nodes?.[0]?.content?.id ?? undefined;
const $26e80ddf91af379c$export$25828e9857936ee8 = ({ rootType: rootType, contentId: contentId, homepageData: homepageData, ancestorData: ancestorData, searchData: searchData })=>{
    switch(rootType){
        case 'self':
            return contentId;
        case 'home':
            return $26e80ddf91af379c$export$27ca14a7672351ca(homepageData);
        case 'parent':
            return $26e80ddf91af379c$export$f0abfa7ade6f050b(ancestorData);
        case 'title':
            return $26e80ddf91af379c$export$af332464b727c9e9(searchData);
        case 'none':
            return undefined;
    }
};
const $26e80ddf91af379c$export$d0cbb0149dfad6ae = (rootType)=>rootType !== 'self' && rootType !== 'parent';
const $26e80ddf91af379c$export$b38ff668c727ce06 = (rootType)=>rootType !== 'none';
const $26e80ddf91af379c$export$a802709b8af34ca = (rootParam)=>{
    const colonIndex = rootParam.indexOf(':');
    return colonIndex >= 0 ? rootParam.substring(colonIndex + 1) : rootParam;
};
const $26e80ddf91af379c$export$87777831b2e51242 = (pageTitle, spaceKey)=>{
    return `title = "${$26e80ddf91af379c$export$bdc9b163c4d0f3de(pageTitle)}" and space = "${$26e80ddf91af379c$export$bdc9b163c4d0f3de(spaceKey)}" and type = "page"`;
};
module.exports["mapPtPageNode"] = $26e80ddf91af379c$export$9921da6540a2b156;
module.exports["sortNodes"] = $26e80ddf91af379c$export$96d07f33920abf3e;
module.exports["CHILDREN_PAGE_SIZE"] = $26e80ddf91af379c$export$3cf9a7263d7d2d28;
module.exports["extractChildNodes"] = $26e80ddf91af379c$export$7db02a6ccf4cb65a;
module.exports["extractChildren"] = $26e80ddf91af379c$export$487d62996e3b3023;
module.exports["parseMacroParams"] = $26e80ddf91af379c$export$66770a7e7da42ecb;
module.exports["serializeMacroParams"] = $26e80ddf91af379c$export$b364eed1315822f9;
module.exports["parseRootType"] = $26e80ddf91af379c$export$b7bc6229bead1c21;
module.exports["extractSingleNodeAdfString"] = $26e80ddf91af379c$export$eca7683f8ecceb76;
module.exports["extractSingleNodeMediaToken"] = $26e80ddf91af379c$export$a8a6626948b501bd;
module.exports["extractBatchPage"] = $26e80ddf91af379c$export$31e03f73732334a0;
module.exports["resolveRootId"] = $26e80ddf91af379c$export$25828e9857936ee8;
module.exports["needsAncestorExpansion"] = $26e80ddf91af379c$export$d0cbb0149dfad6ae;
module.exports["needsRootChildren"] = $26e80ddf91af379c$export$b38ff668c727ce06;
module.exports["parsePageTitle"] = $26e80ddf91af379c$export$a802709b8af34ca;
module.exports["buildTitleSearchCql"] = $26e80ddf91af379c$export$87777831b2e51242;

});

parcelRegister("2jr6j", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $kVsp1 = parcelRequire("kVsp1");


var $34TzN = parcelRequire("34TzN");


var $fV8ei = parcelRequire("fV8ei");

const $9e98ea7884d33a92$export$e06ba1e8026960ca = {
    extensionKey: 'pagetreesearch',
    routes: [
        'view',
        'space-overview'
    ],
    preload: async (node, context)=>{
        const macroParams = node.attrs?.parameters?.macroParams;
        const rootPageString = (0, $fV8ei.getRootPageParam)(macroParams);
        if (rootPageString == null) return;
        const { spaceKey: spaceKey, title: title, hasExplicitSpace: hasExplicitSpace } = (0, $fV8ei.parseRootPageString)(rootPageString, context.spaceKey);
        if (!spaceKey) return;
        if (title) {
            await (0, $wPrRK.slowQueryGuard)('pageTreeSearchPreload', ()=>(0, $dYU3e.query)({
                    query: (0, $kVsp1.default),
                    variables: {
                        spaceKey: spaceKey,
                        title: title,
                        validateSpace: hasExplicitSpace
                    },
                    context: {
                        single: true
                    },
                    __callerPackage__: "preload-macros"
                }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
            return;
        }
        // Space-only validation (e.g. "MYSPACE:")
        if (hasExplicitSpace) await (0, $wPrRK.slowQueryGuard)('pageTreeSearchSpaceValidationPreload', ()=>(0, $dYU3e.query)({
                query: (0, $34TzN.default),
                variables: {
                    spaceKey: spaceKey
                },
                context: {
                    single: true
                },
                __callerPackage__: "preload-macros"
            }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    }
};
module.exports["pagetreeSearchPreloadHandler"] = $9e98ea7884d33a92$export$e06ba1e8026960ca;

});

parcelRegister("kVsp1", function(module, exports) {
/**
 * @generated SignedSource<<ac24f7a863948accfbd6d59cbbee7264>>
 * @relayHash 4484fadd23c040a81eec65da02ab0cd9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8333bcdd71159e20c0f7e8092762d02226d046fb6481936e04c0bb2aff61fca4
const $87e1172a98f7d3d7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "title"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "validateSpace"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "id"
        }
    ], v2 = [
        {
            "condition": "validateSpace",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "key",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": v1 /*: any*/ 
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "title",
                    "variableName": "title"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "page"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": v1 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePageTreeSearchQueryQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePageTreeSearchQueryQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "4484fadd23c040a81eec65da02ab0cd9",
            "id": "8333bcdd71159e20c0f7e8092762d02226d046fb6481936e04c0bb2aff61fca4",
            "metadata": {},
            "name": "usePageTreeSearchQueryQuery",
            "operationKind": "query",
            "text": "query usePageTreeSearchQueryQuery($spaceKey:String!,$title:String!,$validateSpace:Boolean!){space(key:$spaceKey)@include(if:$validateSpace){id},content(spaceKey:$spaceKey,title:$title,type:\"page\"){nodes{id}}}"
        }
    };
}();
$87e1172a98f7d3d7$var$node.hash = "1be6e27ce1b78f4f22a3ff6689bbf9e4";
var $87e1172a98f7d3d7$export$2e2bcd8739ae039 = $87e1172a98f7d3d7$var$node;
module.exports["default"] = $87e1172a98f7d3d7$export$2e2bcd8739ae039;

});

parcelRegister("34TzN", function(module, exports) {
/**
 * @generated SignedSource<<71bcfe57e49ffa98a90c029ce20a0c42>>
 * @relayHash a2a71f8c82ac5eef37dab68dd9909961
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1e18736f7c82cd2662cfe968df89a26d8a8dd52311595737ad8cf4818f4899dc
const $3a566bea7c41a78b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceValidationQueryQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceValidationQueryQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "a2a71f8c82ac5eef37dab68dd9909961",
            "id": "1e18736f7c82cd2662cfe968df89a26d8a8dd52311595737ad8cf4818f4899dc",
            "metadata": {},
            "name": "useSpaceValidationQueryQuery",
            "operationKind": "query",
            "text": "query useSpaceValidationQueryQuery($spaceKey:String!){space(key:$spaceKey){id}}"
        }
    };
}();
$3a566bea7c41a78b$var$node.hash = "7638ca6f03f75527639ed0545762f27e";
var $3a566bea7c41a78b$export$2e2bcd8739ae039 = $3a566bea7c41a78b$var$node;
module.exports["default"] = $3a566bea7c41a78b$export$2e2bcd8739ae039;

});

parcelRegister("fV8ei", function(module, exports) {
/**
 * Extracts the raw `rootPage` macro parameter value, supporting all known
 * legacy parameter aliases (`rootPage`, `rootpage`, `'0'`).
 *
 * Returns `undefined` when no `rootPage` parameter is set.
 */ const $2efd9995ee26a8d7$export$7e7a804114e88dad = (macroParams)=>{
    if (!macroParams) return undefined;
    return macroParams.rootPage?.value ?? macroParams.rootpage?.value ?? macroParams['0']?.value;
};
const $2efd9995ee26a8d7$export$d0fe7d7e2f2da886 = (rootPageString, defaultSpaceKey)=>{
    const delimiterPos = rootPageString.indexOf(':');
    if (delimiterPos > -1) {
        const rawSpaceKey = rootPageString.substring(0, delimiterPos);
        const spaceKey = rawSpaceKey || defaultSpaceKey;
        const title = rootPageString.substring(delimiterPos + 1);
        return {
            spaceKey: spaceKey,
            title: title,
            hasExplicitSpace: Boolean(rawSpaceKey)
        };
    }
    return {
        spaceKey: defaultSpaceKey,
        title: rootPageString,
        hasExplicitSpace: false
    };
};
module.exports["getRootPageParam"] = $2efd9995ee26a8d7$export$7e7a804114e88dad;
module.exports["parseRootPageString"] = $2efd9995ee26a8d7$export$d0fe7d7e2f2da886;

});

parcelRegister("j9Zer", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $xwvlW = parcelRequire("xwvlW");


var $cBlwX = parcelRequire("cBlwX");


var $bWsrO = parcelRequire("bWsrO");


var $dAlan = parcelRequire("dAlan");

/**
 * Resolves a `spaceKey` to its `spaceId` by preloading the popular-labels
 * macro's own space-id query. This is the same query (`space(key:) { id }`)
 * that `usePopularLabelsDataForSpace` runs on the client, so the response
 * warms the same Apollo cache entry the renderer reads from.
 *
 * Returns `null` when the space cannot be resolved.
 */ const $c34d9e9634b09e90$var$preloadSpaceId = async (spaceKey)=>{
    // Wrap in slowQueryGuard so a slow preload cannot hold SSR open past
    // the configured timeout. We capture the underlying query result via a
    // closure: if the guard times out the closure variable stays undefined
    // and we return null, which causes the labels preload to be skipped —
    // the renderer will fetch on the client.
    let result;
    await (0, $wPrRK.slowQueryGuard)('popularLabelsSpaceIdPreload', async ()=>{
        result = await (0, $dYU3e.query)({
            query: (0, $dAlan.default),
            variables: {
                spaceKey: spaceKey
            },
            context: {
                single: true
            },
            __callerPackage__: "preload-macros"
        });
    }, (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    return result?.data?.space?.id ?? null;
};
const $c34d9e9634b09e90$export$b9e25e62a1057304 = {
    extensionKey: 'popular-labels',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, context)=>{
        try {
            const { cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
            if (!cloudId) return;
            const macroParams = node.attrs?.parameters?.macroParams;
            // Resolve the legacy `'currentSpace()'` sentinel against the host
            // page's space key before issuing the space-id lookup, so the
            // preloaded space-id cache entry matches the renderer's lookup.
            const spaceKeyParam = (0, $cBlwX.resolveSpaceKey)(macroParams?.spaceKey?.value, context.spaceKey);
            let spaceId = null;
            if (spaceKeyParam) {
                spaceId = await $c34d9e9634b09e90$var$preloadSpaceId(spaceKeyParam);
                if (!spaceId) // SpaceKey didn't resolve — skip preloading the labels query rather
                // than warming the wrong (global) scope. The renderer will surface
                // the same error on the client.
                return;
            }
            const variables = {
                cloudId: cloudId,
                first: (0, $cBlwX.parseCount)(macroParams?.count?.value),
                style: (0, $cBlwX.toStyleEnum)((0, $cBlwX.parseStyle)(macroParams?.style?.value)),
                spaceId: spaceId
            };
            await (0, $wPrRK.slowQueryGuard)('popularLabelsPreload', ()=>(0, $dYU3e.query)({
                    query: (0, $bWsrO.default),
                    variables: variables,
                    context: {
                        single: true
                    },
                    __callerPackage__: "preload-macros"
                }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
        } catch  {
            // Preloading is best-effort cache warming. Ignore failures here and
            // let the renderer perform the query in its normal error-handled path.
            return;
        }
    }
};
module.exports["popularLabelsPreloadHandler"] = $c34d9e9634b09e90$export$b9e25e62a1057304;

});

parcelRegister("cBlwX", function(module, exports) {
const $1f71c16b1032d2d5$export$72344c9fa45ae2c1 = 100;
const $1f71c16b1032d2d5$export$a3d4695a56a4eb21 = (value)=>{
    if (!value) return $1f71c16b1032d2d5$export$72344c9fa45ae2c1;
    const parsed = parseInt(value, 10);
    return isNaN(parsed) || parsed <= 0 ? $1f71c16b1032d2d5$export$72344c9fa45ae2c1 : parsed;
};
const $1f71c16b1032d2d5$export$e13dc740254f53d7 = (value)=>{
    return value === 'heatmap' ? 'heatmap' : 'list';
};
const $1f71c16b1032d2d5$export$70583ee990b45c2f = (style)=>{
    return style === 'heatmap' ? 'HEATMAP' : 'LIST';
};
const $1f71c16b1032d2d5$export$f8e62856e51f4d9b = 'currentSpace()';
const $1f71c16b1032d2d5$export$95cd40c60becde49 = (rawSpaceKey, currentSpaceKey)=>{
    if (!rawSpaceKey) return undefined;
    if (rawSpaceKey === $1f71c16b1032d2d5$export$f8e62856e51f4d9b) return currentSpaceKey ?? rawSpaceKey;
    return rawSpaceKey;
};
module.exports["parseCount"] = $1f71c16b1032d2d5$export$a3d4695a56a4eb21;
module.exports["parseStyle"] = $1f71c16b1032d2d5$export$e13dc740254f53d7;
module.exports["toStyleEnum"] = $1f71c16b1032d2d5$export$70583ee990b45c2f;
module.exports["resolveSpaceKey"] = $1f71c16b1032d2d5$export$95cd40c60becde49;

});

parcelRegister("bWsrO", function(module, exports) {
/**
 * @generated SignedSource<<1bea52058c65965280e667d93731c507>>
 * @relayHash e0424719155ec546121f256079f01fd9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a05f556780430a9c3e9c36d02e6fcc5b4a00cb66378101a7ba963d0351ba14e5
const $08d54037c47f542d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "style"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "spaceId",
                    "variableName": "spaceId"
                },
                {
                    "kind": "Variable",
                    "name": "style",
                    "variableName": "style"
                }
            ],
            "concreteType": "ConfluencePopularLabelEntryConnection",
            "kind": "LinkedField",
            "name": "confluence_popularLabelsMacro",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluencePopularLabelEntry",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "rank"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "labelId"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePopularLabelsDataQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePopularLabelsDataQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "e0424719155ec546121f256079f01fd9",
            "id": "a05f556780430a9c3e9c36d02e6fcc5b4a00cb66378101a7ba963d0351ba14e5",
            "metadata": {},
            "name": "usePopularLabelsDataQuery",
            "operationKind": "query",
            "text": "query usePopularLabelsDataQuery($cloudId:ID!,$first:Int,$spaceId:ID,$style:ConfluencePopularLabelStyle){confluence_popularLabelsMacro(cloudId:$cloudId,first:$first,spaceId:$spaceId,style:$style){nodes{name,rank,labelId}}}"
        }
    };
}();
$08d54037c47f542d$var$node.hash = "a1e70e0ea0c7fdc30bd20e4d9ca0b0e8";
var $08d54037c47f542d$export$2e2bcd8739ae039 = $08d54037c47f542d$var$node;
module.exports["default"] = $08d54037c47f542d$export$2e2bcd8739ae039;

});

parcelRegister("dAlan", function(module, exports) {
/**
 * @generated SignedSource<<ced0a6739432a230108889f4d0e09538>>
 * @relayHash 41fee47bcd447ee8e96835308a5a4f99
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cd95adfed4d8357af09a9ad201ca4d15932c64b4fa418a1b4a4c2e557e12c551
const $566340bccba941cc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePopularLabelsDataSpaceIdQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePopularLabelsDataSpaceIdQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "41fee47bcd447ee8e96835308a5a4f99",
            "id": "cd95adfed4d8357af09a9ad201ca4d15932c64b4fa418a1b4a4c2e557e12c551",
            "metadata": {},
            "name": "usePopularLabelsDataSpaceIdQuery",
            "operationKind": "query",
            "text": "query usePopularLabelsDataSpaceIdQuery($spaceKey:String){space(key:$spaceKey){id}}"
        }
    };
}();
$566340bccba941cc$var$node.hash = "d5968c7370aba3bd3a9089e4721bb508";
var $566340bccba941cc$export$2e2bcd8739ae039 = $566340bccba941cc$var$node;
module.exports["default"] = $566340bccba941cc$export$2e2bcd8739ae039;

});

parcelRegister("eOfv4", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $30F7c = parcelRequire("30F7c");

const $ab0a577528facf1f$export$a26d4f508ed8cd67 = {
    extensionKey: 'profile-picture',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, _context)=>{
        try {
            const userId = node.attrs?.parameters?.macroParams?.User?.value;
            if (!userId) return;
            const variables = {
                userId: userId
            };
            await (0, $wPrRK.slowQueryGuard)('profilePicturePreload', ()=>(0, $dYU3e.query)({
                    query: (0, $30F7c.default),
                    variables: variables,
                    context: {
                        single: true
                    },
                    __callerPackage__: "preload-macros"
                }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
        } catch  {
            // Preloading is best-effort cache warming. Ignore failures here and
            // let the renderer perform the query in its normal error-handled path.
            return;
        }
    }
};
module.exports["profilePicturePreloadHandler"] = $ab0a577528facf1f$export$a26d4f508ed8cd67;

});

parcelRegister("30F7c", function(module, exports) {
/**
 * @generated SignedSource<<20904bfa8cc8894f1f41fd4c23de4797>>
 * @relayHash 98854a5bccd4ea4b4cf3114c1778a63a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f4c165001740b0572461dd93e231b3425c566a844e008bc410f5e0b3630c4f05
const $082db8f111d4d391$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userId"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "value"
        },
        {
            "kind": "ScalarField",
            "name": "isPrimary"
        }
    ], v2 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "userId"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": v1 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserEmail",
                    "kind": "LinkedField",
                    "name": "emails",
                    "plural": true,
                    "selections": v1 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "isActive"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useProfileInfoUserContextQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useProfileInfoUserContextQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "98854a5bccd4ea4b4cf3114c1778a63a",
            "id": "f4c165001740b0572461dd93e231b3425c566a844e008bc410f5e0b3630c4f05",
            "metadata": {},
            "name": "useProfileInfoUserContextQuery",
            "operationKind": "query",
            "text": "query useProfileInfoUserContextQuery($userId:ID){user:confluence_atlassianUser(id:$userId){id,photos{value,isPrimary},displayName,emails{value,isPrimary},title,isActive}}"
        }
    };
}();
$082db8f111d4d391$var$node.hash = "cd83aff11b55f855ecd3361dedc3552d";
var $082db8f111d4d391$export$2e2bcd8739ae039 = $082db8f111d4d391$var$node;
module.exports["default"] = $082db8f111d4d391$export$2e2bcd8739ae039;

});

parcelRegister("hwhSw", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $30F7c = parcelRequire("30F7c");

const $f988674c040264f3$export$ba7f4f786ca1288f = {
    extensionKey: 'profile',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, _context)=>{
        try {
            const userId = node.attrs?.parameters?.macroParams?.user?.value;
            if (!userId) return;
            const variables = {
                userId: userId
            };
            await (0, $wPrRK.slowQueryGuard)('userProfilePreload', ()=>(0, $dYU3e.query)({
                    query: (0, $30F7c.default),
                    variables: variables,
                    context: {
                        single: true
                    },
                    __callerPackage__: "preload-macros"
                }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
        } catch  {
            // Preloading is best-effort cache warming. Ignore failures here and
            // let the renderer perform the query in its normal error-handled path.
            return;
        }
    }
};
module.exports["userProfilePreloadHandler"] = $f988674c040264f3$export$ba7f4f786ca1288f;

});

parcelRegister("aEHCA", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $15svH = parcelRequire("15svH");


var $jqlpB = parcelRequire("jqlpB");

const $07b632e1e0c660f3$var$buildVariables = (contentId, parsed)=>{
    return (0, $jqlpB.buildViewPdfQueryVariables)({
        contentId: contentId,
        pageName: parsed.pageName,
        spaceKey: parsed.spaceKey,
        date: parsed.date
    });
};
const $07b632e1e0c660f3$export$f9e67083aa63b898 = {
    extensionKey: 'viewpdf',
    routes: [
        'view',
        'space-overview',
        'edit'
    ],
    preload: async (node, context)=>{
        const macroParams = node.attrs?.parameters?.macroParams;
        const parsed = (0, $jqlpB.parseViewPdfMacroParams)(macroParams);
        if (!parsed.attachmentName) return;
        const variables = $07b632e1e0c660f3$var$buildVariables(context.contentId, parsed);
        await (0, $wPrRK.slowQueryGuard)('viewPdfPreload', ()=>(0, $dYU3e.query)({
                query: (0, $15svH.default),
                variables: variables,
                context: {
                    single: true
                },
                __callerPackage__: "preload-macros"
            }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    }
};
module.exports["viewPdfPreloadHandler"] = $07b632e1e0c660f3$export$f9e67083aa63b898;

});

parcelRegister("15svH", function(module, exports) {
/**
 * @generated SignedSource<<c94c3f7a76f8371f5cb62396b720ee7a>>
 * @relayHash 814697115f3f596cbb9c38ce14be1f85
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fb4b2b513a3e28c226362fa46e7d11cc5508513505b03509f58942665c918c38
const $6ba83d52bb6ac0cf$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "postingDay"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "title"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "type"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Variable",
            "name": "postingDay",
            "variableName": "postingDay"
        },
        {
            "kind": "Variable",
            "name": "spaceKey",
            "variableName": "spaceKey"
        },
        {
            "kind": "Variable",
            "name": "status",
            "variableName": "contentStatus"
        },
        {
            "kind": "Variable",
            "name": "title",
            "variableName": "title"
        },
        {
            "kind": "Variable",
            "name": "type",
            "variableName": "type"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 250
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "title"
    }, v10 = {
        "concreteType": "KeyValueHierarchyMap",
        "kind": "LinkedField",
        "name": "extensions",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useViewPdfDataQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "args": v8 /*: any*/ ,
                                            "concreteType": "PaginatedContentList",
                                            "kind": "LinkedField",
                                            "name": "attachments",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Content",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "attachments(first:250)"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useViewPdfDataQuery",
            "selections": [
                {
                    "args": v6 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "args": v8 /*: any*/ ,
                                            "concreteType": "PaginatedContentList",
                                            "kind": "LinkedField",
                                            "name": "attachments",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Content",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "attachments(first:250)"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "814697115f3f596cbb9c38ce14be1f85",
            "id": "fb4b2b513a3e28c226362fa46e7d11cc5508513505b03509f58942665c918c38",
            "metadata": {},
            "name": "useViewPdfDataQuery",
            "operationKind": "query",
            "text": "query useViewPdfDataQuery($contentId:ID,$contentStatus:[String],$spaceKey:String,$title:String,$type:String,$postingDay:String){content(id:$contentId,status:$contentStatus,spaceKey:$spaceKey,title:$title,type:$type,postingDay:$postingDay){edges{node{id,attachments(first:250){nodes{title,extensions{key,value},id}}}}}}"
        }
    };
}();
$6ba83d52bb6ac0cf$var$node.hash = "20d975cc714dfdf1087101ddcb9c164b";
var $6ba83d52bb6ac0cf$export$2e2bcd8739ae039 = $6ba83d52bb6ac0cf$var$node;
module.exports["default"] = $6ba83d52bb6ac0cf$export$2e2bcd8739ae039;

});

parcelRegister("jqlpB", function(module, exports) {
const $3500f1c8d39c6386$export$ac4d1f313c318334 = '100%';
const $3500f1c8d39c6386$export$7ce912260e18e60d = '650px';
const $3500f1c8d39c6386$export$c3becee1470bf9a7 = (size)=>{
    const numericSize = size.replace(/[^\d.]+/g, '');
    if (size.endsWith('%')) return `${numericSize}%`;
    return `${numericSize}px`;
};
const $3500f1c8d39c6386$export$3082a5716eb987e9 = (rawWidth, rawHeight)=>({
        width: rawWidth ? $3500f1c8d39c6386$export$c3becee1470bf9a7(rawWidth) : $3500f1c8d39c6386$export$ac4d1f313c318334,
        height: rawHeight ? $3500f1c8d39c6386$export$c3becee1470bf9a7(rawHeight) : $3500f1c8d39c6386$export$7ce912260e18e60d
    });
const $3500f1c8d39c6386$export$c86b59de1acee041 = (rawPageParam)=>{
    if (!rawPageParam) return {
        pageName: null,
        spaceKey: null,
        date: null
    };
    const pageParam = rawPageParam.trim();
    if (!pageParam) return {
        pageName: null,
        spaceKey: null,
        date: null
    };
    const firstColon = pageParam.indexOf(':');
    const spacePart = firstColon !== -1 ? pageParam.slice(0, firstColon) || null : null;
    const titlePart = firstColon !== -1 ? pageParam.slice(firstColon + 1) : pageParam;
    let pageName = titlePart;
    let date = null;
    const blogMatch = titlePart.match(/^\/(\d{4})\/(\d{2})\/(\d{2})\/(.+)$/);
    if (blogMatch) {
        const [, year, month, day, title] = blogMatch;
        date = `${month}/${day}/${year}`;
        pageName = title;
    }
    return {
        pageName: pageName || null,
        spaceKey: spacePart || null,
        date: date
    };
};
const $3500f1c8d39c6386$export$6cc41227155528f2 = (macroParams)=>{
    const attachmentName = macroParams?.name?.value ?? macroParams?.['']?.value ?? macroParams?.defaultParameterValue?.value ?? null;
    const decodedPage = $3500f1c8d39c6386$export$c86b59de1acee041(macroParams?.page?.value ?? null);
    const { width: viewerWidth, height: viewerHeight } = $3500f1c8d39c6386$export$3082a5716eb987e9(macroParams?.width?.value, macroParams?.height?.value);
    return {
        attachmentName: attachmentName,
        pageName: decodedPage.pageName,
        spaceKey: macroParams?.space?.value ?? decodedPage.spaceKey,
        date: macroParams?.date?.value ?? decodedPage.date,
        viewerWidth: viewerWidth,
        viewerHeight: viewerHeight
    };
};
const $3500f1c8d39c6386$export$a35ba7e9630557a6 = (date)=>{
    const parts = date.split('/');
    if (parts.length !== 3) return undefined;
    const [month, day, year] = parts;
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};
const $3500f1c8d39c6386$export$3ac25d3edc0c1d36 = ({ contentId: contentId, pageName: pageName, spaceKey: spaceKey, date: date })=>{
    const normalizedPageName = pageName?.trim() || null;
    if (normalizedPageName) {
        const variables = {
            contentStatus: [
                'current'
            ],
            title: normalizedPageName,
            type: date ? 'blogpost' : 'page'
        };
        if (spaceKey) variables.spaceKey = spaceKey;
        if (date) variables.postingDay = $3500f1c8d39c6386$export$a35ba7e9630557a6(date);
        return variables;
    }
    return {
        contentId: contentId ?? undefined,
        contentStatus: [
            'current'
        ]
    };
};
module.exports["parseViewPdfMacroParams"] = $3500f1c8d39c6386$export$6cc41227155528f2;
module.exports["buildViewPdfQueryVariables"] = $3500f1c8d39c6386$export$3ac25d3edc0c1d36;

});

parcelRegister("ivpnt", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $wPrRK = parcelRequire("wPrRK");


var $xwvlW = parcelRequire("xwvlW");


var $ei8Ok = parcelRequire("ei8Ok");


var $rPmsQ = parcelRequire("rPmsQ");


var $fzKPX = parcelRequire("fzKPX");

/**
 * Splits the spaces macro param into two buckets at preload time, mirroring
 * the runtime hook's logic so the Apollo cache key matches exactly:
 *
 * - spaceIds: tokens (@self, currentSpace()) and numeric IDs resolved
 *   synchronously. At preload time there is no current-space context so tokens
 *   are dropped (toLongIds with undefined currentSpaceId skips them).
 * - spaceKeys: human-readable keys (e.g. "ENG") passed directly to the AGG
 *   query for server-side resolution (InlineTasksByMetadata.spaceKeys).
 *
 * Falls back to the context spaceKey when no explicit spaces are provided,
 * mirroring the "current page's space" default used at runtime.
 */ const $20c66e73a45f79d8$var$resolveSpaceFilter = (spacesParam, contextSpaceKey)=>{
    if (spacesParam) {
        const parts = (0, $fzKPX.parseCommaSeparatedValues)(spacesParam) ?? [];
        const spaceIds = (0, $fzKPX.toLongIds)(parts, undefined);
        const spaceKeys = parts.filter((value)=>value !== (0, $fzKPX.CURRENT_SPACE_TOKEN) && value !== (0, $fzKPX.SELF_SPACE_TOKEN) && !/^\d+$/.test(value.startsWith('~') ? value.slice(1) : value));
        if (spaceIds.length || spaceKeys.length) return {
            spaceIds: spaceIds,
            spaceKeys: spaceKeys
        };
    }
    // Fall back to the current space from context when no explicit spaces provided.
    const contextSpaceId = Number.parseInt(contextSpaceKey, 10);
    if (!Number.isNaN(contextSpaceId)) return {
        spaceIds: [
            contextSpaceId
        ],
        spaceKeys: []
    };
    return {
        spaceIds: [],
        spaceKeys: []
    };
};
const $20c66e73a45f79d8$export$536478985aace428 = {
    extensionKey: 'tasks-report-macro',
    routes: [
        'view',
        'space-overview',
        'edit',
        'live'
    ],
    preload: async (node, context)=>{
        try {
            const { cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
            if (!cloudId) return;
            const macroParams = node.attrs?.parameters?.macroParams;
            const params = (0, $rPmsQ.parseMacroParams)(macroParams);
            const { spaceIds: spaceIds, spaceKeys: spaceKeys } = $20c66e73a45f79d8$var$resolveSpaceFilter(params.spaces, context.spaceKey);
            if (!spaceIds.length && !spaceKeys.length) return;
            // Keep preload variables identical to runtime so Apollo cache keys match.
            const taskQuery = (0, $fzKPX.buildTaskQueryMetadata)(params, spaceIds, spaceKeys);
            await (0, $wPrRK.slowQueryGuard)('tasksReportPreload', ()=>(0, $dYU3e.query)({
                    query: (0, $ei8Ok.GetTasksReportQuery),
                    variables: {
                        taskQuery: taskQuery,
                        cloudId: cloudId
                    },
                    context: {
                        single: true
                    },
                    __callerPackage__: "preload-macros"
                }), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
        } catch  {
            return;
        }
    }
};
module.exports["tasksReportPreloadHandler"] = $20c66e73a45f79d8$export$536478985aace428;

});

parcelRegister("ei8Ok", function(module, exports) {

var $hJ6Qq = parcelRequire("hJ6Qq");

const $fad24ea7634a5491$export$19eb1cc447563b7 = (0, $hJ6Qq.default);
module.exports["GetTasksReportQuery"] = $fad24ea7634a5491$export$19eb1cc447563b7;

});

parcelRegister("hJ6Qq", function(module, exports) {
/**
 * @generated SignedSource<<a175a783c54a1bbb11115609f78cee71>>
 * @relayHash 4257b78a458e32e70bf16869db78cf05
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9e3aa6ff5332eca65f4d3f98919099fe7dc36425d0f211fc86efcd38e6128e4c
const $711aa99d4bd43f06$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "taskQuery"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "tasksQuery",
            "variableName": "taskQuery"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "taskId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "status"
    }, v6 = {
        "kind": "ScalarField",
        "name": "dueAt"
    }, v7 = {
        "kind": "ScalarField",
        "name": "createdAt"
    }, v8 = {
        "kind": "ScalarField",
        "name": "completedAt"
    }, v9 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v10 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v11 = {
        "concreteType": "GraphQLUserInfo",
        "kind": "LinkedField",
        "name": "assignedTo",
        "plural": false,
        "selections": [
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            {
                "concreteType": "Icon",
                "kind": "LinkedField",
                "name": "profilePicture",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "path"
                    }
                ]
            }
        ]
    }, v12 = {
        "concreteType": "GraphQLUserInfo",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": [
            v9 /*: any*/ ,
            v10 /*: any*/ 
        ]
    }, v13 = {
        "concreteType": "ConfluenceContentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "adf"
            }
        ]
    }, v14 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v15 = {
        "kind": "ScalarField",
        "name": "pageId"
    }, v16 = {
        "kind": "ScalarField",
        "name": "title"
    }, v17 = [
        {
            "kind": "ScalarField",
            "name": "base"
        },
        {
            "kind": "ScalarField",
            "name": "webUi"
        }
    ], v18 = {
        "concreteType": "ConfluencePageLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v17 /*: any*/ 
    }, v19 = {
        "kind": "ScalarField",
        "name": "label"
    }, v20 = {
        "kind": "ScalarField",
        "name": "prefix"
    }, v21 = {
        "concreteType": "ConfluenceLabel",
        "kind": "LinkedField",
        "name": "labels",
        "plural": true,
        "selections": [
            v19 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v22 = {
        "concreteType": "ConfluenceSpace",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v3 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "spaceId"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "concreteType": "ConfluenceSpaceLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v17 /*: any*/ 
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "blogPostId"
    }, v24 = {
        "concreteType": "ConfluenceBlogPostLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v17 /*: any*/ 
    }, v25 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v26 = {
        "concreteType": "ConfluenceLabel",
        "kind": "LinkedField",
        "name": "labels",
        "plural": true,
        "selections": [
            v19 /*: any*/ ,
            v20 /*: any*/ ,
            v3 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "GetTasksReportQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "InlineTasksQueryResult",
                    "kind": "LinkedField",
                    "name": "inlineTasks",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphQLInlineTask",
                            "kind": "LinkedField",
                            "name": "inlineTasks",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "container",
                                    "plural": false,
                                    "selections": [
                                        v14 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v22 /*: any*/ 
                                            ],
                                            "type": "ConfluencePage"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v24 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v22 /*: any*/ 
                                            ],
                                            "type": "ConfluenceBlogPost"
                                        }
                                    ]
                                }
                            ]
                        },
                        v25 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "GetTasksReportQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "InlineTasksQueryResult",
                    "kind": "LinkedField",
                    "name": "inlineTasks",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphQLInlineTask",
                            "kind": "LinkedField",
                            "name": "inlineTasks",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "container",
                                    "plural": false,
                                    "selections": [
                                        v14 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v26 /*: any*/ ,
                                                v22 /*: any*/ 
                                            ],
                                            "type": "ConfluencePage"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v24 /*: any*/ ,
                                                v26 /*: any*/ ,
                                                v22 /*: any*/ 
                                            ],
                                            "type": "ConfluenceBlogPost"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v3 /*: any*/ 
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        },
                        v25 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "4257b78a458e32e70bf16869db78cf05",
            "id": "9e3aa6ff5332eca65f4d3f98919099fe7dc36425d0f211fc86efcd38e6128e4c",
            "metadata": {},
            "name": "GetTasksReportQuery",
            "operationKind": "query",
            "text": "query GetTasksReportQuery($taskQuery:InlineTasksByMetadata!,$cloudId:ID){inlineTasks(tasksQuery:$taskQuery,cloudId:$cloudId){inlineTasks{id,taskId,status,dueAt,createdAt,completedAt,assignedTo{accountId,displayName,profilePicture{path}},createdBy{accountId,displayName},body{adf},container{__typename,...on ConfluencePage{id,pageId,title,links{base,webUi},labels{label,prefix,id},space{id,spaceId,name,links{base,webUi}}},...on ConfluenceBlogPost{id,blogPostId,title,links{base,webUi},labels{label,prefix,id},space{id,spaceId,name,links{base,webUi}}},...on Node{__isNode:__typename,id}}},endCursor}}"
        }
    };
}();
$711aa99d4bd43f06$var$node.hash = "2b6c33814689e4cbcbd78fd4ed149156";
var $711aa99d4bd43f06$export$2e2bcd8739ae039 = $711aa99d4bd43f06$var$node;
module.exports["default"] = $711aa99d4bd43f06$export$2e2bcd8739ae039;

});

parcelRegister("rPmsQ", function(module, exports) {

var $bdzG7 = parcelRequire("bdzG7");

const $3b01e085cfcfbcb8$var$DEFAULT_PAGE_SIZE = 20;
const $3b01e085cfcfbcb8$var$DEFAULT_COLUMNS = [
    'description',
    'duedate',
    'assignee',
    'location'
];
const $3b01e085cfcfbcb8$var$VALID_COLUMNS = [
    'description',
    'duedate',
    'assignee',
    'location',
    'completedate',
    'labels'
];
const $3b01e085cfcfbcb8$var$VALID_COLUMNS_SET = new Set($3b01e085cfcfbcb8$var$VALID_COLUMNS);
function $3b01e085cfcfbcb8$var$parseColumns(raw) {
    if (!raw || typeof raw !== 'string') return $3b01e085cfcfbcb8$var$DEFAULT_COLUMNS;
    const parsed = [];
    const seen = new Set();
    const parts = raw.split(',');
    for (const part of parts){
        const c = part.trim().toLowerCase();
        if ($3b01e085cfcfbcb8$var$VALID_COLUMNS_SET.has(c) && !seen.has(c)) {
            seen.add(c);
            parsed.push(c);
        }
    }
    // If no valid columns were found at all, use the documented default set.
    // This covers the case where the user supplied only invalid column names —
    // without this guard, description would be unshifted below and the user
    // would get a single-column table instead of the four-column default.
    if (!parsed.length) return $3b01e085cfcfbcb8$var$DEFAULT_COLUMNS;
    // description is always present as the first column.
    if (!parsed.includes('description')) parsed.unshift('description');
    return parsed;
}
function $3b01e085cfcfbcb8$export$66770a7e7da42ecb(macroParams) {
    const raw = macroParams ?? {};
    const columns = $3b01e085cfcfbcb8$var$parseColumns(raw.columns?.value);
    const pageSize = parseInt(raw.pageSize?.value ?? '', 10) || $3b01e085cfcfbcb8$var$DEFAULT_PAGE_SIZE;
    const reverseSort = raw.reverseSort?.value === 'true' || raw.reverseSort?.value === true;
    const status = (0, $bdzG7.normalizeTasksReportStatus)(raw.status?.value);
    return {
        columns: columns,
        spaces: raw.spaces?.value || undefined,
        pages: raw.pages?.value || undefined,
        assignees: raw.assignees?.value || undefined,
        creators: raw.creators?.value || undefined,
        labels: raw.labels?.value || undefined,
        status: status,
        duedateFrom: raw.duedateFrom?.value ?? undefined,
        duedateTo: raw.duedateTo?.value ?? undefined,
        createddateFrom: raw.createddateFrom?.value ?? undefined,
        createddateTo: raw.createddateTo?.value ?? undefined,
        pageSize: pageSize,
        sortBy: raw.sortBy?.value || undefined,
        reverseSort: reverseSort
    };
}
module.exports["parseMacroParams"] = $3b01e085cfcfbcb8$export$66770a7e7da42ecb;

});

parcelRegister("bdzG7", function(module, exports) {
const $4338c3d1d9e19bac$export$2344a301308c0556 = {
    complete: 'CHECKED',
    incomplete: 'UNCHECKED'
};
const $4338c3d1d9e19bac$var$DEFAULT_STATUS = 'incomplete';
const $4338c3d1d9e19bac$var$STATUS_ALIASES = {
    complete: 'complete',
    completed: 'complete',
    checked: 'complete',
    incomplete: 'incomplete',
    unchecked: 'incomplete'
};
const $4338c3d1d9e19bac$export$d7a098da087f5881 = (rawStatus)=>{
    const normalizedStatus = rawStatus?.trim().toLowerCase();
    if (!normalizedStatus) return $4338c3d1d9e19bac$var$DEFAULT_STATUS;
    return $4338c3d1d9e19bac$var$STATUS_ALIASES[normalizedStatus] ?? $4338c3d1d9e19bac$var$DEFAULT_STATUS;
};
module.exports["STATUS_MAP"] = $4338c3d1d9e19bac$export$2344a301308c0556;
module.exports["normalizeTasksReportStatus"] = $4338c3d1d9e19bac$export$d7a098da087f5881;

});

parcelRegister("fzKPX", function(module, exports) {

var $iDL64 = parcelRequire("iDL64");


var $bdzG7 = parcelRequire("bdzG7");

const $0eff6d7450e12c55$export$2344a301308c0556 = (0, $bdzG7.STATUS_MAP);
const $0eff6d7450e12c55$export$b589e8bb676eddda = {
    duedate: 'DUE_DATE',
    assignee: 'ASSIGNEE',
    location: 'PAGE_TITLE'
};
const $0eff6d7450e12c55$export$15d71cf2c82ff427 = (value)=>{
    if (!value) return undefined;
    const raw = value.split(',');
    const result = [];
    for (const rawValue of raw){
        const trimmed = rawValue.trim();
        if (trimmed) result.push(trimmed);
    }
    return result.length ? result : undefined;
};
const $0eff6d7450e12c55$export$c080dece27bf09b3 = 'currentSpace()';
const $0eff6d7450e12c55$export$ecbdafc24a12ca0b = '@self';
const $0eff6d7450e12c55$export$4399bda962ab122b = (value)=>{
    const normalizedValue = value.startsWith('~') ? value.slice(1) : value;
    if (!/^\d+$/.test(normalizedValue)) return undefined;
    const parsedId = Number.parseInt(normalizedValue, 10);
    return Number.isNaN(parsedId) ? undefined : parsedId;
};
const $0eff6d7450e12c55$export$3d46c7941b830c2b = (values, currentSpaceId)=>{
    if (!values?.length) return [];
    const parsedIds = [];
    for (const value of values){
        if (value === $0eff6d7450e12c55$export$c080dece27bf09b3 || value === $0eff6d7450e12c55$export$ecbdafc24a12ca0b) {
            if (currentSpaceId !== undefined) parsedIds.push(currentSpaceId);
            continue;
        }
        const parsedId = $0eff6d7450e12c55$export$4399bda962ab122b(value);
        if (parsedId !== undefined) parsedIds.push(parsedId);
    }
    return parsedIds;
};
function $0eff6d7450e12c55$export$6042c1e6bdce848e(params, spaceIds, spaceKeys, after = null) {
    const requestedStatus = params.status;
    const mappedStatus = $0eff6d7450e12c55$export$2344a301308c0556[requestedStatus] ?? $0eff6d7450e12c55$export$2344a301308c0556.incomplete;
    const pageIds = $0eff6d7450e12c55$export$3d46c7941b830c2b($0eff6d7450e12c55$export$15d71cf2c82ff427(params.pages));
    const assigneeAccountIds = $0eff6d7450e12c55$export$15d71cf2c82ff427(params.assignees);
    const creatorAccountIds = $0eff6d7450e12c55$export$15d71cf2c82ff427(params.creators);
    const hasDueDate = params.duedateFrom != null || params.duedateTo != null;
    const hasCreatedDate = params.createddateFrom != null || params.createddateTo != null;
    // Only pass sortParameters for columns the server can sort — labels has no
    // server-side equivalent and falls back to the server's default order.
    const sortColumn = params.sortBy ? $0eff6d7450e12c55$export$b589e8bb676eddda[params.sortBy] ?? null : null;
    const dueDate = hasDueDate ? {
        startDate: (0, $iDL64.toEpoch)(params.duedateFrom),
        endDate: (0, $iDL64.toEpoch)(params.duedateTo)
    } : null;
    const createdDateRange = hasCreatedDate ? {
        startDate: (0, $iDL64.toEpoch)(params.createddateFrom),
        endDate: (0, $iDL64.toEpoch)(params.createddateTo)
    } : null;
    return {
        first: params.pageSize,
        after: after,
        spaceIds: spaceIds.length ? spaceIds : null,
        spaceKeys: spaceKeys.length ? spaceKeys : null,
        pageIds: pageIds.length ? pageIds : null,
        status: mappedStatus,
        accountIds: assigneeAccountIds?.length || creatorAccountIds?.length ? {
            assigneeAccountIds: assigneeAccountIds,
            creatorAccountIds: creatorAccountIds
        } : null,
        dueDate: dueDate,
        createdDateRange: createdDateRange,
        sortParameters: sortColumn ? {
            sortColumn: sortColumn,
            // Legacy macro semantics: reverseSort=false keeps default descending order,
            // reverseSort=true flips to ascending.
            sortOrder: params.reverseSort ? 'ASCENDING' : 'DESCENDING'
        } : null
    };
}
module.exports["parseCommaSeparatedValues"] = $0eff6d7450e12c55$export$15d71cf2c82ff427;
module.exports["CURRENT_SPACE_TOKEN"] = $0eff6d7450e12c55$export$c080dece27bf09b3;
module.exports["SELF_SPACE_TOKEN"] = $0eff6d7450e12c55$export$ecbdafc24a12ca0b;
module.exports["toLongIds"] = $0eff6d7450e12c55$export$3d46c7941b830c2b;
module.exports["buildTaskQueryMetadata"] = $0eff6d7450e12c55$export$6042c1e6bdce848e;

});

parcelRegister("iDL64", function(module, exports) {
const $774a0d79f8a73639$var$DAY_FIRST_DATE_PATTERN = /^(\d{1,2})[\/-](\d{1,2})[\/-](\d{4})$/;
const $774a0d79f8a73639$var$parseDayFirstDate = (input)=>{
    const dayFirstMatch = input.match($774a0d79f8a73639$var$DAY_FIRST_DATE_PATTERN);
    if (!dayFirstMatch) return undefined;
    const day = Number.parseInt(dayFirstMatch[1], 10);
    const month = Number.parseInt(dayFirstMatch[2], 10);
    const year = Number.parseInt(dayFirstMatch[3], 10);
    if (day < 1 || day > 31 || month < 1 || month > 12) return undefined;
    const asUtcMidnight = Date.UTC(year, month - 1, day);
    const parsedDate = new Date(asUtcMidnight);
    return parsedDate.getUTCFullYear() === year && parsedDate.getUTCMonth() === month - 1 && parsedDate.getUTCDate() === day ? asUtcMidnight : undefined;
};
const $774a0d79f8a73639$export$373c6eac988f94dd = (value)=>{
    if (value == null) return undefined;
    if (typeof value === 'number') return Number.isNaN(value) ? undefined : value;
    const trimmed = value.trim();
    if (!trimmed) return undefined;
    const numeric = Number(trimmed);
    if (!Number.isNaN(numeric)) return numeric;
    // Date picker values are day-first calendar dates; parse explicitly to avoid
    // locale-dependent Date.parse swaps (e.g. 09/04 interpreted as Sep 4).
    if ($774a0d79f8a73639$var$DAY_FIRST_DATE_PATTERN.test(trimmed)) return $774a0d79f8a73639$var$parseDayFirstDate(trimmed);
    const parsed = Date.parse(trimmed);
    return Number.isNaN(parsed) ? undefined : parsed;
};
module.exports["toEpoch"] = $774a0d79f8a73639$export$373c6eac988f94dd;

});

parcelRegister("9OYfw", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $l1kdf = parcelRequire("l1kdf");


var $nIvaQ = parcelRequire("nIvaQ");


var $8R0gj = parcelRequire("8R0gj");


var $hNtOj = parcelRequire("hNtOj");


var $27Dus = parcelRequire("27Dus");

function $cb117090d47a4a62$export$952cf09a216eb6d(contentId, draftShareId, useCache) {
    return (0, $dYU3e.query)({
        query: (0, $nIvaQ.getCollabDraftQuery)(),
        variables: {
            id: contentId,
            hydrateAdf: true,
            ...draftShareId ? {
                draftShareId: draftShareId
            } : undefined
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        __callerPackage__: "load-edit-page"
    }).then(async (result)=>{
        // There is a bug in appolo client (https://github.com/apollographql/react-apollo/issues/3918)
        // that doesn't preserve the result in caches if there is an error in SSR
        // So we need to preserve the error, to be able to verify it later during render phase in SSR
        if (result?.errors?.some((err)=>(0, $8R0gj.isDraftSSRPreloadPermissionError)(err?.message))) (0, $hNtOj.ssrPermissionsErrorHandler).markSSRPreloadPermissionError('edit');
        // There are two reasons to store smart card URLs on the window object:
        // 1. The OTP uses a document snapshot from Confluence that may be outdated and miss recently added or removed smart cards,
        //    so we must reconcile the list of smart cards with the draft content.
        // 2. The draft content stores links with slugs, but the Confluence snapshot does not,
        //    so we need to add slugs sourced from the draft content.
        // Therefore, we extract smart cards from the draft content here, save them on the window object,
        // and later use them to align the Confluence snapshot with the draft content.
        window['__SMART_CARDS_IN_DRAFT__'] = (0, $27Dus.findSmartCardNodes)(result?.data?.collabDraft?.document || '');
        return result;
    });
}
function $cb117090d47a4a62$export$7c1f00ae06ab82b8(contentId, draftShareId, useCache, status) {
    return (0, $dYU3e.query)({
        query: (0, $l1kdf.NativeCollabQuery),
        variables: {
            contentId: contentId,
            ...draftShareId && {
                draftShareId: draftShareId
            },
            status: status ?? [
                'draft',
                'current'
            ]
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        context: {
            single: 'true'
        },
        __callerPackage__: "load-edit-page"
    });
}
module.exports["preloadCollabDraftContent"] = $cb117090d47a4a62$export$952cf09a216eb6d;
module.exports["preloadNativeCollab"] = $cb117090d47a4a62$export$7c1f00ae06ab82b8;

});

parcelRegister("l1kdf", function(module, exports) {

var $hrBIS = parcelRequire("hrBIS");

const $c2e596865d8e6fea$export$79b924d780de6f0d = (0, $hrBIS.default);
module.exports["NativeCollabQuery"] = $c2e596865d8e6fea$export$79b924d780de6f0d;

});

parcelRegister("hrBIS", function(module, exports) {
/**
 * @generated SignedSource<<4cf4db12dd73f2ac885d741a3d7c65ba>>
 * @relayHash 4e152ff0861f20bc69927f68972ccc1e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 24bbbff0309d612fd3761eb95cc4e8454341bfb5663a836acebc11c0a54451dc
const $83575f8369490c15$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "draftShareId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "draftShareId",
            "variableName": "draftShareId"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Variable",
            "name": "status",
            "variableName": "status"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "ScalarField",
        "name": "status"
    }, v5 = {
        "kind": "ScalarField",
        "name": "number"
    }, v6 = {
        "kind": "ScalarField",
        "name": "ncsStepVersion"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v8 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v9 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            v10 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "homepageId"
            }
        ]
    }, v12 = {
        "concreteType": "PaginatedLabelList",
        "kind": "LinkedField",
        "name": "labels",
        "plural": false,
        "selections": [
            {
                "concreteType": "Label",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v2 /*: any*/ ,
                    v10 /*: any*/ 
                ]
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v14 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "NativeCollabQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v9 /*: any*/ 
                                    ]
                                },
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "NativeCollabQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v9 /*: any*/ 
                                    ]
                                },
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "4e152ff0861f20bc69927f68972ccc1e",
            "id": "24bbbff0309d612fd3761eb95cc4e8454341bfb5663a836acebc11c0a54451dc",
            "metadata": {},
            "name": "NativeCollabQuery",
            "operationKind": "query",
            "text": "query NativeCollabQuery($contentId:ID,$draftShareId:String,$status:[String]){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,type,status,version{number,ncsStepVersion,by{__typename,type,...on KnownUser{accountId}}},history{createdBy{__typename,displayName},createdDate},space{id,name,homepageId},labels{nodes{id,name}},subType}}}"
        }
    };
}();
$83575f8369490c15$var$node.hash = "182a5142c1846497c5e27245efe74033";
var $83575f8369490c15$export$2e2bcd8739ae039 = $83575f8369490c15$var$node;
module.exports["default"] = $83575f8369490c15$export$2e2bcd8739ae039;

});

parcelRegister("8R0gj", function(module, exports) {

var $747ya = parcelRequire("747ya");

async function $65899b702fdd32b1$export$dfd3c4c0aa957792(contentId, draftShareId) {
    window.__PRELOAD_DRAFT__ = {
        contentId: contentId,
        draftFetchPromise: (0, $747ya.fetchDraft)(contentId, draftShareId),
        startTime: window?.performance?.now?.()
    };
}
const $65899b702fdd32b1$var$DRAFT_PERMISSION_ERROR = '.PermissionException: User does not have permission';
function $65899b702fdd32b1$export$9d45b1b64b2cb8e1(message) {
    if (!message) return false;
    return message.indexOf($65899b702fdd32b1$var$DRAFT_PERMISSION_ERROR) > -1 || false;
}
module.exports["preloadDraft"] = $65899b702fdd32b1$export$dfd3c4c0aa957792;
module.exports["isDraftSSRPreloadPermissionError"] = $65899b702fdd32b1$export$9d45b1b64b2cb8e1;

});

parcelRegister("hNtOj", function(module, exports) {

var $etu7G = parcelRequire("etu7G");

const $120c25b1424bdefe$export$c82fe4eede9104df = new (0, $etu7G.SSRPermissionsErrorHandler)();
module.exports["ssrPermissionsErrorHandler"] = $120c25b1424bdefe$export$c82fe4eede9104df;

});

parcelRegister("etu7G", function(module, exports) {
class $c6d83b8df27b1c26$export$e70f491dc46ba2ed {
    markSSRPreloadPermissionError(route, error) {
        this.hasSSRPreloadPermissionsErrorForRoute = route;
        if (error) this.errorType = error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message?.key === 'confluence.content.restricted.inherited' ? 'inherited' : 'view';
    }
    getRestrictedRoute() {
        return this.hasSSRPreloadPermissionsErrorForRoute || window.__SSR_RESTRICTED_PAGE__?.route || null;
    }
    getErrorType() {
        return this.errorType || window.__SSR_RESTRICTED_PAGE__?.errorType || null;
    }
    constructor(){
        this.hasSSRPreloadPermissionsErrorForRoute = void 0;
        this.errorType = void 0;
        this.hasSSRPreloadPermissionsErrorForRoute = null;
        this.errorType = null;
    }
}
module.exports["SSRPermissionsErrorHandler"] = $c6d83b8df27b1c26$export$e70f491dc46ba2ed;

});

parcelRegister("27Dus", function(module, exports) {

var $eRwHS = parcelRequire("eRwHS");


var $6GQtz = parcelRequire("6GQtz");


var $aN0qB = parcelRequire("aN0qB");

function $010c1dfc98319256$export$1970baffe86d32af(docJsonString) {
    if (!docJsonString) return [];
    const doc = JSON.parse(docJsonString);
    const cardProvider = new (0, $6GQtz.ConfluenceEditorCardProvider)('custom');
    return (0, $eRwHS.findNodesToPrefetch)(doc, [
        {
            provider: cardProvider,
            maxNodesToPrefetch: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH).smartCard
        }
    ], (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_VISIT))[0].nodes;
}
module.exports["findSmartCardNodes"] = $010c1dfc98319256$export$1970baffe86d32af;

});

parcelRegister("eRwHS", function(module, exports) {
function $d135bda53bcecc47$export$41263783ff0932a8(doc, providers, maxNodesToVisit) {
    // Counter for the total number of visited nodes to limit the traversal.
    let totalVisitedNodesCount = 0;
    // A map to store the results, with the provider name as the key.
    const resultMap = providers.reduce((acc, { provider: provider })=>{
        acc[provider.name] = {
            provider: provider,
            nodes: []
        };
        return acc;
    }, {});
    // It doesn't use `filter` function from `@atlaskit/adf-utils/traverse` because it does not support early stopping.
    // We need to stop traversing when we reach the maximum number of nodes to visit to support large documents.
    // Create a list of providers for which we still need to find nodes.
    const providersToLookup = providers.filter(({ maxNodesToPrefetch: maxNodesToPrefetch })=>maxNodesToPrefetch > 0).map(({ provider: provider, maxNodesToPrefetch: maxNodesToPrefetch })=>({
            provider: provider,
            maxNodesToPrefetch: maxNodesToPrefetch,
            foundNodes: 0
        }));
    // Stack for the depth-first search (DFS), starting with the root document node.
    const nodesToVisit = [
        doc
    ];
    // The loop continues as long as there are nodes to visit, providers to look for,
    // and the visited nodes limit has not been reached.
    while(nodesToVisit.length > 0 && providersToLookup.length > 0 && totalVisitedNodesCount < maxNodesToVisit){
        totalVisitedNodesCount += 1;
        // Pop from the end to maintain DFS order (LIFO - Last In, First Out)
        const currentNode = nodesToVisit.pop();
        if (!currentNode) continue;
        // Using a reverse loop to avoid issues with array mutation (when removing elements).
        for(let i = providersToLookup.length - 1; i >= 0; i--){
            const providerToFind = providersToLookup[i];
            // Check if the current provider supports this node.
            if (providerToFind.provider.isNodeSupported(currentNode)) {
                // If provider supports the node, add it to the result map.
                resultMap[providerToFind.provider.name].nodes.push(currentNode);
                // Increment the count of found nodes for this provider.
                providerToFind.foundNodes += 1;
                // If the provider has found enough nodes, remove it from the lookup list.
                if (providerToFind.foundNodes >= providerToFind.maxNodesToPrefetch) providersToLookup.splice(i, 1);
            }
        }
        // If the current node has children, add them to the stack in reverse order
        // to maintain left-to-right traversal when popping from the stack,
        // because it's LIFO.
        if (currentNode.content) // Push children in reverse order to maintain correct DFS traversal order
        for(let i = currentNode.content.length - 1; i >= 0; i--){
            const node = currentNode.content[i];
            if (node) nodesToVisit.push(node);
        }
    }
    // Return an array of the found nodes, grouped by provider.
    return Object.values(resultMap);
}
module.exports["findNodesToPrefetch"] = $d135bda53bcecc47$export$41263783ff0932a8;

});

parcelRegister("aN0qB", function(module, exports) {
// Usually, one screen contains about 2_500 nodes, so 10_000 is more than enough.
const $e5ce665804adc727$export$d723a039341399fc = 10000;
const $e5ce665804adc727$export$109b6787e4cb0d4c = {
    smartCard: 10,
    emoji: 500
};
module.exports["NODE_DATA_PROVIDERS_MAX_NODES_TO_VISIT"] = $e5ce665804adc727$export$d723a039341399fc;
module.exports["NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH"] = $e5ce665804adc727$export$109b6787e4cb0d4c;

});

parcelRegister("hr9NW", function(module, exports) {

var $jC7Je = parcelRequire("jC7Je");


var $4iudd = parcelRequire("4iudd");


var $kwzZh = parcelRequire("kwzZh");


var $67keU = parcelRequire("67keU");


var $4yccB = parcelRequire("4yccB");


var $jXCXE = parcelRequire("jXCXE");


var $6RwwD = parcelRequire("6RwwD");


var $yuV6Z = parcelRequire("yuV6Z");


var $32x2E = parcelRequire("32x2E");


var $9WAeG = parcelRequire("9WAeG");


var $jQQYu = parcelRequire("jQQYu");


var $6GQtz = parcelRequire("6GQtz");


var $6mKj3 = parcelRequire("6mKj3");


var $dYU3e = parcelRequire("dYU3e");


var $xwvlW = parcelRequire("xwvlW");


var $60cDW = parcelRequire("60cDW");


var $aN0qB = parcelRequire("aN0qB");


var $kY8KV = parcelRequire("kY8KV");


var $6GukH = parcelRequire("6GukH");


var $985xA = parcelRequire("985xA");

const $8323d63e0ec880b7$var$MEASURE_SEGMENT = 'ssr-app/prepare/preloadQuery/editor/nodeDataProvidersData';
const $8323d63e0ec880b7$var$DEFAULT_TIMEOUT = 300;
const $8323d63e0ec880b7$var$EDITOR_CARD_PROVIDER_NAME = 'editorCardProvider';
const $8323d63e0ec880b7$var$EXTERNAL_CARD_PROVIDER_NAME = 'externalEditorCardProvider';
const $8323d63e0ec880b7$var$preloadEditorNodeDataProvidersDataQuery = (0, $jC7Je.default);
async function $8323d63e0ec880b7$export$82c96ba69b54d1e5(contentId, cloudId, isBlog) {
    if (!contentId) return;
    if (!(0, $4iudd.isSSR)()) // If we are not in SSR, we don't need to preload node data providers data.
    return;
    await (0, $9WAeG.SSRMeasures).run($8323d63e0ec880b7$var$MEASURE_SEGMENT, async ()=>{
        const fetchAdfStart = performance.now();
        const docJsonString = await $8323d63e0ec880b7$var$fetchAdf(contentId);
        const fetchAdfDuration = performance.now() - fetchAdfStart;
        if (!docJsonString) return;
        const doc = JSON.parse(docJsonString);
        // Validate that the parsed document is a valid JSONDocNode
        if (!(0, $985xA.isValidJSONDocNode)(doc)) return;
        const providers = [];
        let syncedBlocksPromise;
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        if ((0, $6mKj3.expVal)('platform_synced_block', 'isEnabled', false)) {
            if ((0, $jXCXE.isJSONDocNode)(doc)) syncedBlocksPromise = (0, $6GukH.preloadEditorSyncedBlocksData)(contentId, cloudId, isBlog, doc);
        }
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        if ((0, $6mKj3.expValEquals)('cc_editor_node_data_providers_preload_config', 'isEnabled', true) && (0, $6mKj3.expValEquals)('cc_editor_node_data_providers_preload_config', 'isSplittingEnabled', true)) {
            providers.push({
                provider: $8323d63e0ec880b7$export$ebf5846faf5beb2(),
                maxNodesToPrefetch: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH).smartCard
            });
            providers.push({
                provider: $8323d63e0ec880b7$export$21425f1d7e912e7a(),
                maxNodesToPrefetch: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH).smartCard
            });
        } else providers.push({
            provider: $8323d63e0ec880b7$var$ssrEditorCardProvider(),
            maxNodesToPrefetch: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH).smartCard
        });
        const emojiNodeDataProvider = await $8323d63e0ec880b7$var$ssrEmojiNodeDataProvider();
        if (emojiNodeDataProvider) providers.push({
            provider: emojiNodeDataProvider,
            maxNodesToPrefetch: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH).emoji
        });
        providers.forEach(({ provider: provider })=>{
            (0, $9WAeG.SSRMeasures).markMeasureStart($8323d63e0ec880b7$var$measureProviderSegment(provider.name));
        });
        let editorNodeDataProvidersData = await (0, $67keU.prefetchNodeDataProvidersData)({
            doc: doc,
            providers: providers,
            timeout: ((0, $6mKj3.expValEquals)('cc_editor_node_data_providers_preload_config', 'isEnabled', true) ? // eslint-disable-next-line confluence-feature-gating/inline-expVal-params
            (0, $6mKj3.expVal)('cc_editor_node_data_providers_preload_config', 'defaultTimeout', $8323d63e0ec880b7$var$DEFAULT_TIMEOUT) || $8323d63e0ec880b7$var$DEFAULT_TIMEOUT : $8323d63e0ec880b7$var$DEFAULT_TIMEOUT) - fetchAdfDuration,
            maxNodesToVisit: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_VISIT)
        });
        Object.entries(editorNodeDataProvidersData).forEach(([providerName, { duration: duration }])=>{
            (0, $9WAeG.SSRMeasures).setMeasureDuration($8323d63e0ec880b7$var$measureProviderSegment(providerName), duration);
        });
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        if ((0, $6mKj3.expValEquals)('cc_editor_node_data_providers_preload_config', 'isEnabled', true) && (0, $6mKj3.expValEquals)('cc_editor_node_data_providers_preload_config', 'isSplittingEnabled', true)) editorNodeDataProvidersData = $8323d63e0ec880b7$export$45312dbe9e8537fb(editorNodeDataProvidersData);
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expVal)('platform_synced_block', 'isEnabled', false)) {
            const nodeDataToStore = Object.fromEntries(Object.entries(editorNodeDataProvidersData).map(([providerName, { data: data }])=>[
                    providerName,
                    data
                ]));
            (0, $kY8KV.addToSSREditorNodeDataProvidersStore)(nodeDataToStore);
        } else window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] = Object.fromEntries(Object.entries(editorNodeDataProvidersData).map(([providerName, { data: data }])=>[
                providerName,
                data
            ]));
        // Ensure synced blocks data is fully resolved before returning
        if (syncedBlocksPromise) await syncedBlocksPromise;
    });
}
function $8323d63e0ec880b7$export$45312dbe9e8537fb(nodeDataProvidersSsrData, // will merge to the first provider in the list, which is `editorCardProvider` in our case, so it should be listed first in the array
keysOfProviderDataToMerge = [
    $8323d63e0ec880b7$var$EDITOR_CARD_PROVIDER_NAME,
    $8323d63e0ec880b7$var$EXTERNAL_CARD_PROVIDER_NAME
]) {
    if (keysOfProviderDataToMerge.length < 2) return nodeDataProvidersSsrData;
    const [mainProviderName, ...sourceKeys] = keysOfProviderDataToMerge;
    const result = {
        ...nodeDataProvidersSsrData
    };
    const processedSourceKeys = new Set();
    for (const sourceKey of sourceKeys){
        if (sourceKey === mainProviderName || processedSourceKeys.has(sourceKey)) continue;
        processedSourceKeys.add(sourceKey);
        const sourceData = result[sourceKey];
        if (sourceData) {
            result[mainProviderName] = result[mainProviderName] || {
                data: {},
                duration: 0,
                success: false
            };
            result[mainProviderName] = {
                data: {
                    ...result[mainProviderName].data,
                    ...sourceData.data
                },
                duration: Math.max(result[mainProviderName].duration, sourceData.duration),
                success: result[mainProviderName].success || sourceData.success
            };
            delete result[sourceKey];
        }
    }
    return result;
}
function $8323d63e0ec880b7$var$fetchAdf(contentId) {
    return (0, $9WAeG.SSRMeasures).run(`${$8323d63e0ec880b7$var$MEASURE_SEGMENT}/fetch:AdfDocQuery`, async ()=>{
        try {
            const result = await (0, $dYU3e.query)({
                query: $8323d63e0ec880b7$var$preloadEditorNodeDataProvidersDataQuery,
                variables: {
                    contentId: contentId,
                    status: [
                        'draft'
                    ]
                },
                fetchPolicy: 'network-only',
                __callerPackage__: "load-edit-page"
            });
            if (result.hasErrors) return undefined;
            return result.data?.singleContent?.body?.atlas_doc_format?.value || undefined;
        } catch  {
            return undefined;
        }
    });
}
async function $8323d63e0ec880b7$var$ssrEmojiNodeDataProvider() {
    const { userId: userId, cloudId: cloudId, isLicensed: isLicensed, isLoggedIn: isLoggedIn } = (0, $xwvlW.getPreloaderFnContext)();
    // We need a special emoji parameters that supports SSR load optimization here.
    const emojiResourceParams = (0, $yuV6Z.createEmojiProviderParameters)({
        cloudId: cloudId,
        userId: userId,
        isLicensed: isLicensed,
        isLoggedIn: isLoggedIn
    });
    return (0, $32x2E.getEmojiNodeDataProvider)((0, $kwzZh.default), {
        ...emojiResourceParams,
        allowAnonymousAccess: true
    });
}
function $8323d63e0ec880b7$var$ssrEditorCardProvider() {
    const { host: host, cloudId: cloudId, userContext: userContext, customURLs: customURLs } = (0, $60cDW.getSSRRenderInputs)();
    const objectResolverURL = customURLs?.['object-resolver-service']?.match(/^(https?:\/\/[^/]+)/)?.[0];
    const ssrCardClient = new (0, $4yccB.default)('custom', objectResolverURL);
    ssrCardClient.setHeaders({
        Cookie: (0, $jQQYu.createCookie)(userContext),
        Origin: host.startsWith('http') ? host : `https://${host}`,
        CloudId: cloudId
    });
    // No URL filter: accepts both internal and external URLs
    return new (0, $6GQtz.ConfluenceEditorCardProvider)('custom', objectResolverURL, undefined, ssrCardClient);
}
function $8323d63e0ec880b7$var$createSSREditorCardProvider(urlFilter, nameOverride) {
    const { host: host, cloudId: cloudId, userContext: userContext, customURLs: customURLs } = (0, $60cDW.getSSRRenderInputs)();
    // This URL will be something like `https://object-resolver.staging.atl-paas.net/resolve/batch`.
    // We need only protocol and host to pass it to the EditorCardProvider,
    // because path will be added by `CardClient`.
    const objectResolverURL = customURLs?.['object-resolver-service']?.match(/^(https?:\/\/[^/]+)/)?.[0];
    // We need to define a custom CardClient for SSR, because the default one works through public API gateway.
    const ssrCardClient = new (0, $4yccB.default)('custom', objectResolverURL);
    // Headers from `fetchORSForSSR` from confluence/next/packages/content-smartlinks/src/index.ts
    ssrCardClient.setHeaders({
        Cookie: (0, $jQQYu.createCookie)(userContext),
        Origin: host.startsWith('http') ? host : `https://${host}`,
        CloudId: cloudId
    });
    return new (0, $6GQtz.ConfluenceEditorCardProvider)('custom', objectResolverURL, undefined, ssrCardClient, urlFilter, nameOverride);
}
function $8323d63e0ec880b7$export$ebf5846faf5beb2() {
    return $8323d63e0ec880b7$var$createSSREditorCardProvider((0, $6RwwD.isInternalUrl));
}
function $8323d63e0ec880b7$export$21425f1d7e912e7a() {
    return $8323d63e0ec880b7$var$createSSREditorCardProvider((0, $6RwwD.isExternalUrl), $8323d63e0ec880b7$var$EXTERNAL_CARD_PROVIDER_NAME);
}
function $8323d63e0ec880b7$var$measureProviderSegment(providerName) {
    return `${$8323d63e0ec880b7$var$MEASURE_SEGMENT}/${providerName}`;
}
module.exports["preloadEditorNodeDataProvidersData"] = $8323d63e0ec880b7$export$82c96ba69b54d1e5;

});

parcelRegister("jC7Je", function(module, exports) {
/**
 * @generated SignedSource<<a5c664904afb7aa720df5692f74ea8df>>
 * @relayHash 72f0e11f3a3324a5c8d9d9a03df96df2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c6de5103060e3ef016dd939ce41c1ace25f1b934ec83c466b567b4f6ef2e2985
const $f23059387da63ee7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ContentBodyPerRepresentation",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentBody",
                            "kind": "LinkedField",
                            "name": "atlas_doc_format",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadEditorNodeDataProvidersDataQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadEditorNodeDataProvidersDataQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "72f0e11f3a3324a5c8d9d9a03df96df2",
            "id": "c6de5103060e3ef016dd939ce41c1ace25f1b934ec83c466b567b4f6ef2e2985",
            "metadata": {},
            "name": "preloadEditorNodeDataProvidersDataQuery",
            "operationKind": "query",
            "text": "query preloadEditorNodeDataProvidersDataQuery($contentId:ID,$status:[String]){singleContent(id:$contentId,status:$status){id,body{atlas_doc_format{value}}}}"
        }
    };
}();
$f23059387da63ee7$var$node.hash = "b082e4555a8e2adb34e1cfb641ee98a0";
var $f23059387da63ee7$export$2e2bcd8739ae039 = $f23059387da63ee7$var$node;
module.exports["default"] = $f23059387da63ee7$export$2e2bcd8739ae039;

});

parcelRegister("67keU", function(module, exports) {

var $eRwHS = parcelRequire("eRwHS");

async function $787da7bcf8e68b93$export$65217f7ac34c2278({ providers: providers, doc: doc, timeout: timeout, maxNodesToVisit: maxNodesToVisit = Infinity }) {
    if (timeout <= 0) // If the global timeout is 0 or negative, skip fetching entirely.
    return providers.reduce((acc, { provider: provider })=>{
        acc[provider.name] = {
            data: {},
            success: false,
            duration: 0
        };
        return acc;
    }, {});
    const providersWithDefaults = providers.map(({ provider: provider, maxNodesToPrefetch: maxNodesToPrefetch = Infinity, timeout: providerTimeout = Infinity })=>({
            provider: provider,
            maxNodesToPrefetch: maxNodesToPrefetch,
            // Use the minimum of the global timeout and the provider-specific timeout
            timeout: Math.min(providerTimeout, timeout)
        }));
    const providerTimeouts = providersWithDefaults.reduce((acc, { provider: provider, timeout: timeout })=>{
        acc[provider.name] = timeout;
        return acc;
    }, {});
    const nodesWithProviders = (0, $eRwHS.findNodesToPrefetch)(doc, providersWithDefaults, maxNodesToVisit).map(({ provider: provider, nodes: nodes })=>({
            provider: provider,
            nodes: nodes,
            timeout: providerTimeouts[provider.name]
        }));
    const promises = nodesWithProviders.map(async ({ nodes: nodes, provider: provider, timeout: timeout })=>{
        if (timeout <= 0) return {
            provider: provider,
            success: false,
            duration: 0,
            nodes: nodes,
            data: []
        };
        const start = performance.now();
        function getDurationFromStart() {
            return Math.min(performance.now() - start, timeout);
        }
        try {
            const timeoutPromise = new Promise((_, reject)=>{
                setTimeout(()=>{
                    reject();
                }, timeout);
            });
            const data = await Promise.race([
                provider.fetchNodesData(nodes),
                timeoutPromise
            ]);
            return {
                provider: provider,
                success: true,
                duration: getDurationFromStart(),
                nodes: nodes,
                data: data
            };
        } catch  {
            return {
                provider: provider,
                success: false,
                duration: getDurationFromStart(),
                nodes: nodes,
                data: []
            };
        }
    });
    const results = await Promise.all(promises);
    return results.reduce((acc, { provider: provider, success: success, duration: duration, nodes: nodes, data: data })=>{
        const ssrData = data.reduce((providerSsrData, nodeData, nodeIndex)=>{
            const node = nodes[nodeIndex];
            const nodeDataKey = provider.nodeDataKey(node);
            providerSsrData[nodeDataKey] = nodeData;
            return providerSsrData;
        }, {});
        acc[provider.name] = {
            data: ssrData,
            success: success,
            duration: duration
        };
        return acc;
    }, {});
}
module.exports["prefetchNodeDataProvidersData"] = $787da7bcf8e68b93$export$65217f7ac34c2278;

});

parcelRegister("jXCXE", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $3xuv0 = parcelRequire("3xuv0");

function $7859051df33e5c84$export$1c4065b3a9f04cf2(value) {
    if (!value || typeof value !== 'object') return false;
    const doc = value;
    // Check required properties
    if (doc.type !== 'doc') return false;
    if (!Array.isArray(doc.content)) return false;
    // Version is optional but if present should be a number
    if (doc.version !== undefined && typeof doc.version !== 'number') return false;
    return true;
}
module.exports["isJSONDocNode"] = $7859051df33e5c84$export$1c4065b3a9f04cf2;

});

parcelRegister("jQQYu", function(module, exports) {
// Creates a cookie for object-resolver header
const $64671b371f568ec9$export$7892c26d6c7a7447 = (userContext)=>{
    const cookieTarget = 'cloud.session.token';
    return `${cookieTarget}=${userContext}`;
};
module.exports["createCookie"] = $64671b371f568ec9$export$7892c26d6c7a7447;

});

parcelRegister("kY8KV", function(module, exports) {
/**
 * Adds data to the SSR editor node data providers store on the window object.
 * This allows multiple loaders to safely add data to the same object without
 * overwriting each other's data.
 *
 * @param data - The data to merge into the existing store
 */ function $5ae7655949a69969$export$a2bf498e230933ac(data) {
    const existingData = window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] || {};
    window['__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__'] = {
        ...existingData,
        ...data
    };
}
module.exports["addToSSREditorNodeDataProvidersStore"] = $5ae7655949a69969$export$a2bf498e230933ac;

});

parcelRegister("6GukH", function(module, exports) {

var $45MGZ = parcelRequire("45MGZ");

const $86855d2f29349b22$var$MEASURE_SEGMENT = 'ssr-app/prepare/preloadQuery/editor/syncedBlocksData';
async function $86855d2f29349b22$export$bd3ad760f826791(contentId, cloudId, isBlog, doc) {
    if (!contentId || !cloudId || typeof isBlog === 'undefined') return;
    return (0, $45MGZ.preloadSyncedBlocksData)({
        contentId: contentId,
        cloudId: cloudId,
        isBlog: isBlog,
        doc: doc,
        measureSegment: $86855d2f29349b22$var$MEASURE_SEGMENT
    });
}
module.exports["preloadEditorSyncedBlocksData"] = $86855d2f29349b22$export$bd3ad760f826791;

});

parcelRegister("45MGZ", function(module, exports) {

var $4iudd = parcelRequire("4iudd");


var $8Pm8w = parcelRequire("8Pm8w");


var $6oMcp = parcelRequire("6oMcp");


var $cuwGS = parcelRequire("cuwGS");


var $79ir6 = parcelRequire("79ir6");


var $gb05o = parcelRequire("gb05o");


var $9WAeG = parcelRequire("9WAeG");


var $1i2qc = parcelRequire("1i2qc");


var $6mKj3 = parcelRequire("6mKj3");


var $3mugH = parcelRequire("3mugH");


var $kY8KV = parcelRequire("kY8KV");


var $8AcAF = parcelRequire("8AcAF");


var $l9Wsf = parcelRequire("l9Wsf");

const $8435e015d85a0f69$var$MEASURE_SEGMENT = 'ssr-app/prepare/preloadQuery/syncedBlocksData';
// Timeout for fetching synced block references in milliseconds
// This is currently set to higher value to account for potential network latencys
// We will monitor performance and adjust this value as needed
const $8435e015d85a0f69$var$DEFAULT_TIMEOUT = 1500;
// New default timeout for batch fetch implementation, which includes more relistics value
const $8435e015d85a0f69$var$DEFAULT_TIMEOUT_NEXT = 500;
async function $8435e015d85a0f69$export$1de9b28b2fdef558(options) {
    const { contentId: contentId, cloudId: cloudId, isBlog: isBlog, doc: doc, measureSegment: measureSegment, timeout: timeout } = options;
    // Check feature flags before attempting to fetch synced block data
    if (!contentId || !cloudId || !doc || !(0, $4iudd.isSSR)() || typeof isBlog === 'undefined' || !(0, $6mKj3.expVal)('platform_synced_block', 'isEnabled', false)) {
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expVal)('platform_synced_block', 'isEnabled', false)) (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error('Skipped synced blocks preload: guard condition failed'), {
            isSsr: (0, $4iudd.isSSR)(),
            contentId: contentId,
            cloudId: cloudId,
            isBlog: isBlog
        });
        return;
    }
    const segmentName = measureSegment || $8435e015d85a0f69$var$MEASURE_SEGMENT;
    let blockNodeIdentifiers = [];
    // When FG is enabled, check for empty synced blocks BEFORE entering the measured run
    // so pages with no synced blocks don't record a metric for this segment
    blockNodeIdentifiers = (0, $l9Wsf.extractSyncBlockIdentifiers)(doc);
    if (blockNodeIdentifiers.length === 0) return;
    if (doc && (0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'isEnabled', false)) {
        blockNodeIdentifiers = (0, $l9Wsf.extractSyncBlockIdentifiers)(doc);
        // If no synced blocks found, return early
        if (blockNodeIdentifiers.length === 0) return;
    }
    await (0, $9WAeG.SSRMeasures).run(segmentName, async ()=>{
        // Use bulk load (batchFetchData) when doc is available
        if (doc) // Extract block identifiers from the ADF document
        {
            if (!(0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'isEnabled', false)) blockNodeIdentifiers = (0, $l9Wsf.extractSyncBlockIdentifiers)(doc);
        }
        const syncBlockReferences = await $8435e015d85a0f69$export$9523b76ee01ef6d(contentId, cloudId, isBlog, blockNodeIdentifiers, segmentName, timeout);
        if (!syncBlockReferences) {
            if (blockNodeIdentifiers.length > 0) (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Synced block fetch returned incomplete results: ${blockNodeIdentifiers.length} blocks missing`), {
                code: (0, $gb05o.SyncedBlocksSSRErrorCodeMap).FETCH_INCOMPLETE,
                contentId: contentId,
                cloudId: cloudId,
                isBlog: isBlog,
                identifiers: blockNodeIdentifiers,
                missingIdentifiers: blockNodeIdentifiers
            });
            return;
        }
        // check if results match the requested block identifiers, if not,
        // it means the fetch was likely incomplete/failed,
        if (syncBlockReferences.length !== blockNodeIdentifiers.length) {
            // Find which block identifiers are missing from the results
            const returnedIdentifiers = new Set(syncBlockReferences.map((ref)=>`${ref.resourceId}:${ref.data?.blockInstanceId ?? 'unknown'}`));
            const missingIdentifiers = blockNodeIdentifiers.filter((identifier)=>!returnedIdentifiers.has(`${identifier.resourceId}:${identifier.blockInstanceId}`));
            (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Synced block fetch returned incomplete results: ${missingIdentifiers.length} blocks missing`), {
                code: (0, $gb05o.SyncedBlocksSSRErrorCodeMap).FETCH_INCOMPLETE,
                contentId: contentId,
                cloudId: cloudId,
                isBlog: isBlog,
                identifiers: blockNodeIdentifiers,
                missingIdentifiers: missingIdentifiers
            });
        }
        (0, $kY8KV.addToSSREditorNodeDataProvidersStore)({
            syncBlocks: syncBlockReferences
        });
        const syncedBlocksWithMedia = syncBlockReferences.filter((syncBlock)=>{
            // Preload media data providers for synced blocks that contain media nodes
            const containedNodeTypes = (0, $8AcAF.syncBlockContainsNodes)(syncBlock, [
                'media'
            ]);
            return containedNodeTypes.length > 0 && containedNodeTypes.includes('media');
        });
        const tasks = [];
        syncedBlocksWithMedia.forEach((syncBlockInstance)=>{
            tasks.push($8435e015d85a0f69$export$6df3cdf918cdf771(syncBlockInstance));
        });
        await Promise.allSettled(tasks);
    });
}
async function $8435e015d85a0f69$export$6df3cdf918cdf771(syncBlock) {
    if (!syncBlock) return null;
    const { product: product, contentId: contentId } = (0, $cuwGS.parseResourceId)(syncBlock.resourceId) || {};
    if (!product) return {
        resourceId: syncBlock.resourceId,
        result: undefined
    };
    if (product === 'confluence-page') {
        if (!contentId) return {
            resourceId: syncBlock.resourceId,
            result: undefined
        };
        const result = await (0, $1i2qc.preloadMediaToken)(contentId);
        return {
            resourceId: syncBlock.resourceId,
            result: result
        };
    }
    if (product === 'jira-work-item') {
        const jiraIssueAri = syncBlock.data?.sourceAri;
        if (!jiraIssueAri) return {
            resourceId: syncBlock.resourceId,
            result: undefined
        };
        const result = await (0, $1i2qc.preloadJiraMediaToken)(jiraIssueAri);
        return {
            resourceId: syncBlock.resourceId,
            result: result
        };
    }
    return null;
}
function $8435e015d85a0f69$export$9523b76ee01ef6d(contentId, cloudId, isBlog, blockNodeIdentifiers, measureSegment = $8435e015d85a0f69$var$MEASURE_SEGMENT, timeout = (0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'isEnabled', false) ? $8435e015d85a0f69$var$DEFAULT_TIMEOUT_NEXT : $8435e015d85a0f69$var$DEFAULT_TIMEOUT) {
    return (0, $9WAeG.SSRMeasures).run(`${measureSegment}/fetch:SyncBlockReferences`, async ()=>{
        const pageAri = (0, $6oMcp.getConfluencePageAri)({
            cloudId: cloudId,
            pageId: contentId,
            pageType: isBlog ? 'blogpost' : 'page'
        });
        const timeoutError = new Error('timeout');
        let batchFetchDataConfig = undefined;
        if ((0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'isEnabled', false)) batchFetchDataConfig = {
            timeoutMs: (0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'timeout', null) ?? timeout,
            isSSR: (0, $4iudd.isSSR)(),
            maxBatchSize: (0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'maxBatchSize', null) ?? undefined
        };
        try {
            let results;
            if ((0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'isEnabled', false)) // We only passing the batchFetchDataConfig when the experiment is enabled,
            // however, batchFetchData is NOT gateed.
            results = await (0, $8Pm8w.batchFetchData)(cloudId, pageAri, blockNodeIdentifiers, batchFetchDataConfig);
            else results = await Promise.race([
                (0, $8Pm8w.batchFetchData)(cloudId, pageAri, blockNodeIdentifiers),
                new Promise((_resolve, reject)=>setTimeout(()=>{
                        reject(timeoutError);
                    }, timeout))
            ]);
            if (!results) {
                // No results returned - this could indicate a failure in the batch fetch operation
                // this would not be timeout, as it will throw a timeout error instead,
                // so we can attribute this to a fetch failure and log accordingly
                (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error('Synced blocks fetch returned no results'), {
                    code: (0, $gb05o.SyncedBlocksSSRErrorCodeMap).BATCH_FETCH_FAILED,
                    contentId: contentId,
                    cloudId: cloudId,
                    isBlog: isBlog,
                    identifiers: blockNodeIdentifiers
                });
                return undefined;
            }
            // check if result is timeout error
            if (Array.isArray(results) && results.length > 0 && (0, $4iudd.isSSR)() && // we only want to apply this logic for SSR, as in client side we can allow for retries and better error handling.
            (0, $6mKj3.expVal)('platform_editor_sync_block_ssr_config', 'isEnabled', false)) {
                const isTimeout = results.some((result)=>(0, $79ir6.SyncBlockError).Aborted === result.error?.type);
                if (isTimeout) {
                    // This means the batch fetch operation timed out
                    (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error('Synced blocks fetch operation timed out'), {
                        code: (0, $gb05o.SyncedBlocksSSRErrorCodeMap).FETCH_TIMEOUT,
                        contentId: contentId,
                        cloudId: cloudId,
                        isBlog: isBlog,
                        identifiers: blockNodeIdentifiers
                    });
                    // we don't want to return timeout results,
                    // as it might cause error on the initial page load.
                    return undefined;
                }
            }
            return results;
        } catch (error) {
            // Network or API error
            const errorMessage = error instanceof Error ? error.message : String(error);
            const errorName = error instanceof Error ? error.name : undefined;
            (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Batch fetch for synced blocks failed: unable to fetch ${blockNodeIdentifiers.length} blocks`), {
                code: (0, $gb05o.SyncedBlocksSSRErrorCodeMap).BATCH_FETCH_FAILED,
                contentId: contentId,
                cloudId: cloudId,
                isBlog: isBlog,
                identifiers: blockNodeIdentifiers,
                errorMessage: errorMessage,
                errorName: errorName
            });
            return undefined;
        }
    });
}
module.exports["preloadSyncedBlocksData"] = $8435e015d85a0f69$export$1de9b28b2fdef558;

});

parcelRegister("gb05o", function(module, exports) {
/**
 * Error codes for synced blocks preloading
 * Used for tracking and monitoring errors during SSR preload phase
 */ const $dcd4a25c1def153c$export$f10410d219e3ec29 = {
    /**
   * Occurs when the fetch operation returns fewer results than requested.
   * This indicates incomplete data retrieval or potential data loss.
   * Included in error: list of missing block identifiers
   */ FETCH_INCOMPLETE: 'SYNCED_BLOCKS_FETCH_INCOMPLETE',
    /**
   * Occurs when the batch fetch operation throws an error during execution.
   * This indicates a network error, timeout, or API failure.
   * Included in error: resource IDs that failed to fetch
   */ BATCH_FETCH_FAILED: 'SYNCED_BLOCKS_BATCH_FETCH_FAILED',
    /**
   * Occurs when the fetch operation times out without returning results.
   * This is specific to the bulk fetch operation with a configurable timeout.
   */ FETCH_TIMEOUT: 'SYNCED_BLOCKS_FETCH_TIMEOUT'
};
module.exports["SyncedBlocksSSRErrorCodeMap"] = $dcd4a25c1def153c$export$f10410d219e3ec29;

});

parcelRegister("8AcAF", function(module, exports) {
function $239408713401734d$export$25570414f819b6df(syncBlock, nodeTypes) {
    if (!syncBlock?.data?.content) return [];
    if (nodeTypes.length === 0) return [];
    const nodeTypesSet = new Set(nodeTypes);
    const foundTypes = new Set();
    const content = syncBlock.data.content;
    const checkNode = (node)=>{
        if (!node || typeof node !== 'object') return false;
        // Check if this node matches one of the requested types
        if (typeof node.type === 'string' && nodeTypesSet.has(node.type) && !foundTypes.has(node.type)) {
            // node type found, add to found set and remove from search set
            foundTypes.add(node.type);
            nodeTypesSet.delete(node.type);
            // If all types have been found, we can stop searching
            if (nodeTypesSet.size === 0) return true;
        }
        // Recursively check all child content
        if (Array.isArray(node.content)) // Return true to stop searching if all types have been found in children
        return node.content.some(checkNode);
        return false;
    };
    content.some(checkNode);
    return Array.from(foundTypes);
}
module.exports["syncBlockContainsNodes"] = $239408713401734d$export$25570414f819b6df;

});

parcelRegister("l9Wsf", function(module, exports) {
const $7267ec4c0ff40ba5$var$isSyncBlockNode = (node)=>{
    return node.type === 'syncBlock' && typeof node.attrs === 'object' && node.attrs !== null && 'resourceId' in node.attrs && 'localId' in node.attrs && typeof node.attrs.resourceId === 'string' && typeof node.attrs.localId === 'string';
};
function $7267ec4c0ff40ba5$export$7895de99cf1d8719(doc) {
    const content = doc.content || [];
    return content.reduce((acc, node)=>{
        if ($7267ec4c0ff40ba5$var$isSyncBlockNode(node)) acc.push({
            resourceId: node.attrs.resourceId,
            blockInstanceId: node.attrs.localId
        });
        return acc;
    }, []);
}
module.exports["extractSyncBlockIdentifiers"] = $7267ec4c0ff40ba5$export$7895de99cf1d8719;

});

parcelRegister("985xA", function(module, exports) {
function $4a85fd13a342ae42$export$e3ccb083fef98320(value) {
    if (!value || typeof value !== 'object') return false;
    const doc = value;
    // Check required properties
    if (doc.type !== 'doc') return false;
    if (!Array.isArray(doc.content)) return false;
    // Version is optional but if present should be a number
    if (doc.version !== undefined && typeof doc.version !== 'number') return false;
    return true;
}
module.exports["isValidJSONDocNode"] = $4a85fd13a342ae42$export$e3ccb083fef98320;

});

parcelRegister("eVK28", function(module, exports) {

var $1P2f3 = parcelRequire("1P2f3");



/**
 * [js-sha256]{@link https://github.com/emn178/js-sha256}
 *
 * @version 0.10.1
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2023
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    'use strict';
    var ERROR = 'input is invalid type';
    var WINDOW = typeof window === 'object';
    var root = WINDOW ? window : {};
    if (root.JS_SHA256_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === 'object';
    var NODE_JS = !root.JS_SHA256_NO_NODE_JS && typeof $1P2f3 === 'object' && $1P2f3.versions && $1P2f3.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === 'function' && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
    var HEX_CHARS = '0123456789abcdef'.split('');
    var EXTRA = [
        -2147483648,
        8388608,
        32768,
        128
    ];
    var SHIFT = [
        24,
        16,
        8,
        0
    ];
    var K = [
        0x428a2f98,
        0x71374491,
        0xb5c0fbcf,
        0xe9b5dba5,
        0x3956c25b,
        0x59f111f1,
        0x923f82a4,
        0xab1c5ed5,
        0xd807aa98,
        0x12835b01,
        0x243185be,
        0x550c7dc3,
        0x72be5d74,
        0x80deb1fe,
        0x9bdc06a7,
        0xc19bf174,
        0xe49b69c1,
        0xefbe4786,
        0x0fc19dc6,
        0x240ca1cc,
        0x2de92c6f,
        0x4a7484aa,
        0x5cb0a9dc,
        0x76f988da,
        0x983e5152,
        0xa831c66d,
        0xb00327c8,
        0xbf597fc7,
        0xc6e00bf3,
        0xd5a79147,
        0x06ca6351,
        0x14292967,
        0x27b70a85,
        0x2e1b2138,
        0x4d2c6dfc,
        0x53380d13,
        0x650a7354,
        0x766a0abb,
        0x81c2c92e,
        0x92722c85,
        0xa2bfe8a1,
        0xa81a664b,
        0xc24b8b70,
        0xc76c51a3,
        0xd192e819,
        0xd6990624,
        0xf40e3585,
        0x106aa070,
        0x19a4c116,
        0x1e376c08,
        0x2748774c,
        0x34b0bcb5,
        0x391c0cb3,
        0x4ed8aa4a,
        0x5b9cca4f,
        0x682e6ff3,
        0x748f82ee,
        0x78a5636f,
        0x84c87814,
        0x8cc70208,
        0x90befffa,
        0xa4506ceb,
        0xbef9a3f7,
        0xc67178f2
    ];
    var OUTPUT_TYPES = [
        'hex',
        'array',
        'digest',
        'arrayBuffer'
    ];
    var blocks = [];
    if (root.JS_SHA256_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    if (ARRAY_BUFFER && (root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(outputType, is224) {
        return function(message) {
            return new Sha256(is224, true).update(message)[outputType]();
        };
    };
    var createMethod = function(is224) {
        var method = createOutputMethod('hex', is224);
        if (NODE_JS) method = nodeWrap(method, is224);
        method.create = function() {
            return new Sha256(is224);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createOutputMethod(type, is224);
        }
        return method;
    };
    var nodeWrap = function(method, is224) {
        var crypto = (parcelRequire("bH2ds"));
        var Buffer = (parcelRequire("bH2ds")).Buffer;
        var algorithm = is224 ? 'sha224' : 'sha256';
        var bufferFrom;
        if (Buffer.from && !root.JS_SHA256_NO_BUFFER_FROM) bufferFrom = Buffer.from;
        else bufferFrom = function(message) {
            return new Buffer(message);
        };
        var nodeMethod = function(message) {
            if (typeof message === 'string') return crypto.createHash(algorithm).update(message, 'utf8').digest('hex');
            else {
                if (message === null || message === undefined) throw new Error(ERROR);
                else if (message.constructor === ArrayBuffer) message = new Uint8Array(message);
            }
            if (Array.isArray(message) || ArrayBuffer.isView(message) || message.constructor === Buffer) return crypto.createHash(algorithm).update(bufferFrom(message)).digest('hex');
            else return method(message);
        };
        return nodeMethod;
    };
    var createHmacOutputMethod = function(outputType, is224) {
        return function(key, message) {
            return new HmacSha256(key, is224, true).update(message)[outputType]();
        };
    };
    var createHmacMethod = function(is224) {
        var method = createHmacOutputMethod('hex', is224);
        method.create = function(key) {
            return new HmacSha256(key, is224);
        };
        method.update = function(key, message) {
            return method.create(key).update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createHmacOutputMethod(type, is224);
        }
        return method;
    };
    function Sha256(is224, sharedMemory) {
        if (sharedMemory) {
            blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            this.blocks = blocks;
        } else this.blocks = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        if (is224) {
            this.h0 = 0xc1059ed8;
            this.h1 = 0x367cd507;
            this.h2 = 0x3070dd17;
            this.h3 = 0xf70e5939;
            this.h4 = 0xffc00b31;
            this.h5 = 0x68581511;
            this.h6 = 0x64f98fa7;
            this.h7 = 0xbefa4fa4;
        } else {
            this.h0 = 0x6a09e667;
            this.h1 = 0xbb67ae85;
            this.h2 = 0x3c6ef372;
            this.h3 = 0xa54ff53a;
            this.h4 = 0x510e527f;
            this.h5 = 0x9b05688c;
            this.h6 = 0x1f83d9ab;
            this.h7 = 0x5be0cd19;
        }
        this.block = this.start = this.bytes = this.hBytes = 0;
        this.finalized = this.hashed = false;
        this.first = true;
        this.is224 = is224;
    }
    Sha256.prototype.update = function(message) {
        if (this.finalized) return;
        var notString, type = typeof message;
        if (type !== 'string') {
            if (type === 'object') {
                if (message === null) throw new Error(ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(ERROR);
                }
            } else throw new Error(ERROR);
            notString = true;
        }
        var code, index = 0, i, length = message.length, blocks = this.blocks;
        while(index < length){
            if (this.hashed) {
                this.hashed = false;
                blocks[0] = this.block;
                blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            }
            if (notString) for(i = this.start; index < length && i < 64; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < 64; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            this.bytes += i - this.start;
            if (i >= 64) {
                this.block = blocks[16];
                this.start = i - 64;
                this.hash();
                this.hashed = true;
            } else this.start = i;
        }
        if (this.bytes > 4294967295) {
            this.hBytes += this.bytes / 4294967296 << 0;
            this.bytes = this.bytes % 4294967296;
        }
        return this;
    };
    Sha256.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex;
        blocks[16] = this.block;
        blocks[i >> 2] |= EXTRA[i & 3];
        this.block = blocks[16];
        if (i >= 56) {
            if (!this.hashed) this.hash();
            blocks[0] = this.block;
            blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
        }
        blocks[14] = this.hBytes << 3 | this.bytes >>> 29;
        blocks[15] = this.bytes << 3;
        this.hash();
    };
    Sha256.prototype.hash = function() {
        var a = this.h0, b = this.h1, c = this.h2, d = this.h3, e = this.h4, f = this.h5, g = this.h6, h = this.h7, blocks = this.blocks, j, s0, s1, maj, t1, t2, ch, ab, da, cd, bc;
        for(j = 16; j < 64; ++j){
            // rightrotate
            t1 = blocks[j - 15];
            s0 = (t1 >>> 7 | t1 << 25) ^ (t1 >>> 18 | t1 << 14) ^ t1 >>> 3;
            t1 = blocks[j - 2];
            s1 = (t1 >>> 17 | t1 << 15) ^ (t1 >>> 19 | t1 << 13) ^ t1 >>> 10;
            blocks[j] = blocks[j - 16] + s0 + blocks[j - 7] + s1 << 0;
        }
        bc = b & c;
        for(j = 0; j < 64; j += 4){
            if (this.first) {
                if (this.is224) {
                    ab = 300032;
                    t1 = blocks[0] - 1413257819;
                    h = t1 - 150054599 << 0;
                    d = t1 + 24177077 << 0;
                } else {
                    ab = 704751109;
                    t1 = blocks[0] - 210244248;
                    h = t1 - 1521486534 << 0;
                    d = t1 + 143694565 << 0;
                }
                this.first = false;
            } else {
                s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
                s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
                ab = a & b;
                maj = ab ^ a & c ^ bc;
                ch = e & f ^ ~e & g;
                t1 = h + s1 + ch + K[j] + blocks[j];
                t2 = s0 + maj;
                h = d + t1 << 0;
                d = t1 + t2 << 0;
            }
            s0 = (d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10);
            s1 = (h >>> 6 | h << 26) ^ (h >>> 11 | h << 21) ^ (h >>> 25 | h << 7);
            da = d & a;
            maj = da ^ d & b ^ ab;
            ch = h & e ^ ~h & f;
            t1 = g + s1 + ch + K[j + 1] + blocks[j + 1];
            t2 = s0 + maj;
            g = c + t1 << 0;
            c = t1 + t2 << 0;
            s0 = (c >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10);
            s1 = (g >>> 6 | g << 26) ^ (g >>> 11 | g << 21) ^ (g >>> 25 | g << 7);
            cd = c & d;
            maj = cd ^ c & a ^ da;
            ch = g & h ^ ~g & e;
            t1 = f + s1 + ch + K[j + 2] + blocks[j + 2];
            t2 = s0 + maj;
            f = b + t1 << 0;
            b = t1 + t2 << 0;
            s0 = (b >>> 2 | b << 30) ^ (b >>> 13 | b << 19) ^ (b >>> 22 | b << 10);
            s1 = (f >>> 6 | f << 26) ^ (f >>> 11 | f << 21) ^ (f >>> 25 | f << 7);
            bc = b & c;
            maj = bc ^ b & d ^ cd;
            ch = f & g ^ ~f & h;
            t1 = e + s1 + ch + K[j + 3] + blocks[j + 3];
            t2 = s0 + maj;
            e = a + t1 << 0;
            a = t1 + t2 << 0;
            this.chromeBugWorkAround = true;
        }
        this.h0 = this.h0 + a << 0;
        this.h1 = this.h1 + b << 0;
        this.h2 = this.h2 + c << 0;
        this.h3 = this.h3 + d << 0;
        this.h4 = this.h4 + e << 0;
        this.h5 = this.h5 + f << 0;
        this.h6 = this.h6 + g << 0;
        this.h7 = this.h7 + h << 0;
    };
    Sha256.prototype.hex = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
        var hex = HEX_CHARS[h0 >> 28 & 0x0F] + HEX_CHARS[h0 >> 24 & 0x0F] + HEX_CHARS[h0 >> 20 & 0x0F] + HEX_CHARS[h0 >> 16 & 0x0F] + HEX_CHARS[h0 >> 12 & 0x0F] + HEX_CHARS[h0 >> 8 & 0x0F] + HEX_CHARS[h0 >> 4 & 0x0F] + HEX_CHARS[h0 & 0x0F] + HEX_CHARS[h1 >> 28 & 0x0F] + HEX_CHARS[h1 >> 24 & 0x0F] + HEX_CHARS[h1 >> 20 & 0x0F] + HEX_CHARS[h1 >> 16 & 0x0F] + HEX_CHARS[h1 >> 12 & 0x0F] + HEX_CHARS[h1 >> 8 & 0x0F] + HEX_CHARS[h1 >> 4 & 0x0F] + HEX_CHARS[h1 & 0x0F] + HEX_CHARS[h2 >> 28 & 0x0F] + HEX_CHARS[h2 >> 24 & 0x0F] + HEX_CHARS[h2 >> 20 & 0x0F] + HEX_CHARS[h2 >> 16 & 0x0F] + HEX_CHARS[h2 >> 12 & 0x0F] + HEX_CHARS[h2 >> 8 & 0x0F] + HEX_CHARS[h2 >> 4 & 0x0F] + HEX_CHARS[h2 & 0x0F] + HEX_CHARS[h3 >> 28 & 0x0F] + HEX_CHARS[h3 >> 24 & 0x0F] + HEX_CHARS[h3 >> 20 & 0x0F] + HEX_CHARS[h3 >> 16 & 0x0F] + HEX_CHARS[h3 >> 12 & 0x0F] + HEX_CHARS[h3 >> 8 & 0x0F] + HEX_CHARS[h3 >> 4 & 0x0F] + HEX_CHARS[h3 & 0x0F] + HEX_CHARS[h4 >> 28 & 0x0F] + HEX_CHARS[h4 >> 24 & 0x0F] + HEX_CHARS[h4 >> 20 & 0x0F] + HEX_CHARS[h4 >> 16 & 0x0F] + HEX_CHARS[h4 >> 12 & 0x0F] + HEX_CHARS[h4 >> 8 & 0x0F] + HEX_CHARS[h4 >> 4 & 0x0F] + HEX_CHARS[h4 & 0x0F] + HEX_CHARS[h5 >> 28 & 0x0F] + HEX_CHARS[h5 >> 24 & 0x0F] + HEX_CHARS[h5 >> 20 & 0x0F] + HEX_CHARS[h5 >> 16 & 0x0F] + HEX_CHARS[h5 >> 12 & 0x0F] + HEX_CHARS[h5 >> 8 & 0x0F] + HEX_CHARS[h5 >> 4 & 0x0F] + HEX_CHARS[h5 & 0x0F] + HEX_CHARS[h6 >> 28 & 0x0F] + HEX_CHARS[h6 >> 24 & 0x0F] + HEX_CHARS[h6 >> 20 & 0x0F] + HEX_CHARS[h6 >> 16 & 0x0F] + HEX_CHARS[h6 >> 12 & 0x0F] + HEX_CHARS[h6 >> 8 & 0x0F] + HEX_CHARS[h6 >> 4 & 0x0F] + HEX_CHARS[h6 & 0x0F];
        if (!this.is224) hex += HEX_CHARS[h7 >> 28 & 0x0F] + HEX_CHARS[h7 >> 24 & 0x0F] + HEX_CHARS[h7 >> 20 & 0x0F] + HEX_CHARS[h7 >> 16 & 0x0F] + HEX_CHARS[h7 >> 12 & 0x0F] + HEX_CHARS[h7 >> 8 & 0x0F] + HEX_CHARS[h7 >> 4 & 0x0F] + HEX_CHARS[h7 & 0x0F];
        return hex;
    };
    Sha256.prototype.toString = Sha256.prototype.hex;
    Sha256.prototype.digest = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
        var arr = [
            h0 >> 24 & 0xFF,
            h0 >> 16 & 0xFF,
            h0 >> 8 & 0xFF,
            h0 & 0xFF,
            h1 >> 24 & 0xFF,
            h1 >> 16 & 0xFF,
            h1 >> 8 & 0xFF,
            h1 & 0xFF,
            h2 >> 24 & 0xFF,
            h2 >> 16 & 0xFF,
            h2 >> 8 & 0xFF,
            h2 & 0xFF,
            h3 >> 24 & 0xFF,
            h3 >> 16 & 0xFF,
            h3 >> 8 & 0xFF,
            h3 & 0xFF,
            h4 >> 24 & 0xFF,
            h4 >> 16 & 0xFF,
            h4 >> 8 & 0xFF,
            h4 & 0xFF,
            h5 >> 24 & 0xFF,
            h5 >> 16 & 0xFF,
            h5 >> 8 & 0xFF,
            h5 & 0xFF,
            h6 >> 24 & 0xFF,
            h6 >> 16 & 0xFF,
            h6 >> 8 & 0xFF,
            h6 & 0xFF
        ];
        if (!this.is224) arr.push(h7 >> 24 & 0xFF, h7 >> 16 & 0xFF, h7 >> 8 & 0xFF, h7 & 0xFF);
        return arr;
    };
    Sha256.prototype.array = Sha256.prototype.digest;
    Sha256.prototype.arrayBuffer = function() {
        this.finalize();
        var buffer = new ArrayBuffer(this.is224 ? 28 : 32);
        var dataView = new DataView(buffer);
        dataView.setUint32(0, this.h0);
        dataView.setUint32(4, this.h1);
        dataView.setUint32(8, this.h2);
        dataView.setUint32(12, this.h3);
        dataView.setUint32(16, this.h4);
        dataView.setUint32(20, this.h5);
        dataView.setUint32(24, this.h6);
        if (!this.is224) dataView.setUint32(28, this.h7);
        return buffer;
    };
    function HmacSha256(key, is224, sharedMemory) {
        var i, type = typeof key;
        if (type === 'string') {
            var bytes = [], length = key.length, index = 0, code;
            for(i = 0; i < length; ++i){
                code = key.charCodeAt(i);
                if (code < 0x80) bytes[index++] = code;
                else if (code < 0x800) {
                    bytes[index++] = 0xc0 | code >> 6;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else if (code < 0xd800 || code >= 0xe000) {
                    bytes[index++] = 0xe0 | code >> 12;
                    bytes[index++] = 0x80 | code >> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | key.charCodeAt(++i) & 0x3ff);
                    bytes[index++] = 0xf0 | code >> 18;
                    bytes[index++] = 0x80 | code >> 12 & 0x3f;
                    bytes[index++] = 0x80 | code >> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                }
            }
            key = bytes;
        } else {
            if (type === 'object') {
                if (key === null) throw new Error(ERROR);
                else if (ARRAY_BUFFER && key.constructor === ArrayBuffer) key = new Uint8Array(key);
                else if (!Array.isArray(key)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(key)) throw new Error(ERROR);
                }
            } else throw new Error(ERROR);
        }
        if (key.length > 64) key = new Sha256(is224, true).update(key).array();
        var oKeyPad = [], iKeyPad = [];
        for(i = 0; i < 64; ++i){
            var b = key[i] || 0;
            oKeyPad[i] = 0x5c ^ b;
            iKeyPad[i] = 0x36 ^ b;
        }
        Sha256.call(this, is224, sharedMemory);
        this.update(iKeyPad);
        this.oKeyPad = oKeyPad;
        this.inner = true;
        this.sharedMemory = sharedMemory;
    }
    HmacSha256.prototype = new Sha256();
    HmacSha256.prototype.finalize = function() {
        Sha256.prototype.finalize.call(this);
        if (this.inner) {
            this.inner = false;
            var innerHash = this.array();
            Sha256.call(this, this.is224, this.sharedMemory);
            this.update(this.oKeyPad);
            this.update(innerHash);
            Sha256.prototype.finalize.call(this);
        }
    };
    var exports = createMethod();
    exports.sha256 = exports;
    exports.sha224 = createMethod(true);
    exports.sha256.hmac = createHmacMethod();
    exports.sha224.hmac = createHmacMethod(true);
    if (COMMON_JS) module.exports = exports;
    else {
        root.sha256 = exports.sha256;
        root.sha224 = exports.sha224;
        if (AMD) define(function() {
            return exports;
        });
    }
})();

});

parcelRegister("8wyJO", function(module, exports) {

var $ibGN4 = parcelRequire("ibGN4");


var $3V1KT = parcelRequire("3V1KT");

const $01eec1a417789222$export$17ab88ef0193bb4 = (data)=>{
    if (!data) return data;
    if ($01eec1a417789222$var$isConfluenceContentReactions(data)) return data?.confluence_contentReactionsSummary?.contentReactionsSummary?.[0];
    if ($01eec1a417789222$var$isContentReactions(data)) return data?.content?.nodes?.[0]?.contentReactionsSummary;
    if ($01eec1a417789222$var$isCommentReactions(data)) return data?.comments?.nodes?.[0]?.reactionsSummary;
};
const $01eec1a417789222$var$isConfluenceContentReactions = (data)=>Boolean(data.confluence_contentReactionsSummary);
const $01eec1a417789222$var$isContentReactions = (data)=>Boolean(data.content);
const $01eec1a417789222$var$isCommentReactions = (data)=>Boolean(data.comments);
const $01eec1a417789222$var$getReactionsContentQuery = ()=>{
    return 0, $3V1KT.ReactionsContentQuery;
};
const $01eec1a417789222$export$d765e1092b1f36ff = (isComment, contentId, containerId)=>{
    const query = isComment ? (0, $ibGN4.ReactionsCommentsQuery) : $01eec1a417789222$var$getReactionsContentQuery();
    const queryVariables = isComment ? {
        contentId: contentId,
        containerId: containerId
    } : {
        contentId: contentId
    };
    return {
        query: query,
        queryVariables: queryVariables
    };
};
module.exports["getReactionsSummary"] = $01eec1a417789222$export$17ab88ef0193bb4;
module.exports["getReactionsQueryInfo"] = $01eec1a417789222$export$d765e1092b1f36ff;

});

parcelRegister("ibGN4", function(module, exports) {

var $bcPqk = parcelRequire("bcPqk");

const $0c4d3fd1a40dc0de$export$c0002d0cc70e364a = (0, $bcPqk.default);
module.exports["ReactionsCommentsQuery"] = $0c4d3fd1a40dc0de$export$c0002d0cc70e364a;

});

parcelRegister("bcPqk", function(module, exports) {
/**
 * @generated SignedSource<<0d565de88cf0b0b5b63d9eb6adb77c13>>
 * @relayHash cbefab13307a82cf7144a0c0749ceeba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 856749e0bcac9514035b3ed1c7488b61824433724d4eda1d05cbcff973b7dcce
const $6247a0815b189874$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "contentStatus",
                    "value": [
                        "DRAFT",
                        "CURRENT"
                    ]
                }
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "childType",
                                    "value": "comment"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "contentType",
                                    "value": "page"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "pageId",
                                    "variableName": "containerId"
                                }
                            ],
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "reactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "reactionsCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "ari"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "containerAri"
                                },
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "emojiId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "reacted"
                                        },
                                        v2 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ReactionsCommentsQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ReactionsCommentsQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "cbefab13307a82cf7144a0c0749ceeba",
            "id": "856749e0bcac9514035b3ed1c7488b61824433724d4eda1d05cbcff973b7dcce",
            "metadata": {},
            "name": "ReactionsCommentsQuery",
            "operationKind": "query",
            "text": "query ReactionsCommentsQuery($contentId:ID!,$containerId:ID!){comments(commentId:$contentId,contentStatus:[DRAFT,CURRENT]){nodes{id,reactionsSummary(pageId:$containerId,contentType:\"page\",childType:\"comment\"){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}}}"
        }
    };
}();
$6247a0815b189874$var$node.hash = "0b21ca1826000dc79e07e5aee0fcca18";
var $6247a0815b189874$export$2e2bcd8739ae039 = $6247a0815b189874$var$node;
module.exports["default"] = $6247a0815b189874$export$2e2bcd8739ae039;

});

parcelRegister("3V1KT", function(module, exports) {

var $71jDq = parcelRequire("71jDq");

const $bb6fcff23ee99252$export$d1ed7f06ad741aec = (0, $71jDq.default);
module.exports["ReactionsContentQuery"] = $bb6fcff23ee99252$export$d1ed7f06ad741aec;

});

parcelRegister("71jDq", function(module, exports) {
/**
 * @generated SignedSource<<24da7f14ba8749c8630d2573f19b3159>>
 * @relayHash f5d80e75401b9c7d3d224f964fef6438
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1233c9b22c359c5d8cbed7e4b61033fe5b764797cdcb71dc0673a7aa5eed93f4
const $380a75471f8fd0e5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "contentReactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "reactionsCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "ari"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "containerAri"
                                },
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "emojiId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "reacted"
                                        },
                                        v1 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ReactionsContentQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ReactionsContentQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "f5d80e75401b9c7d3d224f964fef6438",
            "id": "1233c9b22c359c5d8cbed7e4b61033fe5b764797cdcb71dc0673a7aa5eed93f4",
            "metadata": {},
            "name": "ReactionsContentQuery",
            "operationKind": "query",
            "text": "query ReactionsContentQuery($contentId:ID!){content(id:$contentId){nodes{id,contentReactionsSummary{reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}}}"
        }
    };
}();
$380a75471f8fd0e5$var$node.hash = "b632c435e4326f4f3245476cffd31162";
var $380a75471f8fd0e5$export$2e2bcd8739ae039 = $380a75471f8fd0e5$var$node;
module.exports["default"] = $380a75471f8fd0e5$export$2e2bcd8739ae039;

});

parcelRegister("9inwL", function(module, exports) {
/**
 * @generated SignedSource<<f8edd74a2bf0cef86303775c92f6818c>>
 * @relayHash f92419f4eae7659107884daf44afe353
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c5083034f862ac3ea960cfc4592f08715470b77981a4653cdbbd9dc1f12df8a1
const $5791e6e7c338c837$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "missingSpaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "condition": "missingSpaceKey",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "key",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentPrerequisitesQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentPrerequisitesQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "f92419f4eae7659107884daf44afe353",
            "id": "c5083034f862ac3ea960cfc4592f08715470b77981a4653cdbbd9dc1f12df8a1",
            "metadata": {},
            "name": "ContentPrerequisitesQuery",
            "operationKind": "query",
            "text": "query ContentPrerequisitesQuery($contentId:ID!,$missingSpaceKey:Boolean=false,$spaceKey:String,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,space{id,key,alias}}},space(key:$spaceKey)@skip(if:$missingSpaceKey){id,name}}"
        }
    };
}();
$5791e6e7c338c837$var$node.hash = "96ae26a7fa99861b8e368c368e56f6cc";
var $5791e6e7c338c837$export$2e2bcd8739ae039 = $5791e6e7c338c837$var$node;
module.exports["default"] = $5791e6e7c338c837$export$2e2bcd8739ae039;

});

parcelRegister("4uNpa", function(module, exports) {
/**
 * @generated SignedSource<<d7fe2a7a66643bd9c72401c8da9b795f>>
 * @relayHash 81e3b75d8ec7e8341dfb9fe5d7c36fac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9df42f2f20f0917766b188fd5cf2b943f7c14748bf3e7fc1c3a1ae1f61a77911
const $2411ee21620b66c4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionOverride"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "version",
                    "variableName": "versionOverride"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "homepageId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        },
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "createdDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentRedirectQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentRedirectQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "81e3b75d8ec7e8341dfb9fe5d7c36fac",
            "id": "9df42f2f20f0917766b188fd5cf2b943f7c14748bf3e7fc1c3a1ae1f61a77911",
            "metadata": {},
            "name": "ContentRedirectQuery",
            "operationKind": "query",
            "text": "query ContentRedirectQuery($contentId:ID,$versionOverride:Int){content(id:$contentId,version:$versionOverride){nodes{id,title,space{id,homepageId,key,alias},history{createdDate}}}}"
        }
    };
}();
$2411ee21620b66c4$var$node.hash = "440c7fc38cc16d750fa69bd87e3ba7c2";
var $2411ee21620b66c4$export$2e2bcd8739ae039 = $2411ee21620b66c4$var$node;
module.exports["default"] = $2411ee21620b66c4$export$2e2bcd8739ae039;

});

parcelRegister("98Fgg", function(module, exports) {
/**
 * @generated SignedSource<<9e3e16b02d7e839cb28fafbd9cc22027>>
 * @relayHash 1eef94f086d4818dc81396289138687a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 57138c5ec4f8edfbd221571e7278778f53d34a1487ac2bb480000f3f99715f09
const $314d226daa5f5ce2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isBlog"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = [
        {
            "condition": "isBlog",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        {
                            "kind": "Literal",
                            "name": "status",
                            "value": [
                                "CURRENT"
                            ]
                        }
                    ],
                    "concreteType": "PTPage",
                    "kind": "LinkedField",
                    "name": "ptpage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 1
                                }
                            ],
                            "concreteType": "PTPaginatedPageList",
                            "kind": "LinkedField",
                            "name": "nearestAncestors",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PTPageEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "PTPage",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "nearestAncestors(first:1)"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                v1 /*: any*/ 
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v4 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "number"
                                }
                            ]
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                v4 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadLegacyBridgeQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadLegacyBridgeQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "1eef94f086d4818dc81396289138687a",
            "id": "57138c5ec4f8edfbd221571e7278778f53d34a1487ac2bb480000f3f99715f09",
            "metadata": {},
            "name": "preloadLegacyBridgeQuery",
            "operationKind": "query",
            "text": "query preloadLegacyBridgeQuery($contentId:ID!,$isBlog:Boolean!){ptpage(id:$contentId,status:[CURRENT])@skip(if:$isBlog){id,nearestAncestors(first:1){edges{node{id,title}}}},content(id:$contentId){nodes{id,type,title,version{number},space{id,key,name,type},operations{operation,targetType}}}}"
        }
    };
}();
$314d226daa5f5ce2$var$node.hash = "6d396d281028b16cc64fd39e7d8cd3db";
var $314d226daa5f5ce2$export$2e2bcd8739ae039 = $314d226daa5f5ce2$var$node;
module.exports["default"] = $314d226daa5f5ce2$export$2e2bcd8739ae039;

});

parcelRegister("8G3G6", function(module, exports) {
/**
 * @generated SignedSource<<c5b5f73002999b27d52061f945d6fdad>>
 * @relayHash 4454a52ea4ab532f76ee4e80586f3a56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b93f6dc06e9898ae5a96da49582122e7834ced458f11ee2b79ed14f9d9b3a87
const $3a0ab9c788e793cd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentType"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                }
            ],
            "concreteType": "CatchupLastViewedTimeResponse",
            "kind": "LinkedField",
            "name": "catchupGetLastViewedTime",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "lastViewedTimeISO"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "4454a52ea4ab532f76ee4e80586f3a56",
            "id": "1b93f6dc06e9898ae5a96da49582122e7834ced458f11ee2b79ed14f9d9b3a87",
            "metadata": {},
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "operationKind": "query",
            "text": "query useDynamicSplitButtonCatchupLastViewedTimeQuery($contentId:ID!,$contentType:CatchupContentType!){catchupGetLastViewedTime(contentId:$contentId,contentType:$contentType){lastViewedTimeISO}}"
        }
    };
}();
$3a0ab9c788e793cd$var$node.hash = "4580906c8b823122d6a7f5ad8c2e2c6c";
var $3a0ab9c788e793cd$export$2e2bcd8739ae039 = $3a0ab9c788e793cd$var$node;
module.exports["default"] = $3a0ab9c788e793cd$export$2e2bcd8739ae039;

});

parcelRegister("38Ncj", function(module, exports) {
/**
 * @generated SignedSource<<97620748d8d680bcf5801bcd64a5c19f>>
 * @relayHash 21cebd3db50676fd19d57554f2f4d6fc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fcc453c87e447898e23b0fd063f4631ca349fe93580bd0dea45de46209594904
const $630a58f9ca4672ab$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isContentTypePublicLinkEligible"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasInheritedRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasViewRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        },
        {
            "condition": "isContentTypePublicLinkEligible",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "contentId"
                        }
                    ],
                    "concreteType": "PublicLinkPage",
                    "kind": "LinkedField",
                    "name": "publicLinkPage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "pageId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "pageStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "accessType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useShareAndRestrictButtonDataQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useShareAndRestrictButtonDataQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "21cebd3db50676fd19d57554f2f4d6fc",
            "id": "fcc453c87e447898e23b0fd063f4631ca349fe93580bd0dea45de46209594904",
            "metadata": {},
            "name": "useShareAndRestrictButtonDataQuery",
            "operationKind": "query",
            "text": "query useShareAndRestrictButtonDataQuery($contentId:ID!,$isContentTypePublicLinkEligible:Boolean!){singleContent(id:$contentId){id,hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title},publicLinkPage(pageId:$contentId)@include(if:$isContentTypePublicLinkEligible){pageId,pageStatus,accessType}}"
        }
    };
}();
$630a58f9ca4672ab$var$node.hash = "336fe7f51ff27baeb231379611028a5d";
var $630a58f9ca4672ab$export$2e2bcd8739ae039 = $630a58f9ca4672ab$var$node;
module.exports["default"] = $630a58f9ca4672ab$export$2e2bcd8739ae039;

});

parcelRegister("1ydBT", function(module, exports) {
/**
 * @generated SignedSource<<2677448ae3824ed4f96e28a9f90ebc11>>
 * @relayHash cba455fca3d3e3ded9f59ef8dd1da82e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b15555a02e345dcac49028e56ae8de642103a954aa49f5dd68c34c48c3bc41c1
const $4edc52e24113851d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v8 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v11 = {
        "kind": "LinkedField",
        "name": "contributors",
        "plural": true,
        "selections": [
            v5 /*: any*/ ,
            v6 /*: any*/ ,
            v8 /*: any*/ ,
            v10 /*: any*/ 
        ]
    }, v12 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v13 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v12 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v14 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v15 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v12 /*: any*/ 
    }, v16 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v17 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v19 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v21 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v22 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v9 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v24 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v25 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "number"
    }, v27 = {
        "kind": "ScalarField",
        "name": "when"
    }, v28 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "confluenceCommentFilter",
                    "value": {
                        "commentState": "UNRESOLVED",
                        "commentType": "FOOTER"
                    }
                },
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Literal",
                    "name": "depth",
                    "value": "ROOT"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                v3 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": [
                        "FOOTER"
                    ]
                }
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ 
                            ]
                        },
                        v11 /*: any*/ ,
                        v13 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ 
                            ]
                        },
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v17 /*: any*/ ,
                        v22 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        v25 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                v11 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                v26 /*: any*/ ,
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "totalCount"
                },
                v5 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
            "selections": v28 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
            "selections": v28 /*: any*/ 
        },
        "params": {
            "cacheID": "cba455fca3d3e3ded9f59ef8dd1da82e",
            "id": "b15555a02e345dcac49028e56ae8de642103a954aa49f5dd68c34c48c3bc41c1",
            "metadata": {},
            "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
            "operationKind": "query",
            "text": "query ObjectCommentContainerPreloadObjectCommentsQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$first:Long){comments(pageId:$pageId,contentStatus:$contentStatus,depth:ROOT,first:$first,type:[FOOTER],confluenceCommentFilter:{commentState:UNRESOLVED,commentType:FOOTER}){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}},totalCount,__typename}}"
        }
    };
}();
$4edc52e24113851d$var$node.hash = "3a2732629f8a4a69bf446268336b7bc9";
var $4edc52e24113851d$export$2e2bcd8739ae039 = $4edc52e24113851d$var$node;
module.exports["default"] = $4edc52e24113851d$export$2e2bcd8739ae039;

});

parcelRegister("MJaSd", function(module, exports) {

var $kgNLQ = parcelRequire("kgNLQ");

const $eeebfa790a4a25a5$export$c6ff0a0df62acf44 = 3;
const $eeebfa790a4a25a5$export$533048ab2aed5b1a = -1;
// Default empty preload data structure (can be spread and isDataProcessed overridden)
const $eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA = {
    allComments: [],
    allFilteredComments: [],
    openInlineComments: [],
    openFooterComments: [],
    resolvedComments: [],
    openComments: [],
    commentsDataMap: {
        inline: {},
        general: {}
    },
    flatCommentsMap: {},
    hasNestedComments: false,
    commentCount: null,
    hasAnyComments: false,
    isDataProcessed: false
};
const $eeebfa790a4a25a5$export$fa19d42490144c8 = (contentId)=>({
        pageId: contentId,
        // Query for all comments regardless of status (although skip deleted since we have no way to show it), we'll filter on the FE
        contentStatus: [
            'DRAFT',
            'CURRENT',
            'ARCHIVED'
        ],
        first: $eeebfa790a4a25a5$export$c6ff0a0df62acf44
    });
const $eeebfa790a4a25a5$export$7cc295d5a932445b = (processedPreloadData, preloadCacheData)=>{
    if (!processedPreloadData.isDataProcessed || !preloadCacheData?.comments) return false;
    const totalCount = preloadCacheData.comments.totalCount;
    // If totalCount is the loading flag, we're still loading
    if (totalCount === $eeebfa790a4a25a5$export$533048ab2aed5b1a) return false;
    // Calculate loaded comment count (parent comments + replies)
    const loadedCommentCount = preloadCacheData.comments.nodes?.reduce((acc, comment)=>{
        if (!comment) return acc;
        return acc + (comment?.replies?.length || 0) + 1; // parent + reply count
    }, 0) ?? 0;
    // Check if we've loaded all available comments
    return loadedCommentCount === totalCount;
};
const $eeebfa790a4a25a5$export$e229b0e2973dcb38 = (processedCommentsData, preloadCacheData, contentStatus)=>{
    // Check cache value to determine if we're in a loading state (totalCount === -1)
    const isPreloadLoadingFromCache = preloadCacheData?.comments?.totalCount === $eeebfa790a4a25a5$export$533048ab2aed5b1a;
    // Process preload data
    // Don't process if we're loading (check cache value, not loading state)
    let processedPreloadData;
    if (isPreloadLoadingFromCache) processedPreloadData = {
        ...$eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA,
        isDataProcessed: false
    };
    else if (preloadCacheData?.comments) {
        if (preloadCacheData.comments.nodes) {
            const allComments = (preloadCacheData.comments.nodes || []).filter((node)=>node !== null);
            // Filter preload comments by the contentStatus prop (same as CommentsDataBackgroundLoader does)
            // This ensures we only show comments that match the current page's content status
            const categorized = (0, $kgNLQ.categorizeComments)(allComments, contentStatus);
            processedPreloadData = {
                allComments: allComments,
                ...categorized,
                isDataProcessed: true
            };
        } else processedPreloadData = {
            ...$eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA,
            isDataProcessed: true
        };
    } else processedPreloadData = {
        ...$eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA,
        isDataProcessed: false
    };
    // Determine which data source to use
    // If ProcessedCommentsDataStore has processed data, use that
    // Otherwise, use the preload query data
    const hasFullData = processedCommentsData.isDataProcessed;
    // Calculate if all data has been preloaded
    const allDataPreloaded = $eeebfa790a4a25a5$export$7cc295d5a932445b(processedPreloadData, preloadCacheData);
    // Dynamically determine the data to return based on current state
    // isDataProcessed always comes from ProcessedCommentsDataStore
    // Only the comment data itself comes from preload when full data isn't available
    const finalData = hasFullData ? processedCommentsData : {
        ...processedCommentsData,
        // Override comment data with preload data, but keep isDataProcessed from store
        ...processedPreloadData,
        isDataProcessed: processedCommentsData.isDataProcessed,
        error: processedCommentsData.error
    };
    return {
        ...finalData,
        // Keep separate vars for preload loading status so we don't have to assert isPreloading && ... everywhere
        isPreloadLoading: isPreloadLoadingFromCache,
        isPreloadDataProcessed: processedPreloadData.isDataProcessed,
        // Indicate whether preload completed with comments (for SSR placeholder display)
        preloadCompletedWithComments: processedPreloadData.isDataProcessed && processedPreloadData.allFilteredComments.length > 0,
        allDataPreloaded: // Indicate whether the preload contained ALL comments
        allDataPreloaded,
        // Indicate whether we're currently using full data or preload data
        isUsingFullData: hasFullData
    };
};
module.exports["PRELOAD_LOADING_FLAG"] = $eeebfa790a4a25a5$export$533048ab2aed5b1a;
module.exports["buildPreloadObjectCommentsQueryVariables"] = $eeebfa790a4a25a5$export$fa19d42490144c8;
module.exports["getPreloadAwareObjectComments"] = $eeebfa790a4a25a5$export$e229b0e2973dcb38;

});

parcelRegister("lj2R9", function(module, exports) {
/**
 * @generated SignedSource<<1e72b221db30c6dd58d4a18a3c908cd9>>
 * @relayHash 667db9b1207176451cb2198029bc1794
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 263c5187fe4d45dd66f4564bd6f052b5aa2b86c867264433913ce3020f843c0c
const $0d0305ae4f6822bb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "externalCollaboratorCount"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ViewSpaceExternalCollaboratorsDialogQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ViewSpaceExternalCollaboratorsDialogQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "667db9b1207176451cb2198029bc1794",
            "id": "263c5187fe4d45dd66f4564bd6f052b5aa2b86c867264433913ce3020f843c0c",
            "metadata": {},
            "name": "ViewSpaceExternalCollaboratorsDialogQuery",
            "operationKind": "query",
            "text": "query ViewSpaceExternalCollaboratorsDialogQuery($spaceKey:String){space(key:$spaceKey){id,name,externalCollaboratorCount,currentUser{isAdmin}}}"
        }
    };
}();
$0d0305ae4f6822bb$var$node.hash = "722ca76340bcbe86e394e6f8663add12";
var $0d0305ae4f6822bb$export$2e2bcd8739ae039 = $0d0305ae4f6822bb$var$node;
module.exports["default"] = $0d0305ae4f6822bb$export$2e2bcd8739ae039;

});

parcelRegister("g2a13", function(module, exports) {
/**
 * @generated SignedSource<<e6d20f14365dfcef5db10c797898d3cf>>
 * @relayHash fe506bd9046797cde11ab0f7fcc9d885
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 854f59c2498e8df1c5c0ea0d63c7c4d8d62ad62311c64a732f4a327d479681be
const $53f7ad90e8632c3f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "SpaceSidebarLinks",
            "kind": "LinkedField",
            "name": "spaceSidebarLinks",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "concreteType": "SpaceSidebarLink",
                    "kind": "LinkedField",
                    "name": "quick",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "position"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "styleClass"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useShortcutsSpaceNavigationQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useShortcutsSpaceNavigationQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "fe506bd9046797cde11ab0f7fcc9d885",
            "id": "854f59c2498e8df1c5c0ea0d63c7c4d8d62ad62311c64a732f4a327d479681be",
            "metadata": {},
            "name": "useShortcutsSpaceNavigationQuery",
            "operationKind": "query",
            "text": "query useShortcutsSpaceNavigationQuery($spaceKey:String){spaceSidebarLinks(spaceKey:$spaceKey){__typename,quick{id,url,position,title,styleClass}}}"
        }
    };
}();
$53f7ad90e8632c3f$var$node.hash = "52dba71769af710a3e1e472bed635436";
var $53f7ad90e8632c3f$export$2e2bcd8739ae039 = $53f7ad90e8632c3f$var$node;
module.exports["default"] = $53f7ad90e8632c3f$export$2e2bcd8739ae039;

});

parcelRegister("MyxIQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $apw3A = parcelRequire("apw3A");


var $4PX6o = parcelRequire("4PX6o");


var $bkTet = parcelRequire("bkTet");


var $6mKj3 = parcelRequire("6mKj3");


var $xwvlW = parcelRequire("xwvlW");


var $wPrRK = parcelRequire("wPrRK");


var $1xpoY = parcelRequire("1xpoY");


var $60cDW = parcelRequire("60cDW");


var $d6NtA = parcelRequire("d6NtA");



var $d5fg6 = parcelRequire("d5fg6");


var $0VKZa = parcelRequire("0VKZa");

/**
 * Post Office class for managing in memory cache of Placement queries.
 * We store the cache reference on the global object to persist across SSR requests.
 */ const $cdd1e9f9feeb24fd$var$POST_OFFICE_QUERY_CACHE = globalThis?.__POST_OFFICE_QUERY_CACHE__ || {};
const $cdd1e9f9feeb24fd$var$postOfficeClient = new (0, $d5fg6.PostOfficeCacheClient)($cdd1e9f9feeb24fd$var$POST_OFFICE_QUERY_CACHE);
const $cdd1e9f9feeb24fd$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $cdd1e9f9feeb24fd$export$b3732c8ff6f9c463 = (res)=>{
    if (typeof res === 'undefined') throw new Error('No response from server');
    if (res.ok) return res;
    throw new Error($cdd1e9f9feeb24fd$export$18a0019e5439b209(res));
};
const $cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse = (data)=>{
    const init = {
        status: 200,
        statusText: 'ok!'
    };
    return new Response(JSON.stringify(data), init);
};
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $cdd1e9f9feeb24fd$var$getIsSSR = ()=>Boolean(undefined);
const $cdd1e9f9feeb24fd$var$POST_OFFICE_SERVICE_NAME = 'post-office';
const $cdd1e9f9feeb24fd$var$POST_OFFICE_ARCHETYPE_NAME = 'post-office-archetype';
const $cdd1e9f9feeb24fd$var$confluenceFetcher = async (url, headers, requestInit)=>{
    // When in SPA mode, we want to re-use the pending fetcher if it exists - so that we don't make another Network request from the Transition preloaders
    if (!$cdd1e9f9feeb24fd$var$getIsSSR()) {
        const cachedFetcher = $cdd1e9f9feeb24fd$var$postOfficeClient.getFetcherWithUrl(url);
        if (cachedFetcher) return cachedFetcher;
    }
    let fetcher;
    fetcher = (0, $4PX6o.defaultFetcher)(url, headers, requestInit);
    fetcher = fetcher.then($cdd1e9f9feeb24fd$export$b3732c8ff6f9c463).then((res)=>res.json()).then((data)=>{
        $cdd1e9f9feeb24fd$var$postOfficeClient.setDataWithUrl(url, data);
        return $cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse(data);
    });
    // When we're in SPA mode, we want to cache the fetcher so that it can be reused
    // if the network request takes too long and the data doesn't come back in time
    // before another request is requested by <Placement>
    if (!$cdd1e9f9feeb24fd$var$getIsSSR()) $cdd1e9f9feeb24fd$var$postOfficeClient.setFetcherWithUrl(url, fetcher);
    return fetcher;
};
const $cdd1e9f9feeb24fd$var$cookieMap = new Map([
    [
        'consentToken',
        (0, $bkTet.ATLASSIAN_CONSENT_COOKIE_KEY)
    ],
    [
        'fallbackConsentToken',
        (0, $bkTet.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)
    ]
]);
const $cdd1e9f9feeb24fd$var$mapCookiesToFetchHeaders = (cookies)=>{
    if (typeof cookies !== 'object' || cookies === null) return undefined;
    return Array.from($cdd1e9f9feeb24fd$var$cookieMap.entries()).map(([key, value])=>{
        if (cookies[key]) return `${value}=${cookies[key]}`;
        return '';
    }).filter(Boolean).join(';');
};
/**
 * Common method for setting up the Post Office placement request URL with the environment and product context
 *
 * @param placementId
 * @param contextOptions
 * @returns
 */ const $cdd1e9f9feeb24fd$var$preloadPostOfficePlacement = async (placementId, contextOptions, extraFetchOptions)=>{
    const { postOfficeContext: postOfficeContext, environment: environment } = contextOptions;
    // Mirror client-side guard in Placement.tsx (useInitialDataIfEnabled → isPostOfficePlacementsGloballyDisabled)
    // to prevent SSR/client mismatch when placements are globally disabled (e.g. stableUI=1).
    if (postOfficeContext.disableAllPlacements) return;
    const confluenceFetcherWithS2SHeaders = async (url)=>{
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const isSSR = Boolean(undefined);
        if (isSSR) {
            let hostEnv = 'prod';
            if (environment.currentEnv !== 'production') hostEnv = 'staging';
            const { cookiesConsentToken: cookiesConsentToken, cookiesFallbackToken: cookiesFallbackToken, isBifrostIcRequest: isBifrostIcRequest } = (0, $60cDW.getSSRRenderInputs)();
            const cookies = $cdd1e9f9feeb24fd$var$mapCookiesToFetchHeaders({
                consentToken: cookiesConsentToken,
                fallbackConsentToken: cookiesFallbackToken
            });
            const fetchHeaders = !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': $cdd1e9f9feeb24fd$var$POST_OFFICE_SERVICE_NAME,
                // Tells Tesseract to S2S with `post-office`
                ...isBifrostIcRequest === true && (0, $6mKj3.expVal)('confluence_ssr_bifrost_ic', 'isEnabled', false) ? {
                    'x-archetype-name': $cdd1e9f9feeb24fd$var$POST_OFFICE_ARCHETYPE_NAME
                } : {},
                'x-ssr-service-env': hostEnv // Defaults to current Env, however Post Office is not in dev
            } : {};
            if (cookies) fetchHeaders.Cookie = cookies;
            const finalUrl = (0, $d6NtA.isLocal)() ? url : url.replace('gateway/api/post-office/', '');
            return $cdd1e9f9feeb24fd$var$confluenceFetcher(finalUrl, fetchHeaders, extraFetchOptions?.requestInit);
        }
        return $cdd1e9f9feeb24fd$var$confluenceFetcher(url, undefined, extraFetchOptions?.requestInit);
    };
    const basePath = (0, $apw3A.buildBasePath)(environment.currentEnv, environment.envConfigs);
    return (0, $4PX6o.requestInitialData)(placementId, postOfficeContext, confluenceFetcherWithS2SHeaders, {
        ...basePath,
        resource: extraFetchOptions?.resource
    });
};
const $cdd1e9f9feeb24fd$export$420f2f91a928b3b6 = ()=>{
    return (0, $cozmU.useCallback)((url, requestOptions)=>{
        // Use data in cache if it exists
        const data = $cdd1e9f9feeb24fd$var$postOfficeClient.getDataWithUrl(url);
        if (data) /**
       * Preloaded data must be serialized, however our initialData is expected to be in the form of a Response promise.
       * TODO: Remove this workaround once the Post Office placement API is updated to handle flat data.
       */ return Promise.resolve($cdd1e9f9feeb24fd$var$wrapResolvedDataAsFetchResponse(data));
        // When in SPA mode, we want to re-use the pending fetcher if it exists - so that we don't make another Network request from the Placement component
        if (!$cdd1e9f9feeb24fd$var$getIsSSR()) {
            const fetcher = $cdd1e9f9feeb24fd$var$postOfficeClient.getFetcherWithUrl(url);
            if (fetcher) return fetcher;
        }
        // Convert headers to Record<string, string> if present
        let headers = {};
        if (requestOptions?.headers) {
            if (requestOptions.headers instanceof Headers) requestOptions.headers.forEach((value, name)=>{
                headers[name] = value;
            });
            else if (Array.isArray(requestOptions.headers)) requestOptions.headers.forEach(([name, value])=>{
                headers[name] = value;
            });
            else headers = requestOptions.headers;
        }
        // Use a new fetcher if neither data nor fetcher is in cache
        return $cdd1e9f9feeb24fd$var$confluenceFetcher(url, headers, requestOptions);
    }, []);
};
const $cdd1e9f9feeb24fd$export$17b92961ead3f211 = (placementId)=>{
    const [preloadedData, setPreloadedData] = (0, $cozmU.useState)(()=>{
        const data = $cdd1e9f9feeb24fd$var$postOfficeClient.getDataWithPlacementId(placementId);
        if (data) return data;
        return undefined;
    });
    const setter = (0, $cozmU.useCallback)((data)=>{
        $cdd1e9f9feeb24fd$var$postOfficeClient.setDataWithPlacementId(placementId, data);
        setPreloadedData(data);
    }, [
        placementId
    ]);
    return [
        preloadedData,
        setter
    ];
};
const $cdd1e9f9feeb24fd$export$1d2f4123d64ba093 = async (placementId, extraFetchOptions)=>{
    const sessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const postOfficeTimeout = (0, $1xpoY.default).getNumber('confluence_frontend_preload_postoffice_timeout', (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    return (0, $wPrRK.slowQueryGuard)(`preloadPostOfficePlacement:${placementId}`, ()=>$cdd1e9f9feeb24fd$var$preloadPostOfficePlacement(placementId, {
            postOfficeContext: (0, $0VKZa.sessionToPostOfficeContext)(sessionContext),
            environment: {
                currentEnv: (0, $0VKZa.transformConfluenceEnvToPostOfficeEnvironment)(sessionContext.environment)
            }
        }, extraFetchOptions), postOfficeTimeout);
};
module.exports["usePlacementSSRFetch"] = $cdd1e9f9feeb24fd$export$420f2f91a928b3b6;
module.exports["usePlacementPreloadedData"] = $cdd1e9f9feeb24fd$export$17b92961ead3f211;
module.exports["preloadPostOfficePlacementWithSessionContext"] = $cdd1e9f9feeb24fd$export$1d2f4123d64ba093;

});

parcelRegister("apw3A", function(module, exports) {

var $3rMm0 = parcelRequire("3rMm0");


var $jdpvF = parcelRequire("jdpvF");

const $9fbb603c3fc74986$export$e8b30f9c4a80230f = (currentEnv, envConfigs = (0, $jdpvF.defaultEnvironmentValues).envConfigs)=>{
    const baseUrl = envConfigs[currentEnv].api.origin;
    // TypeScript & Safety reasons: Final default to staging-prod API path in case path got overriden somewhere to be undefined, but this should not be the case
    const path = envConfigs[currentEnv].api.pathname ?? (0, $3rMm0.API_PATHNAME_STG_PROD);
    return {
        baseUrl: baseUrl,
        path: path
    };
};
module.exports["buildBasePath"] = $9fbb603c3fc74986$export$e8b30f9c4a80230f;

});

parcelRegister("3rMm0", function(module, exports) {
const $9bfb4763c90d8540$export$5ca004be156a127a = 'http://localhost:4224';
const $9bfb4763c90d8540$export$a5c5394c951a9848 = '/gateway/api/post-office/api/v1/placements/';
const $9bfb4763c90d8540$export$1e9fed4c0197724c = 'http://localhost:8081';
const $9bfb4763c90d8540$export$919a9569bce66f17 = '/api/v1/placements/';
const $9bfb4763c90d8540$export$d4fe3482c88e73a8 = '/gateway/api/post-office/api/v1/placements/';
const $9bfb4763c90d8540$export$67be2569ef5d7666 = 'http://localhost:9009';
const $9bfb4763c90d8540$export$b49738b89db261cd = 'https://post-office-rml-frontend.stg-east.frontend.public.atl-paas.net';
const $9bfb4763c90d8540$export$bbd96cd490b0df63 = 'https://post-office-rml-frontend.prod-east.frontend.public.atl-paas.net';
const $9bfb4763c90d8540$export$a2ac4fea250cfcb6 = 'https://post-office-rml-frontend.stg.frontend.cdn.atlassian-us-gov-mod.com';
const $9bfb4763c90d8540$export$4db578e7ea13bd1b = 'https://post-office-rml-frontend.frontend.cdn.atlassian-us-gov-mod.com';
module.exports["API_ORIGIN_TEST_SERVER"] = $9bfb4763c90d8540$export$5ca004be156a127a;
module.exports["API_ORIGIN_LOCAL"] = $9bfb4763c90d8540$export$1e9fed4c0197724c;
module.exports["API_PATHNAME_LOCAL"] = $9bfb4763c90d8540$export$919a9569bce66f17;
module.exports["API_PATHNAME_STG_PROD"] = $9bfb4763c90d8540$export$d4fe3482c88e73a8;
module.exports["REMOTE_MODULE_URI_LOCAL"] = $9bfb4763c90d8540$export$67be2569ef5d7666;
module.exports["REMOTE_MODULE_URI_STG"] = $9bfb4763c90d8540$export$b49738b89db261cd;
module.exports["REMOTE_MODULE_URI_PROD"] = $9bfb4763c90d8540$export$bbd96cd490b0df63;
module.exports["REMOTE_MODULE_URI_STG_FEDM"] = $9bfb4763c90d8540$export$a2ac4fea250cfcb6;
module.exports["REMOTE_MODULE_URI_PROD_FEDM"] = $9bfb4763c90d8540$export$4db578e7ea13bd1b;

});

parcelRegister("jdpvF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $3rMm0 = parcelRequire("3rMm0");

const $1f78ef0061fd59e3$export$5dba87a2097d7fb2 = (isFedRampCompliantUrlsEnabled = false)=>{
    return {
        currentEnv: 'local',
        envConfigs: {
            'test-server': {
                remoteModule: {
                    origin: (0, $3rMm0.REMOTE_MODULE_URI_LOCAL),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $3rMm0.API_ORIGIN_TEST_SERVER),
                    pathname: (0, $3rMm0.API_ORIGIN_TEST_SERVER),
                    searchParams: undefined
                }
            },
            test: {
                remoteModule: {
                    origin: (0, $3rMm0.REMOTE_MODULE_URI_LOCAL),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $3rMm0.API_ORIGIN_LOCAL),
                    pathname: (0, $3rMm0.API_PATHNAME_LOCAL),
                    searchParams: undefined
                }
            },
            local: {
                remoteModule: {
                    origin: (0, $3rMm0.REMOTE_MODULE_URI_LOCAL),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $3rMm0.API_ORIGIN_LOCAL),
                    pathname: (0, $3rMm0.API_PATHNAME_LOCAL),
                    searchParams: undefined
                }
            },
            dev: {
                remoteModule: {
                    origin: (0, $3rMm0.REMOTE_MODULE_URI_LOCAL),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: (0, $3rMm0.API_ORIGIN_LOCAL),
                    pathname: (0, $3rMm0.API_PATHNAME_LOCAL),
                    searchParams: undefined
                }
            },
            staging: {
                remoteModule: {
                    origin: (0, $3rMm0.REMOTE_MODULE_URI_STG),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $3rMm0.API_PATHNAME_STG_PROD),
                    searchParams: undefined
                }
            },
            'stg-fedm-east': {
                remoteModule: {
                    origin: isFedRampCompliantUrlsEnabled ? (0, $3rMm0.REMOTE_MODULE_URI_STG_FEDM) : (0, $3rMm0.REMOTE_MODULE_URI_STG),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $3rMm0.API_PATHNAME_STG_PROD),
                    searchParams: undefined
                }
            },
            production: {
                remoteModule: {
                    origin: (0, $3rMm0.REMOTE_MODULE_URI_PROD),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $3rMm0.API_PATHNAME_STG_PROD),
                    searchParams: undefined
                }
            },
            'prod-fedm-east': {
                remoteModule: {
                    origin: isFedRampCompliantUrlsEnabled ? (0, $3rMm0.REMOTE_MODULE_URI_PROD_FEDM) : (0, $3rMm0.REMOTE_MODULE_URI_PROD),
                    pathname: undefined,
                    searchParams: undefined
                },
                api: {
                    origin: undefined,
                    pathname: (0, $3rMm0.API_PATHNAME_STG_PROD),
                    searchParams: undefined
                }
            }
        }
    };
};
const $1f78ef0061fd59e3$export$b4ede87479bfcf09 = $1f78ef0061fd59e3$export$5dba87a2097d7fb2();
const $1f78ef0061fd59e3$export$fceca2c399b32565 = (0, $cozmU.createContext)($1f78ef0061fd59e3$export$b4ede87479bfcf09);
const $1f78ef0061fd59e3$export$604607f913ef367c = $1f78ef0061fd59e3$export$fceca2c399b32565.Provider;
const $1f78ef0061fd59e3$export$877b97169cc75e8b = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($1f78ef0061fd59e3$export$fceca2c399b32565);
} : ()=>(0, $cozmU.useContext)($1f78ef0061fd59e3$export$fceca2c399b32565);
module.exports["buildDefaultEnvironmentValues"] = $1f78ef0061fd59e3$export$5dba87a2097d7fb2;
module.exports["defaultEnvironmentValues"] = $1f78ef0061fd59e3$export$b4ede87479bfcf09;
module.exports["PostOfficeEnvironmentProvider"] = $1f78ef0061fd59e3$export$604607f913ef367c;
module.exports["usePostOfficeEnvironment"] = $1f78ef0061fd59e3$export$877b97169cc75e8b;

});

parcelRegister("4PX6o", function(module, exports) {
const $dc9030da747a3f79$export$77754e0ac9f8aba3 = (url, headers, fetchOptions)=>fetch(url, {
        ...fetchOptions,
        headers: {
            credentials: 'include',
            mode: 'cors',
            'Content-Type': 'application/json',
            ...headers,
            ...fetchOptions?.headers
        }
    });
const $dc9030da747a3f79$export$c4c39037cc4b06ab = async (placementId, context, fetcher = $dc9030da747a3f79$export$77754e0ac9f8aba3, options)=>{
    const baseUrl = options.baseUrl;
    const path = options.path;
    const requestUrl = baseUrl ? new URL(path, baseUrl).toString() : path;
    const requestResource = options.resource ? options.resource : '';
    function stringifyObjectValues(input) {
        const entries = Object.entries(input);
        const stringifiedEntries = entries.filter(([, v])=>typeof v !== 'undefined' && v !== null).map(([key, value])=>[
                key,
                String(value)
            ]);
        return Object.fromEntries(stringifiedEntries);
    }
    const contextAsSearchParams = new URLSearchParams(stringifyObjectValues(context));
    contextAsSearchParams.sort();
    const url = encodeURI(`${requestUrl}${placementId}${requestResource}?${contextAsSearchParams.toString()}`);
    // Response will be handled inside the component
    return fetcher(url);
};
module.exports["defaultFetcher"] = $dc9030da747a3f79$export$77754e0ac9f8aba3;
module.exports["requestInitialData"] = $dc9030da747a3f79$export$c4c39037cc4b06ab;

});

parcelRegister("d5fg6", function(module, exports) {
class $2eb32372f08d498d$export$11e1da55bed53d18 {
    getKey(url) {
        const urlMatches = url.match(/placements\/([\w\-/]+)(?:.*updateKey=)?(\w+)?/);
        if (urlMatches?.length && urlMatches.length > 1) return urlMatches.slice(1).filter(Boolean).join('/');
        return url;
    }
    get(key) {
        return this.cache[key];
    }
    set(key, value) {
        this.cache[key] = value;
    }
    getDataWithPlacementId(placementId) {
        return this.get(`placements/${placementId}`)?.data;
    }
    setDataWithPlacementId(placementId, data) {
        this.set(`placements/${placementId}`, {
            data: data,
            fetcher: undefined
        });
    }
    getDataWithUrl(url) {
        return this.get('placements/' + this.getKey(url))?.data;
    }
    setDataWithUrl(url, data) {
        const cache = this.get(`placements/${this.getKey(url)}`);
        this.set(`placements/${this.getKey(url)}`, {
            fetcher: cache?.fetcher,
            data: data
        });
    }
    getFetcherWithUrl(url) {
        return this.get(`placements/${this.getKey(url)}`)?.fetcher;
    }
    setFetcherWithUrl(url, fetcher) {
        const cache = this.get(`placements/${this.getKey(url)}`);
        this.set(`placements/${this.getKey(url)}`, {
            data: cache?.data,
            fetcher: fetcher
        });
    }
    constructor(cache){
        this.cache = cache;
        globalThis.__POST_OFFICE_QUERY_CACHE__ = cache;
    }
}
module.exports["PostOfficeCacheClient"] = $2eb32372f08d498d$export$11e1da55bed53d18;

});

parcelRegister("0VKZa", function(module, exports) {

var $i3jcY = parcelRequire("i3jcY");


var $d9tcB = parcelRequire("d9tcB");

const $e888fb1bd5b30926$var$CONFLUENCE_PRODUCT = 'confluence';
const $e888fb1bd5b30926$var$DEFAULT_POST_OFFICE_CONTEXT = {
    product: $e888fb1bd5b30926$var$CONFLUENCE_PRODUCT,
    locale: 'en'
};
const $e888fb1bd5b30926$var$getWorkspaceARI = ({ cloudId: cloudId, activationId: activationId })=>{
    return `ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
};
const $e888fb1bd5b30926$export$40fdfb947dabfc30 = (sessionData)=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId, locale: locale, orgId: orgId, edition: edition } = sessionData;
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const workspaceAri = $e888fb1bd5b30926$var$getWorkspaceARI({
        activationId: activationId,
        cloudId: cloudId
    });
    return {
        ...$e888fb1bd5b30926$var$DEFAULT_POST_OFFICE_CONTEXT,
        locale: locale,
        orgId: orgId,
        isSiteAdmin: isAdmin,
        tenantId: cloudId === '' ? undefined : cloudId,
        workspaceAri: workspaceAri,
        workspaceId: activationId,
        subproduct: undefined,
        productEdition: edition || undefined,
        disableAllPlacements: (0, $i3jcY.isStableUIEnabledForTests)() ? true : undefined
    };
};
const $e888fb1bd5b30926$export$76d03739bfe0286a = (environment)=>{
    switch(environment){
        case 'STAGING':
            return 'staging';
        case 'PRODUCTION':
            return 'production';
        case 'DEVELOPMENT':
            return 'local';
        default:
            return 'local';
    }
};
module.exports["sessionToPostOfficeContext"] = $e888fb1bd5b30926$export$40fdfb947dabfc30;
module.exports["transformConfluenceEnvToPostOfficeEnvironment"] = $e888fb1bd5b30926$export$76d03739bfe0286a;

});

parcelRegister("eKTWO", function(module, exports) {

var $hU1C8 = parcelRequire("hU1C8");


var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $hBkCm = parcelRequire("hBkCm");

var $f7B1p = parcelRequire("f7B1p");


var $jMyy4 = parcelRequire("jMyy4");

const $862814430f69e6aa$export$aad7e27ed56b51fc = (0, $hU1C8.default);
const $862814430f69e6aa$export$ba9e49b520a30a69 = ({ spaceKey: spaceKey, cloudId: cloudId })=>{
    // Apollo path — runs when experiment is on. useQueryInterop must be called
    // unconditionally; the skip option prevents network activity when unused.
    const { data: apolloData, loading: apolloLoading, refetch: apolloRefetch } = (0, $jMyy4.useQueryInterop)($862814430f69e6aa$export$aad7e27ed56b51fc, {
        variables: {
            cloudId: cloudId,
            spaceKey: spaceKey ?? ''
        },
        skip: !(0, $6mKj3.expVal)('confluence_autonomous_space_curation_ssr_streaming', 'isEnabled', false) || !spaceKey,
        interopApolloAggClient: true,
        __callerPackage__: "space-curation"
    });
    const apolloResult = (0, $cozmU.useMemo)(()=>{
        if (!(0, $6mKj3.expVal)('confluence_autonomous_space_curation_ssr_streaming', 'isEnabled', false)) return null;
        const raw = apolloData?.confluence_remoteObjectSuggestionCount;
        // null data is the suppression signal — this includes the case where the
        // backend returns errors alongside null data (e.g. NotFoundException when
        // the user has been permanently suppressed). Do not gate on apolloError.
        const apolloIsSuppressed = !apolloLoading && raw == null;
        return {
            count: raw ?? 0,
            isLoading: apolloLoading,
            isSuppressed: apolloIsSuppressed,
            refetch: ()=>{
                apolloRefetch();
            }
        };
    }, [
        apolloData,
        apolloLoading,
        apolloRefetch
    ]);
    // cfetch path — used when experiment is off
    const [count, setCount] = (0, $cozmU.useState)(0);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    const [isSuppressed, setIsSuppressed] = (0, $cozmU.useState)(false);
    const fetchCount = (0, $cozmU.useCallback)(async ()=>{
        if ((0, $6mKj3.expVal)('confluence_autonomous_space_curation_ssr_streaming', 'isEnabled', false)) return;
        if (!spaceKey) {
            setCount(0);
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        try {
            const response = await (0, $f7B1p.cfetch)(`/wiki/rest/internal/1.0/spaces/${spaceKey}/remote-objects/suggestions/count`, {
                method: 'GET'
            });
            const text = await response.text();
            const parsed = parseInt(text, 10);
            if (isNaN(parsed)) setIsSuppressed(true);
            else {
                setCount(parsed);
                setIsSuppressed(false);
            }
        } catch (error) {
            if ((0, $hBkCm.BadStatusError).isBadStatusError(error) && error.response.status === 404) setIsSuppressed(true);
        // silently fail on other errors
        } finally{
            setIsLoading(false);
        }
    }, [
        spaceKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates
        fetchCount();
    }, [
        fetchCount
    ]);
    if ((0, $6mKj3.expVal)('confluence_autonomous_space_curation_ssr_streaming', 'isEnabled', false)) return apolloResult ?? {
        count: count,
        isLoading: isLoading,
        isSuppressed: isSuppressed,
        refetch: fetchCount
    };
    return {
        count: count,
        isLoading: isLoading,
        isSuppressed: isSuppressed,
        refetch: fetchCount
    };
};
module.exports["RemoteObjectSuggestionCountQuery"] = $862814430f69e6aa$export$aad7e27ed56b51fc;
module.exports["useFetchSuggestionCount"] = $862814430f69e6aa$export$ba9e49b520a30a69;

});

parcelRegister("hU1C8", function(module, exports) {
/**
 * @generated SignedSource<<fb2a123e9f105316d12025951f51fc75>>
 * @relayHash 2928057d03b4f5d5a1a268a9759b926b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2a667fff01500eb3e9307529089fae38f8ffbfdb7afefb552f82585ed918492
const $41493c5c0e5e4e0b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_remoteObjectSuggestionCount"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFetchSuggestionCountQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFetchSuggestionCountQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "2928057d03b4f5d5a1a268a9759b926b",
            "id": "e2a667fff01500eb3e9307529089fae38f8ffbfdb7afefb552f82585ed918492",
            "metadata": {},
            "name": "useFetchSuggestionCountQuery",
            "operationKind": "query",
            "text": "query useFetchSuggestionCountQuery($cloudId:ID!,$spaceKey:String!){confluence_remoteObjectSuggestionCount(cloudId:$cloudId,spaceKey:$spaceKey)}"
        }
    };
}();
$41493c5c0e5e4e0b$var$node.hash = "b167569d29d494154affeddaea33f5a3";
var $41493c5c0e5e4e0b$export$2e2bcd8739ae039 = $41493c5c0e5e4e0b$var$node;
module.exports["default"] = $41493c5c0e5e4e0b$export$2e2bcd8739ae039;

});

parcelRegister("30Qx8", function(module, exports) {

var $cEGBg = parcelRequire("cEGBg");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/navigation/setting/manifest.ts
var $231a1f3f133ad522$var$navigationSettingAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $cEGBg.NavigationSettingAriResourceOwner),
    resourceType: (0, $cEGBg.NavigationSettingAriResourceType),
    resourceIdSlug: "{firstPartyApp}/{siteId}/{activationId}/{settingId}",
    resourceIdSegmentFormats: {
        firstPartyApp: /[a-z0-9-]{1,100}/,
        siteId: /[a-zA-Z0-9_\-.]{1,255}/,
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        settingId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/navigation/setting/index.ts
var $231a1f3f133ad522$export$d9494d14fa8a72a2 = class _NavigationSettingAri extends (0, $1gKSA.RegisteredAri) {
    get firstPartyApp() {
        return this._firstPartyApp;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get settingId() {
        return this._settingId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $231a1f3f133ad522$var$navigationSettingAriStaticOpts.qualifier,
            platformQualifier: $231a1f3f133ad522$var$navigationSettingAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $231a1f3f133ad522$var$navigationSettingAriStaticOpts.resourceOwner,
            resourceType: $231a1f3f133ad522$var$navigationSettingAriStaticOpts.resourceType,
            resourceId: `${opts.firstPartyApp}/${opts.siteId}/${opts.activationId}/${opts.settingId}`,
            resourceIdSegmentValues: {
                firstPartyApp: opts.firstPartyApp,
                siteId: opts.siteId,
                activationId: opts.activationId,
                settingId: opts.settingId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $231a1f3f133ad522$var$navigationSettingAriStaticOpts);
        return new _NavigationSettingAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $231a1f3f133ad522$var$navigationSettingAriStaticOpts);
        return new _NavigationSettingAri(opts);
    }
    getVariables() {
        return {
            firstPartyApp: this.firstPartyApp,
            siteId: this.siteId,
            activationId: this.activationId,
            settingId: this.settingId
        };
    }
    constructor(opts){
        super(opts), this._firstPartyApp = opts.resourceIdSegmentValues.firstPartyApp, this._siteId = opts.resourceIdSegmentValues.siteId, this._activationId = opts.resourceIdSegmentValues.activationId, this._settingId = opts.resourceIdSegmentValues.settingId;
    }
};
module.exports["NavigationSettingAri"] = $231a1f3f133ad522$export$d9494d14fa8a72a2;

});

parcelRegister("cEGBg", function(module, exports) {
// src/navigation/setting/types.ts
var $936a43f66cf48d67$export$efad67ea8db3f12e = "navigation", $936a43f66cf48d67$export$fd28c74ac3f5b728 = "setting";
module.exports["NavigationSettingAriResourceOwner"] = $936a43f66cf48d67$export$efad67ea8db3f12e;
module.exports["NavigationSettingAriResourceType"] = $936a43f66cf48d67$export$fd28c74ac3f5b728;

});

parcelRegister("dGmBZ", function(module, exports) {
/**
 * @generated SignedSource<<feee02eeb4671c2b8ad67730c80d25ec>>
 * @relayHash 3a2b6de25396328a7215eef4ddb9d1c0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da824bb32521ddcdda62ebc8dbb8760dafd02a73da759678ecb4d940100cf6a0
const $819504ce5ddad46c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLicensed"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "kind": "ScalarField",
        "name": "url"
    }, v5 = {
        "kind": "ScalarField",
        "name": "position"
    }, v6 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v7 = {
        "kind": "ScalarField",
        "name": "path"
    }, v8 = {
        "kind": "ScalarField",
        "name": "type"
    }, v9 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "SpaceSidebarLinks",
            "kind": "LinkedField",
            "name": "spaceSidebarLinks",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "includeHidden",
                            "value": true
                        }
                    ],
                    "concreteType": "SpaceSidebarLink",
                    "kind": "LinkedField",
                    "name": "main",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "webItemKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webItemCompleteKey"
                        },
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "width"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "height"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isDefault"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "iconClass"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hidden"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canHide"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "tooltip"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "linkIdentifier"
                        },
                        v8 /*: any*/ 
                    ],
                    "storageKey": "main(includeHidden:true)"
                },
                {
                    "concreteType": "SpaceSidebarLink",
                    "kind": "LinkedField",
                    "name": "quick",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v3 /*: any*/ ,
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                v8 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "status"
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ 
                    ]
                },
                {
                    "condition": "isLicensed",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "SpaceUserMetadata",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isAdmin"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourited"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isWatched"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "containsExternalCollaborators"
                },
                {
                    "concreteType": "SpaceHistory",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "createdDate"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "didContainUserContent"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SpaceNavigationQuery",
            "selections": v9 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "SpaceNavigationQuery",
            "selections": v9 /*: any*/ 
        },
        "params": {
            "cacheID": "3a2b6de25396328a7215eef4ddb9d1c0",
            "id": "da824bb32521ddcdda62ebc8dbb8760dafd02a73da759678ecb4d940100cf6a0",
            "metadata": {},
            "name": "SpaceNavigationQuery",
            "operationKind": "query",
            "text": "query SpaceNavigationQuery($spaceKey:String,$isLicensed:Boolean!){user:confluence_atlassianUser(current:true){id,confluence{permissionType}},spaceSidebarLinks(spaceKey:$spaceKey){main(includeHidden:true){id,webItemKey,webItemCompleteKey,title,url,position,styleClass,icon{path,width,height,isDefault},iconClass,hidden,canHide,tooltip,linkIdentifier,type},quick{id,url,position,title,styleClass}},space(key:$spaceKey){id,key,name,type,status,icon{path},homepage{id},currentUser@include(if:$isLicensed){isAdmin,isFavourited,isWatched},operations{operation,targetType},containsExternalCollaborators,history{createdDate},didContainUserContent}}"
        }
    };
}();
$819504ce5ddad46c$var$node.hash = "bca4942401246f836068201b36fd61d7";
var $819504ce5ddad46c$export$2e2bcd8739ae039 = $819504ce5ddad46c$var$node;
module.exports["default"] = $819504ce5ddad46c$export$2e2bcd8739ae039;

});

parcelRegister("3AeIf", function(module, exports) {
/**
 * @generated SignedSource<<5ee9a080d233dacfb12ae6bd7fab5fc6>>
 * @relayHash f18661cc7a1d2d55f19018b453d74e49
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5b9f82627568e61d5a48e4bdd045a30d7fc6ac7b992beec39feead5b18838e62
const $ca580f7b974eac2e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "spaceViewsPersistence"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f18661cc7a1d2d55f19018b453d74e49",
            "id": "5b9f82627568e61d5a48e4bdd045a30d7fc6ac7b992beec39feead5b18838e62",
            "metadata": {},
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "operationKind": "query",
            "text": "query useSpaceViewsOptionsPersistenceQuery($spaceKey:String!){userPreferences{spaceViewsPersistence(spaceKey:$spaceKey)}}"
        }
    };
}();
$ca580f7b974eac2e$var$node.hash = "cc599626e8f53c4256f22a11dfce92c8";
var $ca580f7b974eac2e$export$2e2bcd8739ae039 = $ca580f7b974eac2e$var$node;
module.exports["default"] = $ca580f7b974eac2e$export$2e2bcd8739ae039;

});

parcelRegister("e5i8U", function(module, exports) {
/**
 * @generated SignedSource<<a8bfa1759f680b51f3aa57c8dc2881e9>>
 * @relayHash e2df23bdc78f713de65477722c69e437
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a39b7f0aab0b5e8324355dad0345b8cded996fb24379f7510a65f6a6f61c1c54
const $352d8776ce9e612e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceViewsDataSpaceRootQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceViewsDataSpaceRootQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "e2df23bdc78f713de65477722c69e437",
            "id": "a39b7f0aab0b5e8324355dad0345b8cded996fb24379f7510a65f6a6f61c1c54",
            "metadata": {},
            "name": "useSpaceViewsDataSpaceRootQuery",
            "operationKind": "query",
            "text": "query useSpaceViewsDataSpaceRootQuery($spaceKey:String!){space(key:$spaceKey){id,homepage{id},operations{operation,targetType}}}"
        }
    };
}();
$352d8776ce9e612e$var$node.hash = "0fe50aba41f4ffff776e7aeae840f990";
var $352d8776ce9e612e$export$2e2bcd8739ae039 = $352d8776ce9e612e$var$node;
module.exports["default"] = $352d8776ce9e612e$export$2e2bcd8739ae039;

});

parcelRegister("2fQCH", function(module, exports) {
/**
 * @generated SignedSource<<bb240b22e09d0e349cbdc3cc16e0e4d3>>
 * @relayHash 5841807a4e3bf2a59de617588db23f8f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1590a2caf1a18e2c8f39c97c955bfbcd2ed31d253f236ac687f9d10cfa2a64f8
const $3b3e50e8050cb646$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isLivePagesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isWhiteboardsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isDatabasesEnabled"
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "didContainUserContent"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FooterCreateButtonsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FooterCreateButtonsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5841807a4e3bf2a59de617588db23f8f",
            "id": "1590a2caf1a18e2c8f39c97c955bfbcd2ed31d253f236ac687f9d10cfa2a64f8",
            "metadata": {},
            "name": "FooterCreateButtonsQuery",
            "operationKind": "query",
            "text": "query FooterCreateButtonsQuery($spaceKey:String){space(key:$spaceKey){id,key,spaceTypeSettings{enabledContentTypes{isLivePagesEnabled,isWhiteboardsEnabled,isDatabasesEnabled}},didContainUserContent,operations{operation,targetType}}}"
        }
    };
}();
$3b3e50e8050cb646$var$node.hash = "8f908e5cb8da1d069802e69ea3d7f563";
var $3b3e50e8050cb646$export$2e2bcd8739ae039 = $3b3e50e8050cb646$var$node;
module.exports["default"] = $3b3e50e8050cb646$export$2e2bcd8739ae039;

});

parcelRegister("1oGPE", function(module, exports) {
const $00840277cc5ce9b5$export$90091b93f6cf4241 = 80;
const $00840277cc5ce9b5$export$3cf9a7263d7d2d28 = 100; // INITIAL_PAGE_SIZE was previously 160 but we reduced it to 80. Should we also reduce this?
module.exports["INITIAL_PAGE_SIZE"] = $00840277cc5ce9b5$export$90091b93f6cf4241;
module.exports["CHILDREN_PAGE_SIZE"] = $00840277cc5ce9b5$export$3cf9a7263d7d2d28;

});

parcelRegister("9eCf8", function(module, exports) {
/**
 * @generated SignedSource<<8534e239fb0aacc80e873983c931e3ce>>
 * @relayHash 40e147f795d6ae695dc2af4dc7df056c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 689b777212e11a0053f5570d2350dc0482010aee341093c6a0ec7019bd59dc72
const $b0adf32477ccbbfa$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isSuperAdmin"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "paginationLimit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ptStatuses"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v5 = {
        "kind": "Literal",
        "name": "enablePaging",
        "value": true
    }, v6 = {
        "kind": "Variable",
        "name": "pageTree",
        "variableName": "paginationLimit"
    }, v7 = {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
    }, v8 = {
        "kind": "Variable",
        "name": "status",
        "variableName": "ptStatuses"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "title"
    }, v11 = {
        "kind": "ScalarField",
        "name": "status"
    }, v12 = {
        "kind": "ScalarField",
        "name": "value"
    }, v13 = {
        "args": [
            {
                "kind": "Literal",
                "name": "format",
                "value": "MILLIS"
            }
        ],
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdDate",
        "plural": false,
        "selections": [
            v12 /*: any*/ 
        ],
        "storageKey": "createdDate(format:\"MILLIS\")"
    }, v14 = {
        "kind": "ScalarField",
        "name": "hasChildren"
    }, v15 = {
        "kind": "ScalarField",
        "name": "blank"
    }, v16 = {
        "condition": "isSuperAdmin",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasRestrictions"
            },
            {
                "kind": "ScalarField",
                "name": "hasInheritedRestrictions"
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "type"
    }, v18 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v19 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v20 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "emoji-title-draft",
                    "editor"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v9 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    v12 /*: any*/ ,
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "number"
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
    }, v21 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v22 = [
        {
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ 
            ]
        },
        {
            "concreteType": "PTPageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                v21 /*: any*/ 
            ]
        }
    ], v23 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "previousSiblings",
        "plural": false,
        "selections": v22 /*: any*/ 
    }, v24 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "followingSiblings",
        "plural": false,
        "selections": v22 /*: any*/ 
    }, v25 = [
        {
            "alias": "currentPage",
            "args": [
                v5 /*: any*/ ,
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "nearestAncestors",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PTPageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                v21 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ 
                            ]
                        }
                    ]
                },
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": false,
                    "selections": v22 /*: any*/ 
                }
            ]
        },
        {
            "args": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v24 /*: any*/ 
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v9 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PageTreeQuery",
            "selections": v25 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PageTreeQuery",
            "selections": v25 /*: any*/ 
        },
        "params": {
            "cacheID": "40e147f795d6ae695dc2af4dc7df056c",
            "id": "689b777212e11a0053f5570d2350dc0482010aee341093c6a0ec7019bd59dc72",
            "metadata": {},
            "name": "PageTreeQuery",
            "operationKind": "query",
            "text": "query PageTreeQuery($spaceKey:String!,$ptStatuses:[PTGraphQLPageStatus],$contentId:ID!,$paginationLimit:Int,$isSuperAdmin:Boolean!){currentPage:ptpage(id:$contentId,spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},children{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}},ptpage(spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}},space(key:$spaceKey){id,homepage{id},operations{operation,targetType}}}"
        }
    };
}();
$b0adf32477ccbbfa$var$node.hash = "9ca5cb64b6d53c6754a4b7af001ba098";
var $b0adf32477ccbbfa$export$2e2bcd8739ae039 = $b0adf32477ccbbfa$var$node;
module.exports["default"] = $b0adf32477ccbbfa$export$2e2bcd8739ae039;

});

parcelRegister("fL5TY", function(module, exports) {
/**
 * @generated SignedSource<<f44238e1234b91ab73d5297b2f7fc17a>>
 * @relayHash 32d094adde43b53166e21c73e0e18466
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8ba3ae6faaa2b1672d7eef93310782aed4bc09c157af62ec4f49eb5fa49b05db
const $b517e71d543026da$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "endCursor"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orderBy"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "statuses"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "endCursor"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "orderby",
                    "variableName": "orderBy"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "statuses"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "blogpost"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        }
                    ]
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "blank"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "emoji-title-published",
                                        "emoji-title-draft",
                                        "editor"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
                        },
                        {
                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "lastModifiedDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "createdDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "BlogTreeRootComponentQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "BlogTreeRootComponentQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "32d094adde43b53166e21c73e0e18466",
            "id": "8ba3ae6faaa2b1672d7eef93310782aed4bc09c157af62ec4f49eb5fa49b05db",
            "metadata": {},
            "name": "BlogTreeRootComponentQuery",
            "operationKind": "query",
            "text": "query BlogTreeRootComponentQuery($spaceKey:String!,$first:Int,$endCursor:String,$statuses:[String],$orderBy:String){content(spaceKey:$spaceKey,type:\"blogpost\",first:$first,orderby:$orderBy,after:$endCursor,status:$statuses){pageInfo{hasNextPage,endCursor},nodes{id,title,status,blank,properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value}},links{webui},metadata{lastModifiedDate,createdDate}}}}"
        }
    };
}();
$b517e71d543026da$var$node.hash = "dcdc7591048a9e478035919db8a4bcd0";
var $b517e71d543026da$export$2e2bcd8739ae039 = $b517e71d543026da$var$node;
module.exports["default"] = $b517e71d543026da$export$2e2bcd8739ae039;

});

parcelRegister("6DMfJ", function(module, exports) {
const $4d5bd09a97238678$export$e3c11860ad35ba05 = [
    'current',
    'draft'
];
const $4d5bd09a97238678$export$70918a400db2b6af = 'VIRTUAL_ROOT_ID';
const $4d5bd09a97238678$export$8ec3d08588d2eeda = 40;
const $4d5bd09a97238678$export$130b26c73bb9d040 = 16;
module.exports["BLOG_STATUSES"] = $4d5bd09a97238678$export$e3c11860ad35ba05;
module.exports["VIRTUAL_ROOT_ID"] = $4d5bd09a97238678$export$70918a400db2b6af;
module.exports["PAGE_SIZE"] = $4d5bd09a97238678$export$8ec3d08588d2eeda;
module.exports["INDENT_PER_LEVEL"] = $4d5bd09a97238678$export$130b26c73bb9d040;

});

parcelRegister("ivyMZ", function(module, exports) {
var $4eb170397cdf11a9$export$bcac0c74873fee96 = /*#__PURE__*/ function(GraphQLPageStatus) {
    GraphQLPageStatus["CURRENT"] = "CURRENT";
    GraphQLPageStatus["DRAFT"] = "DRAFT";
    return GraphQLPageStatus;
}({});
const $4eb170397cdf11a9$export$48ccce95f626ae31 = [
    "CURRENT",
    "DRAFT"
];
const $4eb170397cdf11a9$export$5522fe3493552101 = [
    'current',
    'draft'
];
module.exports["PAGE_TREE_STATUSES"] = $4eb170397cdf11a9$export$48ccce95f626ae31;

});

parcelRegister("gsSsC", function(module, exports) {
/**
 * @generated SignedSource<<1d6d8b72f5cf1c6f95545e0cb79a843c>>
 * @relayHash 1b389961e5e66b422fc68105162ea2a7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8852b3b3e2fe5695e392f9303e5a9bb51e986824492b6578223f976d6e0fdf05
const $64636a4927b33bd4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAnonymouslyAuthorized"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsUserViewingSpaceAsAnonQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsUserViewingSpaceAsAnonQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1b389961e5e66b422fc68105162ea2a7",
            "id": "8852b3b3e2fe5695e392f9303e5a9bb51e986824492b6578223f976d6e0fdf05",
            "metadata": {},
            "name": "useIsUserViewingSpaceAsAnonQuery",
            "operationKind": "query",
            "text": "query useIsUserViewingSpaceAsAnonQuery($spaceKey:String){space(key:$spaceKey){id,currentUser{isAnonymouslyAuthorized}}}"
        }
    };
}();
$64636a4927b33bd4$var$node.hash = "7c791401f0e963cfa78bdcff70a3c87c";
var $64636a4927b33bd4$export$2e2bcd8739ae039 = $64636a4927b33bd4$var$node;
module.exports["default"] = $64636a4927b33bd4$export$2e2bcd8739ae039;

});

parcelRegister("gRzR4", function(module, exports) {
/**
 * @generated SignedSource<<437e2fd324fdb1225cb122ee838aa6a2>>
 * @relayHash b761690351fd38a63053eefb2d1de3c0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8983e89338e9db4549f597c6a2f7f4aa36777c139be8c74459f3b001a0c76de2
const $7836e6257492ac35$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "generatedBy"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "kind": "ScalarField",
                    "name": "creatorId"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                },
                {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "createdDate"
                        }
                    ]
                },
                {
                    "concreteType": "ContentProperties",
                    "kind": "LinkedField",
                    "name": "contentProperties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "DraftContentProperties",
                            "kind": "LinkedField",
                            "name": "draft",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        },
                        {
                            "concreteType": "PublishedContentProperties",
                            "kind": "LinkedField",
                            "name": "latest",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SmartCreateFeedbackBannerQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SmartCreateFeedbackBannerQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "b761690351fd38a63053eefb2d1de3c0",
            "id": "8983e89338e9db4549f597c6a2f7f4aa36777c139be8c74459f3b001a0c76de2",
            "metadata": {},
            "name": "SmartCreateFeedbackBannerQuery",
            "operationKind": "query",
            "text": "query SmartCreateFeedbackBannerQuery($contentId:ID!){singleContent(id:$contentId){title,id,type,creatorId,version{number},history{createdDate},contentProperties{draft{generatedBy},latest{generatedBy}}}}"
        }
    };
}();
$7836e6257492ac35$var$node.hash = "3b6aed693a868f37a0f80c27a28586a0";
var $7836e6257492ac35$export$2e2bcd8739ae039 = $7836e6257492ac35$var$node;
module.exports["default"] = $7836e6257492ac35$export$2e2bcd8739ae039;

});

parcelRegister("1k2r8", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $8Z78B = parcelRequire("8Z78B");

const $2daa64592339f2ce$export$ce5c629ae8376218 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: []
        },
        __callerPackage__: "onboarding-helpers"
    });
};
module.exports["preloadAllOnboardingState"] = $2daa64592339f2ce$export$ce5c629ae8376218;

});

parcelRegister("dd33Q", function(module, exports) {
/**
 * @generated SignedSource<<79c814000abc51a87825021048515fd1>>
 * @relayHash 10a6e74201e75f7fd05257845e870e22
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5f78c38bf43db12554ba0f37ad39b4afd115d6ef16213fadbd51e8708bc161d2
const $b17ca59e188f1f50$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isBlogsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isDatabasesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isEmbedsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isLivePagesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSlidesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isWhiteboardsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFoldersEnabled"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceEnabledContentTypesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceEnabledContentTypesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "10a6e74201e75f7fd05257845e870e22",
            "id": "5f78c38bf43db12554ba0f37ad39b4afd115d6ef16213fadbd51e8708bc161d2",
            "metadata": {},
            "name": "useSpaceEnabledContentTypesQuery",
            "operationKind": "query",
            "text": "query useSpaceEnabledContentTypesQuery($spaceKey:String){space(key:$spaceKey){id,key,spaceTypeSettings{enabledContentTypes{isBlogsEnabled,isDatabasesEnabled,isEmbedsEnabled,isLivePagesEnabled,isSlidesEnabled,isWhiteboardsEnabled,isFoldersEnabled}}}}"
        }
    };
}();
$b17ca59e188f1f50$var$node.hash = "031eb89bf77537fd501cf18345136db8";
var $b17ca59e188f1f50$export$2e2bcd8739ae039 = $b17ca59e188f1f50$var$node;
module.exports["default"] = $b17ca59e188f1f50$export$2e2bcd8739ae039;

});

parcelRegister("hXDOc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $9wGTI = parcelRequire("9wGTI");

var $b22e252a6b9677fd$export$3c7387d0e5ed624d = /*#__PURE__*/ function(PreloadingMode) {
    PreloadingMode["onlyJS"] = "onlyJS";
    PreloadingMode["onlyJSAndCriticalData"] = "onlyJSAndCriticalData";
    PreloadingMode["everything"] = "everything";
    return PreloadingMode;
}({});
const $b22e252a6b9677fd$var$PRELOAD_TIMER = 100;
const $b22e252a6b9677fd$var$sendAnalyticsEvent = (createAnalyticsEvent, action, name, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'hoverPreloader',
            actionSubjectId: name ?? 'n/a',
            source: 'hoverPreloader',
            attributes: attributes
        }
    }).fire();
};
const $b22e252a6b9677fd$var$preload = (preloadUrl, options = {})=>{
    window.dispatchEvent(new CustomEvent('preloadOnHover', {
        bubbles: true,
        detail: {
            preloadUrl: preloadUrl,
            ...options
        }
    }));
};
const $b22e252a6b9677fd$var$TransitionPreloaderImpl = ({ name: name, children: children, preloadUrl: preloadUrl, preloadOptions: preloadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hoverTimeoutRef = (0, $cozmU.useRef)(null);
    const preloadRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            preloadRef.current = false;
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    // Here we implement multi-stage preloading. JS can be preloaded immediately and unconditionally.
    // For the rest of the preload options / experiments require at least a timeout, but other cases
    // may require more sophisticated logic to decide when or whether to preload.
    const onMouseEnter = (0, $cozmU.useCallback)(()=>{
        preloadRef.current = false;
        $b22e252a6b9677fd$var$preload(preloadUrl, {
            preloadingMode: "onlyJS"
        });
        // Do not proceed to the next stage if only JS preloading is enabled
        if (preloadOptions?.preloadingMode === "onlyJS") return;
        // Trigger next preloading stage either if everything is enabled or if critical data preloading
        // is enabled and the corresponding feature flag is enabled.
        const shouldPreload = preloadOptions?.preloadingMode === "everything" ? true : preloadOptions?.preloadingMode === "onlyJSAndCriticalData" && (0, $9wGTI.fg)('confluence_preload_critical_data');
        if (!shouldPreload) return;
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = window.setTimeout(()=>{
            $b22e252a6b9677fd$var$preload(preloadUrl, preloadOptions);
            preloadRef.current = true;
        }, $b22e252a6b9677fd$var$PRELOAD_TIMER);
    }, [
        preloadUrl,
        preloadOptions
    ]);
    const onMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        if (preloadRef.current) $b22e252a6b9677fd$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', name, {
            preloadingMode: preloadOptions?.preloadingMode
        });
    }, [
        createAnalyticsEvent,
        name,
        preloadOptions?.preloadingMode
    ]);
    const onMouseDown = (0, $cozmU.useCallback)(()=>{
        preloadRef.current = false;
    }, []);
    // Helper to chain child handlers with hover-preloader handlers
    const chain = (...fns)=>(...args)=>{
            fns.forEach((fn)=>{
                if (fn) fn(...args);
            });
        };
    const wrappedChild = /*#__PURE__*/ (0, $cozmU.isValidElement)(children) ? /*#__PURE__*/ (0, $cozmU.cloneElement)(children, {
        onMouseEnter: chain(children.props.onMouseEnter, onMouseEnter),
        onFocus: chain(children.props.onFocus, onMouseEnter),
        onMouseLeave: chain(children.props.onMouseLeave, onMouseLeave),
        onBlur: chain(children.props.onBlur, onMouseLeave),
        onMouseDown: chain(children.props.onMouseDown, onMouseDown)
    }) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-vc": `hover-preloader-${name}`,
        "data-testid": "hover-preloader"
    }, wrappedChild);
};
const $b22e252a6b9677fd$export$16d0fec7f7c7ddfa = (props)=>{
    if (!props.preloadUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};
const $b22e252a6b9677fd$export$f5ad7b1003f136b2 = {
    onlyJS: {
        preloadingMode: "onlyJS"
    },
    onlyJSAndCriticalData: {
        preloadingMode: "onlyJSAndCriticalData"
    },
    everything: {
        preloadingMode: "everything"
    }
};
module.exports["PreloadingMode"] = $b22e252a6b9677fd$export$3c7387d0e5ed624d;
module.exports["HoverPreloader"] = $b22e252a6b9677fd$export$16d0fec7f7c7ddfa;
module.exports["PreloadingPresets"] = $b22e252a6b9677fd$export$f5ad7b1003f136b2;

});

parcelRegister("b2p4s", function(module, exports) {
/**
 * @generated SignedSource<<4e480f3ff7d119a77ec41231b6b4ab42>>
 * @relayHash aa12b95dc97d2068b03de4a55dcec507
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0ef2c27ad493d782c86e25177000afba538c3c0eb50c460bf6d939aa03f2139c
const $ac606d0e22e5c37c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "draftShareId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "editor"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(key:\"editor\")"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "NotFoundContainerQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "NotFoundContainerQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "aa12b95dc97d2068b03de4a55dcec507",
            "id": "0ef2c27ad493d782c86e25177000afba538c3c0eb50c460bf6d939aa03f2139c",
            "metadata": {},
            "name": "NotFoundContainerQuery",
            "operationKind": "query",
            "text": "query NotFoundContainerQuery($contentId:ID!,$draftShareId:String,$status:[String]){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,links{webui},properties(key:\"editor\"){nodes{id,key,value}}}}}"
        }
    };
}();
$ac606d0e22e5c37c$var$node.hash = "df3b0c202e5cf0f97257fa8a583747bc";
var $ac606d0e22e5c37c$export$2e2bcd8739ae039 = $ac606d0e22e5c37c$var$node;
module.exports["default"] = $ac606d0e22e5c37c$export$2e2bcd8739ae039;

});

parcelRegister("gw4Eo", function(module, exports) {

var $1ggpj = parcelRequire("1ggpj");

const $17a724fe65d90332$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ((0, $1ggpj.TYPES_WITH_ACTIVATIONID).includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $17a724fe65d90332$export$6a2f2c83863e9bfe;

});

parcelRegister("axutP", function(module, exports) {
/**
 * @generated SignedSource<<471bd2d51696f1de1dc7d46b066715f5>>
 * @relayHash fa5b50f9c89692d4dd86caf1df42c2d1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 60833378a8743a6756bd6e1c0fa498d563c23b5e85cbe46b5ee3f3b782265d4a
const $972689412971ec2f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "ConfluenceTeamPresence",
            "kind": "LinkedField",
            "name": "confluence_teamPresenceContentSetting",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEnabledOnContentView"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentHeaderPresenceContentSettingsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentHeaderPresenceContentSettingsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "fa5b50f9c89692d4dd86caf1df42c2d1",
            "id": "60833378a8743a6756bd6e1c0fa498d563c23b5e85cbe46b5ee3f3b782265d4a",
            "metadata": {},
            "name": "ContentHeaderPresenceContentSettingsQuery",
            "operationKind": "query",
            "text": "query ContentHeaderPresenceContentSettingsQuery($cloudId:ID!,$spaceKey:String!){confluence_teamPresenceContentSetting(cloudId:$cloudId,spaceKey:$spaceKey){isEnabledOnContentView}}"
        }
    };
}();
$972689412971ec2f$var$node.hash = "d0f958354cdf65029012c243a64d4874";
var $972689412971ec2f$export$2e2bcd8739ae039 = $972689412971ec2f$var$node;
module.exports["default"] = $972689412971ec2f$export$2e2bcd8739ae039;

});

parcelRegister("eoU1C", function(module, exports) {
const $b3332cb66ea1a913$export$7f1c6b461c54348b = {
    DIALOG_SPOTLIGHT_SEEN: 'random:ShareAndRestrictDialog:spotlightSeen',
    PUBLIC_LINK_FOOTER_BUTTON_SEEN: 'ShareAndRestrictDialog:editPublicLinkFooterSpotLightSeen',
    EDIT_PUBLIC_LINK_PERMISSION_SEEN: 'ShareAndRestrictDialog:editPublicLinkPermissionSpotLightSeen',
    GENERAL_AND_SPECIFIC_ACCESS_SEEN: 'ShareAndRestrictDialog:generalAndSpecificAccessSpotLightSeen',
    CTA_NOTIFY_MESSAGE_FOOTER_SEEN: 'ShareAndRestrictDialog:ctaNotifyMessageFooterSpotLightSeen'
};
const $b3332cb66ea1a913$export$e5c211f9c9c7792f = [
    ...Object.values($b3332cb66ea1a913$export$7f1c6b461c54348b)
];
module.exports["ONBOARDING_SHARE_AND_RESTRICT_DIALOG"] = $b3332cb66ea1a913$export$7f1c6b461c54348b;
module.exports["ShareAndRestrictDialogOnboardingKeys"] = $b3332cb66ea1a913$export$e5c211f9c9c7792f;

});

parcelRegister("fsF73", function(module, exports) {
const $29520d740d888926$export$84bb2ff8e52d4c63 = {
    HAS_SEEN_PUBLISH_SPOTLIGHT: 'confluence-recap:hasSeenPublishSpotlight'
};
const $29520d740d888926$export$42e96b8eba35eec9 = [
    ...Object.values($29520d740d888926$export$84bb2ff8e52d4c63)
];
module.exports["CONFLUENCE_RECAP_ONBOARDING_STATE_KEYS"] = $29520d740d888926$export$84bb2ff8e52d4c63;
module.exports["ConfluenceRecapOnboardingKeys"] = $29520d740d888926$export$42e96b8eba35eec9;

});

parcelRegister("ixL26", function(module, exports) {
/**
 * @generated SignedSource<<fbb30a8834043aa8efe95e491818e212>>
 * @relayHash d6be154debcc9cc4834278390fc53126
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2aa0ed74afe3b72eb6db76d715d8da108ed70a4d3568c05987cecb7b3770645b
const $0d2a1fbf3179ce94$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "excludeOperations"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "Theme",
                    "kind": "LinkedField",
                    "name": "theme",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "themeKey"
                        }
                    ]
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "condition": "excludeOperations",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "concreteType": "OperationCheckResult",
                                    "kind": "LinkedField",
                                    "name": "operations",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "operation"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "emoji-title-published"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"emoji-title-published\"])"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SpaceOverviewQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "SpaceOverviewQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "d6be154debcc9cc4834278390fc53126",
            "id": "2aa0ed74afe3b72eb6db76d715d8da108ed70a4d3568c05987cecb7b3770645b",
            "metadata": {},
            "name": "SpaceOverviewQuery",
            "operationKind": "query",
            "text": "query SpaceOverviewQuery($spaceKey:String!,$excludeOperations:Boolean!){space(key:$spaceKey){id,currentUser{isAdmin},name,type,theme{themeKey},icon{path},homepage{id,operations@skip(if:$excludeOperations){operation},properties(keys:[\"emoji-title-published\"]){nodes{id,key,value}}}}}"
        }
    };
}();
$0d2a1fbf3179ce94$var$node.hash = "800c4a5e07b722b2b0e454947ac55f3c";
var $0d2a1fbf3179ce94$export$2e2bcd8739ae039 = $0d2a1fbf3179ce94$var$node;
module.exports["default"] = $0d2a1fbf3179ce94$export$2e2bcd8739ae039;

});

parcelRegister("8Xus6", function(module, exports) {
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $cfd109792a890cba$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'TOML',
        alias: [
            'toml'
        ],
        value: 'toml'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    },
    {
        name: 'Markdown',
        alias: [
            'markdown'
        ],
        value: 'markdown'
    }
];
module.exports["SUPPORTED_LANGUAGES"] = $cfd109792a890cba$export$7c77c3a9bb93870d;

});

parcelRegister("3jRrs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cXtTj = parcelRequire("cXtTj");


var $3PNw6 = parcelRequire("3PNw6");

const $7f8675ab969ce2e0$export$e275bea1043f4431 = ()=>{
    // This explicitly does not fire exposure, in order to prevent a Holdout exposure, which can dilute the Holdout measurement.
    const isInConfluenceHoldout = (0, $cXtTj.default).initializeCompleted() && !(0, $cXtTj.default).checkGate('product-confluence-holdout-observability-gate', {
        fireGateExposure: false
    });
    return {
        holdout: isInConfluenceHoldout ? 'confluence-holdout' : ''
    };
};
const $7f8675ab969ce2e0$export$c7fd2161616b0849 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
        data: $7f8675ab969ce2e0$export$e275bea1043f4431()
    });
};
module.exports["getIsInConfluenceHoldoutData"] = $7f8675ab969ce2e0$export$e275bea1043f4431;

});

parcelRegister("6DT7W", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $8e77e8dd4ed98ba0$export$8e100eba08cca59e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "C9H24",
    name: "RequestAccessPopupComponent",
    loader: async ()=>(await (parcelRequire("3Oija"))).RequestAccessPopupComponent
});
module.exports["RequestAccessPopupComponent"] = $8e77e8dd4ed98ba0$export$8e100eba08cca59e;

});

parcelRegister("3Oija", function(module, exports) {

let $2c643e358e42e420$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2c643e358e42e420$var$load("lk4cE").then(()=>parcelRequire('1hgMC'));

});

parcelRegister("dmDX7", function(module, exports) {

var $7NYI2 = parcelRequire("7NYI2");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");

const $4aa29e57813b75ee$var$UsePendingRequestExistsQuery = (0, $7NYI2.default);
const $4aa29e57813b75ee$export$5354a7f39c2c364a = ({ contentId: contentId, preferPreloadedData: preferPreloadedData = false })=>{
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = !userId || !cloudId || !contentId || !(0, $6mKj3.expValEquals)('confluence_frontend_existing_access_request_checks', 'cohort', 'experiment');
    const [isLoadingForFirstTime, setIsLoadingForFirstTime] = (0, $cozmU.useState)(!shouldSkip);
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($4aa29e57813b75ee$var$UsePendingRequestExistsQuery, {
        variables: {
            cloudId: cloudId,
            accessRequestedAaid: userId ?? '',
            contentId: contentId ?? ''
        },
        skip: shouldSkip,
        fetchPolicy: preferPreloadedData ? 'cache-first' : 'network-only',
        onCompleted: ()=>{
            setIsLoadingForFirstTime(false);
        },
        __callerPackage__: "access-requests"
    });
    // SSR-safe resolution signal, for consumers that render on the server. `true` as soon as the
    // answer is available in the store on the current render — including the server render, when the
    // result was SSR-preloaded and read via `cache-first`. Unlike `isLoadingForFirstTime`, this lets an
    // SSR consumer render the resolved copy directly into the server HTML.
    const isPendingRequestResolvedForSSR = shouldSkip || data !== undefined;
    const pendingRequestExists = Boolean(data?.confluence_pendingRequestExists?.isPendingAccessRequestExists);
    return {
        pendingRequestExists: pendingRequestExists,
        loading: loading,
        error: error,
        isLoadingForFirstTime: isLoadingForFirstTime,
        isPendingRequestResolvedForSSR: isPendingRequestResolvedForSSR
    };
};
module.exports["usePendingRequestExists"] = $4aa29e57813b75ee$export$5354a7f39c2c364a;

});

parcelRegister("7NYI2", function(module, exports) {
/**
 * @generated SignedSource<<4d7ccfc95dff4e3b611db90e9453df55>>
 * @relayHash f8787096f4d42896880d52d9cbd4670c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ca265d253ef91a90727e0b2a379d714b1851230382cb448d534c1124fd0266b9
const $3cde78eca68e7b16$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accessRequestedAaid"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accessRequestedAaid",
                    "variableName": "accessRequestedAaid"
                },
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ConfluencePendingAccessRequest",
            "kind": "LinkedField",
            "name": "confluence_pendingRequestExists",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isPendingAccessRequestExists"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePendingRequestExistsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePendingRequestExistsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f8787096f4d42896880d52d9cbd4670c",
            "id": "ca265d253ef91a90727e0b2a379d714b1851230382cb448d534c1124fd0266b9",
            "metadata": {},
            "name": "usePendingRequestExistsQuery",
            "operationKind": "query",
            "text": "query usePendingRequestExistsQuery($accessRequestedAaid:String!,$cloudId:ID!,$contentId:ID!){confluence_pendingRequestExists(accessRequestedAaid:$accessRequestedAaid,cloudId:$cloudId,contentId:$contentId){isPendingAccessRequestExists}}"
        }
    };
}();
$3cde78eca68e7b16$var$node.hash = "4d877c3ca505e954e3d6f173f1138ce0";
var $3cde78eca68e7b16$export$2e2bcd8739ae039 = $3cde78eca68e7b16$var$node;
module.exports["default"] = $3cde78eca68e7b16$export$2e2bcd8739ae039;

});

parcelRegister("kvJHJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");


var $3PNw6 = parcelRequire("3PNw6");


var $l6Cdg = parcelRequire("l6Cdg");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");


var $2O7Qv = parcelRequire("2O7Qv");


var $18R9N = parcelRequire("18R9N");

const $d2938061b4a1e388$var$noop = ()=>{};
const $d2938061b4a1e388$var$EMBEDDED_PREFIX = 'embedded-';
const $d2938061b4a1e388$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { customData: customData = {}, onComplete: onComplete = $d2938061b4a1e388$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of Props guarantees that exactly one of `metricKey` or `metric`
    // is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$d2938061b4a1e388$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    const stopTimeRef = (0, $cozmU.useRef)(stopTime);
    const customDataRef = (0, $cozmU.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $cozmU.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handleSegmentLoadEnd = (0, $cozmU.useCallback)(()=>{
        onComplete();
        let finalCustomData;
        if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
        else finalCustomData = customDataRef.current;
        (0, $l6Cdg.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${prefixedKey}`);
        (0, $2O7Qv.addCustomTimingForMetric)(prefixedKey);
        (0, $3PNw6.addUFOCustomData)({
            ...finalCustomData,
            viewTransitionSource: (0, $lXYVJ.getViewTransitionSource)(),
            ...typeof stopTimeRef.current === 'number' ? {
                stopTime: stopTimeRef.current
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        });
    }, [
        onComplete,
        prefixedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadEnd, timing);
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
const $d2938061b4a1e388$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($d2938061b4a1e388$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $d2938061b4a1e388$export$a267cdf45880b07b;

});

parcelRegister("2O7Qv", function(module, exports) {

var $a33Aa = parcelRequire("a33Aa");

/**
 * Finds the `segment-start:<metricKey>` and `segment-end:<metricKey>` custom
 * marks in the provided marks array and converts them into a UFO custom timing
 * entry keyed as `wf/react/<metricKey>`.
 */ function $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interactionId, marks, metricKey) {
    let startTime;
    let endTime;
    for (const mark of marks){
        if (mark.type !== 'custom') continue;
        if (mark.name === `segment-start:${metricKey}`) startTime = mark.time;
        else if (mark.name === `segment-end:${metricKey}`) endTime = mark.time;
    }
    if (typeof startTime === 'number' && typeof endTime === 'number') (0, $a33Aa.addCustomTiming)(interactionId, [], {
        [`wf/react/${metricKey}`]: {
            startTime: startTime,
            endTime: endTime
        }
    });
}
function $7bc5b7230c0461d4$export$46796e5c908ea08e(metricKey) {
    const interaction = (0, $a33Aa.getActiveInteraction)();
    if (interaction) $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interaction.id, interaction.marks, metricKey);
}
module.exports["addCustomTimingForMetric"] = $7bc5b7230c0461d4$export$46796e5c908ea08e;

});

parcelRegister("hkzol", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $kTb7m = parcelRequire("kTb7m");


var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $lpNn5 = parcelRequire("lpNn5");


var $9GVkD = parcelRequire("9GVkD");


var $56QzY = parcelRequire("56QzY");


var $6abPE = parcelRequire("6abPE");


var $jooGc = parcelRequire("jooGc");


var $kfIha = parcelRequire("kfIha");

const $5e3895b62fe84f52$var$i18n = (0, $kSwu1.defineMessages)({
    copyLinkLabel: {
        id: "copy-content-link.icon.label",
        defaultMessage: "Copy link"
    },
    copiedTextLabel: {
        id: "copy-content-link.copied.tooltip",
        defaultMessage: "Copied!"
    },
    errorCopyingTextLabel: {
        id: "copy-content-link.error.tooltip",
        defaultMessage: "Something went wrong."
    }
});
const $5e3895b62fe84f52$var$DEFAULT_TOOLTIP_DELAY = 100;
const $5e3895b62fe84f52$var$RESET_COPYTEXT_TIMEOUT = 2500;
const $5e3895b62fe84f52$var$iconButtonAppearances = new Set([
    'default',
    'primary',
    'discovery',
    'subtle'
]);
const $5e3895b62fe84f52$var$formatIconButtonAppearance = (appearance)=>$5e3895b62fe84f52$var$iconButtonAppearances.has(appearance) ? appearance : 'default';
const $5e3895b62fe84f52$export$9957974f8b4d8f74 = 'copyShareLink';
const $5e3895b62fe84f52$export$534d10f1c5b9c7b3 = ({ pageMode: pageMode, contentType: contentType, contentId: contentId, spaceKey: spaceKey, source: source, isDraft: isDraft = false, isLivePage: isLivePage = false, isDisabled: isDisabled = false, shouldResetOnHover: shouldResetOnHover = false, buttonAppearance: buttonAppearance = 'subtle', tooltipPosition: tooltipPosition = 'bottom', buttonText: buttonText = '', copiedTextTooltipLabel: copiedTextTooltipLabel = $5e3895b62fe84f52$var$i18n.copiedTextLabel, onClickAttributes: onClickAttributes, iconColor: iconColor, urlOverride: urlOverride = '' })=>{
    const intl = (0, $kSwu1.useIntl)();
    const cleanupCopiedTimer = (0, $cozmU.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isCopied, setIsCopied] = (0, $cozmU.useState)(false);
    const [errorDuringCopy, setErrorDuringCopy] = (0, $cozmU.useState)();
    const updateTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    // Hook to store copy content link click state
    const { setHasClickedCopyContentLink: setHasClickedCopyContentLink, resetHasClickedCopyContentLink: resetHasClickedCopyContentLink } = (0, $jooGc.useCopyContentLinkActions)();
    const { copyToClipboard: copyToClipboard } = (0, $kfIha.useCopyToClipboard)();
    (0, $cozmU.useEffect)(()=>{
        if (isCopied) cleanupCopiedTimer.current = setTimeout(()=>setIsCopied(false), $5e3895b62fe84f52$var$RESET_COPYTEXT_TIMEOUT);
        return ()=>{
            clearTimeout(cleanupCopiedTimer.current);
        };
    }, [
        isCopied
    ]);
    (0, $cozmU.useEffect)(()=>{
        resetHasClickedCopyContentLink();
    }, [
        resetHasClickedCopyContentLink
    ]);
    const { unsupportedLinkError: unsupportedLinkError, copyContentLink: copyContentLink } = (0, $6abPE.useCopyContentLink)({
        pageMode: pageMode,
        contentType: contentType,
        contentId: contentId,
        spaceKey: spaceKey,
        source: source,
        skip: Boolean(urlOverride)
    });
    const handleCopyLink = async ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: $5e3895b62fe84f52$export$9957974f8b4d8f74,
                source: source,
                attributes: {
                    pageMode: pageMode,
                    contentType: contentType,
                    navdexPointType: (0, $56QzY.END),
                    isDraft: isDraft,
                    isLivePage: isLivePage,
                    ...onClickAttributes ?? {}
                }
            }
        }).fire();
        //mark has copy content link click to true
        setHasClickedCopyContentLink();
        try {
            if (!urlOverride) await copyContentLink();
            else await copyToClipboard(urlOverride);
        } catch (e) {
            setErrorDuringCopy(e);
        }
        setIsCopied(true);
    };
    // report errors from the hook's query silently since we have fallback link retrieval
    // methods, but show user error tooltip text if we actually
    // couldn't get any link to copy or the copy itself failed
    const copyError = unsupportedLinkError || errorDuringCopy;
    const copyLinkText = intl.formatMessage($5e3895b62fe84f52$var$i18n.copyLinkLabel);
    const confirmationText = intl.formatMessage(copyError ? $5e3895b62fe84f52$var$i18n.errorCopyingTextLabel : copiedTextTooltipLabel);
    const onMouseLeave = ()=>{
        if (shouldResetOnHover) setIsCopied(false);
    };
    (0, $cozmU.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        isCopied
    ]);
    const iconButtonAppearance = $5e3895b62fe84f52$var$formatIconButtonAppearance(buttonAppearance);
    const getCopyButton = ()=>buttonText ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            testId: "copy-link-button",
            "aria-label": copyLinkText,
            appearance: buttonAppearance,
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))),
            onClick: handleCopyLink,
            onMouseLeave: onMouseLeave,
            isDisabled: isDisabled
        }, buttonText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            testId: "copy-link-button",
            label: copyLinkText,
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
                    ...iconProps,
                    color: iconColor
                }),
            onClick: handleCopyLink,
            onMouseLeave: onMouseLeave,
            isDisabled: isDisabled,
            appearance: iconButtonAppearance
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), {
        role: "status",
        "aria-live": "assertive",
        "aria-atomic": "true"
    }, isCopied && confirmationText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            if (isCopied) return confirmationText;
            if (buttonText) return buttonText;
            else return copyLinkText;
        },
        position: tooltipPosition,
        ignoreTooltipPointerEvents: true,
        delay: $5e3895b62fe84f52$var$DEFAULT_TOOLTIP_DELAY
    }, getCopyButton()));
};
module.exports["ACTION_SUBJECT_ID"] = $5e3895b62fe84f52$export$9957974f8b4d8f74;
module.exports["CopyLinkButton"] = $5e3895b62fe84f52$export$534d10f1c5b9c7b3;

});

parcelRegister("6abPE", function(module, exports) {

var $2i78V = parcelRequire("2i78V");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $jMyy4 = parcelRequire("jMyy4");


var $1NBp8 = parcelRequire("1NBp8");


var $7zgzO = parcelRequire("7zgzO");


var $hkzol = parcelRequire("hkzol");


var $kfIha = parcelRequire("kfIha");

const $68bb0af1984f782c$var$useCopyContentLinkQuery = (0, $2i78V.default);
const $68bb0af1984f782c$export$a049904f049cf16d = ({ pageMode: pageMode, contentType: contentType, contentId: contentId, spaceKey: spaceKey, source: source, skip: skip = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [unsupportedLinkError, setUnsupportedLinkError] = (0, $cozmU.useState)();
    const { toUrl: toUrl } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { copyToClipboard: copyToClipboard } = (0, $kfIha.useCopyToClipboard)();
    const { data: data, loading: loading, error: queryError } = (0, $jMyy4.useQueryInterop)($68bb0af1984f782c$var$useCopyContentLinkQuery, {
        variables: {
            contentId: contentId || ''
        },
        skip: !contentId || skip,
        __callerPackage__: "copy-content-link"
    });
    const makeContentLink = (0, $cozmU.useCallback)(()=>{
        let copyLink;
        // Try to get the page link from queried data, shortened (for view mode) if possible.
        if (data) {
            const links = data?.singleContent?.links;
            if (pageMode === 'edit') copyLink = links?.editui;
            else // pageMode === "view" OR no page mode specified, eg for whiteboards
            copyLink = links?.tinyui || links?.webui;
            if (copyLink && links?.base) {
                const copyLinkUrl = `${links.base}${copyLink}`;
                return copyLinkUrl;
            }
        }
        // Fallback behavior: Use content type + page mode to construct URL.
        let routeName, additionalParams;
        if (pageMode === 'edit') {
            routeName = contentType === 'blogpost' ? (0, $1NBp8.EDIT_BLOG_V2).name : (0, $1NBp8.EDIT_PAGE_V2).name;
            additionalParams = {
                contentType: // EDIT_BLOG_V2 and EDIT_PAGE_V2 routes expect particular contentType format during route construction
                contentType === 'blogpost' ? 'blog' : 'pages'
            };
        } else switch(contentType){
            case 'overview':
                routeName = (0, $1NBp8.SPACE_OVERVIEW).name;
                break;
            case 'blogpost':
                routeName = (0, $1NBp8.VIEW_BLOG).name;
                break;
            case 'page':
                routeName = (0, $1NBp8.VIEW_PAGE).name;
                break;
            case 'whiteboard':
                routeName = (0, $1NBp8.WHITEBOARD_BOARD).name;
                break;
            case 'slide':
                routeName = (0, $1NBp8.SLIDES_VIEW).name;
                break;
            case 'folder':
                routeName = (0, $1NBp8.FOLDER_VIEW).name;
                break;
            // omit databases and other unsupported content types
            default:
                if (!contentType) // contentType is undefined/empty - this is a data issue, not a
                // truly unsupported type. Return undefined rather than erroring.
                return undefined;
                const error = new Error(`Received an unexpected content type: '${contentType}'`);
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'thrown',
                        actionSubject: 'error',
                        actionSubjectId: (0, $hkzol.ACTION_SUBJECT_ID),
                        source: source,
                        attributes: {
                            error: error?.message,
                            contentType: contentType,
                            pageMode: pageMode
                        }
                    }
                }).fire();
                setUnsupportedLinkError(error);
        }
        if (routeName) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'generated',
                    actionSubject: 'fallbackLink',
                    actionSubjectId: (0, $hkzol.ACTION_SUBJECT_ID),
                    source: source,
                    attributes: {
                        queryError: queryError?.message,
                        isDataLoading: loading,
                        route: routeName
                    }
                }
            }).fire();
            // Omit contentSlug, because user perception is that link sharing
            // is more secure without the content title in the URL.
            const copyLinkUrl = `${window.location.origin}${toUrl(routeName, {
                contentId: contentId,
                spaceKey: spaceKey,
                ...additionalParams
            })}`;
            return copyLinkUrl;
        }
        return undefined;
    }, [
        toUrl,
        contentId,
        contentType,
        spaceKey,
        pageMode,
        source,
        data,
        loading,
        queryError,
        createAnalyticsEvent
    ]);
    const copyContentLink = (0, $cozmU.useCallback)(()=>{
        return copyToClipboard(makeContentLink());
    }, [
        makeContentLink,
        copyToClipboard
    ]);
    return {
        queryError: queryError,
        unsupportedLinkError: unsupportedLinkError,
        makeContentLink: makeContentLink,
        copyContentLink: copyContentLink
    };
};
module.exports["useCopyContentLink"] = $68bb0af1984f782c$export$a049904f049cf16d;

});

parcelRegister("2i78V", function(module, exports) {
/**
 * @generated SignedSource<<0b2f5f44bd64ba7831c6ee7b039fb54f>>
 * @relayHash 29cac5aad51907935410d62eca7f1996
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9e424bd39a886792a42fa3d08fff564fafdbc617d54015972ab0f69de51e1d34
const $77e7fa3fd8a73973$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "tinyui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "base"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCopyContentLinkQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCopyContentLinkQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "29cac5aad51907935410d62eca7f1996",
            "id": "9e424bd39a886792a42fa3d08fff564fafdbc617d54015972ab0f69de51e1d34",
            "metadata": {},
            "name": "useCopyContentLinkQuery",
            "operationKind": "query",
            "text": "query useCopyContentLinkQuery($contentId:ID!){singleContent(id:$contentId){id,links{editui,webui,tinyui,base}}}"
        }
    };
}();
$77e7fa3fd8a73973$var$node.hash = "37d735340f7b52ac7552b4a67a3fb5da";
var $77e7fa3fd8a73973$export$2e2bcd8739ae039 = $77e7fa3fd8a73973$var$node;
module.exports["default"] = $77e7fa3fd8a73973$export$2e2bcd8739ae039;

});

parcelRegister("kfIha", function(module, exports) {
const $3551cf4db632cbd5$var$isClipboardApiSupported = ()=>// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    Boolean(navigator.clipboard && typeof navigator.clipboard.writeText === 'function');
const $3551cf4db632cbd5$export$b2199c37e85de4a7 = ()=>{
    const copyToClipboard = async (value)=>{
        if (value && $3551cf4db632cbd5$var$isClipboardApiSupported()) // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        await navigator.clipboard.writeText(value);
    };
    return {
        copyToClipboard: copyToClipboard
    };
};
module.exports["useCopyToClipboard"] = $3551cf4db632cbd5$export$b2199c37e85de4a7;

});

parcelRegister("jooGc", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $4ca5e403580d1e7d$var$initialState = {
    hasClickedCopyContentLink: false
};
const $4ca5e403580d1e7d$var$actions = {
    setHasClickedCopyContentLink: ()=>({ setState: setState })=>{
            setState({
                hasClickedCopyContentLink: true
            });
        },
    resetHasClickedCopyContentLink: ()=>({ setState: setState })=>{
            setState({
                hasClickedCopyContentLink: false
            });
        }
};
const $4ca5e403580d1e7d$var$CopyContentLinkStore = (0, $8s9DV.createStore)({
    initialState: $4ca5e403580d1e7d$var$initialState,
    actions: $4ca5e403580d1e7d$var$actions,
    name: 'CopyContentLinkStore'
});
const $4ca5e403580d1e7d$export$77cd2a2387f7879a = (0, $kBr4q.createStateHook)($4ca5e403580d1e7d$var$CopyContentLinkStore);
const $4ca5e403580d1e7d$export$c42bcb6cac241c15 = (0, $kBr4q.createActionsHook)($4ca5e403580d1e7d$var$CopyContentLinkStore);
module.exports["useCopyContentLinkActions"] = $4ca5e403580d1e7d$export$c42bcb6cac241c15;

});

parcelRegister("lfFzM", function(module, exports) {

var $6b4nE = parcelRequire("6b4nE");


var $jMyy4 = parcelRequire("jMyy4");


var $6jrkJ = parcelRequire("6jrkJ");


var $hiC7Y = parcelRequire("hiC7Y");

const $f78b3fd6fbd1f922$export$dd53ec461ae8f03e = ()=>{
    // if the claim does not exist, we'll skip doing the actual query
    const hasSuperAdminClaim = (0, $6jrkJ.getSuperAdminClaim)();
    const { loading: loading, error: error, data: data } = (0, $jMyy4.useQueryInterop)((0, $hiC7Y.default), {
        skip: !hasSuperAdminClaim,
        __callerPackage__: "super-admin"
    });
    return hasSuperAdminClaim ? {
        loading: loading,
        error: error,
        isSuperAdmin: Boolean(data?.user?.confluence?.roles?.isSuperAdmin)
    } : {
        loading: false,
        isSuperAdmin: false
    };
};
const $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a = ({ children: children })=>{
    const { isSuperAdmin: isSuperAdmin, loading: loading, error: error } = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e();
    return children({
        loading: loading,
        error: error,
        isSuperAdmin: isSuperAdmin
    });
};
$f78b3fd6fbd1f922$export$a7f16c8c21f70b7a.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired
};
module.exports["useIsSuperAdmin"] = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e;
module.exports["AdminKeyQuery"] = $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a;

});

parcelRegister("hiC7Y", function(module, exports) {
/**
 * @generated SignedSource<<994231445f227a67e1aaccbbe4790b5b>>
 * @relayHash 0f84e07ae7daaa03ff834c7e22000d77
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 54df31e8c4d8a985ea8cf57de4e9987537d70dbc168cfc0cfa0a076f20f53d78
const $55ca182de67fa1f0$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphQLConfluenceUserRoles",
                            "kind": "LinkedField",
                            "name": "roles",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isSuperAdmin"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "IsSuperAdminQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "IsSuperAdminQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "0f84e07ae7daaa03ff834c7e22000d77",
            "id": "54df31e8c4d8a985ea8cf57de4e9987537d70dbc168cfc0cfa0a076f20f53d78",
            "metadata": {},
            "name": "IsSuperAdminQuery",
            "operationKind": "query",
            "text": "query IsSuperAdminQuery{user:confluence_atlassianUser(current:true){id,confluence{roles{isSuperAdmin}}}}"
        }
    };
}();
$55ca182de67fa1f0$var$node.hash = "9aa53dcf116596c8f8285a3aa93878ce";
var $55ca182de67fa1f0$export$2e2bcd8739ae039 = $55ca182de67fa1f0$var$node;
module.exports["default"] = $55ca182de67fa1f0$export$2e2bcd8739ae039;

});

parcelRegister("dwkNQ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $lE63B = parcelRequire("lE63B");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $cDs9S = parcelRequire("cDs9S");


var $ad7Ou = parcelRequire("ad7Ou");


var $kz1Yj = parcelRequire("kz1Yj");


var $2wCqQ = parcelRequire("2wCqQ");


var $buxP3 = parcelRequire("buxP3");


var $3izAL = parcelRequire("3izAL");


var $6Pqow = parcelRequire("6Pqow");


var $arQY7 = parcelRequire("arQY7");


var $i1t43 = parcelRequire("i1t43");


var $bcDqz = parcelRequire("bcDqz");


var $6wGOF = parcelRequire("6wGOF");


var $l9ukq = parcelRequire("l9ukq");


var $ep3mz = parcelRequire("ep3mz");


var $1NBp8 = parcelRequire("1NBp8");


var $iquRY = parcelRequire("iquRY");


var $lsxnT = parcelRequire("lsxnT");


var $fdPUP = parcelRequire("fdPUP");


var $1688F = parcelRequire("1688F");


var $1chEN = parcelRequire("1chEN");


var $3c7da = parcelRequire("3c7da");


var $86H8K = parcelRequire("86H8K");


var $308Wd = parcelRequire("308Wd");

const $a159289724029162$var$ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation = (0, $lE63B.default);
const $a159289724029162$var$i18n = (0, $kSwu1.defineMessages)({
    headingSingleUser: {
        id: "share-and-restrict-dialog.resolve-restricted-access.heading.single-user",
        defaultMessage: "Someone needs additional access"
    },
    headingMultiUser: {
        id: "share-and-restrict-dialog.resolve-restricted-access.heading.multi-user",
        defaultMessage: "Some people need additional access"
    },
    parentAccessBody: {
        id: "share-and-restrict-dialog.resolve-restriction.parent-access.body",
        defaultMessage: "They need access to a parent <resourceLink>{resourceTitle}</resourceLink> first before they can successfully access <bold>{pageTitle}</bold>. They\u2019ll be added with view-only access. <learnMoreLink>Learn more</learnMoreLink>"
    },
    parentAccessRolesRolesUpdateBody: {
        id: "share-and-restrict-dialog.resolve-restriction.parent-access.roles-update.body",
        defaultMessage: "They need access to a parent <resourceLink>{resourceTitle}</resourceLink> first before they can successfully access <bold>{pageTitle}</bold>. They\u2019ll be added with view-only access."
    },
    spaceAccessViewAndEditBody: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.view-and-edit.body",
        defaultMessage: "They need access to the space <resourceLink>{resourceTitle}</resourceLink> first before they can successfully access <bold>{pageTitle}</bold>. They\u2019ll be added with view and edit permissions only. <learnMoreLink>Learn more</learnMoreLink>"
    },
    spaceAccessViewAndEditRolesUpdateBody: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.view-and-edit.roles-update.body",
        defaultMessage: "They need edit access to the space <resourceLink>{resourceTitle}</resourceLink> first before they can successfully edit <bold>{pageTitle}</bold>."
    },
    spaceAccessViewBody: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.view.body",
        defaultMessage: "They need access to the space <resourceLink>{resourceTitle}</resourceLink> first before they can successfully view <bold>{pageTitle}</bold>. They\u2019ll be added with view-only access. <learnMoreLink>Learn more</learnMoreLink>"
    },
    spaceAccessViewRolesUpdateBody: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.view.roles-update.body",
        defaultMessage: "They need view access to the space <resourceLink>{resourceTitle}</resourceLink> first before they can successfully view <bold>{pageTitle}</bold>."
    },
    spaceAccessRoleSelectionForViewAccessBody: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.role-selection-for-view-access.body",
        defaultMessage: "<bold>Role</bold>"
    },
    spaceAccessRoleSelectionForEditAccessBody: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.role-selection-for-edit-access.body",
        defaultMessage: "<bold>Roles that allow editing</bold>"
    },
    skipButton: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.skip-button",
        defaultMessage: "Skip for now"
    },
    addToParentButton: {
        id: "share-and-restrict-dialog.resolve-restriction.parent-access.add-to-parent-button",
        defaultMessage: "Add to parent"
    },
    addToSpaceButton: {
        id: "share-and-restrict-dialog.resolve-restriction.space-access.add-to-space-button",
        defaultMessage: "Add to space"
    },
    addToAllButton: {
        id: "share-and-restrict-dialog.resolve-restriction.add-to-all-button",
        defaultMessage: "Add to all"
    },
    multiUserSpaceViewAndEditBody: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.space.view-and-edit.body",
        defaultMessage: "<bold>{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}</bold> needs specific access in other places first before they can successfully access <bold>{pageTitle}</bold>. They\u2019ll be added with edit access at the space level only. They\u2019ll be added to the parent items with view-only access. <learnMoreLink>Learn more</learnMoreLink>"
    },
    multiUserSpaceViewAndEditRolesUpdateBody: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.space.view-and-edit.roles-update.body",
        defaultMessage: "<bold>{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}</bold> needs specific access in other places first before they can successfully edit <bold>{pageTitle}</bold>. Choose a role they should have in the space. They\u2019ll be added to any parent content with view-only access."
    },
    multiUserParentViewAndEditBody: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.parent.view-and-edit.body",
        defaultMessage: "<bold>{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}</bold> needs specific access in other places first before they can successfully access <bold>{pageTitle}</bold>. They\u2019ll be added to the parent items with view-only access. <learnMoreLink>Learn more</learnMoreLink>"
    },
    multiUserParentViewAndEditRolesUpdateBody: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.parent.view-and-edit.roles-update.body",
        defaultMessage: "<bold>{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}</bold> needs specific access in other places first before they can successfully edit <bold>{pageTitle}</bold>. They\u2019ll be added to any parent items with view-only access."
    },
    multiUserViewBody: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.view.body",
        defaultMessage: "<bold>{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}</bold> needs to be granted view access in other places first before they can successfully view <bold>{pageTitle}</bold>. <learnMoreLink>Learn more</learnMoreLink>"
    },
    multiUserViewRolesUpdateBody: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.view.roles-update.body",
        defaultMessage: "<bold>{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}</bold> needs view access in other places first before they can successfully view <bold>{pageTitle}</bold>. They\u2019ll be added to any parent content with view-only access."
    },
    multiUserViewSpaceIncludedRolesUpdateBody: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.view.space-included.roles-update.body",
        defaultMessage: "<bold>{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}</bold> needs view access in other places first before they can successfully view <bold>{pageTitle}</bold>. Choose a role they should have in the space. They\u2019ll be added to any parent content with view-only access."
    },
    usersNameList: {
        id: "share-and-restrict-dialog.resolve-restriction.multi-user.single-restriction.body",
        defaultMessage: "{usersCount, plural, one {{firstUser}} =2 {{firstUser} and {secondUser}} =3 {{firstUser}, {secondUser}, and {thirdUser}} =4 {{firstUser}, {secondUser}, {thirdUser} and {fourthUser}} other {{firstUser}, {secondUser}, {thirdUser} and {remainingUserCount} others}}"
    },
    errorFlagTitle: {
        id: "share-and-restrict-dialog.resolve-restriction-dialog.error-flag.title",
        defaultMessage: "Can\u2019t add guests"
    },
    errorFlagBodyDescription: {
        id: "share-and-restrict-dialog.resolve-restriction-dialog.error-flag.body",
        defaultMessage: "One or more guests can\u2019t be added to the space because they have access to another space already. Guests can only access one space at a time."
    }
});
const $a159289724029162$var$collaboratorSystemRoleId = '0c103ff5-44d0-4b2a-b80d-8690442c95f0';
const $a159289724029162$var$selectStyle = (0, $buxP3.xcss)({
    width: '150px'
});
const $a159289724029162$var$menuItemStyle = (0, $buxP3.xcss)({
    display: 'flex',
    flexDirection: 'column',
    gap: 'space.050'
});
const $a159289724029162$export$51715d98ed95f9db = (restrictedPrincipals = [])=>{
    const hasSpaceRestriction = restrictedPrincipals.some((principal)=>principal.restrictedResources?.some((resource)=>resource?.resourceType === (0, $1chEN.ResourceType).SPACE));
    const hasParentRestriction = restrictedPrincipals.some((principal)=>principal.restrictedResources?.some((resource)=>resource?.resourceType !== (0, $1chEN.ResourceType).SPACE));
    if (hasSpaceRestriction && hasParentRestriction) return 'space-and-parent';
    else if (hasSpaceRestriction) return 'space';
    else return 'parent';
};
const $a159289724029162$var$hasSpaceRestriction = (restrictedPrincipals = [])=>{
    return restrictedPrincipals.some((principal)=>principal.restrictedResources?.some((resource)=>resource?.resourceType === (0, $1chEN.ResourceType).SPACE));
};
const $a159289724029162$var$mapSpaceRoleToOption = (role)=>({
        id: role?.roleId || '',
        label: role?.roleName || '',
        value: role?.roleId || '',
        description: role?.roleDescription || ''
    });
const $a159289724029162$export$b8299340c4128c03 = (t0)=>{
    const $ = (0, $bDgLe.c)(199);
    const { restrictedUserPrincipals: restrictedUserPrincipals, assignableSpaceRolesIntersection: assignableSpaceRolesIntersection, pageTitle: pageTitle, contentId: contentId, addMode: addMode, onComplete: onComplete, onClose: onClose, onCloseComplete: onCloseComplete, onSkip: onSkip, showErrorFlag: showErrorFlag, triggeredBy: triggeredBy } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const focusRef = (0, $cozmU.useRef)(null);
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== assignableSpaceRolesIntersection) {
        t1 = assignableSpaceRolesIntersection?.map($a159289724029162$var$mapSpaceRoleToOption) || [];
        $[0] = assignableSpaceRolesIntersection;
        $[1] = t1;
    } else t1 = $[1];
    const roleOptions = t1;
    let t2;
    if ($[2] !== roleOptions) {
        t2 = ()=>{
            const collaboratorRole = roleOptions.find($a159289724029162$var$_temp);
            if (collaboratorRole) return collaboratorRole;
            return roleOptions[0] || null;
        };
        $[2] = roleOptions;
        $[3] = t2;
    } else t2 = $[3];
    const [selectedRole, setSelectedRole] = (0, $cozmU.useState)(t2);
    let t3;
    if ($[4] !== onClose || $[5] !== onSkip) {
        t3 = ()=>{
            onSkip();
            onClose?.();
        };
        $[4] = onClose;
        $[5] = onSkip;
        $[6] = t3;
    } else t3 = $[6];
    const onCloseButtonClick = t3;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const usersCount = restrictedUserPrincipals ? restrictedUserPrincipals.length : 0;
    let t4;
    let t5;
    if ($[7] !== createAnalyticsEvent || $[8] !== triggeredBy) {
        t4 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "ResolveRestrictionsDialog",
                    attributes: {
                        source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                        triggeredBy: triggeredBy
                    }
                }
            }).fire();
        };
        t5 = [
            createAnalyticsEvent,
            triggeredBy
        ];
        $[7] = createAnalyticsEvent;
        $[8] = triggeredBy;
        $[9] = t4;
        $[10] = t5;
    } else {
        t4 = $[9];
        t5 = $[10];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[11] !== restrictedUserPrincipals) {
        t6 = restrictedUserPrincipals?.map($a159289724029162$var$_temp2);
        $[11] = restrictedUserPrincipals;
        $[12] = t6;
    } else t6 = $[12];
    const blockedAccessSubjects = t6;
    let t7;
    if ($[13] !== contentType || $[14] !== createAnalyticsEvent || $[15] !== intl || $[16] !== onClose || $[17] !== onComplete || $[18] !== onSkip || $[19] !== restrictedUserPrincipals || $[20] !== showErrorFlag || $[21] !== triggeredBy || $[22] !== usersCount) {
        t7 = (data)=>{
            if (data?.resolveRestrictionsForSubjects?.success) {
                createAnalyticsEvent({
                    type: "sendTrackEvent",
                    data: {
                        source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                        action: "success",
                        actionSubject: "resolveRestrictionsForSubjects",
                        attributes: {
                            blockedUsersCount: usersCount,
                            blockedResourceType: $a159289724029162$export$51715d98ed95f9db(restrictedUserPrincipals),
                            contentType: contentType,
                            triggeredBy: triggeredBy
                        }
                    }
                }).fire();
                setIsLoading(false);
                onComplete();
                onClose?.();
            } else {
                const errors = data?.resolveRestrictionsForSubjects?.errors;
                const isGuestError = errors?.some($a159289724029162$var$_temp3);
                createAnalyticsEvent({
                    type: "sendTrackEvent",
                    data: {
                        source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                        action: "failure",
                        actionSubject: "resolveRestrictionsForSubjects",
                        attributes: {
                            blockedUsersCount: usersCount,
                            blockedResourceType: $a159289724029162$export$51715d98ed95f9db(restrictedUserPrincipals),
                            contentType: contentType,
                            errors: errors,
                            triggeredBy: triggeredBy
                        }
                    }
                }).fire();
                setIsLoading(false);
                if (isGuestError) {
                    showErrorFlag({
                        title: intl.formatMessage($a159289724029162$var$i18n.errorFlagTitle),
                        description: intl.formatMessage($a159289724029162$var$i18n.errorFlagBodyDescription),
                        isAutoDismiss: true
                    });
                    onSkip(isGuestError);
                    onClose?.();
                }
            }
        };
        $[13] = contentType;
        $[14] = createAnalyticsEvent;
        $[15] = intl;
        $[16] = onClose;
        $[17] = onComplete;
        $[18] = onSkip;
        $[19] = restrictedUserPrincipals;
        $[20] = showErrorFlag;
        $[21] = triggeredBy;
        $[22] = usersCount;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== createAnalyticsEvent || $[25] !== triggeredBy) {
        t8 = (error_0)=>{
            createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                    action: "errored",
                    actionSubject: "resolveRestrictionsForSubjects",
                    attributes: {
                        message: error_0?.message,
                        name: error_0?.name,
                        stack: error_0?.stack,
                        cause: error_0?.cause,
                        triggeredBy: triggeredBy
                    }
                }
            }).fire();
            setIsLoading(false);
        };
        $[24] = createAnalyticsEvent;
        $[25] = triggeredBy;
        $[26] = t8;
    } else t8 = $[26];
    let t9;
    if ($[27] !== t7 || $[28] !== t8) {
        t9 = {
            onCompleted: t7,
            onError: t8
        };
        $[27] = t7;
        $[28] = t8;
        $[29] = t9;
    } else t9 = $[29];
    const [resolveRestrictionsForSubjectsMutation] = (0, $308Wd.useMutationInterop)($a159289724029162$var$ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation, {
        ...t9,
        __callerPackage__: "share-and-restrict-dialog"
    });
    let t10;
    if ($[30] !== addMode || $[31] !== blockedAccessSubjects || $[32] !== contentId || $[33] !== contentType || $[34] !== createAnalyticsEvent || $[35] !== resolveRestrictionsForSubjectsMutation || $[36] !== restrictedUserPrincipals || $[37] !== selectedRole?.value || $[38] !== triggeredBy || $[39] !== usersCount) {
        t10 = ()=>{
            setIsLoading(true);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "AddResolveRestrictions",
                    attributes: {
                        blockedUsersCount: usersCount,
                        blockedResourceType: $a159289724029162$export$51715d98ed95f9db(restrictedUserPrincipals),
                        contentType: contentType,
                        triggeredBy: triggeredBy
                    }
                }
            }).fire();
            resolveRestrictionsForSubjectsMutation({
                variables: {
                    contentId: contentId,
                    accessType: addMode == "as-editor" ? (0, $1688F.ResourceAccessType).EDIT : (0, $1688F.ResourceAccessType).VIEW,
                    subjects: blockedAccessSubjects || [],
                    spaceRoleId: selectedRole?.value || null
                }
            });
        };
        $[30] = addMode;
        $[31] = blockedAccessSubjects;
        $[32] = contentId;
        $[33] = contentType;
        $[34] = createAnalyticsEvent;
        $[35] = resolveRestrictionsForSubjectsMutation;
        $[36] = restrictedUserPrincipals;
        $[37] = selectedRole?.value;
        $[38] = triggeredBy;
        $[39] = usersCount;
        $[40] = t10;
    } else t10 = $[40];
    const handleAdd = t10;
    let t11;
    if ($[41] !== contentType || $[42] !== createAnalyticsEvent || $[43] !== onClose || $[44] !== onSkip || $[45] !== restrictedUserPrincipals || $[46] !== triggeredBy || $[47] !== usersCount) {
        t11 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "SkipResolveRestrictions",
                    attributes: {
                        blockedUsersCount: usersCount,
                        blockedResourceType: $a159289724029162$export$51715d98ed95f9db(restrictedUserPrincipals),
                        contentType: contentType,
                        triggeredBy: triggeredBy
                    }
                }
            }).fire();
            onSkip();
            onClose?.();
        };
        $[41] = contentType;
        $[42] = createAnalyticsEvent;
        $[43] = onClose;
        $[44] = onSkip;
        $[45] = restrictedUserPrincipals;
        $[46] = triggeredBy;
        $[47] = usersCount;
        $[48] = t11;
    } else t11 = $[48];
    const handleSkip = t11;
    if (usersCount < 1) return null;
    const isSingleUserAndSingleRestriction = restrictedUserPrincipals?.length == 1 && restrictedUserPrincipals[0].restrictedResources?.length == 1;
    const firstRestriction = restrictedUserPrincipals && restrictedUserPrincipals?.length > 1 && restrictedUserPrincipals[0].restrictedResources?.length == 1 && restrictedUserPrincipals[0].restrictedResources[0];
    const isMultiUserSingleRestriction = !isSingleUserAndSingleRestriction && restrictedUserPrincipals?.every((obj)=>{
        if (obj?.restrictedResources?.length == 1) {
            if (firstRestriction && obj?.restrictedResources[0]?.resourceId == firstRestriction?.resourceId) return true;
        }
        return false;
    });
    let t12;
    if ($[49] !== addMode || $[50] !== isRbacEnabled || $[51] !== restrictedUserPrincipals || $[52] !== roleOptions || $[53] !== selectedRole) {
        t12 = ()=>{
            if (!isRbacEnabled || !$a159289724029162$var$hasSpaceRestriction(restrictedUserPrincipals)) return null;
            const roleSelectionBody = addMode === "as-viewer" ? $a159289724029162$var$i18n.spaceAccessRoleSelectionForViewAccessBody : $a159289724029162$var$i18n.spaceAccessRoleSelectionForEditAccessBody;
            const SELECT_STYLE_PROPS = {
                isSearchable: false,
                menuPortalTarget: document.body,
                styles: {
                    menu: $a159289724029162$var$_temp4,
                    menuPortal: $a159289724029162$var$_temp5
                }
            };
            const CustomSingleValue = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo($a159289724029162$var$_temp6);
            const CustomOption = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo($a159289724029162$var$_temp7);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
                color: "color.text",
                testId: "selectRoleText"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                values: {
                    bold: $a159289724029162$var$_temp8
                },
                ...roleSelectionBody
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $a159289724029162$var$selectStyle
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
                options: roleOptions,
                value: selectedRole,
                onChange: (option)=>setSelectedRole(option),
                components: {
                    SingleValue: CustomSingleValue,
                    Option: CustomOption
                },
                ...SELECT_STYLE_PROPS
            })));
        };
        $[49] = addMode;
        $[50] = isRbacEnabled;
        $[51] = restrictedUserPrincipals;
        $[52] = roleOptions;
        $[53] = selectedRole;
        $[54] = t12;
    } else t12 = $[54];
    const renderSpaceRoleSelector = t12;
    if (isSingleUserAndSingleRestriction) {
        const singleUserPrincipal = restrictedUserPrincipals && restrictedUserPrincipals[0] && restrictedUserPrincipals[0].userPrincipal;
        const singleRestrictedResource = restrictedUserPrincipals && restrictedUserPrincipals[0] && restrictedUserPrincipals[0].restrictedResources && restrictedUserPrincipals[0].restrictedResources[0];
        const t13 = singleRestrictedResource && singleRestrictedResource.resourceLink.base || "";
        const t14 = singleRestrictedResource && singleRestrictedResource.resourceLink.webUi || "";
        let resourceUrl;
        if ($[55] !== t13 || $[56] !== t14) {
            resourceUrl = t13 + t14;
            if ((0, $1NBp8.FOLDER_VIEW).match(resourceUrl)) {
                resourceUrl = resourceUrl + "?referrer=share-and-restrict-dialog";
                resourceUrl;
            }
            $[55] = t13;
            $[56] = t14;
            $[57] = resourceUrl;
        } else resourceUrl = $[57];
        const resourceTitle = singleRestrictedResource && singleRestrictedResource.resourceTitle;
        const spaceAccessViewAndEdit = isRbacEnabled ? $a159289724029162$var$i18n.spaceAccessViewAndEditRolesUpdateBody : $a159289724029162$var$i18n.spaceAccessViewAndEditBody;
        const spaceAccessView = isRbacEnabled ? $a159289724029162$var$i18n.spaceAccessViewRolesUpdateBody : $a159289724029162$var$i18n.spaceAccessViewBody;
        const parentAccessBody = isRbacEnabled ? $a159289724029162$var$i18n.parentAccessRolesRolesUpdateBody : $a159289724029162$var$i18n.parentAccessBody;
        const editorMessage = addMode === "as-editor" ? spaceAccessViewAndEdit : spaceAccessView;
        const singleUserBodyMessageId = singleRestrictedResource && singleRestrictedResource.resourceType == (0, $1chEN.ResourceType).SPACE ? editorMessage : parentAccessBody;
        let t15;
        if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
            t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a159289724029162$var$i18n.headingSingleUser));
            $[58] = t15;
        } else t15 = $[58];
        let t16;
        if ($[59] !== onCloseButtonClick) {
            t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), null, t15, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cDs9S.CloseButton), {
                onClick: onCloseButtonClick
            }));
            $[59] = onCloseButtonClick;
            $[60] = t16;
        } else t16 = $[60];
        const t17 = singleUserPrincipal && singleUserPrincipal.avatarUrl;
        let t18;
        if ($[61] !== t17) {
            t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
                src: t17
            });
            $[61] = t17;
            $[62] = t18;
        } else t18 = $[62];
        const t19 = singleUserPrincipal && singleUserPrincipal.name;
        let t20;
        if ($[63] !== t19) {
            t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
                color: "color.text"
            }, t19);
            $[63] = t19;
            $[64] = t20;
        } else t20 = $[64];
        let t21;
        if ($[65] !== t18 || $[66] !== t20) {
            t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
                space: "space.150",
                alignBlock: "center"
            }, t18, t20);
            $[65] = t18;
            $[66] = t20;
            $[67] = t21;
        } else t21 = $[67];
        let t22;
        if ($[68] !== resourceUrl) {
            t22 = (chunks_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    target: "_blank",
                    href: resourceUrl
                }, chunks_0);
            $[68] = resourceUrl;
            $[69] = t22;
        } else t22 = $[69];
        let t23;
        if ($[70] !== pageTitle || $[71] !== resourceTitle || $[72] !== t22) {
            t23 = {
                pageTitle: pageTitle,
                resourceTitle: resourceTitle,
                resourceLink: t22,
                bold: $a159289724029162$var$_temp9,
                learnMoreLink: (0, $86H8K.LearnMoreChunk)
            };
            $[70] = pageTitle;
            $[71] = resourceTitle;
            $[72] = t22;
            $[73] = t23;
        } else t23 = $[73];
        let t24;
        if ($[74] !== singleUserBodyMessageId || $[75] !== t23) {
            t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                values: t23,
                ...singleUserBodyMessageId
            });
            $[74] = singleUserBodyMessageId;
            $[75] = t23;
            $[76] = t24;
        } else t24 = $[76];
        let t25;
        if ($[77] !== renderSpaceRoleSelector) {
            t25 = renderSpaceRoleSelector();
            $[77] = renderSpaceRoleSelector;
            $[78] = t25;
        } else t25 = $[78];
        let t26;
        if ($[79] !== t21 || $[80] !== t24 || $[81] !== t25) {
            t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
                space: "space.200"
            }, t21, t24, t25));
            $[79] = t21;
            $[80] = t24;
            $[81] = t25;
            $[82] = t26;
        } else t26 = $[82];
        let t27;
        if ($[83] === Symbol.for("react.memo_cache_sentinel")) {
            t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a159289724029162$var$i18n.skipButton);
            $[83] = t27;
        } else t27 = $[83];
        let t28;
        if ($[84] !== handleSkip || $[85] !== isLoading) {
            t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                appearance: "subtle",
                onClick: handleSkip,
                isDisabled: isLoading
            }, t27);
            $[84] = handleSkip;
            $[85] = isLoading;
            $[86] = t28;
        } else t28 = $[86];
        const t29 = singleRestrictedResource && singleRestrictedResource.resourceType == (0, $1chEN.ResourceType).SPACE ? $a159289724029162$var$i18n.addToSpaceButton : $a159289724029162$var$i18n.addToParentButton;
        let t30;
        if ($[87] !== t29) {
            t30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), t29);
            $[87] = t29;
            $[88] = t30;
        } else t30 = $[88];
        let t31;
        if ($[89] !== handleAdd || $[90] !== isLoading || $[91] !== t30) {
            t31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                appearance: "primary",
                onClick: handleAdd,
                ref: focusRef,
                isLoading: isLoading
            }, t30);
            $[89] = handleAdd;
            $[90] = isLoading;
            $[91] = t30;
            $[92] = t31;
        } else t31 = $[92];
        let t32;
        if ($[93] !== t28 || $[94] !== t31) {
            t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, t28, t31);
            $[93] = t28;
            $[94] = t31;
            $[95] = t32;
        } else t32 = $[95];
        let t33;
        if ($[96] !== Modal || $[97] !== onClose || $[98] !== onCloseComplete || $[99] !== t16 || $[100] !== t26 || $[101] !== t32) {
            t33 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
                width: "500px",
                autoFocus: focusRef,
                onClose: onClose,
                onCloseComplete: onCloseComplete,
                testId: "modal-dialog-resolve-restrictions"
            }, t16, t26, t32);
            $[96] = Modal;
            $[97] = onClose;
            $[98] = onCloseComplete;
            $[99] = t16;
            $[100] = t26;
            $[101] = t32;
            $[102] = t33;
        } else t33 = $[102];
        return t33;
    } else if (isMultiUserSingleRestriction) {
        let t13;
        if ($[103] !== restrictedUserPrincipals) {
            t13 = restrictedUserPrincipals ? restrictedUserPrincipals.map($a159289724029162$var$_temp0) : [];
            $[103] = restrictedUserPrincipals;
            $[104] = t13;
        } else t13 = $[104];
        const avatarGroupData = t13;
        const t14 = firstRestriction && firstRestriction.resourceLink.base || "";
        const t15 = firstRestriction && firstRestriction.resourceLink.webUi || "";
        let resourceUrl_0;
        if ($[105] !== t14 || $[106] !== t15) {
            resourceUrl_0 = t14 + t15;
            if ((0, $1NBp8.FOLDER_VIEW).match(resourceUrl_0)) {
                resourceUrl_0 = resourceUrl_0 + "?referrer=share-and-restrict-dialog";
                resourceUrl_0;
            }
            $[105] = t14;
            $[106] = t15;
            $[107] = resourceUrl_0;
        } else resourceUrl_0 = $[107];
        const spaceAccessViewAndEdit_0 = isRbacEnabled ? $a159289724029162$var$i18n.spaceAccessViewAndEditRolesUpdateBody : $a159289724029162$var$i18n.spaceAccessViewAndEditBody;
        const spaceAccessView_0 = isRbacEnabled ? $a159289724029162$var$i18n.spaceAccessViewRolesUpdateBody : $a159289724029162$var$i18n.spaceAccessViewBody;
        const i18nSpaceAccess = addMode === "as-editor" ? spaceAccessViewAndEdit_0 : spaceAccessView_0;
        const parentAccessBody_0 = isRbacEnabled ? $a159289724029162$var$i18n.parentAccessRolesRolesUpdateBody : $a159289724029162$var$i18n.parentAccessBody;
        const multiUserSingleRestrictionBodyMessageId = firstRestriction && firstRestriction.resourceType == (0, $1chEN.ResourceType).SPACE ? i18nSpaceAccess : parentAccessBody_0;
        let t16;
        if ($[108] === Symbol.for("react.memo_cache_sentinel")) {
            t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a159289724029162$var$i18n.headingMultiUser));
            $[108] = t16;
        } else t16 = $[108];
        let t17;
        if ($[109] !== onCloseButtonClick) {
            t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), null, t16, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cDs9S.CloseButton), {
                onClick: onCloseButtonClick
            }));
            $[109] = onCloseButtonClick;
            $[110] = t17;
        } else t17 = $[110];
        let t18;
        if ($[111] !== avatarGroupData) {
            t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bcDqz.default), {
                appearance: "stack",
                data: avatarGroupData,
                maxCount: 4
            });
            $[111] = avatarGroupData;
            $[112] = t18;
        } else t18 = $[112];
        const t19 = restrictedUserPrincipals && restrictedUserPrincipals[0] && restrictedUserPrincipals[0].userPrincipal ? restrictedUserPrincipals[0].userPrincipal.name : null;
        const t20 = restrictedUserPrincipals && restrictedUserPrincipals[1] && restrictedUserPrincipals[1].userPrincipal ? restrictedUserPrincipals[1].userPrincipal.name : null;
        const t21 = restrictedUserPrincipals && restrictedUserPrincipals[2] && restrictedUserPrincipals[2].userPrincipal ? restrictedUserPrincipals[2].userPrincipal.name : null;
        const t22 = restrictedUserPrincipals && restrictedUserPrincipals[3] && restrictedUserPrincipals[3].userPrincipal ? restrictedUserPrincipals[3].userPrincipal.name : null;
        const t23 = usersCount - 3;
        let t24;
        if ($[113] !== t19 || $[114] !== t20 || $[115] !== t21 || $[116] !== t22 || $[117] !== t23 || $[118] !== usersCount) {
            t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
                weight: "bold"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...$a159289724029162$var$i18n.usersNameList,
                values: {
                    usersCount: usersCount,
                    firstUser: t19,
                    secondUser: t20,
                    thirdUser: t21,
                    fourthUser: t22,
                    remainingUserCount: t23
                }
            }));
            $[113] = t19;
            $[114] = t20;
            $[115] = t21;
            $[116] = t22;
            $[117] = t23;
            $[118] = usersCount;
            $[119] = t24;
        } else t24 = $[119];
        let t25;
        if ($[120] !== t18 || $[121] !== t24) {
            t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
                space: "space.100",
                alignBlock: "center"
            }, t18, t24);
            $[120] = t18;
            $[121] = t24;
            $[122] = t25;
        } else t25 = $[122];
        const t26 = firstRestriction && firstRestriction.resourceTitle;
        let t27;
        if ($[123] !== resourceUrl_0) {
            t27 = (chunks_2)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    target: "_blank",
                    href: resourceUrl_0
                }, chunks_2);
            $[123] = resourceUrl_0;
            $[124] = t27;
        } else t27 = $[124];
        let t28;
        if ($[125] !== pageTitle || $[126] !== t26 || $[127] !== t27) {
            t28 = {
                pageTitle: pageTitle,
                resourceTitle: t26,
                resourceLink: t27,
                bold: $a159289724029162$var$_temp1,
                learnMoreLink: (0, $86H8K.LearnMoreChunk)
            };
            $[125] = pageTitle;
            $[126] = t26;
            $[127] = t27;
            $[128] = t28;
        } else t28 = $[128];
        let t29;
        if ($[129] !== multiUserSingleRestrictionBodyMessageId || $[130] !== t28) {
            t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                values: t28,
                ...multiUserSingleRestrictionBodyMessageId
            });
            $[129] = multiUserSingleRestrictionBodyMessageId;
            $[130] = t28;
            $[131] = t29;
        } else t29 = $[131];
        let t30;
        if ($[132] !== renderSpaceRoleSelector) {
            t30 = renderSpaceRoleSelector();
            $[132] = renderSpaceRoleSelector;
            $[133] = t30;
        } else t30 = $[133];
        let t31;
        if ($[134] !== t25 || $[135] !== t29 || $[136] !== t30) {
            t31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
                space: "space.200"
            }, t25, t29, t30));
            $[134] = t25;
            $[135] = t29;
            $[136] = t30;
            $[137] = t31;
        } else t31 = $[137];
        let t32;
        if ($[138] === Symbol.for("react.memo_cache_sentinel")) {
            t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a159289724029162$var$i18n.skipButton);
            $[138] = t32;
        } else t32 = $[138];
        let t33;
        if ($[139] !== handleSkip || $[140] !== isLoading) {
            t33 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                appearance: "subtle",
                onClick: handleSkip,
                isDisabled: isLoading
            }, t32);
            $[139] = handleSkip;
            $[140] = isLoading;
            $[141] = t33;
        } else t33 = $[141];
        const t34 = firstRestriction && firstRestriction.resourceType == (0, $1chEN.ResourceType).SPACE ? $a159289724029162$var$i18n.addToSpaceButton : $a159289724029162$var$i18n.addToParentButton;
        let t35;
        if ($[142] !== t34) {
            t35 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), t34);
            $[142] = t34;
            $[143] = t35;
        } else t35 = $[143];
        let t36;
        if ($[144] !== handleAdd || $[145] !== isLoading || $[146] !== t35) {
            t36 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                appearance: "primary",
                onClick: handleAdd,
                ref: focusRef,
                isLoading: isLoading
            }, t35);
            $[144] = handleAdd;
            $[145] = isLoading;
            $[146] = t35;
            $[147] = t36;
        } else t36 = $[147];
        let t37;
        if ($[148] !== t33 || $[149] !== t36) {
            t37 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, t33, t36);
            $[148] = t33;
            $[149] = t36;
            $[150] = t37;
        } else t37 = $[150];
        let t38;
        if ($[151] !== Modal || $[152] !== onClose || $[153] !== onCloseComplete || $[154] !== t17 || $[155] !== t31 || $[156] !== t37) {
            t38 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
                width: "500px",
                autoFocus: focusRef,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, t17, t31, t37);
            $[151] = Modal;
            $[152] = onClose;
            $[153] = onCloseComplete;
            $[154] = t17;
            $[155] = t31;
            $[156] = t37;
            $[157] = t38;
        } else t38 = $[157];
        return t38;
    } else {
        const hasSpaceRestricted = $a159289724029162$var$hasSpaceRestriction(restrictedUserPrincipals);
        const multiUserSpaceViewAndEdit = isRbacEnabled ? $a159289724029162$var$i18n.multiUserSpaceViewAndEditRolesUpdateBody : $a159289724029162$var$i18n.multiUserSpaceViewAndEditBody;
        const multiUserParentViewAndEditBody = isRbacEnabled ? $a159289724029162$var$i18n.multiUserParentViewAndEditRolesUpdateBody : $a159289724029162$var$i18n.multiUserParentViewAndEditBody;
        const multiUserViewAndEditI18n = hasSpaceRestricted ? multiUserSpaceViewAndEdit : multiUserParentViewAndEditBody;
        const multiUserViewRolesUpdateBody = hasSpaceRestricted ? $a159289724029162$var$i18n.multiUserViewSpaceIncludedRolesUpdateBody : $a159289724029162$var$i18n.multiUserViewRolesUpdateBody;
        const multiUserViewBody = isRbacEnabled ? multiUserViewRolesUpdateBody : $a159289724029162$var$i18n.multiUserViewBody;
        const multiUsersBodyMessageId = addMode === "as-editor" ? multiUserViewAndEditI18n : multiUserViewBody;
        const isSingleUser = restrictedUserPrincipals?.length === 1;
        const modalHeight = isSingleUser ? "inherit" : "600px";
        let t13;
        if ($[158] === Symbol.for("react.memo_cache_sentinel")) {
            t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a159289724029162$var$i18n.headingSingleUser));
            $[158] = t13;
        } else t13 = $[158];
        let t14;
        if ($[159] !== onCloseButtonClick) {
            t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), null, t13, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cDs9S.CloseButton), {
                onClick: onCloseButtonClick
            }));
            $[159] = onCloseButtonClick;
            $[160] = t14;
        } else t14 = $[160];
        const t15 = restrictedUserPrincipals && restrictedUserPrincipals[0] && restrictedUserPrincipals[0].userPrincipal ? restrictedUserPrincipals[0].userPrincipal.name : null;
        const t16 = restrictedUserPrincipals && restrictedUserPrincipals[1] && restrictedUserPrincipals[1].userPrincipal ? restrictedUserPrincipals[1].userPrincipal.name : null;
        const t17 = restrictedUserPrincipals && restrictedUserPrincipals[2] && restrictedUserPrincipals[2].userPrincipal ? restrictedUserPrincipals[2].userPrincipal.name : null;
        const t18 = restrictedUserPrincipals && restrictedUserPrincipals[3] && restrictedUserPrincipals[3].userPrincipal ? restrictedUserPrincipals[3].userPrincipal.name : null;
        const t19 = usersCount - 3;
        let t20;
        if ($[161] !== pageTitle || $[162] !== t15 || $[163] !== t16 || $[164] !== t17 || $[165] !== t18 || $[166] !== t19 || $[167] !== usersCount) {
            t20 = {
                usersCount: usersCount,
                firstUser: t15,
                secondUser: t16,
                thirdUser: t17,
                fourthUser: t18,
                remainingUserCount: t19,
                pageTitle: pageTitle,
                bold: $a159289724029162$var$_temp10,
                learnMoreLink: (0, $86H8K.LearnMoreChunk)
            };
            $[161] = pageTitle;
            $[162] = t15;
            $[163] = t16;
            $[164] = t17;
            $[165] = t18;
            $[166] = t19;
            $[167] = usersCount;
            $[168] = t20;
        } else t20 = $[168];
        let t21;
        if ($[169] !== multiUsersBodyMessageId || $[170] !== t20) {
            t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
                space: "space.100",
                alignBlock: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...multiUsersBodyMessageId,
                values: t20
            })));
            $[169] = multiUsersBodyMessageId;
            $[170] = t20;
            $[171] = t21;
        } else t21 = $[171];
        let t22;
        if ($[172] !== renderSpaceRoleSelector) {
            t22 = renderSpaceRoleSelector();
            $[172] = renderSpaceRoleSelector;
            $[173] = t22;
        } else t22 = $[173];
        let t23;
        if ($[174] !== restrictedUserPrincipals) {
            t23 = restrictedUserPrincipals && restrictedUserPrincipals.map($a159289724029162$var$_temp11);
            $[174] = restrictedUserPrincipals;
            $[175] = t23;
        } else t23 = $[175];
        let t24;
        if ($[176] !== t21 || $[177] !== t22 || $[178] !== t23) {
            t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
                space: "space.200"
            }, t21, t22, t23));
            $[176] = t21;
            $[177] = t22;
            $[178] = t23;
            $[179] = t24;
        } else t24 = $[179];
        let t25;
        if ($[180] === Symbol.for("react.memo_cache_sentinel")) {
            t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a159289724029162$var$i18n.skipButton);
            $[180] = t25;
        } else t25 = $[180];
        let t26;
        if ($[181] !== handleSkip || $[182] !== isLoading) {
            t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                appearance: "subtle",
                onClick: handleSkip,
                isDisabled: isLoading
            }, t25);
            $[181] = handleSkip;
            $[182] = isLoading;
            $[183] = t26;
        } else t26 = $[183];
        let t27;
        if ($[184] === Symbol.for("react.memo_cache_sentinel")) {
            t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $a159289724029162$var$i18n.addToAllButton);
            $[184] = t27;
        } else t27 = $[184];
        let t28;
        if ($[185] !== handleAdd || $[186] !== isLoading) {
            t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                appearance: "primary",
                onClick: handleAdd,
                ref: focusRef,
                isLoading: isLoading
            }, t27);
            $[185] = handleAdd;
            $[186] = isLoading;
            $[187] = t28;
        } else t28 = $[187];
        let t29;
        if ($[188] !== t26 || $[189] !== t28) {
            t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, t26, t28);
            $[188] = t26;
            $[189] = t28;
            $[190] = t29;
        } else t29 = $[190];
        let t30;
        if ($[191] !== Modal || $[192] !== modalHeight || $[193] !== onClose || $[194] !== onCloseComplete || $[195] !== t14 || $[196] !== t24 || $[197] !== t29) {
            t30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
                width: "500px",
                height: modalHeight,
                autoFocus: focusRef,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, t14, t24, t29);
            $[191] = Modal;
            $[192] = modalHeight;
            $[193] = onClose;
            $[194] = onCloseComplete;
            $[195] = t14;
            $[196] = t24;
            $[197] = t29;
            $[198] = t30;
        } else t30 = $[198];
        return t30;
    }
};
function $a159289724029162$var$_temp(role) {
    return role.id === $a159289724029162$var$collaboratorSystemRoleId;
}
function $a159289724029162$var$_temp2(user) {
    const blockedAccessSubject = {
        subjectId: user?.userPrincipal?.id || "",
        subjectType: (0, $1688F.BlockedAccessSubjectType).USER
    };
    return blockedAccessSubject;
}
function $a159289724029162$var$_temp3(error) {
    return error.message === "ExcoSingleSpaceException: Failed to save permission for guest: guest already has access to another space";
}
function $a159289724029162$var$_temp4(base) {
    return {
        ...base,
        width: "320px"
    };
}
function $a159289724029162$var$_temp5(base_0) {
    return {
        ...base_0,
        zIndex: 600
    };
}
function $a159289724029162$var$_temp6(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).SingleValue, props, props.data.label);
}
function $a159289724029162$var$_temp7(props_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Option, props_0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $a159289724029162$var$menuItemStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), null, props_0.data.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        color: "color.text.subtlest"
    }, props_0.data.description)));
}
function $a159289724029162$var$_temp8(chunks) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks);
}
function $a159289724029162$var$_temp9(chunks_1) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks_1);
}
function $a159289724029162$var$_temp0(user_0) {
    return {
        key: user_0?.userPrincipal?.email || "",
        name: user_0?.userPrincipal?.name || "",
        href: "#",
        src: user_0?.userPrincipal?.avatarUrl || ""
    };
}
function $a159289724029162$var$_temp1(chunks_3) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks_3);
}
function $a159289724029162$var$_temp10(chunk) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        weight: "bold"
    }, chunk);
}
function $a159289724029162$var$_temp11(user_1) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        space: "space.050",
        key: user_1.userPrincipal?.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("hr", {
        role: "presentation",
        style: {
            width: "100%"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        key: user_1.userPrincipal?.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3c7da.RestrictedUserResourcesDetails), {
        user: user_1.userPrincipal,
        restrictedResources: user_1.restrictedResources
    })));
}
module.exports["getBlockedResourceTypes"] = $a159289724029162$export$51715d98ed95f9db;
module.exports["ResolveRestrictionsDialog"] = $a159289724029162$export$b8299340c4128c03;

});

parcelRegister("lE63B", function(module, exports) {
/**
 * @generated SignedSource<<afc4af36bdf034eb86c1019158a0b4ef>>
 * @relayHash 4a516532f481795a6fb98a0e01c981b9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3fb282db83bed282d73474fa53054acdf7c575da6ffa5d4a3dec565ba86c9898
const $94aa94c1917f6c40$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "accessType"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceRoleId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "subjects"
    }, v4 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "accessType",
                            "variableName": "accessType"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceRoleId",
                            "variableName": "spaceRoleId"
                        },
                        {
                            "kind": "Variable",
                            "name": "subjects",
                            "variableName": "subjects"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "ResolveRestrictionsPayload",
            "kind": "LinkedField",
            "name": "resolveRestrictionsForSubjects",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation",
            "selections": v4 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "4a516532f481795a6fb98a0e01c981b9",
            "id": "3fb282db83bed282d73474fa53054acdf7c575da6ffa5d4a3dec565ba86c9898",
            "metadata": {},
            "name": "ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation",
            "operationKind": "mutation",
            "text": "mutation ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation($accessType:ResourceAccessType!,$contentId:Long!,$subjects:[BlockedAccessSubjectInput]!,$spaceRoleId:ID){resolveRestrictionsForSubjects(input:{accessType:$accessType,contentId:$contentId,subjects:$subjects,spaceRoleId:$spaceRoleId}){success,errors{message}}}"
        }
    };
}();
$94aa94c1917f6c40$var$node.hash = "ff5bb2cdac9b46578fa9fdfee10454ed";
var $94aa94c1917f6c40$export$2e2bcd8739ae039 = $94aa94c1917f6c40$var$node;
module.exports["default"] = $94aa94c1917f6c40$export$2e2bcd8739ae039;

});

parcelRegister("fdPUP", function(module, exports) {
const $73fa77a308d85fef$export$219d516b185caa05 = 'ShareAndRestrictDialog';
const $73fa77a308d85fef$export$da7d900b1da56fbf = 'share-and-restrict-dialog-user-picker-input';
const $73fa77a308d85fef$export$3f89eb51f735e9b3 = [
    'page'
];
const $73fa77a308d85fef$export$b1e4cd5fa4074c7a = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions';
const $73fa77a308d85fef$export$ce504fce6cf8855f = 'https://support.atlassian.com/confluence-cloud/docs/manage-permissions-on-the-page-level/';
module.exports["SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE"] = $73fa77a308d85fef$export$219d516b185caa05;
module.exports["USER_PICKER_INPUT_ID"] = $73fa77a308d85fef$export$da7d900b1da56fbf;
module.exports["ACCESS_LINK_ENROLLED_CONTENT_TYPES"] = $73fa77a308d85fef$export$3f89eb51f735e9b3;
module.exports["SAC_CONTENT_PERMS_MANAGEMENT_DOCUMENTATION"] = $73fa77a308d85fef$export$ce504fce6cf8855f;

});

parcelRegister("1688F", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $1565541f45629689$export$43eb1e191ddb78c0 = /*#__PURE__*/ function(BlockedAccessSubjectType) {
    BlockedAccessSubjectType["GROUP"] = "GROUP";
    BlockedAccessSubjectType["USER"] = "USER";
    return BlockedAccessSubjectType;
}({});
var $1565541f45629689$export$8e7b7bb509dc942b = /*#__PURE__*/ function(ResourceAccessType) {
    ResourceAccessType["EDIT"] = "EDIT";
    ResourceAccessType["VIEW"] = "VIEW";
    return ResourceAccessType;
}({});
module.exports["BlockedAccessSubjectType"] = $1565541f45629689$export$43eb1e191ddb78c0;
module.exports["ResourceAccessType"] = $1565541f45629689$export$8e7b7bb509dc942b;

});

parcelRegister("1chEN", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $597ccb3a2cb4013d$export$43eb1e191ddb78c0 = /*#__PURE__*/ function(BlockedAccessSubjectType) {
    BlockedAccessSubjectType["GROUP"] = "GROUP";
    BlockedAccessSubjectType["USER"] = "USER";
    return BlockedAccessSubjectType;
}({});
var $597ccb3a2cb4013d$export$8e7b7bb509dc942b = /*#__PURE__*/ function(ResourceAccessType) {
    ResourceAccessType["EDIT"] = "EDIT";
    ResourceAccessType["VIEW"] = "VIEW";
    return ResourceAccessType;
}({});
var $597ccb3a2cb4013d$export$c6f9da6f70cfc2eb = /*#__PURE__*/ function(ResourceType) {
    ResourceType["DATABASE"] = "DATABASE";
    ResourceType["FOLDER"] = "FOLDER";
    ResourceType["PAGE"] = "PAGE";
    ResourceType["SPACE"] = "SPACE";
    ResourceType["WHITEBOARD"] = "WHITEBOARD";
    return ResourceType;
}({});
var $597ccb3a2cb4013d$export$69bdd9d16ab8ed0f = /*#__PURE__*/ function(SpaceRoleType) {
    SpaceRoleType["CUSTOM"] = "CUSTOM";
    SpaceRoleType["SYSTEM"] = "SYSTEM";
    return SpaceRoleType;
}({});
module.exports["ResourceType"] = $597ccb3a2cb4013d$export$c6f9da6f70cfc2eb;

});

parcelRegister("3c7da", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $arQY7 = parcelRequire("arQY7");


var $4efpo = parcelRequire("4efpo");


var $2hJf7 = parcelRequire("2hJf7");


var $lBKFk = parcelRequire("lBKFk");


var $bDjVc = parcelRequire("bDjVc");


var $hMaHH = parcelRequire("hMaHH");


var $I7hWB = parcelRequire("I7hWB");


var $iKskQ = parcelRequire("iKskQ");

const $c3b447d238ca71b0$var$i18n = (0, $kSwu1.defineMessages)({
    needsAccess: {
        id: "share-and-restrict-dialog.restricted-user-resources-details.needs-access",
        defaultMessage: "needs access in {resourcesCount} {resourcesCount, plural, one {place} other {places}}:"
    },
    space: {
        id: "share-and-restrict-dialog.restricted-user-resources-details.space",
        defaultMessage: "Space"
    },
    parentItems: {
        id: "share-and-restrict-dialog.restricted-user-resources-details.parent-items",
        defaultMessage: "Parent items"
    }
});
const $c3b447d238ca71b0$var$getContenTypeIcon = (type)=>{
    switch(type){
        case 'DATABASE':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))), {
                label: "Databse"
            });
        case 'WHITEBOARD':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))), {
                label: "Whiteboard"
            });
        case 'PAGE':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
                label: "Page"
            });
        case 'FOLDER':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))), {
                label: "Page"
            });
        case 'SPACE':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKskQ.SpaceIcon), {
                size: "xsmall",
                src: "/images/logo/default-space-logo-256.png"
            });
    }
};
const $c3b447d238ca71b0$var$SingleResourcesDetails = (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { restrictedResource: restrictedResource, showLock: showLock } = t0;
    let t1;
    if ($[0] !== showLock) {
        t1 = showLock ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4efpo))), {
            label: "",
            color: "var(--ds-icon-danger, #C9372C)"
        }) : null;
        $[0] = showLock;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== restrictedResource) {
        t2 = restrictedResource && $c3b447d238ca71b0$var$getContenTypeIcon(restrictedResource.resourceType);
        $[2] = restrictedResource;
        $[3] = t2;
    } else t2 = $[3];
    const t3 = restrictedResource ? restrictedResource.resourceTitle : "";
    let t4;
    if ($[4] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            color: "color.text.subtle"
        }, t3);
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t1 || $[7] !== t2 || $[8] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            space: "space.150",
            alignBlock: "center"
        }, t1, t2, t4);
        $[6] = t1;
        $[7] = t2;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
};
const $c3b447d238ca71b0$export$c6de5a3e56b68494 = (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { user: user, restrictedResources: restrictedResources } = t0;
    let t1;
    if ($[0] !== restrictedResources) {
        t1 = restrictedResources && restrictedResources.filter($c3b447d238ca71b0$var$_temp);
        $[0] = restrictedResources;
        $[1] = t1;
    } else t1 = $[1];
    const resourcesWithoutSpace = t1;
    let t2;
    if ($[2] !== restrictedResources) {
        t2 = restrictedResources && restrictedResources.filter($c3b447d238ca71b0$var$_temp2);
        $[2] = restrictedResources;
        $[3] = t2;
    } else t2 = $[3];
    const restrictedSpaces = t2;
    const resourcesWithoutSpaceCount = resourcesWithoutSpace ? resourcesWithoutSpace.length : 0;
    const restrictedSpacesCount = restrictedSpaces ? restrictedSpaces.length : 0;
    const resourcesCount = resourcesWithoutSpaceCount + restrictedSpacesCount;
    const t3 = user && user.avatarUrl;
    let t4;
    if ($[4] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            src: t3
        });
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    const t5 = user && user.name;
    let t6;
    if ($[6] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            color: "color.text",
            weight: "bold"
        }, t5);
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== resourcesCount) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            values: {
                resourcesCount: resourcesCount
            },
            ...$c3b447d238ca71b0$var$i18n.needsAccess
        });
        $[8] = resourcesCount;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== t4 || $[11] !== t6 || $[12] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            space: "space.050",
            alignBlock: "center"
        }, t4, t6, t7);
        $[10] = t4;
        $[11] = t6;
        $[12] = t7;
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== restrictedSpaces) {
        t9 = restrictedSpaces && restrictedSpaces.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            space: "space.100",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xxsmall",
            as: "h2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c3b447d238ca71b0$var$i18n.space)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            paddingInlineStart: "space.150"
        }, restrictedSpaces.map($c3b447d238ca71b0$var$_temp3))) : null;
        $[14] = restrictedSpaces;
        $[15] = t9;
    } else t9 = $[15];
    let t10;
    if ($[16] !== resourcesWithoutSpace) {
        t10 = resourcesWithoutSpace && resourcesWithoutSpace.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            space: "space.200",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xxsmall",
            as: "h2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $c3b447d238ca71b0$var$i18n.parentItems)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            paddingInlineStart: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            space: "space.200",
            alignBlock: "center"
        }, resourcesWithoutSpace.map($c3b447d238ca71b0$var$_temp4)))) : null;
        $[16] = resourcesWithoutSpace;
        $[17] = t10;
    } else t10 = $[17];
    let t11;
    if ($[18] !== t10 || $[19] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            paddingInlineStart: "space.500"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            space: "space.200",
            alignBlock: "center"
        }, t9, t10));
        $[18] = t10;
        $[19] = t9;
        $[20] = t11;
    } else t11 = $[20];
    let t12;
    if ($[21] !== t11 || $[22] !== t8) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            space: "space.150"
        }, t8, t11);
        $[21] = t11;
        $[22] = t8;
        $[23] = t12;
    } else t12 = $[23];
    return t12;
};
function $c3b447d238ca71b0$var$_temp(resource) {
    if (resource?.resourceType === "SPACE") return false;
    return true;
}
function $c3b447d238ca71b0$var$_temp2(resource_0) {
    if (resource_0?.resourceType === "SPACE") return true;
    return false;
}
function $c3b447d238ca71b0$var$_temp3(resource_1) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3b447d238ca71b0$var$SingleResourcesDetails, {
        restrictedResource: resource_1,
        showLock: false,
        key: resource_1?.resourceId
    });
}
function $c3b447d238ca71b0$var$_temp4(resource_2) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c3b447d238ca71b0$var$SingleResourcesDetails, {
        restrictedResource: resource_2,
        showLock: true,
        key: resource_2?.resourceId
    });
}
module.exports["RestrictedUserResourcesDetails"] = $c3b447d238ca71b0$export$c6de5a3e56b68494;

});

parcelRegister("iKskQ", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $krxYo = parcelRequire("krxYo");


var $iITVA = parcelRequire("iITVA");

const $b378bfc9d198c46c$var$spaceImgStyles = {
    default: "_19itidpf _1o9zidpf _bfhkizff",
    loaded: "_bfhk1j28"
};
const $b378bfc9d198c46c$var$AvatarStyles = {
    xsmall: "_2rko12b0 _1bsbgktf _4t3igktf",
    small: "_2rkolb4i _1bsb1tcg _4t3i1tcg",
    medium: "_2rkofajl _1bsbzwfg _4t3izwfg",
    large: "_2rkofajl _1bsb1ylp _4t3i1ylp",
    xlarge: "_2rko1qi0 _1bsb16xz _4t3i16xz"
};
const $b378bfc9d198c46c$export$b14ad400b1d09e0f = {
    global: (0, (/*@__PURE__*/$parcel$interopDefault($krxYo))),
    personal: (0, (/*@__PURE__*/$parcel$interopDefault($iITVA)))
};
const $b378bfc9d198c46c$export$38ffce4a7986ba20 = /*#__PURE__*/ (0, $cozmU.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { type: type, label: t1, size: t2, src: src, testId: testId } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const [imgLoaded, setImgLoaded] = (0, $cozmU.useState)(!src);
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setImgLoaded(true);
        };
        $[0] = t3;
    } else t3 = $[0];
    const setLoaded = t3;
    if (src) {
        const t4 = src?.includes("/wiki") || src?.startsWith("http") ? src : `/wiki${src}`;
        const t5 = imgLoaded && $b378bfc9d198c46c$var$spaceImgStyles.loaded;
        const t6 = $b378bfc9d198c46c$var$AvatarStyles[size];
        let t7;
        if ($[1] !== t5 || $[2] !== t6) {
            t7 = (0, $hekY6.default)([
                $b378bfc9d198c46c$var$spaceImgStyles["default"],
                t5,
                t6
            ]);
            $[1] = t5;
            $[2] = t6;
            $[3] = t7;
        } else t7 = $[3];
        let t8;
        if ($[4] !== label || $[5] !== t4 || $[6] !== t7 || $[7] !== testId) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
                src: t4,
                alt: label,
                onLoad: setLoaded,
                onError: setLoaded,
                "data-testid": testId,
                className: t7
            });
            $[4] = label;
            $[5] = t4;
            $[6] = t7;
            $[7] = testId;
            $[8] = t8;
        } else t8 = $[8];
        return t8;
    }
    const Icon = type && $b378bfc9d198c46c$export$b14ad400b1d09e0f[type] || (0, (/*@__PURE__*/$parcel$interopDefault($krxYo)));
    let t4;
    if ($[9] !== Icon || $[10] !== label || $[11] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: label,
            testId: testId
        });
        $[9] = Icon;
        $[10] = label;
        $[11] = testId;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : ({ type: type, label: label = '', size: size = 'medium', src: src, testId: testId })=>{
    const [imgLoaded, setImgLoaded] = (0, $cozmU.useState)(!src);
    const setLoaded = (0, $cozmU.useCallback)(()=>{
        setImgLoaded(true);
    }, [
        setImgLoaded
    ]);
    if (src) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: src?.includes('/wiki') || src?.startsWith('http') ? src : `/wiki${src}`,
        alt: label,
        onLoad: setLoaded,
        onError: setLoaded,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $b378bfc9d198c46c$var$spaceImgStyles['default'],
            imgLoaded && $b378bfc9d198c46c$var$spaceImgStyles['loaded'],
            $b378bfc9d198c46c$var$AvatarStyles[size]
        ])
    });
    const Icon = type && $b378bfc9d198c46c$export$b14ad400b1d09e0f[type] || (0, (/*@__PURE__*/$parcel$interopDefault($krxYo)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        label: label,
        testId: testId
    });
});
module.exports["SpaceIcon"] = $b378bfc9d198c46c$export$38ffce4a7986ba20;

});

parcelRegister("86H8K", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $i1t43 = parcelRequire("i1t43");


var $9DHhW = parcelRequire("9DHhW");


var $fdPUP = parcelRequire("fdPUP");

const $09f2383e12028cd7$var$SAC_LEARN_MORE_DOCUMENTATION = 'https://support.atlassian.com/confluence-cloud/docs/troubleshoot-access-problems-to-content/';
const $09f2383e12028cd7$export$40b60b643290317e = (chunks)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleClick = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'blockedAccessLearnMore'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        target: "_blank",
        href: $09f2383e12028cd7$var$SAC_LEARN_MORE_DOCUMENTATION,
        onClick: handleClick
    }, chunks);
};
module.exports["LearnMoreChunk"] = $09f2383e12028cd7$export$40b60b643290317e;

});

parcelRegister("7QoAs", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");


var $d9tcB = parcelRequire("d9tcB");


var $fdPUP = parcelRequire("fdPUP");


var $4Ewfm = parcelRequire("4Ewfm");


var $22cFL = parcelRequire("22cFL");


var $jI7Td = parcelRequire("jI7Td");

const $164b2844d962585d$var$blockedAccessUsersLimit = 10;
const $164b2844d962585d$var$blockedAccessLevelsLimit = 10;
const $164b2844d962585d$export$4da22e4767045266 = async ({ contentId: contentId, cloudId: cloudId, edition: edition, numberOfAncestors: numberOfAncestors, addMode: addMode, stagedUserPrincipals: stagedUserPrincipals, setMasterState: setMasterState, fireAnalyticEvent: fireAnalyticEvent })=>{
    //The validation  is skipped if free edition
    if (edition == (0, $d9tcB.ConfluenceEdition).FREE) return {
        showWarnRestrictionsDialog: false,
        showResolveRestrictionsDialog: false
    };
    const activeStagedUserPrincipals = stagedUserPrincipals.filter((user)=>!(0, $4Ewfm.isUserPendingAccess)({
            type: 'user',
            ...user
        }));
    //The validation  is skipped if staged user count is 0
    if (activeStagedUserPrincipals.length == 0) return {
        showWarnRestrictionsDialog: false,
        showResolveRestrictionsDialog: false
    };
    // if staged user count is greater than 10,
    // or content is more than 10 levels deep
    if (activeStagedUserPrincipals.length > $164b2844d962585d$var$blockedAccessUsersLimit || numberOfAncestors > $164b2844d962585d$var$blockedAccessLevelsLimit) {
        fireAnalyticEvent({
            eventType: 'sendOperationalEvent',
            action: 'BlockedAccessCheckLimitExceeded',
            actionSubject: 'BlockedAccessCheck',
            source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
            attributes: {
                NewUsersCount: activeStagedUserPrincipals.length,
                numberOfAncestors: numberOfAncestors
            }
        });
        const accountIds = activeStagedUserPrincipals.map((user)=>{
            return user.id;
        });
        const { data: usersContentAccessData, error: usersContentAccessError } = await (0, $c0rhi.queryInterop)({
            query: (0, $jI7Td.default),
            variables: {
                accessType: addMode == 'as-editor' ? 'EDIT' : 'VIEW',
                accountIds: accountIds,
                cloudId: cloudId,
                contentId: contentId
            },
            fetchPolicy: 'network-only',
            __callerPackage__: "share-and-restrict-dialog"
        });
        if (usersContentAccessError) {
            fireAnalyticEvent({
                eventType: 'sendOperationalEvent',
                action: 'errored',
                actionSubject: 'UsersContentAccessQuery',
                actionSubjectId: 'validateRestrictedPrincipals',
                attributes: {
                    message: usersContentAccessError.message
                }
            });
            return {
                showWarnRestrictionsDialog: false,
                showResolveRestrictionsDialog: false
            };
        }
        const canNotAccessList = usersContentAccessData?.confluence_userContentAccess?.cannotAccessList;
        if (canNotAccessList != null && canNotAccessList.length > 0) {
            const restrictedUserPrincipalsList = canNotAccessList.map((userId)=>{
                const restrictedPrincipal = {
                    userPrincipal: activeStagedUserPrincipals.find((val)=>val.id === userId),
                    restrictedResources: null
                };
                return restrictedPrincipal;
            });
            setMasterState((s)=>({
                    ...s,
                    restrictedUserPrincipals: restrictedUserPrincipalsList
                }));
            return {
                showWarnRestrictionsDialog: true,
                showResolveRestrictionsDialog: false
            };
        }
    } else {
        const blockedAccessSubjects = activeStagedUserPrincipals.map((user)=>{
            const blockedAccessSubject = {
                subjectId: user.id,
                subjectType: 'USER'
            };
            return blockedAccessSubject;
        });
        const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
            query: (0, $22cFL.default),
            variables: {
                // The GraphQL query expects a number, but contentId is a string. For the relay migration we will type it as any to not break existing functionality,
                // but this should be fixed in the future and keep the types consistent.
                contentId: contentId,
                accessType: addMode == 'as-editor' ? 'EDIT' : 'VIEW',
                subjects: blockedAccessSubjects
            },
            fetchPolicy: 'network-only',
            __callerPackage__: "share-and-restrict-dialog"
        });
        if (error) fireAnalyticEvent({
            eventType: 'sendOperationalEvent',
            action: 'errored',
            actionSubject: 'BlockedAccessRestrictionsQuery',
            actionSubjectId: 'validateRestrictedPrincipals',
            attributes: {
                message: error?.message
            }
        });
        const blockedAccessRestrictions = data?.blockedAccessRestrictions;
        const blockedAccessRestrictionSummary = blockedAccessRestrictions?.blockedAccessRestrictionSummary;
        if (blockedAccessRestrictions && blockedAccessRestrictionSummary && blockedAccessRestrictionSummary.length > 0) {
            const restrictedUserPrincipalsList = blockedAccessRestrictionSummary.map((restrictedUser)=>{
                const restrictedPrincipal = {
                    userPrincipal: activeStagedUserPrincipals.find((val)=>val.id === restrictedUser?.subject?.subjectId),
                    restrictedResources: restrictedUser?.restrictedResources
                };
                return restrictedPrincipal;
            });
            const assignableSpaceRolesIntersection = blockedAccessRestrictions.blockedAccessAssignableSpaceRolesIntersection;
            setMasterState((s)=>({
                    ...s,
                    restrictedUserPrincipals: restrictedUserPrincipalsList,
                    assignableSpaceRolesIntersection: assignableSpaceRolesIntersection
                }));
            //current user is not empowered to fix at least one of the selected user's restrictions
            if (!blockedAccessRestrictions.canFixRestrictionsForAllSubjects) return {
                showWarnRestrictionsDialog: true,
                showResolveRestrictionsDialog: false
            };
            return {
                showWarnRestrictionsDialog: false,
                showResolveRestrictionsDialog: true,
                // Expose this extra info for Realtime requests to consume
                // In USD these get set directly on the masterState
                // But realtime requests don't have access to masterState
                restrictedUserPrincipals: restrictedUserPrincipalsList,
                assignableSpaceRolesIntersection: assignableSpaceRolesIntersection
            };
        }
    }
    // all added principles can access or blocked access was skipped
    return {
        showWarnRestrictionsDialog: false,
        showResolveRestrictionsDialog: false
    };
};
module.exports["validateRestrictedPrincipals"] = $164b2844d962585d$export$4da22e4767045266;

});

parcelRegister("4Ewfm", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $fg72c = parcelRequire("fg72c");


var $8oEoE = parcelRequire("8oEoE");

const $b2ff9ab7087360b2$export$3b523c26f78a7afe = (principal)=>{
    if (principal.type === 'user') {
        const warning = principal.knownErrors?.accessWarning;
        return warning === 'pending-site-access-warning' || warning === 'pending-userbase-propagation-warning';
    }
    return false;
};
function $b2ff9ab7087360b2$export$9871f41355e50e43({ principals: principals, removals: removals, principalsPendingAccess: principalsPendingAccess, removeAll: removeAll }) {
    if (!(0, $9wGTI.fg)('twcg-444-invite-usd-improvements-m2-gate')) return false;
    if (!(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('twcg-444-invite-usd-improvements-m2', 'cohort', 'variation')) return false;
    if (Array.from(principals.values()).some(({ principal: principal })=>$b2ff9ab7087360b2$export$3b523c26f78a7afe(principal))) return true;
    if (principalsPendingAccess.some(({ principal: { id: id } })=>removals.has(id))) return true;
    if (removeAll && principalsPendingAccess.length > 0) return true;
    return false;
}
function $b2ff9ab7087360b2$export$e84d96463240149a({ generalAccess: generalAccess, principals: principals }) {
    return $b2ff9ab7087360b2$var$getRestrictions({
        generalAccess: generalAccess,
        principals: principals,
        restrictionType: 'mutation-restrictions'
    });
}
function $b2ff9ab7087360b2$export$50e102a305a0ed72({ generalAccess: generalAccess, principals: principals }) {
    const currentRestrictions = $b2ff9ab7087360b2$var$getRestrictions({
        generalAccess: generalAccess,
        principals: principals,
        restrictionType: 'publish-modal-restrictions'
    });
    const read = {
        operation: 'read',
        restrictions: {
            user: {
                results: []
            },
            group: {
                results: []
            }
        }
    };
    const update = {
        operation: 'update',
        restrictions: {
            user: {
                results: []
            },
            group: {
                results: []
            }
        }
    };
    const { publishModalReadRestrictions: publishModalReadRestrictions, publishModalUpdateRestrictions: publishModalUpdateRestrictions } = $b2ff9ab7087360b2$var$convertToPublishModalRestrictions(read, update, currentRestrictions);
    return [
        publishModalReadRestrictions,
        publishModalUpdateRestrictions
    ];
}
function $b2ff9ab7087360b2$export$49bcbf98a41d5666({ generalAccess: generalAccess, principals: principals }) {
    const restrictions = $b2ff9ab7087360b2$var$getRestrictions({
        generalAccess: generalAccess,
        principals: principals,
        restrictionType: 'mutation-restrictions'
    });
    const gqlInput = {
        read: restrictions.read,
        update: restrictions.update
    };
    // Only include new fields for explicit permissions paradigm when experiment is enabled
    if ((0, $6mKj3.UNSAFE_expValEqualsNoExposure)('persistence_specific_access_gate', 'cohort', 'experiment')) {
        gqlInput.restrictionState = (0, $fg72c.generalAccessLevelToMode)(generalAccess);
        gqlInput.permissions = $b2ff9ab7087360b2$var$buildPermissionsFromPrincipals(principals, generalAccess);
    }
    return gqlInput;
}
/**
 * Builds the flat permissions array format (view/edit) from the principals map.
 * This is the new format used by the permissions + restrictionState fields on ConfluenceContentInput.
 *
 * Unlike the old restrictions format (read/update with separate user/group arrays),
 * this produces flat arrays of { id, type } objects for view and edit.
 */ function $b2ff9ab7087360b2$var$buildPermissionsFromPrincipals(principals, _generalAccess) {
    const viewList = [];
    const editList = [];
    // For persistence_specific_access_gate: always include principals to show redundant restrictions
    // regardless of general access mode. Add principals based solely on their role.
    for (const [_, value] of principals){
        const { role: role, principal: principal } = value;
        const principalType = principal.type === 'user' ? 'USER' : 'GROUP';
        // Add can-view principals to view list
        if (role === 'can-view') viewList.push({
            id: principal.id,
            type: principalType
        });
        // Add can-edit principals to edit list only
        if (role === 'can-edit') editList.push({
            id: principal.id,
            type: principalType
        });
    }
    return {
        view: viewList,
        edit: editList
    };
}
/**
 * Generates restrictions based on the general access level, the provided principals map and restrictionType.
 */ function $b2ff9ab7087360b2$var$getRestrictions({ generalAccess: generalAccess, principals: principals, restrictionType: restrictionType }) {
    switch(generalAccess){
        case 'restricted':
            return {
                read: $b2ff9ab7087360b2$var$getReadList(principals, restrictionType),
                update: $b2ff9ab7087360b2$var$getUpdateList(principals, restrictionType)
            };
        case 'open-can-view':
            return {
                read: {
                    group: [],
                    user: []
                },
                update: $b2ff9ab7087360b2$var$getUpdateList(principals, restrictionType)
            };
        default:
            return {
                read: {
                    group: [],
                    user: []
                },
                update: {
                    group: [],
                    user: []
                }
            };
    }
}
/**
 * Converts the current state to publish modal restrictions by transforming user and group lists.
 *
 * @param {ContentRestriction} read - The read restrictions content.
 * @param {ContentRestriction} update - The update restrictions content.
 * @param {PageRestrictionsInput} currentRestrictions - The current restrictions input.
 * @returns {{ publishModalReadRestrictions: ContentRestriction, publishModalUpdateRestrictions: ContentRestriction }} The transformed publish modal restrictions.
 */ function $b2ff9ab7087360b2$var$convertToPublishModalRestrictions(read, update, currentRestrictions) {
    const { restrictions: { user: { results: readUserList }, group: { results: readGroupList } } } = read;
    const { restrictions: { user: { results: updateUserList }, group: { results: updateGroupList } } } = update;
    const { read: currentReadList, update: currentUpdateList } = currentRestrictions;
    $b2ff9ab7087360b2$var$pushTransformedUser(readUserList, currentReadList.user);
    $b2ff9ab7087360b2$var$pushTransformedUser(updateUserList, currentUpdateList.user);
    $b2ff9ab7087360b2$var$pushTransformedGroup(readGroupList, currentReadList.group);
    $b2ff9ab7087360b2$var$pushTransformedGroup(updateGroupList, currentUpdateList.group);
    return {
        publishModalReadRestrictions: read,
        publishModalUpdateRestrictions: update
    };
}
/**
 * Transforms and adds user restrictions to the publish modal user list.
 */ function $b2ff9ab7087360b2$var$pushTransformedUser(list, users) {
    for (const user of users){
        if (!user) continue;
        list.push({
            ...user,
            type: 'known',
            // instead of type: 'user'
            publicName: user.displayName,
            isExternalCollaborator: false
        });
    }
}
/**
 * Transforms and adds group restrictions to the publish modal group list.
 */ function $b2ff9ab7087360b2$var$pushTransformedGroup(list, groups) {
    for (const group of groups){
        if (!group) continue;
        list.push(group);
    }
}
const $b2ff9ab7087360b2$var$getUsageType = (principal)=>{
    if ((principal.type === 'group' || principal.type === 'team') && 'usageType' in principal && principal.usageType) return principal.usageType;
    if (principal.type === 'group') return (0, $8oEoE.ConfluenceGroupUsageType).USERBASE_GROUP;
    if (principal.type === 'team') return (0, $8oEoE.ConfluenceGroupUsageType).TEAM_COLLABORATION;
};
/**
 * Generates a list of principals with 'can-edit' access for the update list.
 */ function $b2ff9ab7087360b2$var$getUpdateList(principals, restrictionType) {
    const groupList = [];
    const userList = [];
    for (const [_, value] of principals){
        const { role: role, principal: principal } = value;
        const validGroupType = principal.type === 'group' || principal.type === 'team';
        if (validGroupType && role === 'can-edit') groupList.push({
            id: principal.id,
            name: principal.name,
            ...restrictionType === 'publish-modal-restrictions' && {
                type: 'group'
            },
            ...restrictionType === 'publish-modal-restrictions' && {
                usageType: $b2ff9ab7087360b2$var$getUsageType(principal)
            }
        });
        if (principal.type === 'user' && role === 'can-edit') userList.push({
            ...restrictionType === 'mutation-restrictions' && {
                id: principal.id
            },
            ...restrictionType === 'publish-modal-restrictions' && {
                type: 'user',
                accountId: principal.id,
                displayName: principal.name,
                profilePicture: {
                    path: principal.avatarUrl
                },
                email: principal.email
            }
        });
    }
    return {
        group: groupList,
        user: userList
    };
}
/**
 * Generates a list of principals with 'can-view' access for the read list.
 */ function $b2ff9ab7087360b2$var$getReadList(principals, restrictionType) {
    const groupList = [];
    const userList = [];
    for (const [_, value] of principals){
        const { role: role, principal: principal } = value;
        const validGroupType = principal.type === 'group' || principal.type === 'team';
        if (validGroupType && (role === 'can-view' || role === 'can-edit')) groupList.push({
            id: principal.id,
            name: principal.name,
            ...restrictionType === 'publish-modal-restrictions' && {
                type: 'group'
            },
            ...restrictionType === 'publish-modal-restrictions' && {
                usageType: $b2ff9ab7087360b2$var$getUsageType(principal)
            }
        });
        if (principal.type === 'user' && (role === 'can-view' || role === 'can-edit')) userList.push({
            ...restrictionType === 'mutation-restrictions' && {
                id: principal.id
            },
            ...restrictionType === 'publish-modal-restrictions' && {
                type: 'user',
                accountId: principal.id,
                displayName: principal.name,
                profilePicture: {
                    path: principal.avatarUrl
                },
                email: principal.email
            }
        });
    }
    return {
        group: groupList,
        user: userList
    };
}
module.exports["isUserPendingAccess"] = $b2ff9ab7087360b2$export$3b523c26f78a7afe;
module.exports["shouldMutationIncludeInvites"] = $b2ff9ab7087360b2$export$9871f41355e50e43;
module.exports["getRestrictionsForMutation"] = $b2ff9ab7087360b2$export$e84d96463240149a;
module.exports["getRestrictionsForPublishModal"] = $b2ff9ab7087360b2$export$50e102a305a0ed72;
module.exports["getGqlRestrictionsInputForPublishModal"] = $b2ff9ab7087360b2$export$49bcbf98a41d5666;

});

parcelRegister("fg72c", function(module, exports) {
const $06bae8500a7e571b$export$406c89e51172952a = {
    restricted: 'VIEW_RESTRICTED',
    'open-can-view': 'EDIT_RESTRICTED',
    'open-can-edit': 'OPEN'
};
const $06bae8500a7e571b$export$3e8e3eee6dfccab0 = (level)=>$06bae8500a7e571b$export$406c89e51172952a[level];
module.exports["generalAccessLevelToMode"] = $06bae8500a7e571b$export$3e8e3eee6dfccab0;

});

parcelRegister("8oEoE", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $0f8a7127f2228c42$export$e7c9280c9da1cc0a = /*#__PURE__*/ function(ConfluenceGroupUsageType) {
    ConfluenceGroupUsageType["ADMIN_OVERSIGHT"] = "ADMIN_OVERSIGHT";
    ConfluenceGroupUsageType["TEAM_COLLABORATION"] = "TEAM_COLLABORATION";
    ConfluenceGroupUsageType["USERBASE_GROUP"] = "USERBASE_GROUP";
    return ConfluenceGroupUsageType;
}({});
var $0f8a7127f2228c42$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["ConfluenceGroupUsageType"] = $0f8a7127f2228c42$export$e7c9280c9da1cc0a;

});

parcelRegister("22cFL", function(module, exports) {
/**
 * @generated SignedSource<<75c554d8ad4e342d8666c6b62aee9b86>>
 * @relayHash 0823488049ea540f2c3f5c4cb3a9f517
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e32f72b766dc4dbdcd33139b587c228b30663d8a6a179388fcc7ec57c1ddfaed
const $855873b1252722a0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accessType"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "subjects"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "subjectId"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accessType",
                    "variableName": "accessType"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "subjects",
                    "variableName": "subjects"
                }
            ],
            "concreteType": "BlockedAccessRestrictions",
            "kind": "LinkedField",
            "name": "blockedAccessRestrictions",
            "plural": false,
            "selections": [
                {
                    "concreteType": "SubjectRestrictionHierarchySummary",
                    "kind": "LinkedField",
                    "name": "blockedAccessRestrictionSummary",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "BlockedAccessSubject",
                            "kind": "LinkedField",
                            "name": "subject",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "subjectType"
                                }
                            ]
                        },
                        {
                            "concreteType": "RestrictedResource",
                            "kind": "LinkedField",
                            "name": "restrictedResources",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "resourceId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resourceTitle"
                                },
                                {
                                    "concreteType": "RestrictedResourceLinks",
                                    "kind": "LinkedField",
                                    "name": "resourceLink",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "base"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "webUi"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "requiredAccessType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resourceType"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "BlockedAccessEmpowerment",
                    "kind": "LinkedField",
                    "name": "blockedAccessEmpowerment",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isCurrentUserEmpowered"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceBlockedAccessAssignableSpaceRole",
                    "kind": "LinkedField",
                    "name": "blockedAccessAssignableSpaceRolesIntersection",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "roleId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "roleDescription"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "roleName"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "roleType"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "canFixRestrictionsForAllSubjects"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "BlockedAccessRestrictionsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "BlockedAccessRestrictionsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "0823488049ea540f2c3f5c4cb3a9f517",
            "id": "e32f72b766dc4dbdcd33139b587c228b30663d8a6a179388fcc7ec57c1ddfaed",
            "metadata": {},
            "name": "BlockedAccessRestrictionsQuery",
            "operationKind": "query",
            "text": "query BlockedAccessRestrictionsQuery($accessType:ResourceAccessType!,$contentId:Long!,$subjects:[BlockedAccessSubjectInput]!){blockedAccessRestrictions(accessType:$accessType,contentId:$contentId,subjects:$subjects){blockedAccessRestrictionSummary{subject{subjectId,subjectType},restrictedResources{resourceId,resourceTitle,resourceLink{base,webUi},requiredAccessType,resourceType}},blockedAccessEmpowerment{subjectId,isCurrentUserEmpowered},blockedAccessAssignableSpaceRolesIntersection{roleId,roleDescription,roleName,roleType},canFixRestrictionsForAllSubjects}}"
        }
    };
}();
$855873b1252722a0$var$node.hash = "cc9731fa07afd21d30e45e70eeb338f4";
var $855873b1252722a0$export$2e2bcd8739ae039 = $855873b1252722a0$var$node;
module.exports["default"] = $855873b1252722a0$export$2e2bcd8739ae039;

});

parcelRegister("jI7Td", function(module, exports) {
/**
 * @generated SignedSource<<bc99a62c4eb8102fc854786a36828b06>>
 * @relayHash 727771f625528321882e822398d219fd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e7c474d1f3ca6df3ee1f24f128085a09a26f1796477554de890782e7d51f18e9
const $b86f4f4db61ac40f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accessType"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountIds"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accessType",
                    "variableName": "accessType"
                },
                {
                    "kind": "Variable",
                    "name": "accountIds",
                    "variableName": "accountIds"
                },
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ConfluenceUserContentAccessResult",
            "kind": "LinkedField",
            "name": "confluence_userContentAccess",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canAccessList"
                },
                {
                    "kind": "ScalarField",
                    "name": "cannotAccessList"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "UsersContentAccessQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "UsersContentAccessQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "727771f625528321882e822398d219fd",
            "id": "e7c474d1f3ca6df3ee1f24f128085a09a26f1796477554de890782e7d51f18e9",
            "metadata": {},
            "name": "UsersContentAccessQuery",
            "operationKind": "query",
            "text": "query UsersContentAccessQuery($accessType:ResourceAccessType!,$accountIds:[String]!,$cloudId:ID!,$contentId:ID!){confluence_userContentAccess(accessType:$accessType,accountIds:$accountIds,cloudId:$cloudId,contentId:$contentId){canAccessList,cannotAccessList}}"
        }
    };
}();
$b86f4f4db61ac40f$var$node.hash = "3af84917efe0ce91f68b18f96d2f126c";
var $b86f4f4db61ac40f$export$2e2bcd8739ae039 = $b86f4f4db61ac40f$var$node;
module.exports["default"] = $b86f4f4db61ac40f$export$2e2bcd8739ae039;

});

parcelRegister("f2UnK", function(module, exports) {

var $8NGcs = parcelRequire("8NGcs");


var $dYU3e = parcelRequire("dYU3e");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $0ac8a6fa9069d7d8$var$preloadSpaceRoleModeQuery = (0, $8NGcs.default);
const $0ac8a6fa9069d7d8$export$5174d1e945d5fe4d = (cloudId)=>{
    return (0, $dYU3e.query)({
        query: $0ac8a6fa9069d7d8$var$preloadSpaceRoleModeQuery,
        variables: {
            cloudId: cloudId
        },
        fetchPolicy: 'cache-first',
        __callerPackage__: "share-and-restrict-dialog"
    }).then(({ data: data, hasErrors: hasErrors })=>{
        if (hasErrors) // Handle errors silently for preloading
        return null;
        return data?.confluence_spaceRoleMode || null;
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return null;
    });
};
const $0ac8a6fa9069d7d8$export$c715e7f8018f9029 = async (cloudId)=>{
    await $0ac8a6fa9069d7d8$export$5174d1e945d5fe4d(cloudId);
};
module.exports["preloadSpaceRoleMode"] = $0ac8a6fa9069d7d8$export$c715e7f8018f9029;

});

parcelRegister("8NGcs", function(module, exports) {
/**
 * @generated SignedSource<<bbbcf040ac95e90832074d5908ee571b>>
 * @relayHash 4c198432b204cbcb18fb5160733adf98
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cd62fad16e429cace180371436855ef292c31e1ca910185b179fd16e1c7852d4
const $556eda7e15abe5d2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_spaceRoleMode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadSpaceRoleModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadSpaceRoleModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "4c198432b204cbcb18fb5160733adf98",
            "id": "cd62fad16e429cace180371436855ef292c31e1ca910185b179fd16e1c7852d4",
            "metadata": {},
            "name": "preloadSpaceRoleModeQuery",
            "operationKind": "query",
            "text": "query preloadSpaceRoleModeQuery($cloudId:ID!){confluence_spaceRoleMode(cloudId:$cloudId)}"
        }
    };
}();
$556eda7e15abe5d2$var$node.hash = "1b6118c2bdcdd04e86f799370c9c7bca";
var $556eda7e15abe5d2$export$2e2bcd8739ae039 = $556eda7e15abe5d2$var$node;
module.exports["default"] = $556eda7e15abe5d2$export$2e2bcd8739ae039;

});

parcelRegister("lUcpS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $k78uC = parcelRequire("k78uC");


var $8IfK6 = parcelRequire("8IfK6");

const $91b0a64470223be6$export$5bf35293e545f20c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (...t1)=>{
            const params = t1;
            const event = createAnalyticsEvent((0, $8IfK6.default)(...params));
            event.fire((0, $k78uC.EVENT_CHANNEL));
        };
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const fireEvent = t0;
    let t1;
    if ($[2] !== fireEvent) {
        t1 = {
            fireEvent: fireEvent
        };
        $[2] = fireEvent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireEvent = (0, $cozmU.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $8IfK6.default)(...params));
        event.fire((0, $k78uC.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};
module.exports["useAnalyticsEvents"] = $91b0a64470223be6$export$5bf35293e545f20c;

});

parcelRegister("k78uC", function(module, exports) {
const $0de3cce3bcdfa361$export$3f072f06b90c3985 = 'peopleTeams';
module.exports["EVENT_CHANNEL"] = $0de3cce3bcdfa361$export$3f072f06b90c3985;

});

parcelRegister("8IfK6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::d33f3d33520a5e35881ec61f3c089abb>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen teams-app-internal-analytics
 */ const $fcb00cbaaafbad36$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $fcb00cbaaafbad36$export$2e2bcd8739ae039 = $fcb00cbaaafbad36$var$createEventPayload;
module.exports["default"] = $fcb00cbaaafbad36$export$2e2bcd8739ae039;

});

parcelRegister("eU2tf", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $fe57f9d19e98fdc0$var$messages = (0, $kSwu1.defineMessages)({
    inactiveAccountMsg: {
        id: "pt.profile-card.inactive.account",
        defaultMessage: "Account deactivated"
    },
    generalDescMsgForDisabledUser: {
        id: "pt.profile-card.general.msg.disabled.user",
        defaultMessage: "You can no longer collaborate with this person."
    },
    inactiveAccountDescMsgNoDate: {
        id: "pt.profile-card.inactive.account.no.date",
        defaultMessage: "Their account has been deactivated."
    },
    inactiveAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.inactive.account.has.date.this.week",
        defaultMessage: "Their account was deactivated this week."
    },
    inactiveAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.inactive.account.has.date.this.month",
        defaultMessage: "Their account was deactivated this month."
    },
    inactiveAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.inactive.account.has.date.last.month",
        defaultMessage: "Their account was deactivated last month."
    },
    inactiveAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.inactive.account.has.date.a.few.months",
        defaultMessage: "Their account has been deactivated for a few months."
    },
    inactiveAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.inactive.account.has.date.several.months",
        defaultMessage: "Their account has been deactivated for several months."
    },
    inactiveAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.inactive.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deactivated for more than a year."
    },
    closedAccountMsg: {
        id: "pt.profile-card.closed.account",
        defaultMessage: "Account deleted"
    },
    closedAccountDescMsgNoDate: {
        id: "pt.profile-card.closed.account.no.date",
        defaultMessage: "Their account has been deleted."
    },
    closedAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.closed.account.has.date.this.week",
        defaultMessage: "Their account was deleted this week."
    },
    closedAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.closed.account.has.date.this.month",
        defaultMessage: "Their account was deleted this month."
    },
    closedAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.closed.account.has.date.last.month",
        defaultMessage: "Their account was deleted last month."
    },
    closedAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.closed.account.has.date.a.few.months",
        defaultMessage: "Their account has been deleted for a few months."
    },
    closedAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.closed.account.has.date.several.months",
        defaultMessage: "Their account has been deleted for several months."
    },
    closedAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.closed.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deleted for more than a year."
    },
    disabledAccountDefaultName: {
        id: "pt.profile-card.disabled.account.default.name",
        defaultMessage: "Former user"
    },
    teamViewProfile: {
        id: "pt.team-profile-card.team.action.view-profile",
        defaultMessage: "View profile"
    },
    memberCount: {
        id: "pt.team-profile-card.team.member.count",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}"
    },
    memberCountIncludingYou: {
        id: "pt.team-profile-card.team.member.count-including-you",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you"
    },
    membersMoreThan50: {
        id: "pt.team-profile-card.team.member.many",
        defaultMessage: "Team \u2022 50+ members"
    },
    membersMoreThan50IncludingYou: {
        id: "pt.team-profile-card.team.member.many-including-you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    teamErrorTitle: {
        id: "pt.team-profile-card.error.title",
        defaultMessage: "We\u2019re having trouble retrieving this teams information"
    },
    teamErrorText: {
        id: "pt.team-profile-card.error.suggestion",
        defaultMessage: "Wait a few moments, then try again."
    },
    teamErrorButton: {
        id: "pt.team-profile-card.error.refresh-button",
        defaultMessage: "Try again"
    },
    teamForbiddenErrorStateTitle: {
        id: "pt.team-profile-card.forbidden-error-state.title",
        defaultMessage: "We can\u2019t show you this team"
    },
    teamForbiddenErrorStateDescription: {
        id: "pt.team-profile-card.forbidden-error-state.description",
        defaultMessage: "You don\u2019t have access to view this team."
    },
    managerSectionHeading: {
        id: "pt.team-profile-card.manager.heading",
        defaultMessage: "Manager"
    },
    directReportsSectionHeading: {
        id: "pt.team-profile-card.directReports.heading",
        defaultMessage: "Direct reports"
    },
    teamProfileCardAriaLabel: {
        id: "pt.team-profile-card.aria-label",
        defaultMessage: "More information about this team"
    },
    giveKudosButton: {
        id: "pt.profile-card.give-kudos",
        defaultMessage: "Give kudos"
    },
    // Remove this as part of the FG Cleanup for jfp_a11y_team_profile_card_actions_label
    profileCardMoreIconLabel: {
        id: "pt.profile-card.more-icon-label",
        defaultMessage: "More"
    },
    profileCardMoreIconLabelWithName: {
        id: "pt.profile-card.more-icon-label-with-name",
        defaultMessage: "More actions for {fullName}"
    },
    profileCardMoreReportingLinesLabel: {
        id: "pt.user-profile-card.reporting-lines.more-icon-label",
        defaultMessage: "+{count} more {count, plural, one {profile} other {profiles}}"
    },
    profileCardMoreMembersLabel: {
        id: "pt.team.profile-card.members.more-icon-label",
        defaultMessage: "+{count} more {count, plural, one {members} other {members}}"
    },
    archivedLozenge: {
        id: "pt.team-profile-card.archived-lozenge",
        defaultMessage: "Archived"
    },
    errorUserNotFound: {
        id: "pt.profile-card.error.user-not-found",
        defaultMessage: "The user is no longer available for the site"
    },
    errorGeneric: {
        id: "pt.profile-card.error.generic",
        defaultMessage: "Oops, looks like we\u2019re having issues"
    },
    errorRetrySuggestion: {
        id: "pt.profile-card.error.retry-suggestion",
        defaultMessage: "Try again and we\u2019ll give it another shot"
    },
    errorTryAgain: {
        id: "pt.profile-card.error.try-again-button",
        defaultMessage: "Try again"
    },
    errorDialogLabel: {
        id: "pt.profile-card.error.dialog-label",
        defaultMessage: "Profile card error"
    },
    loadingDialogLabel: {
        id: "pt.profile-card.loading.dialog-label",
        defaultMessage: "Loading profile card"
    },
    serviceAccountLabel: {
        id: "pt.profile-card.service-account.label",
        defaultMessage: "SERVICE ACCOUNT"
    },
    botAccountLabel: {
        id: "pt.profile-card.bot-account.label",
        defaultMessage: "APP"
    },
    viewManagerProfile: {
        id: "pt.profile-card.view-manager-profile",
        defaultMessage: "View {name} profile"
    }
});
var $fe57f9d19e98fdc0$export$2e2bcd8739ae039 = $fe57f9d19e98fdc0$var$messages;
module.exports["default"] = $fe57f9d19e98fdc0$export$2e2bcd8739ae039;

});

parcelRegister("cSSWJ", function(module, exports) {

var $1GhPJ = parcelRequire("1GhPJ");

const $e8b102093dcaac45$export$849551cf61929d4f = {
    packageName: "platform-pkg" ?? '',
    packageVersion: "0.0.0-use.local" ?? ''
};
const $e8b102093dcaac45$var$TEAM_SUBJECT = 'teamProfileCard';
const $e8b102093dcaac45$var$USER_SUBJECT = 'profilecard';
const $e8b102093dcaac45$var$AGENT_SUBJECT = 'rovoAgentProfilecard';
/**
 * @private
 * @deprecated Analytics events should be fired using the `@atlaskit/teams-app-internal-analytics` package.
 */ const $e8b102093dcaac45$var$createEvent = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes,
            firedAt: Math.round((0, $1GhPJ.getPageTime)())
        }
    });
const $e8b102093dcaac45$export$6f40cdf6d42c018d = (type)=>{
    switch(type){
        case 'user':
            return $e8b102093dcaac45$var$USER_SUBJECT;
        case 'team':
            return $e8b102093dcaac45$var$TEAM_SUBJECT;
        case 'agent':
            return $e8b102093dcaac45$var$AGENT_SUBJECT;
        default:
            return 'user';
    }
};
const $e8b102093dcaac45$export$d50ab8a3b6975c = (type, method, teamId)=>{
    return $e8b102093dcaac45$var$createEvent('ui', 'triggered', $e8b102093dcaac45$export$6f40cdf6d42c018d(type), undefined, {
        method: method,
        ...type === 'team' && teamId ? {
            teamId: teamId
        } : {}
    });
};
const $e8b102093dcaac45$export$c9b0e37b229a297b = (action, attributes)=>$e8b102093dcaac45$var$createEvent('operational', action, $e8b102093dcaac45$var$TEAM_SUBJECT, 'request', attributes);
const $e8b102093dcaac45$export$12dae48763368ac9 = (action, attributes)=>$e8b102093dcaac45$var$createEvent('operational', action, $e8b102093dcaac45$var$USER_SUBJECT, 'request', attributes);
const $e8b102093dcaac45$export$41816a317479160b = (type, actionSubjectId, attributes)=>$e8b102093dcaac45$var$createEvent('ui', 'rendered', $e8b102093dcaac45$export$6f40cdf6d42c018d(type), actionSubjectId, attributes);
const $e8b102093dcaac45$export$fdcd134fbeb1f921 = (type, attributes)=>$e8b102093dcaac45$var$createEvent('ui', 'clicked', $e8b102093dcaac45$export$6f40cdf6d42c018d(type), 'action', attributes);
const $e8b102093dcaac45$export$93260987012593be = (attributes)=>$e8b102093dcaac45$var$createEvent('ui', 'clicked', $e8b102093dcaac45$var$USER_SUBJECT, 'reportingLines', attributes);
const $e8b102093dcaac45$export$79befd155063a6a7 = (type, attributes)=>$e8b102093dcaac45$var$createEvent('ui', 'clicked', $e8b102093dcaac45$export$6f40cdf6d42c018d(type), 'moreActions', attributes);
const $e8b102093dcaac45$export$2703289b35687fde = (attributes)=>$e8b102093dcaac45$var$createEvent('ui', 'clicked', $e8b102093dcaac45$var$TEAM_SUBJECT, 'avatar', attributes);
const $e8b102093dcaac45$export$b4411a7661cf2d3f = (attributes)=>$e8b102093dcaac45$var$createEvent('ui', 'clicked', $e8b102093dcaac45$var$TEAM_SUBJECT, 'moreMembers', attributes);
const $e8b102093dcaac45$export$c86679da702d560e = (attributes)=>$e8b102093dcaac45$var$createEvent('ui', 'clicked', $e8b102093dcaac45$var$TEAM_SUBJECT, 'errorRetry', attributes);
const $e8b102093dcaac45$export$a9f8c9f412cf5664 = (action, actionSubjectId, attributes)=>$e8b102093dcaac45$var$createEvent('operational', action, $e8b102093dcaac45$var$AGENT_SUBJECT, actionSubjectId || 'request', attributes);
module.exports["PACKAGE_META_DATA"] = $e8b102093dcaac45$export$849551cf61929d4f;
module.exports["getActionSubject"] = $e8b102093dcaac45$export$6f40cdf6d42c018d;

});

parcelRegister("1GhPJ", function(module, exports) {
const $b79121f0bdcafc37$var$isPerformanceAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && !!performance.now;
};
const $b79121f0bdcafc37$var$performanceAvailable = $b79121f0bdcafc37$var$isPerformanceAvailable();
const $b79121f0bdcafc37$var$initialPageTime = Date.now();
const $b79121f0bdcafc37$export$e9faea7c41053334 = ()=>{
    if ($b79121f0bdcafc37$var$performanceAvailable) return performance.now();
    return Date.now() - $b79121f0bdcafc37$var$initialPageTime;
};
module.exports["getPageTime"] = $b79121f0bdcafc37$export$e9faea7c41053334;

});

parcelRegister("4k5Wq", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $5avUB = parcelRequire("5avUB");


var $4aRua = parcelRequire("4aRua");


var $eU2tf = parcelRequire("eU2tf");


var $hHYlx = parcelRequire("hHYlx");


var $cSSWJ = parcelRequire("cSSWJ");

const $0f12e30f7425acf6$var$ErrorMessage = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(18);
    let t0;
    if ($[0] !== props.errorType) {
        t0 = props.errorType || {
            reason: "default"
        };
        $[0] = props.errorType;
        $[1] = t0;
    } else t0 = $[1];
    const errorType = t0;
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    let t1;
    let t2;
    if ($[2] !== errorReason || $[3] !== fireAnalytics || $[4] !== hasRetry) {
        t1 = ()=>{
            fireAnalytics("ui.profilecard.rendered.error", {
                hasRetry: hasRetry,
                errorType: errorReason,
                firedAt: Math.round(performance.now()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
        };
        t2 = [
            errorReason,
            fireAnalytics,
            hasRetry
        ];
        $[2] = errorReason;
        $[3] = fireAnalytics;
        $[4] = hasRetry;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[7] !== errorReason || $[8] !== reload) {
        t3 = ()=>{
            if (errorReason === "NotFound") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hHYlx.ErrorTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $eU2tf.default).errorUserNotFound));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hHYlx.ErrorTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $eU2tf.default).errorGeneric), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("br", null), reload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
                color: "color.text.subtlest"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $eU2tf.default).errorRetrySuggestion)));
        };
        $[7] = errorReason;
        $[8] = reload;
        $[9] = t3;
    } else t3 = $[9];
    const errorContent = t3;
    let t4;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
            label: "icon error"
        });
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== errorContent) {
        t5 = errorContent();
        $[11] = errorContent;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== reload) {
        t6 = reload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            onClick: reload
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $eU2tf.default).errorTryAgain));
        $[13] = reload;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t5 || $[16] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hHYlx.ErrorWrapper), {
            testId: "profilecard-error"
        }, t4, t5, t6);
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $cozmU.useEffect)(()=>{
        fireAnalytics('ui.profilecard.rendered.error', {
            hasRetry: hasRetry,
            errorType: errorReason,
            firedAt: Math.round(performance.now()),
            ...(0, $cSSWJ.PACKAGE_META_DATA)
        });
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hHYlx.ErrorTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $eU2tf.default).errorUserNotFound));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hHYlx.ErrorTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $eU2tf.default).errorGeneric), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("br", null), reload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            color: "color.text.subtlest"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $eU2tf.default).errorRetrySuggestion)));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hHYlx.ErrorWrapper), {
        testId: "profilecard-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
        label: "icon error"
    }), errorContent(), reload && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: reload
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $eU2tf.default).errorTryAgain)));
};
var $0f12e30f7425acf6$export$2e2bcd8739ae039 = $0f12e30f7425acf6$var$ErrorMessage;
module.exports["default"] = $0f12e30f7425acf6$export$2e2bcd8739ae039;

});

parcelRegister("hHYlx", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");

const $3b2daa1fed2d9894$var$styles = {
    errorWrapper: "_y3gn1h6o _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
    errorTitle: "_19pku2gc",
    teamErrorText: "_syaz1rpy _19pku2gc"
};
const $3b2daa1fed2d9894$export$bb27b7e39840238f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.errorWrapper);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: t0,
            ...props
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.errorWrapper),
        ...props
    });
const $3b2daa1fed2d9894$export$b065fd053267ec81 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props.children) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $3b2daa1fed2d9894$var$styles.errorTitle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            color: "color.text"
        }, props.children));
        $[0] = props.children;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $3b2daa1fed2d9894$var$styles.errorTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        color: "color.text"
    }, props.children));
const $3b2daa1fed2d9894$export$90d92ccfb27352c6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.teamErrorText);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props.children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: t0
        }, props.children);
        $[1] = props.children;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.teamErrorText)
    }, props.children);
module.exports["ErrorWrapper"] = $3b2daa1fed2d9894$export$bb27b7e39840238f;
module.exports["ErrorTitle"] = $3b2daa1fed2d9894$export$b065fd053267ec81;

});

parcelRegister("4PAHv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cXtTj = parcelRequire("cXtTj");


var $ixfCV = parcelRequire("ixfCV");


var $7G50J = parcelRequire("7G50J");


var $eW61a = parcelRequire("eW61a");


var $lUcpS = parcelRequire("lUcpS");


var $1kejP = parcelRequire("1kejP");


var $dRAjC = parcelRequire("dRAjC");


var $4k5Wq = parcelRequire("4k5Wq");


var $kb2tZ = parcelRequire("kb2tZ");


var $hIwXM = parcelRequire("hIwXM");

const $fe1c8bc12e81e628$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $cozmU.useState)();
    // Initialize as true when fix is enabled since we fetch immediately on mount,
    // avoiding a brief error screen flash before the useEffect fires.
    const [isLoading, setIsLoading] = (0, $cozmU.useState)((0, $ixfCV.fg)('jira_ai_fix_agent_profile_card_flashing') || (0, $ixfCV.fg)('confluence_fix_agent_profile_card_flash'));
    const [error, setError] = (0, $cozmU.useState)();
    const [isPermitted, setIsPermitted] = (0, $cozmU.useState)(true);
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const creatorUserId = (0, $cozmU.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $dRAjC.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const navResult = (0, $eW61a.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: creatorUserId || ''
        },
        cloudId: props.cloudId
    });
    let profileHref = navResult.href;
    const getCreator = (0, $cozmU.useCallback)(async ({ creator_type: creator_type, creator: creator, authoringTeam: authoringTeam })=>{
        try {
            let userCreatorInfo;
            const currentCreatorUserId = (0, $ixfCV.fg)('jira_ai_fix_agent_profile_card_flashing') || (0, $ixfCV.fg)('confluence_fix_agent_profile_card_flash') ? creator_type === 'CUSTOMER' && creator ? (0, $dRAjC.getAAIDFromARI)(creator) : undefined : creatorUserId;
            if (currentCreatorUserId && props.cloudId) {
                userCreatorInfo = await props.resourceClient.getProfile(props.cloudId, currentCreatorUserId, fireEvent);
                if ((0, $ixfCV.fg)('jira_ai_fix_agent_profile_card_flashing') || (0, $ixfCV.fg)('confluence_fix_agent_profile_card_flash')) profileHref = (0, $eW61a.navigateToTeamsApp)({
                    type: 'USER',
                    payload: {
                        userId: currentCreatorUserId
                    },
                    cloudId: props.cloudId
                }).href;
            }
            const creatorInfo = (0, $7G50J.getAgentCreator)({
                creatorType: creator_type,
                authoringTeam: authoringTeam ? {
                    displayName: authoringTeam.displayName ?? '',
                    profileLink: authoringTeam.profileUrl ?? undefined
                } : undefined,
                userCreator: userCreatorInfo ? {
                    name: userCreatorInfo.fullName ?? '',
                    profileLink: (0, $ixfCV.fg)('platform-adopt-teams-nav-config') ? profileHref : `/people/${currentCreatorUserId}`
                } : undefined,
                forgeCreator: creator ?? undefined
            });
            return creatorInfo;
        } catch  {
            return undefined;
        }
    }, [
        creatorUserId,
        fireEvent,
        props.cloudId,
        props.resourceClient,
        profileHref
    ]);
    const fetchData = (0, $cozmU.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const profileResult = await props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireEvent);
            const profileData = profileResult.restData;
            const creatorInfoProps = {
                creator_type: profileData?.creator_type,
                creator: profileData?.creator || undefined,
                authoringTeam: profileResult.aggData?.authoringTeam ?? undefined
            };
            const agentCreatorInfo = await getCreator(creatorInfoProps);
            setAgentData({
                ...profileData,
                creatorInfo: agentCreatorInfo
            });
        } catch (err) {
            if (err instanceof (0, $1kejP.AgentForbiddenError) && (0, $cXtTj.default).getExperimentValue('platform_editor_reduced_profile_cards', 'isEnabled', false)) setIsPermitted(false);
            else setError(err);
        } finally{
            setIsLoading(false);
        }
    }, [
        fireEvent,
        getCreator,
        props.accountId,
        props.resourceClient
    ]);
    // Depend on accountId rather than fetchData to avoid a re-fetch loop:
    // agentData changes → creatorUserId → getCreator → fetchData ref changes → useEffect re-fires.
    // Reset state on accountId change so stale data from the previous agent isn't briefly shown.
    (0, $cozmU.useEffect)(()=>{
        if (!((0, $ixfCV.fg)('jira_ai_fix_agent_profile_card_flashing') || (0, $ixfCV.fg)('confluence_fix_agent_profile_card_flash'))) return;
        setAgentData(undefined);
        setError(undefined);
        setIsLoading(true);
        fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.accountId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $ixfCV.fg)('jira_ai_fix_agent_profile_card_flashing') || (0, $ixfCV.fg)('confluence_fix_agent_profile_card_flash')) return;
        fetchData();
    }, [
        fetchData
    ]);
    if (!isPermitted && (0, $cXtTj.default).getExperimentValue('platform_editor_reduced_profile_cards', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kb2tZ.AgentProfileCardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hIwXM.AgentProfileCardLazy), {
        agent: {
            id: '',
            named_id: '',
            name: props.agentName ?? '',
            description: '\u00A0',
            creator_type: 'CUSTOMER',
            is_default: false,
            actor_type: 'AGENT',
            user_defined_conversation_starters: null,
            favourite: false,
            favourite_count: 0,
            identity_account_id: props.accountId,
            creatorInfo: undefined
        },
        isLoading: false,
        resourceClient: props.resourceClient,
        cloudId: props.cloudId,
        hideAgentActions: true,
        hideConversationStarters: true,
        hideAiDisclaimer: true,
        hideStarButton: props.hideStarButton
    })));
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kb2tZ.AgentProfileCardWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4k5Wq.default), {
        reload: ()=>{
            fetchData();
        },
        errorType: error || null,
        fireAnalytics: fireEvent
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hIwXM.AgentProfileCardLazy), {
        agent: agentData,
        isLoading: isLoading,
        hasError: !!error,
        onConversationStartersClick: props.onConversationStartersClick,
        onChatClick: props.onChatClick,
        addFlag: props.addFlag,
        resourceClient: props.resourceClient,
        cloudId: props.cloudId,
        onDeleteAgent: props.onDeleteAgent,
        hideMoreActions: props.hideMoreActions,
        hideAiDisclaimer: props.hideAiDisclaimer,
        hideConversationStarters: props.hideConversationStarters,
        hideAgentActions: props.hideAgentActions,
        hideStarButton: props.hideStarButton
    }));
};
module.exports["AgentProfileCardResourced"] = $fe1c8bc12e81e628$export$4b013ffffcb40af8;

});

parcelRegister("7G50J", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $cXtTj = parcelRequire("cXtTj");


var $I7hWB = parcelRequire("I7hWB");


var $i1t43 = parcelRequire("i1t43");


var $NlHoa = parcelRequire("NlHoa");

var $bltJZ = parcelRequire("bltJZ");


var $ixfCV = parcelRequire("ixfCV");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");


var $lpNn5 = parcelRequire("lpNn5");


var $6h4xM = parcelRequire("6h4xM");


var $i4kCF = parcelRequire("i4kCF");


var $hq9Cp = parcelRequire("hq9Cp");


var $fNIRw = parcelRequire("fNIRw");

const $f5fec235121c7193$var$styles = {
    clickableItem: "_zulp1b66 _1e0c1txw _4cvr1h6o",
    rovoIconWrapper: "_1e0c1txw",
    name: "_1bah1yb4 _4cvr1y6m",
    description: "_1mouze3t _1i4qfg65 _1nmz1hna",
    headingWrapper: "_kqswh2mm",
    hiddenIconWrapper: "_19pkv77o"
};
const $f5fec235121c7193$export$7cbebf266a9bcc3c = ({ creatorType: creatorType, authoringTeam: authoringTeam, userCreator: userCreator, forgeCreator: forgeCreator })=>{
    if (creatorType === 'SYSTEM') return {
        type: 'SYSTEM'
    };
    if ((0, $ixfCV.fg)('rovo_agent_support_a2a_avatar') ? (0, $hq9Cp.isForgeAgentByCreatorType)(creatorType) : creatorType === 'FORGE' || creatorType === 'THIRD_PARTY' // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
    ) return {
        // @todo: remove cast in rovo_agent_support_a2a_avatar cleanup
        type: (0, $ixfCV.fg)('jira_improve_agent_profile_for_a2a') ? creatorType : 'FORGE',
        name: forgeCreator ?? ''
    };
    if (creatorType === 'OOTB') return {
        type: 'OOTB'
    };
    if (creatorType === 'CUSTOMER') {
        if (authoringTeam) return {
            type: 'CUSTOMER',
            name: authoringTeam.displayName,
            profileLink: authoringTeam.profileLink ?? ''
        };
        if (!userCreator?.profileLink) return undefined;
        return {
            type: 'CUSTOMER',
            name: userCreator.name,
            profileLink: userCreator.profileLink,
            status: userCreator.status
        };
    }
    return;
};
const $f5fec235121c7193$export$f35b2eeaa7e3db15 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== creator || $[1] !== formatMessage || $[2] !== isLoading || $[3] !== onCreatorLinkClick) {
        const getCreatorRender = ()=>{
            if (isLoading) return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                    testId: "agent-profile-creator-skeleton",
                    isShimmering: true,
                    height: 18,
                    width: 100
                })
            });
            if (!creator) return null;
            if (creator.type === "SYSTEM" || creator.type === "OOTB") return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
                    alignBlock: "center",
                    testId: "atlassian-icon"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                    label: "",
                    size: "small",
                    appearance: "brand"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), null, "Atlassian"))
            });
            if (creator.type === "CUSTOMER") return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: creator.profileLink,
                    onClick: ()=>onCreatorLinkClick(),
                    target: "_blank"
                }, creator.name, " ", creator.status === "inactive" && formatMessage((0, $fNIRw.messages).agentDeactivated))
            });
            if (creator.type === "REMOTE_A2A") {
                if ((0, $cXtTj.default).getExperimentValue("rovo_hide_remote_a2a_agent_creator_exp", "isEnabled", false)) return null;
                return formatMessage((0, $fNIRw.messages).remoteAgentCreatedBy, {
                    creatorNameWithLink: creator.name
                });
            }
            if (creator.type === "THIRD_PARTY" || creator.type === "FORGE") return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: creator.name
            });
            return null;
        };
        t1 = getCreatorRender();
        $[0] = creator;
        $[1] = formatMessage;
        $[2] = isLoading;
        $[3] = onCreatorLinkClick;
        $[4] = t1;
    } else t1 = $[4];
    const creatorRender = t1;
    if ((0, $ixfCV.fg)("jira_improve_agent_profile_for_a2a")) {
        const showRovoIcon = creator?.type !== "REMOTE_A2A";
        let t2;
        if ($[5] !== creatorRender || $[6] !== showRovoIcon) {
            t2 = creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                xcss: $f5fec235121c7193$var$styles.clickableItem
            }, showRovoIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
                testId: "rovo-icon-wrapper",
                "aria-hidden": "true"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.RovoIcon), {
                appearance: "brand",
                size: "small"
            })) : null, creatorRender) : null;
            $[5] = creatorRender;
            $[6] = showRovoIcon;
            $[7] = t2;
        } else t2 = $[7];
        return t2;
    }
    let t2;
    if ($[8] !== creatorRender) {
        t2 = creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $f5fec235121c7193$var$styles.clickableItem
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
            testId: "rovo-icon-wrapper",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.RovoIcon), {
            appearance: "brand",
            size: "small"
        })), creatorRender) : null;
        $[8] = creatorRender;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
} : ({ creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const getCreatorRender = ()=>{
        if (isLoading) return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                testId: "agent-profile-creator-skeleton",
                isShimmering: true,
                height: 18,
                width: 100
            })
        });
        if (!creator) return null;
        if (creator.type === 'SYSTEM' || creator.type === 'OOTB') return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
                alignBlock: "center",
                testId: "atlassian-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                label: "",
                size: "small",
                appearance: "brand"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), null, "Atlassian"))
        });
        if (creator.type === 'CUSTOMER') return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                href: creator.profileLink,
                onClick: ()=>onCreatorLinkClick(),
                target: "_blank"
            }, creator.name, ' ', creator.status === 'inactive' && formatMessage((0, $fNIRw.messages).agentDeactivated))
        });
        if (creator.type === 'REMOTE_A2A') {
            if ((0, $cXtTj.default).getExperimentValue('rovo_hide_remote_a2a_agent_creator_exp', 'isEnabled', false)) return null;
            return formatMessage((0, $fNIRw.messages).remoteAgentCreatedBy, {
                creatorNameWithLink: creator.name
            });
        } // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
        if (creator.type === 'THIRD_PARTY' || creator.type === 'FORGE') return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: creator.name
        });
        return null;
    };
    const creatorRender = getCreatorRender();
    if ((0, $ixfCV.fg)('jira_improve_agent_profile_for_a2a')) {
        const showRovoIcon = creator?.type !== 'REMOTE_A2A';
        return creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $f5fec235121c7193$var$styles.clickableItem
        }, showRovoIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
            testId: "rovo-icon-wrapper",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.RovoIcon), {
            appearance: "brand",
            size: "small"
        })) : null, creatorRender) : null;
    }
    return creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $f5fec235121c7193$var$styles.clickableItem
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
        testId: "rovo-icon-wrapper",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.RovoIcon), {
        appearance: "brand",
        size: "small"
    })), creatorRender) : null;
};
const $f5fec235121c7193$export$e02348ba0b01a210 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, headingRender: headingRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle, showStarButton: t1, renderAdditionalContent: renderAdditionalContent } = t0;
    const showStarButton = t1 === undefined ? true : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== agentName) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h2",
            size: "medium"
        }, agentName);
        $[0] = agentName;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== formatMessage || $[3] !== isHidden) {
        t3 = isHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $f5fec235121c7193$var$styles.hiddenIconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: formatMessage((0, $fNIRw.messages).hiddenTooltip),
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6h4xM.HiddenIcon), {
            label: formatMessage((0, $fNIRw.messages).hiddenIcon)
        })));
        $[2] = formatMessage;
        $[3] = isHidden;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== headingRender || $[6] !== t2 || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            space: "space.075",
            xcss: $f5fec235121c7193$var$styles.headingWrapper
        }, t2, headingRender, t3);
        $[5] = headingRender;
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== agentName || $[10] !== isStarred || $[11] !== onStarToggle || $[12] !== showStarButton) {
        t5 = showStarButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i4kCF.StarIconButton), {
            isStarred: isStarred,
            handleToggle: onStarToggle,
            agentName: agentName
        });
        $[9] = agentName;
        $[10] = isStarred;
        $[11] = onStarToggle;
        $[12] = showStarButton;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== t4 || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            xcss: $f5fec235121c7193$var$styles.name,
            space: "space.100",
            alignBlock: "center"
        }, t4, t5);
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== agentDescription) {
        t7 = !!agentDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $f5fec235121c7193$var$styles.description,
            as: "p"
        }, agentDescription);
        $[17] = agentDescription;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== renderAdditionalContent) {
        t8 = !!renderAdditionalContent && (0, $ixfCV.fg)("jira_browse_agents_modal") && renderAdditionalContent();
        $[19] = renderAdditionalContent;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== creatorRender || $[22] !== starCountRender || $[23] !== t6 || $[24] !== t7 || $[25] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            space: "space.100"
        }, t6, creatorRender, t7, starCountRender, t8);
        $[21] = creatorRender;
        $[22] = starCountRender;
        $[23] = t6;
        $[24] = t7;
        $[25] = t8;
        $[26] = t9;
    } else t9 = $[26];
    return t9;
} : ({ agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, headingRender: headingRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle, showStarButton: showStarButton = true, renderAdditionalContent: renderAdditionalContent })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        xcss: $f5fec235121c7193$var$styles.name,
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        space: "space.075",
        xcss: $f5fec235121c7193$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h2",
        size: "medium"
    }, agentName), headingRender, isHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $f5fec235121c7193$var$styles.hiddenIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage((0, $fNIRw.messages).hiddenTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6h4xM.HiddenIcon), {
        label: formatMessage((0, $fNIRw.messages).hiddenIcon)
    })))), showStarButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i4kCF.StarIconButton), {
        isStarred: isStarred,
        handleToggle: onStarToggle,
        agentName: agentName
    })), creatorRender, !!agentDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $f5fec235121c7193$var$styles.description,
        as: "p"
    }, agentDescription), starCountRender, !!renderAdditionalContent && (0, $ixfCV.fg)('jira_browse_agents_modal') && renderAdditionalContent());
};
module.exports["getAgentCreator"] = $f5fec235121c7193$export$7cbebf266a9bcc3c;
module.exports["AgentProfileCreator"] = $f5fec235121c7193$export$f35b2eeaa7e3db15;
module.exports["AgentProfileInfo"] = $f5fec235121c7193$export$e02348ba0b01a210;

});

parcelRegister("6h4xM", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bsSbN = parcelRequire("bsSbN");

const $fc7d462f5dd0deaa$export$bce21421c351deb1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), props);
module.exports["HiddenIcon"] = $fc7d462f5dd0deaa$export$bce21421c351deb1;

});

parcelRegister("i4kCF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $6Cex3 = parcelRequire("6Cex3");


var $lbT4j = parcelRequire("lbT4j");


var $hBYtq = parcelRequire("hBYtq");


var $4ssVW = parcelRequire("4ssVW");

const $fbe2d7b3097e2d22$var$styles = {
    pressableStarIcon: "_bfhk1j28 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _4t3i1tcg _1bsb1tcg",
    hidden: "_tzy4idpf"
};
const $fbe2d7b3097e2d22$export$703abb8bd2abdfa5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { isStarred: isStarred, handleToggle: handleToggle, visible: t1, agentName: agentName } = t0;
    const visible = t1 === undefined ? true : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const t2 = !visible && $fbe2d7b3097e2d22$var$styles.hidden;
    let t3;
    if ($[0] !== t2) {
        t3 = (0, $w6R6I.cx)($fbe2d7b3097e2d22$var$styles.pressableStarIcon, t2);
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    let t5;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>setIsHovered(true);
        t5 = ()=>setIsHovered(false);
        $[2] = t4;
        $[3] = t5;
    } else {
        t4 = $[2];
        t5 = $[3];
    }
    let t6;
    if ($[4] !== agentName || $[5] !== formatMessage || $[6] !== isHovered || $[7] !== isStarred) {
        t6 = isStarred || isHovered ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
            spacing: "spacious",
            label: formatMessage((0, $4ssVW.default).removeFromFavouritesLabel, {
                agentName: agentName
            }),
            color: "var(--ds-icon-accent-orange, #E06C00)"
        }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
            spacing: "spacious",
            label: formatMessage((0, $4ssVW.default).clickToFavouriteLabel, {
                agentName: agentName
            }),
            color: "var(--ds-icon, #292A2E)"
        });
        $[4] = agentName;
        $[5] = formatMessage;
        $[6] = isHovered;
        $[7] = isStarred;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== handleToggle || $[10] !== t3 || $[11] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.default), {
            xcss: t3,
            onClick: handleToggle,
            onMouseEnter: t4,
            onMouseLeave: t5
        }, t6);
        $[9] = handleToggle;
        $[10] = t3;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    return t7;
} : ({ isStarred: isStarred, handleToggle: handleToggle, visible: visible = true, agentName: agentName })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    return /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.default), {
        xcss: (0, $w6R6I.cx)($fbe2d7b3097e2d22$var$styles.pressableStarIcon, !visible && $fbe2d7b3097e2d22$var$styles.hidden),
        onClick: handleToggle,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    }, isStarred || isHovered ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
        spacing: "spacious",
        label: formatMessage((0, $4ssVW.default).removeFromFavouritesLabel, {
            agentName: agentName
        }),
        color: "var(--ds-icon-accent-orange, #E06C00)"
    }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
        spacing: "spacious",
        label: formatMessage((0, $4ssVW.default).clickToFavouriteLabel, {
            agentName: agentName
        }),
        color: "var(--ds-icon, #292A2E)"
    }));
};
module.exports["StarIconButton"] = $fbe2d7b3097e2d22$export$703abb8bd2abdfa5;

});

parcelRegister("4ssVW", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a47d9a7d981bdb91$var$message = (0, $kSwu1.defineMessages)({
    removeFromFavouritesLabel: {
        id: "rovo-chat.browse-agents.remove-from-favourites-label",
        defaultMessage: "Remove {agentName} from favourites"
    },
    clickToFavouriteLabel: {
        id: "rovo-chat.browse-agents.click-to-favourite-label",
        defaultMessage: "Add {agentName} to favourites"
    }
});
var $a47d9a7d981bdb91$export$2e2bcd8739ae039 = $a47d9a7d981bdb91$var$message;
module.exports["default"] = $a47d9a7d981bdb91$export$2e2bcd8739ae039;

});

parcelRegister("hq9Cp", function(module, exports) {
const $84118747f7725463$export$3055eac4de8cbd2b = (creatorType)=>creatorType === 'THIRD_PARTY' || creatorType === 'FORGE' || creatorType === 'REMOTE_A2A';
module.exports["isForgeAgentByCreatorType"] = $84118747f7725463$export$3055eac4de8cbd2b;

});

parcelRegister("fNIRw", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $246a354bdf98d3ad$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    agentCreatedBy: {
        id: "ai-mate.agent-profile-info.created-by",
        defaultMessage: "Rovo Agent by {creatorNameWithLink}"
    },
    remoteAgentCreatedBy: {
        id: "ai-mate.agent-profile-info.agent-by",
        defaultMessage: "Agent by {creatorNameWithLink}"
    },
    agentDeactivated: {
        id: "ai-mate.agent-profile-info.deactivated",
        defaultMessage: "(deactivated)"
    },
    starredCount: {
        id: "ai-mate.agent-profile-info.starred-count",
        defaultMessage: "{count} starred"
    },
    hiddenIcon: {
        id: "ai-mate.agent-profile-info.hidden-icon",
        defaultMessage: "Hidden"
    },
    hiddenTooltip: {
        id: "ai-mate.agent-profile-info.hidden-tooltip",
        defaultMessage: "Agent won't show in search results"
    },
    starAgentTooltip: {
        id: "ai-mate.agent-profile-info.star-agent-tooltip",
        defaultMessage: "Star Agent"
    },
    creatorLabel: {
        id: "ai-mate.agent-profile-info.creator",
        defaultMessage: "Creator"
    }
});
module.exports["messages"] = $246a354bdf98d3ad$export$defe85febe8b728c;

});

parcelRegister("1kejP", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $ixfCV = parcelRequire("ixfCV");


var $cSSWJ = parcelRequire("cSSWJ");


var $1GhPJ = parcelRequire("1GhPJ");


var $dRAjC = parcelRequire("dRAjC");


var $goaLH = parcelRequire("goaLH");


var $bTlNq = parcelRequire("bTlNq");


var $de4Mg = parcelRequire("de4Mg");


var $bCBEs = parcelRequire("bCBEs");

class $7eb6fbaa97f76140$export$a6d78d75d03919f1 extends Error {
    constructor(){
        super('Agent access forbidden');
        this.status = 403;
        this.name = 'AgentForbiddenError';
    }
}
const $7eb6fbaa97f76140$var$buildActivationIdQuery = (cloudId, product)=>({
        query: `
		query RovoAgentProfileCard_ActivationQuery($cloudId: ID!, $product: String!) {
			tenantContexts(cloudIds: [$cloudId]) {
				activationIdByProduct(product: $product) {
					active
				}
			}
		}
	`,
        variables: {
            cloudId: cloudId,
            product: product
        }
    });
const $7eb6fbaa97f76140$var$buildRovoAgentQueryByAri = (agentAri)=>({
        query: `
	  query RovoAgentProfileCard_AgentQueryByAri($agentAri: ID!) {
			agentStudio_agentById(id: $agentAri) @optIn(to: "AgentStudio") {
			  __typename
				... on AgentStudioAssistant {
					authoringTeam {
						displayName
					}
				}
				... on QueryError {
					message
				}
			}
		}
	`,
        variables: {
            agentAri: agentAri
        }
    });
const $7eb6fbaa97f76140$var$buildRovoAgentQueryByAccountIdOld = (identityAccountId, cloudId)=>({
        query: `
		query RovoAgentProfileCard_AgentQueryByAccountId($identityAccountId: ID!, $cloudId: ID!) {
			agentStudio_agentByIdentityAccountId(identityAccountId: $identityAccountId, cloudId: $cloudId) @optIn(to: "AgentStudio") {
			  __typename
				... on AgentStudioAssistant {
					authoringTeam {
						displayName
						profileUrl
					}
				}
				... on QueryError {
					message
				}
			}
		}
	`,
        variables: {
            identityAccountId: identityAccountId,
            cloudId: cloudId
        }
    });
const $7eb6fbaa97f76140$var$buildRovoAgentQueryByAccountId = (identityAccountId, cloudId)=>({
        query: `
		query RovoAgentProfileCard_AgentQueryByAccountId($id: ID!, $cloudId: String!) {
			agentStudio_agentByIdentityAccountId(cloudId: $cloudId, id: $id) @optIn(to: "AgentStudio") {
			  __typename
				... on AgentStudioAssistant {
					authoringTeam {
						displayName
						profileUrl
					}
				}
				... on QueryError {
					message
				}
			}
		}
	`,
        variables: {
            id: identityAccountId.startsWith((0, $dRAjC.USER_ARI_PREFIX)) ? identityAccountId : `${0, $dRAjC.USER_ARI_PREFIX}${identityAccountId}`,
            cloudId: cloudId
        }
    });
const $7eb6fbaa97f76140$var$createHeaders = (product, cloudId, isBodyJson)=>{
    const headers = new Headers({
        'X-Product': product,
        'X-Experience-Id': 'profile-card',
        'X-Cloudid': cloudId || ''
    });
    if (isBodyJson) headers.set('Content-Type', 'application/json');
    return headers;
};
class $7eb6fbaa97f76140$export$2e2bcd8739ae039 extends (0, $goaLH.default) {
    basePath() {
        return '/gateway/api/assist/rovo/v1/agents';
    }
    sharedCacheKey(idValue) {
        return `${this.options.cloudId ?? ''}:${idValue}`;
    }
    getCachedProfile(idValue) {
        if (!(0, $cXtTj.default).getExperimentValue('platform_editor_agent_profile_card_fav_sync', 'isEnabled', false)) return super.getCachedProfile(idValue);
        const key = this.sharedCacheKey(idValue);
        const cached = (0, $bCBEs.sharedAgentProfileCache).get(key);
        if (!cached) return null;
        if (cached.expire < Date.now()) {
            (0, $bCBEs.sharedAgentProfileCache).delete(key);
            return null;
        }
        return cached.profile;
    }
    setCachedProfile(idValue, profile) {
        if (!(0, $cXtTj.default).getExperimentValue('platform_editor_agent_profile_card_fav_sync', 'isEnabled', false)) {
            super.setCachedProfile(idValue, profile);
            return;
        }
        (0, $bCBEs.sharedAgentProfileCache).set(this.sharedCacheKey(idValue), {
            expire: Date.now() + (this.config.cacheMaxAge || (0, $bCBEs.SHARED_CACHE_MAX_AGE)),
            profile: profile
        });
    }
    async getActivationId(cloudId, product) {
        const response = await (0, $de4Mg.AGGQuery)('/gateway/api/graphql', $7eb6fbaa97f76140$var$buildActivationIdQuery(cloudId, product));
        return response?.tenantContexts?.[0]?.activationIdByProduct?.active ?? null;
    }
    async getAgentByARIAgg(agentAri) {
        const response = await (0, $de4Mg.AGGQuery)('/gateway/api/graphql', $7eb6fbaa97f76140$var$buildRovoAgentQueryByAri(agentAri));
        if (response.agentStudio_agentById?.__typename === 'QueryError') throw new Error(`ProfileCard agentStudio_agentById returning QueryError: ${response.agentStudio_agentById.message}`);
        return response?.agentStudio_agentById;
    }
    async getAgentByAccountIdAgg(identityAccountId, cloudId) {
        const response = await (0, $de4Mg.AGGQuery)('/gateway/api/graphql', (0, $ixfCV.fg)('jira_ai_fix_agent_profile_card_flashing') ? $7eb6fbaa97f76140$var$buildRovoAgentQueryByAccountId(identityAccountId, cloudId) : $7eb6fbaa97f76140$var$buildRovoAgentQueryByAccountIdOld(identityAccountId, cloudId));
        if (response.agentStudio_agentByIdentityAccountId?.__typename === 'QueryError') throw new Error(`ProfileCard agentStudio_agentByIdentityAccountId returning QueryError: ${response.agentStudio_agentByIdentityAccountId.message}`);
        return response?.agentStudio_agentByIdentityAccountId;
    }
    makeRequest(id, analytics) {
        const product = this.options.productIdentifier || 'rovo';
        const headers = $7eb6fbaa97f76140$var$createHeaders(product, this.options.cloudId);
        let restPromise;
        if (id.type === 'identity') restPromise = fetch(new Request(`${this.basePath()}/accountid/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>{
            if (response.status === 403 && (0, $cXtTj.default).getExperimentValue('platform_editor_reduced_profile_cards', 'isEnabled', false)) throw new $7eb6fbaa97f76140$export$a6d78d75d03919f1();
            return response.json();
        });
        else restPromise = fetch(new Request(`${this.basePath()}/${id.value}`, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: headers
        })).then((response)=>{
            if (response.status === 403 && (0, $cXtTj.default).getExperimentValue('platform_editor_reduced_profile_cards', 'isEnabled', false)) throw new $7eb6fbaa97f76140$export$a6d78d75d03919f1();
            return response.json();
        });
        const aggStartTime = (0, $1GhPJ.getPageTime)();
        const aggPromise = this.getActivationId(this.options.cloudId || '', this.options.productIdentifier || 'rovo').then((activationId)=>{
            if (!activationId) throw new Error('ProfileCard Activation ID not found');
            if (id.type === 'identity') return this.getAgentByAccountIdAgg(id.value, this.options.cloudId || '');
            else {
                const agentAri = `ari:cloud:rovo::agent/activation/${activationId}/${id.value}`;
                return this.getAgentByARIAgg(agentAri);
            }
        })// We are not going to break the flow if the AGG endpoint fails for now
        // @TODO once all the data moved to AGG, we can remove this catch
        .catch((error)=>{
            if (analytics) analytics('operational.rovoAgentProfilecard.failed.request', {
                ...(0, $bTlNq.getErrorAttributes)(error),
                errorType: 'RovoAgentProfileCardAggError',
                duration: (0, $1GhPJ.getPageTime)() - aggStartTime,
                gateway: true,
                firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
            return Promise.resolve(null);
        });
        return Promise.all([
            restPromise,
            aggPromise
        ]).then(([restData, aggData])=>({
                restData: restData,
                aggData: aggData
            }));
    }
    /**
   * This function will call both REST and AGG endpoints to get the agent profile
   * There are some data that is only available in the AGG endpoint, so we need to call both
   * For any new fields, please only add them to the AGG endpoint
   *
   * @TODO migrate everything to AGG endpoint
   */ getProfile(id, analytics) {
        if (!id.value) return Promise.reject(new Error('Id is missing'));
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        const cache = this.getCachedProfile(id.value);
        if (cache) return Promise.resolve(cache);
        return new Promise((resolve, reject)=>{
            const startTime = (0, $1GhPJ.getPageTime)();
            if (analytics) analytics('operational.rovoAgentProfilecard.triggered.request', {
                firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
            this.makeRequest(id, analytics).then((data)=>{
                if (this.cache || (0, $cXtTj.default).getExperimentValue('platform_editor_agent_profile_card_fav_sync', 'isEnabled', false)) this.setCachedProfile(id.value, data);
                if (analytics) analytics('operational.rovoAgentProfilecard.succeeded.request', {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                resolve(data);
            }).catch((error)=>{
                if (analytics) analytics('operational.rovoAgentProfilecard.failed.request', {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    ...(0, $bTlNq.getErrorAttributes)(error),
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                reject(error);
            });
        });
    }
    deleteAgent(agentId, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $1GhPJ.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (analytics) analytics('operational.rovoAgentProfilecard.triggered.request', {
                firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
            const headers = $7eb6fbaa97f76140$var$createHeaders(product, this.options.cloudId);
            fetch(new Request(`${this.basePath()}/${agentId}`, {
                method: 'DELETE',
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics('operational.rovoAgentProfilecard.succeeded.deleteAgent', {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                resolve();
            }).catch((error)=>{
                if (analytics) analytics('operational.rovoAgentProfilecard.failed.deleteAgent', {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    ...(0, $bTlNq.getErrorAttributes)(error),
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                reject(error);
            });
        });
    }
    setFavouriteAgent(agentId, isFavourite, analytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise(async (resolve, reject)=>{
            const startTime = (0, $1GhPJ.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            const actionSubjectId = isFavourite ? 'favourite' : 'unfavourite';
            const requestMethod = isFavourite ? 'POST' : 'DELETE';
            if (analytics) analytics(`operational.rovoAgentProfilecard.triggered.${actionSubjectId}`, {
                firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
            const headers = $7eb6fbaa97f76140$var$createHeaders(product, this.options.cloudId);
            await fetch(new Request(`${this.basePath()}/${agentId}/favourite`, {
                method: requestMethod,
                credentials: 'include',
                mode: 'cors',
                headers: headers
            })).then(()=>{
                if (analytics) analytics(`operational.rovoAgentProfilecard.succeeded.${actionSubjectId}`, {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                if ((0, $cXtTj.default).getExperimentValue('platform_editor_agent_profile_card_fav_sync', 'isEnabled', false)) this.syncFavouriteToCache(agentId, isFavourite);
                resolve();
            }).catch((error)=>{
                if (analytics) analytics(`operational.rovoAgentProfilecard.failed.${actionSubjectId}`, {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    ...(0, $bTlNq.getErrorAttributes)(error),
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                reject(error);
            });
        });
    }
    /**
   * Keeps the shared agent profile cache in sync with the favourite state
   */ syncFavouriteToCache(agentId, isFavourite) {
        const prefix = `${this.options.cloudId ?? ''}:`;
        const keysToUpdate = [];
        (0, $bCBEs.sharedAgentProfileCache).forEach((cached, key)=>{
            if (key.startsWith(prefix) && cached.profile?.restData?.id === agentId) keysToUpdate.push(key);
        });
        keysToUpdate.forEach((key)=>{
            const cached = (0, $bCBEs.sharedAgentProfileCache).get(key);
            if (!cached) return;
            const { restData: restData } = cached.profile;
            const wasFavourite = restData.favourite;
            const currentCount = restData.favourite_count ?? 0;
            const favouriteCount = isFavourite ? currentCount + (wasFavourite ? 0 : 1) : Math.max(0, currentCount - (wasFavourite ? 1 : 0));
            (0, $bCBEs.sharedAgentProfileCache).set(key, {
                ...cached,
                profile: {
                    ...cached.profile,
                    restData: {
                        ...restData,
                        favourite: isFavourite,
                        favourite_count: favouriteCount
                    }
                }
            });
        });
    }
    getPermissions(id, fireAnalytics) {
        if (!this.options.cloudId) return Promise.reject(new Error('cloudId is missing'));
        return new Promise((resolve, reject)=>{
            const startTime = (0, $1GhPJ.getPageTime)();
            const product = this.options.productIdentifier || 'rovo';
            if (fireAnalytics) fireAnalytics('operational.rovoAgentProfilecard.triggered.request', {
                firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
            const headers = $7eb6fbaa97f76140$var$createHeaders(product, this.options.cloudId, true);
            fetch(new Request(`/gateway/api/assist/api/rovo/v2/permissions/agents/${id}`, {
                method: 'POST',
                credentials: 'include',
                mode: 'cors',
                headers: headers,
                body: JSON.stringify({
                    permission_ids: [
                        'AGENT_CREATE',
                        'AGENT_UPDATE',
                        'AGENT_DELETE',
                        'AGENT_DEACTIVATE',
                        'AGENT_READ'
                    ]
                })
            })).then((response)=>response.json()).then((data)=>{
                if (fireAnalytics) fireAnalytics('operational.rovoAgentProfilecard.succeeded.getAgentPermissions', {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                resolve(data);
            }).catch((error)=>{
                if (fireAnalytics) fireAnalytics('operational.rovoAgentProfilecard.failed.getAgentPermissions', {
                    duration: (0, $1GhPJ.getPageTime)() - startTime,
                    ...(0, $bTlNq.getErrorAttributes)(error),
                    gateway: true,
                    firedAt: Math.round((0, $1GhPJ.getPageTime)()),
                    ...(0, $cSSWJ.PACKAGE_META_DATA)
                });
                reject(error);
            });
        });
    }
    constructor(options){
        super(options);
        this.options = void 0;
        this.options = options;
    }
}
module.exports["AgentForbiddenError"] = $7eb6fbaa97f76140$export$a6d78d75d03919f1;
module.exports["default"] = $7eb6fbaa97f76140$export$2e2bcd8739ae039;

});

parcelRegister("dRAjC", function(module, exports) {
const $d2643a1af3062f27$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $d2643a1af3062f27$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($d2643a1af3062f27$export$470b0d72e4fdc43a, '');
};
module.exports["USER_ARI_PREFIX"] = $d2643a1af3062f27$export$470b0d72e4fdc43a;
module.exports["getAAIDFromARI"] = $d2643a1af3062f27$export$3761e66a04602cbd;

});

parcelRegister("goaLH", function(module, exports) {

var $lPEt0 = parcelRequire("lPEt0");

class $796bf3f876369ae9$export$2e2bcd8739ae039 {
    setCachedProfile(cacheIdentifier, profile) {
        this.cache && this.cache.set(cacheIdentifier, {
            expire: Date.now() + this.config.cacheMaxAge,
            profile: profile
        });
    }
    getCachedProfile(cacheIdentifier) {
        if (!this.cache) return null;
        const cached = this.cache.get(cacheIdentifier);
        if (!cached) return null;
        if (cached.expire < Date.now()) {
            this.cache.delete(cacheIdentifier);
            return null;
        }
        // Extend expiry "date"
        this.setCachedProfile(cacheIdentifier, cached.profile);
        return cached.profile;
    }
    flushCache() {
        if (this.cache) this.cache.clear();
    }
    constructor(config){
        this.config = void 0;
        this.cache = void 0;
        const defaults = {
            cacheSize: 10,
            cacheMaxAge: 0
        };
        this.config = {
            ...defaults,
            ...config
        };
        // never set cacheSize or cacheMaxAge to negative numbers
        this.config.cacheSize = Math.max(this.config.cacheSize || 0, 0);
        this.config.cacheMaxAge = Math.max(this.config.cacheMaxAge || 0, 0);
        // DIR-474: cap cache at 30 days.
        if (this.config.cacheMaxAge) this.config.cacheMaxAge = Math.min(this.config.cacheMaxAge, 2592000000);
        // Only set cache if maxCacheAge and cacheSize are set
        this.cache = !this.config.cacheMaxAge || !this.config.cacheSize ? null : new (0, $lPEt0.LRUMap)(this.config.cacheSize);
    }
}
module.exports["default"] = $796bf3f876369ae9$export$2e2bcd8739ae039;

});

parcelRegister("bTlNq", function(module, exports) {

var $44kjq = parcelRequire("44kjq");

const $ee2789e570b42c37$var$IGNORED_ERROR_REASONS_DIRECTORY = [
    // Error categories from pf-directory
    'NotPermitted',
    'Gone',
    'IdentityUserNotFoundError'
];
const $ee2789e570b42c37$var$IGNORE_ERROR_TYPES_AGG = [
    'IdentityUserNotFoundError',
    'TEAMS_FORBIDDEN',
    'TEAMS_TEAM_DELETED'
];
const $ee2789e570b42c37$var$IGNORE_ERROR_CLASSIFICATIONS_AGG = [
    'Gone'
];
function $ee2789e570b42c37$var$isIgnoredError(error) {
    if (!error) return false;
    if (error instanceof (0, $44kjq.DirectoryGraphQLError)) return !!error && $ee2789e570b42c37$var$IGNORED_ERROR_REASONS_DIRECTORY.includes(error.type);
    else if (error instanceof (0, $44kjq.AGGError)) return !!error.errorType && $ee2789e570b42c37$var$IGNORE_ERROR_TYPES_AGG.includes(error.errorType) || !!error.classification && $ee2789e570b42c37$var$IGNORE_ERROR_CLASSIFICATIONS_AGG.includes(error.classification);
    return false;
}
const $ee2789e570b42c37$export$6ad9e7706a4ee0f8 = (error)=>{
    const defaultErrorAttributes = {
        errorCount: null,
        errorDetails: null,
        errorCategory: null,
        errorType: null,
        errorPath: null,
        errorNumber: null,
        errorStatusCode: null,
        traceId: null,
        errorStack: null
    };
    if (error instanceof (0, $44kjq.DirectoryGraphQLErrors)) return {
        ...defaultErrorAttributes,
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($ee2789e570b42c37$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($ee2789e570b42c37$var$isIgnoredError),
        traceId: error.traceId ?? null
    };
    else if (error instanceof (0, $44kjq.DirectoryGraphQLError)) return {
        ...defaultErrorAttributes,
        errorMessage: error.message,
        errorCategory: error.category,
        errorType: error.type,
        errorPath: error.path,
        errorNumber: error.errorNumber ?? null,
        isSLOFailure: !$ee2789e570b42c37$var$isIgnoredError(error)
    };
    else if (error instanceof (0, $44kjq.AGGErrors)) return {
        ...defaultErrorAttributes,
        errorMessage: error.message,
        errorCount: error.errors.length,
        errorDetails: error.errors.map($ee2789e570b42c37$export$6ad9e7706a4ee0f8),
        isSLOFailure: !error.errors.every($ee2789e570b42c37$var$isIgnoredError),
        traceId: error.traceId ?? null
    };
    else if (error instanceof (0, $44kjq.AGGError)) return {
        ...defaultErrorAttributes,
        errorMessage: error.message,
        errorType: error.errorType ?? null,
        errorStatusCode: error.statusCode ?? null,
        isSLOFailure: !$ee2789e570b42c37$var$isIgnoredError(error),
        errorCategory: error.classification ?? null
    };
    else if (error instanceof Error) {
        // Jira custom profile card client error, they wrap the error & put the underlying error in the cause property
        if (error.message.startsWith('Unable to fetch user:')) {
            if (error.hasOwnProperty('cause')) {
                const causeError = error.cause;
                if (causeError instanceof (0, $44kjq.DirectoryGraphQLErrors) || causeError instanceof (0, $44kjq.AGGErrors)) return $ee2789e570b42c37$export$6ad9e7706a4ee0f8(causeError);
            }
            return {
                ...defaultErrorAttributes,
                errorMessage: error.message,
                isSLOFailure: false
            };
        }
        return {
            ...defaultErrorAttributes,
            errorMessage: error.message,
            isSLOFailure: true
        };
    }
    // Unknown
    return {
        ...defaultErrorAttributes,
        errorMessage: 'Unknown error',
        isSLOFailure: true
    };
};
const $ee2789e570b42c37$export$7642af465ceb7f05 = (errors, traceId)=>{
    throw new (0, $44kjq.DirectoryGraphQLErrors)(errors, traceId);
};
const $ee2789e570b42c37$export$d9ad65d422ee3f8c = (errors, traceId)=>{
    throw new (0, $44kjq.AGGErrors)(errors, traceId);
};
module.exports["getErrorAttributes"] = $ee2789e570b42c37$export$6ad9e7706a4ee0f8;
module.exports["handleDirectoryGraphQLErrors"] = $ee2789e570b42c37$export$7642af465ceb7f05;
module.exports["handleAGGErrors"] = $ee2789e570b42c37$export$d9ad65d422ee3f8c;

});

parcelRegister("44kjq", function(module, exports) {
class $6e856ef94dca185e$export$65bd6083489bd8bb extends Error {
    constructor(code, reason, traceId){
        super(reason);
        this.code = void 0;
        this.traceId = void 0;
        this.code = code;
        this.traceId = traceId;
    }
}
class $6e856ef94dca185e$export$c1e4d0de940c06a2 extends Error {
    constructor(message, category, type, extensions = {}, path = []){
        super(message);
        this.category = void 0;
        this.type = void 0;
        this.path = void 0;
        this.errorNumber = void 0;
        this.extensions = void 0;
        this.category = category;
        this.type = type;
        this.path = path.join('.');
        const { errorNumber: errorNumber, ...unknownExtension } = extensions;
        this.errorNumber = extensions.errorNumber;
        this.extensions = unknownExtension;
    }
}
class $6e856ef94dca185e$export$5a5fbfed34a590a1 extends Error {
    constructor(errors, traceId){
        super('DirectoryGraphQLErrors');
        this.errors = void 0;
        this.traceId = void 0;
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $6e856ef94dca185e$export$c1e4d0de940c06a2(error.message, error.category, error.type, error.extensions, error.path));
        else this.errors = [];
    }
}
class $6e856ef94dca185e$export$4a696f048dcc929 extends Error {
    constructor(message, extensions, path = []){
        super(message);
        this.path = void 0;
        this.extensions = void 0;
        this.statusCode = void 0;
        this.errorType = void 0;
        this.classification = void 0;
        this.path = path?.join('.');
        const { statusCode: statusCode, errorType: errorType, classification: classification, ...unknownExtension } = extensions;
        this.statusCode = statusCode;
        this.errorType = errorType;
        this.classification = classification;
        this.extensions = unknownExtension;
    }
}
class $6e856ef94dca185e$export$60d8267243755b9c extends Error {
    constructor(errors, traceId){
        super('AGGErrors');
        this.errors = void 0;
        this.traceId = void 0;
        this.traceId = traceId;
        if (Array.isArray(errors)) this.errors = errors.map((error)=>new $6e856ef94dca185e$export$4a696f048dcc929(error.message, error.extensions, error.path));
        else this.errors = [];
    }
}
module.exports["HttpError"] = $6e856ef94dca185e$export$65bd6083489bd8bb;
module.exports["DirectoryGraphQLError"] = $6e856ef94dca185e$export$c1e4d0de940c06a2;
module.exports["DirectoryGraphQLErrors"] = $6e856ef94dca185e$export$5a5fbfed34a590a1;
module.exports["AGGError"] = $6e856ef94dca185e$export$4a696f048dcc929;
module.exports["AGGErrors"] = $6e856ef94dca185e$export$60d8267243755b9c;

});

parcelRegister("de4Mg", function(module, exports) {

var $44kjq = parcelRequire("44kjq");


var $bTlNq = parcelRequire("bTlNq");

const $c62bb02609d7d21d$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
const $c62bb02609d7d21d$var$id = (headers)=>headers;
async function $c62bb02609d7d21d$export$a5b5995619d4fe36(serviceUrl, query, processHeaders = $c62bb02609d7d21d$var$id) {
    return $c62bb02609d7d21d$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $bTlNq.handleDirectoryGraphQLErrors));
}
async function $c62bb02609d7d21d$export$a14afb5f82fe705(serviceUrl, query, processHeaders = $c62bb02609d7d21d$var$id) {
    return $c62bb02609d7d21d$var$graphQLQuery(serviceUrl, query, processHeaders, (0, $bTlNq.handleAGGErrors));
}
async function $c62bb02609d7d21d$var$graphQLQuery(serviceUrl, query, processHeaders = $c62bb02609d7d21d$var$id, handleErrors) {
    const headers = processHeaders($c62bb02609d7d21d$var$buildHeaders());
    const response = await fetch(new Request(serviceUrl, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    }));
    const traceIdFromHeaders = response?.headers?.get('atl-traceid');
    if (!response.ok) throw new (0, $44kjq.HttpError)(response.status, response.statusText, traceIdFromHeaders);
    const json = await response.json();
    if (json.errors) handleErrors(json.errors, json.extensions?.gateway?.request_id ?? traceIdFromHeaders);
    return json.data;
}
module.exports["directoryGraphqlQuery"] = $c62bb02609d7d21d$export$a5b5995619d4fe36;
module.exports["AGGQuery"] = $c62bb02609d7d21d$export$a14afb5f82fe705;

});

parcelRegister("bCBEs", function(module, exports) {

var $lPEt0 = parcelRequire("lPEt0");

const $0e922c460acdfb54$var$SHARED_CACHE_SIZE = 50;
const $0e922c460acdfb54$export$815222107f6bee54 = 300000; // 5 minutes
const $0e922c460acdfb54$export$d0bf8b40238c05cd = new (0, $lPEt0.LRUMap)($0e922c460acdfb54$var$SHARED_CACHE_SIZE);
module.exports["SHARED_CACHE_MAX_AGE"] = $0e922c460acdfb54$export$815222107f6bee54;
module.exports["sharedAgentProfileCache"] = $0e922c460acdfb54$export$d0bf8b40238c05cd;

});

parcelRegister("kb2tZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $d107d3e886647d93$var$styles = {
    wrapper: "_2rko1mok _1bsb1gwv _bfhk1bhr"
};
const $d107d3e886647d93$export$2c6604b50c274e6f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $d107d3e886647d93$var$styles.wrapper
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $d107d3e886647d93$var$styles.wrapper
    }, children);
};
module.exports["AgentProfileCardWrapper"] = $d107d3e886647d93$export$2c6604b50c274e6f;

});

parcelRegister("hIwXM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $795534535f4e0b8b$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("aIQZv")));
module.exports["AgentProfileCardLazy"] = $795534535f4e0b8b$export$ed0ca9c1d49ea0bf;

});

parcelRegister("aIQZv", function(module, exports) {

let $7ce71e5b9167863f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7ce71e5b9167863f$var$load("iUXaE"),
    $7ce71e5b9167863f$var$load("lTkx9"),
    $7ce71e5b9167863f$var$load("6wr18"),
    $7ce71e5b9167863f$var$load("6uvkG"),
    $7ce71e5b9167863f$var$load("jqoep"),
    $7ce71e5b9167863f$var$load("7EorR"),
    $7ce71e5b9167863f$var$load("8zMmc"),
    $7ce71e5b9167863f$var$load("ffEVr"),
    $7ce71e5b9167863f$var$load("hhss7"),
    $7ce71e5b9167863f$var$load("68aog")
]).then(()=>parcelRequire('ark00'));

});

parcelRegister("a2bT0", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ekCm6 = parcelRequire("ekCm6");


var $w6R6I = parcelRequire("w6R6I");


var $ixfCV = parcelRequire("ixfCV");


var $iMnC5 = parcelRequire("iMnC5");

const $86a4b05b54bce4ef$var$styles = {
    image: "_5ral1dfr _4t3i1osq _1bsb1osq _1e0c1txw _1bah1h6o _4cvr1h6o",
    banner: "_1bsb1osq",
    bannerFillSpace: "_1bsb1osq _4t3i1osq _5ral1dfr",
    bannerRemoteA2A: "_bfhk7qp0"
};
const $86a4b05b54bce4ef$var$Observer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { onLoad: onLoad } = t0;
    let t1;
    let t2;
    if ($[0] !== onLoad) {
        t1 = ()=>{
            onLoad();
        };
        t2 = [
            onLoad
        ];
        $[0] = onLoad;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
} : ({ onLoad: onLoad })=>{
    (0, $cozmU.useEffect)(()=>{
        onLoad();
    }, [
        onLoad
    ]);
    return null;
};

const $86a4b05b54bce4ef$var$AutoDevAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("kYpKY")));

const $86a4b05b54bce4ef$var$AutoFixAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("feg39")));

const $86a4b05b54bce4ef$var$AutoReviewAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("4RJuR")));

const $86a4b05b54bce4ef$var$BacklogBuddyAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("di1lo")));

const $86a4b05b54bce4ef$var$CommsCrafterAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("j5vOg")));

const $86a4b05b54bce4ef$var$CultureAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("ir4Zs")));

const $86a4b05b54bce4ef$var$CustomerInsightAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("huaWP")));

const $86a4b05b54bce4ef$var$DecisionDirectorAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("e7aux")));

const $86a4b05b54bce4ef$var$FeatureFlagAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("ef6sM")));

const $86a4b05b54bce4ef$var$GenericAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("eMArC")));

const $86a4b05b54bce4ef$var$HireWriterAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("lLIpI")));

const $86a4b05b54bce4ef$var$MarketingMessageMaestroAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("guf1O")));

const $86a4b05b54bce4ef$var$MyUserManualAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("fqQ0Z")));

const $86a4b05b54bce4ef$var$OkrOracleAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("g5Au7")));

const $86a4b05b54bce4ef$var$OpsAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("jduPc")));

const $86a4b05b54bce4ef$var$PitchPerfectorAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("2BsbE")));

const $86a4b05b54bce4ef$var$ProductRequirementAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("ccwx8")));

const $86a4b05b54bce4ef$var$ReleaseNotesAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("kCYzi")));

const $86a4b05b54bce4ef$var$ResearchScoutAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("eGpCl")));

const $86a4b05b54bce4ef$var$RovoDevAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("iLJ1v")));

const $86a4b05b54bce4ef$var$SocialMediaScribeAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("j6OuY")));

const $86a4b05b54bce4ef$var$TeamConnectionAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("ddq5w")));

const $86a4b05b54bce4ef$var$WorkflowBuilderAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("lnaW2")));

const $86a4b05b54bce4ef$var$TrialGuideAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("jMZdA")));

const $86a4b05b54bce4ef$var$JsmRovoServiceAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("4Jhm3"))); /**
                                      * OOTB Agents avatars - start
                                      */ 

const $86a4b05b54bce4ef$var$AmplitudeAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("1lG7v")));

const $86a4b05b54bce4ef$var$BoxAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("cr6cT")));

const $86a4b05b54bce4ef$var$CanvaAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("l39Ik")));

const $86a4b05b54bce4ef$var$FigmaAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("eWJHH")));

const $86a4b05b54bce4ef$var$HubSpotAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("hpLK5")));

const $86a4b05b54bce4ef$var$IntercomAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("ceWMu")));

const $86a4b05b54bce4ef$var$GammaAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("5BSGs")));

const $86a4b05b54bce4ef$var$LovableAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("dU4PR")));

const $86a4b05b54bce4ef$var$ReplitAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("4d0IW")));

const $86a4b05b54bce4ef$var$RovoAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("7kGM2")));

const $86a4b05b54bce4ef$var$JiraWorkAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("hNwBH")));

const $86a4b05b54bce4ef$var$JiraCodingAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("eYFGv")));

const $86a4b05b54bce4ef$var$JiraIntelligentTriageAgentAvatar = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("hUkXO"))); /**
                                             * OOTB Agents avatars - end
                                             */ 
const $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2 = {
    primary: '#FCA700',
    secondary: '#FFC716'
};
const $86a4b05b54bce4ef$export$3e344798f7855e62 = {
    primary: '#BF63F3',
    secondary: '#D8A0F7'
};
const $86a4b05b54bce4ef$export$a3d0897f023251ae = {
    primary: '#82B536',
    secondary: '#B3DF72'
};
const $86a4b05b54bce4ef$export$d933daaf7b69e6ee = {
    primary: '#357DE8',
    secondary: '#669DF1'
};
const $86a4b05b54bce4ef$var$colorList = [
    $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2,
    $86a4b05b54bce4ef$export$3e344798f7855e62,
    $86a4b05b54bce4ef$export$a3d0897f023251ae,
    $86a4b05b54bce4ef$export$d933daaf7b69e6ee
]; /**
                                                                               * NOTE: DO NOT ADD OOTB AGENTAVATARS TO THIS LIST
                                                                               */ 
const $86a4b05b54bce4ef$var$avatarList = [
    $86a4b05b54bce4ef$var$CustomerInsightAvatar,
    $86a4b05b54bce4ef$var$BacklogBuddyAvatar,
    $86a4b05b54bce4ef$var$DecisionDirectorAvatar,
    $86a4b05b54bce4ef$var$CommsCrafterAvatar,
    $86a4b05b54bce4ef$var$AutoDevAvatar,
    $86a4b05b54bce4ef$var$OkrOracleAvatar,
    $86a4b05b54bce4ef$var$CultureAvatar,
    $86a4b05b54bce4ef$var$SocialMediaScribeAvatar,
    $86a4b05b54bce4ef$var$TeamConnectionAvatar,
    $86a4b05b54bce4ef$var$HireWriterAvatar,
    $86a4b05b54bce4ef$var$OpsAgentAvatar,
    $86a4b05b54bce4ef$var$ResearchScoutAvatar,
    $86a4b05b54bce4ef$var$ReleaseNotesAvatar,
    $86a4b05b54bce4ef$var$MyUserManualAvatar,
    $86a4b05b54bce4ef$var$PitchPerfectorAvatar,
    $86a4b05b54bce4ef$var$AutoDevAvatar,
    $86a4b05b54bce4ef$var$AutoFixAvatar,
    $86a4b05b54bce4ef$var$AutoReviewAvatar,
    $86a4b05b54bce4ef$var$MarketingMessageMaestroAvatar,
    $86a4b05b54bce4ef$var$FeatureFlagAvatar,
    $86a4b05b54bce4ef$var$ProductRequirementAvatar
];
const $86a4b05b54bce4ef$export$a834793a4d0d739e = $86a4b05b54bce4ef$var$avatarList.length * $86a4b05b54bce4ef$var$colorList.length;
const $86a4b05b54bce4ef$var$outOfTheBoxAgentAvatar = {
    autodev_template_unit_test_creator: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$AutoFixAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.secondary
            }),
        color: $86a4b05b54bce4ef$export$a3d0897f023251ae
    },
    autodev_template_migration_config_changer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$OpsAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.secondary
            }),
        color: $86a4b05b54bce4ef$export$a3d0897f023251ae
    },
    autodev_template_vulnerable_dependency_updater_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$MarketingMessageMaestroAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.secondary
            }),
        color: $86a4b05b54bce4ef$export$a3d0897f023251ae
    },
    autodev_template_code_standardizer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$MyUserManualAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.secondary
            }),
        color: $86a4b05b54bce4ef$export$a3d0897f023251ae
    },
    autodev_template_code_observer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$ResearchScoutAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.secondary
            }),
        color: $86a4b05b54bce4ef$export$a3d0897f023251ae
    },
    autodev_template_code_accessibility_checker_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$HireWriterAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.secondary
            }),
        color: $86a4b05b54bce4ef$export$a3d0897f023251ae
    },
    autodev_code_documentation_writer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$SocialMediaScribeAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.secondary
            }),
        color: $86a4b05b54bce4ef$export$a3d0897f023251ae
    },
    autodev_feature_flag_cleaner_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$FeatureFlagAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.secondary
            }),
        color: $86a4b05b54bce4ef$export$a3d0897f023251ae
    },
    decision_director_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$DecisionDirectorAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.secondary
            }),
        color: $86a4b05b54bce4ef$export$a3d0897f023251ae
    },
    planner_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$OpsAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$3e344798f7855e62.primary,
                secondaryColor: $86a4b05b54bce4ef$export$3e344798f7855e62.secondary
            }),
        color: $86a4b05b54bce4ef$export$3e344798f7855e62
    },
    user_manual_writer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$MyUserManualAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2
    },
    product_requirements_expert_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$ProductRequirementAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2
    },
    issue_organizer_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$BacklogBuddyAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.secondary
            }),
        color: $86a4b05b54bce4ef$export$a3d0897f023251ae
    },
    ops_guide_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$OpsAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2
    },
    discovery_and_feedback_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$CommsCrafterAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.primary,
                secondaryColor: $86a4b05b54bce4ef$export$a3d0897f023251ae.secondary
            }),
        color: $86a4b05b54bce4ef$export$a3d0897f023251ae
    },
    jira_workflow_builder_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$WorkflowBuilderAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.primary,
                secondaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.secondary
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    itops_rca_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$AutoReviewAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2
    },
    jira_trial_guide_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$TrialGuideAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.primary,
                secondaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.secondary
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    daily_brief_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$TrialGuideAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.primary,
                secondaryColor: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2.secondary
            }),
        color: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2
    },
    jira_admin_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$AutoDevAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.primary,
                secondaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.secondary
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    jsm_rovo_service_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$JsmRovoServiceAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $86a4b05b54bce4ef$export$cf7c9ad03f4a70b2
    },
    mcp_amplitude_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$AmplitudeAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    mcp_box_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$BoxAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    mcp_canva_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$CanvaAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    mcp_figma_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$FigmaAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    mcp_hubspot_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$HubSpotAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    mcp_intercom_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$IntercomAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    mcp_gamma_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$GammaAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    mcp_lovable_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$LovableAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    mcp_replit_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$ReplitAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    rovo_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RovoAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    jira_work_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$JiraWorkAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    jira_intelligent_triage_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$JiraIntelligentTriageAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    },
    jira_coding_agent: {
        getRender: (size)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$JiraCodingAgentAvatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: "",
                secondaryColor: ""
            }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    }
}; /**
    * agentIdentityAccountId examples:
    * 5b985e7c96cb052b5f65c830
    * 712020:19e57f67-c132-462b-8503-0c19953122cd
    *
    * agentId examples:
    * cd002f25-46e4-4023-80ff-32e4d90849b4
    */ 
const $86a4b05b54bce4ef$export$c84eb7708138dd4 = ({ agentIdentityAccountId: agentIdentityAccountId, agentId: agentId })=>{
    // we prioritise agentIdentityAccountId first if it is available
    // this is because agentIdentityAccountId is more widely available (e.g. in ProfilePage)
    const idForAgentAvatar = agentIdentityAccountId || agentId;
    if (idForAgentAvatar) {
        // Take the last 8 characters of the id because JS can't handle 16 digit numbers
        const trimmedId = idForAgentAvatar.slice(-8).replace(/[-:]/g, '');
        const parsedId = parseInt(trimmedId, 16);
        if (isNaN(parsedId)) return 0;
        else return parsedId;
    }
    return null;
};
const $86a4b05b54bce4ef$var$ROVO_DEV_AGENT_ID = '027f0676-e8e9-4939-8962-3850987d78bb';
const $86a4b05b54bce4ef$var$getAvatarRender = ({ agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, isRovoDev: isRovoDev, size: size })=>{
    if (isRovoDev) return {
        render: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RovoDevAvatar, {
            size: (0, $ekCm6.AVATAR_SIZES)[size],
            primaryColor: "",
            secondaryColor: ""
        }),
        color: $86a4b05b54bce4ef$export$a3d0897f023251ae
    };
     //@TODO CRCS-3129: Remove Rovo Dev hardcoded icon after TeamEU demos
    // Handle Rovo Dev agent avatar for TeamEU Demo
    if (agentId === $86a4b05b54bce4ef$var$ROVO_DEV_AGENT_ID && (0, $ixfCV.fg)('jira_ai_force_rovo_dev_avatar')) return {
        render: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$RovoDevAvatar, {
            size: (0, $ekCm6.AVATAR_SIZES)[size],
            primaryColor: "",
            secondaryColor: ""
        }),
        color: $86a4b05b54bce4ef$export$a3d0897f023251ae
    };
    if (typeof agentNamedId === 'string' && $86a4b05b54bce4ef$var$outOfTheBoxAgentAvatar[agentNamedId]) {
        const ootbAvatarResult = $86a4b05b54bce4ef$var$outOfTheBoxAgentAvatar[agentNamedId];
        return {
            render: ootbAvatarResult.getRender(size),
            color: ootbAvatarResult.color
        };
    }
    const numberId = $86a4b05b54bce4ef$export$c84eb7708138dd4({
        agentIdentityAccountId: agentIdentityAccountId,
        agentId: agentId
    });
    if (numberId !== null) {
        /**
     * this create all possible combinations of avatars and colors
     * e.g. [[avatar1, color1], [avatar1, color2], [avatar2, color1], [avatar2, color2]]
     * then choose 1 based on agentId
     */ const totalCombinations = $86a4b05b54bce4ef$var$avatarList.length * $86a4b05b54bce4ef$var$colorList.length;
        const combinationIndex = numberId % totalCombinations;
        const avatarIndex = Math.floor(combinationIndex / $86a4b05b54bce4ef$var$colorList.length);
        const colorIndex = combinationIndex % $86a4b05b54bce4ef$var$colorList.length;
        const Avatar = $86a4b05b54bce4ef$var$avatarList[avatarIndex];
        const color = $86a4b05b54bce4ef$var$colorList[colorIndex];
        return {
            render: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Avatar, {
                size: (0, $ekCm6.AVATAR_SIZES)[size],
                primaryColor: color.primary,
                secondaryColor: color.secondary
            }),
            color: color
        };
    }
    return {
        render: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$GenericAvatar, {
            size: (0, $ekCm6.AVATAR_SIZES)[size],
            primaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.primary,
            secondaryColor: $86a4b05b54bce4ef$export$d933daaf7b69e6ee.secondary
        }),
        color: $86a4b05b54bce4ef$export$d933daaf7b69e6ee
    };
};
const $86a4b05b54bce4ef$export$6efaefb8ad2fba40 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, isRovoDev: isRovoDev, creatorType: creatorType, height: height, fillSpace: fillSpace } = t0;
    let t1;
    if ($[0] !== agentId || $[1] !== agentIdentityAccountId || $[2] !== agentNamedId || $[3] !== isRovoDev) {
        t1 = $86a4b05b54bce4ef$var$getAvatarRender({
            agentNamedId: agentNamedId,
            agentId: agentId,
            agentIdentityAccountId: agentIdentityAccountId,
            isRovoDev: isRovoDev,
            size: "medium"
        });
        $[0] = agentId;
        $[1] = agentIdentityAccountId;
        $[2] = agentNamedId;
        $[3] = isRovoDev;
        $[4] = t1;
    } else t1 = $[4];
    const { color: color } = t1;
    const isRemoteA2A = (0, $ixfCV.fg)("jira_improve_agent_profile_for_a2a") && creatorType === "REMOTE_A2A";
    const t2 = fillSpace ? $86a4b05b54bce4ef$var$styles.bannerFillSpace : undefined;
    const t3 = isRemoteA2A ? $86a4b05b54bce4ef$var$styles.bannerRemoteA2A : undefined;
    let t4;
    if ($[5] !== t2 || $[6] !== t3) {
        t4 = (0, $w6R6I.cx)($86a4b05b54bce4ef$var$styles.banner, t2, t3);
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    const t5 = isRemoteA2A ? undefined : color.primary;
    const t6 = height ? `${height}px` : undefined;
    let t7;
    if ($[8] !== t5 || $[9] !== t6) {
        t7 = {
            backgroundColor: t5,
            height: t6
        };
        $[8] = t5;
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] !== t4 || $[12] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: t4,
            style: t7
        });
        $[11] = t4;
        $[12] = t7;
        $[13] = t8;
    } else t8 = $[13];
    return t8;
} : ({ agentNamedId: agentNamedId, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, isRovoDev: isRovoDev, creatorType: creatorType, height: height, fillSpace: fillSpace })=>{
    const { color: color } = $86a4b05b54bce4ef$var$getAvatarRender({
        agentNamedId: agentNamedId,
        agentId: agentId,
        agentIdentityAccountId: agentIdentityAccountId,
        isRovoDev: isRovoDev,
        size: 'medium'
    });
    const isRemoteA2A = (0, $ixfCV.fg)('jira_improve_agent_profile_for_a2a') && creatorType === 'REMOTE_A2A';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($86a4b05b54bce4ef$var$styles.banner, fillSpace ? $86a4b05b54bce4ef$var$styles.bannerFillSpace : undefined, isRemoteA2A ? $86a4b05b54bce4ef$var$styles.bannerRemoteA2A : undefined),
        style: {
            backgroundColor: isRemoteA2A ? undefined : color.primary,
            height: height ? `${height}px` : undefined
        }
    });
};
const $86a4b05b54bce4ef$export$96bb253b7de22616 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(12);
    let t0;
    if ($[0] !== props) {
        t0 = $86a4b05b54bce4ef$var$getAvatarRender(props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    const { render: render, color: color } = t0;
    const { onLoad: onLoad } = props;
    let t1;
    if ($[2] !== color.primary) {
        t1 = {
            backgroundColor: color.primary
        };
        $[2] = color.primary;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== onLoad) {
        t2 = onLoad && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$Observer, {
            onLoad: onLoad
        });
        $[4] = onLoad;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== render || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, t2, render);
        $[6] = render;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== t1 || $[10] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $86a4b05b54bce4ef$var$styles.image,
            style: t1
        }, t3);
        $[9] = t1;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : (props)=>{
    const { render: render, color: color } = $86a4b05b54bce4ef$var$getAvatarRender(props);
    const { onLoad: onLoad } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $86a4b05b54bce4ef$var$styles.image,
        style: {
            backgroundColor: color.primary
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, onLoad && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86a4b05b54bce4ef$var$Observer, {
        onLoad: onLoad
    }), render));
};
module.exports["AgentBanner"] = $86a4b05b54bce4ef$export$6efaefb8ad2fba40;
module.exports["GeneratedAvatar"] = $86a4b05b54bce4ef$export$96bb253b7de22616;

});

parcelRegister("kYpKY", function(module, exports) {

let $f44d63f7a74f8acb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f44d63f7a74f8acb$var$load("iMObC").then(()=>parcelRequire('iXsN7'));

});

parcelRegister("feg39", function(module, exports) {

let $b1649cfe483ec9a0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b1649cfe483ec9a0$var$load("kstRm").then(()=>parcelRequire('bK6sM'));

});

parcelRegister("4RJuR", function(module, exports) {

let $38af675cb55db454$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $38af675cb55db454$var$load("llcXv").then(()=>parcelRequire('dCNdL'));

});

parcelRegister("di1lo", function(module, exports) {

let $9acdffb5c59e3f0d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9acdffb5c59e3f0d$var$load("b4KKP").then(()=>parcelRequire('20vx6'));

});

parcelRegister("j5vOg", function(module, exports) {

let $de5728acaffb9591$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $de5728acaffb9591$var$load("407ox").then(()=>parcelRequire('4MOGN'));

});

parcelRegister("ir4Zs", function(module, exports) {

let $d6be9e8e0052869c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d6be9e8e0052869c$var$load("48VmB").then(()=>parcelRequire('h7Jie'));

});

parcelRegister("huaWP", function(module, exports) {

let $cbadbb06a0117620$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cbadbb06a0117620$var$load("7J2T4").then(()=>parcelRequire('jEDvD'));

});

parcelRegister("e7aux", function(module, exports) {

let $a469db8def0a1348$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a469db8def0a1348$var$load("k8VH8").then(()=>parcelRequire('8DKak'));

});

parcelRegister("ef6sM", function(module, exports) {

let $a5e77ad7ccb3cdb5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a5e77ad7ccb3cdb5$var$load("73ECg").then(()=>parcelRequire('K1eyd'));

});

parcelRegister("eMArC", function(module, exports) {

let $ac31d1852b44e66b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ac31d1852b44e66b$var$load("l7xQ8").then(()=>parcelRequire('8uuyE'));

});

parcelRegister("lLIpI", function(module, exports) {

let $fd907066efd418c0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fd907066efd418c0$var$load("gZUKs").then(()=>parcelRequire('ky2MY'));

});

parcelRegister("guf1O", function(module, exports) {

let $c00b1afcb70b5574$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c00b1afcb70b5574$var$load("iUIIz").then(()=>parcelRequire('gu3EK'));

});

parcelRegister("fqQ0Z", function(module, exports) {

let $b3c1a1ca91afe332$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b3c1a1ca91afe332$var$load("4WEyz").then(()=>parcelRequire('gECy4'));

});

parcelRegister("g5Au7", function(module, exports) {

let $bb696a1487973d02$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bb696a1487973d02$var$load("hTrWv").then(()=>parcelRequire('eHp1N'));

});

parcelRegister("jduPc", function(module, exports) {

let $dfd72461b7e5efd7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dfd72461b7e5efd7$var$load("hgSu9").then(()=>parcelRequire('jGDeV'));

});

parcelRegister("2BsbE", function(module, exports) {

let $1e54e6d15e249ea8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1e54e6d15e249ea8$var$load("1Cm5e").then(()=>parcelRequire('1c1x3'));

});

parcelRegister("ccwx8", function(module, exports) {

let $8e1fd77f340721b6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8e1fd77f340721b6$var$load("gW1VO").then(()=>parcelRequire('jldw7'));

});

parcelRegister("kCYzi", function(module, exports) {

let $f04656d6233e5a5c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f04656d6233e5a5c$var$load("2xiJO").then(()=>parcelRequire('kNSgL'));

});

parcelRegister("eGpCl", function(module, exports) {

let $ab08dc039565a58c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ab08dc039565a58c$var$load("3s3o5").then(()=>parcelRequire('8eply'));

});

parcelRegister("iLJ1v", function(module, exports) {

let $da9f8a7981ec2ce4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $da9f8a7981ec2ce4$var$load("lGvlN").then(()=>parcelRequire('kEjPu'));

});

parcelRegister("j6OuY", function(module, exports) {

let $de95bfd69ede0761$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $de95bfd69ede0761$var$load("hdDMK").then(()=>parcelRequire('6bCpe'));

});

parcelRegister("ddq5w", function(module, exports) {

let $99f0b9d3ccdd4a58$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $99f0b9d3ccdd4a58$var$load("3mJV2").then(()=>parcelRequire('7Gb4S'));

});

parcelRegister("lnaW2", function(module, exports) {

let $f8f43a6dc90f9eee$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f8f43a6dc90f9eee$var$load("cMLT2").then(()=>parcelRequire('5tcSN'));

});

parcelRegister("jMZdA", function(module, exports) {

let $e681fcafe11e5342$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e681fcafe11e5342$var$load("6194k").then(()=>parcelRequire('6LeK2'));

});

parcelRegister("4Jhm3", function(module, exports) {

let $3718d3b36fa5fd70$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3718d3b36fa5fd70$var$load("izPy1").then(()=>parcelRequire('hZ7pV'));

});

parcelRegister("1lG7v", function(module, exports) {

let $0fb86cc2c4073147$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0fb86cc2c4073147$var$load("i1Et0").then(()=>parcelRequire('kTKKU'));

});

parcelRegister("cr6cT", function(module, exports) {

let $90dcd23c2f2236db$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $90dcd23c2f2236db$var$load("5OeCI").then(()=>parcelRequire('7ynR8'));

});

parcelRegister("l39Ik", function(module, exports) {

let $f53169c4259cb361$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f53169c4259cb361$var$load("1SMTI").then(()=>parcelRequire('8sDTM'));

});

parcelRegister("eWJHH", function(module, exports) {

let $ae19ef4d540d8f6b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ae19ef4d540d8f6b$var$load("9UVYf").then(()=>parcelRequire('9KXxY'));

});

parcelRegister("hpLK5", function(module, exports) {

let $cad9ce1adc1d7cd1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cad9ce1adc1d7cd1$var$load("4wV7K").then(()=>parcelRequire('eW24X'));

});

parcelRegister("ceWMu", function(module, exports) {

let $8e94638544de9830$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8e94638544de9830$var$load("4iPF7").then(()=>parcelRequire('dcQg7'));

});

parcelRegister("5BSGs", function(module, exports) {

let $415ad37e6a0ebc27$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $415ad37e6a0ebc27$var$load("gwLRR").then(()=>parcelRequire('2T7Fz'));

});

parcelRegister("dU4PR", function(module, exports) {

let $a1f4418b8e7e3f7b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a1f4418b8e7e3f7b$var$load("8qEhZ").then(()=>parcelRequire('1RnD4'));

});

parcelRegister("4d0IW", function(module, exports) {

let $3108f0168aaf0c49$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3108f0168aaf0c49$var$load("8FUME").then(()=>parcelRequire('77zEU'));

});

parcelRegister("7kGM2", function(module, exports) {

let $556b94a300dbe36c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $556b94a300dbe36c$var$load("eOveI").then(()=>parcelRequire('74dGw'));

});

parcelRegister("hNwBH", function(module, exports) {

let $cf504e5f033f5a23$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cf504e5f033f5a23$var$load("5wdgL").then(()=>parcelRequire('7iDJ1'));

});

parcelRegister("eYFGv", function(module, exports) {

let $ae7700fce28cc575$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ae7700fce28cc575$var$load("gfDZQ").then(()=>parcelRequire('eSnga'));

});

parcelRegister("hUkXO", function(module, exports) {

let $d097ed960fc80e30$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d097ed960fc80e30$var$load("044PY").then(()=>parcelRequire('lUlGx'));

});

parcelRegister("6gGPb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $ekCm6 = parcelRequire("ekCm6");


var $ixfCV = parcelRequire("ixfCV");


var $iMnC5 = parcelRequire("iMnC5");


var $a2bT0 = parcelRequire("a2bT0");


var $iH3wh = parcelRequire("iH3wh");

const $2433037a0219ceb9$export$2f5dfaa7873e8973 = `polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 89.64102% 21.33975%, 91.06889% 22.33956%, 92.30146% 23.57212%, 93.30127% 25%, 94.03794% 26.5798%, 94.48909% 28.26352%, 94.64102% 30%, 94.64102% 70%, 94.48909% 71.73648%, 94.03794% 73.4202%, 93.30127% 75%, 92.30146% 76.42788%, 91.06889% 77.66044%, 89.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 10.35898% 78.66025%, 8.93111% 77.66044%, 7.69854% 76.42788%, 6.69873% 75%, 5.96206% 73.4202%, 5.51091% 71.73648%, 5.35898% 70%, 5.35898% 30%, 5.51091% 28.26352%, 5.96206% 26.5798%, 6.69873% 25%, 7.69854% 23.57212%, 8.93111% 22.33956%, 10.35898% 21.33975%)`;
const $2433037a0219ceb9$var$styles = {
    agentAvatar: "_1e0c1txw _1bah1h6o _4cvr1h6o _mkrz1k6g",
    image: "_5ral1dfr _4t3i1osq _1bsb1osq",
    avatarContentContainer: "_1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o _4cvr1h6o"
};
const $2433037a0219ceb9$var$stylesCompiled = {
    innerShape: "_4t3i1lk2 _1bsb1lk2 _mkrz1k6g"
};
const $2433037a0219ceb9$export$38b71b080e1832c8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { imageUrl: imageUrl, size: t1, label: label, name: name, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, agentNamedId: agentNamedId, showBorder: t2, isRovoDev: isRovoDev, isForgeAgent: isForgeAgent, forgeAgentIconUrl: forgeAgentIconUrl } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const showBorder = t2 === undefined ? true : t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const imgUrl = isForgeAgent && forgeAgentIconUrl ? forgeAgentIconUrl : imageUrl;
    const t3 = (0, $ekCm6.AVATAR_SIZES)[size];
    const t4 = (0, $ekCm6.AVATAR_SIZES)[size];
    let t5;
    if ($[0] !== showBorder) {
        t5 = showBorder ? {
            backgroundColor: "#fff"
        } : {};
        $[0] = showBorder;
        $[1] = t5;
    } else t5 = $[1];
    let t6;
    if ($[2] !== size) {
        t6 = (0, $ixfCV.fg)("rovo_chat_bugfix_agent_avatar_squish") ? {
            minHeight: (0, $ekCm6.AVATAR_SIZES)[size],
            minWidth: (0, $ekCm6.AVATAR_SIZES)[size]
        } : {};
        $[2] = size;
        $[3] = t6;
    } else t6 = $[3];
    let t7;
    if ($[4] !== t3 || $[5] !== t4 || $[6] !== t5 || $[7] !== t6) {
        t7 = {
            height: t3,
            width: t4,
            ...t5,
            ...t6
        };
        $[4] = t3;
        $[5] = t4;
        $[6] = t5;
        $[7] = t6;
        $[8] = t7;
    } else t7 = $[8];
    let t8;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (0, $hekY6.default)([
            $2433037a0219ceb9$var$stylesCompiled.innerShape
        ]);
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== agentId || $[11] !== agentIdentityAccountId || $[12] !== agentNamedId || $[13] !== formatMessage || $[14] !== imgUrl || $[15] !== isRovoDev || $[16] !== label || $[17] !== name || $[18] !== size) {
        t9 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t8
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: $2433037a0219ceb9$var$styles.avatarContentContainer
        }, imgUrl ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            as: "img",
            xcss: $2433037a0219ceb9$var$styles.image,
            src: imgUrl,
            alt: name || label || formatMessage((0, $iH3wh.messages).agentAvatarLabel)
        }) : /*#__PURE__*/ $cozmU.createElement((0, $a2bT0.GeneratedAvatar), {
            agentId: agentId,
            agentNamedId: agentNamedId,
            agentIdentityAccountId: agentIdentityAccountId,
            isRovoDev: isRovoDev,
            size: size
        })));
        $[10] = agentId;
        $[11] = agentIdentityAccountId;
        $[12] = agentNamedId;
        $[13] = formatMessage;
        $[14] = imgUrl;
        $[15] = isRovoDev;
        $[16] = label;
        $[17] = name;
        $[18] = size;
        $[19] = t9;
    } else t9 = $[19];
    let t10;
    if ($[20] !== label || $[21] !== t7 || $[22] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            "aria-label": label,
            xcss: $2433037a0219ceb9$var$styles.agentAvatar,
            style: t7
        }, t9);
        $[20] = label;
        $[21] = t7;
        $[22] = t9;
        $[23] = t10;
    } else t10 = $[23];
    return t10;
} : ({ imageUrl: imageUrl, size: size = 'medium', label: label, name: name, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, agentNamedId: agentNamedId, showBorder: showBorder = true, isRovoDev: isRovoDev, isForgeAgent: isForgeAgent, forgeAgentIconUrl: forgeAgentIconUrl })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const imgUrl = isForgeAgent && forgeAgentIconUrl ? forgeAgentIconUrl : imageUrl;
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        "aria-label": label,
        xcss: $2433037a0219ceb9$var$styles.agentAvatar,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            height: (0, $ekCm6.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
            width: (0, $ekCm6.AVATAR_SIZES)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/ensure-design-token-usage
            ...showBorder ? {
                backgroundColor: '#fff'
            } : {},
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...(0, $ixfCV.fg)('rovo_chat_bugfix_agent_avatar_squish') ? {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                minHeight: (0, $ekCm6.AVATAR_SIZES)[size],
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                minWidth: (0, $ekCm6.AVATAR_SIZES)[size]
            } : {}
        }
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $2433037a0219ceb9$var$stylesCompiled.innerShape
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $2433037a0219ceb9$var$styles.avatarContentContainer
    }, imgUrl ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        as: "img",
        xcss: $2433037a0219ceb9$var$styles.image,
        src: imgUrl,
        alt: name || label || formatMessage((0, $iH3wh.messages).agentAvatarLabel)
    }) : /*#__PURE__*/ $cozmU.createElement((0, $a2bT0.GeneratedAvatar), {
        agentId: agentId,
        agentNamedId: agentNamedId,
        agentIdentityAccountId: agentIdentityAccountId,
        isRovoDev: isRovoDev,
        size: size
    }))));
};
module.exports["AGENT_AVATAR_CLIP_PATH"] = $2433037a0219ceb9$export$2f5dfaa7873e8973;
module.exports["AgentAvatar"] = $2433037a0219ceb9$export$38b71b080e1832c8;

});

parcelRegister("iH3wh", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a5c48f60363d438d$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    agentAvatarLabel: {
        id: "ai-mate.agent-avatar-label",
        defaultMessage: "Agent avatar"
    }
});
module.exports["messages"] = $a5c48f60363d438d$export$defe85febe8b728c;

});

parcelRegister("l0Ey3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $mfdwv = parcelRequire("mfdwv");

const $65ffbdb08fd6ebe6$export$38f9b635c1c454e7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
            ...props,
            label: ""
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($mfdwv))), {
        ...props,
        label: ""
    });
module.exports["ChatPillIcon"] = $65ffbdb08fd6ebe6$export$38f9b635c1c454e7;

});

parcelRegister("2ot3O", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $a2foB = parcelRequire("a2foB");


var $FKQbh = parcelRequire("FKQbh");


var $lqtHz = parcelRequire("lqtHz");

const $1deb345019a8d437$var$FlagContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(null);
const $1deb345019a8d437$export$2879604e6aec4ab = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useFlags() {
    const api = (0, $cozmU.useContext)($1deb345019a8d437$var$FlagContext);
    if (api == null) throw new Error("Unable to find FlagProviderContext");
    return api;
} : function useFlags() {
    const api = (0, $cozmU.useContext)($1deb345019a8d437$var$FlagContext);
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
};
const $1deb345019a8d437$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
const $1deb345019a8d437$export$a4270ab432ac8a58 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FlagsProvider(t0) {
    const $ = (0, $bDgLe.c)(13);
    const { children: children, shouldRenderToParent: shouldRenderToParent } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [flags, setFlags] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (id)=>{
            setFlags((current)=>current.slice(0).filter((flag)=>flag.id !== id));
        };
        $[1] = t2;
    } else t2 = $[1];
    const removeFlag = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $1deb345019a8d437$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        };
        $[2] = t3;
    } else t3 = $[2];
    const api = t3;
    let t4;
    if ($[3] !== children) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1deb345019a8d437$var$FlagContext.Provider, {
            value: api
        }, children);
        $[3] = children;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== flags) {
        t5 = flags.map($1deb345019a8d437$var$_temp);
        $[5] = flags;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== shouldRenderToParent || $[8] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lqtHz.default), {
            onDismissed: removeFlag,
            shouldRenderToParent: shouldRenderToParent
        }, t5);
        $[7] = shouldRenderToParent;
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== t4 || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t4, t6);
        $[10] = t4;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    return t7;
} : function FlagsProvider({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $cozmU.useState)([]);
    const removeFlag = (0, $cozmU.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $cozmU.useMemo)(()=>({
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $1deb345019a8d437$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1deb345019a8d437$var$FlagContext.Provider, {
        value: api
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lqtHz.default), {
        onDismissed: removeFlag,
        shouldRenderToParent: shouldRenderToParent
    }, flags.map((flag_1)=>{
        const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
        const FlagType = isAutoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(FlagType, {
            ...restProps,
            key: flag_1.id
        });
    })));
};
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $1deb345019a8d437$var$_temp(flag_1) {
    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
    const FlagType = isAutoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(FlagType, {
        ...restProps,
        key: flag_1.id
    });
}
const $1deb345019a8d437$export$7b676815c264eaf3 = (fn)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1deb345019a8d437$export$a4270ab432ac8a58, null, fn());
module.exports["useFlags"] = $1deb345019a8d437$export$2879604e6aec4ab;
module.exports["FlagsProvider"] = $1deb345019a8d437$export$a4270ab432ac8a58;

});

parcelRegister("8nzB4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $hz2oZ = parcelRequire("hz2oZ");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");


var $aoLyf = parcelRequire("aoLyf");


var $jPaq9 = parcelRequire("jPaq9");


var $cJ58l = parcelRequire("cJ58l");

const $14d43074808cd80f$var$styles = {
    conversationStartersList: "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq",
    conversationStartersListWithRefreshDesign: "_19pkze3t",
    conversationStaterItem: "_ca0qze3t",
    conversationStarterIcon: "_1o9zidpf",
    conversationStarterText: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _1o9zkb7n _1ul9idpf",
    button: "_11c8fhey _2rko12b0 _syazazsu _ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7 _k48p1wq8 _1bto1l2s _o5721q9c _1o9zkb7n _1bsb1osq _bfhksm61 _irr31dpa _1di6fcek"
};
const $14d43074808cd80f$export$c2d882153e0984c5 = ({ userDefinedConversationStarters: userDefinedConversationStartersParam, isAgentDefault: isAgentDefault })=>{
    const type = 'static';
    const customAgentConversationStarters = [
        {
            message: (0, $cJ58l.messages).agentEmptyStateSuggestion1,
            type: type
        },
        {
            message: (0, $cJ58l.messages).agentEmptyStateSuggestion2,
            type: type
        },
        {
            message: (0, $cJ58l.messages).agentEmptyStateSuggestion3,
            type: type
        }
    ];
    const userDefinedConversationStarters = userDefinedConversationStartersParam ?? [];
    const defaultAgentConversationStarters = [
        {
            message: (0, $cJ58l.messages).emptyStateSuggestion1,
            type: type
        },
        {
            message: (0, $cJ58l.messages).emptyStateSuggestion2,
            type: type
        },
        {
            message: (0, $cJ58l.messages).emptyStateSuggestion3,
            type: type
        }
    ];
    const getCombinedConversationStarters = ()=>{
        const shouldCombine = !isAgentDefault;
        if (shouldCombine) // Return user defined suggestions + static fallback suggestions with a max of 3 suggestions (user defined taking precendence over fallback)
        return [
            ...userDefinedConversationStarters,
            ...customAgentConversationStarters
        ].slice(0, 3);
        return defaultAgentConversationStarters;
    };
    return {
        userDefinedConversationStarters: userDefinedConversationStarters,
        customAgentConversationStarters: customAgentConversationStarters,
        defaultAgentConversationStarters: defaultAgentConversationStarters,
        combinedConversationStarters: getCombinedConversationStarters()
    };
};
const $14d43074808cd80f$export$171adfc74aa509c3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    let isAgentDefault;
    let props;
    let userDefinedConversationStarters;
    if ($[0] !== t0) {
        ({ userDefinedConversationStarters: userDefinedConversationStarters, isAgentDefault: isAgentDefault, ...props } = t0);
        $[0] = t0;
        $[1] = isAgentDefault;
        $[2] = props;
        $[3] = userDefinedConversationStarters;
    } else {
        isAgentDefault = $[1];
        props = $[2];
        userDefinedConversationStarters = $[3];
    }
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[4] !== isAgentDefault || $[5] !== userDefinedConversationStarters) {
        t1 = $14d43074808cd80f$export$c2d882153e0984c5({
            userDefinedConversationStarters: userDefinedConversationStarters,
            isAgentDefault: isAgentDefault
        });
        $[4] = isAgentDefault;
        $[5] = userDefinedConversationStarters;
        $[6] = t1;
    } else t1 = $[6];
    const { combinedConversationStarters: combinedConversationStarters } = t1;
    let t2;
    if ($[7] !== combinedConversationStarters || $[8] !== formatMessage) {
        let t3;
        if ($[10] !== formatMessage) {
            t3 = (starter)=>typeof starter.message === "string" ? {
                    message: starter.message,
                    type: starter.type
                } : {
                    message: formatMessage(starter.message),
                    type: starter.type
                };
            $[10] = formatMessage;
            $[11] = t3;
        } else t3 = $[11];
        t2 = combinedConversationStarters.map(t3);
        $[7] = combinedConversationStarters;
        $[8] = formatMessage;
        $[9] = t2;
    } else t2 = $[9];
    const starters = t2;
    let t3;
    if ($[12] !== props || $[13] !== starters) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($14d43074808cd80f$export$ea338c37011da44c, {
            starters: starters,
            ...props
        });
        $[12] = props;
        $[13] = starters;
        $[14] = t3;
    } else t3 = $[14];
    return t3;
} : ({ userDefinedConversationStarters: userDefinedConversationStarters, isAgentDefault: isAgentDefault, ...props })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { combinedConversationStarters: combinedConversationStarters } = (0, $cozmU.useMemo)(()=>$14d43074808cd80f$export$c2d882153e0984c5({
            userDefinedConversationStarters: userDefinedConversationStarters,
            isAgentDefault: isAgentDefault
        }), [
        userDefinedConversationStarters,
        isAgentDefault
    ]);
    const starters = (0, $cozmU.useMemo)(()=>combinedConversationStarters.map((starter)=>typeof starter.message === 'string' ? {
                message: starter.message,
                type: starter.type
            } : {
                message: formatMessage(starter.message),
                type: starter.type
            }), [
        combinedConversationStarters,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($14d43074808cd80f$export$ea338c37011da44c, {
        starters: starters,
        ...props
    });
};
const $14d43074808cd80f$export$ea338c37011da44c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { starters: starters, onConversationStarterClick: onConversationStarterClick, showReloadButton: t1, onReloadButtonClick: t2, onBrowseAgentsClick: onBrowseAgentsClick, refreshDesignEnabled: t3 } = t0;
    const showReloadButton = t1 === undefined ? false : t1;
    const onReloadButtonClick = t2 === undefined ? $14d43074808cd80f$var$_temp : t2;
    const refreshDesignEnabled = t3 === undefined ? false : t3;
    const t4 = refreshDesignEnabled && $14d43074808cd80f$var$styles.conversationStartersListWithRefreshDesign;
    let t5;
    if ($[0] !== t4) {
        t5 = (0, $w6R6I.cx)($14d43074808cd80f$var$styles.conversationStartersList, t4);
        $[0] = t4;
        $[1] = t5;
    } else t5 = $[1];
    let t6;
    if ($[2] !== onConversationStarterClick || $[3] !== onReloadButtonClick || $[4] !== refreshDesignEnabled || $[5] !== showReloadButton || $[6] !== starters) {
        let t7;
        if ($[8] !== onConversationStarterClick || $[9] !== onReloadButtonClick || $[10] !== refreshDesignEnabled || $[11] !== showReloadButton || $[12] !== starters.length) {
            t7 = (starter, index)=>{
                const isLastStarter = index === starters.length - 1;
                const chatPill = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                    as: "li",
                    key: starter.message,
                    xcss: refreshDesignEnabled && $14d43074808cd80f$var$styles.conversationStaterItem
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
                    xcss: $14d43074808cd80f$var$styles.button,
                    onClick: ()=>onConversationStarterClick(starter),
                    testId: "conversation-starter"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
                    space: "space.150",
                    alignBlock: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                    xcss: $14d43074808cd80f$var$styles.conversationStarterIcon
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aoLyf.AgentChatIcon), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                    xcss: $14d43074808cd80f$var$styles.conversationStarterText
                }, starter.message))));
                return isLastStarter && showReloadButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
                    space: "space.050",
                    grow: "fill",
                    alignInline: "end",
                    key: starter.message
                }, chatPill, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($hz2oZ))),
                    onClick: onReloadButtonClick,
                    appearance: "subtle",
                    label: ""
                })) : chatPill;
            };
            $[8] = onConversationStarterClick;
            $[9] = onReloadButtonClick;
            $[10] = refreshDesignEnabled;
            $[11] = showReloadButton;
            $[12] = starters.length;
            $[13] = t7;
        } else t7 = $[13];
        t6 = starters.map(t7);
        $[2] = onConversationStarterClick;
        $[3] = onReloadButtonClick;
        $[4] = refreshDesignEnabled;
        $[5] = showReloadButton;
        $[6] = starters;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[14] !== onBrowseAgentsClick) {
        t7 = !!onBrowseAgentsClick && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            as: "li"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jPaq9.BrowseAgentsPill), {
            onClick: onBrowseAgentsClick
        }));
        $[14] = onBrowseAgentsClick;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== t5 || $[17] !== t6 || $[18] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            as: "ul",
            space: "space.050",
            xcss: t5
        }, t6, t7);
        $[16] = t5;
        $[17] = t6;
        $[18] = t7;
        $[19] = t8;
    } else t8 = $[19];
    return t8;
} : ({ starters: starters, onConversationStarterClick: onConversationStarterClick, showReloadButton: showReloadButton = false, onReloadButtonClick: onReloadButtonClick = ()=>{}, onBrowseAgentsClick: onBrowseAgentsClick, refreshDesignEnabled: refreshDesignEnabled = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        as: "ul",
        space: "space.050",
        xcss: (0, $w6R6I.cx)($14d43074808cd80f$var$styles.conversationStartersList, refreshDesignEnabled && $14d43074808cd80f$var$styles.conversationStartersListWithRefreshDesign)
    }, starters.map((starter, index)=>{
        const isLastStarter = index === starters.length - 1;
        const chatPill = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            as: "li",
            key: starter.message,
            xcss: refreshDesignEnabled && $14d43074808cd80f$var$styles.conversationStaterItem
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
            xcss: $14d43074808cd80f$var$styles.button,
            onClick: ()=>onConversationStarterClick(starter),
            testId: "conversation-starter"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            space: "space.150",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $14d43074808cd80f$var$styles.conversationStarterIcon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aoLyf.AgentChatIcon), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $14d43074808cd80f$var$styles.conversationStarterText
        }, starter.message))));
        return isLastStarter && showReloadButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            space: "space.050",
            grow: "fill",
            alignInline: "end",
            key: starter.message
        }, chatPill, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hz2oZ))),
            onClick: onReloadButtonClick,
            appearance: "subtle",
            label: ""
        })) : chatPill;
    }), !!onBrowseAgentsClick && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        as: "li"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jPaq9.BrowseAgentsPill), {
        onClick: onBrowseAgentsClick
    })));
};
function $14d43074808cd80f$var$_temp() {}
module.exports["getConversationStarters"] = $14d43074808cd80f$export$c2d882153e0984c5;
module.exports["AgentConversationStarters"] = $14d43074808cd80f$export$171adfc74aa509c3;

});

parcelRegister("aoLyf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bLfHG = parcelRequire("bLfHG");


var $4ez2K = parcelRequire("4ez2K");

const $26810b2bd77e3600$var$styles = {
    agentChatIcon: "_2rko1mok _189ee4h9 _1dqonqa1 _1h6d1l7x _1bsbzwfg _4t3izwfg"
};
const $26810b2bd77e3600$export$f33bbc5f5534c8a4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
            xcss: $26810b2bd77e3600$var$styles.agentChatIcon,
            alignItems: "center",
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bLfHG))), {
            label: "",
            color: "var(--ds-icon-subtlest, #6B6E76)"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
        xcss: $26810b2bd77e3600$var$styles.agentChatIcon,
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bLfHG))), {
        label: "",
        color: "var(--ds-icon-subtlest, #6B6E76)"
    }));
};
module.exports["AgentChatIcon"] = $26810b2bd77e3600$export$f33bbc5f5534c8a4;

});

parcelRegister("jPaq9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $jC4nA = parcelRequire("jC4nA");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");


var $l0Ey3 = parcelRequire("l0Ey3");


var $hNTpD = parcelRequire("hNTpD");

const $ac4acb6d8564709e$var$stylesCompiled = {
    pillLineHeight: "_vwz47vkz"
};
const $ac4acb6d8564709e$var$styles = {
    button: "_2rko12b0 _11c8fhey _189ee4h9 _1dqonqa1 _1h6d1l7x _syazazsu _ca0q12x7 _u5f3utpp _n3td12x7 _19bvutpp _k48p1wq8 _1bto1l2s _o5721q9c _1o9zkb7n _bfhksm61 _irr31dpa _1di6fcek",
    buttonInline: "_18zrv77o",
    queryText: "_1nmz1hna _y3gn1e5h",
    whiteSpacePreWrap: "_o5721jtm"
};
const $ac4acb6d8564709e$export$e33faa86e0996d96 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(20);
    let children;
    let props;
    let t1;
    let t2;
    if ($[0] !== t0) {
        ({ children: children, whiteSpacePreWrap: t1, renderIcon: t2, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
        $[3] = t1;
        $[4] = t2;
    } else {
        children = $[1];
        props = $[2];
        t1 = $[3];
        t2 = $[4];
    }
    const whiteSpacePreWrap = t1 === undefined ? true : t1;
    const renderIcon = t2 === undefined ? true : t2;
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            $ac4acb6d8564709e$var$stylesCompiled.pillLineHeight
        ]);
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== renderIcon) {
        t4 = renderIcon ? /*#__PURE__*/ $cozmU.createElement((0, $l0Ey3.ChatPillIcon), null) : null;
        $[6] = renderIcon;
        $[7] = t4;
    } else t4 = $[7];
    const t5 = whiteSpacePreWrap && $ac4acb6d8564709e$var$styles.whiteSpacePreWrap;
    let t6;
    if ($[8] !== t5) {
        t6 = (0, $w6R6I.cx)($ac4acb6d8564709e$var$styles.queryText, t5);
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== children || $[11] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: t6
        }, children);
        $[10] = children;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== t4 || $[14] !== t7) {
        t8 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t3
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
            space: "space.075",
            alignBlock: "baseline"
        }, t4, t7));
        $[13] = t4;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== props || $[17] !== ref || $[18] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.default), {
            ref: ref,
            ...props,
            xcss: $ac4acb6d8564709e$var$styles.button
        }, t8);
        $[16] = props;
        $[17] = ref;
        $[18] = t8;
        $[19] = t9;
    } else t9 = $[19];
    return t9;
} : ({ children: children, whiteSpacePreWrap: whiteSpacePreWrap = true, renderIcon: renderIcon = true, ...props }, ref)=>/*#__PURE__*/ $cozmU.createElement((0, $hBYtq.default), {
        ref: ref,
        ...props,
        xcss: $ac4acb6d8564709e$var$styles.button
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $ac4acb6d8564709e$var$stylesCompiled.pillLineHeight
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        space: "space.075",
        alignBlock: "baseline"
    }, renderIcon ? /*#__PURE__*/ $cozmU.createElement((0, $l0Ey3.ChatPillIcon), null) : null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($ac4acb6d8564709e$var$styles.queryText, whiteSpacePreWrap && $ac4acb6d8564709e$var$styles.whiteSpacePreWrap)
    }, children)))));
const $ac4acb6d8564709e$export$76b47032dcd9063b = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(10);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            $ac4acb6d8564709e$var$stylesCompiled.pillLineHeight
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))), {
            color: "currentColor",
            label: ""
        });
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== formatMessage) {
        t2 = formatMessage((0, $hNTpD.default).browseAgentsPillLabel);
        $[2] = formatMessage;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t0
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
            space: "space.050",
            xcss: $ac4acb6d8564709e$var$styles.buttonInline
        }, t1, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: $ac4acb6d8564709e$var$styles.queryText
        }, t2)));
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== props || $[7] !== ref || $[8] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.default), {
            ref: ref,
            ...props,
            xcss: $ac4acb6d8564709e$var$styles.button
        }, t3);
        $[6] = props;
        $[7] = ref;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : (props, ref)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.default), {
        ref: ref,
        ...props,
        xcss: $ac4acb6d8564709e$var$styles.button
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $ac4acb6d8564709e$var$stylesCompiled.pillLineHeight
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        space: "space.050",
        xcss: $ac4acb6d8564709e$var$styles.buttonInline
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))), {
        color: "currentColor",
        label: ""
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $ac4acb6d8564709e$var$styles.queryText
    }, formatMessage((0, $hNTpD.default).browseAgentsPillLabel)))));
});
module.exports["ChatPill"] = $ac4acb6d8564709e$export$e33faa86e0996d96;
module.exports["BrowseAgentsPill"] = $ac4acb6d8564709e$export$76b47032dcd9063b;

});

parcelRegister("hNTpD", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $d5949bd621a1b2eb$var$message = (0, $kSwu1.defineMessages)({
    browseAgentsPillLabel: {
        id: "ai-mate.rovo-agent-components.browse-agents-pill.label",
        defaultMessage: "Browse agents"
    }
});
var $d5949bd621a1b2eb$export$2e2bcd8739ae039 = $d5949bd621a1b2eb$var$message;
module.exports["default"] = $d5949bd621a1b2eb$export$2e2bcd8739ae039;

});

parcelRegister("cJ58l", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $56480b3b3cc8c818$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    emptyStateSuggestion1: {
        id: "ai-mate.chat-history.empty-state.suggestion1",
        defaultMessage: "Are any of my tickets overdue?"
    },
    emptyStateSuggestion2: {
        id: "ai-mate.chat-history.empty-state.suggestion2",
        defaultMessage: "What should I work on next?"
    },
    emptyStateSuggestion3: {
        id: "ai-mate.chat-history.empty-state.suggestion3",
        defaultMessage: "Write an update about my week"
    },
    agentEmptyStateSuggestion1: {
        id: "ai-mate.chat-history.empty-state.agent-suggestion1",
        defaultMessage: "Tell me about yourself"
    },
    agentEmptyStateSuggestion2: {
        id: "ai-mate.chat-history.empty-state.agent-suggestion2",
        defaultMessage: "What can you help me with?"
    },
    agentEmptyStateSuggestion3: {
        id: "ai-mate.chat-history.empty-state.agent-suggestion3",
        defaultMessage: "Summarize what I'm looking at"
    }
});
module.exports["messages"] = $56480b3b3cc8c818$export$defe85febe8b728c;

});

parcelRegister("dTEBe", function(module, exports) {

var $iDZi9 = parcelRequire("iDZi9");

const $f229989060597496$export$fda91e425d265029 = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $f229989060597496$export$858653b7ee3cbb17 = (str)=>str.charAt(0).toLowerCase() + str.slice(1);
const $f229989060597496$var$isValidURL = (url)=>{
    try {
        new URL(url);
        return true;
    } catch  {
        return false;
    }
};
const $f229989060597496$export$9748efee331ec573 = (param)=>`${0, $iDZi9.ROVO_PARAM_PREFIX}${$f229989060597496$export$fda91e425d265029(param)}`;
const $f229989060597496$export$f2888183a34644d4 = (param)=>{
    return $f229989060597496$export$858653b7ee3cbb17(param.replace((0, $iDZi9.ROVO_PARAM_PREFIX), ''));
};
// Creates RovoChatParams from URLSearchParams
// Optionally filter to specific params
const $f229989060597496$var$processParams = (input, options = {
    filter: []
})=>{
    const output = {};
    const safeSearchParamsInput = typeof input === 'string' ? $f229989060597496$var$isValidURL(input) ? new URLSearchParams(new URL(input).search) : new URLSearchParams(input) : input;
    const processedInput = new URLSearchParams(safeSearchParamsInput);
    const extracted = new URLSearchParams();
    safeSearchParamsInput.forEach((value, key)=>{
        // Only look at rovoChat params
        if (!key.startsWith((0, $iDZi9.ROVO_PARAM_PREFIX))) return;
        const paramKey = $f229989060597496$export$f2888183a34644d4(key);
        if (options?.filter?.length) {
            if (options.filter.includes(paramKey)) {
                output[paramKey] = decodeURIComponent(value);
                extracted.append(key, value);
            }
        } else output[paramKey] = decodeURIComponent(value);
        // Remove rovoParam from processed input
        processedInput.delete(key);
    });
    const combinedQueryString = [
        processedInput,
        extracted
    ].map((params)=>params.toString()).filter((part)=>part.length > 0).join('&');
    return {
        processed: processedInput,
        rovoParams: output,
        combinedQueryString: combinedQueryString
    };
};
const $f229989060597496$export$6405071f390601f7 = (url)=>{
    try {
        const search = url ? new URL(url).search : window.location.search;
        const q = new URLSearchParams(search);
        return $f229989060597496$var$processParams(q).rovoParams;
    } catch  {
        return {};
    }
};
const $f229989060597496$export$4a302fc7d977f7b3 = (params)=>{
    window.history.pushState({}, '', $f229989060597496$export$ef04687636c850fe(window.location.pathname, params));
};
const $f229989060597496$export$ef04687636c850fe = (url, params)=>{
    const { processed: processed, rovoParams: rovoParams } = $f229989060597496$var$processParams(url);
    const rovoParamsWithExisting = {
        ...rovoParams,
        ...params
    };
    const baseUrl = url.includes('?') ? url.split('?')[0] : url;
    const baseQuery = Array.from(processed).length ? `?${processed.toString()}&` : '?';
    const updatedRovoParamsString = $f229989060597496$export$eddc20a009406015(rovoParamsWithExisting);
    return `${baseUrl}${baseQuery}${updatedRovoParamsString}`;
};
const $f229989060597496$export$eddc20a009406015 = (params, encodeAsObject)=>{
    if (encodeAsObject) return Object.entries(params).reduce((acc, [key, value])=>{
        acc[$f229989060597496$export$9748efee331ec573(key)] = encodeURIComponent(value);
        return acc;
    }, {});
    return Object.entries(params).filter(([_, value])=>value !== undefined).map(([key, value])=>{
        return `${$f229989060597496$export$9748efee331ec573(key)}=${encodeURIComponent(value)}`;
    }).join('&');
};
const $f229989060597496$export$ad5179fba4239081 = (params, fields)=>{
    return Object.entries(params).every(([key, value])=>{
        const field = fields.find((field)=>field === key);
        if (field) return value !== undefined;
        else return value === undefined;
    });
};
const $f229989060597496$export$9c55b0deb4e0c7df = ({ resourceRouterQuery: resourceRouterQuery = false } = {})=>{
    /*
  For products using react-resource-router (e.g Atlas) to
  pass as the value of `query` on the route definition. It ensures that our parameters
  are not stripped from the URL when loading the page, or through redirect hops
  Any new parameters we want to maintain should be added here as well, which means
  only a version bump is needed in those products to support the latest param list
  The !=false simply means that the parameter is supported but is optional, and should
  not contain a value of 'false'
  */ const suffix = resourceRouterQuery ? '!=false' : '';
    return (0, $iDZi9.ROVO_VALID_PARAMS).map((param)=>`${$f229989060597496$export$9748efee331ec573(param)}${suffix}`);
};
module.exports["getRovoParams"] = $f229989060597496$export$6405071f390601f7;
module.exports["updatePageRovoParams"] = $f229989060597496$export$4a302fc7d977f7b3;
module.exports["addRovoParamsToUrl"] = $f229989060597496$export$ef04687636c850fe;
module.exports["encodeRovoParams"] = $f229989060597496$export$eddc20a009406015;

});

parcelRegister("iDZi9", function(module, exports) {
const $36649e4ee5b3590e$export$5a550907ffbc9119 = 'rovoChat';
const $36649e4ee5b3590e$export$3cd6b610e7ede579 = [
    'pathway',
    'agentId',
    'conversationId',
    'prompt',
    'cloudId',
    'triggerOpen',
    'insertPrompt',
    'promptLibraryOpen',
    'openChatMode'
];
module.exports["ROVO_PARAM_PREFIX"] = $36649e4ee5b3590e$export$5a550907ffbc9119;
module.exports["ROVO_VALID_PARAMS"] = $36649e4ee5b3590e$export$3cd6b610e7ede579;

});

parcelRegister("2J4Io", function(module, exports) {
const $d610f1a90044572d$export$23da1d24a38b0bde = ()=>{
    const host = window.location.host;
    return host.includes('localhost') || host.includes('.stg.atlassian') || host.includes('.stg-east.frontend.public.atl-paas.net') || host.includes('jira-dev.com');
};
module.exports["isStaging"] = $d610f1a90044572d$export$23da1d24a38b0bde;

});

parcelRegister("aaPn1", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7cQjw = parcelRequire("7cQjw");


var $iTxmV = parcelRequire("iTxmV");

const $bebfe5469a5e55d3$export$8a1abb7c176bd202 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (siteId)=>{
    const $ = (0, $bDgLe.c)(5);
    const { data: tenantData } = (0, $iTxmV.useTenantDataController)(siteId);
    let t0;
    if ($[0] !== siteId || $[1] !== tenantData?.orgId) {
        t0 = (path)=>(0, $7cQjw.getAtlasURL)(siteId, path, tenantData?.orgId);
        $[0] = siteId;
        $[1] = tenantData?.orgId;
        $[2] = t0;
    } else t0 = $[2];
    tenantData?.orgId;
    const atlasURL = t0;
    let t1;
    if ($[3] !== atlasURL) {
        t1 = {
            atlasURL: atlasURL
        };
        $[3] = atlasURL;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (siteId)=>{
    const { data: tenantData } = (0, $iTxmV.useTenantDataController)(siteId);
    const atlasURL = (0, $cozmU.useCallback)((path)=>(0, $7cQjw.getAtlasURL)(siteId, path, tenantData?.orgId), [
        siteId,
        tenantData?.orgId
    ]);
    return {
        atlasURL: atlasURL
    };
};
const $bebfe5469a5e55d3$export$b61b99f9ac0264be = (0, $gtMdU.isReactCompilerActivePlatform)() ? (siteId)=>{
    const $ = (0, $bDgLe.c)(2);
    const { atlasURL: atlasURL } = $bebfe5469a5e55d3$export$8a1abb7c176bd202(siteId);
    let t0;
    if ($[0] !== atlasURL) {
        t0 = atlasURL("/chat/agents/new");
        $[0] = atlasURL;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (siteId)=>{
    const { atlasURL: atlasURL } = $bebfe5469a5e55d3$export$8a1abb7c176bd202(siteId);
    return atlasURL('/chat/agents/new');
};
module.exports["useAtlasURL"] = $bebfe5469a5e55d3$export$8a1abb7c176bd202;

});

parcelRegister("7cQjw", function(module, exports) {

var $dTEBe = parcelRequire("dTEBe");


var $2J4Io = parcelRequire("2J4Io");

const $4c09219c949e06e3$var$ATLAS_PROD_URL = 'https://home.atlassian.com';
const $4c09219c949e06e3$var$ATLAS_STAGING_URL = 'https://home.stg.atlassian.com';
const $4c09219c949e06e3$export$5105758c0e772381 = ()=>{
    return (0, $2J4Io.isStaging)() ? $4c09219c949e06e3$var$ATLAS_STAGING_URL : $4c09219c949e06e3$var$ATLAS_PROD_URL;
};
const $4c09219c949e06e3$export$bfee0f88bf621ad3 = (siteId, path, orgId)=>{
    let argConcat = '?';
    let processedPath = path.startsWith('/') ? path : `/${path}`;
    if (processedPath.includes('?')) argConcat = '&';
    const basePath = orgId ? `${$4c09219c949e06e3$export$5105758c0e772381()}/o/${orgId}` : $4c09219c949e06e3$export$5105758c0e772381();
    return (0, $dTEBe.addRovoParamsToUrl)(`${basePath}${processedPath}${argConcat}cloudId=${siteId}`, {
        cloudId: siteId
    });
};
module.exports["getAtlasHost"] = $4c09219c949e06e3$export$5105758c0e772381;
module.exports["getAtlasURL"] = $4c09219c949e06e3$export$bfee0f88bf621ad3;

});

parcelRegister("iTxmV", function(module, exports) {

var $6cFsl = parcelRequire("6cFsl");


var $irnO2 = parcelRequire("irnO2");


var $bjY3F = parcelRequire("bjY3F");


var $5SS4O = parcelRequire("5SS4O");


var $fBeNh = parcelRequire("fBeNh");

const $a5b67b50b6da9994$export$b863fec6791eae25 = (siteId)=>{
    (0, $6cFsl.di)((0, $5SS4O.useQuery));
    const experience = (0, $bjY3F.useAIMateExperienceTracker)();
    const { data: data, isFetching: isFetching, error: error_0 } = (0, $5SS4O.useQuery)({
        queryKey: [
            'viewAgentTenantData',
            siteId
        ],
        queryFn: async ()=>{
            experience.start({
                id: (0, $irnO2.ExperienceName).FETCH_AGENT_TENANT_DATA,
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_TENANT_DATA
            });
            const result = await (0, $fBeNh.getCloudUrlFromId)(siteId);
            return result;
        },
        onSuccess: ()=>{
            experience.succeed({
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_TENANT_DATA
            });
        },
        onError: (error)=>{
            experience.fail({
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_TENANT_DATA,
                error: error
            });
        }
    });
    return {
        data: data,
        isFetching: isFetching,
        error: error_0
    };
};
module.exports["useTenantDataController"] = $a5b67b50b6da9994$export$b863fec6791eae25;

});

parcelRegister("5SS4O", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $kBr4q = parcelRequire("kBr4q");

var $fjHkB = parcelRequire("fjHkB");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");


var $8A2GO = parcelRequire("8A2GO");

const $65e219e9f9df9520$var$store = (0, $8s9DV.createStore)({
    initialState: {
        cache: {}
    },
    actions: {
        updateCacheEntry: (key, value)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const currentCacheEntry = state.cache[key] ?? {
                    data: null,
                    error: null,
                    isFetching: false
                };
                const newCacheEntry = {
                    ...currentCacheEntry,
                    ...value
                };
                setState({
                    cache: {
                        ...state.cache,
                        [key]: newCacheEntry
                    }
                });
            },
        getCacheEntry: (key)=>({ getState: getState })=>{
                const state = getState();
                return state.cache[key];
            },
        deleteCacheEntry: (key)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const cache = {
                    ...state.cache
                };
                delete cache[key];
                setState({
                    cache: cache
                });
            }
    }
});
const $65e219e9f9df9520$var$selector = (0, $fjHkB.createSelector)((state)=>state.cache, (_, props)=>props.key, (_, props)=>props.initialQueryEnabled, /**
 * Based on testing, the result of this selector will be compared with previous result using `shallowEqual`
 * and it will determine whether to rerender the component
 * and also after looking at docs in https://github.com/atlassian/react-sweet-state/blob/master/src/utils/memoize.js#L38
 *
 * e.g. for `enabled` true condition:
 * -> 1st call -> cache[key] === undefined; so it will return { data: null, error: null, isFetching: true }
 * -> 2nd call -> cache[key] !== undefined; so it will return cache[key]; however shallowEqual(cache[key], previousResult) will return true -> so no rerender
 *
 * To test this, run the unit test, and then force this function to return new stuff on every call
 * e.g. `return { ...result, random: Math.random() };`
 * it will result in increase renderCount in the unit test
 */ (cache, key, initialQueryEnabled)=>cache[key] ?? {
        data: null,
        error: null,
        isFetching: initialQueryEnabled
    });
const $65e219e9f9df9520$var$useCacheEntry = (0, $kBr4q.createHook)($65e219e9f9df9520$var$store, {
    selector: $65e219e9f9df9520$var$selector
});
const $65e219e9f9df9520$export$96097db97bddd5cd = ({ queryKey: queryKeyParts, queryFn: queryFn, onStart: onStart, onSuccess: onSuccess, onError: onError })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const storeApi = (0, $c6StJ.defaultRegistry).getStore($65e219e9f9df9520$var$store);
    const actions = storeApi.actions;
    if (actions.getCacheEntry(queryKey) !== undefined) return;
    onStart?.();
    actions.updateCacheEntry(queryKey, {
        isFetching: true,
        data: null,
        error: null
    });
    queryFn().then((response)=>{
        actions.updateCacheEntry(queryKey, {
            data: response,
            error: null,
            isFetching: false
        });
        onSuccess?.(response);
    }).catch((error)=>{
        // Cache-side errors are intentionally swallowed: a downstream `useQuery`
        // observer (if any) must refetch and surface the error via its normal
        // path. Remove the warm entry so the failed prefetch does not poison the
        // shared cache for the cold path.
        actions.deleteCacheEntry(queryKey);
        onError?.(error);
    });
};
const $65e219e9f9df9520$export$dd0a697e1782aedd = ({ queryKey: queryKeyParts, queryFn: queryFn, onSuccess: onSuccess, onError: onError, enabled: enabled = true, refetchOnWindowFocus: refetchOnWindowFocus = false })=>{
    const queryKey = queryKeyParts.map((x)=>x?.toString()).join('_');
    const queryFnRef = (0, $cozmU.useRef)(queryFn);
    queryFnRef.current = queryFn;
    const onSuccessRef = (0, $cozmU.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $cozmU.useRef)(onError);
    onErrorRef.current = onError;
    const [cache, { updateCacheEntry: updateCacheEntry, getCacheEntry: getCacheEntry }] = $65e219e9f9df9520$var$useCacheEntry({
        key: queryKey,
        initialQueryEnabled: enabled
    });
    const fetchData = (0, $cozmU.useCallback)(async ()=>{
        updateCacheEntry(queryKey, {
            isFetching: true
        });
        try {
            const response = await queryFnRef.current();
            updateCacheEntry(queryKey, {
                data: response,
                error: null
            });
            onSuccessRef.current?.(response);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const apiError = (0, $8A2GO.mapErrorToApiError)(error);
            updateCacheEntry(queryKey, {
                error: apiError
            });
            onErrorRef.current?.(apiError);
        } finally{
            updateCacheEntry(queryKey, {
                isFetching: false
            });
        }
        return null;
    }, [
        updateCacheEntry,
        queryKey
    ]);
    const updateCache = (0, $cozmU.useCallback)((data)=>{
        updateCacheEntry(queryKey, {
            data: data
        });
    }, [
        updateCacheEntry,
        queryKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (enabled && refetchOnWindowFocus) {
            const unbind = (0, $cbY7C.bind)(window, {
                // We use visibilitychange instead of focus to prevent triggering refetch when moving between iframes such as agent embed
                type: 'visibilitychange',
                listener: ()=>{
                    if (enabled && refetchOnWindowFocus && !getCacheEntry(queryKey)?.isFetching) {
                        if (document.visibilityState === 'visible') fetchData();
                    }
                }
            });
            return unbind;
        }
    }, [
        enabled,
        fetchData,
        getCacheEntry,
        queryKey,
        refetchOnWindowFocus
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!getCacheEntry(queryKey) && enabled) fetchData();
    }, [
        queryKey,
        fetchData,
        enabled,
        getCacheEntry
    ]);
    return {
        data: cache.data,
        error: cache.error,
        isFetching: cache.isFetching,
        refetch: fetchData,
        updateCache: updateCache
    };
};
module.exports["prefetchQuery"] = $65e219e9f9df9520$export$96097db97bddd5cd;
module.exports["useQuery"] = $65e219e9f9df9520$export$dd0a697e1782aedd;

});

parcelRegister("8A2GO", function(module, exports) {
class $a4d06b5ca4d94b78$export$f2e832acab1bdd79 extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $a4d06b5ca4d94b78$export$89d83cc97c52a37 = (error)=>error instanceof $a4d06b5ca4d94b78$export$f2e832acab1bdd79;
const $a4d06b5ca4d94b78$export$3c02d1a328d4d808 = (error)=>{
    if ($a4d06b5ca4d94b78$export$89d83cc97c52a37(error)) return error;
    // Fallback since we expect the error to be an instance of ApiError
    return new $a4d06b5ca4d94b78$export$f2e832acab1bdd79(error.message, {
        statusCode: 0
    });
};
module.exports["ApiError"] = $a4d06b5ca4d94b78$export$f2e832acab1bdd79;
module.exports["isApiError"] = $a4d06b5ca4d94b78$export$89d83cc97c52a37;
module.exports["mapErrorToApiError"] = $a4d06b5ca4d94b78$export$3c02d1a328d4d808;

});

parcelRegister("fBeNh", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $haiCi = parcelRequire("haiCi");


var $8JTh2 = parcelRequire("8JTh2");

const $c818cddb4b471711$var$CloudIdLookupQuery = `
query tenantQuery($cloudIds: [ID!]) {
  tenantContexts(cloudIds: $cloudIds) {
    cloudUrl
    orgId
    customDomains {
      product
      hostName
    }
  }
}
`;
// Cached per `cloudId` — the raw AGG payload is product-agnostic, so we fetch
// once per tenant and let the rewrite step branch on product. The cache stores
// the in-flight Promise so concurrent product lookups dedupe to one request.
const $c818cddb4b471711$var$rawTenantCache = new Map();
const $c818cddb4b471711$var$fetchTenantContext = async (cloudId)=>{
    const response = await (0, $haiCi.performGqlFetch)({
        gqlQuery: $c818cddb4b471711$var$CloudIdLookupQuery,
        variables: {
            cloudIds: [
                cloudId
            ]
        }
    });
    return response.data?.tenantContexts?.[0];
};
const $c818cddb4b471711$export$d4ace54df9bd6bb1 = async (cloudId, product)=>{
    const cachingEnabled = (0, $ixfCV.fg)('aifc_create_enabled');
    let inFlight = cachingEnabled ? $c818cddb4b471711$var$rawTenantCache.get(cloudId) : undefined;
    if (!inFlight) {
        inFlight = $c818cddb4b471711$var$fetchTenantContext(cloudId);
        if (cachingEnabled) {
            $c818cddb4b471711$var$rawTenantCache.set(cloudId, inFlight);
            inFlight.then((result)=>{
                if (result === undefined) $c818cddb4b471711$var$rawTenantCache.delete(cloudId);
            }, ()=>{
                $c818cddb4b471711$var$rawTenantCache.delete(cloudId);
            });
        }
    }
    const raw = await inFlight;
    if (!raw) return undefined;
    return {
        cloudUrl: product ? (0, $8JTh2.rewriteBaseToCustomDomain)(raw.cloudUrl, product, raw.customDomains) : raw.cloudUrl,
        orgId: raw.orgId
    };
};
module.exports["getCloudUrlFromId"] = $c818cddb4b471711$export$d4ace54df9bd6bb1;

});

parcelRegister("8JTh2", function(module, exports) {
const $43581a61b5d6dd12$export$432453592155ebf4 = (base, product, customDomains)=>{
    const match = customDomains?.find((domain)=>domain.product === product && Boolean(domain.hostName));
    if (!match) return base;
    try {
        const url = new URL(base);
        url.hostname = match.hostName;
        // url.toString() normalises bare-root URLs to include a trailing slash
        // (e.g. 'https://wiki.starbucks.com/'). All handlers concatenate a
        // leading-slash path, so we strip the trailing slash to avoid double-slashes
        // (e.g. 'https://wiki.starbucks.com//wiki/spaces/...' → correct).
        return url.toString().replace(/\/$/, '');
    } catch  {
        return base;
    }
};
module.exports["rewriteBaseToCustomDomain"] = $43581a61b5d6dd12$export$432453592155ebf4;

});

parcelRegister("33DP2", function(module, exports) {
const $1034fab58a3f1117$export$73b400613798970e = 'rovo-agents-fe';
module.exports["ROVO_AGENTS_FE_TEAM_NAME"] = $1034fab58a3f1117$export$73b400613798970e;

});

parcelRegister("lJ6db", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $cXtTj = parcelRequire("cXtTj");


var $ixfCV = parcelRequire("ixfCV");


var $a33Aa = parcelRequire("a33Aa");


var $bjY3F = parcelRequire("bjY3F");


var $bxkJA = parcelRequire("bxkJA");


var $8A2GO = parcelRequire("8A2GO");


var $jTKfH = parcelRequire("jTKfH");


var $7zss8 = parcelRequire("7zss8");


var $fDfQA = parcelRequire("fDfQA");


var $emCLk = parcelRequire("emCLk");


var $5suST = parcelRequire("5suST");


var $irsyK = parcelRequire("irsyK");


var $7td41 = parcelRequire("7td41");


var $bkEBw = parcelRequire("bkEBw");

const $a1ccb2b7a1450c9c$var$PRODUCT_HEADER = 'x-product';
/** Number of tasks to request per page when using cursor-based pagination. */ const $a1ccb2b7a1450c9c$var$TASKS_PAGE_SIZE = 25;
const $a1ccb2b7a1450c9c$var$EXPERIENCE_ID_HEADER = 'x-experience-id';
const $a1ccb2b7a1450c9c$var$CHANNEL_ID_HEADER = 'X-Channel-Id';
const $a1ccb2b7a1450c9c$var$DEFAULT_FILE_VALIDATE_PATH = '/rovo/v1/chat/message/file/validate';
const $a1ccb2b7a1450c9c$var$DEFAULT_FILE_UPLOAD_PATH = '/rovo/v1/chat/message/file';
class $a1ccb2b7a1450c9c$export$40a7802808e2fbe3 {
    createHeaders(init) {
        return new Headers({
            [$a1ccb2b7a1450c9c$var$PRODUCT_HEADER]: this.config.product,
            [$a1ccb2b7a1450c9c$var$EXPERIENCE_ID_HEADER]: this.config.experienceId,
            ...this.config.headers || {},
            ...init || {}
        });
    }
    getChannelId(defaultChannelId) {
        return this.config.channelId || defaultChannelId;
    }
    async fetch({ path: path, options: options, holdName: holdName }) {
        const { baseUrl: configBaseUrl, credentials: configCredentials } = this.config;
        const baseUrl = configBaseUrl;
        const requestUrl = (0, $irsyK.addPath)(baseUrl, path);
        const startTime = performance.now();
        const response = await window.fetch(requestUrl, {
            credentials: configCredentials,
            ...options
        });
        if (this.config.labelStack) {
            // Please note that the recorded duration of this hold may differ from the time spent actually fetching the data.
            // This is because the browser may schedule network calls and JavaScript execution at its own discrection based
            // on available resources, the main thread being blocked, etc... Still, it is a helpful approximation.
            const endTime = performance.now();
            (0, $a33Aa.addSpanToAll)('fetch', holdName ? `${options.method}-${holdName}` : 'unknown', this.config.labelStack, startTime, endTime);
        }
        return (0, $irsyK.processResponse)({
            response: response
        });
    }
    async fetchJson(options) {
        const response = await this.fetch(options);
        const json = await response.json();
        return json;
    }
    async fetchStream(options, config) {
        const response = await this.fetch(options);
        const contentType = response.headers.get('content-type') ?? '';
        const headerSuggestsSSE = config?.useSSE && contentType.includes('text/event-stream');
        return {
            responseData: {
                traceId: (0, $jTKfH.getTraceIdFromResponse)(response)
            },
            generator: headerSuggestsSSE ? (0, $emCLk.readSSEStream)(response) : (0, $fDfQA.readJsonStream)(response)
        };
    }
    constructor(props){
        this.config = void 0;
        this.getConfig = ()=>{
            return {
                ...this.config
            };
        };
        const defaultBaseUrl = '/gateway/api/assist';
        const defaultConfig = {
            baseUrl: defaultBaseUrl,
            headers: {}
        };
        this.config = {
            ...props,
            baseUrl: props.baseUrl || defaultConfig.baseUrl,
            credentials: props.credentials,
            headers: {
                ...props.headers || defaultConfig.headers
            }
        };
    }
}
const $a1ccb2b7a1450c9c$var$getHref = (product)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const backendOriginHost = window?.__backendOriginHost;
    if (product === 'confluence' && window.location.hostname === 'localhost' && typeof backendOriginHost === 'string') {
        const urlWithLocalhost = new URL(window?.location?.href);
        urlWithLocalhost.hostname = backendOriginHost;
        urlWithLocalhost.port = '';
        urlWithLocalhost.protocol = 'https:';
        return urlWithLocalhost.toString();
    }
    return window?.location?.href;
};
class $a1ccb2b7a1450c9c$export$a522c5f4ccda1c94 extends $a1ccb2b7a1450c9c$export$40a7802808e2fbe3 {
    async sendMessageStream({ agentNamedId: agentNamedId, agentId: agentId, message: message, mimeType: mimeType, conversationId: conversationId, controller: controller, storeMessage: storeMessage = false, citationsEnabled: citationsEnabled = true, aiFeatureContext: aiFeatureContext, jiraWorkflowContext: jiraWorkflowContext, editorContext: editorContext, whiteboardContext: whiteboardContext, slidesContext: slidesContext, databaseContext: databaseContext, browserContext: browserContext, additionalContext: additionalContext, dashboardContext: dashboardContext, dashboardEditorContext: dashboardEditorContext, fileIds: fileIds, webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, fastModeEnabled: fastModeEnabled, planModeEnabled: planModeEnabled, appFilters: appFilters, useCurrentBrowsingContext: useCurrentBrowsingContext, minionAliasConfig: minionAliasConfig, optInToDeepResearchV2: optInToDeepResearchV2 = false, optInThinkDeeperMessages: optInThinkDeeperMessages = false, optInAnsNow: optInAnsNow = false, optInNewToolTraces: optInNewToolTraces = false, optInNewTeamworkTraceIcons: optInNewTeamworkTraceIcons = false, browserContextSanitizer: browserContextSanitizer, optInSSEStream: optInSSEStream = false, agentVersion: agentVersion, spaceId: spaceId, capabilities: capabilities, shouldExtractConversationScopes: shouldExtractConversationScopes, searchArtifact: searchArtifact, parentMessageId: parentMessageId }) {
        const effectiveCapabilities = (0, $5suST.buildEffectiveCapabilities)(capabilities);
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8',
            [$a1ccb2b7a1450c9c$var$CHANNEL_ID_HEADER]: this.getChannelId('rovo-chat'),
            // This header is used to opt-in to Deep Research v2 on the BE.
            // This is to ensure that we don't use v2 deep research when we are using the old Rovo Chat UI prior to the refresh..
            ...optInToDeepResearchV2 && {
                'X-Deep-Research-V2-Opt-In': 'true'
            },
            // Opt in to using RESEARCH_STEP, RESEARCH_PLAN, and similar messages for "think deeper".
            // Ensures backward compatibility with legacy clients and allows application targeting within the experiment.
            ...optInThinkDeeperMessages && {
                'X-Think-Deeper-Messages-Opt-In': 'true'
            },
            ...optInAnsNow && {
                'X-Answer-Now-UI-Opt-In': 'true'
            },
            ...optInNewToolTraces && {
                'X-New-Tool-Traces-Opt-In': 'true'
            },
            ...optInNewTeamworkTraceIcons && {
                'X-New-Teamwork-Trace-Icons-Opt-In': 'true'
            },
            ...effectiveCapabilities && effectiveCapabilities.length > 0 && {
                'X-Rovo-Chat-Capabilities': JSON.stringify(effectiveCapabilities)
            }
        });
        let knowledgeOverride = {};
        // not setting knowledgeEnabled and filters means all org knowledge is applied by default.
        if (appFilters) {
            if (appFilters.length === 0) knowledgeOverride = {
                knowledgeEnabled: false
            };
            else knowledgeOverride = {
                knowledgeEnabled: true,
                filters: {
                    knowledgeSources: appFilters
                }
            };
        }
        // Check if the URL is blocklisted
        const browserUrl = browserContext?.context?.browserUrl;
        const isBlocklisted = browserUrl && browserContextSanitizer ? browserContextSanitizer.isBlocklisted(browserUrl) : false;
        // Determine the URL to send to the backend
        // If blocklisted, send empty URL to ensure the site is not sent to the backend
        // If browserContext received and context is undefined, assume we're unable to retrieve the context of the page in focus
        let url;
        if (isBlocklisted || browserContext?.context?.browserUrl === 'NO-URL' && (0, $cXtTj.default).getExperimentValue('jira_free_gen_editor', 'isEnabled', false)) url = '';
        else if (browserContext?.context?.browserUrl) url = browserContext.context.browserUrl;
        else url = $a1ccb2b7a1450c9c$var$getHref(this.getConfig().product) ?? '';
        const defaultMimeType = typeof message === 'string' ? 'text/markdown' : 'text/adf';
        const body = {
            content: message,
            context: {
                // without useCurrentBrowsingContext browser_url is not always used by the Rovo,
                // instead it depends on prompt intent to use it,
                // with useCurrentBrowsingContext we can ensure it is always used
                browser_url: url,
                ...useCurrentBrowsingContext === undefined ? {} : {
                    useCurrentBrowsingContext: useCurrentBrowsingContext
                },
                webSearchEnabled: webSearchEnabled,
                deepResearchEnabled: deepResearchEnabled,
                ...thinkDeeperEnabled ? {
                    extendedThinkingEnabled: thinkDeeperEnabled
                } : {},
                ...alphaExtendedThinkingMode ? {
                    alphaExtendedThinkingMode: alphaExtendedThinkingMode
                } : {},
                ...fastModeEnabled ? {
                    fastModeEnabled: fastModeEnabled
                } : {},
                ...planModeEnabled ? {
                    planModeEnabled: planModeEnabled,
                    alphaExtendedThinkingMode: 'MARATHON',
                    extendedThinkingEnabled: true
                } : {},
                ...editorContext ? {
                    editor: editorContext
                } : {},
                ...whiteboardContext ? {
                    whiteboardContext: whiteboardContext
                } : {},
                ...slidesContext ? {
                    slidesContext: slidesContext
                } : {},
                ...databaseContext ? {
                    databaseContext: databaseContext
                } : {},
                ...dashboardEditorContext ? {
                    dashboardEditorContext: dashboardEditorContext
                } : {},
                // If browserUrl is inaccessable, fallback to htmlBody or canvasText if they exist
                // Do not send htmlBody or canvasText if the URL is blocklisted to ensure the site is truly not sent to the backend
                ...browserContext && !isBlocklisted ? {
                    browser: {
                        htmlBody: browserContext.context?.htmlBody,
                        canvasText: browserContext.context?.canvasText
                    }
                } : {},
                jiraWorkflowContext: jiraWorkflowContext,
                ...additionalContext,
                dashboardContext: dashboardContext,
                aiFeatureContext: aiFeatureContext,
                fileIds: fileIds,
                ...knowledgeOverride,
                ...searchArtifact ? {
                    search_artifact: searchArtifact
                } : {},
                ...shouldExtractConversationScopes !== undefined ? {
                    shouldExtractConversationScopes: shouldExtractConversationScopes
                } : {}
            },
            recipient_agent_named_id: agentNamedId,
            agent_id: agentId,
            mimeType: mimeType && (0, $ixfCV.fg)('jira_ai_rendering_a2ui') ? mimeType : defaultMimeType,
            ...agentVersion ? {
                agent_version: agentVersion
            } : {},
            // don't allow store message if feature flag is off
            store_message: (0, $ixfCV.fg)('ai_mate_show_store_messages') ? storeMessage : false,
            citations_enabled: citationsEnabled,
            ...minionAliasConfig ?? (this.getConfig().minionAlias ? {
                stratus_config: {
                    minion_alias: this.getConfig().minionAlias
                }
            } : {}),
            ...spaceId ? {
                space_id: spaceId
            } : {},
            ...parentMessageId ? {
                parent_message_id: parentMessageId
            } : {}
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: optInSSEStream ? `/rovo/v1/chat/conversation/${conversationId}/message/stream/sse` : `/rovo/v1/chat/conversation/${conversationId}/message/stream`,
            options: options
        }, {
            useSSE: optInSSEStream
        });
    }
    async reconnectToMessageStream({ conversationId: conversationId, messageId: messageId, lastEventId: lastEventId, controller: controller }) {
        const headers = this.createHeaders();
        // Add Last-Event-ID header if available
        if (lastEventId) headers.set('Last-Event-ID', lastEventId);
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchStream({
            path: `/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/stream/sse`,
            options: options
        }, {
            useSSE: true
        });
    }
    // Only takes effect if the stream is a Deep Research stream
    async cancelMessageStream({ conversationId: conversationId, messageId: messageId }) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers
        };
        await this.fetch({
            path: `/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/cancel`,
            options: options
        });
    }
    async sendMessageConfirmedTools({ conversationId: conversationId, agentId: agentId, controller: controller, confirmed_tools: confirmed_tools, optInSSEStream: optInSSEStream = false, storeMessage: storeMessage = false, webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, alphaExtendedThinkingMode: alphaExtendedThinkingMode, fastModeEnabled: fastModeEnabled, planModeEnabled: planModeEnabled, aiFeatureContext: aiFeatureContext, agentVersion: agentVersion, optInToDeepResearchV2: optInToDeepResearchV2 = false, optInThinkDeeperMessages: optInThinkDeeperMessages = false, optInAnsNow: optInAnsNow = false, optInNewToolTraces: optInNewToolTraces = false, optInNewTeamworkTraceIcons: optInNewTeamworkTraceIcons = false, capabilities: capabilities, searchArtifact: searchArtifact, jiraWorkflowContext: jiraWorkflowContext, editorContext: editorContext, whiteboardContext: whiteboardContext, slidesContext: slidesContext, databaseContext: databaseContext, browserContext: browserContext, additionalContext: additionalContext, dashboardContext: dashboardContext, dashboardEditorContext: dashboardEditorContext, useCurrentBrowsingContext: useCurrentBrowsingContext, browserContextSanitizer: browserContextSanitizer }) {
        const effectiveCapabilities = (0, $5suST.buildEffectiveCapabilities)(capabilities);
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8',
            [$a1ccb2b7a1450c9c$var$CHANNEL_ID_HEADER]: this.getChannelId('rovo-chat'),
            ...optInToDeepResearchV2 && {
                'X-Deep-Research-V2-Opt-In': 'true'
            },
            ...optInThinkDeeperMessages && {
                'X-Think-Deeper-Messages-Opt-In': 'true'
            },
            ...optInAnsNow && {
                'X-Answer-Now-UI-Opt-In': 'true'
            },
            ...optInNewToolTraces && {
                'X-New-Tool-Traces-Opt-In': 'true'
            },
            ...optInNewTeamworkTraceIcons && {
                'X-New-Teamwork-Trace-Icons-Opt-In': 'true'
            },
            ...effectiveCapabilities && effectiveCapabilities.length > 0 && {
                'X-Rovo-Chat-Capabilities': JSON.stringify(effectiveCapabilities)
            }
        });
        // browser_url is historically the current window location. The blocklist gates the page
        // browser context added under the `rovo-include-full-context-on-confirmed-tools`
        // experiment (when a browserContext is supplied). The NO-URL sentinel under the
        // `jira_free_gen_editor` experiment suppresses the URL (matching sendMessageStream) so that
        // cohort does not leak a URL.
        const browserUrl = browserContext?.context?.browserUrl;
        const isBrowserContextBlocklisted = !!(browserUrl && browserContextSanitizer?.isBlocklisted(browserUrl));
        const isBrowserUrlSuppressed = browserUrl === 'NO-URL' && (0, $cXtTj.default).getExperimentValue('jira_free_gen_editor', 'isEnabled', false);
        const url = isBrowserUrlSuppressed ? '' : window?.location?.href;
        const body = {
            conversation_id: conversationId,
            agent_id: agentId,
            confirmed_tools: confirmed_tools,
            ...agentVersion ? {
                agent_version: agentVersion
            } : {},
            context: {
                // Historical slim context — unchanged so the experiment-off request is byte-identical.
                browser_url: url,
                webSearchEnabled: webSearchEnabled,
                ...deepResearchEnabled ? {
                    deepResearchEnabled: deepResearchEnabled
                } : {},
                ...thinkDeeperEnabled ? {
                    extendedThinkingEnabled: thinkDeeperEnabled
                } : {},
                ...alphaExtendedThinkingMode ? {
                    alphaExtendedThinkingMode: alphaExtendedThinkingMode
                } : {},
                ...planModeEnabled ? {
                    planModeEnabled: planModeEnabled,
                    alphaExtendedThinkingMode: 'MARATHON',
                    extendedThinkingEnabled: true
                } : {},
                ...fastModeEnabled ? {
                    fastModeEnabled: fastModeEnabled
                } : {},
                ...aiFeatureContext ? {
                    aiFeatureContext: aiFeatureContext
                } : {},
                ...searchArtifact ? {
                    search_artifact: searchArtifact
                } : {},
                // Full request context — supplied by the store action only when the
                // `rovo-include-full-context-on-confirmed-tools` experiment is on, so the backend
                // receives the same page/whiteboard/creation context as a regular sendMessage.
                // Every field is omitted when undefined, so the slim request above is unaffected.
                ...useCurrentBrowsingContext === undefined ? {} : {
                    useCurrentBrowsingContext: useCurrentBrowsingContext
                },
                // Content-context objects. Inlined to mirror sendMessageStream's serialization
                // exactly; a unit test (the drift guard) asserts the two stay in sync. Each is
                // omitted when undefined, so the slim request above is unaffected.
                ...editorContext ? {
                    editor: editorContext
                } : {},
                ...whiteboardContext ? {
                    whiteboardContext: whiteboardContext
                } : {},
                ...slidesContext ? {
                    slidesContext: slidesContext
                } : {},
                ...databaseContext ? {
                    databaseContext: databaseContext
                } : {},
                ...dashboardEditorContext ? {
                    dashboardEditorContext: dashboardEditorContext
                } : {},
                ...browserContext && !isBrowserContextBlocklisted ? {
                    browser: {
                        htmlBody: browserContext.context?.htmlBody,
                        canvasText: browserContext.context?.canvasText
                    }
                } : {},
                jiraWorkflowContext: jiraWorkflowContext,
                ...additionalContext,
                dashboardContext: dashboardContext
            },
            // These values are hardcoded because they are not used in backend, but required in the contract
            content: '',
            mimeType: 'text/markdown',
            // don't allow store message if feature flag is off
            store_message: (0, $ixfCV.fg)('ai_mate_show_store_messages') ? storeMessage : false,
            citations_enabled: false
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: optInSSEStream ? `/rovo/v1/chat/conversation/${conversationId}/message/stream/sse` : `/rovo/v1/chat/conversation/${conversationId}/message/stream`,
            options: options
        }, {
            useSSE: optInSSEStream
        });
    }
    async nlCreateAgentStream({ controller: controller, latest_user_message: latest_user_message, draft_agent: draft_agent, conversation_history: conversation_history }) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const body = {
            latest_user_message: latest_user_message,
            draft_agent: draft_agent,
            conversation_history: conversation_history
        };
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(body),
            signal: controller?.signal
        };
        return this.fetchStream({
            path: `/rovo/v1/agents/nlcreate`,
            options: options
        });
    }
    async getChat(conversationId, capabilities) {
        // Forward the caller-provided chat capabilities (e.g. `inline_lumina_enabled`,
        // which is gated behind `rovo_chat_enable_inline_lumina`) so that fetching a
        // chat from history renders the same rich (Lumina) components as a live stream,
        // rather than downgrading to basic markdown.
        //
        // Note: this intentionally forwards `capabilities` as-is rather than routing
        // through `buildEffectiveCapabilities`. That helper fires the actionable
        // follow-ups experiment exposure, which must only happen when a message is
        // SENT — not when history is read — so reusing it here would pollute the
        // experiment and attach send-only capabilities to a read request.
        const headers = this.createHeaders({
            ...capabilities && capabilities.length > 0 && {
                'X-Rovo-Chat-Capabilities': JSON.stringify(capabilities)
            }
        });
        const options = {
            method: 'GET',
            headers: headers
        };
        const rawChat = await this.fetchJson({
            path: `/rovo/v1/chat/conversation/${conversationId}/messages`,
            options: options,
            holdName: 'rovo-v1-chat-conversation-[conversationId]-messages'
        });
        const chatArray = rawChat.items;
        return chatArray.map((message)=>(0, $bxkJA.isHumanMessage)(message) ? message : (0, $bkEBw.toStreamResponse)(message));
    }
    async deleteChat(conversationId, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        await this.fetch({
            path: `/rovo/v1/chat/conversation/${conversationId}`,
            options: options,
            holdName: 'rovo-v1-chat-conversation-[conversationId]'
        });
    }
    async getAgents(controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        const response = await this.fetchJson({
            path: '/rovo/v1/agents',
            options: options,
            holdName: 'rovo-v1-agents'
        });
        return response.items;
    }
    async getAgentDetails(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/rovo/v1/agents/${id}`,
            options: options,
            holdName: 'rovo-v1-agents-[id]'
        });
    }
    async getAgentDetailsByIdentityAccountId(identityAccountId, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/rovo/v1/agents/accountid/${identityAccountId}`,
            options: options,
            holdName: 'rovo-v1-agents-accountid-[identityAccountId]'
        });
    }
    async createAgent(payload, controller) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload),
            signal: controller?.signal
        };
        return this.fetchJson({
            path: '/rovo/v1/agents',
            options: options,
            holdName: 'rovo-v1-agents'
        });
    }
    async updateAgent(id, payload, controller) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PUT',
            headers: headers,
            body: JSON.stringify(payload),
            signal: controller?.signal
        };
        const response = await this.fetchJson({
            path: `/rovo/v1/agents/${id}`,
            options: options,
            holdName: 'rovo-v1-agents-[id]'
        });
        return response;
    }
    async deleteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        return this.fetchJson({
            path: `/rovo/v1/agents/${id}`,
            options: options,
            holdName: 'rovo-v1-agents-[id]'
        });
    }
    async favouriteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'POST',
            headers: headers,
            signal: controller?.signal
        };
        this.fetch({
            path: `/rovo/v1/agents/${id}/favourite`,
            options: options,
            holdName: 'rovo-v1-agents-[id]-favourite'
        });
    }
    async unfavouriteAgent(id, controller) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers,
            signal: controller?.signal
        };
        this.fetch({
            path: `/rovo/v1/agents/${id}/favourite`,
            options: options,
            holdName: 'rovo-v1-agents-[id]-favourite'
        });
    }
    async createConversationChannel(options) {
        const name = options && 'name' in options ? options.name : (0, $7td41.generateConversationName)();
        return this.fetchJson({
            path: `/rovo/v1/chat/conversation`,
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8',
                    [$a1ccb2b7a1450c9c$var$CHANNEL_ID_HEADER]: this.getChannelId('rovo-chat')
                }),
                body: JSON.stringify({
                    name: name,
                    dialogues: options?.dialogues ?? undefined,
                    tags: options?.tags,
                    ...(0, $ixfCV.fg)('rovo_chat_web_pass_agent_to_conversation') ? {
                        agent_id: options?.agentId
                    } : {}
                })
            },
            holdName: 'rovo-v1-chat-conversation'
        });
    }
    async getConversationChannels(options) {
        // Clean up `ConversationChannel[] | { items: ConversationChannel[] }` when fg('rovo_convo_ai_migration') is removed
        const searchParams = new URLSearchParams();
        if (options?.limit !== undefined) searchParams.set('limit', String(options.limit));
        if (options?.cursor !== undefined) searchParams.set('cursor', options.cursor);
        const queryString = searchParams.toString();
        const result = await this.fetchJson({
            path: `/rovo/v1/chat/conversations${queryString ? `?${queryString}` : ''}`,
            options: {
                method: 'GET',
                headers: this.createHeaders()
            },
            holdName: 'rovo-v1-chat-conversations'
        });
        // Transform snake_case fields to camelCase
        return {
            items: result.items.map((item)=>this.transformSnakeCaseToCamelCase(item)),
            hasNext: result.hasNext ?? false,
            cursor: result.cursor ?? null
        };
    }
    async getPinnedConversationSummary() {
        try {
            const result = await this.fetchJson({
                path: '/rovo/v1/chat/conversations/pinned-summary',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-chat-conversations-pinned-summary'
            });
            return {
                pinnedCount: result.pinned_count ?? 0,
                maxPinnedConversations: result.max_pinned_conversations ?? 0
            };
        } catch (error) {
            // The endpoint not being deployed yet surfaces as a 404 — ignore that (callers fall back to
            // the local pinned count). Any other failure is genuine, so rethrow rather than swallow it
            // silently, letting the caller report/handle it.
            const statusCode = error instanceof (0, $8A2GO.ApiError) ? error.errorAttributes?.statusCode : undefined;
            if (statusCode === 404) return undefined;
            throw error;
        }
    }
    updateConversationChannel(id, payload) {
        // Transform camelCase field names to snake_case for the REST API
        const apiPayload = this.transformCamelCaseToSnakeCase(payload);
        return this.fetchJson({
            path: `/rovo/v1/chat/conversation/${id}`,
            options: {
                method: 'PUT',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify(apiPayload)
            },
            holdName: 'rovo-v1-chat-conversation-[id]'
        }).then((response)=>this.transformSnakeCaseToCamelCase(response));
    }
    transformCamelCaseToSnakeCase(payload) {
        const result = {};
        for (const [key, value] of Object.entries(payload)){
            if (key === 'readStatus') result['read_status'] = value;
            else if (key === 'isPinned') result['is_pinned'] = value;
            else if (key === 'pinnedAt') result['pinned_at'] = value;
            else result[key] = value;
        }
        return result;
    }
    transformSnakeCaseToCamelCase(item) {
        if (item == null || typeof item !== 'object') throw new Error(`Expected an object from conversation channel API, got: ${typeof item}`);
        const result = {
            ...item
        };
        if ('read_status' in result) {
            result['readStatus'] = result['read_status'];
            delete result['read_status'];
        }
        if ('is_pinned' in result) {
            result['isPinned'] = result['is_pinned'];
            delete result['is_pinned'];
        }
        if ('pinned_at' in result) {
            result['pinnedAt'] = result['pinned_at'];
            delete result['pinned_at'];
        }
        return result;
    }
    async resolveConversationAction(id, payload) {
        return this.fetchJson({
            path: `/rovo/v1/chat/conversation/${id}/action`,
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'content-type': 'application/json;charset=UTF-8'
                }),
                body: JSON.stringify({
                    ...payload,
                    context: {
                        ...payload.context,
                        browser_url: window.location.href
                    }
                })
            },
            holdName: 'rovo-v1-chat-conversation-[id]-action'
        });
    }
    async bulkResolveConversationUIActions(conversationId, messageId, payload) {
        // The bulk API supports a maximum of 50 items per request.
        // Split into batches and process them sequentially.
        const BATCH_SIZE = 50;
        const allResponses = [];
        for(let batchStart = 0; batchStart < payload.items.length; batchStart += BATCH_SIZE){
            const batchItems = payload.items.slice(batchStart, batchStart + BATCH_SIZE);
            const batchResponses = await this.fetchJson({
                path: `/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/tools/resolution`,
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify({
                        items: batchItems.map((item)=>({
                                ...item,
                                context: {
                                    ...item.context,
                                    browser_url: window.location.href
                                }
                            }))
                    })
                },
                holdName: 'rovo-v1-chat-conversation-[id]-message-[messageId]-tools-resolution'
            });
            allResponses.push(...batchResponses);
        }
        return allResponses;
    }
    // REST starters, newer API
    async generateAgentStarters(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/rovo/v1/conversation-starters/agent-starter-suggestion',
            options: options,
            holdName: 'rovo-v1-conversation-starters-agent-starter-suggestion'
        });
    }
    // REST conversation starters, newer API
    async generateContextualStarters(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/rovo/v1/conversation-starters/page-contextual',
            options: options,
            holdName: 'rovo-v1-conversation-starters-page-contextual'
        });
    }
    // REST dynamic conversation starters (new endpoint)
    async getDynamicConvoStartersNew(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8',
            'x-experience-id': 'convo-starter-for-rovo-button'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/ai/v2/ai-feature/convo-starters',
            options: options,
            holdName: 'api-ai-v2-ai-feature-convo-starters'
        });
    }
    async getWebSearchConfiguration() {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers
        };
        const result = await this.fetchJson({
            path: '/api/v2/configuration/web-search-ai',
            options: options,
            holdName: 'api-v2-configuration-web-search-ai'
        });
        return result;
    }
    async getPrompts() {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers
        };
        const result = await this.fetchJson({
            path: '/api/v2/prompts',
            options: options,
            holdName: 'api-v2-prompts'
        });
        return result;
    }
    async getPrompt(promptId) {
        const headers = this.createHeaders();
        const options = {
            method: 'GET',
            headers: headers
        };
        return this.fetchJson({
            path: `/api/v2/prompts/${promptId}`,
            options: options,
            holdName: 'api-v2-prompts-[promptId]'
        });
    }
    async bulkGetPrompts(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/v2/prompts/bulk-get',
            options: options,
            holdName: 'api-v2-prompts-bulk-get'
        });
    }
    async createPrompt(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/v2/prompts',
            options: options,
            holdName: 'api-v2-prompts'
        });
    }
    async updatePrompt(promptId, payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PATCH',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: `/api/v2/prompts/${promptId}`,
            options: options,
            holdName: 'api-v2-prompts-update'
        });
    }
    async addPromptsToLibrary(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        await this.fetch({
            path: '/api/v2/prompts/add-to-library',
            options: options,
            holdName: 'api-v2-prompts-add-to-library'
        });
    }
    async deletePrompt(shareId) {
        const headers = this.createHeaders();
        const options = {
            method: 'DELETE',
            headers: headers
        };
        await this.fetch({
            path: `/api/v2/prompts/${shareId}`,
            options: options,
            holdName: 'api-v2-prompts-delete'
        });
    }
    async favoritePrompts(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        await this.fetch({
            path: `/api/v2/prompts/favorite`,
            options: options,
            holdName: 'api-v2-prompts-favorite'
        });
    }
    async bulkUpdatePrivacy(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/v2/prompts/bulk-update-privacy',
            options: options,
            holdName: 'api-v2-prompts-bulk-update-privacy'
        });
    }
    async upsertConversationShare(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PATCH',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/v2/share',
            options: options,
            holdName: 'api-v2-share-upsert'
        });
    }
    async ensureConversationShare(payload) {
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PATCH',
            headers: headers,
            body: JSON.stringify(payload)
        };
        return this.fetchJson({
            path: '/api/v2/share',
            options: options,
            holdName: 'api-v2-share-ensure'
        });
    }
    async replaceConversationShare(payload) {
        const { conversationId: conversationId, messageId: messageId, shareType: shareType, allowedUserAris: allowedUserAris } = payload;
        const query = new URLSearchParams({
            conversationId: conversationId,
            messageId: messageId
        });
        const body = {
            conversationId: conversationId,
            messageId: messageId,
            shareType: shareType,
            ...shareType === 'SPECIFIC_USERS' ? {
                allowedUserAris: allowedUserAris ?? []
            } : {}
        };
        const headers = this.createHeaders({
            'content-type': 'application/json;charset=UTF-8'
        });
        const options = {
            method: 'PUT',
            headers: headers,
            body: JSON.stringify(body)
        };
        return this.fetchJson({
            path: `/api/v2/share?${query.toString()}`,
            options: options,
            holdName: 'api-v2-share-replace'
        });
    }
    async getConversationShare(shareToken) {
        return this.fetchJson({
            path: `/api/v2/share/${encodeURIComponent(shareToken)}`,
            options: {
                method: 'GET',
                headers: this.createHeaders()
            },
            holdName: 'api-v2-share-get'
        });
    }
    async forkSharedConversation(shareToken) {
        return this.fetchJson({
            path: `/api/v2/share/${encodeURIComponent(shareToken)}/fork`,
            options: {
                method: 'POST',
                headers: this.createHeaders()
            },
            holdName: 'api-v2-share-fork'
        });
    }
    constructor(props){
        super(props);
        // Defined as an arrow property so `this` stays bound when the reference is
        // passed directly to data-fetching hooks (e.g. useQuery's queryFn).
        this.getGroupedConversationShares = async ()=>{
            return this.fetchJson({
                path: '/api/v2/shares/grouped',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'api-v2-shares-grouped-get'
            });
        };
        this.getAgentActions = async ()=>{
            const response = await this.fetchJson({
                path: '/rovo/v1/agents/configuration/actions',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agents-configuration-actions'
            });
            return response.actions;
        };
        this.getAgentKnowledgeConfiguration = (agentCreatorType)=>{
            const queryParams = agentCreatorType ? `?agentCreatorType=${agentCreatorType}` : '';
            return this.fetchJson({
                path: `/rovo/v1/agents/configuration/knowledge${queryParams}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agents-configuration-knowledge'
            });
        };
        this.getAgentPermissions = (agentId, payload)=>{
            return this.fetchJson({
                path: `/rovo/v2/permissions/agents/${agentId}`,
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v2-permissions-agents-[agentId]'
            });
        };
        this.getRecommendedAgents = ({ limit: limit, pageUrl: pageUrl })=>{
            const urlParams = new URLSearchParams({
                limit: limit.toString()
            });
            if (pageUrl) urlParams.append('pageUrl', pageUrl);
            const fullPath = `/rovo/v1/agents/recommend/v2?${urlParams.toString()}`;
            return this.fetchJson({
                path: fullPath,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agents-recommend-v2'
            });
        };
        this.getConversationDebugLogs = async (conversationId)=>{
            const response = await this.fetchJson({
                path: `/rovo/v1/chat/conversation/${conversationId}/debug-logs`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-chat-conversation-[conversationId]-debug-logs'
            });
            return response.items;
        };
        this.validateFiles = async (payload)=>{
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            return this.fetchJson({
                path: this.config.fileValidatePath ?? $a1ccb2b7a1450c9c$var$DEFAULT_FILE_VALIDATE_PATH,
                options: {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v1-chat-message-file-validate'
            });
        };
        this.uploadFiles = async (payload)=>{
            const formData = new FormData();
            for (const file of payload.files)formData.append('files', file);
            const response = await this.fetchJson({
                path: this.config.fileUploadPath ?? $a1ccb2b7a1450c9c$var$DEFAULT_FILE_UPLOAD_PATH,
                options: {
                    method: 'POST',
                    headers: this.createHeaders(),
                    body: formData
                },
                holdName: 'rovo-v1-chat-message-file'
            });
            return response;
        };
        this.rovoLabsSendMessage = (payload)=>{
            return this.fetchStream({
                path: '/rovo/v1/agent-playground/chat/stream',
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'content-type': 'application/json;charset=UTF-8'
                    }),
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v1-agent-playground-chat-stream'
            });
        };
        this.rovoLabsGetConversations = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/chat/conversations',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-chat-conversations'
            });
        };
        this.rovoLabsGetTools = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/tools',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-tools'
            });
        };
        this.rovoLabsGetLanguageModels = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/language-models',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-language-models'
            });
        };
        this.rovoLabsGetPrompts = ()=>{
            return this.fetchJson({
                path: '/rovo/v1/agent-playground/prompts',
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-agent-playground-prompts'
            });
        };
        this.getGeneratedContent = (payload)=>{
            const queryParams = [];
            if (payload?.actions && payload.actions.length > 0) queryParams.push(`actionKeys=${payload.actions.join(',')}`);
            if (payload?.statuses && payload.statuses.length > 0) queryParams.push(`statuses=${payload.statuses.join(',')}`);
            if (payload?.limit !== undefined) queryParams.push(`limit=${payload.limit}`);
            const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
            return this.fetchJson({
                path: `/rovo/v1/chat/generated-content${queryString}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-chat-generated-content'
            });
        };
        this.getRovoUserSettings = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/user-settings',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-user-settings'
            });
        };
        this.updateRovoUserSettings = async (settings)=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/user-settings',
                options: {
                    method: 'PUT',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify(settings)
                },
                holdName: 'rovo-v1-chat-user-settings'
            });
        };
        this.getRovoMemories = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-memories'
            });
        };
        this.getRovoMemoryBlurb = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories/blurb',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-memories-blurb'
            });
        };
        this.answerNow = async (conversationId, messageId)=>{
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            const options = {
                method: 'POST',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/chat/conversation/${conversationId}/message/${messageId}/answer-now`,
                options: options,
                holdName: 'rovo-v1-chat-conversation-message-answer-now'
            });
        };
        this.deleteRovoMemory = async (memoryId)=>{
            const headers = this.createHeaders();
            const options = {
                method: 'DELETE',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/chat/memories/${memoryId}`,
                options: options,
                holdName: 'rovo-v1-chat-memories-[memoryId]'
            });
        };
        this.getRovoMemoryEdits = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories/memory-edits',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-memories-memory-edits'
            });
        };
        this.createMemoryEdit = async (payload)=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories/memory-edits',
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v1-chat-memories-memory-edits'
            });
        };
        this.createMemory = async (payload)=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories/create',
                options: {
                    method: 'POST',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify(payload)
                },
                holdName: 'rovo-v1-chat-memories-create'
            });
        };
        this.getRovoMemoryEditsCount = async ()=>{
            return this.fetchJson({
                path: '/rovo/v1/chat/memories/memory-edits/count',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-chat-memories-memory-edits-count'
            });
        };
        this.deleteRovoMemoryEdit = async (editId)=>{
            const headers = this.createHeaders();
            const options = {
                method: 'DELETE',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/chat/memories/memory-edits/${editId}`,
                options: options,
                holdName: 'rovo-v1-chat-memories-memory-edits-[editId]'
            });
        };
        this.fetchConversationMetadata = async (conversationId)=>{
            const result = await this.fetchJson({
                path: `/rovo/v1/chat/conversation/${conversationId}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders()
                },
                holdName: 'rovo-v1-chat-conversation-[conversationId]'
            });
            return this.transformSnakeCaseToCamelCase(result);
        };
        this.fetchPersonalizedPromptSuggestions = async (config)=>{
            const { offset: offset = 0, limit: limit = 9 } = config;
            const headers = this.createHeaders({
                'Content-Type': 'application/json'
            });
            const options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    ai_feature_input: {
                        offset: offset,
                        limit: limit
                    }
                })
            };
            const result = await this.fetchJson({
                path: '/api/ai/v2/ai-feature/confluence-prompt-tiles',
                options: options,
                holdName: 'api-ai-v2-ai-feature-confluence-prompt-tiles'
            });
            return result?.ai_feature_output?.prompt_tiles ?? [];
        };
        this.getTasks = async (params)=>{
            const searchParams = new URLSearchParams();
            searchParams.set('limit', String(params?.limit ?? $a1ccb2b7a1450c9c$var$TASKS_PAGE_SIZE));
            if (params?.cursor) searchParams.set('cursor', params.cursor);
            return this.fetchJson({
                path: `/rovo/v1/tasks?${searchParams.toString()}`,
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    })
                },
                holdName: 'rovo-v1-tasks'
            });
        };
        this.getTasksStream = async (controller)=>{
            return this.fetchStream({
                path: '/rovo/v1/tasks/stream',
                options: {
                    method: 'GET',
                    headers: this.createHeaders({
                        Accept: 'text/event-stream'
                    }),
                    signal: controller?.signal
                },
                holdName: 'rovo-v1-tasks-stream'
            }, {
                useSSE: true
            });
        };
        this.cancelTask = async (taskId)=>{
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            const options = {
                method: 'POST',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/tasks/${taskId}/cancel`,
                options: options,
                holdName: 'rovo-v1-tasks-[taskId]-cancel'
            });
        };
        this.deleteTask = async (taskId)=>{
            const headers = this.createHeaders({
                'content-type': 'application/json;charset=UTF-8'
            });
            const options = {
                method: 'DELETE',
                headers: headers
            };
            await this.fetch({
                path: `/rovo/v1/tasks/${taskId}`,
                options: options,
                holdName: 'rovo-v1-tasks-[taskId]-delete'
            });
        };
        this.renameTask = async (taskId, title)=>{
            return this.fetchJson({
                path: `/rovo/v1/tasks/${taskId}`,
                options: {
                    method: 'PUT',
                    headers: this.createHeaders({
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify({
                        title: title
                    })
                },
                holdName: 'rovo-v1-tasks-[taskId]'
            });
        };
        this.fetchPersonalizedPromptSuggestionsStream = async (config)=>{
            const { offset: offset = 0, limit: limit = 9 } = config;
            const headers = this.createHeaders({
                'Content-Type': 'application/json'
            });
            const options = {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    ai_feature_input: {
                        offset: offset,
                        limit: limit
                    }
                })
            };
            return this.fetchStream({
                path: '/api/ai/v2/ai-feature/confluence-prompt-tiles/stream',
                options: options,
                holdName: 'api-ai-v2-ai-feature-confluence-prompt-tiles-stream'
            });
        };
    }
}
const $a1ccb2b7a1450c9c$var$AssistanceServiceContext = /*#__PURE__*/ (0, $cozmU.createContext)(new $a1ccb2b7a1450c9c$export$a522c5f4ccda1c94({
    baseUrl: '',
    product: '',
    experienceId: ''
}));
const $a1ccb2b7a1450c9c$export$8fe647eb935c33db = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { value: value, children: children } = t0;
    let t1;
    if ($[0] !== children || $[1] !== value) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a1ccb2b7a1450c9c$var$AssistanceServiceContext.Provider, {
            value: value
        }, children);
        $[0] = children;
        $[1] = value;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ value: value, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a1ccb2b7a1450c9c$var$AssistanceServiceContext.Provider, {
        value: value
    }, children);
const $a1ccb2b7a1450c9c$export$7e31a1844ebbaf85 = (props)=>{
    (0, $6cFsl.di)((0, $cozmU.useContext), $a1ccb2b7a1450c9c$export$a522c5f4ccda1c94);
    const service = (0, $cozmU.useContext)($a1ccb2b7a1450c9c$var$AssistanceServiceContext);
    (0, $7zss8.setRovoChatProduct)(props?.product ?? service.getConfig().product);
    if (!props || !props.experienceId && !props.product && !props.headers && !props.channelId) return service;
    const product = props.product ?? service.getConfig().product;
    const experienceId = props.experienceId ?? service.getConfig().experienceId;
    const headers = props.headers ?? service.getConfig().headers;
    const channelId = props.channelId ?? service.getConfig().channelId;
    return new $a1ccb2b7a1450c9c$export$a522c5f4ccda1c94({
        ...service.getConfig(),
        product: product,
        experienceId: experienceId,
        headers: headers,
        channelId: channelId
    });
};
const $a1ccb2b7a1450c9c$export$5a9ea20fc196ec62 = (originalHook)=>{
    return (props)=>{
        (0, $6cFsl.di)($a1ccb2b7a1450c9c$export$a522c5f4ccda1c94, (0, $bjY3F.useAIMateExperienceTracker));
        const { assistanceServiceParams: assistanceServiceParams, ...restProps } = props;
        const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)({
            touchpointSource: assistanceServiceParams.touchpointSource
        });
        const headers = (0, $cozmU.useMemo)(()=>{
            // even though AssistanceServiceInputParam enforces lowercase header keys,
            // it is possible to get a non lowercase key if a prebuilt object was assigned to headers at runtime,
            // so this is an additional safety net, without this duplicate headers keys with different case
            // can get appended during header normalization causing request to fail
            // Relevant thread: https://atlassian.slack.com/archives/C0677M19GU9/p1748531977923069?thread_ts=1747336061.856749&cid=C0677M19GU9
            const inputHeaders = props.assistanceServiceParams.headers ? Object.fromEntries(Object.entries(props.assistanceServiceParams.headers).map(([key, value])=>[
                    key.toLowerCase(),
                    value
                ])) : undefined;
            return {
                'x-cloudid': props.assistanceServiceParams.siteId,
                ...inputHeaders
            };
        }, [
            props.assistanceServiceParams.siteId,
            props.assistanceServiceParams.headers
        ]);
        const assistanceService = (0, $cozmU.useMemo)(()=>{
            return new $a1ccb2b7a1450c9c$export$a522c5f4ccda1c94({
                product: assistanceServiceParams.product,
                experienceId: assistanceServiceParams.experienceId,
                headers: headers,
                baseUrl: assistanceServiceParams.baseUrl,
                minionAlias: assistanceServiceParams.minionAlias,
                fileValidatePath: assistanceServiceParams.fileValidatePath,
                fileUploadPath: assistanceServiceParams.fileUploadPath
            });
        }, [
            assistanceServiceParams.baseUrl,
            assistanceServiceParams.experienceId,
            assistanceServiceParams.product,
            headers,
            assistanceServiceParams.minionAlias,
            assistanceServiceParams.fileValidatePath,
            assistanceServiceParams.fileUploadPath
        ]);
        // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing assistance-service baseline: injected hook params are adapted to the generic hook parameter type.
        const result = originalHook({
            ...restProps,
            assistanceServiceInjectedParams: {
                ...assistanceServiceParams,
                headers: headers,
                experienceTracker: experienceTracker,
                assistanceService: assistanceService
            }
        });
        return result;
    };
};
module.exports["AssistanceServiceBase"] = $a1ccb2b7a1450c9c$export$40a7802808e2fbe3;
module.exports["AssistanceServiceImpl"] = $a1ccb2b7a1450c9c$export$a522c5f4ccda1c94;
module.exports["AssistanceServiceProvider"] = $a1ccb2b7a1450c9c$export$8fe647eb935c33db;
module.exports["useAssistanceService"] = $a1ccb2b7a1450c9c$export$7e31a1844ebbaf85;
module.exports["createHookWithAssistanceService"] = $a1ccb2b7a1450c9c$export$5a9ea20fc196ec62;

});

parcelRegister("bxkJA", function(module, exports) {

var $fCunh = parcelRequire("fCunh");


var $8A2GO = parcelRequire("8A2GO");

const $c3ad42ae8c5c5089$export$f78edfe5a93b58af = (message)=>{
    return message !== null && typeof message === 'object' && '__isSSEWrapper' in message && message.__isSSEWrapper === true;
};
const $c3ad42ae8c5c5089$export$5945515082cc2cbf = 'convoai.rest.not.found';
const $c3ad42ae8c5c5089$export$c424fe9570a5f2d9 = 'ACCEPTABLE_USE_VIOLATIONS';
var $c3ad42ae8c5c5089$export$2e28f9aa1dcf9823 = /*#__PURE__*/ function(PromptCategory) {
    PromptCategory["ANALYZE"] = "Analyze";
    PromptCategory["BRAINSTORM"] = "Brainstorm";
    PromptCategory["REVIEW"] = "Review";
    PromptCategory["SUMMARIZE"] = "Summarize";
    PromptCategory["CREATE"] = "Create";
    PromptCategory["EXECUTE"] = "Execute";
    PromptCategory["FIND"] = "Find";
    PromptCategory["LEARN"] = "Learn";
    return PromptCategory;
}({});
var $c3ad42ae8c5c5089$export$bd1535eb0caf2683 = /*#__PURE__*/ function(PromptRole) {
    PromptRole["GENERAL"] = "General";
    PromptRole["ENGINEERING"] = "Engineering";
    PromptRole["PRODUCT"] = "Product";
    PromptRole["PROGRAM_MANAGEMENT"] = "Program Management";
    PromptRole["DESIGN"] = "Design";
    PromptRole["MARKETING"] = "Marketing";
    PromptRole["IT_OPS"] = "IT Ops";
    PromptRole["SALES"] = "Sales";
    PromptRole["CUSTOMER_SUPPORT"] = "Customer Support";
    PromptRole["HELPDESK_SUPPORT"] = "Helpdesk Support";
    PromptRole["SECURITY"] = "Security";
    return PromptRole;
}({});
const $c3ad42ae8c5c5089$export$77c9504201bdfdea = 'PROMPT_TILE';
const $c3ad42ae8c5c5089$export$fb661125ffb29bd6 = (message)=>{
    return $c3ad42ae8c5c5089$export$a69fab2afb88c2eb(message) || $c3ad42ae8c5c5089$export$6f965deda7f0960c(message) || $c3ad42ae8c5c5089$export$b4631726cbc1440a(message);
};
const $c3ad42ae8c5c5089$export$a69fab2afb88c2eb = (message)=>message instanceof Object && message.role === 'HUMAN';
const $c3ad42ae8c5c5089$export$6f965deda7f0960c = (message)=>message instanceof Object && message.role === 'ASSISTANT';
const $c3ad42ae8c5c5089$export$a6e5100ca2770191 = (message)=>message instanceof Object && $c3ad42ae8c5c5089$export$6f965deda7f0960c(message.message);
const $c3ad42ae8c5c5089$export$5c1c15675df13ae5 = (message)=>$c3ad42ae8c5c5089$export$b4631726cbc1440a(message) && message.message?.message?.async_status === 'IN_PROGRESS';
const $c3ad42ae8c5c5089$export$b4631726cbc1440a = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $c3ad42ae8c5c5089$export$d422a2733a3b5def = (message)=>message instanceof Object && message.type === 'ERROR';
const $c3ad42ae8c5c5089$export$1e1cf807ece63df4 = (message)=>$c3ad42ae8c5c5089$export$d422a2733a3b5def(message) && message.message?.message_template === $c3ad42ae8c5c5089$export$c424fe9570a5f2d9;
const $c3ad42ae8c5c5089$export$e45102edbc73b240 = (message)=>message instanceof Object && message.type === 'ANSWER_PART';
const $c3ad42ae8c5c5089$export$51a109436d382715 = (message)=>message instanceof Object && message.type === 'REASONING_PART';
const $c3ad42ae8c5c5089$export$dbf4211c9117b9bc = (message)=>message instanceof Object && message.type === 'ACTION_PART';
const $c3ad42ae8c5c5089$export$3d7b0b359441d5a6 = (message)=>message instanceof Object && message.type === 'ACTION_CLASSIFICATION';
const $c3ad42ae8c5c5089$export$584e11c2903f4ed6 = (message)=>message instanceof Object && message.type === 'ACTION_PREPARE';
const $c3ad42ae8c5c5089$export$7d94ce53d589f586 = (message)=>message instanceof Object && message.type === 'ACTION_COMPLETE';
const $c3ad42ae8c5c5089$export$abec64f24e2ec3e7 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_START';
const $c3ad42ae8c5c5089$export$9c1f93971e9e3fbe = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH';
const $c3ad42ae8c5c5089$export$79a0ed7d987faa8f = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP';
const $c3ad42ae8c5c5089$export$7b1c8227569f1a92 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE';
const $c3ad42ae8c5c5089$export$cde91b49af35d559 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_PLAN';
const $c3ad42ae8c5c5089$export$4a6a601f69cf3c74 = (message)=>message instanceof Object && message.type === 'TODO_SNAPSHOT';
const $c3ad42ae8c5c5089$export$6b0058543411cb3a = (message)=>message instanceof Object && message.type === 'TASK_STATUS';
const $c3ad42ae8c5c5089$export$ac74da022f74040a = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_TITLE_SHORT';
const $c3ad42ae8c5c5089$export$7898cc38956b9052 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'SKILL_START';
const $c3ad42ae8c5c5089$export$bb608d13a1268633 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'SKILL_END';
const $c3ad42ae8c5c5089$export$b65c73c7e2d8d96f = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'FAST_MODE_RESPONSE_AVAILABLE';
const $c3ad42ae8c5c5089$export$40cf419186312161 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'FAST_MODE_ENABLED';
const $c3ad42ae8c5c5089$export$a83708fc4401682d = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'REMOVE_ANSWER_NOW';
const $c3ad42ae8c5c5089$export$68192da24ac8c141 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_SOURCE';
const $c3ad42ae8c5c5089$export$cfccfd17b68ccb0 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_COMPLETE';
const $c3ad42ae8c5c5089$export$1fd230d6956c2575 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_ICONS';
const $c3ad42ae8c5c5089$export$3bc697eeff31bdf6 = (message)=>message instanceof Object && message.type === 'TRACE' && message.message.message_template === 'RESEARCH_STEP_DOCUMENT';
const $c3ad42ae8c5c5089$export$c679ee34f7312895 = (message)=>message instanceof Object && message.type === 'RECONNECT_SUPPORTED';
const $c3ad42ae8c5c5089$export$b00dd9d0560e29d2 = (message)=>message instanceof Object && message.type === 'ANSWER_GENERATION_TYPE';
const $c3ad42ae8c5c5089$export$5fa02529cd2ab34c = (message)=>message instanceof Object && message.type === 'DL_SUB_AGENT';
const $c3ad42ae8c5c5089$export$46e0fb5e4b019a49 = (message)=>message instanceof Object && message.type === 'TRACE' && (message.message.message_template === 'RESEARCH' || message.message.message_template === 'RESEARCH_STEP' || message.message.message_template === 'RESEARCH_STEP_TITLE' || message.message.message_template === 'RESEARCH_STEP_TITLE_SHORT' || message.message.message_template === 'RESEARCH_STEP_SOURCE' || message.message.message_template === 'RESEARCH_STEP_COMPLETE' || message.message.message_template === 'RESEARCH_STEP_ICONS' || message.message.message_template === 'RESEARCH_STEP_DOCUMENT');
const $c3ad42ae8c5c5089$export$6f74311d40862a9f = (message)=>message instanceof Object && message.type === 'TRACE' && ($c3ad42ae8c5c5089$export$7898cc38956b9052(message) || $c3ad42ae8c5c5089$export$bb608d13a1268633(message));
const $c3ad42ae8c5c5089$export$d95e474df0d530df = (message)=>message instanceof Object && message.type === 'TRACE' && message.message?.message_template === 'MEMORY_UPDATE';
const $c3ad42ae8c5c5089$export$fd5a05be03f147a0 = (message)=>{
    // TRACE and research steps are sharing the same type, but we want to separate them
    if ($c3ad42ae8c5c5089$export$46e0fb5e4b019a49(message)) return false;
    if ($c3ad42ae8c5c5089$export$cde91b49af35d559(message)) return false;
    if ($c3ad42ae8c5c5089$export$6f74311d40862a9f(message)) return false;
    if ($c3ad42ae8c5c5089$export$b65c73c7e2d8d96f(message)) return false;
    if ($c3ad42ae8c5c5089$export$682514f3a8131b98(message)) return false;
    return message instanceof Object && message.type === 'TRACE';
};
const $c3ad42ae8c5c5089$export$682514f3a8131b98 = (message)=>{
    return message instanceof Object && message.type === 'TRACE' && message.message?.message_template === 'THINK_DEEPER_TRIGGERED';
};
const $c3ad42ae8c5c5089$export$aeae5b4fda357302 = (message)=>message !== undefined && message !== null && typeof message === 'object' && 'type' in message && message.type === 'FOLLOW_UP_QUERIES';
const $c3ad42ae8c5c5089$export$6275ff996073145e = (message)=>{
    if (!$c3ad42ae8c5c5089$export$f78edfe5a93b58af(message) || message.eventType !== 'AGENTIC_UI') return false;
    if (message.data === null || typeof message.data !== 'object') return false;
    const data = message.data;
    return Array.isArray(data.message?.content);
};
const $c3ad42ae8c5c5089$export$b46beea5c82aa1b9 = (message)=>message instanceof Object && message.type === 'HEART_BEAT';
const $c3ad42ae8c5c5089$export$b8391261162989d9 = (message)=>$c3ad42ae8c5c5089$export$6f965deda7f0960c(message) && (message?.message_metadata?.is_action_execution ?? false) && message?.message_metadata?.action_execution_result === 'SUCCESS';
const $c3ad42ae8c5c5089$export$1060c4fa97e34fa7 = (payloadContext)=>{
    return payloadContext?.resolution?.type === 'cancel';
};
const $c3ad42ae8c5c5089$export$6ce1ccc24e75456f = (error)=>(0, $8A2GO.isApiError)(error) && error.errorAttributes?.errorCode === $c3ad42ae8c5c5089$export$5945515082cc2cbf;
const $c3ad42ae8c5c5089$export$c3c933dad2745d3f = (msg)=>msg && msg.type === 'ACTION_ERROR' && msg.message && msg.message.status === 'ERRORED';
const $c3ad42ae8c5c5089$export$bc96a6a479480590 = (error)=>(0, $8A2GO.isApiError)(error) && error.errorAttributes.statusCode === 429;
const $c3ad42ae8c5c5089$export$f8b1b75846492611 = (error)=>(0, $8A2GO.isApiError)(error) && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === (0, $fCunh.ASSISTANCE_SERVICE_ERROR_CODES).HAS_HIPAA_ENABLED;
const $c3ad42ae8c5c5089$export$d263dc5d64f36d48 = (error)=>error instanceof Object && error?.detail?.type === 'ERROR' && !!error.errorAttributes.errorCode && error.errorAttributes.errorCode === $c3ad42ae8c5c5089$export$c424fe9570a5f2d9;
const $c3ad42ae8c5c5089$export$b454081350f4a578 = (message)=>message instanceof Object && message.type === 'CONVERSATION_CHANNEL_DATA';
const $c3ad42ae8c5c5089$export$145ab74998a54a20 = (message)=>message instanceof Object && message.type === 'SCOPE_DETERMINED';
const $c3ad42ae8c5c5089$export$75ceabc5bb9500e4 = (message)=>message instanceof Object && message.type === 'SPACE_SOURCE_RECOMMENDATIONS' && message.message instanceof Object;
const $c3ad42ae8c5c5089$export$f4111656f23d9b9b = (message)=>message instanceof Object && (message.type === 'PROMPT_REDACTION' || message.type === 'PROMPT_REDACTED');
const $c3ad42ae8c5c5089$export$c43cf9ba6a2176ef = (message)=>message instanceof Object && (message.type === 'PROMPT_BLOCKED' || message.type === 'PROMPT_BLOCK');
const $c3ad42ae8c5c5089$export$f16ff8eb19967a97 = (message)=>message instanceof Object && message.type === 'RESPONSE_REDACTION';
const $c3ad42ae8c5c5089$export$55f7bd80eacbc51b = (message)=>message instanceof Object && message.type === 'RESPONSE_BLOCKED';
const $c3ad42ae8c5c5089$export$a1be74470d3c1fe9 = (message)=>message instanceof Object && message.type === 'ATTACHMENT_BLOCKED';
function $c3ad42ae8c5c5089$export$4af48296a8d61cec(payloadContext) {
    return payloadContext?.resolution?.type === 'confirm';
}
module.exports["isSSEMessage"] = $c3ad42ae8c5c5089$export$f78edfe5a93b58af;
module.exports["ACCEPTABLE_USE_VIOLATIONS_ERROR"] = $c3ad42ae8c5c5089$export$c424fe9570a5f2d9;
module.exports["SUGGESTED_PROMPT_TILE_STREAM_MESSAGE_TYPE"] = $c3ad42ae8c5c5089$export$77c9504201bdfdea;
module.exports["isHumanMessage"] = $c3ad42ae8c5c5089$export$a69fab2afb88c2eb;
module.exports["isAssistantMessage"] = $c3ad42ae8c5c5089$export$6f965deda7f0960c;
module.exports["isStreamResponse"] = $c3ad42ae8c5c5089$export$b4631726cbc1440a;
module.exports["isAgentResponse"] = $c3ad42ae8c5c5089$export$a6e5100ca2770191;
module.exports["isInProgressStreamResponse"] = $c3ad42ae8c5c5089$export$5c1c15675df13ae5;
module.exports["isStreamError"] = $c3ad42ae8c5c5089$export$d422a2733a3b5def;
module.exports["isStreamAUPError"] = $c3ad42ae8c5c5089$export$1e1cf807ece63df4;
module.exports["isStreamAnswerPart"] = $c3ad42ae8c5c5089$export$e45102edbc73b240;
module.exports["isStreamReasoningPart"] = $c3ad42ae8c5c5089$export$51a109436d382715;
module.exports["isStreamActionPart"] = $c3ad42ae8c5c5089$export$dbf4211c9117b9bc;
module.exports["isStreamActionClassification"] = $c3ad42ae8c5c5089$export$3d7b0b359441d5a6;
module.exports["isStreamActionPrepare"] = $c3ad42ae8c5c5089$export$584e11c2903f4ed6;
module.exports["isStreamActionComplete"] = $c3ad42ae8c5c5089$export$7d94ce53d589f586;
module.exports["isStreamResearchStart"] = $c3ad42ae8c5c5089$export$abec64f24e2ec3e7;
module.exports["isStreamResearchBeginningTrace"] = $c3ad42ae8c5c5089$export$9c1f93971e9e3fbe;
module.exports["isStreamResearchStepContent"] = $c3ad42ae8c5c5089$export$79a0ed7d987faa8f;
module.exports["isStreamResearchStepTitle"] = $c3ad42ae8c5c5089$export$7b1c8227569f1a92;
module.exports["isStreamResearchPlan"] = $c3ad42ae8c5c5089$export$cde91b49af35d559;
module.exports["isStreamTodoSnapshot"] = $c3ad42ae8c5c5089$export$4a6a601f69cf3c74;
module.exports["isStreamTaskStatus"] = $c3ad42ae8c5c5089$export$6b0058543411cb3a;
module.exports["isStreamResearchStepTitleShort"] = $c3ad42ae8c5c5089$export$ac74da022f74040a;
module.exports["isStreamSkillStart"] = $c3ad42ae8c5c5089$export$7898cc38956b9052;
module.exports["isStreamSkillEnd"] = $c3ad42ae8c5c5089$export$bb608d13a1268633;
module.exports["isStreamFastModeResponseAvailable"] = $c3ad42ae8c5c5089$export$b65c73c7e2d8d96f;
module.exports["isStreamFastModeEnabled"] = $c3ad42ae8c5c5089$export$40cf419186312161;
module.exports["isStreamRemoveAnswerNow"] = $c3ad42ae8c5c5089$export$a83708fc4401682d;
module.exports["isStreamResearchStepSource"] = $c3ad42ae8c5c5089$export$68192da24ac8c141;
module.exports["isStreamResearchStepCompleted"] = $c3ad42ae8c5c5089$export$cfccfd17b68ccb0;
module.exports["isStreamResearchStepIcons"] = $c3ad42ae8c5c5089$export$1fd230d6956c2575;
module.exports["isStreamResearchStepDocument"] = $c3ad42ae8c5c5089$export$3bc697eeff31bdf6;
module.exports["isStreamReconnectSupportPart"] = $c3ad42ae8c5c5089$export$c679ee34f7312895;
module.exports["isStreamAnswerGenerationType"] = $c3ad42ae8c5c5089$export$b00dd9d0560e29d2;
module.exports["isStreamDynamicLayoutSubAgent"] = $c3ad42ae8c5c5089$export$5fa02529cd2ab34c;
module.exports["isStreamResearchPayload"] = $c3ad42ae8c5c5089$export$46e0fb5e4b019a49;
module.exports["isStreamSkill"] = $c3ad42ae8c5c5089$export$6f74311d40862a9f;
module.exports["isStreamMemoryUpdate"] = $c3ad42ae8c5c5089$export$d95e474df0d530df;
module.exports["isStreamTrace"] = $c3ad42ae8c5c5089$export$fd5a05be03f147a0;
module.exports["isStreamThinkDeeperTriggered"] = $c3ad42ae8c5c5089$export$682514f3a8131b98;
module.exports["isFollowUpMessage"] = $c3ad42ae8c5c5089$export$aeae5b4fda357302;
module.exports["isStreamAgenticUi"] = $c3ad42ae8c5c5089$export$6275ff996073145e;
module.exports["isStreamHeartbeat"] = $c3ad42ae8c5c5089$export$b46beea5c82aa1b9;
module.exports["isActionExecutedSuccessfully"] = $c3ad42ae8c5c5089$export$b8391261162989d9;
module.exports["isActionResolutionCancelled"] = $c3ad42ae8c5c5089$export$1060c4fa97e34fa7;
module.exports["isChannelNotFoundError"] = $c3ad42ae8c5c5089$export$6ce1ccc24e75456f;
module.exports["isStreamActionError"] = $c3ad42ae8c5c5089$export$c3c933dad2745d3f;
module.exports["isRateLimitedError"] = $c3ad42ae8c5c5089$export$bc96a6a479480590;
module.exports["isHipaaError"] = $c3ad42ae8c5c5089$export$f8b1b75846492611;
module.exports["isAUPViolationError"] = $c3ad42ae8c5c5089$export$d263dc5d64f36d48;
module.exports["isConversationChannelDataMessage"] = $c3ad42ae8c5c5089$export$b454081350f4a578;
module.exports["isScopeDeterminedMessage"] = $c3ad42ae8c5c5089$export$145ab74998a54a20;
module.exports["isSpaceSourceRecommendationsMessage"] = $c3ad42ae8c5c5089$export$75ceabc5bb9500e4;
module.exports["isStreamPromptRedaction"] = $c3ad42ae8c5c5089$export$f4111656f23d9b9b;
module.exports["isStreamPromptBlock"] = $c3ad42ae8c5c5089$export$c43cf9ba6a2176ef;
module.exports["isStreamResponseRedaction"] = $c3ad42ae8c5c5089$export$f16ff8eb19967a97;
module.exports["isStreamResponseBlock"] = $c3ad42ae8c5c5089$export$55f7bd80eacbc51b;
module.exports["isStreamAttachmentBlock"] = $c3ad42ae8c5c5089$export$a1be74470d3c1fe9;
module.exports["isConfirmAction"] = $c3ad42ae8c5c5089$export$4af48296a8d61cec;

});

parcelRegister("fCunh", function(module, exports) {
const $885d54b804b288bc$export$e8114853eca81277 = 'ai-mate';
const $885d54b804b288bc$export$1106bf31edf2a9b8 = {
    AGENT_DOES_NOT_EXIST: 'errorAgentNotFound',
    USER_NOT_CREATOR: 'errorIncorrectOwner',
    AGENT_HAS_CONVERSATIONS: 'errorAgentInUse',
    AGENT_DEACTIVATED: 'convoai.rest.bad.request.archived.agent',
    AGENT_FORBIDDEN: 'convoai.rest.agent-forbidden',
    ROVO_PRODUCT_NOT_ACTIVE: 'convoai.rest.rovo.product.not.active',
    HAS_HIPAA_ENABLED: 'convoai.rest.browsing.product.has.hipaa.enabled',
    FILE_SIZE_TOO_LARGE: 'convoai.rest.bad.request.file.size.too.large'
};
const $885d54b804b288bc$export$333e4f57333eadfa = {
    UNSUPPORTED_FILE_TYPE: 415,
    FILE_RAI_POLICY_VIOLATION: 406
};
module.exports["ASSISTANCE_SERVICE_ERROR_CODES"] = $885d54b804b288bc$export$1106bf31edf2a9b8;
module.exports["STATUS_CODES"] = $885d54b804b288bc$export$333e4f57333eadfa;

});

parcelRegister("7zss8", function(module, exports) {
// Dupe of same function from conversation-assistant
// No need to add a whole dependency just for this function
const $b3b3d72d5c15ae5d$export$caa27b16709bc2df = (product)=>{
    if (window) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.__ROVO_CHAT_CONFIG_PRODUCT__ = product;
};
module.exports["setRovoChatProduct"] = $b3b3d72d5c15ae5d$export$caa27b16709bc2df;

});

parcelRegister("fDfQA", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $k046L = parcelRequire("k046L");

async function* $6c7eb7a39a02f1c4$export$1f24b2b263bcfa75(response) {
    const reader = (0, $k046L.getBufferReader)(response);
    let doneStreaming = false;
    let remainder = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) try {
            const processedChunks = `${remainder}${value}`.split('\n'); // assumes that all JSON chunks are separated by a new-line;
            remainder = '';
            for (let chunk of processedChunks)try {
                const json = chunk.startsWith('data: ') && (0, $ixfCV.fg)('rovo-guard-ui-redaction-and-blocking') ? chunk.slice(6) : chunk;
                yield JSON.parse(json);
            } catch (e) {
                // the chunk may be incomplete, so we'll save it for the next iteration.
                remainder = chunk;
            }
        } catch (e) {
            const error = new Error(`Error Processing Stream Data: ${value}`);
            throw error;
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else throw e;
    }
    while (!doneStreaming);
}
module.exports["readJsonStream"] = $6c7eb7a39a02f1c4$export$1f24b2b263bcfa75;

});

parcelRegister("k046L", function(module, exports) {
const $c70dfd75c754b14f$export$f6383c3ea1307da9 = (response)=>{
    if (!response.body) throw new Error('Response body is empty');
    return response.body.pipeThrough(new TextDecoderStream()).getReader();
};
module.exports["getBufferReader"] = $c70dfd75c754b14f$export$f6383c3ea1307da9;

});

parcelRegister("emCLk", function(module, exports) {

var $k046L = parcelRequire("k046L");

const $b3957af9ca78f17a$var$parseSSEMessage = (message)=>{
    const parsed = {};
    const dataLines = [];
    for (const line of message.split('\n')){
        const trimmedLine = line.trim();
        const colonIndex = trimmedLine.indexOf(':');
        if (trimmedLine && colonIndex !== -1) {
            const field = trimmedLine.substring(0, colonIndex);
            const value = trimmedLine.substring(colonIndex + 1).trimStart();
            switch(field){
                case 'event':
                    parsed.eventType = value;
                    break;
                case 'data':
                    dataLines.push(value);
                    break;
                case 'id':
                    parsed.id = value;
                    break;
                default:
                    break;
            }
        }
    }
    if (dataLines.length) parsed.data = dataLines.join('\n');
    return parsed;
};
async function* $b3957af9ca78f17a$export$6dab2f647580dc69(response) {
    const reader = (0, $k046L.getBufferReader)(response);
    let doneStreaming = false;
    let remainder = '';
    do try {
        const { value: value, done: done } = await reader.read();
        doneStreaming = done;
        if (value) {
            const combined = `${remainder}${value}`;
            const parts = combined.split('\n\n'); // SSE messages are separated by double newlines
            // the last part may be incomplete — keep it for the next read
            remainder = parts.pop() ?? '';
            for (const chunk of parts)try {
                const parsed = $b3957af9ca78f17a$var$parseSSEMessage(chunk);
                if (parsed.data) {
                    const parsedData = JSON.parse(parsed.data);
                    yield {
                        __isSSEWrapper: true,
                        data: parsedData,
                        id: parsed.id,
                        eventType: parsed.eventType
                    };
                }
            } catch  {
            // ignore malformed JSON; keep streaming future valid messages
            }
        }
        // If the stream just ended and we still have a remainder, try to parse it once.
        if (doneStreaming && remainder) try {
            const parsed = $b3957af9ca78f17a$var$parseSSEMessage(remainder);
            if (parsed.data) {
                const parsedData = JSON.parse(parsed.data);
                yield {
                    __isSSEWrapper: true,
                    data: parsedData,
                    id: parsed.id,
                    eventType: parsed.eventType
                };
            }
        } catch  {
        // ignore malformed tail
        } finally{
            remainder = '';
        }
    } catch (e) {
        // If we abort the call, this exception bubbles up, so we want to catch it and exit gracefully
        if (e instanceof DOMException && e.name === 'AbortError') doneStreaming = true;
        else throw e;
    }
    while (!doneStreaming);
}
module.exports["readSSEStream"] = $b3957af9ca78f17a$export$6dab2f647580dc69;

});

parcelRegister("5suST", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $ixfCV = parcelRequire("ixfCV");

const $751ca72a9993528e$export$3b20549d55cda4db = 'store-message-from-user-settings';
const $751ca72a9993528e$export$bd10ff38e53e4101 = 'actionable-follow-ups';
const $751ca72a9993528e$export$f447b2e2b8f0d61e = 'actionable-follow-ups-stacked';
/**
 * Maps each gated capability to the gate/experiment that enables it. Add new
 * capability/gate pairs here rather than introducing nested ternaries at the
 * call sites.
 */ const $751ca72a9993528e$var$GATED_CAPABILITIES = [
    {
        capability: $751ca72a9993528e$export$3b20549d55cda4db,
        isEnabled: ()=>(0, $ixfCV.fg)('ai_mate_store_messages_be_driven')
    }
];
/** Maps an experiment cohort to the capability header it opts the request into. */ const $751ca72a9993528e$var$ACTIONABLE_FOLLOW_UPS_CAPABILITY_BY_COHORT = {
    control: undefined,
    inline: $751ca72a9993528e$export$bd10ff38e53e4101,
    stacked: $751ca72a9993528e$export$f447b2e2b8f0d61e
};
/**
 * Resolves the actionable follow-ups experiment cohort and FIRES an exposure.
 *
 * Exposure is fired here — at the point we decide which capability header to send —
 * so that all cohorts (including `control`, which never receives a `◈` marker from
 * the backend) are exposed equally. Firing on client-side marker detection instead
 * would never expose the control cohort and would imbalance the experiment.
 */ const $751ca72a9993528e$var$resolveActionableFollowUpsCohort = ()=>(0, $cXtTj.default).getExperimentValue('rovo_chat_actionable_follow_ups_exp', 'cohort', 'control');
const $751ca72a9993528e$export$6656e8be041b8747 = (capabilities)=>{
    const enabledCapabilities = $751ca72a9993528e$var$GATED_CAPABILITIES.filter(({ isEnabled: isEnabled })=>isEnabled()).map(({ capability: capability })=>capability);
    const followUpsCapability = $751ca72a9993528e$var$ACTIONABLE_FOLLOW_UPS_CAPABILITY_BY_COHORT[$751ca72a9993528e$var$resolveActionableFollowUpsCohort()];
    if (followUpsCapability) enabledCapabilities.push(followUpsCapability);
    if (enabledCapabilities.length === 0) return capabilities;
    return Array.from(new Set([
        ...capabilities ?? [],
        ...enabledCapabilities
    ]));
};
module.exports["buildEffectiveCapabilities"] = $751ca72a9993528e$export$6656e8be041b8747;

});

parcelRegister("irsyK", function(module, exports) {

var $8A2GO = parcelRequire("8A2GO");


var $jTKfH = parcelRequire("jTKfH");

const $c641c5a09bfdfc34$export$4c25481b843feb0b = (baseUrl, path)=>{
    if (path === '') // return base url without trailing slash
    return baseUrl;
    const urlWithTrailingSlash = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    const pathWithoutLeadingSlash = !path.startsWith('/') ? path : path.substring(1, path.length);
    const url = [
        urlWithTrailingSlash,
        pathWithoutLeadingSlash
    ].join('');
    return url;
};
const $c641c5a09bfdfc34$var$removeTimestampFromErrorMessage = (errorBodyJson)=>{
    const { timestamp: _timestamp, ...rest } = errorBodyJson;
    return JSON.stringify(rest);
};
const $c641c5a09bfdfc34$var$processErrorResponse = async ({ response: response })=>{
    let errorCode;
    let outputErrorMessage;
    const responseText = await response.text();
    let rawErrorMessage;
    try {
        const errorBodyJson = JSON.parse(responseText);
        const { error_code: error_code, error_message: error_message, message_template: message_template, errors: errors, errorMessage: errorMessage, timestamp: timestamp } = errorBodyJson;
        rawErrorMessage = errorMessage ?? error_message;
        if (errors?.length) // Use a single error code for now
        errorCode = errors[0];
        else if (error_code) errorCode = error_code;
        else errorCode = message_template;
        if (!errorCode || !rawErrorMessage) outputErrorMessage = timestamp ? $c641c5a09bfdfc34$var$removeTimestampFromErrorMessage(errorBodyJson) : responseText;
        else outputErrorMessage = `${errorCode} - ${rawErrorMessage}`;
    } catch  {
        outputErrorMessage = responseText;
    }
    throw new (0, $8A2GO.ApiError)(`[Code ${response.status}] ${outputErrorMessage}`, {
        errorCode: errorCode,
        statusCode: response.status,
        rawErrorMessage: rawErrorMessage,
        traceId: (0, $jTKfH.getTraceIdFromResponse)(response)
    });
};
const $c641c5a09bfdfc34$export$21fcb6cfd5628534 = async ({ response: response })=>{
    if (!response.ok || response.status >= 400) await $c641c5a09bfdfc34$var$processErrorResponse({
        response: response
    });
    return response;
};
module.exports["addPath"] = $c641c5a09bfdfc34$export$4c25481b843feb0b;
module.exports["processResponse"] = $c641c5a09bfdfc34$export$21fcb6cfd5628534;

});

parcelRegister("7td41", function(module, exports) {
const $00fdf2622c1683af$export$11cc4786742ed7c2 = ()=>{
    const date = new Date();
    const formattedDate = date.toLocaleDateString(undefined, {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit'
    });
    const formattedTime = date.toLocaleTimeString(undefined, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
    const name = `${formattedDate} ${formattedTime}`;
    return name;
};
module.exports["generateConversationName"] = $00fdf2622c1683af$export$11cc4786742ed7c2;

});

parcelRegister("bkEBw", function(module, exports) {

var $bxkJA = parcelRequire("bxkJA");


var $3PJhM = parcelRequire("3PJhM");

const $ac118120c3114919$export$218c8c3169c024d2 = (streamResponse)=>streamResponse.message.message.id;
const $ac118120c3114919$var$addAnswerPartAssistantMessage = (response, answerPart)=>{
    const content = `${response.content}${answerPart.message.content}`;
    // Remove source indexes, e.g [^1^] from the content
    const cleanedContent = content.replace(/\[\^\d+\^\]/g, '');
    return {
        ...response,
        content: cleanedContent
    };
};
const $ac118120c3114919$var$addAnswerPartAgentResponse = (response, answerPart)=>({
        ...response,
        message: $ac118120c3114919$var$addAnswerPartAssistantMessage(response.message, answerPart)
    });
// ****************************************************************************
// Action streaming accumulation configuration
// ****************************************************************************
const $ac118120c3114919$var$toPathArr = (path)=>Array.isArray(path) ? path : path.split('.').filter(Boolean);
const $ac118120c3114919$var$getAtPath = (obj, path)=>{
    let cur = obj;
    for (const key of path){
        if (!(0, $3PJhM.isRecord)(cur)) return undefined;
        cur = cur[key];
    }
    return cur;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ac118120c3114919$var$setAtPath = (obj, path, value)=>{
    if (path.length === 0) return value;
    const [head, ...rest] = path;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const base = obj && typeof obj === 'object' ? obj : {};
    return {
        ...base,
        [head]: $ac118120c3114919$var$setAtPath(base[head], rest, value)
    };
};
// Defines which sub-field(s) of a message action's data should be accumulated by string appending.
// Keyed by action key. Values can be a dot path or an array path, or an array of multiple paths.
// E.g.:
// {
//   'create-document-action': 'content',
//   'update-document-action': ['content', 'meta.subtitle']
// }
let $ac118120c3114919$var$actionDataAccumulationConfig = {
    ['aifc-confluence-page-create']: 'adf'
};
const $ac118120c3114919$export$a1715e22f3105088 = (prev, next)=>{
    const key = next.key;
    const rulePaths = $ac118120c3114919$var$actionDataAccumulationConfig[key];
    const prevData = prev?.data;
    const newData = next?.data;
    if (rulePaths && typeof prevData === 'object' && prevData !== null && typeof newData === 'object' && newData !== null) {
        const paths = Array.isArray(rulePaths) ? rulePaths : [
            rulePaths
        ];
        let base = {
            ...newData
        };
        for (const p of paths){
            const pathArr = $ac118120c3114919$var$toPathArr(p);
            const prevVal = $ac118120c3114919$var$getAtPath(prevData, pathArr);
            const nextVal = $ac118120c3114919$var$getAtPath(newData, pathArr);
            const accumulated = String(prevVal ?? '') + String(nextVal ?? '');
            base = $ac118120c3114919$var$setAtPath(base, pathArr, accumulated);
        }
        return {
            ...prev,
            data: base,
            status: next.status
        };
    }
    // Default: replace only data from next, keep other fields from prev
    return {
        ...prev,
        data: next.data,
        status: next.status
    };
};
const $ac118120c3114919$export$6554ad578994a75f = (actions, actionPart, actionUpdaterOverride)=>{
    const { key: key } = actionPart.message;
    const existingActionIndex = actions.findIndex((action)=>action.key === key);
    if (existingActionIndex === -1) return [
        ...actions || [],
        actionPart.message
    ];
    const updatedActions = [
        ...actions
    ];
    const prevAction = updatedActions[existingActionIndex];
    const nextAction = actionPart.message;
    updatedActions[existingActionIndex] = actionUpdaterOverride ? actionUpdaterOverride(prevAction, nextAction) : $ac118120c3114919$export$a1715e22f3105088(prevAction, nextAction);
    return updatedActions;
};
const $ac118120c3114919$export$6e5609c05ab74cc7 = (response, answerPart)=>({
        ...response,
        message: $ac118120c3114919$var$addAnswerPartAgentResponse(response.message, answerPart)
    });
const $ac118120c3114919$export$13b6a4e4e3704011 = (response, actionPart, actionUpdaterOverride)=>{
    const { message: message } = response.message;
    const { actions: actions } = message;
    const isActionsArrayPresent = actions && actions.length > 0;
    return {
        ...response,
        message: {
            ...response.message,
            message: {
                ...message,
                actions: !isActionsArrayPresent ? [
                    actionPart.message
                ] : $ac118120c3114919$export$6554ad578994a75f(actions, actionPart, actionUpdaterOverride)
            }
        }
    };
};
const $ac118120c3114919$var$removeSensitiveDataAssistantMessage = (message)=>{
    const { plugin_invocations: plugin_invocations, ...rest } = message;
    return {
        ...rest,
        plugin_invocations: plugin_invocations.map((pluginInvocation)=>({
                ...pluginInvocation,
                plugin_output: '--PRIVATE--'
            }))
    };
};
const $ac118120c3114919$var$removeSensitiveDataAgentResponse = (message)=>({
        ...message,
        message: $ac118120c3114919$var$removeSensitiveDataAssistantMessage(message.message)
    });
const $ac118120c3114919$export$efd4f6b5d168b654 = (message)=>({
        ...message,
        message: $ac118120c3114919$var$removeSensitiveDataAgentResponse(message.message)
    });
const $ac118120c3114919$export$4c47ae95c311c518 = '00000000-0000-0000-0000-000000000000';
const $ac118120c3114919$export$4010f996e89e886a = (id, content, isFromSeededConversation, requestId, fileUploads)=>{
    return {
        role: 'HUMAN',
        id: id,
        content: content,
        time_created: new Date().toISOString(),
        user_ari: 'unknown',
        plugin_invocations: [],
        isFromSeededConversation: isFromSeededConversation,
        requestId: requestId,
        file_uploads: fileUploads
    };
};
const $ac118120c3114919$export$3220a4ff7b3a96df = (message)=>{
    if ((0, $bxkJA.isAgentResponse)(message)) return {
        type: 'FINAL_RESPONSE',
        message: message
    };
    return {
        type: 'FINAL_RESPONSE',
        message: {
            message: message
        }
    };
};
module.exports["getId"] = $ac118120c3114919$export$218c8c3169c024d2;
module.exports["addAnswerPart"] = $ac118120c3114919$export$6e5609c05ab74cc7;
module.exports["addActionPart"] = $ac118120c3114919$export$13b6a4e4e3704011;
module.exports["removeSensitiveData"] = $ac118120c3114919$export$efd4f6b5d168b654;
module.exports["NO_PARENT_MESSAGE_ID"] = $ac118120c3114919$export$4c47ae95c311c518;
module.exports["createHumanMessage"] = $ac118120c3114919$export$4010f996e89e886a;
module.exports["toStreamResponse"] = $ac118120c3114919$export$3220a4ff7b3a96df;

});

parcelRegister("ipz0N", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $kkFbH = parcelRequire("kkFbH");


var $88149 = parcelRequire("88149");

const $c358709489b4576e$var$FileIconWithColor = (0, $88149.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), 'grayBold');
$c358709489b4576e$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $c358709489b4576e$export$2e2bcd8739ae039 = $c358709489b4576e$var$FileIconWithColor;
module.exports["default"] = $c358709489b4576e$export$2e2bcd8739ae039;

});

parcelRegister("f49me", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gJ798 = parcelRequire("gJ798");


var $88149 = parcelRequire("88149");

const $3736b97729106be6$var$ChartBarIconWithColor = (0, $88149.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($gJ798))), 'purpleBold');
$3736b97729106be6$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $3736b97729106be6$export$2e2bcd8739ae039 = $3736b97729106be6$var$ChartBarIconWithColor;
module.exports["default"] = $3736b97729106be6$export$2e2bcd8739ae039;

});

parcelRegister("jBJvN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $3fO5l = parcelRequire("3fO5l");


var $88149 = parcelRequire("88149");

const $a7d4397f4d39d7f1$var$ListBulletedIconWithColor = (0, $88149.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), 'greenBold');
$a7d4397f4d39d7f1$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $a7d4397f4d39d7f1$export$2e2bcd8739ae039 = $a7d4397f4d39d7f1$var$ListBulletedIconWithColor;
module.exports["default"] = $a7d4397f4d39d7f1$export$2e2bcd8739ae039;

});

parcelRegister("adk2f", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $3cb2d8c9faefdb0f$var$iconStyles = null;
const $3cb2d8c9faefdb0f$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz _5fdi7vkz _zbji7vkz",
    medium: "_1bsb1tcg _4t3i1tcg _5fdi1tcg _zbji1tcg",
    large: "_1bsbzwfg _4t3izwfg _5fdizwfg _zbjizwfg",
    xlarge: "_1bsbckbl _4t3ickbl _5fdickbl _zbjickbl"
}; /**
    * For windows high contrast mode
    */ 
const $3cb2d8c9faefdb0f$var$baseHcmStyles = null;
const $3cb2d8c9faefdb0f$var$primaryEqualsSecondaryHcmStyles = null;
const $3cb2d8c9faefdb0f$var$secondaryTransparentHcmStyles = null; /**
                                             * __Icon__
                                             *
                                             * Replica of deprecated legacy icon/base
                                             *
                                             */ 
const $3cb2d8c9faefdb0f$export$f04a61298a47a40f = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Icon(props) {
    const $ = (0, $bDgLe.c)(24);
    const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: t0, secondaryColor: secondaryColor, size: size, testId: testId, label: label, width: width, height: height, UNSAFE_margin: UNSAFE_margin } = props;
    const primaryColor = t0 === undefined ? "currentColor" : t0;
    let t1;
    if ($[0] !== Glyph || $[1] !== dangerouslySetGlyph) {
        t1 = dangerouslySetGlyph ? {
            dangerouslySetInnerHTML: {
                __html: dangerouslySetGlyph
            }
        } : {
            children: Glyph ? /*#__PURE__*/ $cozmU.createElement(Glyph, {
                role: "presentation"
            }) : null
        };
        $[0] = Glyph;
        $[1] = dangerouslySetGlyph;
        $[2] = t1;
    } else t1 = $[2];
    const glyphProps = t1;
    let t2;
    if ($[3] !== height || $[4] !== width) {
        t2 = width && height ? {
            width: width + "px",
            height: height + "px"
        } : null;
        $[3] = height;
        $[4] = width;
        $[5] = t2;
    } else t2 = $[5];
    const customDimensions = t2;
    const t3 = `icon-${testId}`;
    const t4 = label ? "img" : undefined;
    const t5 = label ? label : undefined;
    const t6 = label ? undefined : true;
    let t7;
    if ($[6] !== UNSAFE_margin || $[7] !== customDimensions || $[8] !== primaryColor || $[9] !== secondaryColor) {
        t7 = {
            ...customDimensions,
            "--icon-primary-color": primaryColor,
            "--icon-secondary-color": secondaryColor,
            margin: UNSAFE_margin
        };
        $[6] = UNSAFE_margin;
        $[7] = customDimensions;
        $[8] = primaryColor;
        $[9] = secondaryColor;
        $[10] = t7;
    } else t7 = $[10];
    const t8 = t7;
    const t9 = primaryColor === secondaryColor && "_18hbwc43";
    const t10 = secondaryColor === "transparent" && "_4fyi1j28";
    const t11 = size && $3cb2d8c9faefdb0f$var$sizeStyles[size];
    let t12;
    if ($[11] !== t10 || $[12] !== t11 || $[13] !== t9) {
        t12 = (0, $hekY6.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            t9,
            t10,
            t11
        ]);
        $[11] = t10;
        $[12] = t11;
        $[13] = t9;
        $[14] = t12;
    } else t12 = $[14];
    let t13;
    if ($[15] !== glyphProps || $[16] !== t12 || $[17] !== t3 || $[18] !== t4 || $[19] !== t5 || $[20] !== t6 || $[21] !== t8 || $[22] !== testId) {
        t13 = /*#__PURE__*/ $cozmU.createElement("span", {
            "data-testid": testId,
            "data-vc": t3,
            role: t4,
            "aria-label": t5,
            "aria-hidden": t6,
            style: t8,
            ...glyphProps,
            className: t12
        });
        $[15] = glyphProps;
        $[16] = t12;
        $[17] = t3;
        $[18] = t4;
        $[19] = t5;
        $[20] = t6;
        $[21] = t8;
        $[22] = testId;
        $[23] = t13;
    } else t13 = $[23];
    return t13;
} : function Icon(props) {
    const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, size: size, testId: testId, label: label, width: width, height: height, UNSAFE_margin: UNSAFE_margin } = props;
    const glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ $cozmU.createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    const customDimensions = width && height ? {
        width: width + 'px',
        height: height + 'px'
    } : null;
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": testId,
        "data-vc": `icon-${testId}`,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...customDimensions,
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            margin: UNSAFE_margin
        },
        ...glyphProps,
        className: (0, $hekY6.default)([
            "_1e0c1o8l _1o9zidpf _vyfuvuon _vwz4kb7n _1szv15vq _1tly15vq _rzyw1osq _17jb1osq _1ksvoz0e _3se1x1jp _re2rglyw _1veoyfq0 _1kg81r31",
            "_jcxd1r8n _gq0g1onz _1trkwc43",
            primaryColor === secondaryColor && "_18hbwc43",
            secondaryColor === 'transparent' && "_4fyi1j28",
            size && $3cb2d8c9faefdb0f$var$sizeStyles[size]
        ])
    });
});
var $3cb2d8c9faefdb0f$export$2e2bcd8739ae039 = $3cb2d8c9faefdb0f$export$f04a61298a47a40f;
module.exports["Icon"] = $3cb2d8c9faefdb0f$export$f04a61298a47a40f;

});

parcelRegister("iMQz5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gIfnJ = parcelRequire("gIfnJ");


var $4hmAW = parcelRequire("4hmAW");

const $6e22e7dea691eafe$var$BranchObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BranchObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Branch" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function BranchObject({ label: label = 'Branch', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $6e22e7dea691eafe$export$2e2bcd8739ae039 = $6e22e7dea691eafe$var$BranchObject;
module.exports["default"] = $6e22e7dea691eafe$export$2e2bcd8739ae039;

});

parcelRegister("f7FiQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gIfnJ = parcelRequire("gIfnJ");


var $gEyoZ = parcelRequire("gEyoZ");

const $b8829d8a161753f9$var$BranchObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BranchObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Branch" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BranchObjectTile({ label: label = 'Branch', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $b8829d8a161753f9$export$2e2bcd8739ae039 = $b8829d8a161753f9$var$BranchObjectTile;
module.exports["default"] = $b8829d8a161753f9$export$2e2bcd8739ae039;

});

parcelRegister("gEyoZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bB0i2 = parcelRequire("bB0i2");


var $9NPFC = parcelRequire("9NPFC");

/**
 * __Object tile base__
 *
 * An object tile represents an Atlassian-specific content type.
 *
 */ const $e64fa8a7fc69b505$var$ObjectTileBase = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ObjectTileBase(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { label: t1, size: t2, testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const validSizes = [
        "xsmall",
        "small",
        "medium",
        "large",
        "xlarge"
    ];
    (0, $bB0i2.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(", ")}`);
    let t3;
    if ($[0] !== Icon || $[1] !== color || $[2] !== label || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: label,
            color: color,
            testId: testId,
            shouldScale: true
        });
        $[0] = Icon;
        $[1] = color;
        $[2] = label;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== backgroundColor || $[6] !== size || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
            label: "",
            backgroundColor: backgroundColor,
            size: size
        }, t3);
        $[5] = backgroundColor;
        $[6] = size;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : function ObjectTileBase({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $bB0i2.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        label: label,
        color: color,
        testId: testId,
        // @ts-expect-error - Internal, undocumented prop
        shouldScale: true
    }));
};
var $e64fa8a7fc69b505$export$2e2bcd8739ae039 = $e64fa8a7fc69b505$var$ObjectTileBase;
module.exports["default"] = $e64fa8a7fc69b505$export$2e2bcd8739ae039;

});

parcelRegister("39Mwn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lepke = parcelRequire("lepke");


var $4hmAW = parcelRequire("4hmAW");

const $29a7acb65f94e0ba$var$CommitObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CommitObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Commit" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
            color: "var(--ds-icon-accent-yellow, #B38600)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function CommitObject({ label: label = 'Commit', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
};
var $29a7acb65f94e0ba$export$2e2bcd8739ae039 = $29a7acb65f94e0ba$var$CommitObject;
module.exports["default"] = $29a7acb65f94e0ba$export$2e2bcd8739ae039;

});

parcelRegister("6gVpf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lepke = parcelRequire("lepke");


var $gEyoZ = parcelRequire("gEyoZ");

const $90d14fc97efa5c87$var$CommitObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CommitObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Commit" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)";
    const t3 = isBold ? "color.background.accent.yellow.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function CommitObjectTile({ label: label = 'Commit', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)",
        backgroundColor: isBold ? 'color.background.accent.yellow.subtle' : undefined
    });
};
var $90d14fc97efa5c87$export$2e2bcd8739ae039 = $90d14fc97efa5c87$var$CommitObjectTile;
module.exports["default"] = $90d14fc97efa5c87$export$2e2bcd8739ae039;

});

parcelRegister("gITbz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hQhpy = parcelRequire("hQhpy");


var $4hmAW = parcelRequire("4hmAW");

const $d9b76c60fcca1e74$var$PullRequestObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PullRequestObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Pull Request" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
            color: "var(--ds-icon-accent-green, #22A06B)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PullRequestObject({ label: label = 'Pull Request', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
};
var $d9b76c60fcca1e74$export$2e2bcd8739ae039 = $d9b76c60fcca1e74$var$PullRequestObject;
module.exports["default"] = $d9b76c60fcca1e74$export$2e2bcd8739ae039;

});

parcelRegister("lvsY2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hQhpy = parcelRequire("hQhpy");


var $gEyoZ = parcelRequire("gEyoZ");

const $c843d2b7ba70d597$var$PullRequestObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PullRequestObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Pull Request" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)";
    const t3 = isBold ? "color.background.accent.green.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function PullRequestObjectTile({ label: label = 'Pull Request', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)",
        backgroundColor: isBold ? 'color.background.accent.green.subtle' : undefined
    });
};
var $c843d2b7ba70d597$export$2e2bcd8739ae039 = $c843d2b7ba70d597$var$PullRequestObjectTile;
module.exports["default"] = $c843d2b7ba70d597$export$2e2bcd8739ae039;

});

parcelRegister("3CYX0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6YkHb = parcelRequire("6YkHb");


var $4hmAW = parcelRequire("4hmAW");

const $ff9912959f94fce6$var$CodeObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CodeObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Code" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
            color: "var(--ds-icon-accent-purple, #AF59E1)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function CodeObject({ label: label = 'Code', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
};
var $ff9912959f94fce6$export$2e2bcd8739ae039 = $ff9912959f94fce6$var$CodeObject;
module.exports["default"] = $ff9912959f94fce6$export$2e2bcd8739ae039;

});

parcelRegister("2z1Cx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6YkHb = parcelRequire("6YkHb");


var $gEyoZ = parcelRequire("gEyoZ");

const $3fba6eb33cac86c2$var$CodeObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CodeObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Code" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)";
    const t3 = isBold ? "color.background.accent.purple.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function CodeObjectTile({ label: label = 'Code', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)",
        backgroundColor: isBold ? 'color.background.accent.purple.subtle' : undefined
    });
};
var $3fba6eb33cac86c2$export$2e2bcd8739ae039 = $3fba6eb33cac86c2$var$CodeObjectTile;
module.exports["default"] = $3fba6eb33cac86c2$export$2e2bcd8739ae039;

});

parcelRegister("fHe6f", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6spAz = parcelRequire("6spAz");


var $4hmAW = parcelRequire("4hmAW");

const $344e992330cc90e5$var$BugObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BugObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Bug" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function BugObject({ label: label = 'Bug', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $344e992330cc90e5$export$2e2bcd8739ae039 = $344e992330cc90e5$var$BugObject;
module.exports["default"] = $344e992330cc90e5$export$2e2bcd8739ae039;

});

parcelRegister("ix7Nw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6spAz = parcelRequire("6spAz");


var $gEyoZ = parcelRequire("gEyoZ");

const $e3c6782640cca582$var$BugObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BugObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Bug" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BugObjectTile({ label: label = 'Bug', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $e3c6782640cca582$export$2e2bcd8739ae039 = $e3c6782640cca582$var$BugObjectTile;
module.exports["default"] = $e3c6782640cca582$export$2e2bcd8739ae039;

});

parcelRegister("ahlZa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lCTy3 = parcelRequire("lCTy3");


var $4hmAW = parcelRequire("4hmAW");

const $4e5aedb3fb5b2488$var$ChangesObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ChangesObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Changes" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
            color: "var(--ds-icon-accent-yellow, #B38600)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function ChangesObject({ label: label = 'Changes', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
};
var $4e5aedb3fb5b2488$export$2e2bcd8739ae039 = $4e5aedb3fb5b2488$var$ChangesObject;
module.exports["default"] = $4e5aedb3fb5b2488$export$2e2bcd8739ae039;

});

parcelRegister("lfmf4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lCTy3 = parcelRequire("lCTy3");


var $gEyoZ = parcelRequire("gEyoZ");

const $d8f6dc54ca6872bb$var$ChangesObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ChangesObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Changes" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)";
    const t3 = isBold ? "color.background.accent.yellow.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function ChangesObjectTile({ label: label = 'Changes', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)",
        backgroundColor: isBold ? 'color.background.accent.yellow.subtle' : undefined
    });
};
var $d8f6dc54ca6872bb$export$2e2bcd8739ae039 = $d8f6dc54ca6872bb$var$ChangesObjectTile;
module.exports["default"] = $d8f6dc54ca6872bb$export$2e2bcd8739ae039;

});

parcelRegister("6MsAF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7vAVv = parcelRequire("7vAVv");


var $4hmAW = parcelRequire("4hmAW");

const $caa0390e0439cdc5$var$EpicObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function EpicObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Epic" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
            color: "var(--ds-icon-accent-purple, #AF59E1)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function EpicObject({ label: label = 'Epic', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
};
var $caa0390e0439cdc5$export$2e2bcd8739ae039 = $caa0390e0439cdc5$var$EpicObject;
module.exports["default"] = $caa0390e0439cdc5$export$2e2bcd8739ae039;

});

parcelRegister("bht3M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7vAVv = parcelRequire("7vAVv");


var $gEyoZ = parcelRequire("gEyoZ");

const $ff1c12598ed3ba74$var$EpicObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function EpicObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Epic" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)";
    const t3 = isBold ? "color.background.accent.purple.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function EpicObjectTile({ label: label = 'Epic', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)",
        backgroundColor: isBold ? 'color.background.accent.purple.subtle' : undefined
    });
};
var $ff1c12598ed3ba74$export$2e2bcd8739ae039 = $ff1c12598ed3ba74$var$EpicObjectTile;
module.exports["default"] = $ff1c12598ed3ba74$export$2e2bcd8739ae039;

});

parcelRegister("38zdI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ipvL3 = parcelRequire("ipvL3");


var $4hmAW = parcelRequire("4hmAW");

const $021e642953ecdf56$var$IncidentObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IncidentObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Incident" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function IncidentObject({ label: label = 'Incident', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $021e642953ecdf56$export$2e2bcd8739ae039 = $021e642953ecdf56$var$IncidentObject;
module.exports["default"] = $021e642953ecdf56$export$2e2bcd8739ae039;

});

parcelRegister("tBrWH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ipvL3 = parcelRequire("ipvL3");


var $gEyoZ = parcelRequire("gEyoZ");

const $d409ccda82578191$var$IncidentObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IncidentObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Incident" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function IncidentObjectTile({ label: label = 'Incident', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $d409ccda82578191$export$2e2bcd8739ae039 = $d409ccda82578191$var$IncidentObjectTile;
module.exports["default"] = $d409ccda82578191$export$2e2bcd8739ae039;

});

parcelRegister("cVpj0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7EFpK = parcelRequire("7EFpK");


var $4hmAW = parcelRequire("4hmAW");

const $c45be7d7373a5bd1$var$ProblemObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ProblemObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Problem" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function ProblemObject({ label: label = 'Problem', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $c45be7d7373a5bd1$export$2e2bcd8739ae039 = $c45be7d7373a5bd1$var$ProblemObject;
module.exports["default"] = $c45be7d7373a5bd1$export$2e2bcd8739ae039;

});

parcelRegister("e9ExL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7EFpK = parcelRequire("7EFpK");


var $gEyoZ = parcelRequire("gEyoZ");

const $70d7bc77e47e0fe4$var$ProblemObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ProblemObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Problem" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function ProblemObjectTile({ label: label = 'Problem', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $70d7bc77e47e0fe4$export$2e2bcd8739ae039 = $70d7bc77e47e0fe4$var$ProblemObjectTile;
module.exports["default"] = $70d7bc77e47e0fe4$export$2e2bcd8739ae039;

});

parcelRegister("S7fVP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iRFKG = parcelRequire("iRFKG");


var $4hmAW = parcelRequire("4hmAW");

const $ae65607ca2739f04$var$WorkItemObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WorkItemObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Work Item" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function WorkItemObject({ label: label = 'Work Item', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $ae65607ca2739f04$export$2e2bcd8739ae039 = $ae65607ca2739f04$var$WorkItemObject;
module.exports["default"] = $ae65607ca2739f04$export$2e2bcd8739ae039;

});

parcelRegister("2hwbE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iRFKG = parcelRequire("iRFKG");


var $gEyoZ = parcelRequire("gEyoZ");

const $0c8c4b462cd0e972$var$WorkItemObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WorkItemObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Work Item" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function WorkItemObjectTile({ label: label = 'Work Item', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $0c8c4b462cd0e972$export$2e2bcd8739ae039 = $0c8c4b462cd0e972$var$WorkItemObjectTile;
module.exports["default"] = $0c8c4b462cd0e972$export$2e2bcd8739ae039;

});

parcelRegister("bvjEB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jrU5N = parcelRequire("jrU5N");


var $4hmAW = parcelRequire("4hmAW");

const $1e23ddd70a37a65a$var$StoryObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function StoryObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Story" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
            color: "var(--ds-icon-accent-green, #22A06B)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function StoryObject({ label: label = 'Story', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
};
var $1e23ddd70a37a65a$export$2e2bcd8739ae039 = $1e23ddd70a37a65a$var$StoryObject;
module.exports["default"] = $1e23ddd70a37a65a$export$2e2bcd8739ae039;

});

parcelRegister("bnm2b", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jrU5N = parcelRequire("jrU5N");


var $gEyoZ = parcelRequire("gEyoZ");

const $54244c8cd22493dc$var$StoryObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function StoryObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Story" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)";
    const t3 = isBold ? "color.background.accent.green.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function StoryObjectTile({ label: label = 'Story', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)",
        backgroundColor: isBold ? 'color.background.accent.green.subtle' : undefined
    });
};
var $54244c8cd22493dc$export$2e2bcd8739ae039 = $54244c8cd22493dc$var$StoryObjectTile;
module.exports["default"] = $54244c8cd22493dc$export$2e2bcd8739ae039;

});

parcelRegister("jMFOf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lSw2p = parcelRequire("lSw2p");


var $4hmAW = parcelRequire("4hmAW");

const $08adce465a629da4$var$SubtaskObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SubtaskObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Subtask" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function SubtaskObject({ label: label = 'Subtask', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $08adce465a629da4$export$2e2bcd8739ae039 = $08adce465a629da4$var$SubtaskObject;
module.exports["default"] = $08adce465a629da4$export$2e2bcd8739ae039;

});

parcelRegister("h3uhG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lSw2p = parcelRequire("lSw2p");


var $gEyoZ = parcelRequire("gEyoZ");

const $35e12172f066a32d$var$SubtaskObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SubtaskObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Subtask" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function SubtaskObjectTile({ label: label = 'Subtask', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $35e12172f066a32d$export$2e2bcd8739ae039 = $35e12172f066a32d$var$SubtaskObjectTile;
module.exports["default"] = $35e12172f066a32d$export$2e2bcd8739ae039;

});

parcelRegister("a5G9M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iAaYd = parcelRequire("iAaYd");


var $4hmAW = parcelRequire("4hmAW");

const $dcf12dc0efc2d892$var$TaskObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TaskObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Task" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function TaskObject({ label: label = 'Task', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $dcf12dc0efc2d892$export$2e2bcd8739ae039 = $dcf12dc0efc2d892$var$TaskObject;
module.exports["default"] = $dcf12dc0efc2d892$export$2e2bcd8739ae039;

});

parcelRegister("glDuG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iAaYd = parcelRequire("iAaYd");


var $gEyoZ = parcelRequire("gEyoZ");

const $41a316049a2a2c13$var$TaskObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TaskObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Task" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function TaskObjectTile({ label: label = 'Task', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $41a316049a2a2c13$export$2e2bcd8739ae039 = $41a316049a2a2c13$var$TaskObjectTile;
module.exports["default"] = $41a316049a2a2c13$export$2e2bcd8739ae039;

});

parcelRegister("rECdA", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $8m50u = parcelRequire("8m50u");

const $71deccf66348f07d$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $8m50u.componentWithCondition)(()=>(0, $ixfCV.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $71deccf66348f07d$export$cf56d0f54cfcce4;

});

parcelRegister("ai0Ge", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $d4GYd = parcelRequire("d4GYd");


var $gEyoZ = parcelRequire("gEyoZ");

const $36820b590bf4d8fd$var$BlogObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BlogObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Blog" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BlogObjectTile({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $36820b590bf4d8fd$export$2e2bcd8739ae039 = $36820b590bf4d8fd$var$BlogObjectTile;
module.exports["default"] = $36820b590bf4d8fd$export$2e2bcd8739ae039;

});

parcelRegister("7pJjg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kLlYX = parcelRequire("kLlYX");


var $4hmAW = parcelRequire("4hmAW");

const $5d24b7fd99811061$var$PageLiveDocObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageLiveDocObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Page Live Doc" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
            color: "var(--ds-icon-accent-magenta, #CD519D)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PageLiveDocObject({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
};
var $5d24b7fd99811061$export$2e2bcd8739ae039 = $5d24b7fd99811061$var$PageLiveDocObject;
module.exports["default"] = $5d24b7fd99811061$export$2e2bcd8739ae039;

});

parcelRegister("dipyx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kLlYX = parcelRequire("kLlYX");


var $gEyoZ = parcelRequire("gEyoZ");

const $5d01faeb97b0ed22$var$PageLiveDocObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageLiveDocObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Page Live Doc" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)";
    const t3 = isBold ? "color.background.accent.magenta.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function PageLiveDocObjectTile({ label: label = 'Page Live Doc', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)",
        backgroundColor: isBold ? 'color.background.accent.magenta.subtle' : undefined
    });
};
var $5d01faeb97b0ed22$export$2e2bcd8739ae039 = $5d01faeb97b0ed22$var$PageLiveDocObjectTile;
module.exports["default"] = $5d01faeb97b0ed22$export$2e2bcd8739ae039;

});

parcelRegister("lkYE1", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $1eVGO = parcelRequire("1eVGO");

//      
var $f88a81f3886ec3a5$var$charCodeOfDot = ".".charCodeAt(0);
var $f88a81f3886ec3a5$var$reEscapeChar = /\\(\\)?/g;
var $f88a81f3886ec3a5$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f88a81f3886ec3a5$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $f88a81f3886ec3a5$var$charCodeOfDot) result.push("");
    string.replace($f88a81f3886ec3a5$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($f88a81f3886ec3a5$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $f88a81f3886ec3a5$var$keysCache = {};
var $f88a81f3886ec3a5$var$keysRegex = /[.[\]]+/;
var $f88a81f3886ec3a5$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($f88a81f3886ec3a5$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $f88a81f3886ec3a5$var$keysCache[key] = key.split($f88a81f3886ec3a5$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $f88a81f3886ec3a5$var$keysCache[key] = $f88a81f3886ec3a5$var$stringToPath(key);
    }
    return $f88a81f3886ec3a5$var$keysCache[key];
};
//      
var $f88a81f3886ec3a5$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $f88a81f3886ec3a5$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $f88a81f3886ec3a5$var$_toPropertyKey(arg) {
    var key = $f88a81f3886ec3a5$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f88a81f3886ec3a5$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f88a81f3886ec3a5$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $1eVGO.default)(current, [
                key
            ].map($f88a81f3886ec3a5$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $eb3ax.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $f88a81f3886ec3a5$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $f88a81f3886ec3a5$var$setInRecursor(state, 0, $f88a81f3886ec3a5$var$toPath(key), value1, destroyArrays);
};
var $f88a81f3886ec3a5$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $f88a81f3886ec3a5$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $f88a81f3886ec3a5$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $f88a81f3886ec3a5$export$c52e5867d5879e24(values, name);
    var error = $f88a81f3886ec3a5$export$c52e5867d5879e24(errors, name);
    if (error && error[$f88a81f3886ec3a5$export$735bebc8ffabf28a]) error = error[$f88a81f3886ec3a5$export$735bebc8ffabf28a];
    var submitError = submitErrors && $f88a81f3886ec3a5$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $f88a81f3886ec3a5$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f88a81f3886ec3a5$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $f88a81f3886ec3a5$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $f88a81f3886ec3a5$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $f88a81f3886ec3a5$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f88a81f3886ec3a5$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $f88a81f3886ec3a5$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $f88a81f3886ec3a5$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $f88a81f3886ec3a5$var$subscriptionFilter(result, state, previousState, subscription, $f88a81f3886ec3a5$export$41e855cb628c1b55, $f88a81f3886ec3a5$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $f88a81f3886ec3a5$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $f88a81f3886ec3a5$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $f88a81f3886ec3a5$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $f88a81f3886ec3a5$var$subscriptionFilter(result, state, previousState, subscription, $f88a81f3886ec3a5$export$f1ff97b9d1c7a3c3, $f88a81f3886ec3a5$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $f88a81f3886ec3a5$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$f88a81f3886ec3a5$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $f88a81f3886ec3a5$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $f88a81f3886ec3a5$export$83d89fbfd8236492 = "4.20.10";
var $f88a81f3886ec3a5$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $f88a81f3886ec3a5$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $f88a81f3886ec3a5$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $f88a81f3886ec3a5$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $f88a81f3886ec3a5$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $f88a81f3886ec3a5$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $f88a81f3886ec3a5$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $f88a81f3886ec3a5$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($f88a81f3886ec3a5$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $f88a81f3886ec3a5$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $eb3ax.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $eb3ax.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $eb3ax.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $eb3ax.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $eb3ax.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $f88a81f3886ec3a5$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $f88a81f3886ec3a5$export$e6bdf135a54e021b,
                    shallowEqual: $f88a81f3886ec3a5$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $eb3ax.default)({}, state.formState.values)); // clone to avoid writing
            if ($f88a81f3886ec3a5$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f88a81f3886ec3a5$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $f88a81f3886ec3a5$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $eb3ax.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $eb3ax.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $f88a81f3886ec3a5$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $f88a81f3886ec3a5$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $f88a81f3886ec3a5$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$f88a81f3886ec3a5$export$735bebc8ffabf28a]) {
                    var existing = $f88a81f3886ec3a5$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$f88a81f3886ec3a5$export$735bebc8ffabf28a] = error[$f88a81f3886ec3a5$export$735bebc8ffabf28a];
                    merged = $f88a81f3886ec3a5$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$f88a81f3886ec3a5$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$f88a81f3886ec3a5$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $eb3ax.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $f88a81f3886ec3a5$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $f88a81f3886ec3a5$var$notify(fieldSubscriber, fieldState, lastFieldState, $f88a81f3886ec3a5$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $f88a81f3886ec3a5$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $eb3ax.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($f88a81f3886ec3a5$export$c52e5867d5879e24(formState.values, key), $f88a81f3886ec3a5$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($f88a81f3886ec3a5$export$c52e5867d5879e24(formState.values, key), $f88a81f3886ec3a5$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$f88a81f3886ec3a5$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f88a81f3886ec3a5$var$hasAnyError(formState.submitErrors));
        var nextFormState = $f88a81f3886ec3a5$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $f88a81f3886ec3a5$var$notify(state.subscribers, nextFormState, lastFormState, $f88a81f3886ec3a5$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $eb3ax.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($f88a81f3886ec3a5$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $eb3ax.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $eb3ax.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($f88a81f3886ec3a5$export$c52e5867d5879e24(formState.values, key), $f88a81f3886ec3a5$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $f88a81f3886ec3a5$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $f88a81f3886ec3a5$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $f88a81f3886ec3a5$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.values, name) === $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $eb3ax.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $eb3ax.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $eb3ax.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $f88a81f3886ec3a5$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$f88a81f3886ec3a5$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $eb3ax.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $f88a81f3886ec3a5$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $f88a81f3886ec3a5$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $f88a81f3886ec3a5$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f88a81f3886ec3a5$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}
module.exports["getIn"] = $f88a81f3886ec3a5$export$c52e5867d5879e24;
module.exports["FORM_ERROR"] = $f88a81f3886ec3a5$export$97cd7fc25dd32915;
module.exports["fieldSubscriptionItems"] = $f88a81f3886ec3a5$export$41e855cb628c1b55;
module.exports["formSubscriptionItems"] = $f88a81f3886ec3a5$export$f1ff97b9d1c7a3c3;
module.exports["version"] = $f88a81f3886ec3a5$export$83d89fbfd8236492;
module.exports["createForm"] = $f88a81f3886ec3a5$export$f681a8129d2e9d28;

});

parcelRegister("19ZlF", function(module, exports) {

var $lkYE1 = parcelRequire("lkYE1");

//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $0d863840e9077425$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $0d863840e9077425$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($0d863840e9077425$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $0d863840e9077425$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $lkYE1.getIn)(errors, input.name);
    });
};
//      
var $0d863840e9077425$var$noop = function noop() {};
var $0d863840e9077425$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $0d863840e9077425$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $0d863840e9077425$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $0d863840e9077425$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $0d863840e9077425$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($0d863840e9077425$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$0d863840e9077425$export$2e2bcd8739ae039 = $0d863840e9077425$var$createDecorator;
module.exports["default"] = $0d863840e9077425$export$2e2bcd8739ae039;

});

parcelRegister("lSFbL", function(module, exports) {

var $2itBe = parcelRequire("2itBe");

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $fede975c1f302c4c$var$set(object, path, value) {
    return object == null ? object : $2itBe(object, path, value);
}
module.exports = $fede975c1f302c4c$var$set;

});

parcelRegister("4Qc44", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5936b606760a760$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $e5936b606760a760$export$2e2bcd8739ae039 = (0, $cozmU.forwardRef);

});

parcelRegister("fLtAn", function(module, exports) {

var $6YrB3 = parcelRequire("6YrB3");


var $j39Hd = parcelRequire("j39Hd");

const $aff19b92c38e9221$var$SMART_CARD_STORAGE_SCOPE = 'smart-card-social-proof';
const $aff19b92c38e9221$export$f44b87513fae83d9 = 'site-cloud-id:v1:';
const $aff19b92c38e9221$export$a99d139543208cca = 86400000;
const $aff19b92c38e9221$var$smartCardStorage = new (0, $6YrB3.default)($aff19b92c38e9221$var$SMART_CARD_STORAGE_SCOPE);
function $aff19b92c38e9221$var$normalizeBaseUri(baseUriWithNoTrailingSlash = '') {
    return baseUriWithNoTrailingSlash.replace(/\/$/, '');
}
function $aff19b92c38e9221$var$cloudIdStorageItemKey(baseUriWithNoTrailingSlash = '') {
    return `${$aff19b92c38e9221$export$f44b87513fae83d9}${encodeURIComponent($aff19b92c38e9221$var$normalizeBaseUri(baseUriWithNoTrailingSlash))}`;
}
const $aff19b92c38e9221$export$dea1a8bc5840f118 = (baseUriWithNoTrailingSlash = '')=>`${$aff19b92c38e9221$var$SMART_CARD_STORAGE_SCOPE}_${$aff19b92c38e9221$var$cloudIdStorageItemKey(baseUriWithNoTrailingSlash)}`;
const $aff19b92c38e9221$export$b4b75b5ce5d33ae5 = $aff19b92c38e9221$export$dea1a8bc5840f118();
class $aff19b92c38e9221$export$a15da722a3b05509 {
    readStoredCloudId(baseUriWithNoTrailingSlash = '') {
        try {
            const cloudId = $aff19b92c38e9221$var$smartCardStorage.getItem($aff19b92c38e9221$var$cloudIdStorageItemKey(baseUriWithNoTrailingSlash));
            if (typeof cloudId !== 'string' || !cloudId || cloudId === 'undefined') return undefined;
            return cloudId;
        } catch  {
            return undefined;
        }
    }
    writeStoredCloudId(baseUriWithNoTrailingSlash, cloudId) {
        if (!cloudId) return;
        try {
            $aff19b92c38e9221$var$smartCardStorage.setItemWithExpiry($aff19b92c38e9221$var$cloudIdStorageItemKey(baseUriWithNoTrailingSlash), cloudId, $aff19b92c38e9221$export$a99d139543208cca);
        } catch  {
        // Quota, private-mode, SSR, etc. — same intent as personalization-service.
        }
    }
    ensureTenantInfoInflightStarted(baseUriWithNoTrailingSlash) {
        const baseUri = $aff19b92c38e9221$var$normalizeBaseUri(baseUriWithNoTrailingSlash);
        const existing = this.tenantInfoInflightPromises.get(baseUri);
        if (existing) return existing;
        const promise = (async ()=>{
            try {
                const response = await (0, $j39Hd.request)('get', `${baseUri}/_edge/tenant_info`);
                const cloudId = response?.cloudId;
                if (cloudId) this.writeStoredCloudId(baseUri, cloudId);
                return cloudId ? cloudId : this.readStoredCloudId(baseUri);
            } catch  {
                return this.readStoredCloudId(baseUri);
            } finally{
                this.tenantInfoInflightPromises.delete(baseUri);
            }
        })();
        this.tenantInfoInflightPromises.set(baseUri, promise);
        return promise;
    }
    /** Pure synchronous read scoped to the given base URI. */ getStoredCloudId(baseUriWithNoTrailingSlash = '') {
        return this.readStoredCloudId(baseUriWithNoTrailingSlash);
    }
    /** Writes tenant cloud id for tests or callers that intentionally warm storage before edge resolves. */ persistStoredCloudId(cloudId, baseUriWithNoTrailingSlash = '') {
        this.writeStoredCloudId(baseUriWithNoTrailingSlash, cloudId);
    }
    async get(baseUriWithNoTrailingSlash = '') {
        const fromStorage = this.readStoredCloudId(baseUriWithNoTrailingSlash);
        if (fromStorage) return fromStorage;
        return this.ensureTenantInfoInflightStarted(baseUriWithNoTrailingSlash);
    }
    /** Clears session pin and persisted storage so the next {@link get} is a fresh tenant_info fetch. */ clearCache() {
        this.tenantInfoInflightPromises.clear();
    }
    constructor(){
        this.tenantInfoInflightPromises = new Map();
    }
}
const $aff19b92c38e9221$export$1956112846aa829e = new $aff19b92c38e9221$export$a15da722a3b05509();
function $aff19b92c38e9221$export$763646cf0dfa675c(baseUriWithNoTrailingSlash = '') {
    return $aff19b92c38e9221$export$1956112846aa829e.getStoredCloudId(baseUriWithNoTrailingSlash);
}
const $aff19b92c38e9221$export$143af22820ae9de = (baseUriWithNoTrailingSlash = '')=>$aff19b92c38e9221$export$1956112846aa829e.get(baseUriWithNoTrailingSlash);
module.exports["getCurrentSiteCloudIdSync"] = $aff19b92c38e9221$export$763646cf0dfa675c;
module.exports["getCurrentSiteCloudId"] = $aff19b92c38e9221$export$143af22820ae9de;

});

parcelRegister("dz9dk", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $b4SfK = parcelRequire("b4SfK");


var $cMyWi = parcelRequire("cMyWi");


var $1G3WB = parcelRequire("1G3WB");

const $decb67059ffe42ce$var$SMART_LINKS_XPC_BRIDGE = 'smartLinks';
const $decb67059ffe42ce$var$XPC_QUERY_PARAM = 'xpis';
const $decb67059ffe42ce$export$189e6ab4f1c74893 = (details)=>(details?.meta?.is1PLink ?? false) === true;
const $decb67059ffe42ce$var$identityUrlWrapper = (url)=>url;
const $decb67059ffe42ce$var$useSmartLinkCrossProductUrlWrapperFallback = (_args)=>$decb67059ffe42ce$var$identityUrlWrapper;
const $decb67059ffe42ce$export$119a84bedaff7b6e = ({ details: details })=>{
    const { product: product, bridgeProduct: bridgeProduct, xpcProduct: xpcProduct, xpcSubProduct: xpcSubProduct } = (0, $cMyWi.useSmartLinkContext)();
    // xpcProduct takes precedence over product — it identifies the host product for XPC analytics
    // without affecting link resolution (which uses the `product` prop separately).
    const effectiveProduct = xpcProduct ?? product;
    const effectiveBridge = bridgeProduct ?? $decb67059ffe42ce$var$SMART_LINKS_XPC_BRIDGE;
    const effectiveProductForWrapper = effectiveProduct?.toLowerCase() ?? 'unknown';
    const wrapUrl = (0, $b4SfK.useCrossProductUrlWrapper)({
        bridge: effectiveBridge,
        product: effectiveProductForWrapper,
        ...xpcSubProduct ? {
            subProduct: xpcSubProduct
        } : {}
    });
    return (0, $cozmU.useCallback)((url)=>{
        if (typeof window === 'undefined' || !$decb67059ffe42ce$export$189e6ab4f1c74893(details) || !effectiveProduct) return url;
        let parsedUrl;
        try {
            parsedUrl = new URL(url);
        } catch  {
            return url;
        }
        if (parsedUrl.searchParams.has($decb67059ffe42ce$var$XPC_QUERY_PARAM)) return url;
        return wrapUrl(url);
    }, // Keep bridge/subproduct in the dependency array so consumers that memoize this callback
    // refresh when mini-modal context updates from smartLinks to rovo-chat.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        details,
        effectiveBridge,
        effectiveProduct,
        wrapUrl,
        xpcSubProduct
    ]);
};
const $decb67059ffe42ce$export$f59314b362d05e65 = (0, $1G3WB.functionWithFG)('platform_smartlink_xpc_url_wrapping', $decb67059ffe42ce$export$119a84bedaff7b6e, $decb67059ffe42ce$var$useSmartLinkCrossProductUrlWrapperFallback);
module.exports["useSmartLinkCrossProductUrlWrapper"] = $decb67059ffe42ce$export$119a84bedaff7b6e;
module.exports["useSmartLinkCrossProductUrlWrapperGated"] = $decb67059ffe42ce$export$f59314b362d05e65;

});

parcelRegister("b4SfK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $ixfCV = parcelRequire("ixfCV");


var $kwd5f = parcelRequire("kwd5f");


var $3jjX7 = parcelRequire("3jjX7");

const $94cb50462294ed69$export$5d4c4eab0863aae3 = 'interactionSessionIdUpdated';
/**
 * This React hook is called with the correct bridge, product and sub-product parameters.
 * It returns a function that can be used to generate URLs with cross-product interaction parameters.
 *
 * @param options - Properties object that contains the following parameters:
 *
 * @returns A function that appends interaction session ID and other cross-product interaction parameters to a given URL.
 */ function $94cb50462294ed69$export$fc6e9265f8d85c92(options) {
    const { bridge: bridge, product: product, subProduct: subProduct } = options;
    const isEnabled = (0, $ixfCV.fg)('atlaskit-analytics-cross-product');
    // `useRef(initialValue)` evaluates `initialValue` on every render but only uses the result on
    // the first render. Populate the ref imperatively the first time we need it so we don't call
    // `getInstance()` on every render (per Billy Chen's review suggestion).
    const interactionSessionClientRef = (0, $cozmU.useRef)(undefined);
    if (isEnabled && !interactionSessionClientRef.current) interactionSessionClientRef.current = (0, $3jjX7.default).getInstance();
    const [interactionSessionId, setInteractionSessionId] = (0, $cozmU.useState)(()=>interactionSessionClientRef.current?.getCurrentInteractionSessionId() ?? '');
    (0, $cozmU.useEffect)(()=>{
        if (!isEnabled) return ()=>{};
        // Add event listener that subscribes to any future interaction session ID updates
        const unbind = (0, $cbY7C.bind)(document, {
            type: $94cb50462294ed69$export$5d4c4eab0863aae3,
            listener: ()=>{
                // Re-attempt fetch Global interactionSessionClient if not present already
                if (!interactionSessionClientRef.current) interactionSessionClientRef.current = (0, $3jjX7.default).getInstance();
                if (interactionSessionClientRef.current) {
                    const currentSessionId = interactionSessionClientRef.current.getCurrentInteractionSessionId();
                    currentSessionId && setInteractionSessionId(currentSessionId);
                }
            }
        });
        return unbind;
    }, [
        isEnabled
    ]);
    return (0, $cozmU.useCallback)((url)=>{
        if (!isEnabled || !interactionSessionId) return url;
        return (0, $kwd5f.generateUrlWithParams)(url, bridge, interactionSessionId, product, subProduct);
    }, [
        isEnabled,
        bridge,
        interactionSessionId,
        product,
        subProduct
    ]);
}
var $94cb50462294ed69$export$2e2bcd8739ae039 = $94cb50462294ed69$export$fc6e9265f8d85c92;
module.exports["useCrossProductUrlWrapper"] = $94cb50462294ed69$export$fc6e9265f8d85c92;
module.exports["default"] = $94cb50462294ed69$export$2e2bcd8739ae039;

});

parcelRegister("kwd5f", function(module, exports) {
const $8f3492c0e77dd422$export$81d16f1428ce0486 = 'xpis';
const $8f3492c0e77dd422$export$2e3999ec51334ffe = (url, bridge, interactionSessionId, product, subProduct)=>{
    const interactionSource = subProduct ? `${product}-${subProduct}` : product;
    const interactionSession = {
        bridge: bridge,
        id: interactionSessionId,
        source: interactionSource
    };
    const paramValueEncoded = btoa(JSON.stringify(interactionSession));
    let partialUrl = false;
    let urlObj;
    // If relative URL provided, add localhost as placeholder base, to be stripped later
    try {
        urlObj = new URL(url);
    } catch  {
        urlObj = new URL(url, 'http://localhost/');
        partialUrl = true;
    }
    urlObj.searchParams.set($8f3492c0e77dd422$export$81d16f1428ce0486, paramValueEncoded);
    if (partialUrl) return urlObj.pathname + urlObj.search;
    else return urlObj.toString();
};
module.exports["generateUrlWithParams"] = $8f3492c0e77dd422$export$2e3999ec51334ffe;

});

parcelRegister("3jjX7", function(module, exports) {
// WARNING: This value is shared between @atlaskit/analytics-cross-product and
// @atlassiansox/analytics-cross-product-interaction-client. Take care when updating.
const $6e6234f2764332e7$export$7bc189309d2ad463 = 'analyticsInteractionSesssionTrackingClient';
class $6e6234f2764332e7$export$2e2bcd8739ae039 {
    static getInstance() {
        let interactionSessionTracking;
        try {
            // Check if InteractionSessionTracking in global window object
            if ($6e6234f2764332e7$export$7bc189309d2ad463 in window) interactionSessionTracking = window[$6e6234f2764332e7$export$7bc189309d2ad463];
        } catch (err) {
        // Silently swallow exception
        }
        return interactionSessionTracking;
    }
}
module.exports["default"] = $6e6234f2764332e7$export$2e2bcd8739ae039;

});

parcelRegister("bVAqi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cMyWi = parcelRequire("cMyWi");


var $ixfCV = parcelRequire("ixfCV");


var $b8pma = parcelRequire("b8pma");


var $6Vsq4 = parcelRequire("6Vsq4");


var $4yYAm = parcelRequire("4yYAm");


var $h6Vc4 = parcelRequire("h6Vc4");


var $9PA4G = parcelRequire("9PA4G");


var $lBXKn = parcelRequire("lBXKn");


var $cEvdy = parcelRequire("cEvdy");


var $8QLAc = parcelRequire("8QLAc");


var $dz9dk = parcelRequire("dz9dk");


var $9nA1A = parcelRequire("9nA1A");


var $jKbUI = parcelRequire("jKbUI");

const $dee3aec0e9ff1e8c$var$PENDING_LINK_STATUSES = [
    (0, $4yYAm.SmartLinkStatus).Pending,
    (0, $4yYAm.SmartLinkStatus).Resolving
];
/**
 * This represents a Flexible Card: a link represented by a card with metadata.
 * This is the container in which all Flexible UI Blocks and Elements exist.
 * Note: TitleBlock is mandatory for a Flexible Card to render.
 * @see Container
 */ const $dee3aec0e9ff1e8c$var$FlexibleCard = ({ appearance: appearance = 'flexible', cardState: cardState, children: children, id: id, onAuthorize: onAuthorize, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, onError: onError, onResolve: onResolve, origin: origin, placeholderData: placeholderData, renderers: renderers, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, testId: testId, ui: ui, url: url, title: ssrTitle })=>{
    const aiSummaryConfig = (0, $lBXKn.useAISummaryConfig)();
    const resolve = (0, $cEvdy.default)();
    const { isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel, product: product } = (0, $cMyWi.useSmartLinkContext)();
    const rovoConfig = (0, $8QLAc.default)();
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const { status: cardType, details: details } = cardState;
    const status = cardType;
    const appendCrossProductAnalyticsParams = (0, $dz9dk.useSmartLinkCrossProductUrlWrapperGated)({
        details: details
    });
    const transformUrlCallback = (0, $cozmU.useCallback)((destinationUrl = url)=>appendCrossProductAnalyticsParams(destinationUrl), [
        appendCrossProductAnalyticsParams,
        url
    ]);
    const transformUrl = (0, $ixfCV.fg)('platform_smartlink_xpc_url_wrapping') ? transformUrlCallback : undefined;
    // if we have placeholder state it means we can internally use it
    // as temporary resolved data until the actual data comes back as one of the final statuses
    const placeholderCardState = (0, $cozmU.useMemo)(()=>$dee3aec0e9ff1e8c$var$PENDING_LINK_STATUSES.includes(status) && placeholderData && (0, $h6Vc4.extractPlaceHolderCardState)(placeholderData), [
        placeholderData,
        status
    ]);
    const placeHolderStatus = placeholderCardState ? placeholderCardState.status : undefined;
    const context = (0, $cozmU.useMemo)(()=>(0, $jKbUI.getContextByStatus)({
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            response: placeholderCardState ? placeholderCardState.details : details,
            id: id,
            onAuthorize: onAuthorize,
            onClick: onClick,
            onAuxClick: onAuxClick,
            onContextMenu: onContextMenu,
            origin: origin,
            renderers: renderers,
            resolve: resolve,
            product: product,
            rovoConfig: rovoConfig,
            actionOptions: actionOptions,
            status: placeholderCardState ? placeHolderStatus : status,
            url: url,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel,
            transformUrl: transformUrl
        }), [
        aiSummaryConfig,
        appearance,
        actionOptions,
        details,
        id,
        isPreviewPanelAvailable,
        onAuthorize,
        onClick,
        onAuxClick,
        onContextMenu,
        openPreviewPanel,
        origin,
        placeholderCardState,
        placeHolderStatus,
        product,
        renderers,
        resolve,
        rovoConfig,
        status,
        transformUrl,
        url,
        fireEvent
    ]);
    const flexibleCardContext = (0, $cozmU.useMemo)(()=>({
            data: context,
            status: placeHolderStatus ?? status,
            ui: ui
        }), [
        context,
        placeHolderStatus,
        status,
        ui
    ]);
    const { linkTitle: linkTitle } = context || {};
    const title = linkTitle?.text;
    (0, $cozmU.useEffect)(()=>{
        switch(status){
            case (0, $4yYAm.SmartLinkStatus).Resolved:
                if (onResolve) onResolve({
                    title: title,
                    url: url,
                    extensionKey: details?.meta?.key
                });
                break;
            case (0, $4yYAm.SmartLinkStatus).Errored:
            case (0, $4yYAm.SmartLinkStatus).Fallback:
            case (0, $4yYAm.SmartLinkStatus).Forbidden:
            case (0, $4yYAm.SmartLinkStatus).NotFound:
            case (0, $4yYAm.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        title,
        url,
        details?.meta?.key
    ]);
    const retry = flexibleCardContext.data?.actions?.[(0, $4yYAm.InternalActionName).UnresolvedAction];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9PA4G.FlexibleCardContext).Provider, {
        value: flexibleCardContext
    }, $dee3aec0e9ff1e8c$var$PENDING_LINK_STATUSES.includes(status) && !Boolean(placeholderCardState) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "smart-card-flexible-card"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9nA1A.default), {
        testId: testId,
        ...ui,
        title: ssrTitle,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        showHoverPreview: showHoverPreview,
        hoverPreviewOptions: hoverPreviewOptions,
        actionOptions: actionOptions,
        status: status,
        retry: retry
    }, children));
};
var $dee3aec0e9ff1e8c$export$2e2bcd8739ae039 = $dee3aec0e9ff1e8c$var$FlexibleCard;
module.exports["default"] = $dee3aec0e9ff1e8c$export$2e2bcd8739ae039;

});

parcelRegister("h6Vc4", function(module, exports) {
const $ed97ea0952c19fa7$var$isValidPlaceholderData = (placeholderData)=>placeholderData?.data && 'url' in placeholderData.data && 'name' in placeholderData.data;
const $ed97ea0952c19fa7$export$684541b2632ffbbc = (placeholderData)=>{
    return $ed97ea0952c19fa7$var$isValidPlaceholderData(placeholderData) ? {
        status: 'resolved',
        metadataStatus: undefined,
        details: placeholderData
    } : undefined;
};
module.exports["extractPlaceHolderCardState"] = $ed97ea0952c19fa7$export$684541b2632ffbbc;

});

parcelRegister("9nA1A", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $4yYAm = parcelRequire("4yYAm");


var $9PA4G = parcelRequire("9PA4G");


var $1CN4f = parcelRequire("1CN4f");


var $4abK1 = parcelRequire("4abK1");


var $jdA6O = parcelRequire("jdA6O");


var $7ly7P = parcelRequire("7ly7P");


var $4JCld = parcelRequire("4JCld");

const $479950c88028365e$export$6f4e0540a2f2295a = (children, context)=>{
    let options = {};
    if ((0, $1CN4f.isFlexUiPreviewPresent)(context)) (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child)) {
            if ((0, $4abK1.isFlexibleUiPreviewBlock)(child)) {
                const { placement: placement } = child.props;
                if (placement === (0, $4yYAm.MediaPlacement).Left) options.previewOnLeft = true;
                if (placement === (0, $4yYAm.MediaPlacement).Right) options.previewOnRight = true;
            }
        }
    });
    return options;
};
const $479950c88028365e$var$filterChildren = (children, removeBlockRestriction)=>{
    if (removeBlockRestriction) return children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, (child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child) && (0, $4abK1.isFlexibleUiBlock)(child) ? child : undefined);
}; /**
    * Note: This function is only necessary for CompiledCSS within Jest tests due to the way it handles Styles.
    * CompiledCSS will inject a StyleCacheProvider around the component tree, which
    * causes the children to be wrapped in a StyleCacheProvider as well. This function recursively
    * searches for the first valid TitleBlock within the children of the StyleCacheProvider.
    */ 
const $479950c88028365e$export$f6c7a950371733c8 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(node)) return undefined;
    if (node.type === (0, $jdA6O.default)) return node;
    if ((0, $4abK1.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid;
        (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(node.props.children, (child)=>{
            if (typeof child.type !== 'string' && child.type?.name !== 'Style') isChildrenValid = $479950c88028365e$export$f6c7a950371733c8(child);
        });
        return isChildrenValid;
    }
    return undefined;
};
const $479950c88028365e$var$getTitleBlockProps = (children)=>{
    const block = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(children).map((child)=>$479950c88028365e$export$f6c7a950371733c8(child)).filter((x)=>x !== undefined).at(0);
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(block)) return block.props;
};
const $479950c88028365e$var$getLayeredLink = (testId, context, children, onClick, onAuxClick, onContextMenu, title)=>{
    const { linkTitle: linkTitle, url: url = '' } = context || {}; // SSR cannot reliably extract TitleBlock props from children, so `title` is
    // provided from CardSSR as a stable server/client value to prevent hydration
    // text mismatches for the clickable container link.
    const { anchorTarget: target, text: text } = $479950c88028365e$var$getTitleBlockProps(children) || {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4JCld.default), {
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        target: target,
        testId: testId,
        text: title || text || linkTitle?.text,
        url: url
    });
};
const $479950c88028365e$var$baseStyleCommon = null;
const $479950c88028365e$var$backgroundStyles = null;
const $479950c88028365e$var$elevationStyles = null;
const $479950c88028365e$var$clickableContainerStyles = null;
const $479950c88028365e$var$gapStyleMap = {
    xlarge: "_zulpr2fv",
    large: "_zulpzu5n",
    medium: "_zulp1bpf",
    small: "_zulpswc3"
}; /**
    * Get container padding based on smart link size
    * Equivalent version for DS primitives space token is getPrimitivesPaddingSpaceBySize()
    * at view/FlexibleCard/components/utils.tsx
    */ 
const $479950c88028365e$var$getPadding = (size)=>{
    switch(size){
        case (0, $4yYAm.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $4yYAm.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $4yYAm.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $4yYAm.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $479950c88028365e$var$getGap = (size)=>{
    switch(size){
        case (0, $4yYAm.SmartLinkSize).XLarge:
            return "var(--ds-space-250, 20px)";
        case (0, $4yYAm.SmartLinkSize).Large:
            return "var(--ds-space-200, 16px)";
        case (0, $4yYAm.SmartLinkSize).Medium:
            return "var(--ds-space-100, 8px)";
        case (0, $4yYAm.SmartLinkSize).Small:
        default:
            return "var(--ds-space-050, 4px)";
    }
};
const $479950c88028365e$var$previewOnLeftStyleMap = {
    xlarge: "_19bver0k _y5vk1ejb",
    large: "_19bv16ru _y5vkv47k",
    medium: "_19bv1g7w _y5vk1eak",
    small: "_19bvlbes _y5vku2gc"
};
const $479950c88028365e$var$previewOnRightStyleMap = {
    xlarge: "_u5f3er0k _1yob1ejb",
    large: "_u5f316ru _1yobv47k",
    medium: "_u5f31g7w _1yob1eak",
    small: "_u5f3lbes _1yobu2gc"
}; /**
    * A container is a hidden component that build the Flexible Smart Link.
    * All the Flexible UI components are wrapped inside the container.
    * It inherits the ui props from Card component and applies the custom styling
    * accordingly.
    * @internal
    * @see Block
    */ 
const $479950c88028365e$var$Container = ({ children: children, clickableContainer: clickableContainer = false, hideBackground: hideBackground = false, hideElevation: hideElevation = false, hidePadding: hidePadding = false, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, retry: retry, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeBlockRestriction: removeBlockRestriction = false, size: size = (0, $4yYAm.SmartLinkSize).Medium, status: status, testId: testId = 'smart-links-container', title: title })=>{
    (0, $6cFsl.di)((0, $7ly7P.default));
    const padding = hidePadding ? '0px' : $479950c88028365e$var$getPadding(size);
    const gap = $479950c88028365e$var$getGap(size);
    const context = (0, $9PA4G.useFlexibleUiContext)();
    const { previewOnLeft: previewOnLeft, previewOnRight: previewOnRight } = $479950c88028365e$export$6f4e0540a2f2295a(children, context);
    const isResolved = status === 'resolved';
    const isUnresolvedWithAuthFlow = status !== 'resolved' && retry !== undefined;
    const hasHoverCardOverride = hoverPreviewOptions?.render !== undefined;
    const canShowHoverCard = showHoverPreview && (isResolved || isUnresolvedWithAuthFlow || hasHoverCardOverride);
    const containerPaddingStyles = null;
    const container = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-smart-link-container": true,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_1e0c1txw _2lx21bp4 _1ul9idpf _1reo15vq _kqswh2mm _1pcmkb7n _1v7y1i6y _ufn21i6y",
            $479950c88028365e$var$gapStyleMap[size],
            !hideBackground && "_bfhkhp5a",
            "_1yt418y6 _jb7v18y6 _y5vk167t _1yob1wow _r37x1r5k",
            previewOnLeft && $479950c88028365e$var$previewOnLeftStyleMap[size],
            previewOnRight && $479950c88028365e$var$previewOnRightStyleMap[size],
            !hideElevation && "_19itia51 _2rkopb1k _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            clickableContainer && "_nqwih2mm _18ywh2mm _1nq3h2mm _1t4ckb7n _1nxdkb7n _xnbykb7n"
        ]),
        style: {
            "--_1xumd0e": (0, $9aYkv.default)(padding),
            "--_73mooq": (0, $9aYkv.default)(previewOnLeft ? gap : padding),
            "--_12k13bg": (0, $9aYkv.default)(previewOnRight ? gap : padding)
        }
    }, clickableContainer ? $479950c88028365e$var$getLayeredLink(testId, context, children, onClick, onAuxClick, onContextMenu, title) : null, $479950c88028365e$var$filterChildren(children, removeBlockRestriction));
    if (context?.url && canShowHoverCard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ly7P.default), {
        isHoverPreview: isResolved || hasHoverCardOverride,
        isAuthTooltip: isUnresolvedWithAuthFlow,
        actionOptions: actionOptions,
        testId: testId,
        url: context.url,
        hoverPreviewOptions: hoverPreviewOptions
    }, container);
    return container;
};
var $479950c88028365e$export$2e2bcd8739ae039 = $479950c88028365e$var$Container;
module.exports["default"] = $479950c88028365e$export$2e2bcd8739ae039;

});

parcelRegister("1CN4f", function(module, exports) {
const $b11c19fc9aa89c7e$export$783c1bf8fee63f80 = (context)=>Boolean(context && context.preview);
module.exports["isFlexUiPreviewPresent"] = $b11c19fc9aa89c7e$export$783c1bf8fee63f80;

});

parcelRegister("7ly7P", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4yYAm = parcelRequire("4yYAm");


var $16kNn = parcelRequire("16kNn");


var $jLxvy = parcelRequire("jLxvy");

const $32ab5c854e7cdaa4$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY = 100;
const $32ab5c854e7cdaa4$var$HoverCardControl = ({ children: children, isHoverPreview: isHoverPreview, isAuthTooltip: isAuthTooltip, actionOptions: actionOptions, testId: testId, url: url, delay: delay = $32ab5c854e7cdaa4$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY, hoverPreviewOptions: hoverPreviewOptions })=>{
    const [canOpen, setCanOpen] = (0, $cozmU.useState)(true);
    const mouseStopTimer = (0, $cozmU.useRef)();
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        };
    }, []);
    const onMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
    }, []);
    const onMouseMove = (0, $cozmU.useCallback)((e)=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        // Never show hover card on action or when action dropdown opens.
        // The code below can be simplified by using :is() and :has()
        // but the pseudo-class isn't support by Firefox yet.
        const action = // Any action button group (title/footer block)
        e.target.closest('.actions-button-group') || // When action dropdown list is opened on action button group or lozenge action
        e.target.closest('[data-smart-link-container]')?.querySelector('[data-action-open="true"]');
        const canOpenOnElement = isAuthTooltip && !action || // EDM-7060: For hover preview, also hide hover card on all elements
        // except title element (link title)
        isHoverPreview && !action && !e.target.closest(`[data-smart-element]:not([data-smart-element="${(0, $4yYAm.ElementName).Title}"])`);
        mouseStopTimer.current = setTimeout(()=>{
            if (canOpen !== canOpenOnElement) setCanOpen(Boolean(canOpenOnElement));
        }, delay);
    }, [
        isAuthTooltip,
        isHoverPreview,
        canOpen,
        delay
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLxvy.HoverCard), {
        allowEventPropagation: true,
        canOpen: canOpen,
        closeOnChildClick: true,
        actionOptions: actionOptions,
        url: url,
        hoverPreviewOptions: hoverPreviewOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        onBlur: (0, $16kNn.noop),
        onMouseLeave: onMouseLeave,
        onMouseMove: onMouseMove,
        "data-testid": `${testId}-hover-card-wrapper`,
        role: 'presentation'
    }, children));
};
var $32ab5c854e7cdaa4$export$2e2bcd8739ae039 = $32ab5c854e7cdaa4$var$HoverCardControl;
module.exports["default"] = $32ab5c854e7cdaa4$export$2e2bcd8739ae039;

});

parcelRegister("jLxvy", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $6cFsl = parcelRequire("6cFsl");


var $lzgC6 = parcelRequire("lzgC6");


var $6Vsq4 = parcelRequire("6Vsq4");


var $4yYAm = parcelRequire("4yYAm");


var $jdqmT = parcelRequire("jdqmT");


var $hsgLh = parcelRequire("hsgLh");


var $1smAh = parcelRequire("1smAh");


var $cn7Ll = parcelRequire("cn7Ll");

const $f35adce8a13b91c6$var$HoverCardWithErrorBoundary = (props)=>{
    (0, $6cFsl.di)((0, $cn7Ll.HoverCardComponent));
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const { url: url, id: id, children: children } = props;
    const analyticsContext = (0, $1smAh.useSmartLinkAnalyticsContext)({
        display: (0, $4yYAm.CardDisplay).HoverCardPreview,
        id: id,
        source: (0, $cn7Ll.HOVER_CARD_SOURCE),
        url: url
    });
    const onError = (0, $cozmU.useCallback)((error, info)=>{
        (0, $jdqmT.startUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $jdqmT.failUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $jdqmT.failUfoExperience)('smart-link-authenticated', id || 'NULL');
        fireEvent('ui.smartLink.renderFailed', {
            ...analyticsContext?.attributes,
            display: (0, $4yYAm.CardDisplay).HoverCardPreview,
            id: id ?? null,
            error: error,
            errorInfo: info
        });
    }, [
        analyticsContext,
        id,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: children,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hsgLh.SmartLinkModalProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cn7Ll.HoverCardComponent), props, children)));
};
const $f35adce8a13b91c6$var$HoverCardWithoutAnalyticsContext = (0, $lzgC6.default)()($f35adce8a13b91c6$var$HoverCardWithErrorBoundary);
const $f35adce8a13b91c6$export$57a077cc9fbe653e = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f35adce8a13b91c6$var$HoverCardWithoutAnalyticsContext, props);
};
const $f35adce8a13b91c6$export$f1f63acbe6ed8fb0 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f35adce8a13b91c6$export$57a077cc9fbe653e, props);
module.exports["HoverCard"] = $f35adce8a13b91c6$export$57a077cc9fbe653e;
module.exports["StandaloneHoverCard"] = $f35adce8a13b91c6$export$f1f63acbe6ed8fb0;

});

parcelRegister("cn7Ll", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ixfCV = parcelRequire("ixfCV");


var $5wHqn = parcelRequire("5wHqn");


var $fqVYq = parcelRequire("fqVYq");


var $4yYAm = parcelRequire("4yYAm");


var $iUTeb = parcelRequire("iUTeb");


var $9ojsk = parcelRequire("9ojsk");


var $9H66G = parcelRequire("9H66G");


var $16kNn = parcelRequire("16kNn");


var $1smAh = parcelRequire("1smAh");


var $5irZi = parcelRequire("5irZi");


var $4xm0k = parcelRequire("4xm0k");


var $7CAOU = parcelRequire("7CAOU");

const $73aa8936eb4c3aa9$export$421dbc3834daf261 = 'smartLinkPreviewHoverCard';
const $73aa8936eb4c3aa9$var$HOVER_CARD_TRIGGER_WRAPPER = 'hover-card-trigger-wrapper';
const $73aa8936eb4c3aa9$var$FADE_IN_DELAY = 500;
const $73aa8936eb4c3aa9$var$FADE_OUT_DELAY = 300;
const $73aa8936eb4c3aa9$var$RESOLVE_DELAY = 100;
const $73aa8936eb4c3aa9$export$e2173dafa6a751bb = ({ children: children, url: url, id: id = '', canOpen: canOpen = true, closeOnChildClick: closeOnChildClick = false, actionOptions: actionOptions, allowEventPropagation: allowEventPropagation = false, zIndex: zIndex = (0, $7CAOU.HOVER_CARD_Z_INDEX), noFadeDelay: noFadeDelay = false, hoverPreviewOptions: hoverPreviewOptions, role: role, shouldRenderToParent: shouldRenderToParent = false, label: label, titleId: titleId, onVisibilityChange: onVisibilityChange })=>{
    const fadeInDelay = hoverPreviewOptions?.fadeInDelay ?? $73aa8936eb4c3aa9$var$FADE_IN_DELAY;
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const fadeOutTimeoutId = (0, $cozmU.useRef)();
    const fadeInTimeoutId = (0, $cozmU.useRef)();
    const resolveTimeOutId = (0, $cozmU.useRef)();
    const mousePos = (0, $cozmU.useRef)();
    const popupOffset = (0, $cozmU.useRef)();
    const parentSpan = (0, $cozmU.useRef)(null);
    const renderers = (0, $9ojsk.useSmartLinkRenderers)();
    const linkState = (0, $9H66G.useSmartCardState)(url);
    const handleSetIsOpen = (0, $cozmU.useCallback)((isOpen)=>{
        setIsOpen(isOpen);
        onVisibilityChange?.(isOpen);
    }, [
        onVisibilityChange
    ]);
    const { loadMetadata: loadMetadata, register: register } = (0, $iUTeb.useSmartCardActions)(id, url);
    const setMousePosition = (0, $cozmU.useCallback)((event)=>{
        if (isOpen && canOpen) return;
        mousePos.current = {
            x: event.clientX,
            y: event.clientY
        };
        //If these are undefined then popupOffset is undefined and we fallback to default bottom-start placement
        if ((!isOpen || !canOpen) && parentSpan.current && mousePos.current) {
            const { bottom: bottom, left: left } = parentSpan.current.getBoundingClientRect();
            popupOffset.current = [
                mousePos.current.x - left + (0, $7CAOU.CARD_GAP_PX),
                mousePos.current.y - bottom + (0, $7CAOU.CARD_GAP_PX)
            ];
        }
    }, [
        canOpen,
        isOpen
    ]);
    const hideCard = (0, $cozmU.useCallback)(()=>{
        if (handleSetIsOpen) handleSetIsOpen(false);
        else setIsOpen(false);
    }, [
        handleSetIsOpen
    ]);
    const initHideCard = (0, $cozmU.useCallback)(()=>{
        if (fadeInTimeoutId.current) {
            clearTimeout(fadeInTimeoutId.current);
            // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress fade in event
            fadeInTimeoutId.current = undefined;
        }
        if (resolveTimeOutId.current) {
            clearTimeout(resolveTimeOutId.current);
            // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress resolve event
            resolveTimeOutId.current = undefined;
        }
        if (noFadeDelay) hideCard();
        else fadeOutTimeoutId.current = setTimeout(()=>hideCard(), $73aa8936eb4c3aa9$var$FADE_OUT_DELAY);
    }, [
        hideCard,
        noFadeDelay
    ]);
    // clearing out the timeouts in order to avoid memory leaks
    // in case the component unmounts before they execute
    (0, $cozmU.useEffect)(()=>()=>{
            if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
            if (fadeInTimeoutId.current) {
                clearTimeout(fadeInTimeoutId.current);
                // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress fade in event
                fadeInTimeoutId.current = undefined;
            }
            if (resolveTimeOutId.current) {
                clearTimeout(resolveTimeOutId.current);
                // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress resolve event
                resolveTimeOutId.current = undefined;
            }
        }, []);
    // we want to initiate resolve a bit earlier for standalone cards
    // to minimize the loading state
    const initResolve = (0, $cozmU.useCallback)(()=>{
        // this check covers both non-SSR (status) & SSR case (metadataStatus)
        const isLinkUnresolved = linkState.status === 'pending' || !linkState.metadataStatus || linkState.status === 'resolved' && linkState.metadataStatus === 'pending' && (0, $ixfCV.fg)('platform_smartlink_inline_resolve_optimization');
        if (!resolveTimeOutId.current && isLinkUnresolved) resolveTimeOutId.current = setTimeout(()=>{
            if (linkState.status === 'pending') // Link hasn't been registered yet. Register and resolve link.
            register();
            else // Link has been already been partially resolved. Load metadata.
            loadMetadata();
        }, $73aa8936eb4c3aa9$var$RESOLVE_DELAY);
    }, [
        linkState.metadataStatus,
        linkState.status,
        loadMetadata,
        register
    ]);
    const initShowCard = (0, $cozmU.useCallback)((event)=>{
        // clearing out fadeOutTimeoutId in case it's already counting down to hide the card
        if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
        // starting to resolve the hover card if the store doesn't have data about the link yet
        initResolve();
        //Set mouse position in the case it's not already set by onMouseMove, as in the case of scrolling
        setMousePosition(event);
        if (!isOpen && !fadeInTimeoutId.current) {
            // setting a timeout to show a Hover Card after delay runs out
            if (noFadeDelay) {
                if (handleSetIsOpen) handleSetIsOpen(true);
                else setIsOpen(true);
            } else fadeInTimeoutId.current = setTimeout(()=>{
                if (handleSetIsOpen) handleSetIsOpen(true);
                else setIsOpen(true);
            }, fadeInDelay);
        }
    }, [
        initResolve,
        isOpen,
        setMousePosition,
        noFadeDelay,
        fadeInDelay,
        handleSetIsOpen
    ]);
    const onActionClick = (0, $cozmU.useCallback)((actionId)=>{
        if (actionId === (0, $4yYAm.ActionName).PreviewAction || actionId === (0, $4yYAm.ActionName).AutomationAction) hideCard();
    }, [
        hideCard
    ]);
    // Stop hover preview content to propagate event to parent.
    const handleChildClick = (0, $cozmU.useCallback)((e, closeOnClick)=>{
        if (!allowEventPropagation) e.stopPropagation();
        if (closeOnClick) hideCard();
    }, [
        allowEventPropagation,
        hideCard
    ]);
    const onContextMenuClick = (0, $cozmU.useCallback)((e)=>handleChildClick(e, true), [
        handleChildClick
    ]);
    const onChildClick = (0, $cozmU.useCallback)((e)=>handleChildClick(e, closeOnChildClick), [
        closeOnChildClick,
        handleChildClick
    ]);
    const content = (0, $cozmU.useCallback)(({ update: update })=>{
        const hoverCardContentProps = {
            onMouseEnter: initShowCard,
            onMouseLeave: initHideCard,
            cardState: linkState,
            onActionClick: onActionClick,
            onDismiss: hideCard,
            onResolve: update,
            renderers: renderers,
            actionOptions: actionOptions,
            url: url,
            id: id,
            hoverPreviewOptions: hoverPreviewOptions
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1smAh.SmartLinkAnalyticsContext), {
            url: url,
            display: (0, $4yYAm.CardDisplay).HoverCardPreview,
            id: id,
            source: $73aa8936eb4c3aa9$export$421dbc3834daf261
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4xm0k.default), hoverCardContentProps));
    }, [
        initShowCard,
        initHideCard,
        linkState,
        onActionClick,
        hideCard,
        renderers,
        actionOptions,
        url,
        id,
        hoverPreviewOptions
    ]);
    const handleKeyDown = (0, $cozmU.useCallback)((e)=>{
        if (e.key === ' ') {
            e.preventDefault();
            initShowCard(e);
        }
    }, [
        initShowCard
    ]);
    const trigger = (0, $cozmU.useCallback)(({ 'aria-haspopup': _ariaHasPopup, 'aria-expanded': _ariaExpanded, // `aria-controls` is also stripped because the trigger wrapper renders
    // with `role="none"`. axe's `aria-valid-attr-value` rule flags any
    // `aria-controls` value sitting on a presentational element, since the
    // element has no semantic role to control. Removing the attribute
    // keeps the trigger semantically inert without losing functionality.
    'aria-controls': _ariaControls, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            ref: parentSpan
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            ...triggerProps,
            onMouseOver: initShowCard,
            onMouseLeave: initHideCard,
            onMouseMove: setMousePosition,
            onKeyDown: handleKeyDown,
            onClick: onChildClick,
            onContextMenu: onContextMenuClick,
            "data-testid": $73aa8936eb4c3aa9$var$HOVER_CARD_TRIGGER_WRAPPER,
            ...(0, $fqVYq.editorExperiment)('platform_editor_preview_panel_linking_exp', true) ? {
                className: $73aa8936eb4c3aa9$var$HOVER_CARD_TRIGGER_WRAPPER
            } : {},
            onFocus: (0, $16kNn.noop),
            onBlur: (0, $16kNn.noop),
            role: "none"
        }, children)), [
        children,
        initHideCard,
        initShowCard,
        onChildClick,
        onContextMenuClick,
        setMousePosition,
        handleKeyDown
    ]);
    const popupComponent = (0, $cozmU.useMemo)(// Within the Popup component, if shouldRenderToParent, the zIndex prop is ignored
    // as it is assumed that the custom popup container has the desired styles
    ()=>(0, $5irZi.createCustomPopupContainer)(shouldRenderToParent ? zIndex : undefined), [
        zIndex,
        shouldRenderToParent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        testId: "hover-card",
        isOpen: isOpen && canOpen,
        onClose: initHideCard,
        placement: "bottom-start",
        offset: popupOffset.current,
        autoFocus: false,
        content: content,
        trigger: trigger,
        zIndex: zIndex,
        role: role,
        titleId: titleId,
        label: label,
        shouldRenderToParent: shouldRenderToParent,
        // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        popupComponent: popupComponent
    });
};
module.exports["HOVER_CARD_SOURCE"] = $73aa8936eb4c3aa9$export$421dbc3834daf261;
module.exports["HoverCardComponent"] = $73aa8936eb4c3aa9$export$e2173dafa6a751bb;

});

parcelRegister("5irZi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

/**
 * The purpose of this component is to hide the default Popup border.
 * HoverCard border implementation is in ContentContainer where it can
 * change between the default border and prism border during runtime.
 */ const $ac5e610c3ad80dcb$var$CustomPopupContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(({ children: children, shouldFitContainer: _, shouldRenderToParent: __, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ...props,
        ref: ref
    }, children));
const $ac5e610c3ad80dcb$export$c98f335200f1c8df = (zIndex)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(// FIXME: ...props spreads all props to the div, including isReferenceHidden, which is not a valid prop for a div.
    // Find another way but adding exceptions with _, __, ___ etc.
    ({ children: children, shouldFitContainer: _, shouldRenderToParent: __, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ...props,
            ref: ref,
            ...zIndex !== undefined && {
                style: {
                    ...props.style,
                    zIndex: zIndex
                }
            }
        }, children));
};
var $ac5e610c3ad80dcb$export$2e2bcd8739ae039 = $ac5e610c3ad80dcb$var$CustomPopupContainer;
module.exports["createCustomPopupContainer"] = $ac5e610c3ad80dcb$export$c98f335200f1c8df;

});

parcelRegister("4xm0k", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");

var $9DHhW = parcelRequire("9DHhW");


var $cMyWi = parcelRequire("cMyWi");


var $ixfCV = parcelRequire("ixfCV");


var $8m50u = parcelRequire("8m50u");

var $VUk2d = parcelRequire("VUk2d");


var $ieeJu = parcelRequire("ieeJu");


var $6Vsq4 = parcelRequire("6Vsq4");


var $4yYAm = parcelRequire("4yYAm");


var $2Q7sv = parcelRequire("2Q7sv");


var $8QLAc = parcelRequire("8QLAc");


var $dz9dk = parcelRequire("dz9dk");


var $9H66G = parcelRequire("9H66G");


var $16kNn = parcelRequire("16kNn");


var $lOOiS = parcelRequire("lOOiS");


var $l1f3f = parcelRequire("l1f3f");


var $5C2uB = parcelRequire("5C2uB");


var $7CAOU = parcelRequire("7CAOU");


var $6nncv = parcelRequire("6nncv");


var $6GUs4 = parcelRequire("6GUs4");


var $93zgq = parcelRequire("93zgq");


var $dcCaJ = parcelRequire("dcCaJ");


var $exTWI = parcelRequire("exTWI");


var $apqge = parcelRequire("apqge");


var $8qkhz = parcelRequire("8qkhz");

const $51fe488ad53df981$export$34883cbaea18402d = 'smart-links-hover-preview';
const $51fe488ad53df981$var$useIsResolvedView = ({ cardState: cardState, hoverPreviewOptions: hoverPreviewOptions })=>{
    return !hoverPreviewOptions?.render?.() && cardState.status === 'resolved';
};
const $51fe488ad53df981$var$useServices = ({ url: url })=>{
    const linkState = (0, $9H66G.useSmartCardState)(url);
    const services = (0, $2Q7sv.getServices)(linkState.details);
    return services;
};
const $51fe488ad53df981$var$useIsUnauthorisedView = ({ cardState: cardState, url: url, hoverPreviewOptions: hoverPreviewOptions })=>{
    const services = $51fe488ad53df981$var$useServices({
        url: url
    });
    return !hoverPreviewOptions?.render?.() && cardState.status === 'unauthorized' && Boolean(services?.length);
};
const $51fe488ad53df981$var$useIsShowPreauthBetterHovercard = (props)=>{
    const { rovoOptions: rovoConfig } = (0, $8QLAc.default)();
    return Boolean($51fe488ad53df981$var$useIsUnauthorisedView(props) && rovoConfig?.isRovoEnabled && (0, $ieeJu.expValEquals)('platform_sl_3p_preauth_better_hovercard', 'isEnabled', true));
};
const $51fe488ad53df981$var$HoverCardContent = ({ id: id = '', cardState: cardState, onActionClick: onActionClick, onResolve: onResolve, renderers: renderers, url: url, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onDismiss: onDismiss, actionOptions: actionOptions, hoverPreviewOptions: hoverPreviewOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const extensionKey = (0, $cozmU.useMemo)(()=>(0, $2Q7sv.getExtensionKey)(cardState.details), [
        cardState.details
    ]);
    const linkState = (0, $9H66G.useSmartCardState)(url);
    const linkStatus = linkState.status ?? 'pending';
    const definitionId = (0, $cozmU.useMemo)(()=>(0, $2Q7sv.getDefinitionId)(cardState.details), [
        cardState.details
    ]);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, product: product } = (0, $cMyWi.useSmartLinkContext)();
    const isAISummaryEnabled = (0, $lOOiS.getIsAISummaryEnabled)(isAdminHubAIEnabled, cardState.details);
    const services = (0, $2Q7sv.getServices)(linkState.details);
    const appendCrossProductAnalyticsParams = (0, $dz9dk.useSmartLinkCrossProductUrlWrapperGated)({
        details: linkState.details
    });
    const statusRef = (0, $cozmU.useRef)(linkStatus);
    const fireEventRef = (0, $cozmU.useRef)(fireEvent);
    const definitionIdRef = (0, $cozmU.useRef)(definitionId);
    (0, $cozmU.useEffect)(()=>{
        /**
     * Must access object value via ref because its not stable
     * and it can trigger useEffect to re-run below
     */ if (statusRef.current !== linkStatus) statusRef.current = linkStatus;
        if (fireEventRef.current !== fireEvent) fireEventRef.current = fireEvent;
        if (definitionIdRef.current !== definitionId) definitionIdRef.current = definitionId;
    }, [
        linkStatus,
        fireEvent,
        definitionId
    ]);
    (0, $cozmU.useEffect)(()=>{
        const previewDisplay = 'card';
        const previewInvokeMethod = 'mouse_hover';
        const cardOpenTime = Date.now();
        const fireEventCurrent = fireEventRef.current;
        fireEventCurrent('ui.hoverCard.viewed', {
            previewDisplay: previewDisplay,
            previewInvokeMethod: previewInvokeMethod,
            definitionId: definitionIdRef.current ?? null
        });
        return ()=>{
            const hoverTime = Date.now() - cardOpenTime;
            fireEventCurrent('ui.hoverCard.dismissed', {
                previewDisplay: previewDisplay,
                previewInvokeMethod: previewInvokeMethod,
                hoverTime: hoverTime,
                definitionId: definitionIdRef.current ?? null
            });
        };
    }, []);
    const getDestinationUrl = (0, $cozmU.useCallback)(()=>{
        // FIXME: destinationUrl should be rendered in the DOM anchor href instead of derived at click time
        const preferredUrl = (0, $2Q7sv.getClickUrl)(url, linkState.details) ?? url;
        return appendCrossProductAnalyticsParams(preferredUrl) ?? preferredUrl;
    }, [
        appendCrossProductAnalyticsParams,
        linkState.details,
        url
    ]);
    // Middle-click handler to trigger fire3PClickEvent on middle-clicks.
    // Scope is limited to 3P click analytics to keep the experiment focused.
    const onAuxClick = (0, $cozmU.useCallback)((event)=>{
        const destinationUrl = getDestinationUrl();
        (0, $5C2uB.updateAnchorHref)(event, destinationUrl);
    }, [
        getDestinationUrl
    ]);
    // Right-click handler to trigger fire3PClickEvent on right-clicks.
    // Scope is limited to 3P click analytics to keep the experiment focused.
    const onContextMenu = (0, $cozmU.useCallback)((event)=>{
        const destinationUrl = getDestinationUrl();
        (0, $5C2uB.updateAnchorHref)(event, destinationUrl);
    }, [
        getDestinationUrl
    ]);
    const onClick = (0, $cozmU.useCallback)((event)=>{
        if ((0, $ixfCV.fg)('platform_smartlink_xpc_url_wrapping')) {
            // Prevent the anchor's native navigation so we can open the destination URL
            // with cross-product analytics query parameters appended.
            // The cross-product params are client-only and cannot be rendered
            // server-side. Falls back to the original `url` prop if the event target is
            // not an anchor element.
            event.preventDefault();
            const { target: target } = (0, $5C2uB.getAnchorAttributesFromEvent)(event);
            const destinationUrl = getDestinationUrl();
            (0, $5C2uB.updateAnchorHref)(event, destinationUrl);
            window.open(destinationUrl, target);
        }
        const isModifierKeyPressed = (0, $16kNn.isSpecialEvent)(event);
        fireEvent('ui.smartLink.clicked.titleGoToLink', {
            id: id,
            display: (0, $4yYAm.CardDisplay).HoverCardPreview,
            isModifierKeyPressed: isModifierKeyPressed,
            definitionId: definitionId ?? null
        });
        (0, $l1f3f.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        createAnalyticsEvent,
        getDestinationUrl,
        id,
        fireEvent,
        definitionId
    ]);
    const data = cardState.details?.data;
    const { subtitle: subtitle } = (0, $6nncv.getMetadata)(extensionKey, data);
    const titleMaxLines = subtitle && subtitle.length > 0 ? 1 : 2;
    const titleBlockProps = {
        maxLines: titleMaxLines,
        size: (0, $4yYAm.SmartLinkSize).Large,
        position: (0, $4yYAm.SmartLinkPosition).Center,
        subtitle: subtitle,
        anchorTarget: product === 'ATLAS' ? '_self' : undefined
    };
    const uiOptions = (0, $7CAOU.flexibleUiOptions);
    uiOptions.enableSnippetRenderer = true;
    const flexibleCardProps = {
        appearance: (0, $4yYAm.CardDisplay).HoverCardPreview,
        cardState: cardState,
        onClick: onClick,
        ...(0, $ixfCV.fg)('platform_smartlink_xpc_url_wrapping') ? {
            onAuxClick: onAuxClick,
            onContextMenu: onContextMenu
        } : undefined,
        onResolve: onResolve,
        origin: 'smartLinkPreviewHoverCard',
        renderers: renderers,
        actionOptions: actionOptions,
        ui: uiOptions,
        url: url,
        children: null
    };
    const onClickStopPropagation = (0, $cozmU.useCallback)((e)=>e.stopPropagation(), []);
    const useIsResolvedViewGated = (0, $VUk2d.functionUnionWithCondition)(()=>(0, $ixfCV.fg)('platform_sl_3p_preauth_better_hovercard_killswitch'), $51fe488ad53df981$var$useIsResolvedView, ()=>undefined);
    const useIsUnauthorisedViewGated = (0, $VUk2d.functionUnionWithCondition)(()=>(0, $ixfCV.fg)('platform_sl_3p_preauth_better_hovercard_killswitch'), $51fe488ad53df981$var$useIsUnauthorisedView, ()=>undefined);
    const useIsShowPreauthBetterHovercardGated = (0, $VUk2d.functionUnionWithCondition)(()=>(0, $ixfCV.fg)('platform_sl_3p_preauth_better_hovercard_killswitch'), $51fe488ad53df981$var$useIsShowPreauthBetterHovercard, ()=>undefined);
    const isResolved = useIsResolvedViewGated({
        cardState: cardState,
        hoverPreviewOptions: hoverPreviewOptions
    });
    const isUnauthorised = useIsUnauthorisedViewGated({
        cardState: cardState,
        url: url,
        hoverPreviewOptions: hoverPreviewOptions
    });
    const showPreauthBetterHovercard = useIsShowPreauthBetterHovercardGated({
        cardState: cardState,
        url: url,
        hoverPreviewOptions: hoverPreviewOptions
    });
    if ((0, $ixfCV.fg)('platform_sl_3p_preauth_better_hovercard_killswitch')) {
        const cardView = (()=>{
            const overrideView = hoverPreviewOptions?.render?.();
            if (overrideView) return overrideView;
            if (cardState.status === 'errored') return null;
            if (cardState.status === 'resolving' || cardState.metadataStatus === 'pending') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $exTWI.default), {
                flexibleCardProps: flexibleCardProps,
                titleBlockProps: titleBlockProps
            });
            if (isUnauthorised) {
                if (showPreauthBetterHovercard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8qkhz.default), {
                    extensionKey: extensionKey,
                    id: id,
                    flexibleCardProps: flexibleCardProps,
                    onDismiss: onDismiss,
                    url: url
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $apqge.default), {
                    extensionKey: extensionKey,
                    id: id,
                    flexibleCardProps: flexibleCardProps,
                    url: url
                });
            }
            if (cardState.status === 'forbidden' || cardState.status === 'not_found') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $93zgq.default), {
                flexibleCardProps: flexibleCardProps
            });
            if (isResolved) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dcCaJ.default), {
                cardState: cardState,
                extensionKey: extensionKey,
                flexibleCardProps: flexibleCardProps,
                isAISummaryEnabled: isAISummaryEnabled,
                onActionClick: onActionClick,
                titleBlockProps: titleBlockProps
            });
            return null;
        })();
        return cardView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GUs4.default), {
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: onClickStopPropagation,
            widthAppearance: showPreauthBetterHovercard ? 'slim' : undefined,
            isAIEnabled: isAISummaryEnabled,
            url: url
        }, cardView) : null;
    } else {
        const getCardView = (cardState)=>{
            const overrideView = hoverPreviewOptions?.render?.();
            if (overrideView) return overrideView;
            if (cardState.status === 'errored') return null;
            if (cardState.status === 'resolving' || cardState.metadataStatus === 'pending') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $exTWI.default), {
                flexibleCardProps: flexibleCardProps,
                titleBlockProps: titleBlockProps
            });
            if (cardState.status === 'unauthorized' && services?.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $apqge.default), {
                extensionKey: extensionKey,
                id: id,
                flexibleCardProps: flexibleCardProps,
                url: url
            });
            if (cardState.status === 'forbidden' || cardState.status === 'not_found') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $93zgq.default), {
                flexibleCardProps: flexibleCardProps
            });
            if (cardState.status === 'resolved') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dcCaJ.default), {
                cardState: cardState,
                extensionKey: extensionKey,
                flexibleCardProps: flexibleCardProps,
                isAISummaryEnabled: isAISummaryEnabled,
                onActionClick: onActionClick,
                titleBlockProps: titleBlockProps
            });
            return null;
        };
        const cardView = getCardView(cardState);
        return cardView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GUs4.default), {
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: onClickStopPropagation,
            isAIEnabled: isAISummaryEnabled,
            url: url
        }, cardView) : null;
    }
};
const $51fe488ad53df981$var$HoverCardContentWithViewVariant = (props)=>{
    const showPreauthBetterHovercard = $51fe488ad53df981$var$useIsShowPreauthBetterHovercard(props);
    const data = (0, $cozmU.useMemo)(()=>{
        let viewVariant = 'default';
        if (showPreauthBetterHovercard) viewVariant = 'rovo-unauthorised-view';
        return {
            attributes: {
                viewVariant: viewVariant
            }
        };
    }, [
        showPreauthBetterHovercard
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($51fe488ad53df981$var$HoverCardContent, props));
};
const $51fe488ad53df981$var$_default_1 = (0, $8m50u.componentWithCondition)(()=>{
    return (0, $ixfCV.fg)('platform_sl_3p_preauth_better_hovercard_killswitch');
}, $51fe488ad53df981$var$HoverCardContentWithViewVariant, $51fe488ad53df981$var$HoverCardContent);
var $51fe488ad53df981$export$2e2bcd8739ae039 = $51fe488ad53df981$var$_default_1;
module.exports["hoverCardClassName"] = $51fe488ad53df981$export$34883cbaea18402d;
module.exports["default"] = $51fe488ad53df981$export$2e2bcd8739ae039;

});

parcelRegister("7CAOU", function(module, exports) {

var $jp2Q3 = parcelRequire("jp2Q3");


var $4yYAm = parcelRequire("4yYAm");

const $4b92af562a9f6a65$export$8245b0eaabf3440c = (0, $jp2Q3.layers).modal();
const $4b92af562a9f6a65$export$8e022b7269e8199a = {
    hideBackground: true,
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true,
    size: (0, $4yYAm.SmartLinkSize).Medium,
    zIndex: $4b92af562a9f6a65$export$8245b0eaabf3440c + 1
};
const $4b92af562a9f6a65$export$a0a37c997fbcd678 = 24;
const $4b92af562a9f6a65$export$e7cae8c75d768024 = 10; // gap between mouse cursor and hover card
module.exports["HOVER_CARD_Z_INDEX"] = $4b92af562a9f6a65$export$8245b0eaabf3440c;
module.exports["flexibleUiOptions"] = $4b92af562a9f6a65$export$8e022b7269e8199a;
module.exports["CARD_WIDTH_REM"] = $4b92af562a9f6a65$export$a0a37c997fbcd678;
module.exports["CARD_GAP_PX"] = $4b92af562a9f6a65$export$e7cae8c75d768024;

});

parcelRegister("6nncv", function(module, exports) {

var $jawC3 = parcelRequire("jawC3");


var $4yYAm = parcelRequire("4yYAm");


var $eeqm3 = parcelRequire("eeqm3");

const $40b39971c7d4e97d$var$getSimulatedBetterMetadata = (extensionKey, data)=>{
    const types = data ? (0, $jawC3.extractType)(data) : undefined;
    const defaultMetadata = {
        primary: [
            (0, $4yYAm.ElementName).AuthorGroup,
            (0, $4yYAm.ElementName).ModifiedOn
        ]
    };
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            if (types?.includes('atlassian:SourceCodePullRequest')) return {
                primary: [
                    (0, $4yYAm.ElementName).AuthorGroup,
                    (0, $4yYAm.ElementName).ModifiedOn,
                    (0, $4yYAm.ElementName).SubscriberCount,
                    (0, $4yYAm.ElementName).State
                ],
                subtitle: [
                    (0, $4yYAm.ElementName).SourceBranch,
                    (0, $4yYAm.ElementName).TargetBranch
                ]
            };
            if (types?.includes('schema:DigitalDocument')) return {
                primary: [
                    (0, $4yYAm.ElementName).LatestCommit,
                    (0, $4yYAm.ElementName).CollaboratorGroup,
                    (0, $4yYAm.ElementName).ModifiedOn
                ]
            };
            return {
                primary: [
                    (0, $4yYAm.ElementName).AuthorGroup,
                    (0, $4yYAm.ElementName).ModifiedOn
                ]
            };
        case 'confluence-object-provider':
            const primaryAttribution = data && (0, $eeqm3.extractOwnedBy)(data) ? (0, $4yYAm.ElementName).OwnedByGroup : (0, $4yYAm.ElementName).AuthorGroup;
            return {
                primary: [
                    primaryAttribution,
                    (0, $4yYAm.ElementName).ModifiedOn
                ],
                tertiary: [
                    (0, $4yYAm.ElementName).ReactCount,
                    (0, $4yYAm.ElementName).CommentCount,
                    (0, $4yYAm.ElementName).ViewCount
                ]
            };
        case 'jira-object-provider':
            const isJiraTask = data?.['@type']?.includes('atlassian:Task') ?? false;
            return {
                ...defaultMetadata,
                ...isJiraTask && {
                    primary: [
                        (0, $4yYAm.ElementName).AssignedToGroup,
                        (0, $4yYAm.ElementName).State,
                        (0, $4yYAm.ElementName).StoryPoints,
                        (0, $4yYAm.ElementName).Priority
                    ]
                }
            };
        case 'trello-object-provider':
            return {
                primary: [
                    (0, $4yYAm.ElementName).CollaboratorGroup,
                    (0, $4yYAm.ElementName).State,
                    (0, $4yYAm.ElementName).DueOn
                ],
                secondary: [
                    (0, $4yYAm.ElementName).ReactCount,
                    (0, $4yYAm.ElementName).CommentCount,
                    (0, $4yYAm.ElementName).AttachmentCount,
                    (0, $4yYAm.ElementName).ChecklistProgress
                ],
                subtitle: [
                    (0, $4yYAm.ElementName).Location
                ]
            };
        case 'watermelon-object-provider':
            if (types?.includes('atlassian:Project')) return {
                primary: [
                    (0, $4yYAm.ElementName).AuthorGroup,
                    (0, $4yYAm.ElementName).ModifiedOn,
                    (0, $4yYAm.ElementName).State,
                    (0, $4yYAm.ElementName).DueOn
                ]
            };
            return {
                primary: [
                    (0, $4yYAm.ElementName).AuthorGroup,
                    (0, $4yYAm.ElementName).State,
                    (0, $4yYAm.ElementName).DueOn
                ]
            };
        case 'slack-object-provider':
            return {
                primary: [
                    (0, $4yYAm.ElementName).AuthorGroup,
                    (0, $4yYAm.ElementName).SentOn
                ],
                tertiary: [
                    (0, $4yYAm.ElementName).ReactCount,
                    (0, $4yYAm.ElementName).CommentCount
                ]
            };
        case 'google-object-provider':
        case 'figma-object-provider':
            return {
                primary: [
                    (0, $4yYAm.ElementName).AuthorGroup,
                    (0, $4yYAm.ElementName).ModifiedOn
                ]
            };
        default:
            return defaultMetadata;
    }
};
const $40b39971c7d4e97d$var$AvatarGroupsWithNamePrefix = [
    (0, $4yYAm.ElementName).AssignedToGroup,
    (0, $4yYAm.ElementName).OwnedByGroup,
    (0, $4yYAm.ElementName).AuthorGroup
];
const $40b39971c7d4e97d$var$toElementItem = (name)=>{
    const showNamePrefix = $40b39971c7d4e97d$var$AvatarGroupsWithNamePrefix.indexOf(name) !== -1 ? true : undefined;
    const testId = `${name.toLowerCase()}-metadata-element`;
    return {
        name: name,
        showNamePrefix: showNamePrefix,
        testId: testId
    };
};
const $40b39971c7d4e97d$var$toElementItems = (elementNames)=>{
    if (!elementNames?.length) return;
    return elementNames.filter((name)=>name in (0, $4yYAm.ElementName)).map($40b39971c7d4e97d$var$toElementItem);
};
const $40b39971c7d4e97d$export$8548546c0aa631e6 = (extensionKey, data)=>{
    const metadata = $40b39971c7d4e97d$var$getSimulatedBetterMetadata(extensionKey, data);
    const primary = [].concat(metadata.primary, metadata.tertiary);
    return {
        subtitle: $40b39971c7d4e97d$var$toElementItems(metadata.subtitle),
        primary: $40b39971c7d4e97d$var$toElementItems(primary),
        secondary: $40b39971c7d4e97d$var$toElementItems(metadata.secondary)
    };
};
module.exports["getMetadata"] = $40b39971c7d4e97d$export$8548546c0aa631e6;

});

parcelRegister("eeqm3", function(module, exports) {

var $jawC3 = parcelRequire("jawC3");

const $4f7a8ee2597639d5$var$extractLinkName = (link)=>{
    if (link && typeof link === 'object' && link['@type'] === 'Link') return link.name;
};
const $4f7a8ee2597639d5$var$extractValue = (data, key)=>{
    return data?.[key];
};
const $4f7a8ee2597639d5$export$b68822b76d5d51d5 = (data)=>$4f7a8ee2597639d5$var$extractValue(data, 'schema:commentCount');
const $4f7a8ee2597639d5$export$fb0960a89fb9c17b = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $jawC3.isEntityPresent)(response)) {
        const entity = (0, $jawC3.extractEntity)(response);
        return entity && 'commentCount' in entity && typeof entity.commentCount === 'number' ? entity?.commentCount : undefined;
    }
    return response?.data && $4f7a8ee2597639d5$export$b68822b76d5d51d5(response?.data);
};
const $4f7a8ee2597639d5$export$4356c594f5c138d6 = (data)=>$4f7a8ee2597639d5$var$extractValue(data, 'atlassian:appliedToComponentsCount');
const $4f7a8ee2597639d5$export$ac56bd7a37249b48 = (data)=>$4f7a8ee2597639d5$var$extractValue(data, 'endTime');
const $4f7a8ee2597639d5$export$e57334ce4738e29d = (data)=>$4f7a8ee2597639d5$var$extractValue(data, 'atlassian:viewCount');
const $4f7a8ee2597639d5$export$44130aa92252501 = (data)=>$4f7a8ee2597639d5$var$extractValue(data, 'atlassian:reactCount');
const $4f7a8ee2597639d5$export$bb52c21c67a309ca = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $jawC3.isEntityPresent)(response)) {
        const entity = (0, $jawC3.extractEntity)(response);
        const reactions = entity && 'reactions' in entity && Array.isArray(entity.reactions) ? entity.reactions : undefined;
        return reactions?.reduce((total, reaction)=>total + reaction?.total, 0);
    }
    return response?.data && $4f7a8ee2597639d5$export$44130aa92252501(response?.data);
};
const $4f7a8ee2597639d5$export$c8bef3d5e550a3a = (data)=>$4f7a8ee2597639d5$var$extractValue(data, 'atlassian:voteCount');
const $4f7a8ee2597639d5$export$75b4b5a156f48ff3 = (data)=>{
    const persons = (0, $jawC3.extractPersonOwnedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $4f7a8ee2597639d5$export$5546969a505305 = (data)=>{
    const person = (0, $jawC3.extractPersonAssignedTo)(data);
    if (person) return person.name;
};
const $4f7a8ee2597639d5$export$edb8a7a44b91274e = (data)=>{
    const person = (0, $jawC3.extractPersonAssignedTo)(data);
    return person ? [
        person
    ] : undefined;
};
const $4f7a8ee2597639d5$export$69b10d653f96288b = (data)=>{
    const persons = (0, $jawC3.extractPersonCreatedBy)(data);
    if (persons && persons.length) return persons[0].name;
};
const $4f7a8ee2597639d5$export$bcb193c84c865ec9 = (data)=>{
    const person = (0, $jawC3.extractPersonUpdatedBy)(data);
    if (person) return person.name;
};
const $4f7a8ee2597639d5$export$43e54589935a1ff = (data)=>$4f7a8ee2597639d5$var$extractValue(data, 'schema:programmingLanguage');
const $4f7a8ee2597639d5$export$949ac6a8325b3fdb = (data)=>$4f7a8ee2597639d5$var$extractLinkName(data['atlassian:mergeSource']);
const $4f7a8ee2597639d5$export$8bd03a7beb5badf1 = (data)=>$4f7a8ee2597639d5$var$extractValue(data, 'atlassian:subscriberCount');
const $4f7a8ee2597639d5$export$9fc8706c6cb5343a = (data)=>{
    const val = data?.attributedTo ? Array.isArray(data?.attributedTo) ? data?.attributedTo.length : 0 : 0;
    return val;
};
const $4f7a8ee2597639d5$export$65362ff78a97fd8 = (data)=>$4f7a8ee2597639d5$var$extractValue(data, 'atlassian:attachmentCount');
const $4f7a8ee2597639d5$export$29b0ac5d2f9890cf = (data)=>$4f7a8ee2597639d5$var$extractLinkName(data['atlassian:mergeDestination']);
const $4f7a8ee2597639d5$export$dd980f9881b65d9c = (data)=>{
    const checkItemsObj = $4f7a8ee2597639d5$var$extractValue(data, 'atlassian:checkItems');
    return checkItemsObj ? `${checkItemsObj.checkedItems}/${checkItemsObj.totalItems}` : undefined;
};
const $4f7a8ee2597639d5$export$9df94c77b0746c3c = (data)=>{
    const { url: url, name: name } = $4f7a8ee2597639d5$var$extractValue(data, 'location') || {};
    if (url && name && typeof url === 'string') return {
        text: name,
        url: url
    };
};
const $4f7a8ee2597639d5$export$744e3a2674114c1d = (data)=>{
    const subTasksObject = $4f7a8ee2597639d5$var$extractValue(data, 'atlassian:subTasks');
    return subTasksObject && subTasksObject.totalCount ? `${subTasksObject.resolvedCount}/${subTasksObject.totalCount}` : undefined;
};
const $4f7a8ee2597639d5$export$6052f26bb463e370 = (data)=>{
    return data?.userAttributes;
};
const $4f7a8ee2597639d5$export$cc4028b2878d0675 = (data)=>{
    return $4f7a8ee2597639d5$var$extractValue(data, 'atlassian:readTimeInMinutes');
};
const $4f7a8ee2597639d5$export$b592ddecae70b61d = (data)=>{
    return $4f7a8ee2597639d5$var$extractValue(data, 'dateSent');
};
const $4f7a8ee2597639d5$export$5c05c5b7ca37e36e = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $jawC3.isEntityPresent)(response)) return (0, $jawC3.extractEntity)(response)?.createdAt;
    return response?.data && $4f7a8ee2597639d5$export$b592ddecae70b61d(response?.data);
};
const $4f7a8ee2597639d5$export$bdcea84d1550eb9d = (data)=>{
    return $4f7a8ee2597639d5$var$extractValue(data, 'atlassian:storyPoints');
};
const $4f7a8ee2597639d5$export$bec1443e3e33b166 = (meta)=>meta.objectId;
const $4f7a8ee2597639d5$export$11d1314ebbee594e = (meta)=>meta.resourceType;
const $4f7a8ee2597639d5$export$92037aea7f27bf7f = (meta)=>meta.tenantId;
const $4f7a8ee2597639d5$export$f222ff3355b608d8 = (response)=>{
    try {
        const url = (0, $jawC3.extractSmartLinkUrl)(response);
        const hostName = url ? new URL(url).hostname : undefined;
        return hostName;
    } catch  {
        return undefined;
    }
};
module.exports["extractSmartLinkCommentCount"] = $4f7a8ee2597639d5$export$fb0960a89fb9c17b;
module.exports["extractAppliedToComponentsCount"] = $4f7a8ee2597639d5$export$4356c594f5c138d6;
module.exports["extractDueOn"] = $4f7a8ee2597639d5$export$ac56bd7a37249b48;
module.exports["extractViewCount"] = $4f7a8ee2597639d5$export$e57334ce4738e29d;
module.exports["extractSmartLinkReactCount"] = $4f7a8ee2597639d5$export$bb52c21c67a309ca;
module.exports["extractVoteCount"] = $4f7a8ee2597639d5$export$c8bef3d5e550a3a;
module.exports["extractOwnedBy"] = $4f7a8ee2597639d5$export$75b4b5a156f48ff3;
module.exports["extractAssignedTo"] = $4f7a8ee2597639d5$export$5546969a505305;
module.exports["extractPersonAssignedToAsArray"] = $4f7a8ee2597639d5$export$edb8a7a44b91274e;
module.exports["extractProgrammingLanguage"] = $4f7a8ee2597639d5$export$43e54589935a1ff;
module.exports["extractSourceBranch"] = $4f7a8ee2597639d5$export$949ac6a8325b3fdb;
module.exports["extractSubscriberCount"] = $4f7a8ee2597639d5$export$8bd03a7beb5badf1;
module.exports["extractTeamMemberCount"] = $4f7a8ee2597639d5$export$9fc8706c6cb5343a;
module.exports["extractAttachmentCount"] = $4f7a8ee2597639d5$export$65362ff78a97fd8;
module.exports["extractTargetBranch"] = $4f7a8ee2597639d5$export$29b0ac5d2f9890cf;
module.exports["extractChecklistProgress"] = $4f7a8ee2597639d5$export$dd980f9881b65d9c;
module.exports["extractLocation"] = $4f7a8ee2597639d5$export$9df94c77b0746c3c;
module.exports["extractSubTasksProgress"] = $4f7a8ee2597639d5$export$744e3a2674114c1d;
module.exports["extractUserAttributes"] = $4f7a8ee2597639d5$export$6052f26bb463e370;
module.exports["extractReadTime"] = $4f7a8ee2597639d5$export$cc4028b2878d0675;
module.exports["extractSmartLinkSentOn"] = $4f7a8ee2597639d5$export$5c05c5b7ca37e36e;
module.exports["extractStoryPoints"] = $4f7a8ee2597639d5$export$bdcea84d1550eb9d;
module.exports["extractMetaObjectId"] = $4f7a8ee2597639d5$export$bec1443e3e33b166;
module.exports["extractMetaResourceType"] = $4f7a8ee2597639d5$export$11d1314ebbee594e;
module.exports["extractMetaTenantId"] = $4f7a8ee2597639d5$export$92037aea7f27bf7f;
module.exports["extractHostName"] = $4f7a8ee2597639d5$export$f222ff3355b608d8;

});

parcelRegister("6GUs4", function(module, exports) {
/* ContentContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6cFsl = parcelRequire("6cFsl");


var $euBHF = parcelRequire("euBHF");


var $6PgB0 = parcelRequire("6PgB0");


var $4xm0k = parcelRequire("4xm0k");

const $d306b041e75683ad$var$HoverCardContainerStyle = null;
const $d306b041e75683ad$var$hoverCardShellWidthDefault = null;
const $d306b041e75683ad$var$hoverCardShellWidthSlim = null;
const $d306b041e75683ad$var$hoverCardShellHideLoadingPlaceholder = null;
const $d306b041e75683ad$var$popupContainerStyles = null;
const $d306b041e75683ad$var$ConnectedAIPrismContainer = ({ children: children, widthAppearance: widthAppearance, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>{
    (0, $6cFsl.di)((0, $euBHF.default), (0, $6PgB0.default));
    const { state: { status: status } } = (0, $euBHF.default)(url);
    const [showPrism, setShowPrism] = (0, $cozmU.useState)(status === 'loading');
    (0, $cozmU.useEffect)(()=>{
        setShowPrism(status === 'loading');
    }, [
        status
    ]);
    const resolvedWidthAppearance = widthAppearance ?? 'default';
    const container = /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            "_11q7glyw _189eidpf _vchhusvi",
            resolvedWidthAppearance === 'slim' ? "_1bsbtye8" : "_1bsb1f23",
            "_9spsglyw",
            !isAIEnabled && "_2rko1mok _bfhk1bhr _16qs130s",
            (0, $4xm0k.hoverCardClassName)
        ]),
        "data-testid": testId,
        ...props
    }, children);
    return isAIEnabled ? /*#__PURE__*/ $cozmU.createElement((0, $6PgB0.default), {
        isVisible: showPrism,
        testId: `${testId}-prism`
    }, container) : container;
};
const $d306b041e75683ad$var$ContentContainer = ({ children: children, widthAppearance: widthAppearance, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>/*#__PURE__*/ $cozmU.createElement($d306b041e75683ad$var$ConnectedAIPrismContainer, {
        widthAppearance: widthAppearance,
        isAIEnabled: isAIEnabled,
        url: url,
        testId: testId,
        ...props
    }, children);
var $d306b041e75683ad$export$2e2bcd8739ae039 = $d306b041e75683ad$var$ContentContainer;
module.exports["default"] = $d306b041e75683ad$export$2e2bcd8739ae039;

});

parcelRegister("93zgq", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $ad7Ou = parcelRequire("ad7Ou");


var $jawC3 = parcelRequire("jawC3");


var $leSBv = parcelRequire("leSBv");


var $gCfXH = parcelRequire("gCfXH");


var $dM7c5 = parcelRequire("dM7c5");


var $bVAqi = parcelRequire("bVAqi");


var $3qg1D = parcelRequire("3qg1D");

var $voDgt = parcelRequire("voDgt");

const $950782f89926949b$var$titleBlockStyles = null;
const $950782f89926949b$var$mainTextStyles = null;
const $950782f89926949b$var$connectButtonStyles = null;
const $950782f89926949b$var$basePreviewStyles = null;
const $950782f89926949b$var$HoverCardForbiddenView = ({ flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-forbidden-view' })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { cardState: cardState, url: url } = flexibleCardProps;
    const meta = cardState.details?.meta;
    const product = (0, $jawC3.extractSmartLinkProvider)(cardState.details)?.text ?? '';
    const hostname = /*#__PURE__*/ $cozmU.createElement("b", null, (0, $gCfXH.default)(url));
    const { action: action, descriptiveMessageKey: descriptiveMessageKey, titleMessageKey: titleMessageKey, buttonDisabled: buttonDisabled } = (0, $leSBv.extractRequestAccessContextImproved)({
        jsonLd: meta,
        url: url,
        product: product,
        createAnalyticsEvent: createAnalyticsEvent
    }) ?? {};
    if (!titleMessageKey || !descriptiveMessageKey) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $bVAqi.default), {
        ...flexibleCardProps,
        testId: testId
    }, /*#__PURE__*/ $cozmU.createElement((0, $voDgt.default), {
        ignoreContainerPadding: true,
        testId: testId,
        className: (0, $hekY6.default)([
            "_13li1mok _qrwq1mok _otyru2gc"
        ])
    }), /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        testId: `${testId}-title`,
        className: (0, $hekY6.default)([
            "_1bah1h6o _k48p1pd9 _19pku2gc"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $dM7c5.messages)[titleMessageKey],
        values: {
            product: product
        }
    })), /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        testId: `${testId}-content`,
        className: (0, $hekY6.default)([
            "_11c8wadc _1e0c1nu9 _1bah1h6o _19pkze3t _y3gn1h6o"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $dM7c5.messages)[descriptiveMessageKey],
        values: {
            product: product,
            hostname: hostname
        }
    })), action && /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        className: (0, $hekY6.default)([
            "_1bah1h6o _19pku2gc"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        testId: `${testId}-button`,
        onClick: action?.promise,
        appearance: "primary",
        isDisabled: buttonDisabled
    }, action?.text)));
};
var $950782f89926949b$export$2e2bcd8739ae039 = $950782f89926949b$var$HoverCardForbiddenView;
module.exports["default"] = $950782f89926949b$export$2e2bcd8739ae039;

});

parcelRegister("leSBv", function(module, exports) {

var $dM7c5 = parcelRequire("dM7c5");


var $6GOAK = parcelRequire("6GOAK");


var $9ug60 = parcelRequire("9ug60");


var $gCfXH = parcelRequire("gCfXH");

const $ee3dc381f0d57dc0$export$846c1540a86749e6 = ({ jsonLd: jsonLd, url: url, product: product, createAnalyticsEvent: createAnalyticsEvent })=>{
    const requestAccess = jsonLd?.requestAccess ? {
        ...jsonLd?.requestAccess,
        hostname: (0, $gCfXH.default)(url)
    } : undefined;
    switch(jsonLd?.requestAccess?.accessType){
        case 'DIRECT_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'direct_access_title',
                descriptiveMessageKey: 'direct_access_description',
                callToActionMessageKey: 'direct_access',
                action: (0, $9ug60.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'crossJoin',
                        eventType: 'ui'
                    }).fire((0, $6GOAK.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'direct_access', (0, $dM7c5.messages).direct_access, {
                    product: product
                })
            };
        case 'REQUEST_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'default_no_access_title',
                descriptiveMessageKey: 'request_access_description',
                callToActionMessageKey: 'request_access',
                action: (0, $9ug60.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $6GOAK.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'request_access', (0, $dM7c5.messages).request_access)
            };
        case 'PENDING_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'request_access_pending_title',
                descriptiveMessageKey: 'request_access_pending_description',
                callToActionMessageKey: 'request_access_pending',
                action: (0, $9ug60.ForbiddenAction)(()=>window.open(url), 'request_access_pending', (0, $dM7c5.messages).request_access_pending),
                buttonDisabled: true
            };
        case 'DENIED_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'request_denied_description'
            };
        case 'ACCESS_EXISTS':
            if (jsonLd?.visibility === 'not_found') return {
                ...requestAccess,
                titleMessageKey: 'not_found_title',
                descriptiveMessageKey: 'not_found_description'
            };
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'access_exists_description',
                callToActionMessageKey: 'request_access',
                action: (0, $9ug60.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $6GOAK.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'access_exists', (0, $dM7c5.messages).request_access)
            };
        case 'FORBIDDEN':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'forbidden_description'
            };
        default:
            return requestAccess;
    }
};
module.exports["extractRequestAccessContextImproved"] = $ee3dc381f0d57dc0$export$846c1540a86749e6;

});

parcelRegister("9ug60", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $dM7c5 = parcelRequire("dM7c5");

const $053e2873bd8bd139$export$59f8830fb5467e35 = (handler, id = 'connect-other-account', message = (0, $dM7c5.messages).try_another_account, values = {})=>({
        id: id,
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...message,
            values: values
        }),
        promise: ()=>new Promise((resolve)=>resolve(handler())),
        buttonAppearance: 'default'
    });
module.exports["ForbiddenAction"] = $053e2873bd8bd139$export$59f8830fb5467e35;

});

parcelRegister("gCfXH", function(module, exports) {
const $dd8187e5dc61e444$var$extractHostname = (url)=>{
    try {
        return new URL(url).hostname;
    } catch  {
        return url;
    }
};
var $dd8187e5dc61e444$export$2e2bcd8739ae039 = $dd8187e5dc61e444$var$extractHostname;
module.exports["default"] = $dd8187e5dc61e444$export$2e2bcd8739ae039;

});

parcelRegister("dcCaJ", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $6Vsq4 = parcelRequire("6Vsq4");


var $4yYAm = parcelRequire("4yYAm");


var $jdqmT = parcelRequire("jdqmT");


var $euBHF = parcelRequire("euBHF");


var $bVAqi = parcelRequire("bVAqi");


var $9PQfP = parcelRequire("9PQfP");

var $8v3AV = parcelRequire("8v3AV");

var $i9PP7 = parcelRequire("i9PP7");

var $i1503 = parcelRequire("i1503");

var $es2gJ = parcelRequire("es2gJ");

var $jdA6O = parcelRequire("jdA6O");


var $6nncv = parcelRequire("6nncv");


var $9BEAr = parcelRequire("9BEAr");

const $9a8a2863bdf59a4a$var$hiddenSnippetStyles = null;
const $9a8a2863bdf59a4a$var$titleBlockStyles = null;
const $9a8a2863bdf59a4a$var$snippetBlockCss = null;
const $9a8a2863bdf59a4a$var$actionBlockCss = null;
const $9a8a2863bdf59a4a$var$HoverCardResolvedView = ({ cardState: cardState, extensionKey: extensionKey, flexibleCardProps: flexibleCardProps, isAISummaryEnabled: isAISummaryEnabled, onActionClick: onActionClick, titleBlockProps: titleBlockProps, id: id })=>{
    (0, $6cFsl.di)((0, $euBHF.default));
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        // Since this hover view is only rendered on resolved status,
        // there is no need to check for statuses.
        (0, $jdqmT.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
            extensionKey: extensionKey,
            display: (0, $4yYAm.CardDisplay).HoverCardPreview
        }); // UFO will disregard this if authentication experience has not yet been started
        (0, $jdqmT.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
            display: (0, $4yYAm.CardDisplay).HoverCardPreview
        });
        fireEvent('ui.smartLink.renderSuccess', {
            display: (0, $4yYAm.CardDisplay).HoverCardPreview
        });
    }, [
        extensionKey,
        fireEvent,
        id
    ]);
    const data = cardState.details?.data;
    const { primary: primary, secondary: secondary } = (0, $cozmU.useMemo)(()=>{
        return (0, $6nncv.getMetadata)(extensionKey, data);
    }, [
        data,
        extensionKey
    ]);
    const snippetHeight = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(0);
    const snippetBlockRef = (0, $cozmU.useRef)(null);
    const onSnippetRender = (0, $cozmU.useCallback)(()=>{
        snippetHeight.current = snippetBlockRef.current?.getBoundingClientRect().height ?? 0;
    }, []);
    const imagePreview = (0, $9BEAr.default)({
        fallbackElementHeight: snippetHeight.current,
        response: cardState.details
    });
    const snippet = imagePreview ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $es2gJ.default), {
        className: (0, $hekY6.default)([
            "_ca0q1b66"
        ])
    });
    const aiSummaryMinHeight = snippet ? snippetHeight.current : 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bVAqi.default), flexibleCardProps, imagePreview, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdA6O.default), {
        ...titleBlockProps,
        metadataPosition: (0, $4yYAm.SmartLinkPosition).Top,
        className: (0, $hekY6.default)([
            "_zulpu2gc _quenze3t _oebj1txw _13mh1pd9"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1503.default), {
        primary: primary,
        secondary: secondary,
        maxLines: 1,
        size: (0, $4yYAm.SmartLinkSize).Medium
    }), isAISummaryEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i9PP7.default), {
        aiSummaryMinHeight: aiSummaryMinHeight,
        placeholder: snippet
    }) : snippet, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $es2gJ.default), {
        testId: "hidden-snippet",
        onRender: onSnippetRender,
        blockRef: snippetBlockRef,
        isHidden: true,
        className: (0, $hekY6.default)([
            "_3um015vq _kqswstnw"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9PQfP.default), {
        onClick: onActionClick,
        spaceInline: "space.100",
        className: (0, $hekY6.default)([
            "_n3td1b66"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8v3AV.default), null));
};
var $9a8a2863bdf59a4a$export$2e2bcd8739ae039 = $9a8a2863bdf59a4a$var$HoverCardResolvedView;
module.exports["default"] = $9a8a2863bdf59a4a$export$2e2bcd8739ae039;

});

parcelRegister("9BEAr", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iRL51 = parcelRequire("iRL51");


var $voDgt = parcelRequire("voDgt");

const $109b8409b5ebe112$var$ImagePreview = ({ fallbackElementHeight: fallbackElementHeight, response: response })=>{
    const transitionStarted = (0, $cozmU.useRef)(false);
    const previewBlockRef = (0, $cozmU.useRef)(null);
    const [showPreview, setShowPreview] = (0, $cozmU.useState)(true);
    const [dynamicStyles, setDynamicStyles] = (0, $cozmU.useState)({});
    // Set Preview to a fixed height to enable transitions
    const onPreviewRender = (0, $cozmU.useCallback)(()=>{
        if (previewBlockRef.current) {
            const previewHeight = previewBlockRef.current?.getBoundingClientRect().height;
            setDynamicStyles({
                borderTopLeftRadius: "var(--ds-radius-large, 8px)",
                borderTopRightRadius: "var(--ds-radius-large, 8px)",
                ...previewHeight ? {
                    height: `${previewHeight}px`
                } : {}
            });
        }
    }, []);
    // On error set Preview to Fallback height with transition
    const onPreviewError = (0, $cozmU.useCallback)(()=>{
        if (transitionStarted.current === false) {
            setDynamicStyles({
                transition: 'height 300ms ease-in-out',
                height: `${fallbackElementHeight}px`
            });
            transitionStarted.current = true;
        }
    }, [
        fallbackElementHeight
    ]);
    const onPreviewTransitionEnd = (0, $cozmU.useCallback)(()=>{
        setShowPreview(false);
    }, []);
    return showPreview && (0, $iRL51.extractSmartLinkPreviewImage)(response) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $voDgt.default), {
        onError: onPreviewError,
        ignoreContainerPadding: true,
        onTransitionEnd: onPreviewTransitionEnd,
        blockRef: previewBlockRef,
        onRender: onPreviewRender,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles
    }) : null;
};
var $109b8409b5ebe112$export$2e2bcd8739ae039 = $109b8409b5ebe112$var$ImagePreview;
module.exports["default"] = $109b8409b5ebe112$export$2e2bcd8739ae039;

});

parcelRegister("iRL51", function(module, exports) {

var $jawC3 = parcelRequire("jawC3");


var $4yYAm = parcelRequire("4yYAm");

const $31e8e497c67842e8$var$extractPreview = (data)=>{
    if (!data) return undefined;
    const url = (0, $jawC3.extractImage)(data);
    return url ? {
        type: (0, $4yYAm.MediaType).Image,
        url: url
    } : undefined;
};
var $31e8e497c67842e8$export$2e2bcd8739ae039 = $31e8e497c67842e8$var$extractPreview;
const $31e8e497c67842e8$export$a79836076066b8b6 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $jawC3.isEntityPresent)(response)) {
        const entity = (0, $jawC3.extractEntity)(response);
        let url = entity?.thumbnail?.externalUrl;
        return url ? {
            type: (0, $4yYAm.MediaType).Image,
            url: url
        } : undefined;
    }
    return $31e8e497c67842e8$var$extractPreview(response.data);
};
module.exports["extractSmartLinkPreviewImage"] = $31e8e497c67842e8$export$a79836076066b8b6;

});

parcelRegister("exTWI", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $htZ7r = parcelRequire("htZ7r");


var $3qg1D = parcelRequire("3qg1D");


var $3M4EV = parcelRequire("3M4EV");


var $bt1e6 = parcelRequire("bt1e6");


var $7CAOU = parcelRequire("7CAOU");

const $8119c3383e55cb16$var$loadingViewContainer = null;
const $8119c3383e55cb16$var$skeletonContainer = null;
const $8119c3383e55cb16$var$titleStyle = null;
const $8119c3383e55cb16$var$titleBlockStyles = null;
const $8119c3383e55cb16$var$HoverCardLoadingView = ({ titleBlockProps: titleBlockProps })=>{
    const testId = 'hover-card-loading-view';
    const lineHeightRem = 1.25;
    const skeletonWidth = (0, $7CAOU.CARD_WIDTH_REM) - 2;
    const { size: size, actions: actions } = titleBlockProps;
    const actionGroup = actions?.length && actions?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3M4EV.default), {
        items: actions,
        visibleButtonsNum: 2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_1e0c1txw _2lx21bp4 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_zulpud5o _1e0c1txw _2lx21bp4 _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3qg1D.default), {
        ...titleBlockProps,
        testId: `${testId}-title-block`,
        className: (0, $hekY6.default)([
            "_zulpu2gc _1bsb1osq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bt1e6.default), {
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $htZ7r.LoadingSkeleton), null),
        size: size
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": `${testId}-title`,
        className: (0, $hekY6.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _4t3i1k92 _e2oo1osq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $htZ7r.LoadingSkeleton), {
        height: `${lineHeightRem}rem`
    })), actionGroup), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $htZ7r.LoadingSkeleton), {
        width: `${skeletonWidth}rem`,
        height: `${lineHeightRem}rem`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $htZ7r.LoadingSkeleton), {
        width: `${skeletonWidth}rem`,
        height: `${lineHeightRem * 3}rem`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $htZ7r.LoadingSkeleton), {
        width: `${skeletonWidth}rem`,
        height: `${lineHeightRem}rem`
    }))));
};
var $8119c3383e55cb16$export$2e2bcd8739ae039 = $8119c3383e55cb16$var$HoverCardLoadingView;
module.exports["default"] = $8119c3383e55cb16$export$2e2bcd8739ae039;

});

parcelRegister("apqge", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $jawC3 = parcelRequire("jawC3");


var $6Vsq4 = parcelRequire("6Vsq4");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $iUTeb = parcelRequire("iUTeb");


var $2Q7sv = parcelRequire("2Q7sv");


var $4bvRC = parcelRequire("4bvRC");


var $bVAqi = parcelRequire("bVAqi");


var $3qg1D = parcelRequire("3qg1D");


var $3M4EV = parcelRequire("3M4EV");


var $hsIfr = parcelRequire("hsIfr");

const $0784325f946f0262$var$connectButtonStyles = null;
const $0784325f946f0262$var$titleBlockStyles = null;
const $0784325f946f0262$var$mainTextStyles = null;
const $0784325f946f0262$var$HoverCardUnauthorisedView = ({ id: id = '', flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-unauthorised-view', url: url })=>{
    const { cardState: cardState } = flexibleCardProps;
    const providerName = (0, $jawC3.extractSmartLinkProvider)(cardState.details)?.text;
    const isProductIntegrationSupported = (0, $2Q7sv.hasAuthScopeOverrides)(cardState.details);
    const { authorize: authorize } = (0, $iUTeb.useSmartCardActions)(id, url);
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const handleAuthorize = (0, $cozmU.useCallback)(()=>{
        if (authorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            authorize((0, $4yYAm.CardDisplay).HoverCardPreview);
        }
    }, [
        authorize,
        fireEvent
    ]);
    const actions = (0, $cozmU.useMemo)(()=>[
            {
                name: (0, $4yYAm.ActionName).CustomAction,
                content: /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $dM7c5.messages).connect_unauthorised_account_action,
                    values: {
                        context: providerName
                    }
                }),
                onClick: handleAuthorize
            }
        ], [
        handleAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $bVAqi.default), {
        ...flexibleCardProps,
        testId: testId
    }, /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        testId: `${testId}-title`,
        className: (0, $hekY6.default)([
            "_zulpu2gc _13mh1pd9"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $hsIfr.default), null), /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $dM7c5.messages).connect_link_account_card_name,
        values: {
            context: providerName
        }
    })), /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        testId: `${testId}-content`,
        className: (0, $hekY6.default)([
            "_11c8wadc _19pku2gc"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", null, /*#__PURE__*/ $cozmU.createElement((0, $4bvRC.default), {
        providerName: providerName,
        isProductIntegrationSupported: isProductIntegrationSupported
    }))), /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        testId: `${testId}-button`,
        className: (0, $hekY6.default)([
            "_1bahesu3 _19pku2gc"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $3M4EV.default), {
        items: actions,
        appearance: "primary"
    })));
};
var $0784325f946f0262$export$2e2bcd8739ae039 = $0784325f946f0262$var$HoverCardUnauthorisedView;
module.exports["default"] = $0784325f946f0262$export$2e2bcd8739ae039;

});

parcelRegister("4bvRC", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ixfCV = parcelRequire("ixfCV");


var $7vK9E = parcelRequire("7vK9E");


var $6Vsq4 = parcelRequire("6Vsq4");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");

/**
 * This component is used in unauthorized views of a smart link.
 * It represents the main text that provides a user with information on how to connect their account
 */ const $c5ed75a9c5c2c5b7$var$UnauthorisedViewContent = ({ providerName: providerName, isProductIntegrationSupported: isProductIntegrationSupported, testId: testId = 'unauthorised-view-content' })=>{
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const handleLearnMoreClick = (0, $cozmU.useCallback)(()=>{
        fireEvent('ui.button.clicked.learnMore', {});
    }, [
        fireEvent
    ]);
    const learnMoreMessage = isProductIntegrationSupported ? (0, $ixfCV.fg)('product-terminology-refresh') ? (0, $dM7c5.messages).learn_more_about_connecting_account_appify : (0, $dM7c5.messages).learn_more_about_connecting_account : (0, $dM7c5.messages).learn_more_about_smart_links;
    const unauthorizedAccountDescriptionMessage = (0, $dM7c5.messages).learn_more_about_connecting_account_experiment_shorter;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, providerName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...unauthorizedAccountDescriptionMessage,
        values: {
            context: providerName
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $ixfCV.fg)('product-terminology-refresh') ? (0, $dM7c5.messages).connect_unauthorised_account_description_no_provider_appify : (0, $dM7c5.messages).connect_unauthorised_account_description_no_provider), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.default), {
        href: isProductIntegrationSupported ? (0, $4yYAm.CONTENT_URL_3P_ACCOUNT_AUTH) : (0, $4yYAm.CONTENT_URL_SECURITY_AND_PERMISSIONS),
        target: "_blank",
        testId: `${testId}-learn-more`,
        onClick: handleLearnMoreClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), learnMoreMessage)));
};
var $c5ed75a9c5c2c5b7$export$2e2bcd8739ae039 = $c5ed75a9c5c2c5b7$var$UnauthorisedViewContent;
module.exports["default"] = $c5ed75a9c5c2c5b7$export$2e2bcd8739ae039;

});

parcelRegister("8qkhz", function(module, exports) {
/* RovoUnauthorisedView.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $f0b2F = parcelRequire("f0b2F");


var $kTb7m = parcelRequire("kTb7m");


var $bLfHG = parcelRequire("bLfHG");


var $jawC3 = parcelRequire("jawC3");


var $NlHoa = parcelRequire("NlHoa");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $6Vsq4 = parcelRequire("6Vsq4");


var $4yYAm = parcelRequire("4yYAm");


var $dM7c5 = parcelRequire("dM7c5");


var $iUTeb = parcelRequire("iUTeb");


var $bVAqi = parcelRequire("bVAqi");


var $hsIfr = parcelRequire("hsIfr");


var $kyH4O = parcelRequire("kyH4O");

const $31dccf5742e9195b$var$ROVO_FEATURES = [
    {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))),
        message: (0, $dM7c5.messages).rovo_unauthorised_feature_clear_link_names,
        testIdSuffix: 'clear-link-names'
    },
    {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))),
        message: (0, $dM7c5.messages).rovo_unauthorised_feature_understand_linked_docs,
        testIdSuffix: 'understand-linked-docs'
    },
    {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bLfHG))),
        message: (0, $dM7c5.messages).rovo_unauthorised_feature_go_deeper_smart_suggestions,
        testIdSuffix: 'go-deeper-smart-suggestions'
    }
];
const $31dccf5742e9195b$var$sparkleWrapBase = null;
const $31dccf5742e9195b$var$sparkleLeftWrap = null;
const $31dccf5742e9195b$var$sparkleGreyRightWrap = null;
const $31dccf5742e9195b$var$sparkleVioletRightWrap = null;
const $31dccf5742e9195b$var$layoutStyles = {
    connectorStroke: "_syazi7uo _1e0c1txw _1o9zidpf",
    atlassianIconTile: "_2rko1mok _1e0c1txw _4cvr1h6o _1bah1h6o _1bsbzwfg _4t3izwfg _bfhk16e3",
    header: "_bfhkysee _ca0q1ejb _u5f3pxbi _n3tdutpp _19bvpxbi _13li1mok _qrwq1mok _kqswh2mm",
    headerGraphicRow: "_zulpu2gc _1e0c1txw _4cvr1h6o _1bah1h6o _otyrutpp",
    headerTitle: "_y3gn1h6o",
    body: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    featureIconCell: "_1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _1bsb7vkz",
    footer: "_zulputpp _19pkutpp _ca0q1b66 _1e0c1txw _4cvr1h6o _1bahesu3 _1n261g80"
};
const $31dccf5742e9195b$var$RovoUnauthorisedView = ({ id: id = '', flexibleCardProps: flexibleCardProps, onDismiss: onDismiss, testId: testId = 'hover-card-rovo-unauthorised-view', url: url })=>{
    const providerName = (0, $cozmU.useMemo)(()=>(0, $jawC3.extractSmartLinkProvider)(flexibleCardProps.cardState.details)?.text, [
        flexibleCardProps.cardState.details
    ]);
    const { authorize: authorize } = (0, $iUTeb.useSmartCardActions)(id, url);
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const handleAuthorize = (0, $cozmU.useCallback)(()=>{
        if (authorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            authorize((0, $4yYAm.CardDisplay).HoverCardPreview);
        }
    }, [
        authorize,
        fireEvent
    ]);
    const handleDismiss = (0, $cozmU.useCallback)(()=>{
        if (onDismiss) {
            fireEvent('ui.button.clicked.dismiss', {});
            onDismiss();
        }
    }, [
        fireEvent,
        onDismiss
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $bVAqi.default), {
        ...flexibleCardProps,
        testId: testId,
        ui: {
            hideElevation: true,
            hideBackground: true,
            removeBlockRestriction: true,
            hidePadding: true
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $31dccf5742e9195b$var$layoutStyles.header
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_1o9zidpf _1e0c1txw _kqswstnw",
            "_syaz4pcx _154i1ul9 _1ltv1v6z"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $kyH4O.DenseSparkle), null)), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_1o9zidpf _1e0c1txw _kqswstnw",
            "_syazwejn _154i1crf _1xi2qslr"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $kyH4O.SparseSparkle), null)), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_1o9zidpf _1e0c1txw _kqswstnw",
            "_syazuq3u _1bsbqslr _154i1ylp _1xi21v6z"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $kyH4O.DenseSparkle), null)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $31dccf5742e9195b$var$layoutStyles.headerGraphicRow
    }, /*#__PURE__*/ $cozmU.createElement((0, $hsIfr.default), {
        size: (0, $4yYAm.SmartLinkSize).Medium,
        isTiledIcon: true
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $31dccf5742e9195b$var$layoutStyles.connectorStroke
    }, /*#__PURE__*/ $cozmU.createElement((0, $kyH4O.SquiglyArrow), null)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $31dccf5742e9195b$var$layoutStyles.atlassianIconTile
    }, /*#__PURE__*/ $cozmU.createElement((0, $NlHoa.AtlassianIcon), {
        appearance: "inverse",
        size: "small"
    }))), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $31dccf5742e9195b$var$layoutStyles.headerTitle
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
        weight: "bold",
        size: "medium",
        color: "color.text"
    }, providerName ? /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $dM7c5.messages).rovo_unauthorised_title,
        values: {
            context: providerName
        }
    }) : /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).rovo_unauthorised_title_no_provider)))), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $31dccf5742e9195b$var$layoutStyles.body
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.default), {
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.default), {
        space: "space.200"
    }, $31dccf5742e9195b$var$ROVO_FEATURES.map((feature)=>{
        const FeatureIcon = feature.icon;
        return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
            key: feature.testIdSuffix,
            space: "space.150",
            alignBlock: "center",
            testId: `${testId}-feature-${feature.testIdSuffix}`
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: $31dccf5742e9195b$var$layoutStyles.featureIconCell
        }, /*#__PURE__*/ $cozmU.createElement(FeatureIcon, {
            label: ""
        })), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), null, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), feature.message)));
    })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $31dccf5742e9195b$var$layoutStyles.footer
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        spacing: "compact",
        onClick: handleDismiss,
        testId: `${testId}-not-now`
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).rovo_unauthorised_not_now)), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleAuthorize,
        testId: `${testId}-connect-account`
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).rovo_unauthorised_connect_account)))))));
};
var $31dccf5742e9195b$export$2e2bcd8739ae039 = $31dccf5742e9195b$var$RovoUnauthorisedView;
module.exports["default"] = $31dccf5742e9195b$export$2e2bcd8739ae039;

});

parcelRegister("kyH4O", function(module, exports) {
/* graphics.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");

const $0e7d7cec4114cdb4$export$eaa6832866c251cf = ()=>{
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        width: "33",
        height: "33",
        viewBox: "0 0 33 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "currentColor",
        d: "M 18.1377,8.5584 C 19.820521,9.7606431 19.569624,7.0234324 19.891314,6.0724492 20.627318,4.4834923 20.654624,2.6485663 20.986387,0.9358225 20.985763,-0.63106096 19.153938,0.29529924 19.30907,1.4628594 18.581402,3.0380165 18.941526,4.9281736 18.3064,6.59809 18.189624,7.241971 17.98497,7.9130416 18.1377,8.5584 Z M 14.048,8.62872 C 16.108587,8.8291383 14.519035,6.5848441 14.323941,5.6001158 14.16595,3.856369 13.270155,2.254813 12.701225,0.60606587 11.918719,-0.74933808 10.791962,0.96396467 11.513059,1.8973545 11.672048,3.6244988 12.925689,5.0825474 13.2127,6.8456 13.436435,7.4621245 13.581302,8.1376081 14.048,8.62872 Z M 10.5438,10.7324 C 12.427639,9.875884 9.9317744,8.7259408 9.2689606,7.9718267 8.2625,6.5396335 6.6886891,5.5966404 5.36875,4.4566662 4.0131223,3.6745583 3.8966957,5.7235932 4.9866023,6.1718516 5.9867147,7.5895644 7.8032328,8.2251817 8.93219,9.61022 9.4294433,10.031063 9.9148481,10.555839 10.5438,10.7324 Z M 8.55828,14.3099 C 9.7604964,12.627122 7.023384,12.877794 6.0723265,12.556262 4.4833477,11.820331 2.6484558,11.792914 0.93570025,11.461212 c -1.5668845,6.26e-4 -0.64052126,1.832452 0.52703915,1.677318 1.5751539,0.727694 3.4653396,0.36738 5.1352306,1.00267 0.6438861,0.116827 1.314933,0.321333 1.96031,0.1687 z m 0.07008,4.0894 C 8.828733,16.338698 6.5844599,17.928323 5.5997508,18.123433 3.8560002,18.281408 2.2543901,19.1771 0.60569938,19.746162 -0.74955704,20.529217 0.96332374,21.653982 1.8969889,20.93548 3.6240071,20.774217 5.0821994,19.522267 6.84523,19.2346 7.4618123,19.010984 8.1372369,18.866007 8.62836,18.3993 Z m 2.10414,3.5072 C 9.8760472,20.022637 8.7260556,22.518484 7.9719398,23.181273 6.5393153,24.18655 5.6000777,25.76278 4.4595963,27.081513 3.6775168,28.437135 5.7265095,28.553572 6.1747816,27.463666 7.5925047,26.463552 8.2280912,24.647029 9.61315,23.5181 c 0.418283,-0.497326 0.951352,-0.985318 1.11935,-1.6116 z m 3.5775,1.9828 c -1.682815,-1.202255 -1.431924,1.534991 -1.753614,2.485976 -0.736023,1.588942 -0.763314,3.423872 -1.095073,5.136612 6.39e-4,1.566887 1.832425,0.640518 1.677317,-0.527032 0.727655,-1.57517 0.367555,-3.465328 1.00267,-5.135256 0.116772,-0.64388 0.321426,-1.314917 0.1687,-1.9603 z m 4.0891,-0.0702 c -2.060649,-0.200406 -0.470945,2.043891 -0.275873,3.028605 0.157937,1.743716 1.053669,3.345319 1.622686,4.994007 0.782496,1.355437 1.909207,-0.357878 1.188142,-1.291274 C 20.77504,28.823312 19.521385,27.365256 19.2344,25.6022 19.010647,24.985692 18.865809,24.310193 18.3991,23.8191 Z m 3.5074,-2.1038 c -1.88386,0.856461 0.611976,2.006423 1.274773,2.760542 1.006466,1.432207 2.580314,2.375182 3.90024,3.515183 1.355682,0.782012 1.472001,-1.26689 0.382153,-1.715209 C 26.463526,24.858147 24.647022,24.222555 23.5181,22.8375 23.02082,22.416678 22.53553,21.891757 21.9065,21.7153 Z m 1.9826,-3.5775 c -1.202233,1.682763 1.53485,1.432123 2.485905,1.753638 1.588978,0.735928 3.423859,0.763338 5.136608,1.095049 1.566893,-5.94e-4 0.640594,-1.832443 -0.527,-1.677317 C 29.409454,18.581486 27.519286,18.941792 25.8494,18.3065 25.205557,18.189667 24.534178,17.985164 23.8891,18.1378 Z m -0.0704,-4.0894 c -0.200405,2.06064 2.043899,0.470968 3.028605,0.275867 1.743759,-0.15797 3.345359,-1.053678 4.994083,-1.622679 1.355308,-0.782551 -0.357965,-1.909199 -1.29135,-1.188185 -1.727151,0.159054 -3.185218,1.412574 -4.948238,1.699697 -0.616574,0.223619 -1.291971,0.368616 -1.7831,0.8353 z M 21.7152,10.544 c 0.85645,1.88385 2.006449,-0.6119565 2.760542,-1.2747918 1.432624,-1.0052563 2.371905,-2.581444 3.512333,-3.9002107 C 28.770204,4.0133778 26.721159,3.8969258 26.272916,4.986848 24.855171,5.9869493 24.21954,7.8034667 22.8345,8.93243 22.416234,9.4297408 21.883198,9.917751 21.7152,10.544 Z"
    }));
};
const $0e7d7cec4114cdb4$export$d4cc5913ef36e057 = ()=>{
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        width: "35",
        height: "34",
        viewBox: "0 0 35 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "currentColor",
        d: "m 21.4614,9.02651 c 1.774882,1.267966 1.510442,-1.6188099 1.849578,-2.6219063 0.776223,-1.6758612 0.805105,-3.61111 1.154947,-5.41753458 C 24.447185,-0.68027653 22.513317,0.28790594 22.69688,1.5429258 21.929419,3.2042498 22.309243,5.1977402 21.6394,6.95899 21.51609,7.6380728 21.300546,8.3458903 21.4614,9.02651 Z m -9.1629,0.611 C 14.479174,9.6115402 12.55696,7.4386694 12.239238,6.4296801 11.873994,4.6211661 10.751762,3.0453042 9.9684287,1.3818975 9.0519692,0.02745097 7.9717763,1.9817201 8.8672911,2.872095 9.2298246,4.664959 10.714117,6.0484595 11.2158,7.86365 c 0.30309,0.6222222 0.536236,1.3131609 1.0827,1.77386 z M 9.02651,14.4282 c 1.267976,-1.774848 -1.6188386,-1.510386 -2.6219063,-1.849578 -1.6758612,-0.776223 -3.61111,-0.805105 -5.41753458,-1.154947 -1.66734565,0.01874 -0.69916318,1.952608 0.55585668,1.769045 1.661324,0.767461 3.6548144,0.387637 5.4160642,1.05748 0.6790828,0.12331 1.3869003,0.338854 2.06752,0.178 z m 0.79812,7.0123 C 9.6506342,19.264889 7.6156756,21.33182 6.6290172,21.715218 4.8462675,22.200193 3.3480398,23.427583 1.7425513,24.327425 0.48184315,25.389439 2.4687817,26.243895 3.3047292,25.323131 5.0679233,24.838194 6.3485808,23.265036 8.1279,22.6448 8.727623,22.296964 9.4030508,22.019757 9.82463,21.4405 Z m 4.60367,2.4235 c -1.774857,-1.267999 -1.510322,1.618845 -1.849554,2.621865 -0.776222,1.675869 -0.805026,3.611122 -1.154946,5.417535 0.01882,1.667361 1.952587,0.699167 1.769034,-0.555848 0.767463,-1.661311 0.387597,-3.654815 1.057466,-5.416052 0.123252,-0.679055 0.338956,-1.387036 0.178,-2.0675 z m 5.9772,0.261 c -2.173333,-0.211383 -0.496768,2.155705 -0.291021,3.19429 0.166568,1.839106 1.111399,3.528228 1.711458,5.267122 0.84816,1.433261 2.042749,-0.366933 1.253122,-1.36187 C 22.911487,29.402909 21.589251,27.865123 21.2864,26.0057 21.05053,25.355401 20.897759,24.642984 20.4055,24.125 Z m 4.3514,-4.2566 c -1.918413,1.03763 0.793683,2.065164 1.542216,2.81224 1.163691,1.434148 2.891651,2.307238 4.359284,3.41661 1.503797,0.716781 1.491809,-1.445265 0.281572,-1.83218 C 29.783911,22.847779 27.827538,22.311391 26.5397,20.9362 25.981077,20.526301 25.453402,20.026312 24.7569,19.8684 Z m 0.2667,-6.5645 c -0.61356,2.094147 2.024993,0.892339 3.082584,0.881972 1.837741,0.184903 3.674321,-0.429733 5.494903,-0.694759 1.566146,-0.568664 0.02093,-2.078292 -1.105917,-1.48934 -1.8201,-0.172658 -3.577509,0.836398 -5.46037,0.783027 -0.682737,0.109486 -1.416687,0.125746 -2.0112,0.5191 z"
    }));
};
const $0e7d7cec4114cdb4$export$940e84768143d382 = ()=>{
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        width: "31",
        height: "21",
        viewBox: "0 0 31 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "currentColor",
        d: "M 21.853446,0.12040609 C 20.167706,1.2017532 24.715673,2.4997309 25.755055,3.0673371 25.02723,3.2209011 21.984019,3.856737 20.991485,3.9633568 16.045179,5.5890307 11.446918,7.8287185 9.1072914,12.742806 7.8983204,12.284216 5.7117383,11.960731 4.1643839,12.645906 2.2323901,13.501397 0.58356937,15.13985 0.06015349,17.184987 0.06666279,19.997869 1.7741124,16.035826 2.7542112,15.14763 c 1.6305676,-1.477671 4.7339707,-2.002323 5.8717147,-1.083896 -0.6742412,2.17406 -0.7914961,6.013849 1.8803011,6.750565 2.072285,0.571408 3.768061,-1.977378 2.786707,-4.245231 C 12.524186,14.792533 11.187386,13.937797 10.469825,13.425746 12.484573,8.4842061 19.328854,5.5947574 24.21859,4.6647774 25.288915,4.5397793 29.069777,3.0700705 27.388804,4.826459 26.472831,6.3589647 23.793814,8.1658647 23.628028,9.0737265 23.1618,11.626835 26.092344,8.4605266 26.699318,7.7349157 27.826169,6.2825775 29.856947,4.4211835 30.479445,3.5562506 28.766042,2.8991905 26.575439,1.3555612 24.569756,0.89998649 23.662177,0.65006782 22.790889,0.24992986 21.853446,0.12040609 Z M 9.9983561,14.652336 C 11.498101,15.3957 13.411213,18.565161 11.127761,19.347839 9.1996093,18.911365 9.5916528,16.22149 9.9983561,14.652336 Z"
    }));
};
module.exports["DenseSparkle"] = $0e7d7cec4114cdb4$export$eaa6832866c251cf;
module.exports["SparseSparkle"] = $0e7d7cec4114cdb4$export$d4cc5913ef36e057;
module.exports["SquiglyArrow"] = $0e7d7cec4114cdb4$export$940e84768143d382;

});

parcelRegister("4JCld", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $3tPPd = parcelRequire("3tPPd");

const $8721fcf90b86ff31$var$styles = null; /**
                      * An anchor component to cover the entire container creating a clickable area.
                      * @internal
                      * @see `clickableContainer`
                      */ 
const $8721fcf90b86ff31$var$LayeredLink = ({ onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, target: target, testId: testId, text: text, url: url })=>{
    const onMouseDown = (0, $3tPPd.useMouseDownEvent)();
    return /*#__PURE__*/ $cozmU.createElement("a" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _azhw1osq _o5721q9c _hboxstnw _obkmidpf _a52dkb7n",
            "layered-link"
        ]),
        "data-testid": `${testId}-layered-link`,
        href: url,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        onMouseDown: onMouseDown,
        target: target
    }, text);
};
var $8721fcf90b86ff31$export$2e2bcd8739ae039 = $8721fcf90b86ff31$var$LayeredLink;
module.exports["default"] = $8721fcf90b86ff31$export$2e2bcd8739ae039;

});

parcelRegister("jKbUI", function(module, exports) {

var $jawC3 = parcelRequire("jawC3");


var $ixfCV = parcelRequire("ixfCV");


var $4yYAm = parcelRequire("4yYAm");


var $leSBv = parcelRequire("leSBv");


var $iCudX = parcelRequire("iCudX");


var $emAbv = parcelRequire("emAbv");


var $iRL51 = parcelRequire("iRL51");


var $eSImY = parcelRequire("eSImY");


var $fBEPJ = parcelRequire("fBEPJ");


var $7UwLu = parcelRequire("7UwLu");


var $eeqm3 = parcelRequire("eeqm3");


var $dM7c5 = parcelRequire("dM7c5");


var $16kNn = parcelRequire("16kNn");


var $8p295 = parcelRequire("8p295");

const $93d7982fee1bd82d$export$e68aec76e359e401 = (params)=>{
    const { onClick: onClick, response: response, status: status, url: url } = params ?? {};
    switch(status){
        case (0, $4yYAm.SmartLinkStatus).Pending:
        case (0, $4yYAm.SmartLinkStatus).Resolving:
            return {
                linkTitle: (0, $emAbv.default)(status, url, response, onClick),
                url: url
            };
        case (0, $4yYAm.SmartLinkStatus).Resolved:
            return (0, $iCudX.default)(params);
        case (0, $4yYAm.SmartLinkStatus).Unauthorized:
        case (0, $4yYAm.SmartLinkStatus).Forbidden:
        case (0, $4yYAm.SmartLinkStatus).NotFound:
        case (0, $4yYAm.SmartLinkStatus).Errored:
        case (0, $4yYAm.SmartLinkStatus).Fallback:
        default:
            return {
                url: url,
                linkIcon: (0, $fBEPJ.extractErrorIcon)(response, status),
                linkTitle: (0, $emAbv.default)(status, url, response, onClick),
                preview: (0, $iRL51.extractSmartLinkPreviewImage)(response),
                provider: (0, $ixfCV.fg)('platform_sl_google_rebrand') ? (0, $eSImY.default)(response) : (0, $7UwLu.extractSmartLinkProviderIcon)(response),
                actions: {
                    [(0, $4yYAm.InternalActionName).UnresolvedAction]: $93d7982fee1bd82d$export$f3d3482baaff4bf6(url, status, response, params.onAuthorize)
                },
                meta: {
                    accessType: response?.meta?.requestAccess?.accessType
                },
                hostName: (0, $eeqm3.extractHostName)(response)
            };
    }
};
const $93d7982fee1bd82d$var$getForbiddenMessageKey = (meta)=>{
    const accessType = meta?.requestAccess?.accessType;
    switch(accessType){
        case 'DIRECT_ACCESS':
            return (0, $ixfCV.fg)('confluence-issue-terminology-refresh') ? 'join_to_viewIssueTermRefresh' : 'join_to_view';
        case 'REQUEST_ACCESS':
            return (0, $ixfCV.fg)('confluence-issue-terminology-refresh') ? 'request_access_to_viewIssueTermRefresh' : 'request_access_to_view';
        case 'PENDING_REQUEST_EXISTS':
            return 'pending_request';
        case 'FORBIDDEN':
            return 'forbidden_access';
        case 'DENIED_REQUEST_EXISTS':
            return 'request_denied';
        default:
            return 'restricted_link';
    }
};
const $93d7982fee1bd82d$export$f3d3482baaff4bf6 = (url, status, response, onAuthorize)=>{
    const provider = (0, $jawC3.extractSmartLinkProvider)(response);
    const context = provider?.text;
    const values = context ? {
        context: context
    } : undefined;
    switch(status){
        case (0, $4yYAm.SmartLinkStatus).Forbidden:
            const meta = response?.meta ?? (0, $8p295.getForbiddenJsonLd)().meta;
            const access = (0, $leSBv.extractRequestAccessContextImproved)({
                jsonLd: meta,
                url: url,
                product: context ?? ''
            });
            const messageKey = $93d7982fee1bd82d$var$getForbiddenMessageKey(meta);
            const descriptor = (0, $dM7c5.messages)[messageKey];
            const retry = onAuthorize || access?.action?.promise;
            const onClick = retry && !(access?.buttonDisabled ?? false) ? (0, $16kNn.handleOnClick)(retry) : undefined;
            return {
                descriptor: descriptor,
                onClick: onClick,
                values: values
            };
        case (0, $4yYAm.SmartLinkStatus).Unauthorized:
            return onAuthorize ? {
                descriptor: (0, $dM7c5.messages).connect_link_account_card_name,
                onClick: (0, $16kNn.handleOnClick)(onAuthorize),
                values: values
            } : undefined;
        case (0, $4yYAm.SmartLinkStatus).NotFound:
            return {
                descriptor: (0, $dM7c5.messages).cannot_find_link
            };
    }
};
module.exports["getContextByStatus"] = $93d7982fee1bd82d$export$e68aec76e359e401;

});

parcelRegister("iCudX", function(module, exports) {

var $jawC3 = parcelRequire("jawC3");


var $ixfCV = parcelRequire("ixfCV");


var $39PqP = parcelRequire("39PqP");


var $4omKw = parcelRequire("4omKw");


var $6hJQj = parcelRequire("6hJQj");


var $emAbv = parcelRequire("emAbv");


var $iRL51 = parcelRequire("iRL51");


var $k8KyO = parcelRequire("k8KyO");


var $eSImY = parcelRequire("eSImY");


var $igQUs = parcelRequire("igQUs");


var $fBEPJ = parcelRequire("fBEPJ");


var $7UwLu = parcelRequire("7UwLu");


var $hYTxH = parcelRequire("hYTxH");


var $eeqm3 = parcelRequire("eeqm3");

const $3e8bfec00ff792aa$var$extractFlexibleUiContext = ({ appearance: appearance, fireEvent: fireEvent, id: id, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, origin: origin, product: product, resolve: resolve, rovoConfig: rovoConfig, actionOptions: actionOptions, response: response, status: status, aiSummaryConfig: aiSummaryConfig, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel, transformUrl: transformUrl, ...props } = {})=>{
    if (!response) return undefined;
    const data = response.data;
    const meta = response.meta;
    const url = (0, $jawC3.extractSmartLinkUrl)(response);
    return {
        actions: (0, $4omKw.extractFlexibleCardActions)({
            actionOptions: actionOptions,
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            product: product,
            rovoConfig: rovoConfig,
            response: response,
            url: props.url,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel,
            ...(0, $ixfCV.fg)('platform_smartlink_xpc_url_wrapping') ? {
                transformUrl: transformUrl
            } : undefined
        }),
        appliedToComponentsCount: (0, $eeqm3.extractAppliedToComponentsCount)(data),
        assignedToGroup: (0, $eeqm3.extractPersonAssignedToAsArray)(data),
        attachmentCount: (0, $eeqm3.extractAttachmentCount)(data),
        authorGroup: (0, $jawC3.extractSmartLinkAuthorGroup)(response),
        ownedByGroup: (0, $jawC3.extractPersonOwnedBy)(data),
        collaboratorGroup: (0, $6hJQj.extractPersonsUpdatedBy)(data),
        commentCount: (0, $eeqm3.extractSmartLinkCommentCount)(response),
        viewCount: (0, $eeqm3.extractViewCount)(data),
        reactCount: (0, $eeqm3.extractSmartLinkReactCount)(response),
        voteCount: (0, $eeqm3.extractVoteCount)(data),
        checklistProgress: (0, $eeqm3.extractChecklistProgress)(data),
        createdBy: (0, $jawC3.extractSmartLinkCreatedBy)(response),
        ownedBy: (0, $eeqm3.extractOwnedBy)(data),
        assignedTo: (0, $eeqm3.extractAssignedTo)(data),
        createdOn: (0, $jawC3.extractSmartLinkCreatedOn)(response),
        dueOn: (0, $eeqm3.extractDueOn)(data),
        latestCommit: (0, $hYTxH.extractLatestCommit)(data),
        linkIcon: (0, $fBEPJ.extractSmartLinkIcon)(response),
        linkTitle: (0, $emAbv.default)(status, props.url, response, onClick, onAuxClick, onContextMenu),
        location: (0, $eeqm3.extractLocation)(data),
        modifiedBy: (0, $jawC3.extractSmartLinkModifiedBy)(response),
        modifiedOn: (0, $jawC3.extractSmartLinkModifiedOn)(response),
        preview: (0, $iRL51.extractSmartLinkPreviewImage)(response),
        priority: (0, $k8KyO.default)(data),
        provider: (0, $ixfCV.fg)('platform_sl_google_rebrand') ? (0, $eSImY.default)(response) : (0, $7UwLu.extractSmartLinkProviderIcon)(response),
        programmingLanguage: (0, $eeqm3.extractProgrammingLanguage)(data),
        readTime: (0, $eeqm3.extractReadTime)(data),
        sentOn: (0, $eeqm3.extractSmartLinkSentOn)(response),
        snippet: (0, $39PqP.extractSmartLinkSummary)(response) || undefined,
        sourceBranch: (0, $eeqm3.extractSourceBranch)(data),
        state: (0, $igQUs.default)(response, actionOptions, id, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel, (0, $ixfCV.fg)('platform_smartlink_xpc_url_wrapping') ? transformUrl : undefined),
        subscriberCount: (0, $eeqm3.extractSubscriberCount)(data),
        subTasksProgress: (0, $eeqm3.extractSubTasksProgress)(data),
        storyPoints: (0, $eeqm3.extractStoryPoints)(data),
        targetBranch: (0, $eeqm3.extractTargetBranch)(data),
        userAttributes: (0, $eeqm3.extractUserAttributes)(data),
        teamMemberCount: (0, $eeqm3.extractTeamMemberCount)(data),
        url: url,
        ari: (0, $jawC3.extractSmartLinkAri)(response),
        type: (0, $jawC3.extractType)(data),
        meta: {
            objectId: (0, $eeqm3.extractMetaObjectId)(meta),
            resourceType: (0, $eeqm3.extractMetaResourceType)(meta),
            tenantId: (0, $eeqm3.extractMetaTenantId)(meta)
        },
        hostName: (0, $eeqm3.extractHostName)(response)
    };
};
var $3e8bfec00ff792aa$export$2e2bcd8739ae039 = $3e8bfec00ff792aa$var$extractFlexibleUiContext;
module.exports["default"] = $3e8bfec00ff792aa$export$2e2bcd8739ae039;

});

parcelRegister("39PqP", function(module, exports) {

var $jawC3 = parcelRequire("jawC3");

const $0c0165a0a1a1634a$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof jsonLd?.summary === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
};
const $0c0165a0a1a1634a$export$8c6b9b49f358840 = (response)=>{
    if ((0, $jawC3.isEntityPresent)(response)) return (0, $jawC3.extractEntity)(response)?.description;
    return response?.data && $0c0165a0a1a1634a$export$db5a8500f6b6286e(response.data);
};
module.exports["extractSmartLinkSummary"] = $0c0165a0a1a1634a$export$8c6b9b49f358840;

});

parcelRegister("4omKw", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $4yYAm = parcelRequire("4yYAm");


var $6xM6r = parcelRequire("6xM6r");


var $jMbWL = parcelRequire("jMbWL");


var $fYH1Q = parcelRequire("fYH1Q");


var $524Ey = parcelRequire("524Ey");


var $h8eRG = parcelRequire("h8eRG");


var $hb494 = parcelRequire("hb494");


var $irGZZ = parcelRequire("irGZZ");


var $78FxT = parcelRequire("78FxT");

const $33660386a90b3130$export$abe8d0ca1daa1755 = ({ actionOptions: actionOptions, aiSummaryConfig: aiSummaryConfig, appearance: appearance, fireEvent: fireEvent, id: id, origin: origin, product: product, response: response, rovoConfig: rovoConfig, transformUrl: transformUrl, url: url, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel })=>{
    const action = {
        [(0, $4yYAm.ActionName).CopyLinkAction]: (0, $fYH1Q.extractCopyLinkClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $4yYAm.ActionName).DownloadAction]: (0, $524Ey.extractDownloadClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $4yYAm.ActionName).FollowAction]: (0, $h8eRG.default)(response, actionOptions, id),
        [(0, $4yYAm.ActionName).PreviewAction]: (0, $hb494.extractPreviewClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel,
            ...(0, $ixfCV.fg)('platform_smartlink_xpc_url_wrapping') ? {
                transformUrl: transformUrl
            } : undefined
        }),
        [(0, $4yYAm.ActionName).AutomationAction]: (0, $jMbWL.extractAutomationAction)(response),
        [(0, $4yYAm.InternalActionName).AISummaryAction]: (0, $6xM6r.extractAISummaryAction)(response, url, actionOptions, aiSummaryConfig),
        [(0, $4yYAm.ActionName).RovoChatAction]: (0, $irGZZ.default)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            product: product,
            response: response,
            rovoConfig: rovoConfig
        }),
        [(0, $4yYAm.InternalActionName).ViewRelatedLinksAction]: (0, $78FxT.extractViewRelatedLinksAction)(response)
    };
    return Object.values(action).some((value)=>Boolean(value)) ? action : undefined;
};
module.exports["extractFlexibleCardActions"] = $33660386a90b3130$export$abe8d0ca1daa1755;

});

parcelRegister("6xM6r", function(module, exports) {

var $4yYAm = parcelRequire("4yYAm");


var $98Ma9 = parcelRequire("98Ma9");


var $lOOiS = parcelRequire("lOOiS");

const $df0652b82bcf79d1$export$e7f7a50a8b8932df = (response, url, actionOptions, aiSummaryConfig)=>{
    if (!(0, $98Ma9.canShowAction)((0, $4yYAm.CardAction).AISummaryAction, actionOptions) || !(0, $lOOiS.getIsAISummaryEnabled)(aiSummaryConfig?.isAdminHubAIEnabled, response) || !url) return;
    return {
        url: url
    };
};
module.exports["extractAISummaryAction"] = $df0652b82bcf79d1$export$e7f7a50a8b8932df;

});

parcelRegister("98Ma9", function(module, exports) {
const $0142dd557f1abf4d$export$2487b058456cca75 = (action, actionOptions)=>{
    if (typeof actionOptions === 'undefined') return true;
    if (actionOptions.hide || actionOptions.exclude?.includes(action)) return false;
    return true;
};
module.exports["canShowAction"] = $0142dd557f1abf4d$export$2487b058456cca75;

});

parcelRegister("jMbWL", function(module, exports) {

var $4yYAm = parcelRequire("4yYAm");

const $2292e96bf8ec69a8$export$f913cc6abf3ec084 = (response)=>{
    if (!response.data) return undefined;
    if (!response?.meta?.supportedFeature?.includes((0, $4yYAm.ActionName).AutomationAction)) return undefined;
    const data = response.data;
    const meta = response.meta;
    const { name: name, 'atlassian:ari': objectAri } = data;
    const { product: product, tenantId: tenantId, resourceType: resourceType } = meta;
    return {
        product: product,
        resourceType: resourceType,
        siteAri: `ari:cloud:${product}::site/${tenantId}`,
        objectName: name,
        objectAri: objectAri,
        // TODO: The admin experience will be a follow up
        canManageAutomation: false,
        baseAutomationUrl: '',
        analyticsSource: 'smartCardAutomationAction'
    };
};
module.exports["extractAutomationAction"] = $2292e96bf8ec69a8$export$f913cc6abf3ec084;

});

parcelRegister("fYH1Q", function(module, exports) {

var $bVyUW = parcelRequire("bVyUW");

const $430f851bfe7512e2$export$31ddd5c40039ce53 = (param)=>{
    const invokeAction = (0, $bVyUW.extractInvokeCopyLinkAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};
module.exports["extractCopyLinkClientAction"] = $430f851bfe7512e2$export$31ddd5c40039ce53;

});

parcelRegister("bVyUW", function(module, exports) {

var $jawC3 = parcelRequire("jawC3");


var $4yYAm = parcelRequire("4yYAm");





var $2Q7sv = parcelRequire("2Q7sv");


var $98Ma9 = parcelRequire("98Ma9");

const $44f9f0e7452f446b$export$5ec86886067a062d = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $98Ma9.canShowAction)((0, $4yYAm.CardAction).CopyLinkAction, actionOptions)) return;
    const url = (0, $jawC3.extractSmartLinkUrl)(response);
    if (!url) return;
    return {
        actionFn: async ()=>navigator.clipboard.writeText(url),
        actionSubjectId: 'copyLink',
        actionType: (0, $4yYAm.ActionName).CopyLinkAction,
        definitionId: (0, $2Q7sv.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $2Q7sv.getExtensionKey)(response),
        id: id,
        resourceType: (0, $2Q7sv.getResourceType)(response)
    };
};
module.exports["extractInvokeCopyLinkAction"] = $44f9f0e7452f446b$export$5ec86886067a062d;

});

parcelRegister("524Ey", function(module, exports) {

var $apFwO = parcelRequire("apFwO");

const $4623e5e8ceeb2845$export$f6c386869a352b1f = (param)=>{
    const invokeAction = (0, $apFwO.extractInvokeDownloadAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};
module.exports["extractDownloadClientAction"] = $4623e5e8ceeb2845$export$f6c386869a352b1f;

});

parcelRegister("apFwO", function(module, exports) {

var $jawC3 = parcelRequire("jawC3");


var $4yYAm = parcelRequire("4yYAm");





var $2Q7sv = parcelRequire("2Q7sv");


var $16kNn = parcelRequire("16kNn");


var $98Ma9 = parcelRequire("98Ma9");


var $aTUup = parcelRequire("aTUup");

const $60e6e59f530d86aa$export$ea97cd34c2ca86de = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $98Ma9.canShowAction)((0, $4yYAm.CardAction).DownloadAction, actionOptions)) return;
    const data = response.data;
    const downloadActionExists = (0, $aTUup.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'DownloadAction');
    if (downloadActionExists) {
        const downloadUrl = (0, $jawC3.extractSmartLinkDownloadUrl)(response);
        return {
            actionFn: async ()=>(0, $16kNn.downloadUrl)(downloadUrl),
            actionSubjectId: 'downloadDocument',
            actionType: (0, $4yYAm.ActionName).DownloadAction,
            definitionId: (0, $2Q7sv.getDefinitionId)(response),
            display: appearance,
            extensionKey: (0, $2Q7sv.getExtensionKey)(response),
            id: id,
            resourceType: (0, $2Q7sv.getResourceType)(response)
        };
    }
};
module.exports["extractInvokeDownloadAction"] = $60e6e59f530d86aa$export$ea97cd34c2ca86de;

});

parcelRegister("aTUup", function(module, exports) {
const $817aefb3251744bd$export$8f031784a3a03b23 = (jsonLd)=>{
    let actions = jsonLd && jsonLd['schema:potentialAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) actions = [
        actions
    ];
    return actions;
};
module.exports["getActionsFromJsonLd"] = $817aefb3251744bd$export$8f031784a3a03b23;

});

parcelRegister("h8eRG", function(module, exports) {

var $jawC3 = parcelRequire("jawC3");


var $eWtDJ = parcelRequire("eWtDJ");


var $4yYAm = parcelRequire("4yYAm");


var $2Q7sv = parcelRequire("2Q7sv");


var $98Ma9 = parcelRequire("98Ma9");


var $dz3ZB = parcelRequire("dz3ZB");

const $6454219eec79705b$var$extractFollowAction = (response, actionOptions, id)=>{
    if (!(0, $98Ma9.canShowAction)((0, $4yYAm.CardAction).FollowAction, actionOptions)) return;
    const extensionKey = (0, $2Q7sv.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $dz3ZB.default)(data);
    const type = (0, $jawC3.extractType)(data);
    const isProject = type?.includes('atlassian:Project');
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>{
        if (item?.name === 'UpdateAction') {
            const actionName = item?.dataUpdateAction?.name;
            return actionName === (0, $eWtDJ.SmartLinkActionType).FollowEntityAction || actionName === (0, $eWtDJ.SmartLinkActionType).UnfollowEntityAction;
        }
        return false;
    });
    if (!action || !action.resourceIdentifiers) return;
    const url = (0, $jawC3.extractLink)(data);
    const reload = url ? {
        id: id,
        url: url
    } : undefined;
    const actionType = action.dataUpdateAction?.name;
    return {
        action: {
            action: {
                actionType: actionType,
                resourceIdentifiers: action.resourceIdentifiers
            },
            providerKey: extensionKey,
            reload: reload
        },
        value: actionType === (0, $eWtDJ.SmartLinkActionType).FollowEntityAction,
        isProject: isProject
    };
};
var $6454219eec79705b$export$2e2bcd8739ae039 = $6454219eec79705b$var$extractFollowAction;
module.exports["default"] = $6454219eec79705b$export$2e2bcd8739ae039;

});

parcelRegister("dz3ZB", function(module, exports) {
const $2b685e3fe936bab8$var$extractServerAction = (data)=>{
    const actions = data?.['atlassian:serverAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) return [
        actions
    ];
    return actions;
};
var $2b685e3fe936bab8$export$2e2bcd8739ae039 = $2b685e3fe936bab8$var$extractServerAction;
module.exports["default"] = $2b685e3fe936bab8$export$2e2bcd8739ae039;

});

parcelRegister("hb494", function(module, exports) {

var $jINxM = parcelRequire("jINxM");

const $2efe6a41c82eedcb$export$9f0d9100b079448 = (param)=>{
    const result = (0, $jINxM.extractInvokePreviewAction)(param);
    return result ? result : undefined;
};
module.exports["extractPreviewClientAction"] = $2efe6a41c82eedcb$export$9f0d9100b079448;

});

parcelRegister("jINxM", function(module, exports) {

var $jawC3 = parcelRequire("jawC3");


var $4aczz = parcelRequire("4aczz");


var $ieeJu = parcelRequire("ieeJu");


var $4yYAm = parcelRequire("4yYAm");





var $2Q7sv = parcelRequire("2Q7sv");


var $98Ma9 = parcelRequire("98Ma9");


var $01k3g = parcelRequire("01k3g");


var $1qrkW = parcelRequire("1qrkW");


var $a3jaM = parcelRequire("a3jaM");


var $fBEPJ = parcelRequire("fBEPJ");


var $apFwO = parcelRequire("apFwO");


var $2FmJb = parcelRequire("2FmJb");

const $ef64dce8a68d6434$export$caf83f49e52ac0bb = (param)=>{
    const { actionOptions: actionOptions, appearance: display, fireEvent: fireEvent, onClose: onClose, id: id, origin: origin, response: response, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = param;
    const ari = (0, $jawC3.extractSmartLinkAri)(response);
    const url = (0, $jawC3.extractSmartLinkUrl)(response);
    const name = (0, $jawC3.extractSmartLinkTitle)(response);
    const hasPreviewPanelParams = Boolean((0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && isPreviewPanelAvailable && openPreviewPanel && ari && url && name);
    const hasPreviewPanel = hasPreviewPanelParams && isPreviewPanelAvailable({
        ari: ari
    });
    const isInPreviewPanel = (0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && (0, $4aczz.isWithinPreviewPanelIFrame)();
    const data = response.data;
    const meta = response.meta;
    if (!(0, $98Ma9.canShowAction)((0, $4yYAm.CardAction).PreviewAction, actionOptions)) return;
    /* Analytics UI event for preview action created to support tracking of preview actions as the experiment rolls out */ const firePreviewActionUIEvent = ({ previewType: previewType })=>{
        if (!(0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') || origin !== 'smartLinkPreviewHoverCard' || !fireEvent) return;
        fireEvent('ui.smartLink.clicked.previewHoverCard', {
            id: id || '',
            display: 'hoverCardPreview',
            previewType: previewType
        });
    };
    const src = (0, $jawC3.extractPreview)(data, 'web')?.src;
    // disallow preview modals within preview panels
    if (!hasPreviewPanel && isInPreviewPanel) return;
    if (src) {
        const extensionKey = (0, $2Q7sv.getExtensionKey)(response);
        return {
            hasPreviewPanel: hasPreviewPanel,
            invokeAction: {
                actionFn: async ()=>{
                    if (hasPreviewPanel) {
                        let resolvedUrl = url;
                        if ((0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test')) {
                            const responseUrl = response.data && 'url' in response.data ? response.data.url : undefined;
                            resolvedUrl = responseUrl || url;
                        }
                        openPreviewPanel({
                            ari: ari,
                            url: resolvedUrl,
                            name: name,
                            iconUrl: undefined,
                            panelData: {
                                embedUrl: (0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (0, $jawC3.extractSmartLinkEmbed)(response)?.src : undefined
                            }
                        });
                        (0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && firePreviewActionUIEvent({
                            previewType: 'panel'
                        });
                    } else {
                        await (0, $01k3g.openEmbedModal)({
                            fireEvent: fireEvent,
                            extensionKey: extensionKey,
                            id: id,
                            invokeDownloadAction: (0, $apFwO.extractInvokeDownloadAction)(param),
                            invokeViewAction: (0, $2FmJb.extractInvokeViewAction)(param, true),
                            isSupportTheming: (0, $1qrkW.extractIsSupportTheming)(meta),
                            isTrusted: (0, $a3jaM.extractIsTrusted)(meta),
                            linkIcon: (0, $fBEPJ.extractLinkIcon)(response),
                            providerName: (0, $jawC3.extractSmartLinkProvider)(response)?.text,
                            onClose: onClose,
                            origin: origin,
                            src: (0, $jawC3.extractSmartLinkEmbed)(response)?.src,
                            title: (0, $jawC3.extractSmartLinkTitle)(response),
                            url: url,
                            size: actionOptions?.previewAction?.size,
                            isBlanketHidden: actionOptions?.previewAction?.hideBlanket,
                            ...(0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && {
                                isInPreviewPanel: isInPreviewPanel
                            }
                        });
                        (0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && firePreviewActionUIEvent({
                            previewType: 'modal'
                        });
                    }
                },
                actionSubjectId: 'invokePreviewScreen',
                actionType: (0, $4yYAm.ActionName).PreviewAction,
                display: display,
                extensionKey: extensionKey,
                id: id
            }
        };
    }
};
module.exports["extractInvokePreviewAction"] = $ef64dce8a68d6434$export$caf83f49e52ac0bb;

});

parcelRegister("4aczz", function(module, exports) {
/**
 * Utility functions for detecting iframe and preview panel contexts.
 * These utilities help components determine if they're running inside an iframe
 * or within a preview panel context.
 */ const $9b81732d1a3b5b72$var$PREVIEW_PANEL_INDICATORS = {
    EMBEDDED_SOURCE: 'embeddedConfluenceSource',
    PREVIEW_PANELS: 'previewPanels',
    CONFLUENCE_PAGE_PREVIEW: 'confluence-page-preview-panel'
};
const $9b81732d1a3b5b72$var$getUrlSearchParams = (url)=>{
    try {
        return new URLSearchParams(url);
    } catch  {
        return null;
    }
};
const $9b81732d1a3b5b72$var$hasPreviewPanelIndicators = (searchParams)=>{
    return searchParams.has($9b81732d1a3b5b72$var$PREVIEW_PANEL_INDICATORS.PREVIEW_PANELS) || searchParams.get($9b81732d1a3b5b72$var$PREVIEW_PANEL_INDICATORS.EMBEDDED_SOURCE) === $9b81732d1a3b5b72$var$PREVIEW_PANEL_INDICATORS.CONFLUENCE_PAGE_PREVIEW;
};
const $9b81732d1a3b5b72$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
const $9b81732d1a3b5b72$export$f274fcef361fe59d = ()=>{
    try {
        const currentSearch = window.location.search;
        if (currentSearch) {
            const currentParams = $9b81732d1a3b5b72$var$getUrlSearchParams(currentSearch);
            if (currentParams && $9b81732d1a3b5b72$var$hasPreviewPanelIndicators(currentParams)) return true;
        }
        return false;
    } catch  {
        return false;
    }
};
const $9b81732d1a3b5b72$export$24def1b22639c691 = ()=>{
    return $9b81732d1a3b5b72$export$9f140ed41af5108c() && $9b81732d1a3b5b72$export$f274fcef361fe59d();
};
module.exports["isWithinPreviewPanelIFrame"] = $9b81732d1a3b5b72$export$24def1b22639c691;

});

parcelRegister("01k3g", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $kSwu1 = parcelRequire("kSwu1");

const $e71de8c9e06bc4a1$var$IFRAME_NAME = 'twp-editor-preview-iframe';
const $e71de8c9e06bc4a1$var$POPUP_MOUNT_POINT_ID = 'twp-editor-preview-iframe';

async function $e71de8c9e06bc4a1$export$7859f96cd8cff034({ onClose: onClose = ()=>{}, ...props } = {}) {
    let popupMountPoint;
    popupMountPoint = document.getElementById($e71de8c9e06bc4a1$var$POPUP_MOUNT_POINT_ID);
    if (!popupMountPoint) {
        popupMountPoint = document.createElement('div');
        popupMountPoint.id = $e71de8c9e06bc4a1$var$POPUP_MOUNT_POINT_ID;
        popupMountPoint.setAttribute('data-testid', 'preview-modal');
        document.body.appendChild(popupMountPoint);
    }
    let Modal = await (parcelRequire("2A1LX"));
    (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        locale: "en"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal.default, {
        ...props,
        iframeName: $e71de8c9e06bc4a1$var$IFRAME_NAME,
        onClose: (_context)=>{
            if (popupMountPoint) (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).unmountComponentAtNode(popupMountPoint);
            if (onClose) onClose(_context);
        },
        showModal: true
    })), popupMountPoint);
}
module.exports["openEmbedModal"] = $e71de8c9e06bc4a1$export$7859f96cd8cff034;

});

parcelRegister("2A1LX", function(module, exports) {

let $1e105188711335a9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1e105188711335a9$var$load("bU9L5"),
    $1e105188711335a9$var$load("6wr18"),
    $1e105188711335a9$var$load("7EjoG"),
    $1e105188711335a9$var$load("Wowvf"),
    $1e105188711335a9$var$load("2hLAI"),
    $1e105188711335a9$var$load("dCilB"),
    $1e105188711335a9$var$load("h1yOv"),
    $1e105188711335a9$var$load("ffEVr"),
    $1e105188711335a9$var$load("hhss7"),
    $1e105188711335a9$var$load("9mGhw")
]).then(()=>parcelRequire('fGlyS'));

});

parcelRegister("1qrkW", function(module, exports) {

var $y3W88 = parcelRequire("y3W88");

const $a1c6aba8f77f7afa$export$38d755f52cdf4acb = (meta)=>{
    return Boolean(meta?.key && (0, $y3W88.PROVIDER_KEYS_WITH_THEMING).includes(meta.key));
};
module.exports["extractIsSupportTheming"] = $a1c6aba8f77f7afa$export$38d755f52cdf4acb;

});

parcelRegister("y3W88", function(module, exports) {
const $f18cdd07bdfda1f7$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $f18cdd07bdfda1f7$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $f18cdd07bdfda1f7$export$84a73a0383f58180 = 'JiraTask';
const $f18cdd07bdfda1f7$export$c6c83963a9378a67 = 'JiraSubTask';
const $f18cdd07bdfda1f7$export$58af3c426c111a6d = 'JiraStory';
const $f18cdd07bdfda1f7$export$ac9898a63417219e = 'JiraBug';
const $f18cdd07bdfda1f7$export$54db5e3fb12e39cd = 'JiraEpic';
const $f18cdd07bdfda1f7$export$2f54a5a217202c85 = 'JiraIncident';
const $f18cdd07bdfda1f7$export$d097371052bfc411 = 'JiraServiceRequest';
const $f18cdd07bdfda1f7$export$efd9452ad16c6676 = 'JiraChange';
const $f18cdd07bdfda1f7$export$2e7e70abb5d81f67 = 'JiraProblem';
const $f18cdd07bdfda1f7$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
const $f18cdd07bdfda1f7$export$fe44ce30fd8d131b = [
    'jira-object-provider',
    'confluence-object-provider',
    'watermelon-object-provider',
    'legion-object-provider',
    'avpviz-object-provider'
];
module.exports["CONFLUENCE_GENERATOR_ID"] = $f18cdd07bdfda1f7$export$cee224b5de4d6d66;
module.exports["JIRA_GENERATOR_ID"] = $f18cdd07bdfda1f7$export$f654d825189934a7;
module.exports["JIRA_TASK"] = $f18cdd07bdfda1f7$export$84a73a0383f58180;
module.exports["JIRA_SUB_TASK"] = $f18cdd07bdfda1f7$export$c6c83963a9378a67;
module.exports["JIRA_STORY"] = $f18cdd07bdfda1f7$export$58af3c426c111a6d;
module.exports["JIRA_BUG"] = $f18cdd07bdfda1f7$export$ac9898a63417219e;
module.exports["JIRA_EPIC"] = $f18cdd07bdfda1f7$export$54db5e3fb12e39cd;
module.exports["JIRA_INCIDENT"] = $f18cdd07bdfda1f7$export$2f54a5a217202c85;
module.exports["JIRA_SERVICE_REQUEST"] = $f18cdd07bdfda1f7$export$d097371052bfc411;
module.exports["JIRA_CHANGE"] = $f18cdd07bdfda1f7$export$efd9452ad16c6676;
module.exports["JIRA_PROBLEM"] = $f18cdd07bdfda1f7$export$2e7e70abb5d81f67;
module.exports["JIRA_CUSTOM_TASK_TYPE"] = $f18cdd07bdfda1f7$export$ce25cfc40b280dbc;
module.exports["PROVIDER_KEYS_WITH_THEMING"] = $f18cdd07bdfda1f7$export$fe44ce30fd8d131b;

});

parcelRegister("a3jaM", function(module, exports) {
const $388cdc660293d4db$export$4f3ffbb500daac5a = (meta)=>{
    return Boolean(meta?.key && meta.key !== 'iframely-object-provider');
};
module.exports["extractIsTrusted"] = $388cdc660293d4db$export$4f3ffbb500daac5a;

});

parcelRegister("fBEPJ", function(module, exports) {

var $jawC3 = parcelRequire("jawC3");


var $ixfCV = parcelRequire("ixfCV");


var $4yYAm = parcelRequire("4yYAm");


var $bJ2OW = parcelRequire("bJ2OW");


var $aldDV = parcelRequire("aldDV");


var $7UwLu = parcelRequire("7UwLu");

const $c45d8ee8f3107765$export$43612bed147eae48 = (response, renderers)=>{
    const data = response.data;
    const render = (0, $bJ2OW.default)(data, renderers);
    return {
        ...(0, $aldDV.default)(data),
        render: render
    };
};
const $c45d8ee8f3107765$export$bdd29be9b0395931 = (response, status)=>{
    // Try to get provider icon first.
    if (response) {
        const data = response.data;
        const { icon: icon, url: url } = (0, $7UwLu.default)(data) || {};
        if (icon || url) return {
            icon: icon,
            url: url
        };
    }
    // Otherwise, use fallback icon for each status.
    switch(status){
        case (0, $4yYAm.SmartLinkStatus).Forbidden:
        case (0, $4yYAm.SmartLinkStatus).Unauthorized:
            return {
                icon: (0, $4yYAm.IconType).Forbidden
            };
        case (0, $4yYAm.SmartLinkStatus).NotFound:
            return {
                icon: (0, $4yYAm.IconType).Error
            };
        case (0, $4yYAm.SmartLinkStatus).Errored:
        case (0, $4yYAm.SmartLinkStatus).Fallback:
        default:
            return {
                icon: (0, $4yYAm.IconType).Default
            };
    }
};
const $c45d8ee8f3107765$export$35040aed9264b11c = (response, renderers)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $ixfCV.fg)('platform_lp_use_entity_icon_url_for_icon')) {
        if ((0, $jawC3.isEntityPresent)(response)) {
            const entityIcon = (0, $jawC3.extractEntityIcon)(response);
            if (entityIcon) return entityIcon;
        }
    } else {
        if ((0, $jawC3.isEntityPresent)(response)) return (0, $jawC3.extractEntityIcon)(response);
    }
    return $c45d8ee8f3107765$export$43612bed147eae48(response, renderers);
};
module.exports["extractLinkIcon"] = $c45d8ee8f3107765$export$43612bed147eae48;
module.exports["extractErrorIcon"] = $c45d8ee8f3107765$export$bdd29be9b0395931;
module.exports["extractSmartLinkIcon"] = $c45d8ee8f3107765$export$35040aed9264b11c;

});

parcelRegister("bJ2OW", function(module, exports) {
const $6d3228577637aa25$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $6d3228577637aa25$var$extractIconRenderer = (data, renderers)=>{
    const prefix = data['atlassian:titlePrefix'];
    if (prefix?.['@type'] === 'atlassian:Emoji') {
        const emojiId = $6d3228577637aa25$var$sanitizeEmojiValue(prefix['text']);
        const emojiRenderer = renderers?.emoji;
        if (emojiId && emojiRenderer) return ()=>emojiRenderer(emojiId);
    }
};
var $6d3228577637aa25$export$2e2bcd8739ae039 = $6d3228577637aa25$var$extractIconRenderer;
module.exports["default"] = $6d3228577637aa25$export$2e2bcd8739ae039;

});

parcelRegister("aldDV", function(module, exports) {

var $jawC3 = parcelRequire("jawC3");


var $ixfCV = parcelRequire("ixfCV");


var $4yYAm = parcelRequire("4yYAm");


var $2Pj3a = parcelRequire("2Pj3a");


var $i9AjY = parcelRequire("i9AjY");


var $8mPrX = parcelRequire("8mPrX");


var $y3W88 = parcelRequire("y3W88");


var $aX5dQ = parcelRequire("aX5dQ");


var $1VjCT = parcelRequire("1VjCT");


var $jQ3fx = parcelRequire("jQ3fx");


var $7UwLu = parcelRequire("7UwLu");


var $2P0qx = parcelRequire("2P0qx");

const $d862403e920df0d6$var$extractTask = (data, label)=>{
    const { id: id, icon: url } = (0, $8mPrX.extractTaskType)(data) || {};
    const taskType = id?.split('#').pop();
    const taskIcon = url ? {
        label: label,
        url: url
    } : undefined;
    return {
        taskType: taskType,
        taskIcon: taskIcon
    };
};
const $d862403e920df0d6$var$extractTaskNew = (data)=>{
    const taskTypeInfo = (0, $8mPrX.extractTaskType)(data) || {};
    const { id: id, icon: url, name: name } = taskTypeInfo;
    const taskType = id?.split('#').pop();
    const taskIconLabel = name?.trim() || 'Task';
    const taskIcon = url ? {
        label: taskIconLabel,
        url: url
    } : undefined;
    return {
        taskType: taskType,
        taskIcon: taskIcon
    };
};
const $d862403e920df0d6$var$extractType = (jsonLd)=>{
    const type = jsonLd['@type'];
    return Array.isArray(type) ? type.sort((a, b)=>(0, $i9AjY.extractorPriorityMap)[b] - (0, $i9AjY.extractorPriorityMap)[a])[0] : type;
};
const $d862403e920df0d6$var$isJiraProvider = (provider)=>provider === (0, $y3W88.JIRA_GENERATOR_ID);
function $d862403e920df0d6$var$chooseIcon({ urlIcon: urlIcon, type: type, label: label, data: data, providerIcon: providerIcon }) {
    const providerId = data.generator?.['@id'];
    const fileFormat = data?.['schema:fileFormat'];
    const fileFormatIcon = (0, $1VjCT.default)(fileFormat);
    if ((0, $ixfCV.fg)('platform_navx_smart_link_icon_label_a11y')) {
        const iconDescriptor = $d862403e920df0d6$var$typeToIconDescriptor({
            type: type,
            providerId: providerId,
            data: data
        });
        const documentTitle = (0, $ixfCV.fg)('platform_navx_smart_link_icon_label_a11y') ? undefined : (0, $jawC3.extractTitle)(data);
        const extractedDocumentTypeIcon = (0, $aX5dQ.default)(type, documentTitle, providerId);
        const documentTypeIcon = iconDescriptor || extractedDocumentTypeIcon;
        const urlIconNew = (0, $2P0qx.default)(data.icon, documentTypeIcon?.label);
        return (0, $2Pj3a.prioritiseIcon)({
            fileFormatIcon: fileFormatIcon,
            documentTypeIcon: documentTypeIcon,
            urlIcon: urlIconNew,
            providerIcon: providerIcon
        });
    } else {
        const documentTypeIcon = $d862403e920df0d6$var$typeToIconDescriptor({
            type: type,
            label: label,
            providerId: providerId,
            data: data
        }) || (0, $aX5dQ.default)(type, label, providerId);
        return (0, $2Pj3a.prioritiseIcon)({
            fileFormatIcon: fileFormatIcon,
            documentTypeIcon: documentTypeIcon,
            urlIcon: urlIcon,
            providerIcon: providerIcon
        });
    }
}
function $d862403e920df0d6$var$typeToIconDescriptor({ type: type, label: label, providerId: providerId, data: data }) {
    const descriptorLabel = (semantic)=>(0, $ixfCV.fg)('platform_navx_smart_link_icon_label_a11y') ? semantic : label;
    switch(type){
        case 'atlassian:Goal':
            return {
                icon: (0, $4yYAm.IconType).Task,
                label: descriptorLabel('goal')
            };
        case 'atlassian:Project':
            return {
                // FIXME: atlassian:Project seem to be returned for many things, including Confluence space or Trello board,
                // But `IconType.Project` actual value is `BitBucket:Project`!
                icon: (0, $4yYAm.IconType).Project,
                label: descriptorLabel('project')
            };
        case 'atlassian:SourceCodeCommit':
            return {
                icon: (0, $4yYAm.IconType).Commit,
                label: descriptorLabel('commit')
            };
        case 'atlassian:SourceCodePullRequest':
            return {
                icon: (0, $4yYAm.IconType).PullRequest,
                label: descriptorLabel('pull request')
            };
        case 'atlassian:SourceCodeReference':
            return {
                icon: (0, $4yYAm.IconType).Branch,
                label: descriptorLabel('branch')
            };
        case 'atlassian:SourceCodeRepository':
            return {
                icon: (0, $4yYAm.IconType).Repo,
                label: descriptorLabel('repository')
            };
        case 'atlassian:Task':
            if ((0, $ixfCV.fg)('platform_navx_smart_link_icon_label_a11y')) {
                const taskIconDescriptor = {
                    icon: (0, $4yYAm.IconType).Task,
                    label: descriptorLabel('task')
                };
                if ($d862403e920df0d6$var$isJiraProvider(providerId)) {
                    const { taskType: taskType, taskIcon: taskIcon } = $d862403e920df0d6$var$extractTaskNew(data);
                    return taskType === 'JiraCustomTaskType' ? taskIcon || taskIconDescriptor : (0, $jQ3fx.default)(taskType);
                }
                return taskIconDescriptor;
            } else {
                const taskLabel = label || 'Task';
                const taskIconDescriptor = {
                    icon: (0, $4yYAm.IconType).Task,
                    label: taskLabel
                };
                if ($d862403e920df0d6$var$isJiraProvider(providerId)) {
                    const { taskType: taskType, taskIcon: taskIcon } = $d862403e920df0d6$var$extractTask(data);
                    return taskType === 'JiraCustomTaskType' ? taskIcon || taskIconDescriptor : (0, $jQ3fx.default)(taskType, taskLabel);
                }
                return taskIconDescriptor;
            }
        default:
            return undefined;
    }
}
/**
 * Return the icon object given a JSON-LD data object.
 */ const $d862403e920df0d6$var$extractJsonldDataIcon = (data)=>{
    if ((0, $ixfCV.fg)('platform_navx_smart_link_icon_label_a11y')) {
        const type = $d862403e920df0d6$var$extractType(data);
        const providerIcon = (0, $7UwLu.default)(data);
        return $d862403e920df0d6$var$chooseIcon({
            type: type,
            data: data,
            providerIcon: providerIcon
        });
    } else {
        const label = (0, $jawC3.extractTitle)(data);
        const type = $d862403e920df0d6$var$extractType(data);
        const urlIcon = (0, $2P0qx.default)(data.icon, label);
        const providerIcon = (0, $7UwLu.default)(data);
        return $d862403e920df0d6$var$chooseIcon({
            urlIcon: urlIcon,
            providerIcon: providerIcon,
            type: type,
            label: label,
            data: data
        });
    }
};
var $d862403e920df0d6$export$2e2bcd8739ae039 = $d862403e920df0d6$var$extractJsonldDataIcon;
module.exports["default"] = $d862403e920df0d6$export$2e2bcd8739ae039;

});

parcelRegister("2Pj3a", function(module, exports) {
/**
 * Options required to prioritise which icon to show
 */ function $4e81f2f1044982ba$export$65e47eb22a387a86({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon }) {
    return urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
}
module.exports["prioritiseIcon"] = $4e81f2f1044982ba$export$65e47eb22a387a86;

});

parcelRegister("i9AjY", function(module, exports) {
const $936fbc58b48eda25$export$e0deaeb4a2dfe2b4 = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};
module.exports["extractorPriorityMap"] = $936fbc58b48eda25$export$e0deaeb4a2dfe2b4;

});

parcelRegister("8mPrX", function(module, exports) {

var $jawC3 = parcelRequire("jawC3");

const $d0bc942c0997c3eb$export$ed3fd59180514d27 = (jsonLd)=>{
    // TODO: Remove once Jira migrate to the correct type.
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $jawC3.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};
module.exports["extractTaskType"] = $d0bc942c0997c3eb$export$ed3fd59180514d27;

});

parcelRegister("aX5dQ", function(module, exports) {

var $jawC3 = parcelRequire("jawC3");


var $ixfCV = parcelRequire("ixfCV");


var $4yYAm = parcelRequire("4yYAm");

/**
 * Computes the relevant icon for a document type.
 *
 * @remark Note that document icons can vary based on the provider. E.g., a
 * provider may choose to re-use one of these document types in their domain,
 * but offer a different SVG icon on the frontend (to map to this type in their
 * domain). See `schema:digitalDocument` for an example of this behaviour. This
 * mechanism will be superseded by backend-driven icon URLs as part of
 * go/j/MODES-5864. Do not add more!
 *
 * @param documentType JSON-LD document type
 * @param label human-readable label to be displayed on the icon
 * @param providerId JSON-LD provider (generator ID)
 * @returns an icon descriptor representing the document type
 */ const $3153f71083dbedd3$var$extractDocumentTypeIcon = (documentType, label, providerId)=>{
    const getLabel = (hardcodedLabel)=>(0, $ixfCV.fg)('platform_navx_smart_link_icon_label_a11y') ? hardcodedLabel : label;
    switch(documentType){
        case 'schema:BlogPosting':
            return {
                icon: (0, $4yYAm.IconType).Blog,
                label: getLabel('blog')
            };
        case 'schema:DigitalDocument':
            if (providerId && (0, $jawC3.isConfluenceGenerator)(providerId)) return {
                icon: (0, $4yYAm.IconType).LiveDocument,
                label: getLabel('live document')
            };
            else return {
                icon: (0, $4yYAm.IconType).File,
                label: getLabel('file')
            };
        case 'schema:TextDigitalDocument':
            return {
                icon: (0, $4yYAm.IconType).Document,
                label: getLabel('document')
            };
        case 'schema:PresentationDigitalDocument':
            return {
                icon: (0, $4yYAm.IconType).Presentation,
                label: getLabel('presentation')
            };
        case 'schema:SpreadsheetDigitalDocument':
            return {
                icon: (0, $4yYAm.IconType).Spreadsheet,
                label: getLabel('spreadsheet')
            };
        case 'atlassian:Template':
            return {
                icon: (0, $4yYAm.IconType).Template,
                label: getLabel('template')
            };
        case 'atlassian:UndefinedLink':
            return {
                icon: (0, $4yYAm.IconType).Document,
                label: getLabel('document')
            };
        default:
            return undefined;
    }
};
var $3153f71083dbedd3$export$2e2bcd8739ae039 = $3153f71083dbedd3$var$extractDocumentTypeIcon;
module.exports["default"] = $3153f71083dbedd3$export$2e2bcd8739ae039;

});

parcelRegister("jQ3fx", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $4yYAm = parcelRequire("4yYAm");

const $616c5048633b5d21$var$extractJiraTaskIcon = (taskType, label)=>{
    const getLabel = (hardcodedLabel)=>(0, $ixfCV.fg)('platform_navx_smart_link_icon_label_a11y') ? hardcodedLabel : label || 'Task';
    switch(taskType){
        case 'JiraBug':
            return {
                icon: (0, $4yYAm.IconType).Bug,
                label: getLabel('Bug')
            };
        case 'JiraChange':
            return {
                icon: (0, $4yYAm.IconType).Change,
                label: getLabel('Change')
            };
        case 'JiraEpic':
            return {
                icon: (0, $4yYAm.IconType).Epic,
                label: getLabel('Epic')
            };
        case 'JiraIncident':
            return {
                icon: (0, $4yYAm.IconType).Incident,
                label: getLabel('Incident')
            };
        case 'JiraProblem':
            return {
                icon: (0, $4yYAm.IconType).Problem,
                label: getLabel('Problem')
            };
        case 'JiraServiceRequest':
            return {
                icon: (0, $4yYAm.IconType).ServiceRequest,
                label: getLabel('Service request')
            };
        case 'JiraStory':
            return {
                icon: (0, $4yYAm.IconType).Story,
                label: getLabel('Story')
            };
        case 'JiraSubTask':
            return {
                icon: (0, $4yYAm.IconType).SubTask,
                label: getLabel('Sub-task')
            };
        case 'JiraTask':
        default:
            return {
                icon: (0, $4yYAm.IconType).Task,
                label: getLabel('Task')
            };
    }
};
var $616c5048633b5d21$export$2e2bcd8739ae039 = $616c5048633b5d21$var$extractJiraTaskIcon;
module.exports["default"] = $616c5048633b5d21$export$2e2bcd8739ae039;

});

parcelRegister("7UwLu", function(module, exports) {

var $jawC3 = parcelRequire("jawC3");


var $4yYAm = parcelRequire("4yYAm");


var $y3W88 = parcelRequire("y3W88");


var $2P0qx = parcelRequire("2P0qx");

/**
 * Extracts the provider icon and label from the given JSON-LD data.
 *
 * If the data is from Confluence, the icon will be the Confluence icon and the label will be 'Confluence'.
 * If the data is from Jira, the icon will be the Jira icon and the label will be 'Jira'.
 * If the data is from another provider, the icon and label will be extracted from the generator object.
 *
 * @param data - The JSON-LD data to extract the provider icon and label from.
 * @returns IconDescriptor with optional icon string name, url and label, or `undefined` if the data is not provided.
 */ const $b98c3a64f7967b2a$var$extractProviderIcon = (data)=>{
    if (!data) return undefined;
    const generator = data.generator;
    const provider = generator?.['@id'];
    const icon = generator?.icon;
    const label = generator?.name || (0, $jawC3.extractTitle)(data);
    if (provider === (0, $y3W88.CONFLUENCE_GENERATOR_ID)) return {
        icon: (0, $4yYAm.IconType).Confluence,
        label: label || 'Confluence'
    };
    if (provider === (0, $y3W88.JIRA_GENERATOR_ID)) return {
        icon: (0, $4yYAm.IconType).Jira,
        label: label || 'Jira'
    };
    return (0, $2P0qx.default)(icon, label);
};
var $b98c3a64f7967b2a$export$2e2bcd8739ae039 = $b98c3a64f7967b2a$var$extractProviderIcon;
const $b98c3a64f7967b2a$export$5def189f04eea025 = (response)=>{
    if (!response || !response?.data) return undefined;
    if ((0, $jawC3.isEntityPresent)(response)) {
        const provider = (0, $jawC3.extractEntityProvider)(response);
        if (!provider) return undefined;
        switch(provider.id){
            case 0, $y3W88.CONFLUENCE_GENERATOR_ID:
                return {
                    icon: (0, $4yYAm.IconType).Confluence,
                    label: provider.text || 'Confluence'
                };
            case 0, $y3W88.JIRA_GENERATOR_ID:
                return {
                    icon: (0, $4yYAm.IconType).Jira,
                    label: provider.text || 'Jira'
                };
            default:
                const { generator: generator } = response.meta;
                if (!generator) return undefined;
                return {
                    label: generator.name || (0, $jawC3.extractEntity)(response)?.displayName,
                    url: generator.icon?.url
                };
        }
    }
    return $b98c3a64f7967b2a$var$extractProviderIcon(response.data);
};
module.exports["default"] = $b98c3a64f7967b2a$export$2e2bcd8739ae039;
module.exports["extractSmartLinkProviderIcon"] = $b98c3a64f7967b2a$export$5def189f04eea025;

});

parcelRegister("2P0qx", function(module, exports) {

var $jawC3 = parcelRequire("jawC3");

/**
 * Extracts the URL icon from the given icon or link object.
 *
 * @param icon - The icon or link object from which to extract the URL icon.
 * @param label - The label for the URL icon.
 * @returns IconDescriptor, which will contain label and url, or undefined
 */ const $21ca246200c193a5$var$extractUrlIcon = (icon, label)=>{
    const url = icon && (0, $jawC3.extractUrlFromIconJsonLd)(icon);
    return url ? {
        label: label,
        url: url
    } : undefined;
};
var $21ca246200c193a5$export$2e2bcd8739ae039 = $21ca246200c193a5$var$extractUrlIcon;
module.exports["default"] = $21ca246200c193a5$export$2e2bcd8739ae039;

});

parcelRegister("2FmJb", function(module, exports) {

var $jawC3 = parcelRequire("jawC3");


var $ixfCV = parcelRequire("ixfCV");


var $4yYAm = parcelRequire("4yYAm");


var $2Q7sv = parcelRequire("2Q7sv");


var $16kNn = parcelRequire("16kNn");


var $98Ma9 = parcelRequire("98Ma9");


var $aTUup = parcelRequire("aTUup");

const $eacd17f647b08bbc$export$88c5813cfbbe4e4c = ({ actionOptions: actionOptions, appearance: appearance, transformUrl: transformUrl, id: id, response: response }, force)=>{
    if (!(0, $98Ma9.canShowAction)((0, $4yYAm.CardAction).ViewAction, actionOptions)) return;
    const data = response.data;
    if (!data) return;
    const url = (0, $jawC3.extractLink)(data);
    const viewActionExists = (0, $aTUup.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'ViewAction');
    if (url && (viewActionExists || force)) return {
        actionFn: async ()=>{
            if ((0, $ixfCV.fg)('platform_smartlink_xpc_url_wrapping')) {
                const destinationUrl = transformUrl?.(url) ?? url;
                return (0, $16kNn.openUrl)(destinationUrl);
            }
            return (0, $16kNn.openUrl)(url);
        },
        actionSubjectId: 'shortcutGoToLink',
        actionType: 'ViewAction',
        definitionId: (0, $2Q7sv.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $2Q7sv.getExtensionKey)(response),
        id: id,
        resourceType: (0, $2Q7sv.getResourceType)(response)
    };
};
module.exports["extractInvokeViewAction"] = $eacd17f647b08bbc$export$88c5813cfbbe4e4c;

});

parcelRegister("irGZZ", function(module, exports) {

var $jawC3 = parcelRequire("jawC3");


var $ixfCV = parcelRequire("ixfCV");


var $anBbz = parcelRequire("anBbz");


var $4yYAm = parcelRequire("4yYAm");


var $2Q7sv = parcelRequire("2Q7sv");


var $98Ma9 = parcelRequire("98Ma9");


var $aflIU = parcelRequire("aflIU");

// For block card experiment (NAVX-4814)
const $62820a0adcb55b8e$var$ELIGIBLE_EXTENSION_KEYS = new Set([
    'slack-object-provider',
    'google-object-provider',
    'onedrive-object-provider',
    'github-object-provider',
    'ms-teams-object-provider',
    'gitlab-object-provider',
    'salesforce-object-provider'
]);
const $62820a0adcb55b8e$var$extractRovoChatAction = ({ actionOptions: actionOptions, appearance: appearance, id: id, isEmbedRovoActionsFooterExperimentEnabled: isEmbedRovoActionsFooterExperimentEnabled, product: product, response: response, rovoConfig: rovoConfig })=>{
    if (!(0, $98Ma9.canShowAction)((0, $4yYAm.CardAction).RovoChatAction, actionOptions)) return;
    const isRovoChatEnabled = (0, $aflIU.getIsRovoChatEnabled)(rovoConfig?.rovoOptions);
    if (!isRovoChatEnabled) return;
    const extensionKey = (0, $2Q7sv.getExtensionKey)(response);
    const isInlineExperimentEnabled = (0, $ixfCV.fg)('platform_sl_3p_auth_inline_tailored_cta_killswitch') && (0, $anBbz.expValEqualsNoExposure)('platform_sl_3p_auth_inline_tailored_cta', 'isEnabled', true);
    const is3PBlockPostAuthActionsEnabled = extensionKey !== undefined && $62820a0adcb55b8e$var$ELIGIBLE_EXTENSION_KEYS.has(extensionKey) && rovoConfig?.product === 'CONFLUENCE';
    const is3PEmbedPostAuthActionsEnabled = isEmbedRovoActionsFooterExperimentEnabled === true;
    const isSupportedFeature = is3PBlockPostAuthActionsEnabled || isInlineExperimentEnabled || is3PEmbedPostAuthActionsEnabled;
    const isOptIn = actionOptions?.rovoChatAction?.optIn === true;
    const url = (0, $jawC3.extractSmartLinkUrl)(response);
    return isSupportedFeature && isOptIn ? {
        invokeAction: {
            actionSubjectId: 'rovoChatPrompt',
            actionType: (0, $4yYAm.ActionName).RovoChatAction,
            definitionId: (0, $2Q7sv.getDefinitionId)(response),
            display: appearance,
            extensionKey: extensionKey,
            id: id,
            resourceType: (0, $2Q7sv.getResourceType)(response)
        },
        product: product,
        url: url
    } : undefined;
};
var $62820a0adcb55b8e$export$2e2bcd8739ae039 = $62820a0adcb55b8e$var$extractRovoChatAction;
module.exports["default"] = $62820a0adcb55b8e$export$2e2bcd8739ae039;

});

parcelRegister("78FxT", function(module, exports) {

var $jawC3 = parcelRequire("jawC3");

const $b78fcf394208fce3$export$debae7424a0231b9 = (response)=>{
    if (!response?.meta?.supportedFeature?.includes('RelatedLinks')) return;
    const ari = (0, $jawC3.extractSmartLinkAri)(response);
    if (!ari) return;
    return {
        ari: ari
    };
};
module.exports["extractViewRelatedLinksAction"] = $b78fcf394208fce3$export$debae7424a0231b9;

});

parcelRegister("6hJQj", function(module, exports) {

var $jawC3 = parcelRequire("jawC3");

const $bee1077b61636bdc$export$216e4f6aa7c169b8 = (jsonLd)=>{
    if (jsonLd['@type'] === 'atlassian:Project') {
        const members = (0, $jawC3.extractMembers)(jsonLd);
        if (members && members.length !== 0) return members;
    }
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) {
        const extractedPersons = (0, $jawC3.extractPersonFromJsonLd)(updatedBy);
        return extractedPersons ? [
            extractedPersons
        ] : undefined;
    }
};
module.exports["extractPersonsUpdatedBy"] = $bee1077b61636bdc$export$216e4f6aa7c169b8;

});

parcelRegister("emAbv", function(module, exports) {

var $jawC3 = parcelRequire("jawC3");


var $4yYAm = parcelRequire("4yYAm");

const $e366d9a2a40cc6bc$var$extractLinkTitle = (status, propUrl, response, onClick, onAuxClick, onContextMenu)=>{
    const responseUrl = (0, $jawC3.extractSmartLinkUrl)(response);
    const url = status === (0, $4yYAm.SmartLinkStatus).Resolved ? responseUrl ?? propUrl : propUrl;
    const name = (0, $jawC3.extractSmartLinkTitle)(response);
    const text = status === (0, $4yYAm.SmartLinkStatus).Resolved ? name ?? responseUrl ?? propUrl : propUrl;
    return {
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        text: text,
        url: url
    };
};
var $e366d9a2a40cc6bc$export$2e2bcd8739ae039 = $e366d9a2a40cc6bc$var$extractLinkTitle;
module.exports["default"] = $e366d9a2a40cc6bc$export$2e2bcd8739ae039;

});

parcelRegister("k8KyO", function(module, exports) {

var $jawC3 = parcelRequire("jawC3");


var $4yYAm = parcelRequire("4yYAm");

const $a743bfb81d3280a1$var$priorityMapper = {
    blocker: (0, $4yYAm.IconType).PriorityBlocker,
    critical: (0, $4yYAm.IconType).PriorityCritical,
    high: (0, $4yYAm.IconType).PriorityHigh,
    highest: (0, $4yYAm.IconType).PriorityHighest,
    low: (0, $4yYAm.IconType).PriorityLow,
    lowest: (0, $4yYAm.IconType).PriorityLowest,
    major: (0, $4yYAm.IconType).PriorityMajor,
    medium: (0, $4yYAm.IconType).PriorityMedium,
    minor: (0, $4yYAm.IconType).PriorityMinor,
    trivial: (0, $4yYAm.IconType).PriorityTrivial,
    undefined: (0, $4yYAm.IconType).PriorityUndefined
};
const $a743bfb81d3280a1$var$extractPriority = (data)=>{
    const priority = data['atlassian:priority'];
    if (priority) {
        if (typeof priority === 'string') {
            const icon = $a743bfb81d3280a1$var$priorityMapper[priority.toLowerCase()];
            if (icon) return {
                icon: icon,
                label: priority
            };
        } else if (priority['@type'] === 'Object') return {
            label: priority.name,
            url: priority.icon && (0, $jawC3.extractUrlFromIconJsonLd)(priority.icon)
        };
    }
};
var $a743bfb81d3280a1$export$2e2bcd8739ae039 = $a743bfb81d3280a1$var$extractPriority;
module.exports["default"] = $a743bfb81d3280a1$export$2e2bcd8739ae039;

});

parcelRegister("eSImY", function(module, exports) {

var $jawC3 = parcelRequire("jawC3");


var $4yYAm = parcelRequire("4yYAm");


var $y3W88 = parcelRequire("y3W88");

const $fcaa8ed9f9022e61$var$extractProvider = (response)=>{
    const provider = (0, $jawC3.extractSmartLinkProvider)(response);
    if (!provider) return;
    const providerName = provider.text;
    if (provider.id === (0, $y3W88.CONFLUENCE_GENERATOR_ID)) return {
        icon: (0, $4yYAm.IconType).Confluence,
        label: providerName || 'Confluence'
    };
    if (provider.id === (0, $y3W88.JIRA_GENERATOR_ID)) return {
        icon: (0, $4yYAm.IconType).Jira,
        label: providerName || 'Jira'
    };
    if (providerName) return {
        label: providerName,
        url: typeof provider.icon === 'string' ? provider.icon : undefined
    };
};
var $fcaa8ed9f9022e61$export$2e2bcd8739ae039 = $fcaa8ed9f9022e61$var$extractProvider;
module.exports["default"] = $fcaa8ed9f9022e61$export$2e2bcd8739ae039;

});

parcelRegister("igQUs", function(module, exports) {

var $jawC3 = parcelRequire("jawC3");


var $ixfCV = parcelRequire("ixfCV");


var $4yYAm = parcelRequire("4yYAm");


var $2Q7sv = parcelRequire("2Q7sv");


var $98Ma9 = parcelRequire("98Ma9");


var $jINxM = parcelRequire("jINxM");


var $2Mkmh = parcelRequire("2Mkmh");


var $dz3ZB = parcelRequire("dz3ZB");

const $b2b984cf2b128c1f$var$toInvokeRequest = (extensionKey, resourceIdentifiers, actionType, details)=>{
    if (!actionType) return;
    return {
        action: {
            actionType: actionType,
            resourceIdentifiers: resourceIdentifiers
        },
        providerKey: extensionKey,
        details: details
    };
};
const $b2b984cf2b128c1f$var$extractAction = (response, id, actionOptions, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel, transformUrl)=>{
    const extensionKey = (0, $2Q7sv.getExtensionKey)(response);
    const data = response?.data;
    const actions = (0, $dz3ZB.default)(data);
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>item?.name === 'UpdateAction' && item?.refField === 'tag');
    if (!action || !action.resourceIdentifiers) return;
    const read = $b2b984cf2b128c1f$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataRetrievalAction?.name);
    const url = (0, $jawC3.extractLink)(data);
    const invokePreviewAction = response ? (0, $jINxM.extractInvokePreviewAction)({
        actionOptions: actionOptions,
        appearance: appearance,
        fireEvent: fireEvent,
        id: id,
        onClose: resolve ? ()=>url && resolve({
                url: url,
                isReloading: true
            }) : undefined,
        origin: origin,
        response: response,
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        openPreviewPanel: openPreviewPanel,
        ...(0, $ixfCV.fg)('platform_smartlink_xpc_url_wrapping') ? {
            transformUrl: transformUrl
        } : undefined
    })?.invokeAction : undefined;
    const details = {
        id: id,
        url: url,
        invokePreviewAction: invokePreviewAction
    };
    const update = $b2b984cf2b128c1f$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, action.dataUpdateAction?.name, details);
    return read || update ? {
        read: read,
        update: update
    } : undefined;
};
const $b2b984cf2b128c1f$var$extractState = (response, actionOptions, id, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel, transformUrl)=>{
    if (!response || !response.data) return;
    const lozenge = (0, $2Mkmh.extractLozenge)(response?.data);
    if (!lozenge) return;
    if (!(0, $98Ma9.canShowAction)((0, $4yYAm.CardAction).ChangeStatusAction, actionOptions)) return lozenge;
    const action = $b2b984cf2b128c1f$var$extractAction(response, id, actionOptions, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel, (0, $ixfCV.fg)('platform_smartlink_xpc_url_wrapping') ? transformUrl : undefined);
    return {
        ...lozenge,
        action: action
    };
};
var $b2b984cf2b128c1f$export$2e2bcd8739ae039 = $b2b984cf2b128c1f$var$extractState;
module.exports["default"] = $b2b984cf2b128c1f$export$2e2bcd8739ae039;

});

parcelRegister("2Mkmh", function(module, exports) {

var $jawC3 = parcelRequire("jawC3");


var $2vpap = parcelRequire("2vpap");


var $2kOxL = parcelRequire("2kOxL");


var $77Vrx = parcelRequire("77Vrx");


var $8mPrX = parcelRequire("8mPrX");

const $e166bb124f5014dc$export$e5da155556a77bca = (jsonLd)=>{
    const type = (0, $jawC3.extractType)(jsonLd);
    if (type) {
        if (type.includes('atlassian:Task')) {
            const jsonLdTask = jsonLd;
            const lozengeFromTag = (0, $2kOxL.extractTag)(jsonLdTask);
            const lozengeFromStatus = (0, $77Vrx.extractTaskStatus)(jsonLdTask);
            const lozengeFromTaskType = $e166bb124f5014dc$var$extractLozengeFromTaskType(jsonLdTask);
            return lozengeFromTag || lozengeFromStatus || lozengeFromTaskType;
        }
        if (type.includes('atlassian:UndefinedLink')) return {
            text: 'UNDEFINED',
            appearance: 'inprogress'
        };
        // casting it because `extractState` can safely handle missing properties
        return (0, $2vpap.extractState)(jsonLd);
    }
};
const $e166bb124f5014dc$var$extractLozengeFromTaskType = (jsonLdTask)=>{
    const taskType = (0, $8mPrX.extractTaskType)(jsonLdTask);
    if (taskType && taskType.name) return {
        text: taskType.name,
        appearance: 'success'
    };
};
module.exports["extractLozenge"] = $e166bb124f5014dc$export$e5da155556a77bca;

});

parcelRegister("2vpap", function(module, exports) {

var $eZiNI = parcelRequire("eZiNI");

// Maps accent color short names to their corresponding background and text colors
const $29dee88bf4e3c006$var$lozengeAccentStyles = {
    blue: {
        backgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
        color: "var(--ds-text-accent-blue, #1558BC)"
    },
    gray: {
        backgroundColor: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
        color: "var(--ds-text-accent-gray, #505258)"
    },
    green: {
        backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        color: "var(--ds-text-accent-green, #216E4E)"
    },
    lime: {
        backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        color: "var(--ds-text-accent-lime, #4C6B1F)"
    },
    magenta: {
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        color: "var(--ds-text-accent-magenta, #943D73)"
    },
    orange: {
        backgroundColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
        color: "var(--ds-text-accent-orange, #9E4C00)"
    },
    purple: {
        backgroundColor: "var(--ds-background-accent-purple-subtler, #EED7FC)",
        color: "var(--ds-text-accent-purple, #803FA5)"
    },
    red: {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    teal: {
        backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        color: "var(--ds-text-accent-teal, #206A83)"
    },
    yellow: {
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
        color: "var(--ds-text-accent-yellow, #7F5F01)"
    }
};
const $29dee88bf4e3c006$export$5e4074cbce6574c7 = (jsonLd)=>{
    const state = jsonLd['atlassian:state'];
    if (state) {
        if (typeof state === 'string') {
            const linkState = state.toLowerCase();
            if (!(0, $eZiNI.OMIT_STATES).includes(linkState)) return {
                text: linkState,
                appearance: (0, $eZiNI.VALID_STATES)[linkState] || 'default'
            };
        } else if (state['@type'] === 'Link' || state['@type'] === 'Object') {
            if (state.name) {
                const accent = state.accent;
                return {
                    text: state.name,
                    appearance: state.appearance || 'default',
                    style: accent ? $29dee88bf4e3c006$var$lozengeAccentStyles[accent] : undefined
                };
            }
        }
    }
};
module.exports["extractState"] = $29dee88bf4e3c006$export$5e4074cbce6574c7;

});

parcelRegister("eZiNI", function(module, exports) {
const $6cea38ed52bda634$var$VALID_APPEARANCES = [
    'default',
    'success',
    'removed',
    'inprogress',
    'new',
    'moved'
];
const $6cea38ed52bda634$export$ce6b5b303f8e3c99 = (appearance)=>{
    return $6cea38ed52bda634$var$VALID_APPEARANCES.indexOf(appearance) !== -1;
};
const $6cea38ed52bda634$export$7b1deaaad25d1dc1 = {
    open: 'inprogress',
    merged: 'success',
    declined: 'removed',
    closed: 'success',
    draft: 'inprogress',
    archived: 'default',
    'queued to merge': 'moved'
};
const $6cea38ed52bda634$export$772610da74ddbc07 = [
    'current'
];
module.exports["isValidAppearance"] = $6cea38ed52bda634$export$ce6b5b303f8e3c99;
module.exports["VALID_STATES"] = $6cea38ed52bda634$export$7b1deaaad25d1dc1;
module.exports["OMIT_STATES"] = $6cea38ed52bda634$export$772610da74ddbc07;

});

parcelRegister("2kOxL", function(module, exports) {

var $eZiNI = parcelRequire("eZiNI");

const $b2c263e15de4bef1$export$962a8da34cf78a4f = (jsonLd)=>{
    const tag = jsonLd.tag;
    if (tag) {
        if (typeof tag === 'string') return {
            text: tag,
            appearance: 'default'
        };
        else if (Array.isArray(tag)) {
            const tags = tag.map($b2c263e15de4bef1$var$extractTagItem).filter((item)=>!!item);
            if (tags.length > 0) return tags.shift();
        } else return $b2c263e15de4bef1$var$extractTagItem(tag);
    }
};
const $b2c263e15de4bef1$var$extractTagItem = (tag)=>{
    if (typeof tag === 'string') return {
        text: tag,
        appearance: 'default'
    };
    else if (tag['@type'] === 'Link') {
        if (tag.name) return {
            text: tag.name,
            appearance: 'default'
        };
    } else if (tag.name) {
        const appearance = tag.appearance;
        return {
            text: tag.name,
            // Jira currently uses tag.appearance to set the lozenge color. Remove this
            // once we migrate them away from using this old spec.
            appearance: (0, $eZiNI.isValidAppearance)(appearance) && appearance || 'default'
        };
    }
};
module.exports["extractTag"] = $b2c263e15de4bef1$export$962a8da34cf78a4f;

});

parcelRegister("77Vrx", function(module, exports) {
const $3c63915f1609dad1$export$7698df1946deda72 = (jsonLd)=>{
    const taskStatus = jsonLd['atlassian:taskStatus'];
    if (taskStatus && taskStatus.name) return {
        text: taskStatus.name,
        appearance: 'success'
    };
};
module.exports["extractTaskStatus"] = $3c63915f1609dad1$export$7698df1946deda72;

});

parcelRegister("hYTxH", function(module, exports) {
const $22c291da19a1c245$export$f222392162cff0d8 = (jsonLd)=>{
    const latestCommit = jsonLd['atlassian:latestCommit'];
    if (typeof latestCommit === 'string') return latestCommit;
    if (latestCommit) //todo: change the properties to latestCommit.hash when BE is ready
    return latestCommit ? latestCommit.name : undefined;
};
module.exports["extractLatestCommit"] = $22c291da19a1c245$export$f222392162cff0d8;

});

parcelRegister("gJj3k", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jpl1A = parcelRequire("jpl1A");


var $19zon = parcelRequire("19zon");

const $5b6c9e2393a4e885$export$b32b5f1ee4493319 = ({ childRef: childRef, className: className, extensionKey: extensionKey, ...props })=>{
    const confluencePageData = (0, $19zon.useConfluencePageData)(props.src || '', extensionKey || '');
    // Conditional rendering: Page component for lp-cc-embed URLs, iframe for everything else
    return confluencePageData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jpl1A.Page), {
        hostname: confluencePageData.hostname,
        spaceKey: confluencePageData.spaceKey,
        contentId: confluencePageData.contentId,
        parentProduct: confluencePageData.parentProduct,
        hash: confluencePageData.hash,
        mode: confluencePageData.mode,
        locale: confluencePageData.locale,
        iframeRef: childRef,
        onLoad: props.onLoad,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        sandbox: props.sandbox,
        allowedFeatures: confluencePageData.allowedFeatures,
        themeState: confluencePageData.themeStateObject,
        userInfo: confluencePageData.userInfo
    }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("iframe", {
        className: className,
        ...props,
        ref: childRef,
        title: props.title
    });
};
module.exports["IFrame"] = $5b6c9e2393a4e885$export$b32b5f1ee4493319;

});

parcelRegister("jpl1A", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cuq2s = parcelRequire("cuq2s");


var $ZTkH5 = parcelRequire("ZTkH5");


var $huDU4 = parcelRequire("huDU4");

const $4e16066777de6fa0$export$6955bcca4cd3539f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huDU4.Page), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props.locale || $[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cuq2s.I18nProvider), {
            locale: props.locale,
            fetchTranslations: (0, $ZTkH5.default)
        }, t0);
        $[2] = props.locale;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cuq2s.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $ZTkH5.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huDU4.Page), props));
module.exports["Page"] = $4e16066777de6fa0$export$6955bcca4cd3539f;

});

parcelRegister("cuq2s", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $q9Cpn = parcelRequire("q9Cpn");

const $cc5224b9f28cd9ed$export$a54013f0d02a8f82 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { children: children, locale: t1, fetchTranslations: fetchTranslations } = t0;
    const incomingLocale = t1 === undefined ? (0, $q9Cpn.DEFAULT_LOCALE) : t1;
    const [messages, setMessages] = (0, $cozmU.useState)();
    let t2;
    if ($[0] !== incomingLocale) {
        t2 = (0, $q9Cpn.normalizeLocale)(incomingLocale);
        $[0] = incomingLocale;
        $[1] = t2;
    } else t2 = $[1];
    const locale = t2;
    let t3;
    let t4;
    if ($[2] !== fetchTranslations || $[3] !== locale) {
        t3 = ()=>{
            const loadTranslations = async ()=>{
                const localeMessages = await fetchTranslations(locale);
                setMessages(localeMessages);
            };
            loadTranslations();
        };
        t4 = [
            fetchTranslations,
            locale
        ];
        $[2] = fetchTranslations;
        $[3] = locale;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $cozmU.useEffect)(t3, t4);
    if (!messages) return null;
    let t5;
    if ($[6] !== children || $[7] !== locale || $[8] !== messages) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            locale: locale,
            messages: messages,
            defaultLocale: (0, $q9Cpn.DEFAULT_LOCALE)
        }, children);
        $[6] = children;
        $[7] = locale;
        $[8] = messages;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : ({ children: children, locale: incomingLocale = (0, $q9Cpn.DEFAULT_LOCALE), fetchTranslations: fetchTranslations })=>{
    const [messages, setMessages] = (0, $cozmU.useState)();
    const locale = (0, $cozmU.useMemo)(()=>(0, $q9Cpn.normalizeLocale)(incomingLocale), [
        incomingLocale
    ]);
    (0, $cozmU.useEffect)(()=>{
        const loadTranslations = async ()=>{
            const localeMessages = await fetchTranslations(locale);
            setMessages(localeMessages);
        };
        loadTranslations();
    }, [
        fetchTranslations,
        locale
    ]);
    if (!messages) return null;
    // Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
    // They will not function correctly due to a lack of I18n context.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        locale: locale,
        messages: messages,
        defaultLocale: (0, $q9Cpn.DEFAULT_LOCALE)
    }, children);
};
module.exports["I18nProvider"] = $cc5224b9f28cd9ed$export$a54013f0d02a8f82;

});

parcelRegister("q9Cpn", function(module, exports) {
const $bacd93d5d71e2df6$var$DEFAULT_LANGUAGE = 'en';
const $bacd93d5d71e2df6$var$DEFAULT_REGION = 'US';
const $bacd93d5d71e2df6$export$1af4c7e47ad72f44 = `${$bacd93d5d71e2df6$var$DEFAULT_LANGUAGE}-${$bacd93d5d71e2df6$var$DEFAULT_REGION}`;
const $bacd93d5d71e2df6$var$languageToLongLocaleCode = {
    cs: 'cs-CZ',
    da: 'da-DK',
    de: 'de-DE',
    en: 'en-US',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hu: 'hu-HU',
    it: 'it-IT',
    ja: 'ja-JP',
    ko: 'ko-KR',
    // Both `no` and `nb` language codes refer to Norwegian. Refer both to long locale code as `no-NO`
    no: 'no-NO',
    nb: 'no-NO',
    nl: 'nl-NL',
    pl: 'pl-PL',
    ru: 'ru-RU',
    sv: 'sv-SE',
    th: 'th-TH',
    tr: 'tr-TR',
    uk: 'uk-UA',
    vi: 'vi-VN',
    zh: 'zh-CN'
};
const $bacd93d5d71e2df6$export$dca0327c9b9c6498 = (locale)=>{
    if (!locale) return $bacd93d5d71e2df6$export$1af4c7e47ad72f44;
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from the supplied locale.');
    const [, language, region] = match;
    const normalizedLanguage = (language ?? '').toLowerCase();
    const normalizedRegion = (region ?? '').toUpperCase();
    if (normalizedLanguage && normalizedRegion) return [
        normalizedLanguage,
        normalizedRegion
    ].join('-');
    const longLocaleCode = $bacd93d5d71e2df6$var$languageToLongLocaleCode[normalizedLanguage];
    return longLocaleCode ?? $bacd93d5d71e2df6$export$1af4c7e47ad72f44;
};
module.exports["DEFAULT_LOCALE"] = $bacd93d5d71e2df6$export$1af4c7e47ad72f44;
module.exports["normalizeLocale"] = $bacd93d5d71e2df6$export$dca0327c9b9c6498;

});

parcelRegister("ZTkH5", function(module, exports) {

var $bhgzl = parcelRequire("bhgzl");


var $kN2Vj = parcelRequire("kN2Vj");

const $7689e3ff3e3f1e38$var$fetchTranslations = async (locale)=>{
    switch(locale){
        case 'en-GB':
            return 0, $bhgzl.default;
        case 'en-US':
        default:
            return 0, $kN2Vj.default;
    }
};
var $7689e3ff3e3f1e38$export$2e2bcd8739ae039 = $7689e3ff3e3f1e38$var$fetchTranslations;
module.exports["default"] = $7689e3ff3e3f1e38$export$2e2bcd8739ae039;

});

parcelRegister("bhgzl", function(module, exports) {
$parcel$export(module.exports, "default", () => $934ba482728c60bf$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $934ba482728c60bf$export$2e2bcd8739ae039 = {
    'my.test.no-translate': 'My Test'
};

});

parcelRegister("kN2Vj", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ff8966a59ac9886$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $2ff8966a59ac9886$export$2e2bcd8739ae039 = {
    'my.test.no-translate': 'My Test'
};

});

parcelRegister("huDU4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bneqI = parcelRequire("bneqI");


var $kSwu1 = parcelRequire("kSwu1");


var $lNV6K = parcelRequire("lNV6K");


var $eqf9i = parcelRequire("eqf9i");

const $2a2f2045c781985c$var$ViewComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const { locale: locale } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== locale || $[1] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lNV6K.ViewPage), {
            locale: locale,
            ...props
        });
        $[0] = locale;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lNV6K.ViewPage), {
        locale: locale,
        ...props
    });
};
const $2a2f2045c781985c$var$EditComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const { locale: locale } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== locale || $[1] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eqf9i.EditPage), {
            locale: locale,
            ...props
        });
        $[0] = locale;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eqf9i.EditPage), {
        locale: locale,
        ...props
    });
};
const $2a2f2045c781985c$export$6955bcca4cd3539f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const { locale: locale } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== locale || $[1] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bneqI.Page), {
            locale: locale,
            ...props,
            viewComponent: $2a2f2045c781985c$var$ViewComponent,
            editComponent: $2a2f2045c781985c$var$EditComponent
        });
        $[0] = locale;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bneqI.Page), {
        locale: locale,
        ...props,
        viewComponent: $2a2f2045c781985c$var$ViewComponent,
        editComponent: $2a2f2045c781985c$var$EditComponent
    });
};
module.exports["Page"] = $2a2f2045c781985c$export$6955bcca4cd3539f;

});

parcelRegister("lNV6K", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cuq2s = parcelRequire("cuq2s");


var $ZTkH5 = parcelRequire("ZTkH5");


var $d6sBA = parcelRequire("d6sBA");

const $33123752fa9ae571$export$767e3006bdbb424a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6sBA.ViewPage), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props.locale || $[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cuq2s.I18nProvider), {
            locale: props.locale,
            fetchTranslations: (0, $ZTkH5.default)
        }, t0);
        $[2] = props.locale;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cuq2s.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $ZTkH5.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6sBA.ViewPage), props));
module.exports["ViewPage"] = $33123752fa9ae571$export$767e3006bdbb424a;

});

parcelRegister("d6sBA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $50kEc = parcelRequire("50kEc");


var $kSwu1 = parcelRequire("kSwu1");

const $f2833a7709cd73fa$export$767e3006bdbb424a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const { locale: locale } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== locale || $[1] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $50kEc.ViewPage), {
            locale: locale,
            ...props
        });
        $[0] = locale;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $50kEc.ViewPage), {
        locale: locale,
        ...props
    });
};
module.exports["ViewPage"] = $f2833a7709cd73fa$export$767e3006bdbb424a;

});

parcelRegister("eqf9i", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cuq2s = parcelRequire("cuq2s");


var $ZTkH5 = parcelRequire("ZTkH5");


var $b06A9 = parcelRequire("b06A9");

const $93cc002eb7ec4a9a$export$1fea75498367c4ac = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b06A9.EditPage), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props.locale || $[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cuq2s.I18nProvider), {
            locale: props.locale,
            fetchTranslations: (0, $ZTkH5.default)
        }, t0);
        $[2] = props.locale;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cuq2s.I18nProvider), {
        locale: props.locale,
        fetchTranslations: (0, $ZTkH5.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b06A9.EditPage), props));
module.exports["EditPage"] = $93cc002eb7ec4a9a$export$1fea75498367c4ac;

});

parcelRegister("b06A9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4nZvv = parcelRequire("4nZvv");


var $kSwu1 = parcelRequire("kSwu1");

const $3470eb5cef855d36$export$1fea75498367c4ac = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const { locale: locale } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== locale || $[1] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4nZvv.EditPage), {
            locale: locale,
            ...props
        });
        $[0] = locale;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    const { locale: locale } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4nZvv.EditPage), {
        locale: locale,
        ...props
    });
};
module.exports["EditPage"] = $3470eb5cef855d36$export$1fea75498367c4ac;

});

parcelRegister("19zon", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $k4lqb = parcelRequire("k4lqb");


var $jIrdU = parcelRequire("jIrdU");

var $0848f0766ba8a46c$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $0848f0766ba8a46c$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
var $0848f0766ba8a46c$export$dc091dbfc779121b = /*#__PURE__*/ function(CONFLUENCE_EXTENSION_KEYS) {
    CONFLUENCE_EXTENSION_KEYS["PAGE"] = "integration-confluence-object-provider";
    CONFLUENCE_EXTENSION_KEYS["CANVAS"] = "canvas-native-object-provider";
    return CONFLUENCE_EXTENSION_KEYS;
}({});
const $0848f0766ba8a46c$export$10fb2803bc7b79fc = (url, extensionKey)=>{
    const parsedData = (0, $cozmU.useMemo)(()=>{
        if (!url || typeof url !== 'string' || !url.startsWith('http://') && !url.startsWith('https://') || !extensionKey || !Object.values($0848f0766ba8a46c$export$dc091dbfc779121b).find((key)=>key === extensionKey)) return undefined;
        let urlObj;
        try {
            urlObj = new URL(url);
        } catch  {
            return undefined;
        }
        const { searchParams: searchParams, hash: hash } = urlObj;
        const hostname = searchParams?.get('hostname') || '';
        const contentId = searchParams?.get('contentId') || '';
        const spaceKey = searchParams?.get('spaceKey') || '';
        // Early return for invalid URLs
        if (!contentId || !hostname) return undefined;
        const themeState = searchParams?.get('themeState') || '';
        const themeMode = searchParams?.get('themeMode');
        const enableInlineComments = searchParams?.get('enableInlineComments') === 'true';
        const enablePageComments = searchParams?.get('enablePageComments') === 'true';
        const userId = searchParams?.get('userId') || '';
        const userIdType = searchParams?.get('userInfo') || undefined;
        const parentProduct = searchParams?.get('parentProduct') || '';
        const inlineComments = enableInlineComments ? [
            'inline-comments'
        ] : [];
        const pageComments = enablePageComments ? [
            'page-comments'
        ] : [];
        // Calculate theme state object here
        let calculatedThemeStateObject;
        if (themeState) calculatedThemeStateObject = (0, $jIrdU.themeStringToObject)(decodeURIComponent(themeState));
        else if (themeMode) calculatedThemeStateObject = {
            colorMode: themeMode
        };
        const calculatedUserInfo = userId && userIdType ? {
            userId: userId,
            userIdType: userIdType
        } : undefined;
        return {
            hostname: hostname,
            spaceKey: spaceKey,
            contentId: contentId,
            parentProduct: parentProduct,
            userInfo: calculatedUserInfo,
            hash: hash || '',
            enableInlineComments: enableInlineComments,
            enablePageComments: enablePageComments,
            themeStateObject: calculatedThemeStateObject,
            allowedFeatures: {
                edit: [
                    'delete-draft'
                ],
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-reactions',
                    ...pageComments,
                    ...inlineComments
                ]
            },
            mode: "view",
            locale: 'en'
        };
    }, [
        url,
        extensionKey
    ]);
    // Handle theme side effect - only when theme object changes
    (0, $cozmU.useEffect)(()=>{
        if (parsedData?.themeStateObject) (0, $k4lqb.default)(parsedData.themeStateObject);
    }, [
        parsedData?.themeStateObject
    ]);
    return parsedData;
};
module.exports["useConfluencePageData"] = $0848f0766ba8a46c$export$10fb2803bc7b79fc;

});

parcelRegister("hMKdq", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ctzvi = parcelRequire("ctzvi");

const $e93c907c43f1ec9c$var$UniqueKeyContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    uniqueKey: undefined
});
const $e93c907c43f1ec9c$export$71829d27b87a2006 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $ctzvi.createUniqueKey)();
        $[0] = t1;
    } else t1 = $[0];
    const uniqueKey = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            uniqueKey: uniqueKey
        };
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e93c907c43f1ec9c$var$UniqueKeyContext.Provider, {
            value: t2
        }, children);
        $[2] = children;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ({ children: children })=>{
    const uniqueKey = (0, $cozmU.useMemo)(()=>(0, $ctzvi.createUniqueKey)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e93c907c43f1ec9c$var$UniqueKeyContext.Provider, {
        value: {
            uniqueKey: uniqueKey
        }
    }, children);
};
const $e93c907c43f1ec9c$export$cef64a0cfb90e369 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e93c907c43f1ec9c$var$UniqueKeyContext);
} : ()=>{
    return (0, $cozmU.useContext)($e93c907c43f1ec9c$var$UniqueKeyContext);
};
module.exports["UniqueKeyProvider"] = $e93c907c43f1ec9c$export$71829d27b87a2006;
module.exports["useUniqueKey"] = $e93c907c43f1ec9c$export$cef64a0cfb90e369;

});

parcelRegister("lWz4S", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iRK7f = parcelRequire("iRK7f");


var $hDLmU = parcelRequire("hDLmU");

// PerformanceMetricsProvider is only applied to internal EP
// Methods provided by PerformanceMetricsContext are defined by default as () => {}
// This allows instances not wrapped in provider (ie embedded-confluence public) to opperate without errors
const $495e0a92c5164d61$var$PerformanceMetricsContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    isInitialized: false,
    cancelIframeLoadMetrics: ()=>{},
    markIframeLoadMetrics: ()=>{},
    setContentType: ()=>{}
});
// calculate timestamp from iframe's performance metric post message
// relative to parent's window.performance.now() adjusted for post message latency
const $495e0a92c5164d61$var$adjustedPerformanceTimestamp = (timestamp)=>typeof timestamp === 'number' ? window.performance.now() - (Date.now() - timestamp) : undefined;
const $495e0a92c5164d61$var$Provider = ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const [currentContentType, setCurrentContentType] = (0, $cozmU.useState)(contentType);
    const isInitialized = (0, $cozmU.useRef)(true);
    const iframeLoadMetrics = (0, $cozmU.useRef)();
    const embeddedViewToEditTransitionTimer = (0, $cozmU.useRef)();
    (0, $cozmU.useLayoutEffect)(()=>{
        // TODO: Currently EP does not work with more that one instance per parent window
        // When this limitation is fixed we will also need to find a way to serialize post messages
        // this is because post message listeners will pick up on all messages coming to the parent window
        // triggering any callback listening to a given data.type message
        // therefore messages will need to be scoped to the particular instance they are intended for
        embeddedViewToEditTransitionTimer.current?.cancel();
        embeddedViewToEditTransitionTimer.current = (0, $iRK7f.embeddedViewToEditTransitionMetric)();
        // Setup iframe post message handling
        const handler = (e)=>{
            let uniqueKey;
            try {
                uniqueKey = new URL(window.location.href).searchParams.get('uniqueKey');
            } catch (error) {
                uniqueKey = null;
            }
            // Validate uniqueKey (if it exists) to avoid race condition between multiple embedded confluence instances
            if (!e.data.payload?.customData?.uniqueKey || !uniqueKey || e.data.payload.customData.uniqueKey === uniqueKey) switch(e.data.type){
                case (0, $hDLmU.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $hDLmU.EMBEDDED_VIEW_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $495e0a92c5164d61$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $hDLmU.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $hDLmU.EMBEDDED_EDITOR_TTI):
                    iframeLoadMetrics.current?.stop({
                        stopTime: $495e0a92c5164d61$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    embeddedViewToEditTransitionTimer.current?.stop({
                        stopTime: $495e0a92c5164d61$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp),
                        customData: sourceComponent ? {
                            sourceComponent: sourceComponent
                        } : undefined
                    });
                    break;
                case (0, $hDLmU.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $hDLmU.EMBEDDED_EDIT_CLICK):
                    embeddedViewToEditTransitionTimer.current?.start({
                        startTime: $495e0a92c5164d61$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp)
                    });
                    break;
                case (0, $hDLmU.EMBEDDED_CONFLUENCE_METRICS_PREFIX) + (0, $hDLmU.EMBEDDED_IFRAME_CONTENT_INITIALIZED):
                    iframeLoadMetrics.current?.mark('iframe-content-initialized-end', $495e0a92c5164d61$var$adjustedPerformanceTimestamp(e.data.payload?.timestamp));
                    break;
            }
        };
        window.addEventListener('message', handler);
        const currentTransitionTimer = embeddedViewToEditTransitionTimer.current;
        return ()=>{
            window.removeEventListener('message', handler);
            currentTransitionTimer.cancel();
        };
    }, [
        embeddedViewToEditTransitionTimer,
        sourceComponent
    ]);
    // Set load metric based on content type
    (0, $cozmU.useLayoutEffect)(()=>{
        if (currentContentType) {
            // cancel current Embedded Confluence iframe load metric if necessary
            iframeLoadMetrics.current?.cancel();
            iframeLoadMetrics.current = (0, $iRK7f.embeddedConfluenceIframeLoadMetrics)(currentContentType);
            // start Embedded Confluence iframe load metric
            iframeLoadMetrics.current?.start();
            iframeLoadMetrics.current?.mark('lazy-load-start');
        }
        return ()=>{
            iframeLoadMetrics.current?.cancel();
        };
    }, [
        currentContentType,
        sourceComponent
    ]);
    const cancelIframeLoadMetrics = (0, $cozmU.useCallback)(()=>{
        iframeLoadMetrics.current?.cancel();
    }, []);
    const markIframeLoadMetrics = (0, $cozmU.useCallback)((markName)=>{
        iframeLoadMetrics.current?.mark(markName);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($495e0a92c5164d61$var$PerformanceMetricsContext.Provider, {
        value: {
            cancelIframeLoadMetrics: cancelIframeLoadMetrics,
            markIframeLoadMetrics: markIframeLoadMetrics,
            isInitialized: isInitialized.current,
            setContentType: setCurrentContentType
        }
    }, children);
};
const $495e0a92c5164d61$export$865423e6f8e2e839 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($495e0a92c5164d61$var$PerformanceMetricsContext);
} : ()=>{
    return (0, $cozmU.useContext)($495e0a92c5164d61$var$PerformanceMetricsContext);
};
const $495e0a92c5164d61$export$c6f19d9afc6c86c8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { children: children, contentType: contentType, sourceComponent: sourceComponent } = t0;
    const { isInitialized: isInitialized, setContentType: setContentType } = $495e0a92c5164d61$export$865423e6f8e2e839();
    let t1;
    let t2;
    if ($[0] !== contentType || $[1] !== isInitialized || $[2] !== setContentType) {
        t1 = ()=>{
            isInitialized && contentType && setContentType(contentType);
        };
        t2 = [
            isInitialized,
            contentType,
            setContentType
        ];
        $[0] = contentType;
        $[1] = isInitialized;
        $[2] = setContentType;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    if ($[5] !== children || $[6] !== contentType || $[7] !== isInitialized || $[8] !== sourceComponent) {
        t3 = !isInitialized ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($495e0a92c5164d61$var$Provider, {
            contentType: contentType,
            sourceComponent: sourceComponent
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[5] = children;
        $[6] = contentType;
        $[7] = isInitialized;
        $[8] = sourceComponent;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ children: children, contentType: contentType, sourceComponent: sourceComponent })=>{
    const { isInitialized: isInitialized, setContentType: setContentType } = $495e0a92c5164d61$export$865423e6f8e2e839();
    (0, $cozmU.useLayoutEffect)(()=>{
        // Update contentType when Page component replaces ViewPage with EditPage or vice versa
        isInitialized && contentType && setContentType(contentType);
    }, [
        isInitialized,
        contentType,
        setContentType
    ]);
    return !isInitialized ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($495e0a92c5164d61$var$Provider, {
        contentType: contentType,
        sourceComponent: sourceComponent
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
module.exports["usePerformanceMetrics"] = $495e0a92c5164d61$export$865423e6f8e2e839;
module.exports["PerformanceMetricsProvider"] = $495e0a92c5164d61$export$c6f19d9afc6c86c8;

});

parcelRegister("iRK7f", function(module, exports) {

var $iDdTC = parcelRequire("iDdTC");


var $lCTbz = parcelRequire("lCTbz");

const $e6b49468896929e5$export$4de078c3b9971f9b = ()=>(0, $iDdTC.metrics).interaction({
        key: 'embedded-confluence-view-to-edit-transition'
    });
const $e6b49468896929e5$var$timings = [
    {
        key: 'lazy-load',
        startMark: 'lazy-load-start',
        endMark: 'lazy-load-end'
    },
    {
        key: 'common-load',
        startMark: 'common-load-start',
        endMark: 'common-load-end'
    },
    {
        key: 'iframe-content-initialized',
        startMark: 'iframe-content-initialized-start',
        endMark: 'iframe-content-initialized-end'
    }
];
const $e6b49468896929e5$var$loadingMetricsConfig = {
    viewPage: {
        key: 'embedded-confluence-view-page-iframe',
        type: (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $e6b49468896929e5$var$timings
    },
    editPage: {
        key: 'embedded-confluence-edit-page-iframe',
        type: (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD,
        timings: $e6b49468896929e5$var$timings
    }
};
const $e6b49468896929e5$export$a23245993532c751 = (contentType)=>(0, $iDdTC.metrics).pageSegmentLoad($e6b49468896929e5$var$loadingMetricsConfig[contentType]);
module.exports["embeddedViewToEditTransitionMetric"] = $e6b49468896929e5$export$4de078c3b9971f9b;
module.exports["embeddedConfluenceIframeLoadMetrics"] = $e6b49468896929e5$export$a23245993532c751;

});

parcelRegister("hDLmU", function(module, exports) {
const $b5c2a7dcc1a96b34$export$ad3f29048eb3061 = 'embedded-confluence-metrics.';
const $b5c2a7dcc1a96b34$export$e5b04c2a3cc97ddc = 'embedded-view-tti';
const $b5c2a7dcc1a96b34$export$9f8bbf62fac57d48 = 'embedded-editor-tti';
const $b5c2a7dcc1a96b34$export$e08d2ab8ef653595 = 'embedded-edit-click';
const $b5c2a7dcc1a96b34$export$73b982309451f084 = 'embedded-iframe-content-initialized';
module.exports["EMBEDDED_CONFLUENCE_METRICS_PREFIX"] = $b5c2a7dcc1a96b34$export$ad3f29048eb3061;
module.exports["EMBEDDED_VIEW_TTI"] = $b5c2a7dcc1a96b34$export$e5b04c2a3cc97ddc;
module.exports["EMBEDDED_EDITOR_TTI"] = $b5c2a7dcc1a96b34$export$9f8bbf62fac57d48;
module.exports["EMBEDDED_EDIT_CLICK"] = $b5c2a7dcc1a96b34$export$e08d2ab8ef653595;
module.exports["EMBEDDED_IFRAME_CONTENT_INITIALIZED"] = $b5c2a7dcc1a96b34$export$73b982309451f084;

});

parcelRegister("ij75C", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fcaWu = parcelRequire("fcaWu");


var $36Uax = parcelRequire("36Uax");


var $hMKdq = parcelRequire("hMKdq");


var $kTPbu = parcelRequire("kTPbu");

var $bVevd = parcelRequire("bVevd");


var $eAWIs = parcelRequire("eAWIs");

const $1ae0fabae864f28a$export$6e43e60d51b79331 = (themeState)=>{
    const themeString = (0, $fcaWu.themeObjectToString)(themeState);
    return encodeURIComponent(themeString);
};
const $1ae0fabae864f28a$var$serializeQueryParams = (queryParams)=>queryParams ? new URLSearchParams(Object.entries(queryParams).sort(([paramA], [paramB])=>paramA.localeCompare(paramB))).toString() : '';
const $1ae0fabae864f28a$var$STARGATE_CONFLUENCE_PROXY = '/gateway/api/ex/confluence/';
const $1ae0fabae864f28a$var$nonAllFeatures = [
    'modern-header',
    'disable-help-button',
    'disable-title-toolbar'
];
const $1ae0fabae864f28a$export$305222dff575c4e3 = ({ allowedFeatures: allowedFeatures, contentId: contentId, contentType: contentType, contentConfiguration: contentConfiguration, draftShareId: draftShareId, hash: hash, hostname: hostname, mode: mode, parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, parentProductContentId: parentProductContentId, previewPanels: previewPanels, protocol: protocol, queryParams: consumerQueryParams, spaceKey: spaceKey, template: template, themeState: themeState, embeddedConfluenceSource: embeddedConfluenceSource })=>{
    const initialAllowedFeaturesRef = (0, $cozmU.useRef)(undefined);
    // Keep `initialAllowedFeatures` to only contain the initial allowed feature values for cc-frontend SSR rendering
    // Store this value using `useRef` to avoid the iframe url gets updated when `allowedFeatures` React props updated by parent products.
    // If allowedFeatures is equal to 'all' for view mode it must be converted to an array so that 'edit' can be removed.
    const features = (0, $cozmU.useMemo)(()=>allowedFeatures === 'all' ? (0, $36Uax.getAllowedFeatures)({
            contentType: contentType,
            mode: mode
        }) : allowedFeatures, [
        allowedFeatures,
        contentType,
        mode
    ]);
    if (!initialAllowedFeaturesRef.current) initialAllowedFeaturesRef.current = Array.isArray(features) ? features.map((feature)=>{
        if (typeof feature !== 'string') return JSON.stringify(feature);
        else return feature;
    })// 'edit' can not be included as an initialAllowedFeature because it requires the navigation policy, which does not work with SSR.
    // 'enable-redirection' should not be included in initial allowed features unless a parent has passed this in as an allowedFeature in the correct format.
    .filter((feature_0)=>feature_0 !== 'edit' && feature_0 !== 'enable-redirection')// 'modern-header' should not be included in initial allowed features when allowedFeatures is 'all'
    .filter((feature_1)=>!$1ae0fabae864f28a$var$nonAllFeatures.includes(feature_1)).join('.') : features;
    // check whether re-direction is enabled
    const enableRedirectionFeature = features && features !== 'all' ? features.find((feature_2)=>(0, $eAWIs.isRedirectionEnabled)(feature_2)) : undefined;
    const crossSiteTenantId = enableRedirectionFeature ? (0, $eAWIs.getCrossSiteTenantIdFromAllowedFeature)(enableRedirectionFeature) : undefined;
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const { uniqueKey: uniqueKey } = (0, $hMKdq.useUniqueKey)();
    const consumerQueryParamsString = $1ae0fabae864f28a$var$serializeQueryParams(consumerQueryParams);
    const contentConfigurationQueryParamsString = $1ae0fabae864f28a$var$serializeQueryParams(contentConfiguration?.queryParams);
    const queryParams = (0, $cozmU.useMemo)(()=>{
        const query = {};
        if (parentProduct) query.parentProduct = parentProduct;
        if (parentProductContentContainerId) query.parentProductContentContainerId = parentProductContentContainerId;
        if (parentProductContentId) query.parentProductContentId = parentProductContentId;
        if (initialAllowedFeaturesRef.current !== undefined) query.initialAllowedFeatures = initialAllowedFeaturesRef.current;
        if (template) query.insertTemplateWithKey = template;
        if (themeState) query.themeState = $1ae0fabae864f28a$export$6e43e60d51b79331(themeState);
        if (draftShareId) query.draftShareId = draftShareId;
        if (embeddedConfluenceSource) query.embeddedConfluenceSource = embeddedConfluenceSource;
        if (previewPanels) query.previewPanels = previewPanels;
        if (hostname && hostname !== window.location.host) query.isCrossDomain = true;
        if (uniqueKey) query.uniqueKey = uniqueKey;
        query.locale = locale;
        const { isCrossDomain: isCrossDomain, ...restQuery } = query;
        const searchParams = new URLSearchParams({
            ...isCrossDomain ? {
                isCrossDomain: `${isCrossDomain}`
            } : {},
            ...restQuery
        });
        new URLSearchParams(consumerQueryParamsString).forEach((value, key)=>{
            if (!searchParams.has(key)) searchParams.set(key, value);
        });
        new URLSearchParams(contentConfigurationQueryParamsString).forEach((value_0, key_0)=>{
            searchParams.set(key_0, value_0);
        });
        return `?${searchParams.toString()}`;
    }, [
        consumerQueryParamsString,
        contentConfigurationQueryParamsString,
        draftShareId,
        locale,
        parentProduct,
        parentProductContentContainerId,
        parentProductContentId,
        previewPanels,
        themeState,
        hostname,
        embeddedConfluenceSource,
        template,
        uniqueKey
    ]);
    return (0, $cozmU.useMemo)(()=>({
            ...$1ae0fabae864f28a$var$constructUrl(mode, {
                contentId: contentId,
                contentType: contentType,
                hash: hash,
                hostname: hostname,
                protocol: protocol,
                spaceKey: spaceKey,
                queryParams: queryParams,
                crossSiteTenantId: crossSiteTenantId
            })
        }), [
        contentId,
        contentType,
        hash,
        hostname,
        mode,
        protocol,
        spaceKey,
        queryParams,
        crossSiteTenantId
    ]);
};
const $1ae0fabae864f28a$var$CONTEXT_PATH = '/wiki/spaces';
const $1ae0fabae864f28a$var$invalidUrls = {
    standaloneConfluenceUrl: null,
    embeddedConfluenceUrl: null
};
function $1ae0fabae864f28a$var$constructUrl(mode = (0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE, { contentId: contentId, contentType: contentType, hash: hash = '', hostname: hostname, protocol: protocol, spaceKey: spaceKey, queryParams: queryParams, crossSiteTenantId: crossSiteTenantId }) {
    if (contentType !== (0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE && !contentId) {
        /* eslint-disable-next-line no-console */ console.error('Content ID is undefined');
        return $1ae0fabae864f28a$var$invalidUrls;
    }
    if (!spaceKey) {
        /* eslint-disable-next-line no-console */ console.error('Space key is undefined');
        return $1ae0fabae864f28a$var$invalidUrls;
    }
    if (/^\d+$/.test(spaceKey)) /* eslint-disable-next-line no-console */ console.warn('A numeric "spaceKey" is passed into the Embedded Confluence component. Verify that it is the correct "spaceKey" and not the "spaceId." Disregard this warning if it is correct.');
    const prefix = `${protocol || window.location.protocol}//${hostname || window.location.host}${$1ae0fabae864f28a$var$CONTEXT_PATH}`;
    const prefixWithStargate = crossSiteTenantId ? `${protocol || window.location.protocol}//${window.location.host //take the parent site because want don't want it to be cross-site EP
    }${$1ae0fabae864f28a$var$STARGATE_CONFLUENCE_PROXY}${crossSiteTenantId}${$1ae0fabae864f28a$var$CONTEXT_PATH}` : undefined;
    let base;
    const pageUrl = {
        [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: contentId ? `${spaceKey}/pages/${contentId}` : `${spaceKey}/overview`,
        [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const blogpostUrl = {
        [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/pages/${contentId}`,
        [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/pages/edit-embed/${contentId}`
    };
    const whiteboardUrl = {
        [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).VIEW_MODE]: `${spaceKey}/whiteboard/${contentId}`,
        [(0, $bVevd.EMBEDDED_CONFLUENCE_MODE).EDIT_MODE]: `${spaceKey}/whiteboard/${contentId}`
    };
    const contentTypeUrl = {
        [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).PAGE]: pageUrl,
        [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).BLOGPOST]: blogpostUrl,
        [(0, $kTPbu.EMBEDDED_CONFLUENCE_CONTENT_TYPE).WHITEBOARD]: whiteboardUrl
    };
    base = contentTypeUrl[contentType]?.[mode];
    if (!base) {
        /* eslint-disable-next-line no-console */ console.error('URL is not yet supported');
        return $1ae0fabae864f28a$var$invalidUrls;
    }
    const standaloneConfluenceUrl = `${prefix}/${base}${hash}`;
    const embeddedConfluenceUrl = `${prefixWithStargate ?? prefix}/${base}${queryParams}${hash}`;
    return {
        standaloneConfluenceUrl: standaloneConfluenceUrl,
        embeddedConfluenceUrl: embeddedConfluenceUrl
    };
}
module.exports["themeStateObjectToQueryString"] = $1ae0fabae864f28a$export$6e43e60d51b79331;
module.exports["useUrl"] = $1ae0fabae864f28a$export$305222dff575c4e3;

});

parcelRegister("eAWIs", function(module, exports) {
const $66050da24b77bea6$var$IN_EDITOR_TEMPLATES_PANEL_ALLOWED_FEATURES = [
    'template-browser',
    'template-browser-panel'
];
const $66050da24b77bea6$var$hasAllowedFeature = (feature, featureName)=>{
    if (typeof feature === 'string') return feature === featureName;
    if (feature && typeof feature === 'object') return Object.prototype.hasOwnProperty.call(feature, featureName);
    return false;
};
const $66050da24b77bea6$export$b47e8b0fa2aae156 = (allowedFeatures)=>{
    if (allowedFeatures === 'all') return true;
    return allowedFeatures?.some((feature)=>$66050da24b77bea6$var$IN_EDITOR_TEMPLATES_PANEL_ALLOWED_FEATURES.some((featureName)=>$66050da24b77bea6$var$hasAllowedFeature(feature, featureName))) ?? false;
};
const $66050da24b77bea6$export$51abd16148027412 = (feature)=>{
    if (typeof feature === 'object') return 'enable-redirection' in feature;
    if (typeof feature === 'string') try {
        const parsedFeature = JSON.parse(feature);
        return parsedFeature && typeof parsedFeature === 'object' && 'enable-redirection' in parsedFeature;
    } catch  {
        return false;
    }
    return false;
};
const $66050da24b77bea6$export$243fbba563b8aa8e = (feature)=>{
    if (!feature) return undefined;
    if (typeof feature === 'string') try {
        const parsed = JSON.parse(feature);
        return parsed['enable-redirection']?.['cross-site-tenant-id'];
    } catch  {
        return undefined;
    }
    return feature['enable-redirection']?.['cross-site-tenant-id'];
};
module.exports["isInEditorTemplatesPanelEnabled"] = $66050da24b77bea6$export$b47e8b0fa2aae156;
module.exports["isRedirectionEnabled"] = $66050da24b77bea6$export$51abd16148027412;
module.exports["getCrossSiteTenantIdFromAllowedFeature"] = $66050da24b77bea6$export$243fbba563b8aa8e;

});

parcelRegister("3Xkfu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kkFbH = parcelRequire("kkFbH");


var $fBqzD = parcelRequire("fBqzD");


var $iMQz5 = parcelRequire("iMQz5");


var $fHe6f = parcelRequire("fHe6f");


var $ahlZa = parcelRequire("ahlZa");


var $3CYX0 = parcelRequire("3CYX0");


var $39Mwn = parcelRequire("39Mwn");


var $6MsAF = parcelRequire("6MsAF");


var $38zdI = parcelRequire("38zdI");


var $cVpj0 = parcelRequire("cVpj0");


var $gITbz = parcelRequire("gITbz");


var $bvjEB = parcelRequire("bvjEB");


var $jMFOf = parcelRequire("jMFOf");


var $a5G9M = parcelRequire("a5G9M");


var $S7fVP = parcelRequire("S7fVP");


var $ixfCV = parcelRequire("ixfCV");


var $hhrxw = parcelRequire("hhrxw");


var $jrSlu = parcelRequire("jrSlu");


var $jawC3 = parcelRequire("jawC3");

const $f1ce3764841d3d06$var$extractorPriorityMap = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};
const $f1ce3764841d3d06$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $f1ce3764841d3d06$var$getEmptyJsonLd = ()=>$f1ce3764841d3d06$var$emptyData;
const $f1ce3764841d3d06$var$prioritiseIcon = ({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon })=>urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
const $f1ce3764841d3d06$var$extractTaskType = (jsonLd)=>{
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $jawC3.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};
const $f1ce3764841d3d06$var$extractFileFormat = (jsonLd)=>jsonLd['schema:fileFormat'];
const $f1ce3764841d3d06$var$documentLabel = (opts, label)=>{
    if (!opts.showIconLabel) return '';
    return (0, $ixfCV.fg)('platform_navx_smart_link_icon_label_a11y') ? label : opts.title || label;
};

const $f1ce3764841d3d06$var$getBlogIconWrapped = ()=>(parcelRequire("6kJW0")).default;

const $f1ce3764841d3d06$var$getDocumentIcon = ()=>(parcelRequire("9v3GN")).default;

const $f1ce3764841d3d06$var$getFileIcon = ()=>(parcelRequire("4Emmj")).default;

const $f1ce3764841d3d06$var$getLiveDocumentIconWrapped = ()=>(parcelRequire("dGdE6")).default;

const $f1ce3764841d3d06$var$getPresentationIcon = ()=>(parcelRequire("b5Dss")).default;

const $f1ce3764841d3d06$var$getSpreadsheetIcon = ()=>(parcelRequire("7vzLW")).default;
const $f1ce3764841d3d06$var$digitalDocumentToIcon = (opts)=>{
    if (opts.provider?.id && (0, $jawC3.isConfluenceGenerator)(opts.provider.id)) {
        const LiveDocumentIconWrapped = $f1ce3764841d3d06$var$getLiveDocumentIconWrapped();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LiveDocumentIconWrapped, {
            label: $f1ce3764841d3d06$var$documentLabel(opts, 'live document'),
            testId: "live-doc-icon"
        });
    }
    const FileIcon = $f1ce3764841d3d06$var$getFileIcon();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(FileIcon, {
        label: $f1ce3764841d3d06$var$documentLabel(opts, 'file'),
        testId: "file-icon"
    });
};
const $f1ce3764841d3d06$var$documentTypeToIcon = (type, opts)=>{
    switch(type){
        case 'schema:BlogPosting':
            {
                const BlogIconWrapped = $f1ce3764841d3d06$var$getBlogIconWrapped();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BlogIconWrapped, {
                    label: $f1ce3764841d3d06$var$documentLabel(opts, 'blog'),
                    testId: "blog-icon"
                });
            }
        case 'schema:DigitalDocument':
            return $f1ce3764841d3d06$var$digitalDocumentToIcon(opts);
        case 'schema:TextDigitalDocument':
            {
                const DocumentIcon = $f1ce3764841d3d06$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DocumentIcon, {
                    label: $f1ce3764841d3d06$var$documentLabel(opts, 'document'),
                    testId: "document-icon"
                });
            }
        case 'schema:PresentationDigitalDocument':
            {
                const PresentationIcon = $f1ce3764841d3d06$var$getPresentationIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PresentationIcon, {
                    label: $f1ce3764841d3d06$var$documentLabel(opts, 'presentation'),
                    testId: "presentation-icon"
                });
            }
        case 'schema:SpreadsheetDigitalDocument':
            {
                const SpreadsheetIcon = $f1ce3764841d3d06$var$getSpreadsheetIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SpreadsheetIcon, {
                    label: $f1ce3764841d3d06$var$documentLabel(opts, 'spreadsheet'),
                    testId: "spreadsheet-icon"
                });
            }
        case 'atlassian:Template':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), {
                color: "currentColor",
                label: $f1ce3764841d3d06$var$documentLabel(opts, 'template'),
                testId: "document-filled-icon"
            });
        case 'atlassian:UndefinedLink':
            {
                const DocumentIcon = $f1ce3764841d3d06$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DocumentIcon, {
                    label: $f1ce3764841d3d06$var$documentLabel(opts, 'document'),
                    testId: "document-icon"
                });
            }
    }
};
const $f1ce3764841d3d06$var$extractIconFromDocument = (type, opts)=>{
    const iconFromType = $f1ce3764841d3d06$var$documentTypeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $jrSlu.getIconForFileType)(opts.fileFormat, (0, $ixfCV.fg)('platform_navx_smart_link_icon_label_a11y') ? opts.showIconLabel : undefined) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return $f1ce3764841d3d06$var$prioritiseIcon({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $f1ce3764841d3d06$var$extractIconFromTask = (opts)=>{
    const { taskType: taskType, provider: provider } = opts;
    const legacyTaskLabel = opts.title || 'task';
    const getLabel = (semantic)=>(0, $ixfCV.fg)('platform_navx_smart_link_icon_label_a11y') ? semantic : legacyTaskLabel;
    const defaultIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5G9M.default), {
        label: getLabel('Task'),
        testId: "default-task-icon"
    });
    if (provider && provider.id === (0, $hhrxw.JIRA_GENERATOR_ID) && taskType && taskType.id) {
        const taskTypeId = taskType.id;
        const taskTypeName = taskTypeId.split('#').pop();
        switch(taskTypeName){
            case 0, $hhrxw.JIRA_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5G9M.default), {
                    label: getLabel('Task'),
                    testId: "jira-task-icon"
                });
            case 0, $hhrxw.JIRA_SUB_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jMFOf.default), {
                    label: getLabel('Sub-task'),
                    testId: "jira-subtask-icon"
                });
            case 0, $hhrxw.JIRA_STORY:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bvjEB.default), {
                    label: getLabel('Story'),
                    testId: "jira-story-icon"
                });
            case 0, $hhrxw.JIRA_BUG:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fHe6f.default), {
                    label: getLabel('Bug'),
                    testId: "jira-bug-icon"
                });
            case 0, $hhrxw.JIRA_EPIC:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6MsAF.default), {
                    label: getLabel('Epic'),
                    testId: "jira-epic-icon"
                });
            case 0, $hhrxw.JIRA_INCIDENT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38zdI.default), {
                    label: getLabel('Incident'),
                    testId: "jira-incident-icon"
                });
            case 0, $hhrxw.JIRA_SERVICE_REQUEST:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $S7fVP.default), {
                    label: getLabel('Service request'),
                    testId: "jira-service-request-icon"
                });
            case 0, $hhrxw.JIRA_CHANGE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ahlZa.default), {
                    label: getLabel('Change'),
                    testId: "jira-change-icon"
                });
            case 0, $hhrxw.JIRA_PROBLEM:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cVpj0.default), {
                    label: getLabel('Problem'),
                    testId: "jira-problem-icon"
                });
            case 0, $hhrxw.JIRA_CUSTOM_TASK_TYPE:
                return taskType.icon || opts.icon || provider.icon || defaultIcon;
        }
    }
    return defaultIcon;
};
const $f1ce3764841d3d06$var$typeToIcon = (type, opts)=>{
    const getLabel = (title)=>(0, $ixfCV.fg)('platform_navx_smart_link_icon_label_a11y') ? title : opts.title || title;
    switch(type){
        case 'atlassian:SourceCodeCommit':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39Mwn.default), {
                label: getLabel('commit'),
                testId: "commit-icon"
            });
        case 'atlassian:Project':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fBqzD))), {
                label: getLabel('project'),
                testId: "project-icon",
                color: "currentColor"
            });
        case 'atlassian:SourceCodePullRequest':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gITbz.default), {
                label: getLabel('pull request'),
                testId: "pull-request-icon"
            });
        case 'atlassian:SourceCodeReference':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMQz5.default), {
                label: getLabel('reference'),
                testId: "branch-icon"
            });
        case 'atlassian:SourceCodeRepository':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3CYX0.default), {
                label: getLabel('repository'),
                testId: "repo-icon"
            });
        case 'atlassian:Goal':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5G9M.default), {
                label: getLabel('goal'),
                testId: "task-icon"
            });
        case 'atlassian:Task':
            return $f1ce3764841d3d06$var$extractIconFromTask(opts);
        default:
            return undefined;
    }
};
const $f1ce3764841d3d06$var$standardisedExtractIcon = (type, opts)=>{
    const iconFromType = $f1ce3764841d3d06$var$typeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $jrSlu.getIconForFileType)(opts.fileFormat, (0, $ixfCV.fg)('platform_navx_smart_link_icon_label_a11y') ? opts.showIconLabel : undefined) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return $f1ce3764841d3d06$var$prioritiseIcon({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $f1ce3764841d3d06$var$extractIconByType = (type, opts)=>{
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            return $f1ce3764841d3d06$var$extractIconFromDocument(type, opts);
        default:
            return type ? $f1ce3764841d3d06$var$standardisedExtractIcon(type, opts) : undefined;
    }
};
const $f1ce3764841d3d06$var$extractIcon = (jsonLd, priority = 'type', showIconLabel = true)=>{
    const type = jsonLd['@type'];
    const opts = {
        ...(0, $ixfCV.fg)('platform_navx_smart_link_icon_label_a11y') ? {} : {
            title: (0, $jawC3.extractTitle)(jsonLd)
        },
        provider: (0, $jawC3.extractProvider)(jsonLd),
        fileFormat: $f1ce3764841d3d06$var$extractFileFormat(jsonLd),
        taskType: $f1ce3764841d3d06$var$extractTaskType(jsonLd),
        icon: jsonLd.icon && (0, $jawC3.extractUrlFromIconJsonLd)(jsonLd.icon),
        priority: priority,
        showIconLabel: showIconLabel
    };
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>$f1ce3764841d3d06$var$extractorPriorityMap[b] - $f1ce3764841d3d06$var$extractorPriorityMap[a])[0];
        return $f1ce3764841d3d06$var$extractIconByType(highestPriorityType, opts);
    } else return $f1ce3764841d3d06$var$extractIconByType(type, opts);
};
const $f1ce3764841d3d06$var$extractInlineIcon = (jsonLd, showIconLabel = true)=>{
    const provider = (0, $jawC3.extractProvider)(jsonLd);
    if (provider && provider.id) {
        if (provider.id === (0, $hhrxw.CONFLUENCE_GENERATOR_ID) || provider.id === (0, $hhrxw.JIRA_GENERATOR_ID)) return $f1ce3764841d3d06$var$extractIcon(jsonLd, 'type', showIconLabel);
    }
    return $f1ce3764841d3d06$var$extractIcon(jsonLd, 'provider', showIconLabel);
};
const $f1ce3764841d3d06$export$643db2ee2409e635 = (response, showLabel = true)=>{
    if ((0, $jawC3.isEntityPresent)(response)) {
        if ((0, $ixfCV.fg)('platform_lp_use_entity_icon_url_for_icon')) {
            const entityIcon = (0, $jawC3.extractEntityIcon)(response);
            if (entityIcon) return [
                entityIcon.url,
                entityIcon.label
            ];
        }
        const provider = (0, $jawC3.extractEntityProvider)(response);
        if (provider) return provider.icon;
    }
    return $f1ce3764841d3d06$var$extractInlineIcon(response?.data || $f1ce3764841d3d06$var$getEmptyJsonLd(), showLabel);
};
module.exports["extractSmartLinkInlineIcon"] = $f1ce3764841d3d06$export$643db2ee2409e635;

});

parcelRegister("jrSlu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $ixfCV = parcelRequire("ixfCV");


var $hhrxw = parcelRequire("hhrxw");


var $l8WFq = parcelRequire("l8WFq");























const $73d439951cf388f8$var$getLazyIcons = ()=>({
        [(0, $hhrxw.IconType).Document]: {
            default: ()=>Promise.resolve((parcelRequire("9v3GN")))
        },
        [(0, $hhrxw.IconType).Audio]: {
            default: ()=>(parcelRequire("kPWC0"))
        },
        [(0, $hhrxw.IconType).Code]: {
            default: ()=>(parcelRequire("7nVQ2"))
        },
        [(0, $hhrxw.IconType).File]: {
            default: ()=>Promise.resolve((parcelRequire("4Emmj")))
        },
        [(0, $hhrxw.IconType).Folder]: {
            default: ()=>(parcelRequire("9VLzs"))
        },
        [(0, $hhrxw.IconType).Generic]: {
            default: ()=>Promise.resolve((parcelRequire("4Emmj")))
        },
        [(0, $hhrxw.IconType).Image]: {
            default: ()=>(parcelRequire("j9LJx"))
        },
        [(0, $hhrxw.IconType).Presentation]: {
            default: ()=>Promise.resolve((parcelRequire("b5Dss")))
        },
        [(0, $hhrxw.IconType).Spreadsheet]: {
            default: ()=>Promise.resolve((parcelRequire("7vzLW")))
        },
        [(0, $hhrxw.IconType).Video]: {
            default: ()=>(parcelRequire("96zb4"))
        },
        [(0, $hhrxw.IconType).Archive]: {
            default: ()=>(parcelRequire("8KvsV"))
        },
        [(0, $hhrxw.IconType).Executable]: {
            default: ()=>(parcelRequire("kKj89"))
        },
        [(0, $hhrxw.IconType).GIF]: {
            default: ()=>(parcelRequire("1N5Ke"))
        },
        [(0, $hhrxw.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("7KlQ2"))
        },
        [(0, $hhrxw.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("4D6tQ"))
        },
        [(0, $hhrxw.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("30pMN"))
        },
        [(0, $hhrxw.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("hbVly"))
        },
        [(0, $hhrxw.IconType).MSExcel]: {
            default: ()=>(parcelRequire("5eRas"))
        },
        [(0, $hhrxw.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("bmQsw"))
        },
        [(0, $hhrxw.IconType).MSWord]: {
            default: ()=>(parcelRequire("3tCrI"))
        },
        [(0, $hhrxw.IconType).PDF]: {
            default: ()=>(parcelRequire("eiZGU"))
        },
        [(0, $hhrxw.IconType).Sketch]: {
            default: ()=>(parcelRequire("ldRXm"))
        }
    });
const $73d439951cf388f8$var$getTypeToIconMap = (fileFormat)=>{
    const iconDescriptor = (0, $l8WFq.default)(fileFormat);
    if (!iconDescriptor?.icon) return null;
    const lazyIcons = $73d439951cf388f8$var$getLazyIcons();
    if ((0, $ixfCV.fg)('platform_navx_smart_link_icon_label_a11y')) return [
        lazyIcons[iconDescriptor.icon]?.default,
        iconDescriptor.label ?? ''
    ];
    return [
        lazyIcons[iconDescriptor.icon]?.default
    ];
};
const $73d439951cf388f8$export$4d685c85ebc7a1e3 = (fileMimeType, showIconLabel)=>{
    if (!fileMimeType) return;
    const icon = $73d439951cf388f8$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "hbd6r",
        name: "Icon",
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    });
    if ((0, $ixfCV.fg)('platform_navx_smart_link_icon_label_a11y')) {
        const descriptorLabel = icon[1] || '';
        const label = showIconLabel ?? true ? descriptorLabel : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            testId: "document-file-format-icon",
            label: label
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        testId: "document-file-format-icon"
    });
};
module.exports["getIconForFileType"] = $73d439951cf388f8$export$4d685c85ebc7a1e3;

});

parcelRegister("l8WFq", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $hhrxw = parcelRequire("hhrxw");

const $eb169b73453c71b7$var$extractFileFormatIcon = (fileFormat)=>{
    const getIconDescriptor = (icon, label)=>(0, $ixfCV.fg)('platform_navx_smart_link_icon_label_a11y') ? {
            icon: icon,
            label: label
        } : {
            icon: icon
        };
    switch(fileFormat){
        case 'folder':
            return getIconDescriptor((0, $hhrxw.IconType).Folder, 'folder');
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return getIconDescriptor((0, $hhrxw.IconType).Document, 'document');
        case 'application/pdf':
            return getIconDescriptor((0, $hhrxw.IconType).PDF, 'pdf');
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return getIconDescriptor((0, $hhrxw.IconType).Presentation, 'presentation');
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return getIconDescriptor((0, $hhrxw.IconType).Spreadsheet, 'spreadsheet');
        case 'application/vnd.google-apps.document':
            return getIconDescriptor((0, $hhrxw.IconType).GoogleDocs, 'google document');
        case 'application/vnd.google-apps.form':
            return getIconDescriptor((0, $hhrxw.IconType).GoogleForms, 'google form');
        case 'application/vnd.google-apps.spreadsheet':
            return getIconDescriptor((0, $hhrxw.IconType).GoogleSheets, 'google sheet');
        case 'application/vnd.google-apps.presentation':
            return getIconDescriptor((0, $hhrxw.IconType).GoogleSlides, 'google slide');
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return getIconDescriptor((0, $hhrxw.IconType).MSExcel, 'excel spreadsheet');
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return getIconDescriptor((0, $hhrxw.IconType).MSPowerpoint, 'powerpoint');
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return getIconDescriptor((0, $hhrxw.IconType).MSWord, 'word document');
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return getIconDescriptor((0, $hhrxw.IconType).Image, 'image');
        case 'image/gif':
            return getIconDescriptor((0, $hhrxw.IconType).GIF, 'gif');
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return getIconDescriptor((0, $hhrxw.IconType).Audio, 'audio');
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return getIconDescriptor((0, $hhrxw.IconType).Video, 'video');
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return getIconDescriptor((0, $hhrxw.IconType).Code, 'code');
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return getIconDescriptor((0, $hhrxw.IconType).Archive, 'archive');
        case 'application/dmg':
            return getIconDescriptor((0, $hhrxw.IconType).Executable, 'disk image');
        case 'application/sketch':
            return getIconDescriptor((0, $hhrxw.IconType).Sketch, 'sketch');
        case 'application/octet-stream':
        case 'application/invision.prototype':
            return getIconDescriptor((0, $hhrxw.IconType).Generic, 'file');
        default:
            return undefined;
    }
};
var $eb169b73453c71b7$export$2e2bcd8739ae039 = $eb169b73453c71b7$var$extractFileFormatIcon;
module.exports["default"] = $eb169b73453c71b7$export$2e2bcd8739ae039;

});

parcelRegister("kPWC0", function(module, exports) {

let $f2b60935c73a6c05$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f2b60935c73a6c05$var$load("gkVge"),
    $f2b60935c73a6c05$var$load("hLbGw")
]).then(()=>parcelRequire('hyaPI'));

});

parcelRegister("7nVQ2", function(module, exports) {

let $56078bdb4bba4b6f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $56078bdb4bba4b6f$var$load("kDfOJ").then(()=>parcelRequire('gMML3'));

});

parcelRegister("9VLzs", function(module, exports) {

let $73ae5688c13ac7f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $73ae5688c13ac7f1$var$load("6wr18"),
    $73ae5688c13ac7f1$var$load("ffEVr"),
    $73ae5688c13ac7f1$var$load("iN2uJ")
]).then(()=>parcelRequire('giuMD'));

});

parcelRegister("j9LJx", function(module, exports) {

let $df23e277716dc04b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $df23e277716dc04b$var$load("6wr18"),
    $df23e277716dc04b$var$load("ffEVr"),
    $df23e277716dc04b$var$load("6aZeI")
]).then(()=>parcelRequire('4b38C'));

});

parcelRegister("96zb4", function(module, exports) {

let $6a0ff61f5e39486f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6a0ff61f5e39486f$var$load("6wr18"),
    $6a0ff61f5e39486f$var$load("ffEVr"),
    $6a0ff61f5e39486f$var$load("8TGE7")
]).then(()=>parcelRequire('8aT6O'));

});

parcelRegister("8KvsV", function(module, exports) {

let $65eb06ff5571b2cc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $65eb06ff5571b2cc$var$load("5JWJI").then(()=>parcelRequire('iqehY'));

});

parcelRegister("kKj89", function(module, exports) {

let $f1a6f16f6403b629$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f1a6f16f6403b629$var$load("aQ5uu").then(()=>parcelRequire('3OVVx'));

});

parcelRegister("1N5Ke", function(module, exports) {

let $14ded2ce3ce05390$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $14ded2ce3ce05390$var$load("geXPZ").then(()=>parcelRequire('EhIdb'));

});

parcelRegister("7KlQ2", function(module, exports) {

let $5a3dc4e9d091ba35$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5a3dc4e9d091ba35$var$load("b4nm1").then(()=>parcelRequire('hmd8r'));

});

parcelRegister("4D6tQ", function(module, exports) {

let $35efd4ccf002d2a8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $35efd4ccf002d2a8$var$load("jfYeU").then(()=>parcelRequire('lLxTI'));

});

parcelRegister("30pMN", function(module, exports) {

let $23055fbb4908668b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $23055fbb4908668b$var$load("kYkz1").then(()=>parcelRequire('kUQwC'));

});

parcelRegister("hbVly", function(module, exports) {

let $c83ff29c592bd62f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c83ff29c592bd62f$var$load("5kI0b").then(()=>parcelRequire('1G3Dq'));

});

parcelRegister("5eRas", function(module, exports) {

let $3d078090de5174e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3d078090de5174e1$var$load("3i44s").then(()=>parcelRequire('1kVaD'));

});

parcelRegister("bmQsw", function(module, exports) {

let $846a710eb4b35adb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $846a710eb4b35adb$var$load("4QwAJ").then(()=>parcelRequire('aeJll'));

});

parcelRegister("3tCrI", function(module, exports) {

let $2881e71a7d44971f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2881e71a7d44971f$var$load("fHlIz").then(()=>parcelRequire('8If3N'));

});

parcelRegister("eiZGU", function(module, exports) {

let $a6a299b1e4e47c5f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a6a299b1e4e47c5f$var$load("aaRXj").then(()=>parcelRequire('8B1YK'));

});

parcelRegister("ldRXm", function(module, exports) {

let $f734aa7c232eacf4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f734aa7c232eacf4$var$load("6OMo6").then(()=>parcelRequire('AzmWu'));

});

parcelRegister("6kJW0", function(module, exports) {

var $iW3KC = parcelRequire("iW3KC");


var $ai0Ge = parcelRequire("ai0Ge");


var $h9stc = parcelRequire("h9stc");

const $616e4ede6f48d352$var$BlogIconWithColor = (0, $h9stc.renderIconPerSize)((0, $iW3KC.default), (0, $ai0Ge.default));
$616e4ede6f48d352$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $616e4ede6f48d352$export$2e2bcd8739ae039 = $616e4ede6f48d352$var$BlogIconWithColor;
module.exports["default"] = $616e4ede6f48d352$export$2e2bcd8739ae039;

});

parcelRegister("h9stc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2Fmt9 = parcelRequire("2Fmt9");


var $ixfCV = parcelRequire("ixfCV");


var $hhrxw = parcelRequire("hhrxw");

const $886a479395619017$var$appearanceToStandaloneIconColor = {
    blue: "var(--ds-icon-accent-blue, #357DE8)",
    blueBold: "var(--ds-icon-accent-blue, #357DE8)",
    gray: "var(--ds-icon-accent-gray, #7D818A)",
    grayBold: "var(--ds-icon-accent-gray, #7D818A)",
    green: "var(--ds-icon-accent-green, #22A06B)",
    greenBold: "var(--ds-icon-accent-green, #22A06B)",
    lime: "var(--ds-icon-accent-lime, #6A9A23)",
    limeBold: "var(--ds-icon-accent-lime, #6A9A23)",
    magenta: "var(--ds-icon-accent-magenta, #CD519D)",
    magentaBold: "var(--ds-icon-accent-magenta, #CD519D)",
    orange: "var(--ds-icon-accent-orange, #E06C00)",
    orangeBold: "var(--ds-icon-accent-orange, #E06C00)",
    purple: "var(--ds-icon-accent-purple, #AF59E1)",
    purpleBold: "var(--ds-icon-accent-purple, #AF59E1)",
    red: "var(--ds-icon-accent-red, #C9372C)",
    redBold: "var(--ds-icon-accent-red, #C9372C)",
    teal: "var(--ds-icon-accent-teal, #2898BD)",
    tealBold: "var(--ds-icon-accent-teal, #2898BD)",
    yellow: "var(--ds-icon-accent-yellow, #B38600)",
    yellowBold: "var(--ds-icon-accent-yellow, #B38600)"
};
const $886a479395619017$var$isIconSizeLarge = (size)=>size && [
        (0, $hhrxw.SmartLinkSize).Large,
        (0, $hhrxw.SmartLinkSize).XLarge
    ].includes(size);
const $886a479395619017$export$3acc3fb10995f020 = (size)=>{
    if ((0, $ixfCV.fg)('platform_sl_icons_refactor')) switch(size){
        case (0, $hhrxw.SmartLinkSize).Small:
        case (0, $hhrxw.SmartLinkSize).Medium:
            return undefined;
        case (0, $hhrxw.SmartLinkSize).XLarge:
        case (0, $hhrxw.SmartLinkSize).Large:
            return 'small';
        default:
            return undefined;
    }
    switch(size){
        case (0, $hhrxw.SmartLinkSize).XLarge:
        case (0, $hhrxw.SmartLinkSize).Large:
            return 'small';
        default:
            return undefined;
    }
};
const $886a479395619017$export$28dd5ad82647c000 = (ObjectIcon, ObjectTileIcon)=>{
    return ({ size: size, ...props })=>{
        if ($886a479395619017$var$isIconSizeLarge(size)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ObjectTileIcon, {
            ...props,
            size: "small"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ObjectIcon, props);
    };
};
const $886a479395619017$export$87c3646d0e299cfe = (Icon, appearance)=>{
    return ({ size: size, isTiledIcon: isTiledIcon, ...props })=>{
        const tileSize = $886a479395619017$export$3acc3fb10995f020(size);
        if (tileSize === undefined) {
            const label = props.label ?? '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                role: label ? 'img' : undefined,
                "aria-label": label || undefined,
                "data-testid": props.testId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
                color: $886a479395619017$var$appearanceToStandaloneIconColor[appearance],
                label: ""
            }));
        }
        const { ...tileProps } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Fmt9.IconTile), {
            appearance: appearance,
            icon: isTiledIcon ? (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
                    ...iconProps,
                    spacing: "spacious"
                }) : Icon,
            size: tileSize,
            ...tileProps
        });
    };
};
module.exports["renderIconPerSize"] = $886a479395619017$export$28dd5ad82647c000;
module.exports["renderIconTile"] = $886a479395619017$export$87c3646d0e299cfe;

});

parcelRegister("9v3GN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $hMaHH = parcelRequire("hMaHH");


var $h9stc = parcelRequire("h9stc");

const $fc0d527adbaaccfa$var$PageIconWithColor = (0, $h9stc.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), 'blueBold');
$fc0d527adbaaccfa$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $fc0d527adbaaccfa$export$2e2bcd8739ae039 = $fc0d527adbaaccfa$var$PageIconWithColor;
module.exports["default"] = $fc0d527adbaaccfa$export$2e2bcd8739ae039;

});

parcelRegister("4Emmj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $kkFbH = parcelRequire("kkFbH");


var $h9stc = parcelRequire("h9stc");

const $30795df12c6626e4$var$FileIconWithColor = (0, $h9stc.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), 'grayBold');
$30795df12c6626e4$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $30795df12c6626e4$export$2e2bcd8739ae039 = $30795df12c6626e4$var$FileIconWithColor;
module.exports["default"] = $30795df12c6626e4$export$2e2bcd8739ae039;

});

parcelRegister("dGdE6", function(module, exports) {

var $7pJjg = parcelRequire("7pJjg");


var $dipyx = parcelRequire("dipyx");


var $h9stc = parcelRequire("h9stc");

const $c10f705a5270d647$var$LiveDocumentIconWithColor = (0, $h9stc.renderIconPerSize)((0, $7pJjg.default), (0, $dipyx.default));
$c10f705a5270d647$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $c10f705a5270d647$export$2e2bcd8739ae039 = $c10f705a5270d647$var$LiveDocumentIconWithColor;
module.exports["default"] = $c10f705a5270d647$export$2e2bcd8739ae039;

});

parcelRegister("b5Dss", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gJ798 = parcelRequire("gJ798");


var $h9stc = parcelRequire("h9stc");

const $77093538826d7e25$var$ChartBarIconWithColor = (0, $h9stc.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($gJ798))), 'purpleBold');
$77093538826d7e25$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $77093538826d7e25$export$2e2bcd8739ae039 = $77093538826d7e25$var$ChartBarIconWithColor;
module.exports["default"] = $77093538826d7e25$export$2e2bcd8739ae039;

});

parcelRegister("7vzLW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $3fO5l = parcelRequire("3fO5l");


var $h9stc = parcelRequire("h9stc");

const $7d25c80ed1a76c0d$var$ListBulletedIconWithColor = (0, $h9stc.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), 'greenBold');
$7d25c80ed1a76c0d$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $7d25c80ed1a76c0d$export$2e2bcd8739ae039 = $7d25c80ed1a76c0d$var$ListBulletedIconWithColor;
module.exports["default"] = $7d25c80ed1a76c0d$export$2e2bcd8739ae039;

});

parcelRegister("hyOTw", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $52c0c0ab9e795973$var$placeholderShimmer = null;
const $52c0c0ab9e795973$var$appearanceValues = {
    darkGray: {
        animation: "var(--ds-background-accent-gray-subtle, #8C8F97)"
    },
    gray: {
        animation: "var(--ds-skeleton, #0515240F)"
    },
    blue: {
        animation: "var(--ds-background-information-hovered, #CFE1FD)"
    }
};
const $52c0c0ab9e795973$var$spanSkeletonStyles = null;
const $52c0c0ab9e795973$var$spanSkeletonBackgroundStyleMap = {
    gray: "_bfhkysee",
    blue: "_bfhk1s93",
    darkGray: "_bfhk7qp0"
};
const $52c0c0ab9e795973$export$85d5658002cae6ce = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$52c0c0ab9e795973$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $hekY6.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $52c0c0ab9e795973$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
const $52c0c0ab9e795973$export$8f31e4c4a37b8e9c = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$52c0c0ab9e795973$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $hekY6.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $52c0c0ab9e795973$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};
var $52c0c0ab9e795973$export$2e2bcd8739ae039 = $52c0c0ab9e795973$export$8f31e4c4a37b8e9c;
module.exports["SpanSkeleton"] = $52c0c0ab9e795973$export$85d5658002cae6ce;
module.exports["Skeleton"] = $52c0c0ab9e795973$export$8f31e4c4a37b8e9c;

});

parcelRegister("5izWN", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $e2e3e1973cea2910$export$acd4d92ce9f1584f = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { label: label, color: t1 } = t0;
    const color = t1 === undefined ? "currentColor" : t1;
    const t2 = label || undefined;
    const t3 = label ? "img" : "presentation";
    const t4 = label ? undefined : true;
    let t5;
    if ($[0] !== color) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M11.5885 8.1713C7.8852 6.38061 6.80333 6.11304 5.24293 6.11304C3.41207 6.11304 1.85167 6.87459 0.457716 9.01518L0.228858 9.36509C0.0416106 9.65324 0 9.75616 0 9.87965C0 10.0031 0.0624158 10.1061 0.291274 10.2501L2.64227 11.7115C2.7671 11.7938 2.87113 11.835 2.97515 11.835C3.09999 11.835 3.18321 11.7733 3.30804 11.588L3.68253 11.0117C4.26508 10.1266 4.78521 9.83849 5.45098 9.83849C6.03353 9.83849 6.72011 10.0031 7.57312 10.4148L10.0281 11.5674C10.2778 11.6909 10.5483 11.6292 10.6731 11.341L11.8382 8.78877C11.963 8.50062 11.8798 8.31537 11.5885 8.1713ZM0.790601 3.6637C4.49394 5.45439 5.57581 5.72197 7.13621 5.72197C8.96708 5.72197 10.5275 4.96041 11.9214 2.81982L12.1503 2.46991C12.3375 2.18176 12.3791 2.07884 12.3791 1.95535C12.3791 1.83185 12.3167 1.72894 12.0879 1.58486L9.73687 0.123496C9.61204 0.0411652 9.50801 0 9.40399 0C9.27915 0 9.19593 0.0617478 9.0711 0.246991L8.69661 0.823304C8.11406 1.70836 7.59393 1.99651 6.92816 1.99651C6.34561 1.99651 5.65904 1.83185 4.80602 1.4202L2.351 0.267574C2.10133 0.144078 1.83086 0.205826 1.70603 0.493983L0.540937 3.04623C0.416106 3.33438 0.499327 3.51963 0.790601 3.6637Z",
            fill: color
        });
        $[0] = color;
        $[1] = t5;
    } else t5 = $[1];
    let t6;
    if ($[2] !== t2 || $[3] !== t3 || $[4] !== t4 || $[5] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: "16",
            height: "16",
            viewBox: "0 -0.5 13 13",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "aria-label": t2,
            role: t3,
            "aria-hidden": t4
        }, t5);
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
        $[6] = t6;
    } else t6 = $[6];
    return t6;
} : ({ label: label, color: color = 'currentColor' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 -0.5 13 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        "aria-hidden": label ? undefined : true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M11.5885 8.1713C7.8852 6.38061 6.80333 6.11304 5.24293 6.11304C3.41207 6.11304 1.85167 6.87459 0.457716 9.01518L0.228858 9.36509C0.0416106 9.65324 0 9.75616 0 9.87965C0 10.0031 0.0624158 10.1061 0.291274 10.2501L2.64227 11.7115C2.7671 11.7938 2.87113 11.835 2.97515 11.835C3.09999 11.835 3.18321 11.7733 3.30804 11.588L3.68253 11.0117C4.26508 10.1266 4.78521 9.83849 5.45098 9.83849C6.03353 9.83849 6.72011 10.0031 7.57312 10.4148L10.0281 11.5674C10.2778 11.6909 10.5483 11.6292 10.6731 11.341L11.8382 8.78877C11.963 8.50062 11.8798 8.31537 11.5885 8.1713ZM0.790601 3.6637C4.49394 5.45439 5.57581 5.72197 7.13621 5.72197C8.96708 5.72197 10.5275 4.96041 11.9214 2.81982L12.1503 2.46991C12.3375 2.18176 12.3791 2.07884 12.3791 1.95535C12.3791 1.83185 12.3167 1.72894 12.0879 1.58486L9.73687 0.123496C9.61204 0.0411652 9.50801 0 9.40399 0C9.27915 0 9.19593 0.0617478 9.0711 0.246991L8.69661 0.823304C8.11406 1.70836 7.59393 1.99651 6.92816 1.99651C6.34561 1.99651 5.65904 1.83185 4.80602 1.4202L2.351 0.267574C2.10133 0.144078 1.83086 0.205826 1.70603 0.493983L0.540937 3.04623C0.416106 3.33438 0.499327 3.51963 0.790601 3.6637Z",
        fill: color
    }));
module.exports["ConfluenceLogoIcon"] = $e2e3e1973cea2910$export$acd4d92ce9f1584f;

});

parcelRegister("ePExc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ec704748a0115052$export$9542b2119eeb5eb4 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "327gI",
    name: "ShareAndRestrictDialogController",
    loader: async ()=>(await (parcelRequire("8OAE7"))).Controller
});
module.exports["ShareAndRestrictDialogController"] = $ec704748a0115052$export$9542b2119eeb5eb4;

});

parcelRegister("8OAE7", function(module, exports) {

let $66af6b67d96563eb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $66af6b67d96563eb$var$load("gbejv"),
    $66af6b67d96563eb$var$load("GD9EA"),
    $66af6b67d96563eb$var$load("cmmpX"),
    $66af6b67d96563eb$var$load("6wr18"),
    $66af6b67d96563eb$var$load("bRqDI"),
    $66af6b67d96563eb$var$load("jrCdz"),
    $66af6b67d96563eb$var$load("k55bj"),
    $66af6b67d96563eb$var$load("ibo4x"),
    $66af6b67d96563eb$var$load("lbsQO"),
    $66af6b67d96563eb$var$load("ffEVr"),
    $66af6b67d96563eb$var$load("Wowvf"),
    $66af6b67d96563eb$var$load("eRhBr"),
    $66af6b67d96563eb$var$load("7EorR"),
    $66af6b67d96563eb$var$load("daX4F"),
    $66af6b67d96563eb$var$load("hhss7"),
    $66af6b67d96563eb$var$load("bunf9")
]).then(()=>parcelRequire('4adOe'));

});

parcelRegister("erzVD", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d0c6da6b618ff535$export$44ec82a0a8c60a0e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "xpRfQ",
    name: "InspectPermissionsDialog",
    loader: async ()=>(await (parcelRequire("gCuQ2"))).InspectPermissionsDialog
});
module.exports["InspectPermissionsDialog"] = $d0c6da6b618ff535$export$44ec82a0a8c60a0e;

});

parcelRegister("gCuQ2", function(module, exports) {

let $c1981dc9e3e2cc05$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c1981dc9e3e2cc05$var$load("gkVge"),
    $c1981dc9e3e2cc05$var$load("l3CW5"),
    $c1981dc9e3e2cc05$var$load("LWh5V"),
    $c1981dc9e3e2cc05$var$load("gbejv"),
    $c1981dc9e3e2cc05$var$load("GD9EA"),
    $c1981dc9e3e2cc05$var$load("c831e"),
    $c1981dc9e3e2cc05$var$load("kVHWO"),
    $c1981dc9e3e2cc05$var$load("amPsT"),
    $c1981dc9e3e2cc05$var$load("h4Nf7"),
    $c1981dc9e3e2cc05$var$load("4XkGy"),
    $c1981dc9e3e2cc05$var$load("fuOfV"),
    $c1981dc9e3e2cc05$var$load("jL1Ke"),
    $c1981dc9e3e2cc05$var$load("5MQ0D"),
    $c1981dc9e3e2cc05$var$load("Kj0I8"),
    $c1981dc9e3e2cc05$var$load("5xnun"),
    $c1981dc9e3e2cc05$var$load("6wr18"),
    $c1981dc9e3e2cc05$var$load("59hV4"),
    $c1981dc9e3e2cc05$var$load("8zMmc"),
    $c1981dc9e3e2cc05$var$load("4x9Jx"),
    $c1981dc9e3e2cc05$var$load("Wowvf"),
    $c1981dc9e3e2cc05$var$load("hhss7"),
    $c1981dc9e3e2cc05$var$load("ffEVr"),
    $c1981dc9e3e2cc05$var$load("jZMUd"),
    $c1981dc9e3e2cc05$var$load("2EIkU"),
    $c1981dc9e3e2cc05$var$load("iUXaE"),
    $c1981dc9e3e2cc05$var$load("lTkx9"),
    $c1981dc9e3e2cc05$var$load("7EorR"),
    $c1981dc9e3e2cc05$var$load("85liN")
]).then(()=>parcelRequire('jl66H'));

});

parcelRegister("hpRYU", function(module, exports) {

var $1dUJk = parcelRequire("1dUJk");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kfLla = parcelRequire("kfLla");


var $l9ukq = parcelRequire("l9ukq");


var $24tIi = parcelRequire("24tIi");


var $bQm3c = parcelRequire("bQm3c");


var $iMnC5 = parcelRequire("iMnC5");


var $9wGTI = parcelRequire("9wGTI");


var $b3j2Y = parcelRequire("b3j2Y");


var $7lu50 = parcelRequire("7lu50");


var $7Sm4c = parcelRequire("7Sm4c");


var $83Z6R = parcelRequire("83Z6R");


var $jjoF2 = parcelRequire("jjoF2");


var $VQdE0 = parcelRequire("VQdE0");


var $g3p2i = parcelRequire("g3p2i");


var $jMyy4 = parcelRequire("jMyy4");

const $4cbf051190fe8573$var$MIN_SEARCH_LENGTH = 2;
const $4cbf051190fe8573$export$1434adfffc17371d = 200;
const $4cbf051190fe8573$var$withoutAriaLabelledBy = (props)=>{
    const { 'aria-labelledby': _ariaLabelledBy, ...inputProps } = props;
    return inputProps;
};
const $4cbf051190fe8573$var$LabelledInput = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Input, $4cbf051190fe8573$var$withoutAriaLabelledBy(props));
const $4cbf051190fe8573$var$wrapWithLabelledInput = (InputComponent)=>{
    const WrappedLabelledInput = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InputComponent, $4cbf051190fe8573$var$withoutAriaLabelledBy(props));
    return WrappedLabelledInput;
};
const $4cbf051190fe8573$var$getLabelledComponents = (components)=>{
    return {
        ...components,
        Input: components?.Input ? $4cbf051190fe8573$var$wrapWithLabelledInput(components.Input) : $4cbf051190fe8573$var$LabelledInput
    };
};
function $4cbf051190fe8573$export$e11674744930cd15(error) {
    if ('statusCode' in error && error['statusCode'] === 403 || error.message?.includes('403') || error.message?.includes('not allowed')) return true;
    return false;
}
const $4cbf051190fe8573$var$DefaultWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), null, children);
const $4cbf051190fe8573$export$fd4159eb872f73c6 = ({ appearance: appearance, fieldId: fieldId, isMulti: isMulti, includeGroup: includeGroup, onSelect: onSelect, onChange: onChange, onClear: onClear, onFocus: onFocus, onBlur: onBlur, onOpen: onOpen, onClose: onClose, onInputChange: onInputChange, onKeyDown: onKeyDown, filterSearchResults: filterSearchResults, smartFilterOptions: smartFilterOptions, value: value, defaultValue: defaultValue, noOptionsMessage: noOptionsMessage, addMoreMessage: addMoreMessage, menuPortalTarget: menuPortalTarget, autoFocus: autoFocus, width: width, maxPickerHeight: maxPickerHeight, smart: smart, styles: styles, placeholder: placeholder, sitePermissionTypeFilter: sitePermissionTypeFilter = (0, $g3p2i.SitePermissionTypeFilter).NONE, displayEmailInByline: displayEmailInByline, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, enableEmailSearch: enableEmailSearch, allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched, includeTeams: includeTeams, includeTeamsUpdates: includeTeamsUpdates, verifiedTeams: verifiedTeams, menuPosition: menuPosition, customInclusion: customInclusion = [], ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, 'aria-labelledby': ariaLabelledByFromField, ariaDescribedBy: ariaDescribedBy, role: role, isDisabled: isDisabled = false, isLoading: isLoading = false, bootstrapOptions: bootstrapOptions = [], inputId: inputId, withUsers: withUsers = true, Wrapper: Wrapper = $4cbf051190fe8573$var$DefaultWrapper, header: header, open: open, userpickerDescribedbyId: userpickerDescribedbyId, isClearable: isClearable = true, includeUsers: includeUsers = true, transformOptions: transformOptions, userResolvers: userResolvers, components: components, isHeaderFocused: isHeaderFocused, setIsHeaderFocused: setIsHeaderFocused })=>{
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const queryUserAndGroupSearch = (0, $83Z6R.useLazyQueryPromiseInterop)((0, $VQdE0.default));
    const { loading: searchPickerLoading, data: searchPickerData } = (0, $jMyy4.useQueryInterop)((0, $1dUJk.default), {
        __callerPackage__: "user-and-group-search"
    });
    const handleError = (searchError)=>{
        if (searchError) {
            setError(searchError);
            // mark error as handled so we don't have ui unhandled errors
            (0, $7Sm4c.markErrorAsHandled)(searchError);
        }
    };
    const promiseOptions = (searchTerm)=>!searchTerm || searchTerm.length < $4cbf051190fe8573$var$MIN_SEARCH_LENGTH ? [] : (0, $jjoF2.userGroupSearchPromise)({
            searchTerm: searchTerm,
            queryData: queryUserAndGroupSearch({
                variables: {
                    withGroups: includeGroup,
                    searchTerm: searchTerm,
                    sitePermissionTypeFilter: sitePermissionTypeFilter,
                    withUsers: withUsers
                }
            }),
            customInclusion: customInclusion,
            setError: setError,
            filterResults: filterSearchResults
        });
    const searchErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "user-and-group-search.search.error",
        defaultMessage: "Sorry, we\u2019re having trouble loading search results right now."
    });
    const permissionErrorMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "user-and-group-search.permission.error",
        defaultMessage: "We couldn\u2019t find any results because you don't have permission to search the user directory."
    });
    // TODO: <UserPicker> expects `noOptionsMessage` to return string | null
    // but this callback returns JSX.Element | string | null, so error message must be string.
    const emptyResultsMessage = (input)=>{
        if (error) {
            if ($4cbf051190fe8573$export$e11674744930cd15(error)) return permissionErrorMessage;
            return searchErrorMessage;
        } else if (typeof noOptionsMessage === 'function') return noOptionsMessage(input);
        return noOptionsMessage;
    };
    const isEntitledExternalCollaboration = (0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(searchPickerData) ?? false;
    const finalPlaceholder = placeholder || (includeGroup ? allowEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "user-and-group-search.placeholder.text.users.groups.and.email",
        defaultMessage: "Add people by name, email, or group"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "user-and-group-search.placeholder.text.users.and.groups",
        // TODO: a content designer should check this case. This isn't the usual sentence structure for placeholders.
        defaultMessage: "Type a user name or group"
    }) : allowEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "user-and-group-search.placeholder.text.users.and.email",
        defaultMessage: "Add people, emails"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "user-and-group-search.placeholder.text.users",
        // TODO: a content designer should check this case. This isn't the usual sentence structure for placeholders.
        defaultMessage: "Type a user name"
    }));
    const pickerAriaLabelledBy = ariaLabel ? undefined : ariaLabelledBy || ariaLabelledByFromField || `react-select-${fieldId}-placeholder`;
    const pickerComponents = (0, $cozmU.useMemo)(()=>ariaLabel ? $4cbf051190fe8573$var$getLabelledComponents(components) : components, [
        ariaLabel,
        components
    ]);
    const commonProps = {
        appearance: appearance,
        placeholder: finalPlaceholder,
        addMoreMessage: addMoreMessage,
        isMulti: isMulti,
        defaultValue: defaultValue,
        fieldId: fieldId,
        menuPortalTarget: menuPortalTarget,
        noOptionsMessage: emptyResultsMessage,
        onChange: onChange,
        onClear: onClear,
        onFocus: onFocus,
        onOpen: onOpen,
        onClose: onClose,
        onInputChange: onInputChange,
        onSelection: onSelect,
        value: value,
        width: width,
        maxPickerHeight: maxPickerHeight,
        displayEmailInByline: displayEmailInByline,
        allowEmail: allowEmail,
        suggestEmailsForDomain: suggestEmailsForDomain,
        enableEmailSearch: enableEmailSearch,
        allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched,
        styles: styles,
        menuPosition: menuPosition,
        isDisabled: isDisabled,
        inputId: inputId,
        components: pickerComponents,
        withUsers: // Type assertion: runtime receives Option, but UserPicker types expect OptionData
        withUsers,
        header: header,
        open: open,
        ariaLabel: ariaLabel,
        ariaLabelledBy: pickerAriaLabelledBy,
        'aria-describedby': userpickerDescribedbyId,
        isHeaderFocused: isHeaderFocused,
        setIsHeaderFocused: setIsHeaderFocused
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Wrapper, {
        "aria-label": ariaLabel,
        "aria-describedby": ariaDescribedBy,
        role: role
    }, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }) : null, !smart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kfLla.UserPicker), {
        ...commonProps,
        inputId: inputId,
        autoFocus: autoFocus,
        loadOptions: promiseOptions,
        // bug with UserPicker forces us to use a callback rather than just pass in a string
        onBlur: onBlur,
        isLoading: isLoading,
        appearance: appearance,
        isClearable: isClearable
    }), smart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $24tIi.default), {
        ...commonProps,
        inputId: inputId,
        debounceTime: $4cbf051190fe8573$export$1434adfffc17371d,
        includeGroups: includeGroup,
        includeUsers: includeUsers,
        isLoading: searchPickerLoading || isLoading,
        maxOptions: 60,
        onError: handleError,
        filterOptions: smartFilterOptions,
        productAttributes: {
            isEntitledConfluenceExternalCollaborator: isEntitledExternalCollaboration
        },
        principalId: "context",
        productKey: "confluence",
        autoFocus: autoFocus,
        siteId: cloudId,
        orgId: orgId,
        includeTeams: includeTeams,
        includeTeamsUpdates: includeTeamsUpdates,
        verifiedTeams: verifiedTeams,
        bootstrapOptions: bootstrapOptions,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        isClearable: isClearable,
        transformOptions: transformOptions,
        userResolvers: userResolvers,
        displayEmailInByline: true,
        enableEmailSearch: true,
        allowEmailSelectionWhenEmailMatched: false,
        isTeamSyncedToGroupDirectoryFilter: (0, $9wGTI.fg)('confluence_frontend_perms_exp_teams_as_principals')
    }));
};
const $4cbf051190fe8573$export$ca514d5352bb0171 = $4cbf051190fe8573$export$fd4159eb872f73c6;
module.exports["UserAndGroupSearchPicker"] = $4cbf051190fe8573$export$ca514d5352bb0171;

});

parcelRegister("1dUJk", function(module, exports) {
/**
 * @generated SignedSource<<b63c5c1bb2388ba01c0f335df08966f1>>
 * @relayHash 55f887ce338962f3d231967eb05baaf5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f5f3ec7358095a4d557e0d2edf4c5f6fa4971b5401acfcdacb83cc07f551b55a
const $a7eff2b640cdd5ac$var$node = function() {
    var v0 = [
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ExternalCollaboratorFeature",
                    "kind": "LinkedField",
                    "name": "externalCollaborator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "UserAndGroupSearchPickerQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "UserAndGroupSearchPickerQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "55f887ce338962f3d231967eb05baaf5",
            "id": "f5f3ec7358095a4d557e0d2edf4c5f6fa4971b5401acfcdacb83cc07f551b55a",
            "metadata": {},
            "name": "UserAndGroupSearchPickerQuery",
            "operationKind": "query",
            "text": "query UserAndGroupSearchPickerQuery{entitlements{externalCollaborator{isEntitled}}}"
        }
    };
}();
$a7eff2b640cdd5ac$var$node.hash = "6fe67cddff8056d8e38840c5214712ee";
var $a7eff2b640cdd5ac$export$2e2bcd8739ae039 = $a7eff2b640cdd5ac$var$node;
module.exports["default"] = $a7eff2b640cdd5ac$export$2e2bcd8739ae039;

});

parcelRegister("kfLla", function(module, exports) {
/* UserPicker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $lzgC6 = parcelRequire("lzgC6");


var $Vh9GY = parcelRequire("Vh9GY");

var $6wGOF = parcelRequire("6wGOF");


var $j7Sza = parcelRequire("j7Sza");


var $cozmU = parcelRequire("cozmU");


var $bmH9E = parcelRequire("bmH9E");


var $aeELu = parcelRequire("aeELu");


var $al9c2 = parcelRequire("al9c2");


var $1aEbM = parcelRequire("1aEbM");


var $7HZsv = parcelRequire("7HZsv");


var $i7OwT = parcelRequire("i7OwT");


var $50iN8 = parcelRequire("50iN8");


var $aZ910 = parcelRequire("aZ910");


var $kHija = parcelRequire("kHija");


var $ixfCV = parcelRequire("ixfCV");

function $039672e380479ab5$var$_defineProperty(e, r, t) {
    return (r = $039672e380479ab5$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $039672e380479ab5$var$_toPropertyKey(t) {
    var i = $039672e380479ab5$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $039672e380479ab5$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $039672e380479ab5$export$164f4d95e5d7e2f5 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidMount() {
        const experienceForId = (0, $aZ910.userPickerRenderedUfoExperience).getInstance(this.ufoId); // Send UFO success if the experience is still in progress i.e. hasn't failed
        if ([
            (0, $j7Sza.UFOExperienceState).IN_PROGRESS.id,
            (0, $j7Sza.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.success();
    }
    render() {
        const { emailLabel: emailLabel, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, isMulti: isMulti, isValidEmail: isValidEmail, anchor: anchor, menuPortalTarget: menuPortalTarget, menuPosition: menuPosition, menuShouldBlockScroll: menuShouldBlockScroll, captureMenuScroll: captureMenuScroll, closeMenuOnScroll: closeMenuOnScroll, loadUserSource: loadUserSource, menuIsOpen: menuIsOpen, required: required = false, showClearIndicator: showClearIndicator = false, includeTeamsUpdates: includeTeamsUpdates = false } = this.props;
        const width = this.props.width;
        const SelectComponent = allowEmail ? (0, $Vh9GY.default) : (0, $6wGOF.default);
        const creatableProps = suggestEmailsForDomain ? (0, $7HZsv.getCreatableSuggestedEmailProps)(suggestEmailsForDomain, isValidEmail) : (0, $1aEbM.getCreatableProps)(isValidEmail);
        const defaultPickerProps = {
            closeMenuOnScroll: closeMenuOnScroll,
            menuPortalTarget: menuPortalTarget,
            menuPosition: menuPosition,
            menuShouldBlockScroll: menuShouldBlockScroll,
            captureMenuScroll: captureMenuScroll,
            required: required,
            includeTeamsUpdates: includeTeamsUpdates,
            menuIsOpen: menuIsOpen
        };
        const pickerProps = allowEmail ? {
            ...defaultPickerProps,
            ...creatableProps,
            emailLabel: emailLabel
        } : {
            ...defaultPickerProps
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZ910.UfoErrorBoundary), {
            id: this.ufoId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i7OwT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $50iN8.ExusUserSourceProvider), {
            fetchUserSource: loadUserSource
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bmH9E.BaseUserPickerWithoutAnalytics), {
            ...this.props,
            forwardedRef: this.props.forwardedRef,
            width: width,
            SelectComponent: SelectComponent,
            styles: (0, $aeELu.getStyles)(width, isMulti, this.props.appearance === 'compact', this.props.styles, (0, $ixfCV.fg)('platform-component-visual-refresh'), false, this.props.height, this.props.minHeight),
            components: (0, $al9c2.getComponents)(isMulti, anchor, showClearIndicator, this.props?.components ? this.props.components : {}),
            pickerProps: pickerProps
        }))));
    }
    constructor(props){
        super(props); // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        $039672e380479ab5$var$_defineProperty(this, "ufoId", void 0);
        this.ufoId = (0, $kHija.v4)();
        const experienceForId = (0, $aZ910.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        if (![
            (0, $j7Sza.UFOExperienceState).IN_PROGRESS.id,
            (0, $j7Sza.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.start();
    }
}
$039672e380479ab5$var$_defineProperty($039672e380479ab5$export$164f4d95e5d7e2f5, "defaultProps", {
    width: 350,
    isMulti: false
});
const $039672e380479ab5$export$83e0c73b09b3a9cd = (0, $lzgC6.default)()($039672e380479ab5$export$164f4d95e5d7e2f5);
module.exports["UserPicker"] = $039672e380479ab5$export$83e0c73b09b3a9cd;

});

parcelRegister("bmH9E", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $lzgC6 = parcelRequire("lzgC6");


var $j7Sza = parcelRequire("j7Sza");


var $55fM8 = parcelRequire("55fM8");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kHija = parcelRequire("kHija");


var $4hbXV = parcelRequire("4hbXV");


var $a4iVb = parcelRequire("a4iVb");


var $7xLai = parcelRequire("7xLai");


var $f1uNX = parcelRequire("f1uNX");


var $1Xd8s = parcelRequire("1Xd8s");


var $aZ910 = parcelRequire("aZ910");

const $a288f8d93fd9b6f7$var$loadingMessage = ()=>null;
const $a288f8d93fd9b6f7$var$classNamePrefix = 'fabric-user-picker';
class $a288f8d93fd9b6f7$export$b4ff48c8d43b18c3 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    static getDerivedStateFromProps(nextProps, prevState) {
        const derivedState = {};
        if (nextProps.isDisabled || nextProps.disableInput) derivedState.menuIsOpen = false;
        if (nextProps.open !== undefined) derivedState.menuIsOpen = nextProps.open;
        if (nextProps.value !== undefined) derivedState.value = (0, $f1uNX.optionToSelectableOptions)(nextProps.value);
        else if ((0, $f1uNX.isDefaultValuePopulated)(nextProps.defaultValue) && !prevState.isDefaultSet) {
            derivedState.value = (0, $f1uNX.optionToSelectableOptions)(nextProps.defaultValue);
            derivedState.isDefaultSet = true;
        }
        if (nextProps.search !== undefined && nextProps.search !== prevState.inputValue) derivedState.inputValue = nextProps.search;
        if (nextProps.options !== undefined) derivedState.options = nextProps.options;
        return derivedState;
    }
    get isMenuOpenOnClickForSingleSelect() {
        return this.props.openMenuOnClick && !this.props.isMulti;
    }
    componentDidMount() {
        const { open: open, search: search } = this.props;
        // load options when the picker open
        if (open) {
            if (!this.session) this.startSession();
            this.executeLoadOptions(search);
        }
    }
    componentDidUpdate(prevProps, prevState) {
        const { menuIsOpen: menuIsOpen, options: options, resolving: resolving, count: count, inputValue: inputValue } = this.state;
        // Close menu when isFooterFocused or isHeaderFocused changes from true to false
        if (menuIsOpen && (prevProps.isFooterFocused === true && this.props.isFooterFocused === false || prevProps.isHeaderFocused === true && this.props.isHeaderFocused === false) && !this.shouldKeepMenuOpen()) {
            this.resetInputState();
            (0, $f1uNX.callCallback)(this.props.onClose, this.getSessionId());
            this.setState({
                menuIsOpen: false,
                options: []
            });
        }
        // Create a new session when the menu is opened and there is no session
        if (menuIsOpen && !prevState.menuIsOpen && !this.session) this.startSession();
        // Load options when user picker opens or when input value changes
        if (menuIsOpen && !prevState.menuIsOpen || inputValue !== prevState.inputValue) this.executeLoadOptions(inputValue);
        if (!menuIsOpen && prevState.menuIsOpen && this.session) {
            this.fireEvent((0, $4hbXV.cancelEvent), prevState);
            this.session = undefined;
        }
        if (menuIsOpen && (!prevState.menuIsOpen && options.length > 0 || options.length !== prevState.options.length)) this.fireEvent((0, $4hbXV.searchedEvent));
        if (this.state.inputValue !== prevState.inputValue) {
            if (this.session) this.session.inputChangeTime = Date.now();
        }
        if (menuIsOpen && (!prevProps.loadOptions || prevState.menuIsOpen) && count === 0 && !resolving && [
            (0, $j7Sza.UFOExperienceState).STARTED.id,
            (0, $j7Sza.UFOExperienceState).IN_PROGRESS.id
        ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success();
    }
    get ariaProps() {
        const ariaLabels = Object.keys(this.props).filter((key)=>key.startsWith('aria-'));
        const props = {
            ...this.props
        };
        return ariaLabels.reduce((obj, key)=>({
                ...obj,
                [key]: props[key]
            }), {});
    }
    render() {
        const { isMulti: isMulti, isLoading: isLoading, subtle: subtle, noBorder: noBorder, placeholder: placeholder, isClearable: isClearable, isDisabled: isDisabled, isInvalid: isInvalid, clearValueLabel: clearValueLabel, menuMinWidth: menuMinWidth, menuPortalTarget: menuPortalTarget, loadOptionsErrorMessage: loadOptionsErrorMessage, addMoreMessage: addMoreMessage, noOptionsMessage: noOptionsMessage, footer: footer, disableInput: disableInput, components: components, pickerProps: pickerProps, SelectComponent: SelectComponent, styles: styles, autoFocus: autoFocus, fieldId: fieldId, inputId: inputId, maxPickerHeight: maxPickerHeight, textFieldBackgroundColor: textFieldBackgroundColor, ariaLabelledBy: ariaLabelledBy, ariaDescribedBy: ariaDescribedBy, ariaLive: ariaLive, ariaLabel: ariaLabel, name: name, header: header, required: required, UNSAFE_hasDraggableParentComponent: UNSAFE_hasDraggableParentComponent, placeholderAvatar: placeholderAvatar } = this.props;
        const { count: count, hoveringClearIndicator: hoveringClearIndicator, menuIsOpen: menuIsOpen, value: value, inputValue: inputValue, resolving: resolving, showError: showError } = this.state;
        const appearance = this.getAppearance();
        // these props override the default select menu open and close
        const menuOpenDeciderProps = {
            ...!this.isMenuOpenOnClickForSingleSelect && {
                menuIsOpen: menuIsOpen,
                blurInputOnSelect: !isMulti,
                openMenuOnFocus: this.props.openMenuOnFocus ?? true
            }
        };
        const { 'aria-labelledby': ariaLabelledByStandard, 'aria-describedby': ariaDescribedByStandard, ...restAriaProps } = this.ariaProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SelectComponent, {
            name: name,
            value: value,
            autoFocus: autoFocus !== undefined ? autoFocus : menuIsOpen,
            labelId: ariaLabelledBy ?? ariaLabelledByStandard,
            descriptionId: ariaDescribedBy ?? ariaDescribedByStandard,
            "aria-live": ariaLive,
            "aria-required": required,
            required: required,
            ref: this.handleSelectRef,
            isMulti: isMulti,
            options: this.getOptions(),
            styles: styles,
            enableAnimation: isMulti,
            components: components,
            inputValue: inputValue,
            isLoading: count > 0 || resolving || isLoading,
            loadingMessage: $a288f8d93fd9b6f7$var$loadingMessage,
            menuPlacement: "auto",
            placeholder: placeholder ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).placeholder),
            label: ariaLabel,
            addMoreMessage: addMoreMessage,
            classNamePrefix: $a288f8d93fd9b6f7$var$classNamePrefix,
            hoveringClearIndicator: hoveringClearIndicator,
            appearance: appearance,
            isClearable: isClearable,
            noBorder: noBorder,
            subtle: subtle,
            closeMenuOnSelect: !isMulti,
            noOptionsMessage: showError ? loadOptionsErrorMessage : typeof noOptionsMessage === 'function' ? noOptionsMessage : ()=>noOptionsMessage,
            footer: footer,
            isDisabled: isDisabled,
            isInvalid: isInvalid,
            isFocused: menuIsOpen,
            backspaceRemovesValue: isMulti,
            filterOption: null,
            clearValueLabel: clearValueLabel,
            menuMinWidth: menuMinWidth,
            menuPortalTarget: menuPortalTarget,
            disableInput: disableInput || isDisabled,
            instanceId: fieldId,
            inputId: inputId,
            onChange: this.handleChange,
            onMenuOpen: this.handleOpen,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onMenuClose: this.handleClose,
            onInputChange: this.handleInputChange,
            onClearIndicatorHover: this.handleClearIndicatorHover,
            onKeyDown: this.handleKeyDown,
            maxPickerHeight: maxPickerHeight,
            textFieldBackgroundColor: textFieldBackgroundColor,
            header: header,
            placeholderAvatar: placeholderAvatar,
            ...restAriaProps,
            ...pickerProps,
            ...UNSAFE_hasDraggableParentComponent && {
                onValueContainerClick: this.handleClickDraggableParentComponent
            },
            ...menuOpenDeciderProps
        });
    }
    constructor(props){
        super(props);
        this.selectRef = void 0;
        this.session = void 0;
        // session id for focus to blur
        this.journeyId = void 0;
        this.optionsShownUfoExperienceInstance = void 0;
        this.getSessionId = ()=>this.session && this.session.id ? this.session.id : undefined;
        this.withSelectRef = (callback)=>()=>{
                if (this.selectRef) callback(this.selectRef);
            };
        this.nextOption = this.withSelectRef((select)=>select.focusOption('down'));
        this.previousOption = this.withSelectRef((select)=>select.focusOption('up'));
        this.focus = ()=>{
            if (this.selectRef && this.selectRef.focus) this.selectRef.focus();
        };
        this.blur = ()=>{
            if (this.selectRef && this.selectRef.blur) this.selectRef.blur();
        };
        this.selectOption = this.withSelectRef((select)=>{
            const focusedOption = select.state.focusedOption;
            select.selectOption(focusedOption);
        });
        // value = null if user deletes the last item in the user picker
        this.handleChange = (value, { action: action, removedValue: removedValue, option: option })=>{
            if (removedValue && removedValue.data.fixed) return;
            this.resetInputState();
            const { onChange: onChange, onSelection: onSelection, onClear: onClear, isMulti: isMulti } = this.props;
            (0, $f1uNX.callCallback)(onChange, (0, $f1uNX.extractOptionValue)(value), action);
            switch(action){
                case 'select-option':
                    if (value) (0, $f1uNX.callCallback)(onSelection, (0, $f1uNX.extractOptionValue)(value), this.getSessionId(), this);
                    this.fireEvent((0, $4hbXV.selectEvent), isMulti ? option : value);
                    this.session = isMulti ? (0, $4hbXV.startSession)() : undefined;
                    break;
                case 'clear':
                    (0, $f1uNX.callCallback)(onClear);
                    this.fireEvent((0, $4hbXV.clearEvent));
                    break;
                case 'remove-value':
                case 'pop-value':
                    if (removedValue) this.fireEvent((0, $4hbXV.deleteEvent), removedValue.data);
                    break;
            }
            this.fireEvent((0, $4hbXV.searchedEvent));
            if (removedValue && this.state.value && Array.isArray(this.state.value)) {
                const remainingValues = this.state.value.filter((val)=>val.data.id !== removedValue.data.id);
                this.setState({
                    value: remainingValues ? remainingValues : [],
                    menuIsOpen: true
                });
            }
            if (!this.props.value) this.setState({
                value: value ? value : []
            });
        };
        this.handleSelectRef = (ref)=>{
            this.selectRef = ref;
        };
        this.addOptions = (0, $a4iVb.batchByKey)((request, newOptions)=>{
            const { resolving: resolving } = this.state;
            this.setState(({ inflightRequest: inflightRequest, options: options, count: count })=>{
                if (inflightRequest.toString() === request) return {
                    options: (resolving ? options : []).concat(newOptions.reduce((nextOptions, item)=>Array.isArray(item) ? nextOptions.concat(item[0]) : nextOptions.concat(item), [])),
                    count: count - newOptions.length,
                    resolving: count - newOptions.length !== 0
                };
                return null;
            });
        });
        this.handleLoadOptionsError = ()=>{
            const { count: count } = this.state;
            const newCount = count - 1;
            const resolving = newCount !== 0;
            let showError = false;
            if (!resolving) showError = true;
            this.setState({
                count: newCount,
                resolving: resolving,
                showError: showError
            });
            this.fireEvent((0, $4hbXV.failedEvent));
        };
        this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))((search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) {
                const inflightRequest = this.state.inflightRequest + 1;
                const result = this.session && this.session.id ? loadOptions(search, this.session.id) : loadOptions(search);
                const addOptions = this.addOptions.bind(this, inflightRequest.toString());
                let count = 0;
                if ((0, $f1uNX.isIterable)(result)) for (const value of result){
                    Promise.resolve(value).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                else {
                    Promise.resolve(result).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                this.setState({
                    inflightRequest: inflightRequest,
                    count: count,
                    resolving: count !== 0,
                    options: []
                });
            }
        }, 200);
        this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $j7Sza.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        };
        this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        };
        this.executeLoadOptions = (search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) this.setState({
                resolving: true,
                showError: false
            }, ()=>this.debouncedLoadOptions(search));
        };
        this.handleFocus = (event)=>{
            const { value: value, menuIsOpen: menuIsOpen } = this.state;
            if (!menuIsOpen || !this.session) this.startSession();
            this.startOptionsShownUfoExperience();
            (0, $f1uNX.callCallback)(this.props.onFocus, this.getSessionId());
            const openMenuOnFocus = this.props.openMenuOnFocus ?? true;
            if (!this.isMenuOpenOnClickForSingleSelect && openMenuOnFocus) {
                this.setState({
                    menuIsOpen: true
                });
                if (!this.props.isMulti && (0, $f1uNX.isSingleValue)(value)) {
                    const input = event.target;
                    this.setState({
                        inputValue: value.label
                    }, ()=>{
                        if (input instanceof HTMLInputElement) input.setSelectionRange(0, value.label.length);
                    });
                }
            }
        };
        this.resetInputState = ()=>{
            // Prevent filter if query typed, then blurred with no selection
            this.setState({
                inputValue: ''
            });
            (0, $f1uNX.callCallback)(this.props.onInputChange, '', this.getSessionId());
        };
        this.handleOpen = ()=>{
            (0, $f1uNX.callCallback)(this.props.onOpen, this.getSessionId());
            this.setState({
                menuIsOpen: true
            });
        };
        this.handleBlur = ()=>{
            if (this.props.isFooterFocused || this.props.isHeaderFocused) return;
            (0, $f1uNX.callCallback)(this.props.onBlur, this.getSessionId());
            if ((0, $f1uNX.isPopupUserPickerByComponent)(this.props.SelectComponent)) return;
            this.resetInputState();
            this.abortOptionsShownUfoExperience();
            this.setState({
                menuIsOpen: false,
                initialFocusHandled: false,
                options: []
            });
        };
        this.handleClose = ()=>{
            if (this.props.isFooterFocused || this.props.isHeaderFocused) return;
            this.resetInputState();
            (0, $f1uNX.callCallback)(this.props.onClose, this.getSessionId());
            this.setState({
                menuIsOpen: false,
                options: []
            });
        };
        this.handleInputChange = (search, { action: action })=>{
            if (action === 'input-change' || action === 'set-value') {
                (0, $f1uNX.callCallback)(this.props.onInputChange, search, this.getSessionId());
                this.setState({
                    inputValue: search
                });
                this.startOptionsShownUfoExperience();
            }
        };
        this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $4hbXV.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, this.session, this.journeyId, ...args))(createAnalyticsEvent);
        };
        this.startSession = ()=>{
            this.session = (0, $4hbXV.startSession)();
            this.journeyId = this.getSessionId();
            this.fireEvent((0, $4hbXV.focusEvent));
        };
        this.handleKeyDown = (event)=>{
            if (!this.isMenuOpenOnClickForSingleSelect) {
                // Escape
                if (event.keyCode === 27) this.blur();
                // Space
                if (event.keyCode === 32 && !this.state.inputValue) {
                    event.preventDefault();
                    !this.props.disableInput && this.setState({
                        inputValue: ' '
                    });
                }
            }
            if (this.session) {
                this.session.lastKey = event.keyCode;
                switch(event.keyCode){
                    // KeyUp 38
                    case 38:
                        this.session.upCount++;
                        break;
                    // KeyDown 40
                    case 40:
                        this.session.downCount++;
                        break;
                }
            }
            this.props.onKeyDown && this.props.onKeyDown(event);
            if (event.key === 'Escape') {
                this.setState({
                    menuIsOpen: false,
                    options: []
                });
                this.props.setIsFooterFocused && this.props.setIsFooterFocused(false);
                this.props.setIsHeaderFocused && this.props.setIsHeaderFocused(false);
            }
            if (event.key === 'Tab' && this.props.setIsFooterFocused && this.props.footer) this.props.setIsFooterFocused(true);
            if (event.key === 'Tab' && this.props.setIsHeaderFocused && this.props.header) this.props.setIsHeaderFocused(true);
        };
        this.handleClearIndicatorHover = (hoveringClearIndicator)=>{
            this.setState({
                hoveringClearIndicator: hoveringClearIndicator
            });
        };
        this.getOptionsOld = ()=>{
            const options = (0, $f1uNX.getOptions)(this.state.options) || [];
            const { maxOptions: maxOptions, isMulti: isMulti, groupByTypeOrder: groupByTypeOrder } = this.props;
            if (maxOptions === 0) return [];
            if (maxOptions && maxOptions > 0 && maxOptions < options.length) {
                const { value: value } = this.state;
                let filteredOptions = options;
                // Filter out previously selected options
                if (isMulti && Array.isArray(value)) {
                    const valueIds = value.map((item)=>item.data.id);
                    filteredOptions = options.filter((option)=>valueIds.indexOf(option.data.id) === -1);
                }
                return groupByTypeOrder ? (0, $1Xd8s.groupOptionsByType)(filteredOptions.slice(0, maxOptions), groupByTypeOrder) : filteredOptions.slice(0, maxOptions);
            }
            return groupByTypeOrder ? (0, $1Xd8s.groupOptionsByType)(options, groupByTypeOrder) : options;
        };
        this.getOptionsNew = ()=>{
            const options = (0, $f1uNX.getOptions)(this.state.options) || [];
            const { maxOptions: maxOptions, isMulti: isMulti, groupByTypeOrder: groupByTypeOrder, customGroupLabels: customGroupLabels } = this.props;
            if (maxOptions === 0) return [];
            if (maxOptions && maxOptions > 0 && maxOptions < options.length) {
                const { value: value } = this.state;
                let filteredOptions = options;
                // Filter out previously selected options
                if (isMulti && Array.isArray(value)) {
                    const valueIds = value.map((item)=>item.data.id);
                    filteredOptions = options.filter((option)=>valueIds.indexOf(option.data.id) === -1);
                }
                return groupByTypeOrder ? (0, $1Xd8s.groupOptionsByType)(filteredOptions.slice(0, maxOptions), groupByTypeOrder, customGroupLabels) : filteredOptions.slice(0, maxOptions);
            }
            return groupByTypeOrder ? (0, $1Xd8s.groupOptionsByType)(options, groupByTypeOrder, customGroupLabels) : options;
        };
        this.getOptions = ()=>{
            return (0, $ixfCV.fg)('jsm-wfo-assignee-recommendation-on-queues') ? this.getOptionsNew() : this.getOptionsOld();
        };
        this.getAppearance = ()=>this.props.appearance ? this.props.appearance : 'normal';
        this.handleClickDraggableParentComponent = ()=>{
            if (this.state.initialFocusHandled) {
                // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                if (this.state.menuIsOpen) this.handleClose();
                else this.handleOpen();
            } else if (!this.state.menuIsOpen && !this.isMenuOpenOnClickForSingleSelect) {
                // Trigger focus state when ValueContainer is clicked for the first time
                // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                // to manage the state of the dropdown menu
                this.focus();
                this.setState(()=>({
                        initialFocusHandled: true
                    }));
            }
        };
        this.shouldKeepMenuOpen = ()=>Boolean(!!this.props.footer) && Boolean(this.props.isFooterFocused) || Boolean(!!this.props.header) && Boolean(this.props.isHeaderFocused);
        this.state = {
            options: [],
            isDefaultSet: false,
            inflightRequest: 0,
            count: 0,
            hoveringClearIndicator: false,
            menuIsOpen: !!this.props.open,
            inputValue: props.search || '',
            resolving: false,
            showError: false,
            initialFocusHandled: false
        };
        this.optionsShownUfoExperienceInstance = // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        (0, $aZ910.userPickerOptionsShownUfoExperience).getInstance((0, $kHija.v4)());
        if (this.props.forwardedRef) {
            const refValue = {
                focus: this.focus,
                blur: this.blur
            };
            if (typeof this.props.forwardedRef === 'function') this.props.forwardedRef(refValue);
            else this.props.forwardedRef.current = refValue;
        }
    }
}
$a288f8d93fd9b6f7$export$b4ff48c8d43b18c3.defaultProps = {
    isMulti: false,
    subtle: false,
    noBorder: false,
    textFieldBackgroundColor: false,
    isClearable: true,
    loadOptionsErrorMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).errorMessage),
    openMenuOnClick: false
};
const $a288f8d93fd9b6f7$export$d099ade7b4f4d2a4 = (0, $lzgC6.default)()($a288f8d93fd9b6f7$export$b4ff48c8d43b18c3);
module.exports["BaseUserPickerWithoutAnalytics"] = $a288f8d93fd9b6f7$export$b4ff48c8d43b18c3;

});

parcelRegister("4hbXV", function(module, exports) {
// eslint-disable-next-line @typescript-eslint/consistent-type-imports

var $2iGHk = parcelRequire("2iGHk");


var $cXtTj = parcelRequire("cXtTj");


var $ixfCV = parcelRequire("ixfCV");


var $kHija = parcelRequire("kHija");


var $f1uNX = parcelRequire("f1uNX");

const $dd632030d02bf872$var$packageName = "platform-pkg";
const $dd632030d02bf872$var$packageVersion = "0.0.0-use.local";
const $dd632030d02bf872$var$UUID_REGEXP_TEAMS_GROUPS = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $dd632030d02bf872$var$UUID_REGEXP_OLD_AAID = /^[a-fA-F0-9]{1,8}:[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $dd632030d02bf872$var$UUID_REGEXP_NEW_AAID = /^[a-fA-F0-9]{24,24}$/;
const $dd632030d02bf872$export$c0d84948cecf78d8 = ()=>({
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        id: (0, $kHija.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $dd632030d02bf872$export$53eef0dcd9611650 = (0, $2iGHk.default)('fabric-elements');
const $dd632030d02bf872$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $dd632030d02bf872$var$packageName,
            packageVersion: $dd632030d02bf872$var$packageVersion,
            ...attributes
        }
    });
const $dd632030d02bf872$var$checkValidId = (id)=>{
    return $dd632030d02bf872$var$UUID_REGEXP_NEW_AAID.test(id) || $dd632030d02bf872$var$UUID_REGEXP_OLD_AAID.test(id) || $dd632030d02bf872$var$UUID_REGEXP_TEAMS_GROUPS.test(id);
};
const $dd632030d02bf872$var$optionData2Analytics = (option)=>{
    const { id: id, type: type } = option;
    // id's of email types are emails which is PII
    const validatedData = {
        id: $dd632030d02bf872$var$checkValidId(id) ? id : null,
        type: type || null
    };
    if ((0, $f1uNX.isExternalUser)(option)) return {
        ...validatedData,
        type: 'external_user',
        sources: option.sources,
        externalUserType: option.externalUserType
    };
    if ((0, $f1uNX.isCustom)(option) && option.analyticsType) return {
        ...validatedData,
        type: option.analyticsType
    };
    return validatedData;
};
const $dd632030d02bf872$var$buildValueForAnalytics = (value)=>{
    if (value) {
        const valueToConvert = Array.isArray(value) ? value : [
            value
        ];
        return valueToConvert.map(({ data: data })=>$dd632030d02bf872$var$optionData2Analytics(data));
    }
    return [];
};
const $dd632030d02bf872$var$selectedCustomGroupAnalyticsAttributes = (props, option)=>{
    if (!props.customGroupLabels) return {};
    const selectedType = option?.data.type;
    const analyticsLabel = selectedType ? props.customGroupAnalyticsLabels?.[selectedType] : undefined;
    return {
        hasCustomGroupLabels: true,
        ...analyticsLabel ? {
            selectedLabel: analyticsLabel
        } : {}
    };
};
const $dd632030d02bf872$var$createDefaultPickerAttributes = (props, session, journeyId)=>({
        context: props.fieldId,
        sessionId: $dd632030d02bf872$var$sessionId(session),
        pickerType: $dd632030d02bf872$var$pickerType(props),
        journeyId: journeyId
    });
const $dd632030d02bf872$export$e7818c470f37c4bd = (props, state, session, journeyId)=>$dd632030d02bf872$var$createEvent('ui', 'focused', 'userPicker', {
        ...$dd632030d02bf872$var$createDefaultPickerAttributes(props, session, journeyId),
        values: $dd632030d02bf872$var$buildValueForAnalytics(state.value)
    });
const $dd632030d02bf872$export$7b5800e732182efb = (props, state, session, journeyId)=>$dd632030d02bf872$var$createEvent('ui', 'cleared', 'userPicker', {
        ...$dd632030d02bf872$var$createDefaultPickerAttributes(props, session, journeyId),
        pickerOpen: state.menuIsOpen,
        values: $dd632030d02bf872$var$values(state)
    });
const $dd632030d02bf872$export$95711ec6c6227e9a = (props, state, session, journeyId, ...args)=>$dd632030d02bf872$var$createEvent('ui', 'deleted', 'userPickerItem', {
        context: props.fieldId,
        sessionId: $dd632030d02bf872$var$sessionId(session),
        journeyId: journeyId,
        value: $dd632030d02bf872$var$optionData2Analytics(args[0]),
        pickerOpen: state.menuIsOpen,
        ...(0, $cXtTj.default).getExperimentValue('team_member_suggestions_while_creating_team', 'isEnabled', false) && args[0]?.isSuggestedMember !== undefined ? {
            isSuggestedMember: args[0].isSuggestedMember
        } : {}
    });
const $dd632030d02bf872$export$e9caaaecfee38128 = (props, _, session, journeyId, ...args)=>$dd632030d02bf872$var$createEvent('ui', 'cancelled', 'userPicker', {
        ...$dd632030d02bf872$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $dd632030d02bf872$var$sessionDuration(session),
        queryLength: $dd632030d02bf872$var$queryLength(args[0]),
        spaceInQuery: $dd632030d02bf872$var$spaceInQuery(args[0]),
        upKeyCount: $dd632030d02bf872$var$upKeyCount(session),
        downKeyCount: $dd632030d02bf872$var$downKeyCount(session)
    });
const $dd632030d02bf872$export$48143d759475d90f = (props, state, session, journeyId, ...args)=>{
    return $dd632030d02bf872$var$createEvent('ui', $dd632030d02bf872$var$selectEventType(session), 'userPicker', {
        ...$dd632030d02bf872$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $dd632030d02bf872$var$sessionDuration(session),
        position: $dd632030d02bf872$var$position(state, args[0]),
        queryLength: $dd632030d02bf872$var$queryLength(state),
        spaceInQuery: $dd632030d02bf872$var$spaceInQuery(state),
        upKeyCount: $dd632030d02bf872$var$upKeyCount(session),
        downKeyCount: $dd632030d02bf872$var$downKeyCount(session),
        result: $dd632030d02bf872$var$result(args[0]),
        numberOfResults: $dd632030d02bf872$var$numberOfResults(state),
        ...(0, $ixfCV.fg)('jsm_routing_recommended_agent_minor_fix') ? $dd632030d02bf872$var$selectedCustomGroupAnalyticsAttributes(props, args[0]) : {}
    });
};
const $dd632030d02bf872$export$911fb7184b6037eb = (props, state, session, journeyId)=>{
    const searchResults = $dd632030d02bf872$var$results(state);
    return $dd632030d02bf872$var$createEvent('operational', 'searched', 'userPicker', {
        ...$dd632030d02bf872$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $dd632030d02bf872$var$sessionDuration(session),
        durationSinceInputChange: $dd632030d02bf872$var$durationSinceInputChange(session),
        queryLength: $dd632030d02bf872$var$queryLength(state),
        isLoading: $dd632030d02bf872$var$isLoading(props, state),
        results: searchResults,
        numberOfResults: searchResults.length
    });
};
const $dd632030d02bf872$export$c2aec355fef65c9c = (props, _, session, journeyId)=>$dd632030d02bf872$var$createEvent('operational', 'failed', 'userPicker', {
        ...$dd632030d02bf872$var$createDefaultPickerAttributes(props, session, journeyId)
    });
const $dd632030d02bf872$export$f541f04954b0c11e = (sources, accountId)=>$dd632030d02bf872$var$createEvent('ui', 'displayed', 'userInfo', {
        sources: sources,
        // accountId can be PII if it is an email so check that it's an AAID first
        accountId: $dd632030d02bf872$var$checkValidId(accountId) ? accountId : null
    });
function $dd632030d02bf872$var$queryLength(state) {
    return state.inputValue.length;
}
function $dd632030d02bf872$var$selectEventType(session) {
    return session && session.lastKey === 13 ? 'pressed' : 'clicked';
}
function $dd632030d02bf872$var$upKeyCount(session) {
    return session ? session.upCount : null;
}
function $dd632030d02bf872$var$downKeyCount(session) {
    return session ? session.downCount : null;
}
function $dd632030d02bf872$var$spaceInQuery(state) {
    return state.inputValue.indexOf(' ') !== -1;
}
function $dd632030d02bf872$var$sessionDuration(session) {
    return session ? Date.now() - session.start : null;
}
function $dd632030d02bf872$var$durationSinceInputChange(session) {
    return session ? Date.now() - session.inputChangeTime : null;
}
function $dd632030d02bf872$var$sessionId(session) {
    return session && session.id;
}
function $dd632030d02bf872$var$position(state, value) {
    return value ? state.options.findIndex((option)=>option === value.data) : -1;
}
function $dd632030d02bf872$var$pickerType(props) {
    return props.isMulti ? 'multi' : 'single';
}
function $dd632030d02bf872$var$result(option) {
    return option ? $dd632030d02bf872$var$optionData2Analytics(option.data) : null;
}
function $dd632030d02bf872$var$results(state) {
    return (state.options || []).map($dd632030d02bf872$var$optionData2Analytics);
}
function $dd632030d02bf872$var$isLoading(props, state) {
    return state.count > 0 || props.isLoading;
}
function $dd632030d02bf872$var$values(state) {
    return state.value ? Array.isArray(state.value) ? state.value.map((option)=>$dd632030d02bf872$var$optionData2Analytics(option.data)) : [
        $dd632030d02bf872$var$optionData2Analytics(state.value.data)
    ] : [];
}
function $dd632030d02bf872$var$numberOfResults(state) {
    return (state.options || []).length;
}
module.exports["startSession"] = $dd632030d02bf872$export$c0d84948cecf78d8;
module.exports["createAndFireEventInElementsChannel"] = $dd632030d02bf872$export$53eef0dcd9611650;
module.exports["focusEvent"] = $dd632030d02bf872$export$e7818c470f37c4bd;
module.exports["clearEvent"] = $dd632030d02bf872$export$7b5800e732182efb;
module.exports["deleteEvent"] = $dd632030d02bf872$export$95711ec6c6227e9a;
module.exports["cancelEvent"] = $dd632030d02bf872$export$e9caaaecfee38128;
module.exports["selectEvent"] = $dd632030d02bf872$export$48143d759475d90f;
module.exports["searchedEvent"] = $dd632030d02bf872$export$911fb7184b6037eb;
module.exports["failedEvent"] = $dd632030d02bf872$export$c2aec355fef65c9c;
module.exports["userInfoEvent"] = $dd632030d02bf872$export$f541f04954b0c11e;

});

parcelRegister("f1uNX", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $9kYT2 = parcelRequire("9kYT2");


var $3GNtk = parcelRequire("3GNtk");

const $f703df8a196cd65a$export$f6058dbcb5980cb = (option)=>option.type === (0, $9kYT2.ExternalUserType) || Boolean(option.isExternal);
const $f703df8a196cd65a$export$2e44165f1da65304 = (option)=>option.type === undefined || option.type === (0, $9kYT2.UserType);
const $f703df8a196cd65a$export$f8c4277cb588611f = (option)=>option?.type === (0, $9kYT2.TeamType);
const $f703df8a196cd65a$export$d7976824e9f55785 = (option)=>option.type === (0, $9kYT2.GroupType);
const $f703df8a196cd65a$export$7fbbfbca30081d0 = (option)=>option.type === (0, $9kYT2.EmailType);
const $f703df8a196cd65a$export$d3a8f0b77e9737fc = (option)=>option.type === (0, $9kYT2.CustomType);
const $f703df8a196cd65a$export$d6978985a41b0c8 = (value)=>value && !Array.isArray(value) || Array.isArray(value) && value.length > 0;
const $f703df8a196cd65a$var$isOptionData = (option)=>option.name !== undefined;
const $f703df8a196cd65a$export$3f993c492bd6c728 = (option)=>{
    if ($f703df8a196cd65a$var$isOptionData(option)) return {
        data: option,
        isDisabled: option.isDisabled,
        label: option.name,
        value: option.id
    };
    else return {
        data: {
            ...option,
            name: option.id
        },
        isDisabled: option.isDisabled,
        label: option.id,
        value: option.id
    };
};
const $f703df8a196cd65a$export$7ae97131df521bff = (value)=>{
    if (!value) return undefined;
    if (Array.isArray(value)) return value.map(({ data: option })=>option);
    return value.data;
};
const $f703df8a196cd65a$export$9652023d9040757 = (a)=>typeof a?.[Symbol.iterator] === 'function';
const $f703df8a196cd65a$export$d2312e68e1f5ad00 = (0, $dOBRD.default)((options)=>options.map($f703df8a196cd65a$export$3f993c492bd6c728));
const $f703df8a196cd65a$export$e6fda14a194bcbcc = (0, $dOBRD.default)((defaultValue)=>{
    if (!defaultValue) return null;
    if (Array.isArray(defaultValue)) return defaultValue.map($f703df8a196cd65a$export$3f993c492bd6c728);
    return $f703df8a196cd65a$export$3f993c492bd6c728(defaultValue);
});
const $f703df8a196cd65a$export$695fb564e621339a = (appearance)=>appearance === 'big' ? 'medium' : appearance === 'multi' ? 'xsmall' : 'small';
const $f703df8a196cd65a$export$3c62cf9a01367f27 = (child)=>child && typeof child === 'object' && child.props && child.props.type === 'text';
const $f703df8a196cd65a$export$203c2bd2662d1ca2 = (value)=>!!value && !Array.isArray(value);
const $f703df8a196cd65a$export$96bdbc84526f3739 = (value)=>!!value && value.trim().length > 0;
const $f703df8a196cd65a$export$df325aa844b03c31 = (callback, ...args)=>{
    if (typeof callback === 'function') try {
        //  there is mystery error in IE 11, so we need this try-catch
        return callback(...args);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('@atlassian/user-select: an error happening in `callCallback`: ', error);
    }
    return undefined;
};
const $f703df8a196cd65a$export$b4f8f1f54acec99b = (optionData)=>{
    if ($f703df8a196cd65a$export$2e44165f1da65304(optionData) || $f703df8a196cd65a$export$f8c4277cb588611f(optionData) || $f703df8a196cd65a$export$d3a8f0b77e9737fc(optionData) || $f703df8a196cd65a$export$f6058dbcb5980cb(optionData)) return optionData.avatarUrl;
    return undefined;
};
const $f703df8a196cd65a$export$4f60a74234178416 = (SelectComponent)=>SelectComponent === (0, $3GNtk.default);
const $f703df8a196cd65a$export$7add003953ca6733 = (selectProps)=>selectProps.searchThreshold === -1;
const $f703df8a196cd65a$export$5419897287f5f1c7 = (lozengeProp)=>{
    return lozengeProp?.hasOwnProperty('text') || false;
};
module.exports["isExternalUser"] = $f703df8a196cd65a$export$f6058dbcb5980cb;
module.exports["isUser"] = $f703df8a196cd65a$export$2e44165f1da65304;
module.exports["isTeam"] = $f703df8a196cd65a$export$f8c4277cb588611f;
module.exports["isGroup"] = $f703df8a196cd65a$export$d7976824e9f55785;
module.exports["isEmail"] = $f703df8a196cd65a$export$7fbbfbca30081d0;
module.exports["isCustom"] = $f703df8a196cd65a$export$d3a8f0b77e9737fc;
module.exports["isDefaultValuePopulated"] = $f703df8a196cd65a$export$d6978985a41b0c8;
module.exports["extractOptionValue"] = $f703df8a196cd65a$export$7ae97131df521bff;
module.exports["isIterable"] = $f703df8a196cd65a$export$9652023d9040757;
module.exports["getOptions"] = $f703df8a196cd65a$export$d2312e68e1f5ad00;
module.exports["optionToSelectableOptions"] = $f703df8a196cd65a$export$e6fda14a194bcbcc;
module.exports["getAvatarSize"] = $f703df8a196cd65a$export$695fb564e621339a;
module.exports["isChildInput"] = $f703df8a196cd65a$export$3c62cf9a01367f27;
module.exports["isSingleValue"] = $f703df8a196cd65a$export$203c2bd2662d1ca2;
module.exports["hasValue"] = $f703df8a196cd65a$export$96bdbc84526f3739;
module.exports["callCallback"] = $f703df8a196cd65a$export$df325aa844b03c31;
module.exports["getAvatarUrl"] = $f703df8a196cd65a$export$b4f8f1f54acec99b;
module.exports["isPopupUserPickerByComponent"] = $f703df8a196cd65a$export$4f60a74234178416;
module.exports["isLozengeText"] = $f703df8a196cd65a$export$5419897287f5f1c7;

});

parcelRegister("9kYT2", function(module, exports) {
const $7b15e63389e1c86f$export$8436e53e45ffe15b = 'user';
const $7b15e63389e1c86f$export$50042ec1d2e00e63 = 'external_user';
const $7b15e63389e1c86f$export$26bc40b960693765 = 'team';
const $7b15e63389e1c86f$export$d460f747b73abb10 = 'group';
const $7b15e63389e1c86f$export$6662b3461398ef8c = 'email';
const $7b15e63389e1c86f$export$eafd0979afa5b224 = 'custom';
module.exports["UserType"] = $7b15e63389e1c86f$export$8436e53e45ffe15b;
module.exports["ExternalUserType"] = $7b15e63389e1c86f$export$50042ec1d2e00e63;
module.exports["TeamType"] = $7b15e63389e1c86f$export$26bc40b960693765;
module.exports["GroupType"] = $7b15e63389e1c86f$export$d460f747b73abb10;
module.exports["EmailType"] = $7b15e63389e1c86f$export$6662b3461398ef8c;
module.exports["CustomType"] = $7b15e63389e1c86f$export$eafd0979afa5b224;

});

parcelRegister("a4iVb", function(module, exports) {
function $77fb950dcbf791ab$export$da86c38211c1c0a8(callback) {
    const calls = {};
    return (key, ...args)=>{
        if (!calls[key]) {
            window.setTimeout(()=>{
                callback(key, calls[key]);
                delete calls[key];
            });
            calls[key] = [];
        }
        calls[key].push(args);
    };
}
module.exports["batchByKey"] = $77fb950dcbf791ab$export$da86c38211c1c0a8;

});

parcelRegister("7xLai", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $b9ef7149d9297ba5$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    placeholder: {
        id: "fabric.elements.user-picker.placeholder",
        defaultMessage: "Enter people or teams..."
    },
    addMore: {
        id: "fabric.elements.user-picker.placeholder.add-more",
        defaultMessage: "add more people..."
    },
    remove: {
        id: "fabric.elements.user-picker.multi.remove-item",
        defaultMessage: "Remove"
    },
    clear: {
        id: "fabric.elements.user-picker.single.clear",
        defaultMessage: "Clear"
    },
    errorMessage: {
        id: "fabric.elements.user-picker.error.message",
        defaultMessage: "Something went wrong"
    },
    teamByline: {
        id: "fabric.elements.user-picker.team.byline",
        defaultMessage: "Team"
    },
    officialTeamByline: {
        id: "fabric.elements.user-picker.team.byline.official",
        defaultMessage: "{teamTypeName} {verifiedIcon}"
    },
    officialMemberCountWithoutYou: {
        id: "fabric.elements.user-picker.team.member.count.official",
        defaultMessage: "{teamTypeName} {verifiedIcon} \u2022 {count} {count, plural, one {member} other {members}}"
    },
    officialMemberCountWithYou: {
        id: "fabric.elements.user-picker.team.member.count.official.including.you",
        defaultMessage: "{teamTypeName} {verifiedIcon} \u2022 {count} {count, plural, one {member} other {members}}, including you"
    },
    memberCountWithoutYou: {
        id: "fabric.elements.user-picker.team.member.count",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}"
    },
    memberCountWithYou: {
        id: "fabric.elements.user-picker.team.member.count.including.you",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you"
    },
    officialPlus50MembersWithoutYou: {
        id: "fabric.elements.user-picker.team.member.50plus.official",
        defaultMessage: "{teamTypeName} {verifiedIcon} \u2022 50+ members"
    },
    officialPlus50MembersWithYou: {
        id: "fabric.elements.user-picker.team.member.50plus.official.including.you",
        defaultMessage: "{teamTypeName} {verifiedIcon} \u2022 50+ members, including you"
    },
    plus50MembersWithoutYou: {
        id: "fabric.elements.user-picker.team.member.50plus",
        defaultMessage: "Team \u2022 50+ members"
    },
    plus50MembersWithYou: {
        id: "fabric.elements.user-picker.team.member.50plus.including.you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    addEmail: {
        id: "fabric.elements.user-picker.email.add",
        defaultMessage: "Add user"
    },
    selectToAddEmail: {
        id: "fabric.elements.user-picker.email.select.to.add",
        defaultMessage: "Select an email address"
    },
    continueToAddEmail: {
        id: "fabric.elements.user-picker.email.add.potential",
        defaultMessage: "Enter an email address"
    },
    adminManagedGroupByline: {
        id: "fabric.elements.user-picker.group.byline.admin-managed",
        defaultMessage: "Admin group {verifiedIcon}"
    },
    groupByline: {
        id: "fabric.elements.user-picker.group.byline",
        defaultMessage: "Admin-managed group"
    },
    externalUserSourcesHeading: {
        id: "fabric.elements.user-picker.external.sourced.from",
        defaultMessage: "Found in:"
    },
    externalUserSourcesError: {
        id: "fabric.elements.user-picker.external.sourced.error",
        defaultMessage: "We can't connect you right now."
    },
    slackProvider: {
        id: "fabric.elements.user-picker.slack.provider",
        defaultMessage: "Slack"
    },
    googleProvider: {
        id: "fabric.elements.user-picker.google.provider",
        defaultMessage: "Google"
    },
    microsoftProvider: {
        id: "fabric.elements.user-picker.microsoft.provider",
        defaultMessage: "Microsoft"
    },
    gitHubProvider: {
        id: "fabric.elements.user-picker.github.provider",
        defaultMessage: "GitHub"
    },
    jiraSource: {
        id: "fabric.elements.user-picker.source.jira",
        defaultMessage: "Jira"
    },
    confluenceSource: {
        id: "fabric.elements.user-picker.source.confluence",
        defaultMessage: "Confluence"
    },
    otherAtlassianSource: {
        id: "fabric.elements.user-picker.source.other-atlassian",
        defaultMessage: "Other Atlassian products"
    },
    otherAtlassianSourceAppify: {
        id: "fabric.elements.user-picker.source.other-atlassian-appify",
        defaultMessage: "Other Atlassian apps"
    },
    memberLozengeText: {
        id: "fabric.elements.user-picker.member.lozenge.text",
        defaultMessage: "MEMBER"
    },
    guestLozengeText: {
        id: "fabric.elements.user-picker.guest.lozenge.text",
        defaultMessage: "GUEST"
    },
    guestUserLozengeTooltip: {
        id: "fabric.elements.user-picker.guest.lozenge.tooltip.user",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    },
    guestGroupLozengeTooltip: {
        id: "fabric.elements.user-picker.guest.lozenge.tooltip.group",
        defaultMessage: "Guest groups can only access certain spaces and have limited access to user info."
    },
    archivedLozenge: {
        id: "fabric.elements.user-picker.archived.lozenge.text",
        defaultMessage: "Archived"
    },
    userTypeLabel: {
        id: "fabric.elements.user-picker.user.type.label",
        defaultMessage: "People"
    },
    teamTypeLabel: {
        id: "fabric.elements.user-picker.team.type.label",
        defaultMessage: "Teams"
    },
    emailTypeLabel: {
        id: "fabric.elements.user-picker.email.type.label",
        defaultMessage: "Emails"
    },
    groupTypeLabel: {
        id: "fabric.elements.user-picker.group.type.label",
        defaultMessage: "Groups"
    },
    externalUserTypeLabel: {
        id: "fabric.elements.user-picker.external.user.type.label",
        defaultMessage: "External Users"
    },
    customTypeLabel: {
        id: "fabric.elements.user-picker.custom.type.label",
        defaultMessage: "Customs"
    },
    otherTypeLabel: {
        id: "fabric.elements.user-picker.other.type.label",
        defaultMessage: "Others"
    }
});
module.exports["messages"] = $b9ef7149d9297ba5$export$defe85febe8b728c;

});

parcelRegister("1Xd8s", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ixfCV = parcelRequire("ixfCV");


var $kSwu1 = parcelRequire("kSwu1");


var $dOBRD = parcelRequire("dOBRD");


var $7xLai = parcelRequire("7xLai");

const $21c303164bc44ab5$var$getLabelForType = (type, customLabels)=>{
    if (customLabels && type in customLabels && (0, $ixfCV.fg)('jsm-wfo-assignee-recommendation-on-queues')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, customLabels[type]);
    switch(type){
        case 'user':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).userTypeLabel);
        case 'team':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).teamTypeLabel);
        case 'group':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).groupTypeLabel);
        case 'custom':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).customTypeLabel);
        case 'external_user':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).externalUserTypeLabel);
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).otherTypeLabel);
    }
};
const $21c303164bc44ab5$export$393a985f7dd07cfe = (0, $dOBRD.default)((options, groupByTypeOrder, customGroupLabels)=>{
    // If groupByTypeOrder is empty, just return the original options
    if (groupByTypeOrder.length === 0) return options;
    const groupedMap = new Map();
    options.forEach((option)=>{
        const type = option.data.type || 'other';
        if (!groupedMap.has(type)) groupedMap.set(type, []);
        groupedMap.get(type).push(option);
    });
    const result = [];
    // add groups in the specified order
    // type is not in groupByTypeOrder, don't add it to the result
    groupByTypeOrder.forEach((type)=>{
        if (groupedMap.has(type)) {
            result.push({
                label: $21c303164bc44ab5$var$getLabelForType(type, customGroupLabels),
                options: groupedMap.get(type)
            });
            groupedMap.delete(type);
        }
    });
    return result;
});
module.exports["groupOptionsByType"] = $21c303164bc44ab5$export$393a985f7dd07cfe;

});

parcelRegister("aZ910", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fh15z = parcelRequire("fh15z");

var $4MiWC = parcelRequire("4MiWC");

var $j7Sza = parcelRequire("j7Sza");

const $e55e5f2e4b7d5736$export$b49757166e1acfc2 = new (0, $fh15z.ConcurrentExperience)('user-picker-rendered', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $4MiWC.ExperienceTypes).Load,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).PageSegmentLoad
});
const $e55e5f2e4b7d5736$export$135a264e0da507ae = new (0, $fh15z.ConcurrentExperience)('user-picker-options-shown', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $4MiWC.ExperienceTypes).Operation,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult
});
class $e55e5f2e4b7d5736$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidCatch() {
        const instance = $e55e5f2e4b7d5736$export$b49757166e1acfc2.getInstance(this.props.id);
        if (instance.state.id !== (0, $j7Sza.UFOExperienceState).FAILED.id) instance.failure();
    }
    render() {
        return this.props.children;
    }
}
module.exports["userPickerRenderedUfoExperience"] = $e55e5f2e4b7d5736$export$b49757166e1acfc2;
module.exports["userPickerOptionsShownUfoExperience"] = $e55e5f2e4b7d5736$export$135a264e0da507ae;
module.exports["UfoErrorBoundary"] = $e55e5f2e4b7d5736$export$5ef1c2550074a375;

});

parcelRegister("aeELu", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $1TlML = parcelRequire("1TlML");


var $dOBRD = parcelRequire("dOBRD");

const $4ae7cbc7591eb216$export$59c188914e58c94b = "var(--ds-space-075, 6px)";
const $4ae7cbc7591eb216$export$53937c04f7dfc2ae = 6;
const $4ae7cbc7591eb216$export$2c62ba763e976c54 = 39;
const $4ae7cbc7591eb216$export$ffd58b7f6f099a57 = (0, $dOBRD.default)((width, isMulti, isCompact, overrideStyles, isVisualRefresh, isPopupStyles, height, minHeight)=>{
    let styles = {
        menu: (css, state)=>({
                ...css,
                width: width,
                minWidth: state.selectProps.menuMinWidth,
                zIndex: '400'
            }),
        menuList: (css)=>({
                ...css,
                zIndex: '400'
            }),
        control: (css, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                width: width,
                borderColor: state.isFocused ? "var(--ds-border-focused, #4688EC)" : state.isInvalid ? "var(--ds-border-danger, #E2483D)" : state.selectProps.subtle || state.selectProps.noBorder ? 'transparent' : "var(--ds-border-input, #8C8F97)",
                backgroundColor: state.isFocused ? "var(--ds-background-input, #FFFFFF)" : state.selectProps.subtle ? 'transparent' : state.isDisabled && (0, $ixfCV.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-background-disabled, #0515240F)" : state.selectProps.textFieldBackgroundColor ? "var(--ds-background-input, #FFFFFF)" : "var(--ds-background-input, #FFFFFF)",
                '&:hover .fabric-user-picker__clear-indicator': {
                    opacity: 1
                },
                ':hover': {
                    ...css[':hover'],
                    borderColor: state.isFocused ? css[':hover'] ? "var(--ds-border-focused, #4688EC)" : "var(--ds-border-focused, #4688EC)" : state.isInvalid ? "var(--ds-border-danger, #E2483D)" : state.selectProps.subtle ? 'transparent' : "var(--ds-border-input, #8C8F97)",
                    backgroundColor: state.selectProps.subtle && state.selectProps.hoveringClearIndicator ? "var(--ds-background-danger, #FFECEB)" : state.isFocused ? css[':hover'] ? "var(--ds-background-input, #FFFFFF)" : "var(--ds-background-input, #FFFFFF)" : state.isDisabled ? "var(--ds-background-disabled, #0515240F)" : "var(--ds-background-input-hovered, #F8F8F8)"
                },
                padding: 0,
                minHeight: minHeight ? minHeight : height || isCompact ? isMulti && (0, $ixfCV.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? 30 : 'none' : isMulti && (0, $ixfCV.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? 42 : 44,
                /* IE 11 needs to set height explicitly to be vertical align when being in not compact mode */ height: height ? height : isCompact || isMulti ? '100%' : 44,
                maxWidth: '100%'
            };
        },
        clearIndicator: ({ _paddingTop: _paddingTop, _paddingBottom: _paddingBottom, _paddingLeft: _paddingLeft, _paddingRight: _paddingRight, ...css })=>({
                ...css,
                // By default show clear indicator, except for on devices where "hover" is supported.
                // This means mobile devices (which do not support hover) will be able to see the clear indicator.
                opacity: 1,
                '@media (hover: hover) and (pointer: fine)': {
                    opacity: 0
                },
                transition: css.transition + ', opacity 150ms',
                paddingTop: 0,
                padding: 0,
                ':hover': {
                    color: "var(--ds-icon-danger, #C9372C)"
                }
            }),
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        valueContainer: ({ _paddingTop: _paddingTop, _paddingBottom: _paddingBottom, _position: _position, ...css }, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                gridTemplateColumns: 'auto 1fr',
                paddingTop: isCompact ? isMulti && (0, $ixfCV.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-space-025, 2px)" : 0 : isMulti && (0, $ixfCV.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-space-100, 8px)" : $4ae7cbc7591eb216$export$59c188914e58c94b,
                paddingBottom: isCompact ? isMulti && (0, $ixfCV.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-space-025, 2px)" : 0 : isMulti && (0, $ixfCV.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-space-100, 8px)" : $4ae7cbc7591eb216$export$59c188914e58c94b,
                // Match pre–tag-uplift leading inset when only the placeholder shows (share dialog VR, etc.).
                paddingLeft: isMulti ? state.hasValue && state.selectProps.controlShouldRenderValue !== false && (0, $ixfCV.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-space-100, 8px)" : $4ae7cbc7591eb216$export$59c188914e58c94b : 0,
                gap: isMulti && (0, $ixfCV.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? "var(--ds-space-050, 4px)" : undefined,
                overflowX: 'hidden',
                overflowY: 'auto',
                scrollbarWidth: 'none',
                maxHeight: state.selectProps.maxPickerHeight || '100%',
                '::-webkit-scrollbar': {
                    width: 0,
                    background: 'transparent'
                }
            };
        },
        multiValue: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'default'
            }),
        multiValueLabel: (css)=>({
                ...css,
                display: 'flex'
            }),
        multiValueRemove: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'pointer'
            }),
        placeholder: (css, state)=>{
            // fix styling in IE 11: when the position is absolute and `left` prop is not defined,
            // IE and other browsers auto calculate value of "left" prop differently,
            // so we want to explicitly set value for the `left` property
            if (css.position === 'absolute' && !css.left) css.left = `${$4ae7cbc7591eb216$export$59c188914e58c94b}px`;
            return {
                ...css,
                gridArea: '1/2/2/3',
                paddingLeft: state.selectProps.isMulti ? 0 : $4ae7cbc7591eb216$export$59c188914e58c94b,
                /* Margin left right of 2px set by default */ // margin: `0 ${BORDER_PADDING}px`,
                margin: 0,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            };
        },
        option: (css)=>{
            if (isVisualRefresh) return {
                ...css,
                overflow: 'hidden',
                paddingLeft: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)",
                paddingRight: isPopupStyles ? "var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px)"
            };
            return {
                ...css,
                overflow: 'hidden'
            };
        },
        input: (css, state)=>({
                ...css,
                gridArea: '1/2/2/3',
                gridTemplateColumns: isMulti && state.placeholder ? '0 123px' : css.gridTemplateColumns,
                /* Necessary to make input height and tag height the same. */ margin: isMulti && (0, $ixfCV.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? 0 : `${"var(--ds-space-050, 4px)"} 0`,
                /* Padding top and bottom of 2 is set by default. */ paddingTop: 0,
                paddingBottom: 0,
                ...isMulti && (0, $ixfCV.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && {
                    height: "var(--ds-space-250, 20px)",
                    alignItems: 'center'
                },
                paddingLeft: state.selectProps.isMulti ? 0 : $4ae7cbc7591eb216$export$59c188914e58c94b,
                '& input::placeholder': {
                    /* Chrome, Firefox, Opera, Safari 10.1+ */ color: "var(--ds-text-subtlest, #6B6E76)",
                    opacity: 1 /* Firefox */ 
                },
                '& input:-ms-input-placeholder': {
                    /* Internet Explorer 10-11 */ color: "var(--ds-text-subtlest, #6B6E76)"
                }
            }),
        singleValue: (css)=>({
                ...css,
                margin: 0,
                gridArea: '1/2/2/3'
            })
    };
    return overrideStyles ? (0, $1TlML.mergeStyles)(styles, overrideStyles) : styles;
});
const $4ae7cbc7591eb216$export$4e983f376ad8a3af = (0, $dOBRD.default)((width, isMulti, overrideStyles, isVisualRefresh)=>({
        ...$4ae7cbc7591eb216$export$ffd58b7f6f099a57(width, isMulti, false, overrideStyles, isVisualRefresh, true)
    }));
module.exports["getStyles"] = $4ae7cbc7591eb216$export$ffd58b7f6f099a57;

});

parcelRegister("1TlML", function(module, exports) {
function $cc70dd2ba0f00d0d$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
module.exports["mergeStyles"] = $cc70dd2ba0f00d0d$export$e618dc39ac9ad607;

});

parcelRegister("al9c2", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $73k2m = parcelRequire("73k2m");


var $1UZNj = parcelRequire("1UZNj");


var $88TF2 = parcelRequire("88TF2");


var $cs8ca = parcelRequire("cs8ca");


var $c48SA = parcelRequire("c48SA");


var $cnIP4 = parcelRequire("cnIP4");


var $bPMiS = parcelRequire("bPMiS");


var $97jiw = parcelRequire("97jiw");


var $8otJJ = parcelRequire("8otJJ");


var $bV3S4 = parcelRequire("bV3S4");


var $dnFcR = parcelRequire("dnFcR");

const $c4825579da0c037a$export$4e811121b221213b = (0, $dOBRD.default)((multi, anchor, showClearIndicator, customComponents)=>{
    if (anchor) return {
        Control: anchor,
        Option: $cs8ca.Option
    };
    else return {
        MultiValue: $1UZNj.MultiValue,
        DropdownIndicator: null,
        SingleValue: $c48SA.SingleValue,
        ClearIndicator: showClearIndicator || !multi ? (0, $73k2m.ClearIndicator) : null,
        Option: $cs8ca.Option,
        ValueContainer: multi ? (0, $88TF2.MultiValueContainer) : (0, $bPMiS.SingleValueContainer),
        Input: $cnIP4.Input,
        Menu: $bV3S4.Menu,
        Control: $dnFcR.default,
        ...customComponents ? customComponents : {}
    };
});
const $c4825579da0c037a$export$19205fd341a6bb08 = (0, $dOBRD.default)((hasPopupTitle)=>{
    const baseProps = {
        DropdownIndicator: null,
        SingleValue: $c48SA.SingleValue,
        ClearIndicator: $73k2m.ClearIndicator,
        Option: $cs8ca.Option,
        ValueContainer: (0, $bPMiS.SingleValueContainer),
        Input: (0, $97jiw.PopupInput)
    };
    if (hasPopupTitle) return {
        ...baseProps,
        Control: (0, $8otJJ.PopupControl)
    };
    return baseProps;
});
module.exports["getComponents"] = $c4825579da0c037a$export$4e811121b221213b;

});

parcelRegister("73k2m", function(module, exports) {
/* ClearIndicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $l9ukq = parcelRequire("l9ukq");

function $f2345ab9bbe409ae$var$_defineProperty(e, r, t) {
    return (r = $f2345ab9bbe409ae$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f2345ab9bbe409ae$var$_toPropertyKey(t) {
    var i = $f2345ab9bbe409ae$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f2345ab9bbe409ae$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

const $f2345ab9bbe409ae$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("8GbgH")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $f2345ab9bbe409ae$var$clearIndicatorStyles = {
    root: "_v5641ppt _tzy4kb7n _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _30l3s4qr _1mhjgrf3"
};
class $f2345ab9bbe409ae$export$ecf9cf59142dd54a extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        const { //@ts-ignore react-select unsupported props
        selectProps: { clearValueLabel: clearValueLabel } } = this.props;
        const Indicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).ClearIndicator, {
            ...this.props,
            innerProps: {
                ...this.props.innerProps,
                onMouseDown: this.handleMouseDown
            },
            xcss: $f2345ab9bbe409ae$var$clearIndicatorStyles.root
        });
        return clearValueLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
            fallback: Indicator
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f2345ab9bbe409ae$var$AsyncTooltip, {
            content: clearValueLabel
        }, Indicator)) : Indicator;
    }
    constructor(...args){
        super(...args);
        $f2345ab9bbe409ae$var$_defineProperty(this, "handleMouseDown", (event)=>{
            if (event && event.type === 'mousedown' && event.button !== 0) return;
             // Prevent focus when clear on blurred state
            const { clearValue: clearValue, selectProps: selectProps } = this.props;
            clearValue(); //@ts-ignore react-select unsupported props
            if (selectProps && !selectProps.isFocused) event.stopPropagation();
        });
    }
}
module.exports["ClearIndicator"] = $f2345ab9bbe409ae$export$ecf9cf59142dd54a;

});

parcelRegister("8GbgH", function(module, exports) {

let $651afca19fe3ed7a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $651afca19fe3ed7a$var$load("9XXCk").then(()=>parcelRequire('2TLXz'));

});

parcelRegister("1UZNj", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");

var $kz1Yj = parcelRequire("kz1Yj");

var $buxP3 = parcelRequire("buxP3");


var $l9ukq = parcelRequire("l9ukq");


var $lOiVq = parcelRequire("lOiVq");


var $arQY7 = parcelRequire("arQY7");


var $ixfCV = parcelRequire("ixfCV");


var $3Una5 = parcelRequire("3Una5");

var $IOtUu = parcelRequire("IOtUu");


var $2c3Eq = parcelRequire("2c3Eq");


var $kBIAo = parcelRequire("kBIAo");


var $lvlsM = parcelRequire("lvlsM");


var $cGbTM = parcelRequire("cGbTM");


var $f1uNX = parcelRequire("f1uNX");


var $9KSWX = parcelRequire("9KSWX");


var $fBqzD = parcelRequire("fBqzD");


var $aRrFB = parcelRequire("aRrFB");


var $kSwu1 = parcelRequire("kSwu1");


var $7xLai = parcelRequire("7xLai");

function $bffbf0089c3afad8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bffbf0089c3afad8$export$118122ebc1e626fa = (valueContainer, control)=>{
    const { top: top, height: height } = valueContainer.getBoundingClientRect();
    const { height: controlHeight } = control.getBoundingClientRect();
    if (top - height < 0) valueContainer.scrollIntoView();
    if (top + height > controlHeight) valueContainer.scrollIntoView(false);
};
const $bffbf0089c3afad8$var$groupTagContainerOld = (0, $buxP3.xcss)({
    paddingLeft: 'space.025',
    marginTop: 'space.025'
});
const $bffbf0089c3afad8$var$groupTagContainer = (0, $buxP3.xcss)({
    paddingLeft: 'space.050'
});
const $bffbf0089c3afad8$var$archivedLozengeWrapper = (0, $buxP3.xcss)({
    display: 'flex',
    paddingLeft: 'space.050'
});
const $bffbf0089c3afad8$var$iconStyle = {
    name: "1sq8lny",
    styles: "display:flex;align-items:center;justify-content:center;flex-shrink:0;width:20px;height:20px"
};
const $bffbf0089c3afad8$var$nameWrapper = {
    name: "1b3uxdh",
    styles: "font:var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px)"
};
const $bffbf0089c3afad8$var$avatarTagWrapperStyle = {
    name: "14413o7",
    styles: "display:flex;font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
class $bffbf0089c3afad8$export$419cdf50db8b579 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidUpdate() {
        const { isFocused: isFocused } = this.props;
        if (isFocused && this.containerRef.current && this.containerRef.current.parentElement && this.containerRef.current.parentElement.parentElement) $bffbf0089c3afad8$export$118122ebc1e626fa(this.containerRef.current, this.containerRef.current.parentElement.parentElement);
    }
    shouldComponentUpdate(nextProps) {
        const { data: option, innerProps: innerProps, isFocused: isFocused } = this.props;
        const { data: nextOption, innerProps: nextInnerProps, isFocused: nextIsFocused } = nextProps;
        if (option == null || nextOption == null) return option !== nextOption || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
        const { label: label, data: data } = option;
        const { label: nextLabel, data: nextData } = nextOption;
        // We can ignore onRemove here because it is an anonymous function
        // that will be recreated every time but with the same implementation.
        return data !== nextData || label !== nextLabel || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
    }
    render() {
        const { children: children, innerProps: _innerProps, removeProps: removeProps, data: option, ...rest } = this.props;
        if ((0, $ixfCV.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
            const { data: data, label: label } = option;
            const isTeamOption = (0, $f1uNX.isTeam)(data);
            const isGroupOption = (0, $f1uNX.isGroup)(data);
            const isEmailOption = (0, $f1uNX.isEmail)(data);
            const avatarUrl = (0, $f1uNX.getAvatarUrl)(data);
            const isDisabled = Boolean(this.props.selectProps?.isDisabled);
            const canShowArchivedLozenge = (0, $f1uNX.isTeam)(data) && data?.state === 'DISBANDED' && (0, $ixfCV.fg)('enable-sup-archive-experience');
            const avatarProps = avatarUrl ? {
                name: data.name,
                src: avatarUrl
            } : {
                name: data.name
            };
            const onAfterRemoveAction = ()=>{
                removeProps.onClick({});
            };
            if (isEmailOption) return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                ref: this.containerRef,
                css: $bffbf0089c3afad8$var$avatarTagWrapperStyle,
                "data-user-picker-multi-value": true
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $IOtUu.default), {
                text: label,
                elemBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kBIAo.AddOptionAvatar), {
                    isLozenge: true,
                    isPendingAction: data.isPendingAction
                }),
                isRemovable: !isDisabled,
                onAfterRemoveAction: onAfterRemoveAction,
                hasMargin: false
            }));
            if (isGroupOption) return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                ref: this.containerRef,
                css: $bffbf0089c3afad8$var$avatarTagWrapperStyle,
                "data-user-picker-multi-value": true
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $IOtUu.default), {
                text: label,
                elemBefore: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.default), {
                    xcss: $bffbf0089c3afad8$var$groupTagContainer
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fBqzD))), {
                    color: "currentColor",
                    label: "",
                    size: "small"
                })),
                isRemovable: !isDisabled,
                onAfterRemoveAction: onAfterRemoveAction,
                hasMargin: false
            }));
            if (data.icon) return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                ref: this.containerRef,
                css: $bffbf0089c3afad8$var$avatarTagWrapperStyle,
                "data-user-picker-multi-value": true
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $IOtUu.default), {
                text: label,
                elemBefore: /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                    css: $bffbf0089c3afad8$var$iconStyle,
                    style: {
                        color: data.iconColor
                    }
                }, data.icon),
                isRemovable: !isDisabled,
                hasMargin: false,
                onAfterRemoveAction: onAfterRemoveAction
            }));
            return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                ref: this.containerRef,
                css: $bffbf0089c3afad8$var$avatarTagWrapperStyle,
                "data-user-picker-multi-value": true
            }, isTeamOption ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3Una5.default), {
                type: "other",
                text: label,
                isVerified: isTeamOption ? data.verified : undefined,
                isRemovable: !isDisabled,
                onAfterRemoveAction: onAfterRemoveAction,
                avatar: (props)=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, $2c3Eq.default), {
                        ...props,
                        ...avatarProps
                    }),
                hasMargin: false
            }), canShowArchivedLozenge ? /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.default), {
                xcss: $bffbf0089c3afad8$var$archivedLozengeWrapper
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9KSWX.default), {
                appearance: "default"
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).archivedLozenge))) : null) : /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3Una5.default), {
                type: "user",
                text: label,
                isRemovable: !isDisabled,
                onAfterRemoveAction: onAfterRemoveAction,
                avatar: (props)=>/*#__PURE__*/ (0, $lOiVq.jsx)((0, $arQY7.default), {
                        ...props,
                        ...avatarProps
                    }),
                hasMargin: false
            }));
        }
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $l9ukq.components).MultiValue, {
            ...rest,
            data: option,
            removeProps: removeProps,
            innerProps: {
                ref: this.containerRef
            },
            cropWithEllipsis: false
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kz1Yj.default), {
            alignBlock: "center"
        }, this.getElemBefore(), " ", /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: $bffbf0089c3afad8$var$nameWrapper
        }, children), this.getElemAfter()));
    }
    constructor(props){
        super(props);
        this.containerRef = void 0;
        this.getElemBefore = ()=>{
            const { data: { data: data } } = this.props;
            if ((0, $f1uNX.isEmail)(data)) // This element is a decorative icon and does not require a label
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kBIAo.AddOptionAvatar), {
                isLozenge: true,
                isPendingAction: data.isPendingAction
            });
            if ((0, $f1uNX.isGroup)(data)) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.default), {
                xcss: $bffbf0089c3afad8$var$groupTagContainerOld
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fBqzD))), {
                color: "currentColor",
                label: ""
            }));
            if (data.icon) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lvlsM.AvatarOrIcon), {
                appearance: "multi",
                icon: data.icon,
                iconColor: data.iconColor,
                src: (0, $f1uNX.getAvatarUrl)(data),
                type: (0, $f1uNX.isTeam)(data) ? 'team' : 'person'
            });
            // Fallback to original behavior
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cGbTM.SizeableAvatar), {
                appearance: "multi",
                src: (0, $f1uNX.getAvatarUrl)(data),
                type: (0, $f1uNX.isTeam)(data) ? 'team' : 'person'
            });
        };
        this.getElemAfter = ()=>{
            const { data: { data: data } } = this.props;
            const canShowArchivedLozenge = (0, $f1uNX.isTeam)(data) && data?.state === 'DISBANDED' && (0, $ixfCV.fg)('enable-sup-archive-experience');
            if ((0, $f1uNX.isGroup)(data) && data.includeTeamsUpdates || (0, $f1uNX.isTeam)(data) && data.verified) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $aRrFB.VerifiedTeamIcon), {
                size: data.includeTeamsUpdates ? 'small' : 'medium'
            });
            if (canShowArchivedLozenge) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.default), {
                xcss: $bffbf0089c3afad8$var$archivedLozengeWrapper
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9KSWX.default), {
                appearance: "default"
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).archivedLozenge)));
            return null;
        };
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef();
    }
}
module.exports["MultiValue"] = $bffbf0089c3afad8$export$419cdf50db8b579;

});

parcelRegister("kBIAo", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $ldb9Z = parcelRequire("ldb9Z");


var $lOiVq = parcelRequire("lOiVq");

parcelRequire("cozmU");


var $ixfCV = parcelRequire("ixfCV");

const $d4e90a9cb054ea8d$var$getEmailAvatarWrapperStyle = (isLozenge, isPendingAction)=>{
    const padding = isLozenge ? `${"var(--ds-space-0, 0px)"}` : `${"var(--ds-space-050, 4px)"}`;
    const backgroundColor = isPendingAction && (0, $ixfCV.fg)('twcg-444-invite-usd-improvements-m2-gate') ? "var(--ds-background-warning, #FFF5DB)" : "var(--ds-background-neutral, #0515240F)";
    return /*#__PURE__*/ (0, $lOiVq.css)({
        padding: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding,
        backgroundColor: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor,
        borderRadius: "var(--ds-radius-full, 9999px)",
        display: 'flex',
        alignItems: 'center',
        marginLeft: "var(--ds-space-025, 2px)"
    });
};
const $d4e90a9cb054ea8d$export$df396db45e491922 = ({ isLozenge: isLozenge, label: label, isPendingAction: isPendingAction })=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $d4e90a9cb054ea8d$var$getEmailAvatarWrapperStyle(isLozenge, isPendingAction)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ldb9Z))), {
        testId: "add-option-avatar-email-icon",
        label: label || '',
        color: isPendingAction && (0, $ixfCV.fg)('twcg-444-invite-usd-improvements-m2-gate') ? "var(--ds-text-warning, #9E4C00)" : "var(--ds-text-subtle, #505258)"
    })));
};
module.exports["AddOptionAvatar"] = $d4e90a9cb054ea8d$export$df396db45e491922;

});

parcelRegister("lvlsM", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cGbTM = parcelRequire("cGbTM");


var $f1uNX = parcelRequire("f1uNX");


var $lOiVq = parcelRequire("lOiVq");

function $25f984a67853b2bf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $25f984a67853b2bf$var$iconStyle = {
    name: "sjfyf",
    styles: "display:flex;align-items:center;justify-content:center;flex-shrink:0"
};
const $25f984a67853b2bf$var$iconSizes = {
    xsmall: {
        name: "1aynuae",
        styles: "width:20px;height:20px"
    },
    small: {
        name: "1c76jn8",
        styles: "width:28px;height:28px"
    },
    medium: {
        name: "bgbjt4",
        styles: "width:36px;height:36px"
    }
};
const $25f984a67853b2bf$export$60751fd23180a0ed = ({ appearance: appearance = 'big', avatarAppearanceShape: avatarAppearanceShape, icon: icon, iconColor: iconColor, presence: presence, src: src, type: type = 'person' })=>{
    // If icon is provided, render it instead of avatar
    if (icon) {
        const avatarSize = (0, $f1uNX.getAvatarSize)(appearance);
        return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: [
                $25f984a67853b2bf$var$iconStyle,
                $25f984a67853b2bf$var$iconSizes[avatarSize]
            ],
            style: {
                color: iconColor
            }
        }, icon);
    }
    // Otherwise, render the avatar as before
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cGbTM.SizeableAvatar), {
        appearance: appearance,
        src: src,
        presence: presence,
        type: type,
        avatarAppearanceShape: avatarAppearanceShape
    });
};
module.exports["AvatarOrIcon"] = $25f984a67853b2bf$export$60751fd23180a0ed;

});

parcelRegister("cGbTM", function(module, exports) {

var $arQY7 = parcelRequire("arQY7");


var $2c3Eq = parcelRequire("2c3Eq");


var $cozmU = parcelRequire("cozmU");


var $f1uNX = parcelRequire("f1uNX");

class $e2222437848781c0$export$44d81a88129649da extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        const { src: src, presence: presence, appearance: appearance, type: type = 'person', avatarAppearanceShape: avatarAppearanceShape } = this.props;
        const props = {
            size: (0, $f1uNX.getAvatarSize)(appearance),
            src: src,
            borderColor: 'transparent',
            presence: presence,
            ...avatarAppearanceShape && {
                appearance: avatarAppearanceShape
            }
        };
        return type === 'team' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2c3Eq.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), props);
    }
}
module.exports["SizeableAvatar"] = $e2222437848781c0$export$44d81a88129649da;

});

parcelRegister("aRrFB", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $d2UzA = parcelRequire("d2UzA");


var $lpNn5 = parcelRequire("lpNn5");


var $2rxeJ = parcelRequire("2rxeJ");

const $c118d249a8b39a96$export$d7949f68d31e5edd = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { label: t1, showTooltip: showTooltip, customTooltipContent: customTooltipContent, size: t2, spacing: t3 } = t0;
    const label = t1 === undefined ? "Verified Team" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const spacing = t3 === undefined ? "spacious" : t3;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t4;
    if ($[0] !== customTooltipContent || $[1] !== formatMessage || $[2] !== showTooltip) {
        t4 = showTooltip ? customTooltipContent || formatMessage((0, $2rxeJ.messages).verifiedIconDefaultTooltip) : undefined;
        $[0] = customTooltipContent;
        $[1] = formatMessage;
        $[2] = showTooltip;
        $[3] = t4;
    } else t4 = $[3];
    const tooltipContent = t4;
    let t5;
    if ($[4] !== label || $[5] !== size || $[6] !== spacing || $[7] !== tooltipContent) {
        t5 = tooltipContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: tooltipContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            tabIndex: 0,
            role: "button",
            "data-testid": "verified-team-icon"
        }, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
            color: "var(--ds-icon-accent-blue, #357DE8)",
            size: size,
            label: tooltipContent,
            spacing: spacing
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
            color: "var(--ds-icon-accent-blue, #357DE8)",
            size: size,
            spacing: spacing,
            label: label
        });
        $[4] = label;
        $[5] = size;
        $[6] = spacing;
        $[7] = tooltipContent;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ label: label = 'Verified Team', showTooltip: showTooltip, customTooltipContent: customTooltipContent, size: size = 'medium', spacing: spacing = 'spacious' })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const tooltipContent = showTooltip ? customTooltipContent || formatMessage((0, $2rxeJ.messages).verifiedIconDefaultTooltip) : undefined;
    return tooltipContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        tabIndex: 0,
        role: "button",
        "data-testid": "verified-team-icon"
    }, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
        color: "var(--ds-icon-accent-blue, #357DE8)",
        size: size,
        label: tooltipContent,
        spacing: spacing
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
        color: "var(--ds-icon-accent-blue, #357DE8)",
        size: size,
        spacing: spacing,
        label: label
    });
};
module.exports["VerifiedTeamIcon"] = $c118d249a8b39a96$export$d7949f68d31e5edd;

});

parcelRegister("2rxeJ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a8f8527678b71e0e$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    verifiedIconDefaultTooltip: {
        id: "ptc-directory.team-profile-page.team-name.verified-team.icon.tooltip",
        defaultMessage: "This team is verified because it can only be changed by admin."
    }
});
module.exports["messages"] = $a8f8527678b71e0e$export$defe85febe8b728c;

});

parcelRegister("88TF2", function(module, exports) {
/* MultiValueContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l9ukq = parcelRequire("l9ukq");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ixfCV = parcelRequire("ixfCV");


var $7xLai = parcelRequire("7xLai");


var $f1uNX = parcelRequire("f1uNX");


var $9gNGh = parcelRequire("9gNGh");


var $k12R1 = parcelRequire("k12R1");

function $f3ca9dc7e39dcc1b$var$_defineProperty(e, r, t) {
    return (r = $f3ca9dc7e39dcc1b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f3ca9dc7e39dcc1b$var$_toPropertyKey(t) {
    var i = $f3ca9dc7e39dcc1b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $f3ca9dc7e39dcc1b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $f3ca9dc7e39dcc1b$var$valueContainerStyles = {
    root: "_yv0e5bpd _1reo15vq _18m91wug _1fjgglyw _c71l1osq _1suq1j28 _1ke8idpf",
    paddingLegacy: "_ca0qu2gc _n3tdu2gc _19bvu2gc",
    tagUpliftVerticalDefault: "_ca0qu2gc _n3tdu2gc",
    tagUpliftVerticalCompact: "_ca0qv77o _n3tdv77o",
    paddingLeftTight: "_19bv12x7",
    paddingLeftWide: "_19bvu2gc",
    withFlexAndGap: "_zulp1b66 _yv0en7od _1n261g80"
};
class $f3ca9dc7e39dcc1b$export$cf9cf2a30a59265c extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            valueSize: nextProps.getValue ? nextProps.getValue().length : 0,
            previousValueSize: prevState.valueSize
        };
    }
    componentDidUpdate() {
        const { previousValueSize: previousValueSize, valueSize: valueSize } = this.state;
        //@ts-ignore react-select unsupported props
        const { isFocused: isFocused } = this.props.selectProps;
        if (valueSize > previousValueSize && isFocused) {
            if (this.timeoutId) {
                window.clearTimeout(this.timeoutId);
                this.timeoutId = null;
            }
            this.scrollToBottom();
        }
    }
    componentWillUnmount() {
        if (this.timeoutId) window.clearTimeout(this.timeoutId);
    }
    render() {
        const { children: _children, innerProps: _innerProps, hasValue: hasValue, isCompact: isCompact, ...valueContainerProps } = this.props;
        const props = {
            ...valueContainerProps,
            hasValue: hasValue,
            isCompact: isCompact,
            innerProps: this.valueContainerInnerProps
        };
        const ffTagUplifts = (0, $ixfCV.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
        const controlRendersValueInControl = this.props.selectProps.controlShouldRenderValue !== false;
        const tagUpliftChipRow = ffTagUplifts && hasValue && controlRendersValueInControl;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9gNGh.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).ValueContainer, {
            ...props,
            xcss: (0, $k12R1.cx)($f3ca9dc7e39dcc1b$var$valueContainerStyles.root, !ffTagUplifts && $f3ca9dc7e39dcc1b$var$valueContainerStyles.paddingLegacy, ffTagUplifts && (isCompact ? $f3ca9dc7e39dcc1b$var$valueContainerStyles.tagUpliftVerticalCompact : $f3ca9dc7e39dcc1b$var$valueContainerStyles.tagUpliftVerticalDefault), ffTagUplifts && (tagUpliftChipRow ? $f3ca9dc7e39dcc1b$var$valueContainerStyles.paddingLeftWide : $f3ca9dc7e39dcc1b$var$valueContainerStyles.paddingLeftTight), tagUpliftChipRow && $f3ca9dc7e39dcc1b$var$valueContainerStyles.withFlexAndGap)
        }, this.renderChildren()));
    }
    constructor(props){
        super(props);
        $f3ca9dc7e39dcc1b$var$_defineProperty(this, "valueContainerInnerProps", void 0);
        $f3ca9dc7e39dcc1b$var$_defineProperty(this, "timeoutId", null);
        $f3ca9dc7e39dcc1b$var$_defineProperty(this, "scrollToBottom", ()=>{
            this.timeoutId = window.setTimeout(()=>{
                const { ref: { current: current } } = this.valueContainerInnerProps;
                if (current !== null) current.scrollTop = current.scrollHeight;
                this.timeoutId = null;
            });
        });
        $f3ca9dc7e39dcc1b$var$_defineProperty(this, "showPlaceholder", ()=>{
            const { selectProps: { value: value } } = this.props;
            return value && value.length > 0;
        });
        $f3ca9dc7e39dcc1b$var$_defineProperty(this, "addPlaceholder", (placeholder)=>{
            const children = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(this.props.children, (child)=>(0, $f1uNX.isChildInput)(child) && this.showPlaceholder() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(child, {
                    placeholder: placeholder
                }) : child);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
        });
        $f3ca9dc7e39dcc1b$var$_defineProperty(this, "renderChildren", ()=>{
            const { //@ts-ignore react-select unsupported props
            selectProps: { addMoreMessage: addMoreMessage, isDisabled: isDisabled } } = this.props; // Do not render "Add more..." message if picker is disabled
            if (isDisabled) return this.props.children;
            if (addMoreMessage === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).addMore, (addMore)=>{
                let addMoreMessages = addMore;
                if (addMore && typeof addMore === 'string') addMoreMessages = [
                    addMore
                ];
                const placeholder = addMoreMessages?.join('') ?? '';
                return this.addPlaceholder(placeholder);
            });
            return this.addPlaceholder(addMoreMessage);
        }); //@ts-ignore react-select unsupported props
        $f3ca9dc7e39dcc1b$var$_defineProperty(this, "onValueContainerClick", this.props.selectProps.onValueContainerClick);
        this.state = {
            valueSize: 0,
            previousValueSize: 0
        };
        this.valueContainerInnerProps = {
            ref: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef()
        };
    }
}
module.exports["MultiValueContainer"] = $f3ca9dc7e39dcc1b$export$cf9cf2a30a59265c;

});

parcelRegister("9gNGh", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");

function $93cc2b2f9d20e1e3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Conditional wrapper for the ValueContainer in Select. Provides a workaround
 * for issues using react-select on react-beautiful-dnd Draggable elements.
 * @returns
 */ var $93cc2b2f9d20e1e3$var$_ref = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
const $93cc2b2f9d20e1e3$var$ValueContainerWrapper = ({ children: children, isEnabled: isEnabled, onMouseDown: onMouseDown })=>{
    return isEnabled ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlassian/a11y/no-static-element-interactions -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $93cc2b2f9d20e1e3$var$_ref,
        onMouseDown: onMouseDown
    }, children) : children;
};
var $93cc2b2f9d20e1e3$export$2e2bcd8739ae039 = $93cc2b2f9d20e1e3$var$ValueContainerWrapper;
module.exports["default"] = $93cc2b2f9d20e1e3$export$2e2bcd8739ae039;

});

parcelRegister("cs8ca", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $iMnC5 = parcelRequire("iMnC5");


var $l9ukq = parcelRequire("l9ukq");


var $lpNn5 = parcelRequire("lpNn5");


var $cozmU = parcelRequire("cozmU");


var $2c63x = parcelRequire("2c63x");


var $bYoB2 = parcelRequire("bYoB2");


var $k0mXu = parcelRequire("k0mXu");


var $hohk8 = parcelRequire("hohk8");


var $cTtI6 = parcelRequire("cTtI6");


var $2RstY = parcelRequire("2RstY");


var $f1uNX = parcelRequire("f1uNX");


var $bsEy7 = parcelRequire("bsEy7");

const $e10fd610d1140d68$var$defaultOption = ({ data: { data: data }, isSelected: isSelected, status: status })=>// @ts-expect-error - <UserOption> expects `data` to be of User interface, but data is OptionData interface by default. Check if the `user` props in UserOption should also accept OptionData or refactor this file to accept generics
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2c63x.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
const $e10fd610d1140d68$var$dataOption = ({ data: { data: data }, isSelected: isSelected, status: status, selectProps: selectProps })=>{
    if ((0, $f1uNX.isExternalUser)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bYoB2.default), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $f1uNX.isUser)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2c63x.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $f1uNX.isEmail)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cTtI6.default), {
        email: data,
        emailValidity: (0, $bsEy7.isValidEmail)(data.id),
        isSelected: isSelected,
        label: selectProps.emailLabel
    });
    if ((0, $f1uNX.isTeam)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k0mXu.default), {
        team: data,
        isSelected: isSelected,
        includeTeamsUpdates: data.includeTeamsUpdates
    });
    if ((0, $f1uNX.isGroup)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hohk8.default), {
        group: data,
        isSelected: isSelected,
        includeTeamsUpdates: data.includeTeamsUpdates
    });
    if ((0, $f1uNX.isCustom)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2RstY.default), {
        data: data,
        isSelected: isSelected
    });
    return null;
};
const $e10fd610d1140d68$var$dataOptionWithTooltip = (props)=>{
    if (props.data?.data?.tooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: props.data?.data?.tooltip
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), tooltipProps, $e10fd610d1140d68$var$dataOption(props)));
    return $e10fd610d1140d68$var$dataOption(props);
};
const $e10fd610d1140d68$export$36d18380658d5d20 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(10);
    const t0 = props;
    let t1;
    if ($[0] !== props) {
        t1 = $e10fd610d1140d68$var$defaultOption(props);
        $[0] = props;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== props) {
        t2 = $e10fd610d1140d68$var$dataOptionWithTooltip(props);
        $[2] = props;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
            fallback: t1
        }, t2);
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t0 || $[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Option, t0, t3);
        $[7] = t0;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
        fallback: $e10fd610d1140d68$var$defaultOption(props)
    }, $e10fd610d1140d68$var$dataOptionWithTooltip(props)));
module.exports["Option"] = $e10fd610d1140d68$export$36d18380658d5d20;

});

parcelRegister("2c63x", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $dWZMi = parcelRequire("dWZMi");


var $lOiVq = parcelRequire("lOiVq");


var $cozmU = parcelRequire("cozmU");


var $pr26r = parcelRequire("pr26r");


var $apA01 = parcelRequire("apA01");


var $lvlsM = parcelRequire("lvlsM");


var $cGbTM = parcelRequire("cGbTM");


var $f1uNX = parcelRequire("f1uNX");


var $ixfCV = parcelRequire("ixfCV");

class $afa55f5fa163021c$export$8e59f78010871662 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $pr26r.AvatarItemOption), {
            avatar: this.renderAvatar(),
            lozenge: this.getLozengeProps(),
            isDisabled: this.props.user.isDisabled,
            primaryText: this.getPrimaryText(),
            secondaryText: this.renderSecondaryText()
        });
    }
    constructor(...args){
        super(...args);
        this.getPrimaryText = ()=>{
            const { user: { name: name, publicName: publicName, highlight: highlight } } = this.props;
            const result = [
                /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                    key: "name",
                    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    css: (0, $pr26r.textWrapper)(this.props.isSelected ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text, #292A2E)")
                }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $apA01.HighlightText), {
                    highlights: highlight && highlight.name
                }, name))
            ];
            if ((0, $f1uNX.hasValue)(publicName) && name.trim() !== publicName.trim()) {
                const color = this.props.isSelected ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text-subtlest, #6B6E76)";
                result.push(/*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                    key: "publicName"
                }, ' ', /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    css: (0, $pr26r.textWrapper)(color)
                }, "(", /*#__PURE__*/ (0, $lOiVq.jsx)((0, $apA01.HighlightText), {
                    highlights: highlight && highlight.publicName
                }, publicName), ")")));
            }
            return result;
        };
        this.renderSecondaryText = ()=>this.props.user.byline ? /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $pr26r.textWrapper)(this.props.isSelected ? "var(--ds-text-selected, #1868DB)" : "var(--ds-text-subtlest, #6B6E76)")
            }, this.props.user.byline) : undefined;
        this.renderAvatar = ()=>{
            const { user: { avatarUrl: avatarUrl, appType: appType, icon: icon, iconColor: iconColor }, status: status } = this.props;
            const appearance = (0, $ixfCV.fg)('platform-component-visual-refresh') ? 'medium' : 'big';
            if (icon) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lvlsM.AvatarOrIcon), {
                appearance: appearance,
                icon: icon,
                iconColor: iconColor,
                src: avatarUrl,
                presence: status,
                avatarAppearanceShape: (0, $dWZMi.default)(appType)
            });
            // Fallback to original behavior
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $cGbTM.SizeableAvatar), {
                appearance: appearance,
                src: avatarUrl,
                presence: status,
                avatarAppearanceShape: (0, $dWZMi.default)(appType)
            });
        };
        this.getLozengeProps = ()=>typeof this.props.user.lozenge === 'string' ? {
                text: this.props.user.lozenge
            } : this.props.user.lozenge;
    }
}
module.exports["UserOption"] = $afa55f5fa163021c$export$8e59f78010871662;

});

parcelRegister("pr26r", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $9KSWX = parcelRequire("9KSWX");


var $IOtUu = parcelRequire("IOtUu");


var $f1uNX = parcelRequire("f1uNX");


var $ixfCV = parcelRequire("ixfCV");

function $09486341bedb25c7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

const $09486341bedb25c7$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("8GbgH")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $09486341bedb25c7$var$wrapper = (isDisabled)=>/*#__PURE__*/ (0, $lOiVq.css)({
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 1,
        outline: 'none',
        margin: 0,
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: isDisabled ? "var(--ds-opacity-disabled, 0.4)" : undefined
    });
const $09486341bedb25c7$var$optionWrapper = {
    name: "13552d7",
    styles: "max-width:100%;min-width:0;line-height:1.4;padding-left:var(--ds-space-100, 8px)"
};
const $09486341bedb25c7$var$getTextStyle = (isSecondary)=>{
    const secondaryCssArgs = isSecondary ? {
        font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
    } : {};
    return /*#__PURE__*/ (0, $lOiVq.css)({
        margin: 0,
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...secondaryCssArgs
    });
};
const $09486341bedb25c7$var$additionalInfo = {
    name: "1hvgowa",
    styles: "float:right;margin-left:var(--ds-space-100, 8px)"
};
const $09486341bedb25c7$export$aa6223da92b253dd = (color)=>/*#__PURE__*/ (0, $lOiVq.css)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'inline',
        color: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color
    });
const $09486341bedb25c7$var$lozengeAppearanceToTagColor = {
    default: 'standard',
    success: 'lime',
    removed: 'red',
    inprogress: 'blue',
    new: 'purple',
    moved: 'orange'
};
const $09486341bedb25c7$export$164a9d9b3b86dd0c = ({ avatar: avatar, isDisabled: isDisabled, lozenge: lozenge, primaryText: primaryText, secondaryText: secondaryText })=>{
    const renderTag = ()=>{
        if ((0, $f1uNX.isLozengeText)(lozenge) && !lozenge.isBold) {
            const color = lozenge.appearance ? $09486341bedb25c7$var$lozengeAppearanceToTagColor[lozenge.appearance] : 'standard';
            const tag = /*#__PURE__*/ (0, $lOiVq.jsx)((0, $IOtUu.default), {
                text: lozenge.text,
                color: color,
                isRemovable: false,
                migration_fallback: "lozenge"
            });
            if (lozenge.tooltip) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
                fallback: tag
            }, /*#__PURE__*/ (0, $lOiVq.jsx)($09486341bedb25c7$var$AsyncTooltip, {
                content: lozenge.tooltip
            }, tag));
            return tag;
        }
        return renderLozenge();
    };
    const renderLozenge = ()=>{
        if ((0, $f1uNX.isLozengeText)(lozenge)) {
            if (lozenge?.tooltip) // Note that entire Lozenge must be wrapped in the Tooltip (rather than just the
            // Lozenge text) or tooltip won't work
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
                fallback: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9KSWX.default), lozenge, lozenge.text)
            }, /*#__PURE__*/ (0, $lOiVq.jsx)($09486341bedb25c7$var$AsyncTooltip, {
                content: lozenge.tooltip
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9KSWX.default), lozenge, lozenge.text)));
            return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $9KSWX.default), lozenge, lozenge.text);
        }
        return lozenge;
    };
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: $09486341bedb25c7$var$wrapper(isDisabled)
    }, avatar, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $09486341bedb25c7$var$optionWrapper
    }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", null, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $09486341bedb25c7$var$getTextStyle()
    }, primaryText), secondaryText && /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $09486341bedb25c7$var$getTextStyle(true)
    }, secondaryText))), lozenge && /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $09486341bedb25c7$var$additionalInfo
    }, (0, $ixfCV.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? renderTag() : renderLozenge())));
};
module.exports["textWrapper"] = $09486341bedb25c7$export$aa6223da92b253dd;
module.exports["AvatarItemOption"] = $09486341bedb25c7$export$164a9d9b3b86dd0c;

});

parcelRegister("apA01", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

class $f375a32a5b8051ad$export$bb02e7bc6e1a7119 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        const { children: children, highlights: highlights } = this.props;
        const parts = [];
        let lastIndex = 0;
        if (highlights) highlights.sort((a, b)=>a.start - b.start).reduce((highlights, highlight)=>{
            const lastHighlight = highlights[highlights.length - 1];
            if (!lastHighlight || highlight.start > lastHighlight.end + 1) return highlights.concat(highlight);
            if (highlight.end > lastHighlight.end) lastHighlight.end = highlight.end;
            return highlights;
        }, []).forEach((highlight)=>{
            const { start: start, end: end } = highlight;
            if (start >= end) return;
            if (start > lastIndex) parts.push({
                value: children.substring(lastIndex, start),
                matches: false
            });
            parts.push({
                value: children.substring(start, end + 1),
                matches: true
            });
            lastIndex = end + 1;
        });
        if (lastIndex < children.length) parts.push({
            value: children.substring(lastIndex, children.length),
            matches: false
        });
        return parts.map((part, index)=>{
            if (part.matches) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", {
                key: index
            }, part.value);
            return part.value;
        });
    }
}
module.exports["HighlightText"] = $f375a32a5b8051ad$export$bb02e7bc6e1a7119;

});

parcelRegister("bYoB2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $a3b2e53394cea8af$var$AsyncExternalUserOption = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("2SXsi")).then((module)=>{
        return {
            default: module.ExternalUserOption
        };
    }));
var $a3b2e53394cea8af$export$2e2bcd8739ae039 = $a3b2e53394cea8af$var$AsyncExternalUserOption;
module.exports["default"] = $a3b2e53394cea8af$export$2e2bcd8739ae039;

});

parcelRegister("2SXsi", function(module, exports) {

let $219ebe834f23dbfb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $219ebe834f23dbfb$var$load("jZMUd"),
    $219ebe834f23dbfb$var$load("l9aze")
]).then(()=>parcelRequire('hjSks'));

});

parcelRegister("k0mXu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $334e5641372502ac$var$AsyncTeamOption = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("Blpcv")).then((module)=>{
        return {
            default: module.TeamOption
        };
    }));
var $334e5641372502ac$export$2e2bcd8739ae039 = $334e5641372502ac$var$AsyncTeamOption;
module.exports["default"] = $334e5641372502ac$export$2e2bcd8739ae039;

});

parcelRegister("Blpcv", function(module, exports) {

let $07040f7ebd894018$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $07040f7ebd894018$var$load("dBsbZ").then(()=>parcelRequire('k0sQA'));

});

parcelRegister("hohk8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $85cffe183f5a17a9$var$AsyncGroupOption = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("0YD1J")).then((module)=>{
        return {
            default: module.GroupOption
        };
    }));
var $85cffe183f5a17a9$export$2e2bcd8739ae039 = $85cffe183f5a17a9$var$AsyncGroupOption;
module.exports["default"] = $85cffe183f5a17a9$export$2e2bcd8739ae039;

});

parcelRegister("0YD1J", function(module, exports) {

let $002f07c0999fbf19$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $002f07c0999fbf19$var$load("fFsaR").then(()=>parcelRequire('hrN4e'));

});

parcelRegister("cTtI6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $a5138e07c3616ec7$var$AsyncEmailOption = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("hJOc8")).then((module)=>{
        return {
            default: module.EmailOption
        };
    }));
var $a5138e07c3616ec7$export$2e2bcd8739ae039 = $a5138e07c3616ec7$var$AsyncEmailOption;
module.exports["default"] = $a5138e07c3616ec7$export$2e2bcd8739ae039;

});

parcelRegister("hJOc8", function(module, exports) {

let $ce9d9343e981ef24$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ce9d9343e981ef24$var$load("g8N2Z").then(()=>parcelRequire('3wXNe'));

});

parcelRegister("2RstY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $846221ee191ca6c1$var$AsyncCustomOption = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("5aSGg")).then((module)=>{
        return {
            default: module.CustomOption
        };
    }));
var $846221ee191ca6c1$export$2e2bcd8739ae039 = $846221ee191ca6c1$var$AsyncCustomOption;
module.exports["default"] = $846221ee191ca6c1$export$2e2bcd8739ae039;

});

parcelRegister("5aSGg", function(module, exports) {

let $3c484d605f8245e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3c484d605f8245e8$var$load("k9RdS").then(()=>parcelRequire('f8Kzz'));

});

parcelRegister("c48SA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $l9ukq = parcelRequire("l9ukq");


var $9KSWX = parcelRequire("9KSWX");


var $lvlsM = parcelRequire("lvlsM");


var $cGbTM = parcelRequire("cGbTM");


var $f1uNX = parcelRequire("f1uNX");


var $dWZMi = parcelRequire("dWZMi");


var $ixfCV = parcelRequire("ixfCV");


var $aRrFB = parcelRequire("aRrFB");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");


var $7xLai = parcelRequire("7xLai");

const $afcedb8febd5dd73$var$styles = {
    avatarItem: "_1reo15vq _18m915vq _4cvr1h6o _1ul953f4",
    avatarItemTextWrapper: "_16jlkb7n _1o9zkb7n _i0dl1osq _1ul9idpf _p12f1osq _bozgu2gc _vwz419ii",
    avatarItemText: "_syazi7uo _1reo15vq _1bto1l2s _o5721q9c",
    archivedLozengeWrapper: "_1e0c1txw _19bv1b66"
};
const $afcedb8febd5dd73$var$ElementAfter = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    const { data: t0, shouldShowVerifiedIcon: shouldShowVerifiedIcon } = props;
    const { data: data } = t0;
    const showIcon = shouldShowVerifiedIcon ? shouldShowVerifiedIcon(data) : (0, $f1uNX.isTeam)(data) && data.verified || (0, $f1uNX.isGroup)(data) && data.includeTeamsUpdates;
    if (showIcon) {
        const t1 = data.includeTeamsUpdates ? "small" : "medium";
        let t2;
        if ($[0] !== t1) {
            t2 = /*#__PURE__*/ $cozmU.createElement((0, $aRrFB.VerifiedTeamIcon), {
                size: t1
            });
            $[0] = t1;
            $[1] = t2;
        } else t2 = $[1];
        return t2;
    }
    return null;
} : (props)=>{
    const { data: { data: data }, shouldShowVerifiedIcon: shouldShowVerifiedIcon } = props;
    const showIcon = shouldShowVerifiedIcon ? shouldShowVerifiedIcon(data) : (0, $f1uNX.isTeam)(data) && data.verified || (0, $f1uNX.isGroup)(data) && data.includeTeamsUpdates;
    if (showIcon) return /*#__PURE__*/ $cozmU.createElement((0, $aRrFB.VerifiedTeamIcon), {
        size: data.includeTeamsUpdates ? 'small' : 'medium'
    });
    return null;
};
const $afcedb8febd5dd73$export$1949dac661ba6e3a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(9);
    const { data: t0, selectProps: t1 } = props;
    const { label: label, data: data } = t0;
    const { appearance: appearance, isFocused: isFocused } = t1;
    let t2;
    if ($[0] !== data) {
        t2 = (0, $f1uNX.isTeam)(data) && data?.state === "DISBANDED" && (0, $ixfCV.fg)("enable-sup-archive-experience");
        $[0] = data;
        $[1] = t2;
    } else t2 = $[1];
    const canShowArchivedLozenge = t2;
    let t3;
    if ($[2] !== appearance || $[3] !== canShowArchivedLozenge || $[4] !== data || $[5] !== isFocused || $[6] !== label || $[7] !== props) {
        t3 = !isFocused ? /*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).SingleValue, props, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.default), {
            xcss: $afcedb8febd5dd73$var$styles.avatarItem
        }, data.icon ? /*#__PURE__*/ $cozmU.createElement((0, $lvlsM.AvatarOrIcon), {
            icon: data.icon,
            iconColor: data.iconColor,
            src: (0, $f1uNX.getAvatarUrl)(data),
            appearance: appearance,
            type: (0, $f1uNX.isTeam)(data) ? "team" : "person",
            avatarAppearanceShape: (0, $dWZMi.default)(data.appType)
        }) : /*#__PURE__*/ $cozmU.createElement((0, $cGbTM.SizeableAvatar), {
            src: (0, $f1uNX.getAvatarUrl)(data),
            appearance: appearance,
            type: (0, $f1uNX.isTeam)(data) ? "team" : "person",
            avatarAppearanceShape: (0, $dWZMi.default)(data.appType)
        }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: $afcedb8febd5dd73$var$styles.avatarItem
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $afcedb8febd5dd73$var$styles.avatarItemTextWrapper
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: $afcedb8febd5dd73$var$styles.avatarItemText
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
            alignBlock: "center"
        }, label, /*#__PURE__*/ $cozmU.createElement($afcedb8febd5dd73$var$ElementAfter, props), canShowArchivedLozenge ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: $afcedb8febd5dd73$var$styles.archivedLozengeWrapper
        }, /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
            appearance: "default"
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).archivedLozenge))) : null)))))) : null;
        $[2] = appearance;
        $[3] = canShowArchivedLozenge;
        $[4] = data;
        $[5] = isFocused;
        $[6] = label;
        $[7] = props;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : (props)=>{
    const { data: { label: label, data: data }, //@ts-ignore react-select unsupported props
    selectProps: { appearance: appearance, isFocused: isFocused } } = props;
    const canShowArchivedLozenge = (0, $f1uNX.isTeam)(data) && data?.state === 'DISBANDED' && (0, $ixfCV.fg)('enable-sup-archive-experience');
    return !isFocused ? /*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).SingleValue, props, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.default), {
        xcss: $afcedb8febd5dd73$var$styles.avatarItem
    }, data.icon ? /*#__PURE__*/ $cozmU.createElement((0, $lvlsM.AvatarOrIcon), {
        icon: data.icon,
        iconColor: data.iconColor,
        src: (0, $f1uNX.getAvatarUrl)(data),
        appearance: appearance,
        type: (0, $f1uNX.isTeam)(data) ? 'team' : 'person',
        avatarAppearanceShape: (0, $dWZMi.default)(data.appType)
    }) : /*#__PURE__*/ $cozmU.createElement((0, $cGbTM.SizeableAvatar), {
        src: (0, $f1uNX.getAvatarUrl)(data),
        appearance: appearance,
        type: (0, $f1uNX.isTeam)(data) ? 'team' : 'person',
        avatarAppearanceShape: (0, $dWZMi.default)(data.appType)
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $afcedb8febd5dd73$var$styles.avatarItem
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $afcedb8febd5dd73$var$styles.avatarItemTextWrapper
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $afcedb8febd5dd73$var$styles.avatarItemText
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        alignBlock: "center"
    }, label, /*#__PURE__*/ $cozmU.createElement($afcedb8febd5dd73$var$ElementAfter, props), canShowArchivedLozenge ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $afcedb8febd5dd73$var$styles.archivedLozengeWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
        appearance: "default"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $7xLai.messages).archivedLozenge))) : null)))))) : null;
};
module.exports["SingleValue"] = $afcedb8febd5dd73$export$1949dac661ba6e3a;

});

parcelRegister("cnIP4", function(module, exports) {
/* Input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $ixfCV = parcelRequire("ixfCV");


var $l9ukq = parcelRequire("l9ukq");

function $0a548c9faa3635cd$var$_defineProperty(e, r, t) {
    return (r = $0a548c9faa3635cd$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $0a548c9faa3635cd$var$_toPropertyKey(t) {
    var i = $0a548c9faa3635cd$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $0a548c9faa3635cd$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $0a548c9faa3635cd$var$inputStyles = {
    root: "_5ce61rpy _1ir3kb7n _h5gq1rpy"
};
class $0a548c9faa3635cd$export$f5b8910cec6cf069 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    get ariaLabelledBy() {
        if ((0, $ixfCV.fg)('platform_user_picker_fix_redundant_labelledby')) {
            // A11Y-37267: An explicit aria-labelledby is a deliberate association with a visible label
            // element and is the field's true accessible name (WCAG 2.5.3 Label in Name), so it always
            // wins. Otherwise we promote aria-describedby -> aria-labelledby to work around
            // react-select's placeholder linkage bug, but skip that promotion when the input already
            // has an accessible name via aria-label so the description is announced via
            // aria-describedby instead.
            if (this.props['aria-labelledby']) return this.props['aria-labelledby'];
            if (this.props['aria-label']) return undefined;
            return this.props['aria-describedby'];
        }
        return this.props['aria-labelledby'] ?? this.props['aria-describedby'];
    }
    get ariaDescribedBy() {
        return this.props.selectProps?.['aria-describedby'] ?? this.props['aria-describedby'];
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Input, {
            ...this.props,
            "aria-labelledby": this.ariaLabelledBy,
            "aria-describedby": this.ariaDescribedBy,
            innerRef: this.props.innerRef,
            onKeyPress: this.handleKeyPress,
            xcss: $0a548c9faa3635cd$var$inputStyles.root
        });
    }
    constructor(...args){
        super(...args); // onKeyPress is used instead as
        // react-select is using onKeyDown for capturing keyboard input
        $0a548c9faa3635cd$var$_defineProperty(this, "handleKeyPress", (e)=>{
            if (e.key === 'Enter') e.preventDefault();
             //@ts-ignore react-select unsupported props
            if (this.props.selectProps?.disableInput) e.preventDefault();
        });
    }
}
module.exports["Input"] = $0a548c9faa3635cd$export$f5b8910cec6cf069;

});

parcelRegister("bPMiS", function(module, exports) {
/* SingleValueContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $l9ukq = parcelRequire("l9ukq");


var $lvlsM = parcelRequire("lvlsM");


var $cGbTM = parcelRequire("cGbTM");


var $9gNGh = parcelRequire("9gNGh");


var $dWZMi = parcelRequire("dWZMi");

function $66428c86f185db93$var$_defineProperty(e, r, t) {
    return (r = $66428c86f185db93$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $66428c86f185db93$var$_toPropertyKey(t) {
    var i = $66428c86f185db93$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $66428c86f185db93$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $66428c86f185db93$var$valueContainerStyles = {
    root: "_yv0e5bpd _ca0q12x7 _n3td12x7 _19bvze3t _1reo15vq _18m91wug _1fjgglyw _c71l1osq _1suq1j28 _1ke8idpf"
};
const $66428c86f185db93$var$placeholderIconContainer = null;
const $66428c86f185db93$var$wrapperStyle = null;
const $66428c86f185db93$var$showUserAvatar = (inputValue, value)=>value && value.data && inputValue === value.label;
class $66428c86f185db93$export$afa5f855316c6a48 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { children: children, ...valueContainerProps } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9gNGh.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).ValueContainer, {
            ...valueContainerProps,
            xcss: $66428c86f185db93$var$valueContainerStyles.root
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_nd5l1kqh _19bv12x7 _vwz4idpf"
            ])
        }, this.renderAvatar()), children));
    }
    constructor(...args){
        super(...args);
        $66428c86f185db93$var$_defineProperty(this, "renderAvatar", ()=>{
            const { hasValue: hasValue, //@ts-ignore react-select unsupported props
            selectProps: { appearance: appearance, isFocused: isFocused, inputValue: inputValue, value: value, placeholderAvatar: placeholderAvatar } } = this.props;
            if (isFocused || !hasValue) {
                const userData = $66428c86f185db93$var$showUserAvatar(inputValue, value) ? value.data : undefined;
                if (userData?.icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lvlsM.AvatarOrIcon), {
                    appearance: appearance,
                    icon: userData.icon,
                    iconColor: userData.iconColor,
                    type: placeholderAvatar,
                    src: userData.avatarUrl,
                    avatarAppearanceShape: userData ? (0, $dWZMi.default)(userData.appType) : undefined
                });
                 // Fallback to original behavior
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cGbTM.SizeableAvatar), {
                    appearance: appearance,
                    type: placeholderAvatar,
                    src: userData?.avatarUrl,
                    avatarAppearanceShape: userData ? (0, $dWZMi.default)(userData.appType) : undefined
                });
            }
            return null;
        }); //@ts-ignore react-select unsupported props
        $66428c86f185db93$var$_defineProperty(this, "onValueContainerClick", this.props.selectProps.onValueContainerClick);
        $66428c86f185db93$var$_defineProperty(this, "Wrapper", ({ children: children })=>{
            return this.onValueContainerClick ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                onMouseDown: this.onValueContainerClick,
                className: (0, $hekY6.default)([
                    "_16jlkb7n"
                ])
            }, children) : children;
        });
    }
}
module.exports["SingleValueContainer"] = $66428c86f185db93$export$afa5f855316c6a48;

});

parcelRegister("97jiw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cnIP4 = parcelRequire("cnIP4");

class $ae16fbc8746297f4$export$d8edbfd510a7db82 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidMount() {
        if (this.ref) // @ts-ignore
        this.ref.select();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cnIP4.Input), {
            ...this.props,
            innerRef: this.handleInnerRef
        });
    }
    constructor(...args){
        super(...args);
        this.ref = null;
        this.handleInnerRef = (ref)=>{
            this.ref = ref;
            if (this.props.innerRef) this.props.innerRef(ref);
        };
    }
}
module.exports["PopupInput"] = $ae16fbc8746297f4$export$d8edbfd510a7db82;

});

parcelRegister("8otJJ", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $dnFcR = parcelRequire("dnFcR");

function $aa22d968e17202e4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $aa22d968e17202e4$var$controlWrapper = /*#__PURE__*/ (0, $lOiVq.css)({
    display: 'flex',
    flexDirection: 'column',
    padding: `0px ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
});
const $aa22d968e17202e4$var$labelStyle = {
    name: "14uum76",
    styles: "color:var(--ds-text-subtlest, #6B6E76);font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-semibold, 600);padding-bottom:var(--ds-space-050, 4px);padding-left:var(--ds-space-0, 0px);padding-right:var(--ds-space-0, 0px);padding-top:var(--ds-space-250, 20px)"
};
class $aa22d968e17202e4$export$a0cb1b4352357fcc extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    render() {
        const { //@ts-ignore react-select unsupported props
        selectProps: { popupTitle: popupTitle } } = this.props;
        return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: $aa22d968e17202e4$var$controlWrapper
        }, /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: $aa22d968e17202e4$var$labelStyle
        }, popupTitle), /*#__PURE__*/ (0, $lOiVq.jsx)((0, $dnFcR.default), this.props));
    }
}
module.exports["PopupControl"] = $aa22d968e17202e4$export$a0cb1b4352357fcc;

});

parcelRegister("dnFcR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $l9ukq = parcelRequire("l9ukq");


var $k12R1 = parcelRequire("k12R1");

const $b9f98721f1489aa7$var$controlStyles = {
    invalid: "_1h6d1bqt _4cvx1bqt",
    focused: "_1h6d1v1w _bfhk1j9a _4cvx1v1w _irr31j9a",
    disabled: "_irr3187o",
    subtle: "_1h6d1j28 _bfhk1j28 _4cvx1j28 _irr31gly",
    root: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1h6drsbi _bfhk1j9a _p12f1osq _14regrf3 _4cvxrsbi _irr3l4ek _1a98zg3v",
    compact: "_1tke1wug"
};
const $b9f98721f1489aa7$var$Control = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(9);
    const isCompact = props.appearance === "compact";
    const t0 = isCompact && $b9f98721f1489aa7$var$controlStyles.compact;
    const t1 = (props.selectProps.subtle || props.selectProps.noBorder) && $b9f98721f1489aa7$var$controlStyles.subtle;
    const t2 = props.isFocused && $b9f98721f1489aa7$var$controlStyles.focused;
    const t3 = props.isInvalid && $b9f98721f1489aa7$var$controlStyles.invalid;
    const t4 = props.isDisabled && $b9f98721f1489aa7$var$controlStyles.disabled;
    let t5;
    if ($[0] !== t0 || $[1] !== t1 || $[2] !== t2 || $[3] !== t3 || $[4] !== t4) {
        t5 = (0, $k12R1.cx)($b9f98721f1489aa7$var$controlStyles.root, t0, t1, t2, t3, t4);
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== props || $[7] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).Control, {
            ...props,
            xcss: t5
        });
        $[6] = props;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    return t6;
} : (props)=>{
    const isCompact = props.appearance === 'compact';
    return /*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).Control, {
        ...props,
        xcss: (0, $k12R1.cx)($b9f98721f1489aa7$var$controlStyles.root, isCompact && $b9f98721f1489aa7$var$controlStyles.compact, (props.selectProps.subtle || props.selectProps.noBorder) && $b9f98721f1489aa7$var$controlStyles.subtle, props.isFocused && $b9f98721f1489aa7$var$controlStyles.focused, props.isInvalid && $b9f98721f1489aa7$var$controlStyles.invalid, props.isDisabled && $b9f98721f1489aa7$var$controlStyles.disabled)
    });
};
var $b9f98721f1489aa7$export$2e2bcd8739ae039 = $b9f98721f1489aa7$var$Control;
module.exports["default"] = $b9f98721f1489aa7$export$2e2bcd8739ae039;

});

parcelRegister("bV3S4", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $l9ukq = parcelRequire("l9ukq");


var $lOiVq = parcelRequire("lOiVq");

const $797d49a3eba443b9$var$getFooterStyle = ()=>{
    return /*#__PURE__*/ (0, $lOiVq.css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
    });
};
class $797d49a3eba443b9$export$d9b273488cd8ce6f extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $l9ukq.components).Menu, this.props, this.props.selectProps.header, this.props.children, this.props.selectProps.footer && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
            css: $797d49a3eba443b9$var$getFooterStyle()
        }, this.props.selectProps.footer));
    }
}
module.exports["Menu"] = $797d49a3eba443b9$export$d9b273488cd8ce6f;

});

parcelRegister("1aEbM", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $9kYT2 = parcelRequire("9kYT2");


var $bsEy7 = parcelRequire("bsEy7");


var $f1uNX = parcelRequire("f1uNX");

const $ff7ae3636e19fcd6$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $ff7ae3636e19fcd6$var$isValidNewOption = (isValidEmail = (0, $bsEy7.isValidEmail))=>(inputValue)=>inputValue && $ff7ae3636e19fcd6$var$validOption.includes(isValidEmail(inputValue));
const $ff7ae3636e19fcd6$var$getNewOptionData = (inputValue)=>({
        label: inputValue,
        value: inputValue,
        data: {
            id: inputValue,
            name: inputValue,
            type: (0, $9kYT2.EmailType)
        }
    });
const $ff7ae3636e19fcd6$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
const $ff7ae3636e19fcd6$var$isOptionDisabled = (isValidEmail = (0, $bsEy7.isValidEmail))=>(option)=>{
        if ((0, $f1uNX.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
function $ff7ae3636e19fcd6$var$creatableProps(isValidEmail) {
    return {
        allowCreateWhileLoading: true,
        createOptionPosition: 'first',
        isValidNewOption: $ff7ae3636e19fcd6$var$isValidNewOption(isValidEmail),
        getNewOptionData: $ff7ae3636e19fcd6$var$getNewOptionData,
        formatCreateLabel: $ff7ae3636e19fcd6$var$formatCreateLabel,
        isOptionDisabled: $ff7ae3636e19fcd6$var$isOptionDisabled(isValidEmail)
    };
}
const $ff7ae3636e19fcd6$export$36f97d8afa97203d = (0, $dOBRD.default)($ff7ae3636e19fcd6$var$creatableProps);
module.exports["getCreatableProps"] = $ff7ae3636e19fcd6$export$36f97d8afa97203d;

});

parcelRegister("7HZsv", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $9kYT2 = parcelRequire("9kYT2");


var $bsEy7 = parcelRequire("bsEy7");


var $f1uNX = parcelRequire("f1uNX");

const $c6733fa977d328f9$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $c6733fa977d328f9$var$isValidNewOption = (inputValue)=>inputValue && inputValue.length > 0;
// Generates suggested option data based on user input and validity of the input (if it is an email or not);
const $c6733fa977d328f9$var$getNewOptionData = (isValidEmail = (0, $bsEy7.isValidEmail), emailDomain)=>(inputValue)=>{
        if (!inputValue) return null;
        const isEmail = inputValue && $c6733fa977d328f9$var$validOption.includes(isValidEmail(inputValue));
        const value = isEmail ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${emailDomain}`;
        return {
            label: value,
            value: value,
            data: {
                id: value,
                name: value,
                type: (0, $9kYT2.EmailType),
                suggestion: true
            }
        };
    };
const $c6733fa977d328f9$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
// Option will not be selectable until the email value is valid and can actually be invited
const $c6733fa977d328f9$var$isOptionDisabled = (isValidEmail = (0, $bsEy7.isValidEmail))=>(option)=>{
        if ((0, $f1uNX.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
const $c6733fa977d328f9$export$34b9dd2dd6a225e5 = (0, $dOBRD.default)((emailDomain, isValidEmail)=>({
        allowCreateWhileLoading: true,
        createOptionPosition: 'last',
        isValidNewOption: $c6733fa977d328f9$var$isValidNewOption,
        getNewOptionData: $c6733fa977d328f9$var$getNewOptionData(isValidEmail, emailDomain),
        formatCreateLabel: $c6733fa977d328f9$var$formatCreateLabel,
        isOptionDisabled: $c6733fa977d328f9$var$isOptionDisabled(isValidEmail)
    }));
module.exports["getCreatableSuggestedEmailProps"] = $c6733fa977d328f9$export$34b9dd2dd6a225e5;

});

parcelRegister("i7OwT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $8B59y = parcelRequire("8B59y");

const $affe1f0b873bb0fd$var$EMPTY = {};
const $affe1f0b873bb0fd$var$useI18n = (0, $gtMdU.isReactCompilerActivePlatform)() ? (locale)=>{
    const $ = (0, $bDgLe.c)(3);
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState($affe1f0b873bb0fd$var$EMPTY);
    let t0;
    let t1;
    if ($[0] !== locale) {
        t0 = ()=>{
            let aborted = false;
            setMessages($affe1f0b873bb0fd$var$EMPTY);
            (0, $8B59y.getMessagesForLocale)(locale).then((messages_0)=>{
                if (!aborted) setMessages(messages_0);
            }).catch($affe1f0b873bb0fd$var$_temp);
            return ()=>{
                aborted = true;
            };
        };
        t1 = [
            locale
        ];
        $[0] = locale;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t0, t1);
    return messages;
} : (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState($affe1f0b873bb0fd$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        let aborted = false;
        setMessages($affe1f0b873bb0fd$var$EMPTY);
        (0, $8B59y.getMessagesForLocale)(locale).then((messages_0)=>{
            if (!aborted) setMessages(messages_0);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $affe1f0b873bb0fd$var$MessagesIntlProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(7);
    const intl = (0, $kSwu1.useIntl)();
    const { children: children } = props;
    const messages = $affe1f0b873bb0fd$var$useI18n(intl.locale);
    const t0 = intl.messages;
    let t1;
    if ($[0] !== messages || $[1] !== t0) {
        t1 = {
            ...t0,
            ...messages
        };
        $[0] = messages;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    const mergedMessages = t1;
    let t2;
    if ($[3] !== children || $[4] !== intl.locale || $[5] !== mergedMessages) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            locale: intl.locale,
            messages: mergedMessages
        }, children);
        $[3] = children;
        $[4] = intl.locale;
        $[5] = mergedMessages;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
} : (props)=>{
    const intl = (0, $kSwu1.useIntl)();
    const { children: children } = props;
    const messages = $affe1f0b873bb0fd$var$useI18n(intl.locale);
    const mergedMessages = (0, $cozmU.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        locale: intl.locale,
        messages: mergedMessages
    }, children);
};
var $affe1f0b873bb0fd$export$2e2bcd8739ae039 = $affe1f0b873bb0fd$var$MessagesIntlProvider;
function $affe1f0b873bb0fd$var$_temp(error) {
    console.error(error);
}
module.exports["default"] = $affe1f0b873bb0fd$export$2e2bcd8739ae039;

});

parcelRegister("8B59y", function(module, exports) {
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 






























const $fabf0ee840193b6d$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("czT7f")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("is2CR")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("f9PXz")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("hTBlD")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("knhp1")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("6Jf3c")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("4stbQ")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("e5Zyb")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("hTGoS")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("4NzHm")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("7WMbM")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("kRet2")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("k0Ylw")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("ed6HY")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("gYHEQ")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("4y6hg")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("ipkwl")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("6Auf5")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("2Y1OG")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("7U9Cn")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("bpqHS")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("1UMpa")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("5rDRi")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("fTac2")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("kJkHm")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("aMBTr")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("4Y1bg")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("4KYVB")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("4DhwK")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("4H0kN")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $fabf0ee840193b6d$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("hTBlD")).then((mod)=>mod.default);
            }
    }
};
module.exports["getMessagesForLocale"] = $fabf0ee840193b6d$export$d0a3169680473b6c;

});

parcelRegister("czT7f", function(module, exports) {

let $928381cfcdc88412$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $928381cfcdc88412$var$load("aQPG0").then(()=>parcelRequire('2MNNk'));

});

parcelRegister("is2CR", function(module, exports) {

let $d6ece0f77e900d01$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d6ece0f77e900d01$var$load("bkZFg").then(()=>parcelRequire('6wHKZ'));

});

parcelRegister("f9PXz", function(module, exports) {

let $b090006a45f0dcb0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b090006a45f0dcb0$var$load("55jRH").then(()=>parcelRequire('9lr8J'));

});

parcelRegister("hTBlD", function(module, exports) {

let $d0748b3f49a16dcb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d0748b3f49a16dcb$var$load("7gZXw").then(()=>parcelRequire('kLDJj'));

});

parcelRegister("knhp1", function(module, exports) {

let $ed5374660f7d9b16$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ed5374660f7d9b16$var$load("b3SDM").then(()=>parcelRequire('bpfBt'));

});

parcelRegister("6Jf3c", function(module, exports) {

let $4e629ec849dd4d3f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4e629ec849dd4d3f$var$load("1JMhO").then(()=>parcelRequire('PSbJN'));

});

parcelRegister("4stbQ", function(module, exports) {

let $33f06b7bd600d6cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $33f06b7bd600d6cb$var$load("9yhAT").then(()=>parcelRequire('bgepv'));

});

parcelRegister("e5Zyb", function(module, exports) {

let $a43146ee98ca6159$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a43146ee98ca6159$var$load("cdSjM").then(()=>parcelRequire('iklsj'));

});

parcelRegister("hTGoS", function(module, exports) {

let $d0787686b6b885e3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d0787686b6b885e3$var$load("d5cjH").then(()=>parcelRequire('iNF4u'));

});

parcelRegister("4NzHm", function(module, exports) {

let $37e76e00ca9b33bf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $37e76e00ca9b33bf$var$load("cM3qB").then(()=>parcelRequire('acET6'));

});

parcelRegister("7WMbM", function(module, exports) {

let $5c93548215716d82$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5c93548215716d82$var$load("ju3RT").then(()=>parcelRequire('aCa90'));

});

parcelRegister("kRet2", function(module, exports) {

let $f2f3facd803b8f3c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f2f3facd803b8f3c$var$load("eKgTI").then(()=>parcelRequire('5HGir'));

});

parcelRegister("k0Ylw", function(module, exports) {

let $e9229e398f49c2fd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e9229e398f49c2fd$var$load("4SiFB").then(()=>parcelRequire('50gw0'));

});

parcelRegister("ed6HY", function(module, exports) {

let $a5877bb71bc0f7fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a5877bb71bc0f7fc$var$load("3sB8d").then(()=>parcelRequire('43D7o'));

});

parcelRegister("gYHEQ", function(module, exports) {

let $c5c41d72d00b66dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c5c41d72d00b66dd$var$load("cufjc").then(()=>parcelRequire('8ROxp'));

});

parcelRegister("4y6hg", function(module, exports) {

let $34ff34fe5bb47354$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $34ff34fe5bb47354$var$load("hPzC3").then(()=>parcelRequire('8awf7'));

});

parcelRegister("ipkwl", function(module, exports) {

let $d66a7ac30169d5cd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d66a7ac30169d5cd$var$load("cjMnf").then(()=>parcelRequire('44rnN'));

});

parcelRegister("6Auf5", function(module, exports) {

let $4cbd90648eaac27c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4cbd90648eaac27c$var$load("bdFVZ").then(()=>parcelRequire('dfiIH'));

});

parcelRegister("2Y1OG", function(module, exports) {

let $229298178354000a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $229298178354000a$var$load("73TPf").then(()=>parcelRequire('g36ET'));

});

parcelRegister("7U9Cn", function(module, exports) {

let $5c15394e51389f53$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5c15394e51389f53$var$load("84JCz").then(()=>parcelRequire('biRQ5'));

});

parcelRegister("bpqHS", function(module, exports) {

let $84e6bee535d6157a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $84e6bee535d6157a$var$load("e9I4V").then(()=>parcelRequire('iVMCW'));

});

parcelRegister("1UMpa", function(module, exports) {

let $1650919caaa8e2ca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1650919caaa8e2ca$var$load("11Tbc").then(()=>parcelRequire('1KBJA'));

});

parcelRegister("5rDRi", function(module, exports) {

let $3f6e6475cd44f19c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3f6e6475cd44f19c$var$load("9tJmD").then(()=>parcelRequire('aZaJA'));

});

parcelRegister("fTac2", function(module, exports) {

let $b913e639f322e6fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b913e639f322e6fc$var$load("15Pfi").then(()=>parcelRequire('fXcYB'));

});

parcelRegister("kJkHm", function(module, exports) {

let $f17810e6417eeb22$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f17810e6417eeb22$var$load("5JkSw").then(()=>parcelRequire('cMTKF'));

});

parcelRegister("aMBTr", function(module, exports) {

let $7d9bc7e1a9c9a29a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7d9bc7e1a9c9a29a$var$load("8yuuY").then(()=>parcelRequire('i0dXc'));

});

parcelRegister("4Y1bg", function(module, exports) {

let $39ddae750cc71672$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $39ddae750cc71672$var$load("gYFls").then(()=>parcelRequire('47Oa4'));

});

parcelRegister("4KYVB", function(module, exports) {

let $376ab8566e57c3f9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $376ab8566e57c3f9$var$load("4tohK").then(()=>parcelRequire('20QzR'));

});

parcelRegister("4DhwK", function(module, exports) {

let $35f8667a2cfca562$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $35f8667a2cfca562$var$load("iXqHo").then(()=>parcelRequire('4cqqy'));

});

parcelRegister("4H0kN", function(module, exports) {

let $36ab7002b9784b9c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $36ab7002b9784b9c$var$load("lcic8").then(()=>parcelRequire('kb5xT'));

});

parcelRegister("50iN8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $bfa0c313f69ddec7$var$ExusUserSourceContext = /*#__PURE__*/ (0, $cozmU.createContext)({});
const $bfa0c313f69ddec7$export$bcd5c65b586ee3c3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { fetchUserSource: fetchUserSource, children: children } = t0;
    let t1;
    if ($[0] !== fetchUserSource) {
        t1 = {
            fetchUserSource: fetchUserSource
        };
        $[0] = fetchUserSource;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bfa0c313f69ddec7$var$ExusUserSourceContext.Provider, {
            value: t1
        }, children);
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ fetchUserSource: fetchUserSource, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bfa0c313f69ddec7$var$ExusUserSourceContext.Provider, {
        value: {
            fetchUserSource: fetchUserSource
        }
    }, children);
const $bfa0c313f69ddec7$export$c6c0c1a2bac363f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (accountId, shouldFetchSources, existingSources)=>{
    const $ = (0, $bDgLe.c)(19);
    const { fetchUserSource: fetchUserSource } = (0, $cozmU.useContext)($bfa0c313f69ddec7$var$ExusUserSourceContext);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const [externalSources, setExternalSources] = (0, $cozmU.useState)(t0);
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)(null);
    let t1;
    bb0: {
        if (typeof AbortController === "undefined") {
            t1 = undefined;
            break bb0;
        }
        let t2;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = new AbortController();
            $[1] = t2;
        } else t2 = $[1];
        t1 = t2;
    }
    const abortController = t1;
    let t2;
    let t3;
    if ($[2] !== accountId || $[3] !== fetchUserSource || $[4] !== shouldFetchSources) {
        t2 = ()=>{
            let isMounted = true;
            const cleanup = ()=>{
                abortController?.abort();
                isMounted = false;
            };
            if (!fetchUserSource || !shouldFetchSources) {
                setLoading(false);
                return cleanup;
            }
            fetchUserSource(accountId, abortController?.signal).then((externalSources_0)=>{
                if (!isMounted) return;
                setLoading(false);
                const externalSourceTypes = externalSources_0.map($bfa0c313f69ddec7$var$_temp);
                setExternalSources(externalSourceTypes);
            }).catch((error_0)=>{
                if (!isMounted) return;
                setLoading(false);
                setError(error_0);
            });
            return cleanup;
        };
        t3 = [
            fetchUserSource,
            accountId,
            abortController,
            shouldFetchSources
        ];
        $[2] = accountId;
        $[3] = fetchUserSource;
        $[4] = shouldFetchSources;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[7] !== existingSources || $[8] !== externalSources) {
        let t5;
        if ($[10] !== existingSources) {
            t5 = existingSources ?? [];
            $[10] = existingSources;
            $[11] = t5;
        } else t5 = $[11];
        let t6;
        if ($[12] !== externalSources || $[13] !== t5) {
            t6 = new Set([
                ...t5,
                ...externalSources
            ]);
            $[12] = externalSources;
            $[13] = t5;
            $[14] = t6;
        } else t6 = $[14];
        t4 = Array.from(t6);
        $[7] = existingSources;
        $[8] = externalSources;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[15] !== error || $[16] !== loading || $[17] !== t4) {
        t5 = {
            sources: t4,
            loading: loading,
            error: error
        };
        $[15] = error;
        $[16] = loading;
        $[17] = t4;
        $[18] = t5;
    } else t5 = $[18];
    return t5;
} : (accountId, shouldFetchSources, existingSources)=>{
    const { fetchUserSource: fetchUserSource } = (0, $cozmU.useContext)($bfa0c313f69ddec7$var$ExusUserSourceContext);
    const [externalSources, setExternalSources] = (0, $cozmU.useState)([]);
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)(null);
    const abortController = (0, $cozmU.useMemo)(()=>{
        if (typeof AbortController === 'undefined') return;
        return new AbortController();
    }, []);
    (0, $cozmU.useEffect)(()=>{
        let isMounted = true;
        const cleanup = ()=>{
            abortController?.abort();
            isMounted = false;
        };
        if (!fetchUserSource || !shouldFetchSources) {
            setLoading(false);
            return cleanup;
        }
        fetchUserSource(accountId, abortController?.signal).then((externalSources_0)=>{
            if (!isMounted) return;
            setLoading(false);
            const externalSourceTypes = externalSources_0.map((source)=>source.sourceType);
            setExternalSources(externalSourceTypes);
        }).catch((error_0)=>{
            if (!isMounted) return;
            setLoading(false);
            setError(error_0);
        });
        return cleanup;
    }, [
        fetchUserSource,
        accountId,
        abortController,
        shouldFetchSources
    ]);
    return (0, $cozmU.useMemo)(()=>({
            sources: Array.from(new Set([
                ...existingSources ?? [],
                ...externalSources
            ])),
            loading: loading,
            error: error
        }), [
        error,
        existingSources,
        externalSources,
        loading
    ]);
};
function $bfa0c313f69ddec7$var$_temp(source) {
    return source.sourceType;
}
module.exports["ExusUserSourceProvider"] = $bfa0c313f69ddec7$export$bcd5c65b586ee3c3;
module.exports["useUserSource"] = $bfa0c313f69ddec7$export$c6c0c1a2bac363f;

});

parcelRegister("24tIi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9K2Ng = parcelRequire("9K2Ng");


var $cCc2a = parcelRequire("cCc2a");


var $7GkXv = parcelRequire("7GkXv");

const $146c3ccf1b168812$var$SmartUserPickerWithIntlProvider = (props)=>{
    const ufoId = props.inputId || props.fieldId;
    (0, $7GkXv.useUFOConcurrentExperience)((0, $7GkXv.smartUserPickerRenderedUfoExperience), ufoId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7GkXv.UfoErrorBoundary), {
        id: ufoId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cCc2a.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9K2Ng.SmartUserPicker), props)));
};
var $146c3ccf1b168812$export$2e2bcd8739ae039 = $146c3ccf1b168812$var$SmartUserPickerWithIntlProvider;
module.exports["default"] = $146c3ccf1b168812$export$2e2bcd8739ae039;

});

parcelRegister("9K2Ng", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $55fM8 = parcelRequire("55fM8");


var $kHija = parcelRequire("kHija");


var $lzgC6 = parcelRequire("lzgC6");


var $dOBRD = parcelRequire("dOBRD");


var $kSwu1 = parcelRequire("kSwu1");


var $j7Sza = parcelRequire("j7Sza");


var $kfLla = parcelRequire("kfLla");

var $f1uNX = parcelRequire("f1uNX");

var $bsEy7 = parcelRequire("bsEy7");


var $ixfCV = parcelRequire("ixfCV");


var $kK1nI = parcelRequire("kK1nI");


var $cCc2a = parcelRequire("cCc2a");


var $jItb7 = parcelRequire("jItb7");


var $b9heI = parcelRequire("b9heI");

var $uUDXo = parcelRequire("uUDXo");


var $7GkXv = parcelRequire("7GkXv");

const $537559c2d938befb$var$DEFAULT_DEBOUNCE_TIME_MS = 150;
const $537559c2d938befb$var$ufoEndStateConfig = (fieldId)=>{
    return {
        metadata: {
            contextType: fieldId
        }
    };
};
const $537559c2d938befb$var$hasContextChanged = (oldContext, newContext)=>oldContext.siteId !== newContext.siteId || oldContext.orgId !== newContext.orgId || oldContext.userbaseId !== newContext.userbaseId || oldContext.productKey !== newContext.productKey || oldContext.principalId !== newContext.principalId || oldContext.containerId !== newContext.containerId || oldContext.objectId !== newContext.objectId || oldContext.childObjectId !== newContext.childObjectId;
const $537559c2d938befb$var$stringContains = (str, substr)=>{
    if (str === null || str === undefined) return false;
    if (substr === null || substr === '' || substr === undefined) return true;
    return str.toLowerCase().includes(substr.toLowerCase());
};
const $537559c2d938befb$var$getUsersForAnalytics = (users)=>(users || []).map(({ id: id, type: type })=>({
            id: id,
            type: type
        }));
const $537559c2d938befb$var$checkIf500Event = (statusCode)=>500 <= statusCode && statusCode < 600;
const $537559c2d938befb$var$isEmailQuery = (query)=>{
    return (0, $bsEy7.isValidEmail)(query.trim()) === 'VALID';
};
class $537559c2d938befb$export$9b9bd453d1d4e4ce extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    async componentDidMount() {
        try {
            const value = await (0, $uUDXo.default)(this.props.baseUrl, this.props.defaultValue, this.props.productKey, this.props.siteId, {
                tenantId: this.props.siteId,
                activationId: this.props.activationId
            });
            this.setState({
                defaultValue: value
            });
        } catch (e) {
            const defaultValue = await (this.props.onValueError ? this.props.onValueError(e, this.props.defaultValue) || Promise.resolve([]) : Promise.resolve([]));
            this.setState({
                defaultValue: defaultValue
            });
        }
        const { prefetch: prefetch } = this.props;
        if (prefetch) {
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            const sessionId = (0, $kHija.v4)();
            this.fireEvent((0, $kK1nI.mountedWithPrefetchEvent), {
                sessionId: sessionId
            });
            this.setState({
                sessionId: sessionId
            });
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if ($537559c2d938befb$var$hasContextChanged(prevProps, this.props) || this.props.fieldId !== prevProps.fieldId) this.setState({
            users: []
        });
        if ((this.state.sessionId !== prevState.sessionId || this.state.query !== prevState.query) && (this.state.query !== '' || !this.props.bootstrapOptions)) this.getUsers();
        else if (!this.state.closed && !this.state.loading) // If the component has rendered (including its dropdown list) and it
        // is not loading anything further, send the success UFO event
        {
            if (![
                (0, $j7Sza.UFOExperienceState).FAILED.id,
                (0, $j7Sza.UFOExperienceState).SUCCEEDED.id,
                (0, $j7Sza.UFOExperienceState).ABORTED.id
            ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success($537559c2d938befb$var$ufoEndStateConfig(this.props.fieldId));
        }
    }
    render() {
        const { allowEmail: allowEmail, enableEmailSearch: enableEmailSearch, allowEmailSelectionWhenEmailMatched: allowEmailSelectionWhenEmailMatched, ...restProps } = this.props;
        // Determine whether to allow email selection based on allowEmailSelectionWhenEmailMatched, if needed
        let shouldAllowEmail = allowEmail;
        if (allowEmail && enableEmailSearch && !allowEmailSelectionWhenEmailMatched) {
            const isCurrentQueryEmail = $537559c2d938befb$var$isEmailQuery(this.state.query);
            // Only allow email selection when:
            // 1. The query matches email format (validated by regex)
            // 2. No user/external user matches were found (only teams/groups suggested)
            shouldAllowEmail = isCurrentQueryEmail && !this.lastEmailSearchFoundMatches;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cCc2a.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kfLla.UserPicker), {
            ...restProps,
            allowEmail: shouldAllowEmail,
            onInputChange: this.onInputChange,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            defaultValue: this.state.defaultValue,
            isLoading: this.props.isLoading || this.state.loading && !this.state.closed && (!this.props.bootstrapOptions || this.state.query !== ''),
            options: this.filterUsers(),
            menuIsOpen: this.props.menuIsOpen
        }));
    }
    constructor(props){
        super(props);
        this.state = {
            users: [],
            loading: false,
            closed: true,
            query: '',
            defaultValue: [],
            bootstrapOptions: []
        };
        // Track if the last search was an email search that found matches
        this.lastEmailSearchFoundMatches = false;
        this.optionsShownUfoExperienceInstance = void 0;
        this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $j7Sza.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        };
        this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        };
        this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $kK1nI.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, ...args))(createAnalyticsEvent);
        };
        this.filterOptions = (users, query, propFilterOptions)=>propFilterOptions ? propFilterOptions(users, query) : users;
        this.memoizedFilterOptions = (0, $dOBRD.default)(this.filterOptions);
        this.getUsers = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(async ()=>{
            const { query: query, sessionId: sessionId, closed: closed } = this.state;
            const { baseUrl: baseUrl, childObjectId: childObjectId, containerId: containerId, fieldId: fieldId, includeGroups: includeGroups, includeTeams: includeTeams, includeTeamsUpdates: includeTeamsUpdates, includeUsers: includeUsers, includeNonLicensedUsers: includeNonLicensedUsers, intl: intl, fetchOptions: fetchOptions, maxOptions: maxOptions, objectId: objectId, onEmpty: onEmpty, onError: onError, overrideByline: overrideByline, displayEmailInByline: displayEmailInByline, verifiedTeams: verifiedTeams, orgId: orgId, userbaseId: userbaseId, principalId: principalId, productAttributes: productAttributes, productKey: productKey, restrictTo: restrictTo, searchQueryFilter: searchQueryFilter, siteId: siteId, isTeamSyncedToGroupDirectoryFilter: isTeamSyncedToGroupDirectoryFilter, transformOptions: transformOptions, userResolvers: userResolvers, enableEmailSearch: enableEmailSearch } = this.props;
            const maxNumberOfResults = maxOptions || 100;
            const startTime = window.performance.now();
            // Check if this is an email search
            const isEmail = enableEmailSearch && $537559c2d938befb$var$isEmailQuery(query);
            const recommendationsRequest = {
                baseUrl: baseUrl,
                context: {
                    containerId: containerId,
                    contextType: fieldId,
                    objectId: objectId,
                    principalId: principalId,
                    productKey: productKey,
                    siteId: siteId,
                    organizationId: orgId,
                    userbaseId: userbaseId,
                    childObjectId: childObjectId,
                    sessionId: sessionId,
                    productAttributes: productAttributes
                },
                includeUsers: includeUsers,
                includeGroups: // For email searches, disable groups and teams
                includeGroups,
                includeTeams: includeTeams,
                includeNonLicensedUsers: includeNonLicensedUsers,
                maxNumberOfResults: maxNumberOfResults,
                query: query,
                searchEmail: isEmail,
                ...verifiedTeams === true && {
                    verifiedTeams: true
                },
                /*
        	For email-based searches, we have decided to filter out apps.
        	Also - because the other 2 filters ((NOT not_mentionable:true) AND (account_status:active)) are included
        	when filter is empty, they have been added here to maintain consistency.
        		Further ref: https://developer.atlassian.com/platform/user-recommendations/guides/frequently-asked-questions/#filter-behavior
         */ searchQueryFilter: isEmail && !searchQueryFilter ? '(NOT not_mentionable:true) AND (account_status:active) AND (NOT account_type:app)' : searchQueryFilter,
                ...restrictTo && (0, $ixfCV.fg)('smart-user-picker-restrict-to-gate') && {
                    restrictTo: restrictTo
                },
                ...isTeamSyncedToGroupDirectoryFilter === true && {
                    isTeamSyncedToGroupDirectoryFilter: true
                }
            };
            try {
                const { query: query } = this.state;
                this.fireEvent((0, $kK1nI.requestUsersEvent));
                let recommendedUsers;
                if (fetchOptions && (0, $ixfCV.fg)('smart-user-picker-load-options-gate')) recommendedUsers = await fetchOptions(query);
                else if ((0, $ixfCV.fg)('twcg-444-invite-usd-improvements-m2-gate')) {
                    const userRecommendationsPromise = (0, $b9heI.default)(recommendationsRequest, intl);
                    const userResolversPromises = (userResolvers ?? []).map((resolver)=>resolver(query).catch((error)=>{
                            this.fireEvent((0, $kK1nI.failedUserResolversEvent), {
                                resolverName: resolver.name,
                                error: error
                            });
                            return [];
                        }));
                    const [mainRecommendations, ...userResolverResults] = await Promise.all([
                        userRecommendationsPromise,
                        ...userResolversPromises
                    ]);
                    recommendedUsers = [
                        mainRecommendations,
                        ...userResolverResults
                    ].flat();
                } else recommendedUsers = await (0, $b9heI.default)(recommendationsRequest, intl);
                if (overrideByline) {
                    for (let option of recommendedUsers)if ((0, $f1uNX.isUser)(option) || (0, $f1uNX.isExternalUser)(option) || (0, $f1uNX.isTeam)(option)) option.byline = overrideByline(option);
                }
                if (displayEmailInByline) {
                    for (let option of recommendedUsers)if ((0, $f1uNX.isUser)(option) || (0, $f1uNX.isExternalUser)(option)) {
                        if (option.userType === (0, $jItb7.UserEntityType).DEFAULT || option.userType === (0, $jItb7.UserEntityType).CUSTOMER) // Respect existing byline if present
                        {
                            if (option.email && !option.byline) option.byline = option.email;
                        }
                    }
                }
                if (includeTeamsUpdates) {
                    for (let option of recommendedUsers)if ((0, $f1uNX.isGroup)(option) || (0, $f1uNX.isTeam)(option)) option.includeTeamsUpdates = includeTeamsUpdates;
                }
                // Track if email search found matches for conditional allowEmail logic
                if (isEmail) {
                    // Only count user/external user matches, not teams or groups
                    const userMatches = recommendedUsers.filter((user)=>(0, $f1uNX.isUser)(user) || (0, $f1uNX.isExternalUser)(user));
                    this.lastEmailSearchFoundMatches = userMatches.length > 0;
                } else this.lastEmailSearchFoundMatches = false;
                const elapsedTimeMilli = window.performance.now() - startTime;
                const transformedOptions = transformOptions ? await transformOptions(recommendedUsers, query) : recommendedUsers;
                const displayedUsers = transformedOptions.length === 0 && onEmpty ? await onEmpty(query) ?? [] : transformedOptions;
                this.setState((state)=>{
                    const applicable = state.query === query;
                    const users = applicable ? displayedUsers : state.users;
                    const loading = !applicable;
                    this.fireEvent((0, $kK1nI.successfulRequestUsersEvent), {
                        users: $537559c2d938befb$var$getUsersForAnalytics(recommendedUsers),
                        elapsedTimeMilli: elapsedTimeMilli,
                        displayedUsers: $537559c2d938befb$var$getUsersForAnalytics(displayedUsers),
                        productAttributes: productAttributes,
                        applicable: applicable,
                        ...(0, $ixfCV.fg)('twcg-444-invite-usd-improvements-m2-gate') && {
                            userResolvers: Array.isArray(userResolvers) ? userResolvers.map((resolver)=>resolver.name) : []
                        }
                    });
                    return {
                        users: users,
                        loading: loading
                    };
                });
            } catch (e) {
                const is5xxEvent = $537559c2d938befb$var$checkIf500Event(e.statusCode);
                if (!closed && !onError && is5xxEvent) // If the user lookup fails while the menu is open, and the consumer is not providing a
                // fallback data source via the onError prop, then send UFO failure
                this.optionsShownUfoExperienceInstance.failure($537559c2d938befb$var$ufoEndStateConfig(this.props.fieldId));
                this.setState({
                    users: []
                });
                let onErrorProducedError = false;
                let defaultUsers = [];
                try {
                    defaultUsers = onError ? await onError(e, recommendationsRequest) || [] : [];
                } catch  {
                    onErrorProducedError = true;
                }
                if (onErrorProducedError && is5xxEvent) // Log error from fallback data source `onError` to UFO
                this.optionsShownUfoExperienceInstance.failure($537559c2d938befb$var$ufoEndStateConfig(this.props.fieldId));
                if (!is5xxEvent && (!onError && !closed || onErrorProducedError)) this.abortOptionsShownUfoExperience();
                this.setState({
                    users: defaultUsers,
                    loading: false
                });
                const elapsedTimeMilli = window.performance.now() - startTime;
                this.fireEvent((0, $kK1nI.failedRequestUsersEvent), {
                    elapsedTimeMilli: elapsedTimeMilli,
                    productAttributes: productAttributes
                });
            }
        }, this.props.debounceTime ?? 0);
        this.onInputChange = (newQuery, sessionId)=>{
            const query = newQuery || '';
            const { closed: closed } = this.state;
            if (query === this.state.query) return;
            if (!closed) {
                // If the input has been typed into and the dropdown has not been closed
                // (i.e. input blurred) then start the UFO timer.
                // If there's a previous UFO timer running for the same "options shown" experience,
                // it will be aborted first.
                this.startOptionsShownUfoExperience();
                this.setState({
                    loading: true,
                    query: query,
                    sessionId: sessionId
                });
                if (this.props.onInputChange) this.props.onInputChange(query, sessionId);
            }
        };
        this.filterUsers = ()=>{
            const { loading: loading, users: users, query: query } = this.state;
            const filteredUsers = this.memoizedFilterOptions(users, query, this.props.filterOptions);
            //If bootstrapOptions have been passed in and it is bootstrap
            if (this.props.bootstrapOptions && this.props.bootstrapOptions.length !== 0 && query === '') {
                const bootstrapFilteredUsers = this.memoizedFilterOptions(this.props.bootstrapOptions, query, this.props.filterOptions);
                this.fireEvent((0, $kK1nI.filterUsersEvent), {
                    filtered: $537559c2d938befb$var$getUsersForAnalytics(bootstrapFilteredUsers),
                    all: $537559c2d938befb$var$getUsersForAnalytics(this.props.bootstrapOptions)
                });
                return bootstrapFilteredUsers;
            }
            // while when not loading just return already filtered result from server.
            if (!loading) return filteredUsers;
            const queryFilteredUsers = filteredUsers.filter((user)=>$537559c2d938befb$var$stringContains(user.name, query));
            this.fireEvent((0, $kK1nI.filterUsersEvent), {
                filtered: $537559c2d938befb$var$getUsersForAnalytics(queryFilteredUsers),
                all: $537559c2d938befb$var$getUsersForAnalytics(users)
            });
            // when loading filter previous result.
            return filteredUsers;
        };
        this.onFocus = (sessionId)=>{
            const state = {
                closed: false
            };
            this.startOptionsShownUfoExperience();
            if (this.state.users.length === 0) {
                state.sessionId = sessionId;
                state.loading = true;
            } else this.fireEvent((0, $kK1nI.preparedUsersLoadedEvent), {
                users: $537559c2d938befb$var$getUsersForAnalytics(this.state.users),
                preparedSessionId: this.state.sessionId,
                sessionId: sessionId
            });
            this.setState((currentState)=>({
                    ...currentState,
                    ...state
                }));
            if (this.props.onFocus) this.props.onFocus(sessionId);
        };
        this.onBlur = (sessionId)=>{
            this.getUsers.cancel();
            this.abortOptionsShownUfoExperience();
            // clear old users if query is populated so that on refocus,
            // the old list is not shown
            const users = this.state.query.length === 0 ? this.state.users : [];
            this.setState({
                loading: false,
                closed: true,
                users: users
            });
            if (this.props.onBlur) this.props.onBlur(sessionId);
        };
        this.optionsShownUfoExperienceInstance = (0, $7GkXv.smartUserPickerOptionsShownUfoExperience).getInstance(props.inputId || props.fieldId);
    }
}
// TODO: Smart User picker team will have to add a type annotation here
$537559c2d938befb$export$9b9bd453d1d4e4ce.defaultProps = {
    baseUrl: '',
    includeUsers: true,
    includeGroups: false,
    includeTeams: false,
    includeTeamsUpdates: false,
    includeNonLicensedUsers: false,
    displayEmailInByline: false,
    prefetch: false,
    principalId: 'Context',
    debounceTime: $537559c2d938befb$var$DEFAULT_DEBOUNCE_TIME_MS,
    userResolvers: [],
    enableEmailSearch: false,
    allowEmailSelectionWhenEmailMatched: true,
    verifiedTeams: false
};
const $537559c2d938befb$export$9eedb6e5d313efdb = (0, $lzgC6.default)()((0, $kSwu1.injectIntl)($537559c2d938befb$export$9b9bd453d1d4e4ce));
module.exports["SmartUserPicker"] = $537559c2d938befb$export$9eedb6e5d313efdb;

});

parcelRegister("kK1nI", function(module, exports) {
// eslint-disable-next-line @typescript-eslint/consistent-type-imports

var $2iGHk = parcelRequire("2iGHk");


var $kHija = parcelRequire("kHija");

const $7fe07237a7d94e47$var$packageName = "platform-pkg";
const $7fe07237a7d94e47$var$packageVersion = "0.0.0-use.local";
const $7fe07237a7d94e47$export$c0d84948cecf78d8 = ()=>({
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        id: (0, $kHija.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $7fe07237a7d94e47$export$53eef0dcd9611650 = (0, $2iGHk.default)('fabric-elements');
const $7fe07237a7d94e47$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $7fe07237a7d94e47$var$packageName,
            packageVersion: $7fe07237a7d94e47$var$packageVersion,
            ...attributes
        }
    });
const $7fe07237a7d94e47$var$createDefaultSmartPickerAttributes = (props, state)=>{
    const { fieldId: fieldId, objectId: objectId, containerId: containerId, childObjectId: childObjectId, prefetch: prefetch, maxOptions: maxOptions, includeTeams: includeTeams, productKey: productKey, principalId: principalId, siteId: siteId, orgId: orgId, filterOptions: filterOptions } = props;
    const { sessionId: sessionId, query: query } = state;
    const maxNumberOfResults = maxOptions || 100;
    return {
        context: fieldId,
        childObjectId: childObjectId,
        containerId: containerId,
        hasFilterOptions: Boolean(filterOptions),
        includeTeams: includeTeams,
        maxNumberOfResults: maxNumberOfResults,
        objectId: objectId,
        prefetch: prefetch,
        principalId: principalId,
        productKey: productKey,
        queryLength: (query || '').length,
        siteId: siteId,
        orgId: orgId,
        sessionId: sessionId
    };
};
const $7fe07237a7d94e47$var$createSmartUserPickerEvent = (action, actionSubect, attributes = {})=>({
        source: 'smart-user-picker',
        ...$7fe07237a7d94e47$var$createEvent('operational', action, actionSubect, attributes)
    });
const $7fe07237a7d94e47$export$185f4c3d9b7ef9bf = (props, state, attributes = {})=>$7fe07237a7d94e47$var$createSmartUserPickerEvent('loaded', 'preparedUsers', {
        ...$7fe07237a7d94e47$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $7fe07237a7d94e47$export$9cfb4251e50d7b91 = (props, state, attributes = {})=>$7fe07237a7d94e47$var$createSmartUserPickerEvent('mounted', 'prefetch', {
        ...$7fe07237a7d94e47$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $7fe07237a7d94e47$export$fbba77127d7cb173 = (props, state, attributes = {})=>$7fe07237a7d94e47$var$createSmartUserPickerEvent('filtered', 'users', {
        ...$7fe07237a7d94e47$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $7fe07237a7d94e47$export$1762ed8845ff2d9b = (props, state, attributes = {})=>$7fe07237a7d94e47$var$createSmartUserPickerEvent('requested', 'users', {
        ...$7fe07237a7d94e47$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $7fe07237a7d94e47$export$bfc020018aa738d0 = (props, state, attributes = {})=>$7fe07237a7d94e47$var$createSmartUserPickerEvent('successful', 'usersRequest', {
        ...$7fe07237a7d94e47$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $7fe07237a7d94e47$export$738aca68b593db8e = (props, state, attributes = {})=>$7fe07237a7d94e47$var$createSmartUserPickerEvent('failed', 'usersRequest', {
        ...$7fe07237a7d94e47$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
const $7fe07237a7d94e47$export$b9358131e14a4b0b = (props, state, attributes = {})=>$7fe07237a7d94e47$var$createSmartUserPickerEvent('failed', 'userResolversRequest', {
        ...$7fe07237a7d94e47$var$createDefaultSmartPickerAttributes(props, state),
        ...attributes
    });
module.exports["createAndFireEventInElementsChannel"] = $7fe07237a7d94e47$export$53eef0dcd9611650;
module.exports["preparedUsersLoadedEvent"] = $7fe07237a7d94e47$export$185f4c3d9b7ef9bf;
module.exports["mountedWithPrefetchEvent"] = $7fe07237a7d94e47$export$9cfb4251e50d7b91;
module.exports["filterUsersEvent"] = $7fe07237a7d94e47$export$fbba77127d7cb173;
module.exports["requestUsersEvent"] = $7fe07237a7d94e47$export$1762ed8845ff2d9b;
module.exports["successfulRequestUsersEvent"] = $7fe07237a7d94e47$export$bfc020018aa738d0;
module.exports["failedRequestUsersEvent"] = $7fe07237a7d94e47$export$738aca68b593db8e;
module.exports["failedUserResolversEvent"] = $7fe07237a7d94e47$export$b9358131e14a4b0b;

});

parcelRegister("cCc2a", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iX1XL = parcelRequire("iX1XL");

const $3783e719317347ac$var$EMPTY = {};
const $3783e719317347ac$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState($3783e719317347ac$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        let aborted = false;
        setMessages($3783e719317347ac$var$EMPTY);
        (0, $iX1XL.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $3783e719317347ac$var$MessagesIntlProvider = (props)=>{
    const { intl: intl, children: children } = props;
    const messages = $3783e719317347ac$var$useI18n(intl.locale);
    const mergedMessages = (0, $cozmU.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        locale: intl.locale,
        messages: mergedMessages
    }, children);
};
const $3783e719317347ac$var$_default_1 = (0, $kSwu1.injectIntl)($3783e719317347ac$var$MessagesIntlProvider);
var $3783e719317347ac$export$2e2bcd8739ae039 = $3783e719317347ac$var$_default_1;
module.exports["default"] = $3783e719317347ac$export$2e2bcd8739ae039;

});

parcelRegister("iX1XL", function(module, exports) {
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 





























const $792857de5d56fcc9$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("6npt8")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("gDFuO")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("68pf5")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("hHGlo")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("f1C0z")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("3gTwX")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("6pI2S")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("2ZlOL")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("8T8Ab")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("6nJ4E")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("5IoA9")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("g1CsZ")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("aZGmw")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("fOV60")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("g75fo")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("4yIMZ")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("1bALo")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("dhear")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("yo5gM")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("dbxCp")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("3E3J9")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("2tXi9")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("cCZAe")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("btBWb")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("kU1Eg")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("ePEp4")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("25Xis")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("79I5G")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("ibtYk")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $792857de5d56fcc9$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("hHGlo")).then((mod)=>mod.default);
            }
    }
};
module.exports["getMessagesForLocale"] = $792857de5d56fcc9$export$d0a3169680473b6c;

});

parcelRegister("6npt8", function(module, exports) {

let $4a48a5a7336ef556$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a48a5a7336ef556$var$load("aQPG0").then(()=>parcelRequire('kNAr6'));

});

parcelRegister("gDFuO", function(module, exports) {

let $c1d07a1d592a63c6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c1d07a1d592a63c6$var$load("bkZFg").then(()=>parcelRequire('iQITF'));

});

parcelRegister("68pf5", function(module, exports) {

let $47771203695ddf00$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $47771203695ddf00$var$load("55jRH").then(()=>parcelRequire('4Y6NR'));

});

parcelRegister("hHGlo", function(module, exports) {

let $ce374c76d2f1e237$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ce374c76d2f1e237$var$load("7gZXw").then(()=>parcelRequire('44AgC'));

});

parcelRegister("f1C0z", function(module, exports) {

let $af046eaa9eb40603$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $af046eaa9eb40603$var$load("b3SDM").then(()=>parcelRequire('aAjDq'));

});

parcelRegister("3gTwX", function(module, exports) {

let $261df0f125d7ec52$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $261df0f125d7ec52$var$load("9yhAT").then(()=>parcelRequire('gebt4'));

});

parcelRegister("6pI2S", function(module, exports) {

let $4ab73e5e45bd9c3a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ab73e5e45bd9c3a$var$load("cdSjM").then(()=>parcelRequire('66D3r'));

});

parcelRegister("2ZlOL", function(module, exports) {

let $22d233da3d024f10$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $22d233da3d024f10$var$load("d5cjH").then(()=>parcelRequire('5GOkE'));

});

parcelRegister("8T8Ab", function(module, exports) {

let $678a1e1a8fa5b9ec$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $678a1e1a8fa5b9ec$var$load("cM3qB").then(()=>parcelRequire('4kDHd'));

});

parcelRegister("6nJ4E", function(module, exports) {

let $4a57dacc74badc26$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a57dacc74badc26$var$load("ju3RT").then(()=>parcelRequire('2EVaB'));

});

parcelRegister("5IoA9", function(module, exports) {

let $429421467dc9e033$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $429421467dc9e033$var$load("eKgTI").then(()=>parcelRequire('c7qHA'));

});

parcelRegister("g1CsZ", function(module, exports) {

let $baaa94056a83aeca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $baaa94056a83aeca$var$load("4SiFB").then(()=>parcelRequire('bikcP'));

});

parcelRegister("aZGmw", function(module, exports) {

let $80107625e0a4f412$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $80107625e0a4f412$var$load("3sB8d").then(()=>parcelRequire('kuHNn'));

});

parcelRegister("fOV60", function(module, exports) {

let $b847d096a5dfc710$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b847d096a5dfc710$var$load("cufjc").then(()=>parcelRequire('gF7hG'));

});

parcelRegister("g75fo", function(module, exports) {

let $bbb15ec44325a35c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bbb15ec44325a35c$var$load("hPzC3").then(()=>parcelRequire('dffVf'));

});

parcelRegister("4yIMZ", function(module, exports) {

let $351d149a8785bd34$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $351d149a8785bd34$var$load("cjMnf").then(()=>parcelRequire('6FAuN'));

});

parcelRegister("1bALo", function(module, exports) {

let $0dd355f3ec300f90$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0dd355f3ec300f90$var$load("bdFVZ").then(()=>parcelRequire('5e6r7'));

});

parcelRegister("dhear", function(module, exports) {

let $9aa7da3b13e70e6f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9aa7da3b13e70e6f$var$load("73TPf").then(()=>parcelRequire('ag0hm'));

});

parcelRegister("yo5gM", function(module, exports) {

let $0675dbab9a2187ad$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0675dbab9a2187ad$var$load("84JCz").then(()=>parcelRequire('fK5Ez'));

});

parcelRegister("dbxCp", function(module, exports) {

let $99966165c3f9d8e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $99966165c3f9d8e1$var$load("e9I4V").then(()=>parcelRequire('cOlwg'));

});

parcelRegister("3E3J9", function(module, exports) {

let $2a77ffa9ff93ba5e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2a77ffa9ff93ba5e$var$load("11Tbc").then(()=>parcelRequire('g7siS'));

});

parcelRegister("2tXi9", function(module, exports) {

let $1cec4853d1711128$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1cec4853d1711128$var$load("9tJmD").then(()=>parcelRequire('khkji'));

});

parcelRegister("cCZAe", function(module, exports) {

let $9318cdcec3856db5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9318cdcec3856db5$var$load("15Pfi").then(()=>parcelRequire('9Bj7P'));

});

parcelRegister("btBWb", function(module, exports) {

let $85afd4b72e7d87e4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $85afd4b72e7d87e4$var$load("5JkSw").then(()=>parcelRequire('8DnOd'));

});

parcelRegister("kU1Eg", function(module, exports) {

let $f37a50eefde1b8b9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f37a50eefde1b8b9$var$load("8yuuY").then(()=>parcelRequire('dD65A'));

});

parcelRegister("ePEp4", function(module, exports) {

let $acc52b641fad9633$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $acc52b641fad9633$var$load("gYFls").then(()=>parcelRequire('eZJS0'));

});

parcelRegister("25Xis", function(module, exports) {

let $186a0b79be7dcc0f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $186a0b79be7dcc0f$var$load("4tohK").then(()=>parcelRequire('d7z8J'));

});

parcelRegister("79I5G", function(module, exports) {

let $535b932ba5103996$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $535b932ba5103996$var$load("iXqHo").then(()=>parcelRequire('d1XXs'));

});

parcelRegister("ibtYk", function(module, exports) {

let $d3d080e86badaf7d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d3d080e86badaf7d$var$load("lcic8").then(()=>parcelRequire('9U3K8'));

});

parcelRegister("jItb7", function(module, exports) {
var $96c0d04f40ba3ed5$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["USER"] = "USER";
    EntityType["TEAM"] = "TEAM";
    EntityType["GROUP"] = "GROUP";
    return EntityType;
}({});
var $96c0d04f40ba3ed5$export$ef0ef29634e52a6b = /*#__PURE__*/ function(UserEntityType) {
    UserEntityType["DEFAULT"] = "DEFAULT";
    UserEntityType["APP"] = "APP";
    UserEntityType["CUSTOMER"] = "CUSTOMER";
    UserEntityType["SYSTEM"] = "SYSTEM";
    return UserEntityType;
}({});
module.exports["EntityType"] = $96c0d04f40ba3ed5$export$8eda7e02f8f033b2;
module.exports["UserEntityType"] = $96c0d04f40ba3ed5$export$ef0ef29634e52a6b;

});

parcelRegister("b9heI", function(module, exports) {

var $cMfSg = parcelRequire("cMfSg");


var $gh5tj = parcelRequire("gh5tj");

const $a24728959ef3490f$var$getUserRecommendations = (request, intl)=>{
    const url = (0, $gh5tj.config).getRecommendationServiceUrl(request.baseUrl || '');
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: request.context,
            includeUsers: request.includeUsers,
            includeGroups: request.includeGroups,
            includeTeams: request.includeTeams,
            includeNonLicensedUsers: request.includeNonLicensedUsers,
            maxNumberOfResults: request.maxNumberOfResults,
            performSearchQueryOnly: false,
            searchQuery: {
                ...request.verifiedTeams === true && {
                    isVerifiedTeamFilter: true
                },
                ...request.isTeamSyncedToGroupDirectoryFilter === true && {
                    isTeamSyncedToGroupDirectoryFilter: true
                },
                cpusQueryHighlights: {
                    query: '',
                    field: ''
                },
                ...request.context?.productAttributes?.isEntitledConfluenceExternalCollaborator && {
                    productAccessPermissionIds: [
                        'write',
                        'external-collaborator-write'
                    ]
                },
                customQuery: '',
                customerDirectoryId: '',
                filter: request.searchQueryFilter || '',
                minimumAccessLevel: 'APPLICATION',
                queryString: request.query,
                restrictTo: request.restrictTo || {
                    userIds: [],
                    groupIds: []
                },
                searchUserbase: false,
                searchEmail: request.searchEmail
            }
        })
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling smart service, statusCode=${response.status}, statusText=${response.statusText}`,
            statusCode: response.status
        });
    }).then((response)=>(0, $cMfSg.transformUsers)(response, intl));
};
var $a24728959ef3490f$export$2e2bcd8739ae039 = $a24728959ef3490f$var$getUserRecommendations;
module.exports["default"] = $a24728959ef3490f$export$2e2bcd8739ae039;

});

parcelRegister("cMfSg", function(module, exports) {

var $9kYT2 = parcelRequire("9kYT2");


var $4oxIw = parcelRequire("4oxIw");


var $jItb7 = parcelRequire("jItb7");


var $ixfCV = parcelRequire("ixfCV");

const $9b431fcf90cc0132$var$getLozenzeProperties = (entity, intl)=>{
    if (entity.attributes?.workspaceMember) return intl.formatMessage((0, $4oxIw.messages).memberLozengeText);
    if (entity.attributes?.isConfluenceExternalCollaborator) {
        const lozengeTooltipMessage = entity.entityType === (0, $jItb7.EntityType).GROUP ? (0, $4oxIw.messages).guestGroupLozengeTooltip : (0, $4oxIw.messages).guestUserLozengeTooltip;
        return {
            text: intl.formatMessage((0, $4oxIw.messages).guestLozengeText),
            tooltip: intl.formatMessage(lozengeTooltipMessage),
            appearance: 'default'
        };
    }
    const isJiraGuestUser = (0, $ixfCV.fg)('user_picker_guest_lozenges') && entity.attributes?.isJiraGuest;
    if (isJiraGuestUser) return intl.formatMessage((0, $4oxIw.messages).guestLozengeText);
    return undefined;
};
const $9b431fcf90cc0132$var$transformUser = (item, intl)=>{
    const type = item.entityType;
    if (type === (0, $jItb7.EntityType).USER) {
        const user = item;
        const lozenge = $9b431fcf90cc0132$var$getLozenzeProperties(user, intl);
        return {
            id: user.id,
            type: user.nonLicensedUser ? (0, $9kYT2.ExternalUserType) : (0, $9kYT2.UserType),
            userType: user.userType,
            avatarUrl: user.avatarUrl,
            name: user.name,
            email: user.email,
            title: user.title,
            lozenge: lozenge,
            tooltip: user.name,
            isExternal: Boolean(user.nonLicensedUser),
            sources: user.nonLicensedUser ? [
                'other-atlassian'
            ] : undefined,
            appType: user.appType !== undefined ? user.appType : user.attributes?.appType
        };
    }
    if (type === (0, $jItb7.EntityType).TEAM) {
        const team = item;
        return {
            id: team.id,
            type: (0, $9kYT2.TeamType),
            description: team.description || '',
            name: team.displayName || '',
            memberCount: team.memberCount,
            members: team.members,
            includesYou: team.includesYou,
            avatarUrl: team.largeAvatarImageUrl || team.smallAvatarImageUrl,
            tooltip: team.displayName,
            verified: team.verified,
            teamTypeName: team.type?.name,
            state: team.state
        };
    }
    if (type === (0, $jItb7.EntityType).GROUP) {
        const group = item;
        const lozenge = $9b431fcf90cc0132$var$getLozenzeProperties(group, intl);
        return {
            id: group.id,
            type: (0, $9kYT2.GroupType),
            name: group.name || '',
            lozenge: lozenge
        };
    }
    return;
};
const $9b431fcf90cc0132$export$fb8c90bfc4beaa59 = (serverResponse, intl)=>(serverResponse.recommendedUsers || []).map((item)=>$9b431fcf90cc0132$var$transformUser(item, intl)).filter((user)=>!!user).map((user)=>user);
module.exports["transformUsers"] = $9b431fcf90cc0132$export$fb8c90bfc4beaa59;

});

parcelRegister("4oxIw", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $9369811f0ae39467$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    externalUserSourcesHeading: {
        id: "fabric.elements.user-picker.external.sourced.from",
        defaultMessage: "Found in:"
    },
    slackProvider: {
        id: "fabric.elements.user-picker.slack.provider",
        defaultMessage: "Slack"
    },
    googleProvider: {
        id: "fabric.elements.user-picker.google.provider",
        defaultMessage: "Google"
    },
    microsoftProvider: {
        id: "fabric.elements.user-picker.microsoft.provider",
        defaultMessage: "Microsoft"
    },
    gitHubProvider: {
        id: "fabric.elements.user-picker.github.provider",
        defaultMessage: "GitHub"
    },
    memberLozengeText: {
        id: "fabric.elements.user-picker.member.lozenge.text",
        defaultMessage: "MEMBER"
    },
    guestLozengeText: {
        id: "fabric.elements.user-picker.guest.lozenge.text",
        defaultMessage: "GUEST"
    },
    guestUserLozengeTooltip: {
        id: "fabric.elements.user-picker.guest.lozenge.tooltip.user",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    },
    guestGroupLozengeTooltip: {
        id: "fabric.elements.user-picker.guest.lozenge.tooltip.group",
        defaultMessage: "Guest groups can only access certain spaces and have limited access to user info."
    }
});
module.exports["messages"] = $9369811f0ae39467$export$defe85febe8b728c;

});

parcelRegister("gh5tj", function(module, exports) {
const $35b9c4aa02694e21$export$e506a1d27d1eaa20 = {
    getRecommendationServiceUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
    },
    getUsersServiceUrl (productKey, baseUrl = '') {
        return productKey === 'jira' ? `${baseUrl}/rest/api/3/user/bulk` : `${baseUrl}/wiki/rest/api/user/bulk`;
    },
    getGraphQLUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
    },
    getTeamsUrl (id, baseUrl, siteId) {
        return baseUrl ? `${baseUrl}/gateway/api/v4/teams/${id}?siteId=${siteId ?? 'None'}` : `/gateway/api/v4/teams/${id}?siteId=${siteId ?? 'None'}`;
    }
};
module.exports["config"] = $35b9c4aa02694e21$export$e506a1d27d1eaa20;

});

parcelRegister("uUDXo", function(module, exports) {

var $9kYT2 = parcelRequire("9kYT2");


var $gh5tj = parcelRequire("gh5tj");


var $2Pcx3 = parcelRequire("2Pcx3");


var $7okd1 = parcelRequire("7okd1");


var $532Sr = parcelRequire("532Sr");

const $e67531141dda4e4c$var$getHydratedUsersFromProducts = (request)=>{
    const url = `${(0, $gh5tj.config).getUsersServiceUrl(request.productKey, request.baseUrl)}`;
    let params = new URLSearchParams();
    request.accountIds.map((id)=>params.append('accountId', id));
    params.append('maxResults', '2000');
    return fetch(`${url}?${params}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        }
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling users service, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then(request.productKey === 'jira' ? $e67531141dda4e4c$var$transformJiraUsers : $e67531141dda4e4c$var$transformConfluenceUsers);
};
const $e67531141dda4e4c$var$transformJiraUsers = (userResponse)=>userResponse.values.map($e67531141dda4e4c$var$transformJiraUser).filter((user)=>!!user).map((user)=>user);
const $e67531141dda4e4c$var$transformJiraUser = (item)=>{
    if (!item) return null;
    return {
        id: item.accountId,
        type: (0, $9kYT2.UserType),
        avatarUrl: item.avatarUrls ? item.avatarUrls['16x16'] : '',
        name: item.displayName,
        email: item.emailAddress
    };
};
const $e67531141dda4e4c$var$transformConfluenceUsers = (userResponse)=>userResponse.results.map($e67531141dda4e4c$var$transformConfluenceUser).filter((user)=>!!user).map((user)=>user);
const $e67531141dda4e4c$var$transformConfluenceUser = (item)=>{
    if (!item) return null;
    return {
        id: item.accountId,
        type: (0, $9kYT2.UserType),
        avatarUrl: item.profilePicture ? item.profilePicture.path : '',
        name: item.publicName,
        email: item.email
    };
};
const $e67531141dda4e4c$var$sortResults = (options, sortIds)=>{
    const resultsMap = new Map(options.map((option)=>[
            option && option.id,
            option
        ]));
    return sortIds.map((option)=>{
        const user = resultsMap.get(option.id);
        if (user) return user;
        return {
            id: option.id,
            type: option.type,
            name: (0, $532Sr.UNKNOWN)
        };
    });
};
const $e67531141dda4e4c$var$isOptionData = (option)=>{
    return option.name !== undefined;
};
const $e67531141dda4e4c$var$hydrateTeamIds = async (baseUrl, values, siteId)=>{
    if (values.length === 0) return [];
    const legionPromises = values.map((value)=>(0, $7okd1.default)({
            baseUrl: baseUrl,
            id: value.id,
            siteId: siteId
        }));
    return await Promise.all(legionPromises);
};
const $e67531141dda4e4c$var$hydrateAccountIds = async (baseUrl, productKey, values, atlAttributes)=>{
    if (values.length === 0) return [];
    const accountIds = values.map((val)=>val.id);
    //if we are not jira or confluence then use PRS platform hydration
    return productKey === 'jira' || productKey === 'confluence' ? await $e67531141dda4e4c$var$getHydratedUsersFromProducts({
        baseUrl: baseUrl,
        productKey: productKey,
        accountIds: accountIds
    }) : await (0, $2Pcx3.default)(baseUrl, accountIds, {
        product: productKey,
        ...atlAttributes
    });
};
async function $e67531141dda4e4c$var$hydrateDefaultValues(baseUrl, value, productKey, siteId, atlAttributes) {
    //return if no value
    if (!value || Array.isArray(value) && value.length === 0) return [];
    const values = Array.isArray(value) ? value : [
        value
    ];
    // return if all hydrated
    if (!values.some((val)=>!$e67531141dda4e4c$var$isOptionData(val))) return value;
    const [hydratedUsers, hydratedTeams] = await Promise.all([
        $e67531141dda4e4c$var$hydrateAccountIds(baseUrl, productKey, values.filter((val)=>!$e67531141dda4e4c$var$isOptionData(val) && val.type === 'user'), atlAttributes),
        $e67531141dda4e4c$var$hydrateTeamIds(baseUrl, values.filter((val)=>!$e67531141dda4e4c$var$isOptionData(val) && val.type === 'team'), siteId)
    ]);
    const hydratedOptions = values.filter((val)=>$e67531141dda4e4c$var$isOptionData(val)).map((val)=>val).concat(hydratedUsers).concat(hydratedTeams);
    return $e67531141dda4e4c$var$sortResults(hydratedOptions, values);
}
var $e67531141dda4e4c$export$2e2bcd8739ae039 = $e67531141dda4e4c$var$hydrateDefaultValues;
module.exports["default"] = $e67531141dda4e4c$export$2e2bcd8739ae039;

});

parcelRegister("2Pcx3", function(module, exports) {

var $532Sr = parcelRequire("532Sr");


var $h2zzp = parcelRequire("h2zzp");


var $gh5tj = parcelRequire("gh5tj");

/**
 * @param  {string} accountIds ids to hydrate
 * @return GraphQL Query
 */ const $dd0e88f689d12292$var$buildUsersQuery = (accountIds)=>({
        query: `query usersQuery($accountIds: [ID!]!) {
    users(accountIds: $accountIds) {
      name
      accountId
      picture
    }
  }`,
        variables: {
            accountIds: accountIds
        }
    });
const $dd0e88f689d12292$var$makeRequest = async (url, accountIds, attributionData)=>{
    const query = $dd0e88f689d12292$var$buildUsersQuery(accountIds);
    return await (0, $h2zzp.graphqlQuery)(url, query, attributionData);
};
const $dd0e88f689d12292$var$modifyResponse = (users)=>users.map(({ accountId: accountId, name: name, picture: picture })=>({
            avatarUrl: picture,
            id: accountId,
            name: name,
            type: 'user'
        }));
const $dd0e88f689d12292$var$getHydratedUsers = (baseUrl, userIds, attributionData)=>{
    const url = (0, $gh5tj.config).getGraphQLUrl(baseUrl);
    return new Promise((resolve)=>{
        $dd0e88f689d12292$var$makeRequest(url, userIds, attributionData).then((data)=>{
            resolve($dd0e88f689d12292$var$modifyResponse(data.users));
        }).catch(()=>{
            // on network error, return original list with label 'Unknown'
            resolve(userIds.map((id)=>({
                    ...(0, $532Sr.UNKNOWN_USER),
                    id: id
                })));
        });
    });
};
var $dd0e88f689d12292$export$2e2bcd8739ae039 = $dd0e88f689d12292$var$getHydratedUsers;
module.exports["default"] = $dd0e88f689d12292$export$2e2bcd8739ae039;

});

parcelRegister("532Sr", function(module, exports) {
const $6db3863417a51977$export$78244dbb77cfa6b6 = 'Unknown';
const $6db3863417a51977$export$d1f5101c0939e3fe = {
    id: $6db3863417a51977$export$78244dbb77cfa6b6,
    name: $6db3863417a51977$export$78244dbb77cfa6b6,
    type: 'user'
};
const $6db3863417a51977$export$8144dcfc9025ca57 = {
    id: $6db3863417a51977$export$78244dbb77cfa6b6,
    name: $6db3863417a51977$export$78244dbb77cfa6b6,
    type: 'team'
};
module.exports["UNKNOWN"] = $6db3863417a51977$export$78244dbb77cfa6b6;
module.exports["UNKNOWN_USER"] = $6db3863417a51977$export$d1f5101c0939e3fe;
module.exports["UNKNOWN_TEAM"] = $6db3863417a51977$export$8144dcfc9025ca57;

});

parcelRegister("h2zzp", function(module, exports) {

var $bI2Ez = parcelRequire("bI2Ez");

const $cb73305b812b5ba3$var$buildHeaders = (attributionData)=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    const atlAttributionHeader = (0, $bI2Ez.createAtlAttributionHeader)(attributionData);
    headers.append('atl-attribution', atlAttributionHeader['atl-attribution']);
    return headers;
};
function $cb73305b812b5ba3$export$74eb8d79ae3e02b5(serviceUrl, query, attributionData) {
    const headers = $cb73305b812b5ba3$var$buildHeaders(attributionData);
    return fetch(new Request(`${serviceUrl}`, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    })).then((response)=>{
        if (!response.ok) return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
        return response;
    }).then((response)=>response.json()).then((json)=>{
        if (json.errors) return Promise.reject({
            reason: json.errors[0]?.category || 'default'
        });
        return json.data;
    });
}
module.exports["graphqlQuery"] = $cb73305b812b5ba3$export$74eb8d79ae3e02b5;

});

parcelRegister("bI2Ez", function(module, exports) {
/**
 * Utility for creating the atl-attribution header for AGG requests
 * Reference: https://hello.atlassian.net/wiki/spaces/AGG/pages/5954141702/Metrics+Attribution+Onboarding+Doc+for+AGG+Clients
 */ function $de0a2e7a5a86c4fd$export$14ef296862e3705e({ product: product = 'platform', activationId: activationId, ...props } = {}) {
    const headerData = {
        service: 'smart-experiences/smart-user-picker',
        product: product,
        atlWorkspaceId: activationId && props.tenantId ? `ari:cloud:${product}:${props.tenantId}:workspace/${activationId}` : undefined,
        ...props
    };
    return {
        'atl-attribution': JSON.stringify(headerData)
    };
}
module.exports["createAtlAttributionHeader"] = $de0a2e7a5a86c4fd$export$14ef296862e3705e;

});

parcelRegister("7okd1", function(module, exports) {

var $gh5tj = parcelRequire("gh5tj");


var $532Sr = parcelRequire("532Sr");

const $b51f40c08b009007$var$transformTeam = (team, id)=>{
    return {
        id: id,
        name: team.displayName,
        type: 'team',
        avatarUrl: team.smallAvatarImageUrl,
        ...team.state && {
            state: team.state
        }
    };
};
const $b51f40c08b009007$var$hydrateTeamFromLegion = (request)=>{
    const url = (0, $gh5tj.config).getTeamsUrl(request.id, request.baseUrl, request.siteId);
    return fetch(url, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        }
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling Legion, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then((response)=>{
        return $b51f40c08b009007$var$transformTeam(response, request.id);
    }).catch(()=>({
            ...(0, $532Sr.UNKNOWN_TEAM),
            id: request.id
        }));
};
var $b51f40c08b009007$export$2e2bcd8739ae039 = $b51f40c08b009007$var$hydrateTeamFromLegion;
module.exports["default"] = $b51f40c08b009007$export$2e2bcd8739ae039;

});

parcelRegister("7GkXv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fh15z = parcelRequire("fh15z");

var $4MiWC = parcelRequire("4MiWC");

var $j7Sza = parcelRequire("j7Sza");

const $d95d43c2c4127308$var$COMPONENT_NAME = 'smart-user-picker';
const $d95d43c2c4127308$export$df77da4c0210f1c1 = new (0, $fh15z.ConcurrentExperience)('smart-user-picker-rendered', {
    platform: {
        component: $d95d43c2c4127308$var$COMPONENT_NAME
    },
    type: (0, $4MiWC.ExperienceTypes).Load,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).PageSegmentLoad
});
const $d95d43c2c4127308$export$a0e7cca3ab9586eb = new (0, $fh15z.ConcurrentExperience)('smart-user-picker-options-shown', {
    platform: {
        component: $d95d43c2c4127308$var$COMPONENT_NAME
    },
    type: (0, $4MiWC.ExperienceTypes).Operation,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).InlineResult
});
const $d95d43c2c4127308$export$e5e0512991825310 = (experience, id)=>{
    const experienceForId = experience.getInstance(id);
    // Equivalent to componentWillMount - replace with @atlaskit/ufo's
    // useUFOComponentExperience when it supports ConcurrentExperience.
    (0, $cozmU.useState)(()=>{
        experienceForId.start();
    });
    // Replace with @atlaskit/ufo's <ExperienceSuccess> when it supports ConcurrentExperience
    (0, $cozmU.useEffect)(()=>{
        if (experienceForId.state !== (0, $j7Sza.UFOExperienceState)['FAILED']) experienceForId.success();
        return ()=>{
            if ([
                (0, $j7Sza.UFOExperienceState)['STARTED'],
                (0, $j7Sza.UFOExperienceState)['IN_PROGRESS']
            ].includes(experienceForId.state)) experienceForId.abort();
        };
    // We only want this useEffect to run once after component mount, so no deps are needed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
class $d95d43c2c4127308$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidCatch() {
        $d95d43c2c4127308$export$df77da4c0210f1c1.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}
module.exports["smartUserPickerRenderedUfoExperience"] = $d95d43c2c4127308$export$df77da4c0210f1c1;
module.exports["smartUserPickerOptionsShownUfoExperience"] = $d95d43c2c4127308$export$a0e7cca3ab9586eb;
module.exports["useUFOConcurrentExperience"] = $d95d43c2c4127308$export$e5e0512991825310;
module.exports["UfoErrorBoundary"] = $d95d43c2c4127308$export$5ef1c2550074a375;

});

parcelRegister("83Z6R", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7EPz1 = parcelRequire("7EPz1");


var $86okN = parcelRequire("86okN");

const $b847dc1d37d68706$export$dcf9d4e77de27956 = (0, $3u0dr.isReactCompilerActiveV2)() ? function useLazyQueryPromiseInterop(query, options) {
    const $ = (0, $bDgLe.c)(11);
    const resolversRef = (0, $cozmU.useRef)();
    let t0;
    if ($[0] !== query) {
        t0 = (0, $86okN.toDocumentNode)(query);
        $[0] = query;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== options || $[3] !== t0) {
        t1 = [
            t0,
            options
        ];
        $[2] = options;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    const [doQuery, t2] = (0, $7EPz1.useLazyQuery)(...t1);
    const { data: data, error: error } = t2;
    let t3;
    let t4;
    if ($[5] !== data || $[6] !== error) {
        t3 = ()=>{
            if (data) resolversRef.current?.resolve?.(data);
            if (error) resolversRef.current?.reject?.(error);
        };
        t4 = [
            data,
            error
        ];
        $[5] = data;
        $[6] = error;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[9] !== doQuery) {
        t5 = (vars)=>{
            let resolve;
            let reject;
            const promise = new Promise((res, rej)=>{
                resolve = res;
                reject = rej;
            });
            resolversRef.current = {
                resolve: resolve,
                reject: reject
            };
            doQuery(vars);
            return promise;
        };
        $[9] = doQuery;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
} : function useLazyQueryPromiseInterop(query, options) {
    const resolversRef = (0, $cozmU.useRef)();
    /**
   * NOTE: Using `onCompleted` and `onError` callbacks does not work as expected due to Apollo bug which is present in both v2 and v3 - https://github.com/apollographql/apollo-client/issues/9338
   */ const [doQuery, { data: data, error: error }] = (0, $7EPz1.useLazyQuery)(...[
        (0, $86okN.toDocumentNode)(query),
        options
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (data) resolversRef.current?.resolve?.(data);
        if (error) resolversRef.current?.reject?.(error);
    }, [
        data,
        error
    ]);
    return (0, $cozmU.useCallback)((vars)=>{
        let resolve;
        let reject;
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        // @ts-expect-error `resolve` and `reject` *will* be assigned via the Promise constructor, but TS can't guarantee that. This should be replaced with `Promise.withResolvers` once out jest setup properly supports that
        resolversRef.current = {
            resolve: resolve,
            reject: reject
        };
        doQuery(vars);
        return promise;
    }, [
        doQuery
    ]);
};
module.exports["useLazyQueryPromiseInterop"] = $b847dc1d37d68706$export$dcf9d4e77de27956;

});

parcelRegister("jjoF2", function(module, exports) {

var $9fywD = parcelRequire("9fywD");


var $11dKl = parcelRequire("11dKl");


var $9eE57 = parcelRequire("9eE57");


var $g3p2i = parcelRequire("g3p2i");

const $9d3a4572140e810a$export$c139484855007019 = ({ searchTerm: searchTerm, queryData: queryData, customInclusion: customInclusion, setError: setError, filterResults: filterResults })=>{
    const subject = 'userAndGroupSearchQuery';
    (0, $9eE57.perfMarkStart)({
        subject: subject
    });
    return queryData.then((data)=>{
        const { users: users = [], groups: groups = [] } = data.userGroupSearch ?? {};
        const userList = users.map((item)=>({
                id: `user-${item && 'accountId' in item ? item.accountId : ''}`,
                name: item?.displayName || '',
                extra: item,
                type: 'user',
                avatarUrl: item?.profilePicture ? item.profilePicture.path : '',
                lozenge: // ExternalUserLozengeProps type has same name as the one provided by @atlaskit/user-picker but different properties.
                // casting for now to avoid TS error, no change to original properties
                item?.permissionType === (0, $g3p2i.SitePermissionType).EXTERNAL ? (0, $9fywD.ExternalUserLozengeProps) : null
            }));
        const groupList = groups.map((item)=>({
                id: `group-${item?.id}`,
                name: item?.name || '',
                type: 'group',
                extra: item,
                lozenge: // ExternalUserLozengeProps type has same name as the one provided by @atlaskit/user-picker but different properties.
                // casting for now to avoid TS error, no change to original properties
                item?.permissionType === (0, $g3p2i.SitePermissionType).EXTERNAL ? (0, $11dKl.ExternalGroupLozengeProps) : null
            }));
        const customInclusionList = [];
        const cleanedSearchTerm = searchTerm.replace(/\s/g, '').toLowerCase();
        customInclusion.forEach((inclusionObj)=>{
            Object.keys(inclusionObj).forEach((key)=>{
                if (key.toLowerCase().includes(cleanedSearchTerm)) customInclusionList.push(inclusionObj[key]);
            });
        });
        const usersGroupsAndAccessClasses = [
            ...customInclusionList,
            ...userList,
            ...groupList
        ];
        (0, $9eE57.perfMarkEnd)({
            subject: subject
        });
        return filterResults ? usersGroupsAndAccessClasses.filter(filterResults) : usersGroupsAndAccessClasses;
    }).catch((error)=>{
        setError(error);
        return [];
    });
};
module.exports["userGroupSearchPromise"] = $9d3a4572140e810a$export$c139484855007019;

});

parcelRegister("11dKl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9KSWX = parcelRequire("9KSWX");


var $lpNn5 = parcelRequire("lpNn5");

const $f9006b515271a00f$var$i18n = (0, $kSwu1.defineMessages)({
    externalGroupLozengeText: {
        id: "external-collab-ui.group-guest-lozenge",
        defaultMessage: "Guest"
    },
    externalGroupTooltip: {
        id: "external-collab-ui.group-guest-lozenge.tooltip",
        defaultMessage: "Guest groups can only access certain spaces and have limited access to user info."
    }
});
const $f9006b515271a00f$export$fef38ba78dbe85a6 = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f9006b515271a00f$var$i18n.externalGroupTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f9006b515271a00f$var$i18n.externalGroupLozengeText)),
    appearance: 'new',
    isBold: false
};
const $f9006b515271a00f$export$e899659b70340bcf = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $f9006b515271a00f$export$fef38ba78dbe85a6;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalGroupLozengeProps"] = $f9006b515271a00f$export$fef38ba78dbe85a6;

});

parcelRegister("g3p2i", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $fc6a2e7c662c45f6$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
var $fc6a2e7c662c45f6$export$3347a7c058a0368a = /*#__PURE__*/ function(SitePermissionTypeFilter) {
    SitePermissionTypeFilter["ALL"] = "ALL";
    SitePermissionTypeFilter["EXTERNALCOLLABORATOR"] = "EXTERNALCOLLABORATOR";
    SitePermissionTypeFilter["NONE"] = "NONE";
    return SitePermissionTypeFilter;
}({});
module.exports["SitePermissionType"] = $fc6a2e7c662c45f6$export$8995abb8169b2cb8;
module.exports["SitePermissionTypeFilter"] = $fc6a2e7c662c45f6$export$3347a7c058a0368a;

});

parcelRegister("VQdE0", function(module, exports) {
/**
 * @generated SignedSource<<d8c13f003578e6757b54483ce7e2bebb>>
 * @relayHash 8824351f0529abac5573900b2bee2db5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f8b43e5b1993f0813a23a44917516743e194299c3565ccbf17994b391776751
const $3fbecf5b2b9bf0ac$var$node = function() {
    var v0 = {
        "defaultValue": 50,
        "kind": "LocalArgument",
        "name": "maxResults"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchTerm"
    }, v2 = {
        "defaultValue": "NONE",
        "kind": "LocalArgument",
        "name": "sitePermissionTypeFilter"
    }, v3 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "withGroups"
    }, v4 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "withUsers"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "maxResults",
            "variableName": "maxResults"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "searchTerm"
        },
        {
            "kind": "Variable",
            "name": "sitePermissionTypeFilter",
            "variableName": "sitePermissionTypeFilter"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v11 = {
        "condition": "withGroups",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "Group",
                "kind": "LinkedField",
                "name": "groups",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    v8 /*: any*/ 
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "UserAndGroupSearchQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "GraphQLUserAndGroupSearchResults",
                    "kind": "LinkedField",
                    "name": "userGroupSearch",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "withUsers",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "users",
                                    "plural": true,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v11 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "UserAndGroupSearchQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "GraphQLUserAndGroupSearchResults",
                    "kind": "LinkedField",
                    "name": "userGroupSearch",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "withUsers",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "users",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v11 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "8824351f0529abac5573900b2bee2db5",
            "id": "2f8b43e5b1993f0813a23a44917516743e194299c3565ccbf17994b391776751",
            "metadata": {},
            "name": "UserAndGroupSearchQuery",
            "operationKind": "query",
            "text": "query UserAndGroupSearchQuery($searchTerm:String!,$maxResults:Int=50,$withGroups:Boolean=true,$withUsers:Boolean=true,$sitePermissionTypeFilter:SitePermissionTypeFilter=NONE){userGroupSearch(query:$searchTerm,maxResults:$maxResults,sitePermissionTypeFilter:$sitePermissionTypeFilter){users@include(if:$withUsers){__typename,type,displayName,permissionType,profilePicture{path},...on KnownUser{accountId}},groups@include(if:$withGroups){id,name,permissionType}}}"
        }
    };
}();
$3fbecf5b2b9bf0ac$var$node.hash = "52200fecbeb2441b36c8ceb106bad130";
var $3fbecf5b2b9bf0ac$export$2e2bcd8739ae039 = $3fbecf5b2b9bf0ac$var$node;
module.exports["default"] = $3fbecf5b2b9bf0ac$export$2e2bcd8739ae039;

});

parcelRegister("e6Ach", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $3X3EV = parcelRequire("3X3EV");


var $iWhnp = parcelRequire("iWhnp");


var $2qYWP = parcelRequire("2qYWP");

const $bfdefd8cab144f9e$var$CreatableSelect = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
    const creatableProps = (0, $2qYWP.default)(props);
    const selectProps = (0, $iWhnp.default)(creatableProps);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3X3EV.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$bfdefd8cab144f9e$export$2e2bcd8739ae039 = $bfdefd8cab144f9e$var$CreatableSelect;
module.exports["default"] = $bfdefd8cab144f9e$export$2e2bcd8739ae039;

});

parcelRegister("iWhnp", function(module, exports) {
$parcel$export(module.exports, "default", () => $8107ecf375dbb21a$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $bJjSn = parcelRequire("bJjSn");

var $kskvm = parcelRequire("kskvm");


var $hNobR = parcelRequire("hNobR");


var $aeRIw = parcelRequire("aeRIw");

const $8107ecf375dbb21a$var$compareOption = (inputValue = '', option, accessors)=>{
    const candidate = String(inputValue).toLowerCase();
    const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
const $8107ecf375dbb21a$var$builtins = {
    formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
    isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$8107ecf375dbb21a$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$8107ecf375dbb21a$var$compareOption(inputValue, option, accessors))),
    getNewOptionData: (inputValue, optionLabel)=>({
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        })
};
function $8107ecf375dbb21a$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $8107ecf375dbb21a$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $8107ecf375dbb21a$var$builtins.isValidNewOption, getNewOptionData: //@ts-ignore
getNewOptionData = $8107ecf375dbb21a$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
    const { getOptionValue: getOptionValue = (0, $kskvm.getOptionValue), getOptionLabel: getOptionLabel = (0, $bJjSn.getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
    const newOption = (0, $cozmU.useMemo)(()=>isValidNewOption(inputValue, (0, $hNobR.cleanValue)(value), propsOptions, {
            getOptionValue: getOptionValue,
            getOptionLabel: getOptionLabel
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel,
        getOptionValue,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    const options = (0, $cozmU.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption,
            ...propsOptions
        ] : [
            ...propsOptions,
            newOption
        ] : propsOptions, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    const onChange = (0, $cozmU.useCallback)((newValue, actionMeta)=>{
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        const valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                const newOptionData = getNewOptionData(inputValue, inputValue);
                const newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $aeRIw.valueTernary)(isMulti, [
                    ...(0, $hNobR.cleanValue)(value),
                    newOptionData
                ], newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return {
        ...restSelectProps,
        options: options,
        onChange: onChange
    };
}

});

parcelRegister("dqxOF", function(module, exports) {
function $9c67ef4150ae4cb3$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $9c67ef4150ae4cb3$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $9c67ef4150ae4cb3$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $9c67ef4150ae4cb3$export$967a6b9924a689f7(a, b);
    return $9c67ef4150ae4cb3$export$3e67810a3f0e9f1c(a, b);
}
module.exports["shallowEqualObjects"] = $9c67ef4150ae4cb3$export$3e67810a3f0e9f1c;

});

parcelRegister("dDboE", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $6JrSr = parcelRequire("6JrSr");

const $92e077c22efcc597$export$6be90bcb437e928f = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, postfix: postfix = '', prefix: prefix = '' }, ref)=>{
    const id = `${prefix}${(0, $6JrSr.useId)()}${postfix}`;
    (0, $cozmU.useEffect)(()=>{
        if (!ref) return;
        switch(typeof ref){
            case 'function':
                ref(id);
                break;
            case 'object':
                ref.current = id;
                break;
            default:
                throw new Error(`Unreachable case for unsupported type of ref "${typeof ref}"`);
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: typeof children === 'function' ? children({
            id: id
        }) : children
    });
});
module.exports["IdProvider"] = $92e077c22efcc597$export$6be90bcb437e928f;

});

parcelRegister("hjygH", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $1aeb691895c5954d$export$85823f26dca064c3(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>{
            if (error) experienceTracker.stopOnError({
                name: name,
                error: error,
                attributes: attributes
            });
            else experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        };
        t2 = [
            experienceTracker,
            name,
            attributes,
            error
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceStop"] = $1aeb691895c5954d$export$85823f26dca064c3;

});

parcelRegister("k4HA2", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $73152d52b0fbce45$var$initialValue = {};
const $73152d52b0fbce45$export$b060d577040138d8 = (0, $cozmU.createContext)($73152d52b0fbce45$var$initialValue);
const $73152d52b0fbce45$export$42de33f7652dc3de = $73152d52b0fbce45$export$b060d577040138d8.Provider;
const $73152d52b0fbce45$export$a5b6d14a2e25725a = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($73152d52b0fbce45$export$b060d577040138d8);
} : ()=>(0, $cozmU.useContext)($73152d52b0fbce45$export$b060d577040138d8);
module.exports["MessageContextProvider"] = $73152d52b0fbce45$export$42de33f7652dc3de;
module.exports["useMessageContext"] = $73152d52b0fbce45$export$a5b6d14a2e25725a;

});

parcelRegister("82Ab4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");

const $ea8345716b24b21f$export$ba2f44035effd9c1 = /*#__PURE__*/ (0, $cozmU.createContext)({
    sessionId: undefined,
    entityId: undefined
});
const $ea8345716b24b21f$export$f60e87d7b5f59562 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { value: value, children: children } = t0;
    let t1;
    if ($[0] !== children || $[1] !== value) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
            data: value
        }, children);
        $[0] = children;
        $[1] = value;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1 || $[4] !== value) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ea8345716b24b21f$export$ba2f44035effd9c1.Provider, {
            value: value
        }, t1);
        $[3] = t1;
        $[4] = value;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ value: value, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ea8345716b24b21f$export$ba2f44035effd9c1.Provider, {
        value: value
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: value
    }, children));
};
const $ea8345716b24b21f$export$3321c0b02f750bcc = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($ea8345716b24b21f$export$ba2f44035effd9c1);
} : ()=>(0, $cozmU.useContext)($ea8345716b24b21f$export$ba2f44035effd9c1);
module.exports["RecommendationProvider"] = $ea8345716b24b21f$export$f60e87d7b5f59562;
module.exports["useRecommendationContext"] = $ea8345716b24b21f$export$3321c0b02f750bcc;

});

parcelRegister("6NRmI", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $bGVJw = parcelRequire("bGVJw");

var $jdpvF = parcelRequire("jdpvF");


var $2dA2p = parcelRequire("2dA2p");


var $ifV7w = parcelRequire("ifV7w");

// @twood: NEVER CHANGE THIS DEFAULT VALUE
const $a0a682275c4a0108$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED = true;
const $a0a682275c4a0108$var$choreographerLogger = (0, $2dA2p.createInBrowserDebugLogger)('Choreographer');
const $a0a682275c4a0108$var$defaultContext = {
    choreographerEnabled: $a0a682275c4a0108$var$DEFAULT_IS_CHOREOGRAPHER_ENABLED,
    setChoreographerEnabled: ()=>{},
    factory: undefined
};
const $a0a682275c4a0108$var$ChoreographerContext = /*#__PURE__*/ (0, $cozmU.createContext)($a0a682275c4a0108$var$defaultContext);
// Helper to automatically handle ESM and non-ESM imports (either is possible depending on the service/product's build configuration)
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */ const $a0a682275c4a0108$var$importHelper = (mod)=>{
    if (typeof mod.ChoreographerRegistry === 'function') {
        $a0a682275c4a0108$var$choreographerLogger.debug('Using CommonJS module format', {
            moduleType: 'CommonJS'
        });
        return mod.ChoreographerRegistry;
    } else if (typeof mod.default === 'function') {
        $a0a682275c4a0108$var$choreographerLogger.debug('Using ESM module format (browser)', {
            moduleType: 'ESM-browser'
        });
        return mod.default;
    } else if (typeof mod?.default === 'object' && typeof mod.default.ChoreographerRegistry === 'function') {
        $a0a682275c4a0108$var$choreographerLogger.debug('Using ESM module format (Node.js)', {
            moduleType: 'ESM-node'
        });
        return mod.default.ChoreographerRegistry;
    }
    $a0a682275c4a0108$var$choreographerLogger.warn('Using fallback module format', {
        moduleType: 'fallback'
    });
    return mod;
};

const $a0a682275c4a0108$export$e68b2c75bfb5682a = ({ children: children, choreographer: choreographer, placementId: placementId })=>{
    const [choreographerFactory, setChoreographerFactory] = (0, $cozmU.useState)(undefined);
    const [choreographerEnabled, setChoreographerEnabled] = (0, $cozmU.useState)(choreographer?.isDefaultEnabled ?? $a0a682275c4a0108$var$defaultContext.choreographerEnabled);
    const environmentContext = (0, $jdpvF.usePostOfficeEnvironment)();
    const context = (0, $bGVJw.usePostOfficeContext)();
    (0, $cozmU.useEffect)(()=>{
        if ((0, $ifV7w.shouldBypassChoreographerFromDevtools)()) setChoreographerEnabled(false);
    }, [
        setChoreographerEnabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (choreographerEnabled) // eslint-disable-next-line import/dynamic-import-chunkname
        (parcelRequire("bszpu")).then((m)=>{
            const ChoreographerRegistryClass = $a0a682275c4a0108$var$importHelper(m);
            setChoreographerFactory(new ChoreographerRegistryClass(context.product, environmentContext.currentEnv).getPostOfficeChoreographerFactory());
            $a0a682275c4a0108$var$choreographerLogger.info('ChoreographerFactory created', {
                choreographerEnabled: choreographerEnabled,
                product: context.product,
                placementId: placementId
            });
        }).catch((error)=>{
            $a0a682275c4a0108$var$choreographerLogger.error('ChoreographerRegistry import failed', {
                error: error instanceof Error ? error.message : String(error),
                stack: error instanceof Error ? error.stack : undefined,
                product: context.product,
                placementId: placementId
            });
            $a0a682275c4a0108$var$choreographerLogger.warn('Disabling Choreographer due to import failure');
            setChoreographerEnabled(false);
        });
        else $a0a682275c4a0108$var$choreographerLogger.debug('Choreographer disabled, skipping import', {
            product: context.product,
            placementId: placementId
        });
    }, [
        choreographerEnabled,
        context.product,
        environmentContext.currentEnv,
        placementId
    ]);
    const stableChoreographerContext = (0, $cozmU.useMemo)(()=>{
        return {
            factory: choreographerFactory,
            choreographerEnabled: choreographerEnabled,
            setChoreographerEnabled: setChoreographerEnabled
        };
    }, [
        choreographerFactory,
        choreographerEnabled,
        setChoreographerEnabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        $a0a682275c4a0108$var$choreographerLogger.debug('Setting ChoreographerContext', {
            factory: choreographerFactory,
            choreographerEnabled: choreographerEnabled,
            product: context.product,
            placementId: placementId
        });
    }, [
        context.product,
        placementId,
        choreographerEnabled,
        choreographerFactory
    ]);
    (0, $cozmU.useEffect)(()=>{
        return (0, $ifV7w.installChoreographerDevtoolsBridge)({
            setChoreographerEnabled: setChoreographerEnabled
        });
    }, [
        setChoreographerEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a0a682275c4a0108$var$ChoreographerContext.Provider, {
        value: stableChoreographerContext
    }, children);
};
const $a0a682275c4a0108$export$cab5a8adbabcee23 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($a0a682275c4a0108$var$ChoreographerContext);
} : ()=>(0, $cozmU.useContext)($a0a682275c4a0108$var$ChoreographerContext);
module.exports["StableChoreographerProvider"] = $a0a682275c4a0108$export$e68b2c75bfb5682a;
module.exports["useChoreographerContext"] = $a0a682275c4a0108$export$cab5a8adbabcee23;

});

parcelRegister("bGVJw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $df1fef41340c50c5$export$da5dc9062cba6715 = {
    product: undefined,
    subproduct: undefined,
    locale: undefined,
    isSiteAdmin: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined,
    disableAllPlacements: undefined
};
const $df1fef41340c50c5$export$a228be81fcb77b42 = (0, $cozmU.createContext)($df1fef41340c50c5$export$da5dc9062cba6715);
const $df1fef41340c50c5$export$3a10495c2cd2db0c = $df1fef41340c50c5$export$a228be81fcb77b42.Provider;
const $df1fef41340c50c5$export$b77983be89bb0a4e = $df1fef41340c50c5$export$3a10495c2cd2db0c;
const $df1fef41340c50c5$export$5bd9099e0ae94a43 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($df1fef41340c50c5$export$a228be81fcb77b42);
} : ()=>(0, $cozmU.useContext)($df1fef41340c50c5$export$a228be81fcb77b42);
module.exports["defaultPostOfficeContextValue"] = $df1fef41340c50c5$export$da5dc9062cba6715;
module.exports["PostOfficeContext"] = $df1fef41340c50c5$export$a228be81fcb77b42;
module.exports["InternalPostOfficeContextProvider"] = $df1fef41340c50c5$export$3a10495c2cd2db0c;
module.exports["PostOfficeContextProvider"] = $df1fef41340c50c5$export$b77983be89bb0a4e;
module.exports["usePostOfficeContext"] = $df1fef41340c50c5$export$5bd9099e0ae94a43;

});

parcelRegister("2dA2p", function(module, exports) {
/* eslint-disable no-console */ /**
 * Simple browser debug logger for Post Office components.
 *
 * NOTE: This is a copy of
 * `post-office/packages/util/shared-contracts/src/util/in-browser-debug-logger.ts`
 * to avoid a cross-workspace import. You may want to keep them in sync.
 *
 * Usage:
 * - Enable:  window.postOffice{Component}Debug = true
 * - Disable: window.postOffice{Component}Debug = false
 *
 * Example:
 * ```typescript
 * const logger = createInBrowserDebugLogger('Choreographer');
 * logger.debug('Component loaded', { config: 'value' });
 * ```
 */ const $ec8b1e18434a088d$export$806eda59584e395d = (component)=>{
    const windowKey = `postOffice${component}Debug`;
    const isEnabled = ()=>{
        try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            return typeof window !== 'undefined' && window[windowKey] === true;
        } catch  {
            return false;
        }
    };
    const log = (level, message, data)=>{
        if (!isEnabled()) return;
        const prefix = `[Post Office - ${component}]`;
        // Use appropriate console method for each level
        if (level === 'debug') console.log(`${prefix} ${message}`, data || '');
        else if (level === 'info') console.info(`${prefix} ${message}`, data || '');
        else if (level === 'warn') console.warn(`${prefix} ${message}`, data || '');
        else if (level === 'error') console.error(`${prefix} ${message}`, data || '');
    };
    return {
        debug: (msg, data)=>log('debug', msg, data),
        info: (msg, data)=>log('info', msg, data),
        warn: (msg, data)=>log('warn', msg, data),
        error: (msg, data)=>log('error', msg, data)
    };
};
module.exports["createInBrowserDebugLogger"] = $ec8b1e18434a088d$export$806eda59584e395d;

});

parcelRegister("ifV7w", function(module, exports) {

var $6YrB3 = parcelRequire("6YrB3");


var $ixfCV = parcelRequire("ixfCV");

const $3e4b6bb4c2123311$var$DEBUG_BYPASS_SESSION_STORAGE_KEY = 'postOffice.choreographer.debug';
const $3e4b6bb4c2123311$var$DEBUG_BYPASS_SESSION_STORAGE_ITEM_KEY = 'bypassEnabled';
const $3e4b6bb4c2123311$var$getStorageClient = ()=>new (0, $6YrB3.default)($3e4b6bb4c2123311$var$DEBUG_BYPASS_SESSION_STORAGE_KEY, {
        storageEngine: 'sessionStorage'
    });
const $3e4b6bb4c2123311$var$getWindow = ()=>typeof window === 'undefined' ? undefined : window;
const $3e4b6bb4c2123311$var$getPersistedBypassEnabled = ()=>{
    return $3e4b6bb4c2123311$var$getStorageClient().getItem($3e4b6bb4c2123311$var$DEBUG_BYPASS_SESSION_STORAGE_ITEM_KEY) === true;
};
const $3e4b6bb4c2123311$export$8e299e8aab3a0cc6 = ()=>{
    return (0, $ixfCV.fg)('post-office_choreographer_devtools_bridge') && $3e4b6bb4c2123311$var$getPersistedBypassEnabled();
};
const $3e4b6bb4c2123311$var$setPersistedBypassEnabled = (isEnabled)=>{
    // The devtools bridge should never break message rendering when browser storage is blocked.
    // StorageClient handles exceptions internally.
    $3e4b6bb4c2123311$var$getStorageClient().setItemWithExpiry($3e4b6bb4c2123311$var$DEBUG_BYPASS_SESSION_STORAGE_ITEM_KEY, isEnabled);
};
const $3e4b6bb4c2123311$var$getChoreographerSingleton = ()=>$3e4b6bb4c2123311$var$getWindow()?.postOffice?.choreographer?.singleton;
const $3e4b6bb4c2123311$var$getRegisteredPluginIds = ()=>{
    return [
        ...$3e4b6bb4c2123311$var$getWindow()?.choreographerRegistry?.keys() ?? []
    ];
};
const $3e4b6bb4c2123311$var$getSnapshot = ()=>{
    const singleton = $3e4b6bb4c2123311$var$getChoreographerSingleton();
    const registeredPlugins = $3e4b6bb4c2123311$var$getRegisteredPluginIds();
    return {
        activeMessage: singleton?.getCurrentMessage() ?? null,
        bypassEnabled: $3e4b6bb4c2123311$export$8e299e8aab3a0cc6(),
        pendingMessage: singleton?.getCurrentPendingMessage() ?? null,
        queuedMessages: singleton?.getQueuedMessages() ?? [],
        recentEvents: [],
        registeredMessages: registeredPlugins.map((productId)=>({
                productId: productId,
                messageIds: [
                    ...singleton?.getMessages(productId).keys() ?? []
                ]
            })),
        registeredPlugins: registeredPlugins,
        updatedAt: Date.now()
    };
};
const $3e4b6bb4c2123311$export$606f928dbd560712 = ({ setChoreographerEnabled: setChoreographerEnabled })=>{
    const currentWindow = $3e4b6bb4c2123311$var$getWindow();
    if (!currentWindow) return ()=>{};
    if (!(0, $ixfCV.fg)('post-office_choreographer_devtools_bridge')) {
        delete currentWindow.postOffice?.choreographer?.debug;
        return ()=>{};
    }
    const bridge = {
        getSnapshot: $3e4b6bb4c2123311$var$getSnapshot,
        isBypassEnabled: $3e4b6bb4c2123311$export$8e299e8aab3a0cc6,
        setBypassEnabled: (isEnabled)=>{
            $3e4b6bb4c2123311$var$setPersistedBypassEnabled(isEnabled);
            setChoreographerEnabled(!isEnabled);
        }
    };
    currentWindow.postOffice = {
        ...currentWindow.postOffice,
        choreographer: {
            ...currentWindow.postOffice?.choreographer,
            debug: bridge
        }
    };
    return ()=>{
        if (currentWindow.postOffice?.choreographer?.debug === bridge) delete currentWindow.postOffice.choreographer.debug;
    };
};
module.exports["shouldBypassChoreographerFromDevtools"] = $3e4b6bb4c2123311$export$8e299e8aab3a0cc6;
module.exports["installChoreographerDevtoolsBridge"] = $3e4b6bb4c2123311$export$606f928dbd560712;

});

parcelRegister("bszpu", function(module, exports) {

let $857dc6f22f4c1d9c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $857dc6f22f4c1d9c$var$load("41Qou").then(()=>parcelRequire('8h6a6'));

});

parcelRegister("kEPax", function(module, exports) {
$parcel$export(module.exports, "useRecommendationContext", () => (parcelRequire("82Ab4")).useRecommendationContext);
/**
 * Message lifecycle hooks for Post Office headless consumers.
 *
 * Provides `useMessageViewed` — a single hook that fires viewed and delivery
 * analytics events on mount:
 *   - messageViewed() (legacy in-app lifecycle endpoint)
 *   - messageInstanceViewed() (message-instance-event endpoint)
 *   - messageInstanceDeliveredSuccessfully() (message-instance-event endpoint)
 *
 * This module is hoisted into @atlassian/post-office-context so that platform
 * packages can consume it without cross-workspace @post-office/* imports.
 *
 * Canonical sources this was inlined from:
 *   post-office/packages/clients/message-lifecycle
 *   post-office/packages/clients/message-instance-event-frontend-client
 *   post-office/packages/clients/recommendation-context
 */ 
var $cozmU = parcelRequire("cozmU");


var $di43e = parcelRequire("di43e");

var $bGVJw = parcelRequire("bGVJw");


var $k4HA2 = parcelRequire("k4HA2");


var $dEG1b = parcelRequire("dEG1b");


var $eZHZB = parcelRequire("eZHZB");


var $4cICV = parcelRequire("4cICV");


var $82Ab4 = parcelRequire("82Ab4");

class $380d86e06eb73b45$export$9ffc53d3edc152da extends Error {
    constructor(){
        super('useMessageInstanceEvent must be used inside a Message template render component.');
    }
}
class $380d86e06eb73b45$export$6c3423e1c9ff4d5b extends Error {
    constructor(){
        super('Unknown action type');
    }
}
const $380d86e06eb73b45$export$39b0f5626e96f41e = ()=>{
    // globalThis resolves to window in the browser, this will therefore attach at window.window, but we should not change until we are sure what is relying on this path.
    if (typeof window !== 'undefined' && !globalThis?.window?.postOfficeMessageInstanceEventClient) {
        // If we are in the browser but there is no window.window
        if (typeof globalThis.window === 'undefined') globalThis.window = {};
        globalThis.window.postOfficeMessageInstanceEventClient = new (0, $eZHZB.MessageInstanceEventClient)();
    }
    const messageInstanceEventClientRef = (0, $cozmU.useRef)(globalThis?.window?.postOfficeMessageInstanceEventClient ?? new (0, $eZHZB.MessageInstanceEventClient)());
    // This falls back to creation per call in the case window is not defined. It is not the best behaviour as this could cause too many object to be created but is
    // better than an uncontrolled error in SSR. This function needs to be made SSR safe in a safter manner.
    const client = messageInstanceEventClientRef.current;
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId = null, triggerId: messageTriggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, analyticsDetails: analyticsDetails = null, configSetId: configSetId } = (0, $k4HA2.useMessageContext)();
    const { placementId: placementId } = (0, $4cICV.usePlacementContext)();
    const browserContext = (0, $bGVJw.usePostOfficeContext)();
    const recommendationContext = (0, $82Ab4.useRecommendationContext)();
    const messageInstanceDeliveredSuccessfully = (0, $cozmU.useCallback)(async (additionalMetadataFromFrontend)=>{
        if (!messageInstanceId || !messageTemplateId || !placementId || !messageCreationType || !messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new $380d86e06eb73b45$export$9ffc53d3edc152da());
            return;
        }
        await client.sendMessageInstanceEvent({
            messageEventType: 'deliverySuccessful',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? ''
                }
            },
            additionalMetadataFromFrontend: {
                transactionAccountId: transactionAccountId,
                ...additionalMetadataFromFrontend,
                ...analyticsDetails
            },
            messageTriggerId: messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            messageCreationType: messageCreationType,
            configSetId: configSetId,
            timestamp: Date.now()
        });
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        analyticsDetails,
        recommendationContext.entityId,
        recommendationContext.sessionId,
        journeyId,
        journeyTriggerId,
        configSetId
    ]);
    const messageInstanceViewed = (0, $cozmU.useCallback)(async (additionalMetadataFromFrontend)=>{
        if (!messageInstanceId || !messageTemplateId || !placementId || !messageCreationType || !messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new $380d86e06eb73b45$export$9ffc53d3edc152da());
            return;
        }
        await client.sendMessageInstanceEvent({
            messageEventType: 'viewed',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? ''
                }
            },
            additionalMetadataFromFrontend: {
                transactionAccountId: transactionAccountId,
                ...additionalMetadataFromFrontend,
                ...analyticsDetails
            },
            messageTriggerId: messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            messageCreationType: messageCreationType,
            configSetId: configSetId,
            timestamp: Date.now()
        });
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        analyticsDetails,
        recommendationContext.entityId,
        recommendationContext.sessionId,
        journeyId,
        journeyTriggerId,
        configSetId
    ]);
    const messageInstanceClicked = (0, $cozmU.useCallback)(async (params)=>{
        if (!messageInstanceId && !params.messageInstanceId || !messageTemplateId && !params.messageTemplateId || !placementId || !messageCreationType && !params.messageCreationType || !messageTriggerId && !params.messageTriggerId) {
            // eslint-disable-next-line no-console
            console.error(new $380d86e06eb73b45$export$9ffc53d3edc152da());
            return;
        }
        await client.sendMessageInstanceEvent({
            messageInstanceId: params.messageInstanceId ?? messageInstanceId,
            messageTemplateId: params.messageTemplateId ?? messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: {
                ...browserContext,
                source: placementId,
                recommendation: {
                    recommendationSessionId: recommendationContext.sessionId ?? '',
                    recommendationEntityId: recommendationContext.entityId ?? ''
                }
            },
            messageCreationType: params.messageCreationType ?? messageCreationType,
            messageTriggerId: params.messageTriggerId ?? messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            configSetId: configSetId,
            ...params,
            additionalMetadataFromFrontend: {
                transactionAccountId: transactionAccountId,
                ...params.additionalMetadataFromFrontend,
                ...analyticsDetails
            },
            timestamp: Date.now()
        });
    }, [
        client,
        browserContext,
        messageInstanceId,
        messageTemplateId,
        placementId,
        messageCreationType,
        messageTriggerId,
        transactionAccountId,
        analyticsDetails,
        recommendationContext.entityId,
        recommendationContext.sessionId,
        journeyId,
        journeyTriggerId,
        configSetId
    ]);
    return {
        messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully,
        messageInstanceViewed: messageInstanceViewed,
        messageInstanceClicked: messageInstanceClicked
    };
};
const $380d86e06eb73b45$export$f847ba3acec566f4 = ()=>{
    // -- message-lifecycle (legacy) client --
    if (!globalThis.window.postOfficeMessageEventClient) globalThis.window.postOfficeMessageEventClient = new (0, $dEG1b.MessageEventClient)();
    const legacyClient = globalThis.window.postOfficeMessageEventClient;
    // -- message-instance-event client --
    if (!globalThis.window.postOfficeMessageInstanceEventClient) globalThis.window.postOfficeMessageInstanceEventClient = new (0, $eZHZB.MessageInstanceEventClient)();
    const instanceClient = globalThis.window.postOfficeMessageInstanceEventClient;
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId, analyticsDetails: analyticsDetails, triggerId: messageTriggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, configSetId: configSetId } = (0, $k4HA2.useMessageContext)();
    const { placementId: placementId } = (0, $4cICV.usePlacementContext)();
    const browserContext = (0, $bGVJw.usePostOfficeContext)();
    const recommendationContext = (0, $82Ab4.useRecommendationContext)();
    const { markViewedFromPlacement: markViewedFromPlacement } = (0, $di43e.useMessagePlacementHooks)();
    return async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) {
            // eslint-disable-next-line no-console
            console.error('[post-office] useMessageViewed: missing required context fields');
            return;
        }
        const sharedContext = {
            ...browserContext,
            source: placementId,
            recommendation: {
                recommendationSessionId: recommendationContext.sessionId ?? '',
                recommendationEntityId: recommendationContext.entityId ?? ''
            }
        };
        // 1. Legacy lifecycle event (messageViewed)
        markViewedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        legacyClient.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $dEG1b.InAppMessageEventType).Viewed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: {
                browser: browserContext,
                recommendation: recommendationContext
            }
        });
        // 2. messageInstanceViewed
        await instanceClient.sendMessageInstanceEvent({
            messageEventType: 'viewed',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: sharedContext,
            messageCreationType: messageCreationType ?? 'implicit',
            messageTriggerId: messageTriggerId ?? '',
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            configSetId: configSetId,
            additionalMetadataFromFrontend: {
                ...transactionAccountId != null ? {
                    transactionAccountId: transactionAccountId
                } : {},
                ...analyticsDetails ?? {}
            },
            timestamp: Date.now()
        });
        // 3. messageInstanceDeliveredSuccessfully
        if (messageCreationType && messageTriggerId) await instanceClient.sendMessageInstanceEvent({
            messageEventType: 'deliverySuccessful',
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            deliveryChannel: 'in-app',
            placementId: placementId,
            channelType: 'pull',
            context: sharedContext,
            messageCreationType: messageCreationType,
            messageTriggerId: messageTriggerId,
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            configSetId: configSetId,
            additionalMetadataFromFrontend: {
                ...transactionAccountId != null ? {
                    transactionAccountId: transactionAccountId
                } : {},
                ...analyticsDetails ?? {}
            },
            timestamp: Date.now()
        });
    };
};
module.exports["useMessageInstanceEvent"] = $380d86e06eb73b45$export$39b0f5626e96f41e;
module.exports["useMessageViewed"] = $380d86e06eb73b45$export$f847ba3acec566f4;

});

parcelRegister("di43e", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

/**
 * Creates a Publish-Subscribe pattern for managing callbacks.
 * @returns {Array<Subscribe, Publish>} An array containing a Subscribe function and a Publish function.
 */ const $10c4c3085134b526$var$createPubSub = ()=>{
    const subscribers = new Map();
    /**
   * Subscribes a callback function to the pub-sub system.
   * @param {Callback} subscriber - The callback function to subscribe.
   * @returns A function to unsubscribe the callback.
   */ const subscribe = (subscriber)=>{
        subscribers.set(subscriber, subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    /**
   * Publishes the payload to all subscribed callbacks.
   * @param {Callback} payload - The payload to publish to the subscribers.
   */ const publish = (payload)=>{
        subscribers.forEach((cb)=>cb(payload));
    };
    return [
        subscribe,
        publish
    ];
};
const $10c4c3085134b526$export$a28a0c048b24fc5a = ()=>{
    const [onMessageSnooze, snoozeMessageFromPlacement] = $10c4c3085134b526$var$createPubSub();
    const [onMessageDismiss, dismissMessageFromPlacement] = $10c4c3085134b526$var$createPubSub();
    const [onMessageRead, markReadFromPlacement] = $10c4c3085134b526$var$createPubSub();
    const [onMessageViewed, markViewedFromPlacement] = $10c4c3085134b526$var$createPubSub();
    const [onMessageClicked, markClickedFromPlacement] = $10c4c3085134b526$var$createPubSub();
    return {
        onMessageSnooze: onMessageSnooze,
        snoozeMessageFromPlacement: snoozeMessageFromPlacement,
        onMessageDismiss: onMessageDismiss,
        dismissMessageFromPlacement: dismissMessageFromPlacement,
        onMessageRead: onMessageRead,
        markReadFromPlacement: markReadFromPlacement,
        onMessageViewed: onMessageViewed,
        markViewedFromPlacement: markViewedFromPlacement,
        onMessageClicked: onMessageClicked,
        markClickedFromPlacement: markClickedFromPlacement
    };
};
const $10c4c3085134b526$export$ea58328f3ceee4d4 = /*#__PURE__*/ (0, $cozmU.createContext)($10c4c3085134b526$export$a28a0c048b24fc5a());
const $10c4c3085134b526$export$c7535f8ebc5b75a9 = $10c4c3085134b526$export$ea58328f3ceee4d4.Provider;
const $10c4c3085134b526$export$c4b5cec0911af177 = ()=>({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($10c4c3085134b526$export$c7535f8ebc5b75a9, {
            value: $10c4c3085134b526$export$a28a0c048b24fc5a()
        }, children);
const $10c4c3085134b526$export$89f8e1f623d8f5ac = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($10c4c3085134b526$export$ea58328f3ceee4d4);
} : ()=>(0, $cozmU.useContext)($10c4c3085134b526$export$ea58328f3ceee4d4);
module.exports["createMessagePlacementValues"] = $10c4c3085134b526$export$a28a0c048b24fc5a;
module.exports["MessagePlacementProvider"] = $10c4c3085134b526$export$c7535f8ebc5b75a9;
module.exports["useMessagePlacementHooks"] = $10c4c3085134b526$export$89f8e1f623d8f5ac;

});

parcelRegister("dEG1b", function(module, exports) {
/**
 * Canonical MessageEventClient implementation.
 *
 * This is the source of truth. `@post-office/message-lifecycle` uses this via
 * `@atlassian/post-office-context/message-lifecycle`.
 */ // ---------------------------------------------------------------------------
// Types (inlined from @post-office/message-lifecycle/src/types.ts)
// ---------------------------------------------------------------------------
var $e5120a75155e5f6a$export$b31ffc6f7c85f1b = /*#__PURE__*/ function(InAppMessageEventType) {
    InAppMessageEventType["Viewed"] = "viewed";
    InAppMessageEventType["Acknowledged"] = "acknowledged";
    InAppMessageEventType["Clicked"] = "clicked";
    InAppMessageEventType["ClickedSecondary"] = "clickedSecondary";
    InAppMessageEventType["Dismissed"] = "dismissed";
    InAppMessageEventType["Snoozed"] = "snoozed";
    InAppMessageEventType["Read"] = "read";
    InAppMessageEventType["Unread"] = "unread";
    return InAppMessageEventType;
}({});
// ---------------------------------------------------------------------------
// Client
// ---------------------------------------------------------------------------
const $e5120a75155e5f6a$var$DEFAULT_PATH = `/gateway/api/post-office/api/v1/messages/lifecycle`;
const $e5120a75155e5f6a$var$FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
const $e5120a75155e5f6a$var$MESSAGE_EVENTS_BATCH_SIZE = 250;

if (typeof fetch === 'undefined') // If fetch is not supported, load the polyfill.
(parcelRequire("gPhC6"));
class $e5120a75155e5f6a$export$ae86a6dabe385178 {
    async sendEvent(event) {
        const url = `${this.endpointUrl}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(event)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
    }
    batchSendEvent(event) {
        this.batchEvents.push(event);
        if (this.scheduledTimeout === null) this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $e5120a75155e5f6a$var$FLUSH_BATCH_EVENTS_TIMEOUT);
    }
    async markAllAsReadEvent(messages) {
        this.batchEvents.push(...messages);
        await this.flushBatchEvents();
    }
    async sendMessageEvents(events) {
        const url = `${this.endpointUrl}/bulk`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(events)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send batch events to analytics endpoint: ${response.statusText}`);
    }
    async flushBatchEvents() {
        if (this.batchEvents.length === 0) return;
        if (this.batchEvents.length > $e5120a75155e5f6a$var$MESSAGE_EVENTS_BATCH_SIZE) {
            const batch = this.batchEvents.slice(0, $e5120a75155e5f6a$var$MESSAGE_EVENTS_BATCH_SIZE);
            await this.sendMessageEvents(batch);
            if (this.scheduledTimeout !== null) globalThis.window.clearTimeout(this.scheduledTimeout);
            this.batchEvents = this.batchEvents.slice($e5120a75155e5f6a$var$MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
            this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $e5120a75155e5f6a$var$FLUSH_BATCH_EVENTS_TIMEOUT);
            return;
        }
        await this.sendMessageEvents(this.batchEvents);
        this.batchEvents = [];
        if (this.scheduledTimeout !== null) {
            globalThis.window.clearTimeout(this.scheduledTimeout);
            this.scheduledTimeout = null;
        }
    }
    constructor(){
        this.endpointUrl = $e5120a75155e5f6a$var$DEFAULT_PATH;
        this.scheduledTimeout = null;
        this.batchEvents = [];
    }
}
module.exports["InAppMessageEventType"] = $e5120a75155e5f6a$export$b31ffc6f7c85f1b;
module.exports["MessageEventClient"] = $e5120a75155e5f6a$export$ae86a6dabe385178;

});

parcelRegister("gPhC6", function(module, exports) {
$parcel$export(module.exports, "DOMException", () => $c3ff1274c67b31e2$export$fe58bcf938607f6a);
/* eslint-disable no-prototype-builtins */ var $c3ff1274c67b31e2$var$g = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || // eslint-disable-next-line no-undef
typeof $parcel$global !== 'undefined' && $parcel$global || {};
var $c3ff1274c67b31e2$var$support = {
    searchParams: 'URLSearchParams' in $c3ff1274c67b31e2$var$g,
    iterable: 'Symbol' in $c3ff1274c67b31e2$var$g && 'iterator' in Symbol,
    blob: 'FileReader' in $c3ff1274c67b31e2$var$g && 'Blob' in $c3ff1274c67b31e2$var$g && function() {
        try {
            new Blob();
            return true;
        } catch (e) {
            return false;
        }
    }(),
    formData: 'FormData' in $c3ff1274c67b31e2$var$g,
    arrayBuffer: 'ArrayBuffer' in $c3ff1274c67b31e2$var$g
};
function $c3ff1274c67b31e2$var$isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj);
}
if ($c3ff1274c67b31e2$var$support.arrayBuffer) {
    var $c3ff1274c67b31e2$var$viewClasses = [
        '[object Int8Array]',
        '[object Uint8Array]',
        '[object Uint8ClampedArray]',
        '[object Int16Array]',
        '[object Uint16Array]',
        '[object Int32Array]',
        '[object Uint32Array]',
        '[object Float32Array]',
        '[object Float64Array]'
    ];
    var $c3ff1274c67b31e2$var$isArrayBufferView = ArrayBuffer.isView || function(obj) {
        return obj && $c3ff1274c67b31e2$var$viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
    };
}
function $c3ff1274c67b31e2$var$normalizeName(name) {
    if (typeof name !== 'string') name = String(name);
    if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
    return name.toLowerCase();
}
function $c3ff1274c67b31e2$var$normalizeValue(value) {
    if (typeof value !== 'string') value = String(value);
    return value;
}
// Build a destructive iterator for the value list
function $c3ff1274c67b31e2$var$iteratorFor(items) {
    var iterator = {
        next: function() {
            var value = items.shift();
            return {
                done: value === undefined,
                value: value
            };
        }
    };
    if ($c3ff1274c67b31e2$var$support.iterable) iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function $c3ff1274c67b31e2$export$79b704688b15c0f4(headers) {
    this.map = {};
    if (headers instanceof $c3ff1274c67b31e2$export$79b704688b15c0f4) headers.forEach(function(value, name) {
        this.append(name, value);
    }, this);
    else if (Array.isArray(headers)) headers.forEach(function(header) {
        if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
        this.append(header[0], header[1]);
    }, this);
    else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
    }, this);
}
$c3ff1274c67b31e2$export$79b704688b15c0f4.prototype.append = function(name, value) {
    name = $c3ff1274c67b31e2$var$normalizeName(name);
    value = $c3ff1274c67b31e2$var$normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
};
$c3ff1274c67b31e2$export$79b704688b15c0f4.prototype['delete'] = function(name) {
    delete this.map[$c3ff1274c67b31e2$var$normalizeName(name)];
};
$c3ff1274c67b31e2$export$79b704688b15c0f4.prototype.get = function(name) {
    name = $c3ff1274c67b31e2$var$normalizeName(name);
    return this.has(name) ? this.map[name] : null;
};
$c3ff1274c67b31e2$export$79b704688b15c0f4.prototype.has = function(name) {
    return this.map.hasOwnProperty($c3ff1274c67b31e2$var$normalizeName(name));
};
$c3ff1274c67b31e2$export$79b704688b15c0f4.prototype.set = function(name, value) {
    this.map[$c3ff1274c67b31e2$var$normalizeName(name)] = $c3ff1274c67b31e2$var$normalizeValue(value);
};
$c3ff1274c67b31e2$export$79b704688b15c0f4.prototype.forEach = function(callback, thisArg) {
    for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
};
$c3ff1274c67b31e2$export$79b704688b15c0f4.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push(name);
    });
    return $c3ff1274c67b31e2$var$iteratorFor(items);
};
$c3ff1274c67b31e2$export$79b704688b15c0f4.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
        items.push(value);
    });
    return $c3ff1274c67b31e2$var$iteratorFor(items);
};
$c3ff1274c67b31e2$export$79b704688b15c0f4.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
        items.push([
            name,
            value
        ]);
    });
    return $c3ff1274c67b31e2$var$iteratorFor(items);
};
if ($c3ff1274c67b31e2$var$support.iterable) $c3ff1274c67b31e2$export$79b704688b15c0f4.prototype[Symbol.iterator] = $c3ff1274c67b31e2$export$79b704688b15c0f4.prototype.entries;
function $c3ff1274c67b31e2$var$consumed(body) {
    if (body._noBody) return;
    if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
    body.bodyUsed = true;
}
function $c3ff1274c67b31e2$var$fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
        reader.onload = function() {
            resolve(reader.result);
        };
        reader.onerror = function() {
            reject(reader.error);
        };
    });
}
function $c3ff1274c67b31e2$var$readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = $c3ff1274c67b31e2$var$fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise;
}
function $c3ff1274c67b31e2$var$readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = $c3ff1274c67b31e2$var$fileReaderReady(reader);
    var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
    var encoding = match ? match[1] : 'utf-8';
    reader.readAsText(blob, encoding);
    return promise;
}
function $c3ff1274c67b31e2$var$readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);
    for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
    return chars.join('');
}
function $c3ff1274c67b31e2$var$bufferClone(buf) {
    if (buf.slice) return buf.slice(0);
    else {
        var view = new Uint8Array(buf.byteLength);
        view.set(new Uint8Array(buf));
        return view.buffer;
    }
}
function $c3ff1274c67b31e2$var$Body() {
    this.bodyUsed = false;
    this._initBody = function(body) {
        /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */ // eslint-disable-next-line no-self-assign
        this.bodyUsed = this.bodyUsed;
        this._bodyInit = body;
        if (!body) {
            this._noBody = true;
            this._bodyText = '';
        } else if (typeof body === 'string') this._bodyText = body;
        else if ($c3ff1274c67b31e2$var$support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
        else if ($c3ff1274c67b31e2$var$support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
        else if ($c3ff1274c67b31e2$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
        else if ($c3ff1274c67b31e2$var$support.arrayBuffer && $c3ff1274c67b31e2$var$support.blob && $c3ff1274c67b31e2$var$isDataView(body)) {
            this._bodyArrayBuffer = $c3ff1274c67b31e2$var$bufferClone(body.buffer);
            // IE 10-11 can't handle a DataView body.
            this._bodyInit = new Blob([
                this._bodyArrayBuffer
            ]);
        } else if ($c3ff1274c67b31e2$var$support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || $c3ff1274c67b31e2$var$isArrayBufferView(body))) this._bodyArrayBuffer = $c3ff1274c67b31e2$var$bufferClone(body);
        else this._bodyText = body = Object.prototype.toString.call(body);
        if (!this.headers.get('content-type')) {
            if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
            else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
            else if ($c3ff1274c67b31e2$var$support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
    };
    if ($c3ff1274c67b31e2$var$support.blob) this.blob = function() {
        var rejected = $c3ff1274c67b31e2$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
            this._bodyArrayBuffer
        ]));
        else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
        else return Promise.resolve(new Blob([
            this._bodyText
        ]));
    };
    this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
            var isConsumed = $c3ff1274c67b31e2$var$consumed(this);
            if (isConsumed) return isConsumed;
            else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
            else return Promise.resolve(this._bodyArrayBuffer);
        } else if ($c3ff1274c67b31e2$var$support.blob) return this.blob().then($c3ff1274c67b31e2$var$readBlobAsArrayBuffer);
        else throw new Error('could not read as ArrayBuffer');
    };
    this.text = function() {
        var rejected = $c3ff1274c67b31e2$var$consumed(this);
        if (rejected) return rejected;
        if (this._bodyBlob) return $c3ff1274c67b31e2$var$readBlobAsText(this._bodyBlob);
        else if (this._bodyArrayBuffer) return Promise.resolve($c3ff1274c67b31e2$var$readArrayBufferAsText(this._bodyArrayBuffer));
        else if (this._bodyFormData) throw new Error('could not read FormData body as text');
        else return Promise.resolve(this._bodyText);
    };
    if ($c3ff1274c67b31e2$var$support.formData) this.formData = function() {
        return this.text().then($c3ff1274c67b31e2$var$decode);
    };
    this.json = function() {
        return this.text().then(JSON.parse);
    };
    return this;
}
// HTTP methods whose capitalization should be normalized
var $c3ff1274c67b31e2$var$methods = [
    'CONNECT',
    'DELETE',
    'GET',
    'HEAD',
    'OPTIONS',
    'PATCH',
    'POST',
    'PUT',
    'TRACE'
];
function $c3ff1274c67b31e2$var$normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return $c3ff1274c67b31e2$var$methods.indexOf(upcased) > -1 ? upcased : method;
}
function $c3ff1274c67b31e2$export$7fa6c5b6f8193917(input, options) {
    if (!(this instanceof $c3ff1274c67b31e2$export$7fa6c5b6f8193917)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    options = options || {};
    var body = options.body;
    if (input instanceof $c3ff1274c67b31e2$export$7fa6c5b6f8193917) {
        if (input.bodyUsed) throw new TypeError('Already read');
        this.url = input.url;
        this.credentials = input.credentials;
        if (!options.headers) this.headers = new $c3ff1274c67b31e2$export$79b704688b15c0f4(input.headers);
        this.method = input.method;
        this.mode = input.mode;
        this.signal = input.signal;
        if (!body && input._bodyInit != null) {
            body = input._bodyInit;
            input.bodyUsed = true;
        }
    } else this.url = String(input);
    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) this.headers = new $c3ff1274c67b31e2$export$79b704688b15c0f4(options.headers);
    this.method = $c3ff1274c67b31e2$var$normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal || function() {
        if ('AbortController' in $c3ff1274c67b31e2$var$g) {
            var ctrl = new AbortController();
            return ctrl.signal;
        }
    }();
    this.referrer = null;
    if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
    this._initBody(body);
    if (this.method === 'GET' || this.method === 'HEAD') {
        if (options.cache === 'no-store' || options.cache === 'no-cache') {
            // Search for a '_' parameter in the query string
            var reParamSearch = /([?&])_=[^&]*/;
            if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
            this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
            else {
                // Otherwise add a new '_' parameter to the end with the current time
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
            }
        }
    }
}
$c3ff1274c67b31e2$export$7fa6c5b6f8193917.prototype.clone = function() {
    return new $c3ff1274c67b31e2$export$7fa6c5b6f8193917(this, {
        body: this._bodyInit
    });
};
function $c3ff1274c67b31e2$var$decode(body) {
    var form = new FormData();
    body.trim().split('&').forEach(function(bytes) {
        if (bytes) {
            var split = bytes.split('=');
            var name = split.shift().replace(/\+/g, ' ');
            var value = split.join('=').replace(/\+/g, ' ');
            form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
    });
    return form;
}
function $c3ff1274c67b31e2$var$parseHeaders(rawHeaders) {
    var headers = new $c3ff1274c67b31e2$export$79b704688b15c0f4();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
    // https://github.com/github/fetch/issues/748
    // https://github.com/zloirock/core-js/issues/751
    preProcessedHeaders.split('\r').map(function(header) {
        return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
    }).forEach(function(line) {
        var parts = line.split(':');
        var key = parts.shift().trim();
        if (key) {
            var value = parts.join(':').trim();
            try {
                headers.append(key, value);
            } catch (error) {
                console.warn('Response ' + error.message);
            }
        }
    });
    return headers;
}
$c3ff1274c67b31e2$var$Body.call($c3ff1274c67b31e2$export$7fa6c5b6f8193917.prototype);
function $c3ff1274c67b31e2$export$9f633d56d7ec90d3(bodyInit, options) {
    if (!(this instanceof $c3ff1274c67b31e2$export$9f633d56d7ec90d3)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
    if (!options) options = {};
    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
    this.headers = new $c3ff1274c67b31e2$export$79b704688b15c0f4(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
}
$c3ff1274c67b31e2$var$Body.call($c3ff1274c67b31e2$export$9f633d56d7ec90d3.prototype);
$c3ff1274c67b31e2$export$9f633d56d7ec90d3.prototype.clone = function() {
    return new $c3ff1274c67b31e2$export$9f633d56d7ec90d3(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new $c3ff1274c67b31e2$export$79b704688b15c0f4(this.headers),
        url: this.url
    });
};
$c3ff1274c67b31e2$export$9f633d56d7ec90d3.error = function() {
    var response = new $c3ff1274c67b31e2$export$9f633d56d7ec90d3(null, {
        status: 200,
        statusText: ''
    });
    response.ok = false;
    response.status = 0;
    response.type = 'error';
    return response;
};
var $c3ff1274c67b31e2$var$redirectStatuses = [
    301,
    302,
    303,
    307,
    308
];
$c3ff1274c67b31e2$export$9f633d56d7ec90d3.redirect = function(url, status) {
    if ($c3ff1274c67b31e2$var$redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
    return new $c3ff1274c67b31e2$export$9f633d56d7ec90d3(null, {
        status: status,
        headers: {
            location: url
        }
    });
};
var $c3ff1274c67b31e2$export$fe58bcf938607f6a = $c3ff1274c67b31e2$var$g.DOMException;
try {
    new $c3ff1274c67b31e2$export$fe58bcf938607f6a();
} catch (err) {
    $c3ff1274c67b31e2$export$fe58bcf938607f6a = function(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
    };
    $c3ff1274c67b31e2$export$fe58bcf938607f6a.prototype = Object.create(Error.prototype);
    $c3ff1274c67b31e2$export$fe58bcf938607f6a.prototype.constructor = $c3ff1274c67b31e2$export$fe58bcf938607f6a;
}
function $c3ff1274c67b31e2$export$e7aa7bc5c1b3cfb3(input, init) {
    return new Promise(function(resolve, reject) {
        var request = new $c3ff1274c67b31e2$export$7fa6c5b6f8193917(input, init);
        if (request.signal && request.signal.aborted) return reject(new $c3ff1274c67b31e2$export$fe58bcf938607f6a('Aborted', 'AbortError'));
        var xhr = new XMLHttpRequest();
        function abortXhr() {
            xhr.abort();
        }
        xhr.onload = function() {
            var options = {
                statusText: xhr.statusText,
                headers: $c3ff1274c67b31e2$var$parseHeaders(xhr.getAllResponseHeaders() || '')
            };
            // This check if specifically for when a user fetches a file locally from the file system
            // Only if the status is out of a normal range
            if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
            else options.status = xhr.status;
            options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
            var body = 'response' in xhr ? xhr.response : xhr.responseText;
            setTimeout(function() {
                resolve(new $c3ff1274c67b31e2$export$9f633d56d7ec90d3(body, options));
            }, 0);
        };
        xhr.onerror = function() {
            setTimeout(function() {
                reject(new TypeError('Network request failed'));
            }, 0);
        };
        xhr.ontimeout = function() {
            setTimeout(function() {
                reject(new TypeError('Network request timed out'));
            }, 0);
        };
        xhr.onabort = function() {
            setTimeout(function() {
                reject(new $c3ff1274c67b31e2$export$fe58bcf938607f6a('Aborted', 'AbortError'));
            }, 0);
        };
        function fixUrl(url) {
            try {
                return url === '' && $c3ff1274c67b31e2$var$g.location.href ? $c3ff1274c67b31e2$var$g.location.href : url;
            } catch (e) {
                return url;
            }
        }
        xhr.open(request.method, fixUrl(request.url), true);
        if (request.credentials === 'include') xhr.withCredentials = true;
        else if (request.credentials === 'omit') xhr.withCredentials = false;
        if ('responseType' in xhr) {
            if ($c3ff1274c67b31e2$var$support.blob) xhr.responseType = 'blob';
            else if ($c3ff1274c67b31e2$var$support.arrayBuffer) xhr.responseType = 'arraybuffer';
        }
        if (init && typeof init.headers === 'object' && !(init.headers instanceof $c3ff1274c67b31e2$export$79b704688b15c0f4 || $c3ff1274c67b31e2$var$g.Headers && init.headers instanceof $c3ff1274c67b31e2$var$g.Headers)) {
            var names = [];
            Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                names.push($c3ff1274c67b31e2$var$normalizeName(name));
                xhr.setRequestHeader(name, $c3ff1274c67b31e2$var$normalizeValue(init.headers[name]));
            });
            request.headers.forEach(function(value, name) {
                if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
            });
        } else request.headers.forEach(function(value, name) {
            xhr.setRequestHeader(name, value);
        });
        if (request.signal) {
            request.signal.addEventListener('abort', abortXhr);
            xhr.onreadystatechange = function() {
                // DONE (success or failure)
                if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
            };
        }
        xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    });
}
$c3ff1274c67b31e2$export$e7aa7bc5c1b3cfb3.polyfill = true;
if (!$c3ff1274c67b31e2$var$g.fetch) {
    $c3ff1274c67b31e2$var$g.fetch = $c3ff1274c67b31e2$export$e7aa7bc5c1b3cfb3;
    $c3ff1274c67b31e2$var$g.Headers = $c3ff1274c67b31e2$export$79b704688b15c0f4;
    $c3ff1274c67b31e2$var$g.Request = $c3ff1274c67b31e2$export$7fa6c5b6f8193917;
    $c3ff1274c67b31e2$var$g.Response = $c3ff1274c67b31e2$export$9f633d56d7ec90d3;
}
module.exports["Headers"] = $c3ff1274c67b31e2$export$79b704688b15c0f4;
module.exports["Request"] = $c3ff1274c67b31e2$export$7fa6c5b6f8193917;
module.exports["Response"] = $c3ff1274c67b31e2$export$9f633d56d7ec90d3;
module.exports["fetch"] = $c3ff1274c67b31e2$export$e7aa7bc5c1b3cfb3;

});

parcelRegister("eZHZB", function(module, exports) {
/**
 * Canonical MessageInstanceEventClient implementation.
 *
 * This is the source of truth for frontend in-app message instance events.
 * `@atlassian/message-instance-event-frontend-client/message-instance-event-client` and the legacy
 * `@post-office/message-instance-event-frontend-client` package both export this implementation.
 */ // ---------------------------------------------------------------------------
// Client
// ---------------------------------------------------------------------------
const $4f99a14f3531a72b$var$DEFAULT_PATH = `/gateway/api/post-office/api/v1/message-instance-event/bulk`;
const $4f99a14f3531a72b$var$FLUSH_BATCH_EVENTS_TIMEOUT = 1000;
const $4f99a14f3531a72b$var$MESSAGE_EVENTS_BATCH_SIZE = 30;

if (typeof fetch === 'undefined') // If fetch is not supported, load the polyfill.
(parcelRequire("gPhC6"));
class $4f99a14f3531a72b$export$4564cfc2de39be55 {
    async sendMessageInstanceEvent(event) {
        this.batchEvents.push(event);
        if (this.scheduledTimeout === null) this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $4f99a14f3531a72b$var$FLUSH_BATCH_EVENTS_TIMEOUT);
    }
    async sendEventsToBackend(events) {
        const url = `${this.endpointUrl}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(events)
        });
        if (!response.ok) // eslint-disable-next-line no-console
        console.error(`Failed to send event to analytics endpoint: ${response.statusText}`);
    }
    async flushBatchEvents() {
        if (this.batchEvents.length === 0) return;
        if (this.batchEvents.length > $4f99a14f3531a72b$var$MESSAGE_EVENTS_BATCH_SIZE) {
            const batch = this.batchEvents.slice(0, $4f99a14f3531a72b$var$MESSAGE_EVENTS_BATCH_SIZE);
            await this.sendEventsToBackend(batch);
            if (this.scheduledTimeout !== null) globalThis.window.clearTimeout(this.scheduledTimeout);
            this.batchEvents = this.batchEvents.slice($4f99a14f3531a72b$var$MESSAGE_EVENTS_BATCH_SIZE, this.batchEvents.length);
            this.scheduledTimeout = globalThis.window.setTimeout(this.flushBatchEvents.bind(this), $4f99a14f3531a72b$var$FLUSH_BATCH_EVENTS_TIMEOUT);
            return;
        }
        await this.sendEventsToBackend(this.batchEvents);
        this.batchEvents = [];
        if (this.scheduledTimeout !== null) {
            globalThis.window.clearTimeout(this.scheduledTimeout);
            this.scheduledTimeout = null;
        }
    }
    constructor(){
        this.endpointUrl = $4f99a14f3531a72b$var$DEFAULT_PATH;
        this.scheduledTimeout = null;
        this.batchEvents = [];
    }
}
module.exports["MessageInstanceEventClient"] = $4f99a14f3531a72b$export$4564cfc2de39be55;

});

parcelRegister("4cICV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eq1BO = parcelRequire("eq1BO");


var $VDfNH = parcelRequire("VDfNH");

const $2831b09faf7bf56f$export$6394bf86db095a8 = /*#__PURE__*/ (0, $cozmU.createContext)({
    placementId: undefined
});
const $2831b09faf7bf56f$export$6272e220478c7f1d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { value: value, children: children } = t0;
    let t1;
    if ($[0] !== value.placementId) {
        t1 = {
            placementId: value.placementId
        };
        $[0] = value.placementId;
        $[1] = t1;
    } else t1 = $[1];
    const memoizedValue = t1;
    (0, $VDfNH.usePostOfficeScreenPlacement)(memoizedValue);
    let t2;
    if ($[2] !== children || $[3] !== memoizedValue) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eq1BO.PostOfficeAnalyticsContext), {
            data: memoizedValue
        }, children);
        $[2] = children;
        $[3] = memoizedValue;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== memoizedValue || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2831b09faf7bf56f$export$6394bf86db095a8.Provider, {
            value: memoizedValue
        }, t2);
        $[5] = memoizedValue;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ value: value, children: children })=>{
    const memoizedValue = (0, $cozmU.useMemo)(()=>({
            placementId: value.placementId
        }), [
        value.placementId
    ]);
    (0, $VDfNH.usePostOfficeScreenPlacement)(memoizedValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2831b09faf7bf56f$export$6394bf86db095a8.Provider, {
        value: memoizedValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eq1BO.PostOfficeAnalyticsContext), {
        data: memoizedValue
    }, children));
};
const $2831b09faf7bf56f$export$4fc0446ee742ad80 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($2831b09faf7bf56f$export$6394bf86db095a8);
} : ()=>(0, $cozmU.useContext)($2831b09faf7bf56f$export$6394bf86db095a8);
module.exports["PlacementProvider"] = $2831b09faf7bf56f$export$6272e220478c7f1d;
module.exports["usePlacementContext"] = $2831b09faf7bf56f$export$4fc0446ee742ad80;

});

parcelRegister("VDfNH", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $2z6YT = parcelRequire("2z6YT");

const $28ba2b78924c6069$var$initialPlacementState = {
    currentlyMounted: [],
    hasMounted: []
};
const $28ba2b78924c6069$var$PostOfficeScreenContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    placements: $28ba2b78924c6069$var$initialPlacementState
});
const $28ba2b78924c6069$export$70e19226ddeaf957 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($28ba2b78924c6069$var$PostOfficeScreenContext);
} : ()=>(0, $cozmU.useContext)($28ba2b78924c6069$var$PostOfficeScreenContext);
const $28ba2b78924c6069$var$PostOfficeScreenUpdateContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    placementMount: ()=>{},
    placementUnmount: ()=>{}
});
const $28ba2b78924c6069$export$5d27c0ee02be2a23 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($28ba2b78924c6069$var$PostOfficeScreenUpdateContext);
} : ()=>(0, $cozmU.useContext)($28ba2b78924c6069$var$PostOfficeScreenUpdateContext);
const $28ba2b78924c6069$export$ca77a8cbe94108fe = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children } = t0;
    const [placements, setPlacements] = (0, $cozmU.useState)($28ba2b78924c6069$var$initialPlacementState);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (t2)=>{
            const { placementId: placementId } = t2;
            return setPlacements((state)=>state.currentlyMounted.includes(placementId) ? state : {
                    ...state,
                    currentlyMounted: (0, $2z6YT.uniqueArray)([
                        ...state.currentlyMounted,
                        placementId
                    ]),
                    hasMounted: (0, $2z6YT.uniqueArray)([
                        ...state.hasMounted,
                        placementId
                    ])
                });
        };
        $[0] = t1;
    } else t1 = $[0];
    const placementMount = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (t3)=>{
            const { placementId: placementId_0 } = t3;
            return setPlacements((state_0)=>!state_0.currentlyMounted.includes(placementId_0) ? state_0 : {
                    ...state_0,
                    currentlyMounted: state_0.currentlyMounted.filter((e)=>e !== placementId_0)
                });
        };
        $[1] = t2;
    } else t2 = $[1];
    const placementUnmount = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            placementMount: placementMount,
            placementUnmount: placementUnmount
        };
        $[2] = t3;
    } else t3 = $[2];
    const postOfficeScreenUpdateContext = t3;
    let t4;
    if ($[3] !== placements) {
        t4 = {
            placements: placements
        };
        $[3] = placements;
        $[4] = t4;
    } else t4 = $[4];
    const postOfficeScreenContext = t4;
    let t5;
    if ($[5] !== children || $[6] !== postOfficeScreenContext) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28ba2b78924c6069$var$PostOfficeScreenUpdateContext.Provider, {
            value: postOfficeScreenUpdateContext
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28ba2b78924c6069$var$PostOfficeScreenContext.Provider, {
            value: postOfficeScreenContext
        }, children));
        $[5] = children;
        $[6] = postOfficeScreenContext;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
} : ({ children: children })=>{
    const [placements, setPlacements] = (0, $cozmU.useState)($28ba2b78924c6069$var$initialPlacementState);
    const placementMount = (0, $cozmU.useCallback)(({ placementId: placementId })=>setPlacements((state)=>state.currentlyMounted.includes(placementId) ? state : {
                ...state,
                currentlyMounted: (0, $2z6YT.uniqueArray)([
                    ...state.currentlyMounted,
                    placementId
                ]),
                hasMounted: (0, $2z6YT.uniqueArray)([
                    ...state.hasMounted,
                    placementId
                ])
            }), []);
    const placementUnmount = (0, $cozmU.useCallback)(({ placementId: placementId_0 })=>setPlacements((state_0)=>!state_0.currentlyMounted.includes(placementId_0) ? state_0 : {
                ...state_0,
                currentlyMounted: state_0.currentlyMounted.filter((e)=>e !== placementId_0)
            }), []);
    const postOfficeScreenUpdateContext = (0, $cozmU.useMemo)(()=>({
            placementMount: placementMount,
            placementUnmount: placementUnmount
        }), [
        placementMount,
        placementUnmount
    ]);
    const postOfficeScreenContext = (0, $cozmU.useMemo)(()=>({
            placements: placements
        }), [
        placements
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28ba2b78924c6069$var$PostOfficeScreenUpdateContext.Provider, {
        value: postOfficeScreenUpdateContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28ba2b78924c6069$var$PostOfficeScreenContext.Provider, {
        value: postOfficeScreenContext
    }, children));
};
const $28ba2b78924c6069$export$f51d04a086368016 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { placementId: placementId } = t0;
    const { placementMount: placementMount, placementUnmount: placementUnmount } = $28ba2b78924c6069$export$5d27c0ee02be2a23();
    let t1;
    let t2;
    if ($[0] !== placementId || $[1] !== placementMount || $[2] !== placementUnmount) {
        t1 = ()=>{
            if (!placementId) return;
            placementMount({
                placementId: placementId
            });
            return ()=>{
                placementUnmount({
                    placementId: placementId
                });
            };
        };
        t2 = [
            placementId,
            placementMount,
            placementUnmount
        ];
        $[0] = placementId;
        $[1] = placementMount;
        $[2] = placementUnmount;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
} : ({ placementId: placementId })=>{
    const { placementMount: placementMount, placementUnmount: placementUnmount } = $28ba2b78924c6069$export$5d27c0ee02be2a23();
    (0, $cozmU.useEffect)(()=>{
        if (!placementId) return;
        placementMount({
            placementId: placementId
        });
        return ()=>{
            placementUnmount({
                placementId: placementId
            });
        };
    }, [
        placementId,
        placementMount,
        placementUnmount
    ]);
};
module.exports["usePostOfficeScreen"] = $28ba2b78924c6069$export$70e19226ddeaf957;
module.exports["PostOfficeScreenContextProvider"] = $28ba2b78924c6069$export$ca77a8cbe94108fe;
module.exports["usePostOfficeScreenPlacement"] = $28ba2b78924c6069$export$f51d04a086368016;

});

parcelRegister("2z6YT", function(module, exports) {
const $153c91e5091772be$export$bbd17ecb0679edd7 = (input)=>Array.from(new Set(input).values());
module.exports["uniqueArray"] = $153c91e5091772be$export$bbd17ecb0679edd7;

});

parcelRegister("iQwJa", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");

const $23faa112e8710681$export$be54ac815726b4bd = (context)=>{
    const isGlobalDisablePlacementCheckEnabled = (0, $ixfCV.fg)('post-office-enable-disable-placement-check');
    if (isGlobalDisablePlacementCheckEnabled) return context.disableAllPlacements === true;
    return false;
};
module.exports["isPostOfficePlacementsGloballyDisabled"] = $23faa112e8710681$export$be54ac815726b4bd;

});

parcelRegister("gswTK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $32399d5f04a6fb7b$export$afec669dc416ee7e = /*#__PURE__*/ (0, $cozmU.createContext)({
    fetch: (...args)=>globalThis.fetch(...args)
});
const $32399d5f04a6fb7b$export$e1e2cdb0425a9fa8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($32399d5f04a6fb7b$export$afec669dc416ee7e);
} : ()=>(0, $cozmU.useContext)($32399d5f04a6fb7b$export$afec669dc416ee7e);
const $32399d5f04a6fb7b$export$e6d4e8801dff09b9 = ()=>{
    try {
        return (0, $cozmU.useContext)($32399d5f04a6fb7b$export$afec669dc416ee7e);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (_error) {
        return undefined;
    }
};
const $32399d5f04a6fb7b$export$5f25a6ddf0324fa8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { fetch: fetch, children: children } = t0;
    let t1;
    if ($[0] !== fetch) {
        t1 = {
            fetch: fetch
        };
        $[0] = fetch;
        $[1] = t1;
    } else t1 = $[1];
    const value = t1;
    let t2;
    if ($[2] !== children || $[3] !== value) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($32399d5f04a6fb7b$export$afec669dc416ee7e.Provider, {
            value: value
        }, children);
        $[2] = children;
        $[3] = value;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ fetch: fetch, children: children })=>{
    const value = (0, $cozmU.useMemo)(()=>({
            fetch: fetch
        }), [
        fetch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($32399d5f04a6fb7b$export$afec669dc416ee7e.Provider, {
        value: value
    }, children);
};
const $32399d5f04a6fb7b$export$a088c81282679a25 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { fetch: fetch, children: children } = t0;
    if (!fetch) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== children || $[3] !== fetch) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($32399d5f04a6fb7b$export$5f25a6ddf0324fa8, {
            fetch: fetch
        }, children);
        $[2] = children;
        $[3] = fetch;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ fetch: fetch, children: children })=>{
    if (!fetch) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($32399d5f04a6fb7b$export$5f25a6ddf0324fa8, {
        fetch: fetch
    }, children);
};
module.exports["usePlacementFetchingContext"] = $32399d5f04a6fb7b$export$e1e2cdb0425a9fa8;
module.exports["useOptionalPlacementFetchingContext"] = $32399d5f04a6fb7b$export$e6d4e8801dff09b9;
module.exports["PlacementFetchingProvider"] = $32399d5f04a6fb7b$export$5f25a6ddf0324fa8;
module.exports["MaybePlacementFetchingProvider"] = $32399d5f04a6fb7b$export$a088c81282679a25;

});

parcelRegister("iDSbf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $jvnPU = parcelRequire("jvnPU");

const $5a4cef3573b27dec$export$2e74004b635d08aa = `/gateway/api/post-office/api/v1/placements/`;
const $5a4cef3573b27dec$var$isNotEmpty = (input)=>!(typeof input === 'undefined' || input === null);
const $5a4cef3573b27dec$var$stringifyObjectValues = (input)=>{
    const entries = Object.entries(input);
    const stringifiedEntries = entries.filter(([, value])=>$5a4cef3573b27dec$var$isNotEmpty(value)).map(([key, value])=>[
            key,
            String(value)
        ]);
    return Object.fromEntries(stringifiedEntries);
};
const $5a4cef3573b27dec$var$defaultHeaders = {
    credentials: 'include',
    mode: 'cors',
    'Content-Type': 'application/json'
};
const $5a4cef3573b27dec$export$ef70136078f15deb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (placementId, path, context, fetcher, requestOptions, useSWROptions)=>{
    const $ = (0, $bDgLe.c)(7);
    let t0;
    if ($[0] !== path) {
        t0 = path === "" || path === "/" ? "" : `/${path.charAt(0) === "/" ? path.substring(1) : path}`;
        $[0] = path;
        $[1] = t0;
    } else t0 = $[1];
    const normalizedPath = t0;
    let t1;
    if ($[2] !== context) {
        const queryParams = new URLSearchParams($5a4cef3573b27dec$var$stringifyObjectValues(context));
        queryParams.sort();
        t1 = queryParams.toString();
        $[2] = context;
        $[3] = t1;
    } else t1 = $[3];
    const contextAsSearchParams = t1;
    const formattedSearchParams = contextAsSearchParams ? `?${contextAsSearchParams}` : contextAsSearchParams;
    const url = encodeURI(`${$5a4cef3573b27dec$export$2e74004b635d08aa}${placementId}${normalizedPath}${formattedSearchParams}`);
    let t2;
    if ($[4] !== fetcher || $[5] !== requestOptions) {
        t2 = (url_0)=>fetcher.fetch(url_0, {
                ...requestOptions,
                headers: {
                    ...$5a4cef3573b27dec$var$defaultHeaders,
                    ...requestOptions?.headers
                }
            })?.then($5a4cef3573b27dec$var$_temp);
        $[4] = fetcher;
        $[5] = requestOptions;
        $[6] = t2;
    } else t2 = $[6];
    return (0, $jvnPU.default)(placementId ? url : null, t2, useSWROptions);
} : (placementId, path, context, fetcher, requestOptions, useSWROptions)=>{
    const normalizedPath = path === '' || path === '/' ? '' : `/${path.charAt(0) === '/' ? path.substring(1) : path}`;
    const queryParams = new URLSearchParams($5a4cef3573b27dec$var$stringifyObjectValues(context));
    queryParams.sort();
    const contextAsSearchParams = queryParams.toString();
    const formattedSearchParams = contextAsSearchParams ? `?${contextAsSearchParams}` : contextAsSearchParams;
    const url = encodeURI(`${$5a4cef3573b27dec$export$2e74004b635d08aa}${placementId}${normalizedPath}${formattedSearchParams}`);
    return (0, $jvnPU.default)(placementId ? url : null, (url_0)=>fetcher.fetch(url_0, {
            ...requestOptions,
            headers: {
                ...$5a4cef3573b27dec$var$defaultHeaders,
                ...requestOptions?.headers
            }
        })?.then((res)=>{
            if (!res) throw new Error('No response from fetch');
            return res.json();
        }), useSWROptions);
};
function $5a4cef3573b27dec$var$_temp(res) {
    if (!res) throw new Error("No response from fetch");
    return res.json();
}
module.exports["useFetchPlacementData"] = $5a4cef3573b27dec$export$ef70136078f15deb;

});

parcelRegister("jvnPU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6nvBr = parcelRequire("6nvBr");


var $8h4fq = parcelRequire("8h4fq");
parcelRequire("3PVFp");
var $3PVFp = parcelRequire("3PVFp");

var $2Yg7J = parcelRequire("2Yg7J");

// Shared state between server components and client components
const $e33366f5385eaa59$var$noop = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $e33366f5385eaa59$var$UNDEFINED = /*#__NOINLINE__*/ $e33366f5385eaa59$var$noop();
const $e33366f5385eaa59$var$OBJECT = Object;
const $e33366f5385eaa59$var$isUndefined = (v)=>v === $e33366f5385eaa59$var$UNDEFINED;
const $e33366f5385eaa59$var$isFunction = (v)=>typeof v == 'function';
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $e33366f5385eaa59$var$table = new WeakMap();
const $e33366f5385eaa59$var$getTypeName = (value)=>$e33366f5385eaa59$var$OBJECT.prototype.toString.call(value);
const $e33366f5385eaa59$var$isObjectTypeName = (typeName, type)=>typeName === `[object ${type}]`;
// counter of the key
let $e33366f5385eaa59$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $e33366f5385eaa59$var$stableHash = (arg)=>{
    const type = typeof arg;
    const typeName = $e33366f5385eaa59$var$getTypeName(arg);
    const isDate = $e33366f5385eaa59$var$isObjectTypeName(typeName, 'Date');
    const isRegex = $e33366f5385eaa59$var$isObjectTypeName(typeName, 'RegExp');
    const isPlainObject = $e33366f5385eaa59$var$isObjectTypeName(typeName, 'Object');
    let result;
    let index;
    if ($e33366f5385eaa59$var$OBJECT(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $e33366f5385eaa59$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$e33366f5385eaa59$var$counter + '~';
        $e33366f5385eaa59$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $e33366f5385eaa59$var$stableHash(arg[index]) + ',';
            $e33366f5385eaa59$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            const keys = $e33366f5385eaa59$var$OBJECT.keys(arg).sort();
            while(!$e33366f5385eaa59$var$isUndefined(index = keys.pop()))if (!$e33366f5385eaa59$var$isUndefined(arg[index])) result += index + ':' + $e33366f5385eaa59$var$stableHash(arg[index]) + ',';
            $e33366f5385eaa59$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
const $e33366f5385eaa59$var$serialize = (key)=>{
    if ($e33366f5385eaa59$var$isFunction(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $e33366f5385eaa59$var$stableHash(key) : '';
    return [
        key,
        args
    ];
};
const $e33366f5385eaa59$export$dbab534a48e651ef = (key)=>$e33366f5385eaa59$var$serialize(key)[0];
/// <reference types="react/experimental" />
const $e33366f5385eaa59$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).use || // This extra generic is to avoid TypeScript mixing up the generic and JSX sytax
// and emitting an error.
// We assume that this is only for the `use(thenable)` case, not `use(context)`.
// https://github.com/facebook/react/blob/aed00dacfb79d17c53218404c52b1c7aa59c4a89/packages/react-server/src/ReactFizzThenable.js#L45
((thenable)=>{
    switch(thenable.status){
        case 'pending':
            throw thenable;
        case 'fulfilled':
            return thenable.value;
        case 'rejected':
            throw thenable.reason;
        default:
            thenable.status = 'pending';
            thenable.then((v)=>{
                thenable.status = 'fulfilled';
                thenable.value = v;
            }, (e)=>{
                thenable.status = 'rejected';
                thenable.reason = e;
            });
            throw thenable;
    }
});
const $e33366f5385eaa59$var$WITH_DEDUPE = {
    dedupe: true
};
const $e33366f5385eaa59$var$resolvedUndef = Promise.resolve((0, $8h4fq.U));
/**
 * The core implementation of the useSWR hook.
 *
 * This is the main handler function that implements all SWR functionality including
 * data fetching, caching, revalidation, error handling, and state management.
 * It manages the complete lifecycle of SWR requests from initialization through
 * cleanup.
 *
 * Key responsibilities:
 * - Key serialization and normalization
 * - Cache state management and synchronization
 * - Automatic and manual revalidation
 * - Error handling and retry logic
 * - Suspense integration
 * - Loading state management
 * - Effect cleanup and memory management
 *
 * @template Data - The type of data returned by the fetcher
 * @template Error - The type of error that can be thrown
 *
 * @param _key - The SWR key (string, array, object, function, or falsy)
 * @param fetcher - The fetcher function to retrieve data, or null to disable fetching
 * @param config - Complete SWR configuration object with both public and internal options
 *
 * @returns SWRResponse object containing data, error, mutate function, and loading states
 *
 * @internal This is the internal implementation. Use `useSWR` instead.
 */ const $e33366f5385eaa59$var$useSWRHandler = (_key, fetcher, config)=>{
    const { cache: cache, compare: compare, suspense: suspense, fallbackData: fallbackData, revalidateOnMount: revalidateOnMount, revalidateIfStale: revalidateIfStale, refreshInterval: refreshInterval, refreshWhenHidden: refreshWhenHidden, refreshWhenOffline: refreshWhenOffline, keepPreviousData: keepPreviousData, strictServerPrefetchWarning: strictServerPrefetchWarning } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = (0, $8h4fq.b).get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = (0, $8h4fq.s)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0, $cozmU.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0, $cozmU.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0, $cozmU.useRef)(key);
    const fetcherRef = (0, $cozmU.useRef)(fetcher);
    const configRef = (0, $cozmU.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0, $8h4fq.z)(cache, key);
    const stateDependencies = (0, $cozmU.useRef)({}).current;
    // Resolve the fallback data from either the inline option, or the global provider.
    // If it's a promise, we simply let React suspend and resolve it for us.
    const fallback = (0, $8h4fq.e)(fallbackData) ? (0, $8h4fq.e)(config.fallback) ? (0, $8h4fq.U) : config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === 'data') {
                if (!compare(prev[t], current[t])) {
                    if (!(0, $8h4fq.e)(prev[t])) return false;
                    if (!compare(returnedData, current[t])) return false;
                }
            } else {
                if (current[t] !== prev[t]) return false;
            }
        }
        return true;
    };
    const getSnapshot = (0, $cozmU.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0, $8h4fq.e)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            return revalidateIfStale !== false;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0, $8h4fq.m)(state);
            delete snapshot._k;
            if (!shouldStartRequest) return snapshot;
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0, $6nvBr.useSyncExternalStore)((0, $cozmU.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0, $8h4fq.e)(cachedData) ? fallback && (0, $8h4fq.B)(fallback) ? $e33366f5385eaa59$var$use(fallback) : fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0, $cozmU.useRef)(data);
    const returnedData = keepPreviousData ? (0, $8h4fq.e)(cachedData) ? (0, $8h4fq.e)(laggyDataRef.current) ? data : laggyDataRef.current : cachedData : data;
    const hasKeyButNoData = key && (0, $8h4fq.e)(data);
    // Note: the conditionally hook call is fine because the environment
    // `IS_SERVER` never changes.
    const isHydration = !(0, $8h4fq.r) && // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $6nvBr.useSyncExternalStore)(()=>(0, $8h4fq.A), ()=>false, ()=>true);
    // During the initial SSR render, warn if the key has no data pre-fetched via:
    // - fallback data
    // - preload calls
    // - initial data from the cache provider
    // We only warn once for each key during SSR.
    if (strictServerPrefetchWarning && isHydration && !suspense && hasKeyButNoData) console.warn(`Missing pre-initiated data for serialized key "${key}" during server-side rendering. Data fethcing should be initiated on the server and provided to SWR via fallback data. You can set "strictServerPrefetchWarning: false" to disable this warning.`);
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0, $8h4fq.e)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0, $8h4fq.e)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0, $8h4fq.e)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0, $8h4fq.e)(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = (0, $8h4fq.e)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0, $8h4fq.e)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0, $cozmU.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return false;
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (0, $8h4fq.I) return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0, $8h4fq.e)(getCache().data)) initialState.isLoading = true;
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0, $8h4fq.e)(getCache().data)) setTimeout(()=>{
                    if (loading && callbackSafeguard()) getConfig().onLoadingSlow(key, config);
                }, config.loadingTimeout);
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0, $8h4fq.o)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
            // deduplication interval.
            setTimeout(cleanupState, config.dedupingInterval);
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Clear error.
            finalState.error = (0, $8h4fq.U);
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0, $8h4fq.e)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) getConfig().onSuccess(newData, key, config);
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError: shouldRetryOnError } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0, $8h4fq.a)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (!getConfig().revalidateOnFocus || !getConfig().revalidateOnReconnect || isActive()) // If it's inactive, stop. It will auto-revalidate when
                        // refocusing or reconnecting.
                        // When retrying, deduplication is always enabled.
                        currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                            const revalidators = EVENT_REVALIDATORS[key];
                            if (revalidators && revalidators[0]) revalidators[0]((0, $2Yg7J).ERROR_REVALIDATE_EVENT, _opts);
                        }, {
                            retryCount: (opts.retryCount || 0) + 1,
                            dedupe: true
                        });
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    const boundMutate = (0, $cozmU.useCallback)((...args)=>{
        return (0, $8h4fq.n)(cache, keyRef.current, ...args);
    }, []);
    // The logic for updating refs.
    (0, $8h4fq.u)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0, $8h4fq.e)(cachedData)) laggyDataRef.current = cachedData;
    });
    // After mounted or key changed.
    (0, $8h4fq.u)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind((0, $8h4fq.U), $e33366f5385eaa59$var$WITH_DEDUPE);
        let nextFocusRevalidatedAt = 0;
        if (getConfig().revalidateOnFocus) {
            const initNow = Date.now();
            nextFocusRevalidatedAt = initNow + getConfig().focusThrottleInterval;
        }
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        const onRevalidate = (type, opts = {})=>{
            if (type == (0, $2Yg7J).FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == (0, $2Yg7J).RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == (0, $2Yg7J).MUTATE_EVENT) return revalidate();
            else if (type == (0, $2Yg7J).ERROR_REVALIDATE_EVENT) return revalidate(opts);
            return;
        };
        const unsubEvents = (0, $3PVFp.subscribeCallback)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) // Performance optimization: if a request is already in progress for this key,
        // skip the revalidation to avoid redundant work
        {
            if (!FETCH[key]) {
                if ((0, $8h4fq.e)(data) || (0, $8h4fq.r)) // Revalidate immediately.
                softRevalidate();
                else // Delay the revalidate if we have data to return so we won't block
                // rendering.
                (0, $8h4fq.t)(softRevalidate);
            }
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0, $8h4fq.u)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0, $8h4fq.a)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($e33366f5385eaa59$var$WITH_DEDUPE).then(next);
            else // Schedule the next interval to check again.
            next();
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0, $cozmU.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any fallback data. This causes hydration errors. See:
        // https://github.com/vercel/swr/issues/1832
        if (!(0, $8h4fq.I) && (0, $8h4fq.r) && hasKeyButNoData) throw new Error('Fallback data is required when using Suspense in SSR.');
        // Always update fetcher and config refs even with the Suspense mode.
        if (hasKeyButNoData) {
            fetcherRef.current = fetcher;
            configRef.current = config;
            unmountedRef.current = false;
        }
        const req = PRELOAD[key];
        const mutateReq = !(0, $8h4fq.e)(req) && hasKeyButNoData ? boundMutate(req) : $e33366f5385eaa59$var$resolvedUndef;
        $e33366f5385eaa59$var$use(mutateReq);
        if (!(0, $8h4fq.e)(error) && hasKeyButNoData) throw error;
        const revalidation = hasKeyButNoData ? revalidate($e33366f5385eaa59$var$WITH_DEDUPE) : $e33366f5385eaa59$var$resolvedUndef;
        if (!(0, $8h4fq.e)(returnedData) && hasKeyButNoData) {
            // @ts-ignore modify react promise status
            revalidation.status = 'fulfilled';
            // @ts-ignore modify react promise value
            revalidation.value = true;
        }
        $e33366f5385eaa59$var$use(revalidation);
    }
    const swrResponse = {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
    return swrResponse;
};
const $e33366f5385eaa59$export$4c7bbecdacc3ca2c = (0, $8h4fq.O).defineProperty((0, $8h4fq.g), 'defaultValue', {
    value: (0, $8h4fq.d)
});
/**
 * A hook to fetch data.
 *
 * @see {@link https://swr.vercel.app}
 *
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error, isLoading } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (isLoading) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const $e33366f5385eaa59$export$2e2bcd8739ae039 = (0, $3PVFp.withArgs)($e33366f5385eaa59$var$useSWRHandler);
module.exports["SWRConfig"] = $e33366f5385eaa59$export$4c7bbecdacc3ca2c;
module.exports["default"] = $e33366f5385eaa59$export$2e2bcd8739ae039;

});

parcelRegister("8h4fq", function(module, exports) {
$parcel$export(module.exports, "c", () => $606334c7ff6e8c2f$export$db3b6bfb95261072);

var $cozmU = parcelRequire("cozmU");


var $2Yg7J = parcelRequire("2Yg7J");


var $5W8qe = parcelRequire("5W8qe");

'use client';
// Global state used to deduplicate requests and store listeners
const $606334c7ff6e8c2f$export$8b22cf2602fb60ce = new WeakMap();
// Shared state between server components and client components
const $606334c7ff6e8c2f$export$ebd11618f299a286 = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $606334c7ff6e8c2f$export$3a6d5c9ae78a2c08 = /*#__NOINLINE__*/ $606334c7ff6e8c2f$export$ebd11618f299a286();
const $606334c7ff6e8c2f$export$c4ce752e73470fba = Object;
const $606334c7ff6e8c2f$export$f1e1789686576879 = (v)=>v === $606334c7ff6e8c2f$export$3a6d5c9ae78a2c08;
const $606334c7ff6e8c2f$export$407448d2b89b1813 = (v)=>typeof v == 'function';
const $606334c7ff6e8c2f$export$953cecd6e717a553 = (a, b)=>({
        ...a,
        ...b
    });
const $606334c7ff6e8c2f$export$ef35774e6d314e91 = (x)=>$606334c7ff6e8c2f$export$407448d2b89b1813(x.then);
const $606334c7ff6e8c2f$var$EMPTY_CACHE = {};
const $606334c7ff6e8c2f$var$INITIAL_CACHE = {};
const $606334c7ff6e8c2f$var$STR_UNDEFINED = 'undefined';
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const $606334c7ff6e8c2f$export$23f2a1d2818174ef = typeof window != $606334c7ff6e8c2f$var$STR_UNDEFINED;
const $606334c7ff6e8c2f$export$efccba1c4a2ef57b = typeof document != $606334c7ff6e8c2f$var$STR_UNDEFINED;
const $606334c7ff6e8c2f$export$d141bba7fdc215a3 = $606334c7ff6e8c2f$export$23f2a1d2818174ef && 'Deno' in window;
const $606334c7ff6e8c2f$export$4a5767248b18ef41 = ()=>$606334c7ff6e8c2f$export$23f2a1d2818174ef && typeof window['requestAnimationFrame'] != $606334c7ff6e8c2f$var$STR_UNDEFINED;
const $606334c7ff6e8c2f$export$df995fae86a55f06 = (cache, key)=>{
    const state = $606334c7ff6e8c2f$export$8b22cf2602fb60ce.get(cache);
    return [
        // Getter
        ()=>!$606334c7ff6e8c2f$export$f1e1789686576879(key) && cache.get(key) || $606334c7ff6e8c2f$var$EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!$606334c7ff6e8c2f$export$f1e1789686576879(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in $606334c7ff6e8c2f$var$INITIAL_CACHE)) $606334c7ff6e8c2f$var$INITIAL_CACHE[key] = prev;
                state[5](key, $606334c7ff6e8c2f$export$953cecd6e717a553(prev, info), prev || $606334c7ff6e8c2f$var$EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!$606334c7ff6e8c2f$export$f1e1789686576879(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in $606334c7ff6e8c2f$var$INITIAL_CACHE) return $606334c7ff6e8c2f$var$INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !$606334c7ff6e8c2f$export$f1e1789686576879(key) && cache.get(key) || $606334c7ff6e8c2f$var$EMPTY_CACHE;
        }
    ];
} // export { UNDEFINED, OBJECT, isUndefined, isFunction, mergeObjects, isPromiseLike }
;
/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let $606334c7ff6e8c2f$var$online = true;
const $606334c7ff6e8c2f$var$isOnline = ()=>$606334c7ff6e8c2f$var$online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [$606334c7ff6e8c2f$var$onWindowEvent, $606334c7ff6e8c2f$var$offWindowEvent] = $606334c7ff6e8c2f$export$23f2a1d2818174ef && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    $606334c7ff6e8c2f$export$ebd11618f299a286,
    $606334c7ff6e8c2f$export$ebd11618f299a286
];
const $606334c7ff6e8c2f$var$isVisible = ()=>{
    const visibilityState = $606334c7ff6e8c2f$export$efccba1c4a2ef57b && document.visibilityState;
    return $606334c7ff6e8c2f$export$f1e1789686576879(visibilityState) || visibilityState !== 'hidden';
};
const $606334c7ff6e8c2f$var$initFocus = (callback)=>{
    // focus revalidate
    if ($606334c7ff6e8c2f$export$efccba1c4a2ef57b) document.addEventListener('visibilitychange', callback);
    $606334c7ff6e8c2f$var$onWindowEvent('focus', callback);
    return ()=>{
        if ($606334c7ff6e8c2f$export$efccba1c4a2ef57b) document.removeEventListener('visibilitychange', callback);
        $606334c7ff6e8c2f$var$offWindowEvent('focus', callback);
    };
};
const $606334c7ff6e8c2f$var$initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        $606334c7ff6e8c2f$var$online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        $606334c7ff6e8c2f$var$online = false;
    };
    $606334c7ff6e8c2f$var$onWindowEvent('online', onOnline);
    $606334c7ff6e8c2f$var$onWindowEvent('offline', onOffline);
    return ()=>{
        $606334c7ff6e8c2f$var$offWindowEvent('online', onOnline);
        $606334c7ff6e8c2f$var$offWindowEvent('offline', onOffline);
    };
};
const $606334c7ff6e8c2f$export$ffb5f4729a158638 = {
    isOnline: $606334c7ff6e8c2f$var$isOnline,
    isVisible: $606334c7ff6e8c2f$var$isVisible
};
const $606334c7ff6e8c2f$export$9e5f44173e64f162 = {
    initFocus: $606334c7ff6e8c2f$var$initFocus,
    initReconnect: $606334c7ff6e8c2f$var$initReconnect
};
const $606334c7ff6e8c2f$export$9bb611d729802a56 = !(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useId;
const $606334c7ff6e8c2f$export$43caf9889c228507 = !$606334c7ff6e8c2f$export$23f2a1d2818174ef || $606334c7ff6e8c2f$export$d141bba7fdc215a3;
// Polyfill requestAnimationFrame
const $606334c7ff6e8c2f$export$625550452a3fa3ec = (f)=>$606334c7ff6e8c2f$export$4a5767248b18ef41() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const $606334c7ff6e8c2f$export$3b14a55fb2447963 = $606334c7ff6e8c2f$export$43caf9889c228507 ? (0, $cozmU.useEffect) : (0, $cozmU.useLayoutEffect);
// This assignment is to extend the Navigator type to use effectiveType.
const $606334c7ff6e8c2f$var$navigatorConnection = typeof navigator !== 'undefined' && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const $606334c7ff6e8c2f$export$90a7f3efeed30595 = !$606334c7ff6e8c2f$export$43caf9889c228507 && $606334c7ff6e8c2f$var$navigatorConnection && ([
    'slow-2g',
    '2g'
].includes($606334c7ff6e8c2f$var$navigatorConnection.effectiveType) || $606334c7ff6e8c2f$var$navigatorConnection.saveData);
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $606334c7ff6e8c2f$var$table = new WeakMap();
const $606334c7ff6e8c2f$var$getTypeName = (value)=>$606334c7ff6e8c2f$export$c4ce752e73470fba.prototype.toString.call(value);
const $606334c7ff6e8c2f$var$isObjectTypeName = (typeName, type)=>typeName === `[object ${type}]`;
// counter of the key
let $606334c7ff6e8c2f$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $606334c7ff6e8c2f$export$882b5998b3b9117c = (arg)=>{
    const type = typeof arg;
    const typeName = $606334c7ff6e8c2f$var$getTypeName(arg);
    const isDate = $606334c7ff6e8c2f$var$isObjectTypeName(typeName, 'Date');
    const isRegex = $606334c7ff6e8c2f$var$isObjectTypeName(typeName, 'RegExp');
    const isPlainObject = $606334c7ff6e8c2f$var$isObjectTypeName(typeName, 'Object');
    let result;
    let index;
    if ($606334c7ff6e8c2f$export$c4ce752e73470fba(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $606334c7ff6e8c2f$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$606334c7ff6e8c2f$var$counter + '~';
        $606334c7ff6e8c2f$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $606334c7ff6e8c2f$export$882b5998b3b9117c(arg[index]) + ',';
            $606334c7ff6e8c2f$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            const keys = $606334c7ff6e8c2f$export$c4ce752e73470fba.keys(arg).sort();
            while(!$606334c7ff6e8c2f$export$f1e1789686576879(index = keys.pop()))if (!$606334c7ff6e8c2f$export$f1e1789686576879(arg[index])) result += index + ':' + $606334c7ff6e8c2f$export$882b5998b3b9117c(arg[index]) + ',';
            $606334c7ff6e8c2f$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
const $606334c7ff6e8c2f$export$2408f22a0fab9ae5 = (key)=>{
    if ($606334c7ff6e8c2f$export$407448d2b89b1813(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $606334c7ff6e8c2f$export$882b5998b3b9117c(key) : '';
    return [
        key,
        args
    ];
};
// Global timestamp.
let $606334c7ff6e8c2f$var$__timestamp = 0;
const $606334c7ff6e8c2f$export$ae1af26003f05816 = ()=>++$606334c7ff6e8c2f$var$__timestamp;
async function $606334c7ff6e8c2f$export$7ccc53e8f1e7dfc5(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = $606334c7ff6e8c2f$export$953cecd6e717a553({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === 'boolean' ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === 'function' ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if ($606334c7ff6e8c2f$export$407448d2b89b1813(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for (const key of it)if (!/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) matchedKeys.push(key);
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = $606334c7ff6e8c2f$export$2408f22a0fab9ae5(_k);
        if (!key) return;
        const [get, set] = $606334c7ff6e8c2f$export$df995fae86a55f06(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = $606334c7ff6e8c2f$export$8b22cf2602fb60ce.get(cache);
        const startRevalidate = ()=>{
            const revalidators = EVENT_REVALIDATORS[key];
            const revalidate = $606334c7ff6e8c2f$export$407448d2b89b1813(options.revalidate) ? options.revalidate(get().data, _k) : options.revalidate !== false;
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                delete PRELOAD[key];
                if (revalidators && revalidators[0]) return revalidators[0]($2Yg7J.MUTATE_EVENT).then(()=>get().data);
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) // Revalidate and broadcast state.
        return startRevalidate();
        let data = _data;
        let error;
        let isError = false;
        // Update global timestamps.
        const beforeMutationTs = $606334c7ff6e8c2f$export$ae1af26003f05816();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !$606334c7ff6e8c2f$export$f1e1789686576879(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = $606334c7ff6e8c2f$export$f1e1789686576879(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = $606334c7ff6e8c2f$export$407448d2b89b1813(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if ($606334c7ff6e8c2f$export$407448d2b89b1813(data)) // `data` is a function, call it passing current cache value.
        try {
            data = data(committedData);
        } catch (err) {
            // If it throws an error synchronously, we shouldn't update the cache.
            error = err;
            isError = true;
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && $606334c7ff6e8c2f$export$ef35774e6d314e91(data)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
                isError = true;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (isError) throw error;
                return data;
            } else if (isError && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data: committedData,
                    _c: $606334c7ff6e8c2f$export$3a6d5c9ae78a2c08
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!isError) {
                // Transform the result into data.
                if ($606334c7ff6e8c2f$export$407448d2b89b1813(populateCache)) {
                    const populateCachedData = populateCache(data, committedData);
                    set({
                        data: populateCachedData,
                        error: $606334c7ff6e8c2f$export$3a6d5c9ae78a2c08,
                        _c: $606334c7ff6e8c2f$export$3a6d5c9ae78a2c08
                    });
                } else // Only update cached data and reset the error if there's no error. Data can be `undefined` here.
                set({
                    data: data,
                    error: $606334c7ff6e8c2f$export$3a6d5c9ae78a2c08,
                    _c: $606334c7ff6e8c2f$export$3a6d5c9ae78a2c08
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = $606334c7ff6e8c2f$export$ae1af26003f05816();
        // Update existing SWR Hooks' internal states:
        Promise.resolve(startRevalidate()).then(()=>{
            // The mutation and revalidation are ended, we can clear it since the data is
            // not an optimistic value anymore.
            set({
                _c: $606334c7ff6e8c2f$export$3a6d5c9ae78a2c08
            });
        });
        // Throw error or return data
        if (isError) {
            if (throwOnError) throw error;
            return;
        }
        return data;
    }
}
const $606334c7ff6e8c2f$var$revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators)if (revalidators[key][0]) revalidators[key][0](type);
};
const $606334c7ff6e8c2f$export$dda1d9f60106f0e9 = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!$606334c7ff6e8c2f$export$8b22cf2602fb60ce.has(provider)) {
        const opts = $606334c7ff6e8c2f$export$953cecd6e717a553($606334c7ff6e8c2f$export$9e5f44173e64f162, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = Object.create(null);
        const mutate = $606334c7ff6e8c2f$export$7ccc53e8f1e7dfc5.bind($606334c7ff6e8c2f$export$3a6d5c9ae78a2c08, provider);
        let unmount = $606334c7ff6e8c2f$export$ebd11618f299a286;
        const subscriptions = Object.create(null);
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) for (const fn of subs)fn(value, prev);
        };
        const initProvider = ()=>{
            if (!$606334c7ff6e8c2f$export$8b22cf2602fb60ce.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                $606334c7ff6e8c2f$export$8b22cf2602fb60ce.set(provider, [
                    EVENT_REVALIDATORS,
                    Object.create(null),
                    Object.create(null),
                    Object.create(null),
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!$606334c7ff6e8c2f$export$43caf9889c228507) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind($606334c7ff6e8c2f$export$3a6d5c9ae78a2c08, $606334c7ff6e8c2f$var$revalidateAllKeys.bind($606334c7ff6e8c2f$export$3a6d5c9ae78a2c08, EVENT_REVALIDATORS, $2Yg7J.FOCUS_EVENT)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind($606334c7ff6e8c2f$export$3a6d5c9ae78a2c08, $606334c7ff6e8c2f$var$revalidateAllKeys.bind($606334c7ff6e8c2f$export$3a6d5c9ae78a2c08, EVENT_REVALIDATORS, $2Yg7J.RECONNECT_EVENT)));
                    unmount = ()=>{
                        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                        releaseFocus && releaseFocus();
                        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        $606334c7ff6e8c2f$export$8b22cf2602fb60ce.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        $606334c7ff6e8c2f$export$8b22cf2602fb60ce.get(provider)[4]
    ];
};
// error retry
const $606334c7ff6e8c2f$var$onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!$606334c7ff6e8c2f$export$f1e1789686576879(maxRetryCount) && currentRetryCount > maxRetryCount) return;
    setTimeout(revalidate, timeout, opts);
};
const $606334c7ff6e8c2f$export$342063e11d6c3cad = (0, $5W8qe.dequal);
// Default cache provider
const [$606334c7ff6e8c2f$export$db3b6bfb95261072, $606334c7ff6e8c2f$export$35e795649ee09318] = $606334c7ff6e8c2f$export$dda1d9f60106f0e9(new Map());
// Default config
const $606334c7ff6e8c2f$export$4368d992c4eafac0 = $606334c7ff6e8c2f$export$953cecd6e717a553({
    // events
    onLoadingSlow: $606334c7ff6e8c2f$export$ebd11618f299a286,
    onSuccess: $606334c7ff6e8c2f$export$ebd11618f299a286,
    onError: $606334c7ff6e8c2f$export$ebd11618f299a286,
    onErrorRetry: $606334c7ff6e8c2f$var$onErrorRetry,
    onDiscarded: $606334c7ff6e8c2f$export$ebd11618f299a286,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: $606334c7ff6e8c2f$export$90a7f3efeed30595 ? 10000 : 5000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: $606334c7ff6e8c2f$export$90a7f3efeed30595 ? 5000 : 3000,
    compare: // providers
    $606334c7ff6e8c2f$export$342063e11d6c3cad,
    isPaused: ()=>false,
    cache: $606334c7ff6e8c2f$export$db3b6bfb95261072,
    mutate: $606334c7ff6e8c2f$export$35e795649ee09318,
    fallback: {}
}, $606334c7ff6e8c2f$export$ffb5f4729a158638);
const $606334c7ff6e8c2f$export$2d1720544b23b823 = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = $606334c7ff6e8c2f$export$953cecd6e717a553(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1, fallback: f1 } = a;
        const { use: u2, fallback: f2 } = b;
        if (u1 && u2) v.use = u1.concat(u2);
        if (f1 && f2) v.fallback = $606334c7ff6e8c2f$export$953cecd6e717a553(f1, f2);
    }
    return v;
};
const $606334c7ff6e8c2f$export$25ce5a424b770e84 = (0, $cozmU.createContext)({});
const $606334c7ff6e8c2f$export$39b482c5e57630a8 = (props)=>{
    const { value: value } = props;
    const parentConfig = (0, $cozmU.useContext)($606334c7ff6e8c2f$export$25ce5a424b770e84);
    const isFunctionalConfig = $606334c7ff6e8c2f$export$407448d2b89b1813(value);
    const config = (0, $cozmU.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0, $cozmU.useMemo)(()=>isFunctionalConfig ? config : $606334c7ff6e8c2f$export$2d1720544b23b823(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // initialize the cache only on first access.
    const cacheContextRef = (0, $cozmU.useRef)($606334c7ff6e8c2f$export$3a6d5c9ae78a2c08);
    if (provider && !cacheContextRef.current) cacheContextRef.current = $606334c7ff6e8c2f$export$dda1d9f60106f0e9(provider(extendedConfig.cache || $606334c7ff6e8c2f$export$db3b6bfb95261072), config);
    const cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    $606334c7ff6e8c2f$export$3b14a55fb2447963(()=>{
        if (cacheContext) {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0, $cozmU.createElement)($606334c7ff6e8c2f$export$25ce5a424b770e84.Provider, $606334c7ff6e8c2f$export$953cecd6e717a553(props, {
        value: extendedConfig
    }));
};
module.exports["b"] = $606334c7ff6e8c2f$export$8b22cf2602fb60ce;
module.exports["A"] = $606334c7ff6e8c2f$export$ebd11618f299a286;
module.exports["U"] = $606334c7ff6e8c2f$export$3a6d5c9ae78a2c08;
module.exports["O"] = $606334c7ff6e8c2f$export$c4ce752e73470fba;
module.exports["e"] = $606334c7ff6e8c2f$export$f1e1789686576879;
module.exports["a"] = $606334c7ff6e8c2f$export$407448d2b89b1813;
module.exports["m"] = $606334c7ff6e8c2f$export$953cecd6e717a553;
module.exports["B"] = $606334c7ff6e8c2f$export$ef35774e6d314e91;
module.exports["i"] = $606334c7ff6e8c2f$export$23f2a1d2818174ef;
module.exports["z"] = $606334c7ff6e8c2f$export$df995fae86a55f06;
module.exports["I"] = $606334c7ff6e8c2f$export$9bb611d729802a56;
module.exports["r"] = $606334c7ff6e8c2f$export$43caf9889c228507;
module.exports["t"] = $606334c7ff6e8c2f$export$625550452a3fa3ec;
module.exports["u"] = $606334c7ff6e8c2f$export$3b14a55fb2447963;
module.exports["s"] = $606334c7ff6e8c2f$export$2408f22a0fab9ae5;
module.exports["o"] = $606334c7ff6e8c2f$export$ae1af26003f05816;
module.exports["n"] = $606334c7ff6e8c2f$export$7ccc53e8f1e7dfc5;
module.exports["d"] = $606334c7ff6e8c2f$export$4368d992c4eafac0;
module.exports["f"] = $606334c7ff6e8c2f$export$2d1720544b23b823;
module.exports["S"] = $606334c7ff6e8c2f$export$25ce5a424b770e84;
module.exports["g"] = $606334c7ff6e8c2f$export$39b482c5e57630a8;

});

parcelRegister("2Yg7J", function(module, exports) {
const $229db13431cd9163$export$831c820ad60f9d12 = 0;
const $229db13431cd9163$export$24e9454cb99a11dc = 1;
const $229db13431cd9163$export$75ea288459391154 = 2;
const $229db13431cd9163$export$b019c3839228f243 = 3;
module.exports["FOCUS_EVENT"] = $229db13431cd9163$export$831c820ad60f9d12;
module.exports["RECONNECT_EVENT"] = $229db13431cd9163$export$24e9454cb99a11dc;
module.exports["MUTATE_EVENT"] = $229db13431cd9163$export$75ea288459391154;
module.exports["ERROR_REVALIDATE_EVENT"] = $229db13431cd9163$export$b019c3839228f243;

});

parcelRegister("5W8qe", function(module, exports) {
var $4528e6ffac657016$var$has = Object.prototype.hasOwnProperty;
function $4528e6ffac657016$export$de8294bb3be0322f(foo, bar) {
    var ctor, len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $4528e6ffac657016$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($4528e6ffac657016$var$has.call(foo, ctor) && ++len && !$4528e6ffac657016$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$4528e6ffac657016$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}
module.exports["dequal"] = $4528e6ffac657016$export$de8294bb3be0322f;

});

parcelRegister("3PVFp", function(module, exports) {
$parcel$export(module.exports, "useSWRConfig", () => $2cb2ddf873b575a0$export$f1dc0e282d4c1c0);
$parcel$export(module.exports, "withArgs", () => $2cb2ddf873b575a0$export$84d44e54e14b0133);
$parcel$export(module.exports, "subscribeCallback", () => $2cb2ddf873b575a0$export$e005210ed621746);
$parcel$export(module.exports, "SWRGlobalState", () => (parcelRequire("8h4fq")).b);
$parcel$export(module.exports, "defaultConfig", () => (parcelRequire("8h4fq")).d);
$parcel$export(module.exports, "isFunction", () => (parcelRequire("8h4fq")).a);
$parcel$export(module.exports, "isUndefined", () => (parcelRequire("8h4fq")).e);
$parcel$export(module.exports, "mergeObjects", () => (parcelRequire("8h4fq")).m);
$parcel$export(module.exports, "serialize", () => (parcelRequire("8h4fq")).s);

var $8h4fq = parcelRequire("8h4fq");


var $2Yg7J = parcelRequire("2Yg7J");


var $lv9Y3 = parcelRequire("lv9Y3");


var $cozmU = parcelRequire("cozmU");


// @ts-expect-error
const $2cb2ddf873b575a0$var$enableDevtools = (0, $8h4fq.i) && window.__SWR_DEVTOOLS_USE__;
const $2cb2ddf873b575a0$var$use = $2cb2ddf873b575a0$var$enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const $2cb2ddf873b575a0$var$setupDevTools = ()=>{
    if ($2cb2ddf873b575a0$var$enableDevtools) // @ts-expect-error
    window.__SWR_DEVTOOLS_REACT__ = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU)));
};
const $2cb2ddf873b575a0$export$a3295358bff77e = (args)=>{
    return (0, $8h4fq.a)(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
const $2cb2ddf873b575a0$export$f1dc0e282d4c1c0 = ()=>{
    const parentConfig = (0, $cozmU.useContext)((0, $8h4fq.S));
    const mergedConfig = (0, $cozmU.useMemo)(()=>(0, $8h4fq.m)((0, $8h4fq.d), parentConfig), [
        parentConfig
    ]);
    return mergedConfig;
};
const $2cb2ddf873b575a0$export$513ccb98c53b8039 = (key_, fetcher)=>{
    const [key, fnArg] = (0, $8h4fq.s)(key_);
    const [, , , PRELOAD] = (0, $8h4fq.b).get((0, $8h4fq.c));
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
const $2cb2ddf873b575a0$var$middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const [key] = (0, $8h4fq.s)(key_);
            const [, , , PRELOAD] = (0, $8h4fq.b).get((0, $8h4fq.c));
            if (key.startsWith((0, $lv9Y3.INFINITE_PREFIX))) // we want the infinite fetcher to be called.
            // handling of the PRELOAD cache happens there.
            return fetcher_(...args);
            const req = PRELOAD[key];
            if ((0, $8h4fq.e)(req)) return fetcher_(...args);
            delete PRELOAD[key];
            return req;
        });
        return useSWRNext(key_, fetcher, config);
    };
const $2cb2ddf873b575a0$var$BUILT_IN_MIDDLEWARE = $2cb2ddf873b575a0$var$use.concat($2cb2ddf873b575a0$var$middleware);
// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const $2cb2ddf873b575a0$export$84d44e54e14b0133 = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = $2cb2ddf873b575a0$export$f1dc0e282d4c1c0();
        // Normalize arguments.
        const [key, fn, _config] = $2cb2ddf873b575a0$export$a3295358bff77e(args);
        // Merge configurations.
        const config = (0, $8h4fq.f)(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use: use } = config;
        const middleware = (use || []).concat($2cb2ddf873b575a0$var$BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;)next = middleware[i](next);
        return next(key, fn || config.fetcher || null, config);
    };
};
// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const $2cb2ddf873b575a0$export$e005210ed621746 = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};
// Create a custom hook with a middleware
const $2cb2ddf873b575a0$export$525ea7fc6ba00096 = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = $2cb2ddf873b575a0$export$a3295358bff77e(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};
$2cb2ddf873b575a0$var$setupDevTools();

});

parcelRegister("lv9Y3", function(module, exports) {
const $fa743998d40d8600$export$8667f065faedc62c = '$inf$';
module.exports["INFINITE_PREFIX"] = $fa743998d40d8600$export$8667f065faedc62c;

});

parcelRegister("eZLpN", function(module, exports) {

var $26Yfd = parcelRequire("26Yfd");


var $1GTIR = parcelRequire("1GTIR");


var $fqCbQ = parcelRequire("fqCbQ");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");

function $2589de0f689b9a54$export$fc06099c27831dd7({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, onCompleted: onCompleted, onError: onError, transformError: transformError, fetchPolicy: fetchPolicy = 'cache-first', variables: variables, pollInterval: pollInterval }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables,
        parseResult: parseResult
    });
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    return $2589de0f689b9a54$export$846a05bdbd4f6c21({
        key: key,
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        fetchPolicy: fetchPolicy,
        pollInterval: pollInterval
    });
}
function $2589de0f689b9a54$export$846a05bdbd4f6c21(params) {
    const { queryState: queryState, execute: baseExecute, stopPolling: stopPolling } = (0, $fqCbQ.useExperimentalQueryExecution)({
        ...params,
        isLazyQuery: true
    });
    const execute = (0, $26Yfd.useStableCallback)(async (options)=>{
        await baseExecute(options?.variables);
    });
    return [
        execute,
        {
            ...queryState ?? (0, $7ji4X.INITIAL_IDLE_STATE),
            stopPolling: stopPolling
        }
    ];
}
module.exports["useExperimentalLazyQuery"] = $2589de0f689b9a54$export$fc06099c27831dd7;

});

parcelRegister("59MXn", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3U8XR = parcelRequire("3U8XR");


var $9DHhW = parcelRequire("9DHhW");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $6fil2 = parcelRequire("6fil2");

var $f7B1p = parcelRequire("f7B1p");

var $flE5X = parcelRequire("flE5X");


var $bQm3c = parcelRequire("bQm3c");


var $gFlI1 = parcelRequire("gFlI1");


var $fdPUP = parcelRequire("fdPUP");


var $lf3m6 = parcelRequire("lf3m6");

class $ca931691e16eb076$var$UserSuggestionsCache {
    setContext(siteId, orgId, userId, contextType, containerId, objectId, mentionsSessionId) {
        this._siteId = siteId;
        this._orgId = orgId;
        this._userId = userId;
        this._contextType = contextType;
        this._containerId = containerId;
        this._objectId = objectId;
        this._mentionsSessionId = mentionsSessionId;
    }
    setSiteId(siteId) {
        this._siteId = siteId;
    }
    setOrgId(orgId) {
        this._orgId = orgId;
    }
    fullCacheAndStateReset() {
        this._abortAndResetAbortController();
        this._resetUserSuggestionsPromiseState();
        this._resetUserSuggestionsCacheState();
    }
    async hydrateUserSuggestionsCache(isEntitledExternalCollaboration) {
        /** Any errors here will get caught in the usePreloadUserSuggestions hook */ await this._fetchAndCacheUserSuggestions(isEntitledExternalCollaboration);
        return this._userSuggestions;
    }
    async getSuggestedUsers(currentPickedPrincipalIds, isEntitledExternalCollaboration, maxDisplayResults = this._maxNumberOfDisplayResults, shouldFetchMoreResults = true, contextType, siteId, orgId, containerId, objectId, mentionsSessionId) {
        /** Any errors here will get caught in the useUserSuggestions hook */ if (this._userSuggestionsPromiseState === 'empty' || this._shouldFetchAdditionalSuggestions) {
            if (!this._siteId && siteId) this.setSiteId(siteId);
            if (!this._orgId && orgId) this.setOrgId(orgId);
            if (!this._contextType && contextType) this._contextType = contextType;
            if (!this._containerId && containerId) this._containerId = containerId;
            if (!this._objectId && objectId) this._objectId = objectId;
            if (!this._mentionsSessionId && mentionsSessionId) this._mentionsSessionId = mentionsSessionId;
            await this._fetchAndCacheUserSuggestions(isEntitledExternalCollaboration, contextType, containerId, objectId, mentionsSessionId);
        }
        const usersIdsExcludedFromShownSuggestions = [
            ...currentPickedPrincipalIds,
            this._userId
        ];
        const unfilteredServerResults = await this._userSuggestions;
        // Although we allow for maxDisplayResults to be any number, we only fetch 10 at a time so realistically we only display 10 max
        const userFacingDisplayResults = unfilteredServerResults.filter(({ id: id })=>!usersIdsExcludedFromShownSuggestions.includes(id)).slice(0, maxDisplayResults);
        this._shouldFetchAdditionalSuggestions = userFacingDisplayResults.length < this._criticallyLowDisplayResults && this._currentRequestedServerResults <= this._requestedServerResultsHardCap && this._userSuggestionsPromiseState === 'resolved' && this._noMoreServerResults === false && shouldFetchMoreResults;
        if (this._shouldFetchAdditionalSuggestions) {
            this._currentRequestedServerResults += this._serverResultsIncreaseDelta;
            return this.getSuggestedUsers(currentPickedPrincipalIds, isEntitledExternalCollaboration, maxDisplayResults, shouldFetchMoreResults, contextType, siteId, orgId, containerId, objectId, mentionsSessionId);
        }
        return userFacingDisplayResults;
    }
    _abortAndResetAbortController() {
        this._abortController?.abort();
        this._abortController = new AbortController();
    }
    _resetUserSuggestionsPromiseState() {
        this._userSuggestions = new Promise((resolve, reject)=>{
            this._resolveUserSuggestions = resolve;
            this._rejectUserSuggestions = reject;
        });
        this._userSuggestionsPromiseState = 'empty';
    }
    _resetUserSuggestionsCacheState() {
        this._shouldFetchAdditionalSuggestions = false;
        this._currentRequestedServerResults = 10;
        this._noMoreServerResults = false;
    }
    createContextPayload(contextType, containerId, objectId, mentionsSessionId) {
        return (0, $3U8XR.match)({
            contextType: contextType || this._contextType,
            containerId: containerId || this._containerId,
            objectId: objectId || this._objectId,
            mentionsSessionId: mentionsSessionId || this._mentionsSessionId,
            siteId: this._siteId,
            orgId: this._orgId
        }).with({
            contextType: (0, $3U8XR.P).string,
            containerId: (0, $3U8XR.P).string,
            objectId: (0, $3U8XR.P).string,
            mentionsSessionId: (0, $3U8XR.P).string
        }, (res)=>({
                contextType: res.contextType,
                containerId: res.containerId,
                objectId: res.objectId,
                mentionsSessionId: res.mentionsSessionId,
                principalId: 'context',
                productKey: 'confluence',
                siteId: res.siteId,
                organizationId: res.orgId
            })).with({
            contextType: (0, $3U8XR.P).string
        }, (res)=>({
                contextType: res.contextType,
                principalId: 'context',
                productKey: 'confluence',
                siteId: res.siteId,
                organizationId: res.orgId
            })).otherwise((res)=>({
                contextType: 'share-and-restrict-dialog:user-and-group-search:suggested-share-users',
                principalId: 'context',
                productKey: 'confluence',
                siteId: res.siteId,
                organizationId: res.orgId
            }));
    }
    async _fetchAndCacheUserSuggestions(isEntitledExternalCollaboration, contextType, containerId, objectId, mentionsSessionId) {
        try {
            /** No more fetching in the same dialog session if we got an error */ if (this._userSuggestionsPromiseState === 'rejected') return this._userSuggestions;
            this._abortAndResetAbortController();
            this._resetUserSuggestionsPromiseState();
            this._userSuggestionsPromiseState = 'pending';
            const contextPayload = this.createContextPayload(contextType, containerId, objectId, mentionsSessionId);
            const response = await (0, $f7B1p.cfetch)(this._recommendationsApi, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    context: contextPayload,
                    searchQuery: {
                        cpusQueryHighlights: {
                            query: '',
                            field: ''
                        },
                        customQuery: '',
                        customerDirectoryId: '',
                        minimumAccessLevel: 'APPLICATION',
                        productAccessPermissionIds: isEntitledExternalCollaboration ? [
                            'write',
                            'external-collaborator-write'
                        ] : [
                            'write'
                        ],
                        queryString: '',
                        restrictTo: {
                            userIds: [],
                            groupIds: []
                        },
                        searchUserbase: false
                    },
                    includeNonLicensedUsers: false,
                    includeTeams: false,
                    includeGroups: false,
                    includeUsers: true,
                    performSearchQueryOnly: false,
                    maxNumberOfResults: this._currentRequestedServerResults
                }),
                signal: this._abortController?.signal
            });
            const { recommendedUsers: recommendedUsers } = await response.json();
            const formattedUsers = recommendedUsers.map(({ id: id, name: name, email: email, avatarUrl: avatarUrl, userType: userType })=>({
                    type: 'user',
                    id: id,
                    name: name,
                    email: email,
                    avatarUrl: avatarUrl,
                    ...userType !== undefined ? {
                        userType: userType
                    } : {}
                }));
            this._resolveUserSuggestions(formattedUsers);
            this._noMoreServerResults = formattedUsers.length < this._currentRequestedServerResults;
            this._userSuggestionsPromiseState = 'resolved';
        } catch (e) {
            if (e instanceof (0, $flE5X.NoNetworkError) && (0, $6fil2.causedByAbortError)(e)) ;
            else {
                /** Any errors here will get caught in the consuming methods or hooks */ this._rejectUserSuggestions(e);
                this._userSuggestionsPromiseState = 'rejected';
            }
        } finally{
            this._shouldFetchAdditionalSuggestions = false;
        }
    }
    constructor(){
        this._userSuggestions = void 0;
        this._resolveUserSuggestions = void 0;
        this._rejectUserSuggestions = void 0;
        this._userSuggestionsPromiseState = void 0;
        /** URS API Route */ this._recommendationsApi = '/gateway/api/v1/recommendations';
        /** The number of displayed suggestions below which we trigger a fetch */ this._criticallyLowDisplayResults = 3;
        /** Max number of user suggestions shown at any one time */ this._maxNumberOfDisplayResults = 3;
        /** Self-imposed limit, which if reached turns off additional fetching */ this._requestedServerResultsHardCap = 60;
        /** The amount by which we increase the requested results every time we fetch.
     * Since the API is not paginated, we have to increase the amount of suggestions
     * we request from the API for the user to see additional suggestions. Each additional
     * round we increase the requested results by 10 until we reach the self-imposed hard-cap.
     */ this._serverResultsIncreaseDelta = 10;
        /** After initial hydration we look at this variable to know whether to trigger another fetch */ this._shouldFetchAdditionalSuggestions = false;
        /** The current amount of suggestions we request from the API. Gets increased by _serverResultsIncreaseDelta
     * with every following fetch until the hard cap of _requestedServerResultsHardCap is reached
     * At that point we stop allowing fetching of additional results to avoid abusing the API
     */ this._currentRequestedServerResults = 10;
        /** If _currentRequestedServerResults is 10, but the API only returns 5 back, then we assume
     * that there are _noMoreServerResults, a.k.a it becomes true
     */ this._noMoreServerResults = false;
        /** Cancel in-flight requests when needed */ this._abortController = void 0;
        this._siteId = '';
        this._orgId = '';
        this._userId = '';
        this._contextType = undefined;
        this._containerId = undefined;
        this._objectId = undefined;
        this._mentionsSessionId = undefined;
        this.fullCacheAndStateReset();
    }
}
const $ca931691e16eb076$export$434f68299dc91067 = new $ca931691e16eb076$var$UserSuggestionsCache();
const $ca931691e16eb076$export$8ac1bc9725285cbb = ({ currentPickedPrincipalIds: currentPickedPrincipalIds, maxDisplayResults: maxDisplayResults, shouldFetchMoreResults: shouldFetchMoreResults, contextType: contextType, siteId: siteId, orgId: orgId, source: source, skip: skip = false, containerId: containerId, objectId: objectId, mentionsSessionId: mentionsSessionId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { isEntitledExternalCollaboration: isEntitledExternalCollaboration, loading: isEntitledExternalCollaborationLoading } = (0, $gFlI1.useIsEntitledExternalCollaborator)();
    const [suggestedUsers, setSuggestedUsers] = (0, $cozmU.useState)(null);
    const [error, setError] = (0, $cozmU.useState)();
    const [loading, setLoading] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        const _fetchUserSuggestions = async ()=>{
            if (skip) return;
            setLoading(true);
            if (!isEntitledExternalCollaborationLoading) try {
                setSuggestedUsers(await $ca931691e16eb076$export$434f68299dc91067.getSuggestedUsers(currentPickedPrincipalIds, isEntitledExternalCollaboration, maxDisplayResults, shouldFetchMoreResults, contextType, siteId, orgId, containerId, objectId, mentionsSessionId));
                /** Reset error state after successful fetch */ setError(undefined);
            } catch (e) {
                setError(e);
            } finally{
                setLoading(false);
            }
        };
        _fetchUserSuggestions();
    }, [
        currentPickedPrincipalIds,
        isEntitledExternalCollaboration,
        isEntitledExternalCollaborationLoading,
        maxDisplayResults,
        shouldFetchMoreResults,
        contextType,
        siteId,
        orgId,
        skip,
        containerId,
        objectId,
        mentionsSessionId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (error) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: source || (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                action: 'errored',
                actionSubject: 'useUserSuggestions',
                attributes: {
                    message: error?.message,
                    name: error?.name,
                    stack: error?.stack,
                    cause: error?.cause
                }
            }
        }).fire();
    }, [
        error,
        source,
        createAnalyticsEvent
    ]);
    return {
        suggestedUsers: suggestedUsers,
        loading: loading,
        error: error
    };
};
const $ca931691e16eb076$export$a7906c54c2a4948b = (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { skip: t2, preserveCacheOnUnmount: t3 } = t1;
    const skip = t2 === undefined ? false : t2;
    const preserveCacheOnUnmount = t3 === undefined ? false : t3;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { cloudId: cloudId, orgId: unsafeOrgId, userId: unsafeUserId } = (0, $bQm3c.useSessionData)();
    const { isEntitledExternalCollaboration: isEntitledExternalCollaboration, loading: isEntitledExternalCollaborationLoading } = (0, $gFlI1.useIsEntitledExternalCollaborator)();
    const { contentId: contentId, spaceId: spaceId, contextType: contextType, mentionsSessionId: mentionsSessionId } = (0, $lf3m6.useUserSuggestionsMentionsExperiment)();
    const [error, setError] = (0, $cozmU.useState)();
    const preserveCacheOnUnmountRef = (0, $cozmU.useRef)(preserveCacheOnUnmount);
    const orgId = unsafeOrgId ?? "";
    const userId = unsafeUserId ?? "";
    let t4;
    let t5;
    if ($[2] !== preserveCacheOnUnmount) {
        t4 = ()=>{
            preserveCacheOnUnmountRef.current = preserveCacheOnUnmount;
        };
        t5 = [
            preserveCacheOnUnmount
        ];
        $[2] = preserveCacheOnUnmount;
        $[3] = t4;
        $[4] = t5;
    } else {
        t4 = $[3];
        t5 = $[4];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    let t7;
    if ($[5] !== cloudId || $[6] !== contentId || $[7] !== contextType || $[8] !== isEntitledExternalCollaboration || $[9] !== isEntitledExternalCollaborationLoading || $[10] !== mentionsSessionId || $[11] !== orgId || $[12] !== skip || $[13] !== spaceId || $[14] !== userId) {
        t6 = ()=>{
            let isEffectActive = true;
            const hydrate = async ()=>{
                try {
                    $ca931691e16eb076$export$434f68299dc91067.setContext(cloudId, orgId, userId, contextType, spaceId, contentId, mentionsSessionId);
                    await $ca931691e16eb076$export$434f68299dc91067.hydrateUserSuggestionsCache(isEntitledExternalCollaboration);
                } catch (t8) {
                    const e = t8;
                    if (isEffectActive) setError(e);
                }
            };
            if (!isEntitledExternalCollaborationLoading && !skip) hydrate();
            return ()=>{
                if (!preserveCacheOnUnmountRef.current) {
                    $ca931691e16eb076$export$434f68299dc91067.fullCacheAndStateReset();
                    return;
                }
                if (!(0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true)) {
                    $ca931691e16eb076$export$434f68299dc91067.fullCacheAndStateReset();
                    return;
                }
                if (!(0, $9wGTI.fg)("confluence_approvals_share_modal")) {
                    $ca931691e16eb076$export$434f68299dc91067.fullCacheAndStateReset();
                    return;
                }
                isEffectActive = false;
            };
        };
        t7 = [
            cloudId,
            orgId,
            userId,
            isEntitledExternalCollaboration,
            isEntitledExternalCollaborationLoading,
            contextType,
            spaceId,
            skip,
            contentId,
            mentionsSessionId
        ];
        $[5] = cloudId;
        $[6] = contentId;
        $[7] = contextType;
        $[8] = isEntitledExternalCollaboration;
        $[9] = isEntitledExternalCollaborationLoading;
        $[10] = mentionsSessionId;
        $[11] = orgId;
        $[12] = skip;
        $[13] = spaceId;
        $[14] = userId;
        $[15] = t6;
        $[16] = t7;
    } else {
        t6 = $[15];
        t7 = $[16];
    }
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    let t9;
    if ($[17] !== createAnalyticsEvent || $[18] !== error) {
        t8 = ()=>{
            if (error) createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                    action: "errored",
                    actionSubject: "usePreloadUserSuggestions",
                    attributes: {
                        message: error?.message,
                        name: error?.name,
                        stack: error?.stack,
                        cause: error?.cause
                    }
                }
            }).fire();
        };
        t9 = [
            error,
            createAnalyticsEvent
        ];
        $[17] = createAnalyticsEvent;
        $[18] = error;
        $[19] = t8;
        $[20] = t9;
    } else {
        t8 = $[19];
        t9 = $[20];
    }
    (0, $cozmU.useEffect)(t8, t9);
};
module.exports["useUserSuggestions"] = $ca931691e16eb076$export$8ac1bc9725285cbb;
module.exports["usePreloadUserSuggestions"] = $ca931691e16eb076$export$a7906c54c2a4948b;

});

parcelRegister("gFlI1", function(module, exports) {

var $1Z6ME = parcelRequire("1Z6ME");


var $7lu50 = parcelRequire("7lu50");


var $jMyy4 = parcelRequire("jMyy4");

const $5cc409285e24cb50$export$7a601c0e3c28bd14 = ({ skip: skip = false } = {})=>{
    const { loading: loading, data: data } = (0, $jMyy4.useQueryInterop)((0, $1Z6ME.default), {
        skip: skip,
        __callerPackage__: "user-and-group-search"
    });
    return {
        isEntitledExternalCollaboration: (0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(data) ?? false,
        loading: loading
    };
};
module.exports["useIsEntitledExternalCollaborator"] = $5cc409285e24cb50$export$7a601c0e3c28bd14;

});

parcelRegister("1Z6ME", function(module, exports) {
/**
 * @generated SignedSource<<838a970ec1267646f6e4f54fd1423c40>>
 * @relayHash 624bb7f2e1333a1dc93bb4e3e1ab1a47
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 50cdeb2f8746825d9a317b38ba0c85a01e96c5247af9f0eb632d2a708fb4be48
const $08d563e748b13a46$var$node = function() {
    var v0 = [
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ExternalCollaboratorFeature",
                    "kind": "LinkedField",
                    "name": "externalCollaborator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "624bb7f2e1333a1dc93bb4e3e1ab1a47",
            "id": "50cdeb2f8746825d9a317b38ba0c85a01e96c5247af9f0eb632d2a708fb4be48",
            "metadata": {},
            "name": "useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery",
            "operationKind": "query",
            "text": "query useIsEntitledExternalCollaboratorUserAndGroupSearchPickerQuery{entitlements{externalCollaborator{isEntitled}}}"
        }
    };
}();
$08d563e748b13a46$var$node.hash = "15c75f072c1c9beaecdb4e535cfc9037";
var $08d563e748b13a46$export$2e2bcd8739ae039 = $08d563e748b13a46$var$node;
module.exports["default"] = $08d563e748b13a46$export$2e2bcd8739ae039;

});

parcelRegister("lf3m6", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");

const $1fe9d405ea0b7d31$export$c8803e7fcf129fb7 = ()=>{
    const $ = (0, $bDgLe.c)(5);
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceId] = (0, $ep3mz.usePageSpaceKey)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = crypto.randomUUID();
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== contentId || $[2] !== spaceId) {
        t1 = {
            contentId: contentId,
            spaceId: spaceId,
            mentionsSessionId: t0,
            contextType: "Mentions"
        };
        $[1] = contentId;
        $[2] = spaceId;
        $[3] = t1;
    } else t1 = $[3];
    const mentionRequestModel = t1;
    if ((0, $6mKj3.expValEquals)("cc_suggested_users_next", "cohort", "variation")) return mentionRequestModel;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            contentId: undefined,
            spaceId: undefined,
            contextType: undefined,
            mentionsSessionId: undefined
        };
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
module.exports["useUserSuggestionsMentionsExperiment"] = $1fe9d405ea0b7d31$export$c8803e7fcf129fb7;

});

parcelRegister("3P1RK", function(module, exports) {

var $fHoxN = parcelRequire("fHoxN");

var $4a56ff9e2636e665$export$ad59ff7dc414850a = /*#__PURE__*/ function(SpacePermissionsTabKey) {
    SpacePermissionsTabKey["Groups"] = "groups";
    SpacePermissionsTabKey["Users"] = "users";
    SpacePermissionsTabKey["Guests"] = "guests";
    SpacePermissionsTabKey["AnonymousAccess"] = "anonymous";
    SpacePermissionsTabKey["PublicLinks"] = "public-links";
    SpacePermissionsTabKey["Analytics"] = "analytics";
    SpacePermissionsTabKey["Apps"] = "apps";
    return SpacePermissionsTabKey;
}({});
const $4a56ff9e2636e665$export$d4f1d7ffc41e2d29 = {
    ["groups"]: (0, $fHoxN.PermissionDisplayType).GROUP,
    ["users"]: (0, $fHoxN.PermissionDisplayType).LICENSED_USER,
    ["guests"]: (0, $fHoxN.PermissionDisplayType).GUEST_USER,
    ["anonymous"]: (0, $fHoxN.PermissionDisplayType).ANONYMOUS
};
module.exports["SpacePermissionsTabKey"] = $4a56ff9e2636e665$export$ad59ff7dc414850a;
module.exports["SPACE_PERMISSION_TAB_KEY_PRINCIPAL_MAP"] = $4a56ff9e2636e665$export$d4f1d7ffc41e2d29;

});

parcelRegister("fHoxN", function(module, exports) {
/**
 * @generated SignedSource<<ea3843edd17bea243ec9dc06a44ce09f>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $8a20bb30841ead37$export$f1a726cdbae0d72a = /*#__PURE__*/ function(PermissionDisplayType) {
    PermissionDisplayType["ANONYMOUS"] = "ANONYMOUS";
    PermissionDisplayType["GROUP"] = "GROUP";
    PermissionDisplayType["GUEST_USER"] = "GUEST_USER";
    PermissionDisplayType["LICENSED_USER"] = "LICENSED_USER";
    return PermissionDisplayType;
}({});
var $8a20bb30841ead37$export$a99f5dae9c149910 = /*#__PURE__*/ function(SpacePermissionType) {
    SpacePermissionType["ADMINISTER_SPACE"] = "ADMINISTER_SPACE";
    SpacePermissionType["ARCHIVE_PAGE"] = "ARCHIVE_PAGE";
    SpacePermissionType["ARCHIVE_SPACE"] = "ARCHIVE_SPACE";
    SpacePermissionType["COMMENT"] = "COMMENT";
    SpacePermissionType["CREATE_ATTACHMENT"] = "CREATE_ATTACHMENT";
    SpacePermissionType["CREATE_BLOG"] = "CREATE_BLOG";
    SpacePermissionType["CREATE_EDIT_PAGE"] = "CREATE_EDIT_PAGE";
    SpacePermissionType["DELETE_SPACE"] = "DELETE_SPACE";
    SpacePermissionType["EDIT_BLOG"] = "EDIT_BLOG";
    SpacePermissionType["EDIT_NATIVE_CONTENT"] = "EDIT_NATIVE_CONTENT";
    SpacePermissionType["EXPORT_CONTENT"] = "EXPORT_CONTENT";
    SpacePermissionType["EXPORT_PAGE"] = "EXPORT_PAGE";
    SpacePermissionType["EXPORT_SPACE"] = "EXPORT_SPACE";
    SpacePermissionType["MANAGE_GUEST_USERS"] = "MANAGE_GUEST_USERS";
    SpacePermissionType["MANAGE_NONLICENSED_USERS"] = "MANAGE_NONLICENSED_USERS";
    SpacePermissionType["MANAGE_PUBLIC_LINKS"] = "MANAGE_PUBLIC_LINKS";
    SpacePermissionType["MANAGE_USERS"] = "MANAGE_USERS";
    SpacePermissionType["REMOVE_ATTACHMENT"] = "REMOVE_ATTACHMENT";
    SpacePermissionType["REMOVE_BLOG"] = "REMOVE_BLOG";
    SpacePermissionType["REMOVE_COMMENT"] = "REMOVE_COMMENT";
    SpacePermissionType["REMOVE_MAIL"] = "REMOVE_MAIL";
    SpacePermissionType["REMOVE_OWN_CONTENT"] = "REMOVE_OWN_CONTENT";
    SpacePermissionType["REMOVE_PAGE"] = "REMOVE_PAGE";
    SpacePermissionType["SET_PAGE_PERMISSIONS"] = "SET_PAGE_PERMISSIONS";
    SpacePermissionType["VIEW_SPACE"] = "VIEW_SPACE";
    return SpacePermissionType;
}({});
module.exports["PermissionDisplayType"] = $8a20bb30841ead37$export$f1a726cdbae0d72a;
module.exports["SpacePermissionType"] = $8a20bb30841ead37$export$a99f5dae9c149910;

});

parcelRegister("gvWVt", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4af2e88caf28e461$export$632b2aa69aba4fdd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iyBz0",
    name: "ExternalCollaboratorUserLozenge",
    loader: async ()=>(await Promise.resolve((parcelRequire("9fywD")))).ExternalUserLozenge
});
module.exports["ExternalCollaboratorUserLozenge"] = $4af2e88caf28e461$export$632b2aa69aba4fdd;

});

parcelRegister("iJxD8", function(module, exports) {

var $15uL0 = parcelRequire("15uL0");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/identity/team/manifest.ts
var $da3684392924794e$var$identityTeamAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $15uL0.IdentityTeamAriResourceOwner),
    resourceType: (0, $15uL0.IdentityTeamAriResourceType),
    resourceIdSlug: "{teamId}",
    resourceIdSegmentFormats: {
        teamId: /[a-zA-Z0-9.\-_~]+/
    }
};
// src/identity/team/index.ts
var $da3684392924794e$export$33bbb2d79e520118 = class _IdentityTeamAri extends (0, $1gKSA.RegisteredAri) {
    get teamId() {
        return this._teamId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $da3684392924794e$var$identityTeamAriStaticOpts.qualifier,
            platformQualifier: $da3684392924794e$var$identityTeamAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $da3684392924794e$var$identityTeamAriStaticOpts.resourceOwner,
            resourceType: $da3684392924794e$var$identityTeamAriStaticOpts.resourceType,
            resourceId: `${opts.teamId}`,
            resourceIdSegmentValues: {
                teamId: opts.teamId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $da3684392924794e$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $da3684392924794e$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(opts);
    }
    getVariables() {
        return {
            teamId: this.teamId
        };
    }
    constructor(opts){
        super(opts), this._teamId = opts.resourceIdSegmentValues.teamId;
    }
};
module.exports["IdentityTeamAri"] = $da3684392924794e$export$33bbb2d79e520118;

});

parcelRegister("15uL0", function(module, exports) {
// src/identity/team/types.ts
var $0cae1dd2c8cb7865$export$49beddf48ffb3f35 = "identity", $0cae1dd2c8cb7865$export$b2079a2a841afe32 = "team";
module.exports["IdentityTeamAriResourceOwner"] = $0cae1dd2c8cb7865$export$49beddf48ffb3f35;
module.exports["IdentityTeamAriResourceType"] = $0cae1dd2c8cb7865$export$b2079a2a841afe32;

});

parcelRegister("2qJQZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hMaHH = parcelRequire("hMaHH");


var $4hmAW = parcelRequire("4hmAW");

const $f3e0d6c6400f29a4$var$PageObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Page" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PageObject({ label: label = 'Page', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $f3e0d6c6400f29a4$export$2e2bcd8739ae039 = $f3e0d6c6400f29a4$var$PageObject;
module.exports["default"] = $f3e0d6c6400f29a4$export$2e2bcd8739ae039;

});

parcelRegister("8lYIw", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7fpiF = parcelRequire("7fpiF");


var $7zgzO = parcelRequire("7zgzO");


var $dHSeC = parcelRequire("dHSeC");

const $9673d4c78655a9a1$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
    const $ = (0, $bDgLe.c)(9);
    const { target: t0, name: name, href: t1, to: t2, params: t3 } = props;
    const target = t0 === undefined ? undefined : t0;
    const href = t1 === undefined ? null : t1;
    const to = t2 === undefined ? null : t2;
    const params = t3 === undefined ? {} : t3;
    const routesContext = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { matchSupportedRoute: matchSupportedRoute, toUrl: toUrl } = routesContext;
    const customPath = href || to;
    if (!customPath && !name) {
        let t4;
        if ($[0] !== props || $[1] !== ref) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9673d4c78655a9a1$var$WrappedAnchor, {
                ...props,
                ref: ref,
                path: ""
            });
            $[0] = props;
            $[1] = ref;
            $[2] = t4;
        } else t4 = $[2];
        return t4;
    }
    const hrefParams = customPath && {
        href: customPath
    };
    const path = toUrl(name, {
        ...params,
        ...hrefParams
    });
    const match = matchSupportedRoute(path);
    let t4;
    if ($[3] !== match || $[4] !== path || $[5] !== props || $[6] !== ref || $[7] !== target) {
        t4 = match && target !== "_blank" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9673d4c78655a9a1$var$WrappedReactRouterLink, {
            ...props,
            ref: ref,
            match: match
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9673d4c78655a9a1$var$WrappedAnchor, {
            ...props,
            ref: ref,
            path: path
        });
        $[3] = match;
        $[4] = path;
        $[5] = props;
        $[6] = ref;
        $[7] = target;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
});
const $9673d4c78655a9a1$var$WrappedAnchor = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, ref)=>{
    const $ = (0, $bDgLe.c)(21);
    let parentProps;
    let path;
    if ($[0] !== t0) {
        ({ path: path, ...parentProps } = t0);
        $[0] = t0;
        $[1] = parentProps;
        $[2] = path;
    } else {
        parentProps = $[1];
        path = $[2];
    }
    const { children: children, className: className, target: t1, testId: testId, style: style, id: id } = parentProps;
    const target = t1 === undefined ? undefined : t1;
    const routesContext = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { onPageReload: onPageReload } = routesContext;
    let t2;
    if ($[3] !== onPageReload || $[4] !== parentProps) {
        t2 = (e)=>{
            onPageReload(e.target.getAttribute("href"), false);
            if (parentProps.onClick) parentProps.onClick(e);
        };
        $[3] = onPageReload;
        $[4] = parentProps;
        $[5] = t2;
    } else t2 = $[5];
    const onAnchorLinkClick = t2;
    let t3;
    if ($[6] !== parentProps) {
        t3 = (e_0)=>{
            parentProps.onContextMenu?.(e_0);
        };
        $[6] = parentProps;
        $[7] = t3;
    } else t3 = $[7];
    const onAnchorContextMenuClick = t3;
    const t4 = target === "_blank" ? "noreferrer" : undefined;
    const t5 = parentProps["aria-label"];
    let t6;
    if ($[8] !== children || $[9] !== className || $[10] !== id || $[11] !== onAnchorContextMenuClick || $[12] !== onAnchorLinkClick || $[13] !== path || $[14] !== ref || $[15] !== style || $[16] !== t4 || $[17] !== t5 || $[18] !== target || $[19] !== testId) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
            href: path,
            className: className,
            onClick: onAnchorLinkClick,
            onContextMenu: onAnchorContextMenuClick,
            target: target,
            id: id,
            rel: t4,
            "data-testid": testId,
            ref: ref,
            "aria-label": t5,
            style: style
        }, children);
        $[8] = children;
        $[9] = className;
        $[10] = id;
        $[11] = onAnchorContextMenuClick;
        $[12] = onAnchorLinkClick;
        $[13] = path;
        $[14] = ref;
        $[15] = style;
        $[16] = t4;
        $[17] = t5;
        $[18] = target;
        $[19] = testId;
        $[20] = t6;
    } else t6 = $[20];
    return t6;
});
const $9673d4c78655a9a1$var$WrappedReactRouterLink = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, ref)=>{
    const $ = (0, $bDgLe.c)(22);
    let match;
    let parentProps;
    if ($[0] !== t0) {
        ({ match: match, ...parentProps } = t0);
        $[0] = t0;
        $[1] = match;
        $[2] = parentProps;
    } else {
        match = $[1];
        parentProps = $[2];
    }
    const routesContext = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { children: children, className: className, style: style, id: id } = parentProps;
    const { preloadRoute: preloadRoute } = routesContext;
    let t1;
    if ($[3] !== match || $[4] !== preloadRoute) {
        t1 = async ()=>preloadRoute(match);
        $[3] = match;
        $[4] = preloadRoute;
        $[5] = t1;
    } else t1 = $[5];
    const onMouseDownCapture = t1;
    let t2;
    if ($[6] !== parentProps || $[7] !== routesContext) {
        t2 = (event)=>{
            if (parentProps.onClick) parentProps.onClick(event);
            const details = (0, $dHSeC.getSpaTransitionDetails)(event, routesContext);
            if (!event.defaultPrevented && details?.href) {
                event.preventDefault();
                routesContext.push(details.href);
            }
        };
        $[6] = parentProps;
        $[7] = routesContext;
        $[8] = t2;
    } else t2 = $[8];
    const onClick = t2;
    let t3;
    if ($[9] !== parentProps) {
        t3 = (e)=>{
            parentProps.onContextMenu?.(e);
        };
        $[9] = parentProps;
        $[10] = t3;
    } else t3 = $[10];
    const onContextMenu = t3;
    const t4 = `${match.pathname}${match.search}${match.hash}`;
    const t5 = parentProps["aria-label"];
    let t6;
    if ($[11] !== children || $[12] !== className || $[13] !== id || $[14] !== onClick || $[15] !== onContextMenu || $[16] !== onMouseDownCapture || $[17] !== ref || $[18] !== style || $[19] !== t4 || $[20] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7fpiF.Link), {
            to: t4,
            className: className,
            onClick: onClick,
            onContextMenu: onContextMenu,
            onMouseDownCapture: onMouseDownCapture,
            innerRef: ref,
            id: id,
            "aria-label": t5,
            style: style
        }, children);
        $[11] = children;
        $[12] = className;
        $[13] = id;
        $[14] = onClick;
        $[15] = onContextMenu;
        $[16] = onMouseDownCapture;
        $[17] = ref;
        $[18] = style;
        $[19] = t4;
        $[20] = t5;
        $[21] = t6;
    } else t6 = $[21];
    return t6;
});
module.exports["Link"] = $9673d4c78655a9a1$export$a6c7ac8248d6e38a;

});

parcelRegister("7fpiF", function(module, exports) {

var $KDAt0 = parcelRequire("KDAt0");


var $cgTkH = parcelRequire("cgTkH");


var $cozmU = parcelRequire("cozmU");


var $22s37 = parcelRequire("22s37");




var $eb3ax = parcelRequire("eb3ax");


var $1eVGO = parcelRequire("1eVGO");


var $bB0i2 = parcelRequire("bB0i2");

/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $546d8f2c65102c44$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $cgTkH.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $22s37.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $KDAt0.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $546d8f2c65102c44$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $cgTkH.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $22s37.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $KDAt0.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component);
var $546d8f2c65102c44$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $546d8f2c65102c44$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $22s37.createLocation)(to, null, null, currentLocation) : to;
};
var $546d8f2c65102c44$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $546d8f2c65102c44$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef;
if (typeof $546d8f2c65102c44$var$forwardRef === "undefined") $546d8f2c65102c44$var$forwardRef = $546d8f2c65102c44$var$forwardRefShim;
function $546d8f2c65102c44$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $546d8f2c65102c44$var$LinkAnchor = $546d8f2c65102c44$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $1eVGO.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $eb3ax.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$546d8f2c65102c44$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($546d8f2c65102c44$var$forwardRefShim !== $546d8f2c65102c44$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $546d8f2c65102c44$export$a6c7ac8248d6e38a = $546d8f2c65102c44$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $546d8f2c65102c44$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $1eVGO.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $KDAt0.__RouterContext).Consumer, null, function(context) {
        !context && (0, $bB0i2.default)(false);
        var history = context.history;
        var location = $546d8f2c65102c44$var$normalizeToLocation($546d8f2c65102c44$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $eb3ax.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $546d8f2c65102c44$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $22s37.createPath)(context.location) === (0, $22s37.createPath)($546d8f2c65102c44$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($546d8f2c65102c44$var$forwardRefShim !== $546d8f2c65102c44$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(component, props);
    });
});
var $546d8f2c65102c44$var$toType, $546d8f2c65102c44$var$refType;
var $546d8f2c65102c44$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $546d8f2c65102c44$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef;
if (typeof $546d8f2c65102c44$var$forwardRef$1 === "undefined") $546d8f2c65102c44$var$forwardRef$1 = $546d8f2c65102c44$var$forwardRefShim$1;
function $546d8f2c65102c44$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $546d8f2c65102c44$export$b0d92dbee9b5b60d = $546d8f2c65102c44$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $1eVGO.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $KDAt0.__RouterContext).Consumer, null, function(context) {
        !context && (0, $bB0i2.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $546d8f2c65102c44$var$normalizeToLocation($546d8f2c65102c44$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $KDAt0.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $546d8f2c65102c44$var$joinClassnames(className, activeClassName);
            style = (0, $eb3ax.default)({}, style, activeStyle);
        }
        var props = (0, $eb3ax.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($546d8f2c65102c44$var$forwardRefShim$1 !== $546d8f2c65102c44$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($546d8f2c65102c44$export$a6c7ac8248d6e38a, props);
    });
});
var $546d8f2c65102c44$var$ariaCurrentType;
module.exports["Link"] = $546d8f2c65102c44$export$a6c7ac8248d6e38a;

});

parcelRegister("22s37", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $5hfGv = parcelRequire("5hfGv");


var $ucZb7 = parcelRequire("ucZb7");



var $bB0i2 = parcelRequire("bB0i2");

function $17c186b078d80207$var$addLeadingSlash(path) {
    return path.charAt(0) === '/' ? path : '/' + path;
}
function $17c186b078d80207$var$stripLeadingSlash(path) {
    return path.charAt(0) === '/' ? path.substr(1) : path;
}
function $17c186b078d80207$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function $17c186b078d80207$var$stripBasename(path, prefix) {
    return $17c186b078d80207$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $17c186b078d80207$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function $17c186b078d80207$export$8ccf933b0513f8d0(path) {
    var pathname = path || '/';
    var search = '';
    var hash = '';
    var hashIndex = pathname.indexOf('#');
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf('?');
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === '?' ? '' : search,
        hash: hash === '#' ? '' : hash
    };
}
function $17c186b078d80207$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || '/';
    if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
    if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
    return path;
}
function $17c186b078d80207$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === 'string') {
        // Two-arg form: push(path, state)
        location = $17c186b078d80207$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $eb3ax.default)({}, path);
        if (location.pathname === undefined) location.pathname = '';
        if (location.search) {
            if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
        } else location.search = '';
        if (location.hash) {
            if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
        } else location.hash = '';
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== '/') location.pathname = (0, $5hfGv.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = '/';
    return location;
}
function $17c186b078d80207$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $ucZb7.default)(a.state, b.state);
}
function $17c186b078d80207$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
            if (typeof result === 'string') {
                if (typeof getUserConfirmation === 'function') getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $17c186b078d80207$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function $17c186b078d80207$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $17c186b078d80207$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
    return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $17c186b078d80207$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $17c186b078d80207$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $17c186b078d80207$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}
var $17c186b078d80207$var$PopStateEvent = 'popstate';
var $17c186b078d80207$var$HashChangeEvent = 'hashchange';
function $17c186b078d80207$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $17c186b078d80207$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$17c186b078d80207$var$canUseDOM && (0, $bB0i2.default)(false);
    var globalHistory = window.history;
    var canUseHistory = $17c186b078d80207$var$supportsHistory();
    var needsHashChangeListener = !$17c186b078d80207$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $17c186b078d80207$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $17c186b078d80207$var$stripTrailingSlash($17c186b078d80207$var$addLeadingSlash(props.basename)) : '';
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $17c186b078d80207$var$stripBasename(path, basename);
        return $17c186b078d80207$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $17c186b078d80207$var$createTransitionManager();
    function setState(nextState) {
        (0, $eb3ax.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($17c186b078d80207$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($17c186b078d80207$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($17c186b078d80207$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $17c186b078d80207$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($17c186b078d80207$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($17c186b078d80207$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($17c186b078d80207$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($17c186b078d80207$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $17c186b078d80207$var$HashChangeEvent$1 = 'hashchange';
var $17c186b078d80207$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === '!' ? path : '!/' + $17c186b078d80207$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === '!' ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $17c186b078d80207$var$stripLeadingSlash,
        decodePath: $17c186b078d80207$var$addLeadingSlash
    },
    slash: {
        encodePath: $17c186b078d80207$var$addLeadingSlash,
        decodePath: $17c186b078d80207$var$addLeadingSlash
    }
};
function $17c186b078d80207$var$stripHash(url) {
    var hashIndex = url.indexOf('#');
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $17c186b078d80207$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf('#');
    return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}
function $17c186b078d80207$var$pushHashPath(path) {
    window.location.hash = path;
}
function $17c186b078d80207$var$replaceHashPath(path) {
    window.location.replace($17c186b078d80207$var$stripHash(window.location.href) + '#' + path);
}
function $17c186b078d80207$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$17c186b078d80207$var$canUseDOM && (0, $bB0i2.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $17c186b078d80207$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $17c186b078d80207$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
    var basename = props.basename ? $17c186b078d80207$var$stripTrailingSlash($17c186b078d80207$var$addLeadingSlash(props.basename)) : '';
    var _HashPathCoders$hashT = $17c186b078d80207$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($17c186b078d80207$var$getHashPath());
        if (basename) path = $17c186b078d80207$var$stripBasename(path, basename);
        return $17c186b078d80207$export$90c043f1c57770b8(path);
    }
    var transitionManager = $17c186b078d80207$var$createTransitionManager();
    function setState(nextState) {
        (0, $eb3ax.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $17c186b078d80207$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $17c186b078d80207$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $17c186b078d80207$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = 'POP';
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($17c186b078d80207$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($17c186b078d80207$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $17c186b078d80207$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $17c186b078d80207$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $17c186b078d80207$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector('base');
        var href = '';
        if (baseTag && baseTag.getAttribute('href')) href = $17c186b078d80207$var$stripHash(window.location.href);
        return href + '#' + encodePath(basename + $17c186b078d80207$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = 'PUSH';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $17c186b078d80207$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $17c186b078d80207$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $17c186b078d80207$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($17c186b078d80207$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $17c186b078d80207$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $17c186b078d80207$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $17c186b078d80207$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($17c186b078d80207$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($17c186b078d80207$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($17c186b078d80207$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: 'POP',
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $17c186b078d80207$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $17c186b078d80207$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        '/'
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $17c186b078d80207$var$createTransitionManager();
    function setState(nextState) {
        (0, $eb3ax.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $17c186b078d80207$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === 'string' ? $17c186b078d80207$export$90c043f1c57770b8(entry, undefined, createKey()) : $17c186b078d80207$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $17c186b078d80207$export$fe53371bee54353d;
    function push(path, state) {
        var action = 'PUSH';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = 'REPLACE';
        var location = $17c186b078d80207$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $17c186b078d80207$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = 'POP';
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: 'POP',
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}
module.exports["createPath"] = $17c186b078d80207$export$fe53371bee54353d;
module.exports["createLocation"] = $17c186b078d80207$export$90c043f1c57770b8;
module.exports["createBrowserHistory"] = $17c186b078d80207$export$719fc203c4e16dee;
module.exports["createHashHistory"] = $17c186b078d80207$export$b71fdd3798280242;

});

parcelRegister("gqypm", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");


var $f7MuR = parcelRequire("f7MuR");

const $a585c4c0c1029461$export$650aef70f4433205 = ({ variables: variables, skip: skip, fetchPolicy: fetchPolicy })=>{
    const legacyResult = (0, $dK51B.useExperimentalQuery)({
        url: ({ cloudId: cloudId, userId: userId })=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`,
        method: 'GET',
        variables: variables,
        parseResult: (json)=>({
                experimentalSiteUserPersonalization: {
                    attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(json.attributes)
                }
            }),
        skip: skip || (0, $6mKj3.expVal)('cc_ce_mau_deprecated_tap_wrappers_migration', 'isEnabled', false)
    });
    const traitsResult = (0, $f7MuR.useSiteUserTraits)({
        skip: skip || !(0, $6mKj3.expVal)('cc_ce_mau_deprecated_tap_wrappers_migration', 'isEnabled', false),
        fetchPolicy: fetchPolicy
    });
    if (!(0, $6mKj3.expVal)('cc_ce_mau_deprecated_tap_wrappers_migration', 'isEnabled', false)) return {
        data: legacyResult.data,
        loading: legacyResult.loading,
        error: legacyResult.error ?? undefined
    };
    // Exp on: adapt traits result into legacy data/loading/error shape
    const adaptedData = traitsResult.data !== null ? {
        experimentalSiteUserPersonalization: {
            attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(traitsResult.data.attributes)
        }
    } : undefined;
    return {
        data: adaptedData,
        loading: traitsResult.loading,
        error: traitsResult.error ?? undefined
    };
};
module.exports["useExperimentalSiteUserPersonalization"] = $a585c4c0c1029461$export$650aef70f4433205;

});

parcelRegister("grWYF", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $8lt1a = parcelRequire("8lt1a");


var $dPJCf = parcelRequire("dPJCf");


var $lsxnT = parcelRequire("lsxnT");


var $fdPUP = parcelRequire("fdPUP");

const $3a4ed6f24f1b06e9$var$useJourneyIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('journeyId');
function $3a4ed6f24f1b06e9$export$715107a573a5fba6(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { onClose: onClose, journeyId: journeyId } = t0;
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== journeyId) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "onboardingPagePermissionsSpotlight",
                    attributes: {
                        source: (0, $fdPUP.SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE),
                        journeyId: journeyId
                    }
                }
            }).fire();
        };
        t2 = [
            createAnalyticsEvent,
            journeyId
        ];
        $[0] = createAnalyticsEvent;
        $[1] = journeyId;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "share-and-restrict-dialog.share-and-restrict-spotlight-onboarding.ok",
            defaultMessage: "Ok"
        });
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== onClose) {
        t4 = [
            {
                onClick: onClose,
                text: t3
            }
        ];
        $[5] = onClose;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "share-and-restrict-dialog.share-and-restrict-spotlight-onboarding.body",
            defaultMessage: "Control who can view, edit, and comment on your pages."
        });
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== Spotlight || $[9] !== t4) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Spotlight, {
            actions: t4,
            target: "share-button-spotlight-target",
            targetRadius: 3,
            targetBgColor: "var(--ds-surface, #FFFFFF)",
            dialogPlacement: "bottom right",
            dialogWidth: 275,
            messageType: "transactional"
        }, t5);
        $[8] = Spotlight;
        $[9] = t4;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
}
function $3a4ed6f24f1b06e9$export$31f46f470e475335() {
    const $ = (0, $bDgLe.c)(10);
    const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
    const journeyId = $3a4ed6f24f1b06e9$var$useJourneyIdQueryParam();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $cozmU.useState)(false);
    const hasRun = (0, $cozmU.useRef)(false);
    const [cachedJourneyId, setCachedJourneyId] = (0, $cozmU.useState)();
    let t0;
    let t1;
    if ($[0] !== journeyId || $[1] !== setQueryParams) {
        t0 = ()=>{
            if (hasRun.current) return;
            hasRun.current = true;
            if (journeyId !== "onboarding-page-permissions") return;
            setCachedJourneyId(journeyId);
            setQueryParams({
                journeyId: null
            });
            setIsSpotlightActive(true);
        };
        t1 = [
            journeyId,
            setQueryParams
        ];
        $[0] = journeyId;
        $[1] = setQueryParams;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setIsSpotlightActive(false);
        $[4] = t2;
    } else t2 = $[4];
    const handleOnClose = t2;
    let t3;
    if ($[5] !== cachedJourneyId || $[6] !== isSpotlightActive) {
        t3 = isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3a4ed6f24f1b06e9$export$715107a573a5fba6, {
            onClose: handleOnClose,
            journeyId: cachedJourneyId
        });
        $[5] = cachedJourneyId;
        $[6] = isSpotlightActive;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lt1a.default), null, t3);
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
}
module.exports["OnboardingPagePermissionsSpotlight"] = $3a4ed6f24f1b06e9$export$715107a573a5fba6;
module.exports["OnboardingPagePermissionsSpotlightLoader"] = $3a4ed6f24f1b06e9$export$31f46f470e475335;

});

parcelRegister("bCECL", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $kLlYX = parcelRequire("kLlYX");


var $cow67 = parcelRequire("cow67");


var $3gdp3 = parcelRequire("3gdp3");


var $hMaHH = parcelRequire("hMaHH");


var $d4GYd = parcelRequire("d4GYd");


var $bDjVc = parcelRequire("bDjVc");


var $lBKFk = parcelRequire("lBKFk");


var $kWSTb = parcelRequire("kWSTb");


var $2hJf7 = parcelRequire("2hJf7");


var $9zxkL = parcelRequire("9zxkL");


var $di8q4 = parcelRequire("di8q4");


var $2JGYp = parcelRequire("2JGYp");

const $b2e0c504f331f5cc$export$a1ea799cb5c1b499 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { type: type, emoji: emoji, color: color, subType: subType, height: t1, isMarkdownMode: t2 } = t0;
    const height = t1 === undefined ? 16 : t1;
    const isMarkdownMode = t2 === undefined ? false : t2;
    const isLivePage = type === "page" && subType === "live" || type === "liveDoc";
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) {
        const t3 = emoji || "";
        let t4;
        if ($[0] !== height || $[1] !== t3 || $[2] !== type) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                emoji: t3,
                contentType: type,
                context: "contentMenu",
                height: height,
                wrapper: $b2e0c504f331f5cc$var$_temp
            });
            $[0] = height;
            $[1] = t3;
            $[2] = type;
            $[3] = t4;
        } else t4 = $[3];
        return t4;
    }
    const actualType = isLivePage && isMarkdownMode ? "markdown" : isLivePage ? "liveDoc" : type;
    const definition = $b2e0c504f331f5cc$var$iconDefinitions[actualType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    let t3;
    if ($[4] !== Icon || $[5] !== color || $[6] !== label.id) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            label: "",
            color: color,
            testId: label.id
        });
        $[4] = Icon;
        $[5] = color;
        $[6] = label.id;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ type: type, emoji: emoji, color: color, subType: subType, height: height = 16, isMarkdownMode: isMarkdownMode = false })=>{
    const isLivePage = type === 'page' && subType === 'live' || type === 'liveDoc';
    // embed favicon/default content type icon will also be handled by the emoji component
    if ((0, $2JGYp.isValidEmojiOrFavicon)(emoji, type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emoji || '',
        contentType: type,
        context: "contentMenu",
        height: height,
        wrapper: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
            }, children)
    });
    const actualType = isLivePage && isMarkdownMode ? 'markdown' : isLivePage ? 'liveDoc' : type;
    const definition = $b2e0c504f331f5cc$var$iconDefinitions[actualType];
    if (!definition) return null;
    const { icon: Icon, label: label } = definition;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        label: "",
        color: color,
        testId: label.id
    });
};
const $b2e0c504f331f5cc$var$emojiWrapperStyles = (0, $buxP3.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '16px',
    width: '16px',
    height: '16px',
    font: 'font.body.large',
    overflow: 'hidden'
});
const $b2e0c504f331f5cc$var$i18n = (0, $kSwu1.defineMessages)({
    liveDoc: {
        id: "icons.content-icon.label.live-doc",
        defaultMessage: "Live Doc"
    },
    page: {
        id: "icons.content-icon.label.page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "icons.content-icon.label.blogpost",
        defaultMessage: "Blog"
    },
    whiteboard: {
        id: "icons.content-icon.label.whiteboard",
        defaultMessage: "Whiteboard"
    },
    database: {
        id: "icons.content-icon.label.database",
        defaultMessage: "Database"
    },
    slide: {
        id: "icons.content-icon.label.slide",
        defaultMessage: "Slide"
    },
    folder: {
        id: "icons.content-icon.label.folder",
        defaultMessage: "Folder"
    },
    space: {
        id: "icons.content-icon.label.space",
        defaultMessage: "Space"
    },
    note: {
        id: "icons.content-icon.label.note",
        defaultMessage: "Note"
    },
    markdown: {
        id: "icons.content-icon.label.markdown",
        defaultMessage: "Markdown"
    }
});
const $b2e0c504f331f5cc$var$iconDefinitions = {
    liveDoc: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        label: $b2e0c504f331f5cc$var$i18n.liveDoc
    },
    page: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
        label: $b2e0c504f331f5cc$var$i18n.page
    },
    blogpost: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
        label: $b2e0c504f331f5cc$var$i18n.blogpost
    },
    whiteboard: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
        label: $b2e0c504f331f5cc$var$i18n.whiteboard
    },
    database: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
        label: $b2e0c504f331f5cc$var$i18n.database
    },
    slide: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kWSTb))),
        label: $b2e0c504f331f5cc$var$i18n.slide
    },
    folder: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2hJf7))),
        label: $b2e0c504f331f5cc$var$i18n.folder
    },
    space: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9zxkL))),
        label: $b2e0c504f331f5cc$var$i18n.space
    },
    note: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3gdp3))),
        label: $b2e0c504f331f5cc$var$i18n.note
    },
    markdown: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cow67))),
        label: $b2e0c504f331f5cc$var$i18n.markdown
    }
};
function $b2e0c504f331f5cc$var$_temp(t0) {
    const { children: children } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $b2e0c504f331f5cc$var$emojiWrapperStyles
    }, children);
}
module.exports["ContentIcon"] = $b2e0c504f331f5cc$export$a1ea799cb5c1b499;

});

parcelRegister("cow67", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ac59572d5177720dc1f7db0f6832687d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90609fd80a141ebe$var$_react = $90609fd80a141ebe$var$_interopRequireDefault((parcelRequire("cozmU")));

var $90609fd80a141ebe$var$_baseNew = $90609fd80a141ebe$var$_interopRequireDefault((parcelRequire("gElAV")));
function $90609fd80a141ebe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FileMarkdown".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing a Markdown document filetype.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $90609fd80a141ebe$var$FileMarkdownIcon = (props)=>/*#__PURE__*/ $90609fd80a141ebe$var$_react.default.createElement($90609fd80a141ebe$var$_baseNew.default, Object.assign({
        name: "FileMarkdownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12 8.5V5.25c0-.519-.206-1.017-.573-1.384L8.134.573A1.96 1.96 0 0 0 6.75 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h.5v-1.5H2a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v2.5zM7.5 2.06 9.94 4.5H7.5z"/><path fill="currentcolor" d="M5.125 10a.75.75 0 0 1 .661.396L7 12.66l1.214-2.265A.75.75 0 0 1 8.875 10h.375a.75.75 0 0 1 .75.75V16H8.5v-2.962l-.839 1.566a.75.75 0 0 1-1.322 0L5.5 13.039V16H4v-5.25a.75.75 0 0 1 .75-.75zm9.125 0v3.042l.565-.402a.75.75 0 0 1 1 1.104l-1.75 2a.75.75 0 0 1-1.13 0l-1.75-2a.75.75 0 0 1 1-1.104l.565.402V10z"/>`
    }, props));
$90609fd80a141ebe$var$FileMarkdownIcon.displayName = 'FileMarkdownIcon';
var $90609fd80a141ebe$var$_default = module.exports.default = $90609fd80a141ebe$var$FileMarkdownIcon;

});

parcelRegister("3gdp3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b5a64a2ca9b8ddc91e264b2e4d54e26>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25fd434ab2c22b25$var$_react = $25fd434ab2c22b25$var$_interopRequireDefault((parcelRequire("cozmU")));

var $25fd434ab2c22b25$var$_baseNew = $25fd434ab2c22b25$var$_interopRequireDefault((parcelRequire("gElAV")));
function $25fd434ab2c22b25$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25fd434ab2c22b25$var$NotepadIcon = (props)=>/*#__PURE__*/ $25fd434ab2c22b25$var$_react.default.createElement($25fd434ab2c22b25$var$_baseNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$25fd434ab2c22b25$var$NotepadIcon.displayName = 'NotepadIcon';
var $25fd434ab2c22b25$var$_default = module.exports.default = $25fd434ab2c22b25$var$NotepadIcon;

});

parcelRegister("di8q4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $crLHf = parcelRequire("crLHf");


const $7f6506f09fa8c3c7$export$836160481278e63f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CUFGb",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("22FCz"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $crLHf.EmojiPlaceholder), props) : null
});
module.exports["LazyEmojiComponentLoader"] = $7f6506f09fa8c3c7$export$836160481278e63f;

});

parcelRegister("crLHf", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $57p4j = parcelRequire("57p4j");

const $e2c8b616e1533245$var$skeletonWrapperStyles = null;
const $e2c8b616e1533245$var$emojiSkeletonStyles = null;
const $e2c8b616e1533245$export$9fc60f86d5a6479f = (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const PLACEHOLDER_SIZE = props.height || 26;
    let t0;
    if ($[0] !== PLACEHOLDER_SIZE || $[1] !== props.loadingMargin) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            entranceDirection: "left"
        }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $hekY6.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o _1bumglyw _sedtglyw"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                style: {
                    width: `${PLACEHOLDER_SIZE}px`,
                    height: `${PLACEHOLDER_SIZE}px`,
                    margin: props.loadingMargin
                },
                className: (0, $hekY6.default)([
                    "_11q7izff _2rkofajl _18s8ze3t _1e0c1o8l _ca0qze3t"
                ])
            })));
        $[0] = PLACEHOLDER_SIZE;
        $[1] = props.loadingMargin;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
module.exports["EmojiPlaceholder"] = $e2c8b616e1533245$export$9fc60f86d5a6479f;

});

parcelRegister("22FCz", function(module, exports) {

let $17cc0dc072c6a440$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $17cc0dc072c6a440$var$load("ddvkk"),
    $17cc0dc072c6a440$var$load("3upHR"),
    $17cc0dc072c6a440$var$load("iUXaE"),
    $17cc0dc072c6a440$var$load("lTkx9"),
    $17cc0dc072c6a440$var$load("6HpsR"),
    $17cc0dc072c6a440$var$load("N3oqb"),
    $17cc0dc072c6a440$var$load("hZ2FX"),
    $17cc0dc072c6a440$var$load("6wr18"),
    $17cc0dc072c6a440$var$load("ffEVr"),
    $17cc0dc072c6a440$var$load("4Ldt2"),
    $17cc0dc072c6a440$var$load("kFiBp"),
    $17cc0dc072c6a440$var$load("6KGrg")
]).then(()=>parcelRequire('1dhEU'));

});

parcelRegister("2JGYp", function(module, exports) {

var $9MhzF = parcelRequire("9MhzF");


var $5dh5C = parcelRequire("5dh5C");


var $8rneB = parcelRequire("8rneB");

const $3f74e24d74be50af$export$2629e776cd65f583 = (emoji, type)=>{
    /**
   * Why do emojis need to be 'sanitized'? Originally emoji content properties
   * (emoji-title-published, emoji-title-draft) were a part of a REST API
   * where the value would be JSON and not just a string.  This is why emoji
   * values come through with extra quotes and we have to clean that up.
   * A URL with quotes is not a valid URL.
   * e.g. '"https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"' vs.
   * "https://www.youtube.com/s/desktop/1f2ae858/img/favicon_32x32.png"
   */ const sanitizedEmoji = (0, $8rneB.sanitizeEmojiValue)(emoji);
    const isEmbed = type === 'embed';
    const isEmbedWithoutEmoji = isEmbed && !sanitizedEmoji;
    return sanitizedEmoji && (0, $5dh5C.isValidEmoji)(sanitizedEmoji) || sanitizedEmoji && isEmbed && (0, $9MhzF.isValidUrl)(sanitizedEmoji) || isEmbedWithoutEmoji;
};
module.exports["isValidEmojiOrFavicon"] = $3f74e24d74be50af$export$2629e776cd65f583;

});

parcelRegister("9MhzF", function(module, exports) {
const $df5c51c7bf673d12$export$bef94a5618bf18bf = (string)=>{
    try {
        return Boolean(new URL(string));
    } catch (e) {
        return false;
    }
};
module.exports["isValidUrl"] = $df5c51c7bf673d12$export$bef94a5618bf18bf;

});

parcelRegister("5dh5C", function(module, exports) {
const $e57f5fd4620d2578$export$122aed4aa2d0ca26 = (emoji)=>{
    const invalidEmojiRegex = /([a-z\d_-]+):/;
    return !invalidEmojiRegex.test(emoji);
};
module.exports["isValidEmoji"] = $e57f5fd4620d2578$export$122aed4aa2d0ca26;

});

parcelRegister("gfIPU", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $5675860ef242c9e4$export$eed1d73ebdd8c7ab(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>experienceTracker.fail({
                name: name,
                error: error,
                attributes: attributes
            });
        t2 = [
            experienceTracker,
            name,
            error,
            attributes
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceFailure"] = $5675860ef242c9e4$export$eed1d73ebdd8c7ab;

});

parcelRegister("cf6nm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6Cex3 = parcelRequire("6Cex3");


var $lbT4j = parcelRequire("lbT4j");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $44cdfcbcd55a2bbd$export$2ee28caa7f1e962e = ({ isStarred: isStarred, spacing: spacing = 'spacious' })=>{
    const theme = (0, $IQ4Dz.default)();
    const starredColor = theme.colorMode === 'dark' ? "var(--ds-icon-accent-yellow, #B38600)" : "var(--ds-icon-accent-orange, #E06C00)";
    return isStarred ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
        label: "",
        color: starredColor,
        spacing: spacing
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
        label: "",
        color: "currentColor",
        spacing: spacing
    });
};
module.exports["StarIcon"] = $44cdfcbcd55a2bbd$export$2ee28caa7f1e962e;

});

parcelRegister("77a1U", function(module, exports) {

var $4GiSr = parcelRequire("4GiSr");


var $9fsLe = parcelRequire("9fsLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $7aRa9 = parcelRequire("7aRa9");


var $308Wd = parcelRequire("308Wd");


var $cfidN = parcelRequire("cfidN");

const $280d5b858bf30a19$var$PageStarActionButtonPageStarMutation = (0, $9fsLe.default);
const $280d5b858bf30a19$var$PageStarActionButtonPageUnstarMutation = (0, $4GiSr.default);
const $280d5b858bf30a19$var$i18n = (0, $kSwu1.defineMessages)({
    starErrorTitle: {
        id: "action-buttons.content.star.error.title",
        defaultMessage: "We\u2019re having trouble starring this"
    },
    unstarErrorTitle: {
        id: "action-buttons.content.unstar.error.title",
        defaultMessage: "We\u2019re having trouble unstarring this"
    },
    starSuccessFlagTitle: {
        id: "action-buttons.content.star.success.title",
        defaultMessage: "{contentTitle} starred"
    },
    unstarSuccessFlagTitle: {
        id: "action-buttons.content.unstar.success.title",
        defaultMessage: "{contentTitle} unstarred"
    },
    errorDescription: {
        id: "action-buttons.error.description",
        defaultMessage: "Refresh the page and try again."
    }
});
const $280d5b858bf30a19$var$useStarAnalytics = (contentId, analytics)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const stringAttrs = JSON.stringify(analytics?.attributes);
    return (0, $cozmU.useCallback)((action)=>{
        if (!analytics) return;
        const { source: source, containerId: containerId, attributes: attributes } = analytics;
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: action,
                actionSubject: 'favouritePage',
                source: source,
                attributes: attributes,
                objectId: contentId,
                ...containerId && {
                    containerId: containerId
                }
            }
        }).fire();
    }, // Using stringAttrs as dependency instead of analytics.attributes
    // https://github.com/facebook/react/issues/14476
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        createAnalyticsEvent,
        analytics?.source,
        stringAttrs
    ]);
};
const $280d5b858bf30a19$var$PageStarComponent = ({ contentId: contentId, isStarred: isStarred, onStar: onStar, onUnstar: onUnstar, analytics: analytics, intl: intl, children: children, flags: flags, contentTitle: contentTitle = '', shouldShowFlags: shouldShowFlags = false })=>{
    const sendAnalyticsEvent = $280d5b858bf30a19$var$useStarAnalytics(contentId, analytics);
    const [star, { error: starError }] = (0, $308Wd.useMutationInterop)($280d5b858bf30a19$var$PageStarActionButtonPageStarMutation, {
        variables: {
            id: contentId
        },
        onCompleted: ()=>{
            sendAnalyticsEvent('created');
        },
        optimisticResponse: {
            favouritePage: {
                __typename: 'FavouritePagePayload',
                content: {
                    __typename: 'Content',
                    id: contentId,
                    metadata: {
                        __typename: 'ContentMetadata',
                        currentuser: {
                            __typename: 'ContentMetadata_CurrentUserMetadataProvider_currentuser',
                            favourited: {
                                __typename: 'FavouritedSummary',
                                isFavourite: true,
                                favouritedDate: new Date().toISOString()
                            }
                        }
                    }
                }
            }
        },
        __callerPackage__: "action-buttons"
    });
    const [unstar, { error: unstarError }] = (0, $308Wd.useMutationInterop)($280d5b858bf30a19$var$PageStarActionButtonPageUnstarMutation, {
        variables: {
            id: contentId
        },
        onCompleted: ()=>{
            sendAnalyticsEvent('deleted');
        },
        optimisticResponse: {
            unfavouritePage: {
                __typename: 'FavouritePagePayload',
                content: {
                    __typename: 'Content',
                    id: contentId,
                    metadata: {
                        __typename: 'ContentMetadata',
                        currentuser: {
                            __typename: 'ContentMetadata_CurrentUserMetadataProvider_currentuser',
                            favourited: null
                        }
                    }
                }
            }
        },
        __callerPackage__: "action-buttons"
    });
    const toggleStar = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        if (isStarred) {
            onUnstar && onUnstar(e);
            unstar().then(()=>{
                if (shouldShowFlags) flags.showSuccessFlag({
                    title: intl.formatMessage($280d5b858bf30a19$var$i18n.unstarSuccessFlagTitle, {
                        contentTitle: contentTitle
                    }),
                    isAutoDismiss: true
                });
            }).catch((_)=>{});
        } else {
            onStar && onStar(e);
            star().then(()=>{
                if (shouldShowFlags) flags.showSuccessFlag({
                    title: intl.formatMessage($280d5b858bf30a19$var$i18n.starSuccessFlagTitle, {
                        contentTitle: contentTitle
                    }),
                    isAutoDismiss: true
                });
            }).catch((_)=>{});
        }
    }, [
        isStarred,
        onStar,
        star,
        onUnstar,
        unstar,
        contentTitle,
        flags,
        intl,
        shouldShowFlags
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children({
        toggle: toggleStar
    }), starError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cfidN.ActionErrorFlag), {
        title: intl.formatMessage($280d5b858bf30a19$var$i18n.starErrorTitle),
        description: intl.formatMessage($280d5b858bf30a19$var$i18n.errorDescription),
        error: starError
    }), unstarError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cfidN.ActionErrorFlag), {
        title: intl.formatMessage($280d5b858bf30a19$var$i18n.unstarErrorTitle),
        description: intl.formatMessage($280d5b858bf30a19$var$i18n.errorDescription),
        error: unstarError
    }));
};
const $280d5b858bf30a19$export$110ac8adb8c8c03 = (0, $7aRa9.withFlags)((0, $kSwu1.injectIntl)($280d5b858bf30a19$var$PageStarComponent));
module.exports["PageStar"] = $280d5b858bf30a19$export$110ac8adb8c8c03;

});

parcelRegister("4GiSr", function(module, exports) {
/**
 * @generated SignedSource<<3ffaffb5926ed36d9f66867563c732ed>>
 * @relayHash d1da572c7c92b4b266a94268aa3424c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e5938f592be4f9ebb2a4b0128e9ff6974fda1a9904b1cf83b7ff9a9ab5cf46b5
const $dc0ccf8bb0c1b893$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "id"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "favouritePageInput"
                }
            ],
            "concreteType": "FavouritePagePayload",
            "kind": "LinkedField",
            "name": "unfavouritePage",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                    "kind": "LinkedField",
                                    "name": "currentuser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "FavouritedSummary",
                                            "kind": "LinkedField",
                                            "name": "favourited",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "favouritedDate"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PageStarActionButtonPageUnstarMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PageStarActionButtonPageUnstarMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "d1da572c7c92b4b266a94268aa3424c4",
            "id": "e5938f592be4f9ebb2a4b0128e9ff6974fda1a9904b1cf83b7ff9a9ab5cf46b5",
            "metadata": {},
            "name": "PageStarActionButtonPageUnstarMutation",
            "operationKind": "mutation",
            "text": "mutation PageStarActionButtonPageUnstarMutation($id:ID!){unfavouritePage(favouritePageInput:{pageId:$id}){content{id,metadata{currentuser{favourited{isFavourite,favouritedDate}}}}}}"
        }
    };
}();
$dc0ccf8bb0c1b893$var$node.hash = "a57f208826520a57e991955e40d84900";
var $dc0ccf8bb0c1b893$export$2e2bcd8739ae039 = $dc0ccf8bb0c1b893$var$node;
module.exports["default"] = $dc0ccf8bb0c1b893$export$2e2bcd8739ae039;

});

parcelRegister("9fsLe", function(module, exports) {
/**
 * @generated SignedSource<<7f76fd0bae1e7b61d1546ce4fc192079>>
 * @relayHash 893e4cc7292e06a05c8e163bfde7c2d8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e318c7c909b0f3256335fd42867269f6d63076dac709f830f5a46762488d8000
const $6cc5c6f8cf8165a3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "id"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "favouritePageInput"
                }
            ],
            "concreteType": "FavouritePagePayload",
            "kind": "LinkedField",
            "name": "favouritePage",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                    "kind": "LinkedField",
                                    "name": "currentuser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "FavouritedSummary",
                                            "kind": "LinkedField",
                                            "name": "favourited",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "favouritedDate"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PageStarActionButtonPageStarMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PageStarActionButtonPageStarMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "893e4cc7292e06a05c8e163bfde7c2d8",
            "id": "e318c7c909b0f3256335fd42867269f6d63076dac709f830f5a46762488d8000",
            "metadata": {},
            "name": "PageStarActionButtonPageStarMutation",
            "operationKind": "mutation",
            "text": "mutation PageStarActionButtonPageStarMutation($id:ID!){favouritePage(favouritePageInput:{pageId:$id}){content{id,metadata{currentuser{favourited{isFavourite,favouritedDate}}}}}}"
        }
    };
}();
$6cc5c6f8cf8165a3$var$node.hash = "2fe8e2e773241c74a33b1336ab2db2b2";
var $6cc5c6f8cf8165a3$export$2e2bcd8739ae039 = $6cc5c6f8cf8165a3$var$node;
module.exports["default"] = $6cc5c6f8cf8165a3$export$2e2bcd8739ae039;

});

parcelRegister("cfidN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7aRa9 = parcelRequire("7aRa9");


var $b3j2Y = parcelRequire("b3j2Y");

const $774441f3315c6f72$export$5b6a77363c518c1c = (0, $7aRa9.withFlags)(({ flags: flags, title: title, description: description, error: error })=>{
    (0, $cozmU.useEffect)(()=>{
        flags.showErrorFlag({
            id: 'action-button-error',
            title: title,
            description: description
        });
    }, [
        title,
        description,
        flags
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
});
module.exports["ActionErrorFlag"] = $774441f3315c6f72$export$5b6a77363c518c1c;

});

parcelRegister("9SsRl", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $730f8b16a3d58539$export$8ce793b178574678 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.WATCH_BUTTON_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["WATCH_BUTTON_METRIC"] = $730f8b16a3d58539$export$8ce793b178574678;

});

parcelRegister("5EoFB", function(module, exports) {
const $41d3d3266b0b22cf$export$6b0a1934b74e691a = {
    PAGE: 0,
    SPACE: 1
};
const $41d3d3266b0b22cf$export$1841061cdd9b445a = 20;
module.exports["MANAGE_WATCHER_TAB_TYPES"] = $41d3d3266b0b22cf$export$6b0a1934b74e691a;

});

parcelRegister("gqsYd", function(module, exports) {
const $bf558bf49003e931$export$4b915fb24c39b396 = {
    //copied from change-edition. Was not allowed to import it into preloadContentHeader + to prevent bundle size increase.
    FREE: 'FREE',
    PREMIUM: 'PREMIUM',
    STANDARD: 'STANDARD'
};
module.exports["CONFLUENCE_EDITION"] = $bf558bf49003e931$export$4b915fb24c39b396;

});

parcelRegister("49Q03", function(module, exports) {

var $jroIa = parcelRequire("jroIa");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6b4nE = parcelRequire("6b4nE");

parcelRequire("6SsN4");


var $5wHqn = parcelRequire("5wHqn");


var $9DHhW = parcelRequire("9DHhW");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $gqqjz = parcelRequire("gqqjz");


var $lOkIA = parcelRequire("lOkIA");


var $jmjWc = parcelRequire("jmjWc");


var $kvJHJ = parcelRequire("kvJHJ");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $7zgzO = parcelRequire("7zgzO");


var $g1WP0 = parcelRequire("g1WP0");


var $308Wd = parcelRequire("308Wd");


var $20FI0 = parcelRequire("20FI0");


var $9SsRl = parcelRequire("9SsRl");


var $2REhP = parcelRequire("2REhP");


var $jle6C = parcelRequire("jle6C");


var $6in0A = parcelRequire("6in0A");


const $47908050ea4fd9b1$export$9c5737ae30e94007 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "aohZt",
    name: "LazyWatchDialogContent",
    loader: async ()=>(await (parcelRequire("iLUkm"))).WatchDialogContent,
    loading: ({ shouldSSRWatchButton: shouldSSRWatchButton })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                width: '325px',
                height: '180px'
            }
        }, !shouldSSRWatchButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lOkIA.CenteredSpinner), {
            size: "medium"
        }))
});

const $47908050ea4fd9b1$var$LazyWatchDialogShortcut = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "gDGxN",
    name: "LazyWatchDialogShortcut",
    loader: async ()=>(await (parcelRequire("6Uey7"))).WatchDialogShortcut
});
const $47908050ea4fd9b1$var$i18n = (0, $kSwu1.defineMessages)({
    watchContentDialogLabel: {
        id: "watch-dialog.popup.label",
        defaultMessage: "Watch content dialog"
    }
});
const $47908050ea4fd9b1$export$f521883565cfd8d9 = (0, $jroIa.default);
const $47908050ea4fd9b1$export$4b54507e0234ad87 = (0, $kSwu1.injectIntl)(({ contentId: contentId, spaceId: spaceId, params: params, defaultTab: defaultTab, customPlacement: customPlacement, flagsContainer: flagsContainer, isDisabled: /**
   * This disables the usage of the watch button and dialog.
   *
   * Note: If a `customTrigger` is provided, this will be passed through
   * as `isDisabled`. However, as a fallback, even if the button is not
   * disabled properly, the logic here will continue to be disabled.
   */ isDisabled, customTrigger: customTrigger, useShortcut: useShortcut, shouldSSRWatchButton: shouldSSRWatchButton, skipTrialDetailsQuery: skipTrialDetailsQuery, contentType: contentType, componentLocation: componentLocation, intl: intl })=>{
    const [dialogOpen, setDialogOpen] = (0, $cozmU.useState)(false);
    const [shouldOpenWatchDialogFromQueryParams, setShouldOpenWatchDialogFromQueryParams] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const nudgeRef = (0, $cozmU.useRef)(null);
    const { isWatchingContent: isWatchingContent, isWatchingChildren: isWatchingChildren, hasAncestorWatchingChildren: hasAncestorWatchingChildren, isWatchingSpace: isWatchingSpace } = params;
    (0, $cozmU.useEffect)(()=>{
        if (isDisabled) return;
        const { openWatchModal: openWatchModal } = getQueryParams();
        setShouldOpenWatchDialogFromQueryParams(openWatchModal === 'true' && (componentLocation === (0, $2REhP.WATCH_DIALOG_LOCATION).SPACE_OVERVIEW || componentLocation === (0, $2REhP.WATCH_DIALOG_LOCATION).PAGE));
        if (shouldOpenWatchDialogFromQueryParams) setDialogOpen(true);
    }, [
        isDisabled,
        getQueryParams,
        componentLocation,
        shouldOpenWatchDialogFromQueryParams
    ]);
    const removeOpenModalQueryParams = ()=>{
        const queryParams = getQueryParams();
        if (queryParams.openWatchModal) {
            setQueryParams({
                ...queryParams,
                openWatchModal: undefined
            }, true);
            setShouldOpenWatchDialogFromQueryParams(false);
        }
    };
    const toggleDialog = (0, $cozmU.useCallback)(()=>{
        // Do not enable open the dialog if watch is disabled
        if (isDisabled) return;
        setDialogOpen((prevState)=>!prevState);
    }, [
        isDisabled
    ]);
    const isWatching = (0, $cozmU.useCallback)(()=>{
        // If watch is disabled, then the user will default to not watching
        return isDisabled ? false : isWatchingContent || isWatchingSpace || isWatchingChildren || hasAncestorWatchingChildren;
    }, [
        isWatchingContent,
        isWatchingChildren,
        hasAncestorWatchingChildren,
        isWatchingSpace,
        isDisabled
    ]);
    const updateQueryHandler = (updateContentType, newDataValue)=>{
        const contentData = (0, $l1uFv.readQueryInterop)({
            query: $47908050ea4fd9b1$export$f521883565cfd8d9,
            variables: {
                contentId: contentId
            },
            __callerPackage__: "watch-dialog"
        });
        switch(updateContentType){
            case (0, $jle6C.UpdateContentType).CONTENT:
                contentData.singleContent.currentUserIsWatching = newDataValue;
                break;
            case (0, $jle6C.UpdateContentType).CHILDREN:
                contentData.singleContent.currentUserIsWatchingChildren = newDataValue;
                break;
            case (0, $jle6C.UpdateContentType).SPACE:
                contentData.singleContent.space.currentUser.isWatched = newDataValue;
                break;
            default:
                contentData.singleContent.space.currentUser.isWatchingBlogs = newDataValue;
                break;
        }
        (0, $fEmGS.writeQueryInterop)({
            query: $47908050ea4fd9b1$export$f521883565cfd8d9,
            data: contentData,
            __callerPackage__: "watch-dialog"
        });
    };
    const fireWatchAnalyticsEvent = (0, $cozmU.useCallback)((action, actionSubject)=>{
        const analyticsData = {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: contentId,
            objectId: contentId,
            objectType: contentType,
            source: 'WatchButton'
        };
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: analyticsData
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        contentType
    ]);
    const [watchContent] = (0, $308Wd.useMutationInterop)((0, $6in0A.default), {
        onCompleted: ()=>{
            fireWatchAnalyticsEvent((0, $jle6C.UpdateType).WATCH, (0, $jle6C.UpdateContentType).CONTENT);
            toggleDialog();
            experienceTracker.succeed({
                name: (0, $irVI7.WATCH_DIALOG_WATCH_EXPERIENCE)
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $irVI7.WATCH_DIALOG_WATCH_EXPERIENCE),
                error: error.message
            });
        },
        update: (_, { data: { watchContent: watchContentData } })=>{
            updateQueryHandler((0, $jle6C.UpdateContentType).CONTENT, watchContentData.content.currentUserIsWatching);
        },
        __callerPackage__: "watch-dialog"
    });
    const handleOneClickWatch = (0, $cozmU.useCallback)(async ()=>{
        const experienceState = experienceTracker.getExperienceState((0, $irVI7.WATCH_DIALOG_WATCH_EXPERIENCE));
        if (experienceState === null || experienceState.hasStopped) experienceTracker.start({
            name: (0, $irVI7.WATCH_DIALOG_WATCH_EXPERIENCE)
        });
        await watchContent({
            variables: {
                id: contentId
            }
        });
    }, [
        watchContent,
        contentId,
        experienceTracker
    ]);
    const handleWatchButtonClick = (0, $cozmU.useCallback)(async ()=>{
        if (dialogOpen || isWatching()) toggleDialog();
        else await handleOneClickWatch();
    }, [
        toggleDialog,
        isWatching,
        dialogOpen,
        handleOneClickWatch
    ]);
    const openDialog = ()=>{
        setDialogOpen(true);
    };
    const closeDialog = ()=>{
        setDialogOpen(false);
    };
    const renderPopupTrigger = (triggerProps)=>{
        const TriggerButton = customTrigger || (0, $20FI0.WatchButton);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(TriggerButton, {
            isDisabled: isDisabled,
            isWatching: isWatching(),
            isSelected: dialogOpen,
            onMouseOver: $47908050ea4fd9b1$export$9c5737ae30e94007.preload,
            onClick: handleWatchButtonClick,
            triggerProps: triggerProps,
            shouldSSRWatchButton: shouldSSRWatchButton,
            defaultTab: defaultTab,
            contentId: contentId,
            updateQueryHandler: updateQueryHandler
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.CONTENT_TYPES_HEADER_WATCH_EXPERIENCE),
            attributes: {
                isWatching: isWatching()
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            key: contentId,
            metric: (0, $9SsRl.WATCH_BUTTON_METRIC)
        }));
    };
    const renderPopupContent = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                padding: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-200, 16px)"}`
            },
            ref: nudgeRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($47908050ea4fd9b1$export$9c5737ae30e94007, {
            contentId: contentId,
            spaceId: spaceId,
            defaultTab: defaultTab,
            params: params,
            closeWatchDialog: closeDialog,
            updateQueryHandler: updateQueryHandler,
            skipTrialDetailsQuery: skipTrialDetailsQuery,
            contentType: contentType,
            shouldOpenWatchDialogFromQueryParams: shouldOpenWatchDialogFromQueryParams,
            removeOpenModalQueryParams: removeOpenModalQueryParams
        })), dialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g1WP0.AsyncWrapper), {
            trigger: "watch-page",
            showImage: false,
            width: 357,
            reference: nudgeRef
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, useShortcut && !isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($47908050ea4fd9b1$var$LazyWatchDialogShortcut, {
        contentId: contentId,
        contentType: contentType,
        params: params,
        flagsContainer: flagsContainer,
        openDialog: openDialog,
        updateQueryHandler: updateQueryHandler
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        isOpen: dialogOpen,
        onClose: closeDialog,
        content: ()=>renderPopupContent(),
        trigger: renderPopupTrigger,
        placement: customPlacement,
        role: "dialog",
        label: intl.formatMessage($47908050ea4fd9b1$var$i18n.watchContentDialogLabel),
        testId: "watch-content-dialog",
        shouldRenderToParent: true
    }));
});
$47908050ea4fd9b1$export$4b54507e0234ad87.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    spaceId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    params: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).shape({
        isWatchingContent: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool.isRequired,
        isWatchingChildren: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool.isRequired,
        hasAncestorWatchingChildren: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool.isRequired,
        isWatchingSpace: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool.isRequired
    }).isRequired,
    defaultTab: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).number.isRequired,
    customPlacement: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    flagsContainer: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).instanceOf((0, $gqqjz.FlagsStateContainer)),
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    customTrigger: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).elementType,
    useShortcut: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    shouldSSRWatchButton: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    skipTrialDetailsQuery: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    contentType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    componentLocation: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).number
};
module.exports["WatchDialogComponentWithWatchChildrenQuery"] = $47908050ea4fd9b1$export$f521883565cfd8d9;
module.exports["WatchDialogComponent"] = $47908050ea4fd9b1$export$4b54507e0234ad87;

});

parcelRegister("jroIa", function(module, exports) {
/**
 * @generated SignedSource<<8e1cc591f1435412c119051736e0078a>>
 * @relayHash 985f6ee79c133e444ec409d517228f1d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6cad3abfa72a483664cba94f5baf54ffa519efa858bcfd3bc99682a7bcbdd871
const $fe9e027b65465b8b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "currentUserIsWatching"
                },
                {
                    "kind": "ScalarField",
                    "name": "currentUserIsWatchingChildren"
                },
                {
                    "kind": "ScalarField",
                    "name": "currentUserHasAncestorWatchingChildren"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "concreteType": "SpaceUserMetadata",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isWatched"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isWatchingBlogs"
                                }
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "WatchDialogComponentWithWatchChildrenQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "WatchDialogComponentWithWatchChildrenQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "985f6ee79c133e444ec409d517228f1d",
            "id": "6cad3abfa72a483664cba94f5baf54ffa519efa858bcfd3bc99682a7bcbdd871",
            "metadata": {},
            "name": "WatchDialogComponentWithWatchChildrenQuery",
            "operationKind": "query",
            "text": "query WatchDialogComponentWithWatchChildrenQuery($contentId:ID!){singleContent(id:$contentId){__typename,id,currentUserIsWatching,currentUserIsWatchingChildren,currentUserHasAncestorWatchingChildren,type,space{id,key,currentUser{isWatched,isWatchingBlogs},operations{operation,targetType}}}}"
        }
    };
}();
$fe9e027b65465b8b$var$node.hash = "b5ae30f67304ac91f4e47cad0c3cbfda";
var $fe9e027b65465b8b$export$2e2bcd8739ae039 = $fe9e027b65465b8b$var$node;
module.exports["default"] = $fe9e027b65465b8b$export$2e2bcd8739ae039;

});

parcelRegister("lOkIA", function(module, exports) {
/* CenteredSpinner.js generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");


var $lfoFx = parcelRequire("lfoFx");

function $fe0e56b204487583$var$_defineProperty(e, r, t) {
    return (r = $fe0e56b204487583$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fe0e56b204487583$var$_toPropertyKey(t) {
    var i = $fe0e56b204487583$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fe0e56b204487583$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $fe0e56b204487583$export$57732b6846a8df7c = {
    small: 12,
    medium: 26,
    large: 36
};
const $fe0e56b204487583$var$wrapperStyles = null;
const $fe0e56b204487583$var$spinnerStyles = null;
class $fe0e56b204487583$export$a2638930496865a0 extends (0, $cozmU.PureComponent) {
    render() {
        const { style: style, size: size } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: style,
            "data-test-id": "wrapper-spinner",
            className: (0, $hekY6.default)([
                "_1bsb1osq _4t3i1osq _kqswh2mm"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-test-id": "spinner",
            style: {
                marginLeft: `${-$fe0e56b204487583$export$57732b6846a8df7c[size] / 2}px`,
                marginTop: `${-$fe0e56b204487583$export$57732b6846a8df7c[size] / 2}px`
            },
            className: (0, $hekY6.default)([
                "_kqswstnw _1ltv1ssb _154i1ssb _1pbyb4wl"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: $fe0e56b204487583$export$57732b6846a8df7c[size]
        })));
    }
}
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "displayName", 'CenteredSpinner');
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "propTypes", {
    /**
   * custom spinner style
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    /**
   * Size of spinner
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).oneOf([
        'small',
        'medium',
        'large'
    ])
});
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "defaultProps", {
    size: 'small'
});
module.exports["CenteredSpinner"] = $fe0e56b204487583$export$a2638930496865a0;

});

parcelRegister("g1WP0", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $a55d612ff94024a3$var$ThirdPartyNudge = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("7r6LL")).then(({ ThirdPartyNudge: ThirdPartyNudge })=>({
            default: ThirdPartyNudge
        })));

const $a55d612ff94024a3$var$NotificationNudge = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("7r6LL")).then(({ NotificationNudge: NotificationNudge })=>({
            default: NotificationNudge
        })));
const $a55d612ff94024a3$export$91e508f993b0fdc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a55d612ff94024a3$var$ThirdPartyNudge, props));
const $a55d612ff94024a3$export$abc42570cc861f1b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a55d612ff94024a3$var$NotificationNudge, null));
module.exports["AsyncWrapper"] = $a55d612ff94024a3$export$91e508f993b0fdc;

});

parcelRegister("7r6LL", function(module, exports) {

let $56a04e4203ce899a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $56a04e4203ce899a$var$load("6wr18"),
    $56a04e4203ce899a$var$load("gbaDy"),
    $56a04e4203ce899a$var$load("ffEVr"),
    $56a04e4203ce899a$var$load("7EorR"),
    $56a04e4203ce899a$var$load("8zMmc"),
    $56a04e4203ce899a$var$load("hhss7"),
    $56a04e4203ce899a$var$load("bCr24")
]).then(()=>parcelRequire('arPKr'));

});

parcelRegister("20FI0", function(module, exports) {
/* WatchButton.js generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6b4nE = parcelRequire("6b4nE");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $7ZB0A = parcelRequire("7ZB0A");


var $XgBmC = parcelRequire("XgBmC");


var $a79Sy = parcelRequire("a79Sy");


var $lpNn5 = parcelRequire("lpNn5");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");


var $cMvQV = parcelRequire("cMvQV");

const $176bef54c656e043$var$i18n = (0, $kSwu1.defineMessages)({
    startWatchingIconLabel: {
        id: "watch-dialog.watch-button.start.watching.label",
        defaultMessage: "Start watching"
    },
    stopWatchingIconLabel: {
        id: "watch-dialog.watch-button.stop.watching.label",
        defaultMessage: "Stop watching"
    },
    watchStopTooltip: {
        id: "watch-dialog.stop.button.tooltip",
        defaultMessage: "Stop watching"
    },
    watchStartTooltip: {
        id: "watch-dialog.start.button.tooltip",
        defaultMessage: "Watch"
    }
});
const $176bef54c656e043$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $7ZB0A.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_701w1ul9",
            __cmplp.className
        ])
    });
});
const $176bef54c656e043$var$WatchButtonComponent = ({ isDisabled: isDisabled, isWatching: isWatching, isSelected: isSelected, onClick: onClick, onMouseOver: onMouseOver, intl: intl, triggerProps: triggerProps })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const fireClickAnalyticsEvent = (0, $cozmU.useCallback)(()=>{
        const analyticsData = {
            action: 'clicked',
            actionSubject: 'content-watch-button',
            source: 'viewPageScreen'
        };
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: analyticsData
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handleWatchButtonClick = ()=>{
        onClick();
        fireClickAnalyticsEvent();
    };
    const shortcutContent = isWatching ? intl.formatMessage($176bef54c656e043$var$i18n.watchStopTooltip) : intl.formatMessage($176bef54c656e043$var$i18n.watchStartTooltip);
    const getTooltipContent = ()=>{
        if (isDisabled) return undefined;
        if (isLiveEditMode || isOnEditRoute) return shortcutContent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: (0, $cMvQV.isSafari)() ? (0, $gnkil.UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI) : (0, $gnkil.UNIVERSAL_WATCH_CONTENT_SHORTCUT),
            contentBefore: shortcutContent,
            isTooltip: true
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        tag: "span",
        content: getTooltipContent()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($176bef54c656e043$export$2d5d2ba3c7c8c40b, {
        "data-id": "page-watch-button",
        "data-test-id": "page-watch-button",
        testId: "page-watch-button",
        appearance: "subtle",
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleWatchButtonClick,
        onMouseOver: onMouseOver,
        onFocus: onMouseOver,
        iconBefore: isWatching ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($XgBmC))), {
            label: intl.formatMessage($176bef54c656e043$var$i18n.stopWatchingIconLabel),
            testId: "watch-filled-icon",
            spacing: "spacious"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a79Sy))), {
            label: intl.formatMessage($176bef54c656e043$var$i18n.startWatchingIconLabel),
            testId: "watch-icon",
            spacing: "spacious"
        }),
        ...triggerProps
    }));
};
$176bef54c656e043$var$WatchButtonComponent.propTypes = {
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    isWatching: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool.isRequired,
    isSelected: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired,
    onMouseOver: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func,
    intl: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    triggerProps: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object
};
const $176bef54c656e043$export$e149a93a7ac7f896 = (0, $kSwu1.injectIntl)($176bef54c656e043$var$WatchButtonComponent);
module.exports["WatchButton"] = $176bef54c656e043$export$e149a93a7ac7f896;

});

parcelRegister("2REhP", function(module, exports) {
const $215fc810f2773ade$export$613942ed7ac4b968 = {
    PAGE: 0,
    SPACE_OVERVIEW: 1,
    FEED: 2,
    WHITEBOARD: 3
};
module.exports["WATCH_DIALOG_LOCATION"] = $215fc810f2773ade$export$613942ed7ac4b968;

});

parcelRegister("jle6C", function(module, exports) {
var $b11a466056fa4426$export$f8bb0b205e1c369c = /*#__PURE__*/ function(UpdateContentType) {
    UpdateContentType["CONTENT"] = "content";
    UpdateContentType["CHILDREN"] = "children";
    UpdateContentType["BLOGS_IN_SPACE"] = "blogs";
    UpdateContentType["SPACE"] = "space";
    return UpdateContentType;
}({});
var $b11a466056fa4426$export$3b880fb327a46f45 = /*#__PURE__*/ function(UpdateType) {
    UpdateType["WATCH"] = "watch";
    UpdateType["UNWATCH"] = "unwatch";
    return UpdateType;
}({});
module.exports["UpdateContentType"] = $b11a466056fa4426$export$f8bb0b205e1c369c;
module.exports["UpdateType"] = $b11a466056fa4426$export$3b880fb327a46f45;

});

parcelRegister("6in0A", function(module, exports) {
/**
 * @generated SignedSource<<fba01a40abf41f38229c896823374e27>>
 * @relayHash fd81f231087cf7200e9dc6564487d4ac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8d886519cf8ed70ada0eaacb180178bf21c050d416a0212e322876549338c286
const $e1f35a163a9ce341$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "id"
                        },
                        {
                            "kind": "Literal",
                            "name": "currentUser",
                            "value": true
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "watchContentInput"
                }
            ],
            "concreteType": "WatchContentPayload",
            "kind": "LinkedField",
            "name": "watchContent",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "currentUserIsWatching"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "WatchDialogContentWatchContentMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "WatchDialogContentWatchContentMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "fd81f231087cf7200e9dc6564487d4ac",
            "id": "8d886519cf8ed70ada0eaacb180178bf21c050d416a0212e322876549338c286",
            "metadata": {},
            "name": "WatchDialogContentWatchContentMutation",
            "operationKind": "mutation",
            "text": "mutation WatchDialogContentWatchContentMutation($id:ID!){watchContent(watchContentInput:{contentId:$id,currentUser:true}){content{id,currentUserIsWatching}}}"
        }
    };
}();
$e1f35a163a9ce341$var$node.hash = "c3af78be0429c7abdaa087ce8a337162";
var $e1f35a163a9ce341$export$2e2bcd8739ae039 = $e1f35a163a9ce341$var$node;
module.exports["default"] = $e1f35a163a9ce341$export$2e2bcd8739ae039;

});

parcelRegister("iLUkm", function(module, exports) {

let $daa84f36d56ea28b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $daa84f36d56ea28b$var$load("bYzij"),
    $daa84f36d56ea28b$var$load("6damH"),
    $daa84f36d56ea28b$var$load("kHXvF"),
    $daa84f36d56ea28b$var$load("9OSao")
]).then(()=>parcelRequire('jjM3c'));

});

parcelRegister("6Uey7", function(module, exports) {

let $507342388c13d0d6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $507342388c13d0d6$var$load("8hbZ5").then(()=>parcelRequire('j00wp'));

});

parcelRegister("ivEX1", function(module, exports) {
/**
 * Registry of keys used with `confluenceSessionStorageInstance` (session storage).
 *
 * Keys here are intentionally NOT persisted across browser sessions.
 * Do NOT add keys here that should survive a tab close — use `LocalStorageKeys.ts` instead.
 */ const $ebcfca89ee3399cd$export$43572ca00746d574 = {
    /**
	 * The layout ('grid' | 'list') selected by the user for the folder contents view.
	 * Persisted for the duration of the browser session only.
	 */ FOLDER_VIEW_LAYOUT: 'folder.view.layout',
    /**
	 * Overrides the release track to 'dev'. Useful for running end-to-end tests
	 * from a dev machine against a production instance.
	 * Used by @confluence/build-info.
	 */ TELEMETRY_DEV_TRACK_OVERRIDE: 'confluence.telemetry-dev-track-override',
    /**
	 * Enables Confluence frontend logging when set to 'true'.
	 * Used by @confluence/logger.
	 */ ENABLE_LOGGING: 'confluence.enable-logging',
    /**
	 * Controls the minimum log level (1–5) for Confluence frontend logging.
	 * Used by @confluence/logger.
	 */ LOG_LEVEL: 'confluence.log-level',
    /**
	 * Tracks when the page-watch nudge was last shown to the user.
	 * Used by @confluence/third-party-nudge.
	 */ PAGE_VIEW_NUDGE_DATE: 'page-view-nudge-date',
    /**
	 * Tracks the state of the notification section nudge.
	 * Used by @confluence/third-party-nudge.
	 */ NOTIFICATION_NUDGE_STATE: 'notification-nudge-state',
    /**
	 * Per-contentId cache of the most recent custom emoji observed on a Live
	 * Doc, used to drive the "Restore emoji" affordance.
	 * Used by @confluence/emoji-title.
	 */ EMOJI_TITLE_PREVIOUS_EMOJI: 'confluence.emoji-title.previousEmojiId.v1',
    /**
	 * Set to `true` once the Planner title-based agent suggestion banner has been
	 * dismissed (via the close button or by clicking the CTA) during the current
	 * browser session, so it is not re-shown again until the next session.
	 * Used by @confluence/experiment-ootb-title-based-agent-suggestion-nudge.
	 */ TITLE_AGENT_NUDGE_PLANNER_DISMISSED_SESSION: 'confluence.title-agent-nudge.planner-dismissed-session',
    /**
	 * Set to `true` once the Discovery & Feedback title-based agent suggestion
	 * banner has been dismissed (via the close button or by clicking the CTA)
	 * during the current browser session, so it is not re-shown again until the
	 * next session.
	 * Used by @confluence/experiment-ootb-title-based-agent-suggestion-nudge.
	 */ TITLE_AGENT_NUDGE_DISCOVERY_AND_FEEDBACK_DISMISSED_SESSION: 'confluence.title-agent-nudge.discovery-and-feedback-dismissed-session'
};
module.exports["sessionKeys"] = $ebcfca89ee3399cd$export$43572ca00746d574;

});

parcelRegister("f9HtC", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $b0896bd7bf351fc8$export$73075fe16d77da88 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ckcO3",
    name: "ManageWatcherDialogLoader",
    loader: async ()=>(await (parcelRequire("8CCJo"))).ManageWatcherDialog
});
module.exports["ManageWatcherDialogLoader"] = $b0896bd7bf351fc8$export$73075fe16d77da88;

});

parcelRegister("8CCJo", function(module, exports) {

let $646fea89136fe7a4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $646fea89136fe7a4$var$load("6wr18"),
    $646fea89136fe7a4$var$load("1GCFv"),
    $646fea89136fe7a4$var$load("gbejv"),
    $646fea89136fe7a4$var$load("GD9EA"),
    $646fea89136fe7a4$var$load("c831e"),
    $646fea89136fe7a4$var$load("h4Nf7"),
    $646fea89136fe7a4$var$load("ffEVr"),
    $646fea89136fe7a4$var$load("Wowvf"),
    $646fea89136fe7a4$var$load("eRhBr"),
    $646fea89136fe7a4$var$load("7EorR"),
    $646fea89136fe7a4$var$load("hhss7"),
    $646fea89136fe7a4$var$load("iJwzY")
]).then(()=>parcelRequire('45gVm'));

});

parcelRegister("jeQ9x", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $3Ttlf = parcelRequire("3Ttlf");


const $476a1a146c5d6cec$export$c41c4f98f15bcd25 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "I7qQB",
    name: "PublishButtonWithMoreOptions",
    loader: async ()=>{
        return (await (parcelRequire("Nbxn9"))).PublishButtonWithMoreOptions;
    },
    loading: (0, $3Ttlf.PlaceholderPublishButton)
});
module.exports["PublishButtonWithMoreOptions"] = $476a1a146c5d6cec$export$c41c4f98f15bcd25;

});

parcelRegister("3Ttlf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7sJoX = parcelRequire("7sJoX");


var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $iV65j = parcelRequire("iV65j");


var $krxYo = parcelRequire("krxYo");


var $lACKt = parcelRequire("lACKt");

const $6d1be32de0860931$export$a6f3e6c7a6e250cc = ({ publishButtonDisabled: publishButtonDisabled, isUnpublishedDraft: isUnpublishedDraft, shouldShowWorldIcon: shouldShowWorldIcon })=>{
    const intl = (0, $kSwu1.useIntl)();
    if (!isUnpublishedDraft) {
        const WorldIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($krxYo))), {
                label: intl.formatMessage((0, $lACKt.i18nShared).updatePublicContentLabel),
                color: "var(--ds-icon-inverse, #FFFFFF)"
            });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iV65j.SplitButton), {
            appearance: "primary",
            isDisabled: publishButtonDisabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            isDisabled: publishButtonDisabled,
            iconBefore: shouldShowWorldIcon ? WorldIcon : undefined
        }, intl.formatMessage((0, $lACKt.i18nShared).updateButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    ...iconProps,
                    size: "small"
                }),
            label: intl.formatMessage((0, $lACKt.i18nShared).chevronButtonTooltipObjectHeader)
        }));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        isDisabled: publishButtonDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $lACKt.i18nShared).publishButton));
};
module.exports["PlaceholderPublishButton"] = $6d1be32de0860931$export$a6f3e6c7a6e250cc;

});

parcelRegister("lACKt", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $f823ee887c9ee745$export$54342bba4612eedb = (0, $kSwu1.defineMessages)({
    publishButton: {
        id: "publish-modal.default-publish-button",
        defaultMessage: "Publish..."
    },
    updateButton: {
        id: "publish-modal.update-button",
        defaultMessage: "Update"
    },
    chevronButtonTooltipObjectHeader: {
        id: "publish-modal.split-button-tooltip.object-header",
        defaultMessage: "Update settings"
    },
    updatePublicContentLabel: {
        id: "publish-modal.update-public-content-label",
        defaultMessage: "Update public content"
    }
});
module.exports["i18nShared"] = $f823ee887c9ee745$export$54342bba4612eedb;

});

parcelRegister("Nbxn9", function(module, exports) {

let $093d86c75c590258$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $093d86c75c590258$var$load("bYzij"),
    $093d86c75c590258$var$load("kFiBp"),
    $093d86c75c590258$var$load("iUXaE"),
    $093d86c75c590258$var$load("lTkx9"),
    $093d86c75c590258$var$load("6wr18"),
    $093d86c75c590258$var$load("6HLQW"),
    $093d86c75c590258$var$load("6ufIQ"),
    $093d86c75c590258$var$load("gLFJS"),
    $093d86c75c590258$var$load("35X59"),
    $093d86c75c590258$var$load("92b7d"),
    $093d86c75c590258$var$load("2F69B"),
    $093d86c75c590258$var$load("j8Ant"),
    $093d86c75c590258$var$load("idSqX"),
    $093d86c75c590258$var$load("ffEVr"),
    $093d86c75c590258$var$load("7EorR"),
    $093d86c75c590258$var$load("8zMmc"),
    $093d86c75c590258$var$load("el56J"),
    $093d86c75c590258$var$load("guVy6"),
    $093d86c75c590258$var$load("lbsQO"),
    $093d86c75c590258$var$load("3kVph"),
    $093d86c75c590258$var$load("daX4F"),
    $093d86c75c590258$var$load("ayJxT"),
    $093d86c75c590258$var$load("hhss7"),
    $093d86c75c590258$var$load("89b92")
]).then(()=>parcelRequire('6cfXd'));

});

parcelRegister("l7iY7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dPJCf = parcelRequire("dPJCf");


var $3jwuS = parcelRequire("3jwuS");


var $7Sm4c = parcelRequire("7Sm4c");


var $ivb8S = parcelRequire("ivb8S");


var $fsF73 = parcelRequire("fsF73");

const $508580e8423e2725$var$useShowRecap2025QueryParam = (0, $dPJCf.createSingleQueryParamHook)('showRecap2025');
const $508580e8423e2725$export$26f6630e61e959f9 = (isUnpublishedDraft)=>{
    const hasSeenPublishSpotlightRef = (0, $cozmU.useRef)(null);
    const showRecap2025QueryParam = $508580e8423e2725$var$useShowRecap2025QueryParam();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEligible = showRecap2025QueryParam === 'open' && !isLivePage && isUnpublishedDraft;
    const { data: onboardingStateData, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)((0, $fsF73.CONFLUENCE_RECAP_ONBOARDING_STATE_KEYS).HAS_SEEN_PUBLISH_SPOTLIGHT, !isEligible);
    const { hasSeenPublishSpotlight: hasSeenPublishSpotlight } = (0, $ivb8S.deserializeState)(onboardingStateData);
    // Mark GraphQL errors as handled since we gracefully treat them as "hasn't seen spotlight"
    (0, $cozmU.useEffect)(()=>{
        if (onboardingStateError) (0, $7Sm4c.markErrorAsHandled)(onboardingStateError);
    }, [
        onboardingStateError
    ]);
    // Capture the value once when it first becomes available
    // This ensures state changes during the current render cycle don't affect eligibility
    if (hasSeenPublishSpotlightRef.current === null && !onboardingStateLoading) hasSeenPublishSpotlightRef.current = hasSeenPublishSpotlight;
    if (onboardingStateLoading || onboardingStateError) return false;
    // If user has already seen the spotlight, don't show it again
    if (Boolean(hasSeenPublishSpotlightRef.current)) return false;
    return isEligible;
};
module.exports["useRecapSpotlightEligibility"] = $508580e8423e2725$export$26f6630e61e959f9;

});

parcelRegister("bHd1w", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4f760397570928c6$export$28f6951b4656036e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "AuHVu",
    name: "MovePageDialog",
    loader: async ()=>(await (parcelRequire("AvXWe"))).MovePageDialog
});
module.exports["MovePageDialog"] = $4f760397570928c6$export$28f6951b4656036e;

});

parcelRegister("AvXWe", function(module, exports) {

let $06dc28a38ef496a5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $06dc28a38ef496a5$var$load("35X59"),
    $06dc28a38ef496a5$var$load("bYzij"),
    $06dc28a38ef496a5$var$load("ddvkk"),
    $06dc28a38ef496a5$var$load("3upHR"),
    $06dc28a38ef496a5$var$load("iUXaE"),
    $06dc28a38ef496a5$var$load("lTkx9"),
    $06dc28a38ef496a5$var$load("eRhBr"),
    $06dc28a38ef496a5$var$load("bjimZ"),
    $06dc28a38ef496a5$var$load("kUfAt"),
    $06dc28a38ef496a5$var$load("hZ2FX"),
    $06dc28a38ef496a5$var$load("6wr18"),
    $06dc28a38ef496a5$var$load("e4XZ1"),
    $06dc28a38ef496a5$var$load("2Tk6L"),
    $06dc28a38ef496a5$var$load("hxVzR"),
    $06dc28a38ef496a5$var$load("3BNIx"),
    $06dc28a38ef496a5$var$load("9I1GN"),
    $06dc28a38ef496a5$var$load("kzTlz"),
    $06dc28a38ef496a5$var$load("gbDLp"),
    $06dc28a38ef496a5$var$load("Tjs4D"),
    $06dc28a38ef496a5$var$load("jzPyj"),
    $06dc28a38ef496a5$var$load("gW7tk"),
    $06dc28a38ef496a5$var$load("1v24l"),
    $06dc28a38ef496a5$var$load("dtpmo"),
    $06dc28a38ef496a5$var$load("grUVf"),
    $06dc28a38ef496a5$var$load("9pso5"),
    $06dc28a38ef496a5$var$load("eHOWo"),
    $06dc28a38ef496a5$var$load("gLFJS"),
    $06dc28a38ef496a5$var$load("1GCFv"),
    $06dc28a38ef496a5$var$load("4fYzp"),
    $06dc28a38ef496a5$var$load("kHXvF"),
    $06dc28a38ef496a5$var$load("ffEVr"),
    $06dc28a38ef496a5$var$load("aIddG"),
    $06dc28a38ef496a5$var$load("jZMUd"),
    $06dc28a38ef496a5$var$load("2EIkU"),
    $06dc28a38ef496a5$var$load("kFiBp"),
    $06dc28a38ef496a5$var$load("Wowvf"),
    $06dc28a38ef496a5$var$load("6HpsR"),
    $06dc28a38ef496a5$var$load("N3oqb"),
    $06dc28a38ef496a5$var$load("7EorR"),
    $06dc28a38ef496a5$var$load("hhss7"),
    $06dc28a38ef496a5$var$load("36rXN")
]).then(()=>parcelRequire('4yvcZ'));

});

parcelRegister("iSXh4", function(module, exports) {

var $9VdrT = parcelRequire("9VdrT");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $7Sm4c = parcelRequire("7Sm4c");


var $bQm3c = parcelRequire("bQm3c");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $5ZqQS = parcelRequire("5ZqQS");

const $270f2eb7bad14df2$var$createAriId = (cloudId, pageId)=>`ari:cloud:confluence:${cloudId}:page/${pageId}`;
const $270f2eb7bad14df2$var$AutomatedMeetingNotesPagePropertiesQuery = (0, $9VdrT.default);
const $270f2eb7bad14df2$var$IsAutomatedMeetingNotesPropertyKey = 'isAutomatedMeetingNotes';
const $270f2eb7bad14df2$var$MeetingRecurrenceAriPropertyKey = 'meetingRecurrenceAri';
const $270f2eb7bad14df2$export$d2c3b4dbe2618d37 = (pageId)=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($270f2eb7bad14df2$var$AutomatedMeetingNotesPagePropertiesQuery, {
        variables: {
            pageAri: $270f2eb7bad14df2$var$createAriId(cloudId, pageId)
        },
        __callerPackage__: "automated-meeting-notes"
    });
    (0, $cozmU.useEffect)(()=>{
        if (error) {
            if (!(0, $1uFM6.isUnauthorizedError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).INTEGRATIONS
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error
    ]);
    return {
        isLoading: loading,
        ...$270f2eb7bad14df2$export$1607cf22d9dbad(data)
    };
};
const $270f2eb7bad14df2$export$1607cf22d9dbad = (data)=>{
    const pageProperties = data?.page?.properties?.nodes;
    const amnProperty = pageProperties?.find((property)=>property?.key === $270f2eb7bad14df2$var$IsAutomatedMeetingNotesPropertyKey);
    const recurrenceProperty = pageProperties?.find((property)=>property?.key === $270f2eb7bad14df2$var$MeetingRecurrenceAriPropertyKey);
    const isAMN = amnProperty?.value === 'true';
    const isRecurringParent = recurrenceProperty != undefined;
    const isLiveAMNPage = data?.page?.subType?.toLowerCase() === 'live' && isAMN;
    return {
        isAMN: isAMN,
        isRecurringParent: isRecurringParent,
        isLiveAMNPage: isLiveAMNPage
    };
};
module.exports["useAutomatedMeetingNotesPageProperties"] = $270f2eb7bad14df2$export$d2c3b4dbe2618d37;
module.exports["extractAmnPageProperties"] = $270f2eb7bad14df2$export$1607cf22d9dbad;

});

parcelRegister("9VdrT", function(module, exports) {
/**
 * @generated SignedSource<<c55748e87ec72b47f4575a0869b376cf>>
 * @relayHash 2d27dcc1d1eac2731f01ec3e79c7f7d9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bf3bc462d3d8204f9ed38909105bf232600e50daaab2de0e4c1b07ae2dc4f5bd
const $2aa10c7c748cb29a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageAri"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "pageAri"
                }
            ],
            "concreteType": "Page",
            "kind": "LinkedField",
            "name": "page",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "keys",
                            "value": [
                                "isAutomatedMeetingNotes",
                                "meetingRecurrenceAri"
                            ]
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JsonContentProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ],
                    "storageKey": "properties(keys:[\"isAutomatedMeetingNotes\",\"meetingRecurrenceAri\"])"
                },
                {
                    "kind": "ScalarField",
                    "name": "subType"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAutomatedMeetingNotesPagePropertiesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAutomatedMeetingNotesPagePropertiesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "2d27dcc1d1eac2731f01ec3e79c7f7d9",
            "id": "bf3bc462d3d8204f9ed38909105bf232600e50daaab2de0e4c1b07ae2dc4f5bd",
            "metadata": {},
            "name": "useAutomatedMeetingNotesPagePropertiesQuery",
            "operationKind": "query",
            "text": "query useAutomatedMeetingNotesPagePropertiesQuery($pageAri:ID!){page(id:$pageAri){properties(keys:[\"isAutomatedMeetingNotes\",\"meetingRecurrenceAri\"]){nodes{key,value}},subType,id}}"
        }
    };
}();
$2aa10c7c748cb29a$var$node.hash = "a7e1d622b5e3dfb0202b4f6045de22bd";
var $2aa10c7c748cb29a$export$2e2bcd8739ae039 = $2aa10c7c748cb29a$var$node;
module.exports["default"] = $2aa10c7c748cb29a$export$2e2bcd8739ae039;

});

parcelRegister("iXzFq", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $71e3d8e13a87be5f$var$getLegacyActionUrl = (redirectToEditor, contentId)=>{
    if (redirectToEditor) return `${0, $jlIaF.CONTEXT_PATH}/pages/resumedraft.action?draftId=${contentId}`;
    return `${0, $jlIaF.CONTEXT_PATH}/pages/viewpage.action?pageId=${contentId}`;
};
const $71e3d8e13a87be5f$export$11b68a3633074ac0 = ({ contentType: contentType, contentSubType: contentSubType = null, contentId: contentId, spaceKey: spaceKey, redirectToEditor: redirectToEditor = false, useLegacyActionUrl: useLegacyActionUrl = false })=>{
    if (!contentId) return null;
    // assume all page sub types will only redirect to view page
    // can refactor to be more specific if needed
    if (contentType === 'page' && contentSubType !== null) return (0, $1NBp8.VIEW_PAGE).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    });
    if (contentType === 'page' && useLegacyActionUrl) return $71e3d8e13a87be5f$var$getLegacyActionUrl(redirectToEditor, contentId);
    if (contentType === 'page' && redirectToEditor) return (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        spaceKey: spaceKey,
        contentType: 'pages',
        contentId: contentId
    });
    if (contentType === 'blogpost' && redirectToEditor) return (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: 'blog'
    });
    switch(contentType){
        case 'page':
            return (0, $1NBp8.VIEW_PAGE).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'blogpost':
            return (0, $1NBp8.VIEW_BLOG).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'whiteboard':
            return (0, $1NBp8.WHITEBOARD_BOARD).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'database':
            return (0, $1NBp8.DATABASE_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'slide':
            return (0, $1NBp8.SLIDES_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'embed':
            return (0, $1NBp8.EMBED_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'folder':
            return (0, $1NBp8.FOLDER_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
    }
    return null;
};
module.exports["getUrlForContentType"] = $71e3d8e13a87be5f$export$11b68a3633074ac0;

});

parcelRegister("lqy4C", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4c1VG = parcelRequire("4c1VG");


var $alLTz = parcelRequire("alLTz");


var $cLhhP = parcelRequire("cLhhP");

const $047fd93b8f400f5d$export$5419ac0b96bac54b = ({ source: source })=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    const { isStorageEnforcementGracePeriodComplete: isStorageEnforcementGracePeriodComplete } = (0, $4c1VG.useGetCurrentStorageUsage)({
        skip: !isEligibleUser
    });
    const { showBlockCreateModal: showBlockCreateModal } = (0, $cLhhP.useBlockCreateModalActions)();
    const shouldBlockCreate = isEligibleUser && Boolean(isStorageEnforcementGracePeriodComplete);
    const enforceStorageLimit = (0, $cozmU.useCallback)((callback)=>(...args)=>{
            if (shouldBlockCreate) {
                // If the callback is a DOM event (e.g. click, keydown/keyup)
                // handler, prevent the default action (e.g. navigating to an href):
                const event = args?.[0];
                if (event && typeof event.preventDefault === 'function') event.preventDefault();
                experienceTracker.start({
                    name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BLOCK_CREATE_MODAL)
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'render',
                        actionSubject: 'hardStorageEnforcement',
                        actionSubjectId: 'enforceStorageLimit',
                        source: source || 'onboarding'
                    }
                }).fire();
                showBlockCreateModal(source);
                return;
            }
            return callback.apply(undefined, args);
        }, [
        createAnalyticsEvent,
        experienceTracker,
        shouldBlockCreate,
        showBlockCreateModal,
        source
    ]);
    return {
        shouldBlockCreate: shouldBlockCreate,
        enforceStorageLimit: enforceStorageLimit
    };
};
module.exports["useHardStorageEnforcement"] = $047fd93b8f400f5d$export$5419ac0b96bac54b;

});

parcelRegister("4c1VG", function(module, exports) {

var $1hmAp = parcelRequire("1hmAp");


var $jMyy4 = parcelRequire("jMyy4");

const $1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery = (0, $1hmAp.default);
const $1f652a8c0a42982a$export$8bf54c39c48ff2d2 = ({ skip: skip } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery, {
        skip: skip,
        __callerPackage__: "storage-enforcement"
    });
    return {
        currentUsage: data?.storage?.bytesUsed ?? 0,
        isStorageEnforcementGracePeriodComplete: data?.storage?.isStorageEnforcementGracePeriodComplete,
        gracePeriodEndDate: data?.storage?.gracePeriodEndDate,
        loading: loading,
        error: error
    };
};
module.exports["useGetCurrentStorageUsage"] = $1f652a8c0a42982a$export$8bf54c39c48ff2d2;

});

parcelRegister("1hmAp", function(module, exports) {
/**
 * @generated SignedSource<<dc205b784e864c4042673f60370ebfb9>>
 * @relayHash 70e80297d041fb31c0639d661a01c799
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54
const $dc4c6b557b36d823$var$node = function() {
    var v0 = [
        {
            "alias": "storage",
            "concreteType": "ConfluenceStorage",
            "kind": "LinkedField",
            "name": "confluence_storage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "bytesUsed"
                },
                {
                    "kind": "ScalarField",
                    "name": "isStorageEnforcementGracePeriodComplete"
                },
                {
                    "kind": "ScalarField",
                    "name": "gracePeriodEndDate"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "70e80297d041fb31c0639d661a01c799",
            "id": "6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54",
            "metadata": {},
            "name": "useGetCurrentStorageUsageQuery",
            "operationKind": "query",
            "text": "query useGetCurrentStorageUsageQuery{storage:confluence_storage{bytesUsed,isStorageEnforcementGracePeriodComplete,gracePeriodEndDate}}"
        }
    };
}();
$dc4c6b557b36d823$var$node.hash = "41d2bf41d832c3866355b26b49942948";
var $dc4c6b557b36d823$export$2e2bcd8739ae039 = $dc4c6b557b36d823$var$node;
module.exports["default"] = $dc4c6b557b36d823$export$2e2bcd8739ae039;

});

parcelRegister("alLTz", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");

const $2f3a7af74886cca0$export$3fc4fcb674af9bce = ()=>{
    const { edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isEligibleUser = edition === (0, $euL71.ConfluenceEdition).FREE && isLoggedIn;
    return isEligibleUser;
};
module.exports["useIsStorageEnforcementEligible"] = $2f3a7af74886cca0$export$3fc4fcb674af9bce;

});

parcelRegister("cLhhP", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $ff89d2fd8e30c2ae$var$initialState = {
    isActive: false,
    source: ''
};
const $ff89d2fd8e30c2ae$var$NAME = 'BLOCK_CREATE_MODAL_STORE';
const $ff89d2fd8e30c2ae$var$BlockCreateModalStore = (0, $8s9DV.createStore)({
    name: $ff89d2fd8e30c2ae$var$NAME,
    initialState: $ff89d2fd8e30c2ae$var$initialState,
    actions: {
        showBlockCreateModal: (source)=>({ setState: setState })=>{
                setState({
                    isActive: true,
                    source: source
                });
            },
        onBlockCreateModalClose: ()=>({ setState: setState })=>{
                setState({
                    isActive: false,
                    source: ''
                });
            }
    }
});
const $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc = (0, $kBr4q.createHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
const $ff89d2fd8e30c2ae$export$d0e21e34c085fe56 = (0, $kBr4q.createActionsHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
module.exports["useBlockCreateModalStore"] = $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc;
module.exports["useBlockCreateModalActions"] = $ff89d2fd8e30c2ae$export$d0e21e34c085fe56;

});

parcelRegister("iIYTj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $9kbTQ = parcelRequire("9kbTQ");


var $jawC3 = parcelRequire("jawC3");


var $cMyWi = parcelRequire("cMyWi");


var $1F2YI = parcelRequire("1F2YI");


var $ixfCV = parcelRequire("ixfCV");


var $iSrRp = parcelRequire("iSrRp");

parcelRequire("fYWmN");
var $1bRPL = parcelRequire("1bRPL");

parcelRequire("cDMxg");
var $deUyp = parcelRequire("deUyp");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $2Q7sv = parcelRequire("2Q7sv");

var $a1a722d55501d95d$export$89741becde3d0e54 = /*#__PURE__*/ function(SMART_LINK_DRAG_TYPES) {
    SMART_LINK_DRAG_TYPES["EDITOR"] = "smart-link-from-editor";
    SMART_LINK_DRAG_TYPES["RENDERER"] = "smart-link-from-renderer";
    return SMART_LINK_DRAG_TYPES;
}({});
var $a1a722d55501d95d$export$a4a3cf1d43312764 = /*#__PURE__*/ function(SMART_LINK_APPEARANCE) {
    SMART_LINK_APPEARANCE["INLINE"] = "inline";
    SMART_LINK_APPEARANCE["BLOCK"] = "block";
    SMART_LINK_APPEARANCE["EMBED"] = "embed";
    return SMART_LINK_APPEARANCE;
}({});
function $a1a722d55501d95d$export$ac5f6dc1cb5b8db6(type) {
    return type === "smart-link-from-editor" || type === "smart-link-from-renderer";
} /**
   * Checks if a ProseMirror node type is a smart link card.
   */ 
function $a1a722d55501d95d$export$250eee508686c799(nodeType) {
    return nodeType === 'inlineCard' || nodeType === 'blockCard' || nodeType === 'embedCard';
}
const $a1a722d55501d95d$var$idleState = {
    type: 'idle'
};
const $a1a722d55501d95d$var$draggingState = {
    type: 'dragging'
};
const $a1a722d55501d95d$var$styles = {
    preview: "_1reo15vq _18m915vq _2rko12b0 _1rjc1b66 _18zru2gc _1dqonqa1 _1h6d1l7x _bfhkvuon _p12fgx0z _16qs130s",
    previewText: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
    draggableBlock: "_80om1qgj"
};
const $a1a722d55501d95d$var$previewIconStyles = null;
const $a1a722d55501d95d$var$draggableInlineStyles = null;
const $a1a722d55501d95d$var$SmartLinkDragPreview = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SmartLinkDragPreview(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { title: title, url: url, iconUrl: iconUrl } = t0;
    let t1;
    if ($[0] !== iconUrl) {
        t1 = iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            src: iconUrl,
            alt: "",
            className: (0, $hekY6.default)([
                "_1bsbpxbi _4t3ipxbi _1o9zidpf"
            ])
        });
        $[0] = iconUrl;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = title || url;
    let t3;
    if ($[2] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            as: "span",
            xcss: $a1a722d55501d95d$var$styles.previewText
        }, t2);
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t1 || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $a1a722d55501d95d$var$styles.preview
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            alignBlock: "center",
            space: "space.075"
        }, t1, t3));
        $[4] = t1;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function SmartLinkDragPreview({ title: title, url: url, iconUrl: iconUrl }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $a1a722d55501d95d$var$styles.preview
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        alignBlock: "center",
        space: "space.075"
    }, iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: iconUrl,
        alt: "",
        className: (0, $hekY6.default)([
            "_1bsbpxbi _4t3ipxbi _1o9zidpf"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        as: "span",
        xcss: $a1a722d55501d95d$var$styles.previewText
    }, title || url)));
};
function $a1a722d55501d95d$var$getIconUrl(details) {
    if (details?.data && 'icon' in details.data && typeof details?.data?.icon === 'string') return details.data.icon;
    const objectIconUrl = (0, $2Q7sv.getObjectIconUrl)(details);
    if (objectIconUrl) return objectIconUrl;
     // Confluence/Jira content-type specific icons (page, blog, whiteboard, issue, etc.)
    if (details?.entityData && 'iconUrl' in details.entityData && typeof details.entityData.iconUrl === 'string') return details.entityData.iconUrl;
     // Fallback to provider/generator icon (product logo)
    if (typeof details?.meta?.generator?.icon?.url === 'string') return details.meta.generator.icon.url;
    return undefined;
} /**
   * Inner component that handles the actual drag behavior.
   * Must be rendered within a SmartCardProvider context.
   */ 
const $a1a722d55501d95d$var$SmartLinkDraggableInner = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SmartLinkDraggableInner(t0) {
    const $ = (0, $bDgLe.c)(35);
    const { url: url, title: propTitle, appearance: appearance, source: source, isChangeboardTarget: t1, children: children } = t0;
    const isChangeboardTarget = t1 === undefined ? false : t1;
    const ref = (0, $cozmU.useRef)(null);
    const { store: store } = (0, $cMyWi.useSmartLinkContext)();
    const [state, setState] = (0, $cozmU.useState)($a1a722d55501d95d$var$idleState);
    let t2;
    if ($[0] !== appearance || $[1] !== propTitle || $[2] !== source || $[3] !== store || $[4] !== url) {
        t2 = (targetEl)=>({
                element: targetEl,
                getInitialData: ()=>{
                    const cardState = store.getState()[url];
                    const details = cardState?.details;
                    const title = propTitle || (0, $jawC3.extractSmartLinkTitle)(details);
                    const iconUrl = $a1a722d55501d95d$var$getIconUrl(details);
                    return {
                        type: source,
                        url: url,
                        title: title,
                        iconUrl: iconUrl,
                        appearance: appearance
                    };
                },
                onGenerateDragPreview: (t3)=>{
                    const { nativeSetDragImage: nativeSetDragImage } = t3;
                    const cardState_0 = store.getState()[url];
                    const details_0 = cardState_0?.details;
                    const title_0 = propTitle || (0, $jawC3.extractSmartLinkTitle)(details_0);
                    const iconUrl_0 = $a1a722d55501d95d$var$getIconUrl(details_0);
                    (0, $deUyp.setCustomNativeDragPreview)({
                        getOffset: (0, $1bRPL.pointerOutsideOfPreview)({
                            x: "16px",
                            y: "8px"
                        }),
                        render (t4) {
                            const { container: container } = t4;
                            setState({
                                type: "preview",
                                container: container,
                                title: title_0,
                                iconUrl: iconUrl_0
                            });
                            return ()=>setState($a1a722d55501d95d$var$draggingState);
                        },
                        nativeSetDragImage: nativeSetDragImage
                    });
                },
                onDragStart: ()=>setState($a1a722d55501d95d$var$draggingState),
                onDrop: ()=>setState($a1a722d55501d95d$var$idleState)
            });
        $[0] = appearance;
        $[1] = propTitle;
        $[2] = source;
        $[3] = store;
        $[4] = url;
        $[5] = t2;
    } else t2 = $[5];
    const getDragConfig = t2;
    let t3;
    if ($[6] !== appearance || $[7] !== getDragConfig) {
        t3 = ()=>{
            const el = ref.current;
            if (!el) return;
            let cleanupDraggable = null;
            let observer = null;
            if (appearance !== "inline") {
                const setupSmartElementLink = ()=>{
                    el.querySelectorAll("[data-smart-element-link]").forEach($a1a722d55501d95d$var$_temp);
                };
                setupSmartElementLink();
                observer = new MutationObserver(setupSmartElementLink);
                observer.observe(el, {
                    childList: true,
                    subtree: true
                });
            }
            const unbindPointerDown = (0, $cbY7C.bind)(el, {
                type: "pointerdown",
                listener: (event)=>{
                    const selectionAtPointerDown = window.getSelection();
                    if (appearance === "inline" && selectionAtPointerDown?.type === "Range" && selectionAtPointerDown.toString().length > 0) selectionAtPointerDown.removeAllRanges();
                    cleanupDraggable?.();
                    const target = event.target;
                    let dragTarget = el;
                    if (appearance === "inline") {
                        const targetElement = target instanceof Element ? target : null;
                        const hostInlineCardRoot = el.closest("[data-prosemirror-node-name=\"inlineCard\"][draggable=\"true\"]");
                        const inlineCardRoot = targetElement?.closest("[data-prosemirror-node-name=\"inlineCard\"][draggable=\"true\"]") ?? null;
                        const closestInlineAnchor = targetElement?.closest("a[href], [data-smart-element-link]") ?? null;
                        if (closestInlineAnchor instanceof HTMLElement && (el.contains(closestInlineAnchor) || hostInlineCardRoot instanceof HTMLElement && hostInlineCardRoot.contains(closestInlineAnchor))) dragTarget = closestInlineAnchor;
                        else if (inlineCardRoot instanceof HTMLElement && hostInlineCardRoot instanceof HTMLElement && inlineCardRoot === hostInlineCardRoot) dragTarget = inlineCardRoot;
                    } else dragTarget = target instanceof HTMLElement && el.contains(target) ? target : el;
                    cleanupDraggable = (0, $iSrRp.draggable)(getDragConfig(dragTarget));
                }
            });
            return ()=>{
                cleanupDraggable?.();
                unbindPointerDown();
                observer?.disconnect();
            };
        };
        $[6] = appearance;
        $[7] = getDragConfig;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== appearance || $[10] !== getDragConfig || $[11] !== propTitle || $[12] !== source || $[13] !== store || $[14] !== url) {
        t4 = [
            url,
            propTitle,
            appearance,
            source,
            store,
            getDragConfig
        ];
        $[9] = appearance;
        $[10] = getDragConfig;
        $[11] = propTitle;
        $[12] = source;
        $[13] = store;
        $[14] = url;
        $[15] = t4;
    } else t4 = $[15];
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[16] !== state.container || $[17] !== state.iconUrl || $[18] !== state.title || $[19] !== state.type || $[20] !== url) {
        t5 = state.type === "preview" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a1a722d55501d95d$var$SmartLinkDragPreview, {
            title: state.title,
            url: url,
            iconUrl: state.iconUrl
        }), state.container) : null;
        $[16] = state.container;
        $[17] = state.iconUrl;
        $[18] = state.title;
        $[19] = state.type;
        $[20] = url;
        $[21] = t5;
    } else t5 = $[21];
    const preview = t5;
    if (appearance === "inline") {
        const t6 = isChangeboardTarget ? "smart-link-draggable-changeboard" : undefined;
        let t7;
        if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = (0, $hekY6.default)([
                "_80om1qgj _1e0c1nu9"
            ]);
            $[22] = t7;
        } else t7 = $[22];
        let t8;
        if ($[23] !== children || $[24] !== t6 || $[25] !== t7) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                ref: ref,
                "data-testid": "smart-link-draggable-inline",
                "data-spotlight-target": t6,
                className: t7
            }, children);
            $[23] = children;
            $[24] = t6;
            $[25] = t7;
            $[26] = t8;
        } else t8 = $[26];
        let t9;
        if ($[27] !== preview || $[28] !== t8) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t8, preview);
            $[27] = preview;
            $[28] = t8;
            $[29] = t9;
        } else t9 = $[29];
        return t9;
    }
    let t6;
    if ($[30] !== children) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            ref: ref,
            xcss: $a1a722d55501d95d$var$styles.draggableBlock,
            testId: "smart-link-draggable-block"
        }, children);
        $[30] = children;
        $[31] = t6;
    } else t6 = $[31];
    let t7;
    if ($[32] !== preview || $[33] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t6, preview);
        $[32] = preview;
        $[33] = t6;
        $[34] = t7;
    } else t7 = $[34];
    return t7;
} : function SmartLinkDraggableInner({ url: url, title: propTitle, appearance: appearance, source: source, isChangeboardTarget: isChangeboardTarget = false, children: children }) {
    const ref = (0, $cozmU.useRef)(null);
    const { store: store } = (0, $cMyWi.useSmartLinkContext)();
    const [state, setState] = (0, $cozmU.useState)($a1a722d55501d95d$var$idleState); // Store the draggable config so we can re-register on different elements
    // when the browser picks a child as the drag target.
    const getDragConfig = (0, $cozmU.useCallback)((targetEl)=>({
            element: targetEl,
            getInitialData: ()=>{
                const cardState = store.getState()[url];
                const details = cardState?.details;
                const title = propTitle || (0, $jawC3.extractSmartLinkTitle)(details);
                const iconUrl = $a1a722d55501d95d$var$getIconUrl(details);
                return {
                    type: source,
                    url: url,
                    title: title,
                    iconUrl: iconUrl,
                    appearance: appearance
                };
            },
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                const cardState_0 = store.getState()[url];
                const details_0 = cardState_0?.details;
                const title_0 = propTitle || (0, $jawC3.extractSmartLinkTitle)(details_0);
                const iconUrl_0 = $a1a722d55501d95d$var$getIconUrl(details_0);
                (0, $deUyp.setCustomNativeDragPreview)({
                    getOffset: (0, $1bRPL.pointerOutsideOfPreview)({
                        x: '16px',
                        y: '8px'
                    }),
                    render ({ container: container }) {
                        setState({
                            type: 'preview',
                            container: container,
                            title: title_0,
                            iconUrl: iconUrl_0
                        });
                        return ()=>setState($a1a722d55501d95d$var$draggingState);
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            },
            onDragStart: ()=>setState($a1a722d55501d95d$var$draggingState),
            onDrop: ()=>setState($a1a722d55501d95d$var$idleState)
        }), [
        url,
        propTitle,
        appearance,
        source,
        store
    ]);
    // On pointerdown, determine the drag element and register it with Pragmatic DnD.
    // Uses pointerdown because the drag source may not exist at mount time as smart cards resolve.
    // For inline cards inside ProseMirror, prefer the inner anchor because the browser fires
    // dragstart from that element rather than from the inline card wrapper.
    (0, $cozmU.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const inlineCardRootSelector = '[data-prosemirror-node-name="inlineCard"][draggable="true"]'; // In contentEditable editors (ProseMirror), the browser may pick a child
        // element (e.g., an <a> tag) as the drag target instead of our element.
        // On pointerdown, we find the likely drag target and register draggable()
        // on it so pragmatic-drag-and-drop recognizes the drag.
        let cleanupDraggable = null; // In contentEditable="true" contexts (block/embed cards), the browser treats
        // the smart-element-link as editable text rather than a draggable element.
        // Not needed for inline cards since the wrapper is already not editable
        let observer = null;
        if (appearance !== "inline") {
            const setupSmartElementLink = ()=>{
                el.querySelectorAll('[data-smart-element-link]').forEach((link)=>{
                    link.contentEditable = 'false';
                    link.setAttribute('draggable', 'true');
                });
            };
            setupSmartElementLink();
            observer = new MutationObserver(setupSmartElementLink);
            observer.observe(el, {
                childList: true,
                subtree: true
            });
        }
        const unbindPointerDown = (0, $cbY7C.bind)(el, {
            type: 'pointerdown',
            listener: (event)=>{
                const selectionAtPointerDown = window.getSelection();
                if (appearance === "inline" && selectionAtPointerDown?.type === 'Range' && selectionAtPointerDown.toString().length > 0) selectionAtPointerDown.removeAllRanges();
                cleanupDraggable?.();
                const target = event.target; // Find the nearest draggable ancestor within the card to match
                // the element the browser will use as the dragstart target.
                let dragTarget = el;
                if (appearance === "inline") {
                    const targetElement = target instanceof Element ? target : null;
                    const hostInlineCardRoot = el.closest(inlineCardRootSelector);
                    const inlineCardRoot = targetElement?.closest(inlineCardRootSelector) ?? null;
                    const closestInlineAnchor = targetElement?.closest('a[href], [data-smart-element-link]') ?? null;
                    if (closestInlineAnchor instanceof HTMLElement && (el.contains(closestInlineAnchor) || hostInlineCardRoot instanceof HTMLElement && hostInlineCardRoot.contains(closestInlineAnchor))) dragTarget = closestInlineAnchor;
                    else if (inlineCardRoot instanceof HTMLElement && hostInlineCardRoot instanceof HTMLElement && inlineCardRoot === hostInlineCardRoot) dragTarget = inlineCardRoot;
                } else dragTarget = target instanceof HTMLElement && el.contains(target) ? target : el;
                cleanupDraggable = (0, $iSrRp.draggable)(getDragConfig(dragTarget));
            }
        });
        return ()=>{
            cleanupDraggable?.();
            unbindPointerDown();
            observer?.disconnect();
        };
    }, [
        url,
        propTitle,
        appearance,
        source,
        store,
        getDragConfig
    ]);
    const preview = state.type === 'preview' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a1a722d55501d95d$var$SmartLinkDragPreview, {
        title: state.title,
        url: url,
        iconUrl: state.iconUrl
    }), state.container) : null; // Use span with inline display for inline cards to preserve text flow.
    if (appearance === "inline") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        ref: ref,
        "data-testid": "smart-link-draggable-inline",
        "data-spotlight-target": isChangeboardTarget ? 'smart-link-draggable-changeboard' : undefined,
        className: (0, $hekY6.default)([
            "_80om1qgj _1e0c1nu9"
        ])
    }, children), preview);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        ref: ref,
        xcss: $a1a722d55501d95d$var$styles.draggableBlock,
        testId: "smart-link-draggable-block"
    }, children), preview);
};
/**
 * Wraps a smart link card to make it draggable into the content tree.
 * Extracts the resolved title and icon from the smart link data store at drag start time.
 * Falls back to rendering children directly when the feature flag is off or url is missing.
 */ function $a1a722d55501d95d$var$_temp(link) {
    link.contentEditable = "false";
    link.setAttribute("draggable", "true");
}
const $a1a722d55501d95d$export$c67c8f76ce4436c = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SmartLinkDraggable(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { url: url, title: title, appearance: appearance, source: source, isChangeboardTarget: isChangeboardTarget, children: children } = t0;
    if (!url || !(0, $1F2YI.isSafeUrl)(url) || !(0, $ixfCV.fg)("cc_drag_and_drop_smart_link_from_content_to_tree")) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== appearance || $[3] !== children || $[4] !== isChangeboardTarget || $[5] !== source || $[6] !== title || $[7] !== url) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a1a722d55501d95d$var$SmartLinkDraggableInner, {
            url: url,
            title: title,
            appearance: appearance,
            source: source,
            isChangeboardTarget: isChangeboardTarget
        }, children);
        $[2] = appearance;
        $[3] = children;
        $[4] = isChangeboardTarget;
        $[5] = source;
        $[6] = title;
        $[7] = url;
        $[8] = t1;
    } else t1 = $[8];
    return t1;
} : function SmartLinkDraggable({ url: url, title: title, appearance: appearance, source: source, isChangeboardTarget: isChangeboardTarget, children: children }) {
    if (!url || !(0, $1F2YI.isSafeUrl)(url) || !(0, $ixfCV.fg)('cc_drag_and_drop_smart_link_from_content_to_tree')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a1a722d55501d95d$var$SmartLinkDraggableInner, {
        url: url,
        title: title,
        appearance: appearance,
        source: source,
        isChangeboardTarget: isChangeboardTarget
    }, children);
};
module.exports["SMART_LINK_DRAG_TYPES"] = $a1a722d55501d95d$export$89741becde3d0e54;
module.exports["SMART_LINK_APPEARANCE"] = $a1a722d55501d95d$export$a4a3cf1d43312764;
module.exports["isSmartLinkDrag"] = $a1a722d55501d95d$export$ac5f6dc1cb5b8db6;
module.exports["SmartLinkDraggable"] = $a1a722d55501d95d$export$c67c8f76ce4436c;

});

parcelRegister("fYWmN", function(module, exports) {
$parcel$export(module.exports, "pointerOutsideOfPreview", () => (parcelRequire("1bRPL")).pointerOutsideOfPreview);

var $1bRPL = parcelRequire("1bRPL");


});

parcelRegister("1bRPL", function(module, exports) {

var $dJ9DS = parcelRequire("dJ9DS");


var $fYxCA = parcelRequire("fYxCA");


var $beJwy = parcelRequire("beJwy");

function $c244e860353a6e68$export$427e20518819fabc(point) {
    return function getOffset({ container: container }) {
        /**
		 * **Approach: transparent borders.**
		 *
		 * The only reliable cross browser technique found to push a
		 * drag preview away from the cursor is to use transparent borders on the container.
		 *
		 * **🙅📱 Not pushing the preview away on touch devices**
		 *
		 * _On iOS_
		 *
		 * Safari will set the transparent border color to be black
		 *
		 * `iOS@18.4.1` on May 7th 2025:
		 * - If you set the background color on the `container` the border color will be that
		 * - Setting a transparent background color on the `container` still results in a
		 *   black border
		 * - The `<body>` text or background color does not change the black border color
		 *
		 * While dragging, the drag preview will shift under the center of the users pointer.
		 * So if you start at {x: 0, y: 0} (top left), almost immediately the preview will move
		 * to be under the middle of the users pointer.
		 *
		 * _On Android_
		 *
		 * Chrome will put the center of the drag preview under the users pointer immediately.
		 *
		 * Tested on `Chrome@137` on `Android 14` on June 20th 2025
		 *
		 * _What we do_
		 *
		 * We don't add the transparent border
		 *
		 * - Avoid the black color on iOS
		 * - It isn't needed on Android anyway as the preview will be under the center
		 *   of the users pointer
		 *
		 * We put the center of the drag preview under the users pointer
		 *
		 * - Avoids the drag preview quickly moving from a top corner to be centered under
		 *   the users pointer on iOS
		 * - It will be under the center on Android no matter what we do
		 *
		 * We previously had a isTouchDevice() check, but it felt safer for now
		 * to have a more targeted check, as these are the devices that have been
		 * tested on.
		 */ if ((0, $fYxCA.isSafariOnIOS)() || (0, $dJ9DS.isAndroid)()) return (0, $beJwy.centerUnderPointer)({
            container: container
        });
        Object.assign(container.style, {
            borderInlineStart: `${point.x} solid transparent`,
            borderTop: `${point.y} solid transparent`
        });
        // Unfortunate that we need to use `getComputedStyle`,
        // but it's only a single call when the drag is starting.
        const computed = window.getComputedStyle(container);
        if (computed.direction === 'rtl') {
            // The DOMRect will include the new border we added
            const box = container.getBoundingClientRect();
            // Use the top right corner (including the new border) as the offset.
            // The border will push the preview away from the pointer.
            return {
                x: box.width,
                y: 0
            };
        }
        // Use the top left corner as the offset. The border will
        // push the preview away from the pointer.
        return {
            x: 0,
            y: 0
        };
    };
}
module.exports["pointerOutsideOfPreview"] = $c244e860353a6e68$export$427e20518819fabc;

});

parcelRegister("fYxCA", function(module, exports) {

var $gEZCs = parcelRequire("gEZCs");


var $kc8B9 = parcelRequire("kc8B9");

const $e0d278f731546dca$export$52fc40c68fea4952 = (0, $gEZCs.once)(function isSafariOnIOS() {
    return (0, $kc8B9.isSafari)() && 'ontouchend' in document;
});
module.exports["isSafariOnIOS"] = $e0d278f731546dca$export$52fc40c68fea4952;

});

parcelRegister("beJwy", function(module, exports) {
const $d5bf326c593d3c52$export$81d8e72a15eef435 = function centerUnderPointer({ container: container }) {
    const rect = container.getBoundingClientRect();
    return {
        x: rect.width / 2,
        y: rect.height / 2
    };
};
module.exports["centerUnderPointer"] = $d5bf326c593d3c52$export$81d8e72a15eef435;

});

parcelRegister("cDMxg", function(module, exports) {
$parcel$export(module.exports, "setCustomNativeDragPreview", () => (parcelRequire("deUyp")).setCustomNativeDragPreview);

var $deUyp = parcelRequire("deUyp");


});

parcelRegister("deUyp", function(module, exports) {

var $4Vdlk = parcelRequire("4Vdlk");


var $kc8B9 = parcelRequire("kc8B9");


var $f0WuI = parcelRequire("f0WuI");


var $7nhOg = parcelRequire("7nhOg");


var $fbx9a = parcelRequire("fbx9a");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $0a7192879c73e22c$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $0a7192879c73e22c$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $0a7192879c73e22c$var$defaultOffset }) {
    const container = document.createElement('div');
    // Using popover="manual" to place the element in the browser's top layer.
    // This ensures the drag preview container is visually on top of everything else,
    // including elements using z-index and other stacking contexts.
    // "manual" means no light dismiss — we manage the lifecycle ourselves.
    // This element is only created for a single frame for the browser to take a
    // photo of it, and then it is destroyed.
    // Falls back to position:fixed + maxZIndex when the popover API is not available.
    // Note: the popover attribute must be set before the element is in the DOM.
    // `.showPopover()` is called further below after the element is appended to the body.
    if ((0, $fbx9a.supportsPopover)()) container.setAttribute('popover', 'manual');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        ...(0, $fbx9a.supportsPopover)() ? // needs to be overridden by our top / left values
        (0, $7nhOg.popoverResetUserAgentStyles) : {
            // Fallback: using maximum possible z-index so that this element
            // will always be on top of other positioned content.
            zIndex: (0, $f0WuI.maxZIndex)
        },
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    // `.showPopover()` must be called after the element is in the DOM.
    if ((0, $fbx9a.supportsPopover)()) container.showPopover();
    const unmount = render({
        container: container
    });
    /**
	 * Some frameworks (eg `react`) don't render into the container until the next microtask.
	 * - This will run before the browser takes it's picture of the element
	 * - This will run before the animation frame that removes `container`.
	 * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
		 * **Problem**
		 * On `Safari@17.1` if a drag preview element has some opacity,
		 * Safari will include elements behind the drag preview element
		 * in the drag preview.
		 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
		 *
		 * **Fix**
		 * We push the drag preview so it is _almost_ completely offscreen so that
		 * there won't be any elements behind the drag preview element.
		 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
		 *
		 * Using `-0.0001` so that any potential "see through" on the drag preview element
		 * is effectively invisible 👻
		 *
		 * **Unsuccessful alternatives**
		 * Setting a background color (eg "white") on the `container`
		 * → Wrecks the opacity of the drag preview element
		 *
		 * Adding a parent element of the `container` with a background color (eg "white")
		 * → Wrecks the opacity of the drag preview element
		 */ /**
		 * Update: this bug fix is no longer needed in `Safari@26.4` (and maybe earlier)
		 * We can remove it in a future release
		 */ if ((0, $kc8B9.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        // No need to call `.hidePopover()`.
        // Removing the element from the DOM dismisses the popover
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $4Vdlk.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}
module.exports["setCustomNativeDragPreview"] = $0a7192879c73e22c$export$52d889c66db0f96e;

});

parcelRegister("ftFOj", function(module, exports) {

var $ieWRE = parcelRequire("ieWRE");


var $jtuBN = parcelRequire("jtuBN");


var $gZneu = parcelRequire("gZneu");

/** @schema cc */ const $46cf70134ef7593d$var$query = (0, $ieWRE.default);
const $46cf70134ef7593d$export$957cf4ab6fd3f58e = (spaceKey)=>{
    const isSmartFoldersSupported = (0, $gZneu.useIsSmartFoldersSupported)();
    const shouldSkipQuery = !isSmartFoldersSupported || !spaceKey;
    const { loading: loading, data: data } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($46cf70134ef7593d$var$query, {
        variables: {
            spaceKey: spaceKey ?? ''
        },
        skip: shouldSkipQuery,
        __callerPackage__: "smart-folder"
    });
    const enabledContentTypes = data?.space?.spaceTypeSettings?.enabledContentTypes;
    const isFoldersEnabledInSpace = enabledContentTypes?.isFoldersEnabled ?? false;
    const isSmartFoldersEnabledInSpace = enabledContentTypes?.isSmartFoldersEnabled ?? false;
    return {
        isSmartFoldersEnabled: isSmartFoldersSupported && isFoldersEnabledInSpace && isSmartFoldersEnabledInSpace,
        loading: loading
    };
};
module.exports["useIsSmartFoldersEnabled"] = $46cf70134ef7593d$export$957cf4ab6fd3f58e;

});

parcelRegister("ieWRE", function(module, exports) {
/**
 * @generated SignedSource<<5557859264359e1b675fb8554d840b36>>
 * @relayHash 544e060744fb4498c2bc0371295ea8f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID eae917f43c58c67337876ca9022314b94557d64e172a06d9400d5e91a87a797e
const $89ec832c644948be$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFoldersEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSmartFoldersEnabled"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsSmartFoldersEnabledQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsSmartFoldersEnabledQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "544e060744fb4498c2bc0371295ea8f5",
            "id": "eae917f43c58c67337876ca9022314b94557d64e172a06d9400d5e91a87a797e",
            "metadata": {},
            "name": "useIsSmartFoldersEnabledQuery",
            "operationKind": "query",
            "text": "query useIsSmartFoldersEnabledQuery($spaceKey:String!){space(key:$spaceKey){id,spaceTypeSettings{enabledContentTypes{isFoldersEnabled,isSmartFoldersEnabled}}}}"
        }
    };
}();
$89ec832c644948be$var$node.hash = "03675b093cffce21dc93e86a9415a3c7";
var $89ec832c644948be$export$2e2bcd8739ae039 = $89ec832c644948be$var$node;
module.exports["default"] = $89ec832c644948be$export$2e2bcd8739ae039;

});

parcelRegister("gZneu", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");

const $23af0ee2a39f4a09$export$4f0b8fcf328460ea = ()=>{
    const { isRovoEnabled: isRovoEnabled } = (0, $bQm3c.useSessionData)();
    return isRovoEnabled && (0, $6mKj3.expVal)('confluence_folder_view', 'isEnabled', false) && (0, $6mKj3.expVal)('confluence_smart_folders_milestone_1', 'isEnabled', false);
};
module.exports["useIsSmartFoldersSupported"] = $23af0ee2a39f4a09$export$4f0b8fcf328460ea;

});

parcelRegister("hT3jf", function(module, exports) {
/**
 * Returns true if the given content item is a smart (MANAGED) folder.
 *
 * A smart folder is a folder whose `subType` is `"managed"` (the AGG schema
 * returns this value lowercased). Regular folders do not have a subType
 * (it is null or absent).
 *
 * The comparison is case-insensitive to defensively handle any future schema
 * casing changes from the backend.
 *
 * @param content - Any object that may have a `type` and/or `subType` field.
 */ const $13b7c969ce4fb521$export$9aceb9df64593567 = (content)=>{
    return content.type === 'folder' && content.subType?.toLowerCase() === 'managed';
};
module.exports["isSmartFolder"] = $13b7c969ce4fb521$export$9aceb9df64593567;

});

parcelRegister("38vK5", function(module, exports) {

var $iSrRp = parcelRequire("iSrRp");


var $50k8e = parcelRequire("50k8e");

const $13b62b9fdabf1049$var$api = (0, $50k8e.makeApi)({
    monitor: (0, $iSrRp.monitorForElements)
});
const $13b62b9fdabf1049$export$4b66ee8317094cdb = $13b62b9fdabf1049$var$api.autoScroll;
const $13b62b9fdabf1049$export$c9168f41de61f525 = $13b62b9fdabf1049$var$api.autoScrollWindow;
module.exports["autoScrollForElements"] = $13b62b9fdabf1049$export$4b66ee8317094cdb;

});

parcelRegister("50k8e", function(module, exports) {

var $aDtKq = parcelRequire("aDtKq");

parcelRequire("jRbBa");
var $gEZCs = parcelRequire("gEZCs");


var $bTXWf = parcelRequire("bTXWf");


var $4SoL4 = parcelRequire("4SoL4");


var $1UuSE = parcelRequire("1UuSE");

function $f5382ac96223be68$export$b8fa21320a811083({ monitor: monitor }) {
    const elementRegistry = new Map();
    const windowRegistry = new Set();
    function autoScroll(args) {
        elementRegistry.set(args.element, args);
        const cleanup = (0, $aDtKq.combine)((0, $4SoL4.addScrollableAttribute)(args.element), ()=>elementRegistry.delete(args.element));
        return (0, $gEZCs.once)(cleanup);
    }
    function autoScrollWindow(args = {}) {
        // Putting `args` in a unique object so that
        // each call will create a unique entry, even if a consumer
        // shares the `args` object between calls.
        // Just being safe here.
        const unique = {
            ...args
        };
        windowRegistry.add(unique);
        function cleanup() {
            windowRegistry.delete(unique);
        }
        return (0, $gEZCs.once)(cleanup);
    }
    function findEntry(element) {
        return elementRegistry.get(element) ?? null;
    }
    function getWindowScrollEntries() {
        return Array.from(windowRegistry);
    }
    function onFrame({ latestArgs: latestArgs, underUsersPointer: underUsersPointer, timeSinceLastFrame: timeSinceLastFrame }) {
        (0, $1UuSE.tryScroll)({
            input: latestArgs.location.current.input,
            source: latestArgs.source,
            findEntry: findEntry,
            underUsersPointer: underUsersPointer,
            timeSinceLastFrame: timeSinceLastFrame,
            getWindowScrollEntries: getWindowScrollEntries
        });
    }
    (0, $bTXWf.getScheduler)(monitor).onFrame(onFrame);
    return {
        autoScroll: autoScroll,
        autoScrollWindow: autoScrollWindow
    };
}
module.exports["makeApi"] = $f5382ac96223be68$export$b8fa21320a811083;

});

parcelRegister("jRbBa", function(module, exports) {
$parcel$export(module.exports, "once", () => (parcelRequire("gEZCs")).once);

var $gEZCs = parcelRequire("gEZCs");


});

parcelRegister("bTXWf", function(module, exports) {
parcelRequire("66v15");
var $31Y6I = parcelRequire("31Y6I");


var $5Mj3f = parcelRequire("5Mj3f");

// We keep this map so that "over element" scrolling and "overflow" scrolling
// can leverage the same scheduler.
// The 'monitor' is the key for looking up schedulers
const $d27a3192f501902b$var$schedulers = new Map();
function $d27a3192f501902b$export$5cff7ac265db316a(monitor) {
    const scheduler = $d27a3192f501902b$var$schedulers.get(monitor);
    if (scheduler) // @ts-expect-error: I don't know how to link the DragType generic between the key and the value when the
    // monitor itself is the key
    return scheduler;
    const created = $d27a3192f501902b$var$makeScheduler(monitor);
    $d27a3192f501902b$var$schedulers.set(monitor, created);
    return created;
}
function $d27a3192f501902b$var$makeScheduler(monitor) {
    let state = {
        type: 'idle'
    };
    const callbacks = [];
    function loop(timeLastFrameFinished) {
        if (state.type !== 'running') return;
        const timeSinceLastFrame = timeLastFrameFinished - state.timeLastFrameFinished;
        const { latestArgs: latestArgs } = state;
        // A common starting lookup point for determining
        // which auto scroller should be used, and what should be scrolled.
        const underUsersPointer = (0, $31Y6I.getElementFromPointWithoutHoneypot)({
            x: latestArgs.location.current.input.clientX,
            y: latestArgs.location.current.input.clientY
        });
        (0, $5Mj3f.clearUnusedEngagements)(()=>{
            callbacks.forEach((onFrame)=>onFrame({
                    underUsersPointer: underUsersPointer,
                    latestArgs: latestArgs,
                    timeSinceLastFrame: timeSinceLastFrame
                }));
        });
        state.timeLastFrameFinished = timeLastFrameFinished;
        state.frameId = requestAnimationFrame(loop);
    }
    function reset() {
        if (state.type === 'idle') return;
        cancelAnimationFrame(state.frameId);
        (0, $5Mj3f.clearEngagementHistory)();
        state = {
            type: 'idle'
        };
    }
    function start(args) {
        if (state.type !== 'idle') return;
        state = {
            // Waiting a frame so we can accurately determine `timeSinceLastFrame`.
            type: 'initializing',
            latestArgs: args,
            frameId: requestAnimationFrame((timeLastFrameFinished)=>{
                if (state.type !== 'initializing') return;
                state = {
                    type: 'running',
                    timeLastFrameFinished: timeLastFrameFinished,
                    latestArgs: state.latestArgs,
                    frameId: requestAnimationFrame(loop)
                };
            })
        };
    }
    // this module might have been imported after a drag has started
    // We are starting the auto scroller if we get an update event and
    // the auto scroller has not started yet
    function update(args) {
        if (state.type === 'idle') {
            start(args);
            return;
        }
        state.latestArgs = args;
    }
    // Not exposing a way to stop listening
    monitor({
        onDragStart: start,
        onDropTargetChange: update,
        onDrag: update,
        onDrop: reset
    });
    const api = {
        onFrame (fn) {
            callbacks.push(fn);
        }
    };
    return api;
}
module.exports["getScheduler"] = $d27a3192f501902b$export$5cff7ac265db316a;

});

parcelRegister("66v15", function(module, exports) {
$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => (parcelRequire("31Y6I")).getElementFromPointWithoutHoneypot);

var $31Y6I = parcelRequire("31Y6I");


});

parcelRegister("5Mj3f", function(module, exports) {
const $b507fa4d63a4635b$var$ledger = new Map();
const $b507fa4d63a4635b$var$requested = new Set();
function $b507fa4d63a4635b$export$8c764c3f2fc3d2d2(element) {
    $b507fa4d63a4635b$export$1cb7cbb266b6f6fa(element);
    const entry = $b507fa4d63a4635b$var$ledger.get(element);
    if (entry) return entry;
    const fresh = {
        timeOfEngagementStart: Date.now()
    };
    $b507fa4d63a4635b$var$ledger.set(element, fresh);
    return fresh;
}
function $b507fa4d63a4635b$export$1cb7cbb266b6f6fa(element) {
    $b507fa4d63a4635b$var$requested.add(element);
}
function $b507fa4d63a4635b$export$991e77dd347f3df1(fn) {
    // make sure previous engagement requests don't linger
    $b507fa4d63a4635b$var$requested.clear();
    // perform the required work
    fn();
    // if engagements where not requested, purge it
    $b507fa4d63a4635b$var$ledger.forEach((_, element)=>{
        if (!$b507fa4d63a4635b$var$requested.has(element)) $b507fa4d63a4635b$var$ledger.delete(element);
    });
    // cleaning up after ourselves
    $b507fa4d63a4635b$var$requested.clear();
}
function $b507fa4d63a4635b$export$13ae770ed39b71ea() {
    $b507fa4d63a4635b$var$ledger.clear();
}
module.exports["markAndGetEngagement"] = $b507fa4d63a4635b$export$8c764c3f2fc3d2d2;
module.exports["clearUnusedEngagements"] = $b507fa4d63a4635b$export$991e77dd347f3df1;
module.exports["clearEngagementHistory"] = $b507fa4d63a4635b$export$13ae770ed39b71ea;

});

parcelRegister("4SoL4", function(module, exports) {
const $35c4ac2061d5f133$export$4b152ab55cad4fd6 = 'data-auto-scrollable';
const $35c4ac2061d5f133$export$aea217a45095ce11 = `[${$35c4ac2061d5f133$export$4b152ab55cad4fd6}="true"]`;
function $35c4ac2061d5f133$export$4ec12fb57dfebd53(element) {
    element.setAttribute($35c4ac2061d5f133$export$4b152ab55cad4fd6, 'true');
    return ()=>element.removeAttribute($35c4ac2061d5f133$export$4b152ab55cad4fd6);
}
module.exports["selector"] = $35c4ac2061d5f133$export$aea217a45095ce11;
module.exports["addScrollableAttribute"] = $35c4ac2061d5f133$export$4ec12fb57dfebd53;

});

parcelRegister("1UuSE", function(module, exports) {

var $9r8oV = parcelRequire("9r8oV");


var $5Mj3f = parcelRequire("5Mj3f");


var $4SoL4 = parcelRequire("4SoL4");


var $j0x5d = parcelRequire("j0x5d");

function $c48f25f499b57242$var$isScrollingAvailable(value) {
    return Boolean(value.top || value.left);
}
function $c48f25f499b57242$var$tryScrollElements({ target: target, input: input, source: source, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, available: available = {
    top: true,
    left: true
} }) {
    // we cannot do any more scrolling
    if (!$c48f25f499b57242$var$isScrollingAvailable(available)) return available;
    // run out of parents to search
    if (!target) return available;
    const element = target.closest((0, $4SoL4.selector));
    // cannot find any more scroll containers
    if (!element) return available;
    const container = findEntry(element);
    // cannot find registration, this is bad.
    // fail and just exit
    if (!container) return available;
    function continueSearchUp() {
        return $c48f25f499b57242$var$tryScrollElements({
            target: element?.parentElement ?? null,
            findEntry: findEntry,
            source: source,
            timeSinceLastFrame: timeSinceLastFrame,
            input: input,
            available: available
        });
    }
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    // Engagement is not marked if scrolling is explicitly not allowed
    if (container.canScroll && !container.canScroll(feedback)) return continueSearchUp();
    // Marking engagement even if no edges are scrollable.
    // We are marking engagement as soon as the element is scrolled over
    const engagement = (0, $5Mj3f.markAndGetEngagement)(element);
    const config = (0, $9r8oV.getInternalConfig)(container.getConfiguration?.(feedback));
    const allowedAxis = container.getAllowedAxis?.(feedback) ?? 'all';
    const scrollBy = (0, $j0x5d.getScrollBy)({
        element: element,
        engagement: engagement,
        input: input,
        timeSinceLastFrame: timeSinceLastFrame,
        allowedAxis: allowedAxis,
        config: config
    });
    // Only allow scrolling in directions that have not already been used
    const scroll = {
        top: 0,
        left: 0
    };
    if (available.top && scrollBy.top !== 0) {
        scroll.top = scrollBy.top;
        // can no longer scroll on the top after this
        available.top = false;
    }
    if (available.left && scrollBy.left !== 0) {
        scroll.left = scrollBy.left;
        // can no longer scroll on the left after this
        available.left = false;
    }
    // Only scroll if there is something to scroll
    if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
    return continueSearchUp();
}
function $c48f25f499b57242$var$tryScrollWindow({ input: input, timeSinceLastFrame: timeSinceLastFrame, available: available, source: source, entries: entries }) {
    const element = document.documentElement;
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    for (const entry of entries){
        // this entry is not allowing scrolling, we need to look for another
        if (entry.canScroll && !entry.canScroll(feedback)) continue;
        // Note: if we had an event for when the user is leaving a tab
        // we _could_ conceptually reset the engagement
        const engagement = (0, $5Mj3f.markAndGetEngagement)(element);
        const config = (0, $9r8oV.getInternalConfig)(entry.getConfiguration?.(feedback));
        const allowedAxis = entry.getAllowedAxis?.(feedback) ?? 'all';
        const scrollBy = (0, $j0x5d.getScrollBy)({
            element: element,
            engagement: engagement,
            input: input,
            config: config,
            allowedAxis: allowedAxis,
            getRect: (element)=>DOMRect.fromRect({
                    y: 0,
                    x: 0,
                    width: element.clientWidth,
                    height: element.clientHeight
                }),
            timeSinceLastFrame: timeSinceLastFrame
        });
        const scroll = {
            top: available.top ? scrollBy.top : 0,
            left: available.left ? scrollBy.left : 0
        };
        // only trigger a scroll if we are actually scrolling
        if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
        break;
    }
}
function $c48f25f499b57242$export$233199807749476d({ input: input, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, source: source, getWindowScrollEntries: getWindowScrollEntries, underUsersPointer: underUsersPointer }) {
    // We are matching browser behaviour and scrolling inner elements
    // before outer ones. So we try to scroll scroller containers before
    // the window.
    const remainder = $c48f25f499b57242$var$tryScrollElements({
        target: underUsersPointer,
        timeSinceLastFrame: timeSinceLastFrame,
        input: input,
        source: source,
        findEntry: findEntry
    });
    // Check if we can do any window scrolling
    if (!$c48f25f499b57242$var$isScrollingAvailable(remainder)) return;
    $c48f25f499b57242$var$tryScrollWindow({
        input: input,
        source: source,
        entries: getWindowScrollEntries(),
        timeSinceLastFrame: timeSinceLastFrame,
        available: remainder
    });
}
module.exports["tryScroll"] = $c48f25f499b57242$export$233199807749476d;

});

parcelRegister("9r8oV", function(module, exports) {
const $a7ed1bcd13597f53$var$baseConfig = {
    startHitboxAtPercentageRemainingOfElement: {
        top: 0.25,
        right: 0.25,
        bottom: 0.25,
        left: 0.25
    },
    maxScrollAtPercentageRemainingOfHitbox: {
        top: 0.5,
        right: 0.5,
        bottom: 0.5,
        left: 0.5
    },
    timeDampeningDurationMs: 400,
    // Too big and it's too easy to trigger auto scrolling
    // Too small and it's too hard 😅
    maxMainAxisHitboxSize: 180
};
/** What the max scroll should be per second. Using "per second" rather than "per frame"
 * as we want a consistent scroll speed regardless of frame rate.
 *
 *
 * I explored trying to make the max scroll speed dynamic based on particular factors.
 * However, it ended up being difficult to find a _perfect_ formula.
 *
 * Likely the perfect answer would involve:
 * - the size of the scrollable element
 * - the size of the scrollable element relative to the screen size
 * - the size of the drag preview
 * - the size of elements being scrolled in scrollable elements (expensive and difficult to compute)
 */ const $a7ed1bcd13597f53$var$maxPixelScrollPerSecond = {
    // What the value would be if we were scrolling at 15px per frame at 60fps.
    // This is the default as it works well for most experiences.
    // In certain scenarios though it can feel a bit slow.
    standard: 900,
    // What the value would be if we were scrolling at 25px per frame at 60fps.
    // This is not the default as it feels too fast for a lot of experiences.
    fast: 1500
};
function $a7ed1bcd13597f53$export$e96028ec7ff9d079(provided) {
    return {
        ...$a7ed1bcd13597f53$var$baseConfig,
        // only allowing limited control over the config at this stage
        maxPixelScrollPerSecond: $a7ed1bcd13597f53$var$maxPixelScrollPerSecond[provided?.maxScrollSpeed ?? 'standard']
    };
}
module.exports["getInternalConfig"] = $a7ed1bcd13597f53$export$e96028ec7ff9d079;

});

parcelRegister("j0x5d", function(module, exports) {

var $4PtQA = parcelRequire("4PtQA");


var $iqmUH = parcelRequire("iqmUH");


var $lIDh1 = parcelRequire("lIDh1");


var $drwMb = parcelRequire("drwMb");


var $75xM4 = parcelRequire("75xM4");


var $jNg3h = parcelRequire("jNg3h");

function $510e86c1df38ba68$var$getRectDefault(element) {
    return element.getBoundingClientRect();
}
function $510e86c1df38ba68$export$6cfa6dfe6898b98f({ element: element, input: input, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, config: config, allowedAxis: allowedAxis, getRect: getRect = $510e86c1df38ba68$var$getRectDefault }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const clientRect = getRect(element);
    const scrollableEdges = (0, $iqmUH.edges).reduce((map, edge)=>{
        const hitbox = (0, $lIDh1.getOverElementHitbox)[edge]({
            clientRect: clientRect,
            config: config
        });
        const axis = (0, $iqmUH.edgeAxisLookup)[edge];
        // Note: changing the allowed axis during a drag will not
        // reset time dampening. It was decided it would be too
        // complex to implement initially, and we can add it
        // later if needed.
        if (!(0, $75xM4.isAxisAllowed)(axis, allowedAxis)) return map;
        if (!(0, $jNg3h.isWithin)({
            client: client,
            clientRect: hitbox
        })) return map;
        if (!(0, $4PtQA.canScrollOnEdge)[edge](element)) return map;
        map.set(edge, {
            edge: edge,
            hitbox: hitbox
        });
        return map;
    }, new Map());
    const left = (()=>{
        const axis = 'horizontal';
        const leftEdge = scrollableEdges.get('left');
        if (leftEdge) return (0, $drwMb.getScrollChange)({
            client: client,
            edge: leftEdge.edge,
            hitbox: leftEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const rightEdge = scrollableEdges.get('right');
        if (rightEdge) return (0, $drwMb.getScrollChange)({
            client: client,
            edge: rightEdge.edge,
            hitbox: rightEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    const top = (()=>{
        const axis = 'vertical';
        const bottomEdge = scrollableEdges.get('bottom');
        if (bottomEdge) return (0, $drwMb.getScrollChange)({
            client: client,
            edge: bottomEdge.edge,
            hitbox: bottomEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const topEdge = scrollableEdges.get('top');
        if (topEdge) return (0, $drwMb.getScrollChange)({
            client: client,
            edge: topEdge.edge,
            hitbox: topEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    return {
        left: left,
        top: top
    };
}
module.exports["getScrollBy"] = $510e86c1df38ba68$export$6cfa6dfe6898b98f;

});

parcelRegister("4PtQA", function(module, exports) {
const $5318802fe51175c6$export$ccd6d9407403fcad = {
    // Notes:
    //
    // 🌏 Chrome 115.0: uses fractional units for `scrollLeft` and `scrollTop`
    //    (and fractional units don't reach true integer maximum when zoomed in / out)
    // 🍎 Safari 16.5.2: no fractional units
    // 🦊 Firefox 115.0: no fractional units
    // we have some scroll we can move backwards into
    top: (element)=>element.scrollTop > 0,
    // We have some scroll we can move forward into
    right: (element)=>Math.ceil(element.scrollLeft) + element.clientWidth < element.scrollWidth,
    // We have some scroll we can move forwards into
    bottom: (element)=>Math.ceil(element.scrollTop) + element.clientHeight < element.scrollHeight,
    // we have some scroll we can move back into.
    left: (element)=>element.scrollLeft > 0
};
module.exports["canScrollOnEdge"] = $5318802fe51175c6$export$ccd6d9407403fcad;

});

parcelRegister("iqmUH", function(module, exports) {
const $abc8f89ed9b7940d$export$4544a00f8eb65eb2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $abc8f89ed9b7940d$export$7fc144124ccf8292 = {
    top: 'vertical',
    right: 'horizontal',
    bottom: 'vertical',
    left: 'horizontal'
};
module.exports["edges"] = $abc8f89ed9b7940d$export$4544a00f8eb65eb2;
module.exports["edgeAxisLookup"] = $abc8f89ed9b7940d$export$7fc144124ccf8292;

});

parcelRegister("lIDh1", function(module, exports) {

var $eU390 = parcelRequire("eU390");


var $k6QYd = parcelRequire("k6QYd");

function $516f0b1290892600$var$makeGetHitbox({ edge: edge, axis: axis }) {
    return function hitbox({ clientRect: clientRect, config: config }) {
        const { mainAxis: mainAxis, crossAxis: crossAxis } = (0, $eU390.axisLookup)[axis];
        const side = (0, $k6QYd.mainAxisSideLookup)[edge];
        const mainAxisHitboxSize = Math.min(// scale the size of the hitbox down for smaller elements
        config.startHitboxAtPercentageRemainingOfElement[edge] * clientRect[mainAxis.size], // Don't let the hitbox grow too big for big elements
        config.maxMainAxisHitboxSize);
        return DOMRect.fromRect({
            [mainAxis.point]: side === 'start' ? clientRect[mainAxis.point] : clientRect[mainAxis.point] + clientRect[mainAxis.size] - mainAxisHitboxSize,
            [crossAxis.point]: clientRect[crossAxis.point],
            [mainAxis.size]: mainAxisHitboxSize,
            [crossAxis.size]: clientRect[crossAxis.size]
        });
    };
}
const $516f0b1290892600$export$b9a449c20abb0e9 = {
    top: $516f0b1290892600$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'top'
    }),
    right: $516f0b1290892600$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'right'
    }),
    bottom: $516f0b1290892600$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'bottom'
    }),
    left: $516f0b1290892600$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'left'
    })
};
module.exports["getOverElementHitbox"] = $516f0b1290892600$export$b9a449c20abb0e9;

});

parcelRegister("eU390", function(module, exports) {
const $5b0e1b1531f93246$var$vertical = {
    start: 'top',
    end: 'bottom',
    point: 'y',
    size: 'height'
};
const $5b0e1b1531f93246$var$horizontal = {
    start: 'left',
    end: 'right',
    point: 'x',
    size: 'width'
};
const $5b0e1b1531f93246$export$42e42cdab35a2b96 = {
    vertical: {
        mainAxis: $5b0e1b1531f93246$var$vertical,
        crossAxis: $5b0e1b1531f93246$var$horizontal
    },
    horizontal: {
        mainAxis: $5b0e1b1531f93246$var$horizontal,
        crossAxis: $5b0e1b1531f93246$var$vertical
    }
};
module.exports["axisLookup"] = $5b0e1b1531f93246$export$42e42cdab35a2b96;

});

parcelRegister("k6QYd", function(module, exports) {
const $51fdf9dde687ea21$export$a45c0cd714a4dbaa = {
    top: 'start',
    right: 'end',
    bottom: 'end',
    left: 'start'
};
module.exports["mainAxisSideLookup"] = $51fdf9dde687ea21$export$a45c0cd714a4dbaa;

});

parcelRegister("drwMb", function(module, exports) {

var $eU390 = parcelRequire("eU390");


var $fYr9O = parcelRequire("fYr9O");


var $k6QYd = parcelRequire("k6QYd");

// We want a consistent scroll speed across devices, regardless of framerate
function $4d516d91c431b939$var$getMaxScrollChange({ timeSinceLastFrame: timeSinceLastFrame, config: config }) {
    const targetScrollPerMs = config.maxPixelScrollPerSecond / 1000;
    // Adjusting out target scroll rate to match the frame rate of the target device
    // This will pull the scroll speed down on high frame rate devices
    // so we get a consistent visual scroll speed regardless of device.
    const proposed = Math.ceil(targetScrollPerMs * timeSinceLastFrame);
    // If lots of time as passed since that last frame (such on lower frame rate devices)
    // we don't want the scroll speed to be too fast, otherwise it can feel jumpy
    // We are capping the scroll speed at what it would be if we were hitting 60fps
    const maximum = config.maxPixelScrollPerSecond / 60;
    return Math.min(proposed, maximum);
}
function $4d516d91c431b939$var$getDistanceDampening({ client: client, axis: axis, edge: edge, hitbox: hitbox, config: config }) {
    const { mainAxis: mainAxis } = (0, $eU390.axisLookup)[axis];
    const side = (0, $k6QYd.mainAxisSideLookup)[edge];
    // We want to hit the max speed before the edge of the hitbox
    const maxSpeedBuffer = hitbox[mainAxis.size] * config.maxScrollAtPercentageRemainingOfHitbox[edge];
    if (side === 'end') return (0, $fYr9O.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start],
        endOfRange: hitbox[mainAxis.end] - maxSpeedBuffer,
        value: client[mainAxis.point]
    });
    // Moving towards start edge
    const raw = (0, $fYr9O.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start] + maxSpeedBuffer,
        endOfRange: hitbox[mainAxis.end],
        value: client[mainAxis.point]
    });
    // When moving near start edge
    // - the 'end' edge is where we start scrolling
    // - the 'start' edge is where we reach max speed
    // So we need to invert the percentage when moving backwards
    return 1 - raw;
}
function $4d516d91c431b939$export$470a2ff46db8cee8({ client: client, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, axis: axis, hitbox: hitbox, edge: edge, isDistanceDampeningEnabled: isDistanceDampeningEnabled, config: config }) {
    // We have two forms of speed dampening:
    // 1. 🗺️ Distance
    // The closer you are to a hitbox edge, the faster the scroll speed will be
    // 2. ⏱️ Time
    // When first entering a scroll container we want to dampening all scrolling
    // This is to prevent super fast auto scrolling when first entering into
    // a scroll container, or when lifting in a scroll container
    const maxScroll = $4d516d91c431b939$var$getMaxScrollChange({
        timeSinceLastFrame: timeSinceLastFrame,
        config: config
    });
    const percentageDistanceDampening = isDistanceDampeningEnabled ? $4d516d91c431b939$var$getDistanceDampening({
        client: client,
        edge: edge,
        hitbox: hitbox,
        axis: axis,
        config: config
    }) : 1;
    // Dampen speed by time
    const percentageThroughTimeDampening = (0, $fYr9O.getPercentageInRange)({
        startOfRange: engagement.timeOfEngagementStart,
        endOfRange: engagement.timeOfEngagementStart + config.timeDampeningDurationMs,
        value: Date.now()
    });
    // Calculate how much of the max scroll we should apply based on dampening
    const percentageOfMaxScroll = percentageDistanceDampening * percentageThroughTimeDampening;
    // We _could_ ease this update (`Math.pow(percentageOfMaxSpeed, 2)`)
    // But linear is feeling really good
    // Always scrolling by at least one pixel, otherwise the scroll does nothing
    const scroll = Math.max(maxScroll * percentageOfMaxScroll, 1);
    const side = (0, $k6QYd.mainAxisSideLookup)[edge];
    // When moving backwards, we will be scrolling backwards
    return side === 'end' ? scroll : -1 * scroll;
}
module.exports["getScrollChange"] = $4d516d91c431b939$export$470a2ff46db8cee8;

});

parcelRegister("fYr9O", function(module, exports) {
function $e40a4c0dcd17caec$export$1a29de000a332d74({ startOfRange: startOfRange, endOfRange: endOfRange, value: value }) {
    // checking inputs
    const isValid = startOfRange < endOfRange;
    if (!isValid) return 0;
    if (value < startOfRange) return 0;
    if (value > endOfRange) return 1;
    const range = endOfRange - startOfRange;
    return (value - startOfRange) / range;
}
module.exports["getPercentageInRange"] = $e40a4c0dcd17caec$export$1a29de000a332d74;

});

parcelRegister("75xM4", function(module, exports) {
function $21de06d925095ccb$export$7120fdbd90bd1292(axis, allowedAxis) {
    return allowedAxis === 'all' || axis === allowedAxis;
}
module.exports["isAxisAllowed"] = $21de06d925095ccb$export$7120fdbd90bd1292;

});

parcelRegister("jNg3h", function(module, exports) {
function $97331151dddf073e$export$cda7a9d4399bf2e3({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
module.exports["isWithin"] = $97331151dddf073e$export$cda7a9d4399bf2e3;

});

parcelRegister("hHzd2", function(module, exports) {
const $4ee2c7f82a7b207c$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #1868DB)",
    warning: "var(--ds-border-warning, #E06C00)"
};
const $4ee2c7f82a7b207c$export$45db03aa04b685e3 = "var(--ds-border-width-selected, 2px)";
module.exports["presetStrokeColors"] = $4ee2c7f82a7b207c$export$477fafec326bfca0;
module.exports["presetStrokeWidth"] = $4ee2c7f82a7b207c$export$45db03aa04b685e3;

});

parcelRegister("vZEJe", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $cVoAa = parcelRequire("cVoAa");


var $hHzd2 = parcelRequire("hHzd2");

const $b399db01e99f7201$export$62ed72bc21f6b8a6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DropIndicator(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { appearance: t1, edge: edge, gap: gap, indent: indent, type: type } = t0;
    const appearance = t1 === undefined ? "default" : t1;
    const t2 = (0, $hHzd2.presetStrokeColors)[appearance];
    let t3;
    if ($[0] !== edge || $[1] !== gap || $[2] !== indent || $[3] !== t2 || $[4] !== type) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cVoAa.Line), {
            edge: edge,
            gap: gap,
            strokeColor: t2,
            type: type,
            indent: indent
        });
        $[0] = edge;
        $[1] = gap;
        $[2] = indent;
        $[3] = t2;
        $[4] = type;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : function DropIndicator({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cVoAa.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $hHzd2.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
};
var // This default export is intended for usage with React.lazy
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b399db01e99f7201$export$2e2bcd8739ae039 = $b399db01e99f7201$export$62ed72bc21f6b8a6;
module.exports["DropIndicator"] = $b399db01e99f7201$export$62ed72bc21f6b8a6;
module.exports["default"] = $b399db01e99f7201$export$2e2bcd8739ae039;

});

parcelRegister("cVoAa", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $hHzd2 = parcelRequire("hHzd2");

const $06f7f86bfd55e0d2$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $06f7f86bfd55e0d2$var$baseStyles = {
    root: "_1e0c1ule _kqswstnw _1pbykb7n _lcxvglyw _bfhkys7w _rfx31ssb _3l8810ly _kzdanqa1 _15m6ys7w _cfu11ld9 _1kt9b3bt _1cs8stnw _13y0usvi _1mp4vjfa _kfgtvjfa"
};
const $06f7f86bfd55e0d2$var$orientationStyles = {
    horizontal: "_4t3i10ly _1e02fghn _rjxpidpf _z5wtuj5p",
    vertical: "_1bsb10ly _154ifghn _94n5idpf _1aukuj5p"
};
const $06f7f86bfd55e0d2$var$edgeStyles = {
    top: "_154ihv0e _1auk70hn",
    right: "_1xi2hv0e _ooun70hn",
    bottom: "_94n5hv0e _19wo70hn",
    left: "_1ltvhv0e _qnec70hn"
};
const $06f7f86bfd55e0d2$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
const $06f7f86bfd55e0d2$export$17d680238e50603e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Line(t0) {
    const $ = (0, $bDgLe.c)(15);
    const { edge: edge, gap: t1, indent: t2, strokeColor: t3, strokeWidth: t4, type: t5 } = t0;
    const gap = t1 === undefined ? "0px" : t1;
    const indent = t2 === undefined ? "0px" : t2;
    const strokeColor = t3 === undefined ? (0, $hHzd2.presetStrokeColors).default : t3;
    const strokeWidth = t4 === undefined ? (0, $hHzd2.presetStrokeWidth) : t4;
    const type = t5 === undefined ? "terminal" : t5;
    const orientation = $06f7f86bfd55e0d2$var$edgeToOrientationMap[edge];
    const t6 = `calc(-0.5 * (${gap} + var(--stroke-width)))`;
    let t7;
    if ($[0] !== indent || $[1] !== type) {
        t7 = $06f7f86bfd55e0d2$var$lineStartFrom[type]({
            indent: indent
        });
        $[0] = indent;
        $[1] = type;
        $[2] = t7;
    } else t7 = $[2];
    const t8 = type === "no-terminal" ? "none" : "block";
    let t9;
    if ($[3] !== strokeColor || $[4] !== strokeWidth || $[5] !== t6 || $[6] !== t7 || $[7] !== t8) {
        t9 = {
            "--stroke-color": strokeColor,
            "--stroke-width": strokeWidth,
            "--main-axis-offset": t6,
            "--line-main-axis-start": t7,
            "--terminal-display": t8,
            "--terminal-diameter": "calc(var(--stroke-width) * 4)",
            "--terminal-radius": "calc(var(--terminal-diameter) / 2)",
            "--terminal-main-axis-start": "calc(-1 * var(--terminal-diameter))",
            "--terminal-cross-axis-offset": "calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)"
        };
        $[3] = strokeColor;
        $[4] = strokeWidth;
        $[5] = t6;
        $[6] = t7;
        $[7] = t8;
        $[8] = t9;
    } else t9 = $[8];
    const t10 = t9;
    const t11 = $06f7f86bfd55e0d2$var$orientationStyles[orientation];
    const t12 = $06f7f86bfd55e0d2$var$edgeStyles[edge];
    let t13;
    if ($[9] !== t11 || $[10] !== t12) {
        t13 = (0, $hekY6.default)([
            $06f7f86bfd55e0d2$var$baseStyles.root,
            t11,
            t12
        ]);
        $[9] = t11;
        $[10] = t12;
        $[11] = t13;
    } else t13 = $[11];
    let t14;
    if ($[12] !== t10 || $[13] !== t13) {
        t14 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            style: t10,
            className: t13
        });
        $[12] = t10;
        $[13] = t13;
        $[14] = t14;
    } else t14 = $[14];
    return t14;
} : function Line({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $hHzd2.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $hHzd2.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $06f7f86bfd55e0d2$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $06f7f86bfd55e0d2$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $hekY6.default)([
            $06f7f86bfd55e0d2$var$baseStyles.root,
            $06f7f86bfd55e0d2$var$orientationStyles[orientation],
            $06f7f86bfd55e0d2$var$edgeStyles[edge]
        ])
    });
}; // For React.lazy
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$06f7f86bfd55e0d2$export$2e2bcd8739ae039 = $06f7f86bfd55e0d2$export$17d680238e50603e;
module.exports["Line"] = $06f7f86bfd55e0d2$export$17d680238e50603e;

});

parcelRegister("4o1RV", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $1eD4P = parcelRequire("1eD4P");


var $ihkY1 = parcelRequire("ihkY1");


var $kBW0t = parcelRequire("kBW0t");

function $f3bd82ae210529c7$export$57395cb9dce31159() {
    const $ = (0, $bDgLe.c)(3);
    const { navigationPolicy: navigationPolicy } = (0, $1eD4P.useReactProps_DO_NOT_USE)() || {};
    const routePolicy = (0, $ihkY1.useRoutePolicy)(navigationPolicy);
    const shimUrl = (0, $kBW0t.useShimUrl)(navigationPolicy);
    let t0;
    if ($[0] !== routePolicy || $[1] !== shimUrl) {
        t0 = {
            routePolicy: routePolicy,
            ...shimUrl
        };
        $[0] = routePolicy;
        $[1] = shimUrl;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
}
module.exports["useNavigationPolicy"] = $f3bd82ae210529c7$export$57395cb9dce31159;

});

parcelRegister("ihkY1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lTECB = parcelRequire("lTECB");


var $1eD4P = parcelRequire("1eD4P");


var $cb6fO = parcelRequire("cb6fO");


var $kBW0t = parcelRequire("kBW0t");

function $477c5af85d2d7fb0$export$53e37724c6846f41(navigationPolicy) {
    const isEmbeddedConfluence = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    const { shimUrl: shimUrl } = (0, $kBW0t.useShimUrl)(navigationPolicy);
    const iframePassThroughProps = (0, $1eD4P.useReactProps_DO_NOT_USE)();
    const enableIframeSpaTransitions = iframePassThroughProps?.enableSpaTransitions;
    const getEmbeddedConfluenceRoutePolicy = (0, $cozmU.useCallback)(()=>({
            push ({ match: match, matchSupportedRoute: matchSupportedRoute, open: open, push: defaultPush }, url, forceReload) {
                // When navigate to an url with anchor only e.g. `#test`, the navigation doesn't need to continue as SPA transition,
                // Hence, there is no need to continue the navigation using `push` and potentially execute parent product's navigate method.
                // In this case, we exit `routePolicy.push` earlier and use `open` (window.open) to load the url in the exisitng browsing context
                if ((0, $cb6fO.isHashedOnlyURL)(url)) {
                    open(url, '_self');
                    return;
                }
                const _currRouteName = match?.name;
                const _currRouteContentId = match?.params.contentId;
                const _destinationRoute = matchSupportedRoute(url);
                const _dstRouteName = _destinationRoute?.name;
                const _dstRouteContentId = _destinationRoute?.params.contentId;
                const _dstRouteSpaceKey = _destinationRoute?.params.spaceKey;
                /**
       * Transition within the same window if the target route is navigating to the same content
       * This can ensure link to anchors in the page can still happen within the same window, instead of opening a new tab
       **/ const modifiers = {
                    routeName: $477c5af85d2d7fb0$var$toEPRouteName(_dstRouteName),
                    contentId: _dstRouteContentId,
                    spaceKey: _dstRouteSpaceKey,
                    target: this.willPushInSelf(_currRouteName, _currRouteContentId, _dstRouteName, _dstRouteContentId) ? '_self' : '_blank'
                };
                const defaultNavigate = (url_0, { target: target })=>{
                    // We double check the url here in case parent product modify the `url` in `navigate` function and provided the hashed-only url to `defaultNavigate`
                    if ((0, $cb6fO.isHashedOnlyURL)(url_0)) {
                        open(url_0, '_self');
                        return;
                    }
                    const destRoute = matchSupportedRoute(url_0);
                    const willPushInSelf = this.willPushInSelf(_currRouteName, _currRouteContentId, destRoute?.name, destRoute?.params.contentId);
                    // When navigate to an url with anchor and destination is under the same route for same content,
                    // EP's default navigtation should simply follow browser's navigation instead of going to `defaultPush` and execute `history.push`.
                    // In this case, we use `open` (window.open) to load in the exisitng browsing context
                    if (willPushInSelf && Boolean(destRoute?.hash)) {
                        open(destRoute?.hash, '_self');
                        return;
                    }
                    if (target === '_self') defaultPush(url_0, forceReload);
                    else open(url_0, target);
                };
                /**
       * defaultNavigate can be invoked by the embedding product because it's the 3rd argument to
       * navigationPolicy's navigate. If embedding product tells EP to navigate to a URL in a new
       * tab, EP should not shim (rebase) it since the embedding product has already had a chance
       * and they chose not to. On the other hand, if the embedding product does not tell EP to
       * nagivate, EP can shim the url only when opening a new tab (some links might not have been
       * shimmed, need to shim all links supposed to be shimmed as the last defense).
       **/ return navigationPolicy?.navigate ? navigationPolicy?.navigate(url, modifiers, defaultNavigate) : defaultNavigate(modifiers.target === '_self' ? url : shimUrl(url), modifiers);
            },
            willPushInSelf (currRouteName, currRouteContentId, dstRouteName, dstRouteContentId) {
                const isEPRoute = !!$477c5af85d2d7fb0$var$toEPRouteName(dstRouteName);
                const isSameRoute = currRouteName === dstRouteName && currRouteContentId === dstRouteContentId;
                const shouldTransition = !!enableIframeSpaTransitions && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(currRouteName ?? '') && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(dstRouteName ?? '') && currRouteContentId === dstRouteContentId;
                return isEPRoute && (isSameRoute || shouldTransition);
            }
        }), [
        enableIframeSpaTransitions,
        navigationPolicy,
        shimUrl
    ]);
    return (0, $cozmU.useMemo)(()=>isEmbeddedConfluence ? getEmbeddedConfluenceRoutePolicy() : undefined, [
        isEmbeddedConfluence,
        getEmbeddedConfluenceRoutePolicy
    ]);
}
function $477c5af85d2d7fb0$var$toEPRouteName(routeName) {
    switch(routeName){
        case 'VIEW_PAGE':
        case 'EDIT_PAGE_EMBED':
            return routeName;
        default:
            return undefined;
    }
}
module.exports["useRoutePolicy"] = $477c5af85d2d7fb0$export$53e37724c6846f41;

});

parcelRegister("kBW0t", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $dOBRD = parcelRequire("dOBRD");


var $f8dGE = parcelRequire("f8dGE");


var $islpn = parcelRequire("islpn");


var $cb6fO = parcelRequire("cb6fO");

const $734ea8da77496ad5$var$isAdfContent = (content)=>{
    return content && typeof content === 'object' && content.type === 'doc' && Array.isArray(content.content);
};
function $734ea8da77496ad5$export$8ed0b067e5cd675d(navigationPolicy) {
    const $ = (0, $bDgLe.c)(17);
    const shimTemplate = navigationPolicy?.shimUrl;
    const domainNamesToReplace = navigationPolicy?.domainNamesToReplace;
    const spaceKeyFilter = navigationPolicy?.spaceKeyFilter;
    let t0;
    if ($[0] !== domainNamesToReplace || $[1] !== shimTemplate || $[2] !== spaceKeyFilter) {
        t0 = (urlToShim)=>$734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        $[0] = domainNamesToReplace;
        $[1] = shimTemplate;
        $[2] = spaceKeyFilter;
        $[3] = t0;
    } else t0 = $[3];
    const shimUrl = t0;
    let t1;
    if ($[4] !== domainNamesToReplace || $[5] !== shimTemplate || $[6] !== spaceKeyFilter) {
        t1 = (adf)=>{
            if (!shimTemplate || !adf || !Object.keys(adf).length) return adf;
            const adfClone = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(adf);
            $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfClone, shimTemplate, domainNamesToReplace, spaceKeyFilter);
            return adfClone;
        };
        $[4] = domainNamesToReplace;
        $[5] = shimTemplate;
        $[6] = spaceKeyFilter;
        $[7] = t1;
    } else t1 = $[7];
    const shimAdfUrls = t1;
    let t2;
    if ($[8] !== domainNamesToReplace || $[9] !== shimAdfUrls || $[10] !== shimTemplate || $[11] !== spaceKeyFilter) {
        t2 = (html)=>{
            if (!shimTemplate || !html) return html;
            try {
                const parsedContent = JSON.parse(html);
                if ($734ea8da77496ad5$var$isAdfContent(parsedContent)) {
                    if (html.includes("\"extensionKey\":\"nested-table\"")) {
                        const processedAdf = $734ea8da77496ad5$var$shimAdfWithNestedTables(parsedContent, shimAdfUrls);
                        return JSON.stringify(processedAdf);
                    } else {
                        const shimmedAdf = shimAdfUrls(parsedContent);
                        return JSON.stringify(shimmedAdf);
                    }
                }
            } catch  {}
            try {
                return $734ea8da77496ad5$var$shimDomUrls(new DOMParser().parseFromString(html, "text/html"), shimTemplate, domainNamesToReplace, spaceKeyFilter).body.innerHTML;
            } catch  {
                return html;
            }
        };
        $[8] = domainNamesToReplace;
        $[9] = shimAdfUrls;
        $[10] = shimTemplate;
        $[11] = spaceKeyFilter;
        $[12] = t2;
    } else t2 = $[12];
    const shimHtmlUrls = t2;
    let t3;
    if ($[13] !== shimAdfUrls || $[14] !== shimHtmlUrls || $[15] !== shimUrl) {
        t3 = {
            shimUrl: shimUrl,
            shimAdfUrls: shimAdfUrls,
            shimHtmlUrls: shimHtmlUrls
        };
        $[13] = shimAdfUrls;
        $[14] = shimHtmlUrls;
        $[15] = shimUrl;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
}
function $734ea8da77496ad5$var$shimDomUrls(dom, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    const anchors = dom.getElementsByTagName('a');
    Array.from(anchors).forEach((a)=>{
        a.href = $734ea8da77496ad5$var$shimThisUrl(a.href, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    const imgs = dom.getElementsByTagName('img');
    Array.from(imgs).forEach((img)=>{
        img.src = $734ea8da77496ad5$var$shimThisUrl(img.src, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    return dom;
}
function $734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    if (!shimTemplate || !urlToShim || (0, $cb6fO.isHashedOnlyURL)(urlToShim) || !$734ea8da77496ad5$var$isUrlForShimmedSpace(urlToShim, spaceKeyFilter)) return urlToShim;
    try {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const baseUrl = document.baseURI || window.location.toString();
        const absUrlWithDomainToShim = $734ea8da77496ad5$var$getAbsUrlWithDomain(urlToShim, baseUrl);
        const urlPrefixToShim = $734ea8da77496ad5$var$ccAbsUrlWithDomain(baseUrl);
        const urlShimTemplate = $734ea8da77496ad5$var$shimAbsUrlWithDomain(shimTemplate, baseUrl);
        return $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace);
    } catch  {
        return urlToShim;
    }
}
function $734ea8da77496ad5$var$isUrlForShimmedSpace(url, spaceKeyFilter) {
    // If no filter, shim all URLs (backwards compatibility)
    if (!spaceKeyFilter?.length) return true;
    // Regex to extract spaceKey from /spaces/<spaceKey>/
    const match = url.match(/\/spaces\/([^/]+)/);
    if (match) {
        // If URL contains /spaces/<spaceKey>, only shim if spaceKey is in the filter
        const spaceKey = match[1];
        return spaceKeyFilter.includes(spaceKey);
    }
    // For other /wiki URLs (e.g., share links), retain previous behavior and shim
    return true;
}
const $734ea8da77496ad5$var$ccAbsUrlWithDomain = (0, $dOBRD.default)((base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain((0, $cb6fO.CONTEXT_PATH), base)));
const $734ea8da77496ad5$var$shimAbsUrlWithDomain = (0, $dOBRD.default)((urlShimTemplate, base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain(urlShimTemplate, base)));
function $734ea8da77496ad5$var$getAbsUrlWithDomain(url, base) {
    return new URL(url, base).toString();
}
function $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace) {
    if (absUrlWithDomainToShim.includes((0, $cb6fO.CONTEXT_PATH))) {
        //We can only rebase or shim /wiki URLs
        const absUrlObj = new URL(absUrlWithDomainToShim);
        const baseUrlObj = new URL(baseUrl);
        //Check if the URL should be rebased
        if (domainNamesToReplace?.includes(absUrlObj.hostname)) {
            //Rebase the URL by replacing the origin string of absUrlWithDomainToShim with that of baseUrl
            const rebasedAbsUrlToShim = absUrlWithDomainToShim.replace(absUrlObj.origin, baseUrlObj.origin);
            //Shimming the rebased URL
            return rebasedAbsUrlToShim.replace(urlPrefixToShim, urlShimTemplate);
        }
    }
    return absUrlWithDomainToShim.replace(urlPrefixToShim, urlShimTemplate);
}
function $734ea8da77496ad5$var$appendSlash(url) {
    if (!url.endsWith('/')) return `${url}/`;
    return url;
}
const $734ea8da77496ad5$var$URL_ADF_KEYS = [
    'url',
    'href'
];
function $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfJson, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    Object.entries(adfJson).forEach(([key, value])=>{
        if (!value) return;
        if ($734ea8da77496ad5$var$URL_ADF_KEYS.includes(key) && typeof value === 'string') adfJson[key] = $734ea8da77496ad5$var$shimThisUrl(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        else if (typeof value === 'object') $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
}
/**
 * Shims URLs in ADF content that contains nested tables.
 * This function processes ADF document content with nested tables by:
 * 1. Transforming nested tables (incoming)
 * 2. Applying URL shimming via shimAdfUrls
 * 3. Transforming nested tables (outgoing)
 *
 * @param adfContent - Parsed ADF document content (already validated)
 * @param shimAdfUrls - Function to apply URL shimming to ADF objects
 * @returns Processed ADF object with shimmed URLs and transformed nested tables
 */ function $734ea8da77496ad5$var$shimAdfWithNestedTables(adfContent, shimAdfUrls) {
    // Process ADF document with nested tables - transform and delegate to shimAdfUrls
    const { transformedAdf: transformedAdf } = (0, $islpn.transformNestedTablesIncomingDocument)(adfContent);
    const shimmedAdf = shimAdfUrls(transformedAdf);
    return (0, $islpn.transformNestedTableNodeOutgoingDocument)(shimmedAdf);
}
module.exports["useShimUrl"] = $734ea8da77496ad5$export$8ed0b067e5cd675d;

});

parcelRegister("d0Ide", function(module, exports) {
var $fe73de88bf54921d$export$288b04954abdcf5 = /*#__PURE__*/ function(EventSourceName) {
    EventSourceName["ADD_LABEL_TO_PAGE"] = "automationDiscoveryWhenLabelAddedToPage";
    EventSourceName["MEETING_NOTES"] = "automationDiscoveryWhenPublishingMeetingNotes";
    EventSourceName["ARCHIVE_PAGE"] = "automationDiscoveryWhenArchivingPage";
    EventSourceName["HOVER_OVER_PAGE_TITLE"] = "automationDiscoveryFromHoverOverPageTitle";
    EventSourceName["JIRA_LINK"] = "automationDiscoveryJiraLink";
    EventSourceName["MANUAL_TRIGGER"] = "automationDiscoveryManualTrigger";
    EventSourceName["MANUAL_TRIGGER_SMART_BUTTON"] = "automationDiscoveryManualTriggerSmartButton";
    EventSourceName["IN_CONTEXT_RULE_BUILDER"] = "automationDiscoveryInContextRuleBuilder";
    EventSourceName["VERIFED_CONTENT"] = "automationDiscoveryVerifiedContent";
    EventSourceName["BULK_ARCHIVE"] = "automationDiscoveryBulkArchive";
    EventSourceName["GLOBAL_PUBLIC_LINKS"] = "automationDiscoveryGlobalPermissions";
    EventSourceName["PAGE_PUBLIC_LINKS"] = "automationDiscoverPageShare";
    EventSourceName["BULK_ASSIGN"] = "automationDiscoverySpaceAssignedBulk";
    EventSourceName["SINGLE_ASSIGN"] = "automationDiscoverySpaceAssignedSingle";
    EventSourceName["DEFAULT_SPACE_ASSIGN"] = "automationDiscoveryDefaultSpaceAssigned";
    EventSourceName["WHITE_BOARDS"] = "automationDiscoveryPublishWhiteBoards";
    EventSourceName["SHARE_SLACK"] = "automationDiscoveryShareSlack";
    EventSourceName["BULK_CHANGE_OWNER"] = "automationDiscoveryBulkChangePageOwner";
    EventSourceName["PRODUCT_REQUIREMENTS"] = "automationDiscoveryProductRequirements";
    EventSourceName["FEEDBACK_ANALYSIS"] = "automationDiscoveryFeedbackAnalysis";
    EventSourceName["RELEASE_NOTES"] = "automationDiscoveryReleaseNotes";
    return EventSourceName;
}({});
module.exports["EventSourceName"] = $fe73de88bf54921d$export$288b04954abdcf5;

});

parcelRegister("hTxAd", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $tgs13 = parcelRequire("tgs13");

const $a5f7b05a2384a497$export$9f585226e9430b76 = (experienceKey)=>{
    (0, $17wUi.confluenceLocalStorageInstance).setItem(experienceKey, true, (0, $tgs13.TWENTY_EIGHT_DAYS_IN_SECONDS));
};
module.exports["markDiscoveryExperienceAsSeen"] = $a5f7b05a2384a497$export$9f585226e9430b76;

});

parcelRegister("tgs13", function(module, exports) {
const $2e9fe66aaea8de6a$export$f09b8e10e3913161 = 2419200;
const $2e9fe66aaea8de6a$export$885b9d72bc39ecdb = 2592000000;
const $2e9fe66aaea8de6a$export$6ec716a28918c083 = 31536000;
module.exports["TWENTY_EIGHT_DAYS_IN_SECONDS"] = $2e9fe66aaea8de6a$export$f09b8e10e3913161;
module.exports["THREE_HUNDRED_SIXTY_FIVE_DAYS_IN_SECONDS"] = $2e9fe66aaea8de6a$export$6ec716a28918c083;

});

parcelRegister("5v7QA", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $kSwu1 = parcelRequire("kSwu1");

const $9b11c5b093926f82$export$242890b69747c0cf = (0, $kSwu1.defineMessages)({
    dismiss: {
        id: "automation-discovery.common.dismiss",
        defaultMessage: "Not now"
    },
    showMeHow: {
        id: "automation-discovery.common.show-me-how",
        defaultMessage: "Show me how"
    },
    spotlightCta: {
        id: "automation-discovery.manual-trigger.cta.text",
        defaultMessage: "Build rule"
    },
    spotlightDismiss: {
        id: "automation-discovery.manual-trigger.dismiss",
        defaultMessage: "Done"
    }
});
const $9b11c5b093926f82$export$eaeae0ae54954c9a = (0, $kSwu1.defineMessages)({
    header: {
        id: "automation-discovery.hover-page-title.header",
        defaultMessage: "Auto-archive old pages?"
    },
    message: {
        id: "automation-discovery.hover-page-title.message",
        defaultMessage: "This page hasn\u2019t been updated lately. An Automation rule could archive old pages once a month."
    }
});
const $9b11c5b093926f82$export$6216ba99d37b53d2 = (0, $kSwu1.defineMessages)({
    header: {
        id: "automation-discovery.archive.from-archive-modal",
        defaultMessage: "Confluence can auto-archive old pages"
    },
    message: {
        id: "automation-discovery.archive.message",
        defaultMessage: "Try building this Automation rule: Archive pages in this space that haven\u2019t been updated in at least 3 months."
    },
    success: {
        id: "automation-discovery.archive.success",
        defaultMessage: "Your page was archived"
    },
    successHeader: {
        id: "automation-discovery.archive.success-header",
        defaultMessage: "Archived successfully"
    },
    viewInArchive: {
        id: "automation-discovery.archive.view-in-archive",
        defaultMessage: "View in archive"
    }
});
const $9b11c5b093926f82$export$e252be6159b8f418 = (0, $kSwu1.defineMessages)({
    title: {
        id: "automation-discovery.add-label.title",
        defaultMessage: "Confluence can auto-add labels"
    },
    message: {
        id: "automation-discovery.add-label.message",
        defaultMessage: "Try building this Automation rule: When the user you choose publishes a new page, label it with their name."
    }
});
const $9b11c5b093926f82$export$defcdcbe29897057 = (0, $kSwu1.defineMessages)({
    success: {
        id: "automation-discovery.meeting-notes.success",
        defaultMessage: "Your page was published"
    },
    title: {
        id: "automation-discovery.meeting-notes.title",
        defaultMessage: "Confluence can auto-publish pages"
    },
    message: {
        id: "automation-discovery.meeting-notes.message",
        defaultMessage: "Try building this Automation rule: Publish a new Meeting notes page according to your meeting schedule."
    },
    ctaText: {
        id: "automation-discovery.meeting-notes.cta.text",
        defaultMessage: "Auto-summarize pages?"
    },
    modalBody: {
        id: "automation-discovery.meeting-notes.modal.body",
        defaultMessage: "{publishedPageTitle} was successfully published in the {spaceName} space"
    },
    successIconLabel: {
        id: "automation-discovery.meeting-notes.success.icon.label",
        defaultMessage: "Success check icon"
    },
    modalCloseIconLabel: {
        id: "automation-discovery.meeting-notes.modal.close.icon.label",
        defaultMessage: "Close icon for modal"
    }
});
const $9b11c5b093926f82$export$ce468634859ccf2b = (0, $kSwu1.defineMessages)({
    ctaText: {
        id: "automation-discovery.jira-link.cta.text",
        defaultMessage: "Auto-link Jira issues?"
    }
});
const $9b11c5b093926f82$export$51183073ec843a06 = (0, $kSwu1.defineMessages)({
    title: {
        id: "automation-discovery.manual-trigger.title",
        defaultMessage: "Page automation menu"
    },
    body: {
        id: "automation-discovery.manual-trigger.body",
        defaultMessage: "Teammates can apply rules from this menu to a single page."
    }
});
const $9b11c5b093926f82$export$4cf5be76251112af = (0, $kSwu1.defineMessages)({
    title: {
        id: "automation-discovery.verified-content.title",
        defaultMessage: "Want to manage your verified pages?"
    },
    body: {
        id: "automation-discovery.verified-content.body",
        defaultMessage: "Use Confluence automation to schedule reviews for verified content."
    }
});
const $9b11c5b093926f82$export$6b1f7d6fd8c7714c = (0, $kSwu1.defineMessages)({
    productivityTimeSavedMessage: {
        id: "automation-discovery.productivity-insights.time-saved.message",
        defaultMessage: "Save your team <b>{timeSaved, plural, one {{timeSaved} minute} other {{timeSaved} minutes}}</b> per quarter by setting up this automation rule!"
    }
});
module.exports["commonI18n"] = $9b11c5b093926f82$export$242890b69747c0cf;
module.exports["hoverPageTitleI18n"] = $9b11c5b093926f82$export$eaeae0ae54954c9a;
module.exports["archiveMessagesI18n"] = $9b11c5b093926f82$export$6216ba99d37b53d2;
module.exports["labelMessagesI18n"] = $9b11c5b093926f82$export$e252be6159b8f418;
module.exports["meetingNotesI18n"] = $9b11c5b093926f82$export$defcdcbe29897057;
module.exports["jiraLinkI18n"] = $9b11c5b093926f82$export$ce468634859ccf2b;
module.exports["productivityInsightsI18n"] = $9b11c5b093926f82$export$6b1f7d6fd8c7714c;

});

parcelRegister("fiFCv", function(module, exports) {
/* InContextAutomationPrompt.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $eh6Ml = parcelRequire("eh6Ml");


var $9DHhW = parcelRequire("9DHhW");


var $7ZB0A = parcelRequire("7ZB0A");


var $vIR70 = parcelRequire("vIR70");


var $I7hWB = parcelRequire("I7hWB");


var $3izAL = parcelRequire("3izAL");


var $kz1Yj = parcelRequire("kz1Yj");


var $2wCqQ = parcelRequire("2wCqQ");


var $buxP3 = parcelRequire("buxP3");


var $hMcNB = parcelRequire("hMcNB");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $7aRa9 = parcelRequire("7aRa9");


var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");


var $9KNO1 = parcelRequire("9KNO1");


var $d0Ide = parcelRequire("d0Ide");


var $2HPSp = parcelRequire("2HPSp");


var $5v7QA = parcelRequire("5v7QA");


var $5scZK = parcelRequire("5scZK");

const $3dbeeac5567d9c48$var$insightMessageStyles = (0, $buxP3.xcss)({
    marginLeft: 'space.300'
});
const $3dbeeac5567d9c48$var$insightMessageInContextStyles = (0, $buxP3.xcss)({
    marginLeft: 'space.300',
    marginTop: 'space.050'
});
const $3dbeeac5567d9c48$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    buildingRule: {
        id: "automation-discovery.common.building-rule",
        defaultMessage: "Building rule"
    },
    createRule: {
        id: "automation-discovery.common.create-rule",
        defaultMessage: "Turn on rule"
    },
    createRuleSuccess: {
        id: "automation-discovery.common.create-rule-success",
        defaultMessage: "Rule has been turned on"
    },
    viewRule: {
        id: "automation-discovery.common.view-rule",
        defaultMessage: "View rule"
    },
    editInRuleBuilder: {
        id: "automation-discovery.common.edit-in-rule-builder",
        defaultMessage: "Edit in rule builder"
    },
    errorFlagTitle: {
        id: "automation-discovery.common.error-flag.title",
        defaultMessage: "Failed to create rule"
    },
    errorFlagDescription: {
        id: "automation-discovery.common.error-flag.description",
        defaultMessage: "An unexpected error occurred while creating the rule."
    }
});
const $3dbeeac5567d9c48$var$ConditionalWrapper = ({ condition: condition, WrapperIfTrue: WrapperIfTrue, WrapperIfFalse: WrapperIfFalse, children: children })=>condition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrapperIfTrue, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrapperIfFalse, null, children);
const $3dbeeac5567d9c48$var$StackWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), null, children);
const $3dbeeac5567d9c48$var$InlineWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        space: "space.100",
        shouldWrap: true
    }, children);
const $3dbeeac5567d9c48$var$defaultInContextPromptContainerStyles = (0, $buxP3.xcss)({
    padding: 'space.150',
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.small',
    marginBottom: 'space.200',
    marginRight: 'space.0',
    width: '100%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3dbeeac5567d9c48$var$BouncingDot = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1o8l _j7hqu8hp _5sag3sne _tip812c5 _1pgl6ui8 _xg4k6ebc _1lac188d",
            __cmplp.className
        ])
    });
});
const $3dbeeac5567d9c48$var$InContextRuleBuilder = ({ templateId: templateId, spaceKey: spaceKey, templateDescription: templateDescription, handleRedirectToRuleBuilder: handleRedirectToRuleBuilder, handleRuleCreationStart: handleRuleCreationStart, handleRuleCreationSuccess: handleRuleCreationSuccess, flags: flags, children: children, automationDiscoveryParent: automationDiscoveryParent, customContainerStyles: customContainerStyles, checkIsInContextRuleBuilderStateValid: checkIsInContextRuleBuilderStateValid, ruleComponentAlignment: ruleComponentAlignment = 'stack', displayMode: displayMode = 'in-context', handleRuleCreationFail: handleRuleCreationFail, disableCreateRule: disableCreateRule, handleDismiss: handleDismiss, message: message, insightMessage: insightMessage })=>{
    const { cloudId: cloudId, environment: environment } = (0, $bQm3c.useSessionData)();
    const { templateApiParameters: templateApiParameters } = (0, $cozmU.useContext)((0, $2HPSp.InContextRuleBuilderContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const spaceId = (0, $7QM6o.useSpaceId)(spaceKey || undefined);
    const [createdRuleId, setCreatedRuleId] = (0, $cozmU.useState)(null);
    const [displayPrompt, setShouldDisplayPrompt] = (0, $cozmU.useState)(true);
    const [animationState, setAnimationState] = (0, $cozmU.useState)(-1);
    const timeoutID = (0, $cozmU.useRef)(null);
    const isAnimationFinished = animationState >= (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) + 1;
    const onCompleted = (result)=>{
        if (result?.experimentalCreateAutomationRuleFromTemplate?.ruleId) {
            handleRuleCreationSuccess();
            setCreatedRuleId(result.experimentalCreateAutomationRuleFromTemplate.ruleId);
        }
    };
    const onError = (err)=>{
        handleRuleCreationFail?.(err);
        flags.showErrorFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3dbeeac5567d9c48$export$a7357cdd1f0b0168.errorFlagTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3dbeeac5567d9c48$export$a7357cdd1f0b0168.errorFlagDescription),
            isAutoDismiss: true
        });
    };
    const [createAutomationRuleFromTemplate, { data: data, loading: loading, error: mutationError }] = (0, $5scZK.useExperimentalCreateAutomationRuleFromTemplateMutation)({
        onCompleted: onCompleted,
        onError: onError
    });
    (0, $cozmU.useEffect)(()=>{
        if (isAnimationFinished) {
            clearTimeout(timeoutID.current);
            timeoutID.current = null;
            return;
        } // Count up to the # of components in the rule we want to render
        if (!displayPrompt) timeoutID.current = setTimeout(()=>{
            setAnimationState((value)=>value + 1);
        }, 1000);
        return ()=>clearTimeout(timeoutID.current);
    }, [
        animationState,
        isAnimationFinished,
        displayPrompt
    ]);
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: (0, $d0Ide.EventSourceName).IN_CONTEXT_RULE_BUILDER,
                source: (0, $d0Ide.EventSourceName).IN_CONTEXT_RULE_BUILDER,
                attributes: {
                    automationDiscoveryParent: automationDiscoveryParent
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        automationDiscoveryParent
    ]);
    const handleOnClickCreateRule = async ()=>{
        if (checkIsInContextRuleBuilderStateValid()) {
            handleRuleCreationStart?.(); // This is really fast in prod (no remote call)
            const automationStack = await (0, $9KNO1.getAutomationStack)(environment);
            const formattedParameters = Object.entries(templateApiParameters).map(([parameterName, parameterValue])=>({
                    name: parameterName,
                    type: parameterValue.type,
                    value: String(parameterValue.value)
                }));
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'automationDiscoveryInContextRuleBuilderTurnOn',
                    source: (0, $d0Ide.EventSourceName).IN_CONTEXT_RULE_BUILDER,
                    attributes: {
                        spaceKey: spaceKey,
                        automationDiscoveryParent: automationDiscoveryParent
                    }
                }
            }).fire();
            await createAutomationRuleFromTemplate({
                variables: {
                    templateId: templateId,
                    cloudId: cloudId,
                    automationStack: automationStack,
                    spaceId: spaceId,
                    parameters: formattedParameters
                }
            });
        }
    };
    const renderInContextActionButtons = ()=>{
        if (data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            appearance: "link",
            href: `/wiki/spaces/${spaceKey}/settings/automation#/rule/${createdRuleId}`,
            target: "_blank",
            spacing: "none"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3dbeeac5567d9c48$export$a7357cdd1f0b0168.viewRule)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            alignBlock: "center",
            xcss: (0, $buxP3.xcss)({
                color: 'color.text.success'
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            label: "",
            color: "var(--ds-icon-accent-green, #22A06B)",
            size: "small"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3dbeeac5567d9c48$export$a7357cdd1f0b0168.createRuleSuccess)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            appearance: disableCreateRule ? 'primary' : 'link',
            onClick: ()=>{
                handleRedirectToRuleBuilder();
            },
            spacing: disableCreateRule ? 'compact' : 'none'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3dbeeac5567d9c48$export$a7357cdd1f0b0168.editInRuleBuilder)), !disableCreateRule ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $vIR70.default), {
            appearance: "primary",
            spacing: "compact",
            isLoading: loading,
            onClick: handleOnClickCreateRule
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3dbeeac5567d9c48$export$a7357cdd1f0b0168.createRule)) : null);
    };
    if (displayPrompt) return displayMode === 'modal' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        grow: "fill",
        space: "space.150",
        xcss: (0, $buxP3.xcss)({
            padding: 'space.150',
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
            backgroundColor: 'color.background.accent.gray.subtlest'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMcNB))), {
        label: "",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, message)), insightMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $3dbeeac5567d9c48$var$insightMessageStyles
    }, insightMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        alignBlock: "center",
        space: "space.200",
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "link",
        onClick: handleDismiss,
        spacing: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5v7QA.commonI18n).dismiss)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "link",
        onClick: ()=>setShouldDisplayPrompt(false),
        spacing: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5v7QA.commonI18n).showMeHow)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    ), {
        xcss: (0, $buxP3.xcss)({
            borderColor: 'color.border',
            borderStyle: 'solid',
            borderRadius: 'radius.large',
            borderWidth: 'border.width',
            backgroundColor: 'color.background.neutral',
            padding: 'space.200'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMcNB))), {
        label: "",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, message)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle-link",
        onClick: handleDismiss
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5v7QA.commonI18n).dismiss)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "link",
        onClick: ()=>setShouldDisplayPrompt(false),
        spacing: "compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5v7QA.commonI18n).showMeHow)))), insightMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $3dbeeac5567d9c48$var$insightMessageInContextStyles
    }, insightMessage));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        grow: "fill",
        space: "space.150",
        xcss: [
            $3dbeeac5567d9c48$var$defaultInContextPromptContainerStyles,
            customContainerStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMcNB))), {
        label: "",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        space: "space.200",
        xcss: (0, $buxP3.xcss)({
            width: '100%'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        spread: "space-between",
        space: "space.200",
        alignBlock: "center"
    }, isAnimationFinished ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, templateDescription), displayMode === 'in-context' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        alignBlock: "center",
        space: "space.200"
    }, renderInContextActionButtons())) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3dbeeac5567d9c48$export$a7357cdd1f0b0168.buildingRule), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3dbeeac5567d9c48$var$BouncingDot, null, "."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3dbeeac5567d9c48$var$BouncingDot, null, "."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3dbeeac5567d9c48$var$BouncingDot, null, ".")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3dbeeac5567d9c48$var$ConditionalWrapper, {
        condition: ruleComponentAlignment === 'stack',
        WrapperIfTrue: $3dbeeac5567d9c48$var$StackWrapper,
        WrapperIfFalse: $3dbeeac5567d9c48$var$InlineWrapper
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, (child, componentNumber)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(child, {
            isSkeleton: componentNumber === animationState,
            isHidden: componentNumber > animationState
        });
        return child;
    })), !!insightMessage && isAnimationFinished && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), null, insightMessage), isAnimationFinished && displayMode === 'modal' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        alignInline: "end",
        space: "space.200"
    }, renderInContextActionButtons())), mutationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: mutationError
    }));
};
const $3dbeeac5567d9c48$export$bff0256bf4beef8c = (0, $7aRa9.withFlags)((0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).AUTOMATION_FOR_CONFLUENCE
})($3dbeeac5567d9c48$var$InContextRuleBuilder));
module.exports["InContextAutomationPrompt"] = $3dbeeac5567d9c48$export$bff0256bf4beef8c;

});

parcelRegister("9KNO1", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $1UApO = parcelRequire("1UApO");

/**
 * Here we will check if devWatch is running and if so, we will use the associated dev stack.
 */ const $0691681f8bad8323$var$getAutomationDevStackFromLocalServer = async ()=>{
    try {
        const devStackResponse = await (0, $f7B1p.cfetch)('https://localhost:8082/devStack.json', {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            },
            credentials: 'omit'
        });
        const devStack = await devStackResponse.json();
        return devStack.name;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(`Failed to fetch dev stack from https://localhost:8082/devStack.json with error: ${e}`);
        return null;
    }
};
const $0691681f8bad8323$export$6123178d3f5fb24d = async (environment)=>{
    switch(environment){
        case 'DEVELOPMENT':
        case 'STAGING':
            return await $0691681f8bad8323$var$getAutomationDevStackFromLocalServer() || window.localStorage.getItem((0, $1UApO.keys).AUTOMATION_PLATFORM_STACK) || 'staging';
        default:
            return 'pro';
    }
};
module.exports["getAutomationStack"] = $0691681f8bad8323$export$6123178d3f5fb24d;

});

parcelRegister("2HPSp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

var $02196f736713ab99$export$869e231d926edfce = /*#__PURE__*/ function(TemplateParameterTypeEnum) {
    TemplateParameterTypeEnum["TEXT"] = "TEXT";
    TemplateParameterTypeEnum["NUMBER"] = "NUMBER";
    TemplateParameterTypeEnum["BOOLEAN"] = "BOOLEAN";
    return TemplateParameterTypeEnum;
}({});
const $02196f736713ab99$var$defaultContext = {
    templateApiParameters: {},
    setParameterByKey: ()=>{},
    removeParameterByKey: ()=>{}
};
const $02196f736713ab99$export$b1e136c3301c05ad = /*#__PURE__*/ (0, $cozmU.createContext)($02196f736713ab99$var$defaultContext);
const $02196f736713ab99$export$6cdc09e06812d6d1 = ({ children: children })=>{
    const [parameters, setParameters] = (0, $cozmU.useState)({});
    const setParameterByKey = (0, $cozmU.useCallback)((key, value)=>{
        setParameters((prev)=>({
                ...prev,
                [key]: value
            }));
    }, [
        setParameters
    ]);
    const removeParameterByKey = (0, $cozmU.useCallback)((key)=>{
        setParameters((prev)=>{
            const newParameters = {
                ...prev
            };
            delete newParameters[key];
            return newParameters;
        });
    }, [
        setParameters
    ]);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            templateApiParameters: parameters,
            setParameterByKey: setParameterByKey,
            removeParameterByKey: removeParameterByKey
        }), [
        parameters,
        setParameterByKey,
        removeParameterByKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($02196f736713ab99$export$b1e136c3301c05ad.Provider, {
        value: contextValue
    }, children);
};
module.exports["TemplateParameterTypeEnum"] = $02196f736713ab99$export$869e231d926edfce;
module.exports["InContextRuleBuilderContext"] = $02196f736713ab99$export$b1e136c3301c05ad;
module.exports["InContextRuleBuilderProvider"] = $02196f736713ab99$export$6cdc09e06812d6d1;

});

parcelRegister("5scZK", function(module, exports) {

var $9o40q = parcelRequire("9o40q");

const $d71603234ecc6b8d$export$b60b821c3d861f36 = ({ onCompleted: onCompleted, onError: onError })=>{
    return (0, $9o40q.useExperimentalMutation)({
        url: ({ cloudId: cloudId, automationStack: automationStack })=>`/gateway/api/automation/internal-api/confluence/${cloudId}/${automationStack}/public/rest/v1/template/create`,
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        },
        body: ({ templateId: templateId, cloudId: cloudId, spaceId: spaceId, parameters: parameters })=>{
            const ruleHome = spaceId ? `ari:cloud:confluence:${cloudId}:space/${spaceId}` : `ari:cloud:confluence::site/${cloudId}`;
            let formattedParameters = null;
            if (parameters) {
                formattedParameters = {};
                for (const parameter of parameters)formattedParameters[parameter.name] = {
                    value: parameter.value,
                    type: parameter.type
                };
            }
            return JSON.stringify({
                templateId: templateId,
                ruleHome: ruleHome,
                parameters: formattedParameters
            });
        },
        parseResult: ({ ruleId: ruleId, ruleUuid: ruleUuid })=>({
                experimentalCreateAutomationRuleFromTemplate: {
                    ruleId: ruleId,
                    ruleUuid: ruleUuid
                }
            }),
        onCompleted: onCompleted,
        onError: onError
    });
};
var $d71603234ecc6b8d$var$TemplateParameterTypeEnum = /*#__PURE__*/ function(TemplateParameterTypeEnum) {
    TemplateParameterTypeEnum["BOOLEAN"] = "BOOLEAN";
    TemplateParameterTypeEnum["NUMBER"] = "NUMBER";
    TemplateParameterTypeEnum["TEXT"] = "TEXT";
    return TemplateParameterTypeEnum;
}($d71603234ecc6b8d$var$TemplateParameterTypeEnum || {});
module.exports["useExperimentalCreateAutomationRuleFromTemplateMutation"] = $d71603234ecc6b8d$export$b60b821c3d861f36;

});

parcelRegister("9o40q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5JnOJ = parcelRequire("5JnOJ");


var $6mKj3 = parcelRequire("6mKj3");


var $1GTIR = parcelRequire("1GTIR");


var $bjeS8 = parcelRequire("bjeS8");


var $hNILR = parcelRequire("hNILR");

function $ca37881e75cd694f$export$59b64e912820d0fb({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, maxRetries: maxRetries = 0, variables: defaultVariables, update: update, optimisticResponse: optimisticResponse }) {
    if (!(0, $6mKj3.expValEquals)('cc_move_legacy-schema-bridge-code-into-interops', 'isEnabled', true)) // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    return (0, $hNILR.useExperimentalMutationLegacy)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        maxRetries: maxRetries,
        variables: defaultVariables,
        update: update,
        optimisticResponse: optimisticResponse
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        variables: defaultVariables
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    const fetchDataWithRetry = (0, $cozmU.useCallback)(async (variables, count = 0)=>{
        try {
            return await fetchData(variables);
        } catch (error) {
            if (count < maxRetries && error?.response?.status === 409) return fetchDataWithRetry(variables, ++count);
            throw error;
        }
    }, [
        maxRetries,
        fetchData
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks -- The value of expValEquals() does not change over the app's lifetime
    return $ca37881e75cd694f$export$a2949d410ca8baf1({
        fetchData: fetchDataWithRetry,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        update: update,
        optimisticResponse: optimisticResponse
    });
}
function $ca37881e75cd694f$export$a2949d410ca8baf1({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, update: update, optimisticResponse: optimisticResponse }) {
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $5JnOJ.useApolloCompatibleMutation)({
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        update: update,
        optimisticResponse: optimisticResponse,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["useExperimentalMutation"] = $ca37881e75cd694f$export$59b64e912820d0fb;
module.exports["useExperimentalMutationBase"] = $ca37881e75cd694f$export$a2949d410ca8baf1;

});

parcelRegister("5JnOJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $26Yfd = parcelRequire("26Yfd");


var $7Sm4c = parcelRequire("7Sm4c");

function $0e0c7f21ad093cb8$export$36caaad0aa36f272({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, update: defaultUpdate, optimisticResponse: defaultOptimisticResponse, convertToApolloError: convertToApolloError }) {
    const [result, setResult] = (0, $cozmU.useState)({
        data: undefined,
        loading: false,
        error: undefined,
        called: false
    });
    const mutate = (0, $26Yfd.useStableCallback)(async (options = {})=>{
        const { variables: variables, update: optionsUpdate, optimisticResponse: optionsOptimisticResponse } = options;
        const update = optionsUpdate ?? defaultUpdate;
        setResult({
            data: undefined,
            loading: true,
            error: undefined,
            called: true
        });
        const optimisticResponse = optionsOptimisticResponse ?? defaultOptimisticResponse;
        if (optimisticResponse) {
            const optimisticData = typeof optimisticResponse === 'function' ? optimisticResponse(variables ?? {}) : optimisticResponse;
            update?.(null, {
                data: optimisticData
            });
        }
        try {
            const data = await fetchData(variables);
            // The `update` function matches the Apollo useMutation API for compatibility
            // This hook does not implement a cache, so `cache` is always null
            update?.(null, {
                data: data
            });
            const newResult_0 = {
                data: data,
                loading: false,
                error: undefined,
                called: true
            };
            setResult(newResult_0);
            await onCompleted?.(data);
            return {
                data: newResult_0.data
            };
        } catch (error) {
            // Rollback optimistic update on error
            if (optimisticResponse && update) // Signal rollback by calling update with undefined data
            // Consumers should handle this to revert to the previous state
            update(null, {
                data: undefined
            });
            const apolloError = await Promise.resolve(convertToApolloError(error));
            if (apolloError.graphQLErrors?.length) apolloError.graphQLErrors.forEach((e)=>{
                (0, $7Sm4c.processError)(e);
            });
            onError?.(apolloError);
            const newResult = {
                data: undefined,
                loading: false,
                error: apolloError,
                called: true
            };
            setResult(newResult);
            if (!onError) throw apolloError;
            return {
                data: newResult.data
            };
        }
    });
    return [
        mutate,
        result
    ];
}
module.exports["useApolloCompatibleMutation"] = $0e0c7f21ad093cb8$export$36caaad0aa36f272;

});

parcelRegister("hNILR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $26Yfd = parcelRequire("26Yfd");


var $1GTIR = parcelRequire("1GTIR");


var $hR9WV = parcelRequire("hR9WV");

function $fa6207d2b246a38d$export$9aaca330ad9c982e({ url: url, method: method, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, maxRetries: maxRetries = 0, variables: defaultVariables, update: update, optimisticResponse: optimisticResponse }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError,
        variables: defaultVariables
    });
    const fetchDataWithRetry = (0, $cozmU.useCallback)(async (variables, count = 0)=>{
        try {
            return await fetchData(variables);
        } catch (error) {
            if (count < maxRetries && error?.response?.status === 409) return fetchDataWithRetry(variables, ++count);
            throw error;
        }
    }, [
        maxRetries,
        fetchData
    ]);
    return $fa6207d2b246a38d$export$a2949d410ca8baf1({
        fetchData: fetchDataWithRetry,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        update: update,
        optimisticResponse: optimisticResponse
    });
}
function $fa6207d2b246a38d$export$a2949d410ca8baf1({ fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, update: defaultUpdate, optimisticResponse: defaultOptimisticResponse }) {
    const [result, setResult] = (0, $cozmU.useState)({
        data: undefined,
        loading: false,
        error: undefined,
        called: false
    });
    const mutate = (0, $26Yfd.useStableCallback)(async (options = {})=>{
        const { variables: variables, update: optionsUpdate, optimisticResponse: optionsOptimisticResponse } = options;
        const update = optionsUpdate ?? defaultUpdate;
        setResult({
            data: undefined,
            loading: true,
            error: undefined,
            called: true
        });
        const optimisticResponse = optionsOptimisticResponse ?? defaultOptimisticResponse;
        if (optimisticResponse) {
            const optimisticData = typeof optimisticResponse === 'function' ? optimisticResponse(variables ?? {}) : optimisticResponse;
            update?.(null, {
                data: optimisticData
            });
        }
        try {
            const data = await fetchData(variables);
            // The `update` function matches the Apollo useMutation API for compatibility
            // This hook does not implement a cache, so `cache` is always null
            update?.(null, {
                data: data
            });
            const newResult = {
                data: data,
                loading: false,
                error: undefined,
                called: true
            };
            setResult(newResult);
            await onCompleted?.(data);
            return {
                data: newResult.data
            };
        } catch (error) {
            // Rollback optimistic update on error
            if (optimisticResponse && update) // Signal rollback by calling update with undefined data
            // Consumers should handle this to revert to the previous state
            update(null, {
                data: undefined
            });
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            const newResult = {
                data: undefined,
                loading: false,
                error: finalError,
                called: true
            };
            setResult(newResult);
            if (!onError) throw finalError;
            return {
                data: newResult.data
            };
        }
    });
    return [
        mutate,
        result
    ];
}
module.exports["useExperimentalMutationLegacy"] = $fa6207d2b246a38d$export$9aaca330ad9c982e;

});

parcelRegister("d9uxk", function(module, exports) {
/**
 * @generated SignedSource<<600f249b6150b2ccef97c67793fc3512>>
 * @relayHash 3e8398ac4cc35cda2ed93f4628fc8a69
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 011ac4766405f363723e3835120d6e09d2cc477258bfdaab319a0a00e48764fd
const $39137d315768d978$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceDataLifecycleManagementPolicy",
            "kind": "LinkedField",
            "name": "confluence_dataLifecycleManagementPolicy",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceDataRetentionPolicyStatus",
                    "kind": "LinkedField",
                    "name": "dataRetentionPolicyDetailsForWorkspace",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "policyEnabledStatus"
                        },
                        {
                            "concreteType": "ConfluenceDate",
                            "kind": "LinkedField",
                            "name": "disabledOnDate",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDataRetentionDetailsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDataRetentionDetailsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3e8398ac4cc35cda2ed93f4628fc8a69",
            "id": "011ac4766405f363723e3835120d6e09d2cc477258bfdaab319a0a00e48764fd",
            "metadata": {},
            "name": "useDataRetentionDetailsQuery",
            "operationKind": "query",
            "text": "query useDataRetentionDetailsQuery($cloudId:ID!){confluence_dataLifecycleManagementPolicy(cloudId:$cloudId){dataRetentionPolicyDetailsForWorkspace{policyEnabledStatus,disabledOnDate{value}}}}"
        }
    };
}();
$39137d315768d978$var$node.hash = "0241f940fae6659cf9e57c7aaae37fa7";
var $39137d315768d978$export$2e2bcd8739ae039 = $39137d315768d978$var$node;
module.exports["default"] = $39137d315768d978$export$2e2bcd8739ae039;

});

parcelRegister("kDja4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ixfCV = parcelRequire("ixfCV");


var $9wGTI = parcelRequire("9wGTI");


var $yuLaV = parcelRequire("yuLaV");

// These flags are no longer used in confluence and can be removed from this array entirely after we confirm that have been removed from the whiteboards side too
const $9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS = [
    'headerV1',
    'headerV2',
    'whiteboardArchive',
    'removeWhiteboardsHome',
    'removeWhiteboardsHomeInSideNav',
    'whiteboardCreation',
    'whiteboardsEnabled',
    'whiteboardBifrost',
    'whiteboardVersionHistory'
];
const $9cbb170f29556407$export$6f83cfa4fd660300 = ()=>{
    const isWhiteboardsEnabledInEnv = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isWhiteboardFeatureEnabled = (0, $cozmU.useCallback)((featureName)=>{
        if (featureName === 'whiteboardsEnabled') return isWhiteboardsEnabledInEnv;
        // If the FF has been cleaned up on our end just return true
        if ($9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS.some((feature)=>feature === featureName)) return true;
        // Use static feature gate calls to satisfy confluence-feature-gating/static-feature-gates
        switch(featureName){
            case 'whiteboardSolidHeader':
                return (0, $9wGTI.fg)('confluence_frontend_solid_whiteboard_header');
            case 'whiteboardOptOut':
                return (0, $9wGTI.fg)('whiteboards_compliance_opt_out');
            case 'digitalTeammate':
                return (0, $9wGTI.fg)('cc-ai-whiteboards-enable-digital-teammate');
            case 'aiFirstCreation':
                return true;
            default:
                return false;
        }
    }, [
        isWhiteboardsEnabledInEnv
    ]);
    const isWhiteboardCreationDropdownEnabled = (0, $cozmU.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    const isWhiteboardGAOnboardingEnabled = (0, $cozmU.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    return {
        platformFeatureFlagResolver: (0, $ixfCV.getBooleanFF),
        isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled,
        isWhiteboardCreationDropdownEnabled: isWhiteboardCreationDropdownEnabled,
        isWhiteboardGAOnboardingEnabled: isWhiteboardGAOnboardingEnabled
    };
};
module.exports["useIsWhiteboardFeatureEnabled"] = $9cbb170f29556407$export$6f83cfa4fd660300;

});

parcelRegister("yuLaV", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $jH9cM = parcelRequire("jH9cM");


var $3ricL = parcelRequire("3ricL");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

const $705f1ec06aff7fce$export$dd376e644565eb89 = (contentType)=>{
    if (contentType === 'database' || contentType === 'whiteboard' || contentType === 'slide') {
        if ((0, $9wGTI.fg)('use_frontend_feature_encoding_sdk')) {
            const featureKeyMap = {
                database: 'confluence-databases',
                slide: 'confluence-slides',
                whiteboard: 'confluence-whiteboards'
            };
            const isEnvEnabled = (0, $3ricL.isFeatureEnabled)('confluence', featureKeyMap[contentType], {
                'fedramp-moderate': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_fedramp'),
                'isolated-cloud-commercial': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_ic')
            });
            if (contentType === 'slide') return isEnvEnabled && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
            return isEnvEnabled;
        }
        if (contentType === 'slide') return !(0, $jH9cM.isFedRamp)() && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
        return !(0, $jH9cM.isFedRamp)();
    }
    return true;
};
module.exports["isContentTypeEnabledInCurrentEnv"] = $705f1ec06aff7fce$export$dd376e644565eb89;

});

parcelRegister("7EIq6", function(module, exports) {

var $dd33Q = parcelRequire("dd33Q");


var $jtuBN = parcelRequire("jtuBN");


var $iLgzu = parcelRequire("iLgzu");

const $649b778bbd82b1bb$var$useSpaceEnabledContentTypesQuery = (0, $dd33Q.default);
function $649b778bbd82b1bb$export$1defcb29347f9ac6(spaceKey) {
    const { data: defaultSpaceKeyData, loading: isDefaultSpaceKeyLoading } = (0, $iLgzu.useExperimentalPromotedSpacesQuery)({
        skip: spaceKey !== undefined,
        variables: {
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1,
            promotedSpaceKey: null
        }
    });
    const spaceEnabledContentTypesQueryOptions = {
        errorPolicy: 'all',
        skip: !spaceKey && !defaultSpaceKeyData,
        variables: {
            spaceKey: spaceKey || defaultSpaceKeyData?.experimentalPromotedSpaces?.nodes?.[0]?.id
        }
    };
    const { data: enabledContentTypesData, loading: isAnyContentTypesLoading } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($649b778bbd82b1bb$var$useSpaceEnabledContentTypesQuery, {
        ...spaceEnabledContentTypesQueryOptions,
        __callerPackage__: "create-blank-fabric-page"
    });
    const enabledContentTypes = enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes;
    const hasUndefinedContentTypes = enabledContentTypes === undefined || Object.values(enabledContentTypes).some((type)=>type === undefined);
    const isLoading = isDefaultSpaceKeyLoading || isAnyContentTypesLoading || hasUndefinedContentTypes;
    return {
        isCreateWhiteboardEnabled: Boolean(enabledContentTypes?.isWhiteboardsEnabled),
        isCreateBlogEnabled: Boolean(enabledContentTypes?.isBlogsEnabled),
        isCreateDatabaseEnabled: Boolean(enabledContentTypes?.isDatabasesEnabled),
        isCreateSmartLinkEnabled: Boolean(enabledContentTypes?.isEmbedsEnabled),
        isCreateLiveDocEnabled: Boolean(enabledContentTypes?.isLivePagesEnabled),
        isCreateFolderEnabled: Boolean(enabledContentTypes?.isFoldersEnabled),
        isCreateSlidesEnabled: Boolean(enabledContentTypes?.isSlidesEnabled),
        isLoading: isLoading
    };
}
module.exports["useSpaceEnabledContentTypes"] = $649b778bbd82b1bb$export$1defcb29347f9ac6;

});

parcelRegister("iLgzu", function(module, exports) {

var $jaPWl = parcelRequire("jaPWl");


var $dK51B = parcelRequire("dK51B");

const $e671a111e943b77f$export$409ac92b3aba27f5 = ({ skip: skip, onError: onError, variables: variables = {}, fetchPolicy: fetchPolicy } = {})=>{
    const promotedSpacesLimit = variables.promotedSpacesLimit || 10;
    const otherSpacesLimit = variables.otherSpacesLimit || 10;
    const promotedSpaceKey = variables.promotedSpaceKey || '';
    return (0, $dK51B.useExperimentalQuery)({
        url: `/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=${promotedSpacesLimit}&otherSpacesLimit=${otherSpacesLimit}&promotedSpaceKey=${promotedSpaceKey}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $jaPWl.MediaType).JSON
        },
        parseResult: (json)=>{
            const matchedPromotedSpaces = json.matchedPromotedSpaces && json.matchedPromotedSpaces.spaces || [];
            const nodes = (json.promotedSpaces && json.promotedSpaces.spaces || []).concat(json.otherSpaces && json.otherSpaces.spaces || []);
            return {
                experimentalPromotedSpaces: {
                    nodes: nodes,
                    matchedPromotedSpaces: matchedPromotedSpaces,
                    __typename: 'ExperimentalPromotedSpaces'
                }
            };
        },
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalPromotedSpacesQuery"] = $e671a111e943b77f$export$409ac92b3aba27f5;

});

parcelRegister("jaPWl", function(module, exports) {
var $5e96abf23293f6d5$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $5e96abf23293f6d5$export$483c11740a902fcd;

});

parcelRegister("eVXGa", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $1337beb96693807c$var$isAllowedToCreate = (accessStatus)=>accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
const $1337beb96693807c$export$1060ff57674ca8ef = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $1337beb96693807c$var$isAllowedToCreate(accessStatus);
};
module.exports["useIsAllowedToCreateWhiteboard"] = $1337beb96693807c$export$1060ff57674ca8ef;

});

parcelRegister("6cyWf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $350c8455dc4e7cf5$export$d158fa15757a1890 = /*#__PURE__*/ (0, $cozmU.createContext)(false);
const $350c8455dc4e7cf5$export$abfcaeeca4ae7a55 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useHasCustomTheme() {
    return (0, $cozmU.useContext)($350c8455dc4e7cf5$export$d158fa15757a1890);
} : function useHasCustomTheme() {
    return (0, $cozmU.useContext)($350c8455dc4e7cf5$export$d158fa15757a1890);
};
module.exports["HasCustomThemeContext"] = $350c8455dc4e7cf5$export$d158fa15757a1890;
module.exports["useHasCustomTheme"] = $350c8455dc4e7cf5$export$abfcaeeca4ae7a55;

});

parcelRegister("aXMFs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ixfCV = parcelRequire("ixfCV");

function $25b427f2364d8f29$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 * This is copied from @atlaskit/button to render IconButtons. Some IconButton's DOM element
 * will be re-created during SSR -> SPA hydration without using this, which delays TTVC. As
 * IconRenderer is already used in @atlaskit/button to mitigate this issue, add it here to
 * mitigate the same issue for IconButtons in navigation-system, especially for ThemedIconButton.
 *
 */ const $25b427f2364d8f29$var$IconRenderer = ({ icon: Icon })=>{
    // React Compiler opt-out: RC-incompatible (memoization breaks runtime behaviour).
    'use no memo';
    const isRenderProp = $25b427f2364d8f29$var$isIconRenderProp(Icon);
    let iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $ixfCV.fg)('platform_dst_button_chevron_sizing') ? (iconName)=>iconName.startsWith('Chevron') ? 'small' : 'medium' : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, iconProps));
};
var $25b427f2364d8f29$export$2e2bcd8739ae039 = $25b427f2364d8f29$var$IconRenderer;
module.exports["default"] = $25b427f2364d8f29$export$2e2bcd8739ae039;

});

parcelRegister("5dijw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $ixfCV = parcelRequire("ixfCV");


var $hBYtq = parcelRequire("hBYtq");


var $hVZgb = parcelRequire("hVZgb");

const $33036e997e9cb956$var$styles = {
    root: "_zulp12x7 _11c8fhey _2rkofajl _v5649dqc _4bfu1r31 _1hmsglyw _ajmmnqa1 _1rjcze3t _1e0c1txw _4cvr1h6o _1bah1h6o _4t3i5r7u _kqswh2mm _1nrm1r31 _1a3b1r31 _9oik1r31 _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1",
    rootT26Shape: "_2rko1qi0",
    interactiveMotion: "_v564o1g2 _1gglat8s",
    border: "_14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _aetrb3bt _18postnw",
    selected: "_11q71qds _syazw5ct _8l3m15jn _f8pjw5ct _1053w5ct _19lcjrv1 _30l3w5ct _j6xtnh62 _9h8hw5ct",
    disabled: "_11q71c9b _syaz1i3i _8l3m1j28 _f8pj1i3i _10531i3i _19lc1c9b _30l31i3i _j6xt1c9b _9h8h1i3i"
};
const $33036e997e9cb956$var$shapeStyles = {
    default: "_18zrutpp",
    square: "_18zrze3t _1bsb5r7u _vwz4idpf"
};
const $33036e997e9cb956$var$appearanceStyles = {
    default: "_11q7pkxg _syaz1r31 _8l3maykr _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    subtle: "_11q7pkxg _syaz1r31 _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    primary: "_11q7esko _syaz15o7 _f8pj15o7 _105315o7 _19lcp6hf _30l315o7 _j6xt5sko _9h8h15o7"
}; /**
    * Props shared by `ThemedPressable` and `ThemedAnchor`
    */ 
const $33036e997e9cb956$export$66240319f1f78d74 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function ThemedPressable(t0, ref) {
    const $ = (0, $bDgLe.c)(20);
    let T0;
    let appearance;
    let hasBorder;
    let isDisabled;
    let isSelected;
    let shape;
    let t1;
    if ($[0] !== t0) {
        const { appearance: t2, shape: t3, isSelected: t4, isDisabled: t5, ...props } = t0;
        isSelected = t4;
        isDisabled = t5;
        appearance = t2 === undefined ? "default" : t2;
        shape = t3 === undefined ? "default" : t3;
        hasBorder = appearance === "default" || isSelected;
        T0 = (0, $hBYtq.default);
        t1 = (0, $hVZgb.getPrimitiveSpreadProps)(props);
        $[0] = t0;
        $[1] = T0;
        $[2] = appearance;
        $[3] = hasBorder;
        $[4] = isDisabled;
        $[5] = isSelected;
        $[6] = shape;
        $[7] = t1;
    } else {
        T0 = $[1];
        appearance = $[2];
        hasBorder = $[3];
        isDisabled = $[4];
        isSelected = $[5];
        shape = $[6];
        t1 = $[7];
    }
    let t2;
    if ($[8] !== appearance || $[9] !== hasBorder || $[10] !== isDisabled || $[11] !== isSelected || $[12] !== shape) {
        t2 = (0, $k12R1.cx)($33036e997e9cb956$var$styles.root, (0, $ixfCV.fg)("platform-dst-shape-theme-default") && $33036e997e9cb956$var$styles.rootT26Shape, $33036e997e9cb956$var$shapeStyles[shape], hasBorder && $33036e997e9cb956$var$styles.border, $33036e997e9cb956$var$appearanceStyles[appearance], isSelected && $33036e997e9cb956$var$styles.selected, isDisabled && $33036e997e9cb956$var$styles.disabled, (0, $ixfCV.fg)("platform-dst-motion-uplift-button") && $33036e997e9cb956$var$styles.interactiveMotion);
        $[8] = appearance;
        $[9] = hasBorder;
        $[10] = isDisabled;
        $[11] = isSelected;
        $[12] = shape;
        $[13] = t2;
    } else t2 = $[13];
    let t3;
    if ($[14] !== T0 || $[15] !== isDisabled || $[16] !== ref || $[17] !== t1 || $[18] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            ref: ref,
            type: "button",
            xcss: t2,
            isDisabled: isDisabled
        });
        $[14] = T0;
        $[15] = isDisabled;
        $[16] = ref;
        $[17] = t1;
        $[18] = t2;
        $[19] = t3;
    } else t3 = $[19];
    return t3;
} : function ThemedPressable({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref) {
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.default), {
        ...(0, $hVZgb.getPrimitiveSpreadProps)(props),
        ref: ref,
        type: "button",
        /**
                                                                                 * We are using some style values that are outside of the strict
                                                                                 * `@atlaskit/css` types.
                                                                                 */ // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $k12R1.cx)($33036e997e9cb956$var$styles.root, (0, $ixfCV.fg)('platform-dst-shape-theme-default') && $33036e997e9cb956$var$styles.rootT26Shape, $33036e997e9cb956$var$shapeStyles[shape], hasBorder && $33036e997e9cb956$var$styles.border, $33036e997e9cb956$var$appearanceStyles[appearance], isSelected && $33036e997e9cb956$var$styles.selected, isDisabled && $33036e997e9cb956$var$styles.disabled, (0, $ixfCV.fg)('platform-dst-motion-uplift-button') && $33036e997e9cb956$var$styles.interactiveMotion),
        isDisabled: isDisabled
    });
});
module.exports["ThemedPressable"] = $33036e997e9cb956$export$66240319f1f78d74;

});

parcelRegister("hVZgb", function(module, exports) {
/**
 * Props from primitives that we explicitly ignore and remove from spread props,
 * because they apply styles.
 *
 * `css` / `className` are not here because primitives don't support them.
 *
 * See `packages/design-system/primitives/src/components/anchor.tsx` and `packages/design-system/primitives/src/components/pressable.tsx`
 * for where these are defined. These shouldn't change very often as the direction is `xcss` over individual props.
 */ function $c03f86859c8952b6$export$e4c95325a21f9785({ style: style, xcss: xcss, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, ...props }) {
    return props;
}
module.exports["getPrimitiveSpreadProps"] = $c03f86859c8952b6$export$e4c95325a21f9785;

});

parcelRegister("fk0Hw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ad7Ou = parcelRequire("ad7Ou");


var $6cyWf = parcelRequire("6cyWf");


var $2SfBJ = parcelRequire("2SfBJ");

const $651274d8ee84c28a$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(4);
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $2SfBJ.ThemedButton) : (0, $ad7Ou.default);
    let t0;
    if ($[0] !== Component || $[1] !== props || $[2] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            ref: ref,
            ...props
        });
        $[0] = Component;
        $[1] = props;
        $[2] = ref;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props, ref)=>{
    const hasCustomTheme = (0, $6cyWf.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $2SfBJ.ThemedButton) : (0, $ad7Ou.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
        ref: ref,
        ...props
    });
});
module.exports["Button"] = $651274d8ee84c28a$export$353f5b6fc5456de1;

});

parcelRegister("2SfBJ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $aXMFs = parcelRequire("aXMFs");


var $5dijw = parcelRequire("5dijw");

const $8c55572969b08c36$var$textButtonStyles = {
    iconBefore: "_vwz4idpf",
    text: "_k48p1wq8"
};
const $8c55572969b08c36$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function ThemedButton(t0, ref) {
    const $ = (0, $bDgLe.c)(14);
    let IconBefore;
    let children;
    let props;
    if ($[0] !== t0) {
        ({ iconBefore: IconBefore, children: children, ...props } = t0);
        $[0] = t0;
        $[1] = IconBefore;
        $[2] = children;
        $[3] = props;
    } else {
        IconBefore = $[1];
        children = $[2];
        props = $[3];
    }
    let t1;
    if ($[4] !== IconBefore) {
        t1 = IconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: (0, $hekY6.default)([
                $8c55572969b08c36$var$textButtonStyles.iconBefore
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aXMFs.default), {
            icon: IconBefore
        }));
        $[4] = IconBefore;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $8c55572969b08c36$var$textButtonStyles.text
        ]);
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: t2
        }, children);
        $[7] = children;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== props || $[10] !== ref || $[11] !== t1 || $[12] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5dijw.ThemedPressable), {
            ...props,
            ref: ref
        }, t1, t3);
        $[9] = props;
        $[10] = ref;
        $[11] = t1;
        $[12] = t3;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : function ThemedButton({ iconBefore: IconBefore, children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5dijw.ThemedPressable), {
        ...props,
        ref: ref
    }, IconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $8c55572969b08c36$var$textButtonStyles.iconBefore
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aXMFs.default), {
        icon: IconBefore
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $8c55572969b08c36$var$textButtonStyles.text
        ])
    }, children));
});
module.exports["ThemedButton"] = $8c55572969b08c36$export$f67fb575035cc7d0;

});

parcelRegister("fPHWO", function(module, exports) {
function $b86db58908ab3a21$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports["default"] = $b86db58908ab3a21$export$2e2bcd8739ae039;

});

parcelRegister("58FyF", function(module, exports) {
$parcel$export(module.exports, "default", () => $3bddefb3ed7cf5f3$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $3bddefb3ed7cf5f3$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});

parcelRegister("1KLPb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c07c4c04f9f99a3868a6c26b78654ed8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $146f2f46410fb12f$var$_react = $146f2f46410fb12f$var$_interopRequireDefault((parcelRequire("cozmU")));

var $146f2f46410fb12f$var$_baseNew = $146f2f46410fb12f$var$_interopRequireDefault((parcelRequire("gElAV")));
function $146f2f46410fb12f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: None
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $146f2f46410fb12f$var$BookOpenIcon = (props)=>/*#__PURE__*/ $146f2f46410fb12f$var$_react.default.createElement($146f2f46410fb12f$var$_baseNew.default, Object.assign({
        name: "BookOpenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.5 2.25v10H8.75V4.625a2.375 2.375 0 0 1 2.375-2.375zM8 2.333A3.87 3.87 0 0 1 11.125.75h3.501C15.387.75 16 1.367 16 2.125v10.25c0 .76-.616 1.375-1.375 1.375H8.75v1.5h-1.5v-1.5H1.375C.615 13.75 0 13.134 0 12.375V2.125C0 1.366.615.75 1.375.75h3.5A3.87 3.87 0 0 1 8 2.333m-.75 9.917V4.625A2.375 2.375 0 0 0 4.875 2.25H1.5v10zm6-8H10.5v1.5h2.75zm0 2.5H10.5v1.5h2.75z" clip-rule="evenodd"/>`
    }, props));
$146f2f46410fb12f$var$BookOpenIcon.displayName = 'BookOpenIcon';
var $146f2f46410fb12f$var$_default = module.exports.default = $146f2f46410fb12f$var$BookOpenIcon;

});

parcelRegister("dQeg1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8eced7d4004a78c9a645ef3d6727f49b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a13b30eb29a7bdd5$var$_react = $a13b30eb29a7bdd5$var$_interopRequireDefault((parcelRequire("cozmU")));

var $a13b30eb29a7bdd5$var$_baseNew = $a13b30eb29a7bdd5$var$_interopRequireDefault((parcelRequire("gElAV")));
function $a13b30eb29a7bdd5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeChapters".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for auto chapters functionality in Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a13b30eb29a7bdd5$var$AiGenerativeChaptersIcon = (props)=>/*#__PURE__*/ $a13b30eb29a7bdd5$var$_react.default.createElement($a13b30eb29a7bdd5$var$_baseNew.default, Object.assign({
        name: "AiGenerativeChaptersIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1.5 2.5v10h5.75V14H1.375C.615 14 0 13.384 0 12.625V2.375C0 1.617.613 1 1.374 1h3.5A3.87 3.87 0 0 1 8 2.583 3.87 3.87 0 0 1 11.125 1h3.5C15.387 1 16 1.62 16 2.376V8.25h-1.5V2.5h-3.375A2.375 2.375 0 0 0 8.75 4.875V10h-1.5V4.875A2.375 2.375 0 0 0 4.875 2.5zM13.25 6H10.5V4.5h2.75zM2.75 4.5H5.5V6H2.75zm0 2.5H5.5v1.5H2.75zm9.045 2.494a.75.75 0 0 1 1.41 0l.614 1.687 1.687.615a.75.75 0 0 1 0 1.41l-1.687.615-.615 1.686a.75.75 0 0 1-1.41 0l-.615-1.686-1.686-.615a.75.75 0 0 1 0-1.41l1.686-.615z" clip-rule="evenodd"/>`
    }, props));
$a13b30eb29a7bdd5$var$AiGenerativeChaptersIcon.displayName = 'AiGenerativeChaptersIcon';
var $a13b30eb29a7bdd5$var$_default = module.exports.default = $a13b30eb29a7bdd5$var$AiGenerativeChaptersIcon;

});

parcelRegister("3xwCI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b27c4fffdceed1a1307cfef5a2c834bc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $293dc2808d336068$var$_react = $293dc2808d336068$var$_interopRequireDefault((parcelRequire("cozmU")));

var $293dc2808d336068$var$_baseNew = $293dc2808d336068$var$_interopRequireDefault((parcelRequire("gElAV")));
function $293dc2808d336068$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pencil".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: compose video title in Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $293dc2808d336068$var$PencilIcon = (props)=>/*#__PURE__*/ $293dc2808d336068$var$_react.default.createElement($293dc2808d336068$var$_baseNew.default, Object.assign({
        name: "PencilIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.336 1.604a2 2 0 0 1 2.828 0l1.233 1.232a2 2 0 0 1 0 2.828l-8.099 8.099a2 2 0 0 1-1.022.547l-3.379.675a.75.75 0 0 1-.882-.882l.675-3.379a2 2 0 0 1 .547-1.022zm1.768 1.06a.5.5 0 0 0-.707 0l-.961.961 1.939 1.94.96-.961a.5.5 0 0 0 0-.707zm-.79 3.961-1.939-1.94-6.077 6.078a.5.5 0 0 0-.137.255l-.455 2.276 2.276-.455a.5.5 0 0 0 .255-.137zM16 15H8v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$293dc2808d336068$var$PencilIcon.displayName = 'PencilIcon';
var $293dc2808d336068$var$_default = module.exports.default = $293dc2808d336068$var$PencilIcon;

});

parcelRegister("iuCeV", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $bjY3F = parcelRequire("bjY3F");

const $4726ba45c1bca0cb$export$4962f3898bd5c829 = ({ name: name, trigger: trigger = 'mount' })=>{
    (0, $6cFsl.di)((0, $bjY3F.useAIMateExperienceTracker));
    const successTriggerRef = (0, $cozmU.useRef)(trigger);
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    (0, $cozmU.useEffect)(()=>{
        if (successTriggerRef.current === 'mount') experienceTracker.succeed({
            name: name
        });
        if (successTriggerRef.current === 'unmount') return ()=>{
            experienceTracker.succeed({
                name: name
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
const $4726ba45c1bca0cb$export$eed1d73ebdd8c7ab = ({ error: error, name: name })=>{
    (0, $6cFsl.di)((0, $bjY3F.useAIMateExperienceTracker));
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    (0, $cozmU.useEffect)(()=>{
        experienceTracker.fail({
            name: name,
            error: error
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
const $4726ba45c1bca0cb$export$f20b867e738a222c = ({ name: name, attributes: attributes })=>{
    (0, $6cFsl.di)((0, $bjY3F.useAIMateExperienceTracker));
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    (0, $cozmU.useMemo)(()=>{
        experienceTracker.start({
            id: name,
            name: name,
            attributes: attributes
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
module.exports["ExperienceSuccess"] = $4726ba45c1bca0cb$export$4962f3898bd5c829;
module.exports["ExperienceFailure"] = $4726ba45c1bca0cb$export$eed1d73ebdd8c7ab;
module.exports["ExperienceStart"] = $4726ba45c1bca0cb$export$f20b867e738a222c;

});

parcelRegister("aJU2k", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $fiVb2 = parcelRequire("fiVb2");

const $5436fb6e01d0eb8e$export$aaf871ddd4ec7885 = (0, $kBr4q.createActionsHook)((0, $fiVb2.store));
module.exports["useChatModeStoreActions"] = $5436fb6e01d0eb8e$export$aaf871ddd4ec7885;

});

parcelRegister("fiVb2", function(module, exports) {

var $8s9DV = parcelRequire("8s9DV");


var $gchVc = parcelRequire("gchVc");


var $5osBM = parcelRequire("5osBM");


var $eu92c = parcelRequire("eu92c");


var $8XyiW = parcelRequire("8XyiW");

const $485b379839d8bc9f$var$actions = {
    setReasoningMode: (key, reasoningMode)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                reasoningMode: reasoningMode
            }));
        },
    resetReasoningMode: (key)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                reasoningMode: (0, $5osBM.getDerivedDefaultChatMode)().reasoningMode
            }));
        },
    setDeepResearchEnabled: (key, isEnabled)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                reasoningMode: isEnabled ? 'deep-research' : 'auto'
            }));
        },
    setWebSearchEnabled: (key, isEnabled)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                webSearchEnabled: isEnabled
            }));
        },
    setOrgKnowledge: (key, orgKnowledge)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                orgKnowledge: orgKnowledge,
                appFiltersSetByPrompt: false
            }));
        },
    setAppFiltersFromPrompt: (key, filteredApps)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                orgKnowledge: {
                    filteredApps: filteredApps
                },
                appFiltersSetByPrompt: true
            }));
        },
    setUseCurrentPageContext: (key, isEnabled)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, {
                useCurrentPageContext: isEnabled
            }));
        },
    setChatMode: (key, chatMode)=>({ dispatch: dispatch })=>{
            let updatedChatMode = chatMode;
            let orgKnowledge = (0, $5osBM.getDerivedDefaultChatMode)().orgKnowledge;
            if (chatMode.appFilters === undefined) orgKnowledge = (0, $5osBM.getDerivedDefaultChatMode)().orgKnowledge;
            else if (chatMode.appFilters.length > 0) orgKnowledge = {
                filteredApps: chatMode.appFilters
            };
            else orgKnowledge = 'disabled';
            updatedChatMode = {
                ...chatMode,
                orgKnowledge: orgKnowledge
            };
            dispatch((0, $8XyiW.updateMode)(key, {
                ...updatedChatMode,
                appFiltersSetByPrompt: false
            }));
        },
    getChatMode: (key)=>({ getState: getState })=>{
            const state = getState()[key] || (0, $5osBM.getDerivedDefaultChatMode)();
            return {
                ...state,
                ...(0, $eu92c.getDerivedReasoningMode)(state.reasoningMode),
                appFilters: (0, $gchVc.getAppFilters)(state.orgKnowledge)
            };
        },
    clearMode: (key)=>({ dispatch: dispatch })=>{
            dispatch((0, $8XyiW.updateMode)(key, (0, $5osBM.getDerivedDefaultChatMode)()));
        }
};
const $485b379839d8bc9f$export$6f57813fe9f31bf9 = (0, $8s9DV.createStore)({
    initialState: {},
    actions: $485b379839d8bc9f$var$actions
});
module.exports["store"] = $485b379839d8bc9f$export$6f57813fe9f31bf9;

});

parcelRegister("gchVc", function(module, exports) {
const $3b98ce1c6aca161d$export$6c9b22c84a96fd6c = (orgKnowledge)=>{
    if (orgKnowledge === 'disabled') // no org knowledge applied at all.
    return [];
    else if (orgKnowledge.filteredApps.length === 0) // all org knowledge applied and no apps filtered.
    return undefined;
    else // org knowledge applied and apps filtered.
    return orgKnowledge.filteredApps;
};
module.exports["getAppFilters"] = $3b98ce1c6aca161d$export$6c9b22c84a96fd6c;

});

parcelRegister("5osBM", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $ixfCV = parcelRequire("ixfCV");

const $075476664b139afe$var$getWebSearchDefaultFromStorage = ()=>{
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    if (typeof globalThis === 'undefined' || !globalThis.document || !globalThis.localStorage) return null;
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    const value = globalThis.localStorage.getItem('rovo-chat-web-search-default-on');
    if (value === null) return null;
    return value !== 'false';
};
const $075476664b139afe$export$99faa9801df051b0 = ()=>{
    const storageValue = $075476664b139afe$var$getWebSearchDefaultFromStorage();
    // If localStorage explicitly says it's off, default should be off
    // Otherwise, use the experiment flag value
    const webSearchEnabled = storageValue === false ? false : (0, $cXtTj.default).getExperimentValue('rovo_web_search_default_on', 'isEnabled', false);
    return {
        reasoningMode: 'auto',
        webSearchEnabled: webSearchEnabled,
        orgKnowledge: {
            filteredApps: []
        },
        autoApplyEnabled: true,
        appFiltersSetByPrompt: false,
        useCurrentPageContext: (0, $ixfCV.fg)('disable_default_on_current_page_as_context') ? false : true
    };
};
module.exports["getDerivedDefaultChatMode"] = $075476664b139afe$export$99faa9801df051b0;

});

parcelRegister("eu92c", function(module, exports) {

var $ePmEF = parcelRequire("ePmEF");

const $dcc4545520df4d8c$export$d6ea7bd50e1b3540 = (reasoningMode)=>{
    const isThinkDeeperMode = reasoningMode === 'think-deeper' || reasoningMode === 'think-deeper-marathon' || reasoningMode === 'think-deeper-orchestrator';
    return {
        deepResearchEnabled: reasoningMode === 'deep-research',
        thinkDeeperEnabled: isThinkDeeperMode,
        fastModeEnabled: reasoningMode === 'fast',
        autoReasoningEnabled: reasoningMode === 'auto',
        alphaExtendedThinkingMode: (0, $ePmEF.getAlphaExtendedThinkingMode)(reasoningMode),
        taskModeEnabled: reasoningMode === 'task'
    };
};
module.exports["getDerivedReasoningMode"] = $dcc4545520df4d8c$export$d6ea7bd50e1b3540;

});

parcelRegister("ePmEF", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");

const $f28d0c39486e1a59$export$61a509aba0cee914 = (reasoningMode)=>{
    if (!(0, $ixfCV.fg)('rovo_chat_marathon_orchestrator_reasoning_modes')) return undefined;
    switch(reasoningMode){
        case 'think-deeper-marathon':
            return 'MARATHON';
        case 'think-deeper-orchestrator':
            return 'LONG_HORIZON';
        default:
            return undefined;
    }
};
module.exports["getAlphaExtendedThinkingMode"] = $f28d0c39486e1a59$export$61a509aba0cee914;

});

parcelRegister("8XyiW", function(module, exports) {

var $5osBM = parcelRequire("5osBM");

const $3fc1c590f304ee0c$export$f80026ff7d109add = (key, mode)=>{
    return ({ setState: setState, getState: getState })=>{
        const state = getState()[key] || (0, $5osBM.getDerivedDefaultChatMode)();
        setState({
            [key]: {
                ...state,
                ...mode
            }
        });
    };
};
module.exports["updateMode"] = $3fc1c590f304ee0c$export$f80026ff7d109add;

});

parcelRegister("4m5jb", function(module, exports) {

var $8s9DV = parcelRequire("8s9DV");


var $igOtY = parcelRequire("igOtY");

const $ee15880d8017ee4c$export$a08ae3ac6db36809 = 'EMPTY_CONVERSATION_ID';
const $ee15880d8017ee4c$var$initialState = {
    conversations: {
        EMPTY_CONVERSATION_ID: {
            id: $ee15880d8017ee4c$export$a08ae3ac6db36809,
            messages: [],
            name: '',
            status: (0, $igOtY.CHAT_STORE_STATUS).idle,
            traces: [],
            timeCreated: new Date().toISOString()
        }
    },
    currentConversationId: $ee15880d8017ee4c$export$a08ae3ac6db36809,
    isConversationsInitialized: false,
    conversationPagination: {
        ...(0, $igOtY.DEFAULT_CONVERSATION_PAGINATION)
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $ee15880d8017ee4c$var$store;
const $ee15880d8017ee4c$export$8572e013e9dc20c3 = (actions)=>{
    if (!$ee15880d8017ee4c$var$store) $ee15880d8017ee4c$var$store = (0, $8s9DV.createStore)({
        name: 'ConversationAssistantStore',
        initialState: $ee15880d8017ee4c$var$initialState,
        actions: actions
    });
    // The module-level `store` is typed as `any` because its action type T is
    // not known at declaration time. The cast here is safe: `createChatStore` is
    // always called with the same concrete actions object.
    return $ee15880d8017ee4c$var$store;
};
module.exports["EMPTY_CONVERSATION_ID"] = $ee15880d8017ee4c$export$a08ae3ac6db36809;
module.exports["createChatStore"] = $ee15880d8017ee4c$export$8572e013e9dc20c3;

});

parcelRegister("5Sv3D", function(module, exports) {
$parcel$export(module.exports, "default", () => $447a164f7d0faf6b$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $447a164f7d0faf6b$export$2e2bcd8739ae039(callback, delay, options) {
    if (options === void 0) options = {};
    var maxWait = options.maxWait;
    var maxWaitHandler = (0, $cozmU.useRef)(null);
    var maxWaitArgs = (0, $cozmU.useRef)([]);
    var leading = options.leading;
    var trailing = options.trailing === undefined ? true : options.trailing;
    var leadingCall = (0, $cozmU.useRef)(false);
    var functionTimeoutHandler = (0, $cozmU.useRef)(null);
    var isComponentUnmounted = (0, $cozmU.useRef)(false);
    var debouncedFunction = (0, $cozmU.useRef)(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = (0, $cozmU.useCallback)(function() {
        clearTimeout(functionTimeoutHandler.current);
        clearTimeout(maxWaitHandler.current);
        maxWaitHandler.current = null;
        maxWaitArgs.current = [];
        functionTimeoutHandler.current = null;
        leadingCall.current = false;
    }, []);
    (0, $cozmU.useEffect)(function() {
        // We have to set isComponentUnmounted to be truth, as fast-refresh runs all useEffects
        isComponentUnmounted.current = false;
        return function() {
            // we use flag, as we allow to call callPending outside the hook
            isComponentUnmounted.current = true;
        };
    }, []);
    var debouncedCallback = (0, $cozmU.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        maxWaitArgs.current = args;
        clearTimeout(functionTimeoutHandler.current);
        if (leadingCall.current) leadingCall.current = false;
        if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
            debouncedFunction.current.apply(debouncedFunction, args);
            leadingCall.current = true;
        }
        functionTimeoutHandler.current = setTimeout(function() {
            var shouldCallFunction = true;
            if (leading && leadingCall.current) shouldCallFunction = false;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
        }, delay);
        if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
            var args = maxWaitArgs.current;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
        }, maxWait);
    }, [
        maxWait,
        delay,
        cancelDebouncedCallback,
        leading,
        trailing
    ]);
    var callPending = (0, $cozmU.useCallback)(function() {
        // Call pending callback only if we have anything in our queue
        if (!functionTimeoutHandler.current) return;
        debouncedFunction.current.apply(null, maxWaitArgs.current);
        cancelDebouncedCallback();
    }, [
        cancelDebouncedCallback
    ]);
    // At the moment, we use 3 args array so that we save backward compatibility
    return [
        debouncedCallback,
        cancelDebouncedCallback,
        callPending
    ];
}

});

parcelRegister("kuIhJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8A2GO = parcelRequire("8A2GO");

const $b4a77d21276ce51d$export$609860bf8b0084c = ({ mutationFn: mutationFn, onSuccess: onSuccess, onError: onError })=>{
    const mutationFnRef = (0, $cozmU.useRef)(mutationFn);
    mutationFnRef.current = mutationFn;
    const onSuccessRef = (0, $cozmU.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0, $cozmU.useRef)(onError);
    onErrorRef.current = onError;
    const [data, setData] = (0, $cozmU.useState)(null);
    const [error, setError] = (0, $cozmU.useState)(null);
    const [isSubmitting, setIsSubmitting] = (0, $cozmU.useState)(false);
    const mutate = (0, $cozmU.useCallback)(async (payload, mutateCallback)=>{
        setIsSubmitting(true);
        try {
            const response = await mutationFnRef.current(payload);
            setData(response);
            onSuccessRef.current?.(response);
            mutateCallback?.onSuccess?.(response);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error_0) {
            const apiError = (0, $8A2GO.mapErrorToApiError)(error_0);
            setError(apiError);
            onErrorRef.current?.(apiError, payload);
            mutateCallback?.onError?.(apiError);
        } finally{
            setIsSubmitting(false);
        }
    }, []);
    return {
        data: data,
        error: error,
        isSubmitting: isSubmitting,
        mutate: mutate
    };
};
module.exports["useMutation"] = $b4a77d21276ce51d$export$609860bf8b0084c;

});

parcelRegister("iyIOY", function(module, exports) {
parcelRequire("95IFc");
var $142hz = parcelRequire("142hz");
var $eC9tI = parcelRequire("eC9tI");
var $niMUw = parcelRequire("niMUw");
var $4RrPd = parcelRequire("4RrPd");
var $bJv8O = parcelRequire("bJv8O");

var $d82e2b7f9d9ed58c$var$global = (0, $niMUw.getGlobalObject)();
/** Send Console API calls as Sentry Events */ var $d82e2b7f9d9ed58c$export$25a43cb5b5c58c08 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function CaptureConsole(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = CaptureConsole.id;
        /**
         * @inheritDoc
         */ this._levels = (0, $142hz.CONSOLE_LEVELS);
        if (options.levels) this._levels = options.levels;
    }
    /**
     * @inheritDoc
     */ CaptureConsole.prototype.setupOnce = function(_, getCurrentHub) {
        if (!('console' in $d82e2b7f9d9ed58c$var$global)) return;
        this._levels.forEach(function(level) {
            if (!(level in $d82e2b7f9d9ed58c$var$global.console)) return;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $eC9tI.fill)($d82e2b7f9d9ed58c$var$global.console, level, function(originalConsoleMethod) {
                return function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    var hub = getCurrentHub();
                    if (hub.getIntegration(CaptureConsole)) hub.withScope(function(scope) {
                        scope.setLevel((0, $bJv8O.severityFromString)(level));
                        scope.setExtra('arguments', args);
                        scope.addEventProcessor(function(event) {
                            event.logger = 'console';
                            return event;
                        });
                        var message = (0, $4RrPd.safeJoin)(args, ' ');
                        if (level === 'assert') {
                            if (args[0] === false) {
                                message = "Assertion failed: " + ((0, $4RrPd.safeJoin)(args.slice(1), ' ') || 'console.assert');
                                scope.setExtra('arguments', args.slice(1));
                                hub.captureMessage(message);
                            }
                        } else if (level === 'error' && args[0] instanceof Error) hub.captureException(args[0]);
                        else hub.captureMessage(message);
                    });
                    // this fails for some browsers. :(
                    if (originalConsoleMethod) originalConsoleMethod.apply($d82e2b7f9d9ed58c$var$global.console, args);
                };
            });
        });
    };
    /**
     * @inheritDoc
     */ CaptureConsole.id = 'CaptureConsole';
    return CaptureConsole;
}();
module.exports["CaptureConsole"] = $d82e2b7f9d9ed58c$export$25a43cb5b5c58c08;

});

parcelRegister("95IFc", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("niMUw")).getGlobalObject);
$parcel$export(module.exports, "isError", () => (parcelRequire("h6HKI")).isError);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("h6HKI")).isPlainObject);
$parcel$export(module.exports, "CONSOLE_LEVELS", () => (parcelRequire("142hz")).CONSOLE_LEVELS);
$parcel$export(module.exports, "logger", () => (parcelRequire("142hz")).logger);
$parcel$export(module.exports, "normalize", () => (parcelRequire("11Kkv")).normalize);
$parcel$export(module.exports, "fill", () => (parcelRequire("eC9tI")).fill);
$parcel$export(module.exports, "severityFromString", () => (parcelRequire("bJv8O")).severityFromString);
$parcel$export(module.exports, "safeJoin", () => (parcelRequire("4RrPd")).safeJoin);





parcelRequire("niMUw");


parcelRequire("h6HKI");

parcelRequire("142hz");




var $5kreq = parcelRequire("5kreq");

parcelRequire("11Kkv");

parcelRequire("eC9tI");



parcelRequire("bJv8O");



parcelRequire("4RrPd");




var $6pmA9 = parcelRequire("6pmA9");






$parcel$exportWildcard(module.exports, $5kreq);
$parcel$exportWildcard(module.exports, $6pmA9);

});

parcelRegister("lIxjW", function(module, exports) {

var $niMUw = parcelRequire("niMUw");


var $h6HKI = parcelRequire("h6HKI");

function $fcf78dd05a1f2799$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $fcf78dd05a1f2799$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $fcf78dd05a1f2799$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $h6HKI.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $fcf78dd05a1f2799$export$1cfafeee2987818b() {
    var global = (0, $niMUw.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
}
module.exports["htmlTreeAsString"] = $fcf78dd05a1f2799$export$5647df6b7814ac86;

});

parcelRegister("niMUw", function(module, exports) {
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $5kreq = parcelRequire("5kreq");

var $0460b8fabe4a64c2$var$fallbackGlobalObject = {};
function $0460b8fabe4a64c2$export$256479dc0cea61c4() {
    return (0, $5kreq.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $0460b8fabe4a64c2$var$fallbackGlobalObject;
}
function $0460b8fabe4a64c2$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $0460b8fabe4a64c2$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}
module.exports["getGlobalObject"] = $0460b8fabe4a64c2$export$256479dc0cea61c4;
module.exports["getGlobalSingleton"] = $0460b8fabe4a64c2$export$7e223ec222791509;

});

parcelRegister("5kreq", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $3HxeM = parcelRequire("3HxeM");


var $1P2f3 = parcelRequire("1P2f3");

function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $3HxeM.isBrowserBundle)() && Object.prototype.toString.call(typeof $1P2f3 !== 'undefined' ? $1P2f3 : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});

parcelRegister("3HxeM", function(module, exports) {
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $2b1f2b7c68d97ced$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
module.exports["isBrowserBundle"] = $2b1f2b7c68d97ced$export$2928c40372e623c0;

});

parcelRegister("h6HKI", function(module, exports) {
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $c744ef8efbbea969$var$objectToString = Object.prototype.toString;
function $c744ef8efbbea969$export$e6127cc7fe7395c3(wat) {
    switch($c744ef8efbbea969$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $c744ef8efbbea969$export$49034edbe6b62415(wat, Error);
    }
}
function $c744ef8efbbea969$var$isBuiltin(wat, ty) {
    return $c744ef8efbbea969$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $c744ef8efbbea969$export$9f9636d330b71954(wat) {
    return $c744ef8efbbea969$var$isBuiltin(wat, 'ErrorEvent');
}
function $c744ef8efbbea969$export$ef9e2056653f0c8e(wat) {
    return $c744ef8efbbea969$var$isBuiltin(wat, 'DOMError');
}
function $c744ef8efbbea969$export$12e869b2a583f783(wat) {
    return $c744ef8efbbea969$var$isBuiltin(wat, 'DOMException');
}
function $c744ef8efbbea969$export$844ec244b1367d54(wat) {
    return $c744ef8efbbea969$var$isBuiltin(wat, 'String');
}
function $c744ef8efbbea969$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $c744ef8efbbea969$export$53b83ca8eaab0383(wat) {
    return $c744ef8efbbea969$var$isBuiltin(wat, 'Object');
}
function $c744ef8efbbea969$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $c744ef8efbbea969$export$49034edbe6b62415(wat, Event);
}
function $c744ef8efbbea969$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $c744ef8efbbea969$export$49034edbe6b62415(wat, Element);
}
function $c744ef8efbbea969$export$49841c62b9eff15(wat) {
    return $c744ef8efbbea969$var$isBuiltin(wat, 'RegExp');
}
function $c744ef8efbbea969$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $c744ef8efbbea969$export$bc2894c7158efbac(wat) {
    return $c744ef8efbbea969$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $c744ef8efbbea969$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $c744ef8efbbea969$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
module.exports["isError"] = $c744ef8efbbea969$export$e6127cc7fe7395c3;
module.exports["isInstanceOf"] = $c744ef8efbbea969$export$49034edbe6b62415;
module.exports["isString"] = $c744ef8efbbea969$export$844ec244b1367d54;
module.exports["isPrimitive"] = $c744ef8efbbea969$export$c3825b437cbdea5c;
module.exports["isPlainObject"] = $c744ef8efbbea969$export$53b83ca8eaab0383;
module.exports["isEvent"] = $c744ef8efbbea969$export$9671ea99bd126ace;
module.exports["isElement"] = $c744ef8efbbea969$export$45a5e7f76e0caa8d;
module.exports["isRegExp"] = $c744ef8efbbea969$export$49841c62b9eff15;
module.exports["isSyntheticEvent"] = $c744ef8efbbea969$export$bc2894c7158efbac;
module.exports["isNaN"] = $c744ef8efbbea969$export$c9f5652083b8129d;

});

parcelRegister("2Q8PY", function(module, exports) {
var $21174afd68a919a2$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
];
module.exports["SeverityLevels"] = $21174afd68a919a2$export$484b1ea9aec914c;

});

parcelRegister("142hz", function(module, exports) {
$parcel$export(module.exports, "logger", () => $0c67ef66515853ff$export$af88d00dbe7f521);

var $fbwmZ = parcelRequire("fbwmZ");


var $4O82D = parcelRequire("4O82D");


var $niMUw = parcelRequire("niMUw");

// TODO: Implement different loggers for different environments
var $0c67ef66515853ff$var$global = (0, $niMUw.getGlobalObject)();
/** Prefix for logging strings */ var $0c67ef66515853ff$var$PREFIX = 'Sentry Logger ';
var $0c67ef66515853ff$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $0c67ef66515853ff$export$cda52e2a8927a2ca(callback) {
    var global = (0, $niMUw.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $0c67ef66515853ff$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $0c67ef66515853ff$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $4O82D.IS_DEBUG_BUILD) $0c67ef66515853ff$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $0c67ef66515853ff$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $0c67ef66515853ff$var$global.console)[name].apply(_a, (0, $fbwmZ.__spread)([
                    $0c67ef66515853ff$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $0c67ef66515853ff$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $0c67ef66515853ff$export$af88d00dbe7f521;
if (0, $4O82D.IS_DEBUG_BUILD) $0c67ef66515853ff$export$af88d00dbe7f521 = (0, $niMUw.getGlobalSingleton)('logger', $0c67ef66515853ff$var$makeLogger);
else $0c67ef66515853ff$export$af88d00dbe7f521 = $0c67ef66515853ff$var$makeLogger();
module.exports["CONSOLE_LEVELS"] = $0c67ef66515853ff$export$2a2b1d2252a69ecb;

});

parcelRegister("4O82D", function(module, exports) {
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $380211d076ff50e5$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
module.exports["IS_DEBUG_BUILD"] = $380211d076ff50e5$export$48a8984ec0bf2e44;

});

parcelRegister("aY4rC", function(module, exports) {
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $7fc2f48fbe1d088a$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}
module.exports["memoBuilder"] = $7fc2f48fbe1d088a$export$8115b0b78e956ab3;

});

parcelRegister("11Kkv", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $h6HKI = parcelRequire("h6HKI");


var $aY4rC = parcelRequire("aY4rC");


var $eC9tI = parcelRequire("eC9tI");


var $fgmiz = parcelRequire("fgmiz");

function $0bf9d29200a37024$export$a3295358bff77e(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return $0bf9d29200a37024$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function $0bf9d29200a37024$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = $0bf9d29200a37024$export$a3295358bff77e(object, depth);
    if ($0bf9d29200a37024$var$jsonSize(normalized) > maxSize) return $0bf9d29200a37024$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $0bf9d29200a37024$export$588732934346abbf(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, $aY4rC.memoBuilder)();
    var _a = (0, $fbwmZ.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $h6HKI.isNaN)(value)) return value;
    var stringified = $0bf9d29200a37024$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $h6HKI.isError)(value) || (0, $h6HKI.isEvent)(value) ? (0, $eC9tI.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $0bf9d29200a37024$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $0bf9d29200a37024$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $h6HKI.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return "[Function: " + (0, $fgmiz.getFunctionName)(value) + "]";
        if (typeof value === 'symbol') return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function $0bf9d29200a37024$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $0bf9d29200a37024$var$jsonSize(value) {
    return $0bf9d29200a37024$var$utf8Length(JSON.stringify(value));
}
module.exports["normalize"] = $0bf9d29200a37024$export$a3295358bff77e;

});

parcelRegister("eC9tI", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $lIxjW = parcelRequire("lIxjW");


var $h6HKI = parcelRequire("h6HKI");


var $4RrPd = parcelRequire("4RrPd");

function $aa3bf77b99750f4a$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $aa3bf77b99750f4a$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $aa3bf77b99750f4a$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $aa3bf77b99750f4a$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $aa3bf77b99750f4a$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $aa3bf77b99750f4a$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $aa3bf77b99750f4a$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $aa3bf77b99750f4a$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $h6HKI.isError)(value)) newObj = (0, $fbwmZ.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $aa3bf77b99750f4a$var$getOwnProperties(value));
    else if ((0, $h6HKI.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $fbwmZ.__assign)({
            type: event_1.type,
            target: $aa3bf77b99750f4a$var$serializeEventTarget(event_1.target),
            currentTarget: $aa3bf77b99750f4a$var$serializeEventTarget(event_1.currentTarget)
        }, $aa3bf77b99750f4a$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $h6HKI.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $aa3bf77b99750f4a$var$serializeEventTarget(target) {
    try {
        return (0, $h6HKI.isElement)(target) ? (0, $lIxjW.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $aa3bf77b99750f4a$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $aa3bf77b99750f4a$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($aa3bf77b99750f4a$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $4RrPd.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $4RrPd.truncate)(serialized, maxLength);
    }
    return '';
}
function $aa3bf77b99750f4a$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $h6HKI.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $fbwmZ.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $aa3bf77b99750f4a$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($aa3bf77b99750f4a$export$d25f2688db1bb433);
    return val;
}
function $aa3bf77b99750f4a$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $h6HKI.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}
module.exports["fill"] = $aa3bf77b99750f4a$export$9563e054e6f787fb;
module.exports["convertToPlainObject"] = $aa3bf77b99750f4a$export$62ff257738bf57f5;

});

parcelRegister("4RrPd", function(module, exports) {

var $h6HKI = parcelRequire("h6HKI");

function $38a1b21eefbb9b2d$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $38a1b21eefbb9b2d$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $38a1b21eefbb9b2d$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $38a1b21eefbb9b2d$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $h6HKI.isString)(value)) return false;
    if ((0, $h6HKI.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $38a1b21eefbb9b2d$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}
module.exports["truncate"] = $38a1b21eefbb9b2d$export$6a506b36fdea397d;
module.exports["safeJoin"] = $38a1b21eefbb9b2d$export$465e9d514283d4fd;

});

parcelRegister("fgmiz", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");

var $b1c9a5aa64b78b97$var$STACKTRACE_LIMIT = 50;
function $b1c9a5aa64b78b97$export$a5739666fb2d03d4() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, $fbwmZ.__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, $fbwmZ.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $b1c9a5aa64b78b97$export$c55c24c0eeba0205(frames);
    };
}
function $b1c9a5aa64b78b97$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $b1c9a5aa64b78b97$var$STACKTRACE_LIMIT).map(function(frame) {
        return (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        });
    }).reverse();
}
var $b1c9a5aa64b78b97$var$defaultFunctionName = '<anonymous>';
function $b1c9a5aa64b78b97$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $b1c9a5aa64b78b97$var$defaultFunctionName;
        return fn.name || $b1c9a5aa64b78b97$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $b1c9a5aa64b78b97$var$defaultFunctionName;
    }
}
module.exports["getFunctionName"] = $b1c9a5aa64b78b97$export$aad197c7121a6651;

});

parcelRegister("bJv8O", function(module, exports) {

var $dtZ6d = parcelRequire("dtZ6d");


var $2Q8PY = parcelRequire("2Q8PY");

function $88ac0da36f058dd3$var$isSupportedSeverity(level) {
    return (0, $2Q8PY.SeverityLevels).indexOf(level) !== -1;
}
function $88ac0da36f058dd3$export$e01cef29b4327697(level) {
    if (level === 'warn') return (0, $dtZ6d.Severity).Warning;
    if ($88ac0da36f058dd3$var$isSupportedSeverity(level)) return level;
    return (0, $dtZ6d.Severity).Log;
}
module.exports["severityFromString"] = $88ac0da36f058dd3$export$e01cef29b4327697;

});

parcelRegister("6pmA9", function(module, exports) {

var $niMUw = parcelRequire("niMUw");


var $5kreq = parcelRequire("5kreq");

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $niMUw.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $5kreq.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $5kreq.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $niMUw.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

});

parcelRegister("6W0Xl", function(module, exports) {
parcelRequire("95IFc");
var $142hz = parcelRequire("142hz");


var $c9L3v = parcelRequire("c9L3v");

/** Deduplication filter */ var $50c8e6bccf5bbb5e$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($50c8e6bccf5bbb5e$export$3c6361fddf6cd929(currentEvent, self._previousEvent)) {
                        (0, $c9L3v.IS_DEBUG_BUILD) && (0, $142hz.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
function $50c8e6bccf5bbb5e$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($50c8e6bccf5bbb5e$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($50c8e6bccf5bbb5e$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $50c8e6bccf5bbb5e$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$50c8e6bccf5bbb5e$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$50c8e6bccf5bbb5e$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $50c8e6bccf5bbb5e$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $50c8e6bccf5bbb5e$var$_getExceptionFromEvent(previousEvent);
    var currentException = $50c8e6bccf5bbb5e$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$50c8e6bccf5bbb5e$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$50c8e6bccf5bbb5e$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $50c8e6bccf5bbb5e$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $50c8e6bccf5bbb5e$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $50c8e6bccf5bbb5e$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $50c8e6bccf5bbb5e$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $50c8e6bccf5bbb5e$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $50c8e6bccf5bbb5e$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
}
module.exports["Dedupe"] = $50c8e6bccf5bbb5e$export$688d98c249d31ad3;

});

parcelRegister("c9L3v", function(module, exports) {
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $8d9ad39358b035f4$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;
module.exports["IS_DEBUG_BUILD"] = $8d9ad39358b035f4$export$48a8984ec0bf2e44;

});

parcelRegister("fa95z", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");

parcelRequire("95IFc");
var $h6HKI = parcelRequire("h6HKI");
var $142hz = parcelRequire("142hz");
var $11Kkv = parcelRequire("11Kkv");


var $c9L3v = parcelRequire("c9L3v");

/** Patch toString calls to return proper name for wrapped functions */ var $b09ed70491c36903$export$56d961ef3a52a072 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function ExtraErrorData(options) {
        /**
         * @inheritDoc
         */ this.name = ExtraErrorData.id;
        this._options = (0, $fbwmZ.__assign)({
            depth: 3
        }, options);
    }
    /**
     * @inheritDoc
     */ ExtraErrorData.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event, hint) {
            var self = getCurrentHub().getIntegration(ExtraErrorData);
            if (!self) return event;
            return self.enhanceEventWithErrorData(event, hint);
        });
    };
    /**
     * Attaches extracted information from the Error object to extra field in the Event
     */ ExtraErrorData.prototype.enhanceEventWithErrorData = function(event, hint) {
        var _a;
        if (!hint || !hint.originalException || !(0, $h6HKI.isError)(hint.originalException)) return event;
        var name = hint.originalException.name || hint.originalException.constructor.name;
        var errorData = this._extractErrorData(hint.originalException);
        if (errorData) {
            var contexts = (0, $fbwmZ.__assign)({}, event.contexts);
            var normalizedErrorData = (0, $11Kkv.normalize)(errorData, this._options.depth);
            if ((0, $h6HKI.isPlainObject)(normalizedErrorData)) contexts = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, event.contexts), (_a = {}, _a[name] = (0, $fbwmZ.__assign)({}, normalizedErrorData), _a));
            return (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, event), {
                contexts: contexts
            });
        }
        return event;
    };
    /**
     * Extract extra information from the Error object
     */ ExtraErrorData.prototype._extractErrorData = function(error) {
        var e_1, _a, e_2, _b;
        // We are trying to enhance already existing event, so no harm done if it won't succeed
        try {
            var nativeKeys = [
                'name',
                'message',
                'stack',
                'line',
                'column',
                'fileName',
                'lineNumber',
                'columnNumber',
                'toJSON'
            ];
            var extraErrorInfo = {};
            try {
                // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
                for(var _c = (0, $fbwmZ.__values)(Object.keys(error)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var key = _d.value;
                    if (nativeKeys.indexOf(key) !== -1) continue;
                    var value = error[key];
                    extraErrorInfo[key] = (0, $h6HKI.isError)(value) ? value.toString() : value;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
            if (typeof error.toJSON === 'function') {
                var serializedError = error.toJSON();
                try {
                    for(var _e = (0, $fbwmZ.__values)(Object.keys(serializedError)), _f = _e.next(); !_f.done; _f = _e.next()){
                        var key = _f.value;
                        var value = serializedError[key];
                        extraErrorInfo[key] = (0, $h6HKI.isError)(value) ? value.toString() : value;
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            return extraErrorInfo;
        } catch (oO) {
            (0, $c9L3v.IS_DEBUG_BUILD) && (0, $142hz.logger).error('Unable to extract extra data from the Error object:', oO);
        }
        return null;
    };
    /**
     * @inheritDoc
     */ ExtraErrorData.id = 'ExtraErrorData';
    return ExtraErrorData;
}();
module.exports["ExtraErrorData"] = $b09ed70491c36903$export$56d961ef3a52a072;

});

parcelRegister("hLq0X", function(module, exports) {
/** Add node transaction to the event */ var $ceeb015bb088f872$export$febc5573c75cefb0 = /** @class */ function() {
    function Transaction() {
        /**
         * @inheritDoc
         */ this.name = Transaction.id;
    }
    /**
     * @inheritDoc
     */ Transaction.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var self = getCurrentHub().getIntegration(Transaction);
            if (self) return self.process(event);
            return event;
        });
    };
    /**
     * @inheritDoc
     */ Transaction.prototype.process = function(event) {
        var frames = this._getFramesFromEvent(event);
        // use for loop so we don't have to reverse whole frames array
        for(var i = frames.length - 1; i >= 0; i--){
            var frame = frames[i];
            if (frame.in_app === true) {
                event.transaction = this._getTransaction(frame);
                break;
            }
        }
        return event;
    };
    /** JSDoc */ Transaction.prototype._getFramesFromEvent = function(event) {
        var exception = event.exception && event.exception.values && event.exception.values[0];
        return exception && exception.stacktrace && exception.stacktrace.frames || [];
    };
    /** JSDoc */ Transaction.prototype._getTransaction = function(frame) {
        return frame.module || frame.function ? (frame.module || '?') + "/" + (frame.function || '?') : '<unknown>';
    };
    /**
     * @inheritDoc
     */ Transaction.id = 'Transaction';
    return Transaction;
}();
module.exports["Transaction"] = $ceeb015bb088f872$export$febc5573c75cefb0;

});

parcelRegister("go7uG", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $8f99a430e8355353$export$74e304339778e94d = (0, $kSwu1.defineMessages)({
    copyCodeToClipboard: {
        id: "fabric.editor.codeBlockCopyButton.copyToClipboard",
        defaultMessage: "Copy as text"
    },
    copiedCodeToClipboard: {
        id: "fabric.editor.codeBlockCopyButton.copiedToClipboard",
        defaultMessage: "Copied!"
    },
    // Remove wrapCode/unwrapCode and use wrapCodeLabel/unwrapCodeLabel
    // when cleaning up platform_editor_code_block_q4_lovability.
    wrapCode: {
        id: "fabric.editor.codeBlockWrapButton.wrapCodeBlock",
        defaultMessage: "Turn on wrap"
    },
    unwrapCode: {
        id: "fabric.editor.codeBlockWrapButton.unwrapCodeBlock",
        defaultMessage: "Turn off wrap"
    },
    wrapCodeLabel: {
        id: "fabric.editor.codeBlockWrapButton.wrapCode",
        defaultMessage: "Wrap code"
    },
    unwrapCodeLabel: {
        id: "fabric.editor.codeBlockWrapButton.unwrapCode",
        defaultMessage: "Unwrap code"
    },
    showLineNumbersLabel: {
        id: "fabric.editor.codeBlockLineNumbersButton.showLineNumbers",
        defaultMessage: "Show line numbers"
    },
    hideLineNumbersLabel: {
        id: "fabric.editor.codeBlockLineNumbersButton.hideLineNumbers",
        defaultMessage: "Hide line numbers"
    },
    formatCode: {
        id: "fabric.editor.codeBlockFormatButton.formatCode",
        defaultMessage: "Format code"
    },
    formatCodeUnavailable: {
        id: "fabric.editor.codeBlockFormatButton.formatCodeUnavailable",
        defaultMessage: "Formatting not available for this language"
    },
    formatCodeFailed: {
        id: "fabric.editor.codeBlockFormatButton.formatCodeFailed",
        defaultMessage: "Code formatting failed"
    },
    formatCodeFailedDescription: {
        id: "fabric.editor.codeBlockFormatButton.formatCodeFailedDescription",
        defaultMessage: "Review the content or change the selected language."
    },
    formatCodeFailedAutoDetectedDescription: {
        id: "fabric.editor.codeBlockFormatButton.formatCodeFailedAutoDetectedDescription",
        defaultMessage: "Review the content or select a specific language."
    },
    selectLanguage: {
        id: "fabric.editor.selectLanguage",
        defaultMessage: "Select language"
    },
    detectLanguage: {
        id: "fabric.editor.codeBlock.detectLanguage",
        defaultMessage: "Detect language"
    },
    detectedLanguage: {
        id: "fabric.editor.codeBlock.detectedLanguage",
        defaultMessage: "{language} (detected)"
    },
    noneDetected: {
        id: "fabric.editor.codeBlock.noneDetected",
        defaultMessage: "(None detected)"
    },
    recentlyUsed: {
        id: "fabric.editor.codeBlock.recentlyUsed",
        defaultMessage: "Recently used"
    },
    all: {
        id: "fabric.editor.codeBlock.all",
        defaultMessage: "All"
    },
    downloadCodeBlock: {
        id: "fabric.editor.codeBlockDownloadButton.downloadCodeBlock",
        defaultMessage: "Download"
    }
});
module.exports["codeBlockButtonMessages"] = $8f99a430e8355353$export$74e304339778e94d;

});

parcelRegister("jDboD", function(module, exports) {
const $92130f7ce8b5e3de$export$7452d7062a4d0634 = 1000;
module.exports["ANALYTICS_HOVER_DELAY"] = $92130f7ce8b5e3de$export$7452d7062a4d0634;

});

parcelRegister("11zX6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $fa07988e74fc1b7d$export$8f5a73ba0d077b01 = 32;
class $fa07988e74fc1b7d$export$3482036c37e627f4 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidMount() {
        window.addEventListener('message', this.messageCallback);
    }
    componentWillUnmount() {
        window.removeEventListener('message', this.messageCallback);
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.messageCallback = (event)=>{
            const { embedIframeRef: embedIframeRef } = this.props;
            const isFromExpectedIframe = embedIframeRef.current && event.source === embedIframeRef.current.contentWindow;
            const isStringData = typeof event.data === 'string';
            if (isFromExpectedIframe && isStringData) try {
                const data = JSON.parse(event.data);
                if (data.method === 'resize' && typeof data.height === 'number') this.onEmbedHeightChange({
                    height: data.height
                });
            } catch (e) {}
        };
        this.onEmbedHeightChange = (data)=>{
            const { onHeightUpdate: onHeightUpdate } = this.props;
            const height = data.height + $fa07988e74fc1b7d$export$8f5a73ba0d077b01;
            onHeightUpdate(height);
        };
    }
}
module.exports["embedHeaderHeight"] = $fa07988e74fc1b7d$export$8f5a73ba0d077b01;
module.exports["EmbedResizeMessageListener"] = $fa07988e74fc1b7d$export$3482036c37e627f4;

});

parcelRegister("aHoC6", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fc71b9d8c80c48f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $5X6fy = parcelRequire("5X6fy");


var $7Y8M5 = parcelRequire("7Y8M5");


var $ixfCV = parcelRequire("ixfCV");


var $5o4s6 = parcelRequire("5o4s6");


var $4G6PK = parcelRequire("4G6PK");


var $95Vjg = parcelRequire("95Vjg");


var $ihn0W = parcelRequire("ihn0W");


var $hNvnn = parcelRequire("hNvnn");

function $7fc71b9d8c80c48f$export$2e2bcd8739ae039({ layout: layout, width: width, height: height, containerWidth: containerWidth = width, isLoading: isLoading = false, pctWidth: pctWidth, size: size, className: className, children: propsChildren, nodeType: nodeType = 'mediaSingle', fullWidthMode: fullWidthMode, lineLength: editorWidth, hasFallbackContainer: hasFallbackContainer = true, handleMediaSingleRef: handleMediaSingleRef, isInsideOfInlineExtension: isInsideOfInlineExtension = false, dataAttributes: dataAttributes, isInRenderer: isInRenderer = false }) {
    const isPixelWidth = size?.widthType === 'pixel';
    let mediaSingleWidth = size?.width || pctWidth;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(propsChildren);
    if (!mediaSingleWidth && (0, $ihn0W.shouldAddDefaultWrappedWidth)(layout, width, editorWidth)) // if width is not available, set to half of editor width
    mediaSingleWidth = isPixelWidth ? editorWidth / 2 : 50;
    // When width is not set we have an absolute height for a given embed.
    // When both width and height are set we use them to determine ratio and use that to define
    // embed height in relation to whatever width of an dom element is in runtime.
    const isHeightOnly = width === undefined;
    if (mediaSingleWidth) {
        const pxWidth = (0, $95Vjg.getMediaSinglePixelWidth)(mediaSingleWidth, editorWidth, size?.widthType, (0, $4G6PK.MEDIA_SINGLE_GUTTER_SIZE));
        if (isHeightOnly) width = pxWidth - (0, $7Y8M5.akEditorMediaResizeHandlerPaddingWide);
        else if (width !== undefined) {
            height = height / width * pxWidth;
            width = pxWidth;
        }
    } else if (isHeightOnly) // No mediaSingleWidth can be found on already existing pages with existing embeds
    // It's ok to use Embed specific width, because width can be not set only in embed card.
    // This value will be used only in the case of non `wide` and non `full-width` cases inside MediaSingleDimensionHelper.
    width = (0, $7Y8M5.DEFAULT_EMBED_CARD_WIDTH) - (0, $7Y8M5.akEditorMediaResizeHandlerPaddingWide);
    // Media wrapper controls the height of the box.
    // We can define this height
    // - via height directly
    // - via paddingBottom (if we have both height and width) which is a css trick to represent a ratio
    let mediaWrapperHeight;
    let paddingBottom;
    if (isHeightOnly) mediaWrapperHeight = height;
    else if (width !== undefined) {
        const mediaWrapperRatio = height / width * 100;
        paddingBottom = `${mediaWrapperRatio.toFixed(3)}%`;
        if (nodeType === 'embedCard') // we want to set ratio of whole box (including header) buy knowing ratio of iframe itself
        // For some reason importing `embedHeaderHeight` from '@atlaskit/smart-card' breaks
        // packages/editor/editor-core/src/plugins/table/__tests__/unit/toolbar.ts 🤷‍️, but we have a test
        // that uses imported value, so it's should be good.
        paddingBottom = `calc(${paddingBottom} + 32px)`;
    }
    const [media, caption] = children;
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        ref: handleMediaSingleRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $hNvnn.MediaSingleDimensionHelper)({
            width: width,
            layout: layout,
            containerWidth: containerWidth,
            mediaSingleWidth: mediaSingleWidth,
            fullWidthMode: fullWidthMode,
            isExtendedResizeExperienceOn: isPixelWidth,
            isInsideOfInlineExtension: isInsideOfInlineExtension,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isInRenderer: isInRenderer && (0, $ixfCV.fg)('media-perf-uplift-mutation-fix')
        }),
        ...!(0, $ixfCV.fg)('platform_editor_fix_media_in_renderer') ? {} : {
            'data-layout': layout
        },
        "data-width": mediaSingleWidth,
        "data-width-type": size?.widthType || 'percentage',
        "data-node-type": nodeType,
        "data-vc": "media-single",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('rich-media-item mediaSingleView-content-wrap', `image-${layout}`, className, {
            'is-loading': isLoading,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        }),
        ...dataAttributes,
        ...(0, $5o4s6.VcMediaWrapperProps)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $hNvnn.MediaWrapper), {
        hasFallbackContainer: hasFallbackContainer,
        height: mediaWrapperHeight,
        paddingBottom: paddingBottom
    }, media), caption);
}

});

parcelRegister("95Vjg", function(module, exports) {
/**
 * Convert media node width to pixel
 *
 * for legacy experience, image is aligned inside resize handle bar with a gap. So gutterOffset is used to for this use case.
 * for new experience, image is aligned with resize handle bar, so gutterOffset is 0
 *
 * @param width - media single node width
 * @param editorWidth - width of editor
 * @param widthType - width type is defined in the adf document for mediaSingle node, and it is associated with the `width`
 * @param gutterOffset - resize handle bar offset, determines whether align with resize handle bar
 * @returns pixel number for media single node
 */ function $69e3419be6a9274a$export$a6f4ec2edd25b07e(width, editorWidth, widthType = 'percentage', gutterOffset = 0) {
    if (widthType === 'pixel') return width;
    return Math.ceil((editorWidth + gutterOffset) * (width / 100) - gutterOffset);
}
module.exports["getMediaSinglePixelWidth"] = $69e3419be6a9274a$export$a6f4ec2edd25b07e;

});

parcelRegister("hNvnn", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $7Y8M5 = parcelRequire("7Y8M5");


var $ixfCV = parcelRequire("ixfCV");


var $8qft0 = parcelRequire("8qft0");


var $h9Lux = parcelRequire("h9Lux");


var $5y9Nl = parcelRequire("5y9Nl");


var $fuDKy = parcelRequire("fuDKy");

function $640d411acbc53708$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $640d411acbc53708$var$float(layout) {
    switch(layout){
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
function $640d411acbc53708$var$getWidthIfFullWidthMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $7Y8M5.akEditorFullWidthLayoutWidth) ? `${Math.min(containerWidth, (0, $7Y8M5.akEditorFullWidthLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $7Y8M5.akEditorFullWidthLayoutWidth) ? '100%' : `${originalWidth}px`;
}
function $640d411acbc53708$var$getWidthIfDefaultMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $7Y8M5.akEditorFullPageMaxWidth) ? `${Math.min(containerWidth, (0, $7Y8M5.akEditorDefaultLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $7Y8M5.akEditorFullPageMaxWidth) ? '100%' : `${originalWidth}px`;
}
function $640d411acbc53708$export$326222fa0d211f8e(layout, width, containerWidth = 0, fullWidthMode, isResized, isInsideOfInlineExtension) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return isInsideOfInlineExtension ? (0, $h9Lux.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`) : (0, $h9Lux.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $h9Lux.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $640d411acbc53708$var$getWidthIfFullWidthMode(width, containerWidth, isInsideOfInlineExtension) : $640d411acbc53708$var$getWidthIfDefaultMode(width, containerWidth, isInsideOfInlineExtension);
    }
}
function $640d411acbc53708$export$e4db998a333a342e(layout, width, containerWidth = 0, fullWidthMode, isResized) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return (0, $h9Lux.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`);
        case 'full-width':
            return (0, $h9Lux.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $640d411acbc53708$var$getWidthIfFullWidthMode(width, containerWidth) : $640d411acbc53708$var$getWidthIfDefaultMode(width, containerWidth);
    }
}
function $640d411acbc53708$var$calcMargin(layout) {
    switch(layout){
        case 'wrap-right':
            return '12px auto 12px 12px';
        case 'wrap-left':
            return '12px 12px 12px auto';
        default:
            return '24px auto';
    }
}
function $640d411acbc53708$var$calcMaxCssForPercentageTypeMedia(layout) {
    switch(layout){
        case 'wide':
            return `min(var(--ak-editor--breakout-wide-layout-width), var(--ak-editor-max-container-width))`;
        case 'full-width':
            return `min(var(--ak-editor--full-width-layout-width), var(--ak-editor-max-container-width))`;
        default:
            return 'var(--ak-editor-max-container-width)';
    }
}
function $640d411acbc53708$var$isImageAligned(layout) {
    switch(layout){
        case 'align-end':
            return 'margin-right: 0';
        case 'align-start':
            return 'margin-left: 0';
        default:
            return '';
    }
}
/**
 * Can't use `.attrs` to handle highly dynamic styles because we are still
 * supporting `styled-components` v1.
 * @param root0
 * @param root0.containerWidth
 * @param root0.fullWidthMode
 * @param root0.isResized
 * @param root0.layout
 * @param root0.mediaSingleWidth
 * @param root0.width
 * @param root0.isExtendedResizeExperienceOn
 * @param root0.isNestedNode
 * @param root0.isInsideOfInlineExtension
 * @param root0.isInRenderer
 * @example
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $640d411acbc53708$var$_ref = {
    name: "1il1ars",
    styles: "@container ak-renderer-wrapper (min-width: 1px){max-width:100cqw;}"
};
var $640d411acbc53708$var$_ref2 = {
    name: "1bxycju",
    styles: "min-width:100%"
};
const $640d411acbc53708$export$2b2737a2ef2f5b46 = ({ containerWidth: containerWidth = 0, fullWidthMode: fullWidthMode, isResized: isResized, layout: layout, mediaSingleWidth: mediaSingleWidth, width: width, isExtendedResizeExperienceOn: // original media width
isExtendedResizeExperienceOn, isNestedNode: isNestedNode = false, isInsideOfInlineExtension: isInsideOfInlineExtension = false, isInRenderer: isInRenderer = false })=>{
    const calculatedWidth = (0, $fuDKy.roundToClosestEvenPxValue)(isExtendedResizeExperienceOn ? `${mediaSingleWidth || width}px` : mediaSingleWidth ? (0, $5y9Nl.calcResizedWidth)(layout, width || 0, containerWidth) : $640d411acbc53708$export$326222fa0d211f8e(layout, width || 0, containerWidth, fullWidthMode, isResized, isInsideOfInlineExtension));
    const cssMaxWidth = isExtendedResizeExperienceOn ? 'var(--ak-editor-max-container-width)' : $640d411acbc53708$var$calcMaxCssForPercentageTypeMedia(layout);
    // jest warning: JSDOM version (22) doesn't support the new @container CSS rule
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    return /*#__PURE__*/ (0, $lOiVq.css)("tr &,[data-layout-column] &,[data-node-type='expand'] &,[data-panel-type] &,li &,[data-prosemirror-node-name='bodiedSyncBlock'] &,[data-prosemirror-node-name='syncBlock'] &,[data-sync-block-renderer] &,[data-bodied-sync-block] &{max-width:100%;}width:", calculatedWidth, ";", layout === 'full-width' && /* This causes issues for new experience where we don't strip layout attributes
   when copying top-level node and pasting into a table/layout,
   because full-width layout will remain, causing node to be edge-to-edge */ !isExtendedResizeExperienceOn && $640d411acbc53708$var$_ref2, " ", isInRenderer ? $640d411acbc53708$var$_ref : `max-width: ${cssMaxWidth};`, " ", isExtendedResizeExperienceOn && `&[class*='is-resizing'] {
    .new-file-experience-wrapper {
      box-shadow: none !important;
    }

    ${!isNestedNode && (0, $8qft0.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
      transform: translateX(-50%);`}
  }`, " &:not(.is-resizing){transition:width 100ms ease-in;}float:", $640d411acbc53708$var$float(layout), ";margin:", $640d411acbc53708$var$calcMargin(layout), ";&[class*='not-resizing']{", isNestedNode ? /* Make nested node appear responsive when resizing table cell */ `max-width: 100%;` : (0, $8qft0.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
        transform: translateX(-50%);`, ";}", $640d411acbc53708$var$isImageAligned(layout), ";");
};
const $640d411acbc53708$var$RenderFallbackContainer = ({ hasFallbackContainer: hasFallbackContainer, paddingBottom: paddingBottom, height: height })=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    (0, $lOiVq.css)(hasFallbackContainer ? `
  &::after {
    content: '';
    display: block;
    ${height ? `height: ${height}px;` : paddingBottom ? `padding-bottom: ${paddingBottom};` : ''}

    /* Fixes extra padding problem in Firefox */
    font-size: 0;
    line-height: 0;
  }
  ` : '', ";");
const $640d411acbc53708$export$9e3fd9f6215dd7b6 = (props)=>/*#__PURE__*/ (0, $lOiVq.css)("position:relative;", $640d411acbc53708$var$RenderFallbackContainer(props), "&>figure{position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}&>div:not([data-media-badges='true']){position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}& * [data-mark-annotation-type='inlineComment']{width:100%;height:100%;}&[data-node-type='embedCard']>div{width:100%;}[data-node-type='media']{position:static!important;height:auto!important;>div{position:absolute;height:100%;}}");
const $640d411acbc53708$export$542000db99cecf28 = ({ children: children, ...rest })=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $640d411acbc53708$export$9e3fd9f6215dd7b6(rest)
    }, children);
$640d411acbc53708$export$542000db99cecf28.displayName = 'WrapperMediaSingle';
const $640d411acbc53708$export$e18e95249d813157 = ({ borderColor: borderColor })=>{
    // [FEATURE FLAG: platform_editor_media_border_radius_fix]
    // Fixes border radius to properly match image with 8px radius
    // To clean up: remove conditional, keep only flag-on behavior ('8px')
    const borderRadius = (0, $ixfCV.fg)('platform_editor_media_border_radius_fix') ? "var(--ds-radius-large, 8px)" : '1px'; // OLD BEHAVIOR (to be removed when flag is cleaned up)
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            inset: '0px',
            border: `0.5px solid ${borderColor}`,
            borderRadius: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius
        }
    });
};
module.exports["MediaSingleDimensionHelper"] = $640d411acbc53708$export$2b2737a2ef2f5b46;
module.exports["MediaWrapper"] = $640d411acbc53708$export$542000db99cecf28;
module.exports["MediaBorderGapFiller"] = $640d411acbc53708$export$e18e95249d813157;

});

parcelRegister("5y9Nl", function(module, exports) {

var $h9Lux = parcelRequire("h9Lux");

function $a736c0097336f0f5$export$d48e8f24f681763e(layout, width, containerWidth = 0) {
    switch(layout){
        case 'wide':
            return (0, $h9Lux.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $h9Lux.calcBreakoutWidth)(layout, containerWidth);
        default:
            return `${width}px`;
    }
}
module.exports["calcResizedWidth"] = $a736c0097336f0f5$export$d48e8f24f681763e;

});

parcelRegister("fuDKy", function(module, exports) {
/**
 * Reduces the given CSS width value to the next lowest even pixel value if the value is in px.
 * This is to mitigate subpixel rendering issues of embedded smart links.
 *
 * @param widthValue CSS width value to be rounded
 * @returns Reduced CSS width value where px value given, or otherwise the original value
 * @example
 */ // widthValue could be a string in px, rem or percentage, e.g. "800px", "100%", etc.
function $e6d228c4639d9fdf$export$c832331b07480714(widthValue) {
    try {
        if (widthValue.endsWith('px')) {
            const pxWidth = parseInt(widthValue.slice(0, -2));
            return `${pxWidth - pxWidth % 2}px`;
        }
        return widthValue;
    } catch  {
        return widthValue;
    }
}
module.exports["roundToClosestEvenPxValue"] = $e6d228c4639d9fdf$export$c832331b07480714;

});

parcelRegister("fbHl6", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


const $14d0cd645fed394d$var$LazyDatasourceRenderFailedAnalyticsWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("cueDJ")));
const $14d0cd645fed394d$export$f386473e8f104bcb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($14d0cd645fed394d$var$LazyDatasourceRenderFailedAnalyticsWrapper, {
                ...props
            })
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($14d0cd645fed394d$var$LazyDatasourceRenderFailedAnalyticsWrapper, {
            ...props
        })
    });
module.exports["LazyLoadedDatasourceRenderFailedAnalyticsWrapper"] = $14d0cd645fed394d$export$f386473e8f104bcb;

});

parcelRegister("cueDJ", function(module, exports) {

let $9173a48e434958c3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9173a48e434958c3$var$load("bzl94").then(()=>parcelRequire('j30TZ'));

});

parcelRegister("gybyF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kHija = parcelRequire("kHija");


var $cMyWi = parcelRequire("cMyWi");


var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");


var $6Vsq4 = parcelRequire("6Vsq4");


var $apFwO = parcelRequire("apFwO");


var $jINxM = parcelRequire("jINxM");


var $2FmJb = parcelRequire("2FmJb");


var $dM7c5 = parcelRequire("dM7c5");


var $kG7AM = parcelRequire("kG7AM");


var $kfxZm = parcelRequire("kfxZm");


var $cEvdy = parcelRequire("cEvdy");


var $dz9dk = parcelRequire("dz9dk");


var $9H66G = parcelRequire("9H66G");

function $f78fd23812cb38dc$export$a95296ded9241771({ url: url, appearance: appearance, origin: origin, actionOptions: actionOptions, prefetch: prefetch }) {
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $cozmU.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($kHija)))(), []);
    const linkState = (0, $9H66G.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const { isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $cMyWi.useSmartLinkContext)();
    const invokeClientAction = (0, $kfxZm.default)({
        fireEvent: fireEvent
    });
    const resolve = (0, $cEvdy.default)();
    const appendCrossProductAnalyticsParams = (0, $dz9dk.useSmartLinkCrossProductUrlWrapperGated)({
        details: linkState.details
    });
    if ((0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && prefetch && !linkState.details) resolve({
        url: url
    });
    if (linkState.details && !actionOptions?.hide) {
        const actions = [];
        const invokeParam = {
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: linkState.details
        };
        const downloadActionProps = (0, $apFwO.extractInvokeDownloadAction)(invokeParam);
        if (downloadActionProps) actions.push((0, $kG7AM.toAction)(downloadActionProps, invokeClientAction, (0, $dM7c5.messages).download, 'download-content'));
        const viewActionProps = (0, $ixfCV.fg)('platform_smartlink_xpc_url_wrapping') ? (0, $2FmJb.extractInvokeViewAction)({
            ...invokeParam,
            transformUrl: (destinationUrl = url)=>appendCrossProductAnalyticsParams(destinationUrl)
        }) : (0, $2FmJb.extractInvokeViewAction)(invokeParam);
        if (viewActionProps) actions.push((0, $kG7AM.toAction)(viewActionProps, invokeClientAction, (0, $dM7c5.messages).view, 'view-content'));
        const previewActionProps = (0, $jINxM.extractInvokePreviewAction)({
            ...invokeParam,
            fireEvent: fireEvent,
            origin: origin,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            openPreviewPanel: openPreviewPanel,
            ...(0, $ixfCV.fg)('platform_smartlink_xpc_url_wrapping') ? {
                transformUrl: (destinationUrl = url)=>appendCrossProductAnalyticsParams(destinationUrl)
            } : undefined
        });
        if (previewActionProps) actions.push((0, $kG7AM.toAction)(previewActionProps.invokeAction, invokeClientAction, (0, $dM7c5.messages).preview_improved, 'preview-content'));
        return actions;
    }
    return [];
}
module.exports["useSmartLinkActions"] = $f78fd23812cb38dc$export$a95296ded9241771;

});

parcelRegister("kG7AM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $658c5c09596e5d2b$export$9d52be0dab870c7 = (action, invokeClientAction, message, id)=>{
    return {
        id: id,
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), message),
        invoke: ()=>invokeClientAction(action)
    };
};
module.exports["toAction"] = $658c5c09596e5d2b$export$9d52be0dab870c7;

});

parcelRegister("b2XFx", function(module, exports) {
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $kCECX = parcelRequire("kCECX");


var $7Y8M5 = parcelRequire("7Y8M5");


var $8VfSP = parcelRequire("8VfSP");


var $V3JOP = parcelRequire("V3JOP");


var $gDx2k = parcelRequire("gDx2k");


var $ixfCV = parcelRequire("ixfCV");


var $l8Rhq = parcelRequire("l8Rhq");

var $3izAL = parcelRequire("3izAL");

var $6Pqow = parcelRequire("6Pqow");

var $buxP3 = parcelRequire("buxP3");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $eaCAt = parcelRequire("eaCAt");

var $krYZG = parcelRequire("krYZG");


var $bI2nS = parcelRequire("bI2nS");

function $4e976cfe241fa7a6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Dynamic padding value that adjusts based on the editor's base font size.
 * When base font size is <= akEditorFullPageDenseFontSize (13px), uses 1px padding.
 * Otherwise, uses default value with token('space.025').
 */ const $4e976cfe241fa7a6$var$DYNAMIC_PADDING_BLOCK = `clamp(1px, calc((var(--ak-editor-base-font-size, ${(0, $7Y8M5.akEditorFullPageDefaultFontSize)}px) - ${(0, $7Y8M5.akEditorFullPageDenseFontSize)}px) * 999), ${"var(--ds-space-025, 2px)"})`;
const $4e976cfe241fa7a6$var$containerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $4e976cfe241fa7a6$var$iconWrapperStyles = (0, $buxP3.xcss)({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '17px',
    width: '17px'
});
const $4e976cfe241fa7a6$var$hiddenTextStyle = {
    name: "1hr6gib",
    styles: "overflow:hidden;white-space:nowrap;position:absolute;visibility:hidden"
};
const $4e976cfe241fa7a6$var$linkStylesCommon = (0, $buxP3.xcss)({
    position: 'absolute',
    left: 'space.025',
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle',
    paddingBlock: 'space.025',
    paddingInline: 'space.050',
    gap: 'space.025',
    overflow: 'hidden',
    zIndex: 'card',
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: "var(--ds-radius-small, 3px)",
    color: 'color.text.subtle',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    top: '0px',
    height: '1.2em',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered',
        color: 'color.text.subtle',
        textDecoration: 'none'
    }
});
const $4e976cfe241fa7a6$var$MIN_AVAILABLE_SPACE_WITH_LABEL_OVERLAY = 45;
const $4e976cfe241fa7a6$var$ICON_WIDTH = 16;
const $4e976cfe241fa7a6$var$DEFAULT_OPEN_TEXT_WIDTH = 28; // Default open text width in English
const $4e976cfe241fa7a6$var$visitCardLinkAnalytics = (editorAnalyticsApi, inputMethod)=>(state, dispatch)=>{
        if (!(state.selection instanceof (0, $kCECX.NodeSelection))) return false;
        const { type: type } = state.selection.node;
        if (dispatch) {
            const { tr: tr } = state;
            editorAnalyticsApi?.attachAnalyticsEvent((0, $eaCAt.buildVisitedNonHyperLinkPayload)(type.name, inputMethod))(tr);
            dispatch(tr);
        }
        return true;
    };
const $4e976cfe241fa7a6$var$HoverLinkOverlay = ({ children: children, isVisible: isVisible = false, url: url, destinationUrl: destinationUrl, compactPadding: compactPadding = false, editorAnalyticsApi: editorAnalyticsApi, view: view, onClick: onClick, showPanelButton: showPanelButton = false, showPanelButtonIcon: showPanelButtonIcon })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const containerRef = (0, $cozmU.useRef)(null);
    const hoverLinkButtonRef = (0, $cozmU.useRef)(null);
    const hiddenTextRef = (0, $cozmU.useRef)(null);
    const [showLabel, setShowLabel] = (0, $cozmU.useState)(true);
    const [isHovered, setHovered] = (0, $cozmU.useState)(false);
    const openTextWidthRef = (0, $cozmU.useRef)(null);
    const regularPadding = $4e976cfe241fa7a6$var$DYNAMIC_PADDING_BLOCK;
    const memoizedHoverLinkStyles = (0, $cozmU.useMemo)(()=>({
            paddingBlock: compactPadding ? '1px' : regularPadding
        }), [
        compactPadding,
        regularPadding
    ]);
    const hoverLinkStyles = (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedHoverLinkStyles : {
        paddingBlock: compactPadding ? '1px' : $4e976cfe241fa7a6$var$DYNAMIC_PADDING_BLOCK
    };
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!isVisible || !isHovered) return;
        const cardWidth = containerRef.current?.offsetWidth;
        const openButtonWidth = hoverLinkButtonRef.current?.offsetWidth;
        // Get the hidden text width
        if (!openTextWidthRef.current) {
            const hiddenText = hiddenTextRef.current;
            if (hiddenText) {
                // Measure the width of the hidden text
                // Temporarily make the element visible to measure its width
                hiddenText.style.visibility = 'hidden';
                hiddenText.style.display = 'inline';
                openTextWidthRef.current = hiddenText.offsetWidth;
                // Reset the hiddenText's display property
                hiddenText.style.display = 'none';
                hiddenText.style.visibility = 'inherit';
            } else openTextWidthRef.current = $4e976cfe241fa7a6$var$DEFAULT_OPEN_TEXT_WIDTH;
        }
        if (!cardWidth || !openButtonWidth) return;
        const openTextWidth = openTextWidthRef.current || $4e976cfe241fa7a6$var$DEFAULT_OPEN_TEXT_WIDTH;
        let canShowLabel = cardWidth - openTextWidth > $4e976cfe241fa7a6$var$MIN_AVAILABLE_SPACE_WITH_LABEL_OVERLAY + $4e976cfe241fa7a6$var$ICON_WIDTH;
        // When a smart link wraps to multiple lines in a constrained container (e.g. table cell),
        // the hover button can overflow beyond the container bounds. We detect this by comparing
        // the button's right edge to the container's right edge, and hide the label if it overflows.
        if (containerRef.current && hoverLinkButtonRef.current) {
            const containerRight = containerRef.current.getBoundingClientRect().right;
            const buttonRight = hoverLinkButtonRef.current.getBoundingClientRect().right;
            if (buttonRight > containerRight) canShowLabel = false;
        }
        setShowLabel(canShowLabel);
    }, [
        isVisible,
        isHovered
    ]);
    const handleOverlayChange = (isHovered)=>{
        setHovered(isHovered);
        // Reset label visibility on hover start so we can measure if it overflows.
        // Without this, the label stays hidden from a previous hover and won't be re-measured.
        if (isHovered) setShowLabel(true);
    };
    const sendVisitLinkAnalytics = (inputMethod)=>{
        if (editorAnalyticsApi && view) $4e976cfe241fa7a6$var$visitCardLinkAnalytics(editorAnalyticsApi, inputMethod)(view.state, view.dispatch);
    };
    const handleDoubleClick = ()=>{
        if (!showPanelButton) {
            sendVisitLinkAnalytics((0, $krYZG.INPUT_METHOD).DOUBLE_CLICK);
            // Double click opens the link in a new tab
            window.open((0, $ixfCV.fg)('platform_smartlink_xpc_url_wrapping') ? destinationUrl ?? url : url, '_blank');
        }
    };
    const handleClick = (event)=>{
        if (showPanelButton && onClick) onClick(event);
        else sendVisitLinkAnalytics((0, $krYZG.INPUT_METHOD).BUTTON);
    };
    const isPreviewButton = showPanelButton && (0, $fqVYq.editorExperiment)('platform_editor_preview_panel_linking_exp', true);
    const label = isPreviewButton ? formatMessage((0, $bI2nS.messages).previewButtonTitle) : formatMessage((0, $bI2nS.messages).openButtonTitle);
    let icon = null;
    if (isPreviewButton && showPanelButtonIcon === 'panel') icon = /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gDx2k))), {
        label: ""
    });
    else if (isPreviewButton && showPanelButtonIcon === 'modal') icon = /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8VfSP))), {
        label: ""
    });
    else icon = /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
        label: ""
    });
    return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        ref: containerRef,
        css: $4e976cfe241fa7a6$var$containerStyles,
        onDoubleClick: handleDoubleClick,
        onMouseEnter: ()=>handleOverlayChange(true),
        onMouseLeave: ()=>handleOverlayChange(false),
        // No-op focus/blur handlers to satisfy a11y/mouse-events-have-key-events rule.
        // The hover overlay is a mouse convenience — keyboard users can access link actions
        // (open, preview) via the floating toolbar that appears on selection.
        onFocus: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onBlur: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined
    }, children, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: $4e976cfe241fa7a6$var$hiddenTextStyle,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $6Pqow.default), {
        ref: hiddenTextRef,
        size: "small",
        maxLines: 1
    }, label)), isHovered && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $l8Rhq.default), {
        ref: hoverLinkButtonRef,
        xcss: $4e976cfe241fa7a6$var$linkStylesCommon,
        href: (0, $ixfCV.fg)('platform_smartlink_xpc_url_wrapping') ? destinationUrl ?? url : url,
        target: "_blank",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic paddingBlock value based on experiment flags
        style: hoverLinkStyles,
        onClick: handleClick,
        testId: "inline-card-hoverlink-overlay"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.default), {
        xcss: $4e976cfe241fa7a6$var$iconWrapperStyles,
        "data-inlinecard-button-overlay": "icon-wrapper-line-height",
        testId: "inline-card-hoverlink-overlay-icon"
    }, icon), showLabel && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $6Pqow.default), {
        size: "small",
        color: "color.text.subtle",
        maxLines: 1,
        testId: "inline-card-hoverlink-overlay-label"
    }, label)));
};
var $4e976cfe241fa7a6$export$2e2bcd8739ae039 = $4e976cfe241fa7a6$var$HoverLinkOverlay;
module.exports["default"] = $4e976cfe241fa7a6$export$2e2bcd8739ae039;

});

parcelRegister("lmL4n", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


const $73286e13e84d8c04$var$LazyDatasourceTableView = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("8NxN0")).then((module)=>({
            default: module.DatasourceTableView
        })));
const $73286e13e84d8c04$var$DatasourceTableViewWithWrappers = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": "datasource-table-view-suspense"
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: t0,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($73286e13e84d8c04$var$LazyDatasourceTableView, {
                ...props
            })
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": 'datasource-table-view-suspense'
        }),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($73286e13e84d8c04$var$LazyDatasourceTableView, {
            ...props
        })
    });
};
var $73286e13e84d8c04$export$2e2bcd8739ae039 = $73286e13e84d8c04$var$DatasourceTableViewWithWrappers;
module.exports["default"] = $73286e13e84d8c04$export$2e2bcd8739ae039;

});

parcelRegister("8NxN0", function(module, exports) {

let $667d1c32e686797d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $667d1c32e686797d$var$load("66GvX"),
    $667d1c32e686797d$var$load("hxVzR"),
    $667d1c32e686797d$var$load("gbejv"),
    $667d1c32e686797d$var$load("GD9EA"),
    $667d1c32e686797d$var$load("ddvkk"),
    $667d1c32e686797d$var$load("3upHR"),
    $667d1c32e686797d$var$load("eRhBr"),
    $667d1c32e686797d$var$load("hZ2FX"),
    $667d1c32e686797d$var$load("6wr18"),
    $667d1c32e686797d$var$load("6KvrM"),
    $667d1c32e686797d$var$load("151Um"),
    $667d1c32e686797d$var$load("ffEVr"),
    $667d1c32e686797d$var$load("iWnyc"),
    $667d1c32e686797d$var$load("hhss7"),
    $667d1c32e686797d$var$load("Wowvf"),
    $667d1c32e686797d$var$load("7EorR"),
    $667d1c32e686797d$var$load("3WGfe")
]).then(()=>parcelRequire('khl4A'));

});

parcelRegister("3u1Hp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lPEt0 = parcelRequire("lPEt0");


var $cMyWi = parcelRequire("cMyWi");


var $j39Hd = parcelRequire("j39Hd");


var $c7dFC = parcelRequire("c7dFC");

const $adf5b0efff0513f5$var$URL_RESPONSE_CACHE_SIZE = 50;
const $adf5b0efff0513f5$export$f82fcd766a8daa7f = new (0, $lPEt0.LRUMap)($adf5b0efff0513f5$var$URL_RESPONSE_CACHE_SIZE);
const $adf5b0efff0513f5$export$40b1dd31340bd5c2 = new (0, $lPEt0.LRUMap)($adf5b0efff0513f5$var$URL_RESPONSE_CACHE_SIZE);
const $adf5b0efff0513f5$export$15cd58682efec5a5 = new (0, $lPEt0.LRUMap)($adf5b0efff0513f5$var$URL_RESPONSE_CACHE_SIZE);
const $adf5b0efff0513f5$export$5e074c0b68e2ce03 = 20;
const $adf5b0efff0513f5$export$7d812bb756889442 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(13);
    const { connections: t0 } = (0, $cMyWi.useSmartLinkContext)();
    const { client: client } = t0;
    const resolverUrl = (0, $c7dFC.useResolverUrl)(client);
    const cachedRequest = $adf5b0efff0513f5$var$_temp;
    const uncachedRequest = $adf5b0efff0513f5$var$_temp2;
    let t1;
    if ($[0] !== resolverUrl) {
        t1 = async (datasourceId, data_1, t2)=>{
            const force_0 = t2 === undefined ? false : t2;
            return cachedRequest(datasourceId, data_1, `${resolverUrl}/datasource/${datasourceId}/fetch/details`, $adf5b0efff0513f5$export$f82fcd766a8daa7f, force_0);
        };
        $[0] = resolverUrl;
        $[1] = t1;
    } else t1 = $[1];
    const getDatasourceDetails = t1;
    let t2;
    if ($[2] !== resolverUrl) {
        t2 = async (datasourceId_0, data_2, t3)=>{
            const force_1 = t3 === undefined ? false : t3;
            return cachedRequest(datasourceId_0, data_2, `${resolverUrl}/datasource/${datasourceId_0}/fetch/data`, $adf5b0efff0513f5$export$40b1dd31340bd5c2, force_1);
        };
        $[2] = resolverUrl;
        $[3] = t2;
    } else t2 = $[3];
    const getDatasourceData = t2;
    let t3;
    if ($[4] !== resolverUrl) {
        t3 = async (data_3, t4)=>{
            const force_2 = t4 === undefined ? false : t4;
            const resolvedCacheIdKey = "datasourceId" in data_3 ? data_3.datasourceId : data_3.integrationKey;
            if (!resolvedCacheIdKey) throw new Error("No target was supplied to retrieve actions for");
            return cachedRequest(resolvedCacheIdKey, data_3, `${resolverUrl}/actions`, $adf5b0efff0513f5$export$15cd58682efec5a5, force_2);
        };
        $[4] = resolverUrl;
        $[5] = t3;
    } else t3 = $[5];
    const getDatasourceActionsAndPermissions = t3;
    let t4;
    if ($[6] !== resolverUrl) {
        t4 = async (data_4)=>uncachedRequest(data_4, `${resolverUrl}/actions/execute`);
        $[6] = resolverUrl;
        $[7] = t4;
    } else t4 = $[7];
    const executeAtomicAction = t4;
    const invalidateDatasourceDataCacheByAri = $adf5b0efff0513f5$var$_temp3;
    let t5;
    if ($[8] !== executeAtomicAction || $[9] !== getDatasourceActionsAndPermissions || $[10] !== getDatasourceData || $[11] !== getDatasourceDetails) {
        t5 = {
            getDatasourceDetails: getDatasourceDetails,
            getDatasourceData: getDatasourceData,
            getDatasourceActionsAndPermissions: getDatasourceActionsAndPermissions,
            executeAtomicAction: executeAtomicAction,
            invalidateDatasourceDataCacheByAri: invalidateDatasourceDataCacheByAri
        };
        $[8] = executeAtomicAction;
        $[9] = getDatasourceActionsAndPermissions;
        $[10] = getDatasourceData;
        $[11] = getDatasourceDetails;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ()=>{
    const { connections: { client: client } } = (0, $cMyWi.useSmartLinkContext)();
    const resolverUrl = (0, $c7dFC.useResolverUrl)(client);
    const cachedRequest = async (cacheKeyId, data, url, lruMap, force)=>{
        const cacheKeyData = {
            ...data,
            // Sort fields to use cached version of response regardless of the order
            ...'fields' in data ? {
                fields: [
                    ...data.fields || []
                ].sort()
            } : {},
            ...'fieldKeys' in data ? {
                fieldKeys: [
                    ...data.fieldKeys || []
                ].sort()
            } : {}
        };
        const cacheKey = JSON.stringify({
            cacheKeyId: cacheKeyId,
            cacheKeyData: cacheKeyData
        });
        if (force) lruMap.delete(cacheKey);
        let responsePromise = lruMap.get(cacheKey);
        if (responsePromise) return responsePromise;
        const headers = {
            /**
       * This header exists to enable the backend to process relative time, eg: "today", with respect to user timezone.
       * eg: used in "confluence-object-provider" to process confluence SLLV requests to filter data for relative time.
       */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone
        };
        try {
            responsePromise = (0, $j39Hd.request)('post', url, data, headers, [
                200,
                201,
                202,
                203,
                204
            ]);
            lruMap.set(cacheKey, responsePromise);
            return await responsePromise;
        } catch (e) {
            lruMap.delete(cacheKey);
            throw e;
        }
    };
    const uncachedRequest = async (data_0, url_0)=>{
        const responsePromise_0 = (0, $j39Hd.request)('post', url_0, data_0, undefined, [
            200,
            201,
            202,
            203,
            204
        ]);
        return responsePromise_0;
    };
    const getDatasourceDetails = (0, $cozmU.useCallback)(async (datasourceId, data_1, force_0 = false)=>cachedRequest(datasourceId, data_1, `${resolverUrl}/datasource/${datasourceId}/fetch/details`, $adf5b0efff0513f5$export$f82fcd766a8daa7f, force_0), [
        resolverUrl
    ]);
    const getDatasourceData = (0, $cozmU.useCallback)(async (datasourceId_0, data_2, force_1 = false)=>cachedRequest(datasourceId_0, data_2, `${resolverUrl}/datasource/${datasourceId_0}/fetch/data`, $adf5b0efff0513f5$export$40b1dd31340bd5c2, force_1), [
        resolverUrl
    ]);
    const getDatasourceActionsAndPermissions = (0, $cozmU.useCallback)(async (data_3, force_2 = false)=>{
        const resolvedCacheIdKey = 'datasourceId' in data_3 ? data_3.datasourceId : data_3.integrationKey;
        // This is just to prevent empty string being passed up to ORS and causing issues.
        if (!resolvedCacheIdKey) throw new Error('No target was supplied to retrieve actions for');
        return cachedRequest(resolvedCacheIdKey, data_3, `${resolverUrl}/actions`, $adf5b0efff0513f5$export$15cd58682efec5a5, force_2);
    }, [
        resolverUrl
    ]);
    const executeAtomicAction = (0, $cozmU.useCallback)(async (data_4)=>uncachedRequest(data_4, `${resolverUrl}/actions/execute`), [
        resolverUrl
    ]);
    const invalidateDatasourceDataCacheByAri = (0, $cozmU.useCallback)((ari)=>{
        $adf5b0efff0513f5$export$40b1dd31340bd5c2.forEach(async (value, key)=>{
            const response = await value;
            const targetFound = response.data.items.some((item)=>{
                return item['ari']?.data === ari;
            });
            if (targetFound) $adf5b0efff0513f5$export$40b1dd31340bd5c2.delete(key);
        });
    }, []);
    return (0, $cozmU.useMemo)(()=>({
            getDatasourceDetails: getDatasourceDetails,
            getDatasourceData: getDatasourceData,
            getDatasourceActionsAndPermissions: getDatasourceActionsAndPermissions,
            executeAtomicAction: executeAtomicAction,
            invalidateDatasourceDataCacheByAri: invalidateDatasourceDataCacheByAri
        }), [
        getDatasourceDetails,
        getDatasourceData,
        getDatasourceActionsAndPermissions,
        executeAtomicAction,
        invalidateDatasourceDataCacheByAri
    ]);
};
async function $adf5b0efff0513f5$var$_temp(cacheKeyId, data, url, lruMap, force) {
    const cacheKeyData = {
        ...data,
        ..."fields" in data ? {
            fields: [
                ...data.fields || []
            ].sort()
        } : {},
        ..."fieldKeys" in data ? {
            fieldKeys: [
                ...data.fieldKeys || []
            ].sort()
        } : {}
    };
    const cacheKey = JSON.stringify({
        cacheKeyId: cacheKeyId,
        cacheKeyData: cacheKeyData
    });
    if (force) lruMap.delete(cacheKey);
    let responsePromise = lruMap.get(cacheKey);
    if (responsePromise) return responsePromise;
    const headers = {
        "origin-timezone": Intl?.DateTimeFormat().resolvedOptions().timeZone
    };
    try {
        responsePromise = (0, $j39Hd.request)("post", url, data, headers, [
            200,
            201,
            202,
            203,
            204
        ]);
        lruMap.set(cacheKey, responsePromise);
        return await responsePromise;
    } catch (t0) {
        const e = t0;
        lruMap.delete(cacheKey);
        throw e;
    }
}
async function $adf5b0efff0513f5$var$_temp2(data_0, url_0) {
    const responsePromise_0 = (0, $j39Hd.request)("post", url_0, data_0, undefined, [
        200,
        201,
        202,
        203,
        204
    ]);
    return responsePromise_0;
}
function $adf5b0efff0513f5$var$_temp3(ari) {
    $adf5b0efff0513f5$export$40b1dd31340bd5c2.forEach(async (value, key)=>{
        const response = await value;
        const targetFound = response.data.items.some((item)=>item.ari?.data === ari);
        if (targetFound) $adf5b0efff0513f5$export$40b1dd31340bd5c2.delete(key);
    });
}
module.exports["DEFAULT_GET_DATASOURCE_DATA_PAGE_SIZE"] = $adf5b0efff0513f5$export$5e074c0b68e2ce03;
module.exports["useDatasourceClientExtension"] = $adf5b0efff0513f5$export$7d812bb756889442;

});

parcelRegister("gbf0M", function(module, exports) {
const $5ba4766046c2d106$export$1de3504963fc32f2 = (datasource, url)=>{
    return {
        type: 'blockCard',
        attrs: {
            url: url,
            datasource: datasource
        }
    };
};
module.exports["buildDatasourceAdf"] = $5ba4766046c2d106$export$1de3504963fc32f2;

});

parcelRegister("aqP4n", function(module, exports) {
const $03a217ae6d97834d$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $03a217ae6d97834d$var$uniqueKey = Symbol('closestEdge');
function $03a217ae6d97834d$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $03a217ae6d97834d$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$03a217ae6d97834d$var$uniqueKey]: addClosestEdge
    };
}
function $03a217ae6d97834d$export$945a571f3b658bf(userData) {
    return userData[$03a217ae6d97834d$var$uniqueKey] ?? null;
}
module.exports["attachClosestEdge"] = $03a217ae6d97834d$export$f0cafff222395e89;
module.exports["extractClosestEdge"] = $03a217ae6d97834d$export$945a571f3b658bf;

});

parcelRegister("iN08H", function(module, exports) {
$parcel$export(module.exports, "disableNativeDragPreview", () => (parcelRequire("cIWiw")).disableNativeDragPreview);

var $cIWiw = parcelRequire("cIWiw");


});

parcelRegister("cIWiw", function(module, exports) {
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $8d2daf016c36a388$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $8d2daf016c36a388$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $8d2daf016c36a388$var$tinyTransparentImage) nativeSetDragImage($8d2daf016c36a388$var$tinyTransparentImage, 0, 0);
}
module.exports["disableNativeDragPreview"] = $8d2daf016c36a388$export$c588cb30ff3b876e;

});

parcelRegister("aLPNu", function(module, exports) {
$parcel$export(module.exports, "preventUnhandled", () => (parcelRequire("fGXGw")).preventUnhandled);

var $fGXGw = parcelRequire("fGXGw");


});

parcelRegister("fGXGw", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");


var $bl5yp = parcelRequire("bl5yp");

function $3ba3c538e2294e67$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $3ba3c538e2294e67$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $3ba3c538e2294e67$var$start() {
    $3ba3c538e2294e67$var$cleanup();
    $3ba3c538e2294e67$var$unbindEvents = (0, $cbY7C.bindAll)(window, [
        {
            type: 'dragover',
            listener: $3ba3c538e2294e67$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $3ba3c538e2294e67$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $3ba3c538e2294e67$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $3ba3c538e2294e67$var$cleanup
        },
        ...(0, $bl5yp.getBindingsForBrokenDrags)({
            onDragEnd: $3ba3c538e2294e67$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $3ba3c538e2294e67$var$cleanup() {
    $3ba3c538e2294e67$var$unbindEvents?.();
    $3ba3c538e2294e67$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $3ba3c538e2294e67$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $3ba3c538e2294e67$var$cleanup();
}
const $3ba3c538e2294e67$export$453c0582481cc59d = {
    start: $3ba3c538e2294e67$var$start,
    stop: $3ba3c538e2294e67$var$stop
};
module.exports["preventUnhandled"] = $3ba3c538e2294e67$export$453c0582481cc59d;

});

parcelRegister("nsx26", function(module, exports) {
$parcel$export(module.exports, "default", () => $046847ea799ac561$export$2e2bcd8739ae039);

var $zxlpF = parcelRequire("zxlpF");


var $3yGK6 = parcelRequire("3yGK6");

function $046847ea799ac561$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeftStartOfDay = (0, $zxlpF.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $zxlpF.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

});

parcelRegister("bwuOg", function(module, exports) {
const $74d2fe053a191110$export$85183a312807388d = 'media';
const $74d2fe053a191110$export$60efea3f80310017 = 'wide';
module.exports["ANALYTICS_CHANNEL"] = $74d2fe053a191110$export$85183a312807388d;
module.exports["DATASOURCE_DEFAULT_LAYOUT"] = $74d2fe053a191110$export$60efea3f80310017;

});

parcelRegister("9Rq82", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $1P2f3 = parcelRequire("1P2f3");

'use strict';
function $72dd54e799957753$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $72dd54e799957753$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $72dd54e799957753$var$_typeof(o);
}
function $72dd54e799957753$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $72dd54e799957753$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $72dd54e799957753$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $72dd54e799957753$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $72dd54e799957753$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $72dd54e799957753$var$_toPropertyKey(arg) {
    var key = $72dd54e799957753$var$_toPrimitive(arg, "string");
    return $72dd54e799957753$var$_typeof(key) === "symbol" ? key : String(key);
}
function $72dd54e799957753$var$_toPrimitive(input, hint) {
    if ($72dd54e799957753$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($72dd54e799957753$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $72dd54e799957753$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $9VDwT = parcelRequire("9VDwT");

var $72dd54e799957753$var$_require$codes = $9VDwT.codes, $72dd54e799957753$var$ERR_AMBIGUOUS_ARGUMENT = $72dd54e799957753$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $72dd54e799957753$var$ERR_INVALID_ARG_TYPE = $72dd54e799957753$var$_require$codes.ERR_INVALID_ARG_TYPE, $72dd54e799957753$var$ERR_INVALID_ARG_VALUE = $72dd54e799957753$var$_require$codes.ERR_INVALID_ARG_VALUE, $72dd54e799957753$var$ERR_INVALID_RETURN_VALUE = $72dd54e799957753$var$_require$codes.ERR_INVALID_RETURN_VALUE, $72dd54e799957753$var$ERR_MISSING_ARGS = $72dd54e799957753$var$_require$codes.ERR_MISSING_ARGS;

var $9OEKu = parcelRequire("9OEKu");


var $7T2Y0 = parcelRequire("7T2Y0");

var $72dd54e799957753$var$inspect = $7T2Y0.inspect;



var $72dd54e799957753$require$_require$types = $7T2Y0.types;
var $72dd54e799957753$var$isPromise = $72dd54e799957753$require$_require$types.isPromise, $72dd54e799957753$var$isRegExp = $72dd54e799957753$require$_require$types.isRegExp;

var $72dd54e799957753$var$objectAssign = (parcelRequire("fnK1J"))();

var $72dd54e799957753$var$objectIs = (parcelRequire("aKQxr"))();

var $72dd54e799957753$var$RegExpPrototypeTest = (parcelRequire("2BPyg"))('RegExp.prototype.test');
var $72dd54e799957753$var$errorCache = new Map();
var $72dd54e799957753$var$isDeepEqual;
var $72dd54e799957753$var$isDeepStrictEqual;
var $72dd54e799957753$var$parseExpressionAt;
var $72dd54e799957753$var$findNodeAround;
var $72dd54e799957753$var$decoder;

function $72dd54e799957753$var$lazyLoadComparison() {
    var comparison = (parcelRequire("ilKc6"));
    $72dd54e799957753$var$isDeepEqual = comparison.isDeepEqual;
    $72dd54e799957753$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $72dd54e799957753$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $72dd54e799957753$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    '\\b',
    '',
    '',
    "\\u000b",
    '\\f',
    '',
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $72dd54e799957753$var$escapeFn = function escapeFn(str) {
    return $72dd54e799957753$var$meta[str.charCodeAt(0)];
};
var $72dd54e799957753$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $72dd54e799957753$var$assert = module.exports = $72dd54e799957753$var$ok;
var $72dd54e799957753$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $72dd54e799957753$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $9OEKu(obj);
}
function $72dd54e799957753$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = 'Failed';
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($72dd54e799957753$var$warned === false) {
            $72dd54e799957753$var$warned = true;
            var warn = $1P2f3.emitWarning ? $1P2f3.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
        }
        if (argsLen === 2) operator = '!=';
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? 'fail' : operator,
        stackStartFn: stackStartFn || $72dd54e799957753$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $9OEKu(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$72dd54e799957753$var$assert.fail = $72dd54e799957753$var$fail;
// The AssertionError is defined in internal/error.
$72dd54e799957753$var$assert.AssertionError = $9OEKu;
function $72dd54e799957753$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = 'No value argument passed to `assert.ok()`';
        } else if (message instanceof Error) throw message;
        var err = new $9OEKu({
            actual: value,
            expected: true,
            message: message,
            operator: '==',
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $72dd54e799957753$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $72dd54e799957753$var$innerOk.apply(void 0, [
        $72dd54e799957753$var$ok,
        args.length
    ].concat(args));
}
$72dd54e799957753$var$assert.ok = $72dd54e799957753$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $72dd54e799957753$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $72dd54e799957753$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $72dd54e799957753$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '==',
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$72dd54e799957753$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $72dd54e799957753$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $72dd54e799957753$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '!=',
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$72dd54e799957753$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $72dd54e799957753$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($72dd54e799957753$var$isDeepEqual === undefined) $72dd54e799957753$var$lazyLoadComparison();
    if (!$72dd54e799957753$var$isDeepEqual(actual, expected)) $72dd54e799957753$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepEqual',
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$72dd54e799957753$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $72dd54e799957753$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($72dd54e799957753$var$isDeepEqual === undefined) $72dd54e799957753$var$lazyLoadComparison();
    if ($72dd54e799957753$var$isDeepEqual(actual, expected)) $72dd54e799957753$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepEqual',
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $72dd54e799957753$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $72dd54e799957753$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($72dd54e799957753$var$isDeepEqual === undefined) $72dd54e799957753$var$lazyLoadComparison();
    if (!$72dd54e799957753$var$isDeepStrictEqual(actual, expected)) $72dd54e799957753$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepStrictEqual',
        stackStartFn: deepStrictEqual
    });
};
$72dd54e799957753$var$assert.notDeepStrictEqual = $72dd54e799957753$var$notDeepStrictEqual;
function $72dd54e799957753$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $72dd54e799957753$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($72dd54e799957753$var$isDeepEqual === undefined) $72dd54e799957753$var$lazyLoadComparison();
    if ($72dd54e799957753$var$isDeepStrictEqual(actual, expected)) $72dd54e799957753$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepStrictEqual',
        stackStartFn: $72dd54e799957753$var$notDeepStrictEqual
    });
}
$72dd54e799957753$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $72dd54e799957753$var$ERR_MISSING_ARGS('actual', 'expected');
    if (!$72dd54e799957753$var$objectIs(actual, expected)) $72dd54e799957753$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'strictEqual',
        stackStartFn: strictEqual
    });
};
$72dd54e799957753$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $72dd54e799957753$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($72dd54e799957753$var$objectIs(actual, expected)) $72dd54e799957753$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notStrictEqual',
        stackStartFn: notStrictEqual
    });
};
var $72dd54e799957753$var$Comparison = /*#__PURE__*/ $72dd54e799957753$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $72dd54e799957753$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === 'string' && $72dd54e799957753$var$isRegExp(obj[key]) && $72dd54e799957753$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $72dd54e799957753$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$72dd54e799957753$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $72dd54e799957753$var$Comparison(actual, keys);
            var b = new $72dd54e799957753$var$Comparison(expected, keys, actual);
            var err = new $9OEKu({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $72dd54e799957753$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $72dd54e799957753$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== 'function') {
        if ($72dd54e799957753$var$isRegExp(expected)) return $72dd54e799957753$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $72dd54e799957753$var$ERR_INVALID_ARG_TYPE('expected', [
            'Function',
            'RegExp'
        ], expected);
        // Handle primitives properly.
        if ($72dd54e799957753$var$_typeof(actual) !== 'object' || actual === null) {
            var err = new $9OEKu({
                actual: actual,
                expected: expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push('name', 'message');
        else if (keys.length === 0) throw new $72dd54e799957753$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
        if ($72dd54e799957753$var$isDeepEqual === undefined) $72dd54e799957753$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === 'string' && $72dd54e799957753$var$isRegExp(expected[key]) && $72dd54e799957753$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $72dd54e799957753$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $72dd54e799957753$var$getActual(fn) {
    if (typeof fn !== 'function') throw new $72dd54e799957753$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $72dd54e799957753$var$NO_EXCEPTION_SENTINEL;
}
function $72dd54e799957753$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $72dd54e799957753$var$isPromise(obj) || obj !== null && $72dd54e799957753$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function $72dd54e799957753$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === 'function') {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$72dd54e799957753$var$checkIsPromise(resultPromise)) throw new $72dd54e799957753$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
        } else if ($72dd54e799957753$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $72dd54e799957753$var$ERR_INVALID_ARG_TYPE('promiseFn', [
            'Function',
            'Promise'
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $72dd54e799957753$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $72dd54e799957753$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === 'string') {
        if (arguments.length === 4) throw new $72dd54e799957753$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if ($72dd54e799957753$var$_typeof(actual) === 'object' && actual !== null) {
            if (actual.message === error) throw new $72dd54e799957753$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
        } else if (actual === error) throw new $72dd54e799957753$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
        message = error;
        error = undefined;
    } else if (error != null && $72dd54e799957753$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $72dd54e799957753$var$ERR_INVALID_ARG_TYPE('error', [
        'Object',
        'Error',
        'Function',
        'RegExp'
    ], error);
    if (actual === $72dd54e799957753$var$NO_EXCEPTION_SENTINEL) {
        var details = '';
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
        $72dd54e799957753$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$72dd54e799957753$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $72dd54e799957753$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $72dd54e799957753$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === 'string') {
        message = error;
        error = undefined;
    }
    if (!error || $72dd54e799957753$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
        $72dd54e799957753$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$72dd54e799957753$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $72dd54e799957753$var$expectsError.apply(void 0, [
        throws,
        $72dd54e799957753$var$getActual(promiseFn)
    ].concat(args));
};
$72dd54e799957753$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $72dd54e799957753$var$waitForActual(promiseFn).then(function(result) {
        return $72dd54e799957753$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$72dd54e799957753$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $72dd54e799957753$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $72dd54e799957753$var$getActual(fn)
    ].concat(args));
};
$72dd54e799957753$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $72dd54e799957753$var$waitForActual(fn).then(function(result) {
        return $72dd54e799957753$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$72dd54e799957753$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = 'ifError got unwanted exception: ';
        if ($72dd54e799957753$var$_typeof(err) === 'object' && typeof err.message === 'string') {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $72dd54e799957753$var$inspect(err);
        var newErr = new $9OEKu({
            actual: err,
            expected: null,
            operator: 'ifError',
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === 'string') {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split('\n');
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split('\n');
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $72dd54e799957753$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$72dd54e799957753$var$isRegExp(regexp)) throw new $72dd54e799957753$var$ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
    var match = fnName === 'match';
    if (typeof string !== 'string' || $72dd54e799957753$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat($72dd54e799957753$var$_typeof(string), " (").concat($72dd54e799957753$var$inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat($72dd54e799957753$var$inspect(regexp), ". Input:\n\n").concat($72dd54e799957753$var$inspect(string), "\n"));
        var err = new $9OEKu({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$72dd54e799957753$var$assert.match = function match(string, regexp, message) {
    $72dd54e799957753$var$internalMatch(string, regexp, message, match, 'match');
};
$72dd54e799957753$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $72dd54e799957753$var$internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
};
// Expose a strict only variant of assert
function $72dd54e799957753$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $72dd54e799957753$var$innerOk.apply(void 0, [
        $72dd54e799957753$var$strict,
        args.length
    ].concat(args));
}
$72dd54e799957753$var$assert.strict = $72dd54e799957753$var$objectAssign($72dd54e799957753$var$strict, $72dd54e799957753$var$assert, {
    equal: $72dd54e799957753$var$assert.strictEqual,
    deepEqual: $72dd54e799957753$var$assert.deepStrictEqual,
    notEqual: $72dd54e799957753$var$assert.notStrictEqual,
    notDeepEqual: $72dd54e799957753$var$assert.notDeepStrictEqual
});
$72dd54e799957753$var$assert.strict.strict = $72dd54e799957753$var$assert.strict;

});

parcelRegister("9VDwT", function(module, exports) {
$parcel$export(module.exports, "codes", () => $73a819a63e892b7f$export$e45cb6485273080e, (v) => $73a819a63e892b7f$export$e45cb6485273080e = v);
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $73a819a63e892b7f$export$e45cb6485273080e;
'use strict';
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $73a819a63e892b7f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $73a819a63e892b7f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $73a819a63e892b7f$var$_typeof(o);
}
function $73a819a63e892b7f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $73a819a63e892b7f$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $73a819a63e892b7f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $73a819a63e892b7f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $73a819a63e892b7f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $73a819a63e892b7f$var$_toPropertyKey(arg) {
    var key = $73a819a63e892b7f$var$_toPrimitive(arg, "string");
    return $73a819a63e892b7f$var$_typeof(key) === "symbol" ? key : String(key);
}
function $73a819a63e892b7f$var$_toPrimitive(input, hint) {
    if ($73a819a63e892b7f$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($73a819a63e892b7f$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $73a819a63e892b7f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $73a819a63e892b7f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $73a819a63e892b7f$var$_setPrototypeOf(subClass, superClass);
}
function $73a819a63e892b7f$var$_setPrototypeOf(o, p) {
    $73a819a63e892b7f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $73a819a63e892b7f$var$_setPrototypeOf(o, p);
}
function $73a819a63e892b7f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $73a819a63e892b7f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $73a819a63e892b7f$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $73a819a63e892b7f$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $73a819a63e892b7f$var$_possibleConstructorReturn(this, result);
    };
}
function $73a819a63e892b7f$var$_possibleConstructorReturn(self, call) {
    if (call && ($73a819a63e892b7f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $73a819a63e892b7f$var$_assertThisInitialized(self);
}
function $73a819a63e892b7f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $73a819a63e892b7f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $73a819a63e892b7f$var$_getPrototypeOf(o) {
    $73a819a63e892b7f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $73a819a63e892b7f$var$_getPrototypeOf(o);
}
var $73a819a63e892b7f$var$codes = {};
// Lazy loaded
var $73a819a63e892b7f$var$assert;
var $73a819a63e892b7f$var$util;
function $73a819a63e892b7f$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $73a819a63e892b7f$var$_inherits(NodeError, _Base);
        var _super = $73a819a63e892b7f$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $73a819a63e892b7f$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $73a819a63e892b7f$var$_createClass(NodeError);
    }(Base);
    $73a819a63e892b7f$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $73a819a63e892b7f$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $73a819a63e892b7f$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $73a819a63e892b7f$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $73a819a63e892b7f$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$73a819a63e892b7f$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);

$73a819a63e892b7f$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    if ($73a819a63e892b7f$var$assert === undefined) $73a819a63e892b7f$var$assert = (parcelRequire("9Rq82"));
    $73a819a63e892b7f$var$assert(typeof name === 'string', "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $73a819a63e892b7f$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($73a819a63e892b7f$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($73a819a63e892b7f$var$oneOf(expected, 'type'));
    else {
        var type = $73a819a63e892b7f$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($73a819a63e892b7f$var$oneOf(expected, 'type'));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($73a819a63e892b7f$var$_typeof(actual));
    return msg;
}, TypeError);

$73a819a63e892b7f$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
    if ($73a819a63e892b7f$var$util === undefined) $73a819a63e892b7f$var$util = (parcelRequire("7T2Y0"));
    var inspected = $73a819a63e892b7f$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$73a819a63e892b7f$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($73a819a63e892b7f$var$_typeof(value));
    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);

$73a819a63e892b7f$var$createErrorType('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($73a819a63e892b7f$var$assert === undefined) $73a819a63e892b7f$var$assert = (parcelRequire("9Rq82"));
    $73a819a63e892b7f$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg = 'The ';
    var len = args.length;
    args = args.map(function(a) {
        return "\"".concat(a, "\"");
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(', ');
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$73a819a63e892b7f$export$e45cb6485273080e = $73a819a63e892b7f$var$codes;

});

parcelRegister("7T2Y0", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $1P2f3 = parcelRequire("1P2f3");

var $5bdff89be3748b6d$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $5bdff89be3748b6d$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$5bdff89be3748b6d$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($5bdff89be3748b6d$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($5bdff89be3748b6d$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($5bdff89be3748b6d$var$isNull(x) || !$5bdff89be3748b6d$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $5bdff89be3748b6d$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $1P2f3 !== 'undefined' && $1P2f3.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $1P2f3 === 'undefined') return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($1P2f3.throwDeprecation) throw new Error(msg);
            else if ($1P2f3.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $5bdff89be3748b6d$var$debugs = {};
var $5bdff89be3748b6d$var$debugEnvRegex = /^$/;
var $5bdff89be3748b6d$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$5bdff89be3748b6d$var$debugs[set]) {
        if ($5bdff89be3748b6d$var$debugEnvRegex.test(set)) {
            var pid = $1P2f3.pid;
            $5bdff89be3748b6d$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $5bdff89be3748b6d$var$debugs[set] = function() {};
    }
    return $5bdff89be3748b6d$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $5bdff89be3748b6d$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $5bdff89be3748b6d$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($5bdff89be3748b6d$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($5bdff89be3748b6d$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($5bdff89be3748b6d$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($5bdff89be3748b6d$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($5bdff89be3748b6d$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $5bdff89be3748b6d$var$stylizeWithColor;
    return $5bdff89be3748b6d$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $5bdff89be3748b6d$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$5bdff89be3748b6d$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$5bdff89be3748b6d$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $5bdff89be3748b6d$var$stylizeWithColor(str, styleType) {
    var style = $5bdff89be3748b6d$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $5bdff89be3748b6d$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $5bdff89be3748b6d$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $5bdff89be3748b6d$var$stylizeNoColor(str, styleType) {
    return str;
}
function $5bdff89be3748b6d$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $5bdff89be3748b6d$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $5bdff89be3748b6d$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$5bdff89be3748b6d$var$isString(ret)) ret = $5bdff89be3748b6d$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $5bdff89be3748b6d$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $5bdff89be3748b6d$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($5bdff89be3748b6d$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $5bdff89be3748b6d$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($5bdff89be3748b6d$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($5bdff89be3748b6d$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($5bdff89be3748b6d$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($5bdff89be3748b6d$var$isError(value)) return $5bdff89be3748b6d$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($5bdff89be3748b6d$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($5bdff89be3748b6d$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($5bdff89be3748b6d$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($5bdff89be3748b6d$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($5bdff89be3748b6d$var$isError(value)) base = ' ' + $5bdff89be3748b6d$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($5bdff89be3748b6d$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $5bdff89be3748b6d$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $5bdff89be3748b6d$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $5bdff89be3748b6d$var$reduceToSingleString(output, base, braces);
}
function $5bdff89be3748b6d$var$formatPrimitive(ctx, value) {
    if ($5bdff89be3748b6d$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($5bdff89be3748b6d$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($5bdff89be3748b6d$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($5bdff89be3748b6d$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($5bdff89be3748b6d$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $5bdff89be3748b6d$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $5bdff89be3748b6d$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($5bdff89be3748b6d$var$hasOwnProperty(value, String(i))) output.push($5bdff89be3748b6d$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($5bdff89be3748b6d$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $5bdff89be3748b6d$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$5bdff89be3748b6d$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($5bdff89be3748b6d$var$isNull(recurseTimes)) str = $5bdff89be3748b6d$var$formatValue(ctx, desc.value, null);
            else str = $5bdff89be3748b6d$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($5bdff89be3748b6d$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $5bdff89be3748b6d$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("3xAFV"));
function $5bdff89be3748b6d$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $5bdff89be3748b6d$var$isArray;
function $5bdff89be3748b6d$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $5bdff89be3748b6d$var$isBoolean;
function $5bdff89be3748b6d$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $5bdff89be3748b6d$var$isNull;
function $5bdff89be3748b6d$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $5bdff89be3748b6d$var$isNullOrUndefined;
function $5bdff89be3748b6d$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $5bdff89be3748b6d$var$isNumber;
function $5bdff89be3748b6d$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $5bdff89be3748b6d$var$isString;
function $5bdff89be3748b6d$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $5bdff89be3748b6d$var$isSymbol;
function $5bdff89be3748b6d$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $5bdff89be3748b6d$var$isUndefined;
function $5bdff89be3748b6d$var$isRegExp(re) {
    return $5bdff89be3748b6d$var$isObject(re) && $5bdff89be3748b6d$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $5bdff89be3748b6d$var$isRegExp;
module.exports.types.isRegExp = $5bdff89be3748b6d$var$isRegExp;
function $5bdff89be3748b6d$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $5bdff89be3748b6d$var$isObject;
function $5bdff89be3748b6d$var$isDate(d) {
    return $5bdff89be3748b6d$var$isObject(d) && $5bdff89be3748b6d$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $5bdff89be3748b6d$var$isDate;
module.exports.types.isDate = $5bdff89be3748b6d$var$isDate;
function $5bdff89be3748b6d$var$isError(e) {
    return $5bdff89be3748b6d$var$isObject(e) && ($5bdff89be3748b6d$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $5bdff89be3748b6d$var$isError;
module.exports.types.isNativeError = $5bdff89be3748b6d$var$isError;
function $5bdff89be3748b6d$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $5bdff89be3748b6d$var$isFunction;
function $5bdff89be3748b6d$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $5bdff89be3748b6d$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("hUXoN"));
function $5bdff89be3748b6d$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $5bdff89be3748b6d$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $5bdff89be3748b6d$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $5bdff89be3748b6d$var$timestamp() {
    var d = new Date();
    var time = [
        $5bdff89be3748b6d$var$pad(d.getHours()),
        $5bdff89be3748b6d$var$pad(d.getMinutes()),
        $5bdff89be3748b6d$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $5bdff89be3748b6d$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $5bdff89be3748b6d$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("iuv32"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$5bdff89be3748b6d$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $5bdff89be3748b6d$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $5bdff89be3748b6d$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($5bdff89be3748b6d$var$kCustomPromisifiedSymbol && original[$5bdff89be3748b6d$var$kCustomPromisifiedSymbol]) {
        var fn = original[$5bdff89be3748b6d$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $5bdff89be3748b6d$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($5bdff89be3748b6d$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $5bdff89be3748b6d$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $5bdff89be3748b6d$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $5bdff89be3748b6d$var$kCustomPromisifiedSymbol;
function $5bdff89be3748b6d$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $5bdff89be3748b6d$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $1P2f3.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $1P2f3.nextTick($5bdff89be3748b6d$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $5bdff89be3748b6d$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $5bdff89be3748b6d$var$callbackify;

});

parcelRegister("3xAFV", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $2Xb4T = parcelRequire("2Xb4T");


var $6TAnP = parcelRequire("6TAnP");


var $go4T7 = parcelRequire("go4T7");


var $5RMvC = parcelRequire("5RMvC");

function $2940e712aca02fa7$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $2940e712aca02fa7$var$BigIntSupported = typeof BigInt !== 'undefined';
var $2940e712aca02fa7$var$SymbolSupported = typeof Symbol !== 'undefined';
var $2940e712aca02fa7$var$ObjectToString = $2940e712aca02fa7$var$uncurryThis(Object.prototype.toString);
var $2940e712aca02fa7$var$numberValue = $2940e712aca02fa7$var$uncurryThis(Number.prototype.valueOf);
var $2940e712aca02fa7$var$stringValue = $2940e712aca02fa7$var$uncurryThis(String.prototype.valueOf);
var $2940e712aca02fa7$var$booleanValue = $2940e712aca02fa7$var$uncurryThis(Boolean.prototype.valueOf);
if ($2940e712aca02fa7$var$BigIntSupported) var $2940e712aca02fa7$var$bigIntValue = $2940e712aca02fa7$var$uncurryThis(BigInt.prototype.valueOf);
if ($2940e712aca02fa7$var$SymbolSupported) var $2940e712aca02fa7$var$symbolValue = $2940e712aca02fa7$var$uncurryThis(Symbol.prototype.valueOf);
function $2940e712aca02fa7$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $2Xb4T;
module.exports.isGeneratorFunction = $6TAnP;
module.exports.isTypedArray = $5RMvC;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $2940e712aca02fa7$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $2940e712aca02fa7$var$isPromise;
function $2940e712aca02fa7$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $5RMvC(value) || $2940e712aca02fa7$var$isDataView(value);
}
module.exports.isArrayBufferView = $2940e712aca02fa7$var$isArrayBufferView;
function $2940e712aca02fa7$var$isUint8Array(value) {
    return $go4T7(value) === 'Uint8Array';
}
module.exports.isUint8Array = $2940e712aca02fa7$var$isUint8Array;
function $2940e712aca02fa7$var$isUint8ClampedArray(value) {
    return $go4T7(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $2940e712aca02fa7$var$isUint8ClampedArray;
function $2940e712aca02fa7$var$isUint16Array(value) {
    return $go4T7(value) === 'Uint16Array';
}
module.exports.isUint16Array = $2940e712aca02fa7$var$isUint16Array;
function $2940e712aca02fa7$var$isUint32Array(value) {
    return $go4T7(value) === 'Uint32Array';
}
module.exports.isUint32Array = $2940e712aca02fa7$var$isUint32Array;
function $2940e712aca02fa7$var$isInt8Array(value) {
    return $go4T7(value) === 'Int8Array';
}
module.exports.isInt8Array = $2940e712aca02fa7$var$isInt8Array;
function $2940e712aca02fa7$var$isInt16Array(value) {
    return $go4T7(value) === 'Int16Array';
}
module.exports.isInt16Array = $2940e712aca02fa7$var$isInt16Array;
function $2940e712aca02fa7$var$isInt32Array(value) {
    return $go4T7(value) === 'Int32Array';
}
module.exports.isInt32Array = $2940e712aca02fa7$var$isInt32Array;
function $2940e712aca02fa7$var$isFloat32Array(value) {
    return $go4T7(value) === 'Float32Array';
}
module.exports.isFloat32Array = $2940e712aca02fa7$var$isFloat32Array;
function $2940e712aca02fa7$var$isFloat64Array(value) {
    return $go4T7(value) === 'Float64Array';
}
module.exports.isFloat64Array = $2940e712aca02fa7$var$isFloat64Array;
function $2940e712aca02fa7$var$isBigInt64Array(value) {
    return $go4T7(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $2940e712aca02fa7$var$isBigInt64Array;
function $2940e712aca02fa7$var$isBigUint64Array(value) {
    return $go4T7(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $2940e712aca02fa7$var$isBigUint64Array;
function $2940e712aca02fa7$var$isMapToString(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object Map]';
}
$2940e712aca02fa7$var$isMapToString.working = typeof Map !== 'undefined' && $2940e712aca02fa7$var$isMapToString(new Map());
function $2940e712aca02fa7$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $2940e712aca02fa7$var$isMapToString.working ? $2940e712aca02fa7$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $2940e712aca02fa7$var$isMap;
function $2940e712aca02fa7$var$isSetToString(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object Set]';
}
$2940e712aca02fa7$var$isSetToString.working = typeof Set !== 'undefined' && $2940e712aca02fa7$var$isSetToString(new Set());
function $2940e712aca02fa7$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $2940e712aca02fa7$var$isSetToString.working ? $2940e712aca02fa7$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $2940e712aca02fa7$var$isSet;
function $2940e712aca02fa7$var$isWeakMapToString(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object WeakMap]';
}
$2940e712aca02fa7$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $2940e712aca02fa7$var$isWeakMapToString(new WeakMap());
function $2940e712aca02fa7$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $2940e712aca02fa7$var$isWeakMapToString.working ? $2940e712aca02fa7$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $2940e712aca02fa7$var$isWeakMap;
function $2940e712aca02fa7$var$isWeakSetToString(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object WeakSet]';
}
$2940e712aca02fa7$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $2940e712aca02fa7$var$isWeakSetToString(new WeakSet());
function $2940e712aca02fa7$var$isWeakSet(value) {
    return $2940e712aca02fa7$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $2940e712aca02fa7$var$isWeakSet;
function $2940e712aca02fa7$var$isArrayBufferToString(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$2940e712aca02fa7$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $2940e712aca02fa7$var$isArrayBufferToString(new ArrayBuffer());
function $2940e712aca02fa7$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $2940e712aca02fa7$var$isArrayBufferToString.working ? $2940e712aca02fa7$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $2940e712aca02fa7$var$isArrayBuffer;
function $2940e712aca02fa7$var$isDataViewToString(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object DataView]';
}
$2940e712aca02fa7$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $2940e712aca02fa7$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $2940e712aca02fa7$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $2940e712aca02fa7$var$isDataViewToString.working ? $2940e712aca02fa7$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $2940e712aca02fa7$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $2940e712aca02fa7$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $2940e712aca02fa7$var$isSharedArrayBufferToString(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $2940e712aca02fa7$var$isSharedArrayBuffer(value) {
    if (typeof $2940e712aca02fa7$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $2940e712aca02fa7$var$isSharedArrayBufferToString.working === 'undefined') $2940e712aca02fa7$var$isSharedArrayBufferToString.working = $2940e712aca02fa7$var$isSharedArrayBufferToString(new $2940e712aca02fa7$var$SharedArrayBufferCopy());
    return $2940e712aca02fa7$var$isSharedArrayBufferToString.working ? $2940e712aca02fa7$var$isSharedArrayBufferToString(value) : value instanceof $2940e712aca02fa7$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $2940e712aca02fa7$var$isSharedArrayBuffer;
function $2940e712aca02fa7$var$isAsyncFunction(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $2940e712aca02fa7$var$isAsyncFunction;
function $2940e712aca02fa7$var$isMapIterator(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $2940e712aca02fa7$var$isMapIterator;
function $2940e712aca02fa7$var$isSetIterator(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $2940e712aca02fa7$var$isSetIterator;
function $2940e712aca02fa7$var$isGeneratorObject(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $2940e712aca02fa7$var$isGeneratorObject;
function $2940e712aca02fa7$var$isWebAssemblyCompiledModule(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $2940e712aca02fa7$var$isWebAssemblyCompiledModule;
function $2940e712aca02fa7$var$isNumberObject(value) {
    return $2940e712aca02fa7$var$checkBoxedPrimitive(value, $2940e712aca02fa7$var$numberValue);
}
module.exports.isNumberObject = $2940e712aca02fa7$var$isNumberObject;
function $2940e712aca02fa7$var$isStringObject(value) {
    return $2940e712aca02fa7$var$checkBoxedPrimitive(value, $2940e712aca02fa7$var$stringValue);
}
module.exports.isStringObject = $2940e712aca02fa7$var$isStringObject;
function $2940e712aca02fa7$var$isBooleanObject(value) {
    return $2940e712aca02fa7$var$checkBoxedPrimitive(value, $2940e712aca02fa7$var$booleanValue);
}
module.exports.isBooleanObject = $2940e712aca02fa7$var$isBooleanObject;
function $2940e712aca02fa7$var$isBigIntObject(value) {
    return $2940e712aca02fa7$var$BigIntSupported && $2940e712aca02fa7$var$checkBoxedPrimitive(value, $2940e712aca02fa7$var$bigIntValue);
}
module.exports.isBigIntObject = $2940e712aca02fa7$var$isBigIntObject;
function $2940e712aca02fa7$var$isSymbolObject(value) {
    return $2940e712aca02fa7$var$SymbolSupported && $2940e712aca02fa7$var$checkBoxedPrimitive(value, $2940e712aca02fa7$var$symbolValue);
}
module.exports.isSymbolObject = $2940e712aca02fa7$var$isSymbolObject;
function $2940e712aca02fa7$var$isBoxedPrimitive(value) {
    return $2940e712aca02fa7$var$isNumberObject(value) || $2940e712aca02fa7$var$isStringObject(value) || $2940e712aca02fa7$var$isBooleanObject(value) || $2940e712aca02fa7$var$isBigIntObject(value) || $2940e712aca02fa7$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $2940e712aca02fa7$var$isBoxedPrimitive;
function $2940e712aca02fa7$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($2940e712aca02fa7$var$isArrayBuffer(value) || $2940e712aca02fa7$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $2940e712aca02fa7$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});

parcelRegister("2Xb4T", function(module, exports) {
'use strict';

var $2269af4a175bb16e$var$hasToStringTag = (parcelRequire("DVsRa"))();

var $2BPyg = parcelRequire("2BPyg");

var $2269af4a175bb16e$var$$toString = $2BPyg('Object.prototype.toString');
var $2269af4a175bb16e$var$isStandardArguments = function isArguments(value) {
    if ($2269af4a175bb16e$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $2269af4a175bb16e$var$$toString(value) === '[object Arguments]';
};
var $2269af4a175bb16e$var$isLegacyArguments = function isArguments(value) {
    if ($2269af4a175bb16e$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $2269af4a175bb16e$var$$toString(value) !== '[object Array]' && $2269af4a175bb16e$var$$toString(value.callee) === '[object Function]';
};
var $2269af4a175bb16e$var$supportsStandardArguments = function() {
    return $2269af4a175bb16e$var$isStandardArguments(arguments);
}();
$2269af4a175bb16e$var$isStandardArguments.isLegacyArguments = $2269af4a175bb16e$var$isLegacyArguments; // for tests
module.exports = $2269af4a175bb16e$var$supportsStandardArguments ? $2269af4a175bb16e$var$isStandardArguments : $2269af4a175bb16e$var$isLegacyArguments;

});

parcelRegister("2BPyg", function(module, exports) {
'use strict';

var $cAbhD = parcelRequire("cAbhD");


var $26J2z = parcelRequire("26J2z");

var $1e670692988d4e8b$var$$indexOf = $26J2z($cAbhD('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $cAbhD(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $1e670692988d4e8b$var$$indexOf(name, '.prototype.') > -1) return $26J2z(intrinsic);
    return intrinsic;
};

});

parcelRegister("6TAnP", function(module, exports) {
'use strict';
var $50541a19d60c8c39$var$toStr = Object.prototype.toString;
var $50541a19d60c8c39$var$fnToStr = Function.prototype.toString;
var $50541a19d60c8c39$var$isFnRegex = /^\s*(?:function)?\*/;

var $50541a19d60c8c39$var$hasToStringTag = (parcelRequire("DVsRa"))();
var $50541a19d60c8c39$var$getProto = Object.getPrototypeOf;
var $50541a19d60c8c39$var$getGeneratorFunc = function() {
    if (!$50541a19d60c8c39$var$hasToStringTag) return false;
    try {
        return Function('return function*() {}')();
    } catch (e) {}
};
var $50541a19d60c8c39$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($50541a19d60c8c39$var$isFnRegex.test($50541a19d60c8c39$var$fnToStr.call(fn))) return true;
    if (!$50541a19d60c8c39$var$hasToStringTag) {
        var str = $50541a19d60c8c39$var$toStr.call(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$50541a19d60c8c39$var$getProto) return false;
    if (typeof $50541a19d60c8c39$var$GeneratorFunction === 'undefined') {
        var generatorFunc = $50541a19d60c8c39$var$getGeneratorFunc();
        $50541a19d60c8c39$var$GeneratorFunction = generatorFunc ? $50541a19d60c8c39$var$getProto(generatorFunc) : false;
    }
    return $50541a19d60c8c39$var$getProto(fn) === $50541a19d60c8c39$var$GeneratorFunction;
};

});

parcelRegister("hUXoN", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});

parcelRegister("9OEKu", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $1P2f3 = parcelRequire("1P2f3");

'use strict';
function $7258646f9557e685$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7258646f9557e685$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7258646f9557e685$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7258646f9557e685$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7258646f9557e685$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7258646f9557e685$var$_defineProperty(obj, key, value) {
    key = $7258646f9557e685$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7258646f9557e685$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7258646f9557e685$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7258646f9557e685$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7258646f9557e685$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7258646f9557e685$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7258646f9557e685$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7258646f9557e685$var$_toPropertyKey(arg) {
    var key = $7258646f9557e685$var$_toPrimitive(arg, "string");
    return $7258646f9557e685$var$_typeof(key) === "symbol" ? key : String(key);
}
function $7258646f9557e685$var$_toPrimitive(input, hint) {
    if ($7258646f9557e685$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($7258646f9557e685$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $7258646f9557e685$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $7258646f9557e685$var$_setPrototypeOf(subClass, superClass);
}
function $7258646f9557e685$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7258646f9557e685$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $7258646f9557e685$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $7258646f9557e685$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $7258646f9557e685$var$_possibleConstructorReturn(this, result);
    };
}
function $7258646f9557e685$var$_possibleConstructorReturn(self, call) {
    if (call && ($7258646f9557e685$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $7258646f9557e685$var$_assertThisInitialized(self);
}
function $7258646f9557e685$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7258646f9557e685$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $7258646f9557e685$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$7258646f9557e685$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $7258646f9557e685$var$_construct(Class, arguments, $7258646f9557e685$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $7258646f9557e685$var$_setPrototypeOf(Wrapper, Class);
    };
    return $7258646f9557e685$var$_wrapNativeSuper(Class);
}
function $7258646f9557e685$var$_construct(Parent, args, Class) {
    if ($7258646f9557e685$var$_isNativeReflectConstruct()) $7258646f9557e685$var$_construct = Reflect.construct.bind();
    else $7258646f9557e685$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $7258646f9557e685$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $7258646f9557e685$var$_construct.apply(null, arguments);
}
function $7258646f9557e685$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $7258646f9557e685$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $7258646f9557e685$var$_setPrototypeOf(o, p) {
    $7258646f9557e685$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7258646f9557e685$var$_setPrototypeOf(o, p);
}
function $7258646f9557e685$var$_getPrototypeOf(o) {
    $7258646f9557e685$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7258646f9557e685$var$_getPrototypeOf(o);
}
function $7258646f9557e685$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7258646f9557e685$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7258646f9557e685$var$_typeof(o);
}

var $7T2Y0 = parcelRequire("7T2Y0");

var $7258646f9557e685$var$inspect = $7T2Y0.inspect;

var $9VDwT = parcelRequire("9VDwT");

var $7258646f9557e685$var$ERR_INVALID_ARG_TYPE = $9VDwT.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $7258646f9557e685$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $7258646f9557e685$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return '';
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $7258646f9557e685$var$blue = '';
var $7258646f9557e685$var$green = '';
var $7258646f9557e685$var$red = '';
var $7258646f9557e685$var$white = '';
var $7258646f9557e685$var$kReadableOperator = {
    deepStrictEqual: 'Expected values to be strictly deep-equal:',
    strictEqual: 'Expected values to be strictly equal:',
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: 'Expected values to be loosely deep-equal:',
    equal: 'Expected values to be loosely equal:',
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: 'Values identical but not reference-equal:'
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $7258646f9557e685$var$kMaxShortLength = 10;
function $7258646f9557e685$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, 'message', {
        value: source.message
    });
    return target;
}
function $7258646f9557e685$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $7258646f9557e685$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $7258646f9557e685$var$createErrDiff(actual, expected, operator) {
    var other = '';
    var res = '';
    var lastPos = 0;
    var end = '';
    var skipped = false;
    var actualInspected = $7258646f9557e685$var$inspectValue(actual);
    var actualLines = actualInspected.split('\n');
    var expectedLines = $7258646f9557e685$var$inspectValue(expected).split('\n');
    var i = 0;
    var indicator = '';
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === 'strictEqual' && $7258646f9557e685$var$_typeof(actual) === 'object' && $7258646f9557e685$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $7258646f9557e685$var$kMaxShortLength) {
            if (($7258646f9557e685$var$_typeof(actual) !== 'object' || actual === null) && ($7258646f9557e685$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($7258646f9557e685$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== 'strictEqualObject') {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $1P2f3.stderr && $1P2f3.stderr.isTTY ? $1P2f3.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($7258646f9557e685$var$repeat(' ', i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split('\n');
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($7258646f9557e685$var$blue, "...").concat($7258646f9557e685$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($7258646f9557e685$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
    }
    if (i > 3) {
        end = "\n".concat($7258646f9557e685$var$blue, "...").concat($7258646f9557e685$var$white).concat(end);
        skipped = true;
    }
    if (other !== '') {
        end = "\n  ".concat(other).concat(end);
        other = '';
    }
    var printedLines = 0;
    var msg = $7258646f9557e685$var$kReadableOperator[operator] + "\n".concat($7258646f9557e685$var$green, "+ actual").concat($7258646f9557e685$var$white, " ").concat($7258646f9557e685$var$red, "- expected").concat($7258646f9557e685$var$white);
    var skippedMsg = " ".concat($7258646f9557e685$var$blue, "...").concat($7258646f9557e685$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($7258646f9557e685$var$blue, "...").concat($7258646f9557e685$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($7258646f9557e685$var$red, "-").concat($7258646f9557e685$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($7258646f9557e685$var$blue, "...").concat($7258646f9557e685$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($7258646f9557e685$var$green, "+").concat($7258646f9557e685$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$7258646f9557e685$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $7258646f9557e685$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($7258646f9557e685$var$blue, "...").concat($7258646f9557e685$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($7258646f9557e685$var$green, "+").concat($7258646f9557e685$var$white, " ").concat(actualLine);
                other += "\n".concat($7258646f9557e685$var$red, "-").concat($7258646f9557e685$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = '';
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($7258646f9557e685$var$blue, "...").concat($7258646f9557e685$var$white).concat(other, "\n") + "".concat($7258646f9557e685$var$blue, "...").concat($7258646f9557e685$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $7258646f9557e685$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $7258646f9557e685$var$_inherits(AssertionError, _Error);
    var _super = $7258646f9557e685$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $7258646f9557e685$var$_classCallCheck(this, AssertionError);
        if ($7258646f9557e685$var$_typeof(options) !== 'object' || options === null) throw new $7258646f9557e685$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($1P2f3.stderr && $1P2f3.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($1P2f3.stderr && $1P2f3.stderr.getColorDepth && $1P2f3.stderr.getColorDepth() !== 1) {
                    $7258646f9557e685$var$blue = "\x1B[34m";
                    $7258646f9557e685$var$green = "\x1B[32m";
                    $7258646f9557e685$var$white = "\x1B[39m";
                    $7258646f9557e685$var$red = "\x1B[31m";
                } else {
                    $7258646f9557e685$var$blue = '';
                    $7258646f9557e685$var$green = '';
                    $7258646f9557e685$var$white = '';
                    $7258646f9557e685$var$red = '';
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($7258646f9557e685$var$_typeof(actual) === 'object' && actual !== null && $7258646f9557e685$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                actual = $7258646f9557e685$var$copyError(actual);
                expected = $7258646f9557e685$var$copyError(expected);
            }
            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, $7258646f9557e685$var$createErrDiff(actual, expected, operator));
            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $7258646f9557e685$var$kReadableOperator[operator];
                var res = $7258646f9557e685$var$inspectValue(actual).split('\n');
                // In case "actual" is an object, it should not be reference equal.
                if (operator === 'notStrictEqual' && $7258646f9557e685$var$_typeof(actual) === 'object' && actual !== null) base = $7258646f9557e685$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($7258646f9557e685$var$blue, "...").concat($7258646f9557e685$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
            } else {
                var _res = $7258646f9557e685$var$inspectValue(actual);
                var other = '';
                var knownOperators = $7258646f9557e685$var$kReadableOperator[operator];
                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                    _res = "".concat($7258646f9557e685$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($7258646f9557e685$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($7258646f9557e685$var$_assertThisInitialized(_this), 'name', {
            value: 'AssertionError [ERR_ASSERTION]',
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = 'ERR_ASSERTION';
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($7258646f9557e685$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = 'AssertionError';
        return $7258646f9557e685$var$_possibleConstructorReturn(_this);
    }
    $7258646f9557e685$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $7258646f9557e685$var$inspect(this, $7258646f9557e685$var$_objectSpread($7258646f9557e685$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $7258646f9557e685$var$_wrapNativeSuper(Error), $7258646f9557e685$var$inspect.custom);
module.exports = $7258646f9557e685$var$AssertionError;

});

parcelRegister("fnK1J", function(module, exports) {
'use strict';

var $3yGSv = parcelRequire("3yGSv");

var $b32cb5030c98732b$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = 'abcdefghijklmnopqrst';
    var letters = str.split('');
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = '';
    for(var k in obj)actual += k;
    return str !== actual;
};
var $b32cb5030c98732b$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, 'xy');
    } catch (e) {
        return thrower[1] === 'y';
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $3yGSv;
    if ($b32cb5030c98732b$var$lacksProperEnumerationOrder()) return $3yGSv;
    if ($b32cb5030c98732b$var$assignHasPendingExceptions()) return $3yGSv;
    return Object.assign;
};

});

parcelRegister("3yGSv", function(module, exports) {
'use strict';

var $2aMTq = parcelRequire("2aMTq");


var $2975cec13e42e027$var$hasSymbols = (parcelRequire("edGXQ"))();

var $blqMe = parcelRequire("blqMe");


var $f8a3L = parcelRequire("f8a3L");

var $2975cec13e42e027$var$$push = $blqMe('Array.prototype.push');
var $2975cec13e42e027$var$$propIsEnumerable = $blqMe('Object.prototype.propertyIsEnumerable');
var $2975cec13e42e027$var$originalGetSymbols = $2975cec13e42e027$var$hasSymbols ? $f8a3L.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError('target must be an object');
    var to = $f8a3L(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $f8a3L(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $2aMTq(from);
        var getSymbols = $2975cec13e42e027$var$hasSymbols && ($f8a3L.getOwnPropertySymbols || $2975cec13e42e027$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($2975cec13e42e027$var$$propIsEnumerable(from, key)) $2975cec13e42e027$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($2975cec13e42e027$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});

parcelRegister("2aMTq", function(module, exports) {
'use strict';
var $19527114ab6c974a$var$slice = Array.prototype.slice;

var $9QzFm = parcelRequire("9QzFm");

var $19527114ab6c974a$var$origKeys = Object.keys;

var $19527114ab6c974a$var$keysShim = $19527114ab6c974a$var$origKeys ? function keys(o) {
    return $19527114ab6c974a$var$origKeys(o);
} : (parcelRequire("6NXwY"));
var $19527114ab6c974a$var$originalKeys = Object.keys;
$19527114ab6c974a$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($9QzFm(object)) return $19527114ab6c974a$var$originalKeys($19527114ab6c974a$var$slice.call(object));
            return $19527114ab6c974a$var$originalKeys(object);
        };
    } else Object.keys = $19527114ab6c974a$var$keysShim;
    return Object.keys || $19527114ab6c974a$var$keysShim;
};
module.exports = $19527114ab6c974a$var$keysShim;

});

parcelRegister("9QzFm", function(module, exports) {
'use strict';
var $72b4a2f3cb441a79$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $72b4a2f3cb441a79$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $72b4a2f3cb441a79$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("6NXwY", function(module, exports) {
'use strict';
var $4f457f4760cceef9$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $4f457f4760cceef9$var$has = Object.prototype.hasOwnProperty;
    var $4f457f4760cceef9$var$toStr = Object.prototype.toString;
    var $4f457f4760cceef9$var$isArgs = (parcelRequire("9QzFm")); // eslint-disable-line global-require
    var $4f457f4760cceef9$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $4f457f4760cceef9$var$hasDontEnumBug = !$4f457f4760cceef9$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $4f457f4760cceef9$var$hasProtoEnumBug = $4f457f4760cceef9$var$isEnumerable.call(function() {}, 'prototype');
    var $4f457f4760cceef9$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $4f457f4760cceef9$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $4f457f4760cceef9$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $4f457f4760cceef9$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$4f457f4760cceef9$var$excludedKeys['$' + k] && $4f457f4760cceef9$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $4f457f4760cceef9$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $4f457f4760cceef9$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$4f457f4760cceef9$var$hasAutomationEqualityBug) return $4f457f4760cceef9$var$equalsConstructorPrototype(o);
        try {
            return $4f457f4760cceef9$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $4f457f4760cceef9$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $4f457f4760cceef9$var$toStr.call(object) === '[object Function]';
        var isArguments = $4f457f4760cceef9$var$isArgs(object);
        var isString = isObject && $4f457f4760cceef9$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $4f457f4760cceef9$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$4f457f4760cceef9$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $4f457f4760cceef9$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($4f457f4760cceef9$var$hasDontEnumBug) {
            var skipConstructor = $4f457f4760cceef9$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $4f457f4760cceef9$var$dontEnums.length; ++k)if (!(skipConstructor && $4f457f4760cceef9$var$dontEnums[k] === 'constructor') && $4f457f4760cceef9$var$has.call(object, $4f457f4760cceef9$var$dontEnums[k])) theKeys.push($4f457f4760cceef9$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $4f457f4760cceef9$var$keysShim;

});

parcelRegister("aKQxr", function(module, exports) {
'use strict';

var $iZo8r = parcelRequire("iZo8r");

module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $iZo8r;
};

});

parcelRegister("iZo8r", function(module, exports) {
'use strict';
var $dd30a53fbc79558f$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($dd30a53fbc79558f$var$numberIsNaN(a) && $dd30a53fbc79558f$var$numberIsNaN(b)) return true;
    return false;
};

});

parcelRegister("ilKc6", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
function $d5be055d9baf98a0$var$_slicedToArray(arr, i) {
    return $d5be055d9baf98a0$var$_arrayWithHoles(arr) || $d5be055d9baf98a0$var$_iterableToArrayLimit(arr, i) || $d5be055d9baf98a0$var$_unsupportedIterableToArray(arr, i) || $d5be055d9baf98a0$var$_nonIterableRest();
}
function $d5be055d9baf98a0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d5be055d9baf98a0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d5be055d9baf98a0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d5be055d9baf98a0$var$_arrayLikeToArray(o, minLen);
}
function $d5be055d9baf98a0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d5be055d9baf98a0$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $d5be055d9baf98a0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $d5be055d9baf98a0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d5be055d9baf98a0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d5be055d9baf98a0$var$_typeof(o);
}
var $d5be055d9baf98a0$var$regexFlagsSupported = /a/g.flags !== undefined;
var $d5be055d9baf98a0$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $d5be055d9baf98a0$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $d5be055d9baf98a0$var$objectIs = Object.is ? Object.is : (parcelRequire("29nQp"));
var $d5be055d9baf98a0$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $d5be055d9baf98a0$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("ojU0q"));
function $d5be055d9baf98a0$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $d5be055d9baf98a0$var$hasOwnProperty = $d5be055d9baf98a0$var$uncurryThis(Object.prototype.hasOwnProperty);
var $d5be055d9baf98a0$var$propertyIsEnumerable = $d5be055d9baf98a0$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $d5be055d9baf98a0$var$objectToString = $d5be055d9baf98a0$var$uncurryThis(Object.prototype.toString);

var $7T2Y0 = parcelRequire("7T2Y0");

var $d5be055d9baf98a0$require$_require$types = $7T2Y0.types;
var $d5be055d9baf98a0$var$isAnyArrayBuffer = $d5be055d9baf98a0$require$_require$types.isAnyArrayBuffer, $d5be055d9baf98a0$var$isArrayBufferView = $d5be055d9baf98a0$require$_require$types.isArrayBufferView, $d5be055d9baf98a0$var$isDate = $d5be055d9baf98a0$require$_require$types.isDate, $d5be055d9baf98a0$var$isMap = $d5be055d9baf98a0$require$_require$types.isMap, $d5be055d9baf98a0$var$isRegExp = $d5be055d9baf98a0$require$_require$types.isRegExp, $d5be055d9baf98a0$var$isSet = $d5be055d9baf98a0$require$_require$types.isSet, $d5be055d9baf98a0$var$isNativeError = $d5be055d9baf98a0$require$_require$types.isNativeError, $d5be055d9baf98a0$var$isBoxedPrimitive = $d5be055d9baf98a0$require$_require$types.isBoxedPrimitive, $d5be055d9baf98a0$var$isNumberObject = $d5be055d9baf98a0$require$_require$types.isNumberObject, $d5be055d9baf98a0$var$isStringObject = $d5be055d9baf98a0$require$_require$types.isStringObject, $d5be055d9baf98a0$var$isBooleanObject = $d5be055d9baf98a0$require$_require$types.isBooleanObject, $d5be055d9baf98a0$var$isBigIntObject = $d5be055d9baf98a0$require$_require$types.isBigIntObject, $d5be055d9baf98a0$var$isSymbolObject = $d5be055d9baf98a0$require$_require$types.isSymbolObject, $d5be055d9baf98a0$var$isFloat32Array = $d5be055d9baf98a0$require$_require$types.isFloat32Array, $d5be055d9baf98a0$var$isFloat64Array = $d5be055d9baf98a0$require$_require$types.isFloat64Array;
function $d5be055d9baf98a0$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $d5be055d9baf98a0$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($d5be055d9baf98a0$var$isNonIndex).concat($d5be055d9baf98a0$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $d5be055d9baf98a0$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $d5be055d9baf98a0$var$ONLY_ENUMERABLE = undefined;
var $d5be055d9baf98a0$var$kStrict = true;
var $d5be055d9baf98a0$var$kLoose = false;
var $d5be055d9baf98a0$var$kNoIterator = 0;
var $d5be055d9baf98a0$var$kIsArray = 1;
var $d5be055d9baf98a0$var$kIsSet = 2;
var $d5be055d9baf98a0$var$kIsMap = 3;
// Check if they have the same source and flags
function $d5be055d9baf98a0$var$areSimilarRegExps(a, b) {
    return $d5be055d9baf98a0$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $d5be055d9baf98a0$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $d5be055d9baf98a0$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $d5be055d9baf98a0$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $d5be055d9baf98a0$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $d5be055d9baf98a0$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $d5be055d9baf98a0$var$isEqualBoxedPrimitive(val1, val2) {
    if ($d5be055d9baf98a0$var$isNumberObject(val1)) return $d5be055d9baf98a0$var$isNumberObject(val2) && $d5be055d9baf98a0$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($d5be055d9baf98a0$var$isStringObject(val1)) return $d5be055d9baf98a0$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($d5be055d9baf98a0$var$isBooleanObject(val1)) return $d5be055d9baf98a0$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($d5be055d9baf98a0$var$isBigIntObject(val1)) return $d5be055d9baf98a0$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $d5be055d9baf98a0$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $d5be055d9baf98a0$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $d5be055d9baf98a0$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($d5be055d9baf98a0$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $d5be055d9baf98a0$var$numberIsNaN(val1) && $d5be055d9baf98a0$var$numberIsNaN(val2);
        if ($d5be055d9baf98a0$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $d5be055d9baf98a0$var$_typeof(val1) !== 'object') {
            if (val2 === null || $d5be055d9baf98a0$var$_typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $d5be055d9baf98a0$var$_typeof(val2) !== 'object') return false;
    }
    var val1Tag = $d5be055d9baf98a0$var$objectToString(val1);
    var val2Tag = $d5be055d9baf98a0$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $d5be055d9baf98a0$var$getOwnNonIndexProperties(val1, $d5be055d9baf98a0$var$ONLY_ENUMERABLE);
        var keys2 = $d5be055d9baf98a0$var$getOwnNonIndexProperties(val2, $d5be055d9baf98a0$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $d5be055d9baf98a0$var$keyCheck(val1, val2, strict, memos, $d5be055d9baf98a0$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === '[object Object]') {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$d5be055d9baf98a0$var$isMap(val1) && $d5be055d9baf98a0$var$isMap(val2) || !$d5be055d9baf98a0$var$isSet(val1) && $d5be055d9baf98a0$var$isSet(val2)) return false;
    }
    if ($d5be055d9baf98a0$var$isDate(val1)) {
        if (!$d5be055d9baf98a0$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($d5be055d9baf98a0$var$isRegExp(val1)) {
        if (!$d5be055d9baf98a0$var$isRegExp(val2) || !$d5be055d9baf98a0$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($d5be055d9baf98a0$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($d5be055d9baf98a0$var$isArrayBufferView(val1)) {
        if (!strict && ($d5be055d9baf98a0$var$isFloat32Array(val1) || $d5be055d9baf98a0$var$isFloat64Array(val1))) {
            if (!$d5be055d9baf98a0$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$d5be055d9baf98a0$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $d5be055d9baf98a0$var$getOwnNonIndexProperties(val1, $d5be055d9baf98a0$var$ONLY_ENUMERABLE);
        var _keys2 = $d5be055d9baf98a0$var$getOwnNonIndexProperties(val2, $d5be055d9baf98a0$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $d5be055d9baf98a0$var$keyCheck(val1, val2, strict, memos, $d5be055d9baf98a0$var$kNoIterator, _keys);
    } else if ($d5be055d9baf98a0$var$isSet(val1)) {
        if (!$d5be055d9baf98a0$var$isSet(val2) || val1.size !== val2.size) return false;
        return $d5be055d9baf98a0$var$keyCheck(val1, val2, strict, memos, $d5be055d9baf98a0$var$kIsSet);
    } else if ($d5be055d9baf98a0$var$isMap(val1)) {
        if (!$d5be055d9baf98a0$var$isMap(val2) || val1.size !== val2.size) return false;
        return $d5be055d9baf98a0$var$keyCheck(val1, val2, strict, memos, $d5be055d9baf98a0$var$kIsMap);
    } else if ($d5be055d9baf98a0$var$isAnyArrayBuffer(val1)) {
        if (!$d5be055d9baf98a0$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($d5be055d9baf98a0$var$isBoxedPrimitive(val1) && !$d5be055d9baf98a0$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $d5be055d9baf98a0$var$keyCheck(val1, val2, strict, memos, $d5be055d9baf98a0$var$kNoIterator);
}
function $d5be055d9baf98a0$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $d5be055d9baf98a0$var$propertyIsEnumerable(val, k);
    });
}
function $d5be055d9baf98a0$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$d5be055d9baf98a0$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $d5be055d9baf98a0$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($d5be055d9baf98a0$var$propertyIsEnumerable(val1, key)) {
                    if (!$d5be055d9baf98a0$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($d5be055d9baf98a0$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $d5be055d9baf98a0$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $d5be055d9baf98a0$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $d5be055d9baf98a0$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $d5be055d9baf98a0$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $d5be055d9baf98a0$var$kNoIterator || iterationType === $d5be055d9baf98a0$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $d5be055d9baf98a0$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $d5be055d9baf98a0$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $d5be055d9baf98a0$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($d5be055d9baf98a0$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $d5be055d9baf98a0$var$findLooseMatchingPrimitives(prim) {
    switch($d5be055d9baf98a0$var$_typeof(prim)){
        case 'undefined':
            return null;
        case 'object':
            // Only pass in null as object!
            return undefined;
        case 'symbol':
            return false;
        case 'string':
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case 'number':
            if ($d5be055d9baf98a0$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $d5be055d9baf98a0$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $d5be055d9baf98a0$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $d5be055d9baf98a0$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $d5be055d9baf98a0$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$d5be055d9baf98a0$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $d5be055d9baf98a0$var$innerDeepEqual(item, curB, false, memo);
}
function $d5be055d9baf98a0$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $d5be055d9baf98a0$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($d5be055d9baf98a0$var$_typeof(val) === 'object' && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$d5be055d9baf98a0$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $d5be055d9baf98a0$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($d5be055d9baf98a0$var$_typeof(_val) === 'object' && _val !== null) {
                if (!$d5be055d9baf98a0$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$d5be055d9baf98a0$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $d5be055d9baf98a0$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $d5be055d9baf98a0$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($d5be055d9baf98a0$var$innerDeepEqual(key1, key2, strict, memo) && $d5be055d9baf98a0$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $d5be055d9baf98a0$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $d5be055d9baf98a0$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $d5be055d9baf98a0$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($d5be055d9baf98a0$var$_typeof(key) === 'object' && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$d5be055d9baf98a0$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$d5be055d9baf98a0$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $d5be055d9baf98a0$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $d5be055d9baf98a0$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($d5be055d9baf98a0$var$_typeof(_key) === 'object' && _key !== null) {
                if (!$d5be055d9baf98a0$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$d5be055d9baf98a0$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$d5be055d9baf98a0$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $d5be055d9baf98a0$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $d5be055d9baf98a0$var$kIsSet) {
        if (!$d5be055d9baf98a0$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $d5be055d9baf98a0$var$kIsMap) {
        if (!$d5be055d9baf98a0$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $d5be055d9baf98a0$var$kIsArray) for(; i < a.length; i++){
        if ($d5be055d9baf98a0$var$hasOwnProperty(a, i)) {
            if (!$d5be055d9baf98a0$var$hasOwnProperty(b, i) || !$d5be055d9baf98a0$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($d5be055d9baf98a0$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$d5be055d9baf98a0$var$hasOwnProperty(b, key) || !$d5be055d9baf98a0$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$d5be055d9baf98a0$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $d5be055d9baf98a0$var$isDeepEqual(val1, val2) {
    return $d5be055d9baf98a0$var$innerDeepEqual(val1, val2, $d5be055d9baf98a0$var$kLoose);
}
function $d5be055d9baf98a0$var$isDeepStrictEqual(val1, val2) {
    return $d5be055d9baf98a0$var$innerDeepEqual(val1, val2, $d5be055d9baf98a0$var$kStrict);
}
module.exports = {
    isDeepEqual: $d5be055d9baf98a0$var$isDeepEqual,
    isDeepStrictEqual: $d5be055d9baf98a0$var$isDeepStrictEqual
};

});

parcelRegister("29nQp", function(module, exports) {
'use strict';

var $eGbn7 = parcelRequire("eGbn7");


var $26J2z = parcelRequire("26J2z");


var $iZo8r = parcelRequire("iZo8r");


var $aKQxr = parcelRequire("aKQxr");


var $h9z8p = parcelRequire("h9z8p");

var $190eeb03c4f85517$var$polyfill = $26J2z($aKQxr(), Object);
$eGbn7($190eeb03c4f85517$var$polyfill, {
    getPolyfill: $aKQxr,
    implementation: $iZo8r,
    shim: $h9z8p
});
module.exports = $190eeb03c4f85517$var$polyfill;

});

parcelRegister("eGbn7", function(module, exports) {
'use strict';

var $2aMTq = parcelRequire("2aMTq");

var $aafdcf22e1319c4a$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $aafdcf22e1319c4a$var$toStr = Object.prototype.toString;
var $aafdcf22e1319c4a$var$concat = Array.prototype.concat;

var $iFj39 = parcelRequire("iFj39");

var $aafdcf22e1319c4a$var$isFunction = function(fn) {
    return typeof fn === 'function' && $aafdcf22e1319c4a$var$toStr.call(fn) === '[object Function]';
};

var $aafdcf22e1319c4a$var$supportsDescriptors = (parcelRequire("9CFxa"))();
var $aafdcf22e1319c4a$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$aafdcf22e1319c4a$var$isFunction(predicate) || !predicate()) return;
    }
    if ($aafdcf22e1319c4a$var$supportsDescriptors) $iFj39(object, name, value, true);
    else $iFj39(object, name, value);
};
var $aafdcf22e1319c4a$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $2aMTq(map);
    if ($aafdcf22e1319c4a$var$hasSymbols) props = $aafdcf22e1319c4a$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$aafdcf22e1319c4a$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$aafdcf22e1319c4a$var$defineProperties.supportsDescriptors = !!$aafdcf22e1319c4a$var$supportsDescriptors;
module.exports = $aafdcf22e1319c4a$var$defineProperties;

});

parcelRegister("h9z8p", function(module, exports) {
'use strict';

var $aKQxr = parcelRequire("aKQxr");


var $eGbn7 = parcelRequire("eGbn7");

module.exports = function shimObjectIs() {
    var polyfill = $aKQxr();
    $eGbn7(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});

parcelRegister("ojU0q", function(module, exports) {
'use strict';

var $26J2z = parcelRequire("26J2z");


var $eGbn7 = parcelRequire("eGbn7");


var $5PvCl = parcelRequire("5PvCl");


var $15HFT = parcelRequire("15HFT");


var $99fDU = parcelRequire("99fDU");

var $0491ae3133badd22$var$polyfill = $26J2z($15HFT(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $eGbn7($0491ae3133badd22$var$polyfill, {
    getPolyfill: $15HFT,
    implementation: $5PvCl,
    shim: $99fDU
});
module.exports = $0491ae3133badd22$var$polyfill;

});

parcelRegister("5PvCl", function(module, exports) {
'use strict';
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("15HFT", function(module, exports) {
'use strict';

var $5PvCl = parcelRequire("5PvCl");

module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
    return $5PvCl;
};

});

parcelRegister("99fDU", function(module, exports) {
'use strict';

var $eGbn7 = parcelRequire("eGbn7");


var $15HFT = parcelRequire("15HFT");

/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $15HFT();
    $eGbn7(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});

parcelRegister("9Hb6D", function(module, exports) {
$parcel$export(module.exports, "merge", () => $70f0bea37c3dd158$export$4950aa0f605343fb, (v) => $70f0bea37c3dd158$export$4950aa0f605343fb = v);
var $70f0bea37c3dd158$export$4950aa0f605343fb;
"use strict";

var $1pK8e = parcelRequire("1pK8e");


var $hmT2x = parcelRequire("hmT2x");


var $lRrDg = parcelRequire("lRrDg");


var $c9SbF = parcelRequire("c9SbF");

/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (as arguments), and simply
 * forwards (without doing any transformation) all the values from all the input
 * Observables to the output Observable. The output Observable only completes
 * once all input Observables have completed. Any error delivered by an input
 * Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = Rx.Observable.merge(clicks, timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // timer will emit ascending values, one every second(1000ms) to console
 * // clicks logs MouseEvents to console everytime the "document" is clicked
 * // Since the two streams are merged you see these happening
 * // as they occur.
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = Rx.Observable.merge(timer1, timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - First timer1 and timer2 will run concurrently
 * // - timer1 will emit a value every 1000ms for 10 iterations
 * // - timer2 will emit a value every 2000ms for 6 iterations
 * // - after timer1 hits it's max iteration, timer2 will
 * //   continue, and timer3 will start to run concurrently with timer2
 * // - when timer2 hits it's max iteration it terminates, and
 * //   timer3 will continue to emit a value every 500ms until it is complete
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {...ObservableInput} observables Input Observables to merge together.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} an Observable that emits items that are the result of
 * every input Observable.
 * @static true
 * @name merge
 * @owner Observable
 */ function $70f0bea37c3dd158$var$merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if ($lRrDg.isScheduler(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') concurrent = observables.pop();
    } else if (typeof last === 'number') concurrent = observables.pop();
    if (scheduler === null && observables.length === 1 && observables[0] instanceof $1pK8e.Observable) return observables[0];
    return $c9SbF.mergeAll(concurrent)(new $hmT2x.ArrayObservable(observables, scheduler));
}
$70f0bea37c3dd158$export$4950aa0f605343fb = $70f0bea37c3dd158$var$merge;

});

parcelRegister("c9SbF", function(module, exports) {
$parcel$export(module.exports, "mergeAll", () => $8da05bbe9f24d995$export$18aef43295bbe906, (v) => $8da05bbe9f24d995$export$18aef43295bbe906 = v);
var $8da05bbe9f24d995$export$18aef43295bbe906;
"use strict";

var $inXGV = parcelRequire("inXGV");


var $lIS42 = parcelRequire("lIS42");

/**
 * Converts a higher-order Observable into a first-order Observable which
 * concurrently delivers all values that are emitted on the inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables.</span>
 *
 * <img src="./img/mergeAll.png" width="100%">
 *
 * `mergeAll` subscribes to an Observable that emits Observables, also known as
 * a higher-order Observable. Each time it observes one of these emitted inner
 * Observables, it subscribes to that and delivers all the values from the
 * inner Observable on the output Observable. The output Observable only
 * completes once all inner Observables have completed. Any error delivered by
 * a inner Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var firstOrder = higherOrder.mergeAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
 * var firstOrder = higherOrder.mergeAll(2);
 * firstOrder.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link merge}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits values coming from all the
 * inner Observables emitted by the source Observable.
 * @method mergeAll
 * @owner Observable
 */ function $8da05bbe9f24d995$var$mergeAll(concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $inXGV.mergeMap($lIS42.identity, null, concurrent);
}
$8da05bbe9f24d995$export$18aef43295bbe906 = $8da05bbe9f24d995$var$mergeAll;

});

parcelRegister("lIS42", function(module, exports) {
$parcel$export(module.exports, "identity", () => $fd07a50b5336926a$export$f0954fd7d5368655, (v) => $fd07a50b5336926a$export$f0954fd7d5368655 = v);
var $fd07a50b5336926a$export$f0954fd7d5368655;
"use strict";
function $fd07a50b5336926a$var$identity(x) {
    return x;
}
$fd07a50b5336926a$export$f0954fd7d5368655 = $fd07a50b5336926a$var$identity;

});

parcelRegister("8Bx1z", function(module, exports) {
"use strict";
var $643b655b3a668be3$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");

/* tslint:enable:max-line-length */ /**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */ function $643b655b3a668be3$var$filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new $643b655b3a668be3$var$FilterOperator(predicate, thisArg));
    };
}
module.exports.filter = $643b655b3a668be3$var$filter;
var $643b655b3a668be3$var$FilterOperator = function() {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $643b655b3a668be3$var$FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $643b655b3a668be3$var$FilterSubscriber = function(_super) {
    $643b655b3a668be3$var$__extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.count = 0;
    }
    // the try catch block below is left specifically for
    // optimization and perf reasons. a tryCatcher is not necessary here.
    FilterSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.destination.next(value);
    };
    return FilterSubscriber;
}($fNVRJ.Subscriber);

});

parcelRegister("eeWDH", function(module, exports) {
"use strict";
var $a5dfdc0a1bdb1c58$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $atSr0 = parcelRequire("atSr0");


var $kjYch = parcelRequire("kjYch");

/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */ function $a5dfdc0a1bdb1c58$var$take(count) {
    return function(source) {
        if (count === 0) return new $kjYch.EmptyObservable();
        else return source.lift(new $a5dfdc0a1bdb1c58$var$TakeOperator(count));
    };
}
module.exports.take = $a5dfdc0a1bdb1c58$var$take;
var $a5dfdc0a1bdb1c58$var$TakeOperator = function() {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $atSr0.ArgumentOutOfRangeError;
    }
    TakeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a5dfdc0a1bdb1c58$var$TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a5dfdc0a1bdb1c58$var$TakeSubscriber = function(_super) {
    $a5dfdc0a1bdb1c58$var$__extends(TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    TakeSubscriber.prototype._next = function(value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}($fNVRJ.Subscriber);

});

parcelRegister("atSr0", function(module, exports) {
"use strict";
var $7a16d669c235c821$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an element was queried at a certain index of an
 * Observable, but no such index or position exists in that sequence.
 *
 * @see {@link elementAt}
 * @see {@link take}
 * @see {@link takeLast}
 *
 * @class ArgumentOutOfRangeError
 */ var $7a16d669c235c821$var$ArgumentOutOfRangeError = function(_super) {
    $7a16d669c235c821$var$__extends(ArgumentOutOfRangeError, _super);
    function ArgumentOutOfRangeError() {
        var err = _super.call(this, 'argument out of range');
        this.name = err.name = 'ArgumentOutOfRangeError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ArgumentOutOfRangeError;
}(Error);
module.exports.ArgumentOutOfRangeError = $7a16d669c235c821$var$ArgumentOutOfRangeError;

});

parcelRegister("34cAP", function(module, exports) {
$parcel$export(module.exports, "toArray", () => $23bb83863f0fc948$export$45b10814cc054894, (v) => $23bb83863f0fc948$export$45b10814cc054894 = v);
var $23bb83863f0fc948$export$45b10814cc054894;
"use strict";

var $7bBVm = parcelRequire("7bBVm");

function $23bb83863f0fc948$var$toArrayReducer(arr, item, index) {
    if (index === 0) return [
        item
    ];
    arr.push(item);
    return arr;
}
function $23bb83863f0fc948$var$toArray() {
    return $7bBVm.reduce($23bb83863f0fc948$var$toArrayReducer, []);
}
$23bb83863f0fc948$export$45b10814cc054894 = $23bb83863f0fc948$var$toArray;

});

parcelRegister("7bBVm", function(module, exports) {
$parcel$export(module.exports, "reduce", () => $53b6fa7559558246$export$533b26079ad0b4b, (v) => $53b6fa7559558246$export$533b26079ad0b4b = v);
var $53b6fa7559558246$export$533b26079ad0b4b;
"use strict";

var $bbCp3 = parcelRequire("bbCp3");


var $lQvgf = parcelRequire("lQvgf");


var $dTFgb = parcelRequire("dTFgb");


var $kPZwo = parcelRequire("kPZwo");

/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns the
 * accumulated result when the source completes, given an optional seed value.
 *
 * <span class="informal">Combines together all values emitted on the source,
 * using an accumulator function that knows how to join a new source value into
 * the accumulation from the past.</span>
 *
 * <img src="./img/reduce.png" width="100%">
 *
 * Like
 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
 * `reduce` applies an `accumulator` function against an accumulation and each
 * value of the source Observable (from the past) to reduce it to a single
 * value, emitted on the output Observable. Note that `reduce` will only emit
 * one value, only when the source Observable completes. It is equivalent to
 * applying operator {@link scan} followed by operator {@link last}.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
 *   .takeUntil(Rx.Observable.interval(5000));
 * var ones = clicksInFiveSeconds.mapTo(1);
 * var seed = 0;
 * var count = ones.reduce((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link count}
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link scan}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
 * called on each source value.
 * @param {R} [seed] The initial accumulation value.
 * @return {Observable<R>} An Observable that emits a single value that is the
 * result of accumulating the values emitted by the source Observable.
 * @method reduce
 * @owner Observable
 */ function $53b6fa7559558246$var$reduce(accumulator, seed) {
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) return function reduceOperatorFunctionWithSeed(source) {
        return $kPZwo.pipe($bbCp3.scan(accumulator, seed), $lQvgf.takeLast(1), $dTFgb.defaultIfEmpty(seed))(source);
    };
    return function reduceOperatorFunction(source) {
        return $kPZwo.pipe($bbCp3.scan(function(acc, value, index) {
            return accumulator(acc, value, index + 1);
        }), $lQvgf.takeLast(1))(source);
    };
}
$53b6fa7559558246$export$533b26079ad0b4b = $53b6fa7559558246$var$reduce;

});

parcelRegister("bbCp3", function(module, exports) {
"use strict";
var $824e82d9ed0a6633$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");

/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns each
 * intermediate result, with an optional seed value.
 *
 * <span class="informal">It's like {@link reduce}, but emits the current
 * accumulation whenever the source emits a value.</span>
 *
 * <img src="./img/scan.png" width="100%">
 *
 * Combines together all values emitted on the source, using an accumulator
 * function that knows how to join a new source value into the accumulation from
 * the past. Is similar to {@link reduce}, but emits the intermediate
 * accumulations.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var ones = clicks.mapTo(1);
 * var seed = 0;
 * var count = ones.scan((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link reduce}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator
 * The accumulator function called on each source value.
 * @param {T|R} [seed] The initial accumulation value.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method scan
 * @owner Observable
 */ function $824e82d9ed0a6633$var$scan(accumulator, seed) {
    var hasSeed = false;
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) hasSeed = true;
    return function scanOperatorFunction(source) {
        return source.lift(new $824e82d9ed0a6633$var$ScanOperator(accumulator, seed, hasSeed));
    };
}
module.exports.scan = $824e82d9ed0a6633$var$scan;
var $824e82d9ed0a6633$var$ScanOperator = function() {
    function ScanOperator(accumulator, seed, hasSeed) {
        if (hasSeed === void 0) hasSeed = false;
        this.accumulator = accumulator;
        this.seed = seed;
        this.hasSeed = hasSeed;
    }
    ScanOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $824e82d9ed0a6633$var$ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
    };
    return ScanOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $824e82d9ed0a6633$var$ScanSubscriber = function(_super) {
    $824e82d9ed0a6633$var$__extends(ScanSubscriber, _super);
    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this._seed = _seed;
        this.hasSeed = hasSeed;
        this.index = 0;
    }
    Object.defineProperty(ScanSubscriber.prototype, "seed", {
        get: function() {
            return this._seed;
        },
        set: function(value) {
            this.hasSeed = true;
            this._seed = value;
        },
        enumerable: true,
        configurable: true
    });
    ScanSubscriber.prototype._next = function(value) {
        if (!this.hasSeed) {
            this.seed = value;
            this.destination.next(value);
        } else return this._tryNext(value);
    };
    ScanSubscriber.prototype._tryNext = function(value) {
        var index = this.index++;
        var result;
        try {
            result = this.accumulator(this.seed, value, index);
        } catch (err) {
            this.destination.error(err);
        }
        this.seed = result;
        this.destination.next(result);
    };
    return ScanSubscriber;
}($fNVRJ.Subscriber);

});

parcelRegister("lQvgf", function(module, exports) {
"use strict";
var $fe76b4167e522f00$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $atSr0 = parcelRequire("atSr0");


var $kjYch = parcelRequire("kjYch");

/**
 * Emits only the last `count` values emitted by the source Observable.
 *
 * <span class="informal">Remembers the latest `count` values, then emits those
 * only when the source completes.</span>
 *
 * <img src="./img/takeLast.png" width="100%">
 *
 * `takeLast` returns an Observable that emits at most the last `count` values
 * emitted by the source Observable. If the source emits fewer than `count`
 * values then all of its values are emitted. This operator must wait until the
 * `complete` notification emission from the source in order to emit the `next`
 * values on the output Observable, because otherwise it is impossible to know
 * whether or not more values will be emitted on the source. For this reason,
 * all values are emitted synchronously, followed by the complete notification.
 *
 * @example <caption>Take the last 3 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 100);
 * var lastThree = many.takeLast(3);
 * lastThree.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of values to emit from the end of
 * the sequence of values emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits at most the last count
 * values emitted by the source Observable.
 * @method takeLast
 * @owner Observable
 */ function $fe76b4167e522f00$var$takeLast(count) {
    return function takeLastOperatorFunction(source) {
        if (count === 0) return new $kjYch.EmptyObservable();
        else return source.lift(new $fe76b4167e522f00$var$TakeLastOperator(count));
    };
}
module.exports.takeLast = $fe76b4167e522f00$var$takeLast;
var $fe76b4167e522f00$var$TakeLastOperator = function() {
    function TakeLastOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $atSr0.ArgumentOutOfRangeError;
    }
    TakeLastOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $fe76b4167e522f00$var$TakeLastSubscriber(subscriber, this.total));
    };
    return TakeLastOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $fe76b4167e522f00$var$TakeLastSubscriber = function(_super) {
    $fe76b4167e522f00$var$__extends(TakeLastSubscriber, _super);
    function TakeLastSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.ring = new Array();
        this.count = 0;
    }
    TakeLastSubscriber.prototype._next = function(value) {
        var ring = this.ring;
        var total = this.total;
        var count = this.count++;
        if (ring.length < total) ring.push(value);
        else {
            var index = count % total;
            ring[index] = value;
        }
    };
    TakeLastSubscriber.prototype._complete = function() {
        var destination = this.destination;
        var count = this.count;
        if (count > 0) {
            var total = this.count >= this.total ? this.total : this.count;
            var ring = this.ring;
            for(var i = 0; i < total; i++){
                var idx = count++ % total;
                destination.next(ring[idx]);
            }
        }
        destination.complete();
    };
    return TakeLastSubscriber;
}($fNVRJ.Subscriber);

});

parcelRegister("dTFgb", function(module, exports) {
"use strict";
var $a1e06aced5e020ea$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");

/* tslint:enable:max-line-length */ /**
 * Emits a given value if the source Observable completes without emitting any
 * `next` value, otherwise mirrors the source Observable.
 *
 * <span class="informal">If the source Observable turns out to be empty, then
 * this operator will emit a default value.</span>
 *
 * <img src="./img/defaultIfEmpty.png" width="100%">
 *
 * `defaultIfEmpty` emits the values emitted by the source Observable or a
 * specified default value if the source Observable is empty (completes without
 * having emitted any `next` value).
 *
 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link empty}
 * @see {@link last}
 *
 * @param {any} [defaultValue=null] The default value used if the source
 * Observable is empty.
 * @return {Observable} An Observable that emits either the specified
 * `defaultValue` if the source Observable emits no items, or the values emitted
 * by the source Observable.
 * @method defaultIfEmpty
 * @owner Observable
 */ function $a1e06aced5e020ea$var$defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) defaultValue = null;
    return function(source) {
        return source.lift(new $a1e06aced5e020ea$var$DefaultIfEmptyOperator(defaultValue));
    };
}
module.exports.defaultIfEmpty = $a1e06aced5e020ea$var$defaultIfEmpty;
var $a1e06aced5e020ea$var$DefaultIfEmptyOperator = function() {
    function DefaultIfEmptyOperator(defaultValue) {
        this.defaultValue = defaultValue;
    }
    DefaultIfEmptyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a1e06aced5e020ea$var$DefaultIfEmptySubscriber(subscriber, this.defaultValue));
    };
    return DefaultIfEmptyOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a1e06aced5e020ea$var$DefaultIfEmptySubscriber = function(_super) {
    $a1e06aced5e020ea$var$__extends(DefaultIfEmptySubscriber, _super);
    function DefaultIfEmptySubscriber(destination, defaultValue) {
        _super.call(this, destination);
        this.defaultValue = defaultValue;
        this.isEmpty = true;
    }
    DefaultIfEmptySubscriber.prototype._next = function(value) {
        this.isEmpty = false;
        this.destination.next(value);
    };
    DefaultIfEmptySubscriber.prototype._complete = function() {
        if (this.isEmpty) this.destination.next(this.defaultValue);
        this.destination.complete();
    };
    return DefaultIfEmptySubscriber;
}($fNVRJ.Subscriber);

});

parcelRegister("lv9Cv", function(module, exports) {
$parcel$export(module.exports, "of", () => $fa73f494791b08e6$export$ba255e9e49e00608, (v) => $fa73f494791b08e6$export$ba255e9e49e00608 = v);
var $fa73f494791b08e6$export$ba255e9e49e00608;
"use strict";

var $hmT2x = parcelRequire("hmT2x");

$fa73f494791b08e6$export$ba255e9e49e00608 = $hmT2x.ArrayObservable.of;

});

parcelRegister("hrJHY", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $zAMIg = parcelRequire("zAMIg");


var $fEWBj = parcelRequire("fEWBj");


var $fNVRJ = parcelRequire("fNVRJ");


var $1XTds = parcelRequire("1XTds");

/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */ function delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = $zAMIg.async;
    var absoluteDelay = $fEWBj.isDate(delay);
    var delayFor = absoluteDelay ? +delay - scheduler.now() : Math.abs(delay);
    return function(source) {
        return source.lift(new DelayOperator(delayFor, scheduler));
    };
}
exports.delay = delay;
var DelayOperator = function() {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var DelaySubscriber = function(_super) {
    __extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        _super.call(this, destination);
        this.delay = delay;
        this.scheduler = scheduler;
        this.queue = [];
        this.active = false;
        this.errored = false;
    }
    DelaySubscriber.dispatch = function(state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while(queue.length > 0 && queue[0].time - scheduler.now() <= 0)queue.shift().notification.observe(destination);
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        } else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function(scheduler) {
        this.active = true;
        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this,
            destination: this.destination,
            scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function(notification) {
        if (this.errored === true) return;
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) this._schedule(scheduler);
    };
    DelaySubscriber.prototype._next = function(value) {
        this.scheduleNotification($1XTds.Notification.createNext(value));
    };
    DelaySubscriber.prototype._error = function(err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
    };
    DelaySubscriber.prototype._complete = function() {
        this.scheduleNotification($1XTds.Notification.createComplete());
    };
    return DelaySubscriber;
}($fNVRJ.Subscriber);
var DelayMessage = function() {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}();

});

parcelRegister("zAMIg", function(module, exports) {
$parcel$export(module.exports, "async", () => $06afcdac526dbf67$export$12af436354f1a4f7, (v) => $06afcdac526dbf67$export$12af436354f1a4f7 = v);
/**
 *
 * Async Scheduler
 *
 * <span class="informal">Schedule task as if you used setTimeout(task, duration)</span>
 *
 * `async` scheduler schedules tasks asynchronously, by putting them on the JavaScript
 * event loop queue. It is best used to delay tasks in time or to schedule tasks repeating
 * in intervals.
 *
 * If you just want to "defer" task, that is to perform it right after currently
 * executing synchronous code ends (commonly achieved by `setTimeout(deferredTask, 0)`),
 * better choice will be the {@link asap} scheduler.
 *
 * @example <caption>Use async scheduler to delay task</caption>
 * const task = () => console.log('it works!');
 *
 * Rx.Scheduler.async.schedule(task, 2000);
 *
 * // After 2 seconds logs:
 * // "it works!"
 *
 *
 * @example <caption>Use async scheduler to repeat task in intervals</caption>
 * function task(state) {
 *   console.log(state);
 *   this.schedule(state + 1, 1000); // `this` references currently executing Action,
 *                                   // which we reschedule with new state and delay
 * }
 *
 * Rx.Scheduler.async.schedule(task, 3000, 0);
 *
 * // Logs:
 * // 0 after 3s
 * // 1 after 4s
 * // 2 after 5s
 * // 3 after 6s
 *
 * @static true
 * @name async
 * @owner Scheduler
 */ var $06afcdac526dbf67$export$12af436354f1a4f7;
"use strict";

var $1HJiA = parcelRequire("1HJiA");


var $fJ8RQ = parcelRequire("fJ8RQ");

$06afcdac526dbf67$export$12af436354f1a4f7 = new $fJ8RQ.AsyncScheduler($1HJiA.AsyncAction);

});

parcelRegister("fEWBj", function(module, exports) {
$parcel$export(module.exports, "isDate", () => $b6680c598ae7a287$export$871608497c498473, (v) => $b6680c598ae7a287$export$871608497c498473 = v);
var $b6680c598ae7a287$export$871608497c498473;
"use strict";
function $b6680c598ae7a287$var$isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
$b6680c598ae7a287$export$871608497c498473 = $b6680c598ae7a287$var$isDate;

});

parcelRegister("3vMGL", function(module, exports) {

var $5vwoh = parcelRequire("5vwoh");


var $bdgrV = parcelRequire("bdgrV");


var $a7dWT = parcelRequire("a7dWT");

const $a25ace4035d13584$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $5vwoh.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $bdgrV.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
     * Safari has a bug that returns the wrong month for years 2005 and before.
     * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
     * Not all the months fail in each year. To ensure the correct output,
     * we select 2020 as the base year for the whole date,
     * then we replace in the result the original input year
     */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $a7dWT.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $a7dWT.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
     * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
     * We fix it by detecting the real time with getHours method
     */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};
module.exports["createLocalizationProvider"] = $a25ace4035d13584$export$ea56ca58f08ffa52;

});

parcelRegister("5vwoh", function(module, exports) {
const $f2dacbe0eea831b8$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');
module.exports["normalizeLocale"] = $f2dacbe0eea831b8$export$dca0327c9b9c6498;

});

parcelRegister("bdgrV", function(module, exports) {

var $5vwoh = parcelRequire("5vwoh");


var $kGZoG = parcelRequire("kGZoG");


var $8w4cs = parcelRequire("8w4cs");


var $cafP2 = parcelRequire("cafP2");

const $8d32407758572e3f$var$INVALID_DATE = new Date(NaN);
const $8d32407758572e3f$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $8d32407758572e3f$var$INVARIANT_DATE = (0, $cafP2.toDate)($8d32407758572e3f$var$INVARIANT);
const $8d32407758572e3f$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $8d32407758572e3f$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $8d32407758572e3f$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $8d32407758572e3f$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $8d32407758572e3f$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $5vwoh.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($8d32407758572e3f$var$INVARIANT_DATE);
    const shortDate = $8d32407758572e3f$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($8d32407758572e3f$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $8d32407758572e3f$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($8d32407758572e3f$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($8d32407758572e3f$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($8d32407758572e3f$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $8d32407758572e3f$var$stripExtras(date).match($8d32407758572e3f$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $8d32407758572e3f$var$INVALID_DATE;
        const dateParts = $8d32407758572e3f$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $8w4cs.normalizeDate)(extractedDate, options?.defaultFirstDay);
        if (!(0, $kGZoG.isValid)(normalizedDate)) return $8d32407758572e3f$var$INVALID_DATE;
        return (0, $cafP2.toDate)(normalizedDate);
    };
};
module.exports["createDateParser"] = $8d32407758572e3f$export$cfa2ef2687faeda2;

});

parcelRegister("kGZoG", function(module, exports) {

var $aDvYS = parcelRequire("aDvYS");

const $8985e2fc067d563b$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = (0, $aDvYS.getDaysInMonth)(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
module.exports["isValid"] = $8985e2fc067d563b$export$1ea939691cdc45b8;

});

parcelRegister("aDvYS", function(module, exports) {

var $6NKSh = parcelRequire("6NKSh");

const $e96e8b0ab312aaba$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && (0, $6NKSh.isLeapYear)(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
module.exports["getDaysInMonth"] = $e96e8b0ab312aaba$export$f645ddd439eb259d;

});

parcelRegister("6NKSh", function(module, exports) {
const $04f001925dc3d06f$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
module.exports["isLeapYear"] = $04f001925dc3d06f$export$553d7fa8e3805fc0;

});

parcelRegister("8w4cs", function(module, exports) {

var $9tavx = parcelRequire("9tavx");

const $7e5174e81eb823af$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = (0, $9tavx.toDateObj)(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};
module.exports["normalizeDate"] = $7e5174e81eb823af$export$fcc71269590ba0a8;

});

parcelRegister("9tavx", function(module, exports) {
const $4b828859bff16031$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
module.exports["toDateObj"] = $4b828859bff16031$export$abe96da78d4f59dd;

});

parcelRegister("cafP2", function(module, exports) {
const $70268879eaf1b092$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
module.exports["toDate"] = $70268879eaf1b092$export$e67a095c620b86fe;

});

parcelRegister("a7dWT", function(module, exports) {
const $13d20959c22b69ba$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});
module.exports["toFormattedParts"] = $13d20959c22b69ba$export$9b7ca29af37c192;

});

parcelRegister("17wiG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $ixfCV = parcelRequire("ixfCV");


var $3lbOc = parcelRequire("3lbOc");


var $a1L5E = parcelRequire("a1L5E");

const $7f8f90030369ae01$var$MediaCardContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({});
const $7f8f90030369ae01$var$CardLoadingWithContext = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const props = (0, $cozmU.useContext)($7f8f90030369ae01$var$MediaCardContext);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3lbOc.CardLoading), {
            ...props,
            interactionName: "media-card-async-loading"
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const props = (0, $cozmU.useContext)($7f8f90030369ae01$var$MediaCardContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3lbOc.CardLoading), {
        ...props,
        interactionName: "media-card-async-loading"
    });
};

function $7f8f90030369ae01$var$loadCardWithMediaClient() {
    return (parcelRequire("1B8nD"));
}
const $7f8f90030369ae01$var$MediaCardWithMediaClientLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "a0IPb",
    name: "MediaCardWithMediaClientLoadable",
    loader: ()=>$7f8f90030369ae01$var$loadCardWithMediaClient().then((mod)=>mod.CardWithMediaClient),
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$CardLoadingWithContext, null)
});
const $7f8f90030369ae01$var$MediaCardWithMediaClientLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>$7f8f90030369ae01$var$loadCardWithMediaClient().then((mod)=>({
            default: mod.CardWithMediaClient
        })));
const $7f8f90030369ae01$var$CardLoader = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $ixfCV.fg)("platform_media_react19_support") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$CardLoadingWithContext, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$MediaCardWithMediaClientLazy, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$MediaCardWithMediaClientLoadable, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props || $[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "media-card",
            mode: "list"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$MediaCardContext.Provider, {
            value: props
        }, t0));
        $[2] = props;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "media-card",
        mode: "list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$MediaCardContext.Provider, {
        value: props
    }, (0, $ixfCV.fg)('platform_media_react19_support') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$CardLoadingWithContext, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$MediaCardWithMediaClientLazy, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$MediaCardWithMediaClientLoadable, props)));
};
$7f8f90030369ae01$var$CardLoader.preload = ()=>{
    if ((0, $ixfCV.fg)('platform_media_react19_support')) $7f8f90030369ae01$var$loadCardWithMediaClient().then(()=>{});
    else $7f8f90030369ae01$var$MediaCardWithMediaClientLoadable.preload?.();
};
var $7f8f90030369ae01$export$2e2bcd8739ae039 = $7f8f90030369ae01$var$CardLoader;
module.exports["default"] = $7f8f90030369ae01$export$2e2bcd8739ae039;

});

parcelRegister("3lbOc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lfoFx = parcelRequire("lfoFx");


var $ieeJu = parcelRequire("ieeJu");


var $97Pj3 = parcelRequire("97Pj3");


var $8quKc = parcelRequire("8quKc");


var $1pEse = parcelRequire("1pEse");

const $9010bd9f06816b06$export$5d25853fd6bdf402 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { dimensions: dimensionsProp, testId: testId, interactionName: interactionName } = t0;
    let t1;
    if ($[0] !== dimensionsProp) {
        t1 = (0, $8quKc.getDimensionsWithDefault)(dimensionsProp);
        $[0] = dimensionsProp;
        $[1] = t1;
    } else t1 = $[1];
    const dimensions = t1;
    const t2 = testId || "media-card-loading";
    let t3;
    if ($[2] !== interactionName) {
        t3 = (0, $ieeJu.expValEquals)("cc-maui-ai-edit-loading-experiment", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $97Pj3.LoadingBar), {
            interactionName: interactionName || "media-card-loading"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            interactionName: interactionName || "media-card-loading"
        });
        $[2] = interactionName;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== dimensions || $[5] !== t2 || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1pEse.Wrapper), {
            "data-testid": t2,
            "data-test-loading": true,
            dimensions: dimensions,
            "data-vc": "media-card-loading"
        }, t3);
        $[4] = dimensions;
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ dimensions: dimensionsProp, testId: testId, interactionName: interactionName })=>{
    const dimensions = (0, $8quKc.getDimensionsWithDefault)(dimensionsProp);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1pEse.Wrapper), {
        "data-testid": testId || 'media-card-loading',
        "data-test-loading": true,
        dimensions: dimensions,
        "data-vc": "media-card-loading"
    }, (0, $ieeJu.expValEquals)('cc-maui-ai-edit-loading-experiment', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $97Pj3.LoadingBar), {
        interactionName: interactionName || 'media-card-loading'
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        interactionName: interactionName || 'media-card-loading'
    }));
};
module.exports["CardLoading"] = $9010bd9f06816b06$export$5d25853fd6bdf402;

});

parcelRegister("97Pj3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $5EzLH = parcelRequire("5EzLH");

const $9d658d6460d574ed$var$TICK_INTERVAL_MS = 1000;
const $9d658d6460d574ed$var$STATIC_PROGRESS_VALUE = 0.9; /**
                                    * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
                                    * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
                                    * which makes things simpler than doing an `isServer` check or a `null` check.
                                    *
                                    * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
                                    */ 
const $9d658d6460d574ed$var$useLayoutEffect = typeof window === 'undefined' ? (0, $cozmU.useEffect) : (0, $cozmU.useLayoutEffect);
const $9d658d6460d574ed$var$messages = (0, $kSwu1.defineMessages)({
    loadingBarLabel: {
        id: "fabric.media.loading_bar_label",
        defaultMessage: "Loading"
    }
});
const $9d658d6460d574ed$var$trackStyles = null;
const $9d658d6460d574ed$var$fillStyles = null;
const $9d658d6460d574ed$var$clampToPercent = (progress)=>Math.min(1, Math.max(0, progress)) * 100;
const $9d658d6460d574ed$export$6665614bc5d690f6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { animationDisabled: t1, testId: testId, interactionName: interactionName } = t0;
    const animationDisabled = t1 === undefined ? false : t1;
    const intl = (0, $kSwu1.useIntl)();
    const [progress, setProgress] = (0, $cozmU.useState)(animationDisabled ? $9d658d6460d574ed$var$STATIC_PROGRESS_VALUE : 0);
    const intervalRef = (0, $cozmU.useRef)();
    const interactionContext = (0, $cozmU.useContext)((0, $5EzLH.default));
    let t2;
    let t3;
    if ($[0] !== interactionContext || $[1] !== interactionName) {
        t2 = ()=>{
            if (interactionContext != null) return interactionContext.hold(interactionName);
        };
        t3 = [
            interactionContext,
            interactionName
        ];
        $[0] = interactionContext;
        $[1] = interactionName;
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    $9d658d6460d574ed$var$useLayoutEffect(t2, t3);
    let t4;
    let t5;
    if ($[4] !== animationDisabled) {
        t4 = ()=>{
            if (animationDisabled) {
                setProgress($9d658d6460d574ed$var$STATIC_PROGRESS_VALUE);
                return;
            }
            intervalRef.current = setInterval(()=>{
                setProgress((prev)=>{
                    if (prev < 0.1) return prev + 0.1;
                    else {
                        if (prev < 0.6) return prev + 0.35;
                        else {
                            if (prev < 0.9) return prev + 0.1;
                        }
                    }
                    clearInterval(intervalRef.current);
                    return prev;
                });
            }, $9d658d6460d574ed$var$TICK_INTERVAL_MS);
            return ()=>clearInterval(intervalRef.current);
        };
        t5 = [
            animationDisabled
        ];
        $[4] = animationDisabled;
        $[5] = t4;
        $[6] = t5;
    } else {
        t4 = $[5];
        t5 = $[6];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[7] !== intl) {
        t6 = intl.formatMessage($9d658d6460d574ed$var$messages.loadingBarLabel);
        $[7] = intl;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $hekY6.default)([
            "_1reo15vq _18m915vq _2rko1rr0 _kqswstnw _94n5u2gc _1bsb1lk2 _1ltv1ghs _4t3ii2wt _bfhki8nm"
        ]);
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== progress) {
        t8 = $9d658d6460d574ed$var$clampToPercent(progress);
        $[10] = progress;
        $[11] = t8;
    } else t8 = $[11];
    const t9 = `${t8}%`;
    let t10;
    if ($[12] !== t9) {
        t10 = {
            width: t9
        };
        $[12] = t9;
        $[13] = t10;
    } else t10 = $[13];
    let t11;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (0, $hekY6.default)([
            "_2rko1rr0 _v564aq9m _1e0c1ule _4t3i1osq _bfhk10ef"
        ]);
        $[14] = t11;
    } else t11 = $[14];
    let t12;
    if ($[15] !== t10) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: t10,
            className: t11
        });
        $[15] = t10;
        $[16] = t12;
    } else t12 = $[16];
    let t13;
    if ($[17] !== progress || $[18] !== t12 || $[19] !== t6 || $[20] !== testId) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            role: "progressbar",
            "aria-valuenow": progress,
            "aria-label": t6,
            "data-testid": testId,
            className: t7
        }, t12);
        $[17] = progress;
        $[18] = t12;
        $[19] = t6;
        $[20] = testId;
        $[21] = t13;
    } else t13 = $[21];
    return t13;
} : ({ animationDisabled: animationDisabled = false, testId: testId, interactionName: interactionName })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [progress, setProgress] = (0, $cozmU.useState)(animationDisabled ? $9d658d6460d574ed$var$STATIC_PROGRESS_VALUE : 0);
    const intervalRef = (0, $cozmU.useRef)();
    const interactionContext = (0, $cozmU.useContext)((0, $5EzLH.default));
    $9d658d6460d574ed$var$useLayoutEffect(()=>{
        if (interactionContext != null) return interactionContext.hold(interactionName);
    }, [
        interactionContext,
        interactionName
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (animationDisabled) {
            setProgress($9d658d6460d574ed$var$STATIC_PROGRESS_VALUE);
            return;
        }
        intervalRef.current = setInterval(()=>{
            setProgress((prev)=>{
                if (prev < 0.1) return prev + 0.1;
                else if (prev < 0.6) return prev + 0.35;
                else if (prev < 0.9) return prev + 0.1;
                clearInterval(intervalRef.current);
                return prev;
            });
        }, $9d658d6460d574ed$var$TICK_INTERVAL_MS);
        return ()=>clearInterval(intervalRef.current);
    }, [
        animationDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "progressbar",
        "aria-valuenow": progress,
        "aria-label": intl.formatMessage($9d658d6460d574ed$var$messages.loadingBarLabel),
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _2rko1rr0 _kqswstnw _94n5u2gc _1bsb1lk2 _1ltv1ghs _4t3ii2wt _bfhki8nm"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            width: `${$9d658d6460d574ed$var$clampToPercent(progress)}%`
        },
        className: (0, $hekY6.default)([
            "_2rko1rr0 _v564aq9m _1e0c1ule _4t3i1osq _bfhk10ef"
        ])
    }));
};
module.exports["LoadingBar"] = $9d658d6460d574ed$export$6665614bc5d690f6;

});

parcelRegister("1pEse", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $ew4xH = parcelRequire("ew4xH");

const $edacca4f67c5c3ed$export$e6dfd72ab29f8598 = (props)=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: (0, $ew4xH.wrapperStyles)({
            dimensions: props.dimensions
        }),
        ...props
    }, props.children));
};
module.exports["Wrapper"] = $edacca4f67c5c3ed$export$e6dfd72ab29f8598;

});

parcelRegister("ew4xH", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");


var $9AILw = parcelRequire("9AILw");

const $b57e90473f867d52$export$491e6397d7c1480b = ({ dimensions: dimensions })=>/*#__PURE__*/ (0, $lOiVq.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $9AILw.center), "position:relative;background:var(--ds-surface-sunken, #F8F8F8);color:var(--ds-icon, #292A2E);", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $9AILw.borderRadius), {
        maxHeight: '100%',
        maxWidth: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: dimensions.width,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: dimensions.height
    });
module.exports["wrapperStyles"] = $b57e90473f867d52$export$491e6397d7c1480b;

});

parcelRegister("9AILw", function(module, exports) {
const $1086bc1f8c9770f0$export$a5b94313d6908893 = (maxWidth = '100%')=>{
    const unit = typeof maxWidth === 'number' ? 'px' : '';
    return `
    max-width: ${maxWidth}${unit};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `;
};
const $1086bc1f8c9770f0$export$346677f925de839c = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `
    width: ${value}${unit};
    height: ${value}${unit};
  `;
};
const $1086bc1f8c9770f0$export$3481c78889e8fbe8 = `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $1086bc1f8c9770f0$export$d31af2dc8039efd3 = (top = 0, left = 0)=>`
  position: absolute;
  top: ${top}px;
  left: ${left}px;
`;
const $1086bc1f8c9770f0$export$7a57f79000377ca2 = `
  border-radius: ${"var(--ds-radius-small, 3px)"};
`;
const $1086bc1f8c9770f0$export$a98155aef1bfd63 = `
  border-bottom-left-radius: ${"var(--ds-radius-small, 3px)"};
  border-bottom-right-radius: ${"var(--ds-radius-small, 3px)"};
`;
const $1086bc1f8c9770f0$export$24656b269d8df7d6 = 'cubic-bezier(0.645, 0.045, 0.355, 1)';
module.exports["size"] = $1086bc1f8c9770f0$export$346677f925de839c;
module.exports["center"] = $1086bc1f8c9770f0$export$3481c78889e8fbe8;
module.exports["borderRadius"] = $1086bc1f8c9770f0$export$7a57f79000377ca2;

});

parcelRegister("1B8nD", function(module, exports) {

let $129fbf4534065794$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $129fbf4534065794$var$load("6Xt27"),
    $129fbf4534065794$var$load("ddvkk"),
    $129fbf4534065794$var$load("3upHR"),
    $129fbf4534065794$var$load("hZ2FX"),
    $129fbf4534065794$var$load("6OMo6"),
    $129fbf4534065794$var$load("aaRXj"),
    $129fbf4534065794$var$load("fHlIz"),
    $129fbf4534065794$var$load("4QwAJ"),
    $129fbf4534065794$var$load("3i44s"),
    $129fbf4534065794$var$load("5kI0b"),
    $129fbf4534065794$var$load("kYkz1"),
    $129fbf4534065794$var$load("jfYeU"),
    $129fbf4534065794$var$load("b4nm1"),
    $129fbf4534065794$var$load("geXPZ"),
    $129fbf4534065794$var$load("aQ5uu"),
    $129fbf4534065794$var$load("6wr18"),
    $129fbf4534065794$var$load("lVz4k"),
    $129fbf4534065794$var$load("fV46K"),
    $129fbf4534065794$var$load("aOIZj"),
    $129fbf4534065794$var$load("7EorR"),
    $129fbf4534065794$var$load("jOE2W"),
    $129fbf4534065794$var$load("jTOhL"),
    $129fbf4534065794$var$load("cuNBo"),
    $129fbf4534065794$var$load("2XRLb"),
    $129fbf4534065794$var$load("gkVge"),
    $129fbf4534065794$var$load("io0qR"),
    $129fbf4534065794$var$load("3MJxZ"),
    $129fbf4534065794$var$load("kHMR7"),
    $129fbf4534065794$var$load("e3OZZ"),
    $129fbf4534065794$var$load("cL682"),
    $129fbf4534065794$var$load("4MePG"),
    $129fbf4534065794$var$load("4Ldt2"),
    $129fbf4534065794$var$load("5JWJI"),
    $129fbf4534065794$var$load("ffEVr"),
    $129fbf4534065794$var$load("7gPXS")
]).then(()=>parcelRequire('gnpwR'));

});

parcelRegister("hEt1x", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $g9ZnD = parcelRequire("g9ZnD");


var $IY7Mb = parcelRequire("IY7Mb");

const $2ddf178f2decc0e9$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(undefined);
const $2ddf178f2decc0e9$export$57164260bc1f1218 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings } = t0;
    let t1;
    if ($[0] !== mediaClientConfig) {
        t1 = (0, $g9ZnD.getMediaClient)(mediaClientConfig);
        $[0] = mediaClientConfig;
        $[1] = t1;
    } else t1 = $[1];
    const mediaClient = t1;
    const settings = (0, $IY7Mb.useMediaParsedSettings)(mediaSettings);
    let t2;
    if ($[2] !== mediaClient || $[3] !== settings) {
        t2 = {
            mediaClient: mediaClient,
            settings: settings
        };
        $[2] = mediaClient;
        $[3] = settings;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== children || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2ddf178f2decc0e9$export$c94ff18a59d4c4d.Provider, {
            value: t2
        }, children);
        $[5] = children;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $cozmU.useMemo)(()=>(0, $g9ZnD.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $IY7Mb.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2ddf178f2decc0e9$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        }
    }, children);
};
module.exports["MediaContext"] = $2ddf178f2decc0e9$export$c94ff18a59d4c4d;
module.exports["MediaProvider"] = $2ddf178f2decc0e9$export$57164260bc1f1218;

});

parcelRegister("IY7Mb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gYqFD = parcelRequire("gYqFD");

const $a0017e6c99530c15$export$d54af28440a5efc0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const mediaSettings = t1;
    let newSettings;
    if ($[2] !== mediaSettings) {
        newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $gYqFD.defaultMediaUserPreferences);
        $[2] = mediaSettings;
        $[3] = newSettings;
    } else newSettings = $[3];
    const settings = newSettings;
    return settings;
} : (mediaSettings = {})=>{
    const settings = (0, $cozmU.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $gYqFD.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};
module.exports["useMediaParsedSettings"] = $a0017e6c99530c15$export$d54af28440a5efc0;

});

parcelRegister("gYqFD", function(module, exports) {
// Currently only supports boolean, string. Uncomment below to support number
const $c55cff04bbd4c82d$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $c55cff04bbd4c82d$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($c55cff04bbd4c82d$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $c55cff04bbd4c82d$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $c55cff04bbd4c82d$export$2d23ed2854ac1650 = $c55cff04bbd4c82d$export$7e209e67b965bc63($c55cff04bbd4c82d$var$defaultUserPreferences);
module.exports["defaultMediaUserPreferences"] = $c55cff04bbd4c82d$export$2d23ed2854ac1650;

});

parcelRegister("gjPL4", function(module, exports) {
const $2cc17340c0c1baf9$export$d87a47989c00f322 = {
    width: 156,
    height: 125
};
const $2cc17340c0c1baf9$export$aeb48196afcd236a = {
    width: 435,
    height: 125
};
const $2cc17340c0c1baf9$export$1ad38773a5cc4cb0 = {
    width: 300,
    height: 300
};
const $2cc17340c0c1baf9$export$ed7b8a4728e9c63 = (appearance)=>{
    if (appearance === 'image') return $2cc17340c0c1baf9$export$d87a47989c00f322;
    if (appearance === 'square') return $2cc17340c0c1baf9$export$1ad38773a5cc4cb0;
    if (appearance === 'horizontal') return $2cc17340c0c1baf9$export$aeb48196afcd236a;
    return $2cc17340c0c1baf9$export$d87a47989c00f322;
};
module.exports["defaultImageCardDimensions"] = $2cc17340c0c1baf9$export$d87a47989c00f322;
module.exports["getDefaultCardDimensions"] = $2cc17340c0c1baf9$export$ed7b8a4728e9c63;

});

parcelRegister("PGUCj", function(module, exports) {

var $jg98Q = parcelRequire("jg98Q");

const $edab81c479d02fd3$export$7695387cd66cf5b5 = (identifier)=>{
    return identifier.mediaItemType === 'file';
};
const $edab81c479d02fd3$export$2782f2fbff82f0c9 = (identifier)=>{
    return identifier.mediaItemType === 'external-image';
};
const $edab81c479d02fd3$export$5883721593c4e4b1 = (a, b)=>{
    if ($edab81c479d02fd3$export$7695387cd66cf5b5(a) && $edab81c479d02fd3$export$7695387cd66cf5b5(b)) return a.id !== b.id || a.collectionName !== b.collectionName || a.occurrenceKey !== b.occurrenceKey;
    else return !(0, (/*@__PURE__*/$parcel$interopDefault($jg98Q)))(a, b);
};
module.exports["isFileIdentifier"] = $edab81c479d02fd3$export$7695387cd66cf5b5;
module.exports["isExternalImageIdentifier"] = $edab81c479d02fd3$export$2782f2fbff82f0c9;

});

parcelRegister("jg98Q", function(module, exports) {
var $e0569a4986fb9bed$var$pSlice = Array.prototype.slice;

var $4P5TS = parcelRequire("4P5TS");


var $jmVod = parcelRequire("jmVod");

var $e0569a4986fb9bed$var$deepEqual = module.exports = function(actual, expected, opts) {
    if (!opts) opts = {};
    // 7.1. All identical values are equivalent, as determined by ===.
    if (actual === expected) return true;
    else if (actual instanceof Date && expected instanceof Date) return actual.getTime() === expected.getTime();
    else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') return opts.strict ? actual === expected : actual == expected;
    else return $e0569a4986fb9bed$var$objEquiv(actual, expected, opts);
};
function $e0569a4986fb9bed$var$isUndefinedOrNull(value) {
    return value === null || value === undefined;
}
function $e0569a4986fb9bed$var$isBuffer(x) {
    if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
    if (typeof x.copy !== 'function' || typeof x.slice !== 'function') return false;
    if (x.length > 0 && typeof x[0] !== 'number') return false;
    return true;
}
function $e0569a4986fb9bed$var$objEquiv(a, b, opts) {
    var i, key;
    if ($e0569a4986fb9bed$var$isUndefinedOrNull(a) || $e0569a4986fb9bed$var$isUndefinedOrNull(b)) return false;
    // an identical 'prototype' property.
    if (a.prototype !== b.prototype) return false;
    //~~~I've managed to break Object.keys through screwy arguments passing.
    //   Converting to array solves the problem.
    if ($jmVod(a)) {
        if (!$jmVod(b)) return false;
        a = $e0569a4986fb9bed$var$pSlice.call(a);
        b = $e0569a4986fb9bed$var$pSlice.call(b);
        return $e0569a4986fb9bed$var$deepEqual(a, b, opts);
    }
    if ($e0569a4986fb9bed$var$isBuffer(a)) {
        if (!$e0569a4986fb9bed$var$isBuffer(b)) return false;
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    try {
        var ka = $4P5TS(a), kb = $4P5TS(b);
    } catch (e) {
        return false;
    }
    // having the same number of owned properties (keys incorporates
    // hasOwnProperty)
    if (ka.length != kb.length) return false;
    //the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    //~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
    }
    //equivalent values for every corresponding key, and
    //~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!$e0569a4986fb9bed$var$deepEqual(a[key], b[key], opts)) return false;
    }
    return typeof a === typeof b;
}

});

parcelRegister("4P5TS", function(module, exports) {
exports = module.exports = typeof Object.keys === 'function' ? Object.keys : shim;
exports.shim = shim;
function shim(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
}

});

parcelRegister("jmVod", function(module, exports) {
var supportsArgumentsClass = function() {
    return Object.prototype.toString.call(arguments);
}() == '[object Arguments]';
exports = module.exports = supportsArgumentsClass ? supported : unsupported;
exports.supported = supported;
function supported(object) {
    return Object.prototype.toString.call(object) == '[object Arguments]';
}
exports.unsupported = unsupported;
function unsupported(object) {
    return object && typeof object == 'object' && typeof object.length == 'number' && Object.prototype.hasOwnProperty.call(object, 'callee') && !Object.prototype.propertyIsEnumerable.call(object, 'callee') || false;
}

});

parcelRegister("1tBud", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $2mOOd = parcelRequire("2mOOd");


var $717N0 = parcelRequire("717N0");


const $4cc16dba49469f3f$var$MediaViewer = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("92Mc6")).then(({ MediaViewerWithErrorBoundary: MediaViewerWithErrorBoundary })=>({
            default: MediaViewerWithErrorBoundary
        })));
const $4cc16dba49469f3f$var$AsyncMediaViewer = (0, $gtMdU.isReactCompilerActivePlatform)() ? function AsyncMediaViewer(props) {
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2mOOd.default), null);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: t0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $717N0.MediaViewerPortal), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4cc16dba49469f3f$var$MediaViewer, props)));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function AsyncMediaViewer(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2mOOd.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $717N0.MediaViewerPortal), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4cc16dba49469f3f$var$MediaViewer, props)));
};
var $4cc16dba49469f3f$export$2e2bcd8739ae039 = $4cc16dba49469f3f$var$AsyncMediaViewer;
module.exports["default"] = $4cc16dba49469f3f$export$2e2bcd8739ae039;

});

parcelRegister("2mOOd", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $imqjG = parcelRequire("imqjG");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $6ffa2f80eb372db6$export$442b7be89436c101 = '#101214';
const $6ffa2f80eb372db6$var$ModalSpinner = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const t0 = colorMode !== "dark";
    let t1;
    if ($[0] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $imqjG.default), {
            blankedColor: $6ffa2f80eb372db6$export$442b7be89436c101,
            invertSpinnerColor: t0
        });
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ()=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $imqjG.default), {
        blankedColor: $6ffa2f80eb372db6$export$442b7be89436c101,
        invertSpinnerColor: colorMode !== 'dark'
    });
};
var $6ffa2f80eb372db6$export$2e2bcd8739ae039 = $6ffa2f80eb372db6$var$ModalSpinner;
module.exports["default"] = $6ffa2f80eb372db6$export$2e2bcd8739ae039;

});

parcelRegister("imqjG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $knkYU = parcelRequire("knkYU");

const $75f640d6e866ba35$var$ModalSpinner = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $knkYU.default), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $knkYU.default), props);
var $75f640d6e866ba35$export$2e2bcd8739ae039 = $75f640d6e866ba35$var$ModalSpinner;
module.exports["default"] = $75f640d6e866ba35$export$2e2bcd8739ae039;

});

parcelRegister("knkYU", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ea0f137a8e557bc$export$2e2bcd8739ae039);
/* modalSpinner-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lfoFx = parcelRequire("lfoFx");

const $1ea0f137a8e557bc$var$blanketStyles = null;
const $1ea0f137a8e557bc$var$spinnerStyles = null;
const $1ea0f137a8e557bc$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $1ea0f137a8e557bc$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            backgroundColor: blankedColor || $1ea0f137a8e557bc$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        className: (0, $hekY6.default)([
            "_kqsw1n9t _154iidpf _1ltvidpf _94n5idpf _1xi2idpf _1pby1qpw"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        size: "large",
        appearance: invertSpinnerColor || $1ea0f137a8e557bc$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
        testId: 'media-modal-spinner'
    })));

});

parcelRegister("717N0", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cK21K = parcelRequire("cK21K");

const $60b53ae22e9372b5$export$51aee4c01b17acde = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
            zIndex: 510
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>// This zIndex matches with zIndex used by DS Modal and Jira Issue View Modal.
    // This value makes layers stack work correctly:
    //  -> Issue View -> Media Viewer -> DS Modal
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
        zIndex: 510
    }, children);
module.exports["MediaViewerPortal"] = $60b53ae22e9372b5$export$51aee4c01b17acde;

});

parcelRegister("92Mc6", function(module, exports) {

let $6959af56e5c25e15$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6959af56e5c25e15$var$load("6Xt27"),
    $6959af56e5c25e15$var$load("hZ2FX"),
    $6959af56e5c25e15$var$load("6OMo6"),
    $6959af56e5c25e15$var$load("aaRXj"),
    $6959af56e5c25e15$var$load("fHlIz"),
    $6959af56e5c25e15$var$load("4QwAJ"),
    $6959af56e5c25e15$var$load("3i44s"),
    $6959af56e5c25e15$var$load("5kI0b"),
    $6959af56e5c25e15$var$load("kYkz1"),
    $6959af56e5c25e15$var$load("jfYeU"),
    $6959af56e5c25e15$var$load("b4nm1"),
    $6959af56e5c25e15$var$load("geXPZ"),
    $6959af56e5c25e15$var$load("aQ5uu"),
    $6959af56e5c25e15$var$load("6wr18"),
    $6959af56e5c25e15$var$load("1xeJ3"),
    $6959af56e5c25e15$var$load("60PUI"),
    $6959af56e5c25e15$var$load("flY2n"),
    $6959af56e5c25e15$var$load("fV46K"),
    $6959af56e5c25e15$var$load("ffEVr"),
    $6959af56e5c25e15$var$load("jOE2W"),
    $6959af56e5c25e15$var$load("jTOhL"),
    $6959af56e5c25e15$var$load("cuNBo"),
    $6959af56e5c25e15$var$load("2XRLb"),
    $6959af56e5c25e15$var$load("gkVge"),
    $6959af56e5c25e15$var$load("io0qR"),
    $6959af56e5c25e15$var$load("3MJxZ"),
    $6959af56e5c25e15$var$load("kHMR7"),
    $6959af56e5c25e15$var$load("e3OZZ"),
    $6959af56e5c25e15$var$load("cL682"),
    $6959af56e5c25e15$var$load("4MePG"),
    $6959af56e5c25e15$var$load("4Ldt2"),
    $6959af56e5c25e15$var$load("5JWJI"),
    $6959af56e5c25e15$var$load("hhss7"),
    $6959af56e5c25e15$var$load("4jXCC")
]).then(()=>parcelRequire('9vMzD'));

});

parcelRegister("fA65V", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $c226a72f375a9da1$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    click_to_join: {
        id: "fabric.media.click_to_join",
        defaultMessage: "Join {context}"
    },
    click_to_join_description: {
        id: "fabric.media.click_to_join_description",
        defaultMessage: "You've been approved, so you can join {context} right away."
    },
    request_access: {
        id: "fabric.media.request_access",
        defaultMessage: "Request access"
    },
    request_access_description: {
        id: "fabric.media.request_access_description",
        defaultMessage: "Request access to {context} view this preview."
    },
    request_access_pending: {
        id: "fabric.media.request_access_pending",
        defaultMessage: "Access pending"
    },
    request_access_pending_description: {
        id: "fabric.media.request_access_pending_description",
        defaultMessage: "Your access request is pending."
    },
    forbidden_description: {
        id: "fabric.media.forbidden_description",
        defaultMessage: "You don\u2019t have access to this preview. Contact the site admin if you need access."
    },
    request_denied_description: {
        id: "fabric.media.request_denied_description",
        defaultMessage: "Your access request was denied. Contact the site admin if you still need access."
    },
    retry: {
        id: "fabric.media.retry",
        defaultMessage: "Retry"
    },
    failed_to_load: {
        id: "fabric.media.failed_to_load",
        defaultMessage: "Failed to load"
    },
    failed_to_upload: {
        id: "fabric.media.failed_to_upload",
        defaultMessage: "Failed to upload"
    },
    check_internet_connection: {
        id: "fabric.media.check_internet_connection",
        defaultMessage: "Failed to load. Please check your internet connection"
    },
    recent_uploads: {
        id: "fabric.media.recent_uploads",
        defaultMessage: "Recent uploads"
    },
    upload_file: {
        id: "fabric.media.upload_file",
        defaultMessage: "Upload a file"
    },
    drag_and_drop_your_files: {
        id: "fabric.media.drag_and_drop_your_files",
        defaultMessage: "Drag and drop your files anywhere or"
    },
    drag_and_drop_your_files_and_folders: {
        id: "fabric.media.drag_and_drop_your_files_and_folders",
        defaultMessage: "Drag and drop your files and folders anywhere or"
    },
    drop_your_files: {
        id: "fabric.media.drop_your_files",
        defaultMessage: "Drop your files to upload"
    },
    upload: {
        id: "fabric.media.upload",
        defaultMessage: "Upload"
    },
    cancel: {
        id: "fabric.media.cancel",
        defaultMessage: "Cancel"
    },
    delete: {
        id: "fabric.media.delete",
        defaultMessage: "Delete"
    },
    success: {
        id: "fabric.media.success",
        defaultMessage: "Success"
    },
    error: {
        id: "fabric.media.error",
        defaultMessage: "Error"
    },
    search_all_gifs: {
        id: "fabric.media.search_all_gifs",
        defaultMessage: "Search all the GIFs!"
    },
    cant_retrieve_gifs: {
        id: "fabric.media.cant_retrieve_gifs",
        defaultMessage: "Ouch! We could not retrieve any GIFs"
    },
    cant_retrieve_files: {
        id: "fabric.media.cant_retrieve_files",
        defaultMessage: "Ouch! We could not retrieve any files"
    },
    check_your_network: {
        id: "fabric.media.check_your_network",
        defaultMessage: "Check your network connection"
    },
    try_again: {
        id: "fabric.media.try_again",
        defaultMessage: "Try again"
    },
    try_another_account: {
        id: "fabric.media.try_another_account",
        defaultMessage: "Try another account"
    },
    no_gifs_found: {
        id: "fabric.media.no_gifs_found",
        defaultMessage: "Hello? Was it me you're looking for?"
    },
    no_gifs_found_suggestion: {
        id: "fabric.media.no_gifs_found_suggestion",
        defaultMessage: "We couldn't find anything for \"{query}\""
    },
    load_more_gifs: {
        id: "fabric.media.load_more_gifs",
        defaultMessage: "Load more GIFs"
    },
    add_account: {
        id: "fabric.media.add_account",
        defaultMessage: "Add account"
    },
    unlink_account: {
        id: "fabric.media.unlink_account",
        defaultMessage: "Unlink Account"
    },
    upload_file_from: {
        id: "fabric.media.upload_file_from",
        defaultMessage: "Upload a file from {name}"
    },
    connect_to: {
        id: "fabric.media.connect_to",
        defaultMessage: "Connect to {name}"
    },
    connect_account_description: {
        id: "fabric.media.connect_account_description",
        defaultMessage: "We'll open a new page to help you connect your {name} account"
    },
    connect_link_account: {
        id: "fabric.media.connect_link_account",
        defaultMessage: "Connect to preview"
    },
    connect_link_account_card: {
        id: "fabric.media.connect_link_account_card_view",
        defaultMessage: "Connect"
    },
    connect_link_account_card_name: {
        id: "fabric.media.connect_link_account_card_view_name",
        defaultMessage: "Connect your {context} account"
    },
    connect_link_account_card_description: {
        id: "fabric.media.connect_link_account_card_view_description",
        defaultMessage: "To show a preview of this link, connect your {context} account."
    },
    invalid_permissions: {
        id: "fabric.media.invalid_permissions",
        defaultMessage: "Restricted link"
    },
    invalid_permissions_description: {
        id: "fabric.media.invalid_permissions_description",
        defaultMessage: "You'll need to request access or try a different account to view this preview."
    },
    select_an_avatar: {
        id: "fabric.media.select_an_avatar",
        defaultMessage: "Select a default avatar"
    },
    upload_an_avatar: {
        id: "fabric.media.upload_an_avatar",
        defaultMessage: "Upload an avatar"
    },
    select_an_avatar_from_all_defaults: {
        id: "fabric.media.select_an_avatar_from_all_defaults",
        defaultMessage: "Select from all default options"
    },
    select_an_avatar_option: {
        id: "fabric.media.select_an_avatar_option",
        defaultMessage: "Default avatar option {number}"
    },
    show_more_avatars_btn_label: {
        id: "fabric.media.show_more_avatars_btn_label",
        defaultMessage: "Show more"
    },
    or_select_default_avatars: {
        id: "fabric.media.or_select_default_avatars",
        defaultMessage: "Upload a photo or select from some default options"
    },
    loading: {
        id: "fabric.media.loading",
        defaultMessage: "Loading..."
    },
    loading_file: {
        id: "fabric.media.loading_file",
        defaultMessage: "Loading file..."
    },
    save: {
        id: "fabric.media.save",
        defaultMessage: "Save"
    },
    or: {
        id: "fabric.media.or",
        defaultMessage: "or"
    },
    upload_photo: {
        id: "fabric.media.upload_photo",
        defaultMessage: "Upload a photo"
    },
    default_avatars: {
        id: "fabric.media.default_avatars",
        defaultMessage: "Default avatars"
    },
    avatar_picker_back_btn_label: {
        id: "fabric.media.avatar_picker_back_btn_label",
        defaultMessage: "Go Back"
    },
    drag_and_drop_images_here: {
        id: "fabric.media.drag_and_drop_images_here",
        defaultMessage: "Drag and drop your images here"
    },
    alt_text: {
        id: "fabric.media.alt_text_label",
        defaultMessage: "Alt text"
    },
    alt_text_description: {
        id: "fabric.media.alt_text_helper_message",
        defaultMessage: "How would you describe the selected image to someone with low vision?"
    },
    image_url_invalid_error: {
        id: "fabric.media.image_url_invalid_error",
        defaultMessage: "Could not load image, the url is invalid."
    },
    image_format_invalid_error: {
        id: "fabric.media.image_format_invalid_error",
        defaultMessage: "Could not load image, the format is invalid."
    },
    image_size_too_large_error: {
        id: "fabric.media.image_size_too_large_error",
        defaultMessage: "Image is too large, must be no larger than {MAX_SIZE_MB}Mb"
    },
    something_went_wrong: {
        id: "fabric.media.something_went_wrong",
        defaultMessage: "Something went wrong."
    },
    might_be_a_hiccup: {
        id: "fabric.media.might_be_a_hiccup",
        defaultMessage: "It might just be a hiccup."
    },
    couldnt_generate_preview: {
        id: "fabric.media.couldnt_generate_preview",
        defaultMessage: "We couldn't generate a preview for this file."
    },
    couldnt_generate_encrypted_entry_preview: {
        id: "fabric.media.couldnt_generate_encrypted_entry_preview",
        defaultMessage: "We can't preview encrypted or password protected files."
    },
    cant_preview_file_type: {
        id: "fabric.media.cant_preview_file_type",
        defaultMessage: "We can't preview this file type."
    },
    item_not_found_in_list: {
        id: "fabric.media.item_not_found_in_list",
        defaultMessage: "The selected item was not found on the list."
    },
    not_found_title: {
        id: "fabric.media.not_found_title",
        defaultMessage: "Uh oh. We can't find this link!"
    },
    not_found_description: {
        id: "fabric.media.not_found_description",
        defaultMessage: "We couldn't find the link. Check the url and try editing or paste again."
    },
    no_pdf_artifacts: {
        id: "fabric.media.no_pdf_artifacts",
        defaultMessage: "No PDF artifacts found for this file."
    },
    password_protected_pdf: {
        id: "fabric.media.password_protected_pdf",
        defaultMessage: "This file is password protected."
    },
    password: {
        id: "fabric.media.password",
        defaultMessage: "Password"
    },
    enter_password: {
        id: "fabric.media.enter_password",
        defaultMessage: "Enter password"
    },
    incorrect_password: {
        id: "fabric.media.incorrect_password",
        defaultMessage: "Incorrect password. Please try again."
    },
    submit: {
        id: "fabric.media.submit",
        defaultMessage: "Submit"
    },
    give_feedback: {
        id: "fabric.media.give_feedback",
        defaultMessage: "Give feedback"
    },
    try_downloading_file: {
        id: "fabric.media.try_downloading_file",
        defaultMessage: "Try downloading the file to view it."
    },
    archive_format_not_supported: {
        id: "fabric.media.archive_format_not_supported",
        defaultMessage: "Preview is not available for this file type."
    },
    unsupported_file_format: {
        id: "fabric.media.unsupported_file_format",
        defaultMessage: "Unsupported file format"
    },
    webgl_warning_description: {
        id: "fabric.media.webgl_warning_description",
        defaultMessage: "Your browser does not support WebGL. Use a WebGL enabled browser to annotate images."
    },
    unable_to_annotate_image: {
        id: "fabric.media.unable_to_annotate_image",
        defaultMessage: "You're unable to annotate this image"
    },
    learn_more: {
        id: "fabric.media.learn_more",
        defaultMessage: "Learn More"
    },
    accounts: {
        id: "fabric.media.accounts",
        defaultMessage: "Accounts"
    },
    actions: {
        id: "fabric.media.actions",
        defaultMessage: "Actions"
    },
    error_hint_retry: {
        id: "fabric.media.error_hint_retry",
        defaultMessage: "Try again and we'll give it another shot."
    },
    error_hint_critical: {
        id: "fabric.media.error_hint_critical",
        defaultMessage: "If the problem keeps happening contact support."
    },
    close: {
        id: "fabric.media.close",
        defaultMessage: "Close"
    },
    could_not_load_editor: {
        id: "fabric.media.could_not_load_editor",
        defaultMessage: "Ouch! We could not load the editor"
    },
    could_not_save_image: {
        id: "fabric.media.could_not_save_image",
        defaultMessage: "Ouch! We could not save the image"
    },
    could_not_load_link: {
        id: "fabric.media.couldnt_load_link",
        defaultMessage: "We couldn't load this link for an unknown reason."
    },
    annotate: {
        id: "fabric.media.annotate",
        defaultMessage: "Annotate"
    },
    annotate_tool_arrow: {
        id: "fabric.media.annotate.tool.arrow",
        defaultMessage: "Arrow"
    },
    annotate_tool_text: {
        id: "fabric.media.annotate.tool.text",
        defaultMessage: "Text"
    },
    annotate_tool_shape: {
        id: "fabric.media.annotate.tool.shape",
        defaultMessage: "Shape"
    },
    annotate_tool_brush: {
        id: "fabric.media.annotate.tool.brush",
        defaultMessage: "Brush"
    },
    annotate_tool_blur: {
        id: "fabric.media.annotate.tool.blur",
        defaultMessage: "Blur"
    },
    annotate_tool_line_thickness: {
        id: "fabric.media.annotate.tool.line.thickness",
        defaultMessage: "Line thickness"
    },
    annotate_tool_color: {
        id: "fabric.media.annotate.tool.color",
        defaultMessage: "Color"
    },
    annotate_confirmation_close_anyway: {
        id: "fabric.media.annotate.confirmation.close.anyway",
        defaultMessage: "Close anyway"
    },
    annotate_confirmation_heading: {
        id: "fabric.media.annotate.confirmation.heading",
        defaultMessage: "Unsaved changes"
    },
    annotate_confirmation_content: {
        id: "fabric.media.annotate.confirmation.content",
        defaultMessage: "You have some unsaved changes. Are you sure you want to leave?"
    },
    drop_your_files_here: {
        id: "fabric.media.drop_your_files_here",
        defaultMessage: "Drop your files here"
    },
    share_files_instantly: {
        id: "fabric.media.share_files_instantly",
        defaultMessage: "We'll share them instantly"
    },
    insert_files: {
        id: "fabric.media.insert_files",
        defaultMessage: "Insert {0, plural, one {a file} other {{0} files}}"
    },
    zoom_out: {
        id: "fabric.media.zoom_out",
        defaultMessage: "zoom out"
    },
    zoom_in: {
        id: "fabric.media.zoom_in",
        defaultMessage: "zoom in"
    },
    remove_image: {
        id: "fabric.media.remove_image",
        defaultMessage: "Remove image"
    },
    play: {
        id: "fabric.media.play",
        defaultMessage: "Play"
    },
    pause: {
        id: "fabric.media.pause",
        defaultMessage: "Pause"
    },
    disable_fullscreen: {
        id: "fabric.media.disable_fullscreen",
        defaultMessage: "disable fullscreen"
    },
    enable_fullscreen: {
        id: "fabric.media.enable_fullscreen",
        defaultMessage: "enable fullscreen"
    },
    error_loading_file: {
        id: "fabric.media.error_loading_file",
        defaultMessage: "Error loading file"
    },
    error_generating_preview: {
        id: "fabric.media.error_generating_preview",
        defaultMessage: "Error generating preview"
    },
    download: {
        id: "fabric.media.download",
        defaultMessage: "Download"
    },
    download_disabled_security_policy: {
        id: "fabric.media.download_disabled_security_policy",
        defaultMessage: "Download is blocked by your organization's security policy."
    },
    unknown: {
        id: "fabric.media.unknown",
        defaultMessage: "unknown"
    },
    document: {
        id: "fabric.media.document",
        defaultMessage: "document"
    },
    audio: {
        id: "fabric.media.audio",
        defaultMessage: "audio"
    },
    video: {
        id: "fabric.media.video",
        defaultMessage: "video"
    },
    image: {
        id: "fabric.media.image",
        defaultMessage: "image"
    },
    archive: {
        id: "fabric.media.archive",
        defaultMessage: "archive"
    },
    email: {
        id: "fabric.media.email",
        defaultMessage: "email"
    },
    text: {
        id: "fabric.media.text",
        defaultMessage: "text"
    },
    displayThumbnail: {
        id: "fabric.media.display_thumbnail",
        defaultMessage: "Display thumbnail"
    },
    search: {
        id: "fabric.media.search",
        defaultMessage: "search"
    },
    view: {
        id: "fabric.media.view",
        defaultMessage: "View"
    },
    viewIn: {
        id: "fabric.media.srclink",
        defaultMessage: "View in"
    },
    viewOriginal: {
        id: "fabric.media.srclinkunknown",
        defaultMessage: "View Original"
    },
    changeView: {
        id: "fabric.media.change_view",
        defaultMessage: "Change view"
    },
    playbackSpeed: {
        id: "fabric.media.playback_speed",
        defaultMessage: "Playback speed"
    },
    video_captions_enable: {
        id: "fabric.media.video_captions_enable",
        defaultMessage: "Closed Captions"
    },
    video_captions_select_captions: {
        id: "fabric.media.video_captions_select_captions",
        defaultMessage: "Select Captions"
    },
    video_captions_upload_captions_form_header: {
        id: "fabric.media.video_captions_upload_captions_form_header",
        defaultMessage: "Upload Captions"
    },
    video_captions_upload_captions_form_language_picker: {
        id: "fabric.media.video_captions_upload_captions_form_language_picker",
        defaultMessage: "Select the file language"
    },
    video_captions_upload_success_description: {
        id: "fabric.media.video_captions_upload_success_description",
        defaultMessage: "The caption was successfully uploaded for this video."
    },
    video_captions_upload_error_description: {
        id: "fabric.media.video_captions_upload_error_description",
        defaultMessage: "The caption failed to upload."
    },
    video_captions_delete_captions_confirmation_header: {
        id: "fabric.media.video_captions_delete_captions_confirmation_header",
        defaultMessage: "Delete Caption"
    },
    video_captions_delete_captions_confirmation_description: {
        id: "fabric.media.video_captions_delete_captions_confirmation_description",
        defaultMessage: "Please confirm that you want to delete this caption."
    },
    video_captions_delete_success_description: {
        id: "fabric.media.video_captions_delete_success_description",
        defaultMessage: "The caption was successfully removed from this video."
    },
    video_captions_delete_error_description: {
        id: "fabric.media.video_captions_delete_error_description",
        defaultMessage: "The caption failed to delete."
    },
    manage_captions: {
        id: "fabric.media.manage_captions",
        defaultMessage: "Manage Captions"
    },
    add_captions: {
        id: "fabric.media.add_captions",
        defaultMessage: "Add Captions"
    },
    skipBackward: {
        id: "fabric.media.skip_backward",
        defaultMessage: "Back 10 seconds"
    },
    skipForward: {
        id: "fabric.media.skip_forward",
        defaultMessage: "Forward 10 seconds"
    },
    sizeOptions: {
        id: "fabric.media.size_options",
        defaultMessage: "Size options"
    },
    fileDisplayOptions: {
        id: "fabric.media.file.display_options",
        defaultMessage: "Display options"
    },
    volumeLevelControlAria: {
        id: "fabric.media.volume_level",
        defaultMessage: "volume"
    },
    volumeMuteButtonAria: {
        id: "fabric.media.volume_level",
        defaultMessage: "mute"
    },
    playbackDefaultSpeed: {
        id: "fabric.media.playback_default_speed",
        defaultMessage: "Default"
    },
    expand: {
        id: "fabric.media.expand",
        defaultMessage: "Expand"
    },
    preview: {
        id: "fabric.media.preview",
        defaultMessage: "Preview"
    },
    creating_preview: {
        id: "fabric.media.creating_preview",
        defaultMessage: "Creating preview..."
    },
    preview_unavailable: {
        id: "fabric.media.preview_unavailable",
        defaultMessage: "Preview unavailable"
    },
    couldnt_load_file: {
        id: "fabric.media.couldnt_load_file",
        defaultMessage: "We couldn't load the file."
    },
    error_429: {
        id: "fabric.media.error_429",
        defaultMessage: "Error 429"
    },
    close_and_reopen: {
        id: "fabric.media.close_and_reopen",
        defaultMessage: "Try closing this file and reopening."
    },
    viewer_rateLimited: {
        id: "fabric.media.viewer_rateLimited",
        defaultMessage: "We're having difficulties loading your file."
    },
    zip_entry_load_fail: {
        id: "fabric.media.zip_entry_load_failed",
        defaultMessage: "We couldn't load that zip file item to preview"
    },
    file_image_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Image {name} is selected"
    },
    file_video_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Video {name} is selected"
    },
    file_audio_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Audio {name} is selected"
    },
    file_doc_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Document {name} is selected"
    },
    file_archive_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Archive {name} is selected"
    },
    file_unknown_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "File {name} is selected"
    },
    open_file_in_viewer: {
        id: "fabric.media.open_file_in_viewer",
        defaultMessage: "Open {name}"
    },
    open_file_in_viewer_aria_label: {
        id: "fabric.media.open_file_in_viewer_aria_label",
        defaultMessage: "Open {name} in fullscreen"
    },
    video_seeker_assistive_text_time_value: {
        id: "fabric.media.video_seeker_assistive_text_time_value",
        defaultMessage: "{currentTimeHours} {currentTimeMinutes} {currentTimeSeconds} of {videoTotalHours} {videoTotalMinutes} {videoTotalSeconds}"
    },
    video_seeker_label_assistive_text: {
        id: "fabric.media.video_seeker_label_assistive_text",
        defaultMessage: "Seek slider"
    },
    abuse_modal_body: {
        id: "fabric.media.abuse_modal_body",
        defaultMessage: "For your security, our system automatically scans all uploaded files. The file you are about to download potentially contains malicious content"
    },
    abuse_modal_title: {
        id: "fabric.media.abuse_modal_title",
        defaultMessage: "Warning"
    },
    abuse_modal_submit: {
        id: "fabric.media.abuse_modal_submit",
        defaultMessage: "Proceed with download"
    },
    image_cropper_arrow_keys_label: {
        id: "media.media-avatar-picker.image-cropper.arrow-keys.label",
        defaultMessage: "Draggable Image, Ensure your screen reader is not in browse mode. use arrow keys to move & crop the image"
    },
    image_cropper_image_moved: {
        id: "media.media-avatar-picker.image-cropper.arrow-keys.action",
        defaultMessage: "You have moved the image from {key, select, left {left to right} right {right to left} top {top to bottom} other {bottom to top} }, use arrow keys to move & crop the image"
    },
    image_cropper_zoom_out: {
        id: "media.media-avatar-picker.image-cropper.zoom_out",
        defaultMessage: "Zoom out"
    },
    image_cropper_zoom_in: {
        id: "media.media-avatar-picker.image-cropper.zoom_in",
        defaultMessage: "Zoom in"
    },
    image_cropper_zoom_slider: {
        id: "media.media-avatar-picker.image-cropper.zoom_slider",
        defaultMessage: "set zoom"
    },
    image_placer_img_alt: {
        id: "media.media-avatar-picker.image-placer.image-alt",
        defaultMessage: "Image preview"
    },
    svg_base_alt: {
        id: "media.media-viewer.base-svg.alt",
        defaultMessage: "Svg Image"
    },
    archive_download_label_assistive_text: {
        id: "media.media-viewer.archive-sidebar.wrapper.label_assistive_text",
        defaultMessage: "Download Media"
    }
});
module.exports["messages"] = $c226a72f375a9da1$export$defe85febe8b728c;

});

parcelRegister("lNvN4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $gIMcb = parcelRequire("gIMcb");


var $hEt1x = parcelRequire("hEt1x");

const $e5ff9295aa55af63$export$8b3e87ea56c3a345 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $gIMcb.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $hEt1x.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error("No MediaClient set, use MediaClientProvider or MediaProvider to set one");
    return mediaClient || altMediaClient;
} : ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $gIMcb.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $hEt1x.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};
module.exports["useMediaClient"] = $e5ff9295aa55af63$export$8b3e87ea56c3a345;

});

parcelRegister("4fGOw", function(module, exports) {

var $2BeWu = parcelRequire("2BeWu");


var $lNvN4 = parcelRequire("lNvN4");

const $dc2272ad9447ddc9$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $2BeWu.useStore)(store, selector, equals);
function $dc2272ad9447ddc9$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $lNvN4.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $dc2272ad9447ddc9$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}
module.exports["useMediaStore"] = $dc2272ad9447ddc9$export$8a9cc8c330400af8;

});

parcelRegister("2BeWu", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $1e4aa0b9c82f14cb$export$6ccbb43953eebf8);

var $8DZZz = parcelRequire("8DZZz");


var $cozmU = parcelRequire("cozmU");


var $aSzLn = parcelRequire("aSzLn");

var $1e4aa0b9c82f14cb$import_meta = Object.assign(Object.create(null), {
    url: "file:///../platform/node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $1e4aa0b9c82f14cb$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU)));
const { useSyncExternalStoreWithSelector: $1e4aa0b9c82f14cb$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($aSzLn)));
let $1e4aa0b9c82f14cb$var$didWarnAboutEqualityFn = false;
const $1e4aa0b9c82f14cb$var$identity = (arg)=>arg;
function $1e4aa0b9c82f14cb$export$6ccbb43953eebf8(api, selector = $1e4aa0b9c82f14cb$var$identity, equalityFn) {
    if (($1e4aa0b9c82f14cb$import_meta.env ? $1e4aa0b9c82f14cb$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$1e4aa0b9c82f14cb$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $1e4aa0b9c82f14cb$var$didWarnAboutEqualityFn = true;
    }
    const slice = $1e4aa0b9c82f14cb$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $1e4aa0b9c82f14cb$var$useDebugValue(slice);
    return slice;
}
const $1e4aa0b9c82f14cb$var$createImpl = (createState)=>{
    if (($1e4aa0b9c82f14cb$import_meta.env ? $1e4aa0b9c82f14cb$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $8DZZz.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$1e4aa0b9c82f14cb$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $1e4aa0b9c82f14cb$export$185802fd694ee1f5 = (createState)=>createState ? $1e4aa0b9c82f14cb$var$createImpl(createState) : $1e4aa0b9c82f14cb$var$createImpl;
var $1e4aa0b9c82f14cb$export$2e2bcd8739ae039 = (createState)=>{
    if (($1e4aa0b9c82f14cb$import_meta.env ? $1e4aa0b9c82f14cb$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $1e4aa0b9c82f14cb$export$185802fd694ee1f5(createState);
};

});

parcelRegister("c2smn", function(module, exports) {

var $adEwt = parcelRequire("adEwt");


var $hsnIS = parcelRequire("hsnIS");


var $iC5Q5 = parcelRequire("iC5Q5");

const $a3703bbade11fb84$export$b79c645ae6a0e5c7 = (flags)=>{
    const pairs = Object.entries(flags);
    return pairs.filter(([_key, value])=>!!value).map(([key])=>key);
};
const $a3703bbade11fb84$export$c8bcd5e6111ea1f3 = ()=>{
    const productKeys = (0, $hsnIS.getProductKeys)();
    let ldFeatureFlags = [];
    (0, $adEwt.supportedProducts).forEach((product)=>{
        ldFeatureFlags = [
            ...ldFeatureFlags,
            ...Object.values(productKeys[product])
        ];
    });
    return ldFeatureFlags.filter((flag)=>flag !== '');
};
const $a3703bbade11fb84$export$836625761e76d373 = {
    mediaInline: false
};
function $a3703bbade11fb84$export$383e8f51978266d(flagName, featureFlags) {
    return (0, $iC5Q5.getGenericFeatureFlag)(flagName, $a3703bbade11fb84$export$836625761e76d373, featureFlags);
}
module.exports["getFeatureFlagKeysAllProducts"] = $a3703bbade11fb84$export$c8bcd5e6111ea1f3;
module.exports["getMediaFeatureFlag"] = $a3703bbade11fb84$export$383e8f51978266d;

});

parcelRegister("adEwt", function(module, exports) {
// Media feature flags - type and defaults defined here in one source of truth
const $55eb57bebd45f4d3$export$2db74afa1ef496f1 = [
    'confluence',
    'jira'
];
module.exports["supportedProducts"] = $55eb57bebd45f4d3$export$2db74afa1ef496f1;

});

parcelRegister("hsnIS", function(module, exports) {
const $642951ddc1f8ae05$var$productKeys = {
    confluence: {
        mediaInline: ''
    },
    jira: {
        // Manged by Linking Platform. No Rollout plan found for Jira
        mediaInline: ''
    }
};
const $642951ddc1f8ae05$export$189fe120be7e73fc = ()=>$642951ddc1f8ae05$var$productKeys;
module.exports["getProductKeys"] = $642951ddc1f8ae05$export$189fe120be7e73fc;

});

parcelRegister("iC5Q5", function(module, exports) {

var $2hYl7 = parcelRequire("2hYl7");

function $cf2104adc10a7224$export$f2687d0de19e4973(flagName, defaults, featureFlags) {
    const devOverride = (0, $2hYl7.getLocalMediaFeatureFlag)(flagName);
    if (devOverride !== null) try {
        return JSON.parse(devOverride);
    } catch (e) {}
    if (featureFlags) return flagName in featureFlags ? featureFlags[flagName] : defaults[flagName];
    return defaults[flagName];
}
module.exports["getGenericFeatureFlag"] = $cf2104adc10a7224$export$f2687d0de19e4973;

});

parcelRegister("2hYl7", function(module, exports) {
// window.localStorage is easier to mock in tests if wrapped in this module
const $8ed9ff59a41a6857$export$d125817a2695dbc9 = (key)=>{
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return typeof window !== 'undefined' && window.localStorage ? // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        window.localStorage.getItem(key) : null;
    } catch (e) {
    // do nothing, return null by default
    }
    return null;
};
module.exports["getLocalMediaFeatureFlag"] = $8ed9ff59a41a6857$export$d125817a2695dbc9;

});

parcelRegister("1rDre", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $10d6e7acdde4b7aa$var$_react = $10d6e7acdde4b7aa$var$_interopRequireDefault((parcelRequire("cozmU")));

var $adk2f = parcelRequire("adk2f");

function $10d6e7acdde4b7aa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $10d6e7acdde4b7aa$var$Image16Icon = (props)=>/*#__PURE__*/ $10d6e7acdde4b7aa$var$_react.default.createElement($adk2f.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m4.75 11.75-.543-.543a1 1 0 0 0-1.414 0L3 13h10v-2.25l-1.795-1.974a1 1 0 0 0-1.447-.034zM4.667 6.333a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333"/></svg>`
    }, props, {
        size: 'small'
    }));
$10d6e7acdde4b7aa$var$Image16Icon.displayName = 'Image16Icon';
var $10d6e7acdde4b7aa$var$_default = module.exports.default = $10d6e7acdde4b7aa$var$Image16Icon;

});

parcelRegister("2sfCn", function(module, exports) {

var $uXNGm = parcelRequire("uXNGm");


var $1P2f3 = parcelRequire("1P2f3");

/**
A parse stack. These are used internally by the parser to track
parsing progress. They also provide some properties and methods
that external code such as a tokenizer can use to get information
about the parse state.
*/ class $1c9a4fae1b3745c6$export$694e0d28c7ffc90c {
    /**
    @internal
    */ toString() {
        return `[${this.stack.filter((_, i)=>i % 3 == 0).concat(this.state)}]@${this.pos}${this.score ? "!" + this.score : ""}`;
    }
    // Start an empty stack
    /**
    @internal
    */ static start(p, state, pos = 0) {
        let cx = p.parser.context;
        return new $1c9a4fae1b3745c6$export$694e0d28c7ffc90c(p, [], state, pos, pos, 0, [], 0, cx ? new $1c9a4fae1b3745c6$var$StackContext(cx, cx.start) : null, 0, null);
    }
    /**
    The stack's current [context](#lr.ContextTracker) value, if
    any. Its type will depend on the context tracker's type
    parameter, or it will be `null` if there is no context
    tracker.
    */ get context() {
        return this.curContext ? this.curContext.context : null;
    }
    // Push a state onto the stack, tracking its start position as well
    // as the buffer base at that point.
    /**
    @internal
    */ pushState(state, start) {
        this.stack.push(this.state, start, this.bufferBase + this.buffer.length);
        this.state = state;
    }
    // Apply a reduce action
    /**
    @internal
    */ reduce(action) {
        var _a;
        let depth = action >> 19 /* Action.ReduceDepthShift */ , type = action & 65535 /* Action.ValueMask */ ;
        let { parser: parser } = this.p;
        let lookaheadRecord = this.reducePos < this.pos - 25 /* Lookahead.Margin */ ;
        if (lookaheadRecord) this.setLookAhead(this.pos);
        let dPrec = parser.dynamicPrecedence(type);
        if (dPrec) this.score += dPrec;
        if (depth == 0) {
            this.pushState(parser.getGoto(this.state, type, true), this.reducePos);
            // Zero-depth reductions are a special case—they add stuff to
            // the stack without popping anything off.
            if (type < parser.minRepeatTerm) this.storeNode(type, this.reducePos, this.reducePos, lookaheadRecord ? 8 : 4, true);
            this.reduceContext(type, this.reducePos);
            return;
        }
        // Find the base index into `this.stack`, content after which will
        // be dropped. Note that with `StayFlag` reductions we need to
        // consume two extra frames (the dummy parent node for the skipped
        // expression and the state that we'll be staying in, which should
        // be moved to `this.state`).
        let base = this.stack.length - (depth - 1) * 3 - (action & 262144 /* Action.StayFlag */  ? 6 : 0);
        let start = base ? this.stack[base - 2] : this.p.ranges[0].from, size = this.reducePos - start;
        // This is a kludge to try and detect overly deep left-associative
        // trees, which will not increase the parse stack depth and thus
        // won't be caught by the regular stack-depth limit check.
        if (size >= 2000 /* Recover.MinBigReduction */  && !((_a = this.p.parser.nodeSet.types[type]) === null || _a === void 0 ? void 0 : _a.isAnonymous)) {
            if (start == this.p.lastBigReductionStart) {
                this.p.bigReductionCount++;
                this.p.lastBigReductionSize = size;
            } else if (this.p.lastBigReductionSize < size) {
                this.p.bigReductionCount = 1;
                this.p.lastBigReductionStart = start;
                this.p.lastBigReductionSize = size;
            }
        }
        let bufferBase = base ? this.stack[base - 1] : 0, count = this.bufferBase + this.buffer.length - bufferBase;
        // Store normal terms or `R -> R R` repeat reductions
        if (type < parser.minRepeatTerm || action & 131072 /* Action.RepeatFlag */ ) {
            let pos = parser.stateFlag(this.state, 1 /* StateFlag.Skipped */ ) ? this.pos : this.reducePos;
            this.storeNode(type, start, pos, count + 4, true);
        }
        if (action & 262144 /* Action.StayFlag */ ) this.state = this.stack[base];
        else {
            let baseStateID = this.stack[base - 3];
            this.state = parser.getGoto(baseStateID, type, true);
        }
        while(this.stack.length > base)this.stack.pop();
        this.reduceContext(type, start);
    }
    // Shift a value into the buffer
    /**
    @internal
    */ storeNode(term, start, end, size = 4, mustSink = false) {
        if (term == 0 /* Term.Err */  && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
            // Try to omit/merge adjacent error nodes
            let cur = this, top = this.buffer.length;
            if (top == 0 && cur.parent) {
                top = cur.bufferBase - cur.parent.bufferBase;
                cur = cur.parent;
            }
            if (top > 0 && cur.buffer[top - 4] == 0 /* Term.Err */  && cur.buffer[top - 1] > -1) {
                if (start == end) return;
                if (cur.buffer[top - 2] >= start) {
                    cur.buffer[top - 2] = end;
                    return;
                }
            }
        }
        if (!mustSink || this.pos == end) this.buffer.push(term, start, end, size);
        else {
            let index = this.buffer.length;
            if (index > 0 && this.buffer[index - 4] != 0 /* Term.Err */ ) {
                let mustMove = false;
                for(let scan = index; scan > 0 && this.buffer[scan - 2] > end; scan -= 4)if (this.buffer[scan - 1] >= 0) {
                    mustMove = true;
                    break;
                }
                if (mustMove) while(index > 0 && this.buffer[index - 2] > end){
                    // Move this record forward
                    this.buffer[index] = this.buffer[index - 4];
                    this.buffer[index + 1] = this.buffer[index - 3];
                    this.buffer[index + 2] = this.buffer[index - 2];
                    this.buffer[index + 3] = this.buffer[index - 1];
                    index -= 4;
                    if (size > 4) size -= 4;
                }
            }
            this.buffer[index] = term;
            this.buffer[index + 1] = start;
            this.buffer[index + 2] = end;
            this.buffer[index + 3] = size;
        }
    }
    // Apply a shift action
    /**
    @internal
    */ shift(action, type, start, end) {
        if (action & 131072 /* Action.GotoFlag */ ) this.pushState(action & 65535 /* Action.ValueMask */ , this.pos);
        else if ((action & 262144 /* Action.StayFlag */ ) == 0) {
            let nextState = action, { parser: parser } = this.p;
            if (end > this.pos || type <= parser.maxNode) {
                this.pos = end;
                if (!parser.stateFlag(nextState, 1 /* StateFlag.Skipped */ )) this.reducePos = end;
            }
            this.pushState(nextState, start);
            this.shiftContext(type, start);
            if (type <= parser.maxNode) this.buffer.push(type, start, end, 4);
        } else {
            this.pos = end;
            this.shiftContext(type, start);
            if (type <= this.p.parser.maxNode) this.buffer.push(type, start, end, 4);
        }
    }
    // Apply an action
    /**
    @internal
    */ apply(action, next, nextStart, nextEnd) {
        if (action & 65536 /* Action.ReduceFlag */ ) this.reduce(action);
        else this.shift(action, next, nextStart, nextEnd);
    }
    // Add a prebuilt (reused) node into the buffer.
    /**
    @internal
    */ useNode(value, next) {
        let index = this.p.reused.length - 1;
        if (index < 0 || this.p.reused[index] != value) {
            this.p.reused.push(value);
            index++;
        }
        let start = this.pos;
        this.reducePos = this.pos = start + value.length;
        this.pushState(next, start);
        this.buffer.push(index, start, this.reducePos, -1 /* size == -1 means this is a reused value */ );
        if (this.curContext) this.updateContext(this.curContext.tracker.reuse(this.curContext.context, value, this, this.p.stream.reset(this.pos - value.length)));
    }
    // Split the stack. Due to the buffer sharing and the fact
    // that `this.stack` tends to stay quite shallow, this isn't very
    // expensive.
    /**
    @internal
    */ split() {
        let parent = this;
        let off = parent.buffer.length;
        // Because the top of the buffer (after this.pos) may be mutated
        // to reorder reductions and skipped tokens, and shared buffers
        // should be immutable, this copies any outstanding skipped tokens
        // to the new buffer, and puts the base pointer before them.
        while(off > 0 && parent.buffer[off - 2] > parent.reducePos)off -= 4;
        let buffer = parent.buffer.slice(off), base = parent.bufferBase + off;
        // Make sure parent points to an actual parent with content, if there is such a parent.
        while(parent && base == parent.bufferBase)parent = parent.parent;
        return new $1c9a4fae1b3745c6$export$694e0d28c7ffc90c(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, buffer, base, this.curContext, this.lookAhead, parent);
    }
    // Try to recover from an error by 'deleting' (ignoring) one token.
    /**
    @internal
    */ recoverByDelete(next, nextEnd) {
        let isNode = next <= this.p.parser.maxNode;
        if (isNode) this.storeNode(next, this.pos, nextEnd, 4);
        this.storeNode(0 /* Term.Err */ , this.pos, nextEnd, isNode ? 8 : 4);
        this.pos = this.reducePos = nextEnd;
        this.score -= 190 /* Recover.Delete */ ;
    }
    /**
    Check if the given term would be able to be shifted (optionally
    after some reductions) on this stack. This can be useful for
    external tokenizers that want to make sure they only provide a
    given token when it applies.
    */ canShift(term) {
        for(let sim = new $1c9a4fae1b3745c6$var$SimulatedStack(this);;){
            let action = this.p.parser.stateSlot(sim.state, 4 /* ParseState.DefaultReduce */ ) || this.p.parser.hasAction(sim.state, term);
            if (action == 0) return false;
            if ((action & 65536 /* Action.ReduceFlag */ ) == 0) return true;
            sim.reduce(action);
        }
    }
    // Apply up to Recover.MaxNext recovery actions that conceptually
    // inserts some missing token or rule.
    /**
    @internal
    */ recoverByInsert(next) {
        if (this.stack.length >= 300 /* Recover.MaxInsertStackDepth */ ) return [];
        let nextStates = this.p.parser.nextStates(this.state);
        if (nextStates.length > 8 || this.stack.length >= 120 /* Recover.DampenInsertStackDepth */ ) {
            let best = [];
            for(let i = 0, s; i < nextStates.length; i += 2)if ((s = nextStates[i + 1]) != this.state && this.p.parser.hasAction(s, next)) best.push(nextStates[i], s);
            if (this.stack.length < 120 /* Recover.DampenInsertStackDepth */ ) for(let i = 0; best.length < 8 && i < nextStates.length; i += 2){
                let s = nextStates[i + 1];
                if (!best.some((v, i)=>i & 1 && v == s)) best.push(nextStates[i], s);
            }
            nextStates = best;
        }
        let result = [];
        for(let i = 0; i < nextStates.length && result.length < 4 /* Recover.MaxNext */ ; i += 2){
            let s = nextStates[i + 1];
            if (s == this.state) continue;
            let stack = this.split();
            stack.pushState(s, this.pos);
            stack.storeNode(0 /* Term.Err */ , stack.pos, stack.pos, 4, true);
            stack.shiftContext(nextStates[i], this.pos);
            stack.reducePos = this.pos;
            stack.score -= 200 /* Recover.Insert */ ;
            result.push(stack);
        }
        return result;
    }
    // Force a reduce, if possible. Return false if that can't
    // be done.
    /**
    @internal
    */ forceReduce() {
        let { parser: parser } = this.p;
        let reduce = parser.stateSlot(this.state, 5 /* ParseState.ForcedReduce */ );
        if ((reduce & 65536 /* Action.ReduceFlag */ ) == 0) return false;
        if (!parser.validAction(this.state, reduce)) {
            let depth = reduce >> 19 /* Action.ReduceDepthShift */ , term = reduce & 65535 /* Action.ValueMask */ ;
            let target = this.stack.length - depth * 3;
            if (target < 0 || parser.getGoto(this.stack[target], term, false) < 0) {
                let backup = this.findForcedReduction();
                if (backup == null) return false;
                reduce = backup;
            }
            this.storeNode(0 /* Term.Err */ , this.pos, this.pos, 4, true);
            this.score -= 100 /* Recover.Reduce */ ;
        }
        this.reducePos = this.pos;
        this.reduce(reduce);
        return true;
    }
    /**
    Try to scan through the automaton to find some kind of reduction
    that can be applied. Used when the regular ForcedReduce field
    isn't a valid action. @internal
    */ findForcedReduction() {
        let { parser: parser } = this.p, seen = [];
        let explore = (state, depth)=>{
            if (seen.includes(state)) return;
            seen.push(state);
            return parser.allActions(state, (action)=>{
                if (action & 393216 /* Action.GotoFlag */ ) ;
                else if (action & 65536 /* Action.ReduceFlag */ ) {
                    let rDepth = (action >> 19 /* Action.ReduceDepthShift */ ) - depth;
                    if (rDepth > 1) {
                        let term = action & 65535 /* Action.ValueMask */ , target = this.stack.length - rDepth * 3;
                        if (target >= 0 && parser.getGoto(this.stack[target], term, false) >= 0) return rDepth << 19 /* Action.ReduceDepthShift */  | 65536 /* Action.ReduceFlag */  | term;
                    }
                } else {
                    let found = explore(action, depth + 1);
                    if (found != null) return found;
                }
            });
        };
        return explore(this.state, 0);
    }
    /**
    @internal
    */ forceAll() {
        while(!this.p.parser.stateFlag(this.state, 2 /* StateFlag.Accepting */ ))if (!this.forceReduce()) {
            this.storeNode(0 /* Term.Err */ , this.pos, this.pos, 4, true);
            break;
        }
        return this;
    }
    /**
    Check whether this state has no further actions (assumed to be a direct descendant of the
    top state, since any other states must be able to continue
    somehow). @internal
    */ get deadEnd() {
        if (this.stack.length != 3) return false;
        let { parser: parser } = this.p;
        return parser.data[parser.stateSlot(this.state, 1 /* ParseState.Actions */ )] == 65535 /* Seq.End */  && !parser.stateSlot(this.state, 4 /* ParseState.DefaultReduce */ );
    }
    /**
    Restart the stack (put it back in its start state). Only safe
    when this.stack.length == 3 (state is directly below the top
    state). @internal
    */ restart() {
        this.storeNode(0 /* Term.Err */ , this.pos, this.pos, 4, true);
        this.state = this.stack[0];
        this.stack.length = 0;
    }
    /**
    @internal
    */ sameState(other) {
        if (this.state != other.state || this.stack.length != other.stack.length) return false;
        for(let i = 0; i < this.stack.length; i += 3)if (this.stack[i] != other.stack[i]) return false;
        return true;
    }
    /**
    Get the parser used by this stack.
    */ get parser() {
        return this.p.parser;
    }
    /**
    Test whether a given dialect (by numeric ID, as exported from
    the terms file) is enabled.
    */ dialectEnabled(dialectID) {
        return this.p.parser.dialect.flags[dialectID];
    }
    shiftContext(term, start) {
        if (this.curContext) this.updateContext(this.curContext.tracker.shift(this.curContext.context, term, this, this.p.stream.reset(start)));
    }
    reduceContext(term, start) {
        if (this.curContext) this.updateContext(this.curContext.tracker.reduce(this.curContext.context, term, this, this.p.stream.reset(start)));
    }
    /**
    @internal
    */ emitContext() {
        let last = this.buffer.length - 1;
        if (last < 0 || this.buffer[last] != -3) this.buffer.push(this.curContext.hash, this.pos, this.pos, -3);
    }
    /**
    @internal
    */ emitLookAhead() {
        let last = this.buffer.length - 1;
        if (last < 0 || this.buffer[last] != -4) this.buffer.push(this.lookAhead, this.pos, this.pos, -4);
    }
    updateContext(context) {
        if (context != this.curContext.context) {
            let newCx = new $1c9a4fae1b3745c6$var$StackContext(this.curContext.tracker, context);
            if (newCx.hash != this.curContext.hash) this.emitContext();
            this.curContext = newCx;
        }
    }
    /**
    @internal
    */ setLookAhead(lookAhead) {
        if (lookAhead > this.lookAhead) {
            this.emitLookAhead();
            this.lookAhead = lookAhead;
        }
    }
    /**
    @internal
    */ close() {
        if (this.curContext && this.curContext.tracker.strict) this.emitContext();
        if (this.lookAhead > 0) this.emitLookAhead();
    }
    /**
    @internal
    */ constructor(/**
    The parse that this stack is part of @internal
    */ p, /**
    Holds state, input pos, buffer index triplets for all but the
    top state @internal
    */ stack, /**
    The current parse state @internal
    */ state, // The position at which the next reduce should take place. This
    // can be less than `this.pos` when skipped expressions have been
    // added to the stack (which should be moved outside of the next
    // reduction)
    /**
    @internal
    */ reducePos, /**
    The input position up to which this stack has parsed.
    */ pos, /**
    The dynamic score of the stack, including dynamic precedence
    and error-recovery penalties
    @internal
    */ score, // The output buffer. Holds (type, start, end, size) quads
    // representing nodes created by the parser, where `size` is
    // amount of buffer array entries covered by this node.
    /**
    @internal
    */ buffer, // The base offset of the buffer. When stacks are split, the split
    // instance shared the buffer history with its parent up to
    // `bufferBase`, which is the absolute offset (including the
    // offset of previous splits) into the buffer at which this stack
    // starts writing.
    /**
    @internal
    */ bufferBase, /**
    @internal
    */ curContext, /**
    @internal
    */ lookAhead = 0, // A parent stack from which this was split off, if any. This is
    // set up so that it always points to a stack that has some
    // additional buffer content, never to a stack with an equal
    // `bufferBase`.
    /**
    @internal
    */ parent){
        this.p = p;
        this.stack = stack;
        this.state = state;
        this.reducePos = reducePos;
        this.pos = pos;
        this.score = score;
        this.buffer = buffer;
        this.bufferBase = bufferBase;
        this.curContext = curContext;
        this.lookAhead = lookAhead;
        this.parent = parent;
    }
}
class $1c9a4fae1b3745c6$var$StackContext {
    constructor(tracker, context){
        this.tracker = tracker;
        this.context = context;
        this.hash = tracker.strict ? tracker.hash(context) : 0;
    }
}
// Used to cheaply run some reductions to scan ahead without mutating
// an entire stack
class $1c9a4fae1b3745c6$var$SimulatedStack {
    reduce(action) {
        let term = action & 65535 /* Action.ValueMask */ , depth = action >> 19 /* Action.ReduceDepthShift */ ;
        if (depth == 0) {
            if (this.stack == this.start.stack) this.stack = this.stack.slice();
            this.stack.push(this.state, 0, 0);
            this.base += 3;
        } else this.base -= (depth - 1) * 3;
        let goto = this.start.p.parser.getGoto(this.stack[this.base - 3], term, true);
        this.state = goto;
    }
    constructor(start){
        this.start = start;
        this.state = start.state;
        this.stack = start.stack;
        this.base = this.stack.length;
    }
}
// This is given to `Tree.build` to build a buffer, and encapsulates
// the parent-stack-walking necessary to read the nodes.
class $1c9a4fae1b3745c6$var$StackBufferCursor {
    static create(stack, pos = stack.bufferBase + stack.buffer.length) {
        return new $1c9a4fae1b3745c6$var$StackBufferCursor(stack, pos, pos - stack.bufferBase);
    }
    maybeNext() {
        let next = this.stack.parent;
        if (next != null) {
            this.index = this.stack.bufferBase - next.bufferBase;
            this.stack = next;
            this.buffer = next.buffer;
        }
    }
    get id() {
        return this.buffer[this.index - 4];
    }
    get start() {
        return this.buffer[this.index - 3];
    }
    get end() {
        return this.buffer[this.index - 2];
    }
    get size() {
        return this.buffer[this.index - 1];
    }
    next() {
        this.index -= 4;
        this.pos -= 4;
        if (this.index == 0) this.maybeNext();
    }
    fork() {
        return new $1c9a4fae1b3745c6$var$StackBufferCursor(this.stack, this.pos, this.index);
    }
    constructor(stack, pos, index){
        this.stack = stack;
        this.pos = pos;
        this.index = index;
        this.buffer = stack.buffer;
        if (this.index == 0) this.maybeNext();
    }
}
// See lezer-generator/src/encode.ts for comments about the encoding
// used here
function $1c9a4fae1b3745c6$var$decodeArray(input, Type = Uint16Array) {
    if (typeof input != "string") return input;
    let array = null;
    for(let pos = 0, out = 0; pos < input.length;){
        let value = 0;
        for(;;){
            let next = input.charCodeAt(pos++), stop = false;
            if (next == 126 /* Encode.BigValCode */ ) {
                value = 65535 /* Encode.BigVal */ ;
                break;
            }
            if (next >= 92 /* Encode.Gap2 */ ) next--;
            if (next >= 34 /* Encode.Gap1 */ ) next--;
            let digit = next - 32 /* Encode.Start */ ;
            if (digit >= 46 /* Encode.Base */ ) {
                digit -= 46 /* Encode.Base */ ;
                stop = true;
            }
            value += digit;
            if (stop) break;
            value *= 46 /* Encode.Base */ ;
        }
        if (array) array[out++] = value;
        else array = new Type(value);
    }
    return array;
}
class $1c9a4fae1b3745c6$var$CachedToken {
    constructor(){
        this.start = -1;
        this.value = -1;
        this.end = -1;
        this.extended = -1;
        this.lookAhead = 0;
        this.mask = 0;
        this.context = 0;
    }
}
const $1c9a4fae1b3745c6$var$nullToken = new $1c9a4fae1b3745c6$var$CachedToken;
/**
[Tokenizers](#lr.ExternalTokenizer) interact with the input
through this interface. It presents the input as a stream of
characters, tracking lookahead and hiding the complexity of
[ranges](#common.Parser.parse^ranges) from tokenizer code.
*/ class $1c9a4fae1b3745c6$export$f22294a9362415e4 {
    /**
    @internal
    */ resolveOffset(offset, assoc) {
        let range = this.range, index = this.rangeIndex;
        let pos = this.pos + offset;
        while(pos < range.from){
            if (!index) return null;
            let next = this.ranges[--index];
            pos -= range.from - next.to;
            range = next;
        }
        while(assoc < 0 ? pos > range.to : pos >= range.to){
            if (index == this.ranges.length - 1) return null;
            let next = this.ranges[++index];
            pos += next.from - range.to;
            range = next;
        }
        return pos;
    }
    /**
    @internal
    */ clipPos(pos) {
        if (pos >= this.range.from && pos < this.range.to) return pos;
        for (let range of this.ranges)if (range.to > pos) return Math.max(pos, range.from);
        return this.end;
    }
    /**
    Look at a code unit near the stream position. `.peek(0)` equals
    `.next`, `.peek(-1)` gives you the previous character, and so
    on.
    
    Note that looking around during tokenizing creates dependencies
    on potentially far-away content, which may reduce the
    effectiveness incremental parsing—when looking forward—or even
    cause invalid reparses when looking backward more than 25 code
    units, since the library does not track lookbehind.
    */ peek(offset) {
        let idx = this.chunkOff + offset, pos, result;
        if (idx >= 0 && idx < this.chunk.length) {
            pos = this.pos + offset;
            result = this.chunk.charCodeAt(idx);
        } else {
            let resolved = this.resolveOffset(offset, 1);
            if (resolved == null) return -1;
            pos = resolved;
            if (pos >= this.chunk2Pos && pos < this.chunk2Pos + this.chunk2.length) result = this.chunk2.charCodeAt(pos - this.chunk2Pos);
            else {
                let i = this.rangeIndex, range = this.range;
                while(range.to <= pos)range = this.ranges[++i];
                this.chunk2 = this.input.chunk(this.chunk2Pos = pos);
                if (pos + this.chunk2.length > range.to) this.chunk2 = this.chunk2.slice(0, range.to - pos);
                result = this.chunk2.charCodeAt(0);
            }
        }
        if (pos >= this.token.lookAhead) this.token.lookAhead = pos + 1;
        return result;
    }
    /**
    Accept a token. By default, the end of the token is set to the
    current stream position, but you can pass an offset (relative to
    the stream position) to change that.
    */ acceptToken(token, endOffset = 0) {
        let end = endOffset ? this.resolveOffset(endOffset, -1) : this.pos;
        if (end == null || end < this.token.start) throw new RangeError("Token end out of bounds");
        this.token.value = token;
        this.token.end = end;
    }
    /**
    Accept a token ending at a specific given position.
    */ acceptTokenTo(token, endPos) {
        this.token.value = token;
        this.token.end = endPos;
    }
    getChunk() {
        if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
            let { chunk: chunk, chunkPos: chunkPos } = this;
            this.chunk = this.chunk2;
            this.chunkPos = this.chunk2Pos;
            this.chunk2 = chunk;
            this.chunk2Pos = chunkPos;
            this.chunkOff = this.pos - this.chunkPos;
        } else {
            this.chunk2 = this.chunk;
            this.chunk2Pos = this.chunkPos;
            let nextChunk = this.input.chunk(this.pos);
            let end = this.pos + nextChunk.length;
            this.chunk = end > this.range.to ? nextChunk.slice(0, this.range.to - this.pos) : nextChunk;
            this.chunkPos = this.pos;
            this.chunkOff = 0;
        }
    }
    readNext() {
        if (this.chunkOff >= this.chunk.length) {
            this.getChunk();
            if (this.chunkOff == this.chunk.length) return this.next = -1;
        }
        return this.next = this.chunk.charCodeAt(this.chunkOff);
    }
    /**
    Move the stream forward N (defaults to 1) code units. Returns
    the new value of [`next`](#lr.InputStream.next).
    */ advance(n = 1) {
        this.chunkOff += n;
        while(this.pos + n >= this.range.to){
            if (this.rangeIndex == this.ranges.length - 1) return this.setDone();
            n -= this.range.to - this.pos;
            this.range = this.ranges[++this.rangeIndex];
            this.pos = this.range.from;
        }
        this.pos += n;
        if (this.pos >= this.token.lookAhead) this.token.lookAhead = this.pos + 1;
        return this.readNext();
    }
    setDone() {
        this.pos = this.chunkPos = this.end;
        this.range = this.ranges[this.rangeIndex = this.ranges.length - 1];
        this.chunk = "";
        return this.next = -1;
    }
    /**
    @internal
    */ reset(pos, token) {
        if (token) {
            this.token = token;
            token.start = pos;
            token.lookAhead = pos + 1;
            token.value = token.extended = -1;
        } else this.token = $1c9a4fae1b3745c6$var$nullToken;
        if (this.pos != pos) {
            this.pos = pos;
            if (pos == this.end) {
                this.setDone();
                return this;
            }
            while(pos < this.range.from)this.range = this.ranges[--this.rangeIndex];
            while(pos >= this.range.to)this.range = this.ranges[++this.rangeIndex];
            if (pos >= this.chunkPos && pos < this.chunkPos + this.chunk.length) this.chunkOff = pos - this.chunkPos;
            else {
                this.chunk = "";
                this.chunkOff = 0;
            }
            this.readNext();
        }
        return this;
    }
    /**
    @internal
    */ read(from, to) {
        if (from >= this.chunkPos && to <= this.chunkPos + this.chunk.length) return this.chunk.slice(from - this.chunkPos, to - this.chunkPos);
        if (from >= this.chunk2Pos && to <= this.chunk2Pos + this.chunk2.length) return this.chunk2.slice(from - this.chunk2Pos, to - this.chunk2Pos);
        if (from >= this.range.from && to <= this.range.to) return this.input.read(from, to);
        let result = "";
        for (let r of this.ranges){
            if (r.from >= to) break;
            if (r.to > from) result += this.input.read(Math.max(r.from, from), Math.min(r.to, to));
        }
        return result;
    }
    /**
    @internal
    */ constructor(/**
    @internal
    */ input, /**
    @internal
    */ ranges){
        this.input = input;
        this.ranges = ranges;
        /**
        @internal
        */ this.chunk = "";
        /**
        @internal
        */ this.chunkOff = 0;
        /**
        Backup chunk
        */ this.chunk2 = "";
        this.chunk2Pos = 0;
        /**
        The character code of the next code unit in the input, or -1
        when the stream is at the end of the input.
        */ this.next = -1;
        /**
        @internal
        */ this.token = $1c9a4fae1b3745c6$var$nullToken;
        this.rangeIndex = 0;
        this.pos = this.chunkPos = ranges[0].from;
        this.range = ranges[0];
        this.end = ranges[ranges.length - 1].to;
        this.readNext();
    }
}
/**
@internal
*/ class $1c9a4fae1b3745c6$var$TokenGroup {
    token(input, stack) {
        let { parser: parser } = stack.p;
        $1c9a4fae1b3745c6$var$readToken(this.data, input, stack, this.id, parser.data, parser.tokenPrecTable);
    }
    constructor(data, id){
        this.data = data;
        this.id = id;
    }
}
$1c9a4fae1b3745c6$var$TokenGroup.prototype.contextual = $1c9a4fae1b3745c6$var$TokenGroup.prototype.fallback = $1c9a4fae1b3745c6$var$TokenGroup.prototype.extend = false;
/**
@hide
*/ class $1c9a4fae1b3745c6$export$dbe55ed82366d5e9 {
    token(input, stack) {
        let start = input.pos, skipped = 0;
        for(;;){
            let atEof = input.next < 0, nextPos = input.resolveOffset(1, 1);
            $1c9a4fae1b3745c6$var$readToken(this.data, input, stack, 0, this.data, this.precTable);
            if (input.token.value > -1) break;
            if (this.elseToken == null) return;
            if (!atEof) skipped++;
            if (nextPos == null) break;
            input.reset(nextPos, input.token);
        }
        if (skipped) {
            input.reset(start, input.token);
            input.acceptToken(this.elseToken, skipped);
        }
    }
    constructor(data, precTable, elseToken){
        this.precTable = precTable;
        this.elseToken = elseToken;
        this.data = typeof data == "string" ? $1c9a4fae1b3745c6$var$decodeArray(data) : data;
    }
}
$1c9a4fae1b3745c6$export$dbe55ed82366d5e9.prototype.contextual = $1c9a4fae1b3745c6$var$TokenGroup.prototype.fallback = $1c9a4fae1b3745c6$var$TokenGroup.prototype.extend = false;
/**
`@external tokens` declarations in the grammar should resolve to
an instance of this class.
*/ class $1c9a4fae1b3745c6$export$6e56a42e94c6b2cb {
    /**
    Create a tokenizer. The first argument is the function that,
    given an input stream, scans for the types of tokens it
    recognizes at the stream's position, and calls
    [`acceptToken`](#lr.InputStream.acceptToken) when it finds
    one.
    */ constructor(/**
    @internal
    */ token, options = {}){
        this.token = token;
        this.contextual = !!options.contextual;
        this.fallback = !!options.fallback;
        this.extend = !!options.extend;
    }
}
// Tokenizer data is stored a big uint16 array containing, for each
// state:
//
//  - A group bitmask, indicating what token groups are reachable from
//    this state, so that paths that can only lead to tokens not in
//    any of the current groups can be cut off early.
//
//  - The position of the end of the state's sequence of accepting
//    tokens
//
//  - The number of outgoing edges for the state
//
//  - The accepting tokens, as (token id, group mask) pairs
//
//  - The outgoing edges, as (start character, end character, state
//    index) triples, with end character being exclusive
//
// This function interprets that data, running through a stream as
// long as new states with the a matching group mask can be reached,
// and updating `input.token` when it matches a token.
function $1c9a4fae1b3745c6$var$readToken(data, input, stack, group, precTable, precOffset) {
    let state = 0, groupMask = 1 << group, { dialect: dialect } = stack.p.parser;
    scan: for(;;){
        if ((groupMask & data[state]) == 0) break;
        let accEnd = data[state + 1];
        // Check whether this state can lead to a token in the current group
        // Accept tokens in this state, possibly overwriting
        // lower-precedence / shorter tokens
        for(let i = state + 3; i < accEnd; i += 2)if ((data[i + 1] & groupMask) > 0) {
            let term = data[i];
            if (dialect.allows(term) && (input.token.value == -1 || input.token.value == term || $1c9a4fae1b3745c6$var$overrides(term, input.token.value, precTable, precOffset))) {
                input.acceptToken(term);
                break;
            }
        }
        let next = input.next, low = 0, high = data[state + 2];
        // Special case for EOF
        if (input.next < 0 && high > low && data[accEnd + high * 3 - 3] == 65535 /* Seq.End */ ) {
            state = data[accEnd + high * 3 - 1];
            continue scan;
        }
        // Do a binary search on the state's edges
        for(; low < high;){
            let mid = low + high >> 1;
            let index = accEnd + mid + (mid << 1);
            let from = data[index], to = data[index + 1] || 0x10000;
            if (next < from) high = mid;
            else if (next >= to) low = mid + 1;
            else {
                state = data[index + 2];
                input.advance();
                continue scan;
            }
        }
        break;
    }
}
function $1c9a4fae1b3745c6$var$findOffset(data, start, term) {
    for(let i = start, next; (next = data[i]) != 65535 /* Seq.End */ ; i++)if (next == term) return i - start;
    return -1;
}
function $1c9a4fae1b3745c6$var$overrides(token, prev, tableData, tableOffset) {
    let iPrev = $1c9a4fae1b3745c6$var$findOffset(tableData, tableOffset, prev);
    return iPrev < 0 || $1c9a4fae1b3745c6$var$findOffset(tableData, tableOffset, token) < iPrev;
}
// Environment variable used to control console output
const $1c9a4fae1b3745c6$var$verbose = typeof $1P2f3 != "undefined" && $1P2f3.env && /\bparse\b/.test(undefined);
let $1c9a4fae1b3745c6$var$stackIDs = null;
function $1c9a4fae1b3745c6$var$cutAt(tree, pos, side) {
    let cursor = tree.cursor((0, $uXNGm.IterMode).IncludeAnonymous);
    cursor.moveTo(pos);
    for(;;){
        if (!(side < 0 ? cursor.childBefore(pos) : cursor.childAfter(pos))) for(;;){
            if ((side < 0 ? cursor.to < pos : cursor.from > pos) && !cursor.type.isError) return side < 0 ? Math.max(0, Math.min(cursor.to - 1, pos - 25 /* Lookahead.Margin */ )) : Math.min(tree.length, Math.max(cursor.from + 1, pos + 25 /* Lookahead.Margin */ ));
            if (side < 0 ? cursor.prevSibling() : cursor.nextSibling()) break;
            if (!cursor.parent()) return side < 0 ? 0 : tree.length;
        }
    }
}
class $1c9a4fae1b3745c6$var$FragmentCursor {
    nextFragment() {
        let fr = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];
        if (fr) {
            this.safeFrom = fr.openStart ? $1c9a4fae1b3745c6$var$cutAt(fr.tree, fr.from + fr.offset, 1) - fr.offset : fr.from;
            this.safeTo = fr.openEnd ? $1c9a4fae1b3745c6$var$cutAt(fr.tree, fr.to + fr.offset, -1) - fr.offset : fr.to;
            while(this.trees.length){
                this.trees.pop();
                this.start.pop();
                this.index.pop();
            }
            this.trees.push(fr.tree);
            this.start.push(-fr.offset);
            this.index.push(0);
            this.nextStart = this.safeFrom;
        } else this.nextStart = 1e9;
    }
    // `pos` must be >= any previously given `pos` for this cursor
    nodeAt(pos) {
        if (pos < this.nextStart) return null;
        while(this.fragment && this.safeTo <= pos)this.nextFragment();
        if (!this.fragment) return null;
        for(;;){
            let last = this.trees.length - 1;
            if (last < 0) {
                this.nextFragment();
                return null;
            }
            let top = this.trees[last], index = this.index[last];
            if (index == top.children.length) {
                this.trees.pop();
                this.start.pop();
                this.index.pop();
                continue;
            }
            let next = top.children[index];
            let start = this.start[last] + top.positions[index];
            if (start > pos) {
                this.nextStart = start;
                return null;
            }
            if (next instanceof (0, $uXNGm.Tree)) {
                if (start == pos) {
                    if (start < this.safeFrom) return null;
                    let end = start + next.length;
                    if (end <= this.safeTo) {
                        let lookAhead = next.prop((0, $uXNGm.NodeProp).lookAhead);
                        if (!lookAhead || end + lookAhead < this.fragment.to) return next;
                    }
                }
                this.index[last]++;
                if (start + next.length >= Math.max(this.safeFrom, pos)) {
                    this.trees.push(next);
                    this.start.push(start);
                    this.index.push(0);
                }
            } else {
                this.index[last]++;
                this.nextStart = start + next.length;
            }
        }
    }
    constructor(fragments, nodeSet){
        this.fragments = fragments;
        this.nodeSet = nodeSet;
        this.i = 0;
        this.fragment = null;
        this.safeFrom = -1;
        this.safeTo = -1;
        this.trees = [];
        this.start = [];
        this.index = [];
        this.nextFragment();
    }
}
class $1c9a4fae1b3745c6$var$TokenCache {
    getActions(stack) {
        let actionIndex = 0;
        let main = null;
        let { parser: parser } = stack.p, { tokenizers: tokenizers } = parser;
        let mask = parser.stateSlot(stack.state, 3 /* ParseState.TokenizerMask */ );
        let context = stack.curContext ? stack.curContext.hash : 0;
        let lookAhead = 0;
        for(let i = 0; i < tokenizers.length; i++){
            if ((1 << i & mask) == 0) continue;
            let tokenizer = tokenizers[i], token = this.tokens[i];
            if (main && !tokenizer.fallback) continue;
            if (tokenizer.contextual || token.start != stack.pos || token.mask != mask || token.context != context) {
                this.updateCachedToken(token, tokenizer, stack);
                token.mask = mask;
                token.context = context;
            }
            if (token.lookAhead > token.end + 25 /* Lookahead.Margin */ ) lookAhead = Math.max(token.lookAhead, lookAhead);
            if (token.value != 0 /* Term.Err */ ) {
                let startIndex = actionIndex;
                if (token.extended > -1) actionIndex = this.addActions(stack, token.extended, token.end, actionIndex);
                actionIndex = this.addActions(stack, token.value, token.end, actionIndex);
                if (!tokenizer.extend) {
                    main = token;
                    if (actionIndex > startIndex) break;
                }
            }
        }
        while(this.actions.length > actionIndex)this.actions.pop();
        if (lookAhead) stack.setLookAhead(lookAhead);
        if (!main && stack.pos == this.stream.end) {
            main = new $1c9a4fae1b3745c6$var$CachedToken;
            main.value = stack.p.parser.eofTerm;
            main.start = main.end = stack.pos;
            actionIndex = this.addActions(stack, main.value, main.end, actionIndex);
        }
        this.mainToken = main;
        return this.actions;
    }
    getMainToken(stack) {
        if (this.mainToken) return this.mainToken;
        let main = new $1c9a4fae1b3745c6$var$CachedToken, { pos: pos, p: p } = stack;
        main.start = pos;
        main.end = Math.min(pos + 1, p.stream.end);
        main.value = pos == p.stream.end ? p.parser.eofTerm : 0 /* Term.Err */ ;
        return main;
    }
    updateCachedToken(token, tokenizer, stack) {
        let start = this.stream.clipPos(stack.pos);
        tokenizer.token(this.stream.reset(start, token), stack);
        if (token.value > -1) {
            let { parser: parser } = stack.p;
            for(let i = 0; i < parser.specialized.length; i++)if (parser.specialized[i] == token.value) {
                let result = parser.specializers[i](this.stream.read(token.start, token.end), stack);
                if (result >= 0 && stack.p.parser.dialect.allows(result >> 1)) {
                    if ((result & 1) == 0 /* Specialize.Specialize */ ) token.value = result >> 1;
                    else token.extended = result >> 1;
                    break;
                }
            }
        } else {
            token.value = 0 /* Term.Err */ ;
            token.end = this.stream.clipPos(start + 1);
        }
    }
    putAction(action, token, end, index) {
        // Don't add duplicate actions
        for(let i = 0; i < index; i += 3)if (this.actions[i] == action) return index;
        this.actions[index++] = action;
        this.actions[index++] = token;
        this.actions[index++] = end;
        return index;
    }
    addActions(stack, token, end, index) {
        let { state: state } = stack, { parser: parser } = stack.p, { data: data } = parser;
        for(let set = 0; set < 2; set++)for(let i = parser.stateSlot(state, set ? 2 /* ParseState.Skip */  : 1 /* ParseState.Actions */ );; i += 3){
            if (data[i] == 65535 /* Seq.End */ ) {
                if (data[i + 1] == 1 /* Seq.Next */ ) i = $1c9a4fae1b3745c6$var$pair(data, i + 2);
                else {
                    if (index == 0 && data[i + 1] == 2 /* Seq.Other */ ) index = this.putAction($1c9a4fae1b3745c6$var$pair(data, i + 2), token, end, index);
                    break;
                }
            }
            if (data[i] == token) index = this.putAction($1c9a4fae1b3745c6$var$pair(data, i + 1), token, end, index);
        }
        return index;
    }
    constructor(parser, stream){
        this.stream = stream;
        this.tokens = [];
        this.mainToken = null;
        this.actions = [];
        this.tokens = parser.tokenizers.map((_)=>new $1c9a4fae1b3745c6$var$CachedToken);
    }
}
class $1c9a4fae1b3745c6$var$Parse {
    get parsedPos() {
        return this.minStackPos;
    }
    // Move the parser forward. This will process all parse stacks at
    // `this.pos` and try to advance them to a further position. If no
    // stack for such a position is found, it'll start error-recovery.
    //
    // When the parse is finished, this will return a syntax tree. When
    // not, it returns `null`.
    advance() {
        let stacks = this.stacks, pos = this.minStackPos;
        // This will hold stacks beyond `pos`.
        let newStacks = this.stacks = [];
        let stopped, stoppedTokens;
        // If a large amount of reductions happened with the same start
        // position, force the stack out of that production in order to
        // avoid creating a tree too deep to recurse through.
        // (This is an ugly kludge, because unfortunately there is no
        // straightforward, cheap way to check for this happening, due to
        // the history of reductions only being available in an
        // expensive-to-access format in the stack buffers.)
        if (this.bigReductionCount > 300 /* Rec.MaxLeftAssociativeReductionCount */  && stacks.length == 1) {
            let [s] = stacks;
            while(s.forceReduce() && s.stack.length && s.stack[s.stack.length - 2] >= this.lastBigReductionStart);
            this.bigReductionCount = this.lastBigReductionSize = 0;
        }
        // Keep advancing any stacks at `pos` until they either move
        // forward or can't be advanced. Gather stacks that can't be
        // advanced further in `stopped`.
        for(let i = 0; i < stacks.length; i++){
            let stack = stacks[i];
            for(;;){
                this.tokens.mainToken = null;
                if (stack.pos > pos) newStacks.push(stack);
                else if (this.advanceStack(stack, newStacks, stacks)) continue;
                else {
                    if (!stopped) {
                        stopped = [];
                        stoppedTokens = [];
                    }
                    stopped.push(stack);
                    let tok = this.tokens.getMainToken(stack);
                    stoppedTokens.push(tok.value, tok.end);
                }
                break;
            }
        }
        if (!newStacks.length) {
            let finished = stopped && $1c9a4fae1b3745c6$var$findFinished(stopped);
            if (finished) {
                if ($1c9a4fae1b3745c6$var$verbose) console.log("Finish with " + this.stackID(finished));
                return this.stackToTree(finished);
            }
            if (this.parser.strict) {
                if ($1c9a4fae1b3745c6$var$verbose && stopped) console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none"));
                throw new SyntaxError("No parse at " + pos);
            }
            if (!this.recovering) this.recovering = 5 /* Rec.Distance */ ;
        }
        if (this.recovering && stopped) {
            let finished = this.stoppedAt != null && stopped[0].pos > this.stoppedAt ? stopped[0] : this.runRecovery(stopped, stoppedTokens, newStacks);
            if (finished) {
                if ($1c9a4fae1b3745c6$var$verbose) console.log("Force-finish " + this.stackID(finished));
                return this.stackToTree(finished.forceAll());
            }
        }
        if (this.recovering) {
            let maxRemaining = this.recovering == 1 ? 1 : this.recovering * 3 /* Rec.MaxRemainingPerStep */ ;
            if (newStacks.length > maxRemaining) {
                newStacks.sort((a, b)=>b.score - a.score);
                while(newStacks.length > maxRemaining)newStacks.pop();
            }
            if (newStacks.some((s)=>s.reducePos > pos)) this.recovering--;
        } else if (newStacks.length > 1) {
            // Prune stacks that are in the same state, or that have been
            // running without splitting for a while, to avoid getting stuck
            // with multiple successful stacks running endlessly on.
            outer: for(let i = 0; i < newStacks.length - 1; i++){
                let stack = newStacks[i];
                for(let j = i + 1; j < newStacks.length; j++){
                    let other = newStacks[j];
                    if (stack.sameState(other) || stack.buffer.length > 500 /* Rec.MinBufferLengthPrune */  && other.buffer.length > 500 /* Rec.MinBufferLengthPrune */ ) {
                        if ((stack.score - other.score || stack.buffer.length - other.buffer.length) > 0) newStacks.splice(j--, 1);
                        else {
                            newStacks.splice(i--, 1);
                            continue outer;
                        }
                    }
                }
            }
            if (newStacks.length > 12 /* Rec.MaxStackCount */ ) newStacks.splice(12 /* Rec.MaxStackCount */ , newStacks.length - 12 /* Rec.MaxStackCount */ );
        }
        this.minStackPos = newStacks[0].pos;
        for(let i = 1; i < newStacks.length; i++)if (newStacks[i].pos < this.minStackPos) this.minStackPos = newStacks[i].pos;
        return null;
    }
    stopAt(pos) {
        if (this.stoppedAt != null && this.stoppedAt < pos) throw new RangeError("Can't move stoppedAt forward");
        this.stoppedAt = pos;
    }
    // Returns an updated version of the given stack, or null if the
    // stack can't advance normally. When `split` and `stacks` are
    // given, stacks split off by ambiguous operations will be pushed to
    // `split`, or added to `stacks` if they move `pos` forward.
    advanceStack(stack, stacks, split) {
        let start = stack.pos, { parser: parser } = this;
        let base = $1c9a4fae1b3745c6$var$verbose ? this.stackID(stack) + " -> " : "";
        if (this.stoppedAt != null && start > this.stoppedAt) return stack.forceReduce() ? stack : null;
        if (this.fragments) {
            let strictCx = stack.curContext && stack.curContext.tracker.strict, cxHash = strictCx ? stack.curContext.hash : 0;
            for(let cached = this.fragments.nodeAt(start); cached;){
                let match = this.parser.nodeSet.types[cached.type.id] == cached.type ? parser.getGoto(stack.state, cached.type.id) : -1;
                if (match > -1 && cached.length && (!strictCx || (cached.prop((0, $uXNGm.NodeProp).contextHash) || 0) == cxHash)) {
                    stack.useNode(cached, match);
                    if ($1c9a4fae1b3745c6$var$verbose) console.log(base + this.stackID(stack) + ` (via reuse of ${parser.getName(cached.type.id)})`);
                    return true;
                }
                if (!(cached instanceof (0, $uXNGm.Tree)) || cached.children.length == 0 || cached.positions[0] > 0) break;
                let inner = cached.children[0];
                if (inner instanceof (0, $uXNGm.Tree) && cached.positions[0] == 0) cached = inner;
                else break;
            }
        }
        let defaultReduce = parser.stateSlot(stack.state, 4 /* ParseState.DefaultReduce */ );
        if (defaultReduce > 0) {
            stack.reduce(defaultReduce);
            if ($1c9a4fae1b3745c6$var$verbose) console.log(base + this.stackID(stack) + ` (via always-reduce ${parser.getName(defaultReduce & 65535 /* Action.ValueMask */ )})`);
            return true;
        }
        if (stack.stack.length >= 8400 /* Rec.CutDepth */ ) {
            while(stack.stack.length > 6000 /* Rec.CutTo */  && stack.forceReduce());
        }
        let actions = this.tokens.getActions(stack);
        for(let i = 0; i < actions.length;){
            let action = actions[i++], term = actions[i++], end = actions[i++];
            let last = i == actions.length || !split;
            let localStack = last ? stack : stack.split();
            let main = this.tokens.mainToken;
            localStack.apply(action, term, main ? main.start : localStack.pos, end);
            if ($1c9a4fae1b3745c6$var$verbose) console.log(base + this.stackID(localStack) + ` (via ${(action & 65536 /* Action.ReduceFlag */ ) == 0 ? "shift" : `reduce of ${parser.getName(action & 65535 /* Action.ValueMask */ )}`} for ${parser.getName(term)} @ ${start}${localStack == stack ? "" : ", split"})`);
            if (last) return true;
            else if (localStack.pos > start) stacks.push(localStack);
            else split.push(localStack);
        }
        return false;
    }
    // Advance a given stack forward as far as it will go. Returns the
    // (possibly updated) stack if it got stuck, or null if it moved
    // forward and was given to `pushStackDedup`.
    advanceFully(stack, newStacks) {
        let pos = stack.pos;
        for(;;){
            if (!this.advanceStack(stack, null, null)) return false;
            if (stack.pos > pos) {
                $1c9a4fae1b3745c6$var$pushStackDedup(stack, newStacks);
                return true;
            }
        }
    }
    runRecovery(stacks, tokens, newStacks) {
        let finished = null, restarted = false;
        for(let i = 0; i < stacks.length; i++){
            let stack = stacks[i], token = tokens[i << 1], tokenEnd = tokens[(i << 1) + 1];
            let base = $1c9a4fae1b3745c6$var$verbose ? this.stackID(stack) + " -> " : "";
            if (stack.deadEnd) {
                if (restarted) continue;
                restarted = true;
                stack.restart();
                if ($1c9a4fae1b3745c6$var$verbose) console.log(base + this.stackID(stack) + " (restarted)");
                let done = this.advanceFully(stack, newStacks);
                if (done) continue;
            }
            let force = stack.split(), forceBase = base;
            for(let j = 0; force.forceReduce() && j < 10 /* Rec.ForceReduceLimit */ ; j++){
                if ($1c9a4fae1b3745c6$var$verbose) console.log(forceBase + this.stackID(force) + " (via force-reduce)");
                let done = this.advanceFully(force, newStacks);
                if (done) break;
                if ($1c9a4fae1b3745c6$var$verbose) forceBase = this.stackID(force) + " -> ";
            }
            for (let insert of stack.recoverByInsert(token)){
                if ($1c9a4fae1b3745c6$var$verbose) console.log(base + this.stackID(insert) + " (via recover-insert)");
                this.advanceFully(insert, newStacks);
            }
            if (this.stream.end > stack.pos) {
                if (tokenEnd == stack.pos) {
                    tokenEnd++;
                    token = 0 /* Term.Err */ ;
                }
                stack.recoverByDelete(token, tokenEnd);
                if ($1c9a4fae1b3745c6$var$verbose) console.log(base + this.stackID(stack) + ` (via recover-delete ${this.parser.getName(token)})`);
                $1c9a4fae1b3745c6$var$pushStackDedup(stack, newStacks);
            } else if (!finished || finished.score < stack.score) finished = stack;
        }
        return finished;
    }
    // Convert the stack's buffer to a syntax tree.
    stackToTree(stack) {
        stack.close();
        return (0, $uXNGm.Tree).build({
            buffer: $1c9a4fae1b3745c6$var$StackBufferCursor.create(stack),
            nodeSet: this.parser.nodeSet,
            topID: this.topTerm,
            maxBufferLength: this.parser.bufferLength,
            reused: this.reused,
            start: this.ranges[0].from,
            length: stack.pos - this.ranges[0].from,
            minRepeatType: this.parser.minRepeatTerm
        });
    }
    stackID(stack) {
        let id = ($1c9a4fae1b3745c6$var$stackIDs || ($1c9a4fae1b3745c6$var$stackIDs = new WeakMap)).get(stack);
        if (!id) $1c9a4fae1b3745c6$var$stackIDs.set(stack, id = String.fromCodePoint(this.nextStackID++));
        return id + stack;
    }
    constructor(parser, input, fragments, ranges){
        this.parser = parser;
        this.input = input;
        this.ranges = ranges;
        this.recovering = 0;
        this.nextStackID = 0x2654; // ♔, ♕, ♖, ♗, ♘, ♙, ♠, ♡, ♢, ♣, ♤, ♥, ♦, ♧
        this.minStackPos = 0;
        this.reused = [];
        this.stoppedAt = null;
        this.lastBigReductionStart = -1;
        this.lastBigReductionSize = 0;
        this.bigReductionCount = 0;
        this.stream = new $1c9a4fae1b3745c6$export$f22294a9362415e4(input, ranges);
        this.tokens = new $1c9a4fae1b3745c6$var$TokenCache(parser, this.stream);
        this.topTerm = parser.top[1];
        let { from: from } = ranges[0];
        this.stacks = [
            $1c9a4fae1b3745c6$export$694e0d28c7ffc90c.start(this, parser.top[0], from)
        ];
        this.fragments = fragments.length && this.stream.end - from > parser.bufferLength * 4 ? new $1c9a4fae1b3745c6$var$FragmentCursor(fragments, parser.nodeSet) : null;
    }
}
function $1c9a4fae1b3745c6$var$pushStackDedup(stack, newStacks) {
    for(let i = 0; i < newStacks.length; i++){
        let other = newStacks[i];
        if (other.pos == stack.pos && other.sameState(stack)) {
            if (newStacks[i].score < stack.score) newStacks[i] = stack;
            return;
        }
    }
    newStacks.push(stack);
}
class $1c9a4fae1b3745c6$var$Dialect {
    allows(term) {
        return !this.disabled || this.disabled[term] == 0;
    }
    constructor(source, flags, disabled){
        this.source = source;
        this.flags = flags;
        this.disabled = disabled;
    }
}
const $1c9a4fae1b3745c6$var$id = (x)=>x;
/**
Context trackers are used to track stateful context (such as
indentation in the Python grammar, or parent elements in the XML
grammar) needed by external tokenizers. You declare them in a
grammar file as `@context exportName from "module"`.

Context values should be immutable, and can be updated (replaced)
on shift or reduce actions.

The export used in a `@context` declaration should be of this
type.
*/ class $1c9a4fae1b3745c6$export$88193367295cc46b {
    /**
    Define a context tracker.
    */ constructor(spec){
        this.start = spec.start;
        this.shift = spec.shift || $1c9a4fae1b3745c6$var$id;
        this.reduce = spec.reduce || $1c9a4fae1b3745c6$var$id;
        this.reuse = spec.reuse || $1c9a4fae1b3745c6$var$id;
        this.hash = spec.hash || (()=>0);
        this.strict = spec.strict !== false;
    }
}
/**
Holds the parse tables for a given grammar, as generated by
`lezer-generator`, and provides [methods](#common.Parser) to parse
content with.
*/ class $1c9a4fae1b3745c6$export$60c033f4cf02b410 extends (0, $uXNGm.Parser) {
    createParse(input, fragments, ranges) {
        let parse = new $1c9a4fae1b3745c6$var$Parse(this, input, fragments, ranges);
        for (let w of this.wrappers)parse = w(parse, input, fragments, ranges);
        return parse;
    }
    /**
    Get a goto table entry @internal
    */ getGoto(state, term, loose = false) {
        let table = this.goto;
        if (term >= table[0]) return -1;
        for(let pos = table[term + 1];;){
            let groupTag = table[pos++], last = groupTag & 1;
            let target = table[pos++];
            if (last && loose) return target;
            for(let end = pos + (groupTag >> 1); pos < end; pos++)if (table[pos] == state) return target;
            if (last) return -1;
        }
    }
    /**
    Check if this state has an action for a given terminal @internal
    */ hasAction(state, terminal) {
        let data = this.data;
        for(let set = 0; set < 2; set++)for(let i = this.stateSlot(state, set ? 2 /* ParseState.Skip */  : 1 /* ParseState.Actions */ ), next;; i += 3){
            if ((next = data[i]) == 65535 /* Seq.End */ ) {
                if (data[i + 1] == 1 /* Seq.Next */ ) next = data[i = $1c9a4fae1b3745c6$var$pair(data, i + 2)];
                else if (data[i + 1] == 2 /* Seq.Other */ ) return $1c9a4fae1b3745c6$var$pair(data, i + 2);
                else break;
            }
            if (next == terminal || next == 0 /* Term.Err */ ) return $1c9a4fae1b3745c6$var$pair(data, i + 1);
        }
        return 0;
    }
    /**
    @internal
    */ stateSlot(state, slot) {
        return this.states[state * 6 /* ParseState.Size */  + slot];
    }
    /**
    @internal
    */ stateFlag(state, flag) {
        return (this.stateSlot(state, 0 /* ParseState.Flags */ ) & flag) > 0;
    }
    /**
    @internal
    */ validAction(state, action) {
        return !!this.allActions(state, (a)=>a == action ? true : null);
    }
    /**
    @internal
    */ allActions(state, action) {
        let deflt = this.stateSlot(state, 4 /* ParseState.DefaultReduce */ );
        let result = deflt ? action(deflt) : undefined;
        for(let i = this.stateSlot(state, 1 /* ParseState.Actions */ ); result == null; i += 3){
            if (this.data[i] == 65535 /* Seq.End */ ) {
                if (this.data[i + 1] == 1 /* Seq.Next */ ) i = $1c9a4fae1b3745c6$var$pair(this.data, i + 2);
                else break;
            }
            result = action($1c9a4fae1b3745c6$var$pair(this.data, i + 1));
        }
        return result;
    }
    /**
    Get the states that can follow this one through shift actions or
    goto jumps. @internal
    */ nextStates(state) {
        let result = [];
        for(let i = this.stateSlot(state, 1 /* ParseState.Actions */ );; i += 3){
            if (this.data[i] == 65535 /* Seq.End */ ) {
                if (this.data[i + 1] == 1 /* Seq.Next */ ) i = $1c9a4fae1b3745c6$var$pair(this.data, i + 2);
                else break;
            }
            if ((this.data[i + 2] & 1) == 0) {
                let value = this.data[i + 1];
                if (!result.some((v, i)=>i & 1 && v == value)) result.push(this.data[i], value);
            }
        }
        return result;
    }
    /**
    Configure the parser. Returns a new parser instance that has the
    given settings modified. Settings not provided in `config` are
    kept from the original parser.
    */ configure(config) {
        // Hideous reflection-based kludge to make it easy to create a
        // slightly modified copy of a parser.
        let copy = Object.assign(Object.create($1c9a4fae1b3745c6$export$60c033f4cf02b410.prototype), this);
        if (config.props) copy.nodeSet = this.nodeSet.extend(...config.props);
        if (config.top) {
            let info = this.topRules[config.top];
            if (!info) throw new RangeError(`Invalid top rule name ${config.top}`);
            copy.top = info;
        }
        if (config.tokenizers) copy.tokenizers = this.tokenizers.map((t)=>{
            let found = config.tokenizers.find((r)=>r.from == t);
            return found ? found.to : t;
        });
        if (config.specializers) {
            copy.specializers = this.specializers.slice();
            copy.specializerSpecs = this.specializerSpecs.map((s, i)=>{
                let found = config.specializers.find((r)=>r.from == s.external);
                if (!found) return s;
                let spec = Object.assign(Object.assign({}, s), {
                    external: found.to
                });
                copy.specializers[i] = $1c9a4fae1b3745c6$var$getSpecializer(spec);
                return spec;
            });
        }
        if (config.contextTracker) copy.context = config.contextTracker;
        if (config.dialect) copy.dialect = this.parseDialect(config.dialect);
        if (config.strict != null) copy.strict = config.strict;
        if (config.wrap) copy.wrappers = copy.wrappers.concat(config.wrap);
        if (config.bufferLength != null) copy.bufferLength = config.bufferLength;
        return copy;
    }
    /**
    Tells you whether any [parse wrappers](#lr.ParserConfig.wrap)
    are registered for this parser.
    */ hasWrappers() {
        return this.wrappers.length > 0;
    }
    /**
    Returns the name associated with a given term. This will only
    work for all terms when the parser was generated with the
    `--names` option. By default, only the names of tagged terms are
    stored.
    */ getName(term) {
        return this.termNames ? this.termNames[term] : String(term <= this.maxNode && this.nodeSet.types[term].name || term);
    }
    /**
    The eof term id is always allocated directly after the node
    types. @internal
    */ get eofTerm() {
        return this.maxNode + 1;
    }
    /**
    The type of top node produced by the parser.
    */ get topNode() {
        return this.nodeSet.types[this.top[1]];
    }
    /**
    @internal
    */ dynamicPrecedence(term) {
        let prec = this.dynamicPrecedences;
        return prec == null ? 0 : prec[term] || 0;
    }
    /**
    @internal
    */ parseDialect(dialect) {
        let values = Object.keys(this.dialects), flags = values.map(()=>false);
        if (dialect) for (let part of dialect.split(" ")){
            let id = values.indexOf(part);
            if (id >= 0) flags[id] = true;
        }
        let disabled = null;
        for(let i = 0; i < values.length; i++)if (!flags[i]) for(let j = this.dialects[values[i]], id; (id = this.data[j++]) != 65535 /* Seq.End */ ;)(disabled || (disabled = new Uint8Array(this.maxTerm + 1)))[id] = 1;
        return new $1c9a4fae1b3745c6$var$Dialect(dialect, flags, disabled);
    }
    /**
    Used by the output of the parser generator. Not available to
    user code. @hide
    */ static deserialize(spec) {
        return new $1c9a4fae1b3745c6$export$60c033f4cf02b410(spec);
    }
    /**
    @internal
    */ constructor(spec){
        super();
        /**
        @internal
        */ this.wrappers = [];
        if (spec.version != 14 /* File.Version */ ) throw new RangeError(`Parser version (${spec.version}) doesn't match runtime version (${14 /* File.Version */ })`);
        let nodeNames = spec.nodeNames.split(" ");
        this.minRepeatTerm = nodeNames.length;
        for(let i = 0; i < spec.repeatNodeCount; i++)nodeNames.push("");
        let topTerms = Object.keys(spec.topRules).map((r)=>spec.topRules[r][1]);
        let nodeProps = [];
        for(let i = 0; i < nodeNames.length; i++)nodeProps.push([]);
        function setProp(nodeID, prop, value) {
            nodeProps[nodeID].push([
                prop,
                prop.deserialize(String(value))
            ]);
        }
        if (spec.nodeProps) for (let propSpec of spec.nodeProps){
            let prop = propSpec[0];
            if (typeof prop == "string") prop = (0, $uXNGm.NodeProp)[prop];
            for(let i = 1; i < propSpec.length;){
                let next = propSpec[i++];
                if (next >= 0) setProp(next, prop, propSpec[i++]);
                else {
                    let value = propSpec[i + -next];
                    for(let j = -next; j > 0; j--)setProp(propSpec[i++], prop, value);
                    i++;
                }
            }
        }
        this.nodeSet = new (0, $uXNGm.NodeSet)(nodeNames.map((name, i)=>(0, $uXNGm.NodeType).define({
                name: i >= this.minRepeatTerm ? undefined : name,
                id: i,
                props: nodeProps[i],
                top: topTerms.indexOf(i) > -1,
                error: i == 0,
                skipped: spec.skippedNodes && spec.skippedNodes.indexOf(i) > -1
            })));
        if (spec.propSources) this.nodeSet = this.nodeSet.extend(...spec.propSources);
        this.strict = false;
        this.bufferLength = (0, $uXNGm.DefaultBufferLength);
        let tokenArray = $1c9a4fae1b3745c6$var$decodeArray(spec.tokenData);
        this.context = spec.context;
        this.specializerSpecs = spec.specialized || [];
        this.specialized = new Uint16Array(this.specializerSpecs.length);
        for(let i = 0; i < this.specializerSpecs.length; i++)this.specialized[i] = this.specializerSpecs[i].term;
        this.specializers = this.specializerSpecs.map($1c9a4fae1b3745c6$var$getSpecializer);
        this.states = $1c9a4fae1b3745c6$var$decodeArray(spec.states, Uint32Array);
        this.data = $1c9a4fae1b3745c6$var$decodeArray(spec.stateData);
        this.goto = $1c9a4fae1b3745c6$var$decodeArray(spec.goto);
        this.maxTerm = spec.maxTerm;
        this.tokenizers = spec.tokenizers.map((value)=>typeof value == "number" ? new $1c9a4fae1b3745c6$var$TokenGroup(tokenArray, value) : value);
        this.topRules = spec.topRules;
        this.dialects = spec.dialects || {};
        this.dynamicPrecedences = spec.dynamicPrecedences || null;
        this.tokenPrecTable = spec.tokenPrec;
        this.termNames = spec.termNames || null;
        this.maxNode = this.nodeSet.types.length - 1;
        this.dialect = this.parseDialect();
        this.top = this.topRules[Object.keys(this.topRules)[0]];
    }
}
function $1c9a4fae1b3745c6$var$pair(data, off) {
    return data[off] | data[off + 1] << 16;
}
function $1c9a4fae1b3745c6$var$findFinished(stacks) {
    let best = null;
    for (let stack of stacks){
        let stopped = stack.p.stoppedAt;
        if ((stack.pos == stack.p.stream.end || stopped != null && stack.pos > stopped) && stack.p.parser.stateFlag(stack.state, 2 /* StateFlag.Accepting */ ) && (!best || best.score < stack.score)) best = stack;
    }
    return best;
}
function $1c9a4fae1b3745c6$var$getSpecializer(spec) {
    if (spec.external) {
        let mask = spec.extend ? 1 /* Specialize.Extend */  : 0 /* Specialize.Specialize */ ;
        return (value, stack)=>spec.external(value, stack) << 1 | mask;
    }
    return spec.get;
}
module.exports["LocalTokenGroup"] = $1c9a4fae1b3745c6$export$dbe55ed82366d5e9;
module.exports["ExternalTokenizer"] = $1c9a4fae1b3745c6$export$6e56a42e94c6b2cb;
module.exports["ContextTracker"] = $1c9a4fae1b3745c6$export$88193367295cc46b;
module.exports["LRParser"] = $1c9a4fae1b3745c6$export$60c033f4cf02b410;

});

parcelRegister("haZ24", function(module, exports) {

var $b2ZzE = parcelRequire("b2ZzE");


var $3e6dc = parcelRequire("3e6dc");


var $4lK5a = parcelRequire("4lK5a");

/**
An instance of this is passed to completion source functions.
*/ class $c812b694720e13a5$export$7b73e80391102dce {
    /**
    Get the extent, content, and (if there is a token) type of the
    token before `this.pos`.
    */ tokenBefore(types) {
        let token = (0, $4lK5a.syntaxTree)(this.state).resolveInner(this.pos, -1);
        while(token && types.indexOf(token.name) < 0)token = token.parent;
        return token ? {
            from: token.from,
            to: this.pos,
            text: this.state.sliceDoc(token.from, this.pos),
            type: token.type
        } : null;
    }
    /**
    Get the match of the given expression directly before the
    cursor.
    */ matchBefore(expr) {
        let line = this.state.doc.lineAt(this.pos);
        let start = Math.max(line.from, this.pos - 250);
        let str = line.text.slice(start - line.from, this.pos - line.from);
        let found = str.search($c812b694720e13a5$var$ensureAnchor(expr, false));
        return found < 0 ? null : {
            from: start + found,
            to: this.pos,
            text: str.slice(found)
        };
    }
    /**
    Yields true when the query has been aborted. Can be useful in
    asynchronous queries to avoid doing work that will be ignored.
    */ get aborted() {
        return this.abortListeners == null;
    }
    /**
    Allows you to register abort handlers, which will be called when
    the query is
    [aborted](https://codemirror.net/6/docs/ref/#autocomplete.CompletionContext.aborted).
    
    By default, running queries will not be aborted for regular
    typing or backspacing, on the assumption that they are likely to
    return a result with a
    [`validFor`](https://codemirror.net/6/docs/ref/#autocomplete.CompletionResult.validFor) field that
    allows the result to be used after all. Passing `onDocChange:
    true` will cause this query to be aborted for any document
    change.
    */ addEventListener(type, listener, options) {
        if (type == "abort" && this.abortListeners) {
            this.abortListeners.push(listener);
            if (options && options.onDocChange) this.abortOnDocChange = true;
        }
    }
    /**
    Create a new completion context. (Mostly useful for testing
    completion sources—in the editor, the extension will create
    these for you.)
    */ constructor(/**
    The editor state that the completion happens in.
    */ state, /**
    The position at which the completion is happening.
    */ pos, /**
    Indicates whether completion was activated explicitly, or
    implicitly by typing. The usual way to respond to this is to
    only return completions when either there is part of a
    completable entity before the cursor, or `explicit` is true.
    */ explicit, /**
    The editor view. May be undefined if the context was created
    in a situation where there is no such view available, such as
    in synchronous updates via
    [`CompletionResult.update`](https://codemirror.net/6/docs/ref/#autocomplete.CompletionResult.update)
    or when called by test code.
    */ view){
        this.state = state;
        this.pos = pos;
        this.explicit = explicit;
        this.view = view;
        /**
        @internal
        */ this.abortListeners = [];
        /**
        @internal
        */ this.abortOnDocChange = false;
    }
}
function $c812b694720e13a5$var$toSet(chars) {
    let flat = Object.keys(chars).join("");
    let words = /\w/.test(flat);
    if (words) flat = flat.replace(/\w/g, "");
    return `[${words ? "\\w" : ""}${flat.replace(/[^\w\s]/g, "\\$&")}]`;
}
function $c812b694720e13a5$var$prefixMatch(options) {
    let first = Object.create(null), rest = Object.create(null);
    for (let { label: label } of options){
        first[label[0]] = true;
        for(let i = 1; i < label.length; i++)rest[label[i]] = true;
    }
    let source = $c812b694720e13a5$var$toSet(first) + $c812b694720e13a5$var$toSet(rest) + "*$";
    return [
        new RegExp("^" + source),
        new RegExp(source)
    ];
}
/**
Given a a fixed array of options, return an autocompleter that
completes them.
*/ function $c812b694720e13a5$export$db0ee7d2648a0c4b(list) {
    let options = list.map((o)=>typeof o == "string" ? {
            label: o
        } : o);
    let [validFor, match] = options.every((o)=>/^\w+$/.test(o.label)) ? [
        /\w*$/,
        /\w+$/
    ] : $c812b694720e13a5$var$prefixMatch(options);
    return (context)=>{
        let token = context.matchBefore(match);
        return token || context.explicit ? {
            from: token ? token.from : context.pos,
            options: options,
            validFor: validFor
        } : null;
    };
}
/**
Wrap the given completion source so that it will only fire when the
cursor is in a syntax node with one of the given names.
*/ function $c812b694720e13a5$export$498fe7f50ed891b8(nodes, source) {
    return (context)=>{
        for(let pos = (0, $4lK5a.syntaxTree)(context.state).resolveInner(context.pos, -1); pos; pos = pos.parent){
            if (nodes.indexOf(pos.name) > -1) return source(context);
            if (pos.type.isTop) break;
        }
        return null;
    };
}
/**
Wrap the given completion source so that it will not fire when the
cursor is in a syntax node with one of the given names.
*/ function $c812b694720e13a5$export$1dfdaeb1e91714c0(nodes, source) {
    return (context)=>{
        for(let pos = (0, $4lK5a.syntaxTree)(context.state).resolveInner(context.pos, -1); pos; pos = pos.parent){
            if (nodes.indexOf(pos.name) > -1) return null;
            if (pos.type.isTop) break;
        }
        return source(context);
    };
}
class $c812b694720e13a5$var$Option {
    constructor(completion, source, match, score){
        this.completion = completion;
        this.source = source;
        this.match = match;
        this.score = score;
    }
}
function $c812b694720e13a5$var$cur(state) {
    return state.selection.main.from;
}
// Make sure the given regexp has a $ at its end and, if `start` is
// true, a ^ at its start.
function $c812b694720e13a5$var$ensureAnchor(expr, start) {
    var _a;
    let { source: source } = expr;
    let addStart = start && source[0] != "^", addEnd = source[source.length - 1] != "$";
    if (!addStart && !addEnd) return expr;
    return new RegExp(`${addStart ? "^" : ""}(?:${source})${addEnd ? "$" : ""}`, (_a = expr.flags) !== null && _a !== void 0 ? _a : expr.ignoreCase ? "i" : "");
}
/**
This annotation is added to transactions that are produced by
picking a completion.
*/ const $c812b694720e13a5$export$6c84d44c1ceeb831 = /*@__PURE__*/ (0, $b2ZzE.Annotation).define();
/**
Helper function that returns a transaction spec which inserts a
completion's text in the main selection range, and any other
selection range that has the same text in front of it.
*/ function $c812b694720e13a5$export$496ff43229d73eba(state, text, from, to) {
    let { main: main } = state.selection, fromOff = from - main.from, toOff = to - main.from;
    return Object.assign(Object.assign({}, state.changeByRange((range)=>{
        if (range != main && from != to && state.sliceDoc(range.from + fromOff, range.from + toOff) != state.sliceDoc(from, to)) return {
            range: range
        };
        let lines = state.toText(text);
        return {
            changes: {
                from: range.from + fromOff,
                to: to == main.from ? range.to : range.from + toOff,
                insert: lines
            },
            range: (0, $b2ZzE.EditorSelection).cursor(range.from + fromOff + lines.length)
        };
    })), {
        scrollIntoView: true,
        userEvent: "input.complete"
    });
}
const $c812b694720e13a5$var$SourceCache = /*@__PURE__*/ new WeakMap();
function $c812b694720e13a5$var$asSource(source) {
    if (!Array.isArray(source)) return source;
    let known = $c812b694720e13a5$var$SourceCache.get(source);
    if (!known) $c812b694720e13a5$var$SourceCache.set(source, known = $c812b694720e13a5$export$db0ee7d2648a0c4b(source));
    return known;
}
const $c812b694720e13a5$var$startCompletionEffect = /*@__PURE__*/ (0, $b2ZzE.StateEffect).define();
const $c812b694720e13a5$var$closeCompletionEffect = /*@__PURE__*/ (0, $b2ZzE.StateEffect).define();
// A pattern matcher for fuzzy completion matching. Create an instance
// once for a pattern, and then use that to match any number of
// completions.
class $c812b694720e13a5$var$FuzzyMatcher {
    ret(score, matched) {
        this.score = score;
        this.matched = matched;
        return this;
    }
    // Matches a given word (completion) against the pattern (input).
    // Will return a boolean indicating whether there was a match and,
    // on success, set `this.score` to the score, `this.matched` to an
    // array of `from, to` pairs indicating the matched parts of `word`.
    //
    // The score is a number that is more negative the worse the match
    // is. See `Penalty` above.
    match(word) {
        if (this.pattern.length == 0) return this.ret(-100 /* Penalty.NotFull */ , []);
        if (word.length < this.pattern.length) return null;
        let { chars: chars, folded: folded, any: any, precise: precise, byWord: byWord } = this;
        // For single-character queries, only match when they occur right
        // at the start
        if (chars.length == 1) {
            let first = (0, $b2ZzE.codePointAt)(word, 0), firstSize = (0, $b2ZzE.codePointSize)(first);
            let score = firstSize == word.length ? 0 : -100 /* Penalty.NotFull */ ;
            if (first == chars[0]) ;
            else if (first == folded[0]) score += -200 /* Penalty.CaseFold */ ;
            else return null;
            return this.ret(score, [
                0,
                firstSize
            ]);
        }
        let direct = word.indexOf(this.pattern);
        if (direct == 0) return this.ret(word.length == this.pattern.length ? 0 : -100 /* Penalty.NotFull */ , [
            0,
            this.pattern.length
        ]);
        let len = chars.length, anyTo = 0;
        if (direct < 0) {
            for(let i = 0, e = Math.min(word.length, 200); i < e && anyTo < len;){
                let next = (0, $b2ZzE.codePointAt)(word, i);
                if (next == chars[anyTo] || next == folded[anyTo]) any[anyTo++] = i;
                i += (0, $b2ZzE.codePointSize)(next);
            }
            // No match, exit immediately
            if (anyTo < len) return null;
        }
        // This tracks the extent of the precise (non-folded, not
        // necessarily adjacent) match
        let preciseTo = 0;
        // Tracks whether there is a match that hits only characters that
        // appear to be starting words. `byWordFolded` is set to true when
        // a case folded character is encountered in such a match
        let byWordTo = 0, byWordFolded = false;
        // If we've found a partial adjacent match, these track its state
        let adjacentTo = 0, adjacentStart = -1, adjacentEnd = -1;
        let hasLower = /[a-z]/.test(word), wordAdjacent = true;
        // Go over the option's text, scanning for the various kinds of matches
        for(let i = 0, e = Math.min(word.length, 200), prevType = 0 /* Tp.NonWord */ ; i < e && byWordTo < len;){
            let next = (0, $b2ZzE.codePointAt)(word, i);
            if (direct < 0) {
                if (preciseTo < len && next == chars[preciseTo]) precise[preciseTo++] = i;
                if (adjacentTo < len) {
                    if (next == chars[adjacentTo] || next == folded[adjacentTo]) {
                        if (adjacentTo == 0) adjacentStart = i;
                        adjacentEnd = i + 1;
                        adjacentTo++;
                    } else adjacentTo = 0;
                }
            }
            let ch, type = next < 0xff ? next >= 48 && next <= 57 || next >= 97 && next <= 122 ? 2 /* Tp.Lower */  : next >= 65 && next <= 90 ? 1 /* Tp.Upper */  : 0 /* Tp.NonWord */  : (ch = (0, $b2ZzE.fromCodePoint)(next)) != ch.toLowerCase() ? 1 /* Tp.Upper */  : ch != ch.toUpperCase() ? 2 /* Tp.Lower */  : 0 /* Tp.NonWord */ ;
            if (!i || type == 1 /* Tp.Upper */  && hasLower || prevType == 0 /* Tp.NonWord */  && type != 0 /* Tp.NonWord */ ) {
                if (chars[byWordTo] == next || folded[byWordTo] == next && (byWordFolded = true)) byWord[byWordTo++] = i;
                else if (byWord.length) wordAdjacent = false;
            }
            prevType = type;
            i += (0, $b2ZzE.codePointSize)(next);
        }
        if (byWordTo == len && byWord[0] == 0 && wordAdjacent) return this.result(-100 /* Penalty.ByWord */  + (byWordFolded ? -200 /* Penalty.CaseFold */  : 0), byWord, word);
        if (adjacentTo == len && adjacentStart == 0) return this.ret(-200 /* Penalty.CaseFold */  - word.length + (adjacentEnd == word.length ? 0 : -100 /* Penalty.NotFull */ ), [
            0,
            adjacentEnd
        ]);
        if (direct > -1) return this.ret(-700 /* Penalty.NotStart */  - word.length, [
            direct,
            direct + this.pattern.length
        ]);
        if (adjacentTo == len) return this.ret(-900 /* Penalty.NotStart */  - word.length, [
            adjacentStart,
            adjacentEnd
        ]);
        if (byWordTo == len) return this.result(-100 /* Penalty.ByWord */  + (byWordFolded ? -200 /* Penalty.CaseFold */  : 0) + -700 /* Penalty.NotStart */  + (wordAdjacent ? 0 : -1100 /* Penalty.Gap */ ), byWord, word);
        return chars.length == 2 ? null : this.result((any[0] ? -700 /* Penalty.NotStart */  : 0) + -200 /* Penalty.CaseFold */  + -1100 /* Penalty.Gap */ , any, word);
    }
    result(score, positions, word) {
        let result = [], i = 0;
        for (let pos of positions){
            let to = pos + (this.astral ? (0, $b2ZzE.codePointSize)((0, $b2ZzE.codePointAt)(word, pos)) : 1);
            if (i && result[i - 1] == pos) result[i - 1] = to;
            else {
                result[i++] = pos;
                result[i++] = to;
            }
        }
        return this.ret(score - word.length, result);
    }
    constructor(pattern){
        this.pattern = pattern;
        this.chars = [];
        this.folded = [];
        // Buffers reused by calls to `match` to track matched character
        // positions.
        this.any = [];
        this.precise = [];
        this.byWord = [];
        this.score = 0;
        this.matched = [];
        for(let p = 0; p < pattern.length;){
            let char = (0, $b2ZzE.codePointAt)(pattern, p), size = (0, $b2ZzE.codePointSize)(char);
            this.chars.push(char);
            let part = pattern.slice(p, p + size), upper = part.toUpperCase();
            this.folded.push((0, $b2ZzE.codePointAt)(upper == part ? part.toLowerCase() : upper, 0));
            p += size;
        }
        this.astral = pattern.length != this.chars.length;
    }
}
class $c812b694720e13a5$var$StrictMatcher {
    match(word) {
        if (word.length < this.pattern.length) return null;
        let start = word.slice(0, this.pattern.length);
        let match = start == this.pattern ? 0 : start.toLowerCase() == this.folded ? -200 /* Penalty.CaseFold */  : null;
        if (match == null) return null;
        this.matched = [
            0,
            start.length
        ];
        this.score = match + (word.length == this.pattern.length ? 0 : -100 /* Penalty.NotFull */ );
        return this;
    }
    constructor(pattern){
        this.pattern = pattern;
        this.matched = [];
        this.score = 0;
        this.folded = pattern.toLowerCase();
    }
}
const $c812b694720e13a5$var$completionConfig = /*@__PURE__*/ (0, $b2ZzE.Facet).define({
    combine (configs) {
        return (0, $b2ZzE.combineConfig)(configs, {
            activateOnTyping: true,
            activateOnCompletion: ()=>false,
            activateOnTypingDelay: 100,
            selectOnOpen: true,
            override: null,
            closeOnBlur: true,
            maxRenderedOptions: 100,
            defaultKeymap: true,
            tooltipClass: ()=>"",
            optionClass: ()=>"",
            aboveCursor: false,
            icons: true,
            addToOptions: [],
            positionInfo: $c812b694720e13a5$var$defaultPositionInfo,
            filterStrict: false,
            compareCompletions: (a, b)=>a.label.localeCompare(b.label),
            interactionDelay: 75,
            updateSyncTime: 100
        }, {
            defaultKeymap: (a, b)=>a && b,
            closeOnBlur: (a, b)=>a && b,
            icons: (a, b)=>a && b,
            tooltipClass: (a, b)=>(c)=>$c812b694720e13a5$var$joinClass(a(c), b(c)),
            optionClass: (a, b)=>(c)=>$c812b694720e13a5$var$joinClass(a(c), b(c)),
            addToOptions: (a, b)=>a.concat(b),
            filterStrict: (a, b)=>a || b
        });
    }
});
function $c812b694720e13a5$var$joinClass(a, b) {
    return a ? b ? a + " " + b : a : b;
}
function $c812b694720e13a5$var$defaultPositionInfo(view, list, option, info, space, tooltip) {
    let rtl = view.textDirection == (0, $3e6dc.Direction).RTL, left = rtl, narrow = false;
    let side = "top", offset, maxWidth;
    let spaceLeft = list.left - space.left, spaceRight = space.right - list.right;
    let infoWidth = info.right - info.left, infoHeight = info.bottom - info.top;
    if (left && spaceLeft < Math.min(infoWidth, spaceRight)) left = false;
    else if (!left && spaceRight < Math.min(infoWidth, spaceLeft)) left = true;
    if (infoWidth <= (left ? spaceLeft : spaceRight)) {
        offset = Math.max(space.top, Math.min(option.top, space.bottom - infoHeight)) - list.top;
        maxWidth = Math.min(400 /* Info.Width */ , left ? spaceLeft : spaceRight);
    } else {
        narrow = true;
        maxWidth = Math.min(400 /* Info.Width */ , (rtl ? list.right : space.right - list.left) - 30 /* Info.Margin */ );
        let spaceBelow = space.bottom - list.bottom;
        if (spaceBelow >= infoHeight || spaceBelow > list.top) offset = option.bottom - list.top;
        else {
            side = "bottom";
            offset = list.bottom - option.top;
        }
    }
    let scaleY = (list.bottom - list.top) / tooltip.offsetHeight;
    let scaleX = (list.right - list.left) / tooltip.offsetWidth;
    return {
        style: `${side}: ${offset / scaleY}px; max-width: ${maxWidth / scaleX}px`,
        class: "cm-completionInfo-" + (narrow ? rtl ? "left-narrow" : "right-narrow" : left ? "left" : "right")
    };
}
function $c812b694720e13a5$var$optionContent(config) {
    let content = config.addToOptions.slice();
    if (config.icons) content.push({
        render (completion) {
            let icon = document.createElement("div");
            icon.classList.add("cm-completionIcon");
            if (completion.type) icon.classList.add(...completion.type.split(/\s+/g).map((cls)=>"cm-completionIcon-" + cls));
            icon.setAttribute("aria-hidden", "true");
            return icon;
        },
        position: 20
    });
    content.push({
        render (completion, _s, _v, match) {
            let labelElt = document.createElement("span");
            labelElt.className = "cm-completionLabel";
            let label = completion.displayLabel || completion.label, off = 0;
            for(let j = 0; j < match.length;){
                let from = match[j++], to = match[j++];
                if (from > off) labelElt.appendChild(document.createTextNode(label.slice(off, from)));
                let span = labelElt.appendChild(document.createElement("span"));
                span.appendChild(document.createTextNode(label.slice(from, to)));
                span.className = "cm-completionMatchedText";
                off = to;
            }
            if (off < label.length) labelElt.appendChild(document.createTextNode(label.slice(off)));
            return labelElt;
        },
        position: 50
    }, {
        render (completion) {
            if (!completion.detail) return null;
            let detailElt = document.createElement("span");
            detailElt.className = "cm-completionDetail";
            detailElt.textContent = completion.detail;
            return detailElt;
        },
        position: 80
    });
    return content.sort((a, b)=>a.position - b.position).map((a)=>a.render);
}
function $c812b694720e13a5$var$rangeAroundSelected(total, selected, max) {
    if (total <= max) return {
        from: 0,
        to: total
    };
    if (selected < 0) selected = 0;
    if (selected <= total >> 1) {
        let off = Math.floor(selected / max);
        return {
            from: off * max,
            to: (off + 1) * max
        };
    }
    let off = Math.floor((total - selected) / max);
    return {
        from: total - (off + 1) * max,
        to: total - off * max
    };
}
class $c812b694720e13a5$var$CompletionTooltip {
    mount() {
        this.updateSel();
    }
    showOptions(options, id) {
        if (this.list) this.list.remove();
        this.list = this.dom.appendChild(this.createListBox(options, id, this.range));
        this.list.addEventListener("scroll", ()=>{
            if (this.info) this.view.requestMeasure(this.placeInfoReq);
        });
    }
    update(update) {
        var _a;
        let cState = update.state.field(this.stateField);
        let prevState = update.startState.field(this.stateField);
        this.updateTooltipClass(update.state);
        if (cState != prevState) {
            let { options: options, selected: selected, disabled: disabled } = cState.open;
            if (!prevState.open || prevState.open.options != options) {
                this.range = $c812b694720e13a5$var$rangeAroundSelected(options.length, selected, update.state.facet($c812b694720e13a5$var$completionConfig).maxRenderedOptions);
                this.showOptions(options, cState.id);
            }
            this.updateSel();
            if (disabled != ((_a = prevState.open) === null || _a === void 0 ? void 0 : _a.disabled)) this.dom.classList.toggle("cm-tooltip-autocomplete-disabled", !!disabled);
        }
    }
    updateTooltipClass(state) {
        let cls = this.tooltipClass(state);
        if (cls != this.currentClass) {
            for (let c of this.currentClass.split(" "))if (c) this.dom.classList.remove(c);
            for (let c of cls.split(" "))if (c) this.dom.classList.add(c);
            this.currentClass = cls;
        }
    }
    positioned(space) {
        this.space = space;
        if (this.info) this.view.requestMeasure(this.placeInfoReq);
    }
    updateSel() {
        let cState = this.view.state.field(this.stateField), open = cState.open;
        if (open.selected > -1 && open.selected < this.range.from || open.selected >= this.range.to) {
            this.range = $c812b694720e13a5$var$rangeAroundSelected(open.options.length, open.selected, this.view.state.facet($c812b694720e13a5$var$completionConfig).maxRenderedOptions);
            this.showOptions(open.options, cState.id);
        }
        if (this.updateSelectedOption(open.selected)) {
            this.destroyInfo();
            let { completion: completion } = open.options[open.selected];
            let { info: info } = completion;
            if (!info) return;
            let infoResult = typeof info === "string" ? document.createTextNode(info) : info(completion);
            if (!infoResult) return;
            if ("then" in infoResult) infoResult.then((obj)=>{
                if (obj && this.view.state.field(this.stateField, false) == cState) this.addInfoPane(obj, completion);
            }).catch((e)=>(0, $3e6dc.logException)(this.view.state, e, "completion info"));
            else this.addInfoPane(infoResult, completion);
        }
    }
    addInfoPane(content, completion) {
        this.destroyInfo();
        let wrap = this.info = document.createElement("div");
        wrap.className = "cm-tooltip cm-completionInfo";
        if (content.nodeType != null) {
            wrap.appendChild(content);
            this.infoDestroy = null;
        } else {
            let { dom: dom, destroy: destroy } = content;
            wrap.appendChild(dom);
            this.infoDestroy = destroy || null;
        }
        this.dom.appendChild(wrap);
        this.view.requestMeasure(this.placeInfoReq);
    }
    updateSelectedOption(selected) {
        let set = null;
        for(let opt = this.list.firstChild, i = this.range.from; opt; opt = opt.nextSibling, i++){
            if (opt.nodeName != "LI" || !opt.id) i--; // A section header
            else if (i == selected) {
                if (!opt.hasAttribute("aria-selected")) {
                    opt.setAttribute("aria-selected", "true");
                    set = opt;
                }
            } else if (opt.hasAttribute("aria-selected")) opt.removeAttribute("aria-selected");
        }
        if (set) $c812b694720e13a5$var$scrollIntoView(this.list, set);
        return set;
    }
    measureInfo() {
        let sel = this.dom.querySelector("[aria-selected]");
        if (!sel || !this.info) return null;
        let listRect = this.dom.getBoundingClientRect();
        let infoRect = this.info.getBoundingClientRect();
        let selRect = sel.getBoundingClientRect();
        let space = this.space;
        if (!space) {
            let win = this.dom.ownerDocument.defaultView || window;
            space = {
                left: 0,
                top: 0,
                right: win.innerWidth,
                bottom: win.innerHeight
            };
        }
        if (selRect.top > Math.min(space.bottom, listRect.bottom) - 10 || selRect.bottom < Math.max(space.top, listRect.top) + 10) return null;
        return this.view.state.facet($c812b694720e13a5$var$completionConfig).positionInfo(this.view, listRect, selRect, infoRect, space, this.dom);
    }
    placeInfo(pos) {
        if (this.info) {
            if (pos) {
                if (pos.style) this.info.style.cssText = pos.style;
                this.info.className = "cm-tooltip cm-completionInfo " + (pos.class || "");
            } else this.info.style.cssText = "top: -1e6px";
        }
    }
    createListBox(options, id, range) {
        const ul = document.createElement("ul");
        ul.id = id;
        ul.setAttribute("role", "listbox");
        ul.setAttribute("aria-expanded", "true");
        ul.setAttribute("aria-label", this.view.state.phrase("Completions"));
        let curSection = null;
        for(let i = range.from; i < range.to; i++){
            let { completion: completion, match: match } = options[i], { section: section } = completion;
            if (section) {
                let name = typeof section == "string" ? section : section.name;
                if (name != curSection && (i > range.from || range.from == 0)) {
                    curSection = name;
                    if (typeof section != "string" && section.header) ul.appendChild(section.header(section));
                    else {
                        let header = ul.appendChild(document.createElement("completion-section"));
                        header.textContent = name;
                    }
                }
            }
            const li = ul.appendChild(document.createElement("li"));
            li.id = id + "-" + i;
            li.setAttribute("role", "option");
            let cls = this.optionClass(completion);
            if (cls) li.className = cls;
            for (let source of this.optionContent){
                let node = source(completion, this.view.state, this.view, match);
                if (node) li.appendChild(node);
            }
        }
        if (range.from) ul.classList.add("cm-completionListIncompleteTop");
        if (range.to < options.length) ul.classList.add("cm-completionListIncompleteBottom");
        return ul;
    }
    destroyInfo() {
        if (this.info) {
            if (this.infoDestroy) this.infoDestroy();
            this.info.remove();
            this.info = null;
        }
    }
    destroy() {
        this.destroyInfo();
    }
    constructor(view, stateField, applyCompletion){
        this.view = view;
        this.stateField = stateField;
        this.applyCompletion = applyCompletion;
        this.info = null;
        this.infoDestroy = null;
        this.placeInfoReq = {
            read: ()=>this.measureInfo(),
            write: (pos)=>this.placeInfo(pos),
            key: this
        };
        this.space = null;
        this.currentClass = "";
        let cState = view.state.field(stateField);
        let { options: options, selected: selected } = cState.open;
        let config = view.state.facet($c812b694720e13a5$var$completionConfig);
        this.optionContent = $c812b694720e13a5$var$optionContent(config);
        this.optionClass = config.optionClass;
        this.tooltipClass = config.tooltipClass;
        this.range = $c812b694720e13a5$var$rangeAroundSelected(options.length, selected, config.maxRenderedOptions);
        this.dom = document.createElement("div");
        this.dom.className = "cm-tooltip-autocomplete";
        this.updateTooltipClass(view.state);
        this.dom.addEventListener("mousedown", (e)=>{
            let { options: options } = view.state.field(stateField).open;
            for(let dom = e.target, match; dom && dom != this.dom; dom = dom.parentNode)if (dom.nodeName == "LI" && (match = /-(\d+)$/.exec(dom.id)) && +match[1] < options.length) {
                this.applyCompletion(view, options[+match[1]]);
                e.preventDefault();
                return;
            }
        });
        this.dom.addEventListener("focusout", (e)=>{
            let state = view.state.field(this.stateField, false);
            if (state && state.tooltip && view.state.facet($c812b694720e13a5$var$completionConfig).closeOnBlur && e.relatedTarget != view.contentDOM) view.dispatch({
                effects: $c812b694720e13a5$var$closeCompletionEffect.of(null)
            });
        });
        this.showOptions(options, cState.id);
    }
}
function $c812b694720e13a5$var$completionTooltip(stateField, applyCompletion) {
    return (view)=>new $c812b694720e13a5$var$CompletionTooltip(view, stateField, applyCompletion);
}
function $c812b694720e13a5$var$scrollIntoView(container, element) {
    let parent = container.getBoundingClientRect();
    let self = element.getBoundingClientRect();
    let scaleY = parent.height / container.offsetHeight;
    if (self.top < parent.top) container.scrollTop -= (parent.top - self.top) / scaleY;
    else if (self.bottom > parent.bottom) container.scrollTop += (self.bottom - parent.bottom) / scaleY;
}
// Used to pick a preferred option when two options with the same
// label occur in the result.
function $c812b694720e13a5$var$score(option) {
    return (option.boost || 0) * 100 + (option.apply ? 10 : 0) + (option.info ? 5 : 0) + (option.type ? 1 : 0);
}
function $c812b694720e13a5$var$sortOptions(active, state) {
    let options = [];
    let sections = null;
    let addOption = (option)=>{
        options.push(option);
        let { section: section } = option.completion;
        if (section) {
            if (!sections) sections = [];
            let name = typeof section == "string" ? section : section.name;
            if (!sections.some((s)=>s.name == name)) sections.push(typeof section == "string" ? {
                name: name
            } : section);
        }
    };
    let conf = state.facet($c812b694720e13a5$var$completionConfig);
    for (let a of active)if (a.hasResult()) {
        let getMatch = a.result.getMatch;
        if (a.result.filter === false) for (let option of a.result.options)addOption(new $c812b694720e13a5$var$Option(option, a.source, getMatch ? getMatch(option) : [], 1e9 - options.length));
        else {
            let pattern = state.sliceDoc(a.from, a.to), match;
            let matcher = conf.filterStrict ? new $c812b694720e13a5$var$StrictMatcher(pattern) : new $c812b694720e13a5$var$FuzzyMatcher(pattern);
            for (let option of a.result.options)if (match = matcher.match(option.label)) {
                let matched = !option.displayLabel ? match.matched : getMatch ? getMatch(option, match.matched) : [];
                addOption(new $c812b694720e13a5$var$Option(option, a.source, matched, match.score + (option.boost || 0)));
            }
        }
    }
    if (sections) {
        let sectionOrder = Object.create(null), pos = 0;
        let cmp = (a, b)=>{
            var _a, _b;
            return ((_a = a.rank) !== null && _a !== void 0 ? _a : 1e9) - ((_b = b.rank) !== null && _b !== void 0 ? _b : 1e9) || (a.name < b.name ? -1 : 1);
        };
        for (let s of sections.sort(cmp)){
            pos -= 1e5;
            sectionOrder[s.name] = pos;
        }
        for (let option of options){
            let { section: section } = option.completion;
            if (section) option.score += sectionOrder[typeof section == "string" ? section : section.name];
        }
    }
    let result = [], prev = null;
    let compare = conf.compareCompletions;
    for (let opt of options.sort((a, b)=>b.score - a.score || compare(a.completion, b.completion))){
        let cur = opt.completion;
        if (!prev || prev.label != cur.label || prev.detail != cur.detail || prev.type != null && cur.type != null && prev.type != cur.type || prev.apply != cur.apply || prev.boost != cur.boost) result.push(opt);
        else if ($c812b694720e13a5$var$score(opt.completion) > $c812b694720e13a5$var$score(prev)) result[result.length - 1] = opt;
        prev = opt.completion;
    }
    return result;
}
class $c812b694720e13a5$var$CompletionDialog {
    setSelected(selected, id) {
        return selected == this.selected || selected >= this.options.length ? this : new $c812b694720e13a5$var$CompletionDialog(this.options, $c812b694720e13a5$var$makeAttrs(id, selected), this.tooltip, this.timestamp, selected, this.disabled);
    }
    static build(active, state, id, prev, conf, didSetActive) {
        if (prev && !didSetActive && active.some((s)=>s.isPending)) return prev.setDisabled();
        let options = $c812b694720e13a5$var$sortOptions(active, state);
        if (!options.length) return prev && active.some((a)=>a.isPending) ? prev.setDisabled() : null;
        let selected = state.facet($c812b694720e13a5$var$completionConfig).selectOnOpen ? 0 : -1;
        if (prev && prev.selected != selected && prev.selected != -1) {
            let selectedValue = prev.options[prev.selected].completion;
            for(let i = 0; i < options.length; i++)if (options[i].completion == selectedValue) {
                selected = i;
                break;
            }
        }
        return new $c812b694720e13a5$var$CompletionDialog(options, $c812b694720e13a5$var$makeAttrs(id, selected), {
            pos: active.reduce((a, b)=>b.hasResult() ? Math.min(a, b.from) : a, 1e8),
            create: $c812b694720e13a5$var$createTooltip,
            above: conf.aboveCursor
        }, prev ? prev.timestamp : Date.now(), selected, false);
    }
    map(changes) {
        return new $c812b694720e13a5$var$CompletionDialog(this.options, this.attrs, Object.assign(Object.assign({}, this.tooltip), {
            pos: changes.mapPos(this.tooltip.pos)
        }), this.timestamp, this.selected, this.disabled);
    }
    setDisabled() {
        return new $c812b694720e13a5$var$CompletionDialog(this.options, this.attrs, this.tooltip, this.timestamp, this.selected, true);
    }
    constructor(options, attrs, tooltip, timestamp, selected, disabled){
        this.options = options;
        this.attrs = attrs;
        this.tooltip = tooltip;
        this.timestamp = timestamp;
        this.selected = selected;
        this.disabled = disabled;
    }
}
class $c812b694720e13a5$var$CompletionState {
    static start() {
        return new $c812b694720e13a5$var$CompletionState($c812b694720e13a5$var$none, "cm-ac-" + Math.floor(Math.random() * 2e6).toString(36), null);
    }
    update(tr) {
        let { state: state } = tr, conf = state.facet($c812b694720e13a5$var$completionConfig);
        let sources = conf.override || state.languageDataAt("autocomplete", $c812b694720e13a5$var$cur(state)).map($c812b694720e13a5$var$asSource);
        let active = sources.map((source)=>{
            let value = this.active.find((s)=>s.source == source) || new $c812b694720e13a5$var$ActiveSource(source, this.active.some((a)=>a.state != 0 /* State.Inactive */ ) ? 1 /* State.Pending */  : 0 /* State.Inactive */ );
            return value.update(tr, conf);
        });
        if (active.length == this.active.length && active.every((a, i)=>a == this.active[i])) active = this.active;
        let open = this.open, didSet = tr.effects.some((e)=>e.is($c812b694720e13a5$var$setActiveEffect));
        if (open && tr.docChanged) open = open.map(tr.changes);
        if (tr.selection || active.some((a)=>a.hasResult() && tr.changes.touchesRange(a.from, a.to)) || !$c812b694720e13a5$var$sameResults(active, this.active) || didSet) open = $c812b694720e13a5$var$CompletionDialog.build(active, state, this.id, open, conf, didSet);
        else if (open && open.disabled && !active.some((a)=>a.isPending)) open = null;
        if (!open && active.every((a)=>!a.isPending) && active.some((a)=>a.hasResult())) active = active.map((a)=>a.hasResult() ? new $c812b694720e13a5$var$ActiveSource(a.source, 0 /* State.Inactive */ ) : a);
        for (let effect of tr.effects)if (effect.is($c812b694720e13a5$var$setSelectedEffect)) open = open && open.setSelected(effect.value, this.id);
        return active == this.active && open == this.open ? this : new $c812b694720e13a5$var$CompletionState(active, this.id, open);
    }
    get tooltip() {
        return this.open ? this.open.tooltip : null;
    }
    get attrs() {
        return this.open ? this.open.attrs : this.active.length ? $c812b694720e13a5$var$baseAttrs : $c812b694720e13a5$var$noAttrs;
    }
    constructor(active, id, open){
        this.active = active;
        this.id = id;
        this.open = open;
    }
}
function $c812b694720e13a5$var$sameResults(a, b) {
    if (a == b) return true;
    for(let iA = 0, iB = 0;;){
        while(iA < a.length && !a[iA].hasResult())iA++;
        while(iB < b.length && !b[iB].hasResult())iB++;
        let endA = iA == a.length, endB = iB == b.length;
        if (endA || endB) return endA == endB;
        if (a[iA++].result != b[iB++].result) return false;
    }
}
const $c812b694720e13a5$var$baseAttrs = {
    "aria-autocomplete": "list"
};
const $c812b694720e13a5$var$noAttrs = {};
function $c812b694720e13a5$var$makeAttrs(id, selected) {
    let result = {
        "aria-autocomplete": "list",
        "aria-haspopup": "listbox",
        "aria-controls": id
    };
    if (selected > -1) result["aria-activedescendant"] = id + "-" + selected;
    return result;
}
const $c812b694720e13a5$var$none = [];
function $c812b694720e13a5$var$getUpdateType(tr, conf) {
    if (tr.isUserEvent("input.complete")) {
        let completion = tr.annotation($c812b694720e13a5$export$6c84d44c1ceeb831);
        if (completion && conf.activateOnCompletion(completion)) return 12 /* UpdateType.Reset */ ;
    }
    let typing = tr.isUserEvent("input.type");
    return typing && conf.activateOnTyping ? 5 /* UpdateType.Typing */  : typing ? 1 /* UpdateType.Typing */  : tr.isUserEvent("delete.backward") ? 2 /* UpdateType.Backspacing */  : tr.selection ? 8 /* UpdateType.Reset */  : tr.docChanged ? 16 /* UpdateType.ResetIfTouching */  : 0 /* UpdateType.None */ ;
}
class $c812b694720e13a5$var$ActiveSource {
    hasResult() {
        return false;
    }
    get isPending() {
        return this.state == 1 /* State.Pending */ ;
    }
    update(tr, conf) {
        let type = $c812b694720e13a5$var$getUpdateType(tr, conf), value = this;
        if (type & 8 /* UpdateType.Reset */  || type & 16 /* UpdateType.ResetIfTouching */  && this.touches(tr)) value = new $c812b694720e13a5$var$ActiveSource(value.source, 0 /* State.Inactive */ );
        if (type & 4 /* UpdateType.Activate */  && value.state == 0 /* State.Inactive */ ) value = new $c812b694720e13a5$var$ActiveSource(this.source, 1 /* State.Pending */ );
        value = value.updateFor(tr, type);
        for (let effect of tr.effects){
            if (effect.is($c812b694720e13a5$var$startCompletionEffect)) value = new $c812b694720e13a5$var$ActiveSource(value.source, 1 /* State.Pending */ , effect.value);
            else if (effect.is($c812b694720e13a5$var$closeCompletionEffect)) value = new $c812b694720e13a5$var$ActiveSource(value.source, 0 /* State.Inactive */ );
            else if (effect.is($c812b694720e13a5$var$setActiveEffect)) {
                for (let active of effect.value)if (active.source == value.source) value = active;
            }
        }
        return value;
    }
    updateFor(tr, type) {
        return this.map(tr.changes);
    }
    map(changes) {
        return this;
    }
    touches(tr) {
        return tr.changes.touchesRange($c812b694720e13a5$var$cur(tr.state));
    }
    constructor(source, state, explicit = false){
        this.source = source;
        this.state = state;
        this.explicit = explicit;
    }
}
class $c812b694720e13a5$var$ActiveResult extends $c812b694720e13a5$var$ActiveSource {
    hasResult() {
        return true;
    }
    updateFor(tr, type) {
        var _a;
        if (!(type & 3 /* UpdateType.SimpleInteraction */ )) return this.map(tr.changes);
        let result = this.result;
        if (result.map && !tr.changes.empty) result = result.map(result, tr.changes);
        let from = tr.changes.mapPos(this.from), to = tr.changes.mapPos(this.to, 1);
        let pos = $c812b694720e13a5$var$cur(tr.state);
        if (pos > to || !result || type & 2 /* UpdateType.Backspacing */  && ($c812b694720e13a5$var$cur(tr.startState) == this.from || pos < this.limit)) return new $c812b694720e13a5$var$ActiveSource(this.source, type & 4 /* UpdateType.Activate */  ? 1 /* State.Pending */  : 0 /* State.Inactive */ );
        let limit = tr.changes.mapPos(this.limit);
        if ($c812b694720e13a5$var$checkValid(result.validFor, tr.state, from, to)) return new $c812b694720e13a5$var$ActiveResult(this.source, this.explicit, limit, result, from, to);
        if (result.update && (result = result.update(result, from, to, new $c812b694720e13a5$export$7b73e80391102dce(tr.state, pos, false)))) return new $c812b694720e13a5$var$ActiveResult(this.source, this.explicit, limit, result, result.from, (_a = result.to) !== null && _a !== void 0 ? _a : $c812b694720e13a5$var$cur(tr.state));
        return new $c812b694720e13a5$var$ActiveSource(this.source, 1 /* State.Pending */ , this.explicit);
    }
    map(mapping) {
        if (mapping.empty) return this;
        let result = this.result.map ? this.result.map(this.result, mapping) : this.result;
        if (!result) return new $c812b694720e13a5$var$ActiveSource(this.source, 0 /* State.Inactive */ );
        return new $c812b694720e13a5$var$ActiveResult(this.source, this.explicit, mapping.mapPos(this.limit), this.result, mapping.mapPos(this.from), mapping.mapPos(this.to, 1));
    }
    touches(tr) {
        return tr.changes.touchesRange(this.from, this.to);
    }
    constructor(source, explicit, limit, result, from, to){
        super(source, 3 /* State.Result */ , explicit);
        this.limit = limit;
        this.result = result;
        this.from = from;
        this.to = to;
    }
}
function $c812b694720e13a5$var$checkValid(validFor, state, from, to) {
    if (!validFor) return false;
    let text = state.sliceDoc(from, to);
    return typeof validFor == "function" ? validFor(text, from, to, state) : $c812b694720e13a5$var$ensureAnchor(validFor, true).test(text);
}
const $c812b694720e13a5$var$setActiveEffect = /*@__PURE__*/ (0, $b2ZzE.StateEffect).define({
    map (sources, mapping) {
        return sources.map((s)=>s.map(mapping));
    }
});
const $c812b694720e13a5$var$setSelectedEffect = /*@__PURE__*/ (0, $b2ZzE.StateEffect).define();
const $c812b694720e13a5$var$completionState = /*@__PURE__*/ (0, $b2ZzE.StateField).define({
    create () {
        return $c812b694720e13a5$var$CompletionState.start();
    },
    update (value, tr) {
        return value.update(tr);
    },
    provide: (f)=>[
            (0, $3e6dc.showTooltip).from(f, (val)=>val.tooltip),
            (0, $3e6dc.EditorView).contentAttributes.from(f, (state)=>state.attrs)
        ]
});
function $c812b694720e13a5$var$applyCompletion(view, option) {
    const apply = option.completion.apply || option.completion.label;
    let result = view.state.field($c812b694720e13a5$var$completionState).active.find((a)=>a.source == option.source);
    if (!(result instanceof $c812b694720e13a5$var$ActiveResult)) return false;
    if (typeof apply == "string") view.dispatch(Object.assign(Object.assign({}, $c812b694720e13a5$export$496ff43229d73eba(view.state, apply, result.from, result.to)), {
        annotations: $c812b694720e13a5$export$6c84d44c1ceeb831.of(option.completion)
    }));
    else apply(view, option.completion, result.from, result.to);
    return true;
}
const $c812b694720e13a5$var$createTooltip = /*@__PURE__*/ $c812b694720e13a5$var$completionTooltip($c812b694720e13a5$var$completionState, $c812b694720e13a5$var$applyCompletion);
/**
Returns a command that moves the completion selection forward or
backward by the given amount.
*/ function $c812b694720e13a5$export$26f3a479ac65d653(forward, by = "option") {
    return (view)=>{
        let cState = view.state.field($c812b694720e13a5$var$completionState, false);
        if (!cState || !cState.open || cState.open.disabled || Date.now() - cState.open.timestamp < view.state.facet($c812b694720e13a5$var$completionConfig).interactionDelay) return false;
        let step = 1, tooltip;
        if (by == "page" && (tooltip = (0, $3e6dc.getTooltip)(view, cState.open.tooltip))) step = Math.max(2, Math.floor(tooltip.dom.offsetHeight / tooltip.dom.querySelector("li").offsetHeight) - 1);
        let { length: length } = cState.open.options;
        let selected = cState.open.selected > -1 ? cState.open.selected + step * (forward ? 1 : -1) : forward ? 0 : length - 1;
        if (selected < 0) selected = by == "page" ? 0 : length - 1;
        else if (selected >= length) selected = by == "page" ? length - 1 : 0;
        view.dispatch({
            effects: $c812b694720e13a5$var$setSelectedEffect.of(selected)
        });
        return true;
    };
}
/**
Accept the current completion.
*/ const $c812b694720e13a5$export$537623a3380ccdae = (view)=>{
    let cState = view.state.field($c812b694720e13a5$var$completionState, false);
    if (view.state.readOnly || !cState || !cState.open || cState.open.selected < 0 || cState.open.disabled || Date.now() - cState.open.timestamp < view.state.facet($c812b694720e13a5$var$completionConfig).interactionDelay) return false;
    return $c812b694720e13a5$var$applyCompletion(view, cState.open.options[cState.open.selected]);
};
/**
Explicitly start autocompletion.
*/ const $c812b694720e13a5$export$8a36416d28f82fd5 = (view)=>{
    let cState = view.state.field($c812b694720e13a5$var$completionState, false);
    if (!cState) return false;
    view.dispatch({
        effects: $c812b694720e13a5$var$startCompletionEffect.of(true)
    });
    return true;
};
/**
Close the currently active completion.
*/ const $c812b694720e13a5$export$bdc62126738c63ab = (view)=>{
    let cState = view.state.field($c812b694720e13a5$var$completionState, false);
    if (!cState || !cState.active.some((a)=>a.state != 0 /* State.Inactive */ )) return false;
    view.dispatch({
        effects: $c812b694720e13a5$var$closeCompletionEffect.of(null)
    });
    return true;
};
class $c812b694720e13a5$var$RunningQuery {
    constructor(active, context){
        this.active = active;
        this.context = context;
        this.time = Date.now();
        this.updates = [];
        // Note that 'undefined' means 'not done yet', whereas 'null' means
        // 'query returned null'.
        this.done = undefined;
    }
}
const $c812b694720e13a5$var$MaxUpdateCount = 50, $c812b694720e13a5$var$MinAbortTime = 1000;
const $c812b694720e13a5$var$completionPlugin = /*@__PURE__*/ (0, $3e6dc.ViewPlugin).fromClass(class {
    update(update) {
        let cState = update.state.field($c812b694720e13a5$var$completionState);
        let conf = update.state.facet($c812b694720e13a5$var$completionConfig);
        if (!update.selectionSet && !update.docChanged && update.startState.field($c812b694720e13a5$var$completionState) == cState) return;
        let doesReset = update.transactions.some((tr)=>{
            let type = $c812b694720e13a5$var$getUpdateType(tr, conf);
            return type & 8 /* UpdateType.Reset */  || (tr.selection || tr.docChanged) && !(type & 3 /* UpdateType.SimpleInteraction */ );
        });
        for(let i = 0; i < this.running.length; i++){
            let query = this.running[i];
            if (doesReset || query.context.abortOnDocChange && update.docChanged || query.updates.length + update.transactions.length > $c812b694720e13a5$var$MaxUpdateCount && Date.now() - query.time > $c812b694720e13a5$var$MinAbortTime) {
                for (let handler of query.context.abortListeners)try {
                    handler();
                } catch (e) {
                    (0, $3e6dc.logException)(this.view.state, e);
                }
                query.context.abortListeners = null;
                this.running.splice(i--, 1);
            } else query.updates.push(...update.transactions);
        }
        if (this.debounceUpdate > -1) clearTimeout(this.debounceUpdate);
        if (update.transactions.some((tr)=>tr.effects.some((e)=>e.is($c812b694720e13a5$var$startCompletionEffect)))) this.pendingStart = true;
        let delay = this.pendingStart ? 50 : conf.activateOnTypingDelay;
        this.debounceUpdate = cState.active.some((a)=>a.isPending && !this.running.some((q)=>q.active.source == a.source)) ? setTimeout(()=>this.startUpdate(), delay) : -1;
        if (this.composing != 0 /* CompositionState.None */ ) for (let tr of update.transactions){
            if (tr.isUserEvent("input.type")) this.composing = 2 /* CompositionState.Changed */ ;
            else if (this.composing == 2 /* CompositionState.Changed */  && tr.selection) this.composing = 3 /* CompositionState.ChangedAndMoved */ ;
        }
    }
    startUpdate() {
        this.debounceUpdate = -1;
        this.pendingStart = false;
        let { state: state } = this.view, cState = state.field($c812b694720e13a5$var$completionState);
        for (let active of cState.active)if (active.isPending && !this.running.some((r)=>r.active.source == active.source)) this.startQuery(active);
        if (this.running.length && cState.open && cState.open.disabled) this.debounceAccept = setTimeout(()=>this.accept(), this.view.state.facet($c812b694720e13a5$var$completionConfig).updateSyncTime);
    }
    startQuery(active) {
        let { state: state } = this.view, pos = $c812b694720e13a5$var$cur(state);
        let context = new $c812b694720e13a5$export$7b73e80391102dce(state, pos, active.explicit, this.view);
        let pending = new $c812b694720e13a5$var$RunningQuery(active, context);
        this.running.push(pending);
        Promise.resolve(active.source(context)).then((result)=>{
            if (!pending.context.aborted) {
                pending.done = result || null;
                this.scheduleAccept();
            }
        }, (err)=>{
            this.view.dispatch({
                effects: $c812b694720e13a5$var$closeCompletionEffect.of(null)
            });
            (0, $3e6dc.logException)(this.view.state, err);
        });
    }
    scheduleAccept() {
        if (this.running.every((q)=>q.done !== undefined)) this.accept();
        else if (this.debounceAccept < 0) this.debounceAccept = setTimeout(()=>this.accept(), this.view.state.facet($c812b694720e13a5$var$completionConfig).updateSyncTime);
    }
    // For each finished query in this.running, try to create a result
    // or, if appropriate, restart the query.
    accept() {
        var _a;
        if (this.debounceAccept > -1) clearTimeout(this.debounceAccept);
        this.debounceAccept = -1;
        let updated = [];
        let conf = this.view.state.facet($c812b694720e13a5$var$completionConfig), cState = this.view.state.field($c812b694720e13a5$var$completionState);
        for(let i = 0; i < this.running.length; i++){
            let query = this.running[i];
            if (query.done === undefined) continue;
            this.running.splice(i--, 1);
            if (query.done) {
                let pos = $c812b694720e13a5$var$cur(query.updates.length ? query.updates[0].startState : this.view.state);
                let limit = Math.min(pos, query.done.from + (query.active.explicit ? 0 : 1));
                let active = new $c812b694720e13a5$var$ActiveResult(query.active.source, query.active.explicit, limit, query.done, query.done.from, (_a = query.done.to) !== null && _a !== void 0 ? _a : pos);
                // Replay the transactions that happened since the start of
                // the request and see if that preserves the result
                for (let tr of query.updates)active = active.update(tr, conf);
                if (active.hasResult()) {
                    updated.push(active);
                    continue;
                }
            }
            let current = cState.active.find((a)=>a.source == query.active.source);
            if (current && current.isPending) {
                if (query.done == null) {
                    // Explicitly failed. Should clear the pending status if it
                    // hasn't been re-set in the meantime.
                    let active = new $c812b694720e13a5$var$ActiveSource(query.active.source, 0 /* State.Inactive */ );
                    for (let tr of query.updates)active = active.update(tr, conf);
                    if (!active.isPending) updated.push(active);
                } else // Cleared by subsequent transactions. Restart.
                this.startQuery(current);
            }
        }
        if (updated.length || cState.open && cState.open.disabled) this.view.dispatch({
            effects: $c812b694720e13a5$var$setActiveEffect.of(updated)
        });
    }
    constructor(view){
        this.view = view;
        this.debounceUpdate = -1;
        this.running = [];
        this.debounceAccept = -1;
        this.pendingStart = false;
        this.composing = 0 /* CompositionState.None */ ;
        for (let active of view.state.field($c812b694720e13a5$var$completionState).active)if (active.isPending) this.startQuery(active);
    }
}, {
    eventHandlers: {
        blur (event) {
            let state = this.view.state.field($c812b694720e13a5$var$completionState, false);
            if (state && state.tooltip && this.view.state.facet($c812b694720e13a5$var$completionConfig).closeOnBlur) {
                let dialog = state.open && (0, $3e6dc.getTooltip)(this.view, state.open.tooltip);
                if (!dialog || !dialog.dom.contains(event.relatedTarget)) setTimeout(()=>this.view.dispatch({
                        effects: $c812b694720e13a5$var$closeCompletionEffect.of(null)
                    }), 10);
            }
        },
        compositionstart () {
            this.composing = 1 /* CompositionState.Started */ ;
        },
        compositionend () {
            if (this.composing == 3 /* CompositionState.ChangedAndMoved */ ) // Safari fires compositionend events synchronously, possibly
            // from inside an update, so dispatch asynchronously to avoid reentrancy
            setTimeout(()=>this.view.dispatch({
                    effects: $c812b694720e13a5$var$startCompletionEffect.of(false)
                }), 20);
            this.composing = 0 /* CompositionState.None */ ;
        }
    }
});
const $c812b694720e13a5$var$windows = typeof navigator == "object" && /*@__PURE__*/ /Win/.test(navigator.platform);
const $c812b694720e13a5$var$commitCharacters = /*@__PURE__*/ (0, $b2ZzE.Prec).highest(/*@__PURE__*/ (0, $3e6dc.EditorView).domEventHandlers({
    keydown (event, view) {
        let field = view.state.field($c812b694720e13a5$var$completionState, false);
        if (!field || !field.open || field.open.disabled || field.open.selected < 0 || event.key.length > 1 || event.ctrlKey && !($c812b694720e13a5$var$windows && event.altKey) || event.metaKey) return false;
        let option = field.open.options[field.open.selected];
        let result = field.active.find((a)=>a.source == option.source);
        let commitChars = option.completion.commitCharacters || result.result.commitCharacters;
        if (commitChars && commitChars.indexOf(event.key) > -1) $c812b694720e13a5$var$applyCompletion(view, option);
        return false;
    }
}));
const $c812b694720e13a5$var$baseTheme = /*@__PURE__*/ (0, $3e6dc.EditorView).baseTheme({
    ".cm-tooltip.cm-tooltip-autocomplete": {
        "& > ul": {
            fontFamily: "monospace",
            whiteSpace: "nowrap",
            overflow: "hidden auto",
            maxWidth_fallback: "700px",
            maxWidth: "min(700px, 95vw)",
            minWidth: "250px",
            maxHeight: "10em",
            height: "100%",
            listStyle: "none",
            margin: 0,
            padding: 0,
            "& > li, & > completion-section": {
                padding: "1px 3px",
                lineHeight: 1.2
            },
            "& > li": {
                overflowX: "hidden",
                textOverflow: "ellipsis",
                cursor: "pointer"
            },
            "& > completion-section": {
                display: "list-item",
                borderBottom: "1px solid silver",
                paddingLeft: "0.5em",
                opacity: 0.7
            }
        }
    },
    "&light .cm-tooltip-autocomplete ul li[aria-selected]": {
        background: "#17c",
        color: "white"
    },
    "&light .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
        background: "#777"
    },
    "&dark .cm-tooltip-autocomplete ul li[aria-selected]": {
        background: "#347",
        color: "white"
    },
    "&dark .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
        background: "#444"
    },
    ".cm-completionListIncompleteTop:before, .cm-completionListIncompleteBottom:after": {
        content: '"\xb7\xb7\xb7"',
        opacity: 0.5,
        display: "block",
        textAlign: "center"
    },
    ".cm-tooltip.cm-completionInfo": {
        position: "absolute",
        padding: "3px 9px",
        width: "max-content",
        maxWidth: `${400 /* Info.Width */ }px`,
        boxSizing: "border-box",
        whiteSpace: "pre-line"
    },
    ".cm-completionInfo.cm-completionInfo-left": {
        right: "100%"
    },
    ".cm-completionInfo.cm-completionInfo-right": {
        left: "100%"
    },
    ".cm-completionInfo.cm-completionInfo-left-narrow": {
        right: `${30 /* Info.Margin */ }px`
    },
    ".cm-completionInfo.cm-completionInfo-right-narrow": {
        left: `${30 /* Info.Margin */ }px`
    },
    "&light .cm-snippetField": {
        backgroundColor: "#00000022"
    },
    "&dark .cm-snippetField": {
        backgroundColor: "#ffffff22"
    },
    ".cm-snippetFieldPosition": {
        verticalAlign: "text-top",
        width: 0,
        height: "1.15em",
        display: "inline-block",
        margin: "0 -0.7px -.7em",
        borderLeft: "1.4px dotted #888"
    },
    ".cm-completionMatchedText": {
        textDecoration: "underline"
    },
    ".cm-completionDetail": {
        marginLeft: "0.5em",
        fontStyle: "italic"
    },
    ".cm-completionIcon": {
        fontSize: "90%",
        width: ".8em",
        display: "inline-block",
        textAlign: "center",
        paddingRight: ".6em",
        opacity: "0.6",
        boxSizing: "content-box"
    },
    ".cm-completionIcon-function, .cm-completionIcon-method": {
        "&:after": {
            content: "'\u0192'"
        }
    },
    ".cm-completionIcon-class": {
        "&:after": {
            content: "'\u25CB'"
        }
    },
    ".cm-completionIcon-interface": {
        "&:after": {
            content: "'\u25CC'"
        }
    },
    ".cm-completionIcon-variable": {
        "&:after": {
            content: "'\uD835\uDC65'"
        }
    },
    ".cm-completionIcon-constant": {
        "&:after": {
            content: "'\uD835\uDC36'"
        }
    },
    ".cm-completionIcon-type": {
        "&:after": {
            content: "'\uD835\uDC61'"
        }
    },
    ".cm-completionIcon-enum": {
        "&:after": {
            content: "'\u222A'"
        }
    },
    ".cm-completionIcon-property": {
        "&:after": {
            content: "'\u25A1'"
        }
    },
    ".cm-completionIcon-keyword": {
        "&:after": {
            content: "'\uD83D\uDD11\uFE0E'"
        } // Disable emoji rendering
    },
    ".cm-completionIcon-namespace": {
        "&:after": {
            content: "'\u25A2'"
        }
    },
    ".cm-completionIcon-text": {
        "&:after": {
            content: "'abc'",
            fontSize: "50%",
            verticalAlign: "middle"
        }
    }
});
class $c812b694720e13a5$var$FieldPos {
    constructor(field, line, from, to){
        this.field = field;
        this.line = line;
        this.from = from;
        this.to = to;
    }
}
class $c812b694720e13a5$var$FieldRange {
    map(changes) {
        let from = changes.mapPos(this.from, -1, (0, $b2ZzE.MapMode).TrackDel);
        let to = changes.mapPos(this.to, 1, (0, $b2ZzE.MapMode).TrackDel);
        return from == null || to == null ? null : new $c812b694720e13a5$var$FieldRange(this.field, from, to);
    }
    constructor(field, from, to){
        this.field = field;
        this.from = from;
        this.to = to;
    }
}
class $c812b694720e13a5$var$Snippet {
    instantiate(state, pos) {
        let text = [], lineStart = [
            pos
        ];
        let lineObj = state.doc.lineAt(pos), baseIndent = /^\s*/.exec(lineObj.text)[0];
        for (let line of this.lines){
            if (text.length) {
                let indent = baseIndent, tabs = /^\t*/.exec(line)[0].length;
                for(let i = 0; i < tabs; i++)indent += state.facet((0, $4lK5a.indentUnit));
                lineStart.push(pos + indent.length - tabs);
                line = indent + line.slice(tabs);
            }
            text.push(line);
            pos += line.length + 1;
        }
        let ranges = this.fieldPositions.map((pos)=>new $c812b694720e13a5$var$FieldRange(pos.field, lineStart[pos.line] + pos.from, lineStart[pos.line] + pos.to));
        return {
            text: text,
            ranges: ranges
        };
    }
    static parse(template) {
        let fields = [];
        let lines = [], positions = [], m;
        for (let line of template.split(/\r\n?|\n/)){
            while(m = /[#$]\{(?:(\d+)(?::([^}]*))?|((?:\\[{}]|[^}])*))\}/.exec(line)){
                let seq = m[1] ? +m[1] : null, rawName = m[2] || m[3] || "", found = -1;
                let name = rawName.replace(/\\[{}]/g, (m)=>m[1]);
                for(let i = 0; i < fields.length; i++)if (seq != null ? fields[i].seq == seq : name ? fields[i].name == name : false) found = i;
                if (found < 0) {
                    let i = 0;
                    while(i < fields.length && (seq == null || fields[i].seq != null && fields[i].seq < seq))i++;
                    fields.splice(i, 0, {
                        seq: seq,
                        name: name
                    });
                    found = i;
                    for (let pos of positions)if (pos.field >= found) pos.field++;
                }
                positions.push(new $c812b694720e13a5$var$FieldPos(found, lines.length, m.index, m.index + name.length));
                line = line.slice(0, m.index) + rawName + line.slice(m.index + m[0].length);
            }
            line = line.replace(/\\([{}])/g, (_, brace, index)=>{
                for (let pos of positions)if (pos.line == lines.length && pos.from > index) {
                    pos.from--;
                    pos.to--;
                }
                return brace;
            });
            lines.push(line);
        }
        return new $c812b694720e13a5$var$Snippet(lines, positions);
    }
    constructor(lines, fieldPositions){
        this.lines = lines;
        this.fieldPositions = fieldPositions;
    }
}
let $c812b694720e13a5$var$fieldMarker = /*@__PURE__*/ (0, $3e6dc.Decoration).widget({
    widget: /*@__PURE__*/ new class extends (0, $3e6dc.WidgetType) {
        toDOM() {
            let span = document.createElement("span");
            span.className = "cm-snippetFieldPosition";
            return span;
        }
        ignoreEvent() {
            return false;
        }
    }
});
let $c812b694720e13a5$var$fieldRange = /*@__PURE__*/ (0, $3e6dc.Decoration).mark({
    class: "cm-snippetField"
});
class $c812b694720e13a5$var$ActiveSnippet {
    map(changes) {
        let ranges = [];
        for (let r of this.ranges){
            let mapped = r.map(changes);
            if (!mapped) return null;
            ranges.push(mapped);
        }
        return new $c812b694720e13a5$var$ActiveSnippet(ranges, this.active);
    }
    selectionInsideField(sel) {
        return sel.ranges.every((range)=>this.ranges.some((r)=>r.field == this.active && r.from <= range.from && r.to >= range.to));
    }
    constructor(ranges, active){
        this.ranges = ranges;
        this.active = active;
        this.deco = (0, $3e6dc.Decoration).set(ranges.map((r)=>(r.from == r.to ? $c812b694720e13a5$var$fieldMarker : $c812b694720e13a5$var$fieldRange).range(r.from, r.to)));
    }
}
const $c812b694720e13a5$var$setActive = /*@__PURE__*/ (0, $b2ZzE.StateEffect).define({
    map (value, changes) {
        return value && value.map(changes);
    }
});
const $c812b694720e13a5$var$moveToField = /*@__PURE__*/ (0, $b2ZzE.StateEffect).define();
const $c812b694720e13a5$var$snippetState = /*@__PURE__*/ (0, $b2ZzE.StateField).define({
    create () {
        return null;
    },
    update (value, tr) {
        for (let effect of tr.effects){
            if (effect.is($c812b694720e13a5$var$setActive)) return effect.value;
            if (effect.is($c812b694720e13a5$var$moveToField) && value) return new $c812b694720e13a5$var$ActiveSnippet(value.ranges, effect.value);
        }
        if (value && tr.docChanged) value = value.map(tr.changes);
        if (value && tr.selection && !value.selectionInsideField(tr.selection)) value = null;
        return value;
    },
    provide: (f)=>(0, $3e6dc.EditorView).decorations.from(f, (val)=>val ? val.deco : (0, $3e6dc.Decoration).none)
});
function $c812b694720e13a5$var$fieldSelection(ranges, field) {
    return (0, $b2ZzE.EditorSelection).create(ranges.filter((r)=>r.field == field).map((r)=>(0, $b2ZzE.EditorSelection).range(r.from, r.to)));
}
/**
Convert a snippet template to a function that can
[apply](https://codemirror.net/6/docs/ref/#autocomplete.Completion.apply) it. Snippets are written
using syntax like this:

    "for (let ${index} = 0; ${index} < ${end}; ${index}++) {\n\t${}\n}"

Each `${}` placeholder (you may also use `#{}`) indicates a field
that the user can fill in. Its name, if any, will be the default
content for the field.

When the snippet is activated by calling the returned function,
the code is inserted at the given position. Newlines in the
template are indented by the indentation of the start line, plus
one [indent unit](https://codemirror.net/6/docs/ref/#language.indentUnit) per tab character after
the newline.

On activation, (all instances of) the first field are selected.
The user can move between fields with Tab and Shift-Tab as long as
the fields are active. Moving to the last field or moving the
cursor out of the current field deactivates the fields.

The order of fields defaults to textual order, but you can add
numbers to placeholders (`${1}` or `${1:defaultText}`) to provide
a custom order.

To include a literal `{` or `}` in your template, put a backslash
in front of it. This will be removed and the brace will not be
interpreted as indicating a placeholder.
*/ function $c812b694720e13a5$export$f77f1ac5bf251232(template) {
    let snippet = $c812b694720e13a5$var$Snippet.parse(template);
    return (editor, completion, from, to)=>{
        let { text: text, ranges: ranges } = snippet.instantiate(editor.state, from);
        let { main: main } = editor.state.selection;
        let spec = {
            changes: {
                from: from,
                to: to == main.from ? main.to : to,
                insert: (0, $b2ZzE.Text).of(text)
            },
            scrollIntoView: true,
            annotations: completion ? [
                $c812b694720e13a5$export$6c84d44c1ceeb831.of(completion),
                (0, $b2ZzE.Transaction).userEvent.of("input.complete")
            ] : undefined
        };
        if (ranges.length) spec.selection = $c812b694720e13a5$var$fieldSelection(ranges, 0);
        if (ranges.some((r)=>r.field > 0)) {
            let active = new $c812b694720e13a5$var$ActiveSnippet(ranges, 0);
            let effects = spec.effects = [
                $c812b694720e13a5$var$setActive.of(active)
            ];
            if (editor.state.field($c812b694720e13a5$var$snippetState, false) === undefined) effects.push((0, $b2ZzE.StateEffect).appendConfig.of([
                $c812b694720e13a5$var$snippetState,
                $c812b694720e13a5$var$addSnippetKeymap,
                $c812b694720e13a5$var$snippetPointerHandler,
                $c812b694720e13a5$var$baseTheme
            ]));
        }
        editor.dispatch(editor.state.update(spec));
    };
}
function $c812b694720e13a5$var$moveField(dir) {
    return ({ state: state, dispatch: dispatch })=>{
        let active = state.field($c812b694720e13a5$var$snippetState, false);
        if (!active || dir < 0 && active.active == 0) return false;
        let next = active.active + dir, last = dir > 0 && !active.ranges.some((r)=>r.field == next + dir);
        dispatch(state.update({
            selection: $c812b694720e13a5$var$fieldSelection(active.ranges, next),
            effects: $c812b694720e13a5$var$setActive.of(last ? null : new $c812b694720e13a5$var$ActiveSnippet(active.ranges, next)),
            scrollIntoView: true
        }));
        return true;
    };
}
/**
A command that clears the active snippet, if any.
*/ const $c812b694720e13a5$export$4d00dce2599b1df3 = ({ state: state, dispatch: dispatch })=>{
    let active = state.field($c812b694720e13a5$var$snippetState, false);
    if (!active) return false;
    dispatch(state.update({
        effects: $c812b694720e13a5$var$setActive.of(null)
    }));
    return true;
};
/**
Move to the next snippet field, if available.
*/ const $c812b694720e13a5$export$d8da8fdad886df2f = /*@__PURE__*/ $c812b694720e13a5$var$moveField(1);
/**
Move to the previous snippet field, if available.
*/ const $c812b694720e13a5$export$8d02b23b64ec425c = /*@__PURE__*/ $c812b694720e13a5$var$moveField(-1);
/**
Check if there is an active snippet with a next field for
`nextSnippetField` to move to.
*/ function $c812b694720e13a5$export$9c250e449e4af222(state) {
    let active = state.field($c812b694720e13a5$var$snippetState, false);
    return !!(active && active.ranges.some((r)=>r.field == active.active + 1));
}
/**
Returns true if there is an active snippet and a previous field
for `prevSnippetField` to move to.
*/ function $c812b694720e13a5$export$ace2e22fa9996777(state) {
    let active = state.field($c812b694720e13a5$var$snippetState, false);
    return !!(active && active.active > 0);
}
const $c812b694720e13a5$var$defaultSnippetKeymap = [
    {
        key: "Tab",
        run: $c812b694720e13a5$export$d8da8fdad886df2f,
        shift: $c812b694720e13a5$export$8d02b23b64ec425c
    },
    {
        key: "Escape",
        run: $c812b694720e13a5$export$4d00dce2599b1df3
    }
];
/**
A facet that can be used to configure the key bindings used by
snippets. The default binds Tab to
[`nextSnippetField`](https://codemirror.net/6/docs/ref/#autocomplete.nextSnippetField), Shift-Tab to
[`prevSnippetField`](https://codemirror.net/6/docs/ref/#autocomplete.prevSnippetField), and Escape
to [`clearSnippet`](https://codemirror.net/6/docs/ref/#autocomplete.clearSnippet).
*/ const $c812b694720e13a5$export$1808c2f24fc99b36 = /*@__PURE__*/ (0, $b2ZzE.Facet).define({
    combine (maps) {
        return maps.length ? maps[0] : $c812b694720e13a5$var$defaultSnippetKeymap;
    }
});
const $c812b694720e13a5$var$addSnippetKeymap = /*@__PURE__*/ (0, $b2ZzE.Prec).highest(/*@__PURE__*/ (0, $3e6dc.keymap).compute([
    $c812b694720e13a5$export$1808c2f24fc99b36
], (state)=>state.facet($c812b694720e13a5$export$1808c2f24fc99b36)));
/**
Create a completion from a snippet. Returns an object with the
properties from `completion`, plus an `apply` function that
applies the snippet.
*/ function $c812b694720e13a5$export$975ef56e648d23ad(template, completion) {
    return Object.assign(Object.assign({}, completion), {
        apply: $c812b694720e13a5$export$f77f1ac5bf251232(template)
    });
}
const $c812b694720e13a5$var$snippetPointerHandler = /*@__PURE__*/ (0, $3e6dc.EditorView).domEventHandlers({
    mousedown (event, view) {
        let active = view.state.field($c812b694720e13a5$var$snippetState, false), pos;
        if (!active || (pos = view.posAtCoords({
            x: event.clientX,
            y: event.clientY
        })) == null) return false;
        let match = active.ranges.find((r)=>r.from <= pos && r.to >= pos);
        if (!match || match.field == active.active) return false;
        view.dispatch({
            selection: $c812b694720e13a5$var$fieldSelection(active.ranges, match.field),
            effects: $c812b694720e13a5$var$setActive.of(active.ranges.some((r)=>r.field > match.field) ? new $c812b694720e13a5$var$ActiveSnippet(active.ranges, match.field) : null),
            scrollIntoView: true
        });
        return true;
    }
});
function $c812b694720e13a5$var$wordRE(wordChars) {
    let escaped = wordChars.replace(/[\]\-\\]/g, "\\$&");
    try {
        return new RegExp(`[\\p{Alphabetic}\\p{Number}_${escaped}]+`, "ug");
    } catch (_a) {
        return new RegExp(`[\w${escaped}]`, "g");
    }
}
function $c812b694720e13a5$var$mapRE(re, f) {
    return new RegExp(f(re.source), re.unicode ? "u" : "");
}
const $c812b694720e13a5$var$wordCaches = /*@__PURE__*/ Object.create(null);
function $c812b694720e13a5$var$wordCache(wordChars) {
    return $c812b694720e13a5$var$wordCaches[wordChars] || ($c812b694720e13a5$var$wordCaches[wordChars] = new WeakMap);
}
function $c812b694720e13a5$var$storeWords(doc, wordRE, result, seen, ignoreAt) {
    for(let lines = doc.iterLines(), pos = 0; !lines.next().done;){
        let { value: value } = lines, m;
        wordRE.lastIndex = 0;
        while(m = wordRE.exec(value))if (!seen[m[0]] && pos + m.index != ignoreAt) {
            result.push({
                type: "text",
                label: m[0]
            });
            seen[m[0]] = true;
            if (result.length >= 2000 /* C.MaxList */ ) return;
        }
        pos += value.length + 1;
    }
}
function $c812b694720e13a5$var$collectWords(doc, cache, wordRE, to, ignoreAt) {
    let big = doc.length >= 1000 /* C.MinCacheLen */ ;
    let cached = big && cache.get(doc);
    if (cached) return cached;
    let result = [], seen = Object.create(null);
    if (doc.children) {
        let pos = 0;
        for (let ch of doc.children){
            if (ch.length >= 1000 /* C.MinCacheLen */ ) {
                for (let c of $c812b694720e13a5$var$collectWords(ch, cache, wordRE, to - pos, ignoreAt - pos))if (!seen[c.label]) {
                    seen[c.label] = true;
                    result.push(c);
                }
            } else $c812b694720e13a5$var$storeWords(ch, wordRE, result, seen, ignoreAt - pos);
            pos += ch.length + 1;
        }
    } else $c812b694720e13a5$var$storeWords(doc, wordRE, result, seen, ignoreAt);
    if (big && result.length < 2000 /* C.MaxList */ ) cache.set(doc, result);
    return result;
}
/**
A completion source that will scan the document for words (using a
[character categorizer](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer)), and
return those as completions.
*/ const $c812b694720e13a5$export$a018df98be431a1 = (context)=>{
    let wordChars = context.state.languageDataAt("wordChars", context.pos).join("");
    let re = $c812b694720e13a5$var$wordRE(wordChars);
    let token = context.matchBefore($c812b694720e13a5$var$mapRE(re, (s)=>s + "$"));
    if (!token && !context.explicit) return null;
    let from = token ? token.from : context.pos;
    let options = $c812b694720e13a5$var$collectWords(context.state.doc, $c812b694720e13a5$var$wordCache(wordChars), re, 50000 /* C.Range */ , from);
    return {
        from: from,
        options: options,
        validFor: $c812b694720e13a5$var$mapRE(re, (s)=>"^" + s)
    };
};
const $c812b694720e13a5$var$defaults = {
    brackets: [
        "(",
        "[",
        "{",
        "'",
        '"'
    ],
    before: ")]}:;>",
    stringPrefixes: []
};
const $c812b694720e13a5$var$closeBracketEffect = /*@__PURE__*/ (0, $b2ZzE.StateEffect).define({
    map (value, mapping) {
        let mapped = mapping.mapPos(value, -1, (0, $b2ZzE.MapMode).TrackAfter);
        return mapped == null ? undefined : mapped;
    }
});
const $c812b694720e13a5$var$closedBracket = /*@__PURE__*/ new class extends (0, $b2ZzE.RangeValue) {
};
$c812b694720e13a5$var$closedBracket.startSide = 1;
$c812b694720e13a5$var$closedBracket.endSide = -1;
const $c812b694720e13a5$var$bracketState = /*@__PURE__*/ (0, $b2ZzE.StateField).define({
    create () {
        return (0, $b2ZzE.RangeSet).empty;
    },
    update (value, tr) {
        value = value.map(tr.changes);
        if (tr.selection) {
            let line = tr.state.doc.lineAt(tr.selection.main.head);
            value = value.update({
                filter: (from)=>from >= line.from && from <= line.to
            });
        }
        for (let effect of tr.effects)if (effect.is($c812b694720e13a5$var$closeBracketEffect)) value = value.update({
            add: [
                $c812b694720e13a5$var$closedBracket.range(effect.value, effect.value + 1)
            ]
        });
        return value;
    }
});
/**
Extension to enable bracket-closing behavior. When a closeable
bracket is typed, its closing bracket is immediately inserted
after the cursor. When closing a bracket directly in front of a
closing bracket inserted by the extension, the cursor moves over
that bracket.
*/ function $c812b694720e13a5$export$69e4e9d3300ff824() {
    return [
        $c812b694720e13a5$var$inputHandler,
        $c812b694720e13a5$var$bracketState
    ];
}
const $c812b694720e13a5$var$definedClosing = "()[]{}<>";
function $c812b694720e13a5$var$closing(ch) {
    for(let i = 0; i < $c812b694720e13a5$var$definedClosing.length; i += 2)if ($c812b694720e13a5$var$definedClosing.charCodeAt(i) == ch) return $c812b694720e13a5$var$definedClosing.charAt(i + 1);
    return (0, $b2ZzE.fromCodePoint)(ch < 128 ? ch : ch + 1);
}
function $c812b694720e13a5$var$config(state, pos) {
    return state.languageDataAt("closeBrackets", pos)[0] || $c812b694720e13a5$var$defaults;
}
const $c812b694720e13a5$var$android = typeof navigator == "object" && /*@__PURE__*/ /Android\b/.test(navigator.userAgent);
const $c812b694720e13a5$var$inputHandler = /*@__PURE__*/ (0, $3e6dc.EditorView).inputHandler.of((view, from, to, insert)=>{
    if (($c812b694720e13a5$var$android ? view.composing : view.compositionStarted) || view.state.readOnly) return false;
    let sel = view.state.selection.main;
    if (insert.length > 2 || insert.length == 2 && (0, $b2ZzE.codePointSize)((0, $b2ZzE.codePointAt)(insert, 0)) == 1 || from != sel.from || to != sel.to) return false;
    let tr = $c812b694720e13a5$export$7ce1ae5219095222(view.state, insert);
    if (!tr) return false;
    view.dispatch(tr);
    return true;
});
/**
Command that implements deleting a pair of matching brackets when
the cursor is between them.
*/ const $c812b694720e13a5$export$5339d701ea89967c = ({ state: state, dispatch: dispatch })=>{
    if (state.readOnly) return false;
    let conf = $c812b694720e13a5$var$config(state, state.selection.main.head);
    let tokens = conf.brackets || $c812b694720e13a5$var$defaults.brackets;
    let dont = null, changes = state.changeByRange((range)=>{
        if (range.empty) {
            let before = $c812b694720e13a5$var$prevChar(state.doc, range.head);
            for (let token of tokens){
                if (token == before && $c812b694720e13a5$var$nextChar(state.doc, range.head) == $c812b694720e13a5$var$closing((0, $b2ZzE.codePointAt)(token, 0))) return {
                    changes: {
                        from: range.head - token.length,
                        to: range.head + token.length
                    },
                    range: (0, $b2ZzE.EditorSelection).cursor(range.head - token.length)
                };
            }
        }
        return {
            range: dont = range
        };
    });
    if (!dont) dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: "delete.backward"
    }));
    return !dont;
};
/**
Close-brackets related key bindings. Binds Backspace to
[`deleteBracketPair`](https://codemirror.net/6/docs/ref/#autocomplete.deleteBracketPair).
*/ const $c812b694720e13a5$export$9477e95792b48f4a = [
    {
        key: "Backspace",
        run: $c812b694720e13a5$export$5339d701ea89967c
    }
];
/**
Implements the extension's behavior on text insertion. If the
given string counts as a bracket in the language around the
selection, and replacing the selection with it requires custom
behavior (inserting a closing version or skipping past a
previously-closed bracket), this function returns a transaction
representing that custom behavior. (You only need this if you want
to programmatically insert brackets—the
[`closeBrackets`](https://codemirror.net/6/docs/ref/#autocomplete.closeBrackets) extension will
take care of running this for user input.)
*/ function $c812b694720e13a5$export$7ce1ae5219095222(state, bracket) {
    let conf = $c812b694720e13a5$var$config(state, state.selection.main.head);
    let tokens = conf.brackets || $c812b694720e13a5$var$defaults.brackets;
    for (let tok of tokens){
        let closed = $c812b694720e13a5$var$closing((0, $b2ZzE.codePointAt)(tok, 0));
        if (bracket == tok) return closed == tok ? $c812b694720e13a5$var$handleSame(state, tok, tokens.indexOf(tok + tok + tok) > -1, conf) : $c812b694720e13a5$var$handleOpen(state, tok, closed, conf.before || $c812b694720e13a5$var$defaults.before);
        if (bracket == closed && $c812b694720e13a5$var$closedBracketAt(state, state.selection.main.from)) return $c812b694720e13a5$var$handleClose(state, tok, closed);
    }
    return null;
}
function $c812b694720e13a5$var$closedBracketAt(state, pos) {
    let found = false;
    state.field($c812b694720e13a5$var$bracketState).between(0, state.doc.length, (from)=>{
        if (from == pos) found = true;
    });
    return found;
}
function $c812b694720e13a5$var$nextChar(doc, pos) {
    let next = doc.sliceString(pos, pos + 2);
    return next.slice(0, (0, $b2ZzE.codePointSize)((0, $b2ZzE.codePointAt)(next, 0)));
}
function $c812b694720e13a5$var$prevChar(doc, pos) {
    let prev = doc.sliceString(pos - 2, pos);
    return (0, $b2ZzE.codePointSize)((0, $b2ZzE.codePointAt)(prev, 0)) == prev.length ? prev : prev.slice(1);
}
function $c812b694720e13a5$var$handleOpen(state, open, close, closeBefore) {
    let dont = null, changes = state.changeByRange((range)=>{
        if (!range.empty) return {
            changes: [
                {
                    insert: open,
                    from: range.from
                },
                {
                    insert: close,
                    from: range.to
                }
            ],
            effects: $c812b694720e13a5$var$closeBracketEffect.of(range.to + open.length),
            range: (0, $b2ZzE.EditorSelection).range(range.anchor + open.length, range.head + open.length)
        };
        let next = $c812b694720e13a5$var$nextChar(state.doc, range.head);
        if (!next || /\s/.test(next) || closeBefore.indexOf(next) > -1) return {
            changes: {
                insert: open + close,
                from: range.head
            },
            effects: $c812b694720e13a5$var$closeBracketEffect.of(range.head + open.length),
            range: (0, $b2ZzE.EditorSelection).cursor(range.head + open.length)
        };
        return {
            range: dont = range
        };
    });
    return dont ? null : state.update(changes, {
        scrollIntoView: true,
        userEvent: "input.type"
    });
}
function $c812b694720e13a5$var$handleClose(state, _open, close) {
    let dont = null, changes = state.changeByRange((range)=>{
        if (range.empty && $c812b694720e13a5$var$nextChar(state.doc, range.head) == close) return {
            changes: {
                from: range.head,
                to: range.head + close.length,
                insert: close
            },
            range: (0, $b2ZzE.EditorSelection).cursor(range.head + close.length)
        };
        return dont = {
            range: range
        };
    });
    return dont ? null : state.update(changes, {
        scrollIntoView: true,
        userEvent: "input.type"
    });
}
// Handles cases where the open and close token are the same, and
// possibly triple quotes (as in `"""abc"""`-style quoting).
function $c812b694720e13a5$var$handleSame(state, token, allowTriple, config) {
    let stringPrefixes = config.stringPrefixes || $c812b694720e13a5$var$defaults.stringPrefixes;
    let dont = null, changes = state.changeByRange((range)=>{
        if (!range.empty) return {
            changes: [
                {
                    insert: token,
                    from: range.from
                },
                {
                    insert: token,
                    from: range.to
                }
            ],
            effects: $c812b694720e13a5$var$closeBracketEffect.of(range.to + token.length),
            range: (0, $b2ZzE.EditorSelection).range(range.anchor + token.length, range.head + token.length)
        };
        let pos = range.head, next = $c812b694720e13a5$var$nextChar(state.doc, pos), start;
        if (next == token) {
            if ($c812b694720e13a5$var$nodeStart(state, pos)) return {
                changes: {
                    insert: token + token,
                    from: pos
                },
                effects: $c812b694720e13a5$var$closeBracketEffect.of(pos + token.length),
                range: (0, $b2ZzE.EditorSelection).cursor(pos + token.length)
            };
            else if ($c812b694720e13a5$var$closedBracketAt(state, pos)) {
                let isTriple = allowTriple && state.sliceDoc(pos, pos + token.length * 3) == token + token + token;
                let content = isTriple ? token + token + token : token;
                return {
                    changes: {
                        from: pos,
                        to: pos + content.length,
                        insert: content
                    },
                    range: (0, $b2ZzE.EditorSelection).cursor(pos + content.length)
                };
            }
        } else if (allowTriple && state.sliceDoc(pos - 2 * token.length, pos) == token + token && (start = $c812b694720e13a5$var$canStartStringAt(state, pos - 2 * token.length, stringPrefixes)) > -1 && $c812b694720e13a5$var$nodeStart(state, start)) return {
            changes: {
                insert: token + token + token + token,
                from: pos
            },
            effects: $c812b694720e13a5$var$closeBracketEffect.of(pos + token.length),
            range: (0, $b2ZzE.EditorSelection).cursor(pos + token.length)
        };
        else if (state.charCategorizer(pos)(next) != (0, $b2ZzE.CharCategory).Word) {
            if ($c812b694720e13a5$var$canStartStringAt(state, pos, stringPrefixes) > -1 && !$c812b694720e13a5$var$probablyInString(state, pos, token, stringPrefixes)) return {
                changes: {
                    insert: token + token,
                    from: pos
                },
                effects: $c812b694720e13a5$var$closeBracketEffect.of(pos + token.length),
                range: (0, $b2ZzE.EditorSelection).cursor(pos + token.length)
            };
        }
        return {
            range: dont = range
        };
    });
    return dont ? null : state.update(changes, {
        scrollIntoView: true,
        userEvent: "input.type"
    });
}
function $c812b694720e13a5$var$nodeStart(state, pos) {
    let tree = (0, $4lK5a.syntaxTree)(state).resolveInner(pos + 1);
    return tree.parent && tree.from == pos;
}
function $c812b694720e13a5$var$probablyInString(state, pos, quoteToken, prefixes) {
    let node = (0, $4lK5a.syntaxTree)(state).resolveInner(pos, -1);
    let maxPrefix = prefixes.reduce((m, p)=>Math.max(m, p.length), 0);
    for(let i = 0; i < 5; i++){
        let start = state.sliceDoc(node.from, Math.min(node.to, node.from + quoteToken.length + maxPrefix));
        let quotePos = start.indexOf(quoteToken);
        if (!quotePos || quotePos > -1 && prefixes.indexOf(start.slice(0, quotePos)) > -1) {
            let first = node.firstChild;
            while(first && first.from == node.from && first.to - first.from > quoteToken.length + quotePos){
                if (state.sliceDoc(first.to - quoteToken.length, first.to) == quoteToken) return false;
                first = first.firstChild;
            }
            return true;
        }
        let parent = node.to == pos && node.parent;
        if (!parent) break;
        node = parent;
    }
    return false;
}
function $c812b694720e13a5$var$canStartStringAt(state, pos, prefixes) {
    let charCat = state.charCategorizer(pos);
    if (charCat(state.sliceDoc(pos - 1, pos)) != (0, $b2ZzE.CharCategory).Word) return pos;
    for (let prefix of prefixes){
        let start = pos - prefix.length;
        if (state.sliceDoc(start, pos) == prefix && charCat(state.sliceDoc(start - 1, start)) != (0, $b2ZzE.CharCategory).Word) return start;
    }
    return -1;
}
/**
Returns an extension that enables autocompletion.
*/ function $c812b694720e13a5$export$f95786d390465556(config = {}) {
    return [
        $c812b694720e13a5$var$commitCharacters,
        $c812b694720e13a5$var$completionState,
        $c812b694720e13a5$var$completionConfig.of(config),
        $c812b694720e13a5$var$completionPlugin,
        $c812b694720e13a5$var$completionKeymapExt,
        $c812b694720e13a5$var$baseTheme
    ];
}
/**
Basic keybindings for autocompletion.

 - Ctrl-Space (and Alt-\` on macOS): [`startCompletion`](https://codemirror.net/6/docs/ref/#autocomplete.startCompletion)
 - Escape: [`closeCompletion`](https://codemirror.net/6/docs/ref/#autocomplete.closeCompletion)
 - ArrowDown: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(true)`
 - ArrowUp: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(false)`
 - PageDown: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(true, "page")`
 - PageDown: [`moveCompletionSelection`](https://codemirror.net/6/docs/ref/#autocomplete.moveCompletionSelection)`(true, "page")`
 - Enter: [`acceptCompletion`](https://codemirror.net/6/docs/ref/#autocomplete.acceptCompletion)
*/ const $c812b694720e13a5$export$2a3d759d156afab4 = [
    {
        key: "Ctrl-Space",
        run: $c812b694720e13a5$export$8a36416d28f82fd5
    },
    {
        mac: "Alt-`",
        run: $c812b694720e13a5$export$8a36416d28f82fd5
    },
    {
        key: "Escape",
        run: $c812b694720e13a5$export$bdc62126738c63ab
    },
    {
        key: "ArrowDown",
        run: /*@__PURE__*/ $c812b694720e13a5$export$26f3a479ac65d653(true)
    },
    {
        key: "ArrowUp",
        run: /*@__PURE__*/ $c812b694720e13a5$export$26f3a479ac65d653(false)
    },
    {
        key: "PageDown",
        run: /*@__PURE__*/ $c812b694720e13a5$export$26f3a479ac65d653(true, "page")
    },
    {
        key: "PageUp",
        run: /*@__PURE__*/ $c812b694720e13a5$export$26f3a479ac65d653(false, "page")
    },
    {
        key: "Enter",
        run: $c812b694720e13a5$export$537623a3380ccdae
    }
];
const $c812b694720e13a5$var$completionKeymapExt = /*@__PURE__*/ (0, $b2ZzE.Prec).highest(/*@__PURE__*/ (0, $3e6dc.keymap).computeN([
    $c812b694720e13a5$var$completionConfig
], (state)=>state.facet($c812b694720e13a5$var$completionConfig).defaultKeymap ? [
        $c812b694720e13a5$export$2a3d759d156afab4
    ] : []));
/**
Get the current completion status. When completions are available,
this will return `"active"`. When completions are pending (in the
process of being queried), this returns `"pending"`. Otherwise, it
returns `null`.
*/ function $c812b694720e13a5$export$9eb35bf27959eae5(state) {
    let cState = state.field($c812b694720e13a5$var$completionState, false);
    return cState && cState.active.some((a)=>a.isPending) ? "pending" : cState && cState.active.some((a)=>a.state != 0 /* State.Inactive */ ) ? "active" : null;
}
const $c812b694720e13a5$var$completionArrayCache = /*@__PURE__*/ new WeakMap;
/**
Returns the available completions as an array.
*/ function $c812b694720e13a5$export$dc0f5d77fb0cbbf5(state) {
    var _a;
    let open = (_a = state.field($c812b694720e13a5$var$completionState, false)) === null || _a === void 0 ? void 0 : _a.open;
    if (!open || open.disabled) return [];
    let completions = $c812b694720e13a5$var$completionArrayCache.get(open.options);
    if (!completions) $c812b694720e13a5$var$completionArrayCache.set(open.options, completions = open.options.map((o)=>o.completion));
    return completions;
}
/**
Return the currently selected completion, if any.
*/ function $c812b694720e13a5$export$8c322db2cd50d0f1(state) {
    var _a;
    let open = (_a = state.field($c812b694720e13a5$var$completionState, false)) === null || _a === void 0 ? void 0 : _a.open;
    return open && !open.disabled && open.selected >= 0 ? open.options[open.selected].completion : null;
}
/**
Returns the currently selected position in the active completion
list, or null if no completions are active.
*/ function $c812b694720e13a5$export$93d3d3265e08d270(state) {
    var _a;
    let open = (_a = state.field($c812b694720e13a5$var$completionState, false)) === null || _a === void 0 ? void 0 : _a.open;
    return open && !open.disabled && open.selected >= 0 ? open.selected : null;
}
/**
Create an effect that can be attached to a transaction to change
the currently selected completion.
*/ function $c812b694720e13a5$export$64a726c2de6175b8(index) {
    return $c812b694720e13a5$var$setSelectedEffect.of(index);
}
module.exports["CompletionContext"] = $c812b694720e13a5$export$7b73e80391102dce;
module.exports["completeFromList"] = $c812b694720e13a5$export$db0ee7d2648a0c4b;
module.exports["ifNotIn"] = $c812b694720e13a5$export$1dfdaeb1e91714c0;
module.exports["snippetCompletion"] = $c812b694720e13a5$export$975ef56e648d23ad;
module.exports["closeBrackets"] = $c812b694720e13a5$export$69e4e9d3300ff824;

});

parcelRegister("wK0D9", function(module, exports) {

var $drfo6 = parcelRequire("drfo6");


var $4lK5a = parcelRequire("4lK5a");


var $uXNGm = parcelRequire("uXNGm");

let $0626adbc624d09d1$var$_properties = null;
function $0626adbc624d09d1$var$properties() {
    if (!$0626adbc624d09d1$var$_properties && typeof document == "object" && document.body) {
        let { style: style } = document.body, names = [], seen = new Set;
        for(let prop in style)if (prop != "cssText" && prop != "cssFloat") {
            if (typeof style[prop] == "string") {
                if (/[A-Z]/.test(prop)) prop = prop.replace(/[A-Z]/g, (ch)=>"-" + ch.toLowerCase());
                if (!seen.has(prop)) {
                    names.push(prop);
                    seen.add(prop);
                }
            }
        }
        $0626adbc624d09d1$var$_properties = names.sort().map((name)=>({
                type: "property",
                label: name,
                apply: name + ": "
            }));
    }
    return $0626adbc624d09d1$var$_properties || [];
}
const $0626adbc624d09d1$var$pseudoClasses = /*@__PURE__*/ [
    "active",
    "after",
    "any-link",
    "autofill",
    "backdrop",
    "before",
    "checked",
    "cue",
    "default",
    "defined",
    "disabled",
    "empty",
    "enabled",
    "file-selector-button",
    "first",
    "first-child",
    "first-letter",
    "first-line",
    "first-of-type",
    "focus",
    "focus-visible",
    "focus-within",
    "fullscreen",
    "has",
    "host",
    "host-context",
    "hover",
    "in-range",
    "indeterminate",
    "invalid",
    "is",
    "lang",
    "last-child",
    "last-of-type",
    "left",
    "link",
    "marker",
    "modal",
    "not",
    "nth-child",
    "nth-last-child",
    "nth-last-of-type",
    "nth-of-type",
    "only-child",
    "only-of-type",
    "optional",
    "out-of-range",
    "part",
    "placeholder",
    "placeholder-shown",
    "read-only",
    "read-write",
    "required",
    "right",
    "root",
    "scope",
    "selection",
    "slotted",
    "target",
    "target-text",
    "valid",
    "visited",
    "where"
].map((name)=>({
        type: "class",
        label: name
    }));
const $0626adbc624d09d1$var$values = /*@__PURE__*/ [
    "above",
    "absolute",
    "activeborder",
    "additive",
    "activecaption",
    "after-white-space",
    "ahead",
    "alias",
    "all",
    "all-scroll",
    "alphabetic",
    "alternate",
    "always",
    "antialiased",
    "appworkspace",
    "asterisks",
    "attr",
    "auto",
    "auto-flow",
    "avoid",
    "avoid-column",
    "avoid-page",
    "avoid-region",
    "axis-pan",
    "background",
    "backwards",
    "baseline",
    "below",
    "bidi-override",
    "blink",
    "block",
    "block-axis",
    "bold",
    "bolder",
    "border",
    "border-box",
    "both",
    "bottom",
    "break",
    "break-all",
    "break-word",
    "bullets",
    "button",
    "button-bevel",
    "buttonface",
    "buttonhighlight",
    "buttonshadow",
    "buttontext",
    "calc",
    "capitalize",
    "caps-lock-indicator",
    "caption",
    "captiontext",
    "caret",
    "cell",
    "center",
    "checkbox",
    "circle",
    "cjk-decimal",
    "clear",
    "clip",
    "close-quote",
    "col-resize",
    "collapse",
    "color",
    "color-burn",
    "color-dodge",
    "column",
    "column-reverse",
    "compact",
    "condensed",
    "contain",
    "content",
    "contents",
    "content-box",
    "context-menu",
    "continuous",
    "copy",
    "counter",
    "counters",
    "cover",
    "crop",
    "cross",
    "crosshair",
    "currentcolor",
    "cursive",
    "cyclic",
    "darken",
    "dashed",
    "decimal",
    "decimal-leading-zero",
    "default",
    "default-button",
    "dense",
    "destination-atop",
    "destination-in",
    "destination-out",
    "destination-over",
    "difference",
    "disc",
    "discard",
    "disclosure-closed",
    "disclosure-open",
    "document",
    "dot-dash",
    "dot-dot-dash",
    "dotted",
    "double",
    "down",
    "e-resize",
    "ease",
    "ease-in",
    "ease-in-out",
    "ease-out",
    "element",
    "ellipse",
    "ellipsis",
    "embed",
    "end",
    "ethiopic-abegede-gez",
    "ethiopic-halehame-aa-er",
    "ethiopic-halehame-gez",
    "ew-resize",
    "exclusion",
    "expanded",
    "extends",
    "extra-condensed",
    "extra-expanded",
    "fantasy",
    "fast",
    "fill",
    "fill-box",
    "fixed",
    "flat",
    "flex",
    "flex-end",
    "flex-start",
    "footnotes",
    "forwards",
    "from",
    "geometricPrecision",
    "graytext",
    "grid",
    "groove",
    "hand",
    "hard-light",
    "help",
    "hidden",
    "hide",
    "higher",
    "highlight",
    "highlighttext",
    "horizontal",
    "hsl",
    "hsla",
    "hue",
    "icon",
    "ignore",
    "inactiveborder",
    "inactivecaption",
    "inactivecaptiontext",
    "infinite",
    "infobackground",
    "infotext",
    "inherit",
    "initial",
    "inline",
    "inline-axis",
    "inline-block",
    "inline-flex",
    "inline-grid",
    "inline-table",
    "inset",
    "inside",
    "intrinsic",
    "invert",
    "italic",
    "justify",
    "keep-all",
    "landscape",
    "large",
    "larger",
    "left",
    "level",
    "lighter",
    "lighten",
    "line-through",
    "linear",
    "linear-gradient",
    "lines",
    "list-item",
    "listbox",
    "listitem",
    "local",
    "logical",
    "loud",
    "lower",
    "lower-hexadecimal",
    "lower-latin",
    "lower-norwegian",
    "lowercase",
    "ltr",
    "luminosity",
    "manipulation",
    "match",
    "matrix",
    "matrix3d",
    "medium",
    "menu",
    "menutext",
    "message-box",
    "middle",
    "min-intrinsic",
    "mix",
    "monospace",
    "move",
    "multiple",
    "multiple_mask_images",
    "multiply",
    "n-resize",
    "narrower",
    "ne-resize",
    "nesw-resize",
    "no-close-quote",
    "no-drop",
    "no-open-quote",
    "no-repeat",
    "none",
    "normal",
    "not-allowed",
    "nowrap",
    "ns-resize",
    "numbers",
    "numeric",
    "nw-resize",
    "nwse-resize",
    "oblique",
    "opacity",
    "open-quote",
    "optimizeLegibility",
    "optimizeSpeed",
    "outset",
    "outside",
    "outside-shape",
    "overlay",
    "overline",
    "padding",
    "padding-box",
    "painted",
    "page",
    "paused",
    "perspective",
    "pinch-zoom",
    "plus-darker",
    "plus-lighter",
    "pointer",
    "polygon",
    "portrait",
    "pre",
    "pre-line",
    "pre-wrap",
    "preserve-3d",
    "progress",
    "push-button",
    "radial-gradient",
    "radio",
    "read-only",
    "read-write",
    "read-write-plaintext-only",
    "rectangle",
    "region",
    "relative",
    "repeat",
    "repeating-linear-gradient",
    "repeating-radial-gradient",
    "repeat-x",
    "repeat-y",
    "reset",
    "reverse",
    "rgb",
    "rgba",
    "ridge",
    "right",
    "rotate",
    "rotate3d",
    "rotateX",
    "rotateY",
    "rotateZ",
    "round",
    "row",
    "row-resize",
    "row-reverse",
    "rtl",
    "run-in",
    "running",
    "s-resize",
    "sans-serif",
    "saturation",
    "scale",
    "scale3d",
    "scaleX",
    "scaleY",
    "scaleZ",
    "screen",
    "scroll",
    "scrollbar",
    "scroll-position",
    "se-resize",
    "self-start",
    "self-end",
    "semi-condensed",
    "semi-expanded",
    "separate",
    "serif",
    "show",
    "single",
    "skew",
    "skewX",
    "skewY",
    "skip-white-space",
    "slide",
    "slider-horizontal",
    "slider-vertical",
    "sliderthumb-horizontal",
    "sliderthumb-vertical",
    "slow",
    "small",
    "small-caps",
    "small-caption",
    "smaller",
    "soft-light",
    "solid",
    "source-atop",
    "source-in",
    "source-out",
    "source-over",
    "space",
    "space-around",
    "space-between",
    "space-evenly",
    "spell-out",
    "square",
    "start",
    "static",
    "status-bar",
    "stretch",
    "stroke",
    "stroke-box",
    "sub",
    "subpixel-antialiased",
    "svg_masks",
    "super",
    "sw-resize",
    "symbolic",
    "symbols",
    "system-ui",
    "table",
    "table-caption",
    "table-cell",
    "table-column",
    "table-column-group",
    "table-footer-group",
    "table-header-group",
    "table-row",
    "table-row-group",
    "text",
    "text-bottom",
    "text-top",
    "textarea",
    "textfield",
    "thick",
    "thin",
    "threeddarkshadow",
    "threedface",
    "threedhighlight",
    "threedlightshadow",
    "threedshadow",
    "to",
    "top",
    "transform",
    "translate",
    "translate3d",
    "translateX",
    "translateY",
    "translateZ",
    "transparent",
    "ultra-condensed",
    "ultra-expanded",
    "underline",
    "unidirectional-pan",
    "unset",
    "up",
    "upper-latin",
    "uppercase",
    "url",
    "var",
    "vertical",
    "vertical-text",
    "view-box",
    "visible",
    "visibleFill",
    "visiblePainted",
    "visibleStroke",
    "visual",
    "w-resize",
    "wait",
    "wave",
    "wider",
    "window",
    "windowframe",
    "windowtext",
    "words",
    "wrap",
    "wrap-reverse",
    "x-large",
    "x-small",
    "xor",
    "xx-large",
    "xx-small"
].map((name)=>({
        type: "keyword",
        label: name
    })).concat(/*@__PURE__*/ [
    "aliceblue",
    "antiquewhite",
    "aqua",
    "aquamarine",
    "azure",
    "beige",
    "bisque",
    "black",
    "blanchedalmond",
    "blue",
    "blueviolet",
    "brown",
    "burlywood",
    "cadetblue",
    "chartreuse",
    "chocolate",
    "coral",
    "cornflowerblue",
    "cornsilk",
    "crimson",
    "cyan",
    "darkblue",
    "darkcyan",
    "darkgoldenrod",
    "darkgray",
    "darkgreen",
    "darkkhaki",
    "darkmagenta",
    "darkolivegreen",
    "darkorange",
    "darkorchid",
    "darkred",
    "darksalmon",
    "darkseagreen",
    "darkslateblue",
    "darkslategray",
    "darkturquoise",
    "darkviolet",
    "deeppink",
    "deepskyblue",
    "dimgray",
    "dodgerblue",
    "firebrick",
    "floralwhite",
    "forestgreen",
    "fuchsia",
    "gainsboro",
    "ghostwhite",
    "gold",
    "goldenrod",
    "gray",
    "grey",
    "green",
    "greenyellow",
    "honeydew",
    "hotpink",
    "indianred",
    "indigo",
    "ivory",
    "khaki",
    "lavender",
    "lavenderblush",
    "lawngreen",
    "lemonchiffon",
    "lightblue",
    "lightcoral",
    "lightcyan",
    "lightgoldenrodyellow",
    "lightgray",
    "lightgreen",
    "lightpink",
    "lightsalmon",
    "lightseagreen",
    "lightskyblue",
    "lightslategray",
    "lightsteelblue",
    "lightyellow",
    "lime",
    "limegreen",
    "linen",
    "magenta",
    "maroon",
    "mediumaquamarine",
    "mediumblue",
    "mediumorchid",
    "mediumpurple",
    "mediumseagreen",
    "mediumslateblue",
    "mediumspringgreen",
    "mediumturquoise",
    "mediumvioletred",
    "midnightblue",
    "mintcream",
    "mistyrose",
    "moccasin",
    "navajowhite",
    "navy",
    "oldlace",
    "olive",
    "olivedrab",
    "orange",
    "orangered",
    "orchid",
    "palegoldenrod",
    "palegreen",
    "paleturquoise",
    "palevioletred",
    "papayawhip",
    "peachpuff",
    "peru",
    "pink",
    "plum",
    "powderblue",
    "purple",
    "rebeccapurple",
    "red",
    "rosybrown",
    "royalblue",
    "saddlebrown",
    "salmon",
    "sandybrown",
    "seagreen",
    "seashell",
    "sienna",
    "silver",
    "skyblue",
    "slateblue",
    "slategray",
    "snow",
    "springgreen",
    "steelblue",
    "tan",
    "teal",
    "thistle",
    "tomato",
    "turquoise",
    "violet",
    "wheat",
    "white",
    "whitesmoke",
    "yellow",
    "yellowgreen"
].map((name)=>({
        type: "constant",
        label: name
    })));
const $0626adbc624d09d1$var$tags = /*@__PURE__*/ [
    "a",
    "abbr",
    "address",
    "article",
    "aside",
    "b",
    "bdi",
    "bdo",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "figcaption",
    "figure",
    "footer",
    "form",
    "header",
    "hgroup",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "main",
    "meter",
    "nav",
    "ol",
    "output",
    "p",
    "pre",
    "ruby",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "template",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "tr",
    "u",
    "ul"
].map((name)=>({
        type: "type",
        label: name
    }));
const $0626adbc624d09d1$var$atRules = /*@__PURE__*/ [
    "@charset",
    "@color-profile",
    "@container",
    "@counter-style",
    "@font-face",
    "@font-feature-values",
    "@font-palette-values",
    "@import",
    "@keyframes",
    "@layer",
    "@media",
    "@namespace",
    "@page",
    "@position-try",
    "@property",
    "@scope",
    "@starting-style",
    "@supports",
    "@view-transition"
].map((label)=>({
        type: "keyword",
        label: label
    }));
const $0626adbc624d09d1$var$identifier = /^(\w[\w-]*|-\w[\w-]*|)$/, $0626adbc624d09d1$var$variable = /^-(-[\w-]*)?$/;
function $0626adbc624d09d1$var$isVarArg(node, doc) {
    var _a;
    if (node.name == "(" || node.type.isError) node = node.parent || node;
    if (node.name != "ArgList") return false;
    let callee = (_a = node.parent) === null || _a === void 0 ? void 0 : _a.firstChild;
    if ((callee === null || callee === void 0 ? void 0 : callee.name) != "Callee") return false;
    return doc.sliceString(callee.from, callee.to) == "var";
}
const $0626adbc624d09d1$var$VariablesByNode = /*@__PURE__*/ new (0, $uXNGm.NodeWeakMap)();
const $0626adbc624d09d1$var$declSelector = [
    "Declaration"
];
function $0626adbc624d09d1$var$astTop(node) {
    for(let cur = node;;){
        if (cur.type.isTop) return cur;
        if (!(cur = cur.parent)) return node;
    }
}
function $0626adbc624d09d1$var$variableNames(doc, node, isVariable) {
    if (node.to - node.from > 4096) {
        let known = $0626adbc624d09d1$var$VariablesByNode.get(node);
        if (known) return known;
        let result = [], seen = new Set, cursor = node.cursor((0, $uXNGm.IterMode).IncludeAnonymous);
        if (cursor.firstChild()) do {
            for (let option of $0626adbc624d09d1$var$variableNames(doc, cursor.node, isVariable))if (!seen.has(option.label)) {
                seen.add(option.label);
                result.push(option);
            }
        }while (cursor.nextSibling());
        $0626adbc624d09d1$var$VariablesByNode.set(node, result);
        return result;
    } else {
        let result = [], seen = new Set;
        node.cursor().iterate((node)=>{
            var _a;
            if (isVariable(node) && node.matchContext($0626adbc624d09d1$var$declSelector) && ((_a = node.node.nextSibling) === null || _a === void 0 ? void 0 : _a.name) == ":") {
                let name = doc.sliceString(node.from, node.to);
                if (!seen.has(name)) {
                    seen.add(name);
                    result.push({
                        label: name,
                        type: "variable"
                    });
                }
            }
        });
        return result;
    }
}
/**
Create a completion source for a CSS dialect, providing a
predicate for determining what kind of syntax node can act as a
completable variable. This is used by language modes like Sass and
Less to reuse this package's completion logic.
*/ const $0626adbc624d09d1$export$d81c1c660b46cb31 = (isVariable)=>(context)=>{
        let { state: state, pos: pos } = context, node = (0, $4lK5a.syntaxTree)(state).resolveInner(pos, -1);
        let isDash = node.type.isError && node.from == node.to - 1 && state.doc.sliceString(node.from, node.to) == "-";
        if (node.name == "PropertyName" || (isDash || node.name == "TagName") && /^(Block|Styles)$/.test(node.resolve(node.to).name)) return {
            from: node.from,
            options: $0626adbc624d09d1$var$properties(),
            validFor: $0626adbc624d09d1$var$identifier
        };
        if (node.name == "ValueName") return {
            from: node.from,
            options: $0626adbc624d09d1$var$values,
            validFor: $0626adbc624d09d1$var$identifier
        };
        if (node.name == "PseudoClassName") return {
            from: node.from,
            options: $0626adbc624d09d1$var$pseudoClasses,
            validFor: $0626adbc624d09d1$var$identifier
        };
        if (isVariable(node) || (context.explicit || isDash) && $0626adbc624d09d1$var$isVarArg(node, state.doc)) return {
            from: isVariable(node) || isDash ? node.from : pos,
            options: $0626adbc624d09d1$var$variableNames(state.doc, $0626adbc624d09d1$var$astTop(node), isVariable),
            validFor: $0626adbc624d09d1$var$variable
        };
        if (node.name == "TagName") {
            for(let { parent: parent } = node; parent; parent = parent.parent)if (parent.name == "Block") return {
                from: node.from,
                options: $0626adbc624d09d1$var$properties(),
                validFor: $0626adbc624d09d1$var$identifier
            };
            return {
                from: node.from,
                options: $0626adbc624d09d1$var$tags,
                validFor: $0626adbc624d09d1$var$identifier
            };
        }
        if (node.name == "AtKeyword") return {
            from: node.from,
            options: $0626adbc624d09d1$var$atRules,
            validFor: $0626adbc624d09d1$var$identifier
        };
        if (!context.explicit) return null;
        let above = node.resolve(pos), before = above.childBefore(pos);
        if (before && before.name == ":" && above.name == "PseudoClassSelector") return {
            from: pos,
            options: $0626adbc624d09d1$var$pseudoClasses,
            validFor: $0626adbc624d09d1$var$identifier
        };
        if (before && before.name == ":" && above.name == "Declaration" || above.name == "ArgList") return {
            from: pos,
            options: $0626adbc624d09d1$var$values,
            validFor: $0626adbc624d09d1$var$identifier
        };
        if (above.name == "Block" || above.name == "Styles") return {
            from: pos,
            options: $0626adbc624d09d1$var$properties(),
            validFor: $0626adbc624d09d1$var$identifier
        };
        return null;
    };
/**
CSS property, variable, and value keyword completion source.
*/ const $0626adbc624d09d1$export$62bc29ba0658e894 = /*@__PURE__*/ $0626adbc624d09d1$export$d81c1c660b46cb31((n)=>n.name == "VariableName");
/**
A language provider based on the [Lezer CSS
parser](https://github.com/lezer-parser/css), extended with
highlighting and indentation information.
*/ const $0626adbc624d09d1$export$93323d80d661fcda = /*@__PURE__*/ (0, $4lK5a.LRLanguage).define({
    name: "css",
    parser: /*@__PURE__*/ (0, $drfo6.parser).configure({
        props: [
            /*@__PURE__*/ (0, $4lK5a.indentNodeProp).add({
                Declaration: /*@__PURE__*/ (0, $4lK5a.continuedIndent)()
            }),
            /*@__PURE__*/ (0, $4lK5a.foldNodeProp).add({
                "Block KeyframeList": (0, $4lK5a.foldInside)
            })
        ]
    }),
    languageData: {
        commentTokens: {
            block: {
                open: "/*",
                close: "*/"
            }
        },
        indentOnInput: /^\s*\}$/,
        wordChars: "-"
    }
});
/**
Language support for CSS.
*/ function $0626adbc624d09d1$export$dbf350e5966cf602() {
    return new (0, $4lK5a.LanguageSupport)($0626adbc624d09d1$export$93323d80d661fcda, $0626adbc624d09d1$export$93323d80d661fcda.data.of({
        autocomplete: $0626adbc624d09d1$export$62bc29ba0658e894
    }));
}
module.exports["defineCSSCompletionSource"] = $0626adbc624d09d1$export$d81c1c660b46cb31;
module.exports["cssLanguage"] = $0626adbc624d09d1$export$93323d80d661fcda;
module.exports["css"] = $0626adbc624d09d1$export$dbf350e5966cf602;

});

parcelRegister("drfo6", function(module, exports) {

var $2sfCn = parcelRequire("2sfCn");


var $lhXhg = parcelRequire("lhXhg");

// This file was generated by lezer-generator. You probably shouldn't edit it.
const $9c89bba9366b52a5$var$descendantOp = 99, $9c89bba9366b52a5$var$Unit = 1, $9c89bba9366b52a5$var$callee = 100, $9c89bba9366b52a5$var$identifier = 101, $9c89bba9366b52a5$var$VariableName = 2;
/* Hand-written tokenizers for CSS tokens that can't be
   expressed by Lezer's built-in tokenizer. */ const $9c89bba9366b52a5$var$space = [
    9,
    10,
    11,
    12,
    13,
    32,
    133,
    160,
    5760,
    8192,
    8193,
    8194,
    8195,
    8196,
    8197,
    8198,
    8199,
    8200,
    8201,
    8202,
    8232,
    8233,
    8239,
    8287,
    12288
];
const $9c89bba9366b52a5$var$colon = 58, $9c89bba9366b52a5$var$parenL = 40, $9c89bba9366b52a5$var$underscore = 95, $9c89bba9366b52a5$var$bracketL = 91, $9c89bba9366b52a5$var$dash = 45, $9c89bba9366b52a5$var$period = 46, $9c89bba9366b52a5$var$hash = 35, $9c89bba9366b52a5$var$percent = 37, $9c89bba9366b52a5$var$ampersand = 38, $9c89bba9366b52a5$var$backslash = 92, $9c89bba9366b52a5$var$newline = 10;
function $9c89bba9366b52a5$var$isAlpha(ch) {
    return ch >= 65 && ch <= 90 || ch >= 97 && ch <= 122 || ch >= 161;
}
function $9c89bba9366b52a5$var$isDigit(ch) {
    return ch >= 48 && ch <= 57;
}
const $9c89bba9366b52a5$var$identifiers = new (0, $2sfCn.ExternalTokenizer)((input, stack)=>{
    for(let inside = false, dashes = 0, i = 0;; i++){
        let { next: next } = input;
        if ($9c89bba9366b52a5$var$isAlpha(next) || next == $9c89bba9366b52a5$var$dash || next == $9c89bba9366b52a5$var$underscore || inside && $9c89bba9366b52a5$var$isDigit(next)) {
            if (!inside && (next != $9c89bba9366b52a5$var$dash || i > 0)) inside = true;
            if (dashes === i && next == $9c89bba9366b52a5$var$dash) dashes++;
            input.advance();
        } else if (next == $9c89bba9366b52a5$var$backslash && input.peek(1) != $9c89bba9366b52a5$var$newline) {
            input.advance();
            if (input.next > -1) input.advance();
            inside = true;
        } else {
            if (inside) input.acceptToken(next == $9c89bba9366b52a5$var$parenL ? $9c89bba9366b52a5$var$callee : dashes == 2 && stack.canShift($9c89bba9366b52a5$var$VariableName) ? $9c89bba9366b52a5$var$VariableName : $9c89bba9366b52a5$var$identifier);
            break;
        }
    }
});
const $9c89bba9366b52a5$var$descendant = new (0, $2sfCn.ExternalTokenizer)((input)=>{
    if ($9c89bba9366b52a5$var$space.includes(input.peek(-1))) {
        let { next: next } = input;
        if ($9c89bba9366b52a5$var$isAlpha(next) || next == $9c89bba9366b52a5$var$underscore || next == $9c89bba9366b52a5$var$hash || next == $9c89bba9366b52a5$var$period || next == $9c89bba9366b52a5$var$bracketL || next == $9c89bba9366b52a5$var$colon && $9c89bba9366b52a5$var$isAlpha(input.peek(1)) || next == $9c89bba9366b52a5$var$dash || next == $9c89bba9366b52a5$var$ampersand) input.acceptToken($9c89bba9366b52a5$var$descendantOp);
    }
});
const $9c89bba9366b52a5$var$unitToken = new (0, $2sfCn.ExternalTokenizer)((input)=>{
    if (!$9c89bba9366b52a5$var$space.includes(input.peek(-1))) {
        let { next: next } = input;
        if (next == $9c89bba9366b52a5$var$percent) {
            input.advance();
            input.acceptToken($9c89bba9366b52a5$var$Unit);
        }
        if ($9c89bba9366b52a5$var$isAlpha(next)) {
            do input.advance();
            while ($9c89bba9366b52a5$var$isAlpha(input.next) || $9c89bba9366b52a5$var$isDigit(input.next));
            input.acceptToken($9c89bba9366b52a5$var$Unit);
        }
    }
});
const $9c89bba9366b52a5$var$cssHighlighting = (0, $lhXhg.styleTags)({
    "AtKeyword import charset namespace keyframes media supports": (0, $lhXhg.tags).definitionKeyword,
    "from to selector": (0, $lhXhg.tags).keyword,
    NamespaceName: (0, $lhXhg.tags).namespace,
    KeyframeName: (0, $lhXhg.tags).labelName,
    KeyframeRangeName: (0, $lhXhg.tags).operatorKeyword,
    TagName: (0, $lhXhg.tags).tagName,
    ClassName: (0, $lhXhg.tags).className,
    PseudoClassName: (0, $lhXhg.tags).constant((0, $lhXhg.tags).className),
    IdName: (0, $lhXhg.tags).labelName,
    "FeatureName PropertyName": (0, $lhXhg.tags).propertyName,
    AttributeName: (0, $lhXhg.tags).attributeName,
    NumberLiteral: (0, $lhXhg.tags).number,
    KeywordQuery: (0, $lhXhg.tags).keyword,
    UnaryQueryOp: (0, $lhXhg.tags).operatorKeyword,
    "CallTag ValueName": (0, $lhXhg.tags).atom,
    VariableName: (0, $lhXhg.tags).variableName,
    Callee: (0, $lhXhg.tags).operatorKeyword,
    Unit: (0, $lhXhg.tags).unit,
    "UniversalSelector NestingSelector": (0, $lhXhg.tags).definitionOperator,
    MatchOp: (0, $lhXhg.tags).compareOperator,
    "ChildOp SiblingOp, LogicOp": (0, $lhXhg.tags).logicOperator,
    BinOp: (0, $lhXhg.tags).arithmeticOperator,
    Important: (0, $lhXhg.tags).modifier,
    Comment: (0, $lhXhg.tags).blockComment,
    ColorLiteral: (0, $lhXhg.tags).color,
    "ParenthesizedContent StringLiteral": (0, $lhXhg.tags).string,
    ":": (0, $lhXhg.tags).punctuation,
    "PseudoOp #": (0, $lhXhg.tags).derefOperator,
    "; ,": (0, $lhXhg.tags).separator,
    "( )": (0, $lhXhg.tags).paren,
    "[ ]": (0, $lhXhg.tags).squareBracket,
    "{ }": (0, $lhXhg.tags).brace
});
// This file was generated by lezer-generator. You probably shouldn't edit it.
const $9c89bba9366b52a5$var$spec_callee = {
    __proto__: null,
    lang: 32,
    "nth-child": 32,
    "nth-last-child": 32,
    "nth-of-type": 32,
    "nth-last-of-type": 32,
    dir: 32,
    "host-context": 32,
    url: 60,
    "url-prefix": 60,
    domain: 60,
    regexp: 60,
    selector: 138
};
const $9c89bba9366b52a5$var$spec_AtKeyword = {
    __proto__: null,
    "@import": 118,
    "@media": 142,
    "@charset": 146,
    "@namespace": 150,
    "@keyframes": 156,
    "@supports": 168
};
const $9c89bba9366b52a5$var$spec_identifier = {
    __proto__: null,
    not: 132,
    only: 132
};
const $9c89bba9366b52a5$export$8f49e4af10703ce3 = (0, $2sfCn.LRParser).deserialize({
    version: 14,
    states: ":jQYQ[OOO#_Q[OOP#fOWOOOOQP'#Cd'#CdOOQP'#Cc'#CcO#kQ[O'#CfO$_QXO'#CaO$fQ[O'#ChO$qQ[O'#DTO$vQ[O'#DWOOQP'#Em'#EmO${QdO'#DgO%jQ[O'#DtO${QdO'#DvO%{Q[O'#DxO&WQ[O'#D{O&`Q[O'#ERO&nQ[O'#ETOOQS'#El'#ElOOQS'#EW'#EWQYQ[OOO&uQXO'#CdO'jQWO'#DcO'oQWO'#EsO'zQ[O'#EsQOQWOOP(UO#tO'#C_POOO)C@[)C@[OOQP'#Cg'#CgOOQP,59Q,59QO#kQ[O,59QO(aQ[O'#E[O({QWO,58{O)TQ[O,59SO$qQ[O,59oO$vQ[O,59rO(aQ[O,59uO(aQ[O,59wO(aQ[O,59xO)`Q[O'#DbOOQS,58{,58{OOQP'#Ck'#CkOOQO'#DR'#DROOQP,59S,59SO)gQWO,59SO)lQWO,59SOOQP'#DV'#DVOOQP,59o,59oOOQO'#DX'#DXO)qQ`O,59rOOQS'#Cp'#CpO${QdO'#CqO)yQvO'#CsO+ZQtO,5:ROOQO'#Cx'#CxO)lQWO'#CwO+oQWO'#CyO+tQ[O'#DOOOQS'#Ep'#EpOOQO'#Dj'#DjO+|Q[O'#DqO,[QWO'#EtO&`Q[O'#DoO,jQWO'#DrOOQO'#Eu'#EuO)OQWO,5:`O,oQpO,5:bOOQS'#Dz'#DzO,wQWO,5:dO,|Q[O,5:dOOQO'#D}'#D}O-UQWO,5:gO-ZQWO,5:mO-cQWO,5:oOOQS-E8U-E8UO-kQdO,59}O-{Q[O'#E^O.YQWO,5;_O.YQWO,5;_POOO'#EV'#EVP.eO#tO,58yPOOO,58y,58yOOQP1G.l1G.lO/[QXO,5:vOOQO-E8Y-E8YOOQS1G.g1G.gOOQP1G.n1G.nO)gQWO1G.nO)lQWO1G.nOOQP1G/Z1G/ZO/iQ`O1G/^O0SQXO1G/aO0jQXO1G/cO1QQXO1G/dO1hQWO,59|O1mQ[O'#DSO1tQdO'#CoOOQP1G/^1G/^O${QdO1G/^O1{QpO,59]OOQS,59_,59_O${QdO,59aO2TQWO1G/mOOQS,59c,59cO2YQ!bO,59eOOQS'#DP'#DPOOQS'#EY'#EYO2eQ[O,59jOOQS,59j,59jO2mQWO'#DjO2xQWO,5:VO2}QWO,5:]O&`Q[O,5:XO&`Q[O'#E_O3VQWO,5;`O3bQWO,5:ZO(aQ[O,5:^OOQS1G/z1G/zOOQS1G/|1G/|OOQS1G0O1G0OO3sQWO1G0OO3xQdO'#EOOOQS1G0R1G0ROOQS1G0X1G0XOOQS1G0Z1G0ZO4TQtO1G/iOOQO1G/i1G/iOOQO,5:x,5:xO4kQ[O,5:xOOQO-E8[-E8[O4xQWO1G0yPOOO-E8T-E8TPOOO1G.e1G.eOOQP7+$Y7+$YOOQP7+$x7+$xO${QdO7+$xOOQS1G/h1G/hO5TQXO'#ErO5[QWO,59nO5aQtO'#EXO6XQdO'#EoO6cQWO,59ZO6hQpO7+$xOOQS1G.w1G.wOOQS1G.{1G.{OOQS7+%X7+%XOOQS1G/P1G/PO6pQWO1G/POOQS-E8W-E8WOOQS1G/U1G/UO${QdO1G/qOOQO1G/w1G/wOOQO1G/s1G/sO6uQWO,5:yOOQO-E8]-E8]O7TQXO1G/xOOQS7+%j7+%jO7[QYO'#CsOOQO'#EQ'#EQO7gQ`O'#EPOOQO'#EP'#EPO7rQWO'#E`O7zQdO,5:jOOQS,5:j,5:jO8VQtO'#E]O${QdO'#E]O9WQdO7+%TOOQO7+%T7+%TOOQO1G0d1G0dO9kQpO<<HdO9sQWO,5;^OOQP1G/Y1G/YOOQS-E8V-E8VO${QdO'#EZO9{QWO,5;ZOOQT1G.u1G.uOOQP<<Hd<<HdOOQS7+$k7+$kO:TQdO7+%]OOQO7+%d7+%dOOQO,5:k,5:kO3{QdO'#EaO7rQWO,5:zOOQS,5:z,5:zOOQS-E8^-E8^OOQS1G0U1G0UO:[QtO,5:wOOQS-E8Z-E8ZOOQO<<Ho<<HoOOQPAN>OAN>OO;]QdO,5:uOOQO-E8X-E8XOOQO<<Hw<<HwOOQO,5:{,5:{OOQO-E8_-E8_OOQS1G0f1G0f",
    stateData: ";o~O#ZOS#[QQ~OUYOXYO]VO^VOqXOxWO![aO!]ZO!i[O!k]O!m^O!p_O!v`O#XRO#bTO~OQfOUYOXYO]VO^VOqXOxWO![aO!]ZO!i[O!k]O!m^O!p_O!v`O#XeO#bTO~O#U#gP~P!ZO#[jO~O#XlO~O]qO^qOqsOtoOxrO!OtO!RvO#VuO#bnO~O!TwO~P#pO`}O#WzO#XyO~O#X!OO~O#X!QO~OQ![Ob!TOf![Oh![On!YOq!ZO#W!WO#X!SO#e!UO~Ob!^O!d!`O!g!aO#X!]O!T#hP~Oh!fOn!YO#X!eO~Oh!hO#X!hO~Ob!^O!d!`O!g!aO#X!]O~O!Y#hP~P%jO]WX]!WX^WXqWXtWXxWX!OWX!RWX!TWX#VWX#bWX~O]!mO~O!Y!nO#U#gX!S#gX~O#U#gX!S#gX~P!ZO#]!qO#^!qO#_!sO~OUYOXYO]VO^VOqXOxWO#XRO#bTO~OtoO!TwO~O`!zO#WzO#XyO~O!S#gP~P!ZOb#RO~Ob#SO~Op#TO|#UO~OP#WObgXjgX!YgX!dgX!ggX#XgXagXQgXfgXhgXngXqgXtgX!XgX#UgX#WgX#egXpgX!SgX~Ob!^Oj#XO!d!`O!g!aO#X!]O!Y#hP~Ob#[O~Op#`O#X#]O~Ob!^O!d!`O!g!aO#X#aO~Ot#eO!b#dO!T#hX!Y#hX~Ob#hO~Oj#XO!Y#jO~O!Y#kO~Oh#lOn!YO~O!T#mO~O!TwO!b#dO~O!TwO!Y#pO~O!X#rO!Y!Va#U!Va!S!Va~P${O!Y#QX#U#QX!S#QX~P!ZO!Y!nO#U#ga!S#ga~O#]!qO#^!qO#_#xO~O]qO^qOqsOxrO!OtO!RvO#VuO#bnO~Ot#Oa!T#Oaa#Oa~P.pOp#zO|#{O~O]qO^qOqsOxrO#bnO~Ot}i!O}i!R}i!T}i#V}ia}i~P/qOt!Pi!O!Pi!R!Pi!T!Pi#V!Pia!Pi~P/qOt!Qi!O!Qi!R!Qi!T!Qi#V!Qia!Qi~P/qO!S#|O~Oa#fP~P(aOa#cP~P${Oa$TOj#XO~O!Y$VO~Oa$WOh$XOo$XO~Op$ZO#X#]O~O]!`Xa!^X!b!^X~O]$[O~Oa$]O!b#dO~Ot#eO!T#ha!Y#ha~O!b#dOt!ca!T!ca!Y!caa!ca~O!Y$bO~O!S$iO#X$dO#e$cO~Oj#XOt$kO!X$mO!Y!Vi#U!Vi!S!Vi~P${O!Y#Qa#U#Qa!S#Qa~P!ZO!Y!nO#U#gi!S#gi~Oa#fX~P#pOa$qO~Oj#XOQ!{Xa!{Xb!{Xf!{Xh!{Xn!{Xq!{Xt!{X#W!{X#X!{X#e!{X~Ot$sOa#cX~P${Oa$uO~Oj#XOp$vO~Oa$wO~O!b#dOt#Ra!T#Ra!Y#Ra~Oa$yO~P.pOP#WOtgX!TgX~O#e$cOt!sX!T!sX~Ot${O!TwO~O!S%PO#X$dO#e$cO~Oj#XOQ#PXb#PXf#PXh#PXn#PXq#PXt#PX!X#PX!Y#PX#U#PX#W#PX#X#PX#e#PX!S#PX~Ot$kO!X%SO!Y!Vq#U!Vq!S!Vq~P${Oj#XOp%TO~OtoOa#fa~Ot$sOa#ca~Oa%WO~P${Oj#XOQ#Pab#Paf#Pah#Pan#Paq#Pat#Pa!X#Pa!Y#Pa#U#Pa#W#Pa#X#Pa#e#Pa!S#Pa~Oa!}at!}a~P${O#Zo#[#ej!R#e~",
    goto: "-g#jPPP#kP#nP#w$WP#w$g#wPP$mPPP$s$|$|P%`P$|P$|%z&^PPPP$|&vP&z'Q#wP'W#w'^P#wP#w#wPPP'd'y(WPP#nPP(_(_(i(_P(_P(_(_P#nP#nP#nP(l#nP(o(r(u(|#nP#nP)R)X)h)v)|*S*^*d*n*t*zPPPPPPPPPP+Q+ZP+v+yP,o,r,x-RRkQ_bOPdhw!n#tkYOPdhotuvw!n#R#h#tkSOPdhotuvw!n#R#h#tQmTR!tnQ{VR!xqQ!x}Q#Z!XR#y!zq![Z]!T!m#S#U#X#q#{$Q$[$k$l$s$x%Up![Z]!T!m#S#U#X#q#{$Q$[$k$l$s$x%UU$f#m$h${R$z$eq!XZ]!T!m#S#U#X#q#{$Q$[$k$l$s$x%Up![Z]!T!m#S#U#X#q#{$Q$[$k$l$s$x%UQ!f^R#l!gT#^!Z#_Q|VR!yqQ!x|R#y!yQ!PWR!{rQ!RXR!|sQxUQ!wpQ#i!cQ#o!jQ#p!kQ$}$gR%Z$|SgPwQ!phQ#s!nR$n#tZfPhw!n#ta!b[`a!V!^!`#d#eR#b!^R!g^R!i_R#n!iS$g#m$hR%X${V$e#m$h${Q!rjR#w!rQdOShPwU!ldh#tR#t!nQ$Q#SU$r$Q$x%UQ$x$[R%U$sQ#_!ZR$Y#_Q$t$QR%V$tQpUS!vp$pR$p#}Q$l#qR%R$lQ!ogS#u!o#vR#v!pQ#f!_R$`#fQ$h#mR%O$hQ$|$gR%Y$|_cOPdhw!n#t^UOPdhw!n#tQ!uoQ!}tQ#OuQ#PvQ#}#RR$a#hR$R#SQ!VZQ!d]Q#V!TQ#q!m[$P#S$Q$[$s$x%UQ$S#UQ$U#XS$j#q$lQ$o#{R%Q$kR$O#RQiPR#QwQ!c[Q!kaR#Y!VU!_[a!VQ!j`Q#c!^Q#g!`Q$^#dR$_#e",
    nodeNames: "\u26A0 Unit VariableName Comment StyleSheet RuleSet UniversalSelector TagSelector TagName NestingSelector ClassSelector ClassName PseudoClassSelector : :: PseudoClassName PseudoClassName ) ( ArgList ValueName ParenthesizedValue ColorLiteral NumberLiteral StringLiteral BinaryExpression BinOp CallExpression Callee CallLiteral CallTag ParenthesizedContent ] [ LineNames LineName , PseudoClassName ArgList IdSelector # IdName AttributeSelector AttributeName MatchOp ChildSelector ChildOp DescendantSelector SiblingSelector SiblingOp } { Block Declaration PropertyName Important ; ImportStatement AtKeyword import KeywordQuery FeatureQuery FeatureName BinaryQuery LogicOp UnaryQuery UnaryQueryOp ParenthesizedQuery SelectorQuery selector MediaStatement media CharsetStatement charset NamespaceStatement namespace NamespaceName KeyframesStatement keyframes KeyframeName KeyframeList KeyframeSelector KeyframeRangeName SupportsStatement supports AtRule Styles",
    maxTerm: 117,
    nodeProps: [
        [
            "isolate",
            -2,
            3,
            24,
            ""
        ],
        [
            "openedBy",
            17,
            "(",
            32,
            "[",
            50,
            "{"
        ],
        [
            "closedBy",
            18,
            ")",
            33,
            "]",
            51,
            "}"
        ]
    ],
    propSources: [
        $9c89bba9366b52a5$var$cssHighlighting
    ],
    skippedNodes: [
        0,
        3,
        87
    ],
    repeatNodeCount: 11,
    tokenData: "J^~R!^OX$}X^%u^p$}pq%uqr)Xrs.Rst/utu6duv$}vw7^wx7oxy9^yz9oz{9t{|:_|}?Q}!O?c!O!P@Q!P!Q@i!Q![Ab![!]B]!]!^CX!^!_$}!_!`Cj!`!aC{!a!b$}!b!cDw!c!}$}!}#OFa#O#P$}#P#QFr#Q#R6d#R#T$}#T#UGT#U#c$}#c#dHf#d#o$}#o#pH{#p#q6d#q#rI^#r#sIo#s#y$}#y#z%u#z$f$}$f$g%u$g#BY$}#BY#BZ%u#BZ$IS$}$IS$I_%u$I_$I|$}$I|$JO%u$JO$JT$}$JT$JU%u$JU$KV$}$KV$KW%u$KW&FU$}&FU&FV%u&FV;'S$};'S;=`JW<%lO$}`%QSOy%^z;'S%^;'S;=`%o<%lO%^`%cSo`Oy%^z;'S%^;'S;=`%o<%lO%^`%rP;=`<%l%^~%zh#Z~OX%^X^'f^p%^pq'fqy%^z#y%^#y#z'f#z$f%^$f$g'f$g#BY%^#BY#BZ'f#BZ$IS%^$IS$I_'f$I_$I|%^$I|$JO'f$JO$JT%^$JT$JU'f$JU$KV%^$KV$KW'f$KW&FU%^&FU&FV'f&FV;'S%^;'S;=`%o<%lO%^~'mh#Z~o`OX%^X^'f^p%^pq'fqy%^z#y%^#y#z'f#z$f%^$f$g'f$g#BY%^#BY#BZ'f#BZ$IS%^$IS$I_'f$I_$I|%^$I|$JO'f$JO$JT%^$JT$JU'f$JU$KV%^$KV$KW'f$KW&FU%^&FU&FV'f&FV;'S%^;'S;=`%o<%lO%^l)[UOy%^z#]%^#]#^)n#^;'S%^;'S;=`%o<%lO%^l)sUo`Oy%^z#a%^#a#b*V#b;'S%^;'S;=`%o<%lO%^l*[Uo`Oy%^z#d%^#d#e*n#e;'S%^;'S;=`%o<%lO%^l*sUo`Oy%^z#c%^#c#d+V#d;'S%^;'S;=`%o<%lO%^l+[Uo`Oy%^z#f%^#f#g+n#g;'S%^;'S;=`%o<%lO%^l+sUo`Oy%^z#h%^#h#i,V#i;'S%^;'S;=`%o<%lO%^l,[Uo`Oy%^z#T%^#T#U,n#U;'S%^;'S;=`%o<%lO%^l,sUo`Oy%^z#b%^#b#c-V#c;'S%^;'S;=`%o<%lO%^l-[Uo`Oy%^z#h%^#h#i-n#i;'S%^;'S;=`%o<%lO%^l-uS!X[o`Oy%^z;'S%^;'S;=`%o<%lO%^~.UWOY.RZr.Rrs.ns#O.R#O#P.s#P;'S.R;'S;=`/o<%lO.R~.sOh~~.vRO;'S.R;'S;=`/P;=`O.R~/SXOY.RZr.Rrs.ns#O.R#O#P.s#P;'S.R;'S;=`/o;=`<%l.R<%lO.R~/rP;=`<%l.Rn/zYxQOy%^z!Q%^!Q![0j![!c%^!c!i0j!i#T%^#T#Z0j#Z;'S%^;'S;=`%o<%lO%^l0oYo`Oy%^z!Q%^!Q![1_![!c%^!c!i1_!i#T%^#T#Z1_#Z;'S%^;'S;=`%o<%lO%^l1dYo`Oy%^z!Q%^!Q![2S![!c%^!c!i2S!i#T%^#T#Z2S#Z;'S%^;'S;=`%o<%lO%^l2ZYf[o`Oy%^z!Q%^!Q![2y![!c%^!c!i2y!i#T%^#T#Z2y#Z;'S%^;'S;=`%o<%lO%^l3QYf[o`Oy%^z!Q%^!Q![3p![!c%^!c!i3p!i#T%^#T#Z3p#Z;'S%^;'S;=`%o<%lO%^l3uYo`Oy%^z!Q%^!Q![4e![!c%^!c!i4e!i#T%^#T#Z4e#Z;'S%^;'S;=`%o<%lO%^l4lYf[o`Oy%^z!Q%^!Q![5[![!c%^!c!i5[!i#T%^#T#Z5[#Z;'S%^;'S;=`%o<%lO%^l5aYo`Oy%^z!Q%^!Q![6P![!c%^!c!i6P!i#T%^#T#Z6P#Z;'S%^;'S;=`%o<%lO%^l6WSf[o`Oy%^z;'S%^;'S;=`%o<%lO%^d6gUOy%^z!_%^!_!`6y!`;'S%^;'S;=`%o<%lO%^d7QS|So`Oy%^z;'S%^;'S;=`%o<%lO%^b7cSXQOy%^z;'S%^;'S;=`%o<%lO%^~7rWOY7oZw7owx.nx#O7o#O#P8[#P;'S7o;'S;=`9W<%lO7o~8_RO;'S7o;'S;=`8h;=`O7o~8kXOY7oZw7owx.nx#O7o#O#P8[#P;'S7o;'S;=`9W;=`<%l7o<%lO7o~9ZP;=`<%l7on9cSb^Oy%^z;'S%^;'S;=`%o<%lO%^~9tOa~n9{UUQjWOy%^z!_%^!_!`6y!`;'S%^;'S;=`%o<%lO%^n:fWjW!RQOy%^z!O%^!O!P;O!P!Q%^!Q![>T![;'S%^;'S;=`%o<%lO%^l;TUo`Oy%^z!Q%^!Q![;g![;'S%^;'S;=`%o<%lO%^l;nYo`#e[Oy%^z!Q%^!Q![;g![!g%^!g!h<^!h#X%^#X#Y<^#Y;'S%^;'S;=`%o<%lO%^l<cYo`Oy%^z{%^{|=R|}%^}!O=R!O!Q%^!Q![=j![;'S%^;'S;=`%o<%lO%^l=WUo`Oy%^z!Q%^!Q![=j![;'S%^;'S;=`%o<%lO%^l=qUo`#e[Oy%^z!Q%^!Q![=j![;'S%^;'S;=`%o<%lO%^l>[[o`#e[Oy%^z!O%^!O!P;g!P!Q%^!Q![>T![!g%^!g!h<^!h#X%^#X#Y<^#Y;'S%^;'S;=`%o<%lO%^n?VSt^Oy%^z;'S%^;'S;=`%o<%lO%^l?hWjWOy%^z!O%^!O!P;O!P!Q%^!Q![>T![;'S%^;'S;=`%o<%lO%^n@VU#bQOy%^z!Q%^!Q![;g![;'S%^;'S;=`%o<%lO%^~@nTjWOy%^z{@}{;'S%^;'S;=`%o<%lO%^~AUSo`#[~Oy%^z;'S%^;'S;=`%o<%lO%^lAg[#e[Oy%^z!O%^!O!P;g!P!Q%^!Q![>T![!g%^!g!h<^!h#X%^#X#Y<^#Y;'S%^;'S;=`%o<%lO%^bBbU]QOy%^z![%^![!]Bt!];'S%^;'S;=`%o<%lO%^bB{S^Qo`Oy%^z;'S%^;'S;=`%o<%lO%^nC^S!Y^Oy%^z;'S%^;'S;=`%o<%lO%^dCoS|SOy%^z;'S%^;'S;=`%o<%lO%^bDQU!OQOy%^z!`%^!`!aDd!a;'S%^;'S;=`%o<%lO%^bDkS!OQo`Oy%^z;'S%^;'S;=`%o<%lO%^bDzWOy%^z!c%^!c!}Ed!}#T%^#T#oEd#o;'S%^;'S;=`%o<%lO%^bEk[![Qo`Oy%^z}%^}!OEd!O!Q%^!Q![Ed![!c%^!c!}Ed!}#T%^#T#oEd#o;'S%^;'S;=`%o<%lO%^nFfSq^Oy%^z;'S%^;'S;=`%o<%lO%^nFwSp^Oy%^z;'S%^;'S;=`%o<%lO%^bGWUOy%^z#b%^#b#cGj#c;'S%^;'S;=`%o<%lO%^bGoUo`Oy%^z#W%^#W#XHR#X;'S%^;'S;=`%o<%lO%^bHYS!bQo`Oy%^z;'S%^;'S;=`%o<%lO%^bHiUOy%^z#f%^#f#gHR#g;'S%^;'S;=`%o<%lO%^fIQS!TUOy%^z;'S%^;'S;=`%o<%lO%^nIcS!S^Oy%^z;'S%^;'S;=`%o<%lO%^fItU!RQOy%^z!_%^!_!`6y!`;'S%^;'S;=`%o<%lO%^`JZP;=`<%l$}",
    tokenizers: [
        $9c89bba9366b52a5$var$descendant,
        $9c89bba9366b52a5$var$unitToken,
        $9c89bba9366b52a5$var$identifiers,
        1,
        2,
        3,
        4,
        new (0, $2sfCn.LocalTokenGroup)("m~RRYZ[z{a~~g~aO#^~~dP!P!Qg~lO#_~~", 28, 105)
    ],
    topRules: {
        "StyleSheet": [
            0,
            4
        ],
        "Styles": [
            1,
            86
        ]
    },
    specialized: [
        {
            term: 100,
            get: (value)=>$9c89bba9366b52a5$var$spec_callee[value] || -1
        },
        {
            term: 58,
            get: (value)=>$9c89bba9366b52a5$var$spec_AtKeyword[value] || -1
        },
        {
            term: 101,
            get: (value)=>$9c89bba9366b52a5$var$spec_identifier[value] || -1
        }
    ],
    tokenPrec: 1219
});
module.exports["parser"] = $9c89bba9366b52a5$export$8f49e4af10703ce3;

});

parcelRegister("iaLx3", function(module, exports) {

var $cPMnf = parcelRequire("cPMnf");


var $wK0D9 = parcelRequire("wK0D9");


var $evu44 = parcelRequire("evu44");


var $3e6dc = parcelRequire("3e6dc");


var $b2ZzE = parcelRequire("b2ZzE");


var $4lK5a = parcelRequire("4lK5a");

const $d3ae081389252cd8$var$Targets = [
    "_blank",
    "_self",
    "_top",
    "_parent"
];
const $d3ae081389252cd8$var$Charsets = [
    "ascii",
    "utf-8",
    "utf-16",
    "latin1",
    "latin1"
];
const $d3ae081389252cd8$var$Methods = [
    "get",
    "post",
    "put",
    "delete"
];
const $d3ae081389252cd8$var$Encs = [
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
];
const $d3ae081389252cd8$var$Bool = [
    "true",
    "false"
];
const $d3ae081389252cd8$var$S = {}; // Empty tag spec
const $d3ae081389252cd8$var$Tags = {
    a: {
        attrs: {
            href: null,
            ping: null,
            type: null,
            media: null,
            target: $d3ae081389252cd8$var$Targets,
            hreflang: null
        }
    },
    abbr: $d3ae081389252cd8$var$S,
    address: $d3ae081389252cd8$var$S,
    area: {
        attrs: {
            alt: null,
            coords: null,
            href: null,
            target: null,
            ping: null,
            media: null,
            hreflang: null,
            type: null,
            shape: [
                "default",
                "rect",
                "circle",
                "poly"
            ]
        }
    },
    article: $d3ae081389252cd8$var$S,
    aside: $d3ae081389252cd8$var$S,
    audio: {
        attrs: {
            src: null,
            mediagroup: null,
            crossorigin: [
                "anonymous",
                "use-credentials"
            ],
            preload: [
                "none",
                "metadata",
                "auto"
            ],
            autoplay: [
                "autoplay"
            ],
            loop: [
                "loop"
            ],
            controls: [
                "controls"
            ]
        }
    },
    b: $d3ae081389252cd8$var$S,
    base: {
        attrs: {
            href: null,
            target: $d3ae081389252cd8$var$Targets
        }
    },
    bdi: $d3ae081389252cd8$var$S,
    bdo: $d3ae081389252cd8$var$S,
    blockquote: {
        attrs: {
            cite: null
        }
    },
    body: $d3ae081389252cd8$var$S,
    br: $d3ae081389252cd8$var$S,
    button: {
        attrs: {
            form: null,
            formaction: null,
            name: null,
            value: null,
            autofocus: [
                "autofocus"
            ],
            disabled: [
                "autofocus"
            ],
            formenctype: $d3ae081389252cd8$var$Encs,
            formmethod: $d3ae081389252cd8$var$Methods,
            formnovalidate: [
                "novalidate"
            ],
            formtarget: $d3ae081389252cd8$var$Targets,
            type: [
                "submit",
                "reset",
                "button"
            ]
        }
    },
    canvas: {
        attrs: {
            width: null,
            height: null
        }
    },
    caption: $d3ae081389252cd8$var$S,
    center: $d3ae081389252cd8$var$S,
    cite: $d3ae081389252cd8$var$S,
    code: $d3ae081389252cd8$var$S,
    col: {
        attrs: {
            span: null
        }
    },
    colgroup: {
        attrs: {
            span: null
        }
    },
    command: {
        attrs: {
            type: [
                "command",
                "checkbox",
                "radio"
            ],
            label: null,
            icon: null,
            radiogroup: null,
            command: null,
            title: null,
            disabled: [
                "disabled"
            ],
            checked: [
                "checked"
            ]
        }
    },
    data: {
        attrs: {
            value: null
        }
    },
    datagrid: {
        attrs: {
            disabled: [
                "disabled"
            ],
            multiple: [
                "multiple"
            ]
        }
    },
    datalist: {
        attrs: {
            data: null
        }
    },
    dd: $d3ae081389252cd8$var$S,
    del: {
        attrs: {
            cite: null,
            datetime: null
        }
    },
    details: {
        attrs: {
            open: [
                "open"
            ]
        }
    },
    dfn: $d3ae081389252cd8$var$S,
    div: $d3ae081389252cd8$var$S,
    dl: $d3ae081389252cd8$var$S,
    dt: $d3ae081389252cd8$var$S,
    em: $d3ae081389252cd8$var$S,
    embed: {
        attrs: {
            src: null,
            type: null,
            width: null,
            height: null
        }
    },
    eventsource: {
        attrs: {
            src: null
        }
    },
    fieldset: {
        attrs: {
            disabled: [
                "disabled"
            ],
            form: null,
            name: null
        }
    },
    figcaption: $d3ae081389252cd8$var$S,
    figure: $d3ae081389252cd8$var$S,
    footer: $d3ae081389252cd8$var$S,
    form: {
        attrs: {
            action: null,
            name: null,
            "accept-charset": $d3ae081389252cd8$var$Charsets,
            autocomplete: [
                "on",
                "off"
            ],
            enctype: $d3ae081389252cd8$var$Encs,
            method: $d3ae081389252cd8$var$Methods,
            novalidate: [
                "novalidate"
            ],
            target: $d3ae081389252cd8$var$Targets
        }
    },
    h1: $d3ae081389252cd8$var$S,
    h2: $d3ae081389252cd8$var$S,
    h3: $d3ae081389252cd8$var$S,
    h4: $d3ae081389252cd8$var$S,
    h5: $d3ae081389252cd8$var$S,
    h6: $d3ae081389252cd8$var$S,
    head: {
        children: [
            "title",
            "base",
            "link",
            "style",
            "meta",
            "script",
            "noscript",
            "command"
        ]
    },
    header: $d3ae081389252cd8$var$S,
    hgroup: $d3ae081389252cd8$var$S,
    hr: $d3ae081389252cd8$var$S,
    html: {
        attrs: {
            manifest: null
        }
    },
    i: $d3ae081389252cd8$var$S,
    iframe: {
        attrs: {
            src: null,
            srcdoc: null,
            name: null,
            width: null,
            height: null,
            sandbox: [
                "allow-top-navigation",
                "allow-same-origin",
                "allow-forms",
                "allow-scripts"
            ],
            seamless: [
                "seamless"
            ]
        }
    },
    img: {
        attrs: {
            alt: null,
            src: null,
            ismap: null,
            usemap: null,
            width: null,
            height: null,
            crossorigin: [
                "anonymous",
                "use-credentials"
            ]
        }
    },
    input: {
        attrs: {
            alt: null,
            dirname: null,
            form: null,
            formaction: null,
            height: null,
            list: null,
            max: null,
            maxlength: null,
            min: null,
            name: null,
            pattern: null,
            placeholder: null,
            size: null,
            src: null,
            step: null,
            value: null,
            width: null,
            accept: [
                "audio/*",
                "video/*",
                "image/*"
            ],
            autocomplete: [
                "on",
                "off"
            ],
            autofocus: [
                "autofocus"
            ],
            checked: [
                "checked"
            ],
            disabled: [
                "disabled"
            ],
            formenctype: $d3ae081389252cd8$var$Encs,
            formmethod: $d3ae081389252cd8$var$Methods,
            formnovalidate: [
                "novalidate"
            ],
            formtarget: $d3ae081389252cd8$var$Targets,
            multiple: [
                "multiple"
            ],
            readonly: [
                "readonly"
            ],
            required: [
                "required"
            ],
            type: [
                "hidden",
                "text",
                "search",
                "tel",
                "url",
                "email",
                "password",
                "datetime",
                "date",
                "month",
                "week",
                "time",
                "datetime-local",
                "number",
                "range",
                "color",
                "checkbox",
                "radio",
                "file",
                "submit",
                "image",
                "reset",
                "button"
            ]
        }
    },
    ins: {
        attrs: {
            cite: null,
            datetime: null
        }
    },
    kbd: $d3ae081389252cd8$var$S,
    keygen: {
        attrs: {
            challenge: null,
            form: null,
            name: null,
            autofocus: [
                "autofocus"
            ],
            disabled: [
                "disabled"
            ],
            keytype: [
                "RSA"
            ]
        }
    },
    label: {
        attrs: {
            for: null,
            form: null
        }
    },
    legend: $d3ae081389252cd8$var$S,
    li: {
        attrs: {
            value: null
        }
    },
    link: {
        attrs: {
            href: null,
            type: null,
            hreflang: null,
            media: null,
            sizes: [
                "all",
                "16x16",
                "16x16 32x32",
                "16x16 32x32 64x64"
            ]
        }
    },
    map: {
        attrs: {
            name: null
        }
    },
    mark: $d3ae081389252cd8$var$S,
    menu: {
        attrs: {
            label: null,
            type: [
                "list",
                "context",
                "toolbar"
            ]
        }
    },
    meta: {
        attrs: {
            content: null,
            charset: $d3ae081389252cd8$var$Charsets,
            name: [
                "viewport",
                "application-name",
                "author",
                "description",
                "generator",
                "keywords"
            ],
            "http-equiv": [
                "content-language",
                "content-type",
                "default-style",
                "refresh"
            ]
        }
    },
    meter: {
        attrs: {
            value: null,
            min: null,
            low: null,
            high: null,
            max: null,
            optimum: null
        }
    },
    nav: $d3ae081389252cd8$var$S,
    noscript: $d3ae081389252cd8$var$S,
    object: {
        attrs: {
            data: null,
            type: null,
            name: null,
            usemap: null,
            form: null,
            width: null,
            height: null,
            typemustmatch: [
                "typemustmatch"
            ]
        }
    },
    ol: {
        attrs: {
            reversed: [
                "reversed"
            ],
            start: null,
            type: [
                "1",
                "a",
                "A",
                "i",
                "I"
            ]
        },
        children: [
            "li",
            "script",
            "template",
            "ul",
            "ol"
        ]
    },
    optgroup: {
        attrs: {
            disabled: [
                "disabled"
            ],
            label: null
        }
    },
    option: {
        attrs: {
            disabled: [
                "disabled"
            ],
            label: null,
            selected: [
                "selected"
            ],
            value: null
        }
    },
    output: {
        attrs: {
            for: null,
            form: null,
            name: null
        }
    },
    p: $d3ae081389252cd8$var$S,
    param: {
        attrs: {
            name: null,
            value: null
        }
    },
    pre: $d3ae081389252cd8$var$S,
    progress: {
        attrs: {
            value: null,
            max: null
        }
    },
    q: {
        attrs: {
            cite: null
        }
    },
    rp: $d3ae081389252cd8$var$S,
    rt: $d3ae081389252cd8$var$S,
    ruby: $d3ae081389252cd8$var$S,
    samp: $d3ae081389252cd8$var$S,
    script: {
        attrs: {
            type: [
                "text/javascript"
            ],
            src: null,
            async: [
                "async"
            ],
            defer: [
                "defer"
            ],
            charset: $d3ae081389252cd8$var$Charsets
        }
    },
    section: $d3ae081389252cd8$var$S,
    select: {
        attrs: {
            form: null,
            name: null,
            size: null,
            autofocus: [
                "autofocus"
            ],
            disabled: [
                "disabled"
            ],
            multiple: [
                "multiple"
            ]
        }
    },
    slot: {
        attrs: {
            name: null
        }
    },
    small: $d3ae081389252cd8$var$S,
    source: {
        attrs: {
            src: null,
            type: null,
            media: null
        }
    },
    span: $d3ae081389252cd8$var$S,
    strong: $d3ae081389252cd8$var$S,
    style: {
        attrs: {
            type: [
                "text/css"
            ],
            media: null,
            scoped: null
        }
    },
    sub: $d3ae081389252cd8$var$S,
    summary: $d3ae081389252cd8$var$S,
    sup: $d3ae081389252cd8$var$S,
    table: $d3ae081389252cd8$var$S,
    tbody: $d3ae081389252cd8$var$S,
    td: {
        attrs: {
            colspan: null,
            rowspan: null,
            headers: null
        }
    },
    template: $d3ae081389252cd8$var$S,
    textarea: {
        attrs: {
            dirname: null,
            form: null,
            maxlength: null,
            name: null,
            placeholder: null,
            rows: null,
            cols: null,
            autofocus: [
                "autofocus"
            ],
            disabled: [
                "disabled"
            ],
            readonly: [
                "readonly"
            ],
            required: [
                "required"
            ],
            wrap: [
                "soft",
                "hard"
            ]
        }
    },
    tfoot: $d3ae081389252cd8$var$S,
    th: {
        attrs: {
            colspan: null,
            rowspan: null,
            headers: null,
            scope: [
                "row",
                "col",
                "rowgroup",
                "colgroup"
            ]
        }
    },
    thead: $d3ae081389252cd8$var$S,
    time: {
        attrs: {
            datetime: null
        }
    },
    title: $d3ae081389252cd8$var$S,
    tr: $d3ae081389252cd8$var$S,
    track: {
        attrs: {
            src: null,
            label: null,
            default: null,
            kind: [
                "subtitles",
                "captions",
                "descriptions",
                "chapters",
                "metadata"
            ],
            srclang: null
        }
    },
    ul: {
        children: [
            "li",
            "script",
            "template",
            "ul",
            "ol"
        ]
    },
    var: $d3ae081389252cd8$var$S,
    video: {
        attrs: {
            src: null,
            poster: null,
            width: null,
            height: null,
            crossorigin: [
                "anonymous",
                "use-credentials"
            ],
            preload: [
                "auto",
                "metadata",
                "none"
            ],
            autoplay: [
                "autoplay"
            ],
            mediagroup: [
                "movie"
            ],
            muted: [
                "muted"
            ],
            controls: [
                "controls"
            ]
        }
    },
    wbr: $d3ae081389252cd8$var$S
};
const $d3ae081389252cd8$var$GlobalAttrs = {
    accesskey: null,
    class: null,
    contenteditable: $d3ae081389252cd8$var$Bool,
    contextmenu: null,
    dir: [
        "ltr",
        "rtl",
        "auto"
    ],
    draggable: [
        "true",
        "false",
        "auto"
    ],
    dropzone: [
        "copy",
        "move",
        "link",
        "string:",
        "file:"
    ],
    hidden: [
        "hidden"
    ],
    id: null,
    inert: [
        "inert"
    ],
    itemid: null,
    itemprop: null,
    itemref: null,
    itemscope: [
        "itemscope"
    ],
    itemtype: null,
    lang: [
        "ar",
        "bn",
        "de",
        "en-GB",
        "en-US",
        "es",
        "fr",
        "hi",
        "id",
        "ja",
        "pa",
        "pt",
        "ru",
        "tr",
        "zh"
    ],
    spellcheck: $d3ae081389252cd8$var$Bool,
    autocorrect: $d3ae081389252cd8$var$Bool,
    autocapitalize: $d3ae081389252cd8$var$Bool,
    style: null,
    tabindex: null,
    title: null,
    translate: [
        "yes",
        "no"
    ],
    rel: [
        "stylesheet",
        "alternate",
        "author",
        "bookmark",
        "help",
        "license",
        "next",
        "nofollow",
        "noreferrer",
        "prefetch",
        "prev",
        "search",
        "tag"
    ],
    role: /*@__PURE__*/ "alert application article banner button cell checkbox complementary contentinfo dialog document feed figure form grid gridcell heading img list listbox listitem main navigation region row rowgroup search switch tab table tabpanel textbox timer".split(" "),
    "aria-activedescendant": null,
    "aria-atomic": $d3ae081389252cd8$var$Bool,
    "aria-autocomplete": [
        "inline",
        "list",
        "both",
        "none"
    ],
    "aria-busy": $d3ae081389252cd8$var$Bool,
    "aria-checked": [
        "true",
        "false",
        "mixed",
        "undefined"
    ],
    "aria-controls": null,
    "aria-describedby": null,
    "aria-disabled": $d3ae081389252cd8$var$Bool,
    "aria-dropeffect": null,
    "aria-expanded": [
        "true",
        "false",
        "undefined"
    ],
    "aria-flowto": null,
    "aria-grabbed": [
        "true",
        "false",
        "undefined"
    ],
    "aria-haspopup": $d3ae081389252cd8$var$Bool,
    "aria-hidden": $d3ae081389252cd8$var$Bool,
    "aria-invalid": [
        "true",
        "false",
        "grammar",
        "spelling"
    ],
    "aria-label": null,
    "aria-labelledby": null,
    "aria-level": null,
    "aria-live": [
        "off",
        "polite",
        "assertive"
    ],
    "aria-multiline": $d3ae081389252cd8$var$Bool,
    "aria-multiselectable": $d3ae081389252cd8$var$Bool,
    "aria-owns": null,
    "aria-posinset": null,
    "aria-pressed": [
        "true",
        "false",
        "mixed",
        "undefined"
    ],
    "aria-readonly": $d3ae081389252cd8$var$Bool,
    "aria-relevant": null,
    "aria-required": $d3ae081389252cd8$var$Bool,
    "aria-selected": [
        "true",
        "false",
        "undefined"
    ],
    "aria-setsize": null,
    "aria-sort": [
        "ascending",
        "descending",
        "none",
        "other"
    ],
    "aria-valuemax": null,
    "aria-valuemin": null,
    "aria-valuenow": null,
    "aria-valuetext": null
};
const $d3ae081389252cd8$var$eventAttributes = /*@__PURE__*/ "beforeunload copy cut dragstart dragover dragleave dragenter dragend drag paste focus blur change click load mousedown mouseenter mouseleave mouseup keydown keyup resize scroll unload".split(" ").map((n)=>"on" + n);
for (let a of $d3ae081389252cd8$var$eventAttributes)$d3ae081389252cd8$var$GlobalAttrs[a] = null;
class $d3ae081389252cd8$var$Schema {
    constructor(extraTags, extraAttrs){
        this.tags = Object.assign(Object.assign({}, $d3ae081389252cd8$var$Tags), extraTags);
        this.globalAttrs = Object.assign(Object.assign({}, $d3ae081389252cd8$var$GlobalAttrs), extraAttrs);
        this.allTags = Object.keys(this.tags);
        this.globalAttrNames = Object.keys(this.globalAttrs);
    }
}
$d3ae081389252cd8$var$Schema.default = /*@__PURE__*/ new $d3ae081389252cd8$var$Schema;
function $d3ae081389252cd8$var$elementName(doc, tree, max = doc.length) {
    if (!tree) return "";
    let tag = tree.firstChild;
    let name = tag && tag.getChild("TagName");
    return name ? doc.sliceString(name.from, Math.min(name.to, max)) : "";
}
function $d3ae081389252cd8$var$findParentElement(tree, skip = false) {
    for(; tree; tree = tree.parent)if (tree.name == "Element") {
        if (skip) skip = false;
        else return tree;
    }
    return null;
}
function $d3ae081389252cd8$var$allowedChildren(doc, tree, schema) {
    let parentInfo = schema.tags[$d3ae081389252cd8$var$elementName(doc, $d3ae081389252cd8$var$findParentElement(tree))];
    return (parentInfo === null || parentInfo === void 0 ? void 0 : parentInfo.children) || schema.allTags;
}
function $d3ae081389252cd8$var$openTags(doc, tree) {
    let open = [];
    for(let parent = $d3ae081389252cd8$var$findParentElement(tree); parent && !parent.type.isTop; parent = $d3ae081389252cd8$var$findParentElement(parent.parent)){
        let tagName = $d3ae081389252cd8$var$elementName(doc, parent);
        if (tagName && parent.lastChild.name == "CloseTag") break;
        if (tagName && open.indexOf(tagName) < 0 && (tree.name == "EndTag" || tree.from >= parent.firstChild.to)) open.push(tagName);
    }
    return open;
}
const $d3ae081389252cd8$var$identifier = /^[:\-\.\w\u00b7-\uffff]*$/;
function $d3ae081389252cd8$var$completeTag(state, schema, tree, from, to) {
    let end = /\s*>/.test(state.sliceDoc(to, to + 5)) ? "" : ">";
    let parent = $d3ae081389252cd8$var$findParentElement(tree, true);
    return {
        from: from,
        to: to,
        options: $d3ae081389252cd8$var$allowedChildren(state.doc, parent, schema).map((tagName)=>({
                label: tagName,
                type: "type"
            })).concat($d3ae081389252cd8$var$openTags(state.doc, tree).map((tag, i)=>({
                label: "/" + tag,
                apply: "/" + tag + end,
                type: "type",
                boost: 99 - i
            }))),
        validFor: /^\/?[:\-\.\w\u00b7-\uffff]*$/
    };
}
function $d3ae081389252cd8$var$completeCloseTag(state, tree, from, to) {
    let end = /\s*>/.test(state.sliceDoc(to, to + 5)) ? "" : ">";
    return {
        from: from,
        to: to,
        options: $d3ae081389252cd8$var$openTags(state.doc, tree).map((tag, i)=>({
                label: tag,
                apply: tag + end,
                type: "type",
                boost: 99 - i
            })),
        validFor: $d3ae081389252cd8$var$identifier
    };
}
function $d3ae081389252cd8$var$completeStartTag(state, schema, tree, pos) {
    let options = [], level = 0;
    for (let tagName of $d3ae081389252cd8$var$allowedChildren(state.doc, tree, schema))options.push({
        label: "<" + tagName,
        type: "type"
    });
    for (let open of $d3ae081389252cd8$var$openTags(state.doc, tree))options.push({
        label: "</" + open + ">",
        type: "type",
        boost: 99 - level++
    });
    return {
        from: pos,
        to: pos,
        options: options,
        validFor: /^<\/?[:\-\.\w\u00b7-\uffff]*$/
    };
}
function $d3ae081389252cd8$var$completeAttrName(state, schema, tree, from, to) {
    let elt = $d3ae081389252cd8$var$findParentElement(tree), info = elt ? schema.tags[$d3ae081389252cd8$var$elementName(state.doc, elt)] : null;
    let localAttrs = info && info.attrs ? Object.keys(info.attrs) : [];
    let names = info && info.globalAttrs === false ? localAttrs : localAttrs.length ? localAttrs.concat(schema.globalAttrNames) : schema.globalAttrNames;
    return {
        from: from,
        to: to,
        options: names.map((attrName)=>({
                label: attrName,
                type: "property"
            })),
        validFor: $d3ae081389252cd8$var$identifier
    };
}
function $d3ae081389252cd8$var$completeAttrValue(state, schema, tree, from, to) {
    var _a;
    let nameNode = (_a = tree.parent) === null || _a === void 0 ? void 0 : _a.getChild("AttributeName");
    let options = [], token = undefined;
    if (nameNode) {
        let attrName = state.sliceDoc(nameNode.from, nameNode.to);
        let attrs = schema.globalAttrs[attrName];
        if (!attrs) {
            let elt = $d3ae081389252cd8$var$findParentElement(tree), info = elt ? schema.tags[$d3ae081389252cd8$var$elementName(state.doc, elt)] : null;
            attrs = (info === null || info === void 0 ? void 0 : info.attrs) && info.attrs[attrName];
        }
        if (attrs) {
            let base = state.sliceDoc(from, to).toLowerCase(), quoteStart = '"', quoteEnd = '"';
            if (/^['"]/.test(base)) {
                token = base[0] == '"' ? /^[^"]*$/ : /^[^']*$/;
                quoteStart = "";
                quoteEnd = state.sliceDoc(to, to + 1) == base[0] ? "" : base[0];
                base = base.slice(1);
                from++;
            } else token = /^[^\s<>='"]*$/;
            for (let value of attrs)options.push({
                label: value,
                apply: quoteStart + value + quoteEnd,
                type: "constant"
            });
        }
    }
    return {
        from: from,
        to: to,
        options: options,
        validFor: token
    };
}
function $d3ae081389252cd8$var$htmlCompletionFor(schema, context) {
    let { state: state, pos: pos } = context, tree = (0, $4lK5a.syntaxTree)(state).resolveInner(pos, -1), around = tree.resolve(pos);
    for(let scan = pos, before; around == tree && (before = tree.childBefore(scan));){
        let last = before.lastChild;
        if (!last || !last.type.isError || last.from < last.to) break;
        around = tree = before;
        scan = last.from;
    }
    if (tree.name == "TagName") return tree.parent && /CloseTag$/.test(tree.parent.name) ? $d3ae081389252cd8$var$completeCloseTag(state, tree, tree.from, pos) : $d3ae081389252cd8$var$completeTag(state, schema, tree, tree.from, pos);
    else if (tree.name == "StartTag") return $d3ae081389252cd8$var$completeTag(state, schema, tree, pos, pos);
    else if (tree.name == "StartCloseTag" || tree.name == "IncompleteCloseTag") return $d3ae081389252cd8$var$completeCloseTag(state, tree, pos, pos);
    else if (tree.name == "OpenTag" || tree.name == "SelfClosingTag" || tree.name == "AttributeName") return $d3ae081389252cd8$var$completeAttrName(state, schema, tree, tree.name == "AttributeName" ? tree.from : pos, pos);
    else if (tree.name == "Is" || tree.name == "AttributeValue" || tree.name == "UnquotedAttributeValue") return $d3ae081389252cd8$var$completeAttrValue(state, schema, tree, tree.name == "Is" ? pos : tree.from, pos);
    else if (context.explicit && (around.name == "Element" || around.name == "Text" || around.name == "Document")) return $d3ae081389252cd8$var$completeStartTag(state, schema, tree, pos);
    else return null;
}
/**
HTML tag completion. Opens and closes tags and attributes in a
context-aware way.
*/ function $d3ae081389252cd8$export$25345412b4ded248(context) {
    return $d3ae081389252cd8$var$htmlCompletionFor($d3ae081389252cd8$var$Schema.default, context);
}
/**
Create a completion source for HTML extended with additional tags
or attributes.
*/ function $d3ae081389252cd8$export$2bf1c75d01fadf84(config) {
    let { extraTags: extraTags, extraGlobalAttributes: extraAttrs } = config;
    let schema = extraAttrs || extraTags ? new $d3ae081389252cd8$var$Schema(extraTags, extraAttrs) : $d3ae081389252cd8$var$Schema.default;
    return (context)=>$d3ae081389252cd8$var$htmlCompletionFor(schema, context);
}
const $d3ae081389252cd8$var$jsonParser = /*@__PURE__*/ (0, $evu44.javascriptLanguage).parser.configure({
    top: "SingleExpression"
});
const $d3ae081389252cd8$var$defaultNesting = [
    {
        tag: "script",
        attrs: (attrs)=>attrs.type == "text/typescript" || attrs.lang == "ts",
        parser: (0, $evu44.typescriptLanguage).parser
    },
    {
        tag: "script",
        attrs: (attrs)=>attrs.type == "text/babel" || attrs.type == "text/jsx",
        parser: (0, $evu44.jsxLanguage).parser
    },
    {
        tag: "script",
        attrs: (attrs)=>attrs.type == "text/typescript-jsx",
        parser: (0, $evu44.tsxLanguage).parser
    },
    {
        tag: "script",
        attrs (attrs) {
            return /^(importmap|speculationrules|application\/(.+\+)?json)$/i.test(attrs.type);
        },
        parser: $d3ae081389252cd8$var$jsonParser
    },
    {
        tag: "script",
        attrs (attrs) {
            return !attrs.type || /^(?:text|application)\/(?:x-)?(?:java|ecma)script$|^module$|^$/i.test(attrs.type);
        },
        parser: (0, $evu44.javascriptLanguage).parser
    },
    {
        tag: "style",
        attrs (attrs) {
            return (!attrs.lang || attrs.lang == "css") && (!attrs.type || /^(text\/)?(x-)?(stylesheet|css)$/i.test(attrs.type));
        },
        parser: (0, $wK0D9.cssLanguage).parser
    }
];
const $d3ae081389252cd8$var$defaultAttrs = /*@__PURE__*/ [
    {
        name: "style",
        parser: /*@__PURE__*/ (0, $wK0D9.cssLanguage).parser.configure({
            top: "Styles"
        })
    }
].concat(/*@__PURE__*/ $d3ae081389252cd8$var$eventAttributes.map((name)=>({
        name: name,
        parser: (0, $evu44.javascriptLanguage).parser
    })));
/**
A language provider based on the [Lezer HTML
parser](https://github.com/lezer-parser/html), extended with the
JavaScript and CSS parsers to parse the content of `<script>` and
`<style>` tags.
*/ const $d3ae081389252cd8$export$e8e41fa2fad353cb = /*@__PURE__*/ (0, $4lK5a.LRLanguage).define({
    name: "html",
    parser: /*@__PURE__*/ (0, $cPMnf.parser).configure({
        props: [
            /*@__PURE__*/ (0, $4lK5a.indentNodeProp).add({
                Element (context) {
                    let after = /^(\s*)(<\/)?/.exec(context.textAfter);
                    if (context.node.to <= context.pos + after[0].length) return context.continue();
                    return context.lineIndent(context.node.from) + (after[2] ? 0 : context.unit);
                },
                "OpenTag CloseTag SelfClosingTag" (context) {
                    return context.column(context.node.from) + context.unit;
                },
                Document (context) {
                    if (context.pos + /\s*/.exec(context.textAfter)[0].length < context.node.to) return context.continue();
                    let endElt = null, close;
                    for(let cur = context.node;;){
                        let last = cur.lastChild;
                        if (!last || last.name != "Element" || last.to != cur.to) break;
                        endElt = cur = last;
                    }
                    if (endElt && !((close = endElt.lastChild) && (close.name == "CloseTag" || close.name == "SelfClosingTag"))) return context.lineIndent(endElt.from) + context.unit;
                    return null;
                }
            }),
            /*@__PURE__*/ (0, $4lK5a.foldNodeProp).add({
                Element (node) {
                    let first = node.firstChild, last = node.lastChild;
                    if (!first || first.name != "OpenTag") return null;
                    return {
                        from: first.to,
                        to: last.name == "CloseTag" ? last.from : node.to
                    };
                }
            }),
            /*@__PURE__*/ (0, $4lK5a.bracketMatchingHandle).add({
                "OpenTag CloseTag": (node)=>node.getChild("TagName")
            })
        ]
    }),
    languageData: {
        commentTokens: {
            block: {
                open: "<!--",
                close: "-->"
            }
        },
        indentOnInput: /^\s*<\/\w+\W$/,
        wordChars: "-._"
    }
});
/**
A language provider based on the [Lezer HTML
parser](https://github.com/lezer-parser/html), extended with the
JavaScript and CSS parsers to parse the content of `<script>` and
`<style>` tags.
*/ const $d3ae081389252cd8$export$76e66adcf103f9a2 = /*@__PURE__*/ $d3ae081389252cd8$export$e8e41fa2fad353cb.configure({
    wrap: /*@__PURE__*/ (0, $cPMnf.configureNesting)($d3ae081389252cd8$var$defaultNesting, $d3ae081389252cd8$var$defaultAttrs)
});
/**
Language support for HTML, including
[`htmlCompletion`](https://codemirror.net/6/docs/ref/#lang-html.htmlCompletion) and JavaScript and
CSS support extensions.
*/ function $d3ae081389252cd8$export$c0bb0b647f701bb5(config = {}) {
    let dialect = "", wrap;
    if (config.matchClosingTags === false) dialect = "noMatch";
    if (config.selfClosingTags === true) dialect = (dialect ? dialect + " " : "") + "selfClosing";
    if (config.nestedLanguages && config.nestedLanguages.length || config.nestedAttributes && config.nestedAttributes.length) wrap = (0, $cPMnf.configureNesting)((config.nestedLanguages || []).concat($d3ae081389252cd8$var$defaultNesting), (config.nestedAttributes || []).concat($d3ae081389252cd8$var$defaultAttrs));
    let lang = wrap ? $d3ae081389252cd8$export$e8e41fa2fad353cb.configure({
        wrap: wrap,
        dialect: dialect
    }) : dialect ? $d3ae081389252cd8$export$76e66adcf103f9a2.configure({
        dialect: dialect
    }) : $d3ae081389252cd8$export$76e66adcf103f9a2;
    return new (0, $4lK5a.LanguageSupport)(lang, [
        $d3ae081389252cd8$export$76e66adcf103f9a2.data.of({
            autocomplete: $d3ae081389252cd8$export$2bf1c75d01fadf84(config)
        }),
        config.autoCloseTags !== false ? $d3ae081389252cd8$export$f1d931274ca0e1f1 : [],
        (0, $evu44.javascript)().support,
        (0, $wK0D9.css)().support
    ]);
}
const $d3ae081389252cd8$var$selfClosers = /*@__PURE__*/ new Set(/*@__PURE__*/ "area base br col command embed frame hr img input keygen link meta param source track wbr menuitem".split(" "));
/**
Extension that will automatically insert close tags when a `>` or
`/` is typed.
*/ const $d3ae081389252cd8$export$f1d931274ca0e1f1 = /*@__PURE__*/ (0, $3e6dc.EditorView).inputHandler.of((view, from, to, text, insertTransaction)=>{
    if (view.composing || view.state.readOnly || from != to || text != ">" && text != "/" || !$d3ae081389252cd8$export$76e66adcf103f9a2.isActiveAt(view.state, from, -1)) return false;
    let base = insertTransaction(), { state: state } = base;
    let closeTags = state.changeByRange((range)=>{
        var _a, _b, _c;
        let didType = state.doc.sliceString(range.from - 1, range.to) == text;
        let { head: head } = range, after = (0, $4lK5a.syntaxTree)(state).resolveInner(head, -1), name;
        if (didType && text == ">" && after.name == "EndTag") {
            let tag = after.parent;
            if (((_b = (_a = tag.parent) === null || _a === void 0 ? void 0 : _a.lastChild) === null || _b === void 0 ? void 0 : _b.name) != "CloseTag" && (name = $d3ae081389252cd8$var$elementName(state.doc, tag.parent, head)) && !$d3ae081389252cd8$var$selfClosers.has(name)) {
                let to = head + (state.doc.sliceString(head, head + 1) === ">" ? 1 : 0);
                let insert = `</${name}>`;
                return {
                    range: range,
                    changes: {
                        from: head,
                        to: to,
                        insert: insert
                    }
                };
            }
        } else if (didType && text == "/" && after.name == "IncompleteCloseTag") {
            let tag = after.parent;
            if (after.from == head - 2 && ((_c = tag.lastChild) === null || _c === void 0 ? void 0 : _c.name) != "CloseTag" && (name = $d3ae081389252cd8$var$elementName(state.doc, tag, head)) && !$d3ae081389252cd8$var$selfClosers.has(name)) {
                let to = head + (state.doc.sliceString(head, head + 1) === ">" ? 1 : 0);
                let insert = `${name}>`;
                return {
                    range: (0, $b2ZzE.EditorSelection).cursor(head + insert.length, -1),
                    changes: {
                        from: head,
                        to: to,
                        insert: insert
                    }
                };
            }
        }
        return {
            range: range
        };
    });
    if (closeTags.changes.empty) return false;
    view.dispatch([
        base,
        state.update(closeTags, {
            userEvent: "input.complete",
            scrollIntoView: true
        })
    ]);
    return true;
});
module.exports["htmlCompletionSource"] = $d3ae081389252cd8$export$25345412b4ded248;
module.exports["htmlLanguage"] = $d3ae081389252cd8$export$76e66adcf103f9a2;
module.exports["html"] = $d3ae081389252cd8$export$c0bb0b647f701bb5;

});

parcelRegister("cPMnf", function(module, exports) {

var $2sfCn = parcelRequire("2sfCn");


var $lhXhg = parcelRequire("lhXhg");


var $uXNGm = parcelRequire("uXNGm");

// This file was generated by lezer-generator. You probably shouldn't edit it.
const $957fc58a50ba6580$var$scriptText = 54, $957fc58a50ba6580$var$StartCloseScriptTag = 1, $957fc58a50ba6580$var$styleText = 55, $957fc58a50ba6580$var$StartCloseStyleTag = 2, $957fc58a50ba6580$var$textareaText = 56, $957fc58a50ba6580$var$StartCloseTextareaTag = 3, $957fc58a50ba6580$var$EndTag = 4, $957fc58a50ba6580$var$SelfClosingEndTag = 5, $957fc58a50ba6580$var$StartTag = 6, $957fc58a50ba6580$var$StartScriptTag = 7, $957fc58a50ba6580$var$StartStyleTag = 8, $957fc58a50ba6580$var$StartTextareaTag = 9, $957fc58a50ba6580$var$StartSelfClosingTag = 10, $957fc58a50ba6580$var$StartCloseTag = 11, $957fc58a50ba6580$var$NoMatchStartCloseTag = 12, $957fc58a50ba6580$var$MismatchedStartCloseTag = 13, $957fc58a50ba6580$var$missingCloseTag = 57, $957fc58a50ba6580$var$IncompleteCloseTag = 14, $957fc58a50ba6580$var$commentContent$1 = 58, $957fc58a50ba6580$var$Element = 20, $957fc58a50ba6580$var$TagName = 22, $957fc58a50ba6580$var$Attribute = 23, $957fc58a50ba6580$var$AttributeName = 24, $957fc58a50ba6580$var$AttributeValue = 26, $957fc58a50ba6580$var$UnquotedAttributeValue = 27, $957fc58a50ba6580$var$ScriptText = 28, $957fc58a50ba6580$var$StyleText = 31, $957fc58a50ba6580$var$TextareaText = 34, $957fc58a50ba6580$var$OpenTag = 36, $957fc58a50ba6580$var$CloseTag = 37, $957fc58a50ba6580$var$Dialect_noMatch = 0, $957fc58a50ba6580$var$Dialect_selfClosing = 1;
/* Hand-written tokenizers for HTML. */ const $957fc58a50ba6580$var$selfClosers = {
    area: true,
    base: true,
    br: true,
    col: true,
    command: true,
    embed: true,
    frame: true,
    hr: true,
    img: true,
    input: true,
    keygen: true,
    link: true,
    meta: true,
    param: true,
    source: true,
    track: true,
    wbr: true,
    menuitem: true
};
const $957fc58a50ba6580$var$implicitlyClosed = {
    dd: true,
    li: true,
    optgroup: true,
    option: true,
    p: true,
    rp: true,
    rt: true,
    tbody: true,
    td: true,
    tfoot: true,
    th: true,
    tr: true
};
const $957fc58a50ba6580$var$closeOnOpen = {
    dd: {
        dd: true,
        dt: true
    },
    dt: {
        dd: true,
        dt: true
    },
    li: {
        li: true
    },
    option: {
        option: true,
        optgroup: true
    },
    optgroup: {
        optgroup: true
    },
    p: {
        address: true,
        article: true,
        aside: true,
        blockquote: true,
        dir: true,
        div: true,
        dl: true,
        fieldset: true,
        footer: true,
        form: true,
        h1: true,
        h2: true,
        h3: true,
        h4: true,
        h5: true,
        h6: true,
        header: true,
        hgroup: true,
        hr: true,
        menu: true,
        nav: true,
        ol: true,
        p: true,
        pre: true,
        section: true,
        table: true,
        ul: true
    },
    rp: {
        rp: true,
        rt: true
    },
    rt: {
        rp: true,
        rt: true
    },
    tbody: {
        tbody: true,
        tfoot: true
    },
    td: {
        td: true,
        th: true
    },
    tfoot: {
        tbody: true
    },
    th: {
        td: true,
        th: true
    },
    thead: {
        tbody: true,
        tfoot: true
    },
    tr: {
        tr: true
    }
};
function $957fc58a50ba6580$var$nameChar(ch) {
    return ch == 45 || ch == 46 || ch == 58 || ch >= 65 && ch <= 90 || ch == 95 || ch >= 97 && ch <= 122 || ch >= 161;
}
function $957fc58a50ba6580$var$isSpace(ch) {
    return ch == 9 || ch == 10 || ch == 13 || ch == 32;
}
let $957fc58a50ba6580$var$cachedName = null, $957fc58a50ba6580$var$cachedInput = null, $957fc58a50ba6580$var$cachedPos = 0;
function $957fc58a50ba6580$var$tagNameAfter(input, offset) {
    let pos = input.pos + offset;
    if ($957fc58a50ba6580$var$cachedPos == pos && $957fc58a50ba6580$var$cachedInput == input) return $957fc58a50ba6580$var$cachedName;
    let next = input.peek(offset);
    while($957fc58a50ba6580$var$isSpace(next))next = input.peek(++offset);
    let name = "";
    for(;;){
        if (!$957fc58a50ba6580$var$nameChar(next)) break;
        name += String.fromCharCode(next);
        next = input.peek(++offset);
    }
    // Undefined to signal there's a <? or <!, null for just missing
    $957fc58a50ba6580$var$cachedInput = input;
    $957fc58a50ba6580$var$cachedPos = pos;
    return $957fc58a50ba6580$var$cachedName = name ? name.toLowerCase() : next == $957fc58a50ba6580$var$question || next == $957fc58a50ba6580$var$bang ? undefined : null;
}
const $957fc58a50ba6580$var$lessThan = 60, $957fc58a50ba6580$var$greaterThan = 62, $957fc58a50ba6580$var$slash = 47, $957fc58a50ba6580$var$question = 63, $957fc58a50ba6580$var$bang = 33, $957fc58a50ba6580$var$dash = 45;
function $957fc58a50ba6580$var$ElementContext(name, parent) {
    this.name = name;
    this.parent = parent;
}
const $957fc58a50ba6580$var$startTagTerms = [
    $957fc58a50ba6580$var$StartTag,
    $957fc58a50ba6580$var$StartSelfClosingTag,
    $957fc58a50ba6580$var$StartScriptTag,
    $957fc58a50ba6580$var$StartStyleTag,
    $957fc58a50ba6580$var$StartTextareaTag
];
const $957fc58a50ba6580$var$elementContext = new (0, $2sfCn.ContextTracker)({
    start: null,
    shift (context, term, stack, input) {
        return $957fc58a50ba6580$var$startTagTerms.indexOf(term) > -1 ? new $957fc58a50ba6580$var$ElementContext($957fc58a50ba6580$var$tagNameAfter(input, 1) || "", context) : context;
    },
    reduce (context, term) {
        return term == $957fc58a50ba6580$var$Element && context ? context.parent : context;
    },
    reuse (context, node, stack, input) {
        let type = node.type.id;
        return type == $957fc58a50ba6580$var$StartTag || type == $957fc58a50ba6580$var$OpenTag ? new $957fc58a50ba6580$var$ElementContext($957fc58a50ba6580$var$tagNameAfter(input, 1) || "", context) : context;
    },
    strict: false
});
const $957fc58a50ba6580$var$tagStart = new (0, $2sfCn.ExternalTokenizer)((input, stack)=>{
    if (input.next != $957fc58a50ba6580$var$lessThan) {
        // End of file, close any open tags
        if (input.next < 0 && stack.context) input.acceptToken($957fc58a50ba6580$var$missingCloseTag);
        return;
    }
    input.advance();
    let close = input.next == $957fc58a50ba6580$var$slash;
    if (close) input.advance();
    let name = $957fc58a50ba6580$var$tagNameAfter(input, 0);
    if (name === undefined) return;
    if (!name) return input.acceptToken(close ? $957fc58a50ba6580$var$IncompleteCloseTag : $957fc58a50ba6580$var$StartTag);
    let parent = stack.context ? stack.context.name : null;
    if (close) {
        if (name == parent) return input.acceptToken($957fc58a50ba6580$var$StartCloseTag);
        if (parent && $957fc58a50ba6580$var$implicitlyClosed[parent]) return input.acceptToken($957fc58a50ba6580$var$missingCloseTag, -2);
        if (stack.dialectEnabled($957fc58a50ba6580$var$Dialect_noMatch)) return input.acceptToken($957fc58a50ba6580$var$NoMatchStartCloseTag);
        for(let cx = stack.context; cx; cx = cx.parent)if (cx.name == name) return;
        input.acceptToken($957fc58a50ba6580$var$MismatchedStartCloseTag);
    } else {
        if (name == "script") return input.acceptToken($957fc58a50ba6580$var$StartScriptTag);
        if (name == "style") return input.acceptToken($957fc58a50ba6580$var$StartStyleTag);
        if (name == "textarea") return input.acceptToken($957fc58a50ba6580$var$StartTextareaTag);
        if ($957fc58a50ba6580$var$selfClosers.hasOwnProperty(name)) return input.acceptToken($957fc58a50ba6580$var$StartSelfClosingTag);
        if (parent && $957fc58a50ba6580$var$closeOnOpen[parent] && $957fc58a50ba6580$var$closeOnOpen[parent][name]) input.acceptToken($957fc58a50ba6580$var$missingCloseTag, -1);
        else input.acceptToken($957fc58a50ba6580$var$StartTag);
    }
}, {
    contextual: true
});
const $957fc58a50ba6580$var$commentContent = new (0, $2sfCn.ExternalTokenizer)((input)=>{
    for(let dashes = 0, i = 0;; i++){
        if (input.next < 0) {
            if (i) input.acceptToken($957fc58a50ba6580$var$commentContent$1);
            break;
        }
        if (input.next == $957fc58a50ba6580$var$dash) dashes++;
        else if (input.next == $957fc58a50ba6580$var$greaterThan && dashes >= 2) {
            if (i >= 3) input.acceptToken($957fc58a50ba6580$var$commentContent$1, -2);
            break;
        } else dashes = 0;
        input.advance();
    }
});
function $957fc58a50ba6580$var$inForeignElement(context) {
    for(; context; context = context.parent)if (context.name == "svg" || context.name == "math") return true;
    return false;
}
const $957fc58a50ba6580$var$endTag = new (0, $2sfCn.ExternalTokenizer)((input, stack)=>{
    if (input.next == $957fc58a50ba6580$var$slash && input.peek(1) == $957fc58a50ba6580$var$greaterThan) {
        let selfClosing = stack.dialectEnabled($957fc58a50ba6580$var$Dialect_selfClosing) || $957fc58a50ba6580$var$inForeignElement(stack.context);
        input.acceptToken(selfClosing ? $957fc58a50ba6580$var$SelfClosingEndTag : $957fc58a50ba6580$var$EndTag, 2);
    } else if (input.next == $957fc58a50ba6580$var$greaterThan) input.acceptToken($957fc58a50ba6580$var$EndTag, 1);
});
function $957fc58a50ba6580$var$contentTokenizer(tag, textToken, endToken) {
    let lastState = 2 + tag.length;
    return new (0, $2sfCn.ExternalTokenizer)((input)=>{
        // state means:
        // - 0 nothing matched
        // - 1 '<' matched
        // - 2 '</' + possibly whitespace matched
        // - 3-(1+tag.length) part of the tag matched
        // - lastState whole tag + possibly whitespace matched
        for(let state = 0, matchedLen = 0, i = 0;; i++){
            if (input.next < 0) {
                if (i) input.acceptToken(textToken);
                break;
            }
            if (state == 0 && input.next == $957fc58a50ba6580$var$lessThan || state == 1 && input.next == $957fc58a50ba6580$var$slash || state >= 2 && state < lastState && input.next == tag.charCodeAt(state - 2)) {
                state++;
                matchedLen++;
            } else if ((state == 2 || state == lastState) && $957fc58a50ba6580$var$isSpace(input.next)) matchedLen++;
            else if (state == lastState && input.next == $957fc58a50ba6580$var$greaterThan) {
                if (i > matchedLen) input.acceptToken(textToken, -matchedLen);
                else input.acceptToken(endToken, -(matchedLen - 2));
                break;
            } else if ((input.next == 10 /* '\n' */  || input.next == 13 /* '\r' */ ) && i) {
                input.acceptToken(textToken, 1);
                break;
            } else state = matchedLen = 0;
            input.advance();
        }
    });
}
const $957fc58a50ba6580$var$scriptTokens = $957fc58a50ba6580$var$contentTokenizer("script", $957fc58a50ba6580$var$scriptText, $957fc58a50ba6580$var$StartCloseScriptTag);
const $957fc58a50ba6580$var$styleTokens = $957fc58a50ba6580$var$contentTokenizer("style", $957fc58a50ba6580$var$styleText, $957fc58a50ba6580$var$StartCloseStyleTag);
const $957fc58a50ba6580$var$textareaTokens = $957fc58a50ba6580$var$contentTokenizer("textarea", $957fc58a50ba6580$var$textareaText, $957fc58a50ba6580$var$StartCloseTextareaTag);
const $957fc58a50ba6580$var$htmlHighlighting = (0, $lhXhg.styleTags)({
    "Text RawText": (0, $lhXhg.tags).content,
    "StartTag StartCloseTag SelfClosingEndTag EndTag": (0, $lhXhg.tags).angleBracket,
    TagName: (0, $lhXhg.tags).tagName,
    "MismatchedCloseTag/TagName": [
        (0, $lhXhg.tags).tagName,
        (0, $lhXhg.tags).invalid
    ],
    AttributeName: (0, $lhXhg.tags).attributeName,
    "AttributeValue UnquotedAttributeValue": (0, $lhXhg.tags).attributeValue,
    Is: (0, $lhXhg.tags).definitionOperator,
    "EntityReference CharacterReference": (0, $lhXhg.tags).character,
    Comment: (0, $lhXhg.tags).blockComment,
    ProcessingInst: (0, $lhXhg.tags).processingInstruction,
    DoctypeDecl: (0, $lhXhg.tags).documentMeta
});
// This file was generated by lezer-generator. You probably shouldn't edit it.
const $957fc58a50ba6580$export$8f49e4af10703ce3 = (0, $2sfCn.LRParser).deserialize({
    version: 14,
    states: ",xOVO!rOOO!WQ#tO'#CqO!]Q#tO'#CzO!bQ#tO'#C}O!gQ#tO'#DQO!lQ#tO'#DSO!qOaO'#CpO!|ObO'#CpO#XOdO'#CpO$eO!rO'#CpOOO`'#Cp'#CpO$lO$fO'#DTO$tQ#tO'#DVO$yQ#tO'#DWOOO`'#Dk'#DkOOO`'#DY'#DYQVO!rOOO%OQ&rO,59]O%ZQ&rO,59fO%fQ&rO,59iO%qQ&rO,59lO%|Q&rO,59nOOOa'#D^'#D^O&XOaO'#CxO&dOaO,59[OOOb'#D_'#D_O&lObO'#C{O&wObO,59[OOOd'#D`'#D`O'POdO'#DOO'[OdO,59[OOO`'#Da'#DaO'dO!rO,59[O'kQ#tO'#DROOO`,59[,59[OOOp'#Db'#DbO'pO$fO,59oOOO`,59o,59oO'xQ#|O,59qO'}Q#|O,59rOOO`-E7W-E7WO(SQ&rO'#CsOOQW'#DZ'#DZO(bQ&rO1G.wOOOa1G.w1G.wOOO`1G/Y1G/YO(mQ&rO1G/QOOOb1G/Q1G/QO(xQ&rO1G/TOOOd1G/T1G/TO)TQ&rO1G/WOOO`1G/W1G/WO)`Q&rO1G/YOOOa-E7[-E7[O)kQ#tO'#CyOOO`1G.v1G.vOOOb-E7]-E7]O)pQ#tO'#C|OOOd-E7^-E7^O)uQ#tO'#DPOOO`-E7_-E7_O)zQ#|O,59mOOOp-E7`-E7`OOO`1G/Z1G/ZOOO`1G/]1G/]OOO`1G/^1G/^O*PQ,UO,59_OOQW-E7X-E7XOOOa7+$c7+$cOOO`7+$t7+$tOOOb7+$l7+$lOOOd7+$o7+$oOOO`7+$r7+$rO*[Q#|O,59eO*aQ#|O,59hO*fQ#|O,59kOOO`1G/X1G/XO*kO7[O'#CvO*|OMhO'#CvOOQW1G.y1G.yOOO`1G/P1G/POOO`1G/S1G/SOOO`1G/V1G/VOOOO'#D['#D[O+_O7[O,59bOOQW,59b,59bOOOO'#D]'#D]O+pOMhO,59bOOOO-E7Y-E7YOOQW1G.|1G.|OOOO-E7Z-E7Z",
    stateData: ",]~O!^OS~OUSOVPOWQOXROYTO[]O][O^^O`^Oa^Ob^Oc^Ox^O{_O!dZO~OfaO~OfbO~OfcO~OfdO~OfeO~O!WfOPlP!ZlP~O!XiOQoP!ZoP~O!YlORrP!ZrP~OUSOVPOWQOXROYTOZqO[]O][O^^O`^Oa^Ob^Oc^Ox^O!dZO~O!ZrO~P#dO![sO!euO~OfvO~OfwO~OS|OT}OhyO~OS!POT}OhyO~OS!ROT}OhyO~OS!TOT}OhyO~OS}OT}OhyO~O!WfOPlX!ZlX~OP!WO!Z!XO~O!XiOQoX!ZoX~OQ!ZO!Z!XO~O!YlORrX!ZrX~OR!]O!Z!XO~O!Z!XO~P#dOf!_O~O![sO!e!aO~OS!bO~OS!cO~Oi!dOSgXTgXhgX~OS!fOT!gOhyO~OS!hOT!gOhyO~OS!iOT!gOhyO~OS!jOT!gOhyO~OS!gOT!gOhyO~Of!kO~Of!lO~Of!mO~OS!nO~Ok!qO!`!oO!b!pO~OS!rO~OS!sO~OS!tO~Oa!uOb!uOc!uO!`!wO!a!uO~Oa!xOb!xOc!xO!b!wO!c!xO~Oa!uOb!uOc!uO!`!{O!a!uO~Oa!xOb!xOc!xO!b!{O!c!xO~OT~bac!dx{!d~",
    goto: "%p!`PPPPPPPPPPPPPPPPPPPP!a!gP!mPP!yP!|#P#S#Y#]#`#f#i#l#r#x!aP!a!aP$O$U$l$r$x%O%U%[%bPPPPPPPP%hX^OX`pXUOX`pezabcde{!O!Q!S!UR!q!dRhUR!XhXVOX`pRkVR!XkXWOX`pRnWR!XnXXOX`pQrXR!XpXYOX`pQ`ORx`Q{aQ!ObQ!QcQ!SdQ!UeZ!e{!O!Q!S!UQ!v!oR!z!vQ!y!pR!|!yQgUR!VgQjVR!YjQmWR![mQpXR!^pQtZR!`tS_O`ToXp",
    nodeNames: "\u26A0 StartCloseTag StartCloseTag StartCloseTag EndTag SelfClosingEndTag StartTag StartTag StartTag StartTag StartTag StartCloseTag StartCloseTag StartCloseTag IncompleteCloseTag Document Text EntityReference CharacterReference InvalidEntity Element OpenTag TagName Attribute AttributeName Is AttributeValue UnquotedAttributeValue ScriptText CloseTag OpenTag StyleText CloseTag OpenTag TextareaText CloseTag OpenTag CloseTag SelfClosingTag Comment ProcessingInst MismatchedCloseTag CloseTag DoctypeDecl",
    maxTerm: 67,
    context: $957fc58a50ba6580$var$elementContext,
    nodeProps: [
        [
            "closedBy",
            -10,
            1,
            2,
            3,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            "EndTag",
            6,
            "EndTag SelfClosingEndTag",
            -4,
            21,
            30,
            33,
            36,
            "CloseTag"
        ],
        [
            "openedBy",
            4,
            "StartTag StartCloseTag",
            5,
            "StartTag",
            -4,
            29,
            32,
            35,
            37,
            "OpenTag"
        ],
        [
            "group",
            -9,
            14,
            17,
            18,
            19,
            20,
            39,
            40,
            41,
            42,
            "Entity",
            16,
            "Entity TextContent",
            -3,
            28,
            31,
            34,
            "TextContent Entity"
        ],
        [
            "isolate",
            -11,
            21,
            29,
            30,
            32,
            33,
            35,
            36,
            37,
            38,
            41,
            42,
            "ltr",
            -3,
            26,
            27,
            39,
            ""
        ]
    ],
    propSources: [
        $957fc58a50ba6580$var$htmlHighlighting
    ],
    skippedNodes: [
        0
    ],
    repeatNodeCount: 9,
    tokenData: "!<p!aR!YOX$qXY,QYZ,QZ[$q[]&X]^,Q^p$qpq,Qqr-_rs3_sv-_vw3}wxHYx}-_}!OH{!O!P-_!P!Q$q!Q![-_![!]Mz!]!^-_!^!_!$S!_!`!;x!`!a&X!a!c-_!c!}Mz!}#R-_#R#SMz#S#T1k#T#oMz#o#s-_#s$f$q$f%W-_%W%oMz%o%p-_%p&aMz&a&b-_&b1pMz1p4U-_4U4dMz4d4e-_4e$ISMz$IS$I`-_$I`$IbMz$Ib$Kh-_$Kh%#tMz%#t&/x-_&/x&EtMz&Et&FV-_&FV;'SMz;'S;:j!#|;:j;=`3X<%l?&r-_?&r?AhMz?Ah?BY$q?BY?MnMz?MnO$q!Z$|c`PkW!a`!cpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr$qrs&}sv$qvw+Pwx(tx!^$q!^!_*V!_!a&X!a#S$q#S#T&X#T;'S$q;'S;=`+z<%lO$q!R&bX`P!a`!cpOr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&Xq'UV`P!cpOv&}wx'kx!^&}!^!_(V!_;'S&};'S;=`(n<%lO&}P'pT`POv'kw!^'k!_;'S'k;'S;=`(P<%lO'kP(SP;=`<%l'kp([S!cpOv(Vx;'S(V;'S;=`(h<%lO(Vp(kP;=`<%l(Vq(qP;=`<%l&}a({W`P!a`Or(trs'ksv(tw!^(t!^!_)e!_;'S(t;'S;=`*P<%lO(t`)jT!a`Or)esv)ew;'S)e;'S;=`)y<%lO)e`)|P;=`<%l)ea*SP;=`<%l(t!Q*^V!a`!cpOr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!Q*vP;=`<%l*V!R*|P;=`<%l&XW+UYkWOX+PZ[+P^p+Pqr+Psw+Px!^+P!a#S+P#T;'S+P;'S;=`+t<%lO+PW+wP;=`<%l+P!Z+}P;=`<%l$q!a,]``P!a`!cp!^^OX&XXY,QYZ,QZ]&X]^,Q^p&Xpq,Qqr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&X!_-ljhS`PkW!a`!cpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx!P-_!P!Q$q!Q!^-_!^!_*V!_!a&X!a#S-_#S#T1k#T#s-_#s$f$q$f;'S-_;'S;=`3X<%l?Ah-_?Ah?BY$q?BY?Mn-_?MnO$q[/ebhSkWOX+PZ[+P^p+Pqr/^sw/^x!P/^!P!Q+P!Q!^/^!a#S/^#S#T0m#T#s/^#s$f+P$f;'S/^;'S;=`1e<%l?Ah/^?Ah?BY+P?BY?Mn/^?MnO+PS0rXhSqr0msw0mx!P0m!Q!^0m!a#s0m$f;'S0m;'S;=`1_<%l?Ah0m?BY?Mn0mS1bP;=`<%l0m[1hP;=`<%l/^!V1vchS`P!a`!cpOq&Xqr1krs&}sv1kvw0mwx(tx!P1k!P!Q&X!Q!^1k!^!_*V!_!a&X!a#s1k#s$f&X$f;'S1k;'S;=`3R<%l?Ah1k?Ah?BY&X?BY?Mn1k?MnO&X!V3UP;=`<%l1k!_3[P;=`<%l-_!Z3hV!`h`P!cpOv&}wx'kx!^&}!^!_(V!_;'S&};'S;=`(n<%lO&}!_4WihSkWc!ROX5uXZ7SZ[5u[^7S^p5uqr8trs7Sst>]tw8twx7Sx!P8t!P!Q5u!Q!]8t!]!^/^!^!a7S!a#S8t#S#T;{#T#s8t#s$f5u$f;'S8t;'S;=`>V<%l?Ah8t?Ah?BY5u?BY?Mn8t?MnO5u!Z5zbkWOX5uXZ7SZ[5u[^7S^p5uqr5urs7Sst+Ptw5uwx7Sx!]5u!]!^7w!^!a7S!a#S5u#S#T7S#T;'S5u;'S;=`8n<%lO5u!R7VVOp7Sqs7St!]7S!]!^7l!^;'S7S;'S;=`7q<%lO7S!R7qOa!R!R7tP;=`<%l7S!Z8OYkWa!ROX+PZ[+P^p+Pqr+Psw+Px!^+P!a#S+P#T;'S+P;'S;=`+t<%lO+P!Z8qP;=`<%l5u!_8{ihSkWOX5uXZ7SZ[5u[^7S^p5uqr8trs7Sst/^tw8twx7Sx!P8t!P!Q5u!Q!]8t!]!^:j!^!a7S!a#S8t#S#T;{#T#s8t#s$f5u$f;'S8t;'S;=`>V<%l?Ah8t?Ah?BY5u?BY?Mn8t?MnO5u!_:sbhSkWa!ROX+PZ[+P^p+Pqr/^sw/^x!P/^!P!Q+P!Q!^/^!a#S/^#S#T0m#T#s/^#s$f+P$f;'S/^;'S;=`1e<%l?Ah/^?Ah?BY+P?BY?Mn/^?MnO+P!V<QchSOp7Sqr;{rs7Sst0mtw;{wx7Sx!P;{!P!Q7S!Q!];{!]!^=]!^!a7S!a#s;{#s$f7S$f;'S;{;'S;=`>P<%l?Ah;{?Ah?BY7S?BY?Mn;{?MnO7S!V=dXhSa!Rqr0msw0mx!P0m!Q!^0m!a#s0m$f;'S0m;'S;=`1_<%l?Ah0m?BY?Mn0m!V>SP;=`<%l;{!_>YP;=`<%l8t!_>dhhSkWOX@OXZAYZ[@O[^AY^p@OqrBwrsAYswBwwxAYx!PBw!P!Q@O!Q!]Bw!]!^/^!^!aAY!a#SBw#S#TE{#T#sBw#s$f@O$f;'SBw;'S;=`HS<%l?AhBw?Ah?BY@O?BY?MnBw?MnO@O!Z@TakWOX@OXZAYZ[@O[^AY^p@Oqr@OrsAYsw@OwxAYx!]@O!]!^Az!^!aAY!a#S@O#S#TAY#T;'S@O;'S;=`Bq<%lO@O!RA]UOpAYq!]AY!]!^Ao!^;'SAY;'S;=`At<%lOAY!RAtOb!R!RAwP;=`<%lAY!ZBRYkWb!ROX+PZ[+P^p+Pqr+Psw+Px!^+P!a#S+P#T;'S+P;'S;=`+t<%lO+P!ZBtP;=`<%l@O!_COhhSkWOX@OXZAYZ[@O[^AY^p@OqrBwrsAYswBwwxAYx!PBw!P!Q@O!Q!]Bw!]!^Dj!^!aAY!a#SBw#S#TE{#T#sBw#s$f@O$f;'SBw;'S;=`HS<%l?AhBw?Ah?BY@O?BY?MnBw?MnO@O!_DsbhSkWb!ROX+PZ[+P^p+Pqr/^sw/^x!P/^!P!Q+P!Q!^/^!a#S/^#S#T0m#T#s/^#s$f+P$f;'S/^;'S;=`1e<%l?Ah/^?Ah?BY+P?BY?Mn/^?MnO+P!VFQbhSOpAYqrE{rsAYswE{wxAYx!PE{!P!QAY!Q!]E{!]!^GY!^!aAY!a#sE{#s$fAY$f;'SE{;'S;=`G|<%l?AhE{?Ah?BYAY?BY?MnE{?MnOAY!VGaXhSb!Rqr0msw0mx!P0m!Q!^0m!a#s0m$f;'S0m;'S;=`1_<%l?Ah0m?BY?Mn0m!VHPP;=`<%lE{!_HVP;=`<%lBw!ZHcW!bx`P!a`Or(trs'ksv(tw!^(t!^!_)e!_;'S(t;'S;=`*P<%lO(t!aIYlhS`PkW!a`!cpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx}-_}!OKQ!O!P-_!P!Q$q!Q!^-_!^!_*V!_!a&X!a#S-_#S#T1k#T#s-_#s$f$q$f;'S-_;'S;=`3X<%l?Ah-_?Ah?BY$q?BY?Mn-_?MnO$q!aK_khS`PkW!a`!cpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx!P-_!P!Q$q!Q!^-_!^!_*V!_!`&X!`!aMS!a#S-_#S#T1k#T#s-_#s$f$q$f;'S-_;'S;=`3X<%l?Ah-_?Ah?BY$q?BY?Mn-_?MnO$q!TM_X`P!a`!cp!eQOr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&X!aNZ!ZhSfQ`PkW!a`!cpOX$qXZ&XZ[$q[^&X^p$qpq&Xqr-_rs&}sv-_vw/^wx(tx}-_}!OMz!O!PMz!P!Q$q!Q![Mz![!]Mz!]!^-_!^!_*V!_!a&X!a!c-_!c!}Mz!}#R-_#R#SMz#S#T1k#T#oMz#o#s-_#s$f$q$f$}-_$}%OMz%O%W-_%W%oMz%o%p-_%p&aMz&a&b-_&b1pMz1p4UMz4U4dMz4d4e-_4e$ISMz$IS$I`-_$I`$IbMz$Ib$Je-_$Je$JgMz$Jg$Kh-_$Kh%#tMz%#t&/x-_&/x&EtMz&Et&FV-_&FV;'SMz;'S;:j!#|;:j;=`3X<%l?&r-_?&r?AhMz?Ah?BY$q?BY?MnMz?MnO$q!a!$PP;=`<%lMz!R!$ZY!a`!cpOq*Vqr!$yrs(Vsv*Vwx)ex!a*V!a!b!4t!b;'S*V;'S;=`*s<%lO*V!R!%Q]!a`!cpOr*Vrs(Vsv*Vwx)ex}*V}!O!%y!O!f*V!f!g!']!g#W*V#W#X!0`#X;'S*V;'S;=`*s<%lO*V!R!&QX!a`!cpOr*Vrs(Vsv*Vwx)ex}*V}!O!&m!O;'S*V;'S;=`*s<%lO*V!R!&vV!a`!cp!dPOr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!R!'dX!a`!cpOr*Vrs(Vsv*Vwx)ex!q*V!q!r!(P!r;'S*V;'S;=`*s<%lO*V!R!(WX!a`!cpOr*Vrs(Vsv*Vwx)ex!e*V!e!f!(s!f;'S*V;'S;=`*s<%lO*V!R!(zX!a`!cpOr*Vrs(Vsv*Vwx)ex!v*V!v!w!)g!w;'S*V;'S;=`*s<%lO*V!R!)nX!a`!cpOr*Vrs(Vsv*Vwx)ex!{*V!{!|!*Z!|;'S*V;'S;=`*s<%lO*V!R!*bX!a`!cpOr*Vrs(Vsv*Vwx)ex!r*V!r!s!*}!s;'S*V;'S;=`*s<%lO*V!R!+UX!a`!cpOr*Vrs(Vsv*Vwx)ex!g*V!g!h!+q!h;'S*V;'S;=`*s<%lO*V!R!+xY!a`!cpOr!+qrs!,hsv!+qvw!-Swx!.[x!`!+q!`!a!/j!a;'S!+q;'S;=`!0Y<%lO!+qq!,mV!cpOv!,hvx!-Sx!`!,h!`!a!-q!a;'S!,h;'S;=`!.U<%lO!,hP!-VTO!`!-S!`!a!-f!a;'S!-S;'S;=`!-k<%lO!-SP!-kO{PP!-nP;=`<%l!-Sq!-xS!cp{POv(Vx;'S(V;'S;=`(h<%lO(Vq!.XP;=`<%l!,ha!.aX!a`Or!.[rs!-Ssv!.[vw!-Sw!`!.[!`!a!.|!a;'S!.[;'S;=`!/d<%lO!.[a!/TT!a`{POr)esv)ew;'S)e;'S;=`)y<%lO)ea!/gP;=`<%l!.[!R!/sV!a`!cp{POr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!R!0]P;=`<%l!+q!R!0gX!a`!cpOr*Vrs(Vsv*Vwx)ex#c*V#c#d!1S#d;'S*V;'S;=`*s<%lO*V!R!1ZX!a`!cpOr*Vrs(Vsv*Vwx)ex#V*V#V#W!1v#W;'S*V;'S;=`*s<%lO*V!R!1}X!a`!cpOr*Vrs(Vsv*Vwx)ex#h*V#h#i!2j#i;'S*V;'S;=`*s<%lO*V!R!2qX!a`!cpOr*Vrs(Vsv*Vwx)ex#m*V#m#n!3^#n;'S*V;'S;=`*s<%lO*V!R!3eX!a`!cpOr*Vrs(Vsv*Vwx)ex#d*V#d#e!4Q#e;'S*V;'S;=`*s<%lO*V!R!4XX!a`!cpOr*Vrs(Vsv*Vwx)ex#X*V#X#Y!+q#Y;'S*V;'S;=`*s<%lO*V!R!4{Y!a`!cpOr!4trs!5ksv!4tvw!6Vwx!8]x!a!4t!a!b!:]!b;'S!4t;'S;=`!;r<%lO!4tq!5pV!cpOv!5kvx!6Vx!a!5k!a!b!7W!b;'S!5k;'S;=`!8V<%lO!5kP!6YTO!a!6V!a!b!6i!b;'S!6V;'S;=`!7Q<%lO!6VP!6lTO!`!6V!`!a!6{!a;'S!6V;'S;=`!7Q<%lO!6VP!7QOxPP!7TP;=`<%l!6Vq!7]V!cpOv!5kvx!6Vx!`!5k!`!a!7r!a;'S!5k;'S;=`!8V<%lO!5kq!7yS!cpxPOv(Vx;'S(V;'S;=`(h<%lO(Vq!8YP;=`<%l!5ka!8bX!a`Or!8]rs!6Vsv!8]vw!6Vw!a!8]!a!b!8}!b;'S!8];'S;=`!:V<%lO!8]a!9SX!a`Or!8]rs!6Vsv!8]vw!6Vw!`!8]!`!a!9o!a;'S!8];'S;=`!:V<%lO!8]a!9vT!a`xPOr)esv)ew;'S)e;'S;=`)y<%lO)ea!:YP;=`<%l!8]!R!:dY!a`!cpOr!4trs!5ksv!4tvw!6Vwx!8]x!`!4t!`!a!;S!a;'S!4t;'S;=`!;r<%lO!4t!R!;]V!a`!cpxPOr*Vrs(Vsv*Vwx)ex;'S*V;'S;=`*s<%lO*V!R!;uP;=`<%l!4t!V!<TXiS`P!a`!cpOr&Xrs&}sv&Xwx(tx!^&X!^!_*V!_;'S&X;'S;=`*y<%lO&X",
    tokenizers: [
        $957fc58a50ba6580$var$scriptTokens,
        $957fc58a50ba6580$var$styleTokens,
        $957fc58a50ba6580$var$textareaTokens,
        $957fc58a50ba6580$var$endTag,
        $957fc58a50ba6580$var$tagStart,
        $957fc58a50ba6580$var$commentContent,
        0,
        1,
        2,
        3,
        4,
        5
    ],
    topRules: {
        "Document": [
            0,
            15
        ]
    },
    dialects: {
        noMatch: 0,
        selfClosing: 509
    },
    tokenPrec: 511
});
function $957fc58a50ba6580$var$getAttrs(openTag, input) {
    let attrs = Object.create(null);
    for (let att of openTag.getChildren($957fc58a50ba6580$var$Attribute)){
        let name = att.getChild($957fc58a50ba6580$var$AttributeName), value = att.getChild($957fc58a50ba6580$var$AttributeValue) || att.getChild($957fc58a50ba6580$var$UnquotedAttributeValue);
        if (name) attrs[input.read(name.from, name.to)] = !value ? "" : value.type.id == $957fc58a50ba6580$var$AttributeValue ? input.read(value.from + 1, value.to - 1) : input.read(value.from, value.to);
    }
    return attrs;
}
function $957fc58a50ba6580$var$findTagName(openTag, input) {
    let tagNameNode = openTag.getChild($957fc58a50ba6580$var$TagName);
    return tagNameNode ? input.read(tagNameNode.from, tagNameNode.to) : " ";
}
function $957fc58a50ba6580$var$maybeNest(node, input, tags) {
    let attrs;
    for (let tag of tags){
        if (!tag.attrs || tag.attrs(attrs || (attrs = $957fc58a50ba6580$var$getAttrs(node.node.parent.firstChild, input)))) return {
            parser: tag.parser
        };
    }
    return null;
}
// tags?: {
//   tag: string,
//   attrs?: ({[attr: string]: string}) => boolean,
//   parser: Parser
// }[]
// attributes?: {
//   name: string,
//   tagName?: string,
//   parser: Parser
// }[]
function $957fc58a50ba6580$export$3a6217e5968adf01(tags = [], attributes = []) {
    let script = [], style = [], textarea = [], other = [];
    for (let tag of tags){
        let array = tag.tag == "script" ? script : tag.tag == "style" ? style : tag.tag == "textarea" ? textarea : other;
        array.push(tag);
    }
    let attrs = attributes.length ? Object.create(null) : null;
    for (let attr of attributes)(attrs[attr.name] || (attrs[attr.name] = [])).push(attr);
    return (0, $uXNGm.parseMixed)((node, input)=>{
        let id = node.type.id;
        if (id == $957fc58a50ba6580$var$ScriptText) return $957fc58a50ba6580$var$maybeNest(node, input, script);
        if (id == $957fc58a50ba6580$var$StyleText) return $957fc58a50ba6580$var$maybeNest(node, input, style);
        if (id == $957fc58a50ba6580$var$TextareaText) return $957fc58a50ba6580$var$maybeNest(node, input, textarea);
        if (id == $957fc58a50ba6580$var$Element && other.length) {
            let n = node.node, open = n.firstChild, tagName = open && $957fc58a50ba6580$var$findTagName(open, input), attrs;
            if (tagName) {
                for (let tag of other)if (tag.tag == tagName && (!tag.attrs || tag.attrs(attrs || (attrs = $957fc58a50ba6580$var$getAttrs(open, input))))) {
                    let close = n.lastChild;
                    let to = close.type.id == $957fc58a50ba6580$var$CloseTag ? close.from : n.to;
                    if (to > open.to) return {
                        parser: tag.parser,
                        overlay: [
                            {
                                from: open.to,
                                to: to
                            }
                        ]
                    };
                }
            }
        }
        if (attrs && id == $957fc58a50ba6580$var$Attribute) {
            let n = node.node, nameNode;
            if (nameNode = n.firstChild) {
                let matches = attrs[input.read(nameNode.from, nameNode.to)];
                if (matches) for (let attr of matches){
                    if (attr.tagName && attr.tagName != $957fc58a50ba6580$var$findTagName(n.parent, input)) continue;
                    let value = n.lastChild;
                    if (value.type.id == $957fc58a50ba6580$var$AttributeValue) {
                        let from = value.from + 1;
                        let last = value.lastChild, to = value.to - (last && last.isError ? 0 : 1);
                        if (to > from) return {
                            parser: attr.parser,
                            overlay: [
                                {
                                    from: from,
                                    to: to
                                }
                            ]
                        };
                    } else if (value.type.id == $957fc58a50ba6580$var$UnquotedAttributeValue) return {
                        parser: attr.parser,
                        overlay: [
                            {
                                from: value.from,
                                to: value.to
                            }
                        ]
                    };
                }
            }
        }
        return null;
    });
}
module.exports["parser"] = $957fc58a50ba6580$export$8f49e4af10703ce3;
module.exports["configureNesting"] = $957fc58a50ba6580$export$3a6217e5968adf01;

});

parcelRegister("evu44", function(module, exports) {

var $fPKsl = parcelRequire("fPKsl");


var $4lK5a = parcelRequire("4lK5a");


var $b2ZzE = parcelRequire("b2ZzE");


var $3e6dc = parcelRequire("3e6dc");


var $haZ24 = parcelRequire("haZ24");


var $uXNGm = parcelRequire("uXNGm");

/**
A collection of JavaScript-related
[snippets](https://codemirror.net/6/docs/ref/#autocomplete.snippet).
*/ const $a8fb482c20469d02$export$c7c03ffcb9c131fc = [
    /*@__PURE__*/ (0, $haZ24.snippetCompletion)("function ${name}(${params}) {\n\t${}\n}", {
        label: "function",
        detail: "definition",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $haZ24.snippetCompletion)("for (let ${index} = 0; ${index} < ${bound}; ${index}++) {\n\t${}\n}", {
        label: "for",
        detail: "loop",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $haZ24.snippetCompletion)("for (let ${name} of ${collection}) {\n\t${}\n}", {
        label: "for",
        detail: "of loop",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $haZ24.snippetCompletion)("do {\n\t${}\n} while (${})", {
        label: "do",
        detail: "loop",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $haZ24.snippetCompletion)("while (${}) {\n\t${}\n}", {
        label: "while",
        detail: "loop",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $haZ24.snippetCompletion)("try {\n\t${}\n} catch (${error}) {\n\t${}\n}", {
        label: "try",
        detail: "/ catch block",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $haZ24.snippetCompletion)("if (${}) {\n\t${}\n}", {
        label: "if",
        detail: "block",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $haZ24.snippetCompletion)("if (${}) {\n\t${}\n} else {\n\t${}\n}", {
        label: "if",
        detail: "/ else block",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $haZ24.snippetCompletion)("class ${name} {\n\tconstructor(${params}) {\n\t\t${}\n\t}\n}", {
        label: "class",
        detail: "definition",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $haZ24.snippetCompletion)("import {${names}} from \"${module}\"\n${}", {
        label: "import",
        detail: "named",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $haZ24.snippetCompletion)("import ${name} from \"${module}\"\n${}", {
        label: "import",
        detail: "default",
        type: "keyword"
    })
];
/**
A collection of snippet completions for TypeScript. Includes the
JavaScript [snippets](https://codemirror.net/6/docs/ref/#lang-javascript.snippets).
*/ const $a8fb482c20469d02$export$4e97f270e7f6c0ba = /*@__PURE__*/ $a8fb482c20469d02$export$c7c03ffcb9c131fc.concat([
    /*@__PURE__*/ (0, $haZ24.snippetCompletion)("interface ${name} {\n\t${}\n}", {
        label: "interface",
        detail: "definition",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $haZ24.snippetCompletion)("type ${name} = ${type}", {
        label: "type",
        detail: "definition",
        type: "keyword"
    }),
    /*@__PURE__*/ (0, $haZ24.snippetCompletion)("enum ${name} {\n\t${}\n}", {
        label: "enum",
        detail: "definition",
        type: "keyword"
    })
]);
const $a8fb482c20469d02$var$cache = /*@__PURE__*/ new (0, $uXNGm.NodeWeakMap)();
const $a8fb482c20469d02$var$ScopeNodes = /*@__PURE__*/ new Set([
    "Script",
    "Block",
    "FunctionExpression",
    "FunctionDeclaration",
    "ArrowFunction",
    "MethodDeclaration",
    "ForStatement"
]);
function $a8fb482c20469d02$var$defID(type) {
    return (node, def)=>{
        let id = node.node.getChild("VariableDefinition");
        if (id) def(id, type);
        return true;
    };
}
const $a8fb482c20469d02$var$functionContext = [
    "FunctionDeclaration"
];
const $a8fb482c20469d02$var$gatherCompletions = {
    FunctionDeclaration: /*@__PURE__*/ $a8fb482c20469d02$var$defID("function"),
    ClassDeclaration: /*@__PURE__*/ $a8fb482c20469d02$var$defID("class"),
    ClassExpression: ()=>true,
    EnumDeclaration: /*@__PURE__*/ $a8fb482c20469d02$var$defID("constant"),
    TypeAliasDeclaration: /*@__PURE__*/ $a8fb482c20469d02$var$defID("type"),
    NamespaceDeclaration: /*@__PURE__*/ $a8fb482c20469d02$var$defID("namespace"),
    VariableDefinition (node, def) {
        if (!node.matchContext($a8fb482c20469d02$var$functionContext)) def(node, "variable");
    },
    TypeDefinition (node, def) {
        def(node, "type");
    },
    __proto__: null
};
function $a8fb482c20469d02$var$getScope(doc, node) {
    let cached = $a8fb482c20469d02$var$cache.get(node);
    if (cached) return cached;
    let completions = [], top = true;
    function def(node, type) {
        let name = doc.sliceString(node.from, node.to);
        completions.push({
            label: name,
            type: type
        });
    }
    node.cursor((0, $uXNGm.IterMode).IncludeAnonymous).iterate((node)=>{
        if (top) top = false;
        else if (node.name) {
            let gather = $a8fb482c20469d02$var$gatherCompletions[node.name];
            if (gather && gather(node, def) || $a8fb482c20469d02$var$ScopeNodes.has(node.name)) return false;
        } else if (node.to - node.from > 8192) {
            // Allow caching for bigger internal nodes
            for (let c of $a8fb482c20469d02$var$getScope(doc, node.node))completions.push(c);
            return false;
        }
    });
    $a8fb482c20469d02$var$cache.set(node, completions);
    return completions;
}
const $a8fb482c20469d02$var$Identifier = /^[\w$\xa1-\uffff][\w$\d\xa1-\uffff]*$/;
const $a8fb482c20469d02$var$dontComplete = [
    "TemplateString",
    "String",
    "RegExp",
    "LineComment",
    "BlockComment",
    "VariableDefinition",
    "TypeDefinition",
    "Label",
    "PropertyDefinition",
    "PropertyName",
    "PrivatePropertyDefinition",
    "PrivatePropertyName",
    ".",
    "?."
];
/**
Completion source that looks up locally defined names in
JavaScript code.
*/ function $a8fb482c20469d02$export$a2e0a5b87b9b861c(context) {
    let inner = (0, $4lK5a.syntaxTree)(context.state).resolveInner(context.pos, -1);
    if ($a8fb482c20469d02$var$dontComplete.indexOf(inner.name) > -1) return null;
    let isWord = inner.name == "VariableName" || inner.to - inner.from < 20 && $a8fb482c20469d02$var$Identifier.test(context.state.sliceDoc(inner.from, inner.to));
    if (!isWord && !context.explicit) return null;
    let options = [];
    for(let pos = inner; pos; pos = pos.parent)if ($a8fb482c20469d02$var$ScopeNodes.has(pos.name)) options = options.concat($a8fb482c20469d02$var$getScope(context.state.doc, pos));
    return {
        options: options,
        from: isWord ? inner.from : context.pos,
        validFor: $a8fb482c20469d02$var$Identifier
    };
}
function $a8fb482c20469d02$var$pathFor(read, member, name) {
    var _a;
    let path = [];
    for(;;){
        let obj = member.firstChild, prop;
        if ((obj === null || obj === void 0 ? void 0 : obj.name) == "VariableName") {
            path.push(read(obj));
            return {
                path: path.reverse(),
                name: name
            };
        } else if ((obj === null || obj === void 0 ? void 0 : obj.name) == "MemberExpression" && ((_a = prop = obj.lastChild) === null || _a === void 0 ? void 0 : _a.name) == "PropertyName") {
            path.push(read(prop));
            member = obj;
        } else return null;
    }
}
/**
Helper function for defining JavaScript completion sources. It
returns the completable name and object path for a completion
context, or null if no name/property completion should happen at
that position. For example, when completing after `a.b.c` it will
return `{path: ["a", "b"], name: "c"}`. When completing after `x`
it will return `{path: [], name: "x"}`. When not in a property or
name, it will return null if `context.explicit` is false, and
`{path: [], name: ""}` otherwise.
*/ function $a8fb482c20469d02$export$744a796701708158(context) {
    let read = (node)=>context.state.doc.sliceString(node.from, node.to);
    let inner = (0, $4lK5a.syntaxTree)(context.state).resolveInner(context.pos, -1);
    if (inner.name == "PropertyName") return $a8fb482c20469d02$var$pathFor(read, inner.parent, read(inner));
    else if ((inner.name == "." || inner.name == "?.") && inner.parent.name == "MemberExpression") return $a8fb482c20469d02$var$pathFor(read, inner.parent, "");
    else if ($a8fb482c20469d02$var$dontComplete.indexOf(inner.name) > -1) return null;
    else if (inner.name == "VariableName" || inner.to - inner.from < 20 && $a8fb482c20469d02$var$Identifier.test(read(inner))) return {
        path: [],
        name: read(inner)
    };
    else if (inner.name == "MemberExpression") return $a8fb482c20469d02$var$pathFor(read, inner, "");
    else return context.explicit ? {
        path: [],
        name: ""
    } : null;
}
function $a8fb482c20469d02$var$enumeratePropertyCompletions(obj, top) {
    let options = [], seen = new Set;
    for(let depth = 0;; depth++){
        for (let name of (Object.getOwnPropertyNames || Object.keys)(obj)){
            if (!/^[a-zA-Z_$\xaa-\uffdc][\w$\xaa-\uffdc]*$/.test(name) || seen.has(name)) continue;
            seen.add(name);
            let value;
            try {
                value = obj[name];
            } catch (_) {
                continue;
            }
            options.push({
                label: name,
                type: typeof value == "function" ? /^[A-Z]/.test(name) ? "class" : top ? "function" : "method" : top ? "variable" : "property",
                boost: -depth
            });
        }
        let next = Object.getPrototypeOf(obj);
        if (!next) return options;
        obj = next;
    }
}
/**
Defines a [completion source](https://codemirror.net/6/docs/ref/#autocomplete.CompletionSource) that
completes from the given scope object (for example `globalThis`).
Will enter properties of the object when completing properties on
a directly-named path.
*/ function $a8fb482c20469d02$export$fc7787e70db1f2c3(scope) {
    let cache = new Map;
    return (context)=>{
        let path = $a8fb482c20469d02$export$744a796701708158(context);
        if (!path) return null;
        let target = scope;
        for (let step of path.path){
            target = target[step];
            if (!target) return null;
        }
        let options = cache.get(target);
        if (!options) cache.set(target, options = $a8fb482c20469d02$var$enumeratePropertyCompletions(target, !path.path.length));
        return {
            from: context.pos - path.name.length,
            options: options,
            validFor: $a8fb482c20469d02$var$Identifier
        };
    };
}
/**
A language provider based on the [Lezer JavaScript
parser](https://github.com/lezer-parser/javascript), extended with
highlighting and indentation information.
*/ const $a8fb482c20469d02$export$93859f94713968c6 = /*@__PURE__*/ (0, $4lK5a.LRLanguage).define({
    name: "javascript",
    parser: /*@__PURE__*/ (0, $fPKsl.parser).configure({
        props: [
            /*@__PURE__*/ (0, $4lK5a.indentNodeProp).add({
                IfStatement: /*@__PURE__*/ (0, $4lK5a.continuedIndent)({
                    except: /^\s*({|else\b)/
                }),
                TryStatement: /*@__PURE__*/ (0, $4lK5a.continuedIndent)({
                    except: /^\s*({|catch\b|finally\b)/
                }),
                LabeledStatement: (0, $4lK5a.flatIndent),
                SwitchBody: (context)=>{
                    let after = context.textAfter, closed = /^\s*\}/.test(after), isCase = /^\s*(case|default)\b/.test(after);
                    return context.baseIndent + (closed ? 0 : isCase ? 1 : 2) * context.unit;
                },
                Block: /*@__PURE__*/ (0, $4lK5a.delimitedIndent)({
                    closing: "}"
                }),
                ArrowFunction: (cx)=>cx.baseIndent + cx.unit,
                "TemplateString BlockComment": ()=>null,
                "Statement Property": /*@__PURE__*/ (0, $4lK5a.continuedIndent)({
                    except: /^{/
                }),
                JSXElement (context) {
                    let closed = /^\s*<\//.test(context.textAfter);
                    return context.lineIndent(context.node.from) + (closed ? 0 : context.unit);
                },
                JSXEscape (context) {
                    let closed = /\s*\}/.test(context.textAfter);
                    return context.lineIndent(context.node.from) + (closed ? 0 : context.unit);
                },
                "JSXOpenTag JSXSelfClosingTag" (context) {
                    return context.column(context.node.from) + context.unit;
                }
            }),
            /*@__PURE__*/ (0, $4lK5a.foldNodeProp).add({
                "Block ClassBody SwitchBody EnumBody ObjectExpression ArrayExpression ObjectType": (0, $4lK5a.foldInside),
                BlockComment (tree) {
                    return {
                        from: tree.from + 2,
                        to: tree.to - 2
                    };
                }
            })
        ]
    }),
    languageData: {
        closeBrackets: {
            brackets: [
                "(",
                "[",
                "{",
                "'",
                '"',
                "`"
            ]
        },
        commentTokens: {
            line: "//",
            block: {
                open: "/*",
                close: "*/"
            }
        },
        indentOnInput: /^\s*(?:case |default:|\{|\}|<\/)$/,
        wordChars: "$"
    }
});
const $a8fb482c20469d02$var$jsxSublanguage = {
    test: (node)=>/^JSX/.test(node.name),
    facet: /*@__PURE__*/ (0, $4lK5a.defineLanguageFacet)({
        commentTokens: {
            block: {
                open: "{/*",
                close: "*/}"
            }
        }
    })
};
/**
A language provider for TypeScript.
*/ const $a8fb482c20469d02$export$5a3c1a94be83ebb = /*@__PURE__*/ $a8fb482c20469d02$export$93859f94713968c6.configure({
    dialect: "ts"
}, "typescript");
/**
Language provider for JSX.
*/ const $a8fb482c20469d02$export$cf3118f4eee6176c = /*@__PURE__*/ $a8fb482c20469d02$export$93859f94713968c6.configure({
    dialect: "jsx",
    props: [
        /*@__PURE__*/ (0, $4lK5a.sublanguageProp).add((n)=>n.isTop ? [
                $a8fb482c20469d02$var$jsxSublanguage
            ] : undefined)
    ]
});
/**
Language provider for JSX + TypeScript.
*/ const $a8fb482c20469d02$export$5e6bf9a8e977a24e = /*@__PURE__*/ $a8fb482c20469d02$export$93859f94713968c6.configure({
    dialect: "jsx ts",
    props: [
        /*@__PURE__*/ (0, $4lK5a.sublanguageProp).add((n)=>n.isTop ? [
                $a8fb482c20469d02$var$jsxSublanguage
            ] : undefined)
    ]
}, "typescript");
let $a8fb482c20469d02$var$kwCompletion = (name)=>({
        label: name,
        type: "keyword"
    });
const $a8fb482c20469d02$var$keywords = /*@__PURE__*/ "break case const continue default delete export extends false finally in instanceof let new return static super switch this throw true typeof var yield".split(" ").map($a8fb482c20469d02$var$kwCompletion);
const $a8fb482c20469d02$var$typescriptKeywords = /*@__PURE__*/ $a8fb482c20469d02$var$keywords.concat(/*@__PURE__*/ [
    "declare",
    "implements",
    "private",
    "protected",
    "public"
].map($a8fb482c20469d02$var$kwCompletion));
/**
JavaScript support. Includes [snippet](https://codemirror.net/6/docs/ref/#lang-javascript.snippets)
and local variable completion.
*/ function $a8fb482c20469d02$export$755219397dca4f08(config = {}) {
    let lang = config.jsx ? config.typescript ? $a8fb482c20469d02$export$5e6bf9a8e977a24e : $a8fb482c20469d02$export$cf3118f4eee6176c : config.typescript ? $a8fb482c20469d02$export$5a3c1a94be83ebb : $a8fb482c20469d02$export$93859f94713968c6;
    let completions = config.typescript ? $a8fb482c20469d02$export$4e97f270e7f6c0ba.concat($a8fb482c20469d02$var$typescriptKeywords) : $a8fb482c20469d02$export$c7c03ffcb9c131fc.concat($a8fb482c20469d02$var$keywords);
    return new (0, $4lK5a.LanguageSupport)(lang, [
        $a8fb482c20469d02$export$93859f94713968c6.data.of({
            autocomplete: (0, $haZ24.ifNotIn)($a8fb482c20469d02$var$dontComplete, (0, $haZ24.completeFromList)(completions))
        }),
        $a8fb482c20469d02$export$93859f94713968c6.data.of({
            autocomplete: $a8fb482c20469d02$export$a2e0a5b87b9b861c
        }),
        config.jsx ? $a8fb482c20469d02$export$f1d931274ca0e1f1 : []
    ]);
}
function $a8fb482c20469d02$var$findOpenTag(node) {
    for(;;){
        if (node.name == "JSXOpenTag" || node.name == "JSXSelfClosingTag" || node.name == "JSXFragmentTag") return node;
        if (node.name == "JSXEscape" || !node.parent) return null;
        node = node.parent;
    }
}
function $a8fb482c20469d02$var$elementName(doc, tree, max = doc.length) {
    for(let ch = tree === null || tree === void 0 ? void 0 : tree.firstChild; ch; ch = ch.nextSibling){
        if (ch.name == "JSXIdentifier" || ch.name == "JSXBuiltin" || ch.name == "JSXNamespacedName" || ch.name == "JSXMemberExpression") return doc.sliceString(ch.from, Math.min(ch.to, max));
    }
    return "";
}
const $a8fb482c20469d02$var$android = typeof navigator == "object" && /*@__PURE__*/ /Android\b/.test(navigator.userAgent);
/**
Extension that will automatically insert JSX close tags when a `>` or
`/` is typed.
*/ const $a8fb482c20469d02$export$f1d931274ca0e1f1 = /*@__PURE__*/ (0, $3e6dc.EditorView).inputHandler.of((view, from, to, text, defaultInsert)=>{
    if (($a8fb482c20469d02$var$android ? view.composing : view.compositionStarted) || view.state.readOnly || from != to || text != ">" && text != "/" || !$a8fb482c20469d02$export$93859f94713968c6.isActiveAt(view.state, from, -1)) return false;
    let base = defaultInsert(), { state: state } = base;
    let closeTags = state.changeByRange((range)=>{
        var _a;
        let { head: head } = range, around = (0, $4lK5a.syntaxTree)(state).resolveInner(head - 1, -1), name;
        if (around.name == "JSXStartTag") around = around.parent;
        if (state.doc.sliceString(head - 1, head) != text || around.name == "JSXAttributeValue" && around.to > head) ;
        else if (text == ">" && around.name == "JSXFragmentTag") return {
            range: range,
            changes: {
                from: head,
                insert: `</>`
            }
        };
        else if (text == "/" && around.name == "JSXStartCloseTag") {
            let empty = around.parent, base = empty.parent;
            if (base && empty.from == head - 2 && ((name = $a8fb482c20469d02$var$elementName(state.doc, base.firstChild, head)) || ((_a = base.firstChild) === null || _a === void 0 ? void 0 : _a.name) == "JSXFragmentTag")) {
                let insert = `${name}>`;
                return {
                    range: (0, $b2ZzE.EditorSelection).cursor(head + insert.length, -1),
                    changes: {
                        from: head,
                        insert: insert
                    }
                };
            }
        } else if (text == ">") {
            let openTag = $a8fb482c20469d02$var$findOpenTag(around);
            if (openTag && openTag.name == "JSXOpenTag" && !/^\/?>|^<\//.test(state.doc.sliceString(head, head + 2)) && (name = $a8fb482c20469d02$var$elementName(state.doc, openTag, head))) return {
                range: range,
                changes: {
                    from: head,
                    insert: `</${name}>`
                }
            };
        }
        return {
            range: range
        };
    });
    if (closeTags.changes.empty) return false;
    view.dispatch([
        base,
        state.update(closeTags, {
            userEvent: "input.complete",
            scrollIntoView: true
        })
    ]);
    return true;
});
/**
Connects an [ESLint](https://eslint.org/) linter to CodeMirror's
[lint](https://codemirror.net/6/docs/ref/#lint) integration. `eslint` should be an instance of the
[`Linter`](https://eslint.org/docs/developer-guide/nodejs-api#linter)
class, and `config` an optional ESLint configuration. The return
value of this function can be passed to [`linter`](https://codemirror.net/6/docs/ref/#lint.linter)
to create a JavaScript linting extension.

Note that ESLint targets node, and is tricky to run in the
browser. The
[eslint-linter-browserify](https://github.com/UziTech/eslint-linter-browserify)
package may help with that (see
[example](https://github.com/UziTech/eslint-linter-browserify/blob/master/example/script.js)).
*/ function $a8fb482c20469d02$export$5f7cd04a95ec53e6(eslint, config) {
    if (!config) {
        config = {
            parserOptions: {
                ecmaVersion: 2019,
                sourceType: "module"
            },
            env: {
                browser: true,
                node: true,
                es6: true,
                es2015: true,
                es2017: true,
                es2020: true
            },
            rules: {}
        };
        eslint.getRules().forEach((desc, name)=>{
            if (desc.meta.docs.recommended) config.rules[name] = 2;
        });
    }
    return (view)=>{
        let { state: state } = view, found = [];
        for (let { from: from, to: to } of $a8fb482c20469d02$export$93859f94713968c6.findRegions(state)){
            let fromLine = state.doc.lineAt(from), offset = {
                line: fromLine.number - 1,
                col: from - fromLine.from,
                pos: from
            };
            for (let d of eslint.verify(state.sliceDoc(from, to), config))found.push($a8fb482c20469d02$var$translateDiagnostic(d, state.doc, offset));
        }
        return found;
    };
}
function $a8fb482c20469d02$var$mapPos(line, col, doc, offset) {
    return doc.line(line + offset.line).from + col + (line == 1 ? offset.col - 1 : -1);
}
function $a8fb482c20469d02$var$translateDiagnostic(input, doc, offset) {
    let start = $a8fb482c20469d02$var$mapPos(input.line, input.column, doc, offset);
    let result = {
        from: start,
        to: input.endLine != null && input.endColumn != 1 ? $a8fb482c20469d02$var$mapPos(input.endLine, input.endColumn, doc, offset) : start,
        message: input.message,
        source: input.ruleId ? "eslint:" + input.ruleId : "eslint",
        severity: input.severity == 1 ? "warning" : "error"
    };
    if (input.fix) {
        let { range: range, text: text } = input.fix, from = range[0] + offset.pos - start, to = range[1] + offset.pos - start;
        result.actions = [
            {
                name: "fix",
                apply (view, start) {
                    view.dispatch({
                        changes: {
                            from: start + from,
                            to: start + to,
                            insert: text
                        },
                        scrollIntoView: true
                    });
                }
            }
        ];
    }
    return result;
}
module.exports["javascriptLanguage"] = $a8fb482c20469d02$export$93859f94713968c6;
module.exports["typescriptLanguage"] = $a8fb482c20469d02$export$5a3c1a94be83ebb;
module.exports["jsxLanguage"] = $a8fb482c20469d02$export$cf3118f4eee6176c;
module.exports["tsxLanguage"] = $a8fb482c20469d02$export$5e6bf9a8e977a24e;
module.exports["javascript"] = $a8fb482c20469d02$export$755219397dca4f08;

});

parcelRegister("fPKsl", function(module, exports) {

var $2sfCn = parcelRequire("2sfCn");


var $lhXhg = parcelRequire("lhXhg");

// This file was generated by lezer-generator. You probably shouldn't edit it.
const $b86fa7aeb3b96990$var$noSemi = 314, $b86fa7aeb3b96990$var$noSemiType = 315, $b86fa7aeb3b96990$var$incdec = 1, $b86fa7aeb3b96990$var$incdecPrefix = 2, $b86fa7aeb3b96990$var$questionDot = 3, $b86fa7aeb3b96990$var$JSXStartTag = 4, $b86fa7aeb3b96990$var$insertSemi = 316, $b86fa7aeb3b96990$var$spaces = 318, $b86fa7aeb3b96990$var$newline = 319, $b86fa7aeb3b96990$var$LineComment = 5, $b86fa7aeb3b96990$var$BlockComment = 6, $b86fa7aeb3b96990$var$Dialect_jsx = 0;
/* Hand-written tokenizers for JavaScript tokens that can't be
   expressed by lezer's built-in tokenizer. */ const $b86fa7aeb3b96990$var$space = [
    9,
    10,
    11,
    12,
    13,
    32,
    133,
    160,
    5760,
    8192,
    8193,
    8194,
    8195,
    8196,
    8197,
    8198,
    8199,
    8200,
    8201,
    8202,
    8232,
    8233,
    8239,
    8287,
    12288
];
const $b86fa7aeb3b96990$var$braceR = 125, $b86fa7aeb3b96990$var$semicolon = 59, $b86fa7aeb3b96990$var$slash = 47, $b86fa7aeb3b96990$var$star = 42, $b86fa7aeb3b96990$var$plus = 43, $b86fa7aeb3b96990$var$minus = 45, $b86fa7aeb3b96990$var$lt = 60, $b86fa7aeb3b96990$var$comma = 44, $b86fa7aeb3b96990$var$question = 63, $b86fa7aeb3b96990$var$dot = 46, $b86fa7aeb3b96990$var$bracketL = 91;
const $b86fa7aeb3b96990$var$trackNewline = new (0, $2sfCn.ContextTracker)({
    start: false,
    shift (context, term) {
        return term == $b86fa7aeb3b96990$var$LineComment || term == $b86fa7aeb3b96990$var$BlockComment || term == $b86fa7aeb3b96990$var$spaces ? context : term == $b86fa7aeb3b96990$var$newline;
    },
    strict: false
});
const $b86fa7aeb3b96990$var$insertSemicolon = new (0, $2sfCn.ExternalTokenizer)((input, stack)=>{
    let { next: next } = input;
    if (next == $b86fa7aeb3b96990$var$braceR || next == -1 || stack.context) input.acceptToken($b86fa7aeb3b96990$var$insertSemi);
}, {
    contextual: true,
    fallback: true
});
const $b86fa7aeb3b96990$var$noSemicolon = new (0, $2sfCn.ExternalTokenizer)((input, stack)=>{
    let { next: next } = input, after;
    if ($b86fa7aeb3b96990$var$space.indexOf(next) > -1) return;
    if (next == $b86fa7aeb3b96990$var$slash && ((after = input.peek(1)) == $b86fa7aeb3b96990$var$slash || after == $b86fa7aeb3b96990$var$star)) return;
    if (next != $b86fa7aeb3b96990$var$braceR && next != $b86fa7aeb3b96990$var$semicolon && next != -1 && !stack.context) input.acceptToken($b86fa7aeb3b96990$var$noSemi);
}, {
    contextual: true
});
const $b86fa7aeb3b96990$var$noSemicolonType = new (0, $2sfCn.ExternalTokenizer)((input, stack)=>{
    if (input.next == $b86fa7aeb3b96990$var$bracketL && !stack.context) input.acceptToken($b86fa7aeb3b96990$var$noSemiType);
}, {
    contextual: true
});
const $b86fa7aeb3b96990$var$operatorToken = new (0, $2sfCn.ExternalTokenizer)((input, stack)=>{
    let { next: next } = input;
    if (next == $b86fa7aeb3b96990$var$plus || next == $b86fa7aeb3b96990$var$minus) {
        input.advance();
        if (next == input.next) {
            input.advance();
            let mayPostfix = !stack.context && stack.canShift($b86fa7aeb3b96990$var$incdec);
            input.acceptToken(mayPostfix ? $b86fa7aeb3b96990$var$incdec : $b86fa7aeb3b96990$var$incdecPrefix);
        }
    } else if (next == $b86fa7aeb3b96990$var$question && input.peek(1) == $b86fa7aeb3b96990$var$dot) {
        input.advance();
        input.advance();
        if (input.next < 48 || input.next > 57) input.acceptToken($b86fa7aeb3b96990$var$questionDot);
    }
}, {
    contextual: true
});
function $b86fa7aeb3b96990$var$identifierChar(ch, start) {
    return ch >= 65 && ch <= 90 || ch >= 97 && ch <= 122 || ch == 95 || ch >= 192 || !start && ch >= 48 && ch <= 57;
}
const $b86fa7aeb3b96990$var$jsx = new (0, $2sfCn.ExternalTokenizer)((input, stack)=>{
    if (input.next != $b86fa7aeb3b96990$var$lt || !stack.dialectEnabled($b86fa7aeb3b96990$var$Dialect_jsx)) return;
    input.advance();
    if (input.next == $b86fa7aeb3b96990$var$slash) return;
    // Scan for an identifier followed by a comma or 'extends', don't
    // treat this as a start tag if present.
    let back = 0;
    while($b86fa7aeb3b96990$var$space.indexOf(input.next) > -1){
        input.advance();
        back++;
    }
    if ($b86fa7aeb3b96990$var$identifierChar(input.next, true)) {
        input.advance();
        back++;
        while($b86fa7aeb3b96990$var$identifierChar(input.next, false)){
            input.advance();
            back++;
        }
        while($b86fa7aeb3b96990$var$space.indexOf(input.next) > -1){
            input.advance();
            back++;
        }
        if (input.next == $b86fa7aeb3b96990$var$comma) return;
        for(let i = 0;; i++){
            if (i == 7) {
                if (!$b86fa7aeb3b96990$var$identifierChar(input.next, true)) return;
                break;
            }
            if (input.next != "extends".charCodeAt(i)) break;
            input.advance();
            back++;
        }
    }
    input.acceptToken($b86fa7aeb3b96990$var$JSXStartTag, -back);
});
const $b86fa7aeb3b96990$var$jsHighlight = (0, $lhXhg.styleTags)({
    "get set async static": (0, $lhXhg.tags).modifier,
    "for while do if else switch try catch finally return throw break continue default case": (0, $lhXhg.tags).controlKeyword,
    "in of await yield void typeof delete instanceof": (0, $lhXhg.tags).operatorKeyword,
    "let var const using function class extends": (0, $lhXhg.tags).definitionKeyword,
    "import export from": (0, $lhXhg.tags).moduleKeyword,
    "with debugger as new": (0, $lhXhg.tags).keyword,
    TemplateString: (0, $lhXhg.tags).special((0, $lhXhg.tags).string),
    super: (0, $lhXhg.tags).atom,
    BooleanLiteral: (0, $lhXhg.tags).bool,
    this: (0, $lhXhg.tags).self,
    null: (0, $lhXhg.tags).null,
    Star: (0, $lhXhg.tags).modifier,
    VariableName: (0, $lhXhg.tags).variableName,
    "CallExpression/VariableName TaggedTemplateExpression/VariableName": (0, $lhXhg.tags).function((0, $lhXhg.tags).variableName),
    VariableDefinition: (0, $lhXhg.tags).definition((0, $lhXhg.tags).variableName),
    Label: (0, $lhXhg.tags).labelName,
    PropertyName: (0, $lhXhg.tags).propertyName,
    PrivatePropertyName: (0, $lhXhg.tags).special((0, $lhXhg.tags).propertyName),
    "CallExpression/MemberExpression/PropertyName": (0, $lhXhg.tags).function((0, $lhXhg.tags).propertyName),
    "FunctionDeclaration/VariableDefinition": (0, $lhXhg.tags).function((0, $lhXhg.tags).definition((0, $lhXhg.tags).variableName)),
    "ClassDeclaration/VariableDefinition": (0, $lhXhg.tags).definition((0, $lhXhg.tags).className),
    "NewExpression/VariableName": (0, $lhXhg.tags).className,
    PropertyDefinition: (0, $lhXhg.tags).definition((0, $lhXhg.tags).propertyName),
    PrivatePropertyDefinition: (0, $lhXhg.tags).definition((0, $lhXhg.tags).special((0, $lhXhg.tags).propertyName)),
    UpdateOp: (0, $lhXhg.tags).updateOperator,
    "LineComment Hashbang": (0, $lhXhg.tags).lineComment,
    BlockComment: (0, $lhXhg.tags).blockComment,
    Number: (0, $lhXhg.tags).number,
    String: (0, $lhXhg.tags).string,
    Escape: (0, $lhXhg.tags).escape,
    ArithOp: (0, $lhXhg.tags).arithmeticOperator,
    LogicOp: (0, $lhXhg.tags).logicOperator,
    BitOp: (0, $lhXhg.tags).bitwiseOperator,
    CompareOp: (0, $lhXhg.tags).compareOperator,
    RegExp: (0, $lhXhg.tags).regexp,
    Equals: (0, $lhXhg.tags).definitionOperator,
    Arrow: (0, $lhXhg.tags).function((0, $lhXhg.tags).punctuation),
    ": Spread": (0, $lhXhg.tags).punctuation,
    "( )": (0, $lhXhg.tags).paren,
    "[ ]": (0, $lhXhg.tags).squareBracket,
    "{ }": (0, $lhXhg.tags).brace,
    "InterpolationStart InterpolationEnd": (0, $lhXhg.tags).special((0, $lhXhg.tags).brace),
    ".": (0, $lhXhg.tags).derefOperator,
    ", ;": (0, $lhXhg.tags).separator,
    "@": (0, $lhXhg.tags).meta,
    TypeName: (0, $lhXhg.tags).typeName,
    TypeDefinition: (0, $lhXhg.tags).definition((0, $lhXhg.tags).typeName),
    "type enum interface implements namespace module declare": (0, $lhXhg.tags).definitionKeyword,
    "abstract global Privacy readonly override": (0, $lhXhg.tags).modifier,
    "is keyof unique infer asserts": (0, $lhXhg.tags).operatorKeyword,
    JSXAttributeValue: (0, $lhXhg.tags).attributeValue,
    JSXText: (0, $lhXhg.tags).content,
    "JSXStartTag JSXStartCloseTag JSXSelfCloseEndTag JSXEndTag": (0, $lhXhg.tags).angleBracket,
    "JSXIdentifier JSXNameSpacedName": (0, $lhXhg.tags).tagName,
    "JSXAttribute/JSXIdentifier JSXAttribute/JSXNameSpacedName": (0, $lhXhg.tags).attributeName,
    "JSXBuiltin/JSXIdentifier": (0, $lhXhg.tags).standard((0, $lhXhg.tags).tagName)
});
// This file was generated by lezer-generator. You probably shouldn't edit it.
const $b86fa7aeb3b96990$var$spec_identifier = {
    __proto__: null,
    export: 20,
    as: 25,
    from: 33,
    default: 36,
    async: 41,
    function: 42,
    const: 52,
    extends: 56,
    this: 60,
    true: 68,
    false: 68,
    null: 80,
    void: 84,
    typeof: 88,
    super: 104,
    new: 138,
    delete: 150,
    yield: 159,
    await: 163,
    class: 168,
    public: 231,
    private: 231,
    protected: 231,
    readonly: 233,
    instanceof: 252,
    satisfies: 255,
    in: 256,
    import: 290,
    keyof: 347,
    unique: 351,
    infer: 357,
    asserts: 393,
    is: 395,
    abstract: 415,
    implements: 417,
    type: 419,
    let: 422,
    var: 424,
    using: 427,
    interface: 433,
    enum: 437,
    namespace: 443,
    module: 445,
    declare: 449,
    global: 453,
    for: 472,
    of: 481,
    while: 484,
    with: 488,
    do: 492,
    if: 496,
    else: 498,
    switch: 502,
    case: 508,
    try: 514,
    catch: 518,
    finally: 522,
    return: 526,
    throw: 530,
    break: 534,
    continue: 538,
    debugger: 542
};
const $b86fa7aeb3b96990$var$spec_word = {
    __proto__: null,
    async: 125,
    get: 127,
    set: 129,
    declare: 191,
    public: 193,
    private: 193,
    protected: 193,
    static: 195,
    abstract: 197,
    override: 199,
    readonly: 205,
    accessor: 207,
    new: 399
};
const $b86fa7aeb3b96990$var$spec_LessThan = {
    __proto__: null,
    "<": 189
};
const $b86fa7aeb3b96990$export$8f49e4af10703ce3 = (0, $2sfCn.LRParser).deserialize({
    version: 14,
    states: "$EOQ%TQlOOO%[QlOOO'_QpOOP(lO`OOO*zQ!0MxO'#CiO+RO#tO'#CjO+aO&jO'#CjO+oO#@ItO'#D_O.QQlO'#DeO.bQlO'#DpO%[QlO'#DxO0fQlO'#EQOOQ!0Lf'#EY'#EYO1PQ`O'#EVOOQO'#En'#EnOOQO'#Ij'#IjO1XQ`O'#GrO1dQ`O'#EmO1iQ`O'#EmO3hQ!0MxO'#JpO6[Q!0MxO'#JqO6uQ`O'#F[O6zQ,UO'#FsOOQ!0Lf'#Fe'#FeO7VO7dO'#FeO7eQMhO'#F{O9UQ`O'#FzOOQ!0Lf'#Jq'#JqOOQ!0Lb'#Jp'#JpO9ZQ`O'#GvOOQ['#K]'#K]O9fQ`O'#IWO9kQ!0LrO'#IXOOQ['#J^'#J^OOQ['#I]'#I]Q`QlOOQ`QlOOO9sQ!L^O'#DtO9zQlO'#D|O:RQlO'#EOO9aQ`O'#GrO:YQMhO'#CoO:hQ`O'#ElO:sQ`O'#EwO:xQMhO'#FdO;gQ`O'#GrOOQO'#K^'#K^O;lQ`O'#K^O;zQ`O'#GzO;zQ`O'#G{O;zQ`O'#G}O9aQ`O'#HQO<qQ`O'#HTO>YQ`O'#CeO>jQ`O'#HaO>rQ`O'#HgO>rQ`O'#HiO`QlO'#HkO>rQ`O'#HmO>rQ`O'#HpO>wQ`O'#HvO>|Q!0LsO'#H|O%[QlO'#IOO?XQ!0LsO'#IQO?dQ!0LsO'#ISO9kQ!0LrO'#IUO?oQ!0MxO'#CiO@qQpO'#DjQOQ`OOO%[QlO'#EOOAXQ`O'#ERO:YQMhO'#ElOAdQ`O'#ElOAoQ!bO'#FdOOQ['#Cg'#CgOOQ!0Lb'#Do'#DoOOQ!0Lb'#Jt'#JtO%[QlO'#JtOOQO'#Jw'#JwOOQO'#If'#IfOBoQpO'#EeOOQ!0Lb'#Ed'#EdOOQ!0Lb'#J{'#J{OCkQ!0MSO'#EeOCuQpO'#EUOOQO'#Jv'#JvODZQpO'#JwOEhQpO'#EUOCuQpO'#EePEuO&2DjO'#CbPOOO)CD{)CD{OOOO'#I^'#I^OFQO#tO,59UOOQ!0Lh,59U,59UOOOO'#I_'#I_OF`O&jO,59UOFnQ!L^O'#DaOOOO'#Ia'#IaOFuO#@ItO,59yOOQ!0Lf,59y,59yOGTQlO'#IbOGhQ`O'#JrOIgQ!fO'#JrO+}QlO'#JrOInQ`O,5:POJUQ`O'#EnOJcQ`O'#KROJnQ`O'#KQOJnQ`O'#KQOJvQ`O,5;[OJ{Q`O'#KPOOQ!0Ln,5:[,5:[OKSQlO,5:[OMQQ!0MxO,5:dOMqQ`O,5:lON[Q!0LrO'#KOONcQ`O'#J}O9ZQ`O'#J}ONwQ`O'#J}O! PQ`O,5;ZO! UQ`O'#J}O!#ZQ!fO'#JqOOQ!0Lh'#Ci'#CiO%[QlO'#EQO!#yQ!fO,5:qOOQS'#Jx'#JxOOQO-E<h-E<hO9aQ`O,5=^O!$aQ`O,5=^O!$fQlO,5;XO!&iQMhO'#EiO!(SQ`O,5;XO!(XQlO'#DwO!(cQpO,5;bO!(kQpO,5;bO%[QlO,5;bOOQ['#FS'#FSOOQ['#FU'#FUO%[QlO,5;cO%[QlO,5;cO%[QlO,5;cO%[QlO,5;cO%[QlO,5;cO%[QlO,5;cO%[QlO,5;cO%[QlO,5;cO%[QlO,5;cO%[QlO,5;cOOQ['#FY'#FYO!(yQlO,5;sOOQ!0Lf,5;x,5;xOOQ!0Lf,5;y,5;yOOQ!0Lf,5;{,5;{O%[QlO'#InO!*|Q!0LrO,5<hO%[QlO,5;cO!&iQMhO,5;cO!+kQMhO,5;cO!-]QMhO'#E[O%[QlO,5;vOOQ!0Lf,5;z,5;zO!-dQ,UO'#FiO!.aQ,UO'#KVO!-{Q,UO'#KVO!.hQ,UO'#KVOOQO'#KV'#KVO!.|Q,UO,5<ROOOW,5<_,5<_O!/_QlO'#FuOOOW'#Im'#ImO7VO7dO,5<PO!/fQ,UO'#FwOOQ!0Lf,5<P,5<PO!0VQ$IUO'#CwOOQ!0Lh'#C{'#C{O!0jO#@ItO'#DPO!1WQMjO,5<dO!1_Q`O,5<gO!2zQ(CWO'#GWO!3XQ`O'#GXO!3^Q`O'#GXO!4|Q(CWO'#G]O!6RQpO'#GaOOQO'#Gm'#GmO!+rQMhO'#GlOOQO'#Go'#GoO!+rQMhO'#GnO!6tQ$IUO'#JjOOQ!0Lh'#Jj'#JjO!7OQ`O'#JiO!7^Q`O'#JhO!7fQ`O'#CuOOQ!0Lh'#Cy'#CyO!7qQ`O'#C{OOQ!0Lh'#DT'#DTOOQ!0Lh'#DV'#DVO1SQ`O'#DXO!+rQMhO'#GOO!+rQMhO'#GQO!7vQ`O'#GSO!7{Q`O'#GTO!3^Q`O'#GZO!+rQMhO'#G`O;zQ`O'#JiO!8QQ`O'#EoO!8oQ`O,5<fOOQ!0Lb'#Cr'#CrO!8wQ`O'#EpO!9qQpO'#EqOOQ!0Lb'#KP'#KPO!9xQ!0LrO'#K_O9kQ!0LrO,5=bO`QlO,5>rOOQ['#Jf'#JfOOQ[,5>s,5>sOOQ[-E<Z-E<ZO!;wQ!0MxO,5:`O!9lQpO,5:^O!>bQ!0MxO,5:hO%[QlO,5:hO!@xQ!0MxO,5:jOOQO,5@x,5@xO!AiQMhO,5=^O!AwQ!0LrO'#JgO9UQ`O'#JgO!BYQ!0LrO,59ZO!BeQpO,59ZO!BmQMhO,59ZO:YQMhO,59ZO!BxQ`O,5;XO!CQQ`O'#H`O!CfQ`O'#KbO%[QlO,5;|O!9lQpO,5<OO!CnQ`O,5=yO!CsQ`O,5=yO!CxQ`O,5=yO9kQ!0LrO,5=yO;zQ`O,5=iOOQO'#Cw'#CwO!DWQpO,5=fO!D`QMhO,5=gO!DkQ`O,5=iO!DpQ!bO,5=lO!DxQ`O'#K^O>wQ`O'#HVO9aQ`O'#HXO!D}Q`O'#HXO:YQMhO'#HZO!ESQ`O'#HZOOQ[,5=o,5=oO!EXQ`O'#H[O!EjQ`O'#CoO!EoQ`O,59PO!EyQ`O,59PO!HOQlO,59POOQ[,59P,59PO!H`Q!0LrO,59PO%[QlO,59PO!JkQlO'#HcOOQ['#Hd'#HdOOQ['#He'#HeO`QlO,5={O!KRQ`O,5={O`QlO,5>RO`QlO,5>TO!KWQ`O,5>VO`QlO,5>XO!K]Q`O,5>[O!KbQlO,5>bOOQ[,5>h,5>hO%[QlO,5>hO9kQ!0LrO,5>jOOQ[,5>l,5>lO# lQ`O,5>lOOQ[,5>n,5>nO# lQ`O,5>nOOQ[,5>p,5>pO#!YQpO'#D]O%[QlO'#JtO#!{QpO'#JtO##VQpO'#DkO##hQpO'#DkO#%yQlO'#DkO#&QQ`O'#JsO#&YQ`O,5:UO#&_Q`O'#ErO#&mQ`O'#KSO#&uQ`O,5;]O#&zQpO'#DkO#'XQpO'#ETOOQ!0Lf,5:m,5:mO%[QlO,5:mO#'`Q`O,5:mO>wQ`O,5;WO!BeQpO,5;WO!BmQMhO,5;WO:YQMhO,5;WO#'hQ`O,5@`O#'mQ07dO,5:qOOQO-E<d-E<dO#(sQ!0MSO,5;POCuQpO,5:pO#(}QpO,5:pOCuQpO,5;PO!BYQ!0LrO,5:pOOQ!0Lb'#Eh'#EhOOQO,5;P,5;PO%[QlO,5;PO#)[Q!0LrO,5;PO#)gQ!0LrO,5;PO!BeQpO,5:pOOQO,5;V,5;VO#)uQ!0LrO,5;PPOOO'#I['#I[P#*ZO&2DjO,58|POOO,58|,58|OOOO-E<[-E<[OOQ!0Lh1G.p1G.pOOOO-E<]-E<]OOOO,59{,59{O#*fQ!bO,59{OOOO-E<_-E<_OOQ!0Lf1G/e1G/eO#*kQ!fO,5>|O+}QlO,5>|OOQO,5?S,5?SO#*uQlO'#IbOOQO-E<`-E<`O#+SQ`O,5@^O#+[Q!fO,5@^O#+cQ`O,5@lOOQ!0Lf1G/k1G/kO%[QlO,5@mO#+kQ`O'#IhOOQO-E<f-E<fO#+cQ`O,5@lOOQ!0Lb1G0v1G0vOOQ!0Ln1G/v1G/vOOQ!0Ln1G0W1G0WO%[QlO,5@jO#,PQ!0LrO,5@jO#,bQ!0LrO,5@jO#,iQ`O,5@iO9ZQ`O,5@iO#,qQ`O,5@iO#-PQ`O'#IkO#,iQ`O,5@iOOQ!0Lb1G0u1G0uO!(cQpO,5:sO!(nQpO,5:sOOQS,5:u,5:uO#-qQdO,5:uO#-yQMhO1G2xO9aQ`O1G2xOOQ!0Lf1G0s1G0sO#.XQ!0MxO1G0sO#/^Q!0MvO,5;TOOQ!0Lh'#GV'#GVO#/zQ!0MzO'#JjO!$fQlO1G0sO#2VQ!fO'#JuO%[QlO'#JuO#2aQ`O,5:cOOQ!0Lh'#D]'#D]OOQ!0Lf1G0|1G0|O%[QlO1G0|OOQ!0Lf1G1e1G1eO#2fQ`O1G0|O#4zQ!0MxO1G0}O#5RQ!0MxO1G0}O#7iQ!0MxO1G0}O#7pQ!0MxO1G0}O#:WQ!0MxO1G0}O#<nQ!0MxO1G0}O#<uQ!0MxO1G0}O#<|Q!0MxO1G0}O#?dQ!0MxO1G0}O#?kQ!0MxO1G0}O#AxQ?MtO'#CiO#CsQ?MtO1G1_O#CzQ?MtO'#JqO#D_Q!0MxO,5?YOOQ!0Lb-E<l-E<lO#FlQ!0MxO1G0}O#GiQ!0MzO1G0}OOQ!0Lf1G0}1G0}O#HlQMjO'#JzO#HvQ`O,5:vO#H{Q!0MxO1G1bO#IoQ,UO,5<VO#IwQ,UO,5<WO#JPQ,UO'#FnO#JhQ`O'#FmOOQO'#KW'#KWOOQO'#Il'#IlO#JmQ,UO1G1mOOQ!0Lf1G1m1G1mOOOW1G1x1G1xO#KOQ?MtO'#JpO#KYQ`O,5<aO!(yQlO,5<aOOOW-E<k-E<kOOQ!0Lf1G1k1G1kO#K_QpO'#KVOOQ!0Lf,5<c,5<cO#KgQpO,5<cO#KlQMhO'#DROOOO'#I`'#I`O#KsO#@ItO,59kOOQ!0Lh,59k,59kO%[QlO1G2OO!7{Q`O'#IpO#LOQ`O,5<yOOQ!0Lh,5<v,5<vO!+rQMhO'#IsO#LlQMjO,5=WO!+rQMhO'#IuO#M_QMjO,5=YO!&iQMhO,5=[OOQO1G2R1G2RO#MiQ!dO'#CrO#M|Q(CWO'#EpO$ RQpO'#GaO$ iQ!dO,5<rO$ pQ`O'#KYO9ZQ`O'#KYO$!OQ`O,5<tO!+rQMhO,5<sO$!TQ`O'#GYO$!fQ`O,5<sO$!kQ!dO'#GVO$!xQ!dO'#KZO$#SQ`O'#KZO!&iQMhO'#KZO$#XQ`O,5<wO$#^QlO'#JtO$#hQpO'#GbO##hQpO'#GbO$#yQ`O'#GfO!3^Q`O'#GjO$$OQ!0LrO'#IrO$$ZQpO,5<{OOQ!0Lp,5<{,5<{O$$bQpO'#GbO$$oQpO'#GcO$%QQpO'#GcO$%VQMjO,5=WO$%gQMjO,5=YOOQ!0Lh,5=],5=]O!+rQMhO,5@TO!+rQMhO,5@TO$%wQ`O'#IwO$&VQ`O,5@SO$&_Q`O,59aOOQ!0Lh,59g,59gO$'UQ$IYO,59sOOQ!0Lh'#Jn'#JnO$'wQMjO,5<jO$(jQMjO,5<lO@iQ`O,5<nOOQ!0Lh,5<o,5<oO$(tQ`O,5<uO$(yQMjO,5<zO$)ZQ`O,5@TO$)iQ`O'#J}O!$fQlO1G2QO$)nQ`O1G2QO9ZQ`O'#KQO9ZQ`O'#ErO%[QlO'#ErO9ZQ`O'#IyO$)sQ!0LrO,5@yOOQ[1G2|1G2|OOQ[1G4^1G4^OOQ!0Lf1G/z1G/zOOQ!0Lf1G/x1G/xO$+uQ!0MxO1G0SOOQ[1G2x1G2xO!&iQMhO1G2xO%[QlO1G2xO#-|Q`O1G2xO$-yQMhO'#EiOOQ!0Lb,5@R,5@RO$.WQ!0LrO,5@ROOQ[1G.u1G.uO!BYQ!0LrO1G.uO!BeQpO1G.uO!BmQMhO1G.uO$.iQ`O1G0sO$.nQ`O'#CiO$.yQ`O'#KcO$/RQ`O,5=zO$/WQ`O'#KcO$/]Q`O'#KcO$/kQ`O'#JPO$/yQ`O,5@|O$0RQ!fO1G1hOOQ!0Lf1G1j1G1jO9aQ`O1G3eO@iQ`O1G3eO$0YQ`O1G3eO$0_Q`O1G3eOOQ[1G3e1G3eO!DkQ`O1G3TO!&iQMhO1G3QO$0dQ`O1G3QOOQ[1G3R1G3RO!&iQMhO1G3RO$0iQ`O1G3RO$0qQpO'#HPOOQ[1G3T1G3TO!5|QpO'#I{O!DpQ!bO1G3WOOQ[1G3W1G3WOOQ[,5=q,5=qO$0yQMhO,5=sO9aQ`O,5=sO$#yQ`O,5=uO9UQ`O,5=uO!BeQpO,5=uO!BmQMhO,5=uO:YQMhO,5=uO$1XQ`O'#KaO$1dQ`O,5=vOOQ[1G.k1G.kO$1iQ!0LrO1G.kO@iQ`O1G.kO$1tQ`O1G.kO9kQ!0LrO1G.kO$3|Q!fO,5AOO$4ZQ`O,5AOO9ZQ`O,5AOO$4fQlO,5=}O$4mQ`O,5=}OOQ[1G3g1G3gO`QlO1G3gOOQ[1G3m1G3mOOQ[1G3o1G3oO>rQ`O1G3qO$4rQlO1G3sO$8vQlO'#HrOOQ[1G3v1G3vO$9TQ`O'#HxO>wQ`O'#HzOOQ[1G3|1G3|O$9]QlO1G3|O9kQ!0LrO1G4SOOQ[1G4U1G4UOOQ!0Lb'#G^'#G^O9kQ!0LrO1G4WO9kQ!0LrO1G4YO$=dQ`O,5@`O!(yQlO,5;^O9ZQ`O,5;^O>wQ`O,5:VO!(yQlO,5:VO!BeQpO,5:VO$=iQ?MtO,5:VOOQO,5;^,5;^O$=sQpO'#IcO$>ZQ`O,5@_OOQ!0Lf1G/p1G/pO$>cQpO'#IiO$>mQ`O,5@nOOQ!0Lb1G0w1G0wO##hQpO,5:VOOQO'#Ie'#IeO$>uQpO,5:oOOQ!0Ln,5:o,5:oO#'cQ`O1G0XOOQ!0Lf1G0X1G0XO%[QlO1G0XOOQ!0Lf1G0r1G0rO>wQ`O1G0rO!BeQpO1G0rO!BmQMhO1G0rOOQ!0Lb1G5z1G5zO!BYQ!0LrO1G0[OOQO1G0k1G0kO%[QlO1G0kO$>|Q!0LrO1G0kO$?XQ!0LrO1G0kO!BeQpO1G0[OCuQpO1G0[O$?gQ!0LrO1G0kOOQO1G0[1G0[O$?{Q!0MxO1G0kPOOO-E<Y-E<YPOOO1G.h1G.hOOOO1G/g1G/gO$@VQ!bO,5<hO$@_Q!fO1G4hOOQO1G4n1G4nO%[QlO,5>|O$@iQ`O1G5xO$@qQ`O1G6WO$@yQ!fO1G6XO9ZQ`O,5?SO$ATQ!0MxO1G6UO%[QlO1G6UO$AeQ!0LrO1G6UO$AvQ`O1G6TO$AvQ`O1G6TO9ZQ`O1G6TO$BOQ`O,5?VO9ZQ`O,5?VOOQO,5?V,5?VO$BdQ`O,5?VO$)iQ`O,5?VOOQO-E<i-E<iOOQS1G0_1G0_OOQS1G0a1G0aO#-tQ`O1G0aOOQ[7+(d7+(dO!&iQMhO7+(dO%[QlO7+(dO$BrQ`O7+(dO$B}QMhO7+(dO$C]Q!0MzO,5=WO$EhQ!0MzO,5=YO$GsQ!0MzO,5=WO$JUQ!0MzO,5=YO$LgQ!0MzO,59sO$NlQ!0MzO,5<jO%!wQ!0MzO,5<lO%%SQ!0MzO,5<zOOQ!0Lf7+&_7+&_O%'eQ!0MxO7+&_O%(XQlO'#IdO%(fQ`O,5@aO%(nQ!fO,5@aOOQ!0Lf1G/}1G/}O%(xQ`O7+&hOOQ!0Lf7+&h7+&hO%(}Q?MtO,5:dO%[QlO7+&yO%)XQ?MtO,5:`O%)fQ?MtO,5:hO%)pQ?MtO,5:jO%)zQMhO'#IgO%*UQ`O,5@fOOQ!0Lh1G0b1G0bOOQO1G1q1G1qOOQO1G1r1G1rO%*^Q!jO,5<YO!(yQlO,5<XOOQO-E<j-E<jOOQ!0Lf7+'X7+'XOOOW7+'d7+'dOOOW1G1{1G1{O%*iQ`O1G1{OOQ!0Lf1G1}1G1}OOOO,59m,59mO%*nQ!dO,59mOOOO-E<^-E<^OOQ!0Lh1G/V1G/VO%*uQ!0MxO7+'jOOQ!0Lh,5?[,5?[O%+iQMhO1G2eP%+pQ`O'#IpPOQ!0Lh-E<n-E<nO%,^QMjO,5?_OOQ!0Lh-E<q-E<qO%-PQMjO,5?aOOQ!0Lh-E<s-E<sO%-ZQ!dO1G2vO%-bQ!dO'#CrO%-xQMhO'#KQO$#^QlO'#JtOOQ!0Lh1G2^1G2^O%.PQ`O'#IoO%.eQ`O,5@tO%.eQ`O,5@tO%.mQ`O,5@tO%.xQ`O,5@tOOQO1G2`1G2`O%/WQMjO1G2_O!+rQMhO1G2_O%/hQ(CWO'#IqO%/uQ`O,5@uO!&iQMhO,5@uO%/}Q!dO,5@uOOQ!0Lh1G2c1G2cO%2_Q!fO'#CiO%2iQ`O,5=OOOQ!0Lb,5<|,5<|O%2qQpO,5<|OOQ!0Lb,5<},5<}OCfQ`O,5<|O%2|QpO,5<|OOQ!0Lb,5=Q,5=QO$)iQ`O,5=UOOQO,5?^,5?^OOQO-E<p-E<pOOQ!0Lp1G2g1G2gO##hQpO,5<|O$#^QlO,5=OO%3[Q`O,5<}O%3gQpO,5<}O!+rQMhO'#IsO%4aQMjO1G2rO!+rQMhO'#IuO%5SQMjO1G2tO%5^QMjO1G5oO%5hQMjO1G5oOOQO,5?c,5?cOOQO-E<u-E<uOOQO1G.{1G.{O!9lQpO,59uO%[QlO,59uOOQ!0Lh,5<i,5<iO%5uQ`O1G2YO!+rQMhO1G2aO!+rQMhO1G5oO!+rQMhO1G5oO%5zQ!0MxO7+'lOOQ!0Lf7+'l7+'lO!$fQlO7+'lO%6nQ`O,5;^OOQ!0Lb,5?e,5?eOOQ!0Lb-E<w-E<wO%6sQ!dO'#K[O#'cQ`O7+(dO4UQ!fO7+(dO$BuQ`O7+(dO%6}Q!0MvO'#CiO%7nQ!0LrO,5=RO%8PQ!0MvO,5=RO%8dQ`O,5=ROOQ!0Lb1G5m1G5mOOQ[7+$a7+$aO!BYQ!0LrO7+$aO!BeQpO7+$aO!$fQlO7+&_O%8lQ`O'#JOO%9TQ`O,5@}OOQO1G3f1G3fO9aQ`O,5@}O%9TQ`O,5@}O%9]Q`O,5@}OOQO,5?k,5?kOOQO-E<}-E<}OOQ!0Lf7+'S7+'SO%9bQ`O7+)PO9kQ!0LrO7+)PO9aQ`O7+)PO@iQ`O7+)POOQ[7+(o7+(oO%9gQ!0MvO7+(lO!&iQMhO7+(lO!DfQ`O7+(mOOQ[7+(m7+(mO!&iQMhO7+(mO%9qQ`O'#K`O%9|Q`O,5=kOOQO,5?g,5?gOOQO-E<y-E<yOOQ[7+(r7+(rO%;`QpO'#HYOOQ[1G3_1G3_O!&iQMhO1G3_O%[QlO1G3_O%;gQ`O1G3_O%;rQMhO1G3_O9kQ!0LrO1G3aO$#yQ`O1G3aO9UQ`O1G3aO!BeQpO1G3aO!BmQMhO1G3aO%<QQ`O'#I}O%<fQ`O,5@{O%<nQpO,5@{OOQ!0Lb1G3b1G3bOOQ[7+$V7+$VO@iQ`O7+$VO9kQ!0LrO7+$VO%<yQ`O7+$VO%[QlO1G6jO%[QlO1G6kO%=OQ!0LrO1G6jO%=YQlO1G3iO%=aQ`O1G3iO%=fQlO1G3iOOQ[7+)R7+)RO9kQ!0LrO7+)]O`QlO7+)_OOQ['#Kf'#KfOOQ['#JQ'#JQO%=mQlO,5>^OOQ[,5>^,5>^O%[QlO'#HsO%=zQ`O'#HuOOQ[,5>d,5>dO9ZQ`O,5>dOOQ[,5>f,5>fOOQ[7+)h7+)hOOQ[7+)n7+)nOOQ[7+)r7+)rOOQ[7+)t7+)tO%>PQpO1G5zO%>kQ?MtO1G0xO%>uQ`O1G0xOOQO1G/q1G/qO%?QQ?MtO1G/qO>wQ`O1G/qO!(yQlO'#DkOOQO,5>},5>}OOQO-E<a-E<aOOQO,5?T,5?TOOQO-E<g-E<gO!BeQpO1G/qOOQO-E<c-E<cOOQ!0Ln1G0Z1G0ZOOQ!0Lf7+%s7+%sO#'cQ`O7+%sOOQ!0Lf7+&^7+&^O>wQ`O7+&^O!BeQpO7+&^OOQO7+%v7+%vO$?{Q!0MxO7+&VOOQO7+&V7+&VO%[QlO7+&VO%?[Q!0LrO7+&VO!BYQ!0LrO7+%vO!BeQpO7+%vO%?gQ!0LrO7+&VO%?uQ!0MxO7++pO%[QlO7++pO%@VQ`O7++oO%@VQ`O7++oOOQO1G4q1G4qO9ZQ`O1G4qO%@_Q`O1G4qOOQS7+%{7+%{O#'cQ`O<<LOO4UQ!fO<<LOO%@mQ`O<<LOOOQ[<<LO<<LOO!&iQMhO<<LOO%[QlO<<LOO%@uQ`O<<LOO%AQQ!0MzO,5?_O%C]Q!0MzO,5?aO%EhQ!0MzO1G2_O%GyQ!0MzO1G2rO%JUQ!0MzO1G2tO%LaQ!fO,5?OO%[QlO,5?OOOQO-E<b-E<bO%LkQ`O1G5{OOQ!0Lf<<JS<<JSO%LsQ?MtO1G0sO%NzQ?MtO1G0}O& RQ?MtO1G0}O&#SQ?MtO1G0}O&#ZQ?MtO1G0}O&%[Q?MtO1G0}O&']Q?MtO1G0}O&'dQ?MtO1G0}O&'kQ?MtO1G0}O&)lQ?MtO1G0}O&)sQ?MtO1G0}O&)zQ!0MxO<<JeO&+rQ?MtO1G0}O&,oQ?MvO1G0}O&-rQ?MvO'#JjO&/xQ?MtO1G1bO&0VQ?MtO1G0SO&0aQMjO,5?ROOQO-E<e-E<eO!(yQlO'#FpOOQO'#KX'#KXOOQO1G1t1G1tO&0kQ`O1G1sO&0pQ?MtO,5?YOOOW7+'g7+'gOOOO1G/X1G/XO&0zQ!dO1G4vOOQ!0Lh7+(P7+(PP!&iQMhO,5?[O!+rQMhO7+(bO&1RQ`O,5?ZO9ZQ`O,5?ZOOQO-E<m-E<mO&1aQ`O1G6`O&1aQ`O1G6`O&1iQ`O1G6`O&1tQMjO7+'yO&2UQ!dO,5?]O&2`Q`O,5?]O!&iQMhO,5?]OOQO-E<o-E<oO&2eQ!dO1G6aO&2oQ`O1G6aO&2wQ`O1G2jO!&iQMhO1G2jOOQ!0Lb1G2h1G2hOOQ!0Lb1G2i1G2iO%2qQpO1G2hO!BeQpO1G2hOCfQ`O1G2hOOQ!0Lb1G2p1G2pO&2|QpO1G2hO&3[Q`O1G2jO$)iQ`O1G2iOCfQ`O1G2iO$#^QlO1G2jO&3dQ`O1G2iO&4WQMjO,5?_OOQ!0Lh-E<r-E<rO&4yQMjO,5?aOOQ!0Lh-E<t-E<tO!+rQMhO7++ZOOQ!0Lh1G/a1G/aO&5TQ`O1G/aOOQ!0Lh7+'t7+'tO&5YQMjO7+'{O&5jQMjO7++ZO&5tQMjO7++ZO&6RQ!0MxO<<KWOOQ!0Lf<<KW<<KWO&6uQ`O1G0xO!&iQMhO'#IxO&6zQ`O,5@vO&8|Q!fO<<LOO!&iQMhO1G2mO&9TQ!0LrO1G2mOOQ[<<G{<<G{O!BYQ!0LrO<<G{O&9fQ!0MxO<<IyOOQ!0Lf<<Iy<<IyOOQO,5?j,5?jO&:YQ`O,5?jO&:_Q`O,5?jOOQO-E<|-E<|O&:mQ`O1G6iO&:mQ`O1G6iO9aQ`O1G6iO@iQ`O<<LkOOQ[<<Lk<<LkO&:uQ`O<<LkO9kQ!0LrO<<LkOOQ[<<LW<<LWO%9gQ!0MvO<<LWOOQ[<<LX<<LXO!DfQ`O<<LXO&:zQpO'#IzO&;VQ`O,5@zO!(yQlO,5@zOOQ[1G3V1G3VOOQO'#I|'#I|O9kQ!0LrO'#I|O&;_QpO,5=tOOQ[,5=t,5=tO&;fQpO'#EeO&;mQpO'#GdO&;rQ`O7+(yO&;wQ`O7+(yOOQ[7+(y7+(yO!&iQMhO7+(yO%[QlO7+(yO&<PQ`O7+(yOOQ[7+({7+({O9kQ!0LrO7+({O$#yQ`O7+({O9UQ`O7+({O!BeQpO7+({O&<[Q`O,5?iOOQO-E<{-E<{OOQO'#H]'#H]O&<gQ`O1G6gO9kQ!0LrO<<GqOOQ[<<Gq<<GqO@iQ`O<<GqO&<oQ`O7+,UO&<tQ`O7+,VO%[QlO7+,UO%[QlO7+,VOOQ[7+)T7+)TO&<yQ`O7+)TO&=OQlO7+)TO&=VQ`O7+)TOOQ[<<Lw<<LwOOQ[<<Ly<<LyOOQ[-E=O-E=OOOQ[1G3x1G3xO&=[Q`O,5>_OOQ[,5>a,5>aO&=aQ`O1G4OO9ZQ`O7+&dO!(yQlO7+&dOOQO7+%]7+%]O&=fQ?MtO1G6XO>wQ`O7+%]OOQ!0Lf<<I_<<I_OOQ!0Lf<<Ix<<IxO>wQ`O<<IxOOQO<<Iq<<IqO$?{Q!0MxO<<IqO%[QlO<<IqOOQO<<Ib<<IbO!BYQ!0LrO<<IbO&=pQ!0LrO<<IqO&={Q!0MxO<= [O&>]Q`O<= ZOOQO7+*]7+*]O9ZQ`O7+*]OOQ[ANAjANAjO&>eQ!fOANAjO!&iQMhOANAjO#'cQ`OANAjO4UQ!fOANAjO&>lQ`OANAjO%[QlOANAjO&>tQ!0MzO7+'yO&AVQ!0MzO,5?_O&CbQ!0MzO,5?aO&EmQ!0MzO7+'{O&HOQ!fO1G4jO&HYQ?MtO7+&_O&J^Q?MvO,5=WO&LeQ?MvO,5=YO&LuQ?MvO,5=WO&MVQ?MvO,5=YO&MgQ?MvO,59sO' mQ?MvO,5<jO'#pQ?MvO,5<lO'&UQ?MvO,5<zO''zQ?MtO7+'jO'(XQ?MtO7+'lO'(fQ`O,5<[OOQO7+'_7+'_OOQ!0Lh7+*b7+*bO'(kQMjO<<K|OOQO1G4u1G4uO'(rQ`O1G4uO'(}Q`O1G4uO')]Q`O7++zO')]Q`O7++zO!&iQMhO1G4wO')eQ!dO1G4wO')oQ`O7++{O')wQ`O7+(UO'*SQ!dO7+(UOOQ!0Lb7+(S7+(SOOQ!0Lb7+(T7+(TO!BeQpO7+(SOCfQ`O7+(SO'*^Q`O7+(UO!&iQMhO7+(UO$)iQ`O7+(TO'*cQ`O7+(UOCfQ`O7+(TO'*kQMjO<<NuOOQ!0Lh7+${7+${O!+rQMhO<<NuO'*uQ!dO,5?dOOQO-E<v-E<vO'+PQ!0MvO7+(XO!&iQMhO7+(XOOQ[AN=gAN=gO9aQ`O1G5UOOQO1G5U1G5UO'+aQ`O1G5UO'+fQ`O7+,TO'+fQ`O7+,TO9kQ!0LrOANBVO@iQ`OANBVOOQ[ANBVANBVOOQ[ANArANArOOQ[ANAsANAsO'+nQ`O,5?fOOQO-E<x-E<xO'+yQ?MtO1G6fOOQO,5?h,5?hOOQO-E<z-E<zOOQ[1G3`1G3`O',TQ`O,5=OOOQ[<<Le<<LeO!&iQMhO<<LeO&;rQ`O<<LeO',YQ`O<<LeO%[QlO<<LeOOQ[<<Lg<<LgO9kQ!0LrO<<LgO$#yQ`O<<LgO9UQ`O<<LgO',bQpO1G5TO',mQ`O7+,ROOQ[AN=]AN=]O9kQ!0LrOAN=]OOQ[<= p<= pOOQ[<= q<= qO',uQ`O<= pO',zQ`O<= qOOQ[<<Lo<<LoO'-PQ`O<<LoO'-UQlO<<LoOOQ[1G3y1G3yO>wQ`O7+)jO'-]Q`O<<JOO'-hQ?MtO<<JOOOQO<<Hw<<HwOOQ!0LfAN?dAN?dOOQOAN?]AN?]O$?{Q!0MxOAN?]OOQOAN>|AN>|O%[QlOAN?]OOQO<<Mw<<MwOOQ[G27UG27UO!&iQMhOG27UO#'cQ`OG27UO'-rQ!fOG27UO4UQ!fOG27UO'-yQ`OG27UO'.RQ?MtO<<JeO'.`Q?MvO1G2_O'0UQ?MvO,5?_O'2XQ?MvO,5?aO'4[Q?MvO1G2rO'6_Q?MvO1G2tO'8bQ?MtO<<KWO'8oQ?MtO<<IyOOQO1G1v1G1vO!+rQMhOANAhOOQO7+*a7+*aO'8|Q`O7+*aO'9XQ`O<= fO'9aQ!dO7+*cOOQ!0Lb<<Kp<<KpO$)iQ`O<<KpOCfQ`O<<KpO'9kQ`O<<KpO!&iQMhO<<KpOOQ!0Lb<<Kn<<KnO!BeQpO<<KnO'9vQ!dO<<KpOOQ!0Lb<<Ko<<KoO':QQ`O<<KpO!&iQMhO<<KpO$)iQ`O<<KoO':VQMjOANDaO':aQ!0MvO<<KsOOQO7+*p7+*pO9aQ`O7+*pO':qQ`O<= oOOQ[G27qG27qO9kQ!0LrOG27qO!(yQlO1G5QO':yQ`O7+,QO';RQ`O1G2jO&;rQ`OANBPOOQ[ANBPANBPO!&iQMhOANBPO';WQ`OANBPOOQ[ANBRANBRO9kQ!0LrOANBRO$#yQ`OANBROOQO'#H^'#H^OOQO7+*o7+*oOOQ[G22wG22wOOQ[ANE[ANE[OOQ[ANE]ANE]OOQ[ANBZANBZO';`Q`OANBZOOQ[<<MU<<MUO!(yQlOAN?jOOQOG24wG24wO$?{Q!0MxOG24wO#'cQ`OLD,pOOQ[LD,pLD,pO!&iQMhOLD,pO';eQ!fOLD,pO';lQ?MvO7+'yO'=bQ?MvO,5?_O'?eQ?MvO,5?aO'AhQ?MvO7+'{O'C^QMjOG27SOOQO<<M{<<M{OOQ!0LbANA[ANA[O$)iQ`OANA[OCfQ`OANA[O'CnQ!dOANA[OOQ!0LbANAYANAYO'CuQ`OANA[O!&iQMhOANA[O'DQQ!dOANA[OOQ!0LbANAZANAZOOQO<<N[<<N[OOQ[LD-]LD-]O'D[Q?MtO7+*lOOQO'#Ge'#GeOOQ[G27kG27kO&;rQ`OG27kO!&iQMhOG27kOOQ[G27mG27mO9kQ!0LrOG27mOOQ[G27uG27uO'DfQ?MtOG25UOOQOLD*cLD*cOOQ[!$(![!$(![O#'cQ`O!$(![O!&iQMhO!$(![O'DpQ!0MzOG27SOOQ!0LbG26vG26vO$)iQ`OG26vO'GRQ`OG26vOCfQ`OG26vO'G^Q!dOG26vO!&iQMhOG26vOOQ[LD-VLD-VO&;rQ`OLD-VOOQ[LD-XLD-XOOQ[!)9Ev!)9EvO#'cQ`O!)9EvOOQ!0LbLD,bLD,bO$)iQ`OLD,bOCfQ`OLD,bO'GeQ`OLD,bO'GpQ!dOLD,bOOQ[!$(!q!$(!qOOQ[!.K;b!.K;bO'GwQ?MvOG27SOOQ!0Lb!$( |!$( |O$)iQ`O!$( |OCfQ`O!$( |O'ImQ`O!$( |OOQ!0Lb!)9Eh!)9EhO$)iQ`O!)9EhOCfQ`O!)9EhOOQ!0Lb!.K;S!.K;SO$)iQ`O!.K;SOOQ!0Lb!4/0n!4/0nO!(yQlO'#DxO1PQ`O'#EVO'IxQ!fO'#JpO'JPQ!L^O'#DtO'JWQlO'#D|O'J_Q!fO'#CiO'LuQ!fO'#CiO!(yQlO'#EOO'MVQlO,5;XO!(yQlO,5;cO!(yQlO,5;cO!(yQlO,5;cO!(yQlO,5;cO!(yQlO,5;cO!(yQlO,5;cO!(yQlO,5;cO!(yQlO,5;cO!(yQlO,5;cO!(yQlO,5;cO!(yQlO'#InO( YQ`O,5<hO!(yQlO,5;cO( bQMhO,5;cO(!{QMhO,5;cO!(yQlO,5;vO!&iQMhO'#GlO( bQMhO'#GlO!&iQMhO'#GnO( bQMhO'#GnO1SQ`O'#DXO1SQ`O'#DXO!&iQMhO'#GOO( bQMhO'#GOO!&iQMhO'#GQO( bQMhO'#GQO!&iQMhO'#G`O( bQMhO'#G`O!(yQlO,5:hO(#SQpO'#D]O(#^QpO'#JtO!(yQlO,5@mO'MVQlO1G0sO(#hQ?MtO'#CiO!(yQlO1G2OO!&iQMhO'#IsO( bQMhO'#IsO!&iQMhO'#IuO( bQMhO'#IuO(#rQ!dO'#CrO!&iQMhO,5<sO( bQMhO,5<sO'MVQlO1G2QO!(yQlO7+&yO!&iQMhO1G2_O( bQMhO1G2_O!&iQMhO'#IsO( bQMhO'#IsO!&iQMhO'#IuO( bQMhO'#IuO!&iQMhO1G2aO( bQMhO1G2aO'MVQlO7+'lO'MVQlO7+&_O!&iQMhOANAhO( bQMhOANAhO($VQ`O'#EmO($[Q`O'#EmO($dQ`O'#F[O($iQ`O'#EwO($nQ`O'#KRO($yQ`O'#KPO(%UQ`O,5;XO(%ZQMjO,5<dO(%bQ`O'#GXO(%gQ`O'#GXO(%lQ`O,5<fO(%tQ`O,5;XO(%|Q?MtO1G1_O(&TQ`O,5<sO(&YQ`O,5<sO(&_Q`O,5<uO(&dQ`O,5<uO(&iQ`O1G2QO(&nQ`O1G0sO(&sQMjO<<K|O(&zQMjO<<K|O7eQMhO'#F{O9UQ`O'#FzOAdQ`O'#ElO!(yQlO,5;sO!3^Q`O'#GXO!3^Q`O'#GXO!3^Q`O'#GZO!3^Q`O'#GZO!+rQMhO7+(bO!+rQMhO7+(bO%-ZQ!dO1G2vO%-ZQ!dO1G2vO!&iQMhO,5=[O!&iQMhO,5=[",
    stateData: "((P~O'zOS'{OSTOS'|RQ~OPYOQYOSfOY!VOaqOdzOeyOj!POnkOpYOqkOrkOxkOzYO|YO!QWO!UkO!VkO!]XO!guO!jZO!mYO!nYO!oYO!qvO!swO!vxO!z]O$V|O$miO%g}O%i!QO%k!OO%l!OO%m!OO%p!RO%r!SO%u!TO%v!TO%x!UO&U!WO&[!XO&^!YO&`!ZO&b![O&e!]O&k!^O&q!_O&s!`O&u!aO&w!bO&y!cO(RSO(TTO(WUO(_VO(m[O~OWtO~P`OPYOQYOSfOd!jOe!iOnkOpYOqkOrkOxkOzYO|YO!QWO!UkO!VkO!]!eO!guO!jZO!mYO!nYO!oYO!qvO!s!gO!v!hO$V!kO$miO(R!dO(TTO(WUO(_VO(m[O~Oa!wOq!nO!Q!oO!`!yO!a!vO!b!vO!z;wO#R!pO#S!pO#T!xO#U!pO#V!pO#Y!zO#Z!zO(S!lO(TTO(WUO(c!mO(m!sO~O'|!{O~OP]XR]X[]Xa]Xp]X!O]X!Q]X!Z]X!j]X!n]X#P]X#Q]X#^]X#ifX#l]X#m]X#n]X#o]X#p]X#q]X#r]X#s]X#t]X#u]X#w]X#y]X#z]X$P]X'x]X(_]X(p]X(w]X(x]X~O!e%QX~P(qO_!}O(T#PO(U!}O(V#PO~O_#QO(V#PO(W#PO(X#QO~Ov#SO!S#TO(`#TO(a#VO~OPYOQYOSfOd!jOe!iOnkOpYOqkOrkOxkOzYO|YO!QWO!UkO!VkO!]!eO!guO!jZO!mYO!nYO!oYO!qvO!s!gO!v!hO$V!kO$miO(R;{O(TTO(WUO(_VO(m[O~O!Y#ZO!Z#WO!W(fP!W(tP~P+}O![#cO~P`OPYOQYOSfOd!jOe!iOpYOqkOrkOxkOzYO|YO!QWO!UkO!VkO!]!eO!guO!jZO!mYO!nYO!oYO!qvO!s!gO!v!hO$V!kO$miO(TTO(WUO(_VO(m[O~On#mO!Y#iO!z]O#g#lO#h#iO(R;|O!i(qP~P.iO!j#oO(R#nO~O!v#sO!z]O%g#tO~O#i#uO~O!e#vO#i#uO~OP$[OR#zO[$cOp$aO!O#yO!Q#{O!Z$_O!j#xO!n$[O#P$RO#l$OO#m$PO#n$PO#o$PO#p$QO#q$RO#r$RO#s$bO#t$RO#u$SO#w$UO#y$WO#z$XO(_VO(p$YO(w#|O(x#}O~Oa(dX'x(dX'u(dX!i(dX!W(dX!](dX%h(dX!e(dX~P1qO#Q$dO#^$eO$P$eOP(eXR(eX[(eXp(eX!O(eX!Q(eX!Z(eX!j(eX!n(eX#P(eX#l(eX#m(eX#n(eX#o(eX#p(eX#q(eX#r(eX#s(eX#t(eX#u(eX#w(eX#y(eX#z(eX(_(eX(p(eX(w(eX(x(eX!](eX%h(eX~Oa(eX'x(eX'u(eX!W(eX!i(eXt(eX!e(eX~P4UO#^$eO~O$[$hO$^$gO$e$mO~OSfO!]$nO$h$oO$j$qO~Oh%VOj%cOn%WOp%XOq$tOr$tOx%YOz%ZO|%[O!Q${O!]$|O!g%aO!j$xO#h%bO$V%_O$s%]O$u%^O$x%`O(R$sO(TTO(WUO(_$uO(w$}O(x%POg([P~O!j%dO~O!Q%gO!]%hO(R%fO~O!e%lO~Oa%mO'x%mO~O!O%qO~P%[O(S!lO~P%[O%m%uO~P%[Oh%VO!j%dO(R%fO(S!lO~Oe%|O!j%dO(R%fO~O#t$RO~O!O&RO!]&OO!j&QO%i&UO(R%fO(S!lO(TTO(WUO`)UP~O!v#sO~O%r&WO!Q)QX!])QX(R)QX~O(R&XO~Oj!PO!s&^O%i!QO%k!OO%l!OO%m!OO%p!RO%r!SO%u!TO%v!TO~Od&cOe&bO!v&`O%g&aO%z&_O~P<POd&fOeyOj!PO!]&eO!s&^O!vxO!z]O%g}O%k!OO%l!OO%m!OO%p!RO%r!SO%u!TO%v!TO%x!UO~Ob&iO#^&lO%i&gO(S!lO~P=UO!j&mO!s&qO~O!j#oO~O!]XO~Oa%mO'v&yO'x%mO~Oa%mO'v&|O'x%mO~Oa%mO'v'OO'x%mO~O'u]X!W]Xt]X!i]X&Y]X!]]X%h]X!e]X~P(qO!`']O!a'UO!b'UO(S!lO(TTO(WUO~Oq'SO!Q'RO!Y'VO(c'QO![(gP![(vP~P@]Ol'`O!]'^O(R%fO~Oe'eO!j%dO(R%fO~O!O&RO!j&QO~Oq!nO!Q!oO!z;wO#R!pO#S!pO#U!pO#V!pO(S!lO(TTO(WUO(c!mO(m!sO~O!`'kO!a'jO!b'jO#T!pO#Y'lO#Z'lO~PAwOa%mOh%VO!e#vO!j%dO'x%mO(p'nO~O!n'rO#^'pO~PCVOq!nO!Q!oO(TTO(WUO(c!mO(m!sO~O!]XOq(kX!Q(kX!`(kX!a(kX!b(kX!z(kX#R(kX#S(kX#T(kX#U(kX#V(kX#Y(kX#Z(kX(S(kX(T(kX(W(kX(c(kX(m(kX~O!a'jO!b'jO(S!lO~PCuO'}'vO(O'vO(P'xO~O_!}O(T'zO(U!}O(V'zO~O_#QO(V'zO(W'zO(X#QO~Ot'|O~P%[Ov#SO!S#TO(`#TO(a(PO~O!Y(RO!W'UX!W'[X!Z'UX!Z'[X~P+}O!Z(TO!W(fX~OP$[OR#zO[$cOp$aO!O#yO!Q#{O!Z(TO!j#xO!n$[O#P$RO#l$OO#m$PO#n$PO#o$PO#p$QO#q$RO#r$RO#s$bO#t$RO#u$SO#w$UO#y$WO#z$XO(_VO(p$YO(w#|O(x#}O~O!W(fX~PGpO!W(YO~O!W(sX!Z(sX!e(sX!i(sX(p(sX~O#^(sX#i#bX![(sX~PIsO#^(ZO!W(uX!Z(uX~O!Z([O!W(tX~O!W(_O~O#^$eO~PIsO![(`O~P`OR#zO!O#yO!Q#{O!j#xO(_VOP!la[!lap!la!Z!la!n!la#P!la#l!la#m!la#n!la#o!la#p!la#q!la#r!la#s!la#t!la#u!la#w!la#y!la#z!la(p!la(w!la(x!la~Oa!la'x!la'u!la!W!la!i!lat!la!]!la%h!la!e!la~PKZO!i(aO~O!e#vO#^(bO(p'nO!Z(rXa(rX'x(rX~O!i(rX~PMvO!Q%gO!]%hO!z]O#g(gO#h(fO(R%fO~O!Z(hO!i(qX~O!i(jO~O!Q%gO!]%hO#h(fO(R%fO~OP(eXR(eX[(eXp(eX!O(eX!Q(eX!Z(eX!j(eX!n(eX#P(eX#l(eX#m(eX#n(eX#o(eX#p(eX#q(eX#r(eX#s(eX#t(eX#u(eX#w(eX#y(eX#z(eX(_(eX(p(eX(w(eX(x(eX~O!e#vO!i(eX~P! dOR(lO!O(kO!j#xO#Q$dO!z!ya!Q!ya~O!v!ya%g!ya!]!ya#g!ya#h!ya(R!ya~P!#eO!v(pO~OPYOQYOSfOd!jOe!iOnkOpYOqkOrkOxkOzYO|YO!QWO!UkO!VkO!]XO!guO!jZO!mYO!nYO!oYO!qvO!s!gO!v!hO$V!kO$miO(R!dO(TTO(WUO(_VO(m[O~Oh%VOn%WOp%XOq$tOr$tOx%YOz%ZO|<eO!Q${O!]$|O!g=vO!j$xO#h<kO$V%_O$s<gO$u<iO$x%`O(R(tO(TTO(WUO(_$uO(w$}O(x%PO~O#i(vO~O!Y(xO!i(iP~P%[O(c(zO(m[O~O!Q(|O!j#xO(c(zO(m[O~OP;vOQ;vOSfOd=rOe!iOnkOp;vOqkOrkOxkOz;vO|;vO!QWO!UkO!VkO!]!eO!g;yO!jZO!m;vO!n;vO!o;vO!q;zO!s;}O!v!hO$V!kO$m=pO(R)ZO(TTO(WUO(_VO(m[O~O!Z$_Oa$pa'x$pa'u$pa!i$pa!W$pa!]$pa%h$pa!e$pa~Oj)bO~P!&iOh%VOn%WOp%XOq$tOr$tOx%YOz%ZO|%[O!Q${O!]$|O!g%aO!j$xO#h%bO$V%_O$s%]O$u%^O$x%`O(R(tO(TTO(WUO(_$uO(w$}O(x%PO~Og(nP~P!+rO!O)gO!e)fO!]$]X$Y$]X$[$]X$^$]X$e$]X~O!e)fO!](yX$Y(yX$[(yX$^(yX$e(yX~O!O)gO~P!-{O!O)gO!](yX$Y(yX$[(yX$^(yX$e(yX~O!])iO$Y)mO$[)hO$^)hO$e)nO~O!Y)qO~P!(yO$[$hO$^$gO$e)uO~Ol$yX!O$yX#Q$yX'w$yX(w$yX(x$yX~OgkXg$yXlkX!ZkX#^kX~P!/qOv)wO(`)xO(a)zO~Ol*TO!O)|O'w)}O(w$}O(x%PO~Og){O~P!0uOg*UO~Oh%VOn%WOp%XOq$tOr$tOx%YOz%ZO|<eO!Q*WO!]*XO!g=vO!j$xO#h<kO$V%_O$s<gO$u<iO$x%`O(TTO(WUO(_$uO(w$}O(x%PO~O!Y*[O(R*VO!i(|P~P!1dO#i*^O~O!j*_O~Oh%VOn%WOp%XOq$tOr$tOx%YOz%ZO|<eO!Q${O!]$|O!g=vO!j$xO#h<kO$V%_O$s<gO$u<iO$x%`O(R*aO(TTO(WUO(_$uO(w$}O(x%PO~O!Y*dO!W(}P~P!3cOp*pOq!nO!Q*fO!`*nO!a*hO!b*hO!j*_O#Y*oO%_*jO(S!lO(TTO(WUO(c!mO~O![*mO~P!5WO#Q$dOl(^X!O(^X'w(^X(w(^X(x(^X!Z(^X#^(^X~Og(^X#}(^X~P!6YOl*uO#^*tOg(]X!Z(]X~O!Z*vOg([X~Oj%cO(R&XOg([P~Oq*yO~O!j+OO~O(R(tO~On+TO!Q%gO!Y#iO!]%hO!z]O#g#lO#h#iO(R%fO!i(qP~O!e#vO#i+UO~O!Q%gO!Y+WO!Z([O!]%hO(R%fO!W(tP~Oq'YO!Q+YO!Y+XO(TTO(WUO(c(zO~O![(vP~P!9]O!Z+ZOa)RX'x)RX~OP$[OR#zO[$cOp$aO!O#yO!Q#{O!j#xO!n$[O#P$RO#l$OO#m$PO#n$PO#o$PO#p$QO#q$RO#r$RO#s$bO#t$RO#u$SO#w$UO#y$WO#z$XO(_VO(p$YO(w#|O(x#}O~Oa!ha!Z!ha'x!ha'u!ha!W!ha!i!hat!ha!]!ha%h!ha!e!ha~P!:TOR#zO!O#yO!Q#{O!j#xO(_VOP!pa[!pap!pa!Z!pa!n!pa#P!pa#l!pa#m!pa#n!pa#o!pa#p!pa#q!pa#r!pa#s!pa#t!pa#u!pa#w!pa#y!pa#z!pa(p!pa(w!pa(x!pa~Oa!pa'x!pa'u!pa!W!pa!i!pat!pa!]!pa%h!pa!e!pa~P!<kOR#zO!O#yO!Q#{O!j#xO(_VOP!ra[!rap!ra!Z!ra!n!ra#P!ra#l!ra#m!ra#n!ra#o!ra#p!ra#q!ra#r!ra#s!ra#t!ra#u!ra#w!ra#y!ra#z!ra(p!ra(w!ra(x!ra~Oa!ra'x!ra'u!ra!W!ra!i!rat!ra!]!ra%h!ra!e!ra~P!?ROh%VOl+dO!]'^O%h+cO~O!e+fOa(ZX!](ZX'x(ZX!Z(ZX~Oa%mO!]XO'x%mO~Oh%VO!j%dO~Oh%VO!j%dO(R%fO~O!e#vO#i(vO~Ob+qO%i+rO(R+nO(TTO(WUO![)VP~O!Z+sO`)UX~O[+wO~O`+xO~O!]&OO(R%fO(S!lO`)UP~Oh%VO#^+}O~Oh%VOl,QO!]$|O~O!],SO~O!O,UO!]XO~O%m%uO~O!v,ZO~Oe,`O~Ob,aO(R#nO(TTO(WUO![)TP~Oe%|O~O%i!QO(R&XO~P=UO[,fO`,eO~OPYOQYOSfOdzOeyOnkOpYOqkOrkOxkOzYO|YO!QWO!UkO!VkO!guO!jZO!mYO!nYO!oYO!qvO!vxO!z]O$miO%g}O(TTO(WUO(_VO(m[O~O!]!eO!s!gO$V!kO(R!dO~P!FRO`,eOa%mO'x%mO~OPYOQYOSfOd!jOe!iOnkOpYOqkOrkOxkOzYO|YO!QWO!UkO!VkO!]!eO!guO!jZO!mYO!nYO!oYO!qvO!v!hO$V!kO$miO(R!dO(TTO(WUO(_VO(m[O~Oa,kOj!OO!swO%k!OO%l!OO%m!OO~P!HkO!j&mO~O&[,qO~O!],sO~O&m,uO&o,vOP&jaQ&jaS&jaY&jaa&jad&jae&jaj&jan&jap&jaq&jar&jax&jaz&ja|&ja!Q&ja!U&ja!V&ja!]&ja!g&ja!j&ja!m&ja!n&ja!o&ja!q&ja!s&ja!v&ja!z&ja$V&ja$m&ja%g&ja%i&ja%k&ja%l&ja%m&ja%p&ja%r&ja%u&ja%v&ja%x&ja&U&ja&[&ja&^&ja&`&ja&b&ja&e&ja&k&ja&q&ja&s&ja&u&ja&w&ja&y&ja'u&ja(R&ja(T&ja(W&ja(_&ja(m&ja![&ja&c&jab&ja&h&ja~O(R,{O~Oh!cX!Z!PX![!PX!e!PX!e!cX!j!cX#^!PX~O!Z!cX![!cX~P# qO!e-QO#^-POh(hX!Z#fX![#fX!e(hX!j(hX~O!Z(hX![(hX~P#!dOh%VO!e-SO!j%dO!Z!_X![!_X~Oq!nO!Q!oO(TTO(WUO(c!mO~OP;vOQ;vOSfOd=rOe!iOnkOp;vOqkOrkOxkOz;vO|;vO!QWO!UkO!VkO!]!eO!g;yO!jZO!m;vO!n;vO!o;vO!q;zO!s;}O!v!hO$V!kO$m=pO(TTO(WUO(_VO(m[O~O(R<rO~P##yO!Z-WO![(gX~O![-YO~O!e-QO#^-PO!Z#fX![#fX~O!Z-ZO![(vX~O![-]O~O!a-^O!b-^O(S!lO~P##hO![-aO~P'_Ol-dO!]'^O~O!W-iO~Oq!ya!`!ya!a!ya!b!ya#R!ya#S!ya#T!ya#U!ya#V!ya#Y!ya#Z!ya(S!ya(T!ya(W!ya(c!ya(m!ya~P!#eO!n-nO#^-lO~PCVO!a-pO!b-pO(S!lO~PCuOa%mO#^-lO'x%mO~Oa%mO!e#vO#^-lO'x%mO~Oa%mO!e#vO!n-nO#^-lO'x%mO(p'nO~O'}'vO(O'vO(P-uO~Ot-vO~O!W'Ua!Z'Ua~P!:TO!Y-zO!W'UX!Z'UX~P%[O!Z(TO!W(fa~O!W(fa~PGpO!Z([O!W(ta~O!Q%gO!Y.OO!]%hO(R%fO!W'[X!Z'[X~O#^.QO!Z(ra!i(raa(ra'x(ra~O!e#vO~P#,PO!Z(hO!i(qa~O!Q%gO!]%hO#h.UO(R%fO~On.ZO!Q%gO!Y.WO!]%hO!z]O#g.YO#h.WO(R%fO!Z'_X!i'_X~OR._O!j#xO~Oh%VOl.bO!]'^O%h.aO~Oa#ai!Z#ai'x#ai'u#ai!W#ai!i#ait#ai!]#ai%h#ai!e#ai~P!:TOl=|O!O)|O'w)}O(w$}O(x%PO~O#i#]aa#]a#^#]a'x#]a!Z#]a!i#]a!]#]a!W#]a~P#.{O#i(^XP(^XR(^X[(^Xa(^Xp(^X!Q(^X!j(^X!n(^X#P(^X#l(^X#m(^X#n(^X#o(^X#p(^X#q(^X#r(^X#s(^X#t(^X#u(^X#w(^X#y(^X#z(^X'x(^X(_(^X(p(^X!i(^X!W(^X'u(^Xt(^X!](^X%h(^X!e(^X~P!6YO!Z.oO!i(iX~P!:TO!i.rO~O!W.tO~OP$[OR#zO!O#yO!Q#{O!j#xO!n$[O(_VO[#kia#kip#ki!Z#ki#P#ki#m#ki#n#ki#o#ki#p#ki#q#ki#r#ki#s#ki#t#ki#u#ki#w#ki#y#ki#z#ki'x#ki(p#ki(w#ki(x#ki'u#ki!W#ki!i#kit#ki!]#ki%h#ki!e#ki~O#l#ki~P#2kO#l$OO~P#2kOP$[OR#zOp$aO!O#yO!Q#{O!j#xO!n$[O#l$OO#m$PO#n$PO#o$PO(_VO[#kia#ki!Z#ki#P#ki#q#ki#r#ki#s#ki#t#ki#u#ki#w#ki#y#ki#z#ki'x#ki(p#ki(w#ki(x#ki'u#ki!W#ki!i#kit#ki!]#ki%h#ki!e#ki~O#p#ki~P#5YO#p$QO~P#5YOP$[OR#zO[$cOp$aO!O#yO!Q#{O!j#xO!n$[O#P$RO#l$OO#m$PO#n$PO#o$PO#p$QO#q$RO#r$RO#s$bO#t$RO(_VOa#ki!Z#ki#w#ki#y#ki#z#ki'x#ki(p#ki(w#ki(x#ki'u#ki!W#ki!i#kit#ki!]#ki%h#ki!e#ki~O#u#ki~P#7wOP$[OR#zO[$cOp$aO!O#yO!Q#{O!j#xO!n$[O#P$RO#l$OO#m$PO#n$PO#o$PO#p$QO#q$RO#r$RO#s$bO#t$RO#u$SO(_VO(x#}Oa#ki!Z#ki#y#ki#z#ki'x#ki(p#ki(w#ki'u#ki!W#ki!i#kit#ki!]#ki%h#ki!e#ki~O#w$UO~P#:_O#w#ki~P#:_O#u$SO~P#7wOP$[OR#zO[$cOp$aO!O#yO!Q#{O!j#xO!n$[O#P$RO#l$OO#m$PO#n$PO#o$PO#p$QO#q$RO#r$RO#s$bO#t$RO#u$SO#w$UO(_VO(w#|O(x#}Oa#ki!Z#ki#z#ki'x#ki(p#ki'u#ki!W#ki!i#kit#ki!]#ki%h#ki!e#ki~O#y#ki~P#=TO#y$WO~P#=TOP]XR]X[]Xp]X!O]X!Q]X!j]X!n]X#P]X#Q]X#^]X#ifX#l]X#m]X#n]X#o]X#p]X#q]X#r]X#s]X#t]X#u]X#w]X#y]X#z]X$P]X(_]X(p]X(w]X(x]X!Z]X![]X~O#}]X~P#?rOP$[OR#zO[<_Op<]O!O#yO!Q#{O!j#xO!n$[O#P<SO#l<PO#m<QO#n<QO#o<QO#p<RO#q<SO#r<SO#s<^O#t<SO#u<TO#w<VO#y<XO#z<YO(_VO(p$YO(w#|O(x#}O~O#}.vO~P#BPO#Q$dO#^<`O$P<`O#}(eX![(eX~P! dOa'ba!Z'ba'x'ba'u'ba!i'ba!W'bat'ba!]'ba%h'ba!e'ba~P!:TO[#kia#kip#ki!Z#ki#P#ki#p#ki#q#ki#r#ki#s#ki#t#ki#u#ki#w#ki#y#ki#z#ki'x#ki(p#ki'u#ki!W#ki!i#kit#ki!]#ki%h#ki!e#ki~OP$[OR#zO!O#yO!Q#{O!j#xO!n$[O#l$OO#m$PO#n$PO#o$PO(_VO(w#ki(x#ki~P#EROl=|O!O)|O'w)}O(w$}O(x%POP#kiR#ki!Q#ki!j#ki!n#ki#l#ki#m#ki#n#ki#o#ki(_#ki~P#ERO!Z.zOg(nX~P!0uOg.|O~Oa$Oi!Z$Oi'x$Oi'u$Oi!W$Oi!i$Oit$Oi!]$Oi%h$Oi!e$Oi~P!:TO$[.}O$^.}O~O$[/OO$^/OO~O!e)fO#^/PO!]$bX$Y$bX$[$bX$^$bX$e$bX~O!Y/QO~O!])iO$Y/SO$[)hO$^)hO$e/TO~O!Z<ZO![(dX~P#BPO![/UO~O!e)fO$e(yX~O$e/WO~Ot/XO~P!&iOv)wO(`)xO(a/[O~O!Q/_O~O(w$}Ol%`a!O%`a'w%`a(x%`a!Z%`a#^%`a~Og%`a#}%`a~P#LTO(x%POl%ba!O%ba'w%ba(w%ba!Z%ba#^%ba~Og%ba#}%ba~P#LvO!ZfX!efX!ifX!i$yX(pfX~P!/qO!Y/hO!Z([O(R/gO!W(tP!W(}P~P!1dOp*pO!`*nO!a*hO!b*hO!j*_O#Y*oO%_*jO(S!lO(TTO(WUO~Oq<oO!Q/iO!Y+XO![*mO(c<nO![(vP~P#NaO!i/jO~P#.{O!Z/kO!e#vO(p'nO!i(|X~O!i/pO~O!Q%gO!Y*[O!]%hO(R%fO!i(|P~O#i/rO~O!W$yX!Z$yX!e%QX~P!/qO!Z/sO!W(}X~P#.{O!e/uO~O!W/wO~OnkO(R/xO~P.iOh%VOp/}O!e#vO!j%dO(p'nO~O!e+fO~Oa%mO!Z0RO'x%mO~O![0TO~P!5WO!a0UO!b0UO(S!lO~P##hOq!nO!Q0VO(TTO(WUO(c!mO~O#Y0XO~Og%`a!Z%`a#^%`a#}%`a~P!0uOg%ba!Z%ba#^%ba#}%ba~P!0uOj%cO(R&XOg'kX!Z'kX~O!Z*vOg([a~Og0bO~OR0cO!O0cO!Q0dO#Q$dOl{a'w{a(w{a(x{a!Z{a#^{a~Og{a#}{a~P$&dO!O)|O'w)}Ol$ra(w$ra(x$ra!Z$ra#^$ra~Og$ra#}$ra~P$'`O!O)|O'w)}Ol$ta(w$ta(x$ta!Z$ta#^$ta~Og$ta#}$ta~P$(RO#i0gO~Og%Sa!Z%Sa#^%Sa#}%Sa~P!0uOl0iO#^0hOg(]a!Z(]a~O!e#vO~O#i0lO~O!Z+ZOa)Ra'x)Ra~OR#zO!O#yO!Q#{O!j#xO(_VOP!pi[!pip!pi!Z!pi!n!pi#P!pi#l!pi#m!pi#n!pi#o!pi#p!pi#q!pi#r!pi#s!pi#t!pi#u!pi#w!pi#y!pi#z!pi(p!pi(w!pi(x!pi~Oa!pi'x!pi'u!pi!W!pi!i!pit!pi!]!pi%h!pi!e!pi~P$*OOh%VOp%XOq$tOr$tOx%YOz%ZO|<eO!Q${O!]$|O!g=vO!j$xO#h<kO$V%_O$s<gO$u<iO$x%`O(TTO(WUO(_$uO(w$}O(x%PO~On0vO%[0wO(R0tO~P$,fO!e+fOa(Za!](Za'x(Za!Z(Za~O#i0|O~O[]X!ZfX![fX~O!Z0}O![)VX~O![1PO~O[1QO~Ob1SO(R+nO(TTO(WUO~O!]&OO(R%fO`'sX!Z'sX~O!Z+sO`)Ua~O!i1VO~P!:TO[1YO~O`1ZO~O#^1^O~Ol1aO!]$|O~O(c(zO![)SP~Oh%VOl1jO!]1gO%h1iO~O[1tO!Z1rO![)TX~O![1uO~O`1wOa%mO'x%mO~O(R#nO(TTO(WUO~O#Q$dO#^$eO$P$eOP(eXR(eX[(eXp(eX!O(eX!Q(eX!Z(eX!j(eX!n(eX#P(eX#l(eX#m(eX#n(eX#o(eX#p(eX#q(eX#r(eX#s(eX#u(eX#w(eX#y(eX#z(eX(_(eX(p(eX(w(eX(x(eX~O#t1zO&Y1{Oa(eX~P$2PO#^$eO#t1zO&Y1{O~Oa1}O~P%[Oa2PO~O&c2SOP&aiQ&aiS&aiY&aia&aid&aie&aij&ain&aip&aiq&air&aix&aiz&ai|&ai!Q&ai!U&ai!V&ai!]&ai!g&ai!j&ai!m&ai!n&ai!o&ai!q&ai!s&ai!v&ai!z&ai$V&ai$m&ai%g&ai%i&ai%k&ai%l&ai%m&ai%p&ai%r&ai%u&ai%v&ai%x&ai&U&ai&[&ai&^&ai&`&ai&b&ai&e&ai&k&ai&q&ai&s&ai&u&ai&w&ai&y&ai'u&ai(R&ai(T&ai(W&ai(_&ai(m&ai![&aib&ai&h&ai~Ob2YO![2WO&h2XO~P`O!]XO!j2[O~O&o,vOP&jiQ&jiS&jiY&jia&jid&jie&jij&jin&jip&jiq&jir&jix&jiz&ji|&ji!Q&ji!U&ji!V&ji!]&ji!g&ji!j&ji!m&ji!n&ji!o&ji!q&ji!s&ji!v&ji!z&ji$V&ji$m&ji%g&ji%i&ji%k&ji%l&ji%m&ji%p&ji%r&ji%u&ji%v&ji%x&ji&U&ji&[&ji&^&ji&`&ji&b&ji&e&ji&k&ji&q&ji&s&ji&u&ji&w&ji&y&ji'u&ji(R&ji(T&ji(W&ji(_&ji(m&ji![&ji&c&jib&ji&h&ji~O!W2bO~O!Z!_a![!_a~P#BPOq!nO!Q!oO!Y2hO(c!mO!Z'VX!['VX~P@]O!Z-WO![(ga~O!Z']X![']X~P!9]O!Z-ZO![(va~O![2oO~P'_Oa%mO#^2xO'x%mO~Oa%mO!e#vO#^2xO'x%mO~Oa%mO!e#vO!n2|O#^2xO'x%mO(p'nO~Oa%mO'x%mO~P!:TO!Z$_Ot$pa~O!W'Ui!Z'Ui~P!:TO!Z(TO!W(fi~O!Z([O!W(ti~O!W(ui!Z(ui~P!:TO!Z(ri!i(ria(ri'x(ri~P!:TO#^3OO!Z(ri!i(ria(ri'x(ri~O!Z(hO!i(qi~O!Q%gO!]%hO!z]O#g3TO#h3SO(R%fO~O!Q%gO!]%hO#h3SO(R%fO~Ol3[O!]'^O%h3ZO~Oh%VOl3[O!]'^O%h3ZO~O#i%`aP%`aR%`a[%`aa%`ap%`a!Q%`a!j%`a!n%`a#P%`a#l%`a#m%`a#n%`a#o%`a#p%`a#q%`a#r%`a#s%`a#t%`a#u%`a#w%`a#y%`a#z%`a'x%`a(_%`a(p%`a!i%`a!W%`a'u%`at%`a!]%`a%h%`a!e%`a~P#LTO#i%baP%baR%ba[%baa%bap%ba!Q%ba!j%ba!n%ba#P%ba#l%ba#m%ba#n%ba#o%ba#p%ba#q%ba#r%ba#s%ba#t%ba#u%ba#w%ba#y%ba#z%ba'x%ba(_%ba(p%ba!i%ba!W%ba'u%bat%ba!]%ba%h%ba!e%ba~P#LvO#i%`aP%`aR%`a[%`aa%`ap%`a!Q%`a!Z%`a!j%`a!n%`a#P%`a#l%`a#m%`a#n%`a#o%`a#p%`a#q%`a#r%`a#s%`a#t%`a#u%`a#w%`a#y%`a#z%`a'x%`a(_%`a(p%`a!i%`a!W%`a'u%`a#^%`at%`a!]%`a%h%`a!e%`a~P#.{O#i%baP%baR%ba[%baa%bap%ba!Q%ba!Z%ba!j%ba!n%ba#P%ba#l%ba#m%ba#n%ba#o%ba#p%ba#q%ba#r%ba#s%ba#t%ba#u%ba#w%ba#y%ba#z%ba'x%ba(_%ba(p%ba!i%ba!W%ba'u%ba#^%bat%ba!]%ba%h%ba!e%ba~P#.{O#i{aP{a[{aa{ap{a!j{a!n{a#P{a#l{a#m{a#n{a#o{a#p{a#q{a#r{a#s{a#t{a#u{a#w{a#y{a#z{a'x{a(_{a(p{a!i{a!W{a'u{at{a!]{a%h{a!e{a~P$&dO#i$raP$raR$ra[$raa$rap$ra!Q$ra!j$ra!n$ra#P$ra#l$ra#m$ra#n$ra#o$ra#p$ra#q$ra#r$ra#s$ra#t$ra#u$ra#w$ra#y$ra#z$ra'x$ra(_$ra(p$ra!i$ra!W$ra'u$rat$ra!]$ra%h$ra!e$ra~P$'`O#i$taP$taR$ta[$taa$tap$ta!Q$ta!j$ta!n$ta#P$ta#l$ta#m$ta#n$ta#o$ta#p$ta#q$ta#r$ta#s$ta#t$ta#u$ta#w$ta#y$ta#z$ta'x$ta(_$ta(p$ta!i$ta!W$ta'u$tat$ta!]$ta%h$ta!e$ta~P$(RO#i%SaP%SaR%Sa[%Saa%Sap%Sa!Q%Sa!Z%Sa!j%Sa!n%Sa#P%Sa#l%Sa#m%Sa#n%Sa#o%Sa#p%Sa#q%Sa#r%Sa#s%Sa#t%Sa#u%Sa#w%Sa#y%Sa#z%Sa'x%Sa(_%Sa(p%Sa!i%Sa!W%Sa'u%Sa#^%Sat%Sa!]%Sa%h%Sa!e%Sa~P#.{Oa#aq!Z#aq'x#aq'u#aq!W#aq!i#aqt#aq!]#aq%h#aq!e#aq~P!:TO!Y3dO!Z'WX!i'WX~P%[O!Z.oO!i(ia~O!Z.oO!i(ia~P!:TO!W3gO~O#}!la![!la~PKZO#}!ha!Z!ha![!ha~P#BPO#}!pa![!pa~P!<kO#}!ra![!ra~P!?ROg'ZX!Z'ZX~P!+rO!Z.zOg(na~OSfO!]3{O$c3|O~O![4QO~Ot4RO~P#.{Oa$lq!Z$lq'x$lq'u$lq!W$lq!i$lqt$lq!]$lq%h$lq!e$lq~P!:TO!W4TO~P!&iO!Q4UO~O!O)|O'w)}O(x%POl'ga(w'ga!Z'ga#^'ga~Og'ga#}'ga~P%+uO!O)|O'w)}Ol'ia(w'ia(x'ia!Z'ia#^'ia~Og'ia#}'ia~P%,hO(p$YO~P#.{O!WfX!W$yX!ZfX!Z$yX!e%QX#^fX~P!/qO(R<xO~P!1dO!Q%gO!Y4XO!]%hO(R%fO!Z'cX!i'cX~O!Z/kO!i(|a~O!Z/kO!e#vO!i(|a~O!Z/kO!e#vO(p'nO!i(|a~Og${i!Z${i#^${i#}${i~P!0uO!Y4aO!W'eX!Z'eX~P!3cO!Z/sO!W(}a~O!Z/sO!W(}a~P#.{OP]XR]X[]Xp]X!O]X!Q]X!W]X!Z]X!j]X!n]X#P]X#Q]X#^]X#ifX#l]X#m]X#n]X#o]X#p]X#q]X#r]X#s]X#t]X#u]X#w]X#y]X#z]X$P]X(_]X(p]X(w]X(x]X~O!e%XX#t%XX~P%0XO!e#vO#t4fO~Oh%VO!e#vO!j%dO~Oh%VOp4kO!j%dO(p'nO~Op4pO!e#vO(p'nO~Oq!nO!Q4qO(TTO(WUO(c!mO~O(w$}Ol%`i!O%`i'w%`i(x%`i!Z%`i#^%`i~Og%`i#}%`i~P%3xO(x%POl%bi!O%bi'w%bi(w%bi!Z%bi#^%bi~Og%bi#}%bi~P%4kOg(]i!Z(]i~P!0uO#^4wOg(]i!Z(]i~P!0uO!i4zO~Oa$nq!Z$nq'x$nq'u$nq!W$nq!i$nqt$nq!]$nq%h$nq!e$nq~P!:TO!W5QO~O!Z5RO!])OX~P#.{Oa]Xa$yX!]]X!]$yX%]]X'x]X'x$yX!Z]X!Z$yX~P!/qO%]5UOa%Za!]%Za'x%Za!Z%Za~OlmX!OmX'wmX(wmX(xmX~P%7nOn5VO(R#nO~Ob5]O%i5^O(R+nO(TTO(WUO!Z'rX!['rX~O!Z0}O![)Va~O[5bO~O`5cO~Oa%mO'x%mO~P#.{O!Z5kO#^5mO![)SX~O![5nO~Op5tOq!nO!Q*fO!`!yO!a!vO!b!vO!z;wO#R!pO#S!pO#T!pO#U!pO#V!pO#Y5sO#Z!zO(S!lO(TTO(WUO(c!mO(m!sO~O![5rO~P%:ROl5yO!]1gO%h5xO~Oh%VOl5yO!]1gO%h5xO~Ob6QO(R#nO(TTO(WUO!Z'qX!['qX~O!Z1rO![)Ta~O(TTO(WUO(c6SO~O`6WO~O#t6ZO&Y6[O~PMvO!i6]O~P%[Oa6_O~Oa6_O~P%[Ob2YO![6dO&h2XO~P`O!e6fO~O!e6hOh(hi!Z(hi![(hi!e(hi!j(hip(hi(p(hi~O!Z#fi![#fi~P#BPO#^6iO!Z#fi![#fi~O!Z!_i![!_i~P#BPOa%mO#^6rO'x%mO~Oa%mO!e#vO#^6rO'x%mO~O!Z(rq!i(rqa(rq'x(rq~P!:TO!Z(hO!i(qq~O!Q%gO!]%hO#h6yO(R%fO~O!]'^O%h6|O~Ol7QO!]'^O%h6|O~O#i'gaP'gaR'ga['gaa'gap'ga!Q'ga!j'ga!n'ga#P'ga#l'ga#m'ga#n'ga#o'ga#p'ga#q'ga#r'ga#s'ga#t'ga#u'ga#w'ga#y'ga#z'ga'x'ga(_'ga(p'ga!i'ga!W'ga'u'gat'ga!]'ga%h'ga!e'ga~P%+uO#i'iaP'iaR'ia['iaa'iap'ia!Q'ia!j'ia!n'ia#P'ia#l'ia#m'ia#n'ia#o'ia#p'ia#q'ia#r'ia#s'ia#t'ia#u'ia#w'ia#y'ia#z'ia'x'ia(_'ia(p'ia!i'ia!W'ia'u'iat'ia!]'ia%h'ia!e'ia~P%,hO#i${iP${iR${i[${ia${ip${i!Q${i!Z${i!j${i!n${i#P${i#l${i#m${i#n${i#o${i#p${i#q${i#r${i#s${i#t${i#u${i#w${i#y${i#z${i'x${i(_${i(p${i!i${i!W${i'u${i#^${it${i!]${i%h${i!e${i~P#.{O#i%`iP%`iR%`i[%`ia%`ip%`i!Q%`i!j%`i!n%`i#P%`i#l%`i#m%`i#n%`i#o%`i#p%`i#q%`i#r%`i#s%`i#t%`i#u%`i#w%`i#y%`i#z%`i'x%`i(_%`i(p%`i!i%`i!W%`i'u%`it%`i!]%`i%h%`i!e%`i~P%3xO#i%biP%biR%bi[%bia%bip%bi!Q%bi!j%bi!n%bi#P%bi#l%bi#m%bi#n%bi#o%bi#p%bi#q%bi#r%bi#s%bi#t%bi#u%bi#w%bi#y%bi#z%bi'x%bi(_%bi(p%bi!i%bi!W%bi'u%bit%bi!]%bi%h%bi!e%bi~P%4kO!Z'Wa!i'Wa~P!:TO!Z.oO!i(ii~O#}#ai!Z#ai![#ai~P#BPOP$[OR#zO!O#yO!Q#{O!j#xO!n$[O(_VO[#kip#ki#P#ki#m#ki#n#ki#o#ki#p#ki#q#ki#r#ki#s#ki#t#ki#u#ki#w#ki#y#ki#z#ki#}#ki(p#ki(w#ki(x#ki!Z#ki![#ki~O#l#ki~P%MQO#l<PO~P%MQOP$[OR#zOp<]O!O#yO!Q#{O!j#xO!n$[O#l<PO#m<QO#n<QO#o<QO(_VO[#ki#P#ki#q#ki#r#ki#s#ki#t#ki#u#ki#w#ki#y#ki#z#ki#}#ki(p#ki(w#ki(x#ki!Z#ki![#ki~O#p#ki~P& YO#p<RO~P& YOP$[OR#zO[<_Op<]O!O#yO!Q#{O!j#xO!n$[O#P<SO#l<PO#m<QO#n<QO#o<QO#p<RO#q<SO#r<SO#s<^O#t<SO(_VO#w#ki#y#ki#z#ki#}#ki(p#ki(w#ki(x#ki!Z#ki![#ki~O#u#ki~P&#bOP$[OR#zO[<_Op<]O!O#yO!Q#{O!j#xO!n$[O#P<SO#l<PO#m<QO#n<QO#o<QO#p<RO#q<SO#r<SO#s<^O#t<SO#u<TO(_VO(x#}O#y#ki#z#ki#}#ki(p#ki(w#ki!Z#ki![#ki~O#w<VO~P&%cO#w#ki~P&%cO#u<TO~P&#bOP$[OR#zO[<_Op<]O!O#yO!Q#{O!j#xO!n$[O#P<SO#l<PO#m<QO#n<QO#o<QO#p<RO#q<SO#r<SO#s<^O#t<SO#u<TO#w<VO(_VO(w#|O(x#}O#z#ki#}#ki(p#ki!Z#ki![#ki~O#y#ki~P&'rO#y<XO~P&'rOa#{y!Z#{y'x#{y'u#{y!W#{y!i#{yt#{y!]#{y%h#{y!e#{y~P!:TO[#kip#ki#P#ki#p#ki#q#ki#r#ki#s#ki#t#ki#u#ki#w#ki#y#ki#z#ki#}#ki(p#ki!Z#ki![#ki~OP$[OR#zO!O#yO!Q#{O!j#xO!n$[O#l<PO#m<QO#n<QO#o<QO(_VO(w#ki(x#ki~P&*nOl=}O!O)|O'w)}O(w$}O(x%POP#kiR#ki!Q#ki!j#ki!n#ki#l#ki#m#ki#n#ki#o#ki(_#ki~P&*nO#Q$dOP(^XR(^X[(^Xl(^Xp(^X!O(^X!Q(^X!j(^X!n(^X#P(^X#l(^X#m(^X#n(^X#o(^X#p(^X#q(^X#r(^X#s(^X#t(^X#u(^X#w(^X#y(^X#z(^X#}(^X'w(^X(_(^X(p(^X(w(^X(x(^X!Z(^X![(^X~O#}$Oi!Z$Oi![$Oi~P#BPO#}!pi![!pi~P$*OOg'Za!Z'Za~P!0uO![7dO~O!Z'ba!['ba~P#BPO!W7eO~P#.{O!e#vO(p'nO!Z'ca!i'ca~O!Z/kO!i(|i~O!Z/kO!e#vO!i(|i~Og${q!Z${q#^${q#}${q~P!0uO!W'ea!Z'ea~P#.{O!e7lO~O!Z/sO!W(}i~P#.{O!Z/sO!W(}i~O!W7oO~Oh%VOp7tO!j%dO(p'nO~O!e#vO#t7vO~Op7yO!e#vO(p'nO~O!O)|O'w)}O(x%POl'ha(w'ha!Z'ha#^'ha~Og'ha#}'ha~P&3oO!O)|O'w)}Ol'ja(w'ja(x'ja!Z'ja#^'ja~Og'ja#}'ja~P&4bO!W7{O~Og$}q!Z$}q#^$}q#}$}q~P!0uOg(]q!Z(]q~P!0uO#^7|Og(]q!Z(]q~P!0uOa$ny!Z$ny'x$ny'u$ny!W$ny!i$nyt$ny!]$ny%h$ny!e$ny~P!:TO!e6hO~O!Z5RO!])Oa~O!]'^OP$SaR$Sa[$Sap$Sa!O$Sa!Q$Sa!Z$Sa!j$Sa!n$Sa#P$Sa#l$Sa#m$Sa#n$Sa#o$Sa#p$Sa#q$Sa#r$Sa#s$Sa#t$Sa#u$Sa#w$Sa#y$Sa#z$Sa(_$Sa(p$Sa(w$Sa(x$Sa~O%h6|O~P&7SO%]8QOa%Zi!]%Zi'x%Zi!Z%Zi~Oa#ay!Z#ay'x#ay'u#ay!W#ay!i#ayt#ay!]#ay%h#ay!e#ay~P!:TO[8SO~Ob8UO(R+nO(TTO(WUO~O!Z0}O![)Vi~O`8YO~O(c(zO!Z'nX!['nX~O!Z5kO![)Sa~O![8cO~P%:RO(m!sO~P$$oO#Y8dO~O!]1gO~O!]1gO%h8fO~Ol8iO!]1gO%h8fO~O[8nO!Z'qa!['qa~O!Z1rO![)Ti~O!i8rO~O!i8sO~O!i8vO~O!i8vO~P%[Oa8xO~O!e8yO~O!i8zO~O!Z(ui![(ui~P#BPOa%mO#^9SO'x%mO~O!Z(ry!i(rya(ry'x(ry~P!:TO!Z(hO!i(qy~O%h9VO~P&7SO!]'^O%h9VO~O#i${qP${qR${q[${qa${qp${q!Q${q!Z${q!j${q!n${q#P${q#l${q#m${q#n${q#o${q#p${q#q${q#r${q#s${q#t${q#u${q#w${q#y${q#z${q'x${q(_${q(p${q!i${q!W${q'u${q#^${qt${q!]${q%h${q!e${q~P#.{O#i'haP'haR'ha['haa'hap'ha!Q'ha!j'ha!n'ha#P'ha#l'ha#m'ha#n'ha#o'ha#p'ha#q'ha#r'ha#s'ha#t'ha#u'ha#w'ha#y'ha#z'ha'x'ha(_'ha(p'ha!i'ha!W'ha'u'hat'ha!]'ha%h'ha!e'ha~P&3oO#i'jaP'jaR'ja['jaa'jap'ja!Q'ja!j'ja!n'ja#P'ja#l'ja#m'ja#n'ja#o'ja#p'ja#q'ja#r'ja#s'ja#t'ja#u'ja#w'ja#y'ja#z'ja'x'ja(_'ja(p'ja!i'ja!W'ja'u'jat'ja!]'ja%h'ja!e'ja~P&4bO#i$}qP$}qR$}q[$}qa$}qp$}q!Q$}q!Z$}q!j$}q!n$}q#P$}q#l$}q#m$}q#n$}q#o$}q#p$}q#q$}q#r$}q#s$}q#t$}q#u$}q#w$}q#y$}q#z$}q'x$}q(_$}q(p$}q!i$}q!W$}q'u$}q#^$}qt$}q!]$}q%h$}q!e$}q~P#.{O!Z'Wi!i'Wi~P!:TO#}#aq!Z#aq![#aq~P#BPO(w$}OP%`aR%`a[%`ap%`a!Q%`a!j%`a!n%`a#P%`a#l%`a#m%`a#n%`a#o%`a#p%`a#q%`a#r%`a#s%`a#t%`a#u%`a#w%`a#y%`a#z%`a#}%`a(_%`a(p%`a!Z%`a![%`a~Ol%`a!O%`a'w%`a(x%`a~P&HgO(x%POP%baR%ba[%bap%ba!Q%ba!j%ba!n%ba#P%ba#l%ba#m%ba#n%ba#o%ba#p%ba#q%ba#r%ba#s%ba#t%ba#u%ba#w%ba#y%ba#z%ba#}%ba(_%ba(p%ba!Z%ba![%ba~Ol%ba!O%ba'w%ba(w%ba~P&JnOl=}O!O)|O'w)}O(x%PO~P&HgOl=}O!O)|O'w)}O(w$}O~P&JnOR0cO!O0cO!Q0dO#Q$dOP{a[{al{ap{a!j{a!n{a#P{a#l{a#m{a#n{a#o{a#p{a#q{a#r{a#s{a#t{a#u{a#w{a#y{a#z{a#}{a'w{a(_{a(p{a(w{a(x{a!Z{a![{a~O!O)|O'w)}OP$raR$ra[$ral$rap$ra!Q$ra!j$ra!n$ra#P$ra#l$ra#m$ra#n$ra#o$ra#p$ra#q$ra#r$ra#s$ra#t$ra#u$ra#w$ra#y$ra#z$ra#}$ra(_$ra(p$ra(w$ra(x$ra!Z$ra![$ra~O!O)|O'w)}OP$taR$ta[$tal$tap$ta!Q$ta!j$ta!n$ta#P$ta#l$ta#m$ta#n$ta#o$ta#p$ta#q$ta#r$ta#s$ta#t$ta#u$ta#w$ta#y$ta#z$ta#}$ta(_$ta(p$ta(w$ta(x$ta!Z$ta![$ta~Ol=}O!O)|O'w)}O(w$}O(x%PO~OP%SaR%Sa[%Sap%Sa!Q%Sa!j%Sa!n%Sa#P%Sa#l%Sa#m%Sa#n%Sa#o%Sa#p%Sa#q%Sa#r%Sa#s%Sa#t%Sa#u%Sa#w%Sa#y%Sa#z%Sa#}%Sa(_%Sa(p%Sa!Z%Sa![%Sa~P'%sO#}$lq!Z$lq![$lq~P#BPO#}$nq!Z$nq![$nq~P#BPO![9dO~O#}9eO~P!0uO!e#vO!Z'ci!i'ci~O!e#vO(p'nO!Z'ci!i'ci~O!Z/kO!i(|q~O!W'ei!Z'ei~P#.{O!Z/sO!W(}q~Op9lO!e#vO(p'nO~O[9nO!W9mO~P#.{O!W9mO~O!e#vO#t9tO~Og(]y!Z(]y~P!0uO!Z'la!]'la~P#.{Oa%Zq!]%Zq'x%Zq!Z%Zq~P#.{O[9yO~O!Z0}O![)Vq~O#^9}O!Z'na!['na~O!Z5kO![)Si~P#BPO!Q:PO~O!]1gO%h:SO~O(TTO(WUO(c:XO~O!Z1rO![)Tq~O!i:[O~O!i:]O~O!i:^O~O!i:^O~P%[O#^:aO!Z#fy![#fy~O!Z#fy![#fy~P#BPO%h:fO~P&7SO!]'^O%h:fO~O#}#{y!Z#{y![#{y~P#BPOP${iR${i[${ip${i!Q${i!j${i!n${i#P${i#l${i#m${i#n${i#o${i#p${i#q${i#r${i#s${i#t${i#u${i#w${i#y${i#z${i#}${i(_${i(p${i!Z${i![${i~P'%sO!O)|O'w)}O(x%POP'gaR'ga['gal'gap'ga!Q'ga!j'ga!n'ga#P'ga#l'ga#m'ga#n'ga#o'ga#p'ga#q'ga#r'ga#s'ga#t'ga#u'ga#w'ga#y'ga#z'ga#}'ga(_'ga(p'ga(w'ga!Z'ga!['ga~O!O)|O'w)}OP'iaR'ia['ial'iap'ia!Q'ia!j'ia!n'ia#P'ia#l'ia#m'ia#n'ia#o'ia#p'ia#q'ia#r'ia#s'ia#t'ia#u'ia#w'ia#y'ia#z'ia#}'ia(_'ia(p'ia(w'ia(x'ia!Z'ia!['ia~O(w$}OP%`iR%`i[%`il%`ip%`i!O%`i!Q%`i!j%`i!n%`i#P%`i#l%`i#m%`i#n%`i#o%`i#p%`i#q%`i#r%`i#s%`i#t%`i#u%`i#w%`i#y%`i#z%`i#}%`i'w%`i(_%`i(p%`i(x%`i!Z%`i![%`i~O(x%POP%biR%bi[%bil%bip%bi!O%bi!Q%bi!j%bi!n%bi#P%bi#l%bi#m%bi#n%bi#o%bi#p%bi#q%bi#r%bi#s%bi#t%bi#u%bi#w%bi#y%bi#z%bi#}%bi'w%bi(_%bi(p%bi(w%bi!Z%bi![%bi~O#}$ny!Z$ny![$ny~P#BPO#}#ay!Z#ay![#ay~P#BPO!e#vO!Z'cq!i'cq~O!Z/kO!i(|y~O!W'eq!Z'eq~P#.{Op:pO!e#vO(p'nO~O[:tO!W:sO~P#.{O!W:sO~Og(]!R!Z(]!R~P!0uOa%Zy!]%Zy'x%Zy!Z%Zy~P#.{O!Z0}O![)Vy~O!Z5kO![)Sq~O(R:zO~O!]1gO%h:}O~O!i;QO~O%h;VO~P&7SOP${qR${q[${qp${q!Q${q!j${q!n${q#P${q#l${q#m${q#n${q#o${q#p${q#q${q#r${q#s${q#t${q#u${q#w${q#y${q#z${q#}${q(_${q(p${q!Z${q![${q~P'%sO!O)|O'w)}O(x%POP'haR'ha['hal'hap'ha!Q'ha!j'ha!n'ha#P'ha#l'ha#m'ha#n'ha#o'ha#p'ha#q'ha#r'ha#s'ha#t'ha#u'ha#w'ha#y'ha#z'ha#}'ha(_'ha(p'ha(w'ha!Z'ha!['ha~O!O)|O'w)}OP'jaR'ja['jal'jap'ja!Q'ja!j'ja!n'ja#P'ja#l'ja#m'ja#n'ja#o'ja#p'ja#q'ja#r'ja#s'ja#t'ja#u'ja#w'ja#y'ja#z'ja#}'ja(_'ja(p'ja(w'ja(x'ja!Z'ja!['ja~OP$}qR$}q[$}qp$}q!Q$}q!j$}q!n$}q#P$}q#l$}q#m$}q#n$}q#o$}q#p$}q#q$}q#r$}q#s$}q#t$}q#u$}q#w$}q#y$}q#z$}q#}$}q(_$}q(p$}q!Z$}q![$}q~P'%sOg%d!Z!Z%d!Z#^%d!Z#}%d!Z~P!0uO!W;ZO~P#.{Op;[O!e#vO(p'nO~O[;^O!W;ZO~P#.{O!Z'nq!['nq~P#BPO!Z#f!Z![#f!Z~P#BPO#i%d!ZP%d!ZR%d!Z[%d!Za%d!Zp%d!Z!Q%d!Z!Z%d!Z!j%d!Z!n%d!Z#P%d!Z#l%d!Z#m%d!Z#n%d!Z#o%d!Z#p%d!Z#q%d!Z#r%d!Z#s%d!Z#t%d!Z#u%d!Z#w%d!Z#y%d!Z#z%d!Z'x%d!Z(_%d!Z(p%d!Z!i%d!Z!W%d!Z'u%d!Z#^%d!Zt%d!Z!]%d!Z%h%d!Z!e%d!Z~P#.{Op;fO!e#vO(p'nO~O!W;gO~P#.{Op;nO!e#vO(p'nO~O!W;oO~P#.{OP%d!ZR%d!Z[%d!Zp%d!Z!Q%d!Z!j%d!Z!n%d!Z#P%d!Z#l%d!Z#m%d!Z#n%d!Z#o%d!Z#p%d!Z#q%d!Z#r%d!Z#s%d!Z#t%d!Z#u%d!Z#w%d!Z#y%d!Z#z%d!Z#}%d!Z(_%d!Z(p%d!Z!Z%d!Z![%d!Z~P'%sOp;rO!e#vO(p'nO~Ot(dX~P1qO!O%qO~P!(yO(S!lO~P!(yO!WfX!ZfX#^fX~P%0XOP]XR]X[]Xp]X!O]X!Q]X!Z]X!ZfX!j]X!n]X#P]X#Q]X#^]X#^fX#ifX#l]X#m]X#n]X#o]X#p]X#q]X#r]X#s]X#t]X#u]X#w]X#y]X#z]X$P]X(_]X(p]X(w]X(x]X~O!efX!i]X!ifX(pfX~P'JlOP;vOQ;vOSfOd=rOe!iOnkOp;vOqkOrkOxkOz;vO|;vO!QWO!UkO!VkO!]XO!g;yO!jZO!m;vO!n;vO!o;vO!q;zO!s;}O!v!hO$V!kO$m=pO(R)ZO(TTO(WUO(_VO(m[O~O!Z<ZO![$pa~Oh%VOn%WOp%XOq$tOr$tOx%YOz%ZO|<fO!Q${O!]$|O!g=wO!j$xO#h<lO$V%_O$s<hO$u<jO$x%`O(R(tO(TTO(WUO(_$uO(w$}O(x%PO~Oj)bO~P( bOp!cX(p!cX~P# qOp(hX(p(hX~P#!dO![]X![fX~P'JlO!WfX!W$yX!ZfX!Z$yX#^fX~P!/qO#i<OO~O!e#vO#i<OO~O#^<`O~O#t<SO~O#^<pO!Z(uX![(uX~O#^<`O!Z(sX![(sX~O#i<qO~Og<sO~P!0uO#i<yO~O#i<zO~O!e#vO#i<{O~O!e#vO#i<qO~O#}<|O~P#BPO#i<}O~O#i=OO~O#i=TO~O#i=UO~O#i=VO~O#i=WO~O#}=XO~P!0uO#}=YO~P!0uO#Q#R#S#U#V#Y#g#h#s$m$s$u$x%[%]%g%h%i%p%r%u%v%x%z~'|T#m!V'z(S#nq#l#op!O'{$['{(R$^(c~",
    goto: "$8f)ZPPPPPP)[PP)_P)pP+Q/VPPPP6aPP6wPP<oP@cP@yP@yPPP@yPCRP@yP@yP@yPCVPC[PCyPHsPPPHwPPPPHwKzPPPLQLrPHwPHwPP! QHwPPPHwPHwP!#XHwP!&o!'t!'}P!(q!(u!(q!,SPPPPPPP!,s!'tPP!-T!.uP!2RHwHw!2W!5d!:Q!:Q!>PPPP!>XHwPPPPPPPPPP!AhP!BuPPHw!DWPHwPHwHwHwHwHwPHw!EjP!HtP!KzP!LO!LY!L^!L^P!HqP!Lb!LbP# hP# lHwPHw# r#$wCV@yP@yP@y@yP#&U@y@y#(h@y#+`@y#-l@y@y#.[#0p#0p#0u#1O#0p#1ZPP#0pP@y#1s@y#5r@y@y6aPPP#9wPPP#:b#:bP#:bP#:x#:bPP#;OP#:uP#:u#;c#:u#;}#<T#<W)_#<Z)_P#<b#<b#<bP)_P)_P)_P)_PP)_P#<h#<kP#<k)_P#<oP#<rP)_P)_P)_P)_P)_P)_)_PP#<x#=O#=Z#=a#=g#=m#=s#>R#>X#>c#>i#>s#>y#?Z#?a#@R#@e#@k#@q#AP#Af#CZ#Ci#Cp#E[#Ej#G[#Gj#Gp#Gv#G|#HW#H^#Hd#Hn#IQ#IWPPPPPPPPPPP#I^PPPPPPP#JR#MY#Nr#Ny$ RPPP$&mP$&v$)o$0Y$0]$0`$1_$1b$1i$1qP$1w$1zP$2h$2l$3d$4r$4w$5_PP$5d$5j$5n$5q$5u$5y$6u$7^$7u$7y$7|$8P$8V$8Y$8^$8bR!|RoqOXst!Z#d%l&p&r&s&u,n,s2S2VY!vQ'^-`1g5qQ%svQ%{yQ&S|Q&h!VS'U!e-WQ'd!iS'j!r!yU*h$|*X*lQ+l%|Q+y&UQ,_&bQ-^']Q-h'eQ-p'kQ0U*nQ1q,`R<m;z%SdOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%l%s&Q&i&l&p&r&s&u&y'R'`'p(R(T(Z(b(v(x(|){*f+U+Y,k,n,s-d-l-z.Q.o.v/i0V0d0l0|1j1z1{1}2P2S2V2X2x3O3d4q5y6Z6[6_6r8i8x9SS#q];w!r)]$Z$n'V)q-P-S/Q2h3{5m6i9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sU*{%[<e<fQ+q&OQ,a&eQ,h&mQ0r+dQ0u+fQ1S+rQ1y,fQ3W.bQ5V0wQ5]0}Q6Q1rQ7O3[Q8U5^R9Y7Q'QkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%l%s&Q&i&l&m&p&r&s&u&y'R'V'`'p(R(T(Z(b(v(x(|)q){*f+U+Y+d,k,n,s-P-S-d-l-z.Q.b.o.v/Q/i0V0d0l0|1j1z1{1}2P2S2V2X2h2x3O3[3d3{4q5m5y6Z6[6_6i6r7Q8i8x9S9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=s!S!nQ!r!v!y!z$|'U']'^'j'k'l*h*l*n*o-W-^-`-p0U0X1g5q5s%[$ti#v$b$c$d$x${%O%Q%]%^%b)w*P*R*T*W*^*d*t*u+c+f+},Q.a.z/_/h/r/s/u0Y0[0g0h0i1^1a1i3Z4U4V4a4f4w5R5U5x6|7l7v7|8Q8f9V9e9n9t:S:f:t:};V;^<^<_<a<b<c<d<g<h<i<j<k<l<t<u<v<w<y<z<}=O=P=Q=R=S=T=U=X=Y=p=x=y=|=}Q&V|Q'S!eS'Y%h-ZQ+q&OQ,a&eQ0f+OQ1S+rQ1X+xQ1x,eQ1y,fQ5]0}Q5f1ZQ6Q1rQ6T1tQ6U1wQ8U5^Q8X5cQ8q6WQ9|8YQ:Y8nR<o*XrnOXst!V!Z#d%l&g&p&r&s&u,n,s2S2VR,c&i&z^OPXYstuvwz!Z!`!g!j!o#S#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%l%s&Q&i&l&m&p&r&s&u&y'R'`'p(T(Z(b(v(x(|)q){*f+U+Y+d,k,n,s-P-S-d-l-z.Q.b.o.v/Q/i0V0d0l0|1j1z1{1}2P2S2V2X2h2x3O3[3d3{4q5m5y6Z6[6_6i6r7Q8i8x9S9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=r=s[#]WZ#W#Z'V(R!b%im#h#i#l$x%d%g([(f(g(h*W*[*_+W+X+Z,j-Q.O.U.V.W.Y/h/k2[3S3T4X6h6yQ%vxQ%zyS&P|&UQ&]!TQ'a!hQ'c!iQ(o#sS+k%{%|Q+o&OQ,Y&`Q,^&bS-g'd'eQ.d(pQ0{+lQ1R+rQ1T+sQ1W+wQ1l,ZS1p,_,`Q2t-hQ5[0}Q5`1QQ5e1YQ6P1qQ8T5^Q8W5bQ9x8SR:w9y!U$zi$d%O%Q%]%^%b*P*R*^*t*u.z/r0Y0[0g0h0i4V4w7|9e=p=x=y!^%xy!i!u%z%{%|'T'c'd'e'i's*g+k+l-T-g-h-o/{0O0{2m2t2{4i4j4m7s9pQ+e%vQ,O&YQ,R&ZQ,]&bQ.c(oQ1k,YU1o,^,_,`Q3].dQ5z1lS6O1p1qQ8m6P#f=t#v$b$c$x${)w*T*W*d+c+f+},Q.a/_/h/s/u1^1a1i3Z4U4a4f5R5U5x6|7l7v8Q8f9V9n9t:S:f:t:};V;^<a<c<g<i<k<t<v<y<}=P=R=T=X=|=}o=u<^<_<b<d<h<j<l<u<w<z=O=Q=S=U=YW%Ti%V*v=pS&Y!Q&gQ&Z!RQ&[!SQ+S%cR+|&W%]%Si#v$b$c$d$x${%O%Q%]%^%b)w*P*R*T*W*^*d*t*u+c+f+},Q.a.z/_/h/r/s/u0Y0[0g0h0i1^1a1i3Z4U4V4a4f4w5R5U5x6|7l7v7|8Q8f9V9e9n9t:S:f:t:};V;^<^<_<a<b<c<d<g<h<i<j<k<l<t<u<v<w<y<z<}=O=P=Q=R=S=T=U=X=Y=p=x=y=|=}T)x$u)yV*{%[<e<fW'Y!e%h*X-ZS({#y#zQ+`%qQ+v&RS.](k(lQ1b,SQ4x0cR8^5k'QkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%l%s&Q&i&l&m&p&r&s&u&y'R'V'`'p(R(T(Z(b(v(x(|)q){*f+U+Y+d,k,n,s-P-S-d-l-z.Q.b.o.v/Q/i0V0d0l0|1j1z1{1}2P2S2V2X2h2x3O3[3d3{4q5m5y6Z6[6_6i6r7Q8i8x9S9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=s$i$^c#Y#e%p%r%t(Q(W(r(w)P)Q)R)S)T)U)V)W)X)Y)[)^)`)e)o+a+u-U-s-x-}.P.n.q.u.w.x.y/]0j2c2f2v2}3c3h3i3j3k3l3m3n3o3p3q3r3s3t3w3x4P5O5Y6k6q6v7V7W7a7b8`8|9Q9[9b9c:c:y;R;x=gT#TV#U'RkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%l%s&Q&i&l&m&p&r&s&u&y'R'V'`'p(R(T(Z(b(v(x(|)q){*f+U+Y+d,k,n,s-P-S-d-l-z.Q.b.o.v/Q/i0V0d0l0|1j1z1{1}2P2S2V2X2h2x3O3[3d3{4q5m5y6Z6[6_6i6r7Q8i8x9S9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sQ'W!eR2i-W!W!nQ!e!r!v!y!z$|'U']'^'j'k'l*X*h*l*n*o-W-^-`-p0U0X1g5q5sR1d,UnqOXst!Z#d%l&p&r&s&u,n,s2S2VQ&w!^Q't!xS(q#u<OQ+i%yQ,W&]Q,X&_Q-e'bQ-r'mS.m(v<qS0k+U<{Q0y+jQ1f,VQ2Z,uQ2],vQ2e-RQ2r-fQ2u-jS5P0l=VQ5W0zS5Z0|=WQ6j2gQ6n2sQ6s2zQ8R5XQ8}6lQ9O6oQ9R6tR:`8z$d$]c#Y#e%r%t(Q(W(r(w)P)Q)R)S)T)U)V)W)X)Y)[)^)`)e)o+a+u-U-s-x-}.P.n.q.u.x.y/]0j2c2f2v2}3c3h3i3j3k3l3m3n3o3p3q3r3s3t3w3x4P5O5Y6k6q6v7V7W7a7b8`8|9Q9[9b9c:c:y;R;x=gS(m#p'gQ(}#zS+_%p.wS.^(l(nR3U._'QkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%l%s&Q&i&l&m&p&r&s&u&y'R'V'`'p(R(T(Z(b(v(x(|)q){*f+U+Y+d,k,n,s-P-S-d-l-z.Q.b.o.v/Q/i0V0d0l0|1j1z1{1}2P2S2V2X2h2x3O3[3d3{4q5m5y6Z6[6_6i6r7Q8i8x9S9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sS#q];wQ&r!XQ&s!YQ&u![Q&v!]R2R,qQ'_!hQ+b%vQ-c'aS.`(o+eQ2p-bW3Y.c.d0q0sQ6m2qW6z3V3X3]5TU9U6{6}7PU:e9W9X9ZS;T:d:gQ;b;UR;j;cU!wQ'^-`T5o1g5q!Q_OXZ`st!V!Z#d#h%d%l&g&i&p&r&s&u(h,n,s.V2S2V]!pQ!r'^-`1g5qT#q];w%^{OPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%l%s&Q&i&l&m&p&r&s&u&y'R'`'p(R(T(Z(b(v(x(|){*f+U+Y+d,k,n,s-d-l-z.Q.b.o.v/i0V0d0l0|1j1z1{1}2P2S2V2X2x3O3[3d4q5y6Z6[6_6r7Q8i8x9SS({#y#zS.](k(l!s=^$Z$n'V)q-P-S/Q2h3{5m6i9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sU$fd)],hS(n#p'gU*s%R(u3vU0e*z.i7]Q5T0rQ6{3WQ9X7OR:g9Ym!tQ!r!v!y!z'^'j'k'l-`-p1g5q5sQ'r!uS(d#g1|S-n'i'uQ/n*ZQ/{*gQ2|-qQ4]/oQ4i/}Q4j0OQ4o0WQ7h4WS7s4k4mS7w4p4rQ9g7iQ9k7oQ9p7tQ9u7yS:o9l9mS;Y:p:sS;e;Z;[S;m;f;gS;q;n;oR;t;rQ#wbQ'q!uS(c#g1|S(e#m+TQ+V%eQ+g%wQ+m%}U-m'i'r'uQ.R(dQ/m*ZQ/|*gQ0P*iQ0x+hQ1m,[S2y-n-qQ3R.ZS4[/n/oQ4e/yS4h/{0WQ4l0QQ5|1nQ6u2|Q7g4WQ7k4]U7r4i4o4rQ7u4nQ8k5}S9f7h7iQ9j7oQ9r7wQ9s7xQ:V8lQ:m9gS:n9k9mQ:v9uQ;P:WS;X:o:sS;d;Y;ZS;l;e;gS;p;m;oQ;s;qQ;u;tQ=a=[Q=l=eR=m=fV!wQ'^-`%^aOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%l%s&Q&i&l&m&p&r&s&u&y'R'`'p(R(T(Z(b(v(x(|){*f+U+Y+d,k,n,s-d-l-z.Q.b.o.v/i0V0d0l0|1j1z1{1}2P2S2V2X2x3O3[3d4q5y6Z6[6_6r7Q8i8x9SS#wz!j!r=Z$Z$n'V)q-P-S/Q2h3{5m6i9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sR=a=r%^bOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%l%s&Q&i&l&m&p&r&s&u&y'R'`'p(R(T(Z(b(v(x(|){*f+U+Y+d,k,n,s-d-l-z.Q.b.o.v/i0V0d0l0|1j1z1{1}2P2S2V2X2x3O3[3d4q5y6Z6[6_6r7Q8i8x9SQ%ej!^%wy!i!u%z%{%|'T'c'd'e'i's*g+k+l-T-g-h-o/{0O0{2m2t2{4i4j4m7s9pS%}z!jQ+h%xQ,[&bW1n,],^,_,`U5}1o1p1qS8l6O6PQ:W8m!r=[$Z$n'V)q-P-S/Q2h3{5m6i9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sQ=e=qR=f=r%QeOPXYstuvw!Z!`!g!o#S#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%l%s&Q&i&l&p&r&s&u&y'R'`'p(T(Z(b(v(x(|){*f+U+Y+d,k,n,s-d-l-z.Q.b.o.v/i0V0d0l0|1j1z1{1}2P2S2V2X2x3O3[3d4q5y6Z6[6_6r7Q8i8x9SY#bWZ#W#Z(R!b%im#h#i#l$x%d%g([(f(g(h*W*[*_+W+X+Z,j-Q.O.U.V.W.Y/h/k2[3S3T4X6h6yQ,i&m!p=]$Z$n)q-P-S/Q2h3{5m6i9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sR=`'VU'Z!e%h*XR2k-Z%SdOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%l%s&Q&i&l&p&r&s&u&y'R'`'p(R(T(Z(b(v(x(|){*f+U+Y,k,n,s-d-l-z.Q.o.v/i0V0d0l0|1j1z1{1}2P2S2V2X2x3O3d4q5y6Z6[6_6r8i8x9S!r)]$Z$n'V)q-P-S/Q2h3{5m6i9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sQ,h&mQ0r+dQ3W.bQ7O3[R9Y7Q!b$Tc#Y%p(Q(W(r(w)X)Y)^)e+u-s-x-}.P.n.q/]0j2v2}3c3s5O5Y6q6v7V9Q:c;x!P<U)[)o-U.w2c2f3h3q3r3w4P6k7W7a7b8`8|9[9b9c:y;R=g!f$Vc#Y%p(Q(W(r(w)U)V)X)Y)^)e+u-s-x-}.P.n.q/]0j2v2}3c3s5O5Y6q6v7V9Q:c;x!T<W)[)o-U.w2c2f3h3n3o3q3r3w4P6k7W7a7b8`8|9[9b9c:y;R=g!^$Zc#Y%p(Q(W(r(w)^)e+u-s-x-}.P.n.q/]0j2v2}3c3s5O5Y6q6v7V9Q:c;xQ4V/fz=s)[)o-U.w2c2f3h3w4P6k7W7a7b8`8|9[9b9c:y;R=gQ=x=zR=y={'QkOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n%l%s&Q&i&l&m&p&r&s&u&y'R'V'`'p(R(T(Z(b(v(x(|)q){*f+U+Y+d,k,n,s-P-S-d-l-z.Q.b.o.v/Q/i0V0d0l0|1j1z1{1}2P2S2V2X2h2x3O3[3d3{4q5m5y6Z6[6_6i6r7Q8i8x9S9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sS$oh$pR3|/P'XgOPWXYZhstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n$p%l%s&Q&i&l&m&p&r&s&u&y'R'V'`'p(R(T(Z(b(v(x(|)q){*f+U+Y+d,k,n,s-P-S-d-l-z.Q.b.o.v/P/Q/i0V0d0l0|1j1z1{1}2P2S2V2X2h2x3O3[3d3{4q5m5y6Z6[6_6i6r7Q8i8x9S9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sT$kf$qQ$ifS)h$l)lR)t$qT$jf$qT)j$l)l'XhOPWXYZhstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$Z$_$a$e$n$p%l%s&Q&i&l&m&p&r&s&u&y'R'V'`'p(R(T(Z(b(v(x(|)q){*f+U+Y+d,k,n,s-P-S-d-l-z.Q.b.o.v/P/Q/i0V0d0l0|1j1z1{1}2P2S2V2X2h2x3O3[3d3{4q5m5y6Z6[6_6i6r7Q8i8x9S9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=sT$oh$pQ$rhR)s$p%^jOPWXYZstuvw!Z!`!g!o#S#W#Z#d#o#u#x#{$O$P$Q$R$S$T$U$V$W$X$_$a$e%l%s&Q&i&l&m&p&r&s&u&y'R'`'p(R(T(Z(b(v(x(|){*f+U+Y+d,k,n,s-d-l-z.Q.b.o.v/i0V0d0l0|1j1z1{1}2P2S2V2X2x3O3[3d4q5y6Z6[6_6r7Q8i8x9S!s=q$Z$n'V)q-P-S/Q2h3{5m6i9}:a;v;y;z;}<O<P<Q<R<S<T<U<V<W<X<Y<Z<]<`<m<p<q<s<{<|=V=W=s#glOPXZst!Z!`!o#S#d#o#{$n%l&i&l&m&p&r&s&u&y'R'`(|)q*f+Y+d,k,n,s-d.b/Q/i0V0d1j1z1{1}2P2S2V2X3[3{4q5y6Z6[6_7Q8i8x!U%Ri$d%O%Q%]%^%b*P*R*^*t*u.z/r0Y0[0g0h0i4V4w7|9e=p=x=y#f(u#v$b$c$x${)w*T*W*d+c+f+},Q.a/_/h/s/u1^1a1i3Z4U4a4f5R5U5x6|7l7v8Q8f9V9n9t:S:f:t:};V;^<a<c<g<i<k<t<v<y<}=P=R=T=X=|=}Q+P%`Q/^)|o3v<^<_<b<d<h<j<l<u<w<z=O=Q=S=U=Y!U$yi$d%O%Q%]%^%b*P*R*^*t*u.z/r0Y0[0g0h0i4V4w7|9e=p=x=yQ*`$zU*i$|*X*lQ+Q%aQ0Q*j#f=c#v$b$c$x${)w*T*W*d+c+f+},Q.a/_/h/s/u1^1a1i3Z4U4a4f5R5U5x6|7l7v8Q8f9V9n9t:S:f:t:};V;^<a<c<g<i<k<t<v<y<}=P=R=T=X=|=}n=d<^<_<b<d<h<j<l<u<w<z=O=Q=S=U=YQ=h=tQ=i=uQ=j=vR=k=w!U%Ri$d%O%Q%]%^%b*P*R*^*t*u.z/r0Y0[0g0h0i4V4w7|9e=p=x=y#f(u#v$b$c$x${)w*T*W*d+c+f+},Q.a/_/h/s/u1^1a1i3Z4U4a4f5R5U5x6|7l7v8Q8f9V9n9t:S:f:t:};V;^<a<c<g<i<k<t<v<y<}=P=R=T=X=|=}o3v<^<_<b<d<h<j<l<u<w<z=O=Q=S=U=YnoOXst!Z#d%l&p&r&s&u,n,s2S2VS*c${*WQ,|&|Q,}'OR4`/s%[%Si#v$b$c$d$x${%O%Q%]%^%b)w*P*R*T*W*^*d*t*u+c+f+},Q.a.z/_/h/r/s/u0Y0[0g0h0i1^1a1i3Z4U4V4a4f4w5R5U5x6|7l7v7|8Q8f9V9e9n9t:S:f:t:};V;^<^<_<a<b<c<d<g<h<i<j<k<l<t<u<v<w<y<z<}=O=P=Q=R=S=T=U=X=Y=p=x=y=|=}Q,P&ZQ1`,RQ5i1_R8]5jV*k$|*X*lU*k$|*X*lT5p1g5qS/y*f/iQ4n0VT7x4q:PQ+g%wQ0P*iQ0x+hQ1m,[Q5|1nQ8k5}Q:V8lR;P:W!U%Oi$d%O%Q%]%^%b*P*R*^*t*u.z/r0Y0[0g0h0i4V4w7|9e=p=x=yx*P$v)c*Q*r+R/q0^0_3y4^4{4|4}7f7z9v:l=b=n=oS0Y*q0Z#f<a#v$b$c$x${)w*T*W*d+c+f+},Q.a/_/h/s/u1^1a1i3Z4U4a4f5R5U5x6|7l7v8Q8f9V9n9t:S:f:t:};V;^<a<c<g<i<k<t<v<y<}=P=R=T=X=|=}n<b<^<_<b<d<h<j<l<u<w<z=O=Q=S=U=Y!d<t(s)a*Y*b.e.h.l/Y/f/v0p1]3`4S4_4c5h7R7U7m7p7}8P9i9q9w:q:u;W;];h=z={`<u3u7X7[7`9]:h:k;kS=P.g3aT=Q7Z9`!U%Qi$d%O%Q%]%^%b*P*R*^*t*u.z/r0Y0[0g0h0i4V4w7|9e=p=x=y|*R$v)c*S*q+R/b/q0^0_3y4^4s4{4|4}7f7z9v:l=b=n=oS0[*r0]#f<c#v$b$c$x${)w*T*W*d+c+f+},Q.a/_/h/s/u1^1a1i3Z4U4a4f5R5U5x6|7l7v8Q8f9V9n9t:S:f:t:};V;^<a<c<g<i<k<t<v<y<}=P=R=T=X=|=}n<d<^<_<b<d<h<j<l<u<w<z=O=Q=S=U=Y!h<v(s)a*Y*b.f.g.l/Y/f/v0p1]3^3`4S4_4c5h7R7S7U7m7p7}8P9i9q9w:q:u;W;];h=z={d<w3u7Y7Z7`9]9^:h:i:k;kS=R.h3bT=S7[9arnOXst!V!Z#d%l&g&p&r&s&u,n,s2S2VQ&d!UR,k&mrnOXst!V!Z#d%l&g&p&r&s&u,n,s2S2VR&d!UQ,T&[R1[+|snOXst!V!Z#d%l&g&p&r&s&u,n,s2S2VQ1h,YS5w1k1lU8e5u5v5zS:R8g8hS:{:Q:TQ;_:|R;i;`Q&k!VR,d&gR6T1tR:Y8nS&P|&UR1T+sQ&p!WR,n&qR,t&vT2T,s2VR,x&wQ,w&wR2^,xQ'w!{R-t'wSsOtQ#dXT%os#dQ#OTR'y#OQ#RUR'{#RQ)y$uR/Z)yQ#UVR(O#UQ#XWU(U#X(V-{Q(V#YR-{(WQ-X'WR2j-XQ.p(wS3e.p3fR3f.qQ-`'^R2n-`Y!rQ'^-`1g5qR'h!rQ.{)cR3z.{U#_W%g*WU(]#_(^-|Q(^#`R-|(XQ-['ZR2l-[t`OXst!V!Z#d%l&g&i&p&r&s&u,n,s2S2VS#hZ%dU#r`#h.VR.V(hQ(i#jQ.S(eW.[(i.S3P6wQ3P.TR6w3QQ)l$lR/R)lQ$phR)r$pQ$`cU)_$`-w<[Q-w;xR<[)oQ/l*ZW4Y/l4Z7j9hU4Z/m/n/oS7j4[4]R9h7k$e*O$v(s)a)c*Y*b*q*r*|*}+R.g.h.j.k.l/Y/b/d/f/q/v0^0_0p1]3^3_3`3u3y4S4^4_4c4s4u4{4|4}5h7R7S7T7U7Z7[7^7_7`7f7m7p7z7}8P9]9^9_9i9q9v9w:h:i:j:k:l:q:u;W;];h;k=b=n=o=z={Q/t*bU4b/t4d7nQ4d/vR7n4cS*l$|*XR0S*lx*Q$v)c*q*r+R/q0^0_3y4^4{4|4}7f7z9v:l=b=n=o!d.e(s)a*Y*b.g.h.l/Y/f/v0p1]3`4S4_4c5h7R7U7m7p7}8P9i9q9w:q:u;W;];h=z={U/c*Q.e7Xa7X3u7Z7[7`9]:h:k;kQ0Z*qQ3a.gU4t0Z3a9`R9`7Z|*S$v)c*q*r+R/b/q0^0_3y4^4s4{4|4}7f7z9v:l=b=n=o!h.f(s)a*Y*b.g.h.l/Y/f/v0p1]3^3`4S4_4c5h7R7S7U7m7p7}8P9i9q9w:q:u;W;];h=z={U/e*S.f7Ye7Y3u7Z7[7`9]9^:h:i:k;kQ0]*rQ3b.hU4v0]3b9aR9a7[Q*w%UR0a*wQ5S0pR8O5SQ+[%jR0o+[Q5l1bS8_5l:OR:O8`Q,V&]R1e,VQ5q1gR8b5qQ1s,aS6R1s8oR8o6TQ1O+oW5_1O5a8V9zQ5a1RQ8V5`R9z8WQ+t&PR1U+tQ2V,sR6c2VYrOXst#dQ&t!ZQ+^%lQ,m&pQ,o&rQ,p&sQ,r&uQ2Q,nS2T,s2VR6b2SQ%npQ&x!_Q&{!aQ&}!bQ'P!cQ'o!uQ+]%kQ+i%yQ+{&VQ,c&kQ,z&zW-k'i'q'r'uQ-r'mQ0R*kQ0y+jS1v,d,gQ2_,yQ2`,|Q2a,}Q2u-jW2w-m-n-q-sQ5W0zQ5d1XQ5g1]Q5{1mQ6V1xQ6a2RU6p2v2y2|Q6s2zQ8R5XQ8Z5fQ8[5hQ8a5pQ8j5|Q8p6US9P6q6uQ9R6tQ9{8XQ:U8kQ:Z8qQ:b9QQ:x9|Q;O:VQ;S:cR;a;PQ%yyQ'b!iQ'm!uU+j%z%{%|Q-R'TU-f'c'd'eS-j'i'sQ/z*gS0z+k+lQ2g-TS2s-g-hQ2z-oS4g/{0OQ5X0{Q6l2mQ6o2tQ6t2{U7q4i4j4mQ9o7sR:r9pS$wi=pR*x%VU%Ui%V=pR0`*vQ$viS(s#v+fS)a$b$cQ)c$dQ*Y$xS*b${*WQ*q%OQ*r%QQ*|%]Q*}%^Q+R%bQ.g<aQ.h<cQ.j<gQ.k<iQ.l<kQ/Y)wQ/b*PQ/d*RQ/f*TQ/q*^S/v*d/hQ0^*tQ0_*ul0p+c,Q.a1a1i3Z5x6|8f9V:S:f:};VQ1]+}Q3^<tQ3_<vQ3`<yS3u<^<_Q3y.zS4S/_4UQ4^/rQ4_/sQ4c/uQ4s0YQ4u0[Q4{0gQ4|0hQ4}0iQ5h1^Q7R<}Q7S=PQ7T=RQ7U=TQ7Z<bQ7[<dQ7^<hQ7_<jQ7`<lQ7f4VQ7m4aQ7p4fQ7z4wQ7}5RQ8P5UQ9]<zQ9^<uQ9_<wQ9i7lQ9q7vQ9v7|Q9w8QQ:h=OQ:i=QQ:j=SQ:k=UQ:l9eQ:q9nQ:u9tQ;W=XQ;]:tQ;h;^Q;k=YQ=b=pQ=n=xQ=o=yQ=z=|R={=}Q*z%[Q.i<eR7]<fnpOXst!Z#d%l&p&r&s&u,n,s2S2VQ!fPS#fZ#oQ&z!`W'f!o*f0V4qQ'}#SQ)O#{Q)p$nS,g&i&lQ,l&mQ,y&yS-O'R/iQ-b'`Q.s(|Q/V)qQ0m+YQ0s+dQ2O,kQ2q-dQ3X.bQ4O/QQ4y0dQ5v1jQ6X1zQ6Y1{Q6^1}Q6`2PQ6e2XQ7P3[Q7c3{Q8h5yQ8t6ZQ8u6[Q8w6_Q9Z7QQ:T8iR:_8x#[cOPXZst!Z!`!o#d#o#{%l&i&l&m&p&r&s&u&y'R'`(|*f+Y+d,k,n,s-d.b/i0V0d1j1z1{1}2P2S2V2X3[4q5y6Z6[6_7Q8i8xQ#YWQ#eYQ%puQ%rvS%tw!gS(Q#W(TQ(W#ZQ(r#uQ(w#xQ)P$OQ)Q$PQ)R$QQ)S$RQ)T$SQ)U$TQ)V$UQ)W$VQ)X$WQ)Y$XQ)[$ZQ)^$_Q)`$aQ)e$eW)o$n)q/Q3{Q+a%sQ+u&QS-U'V2hQ-s'pS-x(R-zQ-}(ZQ.P(bQ.n(vQ.q(xQ.u;vQ.w;yQ.x;zQ.y;}Q/]){Q0j+UQ2c-PQ2f-SQ2v-lQ2}.QQ3c.oQ3h<OQ3i<PQ3j<QQ3k<RQ3l<SQ3m<TQ3n<UQ3o<VQ3p<WQ3q<XQ3r<YQ3s.vQ3t<]Q3w<`Q3x<mQ4P<ZQ5O0lQ5Y0|Q6k<pQ6q2xQ6v3OQ7V3dQ7W<qQ7a<sQ7b<{Q8`5mQ8|6iQ9Q6rQ9[<|Q9b=VQ9c=WQ:c9SQ:y9}Q;R:aQ;x#SR=g=sR#[WR'X!el!tQ!r!v!y!z'^'j'k'l-`-p1g5q5sS'T!e-WU*g$|*X*lS-T'U']S0O*h*nQ0W*oQ2m-^Q4m0UR4r0XR(y#xQ!fQT-_'^-`]!qQ!r'^-`1g5qQ#p]R'g;wR)d$dY!uQ'^-`1g5qQ'i!rS's!v!yS'u!z5sS-o'j'kQ-q'lR2{-pT#kZ%dS#jZ%dS%jm,jU(e#h#i#lS.T(f(gQ.X(hQ0n+ZQ3Q.UU3R.V.W.YS6x3S3TR9T6yd#^W#W#Z%g(R([*W+W.O/hr#gZm#h#i#l%d(f(g(h+Z.U.V.W.Y3S3T6yS*Z$x*_Q/o*[Q1|,jQ2d-QQ4W/kQ6g2[Q7i4XQ8{6hT=_'V+XV#aW%g*WU#`W%g*WS(S#W([U(X#Z+W/hS-V'V+XT-y(R.OV'[!e%h*XQ$lfR)v$qT)k$l)lR3}/PT*]$x*_T*e${*WQ0q+cQ1_,QQ3V.aQ5j1aQ5u1iQ6}3ZQ8g5xQ9W6|Q:Q8fQ:d9VQ:|:SQ;U:fQ;`:}R;c;VnqOXst!Z#d%l&p&r&s&u,n,s2S2VQ&j!VR,c&gtmOXst!U!V!Z#d%l&g&p&r&s&u,n,s2S2VR,j&mT%km,jR1c,SR,b&eQ&T|R+z&UR+p&OT&n!W&qT&o!W&qT2U,s2V",
    nodeNames: "\u26A0 ArithOp ArithOp ?. JSXStartTag LineComment BlockComment Script Hashbang ExportDeclaration export Star as VariableName String Escape from ; default FunctionDeclaration async function VariableDefinition > < TypeParamList const TypeDefinition extends ThisType this LiteralType ArithOp Number BooleanLiteral TemplateType InterpolationEnd Interpolation InterpolationStart NullType null VoidType void TypeofType typeof MemberExpression . PropertyName [ TemplateString Escape Interpolation super RegExp ] ArrayExpression Spread , } { ObjectExpression Property async get set PropertyDefinition Block : NewTarget new NewExpression ) ( ArgList UnaryExpression delete LogicOp BitOp YieldExpression yield AwaitExpression await ParenthesizedExpression ClassExpression class ClassBody MethodDeclaration Decorator @ MemberExpression PrivatePropertyName CallExpression TypeArgList CompareOp < declare Privacy static abstract override PrivatePropertyDefinition PropertyDeclaration readonly accessor Optional TypeAnnotation Equals StaticBlock FunctionExpression ArrowFunction ParamList ParamList ArrayPattern ObjectPattern PatternProperty Privacy readonly Arrow MemberExpression BinaryExpression ArithOp ArithOp ArithOp ArithOp BitOp CompareOp instanceof satisfies in CompareOp BitOp BitOp BitOp LogicOp LogicOp ConditionalExpression LogicOp LogicOp AssignmentExpression UpdateOp PostfixExpression CallExpression InstantiationExpression TaggedTemplateExpression DynamicImport import ImportMeta JSXElement JSXSelfCloseEndTag JSXSelfClosingTag JSXIdentifier JSXBuiltin JSXIdentifier JSXNamespacedName JSXMemberExpression JSXSpreadAttribute JSXAttribute JSXAttributeValue JSXEscape JSXEndTag JSXOpenTag JSXFragmentTag JSXText JSXEscape JSXStartCloseTag JSXCloseTag PrefixCast < ArrowFunction TypeParamList SequenceExpression InstantiationExpression KeyofType keyof UniqueType unique ImportType InferredType infer TypeName ParenthesizedType FunctionSignature ParamList NewSignature IndexedType TupleType Label ArrayType ReadonlyType ObjectType MethodType PropertyType IndexSignature PropertyDefinition CallSignature TypePredicate asserts is NewSignature new UnionType LogicOp IntersectionType LogicOp ConditionalType ParameterizedType ClassDeclaration abstract implements type VariableDeclaration let var using TypeAliasDeclaration InterfaceDeclaration interface EnumDeclaration enum EnumBody NamespaceDeclaration namespace module AmbientDeclaration declare GlobalDeclaration global ClassDeclaration ClassBody AmbientFunctionDeclaration ExportGroup VariableName VariableName ImportDeclaration ImportGroup ForStatement for ForSpec ForInSpec ForOfSpec of WhileStatement while WithStatement with DoStatement do IfStatement if else SwitchStatement switch SwitchBody CaseLabel case DefaultLabel TryStatement try CatchClause catch FinallyClause finally ReturnStatement return ThrowStatement throw BreakStatement break ContinueStatement continue DebuggerStatement debugger LabeledStatement ExpressionStatement SingleExpression SingleClassItem",
    maxTerm: 378,
    context: $b86fa7aeb3b96990$var$trackNewline,
    nodeProps: [
        [
            "isolate",
            -8,
            5,
            6,
            14,
            35,
            37,
            49,
            51,
            53,
            ""
        ],
        [
            "group",
            -26,
            9,
            17,
            19,
            66,
            206,
            210,
            214,
            215,
            217,
            220,
            223,
            233,
            235,
            241,
            243,
            245,
            247,
            250,
            256,
            262,
            264,
            266,
            268,
            270,
            272,
            273,
            "Statement",
            -34,
            13,
            14,
            30,
            33,
            34,
            40,
            49,
            52,
            53,
            55,
            60,
            68,
            70,
            74,
            78,
            80,
            82,
            83,
            108,
            109,
            118,
            119,
            135,
            138,
            140,
            141,
            142,
            143,
            144,
            146,
            147,
            166,
            168,
            170,
            "Expression",
            -23,
            29,
            31,
            35,
            39,
            41,
            43,
            172,
            174,
            176,
            177,
            179,
            180,
            181,
            183,
            184,
            185,
            187,
            188,
            189,
            200,
            202,
            204,
            205,
            "Type",
            -3,
            86,
            101,
            107,
            "ClassItem"
        ],
        [
            "openedBy",
            23,
            "<",
            36,
            "InterpolationStart",
            54,
            "[",
            58,
            "{",
            71,
            "(",
            159,
            "JSXStartCloseTag"
        ],
        [
            "closedBy",
            -2,
            24,
            167,
            ">",
            38,
            "InterpolationEnd",
            48,
            "]",
            59,
            "}",
            72,
            ")",
            164,
            "JSXEndTag"
        ]
    ],
    propSources: [
        $b86fa7aeb3b96990$var$jsHighlight
    ],
    skippedNodes: [
        0,
        5,
        6,
        276
    ],
    repeatNodeCount: 37,
    tokenData: "$Fq07[R!bOX%ZXY+gYZ-yZ[+g[]%Z]^.c^p%Zpq+gqr/mrs3cst:_tuEruvJSvwLkwx! Yxy!'iyz!(sz{!)}{|!,q|}!.O}!O!,q!O!P!/Y!P!Q!9j!Q!R#:O!R![#<_![!]#I_!]!^#Jk!^!_#Ku!_!`$![!`!a$$v!a!b$*T!b!c$,r!c!}Er!}#O$-|#O#P$/W#P#Q$4o#Q#R$5y#R#SEr#S#T$7W#T#o$8b#o#p$<r#p#q$=h#q#r$>x#r#s$@U#s$f%Z$f$g+g$g#BYEr#BY#BZ$A`#BZ$ISEr$IS$I_$A`$I_$I|Er$I|$I}$Dk$I}$JO$Dk$JO$JTEr$JT$JU$A`$JU$KVEr$KV$KW$A`$KW&FUEr&FU&FV$A`&FV;'SEr;'S;=`I|<%l?HTEr?HT?HU$A`?HUOEr(n%d_$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z&j&hT$h&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c&j&zP;=`<%l&c'|'U]$h&j(X!bOY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}!b(SU(X!bOY'}Zw'}x#O'}#P;'S'};'S;=`(f<%lO'}!b(iP;=`<%l'}'|(oP;=`<%l&}'[(y]$h&j(UpOY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(rp)wU(UpOY)rZr)rs#O)r#P;'S)r;'S;=`*Z<%lO)rp*^P;=`<%l)r'[*dP;=`<%l(r#S*nX(Up(X!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g#S+^P;=`<%l*g(n+dP;=`<%l%Z07[+rq$h&j(Up(X!b'z0/lOX%ZXY+gYZ&cZ[+g[p%Zpq+gqr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p$f%Z$f$g+g$g#BY%Z#BY#BZ+g#BZ$IS%Z$IS$I_+g$I_$JT%Z$JT$JU+g$JU$KV%Z$KV$KW+g$KW&FU%Z&FU&FV+g&FV;'S%Z;'S;=`+a<%l?HT%Z?HT?HU+g?HUO%Z07[.ST(V#S$h&j'{0/lO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c07[.n_$h&j(Up(X!b'{0/lOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z)3p/x`$h&j!n),Q(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`0z!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW1V`#u(Ch$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`2X!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW2d_#u(Ch$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'At3l_(T':f$h&j(X!bOY4kYZ5qZr4krs7nsw4kwx5qx!^4k!^!_8p!_#O4k#O#P5q#P#o4k#o#p8p#p;'S4k;'S;=`:X<%lO4k(^4r_$h&j(X!bOY4kYZ5qZr4krs7nsw4kwx5qx!^4k!^!_8p!_#O4k#O#P5q#P#o4k#o#p8p#p;'S4k;'S;=`:X<%lO4k&z5vX$h&jOr5qrs6cs!^5q!^!_6y!_#o5q#o#p6y#p;'S5q;'S;=`7h<%lO5q&z6jT$c`$h&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c`6|TOr6yrs7]s;'S6y;'S;=`7b<%lO6y`7bO$c``7eP;=`<%l6y&z7kP;=`<%l5q(^7w]$c`$h&j(X!bOY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}!r8uZ(X!bOY8pYZ6yZr8prs9hsw8pwx6yx#O8p#O#P6y#P;'S8p;'S;=`:R<%lO8p!r9oU$c`(X!bOY'}Zw'}x#O'}#P;'S'};'S;=`(f<%lO'}!r:UP;=`<%l8p(^:[P;=`<%l4k%9[:hh$h&j(Up(X!bOY%ZYZ&cZq%Zqr<Srs&}st%ZtuCruw%Zwx(rx!^%Z!^!_*g!_!c%Z!c!}Cr!}#O%Z#O#P&c#P#R%Z#R#SCr#S#T%Z#T#oCr#o#p*g#p$g%Z$g;'SCr;'S;=`El<%lOCr(r<__WS$h&j(Up(X!bOY<SYZ&cZr<Srs=^sw<Swx@nx!^<S!^!_Bm!_#O<S#O#P>`#P#o<S#o#pBm#p;'S<S;'S;=`Cl<%lO<S(Q=g]WS$h&j(X!bOY=^YZ&cZw=^wx>`x!^=^!^!_?q!_#O=^#O#P>`#P#o=^#o#p?q#p;'S=^;'S;=`@h<%lO=^&n>gXWS$h&jOY>`YZ&cZ!^>`!^!_?S!_#o>`#o#p?S#p;'S>`;'S;=`?k<%lO>`S?XSWSOY?SZ;'S?S;'S;=`?e<%lO?SS?hP;=`<%l?S&n?nP;=`<%l>`!f?xWWS(X!bOY?qZw?qwx?Sx#O?q#O#P?S#P;'S?q;'S;=`@b<%lO?q!f@eP;=`<%l?q(Q@kP;=`<%l=^'`@w]WS$h&j(UpOY@nYZ&cZr@nrs>`s!^@n!^!_Ap!_#O@n#O#P>`#P#o@n#o#pAp#p;'S@n;'S;=`Bg<%lO@ntAwWWS(UpOYApZrAprs?Ss#OAp#O#P?S#P;'SAp;'S;=`Ba<%lOAptBdP;=`<%lAp'`BjP;=`<%l@n#WBvYWS(Up(X!bOYBmZrBmrs?qswBmwxApx#OBm#O#P?S#P;'SBm;'S;=`Cf<%lOBm#WCiP;=`<%lBm(rCoP;=`<%l<S%9[C}i$h&j(m%1l(Up(X!bOY%ZYZ&cZr%Zrs&}st%ZtuCruw%Zwx(rx!Q%Z!Q![Cr![!^%Z!^!_*g!_!c%Z!c!}Cr!}#O%Z#O#P&c#P#R%Z#R#SCr#S#T%Z#T#oCr#o#p*g#p$g%Z$g;'SCr;'S;=`El<%lOCr%9[EoP;=`<%lCr07[FRk$h&j(Up(X!b$[#t(R,2j(c$I[OY%ZYZ&cZr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$g%Z$g;'SEr;'S;=`I|<%lOEr+dHRk$h&j(Up(X!b$[#tOY%ZYZ&cZr%Zrs&}st%ZtuGvuw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Gv![!^%Z!^!_*g!_!c%Z!c!}Gv!}#O%Z#O#P&c#P#R%Z#R#SGv#S#T%Z#T#oGv#o#p*g#p$g%Z$g;'SGv;'S;=`Iv<%lOGv+dIyP;=`<%lGv07[JPP;=`<%lEr(KWJ_`$h&j(Up(X!b#n(ChOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KWKl_$h&j$P(Ch(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z,#xLva(x+JY$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sv%ZvwM{wx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KWNW`$h&j#y(Ch(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'At! c_(W';W$h&j(UpOY!!bYZ!#hZr!!brs!#hsw!!bwx!$xx!^!!b!^!_!%z!_#O!!b#O#P!#h#P#o!!b#o#p!%z#p;'S!!b;'S;=`!'c<%lO!!b'l!!i_$h&j(UpOY!!bYZ!#hZr!!brs!#hsw!!bwx!$xx!^!!b!^!_!%z!_#O!!b#O#P!#h#P#o!!b#o#p!%z#p;'S!!b;'S;=`!'c<%lO!!b&z!#mX$h&jOw!#hwx6cx!^!#h!^!_!$Y!_#o!#h#o#p!$Y#p;'S!#h;'S;=`!$r<%lO!#h`!$]TOw!$Ywx7]x;'S!$Y;'S;=`!$l<%lO!$Y`!$oP;=`<%l!$Y&z!$uP;=`<%l!#h'l!%R]$c`$h&j(UpOY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(r!Q!&PZ(UpOY!%zYZ!$YZr!%zrs!$Ysw!%zwx!&rx#O!%z#O#P!$Y#P;'S!%z;'S;=`!']<%lO!%z!Q!&yU$c`(UpOY)rZr)rs#O)r#P;'S)r;'S;=`*Z<%lO)r!Q!'`P;=`<%l!%z'l!'fP;=`<%l!!b/5|!'t_!j/.^$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#&U!)O_!i!Lf$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z-!n!*[b$h&j(Up(X!b(S%&f#o(ChOY%ZYZ&cZr%Zrs&}sw%Zwx(rxz%Zz{!+d{!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW!+o`$h&j(Up(X!b#l(ChOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z+;x!,|`$h&j(Up(X!bp+4YOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z,$U!.Z_!Z+Jf$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[!/ec$h&j(Up(X!b!O.2^OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!0p!P!Q%Z!Q![!3Y![!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#%|!0ya$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!2O!P!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z#%|!2Z_!Y!L^$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!3eg$h&j(Up(X!bq'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!3Y![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S!3Y#S#X%Z#X#Y!4|#Y#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!5Vg$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx{%Z{|!6n|}%Z}!O!6n!O!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!6wc$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad!8_c$h&j(Up(X!bq'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![!8S![!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S!8S#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[!9uf$h&j(Up(X!b#m(ChOY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcxz!;Zz{#-}{!P!;Z!P!Q#/d!Q!^!;Z!^!_#(i!_!`#7S!`!a#8i!a!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z?O!;fb$h&j(Up(X!b!V7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z>^!<w`$h&j(X!b!V7`OY!<nYZ&cZw!<nwx!=yx!P!<n!P!Q!Eq!Q!^!<n!^!_!Gr!_!}!<n!}#O!KS#O#P!Dy#P#o!<n#o#p!Gr#p;'S!<n;'S;=`!L]<%lO!<n<z!>Q^$h&j!V7`OY!=yYZ&cZ!P!=y!P!Q!>|!Q!^!=y!^!_!@c!_!}!=y!}#O!CW#O#P!Dy#P#o!=y#o#p!@c#p;'S!=y;'S;=`!Ek<%lO!=y<z!?Td$h&j!V7`O!^&c!_#W&c#W#X!>|#X#Z&c#Z#[!>|#[#]&c#]#^!>|#^#a&c#a#b!>|#b#g&c#g#h!>|#h#i&c#i#j!>|#j#k!>|#k#m&c#m#n!>|#n#o&c#p;'S&c;'S;=`&w<%lO&c7`!@hX!V7`OY!@cZ!P!@c!P!Q!AT!Q!}!@c!}#O!Ar#O#P!Bq#P;'S!@c;'S;=`!CQ<%lO!@c7`!AYW!V7`#W#X!AT#Z#[!AT#]#^!AT#a#b!AT#g#h!AT#i#j!AT#j#k!AT#m#n!AT7`!AuVOY!ArZ#O!Ar#O#P!B[#P#Q!@c#Q;'S!Ar;'S;=`!Bk<%lO!Ar7`!B_SOY!ArZ;'S!Ar;'S;=`!Bk<%lO!Ar7`!BnP;=`<%l!Ar7`!BtSOY!@cZ;'S!@c;'S;=`!CQ<%lO!@c7`!CTP;=`<%l!@c<z!C][$h&jOY!CWYZ&cZ!^!CW!^!_!Ar!_#O!CW#O#P!DR#P#Q!=y#Q#o!CW#o#p!Ar#p;'S!CW;'S;=`!Ds<%lO!CW<z!DWX$h&jOY!CWYZ&cZ!^!CW!^!_!Ar!_#o!CW#o#p!Ar#p;'S!CW;'S;=`!Ds<%lO!CW<z!DvP;=`<%l!CW<z!EOX$h&jOY!=yYZ&cZ!^!=y!^!_!@c!_#o!=y#o#p!@c#p;'S!=y;'S;=`!Ek<%lO!=y<z!EnP;=`<%l!=y>^!Ezl$h&j(X!b!V7`OY&}YZ&cZw&}wx&cx!^&}!^!_'}!_#O&}#O#P&c#P#W&}#W#X!Eq#X#Z&}#Z#[!Eq#[#]&}#]#^!Eq#^#a&}#a#b!Eq#b#g&}#g#h!Eq#h#i&}#i#j!Eq#j#k!Eq#k#m&}#m#n!Eq#n#o&}#o#p'}#p;'S&};'S;=`(l<%lO&}8r!GyZ(X!b!V7`OY!GrZw!Grwx!@cx!P!Gr!P!Q!Hl!Q!}!Gr!}#O!JU#O#P!Bq#P;'S!Gr;'S;=`!J|<%lO!Gr8r!Hse(X!b!V7`OY'}Zw'}x#O'}#P#W'}#W#X!Hl#X#Z'}#Z#[!Hl#[#]'}#]#^!Hl#^#a'}#a#b!Hl#b#g'}#g#h!Hl#h#i'}#i#j!Hl#j#k!Hl#k#m'}#m#n!Hl#n;'S'};'S;=`(f<%lO'}8r!JZX(X!bOY!JUZw!JUwx!Arx#O!JU#O#P!B[#P#Q!Gr#Q;'S!JU;'S;=`!Jv<%lO!JU8r!JyP;=`<%l!JU8r!KPP;=`<%l!Gr>^!KZ^$h&j(X!bOY!KSYZ&cZw!KSwx!CWx!^!KS!^!_!JU!_#O!KS#O#P!DR#P#Q!<n#Q#o!KS#o#p!JU#p;'S!KS;'S;=`!LV<%lO!KS>^!LYP;=`<%l!KS>^!L`P;=`<%l!<n=l!Ll`$h&j(Up!V7`OY!LcYZ&cZr!Lcrs!=ys!P!Lc!P!Q!Mn!Q!^!Lc!^!_# o!_!}!Lc!}#O#%P#O#P!Dy#P#o!Lc#o#p# o#p;'S!Lc;'S;=`#&Y<%lO!Lc=l!Mwl$h&j(Up!V7`OY(rYZ&cZr(rrs&cs!^(r!^!_)r!_#O(r#O#P&c#P#W(r#W#X!Mn#X#Z(r#Z#[!Mn#[#](r#]#^!Mn#^#a(r#a#b!Mn#b#g(r#g#h!Mn#h#i(r#i#j!Mn#j#k!Mn#k#m(r#m#n!Mn#n#o(r#o#p)r#p;'S(r;'S;=`*a<%lO(r8Q# vZ(Up!V7`OY# oZr# ors!@cs!P# o!P!Q#!i!Q!}# o!}#O#$R#O#P!Bq#P;'S# o;'S;=`#$y<%lO# o8Q#!pe(Up!V7`OY)rZr)rs#O)r#P#W)r#W#X#!i#X#Z)r#Z#[#!i#[#])r#]#^#!i#^#a)r#a#b#!i#b#g)r#g#h#!i#h#i)r#i#j#!i#j#k#!i#k#m)r#m#n#!i#n;'S)r;'S;=`*Z<%lO)r8Q#$WX(UpOY#$RZr#$Rrs!Ars#O#$R#O#P!B[#P#Q# o#Q;'S#$R;'S;=`#$s<%lO#$R8Q#$vP;=`<%l#$R8Q#$|P;=`<%l# o=l#%W^$h&j(UpOY#%PYZ&cZr#%Prs!CWs!^#%P!^!_#$R!_#O#%P#O#P!DR#P#Q!Lc#Q#o#%P#o#p#$R#p;'S#%P;'S;=`#&S<%lO#%P=l#&VP;=`<%l#%P=l#&]P;=`<%l!Lc?O#&kn$h&j(Up(X!b!V7`OY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#W%Z#W#X#&`#X#Z%Z#Z#[#&`#[#]%Z#]#^#&`#^#a%Z#a#b#&`#b#g%Z#g#h#&`#h#i%Z#i#j#&`#j#k#&`#k#m%Z#m#n#&`#n#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z9d#(r](Up(X!b!V7`OY#(iZr#(irs!Grsw#(iwx# ox!P#(i!P!Q#)k!Q!}#(i!}#O#+`#O#P!Bq#P;'S#(i;'S;=`#,`<%lO#(i9d#)th(Up(X!b!V7`OY*gZr*grs'}sw*gwx)rx#O*g#P#W*g#W#X#)k#X#Z*g#Z#[#)k#[#]*g#]#^#)k#^#a*g#a#b#)k#b#g*g#g#h#)k#h#i*g#i#j#)k#j#k#)k#k#m*g#m#n#)k#n;'S*g;'S;=`+Z<%lO*g9d#+gZ(Up(X!bOY#+`Zr#+`rs!JUsw#+`wx#$Rx#O#+`#O#P!B[#P#Q#(i#Q;'S#+`;'S;=`#,Y<%lO#+`9d#,]P;=`<%l#+`9d#,cP;=`<%l#(i?O#,o`$h&j(Up(X!bOY#,fYZ&cZr#,frs!KSsw#,fwx#%Px!^#,f!^!_#+`!_#O#,f#O#P!DR#P#Q!;Z#Q#o#,f#o#p#+`#p;'S#,f;'S;=`#-q<%lO#,f?O#-tP;=`<%l#,f?O#-zP;=`<%l!;Z07[#.[b$h&j(Up(X!b'|0/l!V7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z07[#/o_$h&j(Up(X!bT0/lOY#/dYZ&cZr#/drs#0nsw#/dwx#4Ox!^#/d!^!_#5}!_#O#/d#O#P#1p#P#o#/d#o#p#5}#p;'S#/d;'S;=`#6|<%lO#/d06j#0w]$h&j(X!bT0/lOY#0nYZ&cZw#0nwx#1px!^#0n!^!_#3R!_#O#0n#O#P#1p#P#o#0n#o#p#3R#p;'S#0n;'S;=`#3x<%lO#0n05W#1wX$h&jT0/lOY#1pYZ&cZ!^#1p!^!_#2d!_#o#1p#o#p#2d#p;'S#1p;'S;=`#2{<%lO#1p0/l#2iST0/lOY#2dZ;'S#2d;'S;=`#2u<%lO#2d0/l#2xP;=`<%l#2d05W#3OP;=`<%l#1p01O#3YW(X!bT0/lOY#3RZw#3Rwx#2dx#O#3R#O#P#2d#P;'S#3R;'S;=`#3r<%lO#3R01O#3uP;=`<%l#3R06j#3{P;=`<%l#0n05x#4X]$h&j(UpT0/lOY#4OYZ&cZr#4Ors#1ps!^#4O!^!_#5Q!_#O#4O#O#P#1p#P#o#4O#o#p#5Q#p;'S#4O;'S;=`#5w<%lO#4O00^#5XW(UpT0/lOY#5QZr#5Qrs#2ds#O#5Q#O#P#2d#P;'S#5Q;'S;=`#5q<%lO#5Q00^#5tP;=`<%l#5Q05x#5zP;=`<%l#4O01p#6WY(Up(X!bT0/lOY#5}Zr#5}rs#3Rsw#5}wx#5Qx#O#5}#O#P#2d#P;'S#5};'S;=`#6v<%lO#5}01p#6yP;=`<%l#5}07[#7PP;=`<%l#/d)3h#7ab$h&j$P(Ch(Up(X!b!V7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;ZAt#8vb$Y#t$h&j(Up(X!b!V7`OY!;ZYZ&cZr!;Zrs!<nsw!;Zwx!Lcx!P!;Z!P!Q#&`!Q!^!;Z!^!_#(i!_!}!;Z!}#O#,f#O#P!Dy#P#o!;Z#o#p#(i#p;'S!;Z;'S;=`#-w<%lO!;Z'Ad#:Zp$h&j(Up(X!bq'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!3Y!P!Q%Z!Q![#<_![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S#<_#S#U%Z#U#V#?i#V#X%Z#X#Y!4|#Y#b%Z#b#c#>_#c#d#Bq#d#l%Z#l#m#Es#m#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#<jk$h&j(Up(X!bq'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!O%Z!O!P!3Y!P!Q%Z!Q![#<_![!^%Z!^!_*g!_!g%Z!g!h!4|!h#O%Z#O#P&c#P#R%Z#R#S#<_#S#X%Z#X#Y!4|#Y#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#>j_$h&j(Up(X!bq'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#?rd$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!R#AQ!R!S#AQ!S!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#AQ#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#A]f$h&j(Up(X!bq'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!R#AQ!R!S#AQ!S!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#AQ#S#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#Bzc$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!Y#DV!Y!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#DV#S#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#Dbe$h&j(Up(X!bq'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q!Y#DV!Y!^%Z!^!_*g!_#O%Z#O#P&c#P#R%Z#R#S#DV#S#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#E|g$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![#Ge![!^%Z!^!_*g!_!c%Z!c!i#Ge!i#O%Z#O#P&c#P#R%Z#R#S#Ge#S#T%Z#T#Z#Ge#Z#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z'Ad#Gpi$h&j(Up(X!bq'9tOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!Q%Z!Q![#Ge![!^%Z!^!_*g!_!c%Z!c!i#Ge!i#O%Z#O#P&c#P#R%Z#R#S#Ge#S#T%Z#T#Z#Ge#Z#b%Z#b#c#>_#c#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z*)x#Il_!e$b$h&j#})Lv(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z)[#Jv_al$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z04f#LS^h#)`#P-<U(Up(X!b$m7`OY*gZr*grs'}sw*gwx)rx!P*g!P!Q#MO!Q!^*g!^!_#Mt!_!`$ f!`#O*g#P;'S*g;'S;=`+Z<%lO*g(n#MXX$j&j(Up(X!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g(El#M}Z#p(Ch(Up(X!bOY*gZr*grs'}sw*gwx)rx!_*g!_!`#Np!`#O*g#P;'S*g;'S;=`+Z<%lO*g(El#NyX$P(Ch(Up(X!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g(El$ oX#q(Ch(Up(X!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g*)x$!ga#^*!Y$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`0z!`!a$#l!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(K[$#w_#i(Cl$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z*)x$%Vag!*r#q(Ch$e#|$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`$&[!`!a$'f!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$&g_#q(Ch$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$'qa#p(Ch$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`!a$(v!a#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$)R`#p(Ch$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(Kd$*`a(p(Ct$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!a%Z!a!b$+e!b#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$+p`$h&j#z(Ch(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z%#`$,}_!z$Ip$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z04f$.X_!Q0,v$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(n$/]Z$h&jO!^$0O!^!_$0f!_#i$0O#i#j$0k#j#l$0O#l#m$2^#m#o$0O#o#p$0f#p;'S$0O;'S;=`$4i<%lO$0O(n$0VT_#S$h&jO!^&c!_#o&c#p;'S&c;'S;=`&w<%lO&c#S$0kO_#S(n$0p[$h&jO!Q&c!Q![$1f![!^&c!_!c&c!c!i$1f!i#T&c#T#Z$1f#Z#o&c#o#p$3|#p;'S&c;'S;=`&w<%lO&c(n$1kZ$h&jO!Q&c!Q![$2^![!^&c!_!c&c!c!i$2^!i#T&c#T#Z$2^#Z#o&c#p;'S&c;'S;=`&w<%lO&c(n$2cZ$h&jO!Q&c!Q![$3U![!^&c!_!c&c!c!i$3U!i#T&c#T#Z$3U#Z#o&c#p;'S&c;'S;=`&w<%lO&c(n$3ZZ$h&jO!Q&c!Q![$0O![!^&c!_!c&c!c!i$0O!i#T&c#T#Z$0O#Z#o&c#p;'S&c;'S;=`&w<%lO&c#S$4PR!Q![$4Y!c!i$4Y#T#Z$4Y#S$4]S!Q![$4Y!c!i$4Y#T#Z$4Y#q#r$0f(n$4lP;=`<%l$0O#1[$4z_!W#)l$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z(KW$6U`#w(Ch$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z+;p$7c_$h&j(Up(X!b(_+4QOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[$8qk$h&j(Up(X!b(R,2j$^#t(c$I[OY%ZYZ&cZr%Zrs&}st%Ztu$8buw%Zwx(rx}%Z}!O$:f!O!Q%Z!Q![$8b![!^%Z!^!_*g!_!c%Z!c!}$8b!}#O%Z#O#P&c#P#R%Z#R#S$8b#S#T%Z#T#o$8b#o#p*g#p$g%Z$g;'S$8b;'S;=`$<l<%lO$8b+d$:qk$h&j(Up(X!b$^#tOY%ZYZ&cZr%Zrs&}st%Ztu$:fuw%Zwx(rx}%Z}!O$:f!O!Q%Z!Q![$:f![!^%Z!^!_*g!_!c%Z!c!}$:f!}#O%Z#O#P&c#P#R%Z#R#S$:f#S#T%Z#T#o$:f#o#p*g#p$g%Z$g;'S$:f;'S;=`$<f<%lO$:f+d$<iP;=`<%l$:f07[$<oP;=`<%l$8b#Jf$<{X!]#Hb(Up(X!bOY*gZr*grs'}sw*gwx)rx#O*g#P;'S*g;'S;=`+Z<%lO*g,#x$=sa(w+JY$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_!`Ka!`#O%Z#O#P&c#P#o%Z#o#p*g#p#q$+e#q;'S%Z;'S;=`+a<%lO%Z)>v$?V_![(CdtBr$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z?O$@a_!o7`$h&j(Up(X!bOY%ZYZ&cZr%Zrs&}sw%Zwx(rx!^%Z!^!_*g!_#O%Z#O#P&c#P#o%Z#o#p*g#p;'S%Z;'S;=`+a<%lO%Z07[$Aq|$h&j(Up(X!b'z0/l$[#t(R,2j(c$I[OX%ZXY+gYZ&cZ[+g[p%Zpq+gqr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$f%Z$f$g+g$g#BYEr#BY#BZ$A`#BZ$ISEr$IS$I_$A`$I_$JTEr$JT$JU$A`$JU$KVEr$KV$KW$A`$KW&FUEr&FU&FV$A`&FV;'SEr;'S;=`I|<%l?HTEr?HT?HU$A`?HUOEr07[$D|k$h&j(Up(X!b'{0/l$[#t(R,2j(c$I[OY%ZYZ&cZr%Zrs&}st%ZtuEruw%Zwx(rx}%Z}!OGv!O!Q%Z!Q![Er![!^%Z!^!_*g!_!c%Z!c!}Er!}#O%Z#O#P&c#P#R%Z#R#SEr#S#T%Z#T#oEr#o#p*g#p$g%Z$g;'SEr;'S;=`I|<%lOEr",
    tokenizers: [
        $b86fa7aeb3b96990$var$noSemicolon,
        $b86fa7aeb3b96990$var$noSemicolonType,
        $b86fa7aeb3b96990$var$operatorToken,
        $b86fa7aeb3b96990$var$jsx,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12,
        13,
        14,
        $b86fa7aeb3b96990$var$insertSemicolon,
        new (0, $2sfCn.LocalTokenGroup)("$S~RRtu[#O#Pg#S#T#|~_P#o#pb~gOv~~jVO#i!P#i#j!U#j#l!P#l#m!q#m;'S!P;'S;=`#v<%lO!P~!UO!S~~!XS!Q![!e!c!i!e#T#Z!e#o#p#Z~!hR!Q![!q!c!i!q#T#Z!q~!tR!Q![!}!c!i!}#T#Z!}~#QR!Q![!P!c!i!P#T#Z!P~#^R!Q![#g!c!i#g#T#Z#g~#jS!Q![#g!c!i#g#T#Z#g#q#r!P~#yP;=`<%l!P~$RO(a~~", 141, 338),
        new (0, $2sfCn.LocalTokenGroup)("j~RQYZXz{^~^O(O~~aP!P!Qd~iO(P~~", 25, 321)
    ],
    topRules: {
        "Script": [
            0,
            7
        ],
        "SingleExpression": [
            1,
            274
        ],
        "SingleClassItem": [
            2,
            275
        ]
    },
    dialects: {
        jsx: 0,
        ts: 15091
    },
    dynamicPrecedences: {
        "78": 1,
        "80": 1,
        "92": 1,
        "168": 1,
        "198": 1
    },
    specialized: [
        {
            term: 325,
            get: (value)=>$b86fa7aeb3b96990$var$spec_identifier[value] || -1
        },
        {
            term: 341,
            get: (value)=>$b86fa7aeb3b96990$var$spec_word[value] || -1
        },
        {
            term: 93,
            get: (value)=>$b86fa7aeb3b96990$var$spec_LessThan[value] || -1
        }
    ],
    tokenPrec: 15116
});
module.exports["parser"] = $b86fa7aeb3b96990$export$8f49e4af10703ce3;

});

parcelRegister("9R6p6", function(module, exports) {

var $b2ZzE = parcelRequire("b2ZzE");


var $3e6dc = parcelRequire("3e6dc");


var $4lK5a = parcelRequire("4lK5a");


var $haZ24 = parcelRequire("haZ24");


var $4PTdL = parcelRequire("4PTdL");


var $iaLx3 = parcelRequire("iaLx3");


var $uXNGm = parcelRequire("uXNGm");

const $72ce07fd8a103ed3$var$data = /*@__PURE__*/ (0, $4lK5a.defineLanguageFacet)({
    commentTokens: {
        block: {
            open: "<!--",
            close: "-->"
        }
    }
});
const $72ce07fd8a103ed3$var$headingProp = /*@__PURE__*/ new (0, $uXNGm.NodeProp)();
const $72ce07fd8a103ed3$var$commonmark = /*@__PURE__*/ (0, $4PTdL.parser).configure({
    props: [
        /*@__PURE__*/ (0, $4lK5a.foldNodeProp).add((type)=>{
            return !type.is("Block") || type.is("Document") || $72ce07fd8a103ed3$var$isHeading(type) != null || $72ce07fd8a103ed3$var$isList(type) ? undefined : (tree, state)=>({
                    from: state.doc.lineAt(tree.from).to,
                    to: tree.to
                });
        }),
        /*@__PURE__*/ $72ce07fd8a103ed3$var$headingProp.add($72ce07fd8a103ed3$var$isHeading),
        /*@__PURE__*/ (0, $4lK5a.indentNodeProp).add({
            Document: ()=>null
        }),
        /*@__PURE__*/ (0, $4lK5a.languageDataProp).add({
            Document: $72ce07fd8a103ed3$var$data
        })
    ]
});
function $72ce07fd8a103ed3$var$isHeading(type) {
    let match = /^(?:ATX|Setext)Heading(\d)$/.exec(type.name);
    return match ? +match[1] : undefined;
}
function $72ce07fd8a103ed3$var$isList(type) {
    return type.name == "OrderedList" || type.name == "BulletList";
}
function $72ce07fd8a103ed3$var$findSectionEnd(headerNode, level) {
    let last = headerNode;
    for(;;){
        let next = last.nextSibling, heading;
        if (!next || (heading = $72ce07fd8a103ed3$var$isHeading(next.type)) != null && heading <= level) break;
        last = next;
    }
    return last.to;
}
const $72ce07fd8a103ed3$var$headerIndent = /*@__PURE__*/ (0, $4lK5a.foldService).of((state, start, end)=>{
    for(let node = (0, $4lK5a.syntaxTree)(state).resolveInner(end, -1); node; node = node.parent){
        if (node.from < start) break;
        let heading = node.type.prop($72ce07fd8a103ed3$var$headingProp);
        if (heading == null) continue;
        let upto = $72ce07fd8a103ed3$var$findSectionEnd(node, heading);
        if (upto > end) return {
            from: end,
            to: upto
        };
    }
    return null;
});
function $72ce07fd8a103ed3$var$mkLang(parser) {
    return new (0, $4lK5a.Language)($72ce07fd8a103ed3$var$data, parser, [
        $72ce07fd8a103ed3$var$headerIndent
    ], "markdown");
}
/**
Language support for strict CommonMark.
*/ const $72ce07fd8a103ed3$export$2aaf419d99815e51 = /*@__PURE__*/ $72ce07fd8a103ed3$var$mkLang($72ce07fd8a103ed3$var$commonmark);
const $72ce07fd8a103ed3$var$extended = /*@__PURE__*/ $72ce07fd8a103ed3$var$commonmark.configure([
    (0, $4PTdL.GFM),
    (0, $4PTdL.Subscript),
    (0, $4PTdL.Superscript),
    (0, $4PTdL.Emoji),
    {
        props: [
            /*@__PURE__*/ (0, $4lK5a.foldNodeProp).add({
                Table: (tree, state)=>({
                        from: state.doc.lineAt(tree.from).to,
                        to: tree.to
                    })
            })
        ]
    }
]);
/**
Language support for [GFM](https://github.github.com/gfm/) plus
subscript, superscript, and emoji syntax.
*/ const $72ce07fd8a103ed3$export$4e2e2689db0e8e2b = /*@__PURE__*/ $72ce07fd8a103ed3$var$mkLang($72ce07fd8a103ed3$var$extended);
function $72ce07fd8a103ed3$var$getCodeParser(languages, defaultLanguage) {
    return (info)=>{
        if (info && languages) {
            let found = null;
            // Strip anything after whitespace
            info = /\S*/.exec(info)[0];
            if (typeof languages == "function") found = languages(info);
            else found = (0, $4lK5a.LanguageDescription).matchLanguageName(languages, info, true);
            if (found instanceof (0, $4lK5a.LanguageDescription)) return found.support ? found.support.language.parser : (0, $4lK5a.ParseContext).getSkippingParser(found.load());
            else if (found) return found.parser;
        }
        return defaultLanguage ? defaultLanguage.parser : null;
    };
}
class $72ce07fd8a103ed3$var$Context {
    blank(maxWidth, trailing = true) {
        let result = this.spaceBefore + (this.node.name == "Blockquote" ? ">" : "");
        if (maxWidth != null) {
            while(result.length < maxWidth)result += " ";
            return result;
        } else {
            for(let i = this.to - this.from - result.length - this.spaceAfter.length; i > 0; i--)result += " ";
            return result + (trailing ? this.spaceAfter : "");
        }
    }
    marker(doc, add) {
        let number = this.node.name == "OrderedList" ? String(+$72ce07fd8a103ed3$var$itemNumber(this.item, doc)[2] + add) : "";
        return this.spaceBefore + number + this.type + this.spaceAfter;
    }
    constructor(node, from, to, spaceBefore, spaceAfter, type, item){
        this.node = node;
        this.from = from;
        this.to = to;
        this.spaceBefore = spaceBefore;
        this.spaceAfter = spaceAfter;
        this.type = type;
        this.item = item;
    }
}
function $72ce07fd8a103ed3$var$getContext(node, doc) {
    let nodes = [], context = [];
    for(let cur = node; cur; cur = cur.parent){
        if (cur.name == "FencedCode") return context;
        if (cur.name == "ListItem" || cur.name == "Blockquote") nodes.push(cur);
    }
    for(let i = nodes.length - 1; i >= 0; i--){
        let node = nodes[i], match;
        let line = doc.lineAt(node.from), startPos = node.from - line.from;
        if (node.name == "Blockquote" && (match = /^ *>( ?)/.exec(line.text.slice(startPos)))) context.push(new $72ce07fd8a103ed3$var$Context(node, startPos, startPos + match[0].length, "", match[1], ">", null));
        else if (node.name == "ListItem" && node.parent.name == "OrderedList" && (match = /^( *)\d+([.)])( *)/.exec(line.text.slice(startPos)))) {
            let after = match[3], len = match[0].length;
            if (after.length >= 4) {
                after = after.slice(0, after.length - 4);
                len -= 4;
            }
            context.push(new $72ce07fd8a103ed3$var$Context(node.parent, startPos, startPos + len, match[1], after, match[2], node));
        } else if (node.name == "ListItem" && node.parent.name == "BulletList" && (match = /^( *)([-+*])( {1,4}\[[ xX]\])?( +)/.exec(line.text.slice(startPos)))) {
            let after = match[4], len = match[0].length;
            if (after.length > 4) {
                after = after.slice(0, after.length - 4);
                len -= 4;
            }
            let type = match[2];
            if (match[3]) type += match[3].replace(/[xX]/, ' ');
            context.push(new $72ce07fd8a103ed3$var$Context(node.parent, startPos, startPos + len, match[1], after, type, node));
        }
    }
    return context;
}
function $72ce07fd8a103ed3$var$itemNumber(item, doc) {
    return /^(\s*)(\d+)(?=[.)])/.exec(doc.sliceString(item.from, item.from + 10));
}
function $72ce07fd8a103ed3$var$renumberList(after, doc, changes, offset = 0) {
    for(let prev = -1, node = after;;){
        if (node.name == "ListItem") {
            let m = $72ce07fd8a103ed3$var$itemNumber(node, doc);
            let number = +m[2];
            if (prev >= 0) {
                if (number != prev + 1) return;
                changes.push({
                    from: node.from + m[1].length,
                    to: node.from + m[0].length,
                    insert: String(prev + 2 + offset)
                });
            }
            prev = number;
        }
        let next = node.nextSibling;
        if (!next) break;
        node = next;
    }
}
function $72ce07fd8a103ed3$var$normalizeIndent(content, state) {
    let blank = /^[ \t]*/.exec(content)[0].length;
    if (!blank || state.facet((0, $4lK5a.indentUnit)) != "\t") return content;
    let col = (0, $b2ZzE.countColumn)(content, 4, blank);
    let space = "";
    for(let i = col; i > 0;)if (i >= 4) {
        space += "\t";
        i -= 4;
    } else {
        space += " ";
        i--;
    }
    return space + content.slice(blank);
}
/**
This command, when invoked in Markdown context with cursor
selection(s), will create a new line with the markup for
blockquotes and lists that were active on the old line. If the
cursor was directly after the end of the markup for the old line,
trailing whitespace and list markers are removed from that line.

The command does nothing in non-Markdown context, so it should
not be used as the only binding for Enter (even in a Markdown
document, HTML and code regions might use a different language).
*/ const $72ce07fd8a103ed3$export$4869a6855c4f3e2d = ({ state: state, dispatch: dispatch })=>{
    let tree = (0, $4lK5a.syntaxTree)(state), { doc: doc } = state;
    let dont = null, changes = state.changeByRange((range)=>{
        if (!range.empty || !$72ce07fd8a103ed3$export$4e2e2689db0e8e2b.isActiveAt(state, range.from, 0)) return dont = {
            range: range
        };
        let pos = range.from, line = doc.lineAt(pos);
        let context = $72ce07fd8a103ed3$var$getContext(tree.resolveInner(pos, -1), doc);
        while(context.length && context[context.length - 1].from > pos - line.from)context.pop();
        if (!context.length) return dont = {
            range: range
        };
        let inner = context[context.length - 1];
        if (inner.to - inner.spaceAfter.length > pos - line.from) return dont = {
            range: range
        };
        let emptyLine = pos >= inner.to - inner.spaceAfter.length && !/\S/.test(line.text.slice(inner.to));
        // Empty line in list
        if (inner.item && emptyLine) {
            let first = inner.node.firstChild, second = inner.node.getChild("ListItem", "ListItem");
            // Not second item or blank line before: delete a level of markup
            if (first.to >= pos || second && second.to < pos || line.from > 0 && !/[^\s>]/.test(doc.lineAt(line.from - 1).text)) {
                let next = context.length > 1 ? context[context.length - 2] : null;
                let delTo, insert = "";
                if (next && next.item) {
                    delTo = line.from + next.from;
                    insert = next.marker(doc, 1);
                } else delTo = line.from + (next ? next.to : 0);
                let changes = [
                    {
                        from: delTo,
                        to: pos,
                        insert: insert
                    }
                ];
                if (inner.node.name == "OrderedList") $72ce07fd8a103ed3$var$renumberList(inner.item, doc, changes, -2);
                if (next && next.node.name == "OrderedList") $72ce07fd8a103ed3$var$renumberList(next.item, doc, changes);
                return {
                    range: (0, $b2ZzE.EditorSelection).cursor(delTo + insert.length),
                    changes: changes
                };
            } else {
                let insert = $72ce07fd8a103ed3$var$blankLine(context, state, line);
                return {
                    range: (0, $b2ZzE.EditorSelection).cursor(pos + insert.length + 1),
                    changes: {
                        from: line.from,
                        insert: insert + state.lineBreak
                    }
                };
            }
        }
        if (inner.node.name == "Blockquote" && emptyLine && line.from) {
            let prevLine = doc.lineAt(line.from - 1), quoted = />\s*$/.exec(prevLine.text);
            // Two aligned empty quoted lines in a row
            if (quoted && quoted.index == inner.from) {
                let changes = state.changes([
                    {
                        from: prevLine.from + quoted.index,
                        to: prevLine.to
                    },
                    {
                        from: line.from + inner.from,
                        to: line.to
                    }
                ]);
                return {
                    range: range.map(changes),
                    changes: changes
                };
            }
        }
        let changes = [];
        if (inner.node.name == "OrderedList") $72ce07fd8a103ed3$var$renumberList(inner.item, doc, changes);
        let continued = inner.item && inner.item.from < line.from;
        let insert = "";
        // If not dedented
        if (!continued || /^[\s\d.)\-+*>]*/.exec(line.text)[0].length >= inner.to) for(let i = 0, e = context.length - 1; i <= e; i++)insert += i == e && !continued ? context[i].marker(doc, 1) : context[i].blank(i < e ? (0, $b2ZzE.countColumn)(line.text, 4, context[i + 1].from) - insert.length : null);
        let from = pos;
        while(from > line.from && /\s/.test(line.text.charAt(from - line.from - 1)))from--;
        insert = $72ce07fd8a103ed3$var$normalizeIndent(insert, state);
        if ($72ce07fd8a103ed3$var$nonTightList(inner.node, state.doc)) insert = $72ce07fd8a103ed3$var$blankLine(context, state, line) + state.lineBreak + insert;
        changes.push({
            from: from,
            to: pos,
            insert: state.lineBreak + insert
        });
        return {
            range: (0, $b2ZzE.EditorSelection).cursor(from + insert.length + 1),
            changes: changes
        };
    });
    if (dont) return false;
    dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: "input"
    }));
    return true;
};
function $72ce07fd8a103ed3$var$isMark(node) {
    return node.name == "QuoteMark" || node.name == "ListMark";
}
function $72ce07fd8a103ed3$var$nonTightList(node, doc) {
    if (node.name != "OrderedList" && node.name != "BulletList") return false;
    let first = node.firstChild, second = node.getChild("ListItem", "ListItem");
    if (!second) return false;
    let line1 = doc.lineAt(first.to), line2 = doc.lineAt(second.from);
    let empty = /^[\s>]*$/.test(line1.text);
    return line1.number + (empty ? 0 : 1) < line2.number;
}
function $72ce07fd8a103ed3$var$blankLine(context, state, line) {
    let insert = "";
    for(let i = 0, e = context.length - 2; i <= e; i++)insert += context[i].blank(i < e ? (0, $b2ZzE.countColumn)(line.text, 4, Math.min(line.text.length, context[i + 1].from)) - insert.length : null, i < e);
    return $72ce07fd8a103ed3$var$normalizeIndent(insert, state);
}
function $72ce07fd8a103ed3$var$contextNodeForDelete(tree, pos) {
    let node = tree.resolveInner(pos, -1), scan = pos;
    if ($72ce07fd8a103ed3$var$isMark(node)) {
        scan = node.from;
        node = node.parent;
    }
    for(let prev; prev = node.childBefore(scan);){
        if ($72ce07fd8a103ed3$var$isMark(prev)) scan = prev.from;
        else if (prev.name == "OrderedList" || prev.name == "BulletList") {
            node = prev.lastChild;
            scan = node.to;
        } else break;
    }
    return node;
}
/**
This command will, when invoked in a Markdown context with the
cursor directly after list or blockquote markup, delete one level
of markup. When the markup is for a list, it will be replaced by
spaces on the first invocation (a further invocation will delete
the spaces), to make it easy to continue a list.

When not after Markdown block markup, this command will return
false, so it is intended to be bound alongside other deletion
commands, with a higher precedence than the more generic commands.
*/ const $72ce07fd8a103ed3$export$908442d48a0c6dc7 = ({ state: state, dispatch: dispatch })=>{
    let tree = (0, $4lK5a.syntaxTree)(state);
    let dont = null, changes = state.changeByRange((range)=>{
        let pos = range.from, { doc: doc } = state;
        if (range.empty && $72ce07fd8a103ed3$export$4e2e2689db0e8e2b.isActiveAt(state, range.from)) {
            let line = doc.lineAt(pos);
            let context = $72ce07fd8a103ed3$var$getContext($72ce07fd8a103ed3$var$contextNodeForDelete(tree, pos), doc);
            if (context.length) {
                let inner = context[context.length - 1];
                let spaceEnd = inner.to - inner.spaceAfter.length + (inner.spaceAfter ? 1 : 0);
                // Delete extra trailing space after markup
                if (pos - line.from > spaceEnd && !/\S/.test(line.text.slice(spaceEnd, pos - line.from))) return {
                    range: (0, $b2ZzE.EditorSelection).cursor(line.from + spaceEnd),
                    changes: {
                        from: line.from + spaceEnd,
                        to: pos
                    }
                };
                if (pos - line.from == spaceEnd && // Only apply this if we're on the line that has the
                // construct's syntax, or there's only indentation in the
                // target range
                (!inner.item || line.from <= inner.item.from || !/\S/.test(line.text.slice(0, inner.to)))) {
                    let start = line.from + inner.from;
                    // Replace a list item marker with blank space
                    if (inner.item && inner.node.from < inner.item.from && /\S/.test(line.text.slice(inner.from, inner.to))) {
                        let insert = inner.blank((0, $b2ZzE.countColumn)(line.text, 4, inner.to) - (0, $b2ZzE.countColumn)(line.text, 4, inner.from));
                        if (start == line.from) insert = $72ce07fd8a103ed3$var$normalizeIndent(insert, state);
                        return {
                            range: (0, $b2ZzE.EditorSelection).cursor(start + insert.length),
                            changes: {
                                from: start,
                                to: line.from + inner.to,
                                insert: insert
                            }
                        };
                    }
                    // Delete one level of indentation
                    if (start < pos) return {
                        range: (0, $b2ZzE.EditorSelection).cursor(start),
                        changes: {
                            from: start,
                            to: pos
                        }
                    };
                }
            }
        }
        return dont = {
            range: range
        };
    });
    if (dont) return false;
    dispatch(state.update(changes, {
        scrollIntoView: true,
        userEvent: "delete"
    }));
    return true;
};
/**
A small keymap with Markdown-specific bindings. Binds Enter to
[`insertNewlineContinueMarkup`](https://codemirror.net/6/docs/ref/#lang-markdown.insertNewlineContinueMarkup)
and Backspace to
[`deleteMarkupBackward`](https://codemirror.net/6/docs/ref/#lang-markdown.deleteMarkupBackward).
*/ const $72ce07fd8a103ed3$export$8fb29c1cb6de5143 = [
    {
        key: "Enter",
        run: $72ce07fd8a103ed3$export$4869a6855c4f3e2d
    },
    {
        key: "Backspace",
        run: $72ce07fd8a103ed3$export$908442d48a0c6dc7
    }
];
const $72ce07fd8a103ed3$var$htmlNoMatch = /*@__PURE__*/ (0, $iaLx3.html)({
    matchClosingTags: false
});
/**
Markdown language support.
*/ function $72ce07fd8a103ed3$export$199d64cd116a5491(config = {}) {
    let { codeLanguages: codeLanguages, defaultCodeLanguage: defaultCodeLanguage, addKeymap: addKeymap = true, base: { parser: parser } = $72ce07fd8a103ed3$export$2aaf419d99815e51, completeHTMLTags: completeHTMLTags = true, htmlTagLanguage: htmlTagLanguage = $72ce07fd8a103ed3$var$htmlNoMatch } = config;
    if (!(parser instanceof (0, $4PTdL.MarkdownParser))) throw new RangeError("Base parser provided to `markdown` should be a Markdown parser");
    let extensions = config.extensions ? [
        config.extensions
    ] : [];
    let support = [
        htmlTagLanguage.support
    ], defaultCode;
    if (defaultCodeLanguage instanceof (0, $4lK5a.LanguageSupport)) {
        support.push(defaultCodeLanguage.support);
        defaultCode = defaultCodeLanguage.language;
    } else if (defaultCodeLanguage) defaultCode = defaultCodeLanguage;
    let codeParser = codeLanguages || defaultCode ? $72ce07fd8a103ed3$var$getCodeParser(codeLanguages, defaultCode) : undefined;
    extensions.push((0, $4PTdL.parseCode)({
        codeParser: codeParser,
        htmlParser: htmlTagLanguage.language.parser
    }));
    if (addKeymap) support.push((0, $b2ZzE.Prec).high((0, $3e6dc.keymap).of($72ce07fd8a103ed3$export$8fb29c1cb6de5143)));
    let lang = $72ce07fd8a103ed3$var$mkLang(parser.configure(extensions));
    if (completeHTMLTags) support.push(lang.data.of({
        autocomplete: $72ce07fd8a103ed3$var$htmlTagCompletion
    }));
    return new (0, $4lK5a.LanguageSupport)(lang, support);
}
function $72ce07fd8a103ed3$var$htmlTagCompletion(context) {
    let { state: state, pos: pos } = context, m = /<[:\-\.\w\u00b7-\uffff]*$/.exec(state.sliceDoc(pos - 25, pos));
    if (!m) return null;
    let tree = (0, $4lK5a.syntaxTree)(state).resolveInner(pos, -1);
    while(tree && !tree.type.isTop){
        if (tree.name == "CodeBlock" || tree.name == "FencedCode" || tree.name == "ProcessingInstructionBlock" || tree.name == "CommentBlock" || tree.name == "Link" || tree.name == "Image") return null;
        tree = tree.parent;
    }
    return {
        from: pos - m[0].length,
        to: pos,
        options: $72ce07fd8a103ed3$var$htmlTagCompletions(),
        validFor: /^<[:\-\.\w\u00b7-\uffff]*$/
    };
}
let $72ce07fd8a103ed3$var$_tagCompletions = null;
function $72ce07fd8a103ed3$var$htmlTagCompletions() {
    if ($72ce07fd8a103ed3$var$_tagCompletions) return $72ce07fd8a103ed3$var$_tagCompletions;
    let result = (0, $iaLx3.htmlCompletionSource)(new (0, $haZ24.CompletionContext)((0, $b2ZzE.EditorState).create({
        extensions: $72ce07fd8a103ed3$var$htmlNoMatch
    }), 0, true));
    return $72ce07fd8a103ed3$var$_tagCompletions = result ? result.options : [];
}
module.exports["markdownLanguage"] = $72ce07fd8a103ed3$export$4e2e2689db0e8e2b;
module.exports["markdown"] = $72ce07fd8a103ed3$export$199d64cd116a5491;

});

parcelRegister("4PTdL", function(module, exports) {

var $uXNGm = parcelRequire("uXNGm");


var $lhXhg = parcelRequire("lhXhg");

class $3856c2988d28a302$var$CompositeBlock {
    static create(type, value, from, parentHash, end) {
        let hash = parentHash + (parentHash << 8) + type + (value << 4) | 0;
        return new $3856c2988d28a302$var$CompositeBlock(type, value, from, hash, end, [], []);
    }
    addChild(child, pos) {
        if (child.prop((0, $uXNGm.NodeProp).contextHash) != this.hash) child = new (0, $uXNGm.Tree)(child.type, child.children, child.positions, child.length, this.hashProp);
        this.children.push(child);
        this.positions.push(pos);
    }
    toTree(nodeSet, end = this.end) {
        let last = this.children.length - 1;
        if (last >= 0) end = Math.max(end, this.positions[last] + this.children[last].length + this.from);
        return new (0, $uXNGm.Tree)(nodeSet.types[this.type], this.children, this.positions, end - this.from).balance({
            makeTree: (children, positions, length)=>new (0, $uXNGm.Tree)((0, $uXNGm.NodeType).none, children, positions, length, this.hashProp)
        });
    }
    constructor(type, // Used for indentation in list items, markup character in lists
    value, from, hash, end, children, positions){
        this.type = type;
        this.value = value;
        this.from = from;
        this.hash = hash;
        this.end = end;
        this.children = children;
        this.positions = positions;
        this.hashProp = [
            [
                (0, $uXNGm.NodeProp).contextHash,
                hash
            ]
        ];
    }
}
var $3856c2988d28a302$var$Type;
(function(Type) {
    Type[Type["Document"] = 1] = "Document";
    Type[Type["CodeBlock"] = 2] = "CodeBlock";
    Type[Type["FencedCode"] = 3] = "FencedCode";
    Type[Type["Blockquote"] = 4] = "Blockquote";
    Type[Type["HorizontalRule"] = 5] = "HorizontalRule";
    Type[Type["BulletList"] = 6] = "BulletList";
    Type[Type["OrderedList"] = 7] = "OrderedList";
    Type[Type["ListItem"] = 8] = "ListItem";
    Type[Type["ATXHeading1"] = 9] = "ATXHeading1";
    Type[Type["ATXHeading2"] = 10] = "ATXHeading2";
    Type[Type["ATXHeading3"] = 11] = "ATXHeading3";
    Type[Type["ATXHeading4"] = 12] = "ATXHeading4";
    Type[Type["ATXHeading5"] = 13] = "ATXHeading5";
    Type[Type["ATXHeading6"] = 14] = "ATXHeading6";
    Type[Type["SetextHeading1"] = 15] = "SetextHeading1";
    Type[Type["SetextHeading2"] = 16] = "SetextHeading2";
    Type[Type["HTMLBlock"] = 17] = "HTMLBlock";
    Type[Type["LinkReference"] = 18] = "LinkReference";
    Type[Type["Paragraph"] = 19] = "Paragraph";
    Type[Type["CommentBlock"] = 20] = "CommentBlock";
    Type[Type["ProcessingInstructionBlock"] = 21] = "ProcessingInstructionBlock";
    // Inline
    Type[Type["Escape"] = 22] = "Escape";
    Type[Type["Entity"] = 23] = "Entity";
    Type[Type["HardBreak"] = 24] = "HardBreak";
    Type[Type["Emphasis"] = 25] = "Emphasis";
    Type[Type["StrongEmphasis"] = 26] = "StrongEmphasis";
    Type[Type["Link"] = 27] = "Link";
    Type[Type["Image"] = 28] = "Image";
    Type[Type["InlineCode"] = 29] = "InlineCode";
    Type[Type["HTMLTag"] = 30] = "HTMLTag";
    Type[Type["Comment"] = 31] = "Comment";
    Type[Type["ProcessingInstruction"] = 32] = "ProcessingInstruction";
    Type[Type["Autolink"] = 33] = "Autolink";
    // Smaller tokens
    Type[Type["HeaderMark"] = 34] = "HeaderMark";
    Type[Type["QuoteMark"] = 35] = "QuoteMark";
    Type[Type["ListMark"] = 36] = "ListMark";
    Type[Type["LinkMark"] = 37] = "LinkMark";
    Type[Type["EmphasisMark"] = 38] = "EmphasisMark";
    Type[Type["CodeMark"] = 39] = "CodeMark";
    Type[Type["CodeText"] = 40] = "CodeText";
    Type[Type["CodeInfo"] = 41] = "CodeInfo";
    Type[Type["LinkTitle"] = 42] = "LinkTitle";
    Type[Type["LinkLabel"] = 43] = "LinkLabel";
    Type[Type["URL"] = 44] = "URL";
})($3856c2988d28a302$var$Type || ($3856c2988d28a302$var$Type = {}));
/// Data structure used to accumulate a block's content during [leaf
/// block parsing](#BlockParser.leaf).
class $3856c2988d28a302$export$37a69f74d9ababf6 {
    /// @internal
    constructor(/// The start position of the block.
    start, /// The block's text content.
    content){
        this.start = start;
        this.content = content;
        /// @internal
        this.marks = [];
        /// The block parsers active for this block.
        this.parsers = [];
    }
}
/// Data structure used during block-level per-line parsing.
class $3856c2988d28a302$export$17d680238e50603e {
    /// @internal
    forward() {
        if (this.basePos > this.pos) this.forwardInner();
    }
    /// @internal
    forwardInner() {
        let newPos = this.skipSpace(this.basePos);
        this.indent = this.countIndent(newPos, this.pos, this.indent);
        this.pos = newPos;
        this.next = newPos == this.text.length ? -1 : this.text.charCodeAt(newPos);
    }
    /// Skip whitespace after the given position, return the position of
    /// the next non-space character or the end of the line if there's
    /// only space after `from`.
    skipSpace(from) {
        return $3856c2988d28a302$var$skipSpace(this.text, from);
    }
    /// @internal
    reset(text) {
        this.text = text;
        this.baseIndent = this.basePos = this.pos = this.indent = 0;
        this.forwardInner();
        this.depth = 1;
        while(this.markers.length)this.markers.pop();
    }
    /// Move the line's base position forward to the given position.
    /// This should only be called by composite [block
    /// parsers](#BlockParser.parse) or [markup skipping
    /// functions](#NodeSpec.composite).
    moveBase(to) {
        this.basePos = to;
        this.baseIndent = this.countIndent(to, this.pos, this.indent);
    }
    /// Move the line's base position forward to the given _column_.
    moveBaseColumn(indent) {
        this.baseIndent = indent;
        this.basePos = this.findColumn(indent);
    }
    /// Store a composite-block-level marker. Should be called from
    /// [markup skipping functions](#NodeSpec.composite) when they
    /// consume any non-whitespace characters.
    addMarker(elt) {
        this.markers.push(elt);
    }
    /// Find the column position at `to`, optionally starting at a given
    /// position and column.
    countIndent(to, from = 0, indent = 0) {
        for(let i = from; i < to; i++)indent += this.text.charCodeAt(i) == 9 ? 4 - indent % 4 : 1;
        return indent;
    }
    /// Find the position corresponding to the given column.
    findColumn(goal) {
        let i = 0;
        for(let indent = 0; i < this.text.length && indent < goal; i++)indent += this.text.charCodeAt(i) == 9 ? 4 - indent % 4 : 1;
        return i;
    }
    /// @internal
    scrub() {
        if (!this.baseIndent) return this.text;
        let result = "";
        for(let i = 0; i < this.basePos; i++)result += " ";
        return result + this.text.slice(this.basePos);
    }
    constructor(){
        /// The line's full text.
        this.text = "";
        /// The base indent provided by the composite contexts (that have
        /// been handled so far).
        this.baseIndent = 0;
        /// The string position corresponding to the base indent.
        this.basePos = 0;
        /// The number of contexts handled @internal
        this.depth = 0;
        /// Any markers (i.e. block quote markers) parsed for the contexts. @internal
        this.markers = [];
        /// The position of the next non-whitespace character beyond any
        /// list, blockquote, or other composite block markers.
        this.pos = 0;
        /// The column of the next non-whitespace character.
        this.indent = 0;
        /// The character code of the character after `pos`.
        this.next = -1;
    }
}
function $3856c2988d28a302$var$skipForList(bl, cx, line) {
    if (line.pos == line.text.length || bl != cx.block && line.indent >= cx.stack[line.depth + 1].value + line.baseIndent) return true;
    if (line.indent >= line.baseIndent + 4) return false;
    let size = (bl.type == $3856c2988d28a302$var$Type.OrderedList ? $3856c2988d28a302$var$isOrderedList : $3856c2988d28a302$var$isBulletList)(line, cx, false);
    return size > 0 && (bl.type != $3856c2988d28a302$var$Type.BulletList || $3856c2988d28a302$var$isHorizontalRule(line, cx, false) < 0) && line.text.charCodeAt(line.pos + size - 1) == bl.value;
}
const $3856c2988d28a302$var$DefaultSkipMarkup = {
    [$3856c2988d28a302$var$Type.Blockquote] (bl, cx, line) {
        if (line.next != 62 /* '>' */ ) return false;
        line.markers.push($3856c2988d28a302$var$elt($3856c2988d28a302$var$Type.QuoteMark, cx.lineStart + line.pos, cx.lineStart + line.pos + 1));
        line.moveBase(line.pos + ($3856c2988d28a302$var$space(line.text.charCodeAt(line.pos + 1)) ? 2 : 1));
        bl.end = cx.lineStart + line.text.length;
        return true;
    },
    [$3856c2988d28a302$var$Type.ListItem] (bl, _cx, line) {
        if (line.indent < line.baseIndent + bl.value && line.next > -1) return false;
        line.moveBaseColumn(line.baseIndent + bl.value);
        return true;
    },
    [$3856c2988d28a302$var$Type.OrderedList]: $3856c2988d28a302$var$skipForList,
    [$3856c2988d28a302$var$Type.BulletList]: $3856c2988d28a302$var$skipForList,
    [$3856c2988d28a302$var$Type.Document] () {
        return true;
    }
};
function $3856c2988d28a302$var$space(ch) {
    return ch == 32 || ch == 9 || ch == 10 || ch == 13;
}
function $3856c2988d28a302$var$skipSpace(line, i = 0) {
    while(i < line.length && $3856c2988d28a302$var$space(line.charCodeAt(i)))i++;
    return i;
}
function $3856c2988d28a302$var$skipSpaceBack(line, i, to) {
    while(i > to && $3856c2988d28a302$var$space(line.charCodeAt(i - 1)))i--;
    return i;
}
function $3856c2988d28a302$var$isFencedCode(line) {
    if (line.next != 96 && line.next != 126 /* '`~' */ ) return -1;
    let pos = line.pos + 1;
    while(pos < line.text.length && line.text.charCodeAt(pos) == line.next)pos++;
    if (pos < line.pos + 3) return -1;
    if (line.next == 96) {
        for(let i = pos; i < line.text.length; i++)if (line.text.charCodeAt(i) == 96) return -1;
    }
    return pos;
}
function $3856c2988d28a302$var$isBlockquote(line) {
    return line.next != 62 /* '>' */  ? -1 : line.text.charCodeAt(line.pos + 1) == 32 ? 2 : 1;
}
function $3856c2988d28a302$var$isHorizontalRule(line, cx, breaking) {
    if (line.next != 42 && line.next != 45 && line.next != 95 /* '_-*' */ ) return -1;
    let count = 1;
    for(let pos = line.pos + 1; pos < line.text.length; pos++){
        let ch = line.text.charCodeAt(pos);
        if (ch == line.next) count++;
        else if (!$3856c2988d28a302$var$space(ch)) return -1;
    }
    // Setext headers take precedence
    if (breaking && line.next == 45 && $3856c2988d28a302$var$isSetextUnderline(line) > -1 && line.depth == cx.stack.length && cx.parser.leafBlockParsers.indexOf($3856c2988d28a302$var$DefaultLeafBlocks.SetextHeading) > -1) return -1;
    return count < 3 ? -1 : 1;
}
function $3856c2988d28a302$var$inList(cx, type) {
    for(let i = cx.stack.length - 1; i >= 0; i--)if (cx.stack[i].type == type) return true;
    return false;
}
function $3856c2988d28a302$var$isBulletList(line, cx, breaking) {
    return (line.next == 45 || line.next == 43 || line.next == 42 /* '-+*' */ ) && (line.pos == line.text.length - 1 || $3856c2988d28a302$var$space(line.text.charCodeAt(line.pos + 1))) && (!breaking || $3856c2988d28a302$var$inList(cx, $3856c2988d28a302$var$Type.BulletList) || line.skipSpace(line.pos + 2) < line.text.length) ? 1 : -1;
}
function $3856c2988d28a302$var$isOrderedList(line, cx, breaking) {
    let pos = line.pos, next = line.next;
    for(;;){
        if (next >= 48 && next <= 57 /* '0-9' */ ) pos++;
        else break;
        if (pos == line.text.length) return -1;
        next = line.text.charCodeAt(pos);
    }
    if (pos == line.pos || pos > line.pos + 9 || next != 46 && next != 41 /* '.)' */  || pos < line.text.length - 1 && !$3856c2988d28a302$var$space(line.text.charCodeAt(pos + 1)) || breaking && !$3856c2988d28a302$var$inList(cx, $3856c2988d28a302$var$Type.OrderedList) && (line.skipSpace(pos + 1) == line.text.length || pos > line.pos + 1 || line.next != 49 /* '1' */ )) return -1;
    return pos + 1 - line.pos;
}
function $3856c2988d28a302$var$isAtxHeading(line) {
    if (line.next != 35 /* '#' */ ) return -1;
    let pos = line.pos + 1;
    while(pos < line.text.length && line.text.charCodeAt(pos) == 35)pos++;
    if (pos < line.text.length && line.text.charCodeAt(pos) != 32) return -1;
    let size = pos - line.pos;
    return size > 6 ? -1 : size;
}
function $3856c2988d28a302$var$isSetextUnderline(line) {
    if (line.next != 45 && line.next != 61 /* '-=' */  || line.indent >= line.baseIndent + 4) return -1;
    let pos = line.pos + 1;
    while(pos < line.text.length && line.text.charCodeAt(pos) == line.next)pos++;
    let end = pos;
    while(pos < line.text.length && $3856c2988d28a302$var$space(line.text.charCodeAt(pos)))pos++;
    return pos == line.text.length ? end : -1;
}
const $3856c2988d28a302$var$EmptyLine = /^[ \t]*$/, $3856c2988d28a302$var$CommentEnd = /-->/, $3856c2988d28a302$var$ProcessingEnd = /\?>/;
const $3856c2988d28a302$var$HTMLBlockStyle = [
    [
        /^<(?:script|pre|style)(?:\s|>|$)/i,
        /<\/(?:script|pre|style)>/i
    ],
    [
        /^\s*<!--/,
        $3856c2988d28a302$var$CommentEnd
    ],
    [
        /^\s*<\?/,
        $3856c2988d28a302$var$ProcessingEnd
    ],
    [
        /^\s*<![A-Z]/,
        />/
    ],
    [
        /^\s*<!\[CDATA\[/,
        /\]\]>/
    ],
    [
        /^\s*<\/?(?:address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h1|h2|h3|h4|h5|h6|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul)(?:\s|\/?>|$)/i,
        $3856c2988d28a302$var$EmptyLine
    ],
    [
        /^\s*(?:<\/[a-z][\w-]*\s*>|<[a-z][\w-]*(\s+[a-z:_][\w-.]*(?:\s*=\s*(?:[^\s"'=<>`]+|'[^']*'|"[^"]*"))?)*\s*>)\s*$/i,
        $3856c2988d28a302$var$EmptyLine
    ]
];
function $3856c2988d28a302$var$isHTMLBlock(line, _cx, breaking) {
    if (line.next != 60 /* '<' */ ) return -1;
    let rest = line.text.slice(line.pos);
    for(let i = 0, e = $3856c2988d28a302$var$HTMLBlockStyle.length - (breaking ? 1 : 0); i < e; i++)if ($3856c2988d28a302$var$HTMLBlockStyle[i][0].test(rest)) return i;
    return -1;
}
function $3856c2988d28a302$var$getListIndent(line, pos) {
    let indentAfter = line.countIndent(pos, line.pos, line.indent);
    let indented = line.countIndent(line.skipSpace(pos), pos, indentAfter);
    return indented >= indentAfter + 5 ? indentAfter + 1 : indented;
}
function $3856c2988d28a302$var$addCodeText(marks, from, to) {
    let last = marks.length - 1;
    if (last >= 0 && marks[last].to == from && marks[last].type == $3856c2988d28a302$var$Type.CodeText) marks[last].to = to;
    else marks.push($3856c2988d28a302$var$elt($3856c2988d28a302$var$Type.CodeText, from, to));
}
// Rules for parsing blocks. A return value of false means the rule
// doesn't apply here, true means it does. When true is returned and
// `p.line` has been updated, the rule is assumed to have consumed a
// leaf block. Otherwise, it is assumed to have opened a context.
const $3856c2988d28a302$var$DefaultBlockParsers = {
    LinkReference: undefined,
    IndentedCode (cx, line) {
        let base = line.baseIndent + 4;
        if (line.indent < base) return false;
        let start = line.findColumn(base);
        let from = cx.lineStart + start, to = cx.lineStart + line.text.length;
        let marks = [], pendingMarks = [];
        $3856c2988d28a302$var$addCodeText(marks, from, to);
        while(cx.nextLine() && line.depth >= cx.stack.length){
            if (line.pos == line.text.length) {
                $3856c2988d28a302$var$addCodeText(pendingMarks, cx.lineStart - 1, cx.lineStart);
                for (let m of line.markers)pendingMarks.push(m);
            } else if (line.indent < base) break;
            else {
                if (pendingMarks.length) {
                    for (let m of pendingMarks)if (m.type == $3856c2988d28a302$var$Type.CodeText) $3856c2988d28a302$var$addCodeText(marks, m.from, m.to);
                    else marks.push(m);
                    pendingMarks = [];
                }
                $3856c2988d28a302$var$addCodeText(marks, cx.lineStart - 1, cx.lineStart);
                for (let m of line.markers)marks.push(m);
                to = cx.lineStart + line.text.length;
                let codeStart = cx.lineStart + line.findColumn(line.baseIndent + 4);
                if (codeStart < to) $3856c2988d28a302$var$addCodeText(marks, codeStart, to);
            }
        }
        if (pendingMarks.length) {
            pendingMarks = pendingMarks.filter((m)=>m.type != $3856c2988d28a302$var$Type.CodeText);
            if (pendingMarks.length) line.markers = pendingMarks.concat(line.markers);
        }
        cx.addNode(cx.buffer.writeElements(marks, -from).finish($3856c2988d28a302$var$Type.CodeBlock, to - from), from);
        return true;
    },
    FencedCode (cx, line) {
        let fenceEnd = $3856c2988d28a302$var$isFencedCode(line);
        if (fenceEnd < 0) return false;
        let from = cx.lineStart + line.pos, ch = line.next, len = fenceEnd - line.pos;
        let infoFrom = line.skipSpace(fenceEnd), infoTo = $3856c2988d28a302$var$skipSpaceBack(line.text, line.text.length, infoFrom);
        let marks = [
            $3856c2988d28a302$var$elt($3856c2988d28a302$var$Type.CodeMark, from, from + len)
        ];
        if (infoFrom < infoTo) marks.push($3856c2988d28a302$var$elt($3856c2988d28a302$var$Type.CodeInfo, cx.lineStart + infoFrom, cx.lineStart + infoTo));
        for(let first = true; cx.nextLine() && line.depth >= cx.stack.length; first = false){
            let i = line.pos;
            if (line.indent - line.baseIndent < 4) while(i < line.text.length && line.text.charCodeAt(i) == ch)i++;
            if (i - line.pos >= len && line.skipSpace(i) == line.text.length) {
                for (let m of line.markers)marks.push(m);
                marks.push($3856c2988d28a302$var$elt($3856c2988d28a302$var$Type.CodeMark, cx.lineStart + line.pos, cx.lineStart + i));
                cx.nextLine();
                break;
            } else {
                if (!first) $3856c2988d28a302$var$addCodeText(marks, cx.lineStart - 1, cx.lineStart);
                for (let m of line.markers)marks.push(m);
                let textStart = cx.lineStart + line.basePos, textEnd = cx.lineStart + line.text.length;
                if (textStart < textEnd) $3856c2988d28a302$var$addCodeText(marks, textStart, textEnd);
            }
        }
        cx.addNode(cx.buffer.writeElements(marks, -from).finish($3856c2988d28a302$var$Type.FencedCode, cx.prevLineEnd() - from), from);
        return true;
    },
    Blockquote (cx, line) {
        let size = $3856c2988d28a302$var$isBlockquote(line);
        if (size < 0) return false;
        cx.startContext($3856c2988d28a302$var$Type.Blockquote, line.pos);
        cx.addNode($3856c2988d28a302$var$Type.QuoteMark, cx.lineStart + line.pos, cx.lineStart + line.pos + 1);
        line.moveBase(line.pos + size);
        return null;
    },
    HorizontalRule (cx, line) {
        if ($3856c2988d28a302$var$isHorizontalRule(line, cx, false) < 0) return false;
        let from = cx.lineStart + line.pos;
        cx.nextLine();
        cx.addNode($3856c2988d28a302$var$Type.HorizontalRule, from);
        return true;
    },
    BulletList (cx, line) {
        let size = $3856c2988d28a302$var$isBulletList(line, cx, false);
        if (size < 0) return false;
        if (cx.block.type != $3856c2988d28a302$var$Type.BulletList) cx.startContext($3856c2988d28a302$var$Type.BulletList, line.basePos, line.next);
        let newBase = $3856c2988d28a302$var$getListIndent(line, line.pos + 1);
        cx.startContext($3856c2988d28a302$var$Type.ListItem, line.basePos, newBase - line.baseIndent);
        cx.addNode($3856c2988d28a302$var$Type.ListMark, cx.lineStart + line.pos, cx.lineStart + line.pos + size);
        line.moveBaseColumn(newBase);
        return null;
    },
    OrderedList (cx, line) {
        let size = $3856c2988d28a302$var$isOrderedList(line, cx, false);
        if (size < 0) return false;
        if (cx.block.type != $3856c2988d28a302$var$Type.OrderedList) cx.startContext($3856c2988d28a302$var$Type.OrderedList, line.basePos, line.text.charCodeAt(line.pos + size - 1));
        let newBase = $3856c2988d28a302$var$getListIndent(line, line.pos + size);
        cx.startContext($3856c2988d28a302$var$Type.ListItem, line.basePos, newBase - line.baseIndent);
        cx.addNode($3856c2988d28a302$var$Type.ListMark, cx.lineStart + line.pos, cx.lineStart + line.pos + size);
        line.moveBaseColumn(newBase);
        return null;
    },
    ATXHeading (cx, line) {
        let size = $3856c2988d28a302$var$isAtxHeading(line);
        if (size < 0) return false;
        let off = line.pos, from = cx.lineStart + off;
        let endOfSpace = $3856c2988d28a302$var$skipSpaceBack(line.text, line.text.length, off), after = endOfSpace;
        while(after > off && line.text.charCodeAt(after - 1) == line.next)after--;
        if (after == endOfSpace || after == off || !$3856c2988d28a302$var$space(line.text.charCodeAt(after - 1))) after = line.text.length;
        let buf = cx.buffer.write($3856c2988d28a302$var$Type.HeaderMark, 0, size).writeElements(cx.parser.parseInline(line.text.slice(off + size + 1, after), from + size + 1), -from);
        if (after < line.text.length) buf.write($3856c2988d28a302$var$Type.HeaderMark, after - off, endOfSpace - off);
        let node = buf.finish($3856c2988d28a302$var$Type.ATXHeading1 - 1 + size, line.text.length - off);
        cx.nextLine();
        cx.addNode(node, from);
        return true;
    },
    HTMLBlock (cx, line) {
        let type = $3856c2988d28a302$var$isHTMLBlock(line, cx, false);
        if (type < 0) return false;
        let from = cx.lineStart + line.pos, end = $3856c2988d28a302$var$HTMLBlockStyle[type][1];
        let marks = [], trailing = end != $3856c2988d28a302$var$EmptyLine;
        while(!end.test(line.text) && cx.nextLine()){
            if (line.depth < cx.stack.length) {
                trailing = false;
                break;
            }
            for (let m of line.markers)marks.push(m);
        }
        if (trailing) cx.nextLine();
        let nodeType = end == $3856c2988d28a302$var$CommentEnd ? $3856c2988d28a302$var$Type.CommentBlock : end == $3856c2988d28a302$var$ProcessingEnd ? $3856c2988d28a302$var$Type.ProcessingInstructionBlock : $3856c2988d28a302$var$Type.HTMLBlock;
        let to = cx.prevLineEnd();
        cx.addNode(cx.buffer.writeElements(marks, -from).finish(nodeType, to - from), from);
        return true;
    },
    SetextHeading: undefined // Specifies relative precedence for block-continue function
};
// This implements a state machine that incrementally parses link references. At each
// next line, it looks ahead to see if the line continues the reference or not. If it
// doesn't and a valid link is available ending before that line, it finishes that.
// Similarly, on `finish` (when the leaf is terminated by external circumstances), it
// creates a link reference if there's a valid reference up to the current point.
class $3856c2988d28a302$var$LinkReferenceParser {
    nextLine(cx, line, leaf) {
        if (this.stage == -1 /* RefStage.Failed */ ) return false;
        let content = leaf.content + "\n" + line.scrub();
        let finish = this.advance(content);
        if (finish > -1 && finish < content.length) return this.complete(cx, leaf, finish);
        return false;
    }
    finish(cx, leaf) {
        if ((this.stage == 2 /* RefStage.Link */  || this.stage == 3 /* RefStage.Title */ ) && $3856c2988d28a302$var$skipSpace(leaf.content, this.pos) == leaf.content.length) return this.complete(cx, leaf, leaf.content.length);
        return false;
    }
    complete(cx, leaf, len) {
        cx.addLeafElement(leaf, $3856c2988d28a302$var$elt($3856c2988d28a302$var$Type.LinkReference, this.start, this.start + len, this.elts));
        return true;
    }
    nextStage(elt) {
        if (elt) {
            this.pos = elt.to - this.start;
            this.elts.push(elt);
            this.stage++;
            return true;
        }
        if (elt === false) this.stage = -1 /* RefStage.Failed */ ;
        return false;
    }
    advance(content) {
        for(;;){
            if (this.stage == -1 /* RefStage.Failed */ ) return -1;
            else if (this.stage == 0 /* RefStage.Start */ ) {
                if (!this.nextStage($3856c2988d28a302$var$parseLinkLabel(content, this.pos, this.start, true))) return -1;
                if (content.charCodeAt(this.pos) != 58 /* ':' */ ) return this.stage = -1 /* RefStage.Failed */ ;
                this.elts.push($3856c2988d28a302$var$elt($3856c2988d28a302$var$Type.LinkMark, this.pos + this.start, this.pos + this.start + 1));
                this.pos++;
            } else if (this.stage == 1 /* RefStage.Label */ ) {
                if (!this.nextStage($3856c2988d28a302$var$parseURL(content, $3856c2988d28a302$var$skipSpace(content, this.pos), this.start))) return -1;
            } else if (this.stage == 2 /* RefStage.Link */ ) {
                let skip = $3856c2988d28a302$var$skipSpace(content, this.pos), end = 0;
                if (skip > this.pos) {
                    let title = $3856c2988d28a302$var$parseLinkTitle(content, skip, this.start);
                    if (title) {
                        let titleEnd = $3856c2988d28a302$var$lineEnd(content, title.to - this.start);
                        if (titleEnd > 0) {
                            this.nextStage(title);
                            end = titleEnd;
                        }
                    }
                }
                if (!end) end = $3856c2988d28a302$var$lineEnd(content, this.pos);
                return end > 0 && end < content.length ? end : -1;
            } else return $3856c2988d28a302$var$lineEnd(content, this.pos);
        }
    }
    constructor(leaf){
        this.stage = 0 /* RefStage.Start */ ;
        this.elts = [];
        this.pos = 0;
        this.start = leaf.start;
        this.advance(leaf.content);
    }
}
function $3856c2988d28a302$var$lineEnd(text, pos) {
    for(; pos < text.length; pos++){
        let next = text.charCodeAt(pos);
        if (next == 10) break;
        if (!$3856c2988d28a302$var$space(next)) return -1;
    }
    return pos;
}
class $3856c2988d28a302$var$SetextHeadingParser {
    nextLine(cx, line, leaf) {
        let underline = line.depth < cx.stack.length ? -1 : $3856c2988d28a302$var$isSetextUnderline(line);
        let next = line.next;
        if (underline < 0) return false;
        let underlineMark = $3856c2988d28a302$var$elt($3856c2988d28a302$var$Type.HeaderMark, cx.lineStart + line.pos, cx.lineStart + underline);
        cx.nextLine();
        cx.addLeafElement(leaf, $3856c2988d28a302$var$elt(next == 61 ? $3856c2988d28a302$var$Type.SetextHeading1 : $3856c2988d28a302$var$Type.SetextHeading2, leaf.start, cx.prevLineEnd(), [
            ...cx.parser.parseInline(leaf.content, leaf.start),
            underlineMark
        ]));
        return true;
    }
    finish() {
        return false;
    }
}
const $3856c2988d28a302$var$DefaultLeafBlocks = {
    LinkReference (_, leaf) {
        return leaf.content.charCodeAt(0) == 91 /* '[' */  ? new $3856c2988d28a302$var$LinkReferenceParser(leaf) : null;
    },
    SetextHeading () {
        return new $3856c2988d28a302$var$SetextHeadingParser;
    }
};
const $3856c2988d28a302$var$DefaultEndLeaf = [
    (_, line)=>$3856c2988d28a302$var$isAtxHeading(line) >= 0,
    (_, line)=>$3856c2988d28a302$var$isFencedCode(line) >= 0,
    (_, line)=>$3856c2988d28a302$var$isBlockquote(line) >= 0,
    (p, line)=>$3856c2988d28a302$var$isBulletList(line, p, true) >= 0,
    (p, line)=>$3856c2988d28a302$var$isOrderedList(line, p, true) >= 0,
    (p, line)=>$3856c2988d28a302$var$isHorizontalRule(line, p, true) >= 0,
    (p, line)=>$3856c2988d28a302$var$isHTMLBlock(line, p, true) >= 0
];
const $3856c2988d28a302$var$scanLineResult = {
    text: "",
    end: 0
};
/// Block-level parsing functions get access to this context object.
class $3856c2988d28a302$export$b3bf2b2b75d6537d {
    get parsedPos() {
        return this.absoluteLineStart;
    }
    advance() {
        if (this.stoppedAt != null && this.absoluteLineStart > this.stoppedAt) return this.finish();
        let { line: line } = this;
        for(;;){
            for(let markI = 0;;){
                let next = line.depth < this.stack.length ? this.stack[this.stack.length - 1] : null;
                while(markI < line.markers.length && (!next || line.markers[markI].from < next.end)){
                    let mark = line.markers[markI++];
                    this.addNode(mark.type, mark.from, mark.to);
                }
                if (!next) break;
                this.finishContext();
            }
            if (line.pos < line.text.length) break;
            // Empty line
            if (!this.nextLine()) return this.finish();
        }
        if (this.fragments && this.reuseFragment(line.basePos)) return null;
        start: for(;;){
            for (let type of this.parser.blockParsers)if (type) {
                let result = type(this, line);
                if (result != false) {
                    if (result == true) return null;
                    line.forward();
                    continue start;
                }
            }
            break;
        }
        let leaf = new $3856c2988d28a302$export$37a69f74d9ababf6(this.lineStart + line.pos, line.text.slice(line.pos));
        for (let parse of this.parser.leafBlockParsers)if (parse) {
            let parser = parse(this, leaf);
            if (parser) leaf.parsers.push(parser);
        }
        lines: while(this.nextLine()){
            if (line.pos == line.text.length) break;
            if (line.indent < line.baseIndent + 4) {
                for (let stop of this.parser.endLeafBlock)if (stop(this, line, leaf)) break lines;
            }
            for (let parser of leaf.parsers)if (parser.nextLine(this, line, leaf)) return null;
            leaf.content += "\n" + line.scrub();
            for (let m of line.markers)leaf.marks.push(m);
        }
        this.finishLeaf(leaf);
        return null;
    }
    stopAt(pos) {
        if (this.stoppedAt != null && this.stoppedAt < pos) throw new RangeError("Can't move stoppedAt forward");
        this.stoppedAt = pos;
    }
    reuseFragment(start) {
        if (!this.fragments.moveTo(this.absoluteLineStart + start, this.absoluteLineStart) || !this.fragments.matches(this.block.hash)) return false;
        let taken = this.fragments.takeNodes(this);
        if (!taken) return false;
        this.absoluteLineStart += taken;
        this.lineStart = $3856c2988d28a302$var$toRelative(this.absoluteLineStart, this.ranges);
        this.moveRangeI();
        if (this.absoluteLineStart < this.to) {
            this.lineStart++;
            this.absoluteLineStart++;
            this.readLine();
        } else {
            this.atEnd = true;
            this.readLine();
        }
        return true;
    }
    /// The number of parent blocks surrounding the current block.
    get depth() {
        return this.stack.length;
    }
    /// Get the type of the parent block at the given depth. When no
    /// depth is passed, return the type of the innermost parent.
    parentType(depth = this.depth - 1) {
        return this.parser.nodeSet.types[this.stack[depth].type];
    }
    /// Move to the next input line. This should only be called by
    /// (non-composite) [block parsers](#BlockParser.parse) that consume
    /// the line directly, or leaf block parser
    /// [`nextLine`](#LeafBlockParser.nextLine) methods when they
    /// consume the current line (and return true).
    nextLine() {
        this.lineStart += this.line.text.length;
        if (this.absoluteLineEnd >= this.to) {
            this.absoluteLineStart = this.absoluteLineEnd;
            this.atEnd = true;
            this.readLine();
            return false;
        } else {
            this.lineStart++;
            this.absoluteLineStart = this.absoluteLineEnd + 1;
            this.moveRangeI();
            this.readLine();
            return true;
        }
    }
    /// Retrieve the text of the line after the current one, without
    /// actually moving the context's current line forward.
    peekLine() {
        return this.scanLine(this.absoluteLineEnd + 1).text;
    }
    moveRangeI() {
        while(this.rangeI < this.ranges.length - 1 && this.absoluteLineStart >= this.ranges[this.rangeI].to){
            this.rangeI++;
            this.absoluteLineStart = Math.max(this.absoluteLineStart, this.ranges[this.rangeI].from);
        }
    }
    /// @internal
    /// Collect the text for the next line.
    scanLine(start) {
        let r = $3856c2988d28a302$var$scanLineResult;
        r.end = start;
        if (start >= this.to) r.text = "";
        else {
            r.text = this.lineChunkAt(start);
            r.end += r.text.length;
            if (this.ranges.length > 1) {
                let textOffset = this.absoluteLineStart, rangeI = this.rangeI;
                while(this.ranges[rangeI].to < r.end){
                    rangeI++;
                    let nextFrom = this.ranges[rangeI].from;
                    let after = this.lineChunkAt(nextFrom);
                    r.end = nextFrom + after.length;
                    r.text = r.text.slice(0, this.ranges[rangeI - 1].to - textOffset) + after;
                    textOffset = r.end - r.text.length;
                }
            }
        }
        return r;
    }
    /// @internal
    /// Populate this.line with the content of the next line. Skip
    /// leading characters covered by composite blocks.
    readLine() {
        let { line: line } = this, { text: text, end: end } = this.scanLine(this.absoluteLineStart);
        this.absoluteLineEnd = end;
        line.reset(text);
        for(; line.depth < this.stack.length; line.depth++){
            let cx = this.stack[line.depth], handler = this.parser.skipContextMarkup[cx.type];
            if (!handler) throw new Error("Unhandled block context " + $3856c2988d28a302$var$Type[cx.type]);
            if (!handler(cx, this, line)) break;
            line.forward();
        }
    }
    lineChunkAt(pos) {
        let next = this.input.chunk(pos), text;
        if (!this.input.lineChunks) {
            let eol = next.indexOf("\n");
            text = eol < 0 ? next : next.slice(0, eol);
        } else text = next == "\n" ? "" : next;
        return pos + text.length > this.to ? text.slice(0, this.to - pos) : text;
    }
    /// The end position of the previous line.
    prevLineEnd() {
        return this.atEnd ? this.lineStart : this.lineStart - 1;
    }
    /// @internal
    startContext(type, start, value = 0) {
        this.block = $3856c2988d28a302$var$CompositeBlock.create(type, value, this.lineStart + start, this.block.hash, this.lineStart + this.line.text.length);
        this.stack.push(this.block);
    }
    /// Start a composite block. Should only be called from [block
    /// parser functions](#BlockParser.parse) that return null.
    startComposite(type, start, value = 0) {
        this.startContext(this.parser.getNodeType(type), start, value);
    }
    /// @internal
    addNode(block, from, to) {
        if (typeof block == "number") block = new (0, $uXNGm.Tree)(this.parser.nodeSet.types[block], $3856c2988d28a302$var$none, $3856c2988d28a302$var$none, (to !== null && to !== void 0 ? to : this.prevLineEnd()) - from);
        this.block.addChild(block, from - this.block.from);
    }
    /// Add a block element. Can be called by [block
    /// parsers](#BlockParser.parse).
    addElement(elt) {
        this.block.addChild(elt.toTree(this.parser.nodeSet), elt.from - this.block.from);
    }
    /// Add a block element from a [leaf parser](#LeafBlockParser). This
    /// makes sure any extra composite block markup (such as blockquote
    /// markers) inside the block are also added to the syntax tree.
    addLeafElement(leaf, elt) {
        this.addNode(this.buffer.writeElements($3856c2988d28a302$var$injectMarks(elt.children, leaf.marks), -elt.from).finish(elt.type, elt.to - elt.from), elt.from);
    }
    /// @internal
    finishContext() {
        let cx = this.stack.pop();
        let top = this.stack[this.stack.length - 1];
        top.addChild(cx.toTree(this.parser.nodeSet), cx.from - top.from);
        this.block = top;
    }
    finish() {
        while(this.stack.length > 1)this.finishContext();
        return this.addGaps(this.block.toTree(this.parser.nodeSet, this.lineStart));
    }
    addGaps(tree) {
        return this.ranges.length > 1 ? $3856c2988d28a302$var$injectGaps(this.ranges, 0, tree.topNode, this.ranges[0].from, this.reusePlaceholders) : tree;
    }
    /// @internal
    finishLeaf(leaf) {
        for (let parser of leaf.parsers)if (parser.finish(this, leaf)) return;
        let inline = $3856c2988d28a302$var$injectMarks(this.parser.parseInline(leaf.content, leaf.start), leaf.marks);
        this.addNode(this.buffer.writeElements(inline, -leaf.start).finish($3856c2988d28a302$var$Type.Paragraph, leaf.content.length), leaf.start);
    }
    elt(type, from, to, children) {
        if (typeof type == "string") return $3856c2988d28a302$var$elt(this.parser.getNodeType(type), from, to, children);
        return new $3856c2988d28a302$var$TreeElement(type, from);
    }
    /// @internal
    get buffer() {
        return new $3856c2988d28a302$var$Buffer(this.parser.nodeSet);
    }
    /// @internal
    constructor(/// The parser configuration used.
    parser, /// @internal
    input, fragments, /// @internal
    ranges){
        this.parser = parser;
        this.input = input;
        this.ranges = ranges;
        this.line = new $3856c2988d28a302$export$17d680238e50603e();
        this.atEnd = false;
        /// For reused nodes on gaps, we can't directly put the original
        /// node into the tree, since that may be bigger than its parent.
        /// When this happens, we create a dummy tree that is replaced by
        /// the proper node in `injectGaps` @internal
        this.reusePlaceholders = new Map;
        this.stoppedAt = null;
        /// The range index that absoluteLineStart points into @internal
        this.rangeI = 0;
        this.to = ranges[ranges.length - 1].to;
        this.lineStart = this.absoluteLineStart = this.absoluteLineEnd = ranges[0].from;
        this.block = $3856c2988d28a302$var$CompositeBlock.create($3856c2988d28a302$var$Type.Document, 0, this.lineStart, 0, 0);
        this.stack = [
            this.block
        ];
        this.fragments = fragments.length ? new $3856c2988d28a302$var$FragmentCursor(fragments, input) : null;
        this.readLine();
    }
}
function $3856c2988d28a302$var$injectGaps(ranges, rangeI, tree, offset, dummies) {
    let rangeEnd = ranges[rangeI].to;
    let children = [], positions = [], start = tree.from + offset;
    function movePastNext(upto, inclusive) {
        while(inclusive ? upto >= rangeEnd : upto > rangeEnd){
            let size = ranges[rangeI + 1].from - rangeEnd;
            offset += size;
            upto += size;
            rangeI++;
            rangeEnd = ranges[rangeI].to;
        }
    }
    for(let ch = tree.firstChild; ch; ch = ch.nextSibling){
        movePastNext(ch.from + offset, true);
        let from = ch.from + offset, node, reuse = dummies.get(ch.tree);
        if (reuse) node = reuse;
        else if (ch.to + offset > rangeEnd) {
            node = $3856c2988d28a302$var$injectGaps(ranges, rangeI, ch, offset, dummies);
            movePastNext(ch.to + offset, false);
        } else node = ch.toTree();
        children.push(node);
        positions.push(from - start);
    }
    movePastNext(tree.to + offset, false);
    return new (0, $uXNGm.Tree)(tree.type, children, positions, tree.to + offset - start, tree.tree ? tree.tree.propValues : undefined);
}
/// A Markdown parser configuration.
class $3856c2988d28a302$export$a64f782182dea128 extends (0, $uXNGm.Parser) {
    createParse(input, fragments, ranges) {
        let parse = new $3856c2988d28a302$export$b3bf2b2b75d6537d(this, input, fragments, ranges);
        for (let w of this.wrappers)parse = w(parse, input, fragments, ranges);
        return parse;
    }
    /// Reconfigure the parser.
    configure(spec) {
        let config = $3856c2988d28a302$var$resolveConfig(spec);
        if (!config) return this;
        let { nodeSet: nodeSet, skipContextMarkup: skipContextMarkup } = this;
        let blockParsers = this.blockParsers.slice(), leafBlockParsers = this.leafBlockParsers.slice(), blockNames = this.blockNames.slice(), inlineParsers = this.inlineParsers.slice(), inlineNames = this.inlineNames.slice(), endLeafBlock = this.endLeafBlock.slice(), wrappers = this.wrappers;
        if ($3856c2988d28a302$var$nonEmpty(config.defineNodes)) {
            skipContextMarkup = Object.assign({}, skipContextMarkup);
            let nodeTypes = nodeSet.types.slice(), styles;
            for (let s of config.defineNodes){
                let { name: name, block: block, composite: composite, style: style } = typeof s == "string" ? {
                    name: s
                } : s;
                if (nodeTypes.some((t)=>t.name == name)) continue;
                if (composite) skipContextMarkup[nodeTypes.length] = (bl, cx, line)=>composite(cx, line, bl.value);
                let id = nodeTypes.length;
                let group = composite ? [
                    "Block",
                    "BlockContext"
                ] : !block ? undefined : id >= $3856c2988d28a302$var$Type.ATXHeading1 && id <= $3856c2988d28a302$var$Type.SetextHeading2 ? [
                    "Block",
                    "LeafBlock",
                    "Heading"
                ] : [
                    "Block",
                    "LeafBlock"
                ];
                nodeTypes.push((0, $uXNGm.NodeType).define({
                    id: id,
                    name: name,
                    props: group && [
                        [
                            (0, $uXNGm.NodeProp).group,
                            group
                        ]
                    ]
                }));
                if (style) {
                    if (!styles) styles = {};
                    if (Array.isArray(style) || style instanceof (0, $lhXhg.Tag)) styles[name] = style;
                    else Object.assign(styles, style);
                }
            }
            nodeSet = new (0, $uXNGm.NodeSet)(nodeTypes);
            if (styles) nodeSet = nodeSet.extend((0, $lhXhg.styleTags)(styles));
        }
        if ($3856c2988d28a302$var$nonEmpty(config.props)) nodeSet = nodeSet.extend(...config.props);
        if ($3856c2988d28a302$var$nonEmpty(config.remove)) for (let rm of config.remove){
            let block = this.blockNames.indexOf(rm), inline = this.inlineNames.indexOf(rm);
            if (block > -1) blockParsers[block] = leafBlockParsers[block] = undefined;
            if (inline > -1) inlineParsers[inline] = undefined;
        }
        if ($3856c2988d28a302$var$nonEmpty(config.parseBlock)) for (let spec of config.parseBlock){
            let found = blockNames.indexOf(spec.name);
            if (found > -1) {
                blockParsers[found] = spec.parse;
                leafBlockParsers[found] = spec.leaf;
            } else {
                let pos = spec.before ? $3856c2988d28a302$var$findName(blockNames, spec.before) : spec.after ? $3856c2988d28a302$var$findName(blockNames, spec.after) + 1 : blockNames.length - 1;
                blockParsers.splice(pos, 0, spec.parse);
                leafBlockParsers.splice(pos, 0, spec.leaf);
                blockNames.splice(pos, 0, spec.name);
            }
            if (spec.endLeaf) endLeafBlock.push(spec.endLeaf);
        }
        if ($3856c2988d28a302$var$nonEmpty(config.parseInline)) for (let spec of config.parseInline){
            let found = inlineNames.indexOf(spec.name);
            if (found > -1) inlineParsers[found] = spec.parse;
            else {
                let pos = spec.before ? $3856c2988d28a302$var$findName(inlineNames, spec.before) : spec.after ? $3856c2988d28a302$var$findName(inlineNames, spec.after) + 1 : inlineNames.length - 1;
                inlineParsers.splice(pos, 0, spec.parse);
                inlineNames.splice(pos, 0, spec.name);
            }
        }
        if (config.wrap) wrappers = wrappers.concat(config.wrap);
        return new $3856c2988d28a302$export$a64f782182dea128(nodeSet, blockParsers, leafBlockParsers, blockNames, endLeafBlock, skipContextMarkup, inlineParsers, inlineNames, wrappers);
    }
    /// @internal
    getNodeType(name) {
        let found = this.nodeTypes[name];
        if (found == null) throw new RangeError(`Unknown node type '${name}'`);
        return found;
    }
    /// Parse the given piece of inline text at the given offset,
    /// returning an array of [`Element`](#Element) objects representing
    /// the inline content.
    parseInline(text, offset) {
        let cx = new $3856c2988d28a302$export$75ab56226e2d3efd(this, text, offset);
        outer: for(let pos = offset; pos < cx.end;){
            let next = cx.char(pos);
            for (let token of this.inlineParsers)if (token) {
                let result = token(cx, next, pos);
                if (result >= 0) {
                    pos = result;
                    continue outer;
                }
            }
            pos++;
        }
        return cx.resolveMarkers(0);
    }
    /// @internal
    constructor(/// The parser's syntax [node
    /// types](https://lezer.codemirror.net/docs/ref/#common.NodeSet).
    nodeSet, /// @internal
    blockParsers, /// @internal
    leafBlockParsers, /// @internal
    blockNames, /// @internal
    endLeafBlock, /// @internal
    skipContextMarkup, /// @internal
    inlineParsers, /// @internal
    inlineNames, /// @internal
    wrappers){
        super();
        this.nodeSet = nodeSet;
        this.blockParsers = blockParsers;
        this.leafBlockParsers = leafBlockParsers;
        this.blockNames = blockNames;
        this.endLeafBlock = endLeafBlock;
        this.skipContextMarkup = skipContextMarkup;
        this.inlineParsers = inlineParsers;
        this.inlineNames = inlineNames;
        this.wrappers = wrappers;
        /// @internal
        this.nodeTypes = Object.create(null);
        for (let t of nodeSet.types)this.nodeTypes[t.name] = t.id;
    }
}
function $3856c2988d28a302$var$nonEmpty(a) {
    return a != null && a.length > 0;
}
function $3856c2988d28a302$var$resolveConfig(spec) {
    if (!Array.isArray(spec)) return spec;
    if (spec.length == 0) return null;
    let conf = $3856c2988d28a302$var$resolveConfig(spec[0]);
    if (spec.length == 1) return conf;
    let rest = $3856c2988d28a302$var$resolveConfig(spec.slice(1));
    if (!rest || !conf) return conf || rest;
    let conc = (a, b)=>(a || $3856c2988d28a302$var$none).concat(b || $3856c2988d28a302$var$none);
    let wrapA = conf.wrap, wrapB = rest.wrap;
    return {
        props: conc(conf.props, rest.props),
        defineNodes: conc(conf.defineNodes, rest.defineNodes),
        parseBlock: conc(conf.parseBlock, rest.parseBlock),
        parseInline: conc(conf.parseInline, rest.parseInline),
        remove: conc(conf.remove, rest.remove),
        wrap: !wrapA ? wrapB : !wrapB ? wrapA : (inner, input, fragments, ranges)=>wrapA(wrapB(inner, input, fragments, ranges), input, fragments, ranges)
    };
}
function $3856c2988d28a302$var$findName(names, name) {
    let found = names.indexOf(name);
    if (found < 0) throw new RangeError(`Position specified relative to unknown parser ${name}`);
    return found;
}
let $3856c2988d28a302$var$nodeTypes = [
    (0, $uXNGm.NodeType).none
];
for(let i = 1, name; name = $3856c2988d28a302$var$Type[i]; i++)$3856c2988d28a302$var$nodeTypes[i] = (0, $uXNGm.NodeType).define({
    id: i,
    name: name,
    props: i >= $3856c2988d28a302$var$Type.Escape ? [] : [
        [
            (0, $uXNGm.NodeProp).group,
            i in $3856c2988d28a302$var$DefaultSkipMarkup ? [
                "Block",
                "BlockContext"
            ] : [
                "Block",
                "LeafBlock"
            ]
        ]
    ],
    top: name == "Document"
});
const $3856c2988d28a302$var$none = [];
class $3856c2988d28a302$var$Buffer {
    write(type, from, to, children = 0) {
        this.content.push(type, from, to, 4 + children * 4);
        return this;
    }
    writeElements(elts, offset = 0) {
        for (let e of elts)e.writeTo(this, offset);
        return this;
    }
    finish(type, length) {
        return (0, $uXNGm.Tree).build({
            buffer: this.content,
            nodeSet: this.nodeSet,
            reused: this.nodes,
            topID: type,
            length: length
        });
    }
    constructor(nodeSet){
        this.nodeSet = nodeSet;
        this.content = [];
        this.nodes = [];
    }
}
/// Elements are used to compose syntax nodes during parsing.
class $3856c2988d28a302$export$db77ccec0bb4ccac {
    /// @internal
    writeTo(buf, offset) {
        let startOff = buf.content.length;
        buf.writeElements(this.children, offset);
        buf.content.push(this.type, this.from + offset, this.to + offset, buf.content.length + 4 - startOff);
    }
    /// @internal
    toTree(nodeSet) {
        return new $3856c2988d28a302$var$Buffer(nodeSet).writeElements(this.children, -this.from).finish(this.type, this.to - this.from);
    }
    /// @internal
    constructor(/// The node's
    /// [id](https://lezer.codemirror.net/docs/ref/#common.NodeType.id).
    type, /// The start of the node, as an offset from the start of the document.
    from, /// The end of the node.
    to, /// The node's child nodes @internal
    children = $3856c2988d28a302$var$none){
        this.type = type;
        this.from = from;
        this.to = to;
        this.children = children;
    }
}
class $3856c2988d28a302$var$TreeElement {
    get to() {
        return this.from + this.tree.length;
    }
    get type() {
        return this.tree.type.id;
    }
    get children() {
        return $3856c2988d28a302$var$none;
    }
    writeTo(buf, offset) {
        buf.nodes.push(this.tree);
        buf.content.push(buf.nodes.length - 1, this.from + offset, this.to + offset, -1);
    }
    toTree() {
        return this.tree;
    }
    constructor(tree, from){
        this.tree = tree;
        this.from = from;
    }
}
function $3856c2988d28a302$var$elt(type, from, to, children) {
    return new $3856c2988d28a302$export$db77ccec0bb4ccac(type, from, to, children);
}
const $3856c2988d28a302$var$EmphasisUnderscore = {
    resolve: "Emphasis",
    mark: "EmphasisMark"
};
const $3856c2988d28a302$var$EmphasisAsterisk = {
    resolve: "Emphasis",
    mark: "EmphasisMark"
};
const $3856c2988d28a302$var$LinkStart = {}, $3856c2988d28a302$var$ImageStart = {};
class $3856c2988d28a302$var$InlineDelimiter {
    constructor(type, from, to, side){
        this.type = type;
        this.from = from;
        this.to = to;
        this.side = side;
    }
}
const $3856c2988d28a302$var$Escapable = "!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~";
let $3856c2988d28a302$var$Punctuation = /[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~\xA1\u2010-\u2027]/;
try {
    $3856c2988d28a302$var$Punctuation = new RegExp("[\\p{S}|\\p{P}]", "u");
} catch (_) {}
const $3856c2988d28a302$var$DefaultInline = {
    Escape (cx, next, start) {
        if (next != 92 /* '\\' */  || start == cx.end - 1) return -1;
        let escaped = cx.char(start + 1);
        for(let i = 0; i < $3856c2988d28a302$var$Escapable.length; i++)if ($3856c2988d28a302$var$Escapable.charCodeAt(i) == escaped) return cx.append($3856c2988d28a302$var$elt($3856c2988d28a302$var$Type.Escape, start, start + 2));
        return -1;
    },
    Entity (cx, next, start) {
        if (next != 38 /* '&' */ ) return -1;
        let m = /^(?:#\d+|#x[a-f\d]+|\w+);/i.exec(cx.slice(start + 1, start + 31));
        return m ? cx.append($3856c2988d28a302$var$elt($3856c2988d28a302$var$Type.Entity, start, start + 1 + m[0].length)) : -1;
    },
    InlineCode (cx, next, start) {
        if (next != 96 /* '`' */  || start && cx.char(start - 1) == 96) return -1;
        let pos = start + 1;
        while(pos < cx.end && cx.char(pos) == 96)pos++;
        let size = pos - start, curSize = 0;
        for(; pos < cx.end; pos++)if (cx.char(pos) == 96) {
            curSize++;
            if (curSize == size && cx.char(pos + 1) != 96) return cx.append($3856c2988d28a302$var$elt($3856c2988d28a302$var$Type.InlineCode, start, pos + 1, [
                $3856c2988d28a302$var$elt($3856c2988d28a302$var$Type.CodeMark, start, start + size),
                $3856c2988d28a302$var$elt($3856c2988d28a302$var$Type.CodeMark, pos + 1 - size, pos + 1)
            ]));
        } else curSize = 0;
        return -1;
    },
    HTMLTag (cx, next, start) {
        if (next != 60 /* '<' */  || start == cx.end - 1) return -1;
        let after = cx.slice(start + 1, cx.end);
        let url = /^(?:[a-z][-\w+.]+:[^\s>]+|[a-z\d.!#$%&'*+/=?^_`{|}~-]+@[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?(?:\.[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?)*)>/i.exec(after);
        if (url) return cx.append($3856c2988d28a302$var$elt($3856c2988d28a302$var$Type.Autolink, start, start + 1 + url[0].length, [
            $3856c2988d28a302$var$elt($3856c2988d28a302$var$Type.LinkMark, start, start + 1),
            // url[0] includes the closing bracket, so exclude it from this slice
            $3856c2988d28a302$var$elt($3856c2988d28a302$var$Type.URL, start + 1, start + url[0].length),
            $3856c2988d28a302$var$elt($3856c2988d28a302$var$Type.LinkMark, start + url[0].length, start + 1 + url[0].length)
        ]));
        let comment = /^!--[^>](?:-[^-]|[^-])*?-->/i.exec(after);
        if (comment) return cx.append($3856c2988d28a302$var$elt($3856c2988d28a302$var$Type.Comment, start, start + 1 + comment[0].length));
        let procInst = /^\?[^]*?\?>/.exec(after);
        if (procInst) return cx.append($3856c2988d28a302$var$elt($3856c2988d28a302$var$Type.ProcessingInstruction, start, start + 1 + procInst[0].length));
        let m = /^(?:![A-Z][^]*?>|!\[CDATA\[[^]*?\]\]>|\/\s*[a-zA-Z][\w-]*\s*>|\s*[a-zA-Z][\w-]*(\s+[a-zA-Z:_][\w-.:]*(?:\s*=\s*(?:[^\s"'=<>`]+|'[^']*'|"[^"]*"))?)*\s*(\/\s*)?>)/.exec(after);
        if (!m) return -1;
        return cx.append($3856c2988d28a302$var$elt($3856c2988d28a302$var$Type.HTMLTag, start, start + 1 + m[0].length));
    },
    Emphasis (cx, next, start) {
        if (next != 95 && next != 42) return -1;
        let pos = start + 1;
        while(cx.char(pos) == next)pos++;
        let before = cx.slice(start - 1, start), after = cx.slice(pos, pos + 1);
        let pBefore = $3856c2988d28a302$var$Punctuation.test(before), pAfter = $3856c2988d28a302$var$Punctuation.test(after);
        let sBefore = /\s|^$/.test(before), sAfter = /\s|^$/.test(after);
        let leftFlanking = !sAfter && (!pAfter || sBefore || pBefore);
        let rightFlanking = !sBefore && (!pBefore || sAfter || pAfter);
        let canOpen = leftFlanking && (next == 42 || !rightFlanking || pBefore);
        let canClose = rightFlanking && (next == 42 || !leftFlanking || pAfter);
        return cx.append(new $3856c2988d28a302$var$InlineDelimiter(next == 95 ? $3856c2988d28a302$var$EmphasisUnderscore : $3856c2988d28a302$var$EmphasisAsterisk, start, pos, (canOpen ? 1 /* Mark.Open */  : 0 /* Mark.None */ ) | (canClose ? 2 /* Mark.Close */  : 0 /* Mark.None */ )));
    },
    HardBreak (cx, next, start) {
        if (next == 92 /* '\\' */  && cx.char(start + 1) == 10 /* '\n' */ ) return cx.append($3856c2988d28a302$var$elt($3856c2988d28a302$var$Type.HardBreak, start, start + 2));
        if (next == 32) {
            let pos = start + 1;
            while(cx.char(pos) == 32)pos++;
            if (cx.char(pos) == 10 && pos >= start + 2) return cx.append($3856c2988d28a302$var$elt($3856c2988d28a302$var$Type.HardBreak, start, pos + 1));
        }
        return -1;
    },
    Link (cx, next, start) {
        return next == 91 /* '[' */  ? cx.append(new $3856c2988d28a302$var$InlineDelimiter($3856c2988d28a302$var$LinkStart, start, start + 1, 1 /* Mark.Open */ )) : -1;
    },
    Image (cx, next, start) {
        return next == 33 /* '!' */  && cx.char(start + 1) == 91 /* '[' */  ? cx.append(new $3856c2988d28a302$var$InlineDelimiter($3856c2988d28a302$var$ImageStart, start, start + 2, 1 /* Mark.Open */ )) : -1;
    },
    LinkEnd (cx, next, start) {
        if (next != 93 /* ']' */ ) return -1;
        // Scanning back to the next link/image start marker
        for(let i = cx.parts.length - 1; i >= 0; i--){
            let part = cx.parts[i];
            if (part instanceof $3856c2988d28a302$var$InlineDelimiter && (part.type == $3856c2988d28a302$var$LinkStart || part.type == $3856c2988d28a302$var$ImageStart)) {
                // If this one has been set invalid (because it would produce
                // a nested link) or there's no valid link here ignore both.
                if (!part.side || cx.skipSpace(part.to) == start && !/[(\[]/.test(cx.slice(start + 1, start + 2))) {
                    cx.parts[i] = null;
                    return -1;
                }
                // Finish the content and replace the entire range in
                // this.parts with the link/image node.
                let content = cx.takeContent(i);
                let link = cx.parts[i] = $3856c2988d28a302$var$finishLink(cx, content, part.type == $3856c2988d28a302$var$LinkStart ? $3856c2988d28a302$var$Type.Link : $3856c2988d28a302$var$Type.Image, part.from, start + 1);
                // Set any open-link markers before this link to invalid.
                if (part.type == $3856c2988d28a302$var$LinkStart) for(let j = 0; j < i; j++){
                    let p = cx.parts[j];
                    if (p instanceof $3856c2988d28a302$var$InlineDelimiter && p.type == $3856c2988d28a302$var$LinkStart) p.side = 0 /* Mark.None */ ;
                }
                return link.to;
            }
        }
        return -1;
    }
};
function $3856c2988d28a302$var$finishLink(cx, content, type, start, startPos) {
    let { text: text } = cx, next = cx.char(startPos), endPos = startPos;
    content.unshift($3856c2988d28a302$var$elt($3856c2988d28a302$var$Type.LinkMark, start, start + (type == $3856c2988d28a302$var$Type.Image ? 2 : 1)));
    content.push($3856c2988d28a302$var$elt($3856c2988d28a302$var$Type.LinkMark, startPos - 1, startPos));
    if (next == 40 /* '(' */ ) {
        let pos = cx.skipSpace(startPos + 1);
        let dest = $3856c2988d28a302$var$parseURL(text, pos - cx.offset, cx.offset), title;
        if (dest) {
            pos = cx.skipSpace(dest.to);
            // The destination and title must be separated by whitespace
            if (pos != dest.to) {
                title = $3856c2988d28a302$var$parseLinkTitle(text, pos - cx.offset, cx.offset);
                if (title) pos = cx.skipSpace(title.to);
            }
        }
        if (cx.char(pos) == 41 /* ')' */ ) {
            content.push($3856c2988d28a302$var$elt($3856c2988d28a302$var$Type.LinkMark, startPos, startPos + 1));
            endPos = pos + 1;
            if (dest) content.push(dest);
            if (title) content.push(title);
            content.push($3856c2988d28a302$var$elt($3856c2988d28a302$var$Type.LinkMark, pos, endPos));
        }
    } else if (next == 91 /* '[' */ ) {
        let label = $3856c2988d28a302$var$parseLinkLabel(text, startPos - cx.offset, cx.offset, false);
        if (label) {
            content.push(label);
            endPos = label.to;
        }
    }
    return $3856c2988d28a302$var$elt(type, start, endPos, content);
}
// These return `null` when falling off the end of the input, `false`
// when parsing fails otherwise (for use in the incremental link
// reference parser).
function $3856c2988d28a302$var$parseURL(text, start, offset) {
    let next = text.charCodeAt(start);
    if (next == 60 /* '<' */ ) {
        for(let pos = start + 1; pos < text.length; pos++){
            let ch = text.charCodeAt(pos);
            if (ch == 62 /* '>' */ ) return $3856c2988d28a302$var$elt($3856c2988d28a302$var$Type.URL, start + offset, pos + 1 + offset);
            if (ch == 60 || ch == 10 /* '<\n' */ ) return false;
        }
        return null;
    } else {
        let depth = 0, pos = start;
        for(let escaped = false; pos < text.length; pos++){
            let ch = text.charCodeAt(pos);
            if ($3856c2988d28a302$var$space(ch)) break;
            else if (escaped) escaped = false;
            else if (ch == 40 /* '(' */ ) depth++;
            else if (ch == 41 /* ')' */ ) {
                if (!depth) break;
                depth--;
            } else if (ch == 92 /* '\\' */ ) escaped = true;
        }
        return pos > start ? $3856c2988d28a302$var$elt($3856c2988d28a302$var$Type.URL, start + offset, pos + offset) : pos == text.length ? null : false;
    }
}
function $3856c2988d28a302$var$parseLinkTitle(text, start, offset) {
    let next = text.charCodeAt(start);
    if (next != 39 && next != 34 && next != 40 /* '"\'(' */ ) return false;
    let end = next == 40 ? 41 : next;
    for(let pos = start + 1, escaped = false; pos < text.length; pos++){
        let ch = text.charCodeAt(pos);
        if (escaped) escaped = false;
        else if (ch == end) return $3856c2988d28a302$var$elt($3856c2988d28a302$var$Type.LinkTitle, start + offset, pos + 1 + offset);
        else if (ch == 92 /* '\\' */ ) escaped = true;
    }
    return null;
}
function $3856c2988d28a302$var$parseLinkLabel(text, start, offset, requireNonWS) {
    for(let escaped = false, pos = start + 1, end = Math.min(text.length, pos + 999); pos < end; pos++){
        let ch = text.charCodeAt(pos);
        if (escaped) escaped = false;
        else if (ch == 93 /* ']' */ ) return requireNonWS ? false : $3856c2988d28a302$var$elt($3856c2988d28a302$var$Type.LinkLabel, start + offset, pos + 1 + offset);
        else {
            if (requireNonWS && !$3856c2988d28a302$var$space(ch)) requireNonWS = false;
            if (ch == 91 /* '[' */ ) return false;
            else if (ch == 92 /* '\\' */ ) escaped = true;
        }
    }
    return null;
}
/// Inline parsing functions get access to this context, and use it to
/// read the content and emit syntax nodes.
class $3856c2988d28a302$export$75ab56226e2d3efd {
    /// Get the character code at the given (document-relative)
    /// position.
    char(pos) {
        return pos >= this.end ? -1 : this.text.charCodeAt(pos - this.offset);
    }
    /// The position of the end of this inline section.
    get end() {
        return this.offset + this.text.length;
    }
    /// Get a substring of this inline section. Again uses
    /// document-relative positions.
    slice(from, to) {
        return this.text.slice(from - this.offset, to - this.offset);
    }
    /// @internal
    append(elt) {
        this.parts.push(elt);
        return elt.to;
    }
    /// Add a [delimiter](#DelimiterType) at this given position. `open`
    /// and `close` indicate whether this delimiter is opening, closing,
    /// or both. Returns the end of the delimiter, for convenient
    /// returning from [parse functions](#InlineParser.parse).
    addDelimiter(type, from, to, open, close) {
        return this.append(new $3856c2988d28a302$var$InlineDelimiter(type, from, to, (open ? 1 /* Mark.Open */  : 0 /* Mark.None */ ) | (close ? 2 /* Mark.Close */  : 0 /* Mark.None */ )));
    }
    /// Returns true when there is an unmatched link or image opening
    /// token before the current position.
    get hasOpenLink() {
        for(let i = this.parts.length - 1; i >= 0; i--){
            let part = this.parts[i];
            if (part instanceof $3856c2988d28a302$var$InlineDelimiter && (part.type == $3856c2988d28a302$var$LinkStart || part.type == $3856c2988d28a302$var$ImageStart)) return true;
        }
        return false;
    }
    /// Add an inline element. Returns the end of the element.
    addElement(elt) {
        return this.append(elt);
    }
    /// Resolve markers between this.parts.length and from, wrapping matched markers in the
    /// appropriate node and updating the content of this.parts. @internal
    resolveMarkers(from) {
        // Scan forward, looking for closing tokens
        for(let i = from; i < this.parts.length; i++){
            let close = this.parts[i];
            if (!(close instanceof $3856c2988d28a302$var$InlineDelimiter && close.type.resolve && close.side & 2 /* Mark.Close */ )) continue;
            let emp = close.type == $3856c2988d28a302$var$EmphasisUnderscore || close.type == $3856c2988d28a302$var$EmphasisAsterisk;
            let closeSize = close.to - close.from;
            let open, j = i - 1;
            // Continue scanning for a matching opening token
            for(; j >= from; j--){
                let part = this.parts[j];
                if (part instanceof $3856c2988d28a302$var$InlineDelimiter && part.side & 1 /* Mark.Open */  && part.type == close.type && // Ignore emphasis delimiters where the character count doesn't match
                !(emp && (close.side & 1 /* Mark.Open */  || part.side & 2 /* Mark.Close */ ) && (part.to - part.from + closeSize) % 3 == 0 && ((part.to - part.from) % 3 || closeSize % 3))) {
                    open = part;
                    break;
                }
            }
            if (!open) continue;
            let type = close.type.resolve, content = [];
            let start = open.from, end = close.to;
            // Emphasis marker effect depends on the character count. Size consumed is minimum of the two
            // markers.
            if (emp) {
                let size = Math.min(2, open.to - open.from, closeSize);
                start = open.to - size;
                end = close.from + size;
                type = size == 1 ? "Emphasis" : "StrongEmphasis";
            }
            // Move the covered region into content, optionally adding marker nodes
            if (open.type.mark) content.push(this.elt(open.type.mark, start, open.to));
            for(let k = j + 1; k < i; k++){
                if (this.parts[k] instanceof $3856c2988d28a302$export$db77ccec0bb4ccac) content.push(this.parts[k]);
                this.parts[k] = null;
            }
            if (close.type.mark) content.push(this.elt(close.type.mark, close.from, end));
            let element = this.elt(type, start, end, content);
            // If there are leftover emphasis marker characters, shrink the close/open markers. Otherwise, clear them.
            this.parts[j] = emp && open.from != start ? new $3856c2988d28a302$var$InlineDelimiter(open.type, open.from, start, open.side) : null;
            let keep = this.parts[i] = emp && close.to != end ? new $3856c2988d28a302$var$InlineDelimiter(close.type, end, close.to, close.side) : null;
            // Insert the new element in this.parts
            if (keep) this.parts.splice(i, 0, element);
            else this.parts[i] = element;
        }
        // Collect the elements remaining in this.parts into an array.
        let result = [];
        for(let i = from; i < this.parts.length; i++){
            let part = this.parts[i];
            if (part instanceof $3856c2988d28a302$export$db77ccec0bb4ccac) result.push(part);
        }
        return result;
    }
    /// Find an opening delimiter of the given type. Returns `null` if
    /// no delimiter is found, or an index that can be passed to
    /// [`takeContent`](#InlineContext.takeContent) otherwise.
    findOpeningDelimiter(type) {
        for(let i = this.parts.length - 1; i >= 0; i--){
            let part = this.parts[i];
            if (part instanceof $3856c2988d28a302$var$InlineDelimiter && part.type == type) return i;
        }
        return null;
    }
    /// Remove all inline elements and delimiters starting from the
    /// given index (which you should get from
    /// [`findOpeningDelimiter`](#InlineContext.findOpeningDelimiter),
    /// resolve delimiters inside of them, and return them as an array
    /// of elements.
    takeContent(startIndex) {
        let content = this.resolveMarkers(startIndex);
        this.parts.length = startIndex;
        return content;
    }
    /// Skip space after the given (document) position, returning either
    /// the position of the next non-space character or the end of the
    /// section.
    skipSpace(from) {
        return $3856c2988d28a302$var$skipSpace(this.text, from - this.offset) + this.offset;
    }
    elt(type, from, to, children) {
        if (typeof type == "string") return $3856c2988d28a302$var$elt(this.parser.getNodeType(type), from, to, children);
        return new $3856c2988d28a302$var$TreeElement(type, from);
    }
    /// @internal
    constructor(/// The parser that is being used.
    parser, /// The text of this inline section.
    text, /// The starting offset of the section in the document.
    offset){
        this.parser = parser;
        this.text = text;
        this.offset = offset;
        /// @internal
        this.parts = [];
    }
}
function $3856c2988d28a302$var$injectMarks(elements, marks) {
    if (!marks.length) return elements;
    if (!elements.length) return marks;
    let elts = elements.slice(), eI = 0;
    for (let mark of marks){
        while(eI < elts.length && elts[eI].to < mark.to)eI++;
        if (eI < elts.length && elts[eI].from < mark.from) {
            let e = elts[eI];
            if (e instanceof $3856c2988d28a302$export$db77ccec0bb4ccac) elts[eI] = new $3856c2988d28a302$export$db77ccec0bb4ccac(e.type, e.from, e.to, $3856c2988d28a302$var$injectMarks(e.children, [
                mark
            ]));
        } else elts.splice(eI++, 0, mark);
    }
    return elts;
}
// These are blocks that can span blank lines, and should thus only be
// reused if their next sibling is also being reused.
const $3856c2988d28a302$var$NotLast = [
    $3856c2988d28a302$var$Type.CodeBlock,
    $3856c2988d28a302$var$Type.ListItem,
    $3856c2988d28a302$var$Type.OrderedList,
    $3856c2988d28a302$var$Type.BulletList
];
class $3856c2988d28a302$var$FragmentCursor {
    nextFragment() {
        this.fragment = this.i < this.fragments.length ? this.fragments[this.i++] : null;
        this.cursor = null;
        this.fragmentEnd = -1;
    }
    moveTo(pos, lineStart) {
        while(this.fragment && this.fragment.to <= pos)this.nextFragment();
        if (!this.fragment || this.fragment.from > (pos ? pos - 1 : 0)) return false;
        if (this.fragmentEnd < 0) {
            let end = this.fragment.to;
            while(end > 0 && this.input.read(end - 1, end) != "\n")end--;
            this.fragmentEnd = end ? end - 1 : 0;
        }
        let c = this.cursor;
        if (!c) {
            c = this.cursor = this.fragment.tree.cursor();
            c.firstChild();
        }
        let rPos = pos + this.fragment.offset;
        while(c.to <= rPos)if (!c.parent()) return false;
        for(;;){
            if (c.from >= rPos) return this.fragment.from <= lineStart;
            if (!c.childAfter(rPos)) return false;
        }
    }
    matches(hash) {
        let tree = this.cursor.tree;
        return tree && tree.prop((0, $uXNGm.NodeProp).contextHash) == hash;
    }
    takeNodes(cx) {
        let cur = this.cursor, off = this.fragment.offset, fragEnd = this.fragmentEnd - (this.fragment.openEnd ? 1 : 0);
        let start = cx.absoluteLineStart, end = start, blockI = cx.block.children.length;
        let prevEnd = end, prevI = blockI;
        for(;;){
            if (cur.to - off > fragEnd) {
                if (cur.type.isAnonymous && cur.firstChild()) continue;
                break;
            }
            let pos = $3856c2988d28a302$var$toRelative(cur.from - off, cx.ranges);
            if (cur.to - off <= cx.ranges[cx.rangeI].to) cx.addNode(cur.tree, pos);
            else {
                let dummy = new (0, $uXNGm.Tree)(cx.parser.nodeSet.types[$3856c2988d28a302$var$Type.Paragraph], [], [], 0, cx.block.hashProp);
                cx.reusePlaceholders.set(dummy, cur.tree);
                cx.addNode(dummy, pos);
            }
            // Taken content must always end in a block, because incremental
            // parsing happens on block boundaries. Never stop directly
            // after an indented code block, since those can continue after
            // any number of blank lines.
            if (cur.type.is("Block")) {
                if ($3856c2988d28a302$var$NotLast.indexOf(cur.type.id) < 0) {
                    end = cur.to - off;
                    blockI = cx.block.children.length;
                } else {
                    end = prevEnd;
                    blockI = prevI;
                    prevEnd = cur.to - off;
                    prevI = cx.block.children.length;
                }
            }
            if (!cur.nextSibling()) break;
        }
        while(cx.block.children.length > blockI){
            cx.block.children.pop();
            cx.block.positions.pop();
        }
        return end - start;
    }
    constructor(fragments, input){
        this.fragments = fragments;
        this.input = input;
        // Index into fragment array
        this.i = 0;
        // Active fragment
        this.fragment = null;
        this.fragmentEnd = -1;
        // Cursor into the current fragment, if any. When `moveTo` returns
        // true, this points at the first block after `pos`.
        this.cursor = null;
        if (fragments.length) this.fragment = fragments[this.i++];
    }
}
// Convert an input-stream-relative position to a
// Markdown-doc-relative position by subtracting the size of all input
// gaps before `abs`.
function $3856c2988d28a302$var$toRelative(abs, ranges) {
    let pos = abs;
    for(let i = 1; i < ranges.length; i++){
        let gapFrom = ranges[i - 1].to, gapTo = ranges[i].from;
        if (gapFrom < abs) pos -= gapTo - gapFrom;
    }
    return pos;
}
const $3856c2988d28a302$var$markdownHighlighting = (0, $lhXhg.styleTags)({
    "Blockquote/...": (0, $lhXhg.tags).quote,
    HorizontalRule: (0, $lhXhg.tags).contentSeparator,
    "ATXHeading1/... SetextHeading1/...": (0, $lhXhg.tags).heading1,
    "ATXHeading2/... SetextHeading2/...": (0, $lhXhg.tags).heading2,
    "ATXHeading3/...": (0, $lhXhg.tags).heading3,
    "ATXHeading4/...": (0, $lhXhg.tags).heading4,
    "ATXHeading5/...": (0, $lhXhg.tags).heading5,
    "ATXHeading6/...": (0, $lhXhg.tags).heading6,
    "Comment CommentBlock": (0, $lhXhg.tags).comment,
    Escape: (0, $lhXhg.tags).escape,
    Entity: (0, $lhXhg.tags).character,
    "Emphasis/...": (0, $lhXhg.tags).emphasis,
    "StrongEmphasis/...": (0, $lhXhg.tags).strong,
    "Link/... Image/...": (0, $lhXhg.tags).link,
    "OrderedList/... BulletList/...": (0, $lhXhg.tags).list,
    "BlockQuote/...": (0, $lhXhg.tags).quote,
    "InlineCode CodeText": (0, $lhXhg.tags).monospace,
    "URL Autolink": (0, $lhXhg.tags).url,
    "HeaderMark HardBreak QuoteMark ListMark LinkMark EmphasisMark CodeMark": (0, $lhXhg.tags).processingInstruction,
    "CodeInfo LinkLabel": (0, $lhXhg.tags).labelName,
    LinkTitle: (0, $lhXhg.tags).string,
    Paragraph: (0, $lhXhg.tags).content
});
/// The default CommonMark parser.
const $3856c2988d28a302$export$8f49e4af10703ce3 = new $3856c2988d28a302$export$a64f782182dea128(new (0, $uXNGm.NodeSet)($3856c2988d28a302$var$nodeTypes).extend($3856c2988d28a302$var$markdownHighlighting), Object.keys($3856c2988d28a302$var$DefaultBlockParsers).map((n)=>$3856c2988d28a302$var$DefaultBlockParsers[n]), Object.keys($3856c2988d28a302$var$DefaultBlockParsers).map((n)=>$3856c2988d28a302$var$DefaultLeafBlocks[n]), Object.keys($3856c2988d28a302$var$DefaultBlockParsers), $3856c2988d28a302$var$DefaultEndLeaf, $3856c2988d28a302$var$DefaultSkipMarkup, Object.keys($3856c2988d28a302$var$DefaultInline).map((n)=>$3856c2988d28a302$var$DefaultInline[n]), Object.keys($3856c2988d28a302$var$DefaultInline), []);
function $3856c2988d28a302$var$leftOverSpace(node, from, to) {
    let ranges = [];
    for(let n = node.firstChild, pos = from;; n = n.nextSibling){
        let nextPos = n ? n.from : to;
        if (nextPos > pos) ranges.push({
            from: pos,
            to: nextPos
        });
        if (!n) break;
        pos = n.to;
    }
    return ranges;
}
/// Create a Markdown extension to enable nested parsing on code
/// blocks and/or embedded HTML.
function $3856c2988d28a302$export$2d8e3d567a97292a(config) {
    let { codeParser: codeParser, htmlParser: htmlParser } = config;
    let wrap = (0, $uXNGm.parseMixed)((node, input)=>{
        let id = node.type.id;
        if (codeParser && (id == $3856c2988d28a302$var$Type.CodeBlock || id == $3856c2988d28a302$var$Type.FencedCode)) {
            let info = "";
            if (id == $3856c2988d28a302$var$Type.FencedCode) {
                let infoNode = node.node.getChild($3856c2988d28a302$var$Type.CodeInfo);
                if (infoNode) info = input.read(infoNode.from, infoNode.to);
            }
            let parser = codeParser(info);
            if (parser) return {
                parser: parser,
                overlay: (node)=>node.type.id == $3856c2988d28a302$var$Type.CodeText
            };
        } else if (htmlParser && (id == $3856c2988d28a302$var$Type.HTMLBlock || id == $3856c2988d28a302$var$Type.HTMLTag)) return {
            parser: htmlParser,
            overlay: $3856c2988d28a302$var$leftOverSpace(node.node, node.from, node.to)
        };
        return null;
    });
    return {
        wrap: wrap
    };
}
const $3856c2988d28a302$var$StrikethroughDelim = {
    resolve: "Strikethrough",
    mark: "StrikethroughMark"
};
/// An extension that implements
/// [GFM-style](https://github.github.com/gfm/#strikethrough-extension-)
/// Strikethrough syntax using `~~` delimiters.
const $3856c2988d28a302$export$53f33388b3b5115f = {
    defineNodes: [
        {
            name: "Strikethrough",
            style: {
                "Strikethrough/...": (0, $lhXhg.tags).strikethrough
            }
        },
        {
            name: "StrikethroughMark",
            style: (0, $lhXhg.tags).processingInstruction
        }
    ],
    parseInline: [
        {
            name: "Strikethrough",
            parse (cx, next, pos) {
                if (next != 126 /* '~' */  || cx.char(pos + 1) != 126 || cx.char(pos + 2) == 126) return -1;
                let before = cx.slice(pos - 1, pos), after = cx.slice(pos + 2, pos + 3);
                let sBefore = /\s|^$/.test(before), sAfter = /\s|^$/.test(after);
                let pBefore = $3856c2988d28a302$var$Punctuation.test(before), pAfter = $3856c2988d28a302$var$Punctuation.test(after);
                return cx.addDelimiter($3856c2988d28a302$var$StrikethroughDelim, pos, pos + 2, !sAfter && (!pAfter || sBefore || pBefore), !sBefore && (!pBefore || sAfter || pAfter));
            },
            after: "Emphasis"
        }
    ]
};
// Parse a line as a table row and return the row count. When `elts`
// is given, push syntax elements for the content onto it.
function $3856c2988d28a302$var$parseRow(cx, line, startI = 0, elts, offset = 0) {
    let count = 0, first = true, cellStart = -1, cellEnd = -1, esc = false;
    let parseCell = ()=>{
        elts.push(cx.elt("TableCell", offset + cellStart, offset + cellEnd, cx.parser.parseInline(line.slice(cellStart, cellEnd), offset + cellStart)));
    };
    for(let i = startI; i < line.length; i++){
        let next = line.charCodeAt(i);
        if (next == 124 /* '|' */  && !esc) {
            if (!first || cellStart > -1) count++;
            first = false;
            if (elts) {
                if (cellStart > -1) parseCell();
                elts.push(cx.elt("TableDelimiter", i + offset, i + offset + 1));
            }
            cellStart = cellEnd = -1;
        } else if (esc || next != 32 && next != 9) {
            if (cellStart < 0) cellStart = i;
            cellEnd = i + 1;
        }
        esc = !esc && next == 92;
    }
    if (cellStart > -1) {
        count++;
        if (elts) parseCell();
    }
    return count;
}
function $3856c2988d28a302$var$hasPipe(str, start) {
    for(let i = start; i < str.length; i++){
        let next = str.charCodeAt(i);
        if (next == 124 /* '|' */ ) return true;
        if (next == 92 /* '\\' */ ) i++;
    }
    return false;
}
const $3856c2988d28a302$var$delimiterLine = /^\|?(\s*:?-+:?\s*\|)+(\s*:?-+:?\s*)?$/;
class $3856c2988d28a302$var$TableParser {
    nextLine(cx, line, leaf) {
        if (this.rows == null) {
            this.rows = false;
            let lineText;
            if ((line.next == 45 || line.next == 58 || line.next == 124 /* '-:|' */ ) && $3856c2988d28a302$var$delimiterLine.test(lineText = line.text.slice(line.pos))) {
                let firstRow = [], firstCount = $3856c2988d28a302$var$parseRow(cx, leaf.content, 0, firstRow, leaf.start);
                if (firstCount == $3856c2988d28a302$var$parseRow(cx, lineText, line.pos)) this.rows = [
                    cx.elt("TableHeader", leaf.start, leaf.start + leaf.content.length, firstRow),
                    cx.elt("TableDelimiter", cx.lineStart + line.pos, cx.lineStart + line.text.length)
                ];
            }
        } else if (this.rows) {
            let content = [];
            $3856c2988d28a302$var$parseRow(cx, line.text, line.pos, content, cx.lineStart);
            this.rows.push(cx.elt("TableRow", cx.lineStart + line.pos, cx.lineStart + line.text.length, content));
        }
        return false;
    }
    finish(cx, leaf) {
        if (!this.rows) return false;
        cx.addLeafElement(leaf, cx.elt("Table", leaf.start, leaf.start + leaf.content.length, this.rows));
        return true;
    }
    constructor(){
        // Null means we haven't seen the second line yet, false means this
        // isn't a table, and an array means this is a table and we've
        // parsed the given rows so far.
        this.rows = null;
    }
}
/// This extension provides
/// [GFM-style](https://github.github.com/gfm/#tables-extension-)
/// tables, using syntax like this:
///
/// ```
/// | head 1 | head 2 |
/// | ---    | ---    |
/// | cell 1 | cell 2 |
/// ```
const $3856c2988d28a302$export$54ec01a60f47d33d = {
    defineNodes: [
        {
            name: "Table",
            block: true
        },
        {
            name: "TableHeader",
            style: {
                "TableHeader/...": (0, $lhXhg.tags).heading
            }
        },
        "TableRow",
        {
            name: "TableCell",
            style: (0, $lhXhg.tags).content
        },
        {
            name: "TableDelimiter",
            style: (0, $lhXhg.tags).processingInstruction
        }
    ],
    parseBlock: [
        {
            name: "Table",
            leaf (_, leaf) {
                return $3856c2988d28a302$var$hasPipe(leaf.content, 0) ? new $3856c2988d28a302$var$TableParser : null;
            },
            endLeaf (cx, line, leaf) {
                if (leaf.parsers.some((p)=>p instanceof $3856c2988d28a302$var$TableParser) || !$3856c2988d28a302$var$hasPipe(line.text, line.basePos)) return false;
                let next = cx.peekLine();
                return $3856c2988d28a302$var$delimiterLine.test(next) && $3856c2988d28a302$var$parseRow(cx, line.text, line.basePos) == $3856c2988d28a302$var$parseRow(cx, next, line.basePos);
            },
            before: "SetextHeading"
        }
    ]
};
class $3856c2988d28a302$var$TaskParser {
    nextLine() {
        return false;
    }
    finish(cx, leaf) {
        cx.addLeafElement(leaf, cx.elt("Task", leaf.start, leaf.start + leaf.content.length, [
            cx.elt("TaskMarker", leaf.start, leaf.start + 3),
            ...cx.parser.parseInline(leaf.content.slice(3), leaf.start + 3)
        ]));
        return true;
    }
}
/// Extension providing
/// [GFM-style](https://github.github.com/gfm/#task-list-items-extension-)
/// task list items, where list items can be prefixed with `[ ]` or
/// `[x]` to add a checkbox.
const $3856c2988d28a302$export$771a55a10b0a40ae = {
    defineNodes: [
        {
            name: "Task",
            block: true,
            style: (0, $lhXhg.tags).list
        },
        {
            name: "TaskMarker",
            style: (0, $lhXhg.tags).atom
        }
    ],
    parseBlock: [
        {
            name: "TaskList",
            leaf (cx, leaf) {
                return /^\[[ xX]\][ \t]/.test(leaf.content) && cx.parentType().name == "ListItem" ? new $3856c2988d28a302$var$TaskParser : null;
            },
            after: "SetextHeading"
        }
    ]
};
const $3856c2988d28a302$var$autolinkRE = /(www\.)|(https?:\/\/)|([\w.+-]{1,100}@)|(mailto:|xmpp:)/gy;
const $3856c2988d28a302$var$urlRE = /[\w-]+(\.[\w-]+)+(\/[^\s<]*)?/gy;
const $3856c2988d28a302$var$lastTwoDomainWords = /[\w-]+\.[\w-]+($|\/)/;
const $3856c2988d28a302$var$emailRE = /[\w.+-]+@[\w-]+(\.[\w.-]+)+/gy;
const $3856c2988d28a302$var$xmppResourceRE = /\/[a-zA-Z\d@.]+/gy;
function $3856c2988d28a302$var$count(str, from, to, ch) {
    let result = 0;
    for(let i = from; i < to; i++)if (str[i] == ch) result++;
    return result;
}
function $3856c2988d28a302$var$autolinkURLEnd(text, from) {
    $3856c2988d28a302$var$urlRE.lastIndex = from;
    let m = $3856c2988d28a302$var$urlRE.exec(text);
    if (!m || $3856c2988d28a302$var$lastTwoDomainWords.exec(m[0])[0].indexOf("_") > -1) return -1;
    let end = from + m[0].length;
    for(;;){
        let last = text[end - 1], m;
        if (/[?!.,:*_~]/.test(last) || last == ")" && $3856c2988d28a302$var$count(text, from, end, ")") > $3856c2988d28a302$var$count(text, from, end, "(")) end--;
        else if (last == ";" && (m = /&(?:#\d+|#x[a-f\d]+|\w+);$/.exec(text.slice(from, end)))) end = from + m.index;
        else break;
    }
    return end;
}
function $3856c2988d28a302$var$autolinkEmailEnd(text, from) {
    $3856c2988d28a302$var$emailRE.lastIndex = from;
    let m = $3856c2988d28a302$var$emailRE.exec(text);
    if (!m) return -1;
    let last = m[0][m[0].length - 1];
    return last == "_" || last == "-" ? -1 : from + m[0].length - (last == "." ? 1 : 0);
}
/// Extension that implements autolinking for
/// `www.`/`http://`/`https://`/`mailto:`/`xmpp:` URLs and email
/// addresses.
const $3856c2988d28a302$export$301ee04814c00038 = {
    parseInline: [
        {
            name: "Autolink",
            parse (cx, next, absPos) {
                let pos = absPos - cx.offset;
                if (pos && /\w/.test(cx.text[pos - 1])) return -1;
                $3856c2988d28a302$var$autolinkRE.lastIndex = pos;
                let m = $3856c2988d28a302$var$autolinkRE.exec(cx.text), end = -1;
                if (!m) return -1;
                if (m[1] || m[2]) {
                    end = $3856c2988d28a302$var$autolinkURLEnd(cx.text, pos + m[0].length);
                    if (end > -1 && cx.hasOpenLink) {
                        let noBracket = /([^\[\]]|\[[^\]]*\])*/.exec(cx.text.slice(pos, end));
                        end = pos + noBracket[0].length;
                    }
                } else if (m[3]) end = $3856c2988d28a302$var$autolinkEmailEnd(cx.text, pos);
                else {
                    end = $3856c2988d28a302$var$autolinkEmailEnd(cx.text, pos + m[0].length);
                    if (end > -1 && m[0] == "xmpp:") {
                        $3856c2988d28a302$var$xmppResourceRE.lastIndex = end;
                        m = $3856c2988d28a302$var$xmppResourceRE.exec(cx.text);
                        if (m) end = m.index + m[0].length;
                    }
                }
                if (end < 0) return -1;
                cx.addElement(cx.elt("URL", absPos, end + cx.offset));
                return end + cx.offset;
            }
        }
    ]
};
/// Extension bundle containing [`Table`](#Table),
/// [`TaskList`](#TaskList), [`Strikethrough`](#Strikethrough), and
/// [`Autolink`](#Autolink).
const $3856c2988d28a302$export$66557cc892d8d012 = [
    $3856c2988d28a302$export$54ec01a60f47d33d,
    $3856c2988d28a302$export$771a55a10b0a40ae,
    $3856c2988d28a302$export$53f33388b3b5115f,
    $3856c2988d28a302$export$301ee04814c00038
];
function $3856c2988d28a302$var$parseSubSuper(ch, node, mark) {
    return (cx, next, pos)=>{
        if (next != ch || cx.char(pos + 1) == ch) return -1;
        let elts = [
            cx.elt(mark, pos, pos + 1)
        ];
        for(let i = pos + 1; i < cx.end; i++){
            let next = cx.char(i);
            if (next == ch) return cx.addElement(cx.elt(node, pos, i + 1, elts.concat(cx.elt(mark, i, i + 1))));
            if (next == 92 /* '\\' */ ) elts.push(cx.elt("Escape", i, i++ + 2));
            if ($3856c2988d28a302$var$space(next)) break;
        }
        return -1;
    };
}
/// Extension providing
/// [Pandoc-style](https://pandoc.org/MANUAL.html#superscripts-and-subscripts)
/// superscript using `^` markers.
const $3856c2988d28a302$export$a4eac561e2e9d419 = {
    defineNodes: [
        {
            name: "Superscript",
            style: (0, $lhXhg.tags).special((0, $lhXhg.tags).content)
        },
        {
            name: "SuperscriptMark",
            style: (0, $lhXhg.tags).processingInstruction
        }
    ],
    parseInline: [
        {
            name: "Superscript",
            parse: $3856c2988d28a302$var$parseSubSuper(94 /* '^' */ , "Superscript", "SuperscriptMark")
        }
    ]
};
/// Extension providing
/// [Pandoc-style](https://pandoc.org/MANUAL.html#superscripts-and-subscripts)
/// subscript using `~` markers.
const $3856c2988d28a302$export$54eb3b8088f84d2b = {
    defineNodes: [
        {
            name: "Subscript",
            style: (0, $lhXhg.tags).special((0, $lhXhg.tags).content)
        },
        {
            name: "SubscriptMark",
            style: (0, $lhXhg.tags).processingInstruction
        }
    ],
    parseInline: [
        {
            name: "Subscript",
            parse: $3856c2988d28a302$var$parseSubSuper(126 /* '~' */ , "Subscript", "SubscriptMark")
        }
    ]
};
/// Extension that parses two colons with only letters, underscores,
/// and numbers between them as `Emoji` nodes.
const $3856c2988d28a302$export$56cc48506ff790a = {
    defineNodes: [
        {
            name: "Emoji",
            style: (0, $lhXhg.tags).character
        }
    ],
    parseInline: [
        {
            name: "Emoji",
            parse (cx, next, pos) {
                let match;
                if (next != 58 /* ':' */  || !(match = /^[a-zA-Z_0-9]+:/.exec(cx.slice(pos + 1, cx.end)))) return -1;
                return cx.addElement(cx.elt("Emoji", pos, pos + 1 + match[0].length));
            }
        }
    ]
};
module.exports["MarkdownParser"] = $3856c2988d28a302$export$a64f782182dea128;
module.exports["parser"] = $3856c2988d28a302$export$8f49e4af10703ce3;
module.exports["parseCode"] = $3856c2988d28a302$export$2d8e3d567a97292a;
module.exports["GFM"] = $3856c2988d28a302$export$66557cc892d8d012;
module.exports["Superscript"] = $3856c2988d28a302$export$a4eac561e2e9d419;
module.exports["Subscript"] = $3856c2988d28a302$export$54eb3b8088f84d2b;
module.exports["Emoji"] = $3856c2988d28a302$export$56cc48506ff790a;

});

parcelRegister("czp8P", function(module, exports) {
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $185ef2202d608231$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $185ef2202d608231$export$aa000893c5e2b9c2[hexColor.toUpperCase()];
}
const $185ef2202d608231$export$aa000893c5e2b9c2 = {
    // gray
    /** gray - subtle */ ['#091E4224']: "var(--ds-border, #0B120E24)",
    /** gray */ ['#758195']: "var(--ds-border-bold, #7D818A)",
    /** gray - bold */ ['#172B4D']: "var(--ds-text, #292A2E)"
};
module.exports["hexToEditorBorderPaletteColor"] = $185ef2202d608231$export$bad3c41dd33cb4bc;

});

parcelRegister("1SZMn", function(module, exports) {
var $420fd782fb031b11$export$ecd1fed429542b49 = /*#__PURE__*/ function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
    return RESOLVE_METHOD;
}({});
var $420fd782fb031b11$export$9cf3651d97128b9c = /*#__PURE__*/ function(VIEW_METHOD) {
    VIEW_METHOD["BADGE"] = "badge";
    VIEW_METHOD["COMMENT_BUTTON"] = "commentButton";
    return VIEW_METHOD;
}({});
module.exports["RESOLVE_METHOD"] = $420fd782fb031b11$export$ecd1fed429542b49;
module.exports["VIEW_METHOD"] = $420fd782fb031b11$export$9cf3651d97128b9c;

});

parcelRegister("294Sp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $eDtFr = parcelRequire("eDtFr");


var $kh0hi = parcelRequire("kh0hi");

var $buxP3 = parcelRequire("buxP3");


var $lpNn5 = parcelRequire("lpNn5");


var $ImNkk = parcelRequire("ImNkk");

const $55b84b299399ca35$var$baseStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.small'
});
const $55b84b299399ca35$var$mediumBadgeStyles = (0, $buxP3.xcss)({
    height: 'space.300',
    width: 'space.300'
});
const $55b84b299399ca35$export$d5da84b0136a0cc4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { status: t1, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave } = t0;
    const status = t1 === undefined ? "default" : t1;
    const intl = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== intl) {
        t2 = intl.formatMessage((0, $ImNkk.commentMessages).viewCommentsOnMedia);
        $[0] = intl;
        $[1] = t2;
    } else t2 = $[1];
    const title = t2;
    let t3;
    bb0: switch(status){
        case "active":
            t3 = "color.background.accent.yellow.subtlest.pressed";
            break bb0;
        case "entered":
            t3 = "color.background.accent.yellow.subtlest.hovered";
            break bb0;
        default:
            t3 = "color.background.accent.yellow.subtlest";
    }
    const colourToken = t3;
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = [
            $55b84b299399ca35$var$baseStyles,
            $55b84b299399ca35$var$mediumBadgeStyles
        ];
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== title) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
            label: title,
            spacing: "spacious",
            color: "currentColor"
        });
        $[3] = title;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== colourToken || $[6] !== onClick || $[7] !== onMouseEnter || $[8] !== onMouseLeave || $[9] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
            xcss: t4,
            padding: "space.0",
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            backgroundColor: colourToken
        }, t5);
        $[5] = colourToken;
        $[6] = onClick;
        $[7] = onMouseEnter;
        $[8] = onMouseLeave;
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== t6 || $[12] !== title) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            position: "top",
            content: title
        }, t6);
        $[11] = t6;
        $[12] = title;
        $[13] = t7;
    } else t7 = $[13];
    return t7;
} : ({ status: status = 'default', onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave })=>{
    const intl = (0, $kSwu1.useIntl)();
    const title = intl.formatMessage((0, $ImNkk.commentMessages).viewCommentsOnMedia);
    const colourToken = (0, $cozmU.useMemo)(()=>{
        switch(status){
            case 'active':
                return 'color.background.accent.yellow.subtlest.pressed';
            case 'entered':
                return 'color.background.accent.yellow.subtlest.hovered';
            default:
                return 'color.background.accent.yellow.subtlest';
        }
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: "top",
        content: title
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        xcss: [
            $55b84b299399ca35$var$baseStyles,
            $55b84b299399ca35$var$mediumBadgeStyles
        ],
        padding: "space.0",
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        backgroundColor: colourToken
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
        label: title,
        spacing: "spacious",
        color: "currentColor"
    })));
};
module.exports["CommentBadgeNext"] = $55b84b299399ca35$export$d5da84b0136a0cc4;

});

parcelRegister("ImNkk", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a3dbe84aa3c3621f$export$4c0d145df60cfb04 = (0, $kSwu1.defineMessages)({
    addCommentOnMedia: {
        id: "fabric.editor.addCommentOnMedia",
        defaultMessage: "Add comment"
    },
    viewCommentsOnMedia: {
        id: "fabric.editor.viewCommentOnMedia",
        defaultMessage: "View comments"
    },
    viewAndAddCommentsOnMedia: {
        id: "fabric.editor.viewAndAddCommentsOnMedia",
        defaultMessage: "View and add comments"
    }
});
module.exports["commentMessages"] = $a3dbe84aa3c3621f$export$4c0d145df60cfb04;

});

parcelRegister("2G2MI", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fodiz = parcelRequire("fodiz");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");


var $ieeJu = parcelRequire("ieeJu");


var $lpNn5 = parcelRequire("lpNn5");


var $gR535 = parcelRequire("gR535");

const $ccec193f181caf27$var$baseStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.small',
    backgroundColor: 'elevation.surface',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-200, 16px)",
    cursor: 'pointer'
});
const $ccec193f181caf27$var$NO_EXTERNAL_BADGE_HOSTS = [
    'atlassian.com',
    'loom.com',
    'dam-cdn.atl.orangelogic.com'
];
const $ccec193f181caf27$var$NO_EXTERNAL_BADGE_HOSTS_NEW = [
    'atlassian.com',
    'loom.com',
    'dam-cdn.atl.orangelogic.com',
    'bitbucket.org'
];
const $ccec193f181caf27$export$babb68fb5c212c90 = (url)=>{
    if (!url) return false;
    // Check if URL is valid
    try {
        new URL(url);
    } catch  {
        return false;
    }
    const parsedUrl = new URL(url || '');
    const { hostname: hostname, pathname: pathname, protocol: protocol } = parsedUrl;
    if (protocol === 'data:') return pathname?.startsWith('image/');
    if ((0, $ieeJu.expValEquals)('platform_editor_media_external_badge_bbc_fix', 'isEnable', true)) return Boolean(hostname && $ccec193f181caf27$var$NO_EXTERNAL_BADGE_HOSTS_NEW.some((host)=>hostname === host || hostname.endsWith(`.${host}`)));
    return Boolean(hostname && $ccec193f181caf27$var$NO_EXTERNAL_BADGE_HOSTS.some((host)=>hostname === host || hostname.endsWith(`.${host}`)));
};
const $ccec193f181caf27$export$66bf2ed7a5d4691f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { type: type, url: url } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== intl) {
        t1 = intl.formatMessage((0, $gR535.externalMediaMessages).externalMediaFile);
        $[0] = intl;
        $[1] = t1;
    } else t1 = $[1];
    const message = t1;
    if (type !== "external" || $ccec193f181caf27$export$babb68fb5c212c90(url)) return null;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "external-image-badge"
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== message) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
            label: message
        });
        $[3] = message;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== message || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            padding: "space.050",
            xcss: $ccec193f181caf27$var$baseStyles,
            tabIndex: 0
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: message,
            position: "top"
        }, t3));
        $[5] = message;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ type: type, url: url })=>{
    const intl = (0, $kSwu1.useIntl)();
    const message = intl.formatMessage((0, $gR535.externalMediaMessages).externalMediaFile);
    if (type !== 'external' || $ccec193f181caf27$export$babb68fb5c212c90(url)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        padding: "space.050",
        xcss: $ccec193f181caf27$var$baseStyles,
        tabIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "external-image-badge"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: message,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
        label: message
    })));
};
module.exports["ExternalImageBadge"] = $ccec193f181caf27$export$66bf2ed7a5d4691f;

});

parcelRegister("gR535", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $211a5f48c385cec9$export$8e36294abfabe45e = (0, $kSwu1.defineMessages)({
    externalMediaFile: {
        id: "fabric.editor.externalMediaFile",
        defaultMessage: "External media file"
    }
});
module.exports["externalMediaMessages"] = $211a5f48c385cec9$export$8e36294abfabe45e;

});

parcelRegister("7UxJ0", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $55fM8 = parcelRequire("55fM8");


var $ixfCV = parcelRequire("ixfCV");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");

const $a2c23c75d9cad129$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT = 200;
const $a2c23c75d9cad129$var$containerStyles = (0, $buxP3.xcss)({
    display: 'flex',
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-200, 16px)",
    gap: 'space.025',
    zIndex: 'card',
    height: 'fit-content',
    width: 'fit-content',
    margin: 'space.075'
});
// The above styles are used for both editor and renderer, and in renderer the
// document body is the main scroll area. This means it overscrolls the primary
// toolbar, where the z-index is "2". We have to hack in our own z-index less
// than that to ensure our badge appears under the toolbar when scrolled.
const $a2c23c75d9cad129$var$hackedZIndexStyles = (0, $buxP3.xcss)({
    // @ts-ignore
    zIndex: '1'
});
const $a2c23c75d9cad129$var$resizeOffsetStyles = (0, $buxP3.xcss)({
    right: 'space.150'
});
const $a2c23c75d9cad129$var$getBadgeVisible = (width, height)=>{
    return width && width < $a2c23c75d9cad129$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT || height && height < $a2c23c75d9cad129$var$MEDIA_BADGE_VISIBILITY_BREAKPOINT ? false : true;
};
const $a2c23c75d9cad129$export$6a31fc38737d0e58 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    let { children: children, mediaElement: mediaElement, mediaWidth: mediaWidth, mediaHeight: mediaHeight, extendedResizeOffset: extendedResizeOffset, useMinimumZIndex: t1 } = t0;
    const useMinimumZIndex = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== mediaHeight || $[1] !== mediaWidth) {
        t2 = $a2c23c75d9cad129$var$getBadgeVisible(mediaWidth, mediaHeight);
        $[0] = mediaHeight;
        $[1] = mediaWidth;
        $[2] = t2;
    } else t2 = $[2];
    const [visible, setVisible] = (0, $cozmU.useState)(t2);
    let t3;
    let t4;
    if ($[3] !== mediaElement) {
        t3 = ()=>{
            const observer = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))((entries)=>{
                const [entry] = entries;
                const { width: width, height: height } = entry.contentRect;
                setVisible($a2c23c75d9cad129$var$getBadgeVisible(width, height));
            }));
            if (mediaElement) observer.observe(mediaElement);
            return ()=>{
                observer.disconnect();
            };
        };
        t4 = [
            mediaElement
        ];
        $[3] = mediaElement;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $cozmU.useEffect)(t3, t4);
    if (typeof children === "function") {
        let t5;
        if ($[6] !== children || $[7] !== visible) {
            t5 = children({
                visible: visible
            });
            $[6] = children;
            $[7] = visible;
            $[8] = t5;
        } else t5 = $[8];
        children = t5;
    }
    if (!(0, $ixfCV.fg)("media-perf-uplift-mutation-fix")) {
        if (!mediaElement || (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) === 0) return null;
    }
    const t5 = useMinimumZIndex && $a2c23c75d9cad129$var$hackedZIndexStyles;
    const t6 = extendedResizeOffset && $a2c23c75d9cad129$var$resizeOffsetStyles;
    let t7;
    if ($[9] !== t5 || $[10] !== t6) {
        t7 = [
            $a2c23c75d9cad129$var$containerStyles,
            t5,
            t6
        ];
        $[9] = t5;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== children || $[13] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            as: "div",
            testId: "media-badges",
            "data-media-badges": "true",
            contentEditable: false,
            xcss: t7
        }, children);
        $[12] = children;
        $[13] = t7;
        $[14] = t8;
    } else t8 = $[14];
    return t8;
} : ({ children: children, mediaElement: mediaElement, mediaWidth: mediaWidth, mediaHeight: mediaHeight, extendedResizeOffset: extendedResizeOffset, useMinimumZIndex: useMinimumZIndex = false })=>{
    const [visible, setVisible] = (0, $cozmU.useState)($a2c23c75d9cad129$var$getBadgeVisible(mediaWidth, mediaHeight));
    (0, $cozmU.useEffect)(()=>{
        const observer = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))((entries)=>{
            const [entry] = entries;
            const { width: width, height: height } = entry.contentRect;
            setVisible($a2c23c75d9cad129$var$getBadgeVisible(width, height));
        }));
        if (mediaElement) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        observer.observe(mediaElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        mediaElement
    ]);
    if (typeof children === 'function') children = children({
        visible: visible
    });
    // delete this block on cleanup of media-perf-uplift-mutation-fix
    if (!(0, $ixfCV.fg)('media-perf-uplift-mutation-fix')) {
        // becuase it is wrapped in a fragment, React.Children.count(children) will always be 1.
        // That makes this check a source of late mutations that we don't need.
        if (!mediaElement || (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) === 0) return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        as: "div",
        testId: "media-badges",
        "data-media-badges": "true",
        contentEditable: false,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        xcss: [
            $a2c23c75d9cad129$var$containerStyles,
            useMinimumZIndex && $a2c23c75d9cad129$var$hackedZIndexStyles,
            extendedResizeOffset && $a2c23c75d9cad129$var$resizeOffsetStyles
        ]
    }, children);
};
module.exports["MediaBadges"] = $a2c23c75d9cad129$export$6a31fc38737d0e58;

});

parcelRegister("8TTbR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $j3UOY = parcelRequire("j3UOY");


var $gWRZb = parcelRequire("gWRZb");

const $75428e9db26defa4$var$DURATION_MIN = 0.5;
const $75428e9db26defa4$var$DURATION_MAX = 1.0;
const $75428e9db26defa4$var$EXTRA_PADDING = 4;
const $75428e9db26defa4$export$ba458cf715b18bd1 = {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true
};
const $75428e9db26defa4$export$9f2ec2b609810bce = 'media-filmstrip-list-item';
class $75428e9db26defa4$export$817db220b90d8024 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    get offset() {
        const { offset: offset } = this.props;
        if (!offset) return 0;
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    get minOffset() {
        return 0;
    }
    /**
   * The furthest we can scroll, where the end of the buffer is just in view
   */ get maxOffset() {
        const { bufferWidth: bufferWidth, windowWidth: windowWidth } = this.state;
        return Math.max(this.minOffset, bufferWidth - windowWidth - 1);
    }
    get canGoLeft() {
        return this.offset > this.minOffset;
    }
    get canGoRight() {
        return this.offset < this.maxOffset;
    }
    get transitionDuration() {
        const { animate: animate } = this.props;
        const { windowWidth: windowWidth } = this.state;
        if (!animate) return 0;
        if (Math.abs(this.offset - this.previousOffset) < 1e-6) return $75428e9db26defa4$var$DURATION_MIN;
        else {
            const diff = Math.abs(this.offset - this.previousOffset);
            const relativeOffset = diff / windowWidth;
            const duration = $75428e9db26defa4$var$DURATION_MAX - $75428e9db26defa4$var$DURATION_MIN * relativeOffset;
            return Math.max(Math.min(duration, $75428e9db26defa4$var$DURATION_MAX), $75428e9db26defa4$var$DURATION_MIN);
        }
    }
    initMutationObserver() {
        const { mutationObserver: mutationObserver } = this;
        if (mutationObserver && this.bufferElement) {
            mutationObserver.disconnect();
            mutationObserver.observe(this.bufferElement, $75428e9db26defa4$export$ba458cf715b18bd1);
        }
    }
    // find the child that is cut off on the left edge of the window and change the window offset to
    // start to the left of that child
    getClosestForLeft(offset) {
        const leftWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset));
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (leftWindowEdge >= childBounds.left && leftWindowEdge <= childBounds.right) {
                const newOffset = i === 0 ? childBounds.left : childBounds.right;
                if (newOffset >= $75428e9db26defa4$var$EXTRA_PADDING) return newOffset - $75428e9db26defa4$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    // find the child that is cut off on the right edge of the window and change the window offset
    // to finish at start of the next child
    getClosestForRight(offset) {
        const { windowWidth: windowWidth } = this.state;
        const rightWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset)) + windowWidth;
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (rightWindowEdge >= childBounds.left && rightWindowEdge <= childBounds.right) {
                const newOffset = (i === this.childOffsets.length - 1 ? childBounds.right : childBounds.left) - windowWidth;
                if (newOffset + $75428e9db26defa4$var$EXTRA_PADDING <= this.maxOffset) return newOffset + $75428e9db26defa4$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    renderLeftArrow() {
        const { canGoLeft: canGoLeft } = this;
        if (!canGoLeft) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.LeftArrow), {
            onClick: this.handleLeftClick
        });
    }
    renderRightArrow() {
        const { canGoRight: canGoRight } = this;
        if (!canGoRight) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.RightArrow), {
            onClick: this.handleRightClick
        });
    }
    componentDidMount() {
        this.previousOffset = this.offset;
        window.addEventListener('resize', this.handleSizeChange);
    }
    componentWillUnmount() {
        const { mutationObserver: mutationObserver } = this;
        window.removeEventListener('resize', this.handleSizeChange);
        if (mutationObserver) mutationObserver.disconnect();
    }
    componentDidUpdate() {
        this.previousOffset = this.offset;
    }
    render() {
        const { animate: animate, children: children, testId: testId } = this.props;
        const transform = `translateX(${-this.offset}px)`;
        const transitionProperty = animate ? 'transform' : 'none';
        const transitionDuration = `${this.transitionDuration}s`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.FilmStripViewWrapper), {
            "data-testid": testId
        }, this.renderLeftArrow(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.FilmStripListWrapper), {
            ref: this.handleWindowElementChange,
            onWheel: this.handleScroll,
            onTouchStart: this.handleTouchStart,
            onTouchMove: this.handleTouchMove,
            onTouchEnd: this.handleTouchEnd,
            "data-testid": "filmstrip-list-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.FilmStripList), {
            ref: this.handleBufferElementChange,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                transform: transform,
                transitionProperty: transitionProperty,
                transitionDuration: transitionDuration
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, $75428e9db26defa4$var$mapReactChildToReactNode))), this.renderRightArrow());
    }
    constructor(props){
        super(props);
        this.bufferElement = void 0;
        this.windowElement = void 0;
        this.mutationObserver = void 0;
        this.childOffsets = void 0;
        this.previousOffset = 0;
        this.state = {
            bufferWidth: 0,
            windowWidth: 0,
            touchMoveStartPosition: 0,
            isTouchMoveInProgress: false
        };
        this.handleSizeChange = ()=>{
            // get the new widths
            const { windowElement: windowElement, bufferElement: bufferElement } = this;
            let bufferWidth = 0;
            let windowWidth = 0;
            let childOffsets = [];
            if (windowElement && bufferElement) {
                bufferWidth = bufferElement.getBoundingClientRect().width;
                windowWidth = windowElement.getBoundingClientRect().width;
                // we're calculating `left` based on `width` because `rect.left` can be a negative value after resizing the window (considered scrolled??)
                const children = Array.prototype.slice.call(bufferElement.children, 0);
                let left = 0;
                childOffsets = children.map((child, _index)=>{
                    const width = child.getBoundingClientRect().width;
                    const offset = {
                        left: left,
                        right: left + width - 1
                    };
                    left += width;
                    return offset;
                });
            }
            // make sure the state has changed before we update state and notify the integrator
            // (otherwise, since this method() is called in componentDidUpdate() we'll recurse until the stack size is exceeded)
            const { bufferWidth: prevBufferWidth, windowWidth: prevWindowWidth } = this.state;
            if (bufferWidth === prevBufferWidth && windowWidth === prevWindowWidth) // NOTE: we're not checking here if childOffsets has changed... if the children change size but
            // result in the exact same size buffer, we're not going to update, resulting in incorrect navigations
            return;
            // store the widths
            this.setState({
                bufferWidth: bufferWidth,
                windowWidth: windowWidth
            }, ()=>{
                this.childOffsets = childOffsets;
                // notify the integrator
                const { onSize: onSize } = this.props;
                if (onSize) onSize({
                    offset: Math.min(this.maxOffset, this.offset),
                    offsets: childOffsets,
                    width: windowWidth,
                    minOffset: this.minOffset,
                    maxOffset: this.maxOffset
                });
            });
        };
        this.handleWindowElementChange = (windowElement)=>{
            this.windowElement = windowElement;
            this.handleSizeChange();
        };
        this.handleBufferElementChange = (bufferElement)=>{
            if (!bufferElement) return;
            this.bufferElement = bufferElement;
            this.handleSizeChange();
            this.initMutationObserver();
        };
        this.handleMutation = (_mutationList)=>{
            // there are edge cases where the DOM may change outside of the normal React life-cycle
            // https://product-fabric.atlassian.net/browse/MSW-425
            this.handleSizeChange();
        };
        this.handleLeftClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForLeft(this.offset - windowWidth);
                if (newOffset >= this.offset) // if for some reason we tried to scroll left but it didn't scroll or scrolls right instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.max(this.offset - windowWidth, this.minOffset);
                onScroll({
                    direction: 'left',
                    offset: newOffset,
                    animate: true
                });
            }
        };
        this.handleRightClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForRight(this.offset + windowWidth);
                if (newOffset <= this.offset) // if for some reason we tried to scroll right but it didn't scroll or scrolls left instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.min(this.offset + windowWidth, this.maxOffset);
                onScroll({
                    direction: 'right',
                    offset: newOffset,
                    animate: true
                });
            }
        };
        this.handleScroll = (event)=>{
            const isHorizontalScroll = Math.abs(event.deltaX) > Math.abs(event.deltaY);
            if (!isHorizontalScroll) return;
            // don't actually let the element scroll because we'll fake scrolling with `transform: translateX()`
            event.preventDefault();
            // notify the integrator of the offset change
            const { onScroll: onScroll } = this.props;
            if (onScroll && isHorizontalScroll) {
                const newOffset = Math.max(this.minOffset, Math.min(this.maxOffset, this.offset + event.deltaX));
                onScroll({
                    direction: event.deltaX < 0 ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.handleTouchStart = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: true
            });
        };
        this.handleTouchEnd = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: false
            });
        };
        this.handleTouchMove = (event)=>{
            const { onScroll: onScroll } = this.props;
            if (this.state.isTouchMoveInProgress && onScroll) {
                const currentPosition = event.touches[0].clientX;
                const newOffset = this.state.touchMoveStartPosition ? this.offset - (currentPosition - this.state.touchMoveStartPosition) : this.offset;
                onScroll({
                    direction: newOffset > this.offset ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.childOffsets = [];
        try {
            this.mutationObserver = new MutationObserver((0, (/*@__PURE__*/$parcel$interopDefault($j3UOY)))(this.handleMutation, 30, true));
        // eslint-disable-next-line no-unused-vars
        } catch (e) {
        // in the case where we are running on an unsupported browser,
        // or where tests include the FilmstripView but do not mock the MutationObserver - we catch it and handle safely here.
        // NOTE: this won't effect the component, it just means mutations won't be observerd
        }
    }
}
$75428e9db26defa4$export$817db220b90d8024.defaultProps = {
    animate: false,
    offset: 0
};
function $75428e9db26defa4$var$mapReactChildToReactNode(child, index) {
    const key = $75428e9db26defa4$var$isReactElement(child) && child.key || index;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.FilmStripListItem), {
        key: key,
        index: key
    }, child);
}
function $75428e9db26defa4$var$isReactElement(child) {
    return !!child.type;
}
module.exports["MediaFilmStripListItemSelector"] = $75428e9db26defa4$export$9f2ec2b609810bce;
module.exports["FilmstripView"] = $75428e9db26defa4$export$817db220b90d8024;

});

parcelRegister("j3UOY", function(module, exports) {
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ function $de0a5fa3d60c62bd$var$debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
    function later() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    }
    var debounced = function() {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    debounced.flush = function() {
        if (timeout) {
            result = func.apply(context, args);
            context = args = null;
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return debounced;
}
// Adds compatibility for ES modules
$de0a5fa3d60c62bd$var$debounce.debounce = $de0a5fa3d60c62bd$var$debounce;
module.exports = $de0a5fa3d60c62bd$var$debounce;

});

parcelRegister("gWRZb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jXJyv = parcelRequire("jXJyv");

const $8dba4ca83cef8f6b$export$924abd21043fc000 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ArrowLeftWrapper), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ArrowLeftWrapper), props);
const $8dba4ca83cef8f6b$export$a5ffe38c17bbc0a1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ShadowRight), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ShadowRight), props);
const $8dba4ca83cef8f6b$export$abf07652016c7e56 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ArrowRightWrapper), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ArrowRightWrapper), props);
const $8dba4ca83cef8f6b$export$b39b1b86b48b621f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.LeftArrow), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.LeftArrow), props);
const $8dba4ca83cef8f6b$export$6208675820d4cc50 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.RightArrow), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.RightArrow), props);
const $8dba4ca83cef8f6b$export$d37eb83491863cbb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripViewWrapper), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripViewWrapper), props);
const $8dba4ca83cef8f6b$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripListWrapper), {
            ...props,
            ref: ref
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripListWrapper), {
        ...props,
        ref: ref
    }));
const $8dba4ca83cef8f6b$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripList), {
            ...props,
            ref: ref
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripList), {
        ...props,
        ref: ref
    }));
const $8dba4ca83cef8f6b$export$54cfc70c184c0713 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripListItem), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripListItem), props);
module.exports["LeftArrow"] = $8dba4ca83cef8f6b$export$b39b1b86b48b621f;
module.exports["RightArrow"] = $8dba4ca83cef8f6b$export$6208675820d4cc50;
module.exports["FilmStripViewWrapper"] = $8dba4ca83cef8f6b$export$d37eb83491863cbb;
module.exports["FilmStripListWrapper"] = $8dba4ca83cef8f6b$export$4b7fe5339e3afada;
module.exports["FilmStripList"] = $8dba4ca83cef8f6b$export$710ee13c74b7a1f0;
module.exports["FilmStripListItem"] = $8dba4ca83cef8f6b$export$54cfc70c184c0713;

});

parcelRegister("jXJyv", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kdlgT = parcelRequire("kdlgT");


var $aRvnq = parcelRequire("aRvnq");


var $8TTbR = parcelRequire("8TTbR");


var $ixfCV = parcelRequire("ixfCV");

const $b735c99c0da4e1ae$var$filmStripViewStyles = null;
const $b735c99c0da4e1ae$var$filmStripListWrapperStyles = null;
const $b735c99c0da4e1ae$var$filmStripListStyles = null;
const $b735c99c0da4e1ae$var$filmStripListItemStyles = null;
const $b735c99c0da4e1ae$var$arrowWrapperStyles = null;
const $b735c99c0da4e1ae$var$arrowLeftWrapperStyles = null;
const $b735c99c0da4e1ae$var$arrowRightWrapperStyles = null;
const $b735c99c0da4e1ae$var$shadowStyles = null;
const $b735c99c0da4e1ae$var$resetButtonStyle = null;
const $b735c99c0da4e1ae$var$shadowLeftStyles = null;
const $b735c99c0da4e1ae$var$shadowRightStyles = null;
const $b735c99c0da4e1ae$var$ShadowLeft = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_kqswstnw _1pbyzo7u _4t3i1osq _154iidpf _1bsbyh40 _bfhk1l7x",
            "_1ltvidpf"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_kqswstnw _1pbyzo7u _4t3i1osq _154iidpf _1bsbyh40 _bfhk1l7x",
            "_1ltvidpf"
        ])
    }, children);
const $b735c99c0da4e1ae$export$924abd21043fc000 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, onClick: onClick } = t0;
    let t1;
    if ($[0] !== children || $[1] !== onClick) {
        t1 = (0, $ixfCV.fg)("platform_media_a11y_suppression_fixes") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
            className: (0, $hekY6.default)([
                "_kkk2n7od _1e0c1ule",
                "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs130s _syaz1q3r _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3azsu _irr36o2t _9h8h6x5g _1di615s3",
                "_1ltvu2gc _uhasv77o",
                "arrow"
            ]),
            onClick: (event)=>onClick && onClick(event)
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs130s _syaz1q3r _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3azsu _irr36o2t _9h8h6x5g _1di615s3",
                "_1ltvu2gc _uhasv77o",
                "arrow"
            ]),
            onClick: onClick
        }, children);
        $[0] = children;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children, onClick: onClick })=>{
    return (0, $ixfCV.fg)('platform_media_a11y_suppression_fixes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            "_kkk2n7od _1e0c1ule",
            "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs130s _syaz1q3r _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3azsu _irr36o2t _9h8h6x5g _1di615s3",
            "_1ltvu2gc _uhasv77o",
            "arrow"
        ]),
        onClick: (event)=>onClick && onClick(event)
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs130s _syaz1q3r _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3azsu _irr36o2t _9h8h6x5g _1di615s3",
            "_1ltvu2gc _uhasv77o",
            "arrow"
        ]),
        onClick: onClick
    }, children);
};
const $b735c99c0da4e1ae$export$a5ffe38c17bbc0a1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_kqswstnw _1pbyzo7u _4t3i1osq _154iidpf _1bsbyh40 _bfhk1l7x",
            "_1xi2idpf"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_kqswstnw _1pbyzo7u _4t3i1osq _154iidpf _1bsbyh40 _bfhk1l7x",
            "_1xi2idpf"
        ])
    }, children);
const $b735c99c0da4e1ae$export$abf07652016c7e56 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, onClick: onClick } = t0;
    let t1;
    if ($[0] !== children || $[1] !== onClick) {
        t1 = (0, $ixfCV.fg)("platform_media_a11y_suppression_fixes") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
            className: (0, $hekY6.default)([
                "_kkk2n7od _1e0c1ule",
                "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs130s _syaz1q3r _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3azsu _irr36o2t _9h8h6x5g _1di615s3",
                "_1xi2u2gc _7wy9v77o",
                "arrow"
            ]),
            onClick: (event)=>onClick && onClick(event)
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs130s _syaz1q3r _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3azsu _irr36o2t _9h8h6x5g _1di615s3",
                "_1xi2u2gc _7wy9v77o",
                "arrow"
            ]),
            onClick: onClick
        }, children);
        $[0] = children;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children, onClick: onClick })=>{
    return (0, $ixfCV.fg)('platform_media_a11y_suppression_fixes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            "_kkk2n7od _1e0c1ule",
            "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs130s _syaz1q3r _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3azsu _irr36o2t _9h8h6x5g _1di615s3",
            "_1xi2u2gc _7wy9v77o",
            "arrow"
        ]),
        onClick: (event)=>onClick && onClick(event)
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            "_2rko1rr0 _v564g17y _kqswstnw _154i1ssb _t9ec1i34 _bfhk1bhr _1e0c1txw _80omtlke _16qs130s _syaz1q3r _1bsb1ul9 _4t3i1ul9 _1bah1h6o _tzy4idpf _17521ul9 _w8l5gktf _30l3azsu _irr36o2t _9h8h6x5g _1di615s3",
            "_1xi2u2gc _7wy9v77o",
            "arrow"
        ]),
        onClick: onClick
    }, children);
};
const $b735c99c0da4e1ae$export$b39b1b86b48b621f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { onClick: onClick } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))), {
            color: "currentColor",
            spacing: "spacious",
            label: "left"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== onClick) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$var$ShadowLeft, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$924abd21043fc000, {
            onClick: onClick
        }, t1));
        $[1] = onClick;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$var$ShadowLeft, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$924abd21043fc000, {
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))), {
        color: "currentColor",
        spacing: "spacious",
        label: "left"
    })));
const $b735c99c0da4e1ae$export$6208675820d4cc50 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { onClick: onClick } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
            color: "currentColor",
            spacing: "spacious",
            label: "right"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== onClick) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$a5ffe38c17bbc0a1, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$abf07652016c7e56, {
            onClick: onClick
        }, t1));
        $[1] = onClick;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$a5ffe38c17bbc0a1, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$abf07652016c7e56, {
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
        color: "currentColor",
        spacing: "spacious",
        label: "right"
    })));
const $b735c99c0da4e1ae$export$d37eb83491863cbb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, "data-testid": dataTestId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_2rkofajl _kqswh2mm _ca0qv77o _u5f3idpf _n3tdv77o _19bvidpf _1yqxkb7n _1ajs4jg8"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== dataTestId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": dataTestId,
            className: t1
        }, children);
        $[1] = children;
        $[2] = dataTestId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ children: children, 'data-testid': dataTestId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": dataTestId,
        className: (0, $hekY6.default)([
            "_2rkofajl _kqswh2mm _ca0qv77o _u5f3idpf _n3tdv77o _19bvidpf _1yqxkb7n _1ajs4jg8"
        ])
    }, children);
const $b735c99c0da4e1ae$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(9);
    const { children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, "data-testid": dataTestId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1reo15vq _18m915vq _1bsb1kw7 _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== dataTestId || $[3] !== onTouchEnd || $[4] !== onTouchMove || $[5] !== onTouchStart || $[6] !== onWheel || $[7] !== ref) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: ref,
            onWheel: onWheel,
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd,
            "data-testid": dataTestId,
            className: t1
        }, children);
        $[1] = children;
        $[2] = dataTestId;
        $[3] = onTouchEnd;
        $[4] = onTouchMove;
        $[5] = onTouchStart;
        $[6] = onWheel;
        $[7] = ref;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, 'data-testid': dataTestId }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref,
        onWheel: onWheel,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        "data-testid": dataTestId,
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _1bsb1kw7 _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o"
        ])
    }, children));
const $b735c99c0da4e1ae$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, style: style } = t0;
    const t1 = ref;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _k8m01e03 _6fl41kli _o5721q9c _1e0c1o8l"
        ]);
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== children || $[2] !== style || $[3] !== t1) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
            ref: t1,
            style: style,
            className: t2
        }, children);
        $[1] = children;
        $[2] = style;
        $[3] = t1;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ children: children, style: style }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
        ref: ref,
        style: style,
        className: (0, $hekY6.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qgrf3 _u5f3grf3 _n3tdgrf3 _19bvgrf3 _k8m01e03 _6fl41kli _o5721q9c _1e0c1o8l"
        ])
    }, children));
const $b735c99c0da4e1ae$export$54cfc70c184c0713 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, index: index } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _2mzuglyw _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _1e0c1o8l _s7n4nkob _1wybidpf _1lhcidpf",
            (0, $8TTbR.MediaFilmStripListItemSelector)
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== index) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
            className: t1,
            "data-testid": "media-filmstrip-list-item",
            key: index
        }, children);
        $[1] = children;
        $[2] = index;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ children: children, index: index })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _2mzuglyw _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _1e0c1o8l _s7n4nkob _1wybidpf _1lhcidpf",
            (0, $8TTbR.MediaFilmStripListItemSelector)
        ]),
        "data-testid": "media-filmstrip-list-item",
        key: index
    }, children);
module.exports["ArrowLeftWrapper"] = $b735c99c0da4e1ae$export$924abd21043fc000;
module.exports["ShadowRight"] = $b735c99c0da4e1ae$export$a5ffe38c17bbc0a1;
module.exports["ArrowRightWrapper"] = $b735c99c0da4e1ae$export$abf07652016c7e56;
module.exports["LeftArrow"] = $b735c99c0da4e1ae$export$b39b1b86b48b621f;
module.exports["RightArrow"] = $b735c99c0da4e1ae$export$6208675820d4cc50;
module.exports["FilmStripViewWrapper"] = $b735c99c0da4e1ae$export$d37eb83491863cbb;
module.exports["FilmStripListWrapper"] = $b735c99c0da4e1ae$export$4b7fe5339e3afada;
module.exports["FilmStripList"] = $b735c99c0da4e1ae$export$710ee13c74b7a1f0;
module.exports["FilmStripListItem"] = $b735c99c0da4e1ae$export$54cfc70c184c0713;

});

parcelRegister("3Uz4b", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gOi68 = parcelRequire("gOi68");


var $lNvN4 = parcelRequire("lNvN4");


var $4fGOw = parcelRequire("4fGOw");


var $kJaAu = parcelRequire("kJaAu");

const $d2b956a25eda15ad$var$areFilesPotentiallyDuplicated = (file1, file2)=>file1.status === file2.status && file1.name === file2.name && file1.size === file2.size && file1.mimeType === file2.mimeType && file1.id !== file2.id;
const $d2b956a25eda15ad$export$f91c9e51e5ab027d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useFileHashes(ids) {
    const $ = (0, $bDgLe.c)(15);
    const nonErrorFiles = (0, $4fGOw.useMediaStore)($d2b956a25eda15ad$var$_temp);
    const mediaClient = (0, $lNvN4.useMediaClient)();
    let t0;
    if ($[0] !== ids) {
        t0 = Object.fromEntries(ids.map($d2b956a25eda15ad$var$_temp2));
        $[0] = ids;
        $[1] = t0;
    } else t0 = $[1];
    const collections = t0;
    let t1;
    if ($[2] !== ids || $[3] !== nonErrorFiles) {
        let t2;
        if ($[5] !== ids) {
            t2 = (file)=>ids.some((t3)=>{
                    const { id: id_0 } = t3;
                    return file.id === id_0;
                });
            $[5] = ids;
            $[6] = t2;
        } else t2 = $[6];
        t1 = nonErrorFiles.filter(t2);
        $[2] = ids;
        $[3] = nonErrorFiles;
        $[4] = t1;
    } else t1 = $[4];
    const files = t1;
    const prevFiles = (0, $kJaAu.usePrevious)(files);
    let t2;
    let t3;
    if ($[7] !== collections || $[8] !== files || $[9] !== mediaClient || $[10] !== prevFiles) {
        t2 = ()=>{
            const prev = prevFiles ?? [];
            const addedOrChangedFiles = files.filter((file_0)=>file_0 && prev.every((prevFile)=>prevFile.id !== file_0.id || prevFile.status !== file_0.status));
            const potentialDuplicates = files.filter((file_1)=>addedOrChangedFiles.some((addedFile)=>$d2b956a25eda15ad$var$areFilesPotentiallyDuplicated(file_1, addedFile)));
            if (potentialDuplicates.length) [
                ...addedOrChangedFiles,
                ...potentialDuplicates
            ].forEach((file_2)=>{
                const collectionName_0 = collections[file_2.id];
                mediaClient.file.getFileState(file_2.id, {
                    collectionName: collectionName_0,
                    includeHashForDuplicateFiles: true,
                    forceRefresh: true
                });
            });
        };
        t3 = [
            files,
            prevFiles,
            mediaClient,
            collections
        ];
        $[7] = collections;
        $[8] = files;
        $[9] = mediaClient;
        $[10] = prevFiles;
        $[11] = t2;
        $[12] = t3;
    } else {
        t2 = $[11];
        t3 = $[12];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[13] !== files) {
        t4 = Object.fromEntries(files.map($d2b956a25eda15ad$var$_temp3));
        $[13] = files;
        $[14] = t4;
    } else t4 = $[14];
    const hashMap = t4;
    return hashMap;
} : function useFileHashes(ids) {
    const nonErrorFiles = (0, $4fGOw.useMediaStore)((state)=>Object.values(state.files).filter((0, $gOi68.isNonErrorFinalFileState)));
    const mediaClient = (0, $lNvN4.useMediaClient)();
    const collections = (0, $cozmU.useMemo)(()=>Object.fromEntries(ids.map(({ id: id, collectionName: collectionName })=>[
                id,
                collectionName
            ])), [
        ids
    ]);
    const files = (0, $cozmU.useMemo)(()=>nonErrorFiles.filter((file)=>ids.some(({ id: id_0 })=>file.id === id_0)), [
        nonErrorFiles,
        ids
    ]);
    const prevFiles = (0, $kJaAu.usePrevious)(files);
    (0, $cozmU.useEffect)(()=>{
        const prev = prevFiles ?? [];
        // Get the files that have been added or whose status has changed since last time.
        const addedOrChangedFiles = files.filter((file_0)=>file_0 && prev.every((prevFile)=>prevFile.id !== file_0.id || prevFile.status !== file_0.status));
        // Get the files from the list that are duplicates of the added / changed files
        const potentialDuplicates = files.filter((file_1)=>addedOrChangedFiles.some((addedFile)=>$d2b956a25eda15ad$var$areFilesPotentiallyDuplicated(file_1, addedFile)));
        if (potentialDuplicates.length) // if any duplicates are found then fetch their hashes along with the added files
        [
            ...addedOrChangedFiles,
            ...potentialDuplicates
        ].forEach((file_2)=>{
            const collectionName_0 = collections[file_2.id];
            mediaClient.file.getFileState(file_2.id, {
                collectionName: collectionName_0,
                includeHashForDuplicateFiles: true,
                forceRefresh: true
            });
        });
    }, [
        files,
        prevFiles,
        mediaClient,
        collections
    ]);
    const hashMap = (0, $cozmU.useMemo)(()=>Object.fromEntries(files.map((file_3)=>[
                file_3.id,
                file_3.hash
            ])), [
        files
    ]);
    return hashMap;
};
function $d2b956a25eda15ad$var$_temp3(file_3) {
    return [
        file_3.id,
        file_3.hash
    ];
}
function $d2b956a25eda15ad$var$_temp2(t0) {
    const { id: id, collectionName: collectionName } = t0;
    return [
        id,
        collectionName
    ];
}
function $d2b956a25eda15ad$var$_temp(state) {
    return Object.values(state.files).filter((0, $gOi68.isNonErrorFinalFileState));
}
module.exports["useFileHashes"] = $d2b956a25eda15ad$export$f91c9e51e5ab027d;

});

parcelRegister("kJaAu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $2f894d46a9c73353$export$5cae361ad82dce8b(value) {
    const ref = (0, $cozmU.useRef)();
    (0, $cozmU.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
module.exports["usePrevious"] = $2f894d46a9c73353$export$5cae361ad82dce8b;

});

parcelRegister("12QCz", function(module, exports) {
/* eslint-disable @atlaskit/design-system/no-deprecated-imports, @typescript-eslint/ban-types -- Preserve existing mention implementation while focus-ring usage is reviewed separately. */ 
var $cozmU = parcelRequire("cozmU");


var $b1FLc = parcelRequire("b1FLc");


var $21cx5 = parcelRequire("21cx5");


var $cK6Td = parcelRequire("cK6Td");


var $iD1Wv = parcelRequire("iD1Wv");


var $gcaru = parcelRequire("gcaru");


var $caelp = parcelRequire("caelp");


var $b3nqj = parcelRequire("b3nqj");


var $lzgC6 = parcelRequire("lzgC6");


var $j7Sza = parcelRequire("j7Sza");


var $j1Rvl = parcelRequire("j1Rvl");


var $27ALb = parcelRequire("27ALb");

const $1b57c88557e5831b$export$7452d7062a4d0634 = 1000;
const $1b57c88557e5831b$export$af8124aa496797f2 = '_|unknown|_';
class $1b57c88557e5831b$export$92ab8442e7a15cef extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    componentDidMount() {
        (0, $27ALb.mentionRenderedUfoExperience).getInstance(this.props.id).success();
    }
    componentWillUnmount() {
        if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        const ufoInstance = (0, $27ALb.mentionRenderedUfoExperience).getInstance(this.props.id);
        if ([
            (0, $j7Sza.UFOExperienceState)['STARTED'],
            (0, $j7Sza.UFOExperienceState)['IN_PROGRESS']
        ].includes(ufoInstance.state)) ufoInstance.abort();
    }
    renderUnknownUserError(id) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j1Rvl.UnknownUserError), {
            values: {
                userId: id.slice(-5)
            }
        }, (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, `@${message}`));
    }
    render() {
        const { handleOnClick: handleOnClick, handleOnMouseEnter: handleOnMouseEnter, handleOnMouseLeave: handleOnMouseLeave, props: props } = this;
        const { text: text, id: id, accessLevel: accessLevel, localId: localId, disabledTooltip: disabledTooltip } = props;
        const mentionType = this.getMentionType();
        const failedMention = text === `@${$1b57c88557e5831b$export$af8124aa496797f2}`;
        const showRestrictedTooltip = mentionType === (0, $caelp.MentionType).RESTRICTED;
        const showDisabledTooltip = mentionType === (0, $caelp.MentionType).DISABLED && !!disabledTooltip;
        // A11y: when the chip is in the disabled visual state, expose
        // `aria-disabled` so assistive tech announces it as such. The
        // disabled-tooltip text is mirrored into `aria-label` so the
        // announcement carries the reason even without portal-id wiring for
        // `aria-describedby`.
        const isDisabledChip = mentionType === (0, $caelp.MentionType).DISABLED;
        const disabledA11yProps = isDisabledChip ? {
            'aria-disabled': true,
            ...disabledTooltip ? {
                'aria-label': `${text || '@...'} \u{2014} ${disabledTooltip}`
            } : {}
        } : {};
        const mentionComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b1FLc.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK6Td.default), {
            mentionType: mentionType,
            onClick: handleOnClick,
            onMouseEnter: handleOnMouseEnter,
            onMouseLeave: handleOnMouseLeave,
            spellCheck: false,
            "data-testid": `mention-${id}`,
            "data-mention-type": mentionType,
            "data-mention-tooltip": showRestrictedTooltip || showDisabledTooltip,
            ...disabledA11yProps
        }, failedMention ? this.renderUnknownUserError(id) : text || '@...'));
        const ssrPlaceholderProp = props.ssrPlaceholderId ? {
            'data-ssr-placeholder': props.ssrPlaceholderId
        } : {};
        const wrappedMention = (()=>{
            if (showRestrictedTooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
                fallback: mentionComponent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iD1Wv.default), {
                name: text
            }, mentionComponent));
            if (showDisabledTooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Suspense, {
                fallback: mentionComponent
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gcaru.default), {
                tooltip: disabledTooltip
            }, mentionComponent));
            return mentionComponent;
        })();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $27ALb.UfoErrorBoundary), {
            id: id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            id: localId,
            "data-mention-id": id,
            "data-local-id": localId,
            "data-access-level": accessLevel,
            spellCheck: false,
            ...ssrPlaceholderProp
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $21cx5.default), null, wrappedMention)));
    }
    constructor(props){
        super(props);
        this.hoverTimeout = void 0;
        this.handleOnClick = (e)=>{
            const { id: id, text: text, onClick: onClick, isDisabled: isDisabled } = this.props;
            if (isDisabled) // Disabled chips do not invoke their click handler.
            return;
            if (onClick) onClick(id, text, e);
        };
        this.handleOnMouseEnter = (e)=>{
            const { id: id, text: text, onMouseEnter: onMouseEnter, onHover: onHover } = this.props;
            if (onMouseEnter) onMouseEnter(id, text, e);
            this.hoverTimeout = window.setTimeout(()=>{
                if (onHover) onHover();
                this.hoverTimeout = undefined;
            }, $1b57c88557e5831b$export$7452d7062a4d0634);
        };
        this.handleOnMouseLeave = (e)=>{
            const { id: id, text: text, onMouseLeave: onMouseLeave } = this.props;
            if (onMouseLeave) onMouseLeave(id, text, e);
            if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
        };
        this.getMentionType = ()=>{
            const { accessLevel: accessLevel, isHighlighted: isHighlighted, isDisabled: isDisabled } = this.props;
            if (isDisabled) return (0, $caelp.MentionType).DISABLED;
            if (isHighlighted) return (0, $caelp.MentionType).SELF;
            if ((0, $caelp.isRestricted)(accessLevel)) return (0, $caelp.MentionType).RESTRICTED;
            return (0, $caelp.MentionType).DEFAULT;
        };
        (0, $27ALb.mentionRenderedUfoExperience).getInstance(props.id).start();
    }
}
const $1b57c88557e5831b$var$MentionWithAnalytics = (0, $lzgC6.default)({
    onClick: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $b3nqj.fireAnalyticsMentionEvent)(createEvent)('mention', 'selected', text, id, accessLevel);
        return event;
    },
    onHover: (createEvent, props)=>{
        const { id: id, text: text, accessLevel: accessLevel } = props;
        const event = (0, $b3nqj.fireAnalyticsMentionEvent)(createEvent)('mention', 'hovered', text, id, accessLevel);
        return event;
    }
})($1b57c88557e5831b$export$92ab8442e7a15cef);
const $1b57c88557e5831b$var$Mention = $1b57c88557e5831b$var$MentionWithAnalytics;
var $1b57c88557e5831b$export$2e2bcd8739ae039 = $1b57c88557e5831b$var$Mention;
module.exports["UNKNOWN_USER_ID"] = $1b57c88557e5831b$export$af8124aa496797f2;
module.exports["default"] = $1b57c88557e5831b$export$2e2bcd8739ae039;

});

parcelRegister("cK6Td", function(module, exports) {
/* eslint-disable @atlaskit/design-system/no-html-button */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");


var $caelp = parcelRequire("caelp");


var $cozmU = parcelRequire("cozmU");

const $ef75f214d8da3bca$var$mentionStyle = {
    [(0, $caelp.MentionType).SELF]: {
        background: "var(--ds-background-brand-bold, #1868DB)",
        borderColor: 'transparent',
        text: "var(--ds-text-inverse, #FFFFFF)",
        hoveredBackground: "var(--ds-background-brand-bold-hovered, #1558BC)",
        pressedBackground: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    [(0, $caelp.MentionType).RESTRICTED]: {
        background: 'transparent',
        borderColor: "var(--ds-border-bold, #7D818A)",
        text: "var(--ds-text, #292A2E)",
        hoveredBackground: 'transparent',
        pressedBackground: 'transparent'
    },
    [(0, $caelp.MentionType).DEFAULT]: {
        background: "var(--ds-background-neutral, #0515240F)",
        borderColor: 'transparent',
        text: "var(--ds-text-subtle, #505258)",
        hoveredBackground: "var(--ds-background-neutral-hovered, #0B120E24)",
        pressedBackground: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    [(0, $caelp.MentionType).DISABLED]: {
        background: "var(--ds-background-disabled, #0515240F)",
        borderColor: 'transparent',
        text: "var(--ds-text-disabled, #080F214A)",
        // Disabled chips do not change on hover / press.
        hoveredBackground: "var(--ds-background-disabled, #0515240F)",
        pressedBackground: "var(--ds-background-disabled, #0515240F)"
    }
};
const $ef75f214d8da3bca$var$getStyle = ({ mentionType: mentionType }, property)=>{
    const obj = $ef75f214d8da3bca$var$mentionStyle[mentionType][property];
    return typeof obj === 'string' ? obj : obj;
};
const $ef75f214d8da3bca$var$PrimitiveMention = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ mentionType: mentionType, ...other }, ref)=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $lOiVq.css)("display:inline;border:var(--ds-border-width, 1px) solid ", $ef75f214d8da3bca$var$getStyle({
            mentionType: mentionType
        }, 'borderColor'), ";background:", $ef75f214d8da3bca$var$getStyle({
            mentionType: mentionType
        }, 'background'), ";color:", $ef75f214d8da3bca$var$getStyle({
            mentionType: mentionType
        }, 'text'), ";border-radius:20px;cursor:pointer;padding:0 0.3em 2px 0.23em;line-height:1.714;font-size:1em;font-weight:var(--ds-font-weight-regular, 400);word-break:break-word;&:hover{background:", $ef75f214d8da3bca$var$getStyle({
            mentionType: mentionType
        }, 'hoveredBackground'), ";}&:active{background:", $ef75f214d8da3bca$var$getStyle({
            mentionType: mentionType
        }, 'pressedBackground'), ";}"),
        ...other
    });
});
var $ef75f214d8da3bca$export$2e2bcd8739ae039 = $ef75f214d8da3bca$var$PrimitiveMention;
module.exports["default"] = $ef75f214d8da3bca$export$2e2bcd8739ae039;

});

parcelRegister("gcaru", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $139bcf7839d1a883$var$AsyncDisabledMentionTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("2GsKr")).then((module)=>{
        return {
            default: module.DisabledMentionTooltip
        };
    }));
var $139bcf7839d1a883$export$2e2bcd8739ae039 = $139bcf7839d1a883$var$AsyncDisabledMentionTooltip;
module.exports["default"] = $139bcf7839d1a883$export$2e2bcd8739ae039;

});

parcelRegister("2GsKr", function(module, exports) {

let $1f45cdcc4b463c3d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1f45cdcc4b463c3d$var$load("5bU1Y").then(()=>parcelRequire('eZafG'));

});

parcelRegister("27ALb", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fh15z = parcelRequire("fh15z");

var $4MiWC = parcelRequire("4MiWC");

const $0f53e930d80d4c74$export$1d011e4240507c78 = new (0, $fh15z.ConcurrentExperience)('mention-rendered', {
    platform: {
        component: 'mention'
    },
    type: (0, $4MiWC.ExperienceTypes).Load,
    performanceType: (0, $4MiWC.ExperiencePerformanceTypes).PageSegmentLoad
});
class $0f53e930d80d4c74$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidCatch() {
        $0f53e930d80d4c74$export$1d011e4240507c78.getInstance(this.props.id).failure();
    }
    render() {
        return this.props.children;
    }
}
module.exports["mentionRenderedUfoExperience"] = $0f53e930d80d4c74$export$1d011e4240507c78;
module.exports["UfoErrorBoundary"] = $0f53e930d80d4c74$export$5ef1c2550074a375;

});

parcelRegister("cSuwJ", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $7Y8M5 = parcelRequire("7Y8M5");

function $4a8c68f17b3fe31c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4a8c68f17b3fe31c$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    loading: {
        id: "fabric.editor.expand.loading",
        defaultMessage: "Loading..."
    },
    collapseNode: {
        id: "fabric.editor.collapseNode",
        defaultMessage: "Collapse content"
    },
    expandDefaultTitle: {
        id: "fabric.editor.expandDefaultTitle",
        defaultMessage: "Click here to expand..."
    },
    expandNode: {
        id: "fabric.editor.expandNode",
        defaultMessage: "Expand content"
    },
    expandPlaceholderText: {
        id: "fabric.editor.expandPlaceholder",
        defaultMessage: "Give this expand a title..."
    },
    expandArialabel: {
        id: "fabric.editor.expandAriaLabel",
        defaultMessage: "Give this expand a title"
    },
    expandBodyAriaLabel: {
        id: "fabric.editor.expandBodyAriaLabel",
        defaultMessage: "Expand body content"
    }
});
const $4a8c68f17b3fe31c$export$4eeef63d68e77552 = ({ children: children, expanded: expanded })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: ()=>expanded ? [
                $4a8c68f17b3fe31c$var$expandIconWrapperStyle(),
                $4a8c68f17b3fe31c$var$expandIconWrapperExpandedStyle
            ] : $4a8c68f17b3fe31c$var$expandIconWrapperStyle()
    }, children);
};
const $4a8c68f17b3fe31c$var$expandIconWrapperStyle = ()=>/*#__PURE__*/ (0, $lOiVq.css)({
        cursor: 'pointer',
        display: 'flex',
        color: "var(--ds-icon, #292A2E)",
        borderRadius: "var(--ds-radius-small, 4px)",
        width: '24px',
        height: '24px',
        '&:hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        svg: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transition: `transform 0.2s ${(0, $7Y8M5.akEditorSwoopCubicBezier)}`
        }
    });
const $4a8c68f17b3fe31c$var$expandIconWrapperExpandedStyle = {
    name: "1uoxr6z",
    styles: "svg{transform:rotate(90deg);}"
};
const $4a8c68f17b3fe31c$export$a7ed6bf20867161a = {
    name: "ljflj6",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
};
const $4a8c68f17b3fe31c$export$c67faf67c1185cba = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, ...otherProps }, ref)=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        css: $4a8c68f17b3fe31c$export$a7ed6bf20867161a,
        ref: ref,
        ...otherProps
    }, children);
});
module.exports["messages"] = $4a8c68f17b3fe31c$export$defe85febe8b728c;
module.exports["ExpandIconWrapper"] = $4a8c68f17b3fe31c$export$4eeef63d68e77552;
module.exports["expandLayoutWrapperStyle"] = $4a8c68f17b3fe31c$export$a7ed6bf20867161a;
module.exports["ExpandLayoutWrapperWithRef"] = $4a8c68f17b3fe31c$export$c67faf67c1185cba;

});

parcelRegister("iF7Yl", function(module, exports) {
const $006c5a8383b762f1$var$MAUI_PERSONAL_READ_TOKEN_PATH = '/gateway/api/assist/rovo/v1/maui/media/personal-read-token';
async function $006c5a8383b762f1$export$c64afe9f7c18b7d9(productHeader) {
    const response = await fetch($006c5a8383b762f1$var$MAUI_PERSONAL_READ_TOKEN_PATH, {
        method: 'GET',
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'X-Product': productHeader
        }
    });
    if (!response.ok) throw new Error(`Failed to fetch MAUI personal read token: ${response.status} ${response.statusText}`);
    const data = await response.json();
    return {
        token: data.token,
        collection: data.collection
    };
}
module.exports["fetchMauiPersonalReadToken"] = $006c5a8383b762f1$export$c64afe9f7c18b7d9;

});

parcelRegister("lSM29", function(module, exports) {
/**
 * Environment detection utilities for the viz package
 */ /**
 * Checks if the current environment is local development
 */ const $06a8047ea97c648d$export$96081e27c2a95b0 = ()=>{
    if (typeof window === 'undefined') // Server-side rendering or Node.js environment
    return false;
    const host = window.location.host;
    return host.includes('localhost') || host.includes('127.0.0.1') || host.includes('0.0.0.0');
};
const $06a8047ea97c648d$export$23da1d24a38b0bde = ()=>{
    if (typeof window === 'undefined') return false;
    const host = window.location.host;
    return host.includes('.stg.atlassian') || host.includes('.stg-east.frontend.public.atl-paas.net') || host.includes('jira-dev.com') || host.includes('trellis.coffee');
};
const $06a8047ea97c648d$export$f15d00aa73aafac4 = ()=>{
    return !$06a8047ea97c648d$export$96081e27c2a95b0() && !$06a8047ea97c648d$export$23da1d24a38b0bde();
};
module.exports["isStaging"] = $06a8047ea97c648d$export$23da1d24a38b0bde;

});

parcelRegister("76xix", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $91ZZN = parcelRequire("91ZZN");


const $de0bfd2141159d80$var$LazyRovoLoadingGif = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("d8UlV"))); /**
             * @deprecated please use LazyAnimatedRovoIcon from @atlassian/rovo-platform-ui-components/primitives/rovo-animated-icon/LazyAnimatedRovoIcon instead
             */ 
const $de0bfd2141159d80$export$7ea4e54699cd5224 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { alt: t1, testId: t2, width: t3, height: t4 } = t0;
    const alt = t1 === undefined ? "" : t1;
    const testId = t2 === undefined ? "" : t2;
    const width = t3 === undefined ? "" : t3;
    const height = t4 === undefined ? "" : t4;
    let t5;
    if ($[0] !== alt || $[1] !== height || $[2] !== testId || $[3] !== width) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            interactionName: "rovo-conversation-assistant-animated-icon",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($de0bfd2141159d80$var$LazyRovoLoadingGif, {
            alt: alt,
            testId: testId,
            width: width,
            height: height
        }));
        $[0] = alt;
        $[1] = height;
        $[2] = testId;
        $[3] = width;
        $[4] = t5;
    } else t5 = $[4];
    return t5;
} : ({ alt: alt = '', testId: testId = '', width: width = '', height: height = '' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        interactionName: "rovo-conversation-assistant-animated-icon",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($de0bfd2141159d80$var$LazyRovoLoadingGif, {
        alt: alt,
        testId: testId,
        width: width,
        height: height
    }));
});
module.exports["LazyAnimatedRovoIcon"] = $de0bfd2141159d80$export$7ea4e54699cd5224;

});

parcelRegister("d8UlV", function(module, exports) {

let $9917bc308f190038$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9917bc308f190038$var$load("b7fR4").then(()=>parcelRequire('9r8so'));

});

parcelRegister("eDWhq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $85mU8 = parcelRequire("85mU8");

const $d70864677eee19d7$export$a74fbbd6fb01001c = (clientId, setupHandlers, apiInstance = (0, $85mU8.getBrowserBridgeAPI)())=>{
    const refApi = (0, $cozmU.useRef)(apiInstance);
    const refReady = (0, $cozmU.useRef)(false);
    const refMount = (0, $cozmU.useRef)(setupHandlers);
    const api = refApi.current;
    const setup = (0, $cozmU.useCallback)(()=>{
        // register all handlers
        // devx: provide current `clientId`
        setupHandlers?.((command, handler)=>api.on(clientId, command, handler));
    }, [
        clientId,
        setupHandlers,
        api
    ]);
    const ready = (0, $cozmU.useCallback)(()=>{
        // setup all handlers
        setup();
        // mark client as ready
        api.ready(clientId);
        // now, the client can receive messages AND handle them
        refReady.current = true;
    }, [
        clientId,
        setup,
        api
    ]);
    const send = (0, $cozmU.useCallback)((command_0, params)=>{
        // devx: provide current `clientId`
        return api.send(command_0, {
            ...params,
            senderId: clientId
        });
    }, [
        clientId,
        api
    ]);
    const broadcast = (0, $cozmU.useCallback)((command_1, params_0, options)=>{
        api.broadcast(command_1, params_0, options);
    }, [
        api
    ]);
    const teardown = (0, $cozmU.useCallback)(()=>{
        // devx: provide current `clientId`
        return api.teardown(clientId);
    }, [
        clientId,
        api
    ]);
    (0, $cozmU.useEffect)(()=>{
        // teardown if component tree is being destroyed
        // note: will also tear down all command handlers on your behalf
        return ()=>api.teardown(clientId);
    }, [
        clientId,
        api
    ]);
    /**
   * If we have already mounted our handlers once and marked ourselves as ready, then this
   * bridge API client is already capable of receiving & handling commands. On subsequent renders
   * if our {@link setupHandlers} reference changes, we need to make sure we run our setup again.
   *
   * This will ensure the newest state of every handler is being used, with no stale references
   * in closures, as can often occur with initialise-only-once code in React.
   */ if (refReady.current && refMount.current !== setupHandlers) setup();
    // so we can compare on next render
    refMount.current = setupHandlers;
    return {
        id: api.id,
        ready: ready,
        send: send,
        teardown: teardown,
        broadcast: broadcast
    };
};
module.exports["useRovoContentBridgeAPI"] = $d70864677eee19d7$export$a74fbbd6fb01001c;

});

parcelRegister("6Bfyn", function(module, exports) {
/**
 * Actionable Follow-Up Questions parsing utilities.
 *
 * The backend appends a follow-up section to the end of an assistant answer using a
 * single section marker followed by prose with inline `<followup>…</followup>` tagged
 * questions interspersed:
 *
 *   Normal answer text...
 *
 *   ◈If you want I can <followup>Convert this to a FAQ</followup>, <followup>Add target personas</followup>, or <followup>Make the tone more formal</followup>
 *
 * There is no end marker — everything after the first `◈` is the follow-up payload and
 * is assumed to be the last thing in the message. The surrounding prose renders as
 * normal text, while each `<followup>…</followup>` renders as an inline clickable link.
 *
 * See LDR: https://hello.atlassian.net/wiki/spaces/AA6/pages/7164582669
 */ /** Section marker (U+25C8) that denotes the start of the follow-up questions payload. */ const $d346e53a09a489f1$export$159e069055621f01 = "\u25C8";
const $d346e53a09a489f1$export$3b3ac8a86d553ab4 = 'actionable-follow-ups-';
const $d346e53a09a489f1$export$5b6a3157002ae3dc = (localId)=>{
    return localId != null && localId.startsWith($d346e53a09a489f1$export$3b3ac8a86d553ab4);
};
/**
 * Matches each `<followup>…</followup>` segment in the follow-up payload. The inner capture
 * is non-greedy and allows any character (including `<`/`>`), so question text containing
 * angle brackets parses correctly. An unterminated `<followup>` with no closing tag simply
 * does not match and is treated as in-flight prose.
 */ const $d346e53a09a489f1$var$FOLLOW_UP_QUESTION_REGEX = /<followup>([\s\S]*?)<\/followup>/g;
const $d346e53a09a489f1$export$7111c271f22de367 = (payload)=>{
    if (!payload) return [];
    // Strip a leading marker if the caller passed the full section including `◈`.
    const markerIndex = payload.indexOf($d346e53a09a489f1$export$159e069055621f01);
    let text = markerIndex === -1 ? payload : payload.slice(markerIndex + $d346e53a09a489f1$export$159e069055621f01.length);
    // Drop an unterminated trailing `<followup>` fragment so a half-streamed question
    // is not rendered as raw text until its closing tag arrives.
    const lastOpen = text.lastIndexOf('<followup>');
    if (lastOpen !== -1 && text.indexOf('</followup>', lastOpen) === -1) text = text.slice(0, lastOpen);
    const segments = [];
    let lastIndex = 0;
    const pushText = (value)=>{
        if (value) segments.push({
            type: 'text',
            value: value
        });
    };
    for (const match of text.matchAll($d346e53a09a489f1$var$FOLLOW_UP_QUESTION_REGEX)){
        const matchIndex = match.index ?? 0;
        // Prose preceding this question (preserved verbatim).
        pushText(text.slice(lastIndex, matchIndex));
        lastIndex = matchIndex + match[0].length;
        const question = match[1]?.trim();
        if (question) segments.push({
            type: 'question',
            value: question
        });
    }
    // Trailing prose after the final question.
    pushText(text.slice(lastIndex));
    return segments;
};
module.exports["ACTIONABLE_FOLLOW_UPS_MARKER"] = $d346e53a09a489f1$export$159e069055621f01;
module.exports["ACTIONABLE_FOLLOW_UPS_STATUS_PREFIX"] = $d346e53a09a489f1$export$3b3ac8a86d553ab4;
module.exports["isActionableFollowUpsStatus"] = $d346e53a09a489f1$export$5b6a3157002ae3dc;
module.exports["parseActionableFollowUps"] = $d346e53a09a489f1$export$7111c271f22de367;

});

parcelRegister("oV0CU", function(module, exports) {
const $b9ae9242f3c4f5b9$export$4b225aae27e9366b = '45c9c029-3180-4960-ab0d-db7cdeaf5f54';
const $b9ae9242f3c4f5b9$export$c87b1e2e3344192f = 1000;
const $b9ae9242f3c4f5b9$export$c4e7b6208a0b853e = 60;
const $b9ae9242f3c4f5b9$export$cd6b7e688e614eeb = $b9ae9242f3c4f5b9$export$c4e7b6208a0b853e * 60;
const $b9ae9242f3c4f5b9$export$56bec2f197c16818 = 'aiMateSmartLinkProviders';
const $b9ae9242f3c4f5b9$export$a0d33d6e93abfb90 = 'aiMateChatLoadPreference';
const $b9ae9242f3c4f5b9$export$e8114853eca81277 = 'ai-mate';
const $b9ae9242f3c4f5b9$export$45d167a0ef5aef8d = '/gateway/api/directory/graphql';
const $b9ae9242f3c4f5b9$export$1ea9613e3e37d315 = 30 * $b9ae9242f3c4f5b9$export$c4e7b6208a0b853e * $b9ae9242f3c4f5b9$export$c87b1e2e3344192f;
const $b9ae9242f3c4f5b9$export$501af059da333e01 = 5 * $b9ae9242f3c4f5b9$export$c4e7b6208a0b853e * $b9ae9242f3c4f5b9$export$c87b1e2e3344192f;
const $b9ae9242f3c4f5b9$export$f8d883b8f9181b19 = 'rovoChatLastMessageSentAt';
const $b9ae9242f3c4f5b9$export$85d90d98449e85fd = 140;
const $b9ae9242f3c4f5b9$export$cad0f6e78cd99203 = '600px';
const $b9ae9242f3c4f5b9$export$73f6568f4f3fdeda = 380;
const $b9ae9242f3c4f5b9$export$2c094f7f70c376e3 = 480;
const $b9ae9242f3c4f5b9$export$2e9abc2f500a1704 = 280;
module.exports["FEEDBACK_COLLECTOR_ENTRYPOINT_ID"] = $b9ae9242f3c4f5b9$export$4b225aae27e9366b;
module.exports["MS_IN_SECOND"] = $b9ae9242f3c4f5b9$export$c87b1e2e3344192f;
module.exports["SECONDS_IN_HR"] = $b9ae9242f3c4f5b9$export$cd6b7e688e614eeb;
module.exports["LS_CHAT_LOAD_PREFERENCE_KEY"] = $b9ae9242f3c4f5b9$export$a0d33d6e93abfb90;
module.exports["AI_MATE_EXPERIENCE_ID"] = $b9ae9242f3c4f5b9$export$e8114853eca81277;
module.exports["SHORTER_TIMEOUT_BEFORE_NEW_CHAT"] = $b9ae9242f3c4f5b9$export$501af059da333e01;
module.exports["LS_LAST_MESSAGE_SENT_AT"] = $b9ae9242f3c4f5b9$export$f8d883b8f9181b19;
module.exports["MINI_MODAL_GREETING_HEIGHT"] = $b9ae9242f3c4f5b9$export$85d90d98449e85fd;
module.exports["MINI_MODAL_EXPANDED_HEIGHT"] = $b9ae9242f3c4f5b9$export$cad0f6e78cd99203;
module.exports["SPLIT_LAYOUT_INITIAL_WIDTH"] = $b9ae9242f3c4f5b9$export$73f6568f4f3fdeda;
module.exports["SPLIT_LAYOUT_MIN_WIDTH"] = $b9ae9242f3c4f5b9$export$2c094f7f70c376e3;
module.exports["SPLIT_LAYOUT_ADJACENT_MIN_WIDTH"] = $b9ae9242f3c4f5b9$export$2e9abc2f500a1704;

});

parcelRegister("6rwn6", function(module, exports) {
/* eslint-disable @atlaskit/platform/one-value-export-per-file -- This file predates the rule and is a shared subpath entry point consumed by many packages; splitting would require coordinated changes across the entire monorepo. */ 
var $4wRTw = parcelRequire("4wRTw");


var $6FNab = parcelRequire("6FNab");


var $hUsog = parcelRequire("hUsog");


var $8lhhf = parcelRequire("8lhhf");

const $c360078fe01b00e3$export$d801201dc544181 = (content)=>{
    /*
  This try-catch is a necessary guard rail against broken content to prevent higher level
  error boundaries from displaying the error and breaking the experience.
  */ try {
        return typeof content !== 'string' && 'type' in content && content.type === 'doc';
    } catch  {
        return false;
    }
};
const $c360078fe01b00e3$export$a236f395afded7e0 = (content, suggestionContent)=>{
    if ($c360078fe01b00e3$export$d801201dc544181(content)) {
        // Ensure the content is an array of nodes
        const updatedContent = Array.isArray(content.content) ? content.content : [
            content.content
        ];
        // Append the new paragraph node
        updatedContent.push({
            type: 'paragraph',
            content: [
                {
                    type: 'text',
                    text: suggestionContent
                }
            ]
        });
        // Return the updated DocNode
        return {
            ...content,
            content: updatedContent
        };
    }
    return `${content}\n\n${suggestionContent}`;
};
const $c360078fe01b00e3$var$pluginConfig = {
    linkify: {
        findFilepaths: $4wRTw.findFilepaths,
        isLinkInMatches: $4wRTw.isLinkInMatches
    },
    smartLinks: {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        regexStorage: globalThis.localStorage
    }
};
const $c360078fe01b00e3$export$3374c63d7715b4ce = new (0, $6FNab.ADFEncoder)((schema)=>new (0, $hUsog.AiMateMarkdownTransformer)(schema, $c360078fe01b00e3$var$pluginConfig, false));
const $c360078fe01b00e3$var$streamingAdfEncoder = new (0, $6FNab.ADFEncoder)((schema)=>new (0, $hUsog.AiMateMarkdownTransformer)(schema, $c360078fe01b00e3$var$pluginConfig, true));
const $c360078fe01b00e3$export$53ded0b846f45216 = (content, streaming = false, isExperimentEnabled, shouldShowAsInline, useGroupedCitations, xpcWrapUrl)=>{
    if ($c360078fe01b00e3$export$d801201dc544181(content)) return content;
    if (isExperimentEnabled || shouldShowAsInline || xpcWrapUrl) return new (0, $6FNab.ADFEncoder)((schema)=>new (0, $hUsog.AiMateMarkdownTransformer)(schema, $c360078fe01b00e3$var$pluginConfig, streaming, isExperimentEnabled, shouldShowAsInline, undefined, xpcWrapUrl)).encode(content);
    else if (useGroupedCitations) return streaming ? new (0, $6FNab.ADFEncoder)((schema)=>new (0, $hUsog.AiMateMarkdownTransformer)(schema, $c360078fe01b00e3$var$pluginConfig, true, undefined, undefined, true)).encode(content) : new (0, $6FNab.ADFEncoder)((schema)=>new (0, $hUsog.AiMateMarkdownTransformer)(schema, $c360078fe01b00e3$var$pluginConfig, streaming, isExperimentEnabled, shouldShowAsInline, useGroupedCitations)).encode(content);
    else return streaming ? $c360078fe01b00e3$var$streamingAdfEncoder.encode(content) : $c360078fe01b00e3$export$3374c63d7715b4ce.encode(content);
};
const $c360078fe01b00e3$export$cc924f6f2bb49b7c = (content)=>{
    const contentNodes = [];
    let lastIndex = 0;
    let match;
    let promptLength = 0;
    // Find all skill tag matches
    const matches = [];
    while((match = (0, $8lhhf.ROVO_SKILL_TAG_PATTERN).exec(content)) !== null)matches.push({
        index: match.index,
        skillSlug: match[1],
        // The skill name without the slash
        length: match[0].length // Length of "/skill-name"
    });
    // Process the string segment by segment
    for(let i = 0; i < matches.length; i++){
        const currentMatch = matches[i];
        const matchStart = currentMatch.index;
        const matchEnd = matchStart + currentMatch.length;
        // Add text before the skill tag (if any)
        if (matchStart > lastIndex) {
            const textBefore = content.substring(lastIndex, matchStart);
            if (textBefore) {
                contentNodes.push({
                    type: 'text',
                    text: textBefore
                });
                promptLength += textBefore.length;
            }
        }
        // Add the skill tag as inlineExtension
        contentNodes.push({
            type: 'inlineExtension',
            attrs: {
                extensionKey: (0, $8lhhf.ROVO_SKILL_COMBINED_EXTENSION_KEY),
                extensionType: (0, $8lhhf.ROVO_SKILL_EXTENSION_TYPE),
                parameters: {
                    slug: currentMatch.skillSlug
                }
            }
        });
        promptLength += 1;
        lastIndex = matchEnd;
    }
    // Add remaining text after the last match (if any)
    if (lastIndex < content.length) {
        const textAfter = content.substring(lastIndex);
        if (textAfter) {
            contentNodes.push({
                type: 'text',
                text: textAfter
            });
            promptLength += textAfter.length;
        }
    }
    // If no matches were found, return the entire string as text
    if (contentNodes.length === 0) {
        contentNodes.push({
            type: 'text',
            text: content
        });
        promptLength += content.length;
    }
    return {
        adf: {
            type: 'doc',
            version: 1,
            content: [
                {
                    type: 'paragraph',
                    content: contentNodes
                }
            ]
        },
        promptLength: promptLength
    };
};
const $c360078fe01b00e3$export$b663bc0d84e6eaa6 = '`';
// encodeAdf removes leading spaces, so prepend a text node with the segment's leading spaces to preserve them.
const $c360078fe01b00e3$var$preserveLeadingSpaces = (textSegment, nodes)=>{
    const leading = textSegment.match(/^\s*/)?.[0] ?? '';
    if (leading.length === 0) return nodes;
    return [
        {
            type: 'text',
            text: leading
        },
        ...nodes
    ];
};
// Collect all content nodes from all top-level blocks, since encodeAdf can return multiple paragraphs for e.g. "line1\n\nline2".
const $c360078fe01b00e3$var$getAllNodesFromSegmentAdf = (segmentAdf, fallbackSegment)=>{
    const blocks = segmentAdf.content ?? [];
    if (blocks.length === 0) return [
        {
            type: 'text',
            text: fallbackSegment
        }
    ];
    const nodes = blocks.flatMap((block)=>block.content ?? []);
    return nodes.length > 0 ? nodes : [
        {
            type: 'text',
            text: fallbackSegment
        }
    ];
};
const $c360078fe01b00e3$var$detectSkills = (content, skillMetadata)=>{
    if (!skillMetadata) return [];
    const regex = new RegExp((0, $8lhhf.ROVO_SKILL_TAG_PATTERN).source, 'g');
    const matches = [
        ...content.matchAll(regex)
    ];
    if (matches.length === 0) return [];
    return matches.filter((m)=>m[1] in skillMetadata).map((m)=>({
            index: m.index ?? 0,
            slug: m[1],
            length: m[0].length
        }));
};
// The conversation input editor only supports a limited set of block node types.
// Convert unsupported block nodes to paragraph nodes so that prompts containing
// markdown headings (e.g. "## Title") or horizontal rules (e.g. "---") do not
// trigger "This editor does not support displaying this content: <type>" when inserted.
const $c360078fe01b00e3$var$sanitizeAdfForPromptInput = (adf)=>{
    if (!adf.content) return adf;
    return {
        ...adf,
        content: adf.content.flatMap((node)=>{
            if (node.type === 'heading') // Convert heading to paragraph, preserving inner text content
            return [
                {
                    type: 'paragraph',
                    content: node.content
                }
            ];
            if (node.type === 'rule') // Drop horizontal rules entirely — they have no content to preserve
            return [];
            return [
                node
            ];
        })
    };
};
const $c360078fe01b00e3$export$20cf1197bba4fe47 = (content, skillMetadata, shouldShowAsInline)=>{
    const skillMatches = $c360078fe01b00e3$var$detectSkills(content, skillMetadata);
    if (skillMatches.length === 0) {
        const { placeholderRange: placeholderRange } = $c360078fe01b00e3$var$getPlaceholderRange(content, 0);
        return {
            adf: $c360078fe01b00e3$var$sanitizeAdfForPromptInput($c360078fe01b00e3$export$53ded0b846f45216(content, false, undefined, shouldShowAsInline)),
            promptLength: content.length,
            ...placeholderRange && {
                placeholderRange: placeholderRange
            }
        };
    }
    return $c360078fe01b00e3$var$encodePromptWithSkills(content, skillMatches, skillMetadata);
};
const $c360078fe01b00e3$var$encodePromptWithSkills = (content, skillMatches, skillMetadata)=>{
    const contentNodes = [];
    let lastIndex = 0;
    let promptLength = 0;
    let placeholderRange;
    for(let i = 0; i < skillMatches.length; i++){
        const currentMatch = skillMatches[i];
        const matchStart = currentMatch.index;
        const matchEnd = matchStart + currentMatch.length;
        // Add text and placeholder range before the skill tag (if any)
        if (matchStart > lastIndex) {
            const textSegment = content.substring(lastIndex, matchStart);
            if (textSegment) {
                const { placeholderRange: range } = $c360078fe01b00e3$var$getPlaceholderRange(textSegment, promptLength);
                if (range) placeholderRange = range;
                const segmentAdf = $c360078fe01b00e3$export$53ded0b846f45216(textSegment);
                const nodes = $c360078fe01b00e3$var$getAllNodesFromSegmentAdf(segmentAdf, textSegment);
                contentNodes.push(...$c360078fe01b00e3$var$preserveLeadingSpaces(textSegment, nodes));
                promptLength += textSegment.length;
            }
        }
        // Add the skill tag as inlineExtension
        contentNodes.push({
            type: 'inlineExtension',
            attrs: {
                extensionKey: (0, $8lhhf.ROVO_SKILL_COMBINED_EXTENSION_KEY),
                extensionType: (0, $8lhhf.ROVO_SKILL_EXTENSION_TYPE),
                parameters: {
                    slug: currentMatch.slug,
                    ...skillMetadata?.[currentMatch.slug]
                }
            }
        });
        promptLength += 1;
        lastIndex = matchEnd;
    }
    // Add remaining text and placeholder range after the last match (if any)
    if (lastIndex < content.length) {
        const textSegment = content.substring(lastIndex);
        if (textSegment) {
            const { placeholderRange: range } = $c360078fe01b00e3$var$getPlaceholderRange(textSegment, promptLength);
            if (range) placeholderRange = range;
            const segmentAdf = $c360078fe01b00e3$export$53ded0b846f45216(textSegment);
            const nodes = $c360078fe01b00e3$var$getAllNodesFromSegmentAdf(segmentAdf, textSegment);
            contentNodes.push(...$c360078fe01b00e3$var$preserveLeadingSpaces(textSegment, nodes));
            promptLength += textSegment.length;
        }
    }
    return {
        adf: {
            type: 'doc',
            version: 1,
            content: [
                {
                    type: 'paragraph',
                    content: contentNodes
                }
            ]
        },
        promptLength: promptLength,
        ...placeholderRange && {
            placeholderRange: placeholderRange
        }
    };
};
// Returns the placeholder range for link typeahead when content has `label` backticks.
const $c360078fe01b00e3$var$getPlaceholderRange = (segment, currentContentIndex)=>{
    const firstBacktick = segment.indexOf($c360078fe01b00e3$export$b663bc0d84e6eaa6);
    const lastBacktick = segment.lastIndexOf($c360078fe01b00e3$export$b663bc0d84e6eaa6);
    if (firstBacktick !== -1 && lastBacktick !== -1 && firstBacktick !== lastBacktick) {
        const label = segment.slice(firstBacktick + 1, lastBacktick);
        const start = currentContentIndex + firstBacktick + 1;
        return {
            placeholderRange: {
                start: start,
                end: start + label.length,
                label: label
            }
        };
    }
    return {};
};
module.exports["isAdfContent"] = $c360078fe01b00e3$export$d801201dc544181;
module.exports["appendContent"] = $c360078fe01b00e3$export$a236f395afded7e0;
module.exports["adfEncoder"] = $c360078fe01b00e3$export$3374c63d7715b4ce;
module.exports["encodeAdf"] = $c360078fe01b00e3$export$53ded0b846f45216;
module.exports["encodeSkillPromptToAdf"] = $c360078fe01b00e3$export$cc924f6f2bb49b7c;
module.exports["PROMPT_PLACEHOLDER_CHAR"] = $c360078fe01b00e3$export$b663bc0d84e6eaa6;
module.exports["encodePromptToAdf"] = $c360078fe01b00e3$export$20cf1197bba4fe47;

});

parcelRegister("hUsog", function(module, exports) {

var $fT7Fj = parcelRequire("fT7Fj");


var $zBSTr = parcelRequire("zBSTr");


var $c9zHD = parcelRequire("c9zHD");


var $2jzwX = parcelRequire("2jzwX");


var $aPdNQ = parcelRequire("aPdNQ");


var $ixfCV = parcelRequire("ixfCV");


var $ae1na = parcelRequire("ae1na");


var $lz2jD = parcelRequire("lz2jD");


var $lxRLM = parcelRequire("lxRLM");


var $diCaM = parcelRequire("diCaM");


var $7CEea = parcelRequire("7CEea");


var $3eAWZ = parcelRequire("3eAWZ");


var $77gNR = parcelRequire("77gNR");


var $a1mp1 = parcelRequire("a1mp1");


var $8Idwp = parcelRequire("8Idwp");


var $a52Mw = parcelRequire("a52Mw");


var $ejOiD = parcelRequire("ejOiD");


var $1JPkQ = parcelRequire("1JPkQ");


var $dapfS = parcelRequire("dapfS");


var $6X3gJ = parcelRequire("6X3gJ");


var $bf7Qg = parcelRequire("bf7Qg");


var $k73tv = parcelRequire("k73tv");

class $ed41d4af387b8a76$export$614853bf2169db97 extends (0, $c9zHD.MarkdownTransformer) {
    parse(content) {
        // Sanitize the raw markdown string before it reaches the markdown-it block
        // tokenizer (ParserBlock.tokenize). Indented tables and 4+ space-indented
        // fences can cause catastrophic backtracking / OOM; `sanitizeMarkdown`
        // outdents fences with 4+ spaces of indentation so the parser recognises
        // them as fenced code blocks rather than entering an infinite tokenization
        // loop.
        //
        // Note: md.core.ruler cannot be used here — core rules run AFTER block
        // tokenization, which is too late to prevent the crash. The sanitization
        // must happen on the raw string before parse() is called.
        const preprocessed = (0, $ixfCV.fg)('rovo_chat_normalize_borderless_tables') ? (0, $bf7Qg.normalizeBorderlessTables)(content) : content;
        const node = this.parser.parse((0, $bf7Qg.sanitizeMarkdown)(preprocessed));
        if (!node) return new (0, $aPdNQ.Node)();
        return node;
    }
    constructor(schema, pluginConfig, streaming, isExperimentEnabled, shouldShowAsInline, useGroupedCitations, xpcWrapUrl){
        super();
        this.parser = void 0;
        const md = (0, (/*@__PURE__*/$parcel$interopDefault($fT7Fj)))('zero', {
            html: false
        });
        md.enable([
            // Process html entity - &#123;, &#xAF;, &quot;, ...
            'entity',
            // Process escaped chars and hardbreaks
            'escape',
            'newline'
        ]);
        (0, $k73tv.enableSchemaPlugins)(md, schema);
        // Handle blockquotes inside list items - ADF doesn't support this nesting,
        // so we transform them into emphasized paragraphs
        md.use((0, $a1mp1.default));
        // enable modified version of linkify plugin
        // @see https://product-fabric.atlassian.net/browse/ED-3097
        md.use((0, $77gNR.createLinkifyPlugin)(pluginConfig.linkify));
        if (useGroupedCitations) md.use((0, $diCaM.default));
        else md.use((0, $ae1na.default));
        if ((0, $ixfCV.fg)('rovo_enable_data_sculptor')) md.use((0, $lz2jD.default));
        md.use((0, $lxRLM.default));
        md.use((0, $dapfS.default));
        if ((0, $ixfCV.fg)('rovo_chat_enable_inline_lumina')) md.use((0, $3eAWZ.default));
        // Actionable follow-up questions
        if ((0, $ixfCV.fg)('rovo_chat_actionable_followups_enabled')) md.use((0, $7CEea.default));
        // Convert links with Linking Platform supported URLs to Smart Links
        if (!streaming && (schema.nodes.inlineCard || schema.nodes.blockCard || schema.nodes.embedCard)) // this is where we should separate it into its own plugin called createSmartLinksPluginRefresh
        md.use((0, $ejOiD.createSmartLinksPlugin)(pluginConfig.smartLinks, isExperimentEnabled, shouldShowAsInline, xpcWrapUrl));
        // Convert links matching people directory URLs to mentions
        if (schema.nodes.mention) md.use((0, $a52Mw.default));
        // Table support
        if (schema.nodes.table) {
            md.use((0, $zBSTr.markdownItTable));
            md.use((0, $1JPkQ.default));
        }
        // Image support
        if (schema.nodes.media && schema.nodes.mediaSingle) md.use((0, $8Idwp.default));
        const filter = (0, $k73tv.filterSchemaMapping)(schema, (0, $6X3gJ.mdToPmSchema));
        this.parser = new (0, $2jzwX.MarkdownParser)(schema, md, filter);
    }
}
module.exports["AiMateMarkdownTransformer"] = $ed41d4af387b8a76$export$614853bf2169db97;

});

parcelRegister("ae1na", function(module, exports) {
$parcel$export(module.exports, "default", () => $330d5ffa0743cdd8$export$2e2bcd8739ae039);
const $330d5ffa0743cdd8$var$CITATION_REGEX = /\[\^(\d+)\^\]/;
/**
 * This plugin is used to transform citations in markdown to status tokens
 * Citations are in the format [^1^], [^2^], etc.
 * The citations correspond to source references in the response:
 * If we have a response like:
 * "This is a citation[^5^]. This is another citation[^8^]. This is the final citation[^5^]." then the citations will be transformed to:
 * "This is a citation 1. This is another citation 2. This is the final citation 1."
 * We are reordering the citation from 1 2 3 on purpose
 */ const $330d5ffa0743cdd8$var$citation = (state)=>{
    const tokens = [];
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $330d5ffa0743cdd8$var$CITATION_REGEX.test(childToken.content)) {
                /**
           * Example content: `Hello [^1^][^1^].`
           * `parts` will be ['Hello ', '1', '', '1', '.']
           */ const parts = childToken.content.split($330d5ffa0743cdd8$var$CITATION_REGEX);
                const newChildren = [];
                /**
           * we want to remove consecutive citation
           * e.g. `Hello [^1^][^1^]. How are you [^1^][^2^]`
           * should be transformed to `Hello 1. How are you 1 2`
           */ let lastCitation = null;
                let isLastCitationDuplicate = false;
                // only want to add space in the next part after citation
                // if the last citation is valid
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        // this is a text part
                        /**
               * if the last citation is a duplicate, and the text part is an empty string, we skip rendering the inbetween empty space
               * So it doesn't end up rendering empty space that will end up with multi empty spaces
               * because previous valid citation already added 1 empty space
               *
               * Example: For `[^1^][^1^]`
               * it will be split into parts: ['', '1', '', '1', ''],
               * This code will skip any rendering for the last empty string (index=4)
               * Because the empty string at index=2 already added 1 empty space from the code below
               */ if (isLastCitationDuplicate && part.trim() === '') return;
                        if (part.trim() !== '') /**
                 * if the text part is not an empty string, we want to reset the last citation
                 * because the text part is a valid text, and not a space between citations
                 * so that we can render citation again, even if the next number is the same as the last number
                 *
                 * Example:
                 * `[^1^] [^1^] Hello [^1^][^1^]` -> `1 Hello 1`
                 */ lastCitation = null;
                        const textToken = new state.Token('text', '', 0);
                        if (index === parts.length - 1) textToken.content = part;
                        else textToken.content = part + ' ';
                        textToken.block = false;
                        textToken.level = childToken.level;
                        newChildren.push(textToken);
                    } else {
                        // this is a citation part
                        // if the current citation is the same as the last citation, we skip rendering the citation, and mark it as a duplicate
                        if (part === lastCitation) {
                            isLastCitationDuplicate = true;
                            return;
                        } else {
                            // always reset the duplicate flag
                            isLastCitationDuplicate = false;
                            lastCitation = part;
                        }
                        const citationToken = new state.Token('status', '', 0);
                        citationToken.content = '';
                        citationToken.block = false;
                        citationToken.level = childToken.level;
                        let citationText = part;
                        citationToken.attrs = [
                            [
                                'color',
                                'blue'
                            ],
                            [
                                'text',
                                citationText
                            ],
                            // localId is used to identify the citation token in the DOM
                            // this overrides the uuid that is normally used
                            [
                                'localId',
                                `citation-${citationText}`
                            ]
                        ];
                        citationToken.content = citationText;
                        newChildren.push(citationToken);
                    }
                });
                tokenChildren.push(...newChildren);
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $330d5ffa0743cdd8$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('citation', $330d5ffa0743cdd8$var$citation);

});

parcelRegister("lz2jD", function(module, exports) {
$parcel$export(module.exports, "default", () => $157bfca8bd99df8f$export$2e2bcd8739ae039);
const $157bfca8bd99df8f$var$SCULPTOR_REGEX = /\[\^(sculptor)\^\]/;
const $157bfca8bd99df8f$var$dataSculptor = (state)=>{
    const tokens = [];
    let sculptorCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $157bfca8bd99df8f$var$SCULPTOR_REGEX.test(childToken.content)) {
                const citationToken = new state.Token('status', '', 0);
                citationToken.content = '';
                citationToken.block = false;
                citationToken.level = childToken.level;
                const parts = childToken.content.split($157bfca8bd99df8f$var$SCULPTOR_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        citationToken.attrs = [
                            [
                                'localId',
                                'data-sculptor-' + sculptorCounter
                            ],
                            [
                                'text',
                                'data-sculptor-' + sculptorCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(citationToken);
                        sculptorCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $157bfca8bd99df8f$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('data-sculptor', $157bfca8bd99df8f$var$dataSculptor);

});

parcelRegister("lxRLM", function(module, exports) {
const $14c428bc00c0e101$var$EXPAND_REGEX = /\[\^(expand)\^\]/;
const $14c428bc00c0e101$var$expandable = (state)=>{
    const tokens = [];
    let expandCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children?.length === 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $14c428bc00c0e101$var$EXPAND_REGEX.test(childToken.content)) {
                const parts = childToken.content.split($14c428bc00c0e101$var$EXPAND_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        const expandToken = new state.Token('status', '', 0);
                        expandToken.content = '';
                        expandToken.block = false;
                        expandToken.level = childToken.level;
                        expandToken.attrs = [
                            [
                                'localId',
                                'expandable-' + expandCounter
                            ],
                            [
                                'text',
                                'expandable-' + expandCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(expandToken);
                        expandCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
const $14c428bc00c0e101$var$mdPluginExpandable = (md)=>{
    md.core.ruler.push('expandable', $14c428bc00c0e101$var$expandable);
};
var $14c428bc00c0e101$export$2e2bcd8739ae039 = $14c428bc00c0e101$var$mdPluginExpandable;
module.exports["default"] = $14c428bc00c0e101$export$2e2bcd8739ae039;

});

parcelRegister("diCaM", function(module, exports) {
$parcel$export(module.exports, "default", () => $26c7e36d126f9ad4$export$2e2bcd8739ae039);
const $26c7e36d126f9ad4$var$CITATION_REGEX = /\[\^(\d+)\^\]/;
/**
 * This plugin is used to transform citations in markdown to status tokens
 * Citations are in the format [^1^], [^2^], etc.
 * The citations correspond to source references in the response:
 * If we have a response like:
 * "This is a citation[^5^]. This is another citation[^8^]. This is the final citation[^5^]." then the citations will be transformed to:
 * "This is a citation 1. This is another citation 2. This is the final citation 1."
 * We are reordering the citation from 1 2 3 on purpose
 */ const $26c7e36d126f9ad4$var$groupedCitations = (state)=>{
    const tokens = [];
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $26c7e36d126f9ad4$var$CITATION_REGEX.test(childToken.content)) {
                /**
           * Example content: `Hello [^1^][^1^].`
           * `parts` will be ['Hello ', '1', '', '1', '.']
           */ const parts = childToken.content.split($26c7e36d126f9ad4$var$CITATION_REGEX);
                const newChildren = [];
                /**
           * we want to remove consecutive citation
           * e.g. `Hello [^1^][^1^]. How are you [^1^][^2^]`
           * should be transformed to `Hello 1. How are you 1 2`
           */ let lastCitation = null;
                let isLastCitationDuplicate = false;
                let citationIndices = [];
                // only want to add space in the next part after citation
                // if the last citation is valid
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        // this is a text part
                        /**
               * if the last citation is a duplicate, and the text part is an empty string, we skip rendering the inbetween empty space
               * So it doesn't end up rendering empty space that will end up with multi empty spaces
               * because previous valid citation already added 1 empty space
               *
               * Example: For `[^1^][^1^]`
               * it will be split into parts: ['', '1', '', '1', ''],
               * This code will skip any rendering for the last empty string (index=4)
               * Because the empty string at index=2 already added 1 empty space from the code below
               */ if ((isLastCitationDuplicate || citationIndices.length > 0) && part.trim() === '') return;
                        if (part.trim() !== '') {
                            /**
                 * if the text part is not an empty string, we want to reset the last citation
                 * because the text part is a valid text, and not a space between citations
                 * so that we can render citation again, even if the next number is the same as the last number
                 *
                 * Example:
                 * `[^1^] [^1^] Hello [^1^][^1^]` -> `1 Hello 1`
                 */ lastCitation = null;
                            /**
                 * once we reach a text part, we need to capture the indices of the citations that have occurred up to this point
                 *
                 * Example
                 * `Hello [^1^][^2^] The example continues` -> parts = ['Hello ', '1', '', '2', 'The example continues']
                 * When 'The example continues' is reached, we need to create a status token for the citations prior
                 */ if (citationIndices.length > 0) {
                                const citationToken = new state.Token('status', '', 0);
                                citationToken.content = '';
                                citationToken.block = false;
                                citationToken.level = childToken.level;
                                // localId is used to identify the citation indices in the DOM
                                // this overrides the uuid that is normally used
                                // NOTE: ReactRenderer expects specific props for status nodes and
                                // therefore we cannot pass in custom attributes
                                citationToken.attrs = [
                                    [
                                        'color',
                                        'blue'
                                    ],
                                    [
                                        'text',
                                        'citation'
                                    ],
                                    // citationIndices is used to identify the citation token in the DOM
                                    // this overrides the uuid that is normally used
                                    [
                                        'localId',
                                        JSON.stringify(citationIndices)
                                    ]
                                ];
                                newChildren.push(citationToken);
                                citationIndices = [];
                            }
                        }
                        const textToken = new state.Token('text', '', 0);
                        // don't add trailing space if part already ends with one
                        textToken.content = index === parts.length - 1 ? part : part.endsWith(' ') ? part : part + ' ';
                        textToken.block = false;
                        textToken.level = childToken.level;
                        if (part !== '') newChildren.push(textToken);
                    } else {
                        // this is a citation part
                        // if the current citation is the same as the last citation, we skip rendering the citation, and mark it as a duplicate
                        if (part === lastCitation) {
                            isLastCitationDuplicate = true;
                            return;
                        } else {
                            // always reset the duplicate flag
                            isLastCitationDuplicate = false;
                            lastCitation = part;
                        }
                        citationIndices.push(parseInt(part));
                    }
                });
                /**
           * Once we've reached the end of parts, we need to create a status token for any citations at the very end
           *
           * Example: `Hello [^1^][^2^]` -> parts = ['Hello ', '1', '', '2', '']
           * When we've iterated through all of parts, 1 and 2 indices exist in citationIndices, and a status token needs to be created
           */ if (citationIndices.length > 0) {
                    const citationToken = new state.Token('status', '', 0);
                    citationToken.content = '';
                    citationToken.block = false;
                    citationToken.level = childToken.level;
                    citationToken.attrs = [
                        [
                            'color',
                            'blue'
                        ],
                        [
                            'text',
                            'citation'
                        ],
                        [
                            'localId',
                            JSON.stringify(citationIndices)
                        ]
                    ];
                    newChildren.push(citationToken);
                    citationIndices = [];
                }
                tokenChildren.push(...newChildren);
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $26c7e36d126f9ad4$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('citation', $26c7e36d126f9ad4$var$groupedCitations);

});

parcelRegister("7CEea", function(module, exports) {
$parcel$export(module.exports, "default", () => $04a93a56598a27a8$export$2e2bcd8739ae039);

var $6Bfyn = parcelRequire("6Bfyn");

const $04a93a56598a27a8$var$FOLLOW_UPS_REGEX = /\[\^(actionable-follow-ups)\^\]/;
/**
 * Replaces the `[^actionable-follow-ups^]` placeholder (injected when the `◈`
 * marker is extracted from the assistant response) with a `status` node whose
 * `localId`/`text` is prefixed with `ACTIONABLE_FOLLOW_UPS_STATUS_PREFIX`. The
 * renderer swaps that status node for the actionable follow-up questions UI,
 * pulling the parsed questions from the message's `markdownData`.
 *
 * Mirrors `md-plugin-inline-lumina`.
 */ const $04a93a56598a27a8$var$inlineFollowUps = (state)=>{
    const tokens = [];
    let followUpsCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $04a93a56598a27a8$var$FOLLOW_UPS_REGEX.test(childToken.content)) {
                const parts = childToken.content.split($04a93a56598a27a8$var$FOLLOW_UPS_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        const followUpsToken = new state.Token('status', '', 0);
                        followUpsToken.content = '';
                        followUpsToken.block = false;
                        followUpsToken.level = childToken.level;
                        followUpsToken.attrs = [
                            [
                                'localId',
                                (0, $6Bfyn.ACTIONABLE_FOLLOW_UPS_STATUS_PREFIX) + followUpsCounter
                            ],
                            [
                                'text',
                                (0, $6Bfyn.ACTIONABLE_FOLLOW_UPS_STATUS_PREFIX) + followUpsCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(followUpsToken);
                        followUpsCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
function $04a93a56598a27a8$export$2e2bcd8739ae039(md) {
    md.core.ruler.push('inline-follow-ups', $04a93a56598a27a8$var$inlineFollowUps);
}

});

parcelRegister("3eAWZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $bbeb09636b3688aa$export$2e2bcd8739ae039);

var $1rNZu = parcelRequire("1rNZu");

const $bbeb09636b3688aa$var$LUMINA_REGEX = /\[\^(lumina)\^\]/;
const $bbeb09636b3688aa$var$inlineLumina = (state)=>{
    const tokens = [];
    let luminaCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $bbeb09636b3688aa$var$LUMINA_REGEX.test(childToken.content)) {
                const parts = childToken.content.split($bbeb09636b3688aa$var$LUMINA_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        const luminaToken = new state.Token('status', '', 0);
                        luminaToken.content = '';
                        luminaToken.block = false;
                        luminaToken.level = childToken.level;
                        luminaToken.attrs = [
                            [
                                'localId',
                                (0, $1rNZu.INLINE_LUMINA_STATUS_PREFIX) + luminaCounter
                            ],
                            [
                                'text',
                                (0, $1rNZu.INLINE_LUMINA_STATUS_PREFIX) + luminaCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(luminaToken);
                        luminaCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
function $bbeb09636b3688aa$export$2e2bcd8739ae039(md) {
    md.core.ruler.push('inline-lumina', $bbeb09636b3688aa$var$inlineLumina);
}

});

parcelRegister("1rNZu", function(module, exports) {
const $90cb542132d5af8c$export$8288860537fb7872 = 'inline-lumina-';
const $90cb542132d5af8c$export$5d9d37bd58628e00 = (localId)=>{
    return localId != null && localId.startsWith($90cb542132d5af8c$export$8288860537fb7872);
};
module.exports["INLINE_LUMINA_STATUS_PREFIX"] = $90cb542132d5af8c$export$8288860537fb7872;
module.exports["isInlineLuminaStatus"] = $90cb542132d5af8c$export$5d9d37bd58628e00;

});

parcelRegister("77gNR", function(module, exports) {

var $fX7cS = parcelRequire("fX7cS");

const $b9f103c37ce71df9$export$763ac077c9998026 = (params)=>(md)=>md.core.ruler.push('custom-linkify', (0, $fX7cS.createLinkify)(params));
module.exports["createLinkifyPlugin"] = $b9f103c37ce71df9$export$763ac077c9998026;

});

parcelRegister("fX7cS", function(module, exports) {

var $8Ik5z = parcelRequire("8Ik5z");


var $9p0BY = parcelRequire("9p0BY");

// modified version of the original Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
const $d7524ac980d0a478$var$arrayReplaceAt = (src, pos, newElements)=>[].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
const $d7524ac980d0a478$var$isLinkOpen = (str)=>{
    return /^<a[>\s]/i.test(str);
};
const $d7524ac980d0a478$var$isLinkClose = (str)=>{
    return /^<\/a\s*>/i.test(str);
};
const $d7524ac980d0a478$export$8cd7d1ec2e6808da = ({ findFilepaths: findFilepaths, isLinkInMatches: isLinkInMatches })=>(state)=>{
        const blockTokens = state.tokens;
        const linkify = new (0, (/*@__PURE__*/$parcel$interopDefault($8Ik5z)))();
        for(let j = 0, l = blockTokens.length; j < l; j++){
            if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
            let tokens = blockTokens[j].children ?? [];
            let htmlLinkLevel = 0;
            // We scan from the end, to keep position when new tags added.
            // Use reversed logic in links start/end match
            for(let i = tokens.length - 1; i >= 0; i--){
                const currentToken = tokens[i];
                // Skip content of markdown links
                if (currentToken.type === 'link_close') {
                    i--;
                    while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                    continue;
                }
                // Skip content of html tag links
                if (currentToken.type === 'html_inline') {
                    if ($d7524ac980d0a478$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                    if ($d7524ac980d0a478$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
                }
                if (htmlLinkLevel > 0) continue;
                if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                    const text = currentToken.content;
                    let links = (0, $9p0BY.linkifyMatch)(text);
                    if (!links.length) links = linkify.match(text) || [];
                    // Now split string to nodes
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const nodes = [];
                    let level = currentToken.level;
                    let lastPos = 0;
                    const filepaths = findFilepaths(text);
                    for(let ln = 0; ln < links.length; ln++){
                        if (isLinkInMatches(links[ln].index, filepaths)) continue;
                        const { url: url } = links[ln];
                        const fullUrl = state.md.normalizeLink(url);
                        if (!state.md.validateLink(fullUrl)) continue;
                        let urlText = links[ln].text;
                        // Linkifier might send raw hostnames like "example.com", where url
                        // starts with domain name. So we prepend http:// in those cases,
                        // and remove it afterwards.
                        //
                        if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                        else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                        else urlText = state.md.normalizeLinkText(urlText);
                        const pos = links[ln].index;
                        if (pos > lastPos) {
                            const token = new state.Token('text', '', 0);
                            token.content = text.slice(lastPos, pos);
                            token.level = level;
                            nodes.push(token);
                        }
                        let token = new state.Token('link_open', 'a', 1);
                        token.attrs = [
                            [
                                'href',
                                fullUrl
                            ]
                        ];
                        token.level = level++;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        token = new state.Token('text', '', 0);
                        token.content = urlText;
                        token.level = level;
                        nodes.push(token);
                        token = new state.Token('link_close', 'a', -1);
                        token.level = --level;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        lastPos = links[ln].lastIndex;
                    }
                    if (lastPos < text.length) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos);
                        token.level = level;
                        nodes.push(token);
                    }
                    // replace current node
                    blockTokens[j].children = tokens = $d7524ac980d0a478$var$arrayReplaceAt(tokens, i, nodes);
                }
            }
        }
    };
module.exports["createLinkify"] = $d7524ac980d0a478$export$8cd7d1ec2e6808da;

});

parcelRegister("a1mp1", function(module, exports) {
/**
 * This plugin handles blockquotes nested inside list items.
 * Since ADF doesn't support blockquotes as children of listItems,
 * we transform blockquote content into emphasized (italic) paragraphs.
 *
 * Before: 1. Item\n   > "Quote"
 * After:  1. Item\n   _"Quote"_
 *
 * This allows quotes within lists to render gracefully as italicized text
 * rather than failing due to ADF schema constraints.
 */ const $d2188aa6b0aad9ac$var$listBlockquoteFallback = (state)=>{
    const tokens = state.tokens;
    let listDepth = 0;
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        // Track list nesting depth
        if (token.type === 'ordered_list_open' || token.type === 'bullet_list_open') listDepth++;
        else if (token.type === 'ordered_list_close' || token.type === 'bullet_list_close') listDepth--;
        // If we're inside a list and encounter a blockquote, transform it
        if (listDepth > 0 && token.type === 'blockquote_open') {
            // Find the matching blockquote_close
            let closeIndex = -1;
            let depth = 1;
            for(let j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === 'blockquote_open') depth++;
                else if (tokens[j].type === 'blockquote_close') {
                    depth--;
                    if (depth === 0) {
                        closeIndex = j;
                        break;
                    }
                }
            }
            if (closeIndex !== -1) {
                // Mark the blockquote tokens for removal
                token.type = 'blockquote_fallback_open';
                token.hidden = true;
                tokens[closeIndex].type = 'blockquote_fallback_close';
                tokens[closeIndex].hidden = true;
                // Process the content inside the blockquote
                // We need to wrap the inline content with emphasis marks
                for(let j = i + 1; j < closeIndex; j++){
                    const innerToken = tokens[j];
                    if (innerToken.type === 'inline' && innerToken.children) {
                        // Wrap all children with em marks
                        const emOpen = new state.Token('em_open', 'em', 1);
                        emOpen.block = false;
                        const emClose = new state.Token('em_close', 'em', -1);
                        emClose.block = false;
                        innerToken.children = [
                            emOpen,
                            ...innerToken.children,
                            emClose
                        ];
                    }
                }
            }
        }
    }
    // Filter out the hidden blockquote fallback tokens
    state.tokens = tokens.filter((t)=>t.type !== 'blockquote_fallback_open' && t.type !== 'blockquote_fallback_close');
};
const $d2188aa6b0aad9ac$var$mdPluginListBlockquoteFallback = (md)=>{
    md.core.ruler.push('list_blockquote_fallback', $d2188aa6b0aad9ac$var$listBlockquoteFallback);
};
var $d2188aa6b0aad9ac$export$2e2bcd8739ae039 = $d2188aa6b0aad9ac$var$mdPluginListBlockquoteFallback;
module.exports["default"] = $d2188aa6b0aad9ac$export$2e2bcd8739ae039;

});

parcelRegister("8Idwp", function(module, exports) {
$parcel$export(module.exports, "default", () => $5125c80d561f745e$export$2e2bcd8739ae039);
/**
Note: This implementation was built by referencing Editor AI
packages/editor/editor-plugin-ai/src/prebuilt/content-transformers/markdown-to-pm/md/media-md-plugin.ts

Aside from a refactor, the key differences in logic are:
- Our regex is more specific, and will only match images that are not inside single backticks otherwise we'll see AI Mate render images surrounded by single backticks
*/ function $5125c80d561f745e$var$createRule() {
    // Match any images that aren't inside single backticks
    const mdImageRegex = RegExp("(?<!`)!\\[[^\\]]*\\]\\([^\\)]+\\)(?!`)", "g");
    const validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open'
    ];
    return function media(State) {
        const getUrl = (str)=>{
            const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                const href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        const createMediaTokens = (url)=>{
            const mediaSingleOpen = new State.Token('media_single_open', '', 1);
            const media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ]
            ];
            const mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        const createInlineTokens = (str, openingTokens, closingTokens)=>{
            if (!str || str.length === 0) return [];
            const inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [
                ...openingTokens,
                inlineBefore,
                ...closingTokens
            ];
        };
        let processedTokens = [];
        // Track the difference between original array indices and accumulated tokens indices
        // This is needed because when we skip processed tokens, the indices diverge
        let indexOffset = 0;
        const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
            if (token.type === 'inline' && mdImageRegex.test(token.content)) {
                const openingTokens = [];
                let cursor = i - 1;
                let previousToken = arr[cursor];
                let subTree = [];
                // Loop backwards through the tokens until a valid parent token is found
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                // If the previous token is not a valid parent token, add it to the start of the opening tokens array
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                // Create closing tokens for each opening token and reverse the array
                const closingTokens = openingTokens.map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                const matches = token.content.match(mdImageRegex);
                // Process all images in the inline token
                let inlineContentStack = token.content;
                matches.forEach((match)=>{
                    const start = inlineContentStack.indexOf(match);
                    const contentBefore = inlineContentStack.substring(0, start);
                    inlineContentStack = inlineContentStack.substring(start + match.length);
                    // Add the inline tokens and media tokens to the subtree
                    subTree = [
                        ...subTree,
                        ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                        ...createMediaTokens(match)
                    ];
                });
                // If there is any remaining content in the stack, add the inline tokens to the subtree
                if (inlineContentStack.length) subTree = [
                    ...subTree,
                    ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                ];
                processedTokens = [
                    ...processedTokens,
                    ...closingTokens.map((c)=>c.type)
                ];
                // Adjust cursor to account for previously skipped/modified tokens
                const adjustedCursor = cursor - indexOffset;
                tokens = [
                    ...tokens.slice(0, adjustedCursor),
                    ...subTree
                ];
                // Update offset: we consumed (i - cursor + 1) original tokens and added subTree.length
                indexOffset += i + 1 - cursor - subTree.length;
            } else if (processedTokens.indexOf(token.type) !== -1) {
                // Ignore token if it's already processed
                processedTokens.splice(processedTokens.indexOf(token.type), 1);
                // We skipped a token, so the offset increases
                indexOffset++;
            } else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
var $5125c80d561f745e$export$2e2bcd8739ae039 = (md)=>{
    md.core.ruler.before('inline', 'media', $5125c80d561f745e$var$createRule());
};

});

parcelRegister("a52Mw", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6cf044b287ff6bb$export$2e2bcd8739ae039);
// Regex test is based on what's documented here:
// https://hello.atlassian.net/wiki/spaces/I/pages/1124693006/AAID+Format
const $d6cf044b287ff6bb$var$isPeopleLink = (url)=>{
    return /^\/people\/[a-zA-Z0-9_\|\-\:]{1,128}$/g.test(url);
};
const $d6cf044b287ff6bb$var$getAccountId = (url)=>{
    const match = url.match(/\/people\/([a-zA-Z0-9_\|\-\:]{1,128})/);
    return match ? match[1] : null;
};
const $d6cf044b287ff6bb$var$mentionLinks = (state)=>{
    const tokens = [];
    for (const token of state.tokens){
        const tokenChildren = [];
        // We're only looking for inline children
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken, i)=>{
            const url = childToken.attrGet('href') ?? '';
            const discardedToken = [
                'link_close',
                'text'
            ].includes(childToken.type) && [
                tokenChildren[i - 1]?.type,
                tokenChildren[i - 2]?.type
            ].includes('mention');
            // Discarded tokens are preserved as `null` so index
            // cross-referencing between processed and raw tokens may
            // be preserved, however null are filtered out later.
            if (discardedToken) {
                tokenChildren.push(null);
                return;
            }
            if (childToken.type === 'link_open' && $d6cf044b287ff6bb$var$isPeopleLink(url)) {
                const mentionText = token.children?.[i + 1]?.content ?? '';
                let mentionToken = new state.Token('mention', '', 0);
                mentionToken.content = '';
                mentionToken.block = false;
                mentionToken.level = childToken.level;
                mentionToken.attrSet('id', `${$d6cf044b287ff6bb$var$getAccountId(url)}`);
                if (mentionText) mentionToken.attrSet('text', `@${mentionText}`);
                tokenChildren.push(mentionToken);
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
var $d6cf044b287ff6bb$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('mention', $d6cf044b287ff6bb$var$mentionLinks);

});

parcelRegister("ejOiD", function(module, exports) {

var $kUcLs = parcelRequire("kUcLs");

const $b36376af2b96b431$var$linkPatternStart = '\\bhttps?:\\/\\/(?:www\\.)?';
const $b36376af2b96b431$var$linkPatternEnd = '[^\\s\\]\\)]*';
const $b36376af2b96b431$var$linkRegex = {
    youtube: `${$b36376af2b96b431$var$linkPatternStart}youtube\\.com${$b36376af2b96b431$var$linkPatternEnd}`,
    youtubeShortUrl: `${$b36376af2b96b431$var$linkPatternStart}youtu\\.be${$b36376af2b96b431$var$linkPatternEnd}`,
    loomVideo: `${$b36376af2b96b431$var$linkPatternStart}loom\\.com\\/share\\/${$b36376af2b96b431$var$linkPatternEnd}`,
    figmaFile: `${$b36376af2b96b431$var$linkPatternStart}figma\\.com\\/(file|design)\\/${$b36376af2b96b431$var$linkPatternEnd}`,
    confluenceWhiteboard: `${$b36376af2b96b431$var$linkPatternStart}.*\\/wiki\\/spaces\\/.*\\/whiteboard\\/${$b36376af2b96b431$var$linkPatternEnd}`,
    googlePresentationAndSpreadsheet: `${$b36376af2b96b431$var$linkPatternStart}docs\\.google\\.com\\/(presentation|spreadsheets)\\/d\\/${$b36376af2b96b431$var$linkPatternEnd}`,
    googleDoc: `${$b36376af2b96b431$var$linkPatternStart}docs\\.google\\.com\\/(document)\\/d\\/${$b36376af2b96b431$var$linkPatternEnd}`,
    googleForm: `${$b36376af2b96b431$var$linkPatternStart}docs\\.google\\.com\\/forms\\/d\\/${$b36376af2b96b431$var$linkPatternEnd}`,
    microsoftForm: `${$b36376af2b96b431$var$linkPatternStart}forms\\.office\\.com\\/Pages\\/ResponsePage\\.aspx\\?id\\=${$b36376af2b96b431$var$linkPatternEnd}`,
    // this will be removed following project
    analyticsChart: `\\bhttps://[^.]+\\.(atlassian\\.net|jira-dev\\.com)/analytics/[^/]+/chart-${$b36376af2b96b431$var$linkPatternEnd}` // this will be removed following project
};
const $b36376af2b96b431$var$newThirdPartyLinkRegex = {
    github: `${$b36376af2b96b431$var$linkPatternStart}github\\.com${$b36376af2b96b431$var$linkPatternEnd}`,
    canvaDesign: `${$b36376af2b96b431$var$linkPatternStart}canva\\.com\\/design\\/[a-zA-Z0-9_\\-.]{1,255}\\/[a-zA-Z0-9_\\-.]{1,255}(?:\\/[^\\s\\]\\)]*)?`,
    canvaShortLink: `${$b36376af2b96b431$var$linkPatternStart}canva\\.link\\/[a-zA-Z0-9]+(?:\\?${$b36376af2b96b431$var$linkPatternEnd})?`,
    rovo: `${$b36376af2b96b431$var$linkPatternStart}[^\\s\\]\\)]*\\.atlassian\\.net\\/rovo${$b36376af2b96b431$var$linkPatternEnd}`,
    amplitude: `${$b36376af2b96b431$var$linkPatternStart}app\\.amplitude\\.com${$b36376af2b96b431$var$linkPatternEnd}`
};
const $b36376af2b96b431$var$buildEmbedRegex = (includeNewThirdParties)=>{
    const patterns = [
        ...Object.values($b36376af2b96b431$var$linkRegex),
        ...includeNewThirdParties ? Object.values($b36376af2b96b431$var$newThirdPartyLinkRegex) : []
    ];
    return new RegExp(patterns.join('|'), 'g');
};
const $b36376af2b96b431$var$embedInlineRegex = [
    // avpRovoSkillsChart
    `${$b36376af2b96b431$var$linkPatternStart}avp-rovo-skills\\.[-\\w]+.frontend.public.atl-paas.net/v1/chart[^\\s\\)]+${$b36376af2b96b431$var$linkPatternEnd}`
];
const $b36376af2b96b431$var$avpChartsRegex = `${$b36376af2b96b431$var$linkPatternStart}.*?\\/avpviz\\/c\\/[^\\/]+.*${$b36376af2b96b431$var$linkPatternEnd}`;
/**
 * Checks if there is more than one link in the token stream.
 * Used to determine if all links should be rendered inline instead of as embeds.
 */ const $b36376af2b96b431$var$hasMultipleLinks = (tokens)=>{
    let linkCount = 0;
    for (const token of tokens){
        if (token.type !== 'inline' || !token.children) continue;
        for (const childToken of token.children)if (childToken?.type === 'link_open') {
            linkCount++;
            if (linkCount > 1) return true; // Early exit once we find more than one
        }
    }
    return false;
};
const $b36376af2b96b431$var$createSmartLinks = ({ regexStorage: regexStorage, isExperimentEnabled: isExperimentEnabled, shouldShowAsInline: shouldShowAsInline, xpcWrapUrl: xpcWrapUrl })=>(state)=>{
        const embedRegex = $b36376af2b96b431$var$buildEmbedRegex(isExperimentEnabled?.('rovo_chat_smartlink_new_third_parties', false) ?? false);
        const tokens = [];
        const embedTokens = [];
        let embedMatches = [];
        let filteredTokens = [];
        const renderedInlineEmbeds = new Set();
        // If there are more than one link or the user opened the chat in mini modal, all links display inline
        const forceAllToInline = $b36376af2b96b431$var$hasMultipleLinks(state.tokens) || shouldShowAsInline;
        // process each token to determine if the link should be converted to a smartlink
        for (const token of state.tokens){
            let processedTokenChildren = [];
            const regexMatchesRaw = token.content?.trim().match(embedRegex);
            const regexMatches = regexMatchesRaw ? Array.from(new Set(regexMatchesRaw)) : [];
            embedMatches = [
                ...embedMatches,
                ...regexMatches
            ];
            // Any block or embed Smart Card links will be in an "inline" token. If
            // the current token is anything other than "inline", or there's no child tokens
            // to process, then we add it to the list of tokens to keep and move forward
            if (token.type !== 'inline' || !token.children) {
                tokens.push(token);
                continue;
            }
            var outputToken = new state.Token('inline', '', 0);
            let tokensToAppend = [
                outputToken
            ];
            if (token.children) {
                let discardUntilIndex = -1;
                token.children.forEach((childToken, i)=>{
                    const discardedToken = i <= discardUntilIndex && [
                        'link_close',
                        'text'
                    ].includes(childToken.type);
                    if (discardedToken) return;
                    const url = childToken.attrGet('href') ?? '';
                    const isInlineLink = url === token.children?.[i + 1]?.content;
                    if (childToken?.type === 'link_open' && ((0, $kUcLs.isSupportedByLinkingPlatform)(url, regexStorage) || isInlineLink)) {
                        // Discard the next two tokens. We're now processing the opening node for a URL
                        // that will result in a new node that replaces it, therefore the subsequent link content and
                        // closing node are no longer needed
                        discardUntilIndex = i + 2;
                        // This link will be rendered as a smart link (embed or inline card) by the linking
                        // platform, so we only strip the `datasource` param without applying full XPC wrapping.
                        const smartLinkUrl = xpcWrapUrl ? xpcWrapUrl(url, true) : url;
                        // Check if this link should be rendered as an embed card inline (e.g., Loom, YouTube, Figma) at end of result
                        const matchesEmbedRegex = url.match(embedRegex);
                        if (matchesEmbedRegex && !embedMatches.includes(url)) embedMatches.push(url);
                        // handle condition for when link in the token content matches the linkRegex
                        const shouldRenderLinksAsEmbed = matchesEmbedRegex;
                        const shouldRenderAvpRovoSkillsEmbedInline = token.level <= 1 && $b36376af2b96b431$var$embedInlineRegex.some((r)=>url.match(r));
                        const shouldRenderAvpChartsEmbedInline = token.level <= 1 && url.match($b36376af2b96b431$var$avpChartsRegex);
                        const shouldRenderAvpEmbedInline = shouldRenderAvpRovoSkillsEmbedInline || shouldRenderAvpChartsEmbedInline;
                        // Render inline embed if either regex matches and token content is not part of a list
                        const shouldRenderEmbedInline = shouldRenderLinksAsEmbed && token.level <= 1;
                        if (shouldRenderAvpEmbedInline || shouldRenderLinksAsEmbed) {
                            // handle case if it is an analytic chart link or microsoft form link
                            // these should be rendered as inline cards, not embed cards
                            const isMicrosoftFormLink = new RegExp($b36376af2b96b431$var$linkRegex.microsoftForm).test(url);
                            const isAnalyticsChartLink = new RegExp($b36376af2b96b431$var$linkRegex.analyticsChart).test(url);
                            if (!forceAllToInline && shouldRenderEmbedInline && !isMicrosoftFormLink && !isAnalyticsChartLink || shouldRenderAvpEmbedInline) {
                                outputToken.children = processedTokenChildren;
                                tokensToAppend.push(new state.Token('paragraph_close', '', 0));
                                // Capture whether the URL was standalone on its own line
                                // (i.e. there was no preceding text in the same paragraph)
                                const isStandaloneUrl = processedTokenChildren.length === 0;
                                processedTokenChildren = [];
                                let embedToken = new state.Token('embedCard', '', 0);
                                embedToken.content = '';
                                embedToken.block = true;
                                embedToken.attrSet('url', smartLinkUrl);
                                embedToken.attrSet('layout', 'center');
                                // Mark whether this embed came from a standalone-line URL
                                if (isStandaloneUrl && isExperimentEnabled?.('rovo_chat_smartlink_new_third_parties', false)) embedToken.attrSet('isStandalone', 'true');
                                tokensToAppend.push(embedToken);
                                tokensToAppend.push(new state.Token('paragraph_open', '', 0));
                                outputToken = new state.Token('inline', '', 0);
                                tokensToAppend.push(outputToken);
                                // Track that we've rendered this URL as an inline embed
                                renderedInlineEmbeds.add(url);
                                return;
                            }
                        }
                        // create an inline card for the links that don't qualify
                        let cardToken = new state.Token('inlineCard', '', 0);
                        cardToken.content = '';
                        cardToken.block = false;
                        cardToken.level = childToken.level;
                        cardToken.attrSet('url', smartLinkUrl);
                        processedTokenChildren.push(cardToken);
                        return;
                    } else if (xpcWrapUrl && childToken?.type === 'link_open') // For plain links not supported by the linking platform, apply xpcWrapUrl (with full wrapping) to the href
                    childToken.attrSet('href', xpcWrapUrl(url, false));
                    // pushes non link tokens as is
                    processedTokenChildren.push(childToken);
                });
            }
            // set processed children to the output token
            outputToken.children = processedTokenChildren;
            // Keeps inline tokens that have children and all non-inline tokens.
            const blockTokensWithContent = tokensToAppend.filter((t)=>t.type !== 'inline' || t.children?.length);
            tokens.push(...blockTokensWithContent);
        }
        // Remove empty paragraphs otherwise add it to the filteredTokens
        for(let i = 0; i < tokens.length; i++)if (i < tokens.length - 1 && tokens[i].type === 'paragraph_open' && tokens[i + 1].type === 'paragraph_close') i = i + 1;
        else filteredTokens.push(tokens[i]);
        state.tokens = [
            ...filteredTokens,
            ...embedTokens
        ];
        return;
    };
const $b36376af2b96b431$export$9625a798761643ac = (params, isExperimentEnabled, shouldShowAsInline, xpcWrapUrl)=>(md)=>md.core.ruler.push('inlineCard', $b36376af2b96b431$var$createSmartLinks({
            ...params,
            isExperimentEnabled: isExperimentEnabled,
            shouldShowAsInline: shouldShowAsInline,
            xpcWrapUrl: xpcWrapUrl
        }));
module.exports["createSmartLinksPlugin"] = $b36376af2b96b431$export$9625a798761643ac;

});

parcelRegister("kUcLs", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $3LOz3 = parcelRequire("3LOz3");

const $300d1def19fa699b$export$4b1056d02426889c = (url, regexStorage)=>{
    const cachedProviderRegex = $300d1def19fa699b$export$90caa0c170ea581(regexStorage);
    if (!cachedProviderRegex.length || !url.length) return false;
    try {
        const regexPattern = new RegExp(cachedProviderRegex, 'g');
        return regexPattern.test(url);
    } catch  {
        // Malformed joined provider regex (e.g. duplicate named capture groups) — treat as unsupported.
        return false;
    }
};
const $300d1def19fa699b$export$90caa0c170ea581 = (regexStorage)=>{
    if (regexStorage.getItem((0, $3LOz3.LS_PROVIDER_KEY))) return JSON.parse(`${regexStorage.getItem((0, $3LOz3.LS_PROVIDER_KEY))}`);
    return '';
};
const $300d1def19fa699b$export$5af966b3aa3b1d83 = (regexStorage, providerRegex)=>{
    regexStorage?.setItem((0, $3LOz3.LS_PROVIDER_KEY), JSON.stringify(providerRegex));
};
const $300d1def19fa699b$export$d08c351b3b4e4934 = async (regexStorage, baseUrl)=>{
    const providerData = await $300d1def19fa699b$export$dfebbb511ada4128(baseUrl);
    if (providerData) {
        const providerRegex = $300d1def19fa699b$export$b7ac97ae80c7eb5a(providerData);
        $300d1def19fa699b$export$5af966b3aa3b1d83(regexStorage, providerRegex);
        const providerMapping = $300d1def19fa699b$export$8eafd18d19de7df5(providerData);
        $300d1def19fa699b$export$b22dfe84603542b1(regexStorage, providerMapping);
    }
};
const $300d1def19fa699b$export$b7ac97ae80c7eb5a = (data)=>{
    if (!data?.providers || !Array.isArray(data.providers)) return '';
    const sources = data.providers.reduce((acc, provider)=>{
        const providerSources = provider.patterns?.map((pattern)=>pattern.source) || [];
        return [
            ...acc,
            ...providerSources
        ];
    }, []);
    return sources.join('|');
};
const $300d1def19fa699b$export$8eafd18d19de7df5 = (data)=>{
    if (!data?.providers || !Array.isArray(data.providers)) return {
        combinedRegex: '',
        patterns: []
    };
    const patterns = data.providers.flatMap((provider)=>(provider.patterns || []).map((pattern)=>({
                key: provider.key,
                regex: pattern.source
            })));
    const combinedRegex = patterns.map((p)=>p.regex).join('|');
    return {
        combinedRegex: combinedRegex,
        patterns: patterns
    };
};
const $300d1def19fa699b$export$25b8a9cebf834f6e = (regexStorage)=>{
    const stored = regexStorage.getItem((0, $3LOz3.LS_PROVIDER_MAPPING_KEY));
    if (stored) try {
        return JSON.parse(stored);
    } catch  {
        return null;
    }
    return null;
};
const $300d1def19fa699b$export$b22dfe84603542b1 = (regexStorage, providerMapping)=>{
    regexStorage?.setItem((0, $3LOz3.LS_PROVIDER_MAPPING_KEY), JSON.stringify(providerMapping));
};
const $300d1def19fa699b$export$dfebbb511ada4128 = (0, $dOBRD.default)(async (baseUrl = '')=>{
    try {
        const response = await fetch(baseUrl + (0, $3LOz3.PROVIDERS_API), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                type: 'resolve'
            })
        });
        const data = await response.json();
        return data || null;
    } catch  {
        return null;
    }
});
const $300d1def19fa699b$export$ab8eaff0f2d596bd = (0, $dOBRD.default)(async (baseUrl = '')=>{
    const data = await $300d1def19fa699b$export$dfebbb511ada4128(baseUrl);
    return data ? $300d1def19fa699b$export$b7ac97ae80c7eb5a(data) : '';
});
module.exports["isSupportedByLinkingPlatform"] = $300d1def19fa699b$export$4b1056d02426889c;
module.exports["hydrateLinkingPlatformCache"] = $300d1def19fa699b$export$d08c351b3b4e4934;

});

parcelRegister("3LOz3", function(module, exports) {
const $88340c96f33dece1$export$57ad190cdc563df3 = `/gateway/api/object-resolver/providers`;
const $88340c96f33dece1$export$1a30f994aeced995 = `/gateway/api/object-resolver/resolve/batch`;
const $88340c96f33dece1$export$56bec2f197c16818 = 'aiMateSmartLinkProviders';
const $88340c96f33dece1$export$b9858121ed269ff3 = 'aiMateSmartLinkProviderMapping';
module.exports["PROVIDERS_API"] = $88340c96f33dece1$export$57ad190cdc563df3;
module.exports["LS_PROVIDER_KEY"] = $88340c96f33dece1$export$56bec2f197c16818;
module.exports["LS_PROVIDER_MAPPING_KEY"] = $88340c96f33dece1$export$b9858121ed269ff3;

});

parcelRegister("1JPkQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $75906c97e0460a14$export$2e2bcd8739ae039);
const $75906c97e0460a14$var$tableBreakTags = (state)=>{
    const tokens = state.tokens;
    // Find all table tokens
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        // Check if we're inside a table
        if (token.type === 'table_open') {
            // Process all tokens until the matching table_close
            let j = i + 1;
            while(j < tokens.length && tokens[j].type !== 'table_close'){
                // If we're in a table cell content
                if (tokens && tokens[j]?.type === 'inline' && tokens[j]?.children && tokens[j]?.children?.length) {
                    // Process the content of the cell
                    const children = tokens[j]?.children;
                    if (!children) continue;
                    for(let k = 0; k < children.length; k++){
                        const child = children[k];
                        if (!child) continue;
                        // Replace <br>, <br/>, and <br /> tags with newlines
                        // Match different variations of <br> tags
                        const brRegex = /<br\s*\/?>/gi;
                        if (brRegex.test(child.content)) {
                            child.content = child.content.replace(brRegex, '\n');
                            // If the content is now just a newline, change the token type
                            if (child.content === '\n') child.type = 'hardbreak';
                        }
                    }
                }
                j++;
            }
            // Skip to the end of the table
            i = j;
        }
    }
    return;
};
var $75906c97e0460a14$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('table-break-tags', $75906c97e0460a14$var$tableBreakTags);

});

parcelRegister("dapfS", function(module, exports) {
$parcel$export(module.exports, "default", () => $1502a9fc09adec99$export$2e2bcd8739ae039);
const $1502a9fc09adec99$var$CHART_REGEX = /\[\^(chart)\^\]/;
const $1502a9fc09adec99$var$visualizationChart = (state)=>{
    const tokens = [];
    let chartCounter = 0;
    for (const token of state.tokens){
        const tokenChildren = [];
        if (token.type !== 'inline' || token.children && token?.children?.length <= 0) {
            tokens.push(token);
            continue;
        }
        if (token.children) token.children.forEach((childToken)=>{
            if (childToken.type === 'text' && $1502a9fc09adec99$var$CHART_REGEX.test(childToken.content)) {
                const parts = childToken.content.split($1502a9fc09adec99$var$CHART_REGEX);
                parts.forEach((part, index)=>{
                    if (index % 2 === 0) {
                        const textToken = new state.Token('text', '', 0);
                        textToken.content = part;
                        textToken.level = childToken.level;
                        tokenChildren.push(textToken);
                    } else {
                        // Create a new token for each chart match
                        const chartToken = new state.Token('status', '', 0);
                        chartToken.content = '';
                        chartToken.block = false;
                        chartToken.level = childToken.level;
                        chartToken.attrs = [
                            [
                                'localId',
                                'chart-' + chartCounter
                            ],
                            [
                                'text',
                                'loading chart-' + chartCounter
                            ],
                            [
                                'color',
                                'blue'
                            ]
                        ];
                        tokenChildren.push(chartToken);
                        chartCounter++;
                    }
                });
                return;
            }
            tokenChildren.push(childToken);
        });
        const filteredTokenChildren = tokenChildren.filter((childToken)=>childToken !== null);
        token.children = filteredTokenChildren;
        tokens.push(token);
    }
    state.tokens = tokens;
    return;
};
function $1502a9fc09adec99$export$2e2bcd8739ae039(md) {
    md.core.ruler.push('chart', $1502a9fc09adec99$var$visualizationChart);
}

});

parcelRegister("6X3gJ", function(module, exports) {
const $d663afbcbcce9912$export$cd54a56af01ba875 = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
const $d663afbcbcce9912$export$eb83d753215c78a2 = {
    blockquote: {
        block: 'blockquote'
    },
    paragraph: {
        block: 'paragraph'
    },
    em: {
        mark: 'em'
    },
    strong: {
        mark: 'strong'
    },
    link: {
        mark: 'link',
        attrs: (tok)=>({
                href: tok.attrGet('href'),
                title: tok.attrGet('title') || null
            })
    },
    table: {
        block: 'table'
    },
    tr: {
        block: 'tableRow'
    },
    th: {
        block: 'tableHeader'
    },
    td: {
        block: 'tableCell'
    },
    s: {
        mark: 'strike'
    },
    task_list: {
        block: 'taskList'
    },
    task_item: {
        block: 'taskItem',
        attrs: (tok)=>({
                state: tok.meta
            })
    },
    hr: {
        node: 'rule'
    },
    heading: {
        block: 'heading',
        attrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    softbreak: {
        node: 'hardBreak'
    },
    hardbreak: {
        node: 'hardBreak'
    },
    code_block: {
        block: 'codeBlock'
    },
    list_item: {
        block: 'listItem'
    },
    bullet_list: {
        block: 'bulletList'
    },
    code_inline: {
        mark: 'code'
    },
    ordered_list: {
        block: 'orderedList',
        attrs: (tok)=>{
            const order = +(tok.attrGet('start') || 1);
            return {
                order: order
            };
        }
    },
    fence: {
        block: 'codeBlock',
        // we trim any whitespaces around language definition
        attrs: (tok)=>({
                language: tok.info?.trim() || null
            })
    },
    image: {
        node: 'image',
        attrs: (_tok)=>{
            return {};
        }
    },
    media_single: {
        block: 'mediaSingle',
        attrs: ()=>({})
    },
    media: {
        node: 'media',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url'),
                type: 'external'
            };
        }
    },
    // Enable ADF SmartLinks, produced by our SmartLink MD plugin
    inlineCard: {
        node: 'inlineCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    blockCard: {
        node: 'blockCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    embedCard: {
        node: 'embedCard',
        attrs: (tok)=>{
            return {
                url: tok.attrGet('url')
            };
        }
    },
    // Enable ADF Mentions, produced by our Mentions MD plugin which converts /people links
    mention: {
        node: 'mention',
        attrs: (tok)=>{
            return {
                id: tok.attrGet('id'),
                text: tok.attrGet('text'),
                type: 'mention'
            };
        }
    },
    status: {
        node: 'status',
        attrs: (token)=>({
                text: token.attrGet('text'),
                color: token.attrGet('color'),
                localId: token.attrGet('localId')
            })
    }
};
module.exports["pmToMd"] = $d663afbcbcce9912$export$cd54a56af01ba875;
module.exports["mdToPmSchema"] = $d663afbcbcce9912$export$eb83d753215c78a2;

});

parcelRegister("bf7Qg", function(module, exports) {
/**
 * Sanitizes raw markdown content before it reaches the markdown-it block tokenizer.
 *
 * Two constructs cause `ParserBlock.prototype.tokenize` to enter catastrophic
 * backtracking / exponential rule-matching, causing OOM browser crashes:
 *
 * ## 1. Tables indented 2+ spaces (inside a list item)
 *
 * The `markdown-it-table` plugin requires the table header row to start at
 * column 0 (or ≤1 space of indentation). When an AI response places a table
 * inside a list item — a common pattern — the table rows are indented with
 * 2+ spaces and are never recognized as a table block.
 *
 * Instead, each `|---` separator row triggers markdown-it's `lheading`
 * (setext heading) rule which checks whether the preceding paragraph can be
 * promoted to a heading. This check is O(n) against all prior paragraphs,
 * repeated for every `|` row in the table → O(n²) overall. For documents
 * with 200+ lines and multiple tables, this crashes the browser.
 *
 * ## 2. Code fences indented 4+ spaces (inside nested list items)
 *
 * markdown-it's `fence` block rule only recognizes fences with 0–3 spaces of
 * leading indentation. Fences indented with 4+ spaces (common inside nested
 * list items like "     ```jql") are treated as indented code continuation,
 * meaning the opening fence is never paired with its closing fence. The block
 * parser then tries every rule against the remaining content until EOF →
 * effectively infinite loop → OOM.
 *
 * ## Fix
 *
 * Strip excess leading whitespace from table rows and fence delimiters so
 * they are recognized by the parser as valid block-level constructs. A
 * fence-tracking state machine ensures that table rows and fence delimiters
 * *inside* a code fence are never modified.
 */ // Fast pre-check: matches a line starting with 2+ spaces followed by `|` or ` ``` `.
// Uses (^|\n) so it also catches indented constructs on the very first line.
// If the content has neither, skip the full line-by-line pass entirely.
const $75f540d30ffc20bf$var$NEEDS_SANITIZE_RE = /(?:^|\n) {2,}[|`]/;
function $75f540d30ffc20bf$export$20209a1e2cc01cc1(content) {
    if (!$75f540d30ffc20bf$var$NEEDS_SANITIZE_RE.test(content)) return content;
    const lines = content.split('\n');
    const result = [];
    let inFence = false;
    let fenceIndent = 0;
    for (const line of lines){
        const stripped = line.replace(/^\s+/, '');
        const indent = line.length - stripped.length;
        if (!inFence && stripped.startsWith('```')) {
            if (indent >= 4) {
                // Outdent deeply-indented opening fence to column 0 so the parser
                // recognizes it as a fenced code block
                result.push(stripped);
                inFence = true;
                fenceIndent = indent;
            } else {
                result.push(line);
                inFence = true;
                fenceIndent = indent;
            }
        } else if (inFence && stripped.startsWith('```')) {
            if (indent >= 4 && fenceIndent >= 4) // Outdent matching closing fence
            result.push(stripped);
            else result.push(line);
            inFence = false;
            fenceIndent = 0;
        } else if (!inFence && indent >= 2 && stripped.startsWith('|')) // Outdent table rows that are indented inside list items so
        // markdown-it-table recognizes them as a proper table block
        result.push(stripped);
        else result.push(line);
    }
    return result.join('\n');
}
// Matches a markdown table delimiter/separator row, with or without outer pipes,
// e.g. "--- | ---", "| :--- | ---: |", ":-:|:-:". Requires at least one dash.
const $75f540d30ffc20bf$var$SEPARATOR_ROW_RE = /^\s*\|?\s*:?-{3,}:?\s*(?:\|\s*:?-{3,}:?\s*)*\|?\s*$/;
const $75f540d30ffc20bf$var$isSeparatorRow = (line)=>line.includes('-') && $75f540d30ffc20bf$var$SEPARATOR_ROW_RE.test(line);
const $75f540d30ffc20bf$var$isTableRow = (line)=>line.includes('|') && line.trim().length > 0;
function $75f540d30ffc20bf$export$d000c4875e648c8(content) {
    // Fast pre-check: needs at least one line with a pipe.
    if (!content.includes('|')) return content;
    const addOuterPipes = (line)=>{
        let trimmed = line.trim();
        if (!trimmed.startsWith('|')) trimmed = `| ${trimmed}`;
        if (!trimmed.endsWith('|')) trimmed = `${trimmed} |`;
        return trimmed;
    };
    const isFenceDelimiter = (line)=>line.trimStart().startsWith('```');
    const lines = content.split('\n');
    const result = [];
    let inFence = false;
    for(let i = 0; i < lines.length; i++){
        const line = lines[i];
        // Skip fenced code blocks entirely.
        if (isFenceDelimiter(line)) {
            inFence = !inFence;
            result.push(line);
            continue;
        }
        const next = lines[i + 1];
        // A table starts on a row immediately followed by a separator.
        if (!inFence && $75f540d30ffc20bf$var$isTableRow(line) && next !== undefined && $75f540d30ffc20bf$var$isSeparatorRow(next)) {
            let j = i;
            // Consume contiguous, non-blank rows until the table ends.
            while(j < lines.length && lines[j].trim() !== '' && $75f540d30ffc20bf$var$isTableRow(lines[j])){
                result.push(addOuterPipes(lines[j]));
                j++;
            }
            i = j - 1;
        } else result.push(line);
    }
    return result.join('\n');
}
module.exports["sanitizeMarkdown"] = $75f540d30ffc20bf$export$20209a1e2cc01cc1;
module.exports["normalizeBorderlessTables"] = $75f540d30ffc20bf$export$d000c4875e648c8;

});

parcelRegister("k73tv", function(module, exports) {

var $6X3gJ = parcelRequire("6X3gJ");

const $f6c1dd52940ddca5$export$155749302793c60c = (schema, map)=>Object.keys(map).reduce((newMap, key)=>{
        const value = map[key];
        const block = value.block || value.node;
        const mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
const $f6c1dd52940ddca5$export$a1cf9d9b96e16789 = (md, schema)=>{
    for(const k in 0, $6X3gJ.pmToMd){
        const key = k;
        for(const i in (0, $6X3gJ.pmToMd)[key]){
            const idx = i;
            if (schema[key][idx]) md.enable((0, $6X3gJ.pmToMd)[key][idx]);
        }
    }
};
module.exports["filterSchemaMapping"] = $f6c1dd52940ddca5$export$155749302793c60c;
module.exports["enableSchemaPlugins"] = $f6c1dd52940ddca5$export$a1cf9d9b96e16789;

});

parcelRegister("8lhhf", function(module, exports) {
const $57d7e56ed333ab64$export$d0e832101df0ac96 = 'com.atlassian.rovo.skill';
const $57d7e56ed333ab64$export$d4f002c79ea2ad20 = 'skill';
const $57d7e56ed333ab64$export$e4d0b30afd49f7df = 'skillTag';
const $57d7e56ed333ab64$export$18f911e214c46d8 = /\/([a-zA-Z0-9-]+)/g;
const $57d7e56ed333ab64$export$aae1b80712c1b67b = `${$57d7e56ed333ab64$export$d4f002c79ea2ad20}:${$57d7e56ed333ab64$export$e4d0b30afd49f7df}`;
const $57d7e56ed333ab64$export$b22d8560058c60e1 = (extensionType, extensionKey)=>{
    return extensionType === $57d7e56ed333ab64$export$d0e832101df0ac96 && extensionKey === $57d7e56ed333ab64$export$aae1b80712c1b67b;
};
const $57d7e56ed333ab64$export$f88fd0c0ee7d509a = (skill)=>{
    return [
        {
            type: 'inlineExtension',
            attrs: {
                extensionKey: $57d7e56ed333ab64$export$aae1b80712c1b67b,
                extensionType: $57d7e56ed333ab64$export$d0e832101df0ac96,
                parameters: skill
            }
        },
        // render an empty space after the skill tag
        {
            type: 'text',
            text: ' '
        }
    ];
};
const $57d7e56ed333ab64$export$a425ebfe740d9932 = (skill)=>({
        type: 'doc',
        version: 1,
        content: [
            {
                type: 'paragraph',
                content: $57d7e56ed333ab64$export$f88fd0c0ee7d509a(skill)
            }
        ]
    });
module.exports["ROVO_SKILL_EXTENSION_TYPE"] = $57d7e56ed333ab64$export$d0e832101df0ac96;
module.exports["ROVO_SKILL_EXTENSION_KEY"] = $57d7e56ed333ab64$export$d4f002c79ea2ad20;
module.exports["ROVO_SKILL_TAG_PATTERN"] = $57d7e56ed333ab64$export$18f911e214c46d8;
module.exports["ROVO_SKILL_COMBINED_EXTENSION_KEY"] = $57d7e56ed333ab64$export$aae1b80712c1b67b;
module.exports["isSkillTagExtension"] = $57d7e56ed333ab64$export$b22d8560058c60e1;
module.exports["createSkillNode"] = $57d7e56ed333ab64$export$f88fd0c0ee7d509a;
module.exports["createSkillAdf"] = $57d7e56ed333ab64$export$a425ebfe740d9932;

});

parcelRegister("37RgG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $cd2bff7865b1d155$export$ccc6603eb027f48b = /*#__PURE__*/ (0, $cozmU.createContext)({});
const $cd2bff7865b1d155$export$7b61e11d4e81ba17 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($cd2bff7865b1d155$export$ccc6603eb027f48b);
} : ()=>(0, $cozmU.useContext)($cd2bff7865b1d155$export$ccc6603eb027f48b);
const $cd2bff7865b1d155$export$aa582af5b4b72bb2 = $cd2bff7865b1d155$export$ccc6603eb027f48b.Provider;
const $cd2bff7865b1d155$export$6aab84dc399ad753 = (config)=>({
        agentDefaultIdOverride: config?.defaultAgentId,
        agentIdFiltersOverride: config?.filter
    });
module.exports["useAgentOverrider"] = $cd2bff7865b1d155$export$7b61e11d4e81ba17;
module.exports["AgentOverriderProvider"] = $cd2bff7865b1d155$export$aa582af5b4b72bb2;
module.exports["createAgentsConfig"] = $cd2bff7865b1d155$export$6aab84dc399ad753;

});

parcelRegister("8lt5O", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $464fa95e1d18f18e$var$rovoEntitlementStore = (0, $8s9DV.createStore)({
    initialState: {
        isRovoEnabled: false
    },
    name: 'RovoEntitlementStore',
    actions: {
        setIsRovoEnabled: (isRovoEnabled, reason)=>({ setState: setState })=>{
                setState({
                    isRovoEnabled: isRovoEnabled,
                    reason: reason
                });
            }
    }
});
const $464fa95e1d18f18e$var$useStateHook = (0, $kBr4q.createStateHook)($464fa95e1d18f18e$var$rovoEntitlementStore);
const $464fa95e1d18f18e$export$66d5dd4be64dea43 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const result = $464fa95e1d18f18e$var$useStateHook();
    let t0;
    if ($[0] !== result) {
        t0 = {
            ...result,
            isRovoEnabled: result.isRovoEnabled
        };
        $[0] = result;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const result = $464fa95e1d18f18e$var$useStateHook();
    return {
        ...result,
        isRovoEnabled: result.isRovoEnabled
    };
};
const $464fa95e1d18f18e$export$8004893135276275 = (0, $kBr4q.createActionsHook)($464fa95e1d18f18e$var$rovoEntitlementStore);
const $464fa95e1d18f18e$export$d03a05ad8547472c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const { isRovoEnabled: isRovoEnabled } = t0;
    const { setIsRovoEnabled: setIsRovoEnabled } = $464fa95e1d18f18e$export$8004893135276275();
    setIsRovoEnabled(isRovoEnabled);
    return null;
} : ({ isRovoEnabled: isRovoEnabled })=>{
    const { setIsRovoEnabled: setIsRovoEnabled } = $464fa95e1d18f18e$export$8004893135276275();
    (0, $cozmU.useMemo)(()=>{
        setIsRovoEnabled(isRovoEnabled);
    }, [
        isRovoEnabled,
        setIsRovoEnabled
    ]);
    return null;
};
module.exports["useRovoEntitlement"] = $464fa95e1d18f18e$export$66d5dd4be64dea43;
module.exports["useRovoEntitlementActions"] = $464fa95e1d18f18e$export$8004893135276275;
module.exports["RovoEntitlementSetter"] = $464fa95e1d18f18e$export$d03a05ad8547472c;

});

parcelRegister("bGNkz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $cXtTj = parcelRequire("cXtTj");


var $4m5jb = parcelRequire("4m5jb");

const $af081181a641afaf$export$6fdb848aa0eff3d1 = {
    isActive: false
};
const $af081181a641afaf$var$initialState = {
    activeMenu: 'none',
    mounted: false,
    isAgentSelectorMenuOpen: false,
    streaming: false,
    isChatOnboardingMiniModalOpen: false,
    // If productionized will look to move this logic into conversation-assistant-onboarding
    emptyChatLaunchGreeting: undefined,
    emptyChatLaunchProjectContext: undefined,
    emptyChatLaunchInteractionSource: undefined,
    emptyChatLaunchInvokedFrom: undefined,
    emptyChatLaunchConversationActions: undefined,
    emptyChatLaunchReplaceProviderActions: false,
    emptyChatLaunchSkillRegistryTags: undefined,
    emptyChatLaunchId: 0,
    selectedSpace: undefined,
    activeTabId: 'suggestions',
    previousTabId: 'suggestions',
    lastTabConversationId: '',
    lastLifecycleConversationId: (0, $4m5jb.EMPTY_CONVERSATION_ID),
    lastLifecycleLaunchId: undefined,
    smartLink3PPostAuth: $af081181a641afaf$export$6fdb848aa0eff3d1
};
const $af081181a641afaf$var$store = (0, $8s9DV.createStore)({
    name: 'uiStore',
    initialState: $af081181a641afaf$var$initialState,
    actions: {
        // created for resetting store during tests
        reset: ()=>({ setState: setState })=>{
                setState({
                    ...$af081181a641afaf$var$initialState,
                    conversationHeader: null,
                    selectedSpace: undefined
                });
            },
        setActiveMenu: (menu)=>({ setState: setState })=>{
                setState({
                    activeMenu: menu
                });
            },
        setMounted: (mounted)=>({ setState: setState })=>{
                setState({
                    mounted: mounted
                });
            },
        setIsAgentSelectorMenuOpen: (isOpen)=>({ setState: setState })=>{
                setState({
                    isAgentSelectorMenuOpen: isOpen
                });
            },
        setStreamingStatus: (status)=>({ setState: setState })=>{
                setState({
                    streaming: status
                });
            },
        setIsChatOnboardingMiniModalOpen: (status)=>({ setState: setState })=>{
                setState({
                    isChatOnboardingMiniModalOpen: status
                });
            },
        setSmartLink3PPostAuth: (payload)=>({ setState: setState })=>{
                setState({
                    smartLink3PPostAuth: payload
                });
            },
        clearSmartLink3PPostAuth: ()=>({ setState: setState })=>{
                setState({
                    smartLink3PPostAuth: $af081181a641afaf$export$6fdb848aa0eff3d1
                });
            },
        setConversationHeader: (header)=>({ setState: setState })=>{
                setState({
                    conversationHeader: header
                });
            },
        getIsMounted: ()=>({ getState: getState })=>{
                return getState().mounted;
            },
        setEmptyChatLaunch: (payload)=>({ setState: setState, getState: getState })=>{
                setState({
                    emptyChatLaunchGreeting: payload.customGreeting,
                    emptyChatLaunchConversationActions: payload.customConversationActions,
                    emptyChatLaunchProjectContext: payload.projectContext,
                    emptyChatLaunchInteractionSource: payload.interactionSource,
                    emptyChatLaunchInvokedFrom: payload.invokedFrom,
                    emptyChatLaunchReplaceProviderActions: payload.replaceProviderActions ?? false,
                    emptyChatLaunchSkillRegistryTags: payload.skillRegistryTags,
                    emptyChatLaunchId: getState().emptyChatLaunchId + 1
                });
            },
        clearEmptyChatLaunchGreeting: ()=>({ setState: setState })=>{
                setState({
                    emptyChatLaunchGreeting: undefined,
                    emptyChatLaunchConversationActions: undefined,
                    emptyChatLaunchInteractionSource: undefined,
                    emptyChatLaunchInvokedFrom: undefined,
                    emptyChatLaunchReplaceProviderActions: false,
                    emptyChatLaunchSkillRegistryTags: undefined
                });
            },
        clearEmptyChatLaunchAll: ()=>({ setState: setState })=>{
                setState({
                    emptyChatLaunchGreeting: undefined,
                    emptyChatLaunchConversationActions: undefined,
                    emptyChatLaunchProjectContext: undefined,
                    emptyChatLaunchInteractionSource: undefined,
                    emptyChatLaunchInvokedFrom: undefined,
                    emptyChatLaunchReplaceProviderActions: false,
                    emptyChatLaunchSkillRegistryTags: undefined
                });
            },
        setSelectedSpace: (space)=>({ setState: setState })=>{
                setState({
                    selectedSpace: space
                });
            },
        clearSelectedSpace: ()=>({ setState: setState })=>{
                setState({
                    selectedSpace: undefined
                });
            },
        setActiveTabId: (tabId)=>({ setState: setState })=>{
                setState({
                    activeTabId: tabId
                });
            },
        setPreviousTabId: (tabId)=>({ setState: setState })=>{
                setState({
                    previousTabId: tabId
                });
            },
        setLastTabConversationId: (id)=>({ setState: setState })=>{
                setState({
                    lastTabConversationId: id
                });
            },
        checkAndUpdateLifecycleGuard: (conversationId, launchId)=>({ getState: getState, setState: setState })=>{
                const { lastLifecycleConversationId: lastLifecycleConversationId, lastLifecycleLaunchId: lastLifecycleLaunchId } = getState();
                if (lastLifecycleConversationId === conversationId && lastLifecycleLaunchId === launchId) return false;
                setState({
                    lastLifecycleConversationId: conversationId,
                    lastLifecycleLaunchId: launchId
                });
                return true;
            }
    }
});
const $af081181a641afaf$var$useStore = (0, $kBr4q.createHook)($af081181a641afaf$var$store);
const $af081181a641afaf$export$13a6c73a57f1d6a6 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            customGreeting: state.emptyChatLaunchGreeting,
            projectContext: state.emptyChatLaunchProjectContext,
            interactionSource: state.emptyChatLaunchInteractionSource,
            invokedFrom: state.emptyChatLaunchInvokedFrom,
            customConversationActions: state.emptyChatLaunchConversationActions,
            replaceProviderActions: state.emptyChatLaunchReplaceProviderActions,
            skillRegistryTags: state.emptyChatLaunchSkillRegistryTags,
            launchId: state.emptyChatLaunchId
        })
});
const $af081181a641afaf$export$81a40d215ef1c1de = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            activeTabId: state.activeTabId,
            previousTabId: state.previousTabId,
            lastTabConversationId: state.lastTabConversationId
        })
});
const $af081181a641afaf$export$5f449dc44751be0a = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            selectedSpace: state.selectedSpace
        })
});
const $af081181a641afaf$export$78ce19c6cc1eeb16 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            activeMenu: state.activeMenu,
            isAgentSelectorMenuOpen: state.isAgentSelectorMenuOpen,
            isChatOnboardingMiniModalOpen: state.isChatOnboardingMiniModalOpen,
            selectedSpace: state.selectedSpace
        })
});
const $af081181a641afaf$export$1bd034c20714e002 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            activeMenu: state.activeMenu
        })
});
const $af081181a641afaf$export$762e860bb8461339 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            mounted: state.mounted
        })
});
const $af081181a641afaf$export$d3b1853c9cb98102 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            isChatOnboardingMiniModalOpen: state.isChatOnboardingMiniModalOpen
        })
});
const $af081181a641afaf$export$f4c4584d8302c703 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            conversationHeader: state.conversationHeader
        })
});
const $af081181a641afaf$export$1e3791eaae70097a = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            smartLink3PPostAuth: state.smartLink3PPostAuth
        })
});
const $af081181a641afaf$export$357ffd05205e0c5d = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            selectedSpace: state.selectedSpace,
            isChatOnboardingMiniModalOpen: state.isChatOnboardingMiniModalOpen,
            smartLink3PPostAuth: state.smartLink3PPostAuth
        })
});
const $af081181a641afaf$export$9e369d8095358b77 = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            activeMenu: state.activeMenu,
            selectedSpace: state.selectedSpace
        })
});
const $af081181a641afaf$export$8f5523dfac6ff4fa = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>({
            activeMenu: state.activeMenu,
            selectedSpace: state.selectedSpace,
            isChatOnboardingMiniModalOpen: state.isChatOnboardingMiniModalOpen,
            smartLink3PPostAuth: state.smartLink3PPostAuth
        })
});
const $af081181a641afaf$export$5b2ba9b8ea3b0771 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(26);
    const [t0, t1] = $af081181a641afaf$var$useStore();
    const { activeMenu: activeMenu, mounted: mounted, streaming: streaming, isAgentSelectorMenuOpen: isAgentSelectorMenuOpen, isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen, conversationHeader: conversationHeader, selectedSpace: selectedSpace, activeTabId: activeTabId, previousTabId: previousTabId, lastTabConversationId: lastTabConversationId, smartLink3PPostAuth: smartLink3PPostAuth } = t0;
    const { reset: reset, setActiveMenu: setActiveMenu, setMounted: setMounted, setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen, setStreamingStatus: setStreamingStatus, setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen, setConversationHeader: setConversationHeader, setSelectedSpace: setSelectedSpace, clearSelectedSpace: clearSelectedSpace, setActiveTabId: setActiveTabId, setPreviousTabId: setPreviousTabId, setLastTabConversationId: setLastTabConversationId, setSmartLink3PPostAuth: setSmartLink3PPostAuth, clearSmartLink3PPostAuth: clearSmartLink3PPostAuth } = t1;
    const t2 = conversationHeader ?? null;
    let t3;
    if ($[0] !== activeMenu || $[1] !== activeTabId || $[2] !== clearSelectedSpace || $[3] !== clearSmartLink3PPostAuth || $[4] !== isAgentSelectorMenuOpen || $[5] !== isChatOnboardingMiniModalOpen || $[6] !== lastTabConversationId || $[7] !== mounted || $[8] !== previousTabId || $[9] !== reset || $[10] !== selectedSpace || $[11] !== setActiveMenu || $[12] !== setActiveTabId || $[13] !== setConversationHeader || $[14] !== setIsAgentSelectorMenuOpen || $[15] !== setIsChatOnboardingMiniModalOpen || $[16] !== setLastTabConversationId || $[17] !== setMounted || $[18] !== setPreviousTabId || $[19] !== setSelectedSpace || $[20] !== setSmartLink3PPostAuth || $[21] !== setStreamingStatus || $[22] !== smartLink3PPostAuth || $[23] !== streaming || $[24] !== t2) {
        t3 = {
            activeMenu: activeMenu,
            mounted: mounted,
            streaming: streaming,
            isAgentSelectorMenuOpen: isAgentSelectorMenuOpen,
            conversationHeader: t2,
            selectedSpace: selectedSpace,
            reset: reset,
            setActiveMenu: setActiveMenu,
            setMounted: setMounted,
            setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen,
            setStreamingStatus: setStreamingStatus,
            isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen,
            setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen,
            setConversationHeader: setConversationHeader,
            setSelectedSpace: setSelectedSpace,
            clearSelectedSpace: clearSelectedSpace,
            activeTabId: activeTabId,
            previousTabId: previousTabId,
            lastTabConversationId: lastTabConversationId,
            smartLink3PPostAuth: smartLink3PPostAuth,
            setSmartLink3PPostAuth: setSmartLink3PPostAuth,
            clearSmartLink3PPostAuth: clearSmartLink3PPostAuth,
            setActiveTabId: setActiveTabId,
            setPreviousTabId: setPreviousTabId,
            setLastTabConversationId: setLastTabConversationId
        };
        $[0] = activeMenu;
        $[1] = activeTabId;
        $[2] = clearSelectedSpace;
        $[3] = clearSmartLink3PPostAuth;
        $[4] = isAgentSelectorMenuOpen;
        $[5] = isChatOnboardingMiniModalOpen;
        $[6] = lastTabConversationId;
        $[7] = mounted;
        $[8] = previousTabId;
        $[9] = reset;
        $[10] = selectedSpace;
        $[11] = setActiveMenu;
        $[12] = setActiveTabId;
        $[13] = setConversationHeader;
        $[14] = setIsAgentSelectorMenuOpen;
        $[15] = setIsChatOnboardingMiniModalOpen;
        $[16] = setLastTabConversationId;
        $[17] = setMounted;
        $[18] = setPreviousTabId;
        $[19] = setSelectedSpace;
        $[20] = setSmartLink3PPostAuth;
        $[21] = setStreamingStatus;
        $[22] = smartLink3PPostAuth;
        $[23] = streaming;
        $[24] = t2;
        $[25] = t3;
    } else t3 = $[25];
    return t3;
} : ()=>{
    const [{ activeMenu: activeMenu, mounted: mounted, streaming: streaming, isAgentSelectorMenuOpen: isAgentSelectorMenuOpen, isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen, conversationHeader: conversationHeader, selectedSpace: selectedSpace, activeTabId: activeTabId, previousTabId: previousTabId, lastTabConversationId: lastTabConversationId, smartLink3PPostAuth: smartLink3PPostAuth }, { reset: reset, setActiveMenu: setActiveMenu, setMounted: setMounted, setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen, setStreamingStatus: setStreamingStatus, setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen, setConversationHeader: setConversationHeader, setSelectedSpace: setSelectedSpace, clearSelectedSpace: clearSelectedSpace, setActiveTabId: setActiveTabId, setPreviousTabId: setPreviousTabId, setLastTabConversationId: setLastTabConversationId, setSmartLink3PPostAuth: setSmartLink3PPostAuth, clearSmartLink3PPostAuth: clearSmartLink3PPostAuth }] = $af081181a641afaf$var$useStore();
    return {
        activeMenu: activeMenu,
        mounted: mounted,
        streaming: streaming,
        isAgentSelectorMenuOpen: isAgentSelectorMenuOpen,
        conversationHeader: conversationHeader ?? null,
        selectedSpace: selectedSpace,
        reset: reset,
        setActiveMenu: setActiveMenu,
        setMounted: setMounted,
        setIsAgentSelectorMenuOpen: setIsAgentSelectorMenuOpen,
        setStreamingStatus: setStreamingStatus,
        isChatOnboardingMiniModalOpen: isChatOnboardingMiniModalOpen,
        setIsChatOnboardingMiniModalOpen: setIsChatOnboardingMiniModalOpen,
        setConversationHeader: setConversationHeader,
        setSelectedSpace: setSelectedSpace,
        clearSelectedSpace: clearSelectedSpace,
        activeTabId: activeTabId,
        previousTabId: previousTabId,
        lastTabConversationId: lastTabConversationId,
        smartLink3PPostAuth: smartLink3PPostAuth,
        setSmartLink3PPostAuth: setSmartLink3PPostAuth,
        clearSmartLink3PPostAuth: clearSmartLink3PPostAuth,
        setActiveTabId: setActiveTabId,
        setPreviousTabId: setPreviousTabId,
        setLastTabConversationId: setLastTabConversationId
    };
};
const $af081181a641afaf$export$cd2fc25ddd3752d4 = (0, $kBr4q.createActionsHook)($af081181a641afaf$var$store);
const $af081181a641afaf$var$isRenderStabilizationEnabled = ()=>(0, $cXtTj.default).getExperimentValue('rovo_ttai_segment_render_stabilization', 'isEnabled', false);
const $af081181a641afaf$export$f0adc1af32e51b = (0, $kBr4q.createHook)($af081181a641afaf$var$store, {
    selector: (state)=>$af081181a641afaf$var$isRenderStabilizationEnabled() ? null : state
});
module.exports["useEmptyChatLaunchSelector"] = $af081181a641afaf$export$13a6c73a57f1d6a6;
module.exports["useActiveTabSelector"] = $af081181a641afaf$export$81a40d215ef1c1de;
module.exports["useSelectedSpaceSelector"] = $af081181a641afaf$export$5f449dc44751be0a;
module.exports["useChatHeaderUISelector"] = $af081181a641afaf$export$78ce19c6cc1eeb16;
module.exports["useConversationHeaderSelector"] = $af081181a641afaf$export$f4c4584d8302c703;
module.exports["useChatInputUISelector"] = $af081181a641afaf$export$357ffd05205e0c5d;
module.exports["useSideNavUISelector"] = $af081181a641afaf$export$9e369d8095358b77;
module.exports["useRootUISelector"] = $af081181a641afaf$export$8f5523dfac6ff4fa;
module.exports["useUIStore"] = $af081181a641afaf$export$5b2ba9b8ea3b0771;
module.exports["useUIStoreActions"] = $af081181a641afaf$export$cd2fc25ddd3752d4;
module.exports["useUIStoreSubscription"] = $af081181a641afaf$export$f0adc1af32e51b;

});

parcelRegister("blKf8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2zlSy = parcelRequire("2zlSy");

const $25b69de57535dd1e$export$c85ba824665b708f = (0, $cozmU.createContext)((0, $2zlSy.initialState));
module.exports["uiConfig"] = $25b69de57535dd1e$export$c85ba824665b708f;

});

parcelRegister("2zlSy", function(module, exports) {

var $oV0CU = parcelRequire("oV0CU");

const $25fc89fcc6d2e62b$export$d4c72bab9d6cc13a = {
    fullScreen: false,
    externalEmbed: false,
    isSplitLayout: false,
    splitLayoutInitialWidth: (0, $oV0CU.SPLIT_LAYOUT_INITIAL_WIDTH),
    splitLayoutMinWidth: (0, $oV0CU.SPLIT_LAYOUT_MIN_WIDTH),
    splitLayoutAdjacentMinWidth: (0, $oV0CU.SPLIT_LAYOUT_ADJACENT_MIN_WIDTH),
    splitLayoutStorageKey: 'conversation-assistant.split-layout.right-width',
    customHandlers: {
        handleDeepLinkClick: undefined,
        handleSubmitSmartCreate: ()=>{}
    },
    isBitbucketBetaEnabled: false,
    customFeedbackCategories: undefined,
    stagingAreaRef: undefined,
    promptInputDroppableUrls: undefined,
    enableBrowserContextBanner: false,
    disableSettingsModal: false,
    enableSkills: true,
    enableAutoSuggest: true,
    enableMiniModalResize: true,
    browserContextSanitizer: undefined,
    elements: {
        closeButton: true,
        newChatButton: true,
        fullscreenButton: true,
        createAgentButton: true,
        browseAgentsButton: true,
        agentsMenu: true,
        navbar: true,
        mainChatHeader: true,
        stagingAreaEnabled: false,
        voiceDictationButton: false,
        fileUploadButton: true,
        chatModeMenuButton: true,
        maxModeButton: true,
        shouldShowConversationActions: true,
        shouldShowContextBanner: true
    }
};
module.exports["initialState"] = $25fc89fcc6d2e62b$export$d4c72bab9d6cc13a;

});

parcelRegister("dSCNl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $blKf8 = parcelRequire("blKf8");

const $78dfed354051ab06$export$e83755c3ab7a4493 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $blKf8.uiConfig));
} : ()=>(0, $cozmU.useContext)((0, $blKf8.uiConfig));
module.exports["useUIConfig"] = $78dfed354051ab06$export$e83755c3ab7a4493;

});

parcelRegister("3z1p5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $6SsN4 = parcelRequire("6SsN4");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $ixfCV = parcelRequire("ixfCV");


var $8lt5O = parcelRequire("8lt5O");


var $irnO2 = parcelRequire("irnO2");


var $bxkJA = parcelRequire("bxkJA");


var $8A2GO = parcelRequire("8A2GO");


var $5SS4O = parcelRequire("5SS4O");


var $lJ6db = parcelRequire("lJ6db");


var $bJzbV = parcelRequire("bJzbV");


var $33DP2 = parcelRequire("33DP2");


var $ig6TM = parcelRequire("ig6TM");


var $aihbI = parcelRequire("aihbI");


var $h6LPv = parcelRequire("h6LPv");


var $3ay5Z = parcelRequire("3ay5Z");


var $37RgG = parcelRequire("37RgG");


var $5Vuk7 = parcelRequire("5Vuk7");


var $8reXX = parcelRequire("8reXX");


var $fU4xN = parcelRequire("fU4xN");

const $808992f64c91fd00$var$categoriseAgents = (agents)=>agents.reduce((categorisedAgents, agent)=>{
        if (agent.creator_type === 'SYSTEM') categorisedAgents.system.push(agent);
        else if (agent.visibility === 'PUBLIC') categorisedAgents.public.push(agent);
        else if (agent.visibility === 'PRIVATE') categorisedAgents.private.push(agent);
        else if (!agent.visibility && agent.creator_type === 'CUSTOMER') categorisedAgents.private.push(agent);
        return categorisedAgents;
    }, {
        public: [],
        private: [],
        system: []
    });
/**
 * @deprecated Please use `useAgentsPaginated...` hooks instead
 * @TODO move to different folder https://product-fabric.atlassian.net/browse/RAGE-1562
 */ const $808992f64c91fd00$var$agentsStore = (0, $8s9DV.createStore)({
    initialState: {
        availableAgents: [],
        categorisedAgents: {
            private: [],
            public: [],
            system: []
        },
        agentsInitialized: false,
        agentsError: undefined
    },
    name: 'AgentsStore',
    actions: {
        setAgents: (availableAgents)=>({ setState: setState })=>{
                setState({
                    availableAgents: availableAgents,
                    categorisedAgents: $808992f64c91fd00$var$categoriseAgents(availableAgents)
                });
            },
        setAgentsInitialized: ()=>({ setState: setState })=>{
                setState({
                    agentsInitialized: true
                });
            },
        setAgentsError: (agentsError)=>({ setState: setState })=>{
                setState({
                    agentsError: agentsError
                });
            }
    }
});
/**
 * @deprecated Please use `useAgentsPaginated...` instead
 * @TODO move to different folder https://product-fabric.atlassian.net/browse/RAGE-1562
 */ const $808992f64c91fd00$var$useAgentsStore = (0, $kBr4q.createHook)($808992f64c91fd00$var$agentsStore);
const $808992f64c91fd00$export$f5b1109ecd7858c1 = (0, $lJ6db.createHookWithAssistanceService)(({ onError: onError, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker, experienceId: experienceId, product: product, siteId: siteId, touchpointSource: touchpointSource } })=>{
    // TODO remove `isRovoEnabled`
    const { isRovoEnabled: isRovoEnabled } = (0, $8lt5O.useRovoEntitlement)();
    const { agentIdFiltersOverride: agentIdFiltersOverride, agentDefaultIdOverride: agentDefaultIdOverride } = (0, $37RgG.useAgentOverrider)();
    const [{ availableAgents: availableAgents, categorisedAgents: categorisedAgents, agentsInitialized: agentsInitialized, agentsError: agentsError }, { setAgents: setAgents, setAgentsInitialized: setAgentsInitialized, setAgentsError: setAgentsError }] = $808992f64c91fd00$var$useAgentsStore();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { favouriteAgent: favouriteAgent, unfavouriteAgent: unfavouriteAgent } = (0, $3ay5Z.useAgentFavourites)({
        assistanceServiceParams: {
            experienceId: experienceId,
            product: product,
            siteId: siteId,
            touchpointSource: touchpointSource
        }
    });
    const favouritedAgents = availableAgents.filter((agent)=>agent.favourite);
    const defaultAgent = (0, $cozmU.useMemo)(()=>availableAgents.find((agent)=>agent.is_default), [
        availableAgents
    ]);
    const nonDefaultAgents = (0, $cozmU.useMemo)(()=>availableAgents.filter((agent)=>!agent.is_default), [
        availableAgents
    ]);
    const nonDefaultFavouriteAgents = (0, $cozmU.useMemo)(()=>nonDefaultAgents.filter((agent)=>!agent.favourite), [
        nonDefaultAgents
    ]);
    const fetchAndStoreAvailableAgents = (0, $5SS4O.useQuery)({
        queryKey: [
            'fetchAgents'
        ],
        queryFn: async ()=>{
            try {
                experienceTracker.start({
                    id: (0, $irnO2.ExperienceName).FETCH_AGENTS,
                    name: (0, $irnO2.ExperienceName).FETCH_AGENTS
                });
                const agents = await assistanceService.getAgents();
                const transformedAgents = agents.map((agent)=>{
                    // Rename default agent to Chat, which is displayed in the UI
                    if (agent.is_default) {
                        agent.name = formatMessage((0, $fU4xN.default).defaultAgentName);
                        agent.description = formatMessage((0, $fU4xN.default).defaultAgentDescription);
                    }
                    return agent;
                });
                const overriddenAgents = (0, $5Vuk7.getOverridenAgents)(transformedAgents, agentIdFiltersOverride, agentDefaultIdOverride);
                setAgents(overriddenAgents);
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).FETCH_AGENTS
                });
                setAgentsInitialized();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                //Filter out HIPAA errors from experience tracker https://product-fabric.atlassian.net/browse/ROVOFE-543
                if ((0, $8reXX.isHipaaError)(error)) {
                    experienceTracker.succeed({
                        name: (0, $irnO2.ExperienceName).FETCH_AGENTS
                    });
                    return;
                }
                if ((0, $bxkJA.isRateLimitedError)(error)) setAgentsError(error);
                experienceTracker.fail({
                    name: (0, $irnO2.ExperienceName).FETCH_AGENTS,
                    error: error
                });
                throw error;
            }
        },
        onError: onError,
        enabled: isRovoEnabled,
        refetchOnWindowFocus: false
    });
    const { deleteAgent: deleteAgent } = (0, $h6LPv.useDeleteAgent)({
        onSuccess: ()=>{
            fetchAndStoreAvailableAgents.refetch();
        },
        assistanceServiceParams: {
            experienceId: experienceId,
            product: product,
            siteId: siteId,
            touchpointSource: touchpointSource
        },
        onInit: (id)=>{
            setAgents(availableAgents.filter((agent)=>agent.id !== id));
        },
        onError: ()=>{
            setAgents(availableAgents);
        }
    });
    const setFavouriteAgent = (0, $cozmU.useCallback)(async (id, isFavourite)=>{
        const updatedAgent = availableAgents.find((a)=>a.id === id);
        const setUpdatedAgent = (shouldBeFavourite)=>{
            if (updatedAgent) {
                updatedAgent.favourite = shouldBeFavourite;
                setAgents(availableAgents.map((a)=>{
                    // If the current agent's id matches the new agent's id, return the new agent.
                    // Otherwise, return the current agent.
                    return a.id === updatedAgent.id ? updatedAgent : a;
                }));
            }
        };
        //Optimistically update favourite value before we mutate
        setUpdatedAgent(isFavourite);
        //Pass callback to roll back optimistic update if mutation fails
        const errorCallback = {
            onError: ()=>{
                setUpdatedAgent(!isFavourite);
            }
        };
        if (isFavourite) return await favouriteAgent.mutate(id, errorCallback);
        else return await unfavouriteAgent.mutate(id, errorCallback);
    }, [
        availableAgents,
        setAgents,
        favouriteAgent,
        unfavouriteAgent
    ]);
    /** This updates the agent on the client side only
   * Useful for updating the agent after a successful mutation
   */ const updateAgentLocally = (0, $cozmU.useCallback)((agentId, updatedAgent)=>{
        const updatedAgents = availableAgents.map((agent)=>{
            if (agent.id === agentId) return {
                ...agent,
                ...updatedAgent
            };
            return agent;
        });
        setAgents(updatedAgents);
    }, [
        availableAgents,
        setAgents
    ]);
    return {
        availableAgents: availableAgents,
        favouritedAgents: favouritedAgents,
        categorisedAgents: categorisedAgents,
        fetchAndStoreAvailableAgents: fetchAndStoreAvailableAgents,
        deleteAgent: deleteAgent,
        setFavouriteAgent: setFavouriteAgent,
        defaultAgent: defaultAgent,
        agentsInitialized: agentsInitialized,
        nonDefaultAgents: nonDefaultAgents,
        nonDefaultFavouriteAgents: nonDefaultFavouriteAgents,
        updateAgentLocally: updateAgentLocally,
        agentsError: agentsError
    };
});
const $808992f64c91fd00$var$agentsPaginatedStore = (0, $8s9DV.createStore)({
    initialState: {
        /*
    Hash map which is the source of truth for agent data
    agent categories simply hold the agent ids to perform a lookup
    */ agentsMap: {},
        loadingCategories: new Set(),
        agentCategories: {
            ['all-agents']: {
                agentIds: [],
                pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            },
            ['starred-agents']: {
                agentIds: [],
                pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            },
            ['my-agents']: {
                agentIds: [],
                pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            },
            ['templates']: {
                agentIds: [],
                pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            },
            ['verified-agents']: {
                agentIds: [],
                pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            },
            ['available-for-jira']: {
                agentIds: [],
                pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO),
                abortController: new AbortController()
            }
        }
    },
    name: 'AgentsPaginatedStore',
    actions: {
        /**
     * This action populates a specific category with backend data
     * it will store the ids in `agentCategories` and the agents in `agentsMap`
     */ populateAgentCategories: ({ agentsList: agentsList, pageInfo: pageInfo, category: category = 'all-agents' })=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap, agentCategories: agentCategories } = getState();
                const updatedAgentsMap = {
                    ...agentsMap
                };
                const updatedAgentCategories = {
                    ...agentCategories
                };
                updatedAgentCategories[category].pageInfo = pageInfo;
                if (!agentsList.length) updatedAgentCategories[category].agentIds = [];
                else agentsList.forEach((agent)=>{
                    // Ensure isPlaceholder is cleared when hydrating with real BE data
                    const { isPlaceholder: _isPlaceholder, ...existingData } = updatedAgentsMap[agent.id] ?? {};
                    updatedAgentsMap[agent.id] = {
                        ...existingData,
                        ...agent
                    };
                    updatedAgentCategories[category].agentIds.push(agent.id);
                });
                setState({
                    agentsMap: updatedAgentsMap,
                    agentCategories: updatedAgentCategories
                });
            },
        setAgentCategoriesByCategory: ({ categoryName: categoryName, agentCategoryData: agentCategoryData })=>({ getState: getState, setState: setState })=>{
                const { agentCategories: agentCategories } = getState();
                const updatedAgentCategories = {
                    ...agentCategories,
                    [categoryName]: agentCategoryData
                };
                setState({
                    agentCategories: updatedAgentCategories
                });
            },
        setCategoryError: (categoryName, agentsError)=>({ getState: getState, setState: setState })=>{
                const { agentCategories: agentCategories } = getState();
                const updatedAgentCategories = {
                    ...agentCategories,
                    [categoryName]: {
                        ...agentCategories[categoryName],
                        agentsError: agentsError
                    }
                };
                setState({
                    agentCategories: updatedAgentCategories
                });
            },
        getAgentCategoriesByCategory: (category)=>({ getState: getState })=>{
                const state = getState();
                const { agentCategories: agentCategories } = state;
                return agentCategories[category];
            },
        removeAgent: (id)=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap, agentCategories: agentCategories } = getState();
                const catsImpacted = new Set();
                let agentToReturn;
                const updatedAgentsMap = {
                    ...agentsMap
                };
                const updatedAgentCategories = {
                    ...agentCategories
                };
                if (agentsMap[id]) {
                    agentToReturn = agentsMap[id];
                    delete updatedAgentsMap[id];
                }
                Object.keys(agentCategories).forEach((category)=>{
                    if (updatedAgentCategories[category]?.agentIds.includes(id)) {
                        updatedAgentCategories[category].agentIds = updatedAgentCategories[category].agentIds.filter((agentId)=>agentId !== id);
                        catsImpacted.add(category);
                    }
                });
                setState({
                    agentsMap: updatedAgentsMap,
                    agentCategories: updatedAgentCategories
                });
                return {
                    agent: agentToReturn,
                    categories: Array.from(catsImpacted)
                };
            },
        addAgent: (agent, categories = [
            'all-agents'
        ])=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap, agentCategories: agentCategories } = getState();
                const updatedAgentsMap = {
                    ...agentsMap
                };
                const updatedAgentCategories = {
                    ...agentCategories
                };
                categories.forEach((category)=>{
                    updatedAgentCategories?.[category]?.agentIds.push(agent.id);
                });
                // Ensure isPlaceholder is cleared when adding full agent data
                const { isPlaceholder: _isPlaceholder, ...existingData } = updatedAgentsMap[agent.id] ?? {};
                updatedAgentsMap[agent.id] = {
                    ...existingData,
                    ...agent
                };
                setState({
                    agentsMap: updatedAgentsMap,
                    agentCategories: updatedAgentCategories
                });
            },
        updateAgent: (id, data)=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap } = getState();
                const updatedAgentsMap = {
                    ...agentsMap
                };
                const prevData = agentsMap[id] ?? {};
                const updatedData = {
                    ...prevData,
                    ...data
                };
                // Clean up placeholder flag when real agent data arrives
                // Keep placeholderAvatarUrl to avoid avatar flicker (same image, stable source)
                if (prevData.isPlaceholder) delete updatedData.isPlaceholder;
                updatedAgentsMap[id] = updatedData;
                setState({
                    agentsMap: updatedAgentsMap
                });
                return updatedData;
            },
        setCategoryLoading: (category, loading)=>({ setState: setState, getState: getState })=>{
                const { loadingCategories: loadingCategories } = getState();
                const updatedLoadingCategories = new Set(loadingCategories);
                if (loading) updatedLoadingCategories.add(category);
                else updatedLoadingCategories.delete(category);
                setState({
                    loadingCategories: updatedLoadingCategories
                });
            },
        abortCategoryFetch: (category)=>({ getState: getState })=>{
                const { agentCategories: agentCategories } = getState();
                agentCategories[category].abortController.abort();
                agentCategories[category].abortController = new AbortController();
            },
        /**
     * Sets a placeholder agent in the agentsMap with partial data for immediate rendering.
     * The agent is marked with `isPlaceholder: true` so that `useAgentsPaginatedByAgentId`
     * still fetches full details from the network to replace it.
     * Used for optimistic rendering of agent name/avatar from pubsub payloads.
     */ setPlaceholderAgent: (agentId, data)=>({ setState: setState, getState: getState })=>{
                const { agentsMap: agentsMap } = getState();
                // Only set placeholder if agent doesn't already exist with full data
                if (!agentsMap[agentId]) {
                    const updatedAgentsMap = {
                        ...agentsMap
                    };
                    updatedAgentsMap[agentId] = {
                        ...data,
                        id: agentId,
                        isPlaceholder: true
                    };
                    setState({
                        agentsMap: updatedAgentsMap
                    });
                }
            },
        getCachedAgentByExternalConfigReference: (externalConfigReference)=>({ getState: getState })=>{
                const { agentsMap: agentsMap } = getState();
                return Object.values(agentsMap).find((agent)=>agent.external_config_reference === externalConfigReference);
            }
    }
});
const $808992f64c91fd00$export$1553678862324ff0 = (0, $kBr4q.createActionsHook)($808992f64c91fd00$var$agentsPaginatedStore);
const $808992f64c91fd00$export$cea603150faaa56f = (0, $kBr4q.createHook)($808992f64c91fd00$var$agentsPaginatedStore, {
    // TODO https://product-fabric.atlassian.net/browse/RAGE-618
    // change `{ agentId }` to `agentId`
    selector: (state, agentId)=>({
            agent: state.agentsMap[agentId],
            doesAgentExist: Boolean(state.agentsMap[agentId]),
            isPlaceholder: Boolean(state.agentsMap[agentId]?.isPlaceholder)
        })
});
const $808992f64c91fd00$export$44c2e95a7a8b47c9 = (0, $lJ6db.createHookWithAssistanceService)(({ agentId: agentId, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker } })=>{
    (0, $6cFsl.di)($808992f64c91fd00$export$44c2e95a7a8b47c9, $808992f64c91fd00$export$cea603150faaa56f, $808992f64c91fd00$export$1553678862324ff0);
    const [{ agent: agent, doesAgentExist: doesAgentExist, isPlaceholder: isPlaceholder }] = $808992f64c91fd00$export$cea603150faaa56f(agentId ?? '');
    const { updateAgent: updateAgent } = $808992f64c91fd00$export$1553678862324ff0();
    const { error: error } = (0, $5SS4O.useQuery)({
        queryKey: [
            'agentHydration',
            agentId ?? ''
        ],
        queryFn: async ()=>{
            if (!agentId) // this throw won't happen because the `enabled` field below
            throw new Error('Agent ID is required');
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).HYDRATE_AGENT_DATA,
                id: (0, $irnO2.ExperienceName).HYDRATE_AGENT_DATA
            });
            const response = await assistanceService.getAgentDetails(agentId);
            return response;
        },
        enabled: Boolean(agentId) && (!doesAgentExist || isPlaceholder),
        onSuccess: (data)=>{
            if (!agentId) return;
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).HYDRATE_AGENT_DATA
            });
            updateAgent(agentId ?? '', data);
        },
        onError: (error)=>{
            if (!agentId) return;
            const is404Error = error.errorAttributes.statusCode === 404;
            const is403Error = error.errorAttributes.statusCode === 403 && (0, $ixfCV.fg)('convo-ai-enable-agents-use-permission');
            if (!(is404Error || is403Error)) experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).HYDRATE_AGENT_DATA,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
        }
    });
    if (!agentId) return {
        agent: undefined,
        error: undefined
    };
    return {
        agent: agent,
        error: error ?? undefined
    };
});
const $808992f64c91fd00$export$eae59c91509947e4 = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: assistanceServiceInjectedParams })=>{
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const removedAgentCache = (0, $cozmU.useRef)({
        categories: [],
        agent: undefined
    });
    const { removeAgent: removeAgent, addAgent: addAgent, updateAgent: updateAgent } = $808992f64c91fd00$export$1553678862324ff0();
    const { favouriteAgent: favouriteAgent, unfavouriteAgent: unfavouriteAgent } = (0, $3ay5Z.useAgentFavourites)({
        assistanceServiceParams: assistanceServiceInjectedParams
    });
    // Note: Experience Tracker events implemented in useDeleteAgent
    const { deleteAgent: deleteAgent } = (0, $h6LPv.useDeleteAgent)({
        assistanceServiceParams: assistanceServiceInjectedParams,
        onInit: (id)=>{
            const { categories: categories, agent: agent } = removeAgent(id);
            removedAgentCache.current = {
                categories: categories,
                agent: agent
            };
        },
        onError: ()=>{
            if (removedAgentCache.current.agent) addAgent(removedAgentCache.current.agent, removedAgentCache.current.categories);
        }
    });
    // Note: Experience Tracker events implemented in useAgentFavourites
    const setFavouriteAgent = (0, $cozmU.useCallback)(async (id, favourite, agentAri)=>{
        // Optimistic update
        updateAgent(id, {
            favourite: favourite
        });
        const localRelayUpdate = async (isFavourite)=>{
            if (agentAri) (0, $6SsN4.commitLocalUpdate)(environment, (store)=>{
                const id = (0, $bJzbV.default)({
                    id: agentAri
                }, 'AgentStudioAssistant');
                if (!id) return;
                const agentRecord = store.get(id);
                if (agentRecord) agentRecord.setValue(isFavourite, 'isFavourite');
                const root = store.getRoot();
                const connection = (0, $6SsN4.ConnectionHandler).getConnection(root, 'paginatedAgentsList_agentStudio_getAgents', {
                    cloudId: assistanceServiceInjectedParams.siteId,
                    input: {
                        onlyFavouriteAgents: true
                    },
                    product: assistanceServiceInjectedParams.product
                });
                const agentDataID = agentRecord?.getDataID();
                if (!connection || !agentDataID || !agentRecord) return;
                if (isFavourite) {
                    const edge = (0, $6SsN4.ConnectionHandler).createEdge(store, connection, agentRecord, 'AgentStudioAgentEdge');
                    (0, $6SsN4.ConnectionHandler).insertEdgeAfter(connection, edge);
                } else (0, $6SsN4.ConnectionHandler).deleteNode(connection, agentDataID);
            });
        };
        localRelayUpdate(favourite);
        const errorCallback = {
            onError: ()=>{
                // Reverse optimistic update
                updateAgent(id, {
                    favourite: !favourite
                });
                localRelayUpdate(!favourite);
            }
        };
        if (favourite) return await favouriteAgent.mutate(id, errorCallback);
        else return await unfavouriteAgent.mutate(id, errorCallback);
    }, [
        assistanceServiceInjectedParams.product,
        assistanceServiceInjectedParams.siteId,
        environment,
        favouriteAgent,
        unfavouriteAgent,
        updateAgent
    ]);
    /**
   * Function that updates the verified status of an agent.
   * This can be removed once the dropdown has converted over to relay.
   */ const setVerifiedAgent = (0, $cozmU.useCallback)((id, isVerified)=>{
        updateAgent(id, {
            is_verified: isVerified
        });
    }, [
        updateAgent
    ]);
    // Local cache update function for optimistic delete
    // This only handles cache updates, not API calls or analytics
    const deleteAgentLocally = (0, $cozmU.useCallback)((id)=>{
        // Optimistically remove from cache
        const { categories: categories, agent: agent } = removeAgent(id);
        // Return restore function for error handling
        return {
            restore: ()=>{
                if (agent) addAgent(agent, categories);
            }
        };
    }, [
        removeAgent,
        addAgent
    ]);
    return {
        deleteAgent: deleteAgent,
        setFavouriteAgent: setFavouriteAgent,
        setVerifiedAgent: setVerifiedAgent,
        deleteAgentLocally: deleteAgentLocally
    };
});
const $808992f64c91fd00$export$cc3deb815b1c179b = (0, $kBr4q.createHook)($808992f64c91fd00$var$agentsPaginatedStore, {
    selector: (state, category)=>({
            agentsByCategory: state.agentCategories[category].agentIds.map((agentId)=>state.agentsMap[agentId]),
            isCategoryInitialized: state.agentCategories[category].pageInfo.startCursor !== undefined && state.agentCategories[category].pageInfo.endCursor !== undefined,
            isCategoryLoading: state.loadingCategories.has(category),
            isCategoryEmpty: state.agentCategories[category].agentIds.length === 0,
            hasNextPage: state.agentCategories[category].pageInfo.hasNextPage,
            nextPageCursor: state.agentCategories[category].pageInfo.endCursor,
            agentsError: state.agentCategories[category].agentsError
        })
});
const $808992f64c91fd00$export$e6997ec35c535c54 = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker } })=>{
    (0, $6cFsl.di)((0, $37RgG.useAgentOverrider), $808992f64c91fd00$export$1553678862324ff0);
    const { agentDefaultIdOverride: agentDefaultIdOverride, agentIdFiltersOverride: agentIdFiltersOverride } = (0, $37RgG.useAgentOverrider)();
    const { addAgent: addAgent, populateAgentCategories: populateAgentCategories } = $808992f64c91fd00$export$1553678862324ff0();
    const fetchOverriddenAgentsAndPopulateStoreQuery = (0, $5SS4O.useQuery)({
        queryKey: [
            'fetchOverriddenAgentsAndPopulateStore',
            agentDefaultIdOverride ?? '',
            agentIdFiltersOverride?.join(',') ?? ''
        ],
        queryFn: async ()=>{
            const agentIdsToFetchSet = new Set();
            if (agentDefaultIdOverride) agentIdsToFetchSet.add(agentDefaultIdOverride);
            if (agentIdFiltersOverride?.length) agentIdFiltersOverride.forEach((agentId)=>{
                agentIdsToFetchSet.add(agentId);
            });
            if (agentIdsToFetchSet.size === 0) return;
            const agentIdsToFetch = Array.from(agentIdsToFetchSet);
            populateAgentCategories({
                category: 'all-agents',
                agentsList: [],
                pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO)
            });
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).FETCH_AGENTS_OVERRIDES,
                id: (0, $irnO2.ExperienceName).FETCH_AGENTS_OVERRIDES
            });
            const agents = await Promise.all(agentIdsToFetch.map(async (agentId)=>{
                return await assistanceService.getAgentDetails(agentId);
            }));
            // then add the agents into "All agents" category
            agents.forEach((agent)=>{
                addAgent(agent, [
                    'all-agents'
                ]);
            });
            return agentIdsToFetch;
        },
        onSuccess: ()=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).FETCH_AGENTS_OVERRIDES
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).FETCH_AGENTS_OVERRIDES,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
        },
        enabled: false
    });
    return {
        fetchOverriddenAgentsAndPopulateStore: fetchOverriddenAgentsAndPopulateStoreQuery.refetch
    };
});
const $808992f64c91fd00$export$94c2040c41639ede = (0, $lJ6db.createHookWithAssistanceService)(({ onError: onError, assistanceServiceInjectedParams: assistanceServiceInjectedParams })=>{
    (0, $6cFsl.di)($808992f64c91fd00$export$1553678862324ff0, (0, $37RgG.useAgentOverrider), $808992f64c91fd00$export$e6997ec35c535c54);
    const { experienceTracker: experienceTracker, siteId: siteId, product: product, headers: assistanceServiceHeaders } = assistanceServiceInjectedParams;
    const actions = $808992f64c91fd00$export$1553678862324ff0();
    const { setCategoryLoading: setCategoryLoading, setCategoryError: setCategoryError, populateAgentCategories: populateAgentCategories, getAgentCategoriesByCategory: getAgentCategoriesByCategory, setAgentCategoriesByCategory: setAgentCategoriesByCategory } = actions;
    const { agentDefaultIdOverride: agentDefaultIdOverride, agentIdFiltersOverride: agentIdFiltersOverride } = (0, $37RgG.useAgentOverrider)();
    const { fetchOverriddenAgentsAndPopulateStore: fetchOverriddenAgentsAndPopulateStore } = $808992f64c91fd00$export$e6997ec35c535c54({
        assistanceServiceParams: assistanceServiceInjectedParams
    });
    const fetchAgentsByCategory = (0, $cozmU.useCallback)(async ({ category: category = 'all-agents', after: after, query: query })=>{
        // if there are any overrides, cancel the normal fetchByCategory and instead fetch the overridden agents
        if (agentDefaultIdOverride || agentIdFiltersOverride?.length) return await fetchOverriddenAgentsAndPopulateStore() ?? [];
        const dataBeforeFetch = getAgentCategoriesByCategory(category);
        experienceTracker.start({
            name: (0, $irnO2.ExperienceName).FETCH_AGENTS_PAGINATED,
            id: (0, $irnO2.ExperienceName).FETCH_AGENTS_PAGINATED
        });
        let queryInput = {};
        switch(category){
            case 'starred-agents':
                queryInput.onlyFavouriteAgents = true;
                break;
            case 'my-agents':
                queryInput.onlyMyAgents = true;
                break;
            case 'templates':
                queryInput.onlyTemplateAgents = true;
                break;
            case 'verified-agents':
                queryInput.onlyVerifiedAgents = true;
                break;
        }
        if (query) queryInput.name = query;
        // for rolling back data in case of abort/failure
        const resetData = ()=>{
            setAgentCategoriesByCategory({
                categoryName: category,
                agentCategoryData: dataBeforeFetch
            });
            return dataBeforeFetch.agentIds;
        };
        // No after means we're requesting the first page so the category data is reset
        if (!after) populateAgentCategories({
            category: category,
            agentsList: [],
            pageInfo: (0, $ig6TM.DEFAULT_PAGE_INFO)
        });
        setCategoryLoading(category, true);
        setCategoryError(category, undefined);
        const headers = new Headers(assistanceServiceHeaders);
        const maybeWorkspaceId = headers.get('x-workspace-id');
        try {
            const response = await (0, $ig6TM.fetchPaginatedAgents)({
                after: after ?? undefined,
                cloudId: siteId,
                count: 10,
                input: Object.keys(queryInput).length > 0 ? queryInput : undefined,
                product: product,
                abortController: getAgentCategoriesByCategory(category).abortController,
                workspaceId: maybeWorkspaceId
            });
            setCategoryLoading(category, false);
            if (getAgentCategoriesByCategory(category).abortController.signal?.aborted) {
                experienceTracker.abort({
                    reason: 'Aborted',
                    name: (0, $irnO2.ExperienceName).FETCH_AGENTS_PAGINATED
                });
                return resetData();
            }
            if (response) {
                populateAgentCategories({
                    category: category,
                    agentsList: response.agents,
                    pageInfo: response.pageInfo
                });
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).FETCH_AGENTS_PAGINATED
                });
            }
            return response?.agents.map((agent)=>agent.id);
        } catch (error) {
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).FETCH_AGENTS_PAGINATED,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
            const prevAgentIds = resetData();
            setCategoryError(category, error);
            setCategoryLoading(category, false);
            if (error instanceof (0, $8A2GO.ApiError)) onError?.(error);
            return prevAgentIds;
        }
    }, [
        agentDefaultIdOverride,
        agentIdFiltersOverride?.length,
        getAgentCategoriesByCategory,
        experienceTracker,
        setCategoryLoading,
        setCategoryError,
        assistanceServiceHeaders,
        fetchOverriddenAgentsAndPopulateStore,
        setAgentCategoriesByCategory,
        populateAgentCategories,
        siteId,
        product,
        onError
    ]);
    return {
        ...actions,
        fetchAgentsByCategory: fetchAgentsByCategory
    };
});
const $808992f64c91fd00$export$65c6565d33cf8f4f = (0, $kBr4q.createHook)($808992f64c91fd00$var$agentsPaginatedStore, {
    selector: (state)=>state.agentsMap
});
const $808992f64c91fd00$var$DEFAULT_RECOMMENDED_AGENTS_LIMIT = 3;
const $808992f64c91fd00$var$getRecommendedAgentsQueryKey = ({ limit: limit, pageUrl: pageUrl })=>[
        'recommendedAgents',
        limit,
        pageUrl ?? ''
    ];
const $808992f64c91fd00$var$fetchRecommendedAgents = async ({ assistanceService: assistanceService, limit: limit, pageUrl: pageUrl, updateAgent: updateAgent })=>{
    const response = await assistanceService.getRecommendedAgents({
        limit: limit,
        pageUrl: pageUrl
    });
    // Store the agents in the paginated store for optimistic updates etc.
    // Not adding them to a specific category in local cache on purpose.
    response.agents.forEach((agent)=>{
        updateAgent(agent.id, agent);
    });
    return response;
};
const $808992f64c91fd00$export$100f85e1b969f92e = ({ assistanceService: assistanceService, limit: limit = $808992f64c91fd00$var$DEFAULT_RECOMMENDED_AGENTS_LIMIT, pageUrl: pageUrl, updateAgent: updateAgent, onStart: onStart, onSuccess: onSuccess, onError: onError })=>{
    (0, $5SS4O.prefetchQuery)({
        queryKey: $808992f64c91fd00$var$getRecommendedAgentsQueryKey({
            limit: limit,
            pageUrl: pageUrl
        }),
        queryFn: ()=>$808992f64c91fd00$var$fetchRecommendedAgents({
                assistanceService: assistanceService,
                limit: limit,
                pageUrl: pageUrl,
                updateAgent: updateAgent
            }),
        onStart: onStart,
        onSuccess: onSuccess,
        onError: onError
    });
};
const $808992f64c91fd00$export$631401679afcb10f = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: assistanceServiceInjectedParams, limit: limit = $808992f64c91fd00$var$DEFAULT_RECOMMENDED_AGENTS_LIMIT, pageUrl: pageUrl })=>{
    (0, $6cFsl.di)($808992f64c91fd00$export$65c6565d33cf8f4f);
    const { assistanceService: assistanceService, experienceTracker: experienceTracker, siteId: siteId } = assistanceServiceInjectedParams;
    const [agentsMap, { updateAgent: updateAgent }] = $808992f64c91fd00$export$65c6565d33cf8f4f();
    const { isFetching: isFetching, data: data } = (0, $5SS4O.useQuery)({
        queryKey: $808992f64c91fd00$var$getRecommendedAgentsQueryKey({
            limit: limit,
            pageUrl: pageUrl
        }),
        queryFn: async ()=>{
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).GET_RECOMMENDED_AGENTS,
                name: (0, $irnO2.ExperienceName).GET_RECOMMENDED_AGENTS
            });
            return $808992f64c91fd00$var$fetchRecommendedAgents({
                assistanceService: assistanceService,
                limit: limit,
                pageUrl: pageUrl,
                updateAgent: updateAgent
            });
        },
        enabled: Boolean(siteId),
        onSuccess: ()=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).GET_RECOMMENDED_AGENTS
            });
        },
        onError: (error)=>{
            if ((0, $8reXX.isHipaaError)(error)) {
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).GET_RECOMMENDED_AGENTS
                });
                return;
            }
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).GET_RECOMMENDED_AGENTS,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
        }
    });
    return {
        isFetching: isFetching,
        recommendedAgents: data?.agents.map((agent)=>agentsMap[agent.id]).filter(Boolean) ?? [],
        recommendationKey: data?.metadata?.recommendationKey
    };
});
const $808992f64c91fd00$export$71d3696dcc60eb2d = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { experienceTracker: experienceTracker, siteId: siteId } })=>{
    (0, $6cFsl.di)($808992f64c91fd00$export$1553678862324ff0, (0, $ig6TM.fetchAgentByExternalConfigReference));
    const { updateAgent: updateAgent, getCachedAgentByExternalConfigReference: getCachedAgentByExternalConfigReference } = $808992f64c91fd00$export$1553678862324ff0();
    const getAndStoreAgentByExternalConfigReference = (0, $cozmU.useCallback)(async ({ externalConfigReference: externalConfigReference })=>{
        const cachedAgent = getCachedAgentByExternalConfigReference(externalConfigReference);
        if (cachedAgent) return cachedAgent;
        try {
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE,
                id: (0, $irnO2.ExperienceName).FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE
            });
            const agentData = await (0, $ig6TM.fetchAgentByExternalConfigReference)({
                cloudId: siteId,
                externalConfigReference: externalConfigReference
            });
            // cache the data
            updateAgent(agentData.id, agentData);
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE
            });
            return agentData;
        } catch (error) {
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
            return undefined;
        }
    }, [
        getCachedAgentByExternalConfigReference,
        experienceTracker,
        siteId,
        updateAgent
    ]);
    return {
        getAndStoreAgentByExternalConfigReference: getAndStoreAgentByExternalConfigReference
    };
});
const $808992f64c91fd00$export$eee66751ca85dbf7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (param)=>{
    return $808992f64c91fd00$export$f5b1109ecd7858c1(param);
} : (param)=>{
    return $808992f64c91fd00$export$f5b1109ecd7858c1(param);
};
const $808992f64c91fd00$export$6553fa633373a34 = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { product: product, experienceId: experienceId, headers: headers, touchpointSource: touchpointSource, siteId: siteId }, filter: filter })=>{
    const { availableAgents: availableAgents, favouritedAgents: favouritedAgents } = $808992f64c91fd00$export$eee66751ca85dbf7({
        assistanceServiceParams: {
            product: product,
            experienceId: experienceId,
            headers: headers,
            touchpointSource: touchpointSource,
            siteId: siteId
        }
    });
    const defaultAgents = (0, $aihbI.getSuggestedOotbAgents)({
        availableAgents: availableAgents,
        product: product
    });
    const defaultAgentsOutsideUserFavourites = defaultAgents.filter((defaultAgent)=>!favouritedAgents.find((favAgent)=>favAgent.id === defaultAgent.id));
    const favouritedAgentsWithDefault = [
        ...favouritedAgents,
        ...defaultAgentsOutsideUserFavourites.slice(0, Math.max(3 - favouritedAgents.length, 0))
    ];
    return filter === 'favourites' ? favouritedAgentsWithDefault : availableAgents;
});
module.exports["useAgentsPaginatedStoreActions"] = $808992f64c91fd00$export$1553678862324ff0;
module.exports["useAgentsPaginatedByAgentId"] = $808992f64c91fd00$export$44c2e95a7a8b47c9;
module.exports["useAgentsPaginatedActionsWithOptimistic"] = $808992f64c91fd00$export$eae59c91509947e4;
module.exports["usePaginatedAgentsByCategory"] = $808992f64c91fd00$export$cc3deb815b1c179b;
module.exports["usePaginatedAgentsActions"] = $808992f64c91fd00$export$94c2040c41639ede;
module.exports["usePaginatedAgentsMap"] = $808992f64c91fd00$export$65c6565d33cf8f4f;
module.exports["prefetchRecommendedAgents"] = $808992f64c91fd00$export$100f85e1b969f92e;
module.exports["useRecommendedAgents"] = $808992f64c91fd00$export$631401679afcb10f;
module.exports["usePaginatedAgentByConfigReference"] = $808992f64c91fd00$export$71d3696dcc60eb2d;
module.exports["useAgentsList"] = $808992f64c91fd00$export$6553fa633373a34;

});

parcelRegister("ig6TM", function(module, exports) {

var $6cFsl = parcelRequire("6cFsl");


var $ixfCV = parcelRequire("ixfCV");


var $haiCi = parcelRequire("haiCi");


var $hkokM = parcelRequire("hkokM");

const $23d23aea84aebb6d$export$cf57de7718965ae3 = {
    hasNextPage: false,
    hasPreviousPage: false,
    startCursor: undefined,
    endCursor: undefined
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $23d23aea84aebb6d$var$transformAgentListToGqlResponse = (response)=>{
    try {
        // data can be null if the `abortController` is aborted
        const { edges: edges, pageInfo: pageInfo } = response?.data?.agentStudio_getAgents ?? {
            pageInfo: $23d23aea84aebb6d$export$cf57de7718965ae3
        };
        const agents = edges?.map((edge)=>(0, $hkokM.transformAgentGqlResponse)(edge.node)).filter((agent)=>!!agent.id) ?? [];
        return {
            agents: agents,
            pageInfo: pageInfo
        };
    } catch  {
        return {
            agents: [],
            pageInfo: {
                hasNextPage: false,
                hasPreviousPage: false,
                startCursor: undefined,
                endCursor: undefined
            }
        };
    }
};
const $23d23aea84aebb6d$var$agentStudioAssistantFragment = `
fragment conversationAssistantAgent_agentStudioAssistant on AgentStudioAssistant {
  id
  name
  description
  conversationStarters
  isFavourite
  creatorType
  identityAccountId
  externalConfigReference
  creator {
    id
  }
  icon
  authoringTeam @skip(if: $skipAuthoringTeam) {
    id
    profileUrl
    displayName
		smallAvatarImageUrl
  }
  isVerified
  executionConfig @include(if: $includeExecutionConfig) {
    executionTier
    modelId
  }
}
`;
const $23d23aea84aebb6d$export$44f796a68d9bc9f1 = async ({ cloudId: cloudId, count: count = 10, after: after, product: product, input: input, abortController: abortController, workspaceId: workspaceId })=>{
    (0, $6cFsl.di)((0, $haiCi.performGqlFetch));
    const gqlQuery = `
	query agentStudioGetAgents($cloudId: String!, $first: Int, $input: AgentStudioAgentQueryInput, $after: String, $product: String, $workspaceId: String, $skipAuthoringTeam: Boolean = false, $includeExecutionConfig: Boolean = false) {
		agentStudio_getAgents(
			cloudId: $cloudId
			first: $first
			input: $input
			after: $after
			product: $product
			workspaceId: $workspaceId
		) @optIn(to: "AgentStudio") {
			edges {
				node {
					...conversationAssistantAgent_agentStudioAssistant
				}
			}
			pageInfo {
				startCursor
				endCursor
				hasNextPage
				hasPreviousPage
			}
		}
	}

	${$23d23aea84aebb6d$var$agentStudioAssistantFragment}
	`;
    const variables = {
        cloudId: cloudId,
        first: count,
        after: after,
        product: product,
        input: input,
        workspaceId: workspaceId,
        skipAuthoringTeam: (0, $ixfCV.fg)('rovo_agents_fetch_agents_without_authoring_team'),
        includeExecutionConfig: (0, $ixfCV.fg)('rovo_marathon_as_agent_enabled')
    };
    const response = await (0, $haiCi.performGqlFetch)({
        gqlQuery: gqlQuery,
        variables: variables,
        abortController: abortController
    });
    return $23d23aea84aebb6d$var$transformAgentListToGqlResponse(response);
};
const $23d23aea84aebb6d$export$fce04ce5e2fe57d3 = async ({ cloudId: cloudId, externalConfigReference: externalConfigReference })=>{
    (0, $6cFsl.di)((0, $haiCi.performGqlFetch));
    const gqlQuery = `
	query agentStudioGetAgentByExternalConfigReference($cloudId: String!, $externalConfigReference: String!, $skipAuthoringTeam: Boolean = false, $includeExecutionConfig: Boolean = false) {
		agentStudio_getByExternalReference(cloudId: $cloudId, externalReference: $externalConfigReference) @optIn(to: "AgentStudio") {
			...conversationAssistantAgent_agentStudioAssistant
			}
		}

		${$23d23aea84aebb6d$var$agentStudioAssistantFragment}
		`;
    const variables = {
        cloudId: cloudId,
        externalConfigReference: externalConfigReference,
        skipAuthoringTeam: (0, $ixfCV.fg)('rovo_agents_fetch_agents_without_authoring_team'),
        includeExecutionConfig: (0, $ixfCV.fg)('rovo_marathon_as_agent_enabled')
    };
    const response = await (0, $haiCi.performGqlFetch)({
        gqlQuery: gqlQuery,
        variables: variables
    });
    return (0, $hkokM.transformAgentGqlResponse)(response.data.agentStudio_getByExternalReference);
};
module.exports["DEFAULT_PAGE_INFO"] = $23d23aea84aebb6d$export$cf57de7718965ae3;
module.exports["fetchPaginatedAgents"] = $23d23aea84aebb6d$export$44f796a68d9bc9f1;
module.exports["fetchAgentByExternalConfigReference"] = $23d23aea84aebb6d$export$fce04ce5e2fe57d3;

});

parcelRegister("hkokM", function(module, exports) {
const $296d37b9c9e504ab$export$92f11cf4e802b166 = (ari)=>{
    // Pattern: ari:cloud:rovo::agent/activation/{uuid}/{uuid}
    const ariPattern = /^ari:cloud:rovo::agent\/activation\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/([^/]+)$/;
    const match = ari.match(ariPattern);
    if (!match) return null;
    // Return the second UUID (agent ID)
    return match[1];
};
const $296d37b9c9e504ab$export$91e35509133d1cc1 = (agentNode)=>({
        creator_type: agentNode.creatorType,
        creator: agentNode.creator?.id,
        description: agentNode.description,
        external_config_reference: agentNode.externalConfigReference,
        favourite: agentNode.isFavourite,
        id: $296d37b9c9e504ab$export$92f11cf4e802b166(agentNode.id) ?? '',
        agentAri: agentNode.id,
        identity_account_id: agentNode.identityAccountId,
        name: agentNode.name,
        user_defined_conversation_starters: agentNode.conversationStarters,
        icon: agentNode.icon,
        // We need named_id here as the FE requires it for certain features
        named_id: $296d37b9c9e504ab$export$92f11cf4e802b166(agentNode.id) ?? '',
        authoring_team: agentNode?.authoringTeam ? {
            id: agentNode.authoringTeam.id,
            profile_url: agentNode.authoringTeam.profileUrl,
            display_name: agentNode.authoringTeam.displayName,
            avatar_url: agentNode.authoringTeam.smallAvatarImageUrl
        } : null,
        is_verified: agentNode.isVerified,
        execution_config: agentNode.executionConfig ? {
            execution_tier: agentNode.executionConfig.executionTier
        } : null
    });
module.exports["transformAgentGqlResponse"] = $296d37b9c9e504ab$export$91e35509133d1cc1;

});

parcelRegister("aihbI", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $cXtTj = parcelRequire("cXtTj");


var $i1t43 = parcelRequire("i1t43");


var $NlHoa = parcelRequire("NlHoa");


var $12QCz = parcelRequire("12QCz");


var $ixfCV = parcelRequire("ixfCV");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $hSs5g = parcelRequire("hSs5g");


var $hq9Cp = parcelRequire("hq9Cp");


var $a9aSv = parcelRequire("a9aSv");


var $hlvTd = parcelRequire("hlvTd");


var $5SS4O = parcelRequire("5SS4O");


var $ji12t = parcelRequire("ji12t");


var $8reXX = parcelRequire("8reXX");


var $aaPn1 = parcelRequire("aaPn1");


var $fjlCA = parcelRequire("fjlCA");


var $cKhij = parcelRequire("cKhij");

const $117d671412ecf119$export$3761e66a04602cbd = (ari)=>{
    const matched = ari.match(/\/([a-zA-Z0-9_\|\-\:]{1,128})$/);
    return matched ? matched[1] : undefined;
};
const $117d671412ecf119$export$acf3e1bcf222b00d = (aaid)=>{
    return `ari:cloud:identity::user/${aaid}`;
};
const $117d671412ecf119$export$1565ea9a9fb7ad67 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { agent: agent, siteId: siteId, simplified: simplified, onClick: onClick } = t0;
    if ((0, $ji12t.isSystemAgent)(agent) || (0, $ji12t.isOOTBAgent)(agent) || !agent.creator) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
                alignBlock: "center",
                testId: "atlassian-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                label: "",
                appearance: "brand",
                size: "small"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), null, "Atlassian"));
            $[0] = t1;
        } else t1 = $[0];
        return t1;
    }
    if ((0, $ji12t.isCustomerAgent)(agent)) {
        const authoringTeam = agent.authoring_team;
        if (authoringTeam?.id) {
            let t1;
            if ($[1] !== authoringTeam.display_name || $[2] !== authoringTeam.profile_url || $[3] !== onClick) {
                t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
                    alignBlock: "center",
                    testId: "atlassian-icon"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: authoringTeam.profile_url,
                    target: "_blank",
                    onClick: onClick
                }, authoringTeam.display_name));
                $[1] = authoringTeam.display_name;
                $[2] = authoringTeam.profile_url;
                $[3] = onClick;
                $[4] = t1;
            } else t1 = $[4];
            return t1;
        }
        let t1;
        if ($[5] !== agent.creator) {
            t1 = agent.creator ? $117d671412ecf119$export$3761e66a04602cbd(agent.creator) : undefined;
            $[5] = agent.creator;
            $[6] = t1;
        } else t1 = $[6];
        const aaid = t1;
        if (!aaid) return null;
        let t2;
        if ($[7] !== aaid || $[8] !== onClick || $[9] !== simplified || $[10] !== siteId) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($117d671412ecf119$var$ResolvingMention, {
                userId: aaid,
                siteId: siteId,
                profileCard: true,
                simplified: simplified,
                onClick: onClick
            });
            $[7] = aaid;
            $[8] = onClick;
            $[9] = simplified;
            $[10] = siteId;
            $[11] = t2;
        } else t2 = $[11];
        return t2;
    }
    if ((0, $ixfCV.fg)("rovo_agent_support_a2a_avatar") ? (0, $hq9Cp.isForgeAgentByCreatorType)(agent.creator_type) : (0, $ji12t.isForgeAgent)(agent)) {
        if (agent.creator_type === "REMOTE_A2A" && (0, $cXtTj.default).getExperimentValue("rovo_hide_remote_a2a_agent_creator_exp", "isEnabled", false)) return null;
        let t1;
        if ($[12] !== agent.creator) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), null, agent.creator);
            $[12] = agent.creator;
            $[13] = t1;
        } else t1 = $[13];
        return t1;
    }
    return null;
} : ({ agent: agent, siteId: siteId, simplified: simplified, onClick: onClick })=>{
    if ((0, $ji12t.isSystemAgent)(agent) || (0, $ji12t.isOOTBAgent)(agent) || !agent.creator) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        alignBlock: "center",
        testId: "atlassian-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
        label: "",
        appearance: "brand",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), null, "Atlassian"));
    if ((0, $ji12t.isCustomerAgent)(agent)) {
        const authoringTeam = agent.authoring_team;
        if (authoringTeam?.id) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            alignBlock: "center",
            testId: "atlassian-icon"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: authoringTeam.profile_url,
            target: "_blank",
            onClick: onClick
        }, authoringTeam.display_name));
        const aaid = agent.creator ? $117d671412ecf119$export$3761e66a04602cbd(agent.creator) : undefined;
        if (!aaid) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($117d671412ecf119$var$ResolvingMention, {
            userId: aaid,
            siteId: siteId,
            profileCard: true,
            simplified: simplified,
            onClick: onClick
        });
    }
    if ((0, $ixfCV.fg)('rovo_agent_support_a2a_avatar') ? (0, $hq9Cp.isForgeAgentByCreatorType)(agent.creator_type) : (0, $ji12t.isForgeAgent)(agent)) {
        if (agent.creator_type === 'REMOTE_A2A' && (0, $cXtTj.default).getExperimentValue('rovo_hide_remote_a2a_agent_creator_exp', 'isEnabled', false)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), null, agent.creator);
    }
    return null;
};
// TODO consolidate this with `AgentCreator` component `platform/packages/ai-mate/conversation-assistant-agent/src/common/ui/creator/index.tsx`
const $117d671412ecf119$var$ResolvingMention = ({ userId: userId, siteId: siteId, profileCard: profileCard = false, simplified: simplified = false, onClick: onClick })=>{
    (0, $6cFsl.di)($117d671412ecf119$export$5d980898591175e);
    const { profile: profile, client: client } = $117d671412ecf119$export$5d980898591175e(userId, siteId);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { atlasURL: atlasURL } = (0, $aaPn1.useAtlasURL)(siteId);
    const fullName = profile.data?.status === 'inactive' && profile.data.fullName ? formatMessage((0, $cKhij.default).deactivatedCreatorName, {
        name: profile.data.fullName
    }) : profile.data?.fullName;
    if (profile.isFetching || !profile.data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        isShimmering: true,
        height: 18,
        width: 100,
        borderRadius: "var(--ds-radius-small, 4px)"
    });
    if (simplified) {
        const profileUrl = atlasURL(`/people/${userId}`);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: profileUrl,
            target: "_blank",
            onClick: onClick
        }, fullName);
    }
    return profileCard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSs5g.default), {
        userId: userId,
        resourceClient: client,
        ariaLabel: fullName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $12QCz.default), {
        id: userId,
        isHighlighted: profile.data.isCurrentUser,
        text: `@${fullName}`
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $12QCz.default), {
        id: userId,
        isHighlighted: profile.data.isCurrentUser,
        text: `@${fullName}`
    });
};
const $117d671412ecf119$export$5d980898591175e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useProfileResolution(userId, siteId, t0) {
    const $ = (0, $bDgLe.c)(14);
    const shouldFetch = t0 === undefined ? true : t0;
    const profileClient = (0, $fjlCA.useProfileClient)();
    let t1;
    if ($[0] !== siteId || $[1] !== userId) {
        t1 = [
            "fetchProfile",
            siteId,
            userId
        ];
        $[0] = siteId;
        $[1] = userId;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== profileClient || $[4] !== siteId || $[5] !== userId) {
        t2 = async ()=>{
            try {
                const response = await profileClient.getProfile(siteId, userId);
                return response;
            } catch (t3) {
                const error = t3;
                (0, $hlvTd.logException)({
                    exception: error,
                    name: "ConversationAssistantAgentUseProfileResolutionError"
                });
                return {};
            }
        };
        $[3] = profileClient;
        $[4] = siteId;
        $[5] = userId;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== shouldFetch || $[8] !== t1 || $[9] !== t2) {
        t3 = {
            queryKey: t1,
            queryFn: t2,
            enabled: shouldFetch
        };
        $[7] = shouldFetch;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    const profile = (0, $5SS4O.useQuery)(t3);
    let t4;
    if ($[11] !== profile || $[12] !== profileClient) {
        t4 = {
            profile: profile,
            client: profileClient
        };
        $[11] = profile;
        $[12] = profileClient;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : function useProfileResolution(userId, siteId, shouldFetch = true) {
    const profileClient = (0, $fjlCA.useProfileClient)();
    const profile = (0, $5SS4O.useQuery)({
        queryKey: [
            'fetchProfile',
            siteId,
            userId
        ],
        queryFn: async ()=>{
            try {
                const response = await profileClient.getProfile(siteId, userId);
                return response;
            } catch (error) {
                (0, $hlvTd.logException)({
                    exception: error,
                    name: 'ConversationAssistantAgentUseProfileResolutionError'
                });
                return {};
            }
        },
        enabled: shouldFetch
    });
    return {
        profile: profile,
        client: profileClient
    };
};
const $117d671412ecf119$export$13d60404a0dddebd = (agents, filters)=>{
    return agents.filter((agent)=>agent.name.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase()) || agent.description?.toLocaleLowerCase().includes(filters.searchValue.toLocaleLowerCase())).sort((a, b)=>a.name.localeCompare(b.name));
};
const $117d671412ecf119$export$a6e36c224ec3c0cb = (agent)=>{
    const enabledSources = agent.scenarios?.filter((scenario)=>scenario.isActive && scenario.isValid?.value)?.flatMap((scenario)=>scenario.knowledgeSources).filter((source)=>source?.enabled).flatMap((source)=>source?.sources).filter((source)=>source?.enabled);
    if (!enabledSources?.length) return [];
    const allAris = enabledSources?.reduce((acc, cur)=>{
        const allFilters = [
            ...cur?.filters?.parentFilter ?? [],
            ...cur?.filters?.spaceFilter ?? [],
            ...cur?.filters?.projectFilter ?? []
        ];
        allFilters.forEach((item)=>acc.add(item));
        return acc;
    }, new Set());
    return Array.from(allAris);
};
const $117d671412ecf119$export$6d876204c5d593ac = ({ availableAgents: availableAgents, product: product })=>{
    // If no product is provided / product is not supported, fallback to using default agents
    const defaultAgentsNamedIds = product ? (0, $8reXX.DEFAULT_OOTB_AGENTS_NAMED_IDS)[product] ?? (0, $8reXX.DEFAULT_AGENTS_NAMED_ID_LIST) : (0, $8reXX.DEFAULT_AGENTS_NAMED_ID_LIST);
    const defaultAgents = availableAgents.filter((agent)=>defaultAgentsNamedIds.has(agent.named_id) || agent.external_config_reference && defaultAgentsNamedIds.has(agent.external_config_reference));
    return defaultAgents;
};
module.exports["getAAIDFromARI"] = $117d671412ecf119$export$3761e66a04602cbd;
module.exports["AgentCreatedBy"] = $117d671412ecf119$export$1565ea9a9fb7ad67;
module.exports["useProfileResolution"] = $117d671412ecf119$export$5d980898591175e;
module.exports["getEnabledKnowlegeArisFromAgent"] = $117d671412ecf119$export$a6e36c224ec3c0cb;
module.exports["getSuggestedOotbAgents"] = $117d671412ecf119$export$6d876204c5d593ac;

});

parcelRegister("ji12t", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");

const $ee0754b6a3322402$export$7c120b233d4844c6 = (agent)=>agent.creator_type === 'SYSTEM';
const $ee0754b6a3322402$export$f817e52cf2c5cc8c = (agent)=>agent.creator_type === 'CUSTOMER';
const $ee0754b6a3322402$export$2149adda3d8a5807 = (agent)=>agent.creator_type === 'THIRD_PARTY' || agent.creator_type === 'FORGE' || agent.creator_type === 'REMOTE_A2A' && (0, $ixfCV.fg)('rovo_agent_support_a2a_avatar');
const $ee0754b6a3322402$export$95433d0f8c6ad323 = (agent)=>agent.visibility === 'PRIVATE';
const $ee0754b6a3322402$export$7091e3bee2adaacb = (agent)=>agent.creator_type === 'OOTB';
const $ee0754b6a3322402$export$916e4870f74f205b = {
    ALL_AGENTS: 'all-agents',
    STARRED_AGENTS: 'starred-agents',
    MY_AGENTS: 'my-agents',
    TEMPLATES: 'templates',
    VERIFIED_AGENTS: 'verified-agents',
    /** Jira browse tab: agents available for Jira (UI label localized in product). */ AVAILABLE_FOR_JIRA: 'available-for-jira',
    /** Jira browse tab: 3P marketplace coding agents (UI label localized in product). */ CODING_AGENTS: 'coding-agents'
};
module.exports["isSystemAgent"] = $ee0754b6a3322402$export$7c120b233d4844c6;
module.exports["isCustomerAgent"] = $ee0754b6a3322402$export$f817e52cf2c5cc8c;
module.exports["isForgeAgent"] = $ee0754b6a3322402$export$2149adda3d8a5807;
module.exports["isOOTBAgent"] = $ee0754b6a3322402$export$7091e3bee2adaacb;
module.exports["BrowseCategories"] = $ee0754b6a3322402$export$916e4870f74f205b;

});

parcelRegister("8reXX", function(module, exports) {
const $631eae7ab6cb77ba$export$48783720d93c2d26 = {
    id: 'ai_mate_agent',
    named_id: 'ai_mate_agent',
    name: 'AI Mate',
    description: 'AI Mate',
    creator_type: 'SYSTEM',
    available_plugins: {},
    is_default: true,
    visibility: 'PUBLIC'
};
const $631eae7ab6cb77ba$export$2d0163867590928d = new Set([
    'decision_director_agent',
    'user_manual_writer_agent',
    'product_requirements_expert_agent'
]);
const $631eae7ab6cb77ba$export$804d9ee5f4cc40a8 = {
    ['confluence']: new Set([
        'decision_director_agent',
        'product_requirements_expert_agent',
        'rovo_expert_agent'
    ]),
    ['jira']: new Set([
        'rovo_expert_agent',
        'issue_organizer_agent',
        'jira_theme_analyzer_agent'
    ]),
    ['atlas']: new Set([
        'progress_tracker_agent',
        'product_requirements_expert_agent',
        'rovo_expert_agent'
    ])
};
const $631eae7ab6cb77ba$var$AGENT_AUP_ERROR_CODE = `convoai.agent.responsible-ai.failure`;
const $631eae7ab6cb77ba$var$HIPAA_ERROR_CODE = 'convoai.rest.browsing.product.has.hipaa.enabled';
const $631eae7ab6cb77ba$export$a08ace1426fa4a9e = (error)=>Boolean(error) && typeof error === 'object' && error.errorAttributes && error.errorAttributes.errorCode === $631eae7ab6cb77ba$var$AGENT_AUP_ERROR_CODE;
const $631eae7ab6cb77ba$export$f8b1b75846492611 = (error)=>Boolean(error) && typeof error === 'object' && error.errorAttributes && error.errorAttributes.errorCode === $631eae7ab6cb77ba$var$HIPAA_ERROR_CODE;
const $631eae7ab6cb77ba$export$429080cfef3412f2 = 'browse-agents-container';
module.exports["DEFAULT_AGENTS_NAMED_ID_LIST"] = $631eae7ab6cb77ba$export$2d0163867590928d;
module.exports["DEFAULT_OOTB_AGENTS_NAMED_IDS"] = $631eae7ab6cb77ba$export$804d9ee5f4cc40a8;
module.exports["isHipaaError"] = $631eae7ab6cb77ba$export$f8b1b75846492611;
module.exports["AGENTS_CONTAINER_ID"] = $631eae7ab6cb77ba$export$429080cfef3412f2;

});

parcelRegister("fjlCA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $5hJlu = parcelRequire("5hJlu");

const $b39593d68f627ba8$var$DIRECTORY_URL = '/gateway/api/directory/graphql';
let $b39593d68f627ba8$var$client;
const $b39593d68f627ba8$export$d43dc22a8337ee9f = ()=>{
    (0, $6cFsl.di)((0, $5hJlu.default));
    const profileClient = (0, $cozmU.useMemo)(()=>{
        if (!$b39593d68f627ba8$var$client) // To support di
        $b39593d68f627ba8$var$client = new (0, $5hJlu.default)({
            url: $b39593d68f627ba8$var$DIRECTORY_URL,
            cacheSize: 1000,
            // 1 day
            cacheMaxAge: 86400000
        });
        return $b39593d68f627ba8$var$client;
    }, []);
    return profileClient;
};
module.exports["useProfileClient"] = $b39593d68f627ba8$export$d43dc22a8337ee9f;

});

parcelRegister("cKhij", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $f61c2cb3f029b6ef$var$message = (0, $kSwu1.defineMessages)({
    deactivatedCreatorName: {
        id: "rovo-chat.agent-card.deactivated-name",
        defaultMessage: "{name} (deactivated)"
    }
});
var $f61c2cb3f029b6ef$export$2e2bcd8739ae039 = $f61c2cb3f029b6ef$var$message;
module.exports["default"] = $f61c2cb3f029b6ef$export$2e2bcd8739ae039;

});

parcelRegister("h6LPv", function(module, exports) {

var $irnO2 = parcelRequire("irnO2");


var $kuIhJ = parcelRequire("kuIhJ");


var $lJ6db = parcelRequire("lJ6db");


var $33DP2 = parcelRequire("33DP2");

const $ceec91f359597657$export$89877d4f8d8790ca = (0, $lJ6db.createHookWithAssistanceService)(({ onSuccess: onSuccess, onError: onError, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker }, onInit: onInit })=>{
    const deleteAgent = (0, $kuIhJ.useMutation)({
        mutationFn: async (id)=>{
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).DELETE_AGENT,
                name: (0, $irnO2.ExperienceName).DELETE_AGENT
            });
            onInit?.(id);
            return await assistanceService.deleteAgent(id);
        },
        onSuccess: async (data)=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).DELETE_AGENT
            });
            onSuccess?.();
            return data;
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).DELETE_AGENT,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
            onError?.();
        }
    });
    return {
        deleteAgent: deleteAgent
    };
});
module.exports["useDeleteAgent"] = $ceec91f359597657$export$89877d4f8d8790ca;

});

parcelRegister("3ay5Z", function(module, exports) {

var $irnO2 = parcelRequire("irnO2");


var $kuIhJ = parcelRequire("kuIhJ");


var $lJ6db = parcelRequire("lJ6db");


var $33DP2 = parcelRequire("33DP2");

const $852df1b03fff5c54$export$5c4c46b1f93a6e69 = (0, $lJ6db.createHookWithAssistanceService)(({ onError: onError, onSuccess: onSuccess, assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker } })=>{
    const favouriteAgent = (0, $kuIhJ.useMutation)({
        mutationFn: async (id)=>{
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).FAVOURITE_AGENT,
                name: (0, $irnO2.ExperienceName).FAVOURITE_AGENT
            });
            return await assistanceService.favouriteAgent(id);
        },
        onSuccess: async ()=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).FAVOURITE_AGENT
            });
            onSuccess?.({
                favourite: true
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).FAVOURITE_AGENT,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
            onError?.({
                favourite: true
            });
        }
    });
    const unfavouriteAgent = (0, $kuIhJ.useMutation)({
        mutationFn: async (id)=>{
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).UNFAVOURITE_AGENT,
                name: (0, $irnO2.ExperienceName).UNFAVOURITE_AGENT
            });
            return await assistanceService.unfavouriteAgent(id);
        },
        onSuccess: async ()=>{
            experienceTracker.succeed({
                name: (0, $irnO2.ExperienceName).UNFAVOURITE_AGENT
            });
            onSuccess?.({
                favourite: false
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $irnO2.ExperienceName).UNFAVOURITE_AGENT,
                error: error,
                teamName: (0, $33DP2.ROVO_AGENTS_FE_TEAM_NAME)
            });
            onError?.({
                favourite: false
            });
        }
    });
    return {
        favouriteAgent: favouriteAgent,
        unfavouriteAgent: unfavouriteAgent
    };
});
module.exports["useAgentFavourites"] = $852df1b03fff5c54$export$5c4c46b1f93a6e69;

});

parcelRegister("5Vuk7", function(module, exports) {
const $17fc5339fe3ee56f$export$b873e2166b2a4c4f = (agents, agentIdFiltersOverride, agentDefaultIdOverride)=>{
    const defaultOverrideAgentsIndex = agents.findIndex((agent)=>agentDefaultIdOverride === agent.id);
    let overridenAgents = [];
    if (defaultOverrideAgentsIndex !== -1) overridenAgents = agents.map((agent, index)=>({
            ...agent,
            is_default: index === defaultOverrideAgentsIndex
        }));
    else overridenAgents = agents;
    if (Array.isArray(agentIdFiltersOverride)) return overridenAgents.filter((agent)=>agentIdFiltersOverride?.includes(agent.id) || agent.is_default);
    return overridenAgents;
};
module.exports["getOverridenAgents"] = $17fc5339fe3ee56f$export$b873e2166b2a4c4f;

});

parcelRegister("fU4xN", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $4657aea77ee8f7d7$var$message = (0, $kSwu1.defineMessages)({
    defaultAgentName: {
        id: "ai-mate.agent-selector.default-agent-name",
        defaultMessage: "Chat"
    },
    defaultAgentDescription: {
        id: "ai-mate.agent-selector.default-agent-description",
        defaultMessage: "Get answers, generate new ideas, and accelerate everyday work."
    }
});
var $4657aea77ee8f7d7$export$2e2bcd8739ae039 = $4657aea77ee8f7d7$var$message;
module.exports["default"] = $4657aea77ee8f7d7$export$2e2bcd8739ae039;

});

parcelRegister("lzoay", function(module, exports) {

var $dSoGR = parcelRequire("dSoGR");

const $6b458841b18d92d3$export$2d48a0bb3ca90998 = (0, $dSoGR.createCommand)('action-classification-command');
module.exports["ActionClassificationCommand"] = $6b458841b18d92d3$export$2d48a0bb3ca90998;

});

parcelRegister("hd4Ag", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $9Yqfz = parcelRequire("9Yqfz");


var $eriCt = parcelRequire("eriCt");

const $1f69189ce877419f$export$6fa751d66e55d2e1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const contextValue = (0, $cozmU.useContext)((0, $eriCt.WindowLocationContext));
    const location = (0, $cozmU.useSyncExternalStore)((0, $9Yqfz.subscribeToLocation), (0, $9Yqfz.getLocationSnapshot), (0, $9Yqfz.getLocationServerSnapshot));
    return contextValue ?? location;
} : ()=>{
    const contextValue = (0, $cozmU.useContext)((0, $eriCt.WindowLocationContext));
    const location = (0, $cozmU.useSyncExternalStore)((0, $9Yqfz.subscribeToLocation), (0, $9Yqfz.getLocationSnapshot), (0, $9Yqfz.getLocationServerSnapshot));
    return contextValue ?? location;
};
module.exports["useWindowLocation"] = $1f69189ce877419f$export$6fa751d66e55d2e1;

});

parcelRegister("eriCt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $34391591fc09bf27$export$46133998910543ac = (0, $cozmU.createContext)(null);
module.exports["WindowLocationContext"] = $34391591fc09bf27$export$46133998910543ac;

});

parcelRegister("9MCKh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");






































const $d0265bb51b10f57e$export$dce8bc0f04f0d915 = {
    skill: ()=>Promise.resolve((parcelRequire("h5LaW"))),
    assets: ()=>(parcelRequire("69A4I")),
    add: ()=>Promise.resolve((parcelRequire("gFEZF"))),
    'chart-bar-line': ()=>(parcelRequire("kU1Yt")),
    'ai-generative-text': ()=>Promise.resolve((parcelRequire("9V507"))),
    'work-item': ()=>Promise.resolve((parcelRequire("iRFKG"))),
    'lock-locked': ()=>Promise.resolve((parcelRequire("4efpo"))),
    'chart-pie': ()=>(parcelRequire("e8Ghu")),
    plan: ()=>(parcelRequire("fhtzK")),
    settings: ()=>Promise.resolve((parcelRequire("11OF7"))),
    'project-status': ()=>(parcelRequire("duNV8")),
    'merge-success': ()=>(parcelRequire("3pUsI")),
    'person-add': ()=>(parcelRequire("1ORsb")),
    'people-group': ()=>Promise.resolve((parcelRequire("fBqzD"))),
    'person-added': ()=>(parcelRequire("1VVw9")),
    login: ()=>(parcelRequire("lp0Ka")),
    'ai-generative-text-summary': ()=>Promise.resolve((parcelRequire("f0b2F"))),
    transition: ()=>(parcelRequire("lPrvY")),
    board: ()=>Promise.resolve((parcelRequire("4MdqE"))),
    release: ()=>Promise.resolve((parcelRequire("2F2yY"))),
    'app-switcher': ()=>(parcelRequire("gfpxd")),
    search: ()=>Promise.resolve((parcelRequire("hAgam"))),
    'playlist-add': ()=>(parcelRequire("lJQ5X")),
    'playlist-remove': ()=>(parcelRequire("bYXrx")),
    summary: ()=>Promise.resolve((parcelRequire("f0b2F"))),
    clock: ()=>Promise.resolve((parcelRequire("5ZtfK"))),
    'ai-generative-chapters': ()=>Promise.resolve((parcelRequire("dQeg1"))),
    talent: ()=>(parcelRequire("j74pS")),
    incident: ()=>Promise.resolve((parcelRequire("ipvL3"))),
    form: ()=>(parcelRequire("e3rWd")),
    ticket: ()=>(parcelRequire("fS7mD")),
    alert: ()=>(parcelRequire("hBRNG")),
    pulse: ()=>(parcelRequire("4SYP6")),
    'text-lengthen': ()=>Promise.resolve((parcelRequire("2xJ2w"))),
    'ai-generative-cleanup': ()=>Promise.resolve((parcelRequire("7Jde4"))),
    survey: ()=>(parcelRequire("eNJEs")),
    'text-review': ()=>Promise.resolve((parcelRequire("4u3xL")))
};
const $d0265bb51b10f57e$export$ca2f546e21dcce87 = $d0265bb51b10f57e$export$dce8bc0f04f0d915.skill;
const $d0265bb51b10f57e$export$f7883dcc9f65479a = Object.fromEntries(Object.entries($d0265bb51b10f57e$export$dce8bc0f04f0d915).map(([key, loader])=>[
        key,
        (0, $cozmU.lazy)(loader)
    ]));
const $d0265bb51b10f57e$export$78596fa6083c04d1 = $d0265bb51b10f57e$export$f7883dcc9f65479a.skill;
module.exports["skillIcon"] = $d0265bb51b10f57e$export$dce8bc0f04f0d915;
module.exports["defaultIcon"] = $d0265bb51b10f57e$export$ca2f546e21dcce87;
module.exports["skillIconMap"] = $d0265bb51b10f57e$export$f7883dcc9f65479a;
module.exports["DefaultSkillIcon"] = $d0265bb51b10f57e$export$78596fa6083c04d1;

});

parcelRegister("69A4I", function(module, exports) {

let $47af911cf9753809$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $47af911cf9753809$var$load("69hvJ").then(()=>parcelRequire('437ur'));

});

parcelRegister("kU1Yt", function(module, exports) {

let $f37a91b0c5a24fd5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f37a91b0c5a24fd5$var$load("hrkGn").then(()=>parcelRequire('5kuIA'));

});

parcelRegister("e8Ghu", function(module, exports) {

let $a4b29c33d05c1a9b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a4b29c33d05c1a9b$var$load("c6nMJ").then(()=>parcelRequire('eVhjN'));

});

parcelRegister("fhtzK", function(module, exports) {

let $b1ff629eca57471a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b1ff629eca57471a$var$load("i1I18").then(()=>parcelRequire('dIT3V'));

});

parcelRegister("duNV8", function(module, exports) {

let $9d34ccdd49f0003a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9d34ccdd49f0003a$var$load("bSZcP").then(()=>parcelRequire('6fcYF'));

});

parcelRegister("3pUsI", function(module, exports) {

let $27cf81197ca52259$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $27cf81197ca52259$var$load("3GLMP").then(()=>parcelRequire('bAdTB'));

});

parcelRegister("1ORsb", function(module, exports) {

let $1533ecb52c97b893$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1533ecb52c97b893$var$load("kBatH").then(()=>parcelRequire('am3XR'));

});

parcelRegister("1VVw9", function(module, exports) {

let $1687bb1e68c06fb7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1687bb1e68c06fb7$var$load("iN26T").then(()=>parcelRequire('4s4Os'));

});

parcelRegister("lp0Ka", function(module, exports) {

let $f94c827133a4a8ea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f94c827133a4a8ea$var$load("85Ack").then(()=>parcelRequire('hPGQU'));

});

parcelRegister("lPrvY", function(module, exports) {

let $fe43b4375d61c3d3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fe43b4375d61c3d3$var$load("jjuzw").then(()=>parcelRequire('iJGPY'));

});

parcelRegister("gfpxd", function(module, exports) {

let $bd41dab43722c8d5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bd41dab43722c8d5$var$load("dnVmf").then(()=>parcelRequire('9ib3C'));

});

parcelRegister("lJQ5X", function(module, exports) {

let $fd3635f2e5aabac0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fd3635f2e5aabac0$var$load("glmO2").then(()=>parcelRequire('3yAls'));

});

parcelRegister("bYXrx", function(module, exports) {

let $8b93687e70d55260$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8b93687e70d55260$var$load("32NHR").then(()=>parcelRequire('e3DmL'));

});

parcelRegister("j74pS", function(module, exports) {

let $dea218c262683901$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dea218c262683901$var$load("iWYx4").then(()=>parcelRequire('f1G8J'));

});

parcelRegister("e3rWd", function(module, exports) {

let $a3b7046b3b58e574$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a3b7046b3b58e574$var$load("cXTJH").then(()=>parcelRequire('bFnmR'));

});

parcelRegister("fS7mD", function(module, exports) {

let $b8e19c809ca15790$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b8e19c809ca15790$var$load("kMmm1").then(()=>parcelRequire('2ZUqo'));

});

parcelRegister("hBRNG", function(module, exports) {

let $cd1f9ffc4306ed9a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cd1f9ffc4306ed9a$var$load("k25pB").then(()=>parcelRequire('QrYx2'));

});

parcelRegister("4SYP6", function(module, exports) {

let $38eb62ceae487952$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $38eb62ceae487952$var$load("aWKP7").then(()=>parcelRequire('dK3CB'));

});

parcelRegister("eNJEs", function(module, exports) {

let $ac690dbfdd63bd67$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ac690dbfdd63bd67$var$load("bGOwY").then(()=>parcelRequire('2WCju'));

});

parcelRegister("h5LaW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a094e46648e7c203d266148a7c03a503>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7177f5d9d65cd37$var$_react = $c7177f5d9d65cd37$var$_interopRequireDefault((parcelRequire("cozmU")));

var $c7177f5d9d65cd37$var$_baseNew = $c7177f5d9d65cd37$var$_interopRequireDefault((parcelRequire("gElAV")));
function $c7177f5d9d65cd37$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Skill".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for skill functionality. Skills are a combination of tools and a prompt to allow an agent to perform a multistep process.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c7177f5d9d65cd37$var$SkillIcon = (props)=>/*#__PURE__*/ $c7177f5d9d65cd37$var$_react.default.createElement($c7177f5d9d65cd37$var$_baseNew.default, Object.assign({
        name: "SkillIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM15 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/><path fill="currentcolor" d="m11.11 4.934-5 7-1.22-.871 5-7z"/>`
    }, props));
$c7177f5d9d65cd37$var$SkillIcon.displayName = 'SkillIcon';
var $c7177f5d9d65cd37$var$_default = module.exports.default = $c7177f5d9d65cd37$var$SkillIcon;

});

parcelRegister("2xJ2w", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::14d3508a57d0950b33e5e611a6d67b81>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1da199c7b96e9bc5$var$_react = $1da199c7b96e9bc5$var$_interopRequireDefault((parcelRequire("cozmU")));

var $1da199c7b96e9bc5$var$_baseNew = $1da199c7b96e9bc5$var$_interopRequireDefault((parcelRequire("gElAV")));
function $1da199c7b96e9bc5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextLengthen".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Lengthening text content with Atlassian Intelligence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1da199c7b96e9bc5$var$TextLengthenIcon = (props)=>/*#__PURE__*/ $1da199c7b96e9bc5$var$_react.default.createElement($1da199c7b96e9bc5$var$_baseNew.default, Object.assign({
        name: "TextLengthenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm0 4.167H1v-1.5h14zm0 4.166H1v-1.5h14zM8 15H1v-1.5h7z" clip-rule="evenodd"/>`
    }, props));
$1da199c7b96e9bc5$var$TextLengthenIcon.displayName = 'TextLengthenIcon';
var $1da199c7b96e9bc5$var$_default = module.exports.default = $1da199c7b96e9bc5$var$TextLengthenIcon;

});

parcelRegister("4u3xL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::932feb0531e25a1286f435f5172e41c6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $343cb672fc3c26fb$var$_react = $343cb672fc3c26fb$var$_interopRequireDefault((parcelRequire("cozmU")));

var $343cb672fc3c26fb$var$_baseNew = $343cb672fc3c26fb$var$_interopRequireDefault((parcelRequire("gElAV")));
function $343cb672fc3c26fb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextReview".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Editor action for reviewing text
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $343cb672fc3c26fb$var$TextReviewIcon = (props)=>/*#__PURE__*/ $343cb672fc3c26fb$var$_react.default.createElement($343cb672fc3c26fb$var$_baseNew.default, Object.assign({
        name: "TextReviewIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M9.5 7.25v1.5H1v-1.5zM6 12.5V14H1v-1.5zM15 2v1.5H1V2zm1 8.24-4.67 5.5a.75.75 0 0 1-1.14 0l-2.33-2.75L9 12.02l1.76 2.08 4.1-4.82z"/>`
    }, props));
$343cb672fc3c26fb$var$TextReviewIcon.displayName = 'TextReviewIcon';
var $343cb672fc3c26fb$var$_default = module.exports.default = $343cb672fc3c26fb$var$TextReviewIcon;

});

parcelRegister("f6VI9", function(module, exports) {
function $ae2233479ab8cd62$export$db36004670a5626e(node) {
    return node?.__typename === 'GraphIntegrationSkillDirectoryItem';
}
function $ae2233479ab8cd62$export$7d1ba2a7b9e1a07(node) {
    return node?.__typename === 'ConvoAiSkill';
}
function $ae2233479ab8cd62$export$74ea09dd5afceb60(node) {
    if (!node || node.__typename !== 'GraphIntegrationSkillDirectoryItem') return null;
    const displayName = node.integrationKey?.displayName ?? '';
    const tagDisplayNames = node.tags?.map((t)=>t.displayName) ?? [];
    const trimmedDescription = node.description && node.description?.length > 150 ? `${node.description?.slice(0, 147)}...` : node.description ?? '';
    return {
        id: node.id,
        slug: node.slashCommand?.split('/')?.[1] ?? '',
        name: node.name ?? '',
        description: trimmedDescription,
        iconName: node.iconUrl?.split('name/')?.[1],
        product: displayName ? displayName.charAt(0).toUpperCase() + displayName.slice(1) : '',
        productIconUrl: node.integrationKey?.iconUrl ?? '',
        ...node.color ? {
            color: node.color
        } : {},
        ...tagDisplayNames.length > 0 ? {
            tags: [
                ...tagDisplayNames
            ]
        } : {}
    };
}
function $ae2233479ab8cd62$export$fd76a94f4a001a14(node) {
    if (!node || node.__typename !== 'ConvoAiSkill') return null;
    const primaryIntegration = node.integrations?.[0];
    let productDisplayName = '';
    let productIconUrl = '';
    // If the skill has integrations, else use the legacy integrationKeys.
    if (primaryIntegration) {
        productDisplayName = primaryIntegration.displayName ?? '';
        productIconUrl = primaryIntegration.iconUrl ?? '';
    } else {
        const product = node.integrationKeys?.[0] ?? '';
        productDisplayName = product ? product.charAt(0).toUpperCase() + product.slice(1) : '';
    }
    return {
        id: node.id,
        slug: node.slashCommand?.split('/')?.[1] ?? '',
        name: node.displayName ?? node.name ?? '',
        description: node.helpText ?? node.description ?? '',
        iconName: node.iconKey || node.iconUrl?.split('name/')?.[1],
        product: productDisplayName,
        productIconUrl: productIconUrl,
        ...node.color ? {
            color: node.color
        } : {},
        ...node.tags && node.tags.length > 0 ? {
            tags: [
                ...node.tags
            ]
        } : {}
    };
}
function $ae2233479ab8cd62$export$2cffb029ea623d71(edges) {
    if (!edges) return [];
    return edges.map((edge)=>$ae2233479ab8cd62$export$db36004670a5626e(edge?.node) ? $ae2233479ab8cd62$export$74ea09dd5afceb60(edge.node) : null).filter((skill)=>skill !== null);
}
function $ae2233479ab8cd62$export$554aac7da67453f5(edges) {
    if (!edges) return [];
    return edges.map((edge)=>$ae2233479ab8cd62$export$7d1ba2a7b9e1a07(edge?.node) ? $ae2233479ab8cd62$export$fd76a94f4a001a14(edge.node) : null).filter((skill)=>skill !== null);
}
function $ae2233479ab8cd62$export$faef8b68e529d4a7(edges) {
    if (!edges) return [];
    return edges.map((edge)=>{
        const node = edge?.node;
        if (!node || !node.__typename) return null;
        // Route to appropriate parser based on typename
        if ($ae2233479ab8cd62$export$db36004670a5626e(node)) return $ae2233479ab8cd62$export$74ea09dd5afceb60(node);
        if ($ae2233479ab8cd62$export$7d1ba2a7b9e1a07(node)) return $ae2233479ab8cd62$export$fd76a94f4a001a14(node);
        return null;
    }).filter((skill)=>skill !== null);
}
module.exports["parseSkillNode"] = $ae2233479ab8cd62$export$74ea09dd5afceb60;
module.exports["parseSkillEdges"] = $ae2233479ab8cd62$export$2cffb029ea623d71;
module.exports["parseConvoAiSkillEdges"] = $ae2233479ab8cd62$export$554aac7da67453f5;
module.exports["parseUniversalSkillEdges"] = $ae2233479ab8cd62$export$faef8b68e529d4a7;

});

parcelRegister("7dHQW", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $aAQ8R = parcelRequire("aAQ8R");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $f6VI9 = parcelRequire("f6VI9");


var $1Bxlw = parcelRequire("1Bxlw");

function $5446c5acb3eaf46c$export$70de0c6012582ca5(skillsResponse) {
    if (!skillsResponse?.edges) return {};
    const metadataMap = {};
    skillsResponse.edges.forEach((edge)=>{
        const node = edge?.node;
        if (!node || node.__typename !== 'GraphIntegrationSkillDirectoryItem') return;
        const skill = (0, $f6VI9.parseSkillNode)(node);
        if (!skill || !skill.slug) return;
        metadataMap[skill.slug] = {
            id: skill.id,
            name: skill.name,
            description: skill.description ?? '',
            iconName: skill.iconName,
            product: skill.product,
            productIconUrl: skill.productIconUrl,
            color: skill.color
        };
    });
    return metadataMap;
}
/**
 * Context for skill metadata
 */ const $5446c5acb3eaf46c$var$SkillMetadataContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $5446c5acb3eaf46c$export$6c7e4f3dd3ea4213 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useSkillMetadata() {
    return (0, $cozmU.useContext)($5446c5acb3eaf46c$var$SkillMetadataContext);
} : function useSkillMetadata() {
    return (0, $cozmU.useContext)($5446c5acb3eaf46c$var$SkillMetadataContext);
};
function $5446c5acb3eaf46c$export$54587e1184069f96({ children: children, siteId: siteId, tags: tagsProp, fetchWithoutTags: fetchWithoutTags = false }) {
    const config = (0, $1Bxlw.useRovoSkillsConfig)();
    const { skillsRevision: skillsRevision } = (0, $1Bxlw.useRovoSkillsInvalidation)();
    // Use tags from prop if provided, otherwise fallback to context
    const tags = tagsProp ?? config?.tags;
    const shouldFetch = !!tags?.skillRegistryTags && tags.skillRegistryTags.length > 0 || fetchWithoutTags;
    const skillsResponse = (0, $6SsN4.useLazyLoadQuery)(/* eslint-disable @atlassian/relay/unused-fields -- fields consumed by transformSkillMetadataResponse in this file */ (0, $aAQ8R.default), /* eslint-enable @atlassian/relay/unused-fields */ {
        first: 100,
        relevantFor: [
            'SKILL'
        ],
        cloudId: siteId,
        surface: 'ROVO',
        shouldSkip: !shouldFetch,
        tags: fetchWithoutTags ? undefined : tags?.skillRegistryTags ?? []
    }, {
        fetchKey: skillsRevision,
        fetchPolicy: skillsRevision === 0 ? 'store-or-network' : 'network-only'
    })?.graphIntegration_componentDirectoryItems;
    const skillMetadataMap = (0, $cozmU.useMemo)(()=>{
        if (!shouldFetch) return {};
        return $5446c5acb3eaf46c$export$70de0c6012582ca5(skillsResponse);
    }, [
        shouldFetch,
        skillsResponse
    ]);
    const value = (0, $cozmU.useMemo)(()=>({
            skillMetadataMap: skillMetadataMap
        }), [
        skillMetadataMap
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5446c5acb3eaf46c$var$SkillMetadataContext.Provider, {
        value: value
    }, children);
}
module.exports["useSkillMetadata"] = $5446c5acb3eaf46c$export$6c7e4f3dd3ea4213;
module.exports["SkillMetadataProvider"] = $5446c5acb3eaf46c$export$54587e1184069f96;

});

parcelRegister("aAQ8R", function(module, exports) {
/**
 * @generated SignedSource<<2e0d68bf66f01dede289e18e54bbc3ad>>
 * @relayHash 2b65d1bc6af8a5b24528e315a236250f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c5175af020c79b26302d5ffa3ae68ee40c220659f9948b0647fe7e453403671f
const $442a06332da1bb4d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "relevantFor"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldSkip"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "surface"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "tags"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "relevantFor",
            "variableName": "relevantFor"
        },
        {
            "kind": "Variable",
            "name": "surface",
            "variableName": "surface"
        },
        {
            "kind": "Variable",
            "name": "tags",
            "variableName": "tags"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "slashCommand"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = {
        "kind": "ScalarField",
        "name": "description"
    }, v12 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v13 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v14 = {
        "kind": "ScalarField",
        "name": "color"
    }, v15 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "hasPreviousPage"
            },
            {
                "kind": "ScalarField",
                "name": "startCursor"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v16 = [
        v8 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "skillMetadataProviderQuery",
            "selections": [
                {
                    "condition": "shouldSkip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "GraphIntegrationDirectoryItemConnection",
                            "kind": "LinkedField",
                            "name": "graphIntegration_componentDirectoryItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphIntegrationDirectoryItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        {
                                                            "concreteType": "GraphIntegrationDirectoryFilterDimension",
                                                            "kind": "LinkedField",
                                                            "name": "integrationKey",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                v12 /*: any*/ 
                                                            ]
                                                        },
                                                        v14 /*: any*/ 
                                                    ],
                                                    "type": "GraphIntegrationSkillDirectoryItem"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v15 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "skillMetadataProviderQuery",
            "selections": [
                {
                    "condition": "shouldSkip",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v6 /*: any*/ ,
                            "concreteType": "GraphIntegrationDirectoryItemConnection",
                            "kind": "LinkedField",
                            "name": "graphIntegration_componentDirectoryItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "GraphIntegrationDirectoryItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ ,
                                                        {
                                                            "concreteType": "GraphIntegrationDirectoryFilterDimension",
                                                            "kind": "LinkedField",
                                                            "name": "integrationKey",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                v12 /*: any*/ ,
                                                                v8 /*: any*/ 
                                                            ]
                                                        },
                                                        v14 /*: any*/ 
                                                    ],
                                                    "type": "GraphIntegrationSkillDirectoryItem"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v16 /*: any*/ ,
                                                    "type": "GraphIntegrationActionDirectoryItem"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v16 /*: any*/ ,
                                                    "type": "GraphIntegrationMcpServer"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v16 /*: any*/ ,
                                                    "type": "GraphIntegrationMcpTool"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v16 /*: any*/ ,
                                                    "type": "GraphIntegrationSkillItem"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v15 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c5175af020c79b26302d5ffa3ae68ee40c220659f9948b0647fe7e453403671f",
            "metadata": {},
            "name": "skillMetadataProviderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$442a06332da1bb4d$var$node.hash = "a886cc1a7f4cca0c76a7569f4eaae42e";
var $442a06332da1bb4d$export$2e2bcd8739ae039 = $442a06332da1bb4d$var$node;
module.exports["default"] = $442a06332da1bb4d$export$2e2bcd8739ae039;

});

parcelRegister("1Bxlw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aJNFh = parcelRequire("aJNFh");

const $350692d982fcc44a$var$RovoSkillsConfigContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $350692d982fcc44a$var$fallbackInvalidation = {
    skillsRevision: 0,
    // Outside RovoSkillsConfigProvider there is no revision state to bump, so this only clears
    // the vanilla insert-menu cache. Relay consumers need the provider to refetch by revision.
    invalidateSkillLibrary: (0, $aJNFh.clearSkillsCache)
};
const $350692d982fcc44a$var$RovoSkillsInvalidationContext = /*#__PURE__*/ (0, $cozmU.createContext)($350692d982fcc44a$var$fallbackInvalidation); /**
                                                                                                    * Hook to access Rovo Skills configuration.
                                                                                                    *
                                                                                                    * @returns The Rovo Skills configuration, or undefined if used outside of RovoSkillsConfigProvider
                                                                                                    *
                                                                                                    * @example
                                                                                                    * ```tsx
                                                                                                    * function MyComponent() {
                                                                                                    *   const config = useRovoSkillsConfig();
                                                                                                    *   const tags = config?.tags;
                                                                                                    * }
                                                                                                    * ```
                                                                                                    */ 
const $350692d982fcc44a$export$8f887a582517d0da = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useRovoSkillsConfig() {
    return (0, $cozmU.useContext)($350692d982fcc44a$var$RovoSkillsConfigContext);
} : function useRovoSkillsConfig() {
    return (0, $cozmU.useContext)($350692d982fcc44a$var$RovoSkillsConfigContext);
};
const $350692d982fcc44a$export$4347872345a66163 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useRovoSkillsInvalidation() {
    return (0, $cozmU.useContext)($350692d982fcc44a$var$RovoSkillsInvalidationContext);
} : function useRovoSkillsInvalidation() {
    return (0, $cozmU.useContext)($350692d982fcc44a$var$RovoSkillsInvalidationContext);
};
const $350692d982fcc44a$export$4967709cc8a6f044 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoSkillsConfigProvider(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { config: config, children: children } = t0;
    const value = config;
    const [skillsRevision, setSkillsRevision] = (0, $cozmU.useState)(0);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            (0, $aJNFh.clearSkillsCache)();
            (0, $cozmU.startTransition)(()=>{
                setSkillsRevision($350692d982fcc44a$var$_temp);
            });
        };
        $[0] = t1;
    } else t1 = $[0];
    const invalidateSkillLibrary = t1;
    let t2;
    if ($[1] !== skillsRevision) {
        t2 = {
            skillsRevision: skillsRevision,
            invalidateSkillLibrary: invalidateSkillLibrary
        };
        $[1] = skillsRevision;
        $[2] = t2;
    } else t2 = $[2];
    const invalidationValue = t2;
    let t3;
    if ($[3] !== children || $[4] !== invalidationValue) {
        t3 = /*#__PURE__*/ $cozmU.createElement($350692d982fcc44a$var$RovoSkillsInvalidationContext.Provider, {
            value: invalidationValue
        }, children);
        $[3] = children;
        $[4] = invalidationValue;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== t3 || $[7] !== value) {
        t4 = /*#__PURE__*/ $cozmU.createElement($350692d982fcc44a$var$RovoSkillsConfigContext.Provider, {
            value: value
        }, t3);
        $[6] = t3;
        $[7] = value;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : function RovoSkillsConfigProvider({ config: config, children: children }) {
    const value = (0, $cozmU.useMemo)(()=>config, [
        config
    ]);
    const [skillsRevision, setSkillsRevision] = (0, $cozmU.useState)(0);
    const invalidateSkillLibrary = (0, $cozmU.useCallback)(()=>{
        (0, $aJNFh.clearSkillsCache)();
        (0, $cozmU.startTransition)(()=>{
            setSkillsRevision((revision)=>revision + 1);
        });
    }, []);
    const invalidationValue = (0, $cozmU.useMemo)(()=>({
            skillsRevision: skillsRevision,
            invalidateSkillLibrary: invalidateSkillLibrary
        }), [
        invalidateSkillLibrary,
        skillsRevision
    ]);
    return /*#__PURE__*/ $cozmU.createElement($350692d982fcc44a$var$RovoSkillsConfigContext.Provider, {
        value: value
    }, /*#__PURE__*/ $cozmU.createElement($350692d982fcc44a$var$RovoSkillsInvalidationContext.Provider, {
        value: invalidationValue
    }, children));
};
function $350692d982fcc44a$var$_temp(revision) {
    return revision + 1;
}
module.exports["useRovoSkillsConfig"] = $350692d982fcc44a$export$8f887a582517d0da;
module.exports["useRovoSkillsInvalidation"] = $350692d982fcc44a$export$4347872345a66163;
module.exports["RovoSkillsConfigProvider"] = $350692d982fcc44a$export$4967709cc8a6f044;

});

parcelRegister("aJNFh", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $f6VI9 = parcelRequire("f6VI9");

const $71f78acdff7635c4$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
/**
 * Legacy GraphQL query — graphIntegration_componentDirectoryItems.
 * Returns user-facing descriptions (not AI model instructions).
 * Used when rovo_chat_unified_skills_agg is OFF.
 */ const $71f78acdff7635c4$var$LEGACY_SKILLS_QUERY = `
  query GraphIntegrationItemsQuery(
    $first: Int
    $cloudId: ID!
    $surface: GraphIntegrationSurface
    $relevantFor: [GraphIntegrationDirectoryItemType!]
  ) {
    graphIntegration_componentDirectoryItems(
      first: $first
      cloudId: $cloudId
      surface: $surface
      relevantFor: $relevantFor
    )
    @optIn(to: "GraphIntegrationItemsQuery")
    {
      edges {
        node {
          __typename
          ... on GraphIntegrationSkillDirectoryItem {
            id
            slashCommand
            name
            description
            iconUrl
            integrationKey {
              displayName
              iconUrl
            }
            color
            tags {
              displayName
            }
          }
        }
      }
    }
  }
`;
/**
 * New unified GraphQL query — convoai_availableSkills.
 * Used when rovo_chat_unified_skills_agg is ON.
 */ const $71f78acdff7635c4$var$UNIFIED_SKILLS_QUERY = `
  query ConvoAiAvailableSkillsQuery(
    $first: Int
    $cloudId: ID!
  ) {
    convoai_availableSkills(
      first: $first
      cloudId: $cloudId
    )
    @optIn(to: "ConvoAiAvailableSkills")
    {
      edges {
        node {
          __typename
          ... on ConvoAiSkill {
            id
            name
            description
            displayName
            slashCommand
						helpText
            iconUrl
            iconKey
            color
            source
            tags
            category
            integrationKeys
          }
        }
      }
      errors {
        message
      }
    }
  }
`;
/**
 * Session-level cache for fetched skills.
 * Keyed by `${cloudId}:${graphqlEndpoint}:${useUnified}` to avoid redundant network requests.
 * Skills are cached for the lifetime of the page (matching Relay store behavior).
 * A page refresh will fetch fresh data.
 */ const $71f78acdff7635c4$var$skillsCache = new Map();
function $71f78acdff7635c4$export$e6cf70cf6554c856() {
    $71f78acdff7635c4$var$skillsCache.clear();
}
/**
 * Fetch skills using the new unified convoai_availableSkills endpoint.
 */ async function $71f78acdff7635c4$var$fetchSkillsUnified(cloudId) {
    const response = await fetch($71f78acdff7635c4$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({
            query: $71f78acdff7635c4$var$UNIFIED_SKILLS_QUERY,
            variables: {
                cloudId: cloudId,
                first: 150
            }
        })
    });
    if (!response.ok) return [];
    const json = await response.json();
    if (json.errors?.length || json.data?.convoai_availableSkills?.errors?.length) return [];
    const edges = json.data?.convoai_availableSkills?.edges;
    return (0, $f6VI9.parseConvoAiSkillEdges)(edges);
}
/**
 * Fetch skills using the legacy graphIntegration_componentDirectoryItems endpoint.
 */ async function $71f78acdff7635c4$var$fetchSkillsLegacy(cloudId) {
    const response = await fetch($71f78acdff7635c4$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({
            query: $71f78acdff7635c4$var$LEGACY_SKILLS_QUERY,
            variables: {
                cloudId: cloudId,
                first: 100,
                surface: 'ROVO',
                relevantFor: [
                    'SKILL'
                ]
            }
        })
    });
    if (!response.ok) return [];
    const json = await response.json();
    if (json.errors?.length) return [];
    const edges = json.data?.graphIntegration_componentDirectoryItems?.edges;
    return (0, $f6VI9.parseSkillEdges)(edges);
}
async function $71f78acdff7635c4$export$268d57ae88e7df66(cloudId) {
    const useUnified = (0, $ixfCV.fg)('rovo_chat_unified_skills_agg');
    const cacheKey = `${cloudId}:${useUnified}`;
    const cached = $71f78acdff7635c4$var$skillsCache.get(cacheKey);
    if (cached) return cached;
    try {
        const skills = useUnified ? await $71f78acdff7635c4$var$fetchSkillsUnified(cloudId) : await $71f78acdff7635c4$var$fetchSkillsLegacy(cloudId);
        $71f78acdff7635c4$var$skillsCache.set(cacheKey, skills);
        return skills;
    } catch  {
        // Silently fail — the insert menu will just not show skills
        return [];
    }
}
module.exports["clearSkillsCache"] = $71f78acdff7635c4$export$e6cf70cf6554c856;
module.exports["fetchSkills"] = $71f78acdff7635c4$export$268d57ae88e7df66;

});

parcelRegister("6iWVH", function(module, exports) {
var $b76a5cfcb2493fac$export$87497e63e164f4b3 = /*#__PURE__*/ function(HandleActionType) {
    HandleActionType["Base"] = "Base";
    HandleActionType["Chat"] = "Chat";
    HandleActionType["Nested"] = "Nested";
    HandleActionType["Skill"] = "Skill";
    return HandleActionType;
}({});
const $b76a5cfcb2493fac$export$c91e07269f22915a = new Set([
    'invite-users',
    'grant-app-access',
    'troubleshoot-invitation-errors',
    'troubleshoot-user-access',
    'troubleshoot-user-provisioning',
    'troubleshoot-single-sign-on',
    'review-api-security',
    'policy-assist'
]);
var $b76a5cfcb2493fac$export$7f7a6f1c2ab5127 = /*#__PURE__*/ function(PageContextType) {
    PageContextType["ADMIN_HUB"] = "admin-hub";
    PageContextType["BITBUCKET"] = "bitbucket";
    PageContextType["BITBUCKET_PULL_REQUEST"] = "bitbucket-pull-request";
    PageContextType["BITBUCKET_CREATE_PULL_REQUEST"] = "bitbucket-create-pull-request";
    PageContextType["BITBUCKET_PIPELINES"] = "bitbucket-pipelines";
    PageContextType["BITBUCKET_REPOSITORY_SOURCE"] = "bitbucket-repository-source";
    PageContextType["CONFLUENCE_HOME"] = "confluence-home";
    PageContextType["CONFLUENCE_PAGE_VIEW"] = "confluence-page-view";
    PageContextType["CONFLUENCE_PAGE_EDIT"] = "confluence-page-edit";
    PageContextType["CONFLUENCE_BLOG_VIEW"] = "confluence-blog-view";
    PageContextType["CONFLUENCE_BLOG_EDIT"] = "confluence-blog-edit";
    PageContextType["CONFLUENCE_WHITEBOARD"] = "confluence-whiteboard";
    PageContextType["JIRA_HOME"] = "jira-home";
    PageContextType["JIRA_FOR_YOU"] = "jira-for-you";
    PageContextType["JIRA_ISSUE_VIEW"] = "jira-issue-view";
    PageContextType["JIRA_PROJECT"] = "jira-project";
    PageContextType["JIRA_BOARD"] = "jira-board";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PEOPLE_LEGACY"] = "jira-cmp-space-settings-people-legacy";
    PageContextType["JIRA_CMP_SPACE_SETTINGS_PERMISSIONS_LEGACY"] = "jira-cmp-space-settings-permissions-legacy";
    PageContextType["JIRA_TMP_SPACE_SETTINGS_ACCESS"] = "jira-tmp-space-settings-access";
    PageContextType["JSM_INCIDENT_VIEW"] = "jsm-incident-view";
    PageContextType["JSM_INCIDENT_LIST_VIEW"] = "jsm-incident-list-view";
    PageContextType["JSM_ALERT_VIEW"] = "jsm-alert-view";
    PageContextType["JSM_ALERT_LIST_VIEW"] = "jsm-alert-list-view";
    PageContextType["JSM_ALERT_GROUP_DETAIL_VIEW"] = "jsm-alert-group-detail-view";
    PageContextType["ATLAS_HOME"] = "atlas-home";
    PageContextType["ATLAS_HOME_MAIN"] = "atlas-home-main";
    PageContextType["ATLAS_HOME_DISCOVER"] = "atlas-home-discover";
    PageContextType["ATLAS_HOME_RECENTS"] = "atlas-home-recents";
    PageContextType["ATLAS_HOME_FULL_PAGE_NOTIFICATIONS"] = "atlas-home-full-page-notifications";
    PageContextType["ATLAS_HOME_PROJECT_UPDATES_LIST"] = "atlas-home-project-updates-list";
    PageContextType["ATLAS_HOME_GOAL_UPDATES_LIST"] = "atlas-home-goal-updates-list";
    PageContextType["ATLAS_HOME_TEAM_UPDATES_LIST"] = "atlas-home-team-updates-list";
    PageContextType["ATLAS_HOME_TAG_UPDATES_LIST"] = "atlas-home-tag-updates-list";
    PageContextType["FOCUS"] = "focus";
    PageContextType["FOCUS_FOR_YOU"] = "focus-for-you";
    PageContextType["FOCUS_FOCUS_AREA_PAGE"] = "focus-focus-area-page";
    PageContextType["FOCUS_FOCUS_AREA_GOAL_VIEW"] = "focus-focus-area-goal-view";
    PageContextType["FOCUS_FOCUS_AREA_WORK_VIEW"] = "focus-focus-area-work-view";
    PageContextType["FOCUS_FOCUS_AREA_FUNDS_VIEW"] = "focus-focus-area-funds-view";
    PageContextType["SAC"] = "sac";
    PageContextType["TRELLO_BOARD"] = "trello-board";
    PageContextType["TRELLO_CARD"] = "trello-card";
    PageContextType["UNKNOWN"] = "unknown";
    return PageContextType;
}({});
const $b76a5cfcb2493fac$export$4f757e7d9540e8f9 = 'prompt-of-day';
module.exports["HandleActionType"] = $b76a5cfcb2493fac$export$87497e63e164f4b3;
module.exports["LEGACY_DYNAMIC_SKILL_IDS"] = $b76a5cfcb2493fac$export$c91e07269f22915a;
module.exports["PageContextType"] = $b76a5cfcb2493fac$export$7f7a6f1c2ab5127;
module.exports["PROMPT_OF_DAY_ACTION_ID"] = $b76a5cfcb2493fac$export$4f757e7d9540e8f9;

});

parcelRegister("aIn0d", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $i1t43 = parcelRequire("i1t43");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $10I6z = parcelRequire("10I6z");

const $5f85a79aee555eb3$var$AI_DISCLAIMER_LINK = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $5f85a79aee555eb3$var$styles = {
    text: "_4bfu1r31 _1hmsglyw _ajmmnqa1"
};
const $5f85a79aee555eb3$export$e0542ba0c737fe5c = ({ onLinkClick: onLinkClick, withLink: withLink = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const disclaimerContent = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $10I6z.i18n).disclaimerMessage));
    if (withLink) return /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
        appearance: "subtle",
        href: $5f85a79aee555eb3$var$AI_DISCLAIMER_LINK,
        target: "_blank",
        onClick: onLinkClick
    }, disclaimerContent);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($5f85a79aee555eb3$var$styles.text)
    }, disclaimerContent);
};
module.exports["AIDisclaimer"] = $5f85a79aee555eb3$export$e0542ba0c737fe5c;

});

parcelRegister("10I6z", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $1ae8fb340800d3e1$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    disclaimerMessage: {
        id: "ai-disclaimer.disclaimerMessage",
        defaultMessage: "Uses AI. Verify results."
    }
});
module.exports["i18n"] = $1ae8fb340800d3e1$export$a7357cdd1f0b0168;

});

parcelRegister("4pKRH", function(module, exports) {

var $lJ6db = parcelRequire("lJ6db");

const $f2bc8c41368b5e1f$var$CHANNEL_ID_HEADER = 'X-Channel-Id';
const $f2bc8c41368b5e1f$var$PRODUCT_HEADER = 'x-product';
const $f2bc8c41368b5e1f$var$EXPERIENCE_ID_HEADER = 'x-experience-id';
class $f2bc8c41368b5e1f$export$2687a6d505a87cc5 extends (0, $lJ6db.AssistanceServiceBase) {
    /**
   * Check whether Rovo Insights is available for the current user.
   */ async getInsightsStatus() {
        return this.fetchJson({
            path: '/rovo/v1/insights/status',
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'Content-Type': 'application/json;charset=UTF-8',
                    [$f2bc8c41368b5e1f$var$CHANNEL_ID_HEADER]: 'rovo-chat',
                    [$f2bc8c41368b5e1f$var$PRODUCT_HEADER]: 'rovo',
                    [$f2bc8c41368b5e1f$var$EXPERIENCE_ID_HEADER]: 'rovo-insights'
                }),
                body: JSON.stringify({})
            },
            holdName: 'rovo-v1-insights-status'
        });
    }
    /**
   * Fetch the Rovo Insights feed for the current user.
   * @param options.debugInfo — When true, include debug_info in the response.
   */ async getInsightsFeed(options) {
        const overrides = {};
        if (options?.debugInfo) overrides.debug_info = true;
        if (typeof localStorage !== 'undefined') {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const promptVariation = localStorage.getItem('DEBUG_rovo_insights_prompt_variation');
            if (promptVariation) overrides.prompt_variation = promptVariation;
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const generate = localStorage.getItem('DEBUG_rovo_insights_generate');
            if (generate) overrides.generate = generate === 'true';
        }
        return this.fetchJson({
            path: '/rovo/v1/insights/fetch',
            options: {
                method: 'POST',
                headers: this.createHeaders({
                    'Content-Type': 'application/json;charset=UTF-8',
                    [$f2bc8c41368b5e1f$var$CHANNEL_ID_HEADER]: 'rovo-chat',
                    [$f2bc8c41368b5e1f$var$PRODUCT_HEADER]: 'rovo',
                    [$f2bc8c41368b5e1f$var$EXPERIENCE_ID_HEADER]: 'rovo-insights'
                }),
                body: JSON.stringify(overrides)
            },
            holdName: 'rovo-v1-insights-fetch'
        });
    }
    constructor(config){
        super(config);
    }
}
module.exports["RovoInsightsService"] = $f2bc8c41368b5e1f$export$2687a6d505a87cc5;

});

parcelRegister("fuSOM", function(module, exports) {
parcelRequire("eRn3r");
var $9aUDG = parcelRequire("9aUDG");


var $lA6N5 = parcelRequire("lA6N5");


const $cb5189150b488f78$var$LazyLinkPickerComponent = (0, $9aUDG.lazyForPaint)(()=>(parcelRequire("8Phsn")).then(({ LinkPicker: LinkPicker })=>({
            default: LinkPicker
        })));
// Must be a default export to be able to support prop docs
// eslint-disable-next-line import/no-default-export
const $cb5189150b488f78$var$_default_1 = (0, $lA6N5.composeLinkPicker)($cb5189150b488f78$var$LazyLinkPickerComponent);
var $cb5189150b488f78$export$2e2bcd8739ae039 = $cb5189150b488f78$var$_default_1;
module.exports["default"] = $cb5189150b488f78$export$2e2bcd8739ae039;

});

parcelRegister("lA6N5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

parcelRequire("eRn3r");
var $3QYdZ = parcelRequire("3QYdZ");


var $gBjHb = parcelRequire("gBjHb");


var $kJo8F = parcelRequire("kJo8F");


var $eg7eG = parcelRequire("eg7eG");


var $fCO8c = parcelRequire("fCO8c");


var $k5YvC = parcelRequire("k5YvC");


var $lg1Gp = parcelRequire("lg1Gp");

const $12f35d08bde2472f$export$800daf5fbbe96aff = {
    linkPickerRoot: 'link-picker-root'
};
const $12f35d08bde2472f$export$a2495bb1f182689d = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: (0, $kJo8F.COMPONENT_NAME),
    source: (0, $kJo8F.COMPONENT_NAME)
};
const $12f35d08bde2472f$var$DefaultRootComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": $12f35d08bde2472f$export$800daf5fbbe96aff.linkPickerRoot
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": $12f35d08bde2472f$export$800daf5fbbe96aff.linkPickerRoot
    }, children);
};
const $12f35d08bde2472f$var$fixedWidthContainerStyles = null;
const $12f35d08bde2472f$var$FixedWidthContainer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_1bsb1ubl"
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            role: "dialog",
            "aria-modal": "false",
            "aria-label": "link-picker",
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "dialog",
        "aria-modal": "false",
        "aria-label": "link-picker",
        ...props,
        className: (0, $hekY6.default)([
            "_1bsb1ubl"
        ])
    });
};
const $12f35d08bde2472f$export$922eb685ceb4a294 = (Component)=>{
    return /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
        const { component: component } = props;
        const RootComponent = component ?? $12f35d08bde2472f$var$DefaultRootComponent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
            data: $12f35d08bde2472f$export$a2495bb1f182689d
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eg7eG.LinkPickerSessionProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lg1Gp.MessagesProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                ['--link-picker-width']: props.disableWidth ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                `${0, $kJo8F.LINK_PICKER_WIDTH_IN_PX}px`,
                ['--link-picker-padding-left']: props.paddingLeft ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-right']: props.paddingRight ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-top']: props.paddingTop ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-bottom']: props.paddingBottom ?? "var(--ds-space-200, 16px)"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($12f35d08bde2472f$var$FixedWidthContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fCO8c.ErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3QYdZ.LazySuspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k5YvC.LoaderFallback), {
                url: props.url,
                hideDisplayText: props.hideDisplayText,
                isLoadingPlugins: props.isLoadingPlugins,
                plugins: props.plugins
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RootComponent, {
            ...props,
            "data-testid": $12f35d08bde2472f$export$800daf5fbbe96aff.linkPickerRoot
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props)))))))));
    });
};
module.exports["composeLinkPicker"] = $12f35d08bde2472f$export$922eb685ceb4a294;

});

parcelRegister("kJo8F", function(module, exports) {
const $001c95c8c9eb30f1$export$85183a312807388d = 'media';
const $001c95c8c9eb30f1$export$fc44104665f4d1e5 = 'linkPicker';
const $001c95c8c9eb30f1$export$452f1062ecf44be7 = 5;
const $001c95c8c9eb30f1$export$bf31a09f182d5584 = 342;
const $001c95c8c9eb30f1$export$542fb16962bf430c = '290px';
module.exports["ANALYTICS_CHANNEL"] = $001c95c8c9eb30f1$export$85183a312807388d;
module.exports["COMPONENT_NAME"] = $001c95c8c9eb30f1$export$fc44104665f4d1e5;
module.exports["RECENT_SEARCH_LIST_SIZE"] = $001c95c8c9eb30f1$export$452f1062ecf44be7;
module.exports["LINK_PICKER_WIDTH_IN_PX"] = $001c95c8c9eb30f1$export$bf31a09f182d5584;
module.exports["LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK"] = $001c95c8c9eb30f1$export$542fb16962bf430c;

});

parcelRegister("eg7eG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $kHija = parcelRequire("kHija");


var $gt5Em = parcelRequire("gt5Em");

const $c7635a085ba363f5$export$c07727f5eddb98f = 'SESSION_UNINITIALIZED';
const $c7635a085ba363f5$export$3285420c698bc605 = /*#__PURE__*/ (0, $cozmU.createContext)($c7635a085ba363f5$export$c07727f5eddb98f);
const $c7635a085ba363f5$export$2f19832fd2d620ca = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const { current: sessionId } = (0, $cozmU.useRef)((0, $kHija.v4)());
    (0, $cozmU.useEffect)(()=>{
        (0, $gt5Em.startUfoExperience)((0, $gt5Em.ufoExperience).mounted, sessionId);
        return ()=>(0, $gt5Em.abortUfoExperience)((0, $gt5Em.ufoExperience).mounted, sessionId);
    }, [
        sessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c7635a085ba363f5$export$3285420c698bc605.Provider, {
        value: sessionId
    }, children);
};
const $c7635a085ba363f5$export$36ecc935abdc3636 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($c7635a085ba363f5$export$3285420c698bc605);
} : ()=>(0, $cozmU.useContext)($c7635a085ba363f5$export$3285420c698bc605);
module.exports["LinkPickerSessionProvider"] = $c7635a085ba363f5$export$2f19832fd2d620ca;
module.exports["useLinkPickerSessionId"] = $c7635a085ba363f5$export$36ecc935abdc3636;

});

parcelRegister("gt5Em", function(module, exports) {

var $fh15z = parcelRequire("fh15z");

var $4MiWC = parcelRequire("4MiWC");

const $64cb77453c568c86$export$f9c7780c574346a2 = {
    mounted: 'component-mounted'
};
const $64cb77453c568c86$var$ufoExperiences = {
    [$64cb77453c568c86$export$f9c7780c574346a2.mounted]: new (0, $fh15z.ConcurrentExperience)($64cb77453c568c86$export$f9c7780c574346a2.mounted, {
        type: (0, $4MiWC.ExperienceTypes).Load,
        performanceType: (0, $4MiWC.ExperiencePerformanceTypes).PageSegmentLoad,
        platform: {
            component: 'link-picker'
        }
    })
};
const $64cb77453c568c86$export$5e9287b6a10f8075 = (experienceName, id, metadata)=>{
    const experience = $64cb77453c568c86$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (metadata) experience.addMetadata(metadata);
};
const $64cb77453c568c86$export$c5a5cf072c836c0e = (experienceName, id, metadata)=>{
    const experience = $64cb77453c568c86$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: metadata
    });
};
const $64cb77453c568c86$export$8dda83bafca11b77 = (experienceName, id, metadata)=>{
    const experience = $64cb77453c568c86$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: metadata
    });
};
const $64cb77453c568c86$export$b1021040eb94cdca = (experienceName, id, metadata)=>{
    const experience = $64cb77453c568c86$var$ufoExperiences[experienceName].getInstance(id);
    experience.abort({
        metadata: metadata
    });
};
module.exports["ufoExperience"] = $64cb77453c568c86$export$f9c7780c574346a2;
module.exports["startUfoExperience"] = $64cb77453c568c86$export$5e9287b6a10f8075;
module.exports["succeedUfoExperience"] = $64cb77453c568c86$export$c5a5cf072c836c0e;
module.exports["failUfoExperience"] = $64cb77453c568c86$export$8dda83bafca11b77;
module.exports["abortUfoExperience"] = $64cb77453c568c86$export$b1021040eb94cdca;

});

parcelRegister("fCO8c", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $gt5Em = parcelRequire("gt5Em");


var $kJo8F = parcelRequire("kJo8F");


var $779pE = parcelRequire("779pE");


var $eg7eG = parcelRequire("eg7eG");


var $aRBFH = parcelRequire("aRBFH");


var $f3GZb = parcelRequire("f3GZb");

const $96adf85769963d68$export$e926676385687eaf = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ErrorBoundary(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { children: children } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $eg7eG.useLinkPickerSessionId)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== linkPickerSessionId) {
        t1 = (error, info)=>{
            createAnalyticsEvent((0, $779pE.default)("ui.linkPicker.unhandledErrorCaught", {
                browserInfo: window?.navigator?.userAgent || "unknown",
                error: error.toString(),
                componentStack: info?.componentStack ?? ""
            })).fire((0, $kJo8F.ANALYTICS_CHANNEL));
            (0, $gt5Em.failUfoExperience)((0, $gt5Em.ufoExperience).mounted, linkPickerSessionId);
        };
        $[0] = createAnalyticsEvent;
        $[1] = linkPickerSessionId;
        $[2] = t1;
    } else t1 = $[2];
    const handleError = t1;
    let t2;
    if ($[3] !== children || $[4] !== handleError) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRBFH.BaseErrorBoundary), {
            onError: handleError,
            ErrorComponent: (0, $f3GZb.ErrorBoundaryFallback)
        }, children);
        $[3] = children;
        $[4] = handleError;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : function ErrorBoundary({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $eg7eG.useLinkPickerSessionId)();
    const handleError = (0, $cozmU.useCallback)((error, info)=>{
        // Fire Analytics event
        createAnalyticsEvent((0, $779pE.default)('ui.linkPicker.unhandledErrorCaught', {
            browserInfo: window?.navigator?.userAgent || 'unknown',
            error: error.toString(),
            componentStack: info?.componentStack ?? ''
        })).fire((0, $kJo8F.ANALYTICS_CHANNEL));
        // Fire UFO failed experience
        (0, $gt5Em.failUfoExperience)((0, $gt5Em.ufoExperience).mounted, linkPickerSessionId);
    }, [
        createAnalyticsEvent,
        linkPickerSessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRBFH.BaseErrorBoundary), {
        onError: handleError,
        ErrorComponent: (0, $f3GZb.ErrorBoundaryFallback)
    }, children);
};
module.exports["ErrorBoundary"] = $96adf85769963d68$export$e926676385687eaf;

});

parcelRegister("779pE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::590b9da528f0d0b88cea1feaa1815283>>
 * @codegenCommand yarn workspace @atlaskit/link-picker run codegen-analytics
 */ function $eafc2c5357085519$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $eafc2c5357085519$export$2e2bcd8739ae039 = $eafc2c5357085519$var$createEventPayload;
module.exports["default"] = $eafc2c5357085519$export$2e2bcd8739ae039;

});

parcelRegister("aRBFH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

class $baa71a56a1d588bd$export$688779ac61ee945f extends (0, $cozmU.Component) {
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && ErrorComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ErrorComponent, null);
        return children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
module.exports["BaseErrorBoundary"] = $baa71a56a1d588bd$export$688779ac61ee945f;

});

parcelRegister("f3GZb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $kJo8F = parcelRequire("kJo8F");


var $bXDzR = parcelRequire("bXDzR");


var $k3ncb = parcelRequire("k3ncb");


var $dOXsL = parcelRequire("dOXsL");

const $66e5302c045c6e9e$var$errorBoundaryFallbackStyles = null;
const $66e5302c045c6e9e$var$messages = (0, $kSwu1.defineMessages)({
    heading: {
        defaultMessage: "Something went wrong!",
        id: "fabric.linkPicker.unhandledError.heading"
    },
    description: {
        defaultMessage: "Try reloading the page.",
        id: "fabric.linkPicker.unhandledError.description"
    }
});
const $66e5302c045c6e9e$export$8a28b7e38e4685dd = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(8);
    const intl = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage($66e5302c045c6e9e$var$messages.heading);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    const header = t0;
    let t1;
    if ($[2] !== intl) {
        t1 = intl.formatMessage($66e5302c045c6e9e$var$messages.description);
        $[2] = intl;
        $[3] = t1;
    } else t1 = $[3];
    const description = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_11c8i4vh"
        ]);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== description || $[6] !== header) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
            minHeight: (0, $kJo8F.LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK),
            "data-testid": "link-picker-root-error-boundary-ui",
            className: t2
        }, /*#__PURE__*/ $cozmU.createElement((0, $k3ncb.EmptyState), {
            header: header,
            renderImage: $66e5302c045c6e9e$var$_temp,
            description: description
        }));
        $[5] = description;
        $[6] = header;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ()=>{
    const intl = (0, $kSwu1.useIntl)();
    const header = intl.formatMessage($66e5302c045c6e9e$var$messages.heading);
    const description = intl.formatMessage($66e5302c045c6e9e$var$messages.description);
    return /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
        minHeight: (0, $kJo8F.LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK),
        "data-testid": "link-picker-root-error-boundary-ui",
        className: (0, $hekY6.default)([
            "_11c8i4vh"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $k3ncb.EmptyState), {
        header: header,
        renderImage: ()=>/*#__PURE__*/ $cozmU.createElement((0, $bXDzR.GenericErrorSVG), null),
        description: description
    }));
};
function $66e5302c045c6e9e$var$_temp() {
    return /*#__PURE__*/ $cozmU.createElement((0, $bXDzR.GenericErrorSVG), null);
}
module.exports["ErrorBoundaryFallback"] = $66e5302c045c6e9e$export$8a28b7e38e4685dd;

});

parcelRegister("bXDzR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $efcb4a3aca6e9417$var$SIZE = 96;
const $efcb4a3aca6e9417$var$genericErrorStyles = null;
const $efcb4a3aca6e9417$export$e54420a1a27457a4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(10);
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_1bsb16xz _4t3i16xz _1e0c1ule"
        ]);
        t1 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#fff",
            d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
        });
        t2 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
        });
        t3 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
        });
        t4 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
        });
        t5 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#B7B9BE",
            d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
        });
        t6 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            fillRule: "evenodd",
            d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
            clipRule: "evenodd"
        });
        t7 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            fillRule: "evenodd",
            d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
            clipRule: "evenodd"
        });
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
        $[6] = t6;
        $[7] = t7;
    } else {
        t0 = $[0];
        t1 = $[1];
        t2 = $[2];
        t3 = $[3];
        t4 = $[4];
        t5 = $[5];
        t6 = $[6];
        t7 = $[7];
    }
    let t8;
    if ($[8] !== props) {
        t8 = /*#__PURE__*/ $cozmU.createElement("svg", {
            viewBox: "0 0 96 96",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            className: t0
        }, t1, t2, t3, t4, t5, t6, t7);
        $[8] = props;
        $[9] = t8;
    } else t8 = $[9];
    return t8;
} : (props)=>{
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        className: (0, $hekY6.default)([
            "_1bsb16xz _4t3i16xz _1e0c1ule"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#fff",
        d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#B7B9BE",
        d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        fillRule: "evenodd",
        d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        fillRule: "evenodd",
        d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
        clipRule: "evenodd"
    }));
};
module.exports["GenericErrorSVG"] = $efcb4a3aca6e9417$export$e54420a1a27457a4;

});

parcelRegister("k3ncb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $I7hWB = parcelRequire("I7hWB");


var $4ez2K = parcelRequire("4ez2K");

var $4aRua = parcelRequire("4aRua");

const $abc7c062eda24665$var$styles = {
    containerV2: "_ca0q1ejb _u5f3oahv _19bvoahv _n3td1jfw _y3gn1h6o"
};
const $abc7c062eda24665$export$fddf379e22a74b00 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { testId: testId, header: header, description: description, action: action, renderImage: renderImage } = t0;
    let t1;
    if ($[0] !== renderImage) {
        t1 = renderImage?.();
        $[0] = renderImage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== header) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: "small",
            as: "h2"
        }, header);
        $[2] = header;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== description) {
        t3 = description && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
            as: "p",
            color: "color.text"
        }, description);
        $[4] = description;
        $[5] = t3;
    } else t3 = $[5];
    const t4 = action && action;
    let t5;
    if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== testId) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.default), {
            xcss: $abc7c062eda24665$var$styles.containerV2,
            testId: testId,
            direction: "column",
            alignItems: "center",
            gap: "space.200"
        }, t1, t2, t3, t4);
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = testId;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ testId: testId, header: header, description: description, action: action, renderImage: renderImage })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.default), {
        xcss: $abc7c062eda24665$var$styles.containerV2,
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.200"
    }, renderImage?.(), /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "small",
        as: "h2"
    }, header), description && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
        as: "p",
        color: "color.text"
    }, description), action && action);
};
module.exports["EmptyState"] = $abc7c062eda24665$export$fddf379e22a74b00;

});

parcelRegister("dOXsL", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $1bc658963d2888d5$var$minHeightComponentStyles = null;
const $1bc658963d2888d5$export$42134e2a251518b3 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ className: className, minHeight: minHeight, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref,
        className: (0, $hekY6.default)([
            "_1e0c1txw _4cvr1fhb _1bah1h6o _1tke16li",
            className
        ]),
        ...props,
        style: {
            ['--link-picker-min-height']: minHeight
        }
    });
});
module.exports["MinHeightContainer"] = $1bc658963d2888d5$export$42134e2a251518b3;

});

parcelRegister("k5YvC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lfoFx = parcelRequire("lfoFx");


var $dOXsL = parcelRequire("dOXsL");

const $9e6da8c9bb613998$var$styles = null;
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT = '495px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT = '590px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT = '545px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT = '450px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT = '252px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT = '155px';
const $9e6da8c9bb613998$var$getEstimatedMinHeight = ({ hideDisplayText: hideDisplayText, isLoadingPlugins: isLoadingPlugins, plugins: plugins, url: url })=>{
    /**
   * "Insert mode" (search results shown initially)
   */ if (!url) {
        /**
     * With tabs
     */ if (plugins && plugins.length > 1 || isLoadingPlugins) return hideDisplayText ? $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT : $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT;
         /**
       * Without tabs
       */ 
        if (plugins?.length === 1) return hideDisplayText ? $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT : $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT;
    }
    return hideDisplayText ? $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT : $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT;
};
const $9e6da8c9bb613998$export$d96e921133238c41 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(8);
    let t0;
    if ($[0] !== props) {
        t0 = $9e6da8c9bb613998$var$getEstimatedMinHeight(props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    const minHeight = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_4cvr1h6o"
        ]);
        $[2] = t1;
    } else t1 = $[2];
    const t2 = props.name || "link-picker-loading";
    let t3;
    if ($[3] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
            testId: "link-picker.component-loading-indicator",
            interactionName: t2,
            size: "medium"
        });
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== minHeight || $[6] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
            minHeight: minHeight,
            "data-testid": "link-picker-root-loader-boundary-ui",
            className: t1
        }, t3);
        $[5] = minHeight;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : (props)=>{
    const minHeight = $9e6da8c9bb613998$var$getEstimatedMinHeight(props);
    return /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
        minHeight: minHeight,
        "data-testid": "link-picker-root-loader-boundary-ui",
        className: (0, $hekY6.default)([
            "_4cvr1h6o"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        testId: "link-picker.component-loading-indicator",
        interactionName: props.name || 'link-picker-loading',
        size: "medium"
    }));
};
module.exports["LoaderFallback"] = $9e6da8c9bb613998$export$d96e921133238c41;

});

parcelRegister("lg1Gp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $Vh5j9 = parcelRequire("Vh5j9");

const $f169ae6f19f5b49d$export$54320b51a950d54a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Vh5j9.LazyMessagesProvider), null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Vh5j9.LazyMessagesProvider), null, children);
};
module.exports["MessagesProvider"] = $f169ae6f19f5b49d$export$54320b51a950d54a;

});

parcelRegister("Vh5j9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $64VTj = parcelRequire("64VTj");


var $935R1 = parcelRequire("935R1");


var $2H5my = parcelRequire("2H5my");

const $550b5e1058020e28$export$d013d33430f9fb4b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $64VTj.default), {
            defaultMessages: (0, $935R1.default),
            loaderFn: (0, $2H5my.fetchMessagesForLocale)
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $64VTj.default), {
        defaultMessages: (0, $935R1.default),
        loaderFn: (0, $2H5my.fetchMessagesForLocale)
    }, children);
};
module.exports["LazyMessagesProvider"] = $550b5e1058020e28$export$d013d33430f9fb4b;

});

parcelRegister("2H5my", function(module, exports) {

var $b3upr = parcelRequire("b3upr");

const $d0c1d8c70ea117ba$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const localeKey = locale.replace('-', '_');
        if (localeKey in (0, $b3upr.locales)) {
            const messages = await (0, $b3upr.locales)[localeKey]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $b3upr.locales)) {
            const messages = await (0, $b3upr.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
};
module.exports["fetchMessagesForLocale"] = $d0c1d8c70ea117ba$export$2b153a2030b0feb2;

});

parcelRegister("b3upr", function(module, exports) {

























const $f5a6a4ca12953b28$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("dT096")),
    da: ()=>(parcelRequire("2P2sJ")),
    de: ()=>(parcelRequire("glb5m")),
    en_GB: ()=>(parcelRequire("1owFt")),
    en_ZZ: ()=>(parcelRequire("43PMH")),
    en: ()=>Promise.resolve((parcelRequire("935R1"))),
    es: ()=>(parcelRequire("hGEXH")),
    fi: ()=>(parcelRequire("3GUzN")),
    fr: ()=>(parcelRequire("2GqjB")),
    hu: ()=>(parcelRequire("nq1eZ")),
    it: ()=>(parcelRequire("i2ycc")),
    ja: ()=>(parcelRequire("5fClp")),
    ko: ()=>(parcelRequire("cb3oT")),
    nb: ()=>(parcelRequire("VbcI7")),
    nl: ()=>(parcelRequire("3PMwD")),
    pl: ()=>(parcelRequire("5jUF7")),
    pt_BR: ()=>(parcelRequire("4v22g")),
    ru: ()=>(parcelRequire("adodp")),
    sv: ()=>(parcelRequire("7wcjs")),
    th: ()=>(parcelRequire("5e2PY")),
    tr: ()=>(parcelRequire("11CPA")),
    uk: ()=>(parcelRequire("hRtvo")),
    vi: ()=>(parcelRequire("9PM3y")),
    zh_TW: ()=>(parcelRequire("29Ztf")),
    zh: ()=>(parcelRequire("dAeOf"))
};
module.exports["locales"] = $f5a6a4ca12953b28$export$df1c34db1371eeed;

});

parcelRegister("dT096", function(module, exports) {

let $029be122a3b04e2f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $029be122a3b04e2f$var$load("1JYrd"),
    $029be122a3b04e2f$var$load("cip6w"),
    $029be122a3b04e2f$var$load("3feYV"),
    $029be122a3b04e2f$var$load("gAG2n"),
    $029be122a3b04e2f$var$load("hFpP9"),
    $029be122a3b04e2f$var$load("cwjU2"),
    $029be122a3b04e2f$var$load("3Ff1R"),
    $029be122a3b04e2f$var$load("423Ga")
]).then(()=>parcelRequire('ksVtB'));

});

parcelRegister("2P2sJ", function(module, exports) {

let $20e24127880f8644$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $20e24127880f8644$var$load("30242"),
    $20e24127880f8644$var$load("3qBwQ"),
    $20e24127880f8644$var$load("7Q1SM"),
    $20e24127880f8644$var$load("cYGDU"),
    $20e24127880f8644$var$load("ddSTH"),
    $20e24127880f8644$var$load("33Iaa"),
    $20e24127880f8644$var$load("blA7x"),
    $20e24127880f8644$var$load("gJroP")
]).then(()=>parcelRequire('1VdaT'));

});

parcelRegister("glb5m", function(module, exports) {

let $be5734d35c09852c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $be5734d35c09852c$var$load("15aAJ"),
    $be5734d35c09852c$var$load("8rREG"),
    $be5734d35c09852c$var$load("7JdzX"),
    $be5734d35c09852c$var$load("dgXJL"),
    $be5734d35c09852c$var$load("9d8JZ"),
    $be5734d35c09852c$var$load("6681T"),
    $be5734d35c09852c$var$load("3dn3H"),
    $be5734d35c09852c$var$load("cYXvt")
]).then(()=>parcelRequire('h2ceo'));

});

parcelRegister("1owFt", function(module, exports) {

let $10415f84a3555b14$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $10415f84a3555b14$var$load("l5BBd"),
    $10415f84a3555b14$var$load("93ASN"),
    $10415f84a3555b14$var$load("24LNf"),
    $10415f84a3555b14$var$load("htu5t"),
    $10415f84a3555b14$var$load("1A450"),
    $10415f84a3555b14$var$load("iYQCc"),
    $10415f84a3555b14$var$load("nBJth")
]).then(()=>parcelRequire('6VGGT'));

});

parcelRegister("43PMH", function(module, exports) {

let $2f4f9c87cb3564a3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2f4f9c87cb3564a3$var$load("bbv9t"),
    $2f4f9c87cb3564a3$var$load("9fQoJ"),
    $2f4f9c87cb3564a3$var$load("cnlNg"),
    $2f4f9c87cb3564a3$var$load("lTboH"),
    $2f4f9c87cb3564a3$var$load("gBDXQ"),
    $2f4f9c87cb3564a3$var$load("d3Phe"),
    $2f4f9c87cb3564a3$var$load("lASLx"),
    $2f4f9c87cb3564a3$var$load("bIXgz")
]).then(()=>parcelRequire('glan9'));

});

parcelRegister("hGEXH", function(module, exports) {

let $ce062218aa215854$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ce062218aa215854$var$load("7p4je"),
    $ce062218aa215854$var$load("8SZbD"),
    $ce062218aa215854$var$load("9Uf61"),
    $ce062218aa215854$var$load("iE05k"),
    $ce062218aa215854$var$load("lv5aU"),
    $ce062218aa215854$var$load("3Yk1e"),
    $ce062218aa215854$var$load("5lJyy"),
    $ce062218aa215854$var$load("9w9df")
]).then(()=>parcelRequire('jIUdy'));

});

parcelRegister("3GUzN", function(module, exports) {

let $2b012e3f25fe3861$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2b012e3f25fe3861$var$load("1jQRQ"),
    $2b012e3f25fe3861$var$load("5pOQA"),
    $2b012e3f25fe3861$var$load("fJSEb"),
    $2b012e3f25fe3861$var$load("5GSny"),
    $2b012e3f25fe3861$var$load("cQump"),
    $2b012e3f25fe3861$var$load("ajzkj"),
    $2b012e3f25fe3861$var$load("eyysG"),
    $2b012e3f25fe3861$var$load("27gvR")
]).then(()=>parcelRequire('j6sWj'));

});

parcelRegister("2GqjB", function(module, exports) {

let $1f43eaae3d3fb0b0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1f43eaae3d3fb0b0$var$load("km37l"),
    $1f43eaae3d3fb0b0$var$load("gbksI"),
    $1f43eaae3d3fb0b0$var$load("9TeWr"),
    $1f43eaae3d3fb0b0$var$load("j2X7f"),
    $1f43eaae3d3fb0b0$var$load("fE8pi"),
    $1f43eaae3d3fb0b0$var$load("kUZ7k"),
    $1f43eaae3d3fb0b0$var$load("dJQL7"),
    $1f43eaae3d3fb0b0$var$load("czj6d")
]).then(()=>parcelRequire('6POS4'));

});

parcelRegister("nq1eZ", function(module, exports) {

let $046654ee53250fe6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $046654ee53250fe6$var$load("lTbXI"),
    $046654ee53250fe6$var$load("a98cw"),
    $046654ee53250fe6$var$load("fOGnR"),
    $046654ee53250fe6$var$load("e40mE"),
    $046654ee53250fe6$var$load("btBGI"),
    $046654ee53250fe6$var$load("cDQOq"),
    $046654ee53250fe6$var$load("8upye"),
    $046654ee53250fe6$var$load("GlmUM")
]).then(()=>parcelRequire('5BZIn'));

});

parcelRegister("i2ycc", function(module, exports) {

let $d222f07772d48585$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d222f07772d48585$var$load("iUyZj"),
    $d222f07772d48585$var$load("4PDaO"),
    $d222f07772d48585$var$load("8nEeY"),
    $d222f07772d48585$var$load("lMhbw"),
    $d222f07772d48585$var$load("amTTV"),
    $d222f07772d48585$var$load("kLZKK"),
    $d222f07772d48585$var$load("c7GMc"),
    $d222f07772d48585$var$load("bnhJ1")
]).then(()=>parcelRequire('dkwKE'));

});

parcelRegister("5fClp", function(module, exports) {

let $3d2c18d70682bf56$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3d2c18d70682bf56$var$load("kPlMQ"),
    $3d2c18d70682bf56$var$load("ervs7"),
    $3d2c18d70682bf56$var$load("fzzMQ"),
    $3d2c18d70682bf56$var$load("8CX31"),
    $3d2c18d70682bf56$var$load("kYd4i"),
    $3d2c18d70682bf56$var$load("33S6H"),
    $3d2c18d70682bf56$var$load("kFae4"),
    $3d2c18d70682bf56$var$load("iZWpE")
]).then(()=>parcelRequire('4VLhA'));

});

parcelRegister("cb3oT", function(module, exports) {

let $8dd9266225896019$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8dd9266225896019$var$load("iT2sv"),
    $8dd9266225896019$var$load("iMMtn"),
    $8dd9266225896019$var$load("3gNEO"),
    $8dd9266225896019$var$load("23VWs"),
    $8dd9266225896019$var$load("e1KaU"),
    $8dd9266225896019$var$load("93obY"),
    $8dd9266225896019$var$load("6Y9jE"),
    $8dd9266225896019$var$load("cUTaY")
]).then(()=>parcelRequire('gVcgA'));

});

parcelRegister("VbcI7", function(module, exports) {

let $0abe03de5f1993f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0abe03de5f1993f1$var$load("lyPpF"),
    $0abe03de5f1993f1$var$load("eX5n7"),
    $0abe03de5f1993f1$var$load("gvylW"),
    $0abe03de5f1993f1$var$load("aiYuN"),
    $0abe03de5f1993f1$var$load("gqMCT"),
    $0abe03de5f1993f1$var$load("bxfRe"),
    $0abe03de5f1993f1$var$load("ed6s8"),
    $0abe03de5f1993f1$var$load("lAuJd")
]).then(()=>parcelRequire('6B7wN'));

});

parcelRegister("3PMwD", function(module, exports) {

let $2cabc6a47d3e23a3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2cabc6a47d3e23a3$var$load("iN3cj"),
    $2cabc6a47d3e23a3$var$load("3nHdy"),
    $2cabc6a47d3e23a3$var$load("80OLx"),
    $2cabc6a47d3e23a3$var$load("gDEvm"),
    $2cabc6a47d3e23a3$var$load("5MwHB"),
    $2cabc6a47d3e23a3$var$load("1EVcg"),
    $2cabc6a47d3e23a3$var$load("96q1k"),
    $2cabc6a47d3e23a3$var$load("XQtfV")
]).then(()=>parcelRequire('6e51k'));

});

parcelRegister("5jUF7", function(module, exports) {

let $3dfaae0b91366a24$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3dfaae0b91366a24$var$load("eC1OL"),
    $3dfaae0b91366a24$var$load("ilL9c"),
    $3dfaae0b91366a24$var$load("e4s0V"),
    $3dfaae0b91366a24$var$load("64nco"),
    $3dfaae0b91366a24$var$load("9cx6P"),
    $3dfaae0b91366a24$var$load("28EXy"),
    $3dfaae0b91366a24$var$load("7RZp5"),
    $3dfaae0b91366a24$var$load("leyTH")
]).then(()=>parcelRequire('guLr4'));

});

parcelRegister("4v22g", function(module, exports) {

let $346ba2deeef24df4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $346ba2deeef24df4$var$load("4NJ49"),
    $346ba2deeef24df4$var$load("bfOZL"),
    $346ba2deeef24df4$var$load("4dPO1"),
    $346ba2deeef24df4$var$load("jLbRX"),
    $346ba2deeef24df4$var$load("5g0HW"),
    $346ba2deeef24df4$var$load("gg8tK"),
    $346ba2deeef24df4$var$load("eF54W"),
    $346ba2deeef24df4$var$load("3hnPt")
]).then(()=>parcelRequire('9NY5A'));

});

parcelRegister("adodp", function(module, exports) {

let $76fde6e7dab93238$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $76fde6e7dab93238$var$load("g9gkE"),
    $76fde6e7dab93238$var$load("jYdbS"),
    $76fde6e7dab93238$var$load("ltrgi"),
    $76fde6e7dab93238$var$load("6ncWv"),
    $76fde6e7dab93238$var$load("gFneG"),
    $76fde6e7dab93238$var$load("fu25G"),
    $76fde6e7dab93238$var$load("iQGcz"),
    $76fde6e7dab93238$var$load("ar4uw")
]).then(()=>parcelRequire('l7nLc'));

});

parcelRegister("7wcjs", function(module, exports) {

let $5795129f16bebda4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5795129f16bebda4$var$load("jhikU"),
    $5795129f16bebda4$var$load("f0i3H"),
    $5795129f16bebda4$var$load("69YlM"),
    $5795129f16bebda4$var$load("bvBAp"),
    $5795129f16bebda4$var$load("9kqmW"),
    $5795129f16bebda4$var$load("cyTsc"),
    $5795129f16bebda4$var$load("kXCsp"),
    $5795129f16bebda4$var$load("disCG")
]).then(()=>parcelRequire('ijDRq'));

});

parcelRegister("5e2PY", function(module, exports) {

let $3ce075fd9818b53d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3ce075fd9818b53d$var$load("e2Idi").then(()=>parcelRequire('fC7VU'));

});

parcelRegister("11CPA", function(module, exports) {

let $0bf4017cfd787023$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0bf4017cfd787023$var$load("3gdIo").then(()=>parcelRequire('4USSX'));

});

parcelRegister("hRtvo", function(module, exports) {

let $d00e46120947d0cd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d00e46120947d0cd$var$load("1uCJj").then(()=>parcelRequire('dWB8a'));

});

parcelRegister("9PM3y", function(module, exports) {

let $728e27781bf035cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $728e27781bf035cb$var$load("crqMH").then(()=>parcelRequire('qL2MH'));

});

parcelRegister("29Ztf", function(module, exports) {

let $192c1ad55746f7d1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $192c1ad55746f7d1$var$load("d91RK"),
    $192c1ad55746f7d1$var$load("f7hfJ"),
    $192c1ad55746f7d1$var$load("brdRT"),
    $192c1ad55746f7d1$var$load("QI1kr"),
    $192c1ad55746f7d1$var$load("5LvhC"),
    $192c1ad55746f7d1$var$load("lWBlc"),
    $192c1ad55746f7d1$var$load("s2EmI"),
    $192c1ad55746f7d1$var$load("jc0YL")
]).then(()=>parcelRequire('ayAwo'));

});

parcelRegister("dAeOf", function(module, exports) {

let $9e3a1fff2510c3a2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9e3a1fff2510c3a2$var$load("708J7"),
    $9e3a1fff2510c3a2$var$load("kVqUf"),
    $9e3a1fff2510c3a2$var$load("j03Pa"),
    $9e3a1fff2510c3a2$var$load("2IMxh"),
    $9e3a1fff2510c3a2$var$load("98tcg"),
    $9e3a1fff2510c3a2$var$load("kke1I"),
    $9e3a1fff2510c3a2$var$load("gOwMq"),
    $9e3a1fff2510c3a2$var$load("6GfaN")
]).then(()=>parcelRequire('3x4gn'));

});

parcelRegister("8Phsn", function(module, exports) {

let $66d0a0b5fb7a5f2e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $66d0a0b5fb7a5f2e$var$load("iUXaE"),
    $66d0a0b5fb7a5f2e$var$load("lTkx9"),
    $66d0a0b5fb7a5f2e$var$load("hZ2FX"),
    $66d0a0b5fb7a5f2e$var$load("6wr18"),
    $66d0a0b5fb7a5f2e$var$load("7EorR"),
    $66d0a0b5fb7a5f2e$var$load("ffEVr"),
    $66d0a0b5fb7a5f2e$var$load("Wowvf"),
    $66d0a0b5fb7a5f2e$var$load("hhss7"),
    $66d0a0b5fb7a5f2e$var$load("gnocL")
]).then(()=>parcelRequire('8mHp9'));

});

parcelRegister("15IyG", function(module, exports) {
$parcel$export(module.exports, "default", () => $0cb8d26c32694895$export$2e2bcd8739ae039);

var $nsx26 = parcelRequire("nsx26");


var $1xxT0 = parcelRequire("1xxT0");


var $3yGK6 = parcelRequire("3yGK6");

function $0cb8d26c32694895$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    return (0, $nsx26.default)(dirtyDate, (0, $1xxT0.default)(Date.now(), 1));
}

});

parcelRegister("1xxT0", function(module, exports) {
$parcel$export(module.exports, "default", () => $11f3289e9f8e4176$export$2e2bcd8739ae039);

var $gkHoc = parcelRequire("gkHoc");


var $3yGK6 = parcelRequire("3yGK6");


var $kr6hK = parcelRequire("kr6hK");

function $11f3289e9f8e4176$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    return (0, $gkHoc.default)(dirtyDate, -amount);
}

});

parcelRegister("7fxzU", function(module, exports) {

var $bijHC = parcelRequire("bijHC");

var $caelp = parcelRequire("caelp");


var $9Id8q = parcelRequire("9Id8q");


var $5Zhod = parcelRequire("5Zhod");


var $b8X74 = parcelRequire("b8X74");


var $30DeN = parcelRequire("30DeN");

const $e19aaf09f41a82e7$var$CONTEXT_TYPE = 'Mentions';
const $e19aaf09f41a82e7$var$isSmartMentionConfigWithMentionNameResolver = (smartMentionConfig)=>!!smartMentionConfig.mentionNameResolver;
/*
 * This is a provider implementation which calls URS to provide a list of recommended users/teams to mention.
 * The entryPoint hierarchy is : Editor -> editor-core -> plugins -> mentions -> typeAhead -> getItems -> pluginState.pluginProvider.filter
 * The results are then mapped to mentionItems which have a render prop mentionToTypeaheadItem -> MentionItem
 * https://bitbucket.org/atlassian/atlassian-frontend/src/0884032d85f11f43c13532cd21f13f696b0d28a7/packages/editor/editor-core/src/plugins/mentions/index.tsx#lines-219
 *
 */ class $e19aaf09f41a82e7$var$SmartMentionResource extends (0, $bijHC.AbstractMentionResource) {
    shouldHighlightMention(mention) {
        if (this.smartMentionConfig.shouldHighlightMention) return this.smartMentionConfig.shouldHighlightMention(mention);
        return false;
    }
    notify(searchTime, mentionResult, _query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
    }
    async filter(query, contextIdentifier) {
        this.contextIdentifier = contextIdentifier;
        const searchTime = Date.now();
        try {
            let results = await this.getRecommendedMentions(query ? query : '', contextIdentifier);
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    async getRecommendedMentions(query, contextIdentifier) {
        const startTime = window.performance.now();
        const conf = this.smartMentionConfig;
        const maxNumberOfResults = conf.maxNumberOfResults || 100;
        const request = {
            baseUrl: conf.baseUrl,
            context: {
                productKey: conf.productKey,
                contextType: $e19aaf09f41a82e7$var$CONTEXT_TYPE,
                principalId: conf.principalId || 'context',
                containerId: contextIdentifier && contextIdentifier.containerId,
                siteId: conf.siteId,
                organizationId: conf.orgId,
                objectId: contextIdentifier && contextIdentifier.objectId || 'undefined',
                childObjectId: contextIdentifier && contextIdentifier.childObjectId || 'undefined',
                mentionsSessionId: contextIdentifier && contextIdentifier.sessionId || 'undefined',
                sessionId: contextIdentifier && contextIdentifier.sessionId || 'undefined',
                productAttributes: conf.productAttributes
            },
            includeGroups: conf.includeGroups,
            includeTeams: conf.includeTeams,
            includeUsers: typeof conf.includeUsers === 'undefined' ? true : conf.includeUsers,
            maxNumberOfResults: maxNumberOfResults,
            searchQueryFilter: conf.searchQueryFilter,
            query: query
        };
        try {
            this._notifyAnalyticsListeners((0, $5Zhod.SMART_EVENT_TYPE), 'users', (0, $5Zhod.Actions).REQUESTED, (0, $5Zhod.defaultAttributes)(contextIdentifier));
            const users = await (0, $30DeN.default)(request);
            const elapsedTimeMilli = window.performance.now() - startTime;
            const usersForAnalytics = (0, $5Zhod.getUsersForAnalytics)(users);
            this._notifyAnalyticsListeners((0, $5Zhod.SMART_EVENT_TYPE), 'usersRequest', (0, $5Zhod.Actions).SUCCESSFUL, {
                elapsedTimeMilli: elapsedTimeMilli,
                users: usersForAnalytics,
                displayedUsers: usersForAnalytics,
                ...(0, $5Zhod.defaultAttributes)(contextIdentifier)
            });
            const mentions = this.transformUsersToMentions(users);
            return {
                mentions: mentions,
                query: query
            };
        } catch (e) {
            const elapsedTimeMilli = window.performance.now() - startTime;
            this._notifyAnalyticsListeners((0, $5Zhod.SMART_EVENT_TYPE), 'usersRequest', (0, $5Zhod.Actions).FAILED, {
                elapsedTimeMilli: elapsedTimeMilli,
                ...(0, $5Zhod.defaultAttributes)(contextIdentifier)
            });
            throw e instanceof Error ? e : new Error(String(e));
        }
    }
    transformTeamMember(member) {
        return {
            id: member.id,
            name: member.name
        };
    }
    transformUserToMention(item) {
        const type = item.entityType;
        let defaultVals = {
            source: 'smarts'
        };
        if (type === (0, $9Id8q.EntityType).USER) {
            const user = item;
            return {
                ...defaultVals,
                id: user.id,
                accessLevel: user.accessLevel,
                avatarUrl: user.avatarUrl,
                mentionName: user.nickname || '',
                name: user.name,
                userType: user.userType,
                appType: user.appType
            };
        }
        if (type === (0, $9Id8q.EntityType).TEAM) {
            const team = item;
            let teamLink = '';
            const defaultTeamLink = `${window.location.origin}/people/team/${team.id}`;
            if (typeof this.smartMentionConfig.teamLinkResolver === 'function') teamLink = this.smartMentionConfig.teamLinkResolver(item.id);
            return {
                ...defaultVals,
                id: team.id,
                name: team.displayName || '',
                mentionName: team.displayName,
                avatarUrl: team.smallAvatarImageUrl,
                accessLevel: (0, $caelp.UserAccessLevel)[(0, $caelp.UserAccessLevel).CONTAINER],
                userType: (0, $caelp.UserType)[(0, $caelp.UserType).TEAM],
                lozenge: (0, $caelp.UserType)[(0, $caelp.UserType).TEAM],
                context: {
                    members: team.members ? team.members.map(this.transformTeamMember) : [],
                    includesYou: team.includesYou || false,
                    memberCount: team.memberCount || 0,
                    teamLink: teamLink || defaultTeamLink //OOH HERE Do we pass in resolver or add in provider?
                },
                source: 'smarts'
            };
        }
        if (type === (0, $9Id8q.EntityType).GROUP) {
            const group = item;
            return {
                ...defaultVals,
                id: group.id,
                userType: type.toLowerCase(),
                name: group.name || '',
                lozenge: type.toLowerCase()
            };
        }
        return {
            id: item.id,
            userType: (0, $9Id8q.EntityType).USER.toLowerCase(),
            avatarUrl: item.avatarUrl,
            name: item.name,
            lozenge: (0, $9Id8q.EntityType).USER.toLowerCase()
        };
    }
    transformUsersToMentions(recommendationItems) {
        return (recommendationItems || []).map(this.transformUserToMention, this).filter((user)=>!!user).map((user)=>user);
    }
    cacheMentionName(id, mentionName) {
        this.smartMentionConfig.mentionNameResolver.cacheName(id, mentionName);
    }
    resolveMentionName(id) {
        return this.smartMentionConfig.mentionNameResolver.lookupName(id);
    }
    supportsMentionNameResolving() {
        return true;
    }
    recordMentionSelection(_mention) {
        this._notifyAnalyticsListeners((0, $5Zhod.SMART_EVENT_TYPE), 'usersRequest', (0, $5Zhod.Actions).SELECTED, {
            selectedOption: _mention.id,
            ...(0, $5Zhod.defaultAttributes)(this.contextIdentifier)
        });
    }
    constructor(smartMentionConfig){
        super();
        // If the product doesn't provide a mention name resolve, use the default resolver so that
        // mention names can be looked up from PRS without configuration.
        this.smartMentionConfig = void 0;
        this.lastReturnedSearch = void 0;
        this.contextIdentifier = void 0;
        this.smartMentionConfig = $e19aaf09f41a82e7$var$isSmartMentionConfigWithMentionNameResolver(smartMentionConfig) ? smartMentionConfig : {
            ...smartMentionConfig,
            mentionNameResolver: new (0, $b8X74.DefaultMentionNameResolver)(smartMentionConfig.baseUrl, smartMentionConfig.siteId, smartMentionConfig.productKey)
        };
        this.lastReturnedSearch = 0;
    }
}
var $e19aaf09f41a82e7$export$2e2bcd8739ae039 = $e19aaf09f41a82e7$var$SmartMentionResource;
module.exports["default"] = $e19aaf09f41a82e7$export$2e2bcd8739ae039;

});

parcelRegister("9Id8q", function(module, exports) {
var $ce2b9a608726f465$export$8eda7e02f8f033b2 = /*#__PURE__*/ function(EntityType) {
    EntityType["USER"] = "USER";
    EntityType["TEAM"] = "TEAM";
    EntityType["GROUP"] = "GROUP";
    return EntityType;
}({});
module.exports["EntityType"] = $ce2b9a608726f465$export$8eda7e02f8f033b2;

});

parcelRegister("5Zhod", function(module, exports) {
const $aaff4d743589e839$export$c724588856bbfbcf = 'smart';
var $aaff4d743589e839$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["REQUESTED"] = "requested";
    Actions["SUCCESSFUL"] = "successful";
    Actions["SEARCHED"] = "searched";
    Actions["FAILED"] = "failed";
    Actions["SELECTED"] = "selected";
    return Actions;
}({});
const $aaff4d743589e839$export$38cd8db2db178f58 = (context)=>{
    return {
        context: context?.objectId || '',
        sessionId: context?.sessionId || '',
        pickerType: 'mentions',
        source: 'smarts'
    };
};
const $aaff4d743589e839$export$e8be30a842a4b49d = (users)=>{
    return users ? users.map(({ id: id, entityType: entityType })=>({
            id: id,
            type: entityType.toLowerCase()
        })) : [];
};
module.exports["SMART_EVENT_TYPE"] = $aaff4d743589e839$export$c724588856bbfbcf;
module.exports["Actions"] = $aaff4d743589e839$export$b52183d5cfb26dc9;
module.exports["defaultAttributes"] = $aaff4d743589e839$export$38cd8db2db178f58;
module.exports["getUsersForAnalytics"] = $aaff4d743589e839$export$e8be30a842a4b49d;

});

parcelRegister("b8X74", function(module, exports) {

var $caelp = parcelRequire("caelp");


var $gMmzr = parcelRequire("gMmzr");


var $b3mV7 = parcelRequire("b3mV7");

const $d5111af2e171b376$var$buildUsersQuery = (accountIds)=>({
        query: `query usersQuery($accountIds: [ID!]!) {
    users(accountIds: $accountIds) {
      name
      accountId
    }
  }`,
        variables: {
            accountIds: accountIds
        }
    });
const $d5111af2e171b376$var$makeRequest = async (url, accountIds, cloudId, product)=>{
    const query = $d5111af2e171b376$var$buildUsersQuery(accountIds);
    return (0, $b3mV7.graphqlQuery)(url, query, cloudId, product);
};
class $d5111af2e171b376$export$2ae0434dccdcb77e {
    async lookupName(id) {
        try {
            if (this.cache.has(id)) return {
                id: id,
                name: this.cache.get(id),
                status: (0, $caelp.MentionNameStatus).OK
            };
            const url = (0, $gMmzr.PRD_CONFIG).getGraphQLUrl(this.baseUrl);
            const data = await $d5111af2e171b376$var$makeRequest(url, [
                id
            ], this.cloudId, this.product);
            const userInfo = data.users?.find((user)=>user.accountId === id);
            return userInfo ? {
                id: id,
                name: userInfo.name,
                status: (0, $caelp.MentionNameStatus).OK
            } : {
                id: id,
                status: (0, $caelp.MentionNameStatus).UNKNOWN
            };
        } catch  {
            // on network error, return original list with label 'Unknown'
            return {
                id: id,
                status: (0, $caelp.MentionNameStatus).UNKNOWN
            };
        }
    }
    cacheName(id, name) {
        this.cache.set(id, name);
    }
    constructor(baseUrl, cloudId, product){
        this.baseUrl = void 0;
        this.cloudId = void 0;
        this.product = void 0;
        this.cache = void 0;
        this.baseUrl = baseUrl;
        this.cloudId = cloudId;
        this.product = product;
        this.cache = new Map();
    }
}
module.exports["DefaultMentionNameResolver"] = $d5111af2e171b376$export$2ae0434dccdcb77e;

});

parcelRegister("gMmzr", function(module, exports) {
const $cc0245eb84decfef$export$d4fff2dfff3e2bc1 = {
    getRecommendationServiceUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
    },
    getUsersServiceUrl (productKey) {
        return productKey === 'jira' ? `/rest/api/3/user/bulk` : `/wiki/rest/api/user/bulk`;
    },
    getGraphQLUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
    },
    getTeamsUrl (baseUrl) {
        return baseUrl ? `/${baseUrl}/gateway/api/v3/teams` : `/gateway/api/v3/teams`;
    }
};
module.exports["PRD_CONFIG"] = $cc0245eb84decfef$export$d4fff2dfff3e2bc1;

});

parcelRegister("b3mV7", function(module, exports) {
const $721a16bcf92ff1cb$var$buildHeaders = (cloudId, product = 'platform')=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    if (cloudId && product) {
        const atlAttributionHeader = {
            tenantId: cloudId,
            product: product
        };
        headers.append('atl-attribution', JSON.stringify(atlAttributionHeader));
    }
    return headers;
};
function $721a16bcf92ff1cb$export$74eb8d79ae3e02b5(serviceUrl, query, cloudId, product) {
    const headers = $721a16bcf92ff1cb$var$buildHeaders(cloudId, product);
    return fetch(new Request(`${serviceUrl}`, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    })).then((response)=>{
        if (!response.ok) return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
        return response;
    }).then((response)=>response.json()).then((json)=>{
        if (json.errors) return Promise.reject({
            reason: json.errors[0]?.category || 'default'
        });
        return json.data;
    });
}
module.exports["graphqlQuery"] = $721a16bcf92ff1cb$export$74eb8d79ae3e02b5;

});

parcelRegister("30DeN", function(module, exports) {

var $gMmzr = parcelRequire("gMmzr");

const $f4d78c0bc3a4e1ce$var$getUserRecommendations = (request)=>{
    const url = (0, $gMmzr.PRD_CONFIG).getRecommendationServiceUrl(request.baseUrl);
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: request.context,
            includeUsers: request.includeUsers,
            includeGroups: request.includeGroups,
            includeTeams: request.includeTeams,
            maxNumberOfResults: request.maxNumberOfResults,
            performSearchQueryOnly: false,
            searchQuery: {
                cpusQueryHighlights: {
                    query: '',
                    field: ''
                },
                customQuery: '',
                customerDirectoryId: '',
                filter: request.searchQueryFilter || '',
                minimumAccessLevel: 'APPLICATION',
                queryString: request.query,
                restrictTo: {
                    userIds: [],
                    groupIds: []
                },
                searchUserbase: false
            }
        })
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling smart service, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then((response)=>response.recommendedUsers);
};
var $f4d78c0bc3a4e1ce$export$2e2bcd8739ae039 = $f4d78c0bc3a4e1ce$var$getUserRecommendations;
module.exports["default"] = $f4d78c0bc3a4e1ce$export$2e2bcd8739ae039;

});

parcelRegister("b6fxF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $6SsN4 = parcelRequire("6SsN4");


var $lQV5m = parcelRequire("lQV5m");


var $cK21K = parcelRequire("cK21K");


var $iMnC5 = parcelRequire("iMnC5");


var $jp2Q3 = parcelRequire("jp2Q3");


var $bPFqZ = parcelRequire("bPFqZ");


var $d5gEx = parcelRequire("d5gEx");


var $1koI0 = parcelRequire("1koI0");


var $g0RaX = parcelRequire("g0RaX");


var $3Z1Pc = parcelRequire("3Z1Pc");


var $fxdou = parcelRequire("fxdou");


var $9zU5G = parcelRequire("9zU5G");

const $0b67b0fc1e6d3033$var$ENTRY_POINT_ID = 'user-profile-card-for-mention';
function $0b67b0fc1e6d3033$var$PopperContent({ entryPointReference: entryPointReference, entryPointErrorFallback: entryPointErrorFallback, cloudId: cloudId, testId: testId, agent: agent }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bPFqZ.InternalEntryPointContainer), {
        id: $0b67b0fc1e6d3033$var$ENTRY_POINT_ID,
        entryPointReference: entryPointReference,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fxdou.CardLoading), null),
        errorFallback: entryPointErrorFallback,
        runtimeProps: {
            cloudId: cloudId,
            testId: testId,
            agent: agent
        }
    });
}
function $0b67b0fc1e6d3033$export$b3a703a1f8ebb0c8(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0b67b0fc1e6d3033$var$UserProfileCardForMentionInner, props));
}
/** Inner implementation of {@link UserProfileCardForMention}. */ function $0b67b0fc1e6d3033$var$UserProfileCardForMentionInner({ userId: userId, cloudId: cloudId, orgId: orgId, viewerId: viewerId, children: children, referenceElement: referenceElement, placement: placement = 'bottom-start', trigger: trigger, testId: testId, agent: agent }) {
    const environmentProvider = (0, $d5gEx.useRelayEnvironmentProvider)();
    const onErrorBoundary = (0, $cozmU.useCallback)(()=>{
        (0, $g0RaX.getPageTime)();
    }, []);
    const entryPointErrorFallback = (0, $cozmU.useCallback)((_props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Z1Pc.CardError), {
            testId: testId
        }), [
        testId
    ]);
    const [entryPointReference, setEntryPointReference] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!referenceElement || !userId || !cloudId || !orgId || !viewerId) return;
        const reference = (0, $6SsN4.loadEntryPoint)(environmentProvider, (0, $1koI0.entryPoint), {
            userId: userId,
            cloudId: cloudId,
            orgId: orgId,
            viewerId: viewerId
        });
        setEntryPointReference(reference);
        return ()=>{
            reference.dispose();
            setEntryPointReference(null);
        };
    }, [
        referenceElement,
        userId,
        cloudId,
        orgId,
        viewerId,
        environmentProvider
    ]);
    // Both render paths require these identifiers to make a valid API call. Bail out to
    // the plain children (mention chip without a card) when any are missing - the editor
    // path also needs this guard before its popper renders.
    if (!userId || !cloudId || !orgId || !viewerId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    if (!referenceElement) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9zU5G.UserProfileCardWithTrigger), {
        userId: userId,
        cloudId: cloudId,
        orgId: orgId,
        viewerId: viewerId,
        placement: placement,
        trigger: trigger,
        testId: testId,
        agent: agent,
        shouldRenderToParent: false
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        onError: onErrorBoundary,
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
        zIndex: (0, $jp2Q3.layers).modal()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lQV5m.Popper), {
        referenceElement: referenceElement,
        placement: placement
    }, ({ ref: ref, style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            ref: ref,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- positioning controlled by popper
            style: style,
            testId: testId ? `${testId}--mention-popup` : undefined
        }, entryPointReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0b67b0fc1e6d3033$var$PopperContent, {
            entryPointReference: entryPointReference,
            entryPointErrorFallback: entryPointErrorFallback,
            cloudId: cloudId,
            testId: testId,
            agent: agent
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fxdou.CardLoading), null))))));
}
module.exports["UserProfileCardForMention"] = $0b67b0fc1e6d3033$export$b3a703a1f8ebb0c8;

});

parcelRegister("cbxPV", function(module, exports) {
/// <reference lib="dom" />
/* eslint-env browser */ const $8df0c25ce2bb715f$var$element = document.createElement('i');
function $8df0c25ce2bb715f$export$289b6a6320f709b4(value) {
    const characterReference = '&' + value + ';';
    $8df0c25ce2bb715f$var$element.innerHTML = characterReference;
    const char = $8df0c25ce2bb715f$var$element.textContent;
    // Some named character references do not require the closing semicolon
    // (`&not`, for instance), which leads to situations where parsing the assumed
    // named reference of `&notit;` will result in the string `¬it;`.
    // When we encounter a trailing semicolon after parsing, and the character
    // reference to decode was not a semicolon (`&semi;`), we can assume that the
    // matching was not complete.
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    if (char.charCodeAt(char.length - 1) === 59 /* `;` */  && value !== 'semi') return false;
    // If the decoded string is equal to the input, the character reference was
    // not valid.
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    return char === characterReference ? false : char;
}
module.exports["decodeNamedCharacterReference"] = $8df0c25ce2bb715f$export$289b6a6320f709b4;

});

parcelRegister("6x5cj", function(module, exports) {
const $4c19db43d4ebe254$var$tab = 9 /* `\t` */ ;
const $4c19db43d4ebe254$var$space = 32 /* ` ` */ ;
function $4c19db43d4ebe254$export$a771f20bdd13def9(value) {
    const source = String(value);
    const search = /\r?\n|\r/g;
    let match = search.exec(source);
    let last = 0;
    /** @type {Array<string>} */ const lines = [];
    while(match){
        lines.push($4c19db43d4ebe254$var$trimLine(source.slice(last, match.index), last > 0, true), match[0]);
        last = match.index + match[0].length;
        match = search.exec(source);
    }
    lines.push($4c19db43d4ebe254$var$trimLine(source.slice(last), last > 0, false));
    return lines.join('');
}
/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */ function $4c19db43d4ebe254$var$trimLine(value, start, end) {
    let startIndex = 0;
    let endIndex = value.length;
    if (start) {
        let code = value.codePointAt(startIndex);
        while(code === $4c19db43d4ebe254$var$tab || code === $4c19db43d4ebe254$var$space){
            startIndex++;
            code = value.codePointAt(startIndex);
        }
    }
    if (end) {
        let code = value.codePointAt(endIndex - 1);
        while(code === $4c19db43d4ebe254$var$tab || code === $4c19db43d4ebe254$var$space){
            endIndex--;
            code = value.codePointAt(endIndex - 1);
        }
    }
    return endIndex > startIndex ? value.slice(startIndex, endIndex) : '';
}
module.exports["trimLines"] = $4c19db43d4ebe254$export$a771f20bdd13def9;

});

parcelRegister("h9r4d", function(module, exports) {
$parcel$export(module.exports, "captureException", () => (parcelRequire("lIkvQ")).captureException);
$parcel$export(module.exports, "fireErrorAnalytics", () => (parcelRequire("kFTt2")).default);

var $lIkvQ = parcelRequire("lIkvQ");


var $kFTt2 = parcelRequire("kFTt2");


var $4sTW6 = parcelRequire("4sTW6");


});

parcelRegister("lIkvQ", function(module, exports) {

var $l54O9 = parcelRequire("l54O9");

const $34ee97725f8181a5$export$7da675e3dd1bd6b5 = (sentryUrl, config, getExtraContext)=>(0, $l54O9.default).installGlobalHandler(sentryUrl, config, getExtraContext);
const $34ee97725f8181a5$export$f5282963edea4a68 = (location, error, details = {})=>(0, $l54O9.default).captureException(location, error, details);
module.exports["captureException"] = $34ee97725f8181a5$export$f5282963edea4a68;

});

parcelRegister("l54O9", function(module, exports) {
// This is the only file that should directly import Raven.

var $9HPf3 = parcelRequire("9HPf3");

var $amM2J = parcelRequire("amM2J");

var $eAdCn = parcelRequire("eAdCn");


var $iyIOY = parcelRequire("iyIOY");

var $6W0Xl = parcelRequire("6W0Xl");

var $fa95z = parcelRequire("fa95z");

var $hLq0X = parcelRequire("hLq0X");


var $1wIeS = parcelRequire("1wIeS");

const $15510fe24ae0eb31$var$getFragmentNames = (stackTrace)=>{
    const re = /(?:src\/entry|src|assets)\/([^,./]+)/g;
    const fragmentNames = [];
    let fragmentName = re.exec(stackTrace);
    while(fragmentName){
        fragmentNames.push(fragmentName[1]);
        fragmentName = re.exec(stackTrace);
    }
    const distinctfragmentNames = (0, (/*@__PURE__*/$parcel$interopDefault($1wIeS)))(fragmentNames);
    return distinctfragmentNames;
};
// Add custom tags based on stack trace
const $15510fe24ae0eb31$var$getTaggedData = (data, hint)=>{
    if (!hint) return data;
    const exception = hint.originalException || hint.syntheticException;
    if (!exception) return data;
    const stackTrace = exception.stack;
    if (!stackTrace) return data;
    const taggedData = data;
    const fragmentNames = $15510fe24ae0eb31$var$getFragmentNames(stackTrace);
    if (!fragmentNames.length) taggedData.tags = {
        ...taggedData.tags,
        fragment: 'unknown'
    };
    else {
        taggedData.tags = {
            ...taggedData.tags,
            fragment: fragmentNames[0]
        };
        if (fragmentNames.length > 1) taggedData.extra = {
            ...taggedData.extra,
            allRelevantFragments: fragmentNames
        };
    }
    return taggedData;
};
// https://docs.sentry.io/platforms/javascript/#removing-an-integration
const $15510fe24ae0eb31$var$getFilteredIntegrations = (integrations)=>integrations.filter(({ name: name })=>name !== 'Breadcrumbs');
const $15510fe24ae0eb31$var$installGlobalHandler = (sentryUrl, config, getExtraContext)=>{
    // Check for sentry already enabled to be defensive in case two fragments are loaded in the same page, we
    // don't want duplicated error reports
    const sentryClient = $amM2J.getCurrentHub().getClient();
    if (sentryClient && sentryClient.getOptions().enabled) return;
    const defaultConfig = {
        dsn: sentryUrl,
        environment: "production",
        // This adds our tags to the data sent to sentry
        beforeSend: (event, hint)=>{
            // Yes, we're mutating the argument, but at this point in the error handling lifecycle
            // immutability is not important and it simplifies the logic
            // Event type is documented here: https://github.com/getsentry/sentry-javascript/blob/master/packages/types/src/event.ts
            const extraBeforeSend = config.beforeSend || (()=>null);
            let updatedData = extraBeforeSend(event, hint);
            updatedData = $15510fe24ae0eb31$var$getTaggedData(updatedData, hint);
            return updatedData;
        },
        //Integration typing doesn't seem to work well so I'm just typing it to any
        integrations: (integrations)=>[
                ...$15510fe24ae0eb31$var$getFilteredIntegrations(integrations),
                new $6W0Xl.Dedupe(),
                new $fa95z.ExtraErrorData(),
                new $hLq0X.Transaction(),
                new $iyIOY.CaptureConsole({
                    levels: [
                        'error'
                    ]
                }),
                // not supporting the case where config.integrations is a function that returns an array
                ...config.integrations && config.integrations instanceof Array ? config.integrations : []
            ]
    };
    // Because we don't want to completely override the platform defaults remove them from the config object.
    // They've been integrated into the defaultConfig above.
    config.beforeSend = undefined;
    config.integrations = undefined;
    $eAdCn.init({
        ...defaultConfig,
        ...config
    });
    try {
        $9HPf3.setExtras(getExtraContext());
    } catch (e) {
        $9HPf3.captureException(e);
    }
};
// structured tags that we send to Sentry
// everything else from details object will go into "extras"
const $15510fe24ae0eb31$var$tags = [
    'packageName',
    'teamName'
];
const $15510fe24ae0eb31$var$captureException = (location, error, details)=>{
    $9HPf3.configureScope((scope)=>{
        scope.setTag('logger', location);
        if (details) Object.keys(details).forEach((key)=>{
            if ($15510fe24ae0eb31$var$tags.includes(key)) scope.setTag(key, details[key]);
            else scope.setExtra(key, details[key]);
        });
    });
    $9HPf3.captureException(error);
};
const $15510fe24ae0eb31$var$sentryErrorHandler = {
    installGlobalHandler: $15510fe24ae0eb31$var$installGlobalHandler,
    captureException: $15510fe24ae0eb31$var$captureException
};
var $15510fe24ae0eb31$export$2e2bcd8739ae039 = $15510fe24ae0eb31$var$sentryErrorHandler;
module.exports["default"] = $15510fe24ae0eb31$export$2e2bcd8739ae039;

});

parcelRegister("kFTt2", function(module, exports) {

var $huGTe = parcelRequire("huGTe");


var $66Bcq = parcelRequire("66Bcq");


var $k8V2e = parcelRequire("k8V2e");

var $hcOES = parcelRequire("hcOES");


var $lIkvQ = parcelRequire("lIkvQ");

let $1fc2285692461264$var$analyticsClient;
const $1fc2285692461264$export$d4079397f9611138 = (client)=>{
    $1fc2285692461264$var$analyticsClient = client;
};
const $1fc2285692461264$export$bf406c01a195b215 = ()=>{
    $1fc2285692461264$var$analyticsClient = undefined;
};
const $1fc2285692461264$var$fireErrorAnalytics = ({ event: event, error: error, errorInfo: errorInfo, meta: meta, attributes: attributes })=>{
    const { id: id, packageName: packageName, teamName: teamName } = meta;
    if (__SERVER__) {
        if (error) throw error;
        else {
            const payload = event && (0, $k8V2e.extractAWCDataFromEvent)(event).payload;
            throw new Error(JSON.stringify({
                event: payload,
                errorInfo: errorInfo,
                meta: meta,
                attributes: attributes
            }));
        }
    }
    const fullAnalyticsId = `${packageName}.${id}`;
    if (error) {
        const details = (0, (/*@__PURE__*/$parcel$interopDefault($66Bcq)))({
            ...attributes,
            packageName: packageName,
            teamName: teamName,
            errorInfo: errorInfo
        }, (0, (/*@__PURE__*/$parcel$interopDefault($huGTe))));
        if (event && event.context) {
            const fullEvent = (0, $k8V2e.extractAWCDataFromEvent)(event);
            (0, $lIkvQ.captureException)(fullAnalyticsId, error, {
                ...details,
                ...fullEvent.payload
            });
        } else (0, $lIkvQ.captureException)(fullAnalyticsId, error, details);
    }
    if (event && event.handlers && event.handlers.length > 0) {
        const attrs = attributes || {};
        (0, $hcOES.fireOperationalAnalytics)(event, `${fullAnalyticsId} failed`, attrs);
    } else //Allow this to pass in a promise so that we can avoid blocking render for firing these events.
    if ($1fc2285692461264$var$analyticsClient && $1fc2285692461264$var$analyticsClient.sendOperationalEvent) {
        const gasV3Event = {
            action: 'failed',
            actionSubject: fullAnalyticsId,
            source: 'unknownErrorSource',
            attributes: attributes
        };
        $1fc2285692461264$var$analyticsClient.sendOperationalEvent(gasV3Event);
    } else {
        const analyticsClientUninitialisedError = new Error("Analytics client hasn't been initialised, unable to fire error operational event");
        (0, $lIkvQ.captureException)(fullAnalyticsId, analyticsClientUninitialisedError);
    }
};
const $1fc2285692461264$export$706c486c6b5abdfb = async ({ error: error, id: id, packageName: packageName })=>{
    if (error.statusCode) {
        const { statusCode: statusCode } = error;
        let statusCodeGroup;
        if (statusCode >= 300 && statusCode < 400) statusCodeGroup = '3xx';
        else if (statusCode >= 400 && statusCode < 500) statusCodeGroup = '4xx';
        else if (statusCode >= 500 && statusCode < 600) statusCodeGroup = '5xx';
        else statusCodeGroup = 'unknown';
        await $1fc2285692461264$var$fireErrorAnalytics({
            meta: {
                id: id,
                packageName: packageName
            },
            attributes: {
                statusCodeGroup: statusCodeGroup
            }
        });
    } else await $1fc2285692461264$var$fireErrorAnalytics({
        error: error,
        meta: {
            id: id,
            packageName: packageName
        }
    });
};
var $1fc2285692461264$export$2e2bcd8739ae039 = $1fc2285692461264$var$fireErrorAnalytics;
module.exports["default"] = $1fc2285692461264$export$2e2bcd8739ae039;

});

parcelRegister("4sTW6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lzgC6 = parcelRequire("lzgC6");


var $kFTt2 = parcelRequire("kFTt2");

class $28efc9af7e790139$var$CatchAndReportErrors extends (0, $cozmU.Component) {
    componentDidCatch(error, errorInfo) {
        const { packageName: packageName, id: id, attributes: attributes, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        const analyticsEvent = createAnalyticsEvent({
            action: 'failed'
        });
        (0, $kFTt2.default)({
            event: analyticsEvent,
            errorInfo: errorInfo,
            error: error,
            meta: {
                id: id,
                packageName: packageName
            },
            attributes: attributes
        });
        throw error;
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    }
}
const $28efc9af7e790139$var$reportingErrorBoundary = (0, $lzgC6.default)()($28efc9af7e790139$var$CatchAndReportErrors);
var $28efc9af7e790139$export$2e2bcd8739ae039 = $28efc9af7e790139$var$reportingErrorBoundary;

});

parcelRegister("5pkPF", function(module, exports) {

var $1eVGO = parcelRequire("1eVGO");


var $cgTkH = parcelRequire("cgTkH");



var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $amotT = parcelRequire("amotT");



var $hA0li = parcelRequire("hA0li");


var $eoR7w = parcelRequire("eoR7w");

var $3eff726f85d07655$export$bb38bb9a1161268 = 'unmounted';
var $3eff726f85d07655$export$84cbff306f539230 = 'exited';
var $3eff726f85d07655$export$df38205c966be359 = 'entering';
var $3eff726f85d07655$export$78e9e6e3e014d60a = 'entered';
var $3eff726f85d07655$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $3eff726f85d07655$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $cgTkH.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $3eff726f85d07655$export$84cbff306f539230;
                _this.appearStatus = $3eff726f85d07655$export$df38205c966be359;
            } else initialStatus = $3eff726f85d07655$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $3eff726f85d07655$export$bb38bb9a1161268;
        else initialStatus = $3eff726f85d07655$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $3eff726f85d07655$export$bb38bb9a1161268) return {
            status: $3eff726f85d07655$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $3eff726f85d07655$export$df38205c966be359 && status !== $3eff726f85d07655$export$78e9e6e3e014d60a) nextStatus = $3eff726f85d07655$export$df38205c966be359;
            } else if (status === $3eff726f85d07655$export$df38205c966be359 || status === $3eff726f85d07655$export$78e9e6e3e014d60a) nextStatus = $3eff726f85d07655$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $3eff726f85d07655$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $eoR7w.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $3eff726f85d07655$export$84cbff306f539230) this.setState({
            status: $3eff726f85d07655$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $amotT.default).disabled) {
            this.safeSetState({
                status: $3eff726f85d07655$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $3eff726f85d07655$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $3eff726f85d07655$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $amotT.default).disabled) {
            this.safeSetState({
                status: $3eff726f85d07655$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $3eff726f85d07655$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $3eff726f85d07655$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $3eff726f85d07655$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $1eVGO.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hA0li.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component);
$3eff726f85d07655$var$Transition.contextType = (0, $hA0li.default);
$3eff726f85d07655$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $3eff726f85d07655$var$noop() {}
$3eff726f85d07655$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $3eff726f85d07655$var$noop,
    onEntering: $3eff726f85d07655$var$noop,
    onEntered: $3eff726f85d07655$var$noop,
    onExit: $3eff726f85d07655$var$noop,
    onExiting: $3eff726f85d07655$var$noop,
    onExited: $3eff726f85d07655$var$noop
};
$3eff726f85d07655$var$Transition.UNMOUNTED = $3eff726f85d07655$export$bb38bb9a1161268;
$3eff726f85d07655$var$Transition.EXITED = $3eff726f85d07655$export$84cbff306f539230;
$3eff726f85d07655$var$Transition.ENTERING = $3eff726f85d07655$export$df38205c966be359;
$3eff726f85d07655$var$Transition.ENTERED = $3eff726f85d07655$export$78e9e6e3e014d60a;
$3eff726f85d07655$var$Transition.EXITING = $3eff726f85d07655$export$4aacc83d4d59139f;
var $3eff726f85d07655$export$2e2bcd8739ae039 = $3eff726f85d07655$var$Transition;
module.exports["default"] = $3eff726f85d07655$export$2e2bcd8739ae039;

});

parcelRegister("amotT", function(module, exports) {
$parcel$export(module.exports, "default", () => $78aef2ed8b5cba44$export$2e2bcd8739ae039);
var $78aef2ed8b5cba44$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("hA0li", function(module, exports) {
$parcel$export(module.exports, "default", () => $ccc6107deb85fdd7$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

var $ccc6107deb85fdd7$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(null);

});

parcelRegister("eoR7w", function(module, exports) {
var $a7bc833148928009$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};
module.exports["forceReflow"] = $a7bc833148928009$export$7d26bbb1236dafd6;

});

parcelRegister("2INqe", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ /*
  Styles in this file are based on
  packages/editor/editor-core/src/plugins/media/styles.ts
*/ const $b6b9a13469656ffb$export$a06160db3520e5a2 = 'resizer-item';
const $b6b9a13469656ffb$export$c42cdcfd48254bda = 'resizer-hover-zone';
const $b6b9a13469656ffb$export$10b67c6ff1748bd = 'resizer-is-extended';
const $b6b9a13469656ffb$export$6afc20f0ff6d041 = 'resizer-handle';
const $b6b9a13469656ffb$export$a5792d7e2a486d41 = `${$b6b9a13469656ffb$export$6afc20f0ff6d041}-track`;
const $b6b9a13469656ffb$export$2201bc1aaee73f36 = `${$b6b9a13469656ffb$export$6afc20f0ff6d041}-thumb`;
const $b6b9a13469656ffb$export$97a99610b6f0a178 = `${$b6b9a13469656ffb$export$6afc20f0ff6d041}-danger`;
const $b6b9a13469656ffb$export$b123b2c8a2536d05 = 'resizer-handle-wrapper';
const $b6b9a13469656ffb$export$b5fa87f62ced4967 = 3;
const $b6b9a13469656ffb$export$3d867927ebf9bc1f = 1;
module.exports["resizerItemClassName"] = $b6b9a13469656ffb$export$a06160db3520e5a2;
module.exports["resizerHoverZoneClassName"] = $b6b9a13469656ffb$export$c42cdcfd48254bda;
module.exports["resizerExtendedZone"] = $b6b9a13469656ffb$export$10b67c6ff1748bd;
module.exports["resizerHandleClassName"] = $b6b9a13469656ffb$export$6afc20f0ff6d041;
module.exports["resizerHandleTrackClassName"] = $b6b9a13469656ffb$export$a5792d7e2a486d41;
module.exports["resizerHandleThumbClassName"] = $b6b9a13469656ffb$export$2201bc1aaee73f36;
module.exports["resizerDangerClassName"] = $b6b9a13469656ffb$export$97a99610b6f0a178;
module.exports["handleWrapperClass"] = $b6b9a13469656ffb$export$b123b2c8a2536d05;
module.exports["resizerHandleThumbWidth"] = $b6b9a13469656ffb$export$b5fa87f62ced4967;
module.exports["resizerHandleZIndex"] = $b6b9a13469656ffb$export$3d867927ebf9bc1f;

});

parcelRegister("9to0k", function(module, exports) {
"use strict";
var $6e597142fca2a0bf$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6e597142fca2a0bf$var$__assign = module.exports && module.exports.__assign || function() {
    $6e597142fca2a0bf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6e597142fca2a0bf$var$__assign.apply(this, arguments);
};
var $6e597142fca2a0bf$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
var $6e597142fca2a0bf$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6e597142fca2a0bf$var$React = $6e597142fca2a0bf$var$__importStar((parcelRequire("cozmU")));

var $9aSOx = parcelRequire("9aSOx");


var $6e597142fca2a0bf$var$fast_memoize_1 = $6e597142fca2a0bf$var$__importDefault((parcelRequire("9HfYc")));
var $6e597142fca2a0bf$var$DEFAULT_SIZE = {
    width: 'auto',
    height: 'auto'
};
var $6e597142fca2a0bf$var$clamp = $6e597142fca2a0bf$var$fast_memoize_1.default(function(n, min, max) {
    return Math.max(Math.min(n, max), min);
});
var $6e597142fca2a0bf$var$snap = $6e597142fca2a0bf$var$fast_memoize_1.default(function(n, size) {
    return Math.round(n / size) * size;
});
var $6e597142fca2a0bf$var$hasDirection = $6e597142fca2a0bf$var$fast_memoize_1.default(function(dir, target) {
    return new RegExp(dir, 'i').test(target);
});
var $6e597142fca2a0bf$var$findClosestSnap = $6e597142fca2a0bf$var$fast_memoize_1.default(function(n, snapArray, snapGap) {
    if (snapGap === void 0) snapGap = 0;
    var closestGapIndex = snapArray.reduce(function(prev, curr, index) {
        return Math.abs(curr - n) < Math.abs(snapArray[prev] - n) ? index : prev;
    }, 0);
    var gap = Math.abs(snapArray[closestGapIndex] - n);
    return snapGap === 0 || gap < snapGap ? snapArray[closestGapIndex] : n;
});
var $6e597142fca2a0bf$var$endsWith = $6e597142fca2a0bf$var$fast_memoize_1.default(function(str, searchStr) {
    return str.substr(str.length - searchStr.length, searchStr.length) === searchStr;
});
var $6e597142fca2a0bf$var$getStringSize = $6e597142fca2a0bf$var$fast_memoize_1.default(function(n) {
    n = n.toString();
    if (n === 'auto') return n;
    if ($6e597142fca2a0bf$var$endsWith(n, 'px')) return n;
    if ($6e597142fca2a0bf$var$endsWith(n, '%')) return n;
    if ($6e597142fca2a0bf$var$endsWith(n, 'vh')) return n;
    if ($6e597142fca2a0bf$var$endsWith(n, 'vw')) return n;
    if ($6e597142fca2a0bf$var$endsWith(n, 'vmax')) return n;
    if ($6e597142fca2a0bf$var$endsWith(n, 'vmin')) return n;
    return n + "px";
});
var $6e597142fca2a0bf$var$calculateNewMax = $6e597142fca2a0bf$var$fast_memoize_1.default(function(parentSize, maxWidth, maxHeight, minWidth, minHeight) {
    if (maxWidth && typeof maxWidth === 'string' && $6e597142fca2a0bf$var$endsWith(maxWidth, '%')) {
        var ratio = Number(maxWidth.replace('%', '')) / 100;
        maxWidth = parentSize.width * ratio;
    }
    if (maxHeight && typeof maxHeight === 'string' && $6e597142fca2a0bf$var$endsWith(maxHeight, '%')) {
        var ratio = Number(maxHeight.replace('%', '')) / 100;
        maxHeight = parentSize.height * ratio;
    }
    if (minWidth && typeof minWidth === 'string' && $6e597142fca2a0bf$var$endsWith(minWidth, '%')) {
        var ratio = Number(minWidth.replace('%', '')) / 100;
        minWidth = parentSize.width * ratio;
    }
    if (minHeight && typeof minHeight === 'string' && $6e597142fca2a0bf$var$endsWith(minHeight, '%')) {
        var ratio = Number(minHeight.replace('%', '')) / 100;
        minHeight = parentSize.height * ratio;
    }
    return {
        maxWidth: typeof maxWidth === 'undefined' ? undefined : Number(maxWidth),
        maxHeight: typeof maxHeight === 'undefined' ? undefined : Number(maxHeight),
        minWidth: typeof minWidth === 'undefined' ? undefined : Number(minWidth),
        minHeight: typeof minHeight === 'undefined' ? undefined : Number(minHeight)
    };
});
var $6e597142fca2a0bf$var$definedProps = [
    'style',
    'className',
    'grid',
    'snap',
    'bounds',
    'size',
    'defaultSize',
    'minWidth',
    'minHeight',
    'maxWidth',
    'maxHeight',
    'lockAspectRatio',
    'lockAspectRatioExtraWidth',
    'lockAspectRatioExtraHeight',
    'enable',
    'handleStyles',
    'handleClasses',
    'handleWrapperStyle',
    'handleWrapperClass',
    'children',
    'onResizeStart',
    'onResize',
    'onResizeStop',
    'handleComponent',
    'scale',
    'resizeRatio',
    'snapGap'
];
// HACK: This class is used to calculate % size.
var $6e597142fca2a0bf$var$baseClassName = '__resizable_base__';
var $6e597142fca2a0bf$var$Resizable = /** @class */ function(_super) {
    $6e597142fca2a0bf$var$__extends(Resizable, _super);
    function Resizable(props) {
        var _this = _super.call(this, props) || this;
        _this.ratio = 1;
        _this.resizable = null;
        // For parent boundary
        _this.parentLeft = 0;
        _this.parentTop = 0;
        // For boundary
        _this.resizableLeft = 0;
        _this.resizableTop = 0;
        // For target boundary
        _this.targetLeft = 0;
        _this.targetTop = 0;
        _this.state = {
            isResizing: false,
            resizeCursor: 'auto',
            width: typeof (_this.propsSize && _this.propsSize.width) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.width,
            height: typeof (_this.propsSize && _this.propsSize.height) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.height,
            direction: 'right',
            original: {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            }
        };
        _this.onResizeStart = _this.onResizeStart.bind(_this);
        _this.onMouseMove = _this.onMouseMove.bind(_this);
        _this.onMouseUp = _this.onMouseUp.bind(_this);
        if (typeof window !== 'undefined') {
            window.addEventListener('mouseup', _this.onMouseUp);
            window.addEventListener('mousemove', _this.onMouseMove);
            window.addEventListener('mouseleave', _this.onMouseUp);
            window.addEventListener('touchmove', _this.onMouseMove);
            window.addEventListener('touchend', _this.onMouseUp);
        }
        return _this;
    }
    Object.defineProperty(Resizable.prototype, "parentNode", {
        get: function() {
            if (!this.resizable) return null;
            return this.resizable.parentNode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "propsSize", {
        get: function() {
            return this.props.size || this.props.defaultSize || $6e597142fca2a0bf$var$DEFAULT_SIZE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "base", {
        get: function() {
            var parent = this.parentNode;
            if (!parent) return undefined;
            var children = [].slice.call(parent.children);
            for(var _i = 0, children_1 = children; _i < children_1.length; _i++){
                var n = children_1[_i];
                if (n instanceof HTMLElement) {
                    if (n.classList.contains($6e597142fca2a0bf$var$baseClassName)) return n;
                }
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "size", {
        get: function() {
            var width = 0;
            var height = 0;
            if (typeof window !== 'undefined' && this.resizable) {
                var orgWidth = this.resizable.offsetWidth;
                var orgHeight = this.resizable.offsetHeight;
                // HACK: Set position `relative` to get parent size.
                //       This is because when re-resizable set `absolute`, I can not get base width correctly.
                var orgPosition = this.resizable.style.position;
                if (orgPosition !== 'relative') this.resizable.style.position = 'relative';
                // INFO: Use original width or height if set auto.
                width = this.resizable.style.width !== 'auto' ? this.resizable.offsetWidth : orgWidth;
                height = this.resizable.style.height !== 'auto' ? this.resizable.offsetHeight : orgHeight;
                // Restore original position
                this.resizable.style.position = orgPosition;
            }
            return {
                width: width,
                height: height
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "sizeStyle", {
        get: function() {
            var _this = this;
            var size = this.props.size;
            var getSize = function(key) {
                if (typeof _this.state[key] === 'undefined' || _this.state[key] === 'auto') return 'auto';
                if (_this.propsSize && _this.propsSize[key] && $6e597142fca2a0bf$var$endsWith(_this.propsSize[key].toString(), '%')) {
                    if ($6e597142fca2a0bf$var$endsWith(_this.state[key].toString(), '%')) return _this.state[key].toString();
                    var parentSize = _this.getParentSize();
                    var value = Number(_this.state[key].toString().replace('px', ''));
                    var percent = value / parentSize[key] * 100;
                    return percent + "%";
                }
                return $6e597142fca2a0bf$var$getStringSize(_this.state[key]);
            };
            var width = size && typeof size.width !== 'undefined' && !this.state.isResizing ? $6e597142fca2a0bf$var$getStringSize(size.width) : getSize('width');
            var height = size && typeof size.height !== 'undefined' && !this.state.isResizing ? $6e597142fca2a0bf$var$getStringSize(size.height) : getSize('height');
            return {
                width: width,
                height: height
            };
        },
        enumerable: true,
        configurable: true
    });
    Resizable.prototype.getParentSize = function() {
        if (!this.base || !this.parentNode) return {
            width: window.innerWidth,
            height: window.innerHeight
        };
        // INFO: To calculate parent width with flex layout
        var wrapChanged = false;
        var wrap = this.parentNode.style.flexWrap;
        var minWidth = this.base.style.minWidth;
        if (wrap !== 'wrap') {
            wrapChanged = true;
            this.parentNode.style.flexWrap = 'wrap';
        // HACK: Use relative to get parent padding size
        }
        this.base.style.position = 'relative';
        this.base.style.minWidth = '100%';
        var size = {
            width: this.base.offsetWidth,
            height: this.base.offsetHeight
        };
        this.base.style.position = 'absolute';
        if (wrapChanged) this.parentNode.style.flexWrap = wrap;
        this.base.style.minWidth = minWidth;
        return size;
    };
    Resizable.prototype.componentDidMount = function() {
        this.setState({
            width: this.state.width || this.size.width,
            height: this.state.height || this.size.height
        });
        var parent = this.parentNode;
        if (!(parent instanceof HTMLElement)) return;
        if (this.base) return;
        var element = document.createElement('div');
        element.style.width = '100%';
        element.style.height = '100%';
        element.style.position = 'absolute';
        element.style.transform = 'scale(0, 0)';
        element.style.left = '0';
        element.style.flex = '0';
        if (element.classList) element.classList.add($6e597142fca2a0bf$var$baseClassName);
        else element.className += $6e597142fca2a0bf$var$baseClassName;
        parent.appendChild(element);
    };
    Resizable.prototype.componentWillUnmount = function() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('mouseup', this.onMouseUp);
            window.removeEventListener('mousemove', this.onMouseMove);
            window.removeEventListener('mouseleave', this.onMouseUp);
            window.removeEventListener('touchmove', this.onMouseMove);
            window.removeEventListener('touchend', this.onMouseUp);
            var parent_1 = this.parentNode;
            if (!this.base || !parent_1) return;
            if (!(parent_1 instanceof HTMLElement) || !(this.base instanceof Node)) return;
            parent_1.removeChild(this.base);
        }
    };
    Resizable.prototype.createSizeForCssProperty = function(newSize, kind) {
        var propsSize = this.propsSize && this.propsSize[kind];
        return this.state[kind] === 'auto' && this.state.original[kind] === newSize && (typeof propsSize === 'undefined' || propsSize === 'auto') ? 'auto' : newSize;
    };
    Resizable.prototype.calculateNewMaxFromBoundary = function(maxWidth, maxHeight) {
        if (this.props.bounds === 'parent') {
            var parent_2 = this.parentNode;
            if (parent_2 instanceof HTMLElement) {
                var boundWidth = parent_2.offsetWidth + (this.parentLeft - this.resizableLeft);
                var boundHeight = parent_2.offsetHeight + (this.parentTop - this.resizableTop);
                maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
                maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
            }
        } else if (this.props.bounds === 'window') {
            if (typeof window !== 'undefined') {
                var boundWidth = window.innerWidth - this.resizableLeft;
                var boundHeight = window.innerHeight - this.resizableTop;
                maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
                maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
            }
        } else if (this.props.bounds instanceof HTMLElement) {
            var boundWidth = this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft);
            var boundHeight = this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop);
            maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
            maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
        }
        return {
            maxWidth: maxWidth,
            maxHeight: maxHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromDirection = function(clientX, clientY) {
        var scale = this.props.scale || 1;
        var resizeRatio = this.props.resizeRatio || 1;
        var _a = this.state, direction = _a.direction, original = _a.original;
        var _b = this.props, lockAspectRatio = _b.lockAspectRatio, lockAspectRatioExtraHeight = _b.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _b.lockAspectRatioExtraWidth;
        var newWidth = original.width;
        var newHeight = original.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if ($6e597142fca2a0bf$var$hasDirection('right', direction)) {
            newWidth = original.width + (clientX - original.x) * resizeRatio / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if ($6e597142fca2a0bf$var$hasDirection('left', direction)) {
            newWidth = original.width - (clientX - original.x) * resizeRatio / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if ($6e597142fca2a0bf$var$hasDirection('bottom', direction)) {
            newHeight = original.height + (clientY - original.y) * resizeRatio / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        if ($6e597142fca2a0bf$var$hasDirection('top', direction)) {
            newHeight = original.height - (clientY - original.y) * resizeRatio / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromAspectRatio = function(newWidth, newHeight, max, min) {
        var _a = this.props, lockAspectRatio = _a.lockAspectRatio, lockAspectRatioExtraHeight = _a.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _a.lockAspectRatioExtraWidth;
        var computedMinWidth = typeof min.width === 'undefined' ? 10 : min.width;
        var computedMaxWidth = typeof max.width === 'undefined' || max.width < 0 ? newWidth : max.width;
        var computedMinHeight = typeof min.height === 'undefined' ? 10 : min.height;
        var computedMaxHeight = typeof max.height === 'undefined' || max.height < 0 ? newHeight : max.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if (lockAspectRatio) {
            var extraMinWidth = (computedMinHeight - extraHeight) * this.ratio + extraWidth;
            var extraMaxWidth = (computedMaxHeight - extraHeight) * this.ratio + extraWidth;
            var extraMinHeight = (computedMinWidth - extraWidth) / this.ratio + extraHeight;
            var extraMaxHeight = (computedMaxWidth - extraWidth) / this.ratio + extraHeight;
            var lockedMinWidth = Math.max(computedMinWidth, extraMinWidth);
            var lockedMaxWidth = Math.min(computedMaxWidth, extraMaxWidth);
            var lockedMinHeight = Math.max(computedMinHeight, extraMinHeight);
            var lockedMaxHeight = Math.min(computedMaxHeight, extraMaxHeight);
            newWidth = $6e597142fca2a0bf$var$clamp(newWidth, lockedMinWidth, lockedMaxWidth);
            newHeight = $6e597142fca2a0bf$var$clamp(newHeight, lockedMinHeight, lockedMaxHeight);
        } else {
            newWidth = $6e597142fca2a0bf$var$clamp(newWidth, computedMinWidth, computedMaxWidth);
            newHeight = $6e597142fca2a0bf$var$clamp(newHeight, computedMinHeight, computedMaxHeight);
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.setBoundingClientRect = function() {
        // For parent boundary
        if (this.props.bounds === 'parent') {
            var parent_3 = this.parentNode;
            if (parent_3 instanceof HTMLElement) {
                var parentRect = parent_3.getBoundingClientRect();
                this.parentLeft = parentRect.left;
                this.parentTop = parentRect.top;
            }
        }
        // For target(html element) boundary
        if (this.props.bounds instanceof HTMLElement) {
            var targetRect = this.props.bounds.getBoundingClientRect();
            this.targetLeft = targetRect.left;
            this.targetTop = targetRect.top;
        }
        // For boundary
        if (this.resizable) {
            var _a = this.resizable.getBoundingClientRect(), left = _a.left, top_1 = _a.top;
            this.resizableLeft = left;
            this.resizableTop = top_1;
        }
    };
    Resizable.prototype.onResizeStart = function(event, direction) {
        var clientX = 0;
        var clientY = 0;
        if (event.nativeEvent instanceof MouseEvent) {
            clientX = event.nativeEvent.clientX;
            clientY = event.nativeEvent.clientY;
            // When user click with right button the resize is stuck in resizing mode
            // until users clicks again, dont continue if right click is used.
            // HACK: MouseEvent does not have `which` from flow-bin v0.68.
            if (event.nativeEvent.which === 3) return;
        } else if (event.nativeEvent instanceof TouchEvent) {
            clientX = event.nativeEvent.touches[0].clientX;
            clientY = event.nativeEvent.touches[0].clientY;
        }
        if (this.props.onResizeStart) {
            if (this.resizable) {
                var startResize = this.props.onResizeStart(event, direction, this.resizable);
                if (startResize === false) return;
            }
        }
        // Fix #168
        if (this.props.size) {
            if (typeof this.props.size.height !== 'undefined' && this.props.size.height !== this.state.height) this.setState({
                height: this.props.size.height
            });
            if (typeof this.props.size.width !== 'undefined' && this.props.size.width !== this.state.width) this.setState({
                width: this.props.size.width
            });
        }
        // For lockAspectRatio case
        this.ratio = typeof this.props.lockAspectRatio === 'number' ? this.props.lockAspectRatio : this.size.width / this.size.height;
        // For boundary
        this.setBoundingClientRect();
        this.setState({
            original: {
                x: clientX,
                y: clientY,
                width: this.size.width,
                height: this.size.height
            },
            isResizing: true,
            resizeCursor: window.getComputedStyle(event.target).cursor || 'auto',
            direction: direction
        });
    };
    Resizable.prototype.onMouseMove = function(event) {
        if (!this.state.isResizing || !this.resizable) return;
        var _a = this.props, maxWidth = _a.maxWidth, maxHeight = _a.maxHeight, minWidth = _a.minWidth, minHeight = _a.minHeight;
        var clientX = event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
        var clientY = event instanceof MouseEvent ? event.clientY : event.touches[0].clientY;
        var _b = this.state, direction = _b.direction, original = _b.original, width = _b.width, height = _b.height;
        var parentSize = this.getParentSize();
        var max = $6e597142fca2a0bf$var$calculateNewMax(parentSize, maxWidth, maxHeight, minWidth, minHeight);
        maxWidth = max.maxWidth;
        maxHeight = max.maxHeight;
        minWidth = max.minWidth;
        minHeight = max.minHeight;
        // Calculate new size
        var _c = this.calculateNewSizeFromDirection(clientX, clientY), newHeight = _c.newHeight, newWidth = _c.newWidth;
        // Calculate max size from boundary settings
        var boundaryMax = this.calculateNewMaxFromBoundary(maxWidth, maxHeight);
        // Calculate new size from aspect ratio
        var newSize = this.calculateNewSizeFromAspectRatio(newWidth, newHeight, {
            width: boundaryMax.maxWidth,
            height: boundaryMax.maxHeight
        }, {
            width: minWidth,
            height: minHeight
        });
        newWidth = newSize.newWidth;
        newHeight = newSize.newHeight;
        if (this.props.grid) {
            var newGridWidth = $6e597142fca2a0bf$var$snap(newWidth, this.props.grid[0]);
            var newGridHeight = $6e597142fca2a0bf$var$snap(newHeight, this.props.grid[1]);
            var gap = this.props.snapGap || 0;
            newWidth = gap === 0 || Math.abs(newGridWidth - newWidth) <= gap ? newGridWidth : newWidth;
            newHeight = gap === 0 || Math.abs(newGridHeight - newHeight) <= gap ? newGridHeight : newHeight;
        }
        if (this.props.snap && this.props.snap.x) newWidth = $6e597142fca2a0bf$var$findClosestSnap(newWidth, this.props.snap.x, this.props.snapGap);
        if (this.props.snap && this.props.snap.y) newHeight = $6e597142fca2a0bf$var$findClosestSnap(newHeight, this.props.snap.y, this.props.snapGap);
        var delta = {
            width: newWidth - original.width,
            height: newHeight - original.height
        };
        if (width && typeof width === 'string') {
            if ($6e597142fca2a0bf$var$endsWith(width, '%')) {
                var percent = newWidth / parentSize.width * 100;
                newWidth = percent + "%";
            } else if ($6e597142fca2a0bf$var$endsWith(width, 'vw')) {
                var vw = newWidth / window.innerWidth * 100;
                newWidth = vw + "vw";
            } else if ($6e597142fca2a0bf$var$endsWith(width, 'vh')) {
                var vh = newWidth / window.innerHeight * 100;
                newWidth = vh + "vh";
            }
        }
        if (height && typeof height === 'string') {
            if ($6e597142fca2a0bf$var$endsWith(height, '%')) {
                var percent = newHeight / parentSize.height * 100;
                newHeight = percent + "%";
            } else if ($6e597142fca2a0bf$var$endsWith(height, 'vw')) {
                var vw = newHeight / window.innerWidth * 100;
                newHeight = vw + "vw";
            } else if ($6e597142fca2a0bf$var$endsWith(height, 'vh')) {
                var vh = newHeight / window.innerHeight * 100;
                newHeight = vh + "vh";
            }
        }
        this.setState({
            width: this.createSizeForCssProperty(newWidth, 'width'),
            height: this.createSizeForCssProperty(newHeight, 'height')
        });
        if (this.props.onResize) this.props.onResize(event, direction, this.resizable, delta);
    };
    Resizable.prototype.onMouseUp = function(event) {
        var _a = this.state, isResizing = _a.isResizing, direction = _a.direction, original = _a.original;
        if (!isResizing || !this.resizable) return;
        var delta = {
            width: this.size.width - original.width,
            height: this.size.height - original.height
        };
        if (this.props.onResizeStop) this.props.onResizeStop(event, direction, this.resizable, delta);
        if (this.props.size) this.setState(this.props.size);
        this.setState({
            isResizing: false,
            resizeCursor: 'auto'
        });
    };
    Resizable.prototype.updateSize = function(size) {
        this.setState({
            width: size.width,
            height: size.height
        });
    };
    Resizable.prototype.renderResizer = function() {
        var _this = this;
        var _a = this.props, enable = _a.enable, handleStyles = _a.handleStyles, handleClasses = _a.handleClasses, handleWrapperStyle = _a.handleWrapperStyle, handleWrapperClass = _a.handleWrapperClass, handleComponent = _a.handleComponent;
        if (!enable) return null;
        var resizers = Object.keys(enable).map(function(dir) {
            if (enable[dir] !== false) return $6e597142fca2a0bf$var$React.createElement($9aSOx.Resizer, {
                key: dir,
                direction: dir,
                onResizeStart: _this.onResizeStart,
                replaceStyles: handleStyles && handleStyles[dir],
                className: handleClasses && handleClasses[dir]
            }, handleComponent && handleComponent[dir] ? handleComponent[dir] : null);
            return null;
        });
        // #93 Wrap the resize box in span (will not break 100% width/height)
        return $6e597142fca2a0bf$var$React.createElement("span", {
            className: handleWrapperClass,
            style: handleWrapperStyle
        }, resizers);
    };
    Resizable.prototype.render = function() {
        var _this = this;
        var extendsProps = Object.keys(this.props).reduce(function(acc, key) {
            if ($6e597142fca2a0bf$var$definedProps.indexOf(key) !== -1) return acc;
            acc[key] = _this.props[key];
            return acc;
        }, {});
        return $6e597142fca2a0bf$var$React.createElement("div", $6e597142fca2a0bf$var$__assign({
            ref: function(c) {
                if (c) _this.resizable = c;
            },
            style: $6e597142fca2a0bf$var$__assign({
                position: 'relative',
                userSelect: this.state.isResizing ? 'none' : 'auto'
            }, this.props.style, this.sizeStyle, {
                maxWidth: this.props.maxWidth,
                maxHeight: this.props.maxHeight,
                minWidth: this.props.minWidth,
                minHeight: this.props.minHeight,
                boxSizing: 'border-box'
            }),
            className: this.props.className
        }, extendsProps), this.state.isResizing && $6e597142fca2a0bf$var$React.createElement("div", {
            style: {
                height: '100%',
                width: '100%',
                backgroundColor: 'rgba(0,0,0,0)',
                cursor: "" + (this.state.resizeCursor || 'auto'),
                opacity: 0,
                position: 'fixed',
                zIndex: 9999,
                top: '0',
                left: '0',
                bottom: '0',
                right: '0'
            }
        }), this.props.children, this.renderResizer());
    };
    Resizable.defaultProps = {
        onResizeStart: function() {},
        onResize: function() {},
        onResizeStop: function() {},
        enable: {
            top: true,
            right: true,
            bottom: true,
            left: true,
            topRight: true,
            bottomRight: true,
            bottomLeft: true,
            topLeft: true
        },
        style: {},
        grid: [
            1,
            1
        ],
        lockAspectRatio: false,
        lockAspectRatioExtraWidth: 0,
        lockAspectRatioExtraHeight: 0,
        scale: 1,
        resizeRatio: 1,
        snapGap: 0
    };
    return Resizable;
}($6e597142fca2a0bf$var$React.PureComponent);
module.exports.Resizable = $6e597142fca2a0bf$var$Resizable;

});

parcelRegister("9aSOx", function(module, exports) {
"use strict";
var $6adf91262b04985e$var$__assign = module.exports && module.exports.__assign || function() {
    $6adf91262b04985e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6adf91262b04985e$var$__assign.apply(this, arguments);
};
var $6adf91262b04985e$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6adf91262b04985e$var$React = $6adf91262b04985e$var$__importStar((parcelRequire("cozmU")));
var $6adf91262b04985e$var$styles = {
    top: {
        width: '100%',
        height: '10px',
        top: '-5px',
        left: '0px',
        cursor: 'row-resize'
    },
    right: {
        width: '10px',
        height: '100%',
        top: '0px',
        right: '-5px',
        cursor: 'col-resize'
    },
    bottom: {
        width: '100%',
        height: '10px',
        bottom: '-5px',
        left: '0px',
        cursor: 'row-resize'
    },
    left: {
        width: '10px',
        height: '100%',
        top: '0px',
        left: '-5px',
        cursor: 'col-resize'
    },
    topRight: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        top: '-10px',
        cursor: 'ne-resize'
    },
    bottomRight: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        bottom: '-10px',
        cursor: 'se-resize'
    },
    bottomLeft: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        left: '-10px',
        bottom: '-10px',
        cursor: 'sw-resize'
    },
    topLeft: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        left: '-10px',
        top: '-10px',
        cursor: 'nw-resize'
    }
};
function $6adf91262b04985e$var$Resizer(props) {
    return $6adf91262b04985e$var$React.createElement("div", {
        className: props.className || '',
        style: $6adf91262b04985e$var$__assign({
            position: 'absolute',
            userSelect: 'none'
        }, $6adf91262b04985e$var$styles[props.direction], props.replaceStyles || {}),
        onMouseDown: function(e) {
            props.onResizeStart(e, props.direction);
        },
        onTouchStart: function(e) {
            props.onResizeStart(e, props.direction);
        }
    }, props.children);
}
module.exports.Resizer = $6adf91262b04985e$var$Resizer;

});

parcelRegister("9HfYc", function(module, exports) {
//
// Main
//
function $70f4847fca63d9bd$var$memoize(fn, options) {
    var cache = options && options.cache ? options.cache : $70f4847fca63d9bd$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $70f4847fca63d9bd$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $70f4847fca63d9bd$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $70f4847fca63d9bd$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean' // || typeof value === "string" 'unsafe' primitive for our needs
    ;
}
function $70f4847fca63d9bd$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $70f4847fca63d9bd$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $70f4847fca63d9bd$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $70f4847fca63d9bd$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $70f4847fca63d9bd$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $70f4847fca63d9bd$var$monadic : $70f4847fca63d9bd$var$variadic;
    return $70f4847fca63d9bd$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $70f4847fca63d9bd$var$strategyVariadic(fn, options) {
    var strategy = $70f4847fca63d9bd$var$variadic;
    return $70f4847fca63d9bd$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $70f4847fca63d9bd$var$strategyMonadic(fn, options) {
    var strategy = $70f4847fca63d9bd$var$monadic;
    return $70f4847fca63d9bd$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
//
// Serializer
//
function $70f4847fca63d9bd$var$serializerDefault() {
    return JSON.stringify(arguments);
}
//
// Cache
//
function $70f4847fca63d9bd$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$70f4847fca63d9bd$var$ObjectWithoutPrototypeCache.prototype.has = function(key) {
    return key in this.cache;
};
$70f4847fca63d9bd$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$70f4847fca63d9bd$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $70f4847fca63d9bd$var$cacheDefault = {
    create: function create() {
        return new $70f4847fca63d9bd$var$ObjectWithoutPrototypeCache();
    }
};
//
// API
//
module.exports = $70f4847fca63d9bd$var$memoize;
module.exports.strategies = {
    variadic: $70f4847fca63d9bd$var$strategyVariadic,
    monadic: $70f4847fca63d9bd$var$strategyMonadic
};

});

parcelRegister("6PfjN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::c64352804e2dc1a0b65a6765b7979b51>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen link-analytics
 */ const $43bfeda8ce4963c3$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $43bfeda8ce4963c3$export$2e2bcd8739ae039 = $43bfeda8ce4963c3$var$createEventPayload;
module.exports["default"] = $43bfeda8ce4963c3$export$2e2bcd8739ae039;

});

parcelRegister("liM9D", function(module, exports) {
const $805653e9c9be0b26$export$3f072f06b90c3985 = 'media';
module.exports["EVENT_CHANNEL"] = $805653e9c9be0b26$export$3f072f06b90c3985;

});

parcelRegister("lqRBm", function(module, exports) {
/* eslint-disable compat/compat */ const $b136b9ae0024c8d8$export$51d09170c61ebe04 = (callback)=>window.requestIdleCallback ? window.requestIdleCallback(callback, {
        timeout: 5000
    }) : window.requestAnimationFrame(callback);
module.exports["runWhenIdle"] = $b136b9ae0024c8d8$export$51d09170c61ebe04;

});

parcelRegister("8hDyr", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2iGHk = parcelRequire("2iGHk");

var $9DHhW = parcelRequire("9DHhW");


var $cMyWi = parcelRequire("cMyWi");


var $6PfjN = parcelRequire("6PfjN");


var $liM9D = parcelRequire("liM9D");


var $lqRBm = parcelRequire("lqRBm");


const $e5274b30bf01d8e7$export$612752b1e088a45e = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { store: store, connections: { client: client } } = (0, $cMyWi.useSmartLinkContext)();
    return (0, $cozmU.useMemo)(()=>{
        const factory = (action)=>(...args)=>{
                try {
                    (0, $lqRBm.runWhenIdle)(()=>{
                        (0, $2iGHk.default)((0, $liM9D.EVENT_CHANNEL))((0, $6PfjN.default)('operational.fireAnalyticEvent.commenced', {
                            action: action
                        }))(createAnalyticsEvent);
                    });
                    (0, $lqRBm.runWhenIdle)(async ()=>{
                        const { default: fireEvent } = await (parcelRequire("kItVn"));
                        fireEvent(action, createAnalyticsEvent, client, store)(...args);
                    });
                } catch (error) {
                    (0, $2iGHk.default)((0, $liM9D.EVENT_CHANNEL))((0, $6PfjN.default)('operational.fireAnalyticEvent.failed', {
                        error: error instanceof Error ? error.toString() : '',
                        action: action
                    }))(createAnalyticsEvent);
                }
            };
        return {
            linkCreated: factory('created'),
            linkUpdated: factory('updated'),
            linkDeleted: factory('deleted')
        };
    }, [
        client,
        store,
        createAnalyticsEvent
    ]);
};
module.exports["useSmartLinkLifecycleAnalytics"] = $e5274b30bf01d8e7$export$612752b1e088a45e;

});

parcelRegister("kItVn", function(module, exports) {

let $f14f210d84de21c3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f14f210d84de21c3$var$load("iUXaE"),
    $f14f210d84de21c3$var$load("lTkx9"),
    $f14f210d84de21c3$var$load("hZ2FX"),
    $f14f210d84de21c3$var$load("dXcHK")
]).then(()=>parcelRequire('3hbWh'));

});

parcelRegister("11HKG", function(module, exports) {

var $kU8j5 = parcelRequire("kU8j5");





const $d9e2566b9c6c061f$export$75d81fc396e386db = (pos)=>(0, $kU8j5.isNumber)(pos.x);
module.exports["isVerticalPosition"] = $d9e2566b9c6c061f$export$75d81fc396e386db;

});

parcelRegister("kU8j5", function(module, exports) {
const $8db3bb3cfffbe62d$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
module.exports["isNumber"] = $8db3bb3cfffbe62d$export$7e4aa119212bc614;

});

parcelRegister("cZuBE", function(module, exports) {

var $7Y8M5 = parcelRequire("7Y8M5");


var $fqVYq = parcelRequire("fqVYq");

const $0bd63c8cc84b50d1$export$d52a13210f6817c5 = (containerWidth)=>{
    const padding = containerWidth <= (0, $7Y8M5.akEditorFullPageNarrowBreakout) && (0, $fqVYq.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $7Y8M5.akEditorGutterPaddingReduced) : (0, $7Y8M5.akEditorGutterPaddingDynamic)();
    return Math.min(containerWidth - padding * 2, (0, $7Y8M5.akEditorFullWidthLayoutWidth)) / 2;
};
module.exports["getContainerWidthOrFullEditorWidth"] = $0bd63c8cc84b50d1$export$d52a13210f6817c5;

});

parcelRegister("g6rNx", function(module, exports) {
function $bb92c4fc742f9d95$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports["default"] = $bb92c4fc742f9d95$export$2e2bcd8739ae039;

});

parcelRegister("61VNy", function(module, exports) {

var $kSfw9 = parcelRequire("kSfw9");

function $463fab9b5f038fe4$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $kSfw9.default)(o.key), o);
    }
}
function $463fab9b5f038fe4$export$2e2bcd8739ae039(e, r, t) {
    return r && $463fab9b5f038fe4$var$_defineProperties(e.prototype, r), t && $463fab9b5f038fe4$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports["default"] = $463fab9b5f038fe4$export$2e2bcd8739ae039;

});

parcelRegister("3luEO", function(module, exports) {

var $68pA8 = parcelRequire("68pA8");


var $fPHWO = parcelRequire("fPHWO");

function $26fb1d235b43c874$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $68pA8.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $fPHWO.default)(t);
}
module.exports["default"] = $26fb1d235b43c874$export$2e2bcd8739ae039;

});

parcelRegister("3LZzv", function(module, exports) {
$parcel$export(module.exports, "default", () => $2bf585bebcf0d07d$export$2e2bcd8739ae039);
function $2bf585bebcf0d07d$export$2e2bcd8739ae039(t) {
    return $2bf585bebcf0d07d$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $2bf585bebcf0d07d$export$2e2bcd8739ae039(t);
}

});

parcelRegister("8Npt5", function(module, exports) {

var $1o91h = parcelRequire("1o91h");

function $6676a7c55fc90fae$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $1o91h.default)(t, e);
}
module.exports["default"] = $6676a7c55fc90fae$export$2e2bcd8739ae039;

});

parcelRegister("kL2zH", function(module, exports) {
function $f1ca31bcf83fc566$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports["default"] = $f1ca31bcf83fc566$export$2e2bcd8739ae039;

});

parcelRegister("ivJm4", function(module, exports) {

var $kL2zH = parcelRequire("kL2zH");

function $d79e4dd1e790fb08$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $kL2zH.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $kL2zH.default)(r, a) : void 0;
    }
}
module.exports["default"] = $d79e4dd1e790fb08$export$2e2bcd8739ae039;

});

parcelRegister("dhtsm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b0cd8dd83f623ffc8a93c918c96c1a11>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9ab3b6586bd7bdc0$var$_react = $9ab3b6586bd7bdc0$var$_interopRequireDefault((parcelRequire("cozmU")));

var $9ab3b6586bd7bdc0$var$_baseNew = $9ab3b6586bd7bdc0$var$_interopRequireDefault((parcelRequire("gElAV")));
function $9ab3b6586bd7bdc0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FieldText".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9ab3b6586bd7bdc0$var$FieldTextIcon = (props)=>/*#__PURE__*/ $9ab3b6586bd7bdc0$var$_react.default.createElement($9ab3b6586bd7bdc0$var$_baseNew.default, Object.assign({
        name: "FieldTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.75 2.5H8V1h5v1.5h-1.75v2H14a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2.75v2H13V15H8v-1.5h1.75zm1.5 7.5H14a.5.5 0 0 0 .5-.5v-3A.5.5 0 0 0 14 6h-2.75zM2 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h6v1.5H2a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h6V6z" clip-rule="evenodd"/>`
    }, props));
$9ab3b6586bd7bdc0$var$FieldTextIcon.displayName = 'FieldTextIcon';
var $9ab3b6586bd7bdc0$var$_default = module.exports.default = $9ab3b6586bd7bdc0$var$FieldTextIcon;

});

parcelRegister("aWssQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5X6fy = parcelRequire("5X6fy");


var $9to0k = parcelRequire("9to0k");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $fqVYq = parcelRequire("fqVYq");


var $lpNn5 = parcelRequire("lpNn5");


var $lFU5S = parcelRequire("lFU5S");


var $2INqe = parcelRequire("2INqe");

const $4f26ff7de36db2bd$var$resizerLabelStyles = (0, $buxP3.xcss)({
    position: 'absolute',
    bottom: "var(--ds-space-0, 0px)",
    width: '100%',
    overflow: 'visible',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: "var(--ds-space-0, 0px)",
    zIndex: 'layer' // 400 same z-index as the floating toolbar
});
const $4f26ff7de36db2bd$var$SUPPORTED_HANDLES = [
    'left',
    'right'
];
const $4f26ff7de36db2bd$var$SUPPORTED_HANDLES_FOR_VERTICAL_RESIZE = [
    'left',
    'right',
    'bottom'
];
const $4f26ff7de36db2bd$var$inheritedCSS = {
    position: 'inherit',
    height: 'inherit',
    width: 'inherit',
    display: 'inherit',
    flexDirection: 'inherit',
    justifyContent: 'inherit',
    alignItems: 'inherit'
};
const $4f26ff7de36db2bd$var$ResizerNext = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(94);
    const [isResizing, setIsResizing] = (0, $cozmU.useState)(false);
    const resizable = (0, $cozmU.useRef)(null);
    const resizeHandleThumbRef = (0, $cozmU.useRef)(null);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>({
                getResizerThumbEl () {
                    return resizeHandleThumbRef.current;
                }
            });
        t1 = [
            resizeHandleThumbRef
        ];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useImperativeHandle)(ref, t0, t1);
    let appearance;
    let children;
    let childrenDOMRef;
    let className;
    let handleClassName;
    let handleResize;
    let handleResizeStart;
    let handleResizeStop;
    let handleStyles;
    let handleTooltipContent;
    let height;
    let labelComponent;
    let otherProps;
    let snap;
    let snapGap;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let width;
    if ($[2] !== props) {
        ({ width: width, height: height, children: children, handleClassName: handleClassName, className: className, handleResize: handleResize, handleResizeStart: handleResizeStart, handleResizeStop: handleResizeStop, handleSize: t2, handleAlignmentMethod: t3, handlePositioning: t4, appearance: appearance, handleStyles: handleStyles, resizeRatio: t5, snap: snap, snapGap: snapGap, isHandleVisible: t6, handleHighlight: t7, handleTooltipContent: handleTooltipContent, needExtendedResizeZone: t8, childrenDOMRef: childrenDOMRef, labelComponent: labelComponent, ...otherProps } = props);
        $[2] = props;
        $[3] = appearance;
        $[4] = children;
        $[5] = childrenDOMRef;
        $[6] = className;
        $[7] = handleClassName;
        $[8] = handleResize;
        $[9] = handleResizeStart;
        $[10] = handleResizeStop;
        $[11] = handleStyles;
        $[12] = handleTooltipContent;
        $[13] = height;
        $[14] = labelComponent;
        $[15] = otherProps;
        $[16] = snap;
        $[17] = snapGap;
        $[18] = t2;
        $[19] = t3;
        $[20] = t4;
        $[21] = t5;
        $[22] = t6;
        $[23] = t7;
        $[24] = t8;
        $[25] = width;
    } else {
        appearance = $[3];
        children = $[4];
        childrenDOMRef = $[5];
        className = $[6];
        handleClassName = $[7];
        handleResize = $[8];
        handleResizeStart = $[9];
        handleResizeStop = $[10];
        handleStyles = $[11];
        handleTooltipContent = $[12];
        height = $[13];
        labelComponent = $[14];
        otherProps = $[15];
        snap = $[16];
        snapGap = $[17];
        t2 = $[18];
        t3 = $[19];
        t4 = $[20];
        t5 = $[21];
        t6 = $[22];
        t7 = $[23];
        t8 = $[24];
        width = $[25];
    }
    const handleSize = t2 === undefined ? "medium" : t2;
    const handleAlignmentMethod = t3 === undefined ? "center" : t3;
    const handlePositioning = t4 === undefined ? "overlap" : t4;
    const resizeRatio = t5 === undefined ? 1 : t5;
    const isHandleVisible = t6 === undefined ? false : t6;
    const handleHighlight = t7 === undefined ? "none" : t7;
    const needExtendedResizeZone = t8 === undefined ? true : t8;
    let t9;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (0, $anBbz.expValEqualsNoExposure)("cc-maui-experiment", "isEnabled", true) && (0, $ieeJu.expValEquals)("databases-native-embeds-v2", "isEnabled", true);
        $[26] = t9;
    } else t9 = $[26];
    const isDatabasesV2Enabled = t9;
    const supportedHandles = isDatabasesV2Enabled ? $4f26ff7de36db2bd$var$SUPPORTED_HANDLES_FOR_VERTICAL_RESIZE : $4f26ff7de36db2bd$var$SUPPORTED_HANDLES;
    let t10;
    if ($[27] !== handleResizeStart) {
        t10 = (event)=>{
            event.preventDefault();
            setIsResizing(true);
            handleResizeStart();
        };
        $[27] = handleResizeStart;
        $[28] = t10;
    } else t10 = $[28];
    const onResizeStart = t10;
    let t11;
    if ($[29] !== handleResize) {
        t11 = (_event, direction, _elementRef, delta)=>{
            if (!handleResize) return;
            const resizableCurrent = resizable.current;
            if (!resizableCurrent || !resizableCurrent.state.original) return;
            const originalState = {
                x: resizableCurrent.state.original.x,
                y: resizableCurrent.state.original.y,
                width: resizableCurrent.state.original.width,
                height: resizableCurrent.state.original.height
            };
            if (isDatabasesV2Enabled) handleResize(originalState, delta, direction);
            else handleResize(originalState, delta);
        };
        $[29] = handleResize;
        $[30] = t11;
    } else t11 = $[30];
    const onResize = t11;
    let t12;
    if ($[31] !== handleResizeStop) {
        t12 = (_event_0, direction_0, _elementRef_0, delta_0)=>{
            const resizableCurrent_0 = resizable.current;
            if (!resizableCurrent_0 || !resizableCurrent_0.state.original) return;
            const originalState_0 = {
                x: resizableCurrent_0.state.original.x,
                y: resizableCurrent_0.state.original.y,
                width: resizableCurrent_0.state.original.width,
                height: resizableCurrent_0.state.original.height
            };
            setIsResizing(false);
            if (isDatabasesV2Enabled) handleResizeStop(originalState_0, delta_0, direction_0);
            else handleResizeStop(originalState_0, delta_0);
        };
        $[31] = handleResizeStop;
        $[32] = t12;
    } else t12 = $[32];
    const onResizeStop = t12;
    let t13;
    if ($[33] !== handleAlignmentMethod || $[34] !== handleClassName || $[35] !== handleSize) {
        t13 = supportedHandles.reduce((result, position)=>({
                ...result,
                [position]: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))(handleClassName ?? (0, $2INqe.resizerHandleClassName), position, handleSize, position === "bottom" && isDatabasesV2Enabled ? undefined : handleAlignmentMethod)
            }), {});
        $[33] = handleAlignmentMethod;
        $[34] = handleClassName;
        $[35] = handleSize;
        $[36] = t13;
    } else t13 = $[36];
    const handles = t13;
    const handleWidth = handlePositioning === "adjacent" ? "var(--ds-space-100, 8px)" : "var(--ds-space-300, 24px)";
    const t14 = handlePositioning === "adjacent" ? "center" : undefined;
    let t15;
    if ($[37] !== handlePositioning || $[38] !== handleStyles || $[39] !== handleWidth || $[40] !== t14) {
        const baseHorizontalHandleStyles = {
            width: handleWidth,
            zIndex: (0, $2INqe.resizerHandleZIndex),
            pointerEvents: "auto",
            alignItems: t14
        };
        const baseBottomHandleStyles = {
            height: handleWidth,
            zIndex: (0, $2INqe.resizerHandleZIndex),
            pointerEvents: "auto",
            justifyContent: handlePositioning === "adjacent" ? "center" : undefined
        };
        const t16 = handlePositioning === "adjacent" ? "center" : undefined;
        let t17;
        if ($[42] !== handleWidth || $[43] !== t16) {
            t17 = {
                width: handleWidth,
                zIndex: (0, $2INqe.resizerHandleZIndex),
                pointerEvents: "auto",
                alignItems: t16
            };
            $[42] = handleWidth;
            $[43] = t16;
            $[44] = t17;
        } else t17 = $[44];
        const memoizedBaseHorizontalHandleStyles = t17;
        const t18 = handlePositioning === "adjacent" ? "center" : undefined;
        let t19;
        if ($[45] !== handleWidth || $[46] !== t18) {
            t19 = {
                height: handleWidth,
                zIndex: (0, $2INqe.resizerHandleZIndex),
                pointerEvents: "auto",
                justifyContent: t18
            };
            $[45] = handleWidth;
            $[46] = t18;
            $[47] = t19;
        } else t19 = $[47];
        const memoizedBaseBottomHandleStyles = t19;
        const offset = handlePositioning === "adjacent" ? `calc(${handleWidth} * -1)` : `calc(${handleWidth} * -0.5)`;
        let t20;
        if ($[48] !== handleStyles || $[49] !== memoizedBaseBottomHandleStyles || $[50] !== memoizedBaseHorizontalHandleStyles || $[51] !== offset) {
            t20 = supportedHandles.reduce((result_0, position_0)=>({
                    ...result_0,
                    [position_0]: {
                        ...position_0 === "bottom" ? memoizedBaseBottomHandleStyles : memoizedBaseHorizontalHandleStyles,
                        [position_0]: offset,
                        ...handleStyles?.[position_0]
                    }
                }), {});
            $[48] = handleStyles;
            $[49] = memoizedBaseBottomHandleStyles;
            $[50] = memoizedBaseHorizontalHandleStyles;
            $[51] = offset;
            $[52] = t20;
        } else t20 = $[52];
        const memoizedNextHandleStyles = t20;
        t15 = (0, $ieeJu.expValEquals)("platform_editor_perf_lint_cleanup", "isEnabled", true) ? memoizedNextHandleStyles : supportedHandles.reduce((result_1, position_1)=>({
                ...result_1,
                [position_1]: {
                    ...position_1 === "bottom" ? baseBottomHandleStyles : baseHorizontalHandleStyles,
                    [position_1]: offset,
                    ...handleStyles?.[position_1]
                }
            }), {});
        $[37] = handlePositioning;
        $[38] = handleStyles;
        $[39] = handleWidth;
        $[40] = t14;
        $[41] = t15;
    } else t15 = $[41];
    const nextHandleStyles = t15;
    const t16 = appearance === "danger";
    let t17;
    if ($[53] !== className || $[54] !== isHandleVisible || $[55] !== isResizing || $[56] !== t16) {
        t17 = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))(className, (0, $2INqe.resizerItemClassName), {
            "is-resizing": isResizing,
            "display-handle": isHandleVisible,
            [(0, $2INqe.resizerDangerClassName)]: t16
        });
        $[53] = className;
        $[54] = isHandleVisible;
        $[55] = isResizing;
        $[56] = t16;
        $[57] = t17;
    } else t17 = $[57];
    const resizerClassName = t17;
    let t18;
    if ($[58] !== needExtendedResizeZone) {
        t18 = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))((0, $2INqe.resizerHoverZoneClassName), {
            [(0, $2INqe.resizerExtendedZone)]: needExtendedResizeZone
        });
        $[58] = needExtendedResizeZone;
        $[59] = t18;
    } else t18 = $[59];
    const resizerZoneClassName = t18;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t19;
    if ($[60] !== formatMessage || $[61] !== handleHighlight || $[62] !== handleTooltipContent) {
        t19 = supportedHandles.reduce((result_2, position_2)=>{
            const thumb = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
                className: (0, $2INqe.resizerHandleThumbClassName),
                "data-testid": `resizer-handle-${position_2}-thumb`,
                "aria-label": formatMessage((0, $lFU5S.messages).resizeHandle),
                contentEditable: false,
                ref: resizeHandleThumbRef,
                type: "button",
                tabIndex: -1
            });
            if ((!handleHighlight || handleHighlight === "none") && !handleTooltipContent) return {
                ...result_2,
                [position_2]: thumb
            };
            const thumbWithTrack = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, thumb, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))((0, $2INqe.resizerHandleTrackClassName), handleHighlight),
                "data-testid": `resizer-handle-${position_2}-track`
            }));
            if (!!handleTooltipContent) return {
                ...result_2,
                [position_2]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    contentEditable: false,
                    style: $4f26ff7de36db2bd$var$inheritedCSS
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                    content: handleTooltipContent,
                    hideTooltipOnClick: true,
                    position: "mouse",
                    mousePosition: "auto-start",
                    testId: `resizer-handle-${position_2}-tooltip`
                }, thumbWithTrack))
            };
            return {
                ...result_2,
                [position_2]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    contentEditable: false,
                    style: $4f26ff7de36db2bd$var$inheritedCSS
                }, thumbWithTrack)
            };
        }, {});
        $[60] = formatMessage;
        $[61] = handleHighlight;
        $[62] = handleTooltipContent;
        $[63] = t19;
    } else t19 = $[63];
    const handleComponent = t19;
    let t20;
    bb0: {
        if (!snap || snap.x?.length === 0 && snap.y?.length === 0) {
            t20 = undefined;
            break bb0;
        }
        t20 = snapGap;
    }
    const snapGapActual = t20;
    const resolvedHeight = isDatabasesV2Enabled ? height ?? "auto" : "auto";
    const t21 = width ?? "auto";
    let t22;
    if ($[64] !== resolvedHeight || $[65] !== t21) {
        t22 = {
            width: t21,
            height: resolvedHeight
        };
        $[64] = resolvedHeight;
        $[65] = t21;
        $[66] = t22;
    } else t22 = $[66];
    const resizerAutoSize = t22;
    let t23;
    if ($[67] !== resizerAutoSize || $[68] !== resolvedHeight || $[69] !== width) {
        t23 = (0, $ieeJu.expValEquals)("platform_editor_perf_lint_cleanup", "isEnabled", true) ? resizerAutoSize : {
            width: width ?? "auto",
            height: resolvedHeight
        };
        $[67] = resizerAutoSize;
        $[68] = resolvedHeight;
        $[69] = width;
        $[70] = t23;
    } else t23 = $[70];
    const resizerSize = t23;
    let t24;
    if ($[71] !== childrenDOMRef) {
        t24 = (ref_0)=>childrenDOMRef && childrenDOMRef(ref_0);
        $[71] = childrenDOMRef;
        $[72] = t24;
    } else t24 = $[72];
    let t25;
    if ($[73] !== children || $[74] !== resizerZoneClassName || $[75] !== t24) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: resizerZoneClassName,
            ref: t24
        }, children);
        $[73] = children;
        $[74] = resizerZoneClassName;
        $[75] = t24;
        $[76] = t25;
    } else t25 = $[76];
    let t26;
    if ($[77] !== labelComponent) {
        t26 = labelComponent && (0, $fqVYq.editorExperiment)("single_column_layouts", true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $4f26ff7de36db2bd$var$resizerLabelStyles
        }, labelComponent);
        $[77] = labelComponent;
        $[78] = t26;
    } else t26 = $[78];
    let t27;
    if ($[79] !== handleComponent || $[80] !== handles || $[81] !== nextHandleStyles || $[82] !== onResize || $[83] !== onResizeStart || $[84] !== onResizeStop || $[85] !== otherProps || $[86] !== resizeRatio || $[87] !== resizerClassName || $[88] !== resizerSize || $[89] !== snap || $[90] !== snapGapActual || $[91] !== t25 || $[92] !== t26) {
        t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9to0k.Resizable), {
            ref: resizable,
            size: resizerSize,
            className: resizerClassName,
            handleClasses: handles,
            handleWrapperClass: (0, $2INqe.handleWrapperClass),
            handleStyles: nextHandleStyles,
            onResizeStart: onResizeStart,
            onResize: onResize,
            onResizeStop: onResizeStop,
            resizeRatio: resizeRatio,
            snapGap: snapGapActual,
            snap: snap,
            handleComponent: handleComponent,
            ...otherProps
        }, t25, t26);
        $[79] = handleComponent;
        $[80] = handles;
        $[81] = nextHandleStyles;
        $[82] = onResize;
        $[83] = onResizeStart;
        $[84] = onResizeStop;
        $[85] = otherProps;
        $[86] = resizeRatio;
        $[87] = resizerClassName;
        $[88] = resizerSize;
        $[89] = snap;
        $[90] = snapGapActual;
        $[91] = t25;
        $[92] = t26;
        $[93] = t27;
    } else t27 = $[93];
    return t27;
} : (props, ref)=>{
    const [isResizing, setIsResizing] = (0, $cozmU.useState)(false);
    const resizable = (0, $cozmU.useRef)(null);
    const resizeHandleThumbRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useImperativeHandle)(ref, ()=>{
        return {
            getResizerThumbEl () {
                return resizeHandleThumbRef.current;
            }
        };
    }, [
        resizeHandleThumbRef
    ]);
    const { width: width, height: height, children: children, handleClassName: handleClassName, className: className, handleResize: handleResize, handleResizeStart: handleResizeStart, handleResizeStop: handleResizeStop, handleSize: handleSize = 'medium', handleAlignmentMethod: handleAlignmentMethod = 'center', handlePositioning: handlePositioning = 'overlap', appearance: appearance, handleStyles: handleStyles, resizeRatio: resizeRatio = 1, snap: snap, snapGap: snapGap, isHandleVisible: isHandleVisible = false, handleHighlight: handleHighlight = 'none', handleTooltipContent: handleTooltipContent, needExtendedResizeZone: needExtendedResizeZone = true, childrenDOMRef: childrenDOMRef, labelComponent: labelComponent, ...otherProps } = props;
    const isDatabasesV2Enabled = (0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) && (0, $ieeJu.expValEquals)('databases-native-embeds-v2', 'isEnabled', true);
    const supportedHandles = isDatabasesV2Enabled ? $4f26ff7de36db2bd$var$SUPPORTED_HANDLES_FOR_VERTICAL_RESIZE : $4f26ff7de36db2bd$var$SUPPORTED_HANDLES;
    const onResizeStart = (0, $cozmU.useCallback)((event)=>{
        // prevent creating a drag event on Firefox
        event.preventDefault();
        setIsResizing(true);
        handleResizeStart();
    }, [
        handleResizeStart
    ]);
    const onResize = (0, $cozmU.useCallback)((_event, direction, _elementRef, delta)=>{
        if (!handleResize) return;
        const resizableCurrent = resizable.current;
        if (!resizableCurrent || !resizableCurrent.state.original) return;
        const originalState = {
            x: resizableCurrent.state.original.x,
            y: resizableCurrent.state.original.y,
            width: resizableCurrent.state.original.width,
            height: resizableCurrent.state.original.height
        };
        if (isDatabasesV2Enabled) handleResize(originalState, delta, direction);
        else handleResize(originalState, delta);
    }, [
        handleResize,
        isDatabasesV2Enabled
    ]);
    const onResizeStop = (0, $cozmU.useCallback)((_event_0, direction_0, _elementRef_0, delta_0)=>{
        const resizableCurrent_0 = resizable.current;
        if (!resizableCurrent_0 || !resizableCurrent_0.state.original) return;
        const originalState_0 = {
            x: resizableCurrent_0.state.original.x,
            y: resizableCurrent_0.state.original.y,
            width: resizableCurrent_0.state.original.width,
            height: resizableCurrent_0.state.original.height
        };
        setIsResizing(false);
        if (isDatabasesV2Enabled) handleResizeStop(originalState_0, delta_0, direction_0);
        else handleResizeStop(originalState_0, delta_0);
    }, [
        handleResizeStop,
        isDatabasesV2Enabled
    ]);
    const handles = (0, $cozmU.useMemo)(()=>supportedHandles.reduce((result, position)=>({
                ...result,
                [position]: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))(handleClassName ?? (0, $2INqe.resizerHandleClassName), position, handleSize, position === 'bottom' && isDatabasesV2Enabled ? undefined : handleAlignmentMethod)
            }), {}), [
        handleClassName,
        handleSize,
        handleAlignmentMethod,
        supportedHandles,
        isDatabasesV2Enabled
    ]);
    const handleWidth = handlePositioning === 'adjacent' ? "var(--ds-space-100, 8px)" : "var(--ds-space-300, 24px)";
    const baseHorizontalHandleStyles = {
        width: handleWidth,
        zIndex: (0, $2INqe.resizerHandleZIndex),
        pointerEvents: 'auto',
        alignItems: handlePositioning === 'adjacent' ? 'center' : undefined
    };
    const baseBottomHandleStyles = {
        height: handleWidth,
        zIndex: (0, $2INqe.resizerHandleZIndex),
        pointerEvents: 'auto',
        justifyContent: handlePositioning === 'adjacent' ? 'center' : undefined
    };
    const memoizedBaseHorizontalHandleStyles = (0, $cozmU.useMemo)(()=>({
            width: handleWidth,
            zIndex: (0, $2INqe.resizerHandleZIndex),
            pointerEvents: 'auto',
            alignItems: handlePositioning === 'adjacent' ? 'center' : undefined
        }), [
        handleWidth,
        handlePositioning
    ]);
    const memoizedBaseBottomHandleStyles = (0, $cozmU.useMemo)(()=>({
            height: handleWidth,
            zIndex: (0, $2INqe.resizerHandleZIndex),
            pointerEvents: 'auto',
            justifyContent: handlePositioning === 'adjacent' ? 'center' : undefined
        }), [
        handleWidth,
        handlePositioning
    ]);
    const offset = handlePositioning === 'adjacent' ? `calc(${handleWidth} * -1)` : `calc(${handleWidth} * -0.5)`;
    const memoizedNextHandleStyles = (0, $cozmU.useMemo)(()=>supportedHandles.reduce((result_0, position_0)=>({
                ...result_0,
                [position_0]: {
                    ...position_0 === 'bottom' ? memoizedBaseBottomHandleStyles : memoizedBaseHorizontalHandleStyles,
                    [position_0]: offset,
                    ...handleStyles?.[position_0]
                }
            }), {}), [
        memoizedBaseBottomHandleStyles,
        memoizedBaseHorizontalHandleStyles,
        offset,
        handleStyles,
        supportedHandles
    ]);
    const nextHandleStyles = (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? memoizedNextHandleStyles : // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- intentional fallback for experiment off path
    supportedHandles.reduce((result_1, position_1)=>({
            ...result_1,
            [position_1]: {
                ...position_1 === 'bottom' ? baseBottomHandleStyles : baseHorizontalHandleStyles,
                [position_1]: offset,
                ...handleStyles?.[position_1]
            }
        }), {});
    const resizerClassName = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))(className, (0, $2INqe.resizerItemClassName), {
        'is-resizing': isResizing,
        'display-handle': isHandleVisible,
        [(0, $2INqe.resizerDangerClassName)]: appearance === 'danger'
    });
    const resizerZoneClassName = (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))((0, $2INqe.resizerHoverZoneClassName), {
        [(0, $2INqe.resizerExtendedZone)]: needExtendedResizeZone
    });
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleComponent = (0, $cozmU.useMemo)(()=>{
        return supportedHandles.reduce((result_2, position_2)=>{
            const thumb = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $2INqe.resizerHandleThumbClassName),
                "data-testid": `resizer-handle-${position_2}-thumb`,
                "aria-label": formatMessage((0, $lFU5S.messages).resizeHandle),
                contentEditable: false,
                ref: resizeHandleThumbRef,
                type: "button",
                tabIndex: -1
            });
            if ((!handleHighlight || handleHighlight === 'none') && !handleTooltipContent) return {
                ...result_2,
                [position_2]: thumb
            };
            const thumbWithTrack = //It's important to have {thumb} element before the div, the thumb element is the one that gets focus and only the 1st element recives aria-descibedby attribute which is important for screen reader users
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, thumb, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))((0, $2INqe.resizerHandleTrackClassName), handleHighlight),
                "data-testid": `resizer-handle-${position_2}-track`
            }));
            if (!!handleTooltipContent) return {
                ...result_2,
                [position_2]: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    contentEditable: false,
                    style: $4f26ff7de36db2bd$var$inheritedCSS
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                    content: handleTooltipContent,
                    hideTooltipOnClick: true,
                    position: "mouse",
                    mousePosition: "auto-start",
                    testId: `resizer-handle-${position_2}-tooltip`
                }, thumbWithTrack))
            };
            return {
                ...result_2,
                [position_2]: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    contentEditable: false,
                    style: $4f26ff7de36db2bd$var$inheritedCSS
                }, thumbWithTrack)
            };
        }, {});
    }, [
        handleHighlight,
        handleTooltipContent,
        formatMessage,
        supportedHandles
    ]);
    // snapGap is usually a constant, if snap.x?.length is 0 and snapGap has a value resizer cannot be resized
    const snapGapActual = (0, $cozmU.useMemo)(()=>{
        if (!snap || snap.x?.length === 0 && snap.y?.length === 0) return undefined;
        return snapGap;
    }, [
        snap,
        snapGap
    ]);
    const resolvedHeight = isDatabasesV2Enabled ? height ?? 'auto' : 'auto';
    const resizerAutoSize = (0, $cozmU.useMemo)(()=>({
            width: width ?? 'auto',
            height: resolvedHeight
        }), [
        resolvedHeight,
        width
    ]);
    const resizerSize = (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? resizerAutoSize : // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- intentional fallback for experiment off path
    {
        width: width ?? 'auto',
        height: resolvedHeight
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9to0k.Resizable), {
        ref: resizable,
        size: resizerSize,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resizerClassName,
        handleClasses: handles,
        handleWrapperClass: (0, $2INqe.handleWrapperClass),
        handleStyles: nextHandleStyles,
        onResizeStart: onResizeStart,
        onResize: onResize,
        onResizeStop: onResizeStop,
        resizeRatio: resizeRatio,
        snapGap: snapGapActual,
        snap: snap,
        handleComponent: handleComponent,
        ...otherProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: resizerZoneClassName,
        ref: (ref_0)=>childrenDOMRef && childrenDOMRef(ref_0)
    }, children), labelComponent && (0, $fqVYq.editorExperiment)('single_column_layouts', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $4f26ff7de36db2bd$var$resizerLabelStyles
    }, labelComponent));
};
const $4f26ff7de36db2bd$var$_default_1 = /*#__PURE__*/ (0, $cozmU.forwardRef)($4f26ff7de36db2bd$var$ResizerNext);
var $4f26ff7de36db2bd$export$2e2bcd8739ae039 = $4f26ff7de36db2bd$var$_default_1;
module.exports["default"] = $4f26ff7de36db2bd$export$2e2bcd8739ae039;

});

parcelRegister("ktOsK", function(module, exports) {

var $4MxIv = parcelRequire("4MxIv");

const $5543285de34730ea$export$5ea7b9558ea477a = (mediaSingleWidth, snapArray, guidelineSnaps, snapGap = 0)=>{
    const closestGapIndex = snapArray.reduce((prev, curr, index)=>Math.abs(curr - mediaSingleWidth) < Math.abs(snapArray[prev] - mediaSingleWidth) ? index : prev, 0);
    const gap = Math.abs(snapArray[closestGapIndex] - mediaSingleWidth);
    if (gap < snapGap) {
        const snappingWidth = snapArray[closestGapIndex];
        const guidelineKeys = [];
        // find wich guideline have the matching snap width
        guidelineSnaps.forEach((gs)=>{
            if (gs.width === snappingWidth) guidelineKeys.push(gs.guidelineKey);
        });
        const defaultGuidelineKeys = guidelineKeys.filter((guidelineKey)=>!guidelineKey.startsWith((0, $4MxIv.MEDIA_DYNAMIC_GUIDELINE_PREFIX)));
        return {
            gap: gap,
            // only highlight default guidelines
            // when there are both default and dynamic guidelines to be highlighted
            keys: defaultGuidelineKeys.length && defaultGuidelineKeys.length < guidelineKeys.length ? defaultGuidelineKeys : guidelineKeys
        };
    }
    return {
        gap: gap,
        keys: []
    };
};
module.exports["findClosestSnap"] = $5543285de34730ea$export$5ea7b9558ea477a;

});

parcelRegister("4MxIv", function(module, exports) {
const $5d595a1d0ebc2224$export$4ff81dc131aec9c3 = 'media_';
const $5d595a1d0ebc2224$export$74e673d6ab2f5668 = 'grid_';
module.exports["MEDIA_DYNAMIC_GUIDELINE_PREFIX"] = $5d595a1d0ebc2224$export$4ff81dc131aec9c3;

});

parcelRegister("b8q5K", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $7Y8M5 = parcelRequire("7Y8M5");


var $9jn2Q = parcelRequire("9jn2Q");


var $cZuBE = parcelRequire("cZuBE");

const $b128b1f13fa0f240$var$getDefaultGuidelines = (0, $dOBRD.default)((editorWidth)=>{
    return [
        -6,
        -5,
        -4,
        -3,
        -2,
        -1,
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ].map((val, index)=>({
            key: `grid_${index}`,
            position: {
                x: (0, $9jn2Q.roundToNearest)(val / 12 * editorWidth)
            }
        }));
});
const $b128b1f13fa0f240$var$getWideGuidelines = (0, $dOBRD.default)((editorWidth)=>{
    const wideSpacing = (0, $9jn2Q.roundToNearest)(editorWidth * (0, $7Y8M5.breakoutWideScaleRatio) / 2);
    return [
        {
            key: `wide_left`,
            position: {
                x: -wideSpacing
            }
        },
        {
            key: `wide_right`,
            position: {
                x: wideSpacing
            }
        }
    ];
});
const $b128b1f13fa0f240$var$getFullWidthGuidelines = (0, $dOBRD.default)((containerWidth)=>{
    const fullWidth = (0, $9jn2Q.roundToNearest)((0, $cZuBE.getContainerWidthOrFullEditorWidth)(containerWidth));
    return [
        {
            key: `full_width_left`,
            position: {
                x: -fullWidth
            }
        },
        {
            key: `full_width_right`,
            position: {
                x: fullWidth
            }
        }
    ];
});
const $b128b1f13fa0f240$export$9e51f24cdc2ab89d = (editorWidth, containerWidth, isFullWidthMode = false)=>{
    const innerGrids = $b128b1f13fa0f240$var$getDefaultGuidelines(editorWidth);
    const wideGuidelines = !isFullWidthMode ? $b128b1f13fa0f240$var$getWideGuidelines(editorWidth) : [];
    const fullWidthGuidelines = !isFullWidthMode ? $b128b1f13fa0f240$var$getFullWidthGuidelines(containerWidth) : [];
    return [
        ...innerGrids,
        ...wideGuidelines,
        ...fullWidthGuidelines
    ];
};
module.exports["generateDefaultGuidelines"] = $b128b1f13fa0f240$export$9e51f24cdc2ab89d;

});

parcelRegister("9jn2Q", function(module, exports) {

var $4G6PK = parcelRequire("4G6PK");

const $c99e056030e8fde6$export$f72673597dacfcfa = (value, interval = (0, $4G6PK.DEFAULT_ROUNDING_INTERVAL))=>Math.round(value / interval) * interval;
module.exports["roundToNearest"] = $c99e056030e8fde6$export$f72673597dacfcfa;

});

parcelRegister("lPlPa", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $11HKG = parcelRequire("11HKG");

const $a5ba1143fa136bb2$export$da9fa72115c158e6 = (0, $dOBRD.default)((guidelines, editorWidth, layout = 'center')=>{
    const offset = editorWidth / 2;
    const getPositionX = (position)=>{
        return (0, $11HKG.isVerticalPosition)(position) ? position.x : 0;
    };
    const calcXSnaps = (guidelineReference)=>{
        const snapsWidth = guidelineReference.filter((g)=>g.width > 0).map((g)=>g.width);
        const uniqueSnapWidth = [
            ...new Set(snapsWidth)
        ];
        return snapsWidth.length ? uniqueSnapWidth : undefined;
    };
    const guidelinesSnapsReference = guidelines.map((guideline)=>{
        const positionX = getPositionX(guideline.position);
        if ([
            'align-end',
            'wrap-right'
        ].includes(layout)) return {
            guidelineKey: guideline.key,
            width: offset - positionX
        };
        else if ([
            'align-start',
            'wrap-left'
        ].includes(layout)) return {
            guidelineKey: guideline.key,
            width: positionX + offset
        };
        return {
            guidelineKey: guideline.key,
            width: Math.abs(positionX) * 2
        };
    });
    return {
        guidelineReference: guidelinesSnapsReference,
        snaps: {
            x: calcXSnaps(guidelinesSnapsReference)
        }
    };
});
module.exports["getGuidelineSnaps"] = $a5ba1143fa136bb2$export$da9fa72115c158e6;

});

parcelRegister("78UMD", function(module, exports) {
const $eff334101a184a3e$var$activeGuidelineStyle = (guideline)=>({
        ...guideline,
        active: true,
        show: true
    });
const $eff334101a184a3e$export$529f80a31b4cd2ac = (gap, maxGap, activeGuidelineKeys, guidelines)=>{
    if (activeGuidelineKeys.length) return guidelines.map((guideline)=>{
        if (activeGuidelineKeys.includes(guideline.key) && gap < maxGap) return $eff334101a184a3e$var$activeGuidelineStyle(guideline);
        return guideline;
    });
    else return guidelines;
};
module.exports["getGuidelinesWithHighlights"] = $eff334101a184a3e$export$529f80a31b4cd2ac;

});

parcelRegister("5ZJRm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");



class $928d71b7a1b056f3$export$3ce634ac4a869e2c extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    componentDidMount() {
        this.mounted = true;
        if (!this.state.Browser) Promise.all([
            (parcelRequire("kLkt4")),
            (parcelRequire("1nIaP"))
        ]).then(([mediaClient, browserModule])=>{
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $928d71b7a1b056f3$export$3ce634ac4a869e2c.Browser = mediaClient.withMediaClient(browserModule.Browser);
            if (this.mounted) this.setState({
                Browser: $928d71b7a1b056f3$export$3ce634ac4a869e2c.Browser
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        if (!this.state.Browser) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(this.state.Browser, this.props);
    }
    constructor(...args){
        super(...args);
        this.mounted = false;
        this.state = {
            Browser: $928d71b7a1b056f3$export$3ce634ac4a869e2c.Browser
        };
    }
}
$928d71b7a1b056f3$export$3ce634ac4a869e2c.displayName = 'AsyncBrowser';
$928d71b7a1b056f3$export$3ce634ac4a869e2c.Browser = void 0;
module.exports["BrowserLoader"] = $928d71b7a1b056f3$export$3ce634ac4a869e2c;

});

parcelRegister("kLkt4", function(module, exports) {

let $f1d812f1385ce421$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f1d812f1385ce421$var$load("6Xt27"),
    $f1d812f1385ce421$var$load("hZ2FX"),
    $f1d812f1385ce421$var$load("fV46K"),
    $f1d812f1385ce421$var$load("kruxh")
]).then(()=>parcelRequire('gB7FN'));

});

parcelRegister("1nIaP", function(module, exports) {

let $101a346a9091f68a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $101a346a9091f68a$var$load("fV46K"),
    $101a346a9091f68a$var$load("6Xt27"),
    $101a346a9091f68a$var$load("6OMo6"),
    $101a346a9091f68a$var$load("aaRXj"),
    $101a346a9091f68a$var$load("fHlIz"),
    $101a346a9091f68a$var$load("4QwAJ"),
    $101a346a9091f68a$var$load("3i44s"),
    $101a346a9091f68a$var$load("5kI0b"),
    $101a346a9091f68a$var$load("kYkz1"),
    $101a346a9091f68a$var$load("jfYeU"),
    $101a346a9091f68a$var$load("b4nm1"),
    $101a346a9091f68a$var$load("geXPZ"),
    $101a346a9091f68a$var$load("aQ5uu"),
    $101a346a9091f68a$var$load("flY2n"),
    $101a346a9091f68a$var$load("jOE2W"),
    $101a346a9091f68a$var$load("jTOhL"),
    $101a346a9091f68a$var$load("5ouIR")
]).then(()=>parcelRequire('e7T2P'));

});

parcelRegister("bXbVP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");




class $21bbc164c3f5497e$export$66201d263cd6342 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    componentDidMount() {
        if (!this.state.Dropzone || !this.state.MediaPickerErrorBoundary) Promise.all([
            (parcelRequire("kLkt4")),
            (parcelRequire("gC0i1")),
            (parcelRequire("OJHVR"))
        ]).then(([mediaClient, dropzoneModule, mediaPickerErrorBoundaryModule])=>{
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $21bbc164c3f5497e$export$66201d263cd6342.Dropzone = mediaClient.withMediaClient(dropzoneModule.Dropzone);
            $21bbc164c3f5497e$export$66201d263cd6342.MediaPickerErrorBoundary = mediaPickerErrorBoundaryModule.default;
            this.setState({
                Dropzone: $21bbc164c3f5497e$export$66201d263cd6342.Dropzone,
                MediaPickerErrorBoundary: $21bbc164c3f5497e$export$66201d263cd6342.MediaPickerErrorBoundary
            });
        }).catch(()=>{
        // TODO [MS-2272]: Add operational error to catch import error
        });
    }
    render() {
        const { Dropzone: Dropzone, MediaPickerErrorBoundary: MediaPickerErrorBoundary } = this.state;
        if (!Dropzone || !MediaPickerErrorBoundary) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(MediaPickerErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Dropzone, this.props));
    }
    constructor(...args){
        super(...args);
        this.state = {
            Dropzone: $21bbc164c3f5497e$export$66201d263cd6342.Dropzone,
            MediaPickerErrorBoundary: $21bbc164c3f5497e$export$66201d263cd6342.MediaPickerErrorBoundary
        };
    }
}
$21bbc164c3f5497e$export$66201d263cd6342.displayName = 'AsyncDropzone';
$21bbc164c3f5497e$export$66201d263cd6342.Dropzone = void 0;
$21bbc164c3f5497e$export$66201d263cd6342.MediaPickerErrorBoundary = void 0;
module.exports["DropzoneLoader"] = $21bbc164c3f5497e$export$66201d263cd6342;

});

parcelRegister("gC0i1", function(module, exports) {

let $c1806b7835b52b1b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c1806b7835b52b1b$var$load("fV46K"),
    $c1806b7835b52b1b$var$load("6Xt27"),
    $c1806b7835b52b1b$var$load("6OMo6"),
    $c1806b7835b52b1b$var$load("aaRXj"),
    $c1806b7835b52b1b$var$load("fHlIz"),
    $c1806b7835b52b1b$var$load("4QwAJ"),
    $c1806b7835b52b1b$var$load("3i44s"),
    $c1806b7835b52b1b$var$load("5kI0b"),
    $c1806b7835b52b1b$var$load("kYkz1"),
    $c1806b7835b52b1b$var$load("jfYeU"),
    $c1806b7835b52b1b$var$load("b4nm1"),
    $c1806b7835b52b1b$var$load("geXPZ"),
    $c1806b7835b52b1b$var$load("aQ5uu"),
    $c1806b7835b52b1b$var$load("flY2n"),
    $c1806b7835b52b1b$var$load("jOE2W"),
    $c1806b7835b52b1b$var$load("jTOhL"),
    $c1806b7835b52b1b$var$load("5FmXP")
]).then(()=>parcelRequire('ex3eO'));

});

parcelRegister("OJHVR", function(module, exports) {

let $098820335a8857e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $098820335a8857e8$var$load("246Cm").then(()=>parcelRequire('AiyH6'));

});

parcelRegister("5I78X", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jv11C = parcelRequire("jv11C");


var $ixfCV = parcelRequire("ixfCV");


var $3xsB6 = parcelRequire("3xsB6");


var $79ir6 = parcelRequire("79ir6");


var $916Gd = parcelRequire("916Gd");


var $cduI2 = parcelRequire("cduI2");


var $d04Ge = parcelRequire("d04Ge");


var $kaATz = parcelRequire("kaATz");


var $1MDPE = parcelRequire("1MDPE");

class $979f07693c6de5f0$export$d353efb45bc662f4 {
    isSyncBlock(node) {
        return this.sourceSyncBlockStoreManager.isSourceBlock(node) || this.referenceSyncBlockStoreManager.isReferenceBlock(node);
    }
    async fetchReferencesSourceInfo(resourceId, blockInstanceId, isSourceSyncBlock) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            this.fetchReferencesExperience?.start();
            const response = await this.dataProvider.fetchReferences(resourceId, isSourceSyncBlock);
            if (response.error) {
                this.fetchReferencesExperience?.failure({
                    reason: response.error
                });
                return {
                    error: response.error
                };
            }
            if (!response.references || response.references?.length === 0) return this.getUnregisteredReferences(resourceId, blockInstanceId, isSourceSyncBlock);
            this.fetchReferencesExperience?.success();
            const sourceInfoPromises = (response.references ?? []).map(async (reference)=>{
                this.fetchSourceInfoExperience?.start();
                const sourceInfo = await this.dataProvider?.fetchSyncBlockSourceInfo(reference.blockInstanceId || '', reference.documentAri, (0, $3xsB6.getProductFromSourceAri)(reference.documentAri), reference.hasAccess);
                if (!sourceInfo) {
                    this.fetchSourceInfoExperience?.failure({
                        reason: `no source info returned for ari: ${reference.documentAri}`
                    });
                    return undefined;
                }
                this.fetchSourceInfoExperience?.success();
                return {
                    ...sourceInfo,
                    onSameDocument: reference.onSameDocument,
                    hasAccess: reference.hasAccess,
                    productType: sourceInfo.productType
                };
            });
            const sourceInfos = await Promise.all(sourceInfoPromises);
            const sourceSyncBlockData = await (isSourceSyncBlock ? this.sourceSyncBlockStoreManager.getSyncBlockSourceInfo(blockInstanceId) : this.referenceSyncBlockStoreManager.fetchSyncBlockSourceInfo(resourceId));
            if (sourceSyncBlockData) sourceInfos.push({
                ...sourceSyncBlockData,
                onSameDocument: Boolean(sourceSyncBlockData?.onSameDocument),
                hasAccess: true,
                isSource: true,
                productType: sourceSyncBlockData?.productType
            });
            return {
                references: sourceInfos
            };
        } catch (error) {
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $916Gd.fetchReferencesErrorPayload)(error.message, resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId)));
            return {
                error: (0, $79ir6.SyncBlockError).Errored
            };
        }
    }
    setFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
        this.referenceSyncBlockStoreManager.setFireAnalyticsEvent(fireAnalyticsEvent);
        this.sourceSyncBlockStoreManager.setFireAnalyticsEvent(fireAnalyticsEvent);
        this.fetchReferencesExperience = (0, $cduI2.getFetchReferencesExperience)(fireAnalyticsEvent);
        this.fetchSourceInfoExperience = (0, $cduI2.getFetchSourceInfoExperience)(fireAnalyticsEvent);
    }
    get referenceManager() {
        return this.referenceSyncBlockStoreManager;
    }
    get sourceManager() {
        return this.sourceSyncBlockStoreManager;
    }
    destroy() {
        this.referenceSyncBlockStoreManager.destroy();
        this.sourceSyncBlockStoreManager.destroy();
        this.fetchReferencesExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fetchSourceInfoExperience?.abort({
            reason: 'editorDestroyed'
        });
    }
    async getUnregisteredReferences(resourceId, blockInstanceId, isSourceSyncBlock) {
        // No reference found
        if (isSourceSyncBlock) {
            // Verify that a reference sync block for this specific source actually
            // exists on the current page by checking if the reference manager has
            // an active subscription for the derived reference resourceId.
            const referenceResourceId = this.referenceSyncBlockStoreManager.generateResourceIdForReference(resourceId);
            const hasUnregisteredReferenceOnPage = this.referenceSyncBlockStoreManager.getSubscribedResourceIds().includes(referenceResourceId);
            if (hasUnregisteredReferenceOnPage) {
                // This is current page data. It is the same for data for source and reference
                const sourceSyncBlockData = await this.sourceSyncBlockStoreManager.getSyncBlockSourceInfo(blockInstanceId);
                const references = [];
                if (sourceSyncBlockData) {
                    const sourceSyncBlockReference = {
                        ...sourceSyncBlockData,
                        onSameDocument: true,
                        hasAccess: true,
                        isSource: true
                    };
                    const referenceSyncBlockReference = {
                        ...sourceSyncBlockData,
                        onSameDocument: true,
                        hasAccess: true,
                        isSource: false
                    };
                    references.push(sourceSyncBlockReference, referenceSyncBlockReference);
                }
                this.fetchReferencesExperience?.success();
                return {
                    references: references
                };
            }
            // No remote or local reference exists — show info text with link to doco on how to use Synced Blocks
            this.fetchReferencesExperience?.success();
            return {
                references: []
            };
        }
        // Though no references registered yet for this reference sync block,
        // still show the source and the current page itself since they are known
        // but not saved yet.
        const references = [];
        const sourceSyncBlockData = await this.referenceSyncBlockStoreManager.fetchSyncBlockSourceInfo(resourceId);
        if (sourceSyncBlockData) references.push({
            ...sourceSyncBlockData,
            onSameDocument: Boolean(sourceSyncBlockData?.onSameDocument),
            hasAccess: true,
            isSource: true
        });
        const currentPageData = await this.referenceSyncBlockStoreManager.fetchSyncBlockSourceInfoByLocalId(blockInstanceId);
        if (currentPageData) references.push({
            ...currentPageData,
            onSameDocument: true,
            hasAccess: true,
            isSource: false
        });
        if (references.length === 0) {
            this.fetchReferencesExperience?.failure({
                reason: 'No references found for reference synced block'
            });
            return {
                error: (0, $79ir6.SyncBlockError).Errored
            };
        }
        this.fetchReferencesExperience?.success();
        return {
            references: references
        };
    }
    constructor(dataProvider, viewMode, isLivePage){
        this.referenceSyncBlockStoreManager = void 0;
        this.sourceSyncBlockStoreManager = void 0;
        this.dataProvider = void 0;
        this.fireAnalyticsEvent = void 0;
        this.fetchReferencesExperience = void 0;
        this.fetchSourceInfoExperience = void 0;
        // In future, if reference manager needs to reach to source manager and read its current in memory cache
        // we can pass the source manager as a parameter to the reference manager constructor
        this.sourceSyncBlockStoreManager = new (0, $1MDPE.SourceSyncBlockStoreManager)(dataProvider, viewMode, isLivePage);
        this.referenceSyncBlockStoreManager = new (0, $kaATz.ReferenceSyncBlockStoreManager)(dataProvider, viewMode);
        this.dataProvider = dataProvider;
        this.referenceSyncBlockStoreManager.setRealTimeSubscriptionsEnabled(true);
    }
}
const $979f07693c6de5f0$var$createSyncBlockStoreManager = (dataProvider)=>{
    return new $979f07693c6de5f0$export$d353efb45bc662f4(dataProvider);
};
const $979f07693c6de5f0$export$d95b04bc16414394 = (dataProvider, fireAnalyticsEvent)=>{
    const syncBlockStoreManager = (0, $cozmU.useMemo)(()=>{
        return $979f07693c6de5f0$var$createSyncBlockStoreManager(dataProvider);
    }, [
        dataProvider
    ]);
    const prevFireAnalyticsEventRef = (0, $cozmU.useRef)(undefined);
    if (fireAnalyticsEvent !== prevFireAnalyticsEventRef.current) {
        prevFireAnalyticsEventRef.current = fireAnalyticsEvent;
        syncBlockStoreManager.setFireAnalyticsEvent(fireAnalyticsEvent);
    }
    // Gated by platform_synced_block_patch_14:
    // Destroy the SyncBlockStoreManager when:
    //   (a) the component unmounts — manager is fully cleaned up, or
    //   (b) dataProvider changes — the old manager (now orphaned by the
    //       useMemo recalculation) is destroyed before the new one takes over.
    //
    // Without this, orphaned managers leak timers, GQL subscriptions, and
    // in-flight fetches indefinitely. The effect dep is `syncBlockStoreManager`
    // (the useMemo result) — it changes identity precisely when dataProvider
    // changes, triggering the cleanup for the old instance.
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if ((0, $ixfCV.fg)('platform_synced_block_patch_14')) syncBlockStoreManager.destroy();
        };
    }, [
        syncBlockStoreManager
    ]);
    return syncBlockStoreManager;
};
module.exports["SyncBlockStoreManager"] = $979f07693c6de5f0$export$d353efb45bc662f4;
module.exports["useMemoizedSyncBlockStoreManager"] = $979f07693c6de5f0$export$d95b04bc16414394;

});

parcelRegister("cduI2", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $dp5Fv = parcelRequire("dp5Fv");

var $ezEf7 = parcelRequire("ezEf7");

var $6NW7h = parcelRequire("6NW7h");

const $5b2ece5cdbe51ebe$var$TIMEOUT_DURATION = 30000;
const $5b2ece5cdbe51ebe$export$b335cfa3334e49e6 = (fireAnalyticsEvent)=>{
    return (payload)=>{
        // Runtime type guard - only forward experience events
        if (payload.action === (0, $krYZG.ACTION).EXPERIENCE_MEASURED || payload.action === (0, $krYZG.ACTION).EXPERIENCE_SAMPLED) fireAnalyticsEvent?.(payload);
    };
};
const $5b2ece5cdbe51ebe$export$553df56755696c09 = (fireAnalyticsEvent)=>{
    return new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $krYZG.ACTION).SYNCED_BLOCK_UPDATE,
        dispatchAnalyticsEvent: $5b2ece5cdbe51ebe$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $5b2ece5cdbe51ebe$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $5b2ece5cdbe51ebe$export$188e7890e84f55e4 = (fireAnalyticsEvent)=>{
    return new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $krYZG.ACTION).REFERENCE_SYNCED_BLOCK_UPDATE,
        dispatchAnalyticsEvent: $5b2ece5cdbe51ebe$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $5b2ece5cdbe51ebe$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $5b2ece5cdbe51ebe$export$bbbbcdec37b3c0c0 = (fireAnalyticsEvent)=>{
    return new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $krYZG.ACTION).SYNCED_BLOCK_FETCH,
        dispatchAnalyticsEvent: $5b2ece5cdbe51ebe$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $5b2ece5cdbe51ebe$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $5b2ece5cdbe51ebe$export$cf32ad2bf7484097 = (fireAnalyticsEvent)=>{
    return new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $krYZG.ACTION).SYNCED_BLOCK_GET_SOURCE_INFO,
        dispatchAnalyticsEvent: $5b2ece5cdbe51ebe$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $5b2ece5cdbe51ebe$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $5b2ece5cdbe51ebe$export$666920a07aaa7d43 = (fireAnalyticsEvent)=>{
    return new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $krYZG.ACTION).SYNCED_BLOCK_DELETE,
        dispatchAnalyticsEvent: $5b2ece5cdbe51ebe$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $5b2ece5cdbe51ebe$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $5b2ece5cdbe51ebe$export$bf943e4a2bda18f6 = (fireAnalyticsEvent)=>{
    return new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $krYZG.ACTION).SYNCED_BLOCK_CREATE,
        dispatchAnalyticsEvent: $5b2ece5cdbe51ebe$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $5b2ece5cdbe51ebe$var$TIMEOUT_DURATION
            })
        ]
    });
};
const $5b2ece5cdbe51ebe$export$3ba8782eb93c9adf = (fireAnalyticsEvent)=>{
    return new (0, $dp5Fv.Experience)((0, $ezEf7.EXPERIENCE_ID).ASYNC_OPERATION, {
        action: (0, $krYZG.ACTION).SYNCED_BLOCK_FETCH_REFERENCES,
        dispatchAnalyticsEvent: $5b2ece5cdbe51ebe$export$b335cfa3334e49e6(fireAnalyticsEvent),
        checks: [
            new (0, $6NW7h.ExperienceCheckTimeout)({
                durationMs: $5b2ece5cdbe51ebe$var$TIMEOUT_DURATION
            })
        ]
    });
};
module.exports["getSaveSourceExperience"] = $5b2ece5cdbe51ebe$export$553df56755696c09;
module.exports["getSaveReferenceExperience"] = $5b2ece5cdbe51ebe$export$188e7890e84f55e4;
module.exports["getFetchExperience"] = $5b2ece5cdbe51ebe$export$bbbbcdec37b3c0c0;
module.exports["getFetchSourceInfoExperience"] = $5b2ece5cdbe51ebe$export$cf32ad2bf7484097;
module.exports["getDeleteSourceExperience"] = $5b2ece5cdbe51ebe$export$666920a07aaa7d43;
module.exports["getCreateSourceExperience"] = $5b2ece5cdbe51ebe$export$bf943e4a2bda18f6;
module.exports["getFetchReferencesExperience"] = $5b2ece5cdbe51ebe$export$3ba8782eb93c9adf;

});

parcelRegister("kaATz", function(module, exports) {

var $3u5lg = parcelRequire("3u5lg");


var $jv11C = parcelRequire("jv11C");


var $ixfCV = parcelRequire("ixfCV");


var $79ir6 = parcelRequire("79ir6");


var $916Gd = parcelRequire("916Gd");


var $cduI2 = parcelRequire("cduI2");


var $8kkvD = parcelRequire("8kkvD");


var $d04Ge = parcelRequire("d04Ge");


var $f9GoL = parcelRequire("f9GoL");


var $3ZV9H = parcelRequire("3ZV9H");


var $8d6F6 = parcelRequire("8d6F6");


var $dWaXQ = parcelRequire("dWaXQ");

const $300c2e48dc416b36$var$CACHE_KEY_PREFIX = 'sync-block-data-';
const $300c2e48dc416b36$var$ENTITY_NOT_FOUND_MAX_RETRIES = 3;
const $300c2e48dc416b36$var$ENTITY_NOT_FOUND_INITIAL_DELAY_MS = 2000;
// Grace period before a cache entry is removed after the last subscriber
// unsubscribes (gated by `platform_synced_block_patch_14`). Guards are
// re-checked at fire time; if any are positive, the timer is rescheduled.
const $300c2e48dc416b36$var$CACHE_DELETION_GRACE_PERIOD_MS = 30000;
// Max reschedules before force-deleting with an analytics event (~5 min).
const $300c2e48dc416b36$var$CACHE_DELETION_MAX_RESCHEDULES = 10;
class $300c2e48dc416b36$export$fb04276dca31302e {
    isReferenceBlock(node) {
        return node.type.name === 'syncBlock';
    }
    /**
   * Whether the async data provider is wired and the manager is not torn down.
   * Consumers gate fetch/subscribe on this to avoid a false `Data provider not
   * set` fetch error (EDITOR-7860). The `isDestroyed` check covers managers
   * orphaned mid-flight during an async provider swap, where `dataProvider`
   * alone is insufficient.
   */ hasDataProvider() {
        return !this.isDestroyed && !!this.dataProvider;
    }
    /**
   * Enables or disables real-time GraphQL subscriptions for block updates.
   * When enabled, the store manager will subscribe to real-time updates
   * instead of relying on polling.
   * @param enabled - Whether to enable real-time subscriptions
   */ setRealTimeSubscriptionsEnabled(enabled) {
        this._subscriptionManager.setRealTimeSubscriptionsEnabled(enabled);
    }
    /**
   * Checks if real-time subscriptions are currently enabled.
   */ isRealTimeSubscriptionsEnabled() {
        return this._subscriptionManager.isRealTimeSubscriptionsEnabled();
    }
    /**
   * Returns all resource IDs that are currently subscribed to.
   * Used by React components to render subscription components.
   */ getSubscribedResourceIds() {
        return this._subscriptionManager.getSubscribedResourceIds();
    }
    /**
   * Registers a listener that will be called when subscriptions change.
   * @param listener - Callback function to invoke when subscriptions change
   * @returns Unsubscribe function to remove the listener
   */ onSubscriptionsChanged(listener) {
        return this._subscriptionManager.onSubscriptionsChanged(listener);
    }
    /**
   * Handles incoming data from a GraphQL subscription.
   * Called by React subscription components when they receive updates.
   * @param syncBlockInstance - The updated sync block instance
   */ handleSubscriptionUpdate(syncBlockInstance) {
        this._subscriptionManager.handleSubscriptionUpdate(syncBlockInstance);
    }
    setFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
        this.fetchExperience = (0, $cduI2.getFetchExperience)(fireAnalyticsEvent);
        this.fetchSourceInfoExperience = (0, $cduI2.getFetchSourceInfoExperience)(fireAnalyticsEvent);
        this.saveExperience = (0, $cduI2.getSaveReferenceExperience)(fireAnalyticsEvent);
    }
    setOnUnpublishedSyncBlockDetected(callback) {
        this.onUnpublishedSyncBlockDetected = callback;
    }
    /**
   * Mark a sync block as newly added to the document.
   * This should be called when a sync block node is added via a transaction.
   * @param resourceId - The resource ID of the newly added sync block
   */ markAsNewlyAdded(resourceId) {
        this.newlyAddedSyncBlocks.add(resourceId);
    }
    generateResourceIdForReference(sourceId) {
        if (!this.dataProvider) throw new Error('Data provider not set');
        return this.dataProvider.generateResourceIdForReference(sourceId);
    }
    updateFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
    }
    getInitialSyncBlockData(resourceId) {
        const syncBlockNode = (0, $d04Ge.createSyncBlockNode)('', resourceId);
        const providerData = this.dataProvider?.getNodeDataFromCache(syncBlockNode)?.data;
        if (providerData) // Initial provider cache data can come from SSR/prefetch and bypass updateCache(),
        // so normalize legacy reference payloads here before rendering.
        return this.normalizeReferenceData(providerData);
        return this.getFromSessionCache(resourceId);
    }
    normalizeReferenceData(syncBlock) {
        if (!syncBlock.data?.content?.length) return syncBlock;
        const content = (0, $d04Ge.normalizeSyncBlockJSONContent)(syncBlock.data.content);
        if (content === syncBlock.data.content) return syncBlock;
        return {
            ...syncBlock,
            data: {
                ...syncBlock.data,
                content: content
            }
        };
    }
    updateSessionCache(resourceId) {
        const latestData = this.getFromCache(resourceId);
        if (latestData) (0, $3ZV9H.syncBlockInMemorySessionCache).setItem(`${$300c2e48dc416b36$var$CACHE_KEY_PREFIX}${resourceId}`, JSON.stringify(latestData));
    }
    getFromSessionCache(resourceId) {
        try {
            const raw = (0, $3ZV9H.syncBlockInMemorySessionCache).getItem(`${$300c2e48dc416b36$var$CACHE_KEY_PREFIX}${resourceId}`);
            if (!raw) return undefined;
            // Session cache entries written before this sanitizer existed may still include
            // annotation marks or panel_c1 nodes, so keep this read-time safety net for legacy data.
            return this.normalizeReferenceData(JSON.parse(raw));
        } catch (error) {
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/getFromSessionCache'
            });
            return undefined;
        }
    }
    fetchSyncBlockSourceInfoBySourceAri(sourceAri, hasAccess = true) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            const sourceInfo = this.dataProvider.fetchSyncBlockSourceInfo(undefined, sourceAri, undefined, hasAccess);
            return sourceInfo;
        } catch (error) {
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/fetchSyncBlockSourceInfoBySourceAri'
            });
            this.fireAnalyticsEvent?.((0, $916Gd.getSourceInfoErrorPayload)(error.message));
            return Promise.resolve(undefined);
        }
    }
    fetchSyncBlockSourceInfoByLocalId(localId, hasAccess = true) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            return this.dataProvider.fetchSyncBlockSourceInfo(localId, undefined, undefined, hasAccess);
        } catch (error) {
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/fetchSyncBlockSourceInfoByLocalId'
            });
            this.fireAnalyticsEvent?.((0, $916Gd.getSourceInfoErrorPayload)(error.message));
            return Promise.resolve(undefined);
        }
    }
    fetchSyncBlockSourceInfo(resourceId) {
        try {
            if (!resourceId || !this.dataProvider) throw new Error('Data provider or resourceId not set');
            const existingRequest = this.syncBlockSourceInfoRequests.get(resourceId);
            if (existingRequest) return existingRequest;
            const existingSyncBlock = this.getFromCache(resourceId);
            if (!existingSyncBlock) throw new Error('No existing sync block to fetch source info for');
            const { sourceAri: sourceAri, product: product, blockInstanceId: blockInstanceId, sourceURL: sourceURL, sourceTitle: sourceTitle, onSameDocument: onSameDocument, sourceSubType: sourceSubType, issueType: issueType } = existingSyncBlock.data || {};
            // skip if source URL and title are already present
            if (sourceURL && sourceTitle) return Promise.resolve({
                title: sourceTitle,
                url: sourceURL,
                subType: sourceSubType,
                sourceAri: sourceAri || '',
                onSameDocument: onSameDocument,
                productType: product,
                issueType: issueType
            });
            // Derive once per call so we don't re-parse on every analytics event below.
            // `product` from cached data is preferred when available; fall back to parsing
            // the resourceId.
            const sourceProduct = product ?? (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId);
            if (!sourceAri || !product || !blockInstanceId) {
                this.fireAnalyticsEvent?.((0, $916Gd.getSourceInfoErrorPayload)('SourceAri, product or blockInstanceId missing', resourceId, sourceProduct));
                return Promise.resolve(undefined);
            }
            this.fetchSourceInfoExperience?.start({});
            const sourceInfoPromise = this.dataProvider.fetchSyncBlockSourceInfo(blockInstanceId, sourceAri, product, true // hasAccess
            ).then((sourceInfo)=>{
                if (!sourceInfo) {
                    this.fetchSourceInfoExperience?.failure({
                        reason: 'No source info returned'
                    });
                    this.fireAnalyticsEvent?.((0, $916Gd.getSourceInfoErrorPayload)('No source info returned', resourceId, sourceProduct));
                    return undefined;
                }
                this.updateCacheWithSourceInfo(resourceId, sourceInfo);
                if (sourceInfo.title) this._subscriptionManager.updateSourceTitleSubscriptions(resourceId, sourceInfo.title);
                if (sourceInfo.title && sourceInfo.url) this.fetchSourceInfoExperience?.success();
                else {
                    this.fetchSourceInfoExperience?.failure({
                        reason: 'Missing title or url'
                    });
                    this.fireAnalyticsEvent?.((0, $916Gd.getSourceInfoErrorPayload)('Missing title or url', resourceId, sourceProduct));
                }
                return sourceInfo;
            }).catch((error)=>{
                this.fetchSourceInfoExperience?.failure({
                    reason: error.message
                });
                this.fireAnalyticsEvent?.((0, $916Gd.getSourceInfoErrorPayload)(error.message, resourceId, sourceProduct));
                return undefined;
            }).finally(()=>{
                this.syncBlockSourceInfoRequests.delete(resourceId);
            });
            this.syncBlockSourceInfoRequests.set(resourceId, sourceInfoPromise);
            return sourceInfoPromise;
        } catch (error) {
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $916Gd.getSourceInfoErrorPayload)(error.message, resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId)));
        }
        return Promise.resolve(undefined);
    }
    /**
   * Processes prefetched data and updates the cache.
   * @param prefetchedData - The prefetched data to process
   * @returns {Promise<void>}
   */ async processPrefetchedData(prefetchedData) {
        if (!prefetchedData) return;
        // start the fetch experience (this should be started much earlier to properly track performance, but better late than never)
        this.fetchExperience?.start({});
        // mark the sync block requests as in fly
        prefetchedData.resourceIds.forEach((resourceId)=>{
            this.syncBlockFetchDataRequests.set(resourceId, true);
        });
        try {
            const prefetchedResolvedData = await prefetchedData.prefetchPromise;
            const { hasUnexpectedError: hasUnexpectedError, hasExpectedError: hasExpectedError } = this.processFetchedData(prefetchedResolvedData);
            if (hasUnexpectedError) this.fetchExperience?.failure({
                reason: 'Unexpected error during prefetch'
            });
            else if (hasExpectedError) this.fetchExperience?.abort({
                reason: 'Expected error: NotFound or PermissionDenied during prefetch'
            });
            else this.fetchExperience?.success();
        } catch (error) {
            this.fetchExperience?.failure({
                reason: `Prefetch promise rejected: ${error.message}`
            });
        } finally{
            // Clean up in-flight markers so subsequent fetches are not blocked
            prefetchedData.resourceIds.forEach((resourceId)=>{
                this.syncBlockFetchDataRequests.delete(resourceId);
            });
        }
    }
    /**
   * Fetch sync block data for a given array of sync block nodes.
   * @param syncBlockNodes - The array of sync block nodes to fetch data for
   * @returns The fetched sync block data results
   */ async fetchSyncBlocksData(syncBlockNodes) {
        if (syncBlockNodes.length === 0) return;
        // Don't fetch for not_found error since the source is already deleted
        const nodesToFetch = [];
        syncBlockNodes.forEach((node)=>{
            if (this.syncBlockFetchDataRequests.get(node.attrs.resourceId)) return;
            const existingSyncBlock = this.getFromCache(node.attrs.resourceId);
            if (existingSyncBlock?.error?.type === (0, $79ir6.SyncBlockError).NotFound) return;
            nodesToFetch.push(node);
        });
        if (nodesToFetch.length === 0) return;
        if (!this.dataProvider) {
            // EDITOR-7860: tag the throw so catch sites can suppress the benign
            // not-ready/torn-down case. Gate-off keeps the legacy throw + message.
            if ((0, $ixfCV.fg)('platform_editor_blocks_patch_3')) throw new (0, $79ir6.ProviderNotReadyError)();
            throw new Error('Data provider not set');
        }
        nodesToFetch.forEach((node)=>{
            this.syncBlockFetchDataRequests.set(node.attrs.resourceId, true);
        });
        this.fetchExperience?.start({});
        const data = await this.dataProvider.fetchNodesData(nodesToFetch).finally(()=>{
            nodesToFetch.forEach((node)=>{
                this.syncBlockFetchDataRequests.delete(node.attrs.resourceId);
            });
        });
        const { hasUnexpectedError: hasUnexpectedError, hasExpectedError: hasExpectedError } = this.processFetchedData(data);
        if (hasUnexpectedError) this.fetchExperience?.failure({
            reason: 'Unexpected error during fetch'
        });
        else if (hasExpectedError) this.fetchExperience?.abort({
            reason: 'Expected error: NotFound or PermissionDenied'
        });
        else this.fetchExperience?.success();
    }
    processFetchedData(data) {
        if (!data) return {
            hasUnexpectedError: false,
            hasExpectedError: false
        };
        let hasUnexpectedError = false;
        let hasExpectedError = false;
        data.forEach((syncBlockInstance)=>{
            if (!syncBlockInstance.resourceId) {
                const payload = syncBlockInstance.error?.reason || syncBlockInstance.error?.type || 'Returned sync block instance does not have resource id';
                // No resourceId means we cannot derive a sourceProduct here; intentionally omit.
                // Classify on the structured `type` first, falling back to the free-text
                // `reason`/payload (EDITOR-7862).
                this.fireAnalyticsEvent?.((0, $916Gd.fetchErrorPayload)(payload, undefined, undefined, (0, $916Gd.buildFetchErrorAttribution)((0, $ixfCV.fg)('platform_editor_blocks_patch_3'), syncBlockInstance.error?.type || syncBlockInstance.error?.reason || payload, syncBlockInstance.error?.statusCode)));
                return;
            }
            const existingSyncBlock = this.getFromCache(syncBlockInstance.resourceId);
            const resolvedSyncBlockInstance = existingSyncBlock ? (0, $8kkvD.resolveSyncBlockInstance)(existingSyncBlock, syncBlockInstance) : syncBlockInstance;
            this.updateCache(resolvedSyncBlockInstance);
            // Check if this is a newly added unpublished sync block and notify
            // Only trigger for sync blocks that were just added (not refreshed or loaded on page init)
            if (!syncBlockInstance.error && resolvedSyncBlockInstance.data?.status === 'unpublished' && this.newlyAddedSyncBlocks.has(syncBlockInstance.resourceId) && this.onUnpublishedSyncBlockDetected) {
                // Remove from newly added set after checking to prevent duplicate flags
                this.newlyAddedSyncBlocks.delete(syncBlockInstance.resourceId);
                this.onUnpublishedSyncBlockDetected(resolvedSyncBlockInstance.resourceId);
            } else if (this.newlyAddedSyncBlocks.has(syncBlockInstance.resourceId)) // Remove from newly added set even if not unpublished (to clean up)
            this.newlyAddedSyncBlocks.delete(syncBlockInstance.resourceId);
            // Clear retry tracking on successful fetch — block has been created
            if (!syncBlockInstance.error && this.entityNotFoundRetryCount.has(syncBlockInstance.resourceId)) {
                const timer = this.entityNotFoundRetryTimers.get(syncBlockInstance.resourceId);
                if (timer) {
                    clearTimeout(timer);
                    this.entityNotFoundRetryTimers.delete(syncBlockInstance.resourceId);
                }
                this.entityNotFoundRetryCount.delete(syncBlockInstance.resourceId);
            }
            if (syncBlockInstance.error) {
                // Skip error analytics when EntityNotFound will be retried, to avoid
                // inflating error-rate metrics with expected transient failures
                const isRetryingEntityNotFound = syncBlockInstance.error.type === (0, $79ir6.SyncBlockError).EntityNotFound && (this.entityNotFoundRetryCount.get(syncBlockInstance.resourceId) ?? 0) < $300c2e48dc416b36$var$ENTITY_NOT_FOUND_MAX_RETRIES && (0, $ixfCV.fg)('platform_synced_block_patch_13');
                if (!isRetryingEntityNotFound) // Classify on the structured `type` (a `SyncBlockError` enum value) first,
                // falling back to the free-text `reason` so source-state/permission strings
                // are still bucketed (EDITOR-7862). The emitted `error` attribute is unchanged.
                this.fireAnalyticsEvent?.((0, $916Gd.fetchErrorPayload)(syncBlockInstance.error.reason || syncBlockInstance.error.type, syncBlockInstance.resourceId, syncBlockInstance.data?.product ?? (0, $d04Ge.getSourceProductFromResourceIdSafe)(syncBlockInstance.resourceId), (0, $916Gd.buildFetchErrorAttribution)((0, $ixfCV.fg)('platform_editor_blocks_patch_3'), syncBlockInstance.error.type || syncBlockInstance.error.reason, syncBlockInstance.error.statusCode)));
                if (syncBlockInstance.error.type === (0, $79ir6.SyncBlockError).NotFound || syncBlockInstance.error.type === (0, $79ir6.SyncBlockError).Forbidden) hasExpectedError = true;
                else if (syncBlockInstance.error.type === (0, $79ir6.SyncBlockError).EntityNotFound) {
                    // Schedule a retry for EntityNotFound — the source block may be in
                    // the process of being created by a collaborator (race condition
                    // between NCS propagation and Block Service createBlock call).
                    if ((0, $ixfCV.fg)('platform_synced_block_patch_13')) this.scheduleEntityNotFoundRetry(syncBlockInstance.resourceId);
                    if (!isRetryingEntityNotFound) hasUnexpectedError = true;
                } else if (syncBlockInstance.error) hasUnexpectedError = true;
                return;
            }
            const callbacks = this._subscriptionManager.getSubscriptions().get(syncBlockInstance.resourceId);
            const localIds = callbacks ? Object.keys(callbacks) : [];
            localIds.forEach((localId)=>{
                this.fireAnalyticsEvent?.((0, $916Gd.fetchSuccessPayload)(syncBlockInstance.resourceId, localId, syncBlockInstance.data?.product ?? (0, $d04Ge.getSourceProductFromResourceIdSafe)(syncBlockInstance.resourceId)));
            });
            this.fetchSyncBlockSourceInfo(resolvedSyncBlockInstance.resourceId);
        });
        return {
            hasUnexpectedError: hasUnexpectedError,
            hasExpectedError: hasExpectedError
        };
    }
    updateCacheWithSourceInfo(resourceId, sourceInfo) {
        const existingSyncBlock = this.getFromCache(resourceId);
        // If the cache entry was deleted while the source-info request was
        // in flight, fire an analytics event so the race is observable.
        if (!existingSyncBlock && (0, $ixfCV.fg)('platform_synced_block_patch_14')) {
            this.fireAnalyticsEvent?.((0, $916Gd.sourceInfoOrphanedPayload)(resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId), {
                hasPendingDeletion: this.pendingCacheDeletions.has(resourceId),
                hasSubscribers: this._subscriptionManager.getSubscriptions().has(resourceId)
            }));
            (0, $jv11C.logException)(new Error('updateCacheWithSourceInfo: cache entry missing for resource'), {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/orphaned-source-info'
            });
            return;
        }
        if (existingSyncBlock && existingSyncBlock.data) {
            existingSyncBlock.data.sourceURL = sourceInfo?.url;
            existingSyncBlock.data = {
                ...existingSyncBlock.data,
                sourceURL: sourceInfo?.url,
                sourceTitle: sourceInfo?.title,
                onSameDocument: sourceInfo?.onSameDocument,
                sourceSubType: sourceInfo?.subType,
                issueType: sourceInfo?.issueType
            };
            this.updateCache(existingSyncBlock);
        }
    }
    updateCache(syncBlock) {
        const sanitizedSyncBlock = this.normalizeReferenceData(syncBlock);
        const { resourceId: resourceId } = sanitizedSyncBlock;
        if (resourceId) {
            this.dataProvider?.updateCache({
                [resourceId]: sanitizedSyncBlock
            }, {
                strategy: 'merge',
                source: 'network'
            });
            this._subscriptionManager.notifySubscriptionCallbacks(resourceId, sanitizedSyncBlock);
            this.updateSessionCache(resourceId);
        }
    }
    getFromCache(resourceId) {
        const syncBlockNode = (0, $d04Ge.createSyncBlockNode)('', resourceId);
        return this.dataProvider?.getNodeDataFromCache(syncBlockNode)?.data;
    }
    deleteFromCache(resourceId) {
        this.dataProvider?.removeFromCache([
            resourceId
        ]);
        this._providerFactoryManager.deleteFactory(resourceId);
        // Evict in-flight source-info promise and reset reschedule counter
        // so a stale resolution can't silently merge into a re-fetched entry.
        if ((0, $ixfCV.fg)('platform_synced_block_patch_14')) {
            this.syncBlockSourceInfoRequests.delete(resourceId);
            this.cacheDeletionRescheduleCounts.delete(resourceId);
        }
    }
    /**
   * Returns true if the cache entry for `resourceId` is safe to delete:
   * no active subscribers, no in-flight source-info request, and no
   * queued/in-flight batch fetch (gated by `platform_synced_block_patch_14`).
   */ canDeleteCache(resourceId) {
        if (this._subscriptionManager.getSubscriptions().has(resourceId)) return false;
        if (this.syncBlockSourceInfoRequests.has(resourceId)) return false;
        if (this._batchFetcher.hasPendingFetch(resourceId)) return false;
        return true;
    }
    /**
   * Schedules cache deletion for `resourceId` after the grace period
   * (gated by `platform_synced_block_patch_14`). Called when the last
   * subscriber unsubscribes. Guards are re-checked at fire time; if any
   * are positive the timer is rescheduled up to MAX_RESCHEDULES times.
   */ scheduleCacheDeletion(resourceId) {
        if (!(0, $ixfCV.fg)('platform_synced_block_patch_14')) return;
        if (this.isDestroyed) return;
        // Cancel any existing timer \u2014 restart the grace period \u2014 but DO NOT
        // reset the reschedule counter. The counter is reset only by
        // `cancelPendingCacheDeletion` (called when a real subscriber returns)
        // or when the cache is actually deleted.
        const existing = this.pendingCacheDeletions.get(resourceId);
        if (existing) {
            clearTimeout(existing);
            this.pendingCacheDeletions.delete(resourceId);
        }
        const timer = setTimeout(()=>{
            // Guard against timer callback running after destroy. clearTimeout
            // is synchronous so this should be unreachable in practice, but
            // belt-and-braces.
            if (this.isDestroyed) return;
            this.pendingCacheDeletions.delete(resourceId);
            this.onCacheDeletionTimerFire(resourceId);
        }, $300c2e48dc416b36$var$CACHE_DELETION_GRACE_PERIOD_MS);
        this.pendingCacheDeletions.set(resourceId, timer);
    }
    /**
   * Cancels any pending cache deletion timer for `resourceId` and resets the
   * reschedule counter (gated by `platform_synced_block_patch_14`). Called
   * when a new subscriber arrives.
   */ cancelPendingCacheDeletion(resourceId) {
        if (!(0, $ixfCV.fg)('platform_synced_block_patch_14')) return;
        const existing = this.pendingCacheDeletions.get(resourceId);
        if (existing) {
            clearTimeout(existing);
            this.pendingCacheDeletions.delete(resourceId);
        }
        // Subscribers returning resets the reschedule counter \u2014 the resource is
        // active again.
        this.cacheDeletionRescheduleCounts.delete(resourceId);
    }
    /** Returns whether a cache deletion timer is pending for `resourceId`. */ hasPendingCacheDeletion(resourceId) {
        return this.pendingCacheDeletions.has(resourceId);
    }
    onCacheDeletionTimerFire(resourceId) {
        if (this.canDeleteCache(resourceId)) {
            // `deleteFromCache` resets the reschedule counter under the flag.
            this.deleteFromCache(resourceId);
            return;
        }
        const currentCount = this.cacheDeletionRescheduleCounts.get(resourceId) ?? 0;
        if (currentCount >= $300c2e48dc416b36$var$CACHE_DELETION_MAX_RESCHEDULES) {
            // Stuck guard — force deletion to prevent unbounded memory growth and
            // fire analytics so the stuck state is visible in production telemetry.
            //
            // NOTE: If active React subscribers still exist at force-delete time
            // (e.g. an in-flight batch fetch never settled), the cache entry is
            // removed without notifying subscribers. Those components will
            // continue to render with stale data until their next re-render
            // triggers a new batch fetch — typically within ~1 frame. We accept
            // this brief stale window in exchange for bounded memory growth.
            this.fireAnalyticsEvent?.((0, $916Gd.cacheDeletionForcedPayload)(currentCount, resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId)));
            (0, $jv11C.logException)(new Error(`Cache deletion forced after ${currentCount} reschedules \u{2014} stuck in-flight guard`), {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager/cache-deletion-forced'
            });
            // `deleteFromCache` resets the reschedule counter under the flag.
            this.deleteFromCache(resourceId);
            // If subscribers still exist, kick off a fresh fetch so they get
            // fresh data on the next batch tick instead of holding stale data
            // indefinitely.
            if (this._subscriptionManager.getSubscriptions().has(resourceId)) this.debouncedBatchedFetchSyncBlocks(resourceId);
            return;
        }
        this.cacheDeletionRescheduleCounts.set(resourceId, currentCount + 1);
        this.scheduleCacheDeletion(resourceId);
    }
    /**
   * Schedules a delayed retry for a block that returned EntityNotFound.
   * The block may be in the process of being created by a collaborator —
   * the NCS transaction propagates the bodiedSyncBlock ADF node before
   * the Block Service createBlock call completes.
   */ scheduleEntityNotFoundRetry(resourceId) {
        const currentRetries = this.entityNotFoundRetryCount.get(resourceId) ?? 0;
        if (currentRetries >= $300c2e48dc416b36$var$ENTITY_NOT_FOUND_MAX_RETRIES) // Max retries exceeded — keep count at max so future calls immediately exit
        // (don't delete — that would reset the counter and allow unbounded retry waves)
        return;
        // If a timer is already pending, don't schedule another one — let the
        // existing timer fire. This prevents rapid EntityNotFound responses from
        // exhausting the retry budget through cancellations without any actual
        // fetch completing.
        if (this.entityNotFoundRetryTimers.has(resourceId)) return;
        const delay = $300c2e48dc416b36$var$ENTITY_NOT_FOUND_INITIAL_DELAY_MS * Math.pow(2, currentRetries);
        const timer = setTimeout(()=>{
            this.entityNotFoundRetryTimers.delete(resourceId);
            // If no active subscriptions remain for this block, clean up and skip
            const subscriptions = this._subscriptionManager.getSubscriptions().get(resourceId);
            if (!subscriptions || Object.keys(subscriptions).length === 0) {
                this.entityNotFoundRetryCount.delete(resourceId);
                return;
            }
            // Increment count only when the timer fires, not when scheduled
            this.entityNotFoundRetryCount.set(resourceId, currentRetries + 1);
            // Clear the error from cache so fetchSyncBlocksData doesn't skip it
            const cached = this.getFromCache(resourceId);
            if (cached?.error?.type === (0, $79ir6.SyncBlockError).EntityNotFound) this.deleteFromCache(resourceId);
            // Trigger a re-fetch via the batch fetcher
            this.debouncedBatchedFetchSyncBlocks(resourceId);
        }, delay);
        this.entityNotFoundRetryTimers.set(resourceId, timer);
    }
    debouncedBatchedFetchSyncBlocks(resourceId) {
        this._batchFetcher.queueFetch(resourceId);
    }
    setSSRDataInSessionCache(resourceIds) {
        if (!resourceIds || resourceIds.length === 0) return;
        resourceIds.forEach((resourceId)=>{
            this.updateSessionCache(resourceId);
        });
    }
    subscribeToSyncBlock(resourceId, localId, callback) {
        return this._subscriptionManager.subscribeToSyncBlock(resourceId, localId, callback);
    }
    subscribeToSourceTitle(node, callback) {
        return this._subscriptionManager.subscribeToSourceTitle(node, callback);
    }
    subscribe(node, callback) {
        try {
            // check node is a sync block, as we only support sync block subscriptions
            if (node.type.name !== 'syncBlock') throw new Error('Only sync block node subscriptions are supported');
            const { resourceId: resourceId, localId: localId } = node.attrs;
            if (!localId || !resourceId) throw new Error('Missing local id or resource id');
            return this._subscriptionManager.subscribeToSyncBlock(resourceId, localId, callback);
        } catch (error) {
            // EDITOR-7860: benign not-ready/torn-down case — suppress both the
            // exception-tracker log and the analytics event (checked first so the
            // benign case stays fully silent). Gate-off behaviour is unchanged.
            if ((0, $79ir6.isProviderNotReadyError)(error) && (0, $ixfCV.fg)('platform_editor_blocks_patch_3')) return ()=>{};
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $916Gd.fetchErrorPayload)(error.message, undefined, undefined, (0, $916Gd.buildFetchErrorAttribution)((0, $ixfCV.fg)('platform_editor_blocks_patch_3'), error.message)));
            return ()=>{};
        }
    }
    /**
   * Get the URL for a sync block.
   * @param resourceId - The resource ID of the sync block
   * @returns
   */ getSyncBlockURL(resourceId) {
        return this.getFromCache(resourceId)?.data?.sourceURL;
    }
    getProviderFactory(resourceId) {
        return this._providerFactoryManager.getProviderFactory(resourceId);
    }
    getSSRProviders(resourceId) {
        return this._providerFactoryManager.getSSRProviders(resourceId);
    }
    /**
   * Update reference synced blocks on the document with the BE
   *
   * @returns true if the reference synced blocks are updated successfully, false otherwise
   */ async flush() {
        if (this.viewMode === 'view') // Reference flushes are only meaningful while editing. Treat view-mode flush attempts as
        // gated no-op successes so lifecycle/teardown calls do not report false save failures.
        return true;
        if (!this.isCacheDirty) // we use the isCacheDirty flag as a quick check.
        return true;
        // Prevent concurrent flushes to avoid race conditions with lastFlushedSyncedBlocks
        if (this.isFlushInProgress) {
            // Mark that another flush is needed after the current one completes
            this.flushNeededAfterCurrent = true;
            // We return true here because we know the pending flush will handle the dirty cache
            return true;
        } else this.isFlushInProgress = true;
        let success = true;
        // a copy of the subscriptions STRUCTURE (without the callbacks)
        // To be saved as the last flushed structure if the flush is successful
        const syncedBlocksToFlush = {};
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            const blocks = [];
            // First, build the complete subscription structure
            for (const [resourceId, callbacks] of this._subscriptionManager.getSubscriptions().entries()){
                syncedBlocksToFlush[resourceId] = {};
                Object.keys(callbacks).forEach((localId)=>{
                    blocks.push({
                        resourceId: resourceId,
                        localId: localId
                    });
                    syncedBlocksToFlush[resourceId][localId] = true;
                });
            }
            // Then, compare with the last flushed structure to detect changes
            // We check against the last flushed structure to prevent unnecessary flushes
            // Note that we will always flush at least once when editor starts
            // This is useful for eventual consistency between the editor and the BE.
            if ((0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(syncedBlocksToFlush, this.lastFlushedSyncedBlocks)) {
                this.isCacheDirty = false; // Reset since we're considering this a successful no-op flush
                return true;
            }
            // reset isCacheDirty early to prevent race condition
            // There is a race condition where if a user makes changes (create/delete) to a reference sync block
            // on a live page and the reference sync block is being saved while the user
            // is still making changes, the new changes might not be saved if they all happen
            // exactly at a time when the updateReferenceData is being executed asynchronously.
            this.isCacheDirty = false;
            this.saveExperience?.start();
            const updateResult = await this.dataProvider.updateReferenceData(blocks);
            if (!updateResult.success) {
                success = false;
                this.saveExperience?.failure({
                    reason: updateResult.error || 'Failed to update reference synced blocks on the document'
                });
                this.fireAnalyticsEvent?.((0, $916Gd.updateReferenceErrorPayload)(updateResult.error || 'Failed to update reference synced blocks on the document', undefined, undefined, (0, $916Gd.buildErrorAttribution)((0, $ixfCV.fg)('platform_editor_blocks_patch_3'), updateResult.error, updateResult.statusCode)));
            }
        } catch (error) {
            success = false;
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.saveExperience?.failure({
                reason: error.message
            });
            // No `resourceId` available in this catch — sourceProduct is intentionally omitted.
            // No structured SyncBlockError/status here, so the attribution `reason` falls back
            // to `unknown` when the gate is on.
            this.fireAnalyticsEvent?.((0, $916Gd.updateReferenceErrorPayload)(error.message, undefined, undefined, (0, $916Gd.buildErrorAttribution)((0, $ixfCV.fg)('platform_editor_blocks_patch_3'))));
        } finally{
            if (!success) // set isCacheDirty back to true for cases where it failed to update the reference synced blocks on the BE
            this.isCacheDirty = true;
            else {
                this.lastFlushedSyncedBlocks = syncedBlocksToFlush;
                this.saveExperience?.success();
            }
            // Always reset isFlushInProgress
            this.isFlushInProgress = false;
            // If another flush was requested while this one was in progress, execute it now
            if (this.flushNeededAfterCurrent) {
                this.flushNeededAfterCurrent = false;
                // Use setTimeout to avoid deep recursion and run queued flush asynchronously
                // Note: flush() handles all exceptions internally and never rejects
                this.queuedFlushTimeout = setTimeout(()=>{
                    this.queuedFlushTimeout = undefined;
                    this.flush();
                }, 0);
            }
        }
        return success;
    }
    destroy() {
        // Mark destroyed first so in-flight timer callbacks can early-return.
        this.isDestroyed = true;
        // Cancel any queued flush to prevent it from running after destroy
        if (this.queuedFlushTimeout) {
            clearTimeout(this.queuedFlushTimeout);
            this.queuedFlushTimeout = undefined;
        }
        // Cancel any pending EntityNotFound retry timers
        this.entityNotFoundRetryTimers.forEach((timer)=>clearTimeout(timer));
        this.entityNotFoundRetryTimers.clear();
        this.entityNotFoundRetryCount.clear();
        // Cancel pending cache deletion timers.
        this.pendingCacheDeletions.forEach((timer)=>clearTimeout(timer));
        this.pendingCacheDeletions.clear();
        this.cacheDeletionRescheduleCounts.clear();
        this._subscriptionManager.destroy();
        this._providerFactoryManager.destroy();
        this._batchFetcher.destroy();
        this.dataProvider?.resetCache();
        this.dataProvider = undefined;
        this.syncBlockFetchDataRequests.clear();
        this.syncBlockSourceInfoRequests.clear();
        this.saveExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fetchExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fetchSourceInfoExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fireAnalyticsEvent = undefined;
        // Under `platform_synced_block_patch_14`, `destroy()` is now wired to
        // React component unmount via `useMemoizedSyncBlockStoreManager`.
        // Clearing the module-level singleton on unmount would wipe SSR session
        // cache data that a sibling/successor manager (e.g. the editor
        // instance that mounts immediately after the renderer unmounts during
        // the view-mode transition) is about to read.
        // Let entries age out naturally instead — the in-memory cache is
        // naturally bounded by `maxSize` (LRU) and cleared on hard navigation.
        if (!(0, $ixfCV.fg)('platform_synced_block_patch_14')) (0, $3ZV9H.syncBlockInMemorySessionCache).clear();
    }
    constructor(dataProvider, viewMode){
        this.viewMode = void 0;
        this.dataProvider = void 0;
        // Keeps track of addition and deletion of reference synced blocks on the document
        // This starts as true to always flush the cache when document is saved for the first time
        // to cater the case when a editor session is closed without document being updated right after reference block is deleted
        this.isCacheDirty = true;
        this.fireAnalyticsEvent = void 0;
        this.syncBlockFetchDataRequests = void 0;
        this.syncBlockSourceInfoRequests = void 0;
        // Track newly added sync blocks (resourceIds that were just subscribed to without cached data)
        this.newlyAddedSyncBlocks = void 0;
        // Keep track of the last flushed subscriptions to optimize cache flushing on document save
        this.lastFlushedSyncedBlocks = {};
        // Callback to notify when an unpublished sync block is detected
        this.onUnpublishedSyncBlockDetected = void 0;
        // Track if a flush operation is currently in progress
        this.isFlushInProgress = false;
        // Track if another flush is needed after the current one completes
        this.flushNeededAfterCurrent = false;
        // Track the setTimeout handle for queued flush so we can cancel it on destroy
        this.queuedFlushTimeout = void 0;
        // Track retry attempts for EntityNotFound errors (block may be in the process of being created)
        this.entityNotFoundRetryCount = new Map();
        this.entityNotFoundRetryTimers = new Map();
        // Pending cache deletion timers keyed by resourceId (gated by
        // `platform_synced_block_patch_14`). Cancelled when a subscriber re-attaches.
        this.pendingCacheDeletions = new Map();
        // Reschedule counter per resource — reset on actual deletion or re-subscribe.
        this.cacheDeletionRescheduleCounts = new Map();
        // Set by destroy() so in-flight timer callbacks can early-return.
        this.isDestroyed = false;
        this.fetchExperience = void 0;
        this.fetchSourceInfoExperience = void 0;
        this.saveExperience = void 0;
        this._subscriptionManager = void 0;
        this._providerFactoryManager = void 0;
        this._batchFetcher = void 0;
        this.dataProvider = dataProvider;
        this.viewMode = viewMode;
        this.syncBlockFetchDataRequests = new Map();
        this.syncBlockSourceInfoRequests = new Map();
        this.newlyAddedSyncBlocks = new Set();
        this._subscriptionManager = new (0, $dWaXQ.SyncBlockSubscriptionManager)({
            getDataProvider: ()=>this.dataProvider,
            getFromCache: (rid)=>this.getFromCache(rid),
            updateCache: (inst)=>this.updateCache(inst),
            deleteFromCache: (rid)=>this.deleteFromCache(rid),
            debouncedBatchedFetchSyncBlocks: (rid)=>this.debouncedBatchedFetchSyncBlocks(rid),
            fetchSyncBlockSourceInfo: (rid)=>this.fetchSyncBlockSourceInfo(rid),
            getFireAnalyticsEvent: ()=>this.fireAnalyticsEvent,
            markCacheDirty: ()=>{
                this.isCacheDirty = true;
            },
            // Delegate cache lifecycle to the store manager so guards can be
            // checked atomically (gated by `platform_synced_block_patch_14`).
            scheduleCacheDeletion: (rid)=>this.scheduleCacheDeletion(rid),
            cancelPendingCacheDeletion: (rid)=>this.cancelPendingCacheDeletion(rid)
        });
        this._providerFactoryManager = new (0, $8d6F6.SyncBlockProviderFactoryManager)({
            getDataProvider: ()=>this.dataProvider,
            getFromCache: (rid)=>this.getFromCache(rid),
            getFireAnalyticsEvent: ()=>this.fireAnalyticsEvent
        });
        this._batchFetcher = new (0, $f9GoL.SyncBlockBatchFetcher)({
            getSubscriptions: ()=>this._subscriptionManager.getSubscriptions(),
            fetchSyncBlocksData: (nodes)=>this.fetchSyncBlocksData(nodes),
            getFireAnalyticsEvent: ()=>this.fireAnalyticsEvent,
            // EDITOR-7860: skip + re-queue fetches while not ready / torn down.
            isProviderReady: ()=>this.hasDataProvider()
        });
        // The provider might have SSR data cache already set, so we need to update the cache in session memory storage
        this.setSSRDataInSessionCache(this.dataProvider?.getNodeDataCacheKeys());
    }
}
module.exports["ReferenceSyncBlockStoreManager"] = $300c2e48dc416b36$export$fb04276dca31302e;

});

parcelRegister("8kkvD", function(module, exports) {

var $6oMcp = parcelRequire("6oMcp");


var $79ir6 = parcelRequire("79ir6");

const $91813f771f17ec33$export$dcc459f28c1cd2fd = (oldResult, newResult)=>{
    // if the old result has no data, we simply return the new result
    if (!oldResult.data) return newResult;
    else if (!newResult.data) {
        // return the old result if there was an error, e.g. network error, but not if not found or forbidden
        if (newResult.error?.type === (0, $79ir6.SyncBlockError).NotFound || newResult.error?.type === (0, $79ir6.SyncBlockError).Forbidden) return newResult;
        else return oldResult;
    }
    // otherwise, we merge the two results, preserving the sourceURL and sourceTitle from the old result if it exists
    return {
        ...newResult,
        data: {
            ...newResult.data,
            sourceURL: newResult.data?.sourceURL || oldResult.data?.sourceURL || undefined,
            sourceTitle: newResult.data?.sourceTitle || oldResult.data?.sourceTitle || undefined,
            sourceSubType: $91813f771f17ec33$var$mergeSubType(oldResult, newResult),
            onSameDocument: newResult.data?.onSameDocument || oldResult.data?.onSameDocument || undefined,
            issueType: newResult.data?.issueType || oldResult.data?.issueType || undefined
        }
    };
};
const $91813f771f17ec33$var$mergeSubType = (oldResult, newResult)=>{
    // for classic pages, subType is 'null'
    if (newResult.data?.sourceSubType !== undefined) return newResult.data.sourceSubType;
    if (newResult.data?.sourceAri) // for blogposts, subType is always undefined
    try {
        const { type: pageType } = (0, $6oMcp.getPageIdAndTypeFromConfluencePageAri)({
            ari: newResult.data?.sourceAri
        });
        if (pageType === 'blogpost') return newResult.data?.sourceSubType;
    } catch  {}
    return oldResult.data?.sourceSubType;
};
module.exports["resolveSyncBlockInstance"] = $91813f771f17ec33$export$dcc459f28c1cd2fd;

});

parcelRegister("f9GoL", function(module, exports) {

var $LQnOI = parcelRequire("LQnOI");


var $jv11C = parcelRequire("jv11C");


var $ixfCV = parcelRequire("ixfCV");


var $79ir6 = parcelRequire("79ir6");


var $916Gd = parcelRequire("916Gd");


var $d04Ge = parcelRequire("d04Ge");

class $7b654f51773d0aa6$export$7d827e0357659116 {
    queueFetch(resourceId) {
        const subscriptions = this.deps.getSubscriptions();
        if (subscriptions.has(resourceId) && Object.keys(subscriptions.get(resourceId) || {}).length > 0) {
            this.pendingFetchRequests.add(resourceId);
            this.scheduledBatchFetch();
        } else this.pendingFetchRequests.delete(resourceId);
    }
    /**
   * Returns true if a batched fetch is queued or in flight for `resourceId`.
   * Used by cache deletion guards to prevent deleting while a fetch is
   * about to populate the entry.
   */ hasPendingFetch(resourceId) {
        return this.pendingFetchRequests.has(resourceId) || this.inFlightFetches.has(resourceId);
    }
    cancel() {
        this.scheduledBatchFetch.cancel();
    }
    clearPending() {
        this.pendingFetchRequests.clear();
    }
    destroy() {
        this.isDestroyed = true;
        this.cancel();
        this.clearPending();
        // Clear in-flight tracking to prevent stale entries after teardown.
        this.inFlightFetches.clear();
    }
    constructor(deps){
        this.deps = deps;
        this.pendingFetchRequests = new Set();
        // Tracks resourceIds whose batched fetch is in flight (after RAF drains
        // pendingFetchRequests, before the promise settles). Ensures
        // `hasPendingFetch` remains true during the network window.
        this.inFlightFetches = new Set();
        this.isDestroyed = false;
        this.scheduledBatchFetch = void 0;
        this.scheduledBatchFetch = (0, $LQnOI.default)(()=>{
            if (this.pendingFetchRequests.size === 0) return;
            // EDITOR-7860: not ready — skip and leave resourceIds queued for the
            // next batch once the provider resolves. Gate-off is unchanged (the
            // readiness check is nested under the gate so it is not consulted when
            // the gate is off, and `fg()` stays a standalone condition so gate
            // exposure is still tracked — satisfies @atlaskit/platform/no-preconditioning).
            if ((0, $ixfCV.fg)('platform_editor_blocks_patch_3')) {
                if (this.deps.isProviderReady && !this.deps.isProviderReady()) return;
            }
            const resourceIds = Array.from(this.pendingFetchRequests);
            const syncBlockNodes = resourceIds.map((resId)=>{
                const subscriptions = this.deps.getSubscriptions().get(resId) || {};
                const firstLocalId = Object.keys(subscriptions)[0] || '';
                return (0, $d04Ge.createSyncBlockNode)(firstLocalId, resId);
            });
            this.pendingFetchRequests.clear();
            // Track in-flight before the fetch so guards remain positive.
            resourceIds.forEach((resId)=>this.inFlightFetches.add(resId));
            this.deps.fetchSyncBlocksData(syncBlockNodes).catch((error)=>{
                // EDITOR-7860: benign not-ready throw — re-queue for retry and emit
                // nothing (no analytics, no exception-tracker noise). Checked before
                // `logException` so the benign case stays silent. Re-schedule so the
                // re-queued IDs are retried on the next frame even if no further
                // `queueFetch()` arrives. Gate-off behaviour is unchanged.
                if ((0, $79ir6.isProviderNotReadyError)(error) && (0, $ixfCV.fg)('platform_editor_blocks_patch_3')) {
                    resourceIds.forEach((resId)=>this.pendingFetchRequests.add(resId));
                    if (!this.isDestroyed) this.scheduledBatchFetch();
                    return;
                }
                (0, $jv11C.logException)(error, {
                    location: 'editor-synced-block-provider/syncBlockBatchFetcher/batchedFetchSyncBlocks'
                });
                const attribution = (0, $916Gd.buildFetchErrorAttribution)((0, $ixfCV.fg)('platform_editor_blocks_patch_3'), error.message);
                resourceIds.forEach((resId)=>{
                    this.deps.getFireAnalyticsEvent()?.((0, $916Gd.fetchErrorPayload)(error.message, resId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resId), attribution));
                });
            }).finally(()=>{
                // If the fetcher was destroyed while the request was in flight,
                // skip cleanup — `destroy()` already cleared `inFlightFetches`
                // and there's nothing observable to update.
                if (this.isDestroyed) return;
                // Clear in-flight tracking once the fetch settles.
                resourceIds.forEach((resId)=>this.inFlightFetches.delete(resId));
            });
        });
    }
}
module.exports["SyncBlockBatchFetcher"] = $7b654f51773d0aa6$export$7d827e0357659116;

});

parcelRegister("3ZV9H", function(module, exports) {
/**
 * In-memory session cache for sync block data with size-based LRU eviction.
 *
 * Backed by a plain Map so that potentially private ADF content is never
 * written to any browser-persistent storage (sessionStorage, localStorage,
 * IndexedDB). The module-level singleton survives SPA transitions (no full
 * page reload) and is naturally cleared on hard navigation or tab close.
 *
 * Uses JavaScript Map's insertion-order guarantee to implement LRU:
 * on every read or write the accessed entry is moved to the end of the
 * iteration order; when total cached size exceeds `maxSize`, the oldest
 * (least-recently-used) entries are evicted first.
 */ class $9e2a264ec952713b$export$75f7f86498dcaabe {
    /**
   * Retrieves a cached value by key.
   *
   * **Side-effect:** promotes the entry to the most-recently-used
   * position by re-inserting it at the end of the underlying Map's
   * iteration order.
   */ getItem(key) {
        const value = this.store.get(key);
        if (value === undefined) return null;
        this.store.delete(key);
        this.store.set(key, value);
        return value;
    }
    setItem(key, value) {
        const existing = this.store.get(key);
        if (existing !== undefined) {
            this.currentSize -= existing.length;
            this.store.delete(key);
        }
        this.store.set(key, value);
        this.currentSize += value.length;
        while(this.currentSize > this.maxSize && this.store.size > 1){
            const oldestKey = this.store.keys().next().value;
            if (oldestKey !== undefined) {
                const oldestValue = this.store.get(oldestKey);
                if (oldestValue !== undefined) this.currentSize -= oldestValue.length;
                this.store.delete(oldestKey);
            }
        }
    }
    removeItem(key) {
        const value = this.store.get(key);
        if (value !== undefined) {
            this.currentSize -= value.length;
            this.store.delete(key);
        }
    }
    /**
   * Removes all entries from the cache and resets the tracked size to zero.
   * Useful for cleaning up the singleton on SPA navigation boundaries.
   */ clear() {
        this.store.clear();
        this.currentSize = 0;
    }
    constructor(maxSize = 5242880){
        this.store = new Map();
        this.currentSize = 0;
        /**
     * Maximum total size of all cached values, measured in **UTF-16 code
     * units** (i.e. `String.prototype.length`), not bytes.  For ASCII-only
     * content the two are equivalent; for content with characters outside
     * the BMP each surrogate pair counts as 2.
     */ this.maxSize = void 0;
        this.maxSize = maxSize;
    }
}
const $9e2a264ec952713b$export$b811313deafee9ed = new $9e2a264ec952713b$export$75f7f86498dcaabe();
module.exports["syncBlockInMemorySessionCache"] = $9e2a264ec952713b$export$b811313deafee9ed;

});

parcelRegister("8d6F6", function(module, exports) {

var $jv11C = parcelRequire("jv11C");


var $eNbr2 = parcelRequire("eNbr2");


var $ixfCV = parcelRequire("ixfCV");


var $916Gd = parcelRequire("916Gd");


var $cuwGS = parcelRequire("cuwGS");


var $d04Ge = parcelRequire("d04Ge");

class $6125b02f0c1ee8e1$export$3bfff6c128de82c9 {
    getProviderFactory(resourceId) {
        const dataProvider = this.deps.getDataProvider();
        if (!dataProvider) {
            const error = new Error('Data provider not set');
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockProviderFactoryManager'
            });
            this.deps.getFireAnalyticsEvent()?.((0, $916Gd.fetchErrorPayload)(error.message, resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId), (0, $916Gd.buildFetchErrorAttribution)((0, $ixfCV.fg)('platform_editor_blocks_patch_3'), error.message)));
            return undefined;
        }
        const { parentDataProviders: parentDataProviders, providerCreator: providerCreator } = dataProvider.getSyncedBlockRendererProviderOptions();
        let providerFactory = this.providerFactories.get(resourceId);
        if (!providerFactory) {
            providerFactory = (0, $eNbr2.default).create({
                mentionProvider: parentDataProviders?.mentionProvider,
                profilecardProvider: parentDataProviders?.profilecardProvider,
                taskDecisionProvider: parentDataProviders?.taskDecisionProvider
            });
            this.providerFactories.set(resourceId, providerFactory);
        } else {
            if (parentDataProviders?.mentionProvider) providerFactory.setProvider('mentionProvider', parentDataProviders?.mentionProvider);
            if (parentDataProviders?.profilecardProvider) providerFactory.setProvider('profilecardProvider', parentDataProviders?.profilecardProvider);
            if (parentDataProviders?.taskDecisionProvider) providerFactory.setProvider('taskDecisionProvider', parentDataProviders?.taskDecisionProvider);
        }
        if (providerCreator) try {
            this.retrieveDynamicProviders(resourceId, providerFactory, providerCreator);
        } catch (error) {
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockProviderFactoryManager'
            });
            this.deps.getFireAnalyticsEvent()?.((0, $916Gd.fetchErrorPayload)(error.message, resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId), (0, $916Gd.buildFetchErrorAttribution)((0, $ixfCV.fg)('platform_editor_blocks_patch_3'), error.message)));
        }
        return providerFactory;
    }
    getSSRProviders(resourceId) {
        const dataProvider = this.deps.getDataProvider();
        if (!dataProvider) return null;
        const { providerCreator: providerCreator } = dataProvider.getSyncedBlockRendererProviderOptions();
        if (!providerCreator?.createSSRMediaProvider) return null;
        const parsedResourceId = (0, $cuwGS.parseResourceId)(resourceId);
        if (!parsedResourceId) return null;
        let { contentId: contentId, product: contentProduct } = parsedResourceId;
        const syncBlock = this.deps.getFromCache(resourceId);
        let contentAri = syncBlock?.data?.sourceAri || '';
        if (syncBlock?.data?.sourceAri && syncBlock.data.product) {
            const parentInfo = dataProvider.retrieveSyncBlockParentInfo(syncBlock.data.sourceAri, syncBlock.data.product);
            if (parentInfo) {
                contentId = parentInfo.contentId;
                contentProduct = parentInfo.contentProduct;
                contentAri = parentInfo.contentAri;
            }
        }
        try {
            const mediaProvider = providerCreator.createSSRMediaProvider({
                contentAri: contentAri,
                contentId: contentId,
                contentProduct: contentProduct
            });
            if (mediaProvider) return {
                media: mediaProvider
            };
        } catch (error) {
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockProviderFactoryManager'
            });
        }
        return null;
    }
    deleteFactory(resourceId) {
        this.providerFactories.delete(resourceId);
    }
    destroy() {
        this.providerFactories.forEach((pf)=>pf.destroy());
        this.providerFactories.clear();
    }
    retrieveDynamicProviders(resourceId, providerFactory, providerCreator) {
        const dataProvider = this.deps.getDataProvider();
        if (!dataProvider) throw new Error('Data provider not set');
        const hasMediaProvider = providerFactory.hasProvider('mediaProvider');
        const hasEmojiProvider = providerFactory.hasProvider('emojiProvider');
        const hasCardProvider = providerFactory.hasProvider('cardProvider');
        if (hasMediaProvider && hasEmojiProvider && hasCardProvider) return;
        const syncBlock = this.deps.getFromCache(resourceId);
        if (!syncBlock?.data) return;
        if (!syncBlock.data.sourceAri || !syncBlock.data.product) {
            this.deps.getFireAnalyticsEvent()?.((0, $916Gd.fetchErrorPayload)('Sync block source ari or product not found', resourceId, // Prefer cached product when available; fall back to parsing resourceId.
            syncBlock.data.product ?? (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId), (0, $916Gd.buildFetchErrorAttribution)((0, $ixfCV.fg)('platform_editor_blocks_patch_3'), 'Sync block source ari or product not found')));
            return;
        }
        const parentInfo = dataProvider.retrieveSyncBlockParentInfo(syncBlock.data.sourceAri, syncBlock.data.product);
        if (!parentInfo) throw new Error('Unable to retrieve sync block parent info');
        const { contentAri: contentAri, contentId: contentId, contentProduct: contentProduct } = parentInfo;
        if (!hasMediaProvider && providerCreator.createMediaProvider && contentId && contentProduct) {
            const mediaProvider = providerCreator.createMediaProvider({
                contentAri: contentAri,
                contentProduct: contentProduct,
                contentId: contentId
            });
            if (mediaProvider) providerFactory.setProvider('mediaProvider', mediaProvider);
        }
        if (!hasEmojiProvider && providerCreator.createEmojiProvider && contentId && contentProduct) {
            const emojiProvider = providerCreator.createEmojiProvider({
                contentAri: contentAri,
                contentProduct: contentProduct,
                contentId: contentId
            });
            if (emojiProvider) providerFactory.setProvider('emojiProvider', emojiProvider);
        }
        if (!hasCardProvider && providerCreator.createSmartLinkProvider) {
            const smartLinkProvider = providerCreator.createSmartLinkProvider();
            if (smartLinkProvider) providerFactory.setProvider('cardProvider', smartLinkProvider);
        }
    }
    constructor(deps){
        this.deps = deps;
        this.providerFactories = new Map();
    }
}
module.exports["SyncBlockProviderFactoryManager"] = $6125b02f0c1ee8e1$export$3bfff6c128de82c9;

});

parcelRegister("dWaXQ", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");


var $haNN4 = parcelRequire("haNN4");


var $jv11C = parcelRequire("jv11C");


var $ixfCV = parcelRequire("ixfCV");


var $916Gd = parcelRequire("916Gd");


var $8kkvD = parcelRequire("8kkvD");


var $d04Ge = parcelRequire("d04Ge");

class $0a36060a48fcf8c9$export$200c87d47b3d6e17 {
    // EDITOR-7861: higher ceiling lets transient WS-gateway drops self-heal
    // before a terminal failure is surfaced.
    getMaxRetryAttempts() {
        return (0, $ixfCV.fg)('platform_editor_blocks_patch_3') ? $0a36060a48fcf8c9$export$200c87d47b3d6e17.MAX_RETRY_ATTEMPTS_HARDENED : $0a36060a48fcf8c9$export$200c87d47b3d6e17.MAX_RETRY_ATTEMPTS;
    }
    // Backoff delay for the given attempt.
    // Gate OFF: pure exponential (1s, 2s, 4s, 8s, 16s).
    // Gate ON (EDITOR-7861): exponential capped at MAX_RETRY_DELAY_MS with equal
    // jitter (capped/2 + random*capped/2) — de-synchronises simultaneous
    // reconnects while guaranteeing a non-zero delay (full jitter could hit 0).
    getReconnectionDelay(attempts) {
        const exponential = $0a36060a48fcf8c9$export$200c87d47b3d6e17.INITIAL_RETRY_DELAY_MS * Math.pow($0a36060a48fcf8c9$export$200c87d47b3d6e17.RETRY_BACKOFF_MULTIPLIER, attempts);
        if (!(0, $ixfCV.fg)('platform_editor_blocks_patch_3')) return exponential;
        const half = Math.min(exponential, $0a36060a48fcf8c9$export$200c87d47b3d6e17.MAX_RETRY_DELAY_MS) / 2;
        return Math.round(half + Math.random() * half);
    }
    /**
   * Returns the subscriptions map. Used by external consumers (e.g. batch fetcher, flush)
   * that need to read the current subscription state.
   */ getSubscriptions() {
        return this.subscriptions;
    }
    setRealTimeSubscriptionsEnabled(enabled) {
        if (this.useRealTimeSubscriptions === enabled) return;
        this.useRealTimeSubscriptions = enabled;
        if (enabled) this.setupSubscriptionsForAllBlocks();
        else this.cleanupAll();
    }
    isRealTimeSubscriptionsEnabled() {
        return this.useRealTimeSubscriptions;
    }
    getSubscribedResourceIds() {
        return Array.from(this.subscriptions.keys());
    }
    onSubscriptionsChanged(listener) {
        this.subscriptionChangeListeners.add(listener);
        return ()=>{
            this.subscriptionChangeListeners.delete(listener);
        };
    }
    notifySubscriptionChangeListeners() {
        this.subscriptionChangeListeners.forEach((listener)=>{
            try {
                listener();
            } catch (error) {
                (0, $jv11C.logException)(error, {
                    location: 'editor-synced-block-provider/syncBlockSubscriptionManager/notifySubscriptionChangeListeners'
                });
                this.deps.getFireAnalyticsEvent()?.((0, $916Gd.fetchErrorPayload)(error.message, undefined, undefined, (0, $916Gd.buildFetchErrorAttribution)((0, $ixfCV.fg)('platform_editor_blocks_patch_3'), error.message)));
            }
        });
    }
    handleSubscriptionUpdate(syncBlockInstance) {
        if (!syncBlockInstance.resourceId) return;
        const existing = this.deps.getFromCache(syncBlockInstance.resourceId);
        const resolved = existing ? (0, $8kkvD.resolveSyncBlockInstance)(existing, syncBlockInstance) : syncBlockInstance;
        this.deps.updateCache(resolved);
        if (!syncBlockInstance.error) this.deps.fetchSyncBlockSourceInfo(resolved.resourceId);
    }
    subscribeToSyncBlock(resourceId, localId, callback) {
        // Cancel any pending cache deletion for this resourceId.
        // This handles the case where a block is moved - the old component unmounts
        // (scheduling deletion) but the new component mounts and subscribes before
        // the deletion timeout fires.
        //
        // Under the flag, cache deletion is owned by the store manager.
        // With the flag off, the legacy 1s timer path is preserved.
        const pendingDeletion = this.pendingCacheDeletions.get(resourceId);
        if ((0, $ixfCV.fg)('platform_synced_block_patch_14')) this.deps.cancelPendingCacheDeletion(resourceId);
        else if (pendingDeletion) {
            clearTimeout(pendingDeletion);
            this.pendingCacheDeletions.delete(resourceId);
        }
        // add to subscriptions map
        const resourceSubscriptions = this.subscriptions.get(resourceId) || {};
        const isNewResourceSubscription = Object.keys(resourceSubscriptions).length === 0;
        this.subscriptions.set(resourceId, {
            ...resourceSubscriptions,
            [localId]: callback
        });
        // New subscription means new reference synced block is added to the document
        this.deps.markCacheDirty();
        // Notify listeners if this is a new resource subscription
        if (isNewResourceSubscription) this.notifySubscriptionChangeListeners();
        const cachedData = this.deps.getFromCache(resourceId);
        if (cachedData) callback(cachedData);
        else this.deps.debouncedBatchedFetchSyncBlocks(resourceId);
        // Set up GraphQL subscription if real-time subscriptions are enabled
        if (this.shouldUseRealTime()) this.setupSubscription(resourceId);
        return ()=>{
            const resourceSubscriptions = this.subscriptions.get(resourceId);
            if (resourceSubscriptions) {
                // Unsubscription means a reference synced block is removed from the document
                this.deps.markCacheDirty();
                delete resourceSubscriptions[localId];
                const remainingIds = Object.keys(resourceSubscriptions);
                if (remainingIds.length === 0) {
                    this.subscriptions.delete(resourceId);
                    // Clean up GraphQL subscription when no more local subscribers
                    this.cleanupSubscription(resourceId);
                    // Notify listeners that subscription was removed
                    this.notifySubscriptionChangeListeners();
                    // Under the flag, delegate cache deletion to the store manager
                    // which uses a 30s grace period with guard re-checks.
                    if ((0, $ixfCV.fg)('platform_synced_block_patch_14')) this.deps.scheduleCacheDeletion(resourceId);
                    else {
                        // Legacy path (unchanged): delay cache deletion to handle
                        // block moves (unmount/remount). When a block is moved, the
                        // old component unmounts before the new one mounts. By
                        // delaying deletion, we give the new component time to
                        // subscribe and cancel this pending deletion, preserving
                        // the cached data.
                        // TODO: EDITOR-4152 - Rework this logic (superseded by
                        // `platform_synced_block_patch_14`).
                        const deletionTimeout = setTimeout(()=>{
                            const hasSubscribers = this.subscriptions.has(resourceId);
                            // Only delete if still no subscribers (wasn't re-subscribed)
                            if (!hasSubscribers) this.deps.deleteFromCache(resourceId);
                            this.pendingCacheDeletions.delete(resourceId);
                        }, 1000);
                        this.pendingCacheDeletions.set(resourceId, deletionTimeout);
                    }
                } else this.subscriptions.set(resourceId, resourceSubscriptions);
            }
        };
    }
    subscribeToSourceTitle(node, callback) {
        // check node is a sync block, as we only support sync block subscriptions
        if (node.type.name !== 'syncBlock') return ()=>{};
        const { resourceId: resourceId, localId: localId } = node.attrs;
        if (!localId || !resourceId) return ()=>{};
        const cachedData = this.deps.getFromCache(resourceId);
        if (cachedData?.data?.sourceTitle) callback(cachedData.data.sourceTitle);
        // add to subscriptions map
        const resourceSubscriptions = this.titleSubscriptions.get(resourceId) || {};
        this.titleSubscriptions.set(resourceId, {
            ...resourceSubscriptions,
            [localId]: callback
        });
        return ()=>{
            const resourceSubscriptions = this.titleSubscriptions.get(resourceId);
            if (resourceSubscriptions) {
                delete resourceSubscriptions[localId];
                if (Object.keys(resourceSubscriptions).length === 0) this.titleSubscriptions.delete(resourceId);
                else this.titleSubscriptions.set(resourceId, resourceSubscriptions);
            }
        };
    }
    updateSourceTitleSubscriptions(resourceId, title) {
        const callbacks = this.titleSubscriptions.get(resourceId);
        if (callbacks) Object.values(callbacks).forEach((callback)=>{
            callback(title);
        });
    }
    /**
   * Notifies all subscription callbacks for a given resource ID with the provided sync block instance.
   */ notifySubscriptionCallbacks(resourceId, syncBlock) {
        const callbacks = this.subscriptions.get(resourceId);
        if (callbacks) Object.values(callbacks).forEach((callback)=>{
            callback(syncBlock);
        });
    }
    setupSubscription(resourceId) {
        if (this.graphqlSubscriptions.has(resourceId)) return;
        const dataProvider = this.deps.getDataProvider();
        if (!dataProvider?.subscribeToBlockUpdates) return;
        const unsubscribe = dataProvider.subscribeToBlockUpdates(resourceId, (syncBlockInstance)=>{
            this.handleGraphQLUpdate(syncBlockInstance);
        }, (error)=>{
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/syncBlockSubscriptionManager/graphql-subscription'
            });
            // EDITOR-7861: a single socket drop is usually transient and
            // recovers on reconnect, so under the gate we don't fire a
            // user-facing error here — it's only surfaced on exhaustion (see
            // scheduleReconnection). Gate OFF keeps the legacy fire-on-drop.
            // This branch only runs when the gate is OFF, so buildFetchErrorAttribution
            // would return undefined; the structured attribution (EDITOR-7862) is therefore
            // applied at the gate-ON exhaustion site in scheduleReconnection instead.
            if (!(0, $ixfCV.fg)('platform_editor_blocks_patch_3')) this.deps.getFireAnalyticsEvent()?.((0, $916Gd.fetchErrorPayload)(error.message, resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId)));
            this.handleSubscriptionTerminated(resourceId);
        }, ()=>{
            this.handleSubscriptionTerminated(resourceId);
        });
        if (unsubscribe) this.graphqlSubscriptions.set(resourceId, unsubscribe);
    }
    /**
   * Handles subscription termination (complete or error) by cleaning up the
   * stale entry and scheduling a reconnection with exponential backoff.
   */ handleSubscriptionTerminated(resourceId) {
        // Remove the stale subscription entry so setupSubscription won't early-return
        this.graphqlSubscriptions.delete(resourceId);
        // Guard against duplicate calls (graphql-ws can fire both error and complete)
        if (this.pendingRetries.has(resourceId)) return;
        // Only reconnect if there are still active subscribers for this resource
        if (this.subscriptions.has(resourceId) && this.shouldUseRealTime()) this.scheduleReconnection(resourceId);
    }
    // Schedules a reconnection with backoff (see getMaxRetryAttempts /
    // getReconnectionDelay for the gated behaviour).
    scheduleReconnection(resourceId) {
        const attempts = this.retryAttempts.get(resourceId) ?? 0;
        const maxAttempts = this.getMaxRetryAttempts();
        if (attempts >= maxAttempts) {
            // Exhausted all attempts — the only place a WS drop surfaces as a
            // fetch error under the gate (EDITOR-7861).
            const errorMessage = `Subscription reconnection failed after ${attempts} attempts`;
            // Tab hidden at exhaustion: don't surface a terminal failure (user isn't
            // looking, and most exhaustions self-recover once foregrounded). Park + re-arm
            // on wake, emitting a benign `deferred` signal so suppression stays auditable.
            const shouldDefer = (0, $ixfCV.fg)('platform_editor_blocks_patch_3') && this.isDocumentHidden();
            if (shouldDefer) {
                this.deferredExhausted.add(resourceId);
                this.registerWakeListeners();
                this.deps.getFireAnalyticsEvent()?.((0, $916Gd.fetchErrorPayload)(errorMessage, resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId), (0, $916Gd.buildFetchErrorAttribution)(true, errorMessage, undefined, /* deferred */ true)));
                return;
            }
            (0, $jv11C.logException)(new Error(errorMessage), {
                location: 'editor-synced-block-provider/syncBlockSubscriptionManager/max-retries-exhausted'
            });
            this.deps.getFireAnalyticsEvent()?.((0, $916Gd.fetchErrorPayload)(errorMessage, resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId), (0, $916Gd.buildFetchErrorAttribution)((0, $ixfCV.fg)('platform_editor_blocks_patch_3'), errorMessage)));
            return;
        }
        const delay = this.getReconnectionDelay(attempts);
        const timer = setTimeout(()=>{
            this.pendingRetries.delete(resourceId);
            // Only re-subscribe if still relevant
            if (this.subscriptions.has(resourceId) && this.shouldUseRealTime()) {
                this.setupSubscription(resourceId);
                // Only increment if the subscription was actually established
                // (setupSubscription may be a no-op if another code path already re-established it)
                if (this.graphqlSubscriptions.has(resourceId)) this.retryAttempts.set(resourceId, attempts + 1);
            } else // Conditions no longer met — clean up stale retry state
            this.retryAttempts.delete(resourceId);
        }, delay);
        this.pendingRetries.set(resourceId, timer);
    }
    /**
   * Resets the retry counter for a resource. Called when a successful
   * update is received, indicating the subscription is healthy.
   */ resetRetryCount(resourceId) {
        this.retryAttempts.delete(resourceId);
    }
    /**
   * Whether the tab is currently hidden. SSR/non-browser is treated as "not hidden" so
   * we never defer where wake events can't fire (realtime never subscribes there anyway).
   */ isDocumentHidden() {
        return (0, $haNN4.getDocument)()?.hidden === true;
    }
    /**
   * Lazily register shared `online` / `visibilitychange` listeners on first deferral.
   * Torn down by `unregisterWakeListeners` (via `handleWake`). No-op in SSR / non-browser.
   */ registerWakeListeners() {
        if (this.wakeListenerCleanups.length > 0 || typeof window === 'undefined') return;
        this.wakeListenerCleanups.push((0, $cbY7C.bind)(window, {
            type: 'online',
            listener: this.onOnline
        }));
        const doc = (0, $haNN4.getDocument)();
        if (doc) this.wakeListenerCleanups.push((0, $cbY7C.bind)(doc, {
            type: 'visibilitychange',
            listener: this.onVisibilityChange
        }));
    }
    unregisterWakeListeners() {
        if (this.wakeDebounceTimer !== null) {
            clearTimeout(this.wakeDebounceTimer);
            this.wakeDebounceTimer = null;
        }
        for (const cleanup of this.wakeListenerCleanups)cleanup();
        this.wakeListenerCleanups = [];
    }
    /**
   * Coalesce a burst of wake events into one debounced re-arm sweep. Callers decide
   * eligibility: `onOnline` always sweeps; `onVisibilityChange` only sweeps when visible.
   */ scheduleWakeSweep() {
        if (this.wakeDebounceTimer !== null) return;
        this.wakeDebounceTimer = setTimeout(()=>{
            this.wakeDebounceTimer = null;
            this.handleWake();
        }, $0a36060a48fcf8c9$export$200c87d47b3d6e17.WAKE_DEBOUNCE_MS);
    }
    /**
   * Re-arm every deferred resource: full reset (attempts→0) + immediate reconnect now
   * the tab is visible / online. Healthy subscriptions are untouched. A re-armed cycle
   * that later exhausts while visible fires the terminal error normally.
   */ handleWake() {
        if (this.deferredExhausted.size === 0) {
            this.unregisterWakeListeners();
            return;
        }
        const toRearm = Array.from(this.deferredExhausted);
        this.deferredExhausted.clear();
        for (const resourceId of toRearm){
            // Only re-arm resources that still have active subscribers and realtime on.
            if (!this.subscriptions.has(resourceId) || !this.shouldUseRealTime()) continue;
            this.resetRetryCount(resourceId);
            this.cancelPendingRetry(resourceId);
            this.setupSubscription(resourceId);
        }
        // No deferred resources remain until another hidden exhaustion re-adds one.
        this.unregisterWakeListeners();
    }
    cancelPendingRetry(resourceId) {
        const timer = this.pendingRetries.get(resourceId);
        if (timer) {
            clearTimeout(timer);
            this.pendingRetries.delete(resourceId);
        }
    }
    cancelAllPendingRetries() {
        for (const timer of this.pendingRetries.values())clearTimeout(timer);
        this.pendingRetries.clear();
        this.retryAttempts.clear();
        // Nothing left to re-arm: drop parked exhaustions and tear down wake listeners.
        this.deferredExhausted.clear();
        this.unregisterWakeListeners();
    }
    cleanupSubscription(resourceId) {
        const unsubscribe = this.graphqlSubscriptions.get(resourceId);
        if (unsubscribe) {
            unsubscribe();
            this.graphqlSubscriptions.delete(resourceId);
        }
        this.cancelPendingRetry(resourceId);
        this.retryAttempts.delete(resourceId);
        // No subscribers left, so this resource can't be re-armed.
        this.deferredExhausted.delete(resourceId);
        if (this.deferredExhausted.size === 0) this.unregisterWakeListeners();
    }
    setupSubscriptionsForAllBlocks() {
        for (const resourceId of this.subscriptions.keys())this.setupSubscription(resourceId);
    }
    cleanupAll() {
        for (const unsubscribe of this.graphqlSubscriptions.values())unsubscribe();
        this.graphqlSubscriptions.clear();
        this.cancelAllPendingRetries();
    }
    destroy() {
        this.cleanupAll();
        this.subscriptions.clear();
        this.titleSubscriptions.clear();
        this.subscriptionChangeListeners.clear();
        this.useRealTimeSubscriptions = false;
        // Clear any pending cache deletions
        for (const timeout of this.pendingCacheDeletions.values())clearTimeout(timeout);
        this.pendingCacheDeletions.clear();
    }
    shouldUseRealTime() {
        return this.useRealTimeSubscriptions;
    }
    handleGraphQLUpdate(syncBlockInstance) {
        if (!syncBlockInstance.resourceId) return;
        const existing = this.deps.getFromCache(syncBlockInstance.resourceId);
        const resolved = existing ? (0, $8kkvD.resolveSyncBlockInstance)(existing, syncBlockInstance) : syncBlockInstance;
        this.deps.updateCache(resolved);
        if (!syncBlockInstance.error) {
            this.resetRetryCount(syncBlockInstance.resourceId);
            // A healthy update means a parked exhaustion recovered on its own before any
            // wake sweep — drop it and tear down listeners if nothing else is parked.
            if (this.deferredExhausted.delete(syncBlockInstance.resourceId)) {
                if (this.deferredExhausted.size === 0) this.unregisterWakeListeners();
            }
            const callbacks = this.subscriptions.get(syncBlockInstance.resourceId);
            const localIds = callbacks ? Object.keys(callbacks) : [];
            localIds.forEach((localId)=>{
                this.deps.getFireAnalyticsEvent()?.((0, $916Gd.fetchSuccessPayload)(syncBlockInstance.resourceId, localId, syncBlockInstance.data?.product ?? (0, $d04Ge.getSourceProductFromResourceIdSafe)(syncBlockInstance.resourceId)));
            });
            this.deps.fetchSyncBlockSourceInfo(resolved.resourceId);
        } else {
            const errorMessage = syncBlockInstance.error?.reason || syncBlockInstance.error?.type;
            // Prefer the structured `type` (a `SyncBlockError` enum value) for classification
            // and fall back to the free-text `reason` so source-state/permission strings are
            // still bucketed (EDITOR-7862). The emitted free-text `error` attribute is unchanged.
            this.deps.getFireAnalyticsEvent()?.((0, $916Gd.fetchErrorPayload)(errorMessage, syncBlockInstance.resourceId, syncBlockInstance.data?.product ?? (0, $d04Ge.getSourceProductFromResourceIdSafe)(syncBlockInstance.resourceId), (0, $916Gd.buildFetchErrorAttribution)((0, $ixfCV.fg)('platform_editor_blocks_patch_3'), syncBlockInstance.error?.type || syncBlockInstance.error?.reason, syncBlockInstance.error?.statusCode)));
        }
    }
    constructor(deps){
        this.deps = deps;
        this.subscriptions = new Map();
        this.titleSubscriptions = new Map();
        this.graphqlSubscriptions = new Map();
        this.subscriptionChangeListeners = new Set();
        this.useRealTimeSubscriptions = false;
        // Track pending cache deletions to handle block moves (unmount/remount)
        // When a block is moved, the old component unmounts before the new one mounts,
        // causing the cache to be deleted prematurely. We delay deletion to allow
        // the new component to subscribe and cancel the pending deletion.
        this.pendingCacheDeletions = new Map();
        // backoff cap (gate ON)
        this.retryAttempts = new Map();
        this.pendingRetries = new Map();
        // Resources whose reconnection exhausted while the tab was hidden: parked here and
        // re-armed on the next online / visibilitychange→visible instead of surfacing a
        // terminal error. Only a re-armed attempt that also exhausts while visible fails.
        this.deferredExhausted = new Set();
        this.wakeDebounceTimer = null;
        // `online` always sweeps (network is back regardless of tab visibility); a
        // `visibilitychange` only sweeps when the tab became visible.
        this.onOnline = ()=>this.scheduleWakeSweep();
        this.onVisibilityChange = ()=>{
            if (!this.isDocumentHidden()) this.scheduleWakeSweep();
        };
        // Cleanup fns returned by `bind` for the registered wake listeners; a non-empty
        // array means listeners are currently registered. Emptied on teardown.
        this.wakeListenerCleanups = [];
    }
}
// Reconnection with exponential backoff.
$0a36060a48fcf8c9$export$200c87d47b3d6e17.INITIAL_RETRY_DELAY_MS = 1000;
$0a36060a48fcf8c9$export$200c87d47b3d6e17.RETRY_BACKOFF_MULTIPLIER = 2;
$0a36060a48fcf8c9$export$200c87d47b3d6e17.MAX_RETRY_ATTEMPTS = 5;
// legacy (gate OFF)
$0a36060a48fcf8c9$export$200c87d47b3d6e17.MAX_RETRY_ATTEMPTS_HARDENED = 8;
// gate ON (EDITOR-7861)
$0a36060a48fcf8c9$export$200c87d47b3d6e17.MAX_RETRY_DELAY_MS = 30000;
// Coalesce wake-event bursts into one re-arm sweep to avoid a reconnection storm.
$0a36060a48fcf8c9$export$200c87d47b3d6e17.WAKE_DEBOUNCE_MS = 1000;
module.exports["SyncBlockSubscriptionManager"] = $0a36060a48fcf8c9$export$200c87d47b3d6e17;

});

parcelRegister("1MDPE", function(module, exports) {

var $jv11C = parcelRequire("jv11C");


var $ixfCV = parcelRequire("ixfCV");


var $79ir6 = parcelRequire("79ir6");


var $916Gd = parcelRequire("916Gd");


var $cduI2 = parcelRequire("cduI2");


var $d04Ge = parcelRequire("d04Ge");

/** Maximum time (ms) flush() will wait for in-flight block creations before proceeding. */ const $5851c127b5a56c3a$var$FLUSH_CREATION_AWAIT_TIMEOUT_MS = 1000;
/**
 * Window (ms) within which a repeated `syncedBlockDelete` emission for the same
 * resourceId is suppressed. The same logical removal can re-fire across
 * rebased/remote/redo transactions; a short window collapses those bursts to one
 * event while still allowing a genuine delete→recreate→delete later.
 */ const $5851c127b5a56c3a$var$DELETE_DEDUPE_WINDOW_MS = 5000;
class $5851c127b5a56c3a$export$9c6faa8962092f36 {
    /**
   * Register a callback to be invoked after flush() completes.
   * Used by the pm-plugin to dispatch a transaction so that
   * hasUnsavedBodiedSyncBlockChanges is recalculated in plugin state.
   */ registerFlushCompletionCallback(callback) {
        this.flushCompletionCallback = callback;
    }
    /**
   * Register a callback to be invoked when flush() timed out waiting for a
   * pending block creation and that creation subsequently completes. The
   * callback should trigger a deferred flush to persist the content that
   * was skipped due to the timeout. See EDITOR-7112.
   */ registerPostCreationFlushCallback(callback) {
        this.postCreationFlushCallback = callback;
    }
    setFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
        this.createExperience = (0, $cduI2.getCreateSourceExperience)(fireAnalyticsEvent);
        this.saveExperience = (0, $cduI2.getSaveSourceExperience)(fireAnalyticsEvent);
        this.deleteExperience = (0, $cduI2.getDeleteSourceExperience)(fireAnalyticsEvent);
        this.fetchSourceInfoExperience = (0, $cduI2.getFetchSourceInfoExperience)(fireAnalyticsEvent);
    }
    isSourceBlock(node) {
        return node.type.name === 'bodiedSyncBlock';
    }
    /**
   * Add/update a sync block node to/from the local cache
   * @param syncBlockNode - The sync block node to update
   */ updateSyncBlockData(syncBlockNode, isRemote) {
        try {
            if (this.viewMode === 'view') return false;
            if (!this.isSourceBlock(syncBlockNode)) throw new Error('Invalid sync block node type provided for updateSyncBlockData');
            const { localId: localId, resourceId: resourceId } = syncBlockNode.attrs;
            if (!localId || !resourceId) {
                // Identifiers not populated yet: benign timing case, skip as a no-op.
                if ((0, $ixfCV.fg)('platform_editor_blocks_patch_4')) return false;
                throw new Error('Local ID or resource ID is not set');
            }
            const cachedBlock = this.syncBlockCache.get(resourceId);
            // Fast path: if the PM content fragment hasn't changed, skip serialization entirely
            // Fragment.eq() leverages ProseMirror's structural sharing for O(1) comparison
            if (cachedBlock?.contentFragment?.eq(syncBlockNode.content)) return true;
            const syncBlockData = (0, $d04Ge.convertSyncBlockPMNodeToSyncBlockData)(syncBlockNode);
            if (cachedBlock && !isRemote) this.hasReceivedContentChange = true;
            const isDirty = !isRemote || !cachedBlock; // if the change is not remote, or the block is not in the cache yet, it's dirty
            this.syncBlockCache.set(resourceId, {
                ...syncBlockData,
                isDirty: isDirty,
                // if the change is from remote, it's not dirty
                contentFragment: syncBlockNode.content,
                status: cachedBlock?.status
            });
            return true;
        } catch (error) {
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            // We can derive the product from `syncBlockNode.attrs.resourceId` even though
            // the variable wasn't destructured (the destructuring step itself may have thrown).
            this.fireAnalyticsEvent?.((0, $916Gd.updateCacheErrorPayload)(error.message, syncBlockNode?.attrs?.resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(syncBlockNode?.attrs?.resourceId)));
            return false;
        }
    }
    /**
   * Save content of bodiedSyncBlock nodes in local cache to backend
   *
   * @returns true if saving all nodes successfully, false if fail to save some/all nodes
   */ async flush() {
        try {
            if (this.viewMode === 'view') return true;
            // Wait (up to FLUSH_CREATION_AWAIT_TIMEOUT_MS) for any in-flight
            // block creations to complete before iterating the cache. Without
            // this, blocks created from existing content are skipped
            // (isPendingCreation check below) and if no further edits are made,
            // no subsequent flush is triggered — causing references to show an
            // "unpublished" error.
            // If the timeout expires, any block whose creation is still
            // in-flight is recorded in `creationsTimedOutDuringFlush` so that
            // `commitPendingCreation()` can trigger a follow-up flush once that
            // specific creation completes.
            // See EDITOR-7112.
            if (this.pendingCreationPromises.size > 0) {
                let timedOut = false;
                let timeoutId;
                const timeout = new Promise((resolve)=>{
                    timeoutId = setTimeout(()=>{
                        timedOut = true;
                        resolve();
                    }, $5851c127b5a56c3a$var$FLUSH_CREATION_AWAIT_TIMEOUT_MS);
                });
                await Promise.race([
                    Promise.all(this.pendingCreationPromises.values()),
                    timeout
                ]);
                if (timeoutId !== undefined) clearTimeout(timeoutId);
                if (timedOut) // Record every still-in-flight creation so each late
                // completion is tracked independently.
                for (const resourceId of this.pendingCreationPromises.keys())this.creationsTimedOutDuringFlush.add(resourceId);
            }
            const bodiedSyncBlockNodes = [];
            const bodiedSyncBlockData = [];
            Array.from(this.syncBlockCache.values()).forEach((syncBlockData)=>{
                // Don't flush nodes that
                // - are waiting to be deleted to avoid nodes being re-created
                // - haven't been updated since we last flushed
                // - are still pending BE creation
                if (!syncBlockData.pendingDeletion && syncBlockData.isDirty && !this.isPendingCreation(syncBlockData.resourceId)) {
                    bodiedSyncBlockNodes.push({
                        type: 'bodiedSyncBlock',
                        attrs: {
                            localId: syncBlockData.blockInstanceId,
                            resourceId: syncBlockData.resourceId
                        }
                    });
                    // reset isDirty early to prevent race condition
                    // There is a race condition where if a user makes changes to a source sync block
                    // on a live page and the source sync block is being saved while the user
                    // is still making changes, the new changes might not be saved if they all happen
                    // exactly at a time when the writeNodesData is being executed asynchronously.
                    syncBlockData.isDirty = false;
                    // When flushing, set status to 'active' so the block is published
                    const dataToFlush = {
                        ...syncBlockData,
                        status: 'active'
                    };
                    bodiedSyncBlockData.push(dataToFlush);
                }
            });
            if (bodiedSyncBlockNodes.length === 0) return Promise.resolve(true);
            if (!this.dataProvider) throw new Error('Data provider not set');
            this.saveExperience?.start({});
            const writeResults = await this.dataProvider.writeNodesData(bodiedSyncBlockNodes, bodiedSyncBlockData);
            writeResults.forEach((result)=>{
                // set isDirty to true for cases where it failed to save the sync block to the BE
                if (result.resourceId && result.error && result.error !== (0, $79ir6.SyncBlockError).NotFound) {
                    const cachedData = this.syncBlockCache.get(result.resourceId);
                    if (cachedData) cachedData.isDirty = true;
                }
            });
            if (writeResults.every((result)=>result.resourceId && !result.error)) {
                this.saveExperience?.success();
                writeResults.forEach((result)=>{
                    if (result.resourceId && !result.error) {
                        // Update cache with the status returned from the backend
                        const cachedData = this.syncBlockCache.get(result.resourceId);
                        if (cachedData && result.status) cachedData.status = result.status;
                        this.fireAnalyticsEvent?.((0, $916Gd.updateSuccessPayload)(result.resourceId, false, (0, $d04Ge.getSourceProductFromResourceIdSafe)(result.resourceId)));
                    }
                });
                return true;
            } else {
                this.saveExperience?.failure();
                const attributionEnabled = (0, $ixfCV.fg)('platform_editor_blocks_patch_3');
                writeResults.filter((result)=>!result.resourceId || result.error).forEach((result)=>{
                    this.fireAnalyticsEvent?.((0, $916Gd.updateErrorPayload)(result.error || 'Failed to write data', result.resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(result.resourceId), (0, $916Gd.buildErrorAttribution)(attributionEnabled, result.error, result.statusCode)));
                });
                return false;
            }
        } catch (error) {
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            // Top-level flush failure is not tied to a single resourceId. There is no structured
            // SyncBlockError/status here, so the attribution `reason` falls back to `unknown`.
            this.fireAnalyticsEvent?.((0, $916Gd.updateErrorPayload)(error.message, undefined, undefined, (0, $916Gd.buildErrorAttribution)((0, $ixfCV.fg)('platform_editor_blocks_patch_3'))));
            return false;
        } finally{
            this.flushCompletionCallback?.();
        }
    }
    hasUnsavedChanges() {
        if (this.viewMode === 'view') return false;
        // Only track unsaved changes in source synced block for live pages
        // classic pages's draft don't publish synced block content to block service and the content itself is saved as part of the draft
        // classic page's publish flow will trigger a flush which only uses the isDirty flag to determine if there are unsaved changes
        if (!this.isLivePage) return false;
        return this.hasReceivedContentChange && Array.from(this.syncBlockCache.values()).some((syncBlockData)=>syncBlockData.isDirty);
    }
    isPendingCreation(resourceId) {
        return this.creationCompletionCallbacks.has(resourceId);
    }
    /**
   * Returns `true` when at least one sync block is waiting for its backend
   * creation call to complete. Used as a cheap pre-check in the decoration
   * rebuild path to avoid a full `doc.descendants()` walk when no creations
   * are in flight (see EDITOR-6930).
   */ hasPendingCreations() {
        return this.creationCompletionCallbacks.size > 0;
    }
    /**
   *  Fires callback to insert node (if creation is successful) and clears pending creation data
   * @param success
   */ commitPendingCreation(success, resourceId) {
        if (this.viewMode === 'view') return;
        const onCompletion = this.creationCompletionCallbacks.get(resourceId);
        if (onCompletion) {
            this.creationCompletionCallbacks.delete(resourceId);
            onCompletion(success);
            // If a previous flush() timed out waiting for this specific
            // creation, drop it from the tracking set regardless of outcome so
            // it does not leak. See EDITOR-7112.
            const wasTimedOut = this.creationsTimedOutDuringFlush.delete(resourceId);
            if (success) {
                // If creation is successful, set hasReceivedContentChange to true
                // to indicate that there are unsaved changes in the cache
                this.hasReceivedContentChange = true;
                // If flush() timed out waiting for this creation, notify the
                // plugin so it can trigger a deferred flush. See EDITOR-7112.
                if (wasTimedOut) this.postCreationFlushCallback?.();
            }
        } else this.fireAnalyticsEvent?.((0, $916Gd.createErrorPayload)('creation complete callback missing', resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId)));
        if (success) {
            const sourceProduct = (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId);
            this.fireAnalyticsEvent?.((0, $916Gd.createSuccessPayload)(resourceId || '', sourceProduct));
            // Operational create-success event with the join key + creation-type
            // signals (inputMethod / createdEmpty) captured at the command layer.
            if ((0, $ixfCV.fg)('platform_editor_blocks_patch_4')) this.fireAnalyticsEvent?.((0, $916Gd.createSuccessOperationalPayload)(resourceId || '', this.syncBlockCache.get(resourceId)?.blockInstanceId, sourceProduct, this.creationEnrichment.get(resourceId)));
        } else {
            // Delete the node from cache if fail to create so it's not flushed to BE
            this.syncBlockCache.delete(resourceId || '');
            // Creation failed, so there is no block to add content to — drop the
            // first-content tracking entry so a later unrelated edit cannot fire it.
            this.awaitingFirstContent.delete(resourceId || '');
            this.fireAnalyticsEvent?.((0, $916Gd.createErrorPayload)('Fail to create bodied sync block', resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId)));
        }
        // Enrichment is single-use — drop it once the create has resolved either way.
        this.creationEnrichment.delete(resourceId || '');
    }
    /**
   * Fire the first-content-added event once when a block created empty this
   * session first gains content. The caller detects the in-block edit; this owns
   * dedupe + emission (fires at most once per block, only for empty→content).
   * Gated behind `platform_editor_blocks_patch_4`.
   */ maybeEmitFirstContentAdded(resourceId, blockInstanceId) {
        if (this.viewMode === 'view') return;
        if (!(0, $ixfCV.fg)('platform_editor_blocks_patch_4')) return;
        // `delete` returns false when the id was not tracked (already emitted, or
        // the block was not created empty this session), so this both dedupes and
        // scopes emission to genuine first-content transitions in one check.
        if (!this.awaitingFirstContent.delete(resourceId)) return;
        this.fireAnalyticsEvent?.((0, $916Gd.addContentSuccessPayload)(resourceId, blockInstanceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId)));
    }
    registerConfirmationCallback(callback) {
        this.confirmationCallback = callback;
        return ()=>{
            this.confirmationCallback = undefined;
        };
    }
    requireConfirmationBeforeDelete() {
        return !!this.confirmationCallback;
    }
    /**
   * @returns attributes for a new bodiedSyncBlock node
   */ generateBodiedSyncBlockAttrs() {
        if (!this.dataProvider) throw new Error('Data provider not set or source id not set');
        const { resourceId: resourceId, localId: localId } = this.dataProvider.generateResourceId();
        return {
            resourceId: resourceId,
            localId: localId
        };
    }
    /**
   * Create a bodiedSyncBlock node with empty content to backend
   * @param attrs attributes Ids of the node
   * @param node the ProseMirror node to cache
   * @param onCompletion callback invoked when creation completes
   * @param enrichment optional creation-type signals stashed and attached to the
   *   `syncedBlockCreate` event when the async create resolves. When
   *   `createdEmpty` is true the block is also registered for the
   *   first-content-added event.
   */ createBodiedSyncBlockNode(attrs, node, onCompletion, enrichment) {
        if (this.viewMode === 'view') return;
        const { resourceId: resourceId, localId: blockInstanceId } = attrs;
        // Stash creation-type signals for commitPendingCreation to read.
        if (enrichment) {
            this.creationEnrichment.set(resourceId, enrichment);
            // Only empty-created blocks can produce an empty→content transition.
            if (enrichment.createdEmpty) this.awaitingFirstContent.add(resourceId);
        }
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            // add the node to the cache
            this.updateSyncBlockData(node, false);
            // Mark the block as unpublished in the cache so it can be cleaned up on cancel
            const cached = this.syncBlockCache.get(resourceId);
            if (cached) cached.status = 'unpublished';
            this.creationCompletionCallbacks.set(resourceId, onCompletion);
            this.createExperience?.start({});
            const creationPromise = this.dataProvider.createNodeData({
                content: [],
                blockInstanceId: blockInstanceId,
                resourceId: resourceId
            }).then((result)=>{
                const resourceId = result.resourceId || '';
                if (resourceId && !result.error) {
                    this.commitPendingCreation(true, resourceId);
                    this.createExperience?.success();
                } else {
                    this.commitPendingCreation(false, resourceId);
                    this.createExperience?.failure({
                        reason: result.error || 'Failed to create bodied sync block'
                    });
                    this.fireAnalyticsEvent?.((0, $916Gd.createErrorPayload)(result.error || 'Failed to create bodied sync block', resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId), (0, $916Gd.buildErrorAttribution)((0, $ixfCV.fg)('platform_editor_blocks_patch_3'), result.error, result.statusCode)));
                }
            }).catch((error)=>{
                this.commitPendingCreation(false, resourceId);
                (0, $jv11C.logException)(error, {
                    location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
                });
                this.createExperience?.failure({
                    reason: error.message
                });
                this.fireAnalyticsEvent?.((0, $916Gd.createErrorPayload)(error.message, resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId)));
            }).finally(()=>{
                this.pendingCreationPromises.delete(resourceId);
            });
            this.pendingCreationPromises.set(resourceId, creationPromise);
        } catch (error) {
            if (this.isPendingCreation(resourceId)) this.commitPendingCreation(false, resourceId);
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $916Gd.createErrorPayload)(error.message, resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId)));
        }
    }
    /**
   * Drop dedupe entries older than {@link DELETE_DEDUPE_WINDOW_MS} so
   * `recentDeleteEmissions` stays bounded by the number of recent deletes.
   */ pruneRecentDeleteEmissions(now) {
        for (const [resourceId, emittedAt] of this.recentDeleteEmissions)if (now - emittedAt >= $5851c127b5a56c3a$var$DELETE_DEDUPE_WINDOW_MS) this.recentDeleteEmissions.delete(resourceId);
    }
    /**
   * Emit the `syncedBlockDelete` success event. Gate off: legacy payload. Gate
   * on: attaches `deletionReason`, `mechanism` and `blockInstanceId`, and
   * suppresses repeat emissions within {@link DELETE_DEDUPE_WINDOW_MS}. Must run
   * while the cache entry still exists so `blockInstanceId` is available.
   */ emitDeleteSuccess(resourceId, reason, mechanism) {
        const sourceProduct = (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId);
        if (!(0, $ixfCV.fg)('platform_editor_blocks_patch_4')) {
            this.fireAnalyticsEvent?.((0, $916Gd.deleteSuccessPayload)(resourceId, sourceProduct));
            return;
        }
        const now = Date.now();
        const lastEmittedAt = this.recentDeleteEmissions.get(resourceId);
        if (lastEmittedAt !== undefined && now - lastEmittedAt < $5851c127b5a56c3a$var$DELETE_DEDUPE_WINDOW_MS) return; // duplicate emission for the same logical removal
        this.pruneRecentDeleteEmissions(now);
        this.recentDeleteEmissions.set(resourceId, now);
        const enrichment = {
            blockInstanceId: this.syncBlockCache.get(resourceId)?.blockInstanceId,
            deletionReason: reason,
            mechanism: mechanism
        };
        this.fireAnalyticsEvent?.((0, $916Gd.deleteSuccessPayload)(resourceId, sourceProduct, enrichment));
    }
    async delete(syncBlockIds, onDelete, onDeleteCompleted, reason, mechanism) {
        try {
            if (this.viewMode === 'view') return false;
            if (!this.dataProvider) throw new Error('Data provider not set');
            syncBlockIds.forEach((Ids)=>{
                this.setPendingDeletion(Ids, true);
            });
            this.deleteExperience?.start({});
            const results = await this.dataProvider.deleteNodesData(syncBlockIds.map((attrs)=>attrs.resourceId), reason);
            let callback;
            const isDeleteSuccessful = results.every((result)=>result.success);
            onDeleteCompleted(isDeleteSuccessful);
            if (isDeleteSuccessful) {
                onDelete();
                // Emit before the cache entry is deleted below, so blockInstanceId
                // is still available to emitDeleteSuccess.
                results.forEach((result)=>{
                    this.emitDeleteSuccess(result.resourceId, reason, mechanism);
                });
                callback = (Ids)=>this.syncBlockCache.delete(Ids.resourceId);
                this.clearPendingDeletion();
                this.deleteExperience?.success();
            } else {
                callback = (Ids)=>{
                    this.setPendingDeletion(Ids, false);
                };
                this.deleteExperience?.failure();
                const attributionEnabled = (0, $ixfCV.fg)('platform_editor_blocks_patch_3');
                results.forEach((result)=>{
                    if (result.success) this.emitDeleteSuccess(result.resourceId, reason, mechanism);
                    else this.fireAnalyticsEvent?.((0, $916Gd.deleteErrorPayload)(result.error || 'Failed to delete synced block', result.resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(result.resourceId), (0, $916Gd.buildErrorAttribution)(attributionEnabled, result.error, result.statusCode)));
                });
            }
            syncBlockIds.forEach(callback);
            return isDeleteSuccessful;
        } catch (error) {
            // Thrown (non-result) failure — no structured SyncBlockError/status is available,
            // so the attribution `reason` falls back to `unknown` when the gate is on.
            const attribution = (0, $916Gd.buildErrorAttribution)((0, $ixfCV.fg)('platform_editor_blocks_patch_3'));
            syncBlockIds.forEach((Ids)=>{
                this.setPendingDeletion(Ids, false);
                this.fireAnalyticsEvent?.((0, $916Gd.deleteErrorPayload)(error.message, Ids.resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(Ids.resourceId), attribution));
            });
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            onDeleteCompleted(false);
            return false;
        }
    }
    isRetryingDeletion() {
        return !!this.deletionRetryInfo;
    }
    async retryDeletion() {
        if (this.viewMode === 'view') return Promise.resolve();
        if (!this.deletionRetryInfo) return Promise.resolve();
        const { syncBlockIds: syncBlockIds, onDelete: onDelete, onDeleteCompleted: onDeleteCompleted, deletionReason: deletionReason, mechanism: mechanism } = this.deletionRetryInfo;
        if (this.confirmationCallback) await this.delete(syncBlockIds, onDelete, onDeleteCompleted, deletionReason, mechanism);
    }
    clearPendingDeletion() {
        this.deletionRetryInfo?.destroyCallback();
        this.deletionRetryInfo = undefined;
    }
    /**
   * Fetches the current status of all source sync blocks in the cache from the backend
   * and updates the cache entries with the fetched status.
   * This is called on editor init so we know which blocks are 'unpublished' vs 'active'.
   */ async fetchAndCacheStatuses() {
        if (!this.dataProvider || this.syncBlockCache.size === 0) return;
        // Source blocks have plain UUID resourceIds, but fetchNodesData internally uses
        // generateBlockAriFromReference which expects reference-format resourceIds
        // (e.g. "confluence-page/pageId/uuid"). We convert source resourceIds to reference
        // format before fetching, and maintain a mapping back to original resourceIds
        // so we can update the correct cache entries.
        const sourceToReferenceMap = new Map();
        const syncBlockNodes = Array.from(this.syncBlockCache.entries()).map(([resourceId, data])=>{
            const referenceResourceId = this.dataProvider?.generateResourceIdForReference(resourceId) ?? resourceId;
            sourceToReferenceMap.set(referenceResourceId, resourceId);
            return {
                type: 'bodiedSyncBlock',
                attrs: {
                    localId: data.blockInstanceId,
                    resourceId: referenceResourceId
                }
            };
        });
        try {
            const results = await this.dataProvider.fetchNodesData(syncBlockNodes);
            for (const result of results){
                // Map the reference resourceId back to the source resourceId
                const sourceResourceId = sourceToReferenceMap.get(result.resourceId) ?? result.resourceId;
                const cached = this.syncBlockCache.get(sourceResourceId);
                if (cached && result.data?.status) cached.status = result.data.status;
            }
        } catch  {
        // If the fetch fails, statuses remain undefined.
        // This is acceptable — on cancel, blocks without a known status
        // will not be deleted (safe default).
        }
    }
    /**
   * Deletes all source sync blocks that have 'unpublished' status.
   * Used to clean up orphaned blocks when a user cancels editing without saving.
   * Blocks that were already saved (status 'active') are not affected.
   *
   * @returns true if all deletions succeeded, false otherwise
   */ discardUnpublishedBlocks() {
        const unpublishedBlockIds = Array.from(this.syncBlockCache.entries()).filter(([_, data])=>data.status === 'unpublished' && !data.pendingDeletion).map(([resourceId, data])=>({
                resourceId: resourceId,
                localId: data.blockInstanceId
            }));
        if (unpublishedBlockIds.length === 0) return Promise.resolve(true);
        return this.delete(unpublishedBlockIds, ()=>{}, // onDelete: no-op, document is being discarded
        ()=>{}, // onDeleteCompleted: no-op
        'source-block-unpublished', // Cancel/discard cleanup is code-initiated, not a direct user edit.
        'other');
    }
    /**
   * Deletes sync blocks with confirmation from the backend
   *
   * @param syncBlockIds - The sync block ids to delete
   * @param onDelete - The callback to delete sync block node from document
   * @param onDeleteCompleted - The callback for after the deletion is saved to BE (whether successful or not)
   * @param destroyCallback - The callback to clear any reference stored for deletion (regardless if deletion is completed or abort)
   */ async deleteSyncBlocksWithConfirmation(syncBlockIds, deletionReason, onDelete, onDeleteCompleted, destroyCallback, mechanism) {
        if (this.viewMode === 'view') return Promise.resolve();
        if (this.confirmationCallback) {
            const confirmed = await this.confirmationCallback(syncBlockIds, deletionReason);
            if (confirmed) {
                const isDeleteSuccessful = await this.delete(syncBlockIds, onDelete, onDeleteCompleted, deletionReason, mechanism);
                if (!isDeleteSuccessful) // If deletion failed, save deletion info for potential retry
                this.deletionRetryInfo = {
                    syncBlockIds: syncBlockIds,
                    onDelete: onDelete,
                    onDeleteCompleted: onDeleteCompleted,
                    destroyCallback: destroyCallback,
                    deletionReason: deletionReason,
                    mechanism: mechanism
                };
                else destroyCallback();
            } else destroyCallback();
        }
    }
    getSyncBlockSourceInfo(localId) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            this.fetchSourceInfoExperience?.start();
            return this.dataProvider.fetchSyncBlockSourceInfo(localId, undefined, undefined).then((sourceInfo)=>{
                if (!sourceInfo) this.fetchSourceInfoExperience?.failure({
                    reason: 'No source info returned'
                });
                else this.fetchSourceInfoExperience?.success();
                return sourceInfo;
            });
        } catch (error) {
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $916Gd.getSourceInfoErrorPayload)(error.message));
            return Promise.resolve(undefined);
        }
    }
    fetchReferences(resourceId) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            return this.dataProvider.fetchReferences(resourceId, true);
        } catch (error) {
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $916Gd.fetchReferencesErrorPayload)(error.message, resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId)));
            return Promise.resolve({
                error: (0, $79ir6.SyncBlockError).Errored
            });
        }
    }
    destroy() {
        this.syncBlockCache.clear();
        this.confirmationCallback = undefined;
        this.creationCompletionCallbacks.clear();
        this.flushCompletionCallback = undefined;
        this.postCreationFlushCallback = undefined;
        this.pendingCreationPromises.clear();
        this.creationsTimedOutDuringFlush.clear();
        this.creationEnrichment.clear();
        this.awaitingFirstContent.clear();
        this.recentDeleteEmissions.clear();
        this.dataProvider = undefined;
        this.saveExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.createExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.deleteExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.fetchSourceInfoExperience?.abort({
            reason: 'editorDestroyed'
        });
        this.clearPendingDeletion();
    }
    constructor(dataProvider, viewMode, isLivePage){
        this.viewMode = void 0;
        this.isLivePage = void 0;
        this.dataProvider = void 0;
        this.fireAnalyticsEvent = void 0;
        this.syncBlockCache = void 0;
        this.hasReceivedContentChange = false;
        this.confirmationCallback = void 0;
        this.deletionRetryInfo = void 0;
        this.creationCompletionCallbacks = void 0;
        this.flushCompletionCallback = void 0;
        this.postCreationFlushCallback = void 0;
        /**
     * Promises for in-flight block creations, keyed by resourceId.
     * `flush()` awaits these so that blocks created from existing content are
     * persisted even if no further edits trigger a subsequent flush.
     * See EDITOR-7112.
     */ this.pendingCreationPromises = new Map();
        /**
     * Set of resource IDs whose creation was still in-flight when a `flush()`
     * timed out. Each completion (success or failure) is removed from this set;
     * the first successful completion of any of these IDs triggers
     * `postCreationFlushCallback` so the content is eventually persisted.
     * Tracking IDs (not just a boolean) avoids dropping late completions when
     * multiple blocks are created concurrently. See EDITOR-7112.
     */ this.creationsTimedOutDuringFlush = new Set();
        /**
     * Creation-type signals captured at `createBodiedSyncBlockNode` time and read
     * back in `commitPendingCreation` to enrich the `syncedBlockCreate` event.
     * Kept out of the flushed cache record so it never leaks into Block Service /
     * ADF; removed once consumed.
     */ this.creationEnrichment = new Map();
        /**
     * Resource IDs of blocks created empty this session that have not yet fired
     * the first-content-added event. Added on empty creation, removed when the
     * block first gains content (the event fires once). Blocks created with
     * content or not created this session are never tracked.
     */ this.awaitingFirstContent = new Set();
        this.createExperience = void 0;
        this.saveExperience = void 0;
        this.deleteExperience = void 0;
        this.fetchSourceInfoExperience = void 0;
        /**
     * resourceId -> timestamp (ms) of the last `syncedBlockDelete` emission, used
     * to suppress duplicates within {@link DELETE_DEDUPE_WINDOW_MS}. Only consulted
     * behind `platform_editor_blocks_patch_4`.
     */ this.recentDeleteEmissions = new Map();
        this.setPendingDeletion = (Ids, value)=>{
            if (this.viewMode === 'view') return;
            const syncBlock = this.syncBlockCache.get(Ids.resourceId);
            if (syncBlock) syncBlock.pendingDeletion = value;
        };
        this.dataProvider = dataProvider;
        this.viewMode = viewMode;
        this.isLivePage = isLivePage;
        this.syncBlockCache = new Map();
        this.creationCompletionCallbacks = new Map();
    }
}
module.exports["SourceSyncBlockStoreManager"] = $5851c127b5a56c3a$export$9c6faa8962092f36;

});

parcelRegister("i2lVL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $c17e087269191e3c$var$SyncBlockActionsContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $c17e087269191e3c$export$1536d3aa2f6b9cd9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($c17e087269191e3c$var$SyncBlockActionsContext);
} : ()=>{
    return (0, $cozmU.useContext)($c17e087269191e3c$var$SyncBlockActionsContext);
};
const $c17e087269191e3c$export$5f0b55764d1d819f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, removeSyncBlock: removeSyncBlock, fetchSyncBlockSourceInfo: fetchSyncBlockSourceInfo } = t0;
    let t1;
    if ($[0] !== fetchSyncBlockSourceInfo || $[1] !== removeSyncBlock) {
        t1 = {
            deleteSyncBlock: removeSyncBlock,
            fetchSourceInfo: fetchSyncBlockSourceInfo
        };
        $[0] = fetchSyncBlockSourceInfo;
        $[1] = removeSyncBlock;
        $[2] = t1;
    } else t1 = $[2];
    const value = t1;
    let t2;
    if ($[3] !== children || $[4] !== value) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c17e087269191e3c$var$SyncBlockActionsContext.Provider, {
            value: value
        }, children);
        $[3] = children;
        $[4] = value;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ children: children, removeSyncBlock: removeSyncBlock, fetchSyncBlockSourceInfo: fetchSyncBlockSourceInfo })=>{
    const value = (0, $cozmU.useMemo)(()=>({
            deleteSyncBlock: removeSyncBlock,
            fetchSourceInfo: fetchSyncBlockSourceInfo
        }), [
        removeSyncBlock,
        fetchSyncBlockSourceInfo
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c17e087269191e3c$var$SyncBlockActionsContext.Provider, {
        value: value
    }, children);
};
module.exports["useSyncBlockActions"] = $c17e087269191e3c$export$1536d3aa2f6b9cd9;
module.exports["SyncBlockActionsProvider"] = $c17e087269191e3c$export$5f0b55764d1d819f;

});

parcelRegister("4cJIQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4iudd = parcelRequire("4iudd");


var $jv11C = parcelRequire("jv11C");


var $ixfCV = parcelRequire("ixfCV");


var $79ir6 = parcelRequire("79ir6");


var $916Gd = parcelRequire("916Gd");


var $d04Ge = parcelRequire("d04Ge");

const $c9f3028cf767214f$export$2b02427d5640395b = (manager, resourceId, localId, fireAnalyticsEvent)=>{
    // Initialize both states from a single cache lookup to avoid race conditions.
    // When a block is moved/remounted, the old component's cleanup may clear the cache
    // before or after the new component mounts. By doing a single lookup, we ensure
    // consistency between syncBlockInstance and isLoading initial values.
    const [{ syncBlockInstance: syncBlockInstance, isLoading: isLoading }, setFetchState] = (0, $cozmU.useState)(()=>{
        if (resourceId) {
            const initialData = manager?.referenceManager?.getInitialSyncBlockData(resourceId);
            return {
                syncBlockInstance: initialData ?? null,
                isLoading: initialData === undefined
            };
        }
        return {
            syncBlockInstance: null,
            isLoading: true
        };
    });
    // On Jira the data provider is wired asynchronously, so the manager can be
    // constructed with `dataProvider === undefined`. Fetching/subscribing in that
    // window throws `Data provider not set`, logged as a false fetch error
    // (EDITOR-7860). Gate on readiness; once the provider resolves a new manager
    // instance is created so `referenceManager` changes identity and the effect
    // below re-runs, subscribing exactly once.
    const isDataProviderReady = (0, $ixfCV.fg)('platform_editor_blocks_patch_3') ? manager.referenceManager.hasDataProvider?.() ?? false : true;
    const reloadData = (0, $cozmU.useCallback)(async ()=>{
        if (isLoading) return;
        // Not ready: skip fetch, emit no error (see readiness note above).
        if (!isDataProviderReady) return;
        try {
            const syncBlockNode = resourceId && localId ? (0, $d04Ge.createSyncBlockNode)(localId, resourceId) : null;
            if (!syncBlockNode) throw new Error('Failed to create sync block node from resourceid and localid');
            setFetchState((prev)=>({
                    ...prev,
                    isLoading: true
                }));
            // Fetch sync block data, the `subscribeToSyncBlock` will update the state once data is fetched
            await manager.referenceManager.fetchSyncBlocksData([
                syncBlockNode
            ]);
        } catch (error) {
            // EDITOR-7860: benign not-ready throw — emit no error and stay loading
            // so it resolves on retry once the provider is wired. Checked before
            // `logException` so the benign case produces no exception-tracker noise.
            // Gate-off behaviour is unchanged.
            if ((0, $79ir6.isProviderNotReadyError)(error) && (0, $ixfCV.fg)('platform_editor_blocks_patch_3')) {
                setFetchState((prev)=>({
                        ...prev,
                        isLoading: true
                    }));
                return;
            }
            (0, $jv11C.logException)(error, {
                location: 'editor-synced-block-provider/useFetchSyncBlockData'
            });
            fireAnalyticsEvent?.((0, $916Gd.fetchErrorPayload)(error.message, resourceId, (0, $d04Ge.getSourceProductFromResourceIdSafe)(resourceId), (0, $916Gd.buildFetchErrorAttribution)((0, $ixfCV.fg)('platform_editor_blocks_patch_3'), error.message)));
            // Thread the PII-safe original message/name so the renderer can de-opaque
            // this otherwise-bare `errored` failure. `originalMessage` carries the
            // Error.message and is preferred over `reason` by the renderer, so no
            // separate `reason` is set here.
            setFetchState({
                syncBlockInstance: {
                    resourceId: resourceId || '',
                    error: {
                        type: (0, $79ir6.SyncBlockError).Errored,
                        ...(0, $916Gd.getPiiSafeOriginalError)(error)
                    }
                },
                isLoading: false
            });
            return;
        }
        setFetchState((prev)=>({
                ...prev,
                isLoading: false
            }));
    }, [
        isLoading,
        isDataProviderReady,
        localId,
        manager.referenceManager,
        resourceId,
        fireAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $4iudd.isSSR)()) // in SSR, we don't need to subscribe to updates,
        // instead we rely on pre-fetched data ONLY, see initialization of syncBlockInstance above
        return;
        // Not ready: skip subscribe (it would trigger a batched fetch and a false
        // error) and keep `isLoading: true`. `isDataProviderReady` is in the deps,
        // so the effect re-runs and subscribes once the provider resolves.
        if (!isDataProviderReady) return;
        const unsubscribe = manager.referenceManager.subscribeToSyncBlock(resourceId || '', localId || '', (data)=>{
            setFetchState({
                syncBlockInstance: data,
                isLoading: false
            });
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        isDataProviderReady,
        localId,
        manager.referenceManager,
        resourceId
    ]);
    const ssrProviders = (0, $cozmU.useMemo)(()=>{
        return resourceId ? manager.referenceManager.getSSRProviders(resourceId) : null;
    }, [
        resourceId,
        manager.referenceManager
    ]);
    return {
        isLoading: isLoading,
        ssrProviders: ssrProviders,
        providerFactory: manager.referenceManager.getProviderFactory(resourceId || ''),
        reloadData: reloadData,
        syncBlockInstance: syncBlockInstance
    };
};
module.exports["useFetchSyncBlockData"] = $c9f3028cf767214f$export$2b02427d5640395b;

});

parcelRegister("eO7Q2", function(module, exports) {
/**
 * URL to the Atlassian support documentation for synced blocks in Confluence Cloud.
 */ const $9b8564145c0d1038$export$81b3a92cdfa3191b = 'https://support.atlassian.com/confluence-cloud/docs/reuse-content-with-synced-blocks';
module.exports["SYNCED_BLOCKS_DOCUMENTATION_URL"] = $9b8564145c0d1038$export$81b3a92cdfa3191b;

});

parcelRegister("4nt1R", function(module, exports) {
// #region Imports

var $a31lS = parcelRequire("a31lS");


var $5C5Mq = parcelRequire("5C5Mq");


var $1CaNG = parcelRequire("1CaNG");


var $7Upsh = parcelRequire("7Upsh");


var $lK9Pz = parcelRequire("lK9Pz");


var $jLogi = parcelRequire("jLogi");


var $fKdaf = parcelRequire("fKdaf");


var $5VZEy = parcelRequire("5VZEy");


var $ifkCZ = parcelRequire("ifkCZ");


var $bkj40 = parcelRequire("bkj40");


var $e6Dq9 = parcelRequire("e6Dq9");


var $lDJPY = parcelRequire("lDJPY");


var $1ZhW4 = parcelRequire("1ZhW4");


var $2QN3e = parcelRequire("2QN3e");


var $e273U = parcelRequire("e273U");


var $h0KOi = parcelRequire("h0KOi");


var $5tMpU = parcelRequire("5tMpU");


var $4Kyof = parcelRequire("4Kyof");


var $6WRJZ = parcelRequire("6WRJZ");


var $3HCXM = parcelRequire("3HCXM");


var $jT02V = parcelRequire("jT02V");


var $hYOOW = parcelRequire("hYOOW");


var $f3DNZ = parcelRequire("f3DNZ");


var $hBGxo = parcelRequire("hBGxo");


var $hHtwA = parcelRequire("hHtwA");


var $fb3SZ = parcelRequire("fb3SZ");


var $dxDD9 = parcelRequire("dxDD9");


var $ljXAk = parcelRequire("ljXAk");


var $grjTL = parcelRequire("grjTL");


var $4gNvG = parcelRequire("4gNvG");


var $d1HsG = parcelRequire("d1HsG");


var $ftAOO = parcelRequire("ftAOO");


var $abOD2 = parcelRequire("abOD2");


var $cjuKO = parcelRequire("cjuKO");


var $4lpx1 = parcelRequire("4lpx1");


var $lfQQe = parcelRequire("lfQQe");


var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $loGKD = parcelRequire("loGKD");

function $937c7699f4d8744a$export$4efc99f259929bff(options) {
    const isFullPage = (0, $loGKD.isFullPage)(options.appearance);
    const preset = new (0, $a31lS.EditorPresetBuilder)().add([
        (0, $h0KOi.featureFlagsPlugin),
        options.featureFlags || {}
    ]).maybeAdd([
        (0, $1CaNG.analyticsPlugin),
        {
            createAnalyticsEvent: options.createAnalyticsEvent,
            performanceTracking: options.performanceTracking
        }
    ], Boolean(options.allowAnalyticsGASV3)).add((0, $lK9Pz.betterTypeHistoryPlugin)).add([
        (0, $hYOOW.pastePlugin),
        {
            ...options?.paste,
            isFullPage: isFullPage
        }
    ]).add((0, $ifkCZ.default)).add((0, $4Kyof.focusPlugin)).maybeAdd([
        (0, $5C5Mq.userPreferencesPlugin),
        {
            initialUserPreferences: {
                toolbarDockingPosition: isFullPage ? 'none' : 'top'
            }
        }
    ], ()=>(0, $ixfCV.fg)('platform_editor_use_preferences_plugin')).maybeAdd((0, $jT02V.interactionPlugin), Boolean(options?.__livePage) || (0, $ieeJu.expValEquals)('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)).add((0, $e6Dq9.compositionPlugin)).add([
        (0, $lDJPY.contextIdentifierPlugin),
        {
            contextIdentifierProvider: options.contextIdentifierProvider
        }
    ]).add([
        (0, $7Upsh.default),
        options.base
    ]).add((0, $2QN3e.decorationsPlugin)).add([
        (0, $d1HsG.typeAheadPlugin),
        options.typeAhead
    ]).maybeAdd((0, $6WRJZ.default), Boolean(options.allowUndoRedoButtons)).add((0, $4lpx1.userIntentPlugin)).maybeAdd([
        (0, $4gNvG.toolbarPlugin),
        options.toolbar || {}
    ], Boolean(options.toolbar?.enableNewToolbarExperience)).add([
        (0, $hBGxo.primaryToolbarPlugin),
        {
            contextualFormattingEnabled: isFullPage
        }
    ]).maybeAdd((0, $ftAOO.uiControlRegistryPlugin), (0, $anBbz.expValEqualsNoExposure)('platform_editor_table_menu_updates', 'isEnabled', true) || (0, $anBbz.expValEqualsNoExposure)('platform_editor_layout_column_menu', 'isEnabled', true) || (0, $anBbz.expValEqualsNoExposure)('platform_editor_paste_actions_menu', 'isEnabled', true)).maybeAdd((0, $abOD2.undoRedoPlugin), Boolean(options.featureFlags?.undoRedoButtons ?? options.allowUndoRedoButtons)).maybeAdd([
        (0, $jLogi.blockMenuPlugin),
        {
            useStandardNodeWidth: options.blockMenu?.useStandardNodeWidth ?? false,
            blockLinkHashPrefix: options.blockMenu?.blockLinkHashPrefix,
            getLinkPath: options.blockMenu?.getLinkPath
        }
    ], Boolean(options.blockMenu?.enabled ?? false)).add([
        (0, $fKdaf.blockTypePlugin),
        {
            ...options.blockType,
            includeBlockQuoteAsTextstyleOption: isFullPage
        }
    ]).add((0, $5VZEy.clearMarksOnEmptyDocPlugin)).add([
        (0, $dxDD9.selectionToolbarPlugin),
        {
            preferenceToolbarAboveSelection: !!options.preferenceToolbarAboveSelection,
            contextualFormattingEnabled: isFullPage
        }
    ]).add([
        (0, $3HCXM.hyperlinkPlugin),
        {
            ...options.hyperlinkOptions,
            // @ts-ignore Temporary solution to check for Live Page editor.
            __livePage: options.__livePage
        }
    ]).add([
        (0, $grjTL.textFormattingPlugin),
        options.textFormatting
    ]).add((0, $lfQQe.widthPlugin)).add([
        (0, $hHtwA.quickInsertPlugin),
        options.quickInsert
    ]).add([
        (0, $f3DNZ.placeholderPlugin),
        options.placeholder
    ]).add((0, $cjuKO.unsupportedContentPlugin)).add([
        (0, $e273U.editorDisabledPlugin),
        {
            initialDisabledState: options.disabled
        }
    ]).add([
        (0, $ljXAk.submitEditorPlugin),
        options.submitEditor
    ]).add((0, $1ZhW4.copyButtonPlugin)).add((0, $5tMpU.floatingToolbarPlugin)).add([
        (0, $fb3SZ.selectionPlugin),
        {
            ...options.selection,
            __livePage: options.__livePage
        }
    ]).add([
        (0, $bkj40.default),
        options.codeBlock
    ]);
    return preset;
}
function $937c7699f4d8744a$export$a3add99b7c13b8f7(props) {
    const preset = $937c7699f4d8744a$export$4efc99f259929bff(props);
    return [
        preset
    ];
}
module.exports["createDefaultPreset"] = $937c7699f4d8744a$export$4efc99f259929bff;

});

parcelRegister("erHVE", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $786700e92aa2b215$export$31b2b7ff910ba1f3 = new (0, $kCECX.PluginKey)('editorToolbarPluginKey');
module.exports["editorToolbarPluginKey"] = $786700e92aa2b215$export$31b2b7ff910ba1f3;

});

parcelRegister("aBKty", function(module, exports) {

var $6EphZ = parcelRequire("6EphZ");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/confluence/site/manifest.ts
var $7b91693551a8064f$var$confluenceSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $6EphZ.ConfluenceSiteAriResourceOwner),
    resourceType: (0, $6EphZ.ConfluenceSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/confluence/site/index.ts
var $7b91693551a8064f$export$82e6693d75ffdd8 = class _ConfluenceSiteAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7b91693551a8064f$var$confluenceSiteAriStaticOpts.qualifier,
            platformQualifier: $7b91693551a8064f$var$confluenceSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $7b91693551a8064f$var$confluenceSiteAriStaticOpts.resourceOwner,
            resourceType: $7b91693551a8064f$var$confluenceSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $7b91693551a8064f$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $7b91693551a8064f$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["ConfluenceSiteAri"] = $7b91693551a8064f$export$82e6693d75ffdd8;

});

parcelRegister("6EphZ", function(module, exports) {
// src/confluence/site/types.ts
var $4d7a18635b736c71$export$9e07499cd8b0bde5 = "confluence", $4d7a18635b736c71$export$57b7cabbf31f1f68 = "site";
module.exports["ConfluenceSiteAriResourceOwner"] = $4d7a18635b736c71$export$9e07499cd8b0bde5;
module.exports["ConfluenceSiteAriResourceType"] = $4d7a18635b736c71$export$57b7cabbf31f1f68;

});

parcelRegister("fjKr7", function(module, exports) {

var $lGE71 = parcelRequire("lGE71");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/jira/issue/manifest.ts
var $b26ca6a6a4ea6688$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $lGE71.JiraIssueAriResourceOwner),
    resourceType: (0, $lGE71.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $b26ca6a6a4ea6688$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $b26ca6a6a4ea6688$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $b26ca6a6a4ea6688$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $b26ca6a6a4ea6688$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $b26ca6a6a4ea6688$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $b26ca6a6a4ea6688$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $b26ca6a6a4ea6688$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
};
module.exports["JiraIssueAri"] = $b26ca6a6a4ea6688$export$1da6808e89ee03e;

});

parcelRegister("lGE71", function(module, exports) {
// src/jira/issue/types.ts
var $fc9ca2abfea94195$export$665a39f1b4e29e0a = "jira", $fc9ca2abfea94195$export$76beb4d0da177ad4 = "issue";
module.exports["JiraIssueAriResourceOwner"] = $fc9ca2abfea94195$export$665a39f1b4e29e0a;
module.exports["JiraIssueAriResourceType"] = $fc9ca2abfea94195$export$76beb4d0da177ad4;

});

parcelRegister("aLUFu", function(module, exports) {

var $ilC9E = parcelRequire("ilC9E");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/townsquare/project/manifest.ts
var $7d7a404ac451d38c$var$townsquareProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $ilC9E.TownsquareProjectAriResourceOwner),
    resourceType: (0, $ilC9E.TownsquareProjectAriResourceType),
    resourceIdSlug: "{projectUuid}",
    resourceIdSegmentFormats: {
        projectUuid: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/townsquare/project/index.ts
var $7d7a404ac451d38c$export$41215e8d01921e7d = class _TownsquareProjectAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get projectUuid() {
        return this._projectUuid;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7d7a404ac451d38c$var$townsquareProjectAriStaticOpts.qualifier,
            platformQualifier: $7d7a404ac451d38c$var$townsquareProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $7d7a404ac451d38c$var$townsquareProjectAriStaticOpts.resourceOwner,
            resourceType: $7d7a404ac451d38c$var$townsquareProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectUuid}`,
            resourceIdSegmentValues: {
                projectUuid: opts.projectUuid
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $7d7a404ac451d38c$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $7d7a404ac451d38c$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectUuid: this.projectUuid
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._projectUuid = opts.resourceIdSegmentValues.projectUuid;
    }
};
module.exports["TownsquareProjectAri"] = $7d7a404ac451d38c$export$41215e8d01921e7d;

});

parcelRegister("ilC9E", function(module, exports) {
// src/townsquare/project/types.ts
var $d5b7c8e3ddea6aee$export$a258bc824c789b17 = "townsquare", $d5b7c8e3ddea6aee$export$aa8900dadffaa32a = "project";
module.exports["TownsquareProjectAriResourceOwner"] = $d5b7c8e3ddea6aee$export$a258bc824c789b17;
module.exports["TownsquareProjectAriResourceType"] = $d5b7c8e3ddea6aee$export$aa8900dadffaa32a;

});

parcelRegister("5WTxQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ixfCV = parcelRequire("ixfCV");


var $dinVW = parcelRequire("dinVW");


var $2oyXR = parcelRequire("2oyXR");

const $e01be1a23d2a446d$var$styles = {
    wrapper: "_4t3i1osq _bfhkvuon"
};
const $e01be1a23d2a446d$export$9520f072db304aa0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, testId: testId } = t0;
    if ((0, $ixfCV.fg)("ads-panel-system-gpp")) {
        let t1;
        if ($[0] !== children || $[1] !== testId) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2oyXR.PanelContainer), {
                testId: testId
            }, children);
            $[0] = children;
            $[1] = testId;
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    let t1;
    if ($[3] !== children || $[4] !== testId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            xcss: $e01be1a23d2a446d$var$styles.wrapper,
            testId: testId
        }, children);
        $[3] = children;
        $[4] = testId;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ({ children: children, testId: testId })=>{
    if ((0, $ixfCV.fg)('ads-panel-system-gpp')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2oyXR.PanelContainer), {
        testId: testId
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        xcss: $e01be1a23d2a446d$var$styles.wrapper,
        testId: testId
    }, children);
};
module.exports["PreviewPanel"] = $e01be1a23d2a446d$export$9520f072db304aa0;

});

parcelRegister("2oyXR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $biqj4 = parcelRequire("biqj4");

const $6ccdb3d7b226a54f$var$styles = {
    wrapper: "_4t3i1osq _bfhkvuon _1e0c1txw _2lx21bp4 _kqswh2mm",
    content: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _4t3i1osq _1tkeidpf"
}; /**
    * The PanelContainer component provides a standardized container for displaying content
    * in a side panel layout. It follows the design system patterns and integrates
    * with the navigation system for consistent styling and behavior.
    *
    * Compose it with a fixed `PanelHeader` / `PanelFooter` and a scrollable `PanelContent`
    * (wrapping `PanelSubheader` and `PanelBody`).
    *
    * For resizable panels, use the `PanelSplitter` from `@atlaskit/navigation-system/layout/panel-splitter`
    * alongside the `Panel` slot from `@atlaskit/navigation-system/layout/panel`.
    */ 
const $6ccdb3d7b226a54f$export$7c4d2b536147788a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelContainer(t0) {
    const $ = (0, $bDgLe.c)(8);
    const { children: children, testId: testId, isFocusLockEnabled: t1 } = t0;
    const isFocusLockEnabled = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== children) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: $6ccdb3d7b226a54f$var$styles.content
        }, children);
        $[0] = children;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== t2 || $[3] !== testId) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            as: "section",
            testId: testId,
            xcss: $6ccdb3d7b226a54f$var$styles.wrapper
        }, t2);
        $[2] = t2;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isFocusLockEnabled || $[6] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $biqj4.PanelFocusLock), {
            isFocusLockEnabled: isFocusLockEnabled
        }, t3);
        $[5] = isFocusLockEnabled;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : function PanelContainer({ children: children, testId: testId, isFocusLockEnabled: isFocusLockEnabled = false }) {
    return /*#__PURE__*/ $cozmU.createElement((0, $biqj4.PanelFocusLock), {
        isFocusLockEnabled: isFocusLockEnabled
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        as: "section",
        testId: testId,
        xcss: $6ccdb3d7b226a54f$var$styles.wrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $6ccdb3d7b226a54f$var$styles.content
    }, children)));
};
module.exports["PanelContainer"] = $6ccdb3d7b226a54f$export$7c4d2b536147788a;

});

parcelRegister("biqj4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $1enXm = parcelRequire("1enXm");


var $haNN4 = parcelRequire("haNN4");

// box model so PanelContainer's own height/flex styles work exactly as if this wrapper
// were not there. This avoids breaking resize and full-height layouts.
const $2153848f433e7d96$var$contentsStyle = {
    display: 'contents'
};
const $2153848f433e7d96$var$containerStyles = null; /**
                               * Module-level count of currently-mounted PanelFocusLock instances.
                               *
                               * Used to suppress the return-focus restore when one panel is replaced by
                               * another (e.g. Jira admin sidebar swaps Sidebar A → Sidebar B by changing
                               * the Provider component, which unmounts/remounts PanelFocusLock). Without
                               * this guard, the unmounting panel's queued double-rAF restore would fire
                               * AFTER the new panel's autofocus, snapping focus back to the original
                               * trigger while a replacement panel is on screen.
                               *
                               * The counter is decremented synchronously on cleanup BEFORE the new
                               * instance's mount effect runs, then re-checked inside the deferred restore.
                               * If another instance has mounted by the time the double-rAF fires, the
                               * restore is skipped.
                               */ 
let $2153848f433e7d96$var$panelFocusLockMountCount = 0; /**
                                   * Module-level handoff for the "previously focused" element across an
                                   * unmount → mount swap.
                                   *
                                   * When one PanelFocusLock unmounts and is immediately replaced by another
                                   * because a button INSIDE the unmounting panel triggered the swap (e.g.
                                   * Sidebar A's footer "Add spaces" button opens Sidebar B), the replacement's
                                   * mount effect sees `document.activeElement === document.body` because the
                                   * previously-focused element lived inside the panel that just unmounted.
                                   * Without a handoff, the replacement would capture `body` as its "previously
                                   * focused" snapshot and on close would restore focus to nothing / blur.
                                   *
                                   * The unmounting instance writes its own previously-focused snapshot here,
                                   * and the next mounting instance reads + clears it. The handoff is used
                                   * ONLY when the replacement's `document.activeElement` is `body` (or null) —
                                   * meaning focus disappeared because it lived inside the unmounting panel.
                                   * If `document.activeElement` is a real element (e.g. the user clicked a
                                   * different page-level trigger to open this panel), that element wins
                                   * because it's a more accurate "where focus came from" signal than the
                                   * previous panel's snapshot. Cleared either by the next mount or by the
                                   * deferred restore when no replacement appears, so a stale value can't leak
                                   * across unrelated open cycles.
                                   */ 
let $2153848f433e7d96$var$pendingPreviouslyFocused = null; /**
                                                          * Selector for all focusable elements inside a container, in LTR tab order.
                                                          */ 
const $2153848f433e7d96$var$FOCUSABLE_SELECTOR = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
    'details > summary',
    'audio[controls]',
    'video[controls]'
].join(', ');
const $2153848f433e7d96$export$85d112ac7df5c04f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelFocusLock(t0) {
    const $ = (0, $bDgLe.c)(12);
    const { children: children, isFocusLockEnabled: t1 } = t0;
    const isFocusLockEnabled = t1 === undefined ? false : t1;
    const containerRef = (0, $cozmU.useRef)(null);
    const previouslyFocusedRef = (0, $cozmU.useRef)(null);
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            const doc = (0, $haNN4.getDocument)();
            $2153848f433e7d96$var$pendingPreviouslyFocused = null;
            const activeElement = doc?.activeElement ?? null;
            const activeIsBodyOrNull = !activeElement || activeElement === doc?.body;
            const activeIsInsideOwnContainer = !!activeElement && !!containerRef.current?.contains(activeElement);
            const shouldUseHandoff = activeIsBodyOrNull || activeIsInsideOwnContainer;
            const handoffIsAttached = !!$2153848f433e7d96$var$pendingPreviouslyFocused && !!doc?.body?.contains($2153848f433e7d96$var$pendingPreviouslyFocused);
            previouslyFocusedRef.current = shouldUseHandoff && handoffIsAttached ? $2153848f433e7d96$var$pendingPreviouslyFocused : activeElement;
            $2153848f433e7d96$var$panelFocusLockMountCount = $2153848f433e7d96$var$panelFocusLockMountCount + 1;
            return ()=>{
                $2153848f433e7d96$var$panelFocusLockMountCount = $2153848f433e7d96$var$panelFocusLockMountCount - 1;
                $2153848f433e7d96$var$pendingPreviouslyFocused = previouslyFocusedRef.current;
                const toFocus = previouslyFocusedRef.current;
                setTimeout(()=>{
                    setTimeout(()=>{
                        if ($2153848f433e7d96$var$panelFocusLockMountCount > 0) return;
                        $2153848f433e7d96$var$pendingPreviouslyFocused = null;
                        toFocus?.focus();
                    }, 0);
                }, 0);
            };
        };
        t3 = [];
        $[0] = t2;
        $[1] = t3;
    } else {
        t2 = $[0];
        t3 = $[1];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[2] !== isFocusLockEnabled) {
        t4 = ()=>{
            if (isFocusLockEnabled) return;
            const container = containerRef.current;
            if (!container) return;
            const firstFocusable = container.querySelector($2153848f433e7d96$var$FOCUSABLE_SELECTOR);
            if (firstFocusable) firstFocusable.focus({
                preventScroll: true
            });
        };
        t5 = [
            isFocusLockEnabled
        ];
        $[2] = isFocusLockEnabled;
        $[3] = t4;
        $[4] = t5;
    } else {
        t4 = $[3];
        t5 = $[4];
    }
    (0, $cozmU.useEffect)(t4, t5);
    if (isFocusLockEnabled) {
        let t6;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = {
                style: $2153848f433e7d96$var$contentsStyle
            };
            $[5] = t6;
        } else t6 = $[5];
        let t7;
        if ($[6] !== children) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1enXm.default), {
                autoFocus: true,
                returnFocus: false,
                lockProps: t6
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                ref: containerRef,
                style: $2153848f433e7d96$var$contentsStyle
            }, children));
            $[6] = children;
            $[7] = t7;
        } else t7 = $[7];
        return t7;
    }
    let t6;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $hekY6.default)([
            "_4t3i1osq"
        ]);
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== children || $[10] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: containerRef,
            className: t6
        }, children);
        $[9] = children;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    return t7;
} : function PanelFocusLock({ children: children, isFocusLockEnabled: isFocusLockEnabled = false }) {
    const containerRef = (0, $cozmU.useRef)(null); // Capture the element that was focused before the panel opened so we can
    // restore focus to it when the panel closes — regardless of which close
    // path is taken (X button, footer Close, programmatic close, etc.).
    const previouslyFocusedRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        // Determine the element focus should return to when this panel closes.
        //
        // Default: use the element that was focused at the moment we mount —
        // this is the natural "page trigger" the user just clicked.
        //
        // Edge case (handoff): when one panel unmounts and is immediately
        // replaced by another because a button INSIDE the previous panel
        // triggered the swap (e.g. Sidebar A's footer "Add spaces" button
        // opens Sidebar B), focus has nowhere to go: the trigger button just
        // unmounted with the previous panel, so `document.activeElement`
        // falls back to `body`. In that specific case we adopt the previous
        // panel's snapshot via the module-level handoff slot — it's typically
        // the original page-level trigger that opened the chain.
        //
        // Edge case (StrictMode): in development, React double-invokes
        // effects (setup → cleanup → setup). The second setup runs AFTER
        // Effect 2 below has already moved focus to our own first focusable,
        // so `document.activeElement` is inside our own container — but the
        // DOM was never actually unmounted, so the focused element is still
        // attached. We treat this case the same as body: the user never
        // "came from" our own input, so we should fall back to the handoff
        // (which was just set by Pass 1's cleanup). Without this guard,
        // `previouslyFocused` would be set to our own first focusable, and
        // on close `focus()` would target an element that is by then detached.
        //
        // Always clear the handoff slot regardless of whether we used it, so
        // a stale value can't leak forward into an unrelated future mount.
        const doc = (0, $haNN4.getDocument)();
        const handoff = $2153848f433e7d96$var$pendingPreviouslyFocused;
        $2153848f433e7d96$var$pendingPreviouslyFocused = null;
        const activeElement = doc?.activeElement ?? null;
        const activeIsBodyOrNull = !activeElement || activeElement === doc?.body;
        const activeIsInsideOwnContainer = !!activeElement && !!containerRef.current?.contains(activeElement);
        const shouldUseHandoff = activeIsBodyOrNull || activeIsInsideOwnContainer;
        const handoffIsAttached = !!handoff && !!doc?.body?.contains(handoff);
        previouslyFocusedRef.current = shouldUseHandoff && handoffIsAttached ? handoff : activeElement;
        $2153848f433e7d96$var$panelFocusLockMountCount += 1;
        return ()=>{
            $2153848f433e7d96$var$panelFocusLockMountCount -= 1; // Hand our snapshot off in case a replacement instance is about to
            // mount in the same commit — it will consume this and use it as its
            // own return-focus target, preserving the original trigger across the
            // swap. The slot is cleared either by the next mount or by the
            // deferred restore below if no replacement appears.
            $2153848f433e7d96$var$pendingPreviouslyFocused = previouslyFocusedRef.current; // Capture the target locally so it survives even if something else
            // mutates the ref between now and when the deferred callback fires.
            const toFocus = previouslyFocusedRef.current; // Restore focus on unmount (panel close). Two chained `setTimeout(0)`
            // ensure this fires after react-focus-lock's own deactivation logic
            // when the lock is active, and after React has finished applying any
            // commit that mounted a replacement panel.
            //
            // We use setTimeout rather than requestAnimationFrame here because
            // the latter is unreliable under jsdom + the React 18 concurrent
            // scheduler in unit tests: rAF callbacks scheduled inside a passive
            // effect cleanup don't always flush even when `jest.runAllTimers`
            // is called inside an `act` block (the scheduler uses MessageChannel,
            // which fake timers don't drive). setTimeout(0) flushes reliably with
            // both fake and real timers.
            setTimeout(()=>{
                setTimeout(()=>{
                    // Skip restore if another PanelFocusLock instance has mounted in
                    // the meantime — e.g. a sidebar swap where the consumer unmounts
                    // the current panel and mounts a replacement. The new instance's
                    // autofocus already moved focus into the replacement; restoring
                    // here would yank focus back to this panel's previously-focused
                    // element (typically the original page trigger) and visibly steal
                    // focus away from the replacement panel.
                    if ($2153848f433e7d96$var$panelFocusLockMountCount > 0) return;
                     // We're the last one out — clear the handoff so a future,
                    // unrelated panel open doesn't inherit a stale snapshot.
                    $2153848f433e7d96$var$pendingPreviouslyFocused = null;
                    toFocus?.focus();
                }, 0);
            }, 0);
        };
    }, []);
    // When the lock is NOT enabled, handle auto-focus ourselves — do NOT use
    // react-focus-lock even in disabled mode as it causes layout recalculations
    // that causes animation jank when the panel is inside a CSS transform animation
    // (e.g. SlideIn from @atlaskit/motion).
    (0, $cozmU.useEffect)(()=>{
        if (isFocusLockEnabled) return;
        const container = containerRef.current;
        if (!container) return;
         // Focus synchronously in useEffect (post-paint) with preventScroll to avoid
        // the browser calling scrollIntoView on a mid-animation element.
        const firstFocusable = container.querySelector($2153848f433e7d96$var$FOCUSABLE_SELECTOR);
        if (firstFocusable) firstFocusable.focus({
            preventScroll: true
        });
    }, [
        isFocusLockEnabled
    ]); // When the lock IS enabled, use react-focus-lock for both autoFocus and the trap.
    if (isFocusLockEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1enXm.default), {
        autoFocus: true,
        returnFocus: false,
        lockProps: {
            style: $2153848f433e7d96$var$contentsStyle
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: containerRef,
        style: $2153848f433e7d96$var$contentsStyle
    }, children));
     // Default (no lock): plain wrapper div, auto-focus handled by useEffect above.
    // We deliberately avoid react-focus-lock here to prevent animation jank.
    // height: 100% ensures PanelContainer's own height: 100% resolves correctly.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: containerRef,
        className: (0, $hekY6.default)([
            "_4t3i1osq"
        ])
    }, children);
};
module.exports["PanelFocusLock"] = $2153848f433e7d96$export$85d112ac7df5c04f;

});

parcelRegister("kMhHg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $cXtTj = parcelRequire("cXtTj");


var $ixfCV = parcelRequire("ixfCV");


var $iMnC5 = parcelRequire("iMnC5");


var $aio9r = parcelRequire("aio9r");


var $2Emkv = parcelRequire("2Emkv");

const $f9d4da2be7611286$var$panelSystemStyles = {
    fillParent: "_4t3i1osq _1e0c1txw _2lx21bp4"
};
const $f9d4da2be7611286$export$cda5e69749e7aeee = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { children: children, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes, styles: consumerStyles } = t0;
    const bodyRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== analyticsAttributes || $[1] !== analyticsClient || $[2] !== panelType || $[3] !== parentProduct) {
        t1 = ()=>{
            if (analyticsClient) {
                analyticsClient.sendTrackEvent({
                    action: "viewed",
                    actionSubject: "preview-panel",
                    actionSubjectId: "preview-panel-view",
                    source: "preview-panel",
                    attributes: {
                        parentProduct: parentProduct,
                        panelType: panelType,
                        ...(0, $ixfCV.fg)("add_capacity_tab_to_the_board_horizontal_nav") || (0, $ixfCV.fg)("add-trigger-point-key-attribute-to-preview-panel") || (0, $cXtTj.default).getExperimentValue("individual_capacity_planning_ga", "isEnabled", false, {
                            fireExperimentExposure: false
                        }) ? analyticsAttributes : {}
                    }
                });
                analyticsClient?.startUIViewedEvent();
            }
        };
        t2 = [
            analyticsClient,
            parentProduct,
            panelType,
            analyticsAttributes
        ];
        $[0] = analyticsAttributes;
        $[1] = analyticsClient;
        $[2] = panelType;
        $[3] = parentProduct;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[6] !== children || $[7] !== consumerStyles) {
        t3 = (0, $ixfCV.fg)("ads-panel-system-gpp") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: (0, $w6R6I.cx)($f9d4da2be7611286$var$panelSystemStyles.fillParent, !!consumerStyles && consumerStyles),
            ref: bodyRef
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: (0, $w6R6I.cx)(!!consumerStyles && consumerStyles),
            ref: bodyRef
        }, children);
        $[6] = children;
        $[7] = consumerStyles;
        $[8] = t3;
    } else t3 = $[8];
    const panelBodyContent = t3;
    if ((0, $ixfCV.fg)("ads-panel-system-gpp")) {
        let t4;
        if ($[9] !== panelBodyContent) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aio9r.PanelBody), {
                spacing: "none"
            }, panelBodyContent);
            $[9] = panelBodyContent;
            $[10] = t4;
        } else t4 = $[10];
        const wrappedBody = t4;
        let t5;
        if ($[11] !== analyticsAttributes || $[12] !== analyticsClient || $[13] !== panelType || $[14] !== parentProduct || $[15] !== wrappedBody) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Emkv.PreviewPanelSniffer), {
                containerRef: bodyRef,
                analyticsClient: analyticsClient,
                parentProduct: parentProduct,
                panelType: panelType,
                analyticsAttributes: analyticsAttributes
            }, wrappedBody);
            $[11] = analyticsAttributes;
            $[12] = analyticsClient;
            $[13] = panelType;
            $[14] = parentProduct;
            $[15] = wrappedBody;
            $[16] = t5;
        } else t5 = $[16];
        return t5;
    }
    let t4;
    if ($[17] !== analyticsAttributes || $[18] !== analyticsClient || $[19] !== panelBodyContent || $[20] !== panelType || $[21] !== parentProduct) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Emkv.PreviewPanelSniffer), {
            containerRef: bodyRef,
            analyticsClient: analyticsClient,
            parentProduct: parentProduct,
            panelType: panelType,
            analyticsAttributes: analyticsAttributes
        }, panelBodyContent);
        $[17] = analyticsAttributes;
        $[18] = analyticsClient;
        $[19] = panelBodyContent;
        $[20] = panelType;
        $[21] = parentProduct;
        $[22] = t4;
    } else t4 = $[22];
    return t4;
} : ({ children: children, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes, styles: consumerStyles })=>{
    const bodyRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (analyticsClient) {
            analyticsClient.sendTrackEvent({
                action: 'viewed',
                actionSubject: 'preview-panel',
                actionSubjectId: 'preview-panel-view',
                source: 'preview-panel',
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType,
                    // Availability check only — this decides whether to decorate the preview-panel
                    // "viewed" track event with analyticsAttributes, NOT whether the user is
                    // accessing the Capacity planning experience. We therefore read the GA
                    // experiment WITHOUT firing a Statsig exposure (fireExperimentExposure: false);
                    // exposure is fired at the point the user actually opens the Capacity
                    // experience, keeping the GA experiment's population clean.
                    //
                    // The OR (now 3-way) still short-circuits: when either the legacy EAP gate or
                    // the `add-trigger-point-key-attribute-to-preview-panel` gate is ON, the GA
                    // experiment is never read at all. EAP customers remain unconditionally enabled.
                    ...(0, $ixfCV.fg)('add_capacity_tab_to_the_board_horizontal_nav') || (0, $ixfCV.fg)('add-trigger-point-key-attribute-to-preview-panel') || (0, $cXtTj.default).getExperimentValue('individual_capacity_planning_ga', 'isEnabled', false, {
                        fireExperimentExposure: false
                    }) ? analyticsAttributes : {}
                }
            });
            // https://developer.atlassian.com/platform/analytics-pipeline/guides/deep-dive/cloud-mau/
            // Fires at most once per hour, per product.
            // Requires tenantInfo and userInfo to be set
            analyticsClient?.startUIViewedEvent();
        }
    }, [
        analyticsClient,
        parentProduct,
        panelType,
        analyticsAttributes
    ]);
    // ignoring the rule as we have so many consumers of this that we need to be able to pass in styles
    /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ const panelBodyContent = (0, $ixfCV.fg)('ads-panel-system-gpp') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($f9d4da2be7611286$var$panelSystemStyles.fillParent, !!consumerStyles && consumerStyles),
        ref: bodyRef
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)(!!consumerStyles && consumerStyles),
        ref: bodyRef
    }, children); /* eslint-enable @atlaskit/design-system/consistent-css-prop-usage */ 
    if ((0, $ixfCV.fg)('ads-panel-system-gpp')) {
        const wrappedBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aio9r.PanelBody), {
            spacing: "none"
        }, panelBodyContent);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Emkv.PreviewPanelSniffer), {
            containerRef: bodyRef,
            analyticsClient: analyticsClient,
            parentProduct: parentProduct,
            panelType: panelType,
            analyticsAttributes: analyticsAttributes
        }, wrappedBody);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Emkv.PreviewPanelSniffer), {
        containerRef: bodyRef,
        analyticsClient: analyticsClient,
        parentProduct: parentProduct,
        panelType: panelType,
        analyticsAttributes: analyticsAttributes
    }, panelBodyContent);
};
module.exports["PreviewPanelBody"] = $f9d4da2be7611286$export$cda5e69749e7aeee;

});

parcelRegister("aio9r", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

const $d35068f09c7abc33$var$styles = {
    body: "_16jlkb7n _1i4qfg65 _kqswh2mm",
    defaultSpacing: "_1rjcze3t _bozg1ejb _y4ti1ejb"
}; /**
    * The PanelBody component provides the main content area for panels
    * with consistent styling and scroll behavior.
    */ 
const $d35068f09c7abc33$export$3ac6fba5a6f84a87 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelBody(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { children: children, spacing: t1, testId: testId } = t0;
    const spacing = t1 === undefined ? "default" : t1;
    const t2 = spacing === "default" && $d35068f09c7abc33$var$styles.defaultSpacing;
    let t3;
    if ($[0] !== t2) {
        t3 = (0, $w6R6I.cx)($d35068f09c7abc33$var$styles.body, t2);
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== children || $[3] !== t3 || $[4] !== testId) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            testId: testId,
            xcss: t3
        }, children);
        $[2] = children;
        $[3] = t3;
        $[4] = testId;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : function PanelBody({ children: children, spacing: spacing = 'default', testId: testId }) {
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        testId: testId,
        xcss: (0, $w6R6I.cx)($d35068f09c7abc33$var$styles.body, spacing === 'default' && $d35068f09c7abc33$var$styles.defaultSpacing)
    }, children);
};
module.exports["PanelBody"] = $d35068f09c7abc33$export$3ac6fba5a6f84a87;

});

parcelRegister("2Emkv", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $cXtTj = parcelRequire("cXtTj");


var $ixfCV = parcelRequire("ixfCV");

const $75ef0261b167901c$export$93a96f69a5c679de = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { children: children, containerRef: containerRef, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes } = t0;
    const hasSentOverflowEventRef = (0, $cozmU.useRef)(false);
    let t1;
    if ($[0] !== containerRef) {
        t1 = (event, contentSizePayload)=>{
            if (contentSizePayload.type !== "contentSize" || typeof contentSizePayload.width !== "number" || contentSizePayload.width <= 0 || typeof contentSizePayload.height !== "number" || contentSizePayload.height <= 0) return false;
            const panelIframe = containerRef.current?.querySelector("iframe");
            const panelIframeWindow = panelIframe?.contentWindow;
            if (!panelIframeWindow || event.source !== panelIframeWindow) return false;
            if (event.origin && event.origin !== "null" && panelIframe?.src) try {
                const iframeOrigin = new URL(panelIframe.src, window.location.href).origin;
                if (event.origin !== iframeOrigin) return false;
            } catch  {
                return false;
            }
            return true;
        };
        $[0] = containerRef;
        $[1] = t1;
    } else t1 = $[1];
    const isValidContentSizeMessage = t1;
    let t2;
    if ($[2] !== analyticsAttributes || $[3] !== analyticsClient || $[4] !== panelType || $[5] !== parentProduct) {
        t2 = (t3)=>{
            const { clientWidth: clientWidth, detectionMethod: detectionMethod, scrollWidth: scrollWidth } = t3;
            if (!analyticsClient || hasSentOverflowEventRef.current) return;
            hasSentOverflowEventRef.current = true;
            const overflowPx = typeof clientWidth === "number" && typeof scrollWidth === "number" ? Math.max(scrollWidth - clientWidth, 0) : undefined;
            analyticsClient.sendOperationalEvent({
                action: "detected",
                actionSubject: "layoutOverflow",
                actionSubjectId: "preview-panel-horizontal-overflow",
                source: "preview-panel",
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType,
                    detectionMethod: detectionMethod,
                    clientWidth: clientWidth,
                    scrollWidth: scrollWidth,
                    overflowPx: overflowPx,
                    ...(0, $ixfCV.fg)("add_capacity_tab_to_the_board_horizontal_nav") || (0, $cXtTj.default).getExperimentValue("individual_capacity_planning_ga", "isEnabled", false, {
                        fireExperimentExposure: false
                    }) ? analyticsAttributes : {}
                }
            });
        };
        $[2] = analyticsAttributes;
        $[3] = analyticsClient;
        $[4] = panelType;
        $[5] = parentProduct;
        $[6] = t2;
    } else t2 = $[6];
    const sendOverflowEvent = t2;
    let t3;
    let t4;
    if ($[7] !== containerRef || $[8] !== sendOverflowEvent) {
        t3 = ()=>{
            const bodyElement = containerRef.current;
            if (!bodyElement || typeof ResizeObserver === "undefined") return;
            const detectBodyOverflow = ()=>{
                const clientWidth_0 = bodyElement.clientWidth;
                const scrollWidth_0 = bodyElement.scrollWidth;
                if (scrollWidth_0 > clientWidth_0) sendOverflowEvent({
                    detectionMethod: "body-observer",
                    clientWidth: clientWidth_0,
                    scrollWidth: scrollWidth_0
                });
            };
            detectBodyOverflow();
            const observer = new ResizeObserver(detectBodyOverflow);
            observer.observe(bodyElement);
            return ()=>{
                observer.disconnect();
            };
        };
        t4 = [
            containerRef,
            sendOverflowEvent
        ];
        $[7] = containerRef;
        $[8] = sendOverflowEvent;
        $[9] = t3;
        $[10] = t4;
    } else {
        t3 = $[9];
        t4 = $[10];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[11] !== containerRef || $[12] !== isValidContentSizeMessage || $[13] !== sendOverflowEvent) {
        t5 = ()=>{
            const handleMessage = (event_0)=>{
                const contentSizePayload_0 = event_0.data;
                if (!isValidContentSizeMessage(event_0, contentSizePayload_0)) return;
                const panelIframe_0 = containerRef.current?.querySelector("iframe");
                const iframeClientWidth = panelIframe_0?.clientWidth ?? 0;
                const clientWidth_1 = iframeClientWidth > 0 ? iframeClientWidth : containerRef.current?.clientWidth;
                if (typeof clientWidth_1 !== "number" || contentSizePayload_0.width <= clientWidth_1) return;
                sendOverflowEvent({
                    detectionMethod: "iframe-content-size-message",
                    clientWidth: clientWidth_1,
                    scrollWidth: contentSizePayload_0.width
                });
            };
            return (0, $cbY7C.bind)(window, {
                type: "message",
                listener: handleMessage
            });
        };
        t6 = [
            containerRef,
            isValidContentSizeMessage,
            sendOverflowEvent
        ];
        $[11] = containerRef;
        $[12] = isValidContentSizeMessage;
        $[13] = sendOverflowEvent;
        $[14] = t5;
        $[15] = t6;
    } else {
        t5 = $[14];
        t6 = $[15];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[16] !== children) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[16] = children;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : ({ children: children, containerRef: containerRef, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes })=>{
    const hasSentOverflowEventRef = (0, $cozmU.useRef)(false);
    const isValidContentSizeMessage = (0, $cozmU.useCallback)((event, contentSizePayload)=>{
        if (contentSizePayload.type !== 'contentSize' || typeof contentSizePayload.width !== 'number' || contentSizePayload.width <= 0 || typeof contentSizePayload.height !== 'number' || contentSizePayload.height <= 0) return false;
        const panelIframe = containerRef.current?.querySelector('iframe');
        const panelIframeWindow = panelIframe?.contentWindow;
        if (!panelIframeWindow || event.source !== panelIframeWindow) return false;
        // If both origins are known, ensure the message comes from the iframe's origin.
        if (event.origin && event.origin !== 'null' && panelIframe?.src) try {
            const iframeOrigin = new URL(panelIframe.src, window.location.href).origin;
            if (event.origin !== iframeOrigin) return false;
        } catch  {
            return false;
        }
        return true;
    }, [
        containerRef
    ]);
    const sendOverflowEvent = (0, $cozmU.useCallback)(({ clientWidth: clientWidth, detectionMethod: detectionMethod, scrollWidth: scrollWidth })=>{
        if (!analyticsClient || hasSentOverflowEventRef.current) return;
        hasSentOverflowEventRef.current = true;
        const overflowPx = typeof clientWidth === 'number' && typeof scrollWidth === 'number' ? Math.max(scrollWidth - clientWidth, 0) : undefined;
        analyticsClient.sendOperationalEvent({
            action: 'detected',
            actionSubject: 'layoutOverflow',
            actionSubjectId: 'preview-panel-horizontal-overflow',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType,
                detectionMethod: detectionMethod,
                clientWidth: clientWidth,
                scrollWidth: scrollWidth,
                overflowPx: overflowPx,
                // Availability check only — this decides whether to decorate the overflow
                // operational event with analyticsAttributes, NOT whether the user is
                // accessing the Capacity planning experience. We therefore read the GA
                // experiment WITHOUT firing a Statsig exposure
                // (fireExperimentExposure: false); exposure is fired at the point the user
                // actually opens the Capacity experience, keeping the GA experiment's
                // population clean.
                //
                // The OR still short-circuits: when the legacy EAP gate is ON the experiment
                // is never read at all. EAP customers remain unconditionally enabled.
                ...(0, $ixfCV.fg)('add_capacity_tab_to_the_board_horizontal_nav') || (0, $cXtTj.default).getExperimentValue('individual_capacity_planning_ga', 'isEnabled', false, {
                    fireExperimentExposure: false
                }) ? analyticsAttributes : {}
            }
        });
    }, [
        analyticsClient,
        parentProduct,
        panelType,
        analyticsAttributes
    ]);
    (0, $cozmU.useEffect)(()=>{
        const bodyElement = containerRef.current;
        if (!bodyElement || typeof ResizeObserver === 'undefined') return;
        const detectBodyOverflow = ()=>{
            const clientWidth_0 = bodyElement.clientWidth;
            const scrollWidth_0 = bodyElement.scrollWidth;
            if (scrollWidth_0 > clientWidth_0) sendOverflowEvent({
                detectionMethod: 'body-observer',
                clientWidth: clientWidth_0,
                scrollWidth: scrollWidth_0
            });
        };
        detectBodyOverflow();
        const observer = new ResizeObserver(detectBodyOverflow);
        observer.observe(bodyElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        containerRef,
        sendOverflowEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        const handleMessage = (event_0)=>{
            const contentSizePayload_0 = event_0.data;
            if (!isValidContentSizeMessage(event_0, contentSizePayload_0)) return;
            const panelIframe_0 = containerRef.current?.querySelector('iframe');
            const iframeClientWidth = panelIframe_0?.clientWidth ?? 0;
            const clientWidth_1 = iframeClientWidth > 0 ? iframeClientWidth : containerRef.current?.clientWidth;
            if (typeof clientWidth_1 !== 'number' || contentSizePayload_0.width <= clientWidth_1) return;
            sendOverflowEvent({
                detectionMethod: 'iframe-content-size-message',
                clientWidth: clientWidth_1,
                scrollWidth: contentSizePayload_0.width
            });
        };
        return (0, $cbY7C.bind)(window, {
            type: 'message',
            listener: handleMessage
        });
    }, [
        containerRef,
        isValidContentSizeMessage,
        sendOverflowEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
module.exports["PreviewPanelSniffer"] = $75ef0261b167901c$export$93a96f69a5c679de;

});

parcelRegister("fE1YT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aIlZA = parcelRequire("aIlZA");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $kdlgT = parcelRequire("kdlgT");


var $l3wuH = parcelRequire("l3wuH");


var $V3JOP = parcelRequire("V3JOP");


var $ixfCV = parcelRequire("ixfCV");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $1l0kj = parcelRequire("1l0kj");


var $7ZpVx = parcelRequire("7ZpVx");

var $i68yG = parcelRequire("i68yG");

var $7ZxlY = parcelRequire("7ZxlY");

var $1jpZo = parcelRequire("1jpZo");


var $Emr0i = parcelRequire("Emr0i");


var $7Yky3 = parcelRequire("7Yky3");

const $30b8761d1cee2886$export$e1ea1fbf111a14fe = (url, paramToRemove)=>{
    try {
        const urlObj = new URL(url);
        urlObj.searchParams.delete(paramToRemove);
        return urlObj.toString();
    } catch  {
        // If URL parsing fails, return the original URL
        return url;
    }
};
const $30b8761d1cee2886$var$styles = {
    header: "_1h6d1l7x _bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi _12ornqa1 _1r62e4h9 _4t3i8vuz",
    childWrapper: "_16jlkb7n",
    titleRegion: "_zulpu2gc _1e0c1txw _2lx2vrvc _4cvr1h6o _1bah1yb4 _16jlkb7n _1ul9idpf"
};
const $30b8761d1cee2886$export$426d4171de44bac0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(72);
    const { children: children, onClose: onClose, onOpenInNewTab: onOpenInNewTab, onNavigateBack: onNavigateBack, testId: testId, url: url, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, moreActions: moreActions } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $ixfCV.fg)("platform_preview_panels_cross_app_interaction");
        $[0] = t1;
    } else t1 = $[0];
    const enableCrossMAUUsage = t1;
    const t2 = parentProduct ?? "unknown";
    let t3;
    if ($[1] !== t2) {
        t3 = {
            bridge: "preview-panels",
            product: t2
        };
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    const buildUrlWithAnalyticsParams = (0, $aIlZA.default)(t3);
    let t4;
    if ($[3] !== analyticsClient || $[4] !== onClose || $[5] !== panelType || $[6] !== parentProduct) {
        t4 = ()=>{
            analyticsClient?.sendTrackEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "preview-panel-close",
                source: "preview-panel",
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType
                }
            });
            onClose?.();
        };
        $[3] = analyticsClient;
        $[4] = onClose;
        $[5] = panelType;
        $[6] = parentProduct;
        $[7] = t4;
    } else t4 = $[7];
    const onPanelClose = t4;
    let t5;
    if ($[8] !== analyticsClient || $[9] !== buildUrlWithAnalyticsParams || $[10] !== onOpenInNewTab || $[11] !== panelType || $[12] !== parentProduct || $[13] !== url) {
        t5 = ()=>{
            analyticsClient?.sendTrackEvent({
                action: "clicked",
                actionSubject: "link",
                actionSubjectId: "preview-panel-open-in-new-window",
                source: "preview-panel",
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType
                }
            });
            onOpenInNewTab?.();
            if (url) window.open(enableCrossMAUUsage ? buildUrlWithAnalyticsParams($30b8761d1cee2886$export$e1ea1fbf111a14fe(url, "previewPanels")) : $30b8761d1cee2886$export$e1ea1fbf111a14fe(url, "previewPanels"));
        };
        $[8] = analyticsClient;
        $[9] = buildUrlWithAnalyticsParams;
        $[10] = onOpenInNewTab;
        $[11] = panelType;
        $[12] = parentProduct;
        $[13] = url;
        $[14] = t5;
    } else t5 = $[14];
    const onOpenInNewWindow = t5;
    let t6;
    if ($[15] !== analyticsClient || $[16] !== onNavigateBack || $[17] !== panelType || $[18] !== parentProduct) {
        t6 = ()=>{
            analyticsClient?.sendTrackEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "preview-panel-navigate-back",
                source: "preview-panel",
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType
                }
            });
            onNavigateBack?.();
        };
        $[15] = analyticsClient;
        $[16] = onNavigateBack;
        $[17] = panelType;
        $[18] = parentProduct;
        $[19] = t6;
    } else t6 = $[19];
    const onPanelNavigateBack = t6;
    if ((0, $ixfCV.fg)("ads-panel-system-gpp")) {
        let t7;
        if ($[20] !== formatMessage || $[21] !== onNavigateBack || $[22] !== onPanelNavigateBack || $[23] !== testId) {
            t7 = onNavigateBack && (0, $ixfCV.fg)("jivtech-1920-back-navigation-gpp") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
                label: formatMessage((0, $Emr0i.default).previewPanelNavigateBackLabel),
                onClick: onPanelNavigateBack,
                testId: testId && `${testId}.navigate-back-button`,
                appearance: "default"
            });
            $[20] = formatMessage;
            $[21] = onNavigateBack;
            $[22] = onPanelNavigateBack;
            $[23] = testId;
            $[24] = t7;
        } else t7 = $[24];
        let t8;
        if ($[25] !== children) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                xcss: $30b8761d1cee2886$var$styles.titleRegion
            }, children);
            $[25] = children;
            $[26] = t8;
        } else t8 = $[26];
        let t9;
        if ($[27] !== formatMessage || $[28] !== onOpenInNewWindow || $[29] !== testId || $[30] !== url) {
            t9 = url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
                label: formatMessage((0, $Emr0i.default).previewPanelOpenInNewWindowLabel),
                onClick: onOpenInNewWindow,
                testId: testId && `${testId}.open-in-new-window-button`,
                appearance: "subtle"
            });
            $[27] = formatMessage;
            $[28] = onOpenInNewWindow;
            $[29] = testId;
            $[30] = url;
            $[31] = t9;
        } else t9 = $[31];
        let t10;
        if ($[32] !== formatMessage || $[33] !== onClose || $[34] !== onPanelClose || $[35] !== testId) {
            t10 = onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i68yG.PanelActionClose), {
                onClick: onPanelClose,
                testId: testId && `${testId}.close-button`,
                label: formatMessage((0, $Emr0i.default).previewPanelCloseButtonLabel)
            });
            $[32] = formatMessage;
            $[33] = onClose;
            $[34] = onPanelClose;
            $[35] = testId;
            $[36] = t10;
        } else t10 = $[36];
        let t11;
        if ($[37] !== moreActions || $[38] !== t10 || $[39] !== t9) {
            t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZxlY.PanelActionGroup), null, t9, moreActions, t10);
            $[37] = moreActions;
            $[38] = t10;
            $[39] = t9;
            $[40] = t11;
        } else t11 = $[40];
        let t12;
        if ($[41] !== t11 || $[42] !== t7 || $[43] !== t8 || $[44] !== testId) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1jpZo.PanelHeader), {
                testId: testId
            }, t7, t8, t11);
            $[41] = t11;
            $[42] = t7;
            $[43] = t8;
            $[44] = testId;
            $[45] = t12;
        } else t12 = $[45];
        return t12;
    }
    let t7;
    if ($[46] !== formatMessage || $[47] !== onNavigateBack || $[48] !== onPanelNavigateBack || $[49] !== testId) {
        t7 = onNavigateBack && (0, $ixfCV.fg)("jivtech-1920-back-navigation-gpp") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: $30b8761d1cee2886$var$_temp,
            label: formatMessage((0, $Emr0i.default).previewPanelNavigateBackLabel),
            onClick: onPanelNavigateBack,
            testId: testId && `${testId}.navigate-back-button`
        });
        $[46] = formatMessage;
        $[47] = onNavigateBack;
        $[48] = onPanelNavigateBack;
        $[49] = testId;
        $[50] = t7;
    } else t7 = $[50];
    let t8;
    if ($[51] !== children) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            xcss: $30b8761d1cee2886$var$styles.childWrapper,
            spread: "space-between",
            alignBlock: "center",
            space: "space.100"
        }, children);
        $[51] = children;
        $[52] = t8;
    } else t8 = $[52];
    let t9;
    if ($[53] !== formatMessage || $[54] !== onOpenInNewWindow || $[55] !== testId || $[56] !== url) {
        t9 = url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7Yky3.PreviewPanelNewTabLink), {
            label: formatMessage((0, $Emr0i.default).previewPanelOpenInNewWindowLabel),
            onClick: onOpenInNewWindow,
            testId: testId && `${testId}.open-in-new-window-button`
        });
        $[53] = formatMessage;
        $[54] = onOpenInNewWindow;
        $[55] = testId;
        $[56] = url;
        $[57] = t9;
    } else t9 = $[57];
    let t10;
    if ($[58] !== formatMessage || $[59] !== onClose || $[60] !== onPanelClose || $[61] !== testId) {
        t10 = onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: $30b8761d1cee2886$var$_temp2,
            label: formatMessage((0, $Emr0i.default).previewPanelCloseButtonLabel),
            onClick: onPanelClose,
            testId: testId && `${testId}.close-button`,
            role: "button"
        });
        $[58] = formatMessage;
        $[59] = onClose;
        $[60] = onPanelClose;
        $[61] = testId;
        $[62] = t10;
    } else t10 = $[62];
    let t11;
    if ($[63] !== moreActions || $[64] !== t10 || $[65] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
            gap: "space.100"
        }, t9, moreActions, t10);
        $[63] = moreActions;
        $[64] = t10;
        $[65] = t9;
        $[66] = t11;
    } else t11 = $[66];
    let t12;
    if ($[67] !== t11 || $[68] !== t7 || $[69] !== t8 || $[70] !== testId) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            xcss: $30b8761d1cee2886$var$styles.header,
            testId: testId,
            alignBlock: "center",
            space: "space.100"
        }, t7, t8, t11);
        $[67] = t11;
        $[68] = t7;
        $[69] = t8;
        $[70] = testId;
        $[71] = t12;
    } else t12 = $[71];
    return t12;
} : ({ children: children, onClose: onClose, onOpenInNewTab: onOpenInNewTab, onNavigateBack: onNavigateBack, testId: testId, url: url, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, moreActions: moreActions })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const enableCrossMAUUsage = (0, $ixfCV.fg)('platform_preview_panels_cross_app_interaction');
    const buildUrlWithAnalyticsParams = (0, $aIlZA.default)({
        bridge: 'preview-panels',
        product: parentProduct ?? 'unknown'
    });
    const onPanelClose = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preview-panel-close',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onClose?.();
    };
    const onOpenInNewWindow = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'preview-panel-open-in-new-window',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onOpenInNewTab?.();
        if (url) window.open(enableCrossMAUUsage ? buildUrlWithAnalyticsParams($30b8761d1cee2886$export$e1ea1fbf111a14fe(url, 'previewPanels')) : $30b8761d1cee2886$export$e1ea1fbf111a14fe(url, 'previewPanels'));
    };
    const onPanelNavigateBack = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preview-panel-navigate-back',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onNavigateBack?.();
    };
    if ((0, $ixfCV.fg)('ads-panel-system-gpp')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1jpZo.PanelHeader), {
        testId: testId
    }, onNavigateBack && (0, $ixfCV.fg)('jivtech-1920-back-navigation-gpp') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
        label: formatMessage((0, $Emr0i.default).previewPanelNavigateBackLabel),
        onClick: onPanelNavigateBack,
        testId: testId && `${testId}.navigate-back-button`,
        appearance: "default"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $30b8761d1cee2886$var$styles.titleRegion
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZxlY.PanelActionGroup), null, url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
        label: formatMessage((0, $Emr0i.default).previewPanelOpenInNewWindowLabel),
        onClick: onOpenInNewWindow,
        testId: testId && `${testId}.open-in-new-window-button`,
        appearance: "subtle"
    }), moreActions, onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i68yG.PanelActionClose), {
        onClick: onPanelClose,
        testId: testId && `${testId}.close-button`,
        label: formatMessage((0, $Emr0i.default).previewPanelCloseButtonLabel)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        xcss: $30b8761d1cee2886$var$styles.header,
        testId: testId,
        alignBlock: "center",
        space: "space.100"
    }, onNavigateBack && (0, $ixfCV.fg)('jivtech-1920-back-navigation-gpp') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $Emr0i.default).previewPanelNavigateBackLabel),
        onClick: onPanelNavigateBack,
        testId: testId && `${testId}.navigate-back-button`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        xcss: $30b8761d1cee2886$var$styles.childWrapper,
        spread: "space-between",
        alignBlock: "center",
        space: "space.100"
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
        gap: "space.100"
    }, url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7Yky3.PreviewPanelNewTabLink), {
        label: formatMessage((0, $Emr0i.default).previewPanelOpenInNewWindowLabel),
        onClick: onOpenInNewWindow,
        testId: testId && `${testId}.open-in-new-window-button`
    }), moreActions, onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                ...iconProps_0,
                size: "small"
            }),
        label: formatMessage((0, $Emr0i.default).previewPanelCloseButtonLabel),
        onClick: onPanelClose,
        testId: testId && `${testId}.close-button`,
        role: "button"
    })));
};
function $30b8761d1cee2886$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))), {
        ...iconProps,
        size: "small"
    });
}
function $30b8761d1cee2886$var$_temp2(iconProps_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        ...iconProps_0,
        size: "small"
    });
}
module.exports["PreviewPanelHeader"] = $30b8761d1cee2886$export$426d4171de44bac0;

});

parcelRegister("7ZpVx", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $7vK9E = parcelRequire("7vK9E");

const $2efd2cd3ca9e912b$export$2a18e3520151503 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(30);
    const { children: children, onClick: onClick, href: href, testId: testId, target: target, rel: rel, "aria-label": ariaLabel, "aria-haspopup": ariaHaspopup, "aria-expanded": ariaExpanded, icon: icon, label: label, appearance: t1, spacing: t2 } = t0;
    const appearance = t1 === undefined ? "subtle" : t1;
    const spacing = t2 === undefined ? "default" : t2;
    if (icon) {
        const t3 = ref;
        const t4 = onClick;
        const t5 = label || ariaLabel;
        let t6;
        if ($[0] !== appearance || $[1] !== ariaExpanded || $[2] !== ariaHaspopup || $[3] !== icon || $[4] !== spacing || $[5] !== t3 || $[6] !== t4 || $[7] !== t5 || $[8] !== testId) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ref: t3,
                onClick: t4,
                testId: testId,
                icon: icon,
                label: t5,
                appearance: appearance,
                "aria-haspopup": ariaHaspopup,
                "aria-expanded": ariaExpanded,
                isTooltipDisabled: false,
                spacing: spacing
            });
            $[0] = appearance;
            $[1] = ariaExpanded;
            $[2] = ariaHaspopup;
            $[3] = icon;
            $[4] = spacing;
            $[5] = t3;
            $[6] = t4;
            $[7] = t5;
            $[8] = testId;
            $[9] = t6;
        } else t6 = $[9];
        return t6;
    }
    if (href) {
        const t3 = ref;
        const t4 = onClick;
        let t5;
        if ($[10] !== ariaExpanded || $[11] !== ariaHaspopup || $[12] !== ariaLabel || $[13] !== children || $[14] !== href || $[15] !== rel || $[16] !== t3 || $[17] !== t4 || $[18] !== target || $[19] !== testId) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.default), {
                ref: t3,
                href: href,
                onClick: t4,
                testId: testId,
                target: target,
                rel: rel,
                "aria-label": ariaLabel,
                "aria-haspopup": ariaHaspopup,
                "aria-expanded": ariaExpanded
            }, children);
            $[10] = ariaExpanded;
            $[11] = ariaHaspopup;
            $[12] = ariaLabel;
            $[13] = children;
            $[14] = href;
            $[15] = rel;
            $[16] = t3;
            $[17] = t4;
            $[18] = target;
            $[19] = testId;
            $[20] = t5;
        } else t5 = $[20];
        return t5;
    }
    const t3 = ref;
    const t4 = onClick;
    let t5;
    if ($[21] !== appearance || $[22] !== ariaExpanded || $[23] !== ariaHaspopup || $[24] !== ariaLabel || $[25] !== children || $[26] !== t3 || $[27] !== t4 || $[28] !== testId) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            ref: t3,
            onClick: t4,
            testId: testId,
            "aria-label": ariaLabel,
            "aria-haspopup": ariaHaspopup,
            "aria-expanded": ariaExpanded,
            appearance: appearance
        }, children);
        $[21] = appearance;
        $[22] = ariaExpanded;
        $[23] = ariaHaspopup;
        $[24] = ariaLabel;
        $[25] = children;
        $[26] = t3;
        $[27] = t4;
        $[28] = testId;
        $[29] = t5;
    } else t5 = $[29];
    return t5;
} : ({ children: children, onClick: onClick, href: href, testId: testId, target: target, rel: rel, 'aria-label': ariaLabel, 'aria-haspopup': ariaHaspopup, 'aria-expanded': ariaExpanded, icon: icon, label: label, appearance: appearance = 'subtle', spacing: spacing = 'default' }, ref)=>{
    if (icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        ref: ref,
        onClick: onClick,
        testId: testId,
        icon: icon,
        label: label || ariaLabel,
        appearance: appearance,
        "aria-haspopup": ariaHaspopup,
        "aria-expanded": ariaExpanded,
        isTooltipDisabled: false,
        spacing: spacing
    });
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.default), {
        ref: ref,
        href: href,
        onClick: onClick,
        testId: testId,
        target: target,
        rel: rel,
        "aria-label": ariaLabel,
        "aria-haspopup": ariaHaspopup,
        "aria-expanded": ariaExpanded
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        ref: ref,
        onClick: onClick,
        testId: testId,
        "aria-label": ariaLabel,
        "aria-haspopup": ariaHaspopup,
        "aria-expanded": ariaExpanded,
        appearance: appearance
    }, children);
});
module.exports["PanelAction"] = $2efd2cd3ca9e912b$export$2a18e3520151503;

});

parcelRegister("i68yG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $l3wuH = parcelRequire("l3wuH");


var $7ZpVx = parcelRequire("7ZpVx");

const $837042f62dde5900$export$75d0a5a5f71a1ab1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(8);
    const { onClick: onClick, onBeforeClose: onBeforeClose, testId: testId, label: label } = t0;
    let t1;
    if ($[0] !== onBeforeClose || $[1] !== onClick) {
        t1 = async (event, analyticsEvent)=>{
            if (onBeforeClose) {
                const canClose = await onBeforeClose();
                if (!canClose) return;
            }
            if (onClick) onClick(event, analyticsEvent);
        };
        $[0] = onBeforeClose;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const handleClick = t1;
    const t2 = label || "Close panel";
    let t3;
    if ($[3] !== handleClick || $[4] !== ref || $[5] !== t2 || $[6] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
            ref: ref,
            onClick: handleClick,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
            label: t2,
            spacing: "compact",
            appearance: "subtle"
        });
        $[3] = handleClick;
        $[4] = ref;
        $[5] = t2;
        $[6] = testId;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ onClick: onClick, onBeforeClose: onBeforeClose, testId: testId, label: label }, ref)=>{
    const handleClick = async (event, analyticsEvent)=>{
        if (onBeforeClose) {
            const canClose = await onBeforeClose();
            if (!canClose) return;
        }
        if (onClick) onClick(event, analyticsEvent);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
        ref: ref,
        onClick: handleClick,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: label || 'Close panel',
        spacing: "compact",
        appearance: "subtle"
    });
});
module.exports["PanelActionClose"] = $837042f62dde5900$export$75d0a5a5f71a1ab1;

});

parcelRegister("7ZxlY", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $2d2f9566579f7703$var$styles = {
    group: "_zulpu2gc _1e0c1txw _4cvr1h6o"
}; /**
    * The PanelActionGroup component provides a container for grouping
    * panel actions together with consistent spacing and layout.
    */ 
const $2d2f9566579f7703$export$9546bd4ca18522f9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelActionGroup(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children, testId: testId } = t0;
    let t1;
    if ($[0] !== children || $[1] !== testId) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            testId: testId,
            xcss: $2d2f9566579f7703$var$styles.group
        }, children);
        $[0] = children;
        $[1] = testId;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function PanelActionGroup({ children: children, testId: testId }) {
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        testId: testId,
        xcss: $2d2f9566579f7703$var$styles.group
    }, children);
};
module.exports["PanelActionGroup"] = $2d2f9566579f7703$export$9546bd4ca18522f9;

});

parcelRegister("1jpZo", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

const $2747dc4177a5f32c$var$styles = {
    header: "_4t3i1k7u _1e0c1txw _4cvr1h6o _bozgv47k _y4tiv47k _1q51pxbi _85i5pxbi",
    headerContent: "_zulpu2gc _1e0c1txw _4cvr1h6o _1bah1yb4 _1bsb1osq"
}; /**
    * The PanelHeader component provides a standardized header area for panels
    * containing the title, actions, and other header-specific content.
    * It automatically organizes content into left (back button + title) and right (actions) sections
    * using flexbox layout. Place PanelActionGroup as the last child to position it on the right.
    */ 
const $2747dc4177a5f32c$export$968713404ca1c9aa = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelHeader(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { children: children, testId: testId } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.default), {
            xcss: $2747dc4177a5f32c$var$styles.headerContent
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1 || $[3] !== testId) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            as: "header",
            testId: testId,
            xcss: $2747dc4177a5f32c$var$styles.header
        }, t1);
        $[2] = t1;
        $[3] = testId;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : function PanelHeader({ children: children, testId: testId }) {
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        as: "header",
        testId: testId,
        xcss: $2747dc4177a5f32c$var$styles.header
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.default), {
        xcss: $2747dc4177a5f32c$var$styles.headerContent
    }, children));
};
module.exports["PanelHeader"] = $2747dc4177a5f32c$export$968713404ca1c9aa;

});

parcelRegister("Emr0i", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $e1da37ec0a029195$var$_default_1 = (0, $kSwu1.defineMessages)({
    previewPanelCloseButtonLabel: {
        id: "navigation.preview-panel.preview-panel-header.close-button-label",
        defaultMessage: "Close"
    },
    previewPanelExpandActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-expand.expand-action-label",
        defaultMessage: "Expand"
    },
    previewPanelNewTabActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-new-tab.new-tab-action-label",
        defaultMessage: "Open in new tab"
    },
    previewPanelMoreDropdownActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-more-dropdown.more-dropdown-action-label",
        defaultMessage: "More"
    },
    previewPanelOpenInNewWindowLabel: {
        id: "navigation.preview-panel.preview-panel-header.open-in-new-window-label",
        defaultMessage: "Open in new window"
    },
    previewPanelNavigateBackLabel: {
        id: "navigation.preview-panel.preview-panel-header.navigate-back-label",
        defaultMessage: "Go back to previous panel"
    }
});
var $e1da37ec0a029195$export$2e2bcd8739ae039 = $e1da37ec0a029195$var$_default_1;
module.exports["default"] = $e1da37ec0a029195$export$2e2bcd8739ae039;

});

parcelRegister("7Yky3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $V3JOP = parcelRequire("V3JOP");


var $Emr0i = parcelRequire("Emr0i");


var $6GBgL = parcelRequire("6GBgL");

const $3d98d316d4b42e83$export$d05dda6f1d91eaad = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { href: href, label: label, onClick: onClick, testId: testId, analyticsContext: analyticsContext } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage || $[1] !== label) {
        t1 = label || formatMessage((0, $Emr0i.default).previewPanelNewTabActionLabel);
        $[0] = formatMessage;
        $[1] = label;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== analyticsContext || $[4] !== href || $[5] !== onClick || $[6] !== t1 || $[7] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GBgL.PreviewPanelAction), {
            label: t1,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
            onClick: onClick,
            href: href,
            testId: testId,
            analyticsContext: analyticsContext
        });
        $[3] = analyticsContext;
        $[4] = href;
        $[5] = onClick;
        $[6] = t1;
        $[7] = testId;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ href: href, label: label, onClick: onClick, testId: testId, analyticsContext: analyticsContext })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GBgL.PreviewPanelAction), {
        label: label || formatMessage((0, $Emr0i.default).previewPanelNewTabActionLabel),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
        onClick: onClick,
        href: href,
        testId: testId,
        analyticsContext: analyticsContext
    });
};
module.exports["PreviewPanelNewTabLink"] = $3d98d316d4b42e83$export$d05dda6f1d91eaad;

});

parcelRegister("6GBgL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1sCHt = parcelRequire("1sCHt");

var $7WEaj = parcelRequire("7WEaj");


var $ixfCV = parcelRequire("ixfCV");


var $7ZpVx = parcelRequire("7ZpVx");

const $e48bc72cc4b3f1f2$export$a37cb5f447b2cf16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? function PreviewPanelAction(t0, ref) {
    const $ = (0, $bDgLe.c)(22);
    const { icon: icon, label: label, onClick: onClick, href: href, testId: testId, analyticsContext: analyticsContext } = t0;
    if ((0, $ixfCV.fg)("ads-panel-system-gpp")) {
        if (analyticsContext || href) {
            let t1;
            if ($[0] !== analyticsContext || $[1] !== href || $[2] !== icon || $[3] !== label || $[4] !== onClick || $[5] !== ref || $[6] !== testId) {
                t1 = href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
                    icon: icon,
                    label: label,
                    onClick: onClick,
                    href: href,
                    testId: testId,
                    analyticsContext: analyticsContext,
                    appearance: "subtle",
                    target: "_blank",
                    ref: ref,
                    role: "button"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                    icon: icon,
                    label: label,
                    onClick: onClick,
                    testId: testId,
                    analyticsContext: analyticsContext,
                    appearance: "subtle",
                    ref: ref,
                    role: "button"
                });
                $[0] = analyticsContext;
                $[1] = href;
                $[2] = icon;
                $[3] = label;
                $[4] = onClick;
                $[5] = ref;
                $[6] = testId;
                $[7] = t1;
            } else t1 = $[7];
            return t1;
        }
        let t1;
        if ($[8] !== icon || $[9] !== label || $[10] !== onClick || $[11] !== ref || $[12] !== testId) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
                ref: ref,
                icon: icon,
                label: label,
                onClick: onClick,
                testId: testId,
                appearance: "subtle"
            });
            $[8] = icon;
            $[9] = label;
            $[10] = onClick;
            $[11] = ref;
            $[12] = testId;
            $[13] = t1;
        } else t1 = $[13];
        return t1;
    }
    let t1;
    if ($[14] !== analyticsContext || $[15] !== href || $[16] !== icon || $[17] !== label || $[18] !== onClick || $[19] !== ref || $[20] !== testId) {
        t1 = href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
            icon: icon,
            label: label,
            onClick: onClick,
            href: href,
            testId: testId,
            analyticsContext: analyticsContext,
            appearance: "subtle",
            target: "_blank",
            ref: ref,
            role: "button"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: icon,
            label: label,
            onClick: onClick,
            testId: testId,
            analyticsContext: analyticsContext,
            appearance: "subtle",
            ref: ref,
            role: "button"
        });
        $[14] = analyticsContext;
        $[15] = href;
        $[16] = icon;
        $[17] = label;
        $[18] = onClick;
        $[19] = ref;
        $[20] = testId;
        $[21] = t1;
    } else t1 = $[21];
    return t1;
} : function PreviewPanelAction({ icon: icon, label: label, onClick: onClick, href: href, testId: testId, analyticsContext: analyticsContext }, ref) {
    if ((0, $ixfCV.fg)('ads-panel-system-gpp')) {
        if (analyticsContext || href) return href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
            icon: icon,
            label: label,
            onClick: onClick,
            href: href,
            testId: testId,
            analyticsContext: analyticsContext,
            appearance: "subtle",
            target: "_blank",
            ref: ref,
            role: "button"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: icon,
            label: label,
            onClick: onClick,
            testId: testId,
            analyticsContext: analyticsContext,
            appearance: "subtle",
            ref: ref,
            role: "button"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
            ref: ref,
            icon: icon,
            label: label,
            onClick: onClick,
            testId: testId,
            appearance: "subtle"
        });
    }
    return href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
        icon: icon,
        label: label,
        onClick: onClick,
        href: href,
        testId: testId,
        analyticsContext: analyticsContext,
        appearance: "subtle",
        target: "_blank",
        ref: ref,
        role: "button"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: icon,
        label: label,
        onClick: onClick,
        testId: testId,
        analyticsContext: analyticsContext,
        appearance: "subtle",
        ref: ref,
        role: "button"
    });
});
module.exports["PreviewPanelAction"] = $e48bc72cc4b3f1f2$export$a37cb5f447b2cf16;

});

parcelRegister("bRCqW", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ixfCV = parcelRequire("ixfCV");


var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $aMRlV = parcelRequire("aMRlV");

const $33c23c71035fcd90$export$92a58681483f4529 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { title: title, icon: icon, color: color } = t0;
    if ((0, $ixfCV.fg)("ads-panel-system-gpp")) {
        let t1;
        if ($[0] !== icon || $[1] !== title) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aMRlV.PanelTitle), {
                icon: icon
            }, title);
            $[0] = icon;
            $[1] = title;
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    let t1;
    if ($[3] !== color || $[4] !== title) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            weight: "bold",
            maxLines: 1,
            color: color
        }, title);
        $[3] = color;
        $[4] = title;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== icon || $[7] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            space: "space.100",
            alignBlock: "center"
        }, icon, t1);
        $[6] = icon;
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ title: title, icon: icon, color: color })=>{
    if ((0, $ixfCV.fg)('ads-panel-system-gpp')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aMRlV.PanelTitle), {
        icon: icon
    }, title);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        space: "space.100",
        alignBlock: "center"
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        weight: "bold",
        maxLines: 1,
        color: color
    }, title));
};
module.exports["PreviewPanelTitle"] = $33c23c71035fcd90$export$92a58681483f4529;

});

parcelRegister("aMRlV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $I7hWB = parcelRequire("I7hWB");


var $iMnC5 = parcelRequire("iMnC5");

const $4105ecb3e4516dff$var$styles = {
    title: "_1e0c1txw _4cvr1h6o _16jlkb7n",
    titleText: "_bozg1b66",
    icon: "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1k8s _4t3i1k8s"
}; /**
    * The PanelTitle component provides a standardized title display for panels
    * with optional icon support and consistent typography.
    */ 
const $4105ecb3e4516dff$export$86de09faaa70680d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelTitle(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { children: children, icon: icon, testId: testId } = t0;
    let t1;
    if ($[0] !== icon) {
        t1 = icon && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            xcss: $4105ecb3e4516dff$var$styles.icon
        }, icon);
        $[0] = icon;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $4105ecb3e4516dff$var$styles.titleText
        ]);
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ $cozmU.createElement("span", {
            className: t2
        }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: "small",
            as: "h2"
        }, children));
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== t1 || $[6] !== t3 || $[7] !== testId) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
            testId: testId,
            xcss: $4105ecb3e4516dff$var$styles.title
        }, t1, t3);
        $[5] = t1;
        $[6] = t3;
        $[7] = testId;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : function PanelTitle({ children: children, icon: icon, testId: testId }) {
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        testId: testId,
        xcss: $4105ecb3e4516dff$var$styles.title
    }, icon && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: $4105ecb3e4516dff$var$styles.icon
    }, icon), /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            $4105ecb3e4516dff$var$styles.titleText
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "small",
        as: "h2"
    }, children)));
};
module.exports["PanelTitle"] = $4105ecb3e4516dff$export$86de09faaa70680d;

});

parcelRegister("6dlKt", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jmUhx = parcelRequire("jmUhx");


var $NlHoa = parcelRequire("NlHoa");

var $bltJZ = parcelRequire("bltJZ");


var $iMnC5 = parcelRequire("iMnC5");

const $bea364caeb317857$var$GoogleDriveIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    let props;
    let size;
    if ($[0] !== t0) {
        ({ size: size, ...props } = t0);
        $[0] = t0;
        $[1] = props;
        $[2] = size;
    } else {
        props = $[1];
        size = $[2];
    }
    const t1 = size ?? 20;
    const t2 = size ?? 18;
    let t3;
    let t4;
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M3.33374 17.3241L6.66677 11.5493H19.9999L16.6666 17.3241H3.33374Z",
            fill: "#3777E3"
        });
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M13.3335 11.5493H19.9999L13.3335 0H6.6665L13.3335 11.5493Z",
            fill: "#FFCF63"
        });
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M0 11.5493L3.3335 17.324L9.99985 5.77469L6.66656 0L0 11.5493Z",
            fill: "#11A861"
        });
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
    } else {
        t3 = $[3];
        t4 = $[4];
        t5 = $[5];
    }
    let t6;
    if ($[6] !== props.dataTestId || $[7] !== props.label || $[8] !== t1 || $[9] !== t2) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: t1,
            height: t2,
            viewBox: "0 0 20 18",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": props.dataTestId,
            "aria-label": props.label
        }, t3, t4, t5);
        $[6] = props.dataTestId;
        $[7] = props.label;
        $[8] = t1;
        $[9] = t2;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
} : ({ size: size, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: size ?? 20,
        height: size ?? 18,
        viewBox: "0 0 20 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props.dataTestId,
        "aria-label": props.label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M3.33374 17.3241L6.66677 11.5493H19.9999L16.6666 17.3241H3.33374Z",
        fill: "#3777E3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M13.3335 11.5493H19.9999L13.3335 0H6.6665L13.3335 11.5493Z",
        fill: "#FFCF63"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M0 11.5493L3.3335 17.324L9.99985 5.77469L6.66656 0L0 11.5493Z",
        fill: "#11A861"
    }));
const $bea364caeb317857$var$SlackIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    let props;
    let size;
    if ($[0] !== t0) {
        ({ size: size, ...props } = t0);
        $[0] = t0;
        $[1] = props;
        $[2] = size;
    } else {
        props = $[1];
        size = $[2];
    }
    const t1 = size ?? 24;
    const t2 = size ?? 24;
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            clipPath: "url(#clip0_271_181639)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.33321 2C8.22767 2.00082 7.33294 2.89621 7.33375 3.99954C7.33294 5.10288 8.22849 5.99827 9.33403 5.99909H11.3343V4.00036C11.3351 2.89702 10.4396 2.00163 9.33321 2C9.33403 2 9.33403 2 9.33321 2V2ZM9.33321 7.33321H4.00077C2.89522 7.33402 1.99967 8.22941 2.00049 9.33275C1.99886 10.4361 2.89441 11.3315 3.99995 11.3331H9.33321C10.4388 11.3323 11.3343 10.4369 11.3335 9.33357C11.3343 8.22941 10.4388 7.33402 9.33321 7.33321V7.33321Z",
            fill: "#36C5F0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.9998 9.33275C22.0006 8.22941 21.1051 7.33402 19.9995 7.33321C18.894 7.33402 17.9984 8.22941 17.9992 9.33275V11.3331H19.9995C21.1051 11.3323 22.0006 10.4369 21.9998 9.33275ZM16.6665 9.33275V3.99954C16.6673 2.89702 15.7726 2.00163 14.667 2C13.5615 2.00082 12.6659 2.89621 12.6668 3.99954V9.33275C12.6651 10.4361 13.5607 11.3315 14.6662 11.3331C15.7718 11.3323 16.6673 10.4369 16.6665 9.33275Z",
            fill: "#2EB67D"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.6665 21.9995C15.7721 21.9987 16.6677 21.1033 16.6668 19.9999C16.6677 18.8966 15.7721 18.0012 14.6665 18.0004H12.6663V19.9999C12.6654 21.1025 13.561 21.9979 14.6665 21.9995ZM14.6665 16.6654H19.9998C21.1054 16.6646 22.0009 15.7692 22.0001 14.6659C22.0018 13.5626 21.1062 12.6672 20.0006 12.6655H14.6674C13.5618 12.6663 12.6663 13.5617 12.6671 14.6651C12.6663 15.7692 13.561 16.6646 14.6665 16.6654V16.6654Z",
            fill: "#ECB22E"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2.00073 14.6663C1.99992 15.7696 2.89547 16.665 4.00102 16.6659C5.10657 16.665 6.00212 15.7696 6.0013 14.6663V12.6667H4.00102C2.89547 12.6676 1.99992 13.563 2.00073 14.6663ZM7.33401 14.6663V19.9995C7.33237 21.1029 8.22792 21.9983 9.33347 21.9999C10.439 21.9991 11.3346 21.1037 11.3338 20.0003V14.6679C11.3354 13.5646 10.4398 12.6692 9.33429 12.6676C8.22792 12.6676 7.33319 13.563 7.33401 14.6663C7.33401 14.6671 7.33401 14.6663 7.33401 14.6663Z",
            fill: "#E01E5A"
        }));
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
            id: "clip0_271_181639"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            width: "20",
            height: "20",
            fill: "white",
            transform: "translate(2 2)"
        })));
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== props.dataTestId || $[6] !== props.label || $[7] !== t1 || $[8] !== t2) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: t1,
            height: t2,
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": props.dataTestId,
            "aria-label": props.label
        }, t3, t4);
        $[5] = props.dataTestId;
        $[6] = props.label;
        $[7] = t1;
        $[8] = t2;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : ({ size: size, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: size ?? 24,
        height: size ?? 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props.dataTestId,
        "aria-label": props.label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_271_181639)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.33321 2C8.22767 2.00082 7.33294 2.89621 7.33375 3.99954C7.33294 5.10288 8.22849 5.99827 9.33403 5.99909H11.3343V4.00036C11.3351 2.89702 10.4396 2.00163 9.33321 2C9.33403 2 9.33403 2 9.33321 2V2ZM9.33321 7.33321H4.00077C2.89522 7.33402 1.99967 8.22941 2.00049 9.33275C1.99886 10.4361 2.89441 11.3315 3.99995 11.3331H9.33321C10.4388 11.3323 11.3343 10.4369 11.3335 9.33357C11.3343 8.22941 10.4388 7.33402 9.33321 7.33321V7.33321Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.9998 9.33275C22.0006 8.22941 21.1051 7.33402 19.9995 7.33321C18.894 7.33402 17.9984 8.22941 17.9992 9.33275V11.3331H19.9995C21.1051 11.3323 22.0006 10.4369 21.9998 9.33275ZM16.6665 9.33275V3.99954C16.6673 2.89702 15.7726 2.00163 14.667 2C13.5615 2.00082 12.6659 2.89621 12.6668 3.99954V9.33275C12.6651 10.4361 13.5607 11.3315 14.6662 11.3331C15.7718 11.3323 16.6673 10.4369 16.6665 9.33275Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.6665 21.9995C15.7721 21.9987 16.6677 21.1033 16.6668 19.9999C16.6677 18.8966 15.7721 18.0012 14.6665 18.0004H12.6663V19.9999C12.6654 21.1025 13.561 21.9979 14.6665 21.9995ZM14.6665 16.6654H19.9998C21.1054 16.6646 22.0009 15.7692 22.0001 14.6659C22.0018 13.5626 21.1062 12.6672 20.0006 12.6655H14.6674C13.5618 12.6663 12.6663 13.5617 12.6671 14.6651C12.6663 15.7692 13.561 16.6646 14.6665 16.6654V16.6654Z",
        fill: "#ECB22E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.00073 14.6663C1.99992 15.7696 2.89547 16.665 4.00102 16.6659C5.10657 16.665 6.00212 15.7696 6.0013 14.6663V12.6667H4.00102C2.89547 12.6676 1.99992 13.563 2.00073 14.6663ZM7.33401 14.6663V19.9995C7.33237 21.1029 8.22792 21.9983 9.33347 21.9999C10.439 21.9991 11.3346 21.1037 11.3338 20.0003V14.6679C11.3354 13.5646 10.4398 12.6692 9.33429 12.6676C8.22792 12.6676 7.33319 13.563 7.33401 14.6663C7.33401 14.6671 7.33401 14.6663 7.33401 14.6663Z",
        fill: "#E01E5A"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_271_181639"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "20",
        height: "20",
        fill: "white",
        transform: "translate(2 2)"
    }))));
const $bea364caeb317857$var$MicrosoftSharepointIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    let props;
    let size;
    if ($[0] !== t0) {
        ({ size: size, ...props } = t0);
        $[0] = t0;
        $[1] = props;
        $[2] = size;
    } else {
        props = $[1];
        size = $[2];
    }
    const t1 = size ?? 20;
    const t2 = size ?? 20;
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
            id: "mask0_1701_19689",
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "20",
            height: "20"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M20 0H0V20H20V0Z",
            fill: "white"
        }));
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            mask: "url(#mask0_1701_19689)"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M10.2328 11.4286C13.3153 11.4286 15.8142 8.87025 15.8142 5.71429C15.8142 2.55838 13.3153 0 10.2328 0C7.15024 0 4.65137 2.55838 4.65137 5.71429C4.65137 8.87025 7.15024 11.4286 10.2328 11.4286Z",
            fill: "#036C70"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M14.8838 16.1906C17.7095 16.1906 20.0001 13.8453 20.0001 10.9524C20.0001 8.05957 17.7095 5.71436 14.8838 5.71436C12.0582 5.71436 9.76758 8.05957 9.76758 10.9524C9.76758 13.8453 12.0582 16.1906 14.8838 16.1906Z",
            fill: "#1A9BA1"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M10.93 20C13.1135 20 14.8835 18.1879 14.8835 15.9524C14.8835 13.717 13.1135 11.9048 10.93 11.9048C8.74654 11.9048 6.97656 13.717 6.97656 15.9524C6.97656 18.1879 8.74654 20 10.93 20Z",
            fill: "#37C6D0"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.1",
            d: "M11.1628 5.15708V15.3189C11.1605 15.6721 10.9515 15.9893 10.6327 16.1237C10.531 16.1677 10.4219 16.1904 10.3117 16.1904H6.98145C6.9768 16.1094 6.9768 16.0333 6.9768 15.9523C6.97525 15.8728 6.97835 15.7933 6.9861 15.7142C7.07124 14.1921 7.98717 12.8491 9.35355 12.2428V11.3571C6.31257 10.8637 4.23802 7.93981 4.71991 4.82647C4.72326 4.80491 4.72671 4.78336 4.7303 4.76183C4.75345 4.60124 4.78607 4.44222 4.82797 4.28564H10.3117C10.781 4.28748 11.161 4.67657 11.1628 5.15708Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M9.84662 4.76196H4.73038C4.21355 7.86969 6.25531 10.8181 9.29075 11.3472C9.38275 11.3632 9.475 11.3768 9.56762 11.3882C8.12575 12.0882 7.07503 14.0763 6.98573 15.7143C6.97798 15.7934 6.97488 15.8729 6.97642 15.9524C6.97642 16.0334 6.97642 16.1096 6.98107 16.1906C6.98946 16.3506 7.00968 16.5098 7.04153 16.6667H9.84625C10.1911 16.6643 10.5009 16.4504 10.6322 16.1238C10.6751 16.0199 10.6974 15.9082 10.6974 15.7953V5.6334C10.6956 5.15306 10.3159 4.76406 9.84662 4.76196Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M9.84662 4.76196H4.73035C4.21361 7.87006 6.25568 10.8184 9.29149 11.3476C9.35362 11.3583 9.41587 11.3681 9.47825 11.3767C8.08287 12.1272 7.07361 14.1106 6.98616 15.7143H9.84662C10.3152 15.7107 10.6942 15.3227 10.6977 14.8429V5.6334C10.696 5.15289 10.316 4.7638 9.84662 4.76196Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            opacity: "0.2",
            d: "M9.38134 4.76196H4.73019C4.24225 7.69606 6.03799 10.5216 8.85572 11.2534C7.78884 12.5014 7.13442 14.0628 6.986 15.7143H9.38134C9.85072 15.7126 10.2307 15.3234 10.2325 14.8429V5.6334C10.2322 5.15224 9.85134 4.76224 9.38134 4.76196Z",
            fill: "black"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M0.852563 4.76196H9.38C9.85087 4.76196 10.2325 5.15276 10.2325 5.63483V14.3653C10.2325 14.8473 9.85087 15.2382 9.38 15.2382H0.852563C0.3817 15.2382 0 14.8473 0 14.3653V5.63483C0 5.15276 0.3817 4.76196 0.852563 4.76196Z",
            fill: "#04868B"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            d: "M3.80825 9.89327C3.60846 9.75752 3.44157 9.57689 3.32035 9.36514C3.20289 9.14377 3.14433 8.89464 3.15057 8.64277C3.14011 8.30177 3.25251 7.96864 3.46639 7.70702C3.69112 7.44504 3.98162 7.25104 4.30638 7.14607C4.67651 7.02134 5.06418 6.95988 5.45382 6.96417C5.96621 6.94499 6.4779 7.01834 6.96545 7.18083V8.27602C6.75361 8.14464 6.52287 8.04827 6.28172 7.99039C6.02007 7.92464 5.7516 7.89177 5.48218 7.89227C5.1981 7.88164 4.91582 7.94277 4.66034 8.07039C4.46307 8.15752 4.33516 8.35614 4.33475 8.57602C4.33395 8.70952 4.38401 8.83802 4.47429 8.93414C4.58091 9.04764 4.70705 9.13989 4.84638 9.20652C5.00142 9.28564 5.23397 9.39064 5.54406 9.52177C5.5782 9.53289 5.61147 9.54652 5.64358 9.56277C5.94877 9.68489 6.24317 9.83352 6.5236 10.007C6.73595 10.1411 6.91417 10.3249 7.0436 10.5433C7.17628 10.7908 7.2406 11.0706 7.22963 11.3528C7.24478 11.7029 7.14016 12.0474 6.93382 12.327C6.72816 12.5841 6.45319 12.7735 6.14312 12.8718C5.77844 12.9888 5.39781 13.0454 5.01569 13.0394C4.67282 13.041 4.33047 13.0124 3.99242 12.9536C3.707 12.9059 3.42845 12.822 3.16314 12.7041V11.5494C3.41675 11.7349 3.70007 11.8734 4.00033 11.9589C4.29958 12.0544 4.61066 12.1054 4.92406 12.1104C5.21412 12.1291 5.50367 12.0663 5.76127 11.9285C5.94172 11.8243 6.05147 11.6268 6.04686 11.4146C6.04806 11.2671 5.99103 11.1253 5.88872 11.0213C5.76147 10.8934 5.61415 10.7883 5.45291 10.7104C5.26686 10.6151 4.99291 10.4895 4.63105 10.3336C4.34317 10.2153 4.06755 10.0676 3.80825 9.89327Z",
            fill: "white"
        }));
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== props.dataTestId || $[6] !== props.label || $[7] !== t1 || $[8] !== t2) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: t1,
            height: t2,
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": props.dataTestId,
            "aria-label": props.label
        }, t3, t4);
        $[5] = props.dataTestId;
        $[6] = props.label;
        $[7] = t1;
        $[8] = t2;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : ({ size: size, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: size ?? 20,
        height: size ?? 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props.dataTestId,
        "aria-label": props.label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
        id: "mask0_1701_19689",
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "20",
        height: "20"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M20 0H0V20H20V0Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        mask: "url(#mask0_1701_19689)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M10.2328 11.4286C13.3153 11.4286 15.8142 8.87025 15.8142 5.71429C15.8142 2.55838 13.3153 0 10.2328 0C7.15024 0 4.65137 2.55838 4.65137 5.71429C4.65137 8.87025 7.15024 11.4286 10.2328 11.4286Z",
        fill: "#036C70"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M14.8838 16.1906C17.7095 16.1906 20.0001 13.8453 20.0001 10.9524C20.0001 8.05957 17.7095 5.71436 14.8838 5.71436C12.0582 5.71436 9.76758 8.05957 9.76758 10.9524C9.76758 13.8453 12.0582 16.1906 14.8838 16.1906Z",
        fill: "#1A9BA1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M10.93 20C13.1135 20 14.8835 18.1879 14.8835 15.9524C14.8835 13.717 13.1135 11.9048 10.93 11.9048C8.74654 11.9048 6.97656 13.717 6.97656 15.9524C6.97656 18.1879 8.74654 20 10.93 20Z",
        fill: "#37C6D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.1",
        d: "M11.1628 5.15708V15.3189C11.1605 15.6721 10.9515 15.9893 10.6327 16.1237C10.531 16.1677 10.4219 16.1904 10.3117 16.1904H6.98145C6.9768 16.1094 6.9768 16.0333 6.9768 15.9523C6.97525 15.8728 6.97835 15.7933 6.9861 15.7142C7.07124 14.1921 7.98717 12.8491 9.35355 12.2428V11.3571C6.31257 10.8637 4.23802 7.93981 4.71991 4.82647C4.72326 4.80491 4.72671 4.78336 4.7303 4.76183C4.75345 4.60124 4.78607 4.44222 4.82797 4.28564H10.3117C10.781 4.28748 11.161 4.67657 11.1628 5.15708Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M9.84662 4.76196H4.73038C4.21355 7.86969 6.25531 10.8181 9.29075 11.3472C9.38275 11.3632 9.475 11.3768 9.56762 11.3882C8.12575 12.0882 7.07503 14.0763 6.98573 15.7143C6.97798 15.7934 6.97488 15.8729 6.97642 15.9524C6.97642 16.0334 6.97642 16.1096 6.98107 16.1906C6.98946 16.3506 7.00968 16.5098 7.04153 16.6667H9.84625C10.1911 16.6643 10.5009 16.4504 10.6322 16.1238C10.6751 16.0199 10.6974 15.9082 10.6974 15.7953V5.6334C10.6956 5.15306 10.3159 4.76406 9.84662 4.76196Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M9.84662 4.76196H4.73035C4.21361 7.87006 6.25568 10.8184 9.29149 11.3476C9.35362 11.3583 9.41587 11.3681 9.47825 11.3767C8.08287 12.1272 7.07361 14.1106 6.98616 15.7143H9.84662C10.3152 15.7107 10.6942 15.3227 10.6977 14.8429V5.6334C10.696 5.15289 10.316 4.7638 9.84662 4.76196Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.2",
        d: "M9.38134 4.76196H4.73019C4.24225 7.69606 6.03799 10.5216 8.85572 11.2534C7.78884 12.5014 7.13442 14.0628 6.986 15.7143H9.38134C9.85072 15.7126 10.2307 15.3234 10.2325 14.8429V5.6334C10.2322 5.15224 9.85134 4.76224 9.38134 4.76196Z",
        fill: "black"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M0.852563 4.76196H9.38C9.85087 4.76196 10.2325 5.15276 10.2325 5.63483V14.3653C10.2325 14.8473 9.85087 15.2382 9.38 15.2382H0.852563C0.3817 15.2382 0 14.8473 0 14.3653V5.63483C0 5.15276 0.3817 4.76196 0.852563 4.76196Z",
        fill: "#04868B"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M3.80825 9.89327C3.60846 9.75752 3.44157 9.57689 3.32035 9.36514C3.20289 9.14377 3.14433 8.89464 3.15057 8.64277C3.14011 8.30177 3.25251 7.96864 3.46639 7.70702C3.69112 7.44504 3.98162 7.25104 4.30638 7.14607C4.67651 7.02134 5.06418 6.95988 5.45382 6.96417C5.96621 6.94499 6.4779 7.01834 6.96545 7.18083V8.27602C6.75361 8.14464 6.52287 8.04827 6.28172 7.99039C6.02007 7.92464 5.7516 7.89177 5.48218 7.89227C5.1981 7.88164 4.91582 7.94277 4.66034 8.07039C4.46307 8.15752 4.33516 8.35614 4.33475 8.57602C4.33395 8.70952 4.38401 8.83802 4.47429 8.93414C4.58091 9.04764 4.70705 9.13989 4.84638 9.20652C5.00142 9.28564 5.23397 9.39064 5.54406 9.52177C5.5782 9.53289 5.61147 9.54652 5.64358 9.56277C5.94877 9.68489 6.24317 9.83352 6.5236 10.007C6.73595 10.1411 6.91417 10.3249 7.0436 10.5433C7.17628 10.7908 7.2406 11.0706 7.22963 11.3528C7.24478 11.7029 7.14016 12.0474 6.93382 12.327C6.72816 12.5841 6.45319 12.7735 6.14312 12.8718C5.77844 12.9888 5.39781 13.0454 5.01569 13.0394C4.67282 13.041 4.33047 13.0124 3.99242 12.9536C3.707 12.9059 3.42845 12.822 3.16314 12.7041V11.5494C3.41675 11.7349 3.70007 11.8734 4.00033 11.9589C4.29958 12.0544 4.61066 12.1054 4.92406 12.1104C5.21412 12.1291 5.50367 12.0663 5.76127 11.9285C5.94172 11.8243 6.05147 11.6268 6.04686 11.4146C6.04806 11.2671 5.99103 11.1253 5.88872 11.0213C5.76147 10.8934 5.61415 10.7883 5.45291 10.7104C5.26686 10.6151 4.99291 10.4895 4.63105 10.3336C4.34317 10.2153 4.06755 10.0676 3.80825 9.89327Z",
        fill: "white"
    })));
const $bea364caeb317857$var$styles = {
    scaledLogoWrapper: "_1e0c116y _4cvr1h6o _1bah1h6o",
    scaledLogoInner: "_1e0c116y"
};
const $bea364caeb317857$var$renderScaledLogo = (element, baseSize, size)=>{
    if (!size) return element;
    const scale = size / baseSize;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        as: "span",
        xcss: $bea364caeb317857$var$styles.scaledLogoWrapper,
        style: {
            width: size,
            height: size
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        as: "span",
        xcss: $bea364caeb317857$var$styles.scaledLogoInner,
        style: {
            transform: `scale(${scale})`
        }
    }, element));
};
const $bea364caeb317857$export$f32a352406d501db = (source)=>source === 'atlas' ? 'Projects and goals' : source.replace(/[_-]/g, ' ').split(' ').map((word)=>word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' '); // Base sizes match the rendered pixel dimensions of each icon at their default/size="small" value.
// Atlaskit Logo size="small" = 24px. SVG icons use their native viewBox dimensions.
const $bea364caeb317857$var$iconRenderers = {
    confluence: (options)=>$bea364caeb317857$var$renderScaledLogo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.ConfluenceIcon), {
            size: "small",
            appearance: "brand"
        }), 24, options?.size),
    jira: (options)=>$bea364caeb317857$var$renderScaledLogo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.JiraIcon), {
            size: "small",
            appearance: "brand"
        }), 24, options?.size),
    atlas: (options)=>$bea364caeb317857$var$renderScaledLogo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
            label: "",
            size: "small",
            appearance: "brand"
        }), 24, options?.size),
    google_drive: (options)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bea364caeb317857$var$GoogleDriveIcon, {
            label: "",
            size: options?.size
        }),
    microsoft_sharepoint: (options)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bea364caeb317857$var$MicrosoftSharepointIcon, {
            label: "",
            size: options?.size
        }),
    slack: (options)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bea364caeb317857$var$SlackIcon, {
            label: "",
            size: options?.size
        }),
    loom: (options)=>$bea364caeb317857$var$renderScaledLogo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.LoomIcon), {
            label: "",
            size: "small"
        }), 24, options?.size),
    app: (options)=>$bea364caeb317857$var$renderScaledLogo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jmUhx))), {
            label: "",
            size: "small"
        }), 12, options?.size)
};
const $bea364caeb317857$export$c63040ce43e3b7ce = Object.fromEntries(Object.entries($bea364caeb317857$var$iconRenderers).map(([key, render])=>[
        key,
        render()
    ]));
const $bea364caeb317857$export$40f6c94e234ed9d9 = (source, options)=>$bea364caeb317857$var$iconRenderers[source]?.(options) ?? null;
module.exports["formatKnowledgeSourceLabel"] = $bea364caeb317857$export$f32a352406d501db;
module.exports["iconMapper"] = $bea364caeb317857$export$c63040ce43e3b7ce;
module.exports["getKnowledgeSourceIcon"] = $bea364caeb317857$export$40f6c94e234ed9d9;

});

parcelRegister("1z5OI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8238471175f767861134859691ed34ec>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $123d927b95b85f60$var$_react = $123d927b95b85f60$var$_interopRequireDefault((parcelRequire("cozmU")));

var $123d927b95b85f60$var$_baseNew = $123d927b95b85f60$var$_interopRequireDefault((parcelRequire("gElAV")));
function $123d927b95b85f60$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Telescope".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: Discover feature in Atlassian Home
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $123d927b95b85f60$var$TelescopeIcon = (props)=>/*#__PURE__*/ $123d927b95b85f60$var$_react.default.createElement($123d927b95b85f60$var$_baseNew.default, Object.assign({
        name: "TelescopeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7.687 9.505a.75.75 0 0 1 1.183.072l3.75 5.5-1.24.846L9 12.432V16H7.5l-.001-3.567-2.38 3.49-1.239-.845 3.75-5.5z"/><path fill="currentcolor" d="m10.66 2.963 1.531 2.653L14.44 4.51l-1.698-2.94zM4.414 7.146l1.032 1.787 5.396-2.654L9.411 3.8zm11.392-3.27c.397.69.13 1.571-.584 1.922L3.118 11.75a1.687 1.687 0 0 1-2.206-.67L.289 10A1.687 1.687 0 0 1 .81 7.756L12.018.249l.126-.076a1.375 1.375 0 0 1 1.83.53zM2.21 10.33c.05.085.156.117.245.074l1.64-.808-.93-1.613-1.52 1.019a.187.187 0 0 0-.058.249z"/>`
    }, props));
$123d927b95b85f60$var$TelescopeIcon.displayName = 'TelescopeIcon';
var $123d927b95b85f60$var$_default = module.exports.default = $123d927b95b85f60$var$TelescopeIcon;

});

parcelRegister("kuGC4", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");


var $lx3cN = parcelRequire("lx3cN");

const $d57cf010992105d3$export$409e508fe0e24613 = (0, $kBr4q.createStateHook)((0, $lx3cN.chatStore), {
    selector: (state, { conversationId: conversationId })=>state.conversations[conversationId]
});
module.exports["useConversationById"] = $d57cf010992105d3$export$409e508fe0e24613;

});

parcelRegister("lU4RT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");


var $acQiA = parcelRequire("acQiA");


var $9d7Pd = parcelRequire("9d7Pd");


var $3jSHR = parcelRequire("3jSHR");


var $43dcO = parcelRequire("43dcO");


var $imIsb = parcelRequire("imIsb");


var $1P2f3 = parcelRequire("1P2f3");

/**
 * __Dropdown item checkbox__
 *
 * A dropdown item checkbox creates groups that have multiple selections.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/usage)
 */ const $6b3a69811500fe11$var$DropdownItemCheckbox = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(36);
    let children;
    let defaultSelected;
    let description;
    let id;
    let interactionName;
    let isDisabled;
    let isSelected;
    let rest;
    let t1;
    let t2;
    let t3;
    let testId;
    if ($[0] !== t0) {
        ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: t1, shouldDescriptionWrap: t2, shouldTitleWrap: t3, testId: testId, interactionName: interactionName, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = defaultSelected;
        $[3] = description;
        $[4] = id;
        $[5] = interactionName;
        $[6] = isDisabled;
        $[7] = isSelected;
        $[8] = rest;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = testId;
    } else {
        children = $[1];
        defaultSelected = $[2];
        description = $[3];
        id = $[4];
        interactionName = $[5];
        isDisabled = $[6];
        isSelected = $[7];
        rest = $[8];
        t1 = $[9];
        t2 = $[10];
        t3 = $[11];
        testId = $[12];
    }
    const providedOnClick = t1 === undefined ? (0, $dpsRj.default) : t1;
    const shouldDescriptionWrap = t2 === undefined ? true : t2;
    const shouldTitleWrap = t3 === undefined ? true : t3;
    typeof $1P2f3;
    let t4;
    if ($[13] !== defaultSelected || $[14] !== id || $[15] !== isSelected) {
        t4 = {
            id: id,
            isSelected: isSelected,
            defaultSelected: defaultSelected
        };
        $[13] = defaultSelected;
        $[14] = id;
        $[15] = isSelected;
        $[16] = t4;
    } else t4 = $[16];
    const [selected, setSelected] = (0, $43dcO.default)(t4);
    let t5;
    if ($[17] !== providedOnClick || $[18] !== setSelected) {
        t5 = (event)=>{
            setSelected($6b3a69811500fe11$var$_temp);
            providedOnClick(event);
        };
        $[17] = providedOnClick;
        $[18] = setSelected;
        $[19] = t5;
    } else t5 = $[19];
    const onClickHandler = t5;
    const itemRef = (0, $imIsb.default)();
    let t6;
    if ($[20] !== selected) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3jSHR.default), {
            checked: selected
        });
        $[20] = selected;
        $[21] = t6;
    } else t6 = $[21];
    let t7;
    if ($[22] !== children || $[23] !== description || $[24] !== id || $[25] !== interactionName || $[26] !== isDisabled || $[27] !== itemRef || $[28] !== onClickHandler || $[29] !== rest || $[30] !== selected || $[31] !== shouldDescriptionWrap || $[32] !== shouldTitleWrap || $[33] !== t6 || $[34] !== testId) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $acQiA.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
            value: "none"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            "aria-checked": selected,
            description: description,
            iconBefore: t6,
            id: id,
            isDisabled: isDisabled,
            isSelected: selected,
            onClick: onClickHandler,
            ref: itemRef,
            role: "menuitemcheckbox",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            interactionName: interactionName,
            ...rest
        }, children));
        $[22] = children;
        $[23] = description;
        $[24] = id;
        $[25] = interactionName;
        $[26] = isDisabled;
        $[27] = itemRef;
        $[28] = onClickHandler;
        $[29] = rest;
        $[30] = selected;
        $[31] = shouldDescriptionWrap;
        $[32] = shouldTitleWrap;
        $[33] = t6;
        $[34] = testId;
        $[35] = t7;
    } else t7 = $[35];
    return t7;
} : ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $dpsRj.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, testId: testId, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $1P2f3;
    const [selected, setSelected] = (0, $43dcO.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $cozmU.useCallback)((event)=>{
        setSelected((selected_0)=>!selected_0);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $imIsb.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $acQiA.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        "aria-checked": selected,
        description: description,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3jSHR.default), {
            checked: selected
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: selected,
        onClick: onClickHandler,
        ref: itemRef,
        role: "menuitemcheckbox",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        interactionName: interactionName,
        ...rest
    }, children));
};
var $6b3a69811500fe11$export$2e2bcd8739ae039 = $6b3a69811500fe11$var$DropdownItemCheckbox;
function $6b3a69811500fe11$var$_temp(selected_0) {
    return !selected_0;
}
module.exports["default"] = $6b3a69811500fe11$export$2e2bcd8739ae039;

});

parcelRegister("3jSHR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $a8ec5e894df17170$var$svgStyles = null; /**
                         * __Checkbox icon__
                         *
                         * Used to visually represent the selected state in DropdownItemCheckbox
                         *
                         * @internal
                         */ 
const $a8ec5e894df17170$var$CheckboxIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { checked: checked } = t0;
    const t1 = checked ? "var(--ds-background-selected-bold, #1868DB)" : "var(--ds-background-input, #FFFFFF)";
    const t2 = checked ? "var(--ds-icon-inverse, #FFFFFF)" : "transparent";
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = {
            color: t1,
            fill: t2
        };
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ]);
        $[3] = t4;
    } else t4 = $[3];
    const t5 = checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)";
    let t6;
    if ($[4] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
            stroke: t5,
            x: "5.5",
            y: "5.5",
            width: "13",
            height: "13",
            rx: "1.5",
            fill: "currentColor"
        });
        $[4] = t5;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        $[6] = t7;
    } else t7 = $[6];
    let t8;
    if ($[7] !== t6) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
            fillRule: "evenodd"
        }, t6, t7);
        $[7] = t6;
        $[8] = t8;
    } else t8 = $[8];
    let t9;
    if ($[9] !== t3 || $[10] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            style: t3,
            role: "presentation",
            className: t4
        }, t8);
        $[9] = t3;
        $[10] = t8;
        $[11] = t9;
    } else t9 = $[11];
    return t9;
} : ({ checked: checked })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            color: checked ? "var(--ds-background-selected-bold, #1868DB)" : "var(--ds-background-input, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            fill: checked ? "var(--ds-icon-inverse, #FFFFFF)" : 'transparent'
        },
        role: "presentation",
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        stroke: checked ? "var(--ds-border-selected, #1868DB)" : "var(--ds-border-input, #8C8F97)",
        x: "5.5",
        y: "5.5",
        width: "13",
        height: "13",
        rx: "1.5",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit"
    })));
};
var $a8ec5e894df17170$export$2e2bcd8739ae039 = $a8ec5e894df17170$var$CheckboxIcon;
module.exports["default"] = $a8ec5e894df17170$export$2e2bcd8739ae039;

});

parcelRegister("43dcO", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hR9fw = parcelRequire("hR9fw");


var $lOWpM = parcelRequire("lOWpM");

/**
 * Custom hook to handle checkbox state for dropdown menu.
 * It works in tandem with the selection store context when the
 * component is uncontrolled.
 */ const $e413fac5530a681e$var$useCheckboxState = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { isSelected: isSelected, id: id, defaultSelected: defaultSelected } = t0;
    const { setItemState: setItemState, getItemState: getItemState } = (0, $cozmU.useContext)((0, $lOWpM.SelectionStoreContext));
    const groupId = (0, $cozmU.useContext)((0, $hR9fw.CheckboxGroupContext));
    let t1;
    if ($[0] !== getItemState || $[1] !== groupId || $[2] !== id) {
        t1 = getItemState(groupId, id);
        $[0] = getItemState;
        $[1] = groupId;
        $[2] = id;
        $[3] = t1;
    } else t1 = $[3];
    const persistedIsSelected = t1;
    let t2;
    if ($[4] !== defaultSelected || $[5] !== persistedIsSelected) {
        t2 = ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false;
        $[4] = defaultSelected;
        $[5] = persistedIsSelected;
        $[6] = t2;
    } else t2 = $[6];
    const [localIsSelected, setLocalIsSelected] = (0, $cozmU.useState)(t2);
    let t3;
    if ($[7] !== groupId || $[8] !== id || $[9] !== persistedIsSelected || $[10] !== setItemState) {
        t3 = (newValue)=>{
            const nextValue = newValue(persistedIsSelected);
            setLocalIsSelected(nextValue);
            setItemState(groupId, id, nextValue);
        };
        $[7] = groupId;
        $[8] = id;
        $[9] = persistedIsSelected;
        $[10] = setItemState;
        $[11] = t3;
    } else t3 = $[11];
    const setLocalState = t3;
    if (typeof isSelected === "boolean") {
        let t4;
        if ($[12] !== isSelected) {
            t4 = [
                isSelected,
                $e413fac5530a681e$var$_temp
            ];
            $[12] = isSelected;
            $[13] = t4;
        } else t4 = $[13];
        return t4;
    }
    if (persistedIsSelected === undefined) setItemState(groupId, id, defaultSelected || false);
    let t4;
    if ($[14] !== localIsSelected || $[15] !== setLocalState) {
        t4 = [
            localIsSelected,
            setLocalState
        ];
        $[14] = localIsSelected;
        $[15] = setLocalState;
        $[16] = t4;
    } else t4 = $[16];
    return t4;
} : ({ isSelected: isSelected, id: id, defaultSelected: defaultSelected })=>{
    const { setItemState: setItemState, getItemState: getItemState } = (0, $cozmU.useContext)((0, $lOWpM.SelectionStoreContext));
    const groupId = (0, $cozmU.useContext)((0, $hR9fw.CheckboxGroupContext));
    const persistedIsSelected = getItemState(groupId, id);
    const [localIsSelected, setLocalIsSelected] = (0, $cozmU.useState)(// Initial state is set depending on value being defined or not.
    // This state is only utilised if the checkbox is uncontrolled.
    ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $cozmU.useCallback)((newValue)=>{
        const nextValue = newValue(persistedIsSelected);
        setLocalIsSelected(nextValue);
        setItemState(groupId, id, nextValue);
    }, [
        setItemState,
        persistedIsSelected,
        groupId,
        id
    ]);
    // Checkbox is controlled - do nothing!
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    // Checkbox is going through its first render pass!
    if (persistedIsSelected === undefined) // Set the item so we have this state to access next time the checkbox renders (either by mounting or re-rendering!)
    setItemState(groupId, id, defaultSelected || false);
    // Return the value and setter!
    // Remember this flow is only returned if the checkbox is uncontrolled.
    return [
        localIsSelected,
        setLocalState
    ];
};
var $e413fac5530a681e$export$2e2bcd8739ae039 = $e413fac5530a681e$var$useCheckboxState;
function $e413fac5530a681e$var$_temp() {
    return false;
}
module.exports["default"] = $e413fac5530a681e$export$2e2bcd8739ae039;

});

parcelRegister("hR9fw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $c7ae6da6a8b76651$export$baf37c4be89255b8 = /*#__PURE__*/ (0, $cozmU.createContext)('');
module.exports["CheckboxGroupContext"] = $c7ae6da6a8b76651$export$baf37c4be89255b8;

});

parcelRegister("7DqNt", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6JrSr = parcelRequire("6JrSr");


var $8FgJC = parcelRequire("8FgJC");


var $eiIYc = parcelRequire("eiIYc");


var $hR9fw = parcelRequire("hR9fw");

/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu checkbox items.
 *
 */ const $1b4057c4abe15cf7$var$DropdownItemCheckboxGroup = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    let children;
    let hasSeparator;
    let id;
    let isList;
    let isScrollable;
    let rest;
    let testId;
    let title;
    if ($[0] !== t0) {
        ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, testId: testId, title: title, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = hasSeparator;
        $[3] = id;
        $[4] = isList;
        $[5] = isScrollable;
        $[6] = rest;
        $[7] = testId;
        $[8] = title;
    } else {
        children = $[1];
        hasSeparator = $[2];
        id = $[3];
        isList = $[4];
        isScrollable = $[5];
        rest = $[6];
        testId = $[7];
        title = $[8];
    }
    const uid = (0, $6JrSr.useId)();
    const titleId = `dropdown-menu-item-checkbox-group-title-${uid}`;
    const t1 = title ? titleId : undefined;
    let t2;
    if ($[9] !== title || $[10] !== titleId) {
        t2 = title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eiIYc.default), {
            id: titleId,
            title: title
        });
        $[9] = title;
        $[10] = titleId;
        $[11] = t2;
    } else t2 = $[11];
    let t3;
    if ($[12] !== children || $[13] !== hasSeparator || $[14] !== id || $[15] !== isList || $[16] !== isScrollable || $[17] !== rest || $[18] !== t1 || $[19] !== t2 || $[20] !== testId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
            hasSeparator: hasSeparator,
            id: id,
            isList: isList,
            isScrollable: isScrollable,
            testId: testId,
            titleId: t1,
            ...rest
        }, t2, children);
        $[12] = children;
        $[13] = hasSeparator;
        $[14] = id;
        $[15] = isList;
        $[16] = isScrollable;
        $[17] = rest;
        $[18] = t1;
        $[19] = t2;
        $[20] = testId;
        $[21] = t3;
    } else t3 = $[21];
    let t4;
    if ($[22] !== id || $[23] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hR9fw.CheckboxGroupContext).Provider, {
            value: id
        }, t3);
        $[22] = id;
        $[23] = t3;
        $[24] = t4;
    } else t4 = $[24];
    return t4;
} : ({ children: children, hasSeparator: hasSeparator, id: id, isList: isList, isScrollable: isScrollable, testId: testId, title: title, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    const uid = (0, $6JrSr.useId)();
    const titleId = `dropdown-menu-item-checkbox-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hR9fw.CheckboxGroupContext).Provider, {
        value: id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
        hasSeparator: hasSeparator,
        id: id,
        isList: isList,
        isScrollable: isScrollable,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eiIYc.default), {
        id: titleId,
        title: title
    }), children));
};
var $1b4057c4abe15cf7$export$2e2bcd8739ae039 = $1b4057c4abe15cf7$var$DropdownItemCheckboxGroup;
module.exports["default"] = $1b4057c4abe15cf7$export$2e2bcd8739ae039;

});

parcelRegister("lvJqX", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6JrSr = parcelRequire("6JrSr");


var $5wHqn = parcelRequire("5wHqn");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");

var $4aRua = parcelRequire("4aRua");


var $cEipP = parcelRequire("cEipP");

const $7c29b2adacb89176$var$styles = {
    contentStyles: "_1reo1wug _18m91wug _bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi _p12flti4 _c71llti4",
    rootStyles: "_1e0c1o8l _p12f1osq _1yyu1kum _y2mv1w7i",
    pressableStyles: "_2rko1qi0 _11c8fhey _1rjcze3t _18zrze3t _1e0c116y _bfhksm61 _syazazsu _o5721q9c _kqswh2mm _4cvr1q9y _p12f1osq _4t3i1wug _1bsb1wug _s7n41q9y _9oik1r31 _1bnx8stv _jf4cnqa1"
};
const $7c29b2adacb89176$var$iconColor = {
    connectivity: "_x5v91ft0",
    confirmation: "_x5v94pcx",
    info: "_x5v9qm1h",
    warning: "_x5v9ervl",
    error: "_x5v9s4qr"
}; /**
    * __Inline message__
    *
    * An inline message lets users know when important information is available or when an action is required.
    *
    * - [Examples](https://atlassian.design/components/inline-message/examples)
    * - [Code](https://atlassian.design/components/inline-message/code)
    * - [Usage](https://atlassian.design/components/inline-message/usage)
    *
    * @example
    *
    * ```jsx
    * const Component = () => (
    *   <InlineMessage
    *    title="Inline Message Title Example"
    *    secondaryText="Secondary Text"
    *   >
    *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
    *   </InlineMessage>
    * );
    * ```
    */ 
const $7c29b2adacb89176$var$InlineMessage = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { placement: t1, secondaryText: t2, title: t3, appearance: t4, spacing: t5, children: children, testId: testId, iconLabel: iconLabel, fallbackPlacements: fallbackPlacements } = t0;
    const placement = t1 === undefined ? "bottom-start" : t1;
    const secondaryText = t2 === undefined ? "" : t2;
    const title = t3 === undefined ? "" : t3;
    const appearance = t4 === undefined ? "connectivity" : t4;
    const spacing = t5 === undefined ? "spacious" : t5;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const id = (0, $6JrSr.useId)();
    let t6;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setIsOpen($7c29b2adacb89176$var$_temp);
        };
        $[0] = t6;
    } else t6 = $[0];
    const toggleDialog = t6;
    let t7;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>setIsOpen(false);
        $[1] = t7;
    } else t7 = $[1];
    const onCloseDialog = t7;
    const t8 = $7c29b2adacb89176$var$iconColor[appearance];
    let t9;
    if ($[2] !== t8) {
        t9 = (0, $hekY6.default)([
            $7c29b2adacb89176$var$styles.rootStyles,
            t8
        ]);
        $[2] = t8;
        $[3] = t9;
    } else t9 = $[3];
    let t10;
    if ($[4] !== children) {
        t10 = ()=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
                xcss: $7c29b2adacb89176$var$styles.contentStyles
            }, children);
        $[4] = children;
        $[5] = t10;
    } else t10 = $[5];
    const t11 = testId && `${testId}--popup`;
    let t12;
    if ($[6] !== appearance || $[7] !== iconLabel || $[8] !== id || $[9] !== isOpen || $[10] !== secondaryText || $[11] !== spacing || $[12] !== testId || $[13] !== title) {
        t12 = (t13)=>{
            const { ref: ref, ...triggerProps } = t13;
            return /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.default), {
                ...triggerProps,
                ref: ref,
                id: id,
                "data-ds--inline-message--button": true,
                onClick: toggleDialog,
                testId: testId && `${testId}--button`,
                xcss: $7c29b2adacb89176$var$styles.pressableStyles,
                "aria-expanded": isOpen
            }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
                as: "span",
                space: "space.050",
                alignBlock: "center"
            }, /*#__PURE__*/ $cozmU.createElement((0, $cEipP.default), {
                isOpen: isOpen,
                appearance: appearance,
                label: iconLabel,
                spacing: spacing
            }), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
                as: "span",
                space: "space.100"
            }, title && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
                weight: "medium",
                testId: testId && `${testId}--title`
            }, title), secondaryText && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
                weight: "medium",
                color: "color.text.subtlest",
                maxLines: 1,
                testId: testId && `${testId}--text`
            }, secondaryText))));
        };
        $[6] = appearance;
        $[7] = iconLabel;
        $[8] = id;
        $[9] = isOpen;
        $[10] = secondaryText;
        $[11] = spacing;
        $[12] = testId;
        $[13] = title;
        $[14] = t12;
    } else t12 = $[14];
    let t13;
    if ($[15] !== fallbackPlacements || $[16] !== id || $[17] !== isOpen || $[18] !== placement || $[19] !== t10 || $[20] !== t11 || $[21] !== t12) {
        t13 = /*#__PURE__*/ $cozmU.createElement((0, $5wHqn.default), {
            onClose: onCloseDialog,
            content: t10,
            isOpen: isOpen,
            placement: placement,
            testId: t11,
            fallbackPlacements: fallbackPlacements,
            shouldRenderToParent: true,
            role: "dialog",
            titleId: id,
            trigger: t12
        });
        $[15] = fallbackPlacements;
        $[16] = id;
        $[17] = isOpen;
        $[18] = placement;
        $[19] = t10;
        $[20] = t11;
        $[21] = t12;
        $[22] = t13;
    } else t13 = $[22];
    let t14;
    if ($[23] !== t13 || $[24] !== t9 || $[25] !== testId) {
        t14 = /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": testId,
            className: t9
        }, t13);
        $[23] = t13;
        $[24] = t9;
        $[25] = testId;
        $[26] = t14;
    } else t14 = $[26];
    return t14;
} : ({ placement: placement = 'bottom-start', secondaryText: secondaryText = '', title: title = '', appearance: appearance = 'connectivity', spacing: spacing = 'spacious', children: children, testId: testId, iconLabel: iconLabel, fallbackPlacements: fallbackPlacements })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const id = (0, $6JrSr.useId)();
    const toggleDialog = (0, $cozmU.useCallback)(()=>{
        setIsOpen((oldState)=>!oldState);
    }, [
        setIsOpen
    ]);
    const onCloseDialog = (0, $cozmU.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $7c29b2adacb89176$var$styles.rootStyles,
            $7c29b2adacb89176$var$iconColor[appearance]
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $5wHqn.default), {
        onClose: onCloseDialog,
        content: ()=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
                xcss: $7c29b2adacb89176$var$styles.contentStyles
            }, children),
        isOpen: isOpen,
        placement: placement,
        testId: testId && `${testId}--popup`,
        fallbackPlacements: fallbackPlacements,
        shouldRenderToParent: true,
        role: "dialog",
        titleId: id,
        trigger: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ $cozmU.createElement((0, $hBYtq.default), {
                ...triggerProps,
                ref: ref,
                id: id,
                "data-ds--inline-message--button": true,
                onClick: toggleDialog,
                testId: testId && `${testId}--button`,
                xcss: $7c29b2adacb89176$var$styles.pressableStyles,
                "aria-expanded": isOpen
            }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
                as: "span",
                space: "space.050",
                alignBlock: "center"
            }, /*#__PURE__*/ $cozmU.createElement((0, $cEipP.default), {
                isOpen: isOpen,
                appearance: appearance,
                label: iconLabel,
                spacing: spacing
            }), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
                as: "span",
                space: "space.100"
            }, title && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
                weight: "medium",
                testId: testId && `${testId}--title`
            }, title), secondaryText && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
                weight: "medium",
                color: "color.text.subtlest",
                maxLines: 1,
                testId: testId && `${testId}--text`
            }, secondaryText))))
    }));
};
var $7c29b2adacb89176$export$2e2bcd8739ae039 = $7c29b2adacb89176$var$InlineMessage;
function $7c29b2adacb89176$var$_temp(oldState) {
    return !oldState;
}
module.exports["default"] = $7c29b2adacb89176$export$2e2bcd8739ae039;

});

parcelRegister("cEipP", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $axHIJ = parcelRequire("axHIJ");

const $fe4d2a60aea58684$var$iconColor = {
    connectivity: "_syaz1ft0",
    confirmation: "_syaz4pcx",
    info: "_syazqm1h",
    warning: "_syazervl",
    error: "_syazs4qr"
};
const $fe4d2a60aea58684$var$iconWrapperStyles = null;
const $fe4d2a60aea58684$var$iconColorStyles = null; /**
                               * __Selected icon__
                               *
                               * The selected icon is used as the primary interactive element for the dialog.
                               * Can be used with or without supporting text.
                               */ 
const $fe4d2a60aea58684$var$SelectedIcon = ({ appearance: appearance, isOpen: isOpen, label: label, spacing: spacing })=>{
    const { [appearance]: { icon: Icon, defaultLabel: defaultLabel } } = (0, $axHIJ.typesMapping);
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-ds--inline-message--icon": true,
        className: (0, $hekY6.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _4cvr1h6o",
            $fe4d2a60aea58684$var$iconColor[appearance],
            isOpen && "_syaz1kum"
        ])
    }, /*#__PURE__*/ $cozmU.createElement(Icon, {
        testId: "inline-message-icon",
        label: label || defaultLabel,
        color: "currentColor",
        spacing: spacing
    }));
};
var $fe4d2a60aea58684$export$2e2bcd8739ae039 = $fe4d2a60aea58684$var$SelectedIcon;
module.exports["default"] = $fe4d2a60aea58684$export$2e2bcd8739ae039;

});

parcelRegister("axHIJ", function(module, exports) {

var $24dy7 = parcelRequire("24dy7");


var $fodiz = parcelRequire("fodiz");


var $chu6R = parcelRequire("chu6R");


var $lMGh1 = parcelRequire("lMGh1");

const $0c91ff1a933c23ee$export$4d111645c0b39d5d = {
    connectivity: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))),
        defaultLabel: 'connectivity inline message'
    },
    confirmation: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($chu6R))),
        defaultLabel: 'confirmation inline message'
    },
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fodiz))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))),
        defaultLabel: 'warning inline message'
    },
    error: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($24dy7))),
        defaultLabel: 'error inline message'
    }
};
module.exports["typesMapping"] = $0c91ff1a933c23ee$export$4d111645c0b39d5d;

});

parcelRegister("cAQ1C", function(module, exports) {

var $8s9DV = parcelRequire("8s9DV");

const $0a91b5498053916e$var$actions = {
    register: (handler)=>({ setState: setState, getState: getState })=>{
            if (getState().handlers.includes(handler)) return;
            setState({
                handlers: [
                    ...getState().handlers,
                    handler
                ]
            });
        },
    unregister: (handler)=>({ setState: setState, getState: getState })=>{
            setState({
                handlers: getState().handlers.filter((h)=>h !== handler)
            });
        },
    openFileDialog: ()=>({ getState: getState })=>{
            // Call the most recently registered handler (last mount wins)
            const { handlers: handlers } = getState();
            const lastHandler = handlers[handlers.length - 1];
            lastHandler?.();
        }
};
const $0a91b5498053916e$export$390f32400eaf98c9 = (0, $8s9DV.createStore)({
    name: 'file-upload-trigger',
    initialState: {
        handlers: []
    },
    actions: $0a91b5498053916e$var$actions
});
module.exports["Store"] = $0a91b5498053916e$export$390f32400eaf98c9;

});

parcelRegister("fgCwN", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6gGPb = parcelRequire("6gGPb");

const $8e8c16ce2f720803$export$c913fcdcf440a92c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { agent: agent } = t0;
    const t1 = agent.external_config_reference ?? agent.named_id;
    const t2 = agent.creator_type === "THIRD_PARTY" || agent.creator_type === "FORGE";
    let t3;
    if ($[0] !== agent.icon || $[1] !== agent.id || $[2] !== agent.identity_account_id || $[3] !== t1 || $[4] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $6gGPb.AgentAvatar), {
            agentNamedId: t1,
            agentId: agent.id,
            agentIdentityAccountId: agent.identity_account_id,
            size: "small",
            showBorder: false,
            isForgeAgent: t2,
            forgeAgentIconUrl: agent.icon
        });
        $[0] = agent.icon;
        $[1] = agent.id;
        $[2] = agent.identity_account_id;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ({ agent: agent })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $6gGPb.AgentAvatar), {
        agentNamedId: agent.external_config_reference ?? agent.named_id,
        agentId: agent.id,
        agentIdentityAccountId: agent.identity_account_id,
        size: "small",
        showBorder: false,
        isForgeAgent: agent.creator_type === 'THIRD_PARTY' || agent.creator_type === 'FORGE',
        forgeAgentIconUrl: agent.icon
    });
};
module.exports["PromptAgentAvatar"] = $8e8c16ce2f720803$export$c913fcdcf440a92c;

});

parcelRegister("jdw9n", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $54033ecc926bdd79$export$b9e056b3d42aef4 = ()=>{
    const [PostOfficePlacement, setPostOfficePlacement] = (0, $cozmU.useState)(null);
    const [isMounted, setIsMounted] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (typeof window !== 'undefined') {
            let isComponentMounted = true;
            // Check for mock in test environments (set by VR test)
            const mockModule = window.__mockPostOfficePlacement__;
            if (mockModule) {
                setPostOfficePlacement(()=>mockModule);
                setIsMounted(true);
                return;
            }
            (parcelRequire("kO7rA")).then((module)=>{
                if (isComponentMounted) {
                    setPostOfficePlacement(()=>module.Placement);
                    setIsMounted(true);
                }
            }).catch(()=>{
                if (isComponentMounted) setIsMounted(true);
            });
            return ()=>{
                isComponentMounted = false;
            };
        }
    }, []);
    return {
        PostOfficePlacement: PostOfficePlacement,
        isMounted: isMounted
    };
};
module.exports["usePostOfficePlacement"] = $54033ecc926bdd79$export$b9e056b3d42aef4;

});

parcelRegister("kO7rA", function(module, exports) {

let $f25e406201449020$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f25e406201449020$var$load("ekVH8"),
    $f25e406201449020$var$load("1aMWV"),
    $f25e406201449020$var$load("hVR94"),
    $f25e406201449020$var$load("4Zbes"),
    $f25e406201449020$var$load("eRhBr"),
    $f25e406201449020$var$load("cWzGN")
]).then(()=>parcelRequire('ikSqk'));

});

parcelRegister("5vvb4", function(module, exports) {
const $930d3653747ebd0c$export$c5d4e064eaa9ff1f = async (blob)=>new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>{
            const result = reader.result;
            const base64 = result.split(',')[1];
            resolve(base64);
        };
        reader.onerror = ()=>reject(new Error('Failed to convert to base64'));
        reader.readAsDataURL(blob);
    });
module.exports["createBase64FromBlob"] = $930d3653747ebd0c$export$c5d4e064eaa9ff1f;

});

parcelRegister("i8aB6", function(module, exports) {
/* eslint-disable perfectionist/sort-object-types */ 
var $cozmU = parcelRequire("cozmU");


var $34VCg = parcelRequire("34VCg");

const $89c606f0d1f4dfb4$export$fade2d05a6320d49 = ({ id: id, component: component, type: type, performanceType: performanceType })=>{
    const ufoExperience = (0, $cozmU.useRef)(new (0, $34VCg.UFOExperience)(id, {
        type: type,
        performanceType: performanceType,
        platform: {
            component: component
        }
    }));
    const start = (0, $cozmU.useCallback)((startTime)=>{
        return ufoExperience.current.start(startTime);
    }, []);
    const success = (0, $cozmU.useCallback)((config)=>{
        return ufoExperience.current.success(config);
    }, []);
    const mark = (0, $cozmU.useCallback)((name, timestamp)=>{
        ufoExperience.current.mark(name, timestamp);
    }, []);
    const addMetadata = (0, $cozmU.useCallback)((data)=>{
        ufoExperience.current.addMetadata(data);
    }, []);
    const markFMP = (0, $cozmU.useCallback)((timestamp)=>{
        ufoExperience.current.markFMP(timestamp);
    }, []);
    const markInlineResponse = (0, $cozmU.useCallback)((timestamp)=>{
        ufoExperience.current.markInlineResponse(timestamp);
    }, []);
    const failure = (0, $cozmU.useCallback)((config)=>{
        return ufoExperience.current.failure(config);
    }, []);
    const abort = (0, $cozmU.useCallback)((config)=>{
        return ufoExperience.current.abort(config);
    }, []);
    return {
        start: start,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        addMetadata: addMetadata,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};
module.exports["useUFOExperience"] = $89c606f0d1f4dfb4$export$fade2d05a6320d49;

});

parcelRegister("bY61u", function(module, exports) {
/**
 * Hook to check whether the Rovo Insights feature is available for the current user.
 *
 * Uses RovoInsightsService (extends AssistanceServiceBase) so that Rovo Insights
 * concerns stay out of the general-purpose AssistanceService.
 */ 
var $cozmU = parcelRequire("cozmU");


var $irnO2 = parcelRequire("irnO2");


var $5SS4O = parcelRequire("5SS4O");


var $lJ6db = parcelRequire("lJ6db");


var $4pKRH = parcelRequire("4pKRH");

const $ccf10fb413687b05$var$FRESHNESS_WINDOW_MS = 172800000;
const $ccf10fb413687b05$var$isGeneratedAtFresh = (generatedAt)=>{
    if (!generatedAt) return false;
    const generatedAtTime = new Date(generatedAt).getTime();
    if (Number.isNaN(generatedAtTime)) return false;
    return Date.now() - generatedAtTime < $ccf10fb413687b05$var$FRESHNESS_WINDOW_MS;
};
const $ccf10fb413687b05$export$d191a72e03ff3705 = (0, $lJ6db.createHookWithAssistanceService)(({ assistanceServiceInjectedParams: { assistanceService: assistanceService, experienceTracker: experienceTracker }, enabled: enabled })=>{
    const insightsService = (0, $cozmU.useMemo)(()=>{
        const config = assistanceService.getConfig();
        return new (0, $4pKRH.RovoInsightsService)(config);
    }, [
        assistanceService
    ]);
    const { data: data, isFetching: isFetching } = (0, $5SS4O.useQuery)({
        queryKey: [
            'insightsStatus'
        ],
        enabled: enabled,
        queryFn: async ()=>{
            experienceTracker.start({
                id: (0, $irnO2.ExperienceName).FETCH_INSIGHTS_STATUS,
                name: (0, $irnO2.ExperienceName).FETCH_INSIGHTS_STATUS
            });
            try {
                const response = await insightsService.getInsightsStatus();
                experienceTracker.succeed({
                    name: (0, $irnO2.ExperienceName).FETCH_INSIGHTS_STATUS
                });
                return response;
            } catch (error) {
                experienceTracker.fail({
                    name: (0, $irnO2.ExperienceName).FETCH_INSIGHTS_STATUS,
                    error: error instanceof Error ? error : new Error(String(error))
                });
                throw error;
            }
        }
    });
    return {
        isInsightsAvailable: Boolean(data?.insights_available),
        isLoading: isFetching && data === null,
        generatedAt: data?.generated_at,
        isFresh: $ccf10fb413687b05$var$isGeneratedAtFresh(data?.generated_at)
    };
});
module.exports["useInsightsStatus"] = $ccf10fb413687b05$export$d191a72e03ff3705;

});

parcelRegister("gQrdE", function(module, exports) {

var $5Tn11 = parcelRequire("5Tn11");


var $cfQBH = parcelRequire("cfQBH");


var $8gcBG = parcelRequire("8gcBG");


var $85mU8 = parcelRequire("85mU8");

const $95be6a3a825c3bf3$export$a6cddc722e179ebe = (props)=>{
    const api = (0, $85mU8.getBrowserBridgeAPI)();
    const senderId = (0, $cfQBH.ROVO_EXPERIENCE_TRACKING_SENDER_CLIENT_ID);
    const receiverId = (0, $5Tn11.ROVO_CHAT_CLIENT_ID);
    let payload;
    switch(props.status){
        case 'fail':
            payload = {
                ...props,
                error: typeof props.error === 'string' ? props.error : 'Unknown error',
                reason: undefined,
                senderId: senderId,
                receiverId: receiverId
            };
            break;
        case 'abort':
            payload = {
                ...props,
                reason: typeof props.reason === 'string' ? props.reason : 'Aborted',
                error: undefined,
                senderId: senderId,
                receiverId: receiverId
            };
            break;
        case 'success':
        default:
            payload = {
                ...props,
                error: undefined,
                reason: undefined,
                senderId: senderId,
                receiverId: receiverId
            };
            break;
    }
    api?.send((0, $8gcBG.AifcExperienceTrackingCommand), payload);
};
module.exports["sendAIFCExperienceTrackingToParent"] = $95be6a3a825c3bf3$export$a6cddc722e179ebe;

});

parcelRegister("d5NOj", function(module, exports) {

var $dSoGR = parcelRequire("dSoGR");

const $ace49514fc9a5583$export$ae5d3e7a3e1f01ca = (0, $dSoGR.createCommand)('editor-insert-content-command');
module.exports["EditorInsertContentCommand"] = $ace49514fc9a5583$export$ae5d3e7a3e1f01ca;

});

parcelRegister("b8Mxh", function(module, exports) {
const $8797ec90d8bb9a30$export$c138e7eae20ea2d5 = async (contentId)=>{
    try {
        const response = await fetch(`/wiki/rest/api/content/${encodeURIComponent(contentId)}?expand=ancestors,status&status=draft,current`, {
            credentials: 'include'
        });
        if (!response.ok) return undefined;
        const payload = await response.json();
        if (payload?.status !== 'draft') return undefined;
        const ancestors = payload.ancestors;
        if (!ancestors || ancestors.length === 0) return undefined;
        const directParentId = ancestors[ancestors.length - 1]?.id;
        return typeof directParentId === 'string' ? directParentId : undefined;
    } catch  {
        return undefined;
    }
};
module.exports["resolveConfluenceDraftSiblingParent"] = $8797ec90d8bb9a30$export$c138e7eae20ea2d5;

});

parcelRegister("g3v8V", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $220c40ed22c541bf$var$message = (0, $kSwu1.defineMessages)({
    placeholder: {
        id: "conversation-assistant.edit-with-rovo-bar.placeholder",
        defaultMessage: "Ask Rovo anything..."
    },
    submitLabel: {
        id: "conversation-assistant.edit-with-rovo-bar.submit-label",
        defaultMessage: "Submit"
    },
    subtypeAdjustedFlagTitle: {
        id: "conversation-assistant.edit-with-rovo-bar.subtype-adjusted-flag-title",
        defaultMessage: "Output adjusted"
    },
    subtypeAdjustedFlagDescription: {
        id: "conversation-assistant.edit-with-rovo-bar.subtype-adjusted-flag-description",
        defaultMessage: "Your selection wasn't compatible with that output, so Rovo picked a new one."
    },
    remixVariantsLabel: {
        id: "conversation-assistant.edit-with-rovo-bar.remix-variants-label",
        defaultMessage: "Remix variants"
    },
    remixVariantsAriaLabel: {
        id: "conversation-assistant.edit-with-rovo-bar.remix-variants-aria-label",
        defaultMessage: "{remixVariantLabel} \u2014 {selectorLabel}"
    },
    analyzing: {
        id: "conversation-assistant.edit-with-rovo-bar.analyzing",
        defaultMessage: "Rovo is analyzing"
    },
    stopLabel: {
        id: "conversation-assistant.edit-with-rovo-bar.stop-label",
        defaultMessage: "Stop remixing"
    },
    remixVariantLineChart: {
        id: "conversation-assistant.edit-with-rovo-bar.chart.line-chart",
        defaultMessage: "Line graph"
    },
    chatUpdateLineChart: {
        id: "conversation-assistant.edit-with-rovo-bar.chat-update.line-chart",
        defaultMessage: "Update to a line graph"
    },
    remixVariantAreaChart: {
        id: "conversation-assistant.edit-with-rovo-bar.chart.area-chart",
        defaultMessage: "Area chart"
    },
    chatUpdateAreaChart: {
        id: "conversation-assistant.edit-with-rovo-bar.chat-update.area-chart",
        defaultMessage: "Update to an area chart"
    },
    remixVariantBarChart: {
        id: "conversation-assistant.edit-with-rovo-bar.chart.bar-chart",
        defaultMessage: "Bar chart"
    },
    chatUpdateBarChart: {
        id: "conversation-assistant.edit-with-rovo-bar.chat-update.bar-chart",
        defaultMessage: "Update to a bar chart"
    },
    remixVariantFunnelChart: {
        id: "conversation-assistant.edit-with-rovo-bar.chart.funnel-chart",
        defaultMessage: "Funnel chart"
    },
    chatUpdateFunnelChart: {
        id: "conversation-assistant.edit-with-rovo-bar.chat-update.funnel-chart",
        defaultMessage: "Update to a funnel chart"
    },
    remixVariantPieChart: {
        id: "conversation-assistant.edit-with-rovo-bar.chart.pie-chart",
        defaultMessage: "Pie chart"
    },
    chatUpdatePieChart: {
        id: "conversation-assistant.edit-with-rovo-bar.chat-update.pie-chart",
        defaultMessage: "Update to a pie chart"
    },
    remixVariantGanttChart: {
        id: "conversation-assistant.edit-with-rovo-bar.chart.gantt-chart",
        defaultMessage: "Gantt chart"
    },
    chatUpdateGanttChart: {
        id: "conversation-assistant.edit-with-rovo-bar.chat-update.gantt-chart",
        defaultMessage: "Update to a Gantt chart"
    },
    remixVariantMindMap: {
        id: "conversation-assistant.edit-with-rovo-bar.diagram.mind-map",
        defaultMessage: "Mindmap"
    },
    chatUpdateMindMap: {
        id: "conversation-assistant.edit-with-rovo-bar.chat-update.mind-map",
        defaultMessage: "Update to a mindmap"
    },
    remixVariantFlowChart: {
        id: "conversation-assistant.edit-with-rovo-bar.diagram.flow-chart",
        defaultMessage: "Flowchart"
    },
    chatUpdateFlowChart: {
        id: "conversation-assistant.edit-with-rovo-bar.chat-update.flow-chart",
        defaultMessage: "Update to a flowchart"
    },
    remixVariantModernStyle: {
        id: "conversation-assistant.edit-with-rovo-bar.infographic.modern-style",
        defaultMessage: "Modern style"
    },
    chatUpdateModernStyle: {
        id: "conversation-assistant.edit-with-rovo-bar.chat-update.modern-style",
        defaultMessage: "Update to a modern style"
    },
    remixVariantBoldStyle: {
        id: "conversation-assistant.edit-with-rovo-bar.infographic.bold-style",
        defaultMessage: "Bold style"
    },
    chatUpdateBoldStyle: {
        id: "conversation-assistant.edit-with-rovo-bar.chat-update.bold-style",
        defaultMessage: "Update to a bold style"
    },
    remixVariantMinimalistStyle: {
        id: "conversation-assistant.edit-with-rovo-bar.infographic.minimalist-style",
        defaultMessage: "Minimalist style"
    },
    chatUpdateMinimalistStyle: {
        id: "conversation-assistant.edit-with-rovo-bar.chat-update.minimalist-style",
        defaultMessage: "Update to a minimalist style"
    },
    remixVariantSketchStyle: {
        id: "conversation-assistant.edit-with-rovo-bar.infographic.sketch-style",
        defaultMessage: "Sketch style"
    },
    chatUpdateSketchStyle: {
        id: "conversation-assistant.edit-with-rovo-bar.chat-update.sketch-style",
        defaultMessage: "Update to a sketch style"
    },
    remixVariantFlipCard: {
        id: "conversation-assistant.edit-with-rovo-bar.visual-aid.flip-card",
        defaultMessage: "Flip card"
    },
    chatUpdateFlipCard: {
        id: "conversation-assistant.edit-with-rovo-bar.chat-update.flip-card",
        defaultMessage: "Update to a flip card"
    },
    remixVariantQuadrant: {
        id: "conversation-assistant.edit-with-rovo-bar.visual-aid.quadrant",
        defaultMessage: "Quadrant"
    },
    chatUpdateQuadrant: {
        id: "conversation-assistant.edit-with-rovo-bar.chat-update.quadrant",
        defaultMessage: "Update to a quadrant"
    },
    remixVariantTreeMap: {
        id: "conversation-assistant.edit-with-rovo-bar.visual-aid.tree-map",
        defaultMessage: "Tree map"
    },
    chatUpdateTreeMap: {
        id: "conversation-assistant.edit-with-rovo-bar.chat-update.tree-map",
        defaultMessage: "Update to a tree map"
    },
    remixVariantTimeline: {
        id: "conversation-assistant.edit-with-rovo-bar.visual-aid.timeline",
        defaultMessage: "Timeline"
    },
    chatUpdateTimeline: {
        id: "conversation-assistant.edit-with-rovo-bar.chat-update.timeline",
        defaultMessage: "Update to a timeline"
    },
    remixVariantGeographicalMap: {
        id: "conversation-assistant.edit-with-rovo-bar.visual-aid.geographical-map",
        defaultMessage: "Geographical map"
    },
    chatUpdateGeographicalMap: {
        id: "conversation-assistant.edit-with-rovo-bar.chat-update.geographical-map",
        defaultMessage: "Update to a geographical map"
    },
    remixVariantOrgChart: {
        id: "conversation-assistant.edit-with-rovo-bar.visual-aid.org-chart",
        defaultMessage: "Org chart"
    },
    chatUpdateOrgChart: {
        id: "conversation-assistant.edit-with-rovo-bar.chat-update.org-chart",
        defaultMessage: "Update to an org chart"
    },
    remixVariantImage: {
        id: "conversation-assistant.edit-with-rovo-bar.visual-aid.image",
        defaultMessage: "Image"
    },
    chatUpdateImage: {
        id: "conversation-assistant.edit-with-rovo-bar.chat-update.image",
        defaultMessage: "Update to an image"
    },
    chartType: {
        id: "conversation-assistant.edit-with-rovo-bar.type.charts",
        defaultMessage: "Charts"
    },
    diagramType: {
        id: "conversation-assistant.edit-with-rovo-bar.type.diagrams",
        defaultMessage: "Diagrams"
    },
    infographicType: {
        id: "conversation-assistant.edit-with-rovo-bar.type.infographics",
        defaultMessage: "Infographics"
    },
    visualAidType: {
        id: "conversation-assistant.edit-with-rovo-bar.type.visual-aids",
        defaultMessage: "Visualizations"
    },
    changeChartTitle: {
        id: "conversation-assistant.edit-with-rovo-bar.change-type-title.chart",
        defaultMessage: "Change chart"
    },
    changeDiagramTitle: {
        id: "conversation-assistant.edit-with-rovo-bar.change-type-title.diagram",
        defaultMessage: "Change diagram"
    },
    changeInfographicTitle: {
        id: "conversation-assistant.edit-with-rovo-bar.change-type-title.infographic",
        defaultMessage: "Change infographic"
    },
    changeVisualAidTitle: {
        id: "conversation-assistant.edit-with-rovo-bar.change-type-title.visual-aid",
        defaultMessage: "Change visualization"
    }
});
var $220c40ed22c541bf$export$2e2bcd8739ae039 = $220c40ed22c541bf$var$message;
module.exports["default"] = $220c40ed22c541bf$export$2e2bcd8739ae039;

});

parcelRegister("zCcSI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $kwzZh = parcelRequire("kwzZh");


var $6mKj3 = parcelRequire("6mKj3");


var $32x2E = parcelRequire("32x2E");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $8aF6s = parcelRequire("8aF6s");


var $c96tF = parcelRequire("c96tF");


var $9cZ1w = parcelRequire("9cZ1w");

const $e34c3f63766da5b3$var$CLOSE_MODAL_DELAY = 500;
const $e34c3f63766da5b3$export$a9c99c9d804e8c41 = ({ assistanceServiceConfigHeaders: assistanceServiceConfigHeaders = {}, preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose = false, preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose = false })=>{
    const { cloudId: cloudId, orgId: orgId, userId: userId } = (0, $bQm3c.useSessionData)();
    const emojiProvider = (0, $cozmU.useMemo)(()=>{
        return (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
            cloudId: cloudId,
            userId: userId
        });
    }, [
        userId,
        cloudId
    ]);
    const assistanceServiceConfig = {
        headers: assistanceServiceConfigHeaders,
        baseUrl: '/gateway/api/assist'
    };
    // Keep the config object identity stable when its semantic inputs are stable.
    const memoizedAssistanceServiceConfig = (0, $cozmU.useMemo)(()=>({
            headers: assistanceServiceConfigHeaders,
            baseUrl: '/gateway/api/assist'
        }), [
        assistanceServiceConfigHeaders
    ]);
    const selectedAssistanceServiceConfig = (0, $6mKj3.expValEquals)('rovo_ttai_segment_render_stabilization', 'isEnabled', true) ? memoizedAssistanceServiceConfig : assistanceServiceConfig;
    const memoizedConfig = (0, $cozmU.useMemo)(()=>({
            displaySubmitFlag: true,
            siteId: cloudId,
            product: 'confluence',
            orgId: orgId,
            assistanceServiceConfig: selectedAssistanceServiceConfig,
            emojiProvider: emojiProvider,
            userId: userId ?? undefined,
            preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose,
            preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose
        }), [
        cloudId,
        emojiProvider,
        orgId,
        preventAbortRequestsOnStagingModalClose,
        preventAbortRequestsOnStandaloneChatClose,
        selectedAssistanceServiceConfig,
        userId
    ]);
    return (0, $6mKj3.expValEquals)('rovo_ttai_segment_render_stabilization', 'isEnabled', true) ? memoizedConfig : {
        displaySubmitFlag: true,
        siteId: cloudId,
        product: 'confluence',
        orgId: orgId,
        assistanceServiceConfig: selectedAssistanceServiceConfig,
        emojiProvider: emojiProvider,
        userId: userId ?? undefined,
        preventAbortRequestsOnStagingModalClose: preventAbortRequestsOnStagingModalClose,
        preventAbortRequestsOnStandaloneChatClose: preventAbortRequestsOnStandaloneChatClose
    };
};
const $e34c3f63766da5b3$export$577864d1e6735f1b = ({ flags: flags, customGreeting: customGreeting, shouldShowGreeting: shouldShowGreeting, shouldHideFeedback: shouldHideFeedback })=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const intl = (0, $kSwu1.useIntl)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const navigateToObject = (0, $cozmU.useCallback)(async ({ baseUrl: baseUrlNav, path: path })=>{
        (0, $c96tF.createNavigateToObject)(push)({
            baseUrl: baseUrlNav,
            path: path
        });
        // artifical delay before closing the modal gives the app a moment to transition to the created object while the modal is still open, this creates a smoother transition from modal to new object.
        // For non-SPA transitions, a full page reload will happen so this delay will be ignored
        await new Promise((r)=>setTimeout(r, $e34c3f63766da5b3$var$CLOSE_MODAL_DELAY));
    }, [
        push
    ]);
    const showCreateWithRovoModalCloseFeedbackFlag = (0, $9cZ1w.useLazyShowFeedbackFlag)(flags, intl, showModal, createAnalyticsEvent);
    const handleCloseSmartCreate = (0, $cozmU.useCallback)(({ feedbackVariant: feedbackVariant, currentConversationId: currentConversationId, requestId: requestId, remixMetadata: remixMetadata, contentType: contentType, contentMode: contentMode })=>{
        if (shouldHideFeedback) return;
        if (feedbackVariant === undefined) return;
        showCreateWithRovoModalCloseFeedbackFlag({
            feedbackVariant: feedbackVariant,
            contentType: contentType,
            contentMode: contentMode,
            cloudId: cloudId,
            currentConversationId: currentConversationId ?? undefined,
            requestId: requestId,
            remixMetadata: remixMetadata
        });
    }, [
        showCreateWithRovoModalCloseFeedbackFlag,
        shouldHideFeedback,
        cloudId
    ]);
    // Keep uiConfig identity stable when handler/greeting inputs are stable.
    const memoizedUiConfig = (0, $cozmU.useMemo)(()=>({
            customHandlers: {
                handleSubmitSmartCreate: navigateToObject,
                handleCloseSmartCreate: handleCloseSmartCreate
            },
            elements: {
                voiceDictationButton: true,
                shouldShowGreeting: shouldShowGreeting ?? undefined
            },
            customGreeting: customGreeting ?? undefined
        }), [
        customGreeting,
        handleCloseSmartCreate,
        navigateToObject,
        shouldShowGreeting
    ]);
    return (0, $6mKj3.expValEquals)('rovo_ttai_segment_render_stabilization', 'isEnabled', true) ? memoizedUiConfig : {
        customHandlers: {
            handleSubmitSmartCreate: navigateToObject,
            handleCloseSmartCreate: handleCloseSmartCreate
        },
        elements: {
            voiceDictationButton: true,
            shouldShowGreeting: shouldShowGreeting ?? undefined
        },
        customGreeting: customGreeting ?? undefined
    };
};
module.exports["useConversationAssistantConfig"] = $e34c3f63766da5b3$export$a9c99c9d804e8c41;
module.exports["useConversationAssistantUiConfig"] = $e34c3f63766da5b3$export$577864d1e6735f1b;

});

parcelRegister("c96tF", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $8f856ee350559225$export$b2e60ce4b3907e57 = (baseUrl)=>{
    const host = window.location.host;
    return baseUrl.includes(host) && baseUrl.includes((0, $jlIaF.CONTEXT_PATH));
};
// database need flow query param for special case handling
const $8f856ee350559225$var$addFlowParam = (baseUrl, path)=>{
    const url = new URL(path, baseUrl);
    url.searchParams.set('flow', 'aiCreate');
    return url.pathname + url.search;
};
const $8f856ee350559225$export$38454a8d1321e65a = (push)=>({ baseUrl: baseUrl, path: path })=>{
        const isDatabase = Boolean((0, $1NBp8.DATABASE_VIEW).match(`${baseUrl}${path}`));
        let finalPath = path;
        if (isDatabase) finalPath = $8f856ee350559225$var$addFlowParam(baseUrl, path);
        if ($8f856ee350559225$export$b2e60ce4b3907e57(baseUrl)) push((0, $jlIaF.CONTEXT_PATH) + finalPath);
        else window.location.href = `${baseUrl}${finalPath}`;
    };
module.exports["createNavigateToObject"] = $8f856ee350559225$export$38454a8d1321e65a;

});

parcelRegister("9cZ1w", function(module, exports) {

var $epLE5 = parcelRequire("epLE5");


const $486bada329940e5a$export$f6e059b56d9aeb26 = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("aZZJH"))).showCreateWithRovoModalCloseFeedbackFlagThunk);
module.exports["useLazyShowFeedbackFlag"] = $486bada329940e5a$export$f6e059b56d9aeb26;

});

parcelRegister("epLE5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $dfceb6b0f6d6cccb$export$729b27bc0f344ffe = (loader)=>{
    return (...deps)=>(0, $cozmU.useCallback)((...args)=>{
            return loader().then((thunk)=>thunk(...deps)(...args));
        }, // Linter doesn't like spread syntax
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            ...deps
        ]);
};
module.exports["createLazyCallbackHook"] = $dfceb6b0f6d6cccb$export$729b27bc0f344ffe;

});

parcelRegister("aZZJH", function(module, exports) {

let $801f7d65ac598942$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $801f7d65ac598942$var$load("ekVH8"),
    $801f7d65ac598942$var$load("dQT3c"),
    $801f7d65ac598942$var$load("kHXvF"),
    $801f7d65ac598942$var$load("7gL7H"),
    $801f7d65ac598942$var$load("hhss7"),
    $801f7d65ac598942$var$load("k7MRD")
]).then(()=>parcelRequire('hlCkz'));

});

parcelRegister("cJeDc", function(module, exports) {
var $c39b3ef3793f3f0e$export$3f98ccc336fde004 = /*#__PURE__*/ function(FeedbackVariant) {
    FeedbackVariant["AFTER_AIFC_MODAL_CLOSE"] = "after-aifc-modal-close";
    FeedbackVariant["AFTER_UPDATE_STREAM_COMPLETE"] = "after-update-stream-complete";
    FeedbackVariant["AFTER_REMIX_MODAL_CLOSE"] = "after-remix-modal-close";
    FeedbackVariant["AFTER_REMIX_INSERT"] = "after-remix-insert";
    return FeedbackVariant;
}({});
module.exports["FeedbackVariant"] = $c39b3ef3793f3f0e$export$3f98ccc336fde004;

});

parcelRegister("28WJb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $3Ap09 = parcelRequire("3Ap09");

const $065389573511adac$export$5351114e92b31bc6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (context?.state.panel == null) return null;
    let t0;
    if ($[0] !== context.setPanelWidth || $[1] !== context.state.panel || $[2] !== context.width) {
        t0 = {
            ...context.state.panel,
            width: context.width,
            setWidth: context.setPanelWidth
        };
        $[0] = context.setPanelWidth;
        $[1] = context.state.panel;
        $[2] = context.width;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : ()=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (context?.state.panel == null) return null;
    return {
        ...context.state.panel,
        width: context.width,
        setWidth: context.setPanelWidth
    };
};
module.exports["useCurrentPreviewPanel"] = $065389573511adac$export$5351114e92b31bc6;

});

parcelRegister("8OpiN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::edc088c8e1dff28f4540e843bee097cd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66a69eb8c574d02b$var$_react = $66a69eb8c574d02b$var$_interopRequireDefault((parcelRequire("cozmU")));

var $66a69eb8c574d02b$var$_baseNew = $66a69eb8c574d02b$var$_interopRequireDefault((parcelRequire("gElAV")));
function $66a69eb8c574d02b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsObject".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing objects in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66a69eb8c574d02b$var$AssetsObjectIcon = (props)=>/*#__PURE__*/ $66a69eb8c574d02b$var$_react.default.createElement($66a69eb8c574d02b$var$_baseNew.default, Object.assign({
        name: "AssetsObjectIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5h-2.5v3.75a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75V2.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM7 5.5h2v-3H7zm8 7.5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$66a69eb8c574d02b$var$AssetsObjectIcon.displayName = 'AssetsObjectIcon';
var $66a69eb8c574d02b$var$_default = module.exports.default = $66a69eb8c574d02b$var$AssetsObjectIcon;

});

parcelRegister("fvoKJ", function(module, exports) {

var $8Yift = parcelRequire("8Yift");

const $e160175aa6804997$export$792aeacb7990bc6 = (containerId)=>{
    // we wrap in a try/catch incase there are any issues with creating the site ari
    try {
        return (0, $8Yift.TownsquareSiteAri).create({
            siteId: containerId
        }).toString();
    } catch  {
        return '';
    }
};
module.exports["getSiteAri"] = $e160175aa6804997$export$792aeacb7990bc6;

});

parcelRegister("8Yift", function(module, exports) {

var $4Yksf = parcelRequire("4Yksf");


var $1gKSA = parcelRequire("1gKSA");


var $59jY5 = parcelRequire("59jY5");

// src/townsquare/site/manifest.ts
var $6882151697c9008c$var$townsquareSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $4Yksf.TownsquareSiteAriResourceOwner),
    resourceType: (0, $4Yksf.TownsquareSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/townsquare/site/index.ts
var $6882151697c9008c$export$87ae3de5f1f7725a = class _TownsquareSiteAri extends (0, $1gKSA.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $6882151697c9008c$var$townsquareSiteAriStaticOpts.qualifier,
            platformQualifier: $6882151697c9008c$var$townsquareSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $6882151697c9008c$var$townsquareSiteAriStaticOpts.resourceOwner,
            resourceType: $6882151697c9008c$var$townsquareSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $59jY5.AriParser).fromOpts(derivedOpts, $6882151697c9008c$var$townsquareSiteAriStaticOpts);
        return new _TownsquareSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $59jY5.AriParser).fromString(maybeAri, $6882151697c9008c$var$townsquareSiteAriStaticOpts);
        return new _TownsquareSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["TownsquareSiteAri"] = $6882151697c9008c$export$87ae3de5f1f7725a;

});

parcelRegister("4Yksf", function(module, exports) {
// src/townsquare/site/types.ts
var $39eca1dd131685dd$export$9ee8c46ef1f3e6a8 = "townsquare", $39eca1dd131685dd$export$44737bde24f3bac1 = "site";
module.exports["TownsquareSiteAriResourceOwner"] = $39eca1dd131685dd$export$9ee8c46ef1f3e6a8;
module.exports["TownsquareSiteAriResourceType"] = $39eca1dd131685dd$export$44737bde24f3bac1;

});

parcelRegister("i1agE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d51e4a53b773461fcacb3f2ef49e80e0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d1e048e4b12a2678$var$_react = $d1e048e4b12a2678$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d1e048e4b12a2678$var$_baseNew = $d1e048e4b12a2678$var$_interopRequireDefault((parcelRequire("gElAV")));
function $d1e048e4b12a2678$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WarningOutline".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Low-impact warnings. Overdue dates in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d1e048e4b12a2678$var$WarningOutlineIcon = (props)=>/*#__PURE__*/ $d1e048e4b12a2678$var$_react.default.createElement($d1e048e4b12a2678$var$_baseNew.default, Object.assign({
        name: "WarningOutlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.7 1.383c.996-1.816 3.605-1.817 4.602-.002l5.35 9.73C16.612 12.86 15.346 15 13.35 15H2.667C.67 15-.594 12.862.365 11.113zm3.288.72a1.125 1.125 0 0 0-1.972.002L1.68 11.834c-.41.75.132 1.666.987 1.666H13.35c.855 0 1.398-.917.986-1.667z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.25 9V4h1.5v5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$d1e048e4b12a2678$var$WarningOutlineIcon.displayName = 'WarningOutlineIcon';
var $d1e048e4b12a2678$var$_default = module.exports.default = $d1e048e4b12a2678$var$WarningOutlineIcon;

});

parcelRegister("hSoEi", function(module, exports) {
$parcel$export(module.exports, "default", () => $d03a99980e3dbd9b$export$2e2bcd8739ae039);

var $68pA8 = parcelRequire("68pA8");


var $aTPTV = parcelRequire("aTPTV");


var $8SGej = parcelRequire("8SGej");


var $5Q0Vq = parcelRequire("5Q0Vq");


var $dkBOe = parcelRequire("dkBOe");


var $jrCh2 = parcelRequire("jrCh2");


var $761RI = parcelRequire("761RI");


var $j90Gh = parcelRequire("j90Gh");


var $itDH4 = parcelRequire("itDH4");


var $kr6hK = parcelRequire("kr6hK");


var $3yGK6 = parcelRequire("3yGK6");


var $5KqMf = parcelRequire("5KqMf");


var $erRVM = parcelRequire("erRVM");


var $4m74k = parcelRequire("4m74k");

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $d03a99980e3dbd9b$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $d03a99980e3dbd9b$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $d03a99980e3dbd9b$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $d03a99980e3dbd9b$var$doubleQuoteRegExp = /''/g;
var $d03a99980e3dbd9b$var$notWhitespaceRegExp = /\S/;
var $d03a99980e3dbd9b$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $d03a99980e3dbd9b$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $3yGK6.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $4m74k.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $8SGej.default);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, $kr6hK.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $kr6hK.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $dkBOe.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $5KqMf.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match($d03a99980e3dbd9b$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $761RI.default)) {
            var longFormatter = (0, $761RI.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($d03a99980e3dbd9b$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $aTPTV.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $itDH4.isProtectedWeekYearToken)(token)) (0, $itDH4.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $itDH4.isProtectedDayOfYearToken)(token)) (0, $itDH4.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $erRVM.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($d03a99980e3dbd9b$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $d03a99980e3dbd9b$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $68pA8.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $d03a99980e3dbd9b$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $dkBOe.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $5Q0Vq.default)(date, (0, $j90Gh.default)(date));
    var flags = {};
    var _iterator2 = (0, $aTPTV.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $jrCh2.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $d03a99980e3dbd9b$var$cleanEscapedString(input) {
    return input.match($d03a99980e3dbd9b$var$escapedStringRegExp)[1].replace($d03a99980e3dbd9b$var$doubleQuoteRegExp, "'");
}

});

parcelRegister("aTPTV", function(module, exports) {

var $ivJm4 = parcelRequire("ivJm4");

function $7ef74ce90da10ddf$export$2e2bcd8739ae039(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, $ivJm4.default)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
module.exports["default"] = $7ef74ce90da10ddf$export$2e2bcd8739ae039;

});

parcelRegister("5KqMf", function(module, exports) {

var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $ccS36 = parcelRequire("ccS36");

var $42f6050afbbf6d25$var$TIMEZONE_UNIT_PRIORITY = 10;
var $42f6050afbbf6d25$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $g6rNx.default)(this, Setter);
        (0, $ccS36.default)(this, "priority", void 0);
        (0, $ccS36.default)(this, "subPriority", 0);
    }
    (0, $61VNy.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $42f6050afbbf6d25$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $8Npt5.default)(ValueSetter, _Setter);
    var _super = (0, $kUYG8.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $g6rNx.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $61VNy.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($42f6050afbbf6d25$export$81d53e3678089a6);
var $42f6050afbbf6d25$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $8Npt5.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $kUYG8.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $g6rNx.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this2), "priority", $42f6050afbbf6d25$var$TIMEZONE_UNIT_PRIORITY);
        (0, $ccS36.default)((0, $fPHWO.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $61VNy.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($42f6050afbbf6d25$export$81d53e3678089a6);
module.exports["ValueSetter"] = $42f6050afbbf6d25$export$9a09e32dd4990fd5;
module.exports["DateToSystemTimezoneSetter"] = $42f6050afbbf6d25$export$5aaf7ff7f09ea4ee;

});

parcelRegister("kUYG8", function(module, exports) {

var $3LZzv = parcelRequire("3LZzv");


var $1nPNx = parcelRequire("1nPNx");


var $3luEO = parcelRequire("3luEO");

function $f3a81b1c3407c48d$export$2e2bcd8739ae039(t) {
    var r = (0, $1nPNx.default)();
    return function() {
        var e, o = (0, $3LZzv.default)(t);
        if (r) {
            var s = (0, $3LZzv.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $3luEO.default)(this, e);
    };
}
module.exports["default"] = $f3a81b1c3407c48d$export$2e2bcd8739ae039;

});

parcelRegister("1nPNx", function(module, exports) {
$parcel$export(module.exports, "default", () => $10201e6b86fc7175$export$2e2bcd8739ae039);
function $10201e6b86fc7175$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($10201e6b86fc7175$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("erRVM", function(module, exports) {

var $eC4Z9 = parcelRequire("eC4Z9");


var $712Vg = parcelRequire("712Vg");


var $dxXTH = parcelRequire("dxXTH");


var $88ORV = parcelRequire("88ORV");


var $gZ5xM = parcelRequire("gZ5xM");


var $jHpOc = parcelRequire("jHpOc");


var $hKLEL = parcelRequire("hKLEL");


var $2osza = parcelRequire("2osza");


var $eoc6L = parcelRequire("eoc6L");


var $9P2ZO = parcelRequire("9P2ZO");


var $6zqt8 = parcelRequire("6zqt8");


var $gaEPf = parcelRequire("gaEPf");


var $2zfZV = parcelRequire("2zfZV");


var $iSCOI = parcelRequire("iSCOI");


var $6ku3j = parcelRequire("6ku3j");


var $gxgDD = parcelRequire("gxgDD");


var $jE6Oy = parcelRequire("jE6Oy");


var $j28KI = parcelRequire("j28KI");


var $djpXE = parcelRequire("djpXE");


var $7Nf6S = parcelRequire("7Nf6S");


var $9UQOD = parcelRequire("9UQOD");


var $ael3l = parcelRequire("ael3l");


var $6M1cG = parcelRequire("6M1cG");


var $cAMvE = parcelRequire("cAMvE");


var $4mDmT = parcelRequire("4mDmT");


var $bLXDl = parcelRequire("bLXDl");


var $1kRDS = parcelRequire("1kRDS");


var $iRtG4 = parcelRequire("iRtG4");


var $62f5E = parcelRequire("62f5E");


var $bQs8D = parcelRequire("bQs8D");


var $26OJt = parcelRequire("26OJt");

var $a84d6be113196c14$export$19131010e7fd8373 = {
    G: new (0, $eC4Z9.EraParser)(),
    y: new (0, $712Vg.YearParser)(),
    Y: new (0, $dxXTH.LocalWeekYearParser)(),
    R: new (0, $88ORV.ISOWeekYearParser)(),
    u: new (0, $gZ5xM.ExtendedYearParser)(),
    Q: new (0, $jHpOc.QuarterParser)(),
    q: new (0, $hKLEL.StandAloneQuarterParser)(),
    M: new (0, $2osza.MonthParser)(),
    L: new (0, $eoc6L.StandAloneMonthParser)(),
    w: new (0, $9P2ZO.LocalWeekParser)(),
    I: new (0, $6zqt8.ISOWeekParser)(),
    d: new (0, $gaEPf.DateParser)(),
    D: new (0, $2zfZV.DayOfYearParser)(),
    E: new (0, $iSCOI.DayParser)(),
    e: new (0, $6ku3j.LocalDayParser)(),
    c: new (0, $gxgDD.StandAloneLocalDayParser)(),
    i: new (0, $jE6Oy.ISODayParser)(),
    a: new (0, $j28KI.AMPMParser)(),
    b: new (0, $djpXE.AMPMMidnightParser)(),
    B: new (0, $7Nf6S.DayPeriodParser)(),
    h: new (0, $9UQOD.Hour1to12Parser)(),
    H: new (0, $ael3l.Hour0to23Parser)(),
    K: new (0, $6M1cG.Hour0To11Parser)(),
    k: new (0, $cAMvE.Hour1To24Parser)(),
    m: new (0, $4mDmT.MinuteParser)(),
    s: new (0, $bLXDl.SecondParser)(),
    S: new (0, $1kRDS.FractionOfSecondParser)(),
    X: new (0, $iRtG4.ISOTimezoneWithZParser)(),
    x: new (0, $62f5E.ISOTimezoneParser)(),
    t: new (0, $bQs8D.TimestampSecondsParser)(),
    T: new (0, $26OJt.TimestampMillisecondsParser)()
};
module.exports["parsers"] = $a84d6be113196c14$export$19131010e7fd8373;

});

parcelRegister("eC4Z9", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");

var $aa387b4ba4d3e124$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(EraParser, _Parser);
    var _super = (0, $kUYG8.default)(EraParser);
    function EraParser() {
        var _this;
        (0, $g6rNx.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 140);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $27tFE.Parser));
module.exports["EraParser"] = $aa387b4ba4d3e124$export$8e5a1d3f85a9688;

});

parcelRegister("27tFE", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $ccS36 = parcelRequire("ccS36");


var $5KqMf = parcelRequire("5KqMf");

var $18b340333eececf0$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $g6rNx.default)(this, Parser);
        (0, $ccS36.default)(this, "incompatibleTokens", void 0);
        (0, $ccS36.default)(this, "priority", void 0);
        (0, $ccS36.default)(this, "subPriority", void 0);
    }
    (0, $61VNy.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $5KqMf.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();
module.exports["Parser"] = $18b340333eececf0$export$7acfa6ed01010e37;

});

parcelRegister("712Vg", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");

var $51bae4cb1fda6d08$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(YearParser, _Parser);
    var _super = (0, $kUYG8.default)(YearParser);
    function YearParser() {
        var _this;
        (0, $g6rNx.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 130);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, $5GO7m.mapValue)((0, $5GO7m.parseNDigits)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, $5GO7m.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $5GO7m.mapValue)((0, $5GO7m.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $5GO7m.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $27tFE.Parser));
module.exports["YearParser"] = $51bae4cb1fda6d08$export$48d352de7cd4a988;

});

parcelRegister("5GO7m", function(module, exports) {

var $jO73f = parcelRequire("jO73f");


var $f50NU = parcelRequire("f50NU");

function $4247c0569b65af7c$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $4247c0569b65af7c$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $4247c0569b65af7c$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $jO73f.millisecondsInHour) + minutes * (0, $jO73f.millisecondsInMinute) + seconds * (0, $jO73f.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $4247c0569b65af7c$export$d931c43c4608a164(dateString) {
    return $4247c0569b65af7c$export$cc7cc9e2a3ff9388((0, $f50NU.numericPatterns).anyDigitsSigned, dateString);
}
function $4247c0569b65af7c$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $4247c0569b65af7c$export$cc7cc9e2a3ff9388((0, $f50NU.numericPatterns).singleDigit, dateString);
        case 2:
            return $4247c0569b65af7c$export$cc7cc9e2a3ff9388((0, $f50NU.numericPatterns).twoDigits, dateString);
        case 3:
            return $4247c0569b65af7c$export$cc7cc9e2a3ff9388((0, $f50NU.numericPatterns).threeDigits, dateString);
        case 4:
            return $4247c0569b65af7c$export$cc7cc9e2a3ff9388((0, $f50NU.numericPatterns).fourDigits, dateString);
        default:
            return $4247c0569b65af7c$export$cc7cc9e2a3ff9388(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function $4247c0569b65af7c$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $4247c0569b65af7c$export$cc7cc9e2a3ff9388((0, $f50NU.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return $4247c0569b65af7c$export$cc7cc9e2a3ff9388((0, $f50NU.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return $4247c0569b65af7c$export$cc7cc9e2a3ff9388((0, $f50NU.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return $4247c0569b65af7c$export$cc7cc9e2a3ff9388((0, $f50NU.numericPatterns).fourDigitsSigned, dateString);
        default:
            return $4247c0569b65af7c$export$cc7cc9e2a3ff9388(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function $4247c0569b65af7c$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $4247c0569b65af7c$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $4247c0569b65af7c$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
module.exports["mapValue"] = $4247c0569b65af7c$export$4f84e3a82c7b538;
module.exports["parseNumericPattern"] = $4247c0569b65af7c$export$cc7cc9e2a3ff9388;
module.exports["parseTimezonePattern"] = $4247c0569b65af7c$export$6497f4c0ecdfba8e;
module.exports["parseAnyDigitsSigned"] = $4247c0569b65af7c$export$d931c43c4608a164;
module.exports["parseNDigits"] = $4247c0569b65af7c$export$513bb01536146ab6;
module.exports["parseNDigitsSigned"] = $4247c0569b65af7c$export$2c9307b2e29c533c;
module.exports["dayPeriodEnumToHours"] = $4247c0569b65af7c$export$fb506d2676e7f207;
module.exports["normalizeTwoDigitYear"] = $4247c0569b65af7c$export$29126f735cbf69f7;
module.exports["isLeapYearIndex"] = $4247c0569b65af7c$export$3d50627710b84d75;

});

parcelRegister("f50NU", function(module, exports) {
var $afa7f24e905606cc$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $afa7f24e905606cc$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
module.exports["numericPatterns"] = $afa7f24e905606cc$export$c123ee06d9da8480;
module.exports["timezonePatterns"] = $afa7f24e905606cc$export$a7ee192b982af9c1;

});

parcelRegister("dxXTH", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");


var $a8KF2 = parcelRequire("a8KF2");


var $37zWd = parcelRequire("37zWd");

var $9dccd1cb7e1e332d$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(LocalWeekYearParser, _Parser);
    var _super = (0, $kUYG8.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $g6rNx.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 130);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, $5GO7m.mapValue)((0, $5GO7m.parseNDigits)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, $5GO7m.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $5GO7m.mapValue)((0, $5GO7m.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $a8KF2.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $5GO7m.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $37zWd.default)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $37zWd.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $27tFE.Parser));
module.exports["LocalWeekYearParser"] = $9dccd1cb7e1e332d$export$b8ef38dfcf05d5db;

});

parcelRegister("88ORV", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");


var $87l2G = parcelRequire("87l2G");

var $5ed68794bfbcfe16$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(ISOWeekYearParser, _Parser);
    var _super = (0, $kUYG8.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $g6rNx.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 130);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, $5GO7m.parseNDigitsSigned)(4, dateString);
                return (0, $5GO7m.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $87l2G.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $27tFE.Parser));
module.exports["ISOWeekYearParser"] = $5ed68794bfbcfe16$export$951d1df011fde06f;

});

parcelRegister("gZ5xM", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");

var $c5d6a4ba42a42bbe$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(ExtendedYearParser, _Parser);
    var _super = (0, $kUYG8.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $g6rNx.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 130);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, $5GO7m.parseNDigitsSigned)(4, dateString);
                return (0, $5GO7m.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $27tFE.Parser));
module.exports["ExtendedYearParser"] = $c5d6a4ba42a42bbe$export$bad9d2ea38e8f1a;

});

parcelRegister("jHpOc", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");

var $e5760d85672313f9$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(QuarterParser, _Parser);
    var _super = (0, $kUYG8.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $g6rNx.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 120);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $27tFE.Parser));
module.exports["QuarterParser"] = $e5760d85672313f9$export$5cb0f701186dde1d;

});

parcelRegister("hKLEL", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");

var $cecbb3253193993a$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, $kUYG8.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $g6rNx.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 120);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $27tFE.Parser));
module.exports["StandAloneQuarterParser"] = $cecbb3253193993a$export$300c0c2990e20e6d;

});

parcelRegister("2osza", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $5GO7m = parcelRequire("5GO7m");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");

var $1be3fb4bd2727d42$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(MonthParser, _Parser);
    var _super = (0, $kUYG8.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $g6rNx.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 110);
        return _this;
    }
    (0, $61VNy.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, $5GO7m.mapValue)((0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, $5GO7m.mapValue)((0, $5GO7m.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, $5GO7m.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $27tFE.Parser));
module.exports["MonthParser"] = $1be3fb4bd2727d42$export$400dd8b40ef138a3;

});

parcelRegister("eoc6L", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");

var $a79cb2fe3699b3ad$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(StandAloneMonthParser, _Parser);
    var _super = (0, $kUYG8.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $g6rNx.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 110);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, $5GO7m.mapValue)((0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, $5GO7m.mapValue)((0, $5GO7m.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, $5GO7m.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $27tFE.Parser));
module.exports["StandAloneMonthParser"] = $a79cb2fe3699b3ad$export$1d7eaa53eaa5deba;

});

parcelRegister("9P2ZO", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");


var $2lVoT = parcelRequire("2lVoT");


var $37zWd = parcelRequire("37zWd");

var $726b33645464efcb$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(LocalWeekParser, _Parser);
    var _super = (0, $kUYG8.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $g6rNx.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 100);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $37zWd.default)((0, $2lVoT.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $27tFE.Parser));
module.exports["LocalWeekParser"] = $726b33645464efcb$export$c4005ffc174e07c0;

});

parcelRegister("2lVoT", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b6a117e7c1f54a1$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $dkBOe = parcelRequire("dkBOe");


var $5QkXN = parcelRequire("5QkXN");


var $3yGK6 = parcelRequire("3yGK6");

function $1b6a117e7c1f54a1$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var week = (0, $kr6hK.default)(dirtyWeek);
    var diff = (0, $5QkXN.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});

parcelRegister("6zqt8", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");


var $dnRFE = parcelRequire("dnRFE");


var $87l2G = parcelRequire("87l2G");

var $4c8a8b2857ddf8f8$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(ISOWeekParser, _Parser);
    var _super = (0, $kUYG8.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $g6rNx.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 100);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $87l2G.default)((0, $dnRFE.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $27tFE.Parser));
module.exports["ISOWeekParser"] = $4c8a8b2857ddf8f8$export$6fc8dbedd560a6af;

});

parcelRegister("dnRFE", function(module, exports) {
$parcel$export(module.exports, "default", () => $9be70e3cbf57652f$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $dkBOe = parcelRequire("dkBOe");


var $f46XZ = parcelRequire("f46XZ");


var $3yGK6 = parcelRequire("3yGK6");

function $9be70e3cbf57652f$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var isoWeek = (0, $kr6hK.default)(dirtyISOWeek);
    var diff = (0, $f46XZ.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});

parcelRegister("gaEPf", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $5GO7m = parcelRequire("5GO7m");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");

var $bc5d3f9bf50740b1$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $bc5d3f9bf50740b1$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $bc5d3f9bf50740b1$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(DateParser, _Parser);
    var _super = (0, $kUYG8.default)(DateParser);
    function DateParser() {
        var _this;
        (0, $g6rNx.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 90);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "subPriority", 1);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $5GO7m.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $bc5d3f9bf50740b1$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $bc5d3f9bf50740b1$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $27tFE.Parser));
module.exports["DateParser"] = $bc5d3f9bf50740b1$export$e8d4b28a20981dd2;

});

parcelRegister("2zfZV", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");

var $1deb4275d03bcc29$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(DayOfYearParser, _Parser);
    var _super = (0, $kUYG8.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $g6rNx.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 90);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "subpriority", 1);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $5GO7m.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $27tFE.Parser));
module.exports["DayOfYearParser"] = $1deb4275d03bcc29$export$6cfe0d613455f615;

});

parcelRegister("iSCOI", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $7EDfs = parcelRequire("7EDfs");

var $dbeb6164992582c5$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(DayParser, _Parser);
    var _super = (0, $kUYG8.default)(DayParser);
    function DayParser() {
        var _this;
        (0, $g6rNx.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 90);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $7EDfs.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $27tFE.Parser));
module.exports["DayParser"] = $dbeb6164992582c5$export$1b03c8b76262f7bd;

});

parcelRegister("7EDfs", function(module, exports) {
$parcel$export(module.exports, "default", () => $592ab6bea6499494$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");


var $kr6hK = parcelRequire("kr6hK");


var $4m74k = parcelRequire("4m74k");

function $592ab6bea6499494$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $3yGK6.default)(2, arguments);
    var defaultOptions = (0, $4m74k.getDefaultOptions)();
    var weekStartsOn = (0, $kr6hK.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $dkBOe.default)(dirtyDate);
    var day = (0, $kr6hK.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});

parcelRegister("6ku3j", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");


var $7EDfs = parcelRequire("7EDfs");

var $49bbec1a392484db$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(LocalDayParser, _Parser);
    var _super = (0, $kUYG8.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $g6rNx.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 90);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, $5GO7m.mapValue)((0, $5GO7m.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, $5GO7m.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $7EDfs.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $27tFE.Parser));
module.exports["LocalDayParser"] = $49bbec1a392484db$export$44d1c127ab42c480;

});

parcelRegister("gxgDD", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");


var $7EDfs = parcelRequire("7EDfs");

var $c09ca268b6399ac1$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $kUYG8.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $g6rNx.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 90);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, $5GO7m.mapValue)((0, $5GO7m.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, $5GO7m.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $7EDfs.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $27tFE.Parser));
module.exports["StandAloneLocalDayParser"] = $c09ca268b6399ac1$export$e447a647caaaec1d;

});

parcelRegister("jE6Oy", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");


var $kxXlL = parcelRequire("kxXlL");

var $e4d709f3bfa22a1b$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(ISODayParser, _Parser);
    var _super = (0, $kUYG8.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $g6rNx.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 90);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, $5GO7m.mapValue)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, $5GO7m.mapValue)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, $5GO7m.mapValue)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, $5GO7m.mapValue)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $kxXlL.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $27tFE.Parser));
module.exports["ISODayParser"] = $e4d709f3bfa22a1b$export$693fb1e525095b2a;

});

parcelRegister("kxXlL", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef54ed65fb65360f$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");


var $kr6hK = parcelRequire("kr6hK");

function $ef54ed65fb65360f$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $3yGK6.default)(2, arguments);
    var day = (0, $kr6hK.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $dkBOe.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});

parcelRegister("j28KI", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");

var $ddb4fe47873dbecf$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(AMPMParser, _Parser);
    var _super = (0, $kUYG8.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $g6rNx.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 80);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $5GO7m.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $27tFE.Parser));
module.exports["AMPMParser"] = $ddb4fe47873dbecf$export$8d1e08492351df91;

});

parcelRegister("djpXE", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");

var $9b1130103b9ec382$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(AMPMMidnightParser, _Parser);
    var _super = (0, $kUYG8.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $g6rNx.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 80);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $5GO7m.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $27tFE.Parser));
module.exports["AMPMMidnightParser"] = $9b1130103b9ec382$export$73ca2bd0a17d273;

});

parcelRegister("7Nf6S", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");

var $5ac8d485ed59c619$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(DayPeriodParser, _Parser);
    var _super = (0, $kUYG8.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $g6rNx.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 80);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $5GO7m.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $27tFE.Parser));
module.exports["DayPeriodParser"] = $5ac8d485ed59c619$export$bb9212adf05373db;

});

parcelRegister("9UQOD", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");

var $7382502015b26245$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(Hour1to12Parser, _Parser);
    var _super = (0, $kUYG8.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $g6rNx.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 70);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $27tFE.Parser));
module.exports["Hour1to12Parser"] = $7382502015b26245$export$8a04050a727a1756;

});

parcelRegister("ael3l", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");

var $772b8adf69b218c7$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(Hour0to23Parser, _Parser);
    var _super = (0, $kUYG8.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $g6rNx.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 70);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $27tFE.Parser));
module.exports["Hour0to23Parser"] = $772b8adf69b218c7$export$e56f4dea2c3e56dd;

});

parcelRegister("6M1cG", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");

var $4ee828c00f7373ac$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(Hour0To11Parser, _Parser);
    var _super = (0, $kUYG8.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $g6rNx.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 70);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $27tFE.Parser));
module.exports["Hour0To11Parser"] = $4ee828c00f7373ac$export$cbbe855312f87d77;

});

parcelRegister("cAMvE", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");

var $92ae79c7d88a2f90$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(Hour1To24Parser, _Parser);
    var _super = (0, $kUYG8.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $g6rNx.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 70);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $27tFE.Parser));
module.exports["Hour1To24Parser"] = $92ae79c7d88a2f90$export$6008046d2b34b6a5;

});

parcelRegister("4mDmT", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");

var $32d7c12f76c50723$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(MinuteParser, _Parser);
    var _super = (0, $kUYG8.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $g6rNx.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 60);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $27tFE.Parser));
module.exports["MinuteParser"] = $32d7c12f76c50723$export$2b52670d9e2be53;

});

parcelRegister("bLXDl", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");

var $8922577c9d0d3a05$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(SecondParser, _Parser);
    var _super = (0, $kUYG8.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $g6rNx.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 50);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, $5GO7m.parseNumericPattern)((0, $f50NU.numericPatterns).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, $5GO7m.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $27tFE.Parser));
module.exports["SecondParser"] = $8922577c9d0d3a05$export$94d46d540cf1366a;

});

parcelRegister("1kRDS", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");

var $0f9144ee890f4d12$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(FractionOfSecondParser, _Parser);
    var _super = (0, $kUYG8.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $g6rNx.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 30);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $61VNy.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $5GO7m.mapValue)((0, $5GO7m.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $27tFE.Parser));
module.exports["FractionOfSecondParser"] = $0f9144ee890f4d12$export$b8e6f8b2d70893b1;

});

parcelRegister("iRtG4", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");

var $dbb43294a2aa850b$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $kUYG8.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $g6rNx.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 10);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    (0, $61VNy.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, $5GO7m.parseTimezonePattern)((0, $f50NU.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, $5GO7m.parseTimezonePattern)((0, $f50NU.timezonePatterns).basic, dateString);
                    case 'XXXX':
                        return (0, $5GO7m.parseTimezonePattern)((0, $f50NU.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, $5GO7m.parseTimezonePattern)((0, $f50NU.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, $5GO7m.parseTimezonePattern)((0, $f50NU.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $27tFE.Parser));
module.exports["ISOTimezoneWithZParser"] = $dbb43294a2aa850b$export$104d901d49fea29b;

});

parcelRegister("62f5E", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $f50NU = parcelRequire("f50NU");


var $5GO7m = parcelRequire("5GO7m");

var $464ea28c4b2b8db5$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(ISOTimezoneParser, _Parser);
    var _super = (0, $kUYG8.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $g6rNx.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 10);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    (0, $61VNy.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, $5GO7m.parseTimezonePattern)((0, $f50NU.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, $5GO7m.parseTimezonePattern)((0, $f50NU.timezonePatterns).basic, dateString);
                    case 'xxxx':
                        return (0, $5GO7m.parseTimezonePattern)((0, $f50NU.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, $5GO7m.parseTimezonePattern)((0, $f50NU.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, $5GO7m.parseTimezonePattern)((0, $f50NU.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $27tFE.Parser));
module.exports["ISOTimezoneParser"] = $464ea28c4b2b8db5$export$12910e5204b52b9;

});

parcelRegister("bQs8D", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");

var $89fa60b9e72bd0e2$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(TimestampSecondsParser, _Parser);
    var _super = (0, $kUYG8.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $g6rNx.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 40);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $61VNy.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $5GO7m.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $27tFE.Parser));
module.exports["TimestampSecondsParser"] = $89fa60b9e72bd0e2$export$2cd8bf877a05e96;

});

parcelRegister("26OJt", function(module, exports) {

var $g6rNx = parcelRequire("g6rNx");


var $61VNy = parcelRequire("61VNy");


var $fPHWO = parcelRequire("fPHWO");


var $8Npt5 = parcelRequire("8Npt5");


var $kUYG8 = parcelRequire("kUYG8");


var $ccS36 = parcelRequire("ccS36");


var $27tFE = parcelRequire("27tFE");


var $5GO7m = parcelRequire("5GO7m");

var $18937eb5d5c6e05e$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $8Npt5.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $kUYG8.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $g6rNx.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "priority", 20);
        (0, $ccS36.default)((0, $fPHWO.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $61VNy.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $5GO7m.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $27tFE.Parser));
module.exports["TimestampMillisecondsParser"] = $18937eb5d5c6e05e$export$6d8f69c6906d6368;

});

parcelRegister("gQEZd", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4414baec8e12e18$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $7D31j = parcelRequire("7D31j");


var $3yGK6 = parcelRequire("3yGK6");

function $c4414baec8e12e18$export$2e2bcd8739ae039(date, options) {
    var _options$format, _options$representati;
    (0, $3yGK6.default)(1, arguments);
    var originalDate = (0, $dkBOe.default)(date);
    if (isNaN(originalDate.getTime())) throw new RangeError('Invalid time value');
    var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
    var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');
    if (format !== 'extended' && format !== 'basic') throw new RangeError("format must be 'extended' or 'basic'");
    if (representation !== 'date' && representation !== 'time' && representation !== 'complete') throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var result = '';
    var tzOffset = '';
    var dateDelimiter = format === 'extended' ? '-' : '';
    var timeDelimiter = format === 'extended' ? ':' : '';
    // Representation is either 'date' or 'complete'
    if (representation !== 'time') {
        var day = (0, $7D31j.default)(originalDate.getDate(), 2);
        var month = (0, $7D31j.default)(originalDate.getMonth() + 1, 2);
        var year = (0, $7D31j.default)(originalDate.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== 'date') {
        // Add the timezone.
        var offset = originalDate.getTimezoneOffset();
        if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = (0, $7D31j.default)(Math.floor(absoluteOffset / 60), 2);
            var minuteOffset = (0, $7D31j.default)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            var sign = offset < 0 ? '+' : '-';
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else tzOffset = 'Z';
        var hour = (0, $7D31j.default)(originalDate.getHours(), 2);
        var minute = (0, $7D31j.default)(originalDate.getMinutes(), 2);
        var second = (0, $7D31j.default)(originalDate.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        var separator = result === '' ? '' : 'T';
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        var time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }
    return result;
}

});

parcelRegister("1w4hj", function(module, exports) {
class $7d33ebf4b0fcc5c6$export$7edca8cfa9634e37 {
    static extractErrorMessage(error) {
        if (error instanceof Error) return $7d33ebf4b0fcc5c6$export$7edca8cfa9634e37.redactSensitiveInfo(error.message || 'unknown-error');
        else return $7d33ebf4b0fcc5c6$export$7edca8cfa9634e37.redactSensitiveInfo(String(error));
    }
}
$7d33ebf4b0fcc5c6$export$7edca8cfa9634e37.redactSensitiveInfo = (str)=>{
    const redacted = str// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/[^,\s]+\@[^,\s]+/g, '[REDACTED EMAIL]')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/[^,\s]+\.[^,\s]+/g, '[REDACTED URL]');
    return redacted;
};
module.exports["ErrorUtils"] = $7d33ebf4b0fcc5c6$export$7edca8cfa9634e37;

});

parcelRegister("7ZL6d", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $96bd972ec1007d07$export$480e55f805d7990f = (0, $kSwu1.defineMessages)({
    // Event hub messages
    eventHubfallbackSuggestedTitle: {
        id: "fabric.editor.ai.eventHub.fallbackSuggestedTitle",
        defaultMessage: "Page title"
    },
    eventHubfallbackSuggestedTitlePrefix: {
        id: "fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix",
        defaultMessage: "Page"
    },
    // Toolbar messages
    aiToolbarTitle: {
        id: "fabric.editor.ai.toolbar.titleText",
        defaultMessage: "Atlassian Intelligence"
    },
    improveWritingToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.improveWriting.title",
        defaultMessage: "Improve writing"
    },
    improveWritingToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.improveWriting.tooltip",
        defaultMessage: "Tell Atlassian Intelligence to improve the writing of your selection"
    },
    askAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.askAI.title",
        defaultMessage: "Ask AI"
    },
    askRovoToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.askRovo.title",
        defaultMessage: "Ask Rovo"
    },
    askRovoToolbarRemixAppTitle: {
        id: "fabric.editor.ai.toolbar.askRovo.remixApp.title",
        defaultMessage: "Edit"
    },
    askRovoToolbarImageTitle: {
        id: "fabric.editor.ai.toolbar.askRovo.image.title",
        defaultMessage: "Edit image"
    },
    moreRovoOptionsMenuLabel: {
        id: "fabric.editor.ai.toolbar.moreRovoOptions.label",
        defaultMessage: "More Rovo options"
    },
    askRovoAiSplitButtonLabel: {
        id: "fabric.editor.ai.toolbar.askRovoAiSplitButton.label",
        defaultMessage: "Ask Rovo AI"
    },
    askAIToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip",
        defaultMessage: "Open Atlassian Intelligence"
    },
    askAIToolbarIconTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip.quickCommand",
        defaultMessage: "Ask AI {key}+'"
    },
    askRovoToolbarIconTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.askRovo.tooltip.quickCommand",
        defaultMessage: "Ask Rovo {key}+'"
    },
    askRovoToolbarRemixAppTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.askRovo.remixApp.tooltip.quickCommand",
        defaultMessage: "Edit {key}+'"
    },
    askRovoToolbarImageTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.askRovo.image.tooltip.quickCommand",
        defaultMessage: "Edit image {key}+'"
    },
    tryAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.tryAI.title",
        defaultMessage: "Try AI"
    },
    tryAIToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip",
        defaultMessage: "Open Atlassian Intelligence"
    },
    simplifiedAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.simplifiedAI.title",
        defaultMessage: "AI"
    },
    rovoToolbarDropdownChevronLabel: {
        id: "fabric.editor.ai.toolbar.rovoDropdownChevron.label",
        defaultMessage: "More Ask Rovo options"
    },
    summarizeToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.summarize.title",
        defaultMessage: "Summarize"
    },
    translateToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.translate.title",
        defaultMessage: "Translate"
    },
    translateOptionsIconLabel: {
        id: "fabric.editor.ai.toolbar.translateOptions.label",
        defaultMessage: "Translate options"
    },
    spellingAndGrammarToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.spellingAndGrammar.title",
        defaultMessage: "Fix spelling and grammar"
    },
    makeLongerToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.makeLonger.title",
        defaultMessage: "Make longer"
    },
    makeShorterToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.makeShorter.title",
        defaultMessage: "Make shorter"
    },
    changeToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.changeTone.title",
        defaultMessage: "Change tone"
    },
    changeToneOptionsIconLabel: {
        id: "fabric.editor.ai.toolbar.changeToneOptions.title",
        defaultMessage: "Change tone options"
    },
    moreProfessionalToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.moreProfessionalTone.title",
        defaultMessage: "More professional"
    },
    moreCasualToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.moreCasualTone.title",
        defaultMessage: "More casual"
    },
    moreEmpatheticToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.moreEmpatheticTone.title",
        defaultMessage: "More empathetic"
    },
    adjustLengthToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.adjustLength.title",
        defaultMessage: "Adjust length"
    },
    DefineDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.DefineDropdownIconTitle.title",
        defaultMessage: "Define"
    },
    // Prebuilt messages
    atlasGenerateContentConfigItemDescription: {
        id: "fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription",
        defaultMessage: "Generates content to be inserted into the update"
    },
    atlasSummarizePageConfigItemDescription: {
        id: "fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription",
        defaultMessage: "Summarizes the content of the update"
    },
    confluenceChangeToneSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Change tone"
    },
    confluenceRewriteSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Rewrite"
    },
    confluenceTranslateSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Translate"
    },
    // AI Panel Action items messages
    actionItemsPageTitle: {
        id: "fabric.editor.ai.ai-panels.actionItemsPageTitle",
        defaultMessage: "Action items panel (Beta)"
    },
    actionItemsPageDescription: {
        id: "fabric.editor.ai.ai-panels.actionItemsPageDescription",
        defaultMessage: "Use Atlassian Intelligence to find action items and display in a panel"
    },
    // AI Panel Summarise page messages
    summarizePageTitle: {
        id: "fabric.editor.ai.ai-panels.summarizePageTitle",
        defaultMessage: "Page summary panel (Beta)"
    },
    summarisePageDescription: {
        id: "fabric.editor.ai.ai-panels.summarizePageDescription",
        defaultMessage: "Use Atlassian Intelligence to summarize this page and display in a panel"
    },
    // Agent messages
    agentsDropdownTitle: {
        id: "rovo.agents.dropdown.title",
        defaultMessage: "Agents"
    },
    agentsViewAgentsLabel: {
        id: "rovo.agents.dropdown.viewAgents.label",
        defaultMessage: "View all agents"
    },
    // Error messages
    unhandledErrorMessage: {
        id: "fabric.editor.ai.experience-application.unhandledErrorMessage",
        defaultMessage: "We're having trouble. Close the dialog and try again."
    },
    cmdPaletteUnhandledErrorMessage: {
        id: "fabric.editor.ai.experience-application.cmdPaletteUnhandledErrorMessage",
        defaultMessage: "We're having issues and can't generate a response right now. Try again later."
    },
    markdownErrorMessage: {
        id: "fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage",
        defaultMessage: "We're having trouble generating the preview. Close the dialog and try again."
    },
    // Prompt Builder messages
    promptbuilderAriaLabel: {
        id: "fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel",
        defaultMessage: "Ask Atlassian Intelligence"
    },
    promptBuilderFromButton: {
        id: "fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit",
        defaultMessage: "Generate"
    },
    // AI Smart button messages
    aiSmartButtonDynamicSurfaceSelectedContent: {
        id: "fabric.editor.ai.ai-smart-button.context.reference",
        defaultMessage: "Selected content"
    },
    // Telepointer
    aiRovoTelepointer: {
        id: "fabric.editor.ai.telepointer.rovo",
        defaultMessage: "Rovo"
    },
    // On-paste menu messages
    pasteMenuActionsTitle: {
        id: "fabric.editor.ai.paste-menu.section-title",
        defaultMessage: "Actions"
    },
    // Block menu messages
    blockMenuNestedMenuTitle: {
        id: "fabric.editor.ai.config.item.blockMenuNestedMenu.title",
        defaultMessage: "View more actions"
    },
    // Smartlink action messages
    smartlinkListKeyTopics: {
        id: "fabric.editor.ai.smartlink.action.listKeyTopics",
        defaultMessage: "List key topics"
    },
    smartlinkListKeyThemes: {
        id: "fabric.editor.ai.smartlink.action.listKeyThemes",
        defaultMessage: "List key themes"
    },
    smartlinkExtractInsights: {
        id: "fabric.editor.ai.smartlink.action.extractInsights",
        defaultMessage: "Extract insights"
    },
    smartlinkExtractUserQuotes: {
        id: "fabric.editor.ai.smartlink.action.extractUserQuotes",
        defaultMessage: "Extract user quotes"
    },
    smartlinkAddDecisions: {
        id: "fabric.editor.ai.smartlink.action.addDecisions",
        defaultMessage: "Add decisions"
    },
    smartlinkDefineActionItems: {
        id: "fabric.editor.ai.smartlink.action.defineActionItems",
        defaultMessage: "Define action items"
    },
    smartlinkSummarizeChanges: {
        id: "fabric.editor.ai.smartlink.action.summarizeChanges",
        defaultMessage: "Summarize changes"
    },
    smartlinkAddRelatedWorkItems: {
        id: "fabric.editor.ai.smartlink.action.addRelatedWorkItems",
        defaultMessage: "Add related work items"
    },
    smartlinkListTodos: {
        id: "fabric.editor.ai.smartlink.action.listTodos",
        defaultMessage: "List to-dos"
    }
});
module.exports["aiMessages"] = $96bd972ec1007d07$export$480e55f805d7990f;

});

parcelRegister("a2viN", function(module, exports) {

var $ciSba = parcelRequire("ciSba");


var $cozmU = parcelRequire("cozmU");


var $f6RxU = parcelRequire("f6RxU");

const $0dd3e700d5d7642d$var$isClickable = (props)=>!!props.onClick;
class $0dd3e700d5d7642d$export$6341f9a885713487 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ciSba.DateLozenge), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: this.props.className,
            onClick: $0dd3e700d5d7642d$var$isClickable(this.props) ? this.handleOnClick : undefined,
            color: this.props.color
        }, this.renderContent());
    }
    constructor(...args){
        super(...args);
        this.handleOnClick = (event)=>{
            if ($0dd3e700d5d7642d$var$isClickable(this.props)) this.props.onClick(this.props.value, event);
        };
        this.renderContent = ()=>{
            if (this.props.children) {
                if (typeof this.props.children === 'function') return(// prettier-ignore
                // eslint-disable-next-line @typescript-eslint/ban-types
                this.props.children(this.props));
                return this.props.children;
            }
            return (0, $f6RxU.default)(this.props.value, this.props.format || '');
        };
    }
}
$0dd3e700d5d7642d$export$6341f9a885713487.displayName = 'Date';
$0dd3e700d5d7642d$export$6341f9a885713487.defaultProps = {
    format: 'dd/MM/yyyy',
    color: 'grey'
};
module.exports["Date"] = $0dd3e700d5d7642d$export$6341f9a885713487;

});

parcelRegister("ciSba", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $77fc4aa735a8bb8d$var$baseStyles = null;
const $77fc4aa735a8bb8d$var$onClickStyles = null;
const $77fc4aa735a8bb8d$var$colorStyles = {
    red: "_bfhk1vk5 _syaz9lu1 _irr31rtt",
    yellow: "_bfhkibhp _syazfb2s _irr31773",
    blue: "_bfhk1s93 _syaz16jw _irr31dy8",
    green: "_bfhkn729 _syazh55r _irr31wnw",
    purple: "_bfhkp2ly _syazqmo9 _irr31nm4",
    grey: "_bfhki8nm _syazi7uo _irr3plhp"
};
const $77fc4aa735a8bb8d$export$a9273d5fc6f7142c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(13);
    let children;
    let className;
    let rest;
    let t0;
    if ($[0] !== props) {
        ({ className: className, color: t0, children: children, ...rest } = props);
        $[0] = props;
        $[1] = children;
        $[2] = className;
        $[3] = rest;
        $[4] = t0;
    } else {
        children = $[1];
        className = $[2];
        rest = $[3];
        t0 = $[4];
    }
    const color = t0 === undefined ? "grey" : t0;
    const t1 = props.onClick && "_80omtlke";
    const t2 = $77fc4aa735a8bb8d$var$colorStyles[color];
    let t3;
    if ($[5] !== className || $[6] !== t1 || $[7] !== t2) {
        t3 = (0, $hekY6.default)([
            "_2rkofajl _19pkidpf _2hwxt94y _otyridpf _18u0t94y _v5641y8x _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _kqswh2mm _o5721q9c _80omn7od",
            t1,
            t2,
            className
        ]);
        $[5] = className;
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== children || $[10] !== rest || $[11] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            ...rest,
            className: t3,
            role: "button"
        }, children);
        $[9] = children;
        $[10] = rest;
        $[11] = t3;
        $[12] = t4;
    } else t4 = $[12];
    return t4;
} : (props)=>{
    const { className: className, color: color = 'grey', children: children, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        ...rest,
        className: (0, $hekY6.default)([
            "_2rkofajl _19pkidpf _2hwxt94y _otyridpf _18u0t94y _v5641y8x _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _kqswh2mm _o5721q9c _80omn7od",
            props.onClick && "_80omtlke",
            $77fc4aa735a8bb8d$var$colorStyles[color],
            className
        ]),
        role: "button"
    }, children);
};
module.exports["DateLozenge"] = $77fc4aa735a8bb8d$export$a9273d5fc6f7142c;

});

parcelRegister("c5jT4", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $kSwu1 = parcelRequire("kSwu1");

const $fb80bfa16650ce97$export$21be832820f3e6e6 = (0, $kSwu1.defineMessages)({
    aupViolationMessage: {
        id: "fabric.editor.ai.experience.aupViolationMessage",
        defaultMessage: "Your prompt or content might not comply with our Acceptable Use Policy. Please review both and refer to our <link>Acceptable Use Policy</link> if needed. If the problem persists, consider trying a different prompt or content."
    },
    documentInsertError: {
        id: "fabric.editor.ai.experience-application.documentInsertError",
        defaultMessage: "We're having trouble inserting the response. Close the dialog and try again."
    },
    tokenLimitExceeded: {
        id: "fabric.editor.ai.experience-application.tokenLimitExceeded",
        defaultMessage: "We couldn't get a response. Your prompt or response was over the limit for this request. Close the dialog and try again."
    },
    rateLimitEnforced: {
        id: "fabric.editor.ai.experience-application.rateLimitEnforced",
        defaultMessage: "We\u2019ve received too many recent requests for Atlassian Intelligence (AI). Try again in a few minutes or read about <link>excessive use of AI</link>."
    },
    apiError: {
        id: "fabric.editor.ai.experience.apiError",
        defaultMessage: "We couldn\u2019t get a response, please try again."
    },
    elevateDisabledGenerateError: {
        id: "fabric.editor.ai.experience.elevateDisabledGenetateError",
        defaultMessage: "Free generate is disabled in Elevate at this time."
    },
    internalServerError: {
        id: "fabric.editor.ai.experience.internalServerError",
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <link>check the status of AI</link>."
    },
    inputTooShortError: {
        id: "fabric.editor.ai.experience.inputTooShortError",
        defaultMessage: "The content is too short to summarize. Please add more and try again."
    },
    hipaaContentError: {
        id: "fabric.editor.ai.experience.hipaaContentError",
        defaultMessage: "Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content. Please remove these links and try again."
    },
    adfStreamingError: {
        id: "fabric.editor.ai.experience.adfStreamingError",
        defaultMessage: "Our apologies, we couldn't get a response."
    },
    aifcAupViolationMessage: {
        id: "fabric.editor.ai.experience.aifcAupViolationMessage",
        defaultMessage: "Content does not comply with our <link>Acceptable Use Policy</link>."
    },
    aifcApiError: {
        id: "fabric.editor.ai.experience.aifcApiError",
        defaultMessage: "An unknown error occurred."
    },
    aifcApiErrorRetry: {
        id: "fabric.editor.ai.experience.aifcApiErrorRetry",
        defaultMessage: "An unknown error occurred. Please reload and try again."
    },
    aifcTokenLimitExceeded: {
        id: "fabric.editor.ai.experience.aifcTokenLimitExceeded",
        defaultMessage: "There\u2019s too much content to process. Select less content and try again."
    },
    aifcInputTooShortError: {
        id: "fabric.editor.ai.experience.aifcInputTooShortError",
        defaultMessage: "More content needed to complete your request. Please select more content and try again."
    },
    aifcHipaaContentError: {
        id: "fabric.editor.ai.experience.aifcHipaaContentError",
        defaultMessage: "Your content contains links to HIPAA restricted content. Remove links and try again."
    },
    aifcRateLimitEnforced: {
        id: "fabric.editor.ai.experience.aifcRateLimitEnforced",
        defaultMessage: "You\u2019ve reached the <link>maximum number of requests</link>. Try again in 5 minutes."
    },
    aifcInternalServerError: {
        id: "fabric.editor.ai.experience.aifcInternalServerError",
        defaultMessage: "Our apologies, we couldn\u2019t get a response. Try again in 5 minutes or <link>check Rovo status</link>."
    },
    aifcAdfStreamingError: {
        id: "fabric.editor.ai.experience.aifcAdfStreamingError",
        defaultMessage: "Our apologies, we couldn\u2019t get a response."
    },
    noTextualContentError: {
        id: "fabric.editor.ai.experience.noTextualContentError",
        defaultMessage: "More content needed to complete your request. Please select more content and try again."
    }
});
module.exports["aiFailedStateMessages"] = $fb80bfa16650ce97$export$21be832820f3e6e6;

});

parcelRegister("gWsFk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $a7dc8350eac270bb$var$sizeStyles = {
    small: "_1bsb7vkz _4t3i7vkz",
    medium: "_1bsb1tcg _4t3i1tcg",
    large: "_1bsbzwfg _4t3izwfg",
    xlarge: "_1bsbckbl _4t3ickbl"
};
const $a7dc8350eac270bb$var$svgStyles = null;
const $a7dc8350eac270bb$var$rovoIconPath = /*#__PURE__*/ $cozmU.createElement($cozmU.Fragment, null, /*#__PURE__*/ $cozmU.createElement("path", {
    d: "M10.7601 0.338448C11.5933 -0.121106 12.6101 -0.112663 13.4365 0.363775L19.9352 4.11317L21.4762 5.0023C22.3177 5.4874 22.8385 6.3874 22.8385 7.35696V16.6341C22.8385 17.6075 22.3208 18.5036 21.4769 18.9884L15.4334 22.4752C15.4466 22.438 15.4592 22.4006 15.4713 22.363C15.5834 22.0154 15.6429 21.6481 15.6429 21.2727V11.9955C15.6429 10.7211 14.9646 9.5458 13.8581 8.91002L12.7419 8.26625L9.35306 6.31196V2.71838C9.35306 2.43521 9.39687 2.1586 9.47978 1.89674C9.68356 1.26299 10.117 0.714353 10.7101 0.371867L10.7119 0.37083C10.7288 0.361022 10.745 0.350144 10.7601 0.338448Z",
    fill: "#FCA700"
}), /*#__PURE__*/ $cozmU.createElement("path", {
    d: "M8.71417 1.52478L2.67066 5.01159C1.82674 5.49643 1.30908 6.39246 1.30908 7.36586V16.643C1.30908 17.6126 1.82979 18.5125 2.67121 18.9976L4.10412 19.8243L10.7111 23.6362C11.5374 24.1126 12.5543 24.1211 13.3875 23.6616C13.4026 23.6499 13.4186 23.639 13.4356 23.6292C14.0293 23.287 14.4634 22.7381 14.6675 22.1041C14.7506 21.842 14.7945 21.5651 14.7945 21.2816V17.688L11.2974 15.6713L10.2897 15.0901C9.18348 14.4543 8.50468 13.2788 8.50468 12.0044V2.72728C8.50468 2.35237 8.56398 1.98558 8.67586 1.63842C8.68799 1.60029 8.70078 1.56241 8.71417 1.52478Z",
    fill: "#FCA700"
}), /*#__PURE__*/ $cozmU.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M11.2974 15.6713L4.10412 19.8243L2.67121 18.9976C1.82979 18.5125 1.30908 17.6126 1.30908 16.643V7.36586C1.30908 6.39246 1.82674 5.49643 2.67066 5.01159L8.71417 1.52478C8.70078 1.56241 8.68799 1.60029 8.67586 1.63842C8.56398 1.98558 8.50468 2.35237 8.50468 2.72728V12.0044C8.50468 13.2788 9.18348 14.4543 10.2897 15.0901L11.2974 15.6713Z",
    fill: "#1868DB"
}), /*#__PURE__*/ $cozmU.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M12.7419 8.26625L9.35306 6.31196V2.71838C9.35306 2.43521 9.39687 2.15859 9.47978 1.89674C9.68356 1.26299 10.117 0.714353 10.7101 0.371867L10.7119 0.37083C10.7288 0.361022 10.745 0.350144 10.7601 0.338447C11.5933 -0.121106 12.6101 -0.112663 13.4365 0.363775L19.9352 4.11317L12.7419 8.26625Z",
    fill: "#FCA700"
}), /*#__PURE__*/ $cozmU.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M21.4762 5.00229L19.9352 4.11316L12.7419 8.26624L13.8581 8.91001C14.9646 9.54579 15.6429 10.721 15.6429 11.9955V21.2727C15.6429 21.6481 15.5834 22.0154 15.4713 22.363C15.4592 22.4006 15.4466 22.438 15.4334 22.4752L21.4769 18.9884C22.3208 18.5036 22.8385 17.6075 22.8385 16.6341V7.35695C22.8385 6.38739 22.3177 5.48739 21.4762 5.00229Z",
    fill: "#AF59E0"
}), /*#__PURE__*/ $cozmU.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M11.2975 15.6713L4.10413 19.8244L10.7111 23.6362C11.5375 24.1126 12.5544 24.1211 13.3875 23.6616C13.4026 23.6499 13.4186 23.639 13.4356 23.6292C14.0293 23.287 14.4634 22.7381 14.6675 22.1041C14.7506 21.842 14.7945 21.5651 14.7945 21.2816V17.688L11.2975 15.6713Z",
    fill: "#6A9A23"
}));
const $a7dc8350eac270bb$var$RovoIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(9);
    const { primaryColor: primaryColor, size: t0, label: label } = props;
    const size = t0 === undefined ? "small" : t0;
    let t1;
    if ($[0] !== primaryColor) {
        t1 = {
            color: primaryColor
        };
        $[0] = primaryColor;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = label || undefined;
    const t3 = label ? "img" : "presentation";
    const t4 = $a7dc8350eac270bb$var$sizeStyles[size];
    let t5;
    if ($[2] !== t4) {
        t5 = (0, $hekY6.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw",
            t4
        ]);
        $[2] = t4;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3 || $[7] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement("svg", {
            viewBox: "0 0 24 24",
            style: t1,
            "aria-label": t2,
            role: t3,
            className: t5
        }, $a7dc8350eac270bb$var$rovoIconPath);
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    return t6;
} : (props)=>{
    const { primaryColor: primaryColor, size: size = 'small', label: label } = props;
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor
        },
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw",
            $a7dc8350eac270bb$var$sizeStyles[size]
        ])
    }, $a7dc8350eac270bb$var$rovoIconPath);
};
const $a7dc8350eac270bb$var$rovoIconJiraPath = /*#__PURE__*/ $cozmU.createElement("g", {
    transform: "translate(4, 4)"
}, /*#__PURE__*/ $cozmU.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7.53094 10.4476L2.73541 13.2163L1.78022 12.6652C1.21927 12.3418 0.872135 11.7418 0.872135 11.0954V4.91066C0.872135 4.26173 1.21724 3.66437 1.77985 3.34114L5.80885 1.01662C5.79992 1.0417 5.7914 1.06696 5.78331 1.09238C5.70872 1.32382 5.66919 1.56834 5.66919 1.81828V8.00304C5.66919 8.8526 6.12173 9.63628 6.85921 10.0602L7.53094 10.4476Z",
    fill: "#357DE8"
}), /*#__PURE__*/ $cozmU.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7.53076 10.4476L2.73523 13.2163L7.13984 15.7575C7.69076 16.0751 8.36871 16.0808 8.92411 15.7744C8.93417 15.7666 8.94488 15.7594 8.95621 15.7529C9.35198 15.5247 9.6414 15.1588 9.77748 14.7361C9.83287 14.5614 9.86214 14.3768 9.86214 14.1878V11.7921L7.53076 10.4476Z",
    fill: "#82B536"
}), /*#__PURE__*/ $cozmU.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M14.3184 3.33501L13.291 2.74227L8.49549 5.51098L9.23969 5.94015C9.97729 6.36401 10.4295 7.14752 10.4295 7.99717V14.1819C10.4295 14.4322 10.3899 14.6771 10.3151 14.9088C10.3071 14.9339 10.2987 14.9588 10.2899 14.9836L14.3189 12.6591C14.8815 12.3358 15.2266 11.7385 15.2266 11.0895V4.90479C15.2266 4.25842 14.8794 3.65842 14.3184 3.33501Z",
    fill: "#BF63F3"
}), /*#__PURE__*/ $cozmU.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M8.49384 5.51082L6.23466 4.20796V1.81225C6.23466 1.62347 6.26387 1.43906 6.31913 1.26449C6.455 0.841993 6.74398 0.476235 7.13931 0.247911L7.14051 0.247219C7.15185 0.240681 7.16263 0.233429 7.17269 0.225631C7.72811 -0.0807372 8.40603 -0.0751089 8.95696 0.242516L13.2894 2.74211L8.49384 5.51082Z",
    fill: "#FCA700"
}));
const $a7dc8350eac270bb$export$70b609cdd5be83af = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(9);
    const { primaryColor: primaryColor, size: t0, label: label } = props;
    const size = t0 === undefined ? "large" : t0;
    let t1;
    if ($[0] !== primaryColor) {
        t1 = {
            color: primaryColor
        };
        $[0] = primaryColor;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = label || undefined;
    const t3 = label ? "img" : "presentation";
    const t4 = $a7dc8350eac270bb$var$sizeStyles[size];
    let t5;
    if ($[2] !== t4) {
        t5 = (0, $hekY6.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw",
            t4
        ]);
        $[2] = t4;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3 || $[7] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement("svg", {
            viewBox: "0 0 24 24",
            style: t1,
            "aria-label": t2,
            role: t3,
            className: t5
        }, $a7dc8350eac270bb$var$rovoIconJiraPath);
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    return t6;
} : (props)=>{
    const { primaryColor: primaryColor, size: size = 'large', label: label } = props;
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        viewBox: "0 0 24 24",
        style: {
            color: primaryColor
        },
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation',
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _lswuvuon _lcxvglyw",
            $a7dc8350eac270bb$var$sizeStyles[size]
        ])
    }, $a7dc8350eac270bb$var$rovoIconJiraPath);
};
var $a7dc8350eac270bb$export$2e2bcd8739ae039 = $a7dc8350eac270bb$var$RovoIcon;
module.exports["RovoIconJira"] = $a7dc8350eac270bb$export$70b609cdd5be83af;
module.exports["default"] = $a7dc8350eac270bb$export$2e2bcd8739ae039;

});

parcelRegister("at1wf", function(module, exports) {

var $4XbfY = parcelRequire("4XbfY");


var $iNGf0 = parcelRequire("iNGf0");

class $64cd2f6919e64ab9$export$2e2bcd8739ae039 {
    serializeFragment(fragment) {
        const result = [];
        fragment.forEach((n)=>{
            result.push((0, $iNGf0.reduce)(n, this.schema));
        });
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        return result.join('\n').replace(/\n+/g, '\n');
    }
    static fromSchema(schema = (0, $4XbfY.defaultSchema)) {
        return new $64cd2f6919e64ab9$export$2e2bcd8739ae039(schema);
    }
    constructor(schema){
        this.schema = schema;
        this.schema = schema;
    }
}
module.exports["default"] = $64cd2f6919e64ab9$export$2e2bcd8739ae039;

});

parcelRegister("iNGf0", function(module, exports) {

var $6of4U = parcelRequire("6of4U");


var $ieVrh = parcelRequire("ieVrh");


var $bJSXd = parcelRequire("bJSXd");


var $6IJk5 = parcelRequire("6IJk5");


var $63z7w = parcelRequire("63z7w");


var $Vlxg4 = parcelRequire("Vlxg4");


var $1K7J8 = parcelRequire("1K7J8");


var $52f9Q = parcelRequire("52f9Q");


var $hxitp = parcelRequire("hxitp");


var $6KCHO = parcelRequire("6KCHO");


var $44pQv = parcelRequire("44pQv");


var $9gbbf = parcelRequire("9gbbf");


var $j7mJN = parcelRequire("j7mJN");


var $kxYoQ = parcelRequire("kxYoQ");


var $a9rhS = parcelRequire("a9rhS");


var $jFg0g = parcelRequire("jFg0g");


var $1BnGB = parcelRequire("1BnGB");


var $b49IO = parcelRequire("b49IO");

const $9a113cebc8804ae1$export$533b26079ad0b4b = (node, schema)=>{
    const reducer = $9a113cebc8804ae1$var$nodeToReducerMapping[node.type.name] || $9a113cebc8804ae1$var$nodeToReducerMapping.unknown;
    return reducer(node, schema);
};
const $9a113cebc8804ae1$var$nodeToReducerMapping = {
    blockquote: $6of4U.default,
    bulletList: $ieVrh.default,
    date: $bJSXd.default,
    decisionItem: $6IJk5.default,
    hardBreak: $63z7w.default,
    heading: $Vlxg4.default,
    inlineCard: $1K7J8.default,
    listItem: $52f9Q.default,
    mediaGroup: $hxitp.default,
    mention: $6KCHO.default,
    orderedList: $44pQv.default,
    panel: $9gbbf.default,
    panel_c1: (0, $9gbbf.default),
    paragraph: $j7mJN.default,
    rule: $kxYoQ.default,
    status: $a9rhS.default,
    table: $jFg0g.default,
    taskItem: $1BnGB.default,
    unknown: $b49IO.default
};
module.exports["reduce"] = $9a113cebc8804ae1$export$533b26079ad0b4b;

});

parcelRegister("6of4U", function(module, exports) {

var $iNGf0 = parcelRequire("iNGf0");

const $fd93b6cc3e3ae127$var$blockquote = (node, schema)=>{
    const result = [];
    node.content.forEach((n)=>{
        result.push((0, $iNGf0.reduce)(n, schema));
    });
    return `> ${result.join('')}`;
};
var $fd93b6cc3e3ae127$export$2e2bcd8739ae039 = $fd93b6cc3e3ae127$var$blockquote;
module.exports["default"] = $fd93b6cc3e3ae127$export$2e2bcd8739ae039;

});

parcelRegister("ieVrh", function(module, exports) {

var $iNGf0 = parcelRequire("iNGf0");

const $7148a3dfac9fb0b6$var$bulletList = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push(`* ${(0, $iNGf0.reduce)(n, schema)}`);
    });
    return result.join('\n');
};
var $7148a3dfac9fb0b6$export$2e2bcd8739ae039 = $7148a3dfac9fb0b6$var$bulletList;
module.exports["default"] = $7148a3dfac9fb0b6$export$2e2bcd8739ae039;

});

parcelRegister("bJSXd", function(module, exports) {

var $efgwK = parcelRequire("efgwK");


var $6FNab = parcelRequire("6FNab");

const $abf445e85d320cb8$var$date = (node, _schema)=>{
    return node.attrs.timestamp ? (0, $efgwK.timestampToIsoFormat)(node.attrs.timestamp) : (0, $6FNab.getText)(node);
};
var $abf445e85d320cb8$export$2e2bcd8739ae039 = $abf445e85d320cb8$var$date;
module.exports["default"] = $abf445e85d320cb8$export$2e2bcd8739ae039;

});

parcelRegister("6IJk5", function(module, exports) {

var $iNGf0 = parcelRequire("iNGf0");

const $db9079b38a40c947$var$decisionItem = (node, schema)=>{
    const result = [];
    let previousNodeType = '';
    node.forEach((n)=>{
        const text = (0, $iNGf0.reduce)(n, schema);
        if (previousNodeType === 'mention' && !text.startsWith(' ')) result.push(` ${text}`);
        else result.push(text);
        previousNodeType = n.type.name;
    });
    return `<> ${result.join('').trim()}`;
};
var $db9079b38a40c947$export$2e2bcd8739ae039 = $db9079b38a40c947$var$decisionItem;
module.exports["default"] = $db9079b38a40c947$export$2e2bcd8739ae039;

});

parcelRegister("63z7w", function(module, exports) {
const $21efdb95e5ccf897$var$hardBreak = ()=>{
    return '\n';
};
var $21efdb95e5ccf897$export$2e2bcd8739ae039 = $21efdb95e5ccf897$var$hardBreak;
module.exports["default"] = $21efdb95e5ccf897$export$2e2bcd8739ae039;

});

parcelRegister("Vlxg4", function(module, exports) {

var $iNGf0 = parcelRequire("iNGf0");

const $f85fe34da5fc5487$var$heading = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $iNGf0.reduce)(n, schema));
    });
    return result.join('');
};
var $f85fe34da5fc5487$export$2e2bcd8739ae039 = $f85fe34da5fc5487$var$heading;
module.exports["default"] = $f85fe34da5fc5487$export$2e2bcd8739ae039;

});

parcelRegister("1K7J8", function(module, exports) {

var $6FNab = parcelRequire("6FNab");

const $70f547b653171850$var$inlineCard = (node, _schema)=>{
    return node.attrs.url || node.attrs.data?.url || (0, $6FNab.getText)(node);
};
var $70f547b653171850$export$2e2bcd8739ae039 = $70f547b653171850$var$inlineCard;
module.exports["default"] = $70f547b653171850$export$2e2bcd8739ae039;

});

parcelRegister("52f9Q", function(module, exports) {

var $iNGf0 = parcelRequire("iNGf0");

const $d669454d48ed6f9d$var$listItem = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $iNGf0.reduce)(n, schema));
    });
    return result.join('\n');
};
var $d669454d48ed6f9d$export$2e2bcd8739ae039 = $d669454d48ed6f9d$var$listItem;
module.exports["default"] = $d669454d48ed6f9d$export$2e2bcd8739ae039;

});

parcelRegister("hxitp", function(module, exports) {
const $db1b3432a92b30e7$var$mediaGroup = (node)=>{
    // count children which are media files
    // ignore card links
    let childMediaFilesCount = 0;
    node.content.forEach((childNode)=>{
        if (childNode.attrs.type === 'file') childMediaFilesCount += 1;
    });
    if (childMediaFilesCount) {
        const postfix = childMediaFilesCount > 1 ? 'Files' : 'File';
        return `\u{1F4CE} ${childMediaFilesCount} ${postfix}`;
    }
    return '';
};
var $db1b3432a92b30e7$export$2e2bcd8739ae039 = $db1b3432a92b30e7$var$mediaGroup;
module.exports["default"] = $db1b3432a92b30e7$export$2e2bcd8739ae039;

});

parcelRegister("6KCHO", function(module, exports) {
const $2892b7520cfa40c3$var$mention = (node, _schema)=>{
    if ([
        'all',
        'here'
    ].indexOf(node.attrs.id) !== -1) return `@${node.attrs.id}`;
    return `${node.attrs.text || '@unknown'}`;
};
var $2892b7520cfa40c3$export$2e2bcd8739ae039 = $2892b7520cfa40c3$var$mention;
module.exports["default"] = $2892b7520cfa40c3$export$2e2bcd8739ae039;

});

parcelRegister("44pQv", function(module, exports) {

var $eTXkv = parcelRequire("eTXkv");


var $iNGf0 = parcelRequire("iNGf0");

const $d92c4e65e81f46d9$var$orderedList = (node, schema)=>{
    const result = [];
    const order = (0, $eTXkv.getOrderFromOrderedListNode)(node);
    node.forEach((n, _offset, index)=>{
        result.push(`${index + order}. ${(0, $iNGf0.reduce)(n, schema)}`);
    });
    return result.join('\n');
};
var $d92c4e65e81f46d9$export$2e2bcd8739ae039 = $d92c4e65e81f46d9$var$orderedList;
module.exports["default"] = $d92c4e65e81f46d9$export$2e2bcd8739ae039;

});

parcelRegister("9gbbf", function(module, exports) {

var $iNGf0 = parcelRequire("iNGf0");

const $d6ca89f5f43e07e1$var$panel = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $iNGf0.reduce)(n, schema));
    });
    return result.join('\n');
};
var $d6ca89f5f43e07e1$export$2e2bcd8739ae039 = $d6ca89f5f43e07e1$var$panel;
module.exports["default"] = $d6ca89f5f43e07e1$export$2e2bcd8739ae039;

});

parcelRegister("j7mJN", function(module, exports) {

var $iNGf0 = parcelRequire("iNGf0");

const $5d93a0ec0675b7e1$var$paragraph = (node, schema)=>{
    const result = [];
    let previousNodeType = '';
    node.forEach((n)=>{
        const text = (0, $iNGf0.reduce)(n, schema);
        if (previousNodeType === 'mention' && !text.startsWith(' ')) result.push(` ${text}`);
        else result.push(text);
        previousNodeType = n.type.name;
    });
    return result.join('').trim();
};
var $5d93a0ec0675b7e1$export$2e2bcd8739ae039 = $5d93a0ec0675b7e1$var$paragraph;
module.exports["default"] = $5d93a0ec0675b7e1$export$2e2bcd8739ae039;

});

parcelRegister("kxYoQ", function(module, exports) {
const $e07e0bacdcac7501$var$rule = ()=>{
    return '';
};
var $e07e0bacdcac7501$export$2e2bcd8739ae039 = $e07e0bacdcac7501$var$rule;
module.exports["default"] = $e07e0bacdcac7501$export$2e2bcd8739ae039;

});

parcelRegister("a9rhS", function(module, exports) {

var $6FNab = parcelRequire("6FNab");


var $ixfCV = parcelRequire("ixfCV");

const $fb5e716dbb959b0a$var$status = (node, _schema)=>{
    return node.attrs.text ? node.attrs.style === 'mixedCase' && (0, $ixfCV.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? `[ ${node.attrs.text} ]` : `[ ${node.attrs.text.toUpperCase()} ]` : (0, $6FNab.getText)(node);
};
var $fb5e716dbb959b0a$export$2e2bcd8739ae039 = $fb5e716dbb959b0a$var$status;
module.exports["default"] = $fb5e716dbb959b0a$export$2e2bcd8739ae039;

});

parcelRegister("jFg0g", function(module, exports) {

var $iNGf0 = parcelRequire("iNGf0");

const $7d27d5632f61f2e0$var$table = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push($7d27d5632f61f2e0$var$tableRow(n, schema));
    });
    return result.join('\n');
};
const $7d27d5632f61f2e0$var$tableRow = (node, schema)=>{
    const result = [];
    const separator = '|';
    node.forEach((n)=>{
        result.push($7d27d5632f61f2e0$var$tableCell(n, schema));
    });
    return `${separator}${result.join(`${separator}`)}${separator}`;
};
const $7d27d5632f61f2e0$var$tableCell = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $iNGf0.reduce)(n, schema));
    });
    return result.join('\n');
};
var $7d27d5632f61f2e0$export$2e2bcd8739ae039 = $7d27d5632f61f2e0$var$table;
module.exports["default"] = $7d27d5632f61f2e0$export$2e2bcd8739ae039;

});

parcelRegister("1BnGB", function(module, exports) {

var $iNGf0 = parcelRequire("iNGf0");

const $763eeae6bd63480d$var$taskItem = (node, schema)=>{
    const result = [];
    let previousNodeType = '';
    const state = node.attrs.state === 'DONE' ? '[x]' : '[]';
    node.forEach((n)=>{
        const text = (0, $iNGf0.reduce)(n, schema);
        if (previousNodeType === 'mention' && !text.startsWith(' ')) result.push(` ${text}`);
        else result.push(text);
        previousNodeType = n.type.name;
    });
    return `${state} ${result.join('').trim()}`;
};
var $763eeae6bd63480d$export$2e2bcd8739ae039 = $763eeae6bd63480d$var$taskItem;
module.exports["default"] = $763eeae6bd63480d$export$2e2bcd8739ae039;

});

parcelRegister("b49IO", function(module, exports) {

var $6FNab = parcelRequire("6FNab");


var $iNGf0 = parcelRequire("iNGf0");

const $f5667c3ba2e27106$var$unknown = (node, schema)=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $iNGf0.reduce)(n, schema));
    });
    if (result.length > 0) return result.join('');
    return (0, $6FNab.getText)(node);
};
var $f5667c3ba2e27106$export$2e2bcd8739ae039 = $f5667c3ba2e27106$var$unknown;
module.exports["default"] = $f5667c3ba2e27106$export$2e2bcd8739ae039;

});

parcelRegister("aBPpS", function(module, exports) {

var $kAkrr = parcelRequire("kAkrr");

const $3f2a6eb3804faee7$export$2cf68c3f3d00fa30 = (html)=>{
    return (0, $kAkrr.parseHTMLTextContent)(html);
};
module.exports["createADFFromHTML"] = $3f2a6eb3804faee7$export$2cf68c3f3d00fa30;

});

parcelRegister("kAkrr", function(module, exports) {

var $4XbfY = parcelRequire("4XbfY");


var $aPdNQ = parcelRequire("aPdNQ");


var $4gUn1 = parcelRequire("4gUn1");

const $e2e8b2ba304667a2$var$domParser = (0, $aPdNQ.DOMParser).fromSchema((0, $4XbfY.defaultSchema));
const $e2e8b2ba304667a2$var$NESTING_RULES = (0, $4gUn1.getNestingRulesFromSchema)();
const $e2e8b2ba304667a2$var$canContainChildren = (nodeType)=>!!$e2e8b2ba304667a2$var$NESTING_RULES[nodeType]?.length;
const $e2e8b2ba304667a2$var$isAllowedChild = (parent, child)=>$e2e8b2ba304667a2$var$NESTING_RULES[parent]?.includes(child) ?? false;
const $e2e8b2ba304667a2$var$shouldApplyMark = (tag)=>$e2e8b2ba304667a2$var$domParser.rules.some((rule)=>'mark' in rule && rule.tag === tag);
const $e2e8b2ba304667a2$var$isBlockElement = (tag)=>$e2e8b2ba304667a2$var$domParser.rules.some((rule)=>rule.tag === tag && rule.node);
const $e2e8b2ba304667a2$var$getMarkTypes = (tags)=>{
    const seen = new Set();
    const marks = [];
    for (const tag of tags){
        const markType = $e2e8b2ba304667a2$var$domParser.rules.find((rule)=>rule.tag === tag)?.mark;
        if (markType && !seen.has(markType)) {
            marks.push({
                type: markType
            });
            seen.add(markType);
        }
    }
    return marks;
};
const $e2e8b2ba304667a2$var$createParagraph = (content = [])=>({
        type: 'paragraph',
        content: content
    });
const $e2e8b2ba304667a2$var$getBlockType = (tag)=>{
    const rule = $e2e8b2ba304667a2$var$domParser.rules.find((r)=>r.tag === tag);
    return rule && 'node' in rule && rule.node ? rule.node : 'paragraph';
};
const $e2e8b2ba304667a2$var$createTextNode = (text, marks)=>{
    const markTypes = $e2e8b2ba304667a2$var$getMarkTypes(marks);
    return {
        type: 'text',
        text: text,
        ...markTypes.length > 0 && {
            marks: markTypes
        }
    };
};
const $e2e8b2ba304667a2$var$addText = (text, marks, content)=>{
    if (text) content.push($e2e8b2ba304667a2$var$createTextNode(text, marks));
};
const $e2e8b2ba304667a2$var$handleBlockElement = (tag, innerContent, marks, blocks, currentParagraphContent, parseNode, nestedContainer)=>{
    // Push any accumulated content as paragraph before block element
    if (currentParagraphContent.length > 0) {
        blocks.push($e2e8b2ba304667a2$var$createParagraph([
            ...currentParagraphContent
        ]));
        currentParagraphContent.length = 0;
    }
    const blockType = $e2e8b2ba304667a2$var$getBlockType(tag);
    const newMarks = $e2e8b2ba304667a2$var$shouldApplyMark(tag) ? [
        ...marks,
        tag
    ] : marks;
    const parentNodeType = nestedContainer?.parentType;
    if (nestedContainer && parentNodeType && $e2e8b2ba304667a2$var$isAllowedChild(parentNodeType, blockType)) {
        const elementContent = [];
        const childNestedContainer = $e2e8b2ba304667a2$var$canContainChildren(blockType) ? {
            parentType: blockType,
            children: elementContent
        } : nestedContainer;
        parseNode(innerContent, newMarks, childNestedContainer);
        if (currentParagraphContent.length > 0) {
            elementContent.push($e2e8b2ba304667a2$var$createParagraph([
                ...currentParagraphContent
            ]));
            currentParagraphContent.length = 0;
        }
        nestedContainer.children.push({
            type: blockType,
            content: elementContent.length > 0 ? elementContent : [
                $e2e8b2ba304667a2$var$createParagraph()
            ]
        });
    } else if ($e2e8b2ba304667a2$var$canContainChildren(blockType)) {
        const children = [];
        parseNode(innerContent, newMarks, {
            parentType: blockType,
            children: children
        });
        blocks.push({
            type: blockType,
            content: children.length > 0 ? children : [
                $e2e8b2ba304667a2$var$createParagraph()
            ]
        });
    } else {
        // Regular block elements
        parseNode(innerContent, newMarks, nestedContainer);
        // Push content generated from block parsing
        if (currentParagraphContent.length > 0) {
            if (blockType === 'paragraph' || blockType === 'codeBlock') blocks.push({
                type: blockType,
                content: [
                    ...currentParagraphContent
                ]
            });
            currentParagraphContent.length = 0;
        }
    }
};
const $e2e8b2ba304667a2$var$handleInlineElement = (tag, innerContent, marks, parseNode, nestedContainer)=>{
    const newMarks = $e2e8b2ba304667a2$var$shouldApplyMark(tag) ? [
        ...marks,
        tag
    ] : marks;
    parseNode(innerContent, newMarks, nestedContainer);
};
const $e2e8b2ba304667a2$export$803b79985c54270a = (html)=>{
    const blocks = [];
    const currentParagraphContent = [];
    // Simple regex-based parser that works in both SSR and browser
    const parseNode = (content, marks = [], nestedContainer)=>{
        // Match HTML tags and text content
        // eslint-disable-next-line require-unicode-regexp
        const tagRegex = /<\s*(\w+)([^>]*)>([\s\S]*?)<\s*\/\s*\1\s*>|([^<]+)/g;
        let match = tagRegex.exec(content);
        while(match !== null){
            if (match[4]) $e2e8b2ba304667a2$var$addText(match[4], marks, currentParagraphContent);
            else {
                // HTML element
                const tag = match[1].toLowerCase();
                const innerContent = match[3];
                if ($e2e8b2ba304667a2$var$isBlockElement(tag)) $e2e8b2ba304667a2$var$handleBlockElement(tag, innerContent, marks, blocks, currentParagraphContent, parseNode, nestedContainer);
                else $e2e8b2ba304667a2$var$handleInlineElement(tag, innerContent, marks, parseNode, nestedContainer);
            }
            match = tagRegex.exec(content);
        }
    };
    parseNode(html);
    // Push any remaining content
    if (currentParagraphContent.length > 0) blocks.push($e2e8b2ba304667a2$var$createParagraph(currentParagraphContent));
    return {
        type: 'doc',
        version: 1,
        content: blocks.length > 0 ? blocks : [
            $e2e8b2ba304667a2$var$createParagraph()
        ]
    };
}; // eslint-disable-next-line @atlaskit/editor/no-re-export
module.exports["parseHTMLTextContent"] = $e2e8b2ba304667a2$export$803b79985c54270a;

});

parcelRegister("4gUn1", function(module, exports) {

var $4XbfY = parcelRequire("4XbfY");

const $b004d3653e7159aa$export$61f8df97ec7cf3 = ()=>{
    const KEYWORDS = [
        'inline',
        'block',
        'text',
        'leaf',
        'group',
        'unsupportedBlock',
        'unsupportedInline'
    ];
    const rules = {};
    for (const nodeType of Object.keys((0, $4XbfY.defaultSchema).nodes)){
        const contentStr = (0, $4XbfY.defaultSchema).nodes[nodeType]?.spec.content;
        if (!contentStr) continue;
        const allowedChildren = // eslint-disable-next-line require-unicode-regexp
        (String(contentStr).match(/\b([a-zA-Z_][a-zA-Z0-9_]*)\b/g) || []).filter((match, index, arr)=>!KEYWORDS.includes(match) && (0, $4XbfY.defaultSchema).nodes[match] && arr.indexOf(match) === index);
        if (allowedChildren.length > 0) rules[nodeType] = allowedChildren;
    }
    return rules;
};
module.exports["getNestingRulesFromSchema"] = $b004d3653e7159aa$export$61f8df97ec7cf3;

});

parcelRegister("dHQOi", function(module, exports) {
const $78331c9b4265087f$export$27903d543b563e39 = (attrs)=>(...content)=>({
            type: 'bodiedExtension',
            attrs: attrs,
            content: content
        });
module.exports["bodiedExtension"] = $78331c9b4265087f$export$27903d543b563e39;

});

parcelRegister("bXh4X", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $5251c9f91178493b$export$d4c72bab9d6cc13a = {
    nudges: [],
    dailyBriefUnread: null,
    isNudgeVisible: false
};
const $5251c9f91178493b$export$e324594224ef24da = {
    setNudges: (nudges)=>({ setState: setState })=>{
            setState({
                nudges: nudges
            });
        },
    setButtonClickedTimestamp: (buttonClickedTimestamp)=>({ setState: setState })=>{
            setState({
                buttonClickedTimestamp: buttonClickedTimestamp
            });
        },
    setDailyBriefUnread: (dailyBriefUnread)=>({ setState: setState })=>{
            setState({
                dailyBriefUnread: dailyBriefUnread
            });
        },
    setIsNudgeVisible: (isNudgeVisible)=>({ setState: setState })=>{
            setState({
                isNudgeVisible: isNudgeVisible
            });
        }
};
const $5251c9f91178493b$export$72552b26ebb37b2 = (0, $8s9DV.createStore)({
    initialState: $5251c9f91178493b$export$d4c72bab9d6cc13a,
    actions: $5251c9f91178493b$export$e324594224ef24da,
    name: 'AISmartButtonStore'
});
const $5251c9f91178493b$export$af36d029992e7a8c = (0, $kBr4q.createActionsHook)($5251c9f91178493b$export$72552b26ebb37b2);
module.exports["AISmartButtonStore"] = $5251c9f91178493b$export$72552b26ebb37b2;
module.exports["useAISmartButtonActions"] = $5251c9f91178493b$export$af36d029992e7a8c;

});

parcelRegister("eToX6", function(module, exports) {
/**
 * Utility functions for detecting and working with preview panels
 */ // Types for preview panel detection
// Preview panel indicators
const $cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS = {
    EMBEDDED_SOURCE: 'embeddedConfluenceSource',
    PREVIEW_PANELS: 'previewPanels',
    CONFLUENCE_PAGE_PREVIEW: 'confluence-page-preview-panel'
};
/**
 * Gets URL search parameters safely
 */ const $cf00e918e2c1556d$var$getUrlSearchParams = (url)=>{
    try {
        return new URLSearchParams(url);
    } catch  {
        return null;
    }
};
const $cf00e918e2c1556d$export$5c3b154013d00c5f = (searchParams)=>{
    return searchParams.has($cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.PREVIEW_PANELS) || searchParams.get($cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.EMBEDDED_SOURCE) === $cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.CONFLUENCE_PAGE_PREVIEW;
};
const $cf00e918e2c1556d$export$cd88bef28d20da33 = ()=>{
    try {
        const currentSearch = window.location.search;
        if (currentSearch) {
            const currentParams = $cf00e918e2c1556d$var$getUrlSearchParams(currentSearch);
            if (currentParams && $cf00e918e2c1556d$export$5c3b154013d00c5f(currentParams)) return true;
        }
        return false;
    } catch  {
        return false;
    }
};
const $cf00e918e2c1556d$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
module.exports["hasPreviewPanelIndicators"] = $cf00e918e2c1556d$export$5c3b154013d00c5f;
module.exports["isInPreviewPanel"] = $cf00e918e2c1556d$export$cd88bef28d20da33;
module.exports["isInIframe"] = $cf00e918e2c1556d$export$9f140ed41af5108c;

});

parcelRegister("jn9ek", function(module, exports) {
const $2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'third party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Edited 1st party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Content created or updated with invalid arguments: Invalid space key specified.' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isExceededRateError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message).includes('rate limit exceeded');
};
const $2f7d9ade7a6b90fb$export$9ae592643c1ef19b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$af33641014b57bba = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$b6b21a057779c53b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError);
};
const $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08 = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isExceededRateError);
};
const $2f7d9ade7a6b90fb$export$69408b85ed2a0e77 = (error)=>{
    if (error && 'graphQLErrors' in error) {
        const originalError = error.graphQLErrors?.[0]?.originalError;
        return originalError?.traceId || '';
    }
    return '';
};
module.exports["isBadThirdPartyBlueprintError"] = $2f7d9ade7a6b90fb$export$9ae592643c1ef19b;
module.exports["isBadEditedFirstPartyBlueprintError"] = $2f7d9ade7a6b90fb$export$af33641014b57bba;
module.exports["isInvalidSpaceKeyError"] = $2f7d9ade7a6b90fb$export$b6b21a057779c53b;
module.exports["isRateExceededError"] = $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08;
module.exports["getTraceIdFromApolloError"] = $2f7d9ade7a6b90fb$export$69408b85ed2a0e77;

});

parcelRegister("lYrp8", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $ftFOj = parcelRequire("ftFOj");

const $c3ac8a024e96d385$export$bffe0f7f3be64e87 = (spaceKey, milestone, options = {})=>{
    const { skip: skip = false } = options;
    const { isSmartFoldersEnabled: isSmartFoldersEnabled, loading: loading } = (0, $ftFOj.useIsSmartFoldersEnabled)(skip ? null : spaceKey);
    if (skip) return {
        isSmartFoldersEnabledForMilestone: false,
        loading: false
    };
    // eslint-disable-next-line confluence-feature-gating/inline-usage
    return {
        isSmartFoldersEnabledForMilestone: isSmartFoldersEnabled && (0, $6mKj3.expVal)('confluence_smart_folders_milestone', 'value', 0) >= milestone,
        loading: loading
    };
};
module.exports["useIsSmartFoldersEnabledForMilestone"] = $c3ac8a024e96d385$export$bffe0f7f3be64e87;

});

parcelRegister("sD2Tz", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $9Vkdl = parcelRequire("9Vkdl");


var $1Gu3g = parcelRequire("1Gu3g");


var $4ri4I = parcelRequire("4ri4I");


var $6mKj3 = parcelRequire("6mKj3");


var $58PBI = parcelRequire("58PBI");

// predictive prefetch only runs in browser environments that expose the API.
// Evaluated lazily (as a function) so that test environments can mock window.matchMedia before it is checked.
const $f75716c2560aeeb6$var$getHasMatchMedia = ()=>typeof window !== 'undefined' && typeof window.matchMedia === 'function'; // Copied from https://foresightjs.com/docs/react/hook
function $f75716c2560aeeb6$var$useForesight(options, enabled) {
    const $ = (0, $bDgLe.c)(5);
    const elementRef = (0, $cozmU.useRef)(null);
    const registerResults = (0, $cozmU.useRef)(null);
    let t0;
    let t1;
    if ($[0] !== enabled || $[1] !== options) {
        t0 = ()=>{
            if (!elementRef.current || !enabled) return;
            if (!$f75716c2560aeeb6$var$getHasMatchMedia()) return;
            (0, $9Vkdl.ForesightManager).initialize({
                enableMousePrediction: true,
                trajectoryPredictionTime: (0, $6mKj3.expVal)("platform_editor_predictive_collabdraft_prefetch", "trajectoryPredictionTime", 120),
                positionHistorySize: 8
            });
            const currentElement = elementRef.current;
            registerResults.current = (0, $9Vkdl.ForesightManager).instance.register({
                element: currentElement,
                ...options
            });
            return ()=>{
                (0, $9Vkdl.ForesightManager).instance?.unregister(currentElement, "useEffect");
            };
        };
        t1 = [
            options,
            enabled
        ];
        $[0] = enabled;
        $[1] = options;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            elementRef: elementRef,
            registerResults: registerResults
        };
        $[4] = t2;
    } else t2 = $[4];
    return t2;
}
const $f75716c2560aeeb6$var$PREFETCH_CLICK_WINDOW_MS = 15000;
const $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents = new Map();
const $f75716c2560aeeb6$var$clearPendingPrefetchAnalytics = (contentId)=>{
    const pendingPrefetch = $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.get(contentId);
    if (pendingPrefetch) {
        clearTimeout(pendingPrefetch.timeoutId);
        $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.delete(contentId);
    }
};
const $f75716c2560aeeb6$var$registerPendingPrefetchAnalytics = ({ contentId: contentId, sendPrefetchAnalyticsEvent: sendPrefetchAnalyticsEvent })=>{
    // If there's an existing pending prefetch event for this content that hasn't
    // resolved or timed out yet, fire a prefetchUnused event for it before
    // replacing it with the new one.
    const pendingPrefetch = $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.get(contentId);
    $f75716c2560aeeb6$var$clearPendingPrefetchAnalytics(contentId);
    if (pendingPrefetch) sendPrefetchAnalyticsEvent('prefetchUnused', contentId, {
        clickWindowMs: $f75716c2560aeeb6$var$PREFETCH_CLICK_WINDOW_MS,
        prefetchSource: 'foresightjs'
    });
    const firedAt = Date.now();
    const timeoutId = setTimeout(()=>{
        const pendingPrefetch = $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.get(contentId);
        if (!pendingPrefetch || pendingPrefetch.firedAt !== firedAt) return;
        $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.delete(contentId);
        sendPrefetchAnalyticsEvent('prefetchUnused', contentId, {
            clickWindowMs: $f75716c2560aeeb6$var$PREFETCH_CLICK_WINDOW_MS,
            prefetchSource: 'foresightjs'
        });
    }, $f75716c2560aeeb6$var$PREFETCH_CLICK_WINDOW_MS);
    $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.set(contentId, {
        firedAt: firedAt,
        timeoutId: timeoutId
    });
};
const $f75716c2560aeeb6$export$545c7ef2fbcc68a6 = (contentId, sendPrefetchAnalyticsEvent)=>{
    const pendingPrefetch = $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.get(contentId);
    if (!pendingPrefetch) return;
    const timeToClickMs = Date.now() - pendingPrefetch.firedAt;
    clearTimeout(pendingPrefetch.timeoutId);
    $f75716c2560aeeb6$var$pendingPrefetchAnalyticsEvents.delete(contentId);
    sendPrefetchAnalyticsEvent('prefetchAndClick', contentId, {
        clickWindowMs: $f75716c2560aeeb6$var$PREFETCH_CLICK_WINDOW_MS,
        prefetchSource: 'foresightjs',
        timeToClickMs: timeToClickMs
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Styling div for hover area only
const $f75716c2560aeeb6$var$HoverAreaWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_kqswh2mm _1tes1bs0 _1kt9b3bt _1cs8stnw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f75716c2560aeeb6$export$93fd4db39a89045f = ({ contentId: contentId, spaceKey: spaceKey, children: children, editSource: editSource, isEmbeddedEditor: isEmbeddedEditor, sendPrefetchAnalyticsEvent: sendPrefetchAnalyticsEvent, predictivelyPrefetch: predictivelyPrefetch })=>{
    const preloader = (0, $cozmU.useContext)((0, $58PBI.EditContentButtonPreloaderContext)); // See packages/confluence-fabric-editor/src/editorPreloader.tsx
    const [doPreload, setDoPreload] = (0, $cozmU.useState)(false);
    const doPreloadRef = (0, $cozmU.useRef)(doPreload);
    const [{ editSource: contextEditSource }, { setEditSource: setEditSource }] = (0, $4ri4I.useEditSource)();
    (0, $cozmU.useEffect)(()=>{
        // Keep the ref in sync with the latest doPreload value so that the function returned by
        // cleanup editorPreloadManager always uses the current doPreload value instead of the one before.
        doPreloadRef.current = doPreload;
    }, [
        doPreload
    ]); // Cleanup editorPreloadManager on contentId change and unmount.
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            $f75716c2560aeeb6$var$clearPendingPrefetchAnalytics(contentId);
            if (doPreloadRef.current) (0, $1Gu3g.EditorPreloadManager).removePreloadedId(contentId);
        };
    }, [
        contentId
    ]); // Register edit-button element with ForesightJS for mouse trajectory prediction
    // Only call useForesight when predictive prefetch is enabled
    const foresightOptions = (0, $cozmU.useMemo)(()=>({
            callback: async ()=>{
                if ((0, $1Gu3g.EditorPreloadManager).shouldPreload(contentId) && predictivelyPrefetch) {
                    setDoPreload(true);
                    setEditSource(editSource);
                    $f75716c2560aeeb6$var$registerPendingPrefetchAnalytics({
                        contentId: contentId,
                        sendPrefetchAnalyticsEvent: sendPrefetchAnalyticsEvent
                    });
                }
            },
            name: `edit-button-${contentId}`,
            reactivateAfter: 15000
        }), [
        contentId,
        editSource,
        setEditSource,
        setDoPreload,
        predictivelyPrefetch,
        sendPrefetchAnalyticsEvent
    ]);
    const { elementRef: elementRef } = $f75716c2560aeeb6$var$useForesight(foresightOptions, predictivelyPrefetch); // On hover callback
    const onHover = (0, $cozmU.useCallback)(async ()=>{
        if ((0, $1Gu3g.EditorPreloadManager).shouldPreload(contentId)) {
            setDoPreload(true);
            setEditSource(editSource);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        editSource
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, (0, $6mKj3.expValEquals)('platform_editor_collabdraft_query_improvements', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f75716c2560aeeb6$var$HoverAreaWrapper, {
        ref: $f75716c2560aeeb6$var$getHasMatchMedia() && predictivelyPrefetch && (0, $6mKj3.expValEquals)('platform_editor_predictive_collabdraft_prefetch', 'isEnabled', true) ? elementRef : null,
        onMouseEnter: $f75716c2560aeeb6$var$getHasMatchMedia() && predictivelyPrefetch && (0, $6mKj3.expValEquals)('platform_editor_predictive_collabdraft_prefetch', 'isEnabled', true) ? undefined : onHover
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        onMouseEnter: onHover,
        onFocus: onHover
    }, children), editSource === contextEditSource && doPreload && preloader ? preloader({
        contentId: contentId,
        spaceKey: spaceKey,
        isEmbeddedEditor: isEmbeddedEditor
    }) : null);
};
module.exports["resolvePendingPrefetchAnalytics"] = $f75716c2560aeeb6$export$545c7ef2fbcc68a6;
module.exports["EditContentButtonPreloader"] = $f75716c2560aeeb6$export$93fd4db39a89045f;

});

parcelRegister("9Vkdl", function(module, exports) {

var $akD6a = parcelRequire("akD6a");

function $73991e0e121001da$var$k() {
    let n = $73991e0e121001da$var$E(), e = $73991e0e121001da$var$L();
    return {
        isTouchDevice: n,
        isLimitedConnection: e,
        shouldRegister: !e
    };
}
function $73991e0e121001da$var$E() {
    return typeof window > "u" || typeof navigator > "u" ? !1 : window.matchMedia("(pointer: coarse)").matches && navigator.maxTouchPoints > 0;
}
function $73991e0e121001da$var$L() {
    let n = navigator.connection;
    if (!n) return !1;
    let e = $73991e0e121001da$export$1435e6a4c843d234.instance.getManagerData.globalSettings.minimumConnectionType, t = [
        "slow-2g",
        "2g",
        "3g",
        "4g"
    ], i = t.indexOf(n.effectiveType), r = t.indexOf(e);
    return i < r || n.saveData;
}
function $73991e0e121001da$var$F(n) {
    if (typeof window > "u" || typeof document > "u") return !1;
    let e = window.innerWidth || document.documentElement.clientWidth, t = window.innerHeight || document.documentElement.clientHeight;
    return n.top < t && n.bottom > 0 && n.left < e && n.right > 0;
}
function $73991e0e121001da$var$T() {
    return {
        mouse: {
            hover: 0,
            trajectory: 0
        },
        tab: {
            forwards: 0,
            reverse: 0
        },
        scroll: {
            down: 0,
            left: 0,
            right: 0,
            up: 0
        },
        touch: 0,
        viewport: 0,
        total: 0
    };
}
function $73991e0e121001da$var$H() {
    return {
        debug: !1,
        enableManagerLogging: !1,
        enableMousePrediction: !0,
        enableScrollPrediction: !0,
        positionHistorySize: 8,
        trajectoryPredictionTime: 120,
        scrollMargin: 150,
        defaultHitSlop: {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
        },
        enableTabPrediction: !0,
        tabOffset: 2,
        touchDeviceStrategy: "onTouchStart",
        minimumConnectionType: "3g"
    };
}
function $73991e0e121001da$var$R(n, e, t) {
    let { element: i, callback: r, hitSlop: o, name: s, meta: c, reactivateAfter: b } = n, d = i.getBoundingClientRect(), a = o ? (0, $akD6a.b)(o) : t;
    return {
        id: e,
        element: i,
        callback: r,
        elementBounds: {
            originalRect: d,
            expandedRect: (0, $akD6a.c)(d, a),
            hitSlop: a
        },
        name: s || i.id || "unnamed",
        isIntersectingWithViewport: $73991e0e121001da$var$F(d),
        registerCount: 1,
        meta: c ?? {},
        callbackInfo: {
            callbackFiredCount: 0,
            lastCallbackInvokedAt: void 0,
            lastCallbackCompletedAt: void 0,
            lastCallbackRuntime: void 0,
            lastCallbackStatus: void 0,
            lastCallbackErrorMessage: void 0,
            reactivateAfter: b ?? 1 / 0,
            isCallbackActive: !0,
            isRunningCallback: !1,
            reactivateTimeoutId: void 0
        }
    };
}
var $73991e0e121001da$var$f = class {
    addEventListener(e, t, i) {
        if (i?.signal?.aborted) return;
        let r = this.eventListeners.get(e) ?? [];
        r.push(t), this.eventListeners.set(e, r), i?.signal?.addEventListener("abort", ()=>this.removeEventListener(e, t));
    }
    removeEventListener(e, t) {
        let i = this.eventListeners.get(e);
        if (!i) return;
        let r = i.indexOf(t);
        r > -1 && i.splice(r, 1);
    }
    emit(e) {
        let t = this.eventListeners.get(e.type);
        if (!(!t || t.length === 0)) for(let i = 0; i < t.length; i++)try {
            let r = t[i];
            r && r(e);
        } catch (r) {
            console.error(`Error in ForesightManager event listener ${i} for ${e.type}:`, r);
        }
    }
    hasListeners(e) {
        let t = this.eventListeners.get(e);
        return t !== void 0 && t.length > 0;
    }
    getEventListeners() {
        return this.eventListeners;
    }
    constructor(){
        this.eventListeners = new Map;
    }
};
function $73991e0e121001da$var$y(n, e) {
    return n !== void 0 && e !== n;
}
var $73991e0e121001da$var$I = {
    trajectoryPredictionTime: {
        min: 10,
        max: 200
    },
    positionHistorySize: {
        min: 2,
        max: 30
    },
    scrollMargin: {
        min: 30,
        max: 300
    },
    tabOffset: {
        min: 0,
        max: 20
    }
};
function $73991e0e121001da$var$h(n, e, t) {
    if (!$73991e0e121001da$var$y(t, n[e])) return !1;
    let { min: i, max: r } = $73991e0e121001da$var$I[e];
    return n[e] = (0, $akD6a.a)(t, i, r, e), !0;
}
function $73991e0e121001da$var$m(n, e, t) {
    return $73991e0e121001da$var$y(t, n[e]) ? (n[e] = t, !0) : !1;
}
function $73991e0e121001da$var$M(n, e) {
    $73991e0e121001da$var$h(n, "trajectoryPredictionTime", e.trajectoryPredictionTime), $73991e0e121001da$var$h(n, "positionHistorySize", e.positionHistorySize), $73991e0e121001da$var$h(n, "scrollMargin", e.scrollMargin), $73991e0e121001da$var$h(n, "tabOffset", e.tabOffset), $73991e0e121001da$var$m(n, "enableMousePrediction", e.enableMousePrediction), $73991e0e121001da$var$m(n, "enableScrollPrediction", e.enableScrollPrediction), $73991e0e121001da$var$m(n, "enableTabPrediction", e.enableTabPrediction), $73991e0e121001da$var$m(n, "enableManagerLogging", e.enableManagerLogging), e.defaultHitSlop !== void 0 && (n.defaultHitSlop = (0, $akD6a.b)(e.defaultHitSlop)), e.touchDeviceStrategy !== void 0 && (n.touchDeviceStrategy = e.touchDeviceStrategy), e.minimumConnectionType !== void 0 && (n.minimumConnectionType = e.minimumConnectionType), e.debug !== void 0 && (n.debug = e.debug);
}
function $73991e0e121001da$var$D(n, e) {
    let t = [], i = !1, r = !1, o = !1, s = !1, c = !1;
    if (!e) return {
        changedSettings: t,
        positionHistorySizeChanged: i,
        scrollPredictionChanged: r,
        tabPredictionChanged: o,
        hitSlopChanged: s,
        touchStrategyChanged: c
    };
    let b = [
        "trajectoryPredictionTime",
        "positionHistorySize",
        "scrollMargin",
        "tabOffset"
    ];
    for (let a of b){
        let l = n[a];
        $73991e0e121001da$var$h(n, a, e[a]) && (t.push({
            setting: a,
            oldValue: l,
            newValue: n[a]
        }), a === "positionHistorySize" && (i = !0));
    }
    let d = [
        "enableMousePrediction",
        "enableScrollPrediction",
        "enableTabPrediction"
    ];
    for (let a of d){
        let l = n[a];
        $73991e0e121001da$var$m(n, a, e[a]) && (t.push({
            setting: a,
            oldValue: l,
            newValue: n[a]
        }), a === "enableScrollPrediction" && (r = !0), a === "enableTabPrediction" && (o = !0));
    }
    if (e.defaultHitSlop !== void 0) {
        let a = n.defaultHitSlop, l = (0, $akD6a.b)(e.defaultHitSlop);
        (0, $akD6a.d)(a, l) || (n.defaultHitSlop = l, t.push({
            setting: "defaultHitSlop",
            oldValue: a,
            newValue: l
        }), s = !0);
    }
    if (e.touchDeviceStrategy !== void 0) {
        let a = n.touchDeviceStrategy;
        n.touchDeviceStrategy = e.touchDeviceStrategy, t.push({
            setting: "touchDeviceStrategy",
            oldValue: a,
            newValue: e.touchDeviceStrategy
        }), c = !0;
    }
    if (e.minimumConnectionType !== void 0) {
        let a = n.minimumConnectionType;
        n.minimumConnectionType = e.minimumConnectionType, t.push({
            setting: "minimumConnectionType",
            oldValue: a,
            newValue: e.minimumConnectionType
        });
    }
    return {
        changedSettings: t,
        positionHistorySizeChanged: i,
        scrollPredictionChanged: r,
        tabPredictionChanged: o,
        hitSlopChanged: s,
        touchStrategyChanged: c
    };
}


var $73991e0e121001da$export$1435e6a4c843d234 = class n {
    async getOrCreateDesktopHandler() {
        if (!this.desktopHandler) {
            let { DesktopHandler: e } = await (parcelRequire("2GQEm"));
            this.desktopHandler = new e(this.handlerDependencies), this.devLog("DesktopHandler lazy loaded");
        }
        return this.desktopHandler;
    }
    async getOrCreateTouchHandler() {
        if (!this.touchDeviceHandler) {
            let { TouchDeviceHandler: e } = await (parcelRequire("4mSfC"));
            this.touchDeviceHandler = new e(this.handlerDependencies), this.devLog("TouchDeviceHandler lazy loaded");
        }
        return this.touchDeviceHandler;
    }
    static initialize(e) {
        return this.isInitiated || (n.manager = new n(e)), n.manager;
    }
    static get isInitiated() {
        return !!n.manager;
    }
    static get instance() {
        return this.initialize();
    }
    generateId() {
        return `foresight-${++this.idCounter}`;
    }
    get isUsingDesktopHandler() {
        return this.currentDeviceStrategy === "mouse" || this.currentDeviceStrategy === "pen";
    }
    addEventListener(e, t, i) {
        this.eventEmitter.addEventListener(e, t, i);
    }
    removeEventListener(e, t) {
        this.eventEmitter.removeEventListener(e, t);
    }
    hasListeners(e) {
        return this.eventEmitter.hasListeners(e);
    }
    get getManagerData() {
        let e = this.desktopHandler?.loadedPredictors, t = this.touchDeviceHandler?.loadedPredictors;
        return {
            registeredElements: this.elements,
            globalSettings: this._globalSettings,
            globalCallbackHits: this._globalCallbackHits,
            eventListeners: this.eventEmitter.getEventListeners(),
            currentDeviceStrategy: this.currentDeviceStrategy,
            activeElementCount: this.activeElementCount,
            loadedModules: {
                desktopHandler: this.desktopHandler !== null,
                touchHandler: this.touchDeviceHandler !== null,
                predictors: {
                    mouse: e?.mouse ?? !1,
                    tab: e?.tab ?? !1,
                    scroll: e?.scroll ?? !1,
                    viewport: t?.viewport ?? !1,
                    touchStart: t?.touchStart ?? !1
                }
            }
        };
    }
    get registeredElements() {
        return this.elements;
    }
    register(e) {
        let { element: t, ...i } = e;
        return t instanceof NodeList ? Array.from(t, (r)=>this.registerElement({
                ...i,
                element: r
            })) : this.registerElement({
            ...i,
            element: t
        });
    }
    registerElement(e) {
        let { isTouchDevice: t, isLimitedConnection: i, shouldRegister: r } = $73991e0e121001da$var$k();
        if (!r) return {
            isLimitedConnection: i,
            isTouchDevice: t,
            isRegistered: !1,
            unregister: ()=>{},
            elementData: null
        };
        let o = this.elements.get(e.element);
        if (o) return o.registerCount++, {
            isLimitedConnection: i,
            isTouchDevice: t,
            isRegistered: !1,
            unregister: ()=>{},
            elementData: null
        };
        this.isSetup || this.initializeGlobalListeners();
        let s = $73991e0e121001da$var$R(e, this.generateId(), this._globalSettings.defaultHitSlop);
        return this.elements.set(e.element, s), this.activeElementCount++, this.updateCheckableStatus(s), this.currentlyActiveHandler?.observeElement(e.element), this.eventEmitter.emit({
            type: "elementRegistered",
            timestamp: Date.now(),
            elementData: s
        }), {
            isTouchDevice: t,
            isLimitedConnection: i,
            isRegistered: !0,
            unregister: ()=>{
                this.unregister(e.element);
            },
            elementData: s
        };
    }
    unregister(e, t) {
        e instanceof NodeList ? e.forEach((i)=>this.unregisterElement(i, t)) : this.unregisterElement(e, t);
    }
    unregisterElement(e, t) {
        let i = this.elements.get(e);
        if (!i) return;
        this.clearReactivateTimeout(i), this.currentlyActiveHandler?.unobserveElement(e), this.elements.delete(e), this.checkableElements.delete(i), i.callbackInfo.isCallbackActive && this.activeElementCount--;
        let r = this.elements.size === 0 && this.isSetup;
        r && (this.devLog("All elements unregistered, removing global listeners"), this.removeGlobalListeners()), this.eventEmitter.emit({
            type: "elementUnregistered",
            elementData: i,
            timestamp: Date.now(),
            unregisterReason: t ?? "by user",
            wasLastRegisteredElement: r
        });
    }
    reactivate(e) {
        e instanceof NodeList ? e.forEach((t)=>this.reactivateElement(t)) : this.reactivateElement(e);
    }
    reactivateElement(e) {
        let t = this.elements.get(e);
        t && (this.isSetup || this.initializeGlobalListeners(), this.clearReactivateTimeout(t), t.callbackInfo.isRunningCallback || (t.callbackInfo.isCallbackActive = !0, this.activeElementCount++, this.updateCheckableStatus(t), this.currentlyActiveHandler?.observeElement(e), this.eventEmitter.emit({
            type: "elementReactivated",
            elementData: t,
            timestamp: Date.now()
        })));
    }
    clearReactivateTimeout(e) {
        clearTimeout(e.callbackInfo.reactivateTimeoutId), e.callbackInfo.reactivateTimeoutId = void 0;
    }
    updateCheckableStatus(e) {
        e.isIntersectingWithViewport && e.callbackInfo.isCallbackActive && !e.callbackInfo.isRunningCallback ? this.checkableElements.add(e) : this.checkableElements.delete(e);
    }
    callCallback(e, t) {
        e.callbackInfo.isRunningCallback || !e.callbackInfo.isCallbackActive || (this.markElementAsRunning(e), this.executeCallbackAsync(e, t));
    }
    markElementAsRunning(e) {
        e.callbackInfo.callbackFiredCount++, e.callbackInfo.lastCallbackInvokedAt = Date.now(), e.callbackInfo.isRunningCallback = !0, this.clearReactivateTimeout(e), this.checkableElements.delete(e);
    }
    async executeCallbackAsync(e, t) {
        this.updateHitCounters(t), this.eventEmitter.emit({
            type: "callbackInvoked",
            timestamp: Date.now(),
            elementData: e,
            hitType: t
        });
        let i = performance.now(), r, o = null;
        try {
            await e.callback(e), r = "success";
        } catch (s) {
            o = s instanceof Error ? s.message : String(s), r = "error", console.error(`Error in callback for element ${e.name}:`, s);
        }
        this.finalizeCallback(e, t, i, r, o);
    }
    finalizeCallback(e, t, i, r, o) {
        e.callbackInfo.lastCallbackCompletedAt = Date.now(), e.callbackInfo.isRunningCallback = !1, e.callbackInfo.isCallbackActive = !1, this.activeElementCount--, this.currentlyActiveHandler?.unobserveElement(e.element), e.callbackInfo.reactivateAfter !== 1 / 0 && (e.callbackInfo.reactivateTimeoutId = setTimeout(()=>{
            this.reactivate(e.element);
        }, e.callbackInfo.reactivateAfter));
        let s = this.activeElementCount === 0;
        s && (this.devLog("All elements unactivated, removing global listeners"), this.removeGlobalListeners()), this.eventEmitter.emit({
            type: "callbackCompleted",
            timestamp: Date.now(),
            elementData: e,
            hitType: t,
            elapsed: e.callbackInfo.lastCallbackRuntime = performance.now() - i,
            status: e.callbackInfo.lastCallbackStatus = r,
            errorMessage: e.callbackInfo.lastCallbackErrorMessage = o,
            wasLastActiveElement: s
        });
    }
    updateHitCounters(e) {
        switch(e.kind){
            case "mouse":
                this._globalCallbackHits.mouse[e.subType]++;
                break;
            case "tab":
                this._globalCallbackHits.tab[e.subType]++;
                break;
            case "scroll":
                this._globalCallbackHits.scroll[e.subType]++;
                break;
            case "touch":
                this._globalCallbackHits.touch++;
                break;
            case "viewport":
                this._globalCallbackHits.viewport++;
                break;
            default:
        }
        this._globalCallbackHits.total++;
    }
    async setDeviceStrategy(e) {
        let t = this.currentDeviceStrategy;
        t !== e && this.devLog(`Switching device strategy from ${t} to ${e}`), this.currentlyActiveHandler?.disconnect(), this.currentlyActiveHandler = e === "mouse" || e === "pen" ? await this.getOrCreateDesktopHandler() : await this.getOrCreateTouchHandler(), this.currentlyActiveHandler.connect();
    }
    initializeGlobalListeners() {
        this.isSetup || typeof document > "u" || (this.devLog("Initializing global listeners (pointermove, MutationObserver)"), this.setDeviceStrategy(this.currentDeviceStrategy), document.addEventListener("pointermove", this.handlePointerMove), this.domObserver = new MutationObserver(this.handleDomMutations), this.domObserver.observe(document.documentElement, {
            childList: !0,
            subtree: !0,
            attributes: !1
        }), this.isSetup = !0);
    }
    removeGlobalListeners() {
        typeof document > "u" || (this.isSetup = !1, this.domObserver?.disconnect(), this.domObserver = null, document.removeEventListener("pointermove", this.handlePointerMove), this.currentlyActiveHandler?.disconnect(), this.rafId && (cancelAnimationFrame(this.rafId), this.rafId = null), this.pendingPointerEvent = null);
    }
    alterGlobalSettings(e) {
        let t = $73991e0e121001da$var$D(this._globalSettings, e);
        t.positionHistorySizeChanged && this.desktopHandler && this.desktopHandler.trajectoryPositions.positions.resize(this._globalSettings.positionHistorySize), t.scrollPredictionChanged && this.isUsingDesktopHandler && this.desktopHandler && (this._globalSettings.enableScrollPrediction ? this.desktopHandler.connectScrollPredictor() : this.desktopHandler.disconnectScrollPredictor()), t.tabPredictionChanged && this.isUsingDesktopHandler && this.desktopHandler && (this._globalSettings.enableTabPrediction ? this.desktopHandler.connectTabPredictor() : this.desktopHandler.disconnectTabPredictor()), t.hitSlopChanged && this.forceUpdateAllElementBounds(), t.touchStrategyChanged && !this.isUsingDesktopHandler && this.touchDeviceHandler && this.touchDeviceHandler.setTouchPredictor(), t.changedSettings.length > 0 && this.eventEmitter.emit({
            type: "managerSettingsChanged",
            timestamp: Date.now(),
            managerData: this.getManagerData,
            updatedSettings: t.changedSettings
        });
    }
    forceUpdateAllElementBounds() {
        for (let e of this.elements.values())e.isIntersectingWithViewport && this.forceUpdateElementBounds(e);
    }
    forceUpdateElementBounds(e) {
        let t = e.element.getBoundingClientRect(), i = (0, $akD6a.c)(t, e.elementBounds.hitSlop);
        if (!(0, $akD6a.d)(i, e.elementBounds.expandedRect)) {
            let r = {
                ...e,
                elementBounds: {
                    ...e.elementBounds,
                    originalRect: t,
                    expandedRect: i
                }
            };
            this.elements.set(e.element, r), this.eventEmitter.emit({
                type: "elementDataUpdated",
                elementData: r,
                updatedProps: [
                    "bounds"
                ]
            });
        }
    }
    devLog(e) {
        this._globalSettings.enableManagerLogging && console.log(`%c\u{1F6E0}\uFE0F ForesightManager: ${e}`, "color: #16a34a; font-weight: bold;");
    }
    constructor(e){
        this.elements = new Map;
        this.checkableElements = new Set;
        this.idCounter = 0;
        this.activeElementCount = 0;
        this.desktopHandler = null;
        this.touchDeviceHandler = null;
        this.currentlyActiveHandler = null;
        this.isSetup = !1;
        this.pendingPointerEvent = null;
        this.rafId = null;
        this.domObserver = null;
        this.currentDeviceStrategy = $73991e0e121001da$var$E() ? "touch" : "mouse";
        this.eventEmitter = new $73991e0e121001da$var$f;
        this._globalCallbackHits = $73991e0e121001da$var$T();
        this._globalSettings = $73991e0e121001da$var$H();
        this.handlePointerMove = (e)=>{
            this.pendingPointerEvent = e, e.pointerType !== this.currentDeviceStrategy && (this.eventEmitter.emit({
                type: "deviceStrategyChanged",
                timestamp: Date.now(),
                newStrategy: e.pointerType,
                oldStrategy: this.currentDeviceStrategy
            }), this.currentDeviceStrategy = e.pointerType, this.setDeviceStrategy(this.currentDeviceStrategy)), !this.rafId && (this.rafId = requestAnimationFrame(()=>{
                if (!this.isUsingDesktopHandler) {
                    this.rafId = null;
                    return;
                }
                this.pendingPointerEvent && this.desktopHandler?.processMouseMovement(this.pendingPointerEvent), this.rafId = null;
            }));
        };
        this.handleDomMutations = (e)=>{
            if (!e.length) return;
            this.desktopHandler?.invalidateTabCache();
            let t = !1;
            for(let i = 0; i < e.length; i++){
                let r = e[i];
                if (r && r.type === "childList" && r.removedNodes.length > 0) {
                    t = !0;
                    break;
                }
            }
            if (t) for (let i of this.elements.keys())i.isConnected || this.unregister(i, "disconnected");
        };
        e !== void 0 && $73991e0e121001da$var$M(this._globalSettings, e), this.handlerDependencies = {
            elements: this.elements,
            callCallback: this.callCallback.bind(this),
            emit: this.eventEmitter.emit.bind(this.eventEmitter),
            hasListeners: this.eventEmitter.hasListeners.bind(this.eventEmitter),
            settings: this._globalSettings
        }, this.devLog(`ForesightManager initialized with device strategy: ${this.currentDeviceStrategy}`), this.initializeGlobalListeners();
    }
};
module.exports["ForesightManager"] = $73991e0e121001da$export$1435e6a4c843d234;

});

parcelRegister("akD6a", function(module, exports) {
function $785a19cc58757094$export$407448d2b89b1813(t, o, e, r) {
    return t < o ? console.warn(`ForesightJS: "${r}" value ${t} is below minimum bound ${o}, clamping to ${o}`) : t > e && console.warn(`ForesightJS: "${r}" value ${t} is above maximum bound ${e}, clamping to ${e}`), Math.min(Math.max(t, o), e);
}
function $785a19cc58757094$export$8b22cf2602fb60ce(t) {
    if (typeof t == "number") {
        let o = $785a19cc58757094$export$407448d2b89b1813(t, 0, 2e3, "hitslop");
        return {
            top: o,
            left: o,
            right: o,
            bottom: o
        };
    }
    return {
        top: $785a19cc58757094$export$407448d2b89b1813(t.top, 0, 2e3, "hitslop - top"),
        left: $785a19cc58757094$export$407448d2b89b1813(t.left, 0, 2e3, "hitslop - left"),
        right: $785a19cc58757094$export$407448d2b89b1813(t.right, 0, 2e3, "hitslop - right"),
        bottom: $785a19cc58757094$export$407448d2b89b1813(t.bottom, 0, 2e3, "hitslop - bottom")
    };
}
function $785a19cc58757094$export$db3b6bfb95261072(t, o) {
    return {
        left: t.left - o.left,
        right: t.right + o.right,
        top: t.top - o.top,
        bottom: t.bottom + o.bottom
    };
}
function $785a19cc58757094$export$4368d992c4eafac0(t, o) {
    return !t || !o ? t === o : t.left === o.left && t.right === o.right && t.top === o.top && t.bottom === o.bottom;
}
function $785a19cc58757094$export$f1e1789686576879(t, o) {
    return t.x >= o.left && t.x <= o.right && t.y >= o.top && t.y <= o.bottom;
}
module.exports["a"] = $785a19cc58757094$export$407448d2b89b1813;
module.exports["b"] = $785a19cc58757094$export$8b22cf2602fb60ce;
module.exports["c"] = $785a19cc58757094$export$db3b6bfb95261072;
module.exports["d"] = $785a19cc58757094$export$4368d992c4eafac0;
module.exports["e"] = $785a19cc58757094$export$f1e1789686576879;

});

parcelRegister("2GQEm", function(module, exports) {

let $1f58583a48d142e6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1f58583a48d142e6$var$load("1gINj").then(()=>parcelRequire('11JE0'));

});

parcelRegister("4mSfC", function(module, exports) {

let $32e34c97c7dd1cf5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $32e34c97c7dd1cf5$var$load("1GVLI").then(()=>parcelRequire('5CVfh'));

});

parcelRegister("1Gu3g", function(module, exports) {
/**
 * Editor Preload Manager
 *
 * A static cache for preloaded contentId's designed to prevent
 * the duplication of preload triggers on any one page during
 * a user's session
 */ class $4fc0e3bf51597bc1$export$369fde9923d909f1 {
    /**
   * Should Preload
   *
   * A mutative lookup to the cache that'll insert the contentId provided
   * if it's not already present. Returns true if the cache did not already
   * contain the provided contentId.
   */ static shouldPreload(contentId) {
        if (this.cache.has(contentId)) return false;
        this.cache.add(contentId);
        return true;
    }
    /**
   * Remove Preloaded ID
   *
   * Removes a contentId from the cache, allowing it to be re-preloaded
   */ static removePreloadedId(contentId) {
        this.cache.delete(contentId);
        this.intentCache.delete(contentId);
    }
    /**
   * Clear
   *
   * Removes all cached contentId's from the cache
   */ static clear() {
        this.cache.clear();
        this.intentCache.clear();
    }
}
$4fc0e3bf51597bc1$export$369fde9923d909f1.cache = new Set();
$4fc0e3bf51597bc1$export$369fde9923d909f1.intentCache = new Set();
module.exports["EditorPreloadManager"] = $4fc0e3bf51597bc1$export$369fde9923d909f1;

});

parcelRegister("58PBI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $037500d910957a1c$var$noop = ()=>null;
const $037500d910957a1c$export$2dc50c54ef05578f = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($037500d910957a1c$var$noop);
$037500d910957a1c$export$2dc50c54ef05578f.displayName = 'EditContentButtonPreloaderContext';
module.exports["EditContentButtonPreloaderContext"] = $037500d910957a1c$export$2dc50c54ef05578f;

});

parcelRegister("k22lL", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $1988df8ccc55d194$export$8cf79fbd47bc14c3 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "wym_j",
    name: "ArchiveUpsellDialog",
    loader: async ()=>(await (parcelRequire("h1yHQ"))).ArchiveUpsellDialog
});
module.exports["ArchiveUpsellDialog"] = $1988df8ccc55d194$export$8cf79fbd47bc14c3;

});

parcelRegister("h1yHQ", function(module, exports) {

let $c64d7399e239c6bf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c64d7399e239c6bf$var$load("fINdN"),
    $c64d7399e239c6bf$var$load("hOaAV"),
    $c64d7399e239c6bf$var$load("cPaXL")
]).then(()=>parcelRequire('v2hhG'));

});

parcelRegister("2WH1B", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2099f9ed78e06b67$export$baebba9f0bb9158 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ptN9P",
    name: "ArchivePagesLoader",
    loader: async ()=>(await (parcelRequire("5MnCM"))).ArchivePagesLoader
});
module.exports["ArchivePagesLoader"] = $2099f9ed78e06b67$export$baebba9f0bb9158;

});

parcelRegister("5MnCM", function(module, exports) {

let $4353c2c39964cdb9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4353c2c39964cdb9$var$load("ddvkk"),
    $4353c2c39964cdb9$var$load("3upHR"),
    $4353c2c39964cdb9$var$load("hZ2FX"),
    $4353c2c39964cdb9$var$load("6wr18"),
    $4353c2c39964cdb9$var$load("dRQ13"),
    $4353c2c39964cdb9$var$load("jyWy1"),
    $4353c2c39964cdb9$var$load("LWh5V"),
    $4353c2c39964cdb9$var$load("kHXvF"),
    $4353c2c39964cdb9$var$load("iWnyc"),
    $4353c2c39964cdb9$var$load("ffEVr"),
    $4353c2c39964cdb9$var$load("Wowvf"),
    $4353c2c39964cdb9$var$load("lbsQO"),
    $4353c2c39964cdb9$var$load("ayJxT"),
    $4353c2c39964cdb9$var$load("hhss7"),
    $4353c2c39964cdb9$var$load("3uux1")
]).then(()=>parcelRequire('iYH6z'));

});

parcelRegister("1AbrA", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $a94896b24fa6d771$export$833a1d1f1b7e4f0f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "MiFff",
    name: "PageQuickActionAutomationMenu",
    loader: async ()=>(await (parcelRequire("g0Fzk"))).PageQuickActionAutomationMenu
});
module.exports["PageQuickActionAutomationMenu"] = $a94896b24fa6d771$export$833a1d1f1b7e4f0f;

});

parcelRegister("g0Fzk", function(module, exports) {

let $ba7ce41f52768ba3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ba7ce41f52768ba3$var$load("7TnhR"),
    $ba7ce41f52768ba3$var$load("iUXaE"),
    $ba7ce41f52768ba3$var$load("lTkx9"),
    $ba7ce41f52768ba3$var$load("1X4na"),
    $ba7ce41f52768ba3$var$load("4xZ5N"),
    $ba7ce41f52768ba3$var$load("kHXvF"),
    $ba7ce41f52768ba3$var$load("iWnyc"),
    $ba7ce41f52768ba3$var$load("Wowvf"),
    $ba7ce41f52768ba3$var$load("eRhBr"),
    $ba7ce41f52768ba3$var$load("7EorR"),
    $ba7ce41f52768ba3$var$load("hhss7"),
    $ba7ce41f52768ba3$var$load("9QyoN")
]).then(()=>parcelRequire('bm1ob'));

});

parcelRegister("6ykQV", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $cf5e0ab73c00afb3$export$25f686fb78162d50 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fmQ7C",
    name: "DeleteNestedPagesActionLoader",
    loader: async ()=>(await (parcelRequire("aM49d"))).DeleteNestedPagesAction
});
module.exports["DeleteNestedPagesActionLoader"] = $cf5e0ab73c00afb3$export$25f686fb78162d50;

});

parcelRegister("aM49d", function(module, exports) {

let $7d819ab2294e61e3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7d819ab2294e61e3$var$load("bYzij"),
    $7d819ab2294e61e3$var$load("iWnyc"),
    $7d819ab2294e61e3$var$load("hZ2FX"),
    $7d819ab2294e61e3$var$load("6wr18"),
    $7d819ab2294e61e3$var$load("33ouG"),
    $7d819ab2294e61e3$var$load("73HOd"),
    $7d819ab2294e61e3$var$load("LWh5V"),
    $7d819ab2294e61e3$var$load("kHXvF"),
    $7d819ab2294e61e3$var$load("ffEVr"),
    $7d819ab2294e61e3$var$load("Wowvf"),
    $7d819ab2294e61e3$var$load("lbsQO"),
    $7d819ab2294e61e3$var$load("ayJxT"),
    $7d819ab2294e61e3$var$load("hhss7"),
    $7d819ab2294e61e3$var$load("9YGIy")
]).then(()=>parcelRequire('9R4ZE'));

});

parcelRegister("5FwhF", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ee4e9cc4db58f73d$export$b3f442789ed34bf1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1MHkm",
    name: "CopyPageTreeDialog",
    loader: async ()=>(await (parcelRequire("e5BFD"))).CopyPageTreeContainer
});
module.exports["CopyPageTreeDialog"] = $ee4e9cc4db58f73d$export$b3f442789ed34bf1;

});

parcelRegister("e5BFD", function(module, exports) {

let $a41ec0ea781b99e5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a41ec0ea781b99e5$var$load("eRhBr"),
    $a41ec0ea781b99e5$var$load("hZ2FX"),
    $a41ec0ea781b99e5$var$load("6wr18"),
    $a41ec0ea781b99e5$var$load("2Tk6L"),
    $a41ec0ea781b99e5$var$load("hxVzR"),
    $a41ec0ea781b99e5$var$load("3BNIx"),
    $a41ec0ea781b99e5$var$load("Tjs4D"),
    $a41ec0ea781b99e5$var$load("dtpmo"),
    $a41ec0ea781b99e5$var$load("grUVf"),
    $a41ec0ea781b99e5$var$load("9pso5"),
    $a41ec0ea781b99e5$var$load("kHXvF"),
    $a41ec0ea781b99e5$var$load("iWnyc"),
    $a41ec0ea781b99e5$var$load("ffEVr"),
    $a41ec0ea781b99e5$var$load("lbsQO"),
    $a41ec0ea781b99e5$var$load("jZMUd"),
    $a41ec0ea781b99e5$var$load("2EIkU"),
    $a41ec0ea781b99e5$var$load("7EorR"),
    $a41ec0ea781b99e5$var$load("Wowvf"),
    $a41ec0ea781b99e5$var$load("hhss7"),
    $a41ec0ea781b99e5$var$load("p4ay7")
]).then(()=>parcelRequire('c7g9a'));

});

parcelRegister("5hAil", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $bavCP = parcelRequire("bavCP");

class $3d8ab1ac7a88b72c$export$9fae4d77e240e114 extends (0, $cozmU.Component) {
    render() {
        const { queryProps: queryProps, children: children } = this.props;
        return this._renderQueryComponent(queryProps, children, 0);
    }
    constructor(..._args){
        super(..._args);
        this._queryResults = [];
        this._queryProperties = [];
        this._anyLoading = ()=>this._queryResults.some((data)=>data.loading === true);
        this._renderQueryComponent = (configArray, children, index)=>{
            if (!configArray.length) return children({
                results: [],
                loading: false
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
                errorPolicy: "all",
                ...configArray[index],
                __callerPackage__: "query-group"
            }, ({ data: data, loading: loading, error: error, ...args })=>{
                this._queryResults[index] = {
                    data: data,
                    loading: loading,
                    error: error
                };
                this._queryProperties[index] = args;
                const nextIndex = index + 1;
                if (configArray.length > nextIndex) return this._renderQueryComponent(configArray, children, nextIndex);
                return children({
                    results: this._queryResults,
                    loading: this._anyLoading(),
                    properties: this._queryProperties
                });
            });
        };
    }
}
$3d8ab1ac7a88b72c$export$9fae4d77e240e114.propTypes = {
    queryProps: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).array.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired
};
module.exports["QueryGroup"] = $3d8ab1ac7a88b72c$export$9fae4d77e240e114;

});

parcelRegister("536md", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $5wHqn = parcelRequire("5wHqn");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");

var $hBYtq = parcelRequire("hBYtq");

var $4aRua = parcelRequire("4aRua");


var $lpNn5 = parcelRequire("lpNn5");


var $bNtJQ = parcelRequire("bNtJQ");


var $iN3XE = parcelRequire("iN3XE");


var $5kxDu = parcelRequire("5kxDu");


var $5uSrW = parcelRequire("5uSrW");

const $b41f6df5eadabeb5$var$styles = {
    base: "_zulp1b66 _2rko12b0 _1e0c116y _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _4cvr1h6o _1bah1h6o _o5724jg8 _1bto1l2s _80om73ad",
    compact: "_4t3igktf",
    expanded: "_4t3i1tcg",
    disabled: "_syaz1gmx _bfhk187o _80om73ad",
    clickable: "_80omtlke",
    red: "_syazi7uo _bfhk1rtt",
    redClickable: "_13ix1rtt _irr3affd _1di61j5a",
    redBold: "_syaz15cr _bfhkuibq",
    redBoldClickable: "_13ixuibq _irr3100f _1di61cl6",
    orange: "_syazi7uo _bfhk1kkj",
    orangeClickable: "_13ix1kkj _irr39mfs _1di6axpp",
    yellow: "_syazi7uo _bfhkibhp",
    yellowClickable: "_13ixibhp _irr3aetg _1di61o1l",
    green: "_syazi7uo _bfhkn729",
    greenClickable: "_13ixn729 _irr33utz _1di6yfny",
    blue: "_syazi7uo _bfhk1dy8",
    blueClickable: "_13ix1dy8 _irr3815t _1di6rwxf",
    teal: "_syazi7uo _bfhk1a17",
    tealClickable: "_13ix1a17 _irr3kwwr _1di61jb0",
    lime: "_syazi7uo _bfhkz2ec",
    limeClickable: "_13ixz2ec _irr31gf0 _1di62kxc",
    purple: "_syazi7uo _bfhkp2ly",
    purpleClickable: "_13ixp2ly _irr3kca2 _1di61jbm",
    grey: "_syazi7uo _bfhkysee",
    greyClickable: "_13ixysee _irr3wejn _1di618ut",
    popup: "_1bsbp2n4"
};
const $b41f6df5eadabeb5$var$DataClassificationLevel = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DataClassificationLevel(t0) {
    const $ = (0, $bDgLe.c)(45);
    const { testId: testId, name: name, tooltip: tooltip, tooltipPosition: tooltipPosition, color: t1, iconSize: t2, guideline: guideline, guidelineADF: guidelineADF, isDisabled: t3, isPopupDisabled: t4, isPopupOpenByDefault: t5, getPopupStateControllers: getPopupStateControllers, popupZIndex: popupZIndex, guidelineRepresentation: t6, onPopupShown: onPopupShown, onPopupClose: onPopupClose, onClick: onClick, renderPopupComponent: renderPopupComponent, popupLabel: popupLabel, popupTitleId: popupTitleId, popupRole: popupRole, popupPlacement: t7, shouldRenderToParent: shouldRenderToParent, isIconOnly: t8, associatedPoliciesCount: associatedPoliciesCount, spacing: t9 } = t0;
    const color = t1 === undefined ? "GREY" : t1;
    const iconSize = t2 === undefined ? "small" : t2;
    const isDisabled = t3 === undefined ? false : t3;
    const isPopupDisabled = t4 === undefined ? false : t4;
    const isPopupOpenByDefault = t5 === undefined ? false : t5;
    const guidelineRepresentation = t6 === undefined ? "PLAIN" : t6;
    const popupPlacement = t7 === undefined ? "bottom-start" : t7;
    const isIconOnlyProp = t8 === undefined ? false : t8;
    const spacing = t9 === undefined ? "default" : t9;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isPopupOpen, setIsPopupOpen] = (0, $cozmU.useState)(isDisabled || isPopupDisabled ? false : isPopupOpenByDefault);
    if (getPopupStateControllers) {
        const getOpenState = ()=>isPopupOpen;
        const setOpenState = (isOpen)=>setIsPopupOpen(isOpen);
        getPopupStateControllers(getOpenState, setOpenState);
    }
    const isMissingName = !name || name.length === 0;
    const isIconOnly = isMissingName || isIconOnlyProp;
    let t10;
    if ($[0] !== associatedPoliciesCount || $[1] !== formatMessage || $[2] !== isMissingName || $[3] !== name) {
        t10 = isMissingName ? "" : associatedPoliciesCount ? name + " " + formatMessage((0, $5uSrW.messages).rules, {
            associatedPoliciesCount: associatedPoliciesCount
        }) : name;
        $[0] = associatedPoliciesCount;
        $[1] = formatMessage;
        $[2] = isMissingName;
        $[3] = name;
        $[4] = t10;
    } else t10 = $[4];
    const nameWithRules = t10;
    const t11 = nameWithRules ?? "";
    let t12;
    if ($[5] !== t11) {
        t12 = t11.substring(0, (0, $iN3XE.nameMaxLength));
        $[5] = t11;
        $[6] = t12;
    } else t12 = $[6];
    const nameTruncated = t12;
    const iconPx = iconSize === "small" ? 12 : iconSize === "medium" ? 18 : iconSize === "large" ? 24 : iconSize === "xlarge" ? 32 : iconSize === "xxlarge" ? 40 : 12;
    let t13;
    if ($[7] !== isDisabled || $[8] !== isMissingName || $[9] !== isPopupDisabled || $[10] !== isPopupOpen || $[11] !== onPopupShown) {
        t13 = ()=>{
            if (isPopupDisabled || isDisabled || isMissingName) return;
            if (onPopupShown) onPopupShown();
            setIsPopupOpen(!isPopupOpen);
        };
        $[7] = isDisabled;
        $[8] = isMissingName;
        $[9] = isPopupDisabled;
        $[10] = isPopupOpen;
        $[11] = onPopupShown;
        $[12] = t13;
    } else t13 = $[12];
    const handleContainerClicked = t13;
    let t14;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = ()=>{
            setIsPopupOpen(false);
        };
        $[13] = t14;
    } else t14 = $[13];
    const closePopup = t14;
    const isClickable = !isPopupDisabled && !isDisabled && !isMissingName;
    let t15;
    if ($[14] !== color || $[15] !== formatMessage || $[16] !== handleContainerClicked || $[17] !== iconPx || $[18] !== isClickable || $[19] !== isDisabled || $[20] !== isIconOnly || $[21] !== name || $[22] !== nameTruncated || $[23] !== onClick || $[24] !== spacing || $[25] !== testId) {
        t15 = (t16)=>{
            const triggerProps = t16 === undefined ? {} : t16;
            const { "aria-expanded": ariaExpanded, ...restProps } = triggerProps;
            const Container = isClickable ? (0, $hBYtq.default) : (0, $iMnC5.default);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Container, {
                role: isClickable ? "button" : "presentation",
                "aria-disabled": isDisabled,
                ...isClickable ? {
                    "aria-label": `${formatMessage((0, $5uSrW.messages).dataClassificationLevel)} - ${name}`
                } : {},
                xcss: (0, $w6R6I.cx)(...[
                    $b41f6df5eadabeb5$var$styles.base,
                    ...!isIconOnly ? [
                        spacing === "expanded" ? $b41f6df5eadabeb5$var$styles.expanded : $b41f6df5eadabeb5$var$styles.compact
                    ] : [],
                    ...isDisabled ? [
                        $b41f6df5eadabeb5$var$styles.disabled
                    ] : [],
                    ...!isDisabled ? [
                        {
                            RED: $b41f6df5eadabeb5$var$styles.red,
                            RED_BOLD: $b41f6df5eadabeb5$var$styles.redBold,
                            ORANGE: $b41f6df5eadabeb5$var$styles.orange,
                            YELLOW: $b41f6df5eadabeb5$var$styles.yellow,
                            GREEN: $b41f6df5eadabeb5$var$styles.green,
                            BLUE: $b41f6df5eadabeb5$var$styles.blue,
                            TEAL: $b41f6df5eadabeb5$var$styles.teal,
                            LIME: $b41f6df5eadabeb5$var$styles.lime,
                            PURPLE: $b41f6df5eadabeb5$var$styles.purple,
                            GREY: $b41f6df5eadabeb5$var$styles.grey
                        }[color]
                    ] : [],
                    ...!isDisabled && isClickable ? [
                        $b41f6df5eadabeb5$var$styles.clickable,
                        {
                            RED: $b41f6df5eadabeb5$var$styles.redClickable,
                            RED_BOLD: $b41f6df5eadabeb5$var$styles.redBoldClickable,
                            ORANGE: $b41f6df5eadabeb5$var$styles.orangeClickable,
                            YELLOW: $b41f6df5eadabeb5$var$styles.yellowClickable,
                            GREEN: $b41f6df5eadabeb5$var$styles.greenClickable,
                            BLUE: $b41f6df5eadabeb5$var$styles.blueClickable,
                            TEAL: $b41f6df5eadabeb5$var$styles.tealClickable,
                            LIME: $b41f6df5eadabeb5$var$styles.limeClickable,
                            PURPLE: $b41f6df5eadabeb5$var$styles.purpleClickable,
                            GREY: $b41f6df5eadabeb5$var$styles.greyClickable
                        }[color]
                    ] : []
                ]),
                testId: testId,
                padding: "space.050",
                onClick: ()=>{
                    if (onClick) onClick();
                    handleContainerClicked();
                },
                ...isClickable ? triggerProps : restProps
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
                justifyContent: "center",
                alignItems: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5kxDu.ClassificationIcon), {
                width: iconPx,
                height: iconPx,
                color: isDisabled ? (0, $iN3XE.disabledColorConfig).iconColor : (0, $iN3XE.colorsConfig)[color].iconColor
            })), !isIconOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
                size: "small",
                maxLines: 1,
                color: color === "RED_BOLD" ? "color.text.inverse" : "color.text",
                testId: "data-classification-level-name"
            }, nameTruncated));
        };
        $[14] = color;
        $[15] = formatMessage;
        $[16] = handleContainerClicked;
        $[17] = iconPx;
        $[18] = isClickable;
        $[19] = isDisabled;
        $[20] = isIconOnly;
        $[21] = name;
        $[22] = nameTruncated;
        $[23] = onClick;
        $[24] = spacing;
        $[25] = testId;
        $[26] = t15;
    } else t15 = $[26];
    const getContainer = t15;
    let t16;
    if ($[27] !== getContainer || $[28] !== guideline || $[29] !== guidelineADF || $[30] !== guidelineRepresentation || $[31] !== isPopupDisabled || $[32] !== isPopupOpen || $[33] !== name || $[34] !== onPopupClose || $[35] !== popupLabel || $[36] !== popupPlacement || $[37] !== popupRole || $[38] !== popupTitleId || $[39] !== popupZIndex || $[40] !== renderPopupComponent || $[41] !== shouldRenderToParent || $[42] !== tooltip || $[43] !== tooltipPosition) {
        t16 = isPopupDisabled ? getContainer() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
            label: popupLabel,
            titleId: popupTitleId,
            role: popupRole,
            shouldRenderToParent: shouldRenderToParent,
            placement: popupPlacement,
            trigger: (triggerProps_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                    content: isPopupOpen ? null : tooltip,
                    hideTooltipOnClick: true,
                    position: tooltipPosition
                }, getContainer(triggerProps_0)),
            content: ()=>renderPopupComponent ? renderPopupComponent(closePopup) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                    padding: "space.250",
                    xcss: $b41f6df5eadabeb5$var$styles.popup,
                    role: "dialog",
                    "aria-labelledby": "data-classification-read-content-name",
                    "aria-describedby": "data-classification-read-content-guideline",
                    "aria-modal": "true"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bNtJQ.ClassificationView), {
                    name: name,
                    guideline: guideline,
                    guidelineADF: guidelineADF,
                    guidelineRepresentation: guidelineRepresentation
                })),
            isOpen: isPopupOpen,
            onClose: ()=>{
                if (onPopupClose) onPopupClose();
                closePopup();
            },
            zIndex: popupZIndex
        });
        $[27] = getContainer;
        $[28] = guideline;
        $[29] = guidelineADF;
        $[30] = guidelineRepresentation;
        $[31] = isPopupDisabled;
        $[32] = isPopupOpen;
        $[33] = name;
        $[34] = onPopupClose;
        $[35] = popupLabel;
        $[36] = popupPlacement;
        $[37] = popupRole;
        $[38] = popupTitleId;
        $[39] = popupZIndex;
        $[40] = renderPopupComponent;
        $[41] = shouldRenderToParent;
        $[42] = tooltip;
        $[43] = tooltipPosition;
        $[44] = t16;
    } else t16 = $[44];
    return t16;
} : function DataClassificationLevel({ testId: testId, name: name, tooltip: tooltip, tooltipPosition: tooltipPosition, color: color = 'GREY', iconSize: iconSize = 'small', guideline: guideline, guidelineADF: guidelineADF, isDisabled: isDisabled = false, isPopupDisabled: isPopupDisabled = false, isPopupOpenByDefault: isPopupOpenByDefault = false, getPopupStateControllers: getPopupStateControllers, popupZIndex: popupZIndex, guidelineRepresentation: guidelineRepresentation = 'PLAIN', onPopupShown: onPopupShown, onPopupClose: onPopupClose, onClick: onClick, renderPopupComponent: renderPopupComponent, popupLabel: popupLabel, popupTitleId: popupTitleId, popupRole: popupRole, popupPlacement: popupPlacement = 'bottom-start', shouldRenderToParent: shouldRenderToParent, isIconOnly: isIconOnlyProp = false, associatedPoliciesCount: associatedPoliciesCount, spacing: spacing = 'default' }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isPopupOpen, setIsPopupOpen] = (0, $cozmU.useState)(isDisabled || isPopupDisabled ? false : isPopupOpenByDefault);
    if (getPopupStateControllers) {
        const getOpenState = ()=>isPopupOpen;
        const setOpenState = (isOpen)=>setIsPopupOpen(isOpen);
        getPopupStateControllers(getOpenState, setOpenState);
    }
    const isMissingName = !name || name.length === 0;
    const isIconOnly = isMissingName || isIconOnlyProp;
    const nameWithRules = isMissingName ? '' : associatedPoliciesCount ? name + ' ' + formatMessage((0, $5uSrW.messages).rules, {
        associatedPoliciesCount: associatedPoliciesCount
    }) : name;
    const nameTruncated = (nameWithRules ?? '').substring(0, (0, $iN3XE.nameMaxLength));
    const iconPx = iconSize === 'small' ? 12 : iconSize === 'medium' ? 18 : iconSize === 'large' ? 24 : iconSize === 'xlarge' ? 32 : iconSize === 'xxlarge' ? 40 : 12;
    const handleContainerClicked = ()=>{
        if (isPopupDisabled || isDisabled || isMissingName) return;
        if (onPopupShown) onPopupShown();
        setIsPopupOpen(!isPopupOpen);
    };
    const closePopup = ()=>{
        setIsPopupOpen(false);
    };
    const isClickable = !isPopupDisabled && !isDisabled && !isMissingName;
    const getContainer = (triggerProps = {})=>{
        // @ts-ignore
        const { 'aria-expanded': ariaExpanded, ...restProps } = triggerProps;
        const Container = isClickable ? (0, $hBYtq.default) : (0, $iMnC5.default);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Container, {
            role: isClickable ? 'button' : 'presentation',
            "aria-disabled": isDisabled,
            ...isClickable ? {
                'aria-label': `${formatMessage((0, $5uSrW.messages).dataClassificationLevel)} - ${name}`
            } : {},
            xcss: (0, $w6R6I.cx)(...[
                $b41f6df5eadabeb5$var$styles.base,
                // Add size styles if not icon only
                ...!isIconOnly ? [
                    spacing === 'expanded' ? $b41f6df5eadabeb5$var$styles.expanded : $b41f6df5eadabeb5$var$styles.compact
                ] : [],
                // Add disabled styles if disabled
                ...isDisabled ? [
                    $b41f6df5eadabeb5$var$styles.disabled
                ] : [],
                // Add color styles
                ...!isDisabled ? [
                    {
                        RED: $b41f6df5eadabeb5$var$styles.red,
                        RED_BOLD: $b41f6df5eadabeb5$var$styles.redBold,
                        ORANGE: $b41f6df5eadabeb5$var$styles.orange,
                        YELLOW: $b41f6df5eadabeb5$var$styles.yellow,
                        GREEN: $b41f6df5eadabeb5$var$styles.green,
                        BLUE: $b41f6df5eadabeb5$var$styles.blue,
                        TEAL: $b41f6df5eadabeb5$var$styles.teal,
                        LIME: $b41f6df5eadabeb5$var$styles.lime,
                        PURPLE: $b41f6df5eadabeb5$var$styles.purple,
                        GREY: $b41f6df5eadabeb5$var$styles.grey
                    }[color]
                ] : [],
                // Add clickable styles if clickable
                ...!isDisabled && isClickable ? [
                    $b41f6df5eadabeb5$var$styles.clickable,
                    {
                        RED: $b41f6df5eadabeb5$var$styles.redClickable,
                        RED_BOLD: $b41f6df5eadabeb5$var$styles.redBoldClickable,
                        ORANGE: $b41f6df5eadabeb5$var$styles.orangeClickable,
                        YELLOW: $b41f6df5eadabeb5$var$styles.yellowClickable,
                        GREEN: $b41f6df5eadabeb5$var$styles.greenClickable,
                        BLUE: $b41f6df5eadabeb5$var$styles.blueClickable,
                        TEAL: $b41f6df5eadabeb5$var$styles.tealClickable,
                        LIME: $b41f6df5eadabeb5$var$styles.limeClickable,
                        PURPLE: $b41f6df5eadabeb5$var$styles.purpleClickable,
                        GREY: $b41f6df5eadabeb5$var$styles.greyClickable
                    }[color]
                ] : []
            ]),
            testId: testId,
            padding: "space.050",
            onClick: ()=>{
                if (onClick) onClick();
                handleContainerClicked();
            },
            ...isClickable ? triggerProps : restProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
            justifyContent: "center",
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5kxDu.ClassificationIcon), {
            width: iconPx,
            height: iconPx,
            color: isDisabled ? (0, $iN3XE.disabledColorConfig).iconColor : (0, $iN3XE.colorsConfig)[color].iconColor
        })), !isIconOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            size: "small",
            maxLines: 1,
            color: color === 'RED_BOLD' ? 'color.text.inverse' : 'color.text',
            testId: "data-classification-level-name"
        }, nameTruncated));
    };
    return isPopupDisabled ? getContainer() : // eslint-disable-next-line @atlaskit/design-system/use-should-render-to-parent
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        label: popupLabel,
        titleId: popupTitleId,
        role: popupRole,
        shouldRenderToParent: shouldRenderToParent,
        placement: popupPlacement,
        trigger: (triggerProps_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                content: isPopupOpen ? null : tooltip,
                hideTooltipOnClick: true,
                position: tooltipPosition
            }, getContainer(triggerProps_0)),
        content: ()=>renderPopupComponent ? renderPopupComponent(closePopup) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                padding: "space.250",
                xcss: $b41f6df5eadabeb5$var$styles.popup,
                role: "dialog",
                "aria-labelledby": "data-classification-read-content-name",
                "aria-describedby": "data-classification-read-content-guideline",
                "aria-modal": "true"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bNtJQ.ClassificationView), {
                name: name,
                guideline: guideline,
                guidelineADF: guidelineADF,
                guidelineRepresentation: guidelineRepresentation
            })),
        isOpen: isPopupOpen,
        onClose: ()=>{
            if (onPopupClose) onPopupClose();
            closePopup();
        },
        zIndex: popupZIndex
    });
};
var $b41f6df5eadabeb5$export$2e2bcd8739ae039 = $b41f6df5eadabeb5$var$DataClassificationLevel;
module.exports["default"] = $b41f6df5eadabeb5$export$2e2bcd8739ae039;

});

parcelRegister("bNtJQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $5HApy = parcelRequire("5HApy");


var $iMnC5 = parcelRequire("iMnC5");


var $3BY7M = parcelRequire("3BY7M");


var $iN3XE = parcelRequire("iN3XE");


var $dAbha = parcelRequire("dAbha");


var $eMflC = parcelRequire("eMflC");

// Maximum height for guideline content to enable scrolling for long text
const $93953b443768a836$var$GUIDELINE_MAX_HEIGHT = '300px'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $93953b443768a836$var$Name = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "h2" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_11c81af2 _syazi7uo",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11c81af2 _syazi7uo",
            __cmplp.className
        ])
    });
});
const $93953b443768a836$var$Guideline = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "p" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_11c8fhey _syazi7uo _o5721jtm _1i4q1hna _c71l1mjv _18m91wug",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11c8fhey _syazi7uo _o5721jtm _1i4q1hna _c71l1mjv _18m91wug",
            __cmplp.className
        ])
    });
});
const $93953b443768a836$var$GuidelineADFContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_c71l1mjv _18m91wug",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_c71l1mjv _18m91wug",
            __cmplp.className
        ])
    });
});
const $93953b443768a836$export$d413367b4cbb5577 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { name: name, guideline: guideline, guidelineADF: guidelineADF, guidelineRepresentation: t1 } = t0;
    const guidelineRepresentation = t1 === undefined ? "PLAIN" : t1;
    const t2 = name ?? "";
    let t3;
    if ($[0] !== t2) {
        t3 = t2.substring(0, (0, $iN3XE.nameMaxLength));
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    const nameTruncated = t3;
    let parsedADF;
    let selectedGuideline;
    let t4;
    if ($[2] !== guideline || $[3] !== guidelineADF || $[4] !== guidelineRepresentation) {
        selectedGuideline = (0, $eMflC.selectGuideline)({
            guidelineADF: guidelineADF,
            guideline: guideline,
            guidelineRepresentation: guidelineRepresentation
        });
        parsedADF = guidelineRepresentation === "EDITOR" ? (0, $dAbha.safeParseGuidelineADF)(selectedGuideline) : undefined;
        t4 = (selectedGuideline ?? "").substring(0, (0, $iN3XE.guidelineMaxLength));
        $[2] = guideline;
        $[3] = guidelineADF;
        $[4] = guidelineRepresentation;
        $[5] = parsedADF;
        $[6] = selectedGuideline;
        $[7] = t4;
    } else {
        parsedADF = $[5];
        selectedGuideline = $[6];
        t4 = $[7];
    }
    const guidelineTruncated = t4;
    let t5;
    if ($[8] !== nameTruncated) {
        t5 = nameTruncated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($93953b443768a836$var$Name, {
            id: "data-classification-read-content-name"
        }, nameTruncated);
        $[8] = nameTruncated;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== guidelineRepresentation || $[11] !== guidelineTruncated || $[12] !== parsedADF || $[13] !== selectedGuideline) {
        t6 = selectedGuideline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            paddingBlockStart: "space.200"
        }, guidelineRepresentation === "PLAIN" || !parsedADF ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($93953b443768a836$var$Guideline, {
            id: "data-classification-read-content-guideline"
        }, guidelineTruncated) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($93953b443768a836$var$GuidelineADFContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
            document: parsedADF
        }))));
        $[10] = guidelineRepresentation;
        $[11] = guidelineTruncated;
        $[12] = parsedADF;
        $[13] = selectedGuideline;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t5 || $[16] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), null, t5, t6);
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : ({ name: name, guideline: guideline, guidelineADF: guidelineADF, guidelineRepresentation: guidelineRepresentation = 'PLAIN' })=>{
    const nameTruncated = (name ?? '').substring(0, (0, $iN3XE.nameMaxLength));
    // Select the appropriate guideline based on guidelineRepresentation
    // Prefers guidelineADF when in EDITOR mode, falls back to guideline
    const selectedGuideline = (0, $eMflC.selectGuideline)({
        guidelineADF: guidelineADF,
        guideline: guideline,
        guidelineRepresentation: guidelineRepresentation
    });
    // Parse ADF if in EDITOR mode - parse before truncation to avoid breaking JSON
    const parsedADF = guidelineRepresentation === 'EDITOR' ? (0, $dAbha.safeParseGuidelineADF)(selectedGuideline) : undefined;
    // Only truncate for plain text mode - ADF content shows full text with scrolling
    const guidelineTruncated = (selectedGuideline ?? '').substring(0, (0, $iN3XE.guidelineMaxLength));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), null, nameTruncated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($93953b443768a836$var$Name, {
        id: "data-classification-read-content-name"
    }, nameTruncated), selectedGuideline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        paddingBlockStart: "space.200"
    }, guidelineRepresentation === 'PLAIN' || !parsedADF ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($93953b443768a836$var$Guideline, {
        id: "data-classification-read-content-guideline"
    }, guidelineTruncated) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($93953b443768a836$var$GuidelineADFContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
        document: parsedADF
    })))));
};
module.exports["ClassificationView"] = $93953b443768a836$export$d413367b4cbb5577;

});

parcelRegister("iN3XE", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $5uSrW = parcelRequire("5uSrW");

const { formatMessage: $9038897dcbdba2ca$var$formatMessage } = (0, $kSwu1.createIntl)({
    locale: 'en'
});
const $9038897dcbdba2ca$export$89b67151eed9295a = {
    definition: $9038897dcbdba2ca$var$formatMessage((0, $5uSrW.messages).noClassification),
    includeIcon: false
};
const $9038897dcbdba2ca$export$5f11f8883714351 = {
    id: 'no-selection',
    name: 'No selection'
};
const $9038897dcbdba2ca$export$253bdad208569777 = 50;
const $9038897dcbdba2ca$export$cbc3cef853d1014b = 1000;
const $9038897dcbdba2ca$export$e1444e5b0a63d793 = 1000;
const $9038897dcbdba2ca$export$fb2992e82b83582a = {
    YELLOW: {
        iconColor: "var(--ds-icon-accent-yellow, #B38600)",
        bgColor: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    ORANGE: {
        iconColor: "var(--ds-icon-accent-orange, #E06C00)",
        bgColor: "var(--ds-background-accent-orange-subtle, #FCA700)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    RED: {
        iconColor: "var(--ds-icon-accent-red, #C9372C)",
        bgColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    RED_BOLD: {
        iconColor: "var(--ds-icon-inverse, #FFFFFF)",
        bgColor: "var(--ds-background-accent-red-bolder, #C9372C)",
        fontColor: "var(--ds-text-inverse, #FFFFFF)"
    },
    PURPLE: {
        iconColor: "var(--ds-icon-accent-purple, #AF59E1)",
        bgColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    BLUE: {
        iconColor: "var(--ds-icon-accent-blue, #357DE8)",
        bgColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    TEAL: {
        iconColor: "var(--ds-icon-accent-teal, #2898BD)",
        bgColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    GREEN: {
        iconColor: "var(--ds-icon-accent-green, #22A06B)",
        bgColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    GREY: {
        iconColor: "var(--ds-icon-accent-gray, #7D818A)",
        bgColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
        fontColor: "var(--ds-text, #292A2E)"
    },
    LIME: {
        iconColor: "var(--ds-icon-accent-lime, #6A9A23)",
        bgColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        fontColor: "var(--ds-text, #292A2E)"
    }
};
const $9038897dcbdba2ca$export$9cdea53b8993b139 = {
    iconColor: "var(--ds-icon-disabled, #080F214A)",
    bgColor: "var(--ds-background-disabled, #0515240F)",
    fontColor: "var(--ds-text-disabled, #080F214A)"
};
module.exports["NO_SELECTION_OPTION"] = $9038897dcbdba2ca$export$5f11f8883714351;
module.exports["nameMaxLength"] = $9038897dcbdba2ca$export$253bdad208569777;
module.exports["guidelineMaxLength"] = $9038897dcbdba2ca$export$e1444e5b0a63d793;
module.exports["colorsConfig"] = $9038897dcbdba2ca$export$fb2992e82b83582a;
module.exports["disabledColorConfig"] = $9038897dcbdba2ca$export$9cdea53b8993b139;

});

parcelRegister("5uSrW", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $3adb11bc26592ffe$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    noClassification: {
        id: "data-classification-level.no-classification",
        defaultMessage: "No classification"
    },
    classifyContent: {
        id: "data-classification-level.edit-popup.classify-content",
        defaultMessage: "Classify content"
    },
    selectClassification: {
        id: "data-classification-level.edit-popup.select-classification",
        defaultMessage: "Select classification"
    },
    updateButton: {
        id: "data-classification-level.edit-popup.update-button",
        defaultMessage: "Update"
    },
    cancelButton: {
        id: "data-classification-level.edit-popup.cancel-button",
        defaultMessage: "Cancel"
    },
    changeLevel: {
        id: "data-classification-level.read-popup.change-level",
        defaultMessage: "Change level"
    },
    rules: {
        id: "data-classification-level.rules",
        defaultMessage: "({associatedPoliciesCount, plural, one {# rule} other {# rules}})"
    },
    dataClassificationLevel: {
        id: "data-classification-level.data-classification-level",
        defaultMessage: "Data classification level"
    },
    dataClassificationLevelDialog: {
        id: "data-classification-level.read-popup.data-classification-level",
        defaultMessage: "Data classification level Dialog"
    },
    classificationLevelGuidelines: {
        id: "data-classification-level.read-popup.heading",
        defaultMessage: "Classification level guidelines"
    },
    sourceAutoClassification: {
        id: "data-classification-level.read-popup.source-auto-classification",
        defaultMessage: "The current classification level is based on information detected in the content. <a>Update classification level</a>"
    },
    sourceUserClassification: {
        id: "data-classification-level.read-popup.source-user-classification",
        defaultMessage: "A user assigned the current classification level. <a>Update classification level</a>"
    },
    sourceSpaceDefaultClassification: {
        id: "data-classification-level.read-popup.source-space-default-classification",
        defaultMessage: "The current classification level is the default for this space. <a>Update classification level</a>"
    },
    sourceOrgDefaultClassification: {
        id: "data-classification-level.read-popup.source-org-default-classification",
        defaultMessage: "The current classification level is the default for your organization. <a>Update classification level</a>"
    },
    sourceNoneClassification: {
        id: "data-classification-level.read-popup.source-none-classification",
        defaultMessage: "<a>Update classification level</a>"
    },
    sourceAutoClassificationUserOverrideDisallow: {
        id: "data-classification-level.read-popup.source-auto-classification-user-override-disallow",
        defaultMessage: "The current classification level is based on information detected in the content. Updates to classification levels aren't permitted."
    },
    sourceUserClassificationUserOverrideDisallow: {
        id: "data-classification-level.read-popup.source-user-classification-user-override-disallow",
        defaultMessage: "A user assigned the current classification level. Updates to classification levels aren't permitted."
    },
    sourceSpaceDefaultClassificationUserOverrideDisallow: {
        id: "data-classification-level.read-popup.source-space-default-classification-user-override-disallow",
        defaultMessage: "The current classification level is the default for this space. Updates to classification levels aren't permitted."
    },
    sourceOrgDefaultClassificationUserOverrideDisallow: {
        id: "data-classification-level.read-popup.source-org-default-classification-user-override-disallow",
        defaultMessage: "The current classification level is the default for your organization. Updates to classification levels aren't permitted."
    },
    sourceNoneClassificationUserOverrideDisallow: {
        id: "data-classification-level.read-popup.source-none-classification-user-override-disallow",
        defaultMessage: "Updates to classification levels aren't permitted."
    },
    sourceAutoClassificationNotContainerAdmin: {
        id: "data-classification-level.read-popup.source-auto-classification-not-container-admin",
        defaultMessage: "The current classification level is based on information detected in the content. Only users who can manage space settings can update the current classification level."
    },
    sourceUserClassificationNotContainerAdmin: {
        id: "data-classification-level.read-popup.source-user-classification-not-container-admin",
        defaultMessage: "A user assigned the current classification level. Only users who can manage space settings can update the current classification level."
    },
    sourceSpaceDefaultClassificationNotContainerAdmin: {
        id: "data-classification-level.read-popup.source-space-default-classification-not-container-admin",
        defaultMessage: "The current classification level is the default for this space. Only users who can manage space settings can update the current classification level."
    },
    sourceOrgDefaultClassificationNotContainerAdmin: {
        id: "data-classification-level.read-popup.source-org-default-classification-not-container-admin",
        defaultMessage: "The current classification level is the default for your organization. Only users who can manage space settings can update the current classification level."
    },
    sourceNoneClassificationNotContainerAdmin: {
        id: "data-classification-level.read-popup.source-none-classification-not-container-admin",
        defaultMessage: "Only users who can manage space settings can update the current classification level."
    },
    assignClassificationLevel: {
        id: "data-classification-level.edit-popup.assign-classification-level",
        defaultMessage: "Assign classification level"
    },
    lowestPermittedLevelOrgDefault: {
        id: "data-classification-level.edit-popup.lowest-permitted-level-org-default",
        defaultMessage: "Classification levels less sensitive than the organization default aren't available."
    },
    lowestPermittedLevelSpaceDefault: {
        id: "data-classification-level.edit-popup.lowest-permitted-level-space-default",
        defaultMessage: "Classification levels less sensitive than the space default aren't available."
    },
    lowestPermittedLevelAutoClassification: {
        id: "data-classification-level.edit-popup.lowest-permitted-level-auto-classification",
        defaultMessage: "Classification levels less sensitive than the level automatically applied aren't available."
    },
    noSelection: {
        id: "data-classification-level.edit-popup.no-selection",
        defaultMessage: "No selection"
    },
    noSelectionDescription: {
        id: "data-classification-level.edit-popup.no-selection-description",
        defaultMessage: "The classification level will be updated based on the default or detected content."
    },
    assignButton: {
        id: "data-classification-level.edit-popup.assign-button",
        defaultMessage: "Assign"
    }
});
module.exports["messages"] = $3adb11bc26592ffe$export$defe85febe8b728c;

});

parcelRegister("dAbha", function(module, exports) {
/**
 * @fileoverview ADF parsing utilities for handling guideline content
 *
 * TODO: Consider extracting these utilities to a shared ADF library once the API is stable.
 * This would benefit other teams dealing with similar ReactRenderer empty content issues.
 */ /**
 * Valid empty ADF document that ComposableEditor can work with
 */ const $70a050e8fd107260$var$EMPTY_ADF_DOCUMENT = {
    version: 1,
    type: 'doc',
    content: []
};
/**
 * Type guard to check if a parsed object is a valid ADF DocNode
 *
 * Performs basic structural validation of ADF documents. This intentionally does not validate
 * the entire ADF content tree, as ReactRenderer will handle that validation during rendering.
 * This approach allows for graceful degradation - if the ADF is invalid at a deeper level,
 * the component will fallback to plain text rendering.
 *
 * @param {unknown} obj - Object to validate
 * @returns {boolean} True if the object has the basic structure of an ADF DocNode
 */ const $70a050e8fd107260$var$isValidADFDocument = (obj)=>{
    if (!obj || typeof obj !== 'object') return false;
    const doc = obj;
    // ADF documents must have type 'doc', version 1, and content array
    // Note: We don't validate the content array items themselves, as ReactRenderer
    // will handle that and provide appropriate error handling
    return doc.type === 'doc' && doc.version === 1 && Array.isArray(doc.content);
};
/**
 * Checks if a text node is empty (no text or only whitespace)
 */ const $70a050e8fd107260$var$isEmptyText = (node)=>{
    if (!node || typeof node !== 'object') return true;
    const textNode = node;
    if (textNode.type !== 'text') return false;
    const text = textNode.text;
    return !text || text.trim().length === 0;
};
/**
 * Checks if a paragraph node is empty (no content or only empty text nodes)
 */ const $70a050e8fd107260$var$isEmptyParagraph = (node)=>{
    if (!node || typeof node !== 'object') return true;
    const paragraph = node;
    if (paragraph.type !== 'paragraph') return false;
    // Paragraph with no content property or empty array
    if (!('content' in paragraph) || !paragraph.content || paragraph.content.length === 0) return true;
    // Paragraph with only empty text nodes
    return paragraph.content.every($70a050e8fd107260$var$isEmptyText);
};
/**
 * Returns true if the given ADF doc is "visually empty".
 *
 * The ReactRenderer shows "Unsupported text" errors when it encounters certain
 * empty content structures that the backend may return (e.g., paragraphs with
 * empty text nodes). This function detects those cases so we can normalize them
 * to a proper empty ADF document, allowing components to gracefully fallback
 * to plain text rendering.
 *
 * Handles canonical empty forms like:
 * - {"version":1,"type":"doc","content":[]}
 * - {"version":1,"type":"doc","content":[{"type":"paragraph"}]}
 * - {"version":1,"type":"doc","content":[{"type":"paragraph","content":[]}]}
 * - {"version":1,"type":"doc","content":[{"type":"paragraph","content":[{"type":"text","text":""}]}]}
 * - And variations where text is only whitespace
 *
 * Note: Only handles single-paragraph empty documents to avoid false positives.
 * More complex documents are passed through for ReactRenderer to handle.
 *
 * @param {DocNode} doc - ADF document to check
 * @returns {boolean} True if the document is visually empty
 */ const $70a050e8fd107260$var$isVisuallyEmptyAdf = (doc)=>{
    // Type guard - should always be valid at this point
    if (!doc || doc.type !== 'doc') return true;
    const content = doc.content ?? [];
    // Empty content array
    if (content.length === 0) return true;
    // Only handle simple single-paragraph case to avoid false positives
    // More complex documents should be handled by ReactRenderer
    if (content.length === 1) return $70a050e8fd107260$var$isEmptyParagraph(content[0]);
    return false;
};
const $70a050e8fd107260$export$caab9411b15d6295 = (guideline)=>{
    if (!guideline) return $70a050e8fd107260$var$EMPTY_ADF_DOCUMENT;
    try {
        const parsed = JSON.parse(guideline);
        if (!$70a050e8fd107260$var$isValidADFDocument(parsed)) return $70a050e8fd107260$var$EMPTY_ADF_DOCUMENT;
        // Check if the ADF is visually empty (would cause renderer errors)
        if ($70a050e8fd107260$var$isVisuallyEmptyAdf(parsed)) return $70a050e8fd107260$var$EMPTY_ADF_DOCUMENT;
        return parsed;
    } catch  {
        return $70a050e8fd107260$var$EMPTY_ADF_DOCUMENT;
    }
};
module.exports["safeParseGuidelineADF"] = $70a050e8fd107260$export$caab9411b15d6295;

});

parcelRegister("eMflC", function(module, exports) {
const $d97b9ff8f7ce91a4$export$1da3a1abbabd0674 = ({ guidelineADF: guidelineADF, guideline: guideline, guidelineRepresentation: guidelineRepresentation })=>{
    if (guidelineRepresentation === 'EDITOR') // Prefer ADF format when in EDITOR mode, fallback to plain text
    // Use nullish coalescing to treat empty strings as valid values
    return guidelineADF ?? guideline;
    // Use plain text guideline for PLAIN mode
    return guideline;
};
module.exports["selectGuideline"] = $d97b9ff8f7ce91a4$export$1da3a1abbabd0674;

});

parcelRegister("5kxDu", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $a2dfd28afe2e79cc$export$d2e14829910b9b7d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { color: color, width: width, height: height } = t0;
    let t1;
    if ($[0] !== color) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.6309 0.724217L10.6368 0.729015L10.6564 0.744926C10.674 0.759116 10.7003 0.780345 10.7346 0.807883C10.8033 0.86297 10.9038 0.94325 11.03 1.04291C11.2825 1.24238 11.637 1.51872 12.0437 1.82565C12.8662 2.44636 13.8693 3.16677 14.6721 3.63718C15.3586 4.03945 16.2922 4.34531 17.1042 4.55315C17.5006 4.65463 17.8498 4.72824 18.0989 4.7763C18.2232 4.80028 18.3219 4.81775 18.3882 4.82904C18.4214 4.83469 18.4464 4.83877 18.4625 4.84135L18.4797 4.84408L18.4828 4.84456C18.9716 4.91866 19.3332 5.33888 19.3332 5.8333C19.3332 11.6129 17.1353 15.5513 14.9124 18.041C13.8065 19.2797 12.6995 20.1547 11.8642 20.7227C11.4461 21.0071 11.0944 21.2155 10.8427 21.3551C10.7168 21.4249 10.6157 21.4775 10.5435 21.5139C10.5074 21.5321 10.4785 21.5462 10.4574 21.5564C10.4469 21.5615 10.4382 21.5655 10.4316 21.5687L10.4231 21.5726L10.4201 21.5741L10.4188 21.5746C10.4183 21.5749 10.4177 21.5751 9.99984 20.6666C9.58193 21.5751 9.58142 21.5749 9.58087 21.5746L9.57961 21.5741L9.57653 21.5726L9.56808 21.5687C9.56477 21.5671 9.56096 21.5653 9.55666 21.5633C9.55235 21.5612 9.54754 21.5589 9.54226 21.5564C9.52113 21.5462 9.49227 21.5321 9.45618 21.5139C9.38402 21.4775 9.2829 21.4249 9.15697 21.3551C8.90523 21.2155 8.55357 21.0071 8.13544 20.7227C7.30013 20.1547 6.19319 19.2797 5.08723 18.041C2.86434 15.5513 0.666504 11.6129 0.666504 5.8333C0.666504 5.56667 0.772986 5.31108 0.962294 5.12331C1.15074 4.9364 1.40573 4.8321 1.67105 4.83331L1.67917 4.83324C1.68856 4.83313 1.70565 4.83282 1.72992 4.832C1.77849 4.83035 1.85559 4.82664 1.9571 4.81831C2.1605 4.80162 2.45966 4.76655 2.82229 4.69315C3.55079 4.5457 4.51413 4.24791 5.47072 3.65142C6.36007 3.09685 7.32664 2.37311 8.08223 1.77725C8.45737 1.48141 8.77527 1.22127 8.99892 1.03546C9.11068 0.942624 9.1987 0.868514 9.25835 0.817986C9.28817 0.792727 9.31088 0.773375 9.3259 0.760538L9.3426 0.74625L9.34728 0.742228C9.7143 0.426181 10.2551 0.418601 10.6309 0.724217ZM2.68698 6.74634C2.9006 11.4629 4.75094 14.6614 6.57911 16.709C7.55649 17.8036 8.53288 18.5744 9.26006 19.0689C9.55402 19.2688 9.80621 19.4228 9.99984 19.5342C10.1935 19.4228 10.4457 19.2688 10.7396 19.0689C11.4668 18.5744 12.4432 17.8036 13.4206 16.709C15.2602 14.6486 17.1222 11.4228 17.3165 6.65758C17.106 6.61216 16.8662 6.55674 16.6082 6.49068C15.741 6.26872 14.5913 5.90791 13.6609 5.36276C12.7521 4.83022 11.6718 4.05063 10.8389 3.42208C10.5278 3.18731 10.2466 2.97006 10.0155 2.78938C9.81835 2.95079 9.58294 3.14086 9.32067 3.34769C8.544 3.96016 7.51057 4.73642 6.52896 5.34851C5.31888 6.10307 4.11556 6.47195 3.21905 6.6534C3.02778 6.69212 2.84951 6.7225 2.68698 6.74634ZM9.99984 20.6666L9.58087 21.5746C9.84611 21.6966 10.1536 21.6966 10.4188 21.5746L9.99984 20.6666Z",
            fill: color
        });
        $[0] = color;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== height || $[3] !== t1 || $[4] !== width) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: width,
            height: height,
            viewBox: "0 0 20 22",
            xmlns: "http://www.w3.org/2000/svg"
        }, t1);
        $[2] = height;
        $[3] = t1;
        $[4] = width;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ color: color, width: width, height: height })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 20 22",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.6309 0.724217L10.6368 0.729015L10.6564 0.744926C10.674 0.759116 10.7003 0.780345 10.7346 0.807883C10.8033 0.86297 10.9038 0.94325 11.03 1.04291C11.2825 1.24238 11.637 1.51872 12.0437 1.82565C12.8662 2.44636 13.8693 3.16677 14.6721 3.63718C15.3586 4.03945 16.2922 4.34531 17.1042 4.55315C17.5006 4.65463 17.8498 4.72824 18.0989 4.7763C18.2232 4.80028 18.3219 4.81775 18.3882 4.82904C18.4214 4.83469 18.4464 4.83877 18.4625 4.84135L18.4797 4.84408L18.4828 4.84456C18.9716 4.91866 19.3332 5.33888 19.3332 5.8333C19.3332 11.6129 17.1353 15.5513 14.9124 18.041C13.8065 19.2797 12.6995 20.1547 11.8642 20.7227C11.4461 21.0071 11.0944 21.2155 10.8427 21.3551C10.7168 21.4249 10.6157 21.4775 10.5435 21.5139C10.5074 21.5321 10.4785 21.5462 10.4574 21.5564C10.4469 21.5615 10.4382 21.5655 10.4316 21.5687L10.4231 21.5726L10.4201 21.5741L10.4188 21.5746C10.4183 21.5749 10.4177 21.5751 9.99984 20.6666C9.58193 21.5751 9.58142 21.5749 9.58087 21.5746L9.57961 21.5741L9.57653 21.5726L9.56808 21.5687C9.56477 21.5671 9.56096 21.5653 9.55666 21.5633C9.55235 21.5612 9.54754 21.5589 9.54226 21.5564C9.52113 21.5462 9.49227 21.5321 9.45618 21.5139C9.38402 21.4775 9.2829 21.4249 9.15697 21.3551C8.90523 21.2155 8.55357 21.0071 8.13544 20.7227C7.30013 20.1547 6.19319 19.2797 5.08723 18.041C2.86434 15.5513 0.666504 11.6129 0.666504 5.8333C0.666504 5.56667 0.772986 5.31108 0.962294 5.12331C1.15074 4.9364 1.40573 4.8321 1.67105 4.83331L1.67917 4.83324C1.68856 4.83313 1.70565 4.83282 1.72992 4.832C1.77849 4.83035 1.85559 4.82664 1.9571 4.81831C2.1605 4.80162 2.45966 4.76655 2.82229 4.69315C3.55079 4.5457 4.51413 4.24791 5.47072 3.65142C6.36007 3.09685 7.32664 2.37311 8.08223 1.77725C8.45737 1.48141 8.77527 1.22127 8.99892 1.03546C9.11068 0.942624 9.1987 0.868514 9.25835 0.817986C9.28817 0.792727 9.31088 0.773375 9.3259 0.760538L9.3426 0.74625L9.34728 0.742228C9.7143 0.426181 10.2551 0.418601 10.6309 0.724217ZM2.68698 6.74634C2.9006 11.4629 4.75094 14.6614 6.57911 16.709C7.55649 17.8036 8.53288 18.5744 9.26006 19.0689C9.55402 19.2688 9.80621 19.4228 9.99984 19.5342C10.1935 19.4228 10.4457 19.2688 10.7396 19.0689C11.4668 18.5744 12.4432 17.8036 13.4206 16.709C15.2602 14.6486 17.1222 11.4228 17.3165 6.65758C17.106 6.61216 16.8662 6.55674 16.6082 6.49068C15.741 6.26872 14.5913 5.90791 13.6609 5.36276C12.7521 4.83022 11.6718 4.05063 10.8389 3.42208C10.5278 3.18731 10.2466 2.97006 10.0155 2.78938C9.81835 2.95079 9.58294 3.14086 9.32067 3.34769C8.544 3.96016 7.51057 4.73642 6.52896 5.34851C5.31888 6.10307 4.11556 6.47195 3.21905 6.6534C3.02778 6.69212 2.84951 6.7225 2.68698 6.74634ZM9.99984 20.6666L9.58087 21.5746C9.84611 21.6966 10.1536 21.6966 10.4188 21.5746L9.99984 20.6666Z",
        fill: color
    }));
};
module.exports["ClassificationIcon"] = $a2dfd28afe2e79cc$export$d2e14829910b9b7d;

});

parcelRegister("jJK3p", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $jyPfN = parcelRequire("jyPfN");


var $cPER9 = parcelRequire("cPER9");


var $4qzKl = parcelRequire("4qzKl");


var $a6t12 = parcelRequire("a6t12");

parcelRequire("5XsiK");
var $lfSOe = parcelRequire("lfSOe");

parcelRequire("dD7ks");
var $4N3op = parcelRequire("4N3op");

const $5c1fbd48d7d200d4$var$linkStyles = (0, $buxP3.xcss)({
    textDecoration: 'underline',
    display: 'inline-block',
    cursor: 'pointer'
});
const $5c1fbd48d7d200d4$var$i18n = (0, $kSwu1.defineMessages)({
    profileLinkName: {
        id: "profile.link.name",
        defaultMessage: "{fullName} profile"
    }
});
const $5c1fbd48d7d200d4$export$a2a4245643e0242b = (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { userId: userId, fullName: fullName, isAnonymous: t1, onUserLinkClick: onUserLinkClick, referralSource: referralSource, className: className, style: style, behavior: t2, position: t3, offset: offset, ariaLabel: ariaLabel, isUnderlinedByDefault: t4 } = t0;
    const isAnonymous = t1 === undefined ? false : t1;
    const behavior = t2 === undefined ? "link" : t2;
    const position = t3 === undefined ? "bottom-start" : t3;
    const isUnderlinedByDefault = t4 === undefined ? true : t4;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const intl = (0, $kSwu1.useIntl)();
    const t5 = userId ?? "";
    let t6;
    if ($[0] !== t5) {
        t6 = {
            type: "USER",
            payload: {
                userId: t5
            }
        };
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    const { href: teamsAppPersonProfileUrl } = (0, $4N3op.useNavigateToTeamsApp)(t6);
    let t7;
    if ($[2] !== ariaLabel || $[3] !== behavior || $[4] !== className || $[5] !== fullName || $[6] !== intl || $[7] !== isAnonymous || $[8] !== isUnderlinedByDefault || $[9] !== offset || $[10] !== onUserLinkClick || $[11] !== position || $[12] !== referralSource || $[13] !== style || $[14] !== teamsAppPersonProfileUrl || $[15] !== userId) {
        t7 = ()=>{
            if (behavior === "card") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: isAnonymous,
                userId: userId,
                position: position,
                offset: offset,
                ariaLabel: ariaLabel
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                style: style,
                xcss: $5c1fbd48d7d200d4$var$linkStyles
            }, fullName));
            else {
                const linkStyle = {
                    ...style,
                    ...isUnderlinedByDefault ? {
                        textDecoration: "underline"
                    } : {}
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cPER9.PeopleLink), {
                    target: "_blank",
                    onClick: onUserLinkClick,
                    href: (0, $lfSOe.isTeamsAppEnabled)() ? teamsAppPersonProfileUrl : (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, referralSource),
                    className: className,
                    style: linkStyle,
                    "data-testid": "profile-link",
                    "aria-label": ariaLabel || intl.formatMessage($5c1fbd48d7d200d4$var$i18n.profileLinkName, {
                        fullName: fullName
                    })
                }, fullName);
            }
        };
        $[2] = ariaLabel;
        $[3] = behavior;
        $[4] = className;
        $[5] = fullName;
        $[6] = intl;
        $[7] = isAnonymous;
        $[8] = isUnderlinedByDefault;
        $[9] = offset;
        $[10] = onUserLinkClick;
        $[11] = position;
        $[12] = referralSource;
        $[13] = style;
        $[14] = teamsAppPersonProfileUrl;
        $[15] = userId;
        $[16] = t7;
    } else t7 = $[16];
    const renderNameComponent = t7;
    let t8;
    if ($[17] !== fullName || $[18] !== hasViewUserProfilePermission || $[19] !== isAnonymous || $[20] !== renderNameComponent || $[21] !== userId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isAnonymous || !userId || userId === "" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "profile.anonymous.name",
            defaultMessage: "Anonymous"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, hasViewUserProfilePermission ? renderNameComponent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, fullName)));
        $[17] = fullName;
        $[18] = hasViewUserProfilePermission;
        $[19] = isAnonymous;
        $[20] = renderNameComponent;
        $[21] = userId;
        $[22] = t8;
    } else t8 = $[22];
    return t8;
};
module.exports["ProfileLink"] = $5c1fbd48d7d200d4$export$a2a4245643e0242b;

});

parcelRegister("cPER9", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $8lYIw = parcelRequire("8lYIw");


var $jlIaF = parcelRequire("jlIaF");

parcelRequire("5XsiK");
var $lfSOe = parcelRequire("lfSOe");

const $6a5a2957e3d32f84$export$43aa0d4f5c176033 = (props)=>{
    const $ = (0, $bDgLe.c)(10);
    let children;
    let href;
    let otherProps;
    let to;
    if ($[0] !== props) {
        ({ href: href, to: to, children: children, ...otherProps } = props);
        $[0] = props;
        $[1] = children;
        $[2] = href;
        $[3] = otherProps;
        $[4] = to;
    } else {
        children = $[1];
        href = $[2];
        otherProps = $[3];
        to = $[4];
    }
    const url = to || href;
    const path = url && url.indexOf("/") !== 0 ? `/${url}` : url;
    const destination = !path.startsWith((0, $jlIaF.CONTEXT_PATH)) ? `${0, $jlIaF.CONTEXT_PATH}${path}` : path;
    const t0 = (0, $lfSOe.isTeamsAppEnabled)() ? url : destination;
    let t1;
    if ($[5] !== children || $[6] !== otherProps || $[7] !== t0 || $[8] !== to) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lYIw.Link), {
            href: t0,
            to: to,
            ...otherProps
        }, children);
        $[5] = children;
        $[6] = otherProps;
        $[7] = t0;
        $[8] = to;
        $[9] = t1;
    } else t1 = $[9];
    return t1;
};
$6a5a2957e3d32f84$export$43aa0d4f5c176033.propTypes = {
    href: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string
};
module.exports["PeopleLink"] = $6a5a2957e3d32f84$export$43aa0d4f5c176033;

});

parcelRegister("6p02T", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4aRua = parcelRequire("4aRua");

const $3cbad44d75de57c9$var$SPECIAL_CHARS_REGEX = /^[!#$%^&*() ,.<>?/[\]_\-+=`~|:;{}\\]+/;
const $3cbad44d75de57c9$export$16c2ab98757b54d6 = (excerpt)=>{
    excerpt = excerpt.trim();
    if (!excerpt) // eslint-disable-next-line @atlaskit/design-system/use-primitives-text -- can't use primitives here
    return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            key: "empty"
        })
    ];
    const beginsWithHighlight = excerpt.slice(0, 8) === '@@@hl@@@';
    const beginsWithUrl = excerpt.slice(0, 4) === 'http' || beginsWithHighlight && excerpt.slice(8, 12) === 'http';
    // Strip leading special characters unless the excerpt begins with a highlight
    if (!beginsWithHighlight) excerpt = excerpt.replace($3cbad44d75de57c9$var$SPECIAL_CHARS_REGEX, '');
    // Add ellipses prefix if beginning of excerpt isn't a URL and begins with a lowercase letter (unbolded or bolded)
    if (!beginsWithUrl && (!beginsWithHighlight && excerpt[0] && excerpt[0] === excerpt[0].toLowerCase() || beginsWithHighlight && excerpt[8] && excerpt[8] === excerpt[8].toLowerCase())) excerpt = '...'.concat(excerpt);
    // Add elipses suffix if excerpt doesn't end with ending punctuation
    if (!excerpt.slice(-1).match(/[.!?]/)) excerpt = excerpt.concat('...');
    // Replace line breaks with seperators
    excerpt = excerpt.replace(/\n+/g, " \xb7 ");
    return $3cbad44d75de57c9$export$b847312d69858d61(excerpt);
};
const $3cbad44d75de57c9$export$b847312d69858d61 = (excerpt)=>{
    const res = [];
    let pre, textMatch;
    let i = 0;
    while(excerpt){
        // @ts-expect-error - TS1501 Typescript 5.9.2 upgrade
        const match = excerpt.match(RegExp("(.*?)@@@hl@@@(.*?)@@@endhl@@@(.*)", "s"));
        if (!match) {
            res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
                key: excerpt
            }, excerpt));
            break;
        }
        [, pre, textMatch, excerpt] = match;
        if (pre) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            key: `pre-${i}`
        }, pre));
        if (textMatch) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            as: "strong",
            key: `textMatch-${i}`
        }, textMatch));
        i++;
    }
    return res;
};
const $3cbad44d75de57c9$export$7512fe8206a7f75b = (text)=>text && text.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
module.exports["processExcerpt"] = $3cbad44d75de57c9$export$16c2ab98757b54d6;
module.exports["enrichExcerpt"] = $3cbad44d75de57c9$export$b847312d69858d61;
module.exports["cleanExcerpt"] = $3cbad44d75de57c9$export$7512fe8206a7f75b;

});

parcelRegister("7NoF3", function(module, exports) {
const $e900dacf455c7c27$export$45d9f22b250b4fa6 = 'PAGE_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$daadd9484abf9243 = 'BLOG_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$18ec89b444ed9e13 = 'SPACE_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$1670e1f700b91982 = 'PAGE_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$99c4be058cda9518 = 'BLOG_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$9a65fbf92be78751 = 'SPACE_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$a5c6eb91dd72e7c0 = 'NAVIGATION_RECENT_DROPDOWN_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$835a97ed77363e2a = 'PAGECARD_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$d8133449fbfd82d4 = 'PAGECARD_DRAFT_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$aca8dbff71ee152b = 'QUICK_ACTIONS_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$3a91fd27464e4cde = 'EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$62ca21e37a92c063 = 'CREATE_PAGE_SHORTCUT';
const $e900dacf455c7c27$export$6eda3121bad7aadf = 'CREATE_NAV_BUTTON_CLICK';
const $e900dacf455c7c27$export$7698b0f9c7cef133 = 'CREATE_PAGETREE_BLOG_BUTTON_CLICK';
const $e900dacf455c7c27$export$d83b4b43e279cde5 = 'CREATE_PAGETREE_CHILDPAGE_BUTTON_CLICK';
const $e900dacf455c7c27$export$1dd5c358458f3c8f = 'CREATE_PAGETREE_PAGE_BUTTON_CLICK';
const $e900dacf455c7c27$export$6e88709afea7d3ed = [
    $e900dacf455c7c27$export$aca8dbff71ee152b,
    $e900dacf455c7c27$export$835a97ed77363e2a,
    $e900dacf455c7c27$export$d8133449fbfd82d4,
    $e900dacf455c7c27$export$a5c6eb91dd72e7c0
];
module.exports["PAGE_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$45d9f22b250b4fa6;
module.exports["BLOG_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$daadd9484abf9243;
module.exports["SPACE_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$18ec89b444ed9e13;
module.exports["PAGE_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$1670e1f700b91982;
module.exports["BLOG_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$99c4be058cda9518;
module.exports["SPACE_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$9a65fbf92be78751;
module.exports["PAGECARD_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$835a97ed77363e2a;
module.exports["QUICK_ACTIONS_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$aca8dbff71ee152b;
module.exports["CREATE_PAGE_SHORTCUT"] = $e900dacf455c7c27$export$62ca21e37a92c063;
module.exports["CREATE_NAV_BUTTON_CLICK"] = $e900dacf455c7c27$export$6eda3121bad7aadf;
module.exports["CREATE_PAGETREE_BLOG_BUTTON_CLICK"] = $e900dacf455c7c27$export$7698b0f9c7cef133;
module.exports["InitialLoadEditSources"] = $e900dacf455c7c27$export$6e88709afea7d3ed;

});

parcelRegister("2cKGu", function(module, exports) {

var $1ggpj = parcelRequire("1ggpj");

const $c721ee7829bb57f5$export$f2c6bba4d41ef211 = (contentType, contentMode)=>{
    // Starring currently doesn't support unpublished drafts (which could be of contentType page or blogpost)
    if (contentMode === 'draft') return false;
    return contentType === 'page' || contentType === 'blogpost' || (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database' || contentType === 'embed' || contentType === 'folder';
};
module.exports["useIsStarringEnabled"] = $c721ee7829bb57f5$export$f2c6bba4d41ef211;

});

parcelRegister("5wA2k", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5qRqQ = parcelRequire("5qRqQ");

const $db92b1048ab2b69e$var$SMART_FOLDER_PROPERTIES_KEY = 'smartFolderProperties';
const $db92b1048ab2b69e$var$DEFAULT_PROVIDER = (0, $5qRqQ.SMART_FOLDER_ROVO_CONNECTOR_PROVIDERS)['google-drive'];
const $db92b1048ab2b69e$var$normalizeProviderName = (name)=>name.trim().toLowerCase().replace(/[^a-z0-9]/g, '');
const $db92b1048ab2b69e$var$providerByContainerApp = {
    [$db92b1048ab2b69e$var$normalizeProviderName('Google Drive')]: 'google-drive',
    [$db92b1048ab2b69e$var$normalizeProviderName('google-drive')]: 'google-drive',
    [$db92b1048ab2b69e$var$normalizeProviderName('google-drive-connector')]: 'google-drive',
    [$db92b1048ab2b69e$var$normalizeProviderName('smartlinks-connector-gdrive')]: 'google-drive',
    [$db92b1048ab2b69e$var$normalizeProviderName('smartlinks-connector-gdrive-rsl')]: 'google-drive',
    [$db92b1048ab2b69e$var$normalizeProviderName('lite-connector-gdrive')]: 'google-drive',
    [$db92b1048ab2b69e$var$normalizeProviderName('SharePoint')]: 'sharepoint',
    [$db92b1048ab2b69e$var$normalizeProviderName('sharepoint')]: 'sharepoint',
    [$db92b1048ab2b69e$var$normalizeProviderName('sharepoint-connector')]: 'sharepoint',
    [$db92b1048ab2b69e$var$normalizeProviderName('smartlinks-connector-sharepoint')]: 'sharepoint',
    [$db92b1048ab2b69e$var$normalizeProviderName('ai-3p-connector:sharepoint-domain')]: 'sharepoint',
    [$db92b1048ab2b69e$var$normalizeProviderName('OneDrive')]: 'onedrive',
    [$db92b1048ab2b69e$var$normalizeProviderName('onedrive')]: 'onedrive',
    [$db92b1048ab2b69e$var$normalizeProviderName('smartlinks-connector-onedrive')]: 'onedrive',
    [$db92b1048ab2b69e$var$normalizeProviderName('onedrive-connector')]: 'onedrive'
};
const $db92b1048ab2b69e$var$rememberedSources = new Map();
const $db92b1048ab2b69e$var$subscribers = new Set();
const $db92b1048ab2b69e$var$subscribe = (callback)=>{
    $db92b1048ab2b69e$var$subscribers.add(callback);
    return ()=>{
        $db92b1048ab2b69e$var$subscribers.delete(callback);
    };
};
const $db92b1048ab2b69e$var$skipSubscribe = ()=>()=>{};
const $db92b1048ab2b69e$var$getSkippedRememberedSource = ()=>undefined;
const $db92b1048ab2b69e$var$notifySubscribers = ()=>{
    $db92b1048ab2b69e$var$subscribers.forEach((callback)=>callback());
};
const $db92b1048ab2b69e$var$getSourceFromProvider = (provider)=>{
    const providerConfig = provider ? (0, $5qRqQ.SMART_FOLDER_ROVO_CONNECTOR_PROVIDERS)[provider] : undefined;
    return provider && providerConfig ? {
        appName: providerConfig.displayName,
        provider: provider
    } : undefined;
};
const $db92b1048ab2b69e$var$getProviderFromContainerAri = (containerAri)=>{
    if (!containerAri) return undefined;
    const normalizedContainerAri = containerAri.toLowerCase();
    if (normalizedContainerAri.includes('microsoft.sharepoint') || normalizedContainerAri.includes(':sharepoint::')) return 'sharepoint';
    if (normalizedContainerAri.includes('microsoft.onedrive') || normalizedContainerAri.includes(':onedrive::')) return 'onedrive';
    if (normalizedContainerAri.includes('google.google-drive') || normalizedContainerAri.includes(':drive::')) return 'google-drive';
    return undefined;
};
const $db92b1048ab2b69e$var$getSourceFromContainerApp = (containerApp)=>$db92b1048ab2b69e$var$getSourceFromProvider(containerApp ? $db92b1048ab2b69e$var$providerByContainerApp[$db92b1048ab2b69e$var$normalizeProviderName(containerApp)] : undefined);
const $db92b1048ab2b69e$var$parseSmartFolderContentProperties = (propertyValue)=>{
    let parsedValue = propertyValue;
    try {
        for(let unwrapCount = 0; unwrapCount < 3; unwrapCount += 1){
            if (typeof parsedValue === 'string') {
                parsedValue = JSON.parse(parsedValue);
                continue;
            }
            if (typeof parsedValue !== 'object' || parsedValue === null) return undefined;
            const contentProperties = parsedValue;
            if (typeof contentProperties.value === 'string' || typeof contentProperties.value === 'object') {
                parsedValue = contentProperties.value;
                continue;
            }
            return contentProperties;
        }
    } catch  {
        return undefined;
    }
    return typeof parsedValue === 'object' && parsedValue !== null ? parsedValue : undefined;
};
const $db92b1048ab2b69e$var$getSourceFromPropertyValue = (propertyValue)=>{
    const parsedValue = $db92b1048ab2b69e$var$parseSmartFolderContentProperties(propertyValue);
    if (!parsedValue) return undefined;
    const containerApp = typeof parsedValue.containerApp === 'string' ? parsedValue.containerApp : typeof parsedValue.appName === 'string' ? parsedValue.appName : undefined;
    const sourceFromContainerApp = $db92b1048ab2b69e$var$getSourceFromContainerApp(containerApp);
    if (sourceFromContainerApp) return sourceFromContainerApp;
    const providerName = typeof parsedValue.provider === 'string' ? parsedValue.provider : undefined;
    const sourceFromProvider = $db92b1048ab2b69e$var$getSourceFromContainerApp(providerName);
    if (sourceFromProvider) return sourceFromProvider;
    const containerAri = typeof parsedValue.containerAri === 'string' ? parsedValue.containerAri : undefined;
    return $db92b1048ab2b69e$var$getSourceFromProvider($db92b1048ab2b69e$var$getProviderFromContainerAri(containerAri));
};
const $db92b1048ab2b69e$var$getSourceFromProperties = (properties)=>{
    const smartFolderProperties = properties?.find((property)=>property?.key === $db92b1048ab2b69e$var$SMART_FOLDER_PROPERTIES_KEY);
    return smartFolderProperties?.value ? $db92b1048ab2b69e$var$getSourceFromPropertyValue(smartFolderProperties.value) : undefined;
};
const $db92b1048ab2b69e$export$91c2322e7dd18830 = ({ containerApp: containerApp, folderId: folderId })=>{
    const source = $db92b1048ab2b69e$var$getSourceFromContainerApp(containerApp);
    if (!source) return;
    $db92b1048ab2b69e$var$rememberedSources.set(folderId, source);
    $db92b1048ab2b69e$var$notifySubscribers();
};
const $db92b1048ab2b69e$export$e09566dabae6f841 = (properties)=>$db92b1048ab2b69e$var$getSourceFromProperties(properties) ?? {
        appName: $db92b1048ab2b69e$var$DEFAULT_PROVIDER.displayName,
        provider: $db92b1048ab2b69e$var$DEFAULT_PROVIDER.provider
    };
const $db92b1048ab2b69e$export$89fe473835f648f3 = (folderId, properties, options = {})=>{
    const { skip: skip = false } = options;
    const rememberedSource = (0, $cozmU.useSyncExternalStore)(skip ? $db92b1048ab2b69e$var$skipSubscribe : $db92b1048ab2b69e$var$subscribe, skip ? $db92b1048ab2b69e$var$getSkippedRememberedSource : ()=>$db92b1048ab2b69e$var$rememberedSources.get(folderId), $db92b1048ab2b69e$var$getSkippedRememberedSource);
    if (skip) return {
        appName: $db92b1048ab2b69e$var$DEFAULT_PROVIDER.displayName,
        provider: $db92b1048ab2b69e$var$DEFAULT_PROVIDER.provider
    };
    return $db92b1048ab2b69e$var$getSourceFromProperties(properties) ?? rememberedSource ?? {
        appName: $db92b1048ab2b69e$var$DEFAULT_PROVIDER.displayName,
        provider: $db92b1048ab2b69e$var$DEFAULT_PROVIDER.provider
    };
};
module.exports["rememberSmartFolderQuickActionSource"] = $db92b1048ab2b69e$export$91c2322e7dd18830;
module.exports["useSmartFolderQuickActionSource"] = $db92b1048ab2b69e$export$89fe473835f648f3;

});

parcelRegister("5qRqQ", function(module, exports) {

var $kL8Rw = parcelRequire("kL8Rw");


var $5FjN6 = parcelRequire("5FjN6");


var $sb73H = parcelRequire("sb73H");

const $f6a7ceb315be4336$export$89232d171c71b6dd = {
    'google-drive': {
        provider: 'google-drive',
        displayName: 'Google Drive',
        connectorNames: [
            'google-drive-connector',
            'smartlinks-connector-gdrive',
            'smartlinks-connector-gdrive-rsl',
            'lite-connector-gdrive'
        ],
        iconSrc: (0, (/*@__PURE__*/$parcel$interopDefault($kL8Rw)))
    },
    sharepoint: {
        provider: 'sharepoint',
        displayName: 'SharePoint',
        connectorNames: [
            'sharepoint-connector',
            'smartlinks-connector-sharepoint',
            'ai-3p-connector:sharepoint-domain'
        ],
        iconSrc: (0, (/*@__PURE__*/$parcel$interopDefault($sb73H)))
    },
    onedrive: {
        provider: 'onedrive',
        displayName: 'OneDrive',
        connectorNames: [
            'smartlinks-connector-onedrive',
            'onedrive-connector'
        ],
        iconSrc: (0, (/*@__PURE__*/$parcel$interopDefault($5FjN6)))
    }
};
module.exports["SMART_FOLDER_ROVO_CONNECTOR_PROVIDERS"] = $f6a7ceb315be4336$export$89232d171c71b6dd;

});

parcelRegister("kL8Rw", function(module, exports) {
module.exports = new URL("google-drive.3a58669c.svg", import.meta.url).toString();

});

parcelRegister("5FjN6", function(module, exports) {
module.exports = new URL("one-drive.20ce6075.svg", import.meta.url).toString();

});

parcelRegister("sb73H", function(module, exports) {
module.exports = new URL("sharepoint.e19b75eb.svg", import.meta.url).toString();

});

parcelRegister("3J7TU", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $684d40bc929501f2$export$edb822e56299b4ef = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rCmOK",
    name: "CopyPageDialog",
    loader: async ()=>(await (parcelRequire("lsYFS"))).CopyPageDialogContainer
});
module.exports["CopyPageDialog"] = $684d40bc929501f2$export$edb822e56299b4ef;

});

parcelRegister("lsYFS", function(module, exports) {

let $fa0b472f906a9764$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fa0b472f906a9764$var$load("6wr18"),
    $fa0b472f906a9764$var$load("Wowvf"),
    $fa0b472f906a9764$var$load("kHXvF"),
    $fa0b472f906a9764$var$load("ffEVr"),
    $fa0b472f906a9764$var$load("hhss7"),
    $fa0b472f906a9764$var$load("aiU5r")
]).then(()=>parcelRequire('dVBJi'));

});

parcelRegister("78wUU", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $745e4e253bb54f50$export$fbea3c6f057d30b6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "epAoB",
    name: "MoveBlogModalLoader",
    loader: async ()=>(await (parcelRequire("1lYHI"))).MoveBlogModal
});
module.exports["MoveBlogModalLoader"] = $745e4e253bb54f50$export$fbea3c6f057d30b6;

});

parcelRegister("1lYHI", function(module, exports) {

let $0fc6d72f3d4ebc0b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0fc6d72f3d4ebc0b$var$load("kFiBp"),
    $0fc6d72f3d4ebc0b$var$load("6wr18"),
    $0fc6d72f3d4ebc0b$var$load("dtpmo"),
    $0fc6d72f3d4ebc0b$var$load("grUVf"),
    $0fc6d72f3d4ebc0b$var$load("4fYzp"),
    $0fc6d72f3d4ebc0b$var$load("ffEVr"),
    $0fc6d72f3d4ebc0b$var$load("Wowvf"),
    $0fc6d72f3d4ebc0b$var$load("hhss7"),
    $0fc6d72f3d4ebc0b$var$load("aoUod")
]).then(()=>parcelRequire('fzGQR'));

});

parcelRegister("iVd6X", function(module, exports) {
var $fd8faec801601310$export$6c1ad2d761708c0b = /*#__PURE__*/ function(PublishPageAsBlogSources) {
    PublishPageAsBlogSources["ViewPage"] = "VIEW_PAGE";
    PublishPageAsBlogSources["EditPage"] = "EDIT_PAGE";
    return PublishPageAsBlogSources;
}({});
module.exports["PublishPageAsBlogSources"] = $fd8faec801601310$export$6c1ad2d761708c0b;

});

parcelRegister("f9jv7", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $b29e4bf652226e80$export$6ccdb59d3479f4f1 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '404');
module.exports["isNotFoundError"] = $b29e4bf652226e80$export$6ccdb59d3479f4f1;

});

parcelRegister("lu0E4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hXDOc = parcelRequire("hXDOc");


var $8G1o2 = parcelRequire("8G1o2");


var $dLX9a = parcelRequire("dLX9a");

const $d97c0945857481ee$export$8bc1bc0080a813ff = ({ isPublish: isPublish, contentId: contentId, spaceKey: spaceKey, contentType: contentType, isUnpublishedDraft: isUnpublishedDraft, children: children })=>{
    const breadcrumbs = (0, $8G1o2.useEditorBreadcrumbs)(contentId);
    const publishPreloadUrl = (0, $dLX9a.getPublishPreloadUrl)({
        contentId: contentId,
        spaceKey: spaceKey,
        contentType: contentType
    });
    const closePreloadUrl = (0, $cozmU.useMemo)(()=>{
        if (!breadcrumbs || breadcrumbs.length === 0) return '';
        return (0, $dLX9a.getClosePreloadUrl)({
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: contentType,
            breadcrumbs: breadcrumbs,
            isUnpublishedDraft: isUnpublishedDraft
        });
    }, [
        contentId,
        spaceKey,
        contentType,
        isUnpublishedDraft,
        breadcrumbs
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hXDOc.HoverPreloader), {
        name: "preload-button-wrapper",
        preloadUrl: isPublish ? publishPreloadUrl : closePreloadUrl,
        preloadOptions: (0, $hXDOc.PreloadingPresets).everything
    }, children);
};
module.exports["PreloadButtonWrapper"] = $d97c0945857481ee$export$8bc1bc0080a813ff;

});

parcelRegister("8G1o2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8WndG = parcelRequire("8WndG");


var $eitcW = parcelRequire("eitcW");

function $4afe25e74c0897d4$export$af6ae8f81a672789(contentId) {
    const { data: data, error: error } = (0, $eitcW.useExperimentalEditorBreadcrumbsQuery)({
        variables: {
            contentId: contentId
        },
        skip: !contentId
    });
    return (0, $cozmU.useMemo)(()=>{
        return (0, $8WndG.handleEditorBreadcrumbsQueryResult)(data, error);
    }, [
        data,
        error
    ]);
}
module.exports["useEditorBreadcrumbs"] = $4afe25e74c0897d4$export$af6ae8f81a672789;

});

parcelRegister("8WndG", function(module, exports) {

var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $6fil2 = parcelRequire("6fil2");

function $808c5ea5e28dcdc3$export$ba755fc0ebb98c2(data, error) {
    if (error) {
        if ((0, $6fil2.containsNetworkError)(error) || (0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        else (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
    }
    return data?.experimentalEditorBreadcrumbs?.breadcrumbs || [];
}
module.exports["handleEditorBreadcrumbsQueryResult"] = $808c5ea5e28dcdc3$export$ba755fc0ebb98c2;

});

parcelRegister("eitcW", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $aBfpe = parcelRequire("aBfpe");

const $5d9a3cd7c3da867c$export$dbbd3a7f70eb1e5d = ({ variables: variables, skip: skip, onError: onError })=>{
    const { contentId: contentId } = variables;
    return (0, $dK51B.useExperimentalQuery)({
        url: `/wiki/pages/breadcrumb.action?pageId=${contentId}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResult: (json, _variables)=>{
            if (!contentId) throw new Error('contentId is missing.');
            return {
                experimentalEditorBreadcrumbs: {
                    breadcrumbs: json?.breadcrumbs || null
                }
            };
        },
        skip: skip,
        variables: variables,
        onError: onError
    });
};
module.exports["useExperimentalEditorBreadcrumbsQuery"] = $5d9a3cd7c3da867c$export$dbbd3a7f70eb1e5d;

});

parcelRegister("dLX9a", function(module, exports) {

var $cb6fO = parcelRequire("cb6fO");


var $cEgMD = parcelRequire("cEgMD");


var $1NBp8 = parcelRequire("1NBp8");


var $dqLea = parcelRequire("dqLea");

const $89342ddee4389e57$export$9d5b76aa7bb3f492 = ({ contentId: contentId, spaceKey: spaceKey, contentType: contentType })=>{
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return (0, $1NBp8.COMPANY_HUB).toUrl();
    const path = `${(0, $cb6fO.getSpaceLink)(spaceKey, contentType === 'page' ? 'pages' : 'blog')}/${contentId}`;
    return path;
};
const $89342ddee4389e57$export$5906c3344719ad0e = ({ contentId: contentId, spaceKey: spaceKey, contentType: contentType, breadcrumbs: breadcrumbs, isUnpublishedDraft: isUnpublishedDraft })=>{
    let url = (0, $1NBp8.HOME).toUrl();
    if (isUnpublishedDraft) {
        if (contentType === 'page') // Draft page -> redirect to closest published parent view page
        {
            if (breadcrumbs) {
                url = (0, $dqLea.getNearestVisibleAncestor)({
                    breadcrumbs: breadcrumbs,
                    fallbackUrl: url
                });
                // if the parent is a folder, redirect to the space overview
                if ((0, $1NBp8.FOLDER_VIEW).match(url)) url = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
                    spaceKey: spaceKey
                });
            }
        } else // Draft blog -> redirect to space index page
        url = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
            spaceKey: spaceKey
        });
    } else // this part executes when closing the edit section for a previously/already published page
    // we can do a lil hack here to avoid making a query.
    // the router will prettify our route with slug (& posting date for blogs) for us
    url = $89342ddee4389e57$export$9d5b76aa7bb3f492({
        contentId: contentId,
        spaceKey: spaceKey,
        contentType: contentType
    });
    return url;
};
module.exports["getPublishPreloadUrl"] = $89342ddee4389e57$export$9d5b76aa7bb3f492;
module.exports["getClosePreloadUrl"] = $89342ddee4389e57$export$5906c3344719ad0e;

});

parcelRegister("dqLea", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $af9bcbfa18f4b3b2$export$ebca4fecfc3d5dab = ({ breadcrumbs: breadcrumbs, fallbackUrl: fallbackUrl })=>{
    let url = fallbackUrl;
    // Loop through all breadcrumbs from bottom up and find the first view page url
    if (breadcrumbs) for(let index = breadcrumbs.length - 1; index >= 0; index--){
        const crumb = breadcrumbs[index];
        const ancestorUrl = crumb?.url;
        if (ancestorUrl && !(0, $1NBp8.RESUME_DRAFT_LEGACY).match(ancestorUrl)) {
            url = ancestorUrl;
            break;
        }
    }
    return url;
};
module.exports["getNearestVisibleAncestor"] = $af9bcbfa18f4b3b2$export$ebca4fecfc3d5dab;

});

parcelRegister("24amZ", function(module, exports) {
var $0096831e5a63492d$export$b21a3980a7aad169 = /*#__PURE__*/ function(InlineCommentFramework) {
    InlineCommentFramework["BACKBONE"] = "backbone";
    InlineCommentFramework["REACT"] = "react";
    InlineCommentFramework["ANNOTATION_PROVIDER"] = "annotation-provider";
    return InlineCommentFramework;
}({});
module.exports["InlineCommentFramework"] = $0096831e5a63492d$export$b21a3980a7aad169;

});

parcelRegister("6hmtW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $83FW4 = parcelRequire("83FW4");


var $jil6p = parcelRequire("jil6p");

const $99a81cd20c880202$export$1cacdacf9568d373 = ()=>{
    const context = (0, $cozmU.useContext)((0, $83FW4.CommentContext));
    const memoizedCommentService = (0, $cozmU.useMemo)(()=>new (0, $jil6p.ContentTypesCommentService)(), []);
    if (!context) return {
        commentService: (0, $6mKj3.expValEquals)('cc_fe_performance_page_comments_stability', 'cohort', 'experiment') ? memoizedCommentService : new (0, $jil6p.ContentTypesCommentService)()
    };
    return context;
};
module.exports["useCommentService"] = $99a81cd20c880202$export$1cacdacf9568d373;

});

parcelRegister("83FW4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jil6p = parcelRequire("jil6p");

const $c63b34a18b0f8af5$export$f70cbd0dcaa225fc = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $c63b34a18b0f8af5$export$71e478688b05b68d = ({ children: children })=>{
    const commentService = (0, $cozmU.useRef)(new (0, $jil6p.ContentTypesCommentService)()).current;
    (0, $cozmU.useEffect)(()=>{
        // Cleanup on unmount
        return ()=>{
            commentService.dispose();
        };
    }, [
        commentService
    ]);
    const handleSelectThread = (0, $cozmU.useCallback)((threadId)=>{
        commentService.selectCommentThread(threadId);
    }, [
        commentService
    ]);
    (0, $cozmU.useEffect)(()=>{
        commentService.registerSelectThreadHandler(handleSelectThread);
        return ()=>{
            // un-set the handler on component unmount
            commentService.registerSelectThreadHandler(undefined);
        };
    }, [
        commentService,
        handleSelectThread
    ]);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            commentService: commentService
        }), [
        commentService
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c63b34a18b0f8af5$export$f70cbd0dcaa225fc.Provider, {
        value: contextValue
    }, children);
};
module.exports["CommentContext"] = $c63b34a18b0f8af5$export$f70cbd0dcaa225fc;
module.exports["CommentProvider"] = $c63b34a18b0f8af5$export$71e478688b05b68d;

});

parcelRegister("jil6p", function(module, exports) {
class $569106325e18c3c1$export$6c0a8b19f951b1bc {
    dispose() {
        this.selectThreadHandler = undefined;
        this.reopenResolvedCommentHandler = undefined;
        this.showPanelHandler = undefined;
        this.selectCommentThreadHandler = undefined;
        this.hidePanelHandler = undefined;
        this.onCreateCommentHandler = undefined;
        this.onDeleteCommentHandler = undefined;
        this.triggerCommentPanelRefreshHandler = undefined;
        this.onUpdateCommentHandler = undefined;
        this.onResolveCommentHandler = undefined;
        this.onUpdateReactionHandler = undefined;
        this.onUpdateUnreadCommentsHandler = undefined;
        this.triggerReadStatusCommentHandler = undefined;
    }
    /**
   * Register a handler for thread selection events
   */ registerSelectThreadHandler(handler) {
        this.selectThreadHandler = handler;
    }
    /**
   * Handle thread selection events
   */ handleSelectThread(threadId) {
        this.selectThreadHandler?.(threadId);
    }
    /**
   * Register a handler for show panel events
   */ registerShowPanelHandler(handler) {
        this.showPanelHandler = handler;
    }
    /**
   * Show the comments panel
   */ showPanel(threadId) {
        this.showPanelHandler?.(threadId);
    }
    /**
   * Register a handler for hide panel events
   */ registerHidePanelHandler(handler) {
        this.hidePanelHandler = handler;
    }
    /**
   * Hide the comments panel
   */ hidePanel() {
        this.hidePanelHandler?.();
    }
    /**
   * Register a handler for select comment thread events
   */ registerSelectCommentThreadHandler(handler) {
        this.selectCommentThreadHandler = handler;
    }
    /**
   * Select a specific comment thread
   */ selectCommentThread(threadId) {
        this.selectCommentThreadHandler?.(threadId);
    }
    /**
   * This is called in databases to register the callback confluence FE
   * will call after a resolved comment has been reopened
   */ registerOnReopenResolvedComment(callback) {
        this.reopenResolvedCommentHandler = callback;
    }
    /**
   * This will be called in confluence FE after we have successfully
   * reopened a resolved comment. This allows databases to re-fetch and re-render
   * the comment
   */ onReopenResolvedComment(commentIds) {
        this.reopenResolvedCommentHandler?.(commentIds);
    }
    /**
   * Register a handler for create comment events (called by content types).
   * Canvas registers this so it can be notified when a new top-level comment
   * is created inside the Confluence comments panel.
   */ registerOnCreateComment(callback) {
        this.onCreateCommentHandler = callback;
    }
    /**
   * Handle a create comment event (fired by CFE after a new comment is saved
   * in the comments panel).  This allows Canvas to sync the new comment to
   * other collaborators.
   */ onCreateComment(threadKey) {
        this.onCreateCommentHandler?.(threadKey);
    }
    /**
   * Register a handler for delete comment events (called by content types)
   */ registerOnDeleteComment(callback) {
        this.onDeleteCommentHandler = callback;
    }
    /**
   * Handle a delete comment event (fired by CF)
   */ onDeleteComment(threadKey) {
        this.onDeleteCommentHandler?.(threadKey);
    }
    /**
   * Register a handler for update comment events (called by content types)
   */ registerOnUpdateComment(callback) {
        this.onUpdateCommentHandler = callback;
    }
    /**
   * Handle an update comment event (fired by CF)
   * @param threadKey - The thread key of the comment
   * @param actionType - Optional action type: 'reply' for new replies, 'edit' for comment edits
   */ onUpdateComment(threadKey, actionType) {
        this.onUpdateCommentHandler?.(threadKey, actionType);
    }
    /**
   * Register a handler for trigger comment panel refresh events (called by content types)
   */ registerTriggerCommentPanelRefresh(handler) {
        this.triggerCommentPanelRefreshHandler = handler;
        // If a refresh was requested while no handler was registered, trigger it now
        // so the newly mounted view refetches immediately.
        if (handler && this.hasPendingCommentPanelRefresh) {
            this.hasPendingCommentPanelRefresh = false;
            handler();
        }
    }
    /**
   * Register a handler for resolve comment events (called by content types)
   */ registerOnResolveComment(callback) {
        this.onResolveCommentHandler = callback;
    }
    /**
   * Handle a delete comment event (fired by CF)
   */ onResolveComment(threadKey) {
        this.onResolveCommentHandler?.(threadKey);
    }
    /**
   * Trigger a refresh of the comment panel
   */ async triggerCommentPanelRefresh() {
        if (this.triggerCommentPanelRefreshHandler) {
            await this.triggerCommentPanelRefreshHandler();
            return;
        }
        // No handler registered means the panel is likely closed/unmounted.
        // Remember to refresh on next registration.
        this.hasPendingCommentPanelRefresh = true;
    }
    /**
   * Register a handler for update reaction events (called by content types)
   * @param callback - A callback function that will be called when a reaction is updated
   */ registerOnUpdateReaction(callback) {
        this.onUpdateReactionHandler = callback;
    }
    /**
   * Handle an update reaction event (fired by CF)
   * @param threadKey - The thread key of the comment
   * @param emojiId - The emoji ID of the reaction
   * @param actionType - The action type of the reaction
   * @returns
   */ onUpdateReaction(threadKey, emojiId, actionType) {
        return this.onUpdateReactionHandler?.(threadKey, emojiId, actionType);
    }
    /**
   * Register a handler for update unread comments events (called by content types)
   * @param handler - A callback function that will be called by content types (whiteboards, databases) to register a handler that CFE can use
   * to notify about the comment being read (e.g. update the unread comments status).
   */ registerOnUpdateUnreadComments(handler) {
        this.onUpdateUnreadCommentsHandler = handler;
    }
    /**
   * Handle an update unread comments event (fired by CF)
   * CFE -> Content Types (whiteboards, databases)
   * @param commentIds - The IDs of the comments that have been read
   * @param read - Whether the comments have been read or unread
   * @see triggerReadStatusComment for the counterpart method
   */ onUpdateUnreadComments(commentIds, read = false) {
        return this.onUpdateUnreadCommentsHandler?.(commentIds, read);
    }
    /**
   * Register a handler for trigger read status comment events (called by CF)
   * @param handler - A callback function used by CFE to register a handler that can be used when content types notifies CFE about a comment being read.
   */ registerTriggerReadStatusComment(handler) {
        this.triggerReadStatusCommentHandler = handler;
    }
    /**
   * Triggers an update of the unread comments status (fired by content types)
   * Content Types (whiteboards, databases) -> CFE
   * @param commentIds - The IDs of the comments that have been read
   * @param read - Whether the comments have been read or unread.
   * @see onUpdateUnreadComments for the counterpart method
   */ triggerReadStatusComment(commentIds, read = false) {
        return this.triggerReadStatusCommentHandler?.(commentIds, read);
    }
    constructor(){
        this.selectThreadHandler = void 0;
        this.reopenResolvedCommentHandler = void 0;
        this.showPanelHandler = void 0;
        this.hidePanelHandler = void 0;
        this.selectCommentThreadHandler = void 0;
        this.onDeleteCommentHandler = void 0;
        this.triggerCommentPanelRefreshHandler = void 0;
        // When a refresh is requested while the comments panel is unmounted (no handler
        // registered), we set this flag so the next registration triggers a refetch.
        this.hasPendingCommentPanelRefresh = false;
        this.onCreateCommentHandler = void 0;
        this.onUpdateCommentHandler = void 0;
        this.onResolveCommentHandler = void 0;
        this.onUpdateReactionHandler = void 0;
        this.onUpdateUnreadCommentsHandler = void 0;
        this.triggerReadStatusCommentHandler = void 0;
        this.selectThreadHandler = undefined;
        this.reopenResolvedCommentHandler = undefined;
        this.showPanelHandler = undefined;
        this.selectCommentThreadHandler = undefined;
        this.hidePanelHandler = undefined;
        this.onCreateCommentHandler = undefined;
        this.onDeleteCommentHandler = undefined;
        this.onUpdateCommentHandler = undefined;
        this.triggerCommentPanelRefreshHandler = undefined;
        this.onResolveCommentHandler = undefined;
        this.onUpdateReactionHandler = undefined;
        this.hasPendingCommentPanelRefresh = false;
        this.onUpdateUnreadCommentsHandler = undefined;
        this.triggerReadStatusCommentHandler = undefined;
    }
}
module.exports["ContentTypesCommentService"] = $569106325e18c3c1$export$6c0a8b19f951b1bc;

});

parcelRegister("fy5yb", function(module, exports) {

var $epbW8 = parcelRequire("epbW8");


var $8i27m = parcelRequire("8i27m");

const $747cae967af72a91$export$765c3cc11af57952 = (unresolvedInlineComments)=>Object.fromEntries(unresolvedInlineComments.map((annotationId)=>[
            annotationId,
            {
                id: annotationId,
                annotationType: (0, $epbW8.AnnotationTypes).INLINE_COMMENT,
                state: (0, $epbW8.AnnotationMarkStates).RESOLVED
            }
        ]));
const $747cae967af72a91$var$extractAllComments = (commentsDataMap)=>Object.values(commentsDataMap).flatMap((dataMap)=>Object.values(dataMap));
const $747cae967af72a91$var$excludeDraftComments = (comments)=>comments.filter((comment)=>comment.contentStatus !== 'draft');
const $747cae967af72a91$var$extractUnresolvedCommentIds = (comments)=>comments.filter((comment)=>comment.isOpen).map((comment)=>comment.id);
const $747cae967af72a91$export$8407ff9f3ad87778 = (commentsDataMap, includeDrafts)=>{
    const allParentComments = includeDrafts ? $747cae967af72a91$var$extractAllComments(commentsDataMap) : $747cae967af72a91$var$excludeDraftComments($747cae967af72a91$var$extractAllComments(commentsDataMap));
    return $747cae967af72a91$var$extractUnresolvedCommentIds(allParentComments);
};
const $747cae967af72a91$var$COMMENTS_LOCATIONS = {
    INLINE: 'INLINE',
    FOOTER: 'FOOTER'
};
const $747cae967af72a91$export$e25befbc00a116b = (resolvedComments, commentData)=>{
    if (!resolvedComments?.comments?.nodes) return commentData;
    const resolvedCommentNodes = resolvedComments.comments.nodes.filter((node)=>node !== null);
    const updateComments = (comments, locationType, commentType)=>Object.keys(comments).reduce((acc, key)=>{
            const comment = comments[key];
            const resolvedComment = resolvedCommentNodes.find((resolved)=>locationType === $747cae967af72a91$var$COMMENTS_LOCATIONS.INLINE ? resolved.location.inlineMarkerRef === key && resolved.location.type === locationType : resolved.id === key && resolved.location.type === locationType);
            if (resolvedComment && comment.isOpen) return {
                ...acc,
                [key]: {
                    ...resolvedComment,
                    isOpen: false,
                    type: commentType
                }
            };
            else return {
                ...acc,
                [key]: comment
            };
        }, {});
    const updatedInlineComments = updateComments(commentData.inline, $747cae967af72a91$var$COMMENTS_LOCATIONS.INLINE, (0, $8i27m.CommentType).INLINE);
    const updatedGeneralComments = updateComments(commentData.general, $747cae967af72a91$var$COMMENTS_LOCATIONS.FOOTER, (0, $8i27m.CommentType).GENERAL);
    return {
        inline: updatedInlineComments,
        general: updatedGeneralComments
    };
};
const $747cae967af72a91$export$4e544898773875e3 = ({ isReply: isReply, threadKey: threadKey, commentType: commentType, commentsDataMap: commentsDataMap, deleteParentComment: deleteParentComment })=>{
    if (isReply) return null;
    const deletedParentComment = {
        [(0, $8i27m.CommentType).INLINE]: {
            [threadKey]: commentsDataMap.inline[threadKey]
        },
        [(0, $8i27m.CommentType).GENERAL]: {}
    };
    deleteParentComment({
        threadKey: threadKey,
        commentType: commentType
    });
    return deletedParentComment;
};
const $747cae967af72a91$export$36d96c1319999e05 = ({ threadKey: threadKey, commentType: commentType, commentsDataMap: commentsDataMap, deleteParentComment: deleteParentComment })=>{
    const parentComment = commentsDataMap[commentType][threadKey];
    if (!parentComment) return null;
    const deletedParentComment = {
        [(0, $8i27m.CommentType).INLINE]: commentType === (0, $8i27m.CommentType).INLINE ? {
            [threadKey]: parentComment
        } : {},
        [(0, $8i27m.CommentType).GENERAL]: commentType === (0, $8i27m.CommentType).GENERAL ? {
            [threadKey]: parentComment
        } : {}
    };
    deleteParentComment({
        threadKey: threadKey,
        commentType: commentType
    });
    return deletedParentComment;
};
const $747cae967af72a91$export$485aa15bd11fefca = ({ threadKey: threadKey, commentId: commentId, commentType: commentType, commentsDataMap: commentsDataMap, handleRemovingComments: handleRemovingComments })=>{
    const parentComment = commentsDataMap[commentType][threadKey];
    if (!parentComment) return null;
    const replies = parentComment.replies;
    const deletedReplyComment = replies.find((reply)=>reply.id === commentId);
    if (!deletedReplyComment) return null;
    handleRemovingComments({
        threadKey: threadKey,
        commentId: commentId,
        action: (0, $8i27m.CommentActionType).DELETE_COMMENT,
        commentType: commentType
    });
    return deletedReplyComment;
};
module.exports["getResolvedAnnotationState"] = $747cae967af72a91$export$765c3cc11af57952;
module.exports["computeResolvedCommentIds"] = $747cae967af72a91$export$8407ff9f3ad87778;
module.exports["updateResolvedComments"] = $747cae967af72a91$export$e25befbc00a116b;
module.exports["deleteInlineParentComment"] = $747cae967af72a91$export$4e544898773875e3;
module.exports["deleteParentCommentOptimistically"] = $747cae967af72a91$export$36d96c1319999e05;
module.exports["deleteReplyCommentOptimistically"] = $747cae967af72a91$export$485aa15bd11fefca;

});

parcelRegister("7B9wr", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $ep3mz = parcelRequire("ep3mz");


var $1ggpj = parcelRequire("1ggpj");

const $e0dcf0245d0f4db8$export$8ee67841592dfd9f = ()=>{
    const [contentType] = (0, $ep3mz.useContentType)();
    return contentType !== (0, $1ggpj.ContentType).DATABASE && !(0, $1ggpj.isCanvasContentType)(contentType) && (0, $9wGTI.fg)('confluence_frontend_new_dangling_comments_ux');
};
module.exports["useIsNewDanglingCommentExperienceEnabled"] = $e0dcf0245d0f4db8$export$8ee67841592dfd9f;

});

parcelRegister("aGjYc", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $7W8i8 = parcelRequire("7W8i8");

const $9a76668fa978df44$export$6af3d18059afaa9e = 'outOfDate';
const $9a76668fa978df44$export$926918591069cc4f = ()=>(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) && ((0, $6mKj3.expValEquals)('confluence_fe_create_comment_optimistic', 'isEnabled', true) || (0, $6mKj3.expValEquals)('confluence_fe_reply_comment_optimistic', 'isEnabled', true) || (0, $6mKj3.expValEquals)('confluence_fe_edit_comment_optimistic', 'isEnabled', true));
const $9a76668fa978df44$export$af7cdd47474fbc83 = (// TODO: (COMMENTS-6792) `type` is no longer needed. Remove this later.
_type, mode)=>{
    if (!$9a76668fa978df44$export$926918591069cc4f()) return false;
    switch(mode){
        case 'create':
            return (0, $6mKj3.expValEquals)('confluence_fe_create_comment_optimistic', 'isEnabled', true);
        case 'reply':
            return (0, $6mKj3.expValEquals)('confluence_fe_reply_comment_optimistic', 'isEnabled', true);
        case 'edit':
        default:
            return (0, $6mKj3.expValEquals)('confluence_fe_edit_comment_optimistic', 'isEnabled', true);
    }
};
const $9a76668fa978df44$var$logger = (0, $7W8i8.getLogger)('comment-draft-utils');
const $9a76668fa978df44$export$a47fb462a08de82f = (type, mode)=>{
    if ($9a76668fa978df44$export$926918591069cc4f()) switch(type){
        // Treat edit-inline and inline as the same type, so a comment draft
        // saved in EDITOR mode can be used in VIEW mode of the same page.
        case 'edit-inline':
        case 'inline':
            if (mode === 'create') return (0, $1UApO.keys).COMMENT_DRAFTS_INLINE_CREATE;
            else if (mode === 'edit') return (0, $1UApO.keys).COMMENT_DRAFTS_INLINE_EDIT;
            else return (0, $1UApO.keys).COMMENT_DRAFTS_INLINE_REPLY;
        case 'page':
        default:
            if (mode === 'create') return (0, $1UApO.keys).COMMENT_DRAFTS_PAGE_CREATE;
            else if (mode === 'edit') return (0, $1UApO.keys).COMMENT_DRAFTS_PAGE_EDIT;
            else return (0, $1UApO.keys).COMMENT_DRAFTS_PAGE_REPLY;
    }
    // TODO: (COMMENTS-6792) Remove this when optimistic save is rolled out
    switch(type){
        case 'edit-inline':
            if (mode === 'create') return (0, $1UApO.keys).COMMENT_DRAFTS_EDITOR_INLINE_CREATE;
            else if (mode === 'edit') return (0, $1UApO.keys).COMMENT_DRAFTS_EDITOR_INLINE_EDIT;
            else return (0, $1UApO.keys).COMMENT_DRAFTS_EDITOR_INLINE_REPLY;
        case 'inline':
            if (mode === 'create') return (0, $1UApO.keys).COMMENT_DRAFTS_INLINE_CREATE;
            else if (mode === 'edit') return (0, $1UApO.keys).COMMENT_DRAFTS_INLINE_EDIT;
            else return (0, $1UApO.keys).COMMENT_DRAFTS_INLINE_REPLY;
        case 'page':
        default:
            if (mode === 'create') return (0, $1UApO.keys).COMMENT_DRAFTS_PAGE_CREATE;
            else if (mode === 'edit') return (0, $1UApO.keys).COMMENT_DRAFTS_PAGE_EDIT;
            else return (0, $1UApO.keys).COMMENT_DRAFTS_PAGE_REPLY;
    }
};
const $9a76668fa978df44$export$a4f0a5ceed96eae8 = (adf, pageId, type, mode)=>{
    let b64EncodedDraftObj = null;
    const key = $9a76668fa978df44$export$a47fb462a08de82f(type, mode);
    const draftObj = JSON.stringify({
        pageId: pageId,
        adf: adf
    });
    try {
        if ($9a76668fa978df44$export$926918591069cc4f()) b64EncodedDraftObj = $9a76668fa978df44$export$708cfc4e2abfde1e(draftObj);
        else b64EncodedDraftObj = btoa(draftObj);
    } catch (e) {
        $9a76668fa978df44$var$logger.error`Unable to save draft object for ${pageId}; ${e}`;
    }
    if (b64EncodedDraftObj === null) return false;
    // Store the draft with a 72 hour expiration
    (0, $17wUi.confluenceLocalStorageInstance).setItem(key, b64EncodedDraftObj, 259200);
    return true;
};
const $9a76668fa978df44$export$e7cfba777a0d590e = (type, mode)=>{
    const key = $9a76668fa978df44$export$a47fb462a08de82f(type, mode);
    (0, $17wUi.confluenceLocalStorageInstance).removeItem(key);
};
const $9a76668fa978df44$export$5fff31d3d3e1ad8b = (pageId, type, mode)=>Boolean($9a76668fa978df44$export$7c0604f3bd51258a(pageId, type, mode));
const $9a76668fa978df44$export$7c0604f3bd51258a = (pageId, type, mode)=>{
    let draftObj = null;
    const key = $9a76668fa978df44$export$a47fb462a08de82f(type, mode);
    const b64EncodedDraftObj = (0, $17wUi.confluenceLocalStorageInstance).getItem(key);
    if (b64EncodedDraftObj !== null) {
        try {
            if ($9a76668fa978df44$export$926918591069cc4f()) draftObj = JSON.parse($9a76668fa978df44$export$5590361fa8c7b71(b64EncodedDraftObj));
            else draftObj = JSON.parse(atob(b64EncodedDraftObj));
        } catch (e) {
            $9a76668fa978df44$var$logger.error`Unable to get draft object for ${pageId}; ${e}`;
        }
        if (draftObj) {
            const { pageId: draftPageId, adf: adf } = draftObj;
            // If the pageId matches, return the ADF, otherwise return null
            if (draftPageId === pageId) return adf;
        }
    }
    return null;
};
const $9a76668fa978df44$export$708cfc4e2abfde1e = (adfString)=>{
    const bytes = new TextEncoder().encode(adfString);
    let binary = '';
    for(let i = 0; i < bytes.byteLength; i++)binary += String.fromCharCode(bytes[i]);
    return btoa(binary);
};
const $9a76668fa978df44$export$5590361fa8c7b71 = (base64)=>{
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
    return new TextDecoder().decode(bytes);
};
module.exports["OUT_OF_DATE_KEY"] = $9a76668fa978df44$export$6af3d18059afaa9e;
module.exports["isOptimisticSaveEnabled"] = $9a76668fa978df44$export$926918591069cc4f;
module.exports["shouldUseCommentDraftForOptimisticSave"] = $9a76668fa978df44$export$af7cdd47474fbc83;
module.exports["saveCommentDraft"] = $9a76668fa978df44$export$a4f0a5ceed96eae8;
module.exports["clearCommentDraft"] = $9a76668fa978df44$export$e7cfba777a0d590e;
module.exports["hasCommentDraft"] = $9a76668fa978df44$export$5fff31d3d3e1ad8b;
module.exports["getCommentDraft"] = $9a76668fa978df44$export$7c0604f3bd51258a;

});

parcelRegister("g8bbY", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6ohxN = parcelRequire("6ohxN");


var $bGjLa = parcelRequire("bGjLa");

const $ed6d952ef1a68788$export$4153d6fbc2386422 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CommentEditor(props) {
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ohxN.CoreEditor), {
            ...props,
            appearance: "comment",
            AppearanceComponent: (0, $bGjLa.CommentEditorWithIntl)
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function CommentEditor(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ohxN.CoreEditor), {
        ...props,
        appearance: "comment",
        AppearanceComponent: (0, $bGjLa.CommentEditorWithIntl)
    });
};
module.exports["CommentEditor"] = $ed6d952ef1a68788$export$4153d6fbc2386422;

});

parcelRegister("koEBx", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6ohxN = parcelRequire("6ohxN");


var $eJlpI = parcelRequire("eJlpI");

const $6173d76fe85d4dd6$export$5252bd745392dcde = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ChromelessEditor(props) {
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ohxN.CoreEditor), {
            ...props,
            appearance: "chromeless",
            AppearanceComponent: (0, $eJlpI.default)
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function ChromelessEditor(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ohxN.CoreEditor), {
        ...props,
        appearance: "chromeless",
        AppearanceComponent: (0, $eJlpI.default)
    });
};
module.exports["ChromelessEditor"] = $6173d76fe85d4dd6$export$5252bd745392dcde;

});

parcelRegister("bpOXf", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $erHVE = parcelRequire("erHVE");


var $kCECX = parcelRequire("kCECX");


var $ixfCV = parcelRequire("ixfCV");

const $20e9c0f34a79c353$export$66b514a792884e0c = new (0, $kCECX.PluginKey)('malleableUiPlugin');
function $20e9c0f34a79c353$export$ae190596f549a4a8() {
    return new (0, $kpCD8.SafePlugin)({
        filterTransaction (tr, state) {
            // Block shouldShowToolbar:true transactions when the remix modal is open.
            // The mouseup listener on view.root fires even for clicks inside the remix
            // modal portal, which would re-show the toolbar. Filter those out.
            const toolbarMeta = tr.getMeta((0, $erHVE.editorToolbarPluginKey));
            if (toolbarMeta?.shouldShowToolbar === true) {
                const malleableState = $20e9c0f34a79c353$export$66b514a792884e0c.getState(state);
                if (malleableState?.isRemixModalOpen) return false;
            }
            return true;
        }
    });
}
function $20e9c0f34a79c353$export$11ad8b64b26867df(dispatch) {
    return new (0, $kpCD8.SafePlugin)({
        key: $20e9c0f34a79c353$export$66b514a792884e0c,
        state: {
            init () {
                return {
                    isRemixModalOpen: false,
                    remixModalMetadata: undefined,
                    showLocationPicker: false,
                    aiEditReplacementLocalIds: new Set(),
                    inFlightVariantUpdates: new Set(),
                    showSubtypeAdjustedFlag: false
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($20e9c0f34a79c353$export$66b514a792884e0c);
                if (!meta) return pluginState;
                let changed = false;
                let nextIds = pluginState.aiEditReplacementLocalIds;
                if (meta.addAiEditReplacementLocalId && !nextIds.has(meta.addAiEditReplacementLocalId)) {
                    nextIds = new Set(nextIds);
                    nextIds.add(meta.addAiEditReplacementLocalId);
                    changed = true;
                }
                if (meta.removeAiEditReplacementLocalId && nextIds.has(meta.removeAiEditReplacementLocalId)) {
                    nextIds = new Set(nextIds);
                    nextIds.delete(meta.removeAiEditReplacementLocalId);
                    changed = true;
                }
                let nextInFlightVariantUpdates = pluginState.inFlightVariantUpdates;
                if (meta.addInFlightVariantUpdateId && !nextInFlightVariantUpdates.has(meta.addInFlightVariantUpdateId)) {
                    nextInFlightVariantUpdates = new Set(nextInFlightVariantUpdates);
                    nextInFlightVariantUpdates.add(meta.addInFlightVariantUpdateId);
                    changed = true;
                }
                if (meta.removeInFlightVariantUpdateId && nextInFlightVariantUpdates.has(meta.removeInFlightVariantUpdateId)) {
                    nextInFlightVariantUpdates = new Set(nextInFlightVariantUpdates);
                    nextInFlightVariantUpdates.delete(meta.removeInFlightVariantUpdateId);
                    changed = true;
                }
                if (meta.isRemixModalOpen !== undefined || changed || meta.showSubtypeAdjustedFlag !== undefined || meta.showLocationPicker !== undefined && (0, $ixfCV.fg)('platform_editor_ai_remix_in_editor_loading')) {
                    const result = {
                        isRemixModalOpen: meta.isRemixModalOpen ?? pluginState.isRemixModalOpen,
                        remixModalMetadata: 'remixModalMetadata' in meta ? meta.remixModalMetadata : pluginState.remixModalMetadata,
                        remixSource: 'remixSource' in meta ? meta.remixSource : pluginState.remixSource,
                        showLocationPicker: meta.showLocationPicker !== undefined && (0, $ixfCV.fg)('platform_editor_ai_remix_in_editor_loading') ? meta.showLocationPicker : pluginState.showLocationPicker,
                        aiEditReplacementLocalIds: nextIds,
                        inFlightVariantUpdates: nextInFlightVariantUpdates,
                        showSubtypeAdjustedFlag: meta.showSubtypeAdjustedFlag ?? pluginState.showSubtypeAdjustedFlag
                    };
                    dispatch($20e9c0f34a79c353$export$66b514a792884e0c, result);
                    return result;
                }
                return pluginState;
            }
        }
    });
}
module.exports["malleableUiPluginKey"] = $20e9c0f34a79c353$export$66b514a792884e0c;
module.exports["createToolbarSuppressionPlugin"] = $20e9c0f34a79c353$export$ae190596f549a4a8;
module.exports["createMalleableUiPmPlugin"] = $20e9c0f34a79c353$export$11ad8b64b26867df;

});

parcelRegister("1Nl2R", function(module, exports) {
/**
 * Injected by the extension UI via Global; also exported for consumers who inject styles elsewhere.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Extension container override requires :has and !important

var $lOiVq = parcelRequire("lOiVq");

const $fe922ef20e476cda$var$wrapGap = "var(--ds-space-150, 12px)";
const $fe922ef20e476cda$var$noWrapGap = "var(--ds-space-300, 24px)";
const $fe922ef20e476cda$export$4f468ea4dd4fc462 = /*#__PURE__*/ (0, $lOiVq.css)({
    // Remove margin on extension-overflow-wrapper when it contains a native embed to prevent width overflow.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target overflow wrapper by data attribute
    '.extension-overflow-wrapper:has([data-native-embed-alignment])': {
        margin: '0 !important'
    },
    // The renderer sets overflow-x:auto on .ak-renderer-extension-overflow-container, which clips a
    // pixel-resized native embed that is wider than the text column and prevents centering from
    // working (the scroll container also becomes the reference for the 50% offset). Override to
    // visible so the embed can break out symmetrically on both sides, exactly as images do.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target overflow container by data attribute
    '.ak-renderer-extension-overflow-container:has([data-native-embed-alignment])': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- !important string requires type cast incompatible with the CSSProperties type
        overflowX: 'visible !important'
    },
    // For a center-aligned embed with an explicit pixel width, the outer .ak-renderer-extension
    // wrapper's width is set directly as an inline style by the native embed useEffect (to override
    // the renderer's own inline style="width:100%"). These CSS rules apply the centering transforms
    // on that same wrapper — now that it has the exact pixel width, margin-left:50% +
    // translateX(-50%) breaks it out symmetrically, exactly as MediaSingle does for images.
    // max-width:100cqw prevents overflow beyond the container while still allowing
    // the embed to break out of the narrow layout column (unlike 100% which would
    // clamp to the ~760px parent).
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target renderer extension wrapper by data attribute
    '.ak-renderer-extension:has([data-native-embed-alignment="center"]):has([data-native-embed-width])': {
        position: 'relative',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space -- geometric centering offset, not a spacing value
        marginLeft: '50%',
        transform: 'translateX(-50%)',
        maxWidth: '100cqw'
    },
    // Width: 100% when no explicit width set; fit-content when data-native-embed-width is set.
    // Combined selectors cover both .extension-container (editor) and .ak-renderer-extension (renderer)
    // which use different wrapper class names for the same structural element.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension wrappers by data attribute
    '.extension-container:has([data-native-embed-alignment]):not(:has([data-native-embed-width])), .ak-renderer-extension:has([data-native-embed-alignment]):not(:has([data-native-embed-width]))': {
        width: '100% !important',
        marginLeft: '0 !important',
        marginRight: '0 !important',
        paddingLeft: '0 !important',
        paddingRight: '0 !important'
    },
    // Match editor/renderer wrapper clipping and selected-node ring to the native embed frame radius.
    // Borderless experiences keep the smaller core wrapper radius so their iframe content is not clipped
    // to a framed shape they do not visually own.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension wrappers by the resolved showBorder value
    '.extension-container:has([data-native-embed-show-border="true"]), .ak-renderer-extension:has([data-native-embed-show-border="true"])': {
        borderRadius: "var(--ds-radius-xlarge, 12px)"
    },
    // Initial render placeholder: reserve space with chrome matching the real native embed wrapper
    // while the async iframe experience is resolving. Width/height/aspect-ratio remain inline because
    // they are derived from ADF params and manifest defaults at runtime.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target native embed initial placeholder by test id and border marker
    '[data-native-embed-show-border="true"] > [data-testid="native-embed-initial-placeholder"]': {
        boxSizing: 'border-box',
        maxWidth: '100%',
        overflow: 'hidden',
        backgroundColor: "var(--ds-surface-sunken, #F8F8F8)",
        borderStyle: 'solid',
        borderWidth: "var(--ds-border-width, 1px)",
        borderColor: "var(--ds-border, #0B120E24)",
        borderRadius: "var(--ds-radius-xlarge, 12px)"
    },
    // Borderless experiences such as MAUI/databases intentionally keep the smaller clipping radius
    // used by the real borderless iframe wrapper and avoid painting placeholder border chrome.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target native embed initial placeholder by test id and border marker
    '[data-native-embed-show-border="false"] > [data-testid="native-embed-initial-placeholder"]': {
        boxSizing: 'border-box',
        maxWidth: '100%',
        overflow: 'hidden',
        backgroundColor: "var(--ds-surface-sunken, #F8F8F8)",
        borderRadius: "var(--ds-radius-small, 4px)"
    },
    // In the editor, the --native-embed-width CSS variable is set on .extension-container by the
    // resize plugin. When the embed is nested inside another node (e.g. a table cell or expand),
    // data-native-embed-nested is present and we use maxWidth so the embed shrinks with the parent.
    // When the embed is top-level (not nested), we use width so it takes the exact pixel size.
    // In the renderer, width is set directly as an inline style on .ak-renderer-extension (overriding
    // the renderer's own inline style="width:100%"), so no CSS variable rule is needed for the renderer.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target nested extension container by data attribute on the container itself
    '.extension-container[data-native-embed-nested]:has([data-native-embed-alignment]):has([data-native-embed-width])': {
        maxWidth: 'var(--native-embed-width) !important',
        paddingLeft: '0 !important',
        paddingRight: '0 !important'
    },
    // The second selector adds an ID-level specificity bump so this rule also wins in full-width mode
    // (Confluence "wide" page width), where the editor applies `width: 100% !important` to
    // `.extension-container.block` via a rule scoped under
    // `.fabric-editor--full-width-mode:not(:has(#chromeless-editor))` with specificity (1, 3, 0).
    // Without the second selector, the native embed's (0, 3, 0) rule loses the cascade battle.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Second selector matches specificity of editor-core's full-width-mode rule; own ID won't work as our div is inside .extension-container, not an ancestor
    '.extension-container:not([data-native-embed-nested]):has([data-native-embed-alignment]):has([data-native-embed-width]), .fabric-editor--full-width-mode:not(:has(#chromeless-editor)) .extension-container.block:not([data-native-embed-nested]):has([data-native-embed-alignment]):has([data-native-embed-width])': {
        width: 'var(--native-embed-width) !important',
        paddingLeft: '0 !important',
        paddingRight: '0 !important'
    },
    // Layout column resizing can temporarily rebuild column content before the
    // native embed plugin re-syncs data-native-embed-nested. Fall back to the
    // actual layout-column DOM ancestry so an embed in a column still shrinks to
    // the column instead of taking its stored pixel width.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- DOM ancestry fallback for transient missing data-native-embed-nested
    '.ProseMirror [data-layout-column] .extension-container:has([data-native-embed-alignment]):has([data-native-embed-width]), .fabric-editor--full-width-mode:not(:has(#chromeless-editor)) [data-layout-column] .extension-container.block:has([data-native-embed-alignment]):has([data-native-embed-width])': {
        width: 'auto !important',
        maxWidth: 'var(--native-embed-width) !important',
        paddingLeft: '0 !important',
        paddingRight: '0 !important'
    },
    // Override the extension wrapper's width so alignment margins take effect.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension wrappers by data attribute
    '.extension-container:has([data-native-embed-alignment="left"]), .ak-renderer-extension:has([data-native-embed-alignment="left"])': {
        margin: `${$fe922ef20e476cda$var$noWrapGap} auto ${$fe922ef20e476cda$var$noWrapGap} 0 !important`,
        overflow: 'auto'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension wrappers by data attribute
    '.extension-container:has([data-native-embed-alignment="center"]), .ak-renderer-extension:has([data-native-embed-alignment="center"])': {
        margin: `${$fe922ef20e476cda$var$noWrapGap} 0 !important`,
        position: 'relative',
        left: '50%',
        transform: 'translateX(-50%)',
        marginLeft: '0 !important',
        marginRight: '0 !important'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension wrappers by data attribute
    '.extension-container:has([data-native-embed-alignment="right"]), .ak-renderer-extension:has([data-native-embed-alignment="right"])': {
        margin: `${$fe922ef20e476cda$var$noWrapGap} 0 ${$fe922ef20e476cda$var$noWrapGap} auto !important`,
        overflow: 'auto'
    },
    // wrap-left / wrap-right: float + margin like MediaSingle so text wraps around the embed.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension wrappers by data attribute
    '.extension-container:has([data-native-embed-alignment="wrap-left"])': {
        float: 'left',
        margin: `${$fe922ef20e476cda$var$wrapGap} ${$fe922ef20e476cda$var$wrapGap} ${$fe922ef20e476cda$var$wrapGap} auto !important`,
        maxWidth: `calc((var(--ak-editor-max-container-width, 100%) / 2) - ${$fe922ef20e476cda$var$wrapGap})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension wrappers by data attribute
    '.ak-renderer-extension:has([data-native-embed-alignment="wrap-left"])': {
        float: 'left',
        margin: `${$fe922ef20e476cda$var$wrapGap} ${$fe922ef20e476cda$var$wrapGap} ${$fe922ef20e476cda$var$wrapGap} auto !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension wrappers by data attribute
    '.extension-container:has([data-native-embed-alignment="wrap-right"])': {
        float: 'right',
        margin: `${$fe922ef20e476cda$var$wrapGap} auto ${$fe922ef20e476cda$var$wrapGap} ${$fe922ef20e476cda$var$wrapGap} !important`,
        maxWidth: `calc((var(--ak-editor-max-container-width, 100%) / 2) - ${$fe922ef20e476cda$var$wrapGap})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension wrappers by data attribute
    '.ak-renderer-extension:has([data-native-embed-alignment="wrap-right"])': {
        float: 'right',
        margin: `${$fe922ef20e476cda$var$wrapGap} auto ${$fe922ef20e476cda$var$wrapGap} ${$fe922ef20e476cda$var$wrapGap} !important`
    },
    // Suppress the hover box-shadow on the extension container for all native embeds.
    // Native embeds provide their own chrome so the generic extension hover ring is not appropriate.
    // The selection ring (from .ak-editor-selected-node) is also applied as a box-shadow,
    // and would be incorrectly hidden on hover without the :not() guard.
    // Using :not(.ak-editor-selected-node *) avoids coupling to the intermediate DOM structure.
    // In the renderer there is no selection ring so the :not() guard is not needed.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension wrapper hover by data attribute
    '.extension-container:has([data-native-embed-alignment]):not(.ak-editor-selected-node *):hover': {
        boxShadow: 'none !important'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target renderer extension wrapper hover by data attribute
    '.ak-renderer-extension:has([data-native-embed-alignment]):hover': {
        boxShadow: 'none !important'
    },
    // Suppress the selection ring (box-shadow from .ak-editor-selected-node) for database embeds.
    // Database embeds use appearance="minimal" with no content border, so the selection ring
    // creates a jarring visual effect around a borderless embed.
    // The box-shadow is applied by editor-core to `.extension-container` via the selector:
    //   `.extensionView-content-wrap.ak-editor-selected-node > span > .extension-container`
    // We target `.extension-container` directly using :has() to check for the experience attribute
    // on the inner div, matching regardless of the intermediate DOM structure.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension-container for database embeds when selected
    '.extension-container:has([data-native-embed-experience="database"])': {
        boxShadow: 'none !important'
    }
});
const $fe922ef20e476cda$export$6b40b1bb25fd4056 = /*#__PURE__*/ (0, $lOiVq.css)({
    // The extension-owned resize shell keeps the handles in the native embed DOM, so the editor's
    // generic extension scroll wrapper needs a narrow aperture around the resize shell. Without this,
    // the outside handles are either clipped or exposed through a horizontal scrollbar.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target resize shell marker to avoid changing generic extension overflow
    '.extension-overflow-wrapper:has([data-native-embed-resizer-shell="true"])': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- !important string requires type cast incompatible with the CSSProperties type
        overflowX: 'visible !important'
    },
    // Side-aligned native embeds set overflow:auto on the extension container so wide content can
    // scroll. The resize shell is different: its only horizontal overflow is the handle chrome.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target resize shell marker to keep this exception native-embed-only
    '.extension-container:has([data-native-embed-resizer-shell="true"])': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- !important string requires type cast incompatible with the CSSProperties type
        overflowX: 'visible !important'
    },
    // When the center-aligned extension-owned resize chrome is visible, the editor selection/hover
    // frame must follow the native embed's explicit width. Side and wrap alignments keep their
    // existing wrapper sizing so they are not pinned to a pixel width just because the shell is active.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target extension container by an active marker owned by the native embed shell
    '.extension-container:has([data-native-embed-resizer-active="true"][data-native-embed-resizer-alignment="center"]), .extension-container:has([data-native-embed-resizer-shell="true"][data-native-embed-resizer-alignment="center"]:hover)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- !important keeps selected editor-core width rules aligned to the active resize shell
        width: 'var(--native-embed-width) !important',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- !important overrides editor-core inline max-width while the resize chrome is visible
        maxWidth: 'var(--native-embed-width) !important',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- adjacent resize handles intentionally protrude past the frame
        overflow: 'visible !important',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- keep left/right handles visible when alignment rules set overflow:auto
        overflowX: 'visible !important'
    },
    // While a resize handle is being hovered, focused, or dragged, suppress the native embed
    // title/header chrome so the shell matches the coordinator overlay's resize-only affordance.
    // Hovering the embed body still shows the normal native embed overlay.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Header chrome belongs to the native embed frame inside this shell
    '.extension-container:has([data-native-embed-resizer-handle-active="true"]) [data-header-bar], .extension-container:has([data-native-embed-resizer-handle-active="true"]) [data-header-controls]': {
        opacity: 0,
        pointerEvents: 'none',
        visibility: 'hidden'
    },
    // The editor resizer paints selected node handles with the focused border color. The
    // extension-owned shell keeps visible-but-idle handles neutral to match the coordinator overlay,
    // while .is-resizing continues to show the active focused color during an actual drag.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Target editor-common resizer internals inside the native embed shell only
    '.extension-container:has([data-native-embed-resizer-active="true"]) .resizer-item:not(.is-resizing) .resizer-handle-thumb, .extension-container:has([data-native-embed-resizer-shell="true"]:hover) .resizer-item:not(.is-resizing) .resizer-handle-thumb': {
        background: `${"var(--ds-border, #0B120E24)"} !important`
    }
}); /* eslint-enable @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-important-styles */ 
module.exports["nativeEmbedAlignmentStyles"] = $fe922ef20e476cda$export$4f468ea4dd4fc462;
module.exports["nativeEmbedResizeShellStyles"] = $fe922ef20e476cda$export$6b40b1bb25fd4056;

});

parcelRegister("a25IJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2Vug6 = parcelRequire("2Vug6");

const $25418db445f35861$export$608c5cf5128f3cea = ({ effectiveHeight: effectiveHeight, effectiveWidth: effectiveWidth, lockAspectRatio: lockAspectRatio })=>{
    const placeholderStyle = {
        width: effectiveWidth ? `${effectiveWidth}px` : '100%',
        height: lockAspectRatio ? 'auto' : `${effectiveHeight}px`,
        aspectRatio: lockAspectRatio ? effectiveWidth && effectiveHeight ? `${effectiveWidth} / ${effectiveHeight}` : (0, $2Vug6.NATIVE_EMBED_INITIAL_LAYOUT_FALLBACK_ASPECT_RATIO) : undefined
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "native-embed-initial-placeholder",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- width/height/aspectRatio are dynamic ADF + manifest-derived layout values
        style: placeholderStyle
    });
};
const $25418db445f35861$export$5337b94b2c29c93 = ({ alignment: alignment, effectiveHeight: effectiveHeight, effectiveWidth: effectiveWidth, hasEmbedBorder: hasEmbedBorder, lockAspectRatio: lockAspectRatio })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-native-embed-alignment": alignment,
        "data-native-embed-width": effectiveWidth,
        "data-native-embed-show-border": hasEmbedBorder ? 'true' : 'false'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($25418db445f35861$export$608c5cf5128f3cea, {
        effectiveHeight: effectiveHeight,
        effectiveWidth: effectiveWidth,
        lockAspectRatio: lockAspectRatio
    }));
module.exports["NativeEmbedInitialPlaceholderFrame"] = $25418db445f35861$export$608c5cf5128f3cea;
module.exports["NativeEmbedInitialPlaceholder"] = $25418db445f35861$export$5337b94b2c29c93;

});

parcelRegister("2Vug6", function(module, exports) {

var $ljOiP = parcelRequire("ljOiP");

const $e8ed4dc9830c4b79$export$c2c01e3edfc7c01f = '760 / 600';
const $e8ed4dc9830c4b79$export$2dd05db6133b6a99 = ({ manifest: manifest, parameters: parameters, placeholderId: placeholderId })=>{
    const { alignment: alignment, aspectRatio: aspectRatio, height: height, width: width } = (0, $ljOiP.getParameters)(parameters);
    const effectiveWidth = width ?? manifest?.parameterDefaults?.width;
    // `getParameters` always supplies default values, so inspect raw macroParams to distinguish
    // stored dimensions from package defaults. This prevents the default aspectRatio from affecting
    // older embeds that never persisted original dimensions.
    const macroParams = parameters?.macroParams;
    const heightExplicitlyStored = !!macroParams?.height;
    const aspectRatioExplicitlyStored = !!macroParams?.aspectRatio;
    const effectiveHeightRaw = heightExplicitlyStored ? height : manifest?.parameterDefaults?.height ?? null;
    const effectiveHeight = aspectRatioExplicitlyStored && aspectRatio != null && aspectRatio > 0 && effectiveWidth != null && !heightExplicitlyStored ? Math.round(effectiveWidth / aspectRatio) : effectiveHeightRaw ?? height;
    const lockAspectRatio = typeof manifest?.lockResizeAspectRatio === 'function' ? manifest.lockResizeAspectRatio() : manifest?.lockResizeAspectRatio ?? true;
    return {
        alignment: alignment,
        effectiveHeight: effectiveHeight,
        effectiveWidth: effectiveWidth,
        hasEmbedBorder: manifest?.uiConfig?.showBorder ?? true,
        lockAspectRatio: lockAspectRatio,
        placeholderId: placeholderId
    };
};
module.exports["NATIVE_EMBED_INITIAL_LAYOUT_FALLBACK_ASPECT_RATIO"] = $e8ed4dc9830c4b79$export$c2c01e3edfc7c01f;
module.exports["resolveNativeEmbedInitialLayout"] = $e8ed4dc9830c4b79$export$2dd05db6133b6a99;

});

parcelRegister("8bRAb", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $dWfVs = parcelRequire("dWfVs");


var $aJNFh = parcelRequire("aJNFh");


var $2TWQD = parcelRequire("2TWQD");

async function $22de9e431e2baedb$export$af16a73460e35e28(cloudId, config) {
    const allSkills = await (0, $aJNFh.fetchSkills)(cloudId);
    const filteredSkills = (0, $2TWQD.filterSkills)(allSkills, config);
    return (0, $dWfVs.buildSkillsManifest)(filteredSkills, {
        // Skills should appear below native editor elements in the slash menu.
        // A high priority value (lower importance) ensures native items rank
        // higher when search scores are equal. Skills are identified by their
        // extensionType property (set by buildMenuItem for all extension items)
        // in the reranker at
        // platform/packages/editor/editor-common/src/quick-insert/boost-native-results-above-skills.ts
        priority: config.priority ?? 9000,
        onAction: (skill)=>{
            config.onAnalyticsEvent?.({
                action: (0, $krYZG.ACTION).INSERTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TYPEAHEAD,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).TYPEAHEAD_QUICK_INSERT,
                attributes: {
                    skillSlug: skill.slug,
                    skillName: skill.name,
                    isAiSkill: true
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            });
            return config.onSkillSelected?.(`/${skill.slug}`, skill);
        }
    });
}
module.exports["createRovoSkillsExtensionManifest"] = $22de9e431e2baedb$export$af16a73460e35e28;

});

parcelRegister("dWfVs", function(module, exports) {

var $8lhhf = parcelRequire("8lhhf");


var $9MCKh = parcelRequire("9MCKh");

const $ad58f4ad7597918e$var$DEFAULT_CATEGORY = 'AI';
const $ad58f4ad7597918e$var$MAX_DESCRIPTION_LENGTH = 150;
/**
 * Truncate description to a maximum length.
 * Used to keep insert menu items readable when skill descriptions are long.
 */ function $ad58f4ad7597918e$var$truncateDescription(description) {
    if (description.length <= $ad58f4ad7597918e$var$MAX_DESCRIPTION_LENGTH) return description;
    return description.slice(0, $ad58f4ad7597918e$var$MAX_DESCRIPTION_LENGTH).trim() + "\u2026";
}
/**
 * Returns the skill-specific icon based on the iconName field.
 * Falls back to the default skill icon if no match is found.
 */ const $ad58f4ad7597918e$var$getSkillIcon = (iconName)=>iconName && (0, $9MCKh.skillIcon)[iconName] ? (0, $9MCKh.skillIcon)[iconName] : (0, $9MCKh.defaultIcon);
function $ad58f4ad7597918e$export$d76981760c7a9606(skills, options = {}) {
    const { onAction: onAction, categories: categories = [
        $ad58f4ad7597918e$var$DEFAULT_CATEGORY
    ], priority: priority, getLozenge: getLozenge, nodes: nodes } = options;
    const quickInsertModules = skills.map((skill)=>{
        const keywords = [
            skill.slug,
            skill.product,
            skill.name,
            'skill',
            'skills'
        ].filter((k)=>typeof k === 'string' && k.length > 0);
        return {
            key: skill.slug,
            title: skill.name,
            description: $ad58f4ad7597918e$var$truncateDescription(skill.helpText ?? skill.description ?? ''),
            keywords: keywords,
            categories: categories,
            ...priority !== undefined && {
                priority: priority
            },
            icon: $ad58f4ad7597918e$var$getSkillIcon(skill.iconName),
            ...getLozenge && {
                lozenge: getLozenge(skill)
            },
            action: async ()=>onAction?.(skill)
        };
    });
    return {
        title: 'Rovo Skills',
        description: 'AI-powered skills from Rovo',
        type: (0, $8lhhf.ROVO_SKILL_EXTENSION_TYPE),
        key: (0, $8lhhf.ROVO_SKILL_EXTENSION_KEY),
        icons: {
            '16': (0, $9MCKh.defaultIcon),
            '24': (0, $9MCKh.defaultIcon),
            '48': (0, $9MCKh.defaultIcon)
        },
        modules: {
            quickInsert: quickInsertModules,
            ...nodes && {
                nodes: nodes
            }
        }
    };
}
module.exports["buildSkillsManifest"] = $ad58f4ad7597918e$export$d76981760c7a9606;

});

parcelRegister("2TWQD", function(module, exports) {
function $e8e957862ffce1cf$export$757808344f89f413(skills, config) {
    if (config.showAllSkills) return skills;
    const allowedSlugs = config.allowedSkills ?? [];
    if (allowedSlugs.length === 0) return [];
    const skillsBySlug = new Map(skills.map((skill)=>[
            skill.slug,
            skill
        ]));
    return allowedSlugs.map((slug)=>skillsBySlug.get(slug)).filter((skill)=>skill !== undefined);
}
module.exports["filterSkills"] = $e8e957862ffce1cf$export$757808344f89f413;

});

parcelRegister("emtVP", function(module, exports) {

var $jTt8P = parcelRequire("jTt8P");


var $130CJ = parcelRequire("130CJ");


var $as9lu = parcelRequire("as9lu");


var $f7B1p = parcelRequire("f7B1p");


var $gXKuh = parcelRequire("gXKuh");

function $01f4748f04f8193a$export$c0ee55695026b723(adf) {
    if (!adf?.content) return false;
    const stack = [
        adf
    ];
    while(stack.length > 0){
        const node = stack.pop();
        if (!node) break;
        if (node.type === 'mention' && node.attrs?.userType === 'APP' && typeof node.attrs?.id === 'string' && node.attrs.id !== '') return true;
        if (Array.isArray(node.content)) {
            // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity -- ADF trees are shallow (typically <10 levels); linear in total node count
            for (const child of node.content)if (child) stack.push(child);
        }
    }
    return false;
}
/**
 * Builds an `AgentMentionInfo` from a mention node and its position within the
 * parent's content. Returns null when the node has no usable id.
 */ function $01f4748f04f8193a$var$buildMentionInfo(node, siblings, index) {
    if (!node.attrs?.id) return null;
    const agentId = node.attrs.id;
    const rawMentionText = node.attrs.text ?? '';
    const agentName = rawMentionText.replace(/^@/, '');
    // Build prompt text from the mention's sibling nodes in the parent,
    // preserving the original @-prefixed mention text for the prompt.
    const promptText = siblings.map((sibling, j)=>{
        if (j === index) return rawMentionText;
        return sibling?.type === 'text' && sibling.text ? sibling.text : '';
    }).join('').trim() || rawMentionText;
    return {
        agentId: agentId,
        agentName: agentName,
        promptText: promptText
    };
}
function $01f4748f04f8193a$export$c2a308e988ef7ce4(adf) {
    if (!adf?.content) return null;
    let result = null;
    // traverse walks the full tree even after we find a match — the early-return
    // guard below skips processing but doesn't stop traversal. This is acceptable
    // for comment ADF which is typically small (a few paragraphs).
    (0, $jTt8P.traverse)(adf, {
        mention: (node, parent, index)=>{
            if (result) return; // already found one
            if (node.attrs?.userType !== 'APP') return;
            result = $01f4748f04f8193a$var$buildMentionInfo(node, parent.node?.content ?? [], index);
        }
    });
    return result;
}
function $01f4748f04f8193a$export$82632c733f1d4e2b(adf) {
    if (!adf?.content) return [];
    const candidates = [];
    (0, $jTt8P.traverse)(adf, {
        mention: (node, parent, index)=>{
            const info = $01f4748f04f8193a$var$buildMentionInfo(node, parent.node?.content ?? [], index);
            if (info) candidates.push(info);
        }
    });
    return candidates;
}
function $01f4748f04f8193a$export$39e3aee0c3a40960(adf) {
    if (!adf?.content) return [];
    const ids = [];
    (0, $jTt8P.traverse)(adf, {
        mention: (node)=>{
            const id = node.attrs?.id;
            if (typeof id === 'string' && id !== '' && !node.attrs?.userType) ids.push(id);
        }
    });
    return ids;
}
/**
 * Resolves an Atlassian account ID (from the mention node) to an Agent Studio
 * UUID (needed by the CwR sidebar for agent pre-selection).
 *
 * Uses the Rovo assistance API with the same pattern as AssistanceServiceImpl.
 * Returns null when the account is not an agent (the endpoint yields an error
 * body with no `id`) or on any error — so callers can also use this as an
 * "is this mention an agent?" check. Agent pre-selection degrades gracefully.
 */ async function $01f4748f04f8193a$var$resolveAgentStudioId(accountId, cloudId, signal) {
    try {
        const response = await (0, $f7B1p.cfetch)(`/gateway/api/assist/rovo/v1/agents/accountid/${$01f4748f04f8193a$var$normalizeIdentityAccountId(accountId)}`, {
            method: 'GET',
            headers: {
                'x-product': 'confluence',
                'x-experience-id': 'ai-mate',
                'x-cloudid': cloudId
            },
            signal: signal
        });
        const agent = await response.json();
        // A non-agent account id yields an error body with no `id`. Returning null
        // here lets callers treat this function as an "is this an agent?" check.
        if (!agent?.id) return null;
        return {
            id: agent.id,
            namedId: agent.named_id,
            name: agent.name,
            externalConfigReference: agent.external_config_reference
        };
    } catch (err) {
        return null;
    }
}
async function $01f4748f04f8193a$export$b035cc8717289977(accountId, cloudId, signal) {
    const resolved = await $01f4748f04f8193a$var$resolveAgentStudioId(accountId, cloudId, signal);
    return resolved ? {
        id: accountId,
        name: resolved.name,
        agentNamedId: resolved.externalConfigReference ?? resolved.namedId
    } : null;
}
function $01f4748f04f8193a$var$normalizeIdentityAccountId(accountId) {
    try {
        return (0, $as9lu.IdentityUserAri).parse(accountId).userId;
    } catch  {
        return accountId;
    }
}
async function $01f4748f04f8193a$var$setAgentSessionsProperty(pageId, userId) {
    const propertyKey = `cc-agent-mention-sessions:${userId}`;
    try {
        await (0, $f7B1p.cfetch)(`/wiki/api/v2/pages/${pageId}/properties`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                key: propertyKey,
                value: true
            })
        });
    } catch  {
    // Best-effort write — 409 means already set; any other error is non-fatal.
    }
}
/**
 * Resolves the given mention candidates against the Rovo agents endpoint and
 * returns the first one that is a real agent, together with its Studio id.
 * Returns null when none of the mentions resolve to an agent.
 *
 * Candidates are resolved sequentially so we short-circuit on the first agent
 * (comments typically contain a single mention).
 */ async function $01f4748f04f8193a$var$detectAgentMention(candidates, cloudId) {
    for (const mention of candidates){
        const controller = new AbortController();
        const timeoutId = setTimeout(()=>controller.abort(), (0, $gXKuh.AGENT_RESOLVE_TIMEOUT_MS));
        const resolved = await $01f4748f04f8193a$var$resolveAgentStudioId(mention.agentId, cloudId, controller.signal);
        clearTimeout(timeoutId);
        if (resolved?.id) return {
            mention: mention,
            studioId: resolved.id
        };
    }
    return null;
}
/**
 * Opens the CwR sidebar for an agent mention and fires the `chat-new` postMessage
 * (with page/comment conversation tags). When `preResolvedStudioId` is provided
 * (detected via id-resolution) it is used directly; otherwise the agent's Studio
 * id is resolved best-effort (with timeout) before sending.
 */ function $01f4748f04f8193a$var$openSidebarAndChat(agentMention, cloudId, pageId, commentId, userId, preResolvedStudioId) {
    if (userId && pageId) $01f4748f04f8193a$var$setAgentSessionsProperty(pageId, userId);
    // 1. Open the CwR sidebar via window event
    window.dispatchEvent(new CustomEvent((0, $gXKuh.AGENT_MENTION_COMMENT_SAVED_EVENT), {
        detail: agentMention
    }));
    // 2. Resolve agent ID (if not already known), then send chat-new.
    const prompt = agentMention.promptText;
    const sourceId = `agent-mention-${agentMention.agentId}-${Date.now()}`;
    // Build the comment-mention conversation tags so the backend can create a
    // SessionAssociationPublic record (linking this conversation to the page/comment)
    // and initialize the WORKING state. ARI-formatted IDs are used so the values
    // persisted to ERS are valid Teamwork Graph ARI references, as required by
    // conversational-ai-platform PRs 31101 and 31525. The BE extracts the ARI via
    // substringAfter("page:") / substringAfter("comment:") and stores it as
    // entityId / subEntityId on SessionAssociationPublic.
    const pageAri = pageId && cloudId ? `ari:cloud:confluence:${cloudId}:page/${pageId}` : '';
    const commentAri = commentId && cloudId ? `ari:cloud:confluence:${cloudId}:comment/${commentId}` : '';
    const tags = pageAri && commentAri ? [
        'mention-in-comment',
        `page:${pageAri}`,
        `comment:${commentAri}`
    ] : undefined;
    const chatName = prompt.length > 30 ? `${prompt.substring(0, 30).trimEnd()}\u{2026}` : prompt;
    const sendChatNew = (resolvedAgentId)=>{
        const payload = {
            type: 'chat-new',
            source: 'agentMentionComment',
            data: {
                ...resolvedAgentId ? {
                    agentId: resolvedAgentId
                } : {},
                sourceId: sourceId,
                name: chatName,
                prompt: prompt,
                dialogues: [],
                mode: {
                    useCurrentPageContext: true
                },
                ...tags ? {
                    tags: tags
                } : {}
            }
        };
        window.postMessage({
            eventType: (0, $130CJ.ROVO_POST_MESSAGE_EVENT_TYPE),
            payload: payload,
            payloadId: crypto.randomUUID()
        }, window.location.origin);
    };
    // Studio id already known (detected via id-resolution) or cloudId missing
    // (cannot resolve) — send immediately.
    if (preResolvedStudioId || !cloudId) {
        sendChatNew(preResolvedStudioId);
        return;
    }
    const controller = new AbortController();
    const timeoutId = setTimeout(()=>controller.abort(), (0, $gXKuh.AGENT_RESOLVE_TIMEOUT_MS));
    $01f4748f04f8193a$var$resolveAgentStudioId(agentMention.agentId, cloudId, controller.signal).then((resolved)=>{
        clearTimeout(timeoutId);
        sendChatNew(resolved?.id ?? null);
    });
}
function $01f4748f04f8193a$export$bb4bebb0ee10d371(adf, cloudId, pageId, commentId, userId) {
    // Fast path — a live comment still has userType='APP' on the agent mention.
    const fastPathMention = $01f4748f04f8193a$export$c2a308e988ef7ce4(adf);
    if (fastPathMention) {
        $01f4748f04f8193a$var$openSidebarAndChat(fastPathMention, cloudId, pageId, commentId, userId, null);
        return;
    }
    // Fallback — persisted/copy-pasted comment: userType has been stripped, so
    // identify the agent by resolving the surviving mention id(s). Requires a
    // cloudId to call the agents endpoint.
    if (!cloudId) return;
    const candidates = $01f4748f04f8193a$export$82632c733f1d4e2b(adf);
    if (candidates.length === 0) return;
    $01f4748f04f8193a$var$detectAgentMention(candidates, cloudId).then((match)=>{
        if (!match) return; // none of the mentions are agents
        $01f4748f04f8193a$var$openSidebarAndChat(match.mention, cloudId, pageId, commentId, userId, match.studioId);
    });
}
function $01f4748f04f8193a$export$7f191012969a4a56(conversationId) {
    if (!conversationId) return;
    const payload = {
        type: 'chat-open',
        source: 'agentMentionComment',
        data: {
            channelId: conversationId
        }
    };
    window.postMessage({
        eventType: (0, $130CJ.ROVO_POST_MESSAGE_EVENT_TYPE),
        payload: payload,
        payloadId: crypto.randomUUID()
    }, window.location.origin);
}
module.exports["hasAgentMention"] = $01f4748f04f8193a$export$c0ee55695026b723;
module.exports["extractAgentMentionFromAdf"] = $01f4748f04f8193a$export$c2a308e988ef7ce4;
module.exports["extractUnresolvedMentionIds"] = $01f4748f04f8193a$export$39e3aee0c3a40960;
module.exports["resolveAgentFromMentionId"] = $01f4748f04f8193a$export$b035cc8717289977;
module.exports["handleAgentMentionInComment"] = $01f4748f04f8193a$export$bb4bebb0ee10d371;
module.exports["reopenCommentAgentChat"] = $01f4748f04f8193a$export$7f191012969a4a56;

});

parcelRegister("gXKuh", function(module, exports) {
/**
 * Event dispatched when a comment containing an agent @mention is saved.
 * Listened to by useAgentMentionSidebarListener to open the CwR sidebar.
 */ const $b6c892aa1734c634$export$ca63cd40e8540dc2 = 'confluence:agent-mention-comment-saved';
const $b6c892aa1734c634$export$a31756fd55ed0e4f = 5000;
const $b6c892aa1734c634$export$a1f1ec50f461f04d = new Set([
    'whiteboard',
    'database'
]);
function $b6c892aa1734c634$export$29ca81875e26608b(contentType) {
    if (!contentType) return false;
    return !$b6c892aa1734c634$export$a1f1ec50f461f04d.has(contentType);
}
module.exports["AGENT_MENTION_COMMENT_SAVED_EVENT"] = $b6c892aa1734c634$export$ca63cd40e8540dc2;
module.exports["AGENT_RESOLVE_TIMEOUT_MS"] = $b6c892aa1734c634$export$a31756fd55ed0e4f;
module.exports["isAgentMentionSupportedForContentType"] = $b6c892aa1734c634$export$29ca81875e26608b;

});

parcelRegister("cOau5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kycWk = parcelRequire("kycWk");


var $F4YLX = parcelRequire("F4YLX");


const $831f4393e6328081$export$8c5d88a1b5304a38 = ({ contentId: contentId, isCommentContext: isCommentContext = false })=>{
    return {
        title: 'Redaction',
        type: (0, $kycWk.REDACTION_EXTENSION_TYPE),
        key: 'redaction',
        description: 'Inserts redacted block.',
        icons: {
            // eslint-disable-next-line import/dynamic-import-chunkname
            '48': ()=>(parcelRequire("b4ALZ"))
        },
        modules: {
            nodes: {
                default: {
                    type: 'inlineExtension',
                    render: async ()=>(args)=>{
                            const node = args.node;
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $F4YLX.TourableRedactionExtensionLoader), {
                                contentId: contentId,
                                extensionNode: node,
                                isCommentContext: isCommentContext
                            });
                        }
                }
            }
        }
    };
};
module.exports["createTourableRedactionExtension"] = $831f4393e6328081$export$8c5d88a1b5304a38;

});

parcelRegister("kycWk", function(module, exports) {
// Extension
const $a7399ed0bcbe7ac9$export$ebe904a0bbf57df1 = 'com.atlassian.guard-premium';
const $a7399ed0bcbe7ac9$export$d20f6356992396b7 = 'false';
var $a7399ed0bcbe7ac9$export$80edbf15fa61a4db = /*#__PURE__*/ function(MessageType) {
    MessageType["Engagement"] = "engagement";
    MessageType["Transactional"] = "transactional";
    return MessageType;
}({});
var $a7399ed0bcbe7ac9$export$ca2bc0ed0fbb9a2a = /*#__PURE__*/ function(RedactionsTourSteps) {
    RedactionsTourSteps[RedactionsTourSteps["FIRST"] = 0] = "FIRST";
    RedactionsTourSteps[RedactionsTourSteps["SECOND"] = 1] = "SECOND";
    return RedactionsTourSteps;
}({});
const $a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX = 'redactions-tour:';
const $a7399ed0bcbe7ac9$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX = 'object-sidebar-tour-target:';
const $a7399ed0bcbe7ac9$export$4ac8baee730e0515 = {
    REDACTION_EXTENSION: `${$a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX}redaction-extension`,
    TITLE_REDACTION: `${$a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX}title-redaction`,
    // Note: SpotlightTarget already exist on this element, so we must target that one
    SIDEBAR_DETAILS_BUTTON: `${$a7399ed0bcbe7ac9$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}sidebar-details-button`
};
const $a7399ed0bcbe7ac9$export$765a9736cc8e2d1f = 'https://support.atlassian.com/confluence-cloud/docs/how-redaction-works/';
module.exports["REDACTION_EXTENSION_TYPE"] = $a7399ed0bcbe7ac9$export$ebe904a0bbf57df1;
module.exports["IS_DISMISSED_FLAG"] = $a7399ed0bcbe7ac9$export$d20f6356992396b7;
module.exports["MessageType"] = $a7399ed0bcbe7ac9$export$80edbf15fa61a4db;
module.exports["RedactionsTourSteps"] = $a7399ed0bcbe7ac9$export$ca2bc0ed0fbb9a2a;
module.exports["REDACTIONS_TOUR_TARGETS"] = $a7399ed0bcbe7ac9$export$4ac8baee730e0515;
module.exports["READ_MORE_URL"] = $a7399ed0bcbe7ac9$export$765a9736cc8e2d1f;

});

parcelRegister("F4YLX", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $87886bfe56e46f2e$export$2e83ac12275e5b95 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "jDbpB",
    name: "TourableRedactionExtensionLoader",
    loader: async ()=>(await (parcelRequire("fgA8n"))).TourableRedactionExtension
});
module.exports["TourableRedactionExtensionLoader"] = $87886bfe56e46f2e$export$2e83ac12275e5b95;

});

parcelRegister("fgA8n", function(module, exports) {

let $b1d4611dc33958ff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b1d4611dc33958ff$var$load("5AfWB").then(()=>parcelRequire('jubPE'));

});

parcelRegister("b4ALZ", function(module, exports) {

let $80fc97cf3f3f4d02$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $80fc97cf3f3f4d02$var$load("gCHto").then(()=>parcelRequire('47bbw'));

});

parcelRegister("4hCFw", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $6SsN4 = parcelRequire("6SsN4");


var $w6R6I = parcelRequire("w6R6I");


var $cXtTj = parcelRequire("cXtTj");


var $2ot3O = parcelRequire("2ot3O");


var $ixfCV = parcelRequire("ixfCV");


var $iMnC5 = parcelRequire("iMnC5");


var $29vMs = parcelRequire("29vMs");

var $cXLoX = parcelRequire("cXLoX");


var $5JhlM = parcelRequire("5JhlM");

var $bBIvl = parcelRequire("bBIvl");


var $d5gEx = parcelRequire("d5gEx");


var $gZFfs = parcelRequire("gZFfs");

var $i8aB6 = parcelRequire("i8aB6");


var $a7t2v = parcelRequire("a7t2v");


var $lgull = parcelRequire("lgull");


var $iTtzC = parcelRequire("iTtzC");

const $2795fb4dc781be1d$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $2795fb4dc781be1d$var$ANALYTICS_FROM_CODE = 'SMARTLINK';
const $2795fb4dc781be1d$var$DEFAULT_MAX_LINES = 4;
const $2795fb4dc781be1d$var$styles = {
    container: "_11c8wadc"
};
const $2795fb4dc781be1d$var$getContentTypeParam = (contentType)=>contentType === 'page' ? 'PAGE' : contentType === 'blogpost' ? 'BLOGPOST' : null;
const $2795fb4dc781be1d$var$getAnalyticsConfig = (props)=>({
        product: 'confluence',
        subproduct: 'confluence',
        source: 'confluencePage',
        aiFeatureName: 'aiSnippet',
        proactiveGeneratedAI: 1,
        userGeneratedAI: 0,
        additionalAttributes: {
            contentId: props.contentId,
            contentType: props.contentType,
            from: props.from ?? $2795fb4dc781be1d$var$ANALYTICS_FROM_CODE,
            productAttributionOverride: 'confluence'
        },
        enablePlatformEvents: true,
        skipAISessionValidation: true
    }); /**
     * Main AI Snippet component. Fetches the AI snippet data from the server and displays it.
     * If the snippet data type is not supported, it will display the fallback component.
     * If the AI snippet data is not found or another error occurs it will display the AISnippet component,
     * but with the fallback text in place of the response text.
     *
     * @param contentId - The content ID of the AI snippet
     * @param contentType - The content type of the AI snippet
     * @param cloudId - The cloud ID of the AI snippet
     * @param fallbackText - The text to display if the AI snippet fails to load
     * @param fallbackComponent - The component to display if the AI snippet is not supported
     * @param source [optional] - The source for where the AI snippet was triggered from defaults to 'smartlink'
     * @param onLoadComplete [optional] - The callback function that executes when loading has completed
     * @returns
     */ 
const $2795fb4dc781be1d$export$1b2af18ca4bb327b = (props)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $29vMs.AIEventsInstrumentationProvider), {
        config: $2795fb4dc781be1d$var$getAnalyticsConfig(props)
    }, /*#__PURE__*/ $cozmU.createElement($2795fb4dc781be1d$export$ac90160f7ae1e32f, props));
};
const $2795fb4dc781be1d$export$ac90160f7ae1e32f = ({ contentId: contentId, contentType: contentType, cloudId: cloudId, fallbackText: fallbackText, fallbackComponent: fallbackComponent, userId: userId, displayName: displayName, source: source = 'smartlink', maxLines: maxLines = $2795fb4dc781be1d$var$DEFAULT_MAX_LINES, isHidden: isHidden = false, onLoadComplete: onLoadComplete, showFooter: showFooter, showAwareness: showAwareness })=>{
    const [queryRef, loadQuery] = (0, $6SsN4.useQueryLoader)((0, $iTtzC.default));
    const isLoadingRef = (0, $cozmU.useRef)(true);
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $cXLoX.useAIEventsInstrumentation)();
    const { start: start, success: success, failure: failure } = (0, $i8aB6.useUFOExperience)({
        id: 'ai-snippet-load',
        component: 'ai-snippet',
        type: (0, $gZFfs.ExperienceTypes).Load,
        performanceType: (0, $gZFfs.ExperiencePerformanceTypes).InlineResult
    });
    const contentTypeParam = $2795fb4dc781be1d$var$getContentTypeParam(contentType);
    const isValidQuery = contentType && cloudId && contentId && contentTypeParam;
    const isEnabledForJira = (0, $ixfCV.fg)('jira-cc-ai-snippet-gate');
    const isTrackingEnabled = (0, $cXtTj.default).getExperimentValue('cc-ai-snippet-experiment-tracking', 'isEnabled', false);
    (0, $cozmU.useEffect)(()=>{
        if (!isHidden) trackAIInteractionInit();
        return ()=>{
            if (isLoadingRef.current && !isHidden) trackAIInteractionDismiss();
        }; // Only on component mount/unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $cozmU.useEffect)(()=>{
        isLoadingRef.current = !queryRef;
        if (queryRef) {
            if (isTrackingEnabled) success();
            onLoadComplete?.();
        }
    }, [
        queryRef,
        onLoadComplete,
        success,
        isTrackingEnabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isValidQuery) // Skip query if we don't have valid params as we'll just return the fallback component
        return;
        if (isTrackingEnabled) start();
        loadQuery({
            contentId: contentId,
            contentType: contentTypeParam,
            cloudId: cloudId,
            includeMe: isEnabledForJira
        });
    }, [
        contentId,
        contentTypeParam,
        cloudId,
        loadQuery,
        isValidQuery,
        isEnabledForJira,
        start,
        isTrackingEnabled
    ]);
    if (!isValidQuery) return fallbackComponent;
    const content = /*#__PURE__*/ $cozmU.createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $a7t2v.AISnippetContent), {
            text: fallbackText,
            contentId: contentId,
            showFooter: false,
            showAwareness: showAwareness,
            source: source,
            isHidden: isHidden,
            maxLines: maxLines
        }),
        onError: (error)=>{
            if (!isHidden) {
                if (isTrackingEnabled) failure({
                    metadata: {
                        errorCode: 'extensions' in error ? error.extensions?.statusCode || 500 : 999,
                        errorMessage: error.message || 'Unknown error'
                    }
                });
                trackAIResultError({
                    aiErrorCode: 'extensions' in error ? error.extensions?.statusCode || 500 : 999,
                    aiErrorMessage: error.message || 'Unknown error'
                });
            }
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($2795fb4dc781be1d$var$styles.container)
    }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $bBIvl.AIStreamLoading), null)
    }, queryRef ? /*#__PURE__*/ $cozmU.createElement((0, $lgull.AISnippetLoader), {
        queryRef: queryRef,
        fallbackText: fallbackText,
        contentId: contentId,
        source: source,
        isHidden: isHidden,
        maxLines: maxLines,
        showFooter: showFooter,
        showAwareness: showAwareness
    }) : /*#__PURE__*/ $cozmU.createElement((0, $bBIvl.AIStreamLoading), null))));
    return /*#__PURE__*/ $cozmU.createElement((0, $2ot3O.FlagsProvider), null, isEnabledForJira ? content : /*#__PURE__*/ $cozmU.createElement((0, $5JhlM.AIFeedbackPropertiesProvider), {
        entrypointId: $2795fb4dc781be1d$var$SNIPPET_ENTRYPOINT_ID,
        userId: userId,
        displayName: displayName
    }, content));
};
const $2795fb4dc781be1d$export$c9a07cebec67e951 = (props)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $d5gEx.RelayEnvironmentProvider), null, /*#__PURE__*/ $cozmU.createElement($2795fb4dc781be1d$export$1b2af18ca4bb327b, props));
};
module.exports["AISnippetWithRelayEnvironment"] = $2795fb4dc781be1d$export$c9a07cebec67e951;

});

parcelRegister("5JhlM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $2eafd2f31cb677aa$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $2eafd2f31cb677aa$export$f906c21bacdb2d8e = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $2eafd2f31cb677aa$export$e9e654940dee103b = ({ children: children, entrypointId: entrypointId, locale: locale, feedbackContextId: feedbackContextId = $2eafd2f31cb677aa$var$FEEDBACK_CONTEXT_CF, feedbackContext: feedbackContext = {}, userId: userId, displayName: displayName })=>{
    const { locale: intlLocale } = (0, $kSwu1.useIntl)();
    const feedbackContextString = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${JSON.stringify(value)}`).join(' ');
    const contextValue = (0, $cozmU.useMemo)(()=>({
            entrypointId: entrypointId,
            feedbackContextId: feedbackContextId,
            feedbackContext: feedbackContextString,
            locale: locale || intlLocale,
            userId: userId,
            displayName: displayName
        }), [
        entrypointId,
        feedbackContextId,
        feedbackContextString,
        locale,
        intlLocale,
        userId,
        displayName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2eafd2f31cb677aa$export$f906c21bacdb2d8e.Provider, {
        value: contextValue
    }, children);
};
const $2eafd2f31cb677aa$export$ff3deb4415ee32e3 = ()=>{
    const context = (0, $cozmU.useContext)($2eafd2f31cb677aa$export$f906c21bacdb2d8e);
    if (context === undefined) throw new Error('useAIFeedbackProperties must be used within a AIFeedbackPropertiesProvider');
    return context;
};
module.exports["AIFeedbackPropertiesProvider"] = $2eafd2f31cb677aa$export$e9e654940dee103b;
module.exports["useAIFeedbackProperties"] = $2eafd2f31cb677aa$export$ff3deb4415ee32e3;

});

parcelRegister("bBIvl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");

var $kz1Yj = parcelRequire("kz1Yj");

var $buxP3 = parcelRequire("buxP3");


var $7m1U4 = parcelRequire("7m1U4");

const $b089d8c6b56c64f6$var$styles = (0, $buxP3.xcss)({
    color: 'color.text.subtle'
});
const $b089d8c6b56c64f6$var$i18n = (0, $kSwu1.defineMessages)({
    generatingSummaryText: {
        id: "ai-stream-loading.title",
        defaultMessage: "AI is working..."
    },
    generatingSummaryAnimationAlt: {
        id: "ai-stream-loading.generation-animation",
        defaultMessage: "Generating"
    }
});
const $b089d8c6b56c64f6$export$47a62cbf3ee79fef = ({ padding: padding = 'space.300', titleMessage: titleMessage })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const title = titleMessage ?? $b089d8c6b56c64f6$var$i18n.generatingSummaryText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        padding: padding,
        xcss: $b089d8c6b56c64f6$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        alignBlock: "center",
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7m1U4.GeneratingStreamAnimation), {
        alt: formatMessage($b089d8c6b56c64f6$var$i18n.generatingSummaryAnimationAlt)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), title)));
};
module.exports["AIStreamLoading"] = $b089d8c6b56c64f6$export$47a62cbf3ee79fef;

});

parcelRegister("7m1U4", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $cozmU = parcelRequire("cozmU");

const $c344a4b7f3959518$export$3709887a1be0e305 = ({ alt: alt })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("title", null, alt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "5.5",
        cy: "12.5",
        r: "1.5",
        fill: "#0C66E4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "11.5",
        cy: "10.5",
        r: "1.5",
        fill: "#1D7AFC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.2s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "17.5",
        cy: "12.5",
        r: "1.5",
        fill: "#388BFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.4s"
    })));
};
module.exports["GeneratingStreamAnimation"] = $c344a4b7f3959518$export$3709887a1be0e305;

});

parcelRegister("a7t2v", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $303LV = parcelRequire("303LV");


var $cXtTj = parcelRequire("cXtTj");


var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $cXLoX = parcelRequire("cXLoX");


var $cAiYt = parcelRequire("cAiYt");

var $aIn0d = parcelRequire("aIn0d");

var $cHkK6 = parcelRequire("cHkK6");


var $5GgqH = parcelRequire("5GgqH");

const $24521ba341a214c8$var$MAU_CRITERIA_DWELL_TIME = 3000;
const $24521ba341a214c8$var$sanitizeMarkdown = (text)=>{
    if (!text) return '';
    return text.replace(/={4,}/g, '===') // h1 headers
    .replace(/-{4,}/g, '---'); // h2 headers
};
const $24521ba341a214c8$export$3cf37822a11d3ff3 = ({ text: text, contentId: contentId, showFooter: showFooter = true, showAwareness: showAwareness = false, source: source, isHidden: isHidden, maxLines: maxLines, renderAsMarkdown: renderAsMarkdown = true })=>{
    const ref = (0, $cozmU.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $5GgqH.usePopupDwellTime)(ref, 250);
    const { trackAIResultView: trackAIResultView, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $cXLoX.useAIEventsInstrumentation)();
    // This is needed to keep the snippet value in scope when running the unmount effect
    const snippetValueRef = (0, $cozmU.useRef)(text);
    const isExperimentEnabled = (0, $cXtTj.default).getExperimentValue('cc-ai-snippet-fixes-1025', 'isEnabled', false);
    const isFeedbackEnabled = (0, $cXtTj.default).getExperimentValue('cc-ai-snippet-experiment-feedback', 'isEnabled', false);
    const handleLikeClicked = (0, $cozmU.useCallback)(()=>{
        trackAIFeedbackSubmit('up');
    }, [
        trackAIFeedbackSubmit
    ]);
    const handleDislikeClicked = (0, $cozmU.useCallback)(()=>{
        trackAIFeedbackSubmit('down');
    }, [
        trackAIFeedbackSubmit
    ]);
    (0, $cozmU.useEffect)(()=>{
        const currentText = snippetValueRef.current;
        return ()=>{
            const dwellTime = getDwellTime();
            if (!isHidden) {
                if (showFooter && currentText && dwellTime >= $24521ba341a214c8$var$MAU_CRITERIA_DWELL_TIME) trackAIResultView({
                    attributes: {
                        dwellTime: dwellTime,
                        source: source,
                        wasShownAIContent: true
                    }
                });
                else trackAIResultView({
                    attributes: {
                        dwellTime: dwellTime,
                        source: source,
                        wasShownAIContent: showFooter && !!currentText
                    },
                    doesNotMeetMAUCriteria: true
                });
            }
        };
    // we only want to run this effect on un-mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.100",
        ref: ref
    }, showAwareness && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cAiYt.AIAwareness), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        size: "small",
        maxLines: maxLines
    }, renderAsMarkdown ? isExperimentEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $303LV.default), {
        options: {
            disableParsingRawHTML: true
        }
    }, $24521ba341a214c8$var$sanitizeMarkdown(text || '')) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $303LV.default), null, text || '') : text || ''), showFooter && text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aIn0d.AIDisclaimer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cHkK6.AIFeedbackComponent), {
        contentId: contentId,
        onLikeClicked: isFeedbackEnabled ? handleLikeClicked : undefined,
        onDislikeClicked: isFeedbackEnabled ? handleDislikeClicked : undefined
    })));
};
module.exports["AISnippetContent"] = $24521ba341a214c8$export$3cf37822a11d3ff3;

});

parcelRegister("cAiYt", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $bltJZ = parcelRequire("bltJZ");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $1kxSE = parcelRequire("1kxSE");

const $b6dbb4b671decd4a$var$styles = {
    text: "_4bfu1r31 _1hmsglyw _ajmmnqa1"
};
const $b6dbb4b671decd4a$export$fde99ed387d90f1 = ({ variant: variant = 'summary' })=>{
    const MESSAGE_MAP = {
        summary: (0, $1kxSE.i18n).rovoAwarenessMessage,
        define: (0, $1kxSE.i18n).rovoAwarenessDefineMessage
    };
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const message = MESSAGE_MAP[variant];
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.default), {
        xcss: (0, $w6R6I.cx)($b6dbb4b671decd4a$var$styles.text)
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.default), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $bltJZ.RovoIcon), {
        size: "xxsmall",
        appearance: "brand",
        shouldUseNewLogoDesign: true
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
        color: "color.text.subtlest"
    }, formatMessage(message))));
};
module.exports["AIAwareness"] = $b6dbb4b671decd4a$export$fde99ed387d90f1;

});

parcelRegister("1kxSE", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $c8fb6889a2026e6c$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    rovoAwarenessMessage: {
        id: "ai-awareness.rovoAwarenessMessage",
        defaultMessage: "Summary by Rovo"
    },
    rovoAwarenessDefineMessage: {
        id: "ai-awareness-define.message",
        defaultMessage: "Definition by Rovo"
    }
});
module.exports["i18n"] = $c8fb6889a2026e6c$export$a7357cdd1f0b0168;

});

parcelRegister("cHkK6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $91uAX = parcelRequire("91uAX");


var $2ot3O = parcelRequire("2ot3O");


var $chu6R = parcelRequire("chu6R");


var $i1t43 = parcelRequire("i1t43");


var $ixfCV = parcelRequire("ixfCV");


var $3izAL = parcelRequire("3izAL");

var $kz1Yj = parcelRequire("kz1Yj");

var $buxP3 = parcelRequire("buxP3");


var $lpNn5 = parcelRequire("lpNn5");


var $5JhlM = parcelRequire("5JhlM");


var $gecH2 = parcelRequire("gecH2");

const $2e66c8b5b2928379$var$LINK_TO_PRIVACY_POLICY = 'https://www.atlassian.com/legal/privacy-policy';
const $2e66c8b5b2928379$var$LINK_TO_RESEARCH_GROUP = 'https://www.atlassian.com/research-group';
const $2e66c8b5b2928379$var$i18n = (0, $kSwu1.defineMessages)({
    flagTitle: {
        id: "quick-summary.feedback.flag.title",
        defaultMessage: "Thanks!"
    },
    flagDescription: {
        id: "quick-summary.feedback.flag.description",
        defaultMessage: "We appreciate you taking the time to send this feedback."
    },
    likeTooltip: {
        id: "quick-summary.like.tooltip",
        defaultMessage: "Helpful"
    },
    dislikeTooltip: {
        id: "quick-summary.dislike.tooltip",
        defaultMessage: "Not helpful"
    },
    feedbackTitle: {
        id: "quick-summary.feedback.title",
        defaultMessage: "Help us improve Atlassian Intelligence"
    },
    feedbackSummaryTitle: {
        id: "quick-summary.feedback.summary.title",
        defaultMessage: "Tell us about your experience"
    },
    feedbackSummaryPlaceholder: {
        id: "quick-summary.feedback.summary.placeholder",
        defaultMessage: "What did Atlassian Intelligence do well? What could be improved?"
    },
    canContactText: {
        id: "quick-summary.feedback.can-contact.label",
        defaultMessage: "Atlassian can contact me about this feedback. See our {privacyPolicyLink}."
    },
    privacyPolicyLink: {
        id: "quick-summary.feedback.privacy-policy.link",
        defaultMessage: "privacy policy"
    },
    improveAtlassianText: {
        id: "quick-summary.feedback.improve-atlassian",
        defaultMessage: "I\u2019d like to help improve Atlassian products by joining the {researchGroupLink}."
    },
    improveAtlassianTextAppify: {
        id: "quick-summary.feedback.improve-atlassian-appify",
        defaultMessage: "I\u2019d like to help improve Atlassian apps by joining the {researchGroupLink}."
    },
    researchGroupLink: {
        id: "quick-summary.feedback.research-group.link",
        defaultMessage: "Atlassian Research Group"
    }
});
const $2e66c8b5b2928379$var$PrivacyPolicyLink = ({ link: link })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2e66c8b5b2928379$var$i18n.privacyPolicyLink));
const $2e66c8b5b2928379$var$ResearchGroupLink = ({ link: link })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2e66c8b5b2928379$var$i18n.researchGroupLink));
const $2e66c8b5b2928379$var$CanContactLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$2e66c8b5b2928379$var$i18n.canContactText,
        values: {
            privacyPolicyLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$PrivacyPolicyLink, {
                link: $2e66c8b5b2928379$var$LINK_TO_PRIVACY_POLICY
            })
        }
    });
};
const $2e66c8b5b2928379$var$EnrolLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $ixfCV.fg)('product-terminology-refresh') ? $2e66c8b5b2928379$var$i18n.improveAtlassianTextAppify : $2e66c8b5b2928379$var$i18n.improveAtlassianText,
        values: {
            researchGroupLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$ResearchGroupLink, {
                link: $2e66c8b5b2928379$var$LINK_TO_RESEARCH_GROUP
            })
        }
    });
};
const $2e66c8b5b2928379$var$DislikeIconWrapperXCSS = (0, $buxP3.xcss)({
    transform: 'rotate(180deg)'
});
const $2e66c8b5b2928379$var$ButtonWrapperXCSS = (0, $buxP3.xcss)({
    height: '24px',
    width: '24px'
});
const $2e66c8b5b2928379$export$f9f34317e5bc3551 = ({ contentId: contentId, onLikeClicked: onLikeClicked, onDislikeClicked: onDislikeClicked })=>{
    const { showFlag: showFlag } = (0, $2ot3O.useFlags)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isFeedbackOpen, setIsFeedbackOpen] = (0, $cozmU.useState)(false);
    const feedbackCollectorProperties = (0, $5JhlM.useAIFeedbackProperties)();
    const [sentiment, setSentiment] = (0, $cozmU.useState)('');
    const [hasGoodFeedbackBeenSubmitted, setHasGoodFeedbackBeenSubmitted] = (0, $cozmU.useState)(false);
    const [hasBadFeedbackBeenSubmitted, setHasBadFeedbackBeenSubmitted] = (0, $cozmU.useState)(false);
    const feedbackContextString = `contentId: ${contentId} sentiment: ${sentiment}${feedbackCollectorProperties.feedbackContext.length > 0 ? ` ${feedbackCollectorProperties.feedbackContext}` : ''}`;
    const showFeedbackFlag = ()=>{
        showFlag({
            title: formatMessage($2e66c8b5b2928379$var$i18n.flagTitle),
            description: formatMessage($2e66c8b5b2928379$var$i18n.flagDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                spacing: "spacious",
                color: "var(--ds-icon-success, #6A9A23)",
                label: "success"
            }),
            isAutoDismiss: true
        });
    };
    const handleLikeClicked = ()=>{
        onLikeClicked?.();
        setIsFeedbackOpen(true);
        setSentiment('good');
    };
    const handleDislikeClicked = ()=>{
        onDislikeClicked?.();
        setIsFeedbackOpen(true);
        setSentiment('bad');
    };
    const onFeedbackSubmit = ()=>{
        showFeedbackFlag();
        setIsFeedbackOpen(false);
        if (sentiment === 'good') {
            setHasGoodFeedbackBeenSubmitted(true);
            setHasBadFeedbackBeenSubmitted(false);
        } else {
            setHasBadFeedbackBeenSubmitted(true);
            setHasGoodFeedbackBeenSubmitted(false);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        role: "none",
        onClick: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        hideTooltipOnMouseDown: true,
        content: formatMessage($2e66c8b5b2928379$var$i18n.likeTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $2e66c8b5b2928379$var$ButtonWrapperXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        "aria-label": formatMessage($2e66c8b5b2928379$var$i18n.likeTooltip),
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gecH2.ThumbIcon), {
            isSelected: hasGoodFeedbackBeenSubmitted
        }),
        onClick: handleLikeClicked,
        testId: "feedback-like-button",
        isDisabled: hasGoodFeedbackBeenSubmitted
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        hideTooltipOnMouseDown: true,
        content: formatMessage($2e66c8b5b2928379$var$i18n.dislikeTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $2e66c8b5b2928379$var$ButtonWrapperXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        "aria-label": formatMessage($2e66c8b5b2928379$var$i18n.dislikeTooltip),
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $2e66c8b5b2928379$var$DislikeIconWrapperXCSS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gecH2.ThumbIcon), {
            isSelected: hasBadFeedbackBeenSubmitted
        })),
        onClick: handleDislikeClicked,
        testId: "feedback-dislike-button",
        isDisabled: hasBadFeedbackBeenSubmitted
    }))), isFeedbackOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91uAX.default), {
        locale: feedbackCollectorProperties.locale,
        onSubmit: onFeedbackSubmit,
        onClose: ()=>setIsFeedbackOpen(false),
        atlassianAccountId: feedbackCollectorProperties.userId,
        name: feedbackCollectorProperties.displayName,
        entrypointId: feedbackCollectorProperties.entrypointId,
        summaryPlaceholder: formatMessage($2e66c8b5b2928379$var$i18n.feedbackSummaryPlaceholder),
        additionalFields: [
            {
                id: feedbackCollectorProperties.feedbackContextId,
                value: feedbackContextString
            }
        ],
        feedbackTitle: formatMessage($2e66c8b5b2928379$var$i18n.feedbackTitle),
        showTypeField: false,
        customTextAreaLabel: formatMessage($2e66c8b5b2928379$var$i18n.feedbackSummaryTitle),
        canBeContactedLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$CanContactLabel, null),
        enrolInResearchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$EnrolLabel, null)
    })));
};
module.exports["AIFeedbackComponent"] = $2e66c8b5b2928379$export$f9f34317e5bc3551;

});

parcelRegister("gecH2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $c8bBH = parcelRequire("c8bBH");

const $62e24cf344a5b8b1$export$ec2ba0e929740f73 = ({ isSelected: isSelected })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)",
        label: ""
    });
module.exports["ThumbIcon"] = $62e24cf344a5b8b1$export$ec2ba0e929740f73;

});

parcelRegister("5GgqH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $44sV7 = parcelRequire("44sV7");

const $518681ac338b53b3$export$15dda63faa44a0df = (ref, interval = 500)=>{
    const isOnScreen = (0, $44sV7.useOnScreen)(ref);
    const dwellTimeRef = (0, $cozmU.useRef)(0);
    (0, $cozmU.useEffect)(()=>{
        const incremental = setInterval(()=>{
            if (isOnScreen) dwellTimeRef.current += interval;
        }, interval);
        return ()=>{
            clearInterval(incremental);
        };
    }, [
        isOnScreen,
        interval
    ]);
    const getDwellTime = ()=>dwellTimeRef.current;
    return {
        getDwellTime: getDwellTime
    };
};
module.exports["usePopupDwellTime"] = $518681ac338b53b3$export$15dda63faa44a0df;

});

parcelRegister("44sV7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $9f61f2cd2c8e0202$export$edb9b52ab3f1abbb = (ref)=>{
    const [isIntersecting, setIntersecting] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!ref.current) return;
        const observer = new IntersectionObserver(([entry])=>setIntersecting(entry.isIntersecting));
        if (ref.current) observer.observe(ref.current);
        return ()=>{
            if (observer) observer.disconnect();
        };
    });
    return isIntersecting;
};
module.exports["useOnScreen"] = $9f61f2cd2c8e0202$export$edb9b52ab3f1abbb;

});

parcelRegister("lgull", function(module, exports) {

var $iTtzC = parcelRequire("iTtzC");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $ixfCV = parcelRequire("ixfCV");


var $5JhlM = parcelRequire("5JhlM");


var $a7t2v = parcelRequire("a7t2v");

const $a1264e7348edcdb0$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $a1264e7348edcdb0$export$f50b64530422ea99 = ({ contentId: contentId, fallbackText: fallbackText, queryRef: queryRef, source: source, isHidden: isHidden, maxLines: maxLines, showFooter: showFooter, showAwareness: showAwareness })=>{
    const data = (0, $6SsN4.usePreloadedQuery)((0, $iTtzC.default), queryRef);
    const aiSnippetText = data?.confluence_latestKnowledgeGraphObjectV2?.objectData;
    const content = /*#__PURE__*/ $cozmU.createElement((0, $a7t2v.AISnippetContent), {
        text: aiSnippetText || fallbackText,
        contentId: contentId,
        showFooter: !!aiSnippetText && showFooter,
        showAwareness: !!aiSnippetText && showAwareness,
        source: source,
        isHidden: isHidden,
        maxLines: maxLines,
        renderAsMarkdown: !!aiSnippetText
    });
    if ((0, $ixfCV.fg)('jira-cc-ai-snippet-gate')) return /*#__PURE__*/ $cozmU.createElement((0, $5JhlM.AIFeedbackPropertiesProvider), {
        entrypointId: $a1264e7348edcdb0$var$SNIPPET_ENTRYPOINT_ID,
        userId: data?.me?.user?.accountId,
        displayName: data?.me?.user?.name
    }, content);
    return content;
};
module.exports["AISnippetLoader"] = $a1264e7348edcdb0$export$f50b64530422ea99;

});

parcelRegister("iTtzC", function(module, exports) {
/**
 * @generated SignedSource<<77586322f750ae0b68f16053ceaefeac>>
 * @relayHash 83b5f9dcca400199c020ae8cd7e6e7c7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40
const $34c51f4beec18331$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeMe"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "contentId",
                "variableName": "contentId"
            },
            {
                "kind": "Variable",
                "name": "contentType",
                "variableName": "contentType"
            },
            {
                "kind": "Literal",
                "name": "objectType",
                "value": "snippet_v2"
            }
        ],
        "concreteType": "KnowledgeGraphObjectResponseV2",
        "kind": "LinkedField",
        "name": "confluence_latestKnowledgeGraphObjectV2",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "objectData"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "aiSnippetLoaderQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "condition": "includeMe",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "aiSnippetLoaderQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "condition": "includeMe",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40",
            "metadata": {},
            "name": "aiSnippetLoaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$34c51f4beec18331$var$node.hash = "9d618230ccff7c19cd4e4fee2e2c0a2c";
var $34c51f4beec18331$export$2e2bcd8739ae039 = $34c51f4beec18331$var$node;
module.exports["default"] = $34c51f4beec18331$export$2e2bcd8739ae039;

});

parcelRegister("d8W41", function(module, exports) {

var $caelp = parcelRequire("caelp");


var $b3nqj = parcelRequire("b3nqj");

class $d0502b4ecdd37873$export$2ae0434dccdcb77e {
    lookupName(id) {
        const name = this.nameCache.get(id);
        if (name) {
            this.fireAnalytics(true, name);
            if (this.nameQueue.size === 0) this.scheduleOnAllResolved();
            return name;
        }
        return new Promise((resolve)=>{
            const processingItems = this.processingQueue.get(id);
            if (processingItems) this.processingQueue.set(id, [
                ...processingItems,
                resolve
            ]);
            const queuedItems = this.nameQueue.get(id) || [];
            this.nameQueue.set(id, [
                ...queuedItems,
                resolve
            ]);
            if (queuedItems.length === 0 && !processingItems) this.nameStartTime.set(id, Date.now());
            this.scheduleProcessQueue();
            if (this.isQueueAtLimit()) this.processQueue();
        });
    }
    cacheName(id, name) {
        this.nameCache.set(id, {
            id: id,
            name: name,
            status: (0, $caelp.MentionNameStatus).OK
        });
    }
    scheduleProcessQueue() {
        if (!this.debounce) this.debounce = window.setTimeout(this.processQueue, $d0502b4ecdd37873$export$2ae0434dccdcb77e.waitForBatch);
    }
    scheduleOnAllResolved() {
        if (this.debounceOnResolve) clearTimeout(this.debounceOnResolve);
        this.debounceOnResolve = window.setTimeout(()=>{
            if (this.isOnResolvedAllCalled) return;
            this.onResolvedAll();
            this.isOnResolvedAllCalled = true;
        }, $d0502b4ecdd37873$export$2ae0434dccdcb77e.waitForResolveAll);
    }
    isQueueAtLimit() {
        return this.nameQueue.size >= this.client.getLookupLimit();
    }
    splitQueueAtLimit() {
        const values = Array.from(this.nameQueue.entries());
        const splitPoint = this.client.getLookupLimit();
        return {
            queue: new Map(values.slice(0, splitPoint)),
            extraQueue: new Map(values.slice(splitPoint))
        };
    }
    resolveQueueItem(mentionDetail) {
        const { id: id } = mentionDetail;
        const resolvers = this.processingQueue.get(id);
        if (resolvers) {
            this.processingQueue.delete(id);
            this.nameCache.set(id, mentionDetail);
            resolvers.forEach((resolve)=>{
                try {
                    resolve(mentionDetail);
                } catch  {
                // ignore - exception in consumer
                }
            });
            this.fireAnalytics(false, mentionDetail);
        }
    }
    fireAnalytics(fromCache, mentionDetail) {
        const { id: id } = mentionDetail;
        const action = mentionDetail.status === (0, $caelp.MentionNameStatus).OK ? 'completed' : 'failed';
        const start = this.nameStartTime.get(id);
        const duration = start ? Date.now() - start : 0;
        this.nameStartTime.delete(id);
        this.fireHydrationEvent(action, id, fromCache, duration);
    }
    constructor(client, analyticsProps = {}, onResolvedAll = ()=>{}){
        // ms
        this.client = void 0;
        this.nameCache = new Map();
        this.nameQueue = new Map();
        this.nameStartTime = new Map();
        this.processingQueue = new Map();
        this.debounce = 0;
        this.debounceOnResolve = null;
        this.onResolvedAll = void 0;
        this.isOnResolvedAllCalled = false;
        this.fireHydrationEvent = void 0;
        this.processQueue = ()=>{
            clearTimeout(this.debounce);
            this.debounce = 0;
            const { queue: queue, extraQueue: extraQueue } = this.splitQueueAtLimit();
            this.nameQueue = extraQueue;
            this.processingQueue = $d0502b4ecdd37873$export$71ea0798a8cad7d8(this.processingQueue, queue);
            this.client.lookupMentionNames(Array.from(queue.keys())).then((response)=>{
                response.forEach((mentionDetail)=>{
                    const { id: id } = mentionDetail;
                    queue.delete(id);
                    this.resolveQueueItem(mentionDetail);
                });
                queue.forEach((_callback, id)=>{
                    // No response from client for these ids treat as unknown
                    this.resolveQueueItem({
                        id: id,
                        status: (0, $caelp.MentionNameStatus).UNKNOWN
                    });
                });
            }).catch(()=>{
                // Service completely failed, reject all items in the queue
                queue.forEach((_callback, id)=>{
                    this.resolveQueueItem({
                        id: id,
                        status: (0, $caelp.MentionNameStatus).SERVICE_ERROR
                    });
                });
            });
            // Make sure anything left in the queue gets processed.
            if (this.nameQueue.size > 0) this.scheduleProcessQueue();
            else this.scheduleOnAllResolved();
        };
        this.client = client;
        this.fireHydrationEvent = (0, $b3nqj.fireAnalyticsMentionHydrationEvent)(analyticsProps);
        // If provided, this will be called once all pending mentions in the queue are resolved.
        // A sample usage is scrolling to a mention on page load, after the mentions have loadad.
        this.onResolvedAll = onResolvedAll;
    }
}
/**
 * Merge the two queues making sure to merge callback arrays for items in queueB already in queueA.
 * This addresses [this ticket](https://product-fabric.atlassian.net/browse/QS-3789).
 */ $d0502b4ecdd37873$export$2ae0434dccdcb77e.waitForBatch = 100;
// ms
$d0502b4ecdd37873$export$2ae0434dccdcb77e.waitForResolveAll = 800;
function $d0502b4ecdd37873$export$71ea0798a8cad7d8(queueA, queueB) {
    const queueBeingMerged = new Map([
        ...queueA
    ]);
    // now add the items from the second queue that are not already in the
    //  merged queue being built
    [
        ...queueB
    ].forEach((item)=>{
        const [key, queueBCallbacks] = item;
        const itemAlreadyInMergedQueue = queueBeingMerged.has(key);
        if (!itemAlreadyInMergedQueue) queueBeingMerged.set(key, queueBCallbacks);
        else {
            // item already in merged queue, merge the callback arrays
            const queueACallbacks = queueBeingMerged.get(key) ?? [];
            const mergedCallbacks = new Set([
                ...queueBCallbacks,
                ...queueACallbacks
            ]);
            const deduplicatedCallbacks = Array.from(mergedCallbacks.values()); // prevents calling them twice
            queueBeingMerged.set(key, deduplicatedCallbacks);
        }
    });
    return queueBeingMerged;
}
module.exports["DefaultMentionNameResolver"] = $d0502b4ecdd37873$export$2ae0434dccdcb77e;

});

parcelRegister("k9rxT", function(module, exports) {

var $eaCYh = parcelRequire("eaCYh");


var $2SUNK = parcelRequire("2SUNK");


var $bijHC = parcelRequire("bijHC");

class $f4cb6c0703060f5e$var$CacheEntry {
    expired() {
        return Date.now() > this.expiry;
    }
    constructor(pres, timeout){
        this.presence = void 0;
        this.expiry = void 0;
        this.presence = pres;
        this.expiry = Date.now() + timeout;
    }
}
class $f4cb6c0703060f5e$export$7b4524ed61cc8203 extends (0, $bijHC.AbstractResource) {
    refreshPresence(userIds) {
        throw new Error(`not yet implemented.\nParams: userIds=${userIds}`);
    }
    notifyListeners(presences) {
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(presences);
            } catch (e) {
                // ignore error from listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $f4cb6c0703060f5e$var$PresenceResource extends $f4cb6c0703060f5e$export$7b4524ed61cc8203 {
    refreshPresence(userIds) {
        const cacheHits = this.presenceCache.getBulk(userIds);
        this.notifyListeners(cacheHits);
        const cacheMisses = this.presenceCache.getMissingUserIds(userIds);
        if (cacheMisses.length) this.retrievePresence(cacheMisses);
    }
    retrievePresence(userIds) {
        this.queryDirectoryForPresences(userIds).then((res)=>this.presenceParser.parse(res)).then((presences)=>{
            this.notifyListeners(presences);
            this.presenceCache.update(presences);
        });
    }
    queryDirectoryForPresences(userIds) {
        const query = {
            query: `query getPresenceForMentions($organizationId: String!, $userIds: [String!], $productId: String) {
                PresenceBulk(organizationId: $organizationId, product: $productId, userIds: $userIds) {
                  userId
                  state
                  stateMetadata
                }
              }`,
            variables: {
                organizationId: this.config.cloudId,
                userIds: userIds
            }
        };
        if (this.config.productId) query.variables['productId'] = this.config.productId;
        const atlAttributionHeader = (0, $eaCYh.buildAtlAttributionHeaderValue)({
            cloudId: this.config.cloudId,
            productId: this.config.productId,
            activationId: this.config.activationId
        });
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...atlAttributionHeader,
                ...this.config.headers
            },
            credentials: 'include',
            body: JSON.stringify(query)
        };
        return fetch(this.config.url, options).then((response)=>response.json());
    }
    static cleanUrl(url) {
        if (url.substr(-1) !== '/') url += '/';
        return url;
    }
    constructor(config){
        super();
        this.config = void 0;
        this.presenceCache = void 0;
        this.presenceParser = void 0;
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.cloudId) throw new Error('config.cloudId is a required parameter');
        this.config = config;
        this.config.url = $f4cb6c0703060f5e$var$PresenceResource.cleanUrl(config.url);
        this.presenceCache = config.cache || new $f4cb6c0703060f5e$export$f962b6f1aaaafaf5(config.cacheExpiry);
        this.presenceParser = config.parser || new $f4cb6c0703060f5e$export$80bae4549cafd20d();
    }
}
class $f4cb6c0703060f5e$export$f962b6f1aaaafaf5 {
    /**
   * Precondition: _delete is only called internally if userId exists in cache
   * Removes cache entry
   * @param userId
   */ _delete(userId) {
        delete this.cache[userId];
        this.size--;
    }
    /**
   * Checks a cache entry and calls delete if the info has expired
   * @param userId
   */ _deleteIfExpired(userId) {
        if (this.contains(userId) && this.cache[userId].expired()) this._delete(userId);
    }
    /**
   * Cleans expired entries from cache
   */ _removeExpired() {
        Object.keys(this.cache).forEach((id)=>{
            this._deleteIfExpired(id);
        });
    }
    /**
   * Checks if a user exists in the cache
   * @param userId
   */ contains(userId) {
        return this.cache.hasOwnProperty(userId);
    }
    /**
   * Retrieves a presence from the cache after checking for expired entries
   * @param userId - to index the cache
   * @returns Presence - the presence that matches the userId
   */ get(userId) {
        this._deleteIfExpired(userId);
        if (!this.contains(userId)) return {};
        return this.cache[userId].presence;
    }
    /**
   * Retrieve multiple presences at once from the cache
   * @param userIds - to index the cache
   * @returns PresenceMap - A map of userIds to cached Presences
   */ getBulk(userIds) {
        const presences = {};
        for (const userId of userIds)if (this.contains(userId)) presences[userId] = this.get(userId);
        return presences;
    }
    /**
   * For a given list of ids, returns a subset
   * of all the ids with missing cache entries.
   * @param userIds - to index the cache
   * @returns string[] - ids missing from the cache
   */ getMissingUserIds(userIds) {
        return userIds.filter((id)=>!this.contains(id));
    }
    /**
   * Precondition: presMap only contains ids of users not in cache
   *               expired users must first be removed then reinserted with updated presence
   * Updates the cache by adding the new Presence entries and setting the expiry time
   * @param presMap
   */ update(presMap) {
        if (this.size >= this.flushTrigger) this._removeExpired();
        Object.keys(presMap).forEach((userId)=>{
            this.cache[userId] = new $f4cb6c0703060f5e$var$CacheEntry(presMap[userId], this.expiryInMillis);
            this.size++;
        });
    }
    constructor(cacheTimeout, cacheTrigger){
        this.cache = void 0;
        this.size = void 0;
        this.expiryInMillis = void 0;
        this.flushTrigger = void 0;
        this.expiryInMillis = cacheTimeout ? cacheTimeout : $f4cb6c0703060f5e$export$f962b6f1aaaafaf5.defaultTimeout;
        this.flushTrigger = cacheTrigger ? cacheTrigger : $f4cb6c0703060f5e$export$f962b6f1aaaafaf5.defaultFlushTrigger;
        this.cache = {};
        this.size = 0;
    }
}
$f4cb6c0703060f5e$export$f962b6f1aaaafaf5.defaultTimeout = 20000;
$f4cb6c0703060f5e$export$f962b6f1aaaafaf5.defaultFlushTrigger = 50;
class $f4cb6c0703060f5e$export$80bae4549cafd20d {
    mapState(state) {
        if (state === 'unavailable') return 'offline';
        else if (state === 'available') return 'online';
        else return state;
    }
    parse(response) {
        const presences = {};
        if (response.hasOwnProperty('data') && response['data'].hasOwnProperty('PresenceBulk')) {
            const results = response['data'].PresenceBulk;
            // Store map of state and time indexed by userId.  Ignore null results.
            for (const user of results){
                if (user.userId && user.state) {
                    const state = $f4cb6c0703060f5e$export$80bae4549cafd20d.extractState(user) || user.state;
                    presences[user.userId] = {
                        status: this.mapState(state)
                    };
                } else if (!user.hasOwnProperty('userId') || !user.hasOwnProperty('state')) // eslint-disable-next-line no-console
                console.error('Unexpected response from presence service contains keys: ' + Object.keys(user));
            }
        }
        return presences;
    }
    static extractState(presence) {
        if ($f4cb6c0703060f5e$export$80bae4549cafd20d.isFocusState(presence)) return $f4cb6c0703060f5e$export$80bae4549cafd20d.FOCUS_STATE;
        return presence.state;
    }
    /*
     This is a bit of an odd exception. In the case where a user is in "Focus Mode", their presence state
     is returned as 'busy' along with a `stateMetadata` object containing a `focus` field.
     In this case we ignore the value of the `state` field and treat the presence as a 'focus' state.
    */ static isFocusState(presence) {
        if (presence.stateMetadata) try {
            const metadata = JSON.parse(presence.stateMetadata);
            return metadata && !!metadata.focus;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`Failed to parse presence's stateMetadata for user with id ${presence.userId}: ${presence.stateMetadata}`);
            // eslint-disable-next-line no-console
            console.error(e);
        }
        return false;
    }
}
$f4cb6c0703060f5e$export$80bae4549cafd20d.FOCUS_STATE = 'focus';
var $f4cb6c0703060f5e$export$2e2bcd8739ae039 = $f4cb6c0703060f5e$var$PresenceResource;
module.exports["default"] = $f4cb6c0703060f5e$export$2e2bcd8739ae039;

});

parcelRegister("eaCYh", function(module, exports) {
function $669159666a118337$export$9df8b8301f41e4b7(config) {
    const { cloudId: cloudId, activationId: activationId, productId: productId = 'platform' } = config;
    const value = {
        tenantId: cloudId,
        product: productId
    };
    if (activationId) value.atlWorkspaceId = `ari:cloud:${productId}:${cloudId}:workspace/${activationId}`;
    return {
        'atl-attribution': JSON.stringify(value)
    };
}
module.exports["buildAtlAttributionHeaderValue"] = $669159666a118337$export$9df8b8301f41e4b7;

});

parcelRegister("80Dol", function(module, exports) {

var $bijHC = parcelRequire("bijHC");


var $b3nqj = parcelRequire("b3nqj");


var $caelp = parcelRequire("caelp");


var $f7B1p = parcelRequire("f7B1p");


var $ge2sX = parcelRequire("ge2sX");


var $9fywD = parcelRequire("9fywD");


var $04e9M = parcelRequire("04e9M");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $5CrKL = parcelRequire("5CrKL");


var $j5rtD = parcelRequire("j5rtD");


var $gYPwD = parcelRequire("gYPwD");

const $76cb501321125a14$var$INITIAL_STATE = 'initialState';
const $76cb501321125a14$var$SEARCH = 'searchUser';
const $76cb501321125a14$var$SUCCEEDED = 'succeeded';
const $76cb501321125a14$var$FAILED = 'failed';
const $76cb501321125a14$var$CONTEXT_TYPE = 'Mentions';
/**
 * MAX_NOTIFIED_ITEMS in platform/packages/elements/mention/src/api/MentionResource.ts limits how many mentions returned by UserTeamMentionProvider will be used really! 20 is its value at the time of this writing.
 */ const $76cb501321125a14$var$MAX_RESULTS = 20;
/**
 * platform/packages/editor/editor-plugin-mentions/src/ui/type-ahead/index.tsx sections the mentions returned by UserTeamMentionProvider in agents and non-agents (such as people and teams).
 * But it also defines its own limit per section! 5 is its limit for agents at the time of this writing.
 * So to see both agents and people/non-agents in the sectioned UI, UserTeamMentionProvider needs to arrange enough of each section into the first MAX_RESULTS mentions it returns.
 */ const $76cb501321125a14$var$MIN_AGENT_RESULTS = 5;
// URS filter to include agents (app accounts with agent app type) alongside regular users
const $76cb501321125a14$var$INCLUDE_AGENTS_FILTER = 'account_type:atlassian OR (account_type:app AND app_type:agent)';
// Use in memory cache only
const $76cb501321125a14$var$defaultCache = {
    getStoredValues: ()=>Promise.resolve(new Map()),
    setStoredValues: ()=>Promise.resolve()
};
class $76cb501321125a14$export$f500b4849378edff extends (0, $bijHC.default) {
    /**
   * Overrides `remoteInitialState` from `MentionResource`
   * This is invoked for bootstrap/empty queries,
   */ async remoteInitialState(contextIdentifier) {
        try {
            const promise = await this.doSearch('', contextIdentifier);
            // Set initial cache
            if ((0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true)) this.offlineCache?.set(this.userTeamEndpoint, promise);
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), $76cb501321125a14$var$INITIAL_STATE, $76cb501321125a14$var$SUCCEEDED);
            return promise;
        } catch (e) {
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), $76cb501321125a14$var$INITIAL_STATE, $76cb501321125a14$var$FAILED);
            throw e;
        }
    }
    /**
   * Overrides `remoteSearch` from `MentionResource`
   * This is invoked for non-empty queries.
   */ async remoteSearch(query, contextIdentifier) {
        try {
            const promise = await this.doSearch(query, contextIdentifier);
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), $76cb501321125a14$var$SEARCH, $76cb501321125a14$var$SUCCEEDED);
            return promise;
        } catch (e) {
            this._notifyAnalyticsListeners((0, $b3nqj.SLI_EVENT_TYPE), $76cb501321125a14$var$SEARCH, $76cb501321125a14$var$FAILED);
            throw e;
        }
    }
    async getCachedValue(query) {
        const cachedValue = this.offlineCache?.get(this.userTeamEndpoint);
        if (!cachedValue) return undefined;
        if (query === '') return Promise.resolve(cachedValue);
        else {
            // If we're offline allow basic filtering of the cached results by name.
            if (window?.navigator.onLine === false) return Promise.resolve({
                query: query,
                mentions: cachedValue.mentions?.filter((v)=>v?.name?.toLowerCase().includes(query.toLowerCase()) || v?.mentionName?.toLowerCase().includes(query.toLowerCase()) || v?.nickname?.toLowerCase().includes(query.toLowerCase()))
            });
        }
    }
    async doSearch(query, contextIdentifier) {
        if ((0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true)) {
            const cachedValue = await this.getCachedValue(query);
            // Use stale-while-revalidate - if the cached value exists use it first and
            // update the cache value in the background so that it's up to date when the
            // next call is made
            if (cachedValue) {
                if (query === '') this.doNetworkSearch(query, contextIdentifier).then((results)=>{
                    this.offlineCache?.set(this.userTeamEndpoint, results);
                }).catch(()=>{
                // Pass, it's okay if the cache doesn't update
                });
                return cachedValue;
            }
            return this.doNetworkSearch(query, contextIdentifier);
        } else return this.doNetworkSearch(query, contextIdentifier);
    }
    async doNetworkSearch(query, contextIdentifier) {
        (0, $5CrKL.MENTIONS_QUERY_METRIC).start();
        const [response, agentMentionsResult] = await Promise.all([
            this.post(await this.cloudId(), await this.orgId(), query, contextIdentifier),
            this.includeAgents && (0, $6mKj3.expValEquals)('cc-agent-mentions-via-studio', 'isEnabled', true) ? (0, $gYPwD.queryAgentMentions)(query, $76cb501321125a14$var$MAX_RESULTS).catch(()=>/* For now do not let the experimental queryAgentMentions break the production-available people and teams search. */ ({
                    mentions: [],
                    query: query
                })) : undefined
        ]);
        if (!response.ok) {
            const errorBody = await response.json();
            (0, $5CrKL.MENTIONS_QUERY_METRIC).stop({
                customData: {
                    isExCoEnabled: this.includeExternalCollaborators,
                    success: false
                }
            });
            throw new Error(JSON.stringify(errorBody));
        }
        const body = await response.json();
        const mentions = body.recommendedUsers.map((recommended)=>{
            if (this.isAgent(recommended)) return this.convertToAgentMention(recommended);
            if (this.isUser(recommended)) return this.convertToUserMention(recommended);
            if (this.isTeam(recommended)) return this.convertToTeamMention(recommended);
            // Fallback to user mention for unknown types
            return this.convertToUserMention(recommended);
        });
        let jiraMentions = [];
        if (mentions.length < $76cb501321125a14$var$MAX_RESULTS && this.isEligibleXProductUserInvite && await this.isEligibleXProductUserInvite()) try {
            const jiraResponse = await this.searchXproductUsers(await this.cloudId(), await this.orgId(), query, contextIdentifier);
            if (!jiraResponse.ok) {
                const errorBody = await jiraResponse.json();
                throw new Error(JSON.stringify(errorBody));
            }
            const jiraBody = await jiraResponse.json();
            // Remove objects from jiraMentions if an object with the same id is present in mentions
            const mentionIds = new Set(mentions.map((mention)=>mention.id));
            const recommendedJiraUsers = (jiraBody.recommendedUsers || []).filter((mention)=>!mentionIds.has(mention?.id)).slice(0, $76cb501321125a14$var$MAX_RESULTS - mentions.length);
            //only evaluate the experiment cohort if there are jira mentions to show
            if (recommendedJiraUsers.length > 0 && (0, $6mKj3.expValEquals)('cc_virality_x_product_user_invite', 'cohort', 'test')) jiraMentions = recommendedJiraUsers.map((recommended)=>{
                return {
                    ...this.convertToUserMention(recommended),
                    isXProductUser: true
                };
            });
        } catch (error) {
            const client = await (0, $04e9M.getAnalyticsWebClient)();
            const errorMessages = error instanceof Error ? error.message : String(error);
            client.sendOperationalEvent({
                source: 'editor',
                action: 'errored',
                actionSubject: 'xProductUserSearch',
                attributes: {
                    error: errorMessages,
                    stack: error?.stack
                }
            });
        }
        (0, $5CrKL.MENTIONS_QUERY_METRIC).stop({
            customData: {
                isExCoEnabled: this.includeExternalCollaborators,
                success: true
            }
        });
        let agentMentions = agentMentionsResult?.mentions ?? [];
        let nonAgentMentions = [
            ...mentions,
            ...jiraMentions
        ];
        if (agentMentions.length) {
            // Studio agent results should win if URS ever returns the same agent ID.
            const agentMentionIds = new Set(agentMentions.map((mention)=>mention.id));
            nonAgentMentions = nonAgentMentions.filter((mention)=>!agentMentionIds.has(mention.id));
            agentMentions = agentMentions.slice(0, Math.max($76cb501321125a14$var$MIN_AGENT_RESULTS, $76cb501321125a14$var$MAX_RESULTS - nonAgentMentions.length));
        }
        return {
            query: query,
            mentions: [
                ...agentMentions,
                ...nonAgentMentions
            ]
        };
    }
    async cloudId() {
        const { cloudId: cloudId } = await (0, $ge2sX.getSessionData)();
        return cloudId;
    }
    async orgId() {
        const { orgId: orgId } = await (0, $ge2sX.getSessionData)();
        return orgId;
    }
    async post(cloudId, orgId, query, contextIdentifier) {
        return await (0, $f7B1p.cfetch)(this.userTeamEndpoint, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                context: {
                    contextType: $76cb501321125a14$var$CONTEXT_TYPE,
                    principalId: 'context',
                    productKey: contextIdentifier && contextIdentifier.product || 'confluence',
                    // defaults to 'confluence' to work with old editor
                    siteId: cloudId,
                    containerId: contextIdentifier && contextIdentifier.containerId,
                    objectId: contextIdentifier && contextIdentifier.objectId,
                    childObjectId: contextIdentifier && contextIdentifier.childObjectId,
                    mentionsSessionId: contextIdentifier && contextIdentifier.sessionId,
                    ...orgId ? {
                        organizationId: orgId
                    } : {},
                    ...this.includeExternalCollaborators ? {
                        productAttributes: {
                            isEntitledConfluenceExternalCollaborator: true
                        }
                    } : {}
                },
                searchQuery: {
                    queryString: query,
                    ...this.includeExternalCollaborators ? {
                        productAccessPermissionIds: [
                            'write',
                            'external-collaborator-write'
                        ]
                    } : {},
                    ...this.includeAgents && !(0, $6mKj3.expValEquals)('cc-agent-mentions-via-studio', 'isEnabled', true) ? {
                        filter: $76cb501321125a14$var$INCLUDE_AGENTS_FILTER
                    } : {}
                },
                maxNumberOfResults: $76cb501321125a14$var$MAX_RESULTS,
                includeTeams: true
            })
        });
    }
    async searchXproductUsers(cloudId, orgId, query, contextIdentifier) {
        return await (0, $f7B1p.cfetch)(this.userTeamEndpoint, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({
                context: {
                    contextType: $76cb501321125a14$var$CONTEXT_TYPE,
                    principalId: 'context',
                    productKey: 'jira',
                    // fetch only jira users
                    siteId: cloudId,
                    mentionsSessionId: contextIdentifier && contextIdentifier.sessionId,
                    ...orgId ? {
                        organizationId: orgId
                    } : {}
                },
                searchQuery: {
                    queryString: query,
                    productAccessPermissionIds: [
                        'write'
                    ]
                },
                maxNumberOfResults: $76cb501321125a14$var$MAX_RESULTS,
                includeTeams: false // Do not include teams
            })
        });
    }
    isAgent(recommended) {
        // Agents are returned as USER entity type with appType 'agent'
        return recommended.entityType === 'USER' && recommended.appType === 'agent';
    }
    convertToAgentMention(recommended) {
        return {
            id: recommended.id,
            name: recommended.name || recommended.nickname || '',
            mentionName: recommended.nickname || '',
            avatarUrl: recommended.avatarUrl,
            accessLevel: recommended.accessLevel,
            userType: 'APP',
            // Mark as app/agent type
            appType: 'agent'
        };
    }
    isUser(recommended) {
        // Regular users have entityType USER but no agent appType
        return recommended.entityType === 'USER' && recommended.appType !== 'agent';
    }
    convertToUserMention(recommended) {
        return {
            id: recommended.id,
            name: recommended.name || recommended.nickname || '',
            mentionName: recommended.nickname || '',
            avatarUrl: recommended.avatarUrl,
            accessLevel: recommended.accessLevel,
            userType: recommended.userType,
            ...recommended?.attributes?.isConfluenceExternalCollaborator ? {
                lozenge: (0, $9fywD.ExternalUserLozengeProps)
            } : {}
        };
    }
    isTeam(recommended) {
        return recommended.entityType === 'TEAM';
    }
    convertToTeamMention(recommended) {
        const { teamLinkResolver: teamLinkResolver } = this.teamMentionConfig;
        let teamLink = '';
        const defaultTeamLink = `${window.location.origin}/people/team/${recommended.id}`;
        if (typeof teamLinkResolver === 'function') teamLink = teamLinkResolver(recommended.id);
        return {
            id: recommended.id,
            name: recommended.displayName,
            mentionName: recommended.displayName,
            avatarUrl: recommended.smallAvatarImageUrl,
            accessLevel: (0, $caelp.UserAccessLevel)[(0, $caelp.UserAccessLevel).CONTAINER],
            userType: (0, $caelp.UserType)[(0, $caelp.UserType).TEAM],
            context: {
                members: recommended.members,
                includesYou: recommended.includesYou,
                memberCount: recommended.memberCount,
                teamLink: teamLink || defaultTeamLink
            }
        };
    }
    constructor(userTeamEndpoint, userMentionConfig, teamMentionConfig, includeExternalCollaborators, isEligibleXProductUserInvite, includeAgents = false){
        super(userMentionConfig);
        this.userTeamEndpoint = void 0;
        this.teamMentionConfig = void 0;
        this.includeExternalCollaborators = void 0;
        this.includeAgents = void 0;
        this.offlineCache = void 0;
        this.isEligibleXProductUserInvite = void 0;
        this.teamMentionConfig = teamMentionConfig;
        this.userTeamEndpoint = userTeamEndpoint;
        this.includeExternalCollaborators = includeExternalCollaborators;
        this.includeAgents = includeAgents;
        this.isEligibleXProductUserInvite = isEligibleXProductUserInvite;
        const cache = (0, $9wGTI.fg)('platform_editor_offline_editing_web_ga_fixes') ? $76cb501321125a14$var$defaultCache : undefined;
        this.offlineCache = (0, $6mKj3.expValEquals)('platform_editor_offline_editing_web', 'isEnabled', true) ? new (0, $j5rtD.OfflineCache)(cache) : undefined;
    }
}
module.exports["UserTeamMentionProvider"] = $76cb501321125a14$export$f500b4849378edff;

});

parcelRegister("5CrKL", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $41760797bb45431a$export$59eae628ebf25df4 = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.MENTIONS_QUERY_CUSTOM_KEY)
});
module.exports["MENTIONS_QUERY_METRIC"] = $41760797bb45431a$export$59eae628ebf25df4;

});

parcelRegister("j5rtD", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");

class $099b8337f3ad112c$export$8904fcd398c673fb {
    update() {
        this.storageManager.setStoredValues(this.map).catch(()=>{
        // Pass, it's okay if this fails
        });
    }
    destroy() {
        this.unloadCleanup();
    }
    get(key) {
        return this.map.get(key);
    }
    set(key, value) {
        this.map.set(key, value);
    }
    constructor(storageManager){
        this.map = new Map();
        this.storageManager = void 0;
        this.unloadCleanup = ()=>{};
        const cacheName = 'editor:offline-network-request-cache';
        this.storageManager = storageManager ?? new $099b8337f3ad112c$var$IndexedDBManager(cacheName);
        this.storageManager.getStoredValues()?.then((v)=>{
            this.map = v;
        }).catch(()=>{
        // If the offline cache is rejected, use the initial empty map
        });
        if (window !== undefined) this.unloadCleanup = (0, $cbY7C.bind)(window, {
            type: 'beforeunload',
            listener: ()=>{
                this.update();
            }
        });
    }
}
/** Storage manager using indexeddb */ class $099b8337f3ad112c$var$IndexedDBManager {
    openDatabase() {
        return new Promise((resolve, reject)=>{
            const request = indexedDB.open(this.cacheName, 2);
            request.onupgradeneeded = (event)=>{
                const db = event.target.result;
                // Clear old results
                if (db.objectStoreNames.contains(this.objectStoreName)) db.deleteObjectStore(this.objectStoreName);
                db.createObjectStore(this.objectStoreName);
            };
            request.onsuccess = ()=>{
                resolve(request.result);
            };
            request.onerror = ()=>{
                reject(request.error);
            };
        });
    }
    // Retrieve a map of values for a store based on a set of keys
    async getAllStoredValues(store, keys) {
        const allValues = [];
        for (const key of keys){
            const valueRequest = store.get(key);
            allValues.push(new Promise((resolve, reject)=>{
                valueRequest.onsuccess = ()=>resolve([
                        key,
                        JSON.parse(valueRequest.result)
                    ]);
                valueRequest.onerror = ()=>reject(valueRequest.error);
            }));
        }
        return new Map(await Promise.all(allValues));
    }
    getStoredValues() {
        return this.dbPromise?.then((db)=>{
            return new Promise((resolve, reject)=>{
                const transaction = db.transaction(this.objectStoreName, 'readonly');
                const store = transaction.objectStore(this.objectStoreName);
                const request = store.getAllKeys();
                request.onsuccess = async ()=>{
                    const keys = request.result;
                    const resultMap = await this.getAllStoredValues(store, keys);
                    resolve(resultMap);
                };
                request.onerror = ()=>{
                    reject(request.error);
                };
            });
        }) ?? Promise.reject();
    }
    setStoredValues(values) {
        return this.dbPromise?.then((db)=>{
            return new Promise((resolve, reject)=>{
                const transaction = db.transaction(this.objectStoreName, 'readwrite');
                const store = transaction.objectStore(this.objectStoreName);
                transaction.oncomplete = ()=>resolve();
                transaction.onerror = ()=>reject(transaction.error);
                if (values.size === 0) return;
                // Clear the existing entries before setting new values
                store.clear().onsuccess = ()=>{
                    values.forEach((value, key)=>{
                        const serialisedValue = $099b8337f3ad112c$export$ad730aacbc246ec2(value);
                        if (serialisedValue !== null) store.put(serialisedValue, key);
                    });
                };
            });
        }) ?? Promise.reject();
    }
    constructor(cacheName){
        this.cacheName = cacheName;
        this.dbPromise = undefined;
        this.objectStoreName = 'cache';
        if (window?.indexedDB) this.dbPromise = this.openDatabase();
    }
}
function $099b8337f3ad112c$export$ad730aacbc246ec2(obj) {
    try {
        return JSON.stringify(obj, (_key, value)=>{
            if (typeof value !== 'string' && typeof value !== 'number' && typeof value !== 'boolean' && value !== null && value !== undefined && typeof value !== 'object' && !Array.isArray(value)) throw new Error('Non-serializable property found');
            return value;
        });
    } catch (error) {
        return null;
    }
}
module.exports["OfflineCache"] = $099b8337f3ad112c$export$8904fcd398c673fb;

});

parcelRegister("gYPwD", function(module, exports) {

var $gNfbp = parcelRequire("gNfbp");


var $eKwxR = parcelRequire("eKwxR");


var $kCDdC = parcelRequire("kCDdC");


var $as9lu = parcelRequire("as9lu");


var $c0rhi = parcelRequire("c0rhi");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $ge2sX = parcelRequire("ge2sX");

const $5016900c96a66750$var$PRODUCT = 'confluence';
async function $5016900c96a66750$export$edde3720d795ca12(query, maxResults) {
    let mentions;
    try {
        mentions = query ? await $5016900c96a66750$var$queryAgentMentionsByName(query, maxResults) : await $5016900c96a66750$var$queryAgentMentionsForInitialState(maxResults);
    } catch (error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).COMMENTS
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        throw error;
    }
    return {
        query: query,
        mentions: mentions
    };
}
async function $5016900c96a66750$var$queryAgentMentionsByName(query, maxResults) {
    const { cloudId: cloudId } = await (0, $ge2sX.getSessionData)();
    const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
        query: $5016900c96a66750$var$queryAgentMentionsByNameQuery,
        variables: {
            cloudId: cloudId,
            first: maxResults,
            input: {
                name: query
            },
            product: $5016900c96a66750$var$PRODUCT
        },
        interopApolloAggClient: true,
        __callerPackage__: "fabric-media-support"
    });
    if (error) throw error;
    return $5016900c96a66750$var$convertToMentions(data?.agentStudio_getAgents?.edges);
}
async function $5016900c96a66750$var$queryAgentMentionsForInitialState(maxResults) {
    const { cloudId: cloudId } = await (0, $ge2sX.getSessionData)();
    const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
        query: $5016900c96a66750$var$queryAgentMentionsForInitialStateQuery,
        variables: {
            cloudId: cloudId,
            first: maxResults,
            product: $5016900c96a66750$var$PRODUCT
        },
        interopApolloAggClient: true,
        __callerPackage__: "fabric-media-support"
    });
    if (error) throw error;
    const mentions = [
        ...$5016900c96a66750$var$convertToMentions(data?.favoriteAgents?.edges),
        ...$5016900c96a66750$var$convertToMentions(data?.verifiedAgents?.edges),
        ...$5016900c96a66750$var$convertToMentions(data?.allAgents?.edges)
    ];
    // Only return the first distinct maxResults:
    const returnedMentionIds = new Set();
    return mentions.filter((mention)=>{
        if (returnedMentionIds.size >= maxResults || returnedMentionIds.has(mention.id)) return false;
        returnedMentionIds.add(mention.id);
        return true;
    });
}
function $5016900c96a66750$var$convertToMentions(edges) {
    return edges?.map((edge)=>edge.node).filter((agent)=>Boolean(agent?.identityAccountId && agent?.name)).map($5016900c96a66750$var$convertToMentionDescription) ?? [];
}
function $5016900c96a66750$var$convertToMentionDescription(agent) {
    return {
        appType: 'agent',
        avatarUrl: agent.identityAccount?.picture || undefined,
        id: $5016900c96a66750$export$8cac12d91c2ad785(agent.identityAccountId),
        mentionName: agent.name,
        name: agent.name,
        userType: 'APP'
    };
}
function $5016900c96a66750$export$8cac12d91c2ad785(identityAccountId) {
    try {
        return (0, $as9lu.IdentityUserAri).parse(identityAccountId).userId;
    } catch  {
        return identityAccountId;
    }
}
const $5016900c96a66750$export$ee0ef79a58e4aab4 = (0, $kCDdC.default);
const $5016900c96a66750$var$queryAgentMentionsByNameQuery = (0, $eKwxR.default);
const $5016900c96a66750$var$queryAgentMentionsForInitialStateQuery = (0, $gNfbp.default);
module.exports["queryAgentMentions"] = $5016900c96a66750$export$edde3720d795ca12;

});

parcelRegister("gNfbp", function(module, exports) {
/**
 * @generated SignedSource<<2ee8fe33c19e4f9063e8dd041ceb8f23>>
 * @relayHash 7b785860460f5ebc81d58c2b0e045e7f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c81ec65c5c5d60a55cb747f2548d08913593c05c93fc1c57f3d1a050f86097a0
const $23b05ae499fb93a6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "product"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v3 = {
        "kind": "Variable",
        "name": "product",
        "variableName": "product"
    }, v4 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "input",
            "value": {
                "onlyFavouriteAgents": true
            }
        },
        v3 /*: any*/ 
    ], v5 = [
        {
            "concreteType": "AgentStudioAgentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "AgentStudioAssistant",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "queryAgentMentionsFragment"
                        }
                    ]
                }
            ]
        }
    ], v6 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "input",
            "value": {
                "onlyVerifiedAgents": true
            }
        },
        v3 /*: any*/ 
    ], v7 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        v3 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = [
        {
            "concreteType": "AgentStudioAgentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "AgentStudioAssistant",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "identityAccount",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                },
                                v8 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "identityAccountId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "queryAgentMentionsForInitialStateQuery",
            "selections": [
                {
                    "alias": "favoriteAgents",
                    "args": v4 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v5 /*: any*/ 
                },
                {
                    "alias": "verifiedAgents",
                    "args": v6 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v5 /*: any*/ 
                },
                {
                    "alias": "allAgents",
                    "args": v7 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v5 /*: any*/ 
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "queryAgentMentionsForInitialStateQuery",
            "selections": [
                {
                    "alias": "favoriteAgents",
                    "args": v4 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v9 /*: any*/ 
                },
                {
                    "alias": "verifiedAgents",
                    "args": v6 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v9 /*: any*/ 
                },
                {
                    "alias": "allAgents",
                    "args": v7 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": v9 /*: any*/ 
                }
            ]
        },
        "params": {
            "cacheID": "7b785860460f5ebc81d58c2b0e045e7f",
            "id": "c81ec65c5c5d60a55cb747f2548d08913593c05c93fc1c57f3d1a050f86097a0",
            "metadata": {},
            "name": "queryAgentMentionsForInitialStateQuery",
            "operationKind": "query",
            "text": "query queryAgentMentionsForInitialStateQuery($cloudId:String!,$first:Int,$product:String){favoriteAgents:agentStudio_getAgents(cloudId:$cloudId,first:$first,input:{onlyFavouriteAgents:true},product:$product)@optIn(to:\"AgentStudio\"){edges{node{...queryAgentMentionsFragment,id}}},verifiedAgents:agentStudio_getAgents(cloudId:$cloudId,first:$first,input:{onlyVerifiedAgents:true},product:$product)@optIn(to:\"AgentStudio\"){edges{node{...queryAgentMentionsFragment,id}}},allAgents:agentStudio_getAgents(cloudId:$cloudId,first:$first,product:$product)@optIn(to:\"AgentStudio\"){edges{node{...queryAgentMentionsFragment,id}}}}fragment queryAgentMentionsFragment on AgentStudioAssistant{id,identityAccount{__typename,picture,id},identityAccountId,name}"
        }
    };
}();
$23b05ae499fb93a6$var$node.hash = "54c8a3fa54cf1a93b819180555258d2c";
var $23b05ae499fb93a6$export$2e2bcd8739ae039 = $23b05ae499fb93a6$var$node;
module.exports["default"] = $23b05ae499fb93a6$export$2e2bcd8739ae039;

});

parcelRegister("eKwxR", function(module, exports) {
/**
 * @generated SignedSource<<b38abdea21979ac89988fedcade2900a>>
 * @relayHash af5c4bbb45836e5f91a661e5fbbb6eaf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6e952366d0aeb9cf6c40f69fa4803667ddd767a6e071e19da2f2f86c12a041a9
const $d9f9c84cb1e3d64f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "product"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        },
        {
            "kind": "Variable",
            "name": "product",
            "variableName": "product"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "queryAgentMentionsByNameQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AgentStudioAgentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "AgentStudioAssistant",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "queryAgentMentionsFragment"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "queryAgentMentionsByNameQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "AgentStudioAgentsConnection",
                    "kind": "LinkedField",
                    "name": "agentStudio_getAgents",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AgentStudioAgentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "AgentStudioAssistant",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "identityAccount",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "picture"
                                                },
                                                v2 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "identityAccountId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "af5c4bbb45836e5f91a661e5fbbb6eaf",
            "id": "6e952366d0aeb9cf6c40f69fa4803667ddd767a6e071e19da2f2f86c12a041a9",
            "metadata": {},
            "name": "queryAgentMentionsByNameQuery",
            "operationKind": "query",
            "text": "query queryAgentMentionsByNameQuery($cloudId:String!,$first:Int,$input:AgentStudioAgentQueryInput,$product:String){agentStudio_getAgents(cloudId:$cloudId,first:$first,input:$input,product:$product)@optIn(to:\"AgentStudio\"){edges{node{...queryAgentMentionsFragment,id}}}}fragment queryAgentMentionsFragment on AgentStudioAssistant{id,identityAccount{__typename,picture,id},identityAccountId,name}"
        }
    };
}();
$d9f9c84cb1e3d64f$var$node.hash = "690288a271f716fd79b8de43d77b3b26";
var $d9f9c84cb1e3d64f$export$2e2bcd8739ae039 = $d9f9c84cb1e3d64f$var$node;
module.exports["default"] = $d9f9c84cb1e3d64f$export$2e2bcd8739ae039;

});

parcelRegister("kCDdC", function(module, exports) {
/**
 * @generated SignedSource<<82f707f5e1900b63ef6d27065ff30e56>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5c4367f6180fde75$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "queryAgentMentionsFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "LinkedField",
            "name": "identityAccount",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "picture"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "identityAccountId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ],
    "type": "AgentStudioAssistant"
};
$5c4367f6180fde75$var$node.hash = "e8b4ce6a6bbc22c76e7da2a2f720ab58";
var $5c4367f6180fde75$export$2e2bcd8739ae039 = $5c4367f6180fde75$var$node;
module.exports["default"] = $5c4367f6180fde75$export$2e2bcd8739ae039;

});

parcelRegister("g2yI6", function(module, exports) {

var $89CKS = parcelRequire("89CKS");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $28b5c5efee4d19cf$var$fetchMentionsProviderDataQuery = (0, $89CKS.default);
const $28b5c5efee4d19cf$export$5ced7267a5286f97 = async ()=>{
    return (0, $c0rhi.queryInterop)({
        query: $28b5c5efee4d19cf$var$fetchMentionsProviderDataQuery,
        __callerPackage__: "fabric-media-support"
    }).then(({ data: data })=>{
        return data;
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
module.exports["fetchMentionsProviderData"] = $28b5c5efee4d19cf$export$5ced7267a5286f97;

});

parcelRegister("jdplc", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $lP4rW = parcelRequire("lP4rW");


var $7Jrsi = parcelRequire("7Jrsi");


var $1aZze = parcelRequire("1aZze");


var $28aNf = parcelRequire("28aNf");


var $bnkCY = parcelRequire("bnkCY");

const $93067ab894e7d078$export$c1375d8d7bd75982 = ({ config: config, api: api })=>{
    const editorAnalyticsAPI = api?.analytics?.actions;
    const isNewToolbarEnabled = Boolean(api?.toolbar);
    // Workaround since we want to insert a loom via the `hyperlink` plugin for now.
    // The hyperlink plugin (and the card plugin) are deeply tied into using the Prosemirror Command
    // Ideally one day we refactor those and we can remove this.
    const editorViewRef = {
        current: null
    };
    const primaryToolbarComponent = (0, $1aZze.loomPrimaryToolbarComponent)(config, api);
    if (isNewToolbarEnabled) api?.toolbar?.actions.registerComponents((0, $bnkCY.getToolbarComponents)(config, api));
    else api?.primaryToolbar?.actions.registerComponent({
        name: 'loom',
        component: primaryToolbarComponent
    });
    return {
        name: 'loom',
        actions: {
            recordVideo: $lP4rW.recordVideo,
            insertLoom: (video, positionType)=>(0, $lP4rW.insertLoom)(editorViewRef.current, api, video, positionType),
            initLoom: ({ loomProvider: loomProvider })=>{
                return (0, $lP4rW.setupLoom)(loomProvider, api, editorViewRef.current, true);
            }
        },
        pmPlugins: ()=>[
                {
                    name: 'loom',
                    plugin: ()=>(0, $7Jrsi.createPlugin)({
                            config: config,
                            api: api
                        })
                },
                {
                    name: 'loomViewRefWorkaround',
                    plugin: ()=>{
                        return new (0, $kpCD8.SafePlugin)({
                            view: (editorView)=>{
                                // Do not cleanup the editorViewRef on destroy
                                // because some functions may point to a stale
                                // reference and this means we will return null.
                                // EditorView is assumed to be stable so we do not need to
                                // cleanup.
                                // See: #hot-106316
                                editorViewRef.current = editorView;
                                return {};
                            }
                        });
                    }
                }
            ],
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $7Jrsi.loomPluginKey).getState(editorState);
        },
        pluginsOptions: {
            // Enable inserting Loom recordings through the slash command
            quickInsert: (intl)=>{
                if (config.loomProvider) return (0, $28aNf.getQuickInsertItem)(editorAnalyticsAPI)(intl);
                return [];
            }
        },
        // Enable inserting Loom recordings through main toolbar
        primaryToolbarComponent: !api?.primaryToolbar && !isNewToolbarEnabled ? primaryToolbarComponent : undefined
    };
};
module.exports["loomPlugin"] = $93067ab894e7d078$export$c1375d8d7bd75982;

});

parcelRegister("lP4rW", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $jv11C = parcelRequire("jv11C");


var $28aNf = parcelRequire("28aNf");


var $7Jrsi = parcelRequire("7Jrsi");

const $fa941eae7657c6f0$export$b5c7c74886310ae0 = ({ loomButton: loomButton })=>({ tr: tr })=>{
        tr.setMeta((0, $7Jrsi.loomPluginKey), {
            type: (0, $7Jrsi.LoomPluginAction).ENABLE,
            loomButton: loomButton
        });
        return tr;
    };
const $fa941eae7657c6f0$export$6f61f49dd8b64c45 = ({ error: error })=>({ tr: tr })=>{
        tr.setMeta((0, $7Jrsi.loomPluginKey), {
            type: (0, $7Jrsi.LoomPluginAction).DISABLE,
            error: error
        });
        return tr;
    };
const $fa941eae7657c6f0$export$2d56b03ca3f4ead9 = ({ inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI })=>({ tr: tr })=>{
        tr.setMeta((0, $7Jrsi.loomPluginKey), {
            type: (0, $7Jrsi.LoomPluginAction).RECORD_VIDEO
        });
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).RECORD_VIDEO,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).LOOM,
            attributes: {
                inputMethod: inputMethod
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    };
const $fa941eae7657c6f0$export$3b5a9e613ed2ae87 = ({ inputMethod: inputMethod, error: error, editorAnalyticsAPI: editorAnalyticsAPI })=>({ tr: tr })=>{
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).RECORD_VIDEO_FAILED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).LOOM,
            attributes: {
                inputMethod: inputMethod,
                error: error
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    };
const $fa941eae7657c6f0$export$73a289ac38fc1ec = ({ editorAnalyticsAPI: editorAnalyticsAPI, video: video })=>({ tr: tr })=>{
        tr.setMeta((0, $7Jrsi.loomPluginKey), {
            type: (0, $7Jrsi.LoomPluginAction).INSERT_VIDEO
        });
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).INSERT_VIDEO,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).LOOM,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                duration: video.duration
            }
        })(tr);
        return tr;
    };
const $fa941eae7657c6f0$var$getPositions = (tr, posType)=>{
    const selection = tr.selection;
    switch(posType){
        case 'current':
            return {
                from: selection.from,
                to: selection.from
            };
        case 'start':
            return {
                from: 0,
                to: 0
            };
        case 'end':
            return {
                from: tr.doc.content.size,
                to: tr.doc.content.size
            };
    }
};
const $fa941eae7657c6f0$export$e61f2d2bdaa7ecf4 = (editorView, api, video, positionType)=>{
    if (!editorView) return false;
    const { state: state, dispatch: dispatch } = editorView;
    const { from: from, to: to } = $fa941eae7657c6f0$var$getPositions(state.tr, positionType);
    return api?.hyperlink?.actions.insertLink((0, $krYZG.INPUT_METHOD).TYPEAHEAD, from, to, video.sharedUrl, video.title, undefined, undefined, undefined, 'embed')(state, dispatch) ?? false;
};
const $fa941eae7657c6f0$export$92a5ff9a4d5c2287 = (api)=>{
    api?.core?.actions.execute($fa941eae7657c6f0$export$2d56b03ca3f4ead9({
        inputMethod: (0, $krYZG.INPUT_METHOD).TOOLBAR,
        editorAnalyticsAPI: api?.analytics?.actions
    }));
};
const $fa941eae7657c6f0$export$a39487b0b81d2404 = async (loomProvider, api, editorView, /**
	 * Whether loom initialisation is evoked via `initLoom` command.
	 */ initViaCommand)=>{
    const clientResult = await loomProvider.getClient();
    if (clientResult.status === 'error') {
        api?.core?.actions.execute($fa941eae7657c6f0$export$6f61f49dd8b64c45({
            error: clientResult.message
        }));
        (0, $jv11C.logException)(new Error(clientResult.message), {
            location: 'editor-plugin-loom/sdk-initialisation'
        });
        api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).ERRORED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).LOOM,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: clientResult.message
            }
        });
        return {
            error: clientResult.message
        };
    }
    const { attachToButton: attachToButton } = clientResult.client;
    // Hidden element to work around the SDK API
    const loomButton = document.createElement('button');
    attachToButton({
        button: loomButton,
        onInsert: (video)=>{
            if (!editorView) return;
            const { state: state, dispatch: dispatch } = editorView;
            const pos = state.selection.from;
            api?.hyperlink?.actions.insertLink((0, $krYZG.INPUT_METHOD).TYPEAHEAD, pos, pos, video.sharedUrl, video.title, undefined, undefined, undefined, 'embed')(state, dispatch);
            api?.core?.actions.execute($fa941eae7657c6f0$export$73a289ac38fc1ec({
                editorAnalyticsAPI: api?.analytics?.actions,
                video: video
            }));
        }
    });
    api?.core?.actions.execute(({ tr: tr })=>{
        $fa941eae7657c6f0$export$b5c7c74886310ae0({
            loomButton: loomButton
        })({
            tr: tr
        });
        if (initViaCommand) api?.quickInsert?.commands.addQuickInsertItem((0, $28aNf.getQuickInsertItem)(api?.analytics?.actions))({
            tr: tr
        });
        return tr;
    });
    // We're not combining the analytics steps into the enable / disable commands because the collab-edit plugin
    // filters out any transactions with steps (even analytics) when it's initialising.
    // Even if `initViaCommand` is true, collab-edit might not be ready depending on when `initLoom` is called,
    // hence the analytics step is added separately in both cases
    api?.analytics?.actions.fireAnalyticsEvent({
        action: (0, $krYZG.ACTION).INITIALISED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).LOOM,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
    });
    return {};
};
module.exports["recordVideo"] = $fa941eae7657c6f0$export$2d56b03ca3f4ead9;
module.exports["recordVideoFailed"] = $fa941eae7657c6f0$export$3b5a9e613ed2ae87;
module.exports["insertLoom"] = $fa941eae7657c6f0$export$e61f2d2bdaa7ecf4;
module.exports["executeRecordVideo"] = $fa941eae7657c6f0$export$92a5ff9a4d5c2287;
module.exports["setupLoom"] = $fa941eae7657c6f0$export$a39487b0b81d2404;

});

parcelRegister("28aNf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $gx3UZ = parcelRequire("gx3UZ");


var $jv11C = parcelRequire("jv11C");


var $60Yxm = parcelRequire("60Yxm");


var $lP4rW = parcelRequire("lP4rW");


var $7Jrsi = parcelRequire("7Jrsi");

const $c5f309acd343d20a$export$3432d7b65cad662d = (editorAnalyticsAPI)=>({ formatMessage: formatMessage })=>[
            {
                id: 'loom',
                title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).recordVideo),
                description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).recordVideoDescription),
                keywords: [
                    'loom',
                    'record',
                    'video'
                ],
                priority: 800,
                isDisabledOffline: true,
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($60Yxm))), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)",
                        spacing: "spacious"
                    }),
                action (insert, editorState) {
                    const tr = insert(undefined);
                    const loomState = (0, $7Jrsi.loomPluginKey).getState(editorState);
                    if (!loomState?.isEnabled) {
                        const errorMessage = loomState?.error;
                        (0, $jv11C.logException)(new Error(errorMessage), {
                            location: 'editor-plugin-loom/quick-insert-record-video'
                        });
                        return (0, $lP4rW.recordVideoFailed)({
                            inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT,
                            error: errorMessage,
                            editorAnalyticsAPI: editorAnalyticsAPI
                        })({
                            tr: tr
                        }) ?? false;
                    }
                    return (0, $lP4rW.recordVideo)({
                        inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT,
                        editorAnalyticsAPI: editorAnalyticsAPI
                    })({
                        tr: tr
                    }) ?? false;
                }
            }
        ];
module.exports["getQuickInsertItem"] = $c5f309acd343d20a$export$3432d7b65cad662d;

});

parcelRegister("7Jrsi", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $lP4rW = parcelRequire("lP4rW");

var $a44fd40d86cc104a$export$5f9dbfce88541fe5 = /*#__PURE__*/ function(LoomPluginAction) {
    LoomPluginAction[LoomPluginAction["ENABLE"] = 0] = "ENABLE";
    LoomPluginAction[LoomPluginAction["DISABLE"] = 1] = "DISABLE";
    LoomPluginAction[LoomPluginAction["RECORD_VIDEO"] = 2] = "RECORD_VIDEO";
    LoomPluginAction[LoomPluginAction["INSERT_VIDEO"] = 3] = "INSERT_VIDEO";
    return LoomPluginAction;
}({});
const $a44fd40d86cc104a$export$db6b5ebe5a8c279 = new (0, $kCECX.PluginKey)('loom');
const $a44fd40d86cc104a$export$ae829ec7b2625219 = ({ config: config, api: api })=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $a44fd40d86cc104a$export$db6b5ebe5a8c279,
        state: {
            init: ()=>({
                    isEnabled: false,
                    loomButton: null,
                    isRecordingVideo: false,
                    error: undefined
                }),
            apply: (tr, pluginState)=>{
                const action = tr.getMeta($a44fd40d86cc104a$export$db6b5ebe5a8c279)?.type;
                switch(action){
                    case 0:
                        const { loomButton: loomButton } = tr.getMeta($a44fd40d86cc104a$export$db6b5ebe5a8c279);
                        return {
                            ...pluginState,
                            isEnabled: true,
                            loomButton: loomButton
                        };
                    case 1:
                        const { error: error } = tr.getMeta($a44fd40d86cc104a$export$db6b5ebe5a8c279);
                        return {
                            ...pluginState,
                            isEnabled: false,
                            loomButton: null,
                            error: error
                        };
                    case 2:
                        // Click the unmounted button in state that has the Loom SDK attached
                        pluginState?.loomButton?.click();
                        return {
                            ...pluginState,
                            isRecordingVideo: true
                        };
                    case 3:
                        return {
                            ...pluginState,
                            isRecordingVideo: false
                        };
                    default:
                        return pluginState;
                }
            }
        },
        view (editorView) {
            if (config.loomProvider) (0, $lP4rW.setupLoom)(config.loomProvider, api, editorView);
            return {};
        }
    });
};
module.exports["LoomPluginAction"] = $a44fd40d86cc104a$export$5f9dbfce88541fe5;
module.exports["loomPluginKey"] = $a44fd40d86cc104a$export$db6b5ebe5a8c279;
module.exports["createPlugin"] = $a44fd40d86cc104a$export$ae829ec7b2625219;

});

parcelRegister("1aZze", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $3k5Tv = parcelRequire("3k5Tv");


var $6Ixg8 = parcelRequire("6Ixg8");


var $lP4rW = parcelRequire("lP4rW");


var $g00sD = parcelRequire("g00sD");

const $ec640dec66ccb66d$var$selector = (states)=>{
    return {
        loomEnabled: states.loomState?.isEnabled,
        connectivityMode: states.connectivityState?.mode
    };
};
const $ec640dec66ccb66d$var$CustomisableLoomToolbarButton = (disabled, appearance, api)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((props, ref)=>{
        const { onClickBeforeInit: onClickBeforeInit, isDisabled: isDisabled = false, href: href, ...restProps } = props;
        const { loomEnabled: loomEnabled, connectivityMode: connectivityMode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
            'loom',
            'connectivity'
        ], $ec640dec66ccb66d$var$selector);
        const isLoomEnabled = !!loomEnabled;
        const handleOnClick = (0, $cozmU.useCallback)((e)=>{
            if (isLoomEnabled) (0, $lP4rW.executeRecordVideo)(api);
            else onClickBeforeInit && onClickBeforeInit(e);
        }, [
            isLoomEnabled,
            onClickBeforeInit
        ]);
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $g00sD.default), {
            ref: ref,
            hideTooltip: !!(restProps.onMouseEnter || restProps.onMouseLeave),
            // Ignore href if Loom is enabled so that it doesn't interfere with recording
            href: isLoomEnabled ? undefined : href,
            disabled: disabled || isDisabled || (0, $6Ixg8.isOfflineMode)(connectivityMode),
            api: api,
            appearance: appearance,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (e)=>handleOnClick(e),
            ...restProps
        });
    });
const $ec640dec66ccb66d$var$LoomToolbarButtonWrapper = ({ disabled: disabled, api: api, appearance: appearance })=>{
    const handleOnClick = (0, $cozmU.useCallback)(()=>(0, $lP4rW.executeRecordVideo)(api), [
        api
    ]);
    const { loomEnabled: loomEnabled, connectivityMode: connectivityMode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'loom',
        'connectivity'
    ], $ec640dec66ccb66d$var$selector);
    if (loomEnabled === undefined) return null;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $g00sD.default), {
        // Disable the icon while the SDK isn't initialised
        disabled: disabled || !loomEnabled || (0, $6Ixg8.isOfflineMode)(connectivityMode),
        api: api,
        appearance: appearance,
        onClick: handleOnClick
    });
};
const $ec640dec66ccb66d$export$b7aa095334bc8677 = (config, api)=>({ disabled: disabled, appearance: appearance })=>{
        if (config.shouldShowToolbarButton === false) return null;
        if (config.renderButton) return config.renderButton($ec640dec66ccb66d$var$CustomisableLoomToolbarButton(disabled, appearance, api));
        if (config.shouldShowToolbarButton) return /*#__PURE__*/ (0, $lOiVq.jsx)($ec640dec66ccb66d$var$LoomToolbarButtonWrapper, {
            // Disable the icon while the SDK isn't initialised
            disabled: disabled,
            api: api,
            appearance: appearance
        });
        return null;
    };
module.exports["loomPrimaryToolbarComponent"] = $ec640dec66ccb66d$export$b7aa095334bc8677;

});

parcelRegister("g00sD", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $3k5Tv = parcelRequire("3k5Tv");


var $gx3UZ = parcelRequire("gx3UZ");


var $aiL0G = parcelRequire("aiL0G");

var $ldbHR = parcelRequire("ldbHR");


var $60Yxm = parcelRequire("60Yxm");

function $367060042bbafb1f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// This const is derived from the breakpoint where the toolbar hides its icons. It is used to hide the text in the AI button.
// Derived from values from platform/packages/editor/editor-core/src/ui/Appearance/FullPage/MainToolbar.tsx
const $367060042bbafb1f$var$LOOM_BUTTON_WIDTH_BREAKPOINT = 1076;
const $367060042bbafb1f$var$iconMinWidthStyle = {
    name: "9bmev",
    styles: "min-width:24px"
};
const $367060042bbafb1f$var$selector = (states)=>{
    return {
        width: states.widthState?.width
    };
};
const $367060042bbafb1f$var$LoomToolbarButtonInternal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(({ disabled: disabled, api: api, appearance: appearance, intl: { formatMessage: formatMessage }, selected: selected, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, 'data-ds--level': dataDsLevel, onClick: onClick, href: href, target: target, hideTooltip: hideTooltip, rel: rel }, ref)=>{
    const { width: width } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'width'
    ], $367060042bbafb1f$var$selector);
    const label = formatMessage(appearance === 'comment' ? (0, $gx3UZ.toolbarInsertBlockMessages).addLoomVideoComment : (0, $gx3UZ.toolbarInsertBlockMessages).addLoomVideo);
    const shouldShowRecordText = (width || 0) > $367060042bbafb1f$var$LOOM_BUTTON_WIDTH_BREAKPOINT;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
        hideTooltip: hideTooltip,
        ref: ref,
        href: href,
        buttonId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).RECORD_VIDEO,
        disabled: disabled,
        title: label,
        iconBefore: /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            css: $367060042bbafb1f$var$iconMinWidthStyle
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($60Yxm))), {
            label: label,
            color: disabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon-subtle, #505258)",
            spacing: "spacious"
        })),
        selected: selected,
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        "data-ds--level": dataDsLevel,
        onClick: onClick,
        target: target,
        rel: rel
    }, shouldShowRecordText && formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).recordLoomShortTitle));
});
const $367060042bbafb1f$var$_default_1 = (0, $kSwu1.injectIntl)($367060042bbafb1f$var$LoomToolbarButtonInternal, {
    forwardRef: true
});
var $367060042bbafb1f$export$2e2bcd8739ae039 = $367060042bbafb1f$var$_default_1;
module.exports["default"] = $367060042bbafb1f$export$2e2bcd8739ae039;

});

parcelRegister("bnkCY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3nacY = parcelRequire("3nacY");

var $hVLmg = parcelRequire("hVLmg");


var $akmSK = parcelRequire("akmSK");


var $QhQtc = parcelRequire("QhQtc");

const $abbb8912713cedae$export$a758406ca53b86a5 = (config, api)=>{
    return [
        {
            type: (0, $3nacY.LOOM_MENU_SECTION).type,
            key: (0, $3nacY.LOOM_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $3nacY.OVERFLOW_MENU_PRIMARY_TOOLBAR).type,
                    key: (0, $3nacY.OVERFLOW_MENU_PRIMARY_TOOLBAR).key,
                    rank: (0, $hVLmg.OVERFLOW_MENU_PRIMARY_TOOLBAR_RANK)[(0, $3nacY.LOOM_MENU_SECTION).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $QhQtc.MenuSection), {
                    api: api
                }, children);
            }
        },
        {
            type: (0, $3nacY.LOOM_MENU_ITEM).type,
            key: (0, $3nacY.LOOM_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $3nacY.LOOM_MENU_SECTION).type,
                    key: (0, $3nacY.LOOM_MENU_SECTION).key,
                    rank: (0, $hVLmg.LOOM_MENU_SECTION_RANK)[(0, $3nacY.LOOM_MENU_ITEM).key]
                },
                {
                    type: (0, $3nacY.OVERFLOW_EXTENSIONS_MENU_SECTION).type,
                    key: (0, $3nacY.OVERFLOW_EXTENSIONS_MENU_SECTION).key,
                    rank: (0, $hVLmg.OVERFLOW_EXTENSIONS_MENU_SECTION_RANK)[(0, $3nacY.LOOM_MENU_ITEM).key]
                }
            ],
            component: ()=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $akmSK.LoomMenuItem), {
                    api: api,
                    renderButton: config.renderButton
                });
            },
            isHidden: ()=>{
                const loomState = api?.loom?.sharedState.currentState();
                const editorViewMode = api?.editorViewMode?.sharedState.currentState() ?? 'edit';
                // if shouldRenderButton is not provided, default to true
                const shouldRenderButton = config?.shouldRenderButton?.() ?? true;
                return 'renderButton' in config && shouldRenderButton === false || loomState?.isEnabled === undefined || editorViewMode !== 'edit';
            }
        }
    ];
};
module.exports["getToolbarComponents"] = $abbb8912713cedae$export$a758406ca53b86a5;

});

parcelRegister("akmSK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3k5Tv = parcelRequire("3k5Tv");


var $gx3UZ = parcelRequire("gx3UZ");


var $bFSJa = parcelRequire("bFSJa");


var $60Yxm = parcelRequire("60Yxm");

var $dVKvM = parcelRequire("dVKvM");


var $lP4rW = parcelRequire("lP4rW");

const $1c445c5059187b69$var$useLoomEnabled = (api)=>{
    const { loomEnabled: loomEnabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'loom'
    ], (states)=>{
        return {
            loomEnabled: states.loomState?.isEnabled
        };
    });
    return loomEnabled;
};
const $1c445c5059187b69$export$cfd738d449e0a4ef = ({ api: api, renderButton: renderButton })=>{
    const loomEnabled = $1c445c5059187b69$var$useLoomEnabled(api);
    const { editorViewMode: editorViewMode } = (0, $bFSJa.useEditorToolbar)();
    if (editorViewMode !== 'edit') return null;
    if (renderButton) return renderButton($1c445c5059187b69$export$a209d77fd6c75051(api));
    else if (loomEnabled !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1c445c5059187b69$var$DefaultLoomMenuItem, {
        api: api
    });
};
const $1c445c5059187b69$export$a209d77fd6c75051 = (api)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(({ isDisabled: isDisabled = false, onClickBeforeInit: onClickBeforeInit, href: href, target: target, rel: rel }, ref)=>{
        const loomEnabled = !!$1c445c5059187b69$var$useLoomEnabled(api);
        const handleOnClick = (0, $cozmU.useCallback)((e)=>{
            if (loomEnabled) (0, $lP4rW.executeRecordVideo)(api);
            else if (onClickBeforeInit && e.type === 'click' && e.target instanceof HTMLElement) onClickBeforeInit(e);
        }, [
            loomEnabled,
            onClickBeforeInit
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1c445c5059187b69$var$MenuItemComponent, {
            ref: ref,
            // Ignore href if Loom is enabled so that it doesn't interfere with recording
            href: loomEnabled ? undefined : href,
            disabled: isDisabled,
            onClick: handleOnClick,
            target: target,
            rel: rel
        });
    });
const $1c445c5059187b69$var$DefaultLoomMenuItem = ({ api: api })=>{
    const loomEnabled = $1c445c5059187b69$var$useLoomEnabled(api);
    const handleOnClick = (0, $cozmU.useCallback)(()=>(0, $lP4rW.executeRecordVideo)(api), [
        api
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1c445c5059187b69$var$MenuItemComponent, {
        disabled: !loomEnabled,
        onClick: handleOnClick
    });
};
const $1c445c5059187b69$var$MenuItemComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(// eslint-disable-next-line no-unused-vars
({ disabled: disabled, onClick: onClick, href: href, target: target, rel: rel }, ref)=>{
    const { editorAppearance: editorAppearance } = (0, $bFSJa.useEditorToolbar)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dVKvM.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($60Yxm))), {
            size: "small",
            label: ""
        }),
        isDisabled: disabled,
        href: href,
        target: target,
        rel: rel,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: (e)=>onClick(e)
    }, formatMessage(editorAppearance === 'comment' ? (0, $gx3UZ.toolbarInsertBlockMessages).addLoomVideoComment : (0, $gx3UZ.toolbarInsertBlockMessages).addLoomVideo));
});
module.exports["LoomMenuItem"] = $1c445c5059187b69$export$cfd738d449e0a4ef;

});

parcelRegister("QhQtc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bFSJa = parcelRequire("bFSJa");


var $jgJIe = parcelRequire("jgJIe");

const $fc79263a4212ed67$var$usePluginState = (_api)=>{
    const { editorViewMode: editorViewMode } = (0, $bFSJa.useEditorToolbar)();
    return {
        editorViewMode: editorViewMode
    };
};
const $fc79263a4212ed67$export$4b1545b4f2016d26 = ({ children: children, api: api })=>{
    const { editorViewMode: editorViewMode } = $fc79263a4212ed67$var$usePluginState(api);
    const isEdit = editorViewMode === 'edit';
    if (!isEdit) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jgJIe.ToolbarDropdownItemSection), {
        hasSeparator: isEdit
    }, children);
};
module.exports["MenuSection"] = $fc79263a4212ed67$export$4b1545b4f2016d26;

});

parcelRegister("3Cz3M", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2sp5n = parcelRequire("2sp5n");


var $7Y8M5 = parcelRequire("7Y8M5");


var $ixfCV = parcelRequire("ixfCV");


var $iwIwp = parcelRequire("iwIwp");


var $fxz9v = parcelRequire("fxz9v");


var $gacc6 = parcelRequire("gacc6");


var $dunxr = parcelRequire("dunxr");


var $gIEgP = parcelRequire("gIEgP");


var $bqezu = parcelRequire("bqezu");


var $hzdYl = parcelRequire("hzdYl");

const $58b17ee35bdc2adb$var$nativeEmbedLoadingHandler = (node)=>node.extensionKey.startsWith((0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY)) && (0, $ixfCV.fg)('native_embeds_first_paint_placeholder') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fxz9v.NativeEmbedLoadingPlaceholder), {
        node: node
    }) : null;
const $58b17ee35bdc2adb$export$d34fb9a28e944197 = ({ api: api, config: config })=>{
    // Wire up the CardClient for short-link URL resolution when provided via config.
    if (config?.cardClient) (0, $iwIwp.getNativeEmbedFacade)().setCardClient(config.cardClient);
    // Register the native embed transformers with the card plugin so that
    // embedCard nodes are automatically converted to native embed extensions
    // during URL resolution and appearance switching.
    api?.card?.actions?.registerEmbedCardTransformer({
        // Curry api into cardToNativeEmbedNode so it can use resolveShortLinkUrl
        // for Confluence short-link expansion without requiring a separate CardClient.
        embedCardNodeTransformer: (schema, attrs)=>(0, $gacc6.cardToNativeEmbedNode)(schema, attrs, api),
        createEmbedCardTransformCommand: (0, $gacc6.createCardToNativeEmbedTransform)
    });
    // Register the native embed transformer with the AI plugin so that
    // inserted content nodes can be automatically converted to native embed
    // extensions during AI content insertion.
    api?.aiExperience?.actions?.registerInsertedContentNodeTransformer?.((0, $gacc6.insertedContentToNativeEmbedNode));
    api?.extension?.actions.registerExtensionLoadingHandler({
        extensionType: (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE),
        handler: $58b17ee35bdc2adb$var$nativeEmbedLoadingHandler
    });
    if ((0, $ixfCV.fg)('maui_remixable_page_native_embeds')) api?.aiSelectionContext?.actions?.registerContextExtractor?.('extension', (0, $bqezu.nativeEmbedContextExtractor));
    return {
        name: 'editorPluginNativeEmbeds',
        actions: {
            cardToNativeEmbedNode: (0, $gacc6.cardToNativeEmbedNode),
            createCardToNativeEmbedTransform: (0, $gacc6.createCardToNativeEmbedTransform)
        },
        pmPlugins () {
            const analyticsApi = api?.analytics?.actions;
            return [
                {
                    name: 'nativeEmbedsPluginState',
                    plugin: ()=>(0, $dunxr.createPlugin)(analyticsApi, api)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pmState = (0, $dunxr.pluginKey).getState(editorState);
            if (!pmState) return undefined;
            return {
                trackedEmbedPos: pmState.trackedEmbedPos,
                hoveredEmbedPos: pmState.hoveredEmbedPos,
                width: pmState.resizingWidth || (0, $7Y8M5.akEditorDefaultLayoutWidth),
                isResizing: pmState.isResizing,
                selectedEmbed: pmState.selectedEmbed
            };
        },
        contentComponent (params) {
            if (!params.editorView) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hzdYl.ResizableNativeEmbed), {
                disabled: params.disabled,
                editorView: params.editorView,
                pluginInjectionApi: api,
                appearance: params.appearance,
                containerElement: params.containerElement,
                editorActions: params.editorActions,
                eventDispatcher: params.eventDispatcher,
                popupsMountPoint: params.popupsMountPoint,
                providerFactory: params.providerFactory,
                wrapperElement: params.wrapperElement
            });
        },
        pluginsOptions: {
            floatingToolbar: (0, $gIEgP.getToolbarConfig)({
                api: api,
                linkPickerOptions: config?.linkPickerOptions,
                lpLinkPicker: config?.lpLinkPicker
            })
        }
    };
};
module.exports["nativeEmbedsPlugin"] = $58b17ee35bdc2adb$export$d34fb9a28e944197;

});

parcelRegister("fxz9v", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $ljOiP = parcelRequire("ljOiP");


var $iwIwp = parcelRequire("iwIwp");


var $1Nl2R = parcelRequire("1Nl2R");


var $a25IJ = parcelRequire("a25IJ");

var $2Vug6 = parcelRequire("2Vug6");


const $a1ea65fa13d59a50$var$NativeEmbedUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("lnFlR")).then(({ default: NativeEmbedUIComponent })=>({
            default: NativeEmbedUIComponent
        })));
const $a1ea65fa13d59a50$export$589209289a008d27 = ({ node: node })=>{
    const { parameters: parameters } = node;
    const { url: url } = (0, $ljOiP.getParameters)(parameters);
    const manifest = url ? (0, $iwIwp.getNativeEmbedFacade)().getManifestByUrl(url) : undefined;
    const initialLayout = (0, $2Vug6.resolveNativeEmbedInitialLayout)({
        manifest: manifest,
        parameters: parameters
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lOiVq.Global), {
        styles: (0, $1Nl2R.nativeEmbedAlignmentStyles)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a25IJ.NativeEmbedInitialPlaceholder), initialLayout));
};
function $a1ea65fa13d59a50$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a1ea65fa13d59a50$export$589209289a008d27, props)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a1ea65fa13d59a50$var$NativeEmbedUI, props));
}
module.exports["NativeEmbedLoadingPlaceholder"] = $a1ea65fa13d59a50$export$589209289a008d27;

});

parcelRegister("gacc6", function(module, exports) {

var $9p0BY = parcelRequire("9p0BY");


var $krYZG = parcelRequire("krYZG");


var $2sp5n = parcelRequire("2sp5n");


var $5Qi6J = parcelRequire("5Qi6J");


var $kCECX = parcelRequire("kCECX");


var $k9wGn = parcelRequire("k9wGn");

var $ljOiP = parcelRequire("ljOiP");


var $ixfCV = parcelRequire("ixfCV");


var $mW7G5 = parcelRequire("mW7G5");


var $iwIwp = parcelRequire("iwIwp");

const $ee20aa2809926709$var$getTransformLocalId = (attrs)=>attrs.localId;
const $ee20aa2809926709$var$LAYOUT_TO_ALIGNMENT = {
    center: 'center',
    'full-width': 'center',
    wide: 'center',
    'wrap-left': 'wrap-left',
    'wrap-right': 'wrap-right',
    'align-start': 'left',
    'align-end': 'right'
};
function $ee20aa2809926709$var$mapLayoutToAlignment(layout = 'center') {
    return $ee20aa2809926709$var$LAYOUT_TO_ALIGNMENT[layout] ?? 'center';
}
function $ee20aa2809926709$export$f7e09b33c87279a2(schema, attrs, api) {
    if (!(0, $mW7G5.expVal)('cc-maui-experiment', 'isEnabled', false) && !(0, $ixfCV.fg)('platform_native_embeds_rollout_non_maui_experience')) return undefined;
    const { url: url, layout: layout = 'center', originalHeight: originalHeight, originalWidth: originalWidth } = attrs;
    if (!(0, $9p0BY.isSafeUrl)(url)) return undefined;
    const facade = (0, $iwIwp.getNativeEmbedFacade)();
    // Fast path: synchronous manifest lookup for regular (non-short-link) URLs.
    const manifest = facade.getManifestByUrl(url);
    if (manifest) return $ee20aa2809926709$var$buildNativeEmbedNode(schema, {
        url: url,
        layout: layout,
        originalHeight: originalHeight,
        originalWidth: originalWidth,
        localId: $ee20aa2809926709$var$getTransformLocalId(attrs)
    }, manifest);
    // Async path: for Confluence short-link URLs (/wiki/x/<token>), expand via ORS
    // and retry the manifest lookup with the resolved canonical URL.
    // Uses api.card.actions.resolveShortLinkUrl which accesses the card plugin's
    // internal CardClient — the same one used by all smart cards in the editor.
    if (api?.card?.actions?.resolveShortLinkUrl && (0, $ixfCV.fg)('platform_native_embeds_rollout_non_maui_experience')) return api.card.actions.resolveShortLinkUrl(url).then((resolvedUrl)=>{
        if (!resolvedUrl) return undefined;
        const resolvedManifest = facade.getManifestByUrl(resolvedUrl);
        if (!resolvedManifest) return undefined;
        return $ee20aa2809926709$var$buildNativeEmbedNode(schema, {
            url: resolvedUrl,
            layout: layout,
            originalHeight: originalHeight,
            originalWidth: originalWidth,
            localId: $ee20aa2809926709$var$getTransformLocalId(attrs)
        }, resolvedManifest);
    });
    return undefined;
}
function $ee20aa2809926709$var$buildNativeEmbedNode(schema, attrs, manifest) {
    const { url: url, layout: layout = 'center', originalHeight: originalHeight, originalWidth: originalWidth, localId: localId } = attrs;
    const hasOriginalDimensions = !!(originalWidth && originalHeight);
    const width = originalWidth ?? (0, $k9wGn.NATIVE_EMBED_PARAMETER_DEFAULTS).width;
    // Use aspectRatio when we have computed dimensions, or when a width is set/inferred
    // (so the renderer can derive height). Only fall back to a fixed height when there
    // is no width at all, because aspectRatio is meaningless without a width.
    const hasWidth = !!width;
    const { height: _defaultHeight, ...defaultsWithoutHeight } = (0, $k9wGn.NATIVE_EMBED_PARAMETER_DEFAULTS);
    const macroParams = (0, $ljOiP.setParameters)({}, {
        ...hasWidth ? defaultsWithoutHeight : (0, $k9wGn.NATIVE_EMBED_PARAMETER_DEFAULTS),
        url: url,
        alignment: $ee20aa2809926709$var$mapLayoutToAlignment(layout),
        width: width,
        aspectRatio: hasOriginalDimensions ? originalWidth / originalHeight : hasWidth ? (0, $k9wGn.NATIVE_EMBED_PARAMETER_DEFAULTS).aspectRatio : undefined,
        // height is only stored when there is no width (aspectRatio cannot be used without one)
        ...hasWidth ? {} : {
            height: (0, $k9wGn.NATIVE_EMBED_PARAMETER_DEFAULTS).height
        }
    });
    const extensionAdf = {
        type: 'extension',
        attrs: {
            extensionKey: `${(0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY)}:${manifest.id}`,
            extensionType: (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE),
            ...localId ? {
                localId: localId
            } : {},
            parameters: {
                ...macroParams,
                macroMetadata: {
                    url: // Preserved data in case of revert.
                    url,
                    layout: layout,
                    originalHeight: originalHeight ?? undefined,
                    originalWidth: originalWidth ?? undefined
                }
            }
        }
    };
    return (0, $5Qi6J.processRawValue)(schema, extensionAdf);
}
function $ee20aa2809926709$export$a3e392087da04055(schema, node) {
    if (node.type === schema.nodes.embedCard) return $ee20aa2809926709$export$f7e09b33c87279a2(schema, {
        url: node.attrs.url,
        layout: node.attrs.layout,
        width: node.attrs.width,
        originalHeight: node.attrs.originalHeight,
        originalWidth: node.attrs.originalWidth,
        localId: node.attrs.localId
    });
    if (node.type === schema.nodes.paragraph && node.childCount === 1 && node.firstChild?.isText && node.firstChild.marks.length) {
        const linkMarkType = schema.marks.link;
        const linkMark = linkMarkType ? node.firstChild.marks.find((mark)=>mark.type === linkMarkType) : undefined;
        const url = linkMark?.attrs.href;
        if (url) return $ee20aa2809926709$export$f7e09b33c87279a2(schema, {
            url: url,
            layout: 'center',
            width: undefined
        });
    }
    return undefined;
}
function $ee20aa2809926709$var$appearanceForNodeType(schema, nodeType) {
    if (nodeType === schema.nodes.inlineCard) return 'inline';
    if (nodeType === schema.nodes.blockCard) return 'block';
    if (nodeType === schema.nodes.embedCard) return 'embed';
    return 'url';
}
function $ee20aa2809926709$export$182f08fa3d19e14d(options) {
    if (!(0, $mW7G5.expVal)('cc-maui-experiment', 'isEnabled', false) && !(0, $ixfCV.fg)('platform_native_embeds_rollout_non_maui_experience')) return ()=>false;
    const { augmentTransaction: augmentTransaction, editorAnalyticsApi: editorAnalyticsApi } = options ?? {};
    return (state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $kCECX.NodeSelection) ? state.selection.node : undefined;
        if (!selectedNode) return false;
        const url = selectedNode.attrs.url ?? selectedNode.attrs.data?.url;
        if (!url) return false;
        const previousType = $ee20aa2809926709$var$appearanceForNodeType(state.schema, selectedNode.type);
        const embedAttrs = {
            url: url,
            layout: selectedNode.attrs.layout ?? 'center',
            width: selectedNode.attrs.width ?? (0, $k9wGn.NATIVE_EMBED_PARAMETER_DEFAULTS).width,
            originalHeight: selectedNode.attrs.originalHeight ?? (0, $k9wGn.NATIVE_EMBED_PARAMETER_DEFAULTS).height,
            originalWidth: selectedNode.attrs.originalWidth ?? (0, $k9wGn.NATIVE_EMBED_PARAMETER_DEFAULTS).width,
            localId: selectedNode.attrs.localId
        };
        const extensionNode = $ee20aa2809926709$export$f7e09b33c87279a2(state.schema, embedAttrs);
        if (!extensionNode) return false;
        const { from: from, to: to } = state.selection;
        const tr = state.tr.replaceWith(from, to, extensionNode);
        if (tr.doc.nodeSize - 2 === to) tr.insertText(' ', to);
        tr.setSelection((0, $kCECX.TextSelection).create(tr.doc, to + 1));
        const previousNodePos = from - 1 > 0 ? from - 1 : 0;
        const previousNode = tr.doc.nodeAt(previousNodePos);
        if (previousNode?.type?.name === 'paragraph') tr.delete(previousNodePos, from);
        augmentTransaction?.(tr, state);
        if (dispatch) {
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).CHANGED_TYPE,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).NATIVE_EMBED,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    newType: 'nativeEmbed',
                    previousType: previousType
                }
            })(tr);
            dispatch(tr.scrollIntoView());
        }
        return true;
    };
}
module.exports["cardToNativeEmbedNode"] = $ee20aa2809926709$export$f7e09b33c87279a2;
module.exports["insertedContentToNativeEmbedNode"] = $ee20aa2809926709$export$a3e392087da04055;
module.exports["createCardToNativeEmbedTransform"] = $ee20aa2809926709$export$182f08fa3d19e14d;

});

parcelRegister("dunxr", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");


var $haNN4 = parcelRequire("haNN4");


var $krYZG = parcelRequire("krYZG");


var $brzQy = parcelRequire("brzQy");


var $2sp5n = parcelRequire("2sp5n");


var $9ppjA = parcelRequire("9ppjA");


var $kpCD8 = parcelRequire("kpCD8");


var $gLqwM = parcelRequire("gLqwM");


var $6SJ6d = parcelRequire("6SJ6d");


var $kCECX = parcelRequire("kCECX");


var $bjg0G = parcelRequire("bjg0G");


var $ljOiP = parcelRequire("ljOiP");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $1WSjf = parcelRequire("1WSjf");


var $6yVl9 = parcelRequire("6yVl9");


var $4xLGC = parcelRequire("4xLGC");


var $4usZB = parcelRequire("4usZB");


var $kUhHF = parcelRequire("kUhHF");


var $gnLph = parcelRequire("gnLph");

/**
 * Given a candidate document position (already mapped through the latest
 * transaction), returns the position if it still points to a native embed
 * node, or `null` if the embed has been deleted or replaced.
 *
 * Extracted as a named helper so the intent is clear at the call-site and
 * the validation logic can be updated in one place if needed.
 */ const $d598f2eb7a08550e$var$resolveTrackedEmbedPos = (pos, newEditorState)=>{
    const docSize = newEditorState.doc.content.size;
    if (pos >= docSize) return null;
    const nodeAtPos = newEditorState.doc.nodeAt(pos);
    if (!nodeAtPos || !(0, $kUhHF.isNativeEmbedNode)(nodeAtPos)) return null;
    return pos;
};
const $d598f2eb7a08550e$var$getInsertionMethod = (transactions)=>{
    for (const transaction of transactions){
        const { inputMethod: inputMethod } = (0, $brzQy.getLinkMetadataFromTransaction)(transaction);
        if (inputMethod) return inputMethod;
    }
    return (0, $krYZG.INPUT_METHOD).MANUAL;
};
const $d598f2eb7a08550e$export$68fc950519fc9e9f = 'nativeEmbedsPlugin.isResizing';
const $d598f2eb7a08550e$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('nativeEmbedsPlugin');
/**
 * Walks the document to find all native embed extension nodes and syncs
 * the `data-native-embed-nested` attribute on their DOM `.extension-container`
 * element. This ensures the attribute stays correct after drag-and-drop moves
 * an embed into or out of a nested container.
 *
 * Deferred to a requestAnimationFrame so that the DOM has been fully rebuilt
 * by ProseMirror before we attempt to locate elements.
 */ let $d598f2eb7a08550e$var$syncRAFHandle = null;
const $d598f2eb7a08550e$var$syncNativeEmbedNestedAttributes = (view)=>{
    if ($d598f2eb7a08550e$var$syncRAFHandle !== null) cancelAnimationFrame($d598f2eb7a08550e$var$syncRAFHandle);
    $d598f2eb7a08550e$var$syncRAFHandle = requestAnimationFrame(()=>{
        $d598f2eb7a08550e$var$syncRAFHandle = null;
        if (view.isDestroyed) return;
        const { state: state } = view;
        state.doc.descendants((node, pos)=>{
            if (!(0, $kUhHF.isNativeEmbedNode)(node)) return true; // continue traversal
            try {
                // Use view.nodeDOM to get the actual node's DOM element, bypassing
                // decorations (like gap cursors) that share the same position.
                const rawDom = view.nodeDOM(pos);
                const element = rawDom instanceof HTMLElement ? rawDom : rawDom instanceof Node ? rawDom.parentElement : null;
                if (!element) return false;
                const container = element.querySelector('.extension-container') ?? element.closest('.extension-container') ?? element;
                if ((0, $9ppjA.getNestedParentNode)(pos, state) !== null) container.setAttribute('data-native-embed-nested', '');
                else container.removeAttribute('data-native-embed-nested');
            } catch  {
            // DOM may not be available for this position yet — skip
            }
            return false; // no need to descend into extension node
        });
    });
};
const $d598f2eb7a08550e$export$ae829ec7b2625219 = (editorAnalyticsApi, pluginInjectionApi)=>{
    const writtenMaxHeightLocalIds = new Set();
    // Experiment value is stable for the lifetime of the plugin, so resolve it
    // once at construction time. Avoids redundant flag lookups (and exposure
    // logs) on every child resize event.
    const childResizePolicy = {
        gateWidth: true,
        gateHeight: (0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) && (0, $ieeJu.expValEquals)('databases-native-embeds-v2', 'isEnabled', true)
    };
    return new (0, $kpCD8.SafePlugin)({
        key: $d598f2eb7a08550e$export$18d4026d1ea86bb1,
        props: {
            handleDOMEvents: {
                // Handle click-inside events dispatched by the native embed iframe
                // extension component. We create a proper ProseMirror NodeSelection
                // so that keyboard interactions (Delete, Backspace) work as expected.
                'native-embed-click-inside': (view, event)=>{
                    const target = event.target;
                    if (!(target instanceof HTMLElement)) return false;
                    // Walk up the DOM from the event target to find the node view
                    // wrapper element (identified by the extensionView-content-wrap
                    // class added by ReactNodeView). This element has a pmViewDesc
                    // that ProseMirror can resolve to a document position.
                    let nodeViewDom = target;
                    while(nodeViewDom && nodeViewDom !== view.dom && !nodeViewDom.classList.contains('extensionView-content-wrap'))nodeViewDom = nodeViewDom.parentElement;
                    if (!nodeViewDom || nodeViewDom === view.dom) return false;
                    try {
                        const pos = view.posAtDOM(nodeViewDom, 0);
                        const $pos = view.state.doc.resolve(pos);
                        // For atom nodes (like extension), posAtDOM on the node
                        // view wrapper resolves to the position of the node.
                        // Check nodeAfter at this position.
                        const nodeAfter = $pos.nodeAfter;
                        if (nodeAfter && nodeAfter.type.name === 'extension' && nodeAfter.attrs?.extensionType === (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE) && nodeAfter.attrs?.extensionKey?.includes((0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY))) {
                            const tr = view.state.tr.setSelection((0, $kCECX.NodeSelection).create(view.state.doc, pos));
                            view.dispatch(tr);
                            if (event.detail?.shouldFocus !== false) view.focus();
                            return true;
                        }
                        // Fallback: walk up the ancestor chain in case the position
                        // resolved inside a wrapper node.
                        for(let d = $pos.depth; d >= 0; d--){
                            const node = $pos.node(d);
                            if (node.type.name === 'extension' && node.attrs?.extensionType === (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE) && node.attrs?.extensionKey?.includes((0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY))) {
                                const nodePos = $pos.before(d);
                                const tr = view.state.tr.setSelection((0, $kCECX.NodeSelection).create(view.state.doc, nodePos));
                                view.dispatch(tr);
                                if (event.detail?.shouldFocus !== false) view.focus();
                                return true;
                            }
                        }
                    } catch  {
                    // posAtDOM can throw if the DOM element is not within the editor
                    }
                    return false;
                },
                'native-embed-request-resize': (view, event)=>{
                    const detail = event.detail;
                    const newWidth = typeof detail?.width === 'number' ? detail.width : undefined;
                    const newHeight = typeof detail?.height === 'number' ? detail.height : undefined;
                    const newMaxHeight = typeof detail?.maxHeight === 'number' && Number.isFinite(detail.maxHeight) ? detail.maxHeight : undefined;
                    const shouldPersistResize = newWidth !== undefined || newHeight !== undefined;
                    const target = event.target;
                    if (!(target instanceof HTMLElement) || newWidth === undefined && newHeight === undefined && newMaxHeight === undefined) return false;
                    let nodeViewDom = target;
                    while(nodeViewDom && nodeViewDom !== view.dom && !nodeViewDom.classList.contains('extensionView-content-wrap'))nodeViewDom = nodeViewDom.parentElement;
                    if (!nodeViewDom || nodeViewDom === view.dom) return false;
                    // Width is always gated — once the host has persisted a
                    // width, further child width requests are dropped. Height
                    // is gated behind `databases-native-embeds-v2` while the
                    // manual vertical-resize feature rolls out; in both cases
                    // the rule is "lock the axis on the first child-driven
                    // resize, ignore further child requests on that axis". See
                    // `resolve-child-resize.ts` for the pure policy fn; the
                    // policy itself is built once in `createPlugin` above.
                    const dispatchResizeStopMeta = ()=>{
                        const tr = view.state.tr;
                        tr.setMeta('is-resizer-resizing', false);
                        tr.setMeta('scrollIntoView', false);
                        view.dispatch(tr);
                    };
                    const dispatchSelectionTransferAndResizeStopMeta = (pos)=>{
                        const currentSelection = view.state.selection;
                        const tr = view.state.tr;
                        try {
                            if (!(currentSelection instanceof (0, $kCECX.NodeSelection) && currentSelection.from === pos)) tr.setSelection((0, $kCECX.NodeSelection).create(view.state.doc, pos));
                        } catch  {
                        // The embed may have been removed between mouseup and the
                        // bubbled resize event; still clear resize state below.
                        }
                        tr.setMeta('is-resizer-resizing', false);
                        tr.setMeta('scrollIntoView', false);
                        view.dispatch(tr);
                    };
                    const commitManualResize = (pos, node)=>{
                        const params = node.attrs.parameters;
                        const committedHeight = newHeight;
                        const committedWidth = newWidth ?? (0, $ljOiP.getParameters)(params, 'width');
                        if (committedWidth === undefined) {
                            dispatchResizeStopMeta();
                            return true;
                        }
                        (0, $4xLGC.createUpdateWidthCommand)(pluginInjectionApi, committedWidth, node, committedHeight, {
                            scrollIntoView: false
                        })(view.state, view.dispatch);
                        dispatchSelectionTransferAndResizeStopMeta(pos);
                        return true;
                    };
                    const buildUpdatedParams = (params)=>{
                        const { width: applyWidth, height: applyHeight } = (0, $4usZB.resolveChildResize)(params, {
                            width: newWidth,
                            height: newHeight
                        }, childResizePolicy);
                        let updated = params ?? {};
                        if (applyWidth !== undefined) updated = (0, $ljOiP.setParameter)(updated, {
                            width: applyWidth
                        });
                        if (applyHeight !== undefined) updated = (0, $ljOiP.setParameter)(updated, {
                            height: applyHeight
                        });
                        return updated;
                    };
                    try {
                        const pos = view.posAtDOM(nodeViewDom, 0);
                        const $pos = view.state.doc.resolve(pos);
                        const nodeAfter = $pos.nodeAfter;
                        if (nodeAfter && nodeAfter.type.name === 'extension' && nodeAfter.attrs?.extensionType === (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE) && nodeAfter.attrs?.extensionKey?.includes((0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY))) {
                            const localId = nodeAfter.attrs?.localId;
                            if (typeof localId === 'string' && localId !== '' && newMaxHeight !== undefined && newMaxHeight > 0) {
                                (0, $gnLph.setMaxHeight)(view, localId, newMaxHeight);
                                writtenMaxHeightLocalIds.add(localId);
                            }
                            if (!shouldPersistResize) return true;
                            if (detail?.resizeSource === 'manual-resize') return commitManualResize(pos, nodeAfter);
                            const updatedParams = buildUpdatedParams(nodeAfter.attrs.parameters);
                            const tr = view.state.tr.setNodeMarkup(pos, undefined, {
                                ...nodeAfter.attrs,
                                parameters: updatedParams
                            });
                            view.dispatch(tr);
                            return true;
                        }
                        for(let d = $pos.depth; d >= 0; d--){
                            const node = $pos.node(d);
                            if (node.type.name === 'extension' && node.attrs?.extensionType === (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE) && node.attrs?.extensionKey?.includes((0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY))) {
                                const localId = node.attrs?.localId;
                                if (typeof localId === 'string' && localId !== '' && newMaxHeight !== undefined && newMaxHeight > 0) {
                                    (0, $gnLph.setMaxHeight)(view, localId, newMaxHeight);
                                    writtenMaxHeightLocalIds.add(localId);
                                }
                                if (!shouldPersistResize) return true;
                                const nodePos = $pos.before(d);
                                if (detail?.resizeSource === 'manual-resize') return commitManualResize(nodePos, node);
                                const updatedParams = buildUpdatedParams(node.attrs.parameters);
                                const tr = view.state.tr.setNodeMarkup(nodePos, undefined, {
                                    ...node.attrs,
                                    parameters: updatedParams
                                });
                                view.dispatch(tr);
                                return true;
                            }
                        }
                    } catch  {
                    // posAtDOM can throw if the DOM element is not within the editor
                    }
                    return false;
                },
                'native-embed-request-resize-start': (view)=>{
                    const tr = view.state.tr;
                    tr.setMeta('is-resizer-resizing', true);
                    tr.setMeta('scrollIntoView', false);
                    view.dispatch(tr);
                    return true;
                },
                'native-embed-request-resize-stop': (view)=>{
                    const tr = view.state.tr;
                    tr.setMeta('is-resizer-resizing', false);
                    tr.setMeta('scrollIntoView', false);
                    view.dispatch(tr);
                    return true;
                },
                'native-embed-request-alignment': (view, event)=>{
                    const target = event.target;
                    const alignment = event.detail?.alignment;
                    if (!(target instanceof HTMLElement) || alignment !== 'center') return false;
                    let nodeViewDom = target;
                    while(nodeViewDom && nodeViewDom !== view.dom && !nodeViewDom.classList.contains('extensionView-content-wrap'))nodeViewDom = nodeViewDom.parentElement;
                    if (!nodeViewDom || nodeViewDom === view.dom) return false;
                    try {
                        const pos = view.posAtDOM(nodeViewDom, 0);
                        const $pos = view.state.doc.resolve(pos);
                        const nodeAfter = $pos.nodeAfter;
                        if (nodeAfter && nodeAfter.type.name === 'extension' && nodeAfter.attrs?.extensionType === (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE) && nodeAfter.attrs?.extensionKey?.includes((0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY))) {
                            (0, $1WSjf.createUpdateAlignmentCommand)(pluginInjectionApi, alignment, nodeAfter, {
                                scrollIntoView: false
                            })(view.state, view.dispatch);
                            return true;
                        }
                        for(let d = $pos.depth; d >= 0; d--){
                            const node = $pos.node(d);
                            if (node.type.name === 'extension' && node.attrs?.extensionType === (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE) && node.attrs?.extensionKey?.includes((0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY))) {
                                (0, $1WSjf.createUpdateAlignmentCommand)(pluginInjectionApi, alignment, node, {
                                    scrollIntoView: false
                                })(view.state, view.dispatch);
                                return true;
                            }
                        }
                    } catch  {
                    // posAtDOM can throw if the DOM element is not within the editor.
                    }
                    return false;
                },
                'native-embed-request-guidelines': (view, event)=>{
                    const detail = event.detail;
                    const rawGuidelines = detail?.guidelines;
                    if (!Array.isArray(rawGuidelines)) return false;
                    pluginInjectionApi?.guideline?.actions?.displayGuideline(view)({
                        guidelines: rawGuidelines
                    });
                    return true;
                },
                'native-embed-request-resize-frame': (view)=>{
                    const tr = view.state.tr;
                    tr.setMeta('native-embed-resize-frame', true);
                    tr.setMeta('addToHistory', false);
                    tr.setMeta('scrollIntoView', false);
                    view.dispatch(tr);
                    return true;
                },
                // Handle delete requests from child embeds via the bridge.
                // The child sends { type: 'delete' } when the user presses
                // Delete/Backspace without a focused text input inside the
                // iframe. Only MAUI embeds are eligible for bridge-initiated
                // deletion (verified via the /remix/ui/ URL pattern).
                'native-embed-request-delete': (view)=>{
                    const selected = (0, $bjg0G.findSelectedNodeOfType)(view.state.schema.nodes.extension)(view.state.selection);
                    if (selected && (0, $kUhHF.isNativeEmbedNode)(selected.node)) {
                        const deleted = (0, $6yVl9.createDeleteCommand)(selected)(view.state, view.dispatch);
                        if (deleted) // After bridge-initiated deletion, transfer focus back to the
                        // editor so subsequent keyboard shortcuts (e.g. Ctrl+Z to undo)
                        // are handled by ProseMirror rather than being consumed by the
                        // now-removed iframe.
                        view.focus();
                        return deleted;
                    }
                    return false;
                }
            }
        },
        view: (editorView)=>{
            // Run an initial sync so embeds that are already nested when the
            // editor first mounts get the correct attribute immediately.
            $d598f2eb7a08550e$var$syncNativeEmbedNestedAttributes(editorView);
            // In view mode (editorView.editable === false), clicks on a native embed
            // node don't naturally select it via ProseMirror's event handling.
            // This listener intercepts mousedown events at the document level and
            // manually dispatches a NodeSelection for the clicked embed, so that
            // the floating toolbar appears as expected in view/live-page mode.
            const handleDocMouseDown = (event)=>{
                if (editorView.editable) return;
                const target = event.target;
                if (!(target instanceof HTMLElement)) return;
                const wrapper = target.closest('.extensionView-content-wrap');
                if (!wrapper || !editorView.dom.contains(wrapper)) return;
                try {
                    const pos = editorView.posAtDOM(wrapper, 0);
                    const nodeAfter = editorView.state.doc.resolve(pos).nodeAfter;
                    if (nodeAfter?.type.name === 'extension') {
                        const tr = editorView.state.tr.setSelection((0, $kCECX.NodeSelection).create(editorView.state.doc, pos));
                        editorView.dispatch(tr);
                    }
                } catch  {
                // pos stale
                }
            };
            const doc = (0, $haNN4.getDocument)();
            const unbindMouseDown = doc ? (0, $cbY7C.bind)(doc, {
                type: 'mousedown',
                listener: handleDocMouseDown,
                options: {
                    capture: true
                }
            }) : ()=>{};
            return {
                update: (view, prevState)=>{
                    if (prevState.doc !== view.state.doc) {
                        $d598f2eb7a08550e$var$syncNativeEmbedNestedAttributes(view);
                        const liveLocalIds = new Set();
                        view.state.doc.descendants((node)=>{
                            if ((0, $kUhHF.isNativeEmbedNode)(node) && typeof node.attrs.localId === 'string') liveLocalIds.add(node.attrs.localId);
                            return true;
                        });
                        for (const localId of writtenMaxHeightLocalIds)if (!liveLocalIds.has(localId)) {
                            (0, $gnLph.clearMaxHeight)(editorView, localId);
                            writtenMaxHeightLocalIds.delete(localId);
                        }
                    }
                },
                destroy: ()=>{
                    unbindMouseDown();
                    if ($d598f2eb7a08550e$var$syncRAFHandle !== null) {
                        cancelAnimationFrame($d598f2eb7a08550e$var$syncRAFHandle);
                        $d598f2eb7a08550e$var$syncRAFHandle = null;
                    }
                    for (const localId of writtenMaxHeightLocalIds)(0, $gnLph.clearMaxHeight)(editorView, localId);
                    writtenMaxHeightLocalIds.clear();
                }
            };
        },
        state: {
            init: ()=>({
                    isResizing: false,
                    trackedEmbedPos: null,
                    hoveredEmbedPos: null,
                    selectedEmbed: null,
                    showUrlToolbar: false
                }),
            apply: (tr, state, _oldEditorState, newEditorState)=>{
                const meta = tr.getMeta($d598f2eb7a08550e$export$18d4026d1ea86bb1);
                let nextState = state;
                // Map the last-known embed positions through document changes
                // (following the card/paste/extension plugin pattern).
                // When content above an embed is inserted or removed, the
                // mapped pos shifts — producing a new shared state that
                // triggers onChange in React overlays.
                if (tr.docChanged) {
                    if (nextState.trackedEmbedPos !== null) {
                        const mappedPos = tr.mapping.map(nextState.trackedEmbedPos);
                        const resolvedPos = $d598f2eb7a08550e$var$resolveTrackedEmbedPos(mappedPos, newEditorState);
                        if (resolvedPos !== nextState.trackedEmbedPos) nextState = {
                            ...nextState,
                            trackedEmbedPos: resolvedPos
                        };
                    }
                    if (nextState.hoveredEmbedPos !== null) {
                        const mappedPos = tr.mapping.map(nextState.hoveredEmbedPos);
                        const resolvedPos = $d598f2eb7a08550e$var$resolveTrackedEmbedPos(mappedPos, newEditorState);
                        if (resolvedPos !== nextState.hoveredEmbedPos) nextState = {
                            ...nextState,
                            hoveredEmbedPos: resolvedPos
                        };
                    }
                }
                if (meta?.type === 'SET_HOVERED_EMBED_POS') {
                    // Defensively map `meta.pos` through this transaction's mapping
                    // before storing. The coordinator computes the pos against the
                    // PRE-dispatch view.state, but if a concurrent input rule or
                    // other appendTransaction has rewritten the doc in this same
                    // transaction, the raw pos can be off by N. Mapping then
                    // resolving keeps the stored hoveredEmbedPos consistent with
                    // the doc that this `apply()` is producing.
                    if (meta.pos === null) nextState = {
                        ...nextState,
                        hoveredEmbedPos: null
                    };
                    else {
                        const mappedPos = tr.docChanged ? tr.mapping.map(meta.pos) : meta.pos;
                        const resolvedPos = $d598f2eb7a08550e$var$resolveTrackedEmbedPos(mappedPos, newEditorState);
                        nextState = {
                            ...nextState,
                            hoveredEmbedPos: resolvedPos
                        };
                    }
                }
                if (meta?.type === 'SHOW_URL_TOOLBAR') nextState = {
                    ...nextState,
                    showUrlToolbar: true
                };
                if (meta?.type === 'HIDE_URL_TOOLBAR') nextState = {
                    ...nextState,
                    showUrlToolbar: false
                };
                if (meta?.type === 'SET_RESIZING') nextState = {
                    ...nextState,
                    isResizing: meta.isResizing,
                    resizingWidth: meta.width
                };
                const { schema: schema, selection: selection } = newEditorState;
                const selected = (0, $bjg0G.findSelectedNodeOfType)(schema.nodes.extension)(selection);
                const isNativeEmbed = selected && (0, $kUhHF.isNativeEmbedNode)(selected.node);
                if (isNativeEmbed) {
                    const newPos = selected.pos;
                    const newAlignment = (0, $ljOiP.getParameters)(selected.node.attrs.parameters, 'alignment');
                    const newLocalId = selected.node.attrs.localId;
                    const prev = nextState.selectedEmbed;
                    if (newPos !== prev?.selectionPos || newAlignment !== prev?.alignment || newLocalId !== prev?.localId) nextState = {
                        ...nextState,
                        trackedEmbedPos: newPos,
                        selectedEmbed: {
                            selectionPos: newPos,
                            alignment: newAlignment,
                            localId: newLocalId
                        }
                    };
                } else if (nextState.selectedEmbed !== null) nextState = {
                    ...nextState,
                    selectedEmbed: null
                };
                return nextState;
            }
        },
        appendTransaction: (transactions, oldState, newState)=>{
            if (!editorAnalyticsApi) return null;
            if ((0, $6SJ6d.isReplaceDocOperation)(transactions, oldState)) return null;
            const isNotLocalInsert = transactions.some((t)=>{
                const action = (0, $brzQy.getLinkMetadataFromTransaction)(t).action;
                const isRemote = t.getMeta('isRemote');
                return isRemote || !(action === (0, $krYZG.ACTION).INSERTED || action === undefined);
            });
            if (isNotLocalInsert) return null;
            const existingLocalIds = new Set();
            oldState.doc.descendants((node)=>{
                if ((0, $kUhHF.isNativeEmbedNode)(node) && node.attrs.localId) existingLocalIds.add(node.attrs.localId);
            });
            const insertedEmbeds = transactions.flatMap((tr)=>{
                const inserted = [];
                if (!tr.docChanged) return inserted;
                tr.steps.forEach((step)=>{
                    if ((0, $gLqwM.stepHasSlice)(step)) step.slice.content.descendants((node)=>{
                        if ((0, $kUhHF.isNativeEmbedNode)(node) && node.attrs.localId !== null && !existingLocalIds.has(node.attrs.localId)) inserted.push(node);
                    });
                });
                return inserted;
            });
            if (insertedEmbeds.length === 0) return null;
            const tr = newState.tr;
            const payload = {
                action: (0, $krYZG.ACTION).INSERTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).NATIVE_EMBED,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    insertedCount: insertedEmbeds.length,
                    inputMethod: $d598f2eb7a08550e$var$getInsertionMethod(transactions)
                }
            };
            editorAnalyticsApi.attachAnalyticsEvent(payload)(tr);
            return tr;
        }
    });
};
module.exports["pluginKey"] = $d598f2eb7a08550e$export$18d4026d1ea86bb1;
module.exports["createPlugin"] = $d598f2eb7a08550e$export$ae829ec7b2625219;

});

parcelRegister("1WSjf", function(module, exports) {

var $ljOiP = parcelRequire("ljOiP");

const $45134b38997529c5$export$f0989780f32bfcda = (selectedNode)=>{
    return (0, $ljOiP.getParameters)(selectedNode.attrs.parameters, 'alignment');
};
const $45134b38997529c5$export$c29861a26436e3b2 = (api, alignment, selectedNode, opts)=>()=>{
        api?.extension?.actions?.api()?.doc?.update(selectedNode.attrs.localId, (current)=>({
                attrs: {
                    ...current.attrs,
                    parameters: (0, $ljOiP.setParameter)(current.attrs?.parameters, {
                        alignment: alignment
                    })
                }
            }), opts);
        return true;
    };
module.exports["getAlignment"] = $45134b38997529c5$export$f0989780f32bfcda;
module.exports["createUpdateAlignmentCommand"] = $45134b38997529c5$export$c29861a26436e3b2;

});

parcelRegister("6yVl9", function(module, exports) {
const $2b3b139efe9f8926$export$fca8c83126802dc4 = (selectedNativeEmbed)=>(state, dispatch)=>{
        const { pos: pos, node: node } = selectedNativeEmbed;
        const localId = typeof node.attrs?.localId === 'string' ? node.attrs.localId : undefined;
        let resolvedPos = pos;
        let resolvedNode = node;
        if (localId) {
            const nodeAtCapturedPos = state.doc.nodeAt(pos);
            if (nodeAtCapturedPos?.attrs?.localId === localId) resolvedNode = nodeAtCapturedPos;
            else {
                let found = false;
                state.doc.descendants((candidateNode, candidatePos)=>{
                    if (found) return false;
                    if (candidateNode.attrs?.localId === localId) {
                        resolvedPos = candidatePos;
                        resolvedNode = candidateNode;
                        found = true;
                        return false;
                    }
                    return true;
                });
                if (!found) return false;
            }
        }
        if (dispatch) dispatch(state.tr.delete(resolvedPos, resolvedPos + resolvedNode.nodeSize));
        return true;
    };
module.exports["createDeleteCommand"] = $2b3b139efe9f8926$export$fca8c83126802dc4;

});

parcelRegister("4xLGC", function(module, exports) {

var $ljOiP = parcelRequire("ljOiP");


var $dunxr = parcelRequire("dunxr");

const $87f12a99e92167f9$export$3c49c185de0c2bfc = (selectedNode)=>{
    return (0, $ljOiP.getParameters)(selectedNode.attrs.parameters, 'width');
};
const $87f12a99e92167f9$export$ea9f617f119f6cd3 = (api, width, selectedNode, height, opts)=>()=>{
        api?.extension?.actions?.api()?.doc?.update(selectedNode.attrs.localId, (current)=>{
            const params = current.attrs?.parameters;
            let updatedParams = (0, $ljOiP.setParameter)(params, {
                width: width
            });
            if (height !== undefined) updatedParams = (0, $ljOiP.setParameter)(updatedParams, {
                height: height
            });
            return {
                attrs: {
                    ...current.attrs,
                    parameters: updatedParams
                }
            };
        }, opts);
        return true;
    };
const $87f12a99e92167f9$export$e8152faa2a85727 = (isResizing, width)=>(state, dispatch)=>{
        if (dispatch) {
            const tr = state.tr;
            tr.setMeta((0, $dunxr.pluginKey), {
                type: 'SET_RESIZING',
                isResizing: isResizing,
                width: width
            });
            tr.setMeta('scrollIntoView', false);
            dispatch(tr);
        }
        return true;
    };
module.exports["getWidth"] = $87f12a99e92167f9$export$3c49c185de0c2bfc;
module.exports["createUpdateWidthCommand"] = $87f12a99e92167f9$export$ea9f617f119f6cd3;

});

parcelRegister("4usZB", function(module, exports) {
/**
 * Whether `key` has been EXPLICITLY persisted in the embed's macroParams.
 *
 * We deliberately do not use `getParameters(...)` here — that helper falls
 * back to `NATIVE_EMBED_PARAMETER_DEFAULTS`, so an unset axis would still
 * appear non-null and the gate would reject every request.
 */ const $b05c344de0002e31$var$isAxisPersisted = (params, key)=>params?.macroParams?.[key] !== undefined;
function $b05c344de0002e31$export$7bdcb3d58987b22e(params, request, policy) {
    return {
        width: policy.gateWidth && $b05c344de0002e31$var$isAxisPersisted(params, 'width') ? undefined : request.width,
        height: policy.gateHeight && $b05c344de0002e31$var$isAxisPersisted(params, 'height') ? undefined : request.height
    };
}
module.exports["resolveChildResize"] = $b05c344de0002e31$export$7bdcb3d58987b22e;

});

parcelRegister("kUhHF", function(module, exports) {

var $2sp5n = parcelRequire("2sp5n");


var $bjg0G = parcelRequire("bjg0G");

/**
 * Returns the currently selected extension node, if any.
 */ const $e4ec95534c49ff7b$var$getSelectedExtension = (state)=>{
    const { schema: schema, selection: selection } = state;
    return (0, $bjg0G.findSelectedNodeOfType)(schema.nodes.extension)(selection) || undefined;
};
const $e4ec95534c49ff7b$export$a990e9e9e93229aa = (node)=>{
    return node.type.name === 'extension' && node.attrs?.extensionType === (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE) && node.attrs?.extensionKey?.includes((0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY));
};
const $e4ec95534c49ff7b$export$1782ddbca43ac707 = (state)=>{
    const selected = $e4ec95534c49ff7b$var$getSelectedExtension(state);
    if (selected && $e4ec95534c49ff7b$export$a990e9e9e93229aa(selected.node)) return selected;
    return undefined;
};
module.exports["isNativeEmbedNode"] = $e4ec95534c49ff7b$export$a990e9e9e93229aa;
module.exports["getSelectedNativeEmbedExtension"] = $e4ec95534c49ff7b$export$1782ddbca43ac707;

});

parcelRegister("gnLph", function(module, exports) {
let $ccdeb71fb1aeba65$var$scopeIds = new WeakMap();
let $ccdeb71fb1aeba65$var$nextScopeId = 0;
const $ccdeb71fb1aeba65$var$maxHeightByScopedLocalId = new Map();
const $ccdeb71fb1aeba65$var$listenersByScopedLocalId = new Map();
const $ccdeb71fb1aeba65$var$getScopedLocalId = (scope, localId)=>{
    const existing = $ccdeb71fb1aeba65$var$scopeIds.get(scope);
    if (existing) return `${existing}:${localId}`;
    const created = `scope-${$ccdeb71fb1aeba65$var$nextScopeId++}`;
    $ccdeb71fb1aeba65$var$scopeIds.set(scope, created);
    return `${created}:${localId}`;
};
function $ccdeb71fb1aeba65$export$e6dec7f2e1126484(scope, localId, maxHeight) {
    const scopedLocalId = $ccdeb71fb1aeba65$var$getScopedLocalId(scope, localId);
    $ccdeb71fb1aeba65$var$maxHeightByScopedLocalId.set(scopedLocalId, maxHeight);
    const listeners = $ccdeb71fb1aeba65$var$listenersByScopedLocalId.get(scopedLocalId);
    if (!listeners) return;
    for (const listener of listeners)try {
        listener(maxHeight);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`[max-height-store] listener for "${localId}" threw:`, error);
    }
}
function $ccdeb71fb1aeba65$export$825c16631b262763(scope, localId) {
    return $ccdeb71fb1aeba65$var$maxHeightByScopedLocalId.get($ccdeb71fb1aeba65$var$getScopedLocalId(scope, localId));
}
function $ccdeb71fb1aeba65$export$7b97fa0ebb9b65f6(scope, localId) {
    const scopedLocalId = $ccdeb71fb1aeba65$var$getScopedLocalId(scope, localId);
    $ccdeb71fb1aeba65$var$maxHeightByScopedLocalId.delete(scopedLocalId);
    $ccdeb71fb1aeba65$var$listenersByScopedLocalId.delete(scopedLocalId);
}
function $ccdeb71fb1aeba65$export$955213572ce75a0(scope, localId, listener) {
    const scopedLocalId = $ccdeb71fb1aeba65$var$getScopedLocalId(scope, localId);
    let listeners = $ccdeb71fb1aeba65$var$listenersByScopedLocalId.get(scopedLocalId);
    if (!listeners) {
        listeners = new Set();
        $ccdeb71fb1aeba65$var$listenersByScopedLocalId.set(scopedLocalId, listeners);
    }
    listeners.add(listener);
    return ()=>{
        const set = $ccdeb71fb1aeba65$var$listenersByScopedLocalId.get(scopedLocalId);
        if (!set) return;
        set.delete(listener);
        if (set.size === 0) $ccdeb71fb1aeba65$var$listenersByScopedLocalId.delete(scopedLocalId);
    };
}
function $ccdeb71fb1aeba65$export$1ccd7a1bde88ea45() {
    $ccdeb71fb1aeba65$var$maxHeightByScopedLocalId.clear();
    $ccdeb71fb1aeba65$var$listenersByScopedLocalId.clear();
    $ccdeb71fb1aeba65$var$scopeIds = new WeakMap();
    $ccdeb71fb1aeba65$var$nextScopeId = 0;
}
module.exports["setMaxHeight"] = $ccdeb71fb1aeba65$export$e6dec7f2e1126484;
module.exports["getMaxHeight"] = $ccdeb71fb1aeba65$export$825c16631b262763;
module.exports["clearMaxHeight"] = $ccdeb71fb1aeba65$export$7b97fa0ebb9b65f6;
module.exports["subscribeMaxHeight"] = $ccdeb71fb1aeba65$export$955213572ce75a0;

});

parcelRegister("gIEgP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5NB3T = parcelRequire("5NB3T");

var $3FYPH = parcelRequire("3FYPH");

var $91WyP = parcelRequire("91WyP");

var $iEFx5 = parcelRequire("iEFx5");

var $2BvhC = parcelRequire("2BvhC");


var $2VYYv = parcelRequire("2VYYv");


var $bjg0G = parcelRequire("bjg0G");


var $7Y8M5 = parcelRequire("7Y8M5");


var $f0b2F = parcelRequire("f0b2F");


var $bH62g = parcelRequire("bH62g");


var $f922E = parcelRequire("f922E");


var $2PKI8 = parcelRequire("2PKI8");


var $f4MCV = parcelRequire("f4MCV");


var $iUhs4 = parcelRequire("iUhs4");


var $fHs3z = parcelRequire("fHs3z");


var $iDfTs = parcelRequire("iDfTs");


var $gC2EJ = parcelRequire("gC2EJ");


var $8VfSP = parcelRequire("8VfSP");


var $V3JOP = parcelRequire("V3JOP");


var $1WMy0 = parcelRequire("1WMy0");


var $k9wGn = parcelRequire("k9wGn");

var $ljOiP = parcelRequire("ljOiP");


var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");


var $iwIwp = parcelRequire("iwIwp");


var $74Lcy = parcelRequire("74Lcy");


var $4qo4H = parcelRequire("4qo4H");


var $hHNKT = parcelRequire("hHNKT");


var $7ILEx = parcelRequire("7ILEx");


var $4xLGC = parcelRequire("4xLGC");


var $dunxr = parcelRequire("dunxr");


var $kUhHF = parcelRequire("kUhHF");


var $cbl1F = parcelRequire("cbl1F");


var $eUUS2 = parcelRequire("eUUS2");


var $cersU = parcelRequire("cersU");


var $93v4e = parcelRequire("93v4e");


var $4LsAR = parcelRequire("4LsAR");


var $kkW8v = parcelRequire("kkW8v");

const $31267a1dabad5140$var$ALIGNMENT_ICONS = {
    left: (0, (/*@__PURE__*/$parcel$interopDefault($f922E))),
    center: (0, (/*@__PURE__*/$parcel$interopDefault($bH62g))),
    right: (0, (/*@__PURE__*/$parcel$interopDefault($2PKI8))),
    'wrap-left': (0, (/*@__PURE__*/$parcel$interopDefault($f4MCV))),
    'wrap-right': (0, (/*@__PURE__*/$parcel$interopDefault($iUhs4)))
};
const $31267a1dabad5140$var$getAlignmentLabel = (alignment, intl)=>{
    switch(alignment){
        case 'left':
            return intl.formatMessage((0, $5NB3T.alignmentMessages).alignLeft);
        case 'center':
            return intl.formatMessage((0, $5NB3T.alignmentMessages).alignCenter);
        case 'right':
            return intl.formatMessage((0, $5NB3T.alignmentMessages).alignRight);
        case 'wrap-left':
            return intl.formatMessage((0, $2BvhC.toolbarMessages).wrapLeft);
        case 'wrap-right':
            return intl.formatMessage((0, $2BvhC.toolbarMessages).wrapRight);
    }
};
const $31267a1dabad5140$var$getAlignmentIcon = (alignment, intl)=>{
    const IconComponent = $31267a1dabad5140$var$ALIGNMENT_ICONS[alignment];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
        color: "currentColor",
        spacing: "spacious",
        label: $31267a1dabad5140$var$getAlignmentLabel(alignment, intl)
    });
};
const $31267a1dabad5140$var$NativeEmbedDropdownIcon = ({ icon: IconComponent, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            alignItems: 'center',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            marginRight: "var(--ds-space-negative-100, -8px)"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
        color: "currentColor",
        label: label,
        spacing: "none"
    }));
/**
 * Converts a custom EditorToolbarAction to a FloatingToolbarItem.
 * Uses customActionHandlers from manifest when resolving handler.
 */ function $31267a1dabad5140$var$convertCustomActionToToolbarItem(action, customActionHandlers) {
    return {
        id: `native-embed-${action.key}`,
        type: 'button',
        title: action.label,
        showTitle: action.showTitle,
        icon: action.icon,
        disabled: action.disabled,
        onClick: ()=>{
            customActionHandlers[action.handlerKey];
            return true;
        },
        focusEditoronEnter: true,
        tabIndex: null
    };
}
/**
 * Creates a registry of built-in toolbar items keyed by their BUILTIN_TOOLBAR_KEYS.
 * Resolves handlers from manifest first, then falls back to default actions.
 */ function $31267a1dabad5140$var$createBuiltinToolbarRegistry(handlers, parameters, intl, schema, state, embedWidth, lineLength, api, manifestHandlers, isAskRovoEnabled, selectedNode) {
    // When the embed width is greater than or equal to the layout width,
    // only "center" alignment is valid — disable all other options.
    const shouldDisableNonCenterAlignments = embedWidth !== undefined && lineLength !== undefined && embedWidth >= lineLength;
    const alignmentOptions = (0, $k9wGn.ALIGNMENT_VALUES).map((alignment)=>({
            id: `native-embed-alignment-${alignment}`,
            title: $31267a1dabad5140$var$getAlignmentLabel(alignment, intl),
            onClick: handlers.onAlignmentClick(alignment),
            selected: parameters.alignment === alignment,
            disabled: shouldDisableNonCenterAlignments && alignment !== 'center',
            icon: $31267a1dabad5140$var$getAlignmentIcon(alignment, intl)
        }));
    const alignmentDropdownTitle = $31267a1dabad5140$var$getAlignmentLabel(parameters.alignment, intl);
    const AlignmentIconComponent = $31267a1dabad5140$var$ALIGNMENT_ICONS[parameters.alignment];
    // When a manifest provides its own handler, leave gating up to the experience itself.
    // When the experience provides an isAskRovoEnabled gate, use that.
    // Otherwise, fall back to the default experiment check.
    const showAskRovo = Boolean(manifestHandlers?.onAskRovoClick) || (isAskRovoEnabled ? isAskRovoEnabled() : (0, $ieeJu.expValEquals)('platform_editor_rovobutton_smartlink_toolbar_exp', 'isEnabled', true));
    const showSummarise = Boolean(manifestHandlers?.onSummariseClick) || (0, $ieeJu.expValEquals)('platform_editor_rovobutton_smartlink_toolbar_exp', 'isEnabled', true);
    const askRovoButton = handlers.askRovoButton;
    const showAskRovoFloatingToolbarButton = (0, $ixfCV.fg)('platform_editor_maui_jira_updates') ? showAskRovo && handlers.onAskRovoClick && askRovoButton : showAskRovo && askRovoButton;
    const showRemixFloatingToolbarButton = (0, $ixfCV.fg)('maui_remixable_page_native_embeds');
    const shouldDisableRemix = api?.malleableUi?.actions?.shouldDisableRemix?.() && (0, $ixfCV.fg)('platform_editor_ai_remix_toolbar');
    return {
        ...showAskRovoFloatingToolbarButton && askRovoButton ? {
            [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO]: {
                type: 'custom',
                fallback: [],
                supportsViewMode: true,
                render: (view)=>view ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eUUS2.AskRovoToolbarButton), {
                        button: askRovoButton,
                        isDisabled: shouldDisableRemix,
                        /* eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed) */ onClick: ()=>handlers.onAskRovoClick?.()(view.state, view.dispatch)
                    }) : null
            },
            [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).REMIX_VARIANT]: handlers.getRemixVariantButton?.({
                intl: intl,
                node: selectedNode,
                schema: schema,
                state: state
            }),
            ...showRemixFloatingToolbarButton ? {
                [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).REMIX]: handlers.getRemixButton?.({
                    intl: intl,
                    node: selectedNode
                })
            } : {}
        } : {},
        ...showSummarise ? {
            [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SUMMARISE]: {
                id: 'native-embed-summarise-button',
                type: 'button',
                title: intl.formatMessage((0, $4qo4H.nativeEmbedToolbarMessages).summarise),
                showTitle: true,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))),
                onClick: handlers.onSummariseClick(),
                focusEditoronEnter: true,
                tabIndex: null
            }
        } : {},
        [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).REFRESH]: {
            id: 'native-embed-refresh-button',
            type: 'button',
            title: intl.formatMessage((0, $4qo4H.nativeEmbedToolbarMessages).refresh),
            showTitle: true,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($1WMy0))),
            onClick: handlers.onRefreshClick(),
            focusEditoronEnter: true,
            tabIndex: null
        },
        [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED]: {
            ...(0, $cbl1F.getNativeEmbedAppearanceDropdown)({
                intl: intl,
                onAppearanceClick: handlers.onAppearanceClick
            })
        },
        [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).BORDER]: {
            type: 'custom',
            render: (view, idx)=>{
                if (!view || !selectedNode) return null;
                const extendedMacroParams = selectedNode.attrs.parameters?.macroParams;
                const borderColor = extendedMacroParams?.borderColor?.value || undefined;
                const borderSize = extendedMacroParams?.borderSize?.value ? Number(extendedMacroParams.borderSize.value) : undefined;
                // Pre-create stable command references to satisfy perf-linting/no-unstable-inline-props
                const toggleBorder = ()=>(0, $7ILEx.createToggleBorderCommand)(api, selectedNode)(view.state, view.dispatch);
                const setBorderColor = (color)=>(0, $7ILEx.createSetBorderColorCommand)(api, color, selectedNode)(view.state, view.dispatch);
                const setBorderSize = (size)=>(0, $7ILEx.createSetBorderSizeCommand)(api, size, selectedNode)(view.state, view.dispatch);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4LsAR.default), {
                    key: idx,
                    intl: intl,
                    borderColor: borderColor,
                    borderSize: borderSize,
                    toggleBorder: toggleBorder,
                    setBorderColor: setBorderColor,
                    setBorderSize: setBorderSize
                });
            },
            fallback: []
        },
        [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT]: {
            id: 'native-embed-alignment-dropdown',
            type: 'dropdown',
            tooltip: alignmentDropdownTitle,
            title: ' ',
            iconBefore: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($31267a1dabad5140$var$NativeEmbedDropdownIcon, {
                    icon: AlignmentIconComponent,
                    label: alignmentDropdownTitle
                }),
            options: alignmentOptions
        },
        [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW]: {
            id: 'native-embed-open-new-window-button',
            type: 'button',
            title: intl.formatMessage((0, $91WyP.linkMessages).openLink),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
            onClick: handlers.onOpenInNewWindowClick(),
            focusEditoronEnter: true,
            tabIndex: null,
            supportsViewMode: true
        },
        [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EXPAND]: {
            id: 'native-embed-expand-button',
            type: 'button',
            title: intl.formatMessage((0, $4qo4H.nativeEmbedToolbarMessages).expandPreview),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8VfSP))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($8VfSP))),
            onClick: handlers.onExpandClick(),
            focusEditoronEnter: true,
            tabIndex: null
        },
        [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT_URL]: {
            id: 'native-embed-edit-url-button',
            type: 'button',
            title: intl.formatMessage((0, $iEFx5.linkToolbarMessages).editLink),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
            onClick: handlers.onEditUrlClick(),
            focusEditoronEnter: true,
            tabIndex: null
        },
        [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT]: {
            id: 'native-embed-edit-button',
            type: 'button',
            title: intl.formatMessage((0, $iEFx5.linkToolbarMessages).editDatasourceStandalone),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
            onClick: handlers.onEditClick()
        },
        [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY]: {
            id: 'native-embed-copy-button',
            type: 'button',
            title: intl.formatMessage((0, $74Lcy.nativeEmbedBlockMenuMessages).copy),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))),
            onClick: handlers.onCopyClick(),
            focusEditoronEnter: true,
            tabIndex: null,
            supportsViewMode: true
        },
        /**
     * @private
     * @deprecated Use COPY instead. Will be removed in a follow-up PR.
     */ [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY_LINK]: {
            id: 'native-embed-copy-link-button',
            type: 'button',
            title: intl.formatMessage((0, $3FYPH.messages).copyLink),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))),
            onClick: handlers.onCopyLinkClick(),
            focusEditoronEnter: true,
            tabIndex: null,
            supportsViewMode: true
        },
        [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE]: {
            id: 'native-embed-delete-button',
            type: 'button',
            title: intl.formatMessage((0, $3FYPH.messages).deleteBlock),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))),
            onClick: handlers.onDeleteClick(),
            focusEditoronEnter: true,
            tabIndex: null
        }
    };
}
/**
 * Resolves toolbar items from the manifest's items array.
 * Looks up each key in the built-in registry or customActions.
 */ function $31267a1dabad5140$var$resolveToolbarItemsFromItems(items, builtinRegistry, customActions, editorToolbarHandlers) {
    const resolvedItems = [];
    for (const key of items){
        if (key === (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR) resolvedItems.push({
            type: 'separator',
            fullHeight: true,
            supportsViewMode: true
        });
        else if (key in builtinRegistry && ((0, $ixfCV.fg)('platform_editor_ai_remix_toolbar') ? builtinRegistry[key] : true)) resolvedItems.push(builtinRegistry[key]);
        else if (customActions && key in customActions) resolvedItems.push($31267a1dabad5140$var$convertCustomActionToToolbarItem(customActions[key], editorToolbarHandlers));
    }
    return resolvedItems;
}
/**
 * Converts manifest-defined toolbar actions to FloatingToolbarItems.
 * Uses `items` array with built-in registry + custom actions.
 */ function $31267a1dabad5140$var$convertManifestActionsToToolbarItems(manifestActions, handlers, parameters, intl, schema, state, embedWidth, lineLength, api, manifestHandlers, isAskRovoEnabled, selectedNode) {
    if (!manifestActions.items) return [];
    const builtinRegistry = $31267a1dabad5140$var$createBuiltinToolbarRegistry(handlers, parameters, intl, schema, state, embedWidth, lineLength, api, manifestHandlers, isAskRovoEnabled, selectedNode);
    return $31267a1dabad5140$var$resolveToolbarItemsFromItems(manifestActions.items, builtinRegistry, manifestActions.customActions, handlers);
}
/**
 * Returns toolbar sizing configuration when the URL edit toolbar is active.
 */ const $31267a1dabad5140$var$editUrlToolbarConfig = (showUrlToolbar, lpLinkPicker)=>{
    return showUrlToolbar ? {
        height: lpLinkPicker ? (0, $2VYYv.LINKPICKER_HEIGHT_IN_PX) : (0, $2VYYv.RECENT_SEARCH_HEIGHT_IN_PX),
        width: (0, $2VYYv.RECENT_SEARCH_WIDTH_IN_PX),
        forcePlacement: true
    } : {};
};
/**
 * Default items of toolbar items when no manifest is provided.
 */ const $31267a1dabad5140$var$DEFAULT_TOOLBAR_ITEMS = [
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).REFRESH,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).BORDER,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW
];
const $31267a1dabad5140$var$VIEW_MODE_TOOLBAR_ITEMS = [
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EXPAND
];
function $31267a1dabad5140$export$d8e43bed2cd6707f(node) {
    if (!(node instanceof HTMLElement)) return undefined;
    const container = node.querySelector('.extension-container') ?? node.closest('.extension-container');
    return container instanceof HTMLElement ? container : node;
}
/**
 * Returns the default toolbar items when no manifest actions are provided.
 */ function $31267a1dabad5140$var$getDefaultToolbarItems(handlers, parameters, intl, schema, state, embedWidth, lineLength, api, selectedNode) {
    const builtinRegistry = $31267a1dabad5140$var$createBuiltinToolbarRegistry(handlers, parameters, intl, schema, state, embedWidth, lineLength, api, undefined, undefined, selectedNode);
    return $31267a1dabad5140$var$resolveToolbarItemsFromItems($31267a1dabad5140$var$DEFAULT_TOOLBAR_ITEMS, builtinRegistry, undefined, handlers);
}
const $31267a1dabad5140$export$86ce8f8241c20a3 = ({ api: api, linkPickerOptions: linkPickerOptions, lpLinkPicker: lpLinkPicker })=>(state, intl, providerFactory, _activeConfigs)=>{
        const selectedNativeEmbed = (0, $kUhHF.getSelectedNativeEmbedExtension)(state);
        if (!selectedNativeEmbed) return undefined;
        const pluginState = (0, $dunxr.pluginKey).getState(state);
        const isShowingUrlToolbar = pluginState?.showUrlToolbar ?? false;
        const hoverDecoration = api?.decorations?.actions.hoverDecoration;
        const nodeType = state.schema.nodes.extension;
        const deleteHoverPropsFactory = (nt)=>({
                onMouseEnter: hoverDecoration?.(nt, true),
                onMouseLeave: hoverDecoration?.(nt, false),
                onFocus: hoverDecoration?.(nt, true),
                onBlur: hoverDecoration?.(nt, false)
            });
        const parameters = (0, $ljOiP.getParameters)(selectedNativeEmbed.node.attrs.parameters);
        // Resolve manifest from facade — try URL first, then fall back to
        // experience ID extracted from the extensionKey. The URL-based lookup
        // can fail when the embed is reinserted (e.g. after a Rovo edit)
        // without macroParams being preserved.
        const facade = (0, $iwIwp.getNativeEmbedFacade)();
        let manifest = parameters.url ? facade.getManifestByUrl(parameters.url) : undefined;
        if (!manifest) {
            const extensionKey = selectedNativeEmbed.node.attrs.extensionKey;
            const experienceId = extensionKey?.split(':')[1];
            if (experienceId) manifest = facade.getManifestById(experienceId);
        }
        const rawActions = manifest?.uiConfig?.editorToolbarActions;
        const manifestActions = typeof rawActions === 'function' ? rawActions() : rawActions;
        // Determine handlers based on manifest, falling back to defaults
        const resolvedHandlers = (0, $kkW8v.buildToolbarHandlers)(selectedNativeEmbed, manifest?.uiConfig.editorToolbarHandlers, api, parameters, intl, state.schema);
        const getDomRef = (view)=>{
            try {
                const node = (0, $bjg0G.findDomRefAtPos)(selectedNativeEmbed.pos, view.domAtPos.bind(view));
                return $31267a1dabad5140$export$d8e43bed2cd6707f(node);
            } catch  {
                return undefined;
            }
        };
        // For database native embeds with vertical resize (databases-native-embeds-v2 experiment),
        // increase the toolbar offset to clear the bottom drag handle (20px gap).
        const hasVerticalResize = (0, $hHNKT.nativeEmbedAllowsVerticalResize)(selectedNativeEmbed.node);
        const toolbarOffset = hasVerticalResize ? [
            0,
            20
        ] : [
            0,
            8
        ];
        // If URL toolbar is showing, render the edit URL toolbar instead of normal items
        if (isShowingUrlToolbar) return {
            title: 'Native Embed floating toolbar',
            getDomRef: getDomRef,
            nodeType: state.schema.nodes.extension,
            offset: [
                0,
                8
            ],
            scrollable: false,
            ...$31267a1dabad5140$var$editUrlToolbarConfig(true, lpLinkPicker),
            items: [
                (0, $cersU.buildNativeEmbedEditUrlToolbar)({
                    api: api,
                    linkPickerOptions: linkPickerOptions,
                    lpLinkPicker: lpLinkPicker ?? true,
                    providerFactory: providerFactory,
                    selectedNativeEmbed: selectedNativeEmbed
                })
            ]
        };
        // Determine the embed's current width and the layout line length so we
        // can disable non-center alignment options when the embed is as wide as
        // (or wider than) the layout.
        const widthState = api?.width?.sharedState?.currentState();
        const lineLength = widthState?.lineLength || (0, $7Y8M5.akEditorDefaultLayoutWidth);
        const embedWidth = (0, $4xLGC.getWidth)(selectedNativeEmbed.node) ?? lineLength;
        const isInViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
        if (isInViewMode) {
            const builtinRegistry = $31267a1dabad5140$var$createBuiltinToolbarRegistry(resolvedHandlers, parameters, intl, state.schema, state, embedWidth, lineLength, api, manifest?.uiConfig.editorToolbarHandlers, manifest?.uiConfig.isAskRovoEnabled);
            return {
                title: 'Native Embed floating toolbar',
                getDomRef: getDomRef,
                nodeType: state.schema.nodes.extension,
                offset: toolbarOffset,
                items: $31267a1dabad5140$var$resolveToolbarItemsFromItems($31267a1dabad5140$var$VIEW_MODE_TOOLBAR_ITEMS, builtinRegistry, undefined, resolvedHandlers)
            };
        }
        // Convert manifest actions to FloatingToolbarItems, or fall back to default items
        const items = manifestActions ? $31267a1dabad5140$var$convertManifestActionsToToolbarItems(manifestActions, resolvedHandlers, parameters, intl, state.schema, state, embedWidth, lineLength, api, manifest?.uiConfig.editorToolbarHandlers, manifest?.uiConfig.isAskRovoEnabled, selectedNativeEmbed.node) : $31267a1dabad5140$var$getDefaultToolbarItems(resolvedHandlers, parameters, intl, state.schema, state, embedWidth, lineLength, api, selectedNativeEmbed.node);
        // Auto-append the "More Options" dropdown when there are items to show.
        // Default toolbar (no manifest): always show with default items.
        // Manifest toolbar: only show when moreItems is provided with items.
        const showMoreOptions = manifestActions?.moreItems ? Boolean(manifestActions?.moreItems?.length) : true;
        if (showMoreOptions) items.push((0, $93v4e.getMoreOptionsDropdown)(api, selectedNativeEmbed, deleteHoverPropsFactory(nodeType), resolvedHandlers, parameters, intl, manifestActions?.moreItems, manifestActions?.customActions));
        return {
            title: 'Native Embed floating toolbar',
            getDomRef: getDomRef,
            nodeType: state.schema.nodes.extension,
            offset: toolbarOffset,
            items: items
        };
    };
module.exports["getToolbarConfig"] = $31267a1dabad5140$export$86ce8f8241c20a3;

});

parcelRegister("74Lcy", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $05b362cd50fa2589$export$271a7654ce32757b = (0, $kSwu1.defineMessages)({
    copy: {
        id: "editor-plugin-native-embeds.messages.block-menu.copy",
        defaultMessage: "Copy"
    }
});
module.exports["nativeEmbedBlockMenuMessages"] = $05b362cd50fa2589$export$271a7654ce32757b;

});

parcelRegister("4qo4H", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $94ce71f66457d23a$export$cdc1205423c9f2de = (0, $kSwu1.defineMessages)({
    alwaysShowTitle: {
        id: "editor-plugin-native-embeds.messages.native-embed-toolbar.alwaysShowTitle",
        defaultMessage: "Show embed title"
    },
    expandPreview: {
        id: "editor-plugin-native-embeds.messages.native-embed-toolbar.expandPreview",
        defaultMessage: "Expand"
    },
    refresh: {
        id: "editor-plugin-native-embeds.messages.native-embed-toolbar.refresh",
        defaultMessage: "Refresh"
    },
    setEmbedType: {
        id: "editor-plugin-native-embeds.messages.native-embed-toolbar.setEmbedType",
        defaultMessage: "Set embed type"
    },
    summarise: {
        id: "editor-plugin-native-embeds.messages.native-embed-toolbar.summarise",
        defaultMessage: "Summarize"
    }
});
module.exports["nativeEmbedToolbarMessages"] = $94ce71f66457d23a$export$cdc1205423c9f2de;

});

parcelRegister("hHNKT", function(module, exports) {

var $ljOiP = parcelRequire("ljOiP");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $iwIwp = parcelRequire("iwIwp");

const $f02260fba5bb4551$var$NATIVE_EMBED_EXPERIENCE_PREFIX = 'native-embed:';
// eslint-disable-next-line require-unicode-regexp
const $f02260fba5bb4551$var$DATABASE_NATIVE_EMBED_URL_PATTERN = /\/wiki\/spaces\/[^/]+\/database\/\d+(\?.*)?$/;
// Gates the vertical-resize behavior for db native embeds. While the experiment
// is off, the short-circuit for database embeds is skipped and
// `nativeEmbedAllowsVerticalResize` always reports `false`, so behavior is
// identical to the horizontal-only resize state. Pre-checks `cc-maui-experiment`
// (without firing exposure) so the v2 exposure population stays scoped to the
// MAUI cohort.
const $f02260fba5bb4551$var$isNativeDbEmbedsV2ExperimentEnabled = ()=>(0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) && (0, $ieeJu.expValEquals)('databases-native-embeds-v2', 'isEnabled', true);
const $f02260fba5bb4551$export$c63b2d526fa9c9d1 = (extensionKey)=>{
    if (!extensionKey) return undefined;
    const idx = extensionKey.indexOf($f02260fba5bb4551$var$NATIVE_EMBED_EXPERIENCE_PREFIX);
    if (idx === -1) return undefined;
    const id = extensionKey.slice(idx + $f02260fba5bb4551$var$NATIVE_EMBED_EXPERIENCE_PREFIX.length);
    return id || undefined;
};
const $f02260fba5bb4551$var$getNativeEmbedNodeUrl = (parameters)=>{
    const urlFromMacroParams = (0, $ljOiP.getParameters)(parameters, 'url');
    if (urlFromMacroParams) return urlFromMacroParams;
    const flatUrl = parameters?.url;
    if (typeof flatUrl === 'string') return flatUrl;
    return flatUrl?.value;
};
const $f02260fba5bb4551$export$5656dd81bb31ebb8 = (node)=>{
    const facade = (0, $iwIwp.getNativeEmbedFacade)();
    const experienceId = $f02260fba5bb4551$export$c63b2d526fa9c9d1(node.attrs.extensionKey);
    if (experienceId) {
        const byId = facade.getManifestById(experienceId);
        if (byId) return byId;
    }
    const nodeUrl = $f02260fba5bb4551$var$getNativeEmbedNodeUrl(node.attrs.parameters);
    if (nodeUrl) return facade.getManifestByUrl(nodeUrl);
    return undefined;
};
const $f02260fba5bb4551$export$5afeb39b81d798eb = (url)=>{
    return !!url && $f02260fba5bb4551$var$DATABASE_NATIVE_EMBED_URL_PATTERN.test(url);
};
const $f02260fba5bb4551$export$fcdc775fd72fbed9 = (node)=>{
    if ($f02260fba5bb4551$var$isNativeDbEmbedsV2ExperimentEnabled()) {
        const id = $f02260fba5bb4551$export$c63b2d526fa9c9d1(node.attrs.extensionKey);
        const nodeUrl = $f02260fba5bb4551$var$getNativeEmbedNodeUrl(node.attrs.parameters);
        if (id === 'database' || id === 'database-entry' || $f02260fba5bb4551$export$5afeb39b81d798eb(nodeUrl)) return false;
    }
    const manifest = $f02260fba5bb4551$export$5656dd81bb31ebb8(node);
    if (manifest) return manifest.lockResizeAspectRatio?.() ?? true;
    return true;
};
const $f02260fba5bb4551$export$b594514954d95745 = (node)=>{
    if (!$f02260fba5bb4551$var$isNativeDbEmbedsV2ExperimentEnabled()) return false;
    const manifest = $f02260fba5bb4551$export$5656dd81bb31ebb8(node);
    return manifest?.allowVerticalResize ?? false;
};
module.exports["getNativeEmbedExperienceIdFromExtensionKey"] = $f02260fba5bb4551$export$c63b2d526fa9c9d1;
module.exports["getNativeEmbedShouldLockAspectRatio"] = $f02260fba5bb4551$export$fcdc775fd72fbed9;
module.exports["nativeEmbedAllowsVerticalResize"] = $f02260fba5bb4551$export$b594514954d95745;

});

parcelRegister("7ILEx", function(module, exports) {

var $ljOiP = parcelRequire("ljOiP");

const $ea287d488ebca970$export$cd1350638370dbe1 = '#091E4224';
const $ea287d488ebca970$export$368b62735a1b3872 = 1;
const $ea287d488ebca970$export$1f2a2eaba9ed74e9 = (selectedNode)=>{
    const macroParams = selectedNode.attrs.parameters?.macroParams ?? {};
    // Access as extended params (borderColor/borderSize added in MAUI-478)
    const extendedParams = macroParams;
    return {
        color: extendedParams.borderColor?.value || undefined,
        size: extendedParams.borderSize?.value ? Number(extendedParams.borderSize.value) : undefined
    };
};
/**
 * Removes borderColor and borderSize keys from macroParams entirely.
 */ const $ea287d488ebca970$var$removeBorderFromParameters = (parameters)=>{
    const { borderColor: _bc, borderSize: _bs, ...restMacroParams } = parameters?.macroParams ?? {};
    return {
        ...parameters ?? {},
        macroParams: restMacroParams
    };
};
const $ea287d488ebca970$export$d8d3b5afcdf52490 = (api, color, selectedNode)=>()=>{
        const currentParams = selectedNode.attrs.parameters;
        const extendedParams = currentParams?.macroParams;
        const hasBorderSize = !!extendedParams?.borderSize?.value;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const update = {
            borderColor: color,
            // Only set a default size if none is already stored
            ...!hasBorderSize ? {
                borderSize: $ea287d488ebca970$export$368b62735a1b3872
            } : {}
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newParameters = (0, $ljOiP.setParameters)(currentParams, update);
        api?.extension?.actions?.api()?.doc?.update(selectedNode.attrs.localId, (current)=>({
                attrs: {
                    ...current.attrs,
                    parameters: newParameters
                }
            }));
        return true;
    };
const $ea287d488ebca970$export$332491e877ad56a5 = (api, size, selectedNode)=>()=>{
        const currentParams = selectedNode.attrs.parameters;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newParameters = (0, $ljOiP.setParameters)(currentParams, {
            borderSize: size
        });
        api?.extension?.actions?.api()?.doc?.update(selectedNode.attrs.localId, (current)=>({
                attrs: {
                    ...current.attrs,
                    parameters: newParameters
                }
            }));
        return true;
    };
const $ea287d488ebca970$export$ad24774c83d7117b = (api, selectedNode)=>()=>{
        const currentParams = selectedNode.attrs.parameters;
        const currentColor = currentParams?.macroParams?.borderColor?.value;
        let newParameters;
        if (currentColor) // Remove border — delete borderColor and borderSize from macroParams
        newParameters = $ea287d488ebca970$var$removeBorderFromParameters(currentParams);
        else // Add border with defaults
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        newParameters = (0, $ljOiP.setParameters)(currentParams, {
            borderColor: $ea287d488ebca970$export$cd1350638370dbe1,
            borderSize: $ea287d488ebca970$export$368b62735a1b3872
        });
        api?.extension?.actions?.api()?.doc?.update(selectedNode.attrs.localId, (current)=>({
                attrs: {
                    ...current.attrs,
                    parameters: newParameters
                }
            }));
        return true;
    };
module.exports["createSetBorderColorCommand"] = $ea287d488ebca970$export$d8d3b5afcdf52490;
module.exports["createSetBorderSizeCommand"] = $ea287d488ebca970$export$332491e877ad56a5;
module.exports["createToggleBorderCommand"] = $ea287d488ebca970$export$ad24774c83d7117b;

});

parcelRegister("cbl1F", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9bUBT = parcelRequire("9bUBT");


var $bI2nS = parcelRequire("bI2nS");

var $iEFx5 = parcelRequire("iEFx5");


var $hade9 = parcelRequire("hade9");


var $11OF7 = parcelRequire("11OF7");


var $kvJb4 = parcelRequire("kvJb4");


var $foj7F = parcelRequire("foj7F");


var $hWLxu = parcelRequire("hWLxu");


var $9d7Pd = parcelRequire("9d7Pd");

var $8oBbn = parcelRequire("8oBbn");

var $6IL1T = parcelRequire("6IL1T");

var $8FgJC = parcelRequire("8FgJC");

const $d77861c8602f769f$var$APPEARANCE_OPTIONS = [
    'url',
    'inline',
    'block',
    'embed'
];
const $d77861c8602f769f$var$appearanceMetadataMap = {
    url: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hade9))),
        message: (0, $bI2nS.messages).urlTitle
    },
    inline: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hWLxu))),
        message: (0, $bI2nS.messages).inlineTitle
    },
    block: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kvJb4))),
        message: (0, $bI2nS.messages).blockTitle
    },
    embed: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($foj7F))),
        message: (0, $bI2nS.messages).embedTitle,
        description: (0, $bI2nS.messages).embedToBlockCardWarning
    }
};
const $d77861c8602f769f$var$buildAppearanceDropdownOptions = (intl, onAppearanceClick)=>$d77861c8602f769f$var$APPEARANCE_OPTIONS.map((appearance)=>({
            id: `native-embed-appearance-${appearance}`,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d77861c8602f769f$var$appearanceMetadataMap[appearance].icon, {
                color: 'currentColor',
                label: '',
                spacing: 'spacious'
            }),
            onClick: onAppearanceClick(appearance),
            selected: appearance === 'embed',
            title: intl.formatMessage($d77861c8602f769f$var$appearanceMetadataMap[appearance].message),
            description: $d77861c8602f769f$var$appearanceMetadataMap[appearance].description && intl.formatMessage($d77861c8602f769f$var$appearanceMetadataMap[appearance].description)
        }));
const $d77861c8602f769f$var$NativeEmbedAppearanceMenu = ({ dispatchCommand: dispatchCommand, intl: intl, options: options })=>{
    const preferencesHref = (0, $9bUBT.getLinkPreferencesURLFromENV)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), null, options.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            key: option.id ?? option.title,
            iconBefore: option.icon,
            /* eslint-disable-next-line @atlassian/perf-linting/detect-unnecessary-rerenders,@atlassian/perf-linting/no-unstable-inline-props  */ onClick: ()=>dispatchCommand(option.onClick),
            isSelected: option.selected,
            description: option.description,
            shouldDescriptionWrap: true
        }, option.title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8oBbn.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($11OF7))), {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        }),
        href: preferencesHref,
        target: "_blank"
    }, intl.formatMessage((0, $iEFx5.linkToolbarMessages).preferencesLink))));
};
const $d77861c8602f769f$export$8777833158c4a88c = ({ intl: intl, onAppearanceClick: onAppearanceClick })=>{
    const options = $d77861c8602f769f$var$buildAppearanceDropdownOptions(intl, onAppearanceClick);
    const dropdownOptions = {
        render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d77861c8602f769f$var$NativeEmbedAppearanceMenu, {
                dispatchCommand: props.dispatchCommand,
                intl: intl,
                options: options
            }),
        width: 220,
        height: 260
    };
    const title = intl.formatMessage($d77861c8602f769f$var$appearanceMetadataMap.embed.message);
    const iconBefore = $d77861c8602f769f$var$appearanceMetadataMap.embed.icon;
    return {
        id: 'native-embed-appearance-dropdown',
        type: 'dropdown',
        testId: 'native-embed-appearance-dropdown',
        title: title,
        iconBefore: iconBefore,
        options: dropdownOptions
    };
};
module.exports["getNativeEmbedAppearanceDropdown"] = $d77861c8602f769f$export$8777833158c4a88c;

});

parcelRegister("eUUS2", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $koQIB = parcelRequire("koQIB");

function $a0b3fecddae323a7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
const $a0b3fecddae323a7$var$buttonWrapperStyles = {
    name: "1tyrre4",
    styles: "& button{&::after{display:none;}}"
};
const $a0b3fecddae323a7$var$buttonLabelStyles = {
    name: "5703k4",
    styles: "color:var(--ds-text-subtle, #505258)"
};
function $a0b3fecddae323a7$export$cc61d4d88dbc5bf9({ button: button, isDisabled: isDisabled, onClick: onClick }) {
    const tooltipContent = typeof button.tooltipContent !== 'function' ? button.tooltipContent : undefined;
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $a0b3fecddae323a7$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $koQIB.ConversationAssistantButtonNav4), {
        isActive: false,
        isDisabled: isDisabled,
        label: /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            css: $a0b3fecddae323a7$var$buttonLabelStyles
        }, button.title),
        onClick: onClick,
        productKey: "confluence",
        siteId: "stub-site-id",
        tooltipContent: tooltipContent
    }));
}
module.exports["AskRovoToolbarButton"] = $a0b3fecddae323a7$export$cc61d4d88dbc5bf9;

});

parcelRegister("koQIB", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $4nIKB = parcelRequire("4nIKB");


var $ivGQ2 = parcelRequire("ivGQ2");


var $cXtTj = parcelRequire("cXtTj");


var $bltJZ = parcelRequire("bltJZ");


var $fk0Hw = parcelRequire("fk0Hw");


var $ixfCV = parcelRequire("ixfCV");


var $9Zall = parcelRequire("9Zall");


var $8jXZv = parcelRequire("8jXZv");


var $lpNn5 = parcelRequire("lpNn5");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $1shFr = parcelRequire("1shFr");


var $k9mk2 = parcelRequire("k9mk2");


var $lfMWT = parcelRequire("lfMWT");


var $koH7z = parcelRequire("koH7z");


var $jdw9n = parcelRequire("jdw9n");


var $bY61u = parcelRequire("bY61u");


var $j0DuU = parcelRequire("j0DuU");


var $dY6UE = parcelRequire("dY6UE");


var $c1KVP = parcelRequire("c1KVP");

const $ef750f68c6472b35$var$defaultButtonStyles = {
    paddingInline: "var(--ds-space-100, 8px)"
};
const $ef750f68c6472b35$var$inactiveButtonStyles = {
    background: "var(--ds-background-neutral, #0515240F)"
};
const $ef750f68c6472b35$var$disabledButtonStyles = {
    background: "var(--ds-background-disabled, #0515240F)",
    color: "var(--ds-text-disabled, #080F214A)"
};
const $ef750f68c6472b35$var$conversationAssistantButtonWrapperNoOverlayStyles = null;
const $ef750f68c6472b35$var$topNavButtonFlareKeyframes = null;
const $ef750f68c6472b35$var$topNavButtonFlareAnimationStyles = null;
const $ef750f68c6472b35$var$baseShadow = `0 0 0 2px ${"var(--ds-border-discovery, #AF59E1)"}`;
const $ef750f68c6472b35$var$pulseKeyframes = null;
const $ef750f68c6472b35$var$pulseAnimationStyles = null;
const $ef750f68c6472b35$var$reduceMotionStyles = null; /**
                                  * Wraps button in a div that plays the top-nav flare animation.
                                  */ 
const $ef750f68c6472b35$var$AnimatedFlareWrapper = ({ productKey: productKey, children: children })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    (0, $cozmU.useEffect)(()=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'viewed',
            actionSubject: 'animation',
            actionSubjectId: 'conversationAssistantButtonFlareAnimation',
            attributes: {
                productKey: productKey
            }
        });
    }, [
        sendAnalyticsEvent,
        productKey
    ]);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "animated-flare-wrapper",
        className: (0, $hekY6.default)([
            "_7dirvuon _d32vi7uo _1q9t1wq8 _6pup19i6 _4pkpi7uo",
            "_1reo15vq _18m915vq _2rko12b0 _1e0c116y _mkrzh8ib _kqswh2mm _1s6k11yk _1dbx1m5u _joxli11n _evp6kb7n _108810qc _154y15ob _1kt9b3bt _1uit1osq _iajmqkx9 _z5wtidpf _154pidpf _dsq4glyw _1cs8stnw _1g0vidpf _7dir1j28 _6pup1j28 _1xoxglyw _1rgridpf"
        ])
    }, children);
};
const $ef750f68c6472b35$var$getConversationAssistantButton = (Button = (0, $ivGQ2.PrimaryButton))=>/*#__PURE__*/ (0, $cozmU.forwardRef)(({ testId: testId, isActive: isActive, isDisabled: isDisabled = false, onClick: onClickProp, onMouseEnter: onMouseEnterProp, label: label, tooltipContent: tooltipContent, shortcut: shortcut, siteId: siteId, productKey: productKey, enableOnboardingSpotlight: enableOnboardingSpotlight = false }, ref)=>{
        (0, $6cFsl.di)((0, $cXtTj.default), (0, $bY61u.useInsightsStatus));
        const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
        const { start: start } = (0, $k9mk2.useConversationAssistantSpotlightActions)();
        const { PostOfficePlacement: PostOfficePlacement } = (0, $jdw9n.usePostOfficePlacement)(); // Prefetch insights status to warm the cache before the user opens chat.
        // This triggers the backend to generate insights asynchronously if not already cached.
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const isPulseExperimentEnabled = (0, $cXtTj.default).getExperimentValue('rovo_growth_chat_pulse', 'isEnabled', false);
        (0, $bY61u.useInsightsStatus)({
            enabled: isPulseExperimentEnabled,
            assistanceServiceParams: {
                touchpointSource: 'ask-rovo-button-prefetch',
                product: productKey,
                experienceId: 'ai-mate',
                siteId: siteId
            }
        });
        const [prefersReducedMotion] = (0, $cozmU.useState)(()=>typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches === true);
        const [shouldShowMessage, setShouldShowMessage] = (0, $cozmU.useState)(false);
        const messageId = productKey === 'confluence' ? 'confluence_rovo_chat_agents_spotlight_ga' : productKey === 'jira' ? 'jira_rovo_chat_agents_spotlight_ga' : '';
        const shouldUseCoordination = enableOnboardingSpotlight && !!messageId;
        const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)(); // Capture initial prop values in a ref so the rendered event fires exactly once
        // on mount, even if reactive props like isActive/isDisabled change later.
        const renderedAttributesRef = (0, $cozmU.useRef)({
            isActive: isActive,
            isDisabled: isDisabled,
            productKey: productKey
        });
        const sendAnalyticsEventRef = (0, $cozmU.useRef)(sendAnalyticsEvent);
        sendAnalyticsEventRef.current = sendAnalyticsEvent;
        (0, $cozmU.useEffect)(()=>{
            sendAnalyticsEventRef.current({
                eventType: 'operational',
                action: 'rendered',
                actionSubject: 'rovoChatButton',
                attributes: renderedAttributesRef.current
            }); // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
        const openRovoChat = (event, analyticsEvent)=>{
            if (!isActive && onClick) onClick(event, analyticsEvent);
        };
        const onClick = (0, $cozmU.useCallback)((...params)=>{
            sendAnalyticsEvent({
                eventType: 'ui',
                action: 'clicked',
                actionSubject: 'rovoChatButton',
                attributes: {
                    isActive: isActive,
                    isDisabled: isDisabled,
                    productKey: productKey
                }
            });
            return onClickProp?.(...params);
        }, [
            isActive,
            isDisabled,
            onClickProp,
            productKey,
            sendAnalyticsEvent
        ]);
        const interactionName = isActive ? 'close-rovo-chat-nav-button' : 'open-rovo-chat-nav-button';
        const buttonLabel = label ?? formatMessage((0, $c1KVP.messages).rovoChatButtonLabel);
        const getChildren = ()=>{
            const button = /*#__PURE__*/ $cozmU.createElement(Button, {
                "data-spotlight-target": "rovo-chat-ask-rovo-button",
                onMouseEnter: (event)=>{
                    onMouseEnterProp?.(event);
                    sendAnalyticsEvent({
                        eventType: 'ui',
                        action: 'hovered',
                        actionSubject: 'rovoChatButton',
                        attributes: {
                            isActive: isActive,
                            isDisabled: isDisabled,
                            productKey: productKey
                        }
                    });
                    if (shouldShowMessage) {
                        sendAnalyticsEvent({
                            eventType: 'ui',
                            action: 'hovered',
                            actionSubject: 'rovoChatButtonSpotlight'
                        });
                        start();
                    }
                },
                testId: testId,
                isSelected: isActive,
                onClick: onClick,
                isDisabled: isDisabled,
                tooltip: tooltipContent ?? /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, formatMessage((0, $c1KVP.messages).rovoChatButtonLabel)),
                shortcut: shortcut,
                style: {
                    /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ ...$ef750f68c6472b35$var$defaultButtonStyles,
                    ...!isActive && $ef750f68c6472b35$var$inactiveButtonStyles,
                    ...isDisabled && $ef750f68c6472b35$var$disabledButtonStyles
                },
                iconBefore: /*#__PURE__*/ $cozmU.createElement((0, $bltJZ.RovoIcon), {
                    size: "xxsmall"
                }),
                interactionName: interactionName,
                ref: ref
            }, buttonLabel);
            if (Button === (0, $ivGQ2.PrimaryButton)) return /*#__PURE__*/ $cozmU.createElement("div", {
                role: "list"
            }, button);
            if (!isActive && !isDisabled) {
                const shouldAnimateTopNavButton = !prefersReducedMotion && // Targets non-MAU Rovo Chat users — once a user becomes MAU, the gate
                // resolves to false on their next session (batch trait refreshes daily).
                (0, $ixfCV.fg)('rovo_chat_non_mau_rovo_button_animation_filter') && // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
                (0, $cXtTj.default).getExperimentValue('ask_rovo_top_nav_button_animation', 'isEnabled', false);
                if (shouldAnimateTopNavButton) return /*#__PURE__*/ $cozmU.createElement($ef750f68c6472b35$var$AnimatedFlareWrapper, {
                    productKey: productKey
                }, button);
                return /*#__PURE__*/ $cozmU.createElement("div", {
                    className: (0, $hekY6.default)([
                        "_7dirvuon _d32vi7uo _1q9t1wq8 _6pup19i6 _4pkpi7uo"
                    ])
                }, button);
            }
            return button;
        }; // The long-running-task PostOffice placement is anchored to the Ask Rovo
        // button (via data-spotlight-target) and must mount for every product
        // including Townsquare (productKey="atlas"), so it lives outside
        // SpotlightWrapper which only renders for products that opt into the
        // agents-onboarding coordination flow.
        // Uses <Fragment> (not <>) because this file has @jsx pragma without @jsxFrag.
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const isFullPageSpotlightEnabled = productKey === 'jira' && (0, $cXtTj.default).getExperimentValue('rovo_chat_full_page_chat_spotlight', 'isEnabled', false);
        return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, shouldUseCoordination || isFullPageSpotlightEnabled ? /*#__PURE__*/ $cozmU.createElement($ef750f68c6472b35$export$de76c194bfb85689, {
            setShouldShowMessage: setShouldShowMessage,
            messageId: messageId,
            siteId: siteId,
            children: getChildren(),
            shouldShowMessage: shouldShowMessage,
            openRovoChat: (event, analyticsEvent)=>openRovoChat(event, analyticsEvent),
            isFullPageSpotlightEnabled: isFullPageSpotlightEnabled
        }) : getChildren(), PostOfficePlacement && (0, $ixfCV.fg)('rovo_chat_long_running_task_spotlight') && /*#__PURE__*/ $cozmU.createElement(PostOfficePlacement, {
            placementId: "rovo-chat-long-running-task-spotlight"
        }));
    });
const $ef750f68c6472b35$var$Nav4Button = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ tooltip: tooltip, shortcut: shortcut, ...props }, forwardedRef)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        content: tooltip,
        shortcut: shortcut,
        // Announcing the tooltip means 'Chat' would be announced twice
        isScreenReaderAnnouncementDisabled: true
    }, ({ ref: tooltipRef, ...triggerProps })=>/*#__PURE__*/ $cozmU.createElement((0, $fk0Hw.Button), {
            interactionName: props?.interactionName,
            ref: (0, $4nIKB.mergeRefs)([
                forwardedRef,
                tooltipRef
            ]),
            ...triggerProps,
            ...props,
            onClick: (event, analyticsEvent)=>{
                props.onClick?.(event, analyticsEvent);
                triggerProps.onClick?.(event);
            },
            iconBefore: ()=>props.iconBefore || null
        }));
});
const $ef750f68c6472b35$export$7c328c0993982813 = $ef750f68c6472b35$var$getConversationAssistantButton((0, $ivGQ2.PrimaryButton));
const $ef750f68c6472b35$export$25e85d244cbf7845 = $ef750f68c6472b35$var$getConversationAssistantButton($ef750f68c6472b35$var$Nav4Button);
const $ef750f68c6472b35$export$de76c194bfb85689 = ({ children: children, messageId: messageId, siteId: siteId, setShouldShowMessage: setShouldShowMessage, shouldShowMessage: shouldShowMessage, openRovoChat: openRovoChat, isFullPageSpotlightEnabled: isFullPageSpotlightEnabled = false })=>{
    (0, $6cFsl.di)((0, $1shFr.usePostOfficeCoordination));
    const { activeSpotlight: activeSpotlight } = (0, $k9mk2.useConversationAssistantSpotlightState)();
    const [onboardingStarted, stopOnboarding] = (0, $1shFr.usePostOfficeCoordination)(messageId);
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const onDismissMessage = ()=>{
        setShouldShowMessage(false);
        stopOnboarding();
    };
    (0, $cozmU.useEffect)(()=>{
        if (shouldShowMessage && activeSpotlight !== null) sendAnalyticsEvent({
            eventType: 'ui',
            action: 'shown',
            actionSubject: 'rovoChatButtonSpotlight'
        });
    }, [
        shouldShowMessage,
        activeSpotlight,
        sendAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (onboardingStarted) setShouldShowMessage(true);
    }, [
        onboardingStarted,
        setShouldShowMessage
    ]); // Mutually exclusive with the onboarding spotlight — don't show both at once
    const shouldShowFullPageSpotlight = isFullPageSpotlightEnabled && !shouldShowMessage;
    return /*#__PURE__*/ $cozmU.createElement((0, $dY6UE.ConditionalWrapper), {
        condition: shouldShowMessage || shouldShowFullPageSpotlight,
        wrapper: (children)=>/*#__PURE__*/ $cozmU.createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ $cozmU.createElement((0, $8jXZv.PopoverTarget), null, /*#__PURE__*/ $cozmU.createElement("div", {
                className: (0, $hekY6.default)([
                    shouldShowMessage && activeSpotlight === null && "",
                    shouldShowMessage && activeSpotlight === null && "_2rko12b0 _5sagi11n _tip812c5 _j7hqfamb _1pglmcjr _16qs1peg",
                    "_1bumglyw _sedtglyw"
                ])
            }, children, shouldShowFullPageSpotlight && /*#__PURE__*/ $cozmU.createElement((0, $j0DuU.ChunkErrorBoundary), null, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
                fallback: null
            }, /*#__PURE__*/ $cozmU.createElement((0, $lfMWT.AsyncRovoFullPageSpotlightPlacement), {
                openRovoChat: openRovoChat
            }))))), /*#__PURE__*/ $cozmU.createElement((0, $koH7z.ConversationAssistantOnboardingSpotlight), {
                onDismiss: onDismissMessage,
                openRovoChat: openRovoChat
            }))
    }, children);
};
module.exports["ConversationAssistantButtonNav4"] = $ef750f68c6472b35$export$25e85d244cbf7845;

});

parcelRegister("ivGQ2", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $5SGpQ = parcelRequire("5SGpQ");


var $lpNn5 = parcelRequire("lpNn5");


var $1sXWi = parcelRequire("1sXWi");


var $6Wkr7 = parcelRequire("6Wkr7");

function $451908e5ab05faa3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $451908e5ab05faa3$var$VAR_BUTTON_SELECTED_COLOR = '--button-selected-color';
const $451908e5ab05faa3$var$VAR_BUTTON_SELECTED_BORDER_COLOR = '--button-selected-border-color';
const $451908e5ab05faa3$var$buttonBaseStyles = {
    name: "8cx1fx",
    styles: "display:flex;height:100%;position:relative;align-items:center;justify-content:center;flex-direction:column"
};
const $451908e5ab05faa3$var$buttonNoOpStyle = {
    name: "zvio0b",
    styles: "--noop:1"
};
const $451908e5ab05faa3$var$buttonHighlightedStyles = /*#__PURE__*/ (0, $lOiVq.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&& > *': {
        color: `var(${$451908e5ab05faa3$var$VAR_BUTTON_SELECTED_COLOR})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        height: 3,
        position: 'absolute',
        backgroundColor: `var(${$451908e5ab05faa3$var$VAR_BUTTON_SELECTED_BORDER_COLOR})`,
        borderStartEndRadius: "var(--ds-radius-xsmall, 1px)",
        borderStartStartRadius: "var(--ds-radius-xsmall, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineEnd: "var(--ds-space-050, 4px)",
        insetInlineStart: "var(--ds-space-050, 4px)"
    }
});
const $451908e5ab05faa3$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
    const { children: children, component: component, isHighlighted: isHighlighted, isLoading: isLoading, isSelected: isSelected, onClick: onClick, testId: testId, theme: theme, tooltip: tooltip, shortcut: shortcut, ...rest } = props;
    const themeFromContext = (0, $1sXWi.useTheme)();
    const button = /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        style: {
            [$451908e5ab05faa3$var$VAR_BUTTON_SELECTED_COLOR]: themeFromContext.mode.primaryButton.selected.color,
            [$451908e5ab05faa3$var$VAR_BUTTON_SELECTED_BORDER_COLOR]: themeFromContext.mode.primaryButton.selected.borderColor
        },
        css: [
            $451908e5ab05faa3$var$buttonBaseStyles,
            isHighlighted && $451908e5ab05faa3$var$buttonHighlightedStyles
        ],
        role: "listitem",
        "data-vc": "primary-button"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $5SGpQ.default), {
        appearance: "primary",
        component: component,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $6Wkr7.getPrimaryButtonTheme)(themeFromContext),
        css: [
            $451908e5ab05faa3$var$buttonNoOpStyle
        ],
        ...rest
    }, children));
    if (tooltip) return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $lpNn5.default), {
        content: tooltip,
        hideTooltipOnClick: true,
        shortcut: shortcut
    }, button);
    return button;
});
module.exports["PrimaryButton"] = $451908e5ab05faa3$export$ac16a6a04d9b7c84;

});

parcelRegister("1sXWi", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $caBeY = parcelRequire("caBeY");

const $0c1aad5e33f23526$export$93d4e7f90805808f = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $caBeY.ThemeContext));
} : ()=>(0, $cozmU.useContext)((0, $caBeY.ThemeContext));
module.exports["useTheme"] = $0c1aad5e33f23526$export$93d4e7f90805808f;

});

parcelRegister("caBeY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $R7iGI = parcelRequire("R7iGI");

const $a725a8ada4f727cc$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $cozmU.createContext)((0, $R7iGI.defaultTheme));
module.exports["ThemeContext"] = $a725a8ada4f727cc$export$2c657da244d00bd6;

});

parcelRegister("R7iGI", function(module, exports) {

var $esp18 = parcelRequire("esp18");

const $86ec0bf94787f7c8$export$164de7ab8df77ef0 = (0, $esp18.atlassianTheme);
module.exports["defaultTheme"] = $86ec0bf94787f7c8$export$164de7ab8df77ef0;

});

parcelRegister("esp18", function(module, exports) {

var $jY2LF = parcelRequire("jY2LF");


var $3QMns = parcelRequire("3QMns");

const $e836efa0898b03ba$export$eeee8619e1b91cb0 = (0, $3QMns.generateTheme)({
    name: (0, $jY2LF.DEFAULT_THEME_NAME),
    backgroundColor: '#FFFFFF',
    highlightColor: '#0052CC'
});
module.exports["atlassianTheme"] = $e836efa0898b03ba$export$eeee8619e1b91cb0;

});

parcelRegister("jY2LF", function(module, exports) {
const $fa3ed95e05138600$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-pressed, #144794)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold, #1868DB)",
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-hovered, #1558BC)",
                boxShadow: ''
            },
            selected: {
                color: '',
                backgroundColor: '',
                boxShadow: ''
            }
        },
        iconButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: ''
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: ''
            }
        },
        navigation: {
            backgroundColor: "var(--ds-surface, #FFFFFF)",
            color: "var(--ds-text-subtlest, #6B6E76)"
        },
        productHome: {
            backgroundColor: "var(--ds-text-brand, #1868DB)",
            color: "var(--ds-text, #292A2E)",
            borderRight: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
            // TODO: replace with token after brand refresh
            iconColor: '#357DE8',
            textColor: "var(--ds-text, #292A2E)"
        },
        primaryButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            }
        },
        search: {
            default: {
                backgroundColor: "var(--ds-background-input, #FFFFFF)",
                color: "var(--ds-text-subtlest, #6B6E76)",
                borderColor: "var(--ds-border-input, #8C8F97)"
            },
            focus: {
                borderColor: "var(--ds-border-focused, #4688EC)"
            },
            hover: {
                backgroundColor: "var(--ds-background-input-hovered, #F8F8F8)"
            }
        },
        skeleton: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            opacity: 1
        }
    }
};
// Create deep copy of defaultTheme
const $fa3ed95e05138600$var$defaultThemeCopy = JSON.parse(JSON.stringify($fa3ed95e05138600$var$defaultTheme));
// Update iconColor and textColor in defaultThemeBrandRefresh
$fa3ed95e05138600$var$defaultThemeCopy.mode.productHome.iconColor = undefined;
$fa3ed95e05138600$var$defaultThemeCopy.mode.productHome.textColor = undefined;
const $fa3ed95e05138600$export$2491e13b198e597d = 'atlassian';
var $fa3ed95e05138600$export$2e2bcd8739ae039 = $fa3ed95e05138600$var$defaultTheme;
module.exports["DEFAULT_THEME_NAME"] = $fa3ed95e05138600$export$2491e13b198e597d;
module.exports["default"] = $fa3ed95e05138600$export$2e2bcd8739ae039;

});

parcelRegister("3QMns", function(module, exports) {

var $jY2LF = parcelRequire("jY2LF");


var $7hcrB = parcelRequire("7hcrB");


var $jIkZX = parcelRequire("jIkZX");


var $6DrQc = parcelRequire("6DrQc");


var $dZ8SJ = parcelRequire("dZ8SJ");


var $8T7KI = parcelRequire("8T7KI");

const $42bc0c8ea2a74a92$var$generateOpacityValue = (color)=>color === '#000000' ? 0.3 : 0.6;
const $42bc0c8ea2a74a92$var$generateButtonCSSStates = (colors, buttonType)=>{
    const { backgroundColor: backgroundColor, color: color, highlightColor: highlightColor } = colors;
    // Add less opacity for white text so it is still legible.
    const opacityValue = $42bc0c8ea2a74a92$var$generateOpacityValue(color);
    const isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $8T7KI.hexToRGBA)(backgroundColor, 0.65) : (0, $dZ8SJ.getContrastColor)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $6DrQc.getBoxShadow)('transparent'),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $6DrQc.getBoxShadow)('transparent'),
            color: color
        },
        focus: {
            boxShadow: 'none',
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $8T7KI.hexToRGBA)(backgroundColor, 0.8) : (0, $dZ8SJ.getContrastColor)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $6DrQc.getBoxShadow)('transparent'),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $dZ8SJ.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $6DrQc.getBoxShadow)('transparent')
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $dZ8SJ.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $6DrQc.getBoxShadow)('transparent')
        }
    };
};
const $42bc0c8ea2a74a92$var$generateCreateButtonColors = (_themeBackground, themeHighlight)=>({
        backgroundColor: themeHighlight,
        color: (0, $jIkZX.generateTextColor)(themeHighlight),
        highlightColor: themeHighlight
    });
const $42bc0c8ea2a74a92$export$2e4ecffaca289a18 = (themeColors)=>{
    const { backgroundColor: backgroundColor, highlightColor: highlightColor, name: name } = themeColors;
    const color = (0, $jIkZX.generateTextColor)(backgroundColor);
    const colors = {
        ...themeColors,
        color: color
    };
    if (name === (0, $jY2LF.DEFAULT_THEME_NAME)) return 0, $7hcrB.defaultThemeBrandRefresh;
    return {
        mode: {
            create: $42bc0c8ea2a74a92$var$generateButtonCSSStates($42bc0c8ea2a74a92$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: $42bc0c8ea2a74a92$var$generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: $42bc0c8ea2a74a92$var$generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                iconColor: color,
                textColor: color,
                backgroundColor: highlightColor,
                borderRight: `${"var(--ds-border-width, 1px)"} solid ${(0, $8T7KI.hexToRGBA)(color, 0.5)}`
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $8T7KI.hexToRGBA)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $8T7KI.hexToRGBA)(highlightColor, 0.8),
                    boxShadow: (0, $6DrQc.getBoxShadow)((0, $8T7KI.hexToRGBA)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $dZ8SJ.getContrastColor)(0.1, $42bc0c8ea2a74a92$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};
module.exports["generateTheme"] = $42bc0c8ea2a74a92$export$2e4ecffaca289a18;

});

parcelRegister("7hcrB", function(module, exports) {

var $jY2LF = parcelRequire("jY2LF");

const $a303abd91c32b08e$var$defaultThemeCopy = JSON.parse(JSON.stringify((0, $jY2LF.default)));
const $a303abd91c32b08e$export$77823bc9863eaa03 = $a303abd91c32b08e$var$defaultThemeCopy;
module.exports["defaultThemeBrandRefresh"] = $a303abd91c32b08e$export$77823bc9863eaa03;

});

parcelRegister("jIkZX", function(module, exports) {

var $aELWC = parcelRequire("aELWC");


var $bDWMn = parcelRequire("bDWMn");

const $d156dcf17fd40e8f$export$10a10e7cd1193377 = (color)=>{
    const converted = (0, $bDWMn.convertHexShorthand)(color);
    return (0, $aELWC.default).contrastRatio(converted).hex;
};
module.exports["generateTextColor"] = $d156dcf17fd40e8f$export$10a10e7cd1193377;

});

parcelRegister("bDWMn", function(module, exports) {
const $00e839f9891a322a$var$hex = '[a-z0-9]';
const $00e839f9891a322a$var$shortHandHexColorPattern = new RegExp(`#(${$00e839f9891a322a$var$hex})(${$00e839f9891a322a$var$hex})(${$00e839f9891a322a$var$hex})`, 'i');
const $00e839f9891a322a$var$repeat = (str, times)=>[
        ...Array(times)
    ].map(()=>str).join('');
const $00e839f9891a322a$var$isShortHexColor = (color)=>color && color.length === 4;
const $00e839f9891a322a$var$completeHexColor = (colors)=>{
    const hex = colors.map((color)=>$00e839f9891a322a$var$repeat(color, 2)).join('');
    return `#${hex}`;
};
const $00e839f9891a322a$var$completeTriplet = (colors)=>`#${$00e839f9891a322a$var$repeat(colors[1], 6)}`;
const $00e839f9891a322a$var$isTriplet = (colors)=>colors[0] === colors[1] && colors[1] === colors[2];
const $00e839f9891a322a$export$db8d2130677f868c = (color)=>{
    if ($00e839f9891a322a$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        const matches = color.match($00e839f9891a322a$var$shortHandHexColorPattern);
        if (matches) {
            const colors = matches.slice(1, 4);
            if ($00e839f9891a322a$var$isTriplet(colors)) return $00e839f9891a322a$var$completeTriplet(colors);
            else return $00e839f9891a322a$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};
module.exports["convertHexShorthand"] = $00e839f9891a322a$export$db8d2130677f868c;

});

parcelRegister("6DrQc", function(module, exports) {
const $39c046d81b46dcab$export$bba5a971afe05444 = (color)=>`0 0 0 2px ${color}`;
module.exports["getBoxShadow"] = $39c046d81b46dcab$export$bba5a971afe05444;

});

parcelRegister("dZ8SJ", function(module, exports) {

var $aELWC = parcelRequire("aELWC");


var $8T7KI = parcelRequire("8T7KI");

const $51a91b894a1b5a60$export$77a1051494882576 = (contrastValue, opacityValue, color)=>(0, $8T7KI.hexToRGBA)((0, $aELWC.default).contrast(contrastValue, color).hex, opacityValue);
module.exports["getContrastColor"] = $51a91b894a1b5a60$export$77a1051494882576;

});

parcelRegister("8T7KI", function(module, exports) {

var $aELWC = parcelRequire("aELWC");

const $93f364b8cdab62de$export$7229be6d7219ee6a = (hex, opacity = 1)=>{
    const rgba = {
        ...(0, $aELWC.default).convert(hex).rgb,
        a: opacity
    };
    return `rgba(${Object.values(rgba).join(', ')})`;
};
module.exports["hexToRGBA"] = $93f364b8cdab62de$export$7229be6d7219ee6a;

});

parcelRegister("6Wkr7", function(module, exports) {
const $5e6dc6455211c33f$export$14dd6915caf431fe = ({ mode: { primaryButton: primaryButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...primaryButton.default,
                ...props.isSelected && primaryButton.selected,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                padding: `0 ${"var(--ds-space-050, 4px)"}`,
                marginLeft: 0,
                marginRight: 0,
                ':hover': props.isSelected ? primaryButton.selectedHover : primaryButton.hover,
                ':focus': primaryButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && primaryButton.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };
module.exports["getPrimaryButtonTheme"] = $5e6dc6455211c33f$export$14dd6915caf431fe;

});

parcelRegister("1shFr", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6m3nS = parcelRequire("6m3nS");

const $702fb6d2795d3598$export$a890021247f253fb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (messageId)=>{
    const $ = (0, $bDgLe.c)(14);
    const { isActive: poIsActive } = (0, $6m3nS.useTrigger)(`${messageId}-started`);
    const t0 = `${messageId}-start`;
    let t1;
    if ($[0] !== t0) {
        t1 = {
            triggerId: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { fireTrigger: poRequestMessageStart } = (0, $6m3nS.useFirePostOfficeTrigger)(t1);
    const t2 = `${messageId}-dismiss`;
    let t3;
    if ($[2] !== t2) {
        t3 = {
            triggerId: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const { fireTrigger: poFireDismissClick } = (0, $6m3nS.useFirePostOfficeTrigger)(t3);
    let t4;
    if ($[4] !== poRequestMessageStart) {
        t4 = ()=>{
            poRequestMessageStart({
                isActive: true
            });
        };
        $[4] = poRequestMessageStart;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== messageId || $[7] !== poRequestMessageStart) {
        t5 = [
            messageId,
            poRequestMessageStart
        ];
        $[6] = messageId;
        $[7] = poRequestMessageStart;
        $[8] = t5;
    } else t5 = $[8];
    (0, $cozmU.useEffect)(t4, t5);
    const started = poIsActive;
    let t6;
    if ($[9] !== poFireDismissClick) {
        t6 = (force)=>{
            poFireDismissClick({
                isActive: true
            });
        };
        $[9] = poFireDismissClick;
        $[10] = t6;
    } else t6 = $[10];
    const stop = t6;
    let t7;
    if ($[11] !== started || $[12] !== stop) {
        t7 = [
            started,
            stop
        ];
        $[11] = started;
        $[12] = stop;
        $[13] = t7;
    } else t7 = $[13];
    return t7;
} : (messageId)=>{
    const { isActive: poIsActive } = (0, $6m3nS.useTrigger)(`${messageId}-started`);
    const { fireTrigger: poRequestMessageStart } = (0, $6m3nS.useFirePostOfficeTrigger)({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: poFireDismissClick } = (0, $6m3nS.useFirePostOfficeTrigger)({
        triggerId: `${messageId}-dismiss`
    });
    (0, $cozmU.useEffect)(()=>{
        poRequestMessageStart({
            isActive: true
        });
    }, [
        messageId,
        poRequestMessageStart
    ]);
    const started = poIsActive;
    const stop = (force)=>{
        poFireDismissClick({
            isActive: true
        });
    };
    return [
        started,
        stop
    ];
};
module.exports["usePostOfficeCoordination"] = $702fb6d2795d3598$export$a890021247f253fb;

});

parcelRegister("k9mk2", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $a103c65beb9e285f$var$initialState = {
    activeSpotlight: null
};
const $a103c65beb9e285f$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                activeSpotlight: 0
            });
        },
    next: ()=>({ setState: setState, getState: getState })=>{
            setState({
                activeSpotlight: (getState().activeSpotlight || 0) + 1
            });
        },
    end: ()=>({ setState: setState })=>{
            setState({
                activeSpotlight: null
            });
        }
};
const $a103c65beb9e285f$var$ConversationAssistantSpotlightStore = (0, $8s9DV.createStore)({
    initialState: $a103c65beb9e285f$var$initialState,
    actions: $a103c65beb9e285f$var$actions,
    name: 'ConversationAssistantSpotlightStore'
});
const $a103c65beb9e285f$export$283f4929c8863814 = (0, $kBr4q.createActionsHook)($a103c65beb9e285f$var$ConversationAssistantSpotlightStore);
const $a103c65beb9e285f$export$258c2a6b93cdef4a = (0, $kBr4q.createStateHook)($a103c65beb9e285f$var$ConversationAssistantSpotlightStore);
module.exports["useConversationAssistantSpotlightActions"] = $a103c65beb9e285f$export$283f4929c8863814;
module.exports["useConversationAssistantSpotlightState"] = $a103c65beb9e285f$export$258c2a6b93cdef4a;

});

parcelRegister("lfMWT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $c7538dea34e781c7$export$2a0e9ab75aa119a4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("2rrho")).then(({ RovoFullPageSpotlightPlacement: RovoFullPageSpotlightPlacement })=>({
            default: RovoFullPageSpotlightPlacement
        })));
$c7538dea34e781c7$export$2a0e9ab75aa119a4.displayName = 'AsyncRovoFullPageSpotlightPlacement';
module.exports["AsyncRovoFullPageSpotlightPlacement"] = $c7538dea34e781c7$export$2a0e9ab75aa119a4;

});

parcelRegister("2rrho", function(module, exports) {

let $1c73438ee0ae26e6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1c73438ee0ae26e6$var$load("iu8QM"),
    $1c73438ee0ae26e6$var$load("hVR94"),
    $1c73438ee0ae26e6$var$load("4Zbes"),
    $1c73438ee0ae26e6$var$load("2uWWQ")
]).then(()=>parcelRequire('eH7fb'));

});

parcelRegister("koH7z", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $3eYzF = parcelRequire("3eYzF");


var $uyMbP = parcelRequire("uyMbP");


var $gi4qj = parcelRequire("gi4qj");


var $4AC39 = parcelRequire("4AC39");


var $l3ydK = parcelRequire("l3ydK");


var $2Vz7H = parcelRequire("2Vz7H");


var $6VFk2 = parcelRequire("6VFk2");


var $4enp7 = parcelRequire("4enp7");


var $dOlTT = parcelRequire("dOlTT");


var $2K2hA = parcelRequire("2K2hA");


var $6Yblc = parcelRequire("6Yblc");


var $Ou0Zz = parcelRequire("Ou0Zz");


var $k9mk2 = parcelRequire("k9mk2");


var $7s6Nk = parcelRequire("7s6Nk");

const $cde915fd77272962$export$e4abc8af2fc5e2ac = ({ openRovoChat: openRovoChat, onDismiss: onDismiss })=>{
    (0, $6cFsl.di)((0, $k9mk2.useConversationAssistantSpotlightState));
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { end: end } = (0, $k9mk2.useConversationAssistantSpotlightActions)();
    const { activeSpotlight: activeSpotlight } = (0, $k9mk2.useConversationAssistantSpotlightState)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const handleTryChat = (event, analyticsEvent)=>{
        if (openRovoChat) openRovoChat(event, analyticsEvent);
        end();
        onDismiss();
        sendAnalyticsEvent({
            eventType: 'ui',
            // this is more of 'chatButtonClicked'
            action: 'dismissed',
            actionSubject: 'rovoChatButtonSpotlight'
        });
    };
    const handleDismiss = ()=>{
        end();
        onDismiss();
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'dismissButtonClicked',
            actionSubject: 'rovoChatButtonSpotlight'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, activeSpotlight !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dOlTT.PopoverContent), {
        dismiss: handleDismiss,
        isVisible: activeSpotlight !== null,
        placement: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gi4qj.SpotlightCard), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6VFk2.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4enp7.SpotlightHeadline), null, formatMessage((0, $7s6Nk.default).onboardingHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AC39.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l3ydK.SpotlightDismissControl), {
        onClick: handleDismiss
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyMbP.SpotlightBody), null, formatMessage((0, $7s6Nk.default).onboardingDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Vz7H.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eYzF.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Yblc.SpotlightSecondaryAction), {
        onClick: handleDismiss
    }, formatMessage((0, $7s6Nk.default).dismissOnboarding)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2K2hA.SpotlightPrimaryAction), {
        onClick: handleTryChat
    }, formatMessage((0, $7s6Nk.default).tryChat)))))));
};
module.exports["ConversationAssistantOnboardingSpotlight"] = $cde915fd77272962$export$e4abc8af2fc5e2ac;

});

parcelRegister("7s6Nk", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $7fbfde14cac529b1$var$_default_1 = (0, $kSwu1.defineMessages)({
    tryChat: {
        id: "rovo-onboarding-try-chat",
        defaultMessage: "Try Max"
    },
    dismissOnboarding: {
        id: "rovo-onboarding-dismiss",
        defaultMessage: "Dismiss"
    },
    onboardingHeading: {
        id: "rovo-onboarding-heading",
        defaultMessage: "Say hi to Max"
    },
    onboardingDescription: {
        id: "rovo-onboarding-description",
        defaultMessage: "Max takes on complex, multi-step work and comes back with a finished result."
    }
});
var $7fbfde14cac529b1$export$2e2bcd8739ae039 = $7fbfde14cac529b1$var$_default_1;
module.exports["default"] = $7fbfde14cac529b1$export$2e2bcd8739ae039;

});

parcelRegister("j0DuU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

class $ef1db4b7df15ed66$export$63986981e4af5143 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error) {
        // Log chunk load failures so they are detectable in production
        // eslint-disable-next-line no-console
        console.error('[ChunkErrorBoundary] Failed to load async component chunk:', error);
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false
        };
    }
}
module.exports["ChunkErrorBoundary"] = $ef1db4b7df15ed66$export$63986981e4af5143;

});

parcelRegister("dY6UE", function(module, exports) {
const $3072ddc93b66c1bf$export$39aecc95f0365819 = ({ condition: condition, wrapper: wrapper, children: children })=>condition ? wrapper(children) : children;
module.exports["ConditionalWrapper"] = $3072ddc93b66c1bf$export$39aecc95f0365819;

});

parcelRegister("c1KVP", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $3de6994784243a7f$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    rovoChatButtonLabel: {
        id: "conversation-assistant-button.ask-rovo-label",
        defaultMessage: "Ask Rovo"
    }
});
module.exports["messages"] = $3de6994784243a7f$export$defe85febe8b728c;

});

parcelRegister("cersU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $3FyXx = parcelRequire("3FyXx");


var $ljOiP = parcelRequire("ljOiP");


var $iwIwp = parcelRequire("iwIwp");


var $eQQUc = parcelRequire("eQQUc");

const $113683d07a1f0e4a$export$dc6224f1e35e5cf8 = ({ api: api, linkPickerOptions: linkPickerOptions, lpLinkPicker: lpLinkPicker, providerFactory: providerFactory, selectedNativeEmbed: selectedNativeEmbed, view: view })=>{
    const currentUrl = (0, $ljOiP.getParameters)(selectedNativeEmbed.node.attrs.parameters, 'url');
    const currentDisplayText = (0, $ljOiP.getParameters)(selectedNativeEmbed.node.attrs.parameters, 'displayText');
    const localId = selectedNativeEmbed.node.attrs.localId;
    const onSubmit = (href, _title, displayText)=>{
        (0, $eQQUc.hideUrlToolbar)(view.state, view.dispatch);
        const urlChanged = href !== currentUrl;
        const displayTextChanged = displayText !== currentDisplayText;
        if (urlChanged) {
            // If the new URL is no longer supported by any native embed experience,
            // convert the native embed extension back to a standard embed card.
            const isNativeEmbedUrl = Boolean((0, $iwIwp.getNativeEmbedFacade)().getManifestByUrl(href));
            if (!isNativeEmbedUrl) {
                (0, $eQQUc.createConvertNativeEmbedToEmbedCardCommand)(href)(view.state, view.dispatch);
                return;
            }
        }
        if ((urlChanged || displayTextChanged) && localId) {
            const extensionApi = api?.extension?.actions?.api();
            if (extensionApi?.doc?.update) extensionApi.doc.update(localId, (current)=>({
                    attrs: {
                        ...current.attrs,
                        parameters: (0, $ljOiP.setParameter)(current.attrs?.parameters, {
                            url: href,
                            displayText: displayText
                        })
                    }
                }));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3FyXx.HyperlinkAddToolbar), {
        view: view,
        providerFactory: providerFactory,
        linkPickerOptions: linkPickerOptions,
        displayUrl: currentUrl,
        displayText: currentDisplayText,
        lpLinkPicker: lpLinkPicker,
        invokeMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
        /* eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed) */ onSubmit: (href, title, displayText)=>onSubmit(href, title, displayText),
        onEscapeCallback: (0, $eQQUc.hideUrlToolbar),
        onClickAwayCallback: (0, $eQQUc.hideUrlToolbar)
    });
};
const $113683d07a1f0e4a$export$13e482484d5c4da9 = (props)=>({
        type: 'custom',
        disableArrowNavigation: true,
        fallback: [],
        render: (view)=>view ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($113683d07a1f0e4a$export$dc6224f1e35e5cf8, {
                api: props.api,
                linkPickerOptions: props.linkPickerOptions,
                lpLinkPicker: props.lpLinkPicker,
                providerFactory: props.providerFactory,
                selectedNativeEmbed: props.selectedNativeEmbed,
                view: view
            }) : null
    });
module.exports["buildNativeEmbedEditUrlToolbar"] = $113683d07a1f0e4a$export$13e482484d5c4da9;

});

parcelRegister("eQQUc", function(module, exports) {

var $ljOiP = parcelRequire("ljOiP");


var $dunxr = parcelRequire("dunxr");

const $62a3743d70492368$export$98ee8d0cf866fa75 = (selectedNode)=>{
    return (0, $ljOiP.getParameters)(selectedNode.attrs.parameters, 'url');
};
const $62a3743d70492368$export$179dd5c00c1b0557 = (selectedNode)=>()=>{
        const url = $62a3743d70492368$export$98ee8d0cf866fa75(selectedNode);
        if (url) window.open(url, '_blank', 'noopener,noreferrer');
        return true;
    };
const $62a3743d70492368$export$fff41c4cbbf6af3e = (selectedNode)=>()=>{
        const url = $62a3743d70492368$export$98ee8d0cf866fa75(selectedNode);
        if (url) navigator.clipboard.writeText(url);
        return true;
    };
const $62a3743d70492368$export$15a48157d97d7f65 = (state, dispatch)=>{
    dispatch?.(state.tr.setMeta((0, $dunxr.pluginKey), {
        type: 'SHOW_URL_TOOLBAR'
    }));
    return true;
};
const $62a3743d70492368$export$61961fed5a5ec57a = (state, dispatch)=>{
    dispatch?.(state.tr.setMeta((0, $dunxr.pluginKey), {
        type: 'HIDE_URL_TOOLBAR'
    }));
    return true;
};
const $62a3743d70492368$export$c5f149c9cc530c8e = (href)=>(state, dispatch)=>{
        const { embedCard: embedCard } = state.schema.nodes;
        if (!embedCard) return false;
        const selectedNode = state.selection.node;
        if (!selectedNode) return false;
        const embedCardNode = embedCard.createChecked({
            url: href,
            layout: 'center'
        });
        const { from: from, to: to } = state.selection;
        const tr = state.tr.replaceWith(from, to, embedCardNode);
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
module.exports["createOpenInNewWindowCommand"] = $62a3743d70492368$export$179dd5c00c1b0557;
module.exports["createCopyLinkCommand"] = $62a3743d70492368$export$fff41c4cbbf6af3e;
module.exports["showUrlToolbar"] = $62a3743d70492368$export$15a48157d97d7f65;
module.exports["hideUrlToolbar"] = $62a3743d70492368$export$61961fed5a5ec57a;
module.exports["createConvertNativeEmbedToEmbedCardCommand"] = $62a3743d70492368$export$c5f149c9cc530c8e;

});

parcelRegister("93v4e", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled

var $lOiVq = parcelRequire("lOiVq");


var $3FYPH = parcelRequire("3FYPH");


var $fHs3z = parcelRequire("fHs3z");


var $lBKFk = parcelRequire("lBKFk");


var $iDfTs = parcelRequire("iDfTs");


var $a79Sy = parcelRequire("a79Sy");


var $kTb7m = parcelRequire("kTb7m");


var $k9wGn = parcelRequire("k9wGn");


var $c0A7H = parcelRequire("c0A7H");


var $74Lcy = parcelRequire("74Lcy");


var $4qo4H = parcelRequire("4qo4H");


var $Hf8AD = parcelRequire("Hf8AD");

function $8956bd0cd4887675$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8956bd0cd4887675$var$toggleButtonStyles = {
    name: "1u30rvm",
    styles: "display:flex;align-items:center;cursor:default;&&{background:none;border:none;padding:0;min-height:unset;}& label{margin:0;}"
};
const $8956bd0cd4887675$var$createHandlerCommand = (handler)=>()=>{
        handler?.();
        return true;
    };
function $8956bd0cd4887675$var$convertCustomActionToDropdownOption(action, parameters, editorToolbarHandlers) {
    const IconComponent = action.icon;
    const handler = editorToolbarHandlers[action.handlerKey];
    return {
        id: `native-embed-${action.key}`,
        title: action.label,
        icon: /*#__PURE__*/ (0, $lOiVq.jsx)(IconComponent, {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        }),
        disabled: action.disabled,
        onClick: $8956bd0cd4887675$var$createHandlerCommand(handler ? ()=>handler(parameters) : undefined)
    };
}
/**
 * Creates a registry of built-in "More Options" dropdown items.
 */ function $8956bd0cd4887675$var$createBuiltinMoreOptionsRegistry(api, selectedNativeEmbed, deleteHoverProps, editorToolbarHandlers, intl) {
    const toggleAlwaysShowTitle = (0, $Hf8AD.createToggleAlwaysShowTitle)(api, selectedNativeEmbed.node);
    return {
        [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE]: {
            id: 'native-embed-always-show-title',
            title: intl.formatMessage((0, $4qo4H.nativeEmbedToolbarMessages).alwaysShowTitle),
            icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a79Sy))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
            elemAfter: /*#__PURE__*/ (0, $lOiVq.jsx)("button", {
                type: "button",
                css: $8956bd0cd4887675$var$toggleButtonStyles,
                onClick: (e)=>{
                    e.stopPropagation();
                    toggleAlwaysShowTitle();
                }
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $c0A7H.default), {
                isChecked: (0, $Hf8AD.getAlwaysShowTitleState)(selectedNativeEmbed.node),
                label: intl.formatMessage((0, $4qo4H.nativeEmbedToolbarMessages).alwaysShowTitle)
            })),
            onClick: editorToolbarHandlers.onShowTitleClick()
        },
        [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SET_EMBED_TYPE]: {
            id: 'native-embed-set-embed-type',
            title: intl.formatMessage((0, $4qo4H.nativeEmbedToolbarMessages).setEmbedType),
            icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
            onClick: editorToolbarHandlers.onSetEmbedTypeClick()
        },
        [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY]: {
            id: 'native-embed-copy',
            title: intl.formatMessage((0, $74Lcy.nativeEmbedBlockMenuMessages).copy),
            icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
            onClick: editorToolbarHandlers.onCopyClick()
        },
        /**
     * @private
     * @deprecated Use COPY instead. Will be removed in a follow-up PR.
     */ [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY_LINK]: {
            id: 'native-embed-copy-link',
            title: intl.formatMessage((0, $3FYPH.messages).copyLink),
            icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
            onClick: editorToolbarHandlers.onCopyLinkClick()
        },
        [(0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE]: {
            id: 'native-embed-delete',
            title: intl.formatMessage((0, $3FYPH.messages).deleteBlock),
            icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
            onClick: editorToolbarHandlers.onDeleteClick(),
            ...deleteHoverProps
        }
    };
}
const $8956bd0cd4887675$var$DEFAULT_MORE_OPTIONS = [
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SET_EMBED_TYPE,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
];
function $8956bd0cd4887675$var$resolveMoreOptions(items, builtinRegistry, customActions, parameters, editorToolbarHandlers) {
    const options = [];
    for (const key of items){
        if (key === (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR) options.push({
            type: 'separator'
        });
        else if (key in builtinRegistry) options.push(builtinRegistry[key]);
        else if (customActions && key in customActions) options.push($8956bd0cd4887675$var$convertCustomActionToDropdownOption(customActions[key], parameters, editorToolbarHandlers));
    }
    return options;
}
const $8956bd0cd4887675$export$6030df2c7cd7819c = (api, selectedNativeEmbed, deleteHoverProps, editorToolbarHandlers, parameters, intl, moreItems, customActions)=>{
    const builtinRegistry = $8956bd0cd4887675$var$createBuiltinMoreOptionsRegistry(api, selectedNativeEmbed, deleteHoverProps, editorToolbarHandlers, intl);
    const items = moreItems ?? $8956bd0cd4887675$var$DEFAULT_MORE_OPTIONS;
    const options = $8956bd0cd4887675$var$resolveMoreOptions(items, builtinRegistry, customActions, parameters, editorToolbarHandlers);
    return {
        id: 'native-embed-more-options-button',
        testId: 'native-embed-more-options-button',
        type: 'overflow-dropdown',
        dropdownWidth: 250,
        options: options
    };
};
module.exports["getMoreOptionsDropdown"] = $8956bd0cd4887675$export$6030df2c7cd7819c;

});

parcelRegister("Hf8AD", function(module, exports) {

var $ljOiP = parcelRequire("ljOiP");

const $d2f33fb2ab6a837a$export$3b3f7272b13b81ea = (selectedNode)=>{
    return (0, $ljOiP.getParameters)(selectedNode.attrs.parameters, 'alwaysShowTitle');
};
const $d2f33fb2ab6a837a$export$9f930146f49815d = (api, selectedNode)=>()=>{
        const localId = selectedNode.attrs.localId;
        if (!localId) return;
        const extensionApi = api?.extension?.actions?.api();
        if (!extensionApi?.doc?.update) return;
        const current = $d2f33fb2ab6a837a$export$3b3f7272b13b81ea(selectedNode);
        extensionApi.doc.update(localId, (node)=>({
                attrs: {
                    ...node.attrs,
                    parameters: (0, $ljOiP.setParameter)(node.attrs?.parameters, {
                        alwaysShowTitle: !current
                    })
                }
            }), {
            scrollIntoView: false
        });
    };
module.exports["getAlwaysShowTitleState"] = $d2f33fb2ab6a837a$export$3b3f7272b13b81ea;
module.exports["createToggleAlwaysShowTitle"] = $d2f33fb2ab6a837a$export$9f930146f49815d;

});

parcelRegister("4LsAR", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $ixa4K = parcelRequire("ixa4K");


var $feeMI = parcelRequire("feeMI");


var $7XIuB = parcelRequire("7XIuB");


var $3aDYK = parcelRequire("3aDYK");

var $8VCvx = parcelRequire("8VCvx");

var $7xQNd = parcelRequire("7xQNd");


var $g9ric = parcelRequire("g9ric");

var $9RT19 = parcelRequire("9RT19");

var $gLi18 = parcelRequire("gLi18");

var $ldbHR = parcelRequire("ldbHR");


var $czp8P = parcelRequire("czp8P");


var $lRXxm = parcelRequire("lRXxm");


var $7sJoX = parcelRequire("7sJoX");


var $fxA94 = parcelRequire("fxA94");


var $fRmp0 = parcelRequire("fRmp0");


var $jdueN = parcelRequire("jdueN");


var $4aRua = parcelRequire("4aRua");


var $lpNn5 = parcelRequire("lpNn5");

// packages/editor/editor-core/src/plugins/floating-toolbar/ui/DropdownMenu.tsx
const $5737ffde100b61ed$var$menuItemDimensions = {
    width: 175,
    height: 32
};
const $5737ffde100b61ed$var$itemSpacing = 4; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @compiled/no-exported-css -- Ignored via go/DSP-18766
const $5737ffde100b61ed$var$contextualMenuArrow = null; // top is set via inline style per usage (dynamic index not extractable by @compiled)
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @compiled/no-exported-css, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
const $5737ffde100b61ed$var$contextualSubMenuBase = null; // Pre-computed top offsets for submenu indices 0 and 1
const $5737ffde100b61ed$var$contextualSubMenuTop0 = 0;
const $5737ffde100b61ed$var$contextualSubMenuTop1 = $5737ffde100b61ed$var$menuItemDimensions.height + $5737ffde100b61ed$var$itemSpacing * 2; // backgroundColor is set via inline style (selected state not extractable by @compiled)
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @compiled/no-exported-css, @atlaskit/design-system/use-tokens-shape -- Ignored via go/DSP-18766
const $5737ffde100b61ed$var$buttonStyleBase = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @compiled/no-exported-css, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
const $5737ffde100b61ed$var$buttonWrapperStyle = null; // Static base — enabled/isOpen hover states applied via separate conditional css objects
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @compiled/no-exported-css, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
const $5737ffde100b61ed$var$toolbarButtonWrapperBase = null; // Applied when !enabled: show hover highlight on the main button
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @compiled/no-exported-css, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
const $5737ffde100b61ed$var$toolbarButtonWrapperHoverBtn = null; // Applied when !isOpen && !enabled: show hover highlight on the dropdown button
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @compiled/no-exported-css, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
const $5737ffde100b61ed$var$toolbarButtonWrapperHoverDropdown = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @compiled/no-exported-css, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
const $5737ffde100b61ed$var$dropdownOptionButton = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @compiled/no-exported-css, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
const $5737ffde100b61ed$var$dropdownWrapper = null;
const $5737ffde100b61ed$var$NativeEmbedBorder = ({ intl: { formatMessage: formatMessage }, borderColor: borderColor, borderSize: borderSize, toggleBorder: toggleBorder, setBorderColor: setBorderColor, setBorderSize: setBorderSize })=>{
    const popupTarget = (0, $cozmU.useRef)(null);
    const dropDownColorOptionButton = (0, $cozmU.useRef)(null);
    const dropDownSizeOptionButton = (0, $cozmU.useRef)(null);
    const colorSubmenuRef = (0, $cozmU.useRef)(null);
    const sizeSubmenuRef = (0, $cozmU.useRef)(null);
    const openDropdownButtonRef = (0, $cozmU.useRef)(null);
    const enabled = !!borderColor;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [isOpenByKeyboard, setIsOpenedByKeyboard] = (0, $cozmU.useState)(false);
    const [isColorSubmenuOpen, setIsColorSubmenuOpen] = (0, $cozmU.useState)(false);
    const [isSizeSubmenuOpen, setIsSizeSubmenuOpen] = (0, $cozmU.useState)(false);
    const handleColorSubmenuEsc = (0, $cozmU.useCallback)(()=>{
        setIsOpenedByKeyboard(false);
        setIsColorSubmenuOpen(false);
        dropDownColorOptionButton?.current?.focus();
    }, []);
    const handleSizeSubmenuEsc = (0, $cozmU.useCallback)(()=>{
        setIsOpenedByKeyboard(false);
        setIsSizeSubmenuOpen(false);
        dropDownSizeOptionButton?.current?.focus();
    }, []);
    const handleSubMenuRef = (ref)=>{
        if (!ref) return;
        const rect = ref.getBoundingClientRect();
        if (rect.left + rect.width > window.innerWidth) ref.style.left = `-${rect.width}px`;
    };
    const handleTriggerByKeyboard = (event, allowedKeys, callback)=>{
        if (!allowedKeys.includes(event.key)) return;
        event.preventDefault();
        callback();
        setIsOpenedByKeyboard(true);
    };
    const handleTriggerToolbarByKeyboard = (event, callback)=>{
        handleTriggerByKeyboard(event, [
            'Enter',
            ' '
        ], callback);
    };
    const handleTriggerSubmenuByKeyboard = (event, callback)=>{
        handleTriggerByKeyboard(event, [
            'Enter',
            'ArrowRight'
        ], callback);
    };
    (0, $cozmU.useEffect)(()=>{
        const focusFirstOption = (submenuRef, isOpen)=>{
            if (!isOpenByKeyboard) return;
            if (isOpen && submenuRef.current) {
                const firstOption = submenuRef.current.querySelector('button');
                if (!firstOption) return;
                firstOption.focus();
                const keyboardEvent = new KeyboardEvent('keydown', {
                    key: 'ArrowDown',
                    bubbles: true
                });
                firstOption.dispatchEvent(keyboardEvent);
            }
        };
        focusFirstOption(colorSubmenuRef, isColorSubmenuOpen);
        focusFirstOption(sizeSubmenuRef, isSizeSubmenuOpen);
    }, [
        isColorSubmenuOpen,
        isSizeSubmenuOpen,
        isOpenByKeyboard
    ]);
    const borderSizeOptions = [
        {
            name: formatMessage((0, $ixa4K.imageBorderMessages).borderSizeSubtle),
            value: 1,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jdueN)))
        },
        {
            name: formatMessage((0, $ixa4K.imageBorderMessages).borderSizeMedium),
            value: 2,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fRmp0)))
        },
        {
            name: formatMessage((0, $ixa4K.imageBorderMessages).borderSizeBold),
            value: 3,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($fxA94)))
        }
    ];
    const items = [
        {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
                ref: dropDownColorOptionButton,
                type: "button",
                "aria-label": formatMessage((0, $ixa4K.imageBorderMessages).borderColorDropdownAriaLabel),
                "data-testid": "native-embed-border-dropdown-button-color",
                "aria-expanded": isColorSubmenuOpen,
                onKeyDown: (e)=>handleTriggerSubmenuByKeyboard(e, ()=>{
                        setIsColorSubmenuOpen((prev)=>{
                            const next = !prev;
                            if (next) setIsSizeSubmenuOpen(false);
                            return next;
                        });
                    }),
                className: (0, $hekY6.default)([
                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _189e1dm9 _1dqonqa1 _1h6d1j28 _bfhk1j28 _1e0c1txw _1bsb1osq _4cvr1h6o _1bah1yb4 _858u1v1w _jomr1dpa"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, formatMessage((0, $ixa4K.imageBorderMessages).borderColor)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: (0, $hekY6.default)([
                    "_1e0c1txw _aetr16l8 _pfzt1b66 _14rn1q3r"
                ])
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            , {
                className: (0, $feeMI.DropdownMenuSharedCssClassName).SUBMENU,
                ref: colorSubmenuRef
            }, isColorSubmenuOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic top offset required
            , {
                style: {
                    top: `${$5737ffde100b61ed$var$contextualSubMenuTop0}px`
                },
                ref: handleSubMenuRef,
                className: (0, $hekY6.default)([
                    "_2rkofajl _bfhk1bhr _16qs130s _1e0c1txw _kqswstnw _1ltvjidk _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _ogwtidpf _6tinidpf _1cezidpf _m3zkidpf"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g9ric.ArrowKeyNavigationProvider), {
                type: (0, $9RT19.ArrowKeyNavigationType).MENU,
                handleClose: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    handleColorSubmenuEsc();
                },
                disableCloseOnArrowClick: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7xQNd.default // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            ), {
                onClick: (color)=>{
                    setBorderColor(color);
                    setIsOpen(false);
                },
                onKeyDown: (color, _, event)=>{
                    if (event.key === 'Enter' || event.key === ' ') {
                        setBorderColor(color);
                        setIsOpen(false);
                        setIsColorSubmenuOpen(false);
                        setIsSizeSubmenuOpen(false);
                        openDropdownButtonRef.current?.focus();
                    }
                },
                selectedColor: borderColor ?? null,
                paletteOptions: {
                    palette: (0, $3aDYK.default),
                    paletteColorTooltipMessages: (0, $8VCvx.borderPaletteTooltipMessages),
                    hexToPaletteColor: (0, $czp8P.hexToEditorBorderPaletteColor)
                }
            }))))),
            'data-testid': 'dropdown-item__Color',
            key: 'dropdown-menu-native-embed-border-color-button',
            value: {
                name: 'color'
            },
            'aria-label': '',
            wrapperTabIndex: null
        },
        {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
                type: "button",
                "aria-label": formatMessage((0, $ixa4K.imageBorderMessages).borderSizeDropdownAriaLabel),
                "data-testid": "native-embed-border-dropdown-button-size",
                /* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ "aria-expanded": isSizeSubmenuOpen,
                ref: dropDownSizeOptionButton,
                onKeyDown: (e)=>handleTriggerSubmenuByKeyboard(e, ()=>{
                        setIsSizeSubmenuOpen((prev)=>{
                            const next = !prev;
                            if (next) setIsColorSubmenuOpen(false);
                            return next;
                        });
                    }),
                className: (0, $hekY6.default)([
                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _189e1dm9 _1dqonqa1 _1h6d1j28 _bfhk1j28 _1e0c1txw _1bsb1osq _4cvr1h6o _1bah1yb4 _858u1v1w _jomr1dpa"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, formatMessage((0, $ixa4K.imageBorderMessages).borderSize)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: (0, $hekY6.default)([
                    "_1e0c1txw _aetr16l8 _pfzt1b66 _14rn1q3r"
                ])
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            , {
                className: (0, $feeMI.DropdownMenuSharedCssClassName).SUBMENU,
                ref: sizeSubmenuRef
            }, isSizeSubmenuOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g9ric.ArrowKeyNavigationProvider), {
                type: (0, $9RT19.ArrowKeyNavigationType).MENU,
                handleClose: (e)=>{
                    e.preventDefault();
                    handleSizeSubmenuEsc();
                },
                disableCloseOnArrowClick: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic top offset required
            , {
                style: {
                    top: `${$5737ffde100b61ed$var$contextualSubMenuTop1}px`
                },
                ref: handleSubMenuRef,
                className: (0, $hekY6.default)([
                    "_2rkofajl _bfhk1bhr _16qs130s _1e0c1txw _kqswstnw _1ltvjidk _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _ogwtidpf _6tinidpf _1cezidpf _m3zkidpf"
                ])
            }, borderSizeOptions.map(({ name: name, value: value, icon: icon }, idx)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const ButtonIcon = icon;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                    key: value,
                    content: name
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                    className: (0, $hekY6.default)([
                        "_1reo15vq _18m915vq _2rko1qi0 _1h6d1j28 _1dqonqa1 _189ee4h9 _19pkv77o _2hwx12x7 _otyrv77o _18u0v77o _1e0c1txw _4cvr1h6o _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _858u1l7x _jyzf1l7x _4cvx1l7x"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
                    type: "button",
                    style: {
                        backgroundColor: value === borderSize ? "var(--ds-text, #292A2E)" : "var(--ds-background-neutral, #0515240F)"
                    },
                    "aria-label": name,
                    role: "radio",
                    "aria-checked": value === borderSize,
                    onClick: ()=>{
                        setBorderSize(value);
                        setIsOpen(false);
                    },
                    onKeyDown: (event)=>{
                        if (event.key === 'Enter' || event.key === ' ') {
                            setBorderSize(value);
                            setIsOpen(false);
                            setIsColorSubmenuOpen(false);
                            setIsSizeSubmenuOpen(false);
                            openDropdownButtonRef.current?.focus();
                        }
                    },
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    },
                    className: (0, $hekY6.default)([
                        "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2rko12b0 _19itj0fz _4t3i1ou6 _1bsb1ou6 _80omtlke _1e0c1ule"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ButtonIcon, {
                    color: value === borderSize ? "var(--ds-icon-inverse, #FFFFFF)" : 'currentColor',
                    spacing: "spacious",
                    label: ""
                }))));
            }))))),
            'data-testid': 'dropdown-item__Size',
            key: 'dropdown-menu-native-embed-border-size-button',
            value: {
                name: 'size'
            },
            'aria-label': '',
            wrapperTabIndex: null
        }
    ];
    const fitTolerance = 10;
    const fitWidth = $5737ffde100b61ed$var$menuItemDimensions.width;
    const fitHeight = items.length * ($5737ffde100b61ed$var$menuItemDimensions.height + $5737ffde100b61ed$var$itemSpacing);
    const isAnySubMenuOpen = isSizeSubmenuOpen || isColorSubmenuOpen;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1e0c1txw _1npxidpf _1en3idpf _85sridpf _108kidpf _18cwglyw _11keidpf _yus9idpf _15t6idpf _1raxidpf _sji5idpf _1jaiidpf _1r43idpf _62w1idpf _jyazidpf _fgvyidpf _1opdglyw _1s79idpf _1s4iidpf _14fnidpf _1lduidpf _o7vh1gpt _41lrgrf3 _13jtgrf3 _4q2mv77o",
            !enabled && "_1r351dpa",
            !isOpen && !enabled && "_1fzm1dpa"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldbHR.default // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- className required to target CSS selectors in toolbarButtonWrapper
    ), {
        className: "native-embed-border-toolbar-btn",
        selected: enabled,
        onClick: toggleBorder,
        spacing: "compact",
        "aria-label": enabled ? formatMessage((0, $ixa4K.imageBorderMessages).removeBorder) : formatMessage((0, $ixa4K.imageBorderMessages).addBorder),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lRXxm))), {
            color: "currentColor",
            label: "",
            spacing: "spacious"
        }),
        title: enabled ? formatMessage((0, $ixa4K.imageBorderMessages).removeBorder) : formatMessage((0, $ixa4K.imageBorderMessages).addBorder)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: popupTarget
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldbHR.default // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- className required to target CSS selectors in toolbarButtonWrapper
    ), {
        className: "native-embed-border-toolbar-dropdown",
        ref: openDropdownButtonRef,
        selected: enabled || isOpen,
        "aria-expanded": isOpen,
        "aria-label": formatMessage((0, $ixa4K.imageBorderMessages).borderOptions),
        title: formatMessage((0, $ixa4K.imageBorderMessages).borderOptions),
        spacing: "compact",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            color: "currentColor",
            spacing: "spacious",
            label: "",
            size: "small"
        }),
        onClick: ()=>{
            setIsOpen(!isOpen);
            setIsOpenedByKeyboard(false);
        },
        onKeyDown: (e)=>handleTriggerToolbarByKeyboard(e, ()=>setIsOpen(!isOpen))
    }))), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7XIuB.default), {
        target: popupTarget.current ? popupTarget.current : undefined,
        fitWidth: fitWidth + fitTolerance,
        fitHeight: fitHeight + fitTolerance,
        forcePlacement: true,
        stick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        onMouseLeave: ()=>{
            setIsColorSubmenuOpen(false);
            setIsSizeSubmenuOpen(false);
        },
        onBlur: ()=>{
            setIsColorSubmenuOpen(false);
            setIsSizeSubmenuOpen(false);
        },
        className: (0, $hekY6.default)([
            "_1wyfidpf _gt4gidpf _15s6idpf _1ikmidpf"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gLi18.default // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
    ), {
        arrowKeyNavigationProviderOptions: {
            type: (0, $9RT19.ArrowKeyNavigationType).MENU,
            disableArrowKeyNavigation: isAnySubMenuOpen
        },
        allowEnterDefaultBehavior: isAnySubMenuOpen,
        handleEscapeKeydown: isAnySubMenuOpen ? ()=>{
            return;
        } : ()=>{
            openDropdownButtonRef.current?.focus();
        },
        items: [
            {
                items: items
            }
        ],
        isOpen: isOpen,
        shouldFocusFirstItem: ()=>isOpenByKeyboard,
        onOpenChange: ()=>{
            setIsOpen(false);
            setIsColorSubmenuOpen(false);
            setIsSizeSubmenuOpen(false);
            setIsOpenedByKeyboard(false);
        },
        onItemActivated: ({ item: item })=>{
            if (item.value.name === 'color') setIsColorSubmenuOpen((prev)=>{
                const next = !prev;
                if (next) setIsSizeSubmenuOpen(false);
                return next;
            });
            if (item.value.name === 'size') setIsSizeSubmenuOpen((prev)=>{
                const next = !prev;
                if (next) setIsColorSubmenuOpen(false);
                return next;
            });
        },
        onMouseEnter: ({ item: item })=>{
            if (item.value.name === 'color') {
                setIsColorSubmenuOpen(true);
                setIsOpenedByKeyboard(false);
            }
            if (item.value.name === 'size') {
                setIsSizeSubmenuOpen(true);
                setIsOpenedByKeyboard(false);
            }
        },
        onMouseLeave: ({ item: item })=>{
            if (item.value.name === 'color') setIsColorSubmenuOpen(false);
            if (item.value.name === 'size') setIsSizeSubmenuOpen(false);
        },
        fitWidth: fitWidth + fitTolerance,
        fitHeight: fitHeight + fitTolerance
    }))));
};
var $5737ffde100b61ed$export$2e2bcd8739ae039 = $5737ffde100b61ed$var$NativeEmbedBorder;
module.exports["default"] = $5737ffde100b61ed$export$2e2bcd8739ae039;

});

parcelRegister("kkW8v", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $2sp5n = parcelRequire("2sp5n");


var $bjg0G = parcelRequire("bjg0G");


var $k9wGn = parcelRequire("k9wGn");


var $ixfCV = parcelRequire("ixfCV");


var $ieeJu = parcelRequire("ieeJu");


var $eQQUc = parcelRequire("eQQUc");

var $6yVl9 = parcelRequire("6yVl9");

var $Hf8AD = parcelRequire("Hf8AD");

var $1WSjf = parcelRequire("1WSjf");


var $4JdkX = parcelRequire("4JdkX");




const $9f384a008ac93b94$var$createHandlerCommand = (handler)=>()=>{
        handler?.();
        return true;
    };
function $9f384a008ac93b94$var$wrapManifestHandler(handler, parameters, handlerContext) {
    return ()=>$9f384a008ac93b94$var$createHandlerCommand(()=>handler(parameters, handlerContext));
}
function $9f384a008ac93b94$var$wrapManifestHandlerWithContext(handler, parameters, handlerContext) {
    return (context)=>$9f384a008ac93b94$var$createHandlerCommand(()=>handler(parameters, context, handlerContext));
}
/**
 * Creates a Command that copies the native-embed node to the clipboard.
 * Delegates to the floating-toolbar plugin's `copyNode` command when available,
 * falling back to `createCopyLinkCommand` (copies URL string) when the
 * floating-toolbar plugin is not present.
 */ /**
 * Extracts the hostname from a URL string for use as a fallback display name
 * in the Rovo chat context banner.
 */ function $9f384a008ac93b94$var$getHostnameFromUrl(url) {
    try {
        return new URL(url).hostname;
    } catch  {
        return '';
    }
}
function $9f384a008ac93b94$var$isMauiNativeEmbed(extensionKey) {
    return extensionKey === `${0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY}:maui`;
}
function $9f384a008ac93b94$var$createCopyNodeCommand(selectedNativeEmbed, api) {
    const copyNodeCommand = api?.floatingToolbar?.commands?.copyNode(selectedNativeEmbed.node.type, (0, $krYZG.INPUT_METHOD).FLOATING_TB);
    if (copyNodeCommand) return ()=>{
        api?.core?.actions.execute(copyNodeCommand);
        return true;
    };
    // Fallback: copy the URL string when floating-toolbar plugin is unavailable
    return (0, $eQQUc.createCopyLinkCommand)(selectedNativeEmbed.node);
}
function $9f384a008ac93b94$export$f4fb53cb783b2797(selectedNativeEmbed, api, intl, schema, parameters) {
    const node = selectedNativeEmbed.node;
    const isInViewMode = api?.editorViewMode?.sharedState.currentState()?.mode === 'view';
    const askRovoTarget = !isInViewMode && $9f384a008ac93b94$var$isMauiNativeEmbed(node.attrs?.extensionKey) && (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true) ? 'remix-app' : 'default';
    const embedUrl = parameters.url ?? '';
    const embedName = $9f384a008ac93b94$var$getHostnameFromUrl(embedUrl);
    const askRovoButton = api?.aiExperience?.actions?.getAskRovoFloatingToolbarButton?.({
        intl: intl,
        triggeredFor: schema.nodes.extension,
        target: askRovoTarget,
        openInRovoChat: true,
        rovoChatAIFeatureContext: embedName ? {
            projectContext: {
                projectId: embedUrl,
                projectName: embedName,
                projectUrl: embedUrl
            }
        } : undefined
    });
    const summariseButton = parameters.url ? api?.aiExperience?.actions?.getSummariseSmartlinkFloatingToolbarButton?.({
        intl: intl,
        smartlinkUrl: parameters.url,
        triggeredFor: schema.nodes.extension
    }) : undefined;
    return {
        onAppearanceClick: (appearance)=>(0, $4JdkX.setNativeEmbedAppearance)(selectedNativeEmbed, appearance, api?.analytics?.actions),
        onAlignmentClick: (alignment)=>(0, $1WSjf.createUpdateAlignmentCommand)(api, alignment, node),
        onCopyClick: ()=>$9f384a008ac93b94$var$createCopyNodeCommand(selectedNativeEmbed, api),
        onCopyLinkClick: ()=>(0, $eQQUc.createCopyLinkCommand)(node),
        onDeleteClick: ()=>(0, $6yVl9.createDeleteCommand)(selectedNativeEmbed),
        onShowTitleClick: ()=>$9f384a008ac93b94$var$createHandlerCommand((0, $Hf8AD.createToggleAlwaysShowTitle)(api, node)),
        onExpandClick: ()=>(_state, _dispatch, view)=>{
                if (view) try {
                    const domRef = (0, $bjg0G.findDomRefAtPos)(selectedNativeEmbed.pos, view.domAtPos.bind(view));
                    if (domRef instanceof HTMLElement) {
                        const extensionContainer = domRef.classList.contains('extension-container') ? domRef : domRef.querySelector('.extension-container') ?? domRef;
                        extensionContainer.dispatchEvent(new CustomEvent('native-embed-open-fullscreen', {
                            bubbles: true
                        }));
                    }
                } catch  {
                // ignore
                }
                return true;
            },
        onOpenInNewWindowClick: ()=>(0, $eQQUc.createOpenInNewWindowCommand)(node),
        onEditUrlClick: ()=>(0, $eQQUc.showUrlToolbar),
        onEditClick: ()=>(0, $eQQUc.showUrlToolbar),
        askRovoButton: askRovoButton,
        onAskRovoClick: askRovoButton ? ()=>askRovoButton.onClick : undefined,
        getRemixButton: (0, $ixfCV.fg)('maui_remixable_page_native_embeds') ? api?.malleableUi?.actions?.getRemixFloatingToolbarButton : undefined,
        getRemixVariantButton: api?.malleableUi?.actions?.getRemixVariantFloatingToolbarButton,
        onSummariseClick: ()=>summariseButton?.onClick ?? $9f384a008ac93b94$var$createHandlerCommand(()=>{}),
        onRefreshClick: ()=>$9f384a008ac93b94$var$createHandlerCommand(()=>{}),
        onChangeBorderClick: ()=>$9f384a008ac93b94$var$createHandlerCommand(()=>{}),
        onSetEmbedTypeClick: ()=>$9f384a008ac93b94$var$createHandlerCommand(()=>{})
    };
}
function $9f384a008ac93b94$export$dfa1706461ea0aa3(selectedNativeEmbed, manifestHandlers, api, parameters, intl, schema) {
    const defaultHandlers = $9f384a008ac93b94$export$f4fb53cb783b2797(selectedNativeEmbed, api, intl, schema, parameters);
    const result = {
        ...defaultHandlers
    };
    const selectedNodeLocalId = typeof selectedNativeEmbed.node.attrs?.localId === 'string' ? selectedNativeEmbed.node.attrs.localId : undefined;
    const handlerContext = {
        editorApi: api,
        selectedNodeLocalId: selectedNodeLocalId
    };
    for (const key of (0, $k9wGn.EDITOR_TOOLBAR_HANDLER_KEYS)){
        const manifestHandler = manifestHandlers?.[key];
        if (!manifestHandler) continue;
        switch(key){
            case 'onAlignmentClick':
                result.onAlignmentClick = $9f384a008ac93b94$var$wrapManifestHandlerWithContext(manifestHandler, parameters, handlerContext);
                break;
            case 'onAppearanceClick':
                result.onAppearanceClick = $9f384a008ac93b94$var$wrapManifestHandlerWithContext(manifestHandler, parameters, handlerContext);
                break;
            case 'onAskRovoClick':
                if ((0, $ixfCV.fg)('platform_editor_maui_jira_updates')) result[key] = result[key] !== undefined ? $9f384a008ac93b94$var$wrapManifestHandler(manifestHandler, parameters, handlerContext) : undefined;
                else result[key] = $9f384a008ac93b94$var$wrapManifestHandler(manifestHandler, parameters, handlerContext);
                break;
            default:
                result[key] = $9f384a008ac93b94$var$wrapManifestHandler(manifestHandler, parameters, handlerContext);
        }
    }
    return result;
}
module.exports["buildToolbarHandlers"] = $9f384a008ac93b94$export$dfa1706461ea0aa3;

});

parcelRegister("4JdkX", function(module, exports) {

var $9p0BY = parcelRequire("9p0BY");


var $krYZG = parcelRequire("krYZG");


var $ljOiP = parcelRequire("ljOiP");

function $27b07c57841355c7$var$buildUrlReplacement(schema, url) {
    const { link: link } = schema.marks;
    if (!link) return null;
    const linkContent = schema.text(url, [
        link.create({
            href: url
        })
    ]);
    return schema.nodes.paragraph.create(null, linkContent);
}
function $27b07c57841355c7$var$buildCardReplacement(schema, appearance, url) {
    const cardType = appearance === 'inline' ? schema.nodes.inlineCard : schema.nodes.blockCard;
    if (!cardType) return null;
    const cardNode = cardType.create({
        url: url
    });
    return appearance === 'inline' ? schema.nodes.paragraph.create(null, cardNode) : cardNode;
}
const $27b07c57841355c7$export$22fb0ae5e9d8c713 = (selected, appearance, editorAnalyticsApi)=>(state, dispatch)=>{
        if (appearance === 'embed') return false;
        const { pos: pos, node: node } = selected;
        const { schema: schema } = state;
        const url = (0, $ljOiP.getParameter)(node.attrs.parameters, 'url');
        let content = null;
        if (url && (0, $9p0BY.isSafeUrl)(url)) {
            if (appearance === 'url') content = $27b07c57841355c7$var$buildUrlReplacement(schema, url);
            else if (appearance === 'inline' || appearance === 'block') content = $27b07c57841355c7$var$buildCardReplacement(schema, appearance, url);
        }
        if (content && dispatch) {
            const tr = state.tr.replaceWith(pos, pos + node.nodeSize, content).scrollIntoView();
            editorAnalyticsApi?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).CHANGED_TYPE,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).NATIVE_EMBED,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    newType: appearance,
                    previousType: 'nativeEmbed'
                }
            })(tr);
            dispatch(tr);
        }
        return true;
    };
module.exports["setNativeEmbedAppearance"] = $27b07c57841355c7$export$22fb0ae5e9d8c713;

});

parcelRegister("bqezu", function(module, exports) {

var $2sp5n = parcelRequire("2sp5n");


var $iwIwp = parcelRequire("iwIwp");

/**
 * We are limiting context extraction to this temporary allow list of content types at this stage
 * of the object level remix feature development (object level remix is currently only enabled for pages)
 */ const $687681592c67e711$var$NATIVE_EMBED_CONTENT_TYPE_ALLOW_LIST = [
    'page'
];
const $687681592c67e711$export$1e215007d7182b46 = (node)=>{
    if (node.type !== 'extension') return null;
    const pmNode = node;
    if (!pmNode.attrs) return null;
    const localId = pmNode.attrs?.localId;
    if (!localId) return null;
    const extensionKey = pmNode.attrs.extensionKey;
    if (!extensionKey || !extensionKey.startsWith((0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY))) /** return null if not a native embed */ return null;
    const contentType = extensionKey.split(':')[1];
    if (!$687681592c67e711$var$NATIVE_EMBED_CONTENT_TYPE_ALLOW_LIST.includes(contentType)) /** return null if the content type is not in the allow list */ return null;
    const readContentCommandResult = (0, $iwIwp.getNativeEmbedFacade)().sendReadContent(localId);
    return {
        type: 'nativeContentContext',
        contentType: contentType,
        contentResult: readContentCommandResult
    };
};
module.exports["nativeEmbedContextExtractor"] = $687681592c67e711$export$1e215007d7182b46;

});

parcelRegister("hzdYl", function(module, exports) {
/* ResizableNativeEmbed.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $3k5Tv = parcelRequire("3k5Tv");


var $cXtTj = parcelRequire("cXtTj");


var $ixfCV = parcelRequire("ixfCV");


var $eEoNC = parcelRequire("eEoNC");

const $c34208975346e1fb$export$fe623d3106c02058 = 'nativeEmbed.resizerNext.testid';
const $c34208975346e1fb$var$HIDE_NATIVE_EMBED_RESIZE_CONTROLS_CONFIG = 'platform_native_embeds_hide_resize_controls';
const $c34208975346e1fb$export$e13db278c164b556 = (props)=>{
    const editorViewMode = (0, $3k5Tv.useSharedPluginStateWithSelector)(props.pluginInjectionApi, [
        'editorViewMode'
    ], (states)=>states.editorViewModeState?.mode);
    const shouldHideResizeControls = (0, $cXtTj.default).getExperimentValue($c34208975346e1fb$var$HIDE_NATIVE_EMBED_RESIZE_CONTROLS_CONFIG, 'value', false);
    if ((0, $ixfCV.fg)('cc-native-embed-resize-refactor')) return null;
    if (shouldHideResizeControls && (props.disabled || editorViewMode === 'view')) return null;
     // eslint-disable-next-line react/jsx-props-no-spreading -- thin FG-switch wrapper
    return /*#__PURE__*/ $cozmU.createElement((0, $eEoNC.ResizableNativeEmbedCoordinator), props);
};
module.exports["ResizableNativeEmbed"] = $c34208975346e1fb$export$e13db278c164b556;

});

parcelRegister("eEoNC", function(module, exports) {
/* ResizableNativeEmbedCoordinator.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlassian/perf-linting/no-chain-state-updates -- the coordinator deliberately
 * groups multiple state slices behind subscription callbacks; the lint rule's static
 * analysis can't tell that branches like `setSelectedTarget(null)` in different effect
 * paths aren't actually chained, only conditionally exclusive.
 */ 
var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $bjg0G = parcelRequire("bjg0G");


var $7Y8M5 = parcelRequire("7Y8M5");


var $1WSjf = parcelRequire("1WSjf");


var $dunxr = parcelRequire("dunxr");


var $kUhHF = parcelRequire("kUhHF");


var $bTjR8 = parcelRequire("bTjR8");

const $371da16a9a10889f$export$5d91af3986d5a280 = (props)=>{
    const { pluginInjectionApi: pluginInjectionApi, disabled: disabled, editorView: view, appearance: appearance } = props;
    const initialWidthState = pluginInjectionApi?.width.sharedState.currentState(); // State for width plugin subscription. We intentionally store both lineLength
    // and width in a single object so that updates from the width subscription
    // are applied atomically (avoids the no-chain-state-updates rule).
    const [widthState, setWidthState] = (0, $cozmU.useState)(()=>({
            lineLength: initialWidthState?.lineLength || (0, $7Y8M5.akEditorDefaultLayoutWidth),
            containerWidth: initialWidthState?.width || (0, $7Y8M5.akEditorDefaultLayoutWidth)
        }));
    const { lineLength: lineLength, containerWidth: containerWidth } = widthState;
    (0, $cozmU.useEffect)(()=>{
        const unsubscribe = pluginInjectionApi?.width.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            if (nextSharedState) setWidthState({
                lineLength: nextSharedState.lineLength || (0, $7Y8M5.akEditorDefaultLayoutWidth),
                containerWidth: nextSharedState.width || (0, $7Y8M5.akEditorDefaultLayoutWidth)
            });
        });
        return ()=>{
            unsubscribe?.();
        };
    }, [
        pluginInjectionApi
    ]);
    const [selectionState, setSelectionState] = (0, $cozmU.useState)(()=>{
        const initial = pluginInjectionApi?.editorPluginNativeEmbeds?.sharedState?.currentState();
        return {
            selectedEmbed: initial?.selectedEmbed ?? null,
            trackedEmbedPos: null,
            hoveredEmbedPos: null,
            currentAlignment: initial?.selectedEmbed?.alignment ?? 'center'
        };
    });
    const { selectedEmbed: selectedEmbed, trackedEmbedPos: trackedEmbedPos, hoveredEmbedPos: hoveredEmbedPos, currentAlignment: currentAlignment } = selectionState; // Coordinator-wide single source of truth for "which embed is currently
    // being resized" (by localId). At most one overlay can own a resize at a
    // time; second-start attempts are rejected. Stored in a ref so hover and
    // shared-state callbacks can read it synchronously without re-render.
    const resizingLocalIdRef = (0, $cozmU.useRef)(null); // Tracks the last `pos` we dispatched in a SET_HOVERED_EMBED_POS meta.
    // We dispatch when the *position* changes (not only when the localId
    // changes) so that re-hovering the same embed after a doc transaction
    // re-syncs the plugin to the embed's latest pos rather than leaving it
    // pinned to a stale value. `null` means "no hover position currently
    // tracked by the plugin".
    const lastDispatchedHoverPosRef = (0, $cozmU.useRef)(null); // Resolve the selected target (DOM + node) ------------------------------
    const [selectedTarget, setSelectedTarget] = (0, $cozmU.useState)(null);
    const [hoveredTarget, setHoveredTarget] = (0, $cozmU.useState)(null);
    const handleAlignmentChange = (0, $cozmU.useCallback)((next)=>{
        setSelectionState((prev)=>({
                ...prev,
                currentAlignment: next
            }));
    }, []);
    /**
   * Called by a child overlay when it wants to start a resize. Returns
   * `true` if the start is accepted (this overlay now owns the resize), or
   * `false` if another overlay is already mid-resize and the start should
   * be rejected.
   *
   * NOTE: We deliberately do NOT clear `hoveredTarget` here, even though
   * Tier 1 (e) of the hardening plan suggested it. Clearing it synchronously
   * unmounts the hover overlay that just started the drag (because the
   * render tree no longer includes it), which destroys the ResizerNext
   * subtree mid-mousedown and the drag never reaches `handleResizeStart`.
   * The render-time dedup (`hoveredTarget.localId !== selectedTarget?.localId`)
   * is sufficient to prevent two overlays for the same embed.
   */ const handleResizeStart = (0, $cozmU.useCallback)((localId)=>{
        if (resizingLocalIdRef.current !== null && resizingLocalIdRef.current !== localId) // Another overlay is already mid-resize; reject the second start.
        return false;
        resizingLocalIdRef.current = localId;
        return true;
    }, []);
    /**
   * Called by a child overlay when its resize sequence has finished. We
   * ignore stops for any localId other than the one currently owning the
   * resize — defends against the unmount-cleanup race where a hover overlay
   * is unmounted (because its embed becomes selected) while the *selected*
   * overlay is still mid-resize.
   */ const handleResizeStop = (0, $cozmU.useCallback)((localId)=>{
        if (resizingLocalIdRef.current !== localId) return;
        resizingLocalIdRef.current = null; // Tier 1 (e): unconditionally clear hovered after a resize completes;
        // it will re-acquire on the next pointer movement if the cursor is
        // still inside an embed. (Safe here because the drag has already
        // finished; we're not unmounting an active ResizerNext subtree.)
        setHoveredTarget(null);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        // Tier 1 (c): we deliberately do NOT short-circuit when a resize is in
        // progress. The PM `is-resizer-resizing` meta + plugin-state already
        // prevents the selection from being clobbered by the resize itself,
        // so dropping selection updates client-side just creates drift between
        // the coordinator's view of "selected" and the doc's truth.
        const unsub = pluginInjectionApi?.editorPluginNativeEmbeds?.sharedState?.onChange?.(({ nextSharedState: nextSharedState })=>{
            const nextEmbed = nextSharedState?.selectedEmbed ?? null;
            setSelectionState((prev)=>({
                    selectedEmbed: nextEmbed,
                    trackedEmbedPos: nextSharedState?.trackedEmbedPos ?? null,
                    hoveredEmbedPos: nextSharedState?.hoveredEmbedPos ?? null,
                    currentAlignment: nextEmbed !== null ? nextEmbed.alignment : prev.currentAlignment
                }));
        });
        return ()=>{
            unsub?.();
        };
    }, [
        pluginInjectionApi
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!view) {
            setSelectedTarget(null);
            return;
        }
        const selected = (0, $kUhHF.getSelectedNativeEmbedExtension)(view.state);
        if (!selected) {
            setSelectedTarget(null);
            return;
        }
        try {
            const posForLookup = trackedEmbedPos ?? selected.pos;
            const domNode = (0, $bjg0G.findDomRefAtPos)(posForLookup, view.domAtPos.bind(view));
            const element = domNode instanceof HTMLElement ? domNode : domNode.parentElement;
            if (!element) {
                setSelectedTarget(null);
                return;
            }
            const container = element.querySelector('.extension-container') ?? element.closest('.extension-container') ?? element;
            const innerContainer = container.querySelector('[data-testid="native-embed-extension"]') ?? null;
            const localId = selected.node.attrs?.localId ?? '';
            setSelectedTarget({
                pos: selected.pos,
                localId: localId,
                node: selected.node,
                container: container,
                innerContainer: innerContainer
            });
        } catch  {
            setSelectedTarget(null);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedEmbed,
        view,
        view?.state,
        trackedEmbedPos
    ]);
    // Resolve the portal target (the editor's scroll container)
    const portalTarget = (0, $cozmU.useMemo)(()=>{
        if (!view) return null;
        return view.dom.closest('.fabric-editor-popup-scroll-parent') || view.dom.closest('.ak-editor-content-area') || view.dom.parentElement || null;
    }, [
        view
    ]); /**
               * Given any element inside a native-embed nodeview, walks up to the
               * `extensionView-content-wrap` element which is the actual ProseMirror
               * nodeView wrapper. `view.posAtDOM(wrapper, 0)` then resolves to the
               * exact position of THIS embed in the document — which is the only
               * reliable way to disambiguate sibling embeds. Calling posAtDOM on
               * the inner `.extension-container` returns positions inside the embed
               * (or, for sibling embeds, can collapse to a neighbouring embed's
               * position depending on layout), which is what caused the bug where
               * resizing embed B resized embed C.
               *
               * Lifted to component scope so both the `mouseover` hover detector and
               * the doc-change re-resolution effect can share the same logic.
               */ 
    const resolveTargetFromAnyElement = (0, $cozmU.useCallback)((anyEl)=>{
        if (!view) return null;
        try {
            let nodeViewDom = anyEl;
            while(nodeViewDom && nodeViewDom !== view.dom && !nodeViewDom.classList.contains('extensionView-content-wrap'))nodeViewDom = nodeViewDom.parentElement;
            if (!nodeViewDom || nodeViewDom === view.dom) return null;
            const pos = view.posAtDOM(nodeViewDom, 0);
            const $pos = view.state.doc.resolve(pos);
            let node = null;
            let nodePos = null;
            const nodeAfter = $pos.nodeAfter;
            if (nodeAfter && (0, $kUhHF.isNativeEmbedNode)(nodeAfter)) {
                node = nodeAfter;
                nodePos = pos;
            }
            if (!node) for(let d = $pos.depth; d >= 0; d--){
                const candidate = $pos.node(d);
                if (candidate && (0, $kUhHF.isNativeEmbedNode)(candidate)) {
                    node = candidate;
                    nodePos = d === 0 ? 0 : $pos.before(d);
                    break;
                }
            }
            if (!node || nodePos == null) return null;
            const container = nodeViewDom.querySelector('.extension-container') ?? nodeViewDom;
            const innerContainer = container.querySelector('[data-testid="native-embed-extension"]') ?? null;
            return {
                pos: nodePos,
                localId: node.attrs?.localId ?? '',
                node: node,
                container: container,
                innerContainer: innerContainer
            };
        } catch  {
            return null;
        }
    }, [
        view
    ]);
    // Hover detector --------------------------------------------------------
    (0, $cozmU.useEffect)(()=>{
        if (!view) return;
         // Listen on view.dom itself (the contenteditable). This is the most
        // reliable place to capture mouseover/mouseout on embeds: any other
        // container we'd pick (.ak-editor-content-area, .fabric-editor-
        // popup-scroll-parent, etc) may not be present in every editor surface.
        // Embed iframes don't bubble mouse events to the parent document, but
        // the wrapping `.extension-container` element does — that's what we're
        // tracking here.
        if (!(view.dom instanceof HTMLElement)) return;
        const root = view.dom;
        const isInsideEmbedOrOverlay = (n)=>{
            if (!n) return false;
            if (!(n instanceof Element)) return n.parentElement ? isInsideEmbedOrOverlay(n.parentElement) : false;
            return !!n.closest('.extension-container') || !!n.closest('[data-testid="native-embed-resizer"]');
        }; // Tier 1 (d): debounce hover transitions. Rapid mouseover/mouseout
        // pairs (e.g. crossing internal element boundaries inside an embed
        // wrapper) would otherwise flicker `hoveredTarget` and produce brief
        // two-overlay frames. A short debounce coalesces the burst into a
        // single transition.
        const HOVER_DEBOUNCE_MS = 75;
        let pendingHoverTimeout = null;
        const cancelPendingHover = ()=>{
            if (pendingHoverTimeout !== null) {
                clearTimeout(pendingHoverTimeout);
                pendingHoverTimeout = null;
            }
        };
        const handleOver = (event)=>{
            if (resizingLocalIdRef.current !== null) return;
            const evtTarget = event.target;
            if (!(evtTarget instanceof HTMLElement)) return;
             // Only trigger when the mouse is over an actual native-embed
            // (avoids firing for arbitrary editor content). The element we
            // look up is the inner iframe wrapper; we then resolve up to the
            // nodeView wrapper to disambiguate sibling embeds.
            const inner = evtTarget.closest('[data-testid="native-embed-extension"]');
            if (!inner) return;
            const newTarget = resolveTargetFromAnyElement(inner);
            if (!newTarget) return;
            cancelPendingHover();
            pendingHoverTimeout = setTimeout(()=>{
                pendingHoverTimeout = null;
                if (resizingLocalIdRef.current !== null) return;
                 // Dispatch the PM-world bridge OUTSIDE the setState updater. React
                // may invoke updaters more than once (StrictMode, concurrent
                // rendering); a side-effect inside would then dispatch duplicate
                // transactions. We compare against `lastDispatchedHoverPosRef` —
                // not just localId — so re-hovering the same embed after a doc
                // shift re-syncs the plugin to the embed's latest pos.
                //
                // Collab safety: this transaction has no steps and `tr.docChanged`
                // is false, so the collab plugin's `send-transaction.ts` filter
                // (which requires docChanged) will not broadcast it. Verified
                // against editor-plugin-collab-edit/.../send-transaction.ts.
                if (view && lastDispatchedHoverPosRef.current !== newTarget.pos) {
                    lastDispatchedHoverPosRef.current = newTarget.pos;
                    const tr = view.state.tr.setMeta((0, $dunxr.pluginKey), {
                        type: 'SET_HOVERED_EMBED_POS',
                        pos: newTarget.pos
                    }) // Hover dispatches must never enter the undo stack — they
                    // are pure UI state, not a user-visible doc edit.
                    .setMeta('addToHistory', false);
                    view.dispatch(tr);
                }
                setHoveredTarget((current)=>current?.localId === newTarget.localId ? current : newTarget);
            }, HOVER_DEBOUNCE_MS);
        };
        const handleOut = (event)=>{
            if (resizingLocalIdRef.current !== null) return;
            const me = event;
            const related = me.relatedTarget;
            if (related instanceof Node && isInsideEmbedOrOverlay(related)) return;
            cancelPendingHover();
            pendingHoverTimeout = setTimeout(()=>{
                pendingHoverTimeout = null;
                if (resizingLocalIdRef.current !== null) return;
                 // Clear the tracked hover position so the plugin stops mapping
                // it through transactions. Dispatch outside the setState updater
                // (see handleOver above for rationale) and only when the plugin
                // currently has a non-null pos to clear.
                if (view && lastDispatchedHoverPosRef.current !== null) {
                    lastDispatchedHoverPosRef.current = null;
                    const tr = view.state.tr.setMeta((0, $dunxr.pluginKey), {
                        type: 'SET_HOVERED_EMBED_POS',
                        pos: null
                    }).setMeta('addToHistory', false);
                    view.dispatch(tr);
                }
                setHoveredTarget(null);
            }, HOVER_DEBOUNCE_MS);
        };
        const unbind = (0, $cbY7C.bindAll)(root, [
            {
                type: 'mouseover',
                listener: handleOver
            },
            {
                type: 'mouseout',
                listener: handleOut
            }
        ]);
        return ()=>{
            cancelPendingHover();
            unbind();
        };
    }, [
        view,
        resolveTargetFromAnyElement
    ]);
    // Hover-overlay alignment with doc changes (CNS-26923 parity for hover).
    // When `hoveredEmbedPos` changes (the PM plugin mapped it through a doc
    // transaction) we re-resolve the hover Target so EmbedResizeOverlay's
    // `useLayoutEffect([target])` re-measures against the embed's current
    // rect. See commit message for the full data-flow rationale.
    //
    // `hoveredTarget` is intentionally omitted from deps: it is owned by
    // this same coordinator and only the `hoveredEmbedPos` change should
    // trigger re-resolution. The `resolveTargetFromAnyElement` dep is for
    // react-hooks/exhaustive-deps compliance only — it changes iff `view`
    // changes (already in the dep list).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $cozmU.useEffect)(()=>{
        if (!view || !hoveredTarget) return;
         // Don't disturb an in-flight resize: rebuilding Target identity
        // re-fires EmbedResizeOverlay's measurement effect mid-drag.
        if (resizingLocalIdRef.current !== null) return;
         // PM signalled that the hovered embed is gone (mapped pos resolved
        // to `null` in `resolveTrackedEmbedPos` — i.e. the node at the
        // mapped pos is no longer a native embed, or the embed was deleted
        // outright). Treat this as the authoritative signal that the hover
        // overlay should be unmounted; otherwise the resize handle bars
        // would linger over empty space until the next pointer movement
        // outside an embed (which may never come — e.g. Backspace deletion
        // fires no `mouseout`). The defensive cleanup effect below cannot
        // catch this on its own because its deps don't observe doc
        // transactions. See lingering-handles repro test.
        if (hoveredEmbedPos === null) {
            lastDispatchedHoverPosRef.current = null;
            setHoveredTarget(null);
            return;
        }
        try {
            const domNode = (0, $bjg0G.findDomRefAtPos)(hoveredEmbedPos, view.domAtPos.bind(view));
            const element = domNode instanceof HTMLElement ? domNode : domNode.parentElement;
            if (!element) return;
            const refreshed = resolveTargetFromAnyElement(element);
            if (!refreshed || refreshed.localId !== hoveredTarget.localId) // The mapped pos resolves to a different embed or nothing —
            // leave the hover target alone; the defensive cleanup handles
            // the case where the hovered embed was deleted.
            return;
             // Hand EmbedResizeOverlay a fresh Target object so its
            // `useLayoutEffect([target, ...])` re-fires and re-measures
            // the embed's current getBoundingClientRect().
            setHoveredTarget(refreshed);
        } catch  {
        // place and let the next hoveredEmbedPos change retry.
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hoveredEmbedPos,
        view,
        resolveTargetFromAnyElement
    ]);
    // Defensive: clear hovered target if its DOM is gone (e.g. collab edit
    // removed the embed) or if it's now also the selected target. We use the
    // view's owner document for the check rather than the global `document`
    // to avoid cross-iframe surprises.
    //
    // IMPORTANT: never clear the hovered target if it currently owns an
    // in-flight resize (e.g. selection just transferred to the embed the
    // hover overlay is dragging). Doing so would unmount the ResizerNext
    // subtree mid-drag and silently cancel the resize.
    (0, $cozmU.useEffect)(()=>{
        if (!hoveredTarget) return;
        if (resizingLocalIdRef.current === hoveredTarget.localId) return;
        const ownerDoc = view?.dom.ownerDocument;
        const inDom = ownerDoc ? ownerDoc.contains(hoveredTarget.container) : false;
        const sameAsSelected = !!selectedTarget && hoveredTarget.localId === selectedTarget.localId;
        if (!inDom || sameAsSelected) setHoveredTarget(null);
    }, [
        hoveredTarget,
        view,
        selectedTarget
    ]);
    if (!view || !portalTarget) return null;
     // Render gating ---------------------------------------------------------
    // Continuous-overlay architecture: we render at most ONE EmbedResizeOverlay
    // per embed, keyed by `localId` rather than by mode. This eliminates a
    // whole class of flicker bugs that previously occurred when the embed
    // transitioned hover→selected (e.g. on mouseup of a hover-driven resize):
    // the old design swapped between two `key`-distinct subtrees, forcing
    // React to unmount/remount ResizerNext, drop measurement refs, and re-run
    // layout effects against the previous frame's width.
    //
    // Now `mode` is just a prop that flips between 'hover' and 'selected'
    // — the same React fiber, ResizerNext instance, and refs survive the
    // transition. The hover-vs-selected DOM signal is preserved via the
    // `data-overlay-mode` attribute the overlay already exposes.
    //
    // Mount priority when both selectedTarget and hoveredTarget exist for the
    // SAME embed: prefer `selectedTarget` (it carries the live
    // `currentAlignment` from the alignment toolbar). When they're different
    // embeds, render both: the selected overlay for the selected embed and a
    // hover overlay for the hovered embed.
    const sameEmbedSelectedAndHovered = !!selectedTarget && !!hoveredTarget && selectedTarget.localId === hoveredTarget.localId; // Whichever overlay we render for the hovered embed (if any) only when
    // it is NOT the selected embed; otherwise we collapse to the single
    // selected-mode overlay.
    const hoverOnlyTarget = sameEmbedSelectedAndHovered ? null : hoveredTarget; // The hover overlay must reflect the *hovered* embed's own alignment,
    // not the selection-scoped `currentAlignment` (which only tracks the
    // selected embed). Without this, side-aligned embeds would show resize
    // handles on both edges while hovered (the wrong edge being draggable
    // would fight the alignment), instead of only the inner edge as in the
    // selected state. Reuses the canonical `getAlignment` helper from the
    // alignment command so the overlay's read of alignment is sourced from
    // the same place the command writes it (single source of truth).
    const hoverAlignment = hoveredTarget ? (0, $1WSjf.getAlignment)(hoveredTarget.node) : 'center';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, selectedTarget && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bTjR8.EmbedResizeOverlay // Key by localId — never by mode — so the overlay survives
    ), {
        // hover→selected transitions without remount/flicker.
        key: selectedTarget.localId,
        target: selectedTarget,
        mode: "selected",
        view: view,
        portalTarget: portalTarget,
        pluginInjectionApi: pluginInjectionApi,
        appearance: appearance,
        disabled: !!disabled,
        containerWidth: containerWidth,
        lineLength: lineLength,
        currentAlignment: currentAlignment,
        onAlignmentChange: handleAlignmentChange,
        onResizeStart: handleResizeStart,
        onResizeStop: handleResizeStop
    }), hoverOnlyTarget && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bTjR8.EmbedResizeOverlay), {
        key: hoverOnlyTarget.localId,
        target: hoverOnlyTarget,
        mode: "hover",
        view: view,
        portalTarget: portalTarget,
        pluginInjectionApi: pluginInjectionApi,
        appearance: appearance,
        disabled: !!disabled,
        containerWidth: containerWidth,
        lineLength: lineLength,
        currentAlignment: hoverAlignment,
        onResizeStart: handleResizeStart,
        onResizeStop: handleResizeStop
    }));
};
module.exports["ResizableNativeEmbedCoordinator"] = $371da16a9a10889f$export$5d91af3986d5a280;

});

parcelRegister("bTjR8", function(module, exports) {
/* EmbedResizeOverlay.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $cbY7C = parcelRequire("cbY7C");


var $9kbTQ = parcelRequire("9kbTQ");


var $haNN4 = parcelRequire("haNN4");


var $ktOsK = parcelRequire("ktOsK");

var $b8q5K = parcelRequire("b8q5K");

var $lPlPa = parcelRequire("lPlPa");

var $78UMD = parcelRequire("78UMD");


var $9ppjA = parcelRequire("9ppjA");


var $aWssQ = parcelRequire("aWssQ");


var $kCECX = parcelRequire("kCECX");


var $7Y8M5 = parcelRequire("7Y8M5");


var $cXtTj = parcelRequire("cXtTj");


var $ljOiP = parcelRequire("ljOiP");


var $1WSjf = parcelRequire("1WSjf");


var $4xLGC = parcelRequire("4xLGC");


var $lG1Bc = parcelRequire("lG1Bc");


var $gnLph = parcelRequire("gnLph");


var $jI0jP = parcelRequire("jI0jP");


var $hHNKT = parcelRequire("hHNKT");


var $5h9gN = parcelRequire("5h9gN");


var $bfk7V = parcelRequire("bfk7V");

const $470ca23c824bbe28$var$resizerWrapperStyles = null;
const $470ca23c824bbe28$var$resizerPlaceholderStyles = null;
const $470ca23c824bbe28$var$NATIVE_EMBED_RESIZE_BORDER_SUPPRESSION_CONFIG = 'native_embed_resize_border_suppression';
const $470ca23c824bbe28$var$SELECTED_BORDER_TOKEN = '--ds-border-selected';
const $470ca23c824bbe28$var$getMeasuredResizeRect = (measureEl, innerContainer)=>{
    const outerRect = measureEl.getBoundingClientRect();
    const innerRect = innerContainer?.getBoundingClientRect(); // Wrapped embeds can collapse the node-view wrapper height while the iframe
    // remains visible, so fall back to the frame rect for overlay sizing.
    const visibleInnerRect = innerRect && innerRect.width > 0 && innerRect.height > 0 ? innerRect : measureEl.querySelector('iframe')?.getBoundingClientRect();
    if (!visibleInnerRect || visibleInnerRect.width <= 0 || visibleInnerRect.height <= 0) return outerRect;
    const left = Math.min(outerRect.left, visibleInnerRect.left);
    const right = Math.max(outerRect.right, visibleInnerRect.right);
    const top = Math.min(outerRect.top, visibleInnerRect.top);
    const bottom = Math.max(outerRect.bottom, visibleInnerRect.bottom);
    return {
        bottom: bottom,
        height: bottom - top,
        left: left,
        right: right,
        top: top,
        width: right - left
    };
};
const $470ca23c824bbe28$export$a777b135e925da43 = (props)=>{
    const { target: target, mode: mode, view: view, portalTarget: portalTarget, pluginInjectionApi: pluginInjectionApi, appearance: appearance, disabled: disabled, containerWidth: containerWidth, lineLength: lineLength, currentAlignment: currentAlignment, onAlignmentChange: onAlignmentChange, onResizeStart: onResizeStart, onResizeStop: onResizeStop } = props;
    const disableHandles = !!disabled;
    const isNativeEmbedLoading = (0, $5h9gN.useNativeEmbedLoadingState)(target.container, target.innerContainer);
    const handlesBlocked = disableHandles || isNativeEmbedLoading; // -----------------------------------------------------------------------
    // Per-overlay state
    // -----------------------------------------------------------------------
    const [isResizing, setIsResizing] = (0, $cozmU.useState)(false);
    const [snaps, setSnaps] = (0, $cozmU.useState)({}); // Tracks which handle is currently being dragged so resizeRatio can be
    // switched per-direction (re-resizable applies a single ratio to both axes).
    const [activeResizeDirection, setActiveResizeDirection] = (0, $cozmU.useState)(null);
    const isResizingRef = (0, $cozmU.useRef)(false);
    const aspectRatioRef = (0, $cozmU.useRef)(null);
    const fixedHeightRef = (0, $cozmU.useRef)(null);
    const lastSnappedGuidelineKeysRef = (0, $cozmU.useRef)([]);
    const committedWidthRef = (0, $cozmU.useRef)(null);
    const committedHeightRef = (0, $cozmU.useRef)(null);
    const innerEmbedContainerRef = (0, $cozmU.useRef)(target.innerContainer);
    const resizeFrameRafRef = (0, $cozmU.useRef)(null);
    const bottomDraggedRef = (0, $cozmU.useRef)(false);
    const suppressedSelectedBorderElementRef = (0, $cozmU.useRef)(null); // For nested embeds, capture the actual pixel width of the parent container at
    // drag start. nestedMaxWidth is derived from ProseMirror schema attributes and may
    // not match the actual CSS-computed pixel width (e.g. layout columns with implicit
    // widths). This DOM measurement is the source of truth for clamping during drag.
    const nestedContainerWidthRef = (0, $cozmU.useRef)(null);
    const [embedDomElement, setEmbedDomElement] = (0, $cozmU.useState)(target.container);
    const [nodeRect, setNodeRect] = (0, $cozmU.useState)(null);
    const isResizeBorderSuppressionKillswitchOn = (0, $cXtTj.default).getExperimentValue($470ca23c824bbe28$var$NATIVE_EMBED_RESIZE_BORDER_SUPPRESSION_CONFIG, 'value', false);
    const suppressSelectedBorder = (0, $cozmU.useCallback)(()=>{
        if (isResizeBorderSuppressionKillswitchOn) return;
         // Host-only chrome override: keep PM selection unchanged and clear from the
        // exact element on every stop/unmount path so stale selection chrome cannot leak.
        const previousElement = suppressedSelectedBorderElementRef.current;
        if (previousElement && previousElement !== target.container) previousElement.style.removeProperty($470ca23c824bbe28$var$SELECTED_BORDER_TOKEN);
        target.container.style.setProperty($470ca23c824bbe28$var$SELECTED_BORDER_TOKEN, 'transparent');
        suppressedSelectedBorderElementRef.current = target.container;
    }, [
        isResizeBorderSuppressionKillswitchOn,
        target.container
    ]);
    const clearSelectedBorderSuppression = (0, $cozmU.useCallback)(()=>{
        const suppressedElement = suppressedSelectedBorderElementRef.current;
        if (suppressedElement) {
            suppressedElement.style.removeProperty($470ca23c824bbe28$var$SELECTED_BORDER_TOKEN);
            suppressedSelectedBorderElementRef.current = null;
        }
    }, []);
    const updateMeasuredNodeRect = (0, $cozmU.useCallback)((measureEl, container)=>{
        const containerRect = container.getBoundingClientRect();
        const nodeRectRaw = $470ca23c824bbe28$var$getMeasuredResizeRect(measureEl, innerEmbedContainerRef.current);
        const nextNodeRect = {
            top: nodeRectRaw.top - containerRect.top + container.scrollTop,
            left: nodeRectRaw.left - containerRect.left + container.scrollLeft,
            width: nodeRectRaw.width,
            height: nodeRectRaw.height
        };
        setNodeRect((prevNodeRect)=>{
            if (prevNodeRect && prevNodeRect.top === nextNodeRect.top && prevNodeRect.left === nextNodeRect.left && prevNodeRect.width === nextNodeRect.width && prevNodeRect.height === nextNodeRect.height) return prevNodeRect;
            return nextNodeRect;
        });
        if (committedHeightRef.current !== null && Math.round(nextNodeRect.height) === committedHeightRef.current) committedHeightRef.current = null;
    }, []); // Sync refs / DOM element when the target changes
    (0, $cozmU.useEffect)(()=>{
        setEmbedDomElement(target.container);
        innerEmbedContainerRef.current = target.innerContainer;
    }, [
        target
    ]); // Stable ref to the localId we last reported as "started" so the unmount
    // cleanup can pair the start with a matching stop using the same id, even
    // if `target` has since changed identity.
    const resizingStartedLocalIdRef = (0, $cozmU.useRef)(null); // Make sure if we unmount mid-drag the coordinator's resize ownership is
    // released. We pair start/stop by localId so the coordinator can ignore
    // stops for any embed other than the one currently owning the resize.
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (isResizingRef.current && resizingStartedLocalIdRef.current) {
                const startedLocalId = resizingStartedLocalIdRef.current;
                isResizingRef.current = false;
                resizingStartedLocalIdRef.current = null;
                clearSelectedBorderSuppression(); // Signal drag-stop to the editor-extension even if we unmount mid-drag.
                if (!(0, $hHNKT.getNativeEmbedShouldLockAspectRatio)(target.node)) try {
                    target.container.dispatchEvent(new CustomEvent('native-embed-resize-state-change', {
                        bubbles: true,
                        detail: {
                            active: false,
                            localId: startedLocalId
                        }
                    }));
                } catch  {}
                onResizeStop?.(startedLocalId);
            }
            if (resizeFrameRafRef.current !== null) {
                cancelAnimationFrame(resizeFrameRafRef.current);
                resizeFrameRafRef.current = null;
            }
            clearSelectedBorderSuppression();
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // -----------------------------------------------------------------------
    // Width derivation
    // -----------------------------------------------------------------------
    const currentWidth = (0, $cozmU.useMemo)(()=>{
        const node = target.node;
        if (!node) return lineLength;
        const storedWidth = (0, $4xLGC.getWidth)(node);
        if (storedWidth) return storedWidth;
        const layout = node.attrs.layout || 'default';
        const paramWidth = node.attrs.parameters?.width;
        if (typeof paramWidth === 'number' && paramWidth > 0) return paramWidth;
        if (layout === 'wide') return Math.ceil(lineLength * 1.4);
        if (layout === 'full-width') return 0, $7Y8M5.akEditorFullWidthLayoutWidth;
        return lineLength;
    }, [
        target.node,
        lineLength
    ]); // Live-measured container width that overrides the potentially stale
    // plugin value. On non-maximized Mac windows the width plugin's
    // ResizeObserver can report an inflated containerWidth on initial page
    // load (before the content-tree sidebar has finished rendering). This
    // is updated at the start of each drag with the actual DOM measurement
    // and reset to null when the plugin value updates (meaning it caught up).
    const [liveMeasuredContainerWidth, setLiveMeasuredContainerWidth] = (0, $cozmU.useState)(null); // When the plugin's containerWidth updates, clear the override — the
    // plugin has caught up (e.g. after a window resize).
    (0, $cozmU.useEffect)(()=>{
        setLiveMeasuredContainerWidth(null);
    }, [
        containerWidth
    ]);
    const effectiveContainerWidth = liveMeasuredContainerWidth ?? containerWidth;
    const nestedMaxWidth = (0, $cozmU.useMemo)(()=>{
        if (!view) return undefined;
        try {
            return (0, $9ppjA.getParentNodeWidth)(target.pos, view.state, {
                width: effectiveContainerWidth,
                lineLength: lineLength
            });
        } catch  {
            return undefined;
        }
    }, [
        target.pos,
        view,
        effectiveContainerWidth,
        lineLength
    ]);
    const isNested = nestedMaxWidth !== undefined;
    const maxWidth = (0, $cozmU.useMemo)(()=>{
        return nestedMaxWidth ?? (0, $bfk7V.calcMaxWidth)(effectiveContainerWidth, appearance);
    }, [
        nestedMaxWidth,
        effectiveContainerWidth,
        appearance
    ]);
    const [resizeWidth, setResizeWidth] = (0, $cozmU.useState)(currentWidth);
    const [resizeHeight, setResizeHeight] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!isResizing) {
            if (committedWidthRef.current !== null) {
                if (currentWidth === committedWidthRef.current) committedWidthRef.current = null;
                return;
            } // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- only one state update; the chain detection is a false positive when the initial useState value depends on a derived value (currentWidth)
            setResizeWidth(Math.min(currentWidth, maxWidth));
        }
    }, [
        currentWidth,
        isResizing,
        maxWidth
    ]);
    const allowVerticalResize = (0, $cozmU.useMemo)(()=>(0, $hHNKT.nativeEmbedAllowsVerticalResize)(target.node), [
        target.node
    ]);
    const nativeEmbedExperienceId = (0, $hHNKT.getNativeEmbedExperienceIdFromExtensionKey)(target.node.attrs.extensionKey);
    const isDatabaseNativeEmbed = nativeEmbedExperienceId === 'database' || nativeEmbedExperienceId === 'database-entry';
    const [requestedMaxHeight, setRequestedMaxHeight] = (0, $cozmU.useState)(()=>(0, $gnLph.getMaxHeight)(view, target.localId));
    (0, $cozmU.useEffect)(()=>{
        setRequestedMaxHeight((0, $gnLph.getMaxHeight)(view, target.localId));
        return (0, $gnLph.subscribeMaxHeight)(view, target.localId, (nextMaxHeight)=>{
            setRequestedMaxHeight(nextMaxHeight);
        });
    }, [
        view,
        target.localId
    ]);
    const effectiveMaxHeight = allowVerticalResize && isDatabaseNativeEmbed ? Math.max((0, $bfk7V.MIN_HEIGHT), Math.round(requestedMaxHeight ?? (0, $bfk7V.MAX_HEIGHT))) : undefined; // For database native embeds with vertical resize (gated behind databases-native-embeds-v2),
    // add extra padding around the bottom drag handle.
    const bottomHandleStyles = (0, $cozmU.useMemo)(()=>{
        if (!allowVerticalResize) return undefined;
        const handleHeight = "var(--ds-space-150, 12px)";
        return {
            bottom: {
                height: handleHeight,
                bottom: `calc(${handleHeight} * -1)`
            }
        };
    }, [
        allowVerticalResize
    ]); // -----------------------------------------------------------------------
    // Measure the embed DOM position for overlay positioning.
    // -----------------------------------------------------------------------
    (0, $cozmU.useLayoutEffect)(()=>{
        if (isResizing) return;
        try {
            const measureEl = target.container;
            if (!measureEl) {
                setNodeRect(null);
                return;
            }
            updateMeasuredNodeRect(measureEl, portalTarget);
        } catch  {
            setNodeRect(null);
        }
    }, [
        target,
        portalTarget,
        isResizing,
        updateMeasuredNodeRect,
        lineLength,
        effectiveContainerWidth
    ]); // The host page can move the editor center line without changing the
    // selected node or PM position, e.g. when Confluence toggles its sidebar.
    // Re-measure on observed container/layout events so handles stay attached
    // to the live DOM box even when the embed only moves horizontally.
    (0, $cozmU.useLayoutEffect)(()=>{
        if (isResizing || !embedDomElement) return;
        let animationFrameId = null;
        const updateRectAndWidth = ()=>{
            updateMeasuredNodeRect(embedDomElement, portalTarget);
            const observedWidth = Math.round($470ca23c824bbe28$var$getMeasuredResizeRect(embedDomElement, innerEmbedContainerRef.current).width);
            if (observedWidth > 0) setResizeWidth((prevWidth)=>{
                return prevWidth === observedWidth ? prevWidth : observedWidth;
            });
        };
        const scheduleMeasure = ()=>{
            if (animationFrameId !== null) cancelAnimationFrame(animationFrameId);
            animationFrameId = requestAnimationFrame(()=>{
                animationFrameId = null;
                updateRectAndWidth();
            });
        };
        updateRectAndWidth();
        const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(updateRectAndWidth) : null;
        if (observer) {
            const elementsToObserve = new Set();
            elementsToObserve.add(embedDomElement);
            elementsToObserve.add(portalTarget);
            if (view.dom instanceof HTMLElement) elementsToObserve.add(view.dom);
            if (view.dom.parentElement) elementsToObserve.add(view.dom.parentElement);
            elementsToObserve.forEach((element)=>observer.observe(element));
        }
        const ownerWindow = view.dom.ownerDocument.defaultView;
        const unbindWindowEvents = ownerWindow ? (0, $cbY7C.bindAll)(ownerWindow, [
            {
                type: 'resize',
                listener: scheduleMeasure
            },
            {
                type: 'orientationchange',
                listener: scheduleMeasure
            }
        ]) : null;
        const unbindDocumentEvents = (0, $cbY7C.bindAll)(view.dom.ownerDocument, [
            {
                type: 'transitionend',
                listener: scheduleMeasure
            }
        ]);
        return ()=>{
            unbindWindowEvents?.();
            unbindDocumentEvents();
            observer?.disconnect();
            if (animationFrameId !== null) cancelAnimationFrame(animationFrameId);
        };
    }, [
        isResizing,
        embedDomElement,
        portalTarget,
        updateMeasuredNodeRect,
        view
    ]); // During a side drag of an unlocked-AR embed, observe the inner container's
    // height so the drag handles reposition as the child iframe re-lays out.
    // Not needed for bottom drags (cursor drives height) or locked-AR embeds.
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!isResizing) return;
        if (bottomDraggedRef.current) return;
        if (aspectRatioRef.current !== null) return;
        const inner = innerEmbedContainerRef.current;
        if (!inner || typeof ResizeObserver === 'undefined') return;
        const onObserved = ()=>{
            const liveHeight = Math.round(inner.getBoundingClientRect().height);
            if (liveHeight <= 0 || liveHeight === fixedHeightRef.current) return;
            fixedHeightRef.current = liveHeight;
            setResizeHeight((prev)=>prev === liveHeight ? prev : liveHeight);
            if (embedDomElement) updateMeasuredNodeRect(embedDomElement, portalTarget);
        };
        const ro = new ResizeObserver(onObserved);
        ro.observe(inner);
        return ()=>ro.disconnect();
    }, [
        isResizing,
        activeResizeDirection,
        embedDomElement,
        portalTarget,
        updateMeasuredNodeRect
    ]); // -----------------------------------------------------------------------
    // Guidelines
    // -----------------------------------------------------------------------
    const defaultGuidelines = (0, $cozmU.useMemo)(()=>{
        return isNested ? [] : (0, $b8q5K.generateDefaultGuidelines)(lineLength, effectiveContainerWidth, false);
    }, [
        lineLength,
        effectiveContainerWidth,
        isNested
    ]);
    const guidelinesRef = (0, $cozmU.useMemo)(()=>({
            current: defaultGuidelines
        }), [
        defaultGuidelines
    ]);
    const isGuidelineEnabled = (0, $cozmU.useMemo)(()=>{
        return !!pluginInjectionApi?.guideline;
    }, [
        pluginInjectionApi
    ]); // -----------------------------------------------------------------------
    // Resize handlers
    // -----------------------------------------------------------------------
    const handleWrapperMouseDown = (0, $cozmU.useCallback)((e)=>{
        const t = e.target;
        if (!(t instanceof HTMLElement)) return;
        const handleEl = t.closest('.resizer-handle') || t.closest('.resizer-handle-thumb') || t.closest('.resizer-handle-track') || t.closest('[class*="resizer-handle"]');
        if (handleEl) {
            // Detect which handle was clicked so resizeRatio can be set per
            // direction. re-resizable applies a single resizeRatio to both
            // axes; for centered embeds we need 2 horizontally (symmetric L/R
            // drag) but 1 vertically (asymmetric bottom-only drag), otherwise
            // the bottom handle visually drifts off the embed's bottom edge.
            const handleClassName = handleEl instanceof HTMLElement ? handleEl.className : '';
            const inferredDirection = (()=>{
                if (handleClassName.includes('bottom') || handleEl.closest('[data-testid*="resizer-handle-bottom"]')) return 'bottom';
                if (handleClassName.includes('left') || handleEl.closest('[data-testid*="resizer-handle-left"]')) return 'left';
                if (handleClassName.includes('right') || handleEl.closest('[data-testid*="resizer-handle-right"]')) return 'right';
                return null;
            })();
            setActiveResizeDirection(inferredDirection); // Try to claim resize ownership from the coordinator. If another
            // overlay is already mid-resize the coordinator will reject us; in
            // that case we don't flip our local resizing flag and we let the
            // event bubble normally.
            const accepted = onResizeStart ? onResizeStart(target.localId) : true;
            if (!accepted) return;
            isResizingRef.current = true;
            resizingStartedLocalIdRef.current = target.localId;
            suppressSelectedBorder();
            e.stopPropagation();
        }
    }, [
        onResizeStart,
        suppressSelectedBorder,
        target.localId
    ]);
    const handleResizeStart = (0, $cozmU.useCallback)(()=>{
        // If we did not already claim ownership in handleWrapperMouseDown (for
        // example when ResizerNext starts a drag without our wrapper having
        // observed the mousedown), claim it here. The coordinator may reject
        // the start if another overlay is already mid-resize, in which case we
        // bail without flipping any local state or dispatching meta.
        if (resizingStartedLocalIdRef.current !== target.localId) {
            const accepted = onResizeStart ? onResizeStart(target.localId) : true;
            if (!accepted) return;
            resizingStartedLocalIdRef.current = target.localId;
        }
        suppressSelectedBorder();
        setIsResizing(true);
        isResizingRef.current = true;
        lastSnappedGuidelineKeysRef.current = [];
        bottomDraggedRef.current = false; // Signal drag-start to the editor-extension so it hands width ownership
        // to the overlay for the duration of the drag (prevents width clobber).
        if (!(0, $hHNKT.getNativeEmbedShouldLockAspectRatio)(target.node)) try {
            target.container.dispatchEvent(new CustomEvent('native-embed-resize-state-change', {
                bubbles: true,
                detail: {
                    active: true,
                    localId: target.localId
                }
            }));
        } catch  {}
        if (!view) return;
         // Re-measure the actual container width from the DOM. The width
        // plugin's ResizeObserver may have reported an inflated width on
        // initial page load (e.g. before the content-tree sidebar finished
        // rendering). Using the live measurement ensures maxWidth is
        // correct for this drag session.
        try {
            const scrollParent = (0, $haNN4.getDocument)()?.querySelector('.fabric-editor-popup-scroll-parent');
            if (scrollParent instanceof HTMLElement) {
                const liveWidth = Math.round(scrollParent.offsetWidth);
                if (liveWidth !== containerWidth) setLiveMeasuredContainerWidth(liveWidth);
            }
        } catch  {}
        try {
            const container = target.container;
            if (container) {
                setEmbedDomElement(container);
                if (isNested) {
                    const parentEl = container.offsetParent;
                    if (parentEl) nestedContainerWidthRef.current = Math.round(parentEl.getBoundingClientRect().width);
                } else nestedContainerWidthRef.current = null;
                const innerContainer = target.innerContainer ?? container.querySelector('[data-testid="native-embed-extension"]') ?? null;
                innerEmbedContainerRef.current = innerContainer;
                const rect = $470ca23c824bbe28$var$getMeasuredResizeRect(container, innerContainer);
                if (rect.width > 0) {
                    const startWidth = Math.round(rect.width);
                    setResizeWidth(startWidth);
                    const shouldLockAspectRatio = (0, $hHNKT.getNativeEmbedShouldLockAspectRatio)(target.node);
                    if (shouldLockAspectRatio) {
                        // Use the live DOM measurement as the aspect ratio source.
                        // The stored aspectRatio parameter is not reliable — it defaults
                        // to 1 when no originalWidth/originalHeight was provided, and is
                        // never updated after a resize. The DOM rect at drag-start is the
                        // correct height/width ratio for the embed as it is currently rendered.
                        aspectRatioRef.current = rect.height / rect.width;
                        fixedHeightRef.current = null;
                        setResizeHeight(null);
                        const effectiveHeight = Math.round(rect.width * aspectRatioRef.current);
                        container.style.setProperty('--native-embed-aspect-ratio', `${rect.width} / ${effectiveHeight}`);
                    } else {
                        aspectRatioRef.current = null;
                        const innerHeight = innerEmbedContainerRef.current ? Math.round(innerEmbedContainerRef.current.getBoundingClientRect().height) : 0;
                        const measuredHeight = innerHeight > 0 ? innerHeight : Math.round(rect.height);
                        const currentHeight = effectiveMaxHeight !== undefined ? Math.min(measuredHeight, effectiveMaxHeight) : measuredHeight;
                        fixedHeightRef.current = currentHeight;
                        setResizeHeight(currentHeight);
                        container.style.removeProperty('aspect-ratio');
                        if (allowVerticalResize) {
                            container.style.setProperty('height', `${currentHeight}px`);
                            if (innerEmbedContainerRef.current) {
                                innerEmbedContainerRef.current.style.removeProperty('aspect-ratio');
                                innerEmbedContainerRef.current.style.setProperty('height', `${currentHeight}px`);
                            }
                        }
                    }
                }
            }
        } catch  {}
        const { state: state, dispatch: dispatch } = view;
        const tr = state.tr;
        tr.setMeta((0, $lG1Bc.NATIVE_EMBED_PLUGIN_IS_RESIZING_KEY), true);
        tr.setMeta('is-resizer-resizing', true);
        tr.setMeta('scrollIntoView', false); // NOTE: deliberately DO NOT set selection here. Selection only transfers
        // at mouseup (handleResizeStop), which keeps R4 satisfied for the hover
        // overlay (and is a no-op for the selected overlay).
        dispatch(tr);
    }, [
        view,
        target,
        isNested,
        onResizeStart,
        containerWidth,
        allowVerticalResize,
        effectiveMaxHeight,
        suppressSelectedBorder
    ]);
    const scheduleResizeFrame = (0, $cozmU.useCallback)(()=>{
        if (!view) return;
        if (resizeFrameRafRef.current !== null) return;
        resizeFrameRafRef.current = requestAnimationFrame(()=>{
            resizeFrameRafRef.current = null;
            if (!isResizingRef.current || !view || view.isDestroyed) return;
            const tr = view.state.tr;
            tr.setMeta('native-embed-resize-frame', true);
            tr.setMeta('addToHistory', false);
            tr.setMeta('scrollIntoView', false);
            view.dispatch(tr);
        });
    }, [
        view
    ]);
    const handleResize = (0, $cozmU.useCallback)((size, delta, direction)=>{
        if (direction === 'bottom' && allowVerticalResize) {
            // resizeRatio is forced to 1 for vertical drags below, so
            // delta.height already reflects the cursor movement 1:1 — no
            // need to divide. This keeps the bottom handle stuck to the
            // embed's bottom edge for centered embeds (where horizontal
            // resizeRatio is 2 to support symmetric L/R drag).
            const nextHeight = Math.max((0, $bfk7V.MIN_HEIGHT), Math.round(size.height + delta.height));
            const clampedHeight = effectiveMaxHeight !== undefined ? Math.min(effectiveMaxHeight, nextHeight) : nextHeight;
            fixedHeightRef.current = clampedHeight;
            bottomDraggedRef.current = true;
            setResizeHeight(clampedHeight);
            scheduleResizeFrame();
            return;
        }
        const newWidth = Math.round(size.width + delta.width);
        const effectiveMax = isNested && nestedContainerWidthRef.current !== null ? Math.min(maxWidth, nestedContainerWidthRef.current) : maxWidth;
        const clampedWidth = Math.max((0, $bfk7V.MIN_WIDTH), Math.min(newWidth, effectiveMax));
        setResizeWidth(clampedWidth);
        const isSideAligned = currentAlignment === 'left' || currentAlignment === 'right' || currentAlignment === 'wrap-left' || currentAlignment === 'wrap-right';
        if (!isNested && isSideAligned && clampedWidth > lineLength) {
            onAlignmentChange?.('center');
            if (view?.state && view?.dispatch) {
                // Re-resolve the live node by localId so we operate on the
                // current PMNode instance even if a transaction has landed
                // during the drag and shifted positions.
                const resolved = (0, $jI0jP.resolveLatestPosByLocalId)(view, target.localId);
                const liveNode = resolved?.node ?? target.node;
                if (liveNode) (0, $1WSjf.createUpdateAlignmentCommand)(pluginInjectionApi, 'center', liveNode)(view?.state, view?.dispatch);
            }
        }
        if (isGuidelineEnabled) {
            const layoutForGuidelines = (0, $bfk7V.mapAlignmentToLayout)(currentAlignment);
            const guidelineSnaps = (0, $lPlPa.getGuidelineSnaps)(guidelinesRef.current, lineLength, layoutForGuidelines);
            if (guidelineSnaps.snaps.x) {
                const { gap: gap, keys: activeGuidelineKeys } = (0, $ktOsK.findClosestSnap)(clampedWidth, guidelineSnaps.snaps.x, guidelineSnaps.guidelineReference, (0, $bfk7V.SNAP_GAP));
                lastSnappedGuidelineKeysRef.current = activeGuidelineKeys;
                const nextGuideLines = (0, $78UMD.getGuidelinesWithHighlights)(gap, (0, $bfk7V.SNAP_GAP), activeGuidelineKeys, guidelinesRef.current);
                view && pluginInjectionApi?.guideline?.actions?.displayGuideline(view)({
                    guidelines: nextGuideLines
                });
            }
            setSnaps({
                x: guidelineSnaps.snaps.x || []
            });
        }
    }, [
        maxWidth,
        isNested,
        lineLength,
        guidelinesRef,
        isGuidelineEnabled,
        currentAlignment,
        target,
        pluginInjectionApi,
        view,
        onAlignmentChange,
        allowVerticalResize,
        effectiveMaxHeight,
        scheduleResizeFrame
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!isResizing) return;
        if (embedDomElement) {
            embedDomElement.style.transition = 'none';
            if (isNested) {
                embedDomElement.style.width = '';
                embedDomElement.style.minWidth = '';
                embedDomElement.style.maxWidth = `${resizeWidth}px`;
                embedDomElement.style.setProperty((0, $bfk7V.CSS_VAR_NATIVE_EMBED_WIDTH), `${resizeWidth}px`);
            } else {
                // Write `--native-embed-width` FIRST — it's the cascade winner for
                // `.extension-container` width. Removing it even briefly causes
                // `width: var(--native-embed-width) !important` to resolve to
                // `auto` (full editor column width), producing a visible snap.
                embedDomElement.style.setProperty((0, $bfk7V.CSS_VAR_NATIVE_EMBED_WIDTH), `${resizeWidth}px`);
                embedDomElement.style.width = `${resizeWidth}px`;
                embedDomElement.style.minWidth = `${resizeWidth}px`;
                embedDomElement.style.maxWidth = `${resizeWidth}px`;
            }
            if (resizeHeight !== null) // Only force height for bottom drags; side drags let the child's
            // local height overrides flow through naturally.
            {
                if (bottomDraggedRef.current) {
                    embedDomElement.style.height = `${resizeHeight}px`;
                    embedDomElement.style.removeProperty('aspect-ratio');
                }
            }
        }
        const innerContainer = innerEmbedContainerRef.current;
        if (innerContainer) {
            innerContainer.style.width = `${resizeWidth}px`;
            if (resizeHeight !== null && bottomDraggedRef.current) {
                innerContainer.style.height = `${resizeHeight}px`;
                innerContainer.style.removeProperty('aspect-ratio');
            }
        }
    }, [
        isResizing,
        resizeWidth,
        resizeHeight,
        embedDomElement,
        isNested,
        activeResizeDirection
    ]);
    const handleResizeStop = (0, $cozmU.useCallback)((_size, _delta)=>{
        clearSelectedBorderSuppression();
        if (!(0, $hHNKT.getNativeEmbedShouldLockAspectRatio)(target.node)) try {
            target.container.dispatchEvent(new CustomEvent('native-embed-resize-state-change', {
                bubbles: true,
                detail: {
                    active: false,
                    localId: target.localId
                }
            }));
        } catch  {}
        const isFullWidthSnap = lastSnappedGuidelineKeysRef.current.some((key)=>key.startsWith('full_width'));
        const committedWidth = !isNested && isFullWidthSnap ? (0, $7Y8M5.akEditorFullWidthLayoutWidth) : resizeWidth;
        committedWidthRef.current = committedWidth;
        if (allowVerticalResize && bottomDraggedRef.current && aspectRatioRef.current === null && fixedHeightRef.current !== null && effectiveMaxHeight !== undefined && fixedHeightRef.current > effectiveMaxHeight) fixedHeightRef.current = effectiveMaxHeight;
         // fixedHeightRef was captured at drag-start; re-measure the live
        // height before clearing styles so we commit the correct value.
        const innerContainer = innerEmbedContainerRef.current;
        if (fixedHeightRef.current !== null && innerContainer && !bottomDraggedRef.current) try {
            const liveHeight = Math.round(innerContainer.getBoundingClientRect().height);
            if (liveHeight > 0) fixedHeightRef.current = liveHeight;
        } catch  {}
        if (embedDomElement) {
            embedDomElement.style.transition = ''; // Write `--native-embed-width` before clearing inline overrides —
            // same reason as the drag-time effect above.
            embedDomElement.style.setProperty((0, $bfk7V.CSS_VAR_NATIVE_EMBED_WIDTH), `${committedWidth}px`);
            embedDomElement.style.width = '';
            embedDomElement.style.minWidth = '';
            embedDomElement.style.setProperty('max-width', 'var(--ak-editor-max-container-width)');
            if (fixedHeightRef.current !== null) {
                embedDomElement.style.setProperty('height', `${fixedHeightRef.current}px`);
                embedDomElement.style.removeProperty('aspect-ratio');
            } else embedDomElement.style.setProperty('height', 'auto');
        }
        if (innerContainer) {
            innerContainer.style.width = '';
            if (fixedHeightRef.current !== null) {
                innerContainer.style.height = `${fixedHeightRef.current}px`;
                innerContainer.style.removeProperty('aspect-ratio');
            } else innerContainer.style.height = '';
        }
        innerEmbedContainerRef.current = null;
        view && pluginInjectionApi?.guideline?.actions?.displayGuideline(view)({
            guidelines: []
        });
        lastSnappedGuidelineKeysRef.current = []; // Helper: release this overlay's claim on the coordinator's resize
        // ownership. We pair start/stop by localId so the coordinator can
        // safely ignore stops for any embed other than the one currently
        // owning the resize (defends against unmount-cleanup races).
        const releaseResizeOwnership = ()=>{
            const startedLocalId = resizingStartedLocalIdRef.current;
            resizingStartedLocalIdRef.current = null;
            if (startedLocalId !== null) onResizeStop?.(startedLocalId);
        };
        if (!view) {
            setIsResizing(false);
            setResizeHeight(null);
            isResizingRef.current = false;
            setActiveResizeDirection(null);
            releaseResizeOwnership();
            return;
        } // Re-resolve the live node + position via localId so we operate on
        // the current PMNode instance even if a transaction has landed
        // during the drag and shifted positions. Cached `target.pos` is
        // only used as a fallback for the selection transfer below.
        const resolved = (0, $jI0jP.resolveLatestPosByLocalId)(view, target.localId);
        const liveNode = resolved?.node ?? target.node;
        if (!liveNode) {
            setIsResizing(false);
            setResizeHeight(null);
            isResizingRef.current = false;
            setActiveResizeDirection(null);
            releaseResizeOwnership();
            return;
        }
        const committedHeight = aspectRatioRef.current !== null ? Math.round(committedWidth * aspectRatioRef.current) : fixedHeightRef.current ?? undefined;
        if (committedHeight !== undefined) committedHeightRef.current = committedHeight;
        else committedHeightRef.current = null;
         // Pass `scrollIntoView: false` through to the extension `doc.update`
        // transaction so the width-commit tx never triggers PM's
        // auto-scroll-to-selection behaviour. Without this opt the
        // underlying `tr.replaceWith(...)` lands while PM selection is
        // still on a previously-selected embed (e.g. one further up the
        // page), and PM scrolls that stale selection back into view on
        // mouseup.
        (0, $4xLGC.createUpdateWidthCommand)(pluginInjectionApi, committedWidth, liveNode, committedHeight, {
            scrollIntoView: false
        })(view.state, view.dispatch); // -----------------------------------------------------------------
        // Selection transfer: only at mouseup. With the continuous-overlay
        // architecture the coordinator renders one EmbedResizeOverlay per
        // embed (keyed by localId, with `mode` as a prop), so transferring
        // selection here does NOT cause the overlay to remount — it only
        // flips this overlay's mode prop. This means we can dispatch the
        // selection transfer synchronously without a flicker.
        //
        // Skip the dispatch if the selection is already on this node so we
        // don't add a spurious history entry.
        // -----------------------------------------------------------------
        try {
            const { state: selState, dispatch: selDispatch } = view;
            const currentSelection = selState.selection;
            const resolvedSelectionPos = resolved?.pos ?? target.pos;
            const isAlreadySelected = currentSelection instanceof (0, $kCECX.NodeSelection) && currentSelection.from === resolvedSelectionPos;
            if (!isAlreadySelected) {
                const selectionTr = selState.tr;
                selectionTr.setSelection((0, $kCECX.NodeSelection).create(selState.doc, resolvedSelectionPos));
                selectionTr.setMeta('scrollIntoView', false);
                selDispatch(selectionTr);
            }
        } catch  {}
        const { state: state, dispatch: dispatch } = view;
        const tr = state.tr;
        tr.setMeta((0, $lG1Bc.NATIVE_EMBED_PLUGIN_IS_RESIZING_KEY), false);
        tr.setMeta('is-resizer-resizing', false);
        tr.setMeta('scrollIntoView', false);
        dispatch(tr);
        requestAnimationFrame(()=>{
            setIsResizing(false);
            setResizeHeight(null);
            isResizingRef.current = false;
            setActiveResizeDirection(null);
            releaseResizeOwnership();
        });
        aspectRatioRef.current = null;
        fixedHeightRef.current = null;
        if (resizeFrameRafRef.current !== null) {
            cancelAnimationFrame(resizeFrameRafRef.current);
            resizeFrameRafRef.current = null;
        }
        bottomDraggedRef.current = false;
    }, [
        target,
        pluginInjectionApi,
        view,
        embedDomElement,
        resizeWidth,
        isNested,
        onResizeStop,
        allowVerticalResize,
        effectiveMaxHeight,
        clearSelectedBorderSuppression
    ]); // -----------------------------------------------------------------------
    // Early return — nothing to render
    // -----------------------------------------------------------------------
    // The coordinator gates mounting:
    // - selected mode: overlay is mounted whenever an embed is selected.
    // - hover mode:    overlay is mounted only while the coordinator says the
    //                  embed is hovered (so we should be visible immediately).
    // We always render once we have a measured rect.
    if (!nodeRect) return null;
    const isRightTypeAligned = currentAlignment === 'right' || currentAlignment === 'wrap-right';
    const isLeftTypeAligned = currentAlignment === 'left' || currentAlignment === 'wrap-left';
    const enableRightHandle = !handlesBlocked && currentAlignment !== 'right' && currentAlignment !== 'wrap-right';
    const enableLeftHandle = !handlesBlocked && currentAlignment !== 'left' && currentAlignment !== 'wrap-left';
    const enableBottomHandle = !handlesBlocked && allowVerticalResize;
    let wrapperLeft;
    const actualNestedMax = nestedContainerWidthRef.current;
    const overlayWidth = isResizing ? isNested && actualNestedMax !== null ? Math.min(resizeWidth, actualNestedMax) : resizeWidth : Math.round(nodeRect.width);
    const overlayHeight = isResizing && resizeHeight !== null ? resizeHeight : Math.round(nodeRect.height);
    if (isResizing && embedDomElement && (isLeftTypeAligned || isRightTypeAligned)) {
        const portalRect = portalTarget.getBoundingClientRect();
        const embedRect = embedDomElement.getBoundingClientRect();
        wrapperLeft = embedRect.left - portalRect.left + portalTarget.scrollLeft;
    } else if (isResizing && embedDomElement) {
        const portalRect = portalTarget.getBoundingClientRect();
        const embedRect = embedDomElement.getBoundingClientRect();
        if (isNested) wrapperLeft = embedRect.left - portalRect.left + portalTarget.scrollLeft;
        else {
            const centerX = embedRect.left - portalRect.left + portalTarget.scrollLeft + embedRect.width / 2;
            wrapperLeft = centerX - overlayWidth / 2;
        }
    } else if (isRightTypeAligned || isLeftTypeAligned) wrapperLeft = nodeRect.left;
    else {
        const centerX = nodeRect.left + nodeRect.width / 2;
        wrapperLeft = centerX - overlayWidth / 2;
    }
    const resizerWrapperDynamicStyles = {
        top: nodeRect.top,
        left: wrapperLeft,
        width: overlayWidth
    }; // Visibility rules:
    // - selected overlay: handles always visible (R1) — independent of hover
    // - hover overlay: only mounted by the coordinator while the embed is
    //   hovered, so handles should be visible whenever it is mounted (R2/R3)
    const isHandleVisible = !handlesBlocked && !!nodeRect.height;
    const resizerMaxWidthBase = isNested && actualNestedMax !== null ? actualNestedMax : maxWidth; // While idle, the hover overlay is only drawing handles. If the layout-column
    // max is narrower than the measured frame, re-resizable visually clamps the
    // rail inward over the embed scrollbar, so keep display max at the measured
    // width. Active drags still use the real nested clamp.
    const resizerMaxWidth = mode === 'hover' && !isResizing ? Math.max(resizerMaxWidthBase, overlayWidth) : resizerMaxWidthBase; // re-resizable applies a single resizeRatio to both axes. For centered
    // embeds the horizontal handles need ratio 2 (one drag = symmetric L/R
    // expansion), but the bottom handle is asymmetric (only the bottom edge
    // moves) and must use ratio 1 so it stays glued to the embed's bottom.
    const resizeRatio = activeResizeDirection === 'bottom' ? 1 : currentAlignment === 'center' ? 2 : 1; /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic overlay positioning from DOM measurements */ 
    const overlay = /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "native-embed-resizer",
        "data-overlay-mode": mode,
        "data-embed-local-id": target.localId,
        role: "presentation",
        onMouseDown: handleWrapperMouseDown
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        style: resizerWrapperDynamicStyles,
        "data-testid": "native-embed-resizer-wrapper",
        className: (0, $hekY6.default)([
            "_kqswstnw _lcxv1wug _w4h2stnw _1oc91wug _6ndbom82 _omtm1t8v"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $aWssQ.default /* eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed) */ ), {
        enable: {
            left: enableLeftHandle,
            right: enableRightHandle,
            bottom: enableBottomHandle
        },
        width: overlayWidth,
        height: allowVerticalResize ? overlayHeight : undefined,
        minWidth: (0, $bfk7V.MIN_WIDTH),
        maxWidth: resizerMaxWidth,
        minHeight: allowVerticalResize ? (0, $bfk7V.MIN_HEIGHT) : undefined,
        maxHeight: effectiveMaxHeight,
        handleResizeStart: handleResizeStart,
        handleResize: handleResize,
        handleResizeStop: handleResizeStop,
        snapGap: (0, $bfk7V.SNAP_GAP),
        snap: snaps,
        resizeRatio: resizeRatio,
        isHandleVisible: !!isHandleVisible,
        handleHighlight: "full-height",
        handlePositioning: "adjacent",
        handleStyles: bottomHandleStyles,
        "data-testid": (0, $bfk7V.resizerNextTestId)
    }, (()=>{
        const placeholderHeight = (()=>{
            if (isResizing && resizeHeight !== null) return resizeHeight;
            if (isResizing && aspectRatioRef.current !== null) return Math.round(resizeWidth * aspectRatioRef.current);
             // When not resizing, prefer the live DOM height — it reflects
            // what the embed is actually rendering at. Only fall back to
            // an aspectRatio calculation when the DOM height is unavailable.
            if (nodeRect.height) return nodeRect.height;
            const storedAspectRatio = (0, $ljOiP.getParameters)(target.node.attrs.parameters, 'aspectRatio');
            if (storedAspectRatio != null && storedAspectRatio > 0) // storedAspectRatio is width/height; height = width / aspectRatio.
            // Use overlayWidth (actual DOM width) so the placeholder matches
            // the visible embed proportions.
            return Math.round(overlayWidth / storedAspectRatio);
            return 600; // TODO: CNS-24595 - 600 is a hack, it can lose the select in cases and just falls back to this. We can do better
        })();
        return /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic height from DOM
        , {
            style: {
                height: placeholderHeight
            },
            className: (0, $hekY6.default)([
                "_1bsb1osq _lcxvglyw"
            ])
        });
    })()))); /* eslint-enable @atlaskit/ui-styling-standard/enforce-style-prop */ 
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(overlay, portalTarget);
};
module.exports["EmbedResizeOverlay"] = $470ca23c824bbe28$export$a777b135e925da43;

});

parcelRegister("lG1Bc", function(module, exports) {
const $d14336950ceda964$export$721d3977e29c986e = 'nativeEmbedPlugin.isResizing';
const $d14336950ceda964$export$18e96586e523cafb = 'nativeEmbedPlugin.resizing-width';
module.exports["NATIVE_EMBED_PLUGIN_IS_RESIZING_KEY"] = $d14336950ceda964$export$721d3977e29c986e;

});

parcelRegister("jI0jP", function(module, exports) {
const $5b360b0052eb7219$export$98f6cdba475114d7 = (view, localId)=>{
    if (!view || !localId) return null;
    let result = null;
    try {
        view.state.doc.descendants((node, pos)=>{
            if (result) return false;
            if (node.attrs?.localId === localId) {
                result = {
                    pos: pos,
                    node: node
                };
                return false;
            }
            return true;
        });
    } catch  {
        return null;
    }
    return result;
};
module.exports["resolveLatestPosByLocalId"] = $5b360b0052eb7219$export$98f6cdba475114d7;

});

parcelRegister("5h9gN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $5fec31b17069136f$var$NATIVE_EMBED_LOADING_ATTRIBUTE = 'data-native-embed-loading';
const $5fec31b17069136f$var$getObservedElement = (container, innerContainer)=>{
    if (innerContainer?.hasAttribute($5fec31b17069136f$var$NATIVE_EMBED_LOADING_ATTRIBUTE)) return innerContainer;
    return container?.querySelector(`[${$5fec31b17069136f$var$NATIVE_EMBED_LOADING_ATTRIBUTE}]`) ?? null;
};
const $5fec31b17069136f$var$readLoadingState = (container, innerContainer)=>{
    return $5fec31b17069136f$var$getObservedElement(container, innerContainer)?.getAttribute($5fec31b17069136f$var$NATIVE_EMBED_LOADING_ATTRIBUTE) === 'true';
};
const $5fec31b17069136f$export$14197b94b2594c4e = (container, innerContainer)=>{
    const observedElement = $5fec31b17069136f$var$getObservedElement(container, innerContainer);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(()=>$5fec31b17069136f$var$readLoadingState(container, innerContainer));
    (0, $cozmU.useEffect)(()=>{
        if (!observedElement || typeof MutationObserver === 'undefined') {
            setIsLoading(false);
            return;
        }
        const updateLoadingState = ()=>{
            setIsLoading(observedElement.getAttribute($5fec31b17069136f$var$NATIVE_EMBED_LOADING_ATTRIBUTE) === 'true');
        };
        updateLoadingState();
        const observer = new MutationObserver(updateLoadingState);
        observer.observe(observedElement, {
            attributes: true,
            attributeFilter: [
                $5fec31b17069136f$var$NATIVE_EMBED_LOADING_ATTRIBUTE
            ]
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        observedElement
    ]);
    return isLoading;
};
module.exports["useNativeEmbedLoadingState"] = $5fec31b17069136f$export$14197b94b2594c4e;

});

parcelRegister("bfk7V", function(module, exports) {

var $7Y8M5 = parcelRequire("7Y8M5");


var $fqVYq = parcelRequire("fqVYq");

const $47f918af983fe56e$export$de18d2ff56094455 = (containerWidth, editorAppearance)=>{
    const fullPagePadding = editorAppearance === 'full-page' && containerWidth <= (0, $7Y8M5.akEditorFullPageNarrowBreakout) && (0, $fqVYq.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $7Y8M5.akEditorGutterPaddingReduced) : (0, $7Y8M5.akEditorGutterPaddingDynamic)();
    const fullWidthPadding = editorAppearance === 'full-page' ? fullPagePadding * 2 : (0, $7Y8M5.akEditorGutterPadding) * 2;
    return Math.min(containerWidth - fullWidthPadding, (0, $7Y8M5.akEditorFullWidthLayoutWidth));
};
const $47f918af983fe56e$export$1d9fdc71b83a8eac = 200;
const $47f918af983fe56e$export$70d33a2740b029ae = 200;
const $47f918af983fe56e$export$daa2496be4772440 = 748;
const $47f918af983fe56e$export$6cdb476c834bc60 = 8;
const $47f918af983fe56e$export$a8e17888670204c = '--native-embed-width';
const $47f918af983fe56e$export$fe623d3106c02058 = 'nativeEmbed.resizerNext.testid';
const $47f918af983fe56e$export$2afbeef35ab767b0 = (alignment)=>{
    if (alignment === 'left') return 'align-start';
    if (alignment === 'right') return 'align-end';
    // 'center', 'wrap-left', 'wrap-right' pass through unchanged
    return alignment;
};
module.exports["calcMaxWidth"] = $47f918af983fe56e$export$de18d2ff56094455;
module.exports["MIN_WIDTH"] = $47f918af983fe56e$export$1d9fdc71b83a8eac;
module.exports["MIN_HEIGHT"] = $47f918af983fe56e$export$70d33a2740b029ae;
module.exports["MAX_HEIGHT"] = $47f918af983fe56e$export$daa2496be4772440;
module.exports["SNAP_GAP"] = $47f918af983fe56e$export$6cdb476c834bc60;
module.exports["CSS_VAR_NATIVE_EMBED_WIDTH"] = $47f918af983fe56e$export$a8e17888670204c;
module.exports["resizerNextTestId"] = $47f918af983fe56e$export$fe623d3106c02058;
module.exports["mapAlignmentToLayout"] = $47f918af983fe56e$export$2afbeef35ab767b0;

});

parcelRegister("5pQ1Y", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $676464c7222bdee0$export$d84a6ddaa8e6e9d9 = /*#__PURE__*/ (0, $cozmU.createContext)({
    refetchContent: false
});
$676464c7222bdee0$export$d84a6ddaa8e6e9d9.displayName = 'ContentRefetchContext';
const $676464c7222bdee0$export$dfd2d999f6a2731 = /*#__PURE__*/ (0, $cozmU.createContext)({
    setRefetchContent: ()=>{}
});
$676464c7222bdee0$export$dfd2d999f6a2731.displayName = 'ContentRefetchDispatchContext';
const $676464c7222bdee0$export$cfa813593f7b7ba = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children } = t0;
    const [refetchContent, setRefetchContent] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== refetchContent) {
        t1 = {
            refetchContent: refetchContent
        };
        $[0] = refetchContent;
        $[1] = t1;
    } else t1 = $[1];
    const providerValue = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            setRefetchContent: (shouldRefetchContent)=>setRefetchContent(shouldRefetchContent)
        };
        $[2] = t2;
    } else t2 = $[2];
    const dispatchProviderValue = t2;
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($676464c7222bdee0$export$dfd2d999f6a2731.Provider, {
            value: dispatchProviderValue
        }, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== providerValue || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($676464c7222bdee0$export$d84a6ddaa8e6e9d9.Provider, {
            value: providerValue
        }, t3);
        $[5] = providerValue;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
};
const $676464c7222bdee0$export$68e22604851d391b = ()=>{
    return (0, $cozmU.useContext)($676464c7222bdee0$export$d84a6ddaa8e6e9d9);
};
const $676464c7222bdee0$export$8ebf7a2378ada555 = ()=>{
    return (0, $cozmU.useContext)($676464c7222bdee0$export$dfd2d999f6a2731);
};
module.exports["ContentRefetchProvider"] = $676464c7222bdee0$export$cfa813593f7b7ba;
module.exports["useContentRefetch"] = $676464c7222bdee0$export$68e22604851d391b;
module.exports["useContentRefetchDispatch"] = $676464c7222bdee0$export$8ebf7a2378ada555;

});

parcelRegister("gurMq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $emtVP = parcelRequire("emtVP");

function $c813792041e0815a$export$814a52618fb8e5d7({ enabled: enabled = true, cloudId: cloudId } = {}) {
    const [showFyi, setShowFyi] = (0, $cozmU.useState)(false);
    const [agent, setAgent] = (0, $cozmU.useState)();
    // Per-editor cache of mention-id → resolved agent identity (or null when the id
    // is not an agent). Guarantees each distinct id hits the agents endpoint at most
    // once. `inFlight` dedupes concurrent resolutions for the same id.
    const cacheRef = (0, $cozmU.useRef)(new Map());
    const inFlightRef = (0, $cozmU.useRef)(new Set());
    const abortControllersRef = (0, $cozmU.useRef)(new Set());
    // Ids of the latest non-fast-path mention candidates, so async resolutions can
    // re-evaluate visibility against the current doc.
    const latestCandidateIdsRef = (0, $cozmU.useRef)([]);
    const mountedRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>{
        mountedRef.current = true;
        // Capture the (stable, never-reassigned) ref-held collections so the cleanup
        // operates on the same objects without reading `.current` at teardown
        // (satisfies react-hooks/exhaustive-deps).
        const abortControllers = abortControllersRef.current;
        const inFlight = inFlightRef.current;
        return ()=>{
            mountedRef.current = false;
            abortControllers.forEach((controller)=>controller.abort());
            abortControllers.clear();
            inFlight.clear();
        };
    }, []);
    // Re-derive showFyi/agent from the cache for the current doc's mention ids.
    const applyFromCache = (0, $cozmU.useCallback)(()=>{
        const knownAgent = latestCandidateIdsRef.current.map((id)=>cacheRef.current.get(id)).find((value)=>!!value);
        setShowFyi(!!knownAgent);
        setAgent((prev)=>{
            if (!knownAgent) return undefined;
            return prev?.id === knownAgent.id && prev?.name === knownAgent.name && prev?.agentNamedId === knownAgent.agentNamedId ? prev : knownAgent;
        });
    }, []);
    const onContentChange = (0, $cozmU.useCallback)((adf)=>{
        if (!enabled) return;
        // Fast path — a freshly-typed agent mention still carries userType==='APP'.
        const fastPath = (0, $emtVP.extractAgentMentionFromAdf)(adf);
        if (fastPath) {
            const id = fastPath.agentId;
            latestCandidateIdsRef.current = [];
            setShowFyi(true);
            // Show the name immediately; reuse any avatar key already resolved for this id.
            const cached = cacheRef.current.get(id);
            setAgent((prev)=>{
                const next = {
                    id: id,
                    name: fastPath.agentName,
                    agentNamedId: cached?.agentNamedId
                };
                return prev?.id === next.id && prev?.name === next.name && prev?.agentNamedId === next.agentNamedId ? prev : next;
            });
            // The fast path is otherwise network-free, so an OOTB agent (e.g. Canva) would render the
            // generic fallback avatar. Resolve once (cached) to enrich with the real avatar key. We
            // already KNOW this is an agent (userType==='APP'), so a failed/empty resolve keeps the
            // baseline rather than hiding the nudge.
            if (cloudId && !cacheRef.current.has(id) && !inFlightRef.current.has(id)) {
                inFlightRef.current.add(id);
                const controller = new AbortController();
                abortControllersRef.current.add(controller);
                (0, $emtVP.resolveAgentFromMentionId)(id, cloudId, controller.signal).then((resolved)=>{
                    abortControllersRef.current.delete(controller);
                    inFlightRef.current.delete(id);
                    if (!mountedRef.current) return;
                    // Cache the result — even null — so a failed/non-agent resolution isn't
                    // retried on every subsequent keystroke (the `.has(id)` guard short-circuits).
                    cacheRef.current.set(id, resolved);
                    if (!resolved) return;
                    setAgent((prev)=>prev?.id === id ? {
                            ...prev,
                            agentNamedId: resolved.agentNamedId
                        } : prev);
                }).catch(()=>{
                    abortControllersRef.current.delete(controller);
                    inFlightRef.current.delete(id);
                });
            }
            return;
        }
        // Fallback — userType may have been stripped (paste / reloaded comment).
        // Only mentions that have LOST their userType need id-resolution; live
        // mentions carry a userType (APP is handled by the fast path above, any
        // other type is not an agent), so they are skipped to avoid wasted calls.
        const candidateIds = (0, $emtVP.extractUnresolvedMentionIds)(adf);
        latestCandidateIdsRef.current = candidateIds;
        // Reflect anything already cached immediately (no flicker, no refetch).
        applyFromCache();
        // The async fallback needs a cloudId to call the agents endpoint.
        if (!cloudId) return;
        for (const id of candidateIds){
            if (cacheRef.current.has(id) || inFlightRef.current.has(id)) continue; // already resolved, or a resolution is already in flight
            inFlightRef.current.add(id);
            const controller = new AbortController();
            abortControllersRef.current.add(controller);
            (0, $emtVP.resolveAgentFromMentionId)(id, cloudId, controller.signal).then((resolved)=>{
                abortControllersRef.current.delete(controller);
                inFlightRef.current.delete(id);
                if (!mountedRef.current) return;
                cacheRef.current.set(id, resolved);
                applyFromCache();
            }).catch(()=>{
                // resolveAgentFromMentionId is not expected to reject (it catches
                // internally), but guard defensively so a future refactor — or a
                // throw from applyFromCache — can't surface an unhandled rejection
                // or leave the id stuck in-flight. The nudge is best-effort.
                abortControllersRef.current.delete(controller);
                inFlightRef.current.delete(id);
            });
        }
    }, [
        enabled,
        cloudId,
        applyFromCache
    ]);
    return (0, $cozmU.useMemo)(()=>({
            showFyi: showFyi,
            agent: agent,
            onContentChange: onContentChange
        }), [
        showFyi,
        agent,
        onContentChange
    ]);
}
module.exports["useAgentMentionFyiNudge"] = $c813792041e0815a$export$814a52618fb8e5d7;

});

parcelRegister("4rKYp", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $016f78fedc012cce$export$c82fcdcb4a4bd17 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "YwMBi",
    name: "AgentMentionFyiNudgeAsync",
    loader: async ()=>(await (parcelRequire("3mLV0"))).AgentMentionFyiNudge
});
module.exports["AgentMentionFyiNudgeAsync"] = $016f78fedc012cce$export$c82fcdcb4a4bd17;

});

parcelRegister("3mLV0", function(module, exports) {

let $273898c62ad6016a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $273898c62ad6016a$var$load("7EorR"),
    $273898c62ad6016a$var$load("jqoep"),
    $273898c62ad6016a$var$load("l64sb")
]).then(()=>parcelRequire('kz0zp'));

});

parcelRegister("ag51I", function(module, exports) {

var $49xGN = parcelRequire("49xGN");


var $308Wd = parcelRequire("308Wd");


var $6mKj3 = parcelRequire("6mKj3");


var $kgNLQ = parcelRequire("kgNLQ");

// This hook returns a mutation function to create a new comment on an object. Because the new
// Comments Data Manager caches all the data for comments in Relay, we need to define the mutation
// here so that the cache can be updated fully when a new comment is created - and that means the
// mutation needs to return the full comment data structure that we are using in the returned query
// part of the mutation.  Since that returned query is quite large, we define it here in its own
// hook to avoid having it in many places in the codebase - which makes the code harder to read and
// could lead to the multiple copies getting out of sync.
// Data Mutation Definition:
// Unfortunately our Relay-friendly type generation tools don't support using GQL fragments yet -
// but in order to keep the definition of the comment fields in sync (so the cache update fragment
// is always in sync with the full query) we will need to manually make any changes to one
// definition in any others as well, until our tooling supports fragments and then we move to a
// more fragmented-based approach.  Note there are also comment queries or fragments in the
// following files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data/src/hooks/useCommentById.ts
// - next/packages/comments-data-manager/src/updateCommentInCache.ts
// - next/packages/comments-data-manager/src/useCreateInlineCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineReplyMutation.ts
// - next/packages/object-comments/src/components/ObjectCommentContainer.tsx
const $8cba0eaacdb447e5$var$CreateObjectCommentMutation = (0, $49xGN.default);
const $8cba0eaacdb447e5$export$e30f6438d916be51 = ({ userId: userId, displayName: displayName, adf: adf, pageId: pageId, parentCommentId: parentCommentId })=>{
    const nowISOString = new Date().toISOString();
    return {
        createFooterComment: {
            author: {
                __typename: 'KnownUser',
                accountId: userId,
                displayName: displayName,
                permissionType: null,
                profilePicture: {
                    path: userId ? `/wiki/aa-avatar/${userId}` : '',
                    __typename: 'Icon'
                },
                type: 'known'
            },
            body: {
                value: JSON.stringify(adf),
                __typename: 'DocumentBody'
            },
            container: {
                id: pageId,
                __typename: 'Content'
            },
            contentStatus: 'current',
            createdAt: {
                value: '',
                __typename: 'ConfluenceDate'
            },
            createdAtNonLocalized: nowISOString,
            // this is required to correctly sort comments
            id: (0, $kgNLQ.OPTIMISTIC_SAVE_COMMENT_ID),
            links: {
                editui: null,
                webui: null,
                __typename: 'Map_LinkType_String'
            },
            location: {
                __typename: 'FooterComment',
                type: 'FOOTER',
                commentResolveProperties: {
                    resolved: false,
                    resolvedFriendlyDate: null,
                    resolvedTime: null,
                    resolvedUser: null,
                    __typename: 'InlineCommentResolveProperties'
                }
            },
            parentId: parentCommentId,
            permissions: {
                isEditable: true,
                isRemovable: true,
                isResolvable: true,
                __typename: 'CommentPermissions'
            },
            version: {
                by: {
                    __typename: 'KnownUser',
                    accountId: userId,
                    displayName: displayName,
                    type: 'user'
                },
                friendlyWhen: null,
                when: nowISOString,
                // this is required to show the creation time and tooltip correctly
                number: 1,
                __typename: 'Version'
            },
            __typename: 'Comment'
        }
    };
};
const $8cba0eaacdb447e5$export$14bad9f468eeedfb = ()=>{
    const [createObjectCommentFn] = (0, $308Wd.useMutationInterop)($8cba0eaacdb447e5$var$CreateObjectCommentMutation, {
        ...(0, $kgNLQ.buildMutationContextForNoNetworkError)(),
        __callerPackage__: "comments-data-manager"
    });
    return createObjectCommentFn;
};
const $8cba0eaacdb447e5$export$be067408524a8736 = (commentData)=>{
    return commentData ? {
        ...commentData,
        contributors: [],
        replies: [],
        reactionsSummary: (0, $6mKj3.expValEquals)('confluence_fe_use_create_comment_exclude_reactions', 'isEnabled', true) ? (0, $kgNLQ.emptyReactionsSummary) : commentData.reactionsSummary ?? (0, $kgNLQ.emptyReactionsSummary)
    } : // @ts-expect-error - FIXME: This error was surfaced after enabling the `typescriptExcludeUndefinedFromNullableUnion`
    // Relay compiler option. Previously, `undefined` was incorrectly included in nullable unions in generated types; this option removes it. The owning team should fix this properly.
    undefined;
};
module.exports["getOptimisticResponse"] = $8cba0eaacdb447e5$export$e30f6438d916be51;
module.exports["useCreateObjectCommentMutation"] = $8cba0eaacdb447e5$export$14bad9f468eeedfb;
module.exports["addEmptyObjectRepliesAndReactions"] = $8cba0eaacdb447e5$export$be067408524a8736;

});

parcelRegister("49xGN", function(module, exports) {
/**
 * @generated SignedSource<<9f6362bdef976f1891cc85a14210cfed>>
 * @relayHash e4c493ec197fdfb6eb597c1e5cc6c430
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ec5d148a6bf1b0bbf739ad3280e032c82fd08256cc50a97dc2063f7726739d5e
const $2b92f41c42f85596$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeReactionsSummary"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v7 = {
        "kind": "ScalarField",
        "name": "type"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v9 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v11 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v12 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v13 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v14 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "createFooterComment",
            "plural": false,
            "selections": [
                v4 /*: any*/ ,
                {
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "profilePicture",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        v7 /*: any*/ ,
                        v8 /*: any*/ 
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "representation",
                            "value": "ATLAS_DOC_FORMAT"
                        }
                    ],
                    "concreteType": "DocumentBody",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": v9 /*: any*/ ,
                    "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "container",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ 
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "contentStatus"
                },
                {
                    "concreteType": "ConfluenceDate",
                    "kind": "LinkedField",
                    "name": "createdAt",
                    "plural": false,
                    "selections": v9 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "createdAtNonLocalized"
                },
                {
                    "concreteType": "Map_LinkType_String",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "name": "location",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v7 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "InlineCommentResolveProperties",
                                    "kind": "LinkedField",
                                    "name": "commentResolveProperties",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "FooterComment"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "inlineMarkerRef"
                                },
                                {
                                    "concreteType": "InlineCommentResolveProperties",
                                    "kind": "LinkedField",
                                    "name": "inlineResolveProperties",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDangling"
                                        },
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "inlineText"
                                }
                            ],
                            "type": "InlineComment"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "parentId"
                },
                {
                    "concreteType": "CommentPermissions",
                    "kind": "LinkedField",
                    "name": "permissions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEditable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isRemovable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isResolvable"
                        }
                    ]
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "by",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v6 /*: any*/ ,
                                v8 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "friendlyWhen"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "when"
                        }
                    ]
                },
                {
                    "condition": "includeReactionsSummary",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "childType",
                                    "value": "comment"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "contentType",
                                    "value": "page"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "pageId",
                                    "variableName": "pageId"
                                }
                            ],
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "reactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "ari"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "containerAri"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "reactionsCount"
                                },
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "emojiId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "reacted"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCreateObjectCommentMutation",
            "selections": v14 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCreateObjectCommentMutation",
            "selections": v14 /*: any*/ 
        },
        "params": {
            "cacheID": "e4c493ec197fdfb6eb597c1e5cc6c430",
            "id": "ec5d148a6bf1b0bbf739ad3280e032c82fd08256cc50a97dc2063f7726739d5e",
            "metadata": {},
            "name": "useCreateObjectCommentMutation",
            "operationKind": "mutation",
            "text": "mutation useCreateObjectCommentMutation($pageId:ID!,$cloudId:ID!,$input:CreateCommentInput!,$includeReactionsSummary:Boolean!){createFooterComment(cloudId:$cloudId,input:$input){id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeReactionsSummary){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}}}"
        }
    };
}();
$2b92f41c42f85596$var$node.hash = "c1ecd7a7f6b08a2552cfea3da74fecee";
var $2b92f41c42f85596$export$2e2bcd8739ae039 = $2b92f41c42f85596$var$node;
module.exports["default"] = $2b92f41c42f85596$export$2e2bcd8739ae039;

});

parcelRegister("87CZC", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $lSFbL = parcelRequire("lSFbL");


var $7W8i8 = parcelRequire("7W8i8");


var $9rE3H = parcelRequire("9rE3H");


var $b1hSc = parcelRequire("b1hSc");


var $cD1qu = parcelRequire("cD1qu");


var $irVI7 = parcelRequire("irVI7");


var $56QzY = parcelRequire("56QzY");


var $en1dX = parcelRequire("en1dX");


var $gtj7V = parcelRequire("gtj7V");


var $2i3To = parcelRequire("2i3To");


var $ftXPY = parcelRequire("ftXPY");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");

const $80b47fa0b569ef69$var$logger = (0, $7W8i8.getLogger)('page-comments-queries');
const $80b47fa0b569ef69$export$a02bedef5e94d20c = (actionType, queryVariables, isReactionsEnabled, commentId)=>(_cache, result)=>{
        // If the mutation fails, don't do anything
        if (!result || !result.data) return;
        const { pageId: pageId, type: type } = queryVariables;
        try {
            const singleType = type && type.length >= 1 ? type[0] : undefined;
            const consistentQueryVariables = (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
                pageId: pageId,
                type: singleType
            });
            // Update the comments panel data
            const commentsPanelCacheResponse = (0, $l1uFv.readQueryInterop)({
                query: (0, $b1hSc.default),
                variables: consistentQueryVariables,
                __callerPackage__: "page-comments-queries"
            });
            if (commentsPanelCacheResponse) {
                const panelNodes = commentsPanelCacheResponse?.comments?.nodes || [];
                if (actionType === 'delete') {
                    // Remove the returned commentId from the cache and reset it
                    const idxToRemove = panelNodes.findIndex((comment)=>comment?.id === commentId);
                    if (idxToRemove !== -1) panelNodes.splice(idxToRemove, 1);
                } else {
                    const mutationResult = {
                        ...result.data.createFooterComment,
                        replies: [],
                        contributors: []
                    };
                    // Add the new reply entry to the cache and reset it
                    panelNodes.push(mutationResult);
                }
                (0, $fEmGS.writeQueryInterop)({
                    query: (0, $b1hSc.default),
                    variables: consistentQueryVariables,
                    data: commentsPanelCacheResponse,
                    __callerPackage__: "page-comments-queries"
                });
            }
        } catch (err) {
            $80b47fa0b569ef69$var$logger.error`An Error occurred when updating comments panel cache for ${actionType} - ${err}`;
        }
        try {
            const commentsSectionQuery = isReactionsEnabled ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery);
            // Update the comments section data
            const commentsSectionCacheResponse = (0, $l1uFv.readQueryInterop)({
                query: commentsSectionQuery,
                variables: {
                    contentId: pageId,
                    offset: '',
                    first: (0, $2i3To.DEFAULT_LIMIT)
                },
                __callerPackage__: "page-comments-queries"
            });
            if (commentsSectionCacheResponse) {
                // grab the parent comment for the comments panel
                const commentSectionCacheDataClone = {
                    ...commentsSectionCacheResponse
                };
                const commentEdges = [
                    ...commentSectionCacheDataClone?.comments?.edges || []
                ];
                if (actionType === 'delete') {
                    // Find the last index of the top level comment to delete
                    const indexToDelete = commentEdges?.findIndex((edge)=>edge?.node?.id === commentId);
                    if (indexToDelete !== -1) commentEdges.splice(indexToDelete, 1);
                } else {
                    const mutationResult = {
                        ...result.data.createFooterComment
                    };
                    // As far as I can tell, this is always called w/o reactions enabled
                    // This maps the mutation result we get to the cache object that's expected by the comments section query
                    const cacheCommentObject = {
                        id: mutationResult.id,
                        ancestors: [],
                        author: {
                            ...mutationResult.author,
                            type: 'known'
                        },
                        body: mutationResult.body,
                        contentStatus: mutationResult.contentStatus,
                        links: {
                            webui: mutationResult.links.webui,
                            // @ts-ignore
                            __typename: mutationResult.links.__typename
                        },
                        location: mutationResult.location,
                        parentId: mutationResult.parentId,
                        permissions: mutationResult.permissions,
                        version: {
                            ...mutationResult.version,
                            friendlyWhen: 'Just now',
                            // TODO: Maybe replace this with the actual date
                            by: {
                                type: 'user',
                                displayName: '',
                                accountId: '',
                                __typename: 'User'
                            },
                            __typename: 'Version'
                        },
                        __typename: 'Comment'
                    };
                    // The cache will throw an error if we don't do this ¯\_(ツ)_/¯
                    const cacheContentDeepCopy = JSON.parse(JSON.stringify(cacheCommentObject));
                    const newEdge = {
                        cursor: (commentEdges.length - 1).toString(),
                        node: cacheContentDeepCopy,
                        __typename: 'CommentEdge'
                    };
                    const insertAfterIndex = commentEdges.length - 1;
                    // Put the new reply in the array
                    commentEdges.splice(insertAfterIndex + 1, 0, newEdge);
                }
                (0, $fEmGS.writeQueryInterop)({
                    query: commentsSectionQuery,
                    variables: {
                        contentId: pageId,
                        offset: '',
                        first: (0, $2i3To.DEFAULT_LIMIT)
                    },
                    data: {
                        ...commentSectionCacheDataClone,
                        comments: {
                            ...commentSectionCacheDataClone.comments,
                            totalCount: commentEdges.length,
                            pageInfo: {
                                ...commentSectionCacheDataClone.comments?.pageInfo,
                                endCursor: actionType === 'delete' ? '' : (commentEdges.length - 1).toString(),
                                hasNextPage: false
                            },
                            edges: commentEdges
                        }
                    },
                    __callerPackage__: "page-comments-queries"
                });
            }
        } catch (err) {
            $80b47fa0b569ef69$var$logger.error`An Error occurred when updating comments section cache for ${actionType} - ${err}`;
        }
    };
const $80b47fa0b569ef69$export$bab18f310e4f95e8 = (actionType, queryVariables, parentCommentId, isReactionsEnabled, commentId)=>(_cache, result)=>{
        // If the mutation fails, don't do anything
        if (!result || !result.data) return;
        const { pageId: pageId, type: type } = queryVariables;
        try {
            const singleType = type && type.length >= 1 ? type[0] : undefined;
            const consistentQueryVariables = (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
                pageId: pageId,
                type: singleType
            });
            // Update the comments panel data
            const commentsPanelCacheResponse = (0, $l1uFv.readQueryInterop)({
                query: (0, $b1hSc.default),
                variables: consistentQueryVariables,
                __callerPackage__: "page-comments-queries"
            });
            if (commentsPanelCacheResponse) {
                // grab the parent comment for the comments panel
                const commentsPanelParentComment = commentsPanelCacheResponse?.comments?.nodes?.find((comment)=>comment?.id === parentCommentId);
                if (commentsPanelParentComment) {
                    if (actionType === 'delete') {
                        // Remove the returned commentId from the cache and reset it
                        const idxToRemove = commentsPanelParentComment.replies.findIndex((reply)=>reply?.id === commentId);
                        if (idxToRemove !== -1) commentsPanelParentComment.replies.splice(idxToRemove, 1);
                    } else {
                        const mutationResult = result.data.createFooterComment;
                        // Add the new reply entry to the cache and reset it
                        commentsPanelParentComment.replies.push(mutationResult);
                    }
                    (0, $fEmGS.writeQueryInterop)({
                        query: (0, $b1hSc.default),
                        variables: consistentQueryVariables,
                        data: commentsPanelCacheResponse,
                        __callerPackage__: "page-comments-queries"
                    });
                }
            }
        } catch (err) {
            $80b47fa0b569ef69$var$logger.error`An Error occurred when updating comments panel cache for ${actionType} reply - ${err}`;
        }
        try {
            const commentsSectionQuery = isReactionsEnabled ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery);
            // Update the comments section data
            const commentsSectionCacheResponse = (0, $l1uFv.readQueryInterop)({
                query: commentsSectionQuery,
                variables: {
                    contentId: pageId,
                    offset: '',
                    first: (0, $2i3To.DEFAULT_LIMIT)
                },
                __callerPackage__: "page-comments-queries"
            });
            if (commentsSectionCacheResponse) {
                // grab the parent comment for the comments panel
                const commentsSectionCacheData = {
                    ...commentsSectionCacheResponse
                };
                const commentEdges = [
                    ...commentsSectionCacheData?.comments?.edges || []
                ];
                const parentCommentIdx = commentEdges?.findIndex((commentEdge)=>commentEdge?.node?.id === parentCommentId);
                if (parentCommentIdx !== -1) {
                    if (actionType === 'delete') {
                        // Find the last index of the comment to delete
                        const indexToDelete = commentEdges?.findIndex((edge)=>edge?.node?.id === commentId);
                        if (indexToDelete !== -1) commentEdges.splice(indexToDelete, 1);
                    } else {
                        const mutationResult = {
                            ...result.data.createFooterComment
                        };
                        // As far as I can tell, this is always called w/o reactions enabled
                        // This maps the mutation result we get to the cache object that's expected by the comments section query
                        const cacheCommentObject = {
                            id: mutationResult.id,
                            ancestors: [
                                {
                                    id: mutationResult.parentId,
                                    __typename: 'Comment'
                                }
                            ],
                            author: {
                                ...mutationResult.author,
                                type: 'known'
                            },
                            body: mutationResult.body,
                            contentStatus: mutationResult.contentStatus,
                            links: {
                                webui: mutationResult.links.webui,
                                // @ts-ignore
                                __typename: mutationResult.links.__typename
                            },
                            location: mutationResult.location,
                            parentId: mutationResult.parentId,
                            permissions: mutationResult.permissions,
                            version: {
                                ...mutationResult.version,
                                friendlyWhen: 'Just now',
                                // TODO: Maybe replace this with the actual date
                                by: {
                                    type: 'user',
                                    displayName: '',
                                    accountId: '',
                                    __typename: 'User'
                                },
                                __typename: 'Version'
                            },
                            __typename: 'Comment'
                        };
                        // The cache will throw an error if we don't do this ¯\_(ツ)_/¯
                        const cacheContentDeepCopy = JSON.parse(JSON.stringify(cacheCommentObject));
                        const newEdge = {
                            cursor: (commentEdges.length - 1).toString(),
                            node: cacheContentDeepCopy,
                            __typename: 'CommentEdge'
                        };
                        // Find the last index of the thread to insert the reply
                        const threadLastCommentIdx = commentEdges?.findLastIndex((edge)=>edge?.node?.parentId === parentCommentId);
                        // If we can't find it, the parent has no replies
                        const insertAfterIndex = threadLastCommentIdx !== -1 ? threadLastCommentIdx : parentCommentIdx;
                        // Put the new reply in the array
                        commentEdges.splice(insertAfterIndex + 1, 0, newEdge);
                    }
                    (0, $fEmGS.writeQueryInterop)({
                        query: commentsSectionQuery,
                        variables: {
                            contentId: pageId,
                            offset: '',
                            first: (0, $2i3To.DEFAULT_LIMIT)
                        },
                        data: {
                            ...commentsSectionCacheData,
                            comments: {
                                ...commentsSectionCacheData.comments,
                                totalCount: commentEdges.length,
                                pageInfo: {
                                    ...commentsSectionCacheData.comments?.pageInfo,
                                    endCursor: actionType === 'delete' ? '' : (commentEdges.length - 1).toString(),
                                    hasNextPage: false
                                },
                                edges: commentEdges
                            }
                        },
                        __callerPackage__: "page-comments-queries"
                    });
                }
            }
        } catch (err) {
            $80b47fa0b569ef69$var$logger.error`An Error occurred when updating general comments cache for ${actionType} reply - ${err}`;
        }
    };
const $80b47fa0b569ef69$export$aee61debd6ae89df = (commentId, newBody, pageId, isReactionsEnabled, sessionDisplayName)=>{
    const commentsSectionQuery = isReactionsEnabled ? (0, $ftXPY.CommentsSectionQuery) : (0, $ftXPY.CommentsSectionWithoutReactionsQuery);
    try {
        // Update the comments section data
        const commentsSectionCacheData = (0, $l1uFv.readQueryInterop)({
            query: commentsSectionQuery,
            variables: {
                contentId: pageId,
                offset: '',
                first: (0, $2i3To.DEFAULT_LIMIT)
            },
            __callerPackage__: "page-comments-queries"
        });
        if (commentsSectionCacheData) {
            // grab the parent comment for the comments panel
            const commentEdges = [
                ...commentsSectionCacheData?.comments?.edges || []
            ];
            const commentIdx = commentEdges?.findIndex((commentEdge)=>commentEdge?.node?.id === commentId);
            if (commentIdx !== undefined && commentIdx !== null && commentIdx !== -1 && commentEdges[commentIdx]?.node?.body && commentEdges[commentIdx]?.node?.version?.number) {
                // Find the index to update. TS will throw an error even though we've already checked the index is valid
                // @ts-ignore
                commentEdges[commentIdx].node.body.value = newBody; // Update the body we keep in the footer cache
                // @ts-ignore
                commentEdges[commentIdx].node.version.number += 1; // This is required for the propagated footer version to also be editable
                // @ts-ignore
                (0, (/*@__PURE__*/$parcel$interopDefault($lSFbL)))(commentEdges[commentIdx].node, 'version.by.displayName', sessionDisplayName); // Update the display name to the user who edited the comment
                // @ts-ignore
                (0, (/*@__PURE__*/$parcel$interopDefault($lSFbL)))(commentEdges[commentIdx].node, 'version.when', new Date().toISOString()); // Update the version date to the date of the edit
            }
            (0, $fEmGS.writeQueryInterop)({
                query: commentsSectionQuery,
                variables: {
                    contentId: pageId,
                    offset: '',
                    first: (0, $2i3To.DEFAULT_LIMIT)
                },
                data: {
                    ...commentsSectionCacheData,
                    comments: {
                        ...commentsSectionCacheData.comments,
                        totalCount: commentEdges.length,
                        pageInfo: {
                            ...commentsSectionCacheData.comments?.pageInfo,
                            endCursor: Math.random().toString(),
                            // The cache won't update without this. Should be harmless, given hasNextPage is false, so we won't be loading more
                            hasNextPage: false
                        },
                        edges: commentEdges
                    }
                },
                __callerPackage__: "page-comments-queries"
            });
        }
    } catch (err) {
        $80b47fa0b569ef69$var$logger.error`An Error occurred when updating cache for edit footer reply - ${err}`;
    }
};
const $80b47fa0b569ef69$export$c94bffbead878776 = ({ onSuccess: onSuccess, editCommentQueryId: editCommentQueryId, setCommentForEdit: setCommentForEdit, data: data, createAnalyticsEvent: createAnalyticsEvent, pageId: pageId, pageType: pageType, analyticsSource: analyticsSource, commentId: commentId, pageMode: pageMode, experienceTracker: experienceTracker, searchSessionId: searchSessionId, isFooterComment: isFooterComment })=>{
    onSuccess();
    if (editCommentQueryId) setCommentForEdit && setCommentForEdit('');
    const replyCommentInfo = data?.createFooterComment;
    // Find the reply button container and scroll to it if needed
    if (replyCommentInfo?.id && commentId && isFooterComment) {
        // First find the container
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const container = document.getElementById(`footer-comment-thread-${commentId}-container`);
        if (container) {
            // Set up observer to watch for the reply button in the container
            const observer = new MutationObserver((_mutations, obs)=>{
                const replyButtonContainer = container.querySelector('[data-testid="comments-panel-reply-comment-action"]');
                if (replyButtonContainer) {
                    obs.disconnect();
                    // Check if the element is not in viewport, accounting for 75px add comment prompt at bottom
                    const rect = replyButtonContainer.getBoundingClientRect();
                    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
                    const isInViewport = rect.top >= 0 && rect.left >= 0 && rect.bottom <= viewportHeight - 75 && // Account for add comment prompt
                    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth);
                    if (!isInViewport) replyButtonContainer.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center'
                    });
                }
            });
            observer.observe(container, {
                childList: true,
                subtree: true
            });
            // Cleanup observer after 2 seconds to prevent memory leaks
            setTimeout(()=>{
                observer.disconnect();
            }, 2000);
        }
    }
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: 'created',
            actionSubject: 'comment',
            actionSubjectId: replyCommentInfo?.id,
            // The newly created comment ID
            objectType: pageType,
            objectId: pageId,
            source: analyticsSource,
            attributes: {
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                commentType: (0, $en1dX.CommentType).GENERAL,
                source: analyticsSource,
                pageType: pageType,
                isReply: true,
                pageMode: pageMode,
                isLivePage: pageMode === (0, $cD1qu.PageMode).LIVE,
                editor: 'v2',
                searchSessionId: searchSessionId,
                navdexPointType: (0, $56QzY.END),
                parentCommentId: commentId ?? null // analytics event schema type expects string or null
            }
        }
    }).fire();
    experienceTracker.succeed({
        name: (0, $irVI7.REPLY_TO_PAGE_COMMENT_PUBLISH_EXPERIENCE)
    });
};
module.exports["updateApolloCacheParentCallback"] = $80b47fa0b569ef69$export$a02bedef5e94d20c;
module.exports["updateApolloCacheReplyCallback"] = $80b47fa0b569ef69$export$bab18f310e4f95e8;
module.exports["updateFooterApolloCacheOnEdit"] = $80b47fa0b569ef69$export$aee61debd6ae89df;
module.exports["handleCreateReplySuccess"] = $80b47fa0b569ef69$export$c94bffbead878776;

});

parcelRegister("2i3To", function(module, exports) {
const $a410f94860ee0eb3$export$ebc5ec3267fbcf57 = 100;
const $a410f94860ee0eb3$export$55256f24239e6668 = 0;
module.exports["DEFAULT_LIMIT"] = $a410f94860ee0eb3$export$ebc5ec3267fbcf57;

});

parcelRegister("ftXPY", function(module, exports) {

var $Tbcfi = parcelRequire("Tbcfi");


var $f4AIb = parcelRequire("f4AIb");

const $75943abbc80ed84d$export$fd7e2403f7d3fed9 = (0, $f4AIb.default);
const $75943abbc80ed84d$export$274156b7c7eb3601 = (0, $Tbcfi.default);
module.exports["CommentsSectionQuery"] = $75943abbc80ed84d$export$fd7e2403f7d3fed9;
module.exports["CommentsSectionWithoutReactionsQuery"] = $75943abbc80ed84d$export$274156b7c7eb3601;

});

parcelRegister("Tbcfi", function(module, exports) {
/**
 * @generated SignedSource<<0aa4bde3ab258fb665e89212828a925f>>
 * @relayHash 4e66a1ed92ecc98e74128ce3557c84b1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8d7c6c79929eb2196d98aff2b51eba75c385f34e79e699de05c60f756a38000c
const $c6cf5a908bbe58bf$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "offset"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "offset"
        },
        {
            "kind": "Literal",
            "name": "confluenceCommentFilter",
            "value": {
                "commentState": "UNRESOLVED",
                "commentType": "FOOTER"
            }
        },
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ALL"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "FOOTER"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v5 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "ancestors",
        "plural": true,
        "selections": [
            v7 /*: any*/ 
        ]
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v11 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v13 = {
        "kind": "InlineFragment",
        "selections": [
            v12 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionType"
            }
        ],
        "type": "KnownUser"
    }, v14 = {
        "kind": "ScalarField",
        "name": "value"
    }, v15 = [
        v14 /*: any*/ 
    ], v16 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v15 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v17 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v18 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v15 /*: any*/ 
    }, v19 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v20 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v21 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v22 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v23 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v24 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v21 /*: any*/ ,
                    v22 /*: any*/ ,
                    v23 /*: any*/ ,
                    v24 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v21 /*: any*/ ,
                    v22 /*: any*/ ,
                    v23 /*: any*/ ,
                    v24 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v27 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v28 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v29 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v30 = {
        "kind": "ScalarField",
        "name": "number"
    }, v31 = {
        "kind": "ScalarField",
        "name": "when"
    }, v32 = {
        "kind": "InlineFragment",
        "selections": [
            v12 /*: any*/ 
        ],
        "type": "KnownUser"
    }, v33 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v34 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v35 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v36 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "homepageId"
            }
        ]
    }, v37 = {
        "alias": "user",
        "args": [
            {
                "kind": "Literal",
                "name": "current",
                "value": true
            }
        ],
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
            v10 /*: any*/ ,
            {
                "concreteType": "AtlassianUserPhoto",
                "kind": "LinkedField",
                "name": "photos",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isPrimary"
                    },
                    v14 /*: any*/ 
                ]
            },
            v7 /*: any*/ 
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
    }, v38 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CommentsSectionQueryWithoutReactionsQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "concreteType": "CommentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v13 /*: any*/ 
                                            ]
                                        },
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v25 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        },
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                v29 /*: any*/ ,
                                                v30 /*: any*/ ,
                                                v31 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v32 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v33 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v34 /*: any*/ ,
                                v7 /*: any*/ ,
                                v35 /*: any*/ ,
                                v36 /*: any*/ ,
                                v9 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v32 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v37 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CommentsSectionQueryWithoutReactionsQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "concreteType": "CommentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v38 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v13 /*: any*/ 
                                            ]
                                        },
                                        v16 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v38 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v25 /*: any*/ ,
                                                v26 /*: any*/ 
                                            ]
                                        },
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                v29 /*: any*/ ,
                                                v30 /*: any*/ ,
                                                v31 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        v38 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v32 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v33 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v34 /*: any*/ ,
                                v7 /*: any*/ ,
                                v35 /*: any*/ ,
                                v36 /*: any*/ ,
                                v9 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v38 /*: any*/ ,
                                                v32 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v37 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "4e66a1ed92ecc98e74128ce3557c84b1",
            "id": "8d7c6c79929eb2196d98aff2b51eba75c385f34e79e699de05c60f756a38000c",
            "metadata": {},
            "name": "CommentsSectionQueryWithoutReactionsQuery",
            "operationKind": "query",
            "text": "query CommentsSectionQueryWithoutReactionsQuery($offset:String,$first:Long,$contentId:ID!){comments(pageId:$contentId,type:FOOTER,depth:ALL,confluenceCommentFilter:{commentState:UNRESOLVED,commentType:FOOTER},first:$first,after:$offset){totalCount,pageInfo{hasNextPage,endCursor},edges{cursor,node{id,ancestors{id},author{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId,permissionType}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{friendlyWhen,number,when,by{__typename,type,displayName,...on KnownUser{accountId}}}}}},content(id:$contentId){nodes{subType,id,operations{operation,targetType},space{id,homepageId},type,history{createdBy{__typename,...on KnownUser{accountId}}}}},user:confluence_atlassianUser(current:true){displayName,photos{isPrimary,value},id}}"
        }
    };
}();
$c6cf5a908bbe58bf$var$node.hash = "c124efaee0103dd309c2e510586b845f";
var $c6cf5a908bbe58bf$export$2e2bcd8739ae039 = $c6cf5a908bbe58bf$var$node;
module.exports["default"] = $c6cf5a908bbe58bf$export$2e2bcd8739ae039;

});

parcelRegister("f4AIb", function(module, exports) {
/**
 * @generated SignedSource<<3569a19fadd937f8324f2cd7a1ed6c9e>>
 * @relayHash ddb1eba379ed1544bae77ce8070be56f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e8e74d715fec5fddbd3512bf92f9a13ef034b327df28b13fd1a6534cdc3677e0
const $55379995f0cb8cff$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "offset"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "contentId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "offset"
        },
        {
            "kind": "Literal",
            "name": "confluenceCommentFilter",
            "value": {
                "commentState": "UNRESOLVED",
                "commentType": "FOOTER"
            }
        },
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ALL"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v3 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "type",
            "value": "FOOTER"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v6 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "ancestors",
        "plural": true,
        "selections": [
            v8 /*: any*/ 
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "type"
    }, v11 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v12 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v14 = {
        "kind": "InlineFragment",
        "selections": [
            v13 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "permissionType"
            }
        ],
        "type": "KnownUser"
    }, v15 = {
        "kind": "ScalarField",
        "name": "value"
    }, v16 = [
        v15 /*: any*/ 
    ], v17 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v16 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v18 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v19 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v16 /*: any*/ 
    }, v20 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v21 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v23 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v24 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v25 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v22 /*: any*/ ,
                    v23 /*: any*/ ,
                    v24 /*: any*/ ,
                    v25 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v27 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v22 /*: any*/ ,
                    v23 /*: any*/ ,
                    v24 /*: any*/ ,
                    v25 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v28 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v29 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v30 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v31 = {
        "kind": "ScalarField",
        "name": "number"
    }, v32 = {
        "kind": "ScalarField",
        "name": "when"
    }, v33 = {
        "kind": "InlineFragment",
        "selections": [
            v13 /*: any*/ 
        ],
        "type": "KnownUser"
    }, v34 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v8 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v35 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v36 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v37 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v38 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "homepageId"
            }
        ]
    }, v39 = {
        "alias": "user",
        "args": [
            {
                "kind": "Literal",
                "name": "current",
                "value": true
            }
        ],
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            {
                "concreteType": "AtlassianUserPhoto",
                "kind": "LinkedField",
                "name": "photos",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isPrimary"
                    },
                    v15 /*: any*/ 
                ]
            },
            v8 /*: any*/ 
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
    }, v40 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CommentsSectionQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "concreteType": "CommentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                v14 /*: any*/ 
                                            ]
                                        },
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v26 /*: any*/ ,
                                                v27 /*: any*/ 
                                            ]
                                        },
                                        v28 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                v30 /*: any*/ ,
                                                v31 /*: any*/ ,
                                                v32 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        v33 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v34 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v35 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v36 /*: any*/ ,
                                v8 /*: any*/ ,
                                v37 /*: any*/ ,
                                v38 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v33 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v39 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CommentsSectionQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "concreteType": "CommentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v40 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                v14 /*: any*/ 
                                            ]
                                        },
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v40 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v26 /*: any*/ ,
                                                v27 /*: any*/ 
                                            ]
                                        },
                                        v28 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                v30 /*: any*/ ,
                                                v31 /*: any*/ ,
                                                v32 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        v40 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        v11 /*: any*/ ,
                                                        v33 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v34 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v35 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v36 /*: any*/ ,
                                v8 /*: any*/ ,
                                v37 /*: any*/ ,
                                v38 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v40 /*: any*/ ,
                                                v33 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v39 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "ddb1eba379ed1544bae77ce8070be56f",
            "id": "e8e74d715fec5fddbd3512bf92f9a13ef034b327df28b13fd1a6534cdc3677e0",
            "metadata": {},
            "name": "CommentsSectionQuery",
            "operationKind": "query",
            "text": "query CommentsSectionQuery($offset:String,$first:Long,$contentId:ID!)@allowHigherTimeout{comments(pageId:$contentId,type:FOOTER,depth:ALL,confluenceCommentFilter:{commentState:UNRESOLVED,commentType:FOOTER},first:$first,after:$offset){totalCount,pageInfo{hasNextPage,endCursor},edges{cursor,node{id,ancestors{id},author{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId,permissionType}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{isDangling,resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}},...on FooterComment{commentResolveProperties{resolvedTime,resolvedFriendlyDate,resolvedUser,resolved}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{friendlyWhen,number,when,by{__typename,type,displayName,...on KnownUser{accountId}}},reactionsSummary(pageId:$contentId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}}},content(id:$contentId){nodes{subType,id,operations{operation,targetType},space{id,homepageId},type,history{createdBy{__typename,...on KnownUser{accountId}}}}},user:confluence_atlassianUser(current:true){displayName,photos{isPrimary,value},id}}"
        }
    };
}();
$55379995f0cb8cff$var$node.hash = "2dc784a3ffdaa1784c202cee08d95c7c";
var $55379995f0cb8cff$export$2e2bcd8739ae039 = $55379995f0cb8cff$var$node;
module.exports["default"] = $55379995f0cb8cff$export$2e2bcd8739ae039;

});

parcelRegister("lFkRf", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $CP0sd = parcelRequire("CP0sd");


var $FBfum = parcelRequire("FBfum");

const $ad3c53086a228972$var$parseError = (error)=>{
    const { message: message } = error;
    let errorMessage;
    /* If this is a GraphQL error we need to extract the data out of it
   * GraphQL errors that are returned from queries/mutations always have the same format:
   * GraphQL error: <GUID>:[ <EXCEPTION>:] <REASON>
   */ if (message.indexOf('GraphQL error:') !== -1) {
        const reasonStartIdx = message.lastIndexOf(':') + 1;
        errorMessage = message.substr(reasonStartIdx, message.length - reasonStartIdx).trim();
    } else errorMessage = message;
    const parsedError = {
        message: errorMessage
    };
    // If we have an ApolloErrorInterop, extract the status code and the authorization status
    const { graphQLErrors: graphQLErrors } = error;
    if (graphQLErrors && graphQLErrors.length) parsedError.statusCode = graphQLErrors?.[0]?.extensions?.statusCode;
    return parsedError;
};
const $ad3c53086a228972$export$a67f8c1198066537 = (error)=>{
    if ((0, $6fil2.containsNetworkError)(error)) return (0, $FBfum.i18n).networkError;
    const parsedError = $ad3c53086a228972$var$parseError(error);
    const { message: message } = parsedError;
    switch(true){
        case message === (0, $CP0sd.ObjectCommentsError).VIEW_NOT_PERMITTED:
            return (0, $FBfum.i18n).viewNotPermitted;
        case message === (0, $CP0sd.ObjectCommentsError).NO_CREATE_PERMS:
            return (0, $FBfum.i18n).createNotPermitted;
        case $ad3c53086a228972$export$ecdfad00dc25b27e(message):
            return (0, $FBfum.i18n).contentNotFound;
        default:
            return (0, $FBfum.i18n).unexpectedError;
    }
};
const $ad3c53086a228972$export$c4a6c57f5b95da54 = (translatedMessage)=>translatedMessage.id === (0, $FBfum.i18n).viewNotPermitted.id;
const $ad3c53086a228972$export$476aa014e2fd89d5 = (translatedMessage)=>translatedMessage.id === (0, $FBfum.i18n).networkError.id;
const $ad3c53086a228972$export$aa951ce6b8761d86 = (translatedMessage)=>translatedMessage.id === (0, $FBfum.i18n).createNotPermitted.id;
const $ad3c53086a228972$export$c572523773a0cf86 = (translatedMessage)=>translatedMessage.id === (0, $FBfum.i18n).contentNotFound.id;
const $ad3c53086a228972$export$d1e82e172a94f308 = (translatedMessage, abortOnContainerNotFound)=>$ad3c53086a228972$export$aa951ce6b8761d86(translatedMessage) || $ad3c53086a228972$export$c4a6c57f5b95da54(translatedMessage) || $ad3c53086a228972$export$c572523773a0cf86(translatedMessage) && abortOnContainerNotFound;
const $ad3c53086a228972$var$CONTENT_NOT_FOUND_PATTERNS = [
    /Content with id \S+ for comment container is not found/,
    /No content found with id\s*:\s*\S+/,
    /Cannot create a \[[^\]]+\] comment on content with \[(?:trashed|deleted|archived)\] status/
];
const $ad3c53086a228972$export$ecdfad00dc25b27e = (errorMessage)=>$ad3c53086a228972$var$CONTENT_NOT_FOUND_PATTERNS.some((pattern)=>pattern.test(errorMessage));
module.exports["getTranslatedError"] = $ad3c53086a228972$export$a67f8c1198066537;
module.exports["isRawContentNotFoundError"] = $ad3c53086a228972$export$ecdfad00dc25b27e;
module.exports["isViewNotPermittedError"] = $ad3c53086a228972$export$c4a6c57f5b95da54;
module.exports["isNetworkError"] = $ad3c53086a228972$export$476aa014e2fd89d5;
module.exports["isCommentAbortableError"] = $ad3c53086a228972$export$d1e82e172a94f308;

});

parcelRegister("CP0sd", function(module, exports) {
var $a1a7014f0329fe2c$export$37d35ac9f5bc0a58 = /*#__PURE__*/ function(ObjectCommentsError) {
    // view
    ObjectCommentsError["VIEW_NOT_PERMITTED"] = "403 Forbidden, current user not permitted to use Confluence.";
    // Create
    ObjectCommentsError["NO_CREATE_PERMS"] = "Could not create content with type comment";
    ObjectCommentsError["CONTAINER_NOT_FOUND"] = "Content with id %d for comment container is not found. Please provide correct container id.";
    return ObjectCommentsError;
}({});
module.exports["ObjectCommentsError"] = $a1a7014f0329fe2c$export$37d35ac9f5bc0a58;

});

parcelRegister("FBfum", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $93264f9de833f05e$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    unableToLoadCommentsTitle: {
        id: "comments-util.error.unable.to.load.comments",
        defaultMessage: "Unable to load comments"
    },
    networkError: {
        id: "comments-util.error.network",
        defaultMessage: "A network error was encountered when loading comments. Please try refreshing the page."
    },
    viewNotPermitted: {
        id: "comments-util.error.view.not.permitted",
        defaultMessage: "Your permission settings don\u2019t allow you to view comments on this page. Check with your administrator if you need this ability."
    },
    createNotPermitted: {
        id: "comments-util.error.create.not.permitted",
        defaultMessage: "You can\u2019t create comments in this space. A space admin can modify your permissions."
    },
    contentNotFound: {
        id: "comments-util.error.content.not.found",
        defaultMessage: "The page you are trying to comment on is no longer available. It may have been deleted or archived."
    },
    unexpectedError: {
        id: "comments-util.error.unexpected",
        defaultMessage: "Something went wrong when loading comments on this page."
    }
});
module.exports["i18n"] = $93264f9de833f05e$export$a7357cdd1f0b0168;

});

parcelRegister("2GRt3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $jb2R2 = parcelRequire("jb2R2");

var $bg9GW = parcelRequire("bg9GW");

var $fNtG8 = parcelRequire("fNtG8");

var $apWEJ = parcelRequire("apWEJ");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $clUfR = parcelRequire("clUfR");

const $b82e04cb35c495bd$var$messages = (0, $kSwu1.defineMessages)({
    now: {
        id: "inline-comments-utils.relative-timestamp.now",
        defaultMessage: "Now"
    }
});
const $b82e04cb35c495bd$export$705da3a6fb3571ab = ({ date: date })=>{
    const intl = (0, $kSwu1.useIntl)();
    const now = new Date();
    const diffInMinutes = (0, $fNtG8.default)(now, date);
    const diffInHours = (0, $bg9GW.default)(now, date);
    const diffInDays = (0, $jb2R2.default)(now, date);
    const diffInWeeks = (0, $apWEJ.default)(now, date);
    const { timeZone: userTimeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    const timeZone = userTimeZone || tenantTimeZone || (0, $clUfR.guessTimeZone)();
    // < 2 minutes: "Now"
    if (diffInMinutes < 2) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, intl.formatMessage($b82e04cb35c495bd$var$messages.now));
    // < 1 hour: Shows minutes (e.g., "15m")
    if (diffInMinutes < 60) return(// eslint-disable-next-line react/style-prop-object
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedNumber), {
        value: diffInMinutes,
        style: "unit",
        unit: "minute",
        unitDisplay: "narrow"
    }));
    // < 1 day: Shows hours (e.g., "3h")
    if (diffInHours < 24) // eslint-disable-next-line react/style-prop-object
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedNumber), {
        value: diffInHours,
        style: "unit",
        unit: "hour",
        unitDisplay: "narrow"
    });
    // ≤ 1 week: Shows days (e.g., "5d")
    if (diffInWeeks < 1) // eslint-disable-next-line react/style-prop-object
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedNumber), {
        value: diffInDays,
        style: "unit",
        unit: "day",
        unitDisplay: "narrow"
    });
    // > 1 week: Shows actual date
    const currentYear = now.getFullYear();
    const dateYear = date.getFullYear();
    // Same year: "Jan 15"
    if (currentYear === dateYear) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, intl.formatDate(date, {
        month: 'short',
        day: 'numeric',
        ...(0, $6mKj3.expValEquals)('confluence_fe_ssr_top_footer_comments', 'isEnabled', true) ? {
            timeZone: timeZone
        } : {}
    }));
    // Different year: "Jan 15, 2023"
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, intl.formatDate(date, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        ...(0, $6mKj3.expValEquals)('confluence_fe_ssr_top_footer_comments', 'isEnabled', true) ? {
            timeZone: timeZone
        } : {}
    }));
};
module.exports["RelativeTimestamp"] = $b82e04cb35c495bd$export$705da3a6fb3571ab;

});

parcelRegister("1YPul", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $77145f754114b981$export$d4c72bab9d6cc13a = {
    updateDocumentFn: ()=>{}
};
const $77145f754114b981$export$e324594224ef24da = {
    setUpdateDocumentFn: (newUpdateDocumentFn)=>({ setState: setState })=>{
            setState({
                updateDocumentFn: newUpdateDocumentFn
            });
        }
};
const $77145f754114b981$export$bca0c556b0ff9d9c = (0, $8s9DV.createStore)({
    initialState: $77145f754114b981$export$d4c72bab9d6cc13a,
    actions: $77145f754114b981$export$e324594224ef24da,
    name: 'UpdateDocumentStore'
});
const $77145f754114b981$export$5e7505d6571fe99d = (0, $kBr4q.createHook)($77145f754114b981$export$bca0c556b0ff9d9c);
const $77145f754114b981$export$25ca074c0dbf9075 = (0, $kBr4q.createActionsHook)($77145f754114b981$export$bca0c556b0ff9d9c);
module.exports["useUpdateDocument"] = $77145f754114b981$export$5e7505d6571fe99d;
module.exports["useUpdateDocumentActions"] = $77145f754114b981$export$25ca074c0dbf9075;

});

parcelRegister("3B9cR", function(module, exports) {

var $6kgLu = parcelRequire("6kgLu");

const $7d2c123586cab1f2$export$5fa1043645dd2c26 = (0, $6kgLu.default);
module.exports["InlineCommentQuery"] = $7d2c123586cab1f2$export$5fa1043645dd2c26;

});

parcelRegister("6kgLu", function(module, exports) {
/**
 * @generated SignedSource<<be9673dafa8094e7a6e9dd947e0cfee1>>
 * @relayHash 1565f9a21fb928625638bc549e846634
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 66870dba275f9b13105b9633c348af8de6c6550db6806aaa7794cf5e03af8e86
const $91432cb47dad508a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "annotationId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        {
            "kind": "Variable",
            "name": "inlineMarkerRef",
            "variableName": "annotationId"
        },
        v3 /*: any*/ 
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v8 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v7 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v9 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v10 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v11 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v13 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v14 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v16 = {
        "kind": "ScalarField",
        "name": "type"
    }, v17 = {
        "kind": "ScalarField",
        "name": "when"
    }, v18 = {
        "kind": "ScalarField",
        "name": "number"
    }, v19 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v12 /*: any*/ 
                ]
            },
            v17 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v20 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v21 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    },
                    v5 /*: any*/ 
                ]
            }
        ]
    }, v22 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "resolved"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "resolvedTime"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "resolvedUser"
                    }
                ]
            }
        ],
        "type": "InlineComment"
    }, v23 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v24 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v23 /*: any*/ ,
                    v12 /*: any*/ 
                ]
            },
            v17 /*: any*/ ,
            v18 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "InlineCommentQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                v14 /*: any*/ ,
                                                v15 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ 
                                            ]
                                        },
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                },
                                v19 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v16 /*: any*/ ,
                                        v22 /*: any*/ 
                                    ]
                                },
                                v5 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v12 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v15 /*: any*/ 
                                    ]
                                },
                                v20 /*: any*/ ,
                                v21 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "InlineCommentQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "author",
                                            "plural": false,
                                            "selections": [
                                                v23 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                v14 /*: any*/ ,
                                                v15 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "location",
                                            "plural": false,
                                            "selections": [
                                                v23 /*: any*/ ,
                                                v16 /*: any*/ 
                                            ]
                                        },
                                        v24 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                },
                                v24 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "location",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v22 /*: any*/ 
                                    ]
                                },
                                v5 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v23 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v15 /*: any*/ 
                                    ]
                                },
                                v20 /*: any*/ ,
                                v21 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "1565f9a21fb928625638bc549e846634",
            "id": "66870dba275f9b13105b9633c348af8de6c6550db6806aaa7794cf5e03af8e86",
            "metadata": {},
            "name": "InlineCommentQuery",
            "operationKind": "query",
            "text": "query InlineCommentQuery($annotationId:String,$pageId:ID!,$contentStatus:[GraphQLContentStatus]){comments(inlineMarkerRef:$annotationId,pageId:$pageId,contentStatus:$contentStatus){nodes{replies{id,parentId,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,links{webui,editui},author{__typename,displayName,permissionType,profilePicture{path},...on KnownUser{accountId}},location{__typename,type},version{by{__typename,displayName},when,number},permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}},version{by{__typename,displayName},when,number},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,resolvedTime,resolvedUser}}},id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}}}"
        }
    };
}();
$91432cb47dad508a$var$node.hash = "97a27177dfbb0afcc0c9bf12ba1b9268";
var $91432cb47dad508a$export$2e2bcd8739ae039 = $91432cb47dad508a$var$node;
module.exports["default"] = $91432cb47dad508a$export$2e2bcd8739ae039;

});

parcelRegister("1C8XP", function(module, exports) {

var $3cQo5 = parcelRequire("3cQo5");

const $087454af48047e63$export$c9407390b0cf740d = (0, $3cQo5.default);
module.exports["ActiveInlineCommentsQuery"] = $087454af48047e63$export$c9407390b0cf740d;

});

parcelRegister("3cQo5", function(module, exports) {
/**
 * @generated SignedSource<<131ed4823645958609337a2481f00b28>>
 * @relayHash 0c90169da883bac60f8fe8cfefab06a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 552f4ed74ad1b7c37ac2902ef839637021531a2d5013fcb0803bfdaf5709e0f4
const $487b4c2a573008bb$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "inlineMarkerRefList"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        {
            "kind": "Variable",
            "name": "inlineMarkerRefList",
            "variableName": "inlineMarkerRefList"
        },
        v3 /*: any*/ 
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v7 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v6 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v8 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v9 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v6 /*: any*/ 
    }, v10 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v11 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "type"
    }, v13 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v14 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    v13 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v14 /*: any*/ ,
                    v15 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v18 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v19 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v20 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v21 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v22 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v23 = {
        "kind": "ScalarField",
        "name": "when"
    }, v24 = {
        "kind": "ScalarField",
        "name": "number"
    }, v25 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v22 /*: any*/ 
                ]
            },
            v23 /*: any*/ ,
            v24 /*: any*/ 
        ]
    }, v26 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v28 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v29 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v22 /*: any*/ ,
            v26 /*: any*/ ,
            v27 /*: any*/ ,
            v28 /*: any*/ 
        ]
    }, v30 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v3 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v31 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v32 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ 
        ]
    }, v33 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v31 /*: any*/ ,
                    v22 /*: any*/ 
                ]
            },
            v23 /*: any*/ ,
            v24 /*: any*/ 
        ]
    }, v34 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v31 /*: any*/ ,
            v22 /*: any*/ ,
            v26 /*: any*/ ,
            v27 /*: any*/ ,
            v28 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ActiveInlineCommentsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v25 /*: any*/ ,
                                v29 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ 
                                    ]
                                },
                                v30 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ActiveInlineCommentsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v32 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                v33 /*: any*/ ,
                                v34 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v32 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ ,
                                        v33 /*: any*/ ,
                                        v34 /*: any*/ ,
                                        v30 /*: any*/ 
                                    ]
                                },
                                v30 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "0c90169da883bac60f8fe8cfefab06a0",
            "id": "552f4ed74ad1b7c37ac2902ef839637021531a2d5013fcb0803bfdaf5709e0f4",
            "metadata": {},
            "name": "ActiveInlineCommentsQuery",
            "operationKind": "query",
            "text": "query ActiveInlineCommentsQuery($inlineMarkerRefList:[String!]!,$pageId:ID!,$contentStatus:[GraphQLContentStatus]){comments(inlineMarkerRefList:$inlineMarkerRefList,pageId:$pageId,contentStatus:$contentStatus){nodes{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}}}"
        }
    };
}();
$487b4c2a573008bb$var$node.hash = "93367b15ee96494c20452626f5b23b5d";
var $487b4c2a573008bb$export$2e2bcd8739ae039 = $487b4c2a573008bb$var$node;
module.exports["default"] = $487b4c2a573008bb$export$2e2bcd8739ae039;

});

parcelRegister("isdzP", function(module, exports) {

var $lFkRf = parcelRequire("lFkRf");


var $FBfum = parcelRequire("FBfum");


var $6mKj3 = parcelRequire("6mKj3");


var $fJlJm = parcelRequire("fJlJm");


var $hL41C = parcelRequire("hL41C");


var $9CnRS = parcelRequire("9CnRS");

const $e5083fb3da68bf8e$export$e80a9284539c1797 = (error)=>{
    const { message: message } = error;
    let errorMessage = '';
    const parsedError = {
        message: errorMessage,
        isAuthorized: false
    };
    /* If this is a GraphQL error we need to extract the data out of it
   * GraphQL errors that are returned from mutations always have the same format:
   * GraphQL error: <GUID>: <EXCEPTION>: <REASON>
   * The GUID correlates to the microsId so it unfortunately doesn't do much for us
   * With this in mind, we want to extract the REASON as the message for translation
   */ if (message.indexOf('GraphQL error:') !== -1) {
        const reasonStartIdx = message.lastIndexOf(':') + 1;
        errorMessage = message.substr(reasonStartIdx, message.length - reasonStartIdx).trim();
        // Extract the traceId for highlight errors
        parsedError.errorId = (0, $fJlJm.getLogSafeErrorAttributes)(error).traceId;
    } else errorMessage = message;
    parsedError.message = errorMessage;
    // If we have an ApolloErrorInterop, extract the status code and the authorization status
    const { graphQLErrors: graphQLErrors } = error;
    if (graphQLErrors && graphQLErrors.length) {
        parsedError.statusCode = graphQLErrors?.[0]?.extensions?.statusCode;
        parsedError.isAuthorized = graphQLErrors?.[0]?.extensions?.data?.authorized || false;
    }
    return parsedError;
};
const $e5083fb3da68bf8e$export$a67f8c1198066537 = (message, id = '')=>{
    let i18nError;
    // COMMENTS-4199 - This is our own handling of the error thrown by the editor/renderer that we wrap
    //				   in our own message, so to preserve the original error we just check for our message
    if (message.includes('Unable to apply annotation to document')) {
        if (message.includes('Failed to create annotation')) i18nError = (0, $9CnRS.i18n).unableToApplyDanglingCommentAnnotation;
        else i18nError = (0, $9CnRS.i18n).unableToApplyAnnotation;
    } else if (message.startsWith('Network error: ')) i18nError = (0, $9CnRS.i18n).networkError;
    else if ((0, $lFkRf.isRawContentNotFoundError)(message)) i18nError = (0, $FBfum.i18n).contentNotFound;
    else switch(message){
        case (0, $hL41C.InlineCommentError).INVALID_SELECTION:
        case (0, $hL41C.InlineCommentError).FAILED_TO_INSERT_MARK:
            i18nError = (0, $9CnRS.i18n).invalidHighlight;
            break;
        case (0, $hL41C.InlineCommentError).STALE_SELECTION:
            i18nError = (0, $9CnRS.i18n).staleContent;
            break;
        case (0, $hL41C.InlineCommentError).NO_ANONYMOUS_ACCESS:
            i18nError = (0, $9CnRS.i18n).actionNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).NO_COMMENTS_FOUND_FOR_GIVEN_MARKER_REF:
        case (0, $hL41C.InlineCommentError).NO_COMMENTS_FOUND_FOR_GIVEN_MARKER_REF_LIST:
            i18nError = (0, $9CnRS.i18n).noCommentsFoundForGivenMarkerRef;
            break;
        case (0, $hL41C.InlineCommentError).NO_VIEW_PERMS:
        case (0, $hL41C.InlineCommentError).NOT_AUTHORIZED:
        case (0, $hL41C.InlineCommentError).NOT_AUTHORIZED_COMMENTS:
            i18nError = (0, $9CnRS.i18n).viewNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).NO_UPDATE_PERMS.replace('%d', id ? id : ''):
            i18nError = (0, $9CnRS.i18n).editNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).NO_VIEW_OR_MODIFY_PERMS:
        case (0, $hL41C.InlineCommentError).NO_SPACE_PERMS:
            i18nError = (0, $9CnRS.i18n).viewOrModifyNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).NO_DELETE_WITH_CHILDREN:
            i18nError = (0, $9CnRS.i18n).deleteWithRepliesNotAllowed;
            break;
        case (0, $hL41C.InlineCommentError).NO_CREATE_PERMS:
            i18nError = (0, $9CnRS.i18n).createNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).UPDATE_COMMENT_NOT_FOUND.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).COMMENT_ALREADY_DELETED.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).CANNOT_RESOLVE_DELETED_COMMENT.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).ERROR_404:
            i18nError = (0, $9CnRS.i18n).commentAlreadyDeleted;
            break;
        case (0, $hL41C.InlineCommentError).CANNOT_REPLY_TO_DELETED_PARENT:
            i18nError = (0, $9CnRS.i18n).replyNotAllowedParentDeleted;
            break;
        case (0, $hL41C.InlineCommentError).INVALID_ARGUMENT_MATCHES:
            i18nError = (0, $6mKj3.expValEquals)('confluence_fe_create_inline_use_curr_doc_version', 'isEnabled', true) ? (0, $9CnRS.i18n).cannotHighlightContent : (0, $9CnRS.i18n).contentHasBeenRemoved;
            break;
        case (0, $hL41C.InlineCommentError).CANNOT_REPLY_TO_RESOLVED_COMMENT:
            i18nError = (0, $9CnRS.i18n).cannotReplyToResolvedComment;
            break;
        case (0, $hL41C.InlineCommentError).CANNOT_UPDATE_RESOLVED_COMMENT:
            i18nError = (0, $9CnRS.i18n).cannotUpdateResolvedComment;
            break;
        case (0, $hL41C.InlineCommentError).CONTENT_OUT_OF_DATE:
            i18nError = (0, $9CnRS.i18n).contentOutOfDate;
            break;
        case (0, $hL41C.InlineCommentError).INVALID_ARGUMENT_CREATED_FROM:
        case (0, $hL41C.InlineCommentError).PARENT_NOT_FOUND.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).INCOMPATIBLE_PARENT_TYPE:
        case (0, $hL41C.InlineCommentError).DELETE_ERROR:
        default:
            i18nError = (0, $9CnRS.i18n).unexpectedError;
            break;
    }
    return i18nError;
};
const $e5083fb3da68bf8e$export$336db91bab9fb3ba = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).invalidHighlight.id;
const $e5083fb3da68bf8e$export$68de2e41a5e9d0c3 = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).unexpectedError.id;
const $e5083fb3da68bf8e$export$fb2e61e668e6b1d2 = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).unableToApplyAnnotation.id || translatedMessage.id === (0, $9CnRS.i18n).unableToApplyDanglingCommentAnnotation.id;
const $e5083fb3da68bf8e$export$81795bac145b8560 = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).contentOutOfDate.id || translatedMessage.id === (0, $9CnRS.i18n).staleContent.id;
const $e5083fb3da68bf8e$export$b2e3f629cad072ef = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).commentAlreadyDeleted.id;
const $e5083fb3da68bf8e$export$476aa014e2fd89d5 = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).networkError.id;
const $e5083fb3da68bf8e$export$aa951ce6b8761d86 = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).createNotPermitted.id;
const $e5083fb3da68bf8e$export$c4a6c57f5b95da54 = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).viewNotPermitted.id;
const $e5083fb3da68bf8e$export$c572523773a0cf86 = (translatedMessage)=>translatedMessage.id === (0, $FBfum.i18n).contentNotFound.id;
module.exports["parseError"] = $e5083fb3da68bf8e$export$e80a9284539c1797;
module.exports["getTranslatedError"] = $e5083fb3da68bf8e$export$a67f8c1198066537;
module.exports["isHighlightError"] = $e5083fb3da68bf8e$export$336db91bab9fb3ba;
module.exports["isUnexpectedError"] = $e5083fb3da68bf8e$export$68de2e41a5e9d0c3;
module.exports["isAnnotationError"] = $e5083fb3da68bf8e$export$fb2e61e668e6b1d2;
module.exports["isOutOfDateError"] = $e5083fb3da68bf8e$export$81795bac145b8560;
module.exports["isAlreadyDeletedError"] = $e5083fb3da68bf8e$export$b2e3f629cad072ef;
module.exports["isNetworkError"] = $e5083fb3da68bf8e$export$476aa014e2fd89d5;
module.exports["isCreateNotPermittedError"] = $e5083fb3da68bf8e$export$aa951ce6b8761d86;
module.exports["isViewNotPermittedError"] = $e5083fb3da68bf8e$export$c4a6c57f5b95da54;
module.exports["isContentNotFoundError"] = $e5083fb3da68bf8e$export$c572523773a0cf86;

});

parcelRegister("hL41C", function(module, exports) {
var $4bdefc881ecc3bb8$export$317614131ad59950 = /*#__PURE__*/ function(InlineCommentError) {
    InlineCommentError["INVALID_SELECTION"] = "Invalid text selection. Cannot create inline comments on macros (mentions, images, emojis, etc.)";
    InlineCommentError["FAILED_TO_INSERT_MARK"] = "Failed to insert highlight, invalid originalSelection, numMatches, or matchIndex";
    InlineCommentError["INVALID_ARGUMENT_CREATED_FROM"] = "Invalid createdFrom, please specify if created from editor or renderer";
    InlineCommentError["STALE_SELECTION"] = "Selection was made against a stale version of the content";
    InlineCommentError["NO_ANONYMOUS_ACCESS"] = "Anonymous access is not permitted";
    InlineCommentError["NO_COMMENTS_FOUND_FOR_GIVEN_MARKER_REF"] = "No comments found for the given markerRef";
    InlineCommentError["NO_COMMENTS_FOUND_FOR_GIVEN_MARKER_REF_LIST"] = "No comments found for the given markerRefList";
    InlineCommentError["NO_VIEW_PERMS"] = "User doesn't have VIEW permission for this comment";
    InlineCommentError["NOT_AUTHORIZED"] = "403 Forbidden, current user not permitted to use Confluence.";
    InlineCommentError["NOT_AUTHORIZED_COMMENTS"] = "User does not have permission to access the comment(s)";
    // Create Reply
    InlineCommentError["PARENT_NOT_FOUND"] = "Parent comment with id %d is not found. Please provide correct parent comment id.";
    InlineCommentError["INCOMPATIBLE_PARENT_TYPE"] = "Incompatible parent type. Please provide comment id.";
    InlineCommentError["CANNOT_REPLY_TO_DELETED_PARENT"] = "Cannot add reply to a deleted comment";
    InlineCommentError["CANNOT_REPLY_TO_RESOLVED_COMMENT"] = "Inline comment in RESOLVED status cannot be replied";
    // Delete
    // This is the error message for a NotFoundException only
    InlineCommentError["DELETE_ERROR"] = "Exception occurred while deleting comment with id";
    InlineCommentError["NO_VIEW_OR_MODIFY_PERMS"] = "Parent page view is restricted";
    InlineCommentError["NO_SPACE_PERMS"] = "Space is restricted";
    InlineCommentError["NO_DELETE_WITH_CHILDREN"] = "Inline comment with child cannot be deleted.";
    InlineCommentError["COMMENT_ALREADY_DELETED"] = "Exception occurred while deleting comment with id %d";
    InlineCommentError["ERROR_404"] = "Received status 404";
    // Edit
    InlineCommentError["NO_UPDATE_PERMS"] = "Could not update Content of type  = class com.atlassian.confluence.pages.Comment with id %d";
    InlineCommentError["UPDATE_COMMENT_NOT_FOUND"] = "Could not find Comment for update with id CommentId{id=%d}";
    InlineCommentError["CANNOT_UPDATE_RESOLVED_COMMENT"] = "Inline comment in RESOLVED status cannot be updated";
    // Create
    InlineCommentError["NO_CREATE_PERMS"] = "Could not create content with type comment";
    InlineCommentError["INVALID_ARGUMENT_MATCHES"] = "Invalid arguments provided for matchIndex and/or numMatches";
    InlineCommentError["CONTENT_OUT_OF_DATE"] = "Published Version out of date. Please provide correct published version.";
    InlineCommentError["UNABLE_TO_APPLY_ANNOTATION"] = "Unable to apply annotation to document";
    // Resolve
    InlineCommentError["CANNOT_RESOLVE_DELETED_COMMENT"] = "%d must be existing and be an inline comment";
    return InlineCommentError;
}({});
module.exports["InlineCommentError"] = $4bdefc881ecc3bb8$export$317614131ad59950;

});

parcelRegister("9CnRS", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $90dae8a726ff859c$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    addNew: {
        id: "inline-comments-common.reactions.add.new",
        defaultMessage: "Add new"
    },
    invalidHighlight: {
        id: "inline-comments-common.error.invalid.highlight",
        defaultMessage: "We\u2019re having trouble adding your comment. Try highlighting more or less text."
    },
    replyCommentPlaceholder: {
        id: "inline-comments-common.reply-comment-placeholder",
        defaultMessage: "Reply"
    },
    staleContent: {
        id: "inline-comments-common.error.stale.content",
        defaultMessage: "Refresh to view the latest updates, and try adding your comment again."
    },
    viewNotPermitted: {
        id: "inline-comments-common.error.view.not.permitted",
        defaultMessage: "Your permission settings don\u2019t allow you to view this comment. Check with your administrator if you need this ability."
    },
    createNotPermitted: {
        id: "inline-comments-common.error.create.not.permitted",
        defaultMessage: "You can\u2019t create comments in this space. A space admin can modify your permissions."
    },
    unableToApplyAnnotation: {
        id: "inline-comments-common.error.unable.to.apply.annotation",
        defaultMessage: "Something went wrong when adding this comment to the document. Refresh to see your comment."
    },
    unableToApplyDanglingCommentAnnotation: {
        id: "inline-comments-common.error.unable.to.apply.dangling.comment.annotation",
        defaultMessage: "Your comment was created but could not be added to the document because the text has been changed or removed."
    },
    contentHasBeenRemoved: {
        id: "inline-comments-common.error.create.content.removed",
        defaultMessage: "The text you highlighted has already been deleted by someone else. Refresh to view the latest updates."
    },
    cannotHighlightContent: {
        id: "inline-comments-common.error.cannot.highlight.content",
        defaultMessage: "An error occurred when commenting on the highlighted content. The page may be outdated. Refresh to view the latest updates."
    },
    viewOrModifyNotPermitted: {
        id: "inline-comments-common.error.view.or.modify.not.permitted",
        defaultMessage: "You can\u2019t view or modify comments in this space. A space admin can modify your permissions."
    },
    deleteWithRepliesNotAllowed: {
        id: "inline-comments-common.error.delete.with.replies",
        defaultMessage: "You can\u2019t delete this comment anymore because someone else replied to it. Refresh to see all replies."
    },
    commentAlreadyDeleted: {
        id: "inline-comments-common.error.comment.already.deleted",
        defaultMessage: "This comment has been deleted by someone else. Refresh to view the latest updates."
    },
    commentAlreadyDeletedTitle: {
        id: "inline-comments-common.error.comment.already.deleted.title",
        defaultMessage: "Unable to delete comment"
    },
    noCommentsFoundForGivenMarkerRef: {
        id: "inline-comments-common.error.no.comments.found.for.given.marker.ref",
        defaultMessage: "This comment couldn\u2019t be found. Refresh to view the latest updates."
    },
    resolveNotPermitted: {
        id: "inline-comments-common.error.resolve.not.permitted",
        defaultMessage: "You can\u2019t resolve comments in this space. A space admin can modify your permissions."
    },
    resolveError: {
        id: "inline-comments-common.error.resolve.error",
        defaultMessage: "We failed to resolve your comment due to an error. Try resolving the comment again."
    },
    resolveErrorTitle: {
        id: "inline-comments-common.error.resolve.error.title",
        defaultMessage: "Failed to resolve comment"
    },
    deleteError: {
        id: "inline-comments-common.error.delete.error",
        defaultMessage: "We failed to delete your comment due to an error. Try deleting the comment again."
    },
    deleteErrorTitle: {
        id: "inline-comments-common.error.delete.error.title",
        defaultMessage: "Failed to delete comment"
    },
    editNotPermitted: {
        id: "inline-comments-common.error.edit.not.permitted",
        defaultMessage: "You can\u2019t edit comments in this space. A space admin can modify your permissions."
    },
    replyNotPermitted: {
        id: "inline-comments-common.error.reply.not.permitted",
        defaultMessage: "You can\u2019t reply to comments in this space. A space admin can modify your permissions."
    },
    replyNotAllowedParentDeleted: {
        id: "inline-comments-common.error.reply.not.allowed.parent.deleted",
        defaultMessage: "You can\u2019t reply to this comment because it was just deleted by someone else. Refresh to view the latest updates."
    },
    unableToMarkDOM: {
        id: "inline-comments-common.error.unable.to.mark.dom",
        defaultMessage: "Your comment has been successfully created. Refresh to view it."
    },
    networkError: {
        id: "inline-comments-common.error.network",
        defaultMessage: "Your comment wasn't added due to a network error. Check your connection and try again."
    },
    unexpectedError: {
        id: "inline-comments-common.error.unexpected",
        defaultMessage: "Something went wrong when saving this comment. Close the comment or refresh, and try adding your comment again."
    },
    actionNotPermittedTitle: {
        id: "inline-comments-common.error.action.not.permitted.title",
        defaultMessage: "Unauthorized action"
    },
    actionNotPermitted: {
        id: "inline-comments-common.error.action.not.permitted",
        defaultMessage: "You can\u2019t perform that action on inline comments in this space. A space admin can modify your permissions."
    },
    cannotReplyToResolvedComment: {
        id: "inline-comments-common.error.cannot.reply.to.resolved",
        defaultMessage: "You can\u2019t reply to this comment because it was recently resolved by another user. Refresh to view the latest updates."
    },
    cannotUpdateResolvedComment: {
        id: "inline-comments-common.error.cannot.update.resolved",
        defaultMessage: "You can\u2019t edit this comment because it was recently resolved by another user. Refresh to view the latest updates."
    },
    unableToGenerateStep: {
        id: "inline-comments-common.error.unable.to.generate.step",
        defaultMessage: "You can\u2019t create a comment because something went wrong with your highlight. Close this window and create a new highlight."
    },
    contentOutOfDate: {
        id: "inline-comments-common.error.content.out.of.date",
        defaultMessage: "You can\u2019t create a comment here because the text has been changed or removed."
    },
    createTimeout: {
        id: "inline-comments-common.error.create.timeout",
        defaultMessage: "Your request to create a comment timed out. Wait a few moments and save the comment again."
    },
    /**
   * The message below is duplicated in the next files:
   * next/packages/resolved-inline-comments-dialog/src/ResolvedInlineCommentsDialogComponent.tsx
   * packages/confluence-frontend-server/src/components/Comment/PageCommentRenderer.js
   *
   * If you are going to change the message please make sure that the same changes are made in the mentioned above files
   */ a11yCommentLabel: {
        id: "inline-comments-common.a11y.comment.wrapper.label",
        defaultMessage: "Comment by {username}"
    },
    commentActionsMenuLabel: {
        id: "inline-comments-common.comment.actions.menu.label",
        defaultMessage: "More actions"
    },
    copyLinkTooltip: {
        id: "inline-comments-common.tooltip.copy.link",
        defaultMessage: "Copy link to comment"
    },
    linkCopiedTooltip: {
        id: "inline-comments-common.tooltip.link.has.been.copied",
        defaultMessage: "Copied!"
    },
    resolve: {
        id: "inline-comments-common.view.action.resolve",
        defaultMessage: "Resolve"
    },
    resolved: {
        id: "inline-comments-common.view.action.resolved",
        defaultMessage: "Resolved"
    },
    edit: {
        id: "inline-comments-common.view.action.edit",
        defaultMessage: "Edit"
    },
    delete: {
        id: "inline-comments-common.view.action.delete",
        defaultMessage: "Delete"
    },
    reopen: {
        id: "inline-comments-common.action.reopen",
        defaultMessage: "Reopen"
    },
    replyPlaceholder: {
        id: "inline-comments-common.reply.placeholder",
        defaultMessage: "Reply"
    },
    replyPlaceholderWithName: {
        id: "inline-comments-common.reply.placeholder.with-name",
        defaultMessage: "Reply to {name}"
    },
    reactionAriaLabelWithName: {
        id: "inline-comments-common.reaction.aria-label.with-name",
        defaultMessage: "React to {name}\u2019s comment"
    },
    resolveThread: {
        id: "inline-comments-common.resolve-thread",
        defaultMessage: "Resolve comment thread"
    },
    /**
   * Collaborator Onboarding sample comment
   */ sampleAuthor: {
        id: "inline-comments-common.sample.comment.author",
        defaultMessage: "Confluence"
    },
    sampleBody: {
        id: "inline-comments-common.sample.comment.body",
        defaultMessage: "Highlight content to add an inline comment. All viewers can see these, so it\u2019s great for targeted discussion on a specific word or phrase"
    },
    sampleReply: {
        id: "inline-comments-common.sample.reply.input",
        defaultMessage: "disabled reply input"
    },
    sampleReplyPlaceholder: {
        id: "inline-comments-common.sample.reply.placeholder",
        defaultMessage: "Reply"
    },
    sampleReplyTooltip: {
        id: "inline-comments-common.sample.reply.tooltip",
        defaultMessage: "Reply is unavailable for sample comments"
    },
    sampleDeleteHeader: {
        id: "inline-comments-common.sample.comment.delete.header",
        defaultMessage: "Only you can see this."
    },
    sampleDeleteIcon: {
        id: "inline-comments-common.sample.comment.delete.icon",
        defaultMessage: "Delete icon"
    },
    sampleDeleteTooltip: {
        id: "inline-comments-common.sample.comment.delete.tooltip",
        defaultMessage: "Delete sample comment"
    },
    sampleCloseIconLabel: {
        id: "inline-comments-common.sample.comment.delete.icon.label",
        defaultMessage: "Close sample comment"
    },
    collapsedRepliesMore: {
        id: "inline-comments-common.collapsed.replies.more",
        defaultMessage: "{numCollapsedReplies} more replies"
    },
    unreadInlineComment: {
        id: "inline-comments-common.unread.inline.comment",
        defaultMessage: "This is an unread inline comment"
    },
    deletedCommentActionLabel: {
        id: "inline-comments-common.deleted.comment.action.label",
        defaultMessage: "This comment has been deleted"
    },
    resolvedText: {
        id: "inline-comments-common.resolved",
        defaultMessage: "[Resolved]"
    },
    resolvedFlagText: {
        id: "inline-comments-common.resolved.flag.text",
        defaultMessage: "Comment resolved"
    },
    deletedText: {
        id: "inline-comments-common.deleted",
        defaultMessage: "[Deleted]"
    },
    copyLink: {
        id: "inline-comments-common.copy.link",
        defaultMessage: "Copy link"
    },
    goToCommentCTA: {
        id: "inline-comments-common.comment.reopened.flag.cta.gotocomment",
        defaultMessage: "Go to comment"
    },
    undoCTA: {
        id: "inline-comments-common.comment.reopened.flag.cta.undo",
        defaultMessage: "Undo"
    },
    contentDeleted: {
        id: "inline-comments-common.content.deleted",
        defaultMessage: "Content deleted"
    },
    originalContentDeleted: {
        id: "inline-comments-common.original.content.deleted",
        defaultMessage: "Original content deleted"
    },
    thisContentWasDeleted: {
        id: "inline-comments-common.dangling.comments.this.content.was.deleted",
        defaultMessage: "This content was deleted."
    },
    viewDeletedContent: {
        id: "inline-comments-common.dangling.comments.view.deleted.content",
        defaultMessage: "View deleted content"
    },
    collapseDeletedContent: {
        id: "inline-comments-common.dangling.comments.collapse.deleted.content",
        defaultMessage: "Collapse deleted content"
    }
});
module.exports["i18n"] = $90dae8a726ff859c$export$a7357cdd1f0b0168;

});

parcelRegister("kmHPt", function(module, exports) {
var $b271ebdedd90282b$export$b21a3980a7aad169 = /*#__PURE__*/ function(InlineCommentFramework) {
    InlineCommentFramework["BACKBONE"] = "backbone";
    InlineCommentFramework["REACT"] = "react";
    InlineCommentFramework["ANNOTATION_PROVIDER"] = "annotation-provider";
    return InlineCommentFramework;
}({});
module.exports["InlineCommentFramework"] = $b271ebdedd90282b$export$b21a3980a7aad169;

});

parcelRegister("1PPDm", function(module, exports) {
"use strict";
var $15629b4bdedac47d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @name catchError
 */ function $15629b4bdedac47d$var$catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new $15629b4bdedac47d$var$CatchOperator(selector);
        var caught = source.lift(operator);
        return operator.caught = caught;
    };
}
module.exports.catchError = $15629b4bdedac47d$var$catchError;
var $15629b4bdedac47d$var$CatchOperator = function() {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $15629b4bdedac47d$var$CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $15629b4bdedac47d$var$CatchSubscriber = function(_super) {
    $15629b4bdedac47d$var$__extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        _super.call(this, destination);
        this.selector = selector;
        this.caught = caught;
    }
    // NOTE: overriding `error` instead of `_error` because we don't want
    // to have this flag this subscriber as `isStopped`. We can mimic the
    // behavior of the RetrySubscriber (from the `retry` operator), where
    // we unsubscribe from our source chain, reset our Subscriber flags,
    // then subscribe to the selector result.
    CatchSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            } catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            this.add($863V0.subscribeToResult(this, result));
        }
    };
    return CatchSubscriber;
}($hmcLb.OuterSubscriber);

});

parcelRegister("1xJn2", function(module, exports) {
"use strict";
var $11fc112c79ff43c4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $aRdp2 = parcelRequire("aRdp2");


var $iMtch = parcelRequire("iMtch");

/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
 *   .distinctUntilChanged()
 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
 *
 * @example <caption>An example using a compare function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */ function $11fc112c79ff43c4$var$distinctUntilChanged(compare, keySelector) {
    return function(source) {
        return source.lift(new $11fc112c79ff43c4$var$DistinctUntilChangedOperator(compare, keySelector));
    };
}
module.exports.distinctUntilChanged = $11fc112c79ff43c4$var$distinctUntilChanged;
var $11fc112c79ff43c4$var$DistinctUntilChangedOperator = function() {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $11fc112c79ff43c4$var$DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $11fc112c79ff43c4$var$DistinctUntilChangedSubscriber = function(_super) {
    $11fc112c79ff43c4$var$__extends(DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.hasKey = false;
        if (typeof compare === 'function') this.compare = compare;
    }
    DistinctUntilChangedSubscriber.prototype.compare = function(x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function(value) {
        var keySelector = this.keySelector;
        var key = value;
        if (keySelector) {
            key = $aRdp2.tryCatch(this.keySelector)(value);
            if (key === $iMtch.errorObject) return this.destination.error($iMtch.errorObject.e);
        }
        var result = false;
        if (this.hasKey) {
            result = $aRdp2.tryCatch(this.compare)(this.key, key);
            if (result === $iMtch.errorObject) return this.destination.error($iMtch.errorObject.e);
        } else this.hasKey = true;
        if (Boolean(result) === false) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}($fNVRJ.Subscriber);

});

parcelRegister("ebEo2", function(module, exports) {
"use strict";
var $a5416bba69d7cff3$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");

/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */ function $a5416bba69d7cff3$var$skipWhile(predicate) {
    return function(source) {
        return source.lift(new $a5416bba69d7cff3$var$SkipWhileOperator(predicate));
    };
}
module.exports.skipWhile = $a5416bba69d7cff3$var$skipWhile;
var $a5416bba69d7cff3$var$SkipWhileOperator = function() {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a5416bba69d7cff3$var$SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a5416bba69d7cff3$var$SkipWhileSubscriber = function(_super) {
    $a5416bba69d7cff3$var$__extends(SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.skipping = true;
        this.index = 0;
    }
    SkipWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (this.skipping) this.tryCallPredicate(value);
        if (!this.skipping) destination.next(value);
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function(value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}($fNVRJ.Subscriber);

});

parcelRegister("c7Xul", function(module, exports) {
"use strict";
var $8d4448aad9d90f95$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */ function $8d4448aad9d90f95$var$switchMap(project, resultSelector) {
    return function switchMapOperatorFunction(source) {
        return source.lift(new $8d4448aad9d90f95$var$SwitchMapOperator(project, resultSelector));
    };
}
module.exports.switchMap = $8d4448aad9d90f95$var$switchMap;
var $8d4448aad9d90f95$var$SwitchMapOperator = function() {
    function SwitchMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $8d4448aad9d90f95$var$SwitchMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchMapOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $8d4448aad9d90f95$var$SwitchMapSubscriber = function(_super) {
    $8d4448aad9d90f95$var$__extends(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapSubscriber.prototype._next = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result, value, index);
    };
    SwitchMapSubscriber.prototype._innerSub = function(result, value, index) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        this.add(this.innerSubscription = $863V0.subscribeToResult(this, result, value, index));
    };
    SwitchMapSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ SwitchMapSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = null;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) this._tryNotifyNext(outerValue, innerValue, outerIndex, innerIndex);
        else this.destination.next(innerValue);
    };
    SwitchMapSubscriber.prototype._tryNotifyNext = function(outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return SwitchMapSubscriber;
}($hmcLb.OuterSubscriber);

});

parcelRegister("1mLOG", function(module, exports) {
"use strict";
var $0fecefdacae1f75b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $zAMIg = parcelRequire("zAMIg");

function $0fecefdacae1f75b$var$timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = $zAMIg.async;
    return function(source) {
        return source.lift(new $0fecefdacae1f75b$var$TimeIntervalOperator(scheduler));
    };
}
module.exports.timeInterval = $0fecefdacae1f75b$var$timeInterval;
var $0fecefdacae1f75b$var$TimeInterval = function() {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}();
module.exports.TimeInterval = $0fecefdacae1f75b$var$TimeInterval;
var $0fecefdacae1f75b$var$TimeIntervalOperator = function() {
    function TimeIntervalOperator(scheduler) {
        this.scheduler = scheduler;
    }
    TimeIntervalOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $0fecefdacae1f75b$var$TimeIntervalSubscriber(observer, this.scheduler));
    };
    return TimeIntervalOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $0fecefdacae1f75b$var$TimeIntervalSubscriber = function(_super) {
    $0fecefdacae1f75b$var$__extends(TimeIntervalSubscriber, _super);
    function TimeIntervalSubscriber(destination, scheduler) {
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.lastTime = 0;
        this.lastTime = scheduler.now();
    }
    TimeIntervalSubscriber.prototype._next = function(value) {
        var now = this.scheduler.now();
        var span = now - this.lastTime;
        this.lastTime = now;
        this.destination.next(new $0fecefdacae1f75b$var$TimeInterval(value, span));
    };
    return TimeIntervalSubscriber;
}($fNVRJ.Subscriber);

});

parcelRegister("cmyqT", function(module, exports) {
"use strict";
var $90023fbe608f4f3c$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $zAMIg = parcelRequire("zAMIg");


var $fEWBj = parcelRequire("fEWBj");


var $fNVRJ = parcelRequire("fNVRJ");


var $a6ieS = parcelRequire("a6ieS");

/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */ function $90023fbe608f4f3c$var$timeout(due, scheduler) {
    if (scheduler === void 0) scheduler = $zAMIg.async;
    var absoluteTimeout = $fEWBj.isDate(due);
    var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
    return function(source) {
        return source.lift(new $90023fbe608f4f3c$var$TimeoutOperator(waitFor, absoluteTimeout, scheduler, new $a6ieS.TimeoutError()));
    };
}
module.exports.timeout = $90023fbe608f4f3c$var$timeout;
var $90023fbe608f4f3c$var$TimeoutOperator = function() {
    function TimeoutOperator(waitFor, absoluteTimeout, scheduler, errorInstance) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
    }
    TimeoutOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $90023fbe608f4f3c$var$TimeoutSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.scheduler, this.errorInstance));
    };
    return TimeoutOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $90023fbe608f4f3c$var$TimeoutSubscriber = function(_super) {
    $90023fbe608f4f3c$var$__extends(TimeoutSubscriber, _super);
    function TimeoutSubscriber(destination, absoluteTimeout, waitFor, scheduler, errorInstance) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutSubscriber.dispatchTimeout = function(subscriber) {
        subscriber.error(subscriber.errorInstance);
    };
    TimeoutSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.errorInstance = null;
    };
    return TimeoutSubscriber;
}($fNVRJ.Subscriber);

});

parcelRegister("a6ieS", function(module, exports) {
"use strict";
var $75a89ccb17a412ff$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when duetime elapses.
 *
 * @see {@link timeout}
 *
 * @class TimeoutError
 */ var $75a89ccb17a412ff$var$TimeoutError = function(_super) {
    $75a89ccb17a412ff$var$__extends(TimeoutError, _super);
    function TimeoutError() {
        var err = _super.call(this, 'Timeout has occurred');
        this.name = err.name = 'TimeoutError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return TimeoutError;
}(Error);
module.exports.TimeoutError = $75a89ccb17a412ff$var$TimeoutError;

});

parcelRegister("4Otfs", function(module, exports) {
"use strict";
var $3812850d794e9fac$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gGP9M = parcelRequire("gGP9M");


var $371EO = parcelRequire("371EO");

/**
 * @class BehaviorSubject<T>
 */ var $3812850d794e9fac$var$BehaviorSubject = function(_super) {
    $3812850d794e9fac$var$__extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        _super.call(this);
        this._value = _value;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    /** @deprecated internal use only */ BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        if (this.hasError) throw this.thrownError;
        else if (this.closed) throw new $371EO.ObjectUnsubscribedError();
        else return this._value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}($gGP9M.Subject);
module.exports.BehaviorSubject = $3812850d794e9fac$var$BehaviorSubject;

});

parcelRegister("666Tc", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $5SGpQ = parcelRequire("5SGpQ");


var $6mKj3 = parcelRequire("6mKj3");

const $003eb47e4cfe7fce$var$slideOut = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$48377ae1c677702b = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "ul" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_11c8wadc _1yt4v0yc _1e0c1txw _1n261g80 _4cvr1h6o _1tke1f4h",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$4fbc87ee9c503b41 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1as91r31 _j4qy8stv _1wwgnqa1 _v0fytlke",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // Editor feedback button has a z-index of 460; Table sticky header has a z-index of 500; Renderer Page Toolbar has a z-index of 12
const $003eb47e4cfe7fce$export$f39f3f768bc98e3d = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isSticky: isSticky, isAutoDismissResolve: isAutoDismissResolve, ...__cmpldp } = __cmplp;
        const { rightOffset: t3 } = __cmplp;
        const rightOffset = t3 === undefined ? 0 : t3;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_16090q4": (0, $9aYkv.default)(`${rightOffset}px`),
                "--_162hus6": (0, $9aYkv.default)(__cmplp.offset, "px")
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_19itia51 _2rko1l7b _16qs1nax _bfhkvuon _1xi21dwo _154i1odf _1e0c1txw _2lx21bp4 _vchhusvi _otyr53f4 _1bsb1178 _c71lglyw",
                __cmplp.mode === "view" ? "_1pbyibnn" : "_1pby1ap8",
                __cmplp.isSticky ? "_kqsw1n9t" : "_kqswstnw",
                Boolean(__cmplp.isAutoDismissResolve) && "",
                Boolean(__cmplp.isAutoDismissResolve) && "_y44vuwz3",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $003eb47e4cfe7fce$export$82f8f5af33982290 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isSticky: isSticky, isAutoDismissResolve: isAutoDismissResolve, ...__cmpldp } = __cmplp;
        const { rightOffset: t3 } = __cmplp;
        const rightOffset = t3 === undefined ? 0 : t3;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_16090q4": (0, $9aYkv.default)(`${rightOffset}px`),
                "--_162hus6": (0, $9aYkv.default)(__cmplp.offset, "px")
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_19itia51 _2rkopb1k _16qs130s _bfhkvuon _1xi21dwo _154i1odf _1e0c1txw _2lx21bp4 _vchhusvi _otyr53f4 _1bsb1178 _c71lglyw",
                __cmplp.mode === "view" ? "_1pbyibnn" : "_1pby1ap8",
                __cmplp.isSticky ? "_kqsw1n9t" : "_kqswstnw",
                Boolean(__cmplp.isAutoDismissResolve) && "",
                Boolean(__cmplp.isAutoDismissResolve) && "_y44vuwz3",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $003eb47e4cfe7fce$export$18986330a3dbad03 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1e0c1txw _2lx21bp4 _bfhkvuon _521wia51",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$86b1f0d05f7b12cd = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(11);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isCommentsPanel: isCommentsPanel, isFabricPage: isFabricPage, isStandaloneComment: isStandaloneComment, ...__cmpldp } = __cmplp;
        let result;
        if (__cmplp.isStandaloneComment && (0, $6mKj3.expValEquals)("confluence_comments_tuneup", "isEnabled", true)) result = "var(--ds-space-150, 12px)";
        else {
            const basePadding = __cmplp.mode === "view" ? "var(--ds-space-150, 12px) var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px) var(--ds-space-150, 12px)";
            result = __cmplp.isCommentsPanel ? "0" : basePadding;
        }
        const t3 = result;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $9aYkv.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let result_0;
        if (__cmplp.isStandaloneComment && (0, $6mKj3.expValEquals)("confluence_comments_tuneup", "isEnabled", true)) result_0 = "var(--ds-space-150, 12px)";
        else if (!__cmplp.isCommentsPanel) result_0 = "var(--ds-space-200, 16px)";
        else result_0 = "var(--ds-space-150, 12px)";
        const t5 = result_0;
        let t6;
        if ($[5] !== t5) {
            t6 = (0, $9aYkv.default)(t5);
            $[5] = t5;
            $[6] = t6;
        } else t6 = $[6];
        let t7;
        if ($[7] !== __cmpls || $[8] !== t4 || $[9] !== t6) {
            t7 = {
                ...__cmpls,
                "--_35y4il": t4,
                "--_1unxhh5": t6
            };
            $[7] = __cmpls;
            $[8] = t4;
            $[9] = t6;
            $[10] = t7;
        } else t7 = $[10];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: t7,
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_1yt4pe71 _n3td10kh _1k0cel4l _159vzwfg _1wv11rpy",
                __cmplp.isCommentsPanel || __cmplp.isFabricPage ? "_x3doglyw" : "_x3doj0fz",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $003eb47e4cfe7fce$export$5aae1a36fc838370 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1yt41jx0 _1e0c1txw _4cvr1h6o _2lx21bp4 _1i7vwadc _9a6v14no _kckd15o9 _125xi7uo _31ku1h6o _ekv6wadc _dkzuutpp _5lhmtlke _1pzm1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // View mode styled components
const $003eb47e4cfe7fce$export$b38a2fd24b22fb35 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isReply: isReply, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "",
            !__cmplp.isReply && "_1yt4utpp _n7zlia51",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$d1b98bde82a43bb3 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { shouldHaveButtonGap: shouldHaveButtonGap, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1e0c1txw _1usn19bv _1achz0dk _1scmazsu",
            __cmplp.shouldHaveButtonGap && "_zulpv77o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $003eb47e4cfe7fce$export$6e006bd290301009 = '24px';
const $003eb47e4cfe7fce$export$3421cb2750fe78a7 = '28px';
const $003eb47e4cfe7fce$export$28ae196bde1430fd = '24px'; // Needed to get the correct overall size to match the comment icon next to it
const $003eb47e4cfe7fce$var$inlineHeaderButtonTheme = (isSSRFocusedComment)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        return {
            ...theme,
            buttonStyles: {
                ...theme.buttonStyles,
                background: 'none',
                borderRadius: "var(--ds-radius-small, 4px)",
                height: $003eb47e4cfe7fce$export$6e006bd290301009,
                width: $003eb47e4cfe7fce$export$6e006bd290301009,
                '&:hover': {
                    backgroundColor: `${"var(--ds-surface-hovered, #F0F1F2)"}`
                },
                '&:focus': {
                    boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #4688EC)"}`
                },
                cursor: isSSRFocusedComment ? 'not-allowed' : 'pointer',
                '*': {
                    color: isSSRFocusedComment ? `${"var(--ds-text-subtlest, #6B6E76)"}` : `inherit`
                }
            }
        };
    };
const $003eb47e4cfe7fce$export$2616e8e1e1a7c3e5 = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    let isSSRFocusedComment;
    let props;
    if ($[0] !== t0) {
        ({ isSSRFocusedComment: isSSRFocusedComment, ...props } = t0);
        $[0] = t0;
        $[1] = isSSRFocusedComment;
        $[2] = props;
    } else {
        isSSRFocusedComment = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== isSSRFocusedComment) {
        t1 = $003eb47e4cfe7fce$var$inlineHeaderButtonTheme(isSSRFocusedComment);
        $[3] = isSSRFocusedComment;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== props || $[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5SGpQ.default), {
            theme: t1,
            ...props
        });
        $[5] = props;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
const $003eb47e4cfe7fce$export$e575a964a1fe8b0 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { shouldShowNavigation: shouldShowNavigation, isReattachHeader: isReattachHeader, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_kqswh2mm _1e0c1txw _19bvutpp _u5f3utpp",
            __cmplp.shouldShowNavigation ? "_1bah1yb4" : "_1bahesu3",
            __cmplp.shouldShowNavigation && "_4t3i10yn _ca0qutpp",
            __cmplp.isReattachHeader && "_4t3i10yn _ca0qpxbi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$b3b0191112eea395 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $003eb47e4cfe7fce$export$f39f3f768bc98e3d : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1bsb1178 _4t3irvwn",
            __cmplp.showSkeleton ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $003eb47e4cfe7fce$export$f895097fe90363d1 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { showNavigation: showNavigation, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1e0c1txw",
            __cmplp.showNavigation ? "_19pkxy5q" : "_19pkze3t",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$32dd8f1956fe77b1 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_kqswstnw _1xi2utpp _1pbykb7n _154iutpp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$4b61d9d7155e9162 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_zulp12x7 _kqswstnw _154ipxbi _1ltvpxbi _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $003eb47e4cfe7fce$var$closeButtonTheme = (isUpdatedStandaloneComment)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        return {
            ...theme,
            buttonStyles: {
                ...theme.buttonStyles,
                height: $003eb47e4cfe7fce$export$6e006bd290301009,
                width: isUpdatedStandaloneComment ? $003eb47e4cfe7fce$export$28ae196bde1430fd : $003eb47e4cfe7fce$export$3421cb2750fe78a7
            }
        };
    };
const $003eb47e4cfe7fce$export$de65de8213222d10 = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    let isUpdatedStandaloneComment;
    let props;
    if ($[0] !== t0) {
        ({ isUpdatedStandaloneComment: isUpdatedStandaloneComment, ...props } = t0);
        $[0] = t0;
        $[1] = isUpdatedStandaloneComment;
        $[2] = props;
    } else {
        isUpdatedStandaloneComment = $[1];
        props = $[2];
    }
    const t1 = isUpdatedStandaloneComment ?? false;
    let t2;
    if ($[3] !== t1) {
        t2 = $003eb47e4cfe7fce$var$closeButtonTheme(t1);
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== props || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5SGpQ.default), {
            theme: t2,
            ...props
        });
        $[5] = props;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
module.exports["ActionsContainer"] = $003eb47e4cfe7fce$export$48377ae1c677702b;
module.exports["SidebarContainer"] = $003eb47e4cfe7fce$export$f39f3f768bc98e3d;
module.exports["SidebarContainerRounded"] = $003eb47e4cfe7fce$export$82f8f5af33982290;
module.exports["ReplyListContainer"] = $003eb47e4cfe7fce$export$18986330a3dbad03;
module.exports["NewReplyContainer"] = $003eb47e4cfe7fce$export$86b1f0d05f7b12cd;
module.exports["ResolvedNotificationContainer"] = $003eb47e4cfe7fce$export$5aae1a36fc838370;
module.exports["EditorContainer"] = $003eb47e4cfe7fce$export$b38a2fd24b22fb35;
module.exports["NavigationContainer"] = $003eb47e4cfe7fce$export$d1b98bde82a43bb3;
module.exports["InlineHeaderButton"] = $003eb47e4cfe7fce$export$2616e8e1e1a7c3e5;
module.exports["SidebarHeader"] = $003eb47e4cfe7fce$export$e575a964a1fe8b0;
module.exports["LoadingSkeletonContainer"] = $003eb47e4cfe7fce$export$b3b0191112eea395;
module.exports["CloseButtonContainer"] = $003eb47e4cfe7fce$export$32dd8f1956fe77b1;
module.exports["CloseButton"] = $003eb47e4cfe7fce$export$de65de8213222d10;

});

parcelRegister("daq5m", function(module, exports) {
/* CommentAuthor.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $77XlC = parcelRequire("77XlC");


var $aFLCH = parcelRequire("aFLCH");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $6gGPb = parcelRequire("6gGPb");


var $2ot3O = parcelRequire("2ot3O");


var $6Pqow = parcelRequire("6Pqow");


var $kz1Yj = parcelRequire("kz1Yj");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $lpNn5 = parcelRequire("lpNn5");


var $hMaHH = parcelRequire("hMaHH");


var $jJK3p = parcelRequire("jJK3p");


var $fs6LW = parcelRequire("fs6LW");


var $a6t12 = parcelRequire("a6t12");


var $1YXTQ = parcelRequire("1YXTQ");


var $gvWVt = parcelRequire("gvWVt");


var $6faGq = parcelRequire("6faGq");


var $7tI6B = parcelRequire("7tI6B");


var $3ejfs = parcelRequire("3ejfs");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $2GRt3 = parcelRequire("2GRt3");


var $jMyy4 = parcelRequire("jMyy4");


var $e4o8D = parcelRequire("e4o8D");


var $lRNq8 = parcelRequire("lRNq8");


var $cUiCf = parcelRequire("cUiCf");

'use no memo';
const $005e7fbdd3b99ea0$var$CommentAuthorInlineCommentAuthorQuery = (0, $aFLCH.default);
const $005e7fbdd3b99ea0$var$CommentAuthorUserQuery = (0, $77XlC.default);
const $005e7fbdd3b99ea0$var$getAuthorContainerMarginLeft = ({ isFixedEditStyles: isFixedEditStyles, commentMode: commentMode, isReply: isReply, isStandaloneComment: isStandaloneComment, isFooterComment: isFooterComment })=>{
    if (isFixedEditStyles) {
        const negativeMarginForEditMode = (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? '-16px' : '-24px';
        return commentMode === 'edit' ? isReply || isStandaloneComment || isFooterComment ? '0' : negativeMarginForEditMode : undefined;
    }
    return commentMode === 'reply' ? '-2px' : 'inherit';
};
const $005e7fbdd3b99ea0$var$getAuthorContainerPaddingBottom = ({ isFixedEditStyles: isFixedEditStyles, commentMode: commentMode, isReply: isReply })=>{
    if (isFixedEditStyles) return commentMode === 'edit' ? isReply ? '8px' : '12px' : undefined;
    return commentMode === 'view' ? undefined : '8px';
};
const $005e7fbdd3b99ea0$var$authorContainerBaseStyles = null;
const $005e7fbdd3b99ea0$var$AuthorContainer = (props)=>{
    const { commentMode: _commentMode, isReply: _isReply, isStandaloneComment: _isStandaloneComment, isFooterComment: _isFooterComment, isFixedEditStyles: _isFixedEditStyles, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            marginLeft: $005e7fbdd3b99ea0$var$getAuthorContainerMarginLeft(props),
            paddingBottom: $005e7fbdd3b99ea0$var$getAuthorContainerPaddingBottom(props)
        },
        ...rest,
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _1ul9idpf _jva41snc _uvzw1snc _wkreagmp _12rjagmp _gcmzvv82 _1vjrvv82 _5xy14viv _1dtc4viv _1msj4viv"
        ])
    });
};
const $005e7fbdd3b99ea0$var$avatarWrapperBaseStyles = null;
const $005e7fbdd3b99ea0$var$avatarSmallPaddingStyles = null;
const $005e7fbdd3b99ea0$var$avatarLargePaddingStyles = null;
const $005e7fbdd3b99ea0$var$AvatarWrapper = ({ isCommentsTuneupActive: isCommentsTuneupActive, isCommentsPanel: isCommentsPanel, isFooterComment: isFooterComment, isFixedEditStyles: isFixedEditStyles, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ...props,
        className: (0, $hekY6.default)([
            "_1e0c1txw _kqswh2mm",
            !isCommentsTuneupActive && (isCommentsPanel || isFooterComment || isFixedEditStyles) ? "_u5f312x7" : "_u5f3u2gc"
        ])
    });
};
const $005e7fbdd3b99ea0$var$containerStyles = null;
const $005e7fbdd3b99ea0$var$Container = ({ useProfileLinkStyle: useProfileLinkStyle, useColumnStyle: useColumnStyle, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ...props,
        className: (0, $hekY6.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _1ul9idpf _14yyfhey _hwn17g83 _1msj4viv _5xy14viv _1dtc4viv _17rpwadc _cpznidpf _1s79idpf _amufidpf _x966idpf _387xglyw _14l5azsu _1ptk1j28 _19gdazsu _1gidazsu _1e6pazsu",
            useProfileLinkStyle && "_zulpu2gc _1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx2vrvc _4cvr1q9y _1ul9idpf",
            useColumnStyle && "_zulpidpf _2lx21bp4 _4cvr1y6m"
        ])
    });
};
const $005e7fbdd3b99ea0$var$newPageIconStyle = (0, $buxP3.xcss)({
    position: 'relative'
});
const $005e7fbdd3b99ea0$var$coAuthorPersonAvatarStyle = (0, $buxP3.xcss)({
    marginLeft: 'space.200',
    paddingLeft: 'space.025'
});
const $005e7fbdd3b99ea0$var$coAuthorBotAvatarStyle = (0, $buxP3.xcss)({
    position: 'absolute',
    top: 'space.025',
    left: 'space.0'
});
const $005e7fbdd3b99ea0$var$coAuthorCont = (0, $buxP3.xcss)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 'space.075'
});
const $005e7fbdd3b99ea0$var$profileLinkContainerStyle = null;
const $005e7fbdd3b99ea0$var$profileLinkContainerColumnStyle = null;
const $005e7fbdd3b99ea0$var$truncateTextStyle = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
    flex: '1 1 0%',
    wordBreak: 'unset'
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $005e7fbdd3b99ea0$var$ProfileLinkContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = $005e7fbdd3b99ea0$var$Container, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $005e7fbdd3b99ea0$var$LozengeWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_19bvu2gc _s7n4jp4b",
            __cmplp.className
        ])
    });
});
const $005e7fbdd3b99ea0$var$dateContainerBaseStyles = null;
const $005e7fbdd3b99ea0$var$dateContainerStandaloneStyles = null;
const $005e7fbdd3b99ea0$var$dateContainerSubtlestStyles = null;
const $005e7fbdd3b99ea0$var$DateContainer = ({ isStandaloneComment: isStandaloneComment, isCommentsPanel: isCommentsPanel, isFixedEditStyles: isFixedEditStyles, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ...props,
        className: (0, $hekY6.default)([
            "_2lx2vrvc _1n261q9c _1e0c1txw _2lx2n7od _4cvrn7od _102ewadc _1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf _7wy0glyw _1plv1j28 _zmp8azsu _1blwazsu _9b8iazsu _1kcs1y54",
            isStandaloneComment && "_2lx21bp4 _4cvr1y6m",
            (isStandaloneComment || isCommentsPanel && isFixedEditStyles) && "_syaz1rpy"
        ])
    });
}; // confluence_comments_cohiti_date_tooltips exp evaluations will use this component-level i18n object instead of commentsI18n
const $005e7fbdd3b99ea0$var$i18n = (0, $kSwu1.defineMessages)({
    defaultTooltip: {
        id: "inline-comments-common.date-tooltip.default",
        defaultMessage: "Added on {date} at {timestamp}"
    },
    addedTooltip: {
        id: "inline-comments-common.date-tooltip.added",
        defaultMessage: "Added by {username} on {date} at {timeStamp}"
    },
    resolvedTooltip: {
        id: "inline-comments-common.date-tooltip.resolved",
        defaultMessage: "Resolved by {username} on {date} at {timeStamp}"
    },
    reopenedTooltip: {
        id: "inline-comments-common.date-tooltip.reopened",
        defaultMessage: "Reopened by {username} on {date} at {timeStamp}"
    },
    reopenedDateInfoText: {
        id: "inline-comments-common.reopened.date.info.text",
        defaultMessage: "Reopened {timeAgo}{timeStamp, select,\n\t\t\tundefined {}\n\t\t\tother { at {timeStamp}}\n\t\t}"
    },
    resolvedDateInfoText: {
        id: "inline-comments-common.resolved.date.info.text",
        defaultMessage: "Resolved {timeAgo}"
    },
    coAuthorWithUser: {
        id: "inline-comments-common.co-author.with-user",
        defaultMessage: "with {username}"
    }
});
const $005e7fbdd3b99ea0$export$d05a2f5fbf67a6d7 = ({ commentMode: commentMode, userId: userId, date: date, createdAtNonLocalized: createdAtNonLocalized, size: size, displayName: displayName, avatarUrl: avatarUrl, commentId: commentId, permissionType: permissionType, isInactiveComment: isInactiveComment, resolveProperties: resolveProperties, isCommentsPanel: isCommentsPanel = false, isGeneralComments: isGeneralComments = false, isReply: isReply = false, isFooterComment: isFooterComment = false, isStandaloneComment: isStandaloneComment = false, contributors: contributors })=>{
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const skipUserIdPath = Boolean(avatarUrl && displayName || !userId || commentId);
    const coAuthor = contributors?.find((contributor)=>contributor?.displayName);
    const coAuthorName = coAuthor?.displayName;
    const coAuthorAvatarUrl = coAuthor?.profilePicture?.path;
    const shouldShowCoAuthor = Boolean(coAuthorName && !renderServerPlaceholder);
    const { data: authorData } = (0, $jMyy4.useQueryInterop)($005e7fbdd3b99ea0$var$CommentAuthorInlineCommentAuthorQuery, {
        variables: {
            commentId: commentId
        },
        fetchPolicy: 'cache-and-network',
        skip: Boolean(userId || !commentId),
        __callerPackage__: "inline-comments-common"
    });
    const { data: userDataFromOld } = (0, $jMyy4.useQueryInterop)($005e7fbdd3b99ea0$var$CommentAuthorUserQuery, {
        variables: {
            id: userId
        },
        fetchPolicy: 'cache-and-network',
        skip: skipUserIdPath || (0, $6mKj3.expValEquals)('confluence_comment_improve_author_paint', 'isEnabled', true),
        __callerPackage__: "inline-comments-common"
    });
    const { data: userDataFromNew } = (0, $cUiCf.useCommentAuthorQuery)(userId ?? undefined, {
        skip: skipUserIdPath || !(0, $6mKj3.expValEquals)('confluence_comment_improve_author_paint', 'isEnabled', true),
        fetchPolicy: 'cache-and-network'
    });
    const userData = (0, $6mKj3.expValEquals)('confluence_comment_improve_author_paint', 'isEnabled', true) ? userDataFromNew : userDataFromOld;
    const author = (authorData?.content?.nodes || [])[0]?.history?.createdBy;
    const userAvatar = author ? author.profilePicture?.path : (userData?.user?.photos || [])[0]?.value;
    const userDisplayName = author ? author.displayName : userData?.user?.displayName;
    const userAccountId = author?.accountId;
    const intl = (0, $kSwu1.useIntl)();
    const { formatMessage: formatMessage } = intl;
    const { timeZone: userTimeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    const timeZone = userTimeZone || tenantTimeZone || undefined;
    const getTooltipContent = ()=>{
        if (resolveProperties?.resolvedTime && (0, $6mKj3.expValEquals)('confluence_comments_cohiti_date_tooltips', 'isEnabled', true)) {
            // resolveProperties.resolved = true -> comment is in resolved state
            // resolveProperties.resolved = false -> comment is in re-opened state
            const i18nMessage = resolveProperties?.resolved ? $005e7fbdd3b99ea0$var$i18n.resolvedTooltip : $005e7fbdd3b99ea0$var$i18n.reopenedTooltip;
            const resolvedTimeBase = new Date(resolveProperties.resolvedTime);
            return formatMessage(i18nMessage, {
                username: resolveProperties?.resolvedUser,
                date: intl.formatDate(resolvedTimeBase, {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                    timeZone: timeZone
                }),
                timeStamp: intl.formatTime(resolvedTimeBase, {
                    hour: 'numeric',
                    minute: 'numeric',
                    timeZone: timeZone
                })
            });
        }
        if (resolveProperties?.resolved) return formatMessage((0, $3ejfs.commentsi18n).resolvedByTooltipTextCommentsPanel, {
            username: resolveProperties?.resolvedUser
        });
        return formatMessage((0, $3ejfs.commentsi18n).reopenedByTooltipTextCommentsPanel, {
            username: resolveProperties?.resolvedUser,
            createdAtNonLocalized: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1YXTQ.TimeAgo), {
                date: (0, $6faGq.getValidDate)(createdAtNonLocalized),
                usePrepositions: true
            })
        });
    };
    const getResolvedDateInfoText = ()=>{
        // resolveProperties.resolved = true -> comment is in resolved state
        // resolveProperties.resolved = false -> comment is in re-opened state
        const i18nKey = resolveProperties?.resolved ? 'resolvedDateInfoText' : 'reopenedDateInfoText';
        if (resolveProperties?.resolvedTime && (0, $6mKj3.expValEquals)('confluence_comments_cohiti_date_tooltips', 'isEnabled', true)) {
            const resolvedTimeBase_0 = new Date(resolveProperties.resolvedTime);
            const twentyFourHourThreshold = 86400; // in seconds
            const secondsSinceReopen = (Date.now() - resolvedTimeBase_0.getTime()) / 1000; // Don't include a timestamp if the comment was re-opened less than 24 hours ago
            const shouldIncludeTimeStamp = secondsSinceReopen >= twentyFourHourThreshold;
            return formatMessage($005e7fbdd3b99ea0$var$i18n[i18nKey], {
                // use formatTimeAgo directly so that this string can be injected into aria-label,
                timeAgo: (0, $1YXTQ.formatTimeAgo)(intl, resolvedTimeBase_0, true, {}, userTimeZone, tenantTimeZone),
                timeStamp: shouldIncludeTimeStamp && !(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? intl.formatTime(resolvedTimeBase_0, {
                    hour: 'numeric',
                    minute: 'numeric',
                    timeZone: timeZone
                }) : undefined
            });
        } else return formatMessage((0, $3ejfs.commentsi18n)[i18nKey], {
            friendlyDate: resolveProperties?.resolvedFriendlyDate
        });
    };
    const newExperienceResolveInfo = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            position: "top",
            content: getTooltipContent()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-label": getResolvedDateInfoText()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
            color: "color.text.subtlest",
            size: "small",
            maxLines: 2
        }, getResolvedDateInfoText())));
    };
    const hasPageCommentIconEnabled = (0, $cozmU.useCallback)(()=>{
        if (!isGeneralComments) return false;
        return !isFooterComment;
    }, [
        isGeneralComments,
        isFooterComment
    ]);
    const renderCopyButton = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($005e7fbdd3b99ea0$var$DateContainer, {
            isStandaloneComment: isStandaloneComment,
            isCommentsPanel: isCommentsPanel,
            isFixedEditStyles: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            space: "space.050"
        }, resolveProperties?.resolved || resolveProperties?.resolvedFriendlyDate ? newExperienceResolveInfo() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: (0, $6mKj3.expValEquals)('confluence_comments_cohiti_date_tooltips', 'isEnabled', true) ? formatMessage($005e7fbdd3b99ea0$var$i18n.defaultTooltip, {
                date: intl.formatDate((0, $6faGq.getValidDate)(createdAtNonLocalized), {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                    timeZone: timeZone
                }),
                timestamp: intl.formatTime((0, $6faGq.getValidDate)(createdAtNonLocalized), {
                    hour: 'numeric',
                    minute: 'numeric',
                    timeZone: timeZone
                })
            }) : undefined
        }, (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2GRt3.RelativeTimestamp), {
            date: (0, $6faGq.getValidDate)(createdAtNonLocalized)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1YXTQ.TimeAgo), {
            date: (0, $6faGq.getValidDate)(createdAtNonLocalized)
        })), hasPageCommentIconEnabled() && !isReply && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $005e7fbdd3b99ea0$var$newPageIconStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
            color: "var(--ds-icon-subtlest, #6B6E76)",
            testId: "general-comment-page-icon",
            label: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        }))))));
    };
    const humanAuthorName = displayName || userDisplayName;
    const name = humanAuthorName || '';
    const shouldShowHumanAuthorByline = Boolean(shouldShowCoAuthor && humanAuthorName);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($005e7fbdd3b99ea0$var$AuthorContainer, {
        commentMode: commentMode,
        isReply: isReply,
        isStandaloneComment: isStandaloneComment,
        isFooterComment: isFooterComment,
        isFixedEditStyles: true,
        "data-testid": "comment-author"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($005e7fbdd3b99ea0$var$AvatarWrapper, {
        isCommentsPanel: isCommentsPanel,
        isFooterComment: isFooterComment,
        isFixedEditStyles: true,
        isCommentsTuneupActive: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: shouldShowCoAuthor ? $005e7fbdd3b99ea0$var$coAuthorPersonAvatarStyle : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fs6LW.ProfileAvatar), {
        isBlockLevel: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true),
        userId: userId,
        src: avatarUrl || userAvatar,
        trigger: "click",
        size: size,
        name: name
    })), shouldShowCoAuthor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $005e7fbdd3b99ea0$var$coAuthorBotAvatarStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2ot3O.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
        userId: coAuthor?.accountId,
        trigger: "click",
        fullName: coAuthorName ?? undefined,
        // migrated profile card render the dedicated AgentCard instead of CardError.
        // (Ignored by the platform card when the subject isn't an agent.)
        agent: {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
        imageUrl: coAuthorAvatarUrl ?? undefined,
        agentIdentityAccountId: coAuthor?.accountId,
        size: size,
        name: coAuthorName ?? ''
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lRNq8.MaybeTooltip), {
        date: date,
        name: name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($005e7fbdd3b99ea0$var$Container, {
        useProfileLinkStyle: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true),
        useColumnStyle: !!(resolveProperties?.resolved || resolveProperties?.resolvedFriendlyDate) && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($005e7fbdd3b99ea0$var$ProfileLinkContainer, null, isInactiveComment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": "dummy-profile-link"
    }, humanAuthorName) : shouldShowCoAuthor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $005e7fbdd3b99ea0$var$coAuthorCont
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        weight: "medium"
    }, coAuthorName)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJK3p.ProfileLink), {
        fullName: humanAuthorName,
        userId: userId || userAccountId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            wordBreak: 'break-word',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            color: "var(--ds-text, #292A2E)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            fontWeight: "var(--ds-font-weight-medium, 500)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && $005e7fbdd3b99ea0$var$truncateTextStyle
        },
        isUnderlinedByDefault: false
    }), shouldShowHumanAuthorByline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        color: "color.text.subtlest",
        size: "small"
    }, formatMessage($005e7fbdd3b99ea0$var$i18n.coAuthorWithUser, {
        username: humanAuthorName
    })), permissionType === (0, $7tI6B.SitePermissionType).EXTERNAL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($005e7fbdd3b99ea0$var$LozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gvWVt.ExternalCollaboratorUserLozenge), null)) : null), date && renderCopyButton())));
};
module.exports["CommentAuthor"] = $005e7fbdd3b99ea0$export$d05a2f5fbf67a6d7;

});

parcelRegister("77XlC", function(module, exports) {
/**
 * @generated SignedSource<<c8dd3eccb7ba33dbc36dc502d60b3ff0>>
 * @relayHash 7603ffb5cdb0040c872fb1a866b28175
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0b1e2510061c030d99b8f44e327d161323fb6339bea4e158cd11ff183a6440a0
const $a4999a70afb18ca0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CommentAuthorUserQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CommentAuthorUserQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7603ffb5cdb0040c872fb1a866b28175",
            "id": "0b1e2510061c030d99b8f44e327d161323fb6339bea4e158cd11ff183a6440a0",
            "metadata": {},
            "name": "CommentAuthorUserQuery",
            "operationKind": "query",
            "text": "query CommentAuthorUserQuery($id:ID!){user:confluence_atlassianUser(id:$id){id,displayName,photos{value}}}"
        }
    };
}();
$a4999a70afb18ca0$var$node.hash = "b941cc393296a840051106bc2b577a66";
var $a4999a70afb18ca0$export$2e2bcd8739ae039 = $a4999a70afb18ca0$var$node;
module.exports["default"] = $a4999a70afb18ca0$export$2e2bcd8739ae039;

});

parcelRegister("aFLCH", function(module, exports) {
/**
 * @generated SignedSource<<a6597d231499a8b61bc3837e689f275f>>
 * @relayHash 3fce16c4b50c6a412fa8487092b88148
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e22018d4069a45e8f6db8aee4f779ec3d1167f9f1b3abb3096b28120a93d6641
const $05493535de3a048c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "commentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v4 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CommentAuthorInlineCommentAuthorQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CommentAuthorInlineCommentAuthorQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "3fce16c4b50c6a412fa8487092b88148",
            "id": "e22018d4069a45e8f6db8aee4f779ec3d1167f9f1b3abb3096b28120a93d6641",
            "metadata": {},
            "name": "CommentAuthorInlineCommentAuthorQuery",
            "operationKind": "query",
            "text": "query CommentAuthorInlineCommentAuthorQuery($commentId:ID!){content(id:$commentId){nodes{id,history{createdBy{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}}}"
        }
    };
}();
$05493535de3a048c$var$node.hash = "7be748651ddc7f6e555a6f8193a7649c";
var $05493535de3a048c$export$2e2bcd8739ae039 = $05493535de3a048c$var$node;
module.exports["default"] = $05493535de3a048c$export$2e2bcd8739ae039;

});

parcelRegister("7tI6B", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $89d6a09a4f827a20$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["SitePermissionType"] = $89d6a09a4f827a20$export$8995abb8169b2cb8;

});

parcelRegister("lRNq8", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $lpNn5 = parcelRequire("lpNn5");


var $iMnC5 = parcelRequire("iMnC5");


var $6faGq = parcelRequire("6faGq");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");

const $82d0090970c55653$var$styles = {
    tooltipWrapper: "_1ul9idpf"
};
const $82d0090970c55653$var$i18n = (0, $kSwu1.defineMessages)({
    addedTooltip: {
        id: "inline-comments-common.date-tooltip.added",
        defaultMessage: "Added by {username} on {date} at {timeStamp}"
    }
});
const $82d0090970c55653$export$8d25ba73a810c5c5 = (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, date: date, name: name } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const { formatMessage: formatMessage } = intl;
    const { timeZone: userTimeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    const timeZone = userTimeZone || tenantTimeZone || undefined;
    let t1;
    if ($[0] !== children || $[1] !== date || $[2] !== formatMessage || $[3] !== intl || $[4] !== name || $[5] !== timeZone) {
        t1 = date && (0, $6mKj3.expValEquals)("confluence_comments_tuneup", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $82d0090970c55653$var$styles.tooltipWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: formatMessage($82d0090970c55653$var$i18n.addedTooltip, {
                username: name,
                date: intl.formatDate((0, $6faGq.getValidDate)(date), {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                    timeZone: timeZone
                }),
                timeStamp: intl.formatTime((0, $6faGq.getValidDate)(date), {
                    hour: "numeric",
                    minute: "numeric",
                    timeZone: timeZone
                })
            })
        }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[0] = children;
        $[1] = date;
        $[2] = formatMessage;
        $[3] = intl;
        $[4] = name;
        $[5] = timeZone;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
};
module.exports["MaybeTooltip"] = $82d0090970c55653$export$8d25ba73a810c5c5;

});

parcelRegister("cUiCf", function(module, exports) {

var $kVisP = parcelRequire("kVisP");


var $jMyy4 = parcelRequire("jMyy4");

const $e7d88eb3577c40b3$export$81e6931b5465b2c6 = (0, $kVisP.default);
const $e7d88eb3577c40b3$export$15a9d6bfd715c3fb = (userId, options = {})=>{
    const { skip: skip = !userId, fetchPolicy: fetchPolicy = 'cache-and-network' } = options;
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($e7d88eb3577c40b3$export$81e6931b5465b2c6, {
        variables: {
            id: userId
        },
        fetchPolicy: fetchPolicy,
        skip: skip || !userId,
        __callerPackage__: "inline-comments-common"
    });
    const isReady = skip || !!data || !loading;
    return {
        data: data,
        loading: loading,
        isReady: isReady
    };
};
module.exports["useCommentAuthorQuery"] = $e7d88eb3577c40b3$export$15a9d6bfd715c3fb;

});

parcelRegister("kVisP", function(module, exports) {
/**
 * @generated SignedSource<<718e4c01e003daae73589be1171ec056>>
 * @relayHash d7dd18272a64084411071f3794bede2a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 034bbfdcc82ad8b892c7f2334d1da72b0bff1c2b16820174371933b530761c1d
const $a036ea87d0b71d0a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCommentAuthorQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCommentAuthorQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "d7dd18272a64084411071f3794bede2a",
            "id": "034bbfdcc82ad8b892c7f2334d1da72b0bff1c2b16820174371933b530761c1d",
            "metadata": {},
            "name": "useCommentAuthorQuery",
            "operationKind": "query",
            "text": "query useCommentAuthorQuery($id:ID!){user:confluence_atlassianUser(id:$id){id,displayName,photos{value}}}"
        }
    };
}();
$a036ea87d0b71d0a$var$node.hash = "5a28bff8b85798e31c8498c8ffd13edb";
var $a036ea87d0b71d0a$export$2e2bcd8739ae039 = $a036ea87d0b71d0a$var$node;
module.exports["default"] = $a036ea87d0b71d0a$export$2e2bcd8739ae039;

});

parcelRegister("kuBT6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::28489413fc4445a7626c716baa7dc401>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eeb3ffb0a3d9112d$var$_react = $eeb3ffb0a3d9112d$var$_interopRequireDefault((parcelRequire("cozmU")));

var $eeb3ffb0a3d9112d$var$_baseNew = $eeb3ffb0a3d9112d$var$_interopRequireDefault((parcelRequire("gElAV")));
function $eeb3ffb0a3d9112d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ReplyLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Known uses: replying to a message thread
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eeb3ffb0a3d9112d$var$ReplyLeftIcon = (props)=>/*#__PURE__*/ $eeb3ffb0a3d9112d$var$_react.default.createElement($eeb3ffb0a3d9112d$var$_baseNew.default, Object.assign({
        name: "ReplyLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M5.78 2.28 2.56 5.498H7.5a8.5 8.5 0 0 1 8.5 8.5h-1.5a7 7 0 0 0-7-7H2.56l3.22 3.22-1.06 1.06-4.5-4.5a.75.75 0 0 1 0-1.06l4.5-4.5z"/>`
    }, props));
$eeb3ffb0a3d9112d$var$ReplyLeftIcon.displayName = 'ReplyLeftIcon';
var $eeb3ffb0a3d9112d$var$_default = module.exports.default = $eeb3ffb0a3d9112d$var$ReplyLeftIcon;

});

parcelRegister("fURMF", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");

const $e9d2c346c5e28ee8$var$logger = (0, $7W8i8.getLogger)('scroll-to-element');
/**
 * Returns the HTMLElement that should be used as the scroll root.
 * This is the div with id=AkMainContent when on desktop, falling back to window on mobile.
 */ function $e9d2c346c5e28ee8$var$getScrollRootElement() {
    // On mobile sizes, scroll the window instead of #AkMainContent.
    // The magic number maps to media.above.md @media (min-width: 64rem) = 1024px.
    if (typeof document !== 'undefined' && typeof window !== 'undefined') {
        const akMainContent = document.getElementById('AkMainContent');
        if (window.innerWidth > 1023 && akMainContent) return akMainContent;
        return window;
    }
    return null;
}
const $e9d2c346c5e28ee8$var$explicitScrollListeners = new Set();
function $e9d2c346c5e28ee8$export$73ac910751bb2a9b(listener) {
    $e9d2c346c5e28ee8$var$explicitScrollListeners.add(listener);
    return ()=>$e9d2c346c5e28ee8$var$explicitScrollListeners.delete(listener);
}


function $e9d2c346c5e28ee8$var$invokeExplicitScrollListeners() {
    $e9d2c346c5e28ee8$var$explicitScrollListeners.forEach((listener)=>{
        try {
            listener();
        } catch (error) {
            Promise.all([
                (parcelRequire("2tnYT")),
                (parcelRequire("gBChQ"))
            ]).then(([{ getMonitoringClient: getMonitoringClient }, { Attribution: Attribution }])=>{
                getMonitoringClient().submitError(error, {
                    attribution: Attribution.PAGE_EXTENSIONS
                });
            }).catch(()=>{
            // ignore errors, we can't do anything at this point
            });
        }
    });
}
function $e9d2c346c5e28ee8$var$isSmoothScrollSupported() {
    return typeof document !== 'undefined' && 'scrollBehavior' in document.documentElement.style;
}
function $e9d2c346c5e28ee8$export$9b071b9c6dd786a2(isSmooth = false) {
    $e9d2c346c5e28ee8$var$invokeExplicitScrollListeners();
    const scrollRootElement = $e9d2c346c5e28ee8$var$getScrollRootElement();
    if (scrollRootElement) {
        // scrollRootElement is null during SSR — skip scrolling in that case
        if (isSmooth && $e9d2c346c5e28ee8$var$isSmoothScrollSupported()) scrollRootElement.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
        else scrollRootElement.scrollTo(0, 0);
    }
}
function $e9d2c346c5e28ee8$export$2353115f31f4d15(element, scrollCorrectionPixels, scrollBehavior = 'auto', isLivePage) {
    const scrollRootElement = isLivePage ? typeof document !== 'undefined' ? document.querySelector('.fabric-editor-popup-scroll-parent') : null : $e9d2c346c5e28ee8$var$getScrollRootElement();
    let parentsOffset = 0;
    let currentOffsetParent = element.offsetParent;
    while(currentOffsetParent instanceof HTMLElement && currentOffsetParent != scrollRootElement){
        parentsOffset += currentOffsetParent.offsetTop;
        currentOffsetParent = currentOffsetParent.offsetParent;
    }
    const pageHeaderHeightAdjustment = 56;
    let top = element.offsetTop + (scrollCorrectionPixels || 0) + parentsOffset - pageHeaderHeightAdjustment;
    // check if element is nested inside table, if so we need to account for
    // sticky table header overlapping the element
    const hasTableParent = element?.closest('.pm-table-container td');
    if (hasTableParent && scrollCorrectionPixels) top = top + scrollCorrectionPixels * 1.25;
    $e9d2c346c5e28ee8$var$invokeExplicitScrollListeners();
    let behavior = scrollBehavior;
    if (behavior === 'smooth' && !$e9d2c346c5e28ee8$var$isSmoothScrollSupported()) behavior = 'auto';
    try {
        scrollRootElement?.scroll({
            top: top,
            behavior: behavior
        });
    } catch  {
        $e9d2c346c5e28ee8$var$logger.error`scroll() is not supported on #AkMainContent`;
    }
}
function $e9d2c346c5e28ee8$export$8611df79cae6484f(element) {
    if (typeof document !== 'undefined') {
        const scrollContainer = document.getElementById('AkMainContent');
        const breadcrumbHeaderHeight = 56; // FixedSpaceHeaderContainer (top nav) of the classic full page
        if (scrollContainer && scrollContainer.contains(element)) {
            // Let the browser calculate the exact scroll position
            const savedScroll = scrollContainer.scrollTop;
            element.scrollIntoView({
                behavior: 'instant',
                block: 'start'
            });
            const targetScroll = scrollContainer.scrollTop;
            scrollContainer.scrollTop = savedScroll;
            scrollContainer.scrollTo({
                left: 0,
                top: targetScroll - breadcrumbHeaderHeight,
                behavior: 'smooth'
            });
        } else element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }
}
module.exports["scrollToPageStart"] = $e9d2c346c5e28ee8$export$9b071b9c6dd786a2;
module.exports["scrollToElement"] = $e9d2c346c5e28ee8$export$2353115f31f4d15;
module.exports["scrollToBlockForViewPage"] = $e9d2c346c5e28ee8$export$8611df79cae6484f;

});

parcelRegister("2tnYT", function(module, exports) {

let $1cd0e4621aa50ab2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1cd0e4621aa50ab2$var$load("9fiFD").then(()=>parcelRequire('6SqQk'));

});

parcelRegister("gBChQ", function(module, exports) {

let $c16dcd029b34a01f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c16dcd029b34a01f$var$load("fH5Zm").then(()=>parcelRequire('bZmZf'));

});

parcelRegister("c6FO3", function(module, exports) {

var $dEABD = parcelRequire("dEABD");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $3d3WW = parcelRequire("3d3WW");


var $cJomY = parcelRequire("cJomY");


var $hRnS5 = parcelRequire("hRnS5");


var $lpNn5 = parcelRequire("lpNn5");


var $aBKty = parcelRequire("aBKty");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $zzZbq = parcelRequire("zzZbq");

var $7P5ob = parcelRequire("7P5ob");

var $gYQp3 = parcelRequire("gYQp3");

var $eIO9N = parcelRequire("eIO9N");

var $iuy8J = parcelRequire("iuy8J");


var $7mZPi = parcelRequire("7mZPi");


var $9wGTI = parcelRequire("9wGTI");


var $bzqa9 = parcelRequire("bzqa9");


var $h0UOA = parcelRequire("h0UOA");


var $l8wPz = parcelRequire("l8wPz");


var $lmNXu = parcelRequire("lmNXu");


var $hEeUR = parcelRequire("hEeUR");


var $7mpOv = parcelRequire("7mpOv");


var $chaNr = parcelRequire("chaNr");


var $1C1zB = parcelRequire("1C1zB");


var $gw4Eo = parcelRequire("gw4Eo");


var $eV0v4 = parcelRequire("eV0v4");


var $dPJCf = parcelRequire("dPJCf");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $8i27m = parcelRequire("8i27m");


var $1YXTQ = parcelRequire("1YXTQ");


var $3ejfs = parcelRequire("3ejfs");


var $6faGq = parcelRequire("6faGq");


var $en1dX = parcelRequire("en1dX");


var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $iKSlH = parcelRequire("iKSlH");


var $97Szk = parcelRequire("97Szk");


var $fFmJj = parcelRequire("fFmJj");


var $g7Tm3 = parcelRequire("g7Tm3");


var $1TLVx = parcelRequire("1TLVx");

const $dc146e3974e81fa1$var$NARROW_EMBED_THRESHOLD = 480;
const $dc146e3974e81fa1$var$nativeEmbedWrapperStyle = null;
const $dc146e3974e81fa1$var$NativeEmbedCard = ({ url: url })=>{
    const [appearance, setAppearance] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState('block');
    const containerRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        const el = containerRef.current;
        if (!el) return;
        const observer = new ResizeObserver(([entry])=>{
            setAppearance(entry.contentRect.width >= $dc146e3974e81fa1$var$NARROW_EMBED_THRESHOLD ? 'embed' : 'block');
        });
        observer.observe(el);
        return ()=>observer.disconnect();
    }, []); // url is always validated at call site (safeUrl); empty string means invalid URL
    if (!url) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: containerRef,
        className: (0, $hekY6.default)([
            "_1bsb1osq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
        url: url,
        appearance: appearance
    }));
};
const $dc146e3974e81fa1$var$i18n = (0, $kSwu1.defineMessages)({
    editedInParentheses: {
        id: "comment.renderer.edited.in.parentheses",
        defaultMessage: "(edited)"
    },
    editedBy: {
        id: "comment.renderer.edited.by",
        defaultMessage: "Edited by {username} {at}"
    }
}); // Approx Scroll Height for Comment Container with 2 Lines
const $dc146e3974e81fa1$var$MIN_SCROLL_HEIGHT = 50;
const $dc146e3974e81fa1$var$standaloneStyle = null;
const $dc146e3974e81fa1$var$standaloneStyleV2 = null;
const $dc146e3974e81fa1$var$commentsPanelV2Style = null;
const $dc146e3974e81fa1$var$commentEditedLabelStyle = null;
const $dc146e3974e81fa1$export$fb8f382757c44d14 = (entry, hasBeenViewed, commentId, setHasBeenViewed, markCommentsRead)=>{
    if (entry.isIntersecting) // Comment entered the viewport
    setHasBeenViewed(true);
    else if (hasBeenViewed) // Comment left the viewport after it was viewed
    markCommentsRead({
        variables: {
            commentIds: [
                commentId
            ]
        }
    });
};
const $dc146e3974e81fa1$export$ce6d3ea87eba7794 = /*#__PURE__*/ (0, $cozmU.memo)(({ commentId: commentId, adf: adf, onContentFallback: onContentFallback, isTruncatedContent: isTruncatedContent, onRendered: onRendered, maxHeight: maxHeight, fadeOutHeight: fadeOutHeight, onComplete: onComplete, isInlineComment: isInlineComment, isCommentsPanel: isCommentsPanel = false, isEdited: isEdited, versionByDisplayName: versionByDisplayName, versionDate: versionDate, commentType: commentType, annotationId: annotationId, annotatedText: annotatedText, hideAiSuggestEdit: hideAiSuggestEdit = false, isReply: isReply = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const [rootEl, setRootEl] = (0, $cozmU.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { activationId: activationId, cloudId: cloudId, locale: locale, userId: userId, featureFlags: featureFlags, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const readFragmentInterop = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $dEABD.default),
        __callerPackage__: "comment"
    });
    let analyticsContextSource = (0, $en1dX.AnalyticsSource).COMMENTS_PANEL;
    let definitionExperienceName = 'commentPanelAutohighlight';
    if (!isCommentsPanel) {
        if (commentType === (0, $8i27m.CommentType).GENERAL) {
            analyticsContextSource = (0, $en1dX.AnalyticsSource).PAGE_FOOTER;
            definitionExperienceName = 'commentFooterAutohighlight';
        } else {
            analyticsContextSource = (0, $en1dX.AnalyticsSource).STANDALONE;
            definitionExperienceName = 'commentInlineAutohighlight';
        }
    }
    const { isRovoEnabled: isRovoEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const { isAIEnabledForContent: isAIEnabledForContent, isRovoEnabledForContent: isRovoEnabledForContent } = (0, $7mpOv.useIsAIEnabledForContent)({
        contentId: contentId
    });
    const isDefinitionsEnabled = (isAIEnabledForContent || isRovoEnabledForContent) && locale.startsWith('en') && !JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_READING_AIDS_AUTO_HIGHLIGHT) || '""') && (0, $9wGTI.fg)('kd_definitions_enable_confluence_comments');
    const cloudIdARI = (0, $aBKty.ConfluenceSiteAri).create({
        siteId: cloudId
    }).toString();
    const contentARI = contentType ? (0, $gw4Eo.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: contentType,
        resourceId: contentId || '',
        activationId: ''
    }) : '';
    const spaceARI = spaceId ? (0, $gw4Eo.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: 'space',
        resourceId: spaceId,
        activationId: ''
    }) : '';
    const workspaceId = (0, $gw4Eo.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: 'workspace',
        resourceId: activationId,
        activationId: ''
    }); // entityAri is empty string to fetch acronyms used in comment text (see loadAutohighlights)
    // rather than acronyms used in associated page to prevent them being highlighted again
    const { keyPhrases: keyPhrases, autoHighlightRegex: autoHighlightRegex, loadAutohighlights: loadAutohighlights } = (0, $eIO9N.useAutohighlightSupplier)({
        entityAri: '',
        workspaceId: workspaceId,
        product: 'confluence',
        cloudId: cloudId
    });
    const { fetchDefinition: fetchDefinition } = (0, $iuy8J.useDefinitionSupplier)({
        workspaceId: workspaceId,
        cloudIdARI: cloudIdARI,
        product: 'confluence',
        fetchConfig: {
            entity_ari: contentARI
        },
        productConfig: {
            contentId: contentARI,
            spaceId: spaceARI
        },
        isDefinitionCurationEnabled: true
    });
    const onDisableDefinitions = (0, $cozmU.useCallback)(()=>{
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_READING_AIDS_AUTO_HIGHLIGHT, true);
    }, []);
    const onEnableDefinitions = (0, $cozmU.useCallback)(()=>{
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_READING_AIDS_AUTO_HIGHLIGHT, false);
    }, []);
    const getDefinitionsDisabled = (0, $cozmU.useCallback)(()=>{
        return (0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_READING_AIDS_AUTO_HIGHLIGHT);
    }, []);
    const definitionRestrictionOptions = (0, $97Szk.useDefinitionRestrictionOptions)(contentType);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $9wGTI.fg)('kd_definitions_enable_confluence_comments')) {
            const text = adf ? (0, $gYQp3.parseContent)(adf) : '';
            loadAutohighlights({
                inputText: {
                    text: text,
                    format: (0, $7P5ob.KnowledgeDiscoveryKeyPhraseInputTextFormat).PLAIN
                }
            });
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const memoTextPlatformHighlighter = (0, $cozmU.useMemo)(()=>{
        const sourceConfig = {
            brand: isRovoEnabled ? (0, $zzZbq.AiBrand).ROVO : (0, $zzZbq.AiBrand).AI,
            cloudId: cloudId,
            contentARI: contentARI,
            contentId: contentId,
            experience: definitionExperienceName,
            source: 'readingAids',
            sourceProduct: 'confluence',
            userId: userId,
            workspaceId: workspaceId,
            orgId: orgId
        };
        const curatedDefinitionScopeConfig = {
            workspaceId: workspaceId,
            definitionRestrictionOptions: definitionRestrictionOptions,
            productScopes: {
                contentARI: contentARI,
                spaceARI: spaceARI
            },
            cloudId: cloudId,
            product: 'confluence'
        };
        const definitionConfig = {
            fetchDefinition: fetchDefinition,
            isAutohighlighted: true,
            definitionCurationOptions: {
                curatedDefinitionScopeConfig: curatedDefinitionScopeConfig
            },
            disableDefinitionsCallbacks: {
                onDisableDefinitions: onDisableDefinitions,
                onEnableDefinitions: onEnableDefinitions,
                getDefinitionsDisabled: getDefinitionsDisabled
            },
            showChatFollowUps: isRovoLLMEnabled
        };
        return {
            pattern: autoHighlightRegex,
            component: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7mZPi.RendererDefinitionTextHighlighter), {
                    ...props,
                    definitionConfig: definitionConfig,
                    keyPhrases: keyPhrases,
                    sourceConfig: sourceConfig
                })
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        autoHighlightRegex,
        keyPhrases
    ]);
    const handleContentFallback = (extensionKey)=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'fellback',
                actionSubject: 'comment',
                actionSubjectId: commentId,
                source: 'comment',
                attributes: {
                    editor: 'v2',
                    commentType: 'page',
                    reason: extensionKey ? `${(0, $chaNr.FALLBACK_REASONS).UNSUPPORTED_EXTENSION} - ${extensionKey}` : (0, $chaNr.FALLBACK_REASONS).INVALID_ADF
                }
            }
        }).fire();
        onContentFallback && onContentFallback(extensionKey);
    };
    const extensionHandlers = (0, $cozmU.useMemo)(()=>{
        const base = (0, $1C1zB.getExtensionHandlers)((extensionKey)=>{
            if (!extensionKey?.startsWith('native-embed') || !(0, $9wGTI.fg)('cc_maui_embed_in_comment_editor')) handleContentFallback(extensionKey);
        }, commentId);
        const macroHandlerRaw = base['com.atlassian.confluence.macro.core'];
        const macroHandler = typeof macroHandlerRaw === 'function' ? macroHandlerRaw : (extension, context)=>{
            const nested = macroHandlerRaw?.[extension.extensionKey];
            return nested ? nested(extension, context) : null;
        };
        const macroCore = (0, $9wGTI.fg)('cc_maui_embed_in_comment_editor') ? (extension, context)=>{
            if (extension.extensionKey?.startsWith('native-embed')) {
                const url = extension.parameters?.macroMetadata?.url ?? extension.parameters?.macroParams?.url?.value ?? '';
                const safeUrl = /^https?:\/\//i.test(url) ? url : '';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dc146e3974e81fa1$var$NativeEmbedCard, {
                    url: safeUrl
                });
            }
            return macroHandler(extension, context);
        } : macroHandler;
        return {
            ...base,
            'com.atlassian.confluence.macro.core': macroCore
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        commentId
    ]);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const matchRoute = (0, $dPJCf.useMatchRoute)();
    const embeddedConfluenceEventHandlers = (0, $bzqa9.useEventHandlers)();
    const eventHandlers = (0, $cozmU.useMemo)(()=>({
            ...(0, $lmNXu.createSmartCardEventHandler)({
                matchRoute: matchRoute,
                push: push
            }),
            ...(0, $h0UOA.createLinkEventHandler)({
                matchRoute: matchRoute,
                push: push
            }),
            ...embeddedConfluenceEventHandlers
        }), [
        matchRoute,
        push,
        embeddedConfluenceEventHandlers
    ]); /* Logic to not show Fade when we have 2 lines in Inactive state. When we have more than 2 lines the scrollHeight is
                                                            greater than 50, if its less than 50 send fadeOutHeight as 0*/ 
    const getFadeHeight = ()=>{
        if (isTruncatedContent && (rootEl?.firstElementChild?.scrollHeight ?? 0) > $dc146e3974e81fa1$var$MIN_SCROLL_HEIGHT) return fadeOutHeight;
        else return 0;
    };
    const injectObjectIdIntoRendererAnalytics = (objectId)=>(event)=>{
            // WS-3190 If a renderer event is fired, inject the commentId as objectId
            if (event.payload.actionSubject === 'renderer') event.update((payload)=>({
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        appearance: 'comment',
                        objectId: objectId
                    }
                }));
        };
    const getRendererLocation = (0, $cozmU.useCallback)(()=>{
        let rendererLocation = isInlineComment ? (0, $g7Tm3.CommentRendererLocation).STANDALONE_INLINE : (0, $g7Tm3.CommentRendererLocation).STANDALONE_OBJECT;
        if (isCommentsPanel) {
            if (isInlineComment) rendererLocation = (0, $g7Tm3.CommentRendererLocation).COMMENTS_PANEL_INLINE;
            else rendererLocation = (0, $g7Tm3.CommentRendererLocation).COMMENTS_PANEL_OBJECT;
        }
        return rendererLocation;
    }, [
        isInlineComment,
        isCommentsPanel
    ]);
    const handleEmojiLoadFail = (0, $cozmU.useCallback)((emojiId, reason)=>{
        const rendererLocation = getRendererLocation();
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: pageMode === (0, $cD1qu.PageMode).VIEW ? 'viewPageScreen' : 'editPageScreen',
                objectType: 'page',
                objectId: contentId,
                action: 'failed',
                actionSubject: 'emojiLoad',
                actionSubjectId: 'commentRenderer',
                attributes: {
                    commentId: commentId,
                    location: rendererLocation,
                    isLivePage: pageMode === (0, $cD1qu.PageMode).LIVE,
                    emojiId: emojiId,
                    tenantId: cloudId,
                    userId: userId,
                    reason: reason,
                    pageId: contentId
                }
            }
        }).fire();
    }, [
        pageMode,
        contentId,
        commentId,
        cloudId,
        userId,
        getRendererLocation,
        createAnalyticsEvent
    ]);
    const handleEmojiLoadSuccess = (0, $cozmU.useCallback)((emojiId)=>{
        const rendererLocation = getRendererLocation();
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: pageMode === (0, $cD1qu.PageMode).VIEW ? 'viewPageScreen' : 'editPageScreen',
                objectType: 'page',
                objectId: contentId,
                action: 'success',
                actionSubject: 'emojiLoad',
                actionSubjectId: 'commentRenderer',
                attributes: {
                    commentId: commentId,
                    location: rendererLocation,
                    isLivePage: pageMode === (0, $cD1qu.PageMode).LIVE,
                    emojiId: emojiId,
                    tenantId: cloudId,
                    userId: userId,
                    pageId: contentId
                }
            }
        }).fire();
    }, [
        pageMode,
        contentId,
        commentId,
        cloudId,
        userId,
        getRendererLocation,
        createAnalyticsEvent
    ]);
    if (!adf) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: injectObjectIdIntoRendererAnalytics(commentId),
        channel: "editor"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eV0v4.DynamicAnalyticsListener), {
        channelParam: (0, $eV0v4.editorChannel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: setRootEl,
        className: (0, $hekY6.default)([
            !isCommentsPanel && "_19pkutpp _n3tdu2gc",
            !isCommentsPanel && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && "_19pku2gc",
            isCommentsPanel && (0, $9wGTI.fg)('confluence_frontend_comments_panel_v2') && "_n3tdn7od"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKSlH.MultiMacroQueryContainer), {
        contentId: contentId ?? '',
        featureFlags: featureFlags,
        contentRendererMode: "renderer",
        readFragmentInterop: readFragmentInterop
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hRnS5.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hEeUR.ADFRenderer), {
        contentId: commentId,
        document: adf,
        extensionHandlers: extensionHandlers,
        portal: rootEl ?? undefined,
        allowStickyHeaders: false,
        isTruncatedContent: isTruncatedContent,
        onRendered: onRendered,
        onComplete: onComplete,
        allowSelectAllTrap: true,
        maxHeight: maxHeight,
        fadeOutHeight: getFadeHeight(),
        appearance: "comment",
        eventHandlers: eventHandlers,
        UNSTABLE_allowTableAlignment: !isInlineComment,
        UNSTABLE_allowTableResizing: !isInlineComment,
        shouldRemoveEmptySpaceAroundContent: true,
        onEmojiLoadFail: handleEmojiLoadFail,
        onEmojiLoadSuccess: handleEmojiLoadSuccess,
        textHighlighter: isDefinitionsEnabled ? memoTextPlatformHighlighter : undefined
    }), isEdited && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_11c8wadc _syaz1rpy _ca0q12x7"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage($dc146e3974e81fa1$var$i18n.editedBy, {
            username: versionByDisplayName || formatMessage((0, $3ejfs.commentsi18n).anonymous),
            at: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1YXTQ.TimeAgo), {
                date: (0, $6faGq.getValidDate)(versionDate),
                usePrepositions: true
            })
        }),
        analyticsContext: {
            attributes: {
                source: analyticsContextSource,
                commentType: commentType,
                name: 'commentEditedBadgeTooltip'
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": "comment-edited-label",
        tabIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJomY.default), null, formatMessage($dc146e3974e81fa1$var$i18n.editedInParentheses))))), annotationId && !hideAiSuggestEdit && !isReply && (0, $6mKj3.expValEquals)('ai-suggested-edits', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COMMENTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1TLVx.AiSuggestEdit), {
        commentId: commentId,
        annotationId: annotationId,
        annotatedText: annotatedText,
        commentAdf: adf ? JSON.stringify(adf) : undefined,
        contentId: contentId
    }))))))));
});
$dc146e3974e81fa1$export$ce6d3ea87eba7794.displayName = 'CommentRenderer';
module.exports["CommentRenderer"] = $dc146e3974e81fa1$export$ce6d3ea87eba7794;

});

parcelRegister("dEABD", function(module, exports) {
/**
 * @generated SignedSource<<c27fbbaaa14fcd845cb88463877b689f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $00ef5e4e26dd3cfe$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "css"
        },
        {
            "kind": "ScalarField",
            "name": "data"
        },
        {
            "kind": "ScalarField",
            "name": "js"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "CommentRendererReadFragmentWithAppKey",
        "selections": [
            {
                "concreteType": "Macro",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "macroId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "contentId"
                    },
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "mode",
                                "value": "RENDERER"
                            }
                        ],
                        "concreteType": "RenderedMacro",
                        "kind": "LinkedField",
                        "name": "renderedMacro",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "appKey"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "macroRenderedRepresentation"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "macroBodyStorage"
                            },
                            {
                                "concreteType": "WebResourceDependenciesV2",
                                "kind": "LinkedField",
                                "name": "webResource",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "contexts"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "keys"
                                    },
                                    {
                                        "concreteType": "SuperBatchWebResourcesV2",
                                        "kind": "LinkedField",
                                        "name": "superbatch",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "metatags"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "WebResourceTagsV2",
                                        "kind": "LinkedField",
                                        "name": "tags",
                                        "plural": false,
                                        "selections": v0 /*: any*/ 
                                    },
                                    {
                                        "concreteType": "WebResourceUrisV2",
                                        "kind": "LinkedField",
                                        "name": "uris",
                                        "plural": false,
                                        "selections": v0 /*: any*/ 
                                    }
                                ]
                            },
                            {
                                "concreteType": "EmbeddedMediaTokenV2",
                                "kind": "LinkedField",
                                "name": "mediaToken",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "token"
                                    }
                                ]
                            }
                        ],
                        "storageKey": "renderedMacro(mode:\"RENDERER\")"
                    }
                ]
            },
            {
                "concreteType": "PageInfoV2",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "endCursor"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    }
                ]
            }
        ],
        "type": "MacroConnection"
    };
}();
$00ef5e4e26dd3cfe$var$node.hash = "baa5be0493f483d10c38df29c48e3340";
var $00ef5e4e26dd3cfe$export$2e2bcd8739ae039 = $00ef5e4e26dd3cfe$var$node;
module.exports["default"] = $00ef5e4e26dd3cfe$export$2e2bcd8739ae039;

});

parcelRegister("cJomY", function(module, exports) {
/* edited.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $284f81bf601d8436$var$editedContentStyles = {
    root: "_syaz1rpy"
};
const $284f81bf601d8436$var$Edited = ({ children: children, onFocus: onFocus, onMouseOver: onMouseOver })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        onFocus: onFocus,
        onMouseOver: onMouseOver,
        className: (0, $hekY6.default)([
            $284f81bf601d8436$var$editedContentStyles.root
        ])
    }, children);
$284f81bf601d8436$var$Edited.displayName = 'Edited'; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $284f81bf601d8436$export$2e2bcd8739ae039 = $284f81bf601d8436$var$Edited;
module.exports["default"] = $284f81bf601d8436$export$2e2bcd8739ae039;

});

parcelRegister("zzZbq", function(module, exports) {
const $879361a9ede64ad7$export$82b05c69aac5d0c6 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $879361a9ede64ad7$export$e7d7da8c94dcb6fc = 'https://support.atlassian.com/confluence-cloud/docs/use-atlassian-intelligence-to-search-for-answers/';
const $879361a9ede64ad7$export$506bad4598ef877f = 'https://www.atlassian.com/software/artificial-intelligence';
const $879361a9ede64ad7$export$59da2b3b71a076c7 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $879361a9ede64ad7$export$b4efff19add55eb6 = 'https://confluence.atlassian.com/support/atlassian-support-ai-chat-1455423797.html';
const $879361a9ede64ad7$export$96cc4126cdc27248 = 'https://www.atlassian.com/legal/acceptable-use-policy';
const $879361a9ede64ad7$export$d3a50b0660f215e0 = 'https://support.atlassian.com/organization-administration/docs/usage-limits-in-atlassian-intelligence/';
const $879361a9ede64ad7$export$50e6b843de210064 = 'https://support.atlassian.com/organization-administration/docs/troubleshooting-for-atlassian-intelligence/';
const $879361a9ede64ad7$export$dd87179defae3659 = 'https://support.atlassian.com/organization-administration/docs/the-hipaa-implementation-guide/';
const $879361a9ede64ad7$export$2c1028e1e7bf5557 = 'https://www.atlassian.com/software/rovo';
const $879361a9ede64ad7$export$c4fda24479ad6357 = '82633dea-7fbf-4faa-9a51-a83a3fd181d9';
const $879361a9ede64ad7$export$91d63889268b5e23 = "365\xa05ce1d-16b8-4630-9e93-6c39069625fa";
const $879361a9ede64ad7$export$c0ced37cfe138d3e = '10f4daa4-bcfc-4d42-ae33-92888648d9db';
const $879361a9ede64ad7$export$d04cd98bb7625919 = 'customfield_10047';
const $879361a9ede64ad7$export$ed78826c06dd24e3 = 'fabric-elements';
var $879361a9ede64ad7$export$83c8d7110915321e = /*#__PURE__*/ function(SOURCE) {
    SOURCE["SEARCH_DIALOG"] = "searchDialog";
    SOURCE["ADVANCED_SEARCH"] = "advancedSearch";
    SOURCE["READING_AIDS"] = "readingAids";
    return SOURCE;
}({});
const $879361a9ede64ad7$export$e7862e8dbda0aa3 = '500px';
const $879361a9ede64ad7$export$169d09d6d83f61d6 = '/gateway/api/smartAnswers/stream';
const $879361a9ede64ad7$export$a00f71e6c6b44441 = '/gateway/api/assist';
const $879361a9ede64ad7$export$cc4a4ed360fef1ba = '/gateway/api/graphql';
var $879361a9ede64ad7$export$83d4ba88ba80625b = /*#__PURE__*/ function(QueryIntent) {
    QueryIntent["DEFAULT"] = "DEFAULT";
    QueryIntent["NATURAL_LANGUAGE_QUERY"] = "NATURAL_LANGUAGE_QUERY";
    QueryIntent["KEYWORD_OR_ACRONYM"] = "KEYWORD_OR_ACRONYM";
    QueryIntent["PERSON"] = "PERSON";
    QueryIntent["TEAM"] = "TEAM";
    QueryIntent["NAVIGATIONAL"] = "NAVIGATIONAL";
    QueryIntent["NONE"] = "NONE";
    QueryIntent["LOCATION"] = "LOCATION";
    QueryIntent["DATE"] = "DATE";
    QueryIntent["JIRA_ISSUE"] = "JIRA_ISSUE";
    QueryIntent["TOPIC"] = "TOPIC";
    QueryIntent["JIRA_NATURAL_LANGUAGE_QUERY"] = "JIRA_NATURAL_LANGUAGE_QUERY";
    QueryIntent["JIRA_NLQ_KEYWORD"] = "JIRA_NLQ_KEYWORD";
    QueryIntent["AGENT"] = "AGENT";
    QueryIntent["ORG_CHART"] = "ORG_CHART";
    QueryIntent["NAV_CONTENT"] = "NAV_CONTENT";
    QueryIntent["BOOKMARK"] = "BOOKMARK";
    QueryIntent["VISUAL"] = "VISUAL";
    return QueryIntent;
}({});
var $879361a9ede64ad7$export$a08a848abe54c31f = /*#__PURE__*/ function(AnswerCardType) {
    AnswerCardType["PERSON"] = "people";
    AnswerCardType["TEAM"] = "team";
    AnswerCardType["AGENT"] = "agent";
    AnswerCardType["DATE"] = "date";
    AnswerCardType["LOCATION"] = "location";
    AnswerCardType["TOPIC"] = "topic";
    AnswerCardType["JIRA_NATURAL_LANGUAGE_QUERY"] = "jira_nl_to_jql";
    AnswerCardType["JIRA_ISSUE"] = "jira_issue";
    AnswerCardType["NAVIGATIONAL"] = "navigational";
    AnswerCardType["NAV_CONTENT"] = "nav_content";
    AnswerCardType["NONE"] = "none";
    AnswerCardType["DEFAULT"] = "default";
    AnswerCardType["SAIN"] = "SAIN";
    AnswerCardType["DEFINITION"] = "definition";
    AnswerCardType["ORG_CHART"] = "org_chart";
    AnswerCardType["BOOKMARK_KNOWLEDGE_CARD"] = "bookmarkKnowledgeCard";
    AnswerCardType["VISUAL"] = "visual";
    return AnswerCardType;
}({});
var $879361a9ede64ad7$export$c243a7d908564b9b = /*#__PURE__*/ function(AiExperienceName) {
    AiExperienceName["PERSON_CARD"] = "Person Card";
    AiExperienceName["TEAM_CARD"] = "Team Card";
    AiExperienceName["LOCATION_CARD"] = "Location Card";
    AiExperienceName["DATE_CARD"] = "Date Card";
    AiExperienceName["TOPIC_CARD"] = "Topic Card";
    AiExperienceName["JIRA_NATURAL_LANGUAGE_QUERY_CARD"] = "Jira Card";
    AiExperienceName["AGENT_CARD"] = "Agent Card";
    AiExperienceName["JIRA_ISSUE_CARD"] = "Jira Issue Card";
    AiExperienceName["NAVIGATIONAL"] = "Navigational";
    AiExperienceName["NONE"] = "None";
    AiExperienceName["DEFAULT"] = "Default";
    AiExperienceName["PLAIN_TEXT"] = "Plain Text";
    AiExperienceName["POPULAR_SEARCH_QUERY_CARD"] = "Popular Search Query Card";
    AiExperienceName["NAVIGATIONAL_SEARCH_RESULT_CARD"] = "Navigational Search Result Card";
    return AiExperienceName;
}({});
var $879361a9ede64ad7$export$30e36b9f4147b88f = /*#__PURE__*/ function(CardTemplate) {
    CardTemplate["DEFAULT"] = "DEFAULT";
    CardTemplate["SMART_ANSWER"] = "SMART_ANSWER";
    CardTemplate["RIGHT_PANEL"] = "RIGHT_PANEL";
    return CardTemplate;
}({});
var $879361a9ede64ad7$export$49069087564847a7 = /*#__PURE__*/ function(AiBrand) {
    AiBrand["ROVO"] = "ROVO";
    AiBrand["AI"] = "ATLASSIAN INTELLIGENCE";
    return AiBrand;
}({});
var $879361a9ede64ad7$export$8375a80c95e07251 = /*#__PURE__*/ function(AIAnswerTab) {
    AIAnswerTab["AI_ANSWER"] = "AI_ANSWER";
    AIAnswerTab["SOURCES"] = "SOURCES";
    return AIAnswerTab;
}({});
const $879361a9ede64ad7$export$98d221c2fcca6d6b = [
    "AI_ANSWER",
    "SOURCES"
];
const $879361a9ede64ad7$export$7ecd7f1b620801eb = 'convo_ai_sain_prompt_override_hello';
const $879361a9ede64ad7$export$fe340b7aba57733d = 'atlassian.search-dialog.ai-answer-component';
module.exports["ATLASSIAN_INTELLIGENCE_SEARCH_INFO_LINK"] = $879361a9ede64ad7$export$e7d7da8c94dcb6fc;
module.exports["ATLASSIAN_INTELLIGENCE_TRUST_LINK"] = $879361a9ede64ad7$export$59da2b3b71a076c7;
module.exports["SAC_ATLASSIAN_INTELLIGENCE_TRUST_LINK"] = $879361a9ede64ad7$export$b4efff19add55eb6;
module.exports["ATLASSIAN_ACCEPTABLE_USE_POLICY_LINK"] = $879361a9ede64ad7$export$96cc4126cdc27248;
module.exports["ATLASSIAN_AI_USAGE_LIMITS_LINK"] = $879361a9ede64ad7$export$d3a50b0660f215e0;
module.exports["ATLASSIAN_AI_TROUBLESHOOT_LINK"] = $879361a9ede64ad7$export$50e6b843de210064;
module.exports["ATLASSIAN_HIPAA_COMPLICANCE_LINK"] = $879361a9ede64ad7$export$dd87179defae3659;
module.exports["ATLASSIAN_ROVO_LINK"] = $879361a9ede64ad7$export$2c1028e1e7bf5557;
module.exports["FEEDBACK_ENTRYPOINT_ID_SAIN"] = $879361a9ede64ad7$export$c4fda24479ad6357;
module.exports["FEEDBACK_ENTRYPOINT_ID_TOPICS"] = $879361a9ede64ad7$export$c0ced37cfe138d3e;
module.exports["FEEDBACK_CONTEXT_CF"] = $879361a9ede64ad7$export$d04cd98bb7625919;
module.exports["DEFAULT_GAS_CHANNEL"] = $879361a9ede64ad7$export$ed78826c06dd24e3;
module.exports["READING_AIDS_DIALOG_WIDTH"] = $879361a9ede64ad7$export$e7862e8dbda0aa3;
module.exports["SAIN_STREAMING_API"] = $879361a9ede64ad7$export$169d09d6d83f61d6;
module.exports["ASSISTANCE_SERVICE_API_BASE_URL"] = $879361a9ede64ad7$export$a00f71e6c6b44441;
module.exports["DEFAULT_GRAPHQL_ENDPOINT"] = $879361a9ede64ad7$export$cc4a4ed360fef1ba;
module.exports["QueryIntent"] = $879361a9ede64ad7$export$83d4ba88ba80625b;
module.exports["AnswerCardType"] = $879361a9ede64ad7$export$a08a848abe54c31f;
module.exports["AiExperienceName"] = $879361a9ede64ad7$export$c243a7d908564b9b;
module.exports["CardTemplate"] = $879361a9ede64ad7$export$30e36b9f4147b88f;
module.exports["AiBrand"] = $879361a9ede64ad7$export$49069087564847a7;
module.exports["AIAnswerTab"] = $879361a9ede64ad7$export$8375a80c95e07251;
module.exports["aiAnswerTabsOrder"] = $879361a9ede64ad7$export$98d221c2fcca6d6b;
module.exports["PROMPT_OVERRIDE_SESSION_KEY"] = $879361a9ede64ad7$export$7ecd7f1b620801eb;
module.exports["SEARCH_AI_ANSWER_CACHE_KEY"] = $879361a9ede64ad7$export$fe340b7aba57733d;

});

parcelRegister("7P5ob", function(module, exports) {
var $a0476e60d46954e4$export$5fc610914b028d97 = /*#__PURE__*/ function(KnowledgeDiscoveryKeyPhraseInputTextFormat) {
    KnowledgeDiscoveryKeyPhraseInputTextFormat["PLAIN"] = "PLAIN";
    KnowledgeDiscoveryKeyPhraseInputTextFormat["ADF"] = "ADF";
    return KnowledgeDiscoveryKeyPhraseInputTextFormat;
}({});
module.exports["KnowledgeDiscoveryKeyPhraseInputTextFormat"] = $a0476e60d46954e4$export$5fc610914b028d97;

});

parcelRegister("gYQp3", function(module, exports) {
// create separate utils folder if need to export more utils
const $e7e00ee1b8f0e7bd$var$validMarks = (data)=>{
    const invalidMarks = [
        'annotation',
        'link'
    ];
    return !data.marks || !data.marks.some((mark)=>invalidMarks.includes(mark.type));
};
const $e7e00ee1b8f0e7bd$var$validType = (data)=>{
    const invalidTypes = [
        'codeBlock'
    ];
    return !invalidTypes.includes(data.type);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e7e00ee1b8f0e7bd$var$extractContent = (data, flatMap)=>{
    if ($e7e00ee1b8f0e7bd$var$validType(data)) {
        if (data.content && data.content.length > 0) for (const node of data.content)$e7e00ee1b8f0e7bd$var$extractContent(node, flatMap);
    }
    // leaf node
    if (data.type === 'text' && $e7e00ee1b8f0e7bd$var$validMarks(data)) flatMap.push(data);
};
const $e7e00ee1b8f0e7bd$export$4cf5403beffb0fc1 = (adfValue)=>{
    const flatMap = [];
    $e7e00ee1b8f0e7bd$var$extractContent(adfValue, flatMap);
    return flatMap.map((node)=>node.text).join(',');
};
module.exports["parseContent"] = $e7e00ee1b8f0e7bd$export$4cf5403beffb0fc1;

});

parcelRegister("eIO9N", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $ixfCV = parcelRequire("ixfCV");


var $7AtIp = parcelRequire("7AtIp");


var $i5c0A = parcelRequire("i5c0A");


var $zzZbq = parcelRequire("zzZbq");


var $jXbsB = parcelRequire("jXbsB");


var $8Yi0A = parcelRequire("8Yi0A");


var $e9Hlq = parcelRequire("e9Hlq");


const $22c6369f6e85adc5$export$276f56b9dab90860 = 'atlassian.knowledge-discovery.autohighlights';
const $22c6369f6e85adc5$var$escapeRegExp = (regex)=>{
    return regex.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
};
const $22c6369f6e85adc5$export$4a1c1074ca627 = (keyPhrases)=>{
    try {
        if (!keyPhrases.length) return new RegExp('(?!)');
        else return new RegExp(keyPhrases.map((node)=>`\\b${$22c6369f6e85adc5$var$escapeRegExp(node.keyPhrase)}\\b`).join('|'), 'gi');
    } catch  {
        return new RegExp('(?!)');
    }
};
const $22c6369f6e85adc5$var$getKeyphraseCategory = (keyPhrases)=>{
    return keyPhrases.length ? keyPhrases[0].category : (0, $e9Hlq.KeyPhraseCategory).AUTO;
};
const $22c6369f6e85adc5$var$initialState = {
    keyPhrases: [],
    keyPhraseCategory: (0, $e9Hlq.KeyPhraseCategory).AUTO,
    autoHighlightRegex: new RegExp('(?!)'),
    loadAutohighlights: ()=>Promise.resolve([]),
    resetAutohighlights: ()=>{},
    autohighlightsLoading: false,
    error: undefined
};
const $22c6369f6e85adc5$export$52e9ff9bfbb65046 = ({ entityAri: entityAri, workspaceId: workspaceId, product: product, productConfig: productConfig, fieldType: fieldType, cloudId: cloudId })=>{
    const [state, setState] = (0, $cozmU.useState)($22c6369f6e85adc5$var$initialState);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire((0, $zzZbq.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    const { jiraReporterAccountId: jiraReporterAccountId, jiraAssigneeAccountId: jiraAssigneeAccountId } = productConfig || {};
    const loadAutohighlights = (0, $cozmU.useCallback)(async ({ inputText: inputText })=>{
        try {
            setState({
                ...$22c6369f6e85adc5$var$initialState,
                autohighlightsLoading: true
            });
            const keyPhrasesResult = await (0, $i5c0A.fetchAggResponse)({
                graphQuery: (0, $jXbsB.KeyPhrasesQuery),
                variables: {
                    workspaceId: workspaceId,
                    entityAri: entityAri,
                    ...!!jiraReporterAccountId && {
                        jiraReporterAccountId: jiraReporterAccountId
                    },
                    ...!!jiraAssigneeAccountId && {
                        jiraAssigneeAccountId: jiraAssigneeAccountId
                    },
                    ...!!inputText && {
                        inputText: inputText
                    }
                },
                operationName: (0, $jXbsB.KEY_PHRASES_OPERATION_NAME),
                headers: (0, $7AtIp.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: cloudId,
                    product: product
                })
            });
            const keyPhrases = keyPhrasesResult?.data?.knowledgeDiscovery?.keyPhrases?.nodes ? keyPhrasesResult.data.knowledgeDiscovery.keyPhrases.nodes : [];
            if (keyPhrases.length > 0 && (0, $ixfCV.fg)('kd_definitions_click_and_show_event_product_parity')) fireAnalyticsEvent((0, $8Yi0A.onShownAutoDefinitionHighlights)({
                product: product,
                contentId: entityAri,
                keyPhrases: keyPhrases,
                fieldType: fieldType
            }));
            const autoHighlightRegex = $22c6369f6e85adc5$export$4a1c1074ca627(keyPhrases);
            setState({
                ...$22c6369f6e85adc5$var$initialState,
                keyPhraseCategory: $22c6369f6e85adc5$var$getKeyphraseCategory(keyPhrases),
                autoHighlightRegex: autoHighlightRegex,
                keyPhrases: keyPhrases
            });
            return keyPhrases;
        } catch (error) {
            setState({
                ...$22c6369f6e85adc5$var$initialState,
                error: error.message
            });
            return [];
        }
    }, [
        entityAri,
        workspaceId,
        fireAnalyticsEvent,
        product,
        jiraReporterAccountId,
        jiraAssigneeAccountId,
        fieldType,
        cloudId
    ]);
    const resetAutohighlights = (0, $cozmU.useCallback)(()=>{
        setState($22c6369f6e85adc5$var$initialState);
    }, []);
    const autoHighlightRegex = (0, $cozmU.useMemo)(()=>state.autoHighlightRegex, [
        state.autoHighlightRegex
    ]);
    const autohighlightsLoading = (0, $cozmU.useMemo)(()=>state.autohighlightsLoading, [
        state.autohighlightsLoading
    ]);
    const keyPhrases = (0, $cozmU.useMemo)(()=>state.keyPhrases, [
        state.keyPhrases
    ]);
    const error = (0, $cozmU.useMemo)(()=>state.error, [
        state.error
    ]);
    return {
        keyPhrases: keyPhrases,
        keyPhraseCategory: state.keyPhraseCategory,
        autoHighlightRegex: autoHighlightRegex,
        loadAutohighlights: loadAutohighlights,
        resetAutohighlights: resetAutohighlights,
        autohighlightsLoading: autohighlightsLoading,
        error: error
    };
};
module.exports["getHighlightRegex"] = $22c6369f6e85adc5$export$4a1c1074ca627;
module.exports["useAutohighlightSupplier"] = $22c6369f6e85adc5$export$52e9ff9bfbb65046;

});

parcelRegister("7AtIp", function(module, exports) {
function $7a7ddad2b00bc2ae$export$14ef296862e3705e({ atlWorkspaceId: atlWorkspaceId, tenantId: tenantId, product: product }) {
    const atlAttributionHeader = {
        atlWorkspaceId: atlWorkspaceId,
        tenantId: tenantId,
        product: product
    };
    return {
        'atl-attribution': JSON.stringify(atlAttributionHeader)
    };
}
module.exports["createAtlAttributionHeader"] = $7a7ddad2b00bc2ae$export$14ef296862e3705e;

});

parcelRegister("i5c0A", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $gABt9 = parcelRequire("gABt9");


var $cLhX4 = parcelRequire("cLhX4");


var $lbwuA = parcelRequire("lbwuA");

const $90c66dfb8e95b21f$var$DEFAULT_GRAPHQL_ENDPOINT = '/gateway/api/graphql';
async function $90c66dfb8e95b21f$export$1642248503fca29({ graphQuery: graphQuery, variables: variables, operationName: operationName, aggAbsoluteUrl: url = $90c66dfb8e95b21f$var$DEFAULT_GRAPHQL_ENDPOINT, cache: cache, headers: headers }) {
    // Populated from HTTP response via requestService (not present on JSON body).
    const capturedTracingHeaders = {};
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers ? {
                    ...headers
                } : {}
            },
            body: JSON.stringify({
                operationName: operationName,
                query: graphQuery,
                variables: variables
            })
        },
        queryParams: {
            ...operationName && {
                q: operationName,
                // `operation` is added alongside `q` so UFO's Jira resource-timing
                // `sanitiseEndpoints` keys this fetch by its operation name (e.g.
                // KnowledgeDiscoveryIntentDetectionQuery) instead of collapsing it
                // into the anonymous `gateway_api_graphql` bucket.
                ...(0, $ixfCV.fg)('kd_fe_ufo_named_agg_resources') && {
                    operation: operationName
                }
            }
        },
        reportTracingHeaders: (tracing)=>{
            Object.assign(capturedTracingHeaders, tracing);
        }
    };
    // if there's a ttl use fetch with in-mem cacheing
    if (cache && (0, $ixfCV.fg)('kd_fe_enable_api_cache')) return (0, $lbwuA.fetchAggResponseWithCache)({
        graphQuery: graphQuery,
        variables: variables,
        operationName: operationName,
        cache: cache,
        headers: headers
    });
    const response = await (0, $gABt9.utils).requestService({
        url: url
    }, options);
    // Attach gateway trace / request IDs for downstream tracing and analytics.
    return (0, $cLhX4.enrichAggResponseWithGatewayTracingHeaders)(response, capturedTracingHeaders);
}
module.exports["fetchAggResponse"] = $90c66dfb8e95b21f$export$1642248503fca29;

});

parcelRegister("cLhX4", function(module, exports) {
function $7e561b6b9ac47749$export$547fb2fa14d5b927(response, tracingHeaders) {
    if (!tracingHeaders || Object.keys(tracingHeaders).length === 0) return response;
    return {
        ...response,
        gatewayTracingHeaders: {
            ...response.gatewayTracingHeaders,
            ...tracingHeaders
        }
    };
}
module.exports["enrichAggResponseWithGatewayTracingHeaders"] = $7e561b6b9ac47749$export$547fb2fa14d5b927;

});

parcelRegister("lbwuA", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $gABt9 = parcelRequire("gABt9");


var $cLhX4 = parcelRequire("cLhX4");


var $jarkA = parcelRequire("jarkA");

const $f07e52544b73f9e1$var$DEFAULT_GRAPHQL_ENDPOINT = '/gateway/api/graphql';
async function $f07e52544b73f9e1$export$6fe550b7d5be614c({ graphQuery: graphQuery, variables: variables, operationName: operationName, aggAbsoluteUrl: url = $f07e52544b73f9e1$var$DEFAULT_GRAPHQL_ENDPOINT, cache: cache, headers: headers }) {
    // From HTTP response headers; merged onto the payload before cache / return.
    const capturedTracingHeaders = {};
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers ? {
                    ...headers
                } : {}
            },
            body: JSON.stringify({
                operationName: operationName,
                query: graphQuery,
                variables: variables
            })
        },
        queryParams: {
            ...operationName && {
                q: operationName,
                // `operation` is added alongside `q` so UFO's Jira resource-timing
                // `sanitiseEndpoints` keys this fetch by its operation name (e.g.
                // KnowledgeDiscoveryIntentDetectionQuery) instead of collapsing it
                // into the anonymous `gateway_api_graphql` bucket.
                ...(0, $ixfCV.fg)('kd_fe_ufo_named_agg_resources') && {
                    operation: operationName
                }
            }
        },
        reportTracingHeaders: (tracing)=>{
            Object.assign(capturedTracingHeaders, tracing);
        }
    };
    let cachedResponse = (0, $jarkA.InMemCache).getData(cache.key);
    if (cachedResponse && (0, $jarkA.InMemCache).isValid(cache.key)) return Promise.resolve(cachedResponse);
    // return a pending promise that was cached earlier
    const inflightRequest = (0, $jarkA.InMemCache).getInflightRequest(cache.key);
    if (inflightRequest) return inflightRequest;
    // cache miss, fetch data from agg and store ref to promise
    const request = new Promise(async (resolve, reject)=>{
        try {
            const response = await (0, $gABt9.utils).requestService({
                url: url
            }, options);
            // Attach `x-trace-id` / `atl-request-id` from the HTTP layer for tracing.
            const enriched = (0, $cLhX4.enrichAggResponseWithGatewayTracingHeaders)(response, capturedTracingHeaders);
            (0, $jarkA.InMemCache).setData({
                key: cache.key,
                response: enriched,
                ttl: cache.ttl
            });
            resolve(enriched);
        } catch (error) {
            reject(error);
        } finally{
            (0, $jarkA.InMemCache).removeInflightRequest(cache.key);
        }
    });
    (0, $jarkA.InMemCache).setInflightRequest({
        key: cache.key,
        request: request
    });
    return request;
}
module.exports["fetchAggResponseWithCache"] = $f07e52544b73f9e1$export$6fe550b7d5be614c;

});

parcelRegister("jarkA", function(module, exports) {
const $3588e4a658fbd1e2$var$DEFAULT_TTL = 300000;
class $3588e4a658fbd1e2$export$916bab80494ce385 {
    static setData({ key: key, response: response, ttl: ttl }) {
        this.cache.set(key, {
            ttl: Date.now() + (ttl || $3588e4a658fbd1e2$var$DEFAULT_TTL),
            response: response
        });
    }
    static getData(key) {
        return this.cache.get(key)?.response;
    }
    static isValid(key) {
        const item = this.cache.get(key);
        return Boolean(item) && Date.now() < (item?.ttl || 0);
    }
    static getInflightRequest(key) {
        return this.inFlightRequests.get(key);
    }
    static setInflightRequest({ key: key, request: request }) {
        this.inFlightRequests.set(key, request);
    }
    static removeInflightRequest(key) {
        return this.inFlightRequests.delete(key);
    }
    // only for tests
    static clearCache() {
        this.cache.clear();
        this.inFlightRequests.clear();
    }
}
$3588e4a658fbd1e2$export$916bab80494ce385.cache = new Map();
$3588e4a658fbd1e2$export$916bab80494ce385.inFlightRequests = new Map();
module.exports["InMemCache"] = $3588e4a658fbd1e2$export$916bab80494ce385;

});

parcelRegister("jXbsB", function(module, exports) {
const $3d17a38e3ddac80f$export$b260340f6ff10d53 = 'PlatformHighlightKeywordsQuery';
const $3d17a38e3ddac80f$export$39b2bc657daf065 = `
	query ${$3d17a38e3ddac80f$export$b260340f6ff10d53}(
		$entityAri: String!
		$workspaceId: String!
		$jiraReporterAccountId: String
		$jiraAssigneeAccountId: String
		$inputText: KnowledgeDiscoveryKeyPhraseInputText
	) {
		knowledgeDiscovery  {
			keyPhrases(entityAri: $entityAri, workspaceId: $workspaceId, jiraReporterAccountId: $jiraReporterAccountId, jiraAssigneeAccountId: $jiraAssigneeAccountId, inputText: $inputText) 
				@optIn(to: "KnowledgeDiscovery Get Key Phrases") {
				__typename
				... on KnowledgeDiscoveryKeyPhraseConnection {
					nodes {
						... on KnowledgeDiscoveryKeyPhrase {
							keyPhrase
							category
						}
					}
				}
				... on QueryError {
					message
				}
			}
		}
	}
`;
module.exports["KEY_PHRASES_OPERATION_NAME"] = $3d17a38e3ddac80f$export$b260340f6ff10d53;
module.exports["KeyPhrasesQuery"] = $3d17a38e3ddac80f$export$39b2bc657daf065;

});

parcelRegister("8Yi0A", function(module, exports) {

var $kJQMD = parcelRequire("kJQMD");

const $cac433bd7344ad2b$export$42897f8f02baa658 = ({ product: product, contentId: contentId, keyPhrases: keyPhrases, fieldType: fieldType })=>({
        action: 'shown',
        actionSubject: 'aiDefinitionsAutohighlights',
        source: 'viewPageScreen',
        eventType: 'track',
        attributes: {
            product: product,
            contentId: contentId,
            numHighlights: keyPhrases.length,
            categories: (0, $kJQMD.getHighlightCategories)(keyPhrases),
            beAcronymsEnabled: true,
            fieldType: fieldType
        }
    });
module.exports["onShownAutoDefinitionHighlights"] = $cac433bd7344ad2b$export$42897f8f02baa658;

});

parcelRegister("kJQMD", function(module, exports) {
const $6456db9229e50d9f$export$f600f3124ea5916b = (nodes)=>{
    const categories = new Map();
    try {
        nodes.forEach((node)=>{
            const curCategoryCount = categories.get(node.category);
            if (!!curCategoryCount) categories.set(node.category, curCategoryCount + 1);
            else categories.set(node.category, 1);
        });
    } catch  {
        return undefined;
    }
    return Object.fromEntries(categories);
};
module.exports["getHighlightCategories"] = $6456db9229e50d9f$export$f600f3124ea5916b;

});

parcelRegister("e9Hlq", function(module, exports) {
var $83451bfb10f50104$export$17a511c5c23509af = /*#__PURE__*/ function(KeyPhraseCategory) {
    KeyPhraseCategory["PROJECT"] = "PROJECT";
    KeyPhraseCategory["TEAM"] = "TEAM";
    KeyPhraseCategory["ACRONYM"] = "ACRONYM";
    KeyPhraseCategory["AUTO"] = "AUTO";
    KeyPhraseCategory["OTHER"] = "OTHER";
    return KeyPhraseCategory;
}({});
module.exports["KeyPhraseCategory"] = $83451bfb10f50104$export$17a511c5c23509af;

});

parcelRegister("iuy8J", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7XBGk = parcelRequire("7XBGk");


var $3hVWe = parcelRequire("3hVWe");


var $7AtIp = parcelRequire("7AtIp");


var $i5c0A = parcelRequire("i5c0A");


var $hcBeC = parcelRequire("hcBeC");


var $u7MPJ = parcelRequire("u7MPJ");


var $W5g3o = parcelRequire("W5g3o");


var $ejlPj = parcelRequire("ejlPj");


var $j1YGG = parcelRequire("j1YGG");


var $97lMo = parcelRequire("97lMo");

const $83ed8089ae5bc973$var$i18n = (0, $kSwu1.defineMessages)({
    searchAiDialogQueryPretext: {
        id: "contextual-reading-aids.search-ai-dialog.query-pretext",
        defaultMessage: "what is {queryText}?"
    }
});
const $83ed8089ae5bc973$var$NO_CURATED_DEF_FOUND_MESSAGE = 'No matching scope for Definition';
const $83ed8089ae5bc973$export$7111b45b195dd101 = ({ workspaceId: workspaceId, cloudIdARI: cloudIdARI, fetchConfig: fetchConfig, isDefinitionCurationEnabled: isDefinitionCurationEnabled, productConfig: productConfig, product: product })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const { fireAnalyticsEvent: fireAnalyticsEvent, commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { contentId: contentId } = productConfig;
    const fetchAIGeneratedDefinition = (0, $cozmU.useCallback)(async ({ variables: variables })=>{
        const { query: query, locale: locale, additional_context: additional_context, experience: experience, followUpsEnabled: followUpsEnabled } = variables;
        if (contentId !== '') try {
            const precomputedResult = await (0, $i5c0A.fetchAggResponse)({
                graphQuery: (0, $j1YGG.PrecomputedDefinitionQuery),
                variables: {
                    workspaceId: workspaceId,
                    keyPhrase: variables.query,
                    contentId: contentId
                },
                headers: (0, $7AtIp.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: cloudIdARI,
                    product: product
                })
            });
            if (precomputedResult.data && !precomputedResult.data.knowledgeDiscovery.autoDefinition.message) {
                const data = {
                    nlpSearch: {
                        ...(0, $97lMo.mapCustomDefinitionToNLPSearchType)(precomputedResult.data.knowledgeDiscovery.autoDefinition),
                        extraAPIAnalyticsAttributes: {
                            requestId: precomputedResult.extensions?.gateway?.trace_id ?? null
                        }
                    }
                };
                setLoading(false);
                return data;
            } else if (precomputedResult.data && precomputedResult.data.knowledgeDiscovery.autoDefinition.message) throw new Error(precomputedResult.data.knowledgeDiscovery.autoDefinition.message);
            else throw new Error('Something went wrong with fetching precomputed definition');
        } catch (error) {
            if (error instanceof Object && 'message' in error && error.message !== $83ed8089ae5bc973$var$NO_CURATED_DEF_FOUND_MESSAGE) fireAnalyticsEvent((0, $W5g3o.fetchPrecomputedDefinitionErrorPayload)(error, commonAttributes));
        }
        const streamFetchArgs = {
            variables: {
                query: intl.formatMessage($83ed8089ae5bc973$var$i18n.searchAiDialogQueryPretext, {
                    queryText: query
                }),
                locale: locale,
                cloudIdARI: cloudIdARI,
                additional_context: additional_context,
                experience: experience,
                followUpsEnabled: followUpsEnabled
            },
            isReadingAids: true,
            fetchConfig: fetchConfig,
            generatorConfig: {
                yieldAnswerPart: true,
                yieldFinalResponse: true
            },
            onStreamFinalResponse: ()=>{
                setLoading(false);
            }
        };
        return {
            type: (0, $7XBGk.AIAnswerAPIType).STREAM,
            stream: (0, $hcBeC.aiDefinitionsStreamFetchConvoAIService)(streamFetchArgs)
        };
    }, [
        cloudIdARI,
        fetchConfig,
        intl,
        commonAttributes,
        fireAnalyticsEvent,
        workspaceId,
        contentId,
        product
    ]);
    const fetchDefinition = (0, $cozmU.useCallback)(async ({ variables: variables })=>{
        if (isDefinitionCurationEnabled) try {
            let confluenceScopeId, jiraScopeId;
            if ('spaceId' in productConfig) confluenceScopeId = productConfig;
            else if ('projectId' in productConfig) jiraScopeId = {
                projectId: productConfig.projectId
            };
            const result = await (0, $i5c0A.fetchAggResponse)({
                graphQuery: (0, $ejlPj.CuratedDefinitionQuery),
                variables: {
                    workspaceId: workspaceId,
                    keyPhrase: variables.query,
                    confluenceScopeId: confluenceScopeId,
                    jiraScopeId: jiraScopeId
                },
                operationName: (0, $ejlPj.CURATED_DEFINITION_OPERATION_NAME),
                headers: (0, $7AtIp.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: cloudIdARI,
                    product: product
                })
            });
            if (result.data && !result.data.knowledgeDiscovery.definition.message) {
                const data = {
                    nlpSearch: {
                        ...(0, $97lMo.mapCustomDefinitionToNLPSearchType)(result.data.knowledgeDiscovery.definition),
                        extraAPIAnalyticsAttributes: {
                            requestId: result.extensions?.gateway?.trace_id ?? null
                        }
                    }
                };
                setLoading(false);
                return data;
            } else if (result.data && result.data.knowledgeDiscovery.definition.message) throw new Error(result.data.knowledgeDiscovery.definition.message);
            else throw new Error('Something went wrong with fetching curated definition');
        } catch (error) {
            // want to fire event when error.message does not equal the no curated definition message
            // returned by the query in data.knowledgeDiscovery.definition.message
            if (error instanceof Object && 'message' in error && error.message !== $83ed8089ae5bc973$var$NO_CURATED_DEF_FOUND_MESSAGE) fireAnalyticsEvent((0, $u7MPJ.fetchCuratedDefinitionErrorPayload)(error, commonAttributes));
            return fetchAIGeneratedDefinition({
                variables: variables
            });
        }
        return fetchAIGeneratedDefinition({
            variables: variables
        });
    }, [
        productConfig,
        fetchAIGeneratedDefinition,
        isDefinitionCurationEnabled,
        workspaceId,
        commonAttributes,
        fireAnalyticsEvent,
        cloudIdARI,
        product
    ]);
    return {
        fetchDefinition: fetchDefinition,
        loading: loading
    };
};
module.exports["useDefinitionSupplier"] = $83ed8089ae5bc973$export$7111b45b195dd101;

});

parcelRegister("7XBGk", function(module, exports) {
var $077b30db84e7fa8f$export$e7b798431c659b80 = /*#__PURE__*/ function(AIAnswerAPIType) {
    AIAnswerAPIType["STREAM"] = "STREAM";
    return AIAnswerAPIType;
}({});
module.exports["AIAnswerAPIType"] = $077b30db84e7fa8f$export$e7b798431c659b80;

});

parcelRegister("3hVWe", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $zzZbq = parcelRequire("zzZbq");


var $eLxWr = parcelRequire("eLxWr");

const $3c43e73ca64de843$export$19a05d5f6391d0e1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    loading: undefined,
    isAnswered: false,
    hasError: false,
    advancedSearchUrl: undefined,
    onNavigate: ()=>{},
    updateContextCache: ()=>{},
    fireAnalyticsEvent: ()=>{},
    setQuery: ()=>{},
    setData: ()=>{},
    userDetails: {},
    disclaimer: null,
    commonAttributes: (0, $eLxWr.UNINITIALIZED_COMMON_ATTRIBUTES),
    initialCollapsed: undefined,
    liked: undefined,
    setLiked: ()=>{},
    likesDisabled: false,
    setLikesDisabled: ()=>{},
    initialReported: undefined,
    isReadingAids: false,
    dynamicLayoutSubAgentMessages: [],
    setDynamicLayoutSubAgentMessages: ()=>{},
    cardProviderProps: undefined,
    baseQuery: undefined,
    smartAnswersRoute: (0, $zzZbq.QueryIntent).DEFAULT,
    cardTemplate: (0, $zzZbq.CardTemplate).DEFAULT,
    brand: (0, $zzZbq.AiBrand).AI,
    answerEditor: undefined,
    closeParentDialog: ()=>{},
    showGenericFooter: false,
    initiallyExpanded: false,
    queryIntentClassificationData: undefined,
    traceHeaders: undefined
});
const $3c43e73ca64de843$export$1485bfa2a4aa8c9b = ()=>{
    return (0, $cozmU.useContext)($3c43e73ca64de843$export$19a05d5f6391d0e1);
};
module.exports["AIAnswerContext"] = $3c43e73ca64de843$export$19a05d5f6391d0e1;
module.exports["useAIAnswerContext"] = $3c43e73ca64de843$export$1485bfa2a4aa8c9b;

});

parcelRegister("eLxWr", function(module, exports) {

var $zzZbq = parcelRequire("zzZbq");

const $8b6fc5e12c05b68e$export$fcf902966c0f8c2f = {
    cloudId: '',
    query: '',
    queryHash: '',
    baseQueryHash: '',
    source: '',
    searchSessionId: '',
    answerString: '',
    answerLength: 0,
    answerWordCount: 0,
    answerFormat: null,
    answerCardType: (0, $zzZbq.AnswerCardType).SAIN,
    sources: [],
    followUps: [],
    errorStateSuggestedQueries: [],
    errorState: null,
    extraAttributes: {},
    apiSource: 'cc-search-nlp',
    workspaceId: '',
    sessionId: '',
    brand: (0, $zzZbq.AiBrand).AI,
    orgId: '',
    isHello: false
};
module.exports["UNINITIALIZED_COMMON_ATTRIBUTES"] = $8b6fc5e12c05b68e$export$fcf902966c0f8c2f;

});

parcelRegister("hcBeC", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $6JEx2 = parcelRequire("6JEx2");


var $7zn5c = parcelRequire("7zn5c");


var $7s8U5 = parcelRequire("7s8U5");


var $kqQyU = parcelRequire("kqQyU");


var $htnqN = parcelRequire("htnqN");


var $hpFQM = parcelRequire("hpFQM");


var $cuvLu = parcelRequire("cuvLu");


var $7DMz5 = parcelRequire("7DMz5");


var $zzZbq = parcelRequire("zzZbq");


var $EZPsO = parcelRequire("EZPsO");

const $90600a9a675bda6c$var$identityUserCloudARIPrefix = 'ari:cloud:identity::user/';
function $90600a9a675bda6c$var$getAgentAndExperience(isReadingAids) {
    return isReadingAids ? {
        named_id: 'reading_aids_agent',
        experience: 'reading-aids'
    } : {
        named_id: 'sain_agent',
        experience: 'sain'
    };
}
function $90600a9a675bda6c$var$mapMimeTypeToFormat(mimeType) {
    switch(mimeType){
        case 'text/markdown':
            return (0, $hpFQM.NLPSearchResultFormat).MARKDOWN;
        case 'text/adf':
            return (0, $hpFQM.NLPSearchResultFormat).ADF;
        case 'text/json':
            return (0, $hpFQM.NLPSearchResultFormat).JSON;
        default:
            return (0, $hpFQM.NLPSearchResultFormat).MARKDOWN;
    }
}
function $90600a9a675bda6c$var$mapErrorToSain(error, traceId) {
    const errorMessage = 'message_template' in error ? error.message_template : error.message.message_template;
    switch(errorMessage){
        case 'NO_ANSWER_LLM':
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).NoAnswer
            };
        case 'NO_ANSWER_PEOPLE':
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).NoAnswerWhoQuestion
            };
        case 'NO_ANSWER_KEYWORDS':
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).NoAnswerKeywords
            };
        case 'NO_ANSWER_SEARCH_QA_PLUGIN':
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).NoAnswerSearchResults
            };
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).AcceptableUseViolation
            };
        case 'OPENAI_RATE_LIMIT_USER_ABUSE':
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).NoAnswerOpenAIRateLimitUserAbuse
            };
        case 'FEATURE_DISABLED_ON_SITE':
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).AIDisabled
            };
        default:
            (0, $cuvLu.logger).error({
                error: error,
                functionName: 'mapErrorToSain: NetworkError',
                traceId: traceId
            });
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).NetworkError,
                networkErrorReason: 'unmapped_backend_error',
                networkErrorDetails: errorMessage,
                backendFailureType: 'unmapped_template'
            };
    }
}
function $90600a9a675bda6c$var$mapMessageToNLPSearchType(message, requestId) {
    // Handle cases where message is directly in root or nested under message.message
    const messageContent = message.message || message;
    return {
        nlpResult: messageContent.content,
        uniqueSources: message.sources ? message.sources.map((source)=>({
                ari: source.ari,
                id: source.id?.toString(),
                title: source.title,
                product: source.product,
                type: source.type,
                url: source.url,
                lastModified: source.lastModified,
                iconUrl: null,
                spaceName: null,
                spaceUrl: null
            })) : [],
        disclaimer: messageContent.message_metadata?.disclaimer ?? null,
        errorState: null,
        format: $90600a9a675bda6c$var$mapMimeTypeToFormat(messageContent.content_mime_type),
        extraAPIAnalyticsAttributes: {
            message_id: messageContent.id,
            conversational_channel_id: messageContent.conversation_channel_id,
            experience_id: messageContent.experience_id,
            user_id: messageContent.user_ari?.replace($90600a9a675bda6c$var$identityUserCloudARIPrefix, '') ?? null,
            userQuery: message.human_message?.content ?? null,
            requestId: (0, $ixfCV.fg)('kd_fix_sain_mau_instrumentation') ? requestId ?? null : message.message?.message_metadata?.request_id ?? null,
            answerGenerationModel: message.usage_data ?? null,
            ...!(0, $ixfCV.fg)('kd_consolidate_sources_analytics') && {
                sources: message.sources
            },
            cacheInfo: message.message?.message_metadata?.global_cache_info ?? null,
            pluginInvocations: message.message?.plugin_invocations,
            rawJson: message,
            ...(0, $ixfCV.fg)('kd_sain_online_debugger') && {
                minion_outputs: message.message?.minion_outputs,
                traceId: requestId ?? null
            }
        },
        authority_ui_metadata: messageContent.authority_ui_metadata ?? null
    };
}
async function* $90600a9a675bda6c$export$87d234127b4babfd({ fetchReturn: fetchReturn, variables: variables, fetchConfig: fetchConfig }) {
    try {
        const { query: query, locale: locale, experience: experience, filters: filters, cloudIdARI: cloudIdARI, followUpsEnabled: followUpsEnabled } = variables || {};
        const url = `${fetchConfig?.hostName || ''}${(0, $zzZbq.SAIN_STREAMING_API)}`;
        const response = await (fetchReturn ? fetchReturn : fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: query,
                filters: filters,
                locations: [
                    cloudIdARI
                ],
                locale: locale,
                experience: experience,
                followUpsEnabled: followUpsEnabled
            }),
            credentials: fetchConfig?.credentials || 'same-origin'
        }));
        if (!response.ok) // For non 200 status codes
        return {
            state: 'failed',
            reason: 'backend',
            details: 'Unhandled error response received',
            errorCode: response.status
        };
        if (!response.body) return {
            state: 'failed',
            reason: 'backend',
            details: 'response.body missing',
            errorCode: response.status
        };
        try {
            const reader = response.body.getReader();
            const decoder = new TextDecoder('utf-8');
            let buffer = '';
            let done = false;
            let finalResponse;
            while(!done){
                const { value: value, done: doneReading } = await reader.read();
                done = doneReading;
                const chunkValue = decoder.decode(value);
                buffer = buffer + chunkValue;
                // Split the buffer by line breaks
                const lines = buffer.split('\n');
                // Process all complete lines, except for the last one (which might be incomplete)
                while(lines.length > 1){
                    const line = lines.shift();
                    const parsedData = JSON.parse(line);
                    if (parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).AnswerType || parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).AnswerPart || parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).GenerationType || parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).Trace || parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).ErrorStateQuerySuggestions || parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage) yield parsedData;
                    else {
                        finalResponse = parsedData;
                        done = true;
                    }
                }
                // Keep the last (potentially incomplete) line in the buffer
                buffer = lines[0];
            }
            if (finalResponse?.type !== (0, $7s8U5.AIAnswerQueryStreamType).FinalResponse) return {
                state: 'failed',
                reason: 'parsing',
                error: 'Unexpected final response value'
            };
            return {
                state: 'complete',
                value: finalResponse
            };
        } catch (parsingError) {
            return {
                state: 'failed',
                reason: 'parsing',
                error: parsingError
            };
        }
    } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') // this is likely an abort error
        return {
            state: 'failed',
            reason: 'aborted'
        };
        if (error instanceof Error) return {
            state: 'failed',
            reason: 'error',
            details: error.message,
            error: error
        };
        return {
            state: 'failed',
            reason: 'unknown'
        };
    }
}
const $90600a9a675bda6c$var$getAgentInput = ({ variables: variables, fetchConfig: fetchConfig })=>{
    const { query: query, locale: locale, additional_context: additional_context, experimentContext: experimentContext, isQuerySuggestion: isQuerySuggestion } = variables || {};
    return {
        content: query,
        locale: locale,
        additional_context: additional_context,
        entity_ari: fetchConfig?.entity_ari,
        ...experimentContext && (0, $ixfCV.fg)('kd_sain_backend_exp_context') && {
            experimentContext: experimentContext
        },
        ...typeof isQuerySuggestion === 'boolean' ? {
            isQuerySuggestion: isQuerySuggestion
        } : {}
    };
};
const $90600a9a675bda6c$var$getPromptOverrideContext = ()=>{
    if (!(0, $ixfCV.fg)('convo_ai_sain_enable_prompt_override_hello_only')) return {};
    const promptOverride = (0, $6JEx2.getSessionItem)((0, $zzZbq.PROMPT_OVERRIDE_SESSION_KEY));
    if (!promptOverride) return {};
    return {
        aiFeatureContext: {
            systemPromptOverride: promptOverride
        }
    };
};
async function* $90600a9a675bda6c$export$3e1bd964ad0ba888({ fetchReturn: fetchReturn, variables: variables, isReadingAids: isReadingAids, fetchConfig: fetchConfig, generatorConfig: generatorConfig = {
    yieldAnswerPart: true,
    yieldFinalResponse: false
}, storeMessage: storeMessage, onStreamFinalResponse: onStreamFinalResponse }) {
    try {
        const { filters: filters, selectedProduct: selectedProduct } = variables || {};
        const { experience: experience, named_id: named_id } = $90600a9a675bda6c$var$getAgentAndExperience(isReadingAids);
        const url = `${fetchConfig?.hostName || ''}${(0, $zzZbq.ASSISTANCE_SERVICE_API_BASE_URL)}/rovo/v1/sain/stream`;
        const streamFilters = filters && !Array.isArray(filters) && (0, $ixfCV.fg)('kd_add_common_filters_support_to_sain') ? [
            {
                commonFilters: filters.commonFilters
            },
            {
                confluenceFilters: filters.confluenceFilters
            }
        ] : [
            {
                confluenceFilters: filters
            }
        ];
        if (selectedProduct) streamFilters.push({
            knowledgeSources: [
                selectedProduct
            ]
        });
        const response = await (fetchReturn ? fetchReturn : fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Product': 'confluence',
                'X-Experience-Id': experience,
                'X-Rovo-Chat-Capabilities': JSON.stringify([
                    'inline_lumina_enabled'
                ]),
                ...(0, $7DMz5.SAINFeatureControl).isSAINUpdatedFlowEnabled() && {
                    'X-Think-Deeper-Messages-Opt-In': 'true',
                    'X-New-Tool-Traces-Opt-In': 'true'
                },
                ...fetchConfig?.headers ? fetchConfig.headers : {}
            },
            body: JSON.stringify({
                recipient_agent_named_id: named_id,
                agent_input: {
                    ...$90600a9a675bda6c$var$getAgentInput({
                        variables: variables,
                        fetchConfig: fetchConfig
                    }),
                    filters: filters ? streamFilters : undefined,
                    ...$90600a9a675bda6c$var$getPromptOverrideContext()
                },
                ...storeMessage
            }),
            credentials: fetchConfig?.credentials || 'same-origin',
            signal: fetchConfig?.timeout ? AbortSignal.timeout(fetchConfig?.timeout) : undefined
        }));
        const traceId = response.headers.get('x-trace-id') || null;
        if (!response.body) return {
            state: 'failed',
            reason: 'backend',
            details: 'response.body missing',
            errorCode: response.status,
            backendFailureType: 'empty_body'
        };
        try {
            const reader = response.body.getReader();
            const decoder = new TextDecoder('utf-8');
            let buffer = '';
            let done = false;
            let finalResponse;
            const pluginsInvoked = [];
            yield {
                type: (0, $7s8U5.AIAnswerQueryStreamType).AnswerType,
                message: {
                    format: (0, $hpFQM.NLPSearchResultFormat).MARKDOWN
                }
            };
            while(!done){
                const { value: value, done: doneReading } = await reader.read();
                done = doneReading;
                const chunkValue = decoder.decode(value);
                buffer = buffer + chunkValue;
                // Split the buffer by line breaks
                const lines = buffer.split('\n');
                // add case here to return error from stream
                if (!response.ok) {
                    const finalResponse = JSON.parse(lines[0]);
                    if (finalResponse?.errors.includes((0, $kqQyU.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR)) return {
                        state: 'failed',
                        reason: 'backend',
                        details: (0, $kqQyU.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR,
                        errorCode: response.status,
                        backendFailureType: 'hipaa'
                    };
                    // For non 200 status codes
                    return {
                        state: 'failed',
                        reason: 'backend',
                        details: 'Unhandled error response received',
                        errorCode: response.status,
                        backendFailureType: 'http_error'
                    };
                }
                // Process all complete lines, except for the last one (which might be incomplete)
                while(lines.length > 1){
                    const line = lines.shift();
                    const parsedData = (0, $EZPsO.mapStreamSAINResponse)(JSON.parse(line), traceId);
                    if (parsedData.type === 'other') continue;
                    else if (parsedData.type === 'plugin-invocation') {
                        pluginsInvoked.push(parsedData.pluginName);
                        continue;
                    } else if (parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).AnswerType || parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).AnswerPart || parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).GenerationType || parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).Trace || parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage) {
                        if (generatorConfig.yieldAnswerPart) yield parsedData;
                    } else if (parsedData.type === 'follow-up') {
                        if (!finalResponse?.message || !variables?.followUpsEnabled) continue;
                        finalResponse.message.nlpFollowUpResults = {
                            followUps: parsedData.queries
                        };
                        const { serveExperiment: serveErrorStateSuggestedQueriesExp } = (0, $7zn5c.getFrontendExperiment)({
                            abTestId: 'kd_sain_show_no_answer_suggestions_exp'
                        });
                        if (!serveErrorStateSuggestedQueriesExp) done = true;
                    } else if (parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).ErrorStateQuerySuggestions) {
                        if (!finalResponse?.message) continue;
                        finalResponse.message.nlpSuggestedQueries = parsedData.suggested_queries;
                        done = true;
                    } else if (parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).EarlyStop) return {
                        state: 'complete',
                        value: parsedData
                    };
                    else {
                        finalResponse = parsedData;
                        onStreamFinalResponse?.();
                        if (!variables?.followUpsEnabled) done = true;
                        if (generatorConfig.yieldFinalResponse) yield finalResponse;
                    }
                }
                // Keep the last (potentially incomplete) line in the buffer
                buffer = lines[0];
            }
            if (finalResponse?.type !== (0, $7s8U5.AIAnswerQueryStreamType).FinalResponse) return {
                state: 'failed',
                reason: 'parsing',
                error: 'Unexpected final response value'
            };
            if ((0, $ixfCV.fg)('kd_add_plugins_invoked')) {
                const filteredPluginsInvoked = pluginsInvoked.filter(Boolean);
                if (filteredPluginsInvoked.length > 0 && finalResponse.message) {
                    const existing = finalResponse.message.extraAPIAnalyticsAttributes?.pluginsInvoked ?? [];
                    finalResponse.message.extraAPIAnalyticsAttributes = {
                        ...finalResponse.message.extraAPIAnalyticsAttributes,
                        pluginsInvoked: [
                            ...new Set([
                                ...existing,
                                ...filteredPluginsInvoked
                            ])
                        ]
                    };
                }
            }
            return {
                state: 'complete',
                value: finalResponse
            };
        } catch (parsingError) {
            return {
                state: 'failed',
                reason: 'parsing',
                error: parsingError
            };
        }
    } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') return {
            state: 'failed',
            reason: 'aborted'
        };
        if (error instanceof DOMException && error.name === 'TimeoutError') return {
            state: 'failed',
            reason: 'timeout'
        };
        if (error instanceof Error) return {
            state: 'failed',
            reason: 'error',
            details: error.message,
            error: error
        };
        return {
            state: 'failed',
            reason: 'unknown'
        };
    }
}
async function $90600a9a675bda6c$export$c8ae4e2310d6c222({ variables: variables, isReadingAids: isReadingAids, fetchConfig: fetchConfig }) {
    const { experience: experience, named_id: named_id } = $90600a9a675bda6c$var$getAgentAndExperience(isReadingAids);
    const url = `${fetchConfig?.hostName || ''}${(0, $zzZbq.ASSISTANCE_SERVICE_API_BASE_URL)}/chat/v1/invoke_agent`;
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Product': 'confluence',
            'X-Experience-Id': experience,
            ...fetchConfig?.headers
        },
        body: JSON.stringify({
            recipient_agent_named_id: named_id,
            agent_input: $90600a9a675bda6c$var$getAgentInput({
                variables: variables,
                fetchConfig: fetchConfig
            })
        }),
        credentials: fetchConfig?.credentials || 'same-origin',
        signal: fetchConfig?.timeout ? AbortSignal.timeout(fetchConfig?.timeout) : undefined
    });
    const traceId = response.headers.get('x-trace-id') || null;
    const data = await response.json();
    if ('message_template' in data) {
        const { errorState: errorState, networkErrorReason: networkErrorReason, networkErrorDetails: networkErrorDetails, backendFailureType: backendFailureType } = $90600a9a675bda6c$var$mapErrorToSain(data, traceId);
        return {
            nlpSearch: {
                errorState: errorState,
                networkErrorReason: networkErrorReason,
                networkErrorDetails: networkErrorDetails,
                backendFailureType: backendFailureType,
                disclaimer: null,
                format: (0, $hpFQM.NLPSearchResultFormat).MARKDOWN,
                uniqueSources: []
            }
        };
    }
    return {
        nlpSearch: $90600a9a675bda6c$var$mapMessageToNLPSearchType(data, traceId)
    };
}
async function* $90600a9a675bda6c$export$824b789d24de77d3({ fetchReturn: fetchReturn, variables: variables, fetchConfig: fetchConfig, generatorConfig: generatorConfig = {
    yieldAnswerPart: true,
    yieldFinalResponse: false
}, onStreamFinalResponse: onStreamFinalResponse }) {
    try {
        const url = `${fetchConfig?.hostName || ''}${(0, $zzZbq.ASSISTANCE_SERVICE_API_BASE_URL)}/rovo/v1/ai-definition`;
        const response = await (fetchReturn ? fetchReturn : fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Product': 'confluence',
                'X-Experience-Id': 'reading-aids',
                ...fetchConfig?.headers ? fetchConfig.headers : {}
            },
            body: JSON.stringify({
                ...$90600a9a675bda6c$var$getAgentInput({
                    variables: variables,
                    fetchConfig: fetchConfig
                })
            }),
            credentials: fetchConfig?.credentials || 'same-origin',
            signal: fetchConfig?.timeout ? AbortSignal.timeout(fetchConfig?.timeout) : undefined
        }));
        const traceId = response.headers.get('x-trace-id') || null;
        if (!response.body) return {
            state: 'failed',
            reason: 'backend',
            details: 'response.body missing',
            errorCode: response.status,
            backendFailureType: 'empty_body'
        };
        try {
            const reader = response.body.getReader();
            const decoder = new TextDecoder('utf-8');
            let buffer = '';
            let done = false;
            let finalResponse;
            yield {
                type: (0, $7s8U5.AIAnswerQueryStreamType).AnswerType,
                message: {
                    format: (0, $hpFQM.NLPSearchResultFormat).MARKDOWN
                }
            };
            while(!done){
                const { value: value, done: doneReading } = await reader.read();
                done = doneReading;
                const chunkValue = decoder.decode(value);
                buffer = buffer + chunkValue;
                // Split the buffer by line breaks
                const lines = buffer.split('\n');
                // add case here to return error from stream
                if (!response.ok) {
                    const finalResponse = JSON.parse(lines[0]);
                    if (finalResponse?.errors.includes((0, $kqQyU.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR)) return {
                        state: 'failed',
                        reason: 'backend',
                        details: (0, $kqQyU.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR,
                        errorCode: response.status,
                        backendFailureType: 'hipaa'
                    };
                    return {
                        state: 'failed',
                        reason: 'backend',
                        details: 'Unhandled error response received',
                        errorCode: response.status,
                        backendFailureType: 'http_error'
                    };
                }
                // Process all complete lines, except for the last one (which might be incomplete)
                while(lines.length > 1){
                    const line = lines.shift();
                    const parsedData = (0, $EZPsO.mapStreamDefinitionResponse)(JSON.parse(line), traceId);
                    if (parsedData.type === 'other') continue;
                    else if (parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).AnswerType || parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).AnswerPart || parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).GenerationType || parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).Trace || parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage) {
                        if (generatorConfig.yieldAnswerPart) yield parsedData;
                    } else if (parsedData.type === 'follow-up') {
                        if (!finalResponse?.message || !variables?.followUpsEnabled) continue;
                        finalResponse.message.nlpFollowUpResults = {
                            followUps: parsedData.queries
                        };
                        const { serveExperiment: serveErrorStateSuggestedQueriesExp } = (0, $7zn5c.getFrontendExperiment)({
                            abTestId: 'kd_sain_show_no_answer_suggestions_exp'
                        });
                        if (!serveErrorStateSuggestedQueriesExp) done = true;
                    } else if (parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).ErrorStateQuerySuggestions) {
                        if (!finalResponse?.message) continue;
                        finalResponse.message.nlpSuggestedQueries = parsedData.suggested_queries;
                        done = true;
                    } else {
                        finalResponse = parsedData;
                        onStreamFinalResponse?.();
                        if (!variables?.followUpsEnabled) done = true;
                        if (generatorConfig.yieldFinalResponse) yield finalResponse;
                    }
                }
                // Keep the last (potentially incomplete) line in the buffer
                buffer = lines[0];
            }
            if (finalResponse?.type !== (0, $7s8U5.AIAnswerQueryStreamType).FinalResponse) return {
                state: 'failed',
                reason: 'parsing',
                error: 'Unexpected final response value'
            };
            return {
                state: 'complete',
                value: finalResponse
            };
        } catch (parsingError) {
            return {
                state: 'failed',
                reason: 'parsing',
                error: parsingError
            };
        }
    } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') return {
            state: 'failed',
            reason: 'aborted'
        };
        if (error instanceof DOMException && error.name === 'TimeoutError') return {
            state: 'failed',
            reason: 'timeout'
        };
        if (error instanceof Error) return {
            state: 'failed',
            reason: 'error',
            details: error.message,
            error: error
        };
        return {
            state: 'failed',
            reason: 'unknown'
        };
    }
}
module.exports["sainStreamFetchConvoAIService"] = $90600a9a675bda6c$export$3e1bd964ad0ba888;
module.exports["aiDefinitionsStreamFetchConvoAIService"] = $90600a9a675bda6c$export$824b789d24de77d3;

});

parcelRegister("6JEx2", function(module, exports) {

var $7dBf8 = parcelRequire("7dBf8");


var $ixfCV = parcelRequire("ixfCV");

const $37713e14e82d0a4d$export$9d075e4b938a80be = 'atlassian.search-dialog-sticky';
const $37713e14e82d0a4d$export$240cb7dc75f6cac2 = 'atlassian.search-dialog-query';
const $37713e14e82d0a4d$export$978fb20afa14aaa7 = 'atlassian.search-dialog-filters';
const $37713e14e82d0a4d$export$f4dca218ecb5824a = 'atlassian.search-dialog.ai-dialog';
const $37713e14e82d0a4d$var$getWindow = ()=>{
    if (typeof window === 'undefined') return null;
    // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
    if (typeof window.sessionStorage === 'undefined' && (0, $ixfCV.fg)('fix_ssr_browser_storage_undefined')) return null;
    return window;
};
const $37713e14e82d0a4d$export$fdf7104ff19cc288 = (key)=>{
    const windowReady = $37713e14e82d0a4d$var$getWindow();
    if (!windowReady) return null;
    return (0, $ixfCV.fg)('search_page_use_bsc_session_storage') ? (0, $7dBf8.AtlBrowserStorageSession).getItem(key) : $37713e14e82d0a4d$var$getWindow()?.sessionStorage.getItem(key);
};
const $37713e14e82d0a4d$export$a5376dd4adeb0fbf = (key, value)=>{
    const windowReady = $37713e14e82d0a4d$var$getWindow();
    if (!windowReady) return;
    try {
        if ((0, $ixfCV.fg)('search_page_use_bsc_session_storage')) (0, $7dBf8.AtlBrowserStorageSession).setItem(key, value);
        else $37713e14e82d0a4d$var$getWindow()?.sessionStorage.setItem(key, value);
    } catch (error) {
        error.code, DOMException.QUOTA_EXCEEDED_ERR;
    }
};
const $37713e14e82d0a4d$export$5896963da935fdc4 = (key)=>{
    const windowReady = $37713e14e82d0a4d$var$getWindow();
    if (!windowReady) return;
    if ((0, $ixfCV.fg)('search_page_use_bsc_session_storage')) (0, $7dBf8.AtlBrowserStorageSession).removeItem(key);
    else $37713e14e82d0a4d$var$getWindow()?.sessionStorage.removeItem(key);
};
module.exports["SEARCH_QUERY_KEY"] = $37713e14e82d0a4d$export$240cb7dc75f6cac2;
module.exports["SEARCH_FILTERS_KEY"] = $37713e14e82d0a4d$export$978fb20afa14aaa7;
module.exports["SEARCH_SHOW_AI_DIALOG_KEY"] = $37713e14e82d0a4d$export$f4dca218ecb5824a;
module.exports["getSessionItem"] = $37713e14e82d0a4d$export$fdf7104ff19cc288;
module.exports["setSessionItem"] = $37713e14e82d0a4d$export$a5376dd4adeb0fbf;
module.exports["deleteSessionItem"] = $37713e14e82d0a4d$export$5896963da935fdc4;

});

parcelRegister("7zn5c", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $2wiZs = parcelRequire("2wiZs");

const $bd707cc6f6ee43a7$export$a68238496eb1c8ce = ({ abTestId: abTestId, onError: onError })=>{
    try {
        const cohort = (0, $cXtTj.default).getExperiment(abTestId).get('cohort', (0, $2wiZs.Cohort).Default);
        const serveExperiment = cohort === (0, $2wiZs.Cohort).Test;
        return {
            serveExperiment: serveExperiment,
            abTestId: abTestId,
            cohort: cohort
        };
    } catch (error) {
        onError?.(error);
    }
    return {
        serveExperiment: false,
        abTestId: abTestId,
        cohort: (0, $2wiZs.Cohort).Default
    };
};
const $bd707cc6f6ee43a7$export$8774a01dc80b4a26 = (overrides)=>{
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    if ((0, $cXtTj.default).checkGate('search-experiment-overrides-killswitch')) return $bd707cc6f6ee43a7$var$defaultCheckGate;
    if (!overrides) return $bd707cc6f6ee43a7$var$defaultCheckGate;
    try {
        const gates = overrides.filter((overrides)=>overrides.type === 'gate');
        const getFeatureGate = (name)=>{
            const overrideFeatureGate = gates.find((override)=>'name' in override && override.name === name);
            if (!overrideFeatureGate) return $bd707cc6f6ee43a7$var$defaultCheckGate(name);
            // Overrides always resolve to true as using an override is equivelant to turning FF on.
            return true;
        };
        return getFeatureGate;
    } catch (e) {
        console.error(e);
        return $bd707cc6f6ee43a7$var$defaultCheckGate;
    }
};
const $bd707cc6f6ee43a7$export$841981a8a1feee8d = (overrides)=>{
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    if ((0, $cXtTj.default).checkGate('search-experiment-overrides-killswitch')) return $bd707cc6f6ee43a7$export$a68238496eb1c8ce;
    if (!overrides) return $bd707cc6f6ee43a7$export$a68238496eb1c8ce;
    try {
        const experiments = overrides.filter((overrides)=>overrides.type === 'experiment');
        const customGetFrontendExperiment = ({ abTestId: abTestId, onError: onError })=>{
            const overrideFrontendExperiment = experiments.find((override)=>'name' in override && override.name === abTestId);
            if (!overrideFrontendExperiment) return $bd707cc6f6ee43a7$export$a68238496eb1c8ce({
                abTestId: abTestId,
                onError: onError
            });
            return {
                abTestId: abTestId,
                serveExperiment: true,
                cohort: 'cohort' in overrideFrontendExperiment ? overrideFrontendExperiment.cohort : (0, $2wiZs.Cohort).Test
            };
        };
        return customGetFrontendExperiment;
    } catch (e) {
        console.error(e);
        return $bd707cc6f6ee43a7$export$a68238496eb1c8ce;
    }
};
// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
const $bd707cc6f6ee43a7$var$defaultCheckGate = (name)=>(0, $cXtTj.default).checkGate(name);
const $bd707cc6f6ee43a7$export$b8cc3cdd046fba93 = (uiExperimentName, layerName, options = {
    fireLayerExposure: true
})=>{
    const layer = (0, $cXtTj.default).getLayer(layerName, {
        fireLayerExposure: false
    });
    const frontendExperimentName = layer.get('frontendExperimentName', '');
    if (frontendExperimentName === uiExperimentName) return (0, $cXtTj.default).getLayer(layerName, options);
    return undefined;
};
module.exports["getFrontendExperiment"] = $bd707cc6f6ee43a7$export$a68238496eb1c8ce;
module.exports["createFeatureGateHandler"] = $bd707cc6f6ee43a7$export$8774a01dc80b4a26;
module.exports["createFrontendExperimentHandler"] = $bd707cc6f6ee43a7$export$841981a8a1feee8d;
module.exports["getMutuallyExclusiveUIExperiment"] = $bd707cc6f6ee43a7$export$b8cc3cdd046fba93;

});

parcelRegister("2wiZs", function(module, exports) {
var $695dfb69bc28d28c$export$b76685d1b5a37732 = /*#__PURE__*/ function(Cohort) {
    Cohort["Default"] = "not-enrolled";
    Cohort["Control"] = "control";
    Cohort["Test"] = "test";
    return Cohort;
}({});
module.exports["Cohort"] = $695dfb69bc28d28c$export$b76685d1b5a37732;

});

parcelRegister("7s8U5", function(module, exports) {
var $39c6704e11fb0392$export$130eddddf4243f3f = /*#__PURE__*/ function(AIAnswerQueryStreamType) {
    AIAnswerQueryStreamType["AnswerType"] = "ANSWER_TYPE";
    AIAnswerQueryStreamType["GenerationType"] = "ANSWER_GENERATION_TYPE";
    AIAnswerQueryStreamType["AnswerPart"] = "ANSWER_PART";
    AIAnswerQueryStreamType["FinalResponse"] = "FINAL_RESPONSE";
    AIAnswerQueryStreamType["Trace"] = "TRACE";
    AIAnswerQueryStreamType["ErrorStateQuerySuggestions"] = "ERROR_STATE_QUERY_SUGGESTIONS";
    AIAnswerQueryStreamType["DynamicLayoutSubAgentMessage"] = "DL_SUB_AGENT";
    AIAnswerQueryStreamType["EarlyStop"] = "EARLY_STOP";
    return AIAnswerQueryStreamType;
}({});
module.exports["AIAnswerQueryStreamType"] = $39c6704e11fb0392$export$130eddddf4243f3f;

});

parcelRegister("kqQyU", function(module, exports) {
var $75d15123b426d0da$export$6b1112c70cca65d3 = /*#__PURE__*/ function(NLPSearchErrorCodes) {
    NLPSearchErrorCodes["HIPAA_ENABLED_ERROR"] = "convoai.rest.browsing.product.has.hipaa.enabled";
    return NLPSearchErrorCodes;
}({});
module.exports["NLPSearchErrorCodes"] = $75d15123b426d0da$export$6b1112c70cca65d3;

});

parcelRegister("htnqN", function(module, exports) {
var $23c5d95fd834a4b7$export$9405d23bea8d0d8b = /*#__PURE__*/ function(NLPSearchErrorState) {
    NLPSearchErrorState["NoAnswer"] = "NO_ANSWER";
    NLPSearchErrorState["NoAnswerKeywords"] = "NO_ANSWER_KEYWORDS";
    NLPSearchErrorState["NoAnswerSearchResults"] = "NO_ANSWER_SEARCH_RESULTS";
    NLPSearchErrorState["NoAnswerHydration"] = "NO_ANSWER_HYDRATION";
    NLPSearchErrorState["NoAnswerRelevantContent"] = "NO_ANSWER_RELEVANT_CONTENT";
    NLPSearchErrorState["NoAnswerOpenAIResponseError"] = "NO_ANSWER_OPEN_AI_RESPONSE_ERR";
    NLPSearchErrorState["NoAnswerOpenAIRateLimitUserAbuse"] = "OPENAI_RATE_LIMIT_USER_ABUSE";
    NLPSearchErrorState["NoAnswerWhoQuestion"] = "NO_ANSWER_WHO_QUESTION";
    NLPSearchErrorState["SubjectiveQuery"] = "SUBJECTIVE_QUERY";
    NLPSearchErrorState["AcceptableUseViolation"] = "ACCEPTABLE_USE_VIOLATIONS";
    NLPSearchErrorState["AIDisabled"] = "AI_DISABLED";
    NLPSearchErrorState["EarlyStop"] = "EARLY_STOP";
    // These values are not returned from the BE and are only used by the FE
    NLPSearchErrorState["Default"] = "DEFAULT";
    NLPSearchErrorState["NetworkError"] = "NETWORK_ERROR";
    NLPSearchErrorState["TimeoutError"] = "TIMEOUT_ERROR";
    NLPSearchErrorState["HIPAAError"] = "HIPAA_ERROR";
    NLPSearchErrorState["RenderError"] = "RENDER_ERROR";
    return NLPSearchErrorState;
}({});
module.exports["NLPSearchErrorState"] = $23c5d95fd834a4b7$export$9405d23bea8d0d8b;

});

parcelRegister("cuvLu", function(module, exports) {

var $9kP1w = parcelRequire("9kP1w");

const $24c5d3b79a8553ed$var$error = async ({ error: error, functionName: functionName, traceId: traceId })=>{
    try {
        const SentryClient = await (0, $9kP1w.getSentryClient)();
        if (!SentryClient) return;
        SentryClient.withScope((scope)=>{
            scope.setTag('packageName', '@atlassian/search-ai');
            scope.setFingerprint([
                `functionName: ${functionName}`
            ]);
            if (traceId) scope.setTag('traceId', traceId);
            SentryClient.captureException(error, scope);
        });
    } catch (error) {
        // When there was an error with Sentry, just output to console
        // eslint-disable-next-line no-console
        console.error(error);
    }
};
const $24c5d3b79a8553ed$export$af88d00dbe7f521 = {
    error: $24c5d3b79a8553ed$var$error
};
module.exports["logger"] = $24c5d3b79a8553ed$export$af88d00dbe7f521;

});

parcelRegister("9kP1w", function(module, exports) {

var $4Z7Gy = parcelRequire("4Z7Gy");


var $1XLxS = parcelRequire("1XLxS");


var $21lBS = parcelRequire("21lBS");

let $31b5892e00f59305$var$Sentry;
const $31b5892e00f59305$var$beforeSend = (event)=>{
    // Delete the query string as it contains UGC
    if (event.request?.url) event.request.url = event.request.url.split('?')[0];
    if (event.request?.headers?.Referer) event.request.headers.Referer = event.request.headers.Referer.split('?')[0];
    if (event.environment === 'development') return null;
    return event;
};

const $31b5892e00f59305$export$f553e8b08ef59d31 = async ()=>{
    if (!$31b5892e00f59305$var$Sentry) $31b5892e00f59305$var$Sentry = Promise.resolve((parcelRequire("eieXD"))).then((SentryModule)=>{
        SentryModule.init({
            dsn: (0, $21lBS.SENTRY_DSN),
            attachStacktrace: true,
            release: (0, $4Z7Gy.PRODUCT_BUILD) || (0, $21lBS.UNKNOWN_TAG),
            environment: (0, $1XLxS.getEnvironment)(),
            beforeSend: $31b5892e00f59305$var$beforeSend
        });
        return SentryModule;
    }).catch(()=>{
    // TODO: Retry mechanism for chunk loading failures?
    });
    return $31b5892e00f59305$var$Sentry;
};
module.exports["getSentryClient"] = $31b5892e00f59305$export$f553e8b08ef59d31;

});

parcelRegister("4Z7Gy", function(module, exports) {
// @ts-nocheck - extra properties on window are not known
/**
 * Constants for the build version of the product. Each product specifies
 * build version in a different way.
 *  - Jira: window.BUILD_KEY
 *  - Confluence: window.__buildInfo.FRONTEND_VERSION
 *  - For the service workers where window is not available, we return 'unknown'.
 */ const $9e905647717b836a$export$668f31ea3127f48f = (typeof window !== 'undefined' && (window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION)) ?? 'unknown';
module.exports["PRODUCT_BUILD"] = $9e905647717b836a$export$668f31ea3127f48f;

});

parcelRegister("1XLxS", function(module, exports) {
const $95ec216372a1151c$export$57570b1603cf6adb = ()=>{
    if (window.location.hostname.includes('localhost')) return 'development';
    else if (window.location.hostname.includes('jira-dev.com') || window.location.hostname.includes('stg.atlassian.com')) return 'staging';
    else return 'production';
};
module.exports["getEnvironment"] = $95ec216372a1151c$export$57570b1603cf6adb;

});

parcelRegister("21lBS", function(module, exports) {
// https://atlassian-2y.sentry.io/projects/afm-search-ai/getting-started/
const $da80adf2194c7fdc$export$6faa4a850bc4d0ce = 'https://467ed23c400f1de490da05364bed5930@o55978.ingest.us.sentry.io/4507432686125056';
const $da80adf2194c7fdc$export$ea77880e3935182d = 'unknown';
module.exports["SENTRY_DSN"] = $da80adf2194c7fdc$export$6faa4a850bc4d0ce;
module.exports["UNKNOWN_TAG"] = $da80adf2194c7fdc$export$ea77880e3935182d;

});

parcelRegister("7DMz5", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $1UWNP = parcelRequire("1UWNP");


var $cXtTj = parcelRequire("cXtTj");


var $ixfCV = parcelRequire("ixfCV");


var $1XsRq = parcelRequire("1XsRq");

const $52567597a0df92ee$var$canRenderLuminaUnmemoized = ()=>{
    if ((0, $ixfCV.fg)('kd_dynamic_layout_in_sain')) return true;
    return false;
};
const $52567597a0df92ee$var$isSAINUXUpliftEnabledUnmemoized = ()=>{
    if ((0, $ixfCV.fg)('kd_team_26_sain_borderless_update')) return true;
    const helloLayer = (0, $cXtTj.default).getLayer((0, $1XsRq.SAIN_HELLO_LAYER_NAME));
    const helloCustomersEnabled = helloLayer.get('SAINUXUpliftEnabled', false);
    const customerLayer = (0, $cXtTj.default).getLayer((0, $1XsRq.SAIN_LAYER_NAME));
    const customersEnabled = customerLayer.get('SAINUXUpliftEnabled', false);
    if (helloCustomersEnabled || customersEnabled) return true;
    return false;
};
const $52567597a0df92ee$var$isSourcesInShortSAINAnswersEnabledUnmemoized = ()=>{
    if ((0, $ixfCV.fg)('kd_sain_show_sources_in_short_answers')) return true;
    return (0, $1XsRq.hasSAINLayerParamValue)('sourcesInShortSAINAnswers', 'test');
};
const $52567597a0df92ee$var$isZeroQuerySuggestionsV1EnabledUnmemoized = (primaryProduct)=>{
    if (primaryProduct === 'jira') return (0, $ixfCV.fg)('kd_jira_prequery_suggestions_v1');
    if (primaryProduct === 'confluence') return (0, $ixfCV.fg)('kd_confluence_prequery_suggestions_v1');
    return false;
};
const $52567597a0df92ee$var$isFullHeightLuminaEnabledUnmemoized = ()=>{
    if ((0, $ixfCV.fg)('kd_enable_full_height_lumina')) return true;
    return false;
};
const $52567597a0df92ee$var$isNonPrimaryClickTrackingEnabledUnmemoized = ()=>{
    if ((0, $ixfCV.fg)('kd_track_non_primary_clicks_gate')) return true;
    if ((0, $cXtTj.default).getExperimentValue('kd_track_non_primary_clicks', 'shouldTrackNonPrimaryClicks', 'control', {
        fireExperimentExposure: false
    }) === 'test') return true;
    return false;
};
const $52567597a0df92ee$var$triggerNonPrimaryClickTrackingExposure = ()=>{
    try {
        if (!(0, $ixfCV.fg)('kd_track_non_primary_clicks_gate')) (0, $cXtTj.default).manuallyLogExperimentExposure('kd_track_non_primary_clicks');
    } catch  {
    // Silently fail if FeatureGates is not available (e.g., in test environments)
    }
};
const $52567597a0df92ee$var$isNavigationalIntentEnabledUnmemoized = ()=>{
    if ((0, $ixfCV.fg)('kd_sain_enable_navigational_intent_gate')) return true;
    return false;
};
const $52567597a0df92ee$var$isInlineCitationsUpdateEnabledUnmemoized = ()=>{
    if ((0, $ixfCV.fg)('kd_team_26_sain_inline_citations_update')) return true;
    if ((0, $1XsRq.hasSAINHelloLayerParamValue)('InlineCitationUpdate', 'test')) return true;
    if ((0, $1XsRq.hasSAINLayerParamValue)('InlineCitationUpdate', 'test')) return true;
    return false;
};
const $52567597a0df92ee$var$isLinkListSourcesEnabledUnmemoized = ()=>{
    if ((0, $ixfCV.fg)('kd_sain_link_list_sources')) return true;
    if ((0, $1XsRq.hasSAINUXLayerParamValue)('SAINRecentLinksListEnabled', 'test')) return true;
    return false;
};
const $52567597a0df92ee$var$isImprovedChatOptionsEnabledUnmemoized = ()=>{
    if ((0, $ixfCV.fg)('kd_sain_improved_chat_options')) return true;
    if ((0, $1XsRq.hasSAINHelloLayerParamValue)('SAINImprovedChatOptions', 'test')) return true;
    if ((0, $1XsRq.hasSAINLayerParamValue)('SAINImprovedChatOptions', 'test')) return true;
    return false;
};
const $52567597a0df92ee$var$isSAINUpdatedFlowEnabledUnmemoized = ()=>{
    if ((0, $ixfCV.fg)('kd_sain_user_flow_updates_enabled')) return true;
    if ((0, $1XsRq.hasSAINUXHelloLayerParamValue)('sainFlowUpdates', 'test')) return true;
    return false;
};
const $52567597a0df92ee$var$isPeopleConnectorUXEnabledUnmemoized = ()=>{
    if ((0, $ixfCV.fg)('kd_sain_pt_person_team_26')) return true;
    if ((0, $1XsRq.hasSAINUXHelloLayerParamValue)('PeopleConnectorUXEnabled', 'people')) return true;
    if ((0, $1XsRq.hasSAINUXLayerParamValue)('PeopleConnectorUXEnabled', 'people')) return true;
    return false;
};
const $52567597a0df92ee$var$isJiraSAINCardSmartLinkEnabledUnmemoized = ({ sourceProduct: sourceProduct })=>{
    const { serveExperiment: serveJiraFPSNLQNavigationExperiment } = (0, $1XsRq.getJiraUIExperienceLayerFrontendExperiment)({
        abTestId: 'rovo_jira_nin_fps_nlq_navigation_exp'
    });
    const { serveExperiment: serveJiraFPSNLQNavigationTenantsExperiment } = (0, $1XsRq.getJiraUIExperienceTenantsLayerFrontendExperiment)({
        abTestId: 'rovo_jira_nin_fps_nlq_navigation_tenants_exp'
    });
    return sourceProduct === 'jira' && ((0, $ixfCV.fg)('kd_jira_sain_card_smartlink_fg') || serveJiraFPSNLQNavigationExperiment || serveJiraFPSNLQNavigationTenantsExperiment);
};
const $52567597a0df92ee$export$1f65635c37e1bde3 = {
    canRenderLumina: (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($52567597a0df92ee$var$canRenderLuminaUnmemoized),
    isSAINUXUpliftEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($52567597a0df92ee$var$isSAINUXUpliftEnabledUnmemoized),
    isFullHeightLuminaEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($52567597a0df92ee$var$isFullHeightLuminaEnabledUnmemoized),
    isSourcesInShortSAINAnswersEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($52567597a0df92ee$var$isSourcesInShortSAINAnswersEnabledUnmemoized),
    isZeroQuerySuggestionsV1Enabled: (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($52567597a0df92ee$var$isZeroQuerySuggestionsV1EnabledUnmemoized),
    isNonPrimaryClickTrackingEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($52567597a0df92ee$var$isNonPrimaryClickTrackingEnabledUnmemoized),
    triggerNonPrimaryClickTrackingExposure: $52567597a0df92ee$var$triggerNonPrimaryClickTrackingExposure,
    isJiraSAINCardSmartLinkEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($52567597a0df92ee$var$isJiraSAINCardSmartLinkEnabledUnmemoized),
    isNavigationalIntentEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($52567597a0df92ee$var$isNavigationalIntentEnabledUnmemoized),
    isInlineCitationsUpdateEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($52567597a0df92ee$var$isInlineCitationsUpdateEnabledUnmemoized),
    isLinkListSourcesEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($52567597a0df92ee$var$isLinkListSourcesEnabledUnmemoized),
    isPeopleConnectorUXEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($52567597a0df92ee$var$isPeopleConnectorUXEnabledUnmemoized),
    isSAINUpdatedFlowEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($52567597a0df92ee$var$isSAINUpdatedFlowEnabledUnmemoized),
    isImprovedChatOptionsEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($52567597a0df92ee$var$isImprovedChatOptionsEnabledUnmemoized)
};
module.exports["SAINFeatureControl"] = $52567597a0df92ee$export$1f65635c37e1bde3;

});

parcelRegister("1XsRq", function(module, exports) {

var $1UWNP = parcelRequire("1UWNP");


var $cXtTj = parcelRequire("cXtTj");


var $7zn5c = parcelRequire("7zn5c");


var $fUTzE = parcelRequire("fUTzE");


var $cuvLu = parcelRequire("cuvLu");

const $1c4c47b3b90137c3$export$5091efb9b1abe9af = 'kd_sain_layer';
const $1c4c47b3b90137c3$export$61cd502eadfc7f4a = 'kd_sain_hello_layer';
const $1c4c47b3b90137c3$export$424fa15ff0b7ba = 'kd_sain_ux_layer';
const $1c4c47b3b90137c3$export$7ddc02143e0dc525 = 'kd_sain_ux_hello_layer';
const $1c4c47b3b90137c3$export$fb4dba971e54444f = 'rovo_jira_ui_experience_layer';
const $1c4c47b3b90137c3$export$50eae6f311ab1b36 = 'rovo_jira_ui_tenants_experience_layer';
function $1c4c47b3b90137c3$var$doesLayerFrontendExperimentExist(layerName, abTestId) {
    const layer = (0, $cXtTj.default).getLayer(layerName, {
        fireLayerExposure: false
    });
    const layerFrontendExperimentName = layer.get('frontendExperimentName', null);
    return layerFrontendExperimentName !== null && layerFrontendExperimentName === abTestId;
}
function $1c4c47b3b90137c3$var$getLayerFrontendExperimentUnmemoized({ layerName: layerName, abTestId: abTestId, onError: onError }) {
    const falseEvaluationResult = {
        serveExperiment: false,
        abTestId: abTestId,
        cohort: 'not-enrolled'
    };
    const handleError = (error)=>{
        (0, $cuvLu.logger).error({
            error: error,
            functionName: `getLayerFrontendExperimentUnmemoized(${layerName})`
        });
        onError?.(error);
    };
    try {
        // we skip experiment evaluation if the user is part of the SAIN holdback experiment test cohort,
        // because SAIN is disabled in this case
        if ((0, $fUTzE.isPartofSainHoldbackExperiment)()) return falseEvaluationResult;
        if ($1c4c47b3b90137c3$var$doesLayerFrontendExperimentExist(layerName, abTestId)) return (0, $7zn5c.getFrontendExperiment)({
            abTestId: abTestId,
            onError: handleError
        });
    } catch (error) {
        handleError(error);
    }
    return falseEvaluationResult;
}
const $1c4c47b3b90137c3$export$3de2a2aa2c11f251 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((params)=>$1c4c47b3b90137c3$var$getLayerFrontendExperimentUnmemoized({
        ...params,
        layerName: $1c4c47b3b90137c3$export$5091efb9b1abe9af
    }), ({ abTestId: abTestId })=>abTestId);
const $1c4c47b3b90137c3$export$5c2fc79d2a515e54 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((params)=>$1c4c47b3b90137c3$var$getLayerFrontendExperimentUnmemoized({
        ...params,
        layerName: $1c4c47b3b90137c3$export$61cd502eadfc7f4a
    }), ({ abTestId: abTestId })=>abTestId);
const $1c4c47b3b90137c3$export$eff5ae0107dfb424 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((params)=>$1c4c47b3b90137c3$var$getLayerFrontendExperimentUnmemoized({
        ...params,
        layerName: $1c4c47b3b90137c3$export$424fa15ff0b7ba
    }), ({ abTestId: abTestId })=>abTestId);
const $1c4c47b3b90137c3$export$6a289441cb90b0e0 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((params)=>$1c4c47b3b90137c3$var$getLayerFrontendExperimentUnmemoized({
        ...params,
        layerName: $1c4c47b3b90137c3$export$7ddc02143e0dc525
    }), ({ abTestId: abTestId })=>abTestId);
const $1c4c47b3b90137c3$export$2ae87375886cb5b0 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((params)=>$1c4c47b3b90137c3$var$getLayerFrontendExperimentUnmemoized({
        ...params,
        layerName: $1c4c47b3b90137c3$export$fb4dba971e54444f
    }), ({ abTestId: abTestId })=>abTestId);
const $1c4c47b3b90137c3$export$399aed7d323465a6 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((params)=>$1c4c47b3b90137c3$var$getLayerFrontendExperimentUnmemoized({
        ...params,
        layerName: $1c4c47b3b90137c3$export$50eae6f311ab1b36
    }), ({ abTestId: abTestId })=>abTestId);
function $1c4c47b3b90137c3$var$getLayerFrontendMultiArmExperimentUnmemoized({ layerName: layerName, abTestId: abTestId, onError: onError }) {
    const handleError = (error)=>{
        (0, $cuvLu.logger).error({
            error: error,
            functionName: `getLayerFrontendExperimentUnmemoized(${layerName})`
        });
        onError?.(error);
    };
    try {
        // we skip experiment evaluation if the user is part of the SAIN holdback experiment test cohort,
        // because SAIN is disabled in this case
        if (!(0, $fUTzE.isPartofSainHoldbackExperiment)() && $1c4c47b3b90137c3$var$doesLayerFrontendExperimentExist(layerName, abTestId)) {
            const experiment = (0, $cXtTj.default).getExperiment(abTestId);
            const cohort = experiment.get('cohort', 'not-enrolled');
            return {
                abTestId: abTestId,
                cohort: cohort
            };
        }
    } catch (error) {
        handleError(error);
    }
    return {
        abTestId: abTestId,
        cohort: 'not-enrolled'
    };
}
const $1c4c47b3b90137c3$export$3e4672526d3420fc = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((params)=>$1c4c47b3b90137c3$var$getLayerFrontendMultiArmExperimentUnmemoized({
        ...params,
        layerName: $1c4c47b3b90137c3$export$5091efb9b1abe9af
    }), ({ abTestId: abTestId })=>abTestId);
const $1c4c47b3b90137c3$export$7ea065ff36b2919b = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((params)=>$1c4c47b3b90137c3$var$getLayerFrontendMultiArmExperimentUnmemoized({
        ...params,
        layerName: $1c4c47b3b90137c3$export$61cd502eadfc7f4a
    }), ({ abTestId: abTestId })=>abTestId);
const $1c4c47b3b90137c3$export$86b1582e6f2170b8 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((params)=>$1c4c47b3b90137c3$var$getLayerFrontendMultiArmExperimentUnmemoized({
        ...params,
        layerName: $1c4c47b3b90137c3$export$424fa15ff0b7ba
    }), ({ abTestId: abTestId })=>abTestId);
const $1c4c47b3b90137c3$export$51994ae426522802 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((params)=>$1c4c47b3b90137c3$var$getLayerFrontendMultiArmExperimentUnmemoized({
        ...params,
        layerName: $1c4c47b3b90137c3$export$7ddc02143e0dc525
    }), ({ abTestId: abTestId })=>abTestId);
const $1c4c47b3b90137c3$export$ef7d89c571d837a1 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((paramName)=>{
    const layer = (0, $cXtTj.default).getLayer($1c4c47b3b90137c3$export$5091efb9b1abe9af);
    return layer.get(paramName, null);
}, (paramName)=>paramName);
const $1c4c47b3b90137c3$export$98e9af5151f46651 = (paramName, paramValue)=>{
    return $1c4c47b3b90137c3$export$ef7d89c571d837a1(paramName) === paramValue;
};
const $1c4c47b3b90137c3$export$2a3e1ea63f6e0a96 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((paramName)=>{
    const layer = (0, $cXtTj.default).getLayer($1c4c47b3b90137c3$export$61cd502eadfc7f4a);
    return layer.get(paramName, null);
}, (paramName)=>paramName);
const $1c4c47b3b90137c3$export$acf5b4af6876c34 = (paramName, paramValue)=>{
    return $1c4c47b3b90137c3$export$2a3e1ea63f6e0a96(paramName) === paramValue;
};
const $1c4c47b3b90137c3$export$1cb8634000255dfc = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((paramName)=>{
    const layer = (0, $cXtTj.default).getLayer($1c4c47b3b90137c3$export$424fa15ff0b7ba);
    return layer.get(paramName, null);
}, (paramName)=>paramName);
const $1c4c47b3b90137c3$export$73e8f0ae9f40c076 = (paramName, paramValue)=>{
    return $1c4c47b3b90137c3$export$1cb8634000255dfc(paramName) === paramValue;
};
const $1c4c47b3b90137c3$export$bc756838254fcee0 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((paramName)=>{
    const layer = (0, $cXtTj.default).getLayer($1c4c47b3b90137c3$export$7ddc02143e0dc525);
    return layer.get(paramName, null);
}, (paramName)=>paramName);
const $1c4c47b3b90137c3$export$18e8e8d49cd8924f = (paramName, paramValue)=>{
    return $1c4c47b3b90137c3$export$bc756838254fcee0(paramName) === paramValue;
};
module.exports["SAIN_LAYER_NAME"] = $1c4c47b3b90137c3$export$5091efb9b1abe9af;
module.exports["SAIN_HELLO_LAYER_NAME"] = $1c4c47b3b90137c3$export$61cd502eadfc7f4a;
module.exports["getSAINLayerFrontendExperiment"] = $1c4c47b3b90137c3$export$3de2a2aa2c11f251;
module.exports["getJiraUIExperienceLayerFrontendExperiment"] = $1c4c47b3b90137c3$export$2ae87375886cb5b0;
module.exports["getJiraUIExperienceTenantsLayerFrontendExperiment"] = $1c4c47b3b90137c3$export$399aed7d323465a6;
module.exports["hasSAINLayerParamValue"] = $1c4c47b3b90137c3$export$98e9af5151f46651;
module.exports["hasSAINHelloLayerParamValue"] = $1c4c47b3b90137c3$export$acf5b4af6876c34;
module.exports["hasSAINUXLayerParamValue"] = $1c4c47b3b90137c3$export$73e8f0ae9f40c076;
module.exports["hasSAINUXHelloLayerParamValue"] = $1c4c47b3b90137c3$export$18e8e8d49cd8924f;

});

parcelRegister("fUTzE", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $3XLuW = parcelRequire("3XLuW");

function $5ecef285828a8671$export$c5e2c0a7fe245f7d() {
    const layer = (0, $cXtTj.default).getLayer((0, $3XLuW.STATSIG_SEARCH_BACKEND_NON_OVERLAPPING_DOMAIN), {
        fireLayerExposure: false
    });
    const abTestId = layer.get('abTestId', 'no_ab_test_id');
    if (abTestId === 'kd_disable_sain_experiment') {
        const backendExperimentData = layer.get('backendChanges', {
            sain: true
        });
        if (!backendExperimentData?.sain) return true;
    }
    return false;
}
module.exports["isPartofSainHoldbackExperiment"] = $5ecef285828a8671$export$c5e2c0a7fe245f7d;

});

parcelRegister("3XLuW", function(module, exports) {
const $2bb5e141f8b5ba9a$export$71a8b319599e57dc = 'l1_premium_vs_standard';
const $2bb5e141f8b5ba9a$export$c076c4dd9e9d1e6e = 'search_platform_layer_l1_standard';
const $2bb5e141f8b5ba9a$export$23877616cb34cf0c = 'search_platform_layer_l1_premium';
const $2bb5e141f8b5ba9a$export$68be56e20dba0ed5 = 'l2_premium_vs_standard';
const $2bb5e141f8b5ba9a$export$f39fa5cd744578ae = 'search_platform_layer_l2_standard';
const $2bb5e141f8b5ba9a$export$a36d8c2d9981ec2b = 'search_platform_layer_l2_premium';
const $2bb5e141f8b5ba9a$export$fe025e19388affcf = 'search_platform_layer_l2_blending';
const $2bb5e141f8b5ba9a$export$11e2cd4e8edc5e82 = 'search_platform_layer_l3';
const $2bb5e141f8b5ba9a$export$9b30fb0a29b39382 = 'search_platform_layer_query_expansion';
const $2bb5e141f8b5ba9a$export$a62089c95934ccf8 = 'enable_l3';
const $2bb5e141f8b5ba9a$export$4e36729d15b3db9e = 'enable_query_rewrite';
const $2bb5e141f8b5ba9a$export$87f92c12fc8bb620 = 'search_platform_non_overlapping_domain';
const $2bb5e141f8b5ba9a$export$86bb6d2503529310 = 'search_platform_layer_l1';
const $2bb5e141f8b5ba9a$export$722a4624bef605fa = 'search_platform_layer_l2';
const $2bb5e141f8b5ba9a$export$1963cf4be1b2cd5e = 'search_platform_layer_l3';
const $2bb5e141f8b5ba9a$export$a18b3b3caa760214 = 'search_platform_layer_query_expansion';
const $2bb5e141f8b5ba9a$export$39bbb550e0341d58 = 'full_page_search_layer';
const $2bb5e141f8b5ba9a$export$b669e8e4ed2b4c67 = 'quick_find_layer';
const $2bb5e141f8b5ba9a$export$dd8503a49fbff14d = 'rovo_search_qf_experience_layer';
const $2bb5e141f8b5ba9a$export$afc3cbf9db978004 = {
    experimentId: 'default',
    shadowExperimentId: 'default',
    controlId: 'default',
    abTestId: 'default'
};
const $2bb5e141f8b5ba9a$export$fca208e1e43c6fac = {
    experimentId: 'default',
    shadowExperimentId: 'default',
    experimentLayers: []
};
module.exports["STATSIG_SEARCH_BACKEND_FEATURE_GATE_L1_STANDARD_VS_PREMIUM"] = $2bb5e141f8b5ba9a$export$71a8b319599e57dc;
module.exports["STATSIG_SEARCH_BACKEND_L1_LAYER_STANDARD"] = $2bb5e141f8b5ba9a$export$c076c4dd9e9d1e6e;
module.exports["STATSIG_SEARCH_BACKEND_L1_LAYER_PREMIUM"] = $2bb5e141f8b5ba9a$export$23877616cb34cf0c;
module.exports["STATSIG_SEARCH_BACKEND_FEATURE_GATE_L2_STANDARD_VS_PREMIUM"] = $2bb5e141f8b5ba9a$export$68be56e20dba0ed5;
module.exports["STATSIG_SEARCH_BACKEND_L2_LAYER_STANDARD"] = $2bb5e141f8b5ba9a$export$f39fa5cd744578ae;
module.exports["STATSIG_SEARCH_BACKEND_L2_LAYER_PREMIUM"] = $2bb5e141f8b5ba9a$export$a36d8c2d9981ec2b;
module.exports["STATSIG_SEARCH_BACKEND_L2_BLENDING_LAYER"] = $2bb5e141f8b5ba9a$export$fe025e19388affcf;
module.exports["STATSIG_SEARCH_BACKEND_L3_LAYER"] = $2bb5e141f8b5ba9a$export$11e2cd4e8edc5e82;
module.exports["STATSIG_SEARCH_BACKEND_QUERY_EXPANSION_LAYER"] = $2bb5e141f8b5ba9a$export$9b30fb0a29b39382;
module.exports["STATSIG_SEARCH_BACKEND_FEATURE_GATE_L3_ENABLED"] = $2bb5e141f8b5ba9a$export$a62089c95934ccf8;
module.exports["STATSIG_SEARCH_BACKEND_FEATURE_GATE_QUERY_EXPANSION_ENABLED"] = $2bb5e141f8b5ba9a$export$4e36729d15b3db9e;
module.exports["STATSIG_SEARCH_BACKEND_NON_OVERLAPPING_DOMAIN"] = $2bb5e141f8b5ba9a$export$87f92c12fc8bb620;
module.exports["STATSIG_FULL_PAGE_SEARCH_LAYER"] = $2bb5e141f8b5ba9a$export$39bbb550e0341d58;
module.exports["STATSIG_QUICK_FIND_LAYER"] = $2bb5e141f8b5ba9a$export$b669e8e4ed2b4c67;
module.exports["DEFAULT_STATSIG_EXPERIMENT_CONFIG"] = $2bb5e141f8b5ba9a$export$afc3cbf9db978004;
module.exports["DEFAULT_STATSIG_PARALLEL_EXPERIMENTS_CONFIG"] = $2bb5e141f8b5ba9a$export$fca208e1e43c6fac;

});

parcelRegister("EZPsO", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $7s8U5 = parcelRequire("7s8U5");


var $htnqN = parcelRequire("htnqN");


var $hpFQM = parcelRequire("hpFQM");


var $cuvLu = parcelRequire("cuvLu");


var $7DMz5 = parcelRequire("7DMz5");


var $g7itP = parcelRequire("g7itP");


var $3v6Cp = parcelRequire("3v6Cp");


var $7s0JE = parcelRequire("7s0JE");


var $fhQSR = parcelRequire("fhQSR");

const $18420cdcd30a1600$var$mapMimeTypeToFormat = (mimeType)=>{
    switch(mimeType){
        case 'text/markdown':
            return (0, $hpFQM.NLPSearchResultFormat).MARKDOWN;
        case 'text/adf':
            return (0, $hpFQM.NLPSearchResultFormat).ADF;
        case 'text/json':
            return (0, $hpFQM.NLPSearchResultFormat).JSON;
        default:
            return (0, $hpFQM.NLPSearchResultFormat).MARKDOWN;
    }
};
const $18420cdcd30a1600$var$mapErrorTo = (error, traceId)=>{
    const errorMessage = 'message_template' in error ? error.message_template : error.message.message_template;
    switch(errorMessage){
        case 'NO_ANSWER_LLM':
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).NoAnswer
            };
        case 'NO_ANSWER_PEOPLE':
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).NoAnswerWhoQuestion
            };
        case 'NO_ANSWER_KEYWORDS':
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).NoAnswerKeywords
            };
        case 'NO_ANSWER_SEARCH_QA_PLUGIN':
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).NoAnswerSearchResults
            };
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).AcceptableUseViolation
            };
        case 'OPENAI_RATE_LIMIT_USER_ABUSE':
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).NoAnswerOpenAIRateLimitUserAbuse
            };
        case 'FEATURE_DISABLED_ON_SITE':
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).AIDisabled
            };
        default:
            (0, $cuvLu.logger).error({
                error: error,
                functionName: 'mapErrorToSain: NetworkError',
                traceId: traceId
            });
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).NetworkError,
                networkErrorReason: 'unmapped_backend_error',
                networkErrorDetails: errorMessage,
                backendFailureType: 'unmapped_template'
            };
    }
};
const $18420cdcd30a1600$var$identityUserCloudARIPrefix = 'ari:cloud:identity::user/';
const $18420cdcd30a1600$export$b4465cb8e5734ca9 = (message, requestId)=>{
    // Handle cases where message is directly in root or nested under message.message
    const messageContent = message.message;
    // The CSM streaming endpoint puts sources inside SAINMessage (message.message.sources)
    // rather than at the SAINAgentResponse level (message.sources). Fall back to the
    // nested location so citations and the Sources section render correctly for both the APIs.
    const sources = message.sources ?? message.message?.sources;
    return {
        nlpResult: (0, $ixfCV.fg)('kd_sain_extract_footnote') ? (0, $g7itP.cleanSAINAnswerCitations)(messageContent.content) : messageContent.content,
        uniqueSources: sources ? sources.map((source)=>({
                ari: source.ari,
                id: source.id?.toString(),
                title: source.title,
                product: source.product,
                type: source.type,
                url: source.url,
                lastModified: source.lastModified,
                iconUrl: null,
                spaceName: null,
                spaceUrl: null
            })) : [],
        disclaimer: messageContent.message_metadata?.disclaimer ?? null,
        errorState: null,
        format: $18420cdcd30a1600$var$mapMimeTypeToFormat(messageContent.content_mime_type),
        extraAPIAnalyticsAttributes: {
            message_id: messageContent.id,
            conversational_channel_id: messageContent.conversation_channel_id,
            experience_id: messageContent.experience_id,
            user_id: messageContent.user_ari?.replace($18420cdcd30a1600$var$identityUserCloudARIPrefix, '') ?? null,
            userQuery: message.human_message?.content ?? null,
            requestId: (0, $ixfCV.fg)('kd_fix_sain_mau_instrumentation') ? requestId ?? null : messageContent.message_metadata?.request_id ?? null,
            answerGenerationModel: message.usage_data ?? null,
            ...!(0, $ixfCV.fg)('kd_consolidate_sources_analytics') && {
                sources: sources
            },
            cacheInfo: messageContent.message_metadata?.global_cache_info ?? null,
            pluginInvocations: messageContent.plugin_invocations,
            rawJson: message,
            ...(0, $ixfCV.fg)('kd_sain_online_debugger') && {
                minion_outputs: message.message?.minion_outputs,
                traceId: requestId ?? null
            },
            ...(0, $ixfCV.fg)('kd_add_plugins_invoked') && (()=>{
                const pluginNames = (messageContent.plugin_invocations ?? []).map((p)=>p.plugin_name).filter(Boolean);
                const minionOutputs = messageContent.minion_outputs ?? [];
                const minionIds = minionOutputs.flat().map((m)=>m.minion_id).filter(Boolean);
                const pluginsInvoked = [
                    ...pluginNames,
                    ...minionIds
                ];
                return pluginsInvoked.length > 0 ? {
                    pluginsInvoked: pluginsInvoked
                } : {};
            })()
        },
        authority_ui_metadata: messageContent.authority_ui_metadata ?? null
    };
};
const $18420cdcd30a1600$export$ed070f749797478 = (response, traceId)=>{
    if ((0, $fhQSR.isStreamError)(response)) {
        const { errorState: errorState, networkErrorReason: networkErrorReason, networkErrorDetails: networkErrorDetails, backendFailureType: backendFailureType } = $18420cdcd30a1600$var$mapErrorTo(response, traceId);
        return {
            type: (0, $7s8U5.AIAnswerQueryStreamType).FinalResponse,
            message: {
                errorState: errorState,
                errorCode: response.message.status_code,
                networkErrorReason: networkErrorReason,
                networkErrorDetails: networkErrorDetails,
                backendFailureType: backendFailureType,
                disclaimer: null,
                format: (0, $hpFQM.NLPSearchResultFormat).MARKDOWN,
                uniqueSources: []
            }
        };
    }
    if ((0, $fhQSR.isStreamGenerationType)(response) && (0, $7DMz5.SAINFeatureControl).canRenderLumina()) return {
        type: (0, $7s8U5.AIAnswerQueryStreamType).GenerationType,
        message: {
            answer_generation_type: response.message.answer_generation_type
        }
    };
    if ((0, $fhQSR.isStreamTrace)(response)) {
        // When the new user-flow FG is on, also surface the rich research-step
        // fields if the BE included a `message_template` (RESEARCH_STEP_*, etc).
        // Legacy traces are unaffected — they just won't carry `traceData`.
        const includeTraceData = (0, $7DMz5.SAINFeatureControl).isSAINUpdatedFlowEnabled() && !!response.message.message_template;
        return {
            type: (0, $7s8U5.AIAnswerQueryStreamType).Trace,
            message: response.message.content,
            ...includeTraceData && {
                traceData: {
                    messageTemplate: response.message.message_template,
                    title: response.message.title,
                    stepId: response.message.stepId,
                    roundId: response.message.roundId,
                    content: response.message.content,
                    toolName: response.message.toolName,
                    toolIcon: response.message.toolIcon,
                    products: response.message.products,
                    sources: response.message.sources ?? undefined,
                    url: response.message.url,
                    product: response.message.product
                }
            }
        };
    }
    if ((0, $fhQSR.isStreamAnswerPart)(response)) return {
        type: (0, $7s8U5.AIAnswerQueryStreamType).AnswerPart,
        message: {
            nlpResult: (0, $ixfCV.fg)('kd_fix_streaming_hr_line') ? (0, $7s0JE.stripLeadingHorizontalRule)(response.message.content) : response.message.content
        }
    };
    if ((0, $fhQSR.isStreamSAINResponse)(response)) return {
        type: (0, $7s8U5.AIAnswerQueryStreamType).FinalResponse,
        message: $18420cdcd30a1600$export$b4465cb8e5734ca9(response.message, traceId)
    };
    if ((0, $fhQSR.isStreamFollowUp)(response)) return {
        type: 'follow-up',
        queries: response.message.follow_up_queries ?? []
    };
    if ((0, $fhQSR.isStreamErrorStateQuerySuggestions)(response)) return {
        type: (0, $7s8U5.AIAnswerQueryStreamType).ErrorStateQuerySuggestions,
        suggested_queries: response.message.suggested_queries ?? []
    };
    if ((0, $7DMz5.SAINFeatureControl).canRenderLumina()) {
        if ((0, $fhQSR.isStreamDynamicLayoutSubAgent)(response)) return {
            type: (0, $7s8U5.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage,
            message: response.message
        };
    }
    if ((0, $ixfCV.fg)('kd_sain_early_stop_hello_exp_fg') || (0, $ixfCV.fg)('kd_sain_early_stop_customer_exp_fg')) {
        if ((0, $fhQSR.isStreamEarlyStop)(response)) {
            const earlyStopSearchResult = {
                nlpResult: response.message?.reason ?? '',
                format: null,
                uniqueSources: [],
                errorState: (0, $htnqN.NLPSearchErrorState).EarlyStop,
                disclaimer: null
            };
            return {
                type: (0, $7s8U5.AIAnswerQueryStreamType).EarlyStop,
                message: earlyStopSearchResult
            };
        }
    }
    if (response.type === 'PLUGIN_INVOCATION' && response.message?.plugin_name) return {
        type: 'plugin-invocation',
        pluginName: response.message.plugin_name
    };
    return {
        type: 'other'
    };
};
const $18420cdcd30a1600$export$fb9e9bea38ae660f = (response, traceId)=>{
    if ((0, $fhQSR.isStreamError)(response)) {
        const { errorState: errorState, networkErrorReason: networkErrorReason, networkErrorDetails: networkErrorDetails, backendFailureType: backendFailureType } = $18420cdcd30a1600$var$mapErrorTo(response, traceId);
        return {
            type: (0, $7s8U5.AIAnswerQueryStreamType).FinalResponse,
            message: {
                errorState: errorState,
                errorCode: response.message.status_code,
                networkErrorReason: networkErrorReason,
                networkErrorDetails: networkErrorDetails,
                backendFailureType: backendFailureType,
                disclaimer: null,
                format: (0, $hpFQM.NLPSearchResultFormat).MARKDOWN,
                uniqueSources: []
            }
        };
    }
    if ((0, $fhQSR.isStreamTrace)(response)) return {
        type: (0, $7s8U5.AIAnswerQueryStreamType).Trace,
        message: response.message.content
    };
    if ((0, $fhQSR.isStreamAnswerPart)(response)) return {
        type: (0, $7s8U5.AIAnswerQueryStreamType).AnswerPart,
        message: {
            nlpResult: response.message.content
        }
    };
    if ((0, $fhQSR.isStreamDefinitionResponse)(response)) return {
        type: (0, $7s8U5.AIAnswerQueryStreamType).FinalResponse,
        message: (0, $3v6Cp.mapDefinitionMessageToNLPSearchType)(response.message, traceId)
    };
    if ((0, $fhQSR.isStreamFollowUp)(response)) return {
        type: 'follow-up',
        queries: response.message.follow_up_queries ?? []
    };
    return {
        // Don't currently handle other types, such as PLUGIN_INVOCATION
        type: 'other'
    };
};
module.exports["mapStreamSAINResponse"] = $18420cdcd30a1600$export$ed070f749797478;
module.exports["mapStreamDefinitionResponse"] = $18420cdcd30a1600$export$fb9e9bea38ae660f;

});

parcelRegister("g7itP", function(module, exports) {
const $c9bf059aebe9542e$export$231abbb3de9b00b5 = (result)=>{
    const removeFootnoteRegex = /\[\^(\d{1,2})\^\]:\s*https?:\/\/.*$/gm;
    const removeNonDigitCitationsRegex = /\[\^([a-zA-Z\-]+)\^\]/g;
    let cleanedAnswer = result.replace(removeFootnoteRegex, '').trim();
    cleanedAnswer = cleanedAnswer.replace(removeNonDigitCitationsRegex, '').trim();
    return cleanedAnswer;
};
module.exports["cleanSAINAnswerCitations"] = $c9bf059aebe9542e$export$231abbb3de9b00b5;

});

parcelRegister("3v6Cp", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $hpFQM = parcelRequire("hpFQM");

const $3a550909e4e16fa5$export$b4d3daa122c7e257 = (message, traceId)=>{
    return {
        nlpResult: message.content,
        uniqueSources: message.sources ? message.sources.map((source)=>({
                ari: source.ari,
                id: source.id?.toString(),
                title: source.title,
                product: source.product,
                type: source.type,
                url: source.url,
                lastModified: source.lastModified,
                iconUrl: null,
                spaceName: null,
                spaceUrl: null
            })) : [],
        disclaimer: null,
        errorState: null,
        format: (0, $hpFQM.NLPSearchResultFormat).MARKDOWN,
        extraAPIAnalyticsAttributes: {
            requestId: traceId ?? null,
            userQuery: message.human_message?.content ?? null,
            answerGenerationModel: message.usage_data ?? null,
            ...!(0, $ixfCV.fg)('kd_consolidate_sources_analytics') && {
                sources: message.sources
            },
            rawJson: message
        }
    };
};
module.exports["mapDefinitionMessageToNLPSearchType"] = $3a550909e4e16fa5$export$b4d3daa122c7e257;

});

parcelRegister("7s0JE", function(module, exports) {
/**
 * Strips a leading markdown horizontal rule (`----` / `---`) that the backend
 * occasionally sends as the very first streamed chunk.  When rendered
 * incrementally by `use-buffered-content`, this produces a large grey `<hr>`
 * line that disappears once the full answer arrives, causing an unwanted flash.
 *
 * The pattern `\n\n---+\n\n` only matches when the rule appears at the very
 * start of the content so legitimate mid-answer dividers are preserved.
 */ const $eca07c9d38f17ebd$export$4cbb8bd973cd24f9 = (content)=>{
    return content.replace(/^\n*-{3,}\n*/, '');
};
module.exports["stripLeadingHorizontalRule"] = $eca07c9d38f17ebd$export$4cbb8bd973cd24f9;

});

parcelRegister("fhQSR", function(module, exports) {
const $77022310b2d5138b$export$b4631726cbc1440a = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $77022310b2d5138b$export$d422a2733a3b5def = (message)=>message instanceof Object && message.type === 'ERROR';
const $77022310b2d5138b$export$e45102edbc73b240 = (message)=>message instanceof Object && message.type === 'ANSWER_PART';
const $77022310b2d5138b$export$c563bc6129a38894 = (message)=>message instanceof Object && message.type === 'ANSWER_GENERATION_TYPE';
const $77022310b2d5138b$export$fd5a05be03f147a0 = (message)=>message instanceof Object && message.type === 'TRACE';
const $77022310b2d5138b$export$51a1b4e474708d74 = (message)=>message instanceof Object && message.type === 'PLUGIN_INVOCATION';
const $77022310b2d5138b$export$cfb6b6bb809f778e = (message)=>message instanceof Object && message.type === 'FOLLOW_UP_QUERIES';
const $77022310b2d5138b$export$de29cc71fd2aafc1 = (message)=>message instanceof Object && message.type === 'ERROR_STATE_QUERY_SUGGESTIONS';
const $77022310b2d5138b$export$5fa02529cd2ab34c = (message)=>message instanceof Object && message.type === 'DL_SUB_AGENT';
const $77022310b2d5138b$export$b6b59db8d0b45219 = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $77022310b2d5138b$export$1598409b78d1d369 = (message)=>message instanceof Object && message.type === 'EARLY_STOP';
const $77022310b2d5138b$export$53e95dec5f877b4e = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
module.exports["isStreamError"] = $77022310b2d5138b$export$d422a2733a3b5def;
module.exports["isStreamAnswerPart"] = $77022310b2d5138b$export$e45102edbc73b240;
module.exports["isStreamGenerationType"] = $77022310b2d5138b$export$c563bc6129a38894;
module.exports["isStreamTrace"] = $77022310b2d5138b$export$fd5a05be03f147a0;
module.exports["isStreamFollowUp"] = $77022310b2d5138b$export$cfb6b6bb809f778e;
module.exports["isStreamErrorStateQuerySuggestions"] = $77022310b2d5138b$export$de29cc71fd2aafc1;
module.exports["isStreamDynamicLayoutSubAgent"] = $77022310b2d5138b$export$5fa02529cd2ab34c;
module.exports["isStreamSAINResponse"] = $77022310b2d5138b$export$b6b59db8d0b45219;
module.exports["isStreamEarlyStop"] = $77022310b2d5138b$export$1598409b78d1d369;
module.exports["isStreamDefinitionResponse"] = $77022310b2d5138b$export$53e95dec5f877b4e;

});

parcelRegister("u7MPJ", function(module, exports) {

var $4Tg3t = parcelRequire("4Tg3t");

const $a12cf3bdcfab939f$export$1b6ec2a437dbf65e = (error, commonAttributes)=>{
    const { extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'failed',
        actionSubject: 'aiCuratedDefinitionFetch',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.sanitizeExtraAttributes)(extraAttributes),
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    };
};
module.exports["fetchCuratedDefinitionErrorPayload"] = $a12cf3bdcfab939f$export$1b6ec2a437dbf65e;

});

parcelRegister("4Tg3t", function(module, exports) {

var $ixfCV = parcelRequire("ixfCV");


var $9oghv = parcelRequire("9oghv");


var $fRZe0 = parcelRequire("fRZe0");


var $6r8zo = parcelRequire("6r8zo");


var $agG6W = parcelRequire("agG6W");

// list from https://atlassian.slack.com/archives/C08VA0N40A2/p1749172242825969?thread_ts=1749088363.059769&cid=C08VA0N40A2
const $25e050b8a4f8e071$var$products1PList = [
    'Assets',
    'Atlas',
    'Confluence',
    'Atlassian Analytics',
    'Atlassian Cloud',
    'Automation for Jira',
    'Bamboo',
    'Bitbucket',
    'Compass',
    'Jira',
    'Jira Product Discovery',
    'Jira Service Management',
    'Jira Software',
    'Jira Work Management',
    'Jira Align',
    'Migration',
    'Loom',
    'Opsgenie',
    'Platform Experiences',
    'Rovo',
    'Statuspage',
    'Trello',
    'webSearch',
    'web-page',
    'Fisheye and Crucible',
    'Crowd',
    'Sourcetree',
    'Unknown',
    'Focus',
    'file-upload',
    'Advanced Roadmaps For Jira',
    'Questions for Confluence',
    'csm',
    'Dewey Support',
    'Dewey JAC Support',
    'Help Aggregator'
];
const $25e050b8a4f8e071$var$noAnswerPhrases = [
    "i'm sorry",
    'i apologize',
    "couldn't find ",
    "couldn't generate",
    'provide more context',
    "don't have enough information"
];
const $25e050b8a4f8e071$export$e9cf531f9f13a177 = (text)=>{
    const lowerCaseText = text.toLowerCase();
    return $25e050b8a4f8e071$var$noAnswerPhrases.some((phrase)=>lowerCaseText.includes(phrase));
};
const $25e050b8a4f8e071$var$getSourceProducts = (sources, luminaUrls = [])=>{
    const products = {};
    const sourceUrls = new Set(sources.map((source)=>source.url));
    sources.forEach((source)=>{
        const productName = source.product;
        if (productName) products[productName] = (products[productName] ?? 0) + 1;
    });
    luminaUrls.forEach((url)=>{
        if (sourceUrls.has(url)) return;
        try {
            const productName = (0, $agG6W.getProductKey)(url);
            if (productName) products[productName] = (products[productName] ?? 0) + 1;
        } catch  {
            return;
        }
    });
    return products;
};
const $25e050b8a4f8e071$var$sanitizeSources = (sources)=>sources.map((source)=>({
            id: source.ari ?? source.id,
            type: source.type
        }));
const $25e050b8a4f8e071$export$fae1292002da0b83 = (sources)=>sources.filter((source)=>source.product ? !$25e050b8a4f8e071$var$products1PList.includes(source.product) && !source.product.includes('Plugin') : false);
const $25e050b8a4f8e071$var$filterLumina3PUrls = (urls)=>urls.filter((url)=>{
        try {
            const product = (0, $agG6W.getProductKey)(url);
            return $25e050b8a4f8e071$export$c33e27f4ca8bdbe0(product);
        } catch  {
            return false;
        }
    });
const $25e050b8a4f8e071$export$c33e27f4ca8bdbe0 = (product)=>product ? !$25e050b8a4f8e071$var$products1PList.includes(product) && !product.includes('Plugin') : false;
const $25e050b8a4f8e071$export$988d4f126deef74 = (extraAttributes)=>{
    if (!(0, $ixfCV.fg)('kd_fe_sanitize_analytics')) return extraAttributes;
    const sanitizedAttributes = {};
    // Sanitize everything except COMMON_ALLOWED_KEYS
    for(const key in extraAttributes)if ((0, $fRZe0.ALLOWED_EXTRA_ATTRIBUTES_KEYS).has(key)) sanitizedAttributes[key] = extraAttributes[key];
    else // replacing with text because the value has type `any`
    sanitizedAttributes[key] = '[sanitized]';
    return sanitizedAttributes;
};
/**
 * Keys produced by `filterCommonAttributes` (including optional and feature-gated fields). Keep in
 * sync when adding new attributes there — `SEARCH_AI_ANALYTICS_CONTEXT_ATTRIBUTE_ALLOWLIST` is
 * derived from this list plus `ALLOWED_EXTRA_ATTRIBUTES_KEYS`, `location`, and `source`.
 */ const $25e050b8a4f8e071$var$FILTER_COMMON_ATTRIBUTES_OUTPUT_KEYS = [
    'searchSessionId',
    'queryHash',
    'baseQueryHash',
    'wordCount',
    'queryLength',
    'answerHash',
    'appliedFilters',
    'answerFormat',
    'answerLength',
    'answerWordCount',
    'answerCardType',
    'followUpsCount',
    'followUpsLength',
    'has3PSources',
    'sources',
    'sourceProducts',
    'apiSource',
    'brand',
    'sessionId',
    'isHello',
    'sourceProduct',
    'isReadingAids',
    'queryIntent',
    'sourcesCount',
    'sources3P',
    'sources3PCount',
    'hasSources',
    'has1PSources',
    'containsNoAnswerPhrase',
    'containsLuminaContent',
    'luminaContentTypes',
    'jiraNlToJqlCardVariant'
];
const $25e050b8a4f8e071$export$26c187b85342c353 = new Set([
    'location',
    'source',
    ...$25e050b8a4f8e071$var$FILTER_COMMON_ATTRIBUTES_OUTPUT_KEYS,
    ...(0, $fRZe0.ALLOWED_EXTRA_ATTRIBUTES_KEYS)
]);
const $25e050b8a4f8e071$export$5e5d3678c52c4007 = (data)=>{
    const location = data.location;
    const raw = {
        ...data.attributes
    };
    if (raw.location === undefined) raw.location = location;
    const attributes = {};
    for (const key of Object.keys(raw))if ($25e050b8a4f8e071$export$26c187b85342c353.has(key)) attributes[key] = raw[key];
    return {
        attributes: attributes,
        location: location
    };
};
const $25e050b8a4f8e071$export$14f72eaec5bfc1a8 = (props)=>{
    const { appliedFilters: appliedFilters, answerFormat: answerFormat, answerLength: answerLength, answerWordCount: answerWordCount, answerCardType: answerCardType, followUps: followUps, sources: sources, extraAttributes: extraAttributes, searchSessionId: searchSessionId, queryHash: queryHash, baseQueryHash: baseQueryHash, query: query, answerString: answerString, apiSource: apiSource, brand: brand, sourceProduct: sourceProduct, isReadingAids: isReadingAids, queryIntent: queryIntent, sessionId: sessionId, isHello: isHello, containsLuminaContent: containsLuminaContent, luminaContentTypes: luminaContentTypes, luminaContentMap: luminaContentMap } = props;
    const filtered3P = $25e050b8a4f8e071$export$fae1292002da0b83(sources);
    const luminaUrls = (0, $ixfCV.fg)('kd_enable_lumina_list_3p_sources_attributes') ? (0, $6r8zo.extractLuminaUrls)(luminaContentMap ?? {}) : [];
    const filtered3PUrls = new Set(filtered3P.map((source)=>source.url));
    const filteredLumina3P = $25e050b8a4f8e071$var$filterLumina3PUrls(luminaUrls).filter((url)=>!filtered3PUrls.has(url));
    return {
        searchSessionId: searchSessionId,
        queryHash: queryHash,
        baseQueryHash: baseQueryHash,
        wordCount: (query.match(/\w+/g) || []).length,
        queryLength: query.length,
        answerHash: (0, $9oghv.sha256Hash)(answerString),
        appliedFilters: appliedFilters,
        answerFormat: answerFormat,
        answerLength: answerLength,
        answerWordCount: answerWordCount,
        answerCardType: answerCardType,
        followUpsCount: followUps.length,
        followUpsLength: followUps.map((followUp)=>followUp.length),
        has3PSources: filtered3P.length > 0 || filteredLumina3P.length > 0,
        sources: $25e050b8a4f8e071$var$sanitizeSources(sources),
        sourceProducts: $25e050b8a4f8e071$var$getSourceProducts(sources, luminaUrls),
        apiSource: apiSource,
        brand: brand,
        ...sourceProduct !== undefined && {
            sourceProduct: sourceProduct
        },
        ...isReadingAids !== undefined && {
            isReadingAids: isReadingAids
        },
        ...queryIntent !== undefined && {
            queryIntent: queryIntent
        },
        ...containsLuminaContent !== undefined && {
            containsLuminaContent: containsLuminaContent
        },
        ...luminaContentTypes !== undefined && {
            luminaContentTypes: luminaContentTypes
        },
        ...(0, $ixfCV.fg)('kd_consolidate_sources_analytics') && {
            sourcesCount: sources.length,
            sources3P: $25e050b8a4f8e071$var$sanitizeSources(filtered3P),
            sources3PCount: filtered3P.length + filteredLumina3P.length
        },
        ...(0, $ixfCV.fg)('kd_send_no_answer_attributes') && {
            hasSources: sources.length > 0,
            has1PSources: sources.length > filtered3P.length,
            containsNoAnswerPhrase: $25e050b8a4f8e071$export$e9cf531f9f13a177(answerString)
        },
        sessionId: sessionId,
        isHello: isHello,
        ...$25e050b8a4f8e071$export$988d4f126deef74(extraAttributes)
    };
};
module.exports["isSourceProduct3P"] = $25e050b8a4f8e071$export$c33e27f4ca8bdbe0;
module.exports["sanitizeExtraAttributes"] = $25e050b8a4f8e071$export$988d4f126deef74;
module.exports["sanitizeSearchAIAnalyticsContextData"] = $25e050b8a4f8e071$export$5e5d3678c52c4007;
module.exports["filterCommonAttributes"] = $25e050b8a4f8e071$export$14f72eaec5bfc1a8;

});

parcelRegister("9oghv", function(module, exports) {

var $eVK28 = parcelRequire("eVK28");

const $0afda9e797c2a356$export$e9131c78c1110376 = (str)=>(0, $eVK28.sha256)(str);
module.exports["sha256Hash"] = $0afda9e797c2a356$export$e9131c78c1110376;

});

parcelRegister("fRZe0", function(module, exports) {
/**
 * Any keys that exactly match an entry in this Set will _NOT_ be sanitized. So be sure that anything
 * you add here will not contain PII or UGC
 *
 * Exported for unit tests: `analytics-helpers-test` keeps a duplicate list that must match — so
 * extending the allowlist requires updating that test (and review).
 */ const $d4b17abe12e8a132$export$dff579a44dd3965d = new Set([
    'contentId',
    'readingAidsSessionId',
    'fieldType',
    'multipleUserResultsShown',
    'numAddtlWhoMatches',
    'isCuratedDefinition',
    'isPrecomputedDefinition',
    'editDistance',
    'bookmarkId',
    'bookmarkState',
    'dwellTime',
    'availableProducts',
    'isDescriptionEmpty',
    // from extraAPIAnalyticsAttributes
    'message_id',
    'conversational_channel_id',
    'experience_id',
    'user_id',
    // Deduplicated list of plugin names and minion IDs invoked during the AI answer generation
    'pluginsInvoked',
    // from extraAnalyticsAttributes
    'experiments',
    'featureGates',
    'isFullPageSearch',
    'has3pProducts',
    'is3pSearch',
    'mode',
    'triggeredBy',
    'referrer',
    'requestId'
]);
module.exports["ALLOWED_EXTRA_ATTRIBUTES_KEYS"] = $d4b17abe12e8a132$export$dff579a44dd3965d;

});

parcelRegister("6r8zo", function(module, exports) {
const $f454e58bf727a41f$var$URL_REGEX = /url="([^"]+)"/g;
const $f454e58bf727a41f$export$b2d8940859284af3 = (luminaContentMap)=>{
    const urls = [];
    for (const value of Object.values(luminaContentMap))for (const match of value.matchAll($f454e58bf727a41f$var$URL_REGEX))urls.push(match[1]);
    return urls;
};
module.exports["extractLuminaUrls"] = $f454e58bf727a41f$export$b2d8940859284af3;

});

parcelRegister("agG6W", function(module, exports) {
// utility function copied from /rovo-extension/packages/extension-frontend/src/utils/getProductKey.ts
const $aa4d6d606cb06528$var$SPECIAL_HOST_PRODUCT_KEYS = {
    'calendar.google.com': 'google-calendar',
    'drive.google.com': 'GoogleDrive',
    'docs.google.com': 'GoogleDrive',
    'mail.google.com': 'gmail',
    'teams.microsoft.com': 'Microsoft',
    'outlook.com': 'outlook-mail',
    'outlook.office.com': 'outlook-mail',
    'home.atlassian.com': 'townsquare',
    'xd.adobe.com': 'adobexd'
};
const $aa4d6d606cb06528$var$ATLASSIAN_DOMAIN_SUFFIXES = [
    '.atlassian.net',
    '.atlassian.cloud',
    '.jira-dev.com'
];
const $aa4d6d606cb06528$var$ATLASSIAN_PATH_PRODUCT_KEYS = {
    '/wiki': 'Confluence',
    '/browse': 'Jira',
    '/jira': 'Jira',
    '/compass': 'Compass',
    '/focus': 'Mercury'
};
const $aa4d6d606cb06528$var$DOMAIN_SUFFIX_OVERRIDES = {
    '.powerbi.com': 'power-bi',
    '.azure.com': 'azure-devops',
    '.adobesign.com': 'adobe-sign'
};
const $aa4d6d606cb06528$var$VALID_PRODUCT_KEYS = new Set([
    'bitbucket',
    'compass',
    'confluence',
    'jira',
    'jira-product-discovery',
    'jira-servicedesk',
    'trello',
    'mercury',
    'slack',
    'figma',
    'drive',
    'sharepoint',
    'onedrive',
    'dropbox',
    'github',
    'gitlab',
    'google-calendar',
    'gmail',
    'outlook-mail',
    'outlook-calendar',
    'teams',
    'zendesk',
    'airtable',
    'asana',
    'smartsheet',
    'notion',
    'miro',
    'docusign',
    'lucid',
    'monday',
    'azure-devops',
    'box',
    'zeplin',
    'servicenow',
    'power-bi',
    'clickup',
    'amplitude',
    'stripe',
    'adobexd',
    'aha',
    'mural',
    'webex',
    'todoist',
    'pagerduty',
    'pipedrive',
    'hubspot',
    'dovetail',
    'launchdarkly',
    'salesforce',
    'sentry',
    'loom',
    'adobe-sign'
]);
function $aa4d6d606cb06528$var$getProductKeyFromDomain(hostname) {
    // extract domain suffix and check if it maps to a valid product key
    const domainParts = hostname.split('.');
    if (domainParts.length >= 2) {
        const suffix = '.' + domainParts.slice(-2).join('.');
        if ($aa4d6d606cb06528$var$DOMAIN_SUFFIX_OVERRIDES[suffix]) return $aa4d6d606cb06528$var$DOMAIN_SUFFIX_OVERRIDES[suffix];
        // extract the main domain part (e.g. "zendesk" from "zendesk.com")
        const mainDomain = domainParts[domainParts.length - 2];
        // check if the main domain is a valid product key
        if ($aa4d6d606cb06528$var$VALID_PRODUCT_KEYS.has(mainDomain)) return mainDomain.split('-').map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
        return 'Unknown';
    }
    return 'Unknown';
}
function $aa4d6d606cb06528$export$d0b7f02493f85477(url) {
    const { hostname: hostname, pathname: pathname } = new URL(url);
    // check for special hostname mappings (e.g. calendar.google.com → google-calendar)
    if ($aa4d6d606cb06528$var$SPECIAL_HOST_PRODUCT_KEYS[hostname]) return $aa4d6d606cb06528$var$SPECIAL_HOST_PRODUCT_KEYS[hostname];
    // check if it's an Atlassian domain (e.g. company.atlassian.net)
    const isAtlassianDomain = $aa4d6d606cb06528$var$ATLASSIAN_DOMAIN_SUFFIXES.some((suffix)=>hostname.endsWith(suffix)) || hostname.includes('.atlassian.');
    if (isAtlassianDomain) {
        // for Atlassian domains, identify product based on path patterns (e.g. /wiki → confluence)
        for (const [pathPattern, productKey] of Object.entries($aa4d6d606cb06528$var$ATLASSIAN_PATH_PRODUCT_KEYS)){
            if (pathname.includes(pathPattern)) return productKey;
        }
        return 'Unknown';
    }
    // for other domains, extract product key from domain name (e.g. zendesk.com → zendesk)
    return $aa4d6d606cb06528$var$getProductKeyFromDomain(hostname);
}
module.exports["getProductKey"] = $aa4d6d606cb06528$export$d0b7f02493f85477;

});

parcelRegister("W5g3o", function(module, exports) {

var $4Tg3t = parcelRequire("4Tg3t");

const $9042266756084a97$export$b3c6d7a1ecb4efe1 = (error, commonAttributes)=>{
    const { extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'failed',
        actionSubject: 'aiPrecomputedDefinitionFetch',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.sanitizeExtraAttributes)(extraAttributes),
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    };
};
module.exports["fetchPrecomputedDefinitionErrorPayload"] = $9042266756084a97$export$b3c6d7a1ecb4efe1;

});

parcelRegister("ejlPj", function(module, exports) {
// query to check whether curated definition exists
const $663f31c0647b8bde$export$9051e5c888508a3d = 'CuratedDefinitionQuery';
const $663f31c0647b8bde$export$1886f34f107a0451 = `
query ${$663f31c0647b8bde$export$9051e5c888508a3d}(
		$workspaceId: String!
		$keyPhrase: String!
		$confluenceScopeId: KnowledgeDiscoveryDefinitionScopeIdConfluence
		$jiraScopeId: KnowledgeDiscoveryDefinitionScopeIdJira
	) {
		knowledgeDiscovery {
			definition(
				workspaceId: $workspaceId
				keyPhrase: $keyPhrase
				confluenceScopeId: $confluenceScopeId
				jiraScopeId: $jiraScopeId
			) @optIn(to: "KnowledgeDiscovery Get definition") {
				__typename
				... on KnowledgeDiscoveryDefinition {
					definition
					accountId
					createdAt
					editor {
						... on User {
							name
							accountId
						}
					}
					referenceUrl
					confluenceEntity {
						... on ConfluencePage {
							id
							type
							title
							space {
								name
							}
						}
						... on ConfluenceBlogPost {
							id
							type
							title
							space {
								name
							}
						}
					}
				}
				... on QueryError {
					message
				}
			}
		}
	}
`;
module.exports["CURATED_DEFINITION_OPERATION_NAME"] = $663f31c0647b8bde$export$9051e5c888508a3d;
module.exports["CuratedDefinitionQuery"] = $663f31c0647b8bde$export$1886f34f107a0451;

});

parcelRegister("j1YGG", function(module, exports) {
const $0b7765a5ad679bd9$export$73cd67d787c37f2e = `
query PrecomputedDefinitionQuery(
		$workspaceId: String!
		$keyPhrase: String!
        $contentId: String!
	) {
		knowledgeDiscovery {
			autoDefinition(
				workspaceId: $workspaceId
				keyPhrase: $keyPhrase
				contentId: $contentId
			) @optIn(to: "KnowledgeDiscovery Get auto definition") {
				__typename
				... on KnowledgeDiscoveryAutoDefinition {
					definition
                    createdAt
					confluenceEntity {
						... on ConfluencePage {
							id
							type
							title
							space {
								name
							}
                            links {
                                base
                                webUi
                            }
						}
						... on ConfluenceBlogPost {
							id
							type
							title
							space {
								name
							}
                            links {
                                base
                                webUi
                            }
						}
					}
				}
				... on QueryError {
					message
                    extensions {
                        statusCode
                        errorType
                    }
				}
			}
		}
	}
`;
module.exports["PrecomputedDefinitionQuery"] = $0b7765a5ad679bd9$export$73cd67d787c37f2e;

});

parcelRegister("97lMo", function(module, exports) {

var $9u8Y2 = parcelRequire("9u8Y2");


var $hpFQM = parcelRequire("hpFQM");

const $5223057167adf139$export$faaccabd846a199 = (definition)=>{
    const definitionReference = definition.confluenceEntity;
    return {
        nlpResult: definition.definition,
        uniqueSources: definitionReference ? [
            {
                id: definitionReference?.id || '',
                title: definitionReference?.title || '',
                url: 'referenceUrl' in definition ? definition.referenceUrl || '' : 'links' in definitionReference && definitionReference.links.base && definitionReference.links.webUi ? `${definitionReference.links.base}${definitionReference.links.webUi}` : '',
                type: definitionReference?.type || '',
                // Currently curated and precomputed definitions sources can only be Confluence
                product: 'Confluence',
                lastModified: '',
                iconUrl: '',
                spaceName: definitionReference?.space?.name || '',
                spaceUrl: null
            }
        ] : [],
        nlpResultEditor: 'editor' in definition ? {
            name: definition.editor?.name || '',
            id: definition.editor?.accountId || ''
        } : undefined,
        disclaimer: null,
        errorState: null,
        format: (0, $hpFQM.NLPSearchResultFormat).MARKDOWN,
        customDefinitionType: 'editor' in definition ? (0, $9u8Y2.NLPSearchCustomDefinitionType).CURATED : (0, $9u8Y2.NLPSearchCustomDefinitionType).PRECOMPUTED
    };
};
module.exports["mapCustomDefinitionToNLPSearchType"] = $5223057167adf139$export$faaccabd846a199;

});

parcelRegister("9u8Y2", function(module, exports) {
var $087ad2b4edc49da7$export$12b805d25b464b8d = /*#__PURE__*/ function(NLPSearchCustomDefinitionType) {
    NLPSearchCustomDefinitionType["CURATED"] = "CURATED";
    NLPSearchCustomDefinitionType["PRECOMPUTED"] = "PRECOMPUTED";
    return NLPSearchCustomDefinitionType;
}({});
module.exports["NLPSearchCustomDefinitionType"] = $087ad2b4edc49da7$export$12b805d25b464b8d;

});

parcelRegister("7mZPi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2hZ5V = parcelRequire("2hZ5V");

const $e3aff56aba7c2fd1$var$existingHighlightedTextMap = new Map();
const $e3aff56aba7c2fd1$export$f9a15102b225398f = ({ children: children, match: match, marks: marks, startPos: startPos, definitionConfig: definitionConfig, sourceConfig: sourceConfig, keyPhrases: keyPhrases })=>{
    const contentARI = sourceConfig.contentARI;
    if (!$e3aff56aba7c2fd1$var$existingHighlightedTextMap.has(`${contentARI}-${match}`)) $e3aff56aba7c2fd1$var$existingHighlightedTextMap.set(`${contentARI}-${match}`, startPos);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            $e3aff56aba7c2fd1$var$existingHighlightedTextMap.delete(`${contentARI}-${match}`);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // no comments or links should be highlighted
    if (!(marks.has('annotation') || marks.has('link'))) {
        const nodeMatch = keyPhrases.find((node)=>node.keyPhrase === match);
        // only highlight first occurrence of the word
        if (!!nodeMatch && $e3aff56aba7c2fd1$var$existingHighlightedTextMap.get(`${contentARI}-${match}`) === startPos) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2hZ5V.DefinitionTextHighlighter), {
            keyPhraseCategory: nodeMatch.category,
            definitionConfig: definitionConfig,
            sourceConfig: sourceConfig
        }, children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
module.exports["RendererDefinitionTextHighlighter"] = $e3aff56aba7c2fd1$export$f9a15102b225398f;

});

parcelRegister("2hZ5V", function(module, exports) {
/* definition-text-highlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $kHija = parcelRequire("kHija");


var $8tNXq = parcelRequire("8tNXq");


var $hsCD1 = parcelRequire("hsCD1");


var $7hxTR = parcelRequire("7hxTR");


var $cmPey = parcelRequire("cmPey");


var $djTZ8 = parcelRequire("djTZ8");

const $6d3b704c5ce74d57$var$definitionWrapperStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $6d3b704c5ce74d57$var$DefinitionHighlighter = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { showHighlight: showHighlight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_11qfq0e": (0, $9aYkv.default)(__cmplp.showHighlight ? 'solid' : 'none')
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_5pioz8co _189e1dm9 _1il9buyh _19lc184f _d0altlke",
            __cmplp.className
        ])
    });
});
const $6d3b704c5ce74d57$export$5f4d22ccfacd381d = /*#__PURE__*/ (0, $cozmU.memo)(({ children: children, definitionConfig: definitionConfig, keyPhraseCategory: keyPhraseCategory, sourceConfig: sourceConfig })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const definitionSessionId = (0, $cozmU.useRef)((0, $kHija.v4)()).current; // controls whether to show underline highlight
    const [showHighlight, setShowHighlight] = (0, $cozmU.useState)(true);
    const [definitionQuery, setDefinitionQuery] = (0, $cozmU.useState)('');
    const [triggerPosition, setTriggerPosition] = (0, $cozmU.useState)(undefined); // const [additionalContext, setAdditionalContext] = useState('');
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const onDefinitionSingleClick = (0, $cozmU.useCallback)(async (e)=>{
        e.preventDefault();
        e.stopPropagation();
        const eventTarget = e.target;
        if (!eventTarget || !(eventTarget instanceof Element)) return;
        await (0, $hsCD1.aiDefinitionsLoadUFOExperience).start();
        setShowHighlight(false);
        fireAnalyticsEvent((0, $cmPey.onClickAutoDefinitionHighlights)({
            contentId: sourceConfig.contentId,
            sessionId: definitionSessionId,
            keyPhraseCategory: keyPhraseCategory
        })); // const selectedContext = eventTarget.parentElement;
        // const additionalContext = selectedContext
        // 	? selectedContext.textContent || selectedContext.innerText
        // 	: '';
        const rect = eventTarget.getBoundingClientRect(); // we only need to pass in height to popup; others are needed for manual define
        const acronymRect = {
            top: 0,
            left: 0,
            width: rect.width,
            height: rect.height
        };
        setDefinitionQuery(eventTarget.textContent || '');
        setTriggerPosition(acronymRect); // setAdditionalContext(additionalContext);
    }, [
        definitionSessionId,
        fireAnalyticsEvent,
        keyPhraseCategory,
        sourceConfig.contentId
    ]);
    const onDefinitionClick = (0, $7hxTR.useTextHighlighterClickNative)({
        singleClickCallback: onDefinitionSingleClick,
        doubleClickCallback: ()=>{} // do nothing, actions menu takes over
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            "_kqswh2mm"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d3b704c5ce74d57$var$DefinitionHighlighter, {
        showHighlight: showHighlight,
        onClick: onDefinitionClick,
        "data-testid": "definition-highlighter"
    }, children), triggerPosition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $djTZ8.DefinitionPopup), {
        onClose: ()=>{
            setTriggerPosition(undefined);
            setShowHighlight(true);
        },
        triggerPosition: triggerPosition,
        queryConfig: {
            query: definitionQuery,
            additionalQueryContext: ''
        },
        sessionConfig: {
            sessionId: definitionSessionId
        },
        sourceConfig: sourceConfig,
        definitionConfig: definitionConfig,
        definitionLoadingConfig: {
            width: triggerPosition.width
        },
        onLoad: ()=>setShowHighlight(true)
    }) : null);
});
module.exports["DefinitionTextHighlighter"] = $6d3b704c5ce74d57$export$5f4d22ccfacd381d;

});

parcelRegister("8tNXq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $zzZbq = parcelRequire("zzZbq");

const $a273dd7aa35752e1$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire((0, $zzZbq.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return [
        fireAnalyticsEvent
    ];
};
module.exports["useAnalytics"] = $a273dd7aa35752e1$export$e955abb82869dc84;

});

parcelRegister("hsCD1", function(module, exports) {

var $gZFfs = parcelRequire("gZFfs");

var $34VCg = parcelRequire("34VCg");

const $e508769d540061ba$var$DEFINITIONS_COMPONENT = 'search-ai-definitions';
const $e508769d540061ba$export$5b2a28beea8d66c3 = new (0, $34VCg.UFOExperience)(`${$e508769d540061ba$var$DEFINITIONS_COMPONENT}-load`, {
    type: (0, $gZFfs.ExperienceTypes).Experience,
    performanceType: (0, $gZFfs.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: $e508769d540061ba$var$DEFINITIONS_COMPONENT
    }
});
module.exports["aiDefinitionsLoadUFOExperience"] = $e508769d540061ba$export$5b2a28beea8d66c3;

});

parcelRegister("7hxTR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $99523e27f8354c2e$export$ab78b8e7dad428f8 = ({ singleClickCallback: singleClickCallback, doubleClickCallback: doubleClickCallback, delay: delay = 250 })=>{
    const [state, setState] = (0, $cozmU.useState)({
        e: null
    });
    (0, $cozmU.useEffect)(()=>{
        if (!Boolean(state.e)) return;
        const timer = setTimeout(()=>{
            // single click
            if (state.e?.detail === 1) singleClickCallback(state.e);
            else if (state.e?.detail && state.e.detail > 1) doubleClickCallback(state.e);
            setState({
                e: null
            });
        }, delay);
        return ()=>clearTimeout(timer);
    }, [
        state,
        singleClickCallback,
        doubleClickCallback,
        delay
    ]);
    return (e)=>{
        setState({
            e: e
        });
    };
};
const $99523e27f8354c2e$export$f93f1774a43b3eae = ({ singleClickCallback: singleClickCallback, doubleClickCallback: doubleClickCallback, delay: delay = 250 })=>{
    const [state, setState] = (0, $cozmU.useState)({
        click: 0,
        e: null
    });
    (0, $cozmU.useEffect)(()=>{
        if (!Boolean(state.e)) return;
        const timer = setTimeout(()=>{
            // simple click
            if (state.click === 1) singleClickCallback(state.e);
            setState({
                e: null,
                click: 0
            });
        }, delay);
        // the duration between this click and the previous one
        // is less than the value of delay = double-click
        if (state.click === 2) doubleClickCallback(state.e);
        return ()=>clearTimeout(timer);
    }, [
        state,
        singleClickCallback,
        doubleClickCallback,
        delay
    ]);
    return (e)=>{
        setState({
            click: state.click + 1,
            e: e
        });
    };
};
module.exports["useTextHighlighterClickNative"] = $99523e27f8354c2e$export$ab78b8e7dad428f8;
module.exports["useTextHighlighterClick"] = $99523e27f8354c2e$export$f93f1774a43b3eae;

});

parcelRegister("cmPey", function(module, exports) {

var $e9Hlq = parcelRequire("e9Hlq");

const $6014f4fbf1680805$export$9e6261f08debf93b = ({ contentId: contentId, sessionId: sessionId, keyPhraseCategory: keyPhraseCategory, fieldType: fieldType })=>({
        action: 'clicked',
        actionSubject: 'aiDefinitionsAutohighlights',
        source: 'viewPageScreen',
        eventType: 'ui',
        attributes: {
            contentId: contentId,
            readingAidsSessionId: sessionId,
            keyPhraseCategory: keyPhraseCategory || (0, $e9Hlq.KeyPhraseCategory).AUTO,
            fieldType: fieldType
        }
    });
module.exports["onClickAutoDefinitionHighlights"] = $6014f4fbf1680805$export$9e6261f08debf93b;

});

parcelRegister("djTZ8", function(module, exports) {
/* definition-popup.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $5wHqn = parcelRequire("5wHqn");


var $ieeJu = parcelRequire("ieeJu");

const $c5082a2841defa60$var$DEFINITION_DIALOG_TITLE_ID = 'definition-dialog-title';
const $c5082a2841defa60$var$popupContainerStyles = null;
const $c5082a2841defa60$var$CustomPopupContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, ...props }, ref)=>{
    if ((0, $ieeJu.expValEquals)('a11y-fixes-week1-june-2026', 'isEnabled', true)) return /*#__PURE__*/ $cozmU.createElement("div", {
        ...props,
        ref: ref,
        role: "dialog",
        "aria-modal": "false",
        "aria-labelledby": $c5082a2841defa60$var$DEFINITION_DIALOG_TITLE_ID,
        className: (0, $hekY6.default)([
            "_1pbyowjs"
        ])
    }, children);
    return /*#__PURE__*/ $cozmU.createElement("span", {
        ...props,
        ref: ref,
        className: (0, $hekY6.default)([
            "_1pbyowjs"
        ])
    }, children);
});
const $c5082a2841defa60$var$definitionPopupTriggerStylesStatic = null;

const $c5082a2841defa60$var$LazyDefinitionPopupContent = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("lON2v")).then((module)=>({
            default: module.DefinitionPopupContent
        })));
function $c5082a2841defa60$export$576a6d4c65a0c923({ onClose: onClose, triggerPosition: triggerPosition, onLoad: onLoad, ...definitionPopupContentProps }) {
    const definitionPopupTriggerStylesDynamic = {
        height: `${triggerPosition.height}px`,
        left: `${triggerPosition.left}px`,
        top: `${triggerPosition.top}px`,
        width: `${triggerPosition.width}px`
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $5wHqn.default), {
        content: ({ update: update })=>/*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
                fallback: null
            }, /*#__PURE__*/ $cozmU.createElement($c5082a2841defa60$var$LazyDefinitionPopupContent, {
                ...definitionPopupContentProps,
                onClose: onClose,
                onLoad: ()=>{
                    onLoad?.();
                    update();
                }
            })),
        onClose: onClose,
        placement: "bottom-start",
        popupComponent: $c5082a2841defa60$var$CustomPopupContainer,
        testId: "definition-popup",
        trigger: (triggerProps)=>/*#__PURE__*/ $cozmU.createElement("span", {
                ...triggerProps,
                style: definitionPopupTriggerStylesDynamic,
                "data-testid": "definition-popup-trigger",
                className: (0, $hekY6.default)([
                    "_tzy4idpf _kqswstnw _lcxvglyw _bfhk1j28 _1ltvidpf _94n5idpf"
                ])
            }),
        isOpen: true
    });
}
module.exports["DefinitionPopup"] = $c5082a2841defa60$export$576a6d4c65a0c923;

});

parcelRegister("lON2v", function(module, exports) {

let $fe244eafe05d29b2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fe244eafe05d29b2$var$load("kT6dz"),
    $fe244eafe05d29b2$var$load("bpmjT"),
    $fe244eafe05d29b2$var$load("ig9dh"),
    $fe244eafe05d29b2$var$load("hA8hA"),
    $fe244eafe05d29b2$var$load("gbejv"),
    $fe244eafe05d29b2$var$load("GD9EA"),
    $fe244eafe05d29b2$var$load("7TnhR"),
    $fe244eafe05d29b2$var$load("iUXaE"),
    $fe244eafe05d29b2$var$load("lTkx9"),
    $fe244eafe05d29b2$var$load("hUbK8"),
    $fe244eafe05d29b2$var$load("hn4Xf"),
    $fe244eafe05d29b2$var$load("eSqZD"),
    $fe244eafe05d29b2$var$load("2PFjC"),
    $fe244eafe05d29b2$var$load("gwGEC"),
    $fe244eafe05d29b2$var$load("l5nRU"),
    $fe244eafe05d29b2$var$load("fcAaN"),
    $fe244eafe05d29b2$var$load("i4oYl"),
    $fe244eafe05d29b2$var$load("2CrXe"),
    $fe244eafe05d29b2$var$load("beMmd"),
    $fe244eafe05d29b2$var$load("1rM9D"),
    $fe244eafe05d29b2$var$load("3cN9G"),
    $fe244eafe05d29b2$var$load("7oMW2"),
    $fe244eafe05d29b2$var$load("j3345"),
    $fe244eafe05d29b2$var$load("2J2X1"),
    $fe244eafe05d29b2$var$load("do0Fh"),
    $fe244eafe05d29b2$var$load("1Gr4q"),
    $fe244eafe05d29b2$var$load("4RsKm"),
    $fe244eafe05d29b2$var$load("7oAXW"),
    $fe244eafe05d29b2$var$load("3RQq6"),
    $fe244eafe05d29b2$var$load("iOfkQ"),
    $fe244eafe05d29b2$var$load("dxcsb"),
    $fe244eafe05d29b2$var$load("99ObF"),
    $fe244eafe05d29b2$var$load("9ZFGK"),
    $fe244eafe05d29b2$var$load("2hLAI"),
    $fe244eafe05d29b2$var$load("dCilB"),
    $fe244eafe05d29b2$var$load("h1yOv"),
    $fe244eafe05d29b2$var$load("1T8H1"),
    $fe244eafe05d29b2$var$load("fyKFO"),
    $fe244eafe05d29b2$var$load("d9sg7"),
    $fe244eafe05d29b2$var$load("l0N35"),
    $fe244eafe05d29b2$var$load("Wowvf"),
    $fe244eafe05d29b2$var$load("hhss7"),
    $fe244eafe05d29b2$var$load("ekVH8"),
    $fe244eafe05d29b2$var$load("c1gk3"),
    $fe244eafe05d29b2$var$load("Kj0I8"),
    $fe244eafe05d29b2$var$load("5xnun"),
    $fe244eafe05d29b2$var$load("cyTuQ"),
    $fe244eafe05d29b2$var$load("jqoep"),
    $fe244eafe05d29b2$var$load("6wr18"),
    $fe244eafe05d29b2$var$load("59hV4"),
    $fe244eafe05d29b2$var$load("4x9Jx"),
    $fe244eafe05d29b2$var$load("a8glC"),
    $fe244eafe05d29b2$var$load("eCXJR"),
    $fe244eafe05d29b2$var$load("1VTX2"),
    $fe244eafe05d29b2$var$load("ffEVr"),
    $fe244eafe05d29b2$var$load("2EIkU"),
    $fe244eafe05d29b2$var$load("ddvkk"),
    $fe244eafe05d29b2$var$load("3upHR"),
    $fe244eafe05d29b2$var$load("hZ2FX"),
    $fe244eafe05d29b2$var$load("7EorR"),
    $fe244eafe05d29b2$var$load("lyDkU")
]).then(()=>parcelRequire('lPV0U'));

});

parcelRegister("bzqa9", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $lTECB = parcelRequire("lTECB");


var $dPJCf = parcelRequire("dPJCf");


var $4qzKl = parcelRequire("4qzKl");


var $icKZN = parcelRequire("icKZN");

const $abb6860b27595ef6$export$8ce912bc34d0dbea = ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    let t0;
    if ($[0] !== push) {
        t0 = (event, url)=>{
            if (!event?.isDefaultPrevented()) event?.preventDefault();
            if ((0, $icKZN.isClickEventToOpenNewTab)(event)) window.open(url, "_blank");
            else push(url);
        };
        $[0] = push;
        $[1] = t0;
    } else t0 = $[1];
    const handleClick = t0;
    let t1;
    if ($[2] !== handleClick) {
        t1 = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)() ? {
            mention: {
                onClick: async (userId, _, event_0)=>{
                    event_0?.preventDefault();
                    event_0?.stopPropagation();
                    const url_0 = await (0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(userId);
                    handleClick(event_0, url_0);
                }
            },
            link: {
                onClick (e, url_1) {
                    handleClick(e, url_1);
                }
            },
            smartCard: {
                onClick (e_0, url_2) {
                    handleClick(e_0, url_2);
                }
            }
        } : undefined;
        $[2] = handleClick;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["useEventHandlers"] = $abb6860b27595ef6$export$8ce912bc34d0dbea;

});

parcelRegister("chaNr", function(module, exports) {
const $edb96fd8df3233f3$export$8e1715e14eb19dce = {
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__'
};
const $edb96fd8df3233f3$export$a4903313a3329d59 = {
    UNSUPPORTED_EXTENSION: 'unsupportedExtension',
    INVALID_ADF: 'invalidAdf'
};
const $edb96fd8df3233f3$export$718381a72a965ef3 = [
    'jira',
    'attachments',
    'bgcolor',
    'blog-posts',
    'center',
    'chart',
    'column',
    'contentbylabel',
    'content-by-user',
    'rw-ui-layout-macro',
    'content-report-table',
    'profile-picture',
    'contributors-summary',
    'copyright',
    'excerpt',
    'excerpt-include',
    'fancy-bullets',
    'favpages',
    'gallery',
    'global-reports',
    'map',
    'highlight',
    'listlabels',
    'mathblock',
    'mathinline',
    'loremipsum',
    'navmap',
    'network',
    'index',
    'details',
    'detailssummary',
    'panel',
    'popular-labels',
    'privacy-mark',
    'privacy-policy',
    'recently-updated',
    'recently-used-labels',
    'reg-tm',
    'section',
    'sm',
    'space-details',
    'strike',
    'tasks-report-macro',
    'tm',
    'rw-ui-textbox-macro',
    'userlister',
    'profile',
    'jirachart',
    'jiraroadmap',
    'gadget',
    'contributors',
    'widget'
];
module.exports["FALLBACK_REASONS"] = $edb96fd8df3233f3$export$a4903313a3329d59;
module.exports["supportedMacroExtensions"] = $edb96fd8df3233f3$export$718381a72a965ef3;

});

parcelRegister("1C1zB", function(module, exports) {
/* eslint-disable react/jsx-boolean-value */ 
var $cozmU = parcelRequire("cozmU");


var $5kjCz = parcelRequire("5kjCz");


var $8pcS0 = parcelRequire("8pcS0");


var $fuLIO = parcelRequire("fuLIO");


var $kycWk = parcelRequire("kycWk");

var $F4YLX = parcelRequire("F4YLX");


var $chaNr = parcelRequire("chaNr");


var $lXP6p = parcelRequire("lXP6p");


var $ajkp0 = parcelRequire("ajkp0");

const $4ff570b9d2ed6508$var$getRedactionExtensionHandler = (contentId)=>(extension)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $F4YLX.TourableRedactionExtensionLoader), {
            contentId: contentId,
            extensionNode: extension,
            isCommentContext: true
        });
    };
const $4ff570b9d2ed6508$export$fe33197d44e10fcf = (setLegacyRendererFlag, contentId, spaceKey, mode)=>{
    const macroHandler = {
        [(0, $8pcS0.EXTENSION_TYPE).MACRO_CORE]: $4ff570b9d2ed6508$var$getMacroExtensionHandler({
            setLegacyRendererFlag: setLegacyRendererFlag,
            contentId: contentId,
            spaceKey: spaceKey,
            mode: mode
        })
    };
    const migrationHandler = {
        [(0, $8pcS0.EXTENSION_TYPE).MIGRATION]: $4ff570b9d2ed6508$var$getMigrationExtensionHandler(setLegacyRendererFlag, contentId)
    };
    const redactionHandler = {
        [(0, $kycWk.REDACTION_EXTENSION_TYPE)]: $4ff570b9d2ed6508$var$getRedactionExtensionHandler(contentId)
    };
    return {
        ...macroHandler,
        ...migrationHandler,
        ...redactionHandler
    };
};
const $4ff570b9d2ed6508$var$getMacroExtensionHandler = ({ setLegacyRendererFlag: setLegacyRendererFlag, contentId: contentId, spaceKey: spaceKey, mode: mode })=>(extension)=>{
        const { extensionKey: extensionKey } = extension;
        if (setLegacyRendererFlag) setLegacyRendererFlag(extensionKey);
        if ((0, $chaNr.supportedMacroExtensions).includes(extensionKey)) {
            const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(extension);
            const macroDefaultProps = {
                node: extension,
                contentId: contentId || '',
                mode: mode || (0, $5kjCz.RENDERER),
                spaceKey: spaceKey || '',
                extensionKey: extensionKey,
                attributes: attributes
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fuLIO.LegacyMacroRendererQuery), macroDefaultProps);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ajkp0.UnsupportedFallbackComponent), null);
    };
const $4ff570b9d2ed6508$var$getMigrationExtensionHandler = (setLegacyRendererFlag, contentId)=>(extension)=>{
        const { extensionKey: extensionKey } = extension;
        if (extensionKey === (0, $8pcS0.MIGRATION_EXTENSION_KEYS).INVALID) {
            if (setLegacyRendererFlag) setLegacyRendererFlag();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ajkp0.UnsupportedFallbackComponent), null);
        }
        if (extensionKey === (0, $8pcS0.EXTENSION_KEY).INLINE_EXTERNAL_IMAGE || extensionKey === (0, $8pcS0.EXTENSION_KEY).INLINE_MEDIA_IMAGE) {
            if (setLegacyRendererFlag) setLegacyRendererFlag(extensionKey);
            return contentId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lXP6p.FallbackComponent), {
                contentId: contentId
            }) : null;
        }
        return null;
    };
module.exports["getExtensionHandlers"] = $4ff570b9d2ed6508$export$fe33197d44e10fcf;

});

parcelRegister("lXP6p", function(module, exports) {

var $eJfvT = parcelRequire("eJfvT");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $V3JOP = parcelRequire("V3JOP");


var $aRGok = parcelRequire("aRGok");


var $jMyy4 = parcelRequire("jMyy4");


var $cutWg = parcelRequire("cutWg");

const $0d195c36a2d7770a$var$StyledContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt45uws _1e0c1txw _10rcu2gc",
            __cmplp.className
        ])
    });
});
const $0d195c36a2d7770a$var$CommentSkeleton = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $0d195c36a2d7770a$var$SkeletonContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt41g6e _1e0c1txw _99ztu2gc",
            __cmplp.className
        ])
    });
});
const $0d195c36a2d7770a$var$CommentSkeletonLine = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1gljcou": (0, $9aYkv.default)(__cmplp.width, "%")
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2rkofajl _bfhkizff _4t3i1crf _otyru2gc _1bsb1rkg",
            __cmplp.className
        ])
    });
});
const $0d195c36a2d7770a$export$23216ae99c93d0b = ({ contentId: contentId })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $eJfvT.default), {
        variables: {
            contentId: contentId ?? ''
        },
        __callerPackage__: "comment-extension-handlers"
    });
    const buildUserObject = (data)=>{
        const userId = data?.content?.nodes?.[0]?.history?.createdBy?.accountId;
        const avatarUrl = data?.content?.nodes?.[0]?.history?.createdBy?.profilePicture?.path;
        const displayName = data?.content?.nodes?.[0]?.history?.createdBy?.displayName;
        return {
            userId: userId,
            avatarUrl: avatarUrl,
            displayName: displayName
        };
    };
    const handleCloseModal = (0, $cozmU.useCallback)(()=>{
        setIsOpen(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
    const user = buildUserObject(data);
    const legacyContent = data?.content?.nodes?.[0]?.body?.view?.value ?? '';
    const webResourceKeys = data?.content?.nodes?.[0]?.body?.view?.webresource?.keys ?? [];
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0d195c36a2d7770a$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
        spacing: "spacious",
        label: "legacy-modal-shortcut"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0d195c36a2d7770a$var$CommentSkeleton, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0d195c36a2d7770a$var$CommentSkeletonLine, {
        width: 100
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0d195c36a2d7770a$var$CommentSkeletonLine, {
        width: 100
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0d195c36a2d7770a$var$CommentSkeletonLine, {
        width: 75
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0d195c36a2d7770a$var$StyledContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
        spacing: "spacious",
        label: "legacy-modal-shortcut"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: "#",
        onClick: handleCloseModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "comment-extension-handlers.fallback.action",
        defaultMessage: "Click to view content"
    })), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "comment-extension-handlers.fallback.reason",
        defaultMessage: "that can\u2019t display inline as it was created in a legacy version of Confluence."
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cutWg.LegacyContentModal), {
        onClose: setIsOpen,
        content: legacyContent,
        webResources: webResourceKeys,
        user: user
    })));
};
module.exports["FallbackComponent"] = $0d195c36a2d7770a$export$23216ae99c93d0b;

});

parcelRegister("eJfvT", function(module, exports) {
/**
 * @generated SignedSource<<aa5c445a239b7119d514c8f17757ea66>>
 * @relayHash 2b11554f4389f71764621368308cd942
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2a38265f9e9abdb4a3757d0be1c234f0641d5bb317dd568c63a5496eb5b0dbaa
const $f10d0aba441df4ce$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentBodyPerRepresentation",
                            "kind": "LinkedField",
                            "name": "body",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentBody",
                                    "kind": "LinkedField",
                                    "name": "view",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        },
                                        {
                                            "concreteType": "WebResourceDependencies",
                                            "kind": "LinkedField",
                                            "name": "webresource",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "keys"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "accountId"
                                                }
                                            ],
                                            "type": "KnownUser"
                                        },
                                        {
                                            "concreteType": "Icon",
                                            "kind": "LinkedField",
                                            "name": "profilePicture",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "path"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "displayName"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FallbackComponentLegacyContentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FallbackComponentLegacyContentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "2b11554f4389f71764621368308cd942",
            "id": "2a38265f9e9abdb4a3757d0be1c234f0641d5bb317dd568c63a5496eb5b0dbaa",
            "metadata": {},
            "name": "FallbackComponentLegacyContentQuery",
            "operationKind": "query",
            "text": "query FallbackComponentLegacyContentQuery($contentId:ID!){content(id:$contentId){nodes{id,body{view{value,webresource{keys}}},history{createdBy{__typename,...on KnownUser{accountId},profilePicture{path},displayName}},type}}}"
        }
    };
}();
$f10d0aba441df4ce$var$node.hash = "115b91c2474796b4abfdcb0076932148";
var $f10d0aba441df4ce$export$2e2bcd8739ae039 = $f10d0aba441df4ce$var$node;
module.exports["default"] = $f10d0aba441df4ce$export$2e2bcd8739ae039;

});

parcelRegister("cutWg", function(module, exports) {
/* LegacyContentModal.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $7aRdF = parcelRequire("7aRdF");


var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $brpfO = parcelRequire("brpfO");


var $jJK3p = parcelRequire("jJK3p");


var $fs6LW = parcelRequire("fs6LW");


var $cpjd2 = parcelRequire("cpjd2");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $920076e2f988014c$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _ca0qpxbi",
            __cmplp.className
        ])
    });
});
const $920076e2f988014c$var$ContentContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _2lx21bp4 _19bvu2gc _16tx1b66",
            __cmplp.className
        ])
    });
});
const $920076e2f988014c$var$closeButton = (0, $kSwu1.defineMessage)({
    id: "comment-extension-handlers.legacy-content-modal.close-button.non-final-ai",
    defaultMessage: "Close"
});
const $920076e2f988014c$export$8d93ebb7c75cb5b4 = ({ onClose: onClose, content: content, user: user, webResources: webResources })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [containerRef, setContainerRef] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        (0, $cpjd2.requireLegacyWRM)(webResources, ()=>{}, ()=>{});
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (containerRef) (0, $brpfO.evalLegacyConnectInlineScripts)(containerRef);
    }, [
        containerRef
    ]);
    const onRefSet = (ref)=>{
        setContainerRef(ref);
    };
    const handleClose = ()=>{
        onClose(false);
    };
    const handleImageClick = (event)=>{
        // clicking on an image shows a full screen modal
        // of the image in the background
        if (event.target instanceof HTMLImageElement) onClose(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        onClose: handleClose,
        width: "large",
        testId: "modal-dialog-legacy-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($920076e2f988014c$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fs6LW.ProfileAvatar), {
        userId: user.userId,
        src: user.avatarUrl,
        name: user.displayName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($920076e2f988014c$var$ContentContainer, {
        onClick: handleImageClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jJK3p.ProfileLink), {
        userId: user.userId,
        fullName: user.displayName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        ref: onRefSet,
        dangerouslySetInnerHTML: {
            __html: content
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        autoFocus: true,
        appearance: "primary",
        onClick: handleClose
    }, formatMessage($920076e2f988014c$var$closeButton))));
};
module.exports["LegacyContentModal"] = $920076e2f988014c$export$8d93ebb7c75cb5b4;

});

parcelRegister("ajkp0", function(module, exports) {
/* UnsupportedFallbackComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $24dy7 = parcelRequire("24dy7");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ff2521e469949e41$var$StyledContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt45uws _1e0c1txw _10rcu2gc",
            __cmplp.className
        ])
    });
});
const $ff2521e469949e41$export$563f56722e191781 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ff2521e469949e41$var$StyledContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        spacing: "spacious",
        label: "unsupported-legacy-error"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "comment-extension-handlers.unsupported.fallback",
        defaultMessage: "This content cannot be displayed as it was created in a legacy version of Confluence and is unsupported."
    }));
module.exports["UnsupportedFallbackComponent"] = $ff2521e469949e41$export$563f56722e191781;

});

parcelRegister("eV0v4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3d3WW = parcelRequire("3d3WW");


var $78QFu = parcelRequire("78QFu");

const $2f8044ddd141ffa3$export$8f5016028a31aee0 = {
    channel: 'media',
    actionSubjects: [
        'mediaCardRender',
        'mediaUpload',
        'smartLink'
    ]
};
const $2f8044ddd141ffa3$export$def227c48fe2bf2c = {
    channel: 'editor',
    actionSubjects: [
        'renderer'
    ]
};
const $2f8044ddd141ffa3$export$e3ba538a10828e25 = ({ channelParam: channelParam, children: children })=>{
    const handleEvent = (0, $cozmU.useCallback)((event)=>{
        function updateEvent() {
            event.update((payload)=>{
                return {
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                    }
                };
            });
        }
        if (channelParam.actionSubjects.includes(event.payload.actionSubject)) updateEvent();
    }, [
        channelParam
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        channel: channelParam.channel,
        onEvent: handleEvent
    }, children);
};
module.exports["mediaChannel"] = $2f8044ddd141ffa3$export$8f5016028a31aee0;
module.exports["editorChannel"] = $2f8044ddd141ffa3$export$def227c48fe2bf2c;
module.exports["DynamicAnalyticsListener"] = $2f8044ddd141ffa3$export$e3ba538a10828e25;

});

parcelRegister("97Szk", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kkFbH = parcelRequire("kkFbH");


var $8A5sV = parcelRequire("8A5sV");


var $kpuvJ = parcelRequire("kpuvJ");


var $d4GYd = parcelRequire("d4GYd");


var $jkdKe = parcelRequire("jkdKe");

const $3fda69966c9a64cd$var$i18n = (0, $kSwu1.defineMessages)({
    editDefinitionRestrictedToSpaceOption: {
        id: "contextual-reading-aids.edit.definition.restricted.to.space.option",
        defaultMessage: "In this space"
    },
    editDefinitionRestrictedToPageOption: {
        id: "contextual-reading-aids.edit.definition.restricted.to.page.option",
        defaultMessage: "On this page"
    },
    editDefinitionRestrictedToBlogpostOption: {
        id: "contextual-reading-aids.edit.definition.restricted.to.blogpost.option",
        defaultMessage: "On this blogpost"
    },
    editDefinitionRestrictedToSiteOption: {
        id: "contextual-reading-aids.edit.definition.restricted.to.site.option",
        defaultMessage: "On this site"
    }
});
function $3fda69966c9a64cd$export$ad09b24d617a41f5(contentType) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return (0, $cozmU.useMemo)(()=>[
            {
                label: formatMessage($3fda69966c9a64cd$var$i18n.editDefinitionRestrictedToSpaceOption),
                value: (0, $jkdKe.EditedDefinitionScope).SPACE,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8A5sV))), {
                    label: ""
                })
            },
            contentType === 'blogpost' ? {
                label: formatMessage($3fda69966c9a64cd$var$i18n.editDefinitionRestrictedToBlogpostOption),
                value: (0, $jkdKe.EditedDefinitionScope).BLOGPOST,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))), {
                    label: ""
                })
            } : {
                label: formatMessage($3fda69966c9a64cd$var$i18n.editDefinitionRestrictedToPageOption),
                value: (0, $jkdKe.EditedDefinitionScope).PAGE,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), {
                    label: ""
                })
            },
            {
                label: formatMessage($3fda69966c9a64cd$var$i18n.editDefinitionRestrictedToSiteOption),
                value: (0, $jkdKe.EditedDefinitionScope).ORGANIZATION,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kpuvJ))), {
                    label: ""
                })
            }
        ], [
        contentType,
        formatMessage
    ]);
}
module.exports["useDefinitionRestrictionOptions"] = $3fda69966c9a64cd$export$ad09b24d617a41f5;

});

parcelRegister("jkdKe", function(module, exports) {
var $8ca9ab19b77d9d33$export$a53c998f5fa685e1 = /*#__PURE__*/ function(EditedDefinitionScope) {
    EditedDefinitionScope["SPACE"] = "SPACE";
    EditedDefinitionScope["PAGE"] = "PAGE";
    EditedDefinitionScope["BLOGPOST"] = "BLOGPOST";
    EditedDefinitionScope["ORGANIZATION"] = "ORGANIZATION";
    EditedDefinitionScope["PROJECT"] = "PROJECT";
    return EditedDefinitionScope;
}({});
module.exports["EditedDefinitionScope"] = $8ca9ab19b77d9d33$export$a53c998f5fa685e1;

});

parcelRegister("g7Tm3", function(module, exports) {
var $f98b9dde8f8a6e61$export$f30b281f34822b59 = /*#__PURE__*/ function(CommentRendererLocation) {
    CommentRendererLocation["COMMENTS_PANEL_INLINE"] = "comments-panel-inline";
    CommentRendererLocation["COMMENTS_PANEL_OBJECT"] = "comments-panel-object";
    CommentRendererLocation["STANDALONE_INLINE"] = "standalone-inline";
    CommentRendererLocation["STANDALONE_OBJECT"] = "standalone-object";
    return CommentRendererLocation;
}({});
module.exports["CommentRendererLocation"] = $f98b9dde8f8a6e61$export$f30b281f34822b59;

});

parcelRegister("1TLVx", function(module, exports) {
/* AiSuggestEdit.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-tokens-space */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $4aRua = parcelRequire("4aRua");


var $gC0KQ = parcelRequire("gC0KQ");


var $5avUB = parcelRequire("5avUB");


var $76xix = parcelRequire("76xix");


var $ep3mz = parcelRequire("ep3mz");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");


var $gczDe = parcelRequire("gczDe");


var $epbW8 = parcelRequire("epbW8");


var $fJCU9 = parcelRequire("fJCU9");


var $tch6L = parcelRequire("tch6L");

const $1b60cc241c9d075b$var$i18n = (0, $kSwu1.defineMessages)({
    suggestEdit: {
        id: "ai-suggest-edit.button.label",
        defaultMessage: "Suggest Edit"
    },
    loading: {
        id: "ai-suggest-edit.button.loading",
        defaultMessage: "Suggesting edit..."
    },
    error: {
        id: "ai-suggest-edit.button.error",
        defaultMessage: "Retry suggest edit"
    },
    rovoLoadingAlt: {
        id: "ai-suggest-edit.rovo-loading.alt",
        defaultMessage: "Rovo is processing"
    }
});
// Rainbow border animation keyframes
const $1b60cc241c9d075b$var$animateBorder = null;
const $1b60cc241c9d075b$var$buttonContainerStyle = null; // Rainbow gradient border styles for loading state
const $1b60cc241c9d075b$var$rainbowBorderStyle = null; // CSS property declaration for --angle (needed for the animation)
const $1b60cc241c9d075b$var$anglePropertyStyle = null;
const $1b60cc241c9d075b$var$loadingIconStyle = null; // Style to make the wrapper only as wide as its content
const $1b60cc241c9d075b$var$fitContentStyle = null;
const $1b60cc241c9d075b$var$SuggestEditIcon = ({ isLoading: isLoading, error: error, loadingAlt: loadingAlt })=>{
    if (isLoading) return /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb7vkz _4t3i7vkz"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $76xix.LazyAnimatedRovoIcon), {
        alt: loadingAlt,
        width: "16px",
        height: "16px"
    }));
    if (error) // Icon is decorative - button text provides accessible name
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    });
     // Icon is decorative - button text provides accessible name
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC0KQ))), {
        label: ""
    });
};
const $1b60cc241c9d075b$export$14092fd39e8d9e65 = ({ annotationId: annotationId, annotatedText: annotatedText, commentAdf: commentAdf, commentId: _commentId, contentId: contentIdProp })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isRovoEnabled: isRovoEnabled } = (0, $bQm3c.useSessionData)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = pageContentId || contentIdProp; // IMPORTANT: keep feature gate / experiment usage inline so it remains statically analyzable.
    const { suggestEdit: suggestEdit, isLoading: isLoading, error: error, isSuccess: isSuccess, reset: reset } = (0, $tch6L.useSuggestEdit)({
        contentId: contentId,
        enabled: isRovoEnabled
    }); // Handle successful edit: resolve the inline comment
    (0, $cozmU.useEffect)(()=>{
        if (isSuccess) {
            if (annotationId) {
                const eventEmitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                if (pageMode === (0, $cD1qu.PageMode).VIEW) eventEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_STATE, {
                    [annotationId]: {
                        id: annotationId,
                        annotationType: (0, $epbW8.AnnotationTypes).INLINE_COMMENT,
                        state: (0, $epbW8.AnnotationMarkStates).RESOLVED
                    }
                });
                else eventEmitter.emit('resolve', annotationId);
            }
        }
    }, [
        isSuccess,
        annotationId,
        pageMode
    ]);
    const handleClick = (0, $cozmU.useCallback)(()=>{
        if (isLoading) {
            reset();
            return;
        }
        const commentText = (0, $tch6L.getCommentTextFromAdf)(commentAdf);
        suggestEdit({
            annotatedText: annotatedText,
            commentText: commentText,
            contentId: contentId
        });
    }, [
        annotatedText,
        commentAdf,
        contentId,
        isLoading,
        reset,
        suggestEdit
    ]);
    const loadingAlt = formatMessage($1b60cc241c9d075b$var$i18n.rovoLoadingAlt);
    const renderIcon = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ $cozmU.createElement($1b60cc241c9d075b$var$SuggestEditIcon, {
            isLoading: isLoading,
            error: error,
            loadingAlt: loadingAlt
        }), [
        isLoading,
        error,
        loadingAlt
    ]);
    const isAllowedPageMode = pageMode === (0, $cD1qu.PageMode).LIVE || pageMode === (0, $cD1qu.PageMode).EDIT;
    if (!annotationId || !isAllowedPageMode || !isRovoEnabled || !(0, $6mKj3.expValEquals)('ai-suggested-edits', 'isEnabled', true)) return null;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "aria-live": "polite",
        className: (0, $hekY6.default)([
            "_ca0qu2gc _n3td1b66"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            isLoading && "",
            isLoading && "_2rko12b0 _1rrh1i1e _kqswh2mm _1tes12gs _rfx312b0 _1414yh40 _p7f0yh40 _7gpxyh40 _syayyh40 _1s6kbt9t _16qq1kun _1kt9b3bt _1cs8stnw _12a1epuu _x5brkvto _13sb1p67 _dsq4glyw",
            isLoading && "",
            isLoading && "_1bsb1ns9"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        iconBefore: renderIcon,
        onClick: handleClick,
        testId: "ai-suggest-edit-button"
    }, error && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
        as: "span",
        color: "color.text.danger"
    }, formatMessage($1b60cc241c9d075b$var$i18n.error)), !error && (isLoading ? formatMessage($1b60cc241c9d075b$var$i18n.loading) : formatMessage($1b60cc241c9d075b$var$i18n.suggestEdit)))));
};
module.exports["AiSuggestEdit"] = $1b60cc241c9d075b$export$14092fd39e8d9e65;

});

parcelRegister("tch6L", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jTt8P = parcelRequire("jTt8P");


var $bm4Et = parcelRequire("bm4Et");


var $eDWhq = parcelRequire("eDWhq");


var $9lHB9 = parcelRequire("9lHB9");

const $c831c12a1b3671b1$export$99257a64eb64548c = (commentAdf)=>{
    if (!commentAdf) return '';
    try {
        const doc = JSON.parse(commentAdf);
        const result = [];
        (0, $jTt8P.traverse)(doc, {
            text: (node)=>{
                result.push(node.text || '');
            },
            mention: (node)=>{
                result.push(node.attrs?.text || '');
            },
            emoji: (node)=>{
                result.push(node.attrs?.text || node.attrs?.shortName || '');
            },
            hardBreak: ()=>{
                result.push(' ');
            }
        });
        return result.join('').trim();
    } catch  {
        return '';
    }
};
const $c831c12a1b3671b1$var$initialState = {
    isLoading: false,
    error: null,
    isSuccess: false
};
const $c831c12a1b3671b1$export$d2b578541bb14155 = ({ contentId: contentId, enabled: enabled = true } = {})=>{
    const [state, setState] = (0, $cozmU.useState)($c831c12a1b3671b1$var$initialState);
    const isActiveRef = (0, $cozmU.useRef)(false);
    const contentIdRef = (0, $cozmU.useRef)(contentId);
    // Keep contentIdRef in sync
    (0, $cozmU.useEffect)(()=>{
        contentIdRef.current = contentId;
    }, [
        contentId
    ]);
    const reset = (0, $cozmU.useCallback)(()=>{
        setState($c831c12a1b3671b1$var$initialState);
        isActiveRef.current = false;
    }, []);
    // Use a separate client ID for suggest-edit to avoid conflicting with the editor's bridge registration.
    // The editor registers with getConfluenceEditorClientId(contentId) and handles ContentReadyCommand
    // and ReadContentCommand. We just need to send messages and listen for stream events.
    const suggestEditClientId = (0, $bm4Et.client)(`confluence-suggest-edit-${contentId || 'fallback'}`);
    // Set up bridge API with handlers for streaming lifecycle events
    const { send: send, ready: ready } = (0, $eDWhq.useRovoContentBridgeAPI)(suggestEditClientId, (on)=>{
        // Handle stream completed - edit was successfully applied
        on((0, $9lHB9.RovoStreamCompletedCommand), ()=>{
            if (isActiveRef.current) {
                setState({
                    isLoading: false,
                    error: null,
                    isSuccess: true
                });
                isActiveRef.current = false;
            }
        });
        // Handle stream error - edit failed
        on((0, $9lHB9.RovoStreamErroredCommand), ()=>{
            if (isActiveRef.current) {
                setState({
                    isLoading: false,
                    error: 'Failed to apply edit',
                    isSuccess: false
                });
                isActiveRef.current = false;
            }
        });
        // Handle stream aborted - user cancelled
        on((0, $9lHB9.RovoStreamAbortedCommand), ()=>{
            if (isActiveRef.current) {
                setState({
                    isLoading: false,
                    error: null,
                    isSuccess: false
                });
                isActiveRef.current = false;
            }
        });
    });
    // Mark the client as ready to receive messages just-in-time.
    // This avoids chaining state updates via an effect.
    const hasCalledReadyRef = (0, $cozmU.useRef)(false);
    const suggestEdit = (0, $cozmU.useCallback)(({ annotatedText: annotatedText, commentText: commentText, contentId: paramContentId })=>{
        if (enabled && !hasCalledReadyRef.current) {
            ready();
            hasCalledReadyRef.current = true;
        }
        const effectiveContentId = paramContentId || contentId;
        contentIdRef.current = effectiveContentId;
        // Validate required context - contentId is essential for page context
        if (!effectiveContentId) {
            setState({
                isLoading: false,
                error: 'Missing page context. Unable to suggest edit.',
                isSuccess: false
            });
            return;
        }
        if (!annotatedText) {
            setState({
                isLoading: false,
                error: 'No annotated text found. Unable to suggest edit.',
                isSuccess: false
            });
            return;
        }
        // Set loading state
        setState({
            isLoading: true,
            error: null,
            isSuccess: false
        });
        // Track this request
        isActiveRef.current = true;
        // Build the initial prompt with context about the comment
        const prompt = `Update the document using the ConfluenceCreationTool and fix the content "${annotatedText}"` + `based on the comment: "${commentText}".` + `Only fix the content. ` + `Do not provide your own comment.` + `Do not open up the Rovo chat window. openChat=false.`;
        try {
            send((0, $9lHB9.InlineInputBoxSendMessageCommand), {
                receiverId: (0, $9lHB9.ROVO_CHAT_CLIENT_ID),
                prompt: prompt,
                source: 'CONFLUENCE_COMMENT_FIX',
                productKey: 'confluence',
                deepResearchEnabled: false,
                webSearchEnabled: false,
                contentId: effectiveContentId,
                openChat: false,
                addCurrentPageAsContextUserPreference: true
            });
        } catch (error) {
            setState({
                isLoading: false,
                error: error instanceof Error ? error.message : 'Failed to send message to Rovo',
                isSuccess: false
            });
            isActiveRef.current = false;
        }
    }, [
        send,
        contentId,
        enabled,
        ready
    ]);
    return {
        ...state,
        suggestEdit: suggestEdit,
        reset: reset
    };
};
module.exports["getCommentTextFromAdf"] = $c831c12a1b3671b1$export$99257a64eb64548c;
module.exports["useSuggestEdit"] = $c831c12a1b3671b1$export$d2b578541bb14155;

});

parcelRegister("kYmM6", function(module, exports) {
$parcel$export(module.exports, "EngagementSpotlight", () => $fb284c93f8071f78$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $8lt1a = parcelRequire("8lt1a");


var $cBzEF = parcelRequire("cBzEF");


var $SW3sR = parcelRequire("SW3sR");


var $az1Tm = parcelRequire("az1Tm");


var $ljWtG = parcelRequire("ljWtG");

const $fb284c93f8071f78$var$SpotlightWithVariables = (0, $cBzEF.default)((0, $ljWtG.default));
const $fb284c93f8071f78$export$f57123e11f24bec9 = (0, $SW3sR.default)($fb284c93f8071f78$var$SpotlightWithVariables);
const $fb284c93f8071f78$var$SpotlightWithMessage = (0, $az1Tm.default)($fb284c93f8071f78$export$f57123e11f24bec9, 'spotlight');
function $fb284c93f8071f78$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8lt1a.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fb284c93f8071f78$var$SpotlightWithMessage, props));
}

});

parcelRegister("cBzEF", function(module, exports) {
$parcel$export(module.exports, "default", () => $34e44422bdcc20b3$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $3DoH3 = parcelRequire("3DoH3");

function $34e44422bdcc20b3$export$2e2bcd8739ae039(TargetComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithVariables extends (0, $cozmU.Component) {
        render() {
            const props = $34e44422bdcc20b3$var$runMessagePropsReplacement(this.props);
            if (!props) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(TargetComponent, props);
        }
    }
    WithVariables.displayName = `${TargetComponent.displayName || TargetComponent.name || ''}WithEPVariables`;
    return WithVariables;
}
/**
 * Runs replacement over spotlight message properties.
 * Returns null if replacement fails.
 */ function $34e44422bdcc20b3$var$runMessagePropsReplacement(props) {
    const { variables: variables, ...otherProps } = props;
    const { title: title, body: body, primaryText: primaryText, primaryAction: primaryAction, secondaryText: secondaryText, secondaryAction: secondaryAction } = props;
    const inputs = {
        title: title,
        body: body,
        primaryText: primaryText,
        primaryActionUrl: primaryAction && primaryAction.data && primaryAction.data.url,
        secondaryText: secondaryText,
        secondaryActionUrl: secondaryAction && secondaryAction.data && secondaryAction.data.url
    };
    const replacedInputs = (0, $3DoH3.runTemplateOnInputs)(variables || {}, inputs);
    if (!replacedInputs) return null;
    const outputProps = {
        ...otherProps,
        title: replacedInputs.title,
        body: replacedInputs.body,
        primaryText: replacedInputs.primaryText,
        secondaryText: replacedInputs.secondaryText
    };
    if (primaryAction) outputProps.primaryAction = (0, $3DoH3.rebuildButtonAction)(replacedInputs.primaryActionUrl, primaryAction);
    if (secondaryAction) outputProps.secondaryAction = (0, $3DoH3.rebuildButtonAction)(replacedInputs.secondaryActionUrl, secondaryAction);
    return outputProps;
}

});

parcelRegister("3DoH3", function(module, exports) {

var $5T3fV = parcelRequire("5T3fV");

var $6TKWB = parcelRequire("6TKWB");

function $13e227600b72e49d$export$5d0ec4f796aceeb1(replacedUrl, action) {
    return {
        ...action,
        data: action.data && {
            ...action.data,
            url: replacedUrl
        }
    };
}
function $13e227600b72e49d$export$d808999430a3f186(variables, messageInputs) {
    const keys = Object.keys(messageInputs);
    const output = {};
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const input = messageInputs[key];
        if (input) {
            const isUrl = key === 'primaryActionUrl' || key === 'secondaryActionUrl';
            const replacedInput = isUrl ? (0, $6TKWB.runTemplateForUrl)(input, variables) : (0, $6TKWB.runTemplateForHtml)(input, variables);
            if (replacedInput.type === (0, $5T3fV.REPLACEMENT_ERROR)) return null;
            output[key] = replacedInput.result;
        }
    }
    return output;
}
module.exports["rebuildButtonAction"] = $13e227600b72e49d$export$5d0ec4f796aceeb1;
module.exports["runTemplateOnInputs"] = $13e227600b72e49d$export$d808999430a3f186;

});

parcelRegister("5T3fV", function(module, exports) {
const $cf093fbc3dc23918$export$e26f00bd90899835 = 'success';
const $cf093fbc3dc23918$export$edb46161045fece7 = 'error';
module.exports["REPLACEMENT_ERROR"] = $cf093fbc3dc23918$export$edb46161045fece7;

});

parcelRegister("6TKWB", function(module, exports) {

var $fTjYC = parcelRequire("fTjYC");


var $2EUH3 = parcelRequire("2EUH3");


var $5T3fV = parcelRequire("5T3fV");


var $9cLK6 = parcelRequire("9cLK6");

function $c2fae8ad6770c6bd$export$5d49303889cd00ad(template) {
    const parsedTemplate = (0, $fTjYC.default)(template);
    return (0, $9cLK6.getRequiredVariablesFromTemplate)(parsedTemplate);
}
function $c2fae8ad6770c6bd$export$416b2ef51d91ea20(template, variables) {
    const epTemplate = (0, $fTjYC.default)(template);
    return (0, $2EUH3.replaceForUrl)(epTemplate, variables);
}
function $c2fae8ad6770c6bd$export$5681b97796b74884(template, variables) {
    const epTemplate = (0, $fTjYC.default)(template);
    return (0, $2EUH3.replaceForHtml)(epTemplate, variables);
}
module.exports["runTemplateForUrl"] = $c2fae8ad6770c6bd$export$416b2ef51d91ea20;
module.exports["runTemplateForHtml"] = $c2fae8ad6770c6bd$export$5681b97796b74884;

});

parcelRegister("fTjYC", function(module, exports) {
$parcel$export(module.exports, "default", () => $12ece21e986981f0$export$2e2bcd8739ae039);

var $FbqPD = parcelRequire("FbqPD");

/**
 * This is regular expression to parse double and triple bracket variables.
 * We should replace this with an imperative parser or a library if we want to
 * add more functionality, but this is simple enough as it is.
 *
 * The regular expression is:
 *
 * # Try to match triple bracket variables in a capture group:
 * (
 *   {{{ # Start matching on leading "{{{"
 *     (
 *       # Match on 1+ inner characters
 *       (
 *         # Do negative look-ahead for closing brackets '}}}'.
 *         # Then match on any character. What this means is, match on any
 *         # character that isn't a bracket followed by two other brackets.
 *         # So, first check if we're not at the end of the tag, otherwise
 *         # match.
 *         # Negative look-ahead won't collect the character, just fail if it's
 *         # the triple bracket sequence.
 *         (?!}}}).
 *       )+
 *     ) # Finish `UNESCAPED_GROUP_CONTENTS`, which is our UNESCAPED variable
 *       # name capture group
 *   }}}
 * )
 *
 * | # OR try matching the double bracket variables
 *
 * # The logic is the same, throughout
 * (
 *   {{
 *     (
 *       (
 *         (?!}}).
 *       )+
 *     ) # Finish `ESCAPED_GROUP_CONTENTS`, which is our ESCAPED variable name
 *       # capture group
 *   }}
 * )
 *
 * See https://regex101.com/r/Eo26HD/1 too.
 *
 * Group indexes are named bellow.
 */ const $12ece21e986981f0$var$PARSE_VARIABLES_REGEXP = /({{{(((?!}}}).)+)}}})|({{(((?!}}).)+)}})/g;
const $12ece21e986981f0$var$UNESCAPED_MATCH = 1;
const $12ece21e986981f0$var$UNESCAPED_GROUP_CONTENTS = 2;
const $12ece21e986981f0$var$ESCAPED_GROUP_CONTENTS = 5;
function $12ece21e986981f0$export$2e2bcd8739ae039(template) {
    const parts = (0, $FbqPD.regexpParts)(template, $12ece21e986981f0$var$PARSE_VARIABLES_REGEXP);
    return {
        parts: parts.map((regexpPart)=>{
            if (regexpPart.type === 'text') return regexpPart;
            if (regexpPart.match[$12ece21e986981f0$var$UNESCAPED_MATCH]) return {
                type: 'unescaped',
                variableName: regexpPart.match[$12ece21e986981f0$var$UNESCAPED_GROUP_CONTENTS] || ''
            };
            return {
                type: 'escaped',
                variableName: regexpPart.match[$12ece21e986981f0$var$ESCAPED_GROUP_CONTENTS] || ''
            };
        })
    };
}

});

parcelRegister("FbqPD", function(module, exports) {
function $f585b099cd109431$export$b16d411b3b6d6dff(input, regexp) {
    const allMatches = $f585b099cd109431$export$1ab25a4faafb1ac3(input, regexp);
    const state = allMatches.reduce((memo, matchResult)=>{
        const leadingIndex = matchResult.index || 0;
        const leading = input.slice(memo.currentPosition, leadingIndex);
        if (leading) memo.result.push({
            type: 'text',
            text: leading
        });
        memo.result.push({
            type: 'match',
            match: matchResult
        });
        return {
            currentPosition: leadingIndex + $f585b099cd109431$export$3aff5fb0c83cea11(matchResult),
            result: memo.result
        };
    }, {
        currentPosition: 0,
        result: []
    });
    const trailing = input.slice(state.currentPosition, input.length);
    if (trailing) state.result.push({
        type: 'text',
        text: trailing
    });
    return state.result;
}
function $f585b099cd109431$export$1ab25a4faafb1ac3(input, regexp) {
    const result = [];
    for(let m = regexp.exec(input); m; m = regexp.exec(input))result.push(m);
    return result;
}
function $f585b099cd109431$export$3aff5fb0c83cea11(matchResult) {
    return matchResult[0] ? matchResult[0].length : 0;
}
module.exports["regexpParts"] = $f585b099cd109431$export$b16d411b3b6d6dff;

});

parcelRegister("2EUH3", function(module, exports) {

var $9cLK6 = parcelRequire("9cLK6");


var $ikIHo = parcelRequire("ikIHo");

/**
 * Runs variable validation and if successful calls the provided function and
 * wraps it in a result object, otherwise returns a failure.
 */ function $ae834a27846d8ae4$var$withVariableValidation(template, variables, fn) {
    const requiredKeys = (0, $9cLK6.getRequiredVariablesFromTemplate)(template);
    const missingKeys = requiredKeys.filter((variableName)=>!variables[variableName]);
    if (missingKeys.length) return {
        type: 'error',
        errorType: 'missing-variables-error',
        missingVariables: missingKeys
    };
    return {
        type: 'success',
        result: fn(template, variables)
    };
}
/**
 * Replaces variables onto a template, using the provided escaping function.
 */ function $ae834a27846d8ae4$var$rawReplaceVariables(template, variables, escapeFn) {
    return template.parts.map((templatePart)=>{
        if (templatePart.type === 'text') return templatePart.text;
        if (templatePart.type === 'escaped') return escapeFn(variables[templatePart.variableName]);
        return variables[templatePart.variableName];
    }).join('');
}
/**
 * Without validation, runs a template with URI escaping.
 */ function $ae834a27846d8ae4$var$rawReplaceVariablesForUrl(template, variables) {
    return $ae834a27846d8ae4$var$rawReplaceVariables(template, variables, encodeURIComponent);
}
/**
 * Without validation, runs a template with HTML escaping.
 */ function $ae834a27846d8ae4$var$rawReplaceVariablesForHtml(template, variables) {
    return $ae834a27846d8ae4$var$rawReplaceVariables(template, variables, (0, $ikIHo.default));
}
function $ae834a27846d8ae4$export$d10ae881b12b8ef2(template, variables) {
    return $ae834a27846d8ae4$var$withVariableValidation(template, variables, $ae834a27846d8ae4$var$rawReplaceVariablesForUrl);
}
function $ae834a27846d8ae4$export$ca536300dbd6350(template, variables) {
    return $ae834a27846d8ae4$var$withVariableValidation(template, variables, $ae834a27846d8ae4$var$rawReplaceVariablesForHtml);
}
module.exports["replaceForUrl"] = $ae834a27846d8ae4$export$d10ae881b12b8ef2;
module.exports["replaceForHtml"] = $ae834a27846d8ae4$export$ca536300dbd6350;

});

parcelRegister("9cLK6", function(module, exports) {

var $9rVH1 = parcelRequire("9rVH1");

function $a419bf8a95fc7381$export$bf97a83dc861479c(template) {
    const variableParts = template.parts.filter((part)=>part.type === 'escaped' || part.type === 'unescaped');
    return variableParts;
}
function $a419bf8a95fc7381$export$4a33186abb06007b(template) {
    const variableParts = $a419bf8a95fc7381$export$bf97a83dc861479c(template);
    const variableNames = variableParts.map((part)=>part.variableName);
    return (0, $9rVH1.uniqStrings)(variableNames);
}
module.exports["getRequiredVariablesFromTemplate"] = $a419bf8a95fc7381$export$4a33186abb06007b;

});

parcelRegister("9rVH1", function(module, exports) {
/**
 * Removes duplicate strings from an array.
 */ function $4baa42b9eaed5d48$export$c150c7c1a29f33d8(strings) {
    const ourSet = {};
    for(let i = 0; i < strings.length; i++)ourSet[strings[i]] = null;
    return Object.keys(ourSet);
}
module.exports["uniqStrings"] = $4baa42b9eaed5d48$export$c150c7c1a29f33d8;

});

parcelRegister("ikIHo", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ea26e7ca5d3f216$export$2e2bcd8739ae039);
/**
 * Escapes an HTML string.
 *
 * @param {String} input
 * @return {String}
 */ function $1ea26e7ca5d3f216$export$2e2bcd8739ae039(input) {
    return input.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39');
}

});

parcelRegister("SW3sR", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee887a7f050674ba$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $lzgC6 = parcelRequire("lzgC6");

var $ee887a7f050674ba$export$2e2bcd8739ae039 = (InnerComponent)=>{
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class EngagementEventsWrapper extends (0, $cozmU.Component) {
        UNSAFE_componentWillMount() {
            this.fireEvent('shown');
        }
        componentWillUnmount() {
            this.fireEvent('hidden');
        }
        fireEvent(action, properties = {}) {
            const { createAnalyticsEvent: createAnalyticsEvent, messageId: messageId, variationId: variationId, componentId: componentId, componentType: componentType, isLast: isLast } = this.props;
            const analyticsEvent = createAnalyticsEvent({
                action: action,
                ...properties
            });
            analyticsEvent.update({
                ekMessageId: messageId,
                ekVariationId: variationId,
                ekComponentId: componentId,
                ekComponentType: componentType,
                ekIsLast: isLast
            });
            analyticsEvent.fire('engagement');
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InnerComponent, {
                ...this.props,
                fireClickEvent: this.fireClickEvent
            });
        }
        constructor(...args){
            super(...args);
            this.fireClickEvent = (clickType)=>{
                this.fireEvent('click', {
                    clickType: clickType
                });
            };
        }
    }
    return (0, $lzgC6.default)()(EngagementEventsWrapper);
};

});

parcelRegister("az1Tm", function(module, exports) {
$parcel$export(module.exports, "default", () => $47a0a8b1c9621cae$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");

var $47a0a8b1c9621cae$export$2e2bcd8739ae039 = (InnerComponent, componentType)=>{
    function isTargetComponent(message) {
        return message.componentType === componentType;
    }
    function computeNewState(state) {
        const current = state.current;
        if (current && isTargetComponent(current)) {
            let message;
            switch(current.componentType){
                case 'contextualSurvey':
                    message = {
                        ...current,
                        aaid: state.config.aaid,
                        cloudId: state.config.cloudId,
                        stargateUrl: state.config.stargateUrl,
                        product: state.config.product,
                        orgId: state.config.orgId,
                        workspaceId: state.config.workspaceId
                    };
                    break;
                default:
                    message = current;
            }
            return {
                message: message
            };
        }
        return {
            message: null
        };
    }
    function getComponentType() {
        return componentType;
    }
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class StoreWrapper extends (0, $cozmU.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(StoreWrapperInner, {
                ...this.props,
                context: this.context
            });
        }
        constructor(...args){
            super(...args);
            this.context = void 0;
        }
    }
    StoreWrapper.contextTypes = {
        subscribeEngagementState: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func,
        setComponentConfig: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func
    };
    const StoreWrapperInner = (allProps)=>{
        const { context: context, ...props } = allProps;
        const { children: children, engagementId: engagementId, messageType: messageType, onMessageDisposition: onMessageDisposition } = props;
        const [message, setMessage] = (0, $cozmU.useState)(null);
        const unsubscribeRef = (0, $cozmU.useRef)(null);
        const removeConfigRef = (0, $cozmU.useRef)(null);
        const canSubscribe = (0, $cozmU.useCallback)(()=>{
            return context && !!context?.subscribeEngagementState;
        }, [
            context
        ]);
        const canSetConfig = (0, $cozmU.useCallback)(()=>{
            return context && !!context?.setComponentConfig;
        }, [
            context
        ]);
        const onStoreChange = (0, $cozmU.useCallback)((state)=>{
            setMessage(computeNewState(state).message);
        }, []);
        const subscribeToStore = (0, $cozmU.useCallback)(()=>{
            return context?.subscribeEngagementState?.(onStoreChange);
        }, [
            context,
            onStoreChange
        ]);
        const setChoreographerConfig = (0, $cozmU.useCallback)((propsToUse = props)=>{
            return context?.setComponentConfig?.(getComponentType(), {
                messageType: propsToUse.messageType,
                onMessageDisposition: propsToUse.onMessageDisposition
            }, propsToUse.engagementId);
        }, [
            context,
            props
        ]);
        // Handle initial mount (equivalent to UNSAFE_componentWillMount)
        (0, $cozmU.useEffect)(()=>{
            if (canSubscribe()) unsubscribeRef.current = subscribeToStore() || null;
            if (canSetConfig()) removeConfigRef.current = setChoreographerConfig() || null;
            return ()=>{
                if (unsubscribeRef.current) unsubscribeRef.current();
                if (removeConfigRef.current) removeConfigRef.current();
            };
        }, [
            canSubscribe,
            canSetConfig,
            subscribeToStore,
            setChoreographerConfig
        ]);
        // Handle prop changes (equivalent to UNSAFE_componentWillReceiveProps)
        const previousEngagementId = (0, $cozmU.useRef)(engagementId);
        const previousMessageType = (0, $cozmU.useRef)(messageType);
        const previousOnMessageDisposition = (0, $cozmU.useRef)(onMessageDisposition);
        (0, $cozmU.useEffect)(()=>{
            if (previousEngagementId.current !== engagementId && removeConfigRef.current && canSetConfig()) {
                removeConfigRef.current();
                removeConfigRef.current = setChoreographerConfig(props) || null;
            } else if ((previousMessageType.current !== messageType || previousOnMessageDisposition.current !== onMessageDisposition) && canSetConfig()) setChoreographerConfig(props);
            previousEngagementId.current = engagementId;
            previousMessageType.current = messageType;
            previousOnMessageDisposition.current = onMessageDisposition;
        }, [
            props,
            setChoreographerConfig,
            canSetConfig,
            engagementId,
            messageType,
            onMessageDisposition
        ]);
        if (!message) {
            if (componentType === 'inlineDialog') return children || null;
            return null;
        }
        if (engagementId && message !== null && message.target && engagementId !== message.target) return null;
        const messageKey = `${message.messageId}.${message.variationId}.${message.componentId}`;
        // Key is useful here to make sure that when the currently active
        // messages changes, the old component is unmounted (therefore
        // firing an analytic event for hiding the component) and mounting
        // a new component for the new message (firing a shown event for
        // the new message). Not using key would allow React to apply an
        // optimization that would reuse the current component for a new
        // message which would not call the normal mount and unmount
        // lifecycle methods.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InnerComponent, {
            key: messageKey,
            ...props,
            ...message
        });
    };
    return StoreWrapper;
};

});

parcelRegister("ljWtG", function(module, exports) {
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $jEK83 = parcelRequire("jEK83");


var $cJ0FD = parcelRequire("cJ0FD");


var $bYkMC = parcelRequire("bYkMC");


var $ixfCV = parcelRequire("ixfCV");


var $4aRua = parcelRequire("4aRua");


var $3eYzF = parcelRequire("3eYzF");


var $uyMbP = parcelRequire("uyMbP");


var $gi4qj = parcelRequire("gi4qj");


var $4AC39 = parcelRequire("4AC39");


var $l3ydK = parcelRequire("l3ydK");


var $2Vz7H = parcelRequire("2Vz7H");


var $6VFk2 = parcelRequire("6VFk2");


var $4enp7 = parcelRequire("4enp7");


var $6OwHS = parcelRequire("6OwHS");


var $dOlTT = parcelRequire("dOlTT");


var $2K2hA = parcelRequire("2K2hA");


var $jSxX3 = parcelRequire("jSxX3");


var $6Yblc = parcelRequire("6Yblc");


var $6WiUl = parcelRequire("6WiUl");


var $7W1a8 = parcelRequire("7W1a8");


var $aeF84 = parcelRequire("aeF84");


var $kTn88 = parcelRequire("kTn88");

function $15c742fa8be3ab00$var$_defineProperty(e, r, t) {
    return (r = $15c742fa8be3ab00$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $15c742fa8be3ab00$var$_toPropertyKey(t) {
    var i = $15c742fa8be3ab00$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $15c742fa8be3ab00$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $15c742fa8be3ab00$var$styles = {
    image: "_1bsb1osq"
};
const $15c742fa8be3ab00$export$f14689466e4eca7a = ({ isMigrated: isMigrated = false, ...rest })=>{
    if (isMigrated && (0, $ixfCV.fg)('ads_spotlight_migration_engagekit_ts')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($15c742fa8be3ab00$var$MigratedAkSpotlight, rest);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($15c742fa8be3ab00$var$DeprecatedAkSpotlight, rest);
}; // eslint-disable-next-line @repo/internal/react/no-class-components
class $15c742fa8be3ab00$var$DeprecatedAkSpotlight extends (0, $cozmU.Component) {
    getButtonClickHandler(buttonType, action) {
        const { fireClickEvent: fireClickEvent } = this.props;
        switch(action.type){
            case (0, $7W1a8.buttonActionTypes).LINK:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                    window.open(action.data.url, action.data.target);
                };
            default:
                return ()=>{
                    fireClickEvent(`${buttonType}`);
                };
        }
    }
    getButtonActions() {
        const { primaryAction: primaryAction, primaryText: primaryText, secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
        const actions = [];
        if (secondaryAction && secondaryText) actions.push({
            onClick: this.getButtonClickHandler('secondary', secondaryAction),
            text: secondaryText,
            appearance: secondaryAction.appearance
        });
        if (primaryAction && primaryText) actions.push({
            onClick: this.getButtonClickHandler('primary', primaryAction),
            text: primaryText,
            appearance: primaryAction.appearance,
            autoFocus: true
        });
        return actions;
    }
    render() {
        const { body: body, dialogPlacement: dialogPlacement, dialogWidth: dialogWidth, title: title, image: image, pulse: pulse, target: target, targetBgColor: targetBgColor, targetRadius: targetRadius } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bYkMC.default), {
            actions: this.getButtonActions(),
            dialogPlacement: dialogPlacement,
            dialogWidth: dialogWidth,
            heading: title,
            image: image,
            pulse: pulse,
            target: target,
            targetBgColor: targetBgColor,
            targetRadius: targetRadius
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kTn88.default), {
            html: body
        }));
    }
}
$15c742fa8be3ab00$var$_defineProperty($15c742fa8be3ab00$var$DeprecatedAkSpotlight, "defaultProps", {
    fireClickEvent: (0, (/*@__PURE__*/$parcel$interopDefault($jEK83)))
});
const $15c742fa8be3ab00$var$MigratedAkSpotlight = (props)=>{
    const placement = (0, $aeF84.translations).dialogPlacement(props.dialogPlacement);
    const [isVisible, setIsVisible] = (0, $cozmU.useState)(true);
    const dismiss = (0, $cozmU.useCallback)(()=>{
        setIsVisible(false);
    }, [
        setIsVisible
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dOlTT.PopoverContent), {
        offset: props.offset,
        dismiss: dismiss,
        placement: placement,
        isVisible: isVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gi4qj.SpotlightCard), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6VFk2.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4enp7.SpotlightHeadline), null, props.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AC39.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l3ydK.SpotlightDismissControl), null))), props.image && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OwHS.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: props.image,
        alt: "",
        className: (0, $hekY6.default)([
            $15c742fa8be3ab00$var$styles.image
        ])
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyMbP.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, props.body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Vz7H.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eYzF.SpotlightActions), null, props.secondaryAction && (props.secondaryAction?.type === 'link' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6WiUl.SpotlightSecondaryLink), {
        onClick: dismiss,
        ...props.secondaryAction.data,
        href: props.secondaryAction.data?.url || '',
        target: props.secondaryAction.data?.target
    }, props.secondaryText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Yblc.SpotlightSecondaryAction), {
        onClick: dismiss,
        ...props.secondaryAction.data
    }, props.secondaryText)), props.primaryAction && (props.primaryAction?.type === 'link' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jSxX3.SpotlightPrimaryLink), {
        onClick: dismiss,
        ...props.primaryAction.data,
        href: props.primaryAction.data?.url || '',
        target: props.primaryAction.data?.target
    }, props.primaryText) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2K2hA.SpotlightPrimaryAction), {
        onClick: dismiss,
        ...props.primaryAction.data
    }, props.primaryText))))));
};
var $15c742fa8be3ab00$export$2e2bcd8739ae039 = $15c742fa8be3ab00$export$f14689466e4eca7a;
module.exports["default"] = $15c742fa8be3ab00$export$2e2bcd8739ae039;

});

parcelRegister("jSxX3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $7vK9E = parcelRequire("7vK9E");

var $4aRua = parcelRequire("4aRua");

const $8cb020cd2de9ca14$var$styles = {
    root: "_2rko12b0 _vchhusvi _1e0c1txw _4cvr1h6o _syaz15cr",
    outline: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1dqonqa1 _189ee4h9 _1h6d8yml _18zr12x7 _bfhk1aqn _9oik1r31 _1bnxglyw _jf4cnqa1 _irr31ibz _1nrm1r31 _c2waglyw _1iohnqa1 _1di6of27",
    primary: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1dqonqa1 _189ee4h9 _1h6da755 _18zr12x7 _bfhk1856 _9oik1r31 _1bnxglyw _jf4cnqa1 _irr3hf2y _1nrm1r31 _c2waglyw _1iohnqa1 _1di6g6ey"
};
const $8cb020cd2de9ca14$export$82ba9bc832fb64 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(16);
    const { "aria-label": ariaLabel, onClick: onClick, children: children, testId: testId, appearance: t1, href: href, target: target, rel: rel } = t0;
    const appearance = t1 === undefined ? "outline" : t1;
    const t2 = $8cb020cd2de9ca14$var$styles[appearance];
    let t3;
    if ($[0] !== t2) {
        t3 = (0, $w6R6I.cx)($8cb020cd2de9ca14$var$styles.root, t2);
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== onClick) {
        t4 = onClick ? (e, _analyticsEvent)=>onClick(e) : undefined;
        $[2] = onClick;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== children) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
            as: "span"
        }, children);
        $[4] = children;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== ariaLabel || $[7] !== href || $[8] !== ref || $[9] !== rel || $[10] !== t3 || $[11] !== t4 || $[12] !== t5 || $[13] !== target || $[14] !== testId) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.default), {
            "aria-label": ariaLabel,
            ref: ref,
            testId: testId,
            xcss: t3,
            href: href,
            target: target,
            rel: rel,
            onClick: t4,
            componentName: "SpotlightPrimaryLink"
        }, t5);
        $[6] = ariaLabel;
        $[7] = href;
        $[8] = ref;
        $[9] = rel;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
        $[13] = target;
        $[14] = testId;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
} : ({ 'aria-label': ariaLabel, onClick: onClick, children: children, testId: testId, appearance: appearance = 'outline', href: href, target: target, rel: rel }, ref)=>/*#__PURE__*/ $cozmU.createElement((0, $7vK9E.default), {
        "aria-label": ariaLabel,
        ref: ref,
        testId: testId,
        xcss: (0, $w6R6I.cx)($8cb020cd2de9ca14$var$styles.root, $8cb020cd2de9ca14$var$styles[appearance]),
        href: href,
        target: target,
        rel: rel,
        onClick: onClick ? (e, _analyticsEvent)=>onClick(e) : undefined,
        componentName: "SpotlightPrimaryLink"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
        as: "span"
    }, children)));
module.exports["SpotlightPrimaryLink"] = $8cb020cd2de9ca14$export$82ba9bc832fb64;

});

parcelRegister("6WiUl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7vK9E = parcelRequire("7vK9E");

var $4aRua = parcelRequire("4aRua");

const $3dd4b7177da38ec2$var$styles = {
    root: "_2rko12b0 _4bfu1r31 _1hmsglyw _ajmmnqa1 _18zr12x7 _1rjcv77o _vchhusvi _1e0c1txw _4cvr1h6o _syaz15cr _bfhk1aqn _9oik1r31 _1bnxglyw _jf4cnqa1 _irr31ibz _1nrm1r31 _c2waglyw _1iohnqa1 _1di6of27"
};
const $3dd4b7177da38ec2$export$797d360648cfd970 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(13);
    const { "aria-label": ariaLabel, onClick: onClick, children: children, testId: testId, href: href, target: target, rel: rel } = t0;
    let t1;
    if ($[0] !== onClick) {
        t1 = onClick ? (e, _analyticsEvent)=>onClick(e) : undefined;
        $[0] = onClick;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
            as: "span"
        }, children);
        $[2] = children;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== ariaLabel || $[5] !== href || $[6] !== ref || $[7] !== rel || $[8] !== t1 || $[9] !== t2 || $[10] !== target || $[11] !== testId) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.default), {
            "aria-label": ariaLabel,
            ref: ref,
            testId: testId,
            xcss: $3dd4b7177da38ec2$var$styles.root,
            href: href,
            target: target,
            rel: rel,
            onClick: t1,
            componentName: "SpotlightSecondaryLink"
        }, t2);
        $[4] = ariaLabel;
        $[5] = href;
        $[6] = ref;
        $[7] = rel;
        $[8] = t1;
        $[9] = t2;
        $[10] = target;
        $[11] = testId;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
} : ({ 'aria-label': ariaLabel, onClick: onClick, children: children, testId: testId, href: href, target: target, rel: rel }, ref)=>/*#__PURE__*/ $cozmU.createElement((0, $7vK9E.default), {
        "aria-label": ariaLabel,
        ref: ref,
        testId: testId,
        xcss: $3dd4b7177da38ec2$var$styles.root,
        href: href,
        target: target,
        rel: rel,
        onClick: onClick ? (e, _analyticsEvent)=>onClick(e) : undefined,
        componentName: "SpotlightSecondaryLink"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.default), {
        as: "span"
    }, children)));
module.exports["SpotlightSecondaryLink"] = $3dd4b7177da38ec2$export$797d360648cfd970;

});

parcelRegister("7W1a8", function(module, exports) {
const $57ff06a66745a54c$export$e7d79186651244da = {
    LINK: 'link',
    DISMISS: 'dismiss'
};
module.exports["buttonActionTypes"] = $57ff06a66745a54c$export$e7d79186651244da;

});

parcelRegister("aeF84", function(module, exports) {
const $a5b3f49738f3da96$export$44271b4f0c6a3563 = (value)=>{
    if (!value || value.length === 0) return '';
    /**
   * All of the following are actually invalid in CSS selectors.
   * It's unlikely that a lot of these are actually used as `Spotlight` `name` prop values.
   * If it turns out other characters are used, add them as needed.
   *
   * (space) — descendant combinator
   * > — child combinator
   * + — adjacent sibling combinator
   * ~ — general sibling combinator
   * . — class selector
   * # — ID selector
   * : — pseudo-class/element
   * [ ] — attribute selectors
   * ( ) — functional notation
   * , — selector list separator
   * * — universal selector
   * | — namespace separator
   * " ' — string delimiters
   * \ — escape character
   * Characters not allowed in unescaped identifiers:
   * Digits 0-9 cannot be the first character
   * !, @, $, %, ^, &, =, {, }, ;, /, and most other punctuation
   */ return value.replaceAll(' ', '-').replaceAll('/', '-');
};
const $a5b3f49738f3da96$var$placementMap = {
    'top right': 'top-start',
    'top center': 'top-center',
    'top left': 'top-end',
    'right bottom': 'right-start',
    'right middle': 'right-start',
    'right top': 'right-end',
    'bottom left': 'bottom-end',
    'bottom center': 'bottom-center',
    'bottom right': 'bottom-start',
    'left top': 'left-end',
    'left middle': 'left-start',
    'left bottom': 'left-start'
};
const $a5b3f49738f3da96$export$608d2c28a2f3926e = (value)=>{
    // `bottom left` is the default placement when `undefined` is passed.
    return $a5b3f49738f3da96$var$placementMap[value || 'bottom left'];
};
const $a5b3f49738f3da96$export$150b732325d14d04 = {
    target: $a5b3f49738f3da96$export$44271b4f0c6a3563,
    dialogPlacement: $a5b3f49738f3da96$export$608d2c28a2f3926e
};
module.exports["translations"] = $a5b3f49738f3da96$export$150b732325d14d04;

});

parcelRegister("kTn88", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

class $29867601681dbf75$export$2e2bcd8739ae039 extends (0, $cozmU.PureComponent) {
    render() {
        const { html: html } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
    }
}
module.exports["default"] = $29867601681dbf75$export$2e2bcd8739ae039;

});

parcelRegister("1a6Dn", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");


var $hrAmX = parcelRequire("hrAmX");

class $d3905c2d386f370c$export$c59406a16f2704a5 extends (0, $kNIYN.Container) {
    constructor(...args){
        super(...args);
        this.state = {
            floatingBanners: []
        };
        this.showFloating = (name, height)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index === -1) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray.push({
                    name: name,
                    height: height
                });
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
            else if (this.state.floatingBanners[index].height !== height) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray[index].height = height;
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
        };
        this.hideFloating = (name)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index > -1) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray.splice(index, 1);
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
        };
        this.getFloatingHeightBefore = (name)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index === -1) return 0;
            return this.state.floatingBanners.slice(0, index).reduce((height, banner)=>{
                return height + banner.height;
            }, 0);
        };
        this.getFloatingHeight = ()=>this.state.floatingBanners.reduce((height, banner)=>height + banner.height, 0);
    }
}
module.exports["FloatingBannerStateContainer"] = $d3905c2d386f370c$export$c59406a16f2704a5;

});

parcelRegister("8WfxO", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eSLr0 = parcelRequire("eSLr0");


var $ep3mz = parcelRequire("ep3mz");


var $6mKj3 = parcelRequire("6mKj3");


var $dS3n9 = parcelRequire("dS3n9");

const $720c81ac24834d84$export$dc9cc84753faedac = ()=>{
    const $ = (0, $bDgLe.c)(10);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const atlGeneralHeightChanges = (0, $cozmU.useRef)(t0);
    const [webPanelHeight, setWebPanelHeight] = (0, $cozmU.useState)($720c81ac24834d84$var$_temp);
    const [t1] = (0, $ep3mz.usePageState)();
    const { contentId: contentId, spaceKey: spaceKey } = t1;
    let t2;
    if ($[1] !== contentId || $[2] !== spaceKey) {
        t2 = {
            location: (0, $eSLr0.ATL_GENERAL),
            fetchPolicy: "cache-first",
            spaceKey: spaceKey,
            contentId: contentId
        };
        $[1] = contentId;
        $[2] = spaceKey;
        $[3] = t2;
    } else t2 = $[3];
    const { panels: panels } = (0, $dS3n9.useWebPanelLocation)(t2);
    const isATLGeneralWebPanelFixed = panels.length > 0;
    let t3;
    let t4;
    if ($[4] !== isATLGeneralWebPanelFixed) {
        t3 = ()=>{
            const listener = (e)=>{
                let newHeight;
                if ((0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) {
                    setWebPanelHeight(e?.detail?.height ?? 0);
                    newHeight = e?.detail?.height ?? 0;
                } else {
                    setWebPanelHeight($720c81ac24834d84$var$getAtlGeneralWebPanelHeight());
                    newHeight = $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
                }
                if (typeof window !== "undefined" && Boolean(window.__SSR_RENDERED__)) {
                    const lastHeight = atlGeneralHeightChanges.current.length === 0 ? window.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__ || 0 : atlGeneralHeightChanges.current[atlGeneralHeightChanges.current.length - 1];
                    if (lastHeight !== newHeight) atlGeneralHeightChanges.current.push(newHeight);
                    window.__ATL_GENERAL_WEBPANEL_HEIGHT_CHANGES__ = atlGeneralHeightChanges.current;
                }
            };
            if (isATLGeneralWebPanelFixed) document.addEventListener("atlGeneralWebPanelHeightUpdated", listener);
            return ()=>{
                if (isATLGeneralWebPanelFixed) document.removeEventListener("atlGeneralWebPanelHeightUpdated", listener);
            };
        };
        t4 = [
            isATLGeneralWebPanelFixed
        ];
        $[4] = isATLGeneralWebPanelFixed;
        $[5] = t3;
        $[6] = t4;
    } else {
        t3 = $[5];
        t4 = $[6];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[7] !== isATLGeneralWebPanelFixed || $[8] !== webPanelHeight) {
        t5 = {
            isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed,
            atlGeneralWebPanelHeight: webPanelHeight
        };
        $[7] = isATLGeneralWebPanelFixed;
        $[8] = webPanelHeight;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
};
const $720c81ac24834d84$var$getAtlGeneralWebPanelHeight = ()=>{
    if (typeof document === 'undefined') return 0;
    return parseInt(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    getComputedStyle(document.documentElement).getPropertyValue('--atl-general-webpanel-height')) || 0;
};
function $720c81ac24834d84$var$_temp() {
    if (typeof window !== "undefined" && Boolean(window.__SSR_RENDERED__) && (0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) {
        const initialHeight = window.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__;
        return initialHeight ?? 0;
    } else return $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
}
module.exports["useATLGeneralWebPanelListener"] = $720c81ac24834d84$export$dc9cc84753faedac;

});

parcelRegister("dS3n9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $jMyy4 = parcelRequire("jMyy4");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $eSLr0 = parcelRequire("eSLr0");


var $9Z1sw = parcelRequire("9Z1sw");

const $9fffd50bbcc7c343$export$c8daa7260f75e213 = ({ spaceKey: spaceKey, contentId: contentId, location: location, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', onCompleted: onCompleted })=>{
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    const spaceIdentifier = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, 'spaceKey') || (0, $c3Qwv.getSingleParam)(queryParams, 'key');
    const contentIdentifier = contentId || (0, $c3Qwv.getSingleParam)(queryParams, 'pageId');
    const variables = contentIdentifier ? {
        contentId: contentIdentifier,
        location: location
    } : {
        spaceKey: spaceIdentifier,
        location: location
    };
    const batchResult = (0, $9Z1sw.useWebPanelLocationBatchResult)(location);
    const batchResultData = batchResult?.data;
    const batchResultError = batchResult?.error;
    const batchResultLoading = batchResult?.loading;
    const completedBatchResultKeyRef = (0, $cozmU.useRef)(null);
    const baseOptions = {
        variables: variables,
        skip: Boolean(batchResult),
        ...onCompleted && {
            onCompleted: onCompleted
        }
    };
    const useNoFurtherUpdate = location !== (0, $eSLr0.DASHBOARD_SECONDARY) && // Keep watching query for home route to avoid VC90 regression
    (0, $6mKj3.expValEquals)('confluence_stop_watching_webpanellocationquery', 'isEnabled', true);
    const { loading: loading, data: data, error: error } = useNoFurtherUpdate ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        __callerPackage__: "web-panel-location"
    }) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: fetchPolicy,
        __callerPackage__: "web-panel-location"
    });
    const result = batchResult ?? {
        loading: loading,
        data: data,
        error: error
    };
    (0, $cozmU.useEffect)(()=>{
        if (batchResultLoading || batchResultError || !batchResultData || !onCompleted) return;
        const batchResultKey = `${contentIdentifier || ''}:${spaceIdentifier || ''}:${location}`;
        if (completedBatchResultKeyRef.current !== batchResultKey) {
            completedBatchResultKeyRef.current = batchResultKey;
            onCompleted();
        }
    }, [
        batchResultData,
        batchResultError,
        batchResultLoading,
        contentIdentifier,
        location,
        onCompleted,
        spaceIdentifier
    ]);
    const panels = (result.data?.webPanels || []).filter((panel)=>panel);
    return {
        panels: panels,
        loading: result.loading,
        error: result.error
    };
};
module.exports["useWebPanelLocation"] = $9fffd50bbcc7c343$export$c8daa7260f75e213;

});

parcelRegister("7VJPz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6B1vK = parcelRequire("6B1vK");

var $aBKty = parcelRequire("aBKty");


var $aJPUt = parcelRequire("aJPUt");


var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");


var $au7xi = parcelRequire("au7xi");


var $1lyRS = parcelRequire("1lyRS");

const $cd53535796fd282e$export$16ffa5f7b88dc45f = ({ contentId: contentId, contentType: contentType, cloudId: cloudId })=>{
    const extensionHandlers = {};
    extensionHandlers[0, $au7xi.smartButtonExtensionType] = (extension)=>{
        const pageAri = contentId ? (0, $6B1vK.ConfluencePageAri).create({
            siteId: cloudId,
            pageId: contentId
        }).toString() : undefined;
        const site = (0, $aBKty.ConfluenceSiteAri).create({
            siteId: cloudId
        }).toString();
        const experienceName = (0, $5kjCz.getExperienceName)((0, $5kjCz.RENDERER), extension);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4KFTW.MacroExperienceStart), {
            name: experienceName,
            contentId: contentId ?? '',
            mode: (0, $5kjCz.RENDERER),
            extensionKey: extension.extensionKey,
            attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(extension),
            timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1lyRS.SmartButtonLoader), {
            ruleId: extension.parameters?.ruleId,
            scopeId: extension.parameters?.scopeId,
            pageAri: pageAri,
            site: site,
            smartButtonName: extension.parameters?.smartButtonName,
            experienceTrackerName: experienceName,
            contentId: contentId ?? '',
            contentType: contentType ?? '',
            isViewMode: true
        }));
    };
    return extensionHandlers;
};
module.exports["getRendererSmartButtonExtensionHandlers"] = $cd53535796fd282e$export$16ffa5f7b88dc45f;

});

parcelRegister("1lyRS", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $16e92128cf9491a8$export$32d8d71ddecea49c = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "LmILK",
    name: "SmartButtonLoader",
    loader: async ()=>(await (parcelRequire("brLDq"))).SmartButton
});
module.exports["SmartButtonLoader"] = $16e92128cf9491a8$export$32d8d71ddecea49c;

});

parcelRegister("brLDq", function(module, exports) {

let $85572a9f7ba15616$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $85572a9f7ba15616$var$load("lbsQO"),
    $85572a9f7ba15616$var$load("7TnhR"),
    $85572a9f7ba15616$var$load("6wr18"),
    $85572a9f7ba15616$var$load("2xKrc"),
    $85572a9f7ba15616$var$load("ffEVr"),
    $85572a9f7ba15616$var$load("hhss7"),
    $85572a9f7ba15616$var$load("lhkXg")
]).then(()=>parcelRequire('hLSQl'));

});

parcelRegister("cfM7x", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $090373eba5349880$export$49e1053dfc41d188 = /*#__PURE__*/ (0, $cozmU.createContext)({
    // AI and Company Hub
    isCompanyHub: true,
    isAdminHubAIEnabled: false,
    enableLinkInputInMediaPicker: false,
    helpCenterAri: '',
    showConfigPreambleSupportLink: false,
    // Shortcuts
    shortcutListener: undefined,
    // Smart cards
    smartCardProviderComponent: undefined,
    // Custom search configuration
    orgId: '',
    userId: '',
    searchConfigProvider: {
        peopleDirectoryUrl: '',
        advancedSearchUrl: '',
        searchSessionId: ''
    },
    displayName: '',
    // Theming
    isSSRProductInDarkMode: undefined,
    branding: undefined,
    hideExtensionBorders: false,
    // Feedback collection
    useFeedbackCollector: undefined,
    // Media providers
    cloudId: '',
    useMediaConfig: undefined,
    createEditorMediaProvider: ()=>Promise.resolve({
            viewMediaClientConfig: {
                authProvider: async ()=>({})
            },
            uploadMediaClientConfig: {
                authProvider: async ()=>({})
            }
        }),
    // Error handling
    submitError: ()=>{},
    markErrorAsHandled: ()=>{},
    errorDisplayComponent: ()=>null,
    errorBoundaryComponent: undefined,
    // Premium upsells
    ConfigUpsellScreen: undefined,
    // Experience tracking
    mediaUploadExperienceTracker: undefined,
    aiDescriptionExperienceTracker: undefined,
    experienceSuccessComponent: ()=>null,
    experienceStopComponent: ()=>null,
    experienceStartComponent: ()=>null,
    // Analytics
    analyticsContext: {},
    // User segmentation
    useSegmentationTargetGroups: ()=>{},
    isTargetAudience: ()=>false,
    // Link picker configuration
    linkPickerConfig: {},
    enableTargeting: false,
    enableUnifiedSearchFeatures: false,
    enableSmartCardsFields: false
});
const $090373eba5349880$export$774887fcc3922763 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    const defaultValue = (0, $cozmU.useContext)($090373eba5349880$export$49e1053dfc41d188);
    let t1;
    if ($[3] !== defaultValue || $[4] !== props) {
        t1 = {
            ...defaultValue,
            ...props
        };
        $[3] = defaultValue;
        $[4] = props;
        $[5] = t1;
    } else t1 = $[5];
    const value = t1;
    let t2;
    if ($[6] !== children || $[7] !== value) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($090373eba5349880$export$49e1053dfc41d188.Provider, {
            value: value
        }, children);
        $[6] = children;
        $[7] = value;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ children: children, ...props })=>{
    const defaultValue = (0, $cozmU.useContext)($090373eba5349880$export$49e1053dfc41d188);
    const value = {
        ...defaultValue,
        ...props
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($090373eba5349880$export$49e1053dfc41d188.Provider, {
        value: value
    }, children);
};
const $090373eba5349880$export$8dcbb40932065737 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useProductDependencies() {
    const ctx = (0, $cozmU.useContext)($090373eba5349880$export$49e1053dfc41d188);
    if (!ctx) throw new Error("useProductDependencies must be used within ProductDependenciesProvider");
    return ctx;
} : function useProductDependencies() {
    const ctx = (0, $cozmU.useContext)($090373eba5349880$export$49e1053dfc41d188);
    if (!ctx) throw new Error('useProductDependencies must be used within ProductDependenciesProvider');
    return ctx;
};
module.exports["ProductDependenciesContext"] = $090373eba5349880$export$49e1053dfc41d188;
module.exports["useProductDependencies"] = $090373eba5349880$export$8dcbb40932065737;

});

parcelRegister("hUS75", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $5kjCz = parcelRequire("5kjCz");


var $2bAZx = parcelRequire("2bAZx");

function $50ff55d614a641f6$export$720dc4209419df4e(name, error, mode, contentId, attributes, source) {
    if ((0, $6fil2.containsNetworkError)(error)) {
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).abort({
            name: name,
            reason: `Aborted ${name} because of network error: ${error.toString()}`,
            checkForTimeout: false,
            attributes: {
                ...attributes,
                source: source
            }
        });
        return;
    }
    (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
        name: name,
        error: error,
        attributes: {
            ...attributes,
            source: source
        }
    });
}
function $50ff55d614a641f6$export$d22b49804594ed4d({ attributes: attributes, children: children = null, error: error, contentId: contentId, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        if (error) $50ff55d614a641f6$export$720dc4209419df4e(name, error, mode, contentId, attributes, source);
        else (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: name,
            attributes: attributes
        });
    }, [
        attributes,
        contentId,
        error,
        mode,
        name,
        source
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceStop"] = $50ff55d614a641f6$export$d22b49804594ed4d;

});

parcelRegister("lOeVN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8aF6s = parcelRequire("8aF6s");


var $jmjWc = parcelRequire("jmjWc");

function $926167cc1656a619$export$4be696be8a3bff13(props) {
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const propsRef = (0, $cozmU.useRef)();
    propsRef.current = props;
    return (0, $cozmU.useCallback)(()=>showModal($926167cc1656a619$var$FeedbackCollectorLoader, propsRef.current), [
        showModal
    ]);
}

const $926167cc1656a619$var$FeedbackCollectorLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "nSIir",
    name: "FeedbackCollectorLoader",
    loader: async ()=>(await (parcelRequire("dt78c"))).FeedbackCollector
});
module.exports["useFeedbackCollector"] = $926167cc1656a619$export$4be696be8a3bff13;

});

parcelRegister("dt78c", function(module, exports) {

let $9ce383e3aa6e7c1b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9ce383e3aa6e7c1b$var$load("6wr18"),
    $9ce383e3aa6e7c1b$var$load("ffEVr"),
    $9ce383e3aa6e7c1b$var$load("hhss7"),
    $9ce383e3aa6e7c1b$var$load("7gL7H"),
    $9ce383e3aa6e7c1b$var$load("kHXvF"),
    $9ce383e3aa6e7c1b$var$load("bUC6C")
]).then(()=>parcelRequire('cz7bE'));

});

parcelRegister("gH7sg", function(module, exports) {
const $0aaa27c2ee4953f8$export$12cc65019788286c = {
    photorealistic: 'photorealistic',
    abstract: 'abstract',
    watercolors: 'watercolors',
    graphic_design: 'graphic_design',
    landscape: 'landscape',
    sketch: 'sketch',
    threeD: 'v2_claymorphism'
};
const $0aaa27c2ee4953f8$export$607fdde54add7f63 = {
    auto: 'auto',
    fast: 'fast',
    high: 'high',
    max: 'max'
};
module.exports["IMAGE_GENERATION_THEMES"] = $0aaa27c2ee4953f8$export$12cc65019788286c;
module.exports["IMAGE_GENERATION_MODELS"] = $0aaa27c2ee4953f8$export$607fdde54add7f63;

});

parcelRegister("eLV9q", function(module, exports) {
$parcel$export(module.exports, "useGetNavigateToTeamsApp", () => (parcelRequire("eWzPA")).useGetNavigateToTeamsApp);

var $eWzPA = parcelRequire("eWzPA");


});

parcelRegister("eWzPA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $eW61a = parcelRequire("eW61a");


var $bQm3c = parcelRequire("bQm3c");

const $8c3fac113683eb0d$export$bb1230c0e6efa9dc = ()=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const getNavigateToTeamsApp = (navActionPayload, shouldOpenInSameTab)=>{
        return (0, $eW61a.navigateToTeamsApp)({
            hostProduct: 'confluence',
            orgId: orgId,
            cloudId: cloudId,
            userHasNav4Enabled: true,
            shouldOpenInSameTab: shouldOpenInSameTab,
            ...navActionPayload
        });
    };
    return (0, $cozmU.useCallback)(getNavigateToTeamsApp, [
        cloudId,
        orgId
    ]);
};
module.exports["useGetNavigateToTeamsApp"] = $8c3fac113683eb0d$export$bb1230c0e6efa9dc;

});

parcelRegister("1SPMi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3d3WW = parcelRequire("3d3WW");


var $iTJtk = parcelRequire("iTJtk");


var $bQm3c = parcelRequire("bQm3c");


var $2SowE = parcelRequire("2SowE");

const $c749b0358b0b3fb9$export$46da93e796378064 = (props)=>{
    const { objectId: objectId, objectType: objectType, children: children, source: source } = props;
    // setting default to development so in tests it doesn't fail due to being undefined
    const { environment: environment } = (0, $bQm3c.useSessionData)() || {};
    // setting default to development so in tests it doesn't fail due to being undefined
    const safeEnvironment = environment || 'DEVELOPMENT';
    const handleEvent = (0, $cozmU.useCallback)((event)=>{
        const instanceName = safeEnvironment;
        event.update((payload)=>{
            let newPayload = (0, $2SowE.extendPayloadAttributes)(payload, {
                objectId: objectId,
                objectType: objectType,
                rendererSource: source
            });
            if (instanceName) newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, {
                instance: instanceName
            });
            return newPayload;
        });
    }, [
        safeEnvironment,
        objectId,
        objectType,
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: handleEvent,
        channel: (0, $iTJtk.FabricChannel).editor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: handleEvent,
        channel: (0, $iTJtk.FabricChannel).media
    }, children));
};
module.exports["RendererAnalyticsListener"] = $c749b0358b0b3fb9$export$46da93e796378064;

});

parcelRegister("13PMQ", function(module, exports) {
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $0c5e3e04f495ba65$var$ch2 = {};
var $0c5e3e04f495ba65$var$wk = function(c, id, msg, transfer, cb) {
    var w = new Worker($0c5e3e04f495ba65$var$ch2[id] || ($0c5e3e04f495ba65$var$ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: 'text/javascript'
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $0c5e3e04f495ba65$var$u8 = Uint8Array, $0c5e3e04f495ba65$var$u16 = Uint16Array, $0c5e3e04f495ba65$var$i32 = Int32Array;
// fixed length extra bits
var $0c5e3e04f495ba65$var$fleb = new $0c5e3e04f495ba65$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
var $0c5e3e04f495ba65$var$fdeb = new $0c5e3e04f495ba65$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $0c5e3e04f495ba65$var$clim = new $0c5e3e04f495ba65$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $0c5e3e04f495ba65$var$freb = function(eb, start) {
    var b = new $0c5e3e04f495ba65$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $0c5e3e04f495ba65$var$i32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return {
        b: b,
        r: r
    };
};
var $0c5e3e04f495ba65$var$_a = $0c5e3e04f495ba65$var$freb($0c5e3e04f495ba65$var$fleb, 2), $0c5e3e04f495ba65$var$fl = $0c5e3e04f495ba65$var$_a.b, $0c5e3e04f495ba65$var$revfl = $0c5e3e04f495ba65$var$_a.r;
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$0c5e3e04f495ba65$var$fl[28] = 258, $0c5e3e04f495ba65$var$revfl[258] = 28;
var $0c5e3e04f495ba65$var$_b = $0c5e3e04f495ba65$var$freb($0c5e3e04f495ba65$var$fdeb, 0), $0c5e3e04f495ba65$var$fd = $0c5e3e04f495ba65$var$_b.b, $0c5e3e04f495ba65$var$revfd = $0c5e3e04f495ba65$var$_b.r;
// map of value to reverse (assuming 16 bits)
var $0c5e3e04f495ba65$var$rev = new $0c5e3e04f495ba65$var$u16(32768);
for(var $0c5e3e04f495ba65$var$i = 0; $0c5e3e04f495ba65$var$i < 32768; ++$0c5e3e04f495ba65$var$i){
    // reverse table algorithm from SO
    var $0c5e3e04f495ba65$var$x = ($0c5e3e04f495ba65$var$i & 0xAAAA) >> 1 | ($0c5e3e04f495ba65$var$i & 0x5555) << 1;
    $0c5e3e04f495ba65$var$x = ($0c5e3e04f495ba65$var$x & 0xCCCC) >> 2 | ($0c5e3e04f495ba65$var$x & 0x3333) << 2;
    $0c5e3e04f495ba65$var$x = ($0c5e3e04f495ba65$var$x & 0xF0F0) >> 4 | ($0c5e3e04f495ba65$var$x & 0x0F0F) << 4;
    $0c5e3e04f495ba65$var$rev[$0c5e3e04f495ba65$var$i] = (($0c5e3e04f495ba65$var$x & 0xFF00) >> 8 | ($0c5e3e04f495ba65$var$x & 0x00FF) << 8) >> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $0c5e3e04f495ba65$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $0c5e3e04f495ba65$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $0c5e3e04f495ba65$var$u16(mb);
    for(i = 1; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $0c5e3e04f495ba65$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$0c5e3e04f495ba65$var$rev[v] >> rvb] = sv;
        }
    } else {
        co = new $0c5e3e04f495ba65$var$u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = $0c5e3e04f495ba65$var$rev[le[cd[i] - 1]++] >> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $0c5e3e04f495ba65$var$flt = new $0c5e3e04f495ba65$var$u8(288);
for(var $0c5e3e04f495ba65$var$i = 0; $0c5e3e04f495ba65$var$i < 144; ++$0c5e3e04f495ba65$var$i)$0c5e3e04f495ba65$var$flt[$0c5e3e04f495ba65$var$i] = 8;
for(var $0c5e3e04f495ba65$var$i = 144; $0c5e3e04f495ba65$var$i < 256; ++$0c5e3e04f495ba65$var$i)$0c5e3e04f495ba65$var$flt[$0c5e3e04f495ba65$var$i] = 9;
for(var $0c5e3e04f495ba65$var$i = 256; $0c5e3e04f495ba65$var$i < 280; ++$0c5e3e04f495ba65$var$i)$0c5e3e04f495ba65$var$flt[$0c5e3e04f495ba65$var$i] = 7;
for(var $0c5e3e04f495ba65$var$i = 280; $0c5e3e04f495ba65$var$i < 288; ++$0c5e3e04f495ba65$var$i)$0c5e3e04f495ba65$var$flt[$0c5e3e04f495ba65$var$i] = 8;
// fixed distance tree
var $0c5e3e04f495ba65$var$fdt = new $0c5e3e04f495ba65$var$u8(32);
for(var $0c5e3e04f495ba65$var$i = 0; $0c5e3e04f495ba65$var$i < 32; ++$0c5e3e04f495ba65$var$i)$0c5e3e04f495ba65$var$fdt[$0c5e3e04f495ba65$var$i] = 5;
// fixed length map
var $0c5e3e04f495ba65$var$flm = /*#__PURE__*/ $0c5e3e04f495ba65$var$hMap($0c5e3e04f495ba65$var$flt, 9, 0), $0c5e3e04f495ba65$var$flrm = /*#__PURE__*/ $0c5e3e04f495ba65$var$hMap($0c5e3e04f495ba65$var$flt, 9, 1);
// fixed distance map
var $0c5e3e04f495ba65$var$fdm = /*#__PURE__*/ $0c5e3e04f495ba65$var$hMap($0c5e3e04f495ba65$var$fdt, 5, 0), $0c5e3e04f495ba65$var$fdrm = /*#__PURE__*/ $0c5e3e04f495ba65$var$hMap($0c5e3e04f495ba65$var$fdt, 5, 1);
// find max of array
var $0c5e3e04f495ba65$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $0c5e3e04f495ba65$var$bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $0c5e3e04f495ba65$var$bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var $0c5e3e04f495ba65$var$shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $0c5e3e04f495ba65$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    return new $0c5e3e04f495ba65$var$u8(v.subarray(s, e));
};
var $0c5e3e04f495ba65$export$ae5516a5a74c19a8 = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var $0c5e3e04f495ba65$var$ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
];
var $0c5e3e04f495ba65$var$err = function(ind, msg, nt) {
    var e = new Error(msg || $0c5e3e04f495ba65$var$ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, $0c5e3e04f495ba65$var$err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var $0c5e3e04f495ba65$var$inflt = function(dat, st, buf, dict) {
    // source length       dict length
    var sl = dat.length, dl = dict ? dict.length : 0;
    if (!sl || st.f && !st.l) return buf || new $0c5e3e04f495ba65$var$u8(0);
    var noBuf = !buf;
    // have to estimate size
    var resize = noBuf || st.i != 2;
    // no state
    var noSt = st.i;
    // Assumes roughly 33% compression ratio average
    if (noBuf) buf = new $0c5e3e04f495ba65$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $0c5e3e04f495ba65$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = $0c5e3e04f495ba65$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $0c5e3e04f495ba65$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $0c5e3e04f495ba65$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) $0c5e3e04f495ba65$var$err(0);
                    break;
                }
                // ensure size
                if (resize) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = $0c5e3e04f495ba65$var$flrm, dm = $0c5e3e04f495ba65$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $0c5e3e04f495ba65$var$bits(dat, pos, 31) + 257, hcLen = $0c5e3e04f495ba65$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $0c5e3e04f495ba65$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $0c5e3e04f495ba65$var$u8(tl);
                // code length tree
                var clt = new $0c5e3e04f495ba65$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$0c5e3e04f495ba65$var$clim[i]] = $0c5e3e04f495ba65$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $0c5e3e04f495ba65$var$max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = $0c5e3e04f495ba65$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$0c5e3e04f495ba65$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $0c5e3e04f495ba65$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $0c5e3e04f495ba65$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $0c5e3e04f495ba65$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $0c5e3e04f495ba65$var$max(lt);
                // max dist bits
                dbt = $0c5e3e04f495ba65$var$max(dt);
                lm = $0c5e3e04f495ba65$var$hMap(lt, lbt, 1);
                dm = $0c5e3e04f495ba65$var$hMap(dt, dbt, 1);
            } else $0c5e3e04f495ba65$var$err(1);
            if (pos > tbts) {
                if (noSt) $0c5e3e04f495ba65$var$err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17
        if (resize) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[$0c5e3e04f495ba65$var$bits16(dat, pos) & lms], sym = c >> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) $0c5e3e04f495ba65$var$err(0);
                break;
            }
            if (!c) $0c5e3e04f495ba65$var$err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $0c5e3e04f495ba65$var$fleb[i];
                    add = $0c5e3e04f495ba65$var$bits(dat, pos, (1 << b) - 1) + $0c5e3e04f495ba65$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$0c5e3e04f495ba65$var$bits16(dat, pos) & dms], dsym = d >> 4;
                if (!d) $0c5e3e04f495ba65$var$err(3);
                pos += d & 15;
                var dt = $0c5e3e04f495ba65$var$fd[dsym];
                if (dsym > 3) {
                    var b = $0c5e3e04f495ba65$var$fdeb[dsym];
                    dt += $0c5e3e04f495ba65$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) $0c5e3e04f495ba65$var$err(0);
                    break;
                }
                if (resize) cbuf(bt + 131072);
                var end = bt + add;
                if (bt < dt) {
                    var shift = dl - dt, dend = Math.min(dt, end);
                    if (shift + bt < 0) $0c5e3e04f495ba65$var$err(3);
                    for(; bt < dend; ++bt)buf[bt] = dict[shift + bt];
                }
                for(; bt < end; ++bt)buf[bt] = buf[bt - dt];
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    // don't reallocate for streams or user buffers
    return bt != buf.length && noBuf ? $0c5e3e04f495ba65$var$slc(buf, 0, bt) : buf.subarray(0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $0c5e3e04f495ba65$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $0c5e3e04f495ba65$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
    d[o + 2] |= v >> 16;
};
// creates code lengths from a frequency table
var $0c5e3e04f495ba65$var$hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return {
        t: $0c5e3e04f495ba65$var$et,
        l: 0
    };
    if (s == 1) {
        var v = new $0c5e3e04f495ba65$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return {
            t: v,
            l: 1
        };
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $0c5e3e04f495ba65$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $0c5e3e04f495ba65$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return {
        t: new $0c5e3e04f495ba65$var$u8(tr),
        l: mbt
    };
};
// get the max length and assign length codes
var $0c5e3e04f495ba65$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($0c5e3e04f495ba65$var$ln(n.l, l, d + 1), $0c5e3e04f495ba65$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $0c5e3e04f495ba65$var$lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $0c5e3e04f495ba65$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return {
        c: cl.subarray(0, cli),
        n: s
    };
};
// calculate the length of output from tree, code lengths
var $0c5e3e04f495ba65$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $0c5e3e04f495ba65$var$wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $0c5e3e04f495ba65$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $0c5e3e04f495ba65$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $0c5e3e04f495ba65$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $0c5e3e04f495ba65$var$hTree(lf, 15), dlt = _a.t, mlb = _a.l;
    var _b = $0c5e3e04f495ba65$var$hTree(df, 15), ddt = _b.t, mdb = _b.l;
    var _c = $0c5e3e04f495ba65$var$lc(dlt), lclt = _c.c, nlc = _c.n;
    var _d = $0c5e3e04f495ba65$var$lc(ddt), lcdt = _d.c, ndc = _d.n;
    var lcfreq = new $0c5e3e04f495ba65$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)++lcfreq[lclt[i] & 31];
    for(var i = 0; i < lcdt.length; ++i)++lcfreq[lcdt[i] & 31];
    var _e = $0c5e3e04f495ba65$var$hTree(lcfreq, 7), lct = _e.t, mlcb = _e.l;
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$0c5e3e04f495ba65$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $0c5e3e04f495ba65$var$clen(lf, $0c5e3e04f495ba65$var$flt) + $0c5e3e04f495ba65$var$clen(df, $0c5e3e04f495ba65$var$fdt) + eb;
    var dtlen = $0c5e3e04f495ba65$var$clen(lf, dlt) + $0c5e3e04f495ba65$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $0c5e3e04f495ba65$var$clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
    if (bs >= 0 && flen <= ftlen && flen <= dtlen) return $0c5e3e04f495ba65$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $0c5e3e04f495ba65$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $0c5e3e04f495ba65$var$hMap(dlt, mlb, 0), ll = dlt, dm = $0c5e3e04f495ba65$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $0c5e3e04f495ba65$var$hMap(lct, mlcb, 0);
        $0c5e3e04f495ba65$var$wbits(out, p, nlc - 257);
        $0c5e3e04f495ba65$var$wbits(out, p + 5, ndc - 1);
        $0c5e3e04f495ba65$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$0c5e3e04f495ba65$var$wbits(out, p + 3 * i, lct[$0c5e3e04f495ba65$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $0c5e3e04f495ba65$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $0c5e3e04f495ba65$var$wbits(out, p, clct[i] >> 5 & 127), p += clct[i] >> 12;
            }
        }
    } else lm = $0c5e3e04f495ba65$var$flm, ll = $0c5e3e04f495ba65$var$flt, dm = $0c5e3e04f495ba65$var$fdm, dl = $0c5e3e04f495ba65$var$fdt;
    for(var i = 0; i < li; ++i){
        var sym = syms[i];
        if (sym > 255) {
            var len = sym >> 18 & 31;
            $0c5e3e04f495ba65$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7) $0c5e3e04f495ba65$var$wbits(out, p, sym >> 23 & 31), p += $0c5e3e04f495ba65$var$fleb[len];
            var dst = sym & 31;
            $0c5e3e04f495ba65$var$wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3) $0c5e3e04f495ba65$var$wbits16(out, p, sym >> 5 & 8191), p += $0c5e3e04f495ba65$var$fdeb[dst];
        } else $0c5e3e04f495ba65$var$wbits16(out, p, lm[sym]), p += ll[sym];
    }
    $0c5e3e04f495ba65$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $0c5e3e04f495ba65$var$deo = /*#__PURE__*/ new $0c5e3e04f495ba65$var$i32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $0c5e3e04f495ba65$var$et = /*#__PURE__*/ new $0c5e3e04f495ba65$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $0c5e3e04f495ba65$var$dflt = function(dat, lvl, plvl, pre, post, st) {
    var s = st.z || dat.length;
    var o = new $0c5e3e04f495ba65$var$u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var lst = st.l;
    var pos = (st.r || 0) & 7;
    if (lvl) {
        if (pos) w[0] = st.r >> 3;
        var opt = $0c5e3e04f495ba65$var$deo[lvl - 1];
        var n = opt >> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = st.p || new $0c5e3e04f495ba65$var$u16(32768), head = st.h || new $0c5e3e04f495ba65$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $0c5e3e04f495ba65$var$i32(25000);
        // length/literal freq   distance freq
        var lf = new $0c5e3e04f495ba65$var$u16(288), df = new $0c5e3e04f495ba65$var$u16(32);
        //  l/lcnt  exbits  index          l/lind  waitdx          blkpos
        var lc_1 = 0, eb = 0, i = st.i || 0, li = 0, wi = st.w || 0, bs = 0;
        for(; i + 2 < s; ++i){
            // hash value
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && (rem > 423 || !lst)) {
                    pos = $0c5e3e04f495ba65$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one int32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $0c5e3e04f495ba65$var$revfl[l] << 18 | $0c5e3e04f495ba65$var$revfd[d];
                    var lin = $0c5e3e04f495ba65$var$revfl[l] & 31, din = $0c5e3e04f495ba65$var$revfd[d] & 31;
                    eb += $0c5e3e04f495ba65$var$fleb[lin] + $0c5e3e04f495ba65$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        for(i = Math.max(i, wi); i < s; ++i){
            syms[li++] = dat[i];
            ++lf[dat[i]];
        }
        pos = $0c5e3e04f495ba65$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        if (!lst) {
            st.r = pos & 7 | w[pos / 8 | 0] << 3;
            // shft(pos) now 1 less if pos & 7 != 0
            pos -= 7;
            st.h = head, st.p = prev, st.i = i, st.w = wi;
        }
    } else {
        for(var i = st.w || 0; i < s + lst; i += 65535){
            // end
            var e = i + 65535;
            if (e >= s) {
                // write final block
                w[pos / 8 | 0] = lst;
                e = s;
            }
            pos = $0c5e3e04f495ba65$var$wfblk(w, pos + 1, dat.subarray(i, e));
        }
        st.i = s;
    }
    return $0c5e3e04f495ba65$var$slc(o, 0, pre + $0c5e3e04f495ba65$var$shft(pos) + post);
};
// CRC32 table
var $0c5e3e04f495ba65$var$crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $0c5e3e04f495ba65$var$crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $0c5e3e04f495ba65$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Adler32
var $0c5e3e04f495ba65$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | (a & 0xFF00) << 8 | (b & 255) << 8 | b >> 8;
        }
    };
};
// deflate with opts
var $0c5e3e04f495ba65$var$dopt = function(dat, opt, pre, post, st) {
    if (!st) {
        st = {
            l: 1
        };
        if (opt.dictionary) {
            var dict = opt.dictionary.subarray(-32768);
            var newDat = new $0c5e3e04f495ba65$var$u8(dict.length + dat.length);
            newDat.set(dict);
            newDat.set(dat, dict.length);
            dat = newDat;
            st.w = dict.length;
        }
    }
    return $0c5e3e04f495ba65$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? st.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 20 : 12 + opt.mem, pre, post, st);
};
// Walmart object spread
var $0c5e3e04f495ba65$var$mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $0c5e3e04f495ba65$var$wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return fnStr;
};
var $0c5e3e04f495ba65$var$ch = [];
// clone bufs
var $0c5e3e04f495ba65$var$cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $0c5e3e04f495ba65$var$wrkr = function(fns, init, id, cb) {
    if (!$0c5e3e04f495ba65$var$ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)fnStr = $0c5e3e04f495ba65$var$wcln(fns[i], fnStr, td_1);
        $0c5e3e04f495ba65$var$ch[id] = {
            c: $0c5e3e04f495ba65$var$wcln(fns[m], fnStr, td_1),
            e: td_1
        };
    }
    var td = $0c5e3e04f495ba65$var$mrg({}, $0c5e3e04f495ba65$var$ch[id].e);
    return $0c5e3e04f495ba65$var$wk($0c5e3e04f495ba65$var$ch[id].c + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, $0c5e3e04f495ba65$var$cbfs(td), cb);
};
// base async inflate fn
var $0c5e3e04f495ba65$var$bInflt = function() {
    return [
        $0c5e3e04f495ba65$var$u8,
        $0c5e3e04f495ba65$var$u16,
        $0c5e3e04f495ba65$var$i32,
        $0c5e3e04f495ba65$var$fleb,
        $0c5e3e04f495ba65$var$fdeb,
        $0c5e3e04f495ba65$var$clim,
        $0c5e3e04f495ba65$var$fl,
        $0c5e3e04f495ba65$var$fd,
        $0c5e3e04f495ba65$var$flrm,
        $0c5e3e04f495ba65$var$fdrm,
        $0c5e3e04f495ba65$var$rev,
        $0c5e3e04f495ba65$var$ec,
        $0c5e3e04f495ba65$var$hMap,
        $0c5e3e04f495ba65$var$max,
        $0c5e3e04f495ba65$var$bits,
        $0c5e3e04f495ba65$var$bits16,
        $0c5e3e04f495ba65$var$shft,
        $0c5e3e04f495ba65$var$slc,
        $0c5e3e04f495ba65$var$err,
        $0c5e3e04f495ba65$var$inflt,
        $0c5e3e04f495ba65$export$90366d8b308ba94a,
        $0c5e3e04f495ba65$var$pbf,
        $0c5e3e04f495ba65$var$gopt
    ];
};
var $0c5e3e04f495ba65$var$bDflt = function() {
    return [
        $0c5e3e04f495ba65$var$u8,
        $0c5e3e04f495ba65$var$u16,
        $0c5e3e04f495ba65$var$i32,
        $0c5e3e04f495ba65$var$fleb,
        $0c5e3e04f495ba65$var$fdeb,
        $0c5e3e04f495ba65$var$clim,
        $0c5e3e04f495ba65$var$revfl,
        $0c5e3e04f495ba65$var$revfd,
        $0c5e3e04f495ba65$var$flm,
        $0c5e3e04f495ba65$var$flt,
        $0c5e3e04f495ba65$var$fdm,
        $0c5e3e04f495ba65$var$fdt,
        $0c5e3e04f495ba65$var$rev,
        $0c5e3e04f495ba65$var$deo,
        $0c5e3e04f495ba65$var$et,
        $0c5e3e04f495ba65$var$hMap,
        $0c5e3e04f495ba65$var$wbits,
        $0c5e3e04f495ba65$var$wbits16,
        $0c5e3e04f495ba65$var$hTree,
        $0c5e3e04f495ba65$var$ln,
        $0c5e3e04f495ba65$var$lc,
        $0c5e3e04f495ba65$var$clen,
        $0c5e3e04f495ba65$var$wfblk,
        $0c5e3e04f495ba65$var$wblk,
        $0c5e3e04f495ba65$var$shft,
        $0c5e3e04f495ba65$var$slc,
        $0c5e3e04f495ba65$var$dflt,
        $0c5e3e04f495ba65$var$dopt,
        $0c5e3e04f495ba65$export$21533ff51b8a0b4a,
        $0c5e3e04f495ba65$var$pbf
    ];
};
// gzip extra
var $0c5e3e04f495ba65$var$gze = function() {
    return [
        $0c5e3e04f495ba65$var$gzh,
        $0c5e3e04f495ba65$var$gzhl,
        $0c5e3e04f495ba65$var$wbytes,
        $0c5e3e04f495ba65$var$crc,
        $0c5e3e04f495ba65$var$crct
    ];
};
// gunzip extra
var $0c5e3e04f495ba65$var$guze = function() {
    return [
        $0c5e3e04f495ba65$var$gzs,
        $0c5e3e04f495ba65$var$gzl
    ];
};
// zlib extra
var $0c5e3e04f495ba65$var$zle = function() {
    return [
        $0c5e3e04f495ba65$var$zlh,
        $0c5e3e04f495ba65$var$wbytes,
        $0c5e3e04f495ba65$var$adler
    ];
};
// unzlib extra
var $0c5e3e04f495ba65$var$zule = function() {
    return [
        $0c5e3e04f495ba65$var$zls
    ];
};
// post buf
var $0c5e3e04f495ba65$var$pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get opts
var $0c5e3e04f495ba65$var$gopt = function(o) {
    return o && {
        out: o.size && new $0c5e3e04f495ba65$var$u8(o.size),
        dictionary: o.dictionary
    };
};
// async helper
var $0c5e3e04f495ba65$var$cbify = function(dat, opts, fns, init, id, cb) {
    var w = $0c5e3e04f495ba65$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var $0c5e3e04f495ba65$var$astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        if (ev.data[0]) {
            strm.push(ev.data[0], ev.data[1]);
            postMessage([
                ev.data[0].length
            ]);
        } else strm.flush(ev.data[1]);
    };
};
// async stream attach
var $0c5e3e04f495ba65$var$astrmify = function(fns, strm, opts, init, id, flush, ext) {
    var t;
    var w = $0c5e3e04f495ba65$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else if (!Array.isArray(dat)) ext(dat);
        else if (dat.length == 1) {
            strm.queuedSize -= dat[0];
            if (strm.ondrain) strm.ondrain(dat[0]);
        } else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.queuedSize = 0;
    strm.push = function(d, f) {
        if (!strm.ondata) $0c5e3e04f495ba65$var$err(5);
        if (t) strm.ondata($0c5e3e04f495ba65$var$err(4, 0, 1), null, !!f);
        strm.queuedSize += d.length;
        // can fail for cross-realm Uint8Array, but ok - only a small performance penalty
        w.postMessage([
            d,
            t = f
        ], d.buffer instanceof ArrayBuffer ? [
            d.buffer
        ] : []);
    };
    strm.terminate = function() {
        w.terminate();
    };
    if (flush) strm.flush = function(sync) {
        w.postMessage([
            0,
            sync
        ]);
    };
};
// read 2 bytes
var $0c5e3e04f495ba65$var$b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $0c5e3e04f495ba65$var$b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
// read 8 bytes
var $0c5e3e04f495ba65$var$b8 = function(d, b) {
    return $0c5e3e04f495ba65$var$b4(d, b) + $0c5e3e04f495ba65$var$b4(d, b + 4) * 4294967296;
};
// write bytes
var $0c5e3e04f495ba65$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $0c5e3e04f495ba65$var$gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $0c5e3e04f495ba65$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $0c5e3e04f495ba65$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) $0c5e3e04f495ba65$var$err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += (d[10] | d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $0c5e3e04f495ba65$var$gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var $0c5e3e04f495ba65$var$gzhl = function(o) {
    return 10 + (o.filename ? o.filename.length + 1 : 0);
};
// zlib header
var $0c5e3e04f495ba65$var$zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (o.dictionary && 32);
    c[1] |= 31 - (c[0] << 8 | c[1]) % 31;
    if (o.dictionary) {
        var h = $0c5e3e04f495ba65$var$adler();
        h.p(o.dictionary);
        $0c5e3e04f495ba65$var$wbytes(c, 2, h.d());
    }
};
// zlib start
var $0c5e3e04f495ba65$var$zls = function(d, dict) {
    if ((d[0] & 15) != 8 || d[0] >> 4 > 7 || (d[0] << 8 | d[1]) % 31) $0c5e3e04f495ba65$var$err(6, 'invalid zlib data');
    if ((d[1] >> 5 & 1) == +!dict) $0c5e3e04f495ba65$var$err(6, 'invalid zlib data: ' + (d[1] & 32 ? 'need' : 'unexpected') + ' dictionary');
    return (d[1] >> 3 & 4) + 2;
};
function $0c5e3e04f495ba65$var$StrmOpt(opts, cb) {
    if (typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
/**
 * Streaming DEFLATE compression
 */ var $0c5e3e04f495ba65$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
        this.s = {
            l: 0,
            i: 32768,
            w: 32768,
            z: 32768
        };
        // Buffer length must always be 0 mod 32768 for index calculations to be correct when modifying head and prev
        // 98304 = 32768 (lookback) + 65536 (common chunk size)
        this.b = new $0c5e3e04f495ba65$var$u8(98304);
        if (this.o.dictionary) {
            var dict = this.o.dictionary.subarray(-32768);
            this.b.set(dict, 32768 - dict.length);
            this.s.i = 32768 - dict.length;
        }
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata($0c5e3e04f495ba65$var$dopt(c, this.o, 0, 0, this.s), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        if (this.s.l) $0c5e3e04f495ba65$var$err(4);
        var endLen = chunk.length + this.s.z;
        if (endLen > this.b.length) {
            if (endLen > 2 * this.b.length - 32768) {
                var newBuf = new $0c5e3e04f495ba65$var$u8(endLen & -32768);
                newBuf.set(this.b.subarray(0, this.s.z));
                this.b = newBuf;
            }
            var split = this.b.length - this.s.z;
            this.b.set(chunk.subarray(0, split), this.s.z);
            this.s.z = this.b.length;
            this.p(this.b, false);
            this.b.set(this.b.subarray(-32768));
            this.b.set(chunk.subarray(split), 32768);
            this.s.z = chunk.length - split + 32768;
            this.s.i = 32766, this.s.w = 32768;
        } else {
            this.b.set(chunk, this.s.z);
            this.s.z += chunk.length;
        }
        this.s.l = final & 1;
        if (this.s.z > this.s.w + 8191 || final) {
            this.p(this.b, final || false);
            this.s.w = this.s.i, this.s.i -= 2;
        }
        if (final) {
            // cleanup unneeded buffers/state to reduce memory usage
            this.s = this.o = {};
            this.b = $0c5e3e04f495ba65$var$et;
        }
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * deflated output for small inputs.
     * @param sync Whether to flush to a byte boundary. A sync flush takes 4-5
     *             extra bytes, but guarantees all pushed data is immediately
     *             decompressible. A separate DEFLATE stream may be concatenated
     *             with the current output after a sync flush.
     */ Deflate.prototype.flush = function(sync) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        if (this.s.l) $0c5e3e04f495ba65$var$err(4);
        this.p(this.b, false);
        this.s.w = this.s.i, this.s.i -= 2;
        // could technically skip writing the type-0 block for (this.s.r & 7) == 0,
        // but the deterministic trailer (00 00 FF FF) is useful in some situations
        if (sync) {
            var c = new $0c5e3e04f495ba65$var$u8(6);
            c[0] = this.s.r >> 3;
            // write empty, non-final type-0 block
            var ep = $0c5e3e04f495ba65$var$wfblk(c, this.s.r, $0c5e3e04f495ba65$var$et);
            this.s.r = 0;
            this.ondata(c.subarray(0, ep >> 3), false);
        }
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $0c5e3e04f495ba65$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        $0c5e3e04f495ba65$var$astrmify([
            $0c5e3e04f495ba65$var$bDflt,
            function() {
                return [
                    $0c5e3e04f495ba65$var$astrm,
                    $0c5e3e04f495ba65$export$ae157b6234afe138
                ];
            }
        ], this, $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $0c5e3e04f495ba65$export$ae157b6234afe138(ev.data);
            onmessage = $0c5e3e04f495ba65$var$astrm(strm);
        }, 6, 1);
    }
    return AsyncDeflate;
}();
function $0c5e3e04f495ba65$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return $0c5e3e04f495ba65$var$cbify(data, opts, [
        $0c5e3e04f495ba65$var$bDflt
    ], function(ev) {
        return $0c5e3e04f495ba65$var$pbf($0c5e3e04f495ba65$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $0c5e3e04f495ba65$export$21533ff51b8a0b4a(data, opts) {
    return $0c5e3e04f495ba65$var$dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $0c5e3e04f495ba65$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    function Inflate(opts, cb) {
        // no StrmOpt here to avoid adding to workerizer
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        var dict = opts && opts.dictionary && opts.dictionary.subarray(-32768);
        this.s = {
            i: 0,
            b: dict ? dict.length : 0
        };
        this.o = new $0c5e3e04f495ba65$var$u8(32768);
        this.p = new $0c5e3e04f495ba65$var$u8(0);
        if (dict) this.o.set(dict);
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        if (this.d) $0c5e3e04f495ba65$var$err(4);
        if (!this.p.length) this.p = c;
        else if (c.length) {
            var n = new $0c5e3e04f495ba65$var$u8(this.p.length + c.length);
            n.set(this.p), n.set(c, this.p.length), this.p = n;
        }
    };
    Inflate.prototype.c = function(final) {
        this.s.i = +(this.d = final || false);
        var bts = this.s.b;
        var dt = $0c5e3e04f495ba65$var$inflt(this.p, this.s, this.o);
        this.ondata($0c5e3e04f495ba65$var$slc(dt, bts, this.s.b), this.d);
        this.o = $0c5e3e04f495ba65$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $0c5e3e04f495ba65$var$slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $0c5e3e04f495ba65$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    function AsyncInflate(opts, cb) {
        $0c5e3e04f495ba65$var$astrmify([
            $0c5e3e04f495ba65$var$bInflt,
            function() {
                return [
                    $0c5e3e04f495ba65$var$astrm,
                    $0c5e3e04f495ba65$export$d1de70a877d6e43c
                ];
            }
        ], this, $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $0c5e3e04f495ba65$export$d1de70a877d6e43c(ev.data);
            onmessage = $0c5e3e04f495ba65$var$astrm(strm);
        }, 7, 0);
    }
    return AsyncInflate;
}();
function $0c5e3e04f495ba65$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return $0c5e3e04f495ba65$var$cbify(data, opts, [
        $0c5e3e04f495ba65$var$bInflt
    ], function(ev) {
        return $0c5e3e04f495ba65$var$pbf($0c5e3e04f495ba65$export$90366d8b308ba94a(ev.data[0], $0c5e3e04f495ba65$var$gopt(ev.data[1])));
    }, 1, cb);
}
function $0c5e3e04f495ba65$export$90366d8b308ba94a(data, opts) {
    return $0c5e3e04f495ba65$var$inflt(data, {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $0c5e3e04f495ba65$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = $0c5e3e04f495ba65$var$crc();
        this.l = 0;
        this.v = 1;
        $0c5e3e04f495ba65$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        this.l += chunk.length;
        $0c5e3e04f495ba65$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        var raw = $0c5e3e04f495ba65$var$dopt(c, this.o, this.v && $0c5e3e04f495ba65$var$gzhl(this.o), f && 8, this.s);
        if (this.v) $0c5e3e04f495ba65$var$gzh(raw, this.o), this.v = 0;
        if (f) $0c5e3e04f495ba65$var$wbytes(raw, raw.length - 8, this.c.d()), $0c5e3e04f495ba65$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * GZIPped output for small inputs.
     * @param sync Whether to flush to a byte boundary. A sync flush takes 4-5
     *             extra bytes, but guarantees all pushed data is immediately
     *             decompressible.
     */ Gzip.prototype.flush = function(sync) {
        $0c5e3e04f495ba65$export$ae157b6234afe138.prototype.flush.call(this, sync);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $0c5e3e04f495ba65$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        $0c5e3e04f495ba65$var$astrmify([
            $0c5e3e04f495ba65$var$bDflt,
            $0c5e3e04f495ba65$var$gze,
            function() {
                return [
                    $0c5e3e04f495ba65$var$astrm,
                    $0c5e3e04f495ba65$export$ae157b6234afe138,
                    $0c5e3e04f495ba65$export$8e4b66d280bf8342
                ];
            }
        ], this, $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $0c5e3e04f495ba65$export$8e4b66d280bf8342(ev.data);
            onmessage = $0c5e3e04f495ba65$var$astrm(strm);
        }, 8, 1);
    }
    return AsyncGzip;
}();
function $0c5e3e04f495ba65$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return $0c5e3e04f495ba65$var$cbify(data, opts, [
        $0c5e3e04f495ba65$var$bDflt,
        $0c5e3e04f495ba65$var$gze,
        function() {
            return [
                $0c5e3e04f495ba65$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $0c5e3e04f495ba65$var$pbf($0c5e3e04f495ba65$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $0c5e3e04f495ba65$export$3d616c3fb3e15483(data, opts) {
    if (!opts) opts = {};
    var c = $0c5e3e04f495ba65$var$crc(), l = data.length;
    c.p(data);
    var d = $0c5e3e04f495ba65$var$dopt(data, opts, $0c5e3e04f495ba65$var$gzhl(opts), 8), s = d.length;
    return $0c5e3e04f495ba65$var$gzh(d, opts), $0c5e3e04f495ba65$var$wbytes(d, s - 8, c.d()), $0c5e3e04f495ba65$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming single or multi-member GZIP decompression
 */ var $0c5e3e04f495ba65$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    function Gunzip(opts, cb) {
        this.v = 1;
        this.r = 0;
        $0c5e3e04f495ba65$export$d1de70a877d6e43c.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $0c5e3e04f495ba65$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        this.r += chunk.length;
        if (this.v) {
            var p = this.p.subarray(this.v - 1);
            var s = p.length > 3 ? $0c5e3e04f495ba65$var$gzs(p) : 4;
            if (s > p.length) {
                if (!final) return;
            } else if (this.v > 1 && this.onmember) this.onmember(this.r - p.length);
            this.p = p.subarray(s), this.v = 0;
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $0c5e3e04f495ba65$export$d1de70a877d6e43c.prototype.c.call(this, 0);
        // process concatenated GZIP
        if (this.s.f && !this.s.l) {
            this.v = $0c5e3e04f495ba65$var$shft(this.s.p) + 9;
            this.s = {
                i: 0
            };
            this.o = new $0c5e3e04f495ba65$var$u8(0);
            this.push(new $0c5e3e04f495ba65$var$u8(0), final);
        } else if (final) $0c5e3e04f495ba65$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming single or multi-member GZIP decompression
 */ var $0c5e3e04f495ba65$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    function AsyncGunzip(opts, cb) {
        var _this = this;
        $0c5e3e04f495ba65$var$astrmify([
            $0c5e3e04f495ba65$var$bInflt,
            $0c5e3e04f495ba65$var$guze,
            function() {
                return [
                    $0c5e3e04f495ba65$var$astrm,
                    $0c5e3e04f495ba65$export$d1de70a877d6e43c,
                    $0c5e3e04f495ba65$export$4cb607de6db70415
                ];
            }
        ], this, $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $0c5e3e04f495ba65$export$4cb607de6db70415(ev.data);
            strm.onmember = function(offset) {
                return postMessage(offset);
            };
            onmessage = $0c5e3e04f495ba65$var$astrm(strm);
        }, 9, 0, function(offset) {
            return _this.onmember && _this.onmember(offset);
        });
    }
    return AsyncGunzip;
}();
function $0c5e3e04f495ba65$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return $0c5e3e04f495ba65$var$cbify(data, opts, [
        $0c5e3e04f495ba65$var$bInflt,
        $0c5e3e04f495ba65$var$guze,
        function() {
            return [
                $0c5e3e04f495ba65$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $0c5e3e04f495ba65$var$pbf($0c5e3e04f495ba65$export$c80456f7aaba691c(ev.data[0], ev.data[1]));
    }, 3, cb);
}
function $0c5e3e04f495ba65$export$c80456f7aaba691c(data, opts) {
    var st = $0c5e3e04f495ba65$var$gzs(data);
    if (st + 8 > data.length) $0c5e3e04f495ba65$var$err(6, 'invalid gzip data');
    return $0c5e3e04f495ba65$var$inflt(data.subarray(st, -8), {
        i: 2
    }, opts && opts.out || new $0c5e3e04f495ba65$var$u8($0c5e3e04f495ba65$var$gzl(data)), opts && opts.dictionary);
}
/**
 * Streaming Zlib compression
 */ var $0c5e3e04f495ba65$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = $0c5e3e04f495ba65$var$adler();
        this.v = 1;
        $0c5e3e04f495ba65$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        $0c5e3e04f495ba65$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        var raw = $0c5e3e04f495ba65$var$dopt(c, this.o, this.v && (this.o.dictionary ? 6 : 2), f && 4, this.s);
        if (this.v) $0c5e3e04f495ba65$var$zlh(raw, this.o), this.v = 0;
        if (f) $0c5e3e04f495ba65$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * zlibbed output for small inputs.
     * @param sync Whether to flush to a byte boundary. A sync flush takes 4-5
     *             extra bytes, but guarantees all pushed data is immediately
     *             decompressible.
     */ Zlib.prototype.flush = function(sync) {
        $0c5e3e04f495ba65$export$ae157b6234afe138.prototype.flush.call(this, sync);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $0c5e3e04f495ba65$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        $0c5e3e04f495ba65$var$astrmify([
            $0c5e3e04f495ba65$var$bDflt,
            $0c5e3e04f495ba65$var$zle,
            function() {
                return [
                    $0c5e3e04f495ba65$var$astrm,
                    $0c5e3e04f495ba65$export$ae157b6234afe138,
                    $0c5e3e04f495ba65$export$4187ccf2467013b9
                ];
            }
        ], this, $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $0c5e3e04f495ba65$export$4187ccf2467013b9(ev.data);
            onmessage = $0c5e3e04f495ba65$var$astrm(strm);
        }, 10, 1);
    }
    return AsyncZlib;
}();
function $0c5e3e04f495ba65$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return $0c5e3e04f495ba65$var$cbify(data, opts, [
        $0c5e3e04f495ba65$var$bDflt,
        $0c5e3e04f495ba65$var$zle,
        function() {
            return [
                $0c5e3e04f495ba65$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $0c5e3e04f495ba65$var$pbf($0c5e3e04f495ba65$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $0c5e3e04f495ba65$export$f87121a6d50aff25(data, opts) {
    if (!opts) opts = {};
    var a = $0c5e3e04f495ba65$var$adler();
    a.p(data);
    var d = $0c5e3e04f495ba65$var$dopt(data, opts, opts.dictionary ? 6 : 2, 4);
    return $0c5e3e04f495ba65$var$zlh(d, opts), $0c5e3e04f495ba65$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $0c5e3e04f495ba65$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    function Unzlib(opts, cb) {
        $0c5e3e04f495ba65$export$d1de70a877d6e43c.call(this, opts, cb);
        this.v = opts && opts.dictionary ? 2 : 1;
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $0c5e3e04f495ba65$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 6 && !final) return;
            this.p = this.p.subarray($0c5e3e04f495ba65$var$zls(this.p, this.v - 1)), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) $0c5e3e04f495ba65$var$err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $0c5e3e04f495ba65$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $0c5e3e04f495ba65$export$cf6668790220dcad = /*#__PURE__*/ function() {
    function AsyncUnzlib(opts, cb) {
        $0c5e3e04f495ba65$var$astrmify([
            $0c5e3e04f495ba65$var$bInflt,
            $0c5e3e04f495ba65$var$zule,
            function() {
                return [
                    $0c5e3e04f495ba65$var$astrm,
                    $0c5e3e04f495ba65$export$d1de70a877d6e43c,
                    $0c5e3e04f495ba65$export$af2424f875ff1b17
                ];
            }
        ], this, $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $0c5e3e04f495ba65$export$af2424f875ff1b17(ev.data);
            onmessage = $0c5e3e04f495ba65$var$astrm(strm);
        }, 11, 0);
    }
    return AsyncUnzlib;
}();
function $0c5e3e04f495ba65$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return $0c5e3e04f495ba65$var$cbify(data, opts, [
        $0c5e3e04f495ba65$var$bInflt,
        $0c5e3e04f495ba65$var$zule,
        function() {
            return [
                $0c5e3e04f495ba65$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $0c5e3e04f495ba65$var$pbf($0c5e3e04f495ba65$export$9ec8134f0f1b9fc6(ev.data[0], $0c5e3e04f495ba65$var$gopt(ev.data[1])));
    }, 5, cb);
}
function $0c5e3e04f495ba65$export$9ec8134f0f1b9fc6(data, opts) {
    return $0c5e3e04f495ba65$var$inflt(data.subarray($0c5e3e04f495ba65$var$zls(data, opts && opts.dictionary), -4), {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $0c5e3e04f495ba65$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    function Decompress(opts, cb) {
        this.o = $0c5e3e04f495ba65$var$StrmOpt.call(this, opts, cb) || {};
        this.G = $0c5e3e04f495ba65$export$4cb607de6db70415;
        this.I = $0c5e3e04f495ba65$export$d1de70a877d6e43c;
        this.Z = $0c5e3e04f495ba65$export$af2424f875ff1b17;
    }
    // init substream
    // overriden by AsyncDecompress
    Decompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(dat, final) {
            _this.ondata(dat, final);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $0c5e3e04f495ba65$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(this.o) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(this.o) : new this.Z(this.o);
                this.i();
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $0c5e3e04f495ba65$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    function AsyncDecompress(opts, cb) {
        $0c5e3e04f495ba65$export$578fe199ef655b76.call(this, opts, cb);
        this.queuedSize = 0;
        this.G = $0c5e3e04f495ba65$export$d5adcdd968132151;
        this.I = $0c5e3e04f495ba65$export$fff8358d6dbaa9cc;
        this.Z = $0c5e3e04f495ba65$export$cf6668790220dcad;
    }
    AsyncDecompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(err, dat, final) {
            _this.ondata(err, dat, final);
        };
        this.s.ondrain = function(size) {
            _this.queuedSize -= size;
            if (_this.ondrain) _this.ondrain(size);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        this.queuedSize += chunk.length;
        $0c5e3e04f495ba65$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $0c5e3e04f495ba65$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $0c5e3e04f495ba65$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $0c5e3e04f495ba65$export$cae1ce83fe4a1782(data, opts, cb) : $0c5e3e04f495ba65$export$ca7cbb494e731274(data, opts, cb);
}
function $0c5e3e04f495ba65$export$c4bdbbbc9a4faabe(data, opts) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $0c5e3e04f495ba65$export$c80456f7aaba691c(data, opts) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $0c5e3e04f495ba65$export$90366d8b308ba94a(data, opts) : $0c5e3e04f495ba65$export$9ec8134f0f1b9fc6(data, opts);
}
// flatten a directory structure
var $0c5e3e04f495ba65$var$fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = $0c5e3e04f495ba65$var$mrg(o, val[1]), val = val[0];
        if (ArrayBuffer.isView(val)) t[n] = [
            val,
            op
        ];
        else {
            t[n += '/'] = [
                new $0c5e3e04f495ba65$var$u8(0),
                op
            ];
            $0c5e3e04f495ba65$var$fltn(val, n, t, o);
        }
    }
};
// text encoder
var $0c5e3e04f495ba65$var$te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var $0c5e3e04f495ba65$var$td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var $0c5e3e04f495ba65$var$tds = 0;
try {
    $0c5e3e04f495ba65$var$td.decode($0c5e3e04f495ba65$var$et, {
        stream: true
    });
    $0c5e3e04f495ba65$var$tds = 1;
} catch (e) {}
// decode UTF8
var $0c5e3e04f495ba65$var$dutf8 = function(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return {
            s: r,
            r: $0c5e3e04f495ba65$var$slc(d, i - 1)
        };
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var $0c5e3e04f495ba65$export$ba46860a31c72e94 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if ($0c5e3e04f495ba65$var$tds) this.t = new TextDecoder();
        else this.p = $0c5e3e04f495ba65$var$et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) $0c5e3e04f495ba65$var$err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) $0c5e3e04f495ba65$var$err(4);
        var dat = new $0c5e3e04f495ba65$var$u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = $0c5e3e04f495ba65$var$dutf8(dat), s = _a.s, r = _a.r;
        if (final) {
            if (r.length) $0c5e3e04f495ba65$var$err(8);
            this.p = null;
        } else this.p = r;
        this.ondata(s, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var $0c5e3e04f495ba65$export$283f13d12b1b210e = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        if (this.d) $0c5e3e04f495ba65$var$err(4);
        this.ondata($0c5e3e04f495ba65$export$366b39a6daa8ed7a(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function $0c5e3e04f495ba65$export$366b39a6daa8ed7a(str, latin1) {
    if (latin1) {
        var ar_1 = new $0c5e3e04f495ba65$var$u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if ($0c5e3e04f495ba65$var$te) return $0c5e3e04f495ba65$var$te.encode(str);
    var l = str.length;
    var ar = new $0c5e3e04f495ba65$var$u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $0c5e3e04f495ba65$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return $0c5e3e04f495ba65$var$slc(ar, 0, ai);
}
function $0c5e3e04f495ba65$export$adb211f8cb999894(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if ($0c5e3e04f495ba65$var$td) return $0c5e3e04f495ba65$var$td.decode(dat);
    else {
        var _a = $0c5e3e04f495ba65$var$dutf8(dat), s = _a.s, r = _a.r;
        if (r.length) $0c5e3e04f495ba65$var$err(8);
        return s;
    }
}
// deflate bit flag
var $0c5e3e04f495ba65$var$dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var $0c5e3e04f495ba65$var$slzh = function(d, b) {
    return b + 30 + $0c5e3e04f495ba65$var$b2(d, b + 26) + $0c5e3e04f495ba65$var$b2(d, b + 28);
};
// read zip header
var $0c5e3e04f495ba65$var$zh = function(d, b, z) {
    var fnl = $0c5e3e04f495ba65$var$b2(d, b + 28), efl = $0c5e3e04f495ba65$var$b2(d, b + 30), fn = $0c5e3e04f495ba65$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($0c5e3e04f495ba65$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl;
    var _a = $0c5e3e04f495ba65$var$z64hs(d, es, efl, z, $0c5e3e04f495ba65$var$b4(d, b + 20), $0c5e3e04f495ba65$var$b4(d, b + 24), $0c5e3e04f495ba65$var$b4(d, b + 42)), sc = _a[0], su = _a[1], off = _a[2];
    return [
        $0c5e3e04f495ba65$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + efl + $0c5e3e04f495ba65$var$b2(d, b + 32),
        off
    ];
};
// read zip64 header sizes
var $0c5e3e04f495ba65$var$z64hs = function(d, b, l, z, sc, su, off) {
    var nsc = sc == 4294967295, nsu = su == 4294967295, noff = off == 4294967295, e = b + l;
    var nf = nsc + nsu + noff;
    if (z && nf) {
        for(; b + 4 < e; b += 4 + $0c5e3e04f495ba65$var$b2(d, b + 2)){
            if ($0c5e3e04f495ba65$var$b2(d, b) == 1) return [
                nsc ? $0c5e3e04f495ba65$var$b8(d, b + 4 + 8 * nsu) : sc,
                nsu ? $0c5e3e04f495ba65$var$b8(d, b + 4) : su,
                noff ? $0c5e3e04f495ba65$var$b8(d, b + 4 + 8 * (nsu + nsc)) : off,
                1
            ];
        }
        // z == 2 for unknown whether or not zip64
        if (z < 2) $0c5e3e04f495ba65$var$err(13);
    }
    return [
        sc,
        su,
        off,
        0
    ];
};
// extra field length
var $0c5e3e04f495ba65$var$exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) $0c5e3e04f495ba65$var$err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var $0c5e3e04f495ba65$var$wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = $0c5e3e04f495ba65$var$exfl(ex);
    $0c5e3e04f495ba65$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c < 0 && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) $0c5e3e04f495ba65$var$err(10);
    $0c5e3e04f495ba65$var$wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >> 1), b += 4;
    if (c != -1) {
        $0c5e3e04f495ba65$var$wbytes(d, b, f.crc);
        $0c5e3e04f495ba65$var$wbytes(d, b + 4, c < 0 ? -c - 2 : c);
        $0c5e3e04f495ba65$var$wbytes(d, b + 8, f.size);
    }
    $0c5e3e04f495ba65$var$wbytes(d, b + 12, fl);
    $0c5e3e04f495ba65$var$wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        $0c5e3e04f495ba65$var$wbytes(d, b, col);
        $0c5e3e04f495ba65$var$wbytes(d, b + 6, f.attrs);
        $0c5e3e04f495ba65$var$wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        $0c5e3e04f495ba65$var$wbytes(d, b, +k);
        $0c5e3e04f495ba65$var$wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var $0c5e3e04f495ba65$var$wzf = function(o, b, c, d, e) {
    $0c5e3e04f495ba65$var$wbytes(o, b, 0x6054B50); // skip disk
    $0c5e3e04f495ba65$var$wbytes(o, b + 8, c);
    $0c5e3e04f495ba65$var$wbytes(o, b + 10, c);
    $0c5e3e04f495ba65$var$wbytes(o, b + 12, d);
    $0c5e3e04f495ba65$var$wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var $0c5e3e04f495ba65$export$2b25194e1767ea06 = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = $0c5e3e04f495ba65$var$crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        // we shouldn't really do this cast, but properly handling ArrayBufferLike
        // makes the API unergonomic with Buffer
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var $0c5e3e04f495ba65$export$f7e481ca646388b6 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $0c5e3e04f495ba65$export$2b25194e1767ea06.call(this, filename);
        this.d = new $0c5e3e04f495ba65$export$ae157b6234afe138(opts, function(dat, final) {
            _this.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = $0c5e3e04f495ba65$var$dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        $0c5e3e04f495ba65$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var $0c5e3e04f495ba65$export$ffb5e59e179924b2 = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $0c5e3e04f495ba65$export$2b25194e1767ea06.call(this, filename);
        this.d = new $0c5e3e04f495ba65$export$84e526fabcba03e3(opts, function(err, dat, final) {
            _this.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = $0c5e3e04f495ba65$var$dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        $0c5e3e04f495ba65$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var $0c5e3e04f495ba65$export$9a4d4a7c32a75d2f = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this = this;
        if (!this.ondata) $0c5e3e04f495ba65$var$err(5);
        // finishing or finished
        if (this.d & 2) this.ondata($0c5e3e04f495ba65$var$err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = $0c5e3e04f495ba65$export$366b39a6daa8ed7a(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && $0c5e3e04f495ba65$export$366b39a6daa8ed7a(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + $0c5e3e04f495ba65$var$exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata($0c5e3e04f495ba65$var$err(11, 0, 1), null, false);
            var header = new $0c5e3e04f495ba65$var$u8(hl_1);
            $0c5e3e04f495ba65$var$wzh(header, 0, file, f, u, -1);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = $0c5e3e04f495ba65$var$mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this.ondata(err, dat, final);
                    _this.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new $0c5e3e04f495ba65$var$u8(16);
                        $0c5e3e04f495ba65$var$wbytes(dd, 0, 0x8074B50);
                        $0c5e3e04f495ba65$var$wbytes(dd, 4, file.crc);
                        $0c5e3e04f495ba65$var$wbytes(dd, 8, cl_1);
                        $0c5e3e04f495ba65$var$wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this = this;
        if (this.d & 2) {
            this.ondata($0c5e3e04f495ba65$var$err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this.d & 1)) return;
                _this.u.splice(-1, 1);
                _this.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + $0c5e3e04f495ba65$var$exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new $0c5e3e04f495ba65$var$u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            $0c5e3e04f495ba65$var$wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
            bt += 46 + f.f.length + $0c5e3e04f495ba65$var$exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        $0c5e3e04f495ba65$var$wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function $0c5e3e04f495ba65$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    var r = {};
    $0c5e3e04f495ba65$var$fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        $0c5e3e04f495ba65$var$mt(function() {
            cb(a, b);
        });
    };
    $0c5e3e04f495ba65$var$mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new $0c5e3e04f495ba65$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                $0c5e3e04f495ba65$var$wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + $0c5e3e04f495ba65$var$exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                $0c5e3e04f495ba65$var$wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        $0c5e3e04f495ba65$var$wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $0c5e3e04f495ba65$var$crc(), size = file.length;
        c.p(file);
        var f = $0c5e3e04f495ba65$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $0c5e3e04f495ba65$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $0c5e3e04f495ba65$var$exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = $0c5e3e04f495ba65$var$mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl($0c5e3e04f495ba65$var$err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, $0c5e3e04f495ba65$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($0c5e3e04f495ba65$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $0c5e3e04f495ba65$export$eb1654f146d54eb3(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    $0c5e3e04f495ba65$var$fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = $0c5e3e04f495ba65$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $0c5e3e04f495ba65$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $0c5e3e04f495ba65$var$exfl(p.extra);
        if (s > 65535) $0c5e3e04f495ba65$var$err(11);
        var d = compression ? $0c5e3e04f495ba65$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $0c5e3e04f495ba65$var$crc();
        c.p(file);
        files.push($0c5e3e04f495ba65$var$mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new $0c5e3e04f495ba65$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $0c5e3e04f495ba65$var$wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + $0c5e3e04f495ba65$var$exfl(f.extra);
        out.set(f.c, f.o + badd);
        $0c5e3e04f495ba65$var$wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    $0c5e3e04f495ba65$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var $0c5e3e04f495ba65$export$93f81d5bbbb7c6bf = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(chunk, final) {
        // same as ZipPassThrough: cast to retain Buffer ergonomics
        this.ondata(null, chunk, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var $0c5e3e04f495ba65$export$eb188945cc39e642 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this = this;
        this.i = new $0c5e3e04f495ba65$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(chunk, final) {
        try {
            this.i.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var $0c5e3e04f495ba65$export$6235d84645dad4f9 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this = this;
        if (sz < 320000) this.i = new $0c5e3e04f495ba65$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
        else {
            this.i = new $0c5e3e04f495ba65$export$fff8358d6dbaa9cc(function(err, dat, final) {
                _this.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(chunk, final) {
        if (this.i.terminate) chunk = $0c5e3e04f495ba65$var$slc(chunk, 0);
        this.i.push(chunk, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var $0c5e3e04f495ba65$export$9b7485f84cbaaa56 = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: $0c5e3e04f495ba65$export$93f81d5bbbb7c6bf
        };
        this.p = $0c5e3e04f495ba65$var$et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this = this;
        if (!this.onfile) $0c5e3e04f495ba65$var$err(5);
        if (!this.p) $0c5e3e04f495ba65$var$err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new $0c5e3e04f495ba65$var$u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var sig = $0c5e3e04f495ba65$var$b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = $0c5e3e04f495ba65$var$b2(buf, i + 6), cmp_1 = $0c5e3e04f495ba65$var$b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = $0c5e3e04f495ba65$var$b2(buf, i + 26), es = $0c5e3e04f495ba65$var$b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var lsc = $0c5e3e04f495ba65$var$b4(buf, i + 18), lsu = $0c5e3e04f495ba65$var$b4(buf, i + 22);
                        var fn_1 = $0c5e3e04f495ba65$export$adb211f8cb999894(buf.subarray(i + 30, i += 30 + fnl), !u);
                        var _a = $0c5e3e04f495ba65$var$z64hs(buf, i, es, 2, lsc, lsu, 0), sc_1 = _a[0], su_1 = _a[1], z64 = _a[3];
                        if (dd) sc_1 = -1 - z64;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) $0c5e3e04f495ba65$var$err(5);
                                if (!sc_1) file_1.ondata(null, $0c5e3e04f495ba65$var$et, true);
                                else {
                                    var ctr = _this.o[cmp_1];
                                    if (!ctr) file_1.ondata($0c5e3e04f495ba65$var$err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this.k[0] == chks_3 && _this.c) _this.d = d_1;
                                    else d_1.push($0c5e3e04f495ba65$var$et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = $0c5e3e04f495ba65$var$et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - ($0c5e3e04f495ba65$var$b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) $0c5e3e04f495ba65$var$err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var $0c5e3e04f495ba65$var$mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function(fn) {
    fn();
};
function $0c5e3e04f495ba65$export$23c8d3f8757cab88(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $0c5e3e04f495ba65$var$err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        $0c5e3e04f495ba65$var$mt(function() {
            cb(a, b);
        });
    };
    $0c5e3e04f495ba65$var$mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; $0c5e3e04f495ba65$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd($0c5e3e04f495ba65$var$err(13, 0, 1), null);
        return tAll;
    }
    var lft = $0c5e3e04f495ba65$var$b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = $0c5e3e04f495ba65$var$b4(data, e + 16);
        var z = $0c5e3e04f495ba65$var$b4(data, e - 20) == 0x7064B50;
        if (z) {
            var ze = $0c5e3e04f495ba65$var$b4(data, e - 12);
            z = $0c5e3e04f495ba65$var$b4(data, ze) == 0x6064B50;
            if (z) {
                c = lft = $0c5e3e04f495ba65$var$b4(data, ze + 32);
                o = $0c5e3e04f495ba65$var$b4(data, ze + 48);
            }
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = $0c5e3e04f495ba65$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $0c5e3e04f495ba65$var$slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, $0c5e3e04f495ba65$var$slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    // Synchronously decompress under 512KB, or barely-compressed data
                    if (su < 524288 || sc > 0.8 * su) try {
                        cbl(null, $0c5e3e04f495ba65$export$90366d8b308ba94a(infl, {
                            out: new $0c5e3e04f495ba65$var$u8(su)
                        }));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push($0c5e3e04f495ba65$export$cae1ce83fe4a1782(infl, {
                        size: su
                    }, cbl));
                } else cbl($0c5e3e04f495ba65$var$err(14, 'unknown compression type ' + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function $0c5e3e04f495ba65$export$c757709326bb5901(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; $0c5e3e04f495ba65$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) $0c5e3e04f495ba65$var$err(13);
    var c = $0c5e3e04f495ba65$var$b2(data, e + 8);
    if (!c) return {};
    var o = $0c5e3e04f495ba65$var$b4(data, e + 16);
    var z = $0c5e3e04f495ba65$var$b4(data, e - 20) == 0x7064B50;
    if (z) {
        var ze = $0c5e3e04f495ba65$var$b4(data, e - 12);
        z = $0c5e3e04f495ba65$var$b4(data, ze) == 0x6064B50;
        if (z) {
            c = $0c5e3e04f495ba65$var$b4(data, ze + 32);
            o = $0c5e3e04f495ba65$var$b4(data, ze + 48);
        }
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = $0c5e3e04f495ba65$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $0c5e3e04f495ba65$var$slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = $0c5e3e04f495ba65$var$slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = $0c5e3e04f495ba65$export$90366d8b308ba94a(data.subarray(b, b + sc), {
                out: new $0c5e3e04f495ba65$var$u8(su)
            });
            else $0c5e3e04f495ba65$var$err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}
module.exports["gzipSync"] = $0c5e3e04f495ba65$export$3d616c3fb3e15483;
module.exports["gunzipSync"] = $0c5e3e04f495ba65$export$c80456f7aaba691c;

});

parcelRegister("8BldL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $f1df1ad831df9f5a$export$6107f09ca09b8b5f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    embeddedParentModalKey: undefined,
    setEmbeddedParentModalKey: ()=>{},
    forwarder: ()=>Promise.resolve()
});
module.exports["EmbeddedModalContext"] = $f1df1ad831df9f5a$export$6107f09ca09b8b5f;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("4ewzf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6ojvx = parcelRequire("6ojvx");

var $DIyeF = parcelRequire("DIyeF");


var $4K6lC = parcelRequire("4K6lC");

const $4d5d83f604ebdb2f$export$64f0f7e9be5f8ff = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { analyticsWebClient: analyticsWebClient, environment: environment, product: product, page: page, children: children } = t0;
    let t1;
    if ($[0] !== page || $[1] !== product) {
        t1 = {
            product: product,
            page: page
        };
        $[0] = page;
        $[1] = product;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== page) {
        t2 = {
            moduleType: page
        };
        $[3] = page;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== analyticsWebClient || $[6] !== children || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4K6lC.default), {
            client: analyticsWebClient,
            commonAttributes: t2
        }, children);
        $[5] = analyticsWebClient;
        $[6] = children;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== t1 || $[10] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $DIyeF.MetricsContextProvider), {
            value: t1
        }, t3);
        $[9] = t1;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== environment || $[13] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ojvx.EnvironmentContext).Provider, {
            value: environment
        }, t4);
        $[12] = environment;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
} : ({ analyticsWebClient: analyticsWebClient, environment: environment, product: product, page: page, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ojvx.EnvironmentContext).Provider, {
        value: environment
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $DIyeF.MetricsContextProvider), {
        value: {
            product: product,
            page: page
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4K6lC.default), {
        client: analyticsWebClient,
        commonAttributes: {
            moduleType: page
        }
    }, children)));
};
module.exports["ForgeUIExtensionPointProvider"] = $4d5d83f604ebdb2f$export$64f0f7e9be5f8ff;

});

parcelRegister("dPlMJ", function(module, exports) {
/* ConnectEosBanner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $7dBf8 = parcelRequire("7dBf8");


var $cXtTj = parcelRequire("cXtTj");


var $lvJqX = parcelRequire("lvJqX");


var $1VhsF = parcelRequire("1VhsF");

var $jtT80 = parcelRequire("jtT80");


var $kSwu1 = parcelRequire("kSwu1");


var $7OuPp = parcelRequire("7OuPp");


var $lEfEl = parcelRequire("lEfEl");

function $3d63ea7a98a3f43b$var$_defineProperty(e, r, t) {
    return (r = $3d63ea7a98a3f43b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $3d63ea7a98a3f43b$var$_toPropertyKey(t) {
    var i = $3d63ea7a98a3f43b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $3d63ea7a98a3f43b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $3d63ea7a98a3f43b$export$4f5b90a6ce229aa1 = 'customer-messaging-iframe-banner-dismiss-days';
const $3d63ea7a98a3f43b$export$461103d5504d4d8b = 'connect-eos-banner_dismissed';
const $3d63ea7a98a3f43b$var$BSC_SUCCESS_STATUS = 'SUCCESS';
const $3d63ea7a98a3f43b$var$BSC_BLOCKED_STATUS = 'BLOCKED';
const $3d63ea7a98a3f43b$export$9d00c95780551685 = 30;
const $3d63ea7a98a3f43b$export$10cefe68e4bb6b44 = 86400000;
const $3d63ea7a98a3f43b$export$a916575f88d9889f = 'customer-messaging-iframe-banner-enabled';
const $3d63ea7a98a3f43b$var$FEATURE_GATE_DEV_CANARY_ENABLED = 'customer-messaging-is-dev-canary';
const $3d63ea7a98a3f43b$var$DEVELOPER_CANARY_PROGRAM_URL = 'https://developer.atlassian.com/cloud/jira/platform/developer-canary-program/';
const $3d63ea7a98a3f43b$var$FORGE_CHANGELOG_URL = 'https://developer.atlassian.com/platform/forge/changelog/';
const $3d63ea7a98a3f43b$var$DEFAULT_LOCALE = 'en';
const $3d63ea7a98a3f43b$var$defaultIntlCache = (0, $kSwu1.createIntlCache)();
const $3d63ea7a98a3f43b$var$defaultIntl = (0, $kSwu1.createIntl)({
    locale: $3d63ea7a98a3f43b$var$DEFAULT_LOCALE
}, $3d63ea7a98a3f43b$var$defaultIntlCache);
const $3d63ea7a98a3f43b$var$containerStyles = {
    marginBottom: '8px'
};
const $3d63ea7a98a3f43b$var$devCanaryMessageStyles = null;
function $3d63ea7a98a3f43b$export$e6e73547b6ec2430(appKey) {
    return `${appKey}-${$3d63ea7a98a3f43b$export$461103d5504d4d8b}`;
}
class $3d63ea7a98a3f43b$var$ConnectEosBannerComponent extends $cozmU.PureComponent {
    _getDismissDurationMs() {
        const days = (0, $cXtTj.default).getExperiment($3d63ea7a98a3f43b$export$4f5b90a6ce229aa1, {
            fireExperimentExposure: false
        }).get('value', $3d63ea7a98a3f43b$export$9d00c95780551685);
        return (typeof days === 'number' && days > 0 ? days : $3d63ea7a98a3f43b$export$9d00c95780551685) * $3d63ea7a98a3f43b$export$10cefe68e4bb6b44;
    }
    _isDismissed() {
        if (typeof window === 'undefined') return false;
        const dismissStorageKey = $3d63ea7a98a3f43b$export$e6e73547b6ec2430(this.props.appKey);
        const storedItem = (0, $7dBf8.AtlBrowserStorageLocal).getItem(dismissStorageKey);
        if (!storedItem) return false;
        let dismissedAt;
        try {
            const parsedItem = JSON.parse(storedItem);
            dismissedAt = parsedItem.value;
        } catch (e) {
            (0, $7OuPp.logger).warn('Failed to parse Connect EOS banner dismissal', {
                key: dismissStorageKey,
                error: e
            });
            return false;
        }
        if (!dismissedAt) return false;
        const dismissedTimestamp = Number(dismissedAt);
        if (isNaN(dismissedTimestamp)) return false;
        return Date.now() - dismissedTimestamp < this._getDismissDurationMs();
    }
    _shouldShowBanner() {
        // Don't show if the main feature gate is not enabled
        if (!(0, $cXtTj.default).checkGate($3d63ea7a98a3f43b$export$a916575f88d9889f)) return false;
         // Don't show for system apps
        if (this.props.isSystemApp) return false;
         // Don't show if previously dismissed (within configured dismiss duration)
        if (this.state.dismissed) return false;
        return true;
    }
    _isProd() {
        if (typeof window === 'undefined') return false;
        return window.location.hostname.endsWith('.atlassian.net');
    }
    _isSiteAdmin() {
        return this.props.isSiteAdmin ?? false;
    }
    _isDevCanary() {
        return (0, $cXtTj.default).checkGate($3d63ea7a98a3f43b$var$FEATURE_GATE_DEV_CANARY_ENABLED);
    }
    _getConnectedAppsUrl() {
        const cloudId = this.props.cloudId ?? (typeof document !== 'undefined' ? document.querySelector('meta[name="ajs-cloud-id"]')?.content : undefined) ?? undefined;
        const adminHost = this._isProd() ? 'admin.atlassian.com' : 'admin.stg.atlassian.com';
        if (!cloudId) return undefined;
        return `https://${adminHost}/s/${cloudId}/user-connected-apps/tab/installed`;
    }
    _getAdminMessageBody() {
        const { appName: appName } = this.props;
        const connectedAppsUrl = this._getConnectedAppsUrl();
        const message = appName ? (0, $lEfEl.connectEosBannerMessages).adminMessageWithAppName : (0, $lEfEl.connectEosBannerMessages).adminMessageWithoutAppName;
        const connectedApps = (chunks)=>/*#__PURE__*/ $cozmU.createElement("strong", null, connectedAppsUrl ? /*#__PURE__*/ $cozmU.createElement("a", {
                href: connectedAppsUrl
            }, chunks) : /*#__PURE__*/ $cozmU.createElement("span", null, chunks));
        const values = appName ? {
            appName: /*#__PURE__*/ $cozmU.createElement("strong", null, appName),
            connectedApps: connectedApps
        } : {
            connectedApps: connectedApps
        };
        return /*#__PURE__*/ $cozmU.createElement("p", null, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
            ...message,
            values: values
        }));
    }
    _getNonAdminMessageBody() {
        const { appName: appName } = this.props;
        const message = appName ? (0, $lEfEl.connectEosBannerMessages).nonAdminMessageWithAppName : (0, $lEfEl.connectEosBannerMessages).nonAdminMessageWithoutAppName;
        return /*#__PURE__*/ $cozmU.createElement("p", null, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
            ...message,
            values: appName ? {
                appName: /*#__PURE__*/ $cozmU.createElement("strong", null, appName)
            } : {}
        }));
    }
    _getDevCanaryMessageBody() {
        if (!this._isDevCanary()) return null;
        const developerCanaryProgram = (chunks)=>/*#__PURE__*/ $cozmU.createElement("a", {
                href: $3d63ea7a98a3f43b$var$DEVELOPER_CANARY_PROGRAM_URL,
                target: "_blank",
                rel: "noopener noreferrer"
            }, chunks);
        const forgeChangelog = (chunks)=>/*#__PURE__*/ $cozmU.createElement("a", {
                href: $3d63ea7a98a3f43b$var$FORGE_CHANGELOG_URL,
                target: "_blank",
                rel: "noopener noreferrer"
            }, chunks);
        return /*#__PURE__*/ $cozmU.createElement("p", {
            className: (0, $hekY6.default)([
                "_19pkze3t"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $lEfEl.connectEosBannerMessages).devCanaryMessage,
            values: {
                developerCanaryProgram: developerCanaryProgram,
                forgeChangelog: forgeChangelog
            }
        }));
    }
    _getDismissAction() {
        return /*#__PURE__*/ $cozmU.createElement((0, $jtT80.default), {
            onClick: this._dismiss,
            key: "dismiss"
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $lEfEl.connectEosBannerMessages).dismiss));
    }
    getSectionWarningBanner() {
        return /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "connect-eos-banner",
            style: $3d63ea7a98a3f43b$var$containerStyles
        }, /*#__PURE__*/ $cozmU.createElement((0, $1VhsF.default), {
            appearance: "warning"
        }, this._isSiteAdmin() ? this._getAdminMessageBody() : this._getNonAdminMessageBody(), this._getDevCanaryMessageBody(), this._getDismissAction()));
    }
    getInlineBanner() {
        return /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "connect-eos-v2-banner"
        }, /*#__PURE__*/ $cozmU.createElement((0, $lvJqX.default), {
            appearance: "warning",
            secondaryText: (this.props.intl ?? $3d63ea7a98a3f43b$var$defaultIntl).formatMessage((0, $lEfEl.connectEosBannerMessages).inlineSecondaryText)
        }, this._isSiteAdmin() ? this._getAdminMessageBody() : this._getNonAdminMessageBody(), this._getDevCanaryMessageBody(), this._getDismissAction()));
    }
    render() {
        if (!this._shouldShowBanner()) return null;
        const banner = this.props.moduleType === 'webPanels' ? this.getInlineBanner() : this.getSectionWarningBanner();
        if (!this.props.intl) return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.RawIntlProvider), {
            value: $3d63ea7a98a3f43b$var$defaultIntl
        }, banner);
        return banner;
    }
    constructor(props){
        super(props);
        $3d63ea7a98a3f43b$var$_defineProperty(this, "_dismiss", ()=>{
            const dismissedAt = Date.now();
            const storedItem = JSON.stringify({
                value: dismissedAt
            });
            const dismissStorageKey = $3d63ea7a98a3f43b$export$e6e73547b6ec2430(this.props.appKey); // @browser-storage setter
            (0, $7dBf8.AtlBrowserStorageLocal).setItem(dismissStorageKey, storedItem).then((result)=>{
                if (result?.status && result.status !== $3d63ea7a98a3f43b$var$BSC_SUCCESS_STATUS && result.status !== $3d63ea7a98a3f43b$var$BSC_BLOCKED_STATUS) (0, $7OuPp.logger).warn('Failed to persist Connect EOS banner dismissal', {
                    key: dismissStorageKey,
                    result: result
                });
            }).catch((error)=>{
                (0, $7OuPp.logger).warn('Failed to persist Connect EOS banner dismissal', {
                    key: dismissStorageKey,
                    error: error
                });
            });
            this.setState({
                dismissed: true
            });
        });
        this.state = {
            dismissed: this._isDismissed()
        };
    }
}
$3d63ea7a98a3f43b$var$_defineProperty($3d63ea7a98a3f43b$var$ConnectEosBannerComponent, "defaultProps", {
    isSystemApp: false,
    moduleType: ''
});
const $3d63ea7a98a3f43b$export$70b82b13309d5477 = (0, $kSwu1.injectIntl)($3d63ea7a98a3f43b$var$ConnectEosBannerComponent, {
    enforceContext: false
});
module.exports["ConnectEosBanner"] = $3d63ea7a98a3f43b$export$70b82b13309d5477;

});

parcelRegister("7OuPp", function(module, exports) {
/* eslint-disable */ // @ts-nocheck

var $jDYJM = parcelRequire("jDYJM");

class $8825011921e30ce8$var$LoggerController {
    isDebugEnabled() {
        return this.debugEnabled;
    }
    isInfoEnabled() {
        return this.infoEnabled;
    }
    constructor(){
        this.debugEnabled = false;
        this.infoEnabled = true;
    }
}
/**
 * This class serves two purposes:
 *   - It provides the ability for products to register their implementations
 *     of LoggerAPI for use by the connect front end code.
 *   - It provides the LoggerAPI implementation that connect front end code
 *     should use. This implementation delegates to the registered LoggerAPI
 *     implementation. This class should be used within the connect front end
 *     code as follows:
 *
 *     import logger from '../adaptors/logger/LoggerAdaptor';
 *
 *     logger.info('My message', extraStuffOfInterest, etc, ...);
 */ class $8825011921e30ce8$var$LoggerAdaptor {
    /**
   * Implementation of AnalyticsRegistry#registerAnalyticsAPI().
   */ registerLoggerAPI(loggerAPI) {
        this.loggerAPI = loggerAPI;
    }
    /**
   * Implementation of LoggerAPI#debug() for use by connect-module-core code.
   */ debug(message, ...optionalParams) {
        try {
            if (this.loggerController.isDebugEnabled()) this.loggerAPI.debug.apply(this.loggerAPI, arguments);
        } catch (exception) {
        // Ignore
        }
    }
    /**
   * Implementation of LoggerAPI#info() for use by connect-module-core code.
   */ info(message, ...optionalParams) {
        try {
            if (this.loggerController.isInfoEnabled()) this.loggerAPI.info.apply(this.loggerAPI, arguments);
        } catch (exception) {
        // Ignore
        }
    }
    /**
   * Implementation of LoggerAPI#warn() for use by connect-module-core code.
   */ warn(message, ...optionalParams) {
        try {
            this.loggerAPI.warn.apply(this.loggerAPI, arguments);
        } catch (exception) {
            const logger = console.warn || console.log;
            if (logger) logger.apply(logger, arguments);
        }
    }
    /**
   * Implementation of LoggerAPI#error() for use by connect-module-core code.
   */ error(message, ...optionalParams) {
        try {
            this.loggerAPI.error.apply(this.loggerAPI, arguments);
        } catch (exception) {
            const logger = console.error || console.log;
            if (logger) logger.apply(logger, arguments);
        }
    }
    constructor(){
        this.loggerController = void 0;
        this.loggerAPI = (0, $jDYJM.default);
        this.loggerController = new $8825011921e30ce8$var$LoggerController();
        window._loggerController = this.loggerController;
    }
}
const $8825011921e30ce8$export$af88d00dbe7f521 = new $8825011921e30ce8$var$LoggerAdaptor();
module.exports["logger"] = $8825011921e30ce8$export$af88d00dbe7f521;

});

parcelRegister("jDYJM", function(module, exports) {
$parcel$export(module.exports, "default", () => $14ab1827b564829e$export$2e2bcd8739ae039);
/* eslint-disable */ // @ts-nocheck
class $14ab1827b564829e$var$DefaultLoggerAPI {
    debug(message, ...optionalParams) {
        console.debug.apply(console, arguments);
    }
    info(message, ...optionalParams) {
        console.info.apply(console, arguments);
    }
    warn(message, ...optionalParams) {
        console.warn.apply(console, arguments);
    }
    error(message, ...optionalParams) {
        console.error.apply(console, arguments);
    }
}
var $14ab1827b564829e$export$2e2bcd8739ae039 = new $14ab1827b564829e$var$DefaultLoggerAPI();

});

parcelRegister("lEfEl", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $e33f058366d031a5$export$db71c19e7db05343 = (0, $kSwu1.defineMessages)({
    adminMessageWithAppName: {
        id: "connect-module-core.eos.adminMessageWithAppName",
        defaultMessage: "The {appName} app is running on a platform that'll be unsupported after December 2026. Check <connectedApps>Connected apps</connectedApps> to see what options are available for all similar apps."
    },
    adminMessageWithoutAppName: {
        id: "connect-module-core.eos.adminMessageWithoutAppName",
        defaultMessage: "This app is running on a platform that'll be unsupported after December 2026. Check <connectedApps>Connected apps</connectedApps> to see what options are available for all similar apps."
    },
    nonAdminMessageWithAppName: {
        id: "connect-module-core.eos.nonAdminMessageWithAppName",
        defaultMessage: "The {appName} app is running on a platform that'll be unsupported after December 2026. To explore your options, contact your site admin."
    },
    nonAdminMessageWithoutAppName: {
        id: "connect-module-core.eos.nonAdminMessageWithoutAppName",
        defaultMessage: "This app is running on a platform that'll be unsupported after December 2026. To explore your options, contact your site admin."
    },
    devCanaryMessage: {
        id: "connect-module-core.eos.devCanaryMessage",
        defaultMessage: "You're seeing this message because your tenant is enrolled in the <developerCanaryProgram>Developer Canary Program</developerCanaryProgram>. For updates on when this goes live in production, watch the <forgeChangelog>Forge changelog</forgeChangelog>."
    },
    dismiss: {
        id: "connect-module-core.eos.dismiss",
        defaultMessage: "Dismiss"
    },
    inlineSecondaryText: {
        id: "connect-module-core.eos.inlineSecondaryText",
        defaultMessage: "This app might stop working soon"
    }
});
module.exports["connectEosBannerMessages"] = $e33f058366d031a5$export$db71c19e7db05343;

});

parcelRegister("jAI8J", function(module, exports) {
/**
 * Set of system app addon keys.
 * These are special built-in applications that are part of the system.
 */ const $252ad196ad9bae6b$var$SYSTEM_APP_ADDON_KEYS = new Set([
    'jira-slack-integration',
    'com.atlassian.servicedesk.embedded',
    'com.atlassian.servicedesk.embedded.moderate',
    'stspg-jira-ops',
    'com.atlassian.jira.spreadsheets',
    'atlassian-outlook-integration',
    'com.codebarrel.addons.automation',
    'com.codebarrel.addons.automation.moderate',
    'opsgenie-jira-adapter',
    'opsgenie-jira-adapter.moderate',
    'halp.com',
    'halp.moderate.com',
    'msteams-jira',
    'com.atlassian.atlas.jira',
    'cello',
    'msteams-confluence',
    'opsgenie-incident-timeline-lab',
    'com.addonengine.analytics'
]);
function $252ad196ad9bae6b$export$4d755424ce1abae9(addonKey) {
    return $252ad196ad9bae6b$var$SYSTEM_APP_ADDON_KEYS.has(addonKey);
}
module.exports["isSystemApp"] = $252ad196ad9bae6b$export$4d755424ce1abae9;

});

parcelRegister("kksmx", function(module, exports) {
const $e82f7a932bbd9bed$export$66373c7c22b9de3c = '__LEGACY_MACRO_SSRED__';
const $e82f7a932bbd9bed$export$583da28e18e772e3 = (macroOutput, macroData)=>{
    if (macroOutput) return 'ssr-new';
    else if (macroData) return 'ssr-exp';
    return 'ssr-legacy';
};
const $e82f7a932bbd9bed$export$90da570939dfebac = (macroId)=>window[$e82f7a932bbd9bed$export$66373c7c22b9de3c]?.[macroId];
const $e82f7a932bbd9bed$export$b0e8f73fcaf60c5c = ({ macroId: macroId, renderType: renderType })=>{
    return null;
};
module.exports["getRenderType"] = $e82f7a932bbd9bed$export$583da28e18e772e3;
module.exports["getExtensionSSRMark"] = $e82f7a932bbd9bed$export$90da570939dfebac;
module.exports["ExtensionSSRMark"] = $e82f7a932bbd9bed$export$b0e8f73fcaf60c5c;

});

parcelRegister("c2cyb", function(module, exports) {
/* TemplateIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $7zsi1 = parcelRequire("7zsi1");


var $arQY7 = parcelRequire("arQY7");


var $cJ0FD = parcelRequire("cJ0FD");


var $kkFbH = parcelRequire("kkFbH");


var $dAyZN = parcelRequire("dAyZN");


var $8nXYN = parcelRequire("8nXYN");

const $41adb9ebadfabbfe$var$iconWrapperStyles = null;
const $41adb9ebadfabbfe$var$imageWrapperStyles = null;
const $41adb9ebadfabbfe$var$InjectedTemplateIcon = ({ template: template, isDisabled: isDisabled = false, size: size = 'medium' })=>{
    if (template.iconURL) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "template-icon-avatar",
        className: (0, $hekY6.default)([
            "_1wpz1y6m"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        appearance: "square",
        size: size,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _vchhusvi _2hwx1b66 _1o9zidpf _16jlidpf _1wpz1y6m _16qsglyw"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7zsi1.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        alt: "",
        src: template.iconURL || '',
        srcDark: template.darkModeIconURL || ''
    })))));
    else if (template.styleClass) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dAyZN.TemplateLegacyIcon), {
        size: size,
        template: template
    });
    else // Ideally, this code will never be used. However, if the BE response is missing an iconURL for some reason,
    // this will return an icon with a grey background color that looks like the icon for 3rd party templates.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8nXYN.DefaultIcon), {
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), {
        spacing: "spacious",
        color: "var(--ds-icon-inverse, #FFFFFF)",
        label: ""
    }));
};
// The avatar-item component, which actually renders TemplateIcon, passes a backgroundColor
// prop to the TemplateIcon. The TemplateIcon and InjectedTemplateIcon disregard this backgroundColor
// prop. Therefore, we can ignore the backgroundColor prop for memoization.
const $41adb9ebadfabbfe$var$areEqual = (prevProps, nextProps)=>{
    return prevProps.template === nextProps.template && prevProps.isDisabled === nextProps.isDisabled && prevProps.size === nextProps.size;
};
const $41adb9ebadfabbfe$export$17f8b5fdc0dde895 = /*#__PURE__*/ (0, $cozmU.memo)($41adb9ebadfabbfe$var$InjectedTemplateIcon, $41adb9ebadfabbfe$var$areEqual);
module.exports["TemplateIcon"] = $41adb9ebadfabbfe$export$17f8b5fdc0dde895;

});

parcelRegister("dAyZN", function(module, exports) {
/* TemplateLegacyIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $cozmU = parcelRequire("cozmU");

const $c41888ccf34d17d9$var$smallBackgroundSize = null;
const $c41888ccf34d17d9$var$mediumBackgroundSize = null;
const $c41888ccf34d17d9$var$largeBackgroundSize = null;
const $c41888ccf34d17d9$var$smallSize = null;
const $c41888ccf34d17d9$var$mediumSize = null;
const $c41888ccf34d17d9$var$largeSize = null;
const $c41888ccf34d17d9$var$styles = {
    classIconWrapperStyles: "_2mzuglyw",
    classIconStyles: "_2rkofajl",
    iconStyles: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _2hwx1b66 _1o9zidpf _16jlidpf _1wpz1y6m _16qsglyw"
};
const $c41888ccf34d17d9$var$backgroundSizeMapping = {
    small: $c41888ccf34d17d9$var$smallBackgroundSize,
    medium: $c41888ccf34d17d9$var$mediumBackgroundSize,
    large: $c41888ccf34d17d9$var$largeBackgroundSize
};
const $c41888ccf34d17d9$var$sizeMapping = {
    small: $c41888ccf34d17d9$var$smallSize,
    medium: $c41888ccf34d17d9$var$mediumSize,
    large: $c41888ccf34d17d9$var$largeSize
}; // The avatar-item component, which actually renders TemplateLegacyIcon, passes a backgroundColor
// prop to the TemplateLegacyIcon. The TemplateLegacyIcon disregards this backgroundColor
// prop. Therefore, we can ignore the backgroundColor prop for memoization.
const $c41888ccf34d17d9$var$areEqual = (prevProps, nextProps)=>{
    return prevProps.template === nextProps.template;
};
const $c41888ccf34d17d9$export$7da270837ef49506 = /*#__PURE__*/ (0, $cozmU.memo)(({ template: template, size: size = 'medium' })=>{
    const styleClass = template.styleClass || '';
    const itemModuleCompleteKey = template.itemModuleCompleteKey || '';
    const blueprintModuleCompleteKey = template.blueprintModuleCompleteKey || '';
    const contentBlueprintId = template.contentBlueprintId || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            $c41888ccf34d17d9$var$styles.iconStyles,
            $c41888ccf34d17d9$var$styles.classIconWrapperStyles,
            "template"
        ]),
        "data-item-module-complete-key": itemModuleCompleteKey,
        "data-blueprint-module-complete-key": blueprintModuleCompleteKey,
        "data-content-blueprint-id": contentBlueprintId,
        "data-testid": "template-icon-legacy"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            $c41888ccf34d17d9$var$styles.iconStyles,
            "_17261kzg _17lp134g _15d44clk",
            "_17261772 _17lp1wkm _15d4zabe",
            $c41888ccf34d17d9$var$styles.classIconStyles,
            styleClass
        ]),
        style: {
            "--_1sqmkfg": (0, $9aYkv.default)($c41888ccf34d17d9$var$smallSize),
            "--_1clui7k": (0, $9aYkv.default)($c41888ccf34d17d9$var$mediumSize),
            "--_1ok9ig": (0, $9aYkv.default)($c41888ccf34d17d9$var$largeSize),
            "--_10y2yj4": (0, $9aYkv.default)($c41888ccf34d17d9$var$smallBackgroundSize),
            "--_b7jail": (0, $9aYkv.default)($c41888ccf34d17d9$var$mediumBackgroundSize),
            "--_w9udt4": (0, $9aYkv.default)($c41888ccf34d17d9$var$largeBackgroundSize)
        }
    }));
}, $c41888ccf34d17d9$var$areEqual);
module.exports["TemplateLegacyIcon"] = $c41888ccf34d17d9$export$7da270837ef49506;

});

parcelRegister("8nXYN", function(module, exports) {
/* TemplateIconStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $cozmU = parcelRequire("cozmU");

const $978a137b0603779d$var$defaultIconCss = null;
const $978a137b0603779d$var$smallSize = null;
const $978a137b0603779d$var$mediumSize = null;
const $978a137b0603779d$var$largeSize = null;
const $978a137b0603779d$var$iconStyles = null;
const $978a137b0603779d$var$sizeMapping = {
    small: $978a137b0603779d$var$smallSize,
    medium: $978a137b0603779d$var$mediumSize,
    large: $978a137b0603779d$var$largeSize
};
const $978a137b0603779d$export$d206ce4c12e8ddf6 = ({ children: children, size: size = 'medium' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "template-icon-default",
        className: (0, $hekY6.default)([
            "_2rkofajl _ca0q1b66 _y3gn1h6o _bfhk1i45",
            "_17261kzg _17lp134g _15d44clk",
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _2hwx1b66 _1o9zidpf _16jlidpf _1wpz1y6m _16qsglyw"
        ]),
        style: {
            "--_1sqmkfg": (0, $9aYkv.default)($978a137b0603779d$var$smallSize),
            "--_1clui7k": (0, $9aYkv.default)($978a137b0603779d$var$mediumSize),
            "--_1ok9ig": (0, $9aYkv.default)($978a137b0603779d$var$largeSize)
        }
    }, children);
};
module.exports["DefaultIcon"] = $978a137b0603779d$export$d206ce4c12e8ddf6;

});

parcelRegister("6Ywr0", function(module, exports) {

var $3d5UI = parcelRequire("3d5UI");

function $bb082ed2371b78b6$export$dfb0c4efd029859d(module) {
    try {
        window.require(module);
        return true;
    } catch (err) {
        return false;
    }
}
function $bb082ed2371b78b6$export$2b551419a2839406({ listener: listener, module: module, interval: interval = 250 }, callback) {
    (0, $3d5UI.waitForGlobal)({
        listener: `wait-for-required-module ${module}`,
        globalProperty: 'require'
    }, ()=>{
        if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
            callback();
            return;
        }
        const waitForRequiredModuleInterval = setInterval(()=>{
            if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
                clearInterval(waitForRequiredModuleInterval);
                callback();
            }
        }, interval);
    });
}
module.exports["isRequiredModuleLoaded"] = $bb082ed2371b78b6$export$dfb0c4efd029859d;
module.exports["waitForRequiredModule"] = $bb082ed2371b78b6$export$2b551419a2839406;

});

parcelRegister("10Oe6", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $dOBRD = parcelRequire("dOBRD");


var $5cryL = parcelRequire("5cryL");


var $9wGTI = parcelRequire("9wGTI");


var $iacta = parcelRequire("iacta");


var $ae5hk = parcelRequire("ae5hk");

const $f4c21c880d0229da$var$i18n = (0, $kSwu1.defineMessages)({
    featuredCategoryName: {
        id: "template-utils.featured.category.name",
        defaultMessage: "Featured"
    },
    myTemplatesCategoryName: {
        id: "template-utils.my-templates.category.name",
        defaultMessage: "My Templates"
    },
    starredCategoryName: {
        id: "template-utils.starred.category.name",
        defaultMessage: "Starred"
    },
    promotedCategoryName: {
        id: "template-utils.promoted.category.name",
        defaultMessage: "Promoted"
    }
});
const $f4c21c880d0229da$export$612b286afa12407b = '00000000-0000-0000-0000-000000000001';
const $f4c21c880d0229da$export$3b0b898c62947fee = (templateId)=>!/^[0-9]+$/.test(templateId);
const $f4c21c880d0229da$export$47ee581a4caa8fa2 = (templateId)=>!templateId || templateId === '';
const $f4c21c880d0229da$export$13d482a11efa2b43 = (template)=>{
    return template?.blueprintModuleCompleteKey || template?.templateId || template?.itemModuleCompleteKey || '';
};
const $f4c21c880d0229da$export$c095b4283dffab05 = (template)=>{
    return template.contentBlueprintId || template.templateId || '';
};
const $f4c21c880d0229da$export$3abed2086f3435f9 = (template)=>{
    if (!template) return null;
    if (template.templateType === 'blueprint' && template.hasGlobalBlueprintContent && template.contentBlueprintId !== $f4c21c880d0229da$export$612b286afa12407b) return template.blueprintModuleCompleteKey ?? null;
    return $f4c21c880d0229da$export$c095b4283dffab05(template);
};
const $f4c21c880d0229da$export$f19afdee92cfd543 = (templates, selectedSortOrder)=>{
    const nonFeaturedTemplates = [];
    const promotedTemplates = [];
    const customTemplates = [];
    templates.forEach((template)=>{
        if (template.categoryIds.includes('template.category.promoted') || template.categoryIds.includes('template.category.custom')) {
            if (!template.categoryIds.includes((0, $iacta.FEATURED_CATEGORY_ID))) template.categoryIds.push((0, $iacta.FEATURED_CATEGORY_ID));
            // We want to show all promoted templates first, regardless of
            // whether or not the template is custom
            if (template.categoryIds.includes('template.category.promoted')) promotedTemplates.push(template);
            else customTemplates.push(template);
        } else nonFeaturedTemplates.push(template);
    });
    // If alphabetical sort is on, we don't care to show featured categories first
    if (selectedSortOrder !== (0, $ae5hk.SortOrders).ALPHABETICAL_SORT) return [
        ...promotedTemplates,
        ...customTemplates,
        ...nonFeaturedTemplates
    ];
    else return templates;
};
const $f4c21c880d0229da$export$6d6fdbfe01edf136 = (templates, currentUserId, additionalTemplateIdsList)=>{
    templates.forEach((t)=>{
        const isStarredTemplateOrCreatedByCurrentUser = t.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || // checks for recently unstarred templates that we still want to display
        additionalTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(t)) || t.author === currentUserId;
        if (isStarredTemplateOrCreatedByCurrentUser && !t.categoryIds.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) t.categoryIds.push((0, $iacta.MY_TEMPLATES_CATEGORY_ID));
    });
};
const $f4c21c880d0229da$export$dea26c1eb71953eb = (templates)=>templates?.filter((template)=>template.categoryIds.includes('template.category.promoted') || template.categoryIds.includes('template.category.custom')).length;
const $f4c21c880d0229da$export$e4f285fe1dc6eb6 = (templates, currentUserId)=>templates?.filter((template)=>template.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || template.author === currentUserId).length;
const $f4c21c880d0229da$export$c5981f9aba761c29 = (availableCategories, lastSelectedCategoryIds)=>availableCategories.filter((category)=>lastSelectedCategoryIds.includes(category.id)).map((category)=>category.id);
const $f4c21c880d0229da$export$cdc91788760e8bf8 = (0, $dOBRD.default)((templates, additionalTemplateIdsList)=>{
    return templates.filter((t)=>t.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || additionalTemplateIdsList.has($f4c21c880d0229da$export$3abed2086f3435f9(t)));
});
const $f4c21c880d0229da$export$1caa21769d3bff9a = (templates, categoryIds, selectedSortOrder, currentUserId, additionalTemplateIdsList)=>{
    if (!categoryIds.length) return templates;
    if (categoryIds?.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) $f4c21c880d0229da$export$6d6fdbfe01edf136(templates, currentUserId, additionalTemplateIdsList);
    const isFeaturedCategorySelected = categoryIds?.includes((0, $iacta.FEATURED_CATEGORY_ID));
    const templatesToBeFiltered = isFeaturedCategorySelected ? $f4c21c880d0229da$export$f19afdee92cfd543(templates, selectedSortOrder) : templates;
    return templatesToBeFiltered?.filter((template)=>template?.categoryIds?.some((categoryId)=>categoryIds?.includes(categoryId) || additionalTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(template))));
};
const $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter = (categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId, additionalUnstarredTemplateIdsList)=>{
    const isRecentlyUnstarred = additionalUnstarredTemplateIdsList && additionalUnstarredTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(template));
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.starredCategoryName)) && isFavourite || isRecentlyUnstarred) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.starredCategoryName));
    else if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.promotedCategoryName)) && isPromoted) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.promotedCategoryName));
    const isFeaturedCategoryTemplate = categoryIds.includes('template.category.promoted') || categoryIds.includes('template.category.custom');
    const isMyTemplatesCategoryTemplate = categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || author === currentUserId;
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.featuredCategoryName)) && isFeaturedCategoryTemplate) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.featuredCategoryName));
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.myTemplatesCategoryName)) && isMyTemplatesCategoryTemplate) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.myTemplatesCategoryName));
    const keywordsIncludesSearchQuery = (keyword)=>keyword?.toLowerCase().includes(lowercaseQuery);
    return keywords.some(keywordsIncludesSearchQuery);
};
const $f4c21c880d0229da$export$698b1171e770b401 = (query, intl, currentUserId, additionalUnstarredTemplateIdsList)=>{
    return (template)=>{
        const lowercaseQuery = query.toLowerCase();
        const name = template.name || '';
        const description = template.description || '';
        const author = template.author || '';
        const keywords = template.keywords || [];
        const categoryIds = template.categoryIds || [];
        const isFavourite = template.isFavourite || false;
        const isPromoted = template.isPromoted || false;
        const blueprintAuthor = template.blueprintModuleCompleteKey ? author : '';
        const keywordsIncludeSearchQuery = $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter(categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId, additionalUnstarredTemplateIdsList);
        return name.toLowerCase().includes(lowercaseQuery) || description.toLowerCase().includes(lowercaseQuery) || blueprintAuthor.toLowerCase().includes(lowercaseQuery) || keywordsIncludeSearchQuery;
    };
};
const $f4c21c880d0229da$export$bf559da1453b0f39 = (0, $dOBRD.default)((templates, intl, currentUserId, searchQuery, additionalUnstarredTemplateIdsList)=>{
    if (searchQuery) {
        const searchQueryFilter = $f4c21c880d0229da$export$698b1171e770b401(searchQuery, intl, currentUserId, additionalUnstarredTemplateIdsList);
        templates = templates.filter(searchQueryFilter);
    }
    return templates;
});
const $f4c21c880d0229da$export$23b29992d53f1142 = (template, intl, currentUserId, searchQuery)=>{
    if (!searchQuery) return {
        searchQueryMatchesTitle: false,
        searchQueryMatchesDescription: false,
        searchQueryMatchesAuthor: false,
        searchQueryMatchesKeywords: false
    };
    const lowercaseQuery = searchQuery.toLowerCase();
    const name = template.name || '';
    const description = template.description || '';
    const author = template.author || '';
    const keywords = template.keywords || [];
    const categoryIds = template.categoryIds || [];
    const isFavourite = template.isFavourite;
    const isPromoted = template.isPromoted;
    const keywordsIncludeSearchQuery = $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter(categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId);
    return {
        searchQueryMatchesTitle: name.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesDescription: description.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesAuthor: author.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesKeywords: keywordsIncludeSearchQuery
    };
};
const $f4c21c880d0229da$export$16f4535f1b52f11d = (0, $dOBRD.default)((templates, includeEditorTutorialTemplate, selectedSortOrder)=>{
    // filter out null templates
    const nonNullTemplates = templates.filter((template)=>!!template);
    const tutorialIndex = nonNullTemplates.findIndex((element)=>// only one should appear at the same time
        (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? element.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED) : element.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY));
    if (tutorialIndex === -1) return nonNullTemplates;
    const tutorial = nonNullTemplates[tutorialIndex];
    // Remove the editor tutorial template if it shouldn't be included
    if (!includeEditorTutorialTemplate) {
        nonNullTemplates.splice(tutorialIndex, 1);
        return nonNullTemplates;
    }
    // If the sorting order is not alphabetical
    if (selectedSortOrder !== (0, $ae5hk.SortOrders).ALPHABETICAL_SORT) {
        // Remove the tutorial template, and then add it to the front.
        nonNullTemplates.splice(tutorialIndex, 1);
        nonNullTemplates.unshift(tutorial);
    }
    return nonNullTemplates;
});
const $f4c21c880d0229da$export$9b34fbf9a069b426 = (0, $dOBRD.default)((templates, allowList)=>{
    if (!allowList.length) return templates;
    return templates.filter((template)=>allowList.includes($f4c21c880d0229da$export$13d482a11efa2b43(template)));
});
const $f4c21c880d0229da$export$d444d78112a48f41 = (template)=>{
    if (template.blueprintModuleCompleteKey) return {
        idType: 'blueprint',
        id: template.blueprintModuleCompleteKey
    };
    if (template.templateId) return {
        idType: 'template',
        id: template.templateId
    };
    return {
        idType: 'other',
        id: template.itemModuleCompleteKey
    };
};
const $f4c21c880d0229da$export$9fd27f38e4a8e848 = (templates, favouritedTemplatesList)=>{
    // filter out null templates
    const filteredTemplates = templates.filter((template)=>!!template);
    if (!favouritedTemplatesList) return filteredTemplates;
    return filteredTemplates.map((template)=>{
        const isFavourite = favouritedTemplatesList.some((favouritedTemplateId)=>favouritedTemplateId === $f4c21c880d0229da$export$3abed2086f3435f9(template));
        // avoid re-adding starred category to a template that has already been starred
        const categoryIds = template.categoryIds.filter((category)=>category !== (0, $iacta.STARRED_CATEGORY_ID));
        if (isFavourite) categoryIds.push((0, $iacta.STARRED_CATEGORY_ID));
        return {
            ...template,
            isFavourite: isFavourite,
            categoryIds: categoryIds
        };
    });
};
module.exports["BLOG_CONTENT_BLUEPRINT_ID"] = $f4c21c880d0229da$export$612b286afa12407b;
module.exports["isBlueprint"] = $f4c21c880d0229da$export$3b0b898c62947fee;
module.exports["getTemplateKey"] = $f4c21c880d0229da$export$13d482a11efa2b43;
module.exports["getTemplateId"] = $f4c21c880d0229da$export$c095b4283dffab05;
module.exports["getTemplateIdForUserPreferences"] = $f4c21c880d0229da$export$3abed2086f3435f9;
module.exports["getFeaturedCategoryCount"] = $f4c21c880d0229da$export$dea26c1eb71953eb;
module.exports["getMyTemplatesCategoryCount"] = $f4c21c880d0229da$export$e4f285fe1dc6eb6;
module.exports["getExistingCategoryIds"] = $f4c21c880d0229da$export$c5981f9aba761c29;
module.exports["filterTemplatesByCategoryIds"] = $f4c21c880d0229da$export$1caa21769d3bff9a;
module.exports["filterTemplatesBySearchQuery"] = $f4c21c880d0229da$export$bf559da1453b0f39;
module.exports["getSearchQueryMatches"] = $f4c21c880d0229da$export$23b29992d53f1142;
module.exports["filterEditorTutorialTemplate"] = $f4c21c880d0229da$export$16f4535f1b52f11d;
module.exports["filterTemplatesByAllowList"] = $f4c21c880d0229da$export$9b34fbf9a069b426;
module.exports["getTemplateIdAttributesForAnalytics"] = $f4c21c880d0229da$export$d444d78112a48f41;
module.exports["updateFavouriteTemplates"] = $f4c21c880d0229da$export$9fd27f38e4a8e848;

});

parcelRegister("iacta", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");

const $1c68435f253b2047$export$b1a62972d9cddd78 = 'template.category.featured';
const $1c68435f253b2047$export$5aacf8f53708daf0 = 'template.category.my-templates';
const $1c68435f253b2047$export$c2a29eb4a43ff314 = 'template.category.starred';
const $1c68435f253b2047$export$d01d2d40a80eb4a1 = (0, $dOBRD.default)((templates, categories, mandatoryCategoryIdToShow = '')=>{
    const categoryIdToCountMap = {};
    for (const template of templates)// eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
    for (const categoryId of template.categoryIds){
        if (!categoryId) continue;
        if (!categoryIdToCountMap[categoryId]) categoryIdToCountMap[categoryId] = 0;
        categoryIdToCountMap[categoryId]++;
    }
    const countedCategories = [];
    for (const category of categories){
        if (!category?.id || !category?.name) continue;
        const count = categoryIdToCountMap[category.id];
        const shouldForceShowCategory = category.id === mandatoryCategoryIdToShow;
        if (count || shouldForceShowCategory) countedCategories.push({
            id: category.id,
            name: category.name,
            count: count
        });
    }
    return countedCategories;
});
const $1c68435f253b2047$export$b36f54982a81becd = (categoryId, categories)=>{
    return Object.values(categories).some((existingCategory)=>existingCategory.id === categoryId);
};
module.exports["FEATURED_CATEGORY_ID"] = $1c68435f253b2047$export$b1a62972d9cddd78;
module.exports["MY_TEMPLATES_CATEGORY_ID"] = $1c68435f253b2047$export$5aacf8f53708daf0;
module.exports["STARRED_CATEGORY_ID"] = $1c68435f253b2047$export$c2a29eb4a43ff314;
module.exports["getCountedCategories"] = $1c68435f253b2047$export$d01d2d40a80eb4a1;
module.exports["isCategoryIdInCategories"] = $1c68435f253b2047$export$b36f54982a81becd;

});

parcelRegister("4eJH6", function(module, exports) {
var $7dcc17f1ea6ba5ae$export$b573856c46cc9357 = /*#__PURE__*/ function(CalendarView) {
    CalendarView["dayGridMonth"] = "dayGridMonth";
    CalendarView["timeGridWeek"] = "timeGridWeek";
    CalendarView["listMonth"] = "listMonth";
    CalendarView["list"] = "list";
    CalendarView["timeline"] = "timeline";
    return CalendarView;
}({});
var $7dcc17f1ea6ba5ae$export$2f3a5af09227bbc8 = /*#__PURE__*/ function(CalendarViewPreference) {
    CalendarViewPreference["month"] = "month";
    CalendarViewPreference["agendaWeek"] = "agendaWeek";
    CalendarViewPreference["basicDay"] = "basicDay";
    CalendarViewPreference["timeline"] = "timeline";
    return CalendarViewPreference;
}({});
module.exports["CalendarView"] = $7dcc17f1ea6ba5ae$export$b573856c46cc9357;
module.exports["CalendarViewPreference"] = $7dcc17f1ea6ba5ae$export$2f3a5af09227bbc8;

});

parcelRegister("5ozYM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $5hAil = parcelRequire("5hAil");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $cEgMD = parcelRequire("cEgMD");


var $d5RCH = parcelRequire("d5RCH");


var $1ytiN = parcelRequire("1ytiN");


var $3zetf = parcelRequire("3zetf");

const $080ccb5c9f312cd0$var$i18n = (0, $kSwu1.defineMessages)({
    companyHubDefaultTitle: {
        id: "document-title.document-space-title.company-hub.title",
        defaultMessage: "Company hub"
    }
});
function $080ccb5c9f312cd0$export$7ce5f0b10eeaaf17({ spaceKey: spaceKey, titlePrefix: titlePrefix }) {
    const { siteTitle: siteTitle, companyHubName: companyHubName } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    //In the case when page is rendered by SSR, the __DOCUMENT_TITLE_TAG__ will be populated and we can skip document title.
    if (window['__DOCUMENT_TITLE_TAG__'] && window['__SSR_RENDERED__']) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).INHERIT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5hAil.QueryGroup), {
        queryProps: (0, $3zetf.getSpaceNameQueryProps)(spaceKey)
    }, ({ results: results, loading: loading })=>{
        if (loading) return null;
        const companyHubSpaceName = companyHubName || formatMessage($080ccb5c9f312cd0$var$i18n.companyHubDefaultTitle);
        const spaceName = isCompanyHub ? companyHubSpaceName : (0, $3zetf.getSpaceNameFromResults)(results);
        const title = [
            titlePrefix,
            spaceName,
            siteTitle
        ].filter((part)=>part).join(' - ');
        // set for SSR document title
        window.__DOCUMENT_TITLE_TAG__ = title;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5RCH.PageTitle), {
            title: title
        });
    }));
}
module.exports["DocumentSpaceTitle"] = $080ccb5c9f312cd0$export$7ce5f0b10eeaaf17;

});

parcelRegister("d5RCH", function(module, exports) {
function $69aebb91e74cbedb$export$155581e8dc02007a({ title: title }) {
    // document.title is safe to set during render:
    // - It's idempotent (setting the same value multiple times is safe)
    // - It doesn't trigger React re-renders
    // - Many React libraries do this (react-helmet, react-document-title, etc.)
    // - It's a browser API, not React state, so it doesn't violate React's rules
    // - The last component to render will have its title set, avoiding race conditions
    if (typeof document !== 'undefined' && title) document.title = title;
    return null;
}
module.exports["PageTitle"] = $69aebb91e74cbedb$export$155581e8dc02007a;

});

parcelRegister("3zetf", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $7ftOo = parcelRequire("7ftOo");

const $578f455bd7f79c76$export$64984dda48ed9108 = (results)=>{
    const errors = results.filter((result)=>result.error).map((result)=>result.error);
    if (errors.length) throw new Error(errors.join('\n\n'));
    return results[0]?.data?.space?.name || '';
};
const $578f455bd7f79c76$export$5e300c68d69bb755 = (spaceKey)=>{
    return [
        {
            query: (0, $7ftOo.SpaceNameQuery),
            variables: {
                spaceKey: spaceKey
            },
            skip: !spaceKey
        }
    ];
};
module.exports["getSpaceNameFromResults"] = $578f455bd7f79c76$export$64984dda48ed9108;
module.exports["getSpaceNameQueryProps"] = $578f455bd7f79c76$export$5e300c68d69bb755;

});

parcelRegister("7ftOo", function(module, exports) {

var $1QQ3D = parcelRequire("1QQ3D");

const $6a955c062718cf11$export$572a16972f8daeee = (0, $1QQ3D.default);
module.exports["SpaceNameQuery"] = $6a955c062718cf11$export$572a16972f8daeee;

});

parcelRegister("1QQ3D", function(module, exports) {
/**
 * @generated SignedSource<<37ab2e117a86d1dc715949d29203f432>>
 * @relayHash b9a37f70969ec1ccfea09d42d23ee047
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f211597d24101c497aaa6a30088a1b2c297fbb6197c83adc7a00aafa186acb5f
const $117903155ebb89ee$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceNameQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceNameQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "b9a37f70969ec1ccfea09d42d23ee047",
            "id": "f211597d24101c497aaa6a30088a1b2c297fbb6197c83adc7a00aafa186acb5f",
            "metadata": {},
            "name": "SpaceNameQuery",
            "operationKind": "query",
            "text": "query SpaceNameQuery($spaceKey:String!){space(key:$spaceKey){id,name,key}}"
        }
    };
}();
$117903155ebb89ee$var$node.hash = "0ef458e46db525bf3a5156fbd23b8cfc";
var $117903155ebb89ee$export$2e2bcd8739ae039 = $117903155ebb89ee$var$node;
module.exports["default"] = $117903155ebb89ee$export$2e2bcd8739ae039;

});

parcelRegister("lLRfG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $3PNw6 = parcelRequire("3PNw6");


var $78QFu = parcelRequire("78QFu");


var $7sK8i = parcelRequire("7sK8i");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $6VdZc = parcelRequire("6VdZc");


var $4XtQK = parcelRequire("4XtQK");


var $2O7Qv = parcelRequire("2O7Qv");

const $4291167636037428$var$PageLoadEndComponent = /*#__PURE__*/ (0, $cozmU.memo)(({ metric: metric, customData: customData = {}, stopTime: stopTime })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hasFiredRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredRef.current) return;
        hasFiredRef.current = true;
        if (metric) (0, $2O7Qv.addCustomTimingForMetric)(metric.key);
        (0, $3PNw6.addUFOCustomData)({
            ...customData,
            ...typeof stopTime === 'number' ? {
                stopTime: stopTime
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        });
        (0, $7sK8i.resumeLowPriorityEvents)();
    // Not adding exhaustive dependencies because we want this to fire only once,
    // despite any changes to `customData`
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        metric
    ]);
    (0, $4XtQK.reportHydrationError)(createAnalyticsEvent, metric?.key);
    return null;
});
const $4291167636037428$export$570dec5b65c6715b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($4291167636037428$var$PageLoadEndComponent);
module.exports["PageLoadEnd"] = $4291167636037428$export$570dec5b65c6715b;

});

parcelRegister("4XtQK", function(module, exports) {

var $5ZqQS = parcelRequire("5ZqQS");


var $dtDUi = parcelRequire("dtDUi");


var $6mKj3 = parcelRequire("6mKj3");

function $433efe87b2d05424$export$e885a680acb7d12e(createAnalyticsEvent, metricKey) {
    if (!(window?.__SSR_RENDERED__ && Boolean(window.__HYDRATION_FAILED__))) return;
    const { error: errorWithRoute, route: route } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
    const attribution = window.__SSR_REACT_STREAMING__ ? 'streaming-hydration' : 'hydration';
    if ((0, $6mKj3.expVal)('confluence_frontend_hydration_failure_reporting', 'isEnabled', false)) createAnalyticsEvent((0, $dtDUi.getHydrationFailureOperationalEvent)({
        source: `PageLoadEnd - ${metricKey}`,
        route: route,
        errorWithRoute: errorWithRoute,
        isSSRReactStreaming: Boolean(window.__SSR_REACT_STREAMING__)
    })).fire();
    else (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute, {
        attribution: attribution
    });
}
module.exports["reportHydrationError"] = $433efe87b2d05424$export$e885a680acb7d12e;

});

parcelRegister("2w2Hu", function(module, exports) {
/**
 * These are loadable names that cross reference by multiple places.
 * They were kept as constants here instead of automatically generated for consistency.
 * ONLY put names here if they are going to be used in _mustPreloadWhenRenderingSPA.
 */ const $8cf96aaaf31dfd76$export$75ebf2388340a0ba = {
    ClassicRendererLoader: 'ClassicRendererLoader',
    ClassicEditorContextProviderLoader: 'ClassicEditorContextProviderLoader',
    NativeCollabLoader: 'NativeCollabLoader',
    FullPageEditorLoader: 'FullPageEditorLoader',
    ViewPageRouteComponentLoader: 'ViewPageRouteComponentLoader',
    LivePageComponentLoader: 'LivePageComponentLoader',
    EditorByLineArea: 'EditorByLineArea'
};
module.exports["MustPreloadLoadableNames"] = $8cf96aaaf31dfd76$export$75ebf2388340a0ba;

});

parcelRegister("ZJvdP", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $543e3a9ad9cfc398$export$3ad73c971369d052 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "sYDyD",
    name: "PageIncludeMacroHandler",
    loader: async ()=>(await (parcelRequire("gIDv4"))).PageIncludeMacroRenderer
});
module.exports["PageIncludeMacroHandler"] = $543e3a9ad9cfc398$export$3ad73c971369d052;

});

parcelRegister("gIDv4", function(module, exports) {

let $c2bf65516d0474fe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c2bf65516d0474fe$var$load("5h4De").then(()=>parcelRequire('doY9Y'));

});

parcelRegister("8Ksv7", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $11414ac1857ca883$export$cfa4ed6e2f4ad26 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "lJE6O",
    name: "BlogPostsMacroHandler",
    loader: async ()=>(await (parcelRequire("c1Bch"))).BlogPostsMacroRenderer
});
module.exports["BlogPostsMacroHandler"] = $11414ac1857ca883$export$cfa4ed6e2f4ad26;

});

parcelRegister("c1Bch", function(module, exports) {

let $8c126e9630edc242$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8c126e9630edc242$var$load("iUXaE"),
    $8c126e9630edc242$var$load("lTkx9"),
    $8c126e9630edc242$var$load("1GCFv"),
    $8c126e9630edc242$var$load("bV5bW"),
    $8c126e9630edc242$var$load("28h7Y")
]).then(()=>parcelRequire('5iRsI'));

});

parcelRegister("jJli4", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $f9KPY = parcelRequire("f9KPY");


const $7549d063fe593b21$export$2800e3d415e59020 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "8zrD8",
    name: "ExcerptIncludeLoader",
    loader: async ()=>(await (parcelRequire("jEo2C"))).ExcerptInclude,
    // Component shadow is a subset of ExcerptIncludeProps so this would generate a TS error here as Loadable
    // expects the prop types to match.
    // @ts-expect-error
    loading: (0, $f9KPY.ExcerptIncludeComponentShadow)
});
module.exports["ExcerptIncludeLoader"] = $7549d063fe593b21$export$2800e3d415e59020;

});

parcelRegister("f9KPY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $lOkIA = parcelRequire("lOkIA");


var $dhEYL = parcelRequire("dhEYL");

class $747c563e4499b240$export$8f88facf076a2d46 extends (0, $cozmU.PureComponent) {
    render() {
        const { shouldPanelBeDisplayed: shouldPanelBeDisplayed, targetContentTitle: targetContentTitle } = this.props;
        return shouldPanelBeDisplayed ? // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "data-testid": "excerpt-include-panel",
            style: (0, $dhEYL.panel)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            style: (0, $dhEYL.panelHeader)
        }, targetContentTitle || // eslint-disable-next-line check-i18n-id-prefix/i18n-id-prefix-with-package-name-FormattedMessage
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "editor.excerpt.include.panel.title.loading"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            style: (0, $dhEYL.panelBody)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lOkIA.CenteredSpinner), {
            size: "medium",
            style: {
                minHeight: 100
            }
        }))) : // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lOkIA.CenteredSpinner), {
            size: "medium",
            style: {
                minHeight: 100
            }
        });
    }
}
module.exports["ExcerptIncludeComponentShadow"] = $747c563e4499b240$export$8f88facf076a2d46;

});

parcelRegister("dhEYL", function(module, exports) {
const $9b021e0aba5455d5$export$21f42ab9b6679f44 = {
    display: 'block',
    // DEBUGGING
    borderWidth: "var(--ds-border-width, 1px)",
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    borderRadius: "var(--ds-radius-small, 3px)",
    borderStyle: 'solid',
    borderColor: "var(--ds-border, #0B120E24)",
    borderImage: 'initial'
};
const $9b021e0aba5455d5$export$92937d9937dc7ce9 = {
    display: 'block',
    // DEBUGGING
    backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    minWidth: '128px',
    padding: "var(--ds-space-100, 8px)",
    font: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $9b021e0aba5455d5$export$d763905bda51ef54 = {
    display: 'block',
    // DEBUGGING
    minWidth: '128px',
    borderWidth: `${"var(--ds-border-width, 1px)"} 0px 0px 0px`,
    borderStyle: 'solid',
    borderColor: "var(--ds-border, #0B120E24)",
    padding: "var(--ds-space-100, 8px)"
};
const $9b021e0aba5455d5$export$99e3f651fb62ec86 = {
    color: "var(--ds-text-subtlest, #6B6E76)",
    paddingLeft: "var(--ds-space-050, 4px)"
};
module.exports["panel"] = $9b021e0aba5455d5$export$21f42ab9b6679f44;
module.exports["panelHeader"] = $9b021e0aba5455d5$export$92937d9937dc7ce9;
module.exports["panelBody"] = $9b021e0aba5455d5$export$d763905bda51ef54;
module.exports["panelHeaderExcerpt"] = $9b021e0aba5455d5$export$99e3f651fb62ec86;

});

parcelRegister("jEo2C", function(module, exports) {

let $e4e466d71636e334$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e4e466d71636e334$var$load("he34V"),
    $e4e466d71636e334$var$load("79Tk4"),
    $e4e466d71636e334$var$load("hZ2FX"),
    $e4e466d71636e334$var$load("6wr18"),
    $e4e466d71636e334$var$load("ffEVr"),
    $e4e466d71636e334$var$load("Wowvf"),
    $e4e466d71636e334$var$load("lbsQO"),
    $e4e466d71636e334$var$load("9tNcH")
]).then(()=>parcelRequire('c6u22'));

});

parcelRegister("5LTS4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $6VdZc = parcelRequire("6VdZc");


var $4JC0x = parcelRequire("4JC0x");


var $1xpoY = parcelRequire("1xpoY");


var $bF1aY = parcelRequire("bF1aY");


var $h8C1D = parcelRequire("h8C1D");


var $kksmx = parcelRequire("kksmx");

const $ebb4d303074e1a0c$var$NOT_SSRED = 'none';
const $ebb4d303074e1a0c$var$NOT_SSRED_BLOCKED = 'ssr-blocked';
// Limit performance tracking for only top 10 extensions on initial load.
// The value is semi-arbitrary, as this is +2 to the number of extensions
// we attempt to SSR on initial load - this will give us an idea how the
// non-SSRed extensions are performing.
// This will lead to ~39% more tracking events send overall, comparing to
// 50/50 rollout we had before, but will prevent from sending huge amount
// of events for individual pages with a lot of extensions.
const $ebb4d303074e1a0c$var$TRACKING_LIMIT = 10;
const $ebb4d303074e1a0c$var$isBlocklisted = (ssrPreloadFailure)=>ssrPreloadFailure?.startsWith('blocklist') ? $ebb4d303074e1a0c$var$NOT_SSRED_BLOCKED : $ebb4d303074e1a0c$var$NOT_SSRED;
// This check is being made only upon initial render, and therefore is sufficient for
// checking whether element (in our case the marker) appears above the fold when rendered.
const $ebb4d303074e1a0c$var$isMarkerAboveTheFold = (el)=>{
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight));
};
const $ebb4d303074e1a0c$var$getPerformanceEntry = (entryName)=>{
    if (performance && typeof performance.getEntriesByName === 'function') return performance.getEntriesByName(entryName);
    return [];
};
const $ebb4d303074e1a0c$export$64e91845ba744516 = ({ node: node, contentId: contentId, extensionKey: extensionKey })=>{
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { localId: localId } = node;
    const macroId = node.parameters?.macroMetadata?.macroId?.value;
    const extensionBlocklist = (0, $1xpoY.default).getString('confluence-extensions-server-render-blocklist', '');
    const markerRef = (0, $cozmU.useRef)(null);
    const { extensionIndex: extensionIndex, isUnsupportedExtension: isUnsupportedExtension } = (0, $h8C1D.useExtensionIndex)(macroId);
    const doNotTrackExtension = extensionIndex === (0, $h8C1D.UNKNOWN_INDEX) || extensionIndex >= $ebb4d303074e1a0c$var$TRACKING_LIMIT;
    (0, $cozmU.useEffect)(()=>{
        // NOTE: as of now, this metric is tailored to monitoring the performance of extensions
        // on initial load. We're not planning to use this metric in any way on transitions yet
        // thus we don't want to spam analytics with the data we don't use.
        if (doNotTrackExtension || !(0, $6VdZc.isInitial)()) return;
        // WARN: Complexity alert! The logic of fmp/tti/duration calculation is convoluted
        // here because of several reasons. Due to the timing of creating performance marks
        // that we use here, we may report extension timing *before* TTI measure is evaluated,
        // since TTI measure is waiting for several page segments. Thus on initial load we have
        // to rely on other reference points, that are available before extensions are rendered.
        const pageTTI = (0, $6VdZc.isInitial)() ? $ebb4d303074e1a0c$var$getPerformanceEntry('rendererRendered.end')?.pop()?.startTime : $ebb4d303074e1a0c$var$getPerformanceEntry('browser-metric:tti')?.pop()?.duration;
        const pageFMP = (0, $6VdZc.isInitial)() ? $ebb4d303074e1a0c$var$getPerformanceEntry('CFP-63.ssr-ttr')?.pop()?.startTime : pageTTI;
        const clientRouteStart = $ebb4d303074e1a0c$var$getPerformanceEntry('browser-metric.start')?.pop()?.startTime;
        const ssrPreloadFailure = (0, $4JC0x.getPreloadFailures)(macroId) || '';
        const ssrGeneralFailure = (0, $4JC0x.getGeneralFailures)() || '';
        const isExtensionSSRed = (0, $6VdZc.isInitial)() ? (0, $kksmx.getExtensionSSRMark)(macroId) || $ebb4d303074e1a0c$var$isBlocklisted(ssrPreloadFailure) : $ebb4d303074e1a0c$var$NOT_SSRED;
        // On transition we cannot reliably expect that "browser-metric:tti" measure is there
        // before macro rendering. Thus, use routing start as a base point for extension performance
        // measurement on transition. Note that FMP=TTI on transition.
        const startTime = ((0, $6VdZc.isInitial)() ? pageFMP : clientRouteStart) ?? 0;
        const customData = {
            isExtensionSSRed: isExtensionSSRed,
            extensionIndex: extensionIndex,
            extensionKey: extensionKey,
            contentId: contentId,
            pageFMP: pageFMP ?? 0,
            pageTTI: pageTTI ?? 0,
            isATF: $ebb4d303074e1a0c$var$isMarkerAboveTheFold(markerRef.current),
            ssrPreloadFailure: isUnsupportedExtension ? 'unsupportedContentInternalExtension' : ssrPreloadFailure || ssrGeneralFailure,
            clientRouteStart: clientRouteStart ?? 0,
            hydratable: window?.__HYDRATABLE__ || false,
            hydrationFailed: window?.__HYDRATION_FAILED__ || false
        };
        const metric = (0, $bF1aY.LEGACY_EXTENSION_LOADING_METRIC)(`${extensionKey}.${contentId}.${localId}`);
        metric.start({
            startTime: startTime
        });
        metric.stop({
            customData: customData
        });
    }, [
        doNotTrackExtension,
        extensionBlocklist,
        extensionKey,
        extensionIndex,
        isUnsupportedExtension,
        routeName,
        localId,
        contentId,
        macroId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        ref: markerRef
    });
};
module.exports["ExtensionLoadingComplete"] = $ebb4d303074e1a0c$export$64e91845ba744516;

});

parcelRegister("bF1aY", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $63112e910a0def69$export$841f5507db609445 = (0, $lSOAM.createConcurrentCustomMetric)({
    key: (0, $fd6g2.LEGACY_EXTENSION_LOADING_CUSTOM_KEY)
});
module.exports["LEGACY_EXTENSION_LOADING_METRIC"] = $63112e910a0def69$export$841f5507db609445;

});

parcelRegister("h8C1D", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $llqlc = parcelRequire("llqlc");


var $8pcS0 = parcelRequire("8pcS0");

const $028a91b33dee434b$export$7affafe0528b70b1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    indexes: new Map()
});
const $028a91b33dee434b$var$extractExtensions = (adf)=>(0, $llqlc.filter)(adf, (node)=>(0, $8pcS0.supportedExtensions).has(node.type));
const $028a91b33dee434b$export$e4ac003417d6dace = 'UNKNOWN';
const $028a91b33dee434b$export$981cab9712b3b1a3 = ({ document: document, children: children })=>{
    const indexes = (0, $cozmU.useMemo)(()=>{
        const extensions = $028a91b33dee434b$var$extractExtensions(document);
        return new Map(extensions.map((node, idx)=>{
            window['unsupportedExtension'] = window['unsupportedExtension'] || {};
            if (node.attrs?.parameters?.nestedContent?.content && node.attrs.extensionKey === '__confluenceADFMigrationUnsupportedContentInternalExtension__') node.attrs.parameters.nestedContent.content.forEach((each)=>{
                window['unsupportedExtension'][each.attrs?.parameters?.macroMetadata?.macroId?.value] = idx;
            });
            return [
                node.attrs?.parameters?.macroMetadata?.macroId?.value,
                idx
            ];
        }));
    }, [
        document
    ]);
    const value = (0, $cozmU.useMemo)(()=>({
            indexes: indexes
        }), [
        indexes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($028a91b33dee434b$export$7affafe0528b70b1.Provider, {
        value: value
    }, children);
};
const $028a91b33dee434b$export$ea9830505fbaa6ad = (macroId)=>{
    const { indexes: indexes } = (0, $cozmU.useContext)($028a91b33dee434b$export$7affafe0528b70b1);
    let index = indexes.get(macroId);
    const unsupportedExtensions = window['unsupportedExtension'];
    let isUnsupportedExtension = false;
    if (unsupportedExtensions && unsupportedExtensions[macroId]) {
        index = unsupportedExtensions[macroId];
        isUnsupportedExtension = true;
    }
    return {
        extensionIndex: typeof index === 'number' ? index : $028a91b33dee434b$export$e4ac003417d6dace,
        isUnsupportedExtension: isUnsupportedExtension
    };
};
module.exports["UNKNOWN_INDEX"] = $028a91b33dee434b$export$e4ac003417d6dace;
module.exports["ExtrensionIndexProvider"] = $028a91b33dee434b$export$981cab9712b3b1a3;
module.exports["useExtensionIndex"] = $028a91b33dee434b$export$ea9830505fbaa6ad;

});

parcelRegister("jxpvN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $205998aae8e9bd72$export$60bd66ed7962b851 = /*#__PURE__*/ (0, $cozmU.createContext)({
    includeTopNav: true
});
$205998aae8e9bd72$export$60bd66ed7962b851.displayName = 'BannerContext';
module.exports["BannerContext"] = $205998aae8e9bd72$export$60bd66ed7962b851;

});

parcelRegister("2tHI8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");

const $ba840c49dd70d4e9$export$322c13354cdebc20 = ()=>{
    const [panelHeight, setPanelHeight] = (0, $cozmU.useState)(()=>{
        if (typeof window !== 'undefined' && Boolean(window.__SSR_RENDERED__) && (0, $6mKj3.expValEquals)('confluence_editor_wrapper_ttvc_fix', 'isEnabled', true)) {
            const initialHeight = window['__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__'];
            return initialHeight ?? 0;
        }
        return 0;
    });
    (0, $cozmU.useEffect)(()=>{
        const updateHeight = (e)=>{
            if ((0, $6mKj3.expValEquals)('confluence_editor_wrapper_ttvc_fix', 'isEnabled', true)) // Use event detail height if available, otherwise fallback to 0
            setPanelHeight(e?.detail?.height ?? 0);
            else // Legacy behavior: read from CSS variable
            try {
                const heightValue = getComputedStyle(document.documentElement).getPropertyValue('--atl-general-webpanel-height');
                const numericValue = parseInt(heightValue, 10);
                setPanelHeight(!isNaN(numericValue) && numericValue >= 0 ? numericValue : 0);
            } catch (e) {
                setPanelHeight(0);
            }
        };
        !(0, $6mKj3.expValEquals)('confluence_editor_wrapper_ttvc_fix', 'isEnabled', true) && updateHeight();
        // Listen for height changes
        document.addEventListener('atlGeneralWebPanelHeightUpdated', updateHeight);
        return ()=>{
            document.removeEventListener('atlGeneralWebPanelHeightUpdated', updateHeight);
        };
    }, []);
    return panelHeight;
};
module.exports["useGeneralWebPanelHeight"] = $ba840c49dd70d4e9$export$322c13354cdebc20;

});

parcelRegister("cqCFf", function(module, exports) {
/* LiveSearchTemplate.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ /* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */ 
var $cozmU = parcelRequire("cozmU");


var $k12R1 = parcelRequire("k12R1");


var $kSwu1 = parcelRequire("kSwu1");


var $kyKWe = parcelRequire("kyKWe");


var $hAgam = parcelRequire("hAgam");


var $6wGOF = parcelRequire("6wGOF");


var $l9ukq = parcelRequire("l9ukq");


var $9DHhW = parcelRequire("9DHhW");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $9GVkD = parcelRequire("9GVkD");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $1AV5C = parcelRequire("1AV5C");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $6mKj3 = parcelRequire("6mKj3");


var $b3dss = parcelRequire("b3dss");


var $3uWLy = parcelRequire("3uWLy");


var $afqWO = parcelRequire("afqWO");


var $lHQkL = parcelRequire("lHQkL");


var $3EYav = parcelRequire("3EYav");


var $047Sb = parcelRequire("047Sb");

const $ea51fe5225a56158$var$CONFLUENCE_ARI = 'ari:cloud:confluence::site/'; // Value of these constants is important for proper handling of input events for live search
const $ea51fe5225a56158$export$f96974a826589f12 = 'live-search-macro';
const $ea51fe5225a56158$export$914adcd8d06245e4 = 'search-macro-button';
const $ea51fe5225a56158$var$controlStyles = {
    root: "_bfw71uh4 _8vu41qi0 _irr3l4ek",
    focused: "_bfw7z0c1 _irr31j9a"
};
const $ea51fe5225a56158$var$MediumControl = ({ children: children, ...props })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).Control, {
        ...props,
        xcss: (0, $k12R1.cx)($ea51fe5225a56158$var$controlStyles.root, props.isFocused && $ea51fe5225a56158$var$controlStyles.focused)
    }, children);
};
const $ea51fe5225a56158$var$LargeControl = ({ children: children, ...props })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $l9ukq.components).Control, {
        ...props,
        xcss: (0, $k12R1.cx)($ea51fe5225a56158$var$controlStyles.root, props.isFocused && $ea51fe5225a56158$var$controlStyles.focused)
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
        color: "var(--ds-icon-subtle, #505258)",
        label: intl.formatMessage((0, $lHQkL.i18n).searchIconLabel),
        spacing: "spacious"
    }), children);
};
const $ea51fe5225a56158$var$mediumSizeWrapperStyles = (0, $buxP3.xcss)({
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 'space.050',
    paddingBottom: 'space.050'
});
const $ea51fe5225a56158$var$largeSizeWrapperStyles = (0, $buxP3.xcss)({
    padding: 'space.050',
    display: 'block'
});
const $ea51fe5225a56158$export$f43084e69a1ba6f6 = ({ config: config })=>{
    const scriptRef = (0, $cozmU.useRef)(null);
    const selectRef = (0, $cozmU.useRef)(null);
    const { size: size, placeholder: placeholder } = config;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const confluenceInstance = $ea51fe5225a56158$var$CONFLUENCE_ARI.concat(cloudId);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [currentSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [searchResults, setSearchResults] = (0, $cozmU.useState)([]);
    const [loadState, setLoadState] = (0, $cozmU.useState)(true);
    const [searchInput, setSearchInput] = (0, $cozmU.useState)('');
    const [menuIsOpen, setMenuOpen] = (0, $cozmU.useState)(false);
    const [queryVersion, setQueryVersion] = (0, $cozmU.useState)(0);
    const [searchSessionId, setSearchSessionId] = (0, $cozmU.useState)((0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))());
    const intl = (0, $kSwu1.useIntl)();
    const handleClickNavigate = (0, $3EYav.handleNavigate)();
    const nonceValue = window.__SSR_NONCE_VALUE__;
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const isInEditMode = pageMode === (0, $cD1qu.PageMode).EDIT;
    (0, $cozmU.useEffect)(()=>{
        const closeResultsOnResize = ()=>{
            setMenuOpen(false);
        };
        window.addEventListener('resize', closeResultsOnResize);
        return ()=>window.removeEventListener('resize', closeResultsOnResize);
    }, []);
    const updateResults = (0, $cozmU.useCallback)((results)=>{
        setSearchResults(results);
        setQueryVersion(queryVersion + 1);
    }, [
        queryVersion
    ]);
    const handleMenuClose = (0, $cozmU.useCallback)(()=>{
        setSearchInput(searchInput);
        setSearchResults(searchResults);
        setQueryVersion(0);
        setMenuOpen(false);
        setSearchSessionId((0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))());
    }, [
        searchInput,
        searchResults
    ]);
    const onChange = async (str)=>{
        const input = str;
        setSearchInput(input);
        if (input.length > 2) {
            setLoadState(true);
            const { results: results, size: size } = await (0, $b3dss.handleAGGSearch)({
                searchInput: input,
                config: config,
                currentSpaceKey: currentSpaceKey,
                confluenceInstance: confluenceInstance
            });
            updateResults(results);
            setLoadState(false);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'shown',
                    actionSubject: 'liveSearchResults',
                    actionSubjectId: 'liveSearchQueryResults',
                    source: 'liveSearch',
                    attributes: {
                        source: 'liveSearch',
                        searchSessionId: searchSessionId,
                        queryHash: (0, $1AV5C.hashDataWithSha1_DO_NOT_USE)(input),
                        queryVersion: queryVersion,
                        queryLength: input.length,
                        wordCount: input.split(/\s+/).length,
                        resultCount: size
                    }
                }
            }).fire();
        } else if (searchResults.length) setSearchResults([]);
    };
    const navigateHandler = (0, $cozmU.useCallback)((obj)=>{
        const trigger = obj?.searchMore ? 'menuClick' : obj?.nativeEvent?.type === 'submit' ? 'shortcut' : 'click'; // will need to apply the same filter setting when navigate to advance page
        handleClickNavigate({
            searchMore: searchInput,
            searchResult: obj.searchResult,
            currentSpaceKey: currentSpaceKey,
            config: config,
            eventParams: {
                wordCount: searchInput.split(/\s+/).length,
                queryLength: searchInput.length,
                queryHash: (0, $1AV5C.hashDataWithSha1_DO_NOT_USE)(searchInput),
                trigger: trigger,
                queryVersion: queryVersion,
                searchSessionId: searchSessionId,
                pageId: contentId
            }
        });
    }, // Only searchInput and config may change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        searchInput,
        config
    ]);
    const handleActivateButtonOnKeydown = (event)=>{
        // Keyboard support for button: https://www.w3.org/TR/wai-aria-practices/examples/button/button.html
        // event.key spec: https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values
        const ACTIVATE_BUTTON_KEYS = [
            'Enter',
            'Spacebar',
            ' '
        ]; // Stop the propagation of these keyboard events so users can activate the button using the keyboard without the editor handling it
        if (ACTIVATE_BUTTON_KEYS.includes(event?.key)) {
            event?.stopPropagation();
            event?.preventDefault();
            navigateHandler(event);
        }
    };
    const handleKeyDownOverride = (0, $cozmU.useCallback)((e)=>{
        if ((e?.metaKey || e?.ctrlKey) && e?.key === 'a') e.stopPropagation();
    }, []);
    const MenuList = (props)=>{
        // corresponds to Search result format LSM setting
        const { additional: additional } = config;
        const extraInfo = additional === 'page excerpt' ? 'excerpt' : additional === 'none' ? 'none' : 'space';
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ $cozmU.createElement("div", {
            style: props
        }, /*#__PURE__*/ $cozmU.createElement((0, $afqWO.SearchResultsList), {
            searchResults: searchResults,
            searchInput: searchInput,
            onClick: navigateHandler,
            extraInfo: extraInfo,
            loading: loadState
        })));
    };
    const focusSelect = ()=>{
        selectRef.current?.focus();
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $3uWLy.LiveSearchWrapper), {
        title: intl.formatMessage((0, $lHQkL.i18n).liveSearchTooltip),
        "data-fabric-macro": config?.macroId,
        "data-macro-body": true,
        "data-macro-parameters": JSON.stringify({
            currentSpaceKey: currentSpaceKey,
            ...config
        })
    }, /*#__PURE__*/ $cozmU.createElement((0, $3uWLy.SearchMacro), {
        isLarge: size === 'large'
    }, /*#__PURE__*/ $cozmU.createElement("form", {
        onSubmit: navigateHandler
    }, /*#__PURE__*/ $cozmU.createElement((0, $3izAL.default), {
        xcss: size === 'large' ? $ea51fe5225a56158$var$largeSizeWrapperStyles : $ea51fe5225a56158$var$mediumSizeWrapperStyles
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: "search-macro-query",
        role: "presentation",
        onMouseDown: focusSelect
    }, /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), null, /*#__PURE__*/ $cozmU.createElement("label", {
        htmlFor: "live-search-select"
    }, intl.formatMessage((0, $lHQkL.i18n).liveSearchLabel))), /*#__PURE__*/ $cozmU.createElement((0, $6wGOF.default), {
        isDisabled: isInEditMode,
        inputId: "live-search-select",
        classNamePrefix: $ea51fe5225a56158$export$f96974a826589f12,
        ref: selectRef,
        placeholder: placeholder || intl.formatMessage((0, $lHQkL.i18n).liveSearchLabel),
        inputValue: searchInput,
        onInputChange: (input)=>{
            onChange(input);
        },
        onKeyDown: handleKeyDownOverride,
        menuIsOpen: searchInput.length > 2 ? menuIsOpen : false,
        styles: {
            menuPortal: (base)=>({
                    ...base,
                    zIndex: 2
                }),
            menu: (base)=>({
                    ...base,
                    overflowY: 'auto',
                    minWidth: '283px'
                }),
            placeholder: (base)=>({
                    ...base,
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis'
                }),
            control: (base, state)=>({
                    ...base,
                    paddingLeft: size === 'large' ? "var(--ds-space-050, 4px)" : '0px',
                    backgroundColor: "var(--ds-background-input, #FFFFFF)",
                    border: state.isFocused ? `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-selected, #1868DB)"}` : `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
                    borderRadius: "var(--ds-radius-medium, 6px)",
                    ':hover': {
                        backgroundColor: state.isFocused ? "var(--ds-background-input, #FFFFFF)" : "var(--ds-background-input-hovered, #F8F8F8)",
                        border: state.isFocused ? `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-selected, #1868DB)"}` : `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
                        borderRadius: "var(--ds-radius-medium, 6px)"
                    }
                }),
            valueContainer: (base)=>({
                    ...base,
                    paddingLeft: size === 'large' ? "var(--ds-space-025, 2px)" : "var(--ds-space-100, 8px)"
                })
        },
        maxMenuHeight: 400,
        components: {
            MenuList: MenuList,
            DropdownIndicator: ()=>null,
            Control: size === 'large' ? $ea51fe5225a56158$var$LargeControl : $ea51fe5225a56158$var$MediumControl
        },
        menuPortalTarget: typeof document !== 'undefined' ? document.body : null,
        onMenuOpen: ()=>setMenuOpen(true),
        onMenuClose: ()=>handleMenuClose()
    })), size !== 'large' && /*#__PURE__*/ $cozmU.createElement((0, $3uWLy.StyledButton // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ), {
        className: $ea51fe5225a56158$export$914adcd8d06245e4,
        iconBefore: /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
            color: "var(--ds-icon-subtle, #505258)",
            label: (0, $6mKj3.expValEquals)('a11y-fixes-week2-may-2026', 'isEnabled', true) ? '' : intl.formatMessage((0, $lHQkL.i18n).searchIconLabel),
            spacing: "spacious"
        }),
        onClick: navigateHandler,
        onKeyDown: handleActivateButtonOnKeydown,
        appearance: "subtle",
        isDisabled: isInEditMode
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $lHQkL.i18n).liveSearchLabel))), /*#__PURE__*/ $cozmU.createElement("script", {
        ...nonceValue !== undefined ? {
            nonce: nonceValue
        } : {},
        "data-test-id": "ssr-scripts-init",
        ref: scriptRef,
        dangerouslySetInnerHTML: {
            __html: (0, $047Sb.script)
        }
    }))));
};
module.exports["LIVE_SEARCH_SELECT_CLASSNAME_PREFIX"] = $ea51fe5225a56158$export$f96974a826589f12;
module.exports["LIVE_SEARCH_BUTTON_CLASSNAME"] = $ea51fe5225a56158$export$914adcd8d06245e4;
module.exports["LiveSearchTemplate"] = $ea51fe5225a56158$export$f43084e69a1ba6f6;

});

parcelRegister("b3dss", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");


var $coZY6 = parcelRequire("coZY6");


var $8scIT = parcelRequire("8scIT");


var $b6QdV = parcelRequire("b6QdV");

const $5ecb5a6b19c7b99a$export$f3881448ce6d41ab = async ({ searchInput: searchInput, config: config, currentSpaceKey: currentSpaceKey, confluenceInstance: confluenceInstance })=>{
    const results = await (0, $c0rhi.queryInterop)({
        query: (0, $b6QdV.default),
        interopApolloAggClient: true,
        ...(0, $coZY6.getQueryVariablesForAGGSearch)({
            searchInput: searchInput,
            config: config,
            currentSpaceKey: currentSpaceKey,
            confluenceInstance: confluenceInstance
        }),
        __callerPackage__: "live-search"
    }).then((response)=>response.data.search?.search?.edges.map((0, $8scIT.aggResultMapper)));
    return {
        results: results,
        size: results.length
    };
};
module.exports["handleAGGSearch"] = $5ecb5a6b19c7b99a$export$f3881448ce6d41ab;

});

parcelRegister("coZY6", function(module, exports) {

var $6Jc3U = parcelRequire("6Jc3U");

const $adcbb7eb47b613db$export$151b4a7c4fb38187 = 'confluence.liveSearchMacro';
const $adcbb7eb47b613db$export$8c6bf2df244e6a99 = '/wiki';
const $adcbb7eb47b613db$export$185e0f2aa1d225bd = 5;
const $adcbb7eb47b613db$export$5685b08df1669f19 = ',';
const $adcbb7eb47b613db$export$c94fdbf59dff15c8 = [
    'ati:cloud:confluence:page',
    'ati:cloud:confluence:blogpost',
    'ati:cloud:confluence:space',
    'ati:cloud:confluence:comment',
    'ati:cloud:confluence:whiteboard',
    'ati:cloud:confluence:database',
    'ati:cloud:confluence:embed',
    'ati:cloud:confluence:slide'
];
var $adcbb7eb47b613db$export$9da7f865fb841394 = /*#__PURE__*/ function(ConfluenceATIs) {
    ConfluenceATIs["PAGE"] = "ati:cloud:confluence:page";
    ConfluenceATIs["BLOG"] = "ati:cloud:confluence:blogpost";
    ConfluenceATIs["SPACE"] = "ati:cloud:confluence:space";
    ConfluenceATIs["COMMENT"] = "ati:cloud:confluence:comment";
    ConfluenceATIs["WHITEBOARD"] = "ati:cloud:confluence:whiteboard";
    ConfluenceATIs["DATABASE"] = "ati:cloud:confluence:database";
    ConfluenceATIs["EMBED"] = "ati:cloud:confluence:embed";
    ConfluenceATIs["SLIDE"] = "ati:cloud:confluence:slide";
    return ConfluenceATIs;
}({});
const $adcbb7eb47b613db$export$36f2f1b03ac5f864 = ({ searchInput: searchInput, config: config, currentSpaceKey: currentSpaceKey, confluenceInstance: confluenceInstance })=>{
    const { type: type, spaceKey: spaceKey, labels: labels } = config;
    return {
        variables: {
            experience: $adcbb7eb47b613db$export$151b4a7c4fb38187,
            query: searchInput,
            first: $adcbb7eb47b613db$export$185e0f2aa1d225bd,
            filters: {
                entities: $adcbb7eb47b613db$export$e2e3f9f64b249105(type),
                locations: [
                    confluenceInstance
                ],
                confluenceFilters: (0, $6Jc3U.createAggFilters)(spaceKey, currentSpaceKey, labels)
            }
        }
    };
};
const $adcbb7eb47b613db$export$e2e3f9f64b249105 = (type)=>{
    let entities;
    switch(type){
        case 'page':
            entities = [
                "ati:cloud:confluence:page"
            ];
            break;
        case 'blogpost':
            entities = [
                "ati:cloud:confluence:blogpost"
            ];
            break;
        case 'spacedesc':
            entities = [
                "ati:cloud:confluence:space"
            ];
            break;
        case 'comment':
            entities = [
                "ati:cloud:confluence:comment"
            ];
            break;
        case 'whiteboard':
            entities = [
                "ati:cloud:confluence:whiteboard"
            ];
            break;
        case 'database':
            entities = [
                "ati:cloud:confluence:database"
            ];
            break;
        case 'embed':
            entities = [
                "ati:cloud:confluence:embed"
            ];
            break;
        case 'slide':
            entities = [
                "ati:cloud:confluence:slide"
            ];
            break;
        default:
            entities = $adcbb7eb47b613db$export$c94fdbf59dff15c8;
    }
    return entities;
};
module.exports["CONTEXT_PATH"] = $adcbb7eb47b613db$export$8c6bf2df244e6a99;
module.exports["LABEL_FILTER_SEPARATOR"] = $adcbb7eb47b613db$export$5685b08df1669f19;
module.exports["getQueryVariablesForAGGSearch"] = $adcbb7eb47b613db$export$36f2f1b03ac5f864;

});

parcelRegister("6Jc3U", function(module, exports) {

var $coZY6 = parcelRequire("coZY6");

const $aa37c24e8c8ac542$export$416386056bdfd75 = (spaceKey, currentSpaceKey, labels)=>{
    const aggConfluenceFilters = {};
    const spaceFilterKey = !spaceKey ? undefined : spaceKey === 'currentSpace()' || spaceKey === '@self' ? currentSpaceKey : spaceKey;
    if (spaceFilterKey) aggConfluenceFilters.spacesFilter = [
        spaceFilterKey
    ];
    if (labels) {
        const labelFilters = labels.split((0, $coZY6.LABEL_FILTER_SEPARATOR));
        aggConfluenceFilters.labelsFilter = labelFilters;
    }
    return aggConfluenceFilters;
};
module.exports["createAggFilters"] = $aa37c24e8c8ac542$export$416386056bdfd75;

});

parcelRegister("8scIT", function(module, exports) {

var $coZY6 = parcelRequire("coZY6");

const $8125818ec3b81d48$export$a9c9cad42c57a90d = ({ node: result })=>({
        id: result.id,
        title: result.title,
        excerpt: result.excerpt || '',
        spaceName: result.space?.name || '',
        type: result.type,
        url: $8125818ec3b81d48$export$d449648a99616a75(result.url)
    });
const $8125818ec3b81d48$export$d449648a99616a75 = (url)=>{
    const splitUrl = url.split((0, $coZY6.CONTEXT_PATH));
    return splitUrl[splitUrl.length - 1];
};
module.exports["aggResultMapper"] = $8125818ec3b81d48$export$a9c9cad42c57a90d;

});

parcelRegister("b6QdV", function(module, exports) {
/**
 * @generated SignedSource<<08dfc4c0831547d1e5bb5f8577164e7d>>
 * @relayHash b471b1154ab30ebc4408fb7bac5cce34
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a2020dc14c8c38653e1c2a2c56c15153664f6729d547645fb246000cdc144fa0
const $b84b615bca25d155$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experience"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filters"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "query"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "experience",
            "variableName": "experience"
        },
        {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "title"
    }, v7 = {
        "kind": "ScalarField",
        "name": "type"
    }, v8 = {
        "kind": "ScalarField",
        "name": "url"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "excerpt"
            },
            {
                "concreteType": "SearchConfluenceResultSpace",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    }
                ]
            }
        ],
        "type": "SearchConfluencePageBlogAttachment"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "LiveSearchAGGQuery",
            "selections": [
                {
                    "concreteType": "SearchQueryAPI",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "SearchItemConnection",
                            "kind": "LinkedField",
                            "name": "search",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "SearchResultItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "LiveSearchAGGQuery",
            "selections": [
                {
                    "concreteType": "SearchQueryAPI",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": [
                        {
                            "args": v4 /*: any*/ ,
                            "concreteType": "SearchItemConnection",
                            "kind": "LinkedField",
                            "name": "search",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "SearchResultItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b471b1154ab30ebc4408fb7bac5cce34",
            "id": "a2020dc14c8c38653e1c2a2c56c15153664f6729d547645fb246000cdc144fa0",
            "metadata": {},
            "name": "LiveSearchAGGQuery",
            "operationKind": "query",
            "text": "query LiveSearchAGGQuery($experience:String!,$query:String!,$first:Int,$filters:SearchFilterInput!){search{search(experience:$experience,query:$query,first:$first,filters:$filters){edges{node{__typename,id,title,type,url,...on SearchConfluencePageBlogAttachment{excerpt,space{id,name}}}}}}}"
        }
    };
}();
$b84b615bca25d155$var$node.hash = "e68094c3a55432af69fb46f8bfefc4c4";
var $b84b615bca25d155$export$2e2bcd8739ae039 = $b84b615bca25d155$var$node;
module.exports["default"] = $b84b615bca25d155$export$2e2bcd8739ae039;

});

parcelRegister("3uWLy", function(module, exports) {
/* LiveSearchElementStructure.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $7ZB0A = parcelRequire("7ZB0A");

const $bd32abb04a95f4ca$export$a1c423cec4871ad1 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt4v77o _1bsb1osq _p12f1osq _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $bd32abb04a95f4ca$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $7ZB0A.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1w90i7uo _qop31e5h _149mu2gc _16hgi8nm _btpd1ylp _if291txw _1kba1h6o",
            __cmplp.className
        ])
    });
});
const $bd32abb04a95f4ca$export$6d263636989f6ae8 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLarge: isLarge, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11c8fhey _1e0c1o8l _p12f1osq",
            __cmplp.isLarge ? "_1bsb1ogm _8e9gh2mm _11lwglyw _vj0b1ocd _1y9uglyw _1phy1ocd _w4u1stnw _mbkzu2gc _kjd0rdoj _tj1p1ihb" : "_1bsb1m8p _11lw1e5h _zi7q1ujv _tr7mglyw",
            __cmplp.className
        ])
    });
});
const $bd32abb04a95f4ca$var$SearchMacroMedium = null;
const $bd32abb04a95f4ca$var$SearchMacroLarge = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$fb9f58ebe9de6283 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$1917b7d8b72b7e9c = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_ca0q1l7b _2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$41596f83281a8833 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt41pyq _1tke1gkc _kqswh2mm _y3gn1e5h _1e0c1txw _2lx2vrvc _19ysutpp _7mmmutpp _irr319i6 _d0altlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$31f0069b8e88f592 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11c8wadc _1reo15vq _18m915vq _syazazsu _19pkv77o _c71l1f4h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$fcde7feadcb5c60d = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11c8wadc _syazazsu _19pkv77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$904a9954c9f03ce2 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1bsb1osq _1tke163w _1e0c1txw _2lx21bp4 _4cvr1h6o _y3gn1h6o _7axpzws8 _mezj1st9 _bna712cx",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$7c3018f441722857 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_18s8zdiv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$ec0f4e517a3a36ce = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1bsb1osq _4t3i163w _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$7d1f3ef9e605f458 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt41w7u _x3doia51 _bfhk1bhr _c71lgktf _y3gn1e5h _kqsw1if8 _94n5idpf _irr36o2t _d0altlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$2d2e4766151d9035 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_syazi7uo _1r5pwu06",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bd32abb04a95f4ca$export$1b51c6466e79404f = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_syazi7uo _1kibidpf _1laeidpf _1f5yidpf _kq8jidpf _1695idpf _1pnsidpf _vktqidpf _1byqidpf _1ilx1ule",
            __cmplp.className
        ])
    });
});
module.exports["LiveSearchWrapper"] = $bd32abb04a95f4ca$export$a1c423cec4871ad1;
module.exports["StyledButton"] = $bd32abb04a95f4ca$export$2d5d2ba3c7c8c40b;
module.exports["SearchMacro"] = $bd32abb04a95f4ca$export$6d263636989f6ae8;
module.exports["SearchResultIconWrapper"] = $bd32abb04a95f4ca$export$1917b7d8b72b7e9c;
module.exports["SearchResultNormalWrapper"] = $bd32abb04a95f4ca$export$41596f83281a8833;
module.exports["SearchResultExcerpt"] = $bd32abb04a95f4ca$export$31f0069b8e88f592;
module.exports["SearchResultSpace"] = $bd32abb04a95f4ca$export$fcde7feadcb5c60d;
module.exports["SearchNoResultWrapper"] = $bd32abb04a95f4ca$export$904a9954c9f03ce2;
module.exports["TextWrapper"] = $bd32abb04a95f4ca$export$7c3018f441722857;
module.exports["SearchLoadWrapper"] = $bd32abb04a95f4ca$export$ec0f4e517a3a36ce;
module.exports["SearchResultMoreWrapper"] = $bd32abb04a95f4ca$export$7d1f3ef9e605f458;
module.exports["TextContentBold"] = $bd32abb04a95f4ca$export$2d2e4766151d9035;
module.exports["TextContent"] = $bd32abb04a95f4ca$export$1b51c6466e79404f;

});

parcelRegister("afqWO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7gG00 = parcelRequire("7gG00");


var $cElcb = parcelRequire("cElcb");


var $8z70D = parcelRequire("8z70D");


var $dkccs = parcelRequire("dkccs");

const $6cd4a3afa36bda77$export$92697b2a267ec7ef = ({ searchResults: searchResults, searchInput: searchInput, onClick: onClick, loading: loading, extraInfo: extraInfo })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7gG00.SearchLoading), null) : searchResults.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, searchResults.map((result)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cElcb.SearchResult), {
            searchResult: result,
            onClick: onClick,
            extraInfo: extraInfo,
            key: result.id
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dkccs.SearchResultMore), {
        onClick: onClick,
        searchInput: searchInput
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8z70D.SearchNoResults), null));
module.exports["SearchResultsList"] = $6cd4a3afa36bda77$export$92697b2a267ec7ef;

});

parcelRegister("7gG00", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lfoFx = parcelRequire("lfoFx");


var $3uWLy = parcelRequire("3uWLy");

const $8f0e2446176068a1$export$8934683688a2f019 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3uWLy.SearchLoadWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "small"
    }));
module.exports["SearchLoading"] = $8f0e2446176068a1$export$8934683688a2f019;

});

parcelRegister("cElcb", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6p02T = parcelRequire("6p02T");


var $3uWLy = parcelRequire("3uWLy");


var $7pRSN = parcelRequire("7pRSN");

const $c20f7d4a6116fd22$export$a2def421b23768aa = ({ searchResult: searchResult, onClick: onClick, extraInfo: extraInfo })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3uWLy.SearchResultNormalWrapper), {
        onClick: ()=>onClick({
                searchResult: searchResult.url
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3uWLy.SearchResultIconWrapper), {
        contentType: searchResult.type
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7pRSN.SearchResultTypeIcon), {
        contentType: searchResult.type
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, (0, $6p02T.enrichExcerpt)(searchResult.title)), extraInfo === 'excerpt' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3uWLy.SearchResultExcerpt), null, (0, $6p02T.processExcerpt)(searchResult.excerpt)), extraInfo === 'space' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3uWLy.SearchResultSpace), null, (0, $6p02T.enrichExcerpt)(searchResult.type !== 'space' ? searchResult.spaceName : searchResult.title))));
module.exports["SearchResult"] = $c20f7d4a6116fd22$export$a2def421b23768aa;

});

parcelRegister("7pRSN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iW3KC = parcelRequire("iW3KC");


var $1rDre = parcelRequire("1rDre");


var $gxI48 = parcelRequire("gxI48");


var $2qJQZ = parcelRequire("2qJQZ");


var $bDjVc = parcelRequire("bDjVc");


var $lBKFk = parcelRequire("lBKFk");


var $kWSTb = parcelRequire("kWSTb");


var $cSGyR = parcelRequire("cSGyR");

const $d0c35681f27804ef$export$73b9ddc99f37f785 = ({ contentType: contentType })=>{
    switch(contentType){
        case 'blogpost':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iW3KC.default), {
                label: "page icon"
            });
        case 'image':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1rDre))), {
                label: "page icon"
            });
        case 'attachment':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gxI48))), {
                label: "page icon",
                spacing: "spacious"
            });
        case 'whiteboard':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))), {
                label: "whiteboard icon"
            });
        case 'database':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))), {
                label: "database icon"
            });
        case 'slide':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kWSTb))), {
                label: "slide icon"
            });
        case 'embed':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSGyR))), {
                label: "embed icon"
            });
        case 'page':
        case 'comment':
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2qJQZ.default), {
                label: "page icon"
            });
    }
};
module.exports["SearchResultTypeIcon"] = $d0c35681f27804ef$export$73b9ddc99f37f785;

});

parcelRegister("8z70D", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3uWLy = parcelRequire("3uWLy");


var $6tQj0 = parcelRequire("6tQj0");


var $lHQkL = parcelRequire("lHQkL");

const $d23f3d633ea38e93$export$8e56e0a68b41e69c = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3uWLy.SearchNoResultWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($6tQj0))),
        alt: intl.formatMessage((0, $lHQkL.i18n).searchIconLabel)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3uWLy.TextWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3uWLy.TextContentBold), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $lHQkL.i18n).liveSearchSelectNoResult1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3uWLy.TextContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $lHQkL.i18n).liveSearchSelectNoResult2))));
};
module.exports["SearchNoResults"] = $d23f3d633ea38e93$export$8e56e0a68b41e69c;

});

parcelRegister("6tQj0", function(module, exports) {
module.exports = new URL("searchError.f24f82b3.svg", import.meta.url).toString();

});

parcelRegister("lHQkL", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $3004d3bb8ead7d7b$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    liveSearchLabel: {
        id: "live-search.label",
        defaultMessage: "Search"
    },
    liveSearchTooltip: {
        id: "live-search.tooltip",
        defaultMessage: "Live Search Macro"
    },
    liveSearchSelectSearchMore: {
        id: "live-search.search-more",
        defaultMessage: "See more search results"
    },
    liveSearchSelectNoResult1: {
        id: "live-search.no-result-1",
        defaultMessage: "We couldn\u2019t find anything matching your search"
    },
    liveSearchSelectNoResult2: {
        id: "live-search.no-result-2",
        defaultMessage: "Try again with a different term"
    },
    searchIconLabel: {
        id: "live-search.search-icon-label",
        defaultMessage: "Magnifying glass"
    }
});
module.exports["i18n"] = $3004d3bb8ead7d7b$export$a7357cdd1f0b0168;

});

parcelRegister("dkccs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3uWLy = parcelRequire("3uWLy");


var $lHQkL = parcelRequire("lHQkL");

const $b4fc439cf581a678$export$37d81fcf1a4df7fc = ({ onClick: onClick, searchInput: searchInput })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3uWLy.SearchResultMoreWrapper), {
        onClick: ()=>onClick({
                searchMore: searchInput
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $lHQkL.i18n).liveSearchSelectSearchMore));
module.exports["SearchResultMore"] = $b4fc439cf581a678$export$37d81fcf1a4df7fc;

});

parcelRegister("3EYav", function(module, exports) {
// handleNavigate does called in react component
/* eslint-disable react-hooks/rules-of-hooks */ 
var $9DHhW = parcelRequire("9DHhW");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");

const $1b86c7896a2c63d8$export$efe49016b6e93b85 = ()=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    return ({ searchMore: searchMore, searchResult: searchResult, currentSpaceKey: currentSpaceKey, config: config, eventParams: eventParams })=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'liveSearch',
                source: 'liveSearch',
                actionSubjectId: 'liveSearchButtonClicked',
                objectId: eventParams?.pageId,
                attributes: {
                    destination: !searchResult ? 'advanced_search' : 'user_defined',
                    trigger: eventParams?.trigger || 'click',
                    source: 'liveSearch',
                    searchSessionId: eventParams?.searchSessionId || undefined,
                    navigation: searchMore ? 'postQuery' : 'preQuery'
                }
            }
        }).fire();
        if (searchMore !== undefined && !searchResult) {
            const { spaceKey: spaceKey, type: type, labels: labels } = config;
            let typeQuery;
            let spaces;
            if (spaceKey === 'currentSpace()' || spaceKey === '@self') spaces = `&spaces=${currentSpaceKey}`;
            else if (spaceKey) spaces = `&spaces=${spaceKey}`;
            if (type === 'spacedesc') typeQuery = '&type=space';
            else if (type) typeQuery = `&type=${type}`;
            const appliedLabels = labels ? `&labels=${labels}` : '';
            push(`${(0, $1NBp8.ADVANCED_SEARCH).toUrl()}?text=${searchMore}${spaces || ''}${typeQuery || ''}${appliedLabels}`);
        } else {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'selected',
                    actionSubject: 'liveSearchResult',
                    actionSubjectId: 'liveSearchQueryResult',
                    source: 'liveSearch',
                    attributes: {
                        source: 'liveSearch',
                        searchSessionId: eventParams?.searchSessionId,
                        queryHash: eventParams?.queryHash,
                        queryVersion: eventParams?.queryVersion,
                        queryLength: eventParams?.queryLength,
                        wordCount: eventParams?.wordCount
                    }
                }
            }).fire();
            push(`${(0, $1NBp8.WIKI).toUrl()}${searchResult}`);
        }
    };
};
module.exports["handleNavigate"] = $1b86c7896a2c63d8$export$efe49016b6e93b85;

});

parcelRegister("047Sb", function(module, exports) {
/* eslint-disable */ // @ts-ignore
const $4e16e09ee5d4c2a8$export$bc237d627614fc48 = `!function(e,a){a.liveSearchInput={};var t,c=e.querySelectorAll("div[title='Live Search Macro']"),r=c[c.length-1],n=r.getElementsByTagName("form")[0],i=r.getElementsByTagName("button")[0],l=r.getElementsByTagName("input")[0],s=r.attributes,p="";Array.prototype.slice.call(s).forEach(function(e){"data-macro-parameters"===e.name&&(t=JSON.parse(e.value))});var e=t||{},c=e.spaceKey,r=e.type,s=e.currentSpaceKey,u=e.macroId,o="",m="";function v(e){var t="/wiki/search?text="+p+m+o;a.location.href=t,e.preventDefault()}function y(e,t,a){e&&e.addEventListener(t,a)}"currentSpace()"===c||"@self"===c?m="&spaces="+s:c&&(m="&spaces="+c),"spacedesc"===r?o="&type=space":r&&(o="&type="+r),y(n,"submit",v),y(i,"click",v),y(l,"input",function(e){p=e.target.value,u&&(a.liveSearchInput[u]=p)})}(document,window);`;
module.exports["script"] = $4e16e09ee5d4c2a8$export$bc237d627614fc48;

});

parcelRegister("iNIw3", function(module, exports) {
const $2008359fb3515e18$export$38c6526d67de94bb = 'xen:macro';
const $2008359fb3515e18$export$8d4b803281599c6a = 'com.atlassian.ecosystem';
const $2008359fb3515e18$export$d7168699755008a = 'com.atlassian.confluence.macro.core';
const $2008359fb3515e18$export$46fc26821adc3495 = 'connectAddon';
const $2008359fb3515e18$export$95077f102dafd025 = 'migratedServerP2Addon';
const $2008359fb3515e18$export$981e47da3e2dfc13 = 'bodiedExtension';
const $2008359fb3515e18$export$4506b39eefa6dc94 = 'multiBodiedExtension';
const $2008359fb3515e18$export$d2cde58d8ae019a9 = 'forge.ui.extension';
const $2008359fb3515e18$export$bf4c163a4c708db1 = 'forgeDocUpdated';
module.exports["MODULE_NAME"] = $2008359fb3515e18$export$38c6526d67de94bb;
module.exports["EXTENSION_NAMESPACE"] = $2008359fb3515e18$export$8d4b803281599c6a;
module.exports["P2_OR_CONNECT_CONFLUENCE_MACRO_EXTENSION_TYPE"] = $2008359fb3515e18$export$d7168699755008a;
module.exports["CONNECT_ADDON_ACTION_SUBJECT"] = $2008359fb3515e18$export$46fc26821adc3495;
module.exports["MIGRATED_SERVER_P2_ADDON_ACTION_SUBJECT"] = $2008359fb3515e18$export$95077f102dafd025;
module.exports["EXTENSION_TYPE_MULTI_BODIED"] = $2008359fb3515e18$export$4506b39eefa6dc94;
module.exports["FORGE_EXTENSION"] = $2008359fb3515e18$export$d2cde58d8ae019a9;
module.exports["FORGE_DOC_UPDATED_EVENT"] = $2008359fb3515e18$export$bf4c163a4c708db1;

});

parcelRegister("hHZWk", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $jlIaF = parcelRequire("jlIaF");


var $a6t12 = parcelRequire("a6t12");


var $4qzKl = parcelRequire("4qzKl");

/**
 * This component processes the DOM Node for ContentBody, Likes, & CommentBody to find all User Mentions
 * and User Links and replaces them with a React Element for @atlaskit/profilecard
 */ const $fe7178b75f06350f$var$LEGACY_USER_ELEMENT_SELECTORS = [
    'a.user-mention',
    'a.confluence-userlink',
    'a.userLogoLink',
    'span.user-hover-trigger',
    'img.confluence-userlink'
];
class $fe7178b75f06350f$export$549ba0a29911d5ee extends (0, $cozmU.Component) {
    shouldComponentUpdate(nextProps) {
        return nextProps.node !== this.props.node;
    }
    getLegacyUserElements() {
        const { node: node } = this.props;
        if (!node) return [];
        return Array.from(node.querySelectorAll($fe7178b75f06350f$var$LEGACY_USER_ELEMENT_SELECTORS.join(',')));
    }
    render() {
        return (0, $4qzKl.replaceUserElementsWithPlaceholders)(this.getLegacyUserElements()).map((item)=>this.renderPortal(item));
    }
    constructor(...args){
        super(...args);
        this.renderPortal = (item)=>{
            const { position: position } = this.props;
            const userId = item.props['data-account-id'];
            item.props.href = (0, $4qzKl.getAtlassianPeopleProfileUrl)(item.props['data-account-id'], null, (0, $jlIaF.CONTEXT_PATH));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fe7178b75f06350f$export$b688bc1b9fd324b6, {
                placeholder: item.placeholder
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: !userId,
                userId: userId,
                position: position
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", item.props, item.props.children))), item.placeholder);
        };
    }
}
function $fe7178b75f06350f$export$b688bc1b9fd324b6(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { placeholder: placeholder, children: children } = t0;
    let t1;
    let t2;
    if ($[0] !== placeholder) {
        t1 = ()=>{
            const markPlaceholderIgnored = (e)=>{
                if (e?.tagName === "SPAN") {
                    e.setAttribute("data-ssr-placeholder-ignored", "true");
                    Array.from(e.children).forEach((child)=>markPlaceholderIgnored(child));
                }
            };
            markPlaceholderIgnored(placeholder);
        };
        t2 = [
            placeholder
        ];
        $[0] = placeholder;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
}
module.exports["LegacyUserElementsHover"] = $fe7178b75f06350f$export$549ba0a29911d5ee;

});

parcelRegister("8cOoD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $cpjd2 = parcelRequire("cpjd2");


var $gEtAQ = parcelRequire("gEtAQ");


var $fySJw = parcelRequire("fySJw");


var $3LvmY = parcelRequire("3LvmY");

const $198de0e1d1f1ab22$export$f1a6c160e5107221 = 'dataProvider';
const $198de0e1d1f1ab22$export$57b0f508e89cfdbb = ({ connectHost: connectHost })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        const isViewPage = (0, $gEtAQ.isViewPage)();
        $198de0e1d1f1ab22$export$eb1900d465fb2cb9({
            connectHost: connectHost,
            createAnalyticsEvent: createAnalyticsEvent,
            isViewPage: isViewPage
        });
    }, [
        connectHost,
        createAnalyticsEvent
    ]);
    return null;
};
const $198de0e1d1f1ab22$export$594716b2dbd4f0f9 = ()=>!!window['connectHost']?.isModuleDefined($198de0e1d1f1ab22$export$f1a6c160e5107221);
const $198de0e1d1f1ab22$export$eb1900d465fb2cb9 = ({ connectHost: connectHost, createAnalyticsEvent: createAnalyticsEvent, isViewPage: isViewPage })=>{
    const isDPModuleDefined = $198de0e1d1f1ab22$export$594716b2dbd4f0f9();
    const dataProviderModule = {
        emitToDataProvider: async (...args)=>{
            const data = args.length > 1 ? args[0] : null;
            const sendResponse = args.length > 1 ? args[args.length - 1] : args[0];
            const context = sendResponse?._context;
            const fragmentLocalId = context?.extension?.options?.productContext?.['macro.fragmentLocalId'];
            const extensionKey = context?.extension?.key;
            const event = (0, $3LvmY.getReceivedConnectRefDataEvent)({
                isViewPage: isViewPage,
                extensionKey: extensionKey
            });
            createAnalyticsEvent(event).fire();
            if (!extensionKey) throw Error('Missing Connect app extensionKey while transferring data.');
            const connectDataListener = (0, $fySJw.getConnectDataListener)();
            const status = await connectDataListener.transfer(extensionKey, fragmentLocalId, data, createAnalyticsEvent, isViewPage);
            return sendResponse(status);
        }
    };
    if (!isDPModuleDefined) connectHost.defineModule($198de0e1d1f1ab22$export$f1a6c160e5107221, dataProviderModule);
};
const $198de0e1d1f1ab22$export$8738a87451e0e0f8 = async ({ logger: logger, isViewPage: isViewPage, createAnalyticsEvent: createAnalyticsEvent })=>{
    await new Promise((resolve)=>{
        (0, $cpjd2.requireLegacyWRM)([
            'wr!confluence.web.resources:querystring',
            'wr!confluence.web.resources:navigator-context',
            'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
        ], ()=>{
            const connectHost = window['connectHost'];
            $198de0e1d1f1ab22$export$eb1900d465fb2cb9({
                connectHost: connectHost,
                createAnalyticsEvent: createAnalyticsEvent,
                isViewPage: isViewPage
            });
            resolve();
        }, ()=>{
            logger.error`Error loading WRM for dataProvider!`;
            resolve();
        });
    });
};
module.exports["DataProviderModule"] = $198de0e1d1f1ab22$export$57b0f508e89cfdbb;
module.exports["checkIsDPModuleDefined"] = $198de0e1d1f1ab22$export$594716b2dbd4f0f9;
module.exports["loadDataProviderModule"] = $198de0e1d1f1ab22$export$8738a87451e0e0f8;

});

parcelRegister("3FlVr", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable check-file/filename-blocklist */ var $3196fb7749a17aaf$export$3b10d30805d4d939 = /*#__PURE__*/ function(ReactionLocation) {
    ReactionLocation["PAGE"] = "page";
    ReactionLocation["BLOGPOST"] = "blogpost";
    ReactionLocation["PAGE_COMMENT"] = "page-comment";
    ReactionLocation["INLINE_COMMENT"] = "inline-comment";
    ReactionLocation["EDITOR_INLINE_COMMENT"] = "editor-inline-comment";
    ReactionLocation["FEED_PAGE"] = "feed-page";
    ReactionLocation["FEED_BLOGPOST"] = "feed-blogpost";
    ReactionLocation["FEED_COMMENT"] = "feed-comment";
    ReactionLocation["OBJECT_COMMENT_FOOTER_PAGE"] = "object-comment-footer-page";
    ReactionLocation["OBJECT_COMMENT_FOOTER_BLOGPOST"] = "object-comment-footer-blogpost";
    return ReactionLocation;
}({});
var $3196fb7749a17aaf$export$d86afc9493bb8e1 = /*#__PURE__*/ function(ReactionContainerType) {
    ReactionContainerType["PAGE"] = "page";
    ReactionContainerType["BLOGPOST"] = "blogpost";
    ReactionContainerType["SPACE"] = "space";
    return ReactionContainerType;
}({});
module.exports["ReactionLocation"] = $3196fb7749a17aaf$export$3b10d30805d4d939;
module.exports["ReactionContainerType"] = $3196fb7749a17aaf$export$d86afc9493bb8e1;

});

parcelRegister("1NF8X", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $bFPHx = parcelRequire("bFPHx");


var $5Kc7f = parcelRequire("5Kc7f");


const $032b81a28ff18608$export$96ee387620e23ced = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "XLglR",
    name: "ReactionsLoader",
    loading: (props)=>{
        return props?.summaryViewEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bFPHx.ReactionsPlaceholder), {
            useAccuratePills: true,
            ...props
        });
    },
    loader: async ()=>(await (parcelRequire("1QGVZ"))).Reactions
});

const $032b81a28ff18608$export$ddfc48793728637f = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "4wRdk",
    name: "ReactionsLoaderBackground",
    loading: (props)=>{
        return props?.summaryViewEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bFPHx.ReactionsPlaceholder), null);
    },
    loader: async ()=>(await (parcelRequire("1QGVZ"))).Reactions
});
module.exports["ReactionsLoader"] = $032b81a28ff18608$export$96ee387620e23ced;
module.exports["ReactionsLoaderBackground"] = $032b81a28ff18608$export$ddfc48793728637f;

});

parcelRegister("bFPHx", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $b3Wpp = parcelRequire("b3Wpp");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $b35Wv = parcelRequire("b35Wv");


var $4ez2K = parcelRequire("4ez2K");


var $1sCHt = parcelRequire("1sCHt");


var $jMyy4 = parcelRequire("jMyy4");


var $ep3mz = parcelRequire("ep3mz");

const $3ae84312c23de134$var$ReactionsPlaceholderQuery = (0, $b3Wpp.default);
const $3ae84312c23de134$var$placeholderContainerStyles = null;
const $3ae84312c23de134$var$reactionPillStyles = null;
const $3ae84312c23de134$var$reactionIconStyles = null;
const $3ae84312c23de134$var$DEFAULT_NUM_PILLS = 2;
const $3ae84312c23de134$export$47a91e92112986d6 = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { useAccuratePills: useAccuratePills, onlyRenderPicker: onlyRenderPicker, customAnalyticsAttributes: customAnalyticsAttributes } = t0;
    const isSSR = window.__SSR_RENDERED__ || undefined;
    const [contentId] = (0, $ep3mz.usePageContentId)();
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = !isSSR || !useAccuratePills || !contentId || onlyRenderPicker;
    let t3;
    if ($[2] !== t1 || $[3] !== t2) {
        t3 = {
            variables: t1,
            skip: t2
        };
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($3ae84312c23de134$var$ReactionsPlaceholderQuery, {
        ...t3,
        __callerPackage__: "reactions"
    });
    if (loading) return null;
    let t4;
    if ($[5] !== customAnalyticsAttributes || $[6] !== onlyRenderPicker) {
        t4 = (numPills)=>onlyRenderPicker ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
                justifyContent: "center",
                alignItems: "center",
                testId: "reactions-picker-placeholder"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($b35Wv))),
                label: "",
                analyticsContext: {
                    name: "reactionsPicker",
                    ...customAnalyticsAttributes
                }
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "data-testid": "reactions-placeholder",
                className: (0, $hekY6.default)([
                    "_1e0c1txw _2lx2vrvc _4cvr1h6o _80om1x0y _19pkv77o _otyrv77o _18u0idpf"
                ])
            }, Array(numPills).fill("").map($3ae84312c23de134$var$_temp), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                "data-testid": "reaction-icon",
                className: (0, $hekY6.default)([
                    "_11q7vkf5 _2rko1rr0 _1bsb1crf _4t3i1crf _18u012x7"
                ])
            }));
        $[5] = customAnalyticsAttributes;
        $[6] = onlyRenderPicker;
        $[7] = t4;
    } else t4 = $[7];
    const renderPlaceholder = t4;
    if (isSSR) {
        const numDistinctReactions = data?.content?.nodes?.[0]?.contentReactionsSummary?.reactionsSummaryForEmoji.length;
        const numReactionPills = numDistinctReactions !== undefined ? numDistinctReactions : $3ae84312c23de134$var$DEFAULT_NUM_PILLS;
        let t5;
        if ($[8] !== numReactionPills || $[9] !== renderPlaceholder) {
            t5 = renderPlaceholder(numReactionPills);
            $[8] = numReactionPills;
            $[9] = renderPlaceholder;
            $[10] = t5;
        } else t5 = $[10];
        return t5;
    } else {
        let t5;
        if ($[11] !== renderPlaceholder) {
            t5 = renderPlaceholder($3ae84312c23de134$var$DEFAULT_NUM_PILLS);
            $[11] = renderPlaceholder;
            $[12] = t5;
        } else t5 = $[12];
        return t5;
    }
};
function $3ae84312c23de134$var$_temp(_, i) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        key: i,
        "data-testid": "reactions-pill",
        className: (0, $hekY6.default)([
            "_11q7vkf5 _2rko1rr0 _1bsbor1b _4t3i1tcg _2hwx1b66"
        ])
    });
}
module.exports["ReactionsPlaceholder"] = $3ae84312c23de134$export$47a91e92112986d6;

});

parcelRegister("b3Wpp", function(module, exports) {
/**
 * @generated SignedSource<<1d6855ec0a749a41169ad18fea189d4c>>
 * @relayHash 82e58e09cb6c0ae8731a0483a5357faf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d94877ce2b304668842025392ca6cfa2689c4ad6aec2d397cee17e057f1968a6
const $41658e2724bc842d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "contentReactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ReactionsPlaceholderQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ReactionsPlaceholderQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "82e58e09cb6c0ae8731a0483a5357faf",
            "id": "d94877ce2b304668842025392ca6cfa2689c4ad6aec2d397cee17e057f1968a6",
            "metadata": {},
            "name": "ReactionsPlaceholderQuery",
            "operationKind": "query",
            "text": "query ReactionsPlaceholderQuery($contentId:ID!){content(id:$contentId){nodes{id,contentReactionsSummary{reactionsSummaryForEmoji{id}}}}}"
        }
    };
}();
$41658e2724bc842d$var$node.hash = "22ecbec40a97883abeadc26399cf4367";
var $41658e2724bc842d$export$2e2bcd8739ae039 = $41658e2724bc842d$var$node;
module.exports["default"] = $41658e2724bc842d$export$2e2bcd8739ae039;

});

parcelRegister("5Kc7f", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $1l0kj = parcelRequire("1l0kj");


var $iKpb2 = parcelRequire("iKpb2");

const $aba7293523a7a5b0$var$styles = {
    emojiPlaceholderBackground: "_bfhkizff",
    wrapperStyles: "_19bvu2gc _u5f3utpp _19pk1i6y",
    countSkeletonStyles: "_2rko1rr0 _1bsb19bv _4t3i19bv _bfhkizff"
};
const $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS = {
    shortName: 'loading-placeholder',
    size: 16,
    xcss: $aba7293523a7a5b0$var$styles.emojiPlaceholderBackground
};
const $aba7293523a7a5b0$export$d85d0301f09f2005 = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            space: "space.050",
            alignBlock: "center",
            className: (0, $hekY6.default)([
                $aba7293523a7a5b0$var$styles.wrapperStyles
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKpb2.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKpb2.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKpb2.default), $aba7293523a7a5b0$var$PLACEHOLDER_COMMON_PROPS), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $aba7293523a7a5b0$var$styles.countSkeletonStyles
            ])
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
module.exports["ReactionsSummaryViewPlaceholder"] = $aba7293523a7a5b0$export$d85d0301f09f2005;

});

parcelRegister("1QGVZ", function(module, exports) {

let $158bf39de6d82a86$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $158bf39de6d82a86$var$load("he34V"),
    $158bf39de6d82a86$var$load("ddvkk"),
    $158bf39de6d82a86$var$load("3upHR"),
    $158bf39de6d82a86$var$load("bjimZ"),
    $158bf39de6d82a86$var$load("kUfAt"),
    $158bf39de6d82a86$var$load("9ZY0g"),
    $158bf39de6d82a86$var$load("ipIDQ"),
    $158bf39de6d82a86$var$load("h4Nf7"),
    $158bf39de6d82a86$var$load("4XkGy"),
    $158bf39de6d82a86$var$load("fuOfV"),
    $158bf39de6d82a86$var$load("jL1Ke"),
    $158bf39de6d82a86$var$load("5MQ0D"),
    $158bf39de6d82a86$var$load("Kj0I8"),
    $158bf39de6d82a86$var$load("5xnun"),
    $158bf39de6d82a86$var$load("6wr18"),
    $158bf39de6d82a86$var$load("59hV4"),
    $158bf39de6d82a86$var$load("8zMmc"),
    $158bf39de6d82a86$var$load("4x9Jx"),
    $158bf39de6d82a86$var$load("7EorR"),
    $158bf39de6d82a86$var$load("ffEVr"),
    $158bf39de6d82a86$var$load("ghNAx"),
    $158bf39de6d82a86$var$load("iUXaE"),
    $158bf39de6d82a86$var$load("lTkx9"),
    $158bf39de6d82a86$var$load("Wowvf"),
    $158bf39de6d82a86$var$load("eRhBr"),
    $158bf39de6d82a86$var$load("hhss7"),
    $158bf39de6d82a86$var$load("1C6qR")
]).then(()=>parcelRequire('kTkGJ'));

});

parcelRegister("ad6ZE", function(module, exports) {
var $bcdbc544cc3a5c22$export$2df6d049e5bad28e = /*#__PURE__*/ function(InlineCommentMode) {
    InlineCommentMode["EDIT"] = "edit";
    InlineCommentMode["VIEW"] = "view";
    InlineCommentMode["LIVE"] = "live";
    return InlineCommentMode;
}({});
module.exports["InlineCommentMode"] = $bcdbc544cc3a5c22$export$2df6d049e5bad28e;

});

parcelRegister("jJx00", function(module, exports) {

var $epbW8 = parcelRequire("epbW8");


var $fJCU9 = parcelRequire("fJCU9");


var $cD1qu = parcelRequire("cD1qu");

const $5ec5fd51084563e9$export$a6eb195c212220c7 = (annotationId, pageMode, // eslint-disable-next-line @typescript-eslint/no-explicit-any
eventEmitter)=>{
    if (!eventEmitter) return;
    if (pageMode === (0, $cD1qu.PageMode).VIEW) eventEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_STATE, {
        [annotationId]: {
            id: annotationId,
            annotationType: (0, $epbW8.AnnotationTypes).INLINE_COMMENT,
            state: (0, $epbW8.AnnotationMarkStates).RESOLVED
        }
    });
    else eventEmitter.emit('resolve', annotationId);
};
const $5ec5fd51084563e9$export$ce8c47c029702c7a = (annotationId, pageMode, // eslint-disable-next-line @typescript-eslint/no-explicit-any
eventEmitter)=>{
    if (!eventEmitter) return;
    if (pageMode === (0, $cD1qu.PageMode).VIEW) eventEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_STATE, {
        [annotationId]: {
            id: annotationId,
            annotationType: (0, $epbW8.AnnotationTypes).INLINE_COMMENT,
            state: (0, $epbW8.AnnotationMarkStates).ACTIVE
        }
    });
    else eventEmitter.emit('unresolve', annotationId);
};
module.exports["resolveInlineCommentAnnotation"] = $5ec5fd51084563e9$export$a6eb195c212220c7;
module.exports["unresolveInlineCommentAnnotation"] = $5ec5fd51084563e9$export$ce8c47c029702c7a;

});

parcelRegister("3s9yq", function(module, exports) {

var $4gWyR = parcelRequire("4gWyR");

const $dc6096cce6b3b96b$export$8c4bf31cea6aa53c = (0, $4gWyR.default);
module.exports["InlineCommentsQuery"] = $dc6096cce6b3b96b$export$8c4bf31cea6aa53c;

});

parcelRegister("4gWyR", function(module, exports) {
/**
 * @generated SignedSource<<3bfeca0bb9e902eac5c5f7e4df1177b1>>
 * @relayHash b1e02ca7b094a1ff9aaf5a6b5ddc5a29
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9ca55d271207d138fc62881aa0d6c6f83af1c22e78c15115c42f10e48b73f506
const $ed32661450888f95$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v4 = {
        "args": [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "pageId"
            }
        ],
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    {
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v3 /*: any*/ 
                        ]
                    },
                    v3 /*: any*/ 
                ]
            }
        ]
    }, v5 = [
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ROOT"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        },
        {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "pageId"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "UNRESOLVED"
        }
    ], v6 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v7 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v6 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v8 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v9 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v6 /*: any*/ 
    }, v10 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v11 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v13 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v14 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    v12 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v12 /*: any*/ ,
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v18 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            v16 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v19 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v20 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v21 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v22 = {
        "kind": "ScalarField",
        "name": "when"
    }, v23 = {
        "kind": "ScalarField",
        "name": "number"
    }, v24 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v21 /*: any*/ 
                ]
            },
            v22 /*: any*/ ,
            v23 /*: any*/ 
        ]
    }, v25 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v27 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v28 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v21 /*: any*/ ,
            v25 /*: any*/ ,
            v26 /*: any*/ ,
            v27 /*: any*/ 
        ]
    }, v29 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v30 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v29 /*: any*/ ,
            v2 /*: any*/ ,
            v16 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v31 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v29 /*: any*/ ,
                    v21 /*: any*/ 
                ]
            },
            v22 /*: any*/ ,
            v23 /*: any*/ 
        ]
    }, v32 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v29 /*: any*/ ,
            v21 /*: any*/ ,
            v25 /*: any*/ ,
            v26 /*: any*/ ,
            v27 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "InlineCommentsQuery",
            "selections": [
                v4 /*: any*/ ,
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v24 /*: any*/ ,
                                v28 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v28 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "InlineCommentsQuery",
            "selections": [
                v4 /*: any*/ ,
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v30 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v31 /*: any*/ ,
                                v32 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v30 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v31 /*: any*/ ,
                                        v32 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b1e02ca7b094a1ff9aaf5a6b5ddc5a29",
            "id": "9ca55d271207d138fc62881aa0d6c6f83af1c22e78c15115c42f10e48b73f506",
            "metadata": {},
            "name": "InlineCommentsQuery",
            "operationKind": "query",
            "text": "query InlineCommentsQuery($pageId:ID!)@allowHigherTimeout{content(id:$pageId){nodes{id,type,space{id,operations{operation,targetType}},operations{operation,targetType}}},comments(pageId:$pageId,type:UNRESOLVED,depth:ROOT,first:1000){nodes{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}}}}"
        }
    };
}();
$ed32661450888f95$var$node.hash = "82d41657ba53df28146f886f7478ca62";
var $ed32661450888f95$export$2e2bcd8739ae039 = $ed32661450888f95$var$node;
module.exports["default"] = $ed32661450888f95$export$2e2bcd8739ae039;

});

parcelRegister("aMfLn", function(module, exports) {

var $eOaGc = parcelRequire("eOaGc");


var $kDIns = parcelRequire("kDIns");

const $194c389c7ab5ab2c$export$bbbd7ccaedea9691 = async ({ rendererActions: rendererActions, contentId: contentId, triggerAnalyticsEvent: triggerAnalyticsEvent, updateUnresolvedInlineComment: updateUnresolvedInlineComment })=>{
    const allAnnotationMarks = rendererActions?.getAnnotationMarks();
    const allAnnotationIds = allAnnotationMarks?.map((mark)=>mark.attrs.id) || [];
    (0, $kDIns.getRendererAnnotationStates)({
        annotations: allAnnotationIds,
        pageId: contentId,
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        validAnnotationsCallback: updateUnresolvedInlineComment,
        isNestedRender: false
    }).catch(()=>{
    //intentional no-op
    });
};
const $194c389c7ab5ab2c$export$2600439b3e609c06 = (step, pos)=>{
    // AddMarkStep has additional properties that aren't allowed in the mutation variables
    const markInfo = {
        mark: {
            attrs: {
                annotationType: 'inlineComment',
                id: step.mark.attrs.id
            },
            type: 'annotation'
        }
    };
    // TODO: remove this logic since pos should be read from step
    if (pos !== undefined) return {
        pos: pos,
        ...markInfo
    };
    if (step instanceof (0, $eOaGc.AddMarkStep) || step instanceof (0, $eOaGc.RemoveMarkStep)) {
        const { from: from, to: to } = step;
        return {
            from: from,
            to: to,
            ...markInfo
        };
    }
    return {
        pos: step.pos,
        ...markInfo
    };
};
module.exports["updateRendererAnnotations"] = $194c389c7ab5ab2c$export$bbbd7ccaedea9691;
module.exports["constructStepForGql"] = $194c389c7ab5ab2c$export$2600439b3e609c06;

});

parcelRegister("6bd6t", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $7ZB0A = parcelRequire("7ZB0A");


var $lpNn5 = parcelRequire("lpNn5");


var $2ot3O = parcelRequire("2ot3O");


var $chu6R = parcelRequire("chu6R");


var $91uAX = parcelRequire("91uAX");


var $9DHhW = parcelRequire("9DHhW");


var $3izAL = parcelRequire("3izAL");


var $kz1Yj = parcelRequire("kz1Yj");


var $buxP3 = parcelRequire("buxP3");


var $cXLoX = parcelRequire("cXLoX");


var $b3j2Y = parcelRequire("b3j2Y");


var $bQm3c = parcelRequire("bQm3c");


var $7OLeD = parcelRequire("7OLeD");


var $PjC9c = parcelRequire("PjC9c");


var $dchHi = parcelRequire("dchHi");

const $6d65bb3bd17dd577$var$LINK_TO_PRIVACY_POLICY = 'https://www.atlassian.com/legal/privacy-policy';
const $6d65bb3bd17dd577$var$LINK_TO_RESEARCH_GROUP = 'https://www.atlassian.com/research-group';
const $6d65bb3bd17dd577$var$i18n = (0, $kSwu1.defineMessages)({
    flagTitle: {
        id: "quick-summary.feedback.flag.title",
        defaultMessage: "Thanks!"
    },
    flagDescription: {
        id: "quick-summary.feedback.flag.description",
        defaultMessage: "We appreciate you taking the time to send this feedback."
    },
    likeTooltip: {
        id: "quick-summary.like.tooltip",
        defaultMessage: "Good response"
    },
    dislikeTooltip: {
        id: "quick-summary.dislike.tooltip",
        defaultMessage: "Bad response"
    },
    likeSuggestionTooltip: {
        id: "quick-summary.like-suggestion.tooltip",
        defaultMessage: "Helpful"
    },
    dislikeSuggestionTooltip: {
        id: "quick-summary.dislike-suggestion.tooltip",
        defaultMessage: "Not helpful"
    },
    feedbackTitle: {
        id: "quick-summary.feedback.title",
        defaultMessage: "Help us improve Atlassian Intelligence"
    },
    feedbackSummaryTitle: {
        id: "quick-summary.feedback.summary.title",
        defaultMessage: "Tell us about your experience"
    },
    feedbackSummaryPlaceholder: {
        id: "quick-summary.feedback.summary.placeholder",
        defaultMessage: "What did Atlassian Intelligence do well? What could be improved?"
    },
    canContactText: {
        id: "quick-summary.feedback.can-contact.label",
        defaultMessage: "Atlassian can contact me about this feedback. See our {privacyPolicyLink}."
    },
    privacyPolicyLink: {
        id: "quick-summary.feedback.privacy-policy.link",
        defaultMessage: "privacy policy"
    },
    improveAtlassianText: {
        id: "quick-summary.feedback.improve-atlassian",
        defaultMessage: "I\u2019d like to help improve Atlassian products by joining the {researchGroupLink}."
    },
    researchGroupLink: {
        id: "quick-summary.feedback.research-group.link",
        defaultMessage: "Atlassian Research Group"
    }
});
const $6d65bb3bd17dd577$var$PrivacyPolicyLink = ({ link: link })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6d65bb3bd17dd577$var$i18n.privacyPolicyLink));
const $6d65bb3bd17dd577$var$ResearchGroupLink = ({ link: link })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6d65bb3bd17dd577$var$i18n.researchGroupLink));
const $6d65bb3bd17dd577$var$CanContactLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$6d65bb3bd17dd577$var$i18n.canContactText,
        values: {
            privacyPolicyLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d65bb3bd17dd577$var$PrivacyPolicyLink, {
                link: $6d65bb3bd17dd577$var$LINK_TO_PRIVACY_POLICY
            })
        }
    });
};
const $6d65bb3bd17dd577$var$EnrolLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$6d65bb3bd17dd577$var$i18n.improveAtlassianText,
        values: {
            researchGroupLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d65bb3bd17dd577$var$ResearchGroupLink, {
                link: $6d65bb3bd17dd577$var$LINK_TO_RESEARCH_GROUP
            })
        }
    });
};
const $6d65bb3bd17dd577$var$TooltipWrapperXCSS = (0, $buxP3.xcss)({
    listStyle: 'none',
    marginTop: 'space.0'
});
const $6d65bb3bd17dd577$var$FeedbackIconXCSS = (0, $buxP3.xcss)({
    marginRight: 'space.050'
});
const $6d65bb3bd17dd577$var$DislikeIconWrapperXCSS = (0, $buxP3.xcss)({
    transform: 'rotate(180deg)'
});
const $6d65bb3bd17dd577$var$ButtonWrapperXCSS = (0, $buxP3.xcss)({
    height: '24px',
    width: '24px'
});
const $6d65bb3bd17dd577$var$InlineULXCSS = (0, $buxP3.xcss)({
    paddingLeft: 'space.0',
    display: 'flex'
});
const $6d65bb3bd17dd577$export$cbc8ab5712ed2bd3 = ({ analyticsProperties: analyticsProperties, contentId: contentId, spaceKey: spaceKey, summaryId: summaryId, summaryLocale: summaryLocale, feedbackTitle: feedbackTitle, feedbackSummaryPlaceholder: feedbackSummaryPlaceholder, aiContentType: aiContentType })=>{
    const { showFlag: showFlag } = (0, $2ot3O.useFlags)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isFeedbackOpen, setIsFeedbackOpen] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const feedbackCollectorProperties = (0, $dchHi.useFeedbackCollectorProperties)();
    const [sentiment, setSentiment] = (0, $cozmU.useState)('');
    const [hasGoodFeedbackBeenSubmitted, setHasGoodFeedbackBeenSubmitted] = (0, $cozmU.useState)(false);
    const [hasBadFeedbackBeenSubmitted, setHasBadFeedbackBeenSubmitted] = (0, $cozmU.useState)(false);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $cXLoX.useAIEventsInstrumentation)();
    // Only fetch contributor info when contentId is provided (not for space-level feedback)
    const shouldFetchContributors = !!contentId;
    const contributorResult = (0, $PjC9c.useCurrentUserContributor)(contentId || '');
    const { isCurrentUserContributor: isCurrentUserContributor, contentContributorsError: contentContributorsError } = shouldFetchContributors ? contributorResult : {
        isCurrentUserContributor: undefined,
        contentContributorsError: undefined
    };
    const feedbackContextParts = [
        contentId && `contentId: ${contentId}`,
        spaceKey && `spaceKey: ${spaceKey}`,
        `sentiment: ${sentiment}`,
        `cloudId: ${cloudId}`,
        `isCurrentUserContributor: ${isCurrentUserContributor}`,
        feedbackCollectorProperties.feedbackContext.length > 0 && feedbackCollectorProperties.feedbackContext
    ].filter(Boolean);
    const feedbackContextString = feedbackContextParts.join(' ');
    (0, $cozmU.useEffect)(()=>{
        if (isFeedbackOpen) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: `${analyticsProperties.source}FeedbackCollectorDialog`,
                attributes: {
                    ...contentId && {
                        contentId: contentId
                    },
                    ...spaceKey && {
                        spaceKey: spaceKey
                    },
                    summaryId: summaryId,
                    summaryLocale: summaryLocale,
                    sentiment: sentiment,
                    ...analyticsProperties.additionalAnalyticsAttributes
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isFeedbackOpen,
        contentId,
        spaceKey,
        summaryId,
        summaryLocale,
        sentiment,
        analyticsProperties
    ]);
    const showFeedbackFlag = ()=>{
        showFlag({
            title: formatMessage($6d65bb3bd17dd577$var$i18n.flagTitle),
            description: formatMessage($6d65bb3bd17dd577$var$i18n.flagDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                color: "var(--ds-icon-success, #6A9A23)",
                label: "success"
            }),
            isAutoDismiss: true
        });
    };
    const onLikeClicked = ()=>{
        setIsFeedbackOpen(true);
        setSentiment('good');
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: analyticsProperties.source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `${analyticsProperties.source}LikeButton`,
                attributes: {
                    ...contentId && {
                        contentId: contentId
                    },
                    ...spaceKey && {
                        spaceKey: spaceKey
                    },
                    summaryId: summaryId,
                    summaryLocale: summaryLocale,
                    ...analyticsProperties.additionalAnalyticsAttributes
                }
            }
        }).fire();
        trackAIFeedbackSubmit('up');
    };
    const onDislikeClicked = ()=>{
        setIsFeedbackOpen(true);
        setSentiment('bad');
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: analyticsProperties.source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `${analyticsProperties.source}DislikeButton`,
                attributes: {
                    ...contentId && {
                        contentId: contentId
                    },
                    ...spaceKey && {
                        spaceKey: spaceKey
                    },
                    summaryId: summaryId,
                    summaryLocale: summaryLocale,
                    ...analyticsProperties.additionalAnalyticsAttributes
                }
            }
        }).fire();
        trackAIFeedbackSubmit('down');
    };
    const onFeedbackSubmit = ()=>{
        showFeedbackFlag();
        setIsFeedbackOpen(false);
        if (sentiment === 'good') {
            setHasGoodFeedbackBeenSubmitted(true);
            setHasBadFeedbackBeenSubmitted(false);
        } else {
            setHasBadFeedbackBeenSubmitted(true);
            setHasGoodFeedbackBeenSubmitted(false);
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: analyticsProperties.source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `${analyticsProperties.source}SubmitFeedbackButton`,
                attributes: {
                    ...contentId && {
                        contentId: contentId
                    },
                    ...spaceKey && {
                        spaceKey: spaceKey
                    },
                    summaryId: summaryId,
                    summaryLocale: summaryLocale,
                    sentiment: sentiment,
                    ...analyticsProperties.additionalAnalyticsAttributes
                }
            }
        }).fire();
    };
    const likeTooltip = aiContentType && aiContentType === 'suggestion' ? $6d65bb3bd17dd577$var$i18n.likeSuggestionTooltip : $6d65bb3bd17dd577$var$i18n.likeTooltip;
    const dislikeTooltip = aiContentType && aiContentType === 'suggestion' ? $6d65bb3bd17dd577$var$i18n.dislikeSuggestionTooltip : $6d65bb3bd17dd577$var$i18n.dislikeTooltip;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        role: "none",
        onClick: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        as: "ul",
        xcss: $6d65bb3bd17dd577$var$InlineULXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        as: "li",
        xcss: [
            $6d65bb3bd17dd577$var$TooltipWrapperXCSS,
            $6d65bb3bd17dd577$var$FeedbackIconXCSS
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        hideTooltipOnMouseDown: true,
        content: formatMessage(likeTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $6d65bb3bd17dd577$var$ButtonWrapperXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        "aria-label": formatMessage(likeTooltip),
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7OLeD.ThumbsIcon), {
            isSelected: hasGoodFeedbackBeenSubmitted
        }),
        onClick: onLikeClicked,
        testId: "feedback-like-button",
        isDisabled: hasGoodFeedbackBeenSubmitted
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        as: "li",
        xcss: [
            $6d65bb3bd17dd577$var$TooltipWrapperXCSS,
            $6d65bb3bd17dd577$var$FeedbackIconXCSS
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        hideTooltipOnMouseDown: true,
        content: formatMessage(dislikeTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $6d65bb3bd17dd577$var$ButtonWrapperXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        "aria-label": formatMessage(dislikeTooltip),
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $6d65bb3bd17dd577$var$DislikeIconWrapperXCSS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7OLeD.ThumbsIcon), {
            isSelected: hasBadFeedbackBeenSubmitted
        })),
        onClick: onDislikeClicked,
        testId: "feedback-dislike-button",
        isDisabled: hasBadFeedbackBeenSubmitted
    }))))), isFeedbackOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91uAX.default), {
        locale: feedbackCollectorProperties.locale,
        onSubmit: onFeedbackSubmit,
        onClose: ()=>setIsFeedbackOpen(false),
        atlassianAccountId: feedbackCollectorProperties.userId,
        name: feedbackCollectorProperties.displayName,
        entrypointId: feedbackCollectorProperties.entrypointId,
        summaryPlaceholder: formatMessage(feedbackSummaryPlaceholder ?? $6d65bb3bd17dd577$var$i18n.feedbackSummaryPlaceholder),
        additionalFields: [
            {
                id: feedbackCollectorProperties.feedbackContextId,
                value: feedbackContextString
            }
        ],
        feedbackTitle: formatMessage(feedbackTitle ?? $6d65bb3bd17dd577$var$i18n.feedbackTitle),
        showTypeField: false,
        customTextAreaLabel: formatMessage($6d65bb3bd17dd577$var$i18n.feedbackSummaryTitle),
        canBeContactedLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d65bb3bd17dd577$var$CanContactLabel, null),
        enrolInResearchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d65bb3bd17dd577$var$EnrolLabel, null)
    })), contentContributorsError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: contentContributorsError
    }));
};
module.exports["SmartsFeedbackComponent"] = $6d65bb3bd17dd577$export$cbc8ab5712ed2bd3;

});

parcelRegister("7OLeD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $c8bBH = parcelRequire("c8bBH");

const $e94a9fb89963bcaa$export$1337fc502d44e2c0 = ({ isSelected: isSelected })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)",
        spacing: "spacious",
        label: ""
    });
module.exports["ThumbsIcon"] = $e94a9fb89963bcaa$export$1337fc502d44e2c0;

});

parcelRegister("PjC9c", function(module, exports) {

var $3XvFR = parcelRequire("3XvFR");


var $jMyy4 = parcelRequire("jMyy4");

const $03062ed3aa730446$var$useCurrentUserContributorContentContributorsQuery = (0, $3XvFR.default);
const $03062ed3aa730446$export$b7b7e80a2f61884d = (contentId)=>{
    const { data: data, loading: contentContributorsLoading, error: contentContributorsError } = (0, $jMyy4.useQueryInterop)($03062ed3aa730446$var$useCurrentUserContributorContentContributorsQuery, {
        variables: {
            contentId: contentId
        },
        __callerPackage__: "quick-summary"
    });
    const isCurrentUserContributor = data?.contentContributors?.isCurrentUserContributor ?? undefined;
    return {
        isCurrentUserContributor: isCurrentUserContributor,
        contentContributorsLoading: contentContributorsLoading,
        contentContributorsError: contentContributorsError
    };
};
module.exports["useCurrentUserContributor"] = $03062ed3aa730446$export$b7b7e80a2f61884d;

});

parcelRegister("3XvFR", function(module, exports) {
/**
 * @generated SignedSource<<55bd5100cd9bfeca975d2cfff5c68ec3>>
 * @relayHash 8d03040d688843528ead855771e8246c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e77762aba0ebc1a12b0097564e9f8fce072dd0e08c861f47b22ab9799b0f4a00
const $019e619a88781c82$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentContributors",
            "kind": "LinkedField",
            "name": "contentContributors",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isCurrentUserContributor"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCurrentUserContributorContentContributorsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCurrentUserContributorContentContributorsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8d03040d688843528ead855771e8246c",
            "id": "e77762aba0ebc1a12b0097564e9f8fce072dd0e08c861f47b22ab9799b0f4a00",
            "metadata": {},
            "name": "useCurrentUserContributorContentContributorsQuery",
            "operationKind": "query",
            "text": "query useCurrentUserContributorContentContributorsQuery($contentId:ID!){contentContributors(id:$contentId){isCurrentUserContributor}}"
        }
    };
}();
$019e619a88781c82$var$node.hash = "3529cb3bd09c95342e2b9b31b917a3c4";
var $019e619a88781c82$export$2e2bcd8739ae039 = $019e619a88781c82$var$node;
module.exports["default"] = $019e619a88781c82$export$2e2bcd8739ae039;

});

parcelRegister("dchHi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $bQm3c = parcelRequire("bQm3c");

const $e12d220a6c6e853e$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $e12d220a6c6e853e$export$5b0d1a23cf38988 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $e12d220a6c6e853e$export$eecedbc46bd36460 = ({ children: children, entrypointId: entrypointId, locale: locale, feedbackContextId: feedbackContextId = $e12d220a6c6e853e$var$FEEDBACK_CONTEXT_CF, feedbackContext: feedbackContext = {}, userId: userId, displayName: displayName })=>{
    const { displayName: sessionDisplayName, userId: sessionUserId } = (0, $bQm3c.useSessionData)();
    const { locale: intlLocale } = (0, $kSwu1.useIntl)();
    const feedbackContextString = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${JSON.stringify(value)}`).join(' ');
    const contextValue = (0, $cozmU.useMemo)(()=>({
            entrypointId: entrypointId,
            feedbackContextId: feedbackContextId,
            feedbackContext: feedbackContextString,
            locale: locale || intlLocale,
            userId: userId || sessionUserId || undefined,
            displayName: displayName || sessionDisplayName || undefined
        }), [
        entrypointId,
        feedbackContextId,
        feedbackContextString,
        locale,
        intlLocale,
        userId,
        sessionUserId,
        displayName,
        sessionDisplayName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e12d220a6c6e853e$export$5b0d1a23cf38988.Provider, {
        value: contextValue
    }, children);
};
const $e12d220a6c6e853e$export$e8f7cf9dc2b23528 = ()=>{
    const context = (0, $cozmU.useContext)($e12d220a6c6e853e$export$5b0d1a23cf38988);
    if (context === undefined) throw new Error('useFeedbackCollectorProperties must be used within a FeedbackCollectorPropertiesProvider');
    return context;
};
module.exports["FeedbackCollectorPropertiesProvider"] = $e12d220a6c6e853e$export$eecedbc46bd36460;
module.exports["useFeedbackCollectorProperties"] = $e12d220a6c6e853e$export$e8f7cf9dc2b23528;

});

parcelRegister("gVCFw", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $41c05f11e4e9fb00$export$e4f30354a76c156b = (0, $kSwu1.defineMessages)({
    suggestEditsButtonLabel: {
        id: "fabric.editor.ai.suggestions.suggestEditsButtonLabel",
        defaultMessage: "Review"
    },
    suggestEditsPromptPrefix: {
        id: "fabric.editor.ai.suggestions.suggestEditsPromptPrefix.non-final",
        defaultMessage: "Review my content with "
    },
    suggestionsToolbarButtonLabel: {
        id: "fabric.editor.ai.suggestions.toolbarButton.label.non-final",
        defaultMessage: "Suggestions"
    },
    suggestionsToolbarButtonLoadingLabel: {
        id: "fabric.editor.ai.suggestions.toolbarButton.loadingLabel.non-final",
        defaultMessage: "Loading"
    },
    suggestionsToolbarButtonReadyLabel: {
        id: "fabric.editor.ai.suggestions.toolbarButton.readyLabel.non-final",
        defaultMessage: "View"
    },
    suggestionsToolbarButtonErrorLabel: {
        id: "fabric.editor.ai.suggestions.toolbarButton.errorLabel.non-final",
        defaultMessage: "Retry"
    },
    previewLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.previewLabel.non-final",
        defaultMessage: "Preview"
    },
    viewLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.viewLabel.non-final",
        defaultMessage: "View"
    },
    titleLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.titleLabel.non-final",
        defaultMessage: "Title"
    },
    reviewNote: {
        id: "fabric.editor.ai.suggestions.stagingArea.reviewNote.non-final",
        defaultMessage: "Review \u2022 Only visible to you"
    },
    applyChangesButtonLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.applyChangesButtonLabel.non-final",
        defaultMessage: "Apply changes"
    },
    fetchSuggestionsButtonLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.fetchSuggestionsButtonLabel.non-final",
        defaultMessage: "Fetch suggestions"
    },
    fetchSuggestionsButtonLoadingLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.fetchSuggestionsButtonLoadingLabel.non-final",
        defaultMessage: "Loading\u2026"
    },
    iconButtonSuggestionsCountLabel: {
        id: "fabric.editor.ai.suggestions.iconButton.suggestionsCountLabel.non-final",
        defaultMessage: "{count} suggestions"
    },
    labsLozengeLabel: {
        id: "fabric.editor.ai.suggestions.labsLozengeLabel.non-final",
        defaultMessage: "Labs"
    },
    originalViewLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.originalViewLabel.non-final",
        defaultMessage: "Original \u2022 View only"
    },
    suggestedLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.suggestedLabel.non-final",
        defaultMessage: "Suggested"
    },
    suggestionsLabel: {
        id: "fabric.editor.ai.suggestions.stagingArea.suggestionsLabel.non-final",
        defaultMessage: "Suggestions"
    },
    cardCloseButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.closeButtonLabel.non-final",
        defaultMessage: "Close"
    },
    cardShowSidebarButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.showSidebarButtonLabel.non-final",
        defaultMessage: "Show sidebar"
    },
    cardExpandButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.expandButtonLabel.non-final",
        defaultMessage: "Expand"
    },
    cardCollapseButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.collapseButtonLabel.non-final",
        defaultMessage: "Collapse"
    },
    cardRovoTitle: {
        id: "fabric.editor.ai.suggestions.card.rovoTitle.non-final",
        defaultMessage: "Rovo"
    },
    cardPrivateLabel: {
        id: "fabric.editor.ai.suggestions.card.privateLabel.non-final",
        defaultMessage: "Private"
    },
    cardPrivateTooltipLabelShort: {
        id: "fabric.editor.ai.suggestions.card.privateTooltipLabelShort.non-final",
        defaultMessage: "Visible only to you"
    },
    cardSourcesButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.sourcesButtonLabel.non-final",
        defaultMessage: "Sources"
    },
    cardSourcesHideButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.sourcesHideButtonLabel.non-final",
        defaultMessage: "Hide reasoning"
    },
    cardSourcesShowButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.sourcesShowButtonLabel.non-final",
        defaultMessage: "Show reasoning"
    },
    cardAcceptButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.acceptButtonLabel.non-final",
        defaultMessage: "Accept"
    },
    cardDiscardButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.discardButtonLabel.non-final",
        defaultMessage: "Discard"
    },
    cardDisclaimerText: {
        id: "fabric.editor.ai.suggestions.card.disclaimerText.non-final",
        defaultMessage: "Uses AI. Verify results."
    },
    cardDismissButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.dismissButtonLabel.non-final",
        defaultMessage: "Dismiss"
    },
    cardMoreOptionsButtonLabel: {
        id: "fabric.editor.ai.suggestions.card.moreOptionsButtonLabel.non-final",
        defaultMessage: "More options"
    },
    cardOnlyShowSuggestionOptionLabel: {
        id: "fabric.editor.ai.suggestions.card.onlyShowSuggestionOptionLabel.non-final",
        defaultMessage: "Only show suggestion"
    },
    cardCompareWithOriginalOptionLabel: {
        id: "fabric.editor.ai.suggestions.card.compareWithOriginalOptionLabel.non-final",
        defaultMessage: "Compare with original"
    },
    cardScrollBackToSuggestionLabel: {
        id: "fabric.editor.ai.suggestions.card.scrollBackToSuggestionLabel.non-final",
        defaultMessage: "Back to suggestion"
    },
    thinkingEscHint: {
        id: "fabric.editor.ai.suggestions.thinking.escHint.non-final",
        defaultMessage: "Esc"
    },
    thinkingStopLabel: {
        id: "fabric.editor.ai.suggestions.thinking.stopLabel.non-final",
        defaultMessage: "Stop"
    },
    thinkingReviewingContent: {
        id: "fabric.editor.ai.suggestions.thinking.reviewingContent.non-final",
        defaultMessage: "Reviewing content"
    },
    thinkingCheckingRelatedSources: {
        id: "fabric.editor.ai.suggestions.thinking.checkingRelatedSources.non-final",
        defaultMessage: "Checking related sources"
    },
    thinkingIdentifyingImprovements: {
        id: "fabric.editor.ai.suggestions.thinking.identifyingImprovements.non-final",
        defaultMessage: "Identifying improvements"
    },
    thinkingPreparingSuggestions: {
        id: "fabric.editor.ai.suggestions.thinking.preparingSuggestions.non-final",
        defaultMessage: "Preparing suggestions"
    },
    thinkingCompleteReviewComplete: {
        id: "fabric.editor.ai.suggestions.thinkingComplete.reviewComplete.non-final",
        defaultMessage: "Suggestions ready"
    },
    thinkingCompleteNoSuggestions: {
        id: "fabric.editor.ai.suggestions.thinkingComplete.noSuggestions.non-final",
        defaultMessage: "No suggestions found"
    },
    thinkingCompleteViewSuggestions: {
        id: "fabric.editor.ai.suggestions.thinkingComplete.viewSuggestions.non-final",
        defaultMessage: "View"
    },
    thinkingCompleteClose: {
        id: "fabric.editor.ai.suggestions.thinkingComplete.close.non-final",
        defaultMessage: "Close"
    }
});
module.exports["aiSuggestionsMessages"] = $41c05f11e4e9fb00$export$e4f30354a76c156b;

});

parcelRegister("lTuad", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4oS56 = parcelRequire("4oS56");

const $cd929b75fafb645b$export$cea8cae1a6ef81f0 = /*#__PURE__*/ (0, $cozmU.memo)(({ itemName: itemName, children: component, closeSelf: closeSelf, hasPadding: hasPadding = true, customWidth: customWidth })=>{
    const { setItem: setItem, removeItem: removeItem } = (0, $cozmU.useContext)((0, $4oS56.EditorContextPanelContext));
    // remove the item on unmount
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            removeItem(itemName);
        };
    }, [
        itemName,
        removeItem
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (component) setItem({
            itemName: itemName,
            component: component,
            close: closeSelf,
            hasPadding: hasPadding,
            customWidth: customWidth
        });
        else removeItem(itemName);
    }, [
        component,
        itemName,
        setItem,
        removeItem,
        closeSelf,
        hasPadding,
        customWidth
    ]);
    return null;
});
module.exports["EditorContextPanelItem"] = $cd929b75fafb645b$export$cea8cae1a6ef81f0;

});

parcelRegister("c5gk7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $l3wuH = parcelRequire("l3wuH");


var $lpNn5 = parcelRequire("lpNn5");

const $3611e64236f83f1d$var$i18n = (0, $kSwu1.defineMessages)({
    close: {
        id: "editor-context-panel.panel-close-button.close-label",
        defaultMessage: "Close configuration panel"
    }
});
const $3611e64236f83f1d$export$de65de8213222d10 = /*#__PURE__*/ (0, $cozmU.memo)(({ appearance: appearance = 'subtle', onClose: onClose, label: label, isTooltipDisabled: isTooltipDisabled = true, testId: testId = 'panel-close-button', analyticsContext: analyticsContext })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        hideTooltipOnClick: true,
        content: label || formatMessage($3611e64236f83f1d$var$i18n.close)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        onClick: onClose,
        appearance: appearance,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: label || formatMessage($3611e64236f83f1d$var$i18n.close),
        testId: testId,
        isTooltipDisabled: isTooltipDisabled,
        analyticsContext: analyticsContext
    }));
});
module.exports["CloseButton"] = $3611e64236f83f1d$export$de65de8213222d10;

});

parcelRegister("2E1L5", function(module, exports) {
const $f1205e6da653ae62$export$16708f74bd486c8 = 'confluence_page_ownership_changeboarding';
const $f1205e6da653ae62$export$9ed1986df73b834a = 'change-page-ownership-link';
const $f1205e6da653ae62$export$21191b0c00ca25f4 = 10;
const $f1205e6da653ae62$export$83728ea2bd792f67 = {
    USER_IS_NULL: 'You cannot set an owner as an anonymous user.',
    USER_NOT_FOUND: 'Owner id is an invalid account id.',
    USER_MISSING_PAGE_PERMISSION: 'New owner must have view and edit permission on the content.',
    CONTENT_ID_INVALID: 'Content id is invalid.',
    INSUFFICIENT_PERMISSIONS: 'You must be the content creator, owner, or a space admin to set the owner.'
};
const $f1205e6da653ae62$export$f0b683cb64dc68b0 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
const $f1205e6da653ae62$export$b344b39e3835f655 = 'https://support.atlassian.com/confluence-cloud/docs/transfer-ownership-of-your-page-to-another-person/';
const $f1205e6da653ae62$export$7ab4b084abc24ac8 = 'https://support.atlassian.com/confluence-cloud/docs/transfer-ownership-of-your-page-to-another-person/';
module.exports["CONTENT_OWNERSHIP_WEB_ITEM_ID"] = $f1205e6da653ae62$export$9ed1986df73b834a;
module.exports["DEFAULT_CONTRIBUTORS_FETCH_LIMIT"] = $f1205e6da653ae62$export$21191b0c00ca25f4;
module.exports["EXPECTED_ERROR_MESSAGES"] = $f1205e6da653ae62$export$83728ea2bd792f67;
module.exports["PARENT_PAGE_LEARN_MORE_URL"] = $f1205e6da653ae62$export$f0b683cb64dc68b0;
module.exports["CONFIRM_MODAL_LEARN_MORE_LINK"] = $f1205e6da653ae62$export$7ab4b084abc24ac8;

});

parcelRegister("gGK1T", function(module, exports) {
/**
 * @generated SignedSource<<e983bd00ea24afc042f5f11535352524>>
 * @relayHash b8208417e6c09fc98b947c6af794b0f3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c971c003da78a01cf940b7459511673bdc72b6148aa95f1c43a4a7a4369e8327
const $edbbfe37cbd0175f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": 4,
            "kind": "LocalArgument",
            "name": "limit"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v7 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v8 = [
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ 
    ], v9 = [
        v1 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        }
    ], v10 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentOwnershipContributorsContentOwnershipContributorsQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v8 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v8 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v8 /*: any*/ 
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentOwnershipContributorsContentOwnershipContributorsQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v10 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v10 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v10 /*: any*/ 
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b8208417e6c09fc98b947c6af794b0f3",
            "id": "c971c003da78a01cf940b7459511673bdc72b6148aa95f1c43a4a7a4369e8327",
            "metadata": {},
            "name": "useContentOwnershipContributorsContentOwnershipContributorsQuery",
            "operationKind": "query",
            "text": "query useContentOwnershipContributorsContentOwnershipContributorsQuery($contentId:ID!,$limit:Int=4){content(id:$contentId){nodes{id,history{ownedBy{__typename,displayName,type,...on KnownUser{accountId},profilePicture{path}}},version{by{__typename,displayName,type,...on KnownUser{accountId},profilePicture{path}}}}},contentContributors(id:$contentId,limit:$limit){nodes{__typename,displayName,type,...on KnownUser{accountId},profilePicture{path}}}}"
        }
    };
}();
$edbbfe37cbd0175f$var$node.hash = "e8dd42a19657acc23120ab54c46606ff";
var $edbbfe37cbd0175f$export$2e2bcd8739ae039 = $edbbfe37cbd0175f$var$node;
module.exports["default"] = $edbbfe37cbd0175f$export$2e2bcd8739ae039;

});

parcelRegister("bVAxT", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");

class $20c3e8ab10e63e24$export$f91385b453474810 extends (0, $kNIYN.Container) {
    getContentId() {
        return this.state.contentId;
    }
    getIsOpen() {
        return this.state.isOpen;
    }
    getTriggeredFrom() {
        return this.state.triggeredFrom;
    }
    getHideRestrictionsButtonSpinner() {
        return this.state.hideRestrictionsButtonSpinner;
    }
    setIsOpen(isOpen, triggeredFrom = null, callback) {
        return this.setState({
            isOpen: isOpen,
            triggeredFrom: triggeredFrom
        }, ()=>{
            if (callback) // using setTimeout here to let dialog transitions finish in case we want to interact with the UI. needed to trigger the share button.
            setTimeout(callback, 0);
        });
    }
    setContentId(contentId) {
        return this.setState({
            contentId: contentId
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isOpen: false,
            triggeredFrom: null,
            hideRestrictionsButtonSpinner: false,
            contentId: ''
        };
        this.initState = ()=>{
            return this.setState({
                contentId: '',
                isOpen: false,
                triggeredFrom: null,
                hideRestrictionsButtonSpinner: false
            });
        };
        this.setHideRestrictionsButtonSpinner = ()=>{
            return this.setState({
                hideRestrictionsButtonSpinner: true
            });
        };
    }
}
module.exports["RestrictionsDialogStateContainer"] = $20c3e8ab10e63e24$export$f91385b453474810;

});

parcelRegister("bJX6u", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");

const $258e0d668fcd3778$export$7e292eecf5a8f340 = {
    contentState: null,
    contentStateLastUpdated: null,
    shouldRunContentStateEffect: true,
    defaultStatesArray: [],
    customStatesArray: [],
    isContentStateEnabled: true,
    isSuggestedEnabled: true,
    isCustomEnabled: true,
    isUpdating: false,
    lastFetchedIsDraft: null,
    lastFetchedContentId: null
};
class $258e0d668fcd3778$export$ade89fbf99f42685 extends (0, $kNIYN.Container) {
    populateState(ssrContentStateData) {
        const newContentStateValues = Object.assign({}, $258e0d668fcd3778$export$7e292eecf5a8f340);
        newContentStateValues.shouldRunContentStateEffect = false;
        newContentStateValues.contentState = ssrContentStateData?.singleContent?.contentState || null;
        newContentStateValues.contentStateLastUpdated = ssrContentStateData?.singleContent?.contentStateLastUpdated?.value || null;
        newContentStateValues.defaultStatesArray = ssrContentStateData?.availableContentStates?.spaceContentStates?.filter((i)=>!!i) || [];
        newContentStateValues.customStatesArray = ssrContentStateData?.availableContentStates?.customContentStates?.filter((i)=>!!i) || [];
        // If an admin has turned off a toggle, BE returns us the value as null
        // If an empty array is returned [], means the feature is still enabled - there's just no values in there.
        // if both return as null it means the admin disabled content states
        const isSuggestedContentStatesDisabled = !ssrContentStateData?.availableContentStates?.spaceContentStates;
        const isCustomContentStatesDisabled = !ssrContentStateData?.availableContentStates?.customContentStates;
        const isContentStatesDisabled = isSuggestedContentStatesDisabled && isCustomContentStatesDisabled;
        if (isContentStatesDisabled) newContentStateValues.isContentStateEnabled = false;
        else if (isSuggestedContentStatesDisabled) // if spaceContentStates is null, admin disabled suggested
        newContentStateValues.isSuggestedEnabled = false;
        else if (isCustomContentStatesDisabled) // if customContentStates is null, admin disabled custom
        newContentStateValues.isCustomEnabled = false;
        this.state = newContentStateValues;
    }
    constructor(ssrContentStateData){
        super();
        this.state = {
            ...$258e0d668fcd3778$export$7e292eecf5a8f340
        };
        // Guards optimistic, mutation-owned fields (applied status + option list) from being
        // clobbered by stale refetches while an operation is pending. Kept off `state` so it
        // survives the refetch-driven `setInitialValues` calls.
        this.isOptimisticOperationPending = false;
        this.setIsOptimisticOperationPending = (isOptimisticOperationPending)=>{
            this.isOptimisticOperationPending = isOptimisticOperationPending;
        };
        // The contentId for which the empty add-status trigger should be kept visible after a
        // view-mode delete. Stored as an id (not a boolean) so render can scope it to the current page
        // without a navigation listener — it's only honored while this matches the active contentId,
        // so it naturally clears on navigation. Kept off `state` so a fresh container (refresh) resets it.
        this.keepEmptyTriggerForContentId = null;
        this.setKeepEmptyTriggerForContentId = (contentId)=>{
            this.keepEmptyTriggerForContentId = contentId;
        };
        this.setContentState = (contentState)=>this.setState({
                contentState: contentState
            });
        this.setShouldRunContentStateEffect = (shouldRunContentStateEffect)=>this.setState({
                shouldRunContentStateEffect: shouldRunContentStateEffect
            });
        this.setDefaultStatesArray = (defaultStatesArray)=>this.setState({
                defaultStatesArray: defaultStatesArray
            });
        this.setCustomStatesArray = (customStatesArray)=>this.setState({
                customStatesArray: customStatesArray
            });
        this.setIsContentStateEnabled = (isContentStateEnabled)=>this.setState({
                isContentStateEnabled: isContentStateEnabled
            });
        this.setIsSuggestedEnabled = (isSuggestedEnabled)=>this.setState({
                isSuggestedEnabled: isSuggestedEnabled
            });
        this.setIsCustomEnabled = (isCustomEnabled)=>this.setState({
                isCustomEnabled: isCustomEnabled
            });
        this.setIsUpdating = (isUpdating)=>this.setState({
                isUpdating: isUpdating
            });
        this.setLastFetchedIsDraft = (lastFetchedIsDraft)=>this.setState({
                lastFetchedIsDraft: lastFetchedIsDraft
            });
        this.setLastFetchedContentId = (lastFetchedContentId)=>this.setState({
                lastFetchedContentId: lastFetchedContentId
            });
        this.setInitialValues = (contentStateState)=>this.setState(contentStateState);
        this.resetToDefaults = ()=>this.setState({
                ...$258e0d668fcd3778$export$7e292eecf5a8f340
            });
        if (ssrContentStateData) this.populateState(ssrContentStateData);
    }
}
module.exports["defaultValues"] = $258e0d668fcd3778$export$7e292eecf5a8f340;
module.exports["ContentStateStateContainer"] = $258e0d668fcd3778$export$ade89fbf99f42685;

});

parcelRegister("iiPY2", function(module, exports) {
$parcel$export(module.exports, "ContentTypeClassification", () => (parcelRequire("2JKSZ")).ContentTypeClassification);

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $jmjWc = parcelRequire("jmjWc");


var $2JKSZ = parcelRequire("2JKSZ");


const $200528ba24c995ad$export$b3d0b57fae17761b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "fcpuS",
    name: "ContentTypeClassificationLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("2JKSZ")))).ContentTypeClassification,
    loading: (props)=>{
        const { contentClassificationMetadata: contentClassificationMetadata } = props;
        const { hasNoClassification: hasNoClassification } = contentClassificationMetadata;
        const shouldNotRenderLoader = hasNoClassification;
        if (shouldNotRenderLoader) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
        /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
            const $ = (0, $bDgLe.c)(13);
            let T0;
            let t1;
            let t2;
            let t3;
            let t4;
            if ($[0] !== __cmplr || $[1] !== t0) {
                const { as: t5, style: __cmpls, ...__cmplp } = t0;
                const C = t5 === undefined ? "div" : t5;
                T0 = C;
                t1 = __cmplp;
                t2 = __cmpls;
                t3 = __cmplr;
                t4 = (0, $hekY6.default)([
                    "_4t3i1tcg",
                    __cmplp.className
                ]);
                $[0] = __cmplr;
                $[1] = t0;
                $[2] = T0;
                $[3] = t1;
                $[4] = t2;
                $[5] = t3;
                $[6] = t4;
            } else {
                T0 = $[2];
                t1 = $[3];
                t2 = $[4];
                t3 = $[5];
                t4 = $[6];
            }
            let t5;
            if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
                t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
                    ...t1,
                    style: t2,
                    ref: t3,
                    className: t4
                });
                $[7] = T0;
                $[8] = t1;
                $[9] = t2;
                $[10] = t3;
                $[11] = t4;
                $[12] = t5;
            } else t5 = $[12];
            return t5;
        } : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
                ...__cmplp,
                style: __cmpls,
                ref: __cmplr,
                className: (0, $hekY6.default)([
                    "_4t3i1tcg",
                    __cmplp.className
                ])
            });
        }), {}, '');
    }
});
module.exports["ContentTypeClassificationLoader"] = $200528ba24c995ad$export$b3d0b57fae17761b;

});

parcelRegister("2JKSZ", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $6mKj3 = parcelRequire("6mKj3");


var $arfOv = parcelRequire("arfOv");


var $9yVdT = parcelRequire("9yVdT");


var $fGQzQ = parcelRequire("fGQzQ");


var $1u6lx = parcelRequire("1u6lx");


var $in5LX = parcelRequire("in5LX");


var $79yie = parcelRequire("79yie");


var $1cYlh = parcelRequire("1cYlh");


const $d07cae14ea38bbbf$var$ClassificationTagButtonError = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "8ozBk",
    name: "ClassificationTagButtonError",
    loader: async ()=>(await (parcelRequire("8NFko"))).ClassificationTagButtonError
});
const $d07cae14ea38bbbf$var$ContentTypeClassificationComponent = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { spaceKey: spaceKey, contentId: contentId, contentType: contentType, contentClassificationMetadata: contentClassificationMetadata, readOnly: t1, variant: t2, popupPlacementOverride: popupPlacementOverride, spacing: spacing, onRestoreFocus: onRestoreFocus, buttonTestId: buttonTestId } = t0;
    const readOnly = t1 === undefined ? true : t1;
    const variant = t2 === undefined ? (0, $1u6lx.TagButtonUIVariant).default : t2;
    const intl = (0, $kSwu1.useIntl)();
    let t3;
    if ($[0] !== contentClassificationMetadata || $[1] !== contentId) {
        t3 = {
            contentId: contentId,
            contentClassificationMetadata: contentClassificationMetadata
        };
        $[0] = contentClassificationMetadata;
        $[1] = contentId;
        $[2] = t3;
    } else t3 = $[2];
    const handleSubmit = (0, $fGQzQ.useEditSubmitCallback)(t3);
    const { classification: currentClassification, hasNoClassification: hasNoClassification, shouldDisplayClassification: shouldDisplayClassification, flagStatus: flagStatus, errorState: errorState, contentLevelError: contentLevelError, spaceDefaultIsOverridden: spaceDefaultIsOverridden, source: source, canManageSpaceSettings: canManageSpaceSettings, classificationControlSetting: classificationControlSetting, userOverrideSetting: userOverrideSetting } = contentClassificationMetadata;
    const isLoading = flagStatus === (0, $in5LX.FlagStatus).LOADING;
    const showNoClassificationLozenge = contentClassificationMetadata?.userOverrideSetting === "DISALLOW" && hasNoClassification && (0, $6mKj3.expVal)("dlp_auto_classifications_enabled", "isEnabled", false);
    const isAddNewClassificationMode = !readOnly && hasNoClassification && !shouldDisplayClassification && !showNoClassificationLozenge;
    if (isAddNewClassificationMode) return null;
    let displayClassification = currentClassification;
    if (showNoClassificationLozenge) {
        let t4;
        if ($[3] !== intl.formatMessage) {
            t4 = (0, $1cYlh.getNoClassificationForContent)(intl.formatMessage);
            $[3] = intl.formatMessage;
            $[4] = t4;
        } else t4 = $[4];
        displayClassification = t4;
    }
    if (!displayClassification || errorState === (0, $79yie.ErrorState).NULL) return null;
    if (errorState === (0, $79yie.ErrorState).MESSAGE) {
        let t4;
        if ($[5] !== contentLevelError) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d07cae14ea38bbbf$var$ClassificationTagButtonError, {
                contentLevelError: contentLevelError
            });
            $[5] = contentLevelError;
            $[6] = t4;
        } else t4 = $[6];
        return t4;
    }
    const t4 = readOnly ? (0, $arfOv.TagButtonMenuBehavior).readOnly : (0, $arfOv.TagButtonMenuBehavior).readAndEdit;
    let t5;
    if ($[7] !== buttonTestId || $[8] !== canManageSpaceSettings || $[9] !== classificationControlSetting || $[10] !== contentId || $[11] !== contentType || $[12] !== displayClassification || $[13] !== handleSubmit || $[14] !== isLoading || $[15] !== onRestoreFocus || $[16] !== popupPlacementOverride || $[17] !== source || $[18] !== spaceDefaultIsOverridden || $[19] !== spaceKey || $[20] !== spacing || $[21] !== t4 || $[22] !== userOverrideSetting || $[23] !== variant) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arfOv.GenericClassificationTagButton), {
            spaceKey: spaceKey,
            contentId: contentId,
            contentType: contentType,
            currentClassification: displayClassification,
            spaceDefaultIsOverridden: spaceDefaultIsOverridden,
            onEditSubmit: handleSubmit,
            menuBehavior: t4,
            loading: isLoading,
            variant: variant,
            popupPlacementOverride: popupPlacementOverride,
            spacing: spacing,
            onRestoreFocus: onRestoreFocus,
            buttonTestId: buttonTestId,
            source: source,
            canManageSpaceSettings: canManageSpaceSettings,
            classificationControlSetting: classificationControlSetting,
            userOverrideSetting: userOverrideSetting
        });
        $[7] = buttonTestId;
        $[8] = canManageSpaceSettings;
        $[9] = classificationControlSetting;
        $[10] = contentId;
        $[11] = contentType;
        $[12] = displayClassification;
        $[13] = handleSubmit;
        $[14] = isLoading;
        $[15] = onRestoreFocus;
        $[16] = popupPlacementOverride;
        $[17] = source;
        $[18] = spaceDefaultIsOverridden;
        $[19] = spaceKey;
        $[20] = spacing;
        $[21] = t4;
        $[22] = userOverrideSetting;
        $[23] = variant;
        $[24] = t5;
    } else t5 = $[24];
    let t6;
    if ($[25] !== flagStatus || $[26] !== isLoading || $[27] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9yVdT.TagLoadingAndFlagWrapper), {
            isLoading: isLoading,
            flagStatus: flagStatus
        }, t5);
        $[25] = flagStatus;
        $[26] = isLoading;
        $[27] = t5;
        $[28] = t6;
    } else t6 = $[28];
    return t6;
} : ({ spaceKey: spaceKey, contentId: contentId, contentType: contentType, contentClassificationMetadata: contentClassificationMetadata, readOnly: readOnly = true, variant: variant = (0, $1u6lx.TagButtonUIVariant).default, popupPlacementOverride: popupPlacementOverride, spacing: spacing, onRestoreFocus: onRestoreFocus, buttonTestId: buttonTestId })=>{
    const intl = (0, $kSwu1.useIntl)();
    const handleSubmit = (0, $fGQzQ.useEditSubmitCallback)({
        contentId: contentId,
        contentClassificationMetadata: contentClassificationMetadata
    });
    const { classification: currentClassification, hasNoClassification: hasNoClassification, shouldDisplayClassification: shouldDisplayClassification, flagStatus: flagStatus, errorState: errorState, contentLevelError: contentLevelError, spaceDefaultIsOverridden: spaceDefaultIsOverridden, source: source, canManageSpaceSettings: canManageSpaceSettings, classificationControlSetting: classificationControlSetting, userOverrideSetting: userOverrideSetting } = contentClassificationMetadata;
    const isLoading = flagStatus === (0, $in5LX.FlagStatus).LOADING;
    const showNoClassificationLozenge = contentClassificationMetadata?.userOverrideSetting === 'DISALLOW' && hasNoClassification && (0, $6mKj3.expVal)('dlp_auto_classifications_enabled', 'isEnabled', false);
    const isAddNewClassificationMode = !readOnly && hasNoClassification && !shouldDisplayClassification && !showNoClassificationLozenge;
    if (isAddNewClassificationMode) return null;
    let displayClassification = currentClassification;
    if (showNoClassificationLozenge) displayClassification = (0, $1cYlh.getNoClassificationForContent)(intl.formatMessage);
    if (!displayClassification || errorState === (0, $79yie.ErrorState).NULL) return null;
    if (errorState === (0, $79yie.ErrorState).MESSAGE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d07cae14ea38bbbf$var$ClassificationTagButtonError, {
        contentLevelError: contentLevelError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9yVdT.TagLoadingAndFlagWrapper), {
        isLoading: isLoading,
        flagStatus: flagStatus
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arfOv.GenericClassificationTagButton), {
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: contentType,
        currentClassification: displayClassification,
        spaceDefaultIsOverridden: spaceDefaultIsOverridden,
        onEditSubmit: handleSubmit,
        menuBehavior: readOnly ? (0, $arfOv.TagButtonMenuBehavior).readOnly : (0, $arfOv.TagButtonMenuBehavior).readAndEdit,
        loading: isLoading,
        variant: variant,
        popupPlacementOverride: popupPlacementOverride,
        spacing: spacing,
        onRestoreFocus: onRestoreFocus,
        buttonTestId: buttonTestId,
        source: source,
        canManageSpaceSettings: canManageSpaceSettings,
        classificationControlSetting: classificationControlSetting,
        userOverrideSetting: userOverrideSetting
    }));
};
const $d07cae14ea38bbbf$var$ContentTypeClassificationGetter = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d07cae14ea38bbbf$var$ContentTypeClassificationComponent, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d07cae14ea38bbbf$var$ContentTypeClassificationComponent, props);
};
const $d07cae14ea38bbbf$var$ContentTypeClassificationWithErrorBoundary = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).DLP
})($d07cae14ea38bbbf$var$ContentTypeClassificationGetter);
const $d07cae14ea38bbbf$export$e97138dbbe0f9a02 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d07cae14ea38bbbf$var$ContentTypeClassificationWithErrorBoundary, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d07cae14ea38bbbf$var$ContentTypeClassificationWithErrorBoundary, props);
module.exports["ContentTypeClassification"] = $d07cae14ea38bbbf$export$e97138dbbe0f9a02;

});

parcelRegister("arfOv", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $536md = parcelRequire("536md");


var $jmjWc = parcelRequire("jmjWc");


var $bQm3c = parcelRequire("bQm3c");


var $earLp = parcelRequire("earLp");


var $1u6lx = parcelRequire("1u6lx");


var $6Ry4r = parcelRequire("6Ry4r");


const $e299f5faef060d8a$var$ClassificationReadViewPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "zUIer",
    name: "ClassificationReadViewPopup",
    loader: async ()=>(await (parcelRequire("c9NHr"))).ClassificationReadViewPopup
});

const $e299f5faef060d8a$var$ClassificationEditViewPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "mT5oW",
    name: "ClassificationEditViewPopup",
    loader: async ()=>(await (parcelRequire("hhMPb"))).ClassificationEditViewPopup
});
var $e299f5faef060d8a$export$db79e28c55608769 = /*#__PURE__*/ function(TagButtonMenuBehavior) {
    TagButtonMenuBehavior["readOnly"] = "readOnly";
    TagButtonMenuBehavior["editOnly"] = "editOnly";
    TagButtonMenuBehavior["readAndEdit"] = "readAndEdit";
    return TagButtonMenuBehavior;
}({});
const $e299f5faef060d8a$var$DataClassificationLevelMemo = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $536md.default));
const $e299f5faef060d8a$var$messages = (0, $kSwu1.defineMessages)({
    tooltipMessage: {
        id: "data-classification.content-classification.tag-button.tooltip",
        defaultMessage: "This {contentType} is classified as {classification}"
    }
});
const $e299f5faef060d8a$export$e396cc9924b8f3a0 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(56);
    const { spaceKey: spaceKey, contentId: contentId, contentType: contentType, currentClassification: currentClassification, spaceDefaultIsOverridden: spaceDefaultIsOverridden, onEditCancel: onEditCancelProp, onEditSubmit: onEditSubmitProp, loading: t1, isPopupDisabled: t2, menuBehavior: t3, variant: t4, popupPlacementOverride: popupPlacementOverride, spacing: spacing, onRestoreFocus: onRestoreFocus, buttonTestId: t5, source: source, canManageSpaceSettings: canManageSpaceSettings, classificationControlSetting: classificationControlSetting, userOverrideSetting: userOverrideSetting } = t0;
    const loading = t1 === undefined ? false : t1;
    const isPopupDisabled = t2 === undefined ? false : t2;
    const menuBehavior = t3 === undefined ? "readOnly" : t3;
    const variant = t4 === undefined ? (0, $1u6lx.TagButtonUIVariant).default : t4;
    const buttonTestId = t5 === undefined ? "data-classification-level" : t5;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [isReadView, setIsReadView] = (0, $cozmU.useState)(true);
    const { trackEditPopupViewed: trackEditPopupViewed } = (0, $earLp.useTrackClassificationAnalytics)();
    const popupPlacement = popupPlacementOverride || "auto";
    let t6;
    let t7;
    if ($[0] !== menuBehavior) {
        t6 = ()=>{
            if (menuBehavior === "editOnly") setIsReadView(false);
        };
        t7 = [
            menuBehavior
        ];
        $[0] = menuBehavior;
        $[1] = t6;
        $[2] = t7;
    } else {
        t6 = $[1];
        t7 = $[2];
    }
    (0, $cozmU.useEffect)(t6, t7);
    const defaultSelectedEditOption = spaceDefaultIsOverridden ? currentClassification : undefined;
    let getOnChangeLevelClick;
    let handlePopupShown;
    let onEditCancel;
    let onEditSubmit;
    if ($[3] !== isReadView || $[4] !== menuBehavior || $[5] !== onEditCancelProp || $[6] !== onEditSubmitProp || $[7] !== onRestoreFocus || $[8] !== trackEditPopupViewed) {
        getOnChangeLevelClick = ()=>{
            if (menuBehavior === "readOnly") return;
            return ()=>{
                setIsReadView(false);
                handlePopupShown({
                    isOpen: true,
                    shouldForce: true
                });
            };
        };
        let t8;
        if ($[13] !== menuBehavior || $[14] !== onEditCancelProp) {
            t8 = (closePopup)=>{
                onEditCancelProp && onEditCancelProp();
                closePopup();
                if (menuBehavior !== "editOnly") setIsReadView(true);
            };
            $[13] = menuBehavior;
            $[14] = onEditCancelProp;
            $[15] = t8;
        } else t8 = $[15];
        onEditCancel = t8;
        let t9;
        if ($[16] !== menuBehavior || $[17] !== onEditSubmitProp || $[18] !== onRestoreFocus) {
            t9 = (classification, closePopup_0)=>{
                onEditSubmitProp && onEditSubmitProp(classification);
                onRestoreFocus && onRestoreFocus();
                closePopup_0();
                if (menuBehavior !== "editOnly") setIsReadView(true);
            };
            $[16] = menuBehavior;
            $[17] = onEditSubmitProp;
            $[18] = onRestoreFocus;
            $[19] = t9;
        } else t9 = $[19];
        onEditSubmit = t9;
        handlePopupShown = (t10)=>{
            const { isOpen: isOpen, shouldForce: t11 } = t10;
            const shouldForce = t11 === undefined ? false : t11;
            if (isOpen) {
                const shouldTrackEvent = !isReadView || shouldForce;
                if (shouldTrackEvent) trackEditPopupViewed((0, $earLp.ActionSubjectId).CONTENT_TYPE_TITLE_DATA_CLASSIFICATION_POPUP);
            }
        };
        $[3] = isReadView;
        $[4] = menuBehavior;
        $[5] = onEditCancelProp;
        $[6] = onEditSubmitProp;
        $[7] = onRestoreFocus;
        $[8] = trackEditPopupViewed;
        $[9] = getOnChangeLevelClick;
        $[10] = handlePopupShown;
        $[11] = onEditCancel;
        $[12] = onEditSubmit;
    } else {
        getOnChangeLevelClick = $[9];
        handlePopupShown = $[10];
        onEditCancel = $[11];
        onEditSubmit = $[12];
    }
    let t8;
    if ($[20] !== canManageSpaceSettings || $[21] !== classificationControlSetting || $[22] !== cloudId || $[23] !== contentId || $[24] !== currentClassification || $[25] !== defaultSelectedEditOption || $[26] !== getOnChangeLevelClick || $[27] !== isReadView || $[28] !== loading || $[29] !== onEditCancel || $[30] !== onEditSubmit || $[31] !== source || $[32] !== spaceKey || $[33] !== userOverrideSetting) {
        t8 = (closePopup_1)=>isReadView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e299f5faef060d8a$var$ClassificationReadViewPopup, {
                name: currentClassification.name,
                classification: currentClassification,
                onChangeLevelClick: getOnChangeLevelClick(),
                source: source ?? undefined,
                isCurrentUserSpaceAdmin: canManageSpaceSettings,
                classificationControl: classificationControlSetting ?? "ANY",
                userOverride: userOverrideSetting ?? "ANY"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e299f5faef060d8a$var$ClassificationEditViewPopup, {
                spaceKey: spaceKey,
                selectedOption: defaultSelectedEditOption,
                onEditCancel: ()=>onEditCancel(closePopup_1),
                onEditSubmit: (classification_0)=>onEditSubmit(classification_0, closePopup_1),
                loading: loading,
                cloudId: cloudId,
                contentId: contentId,
                userOverride: userOverrideSetting ?? "ANY"
            });
        $[20] = canManageSpaceSettings;
        $[21] = classificationControlSetting;
        $[22] = cloudId;
        $[23] = contentId;
        $[24] = currentClassification;
        $[25] = defaultSelectedEditOption;
        $[26] = getOnChangeLevelClick;
        $[27] = isReadView;
        $[28] = loading;
        $[29] = onEditCancel;
        $[30] = onEditSubmit;
        $[31] = source;
        $[32] = spaceKey;
        $[33] = userOverrideSetting;
        $[34] = t8;
    } else t8 = $[34];
    const renderPopupComponent = t8;
    let t9;
    if ($[35] !== currentClassification) {
        t9 = (0, $6Ry4r.getGuidelineProps)(currentClassification);
        $[35] = currentClassification;
        $[36] = t9;
    } else t9 = $[36];
    const { guideline: guideline, guidelineRepresentation: guidelineRepresentation } = t9;
    const t10 = currentClassification.name;
    let t11;
    if ($[37] !== contentType || $[38] !== currentClassification.name || $[39] !== formatMessage) {
        t11 = formatMessage($e299f5faef060d8a$var$messages.tooltipMessage, {
            contentType: contentType,
            classification: currentClassification.name
        });
        $[37] = contentType;
        $[38] = currentClassification.name;
        $[39] = formatMessage;
        $[40] = t11;
    } else t11 = $[40];
    const t12 = currentClassification.color || "GREY";
    const t13 = renderPopupComponent;
    let t14;
    if ($[41] !== handlePopupShown) {
        t14 = ()=>handlePopupShown({
                isOpen: true
            });
        $[41] = handlePopupShown;
        $[42] = t14;
    } else t14 = $[42];
    const t15 = variant === (0, $1u6lx.TagButtonUIVariant).iconOnly;
    let t16;
    if ($[43] !== buttonTestId || $[44] !== currentClassification.name || $[45] !== guideline || $[46] !== guidelineRepresentation || $[47] !== isPopupDisabled || $[48] !== popupPlacement || $[49] !== spacing || $[50] !== t11 || $[51] !== t12 || $[52] !== t13 || $[53] !== t14 || $[54] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e299f5faef060d8a$var$DataClassificationLevelMemo, {
            testId: buttonTestId,
            name: t10,
            guideline: guideline,
            guidelineRepresentation: guidelineRepresentation,
            tooltip: t11,
            color: t12,
            isPopupDisabled: isPopupDisabled,
            renderPopupComponent: t13,
            onPopupShown: t14,
            isIconOnly: t15,
            popupPlacement: popupPlacement,
            spacing: spacing
        }));
        $[43] = buttonTestId;
        $[44] = currentClassification.name;
        $[45] = guideline;
        $[46] = guidelineRepresentation;
        $[47] = isPopupDisabled;
        $[48] = popupPlacement;
        $[49] = spacing;
        $[50] = t11;
        $[51] = t12;
        $[52] = t13;
        $[53] = t14;
        $[54] = t15;
        $[55] = t16;
    } else t16 = $[55];
    return t16;
} : ({ spaceKey: spaceKey, contentId: contentId, contentType: contentType, currentClassification: currentClassification, spaceDefaultIsOverridden: spaceDefaultIsOverridden, onEditCancel: onEditCancelProp, onEditSubmit: onEditSubmitProp, loading: loading = false, isPopupDisabled: isPopupDisabled = false, menuBehavior: menuBehavior = "readOnly", variant: variant = (0, $1u6lx.TagButtonUIVariant).default, popupPlacementOverride: popupPlacementOverride, spacing: spacing, onRestoreFocus: onRestoreFocus, buttonTestId: buttonTestId = 'data-classification-level', source: source, canManageSpaceSettings: canManageSpaceSettings, classificationControlSetting: classificationControlSetting, userOverrideSetting: userOverrideSetting })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const [isReadView, setIsReadView] = (0, $cozmU.useState)(true);
    const { trackEditPopupViewed: trackEditPopupViewed } = (0, $earLp.useTrackClassificationAnalytics)();
    const popupPlacement = popupPlacementOverride || 'auto';
    (0, $cozmU.useEffect)(()=>{
        if (menuBehavior === "editOnly") setIsReadView(false);
    }, [
        menuBehavior
    ]);
    const defaultSelectedEditOption = spaceDefaultIsOverridden ? currentClassification : undefined;
    const getOnChangeLevelClick = ()=>{
        if (menuBehavior === "readOnly") return undefined;
        return ()=>{
            setIsReadView(false);
            handlePopupShown({
                isOpen: true,
                shouldForce: true
            });
        };
    };
    const onEditCancel = (closePopup)=>{
        onEditCancelProp && onEditCancelProp();
        closePopup();
        if (menuBehavior !== "editOnly") setIsReadView(true);
    };
    const onEditSubmit = (classification, closePopup_0)=>{
        onEditSubmitProp && onEditSubmitProp(classification);
        onRestoreFocus && onRestoreFocus();
        closePopup_0();
        if (menuBehavior !== "editOnly") setIsReadView(true);
    };
    const handlePopupShown = ({ isOpen: isOpen, shouldForce: shouldForce = false })=>{
        if (isOpen) {
            const shouldTrackEvent = !isReadView || shouldForce;
            if (shouldTrackEvent) trackEditPopupViewed((0, $earLp.ActionSubjectId).CONTENT_TYPE_TITLE_DATA_CLASSIFICATION_POPUP);
        }
    };
    const renderPopupComponent = (closePopup_1)=>{
        return isReadView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e299f5faef060d8a$var$ClassificationReadViewPopup, {
            name: currentClassification.name,
            classification: currentClassification,
            onChangeLevelClick: getOnChangeLevelClick(),
            source: source ?? undefined,
            isCurrentUserSpaceAdmin: canManageSpaceSettings,
            classificationControl: classificationControlSetting ?? 'ANY',
            userOverride: userOverrideSetting ?? 'ANY'
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e299f5faef060d8a$var$ClassificationEditViewPopup, {
            spaceKey: spaceKey,
            selectedOption: defaultSelectedEditOption,
            onEditCancel: ()=>onEditCancel(closePopup_1),
            onEditSubmit: (classification_0)=>onEditSubmit(classification_0, closePopup_1),
            loading: loading,
            cloudId: cloudId,
            contentId: contentId,
            userOverride: userOverrideSetting ?? 'ANY'
        });
    };
    const { guideline: guideline, guidelineRepresentation: guidelineRepresentation } = (0, $6Ry4r.getGuidelineProps)(currentClassification);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e299f5faef060d8a$var$DataClassificationLevelMemo, {
        testId: buttonTestId,
        name: currentClassification.name,
        guideline: guideline,
        guidelineRepresentation: guidelineRepresentation,
        tooltip: formatMessage($e299f5faef060d8a$var$messages.tooltipMessage, {
            contentType: contentType,
            classification: currentClassification.name
        }),
        color: currentClassification.color || 'GREY',
        isPopupDisabled: isPopupDisabled,
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        renderPopupComponent: renderPopupComponent,
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        onPopupShown: ()=>handlePopupShown({
                isOpen: true
            }),
        isIconOnly: variant === (0, $1u6lx.TagButtonUIVariant).iconOnly,
        popupPlacement: popupPlacement,
        spacing: spacing
    }));
};
module.exports["TagButtonMenuBehavior"] = $e299f5faef060d8a$export$db79e28c55608769;
module.exports["GenericClassificationTagButton"] = $e299f5faef060d8a$export$e396cc9924b8f3a0;

});

parcelRegister("earLp", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $9DHhW = parcelRequire("9DHhW");


var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");

var $a91836006a246f35$export$cb7d54f314e067cb = /*#__PURE__*/ function(ActionSubjectId) {
    ActionSubjectId["EDITOR_TITLE_DATA_CLASSIFICATION_POPUP"] = "editorTitleDataClassificationPopup";
    ActionSubjectId["CONTENT_TYPE_TITLE_DATA_CLASSIFICATION_POPUP"] = "contentTypeTitleDataClassificationPopup";
    ActionSubjectId["GENERIC_DATA_CLASSIFICATION_MODAL_POPUP"] = "genericDataClassificationModalPopup";
    return ActionSubjectId;
}({});
const $a91836006a246f35$var$getEditPopupViewedScreenEvent = ({ cloudId: cloudId, spaceId: spaceId, orgId: orgId, actionSubjectId: actionSubjectId })=>({
        type: 'sendScreenEvent',
        data: {
            name: 'dataClassificationEditPopup',
            action: 'viewed',
            actionSubject: 'popup',
            actionSubjectId: actionSubjectId,
            attributes: {
                cloudId: cloudId,
                spaceId: spaceId,
                orgId: orgId
            }
        }
    });
const $a91836006a246f35$export$c5f7a48280d6f361 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== cloudId || $[1] !== createAnalyticsEvent || $[2] !== orgId || $[3] !== spaceId) {
        t0 = {
            trackEditPopupViewed: (actionSubjectId)=>{
                if (!spaceId || !cloudId || !orgId) return;
                createAnalyticsEvent($a91836006a246f35$var$getEditPopupViewedScreenEvent({
                    cloudId: cloudId,
                    spaceId: spaceId,
                    orgId: orgId,
                    actionSubjectId: actionSubjectId
                })).fire();
            },
            trackRenderTagError: (errorMessage)=>{
                if (!spaceId || !cloudId || !orgId) return;
                createAnalyticsEvent({
                    type: "sendOperationalEvent",
                    data: {
                        action: "failed",
                        actionSubject: "dataClassificationTagRender",
                        source: "confluence-frontend",
                        attributes: {
                            cloudId: cloudId,
                            spaceId: spaceId,
                            orgId: orgId,
                            error: errorMessage
                        }
                    }
                }).fire();
            }
        };
        $[0] = cloudId;
        $[1] = createAnalyticsEvent;
        $[2] = orgId;
        $[3] = spaceId;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : ()=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    return {
        trackEditPopupViewed: (actionSubjectId)=>{
            if (!spaceId || !cloudId || !orgId) return;
            createAnalyticsEvent($a91836006a246f35$var$getEditPopupViewedScreenEvent({
                cloudId: cloudId,
                spaceId: spaceId,
                orgId: orgId,
                actionSubjectId: actionSubjectId
            })).fire();
        },
        trackRenderTagError: (errorMessage)=>{
            if (!spaceId || !cloudId || !orgId) return;
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'dataClassificationTagRender',
                    source: 'confluence-frontend',
                    attributes: {
                        cloudId: cloudId,
                        spaceId: spaceId,
                        orgId: orgId,
                        error: errorMessage
                    }
                }
            }).fire();
        }
    };
};
module.exports["ActionSubjectId"] = $a91836006a246f35$export$cb7d54f314e067cb;
module.exports["useTrackClassificationAnalytics"] = $a91836006a246f35$export$c5f7a48280d6f361;

});

parcelRegister("1u6lx", function(module, exports) {
var $a200b44450c31008$export$f72f271864b318ce = /*#__PURE__*/ function(TagButtonUIVariant) {
    TagButtonUIVariant["iconOnly"] = "iconOnly";
    TagButtonUIVariant["default"] = "default";
    return TagButtonUIVariant;
}({});
module.exports["TagButtonUIVariant"] = $a200b44450c31008$export$f72f271864b318ce;

});

parcelRegister("6Ry4r", function(module, exports) {
const $588818833e6e4a91$export$44b43449ad5e39e3 = (classification)=>{
    // Prefer ADF guideline over plain text
    if (classification?.guidelineADF) return {
        guideline: classification.guidelineADF,
        guidelineRepresentation: 'EDITOR'
    };
    // Fall back to plain text guideline
    return {
        guideline: classification?.guideline,
        guidelineRepresentation: 'PLAIN'
    };
};
module.exports["getGuidelineProps"] = $588818833e6e4a91$export$44b43449ad5e39e3;

});

parcelRegister("c9NHr", function(module, exports) {

let $8d9ce09dac3a8042$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8d9ce09dac3a8042$var$load("ieMNy"),
    $8d9ce09dac3a8042$var$load("iJsKa")
]).then(()=>parcelRequire('ePhVt'));

});

parcelRegister("hhMPb", function(module, exports) {

let $c959e5c12627131d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c959e5c12627131d$var$load("grUVf"),
    $c959e5c12627131d$var$load("ieMNy"),
    $c959e5c12627131d$var$load("58UdM")
]).then(()=>parcelRequire('8KSlr'));

});

parcelRegister("9yVdT", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $lfoFx = parcelRequire("lfoFx");


var $1l0kj = parcelRequire("1l0kj");


var $gqqjz = parcelRequire("gqqjz");


var $in5LX = parcelRequire("in5LX");


var $gfkT8 = parcelRequire("gfkT8");


var $93WhG = parcelRequire("93WhG");

const $b9673e4989b5dd09$export$10b01f6c9dc571ea = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { children: children, flagStatus: flagStatus, isLoading: t1 } = t0;
    const isLoading = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== isLoading) {
        t2 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "small",
            interactionName: "data-classification-tag-loading"
        });
        $[0] = isLoading;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = [
            (0, $gqqjz.FlagsStateContainer)
        ];
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== flagStatus) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: t3
        }, (flags)=>flagStatus === (0, $in5LX.FlagStatus).ERROR && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gfkT8.SaveFlag), {
                flags: flags,
                title: (0, $93WhG.sharedMessages).saveErrorTextPrimary,
                description: (0, $93WhG.sharedMessages).saveErrorTextSecondary,
                type: "warning",
                showRefresh: false
            }));
        $[3] = flagStatus;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== children || $[6] !== t2 || $[7] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
            alignBlock: "center",
            space: "space.050"
        }, children, t2, t4);
        $[5] = children;
        $[6] = t2;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ children: children, flagStatus: flagStatus, isLoading: isLoading = false })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.default), {
        alignBlock: "center",
        space: "space.050"
    }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "small",
        interactionName: "data-classification-tag-loading"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>flagStatus === (0, $in5LX.FlagStatus).ERROR && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gfkT8.SaveFlag), {
            flags: flags,
            title: (0, $93WhG.sharedMessages).saveErrorTextPrimary,
            description: (0, $93WhG.sharedMessages).saveErrorTextSecondary,
            type: "warning",
            showRefresh: false
        })));
};
module.exports["TagLoadingAndFlagWrapper"] = $b9673e4989b5dd09$export$10b01f6c9dc571ea;

});

parcelRegister("gfkT8", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $1cYlh = parcelRequire("1cYlh");

const $4ebf6b4d55a3b532$var$actionMessage = (0, $kSwu1.defineMessage)({
    id: "data-classification.settings-panel.error-flag-action",
    defaultMessage: "Refresh page"
});
const $4ebf6b4d55a3b532$export$fedbe2c138bb22c4 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { flags: flags, type: type, title: title, description: description, classification: classification, spaceName: spaceName, showRefresh: showRefresh } = t0;
    let t1;
    let t2;
    if ($[0] !== classification || $[1] !== description || $[2] !== flags || $[3] !== showRefresh || $[4] !== spaceName || $[5] !== title || $[6] !== type) {
        t1 = ()=>{
            const actions = !!showRefresh ? [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $4ebf6b4d55a3b532$var$actionMessage),
                    onClick: $4ebf6b4d55a3b532$var$_temp
                }
            ] : [];
            const showFlag = async ()=>{
                const successFlag = await flags.showFlag({
                    type: type,
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), title),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                        ...description,
                        values: {
                            spaceName: spaceName,
                            classification: classification === (0, $1cYlh.NO_CLASSIFICATION) ? "unclassified" : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, classification)
                        }
                    }),
                    actions: actions
                });
                setTimeout(()=>flags.hideFlag(successFlag.id), 5000);
            };
            showFlag().catch(console.error);
        };
        t2 = [
            flags,
            type,
            title,
            description,
            spaceName,
            showRefresh,
            classification
        ];
        $[0] = classification;
        $[1] = description;
        $[2] = flags;
        $[3] = showRefresh;
        $[4] = spaceName;
        $[5] = title;
        $[6] = type;
        $[7] = t1;
        $[8] = t2;
    } else {
        t1 = $[7];
        t2 = $[8];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
} : ({ flags: flags, type: type, title: title, description: description, classification: classification, spaceName: spaceName, showRefresh: showRefresh })=>{
    (0, $cozmU.useEffect)(()=>{
        const actions = !!showRefresh ? [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $4ebf6b4d55a3b532$var$actionMessage),
                onClick: ()=>window.location.reload()
            }
        ] : [];
        const showFlag = async ()=>{
            const successFlag = await flags.showFlag({
                type: type,
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), title),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...description,
                    values: {
                        spaceName: spaceName,
                        classification: classification === (0, $1cYlh.NO_CLASSIFICATION) ? 'unclassified' : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, classification)
                    }
                }),
                actions: actions
            });
            setTimeout(()=>flags.hideFlag(successFlag.id), 5000);
        };
        // eslint-disable-next-line no-console
        showFlag().catch(console.error);
    }, [
        flags,
        type,
        title,
        description,
        spaceName,
        showRefresh,
        classification
    ]);
    return null;
};
const $4ebf6b4d55a3b532$var$SaveFlagGetter = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4ebf6b4d55a3b532$export$fedbe2c138bb22c4, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4ebf6b4d55a3b532$export$fedbe2c138bb22c4, props);
};
const $4ebf6b4d55a3b532$var$SaveFlagWithErrorBoundary = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).DLP
})($4ebf6b4d55a3b532$var$SaveFlagGetter);
const $4ebf6b4d55a3b532$export$ac7557ff3627d244 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4ebf6b4d55a3b532$var$SaveFlagWithErrorBoundary, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4ebf6b4d55a3b532$var$SaveFlagWithErrorBoundary, props);
function $4ebf6b4d55a3b532$var$_temp() {
    return window.location.reload();
}
module.exports["SaveFlag"] = $4ebf6b4d55a3b532$export$ac7557ff3627d244;

});

parcelRegister("93WhG", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $81f08aaba4f97dd2$export$39a13631616da233 = (0, $kSwu1.defineMessages)({
    classifyContent: {
        id: "data-classification.shared-messages.edit-popup.classify-content",
        defaultMessage: "Classify content"
    },
    fetchErrorTextPrimary: {
        id: "data-classification.shared-messages.fetch-error.primary",
        defaultMessage: "Unable to load classification. Try again."
    },
    fetchErrorTextSecondary: {
        id: "data-classification.shared-messages.fetch-error.secondary",
        defaultMessage: "Try reloading now."
    },
    saveErrorTextPrimary: {
        id: "data-classification.shared-messages.save-error.primary",
        defaultMessage: "Update to classification failed to save"
    },
    saveErrorTextSecondary: {
        id: "data-classification.shared-messages.save-error.secondary",
        defaultMessage: "Please try again."
    }
});
module.exports["sharedMessages"] = $81f08aaba4f97dd2$export$39a13631616da233;

});

parcelRegister("fGQzQ", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7tHGa = parcelRequire("7tHGa");


var $in5LX = parcelRequire("in5LX");


var $4oYaK = parcelRequire("4oYaK");


var $3tzmY = parcelRequire("3tzmY");


var $45d60 = parcelRequire("45d60");


var $fcQxC = parcelRequire("fcQxC");

const $3ebf4e9018306b37$export$9756cece5bf0eb59 = (contentStatus)=>{
    switch(contentStatus){
        case (0, $7tHGa.ContentStatus).DRAFT:
            return (0, $45d60.ContentDataClassificationMutationContentStatus).DRAFT;
        default:
            return (0, $45d60.ContentDataClassificationMutationContentStatus).CURRENT;
    }
};
const $3ebf4e9018306b37$export$94cbb2414d06bc8b = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { contentId: contentId, contentClassificationMetadata: contentClassificationMetadata } = t0;
    const { setSubmittedClassification: setSubmittedClassification, setFlagStatus: setFlagStatus, updateContentDataClassificationLevel: updateClassificationMutation, deleteContentDataClassificationLevel: deleteClassificationMutation, contentStatusContext: contentStatusContext } = contentClassificationMetadata;
    let t1;
    if ($[0] !== contentId || $[1] !== contentStatusContext || $[2] !== deleteClassificationMutation || $[3] !== setFlagStatus || $[4] !== setSubmittedClassification || $[5] !== updateClassificationMutation) {
        t1 = (classificationOption)=>{
            if (!classificationOption?.id) return;
            setFlagStatus((0, $in5LX.FlagStatus).LOADING);
            const { writeContext: contentStatusWriteContext } = (0, $fcQxC.getReadAndWriteContextFromQueryContext)(contentStatusContext ?? "current-only");
            const contentStatuses = contentStatusWriteContext.map($3ebf4e9018306b37$export$9756cece5bf0eb59);
            const baseVariables = {
                id: parseInt(contentId),
                contentStatuses: contentStatuses
            };
            const optionIsNoClassificationOption = classificationOption?.id === (0, $4oYaK.NO_CLASSIFICATION_OPTION_ID);
            const optionIsSpaceDefaultClassificationOption = classificationOption?.id === (0, $3tzmY.SPACE_DEFAULT_CLASSIFICATION_OPTION_ID);
            const shouldDeleteClassification = optionIsNoClassificationOption || optionIsSpaceDefaultClassificationOption;
            if (shouldDeleteClassification) {
                if (optionIsNoClassificationOption) setSubmittedClassification(null);
                if (optionIsSpaceDefaultClassificationOption) setSubmittedClassification(classificationOption?.classificationOverride ?? null);
                deleteClassificationMutation({
                    variables: baseVariables
                });
            } else {
                setSubmittedClassification(classificationOption);
                updateClassificationMutation({
                    variables: {
                        ...baseVariables,
                        classificationLevelId: classificationOption.id
                    }
                });
            }
        };
        $[0] = contentId;
        $[1] = contentStatusContext;
        $[2] = deleteClassificationMutation;
        $[3] = setFlagStatus;
        $[4] = setSubmittedClassification;
        $[5] = updateClassificationMutation;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : ({ contentId: contentId, contentClassificationMetadata: contentClassificationMetadata })=>{
    const { setSubmittedClassification: setSubmittedClassification, setFlagStatus: setFlagStatus, updateContentDataClassificationLevel: updateClassificationMutation, deleteContentDataClassificationLevel: deleteClassificationMutation, contentStatusContext: contentStatusContext } = contentClassificationMetadata;
    return (0, $cozmU.useCallback)((classificationOption)=>{
        // Provides type safety for the mutation variables
        if (!classificationOption?.id) return;
        setFlagStatus((0, $in5LX.FlagStatus).LOADING);
        const { writeContext: contentStatusWriteContext } = (0, $fcQxC.getReadAndWriteContextFromQueryContext)(contentStatusContext ?? 'current-only');
        const contentStatuses = contentStatusWriteContext.map($3ebf4e9018306b37$export$9756cece5bf0eb59);
        const baseVariables = {
            id: parseInt(contentId),
            contentStatuses: contentStatuses
        };
        const optionIsNoClassificationOption = classificationOption?.id === (0, $4oYaK.NO_CLASSIFICATION_OPTION_ID);
        const optionIsSpaceDefaultClassificationOption = classificationOption?.id === (0, $3tzmY.SPACE_DEFAULT_CLASSIFICATION_OPTION_ID);
        const shouldDeleteClassification = optionIsNoClassificationOption || optionIsSpaceDefaultClassificationOption;
        if (shouldDeleteClassification) {
            if (optionIsNoClassificationOption) setSubmittedClassification(null);
            if (optionIsSpaceDefaultClassificationOption) setSubmittedClassification(classificationOption?.classificationOverride ?? null);
            deleteClassificationMutation({
                variables: baseVariables
            });
        } else {
            setSubmittedClassification(classificationOption);
            updateClassificationMutation({
                variables: {
                    ...baseVariables,
                    classificationLevelId: classificationOption.id
                }
            });
        }
    }, [
        contentId,
        setFlagStatus,
        contentStatusContext,
        updateClassificationMutation,
        deleteClassificationMutation,
        setSubmittedClassification
    ]);
};
module.exports["useEditSubmitCallback"] = $3ebf4e9018306b37$export$94cbb2414d06bc8b;

});

parcelRegister("4oYaK", function(module, exports) {
const $8d28ed91f3c96188$export$ea52aaec0b4536b2 = 'data-classification.no-classification-option';
module.exports["NO_CLASSIFICATION_OPTION_ID"] = $8d28ed91f3c96188$export$ea52aaec0b4536b2;

});

parcelRegister("3tzmY", function(module, exports) {
const $1cdd6556a0b2e638$export$8942d0d7876f8b98 = 'data-classification.space-default-classification-option';
module.exports["SPACE_DEFAULT_CLASSIFICATION_OPTION_ID"] = $1cdd6556a0b2e638$export$8942d0d7876f8b98;

});

parcelRegister("45d60", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $d94436a169325872$export$8be450ac125d65b9 = /*#__PURE__*/ function(ContentDataClassificationMutationContentStatus) {
    ContentDataClassificationMutationContentStatus["CURRENT"] = "CURRENT";
    ContentDataClassificationMutationContentStatus["DRAFT"] = "DRAFT";
    return ContentDataClassificationMutationContentStatus;
}({});
module.exports["ContentDataClassificationMutationContentStatus"] = $d94436a169325872$export$8be450ac125d65b9;

});

parcelRegister("8NFko", function(module, exports) {

let $6682f537c7726c29$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6682f537c7726c29$var$load("5odbj").then(()=>parcelRequire('2O7oS'));

});

parcelRegister("knzfV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $40pD8 = parcelRequire("40pD8");


var $fGQzQ = parcelRequire("fGQzQ");


var $earLp = parcelRequire("earLp");


const $5cd13874f5033207$var$LazyClassificationEditModalContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "oT96U",
    name: "LazyClassificationEditModalContent",
    loader: async ()=>(await (parcelRequire("2ad5Q"))).ClassificationEditModalContent
});
const $5cd13874f5033207$export$d7e008c8afea1e79 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { contentId: contentId, spaceKey: spaceKey, contentClassificationMetadata: contentClassificationMetadata } = t0;
    const { isClassificationModalOpen: isClassificationModalOpen } = (0, $40pD8.useClassificationModalContext)();
    const { setIsClassificationModalOpen: setIsClassificationModalOpen } = (0, $40pD8.useClassificationModalDispatchContext)();
    const { trackEditPopupViewed: trackEditPopupViewed } = (0, $earLp.useTrackClassificationAnalytics)();
    let t1;
    if ($[0] !== contentClassificationMetadata || $[1] !== contentId) {
        t1 = {
            contentId: contentId,
            contentClassificationMetadata: contentClassificationMetadata
        };
        $[0] = contentClassificationMetadata;
        $[1] = contentId;
        $[2] = t1;
    } else t1 = $[2];
    const handleSubmit = (0, $fGQzQ.useEditSubmitCallback)(t1);
    const { classification: classification, spaceDefaultIsOverridden: spaceDefaultIsOverridden } = contentClassificationMetadata;
    const defaultSelectedEditOption = spaceDefaultIsOverridden ? classification : undefined;
    let t2;
    if ($[3] !== handleSubmit || $[4] !== setIsClassificationModalOpen) {
        t2 = (classificationOption)=>{
            handleSubmit(classificationOption);
            setIsClassificationModalOpen(false);
        };
        $[3] = handleSubmit;
        $[4] = setIsClassificationModalOpen;
        $[5] = t2;
    } else t2 = $[5];
    const onEditSubmit = t2;
    let t3;
    if ($[6] !== setIsClassificationModalOpen) {
        t3 = ()=>{
            setIsClassificationModalOpen(false);
        };
        $[6] = setIsClassificationModalOpen;
        $[7] = t3;
    } else t3 = $[7];
    const onEditCancel = t3;
    let t4;
    let t5;
    if ($[8] !== isClassificationModalOpen || $[9] !== trackEditPopupViewed) {
        t4 = ()=>{
            if (isClassificationModalOpen) trackEditPopupViewed((0, $earLp.ActionSubjectId).GENERIC_DATA_CLASSIFICATION_MODAL_POPUP);
        };
        t5 = [
            isClassificationModalOpen,
            trackEditPopupViewed
        ];
        $[8] = isClassificationModalOpen;
        $[9] = trackEditPopupViewed;
        $[10] = t4;
        $[11] = t5;
    } else {
        t4 = $[10];
        t5 = $[11];
    }
    (0, $cozmU.useEffect)(t4, t5);
    if (!isClassificationModalOpen) return null;
    let t6;
    if ($[12] !== setIsClassificationModalOpen) {
        t6 = ()=>setIsClassificationModalOpen(false);
        $[12] = setIsClassificationModalOpen;
        $[13] = t6;
    } else t6 = $[13];
    const t7 = defaultSelectedEditOption ?? undefined;
    let t8;
    if ($[14] !== contentId || $[15] !== onEditCancel || $[16] !== onEditSubmit || $[17] !== spaceKey || $[18] !== t6 || $[19] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5cd13874f5033207$var$LazyClassificationEditModalContent, {
            onClose: t6,
            onEditSubmit: onEditSubmit,
            onEditCancel: onEditCancel,
            selectedOption: t7,
            spaceKey: spaceKey,
            contentId: contentId
        });
        $[14] = contentId;
        $[15] = onEditCancel;
        $[16] = onEditSubmit;
        $[17] = spaceKey;
        $[18] = t6;
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    return t8;
} : ({ contentId: contentId, spaceKey: spaceKey, contentClassificationMetadata: contentClassificationMetadata })=>{
    const { isClassificationModalOpen: isClassificationModalOpen } = (0, $40pD8.useClassificationModalContext)();
    const { setIsClassificationModalOpen: setIsClassificationModalOpen } = (0, $40pD8.useClassificationModalDispatchContext)();
    const { trackEditPopupViewed: trackEditPopupViewed } = (0, $earLp.useTrackClassificationAnalytics)();
    const handleSubmit = (0, $fGQzQ.useEditSubmitCallback)({
        contentId: contentId,
        contentClassificationMetadata: contentClassificationMetadata
    });
    const { classification: classification, spaceDefaultIsOverridden: spaceDefaultIsOverridden } = contentClassificationMetadata;
    const defaultSelectedEditOption = spaceDefaultIsOverridden ? classification : undefined;
    const onEditSubmit = (0, $cozmU.useCallback)((classificationOption)=>{
        handleSubmit(classificationOption);
        setIsClassificationModalOpen(false);
    }, [
        handleSubmit,
        setIsClassificationModalOpen
    ]);
    const onEditCancel = (0, $cozmU.useCallback)(()=>{
        setIsClassificationModalOpen(false);
    }, [
        setIsClassificationModalOpen
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isClassificationModalOpen) trackEditPopupViewed((0, $earLp.ActionSubjectId).GENERIC_DATA_CLASSIFICATION_MODAL_POPUP);
    }, [
        isClassificationModalOpen,
        trackEditPopupViewed
    ]);
    if (!isClassificationModalOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5cd13874f5033207$var$LazyClassificationEditModalContent, {
        onClose: ()=>setIsClassificationModalOpen(false),
        onEditSubmit: onEditSubmit,
        onEditCancel: onEditCancel,
        selectedOption: defaultSelectedEditOption ?? undefined,
        spaceKey: spaceKey,
        contentId: contentId
    });
};
module.exports["ClassificationEditModal"] = $5cd13874f5033207$export$d7e008c8afea1e79;

});

parcelRegister("2ad5Q", function(module, exports) {

let $1936ac02d0e8ab82$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1936ac02d0e8ab82$var$load("grUVf"),
    $1936ac02d0e8ab82$var$load("ieMNy"),
    $1936ac02d0e8ab82$var$load("58UdM"),
    $1936ac02d0e8ab82$var$load("20qsp")
]).then(()=>parcelRequire('enSER'));

});

parcelRegister("lABjq", function(module, exports) {
const $8cb98e143c540908$export$79ede1af301c436c = {
    pageJustPublished: false
};
module.exports["pagePublishedState"] = $8cb98e143c540908$export$79ede1af301c436c;

});

parcelRegister("2wSyg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $87bc0f5ac3c4b9fb$var$DraftSyncAndPublishContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    getIsPublishing: ()=>false,
    setIsPublishing: (_)=>{
    // Intentional no-op
    },
    isPublishing: false
});
const $87bc0f5ac3c4b9fb$export$dc8d83ecee528ce8 = ({ children: children })=>{
    // These should remain in sync. The ref is used while a draft sync occurs, while
    // the state variable is used for re-rendering.
    const isPublishingRef = (0, $cozmU.useRef)(false);
    const [isPublishing, setIsPublishing] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const getIsPublishing = (0, $cozmU.useCallback)(()=>isPublishingRef.current, []);
    const setPublishing = (0, $cozmU.useCallback)((value)=>{
        isPublishingRef.current = value;
        setIsPublishing(value);
    }, []);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            getIsPublishing: getIsPublishing,
            setIsPublishing: setPublishing,
            isPublishing: isPublishing
        }), [
        getIsPublishing,
        setPublishing,
        isPublishing
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($87bc0f5ac3c4b9fb$var$DraftSyncAndPublishContext.Provider, {
        value: contextValue
    }, children);
};
const $87bc0f5ac3c4b9fb$export$bceb447197cf2e23 = ({ children: children })=>{
    const context = $87bc0f5ac3c4b9fb$export$6aa44ee82d5db3e4();
    return children(context);
};
const $87bc0f5ac3c4b9fb$export$6aa44ee82d5db3e4 = ()=>{
    return (0, $cozmU.useContext)($87bc0f5ac3c4b9fb$var$DraftSyncAndPublishContext);
};
module.exports["DraftSyncAndPublishContextProvider"] = $87bc0f5ac3c4b9fb$export$dc8d83ecee528ce8;
module.exports["DraftSyncAndPublishContextConsumer"] = $87bc0f5ac3c4b9fb$export$bceb447197cf2e23;
module.exports["useDraftSyncAndPublishContext"] = $87bc0f5ac3c4b9fb$export$6aa44ee82d5db3e4;

});

parcelRegister("lEnke", function(module, exports) {

var $9o40q = parcelRequire("9o40q");


var $aBfpe = parcelRequire("aBfpe");

const $6bba1273a65c92dc$export$97c5b582958cdf97 = ({ onCompleted: onCompleted, onError: onError } = {})=>{
    return (0, $9o40q.useExperimentalMutation)({
        url: ({ contentId: contentId })=>`/wiki/rest/api/content/${contentId}/?status=draft&action=sync`,
        method: 'PUT',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        body: ({ contentId: contentId, contentType: contentType, title: title, content: content, ncsStepVersion: ncsStepVersion })=>{
            const history = contentType === 'blogpost' ? {
                createdDate: new Date().toISOString()
            } : undefined;
            const extensions = {
                'update-trigger': 'DRAFT_SYNC'
            };
            const body = {
                id: contentId,
                type: contentType,
                title: title,
                body: {
                    atlas_doc_format: {
                        value: content,
                        representation: 'atlas_doc_format',
                        content: {
                            id: contentId
                        }
                    }
                },
                status: 'draft',
                version: {
                    number: 1,
                    message: '',
                    ...ncsStepVersion ? {
                        ncsStepVersion: ncsStepVersion
                    } : {}
                },
                extensions: extensions,
                history: history
            };
            return JSON.stringify(body);
        },
        parseResult: (response)=>{
            // The response should match the GraphQL mutation structure
            // experimentalDraftSync: { id: string | null }
            return {
                experimentalDraftSync: {
                    id: response?.id || null
                }
            };
        },
        onCompleted: onCompleted,
        onError: onError
    });
};
module.exports["useExperimentalDraftSyncMutation"] = $6bba1273a65c92dc$export$97c5b582958cdf97;

});

parcelRegister("79LXc", function(module, exports) {

var $islpn = parcelRequire("islpn");


var $4EPzQ = parcelRequire("4EPzQ");

const $e6b881450bf521b8$export$46a7f65963d82cf5 = (doc)=>{
    const pageElementCounts = {
        elements: {},
        textFormats: {},
        macros: {},
        unexpectedElements: {}
    };
    (0, $4EPzQ.reduce)(doc, (acc, node)=>{
        if (node.type === 'text') {
            if (node.marks) node.marks.forEach((mark)=>{
                const markType = mark.type;
                acc.textFormats[markType] = (acc.textFormats[markType] ?? 0) + 1;
            });
            acc.elements[node.type] = (acc.elements[node.type] ?? 0) + 1;
        } else if (node.type === 'extension' || node.type === 'inlineExtension' || node.type === 'bodiedExtension' || node.type === 'multiBodiedExtension' || node.type === 'extensionFrame') {
            if ('attrs' in node && node.attrs && 'extensionKey' in node.attrs && node.attrs.extensionKey) {
                let extensionKey = node.attrs.extensionKey;
                // If there is a nested table extension
                if ((0, $islpn.isNestedTableExtension)(node)) {
                    if ('parameters' in node.attrs && node.attrs.parameters && 'adf' in node.attrs.parameters) {
                        // Check to see if the ADF contains a nested table
                        const adfString = node.attrs.parameters.adf;
                        const adf = JSON.parse(adfString);
                        if (adfString.includes('{"type":"table"')) {
                            if ($e6b881450bf521b8$var$getHasNestedTable(adf)) acc.unexpectedElements['tablesNestedMoreThanOnce'] = (acc.unexpectedElements['tablesNestedMoreThanOnce'] ?? 0) + 1;
                        }
                    }
                }
                // If macros extensionKey has <UUID>/<UUID>/static/ prepended to it, remove the prefix
                if (extensionKey.includes('/static/')) {
                    const extensionKeyParts = extensionKey.split('/');
                    extensionKey = extensionKeyParts[extensionKeyParts.length - 1];
                }
                acc.macros[extensionKey] = (acc.macros[extensionKey] ?? 0) + 1;
            }
        } else acc.elements[node.type] = (acc.elements[node.type] ?? 0) + 1;
        return acc;
    }, pageElementCounts);
    return pageElementCounts;
};
/**
 * Return true is the JSON document contains a table nested within a table
 */ const $e6b881450bf521b8$var$getHasNestedTable = (node)=>{
    return (0, $4EPzQ.reduce)(node, (hasNestedTable, node)=>{
        if (hasNestedTable) return hasNestedTable;
        if (node.type === 'table') {
            // The first node that we pass into the reduce function is a table node, and we need to ignore it
            let foundFirstTable = false;
            return (0, $4EPzQ.reduce)(node, (hasNestedTable, node)=>{
                if (hasNestedTable) return hasNestedTable;
                if (node.type === 'table' && foundFirstTable) return true;
                else if (node.type === 'table') foundFirstTable = true;
                return hasNestedTable;
            }, false);
        }
        return hasNestedTable;
    }, false);
};
module.exports["getPageElementCounts"] = $e6b881450bf521b8$export$46a7f65963d82cf5;

});

parcelRegister("gQojb", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");

const $3dcbd344a2ba2fc1$export$593ae3df1272c4d1 = ({ source: source, actionSubjectId: actionSubjectId, contentId: contentId, contentType: contentType, collabService: collabService, version: version })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const triggerPageConflictAnalytics = (0, $cozmU.useCallback)((errorMessage, extraData = {})=>{
        $3dcbd344a2ba2fc1$export$80e39f0a257b3d6c(source, actionSubjectId, {
            contentId: contentId,
            contentType: contentType,
            collabService: collabService,
            version: version,
            errorMessage: errorMessage,
            ...extraData
        }, createAnalyticsEvent);
    }, [
        createAnalyticsEvent,
        source,
        actionSubjectId,
        contentId,
        contentType,
        collabService,
        version
    ]);
    return {
        triggerPageConflictAnalytics: triggerPageConflictAnalytics
    };
};
const $3dcbd344a2ba2fc1$export$80e39f0a257b3d6c = (source, actionSubjectId, attributes, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            source: source,
            action: 'error',
            actionSubject: 'pageConflict',
            actionSubjectId: actionSubjectId,
            attributes: attributes
        }
    }).fire();
};
module.exports["usePageConflictAnalytics"] = $3dcbd344a2ba2fc1$export$593ae3df1272c4d1;

});

parcelRegister("dYcT6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $601vk = parcelRequire("601vk");

const $2e3f617799d734b5$var$EditorFlagsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    showEditorFlag: ()=>{}
});
const $2e3f617799d734b5$export$ad7226c60a7baa4f = ({ contentId: contentId, children: children })=>{
    const [flag, setFlag] = (0, $cozmU.useState)(undefined);
    const showEditorFlag = (0, $cozmU.useCallback)((flagData)=>{
        setFlag(flagData);
    }, [
        setFlag
    ]);
    // memoize to return the same reference to object and prevent render of multiple error flag with the same message
    const errorData = (0, $cozmU.useMemo)(()=>flag?.errorName ? {
            [flag.errorName]: true
        } : undefined, [
        flag
    ]);
    const contextValue = (0, $cozmU.useMemo)(()=>{
        return {
            showEditorFlag: showEditorFlag
        };
    }, [
        showEditorFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e3f617799d734b5$var$EditorFlagsContext.Provider, {
        value: contextValue
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $601vk.EditorErrorFlags), {
        contentId: contentId,
        statusCode: flag?.statusCode,
        errorData: errorData,
        lastPublisher: flag?.lastPublisher,
        collabService: flag?.collabService,
        isUnpublishedDraft: flag?.isUnpublishedDraft
    }));
};
function $2e3f617799d734b5$export$5368f855bc23a165(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e3f617799d734b5$export$ad7226c60a7baa4f, {
            contentId: props.contentId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, props));
}
const $2e3f617799d734b5$export$32aceb9a79692418 = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($2e3f617799d734b5$var$EditorFlagsContext);
};
module.exports["withEditorFlagsContext"] = $2e3f617799d734b5$export$5368f855bc23a165;
module.exports["useEditorFlagsContext"] = $2e3f617799d734b5$export$32aceb9a79692418;

});

parcelRegister("601vk", function(module, exports) {

var $f2yKj = parcelRequire("f2yKj");


var $kw3pa = parcelRequire("kw3pa");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kyKWe = parcelRequire("kyKWe");


var $9DHhW = parcelRequire("9DHhW");


var $ep3mz = parcelRequire("ep3mz");


var $7aRa9 = parcelRequire("7aRa9");


var $b3j2Y = parcelRequire("b3j2Y");


var $3jwuS = parcelRequire("3jwuS");


var $03Xmw = parcelRequire("03Xmw");


var $fb79u = parcelRequire("fb79u");


var $6jB9o = parcelRequire("6jB9o");


var $1mHQU = parcelRequire("1mHQU");


var $cHfGW = parcelRequire("cHfGW");


var $gQojb = parcelRequire("gQojb");


var $jMyy4 = parcelRequire("jMyy4");

const $5f7518f04afd0b6f$export$8f60114e4ef36b27 = (0, $kSwu1.injectIntl)(({ flags: flags, nextTryIn: nextTryIn, statusCode: statusCode, flagData: flagData, errorData: errorData, intl: { formatMessage: formatMessage }, lastPublisher: lastPublisher, parentPageId: parentPageId, collabService: collabService, isUnpublishedDraft: isUnpublishedDraft })=>{
    const [{ contentSlug: contentSlug, contentId: contentId, spaceKey: spaceKey, contentType: contentType }] = (0, $ep3mz.usePageState)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { triggerPageConflictAnalytics: triggerPageConflictAnalytics } = (0, $gQojb.usePageConflictAnalytics)({
        contentId: contentId,
        contentType: contentType,
        collabService: collabService,
        source: 'EditorFlags',
        actionSubjectId: 'editor.flag'
    });
    const userInfoQueryResult = (0, $jMyy4.useQueryInterop)((0, $kw3pa.default), {
        variables: {
            accountId: lastPublisher || ''
        },
        // only make this query if the lastPublisher is defined and it is a publish/restore flag
        skip: !lastPublisher || !errorData || !errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).OTHER_PUBLISH] && !errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).OTHER_RESTORE],
        __callerPackage__: "editor-flags"
    });
    // only make this query if the parentPageId is NOT defined and we have an error where we want link to the parent page
    const ancestorQuerySkipped = Boolean(parentPageId) || !contentId || !errorData || !errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).PARENT_NOT_PUBLISHED];
    const ancestorQueryResult = (0, $jMyy4.useQueryInterop)((0, $f2yKj.default), {
        variables: {
            contentId: contentId
        },
        skip: ancestorQuerySkipped,
        __callerPackage__: "editor-flags"
    });
    const [actualParentPageId, setActualParentPageId] = (0, $cozmU.useState)(parentPageId);
    (0, $cozmU.useEffect)(()=>{
        // when done loading, set to the parentId that was found, or "" if not found
        if (!ancestorQuerySkipped && !ancestorQueryResult.loading) setActualParentPageId(ancestorQueryResult.data?.content?.nodes?.[0]?.ancestors?.slice(-1)[0]?.id || parentPageId || '');
    }, [
        parentPageId,
        ancestorQueryResult,
        ancestorQuerySkipped
    ]);
    // Cleanup on component unmount
    (0, $cozmU.useEffect)(()=>()=>void flags.hideAllFlags(), [
        flags
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!(errorData?.[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).OTHER_PUBLISH] || errorData?.[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).OTHER_RESTORE] || errorData?.[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).PARENT_NOT_PUBLISHED] && actualParentPageId === undefined) && !flagData) {
            const flagContent = (0, $cHfGW.buildEditorFlagMessage)({
                errorData: errorData,
                spaceKey: spaceKey,
                statusCode: statusCode,
                formatMessage: formatMessage,
                nextTryIn: nextTryIn,
                parentPageId: actualParentPageId,
                isUnpublishedDraft: isUnpublishedDraft,
                isLivePage: isLivePage
            });
            if (flagContent) {
                const flagId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
                flags.showErrorFlag({
                    id: flagId,
                    title: flagContent.title,
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $03Xmw.FlagDescription), {
                        flags: flags,
                        flagContent: flagContent,
                        flagId: flagId,
                        nextTryIn: nextTryIn
                    })
                });
                if (statusCode === 409) triggerPageConflictAnalytics(Object.keys(errorData ?? {}).filter((k)=>k.startsWith('com.atlassian.confluence.api.service.exceptions.ecosystem.ConflictException')), {});
            } else // If there is no errorData the value of flagProps is null
            // Clear the existing flags
            flags.hideAllFlags();
        }
    }, [
        isUnpublishedDraft,
        flags,
        flagData,
        nextTryIn,
        spaceKey,
        statusCode,
        errorData,
        lastPublisher,
        actualParentPageId,
        contentId,
        formatMessage,
        triggerPageConflictAnalytics,
        isLivePage
    ]);
    const showInfoFlag = (0, $cozmU.useCallback)(()=>{
        const attributes = {
            contentType: contentType,
            spaceKey: spaceKey,
            contentId: contentId,
            contentSlug: contentSlug
        };
        return (0, $fb79u.initializeInfoFlag)(flags, formatMessage, attributes, isLivePage);
    }, // Subscribe returns a new flag object each rerender causing infinite rerendering when displaying a publish flag,
    // so we are excluding it from the dep array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        formatMessage
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (errorData && (errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).OTHER_PUBLISH] || errorData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).OTHER_RESTORE])) showInfoFlag()(userInfoQueryResult, {
            ...errorData
        });
    }, [
        userInfoQueryResult,
        errorData,
        showInfoFlag
    ]);
    const showSuccessFlag = (0, $cozmU.useCallback)(()=>{
        const attributes = {
            contentType: contentType,
            spaceKey: spaceKey,
            contentId: contentId,
            contentSlug: contentSlug
        };
        (0, $6jB9o.initializeSuccessFlag)(flags, formatMessage, {
            attributes: attributes,
            flagData: flagData
        }, createAnalyticsEvent);
    // Subscribe returns a new flag object each rerender causing infinite re-rendering,
    // so we are excluding it from the dep array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        formatMessage
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (flagData) showSuccessFlag();
    }, [
        flagData,
        showSuccessFlag
    ]);
    return ancestorQueryResult?.error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: ancestorQueryResult.error
    }) : null;
});
const $5f7518f04afd0b6f$export$7220a8ff64533d72 = (0, $7aRa9.withFlags)($5f7518f04afd0b6f$export$8f60114e4ef36b27);
module.exports["EditorFlags"] = $5f7518f04afd0b6f$export$8f60114e4ef36b27;
module.exports["EditorErrorFlags"] = $5f7518f04afd0b6f$export$7220a8ff64533d72;

});

parcelRegister("f2yKj", function(module, exports) {
/**
 * @generated SignedSource<<482f7d31f52d97ab2f318d5074e06f74>>
 * @relayHash 143c98ff018aa1ff4230e9a1e86632ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c3139736436d5ee28a33804f3e80416357bad9c4b98c269648f2b81dd964f39a
const $2292f9aa8bd88324$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "current",
                        "draft"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "ancestors",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditorFlagsContentAncestorsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditorFlagsContentAncestorsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "143c98ff018aa1ff4230e9a1e86632ca",
            "id": "c3139736436d5ee28a33804f3e80416357bad9c4b98c269648f2b81dd964f39a",
            "metadata": {},
            "name": "EditorFlagsContentAncestorsQuery",
            "operationKind": "query",
            "text": "query EditorFlagsContentAncestorsQuery($contentId:ID!){content(id:$contentId,status:[\"current\",\"draft\"]){nodes{id,ancestors{id}}}}"
        }
    };
}();
$2292f9aa8bd88324$var$node.hash = "dae699d39d7456c23f9c77a8e35347ba";
var $2292f9aa8bd88324$export$2e2bcd8739ae039 = $2292f9aa8bd88324$var$node;
module.exports["default"] = $2292f9aa8bd88324$export$2e2bcd8739ae039;

});

parcelRegister("kw3pa", function(module, exports) {
/**
 * @generated SignedSource<<711180ccf51b771573a7257f3074d406>>
 * @relayHash 633f8580ff29ac0eef5aabbd01aa2025
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 04b103c3fd8e6dd3187db1fe66459b8fdab4878d85ace24413ec2d1f946efb9f
const $4b4bf52c95a16bda$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }
    ], v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "accountId"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditorFlagsUserPersonalInformationQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditorFlagsUserPersonalInformationQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "633f8580ff29ac0eef5aabbd01aa2025",
            "id": "04b103c3fd8e6dd3187db1fe66459b8fdab4878d85ace24413ec2d1f946efb9f",
            "metadata": {},
            "name": "EditorFlagsUserPersonalInformationQuery",
            "operationKind": "query",
            "text": "query EditorFlagsUserPersonalInformationQuery($accountId:ID!){user:confluence_atlassianUser(id:$accountId){id,displayName}}"
        }
    };
}();
$4b4bf52c95a16bda$var$node.hash = "f3c3315775439f1cc7912f906f070deb";
var $4b4bf52c95a16bda$export$2e2bcd8739ae039 = $4b4bf52c95a16bda$var$node;
module.exports["default"] = $4b4bf52c95a16bda$export$2e2bcd8739ae039;

});

parcelRegister("03Xmw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $7dc210c4acbee9cf$export$bc4f7e1226380dba = ({ flagContent: flagContent, nextTryIn: nextTryIn, flagId: flagId, flags: flags })=>{
    const [secondsLeft, setSecondsLeft] = (0, $cozmU.useState)(nextTryIn ? // We get nextTryIn in ms
    Math.max(Math.round(nextTryIn / 1000), 0) : 0);
    const description = typeof flagContent.description === 'function' ? flagContent.description(secondsLeft) : flagContent.description;
    (0, $cozmU.useEffect)(()=>{
        if (nextTryIn) {
            const flagInterval = setInterval(()=>setSecondsLeft((secondsLeft)=>secondsLeft - 1), 1000);
            return ()=>clearInterval(flagInterval);
        }
    }, [
        nextTryIn
    ]);
    // Clean the flag up if the flag is a count down flag
    // and the countdown reached its end
    if (nextTryIn && secondsLeft < 0) flags.hideFlag(flagId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "flag-description"
    }, description, flagContent.details && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "flag-details"
    }, flagContent.details));
};
module.exports["FlagDescription"] = $7dc210c4acbee9cf$export$bc4f7e1226380dba;

});

parcelRegister("fb79u", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1mHQU = parcelRequire("1mHQU");


var $4iY7F = parcelRequire("4iY7F");

const $e03997dfc3ec06ab$var$i18n = {
    publishTitle: {
        id: 'editor-flags.publish-page.title',
        defaultMessage: 'New version published',
        description: 'Title for flag that appears when a new version of the page is published'
    },
    publishMessage: {
        id: 'editor-flags.publish-page.known.user.message',
        defaultMessage: "{user} just published a new version of this page, which includes the changes you\u2019ve made so far",
        description: 'Message for flag that appears when a new version of the page is published'
    },
    restoreTitle: {
        id: 'editor-flags.restore-page.title',
        defaultMessage: 'Previous version restored',
        description: 'Title for flag that appears when another user restores a previous version of the page'
    },
    restoreOtherMessage: {
        id: 'editor-flags.restore-page.known.user.message',
        defaultMessage: '{user} just restored a prior version of this {contentType}. Recent changes may have been lost. Check the <alink>page history</alink> for details.',
        description: 'Message for flag that apprears when another user restores a previous version of the page'
    },
    unknownUser: {
        id: 'editor-flags.publish-page.known.user.name',
        defaultMessage: 'Another user',
        description: 'Alternate name when the user responsible for publish is not known'
    },
    anonymousUser: {
        id: 'editor-flags.publish-page.anonymous.user.name',
        defaultMessage: 'An anonymous user',
        description: 'Alternate name when anonymous user is responsible for publish'
    },
    reloadButton: {
        id: 'editor-flags.publish-page.actions.reload',
        description: 'Button label for button that causes a page reload',
        defaultMessage: 'Reload'
    }
};
const $e03997dfc3ec06ab$var$reloadPage = ()=>window.location.reload();
const $e03997dfc3ec06ab$var$displayLivePagePublishedFlag = (flags, formatMessage, user)=>{
    flags.showCustomFlag({
        title: formatMessage($e03997dfc3ec06ab$var$i18n.publishTitle),
        description: formatMessage($e03997dfc3ec06ab$var$i18n.publishMessage, {
            user: user
        }),
        actions: [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    "data-testid": "quick-reload-reload-button"
                }, formatMessage($e03997dfc3ec06ab$var$i18n.reloadButton)),
                onClick: $e03997dfc3ec06ab$var$reloadPage
            }
        ]
    });
};
const $e03997dfc3ec06ab$var$getUserMessage = (formatMessage, queryResult)=>{
    let user;
    const displayName = queryResult?.data?.user?.displayName;
    /* There are 3 cases:
       1. error when making query : the other publisher is unknown and therefore default to "Another user"
       2. queryResult?.data?.user?.displayName is falsy but there is no error, the other publisher is anonymous user
       3. The other publisher is authenticated and there's no error in making query
      */ if (queryResult.error) // error when making query, publisher is unknown and therefore
    user = formatMessage($e03997dfc3ec06ab$var$i18n.unknownUser);
    else if (!displayName) // queryResult data is null, publisher is anonymous user
    user = formatMessage($e03997dfc3ec06ab$var$i18n.anonymousUser);
    else user = displayName;
    return user;
};
const $e03997dfc3ec06ab$var$handlePublishFlag = (flags, formatMessage, isLivePage, user)=>{
    if (isLivePage) $e03997dfc3ec06ab$var$displayLivePagePublishedFlag(flags, formatMessage, user);
    else flags.showInfoFlag({
        title: formatMessage($e03997dfc3ec06ab$var$i18n.publishTitle),
        description: formatMessage($e03997dfc3ec06ab$var$i18n.publishMessage, {
            user: user
        })
    });
};
const $e03997dfc3ec06ab$export$147dab68cb862647 = (flags, formatMessage, attributes, isLivePage = false)=>(queryResult, flagData)=>{
        if (!queryResult.loading) {
            const user = $e03997dfc3ec06ab$var$getUserMessage(formatMessage, queryResult);
            if (flagData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).OTHER_PUBLISH]) {
                $e03997dfc3ec06ab$var$handlePublishFlag(flags, formatMessage, isLivePage, user);
                return;
            } else if (flagData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).OTHER_RESTORE]) flags.showInfoFlag({
                title: formatMessage($e03997dfc3ec06ab$var$i18n.restoreTitle),
                description: formatMessage($e03997dfc3ec06ab$var$i18n.restoreOtherMessage, {
                    user: user,
                    alink: (0, $4iY7F.getPageHistoryLink)(attributes),
                    contentType: attributes.contentType ?? 'page'
                })
            });
        }
        return null;
    };
module.exports["initializeInfoFlag"] = $e03997dfc3ec06ab$export$147dab68cb862647;

});

parcelRegister("4iY7F", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $i1t43 = parcelRequire("i1t43");


var $1NBp8 = parcelRequire("1NBp8");

const $35f324be8ccb2751$export$be60689b3b3efd2c = (attributes)=>{
    const { spaceKey: spaceKey, contentId: contentId, contentSlug: contentSlug } = attributes;
    return (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            target: "_blank",
            href: (0, $1NBp8.CONTENT_HISTORY).toUrl({
                spaceKey: spaceKey,
                contentId: contentId,
                contentSlug: contentSlug
            })
        }, chunks);
};
module.exports["getPageHistoryLink"] = $35f324be8ccb2751$export$be60689b3b3efd2c;

});

parcelRegister("6jB9o", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $1NBp8 = parcelRequire("1NBp8");


var $7PLO8 = parcelRequire("7PLO8");


var $1mHQU = parcelRequire("1mHQU");


var $4iY7F = parcelRequire("4iY7F");

const $c31ff9c3561eb614$var$i18n = {
    blogifySuccessTitle: {
        id: 'editor-flags.blogify.blogpost.success.title',
        defaultMessage: 'Page converted to a blog post',
        description: 'The title of the flag shown in the editor when someone convert a page to blogpost'
    },
    blogifySuccessMessage: {
        id: 'editor-flags.blogify.blogpost.success.message',
        defaultMessage: "{displayName} just converted this page to a <alink>blog post</alink>, which includes the changes you\u2019ve made so far.",
        description: 'The body of the flag shown in the editor when someone convert a page to blogpost'
    },
    restoreTitle: {
        id: 'editor-flags.restore-page.title',
        defaultMessage: 'Previous version restored',
        description: 'Title for flag that appears when another user restores a previous version of the page'
    },
    restoreMessage: {
        id: 'editor-flags.restore.page.success.message',
        defaultMessage: 'Recent changes may have been overwritten. Check the <alink>page history</alink> for details.',
        description: 'The body of the flag shown in the editor when someone revert the page/blogpost to previous version in page history'
    },
    extensionCreateTitle: {
        id: 'editor-flags.extension-create.title',
        defaultMessage: 'New draft created',
        description: 'Title for flag that appears when a draft is created by the /create Confluence page extension from another page'
    },
    extensionCreateMessage: {
        id: 'editor-flags.extension-create.message',
        defaultMessage: "There\u2019s now a link to this draft on <alink>{parentPage}</alink>. All of your changes have been saved.",
        description: 'The body of the flag shown in the editor when a draft is created by the /create Confluence page extension from another page'
    },
    extensionCreateParentPage: {
        id: 'editor-flags.extension-create.parent-page',
        defaultMessage: 'the previous page',
        description: 'Placeholder text for {parentPage} in `editor-flags.extension-create.message` when the parent page does not have a title'
    }
};
const $c31ff9c3561eb614$export$63605c1c0febbffe = (flags, formatMessage, { attributes: attributes, flagData: flagData }, createAnalyticsEvent)=>{
    const { contentType: contentType, spaceKey: spaceKey, contentId: contentId } = attributes;
    if (flagData) {
        if (flagData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).RESTORE_CONTENT_SUCCESS]) flags.showFlag({
            type: 'success-circle',
            title: formatMessage($c31ff9c3561eb614$var$i18n.restoreTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...$c31ff9c3561eb614$var$i18n.restoreMessage,
                values: {
                    contentType: contentType,
                    alink: (0, $4iY7F.getPageHistoryLink)(attributes)
                }
            }),
            messageType: 'transactional',
            messageId: 'editor-flags-version-restore-success'
        });
        else if (flagData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).BLOGIFY_BLOGPOST_SUCCESS]) {
            const displayName = flagData?.converterDisplayName;
            flags.showFlag({
                type: 'success-circle',
                title: formatMessage($c31ff9c3561eb614$var$i18n.blogifySuccessTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...$c31ff9c3561eb614$var$i18n.blogifySuccessMessage,
                    values: {
                        displayName: displayName || formatMessage({
                            id: "editor.page.moved.message.unknown.mover"
                        }),
                        alink: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                                target: "_blank",
                                href: (0, $1NBp8.EDIT_BLOG_V2).toUrl({
                                    spaceKey: spaceKey,
                                    contentId: contentId,
                                    contentType: 'blog'
                                }, {
                                    query: {
                                        draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                                    }
                                })
                            }, chunks)
                    }
                }),
                messageType: 'transactional',
                messageId: 'editor-flags-blogify-success'
            });
        } else if (flagData[(0, $1mHQU.ALLOWED_FLAG_MESSAGES).CREATED_FROM_EXTENSION]) {
            const { parentContentId: parentContentId, parentTitle: parentTitle } = flagData;
            const parentUrl = (0, $1NBp8.EDIT_PAGE_V2).toUrl({
                contentType: 'pages',
                spaceKey: spaceKey,
                contentId: parentContentId
            });
            const handleClick = (event)=>{
                event.preventDefault();
                // Open the parent page in the existing tab if it hasn't been closed
                const parentWin = window.open('', parentContentId);
                parentWin?.focus();
                // If tab was closed, navigate new tab to the parent page URL
                if (parentWin && !parentWin.location.host) // eslint-disable-next-line no-restricted-syntax
                parentWin.location.assign(parentUrl);
                if (createAnalyticsEvent) createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'parentPageLink',
                        actionSubjectId: 'inlineCreateOneStepExperiment',
                        source: 'SuccessFlag',
                        attributes: {
                            contentId: contentId,
                            contentType: contentType,
                            parentContentId: parentContentId
                        }
                    }
                }).fire();
            };
            flags.showFlag({
                type: 'success-circle',
                title: formatMessage($c31ff9c3561eb614$var$i18n.extensionCreateTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...$c31ff9c3561eb614$var$i18n.extensionCreateMessage,
                    values: {
                        parentPage: !!parentTitle ? parentTitle : formatMessage($c31ff9c3561eb614$var$i18n.extensionCreateParentPage),
                        alink: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                                href: parentUrl,
                                target: parentContentId,
                                onClick: handleClick
                            }, chunks)
                    }
                }),
                messageType: 'transactional',
                messageId: 'editor-flags-create-from-extension-success'
            });
        }
    }
};
const $c31ff9c3561eb614$export$4db4941fd1416d17 = ()=>{
    // createdFrom parameter means draft was created by the create page extension from another page
    const urlParams = new URLSearchParams(window.location.search);
    const parentContentId = urlParams.get('createdFrom');
    if (parentContentId) {
        // Remove createdFrom param from url without reloading
        urlParams.delete('createdFrom');
        const newParams = urlParams.size > 0 ? `?${urlParams.toString()}` : '';
        window.history.pushState({}, '', `${window.location.pathname}${newParams}`);
        // Show flag if the parentContentId is a number
        // and this was an auto redirect from parent page, i.e. not copy/pasted url
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        if (/^\d+$/.test(parentContentId) && !!document.referrer) return parentContentId;
    }
    return null;
};
module.exports["initializeSuccessFlag"] = $c31ff9c3561eb614$export$63605c1c0febbffe;
module.exports["getParentContentId"] = $c31ff9c3561eb614$export$4db4941fd1416d17;

});

parcelRegister("18vK6", function(module, exports) {

var $6ZtPk = parcelRequire("6ZtPk");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $7zgzO = parcelRequire("7zgzO");


var $1NBp8 = parcelRequire("1NBp8");


var $jMyy4 = parcelRequire("jMyy4");


var $kfIha = parcelRequire("kfIha");


var $1RN2b = parcelRequire("1RN2b");

const $c8a2a643eaa1809a$var$useCopyContentLinkCopyLinkQuery = (0, $6ZtPk.default);
var $c8a2a643eaa1809a$export$61634440d18842d5 = /*#__PURE__*/ function(SUPPORTED_CONTENT_TYPES) {
    SUPPORTED_CONTENT_TYPES["PAGE"] = "page";
    SUPPORTED_CONTENT_TYPES["BLOGPOST"] = "blogpost";
    SUPPORTED_CONTENT_TYPES["OVERVIEW"] = "overview";
    SUPPORTED_CONTENT_TYPES["WHITEBOARD"] = "whiteboard";
    SUPPORTED_CONTENT_TYPES["EMBED"] = "embed";
    SUPPORTED_CONTENT_TYPES["DATABASE"] = "database";
    return SUPPORTED_CONTENT_TYPES;
}({});
const $c8a2a643eaa1809a$export$a049904f049cf16d = ({ pageMode: pageMode, contentType: contentType, contentId: contentId, spaceKey: spaceKey, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [unsupportedLinkError, setUnsupportedLinkError] = (0, $cozmU.useState)();
    const { toUrl: toUrl } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { copyToClipboard: copyToClipboard } = (0, $kfIha.useCopyToClipboard)();
    const { data: data, loading: loading, error: queryError } = (0, $jMyy4.useQueryInterop)($c8a2a643eaa1809a$var$useCopyContentLinkCopyLinkQuery, {
        variables: {
            contentId: contentId
        },
        __callerPackage__: "share-and-restrict-dialog"
    });
    const getCopyContentLink = (0, $cozmU.useCallback)(()=>{
        let copyLink;
        // Try to get the page link from queried data, shortened (for view mode) if possible.
        if (data) {
            const links = data?.singleContent?.links;
            if (pageMode === (0, $1RN2b.PAGE_MODE).EDIT) copyLink = links?.editui;
            else // pageMode === "view" OR no page mode specified, eg for whiteboards
            copyLink = links?.tinyui || links?.webui;
            if (copyLink && links?.base) return `${links.base}${copyLink}`;
        }
        // Fallback behavior: Use content type + page mode to construct URL.
        let routeName, additionalParams;
        if (pageMode === (0, $1RN2b.PAGE_MODE).EDIT) {
            routeName = contentType === "blogpost" ? (0, $1NBp8.EDIT_BLOG_V2).name : (0, $1NBp8.EDIT_PAGE_V2).name;
            additionalParams = {
                contentType: // EDIT_BLOG_V2 and EDIT_PAGE_V2 routes expect particular contentType format during route construction
                contentType === "blogpost" ? 'blog' : 'pages'
            };
        } else switch(contentType){
            case "overview":
                routeName = (0, $1NBp8.SPACE_OVERVIEW).name;
                break;
            case "blogpost":
                routeName = (0, $1NBp8.VIEW_BLOG).name;
                break;
            case "page":
                routeName = (0, $1NBp8.VIEW_PAGE).name;
                break;
            case "whiteboard":
                routeName = (0, $1NBp8.WHITEBOARD_BOARD).name;
                break;
            case "embed":
                routeName = (0, $1NBp8.EMBED_VIEW).name;
                break;
            case "database":
                routeName = (0, $1NBp8.DATABASE_VIEW).name;
                break;
            // omit unsupported content types
            default:
                if (!contentType) // contentType is undefined/empty - this is a data issue, not a
                // truly unsupported type. Return undefined rather than erroring.
                return undefined;
                const error = new Error(`Received an unexpected content type: '${contentType}'`);
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'thrown',
                        actionSubject: 'error',
                        actionSubjectId: (0, $1RN2b.ACTION_SUBJECT_ID),
                        source: source,
                        attributes: {
                            error: error?.message,
                            contentType: contentType,
                            pageMode: pageMode
                        }
                    }
                }).fire();
                setUnsupportedLinkError(error);
        }
        if (routeName) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'copied',
                    actionSubject: 'fallbackLink',
                    actionSubjectId: (0, $1RN2b.ACTION_SUBJECT_ID),
                    source: source,
                    attributes: {
                        queryError: queryError?.message,
                        isDataLoading: loading,
                        route: routeName
                    }
                }
            }).fire();
            // Omit contentSlug, because user perception is that link sharing
            // is more secure without the content title in the URL.
            return `${window.location.origin}${toUrl(routeName, {
                contentId: contentId,
                spaceKey: spaceKey,
                ...additionalParams
            })}`;
        }
        return undefined;
    }, [
        toUrl,
        contentId,
        contentType,
        spaceKey,
        pageMode,
        source,
        data,
        loading,
        queryError,
        createAnalyticsEvent
    ]);
    const copyContentLink = (0, $cozmU.useCallback)(()=>{
        return copyToClipboard(getCopyContentLink());
    }, [
        getCopyContentLink,
        copyToClipboard
    ]);
    return (0, $cozmU.useMemo)(()=>({
            queryError: queryError,
            unsupportedLinkError: unsupportedLinkError,
            getCopyContentLink: getCopyContentLink,
            copyContentLink: copyContentLink
        }), [
        queryError,
        unsupportedLinkError,
        getCopyContentLink,
        copyContentLink
    ]);
};
module.exports["SUPPORTED_CONTENT_TYPES"] = $c8a2a643eaa1809a$export$61634440d18842d5;
module.exports["useCopyContentLink"] = $c8a2a643eaa1809a$export$a049904f049cf16d;

});

parcelRegister("6ZtPk", function(module, exports) {
/**
 * @generated SignedSource<<eb2b56a2caf0d743247e79708ebe7cd0>>
 * @relayHash 18ff4f8d8b4085f53eca6f5430f839ae
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 696a1658ae695a2ccdd29b5b577d0bea392665ecbf8da6a0b6fcc65e73032b59
const $833a147e3ae344d9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "tinyui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "base"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCopyContentLinkCopyLinkQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCopyContentLinkCopyLinkQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "18ff4f8d8b4085f53eca6f5430f839ae",
            "id": "696a1658ae695a2ccdd29b5b577d0bea392665ecbf8da6a0b6fcc65e73032b59",
            "metadata": {},
            "name": "useCopyContentLinkCopyLinkQuery",
            "operationKind": "query",
            "text": "query useCopyContentLinkCopyLinkQuery($contentId:ID!){singleContent(id:$contentId){id,links{editui,webui,tinyui,base}}}"
        }
    };
}();
$833a147e3ae344d9$var$node.hash = "d21c9891b99750e37c7d31e767baec64";
var $833a147e3ae344d9$export$2e2bcd8739ae039 = $833a147e3ae344d9$var$node;
module.exports["default"] = $833a147e3ae344d9$export$2e2bcd8739ae039;

});

parcelRegister("1RN2b", function(module, exports) {
const $d453ec9fb76ba7fd$export$9957974f8b4d8f74 = 'copyShareLink';
var $d453ec9fb76ba7fd$export$e82cf716cce37b4e = /*#__PURE__*/ function(PAGE_MODE) {
    PAGE_MODE["VIEW"] = "view";
    PAGE_MODE["EDIT"] = "edit";
    return PAGE_MODE;
}({});
module.exports["ACTION_SUBJECT_ID"] = $d453ec9fb76ba7fd$export$9957974f8b4d8f74;
module.exports["PAGE_MODE"] = $d453ec9fb76ba7fd$export$e82cf716cce37b4e;

});

parcelRegister("bPoXA", function(module, exports) {
$parcel$export(module.exports, "PAGE_MODE", () => (parcelRequire("1RN2b")).PAGE_MODE);

var $jmjWc = parcelRequire("jmjWc");


var $7VdCF = parcelRequire("7VdCF");


var $1RN2b = parcelRequire("1RN2b");


const $593a9a70400e9fe4$export$9d30156e45c09e81 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "VbFx8",
    name: "CopyLinkButtonLoader",
    loader: async ()=>{
        return (await (parcelRequire("gabHE"))).CopyLink;
    },
    loading: (0, $7VdCF.CopyLinkButtonPlaceholder)
});
module.exports["CopyLinkButtonLoader"] = $593a9a70400e9fe4$export$9d30156e45c09e81;

});

parcelRegister("7VdCF", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kTb7m = parcelRequire("kTb7m");


var $7ZB0A = parcelRequire("7ZB0A");

const $e679cdda51869592$var$i18n = (0, $kSwu1.defineMessages)({
    copyLinkLabel: {
        id: "share-and-restrict-dialog.copylink.icon.label",
        defaultMessage: "Copy link"
    }
});
const $e679cdda51869592$export$1f3200a5b8d4d8e1 = ()=>{
    const $ = (0, $bDgLe.c)(4);
    const intl = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage($e679cdda51869592$var$i18n.copyLinkLabel);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            testId: "copy-link-button-placeholder",
            "data-test-id": "copy-link-button-placeholder",
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
                label: t0,
                spacing: "spacious"
            }),
            isDisabled: true
        });
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["CopyLinkButtonPlaceholder"] = $e679cdda51869592$export$1f3200a5b8d4d8e1;

});

parcelRegister("gabHE", function(module, exports) {

let $bc46a87f75e7c541$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bc46a87f75e7c541$var$load("bYzij"),
    $bc46a87f75e7c541$var$load("9RX5o")
]).then(()=>parcelRequire('eB05M'));

});

parcelRegister("cl74W", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $3izAL = parcelRequire("3izAL");


var $kA6Zo = parcelRequire("kA6Zo");


var $kz1Yj = parcelRequire("kz1Yj");


var $2wCqQ = parcelRequire("2wCqQ");


var $buxP3 = parcelRequire("buxP3");


var $chu6R = parcelRequire("chu6R");


var $l3wuH = parcelRequire("l3wuH");


var $7ZB0A = parcelRequire("7ZB0A");


var $I7hWB = parcelRequire("I7hWB");


var $9DHhW = parcelRequire("9DHhW");


var $hMcNB = parcelRequire("hMcNB");


var $lsxnT = parcelRequire("lsxnT");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $hTxAd = parcelRequire("hTxAd");


var $fiFCv = parcelRequire("fiFCv");


var $5v7QA = parcelRequire("5v7QA");

const $6518ada37406f39b$var$insightMessageStyles = (0, $buxP3.xcss)({
    marginLeft: 'space.300'
});
const $6518ada37406f39b$var$i18n = (0, $kSwu1.defineMessages)({
    successIconLabel: {
        id: "automation-discovery.global-public-link.success.icon.label",
        defaultMessage: "Success check icon"
    },
    modalCloseIconLabel: {
        id: "automation-discovery.global-public-link.modal.close.icon.label",
        defaultMessage: "Close icon for modal"
    }
});
const $6518ada37406f39b$var$BaseAutomationDiscoveryDialogComponent = ({ onClose: onClose, templateUrl: templateUrl, templateName: templateName, spaceKey: spaceKey, header: header, cta: cta, eventSourceName: eventSourceName, localStorageKey: localStorageKey, discoveryExperience: discoveryExperience, customBody: customBody, children: children, templateId: templateId = '', onDismiss: onDismiss = ()=>{}, onRedirectToRuleBuilder: onRedirectToRuleBuilder = ()=>{}, onCreateRuleSuccess: onCreateRuleSuccess = ()=>{}, onRuleCreateStart: onRuleCreateStart, onCreateRuleFail: onCreateRuleFail, disableCreateRule: disableCreateRule, testId: testId, insightMessage: insightMessage })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: discoveryExperience,
                source: eventSourceName
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        eventSourceName,
        discoveryExperience
    ]);
    const handleDismiss = ()=>{
        (0, $hTxAd.markDiscoveryExperienceAsSeen)(localStorageKey);
        onClose();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `${discoveryExperience}Dismiss`,
                source: eventSourceName,
                attributes: {
                    spaceKey: spaceKey
                }
            }
        }).fire();
    };
    const handleProceed = ()=>{
        window.open(templateUrl, '_blank');
        (0, $hTxAd.markDiscoveryExperienceAsSeen)(localStorageKey);
        onClose();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: `${discoveryExperience}Proceed`,
                source: eventSourceName,
                attributes: {
                    spaceKey: spaceKey,
                    template: templateName
                }
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
        width: "small",
        onClose: onClose,
        testId: testId,
        messageType: "transactional"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        justifyContent: "end",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        xcss: (0, $buxP3.xcss)({
            padding: 'space.100',
            paddingRight: 'space.200'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        "aria-label": formatMessage((0, $5v7QA.meetingNotesI18n).modalCloseIconLabel),
        appearance: "link",
        onClick: onClose,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
            label: "",
            color: "var(--ds-text-subtle, #505258)"
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
        label: formatMessage($6518ada37406f39b$var$i18n.successIconLabel),
        color: "var(--ds-icon-success, #6A9A23)",
        spacing: "spacious"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "small"
    }, header)), customBody), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, children ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fiFCv.InContextAutomationPrompt), {
        ruleComponentAlignment: "stack",
        templateId: templateId,
        templateDescription: templateName,
        spaceKey: spaceKey,
        message: cta,
        insightMessage: insightMessage,
        handleRedirectToRuleBuilder: onRedirectToRuleBuilder,
        handleDismiss: onDismiss,
        handleRuleCreationSuccess: onCreateRuleSuccess,
        handleRuleCreationStart: onRuleCreateStart,
        handleRuleCreationFail: onCreateRuleFail,
        checkIsInContextRuleBuilderStateValid: ()=>true,
        automationDiscoveryParent: eventSourceName,
        displayMode: "modal",
        disableCreateRule: disableCreateRule
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        grow: "fill",
        space: "space.150",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        xcss: (0, $buxP3.xcss)({
            padding: 'space.150',
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Requested suppression for existing token string
            backgroundColor: 'color.background.accent.gray.subtlest'
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMcNB))), {
        label: "",
        color: "var(--ds-icon-accent-blue, #357DE8)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, cta)), insightMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $6518ada37406f39b$var$insightMessageStyles
    }, insightMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
        alignBlock: "center",
        space: "space.200",
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "link",
        onClick: handleDismiss,
        spacing: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5v7QA.commonI18n).dismiss)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "link",
        onClick: handleProceed,
        spacing: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5v7QA.commonI18n).showMeHow))))));
};
const $6518ada37406f39b$export$50558003331d128c = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).AUTOMATION_FOR_CONFLUENCE
})($6518ada37406f39b$var$BaseAutomationDiscoveryDialogComponent);
module.exports["BaseAutomationDiscoveryDialog"] = $6518ada37406f39b$export$50558003331d128c;

});

parcelRegister("pUzjH", function(module, exports) {
const $70a693612bc9ad24$export$3475487c10c1ac17 = async (cloudId)=>{
    const siteTraits = await $70a693612bc9ad24$var$fetchSitePersonalization(cloudId);
    const optoutTraitValue = siteTraits.find((trait)=>trait.name === 'optout_all_messages')?.value;
    return typeof optoutTraitValue === 'boolean' && optoutTraitValue;
};
const $70a693612bc9ad24$var$getPersonalizationSiteTraitsUrl = (cloudId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`;
const $70a693612bc9ad24$var$fetchSitePersonalization = async (cloudId)=>{
    const response = await fetch($70a693612bc9ad24$var$getPersonalizationSiteTraitsUrl(cloudId), {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    const { attributes: attributes } = await response.json();
    return attributes;
};
module.exports["isSiteOptedOut"] = $70a693612bc9ad24$export$3475487c10c1ac17;

});

parcelRegister("kdpMy", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $9ec3d7afd2a780b8$export$d4c72bab9d6cc13a = {
    generatedTitle: '',
    trackAIResultViewStored: ()=>{},
    generatedTitleFromPaste: '',
    fireResultAnalyticsFromPaste: ()=>{}
};
const $9ec3d7afd2a780b8$var$NAME = 'GENERATED_TITLE_STORE';
const $9ec3d7afd2a780b8$export$e324594224ef24da = {
    setGeneratedTitle: (newTitle)=>({ setState: setState })=>{
            setState({
                generatedTitle: newTitle
            });
        },
    setTrackAIResultViewStored: (trackAIResultViewHook)=>({ setState: setState })=>{
            setState({
                trackAIResultViewStored: trackAIResultViewHook
            });
        },
    setGeneratedTitleFromPaste: (newTitle)=>({ setState: setState })=>{
            setState({
                generatedTitleFromPaste: newTitle
            });
        },
    setFireResultAnalyticsFromPaste: (fireResultAnalytics)=>({ setState: setState })=>{
            setState({
                fireResultAnalyticsFromPaste: fireResultAnalytics
            });
        },
    clearGeneratedTitleFromPaste: ()=>({ setState: setState })=>{
            setState({
                generatedTitleFromPaste: '',
                fireResultAnalyticsFromPaste: ()=>{}
            });
        }
};
const $9ec3d7afd2a780b8$var$GeneratedTitleStore = (0, $8s9DV.createStore)({
    name: $9ec3d7afd2a780b8$var$NAME,
    initialState: $9ec3d7afd2a780b8$export$d4c72bab9d6cc13a,
    actions: $9ec3d7afd2a780b8$export$e324594224ef24da
});
const $9ec3d7afd2a780b8$export$b824f038e1bda391 = (0, $kBr4q.createHook)($9ec3d7afd2a780b8$var$GeneratedTitleStore);
const $9ec3d7afd2a780b8$export$5d1d441e079eaec3 = (0, $kBr4q.createActionsHook)($9ec3d7afd2a780b8$var$GeneratedTitleStore);
module.exports["useGeneratedTitle"] = $9ec3d7afd2a780b8$export$b824f038e1bda391;
module.exports["useGeneratedTitleActions"] = $9ec3d7afd2a780b8$export$5d1d441e079eaec3;

});

parcelRegister("ajdQJ", function(module, exports) {
class $78166bfa877f38c2$var$SafeString {
    constructor(value){
        this.value = value;
        this.valueOf = this.toString = this.toJSON = ()=>this.value;
    }
}
const $78166bfa877f38c2$export$b91bb42a4e3ff500 = (value)=>new $78166bfa877f38c2$var$SafeString(value);
const $78166bfa877f38c2$export$7d336779073e9481 = (value)=>value instanceof $78166bfa877f38c2$var$SafeString;
const $78166bfa877f38c2$export$2a4aba80518f1883 = (...allowedStrings)=>(value)=>allowedStrings.includes(value) ? Object.freeze(new $78166bfa877f38c2$var$SafeString(value)) : value;
module.exports["dangerouslyCreateSafeString"] = $78166bfa877f38c2$export$b91bb42a4e3ff500;
module.exports["markAsSafe"] = $78166bfa877f38c2$export$2a4aba80518f1883;

});

parcelRegister("1BYn9", function(module, exports) {

var $3TDto = parcelRequire("3TDto");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $fWkVZ = parcelRequire("fWkVZ");


var $jMyy4 = parcelRequire("jMyy4");

const $141bd073c52fec74$export$44f5b9746e66da9 = ()=>{
    const { data: data, error: error, loading: isAdminCheckLoading } = (0, $jMyy4.useQueryInterop)((0, $3TDto.default), {
        __callerPackage__: "current-user"
    });
    if (error) {
        if (!(0, $1uFM6.isUnauthorizedError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    const isProductAdmin = (0, $fWkVZ.getIsProductAdminFromQuery)(data);
    return {
        isProductAdmin: isProductAdmin,
        isAdminCheckLoading: isAdminCheckLoading
    };
};
module.exports["useIsProductAdmin"] = $141bd073c52fec74$export$44f5b9746e66da9;

});

parcelRegister("3TDto", function(module, exports) {
/**
 * @generated SignedSource<<5ad29dfea09a4ca6925d754e625f4e3a>>
 * @relayHash d40e79986defbb74ee71a42460f4e593
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fe516d70b362da33d2c9dc8e98f7d27b5868b10eb9ecfdd545bfad6f07fa6622
const $7c2c3a08c3ad61f2$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        },
        {
            "kind": "ScalarField",
            "name": "isSiteAdmin"
        },
        {
            "kind": "ScalarField",
            "name": "hasUserAccessAdminRole"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useIsProductAdminUseIsProductAdminQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useIsProductAdminUseIsProductAdminQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "d40e79986defbb74ee71a42460f4e593",
            "id": "fe516d70b362da33d2c9dc8e98f7d27b5868b10eb9ecfdd545bfad6f07fa6622",
            "metadata": {},
            "name": "useIsProductAdminUseIsProductAdminQuery",
            "operationKind": "query",
            "text": "query useIsProductAdminUseIsProductAdminQuery{user:confluence_atlassianUser(current:true){id,confluence{operations{operation,targetType}}},isSiteAdmin,hasUserAccessAdminRole}"
        }
    };
}();
$7c2c3a08c3ad61f2$var$node.hash = "179058bf05f0f539ac360b7a899d6923";
var $7c2c3a08c3ad61f2$export$2e2bcd8739ae039 = $7c2c3a08c3ad61f2$var$node;
module.exports["default"] = $7c2c3a08c3ad61f2$export$2e2bcd8739ae039;

});

parcelRegister("letmB", function(module, exports) {

var $6B1vK = parcelRequire("6B1vK");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $8HDoM = parcelRequire("8HDoM");


var $vOJcF = parcelRequire("vOJcF");


var $c0rhi = parcelRequire("c0rhi");

const $a2d59a8e8d049c83$export$c3db30b0866daf5a = 'companyHubAnnouncementBannerId';
const $a2d59a8e8d049c83$export$324fa2b24bd3bd0 = async (contentId, tenantId)=>{
    try {
        // Fetch the announcement banner id from the page properties
        const { data: dataAnnouncementBanner } = await (0, $c0rhi.queryInterop)({
            query: (0, $8HDoM.CompanyHubAnnouncementBannerQuery),
            variables: {
                pageId: (0, $6B1vK.ConfluencePageAri).create({
                    siteId: tenantId,
                    pageId: contentId
                }).toString(),
                keys: [
                    $a2d59a8e8d049c83$export$c3db30b0866daf5a
                ]
            },
            __callerPackage__: "company-hub-utils"
        });
        const bannerId = dataAnnouncementBanner?.confluence?.page?.properties?.[0]?.value;
        if (!bannerId) return {
            bannerId: null
        };
        // If the announcement banner exists check banner status
        const { data: dataAnnouncementBannerStatus } = await (0, $c0rhi.queryInterop)({
            query: (0, $vOJcF.CompanyHubAnnouncementBannerStatusQuery),
            variables: {
                bannerId: bannerId
            },
            __callerPackage__: "company-hub-utils"
        });
        return {
            bannerId: bannerId,
            bannerStatus: dataAnnouncementBannerStatus?.adminAnnouncementBannerSetting?.status
        };
    } catch (error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return {
            bannerId: null
        };
    }
};
module.exports["COMPANY_HUB_ANNOUNCEMENT_BANNER_CONTENT_PROPERTY_KEY"] = $a2d59a8e8d049c83$export$c3db30b0866daf5a;
module.exports["getCompanyHubAnnouncementBanner"] = $a2d59a8e8d049c83$export$324fa2b24bd3bd0;

});

parcelRegister("8HDoM", function(module, exports) {

var $1zTRY = parcelRequire("1zTRY");

const $b548b68664ebb0d0$export$89196b32c22f357e = (0, $1zTRY.default);
module.exports["CompanyHubAnnouncementBannerQuery"] = $b548b68664ebb0d0$export$89196b32c22f357e;

});

parcelRegister("1zTRY", function(module, exports) {
/**
 * @generated SignedSource<<fd2c74a905d02f0e86feafc916682635>>
 * @relayHash d5bf5df01eff840f9b29492824ebb770
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f2dbcd4c020f3063655a22a146ec1e45596f5206fe356d3370930377f841e1ab
const $6e08b27e27741697$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "keys"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "concreteType": "ConfluenceQueryApi",
            "kind": "LinkedField",
            "name": "confluence",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "pageId"
                        }
                    ],
                    "concreteType": "ConfluencePage",
                    "kind": "LinkedField",
                    "name": "page",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "keys",
                                    "variableName": "keys"
                                }
                            ],
                            "concreteType": "ConfluencePageProperty",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                },
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CompanyHubAnnouncementBannerQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CompanyHubAnnouncementBannerQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "d5bf5df01eff840f9b29492824ebb770",
            "id": "f2dbcd4c020f3063655a22a146ec1e45596f5206fe356d3370930377f841e1ab",
            "metadata": {},
            "name": "CompanyHubAnnouncementBannerQuery",
            "operationKind": "query",
            "text": "query CompanyHubAnnouncementBannerQuery($pageId:ID!,$keys:[String]!){confluence{page(id:$pageId){id,properties(keys:$keys){key,value,id}}}}"
        }
    };
}();
$6e08b27e27741697$var$node.hash = "fbfc6dce8692747276f81029c894fe08";
var $6e08b27e27741697$export$2e2bcd8739ae039 = $6e08b27e27741697$var$node;
module.exports["default"] = $6e08b27e27741697$export$2e2bcd8739ae039;

});

parcelRegister("vOJcF", function(module, exports) {

var $dXZhO = parcelRequire("dXZhO");

const $bee353d845b65bc1$export$b7c5a946c2c575d = (0, $dXZhO.default);
module.exports["CompanyHubAnnouncementBannerStatusQuery"] = $bee353d845b65bc1$export$b7c5a946c2c575d;

});

parcelRegister("dXZhO", function(module, exports) {
/**
 * @generated SignedSource<<71556551300658107cf27666a4fc441f>>
 * @relayHash 63ebc26c4e8f00afe8b0ef90b6f20478
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 517e7bc0b657d6a5cbc2554de9f2e62ee6b8f153890e617c5b562206f56ba7c1
const $a96221200ab74212$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "bannerId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "bannerId"
                }
            ],
            "concreteType": "ConfluenceAdminAnnouncementBannerSetting",
            "kind": "LinkedField",
            "name": "adminAnnouncementBannerSetting",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "status"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CompanyHubAnnouncementBannerStatusQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CompanyHubAnnouncementBannerStatusQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "63ebc26c4e8f00afe8b0ef90b6f20478",
            "id": "517e7bc0b657d6a5cbc2554de9f2e62ee6b8f153890e617c5b562206f56ba7c1",
            "metadata": {},
            "name": "CompanyHubAnnouncementBannerStatusQuery",
            "operationKind": "query",
            "text": "query CompanyHubAnnouncementBannerStatusQuery($bannerId:String!){adminAnnouncementBannerSetting(id:$bannerId){id,status}}"
        }
    };
}();
$a96221200ab74212$var$node.hash = "0729b964654c5bed0f702b89156648b8";
var $a96221200ab74212$export$2e2bcd8739ae039 = $a96221200ab74212$var$node;
module.exports["default"] = $a96221200ab74212$export$2e2bcd8739ae039;

});

parcelRegister("k7Jwr", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $0714d46e5830d709$export$99fe151f78e1a08f = /*#__PURE__*/ function(GraphQLFrontCoverState) {
    GraphQLFrontCoverState["HIDDEN"] = "HIDDEN";
    GraphQLFrontCoverState["SHOWN"] = "SHOWN";
    GraphQLFrontCoverState["UNSET"] = "UNSET";
    return GraphQLFrontCoverState;
}({});
module.exports["GraphQLFrontCoverState"] = $0714d46e5830d709$export$99fe151f78e1a08f;

});

parcelRegister("5wLVq", function(module, exports) {

var $dYrYQ = parcelRequire("dYrYQ");


var $k7Jwr = parcelRequire("k7Jwr");


var $8DBCv = parcelRequire("8DBCv");


var $308Wd = parcelRequire("308Wd");


var $fEmGS = parcelRequire("fEmGS");

const $14b7107f244f2fb8$export$eb7670413c83c3d4 = ()=>{
    const [updateSiteLookAndFeel, { data: data, loading: loading, error: error }] = (0, $308Wd.useMutationInterop)((0, $dYrYQ.default), {
        update: (_cache, { data: data })=>{
            (0, $fEmGS.writeQueryInterop)({
                query: (0, $8DBCv.default),
                data: {
                    siteSettings: {
                        // Codegen is specifically configured to not add __typename when generating the types file,
                        // so unfortunately ts-ignore is required here.
                        // @ts-ignore
                        __typename: 'SiteSettings',
                        frontCover: {
                            // Codegen is specifically configured to not add __typename when generating the types file,
                            // so unfortunately ts-ignore is required here.
                            // @ts-ignore
                            __typename: 'FrontCover',
                            frontCoverState: data?.updateSiteLookAndFeel?.siteLookAndFeel?.frontCoverState
                        }
                    }
                },
                __callerPackage__: "company-hub-utils"
            });
        },
        __callerPackage__: "company-hub-utils"
    });
    const changeHubPublishState = (frontCoverState)=>updateSiteLookAndFeel({
            variables: {
                input: {
                    faviconFiles: [],
                    frontCoverState: frontCoverState,
                    showFrontCover: frontCoverState === (0, $k7Jwr.GraphQLFrontCoverState).SHOWN
                }
            }
        });
    return {
        data: data,
        loading: loading,
        error: error,
        changeHubPublishState: changeHubPublishState
    };
};
module.exports["useChangeCompanyHubPublishState"] = $14b7107f244f2fb8$export$eb7670413c83c3d4;

});

parcelRegister("dYrYQ", function(module, exports) {
/**
 * @generated SignedSource<<78b9846f4532bec84d4ecf499dce57cc>>
 * @relayHash a2b4f79ba8694b8a2d5afbaf9da0fcb0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4f0dfbbfc5c4fa6e0daaf56d8218ccb97b40043f636316a0df8b893f60d7ec2a
const $60288b3398c0f5d0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "concreteType": "SiteLookAndFeel",
        "kind": "LinkedField",
        "name": "siteLookAndFeel",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "frontCoverState"
            }
        ]
    }, v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useChangeCompanyHubPublishStateChangeHubPublishStateMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "UpdateSiteLookAndFeelPayload",
                    "kind": "LinkedField",
                    "name": "updateSiteLookAndFeel",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useChangeCompanyHubPublishStateChangeHubPublishStateMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "UpdateSiteLookAndFeelPayload",
                    "kind": "LinkedField",
                    "name": "updateSiteLookAndFeel",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "a2b4f79ba8694b8a2d5afbaf9da0fcb0",
            "id": "4f0dfbbfc5c4fa6e0daaf56d8218ccb97b40043f636316a0df8b893f60d7ec2a",
            "metadata": {},
            "name": "useChangeCompanyHubPublishStateChangeHubPublishStateMutation",
            "operationKind": "mutation",
            "text": "mutation useChangeCompanyHubPublishStateChangeHubPublishStateMutation($input:UpdateSiteLookAndFeelInput!){updateSiteLookAndFeel(input:$input){siteLookAndFeel{frontCoverState},success,errors{message,extensions{__typename,errorType,statusCode,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$60288b3398c0f5d0$var$node.hash = "5001b4614b3c544c07ab66e207d7fc69";
var $60288b3398c0f5d0$export$2e2bcd8739ae039 = $60288b3398c0f5d0$var$node;
module.exports["default"] = $60288b3398c0f5d0$export$2e2bcd8739ae039;

});

parcelRegister("8DBCv", function(module, exports) {
/**
 * @generated SignedSource<<807c6e8dd961dae500f9ddaee8d316b9>>
 * @relayHash cf3a11251bae2782447696e602cbd833
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c8c8215334c6aaae5ba752034e6f1f94c2510353995460bd924dc0af55a18cb5
const $01986b5e53f5d2cf$var$node = function() {
    var v0 = [
        {
            "concreteType": "SiteSettings",
            "kind": "LinkedField",
            "name": "siteSettings",
            "plural": false,
            "selections": [
                {
                    "concreteType": "FrontCover",
                    "kind": "LinkedField",
                    "name": "frontCover",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "frontCoverState"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "ChangeHubPublishStateWriteQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "ChangeHubPublishStateWriteQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "cf3a11251bae2782447696e602cbd833",
            "id": "c8c8215334c6aaae5ba752034e6f1f94c2510353995460bd924dc0af55a18cb5",
            "metadata": {},
            "name": "ChangeHubPublishStateWriteQuery",
            "operationKind": "query",
            "text": "query ChangeHubPublishStateWriteQuery{siteSettings{frontCover{frontCoverState}}}"
        }
    };
}();
$01986b5e53f5d2cf$var$node.hash = "c5edd80e44855ef2031199e9bcac6386";
var $01986b5e53f5d2cf$export$2e2bcd8739ae039 = $01986b5e53f5d2cf$var$node;
module.exports["default"] = $01986b5e53f5d2cf$export$2e2bcd8739ae039;

});

parcelRegister("6MSEP", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $9387550ed869acb8$export$4242cfff65d64b16 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "M3-19",
    name: "RestrictedPage",
    loader: async ()=>(await (parcelRequire("gkx9L"))).RestrictedPage
});
module.exports["RestrictedPage"] = $9387550ed869acb8$export$4242cfff65d64b16;

});

parcelRegister("gkx9L", function(module, exports) {

let $be383bcc95155596$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $be383bcc95155596$var$load("6wr18"),
    $be383bcc95155596$var$load("ffEVr"),
    $be383bcc95155596$var$load("daX4F"),
    $be383bcc95155596$var$load("7EorR"),
    $be383bcc95155596$var$load("hhss7"),
    $be383bcc95155596$var$load("2OcM6"),
    $be383bcc95155596$var$load("kUiwW")
]).then(()=>parcelRequire('3kPYw'));

});

parcelRegister("5MyXJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $bQm3c = parcelRequire("bQm3c");


var $3jwuS = parcelRequire("3jwuS");


var $1xpoY = parcelRequire("1xpoY");


var $9wGTI = parcelRequire("9wGTI");


var $8MyKT = parcelRequire("8MyKT");


var $jKP0k = parcelRequire("jKP0k");


var $loOZe = parcelRequire("loOZe");


var $9y3bP = parcelRequire("9y3bP");

/* Editor heartbeat defaults to every 60 seconds. */ const $2350038afb2a4a3e$var$DEFAULT_HEARTBEAT_TIMER_INTERVAL = 60000;
const $2350038afb2a4a3e$var$MIN_HEARTBEAT_TIMER_INTERVAL = $2350038afb2a4a3e$var$DEFAULT_HEARTBEAT_TIMER_INTERVAL;
/* Editor heartbeat is capped at 5 minutes. */ const $2350038afb2a4a3e$var$MAX_HEARTBEAT_TIMER_INTERVAL = 300000;
const $2350038afb2a4a3e$var$EDITOR_HEARTBEAT_INTERVAL_MS = 'confluence_editor_heartbeat_interval_ms';
const $2350038afb2a4a3e$var$EDITOR_NCS_MAX_PARTICIPANTS = 'confluence_frontend_collab_ncs_max_participants';
const $2350038afb2a4a3e$var$LIVE_PAGES_LIMITS = 'confluence_frontend_collab_live_pages_limits';
const $2350038afb2a4a3e$var$COLLAB_SERVICE = 'ncs'; // this hook is only used for NCS editor
const $2350038afb2a4a3e$var$DEFAULT_MAX_EDIT_PARTICIPANTS = 12;
const $2350038afb2a4a3e$var$getHeartbeatTimerInterval = ()=>{
    if (!(0, $9wGTI.fg)('confluence_editor_use_custom_heartbeat_interval')) return $2350038afb2a4a3e$var$DEFAULT_HEARTBEAT_TIMER_INTERVAL;
    const configuredInterval = (0, $1xpoY.default).getNumber($2350038afb2a4a3e$var$EDITOR_HEARTBEAT_INTERVAL_MS, $2350038afb2a4a3e$var$DEFAULT_HEARTBEAT_TIMER_INTERVAL);
    if (!Number.isFinite(configuredInterval) || configuredInterval < $2350038afb2a4a3e$var$MIN_HEARTBEAT_TIMER_INTERVAL || configuredInterval > $2350038afb2a4a3e$var$MAX_HEARTBEAT_TIMER_INTERVAL) return $2350038afb2a4a3e$var$DEFAULT_HEARTBEAT_TIMER_INTERVAL;
    return configuredInterval;
};
class $2350038afb2a4a3e$export$17a91496024ff2c1 extends Error {
    constructor(message, reason){
        super(message), this.message = message, this.reason = reason;
        this.reason = reason;
    }
}
const $2350038afb2a4a3e$export$e11674744930cd15 = (heartbeatError)=>{
    return heartbeatError?.reason === 'unauthorised' || heartbeatError?.reason === 'UNAUTHORIZED';
};
const $2350038afb2a4a3e$export$af429709ba6838d6 = ({ contentId: contentId, contentType: contentType, collabEditInitialized: collabEditInitialized, viewMode: viewMode })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const heartbeatTimerId = (0, $cozmU.useRef)(null);
    const editorSessionIdRef = (0, $cozmU.useRef)(null);
    const [subtypeMismatch, setSubtypeMismatch] = (0, $cozmU.useState)(false);
    const [heartbeatSubtype, setHeartbeatSubtype] = (0, $cozmU.useState)(undefined);
    // If view mode changes, trigger new heartbeat request with new "user type", before enforcing any limits or returning errors
    const prevViewModeRef = (0, $cozmU.useRef)(viewMode !== undefined ? viewMode : null);
    const isResettingHeartbeat = (0, $cozmU.useRef)(false);
    // keep track of list of users from heartbeat response, which are ordered by time that they joined the collaborative session
    const [orderedActiveUsers, setOrderedActiveUsers] = (0, $cozmU.useState)(null);
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // used for regular pages
    const [collabLimitReached, setCollabLimitReached] = (0, $cozmU.useState)(false);
    // used for live pages
    const [liveEditLimitReached, setLiveEditLimitReached] = (0, $cozmU.useState)(false);
    const [liveViewLimitReached, setLiveViewLimitReached] = (0, $cozmU.useState)(false);
    const [heartbeatError, setHeartbeatError] = (0, $cozmU.useState)();
    let maxEditParticipants = (0, $1xpoY.default).getNumber($2350038afb2a4a3e$var$EDITOR_NCS_MAX_PARTICIPANTS, $2350038afb2a4a3e$var$DEFAULT_MAX_EDIT_PARTICIPANTS);
    const livePagesLimitConfig = (0, $1xpoY.default).getString($2350038afb2a4a3e$var$LIVE_PAGES_LIMITS, '');
    const { viewLimit: livePageViewLimit, editLimit: livePageEditLimit } = (0, $cozmU.useMemo)(()=>{
        const defaultLimits = {
            editLimit: $2350038afb2a4a3e$var$DEFAULT_MAX_EDIT_PARTICIPANTS,
            viewLimit: 100
        };
        if (typeof livePagesLimitConfig === 'string') try {
            const limitObject = JSON.parse(livePagesLimitConfig);
            if (!('viewLimit' in limitObject) || !('editLimit' in limitObject)) return defaultLimits;
            return limitObject;
        } catch  {
        // ignore and fallback to default
        }
        return defaultLimits;
    }, [
        livePagesLimitConfig
    ]);
    if (isLivePage) maxEditParticipants = livePageEditLimit;
    const [startHeartbeat] = (0, $loOZe.useExperimentalEditorStartHeartbeatMutation)({
        variables: {
            contentId: contentId,
            contentType: contentType,
            collabService: $2350038afb2a4a3e$var$COLLAB_SERVICE,
            heartbeatUserType: viewMode ? (0, $8MyKT.ExperimentalHeartbeatUserType).VIEW : (0, $8MyKT.ExperimentalHeartbeatUserType).EDIT
        }
    });
    const [stopHeartbeat] = (0, $9y3bP.useExperimentalEditorStopHeartbeatMutation)({
        variables: {
            contentId: contentId,
            contentType: contentType,
            heartbeatUserType: viewMode ? (0, $jKP0k.ExperimentalHeartbeatUserType).VIEW : (0, $jKP0k.ExperimentalHeartbeatUserType).EDIT
        }
    });
    const handleError = (0, $cozmU.useCallback)((error, data)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'error',
                actionSubject: 'heartbeat',
                source: 'useEditorHeartbeat',
                objectId: contentId,
                objectType: contentType,
                attributes: {
                    error: {
                        reason: error instanceof $2350038afb2a4a3e$export$17a91496024ff2c1 ? error.reason : 'Error',
                        message: error.message
                    },
                    activeUsersSize: data?.experimentalEditorStartHeartbeat?.orderedUsers?.length
                }
            }
        }).fire();
        setHeartbeatError(error);
    }, [
        contentId,
        contentType,
        createAnalyticsEvent
    ]);
    const stopHeartbeatCallback = (0, $cozmU.useCallback)(()=>{
        if (heartbeatTimerId?.current) clearInterval(heartbeatTimerId.current);
        stopHeartbeat().catch((error)=>{
            handleError(error);
        });
    }, [
        stopHeartbeat,
        handleError
    ]);
    const handleHeartbeatSubtypeMismatch = (0, $cozmU.useCallback)((subtype)=>{
        setHeartbeatSubtype(subtype);
        // Detect if page type (live/classic page) differs between frontend and backend
        // This can happen when a page is converted but the user hasn't received the event
        // We disable the editor in NCS to prevent potential data loss in this state
        const hasSubtypeMismatch = isLivePage && subtype !== 'live' || // Live doc with a different subtype
        !isLivePage && subtype !== null; // Non-live doc with any subtype
        setSubtypeMismatch(hasSubtypeMismatch);
    }, [
        isLivePage,
        setHeartbeatSubtype,
        setSubtypeMismatch
    ]);
    const startHeartbeatCallback = (0, $cozmU.useCallback)(()=>{
        startHeartbeat().then((result)=>{
            const { data: data } = result;
            if (isResettingHeartbeat.current) isResettingHeartbeat.current = false;
            if (!data || !data.experimentalEditorStartHeartbeat) {
                handleError(new $2350038afb2a4a3e$export$17a91496024ff2c1('Missing response data', !data ? 'No data' : 'No heartbeat data'));
                return;
            }
            const { error: error, message: message, orderedUsers: orderedUsers, editorSessionId: editorSessionId, subtype: subtype } = data.experimentalEditorStartHeartbeat;
            editorSessionIdRef.current = editorSessionId;
            if ((0, $9wGTI.fg)('confluence_ncs_disconnect_idle_tabs_pubsub')) handleHeartbeatSubtypeMismatch(subtype);
            if (error) {
                const heartbeatError = new $2350038afb2a4a3e$export$17a91496024ff2c1(message ?? 'Heartbeat failed', error);
                if (isLivePage && $2350038afb2a4a3e$export$e11674744930cd15(heartbeatError)) // heartbeat permission check is a redundant extra check on top of NCS permission enforcement
                // for live pages:
                //    there is a race condition where heartbeat is sent with outdated user type
                //    we ignore the permission error and re-send the heartbeat with the correct user type
                return;
                handleError(heartbeatError, data);
            }
            if (!!orderedUsers) setOrderedActiveUsers(orderedUsers);
        }).catch((error)=>{
            handleError(error);
        });
    }, [
        startHeartbeat,
        handleError,
        isLivePage,
        handleHeartbeatSubtypeMismatch
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!orderedActiveUsers || isResettingHeartbeat.current) return;
        const isCurrentUserOverLimit = ({ activeUsers: activeUsers, limit: limit })=>{
            // If there are less active users than the limit, the user is not over the limit
            if (activeUsers.length < limit) return false;
            const isUserAnActiveUser = userId ? activeUsers.slice(0, limit).includes(userId) : false;
            return(// heartbeat backend doesn't handle anonymous users, they will be locked out regardless of order that they joined (i.e. we just use activeUsers size number comparison for anonymous users)
            // otherwise, only the first N users should be able to continue editing
            !userId && activeUsers.length > limit || !!userId && !isUserAnActiveUser);
        };
        const editUsers = orderedActiveUsers.filter((user)=>user.heartbeatUserType === (0, $8MyKT.ExperimentalHeartbeatUserType).EDIT).map((user)=>user.accountId) ?? [];
        const isEditLimitExceeded = isCurrentUserOverLimit({
            activeUsers: editUsers,
            limit: maxEditParticipants
        });
        if (!isLivePage) {
            setCollabLimitReached(isEditLimitExceeded);
            return;
        }
        // include edit->view fallback users, based on queue order
        const allowedEditUsers = editUsers.slice(0, maxEditParticipants);
        const viewUsers = orderedActiveUsers.filter((user)=>!allowedEditUsers.includes(user.accountId)).map((user)=>user.accountId) ?? [];
        const isViewLimitExceeded = isCurrentUserOverLimit({
            activeUsers: viewUsers,
            limit: livePageViewLimit
        });
        if (isEditLimitExceeded && !(prevViewModeRef.current || isViewLimitExceeded)) setLiveEditLimitReached(true);
        else setLiveEditLimitReached(false);
        if (isViewLimitExceeded && (prevViewModeRef.current || isEditLimitExceeded)) setLiveViewLimitReached(true);
        else setLiveViewLimitReached(false);
    }, [
        orderedActiveUsers,
        maxEditParticipants,
        userId,
        isLivePage,
        livePageViewLimit
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (viewMode !== undefined && viewMode !== prevViewModeRef.current) {
            // view mode has changed, refetch heartbeat with new user type
            isResettingHeartbeat.current = true;
            startHeartbeatCallback();
            prevViewModeRef.current = viewMode;
        }
    }, [
        viewMode,
        startHeartbeatCallback
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (collabEditInitialized) {
            startHeartbeatCallback();
            heartbeatTimerId.current = setInterval(startHeartbeatCallback, $2350038afb2a4a3e$var$getHeartbeatTimerInterval());
            return ()=>stopHeartbeatCallback();
        }
    // prevent re-triggering start/stop when heartbeat type changes (i.e. when mutation callback changes)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collabEditInitialized,
        contentId,
        // only re-trigger heartbeat on specific mutation variables, not viewMode
        contentType
    ]);
    return {
        collabLimitReached: // regular edit pages
        collabLimitReached,
        liveEditLimitReached: // live pages specific
        liveEditLimitReached,
        liveViewLimitReached: liveViewLimitReached,
        heartbeatError: // shared data
        heartbeatError,
        stopHeartbeatCallback: stopHeartbeatCallback,
        editorSessionId: editorSessionIdRef.current,
        subtypeMismatch: subtypeMismatch,
        heartbeatSubtype: heartbeatSubtype
    };
};
module.exports["isPermissionError"] = $2350038afb2a4a3e$export$e11674744930cd15;
module.exports["useEditorHeartbeat"] = $2350038afb2a4a3e$export$af429709ba6838d6;

});

parcelRegister("8MyKT", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $d61f6181e4c7da5b$export$5d0e43ccb00ec46a = /*#__PURE__*/ function(ExperimentalHeartbeatUserType) {
    ExperimentalHeartbeatUserType["EDIT"] = "EDIT";
    ExperimentalHeartbeatUserType["VIEW"] = "VIEW";
    return ExperimentalHeartbeatUserType;
}({});
module.exports["ExperimentalHeartbeatUserType"] = $d61f6181e4c7da5b$export$5d0e43ccb00ec46a;

});

parcelRegister("jKP0k", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $89185ab988181834$export$5d0e43ccb00ec46a = /*#__PURE__*/ function(ExperimentalHeartbeatUserType) {
    ExperimentalHeartbeatUserType["EDIT"] = "EDIT";
    ExperimentalHeartbeatUserType["VIEW"] = "VIEW";
    return ExperimentalHeartbeatUserType;
}({});
module.exports["ExperimentalHeartbeatUserType"] = $89185ab988181834$export$5d0e43ccb00ec46a;

});

parcelRegister("loOZe", function(module, exports) {

var $9o40q = parcelRequire("9o40q");


var $aBfpe = parcelRequire("aBfpe");


var $hBkCm = parcelRequire("hBkCm");

const $d7e083384eee425a$var$TENANT_SUSPENDED_RESPONSE = 'Site temporarily unavailable';
const $d7e083384eee425a$export$458b4e9b72fe370e = ({ variables: variables })=>{
    return (0, $9o40q.useExperimentalMutation)({
        url: '/wiki/api/v2/editor/heartbeat/start',
        method: 'POST',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON,
            Accept: (0, $aBfpe.MediaType).JSON
        },
        variables: variables,
        body: ({ contentId: contentId, contentType: contentType, collabService: collabService, heartbeatUserType: heartbeatUserType })=>JSON.stringify({
                dataType: 'json',
                contentId: contentId,
                draftType: contentType ?? '',
                collabService: collabService,
                // confluence-frontend only sends heartbeat for Fabric editor, legacy editor heartbeat code is in confluence web resource.
                // heartbeat response is different for each editor version; only fabric heartbeat response in handled in this experimental mutation
                editorVersion: 'v2',
                heartbeatUserType: heartbeatUserType
            }),
        parseResponseOnError: async (fetchError)=>{
            // this catches unhandled server errors (e.g. internal server error)
            let error;
            let message;
            if (fetchError instanceof (0, $hBkCm.BadStatusError)) try {
                // try to parse original error message
                const errorMessageJson = await fetchError.response.json();
                if (errorMessageJson?.errorMessage === $d7e083384eee425a$var$TENANT_SUSPENDED_RESPONSE) {
                    // error from atlassian-proxy during region migration
                    error = 'tenant-unavailable';
                    message = 'Site temporarily unavailable';
                } else {
                    // Parse heartbeat REST error response
                    error = errorMessageJson?.errors[0].code;
                    message = errorMessageJson?.errors[0].title;
                }
            } catch  {
                error = fetchError.response.statusText;
                message = fetchError.message;
            }
            else {
                error = fetchError.name;
                message = fetchError.message;
            }
            return {
                orderedUsers: null,
                editorSessionId: null,
                error: error,
                message: message,
                subtype: null
            };
        },
        parseResult: ({ orderedUsers: orderedUsers, editorSessionId: editorSessionId, subtype: subtype, error: error, message: message })=>{
            return {
                experimentalEditorStartHeartbeat: {
                    orderedUsers: orderedUsers,
                    editorSessionId: editorSessionId,
                    error: error,
                    message: message,
                    subtype: subtype
                }
            };
        }
    });
};
module.exports["useExperimentalEditorStartHeartbeatMutation"] = $d7e083384eee425a$export$458b4e9b72fe370e;

});

parcelRegister("9y3bP", function(module, exports) {

var $aBfpe = parcelRequire("aBfpe");


var $9o40q = parcelRequire("9o40q");

const $bd279094f7d7a508$export$d3610256bfeae95f = ({ variables: variables })=>{
    return (0, $9o40q.useExperimentalMutation)({
        url: '/wiki/api/v2/editor/heartbeat/stop',
        method: 'POST',
        variables: variables,
        headers: {
            Accept: (0, $aBfpe.MediaType).JSON,
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        body: ({ contentId: contentId, contentType: contentType, heartbeatUserType: heartbeatUserType })=>JSON.stringify({
                dataType: 'json',
                contentId: contentId,
                draftType: contentType ?? '',
                heartbeatUserType: heartbeatUserType
            }),
        parseResponseOnError: ()=>{
            return false;
        },
        parseResult: (response)=>{
            return {
                experimentalEditorStopHeartbeat: Boolean(response)
            };
        }
    });
};
module.exports["useExperimentalEditorStopHeartbeatMutation"] = $bd279094f7d7a508$export$d3610256bfeae95f;

});

parcelRegister("iVU5h", function(module, exports) {
const $6269d9b82324487a$export$42ca032027818031 = ()=>{
    return new URLSearchParams(window.location.search).get('amn-referral-source') || '';
};
module.exports["getAMNReferralSourceFromQueryParam"] = $6269d9b82324487a$export$42ca032027818031;

});

parcelRegister("c411D", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $351b756af5d314b8$export$6654a9a4dc3a2802 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $351b756af5d314b8$var$_temp;
} : ()=>{
    return (0, $cozmU.useCallback)((payload, type)=>{
        window.parent.postMessage({
            type: type,
            payload: payload
        }, '*');
    }, []);
};
function $351b756af5d314b8$var$_temp(payload, type) {
    window.parent.postMessage({
        type: type,
        payload: payload
    }, "*");
}
module.exports["useEmbeddedConfluenceEventMarkers"] = $351b756af5d314b8$export$6654a9a4dc3a2802;

});

parcelRegister("5q601", function(module, exports) {
const $23ec6b91fddb9839$export$190611e0edbb22d5 = 'viewEditButtonClicked';
const $23ec6b91fddb9839$export$ed5bb54d3f9e4a8e = 'editButtonClickedToEditRouteChange';
const $23ec6b91fddb9839$export$caabe0b707a0bfac = 'editRouteChangeToPageLoad';
const $23ec6b91fddb9839$export$a5b3479b02282e8c = 'tinySynchronyPluginsLoad';
const $23ec6b91fddb9839$export$1787f4f7916eb601 = 'tinySynchronyContentFetch';
const $23ec6b91fddb9839$export$99c2e20685f1cd4e = 'editIntentToEditPageTTI';
const $23ec6b91fddb9839$export$e04cfb21f00b2ad0 = 'editIntentToEditPageFMP';
const $23ec6b91fddb9839$export$1d8f87e0ed24898e = 'editEmbeddedPageTTI';
const $23ec6b91fddb9839$export$16bdef2ba2fa4a5 = 'editEmbeddedPageFMP';
const $23ec6b91fddb9839$export$4d09a02f749e3cc2 = 'routeChangeToEditorTTI';
const $23ec6b91fddb9839$export$c2bda34fe2c26f89 = 'tinySynchronyContentMetadaPreload';
module.exports["VIEW_EDIT_BUTTON_CLICKED_ACTION"] = $23ec6b91fddb9839$export$190611e0edbb22d5;
module.exports["EDIT_ROUTE_CHANGE_ACTION"] = $23ec6b91fddb9839$export$ed5bb54d3f9e4a8e;
module.exports["EDIT_ROUTE_CHANGE_TO_FMP_ACTION"] = $23ec6b91fddb9839$export$caabe0b707a0bfac;
module.exports["TINY_SYNCHRONY_PLUGINS_LOAD_ACTION"] = $23ec6b91fddb9839$export$a5b3479b02282e8c;
module.exports["TINY_SYNCHRONY_CONTENT_FETCH_ACTION"] = $23ec6b91fddb9839$export$1787f4f7916eb601;
module.exports["EDIT_INTENT_EDIT_TTI_ACTION"] = $23ec6b91fddb9839$export$99c2e20685f1cd4e;
module.exports["EDIT_INTENT_EDIT_FMP_ACTION"] = $23ec6b91fddb9839$export$e04cfb21f00b2ad0;
module.exports["EMBEDDED_EDIT_TTI_ACTION"] = $23ec6b91fddb9839$export$1d8f87e0ed24898e;
module.exports["EMBEDDED_EDIT_FMP_ACTION"] = $23ec6b91fddb9839$export$16bdef2ba2fa4a5;
module.exports["EDIT_ROUTE_CHANGE_TO_TTI_ACTION"] = $23ec6b91fddb9839$export$4d09a02f749e3cc2;
module.exports["TINY_SYNCHRONY_CONTENT_METADATA_PRELOAD"] = $23ec6b91fddb9839$export$c2bda34fe2c26f89;

});

parcelRegister("eqOQ5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $l6Cdg = parcelRequire("l6Cdg");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");

const $c0c8a88c8af3113f$var$PageLoadMarkFMPComponent = ({ timestamp: timestamp })=>{
    (0, $cozmU.useEffect)(()=>(0, $l6Cdg.addUFOCustomMark)('fmp', timestamp), [
        timestamp
    ]);
    return null;
};
const $c0c8a88c8af3113f$export$107265ce1e467930 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($c0c8a88c8af3113f$var$PageLoadMarkFMPComponent);
module.exports["PageLoadMarkFMP"] = $c0c8a88c8af3113f$export$107265ce1e467930;

});

parcelRegister("7r2px", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");

const $0bdd6e0a6db7c960$var$logger = (0, $7W8i8.getLogger)('retrieveContentExtensionMetrics');
const $0bdd6e0a6db7c960$export$1fa8ce0cc2ea267e = 10;
const $0bdd6e0a6db7c960$export$5da22daff5be7fe6 = (contentBody)=>{
    try {
        const contentExtensionMetrics = {
            contentExtensionCount: {
                connect: {},
                forge: {}
            },
            contentExtensionKeys: {
                connect: [],
                forge: []
            },
            depth: {
                connect: [],
                forge: []
            },
            hasExtensions: false
        };
        const document = JSON.parse(contentBody);
        const visit = (node)=>{
            $0bdd6e0a6db7c960$export$bd4248834ea73a5(node, contentExtensionMetrics);
        };
        document?.content?.forEach(visit);
        return contentExtensionMetrics;
    } catch  {
        $0bdd6e0a6db7c960$var$logger.error`Unable to parse ADF`;
        return {};
    }
};
const $0bdd6e0a6db7c960$export$bd4248834ea73a5 = (node, contentExtensionMetrics, depth)=>{
    $0bdd6e0a6db7c960$var$retrieveContentExtensionCountFromNode(node, contentExtensionMetrics.contentExtensionCount);
    $0bdd6e0a6db7c960$var$retrieveContentExtensionKeysFromNode(node, contentExtensionMetrics.contentExtensionKeys);
    if (depth !== undefined) $0bdd6e0a6db7c960$var$retrieveContentExtensionDepthFromNode(node, contentExtensionMetrics.depth, depth);
    contentExtensionMetrics.hasExtensions = contentExtensionMetrics.contentExtensionKeys?.connect.length > 0 || contentExtensionMetrics.contentExtensionKeys?.forge.length > 0;
    return contentExtensionMetrics;
};
function $0bdd6e0a6db7c960$var$retrieveContentExtensionKeysFromNode({ attrs: attrs, type: type }, contentExtensionKeys) {
    if (attrs && type) {
        const { extensionType: extensionType, extensionKey: extensionKey } = attrs;
        if (extensionType === 'com.atlassian.ecosystem' && extensionKey) contentExtensionKeys.forge.push(extensionKey);
        else if (extensionType === 'com.atlassian.confluence.macro.core' && extensionKey) contentExtensionKeys.connect.push(extensionKey);
        else if (extensionType === 'com.atlassian.confluence.migration' && extensionKey) contentExtensionKeys.connect.push(extensionKey);
        else return;
    }
}
function $0bdd6e0a6db7c960$var$retrieveContentExtensionCountFromNode({ attrs: attrs, type: type }, contentExtensionCount) {
    if (attrs && type) {
        const { extensionType: extensionType } = attrs;
        let extensionsObj;
        if (extensionType === 'com.atlassian.ecosystem') extensionsObj = contentExtensionCount.forge;
        else if (extensionType === 'com.atlassian.confluence.macro.core') extensionsObj = contentExtensionCount.connect;
        else if (extensionType === 'com.atlassian.confluence.migration') extensionsObj = contentExtensionCount.connect;
        else return;
        if (extensionsObj) extensionsObj[type] = (extensionsObj[type] || 0) + 1;
    }
}
function $0bdd6e0a6db7c960$var$retrieveContentExtensionDepthFromNode({ attrs: attrs, type: type }, contentExtensionDepth, depth) {
    if (attrs && type) {
        const { extensionType: extensionType } = attrs;
        if (extensionType === 'com.atlassian.ecosystem') contentExtensionDepth.forge.push(depth);
        else if (extensionType === 'com.atlassian.confluence.macro.core' || extensionType === 'com.atlassian.confluence.migration') contentExtensionDepth.connect.push(depth);
    }
}
module.exports["retrieveContentExtensionMetrics"] = $0bdd6e0a6db7c960$export$5da22daff5be7fe6;
module.exports["retrieveContentExtensionMetricsFromNode"] = $0bdd6e0a6db7c960$export$bd4248834ea73a5;

});

parcelRegister("juCeZ", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $jMyy4 = parcelRequire("jMyy4");


var $9Z1sw = parcelRequire("9Z1sw");

const $816e839f3c4509f6$export$b3d89882591ee965 = ({ contentId: contentId, location: location })=>{
    const batchResult = (0, $9Z1sw.useWebPanelLocationBatchResult)(location);
    const baseOptions = {
        variables: {
            contentId: contentId,
            location: location
        },
        skip: Boolean(batchResult)
    };
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data } = (0, $6mKj3.expValEquals)('confluence_stop_watching_webpanellocationquery', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        __callerPackage__: "web-panel-location"
    }) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: 'cache-first',
        __callerPackage__: "web-panel-location"
    });
    const panels = batchResult?.data?.webPanels || data?.webPanels || [];
    return panels.map((panel)=>panel?.moduleKey).join(',');
};
module.exports["useConnectAppsData"] = $816e839f3c4509f6$export$b3d89882591ee965;

});

parcelRegister("koYWo", function(module, exports) {

var $iFjdQ = parcelRequire("iFjdQ");


var $5q601 = parcelRequire("5q601");

const $b52d61085419c758$var$EDITOR_STARTED_MAX_MS = 15000;
const $b52d61085419c758$export$a8df9cafe21ac55e = (createAnalyticsEvent, analytics)=>{
    const { isCreate: isCreate } = analytics;
    const measures = (0, $iFjdQ.ExperienceActionMeasures).getMeasures();
    if (!measures.hasOwnProperty((0, $5q601.EDIT_ROUTE_CHANGE_TO_TTI_ACTION))) return;
    const timeToInitializeEditor = measures[0, $5q601.EDIT_ROUTE_CHANGE_TO_TTI_ACTION].duration;
    // Don't send event if editor took longer than 15 seconds to intialize or if page is being created
    if (timeToInitializeEditor > $b52d61085419c758$var$EDITOR_STARTED_MAX_MS || isCreate) return;
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: 'editorStarted',
            actionSubject: 'performanceTrigger',
            source: 'editPageScreen',
            attributes: {
                timeToInitializeEditor: timeToInitializeEditor
            }
        }
    }).fire();
};
module.exports["sendEditorStartedPageEvent"] = $b52d61085419c758$export$a8df9cafe21ac55e;

});

parcelRegister("8rj8Z", function(module, exports) {

var $l1kdf = parcelRequire("l1kdf");


var $c0rhi = parcelRequire("c0rhi");

const $87f902552c64bfd1$export$afadd31735d9bb64 = async (contentId)=>{
    try {
        return await (0, $c0rhi.queryInterop)({
            query: (0, $l1kdf.NativeCollabQuery),
            context: {
                single: true
            },
            fetchPolicy: 'network-only',
            variables: {
                contentId: contentId,
                status: [
                    'draft',
                    'current'
                ]
            } // For live docs, we need to fetch the current status instead of draft as live docs don't have drafts
            ,
            __callerPackage__: "editor-features"
        });
    } catch  {
    // NOTE: We intentionally swallow any possible error here as this query is only aimed
    // populate the cache with just published content. Should any error occur here after
    // successful publishing the page, the Apollo cache for the query will be invalidated
    // anyway and View Page will fetch the page and handle possible errors.
    }
};
module.exports["refetchEditorContent"] = $87f902552c64bfd1$export$afadd31735d9bb64;

});

parcelRegister("2sWSU", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $jOBr7 = parcelRequire("jOBr7");


const $2259a099417bd041$export$9f5f445f63346dec = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "koi_U",
    name: "CategorySelector",
    loader: async ()=>(await (parcelRequire("6mo6a"))).CategorySelector,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jOBr7.LoadingCategories), null)
});

const $2259a099417bd041$export$fd98f335d958fe2c = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Mzucr",
    name: "InlineCategorySelector",
    loader: async ()=>(await (parcelRequire("2VlSg"))).InlineCategorySelector,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jOBr7.LoadingInlineCategories), null)
});
module.exports["CategorySelector"] = $2259a099417bd041$export$9f5f445f63346dec;
module.exports["InlineCategorySelector"] = $2259a099417bd041$export$fd98f335d958fe2c;

});

parcelRegister("jOBr7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hicHn = parcelRequire("hicHn");

const $c94e5250e436cf81$export$d00b36cac03d226 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hicHn.CategoryList), {
        "data-testid": "loading-categories"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hicHn.PlaceholderPill), {
        width: 120,
        isDisabled: true
    }, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hicHn.PlaceholderPill), {
        width: 88,
        isDisabled: true
    }, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hicHn.PlaceholderPill), {
        width: 156,
        isDisabled: true
    }, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hicHn.PlaceholderPill), {
        width: 88,
        isDisabled: true
    }, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hicHn.PlaceholderPill), {
        width: 120,
        isDisabled: true
    }, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hicHn.PlaceholderPill), {
        width: 32,
        isDisabled: true
    }, "\xa0"));
const $c94e5250e436cf81$export$59cb8d91bea3cd98 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hicHn.InlineCategorySelectorWrapper), {
        "data-testid": "inline-loading-categories",
        isCollapsed: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hicHn.InlineCategoryList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hicHn.PlaceholderPill), {
        width: 88,
        isDisabled: true
    }, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hicHn.PlaceholderPill), {
        width: 120,
        isDisabled: true
    }, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hicHn.PlaceholderPill), {
        width: 88,
        isDisabled: true
    }, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hicHn.PlaceholderPill), {
        width: 120,
        isDisabled: true
    }, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hicHn.PlaceholderPill), {
        width: 120,
        isDisabled: true
    }, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hicHn.PlaceholderPill), {
        width: 88,
        isDisabled: true
    }, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hicHn.PlaceholderPill), {
        width: 120,
        isDisabled: true
    }, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hicHn.PlaceholderPill), {
        width: 156,
        isDisabled: true
    }, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hicHn.PlaceholderExpandPill), {
        width: 24,
        isDisabled: true
    }, "\xa0")));
module.exports["LoadingCategories"] = $c94e5250e436cf81$export$d00b36cac03d226;
module.exports["LoadingInlineCategories"] = $c94e5250e436cf81$export$59cb8d91bea3cd98;

});

parcelRegister("hicHn", function(module, exports) {
/* CategorySelectorStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");

const $29c38e9d5023fba6$export$fef438fc53d8c7b3 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisabled: isDisabled, isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_12ji1r31 _1qu2glyw _12y31o36 _1yt4xwjf _v564klxk _2rko1rr0 _11c8fhey _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _vchhusvi _1e0c116y _4t3i1ou6 _19pkidpf _otyru2gc _2hwx1b66 _uiztglyw _p12f1osq _1bto1l2s _o5721q9c _s7n4jp4b _7ehiw5lj _irr3i8nm",
            __cmplp.isDisabled || !__cmplp.isSelected ? "_bfhki8nm" : "_bfhk15s3",
            __cmplp.isDisabled || !__cmplp.isSelected ? "_1h6d1j28" : "_1h6d6x5g",
            __cmplp.isDisabled || !__cmplp.isSelected ? "_syazi7uo" : "_syaz6x5g",
            __cmplp.isDisabled ? "_80om1kw7" : "_80omtlke",
            __cmplp.className
        ])
    });
});
const $29c38e9d5023fba6$export$36ed96fc7440ff81 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = $29c38e9d5023fba6$export$fef438fc53d8c7b3, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_19bv1y44 _u5f31y44 _s7n4jp4b _2hwxidpf _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $29c38e9d5023fba6$export$97fb31c46eea67f0 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = $29c38e9d5023fba6$export$fef438fc53d8c7b3, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1gljcou": (0, $9aYkv.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1bsb1rkg _1o9zidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $29c38e9d5023fba6$export$7c3018f441722857 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _1bto1l2s _1o9zkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $29c38e9d5023fba6$export$ea56f7cea075a7df = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $29c38e9d5023fba6$export$ae846b5f9b917b03 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_18s818xp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $29c38e9d5023fba6$export$4d0d284a7daa943b = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_18s81opn",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $29c38e9d5023fba6$export$324eb091ed8d0181 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_18s8huju",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $29c38e9d5023fba6$export$be58b4326e23250f = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $29c38e9d5023fba6$export$95aa4184327d6b72 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_k48p1pd9 _1o9zidpf _18u012x7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $29c38e9d5023fba6$export$fc1c3c7100f32c93 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_18u0v77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $29c38e9d5023fba6$export$a05835e82fd98f96 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt4pxbi _p12fgx0z _vchhusvi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $29c38e9d5023fba6$export$79717968ed9ae6cd = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yxxidpf",
            __cmplp.className
        ])
    });
});
const $29c38e9d5023fba6$export$94db4e2a8a326082 = 26; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $29c38e9d5023fba6$export$1fa4c0e9ca4cb169 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCollapsed: isCollapsed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt41qq9 _1reo15vq _18m915vq _kqswh2mm _1e0c1txw _4cvr1y6m",
            __cmplp.isCollapsed ? "_4t3i1ou6" : "_4t3i1wug",
            __cmplp.className
        ])
    });
});
const $29c38e9d5023fba6$export$a37b48cfe5037c84 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = $29c38e9d5023fba6$export$fef438fc53d8c7b3, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c116y _4cvr1h6o _4t3i1tcg _19pkt94y _otyrt94y _18u0idpf _2hwxidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $29c38e9d5023fba6$export$5b35db8b663b38dd = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = $29c38e9d5023fba6$export$97fb31c46eea67f0, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4t3i1tcg _19pkt94y _otyrt94y _18u0idpf _2hwxidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $29c38e9d5023fba6$export$5dff2750eb30565b = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = $29c38e9d5023fba6$export$79717968ed9ae6cd, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_p12f1osq _1ofnglyw",
            __cmplp.className
        ])
    });
});
module.exports["CategoryPill"] = $29c38e9d5023fba6$export$fef438fc53d8c7b3;
module.exports["EllipsisPill"] = $29c38e9d5023fba6$export$36ed96fc7440ff81;
module.exports["PlaceholderPill"] = $29c38e9d5023fba6$export$97fb31c46eea67f0;
module.exports["TextWrapper"] = $29c38e9d5023fba6$export$7c3018f441722857;
module.exports["CategoryNameWrapper"] = $29c38e9d5023fba6$export$ea56f7cea075a7df;
module.exports["TrophyIconWrapper"] = $29c38e9d5023fba6$export$ae846b5f9b917b03;
module.exports["FireIconWrapper"] = $29c38e9d5023fba6$export$4d0d284a7daa943b;
module.exports["StarIconWrapper"] = $29c38e9d5023fba6$export$324eb091ed8d0181;
module.exports["IconWrapper"] = $29c38e9d5023fba6$export$be58b4326e23250f;
module.exports["Bold"] = $29c38e9d5023fba6$export$95aa4184327d6b72;
module.exports["NoCountSpace"] = $29c38e9d5023fba6$export$fc1c3c7100f32c93;
module.exports["InlineDialogContentWrapper"] = $29c38e9d5023fba6$export$a05835e82fd98f96;
module.exports["CategoryList"] = $29c38e9d5023fba6$export$79717968ed9ae6cd;
module.exports["COLLAPSED_INLINE_WRAPPER_HEIGHT"] = $29c38e9d5023fba6$export$94db4e2a8a326082;
module.exports["InlineCategorySelectorWrapper"] = $29c38e9d5023fba6$export$1fa4c0e9ca4cb169;
module.exports["InlineExpandCollapsePill"] = $29c38e9d5023fba6$export$a37b48cfe5037c84;
module.exports["PlaceholderExpandPill"] = $29c38e9d5023fba6$export$5b35db8b663b38dd;
module.exports["InlineCategoryList"] = $29c38e9d5023fba6$export$5dff2750eb30565b;

});

parcelRegister("6mo6a", function(module, exports) {

let $4a177d9c05255696$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a177d9c05255696$var$load("g6t0n").then(()=>parcelRequire('Go6xd'));

});

parcelRegister("2VlSg", function(module, exports) {

let $2211df6eecceaf64$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2211df6eecceaf64$var$load("1NmUq").then(()=>parcelRequire('7vrqx'));

});

parcelRegister("6sN9o", function(module, exports) {
/* DebouncedSearchBar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $55fM8 = parcelRequire("55fM8");


var $4yg9g = parcelRequire("4yg9g");


var $hAgam = parcelRequire("hAgam");


var $5avUB = parcelRequire("5avUB");


var $9GVkD = parcelRequire("9GVkD");


var $kh0hi = parcelRequire("kh0hi");


var $buxP3 = parcelRequire("buxP3");

function $82b202e8c8a4137c$var$_defineProperty(e, r, t) {
    return (r = $82b202e8c8a4137c$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $82b202e8c8a4137c$var$_toPropertyKey(t) {
    var i = $82b202e8c8a4137c$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $82b202e8c8a4137c$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $82b202e8c8a4137c$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    searchBarLabel: {
        id: "debounced-search-bar.label",
        defaultMessage: "Search"
    },
    searchPlaceholderText: {
        id: "debounced-search-bar.hintText",
        defaultMessage: "Search"
    },
    searchIconLabel: {
        id: "debounced-search-bar.search.icon.label",
        defaultMessage: "Search icon"
    },
    crossIconLabel: {
        id: "debounced-search-bar.cross.icon.label",
        defaultMessage: "Clear search bar"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $82b202e8c8a4137c$var$SearchIconWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_18s81gdr",
            __cmplp.className
        ])
    });
});
const $82b202e8c8a4137c$var$pressableStyles = (0, $buxP3.xcss)({
    marginTop: '0',
    marginBottom: '0',
    marginLeft: 'space.075',
    marginRight: 'space.075',
    padding: '0',
    background: 'none',
    border: 'none'
});
const $82b202e8c8a4137c$var$pressableDisabledStyle = (0, $buxP3.xcss)({
    cursor: 'inherit'
});
const $82b202e8c8a4137c$var$pressableEnabledStyle = (0, $buxP3.xcss)({
    cursor: 'pointer'
});
class $82b202e8c8a4137c$var$InjectedDebouncedSearchBar extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        const { intl: intl, onFocus: onFocus, label: label = intl.formatMessage($82b202e8c8a4137c$export$a7357cdd1f0b0168.searchBarLabel), placeholder: placeholder = intl.formatMessage($82b202e8c8a4137c$export$a7357cdd1f0b0168.searchPlaceholderText), testId: testId, isDisabled: isDisabled, isCompact: isCompact, autoFocus: autoFocus, ariaLabelledBy: ariaLabelledBy, ariaLive: ariaLive } = this.props;
        const { value: value } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
            ref: this.searchBarRef,
            label: label,
            testId: testId,
            placeholder: placeholder,
            value: value,
            onChange: this.handleChange,
            onBlur: this.handleBlur,
            elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($82b202e8c8a4137c$var$SearchIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
                label: intl.formatMessage($82b202e8c8a4137c$export$a7357cdd1f0b0168.searchIconLabel),
                color: "var(--ds-icon-subtle)"
            })),
            elemAfterInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
                xcss: [
                    $82b202e8c8a4137c$var$pressableStyles,
                    isDisabled ? $82b202e8c8a4137c$var$pressableDisabledStyle : $82b202e8c8a4137c$var$pressableEnabledStyle
                ],
                testId: "clear-button",
                onClick: this.handleClearClick,
                isDisabled: isDisabled
            }, !!value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                label: intl.formatMessage($82b202e8c8a4137c$export$a7357cdd1f0b0168.crossIconLabel),
                color: isDisabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon-subtle, #505258)"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                label: intl.formatMessage($82b202e8c8a4137c$export$a7357cdd1f0b0168.crossIconLabel),
                color: isDisabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon-subtle, #505258)"
            }))),
            isDisabled: isDisabled,
            onFocus: onFocus,
            isCompact: isCompact,
            autoFocus: autoFocus,
            "aria-labelledby": ariaLabelledBy,
            "aria-live": ariaLive
        });
    }
    constructor(...args){
        super(...args);
        $82b202e8c8a4137c$var$_defineProperty(this, "state", {
            value: this.props.initialValue || ''
        });
        $82b202e8c8a4137c$var$_defineProperty(this, "searchBarRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef());
        $82b202e8c8a4137c$var$_defineProperty(this, "_debouncedUpdateSearch", (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))((newSearchQuery)=>{
            this.props.onChange(newSearchQuery);
        }, this.props.debouncedTime));
        $82b202e8c8a4137c$var$_defineProperty(this, "handleChange", (e)=>{
            this.setState({
                value: e.target.value
            });
            this._debouncedUpdateSearch(e.target.value);
        });
        $82b202e8c8a4137c$var$_defineProperty(this, "handleBlur", ()=>{
            const { onBlur: onBlur } = this.props;
            this._debouncedUpdateSearch.flush();
            onBlur?.();
        });
        $82b202e8c8a4137c$var$_defineProperty(this, "handleClearClick", (e)=>{
            e.preventDefault();
            if (this.props.isDisabled) return;
            this.setState({
                value: ''
            });
            this._debouncedUpdateSearch('');
            this._debouncedUpdateSearch.flush();
            this.searchBarRef.current?.focus();
        });
    }
}
$82b202e8c8a4137c$var$_defineProperty($82b202e8c8a4137c$var$InjectedDebouncedSearchBar, "defaultProps", {
    isCompact: true,
    debouncedTime: 250
});
const $82b202e8c8a4137c$export$6dbfe8c3c1fa25b2 = (0, $kSwu1.injectIntl)($82b202e8c8a4137c$var$InjectedDebouncedSearchBar);
module.exports["DebouncedSearchBar"] = $82b202e8c8a4137c$export$6dbfe8c3c1fa25b2;

});

parcelRegister("7Voxz", function(module, exports) {

var $kBRLU = parcelRequire("kBRLU");

var $3353d8f494041692$export$ec254908aabec82d = /*#__PURE__*/ function(EMPTY_STATE_VARIANT) {
    EMPTY_STATE_VARIANT["SEARCH"] = "search";
    EMPTY_STATE_VARIANT["MY_TEMPLATES"] = "my-templates";
    EMPTY_STATE_VARIANT["FAVORITES"] = "favorites";
    return EMPTY_STATE_VARIANT;
}({});
function $3353d8f494041692$export$89548721a3a7aa8c(isCategoryEmpty, selectedCategoryId) {
    if (!isCategoryEmpty) return "search";
    if (selectedCategoryId === (0, $kBRLU.SNIPPET_CATEGORY_IDS).MY_TEMPLATES) return "my-templates";
    if (selectedCategoryId === (0, $kBRLU.SNIPPET_CATEGORY_IDS).FAVORITES) return "favorites";
    return "search";
}
module.exports["EMPTY_STATE_VARIANT"] = $3353d8f494041692$export$ec254908aabec82d;
module.exports["getEmptyStateVariant"] = $3353d8f494041692$export$89548721a3a7aa8c;

});

parcelRegister("5Vsx9", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $kSwu1 = parcelRequire("kSwu1");


var $kBRLU = parcelRequire("kBRLU");

const $76d8847bf8b5dfb8$var$snippetCategoryI18n = (0, $kSwu1.defineMessages)({
    allCategory: {
        id: "snippets.snippet-tab.category.all",
        defaultMessage: "All"
    },
    myTemplatesCategory: {
        id: "snippets.snippet-tab.category.my-templates",
        defaultMessage: "My Templates"
    },
    favoritesCategory: {
        id: "snippets.snippet-tab.category.favorites",
        defaultMessage: "Favorites"
    }
});
const $76d8847bf8b5dfb8$export$9f6577ab4f3698eb = ()=>{
    const $ = (0, $bDgLe.c)(16);
    const intl = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage($76d8847bf8b5dfb8$var$snippetCategoryI18n.allCategory);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = {
            id: (0, $kBRLU.SNIPPET_CATEGORY_IDS).ALL,
            name: t0
        };
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== intl) {
        t2 = intl.formatMessage($76d8847bf8b5dfb8$var$snippetCategoryI18n.myTemplatesCategory);
        $[4] = intl;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = {
            id: (0, $kBRLU.SNIPPET_CATEGORY_IDS).MY_TEMPLATES,
            name: t2
        };
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== intl) {
        t4 = intl.formatMessage($76d8847bf8b5dfb8$var$snippetCategoryI18n.favoritesCategory);
        $[8] = intl;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== t4) {
        t5 = {
            id: (0, $kBRLU.SNIPPET_CATEGORY_IDS).FAVORITES,
            name: t4
        };
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== t1 || $[13] !== t3 || $[14] !== t5) {
        t6 = [
            t1,
            t3,
            t5
        ];
        $[12] = t1;
        $[13] = t3;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
};
module.exports["useSnippetFilterCategories"] = $76d8847bf8b5dfb8$export$9f6577ab4f3698eb;

});

parcelRegister("2mmJ0", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $RfroO = parcelRequire("RfroO");


var $cJ0FD = parcelRequire("cJ0FD");


var $3izAL = parcelRequire("3izAL");


var $6Pqow = parcelRequire("6Pqow");


var $buxP3 = parcelRequire("buxP3");


var $hPTbh = parcelRequire("hPTbh");


var $7Voxz = parcelRequire("7Voxz");


var $jxXkP = parcelRequire("jxXkP");


var $wSNO8 = parcelRequire("wSNO8");


var $48oTq = parcelRequire("48oTq");


var $dRqQU = parcelRequire("dRqQU");


var $MIjeo = parcelRequire("MIjeo");


var $kzKk3 = parcelRequire("kzKk3");

const $d7e889767909fab4$var$wrapperStyle = (0, $buxP3.xcss)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flexGrow: 1,
    marginBottom: 'space.100'
});
const $d7e889767909fab4$export$6ec02dae7201276c = (t0)=>{
    const $ = (0, $bDgLe.c)(30);
    const { origin: origin, variant: variant, primaryAction: primaryAction } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const { fireButtonClickedAnalytic: fireButtonClickedAnalytic } = (0, $jxXkP.useSnippetAnalytics)(origin);
    let header;
    let description;
    let imageUrl;
    let imageHeight;
    let renderImage;
    let primaryActionLabel = null;
    if (variant === (0, $7Voxz.EMPTY_STATE_VARIANT).MY_TEMPLATES) {
        let t1;
        if ($[0] !== intl) {
            t1 = intl.formatMessage((0, $kzKk3.i18n).myTemplatesEmptyHeader);
            $[0] = intl;
            $[1] = t1;
        } else t1 = $[1];
        header = t1;
        let t2;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...(0, $kzKk3.i18n).myTemplatesEmptyDescription,
                values: {
                    categoryName: $d7e889767909fab4$var$_temp,
                    br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("br", null)
                }
            });
            $[2] = t2;
        } else t2 = $[2];
        description = t2;
        imageUrl = (0, (/*@__PURE__*/$parcel$interopDefault($48oTq)));
        imageHeight = 165;
        if (primaryAction) {
            let t3;
            if ($[3] !== intl) {
                t3 = intl.formatMessage((0, $kzKk3.i18n).myTemplatesEmptyPrimaryAction);
                $[3] = intl;
                $[4] = t3;
            } else t3 = $[4];
            primaryActionLabel = t3;
        }
    } else if (variant === (0, $7Voxz.EMPTY_STATE_VARIANT).FAVORITES) {
        let t1;
        if ($[5] !== intl) {
            t1 = intl.formatMessage((0, $kzKk3.i18n).favoritesEmptyHeader);
            $[5] = intl;
            $[6] = t1;
        } else t1 = $[6];
        header = t1;
        let t2;
        if ($[7] !== intl) {
            t2 = intl.formatMessage((0, $kzKk3.i18n).favoritesEmptyDescription);
            $[7] = intl;
            $[8] = t2;
        } else t2 = $[8];
        description = t2;
        imageUrl = (0, (/*@__PURE__*/$parcel$interopDefault($wSNO8)));
        imageHeight = 165;
        if (primaryAction) {
            let t3;
            if ($[9] !== intl) {
                t3 = intl.formatMessage((0, $kzKk3.i18n).favoritesEmptyPrimaryAction);
                $[9] = intl;
                $[10] = t3;
            } else t3 = $[10];
            primaryActionLabel = t3;
        }
    } else {
        let t1;
        if ($[11] !== intl) {
            t1 = intl.formatMessage((0, $kzKk3.i18n).emptyHeader);
            $[11] = intl;
            $[12] = t1;
        } else t1 = $[12];
        header = t1;
        let t2;
        if ($[13] !== intl) {
            t2 = intl.formatMessage((0, $kzKk3.i18n).emptyDescription);
            $[13] = intl;
            $[14] = t2;
        } else t2 = $[14];
        description = t2;
        imageHeight = 160;
        renderImage = $d7e889767909fab4$var$_temp2;
    }
    let t1;
    if ($[15] !== fireButtonClickedAnalytic || $[16] !== primaryAction || $[17] !== variant) {
        t1 = ()=>{
            if (variant === (0, $7Voxz.EMPTY_STATE_VARIANT).MY_TEMPLATES) fireButtonClickedAnalytic((0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).EMPTY_MY_TEMPLATES_CALL_TO_ACTION);
            else if (variant === (0, $7Voxz.EMPTY_STATE_VARIANT).FAVORITES) fireButtonClickedAnalytic((0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).EMPTY_FAVORITES_CALL_TO_ACTION);
            primaryAction?.();
        };
        $[15] = fireButtonClickedAnalytic;
        $[16] = primaryAction;
        $[17] = variant;
        $[18] = t1;
    } else t1 = $[18];
    const handlePrimaryAction = t1;
    let t2;
    if ($[19] !== handlePrimaryAction || $[20] !== primaryAction || $[21] !== primaryActionLabel) {
        t2 = primaryAction && primaryActionLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: handlePrimaryAction
        }, primaryActionLabel) : null;
        $[19] = handlePrimaryAction;
        $[20] = primaryAction;
        $[21] = primaryActionLabel;
        $[22] = t2;
    } else t2 = $[22];
    const primaryActionButton = t2;
    const t3 = primaryActionButton ?? undefined;
    let t4;
    if ($[23] !== description || $[24] !== header || $[25] !== imageHeight || $[26] !== imageUrl || $[27] !== renderImage || $[28] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $d7e889767909fab4$var$wrapperStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $RfroO.default), {
            headingSize: "xsmall",
            header: header,
            description: description,
            imageUrl: imageUrl,
            imageHeight: imageHeight,
            renderImage: renderImage,
            primaryAction: t3
        }));
        $[23] = description;
        $[24] = header;
        $[25] = imageHeight;
        $[26] = imageUrl;
        $[27] = renderImage;
        $[28] = t3;
        $[29] = t4;
    } else t4 = $[29];
    return t4;
};
function $d7e889767909fab4$var$_temp(chunks) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        as: "strong"
    }, chunks);
}
function $d7e889767909fab4$var$_temp2() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($MIjeo))),
        srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($dRqQU))),
        alt: ""
    });
}
module.exports["EmptySnippets"] = $d7e889767909fab4$export$6ec02dae7201276c;

});

parcelRegister("wSNO8", function(module, exports) {
module.exports = new URL("EmptyFavoritesImg.bbb61fc3.svg", import.meta.url).toString();

});

parcelRegister("48oTq", function(module, exports) {
module.exports = new URL("EmptyMyTemplatesImg.66c713bd.svg", import.meta.url).toString();

});

parcelRegister("dRqQU", function(module, exports) {
module.exports = new URL("EmptySearchDark.eb3b9001.svg", import.meta.url).toString();

});

parcelRegister("MIjeo", function(module, exports) {
module.exports = new URL("EmptySearchLight.8191120f.svg", import.meta.url).toString();

});

parcelRegister("kzKk3", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a335104451b5aa13$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    emptyHeader: {
        id: "snippets.snippet-tab.empty.header",
        defaultMessage: "No templates found"
    },
    emptyDescription: {
        id: "snippets.snippet-tab.empty.description",
        defaultMessage: "Try selecting a different category to see more templates."
    },
    myTemplatesEmptyHeader: {
        id: "snippets.snippet-tab.empty.my-templates.header",
        defaultMessage: "Make almost anything a block template"
    },
    myTemplatesEmptyDescription: {
        id: "snippets.snippet-tab.empty.my-templates.description",
        defaultMessage: "Highlight page content, and select \"Create Block Template\" to save it here in <categoryName>My Templates</categoryName>.{br}Type \"/templatename\" to insert into a page."
    },
    myTemplatesEmptyPrimaryAction: {
        id: "snippets.snippet-tab.empty.my-templates.primary-action",
        defaultMessage: "Create template"
    },
    favoritesEmptyHeader: {
        id: "snippets.snippet-tab.empty.favorites.header",
        defaultMessage: "You haven't starred a template yet"
    },
    favoritesEmptyDescription: {
        id: "snippets.snippet-tab.empty.favorites.description",
        defaultMessage: "Star a template to save it here. Type \"/templatename\" to quickly insert it into a page."
    },
    favoritesEmptyPrimaryAction: {
        id: "snippets.snippet-tab.empty.favorites.primary-action",
        defaultMessage: "Explore templates"
    }
});
module.exports["i18n"] = $a335104451b5aa13$export$a7357cdd1f0b0168;

});

parcelRegister("cg3fp", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $3d78d89b40cc8d4c$export$5fa3549ed03b29d2 = (fireScreenViewedAnalytic)=>{
    const $ = (0, $bDgLe.c)(3);
    const hasFiredViewedRef = (0, $cozmU.useRef)(false);
    let t0;
    let t1;
    if ($[0] !== fireScreenViewedAnalytic) {
        t0 = ()=>{
            if (hasFiredViewedRef.current) return;
            hasFiredViewedRef.current = true;
            fireScreenViewedAnalytic();
        };
        t1 = [
            fireScreenViewedAnalytic
        ];
        $[0] = fireScreenViewedAnalytic;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
};
module.exports["useSnippetViewedOnce"] = $3d78d89b40cc8d4c$export$5fa3549ed03b29d2;

});

parcelRegister("5B99W", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bQm3c = parcelRequire("bQm3c");


var $cga1x = parcelRequire("cga1x");


var $kBRLU = parcelRequire("kBRLU");


var $gPFNt = parcelRequire("gPFNt");

const $354bd492cd3c3cd4$export$8c1f8aab30e0c253 = (snippets, categoryId, searchQuery, userId)=>{
    let categoryFiltered = snippets;
    // Apply category filter
    if (categoryId === (0, $kBRLU.SNIPPET_CATEGORY_IDS).MY_TEMPLATES) categoryFiltered = snippets.filter((snippet)=>snippet.scope === (0, $cga1x.SnippetScope).USER && snippet.createdBy.accountId === userId);
    else if (categoryId === (0, $kBRLU.SNIPPET_CATEGORY_IDS).FAVORITES) categoryFiltered = snippets.filter((snippet)=>snippet?.isFavorite);
    // Apply search filter
    const trimmedSearchQuery = searchQuery.trim().toLowerCase();
    if (!trimmedSearchQuery) return categoryFiltered;
    return categoryFiltered.filter((snippet)=>{
        const nameMatch = snippet.name.toLowerCase().includes(trimmedSearchQuery);
        const ownerMatch = snippet.createdBy.displayName.toLowerCase().includes(trimmedSearchQuery);
        const descriptionMatch = snippet.description?.toLowerCase().includes(trimmedSearchQuery);
        return nameMatch || ownerMatch || descriptionMatch;
    });
};
const $354bd492cd3c3cd4$export$961a77b8589838c3 = (snippets, sortOrder)=>{
    const sorted = [
        ...snippets
    ];
    switch(sortOrder){
        case (0, $gPFNt.SnippetSortOrder).CREATED_AT:
            return sorted.sort((a, b)=>new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
        case (0, $gPFNt.SnippetSortOrder).LAST_UPDATED:
            return sorted.sort((a, b)=>new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
        case (0, $gPFNt.SnippetSortOrder).POPULARITY:
            return sorted.sort((a, b)=>{
                // Site and global snippets should be sorted by insert count, but not user snippets
                const sortableInsertCount = (s)=>s.scope === (0, $cga1x.SnippetScope).USER ? 0 : s.insertCount ?? 0;
                return sortableInsertCount(b) - sortableInsertCount(a);
            });
        case (0, $gPFNt.SnippetSortOrder).ALPHABETICAL:
            return sorted.sort((a, b)=>a.name.localeCompare(b.name));
        default:
            return sorted;
    }
};
const $354bd492cd3c3cd4$export$f1d3128352bb5216 = (snippets)=>{
    const $ = (0, $bDgLe.c)(12);
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const [selectedCategoryId, setSelectedCategoryId] = (0, $cozmU.useState)((0, $kBRLU.DEFAULT_CATEGORY_ID));
    const [searchQuery, setSearchQuery] = (0, $cozmU.useState)("");
    const [sortOrder, setSortOrder] = (0, $cozmU.useState)((0, $gPFNt.DEFAULT_SNIPPET_SORT_ORDER));
    let t0;
    if ($[0] !== searchQuery || $[1] !== selectedCategoryId || $[2] !== snippets || $[3] !== sortOrder || $[4] !== userId) {
        t0 = $354bd492cd3c3cd4$export$961a77b8589838c3($354bd492cd3c3cd4$export$8c1f8aab30e0c253(snippets, selectedCategoryId, searchQuery, userId), sortOrder);
        $[0] = searchQuery;
        $[1] = selectedCategoryId;
        $[2] = snippets;
        $[3] = sortOrder;
        $[4] = userId;
        $[5] = t0;
    } else t0 = $[5];
    const filteredSnippets = t0;
    let t1;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setSelectedCategoryId((0, $kBRLU.DEFAULT_CATEGORY_ID));
            setSearchQuery("");
            setSortOrder((0, $gPFNt.DEFAULT_SNIPPET_SORT_ORDER));
        };
        $[6] = t1;
    } else t1 = $[6];
    let t2;
    if ($[7] !== filteredSnippets || $[8] !== searchQuery || $[9] !== selectedCategoryId || $[10] !== sortOrder) {
        t2 = {
            selectedCategoryId: selectedCategoryId,
            searchQuery: searchQuery,
            sortOrder: sortOrder,
            filteredSnippets: filteredSnippets,
            setCategoryFilter: setSelectedCategoryId,
            setSearchQuery: setSearchQuery,
            setSortOrder: setSortOrder,
            resetFilters: t1
        };
        $[7] = filteredSnippets;
        $[8] = searchQuery;
        $[9] = selectedCategoryId;
        $[10] = sortOrder;
        $[11] = t2;
    } else t2 = $[11];
    return t2;
};
module.exports["filterSnippets"] = $354bd492cd3c3cd4$export$8c1f8aab30e0c253;
module.exports["sortSnippets"] = $354bd492cd3c3cd4$export$961a77b8589838c3;
module.exports["useSnippetFilterAndSort"] = $354bd492cd3c3cd4$export$f1d3128352bb5216;

});

parcelRegister("67NtX", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $4ez2K = parcelRequire("4ez2K");


var $3BY7M = parcelRequire("3BY7M");


var $9wGTI = parcelRequire("9wGTI");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $kBU5m = parcelRequire("kBU5m");


var $bQm3c = parcelRequire("bQm3c");


var $hPTbh = parcelRequire("hPTbh");


var $jxXkP = parcelRequire("jxXkP");


var $ies1q = parcelRequire("ies1q");


var $5DXNy = parcelRequire("5DXNy");

const $e12252c7883ca5e3$var$styles = {
    scaledContainer: "_1reo15vq _18m915vq _uiztglyw _lcxvglyw",
    scaledContent: "_4t3i1wug _8hrz5d63",
    loadingWrapper: "_1bsb1osq _4t3i1osq"
}; /** Desired output dimensions (container size) */ 
const $e12252c7883ca5e3$export$a13d19bdacf806db = (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { snippet: snippet, dimensions: dimensions, renderWidth: renderWidth, loadingComponent: loadingComponent } = t0;
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(true);
    const showFallback = !!loadingComponent && isLoading;
    let t1;
    if ($[0] !== loadingComponent || $[1] !== showFallback) {
        t1 = showFallback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.default), {
            xcss: $e12252c7883ca5e3$var$styles.loadingWrapper,
            alignItems: "center",
            justifyContent: "center"
        }, loadingComponent);
        $[0] = loadingComponent;
        $[1] = showFallback;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>setIsLoading(false);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== snippet.body || $[5] !== snippet.scope || $[6] !== snippet.snippetId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e12252c7883ca5e3$var$Renderer, {
            adf: snippet.body,
            snippetId: snippet.snippetId,
            scope: snippet.scope,
            onRendered: t2
        });
        $[4] = snippet.body;
        $[5] = snippet.scope;
        $[6] = snippet.snippetId;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== dimensions || $[9] !== renderWidth || $[10] !== showFallback || $[11] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e12252c7883ca5e3$var$ScaledContainer, {
            dimensions: dimensions,
            renderWidth: renderWidth,
            shouldHide: showFallback
        }, t3);
        $[8] = dimensions;
        $[9] = renderWidth;
        $[10] = showFallback;
        $[11] = t3;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== t1 || $[14] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1, t4);
        $[13] = t1;
        $[14] = t4;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
};
const $e12252c7883ca5e3$var$Renderer = (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { adf: adf, snippetId: snippetId, scope: scope, onRendered: onRendered } = t0;
    const { cloudId: cloudId, userId: userId, featureFlags: featureFlags } = (0, $bQm3c.useSessionData)();
    const { fireFailedAnalytic: fireFailedAnalytic } = (0, $jxXkP.useSnippetAnalytics)((0, $hPTbh.ANALYTICS_ORIGIN).SNIPPET_PANEL);
    let t1;
    if ($[0] !== fireFailedAnalytic) {
        t1 = (error)=>{
            const reasonString = error instanceof Error ? error.message : JSON.stringify(error);
            const errorToLog = new Error(`Error when rendering snippet preview: ${reasonString}`);
            (0, $5ZqQS.getMonitoringClient)().submitError(errorToLog, {
                attribution: (0, $3IBnw.Attribution).INTEGRATIONS
            });
            fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_PREVIEW_RENDER, {});
        };
        $[0] = fireFailedAnalytic;
        $[1] = t1;
    } else t1 = $[1];
    const handleRenderError = t1;
    let t2;
    if ($[2] !== cloudId || $[3] !== scope || $[4] !== snippetId || $[5] !== userId) {
        t2 = (0, $5DXNy.getProviders)(cloudId, userId, snippetId, scope);
        $[2] = cloudId;
        $[3] = scope;
        $[4] = snippetId;
        $[5] = userId;
        $[6] = t2;
    } else t2 = $[6];
    const providers = t2;
    let t3;
    if ($[7] !== adf) {
        t3 = (0, $ies1q.wrapAdfWithDocNode)(adf);
        $[7] = adf;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $9wGTI.fg)("platform_synced_block_patch_13");
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== featureFlags) {
        t5 = (0, $kBU5m.getMediaFeatureFlags)(featureFlags);
        $[10] = featureFlags;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== t5) {
        t6 = {
            featureFlags: t5
        };
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== handleRenderError || $[15] !== onRendered || $[16] !== providers || $[17] !== t3 || $[18] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
            adfStage: "stage0",
            document: t3,
            appearance: "full-page",
            allowColumnSorting: false,
            enableSsrInlineScripts: false,
            allowHeadingAnchorLinks: false,
            allowCustomPanels: t4,
            stickyHeaders: undefined,
            dataProviders: providers,
            onComplete: onRendered,
            onError: handleRenderError,
            allowPlaceholderText: true,
            media: t6
        });
        $[14] = handleRenderError;
        $[15] = onRendered;
        $[16] = providers;
        $[17] = t3;
        $[18] = t6;
        $[19] = t7;
    } else t7 = $[19];
    return t7;
};
const $e12252c7883ca5e3$var$useContainerWidth = (containerRef)=>{
    const $ = (0, $bDgLe.c)(3);
    const [containerWidth, setContainerWidth] = (0, $cozmU.useState)(null);
    let t0;
    let t1;
    if ($[0] !== containerRef) {
        t0 = ()=>{
            const node = containerRef.current;
            if (!node || typeof ResizeObserver === "undefined") return;
            const observer = new ResizeObserver((t2)=>{
                const [entry] = t2;
                const width = entry.contentRect.width;
                if (width > 0) setContainerWidth(width);
            });
            observer.observe(node);
            return ()=>observer.disconnect();
        };
        t1 = [
            containerRef
        ];
        $[0] = containerRef;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return containerWidth;
};
const $e12252c7883ca5e3$var$ScaledContainer = (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { children: children, dimensions: dimensions, renderWidth: renderWidth, shouldHide: t1 } = t0;
    const shouldHide = t1 === undefined ? false : t1;
    const containerRef = (0, $cozmU.useRef)(null);
    const containerWidth = $e12252c7883ca5e3$var$useContainerWidth(containerRef);
    const scaleFactor = containerWidth !== null ? containerWidth / renderWidth : 0;
    const isMeasured = containerWidth !== null;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (node)=>{
            containerRef.current = node;
            node?.setAttribute("inert", "");
        };
        $[0] = t2;
    } else t2 = $[0];
    const t3 = shouldHide ? "none" : "block";
    let t4;
    if ($[1] !== dimensions.maxHeight || $[2] !== dimensions.width || $[3] !== t3) {
        t4 = {
            width: dimensions.width,
            maxHeight: dimensions.maxHeight,
            display: t3
        };
        $[1] = dimensions.maxHeight;
        $[2] = dimensions.width;
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    const t5 = `scale(${scaleFactor})`;
    const t6 = isMeasured ? "visible" : "hidden";
    let t7;
    if ($[5] !== renderWidth || $[6] !== t5 || $[7] !== t6) {
        t7 = {
            transform: t5,
            width: renderWidth,
            visibility: t6,
            containerType: "inline-size"
        };
        $[5] = renderWidth;
        $[6] = t5;
        $[7] = t6;
        $[8] = t7;
    } else t7 = $[8];
    let t8;
    if ($[9] !== children || $[10] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $e12252c7883ca5e3$var$styles.scaledContent,
            style: t7
        }, children);
        $[9] = children;
        $[10] = t7;
        $[11] = t8;
    } else t8 = $[11];
    let t9;
    if ($[12] !== t4 || $[13] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            ref: t2,
            xcss: $e12252c7883ca5e3$var$styles.scaledContainer,
            testId: "snippet-preview-container",
            style: t4
        }, t8);
        $[12] = t4;
        $[13] = t8;
        $[14] = t9;
    } else t9 = $[14];
    return t9;
};
module.exports["SnippetPreview"] = $e12252c7883ca5e3$export$a13d19bdacf806db;

});

parcelRegister("5DXNy", function(module, exports) {

var $kwzZh = parcelRequire("kwzZh");


var $eNbr2 = parcelRequire("eNbr2");


var $32x2E = parcelRequire("32x2E");


var $bKBay = parcelRequire("bKBay");

const $1b808083bd8e59eb$export$4e044719025cb45d = (cloudId, userId, snippetId, scope)=>{
    const providers = (0, $eNbr2.default).create({});
    providers.setProvider('emojiProvider', (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
        cloudId: cloudId,
        userId: userId
    }));
    providers.setProvider('mediaProvider', (0, $bKBay.createSnippetsRendererMediaProvider)({
        snippetId: snippetId,
        scope: scope
    }));
    return providers;
};
module.exports["getProviders"] = $1b808083bd8e59eb$export$4e044719025cb45d;

});

parcelRegister("2esFu", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $dinVW = parcelRequire("dinVW");

const $def96d89fa00bdae$var$styles = {
    skeletonLongLine: "_2rko1mok _4t3i1crf _1bsb1w8u _bfhkizff",
    skeletonShortLine: "_2rko1mok _4t3i1crf _1bsbhwvj _bfhkizff",
    skeletonLine: "_2rko1mok _4t3i1crf _1bsb1nrf _bfhkizff"
};
const $def96d89fa00bdae$export$b8636d59d0a13d7d = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $def96d89fa00bdae$var$styles.skeletonLongLine
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $def96d89fa00bdae$var$styles.skeletonLine
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $def96d89fa00bdae$var$styles.skeletonLongLine
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $def96d89fa00bdae$var$styles.skeletonShortLine
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
module.exports["SnippetPreviewSkeleton"] = $def96d89fa00bdae$export$b8636d59d0a13d7d;

});

parcelRegister("bL1ca", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $3vgx3 = parcelRequire("3vgx3");


var $6TaGl = parcelRequire("6TaGl");


var $gC2EJ = parcelRequire("gC2EJ");


var $fHs3z = parcelRequire("fHs3z");


var $iDfTs = parcelRequire("iDfTs");


var $kTb7m = parcelRequire("kTb7m");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $5vi32 = parcelRequire("5vi32");


var $7aRa9 = parcelRequire("7aRa9");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $i1se2 = parcelRequire("i1se2");


var $cga1x = parcelRequire("cga1x");


var $eDBud = parcelRequire("eDBud");

const $d0a603587c38db5a$var$styles = {
    actionsContainer: "_v564wz4i _1o9zidpf _tzy4idpf _1mygkb7n",
    actionsContainerVisible: "_tzy4kb7n"
};
const $d0a603587c38db5a$var$messages = (0, $kSwu1.defineMessages)({
    moreActions: {
        id: "snippets.snippetMoreActions.moreActions",
        defaultMessage: "Block Templates actions"
    },
    edit: {
        id: "snippets.snippetMoreActions.edit",
        defaultMessage: "Edit"
    },
    duplicate: {
        id: "snippets.snippetMoreActions.duplicate",
        defaultMessage: "Duplicate"
    },
    delete: {
        id: "snippets.snippetMoreActions.delete",
        defaultMessage: "Delete"
    },
    share: {
        id: "snippets.snippetMoreActions.share",
        defaultMessage: "Copy share link"
    },
    shareSuccessFlagTitle: {
        id: "snippets.snippetMoreActions.shareSuccessFlagTitle",
        defaultMessage: "Link copied"
    },
    shareSuccessFlagDescription: {
        id: "snippets.snippetMoreActions.shareSuccessFlagDescription",
        defaultMessage: "Template share link copied to clipboard"
    }
});
const $d0a603587c38db5a$var$SnippetMoreActionsInner = (t0)=>{
    const $ = (0, $bDgLe.c)(59);
    const { analyticsOrigin: analyticsOrigin, snippet: snippet, isHovered: isHovered, onMenuOpenChange: onMenuOpenChange, contentId: t1, spaceId: t2, spaceKey: t3, flags: flags } = t0;
    const contentId = t1 === undefined ? "" : t1;
    const spaceId = t2 === undefined ? "" : t2;
    const spaceKey = t3 === undefined ? "" : t3;
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const [isMenuOpen, setIsMenuOpen] = (0, $cozmU.useState)(false);
    const intl = (0, $kSwu1.useIntl)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    let t4;
    if ($[0] !== analyticsOrigin || $[1] !== contentId || $[2] !== spaceId || $[3] !== spaceKey) {
        t4 = {
            analyticsOrigin: analyticsOrigin,
            contentId: contentId,
            spaceId: spaceId,
            spaceKey: spaceKey
        };
        $[0] = analyticsOrigin;
        $[1] = contentId;
        $[2] = spaceId;
        $[3] = spaceKey;
        $[4] = t4;
    } else t4 = $[4];
    const { handleEdit: handleEdit, handleDuplicate: handleDuplicate, handleDelete: handleDelete, handleShare: handleShare } = (0, $i1se2.useSnippetActionHandlers)(t4);
    const isOwnedByCurrentUser = snippet.scope === (0, $cga1x.SnippetScope).USER && userId === snippet.createdBy.accountId;
    let t5;
    if ($[5] !== isEmbeddedConfluence) {
        t5 = !isEmbeddedConfluence && (0, $6mKj3.expVal)("platform_editor_blocks_conf", "isEnabled", false);
        $[5] = isEmbeddedConfluence;
        $[6] = t5;
    } else t5 = $[6];
    const showShare = t5;
    let t6;
    if ($[7] !== onMenuOpenChange) {
        t6 = (t7)=>{
            const { isOpen: isOpen } = t7;
            setIsMenuOpen(isOpen);
            onMenuOpenChange?.(isOpen);
        };
        $[7] = onMenuOpenChange;
        $[8] = t6;
    } else t6 = $[8];
    const handleMenuOpenChange = t6;
    let t7;
    if ($[9] !== flags || $[10] !== handleShare || $[11] !== intl || $[12] !== snippet) {
        t7 = ()=>{
            handleShare(snippet).then((success)=>{
                if (success && flags) (0, $eDBud.showSnippetSuccessFlag)(flags, intl.formatMessage($d0a603587c38db5a$var$messages.shareSuccessFlagTitle), intl.formatMessage($d0a603587c38db5a$var$messages.shareSuccessFlagDescription));
            }).catch($d0a603587c38db5a$var$_temp);
        };
        $[9] = flags;
        $[10] = handleShare;
        $[11] = intl;
        $[12] = snippet;
        $[13] = t7;
    } else t7 = $[13];
    const onShareClick = t7;
    const t8 = `snippet-panel-actions-${snippet.snippetId}`;
    const t9 = (isHovered || isMenuOpen) && $d0a603587c38db5a$var$styles.actionsContainerVisible;
    let t10;
    if ($[14] !== t9) {
        t10 = (0, $w6R6I.cx)($d0a603587c38db5a$var$styles.actionsContainer, t9);
        $[14] = t9;
        $[15] = t10;
    } else t10 = $[15];
    const t11 = `snippet-ellipsis-menu-${snippet.snippetId}`;
    let t12;
    if ($[16] !== intl || $[17] !== isMenuOpen) {
        t12 = (t13)=>{
            const { triggerRef: triggerRef, ...props } = t13;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...props,
                label: intl.formatMessage($d0a603587c38db5a$var$messages.moreActions),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                ref: triggerRef,
                appearance: "subtle",
                "aria-expanded": isMenuOpen ? "true" : "false"
            });
        };
        $[16] = intl;
        $[17] = isMenuOpen;
        $[18] = t12;
    } else t12 = $[18];
    let t13;
    if ($[19] !== handleEdit || $[20] !== intl || $[21] !== isOwnedByCurrentUser || $[22] !== snippet) {
        t13 = isOwnedByCurrentUser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            onClick: ()=>handleEdit(snippet),
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
                label: intl.formatMessage($d0a603587c38db5a$var$messages.edit)
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $d0a603587c38db5a$var$messages.edit));
        $[19] = handleEdit;
        $[20] = intl;
        $[21] = isOwnedByCurrentUser;
        $[22] = snippet;
        $[23] = t13;
    } else t13 = $[23];
    let t14;
    if ($[24] !== intl || $[25] !== onShareClick || $[26] !== showShare) {
        t14 = showShare && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            onClick: onShareClick,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
                label: intl.formatMessage($d0a603587c38db5a$var$messages.share)
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $d0a603587c38db5a$var$messages.share));
        $[24] = intl;
        $[25] = onShareClick;
        $[26] = showShare;
        $[27] = t14;
    } else t14 = $[27];
    let t15;
    if ($[28] !== handleDuplicate || $[29] !== snippet) {
        t15 = ()=>handleDuplicate(snippet);
        $[28] = handleDuplicate;
        $[29] = snippet;
        $[30] = t15;
    } else t15 = $[30];
    let t16;
    if ($[31] !== intl) {
        t16 = intl.formatMessage($d0a603587c38db5a$var$messages.duplicate);
        $[31] = intl;
        $[32] = t16;
    } else t16 = $[32];
    let t17;
    if ($[33] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
            label: t16
        });
        $[33] = t16;
        $[34] = t17;
    } else t17 = $[34];
    let t18;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $d0a603587c38db5a$var$messages.duplicate);
        $[35] = t18;
    } else t18 = $[35];
    let t19;
    if ($[36] !== t15 || $[37] !== t17) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            onClick: t15,
            elemBefore: t17
        }, t18);
        $[36] = t15;
        $[37] = t17;
        $[38] = t19;
    } else t19 = $[38];
    let t20;
    if ($[39] !== handleDelete || $[40] !== intl || $[41] !== isOwnedByCurrentUser || $[42] !== snippet) {
        t20 = isOwnedByCurrentUser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            onClick: ()=>handleDelete(snippet),
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                label: intl.formatMessage($d0a603587c38db5a$var$messages.delete)
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $d0a603587c38db5a$var$messages.delete));
        $[39] = handleDelete;
        $[40] = intl;
        $[41] = isOwnedByCurrentUser;
        $[42] = snippet;
        $[43] = t20;
    } else t20 = $[43];
    let t21;
    if ($[44] !== t13 || $[45] !== t14 || $[46] !== t19 || $[47] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, t13, t14, t19, t20);
        $[44] = t13;
        $[45] = t14;
        $[46] = t19;
        $[47] = t20;
        $[48] = t21;
    } else t21 = $[48];
    let t22;
    if ($[49] !== handleMenuOpenChange || $[50] !== isMenuOpen || $[51] !== t11 || $[52] !== t12 || $[53] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            placement: "bottom-end",
            testId: t11,
            trigger: t12,
            appearance: "tall",
            isOpen: isMenuOpen,
            onOpenChange: handleMenuOpenChange
        }, t21);
        $[49] = handleMenuOpenChange;
        $[50] = isMenuOpen;
        $[51] = t11;
        $[52] = t12;
        $[53] = t21;
        $[54] = t22;
    } else t22 = $[54];
    let t23;
    if ($[55] !== t10 || $[56] !== t22 || $[57] !== t8) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            testId: t8,
            xcss: t10
        }, t22);
        $[55] = t10;
        $[56] = t22;
        $[57] = t8;
        $[58] = t23;
    } else t23 = $[58];
    return t23;
};
const $d0a603587c38db5a$export$ffd81b4fbf24c6dc = (0, $7aRa9.withFlags)($d0a603587c38db5a$var$SnippetMoreActionsInner);
function $d0a603587c38db5a$var$_temp() {}
module.exports["SnippetMoreActions"] = $d0a603587c38db5a$export$ffd81b4fbf24c6dc;

});

parcelRegister("i1se2", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4oS56 = parcelRequire("4oS56");


var $kfIha = parcelRequire("kfIha");


var $8aF6s = parcelRequire("8aF6s");


var $hPTbh = parcelRequire("hPTbh");


var $cQa7q = parcelRequire("cQa7q");


var $2q5ry = parcelRequire("2q5ry");


var $4lamI = parcelRequire("4lamI");


var $aUBmi = parcelRequire("aUBmi");


var $jxXkP = parcelRequire("jxXkP");

const $93b1aebccdc051cd$export$fffb2c8c8b22d965 = (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { analyticsOrigin: analyticsOrigin, contentId: t1, spaceId: t2, spaceKey: t3 } = t0;
    const contentId = t1 === undefined ? "" : t1;
    const spaceId = t2 === undefined ? "" : t2;
    const spaceKey = t3 === undefined ? "" : t3;
    const { fireButtonClickedAnalytic: fireButtonClickedAnalytic } = (0, $jxXkP.useSnippetAnalytics)(analyticsOrigin);
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { copyToClipboard: copyToClipboard } = (0, $kfIha.useCopyToClipboard)();
    const { editorAPI: editorAPI } = (0, $cozmU.useContext)((0, $4oS56.EditorContextPanelContext));
    let t4;
    if ($[0] !== contentId || $[1] !== editorAPI || $[2] !== fireButtonClickedAnalytic || $[3] !== showModal || $[4] !== spaceId || $[5] !== spaceKey) {
        t4 = (snippet)=>{
            fireButtonClickedAnalytic((0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).EDIT_SNIPPET, {
                snippetId: snippet.snippetId,
                scope: snippet.scope
            });
            showModal((0, $4lamI.EditSnippetModal), {
                snippet: snippet,
                editorAPI: editorAPI,
                contentId: contentId,
                spaceId: spaceId,
                spaceKey: spaceKey
            });
        };
        $[0] = contentId;
        $[1] = editorAPI;
        $[2] = fireButtonClickedAnalytic;
        $[3] = showModal;
        $[4] = spaceId;
        $[5] = spaceKey;
        $[6] = t4;
    } else t4 = $[6];
    const handleEdit = t4;
    let t5;
    if ($[7] !== analyticsOrigin || $[8] !== contentId || $[9] !== editorAPI || $[10] !== fireButtonClickedAnalytic || $[11] !== showModal || $[12] !== spaceId || $[13] !== spaceKey) {
        t5 = (snippet_0)=>{
            fireButtonClickedAnalytic((0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).DUPLICATE_SNIPPET, {
                snippetId: snippet_0.snippetId,
                scope: snippet_0.scope
            });
            showModal((0, $2q5ry.DuplicateSnippetModal), {
                snippet: snippet_0,
                editorAPI: editorAPI,
                contentId: contentId,
                spaceId: spaceId,
                spaceKey: spaceKey,
                analyticsOrigin: analyticsOrigin
            });
        };
        $[7] = analyticsOrigin;
        $[8] = contentId;
        $[9] = editorAPI;
        $[10] = fireButtonClickedAnalytic;
        $[11] = showModal;
        $[12] = spaceId;
        $[13] = spaceKey;
        $[14] = t5;
    } else t5 = $[14];
    const handleDuplicate = t5;
    let t6;
    if ($[15] !== editorAPI || $[16] !== fireButtonClickedAnalytic || $[17] !== showModal) {
        t6 = (snippet_1)=>{
            fireButtonClickedAnalytic((0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).DELETE_SNIPPET, {
                snippetId: snippet_1.snippetId,
                scope: snippet_1.scope
            });
            showModal((0, $cQa7q.DeleteSnippetModal), {
                snippet: snippet_1,
                editorAPI: editorAPI
            });
        };
        $[15] = editorAPI;
        $[16] = fireButtonClickedAnalytic;
        $[17] = showModal;
        $[18] = t6;
    } else t6 = $[18];
    const handleDelete = t6;
    let t7;
    if ($[19] !== copyToClipboard || $[20] !== fireButtonClickedAnalytic) {
        t7 = async (snippet_2)=>{
            fireButtonClickedAnalytic((0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).COPY_SNIPPET_LINK, {
                snippetId: snippet_2.snippetId,
                scope: snippet_2.scope,
                isShared: snippet_2.isShared
            });
            if (!snippet_2.shareUrl) {
                (0, $aUBmi.reportError)(new Error(`handleShare called without shareUrl for snippet ${snippet_2.snippetId}`));
                return false;
            }
            const fullUrl = typeof window !== "undefined" ? `${window.location.origin}${snippet_2.shareUrl}` : snippet_2.shareUrl;
            try {
                await copyToClipboard(fullUrl);
                return true;
            } catch  {
                return false;
            }
        };
        $[19] = copyToClipboard;
        $[20] = fireButtonClickedAnalytic;
        $[21] = t7;
    } else t7 = $[21];
    const handleShare = t7;
    let t8;
    if ($[22] !== handleDelete || $[23] !== handleDuplicate || $[24] !== handleEdit || $[25] !== handleShare) {
        t8 = {
            handleEdit: handleEdit,
            handleDuplicate: handleDuplicate,
            handleDelete: handleDelete,
            handleShare: handleShare
        };
        $[22] = handleDelete;
        $[23] = handleDuplicate;
        $[24] = handleEdit;
        $[25] = handleShare;
        $[26] = t8;
    } else t8 = $[26];
    return t8;
};
module.exports["useSnippetActionHandlers"] = $93b1aebccdc051cd$export$fffb2c8c8b22d965;

});

parcelRegister("cQa7q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7joZr = parcelRequire("7joZr");


var $ad7Ou = parcelRequire("ad7Ou");


var $cDs9S = parcelRequire("cDs9S");


var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $lsxnT = parcelRequire("lsxnT");


var $7aRa9 = parcelRequire("7aRa9");


var $hPTbh = parcelRequire("hPTbh");


var $jxXkP = parcelRequire("jxXkP");


var $dZUkS = parcelRequire("dZUkS");


var $64ncc = parcelRequire("64ncc");

const $629f1f7885b694b1$var$DeleteSnippetModalWithFlags = ({ snippet: snippet, onClose: onClose, onCloseComplete: onCloseComplete, flags: flags, editorAPI: editorAPI })=>{
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const titleId = (0, $cozmU.useId)();
    const intl = (0, $kSwu1.useIntl)();
    const { fireModalClosedAnalytic: fireModalClosedAnalytic, fireFailedAnalytic: fireFailedAnalytic } = (0, $jxXkP.useSnippetAnalytics)((0, $hPTbh.ANALYTICS_ORIGIN).DELETE_SNIPPET_MODAL);
    const snippetsActions = (0, $dZUkS.useSnippetsActions)();
    const [isDeleting, setIsDeleting] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(null);
    const handleCancel = ()=>{
        fireModalClosedAnalytic((0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).DELETE_SNIPPET, {
            snippetId: snippet.snippetId,
            outcome: (0, $hPTbh.MODAL_OUTCOME).CANCELLED
        });
        onClose();
    };
    const handleConfirm = async ()=>{
        setIsDeleting(true);
        setError(null);
        try {
            await snippetsActions.deleteSnippet(snippet.snippetId, {
                flags: flags,
                intl: intl,
                editorAPI: editorAPI ?? null
            });
            fireModalClosedAnalytic((0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).DELETE_SNIPPET, {
                snippetId: snippet.snippetId,
                outcome: (0, $hPTbh.MODAL_OUTCOME).DELETED
            });
            onClose();
        } catch (err) {
            setError(err instanceof Error ? err : new Error(String(err)));
            fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_DELETE, {
                snippetId: snippet.snippetId
            });
        } finally{
            setIsDeleting(false);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
        onClose: handleCancel,
        onCloseComplete: onCloseComplete
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        id: titleId,
        weight: "semibold",
        size: "large"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $64ncc.messages).deleteTemplateModalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cDs9S.CloseButton), {
        onClick: handleCancel
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $64ncc.messages).deleteTemplateModalBody)), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
        color: "color.text.danger",
        size: "small"
    }, error.message))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7joZr.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: handleCancel,
        isDisabled: isDeleting
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $64ncc.messages).deleteTemplateModalCancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "danger",
        onClick: handleConfirm,
        isLoading: isDeleting,
        isDisabled: isDeleting
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $64ncc.messages).deleteTemplateModalConfirmButton)))));
};
const $629f1f7885b694b1$export$424b6d728b5615c6 = (0, $7aRa9.withFlags)($629f1f7885b694b1$var$DeleteSnippetModalWithFlags);
module.exports["DeleteSnippetModal"] = $629f1f7885b694b1$export$424b6d728b5615c6;

});

parcelRegister("2q5ry", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7aRa9 = parcelRequire("7aRa9");


var $ies1q = parcelRequire("ies1q");


var $gUhOL = parcelRequire("gUhOL");


var $dZUkS = parcelRequire("dZUkS");


var $hPTbh = parcelRequire("hPTbh");


var $8yRiX = parcelRequire("8yRiX");


var $jxXkP = parcelRequire("jxXkP");


var $2u5FB = parcelRequire("2u5FB");


var $6K2yS = parcelRequire("6K2yS");


var $eWCeD = parcelRequire("eWCeD");


var $aNHzZ = parcelRequire("aNHzZ");


var $8JRDD = parcelRequire("8JRDD");


var $2hX8e = parcelRequire("2hX8e");

const $9b2db0b31b451eb0$var$DuplicateSnippetModalWithFlags = (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { snippet: snippet, onClose: onClose, onCloseComplete: onCloseComplete, contentId: contentId, spaceId: spaceId, spaceKey: spaceKey, flags: flags, editorAPI: editorAPI, analyticsOrigin: analyticsOrigin } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const openSnippetPanel = (0, $8yRiX.useOpenSnippetPanel)();
    const { isSnippetSharingForSiteEnabled: t1 } = (0, $dZUkS.useSnippetsState)();
    const isSnippetSharingForSiteEnabled = t1 === undefined ? false : t1;
    const snippetsActions = (0, $dZUkS.useSnippetsActions)();
    const { fireFailedAnalytic: fireFailedAnalytic, fireSuccessAnalytic: fireSuccessAnalytic } = (0, $jxXkP.useSnippetAnalytics)((0, $hPTbh.ANALYTICS_ORIGIN).DUPLICATE_SNIPPET_MODAL);
    const handleClose = (0, $8JRDD.useSnippetModalClose)(onClose, (0, $hPTbh.ANALYTICS_ORIGIN).DUPLICATE_SNIPPET_MODAL, (0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).DUPLICATE_SNIPPET);
    let T0;
    let t2;
    if ($[0] !== analyticsOrigin || $[1] !== contentId || $[2] !== editorAPI || $[3] !== fireFailedAnalytic || $[4] !== fireSuccessAnalytic || $[5] !== flags || $[6] !== handleClose || $[7] !== intl || $[8] !== isSnippetSharingForSiteEnabled || $[9] !== onCloseComplete || $[10] !== openSnippetPanel || $[11] !== snippet.body || $[12] !== snippet.description || $[13] !== snippet.name || $[14] !== snippet.scope || $[15] !== snippet.snippetId || $[16] !== snippetsActions || $[17] !== spaceId || $[18] !== spaceKey) {
        const baseValues = (0, $aNHzZ.getDefaultFormValues)(isSnippetSharingForSiteEnabled);
        const suggestedName = (0, $gUhOL.getSuggestedDuplicateName)(snippet.name ?? "");
        const defaultValues = {
            ...baseValues,
            snippetName: suggestedName,
            snippetDescription: snippet.description ?? ""
        };
        const initialAdf = (0, $ies1q.wrapAdfWithDocNode)(snippet?.body);
        const formKey = `duplicate-${snippet.snippetId}`;
        const title = intl.formatMessage((0, $2hX8e.duplicateSnippetModalMessages).titleDuplicate, {
            snippetName: snippet.name ?? ""
        });
        const submitLabel = intl.formatMessage((0, $2hX8e.duplicateSnippetModalMessages).duplicateButton);
        const successFlagActions = analyticsOrigin === (0, $hPTbh.ANALYTICS_ORIGIN).SNIPPET_GALLERY ? undefined : [
            {
                content: intl.formatMessage((0, $6K2yS.messages).successFlagViewTemplateAction),
                onClick: openSnippetPanel
            }
        ];
        const onSubmit = async (values, currentAdf)=>{
            const bodySize = JSON.stringify(currentAdf).length;
            const duplicatedSnippet = await snippetsActions.createSnippet(values.snippetName, currentAdf, values.snippetDescription, {
                flags: flags,
                intl: intl,
                editorAPI: editorAPI ?? undefined,
                isShared: values.isShared,
                successFlagActions: successFlagActions,
                onShareFailure: (snippetId)=>fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_SHARE, {
                        snippetId: snippetId
                    }),
                onSaveFailure: (error)=>{
                    const isBodyTooLarge = (0, $eWCeD.isBodyTooLargeError)(error);
                    fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_DUPLICATE, {
                        snippetId: snippet.snippetId,
                        ...isBodyTooLarge && {
                            isBodyTooLarge: true,
                            bodySize: bodySize
                        }
                    });
                },
                messages: {
                    successFlagTitle: (0, $2hX8e.duplicateSnippetModalMessages).duplicateSuccessFlagTitle,
                    errorFlagTitle: (0, $2hX8e.duplicateSnippetModalMessages).duplicateErrorFlagTitle,
                    errorFlagDescription: (0, $2hX8e.duplicateSnippetModalMessages).duplicateErrorFlagDescription
                }
            });
            if (duplicatedSnippet) {
                fireSuccessAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_SAVE_SUCCESS, {
                    snippetId: duplicatedSnippet.snippetId,
                    bodySize: bodySize,
                    modalType: (0, $hPTbh.MODAL_TYPE).DUPLICATE
                });
                handleClose({
                    outcome: (0, $hPTbh.MODAL_OUTCOME).DUPLICATED,
                    snippetId: duplicatedSnippet.snippetId
                });
            }
        };
        T0 = (0, $2u5FB.SnippetBaseModal);
        t2 = (0, $2u5FB.getSnippetBaseModalProps)({
            title: title,
            submitLabel: submitLabel,
            formKey: formKey,
            defaultValues: defaultValues,
            initialAdf: initialAdf,
            onSubmit: onSubmit,
            handleClose: handleClose,
            fireFailedAnalytic: fireFailedAnalytic,
            onCloseComplete: onCloseComplete,
            contentId: contentId,
            spaceId: spaceId,
            spaceKey: spaceKey,
            snippetId: snippet.snippetId,
            snippetScope: snippet.scope,
            isSnippetSharingForSiteEnabled: isSnippetSharingForSiteEnabled
        });
        $[0] = analyticsOrigin;
        $[1] = contentId;
        $[2] = editorAPI;
        $[3] = fireFailedAnalytic;
        $[4] = fireSuccessAnalytic;
        $[5] = flags;
        $[6] = handleClose;
        $[7] = intl;
        $[8] = isSnippetSharingForSiteEnabled;
        $[9] = onCloseComplete;
        $[10] = openSnippetPanel;
        $[11] = snippet.body;
        $[12] = snippet.description;
        $[13] = snippet.name;
        $[14] = snippet.scope;
        $[15] = snippet.snippetId;
        $[16] = snippetsActions;
        $[17] = spaceId;
        $[18] = spaceKey;
        $[19] = T0;
        $[20] = t2;
    } else {
        T0 = $[19];
        t2 = $[20];
    }
    let t3;
    if ($[21] !== T0 || $[22] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, t2);
        $[21] = T0;
        $[22] = t2;
        $[23] = t3;
    } else t3 = $[23];
    return t3;
};
const $9b2db0b31b451eb0$export$e422d2665be90f85 = (0, $7aRa9.withFlags)($9b2db0b31b451eb0$var$DuplicateSnippetModalWithFlags);
module.exports["DuplicateSnippetModal"] = $9b2db0b31b451eb0$export$e422d2665be90f85;

});

parcelRegister("gUhOL", function(module, exports) {
/**
 * Returns a suggested name for a duplicated snippet.
 * - If currentName ends with optional space(s) + number (e.g. "Snippet 2", "Snippet 10"), increment the number (e.g. "Snippet 3").
 * - Otherwise append " 2" so the next duplicate will fall under the first case.
 */ const $15e4b6093fd907e1$export$77a98a67f1bd093c = (currentName)=>{
    const trimmed = currentName.trim();
    if (!trimmed) // If the name is empty, leave as is
    return currentName;
    // Match "prefix" + space(s) + trailing number (e.g. "Snippet 2")
    const match = trimmed.match(/^(.+?)\s+(\d+)$/);
    if (match) {
        const prefix = match[1];
        const num = match[2];
        return `${prefix} ${parseInt(num, 10) + 1}`;
    }
    return `${trimmed} 2`;
};
module.exports["getSuggestedDuplicateName"] = $15e4b6093fd907e1$export$77a98a67f1bd093c;

});

parcelRegister("2hX8e", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $917224bcae6dc304$export$cf4d37474cc90563 = (0, $kSwu1.defineMessages)({
    titleDuplicate: {
        id: "snippets.snippetEditorModal.titleDuplicate",
        defaultMessage: "Create duplicate of {snippetName}"
    },
    duplicateButton: {
        id: "snippets.snippetEditorModal.duplicateButton",
        defaultMessage: "Duplicate"
    },
    duplicateSuccessFlagTitle: {
        id: "snippets.snippetEditorModal.duplicateSuccessFlagTitle",
        defaultMessage: "Template \"{snippetName}\" duplicated"
    },
    duplicateErrorFlagTitle: {
        id: "snippets.snippetEditorModal.duplicateErrorFlagTitle",
        defaultMessage: "Could not duplicate the template"
    },
    duplicateErrorFlagDescription: {
        id: "snippets.snippetEditorModal.duplicateErrorFlagDescription",
        defaultMessage: "Please try again"
    }
});
module.exports["duplicateSnippetModalMessages"] = $917224bcae6dc304$export$cf4d37474cc90563;

});

parcelRegister("4lamI", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kz1Yj = parcelRequire("kz1Yj");


var $7aRa9 = parcelRequire("7aRa9");


var $ies1q = parcelRequire("ies1q");


var $dZUkS = parcelRequire("dZUkS");


var $hPTbh = parcelRequire("hPTbh");


var $jxXkP = parcelRequire("jxXkP");


var $eWCeD = parcelRequire("eWCeD");


var $8JRDD = parcelRequire("8JRDD");


var $2u5FB = parcelRequire("2u5FB");


var $giat8 = parcelRequire("giat8");


var $aNHzZ = parcelRequire("aNHzZ");


var $8pLNp = parcelRequire("8pLNp");

const $b954cfb60a1110d7$var$EditSnippetModalWithFlags = (t0)=>{
    const $ = (0, $bDgLe.c)(36);
    const { snippet: snippet, onClose: onClose, onCloseComplete: onCloseComplete, contentId: contentId, spaceId: spaceId, spaceKey: spaceKey, flags: flags, editorAPI: editorAPI } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const { isSnippetSharingForSiteEnabled: t1 } = (0, $dZUkS.useSnippetsState)();
    const isSnippetSharingForSiteEnabled = t1 === undefined ? false : t1;
    const snippetsActions = (0, $dZUkS.useSnippetsActions)();
    const { fireFailedAnalytic: fireFailedAnalytic, fireSuccessAnalytic: fireSuccessAnalytic } = (0, $jxXkP.useSnippetAnalytics)((0, $hPTbh.ANALYTICS_ORIGIN).EDIT_SNIPPET_MODAL);
    const handleClose = (0, $8JRDD.useSnippetModalClose)(onClose, (0, $hPTbh.ANALYTICS_ORIGIN).EDIT_SNIPPET_MODAL, (0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).EDIT_SNIPPET);
    let T0;
    let t2;
    if ($[0] !== contentId || $[1] !== editorAPI || $[2] !== fireFailedAnalytic || $[3] !== fireSuccessAnalytic || $[4] !== flags || $[5] !== handleClose || $[6] !== intl || $[7] !== isSnippetSharingForSiteEnabled || $[8] !== onCloseComplete || $[9] !== snippet.body || $[10] !== snippet.description || $[11] !== snippet.isShared || $[12] !== snippet.name || $[13] !== snippet.scope || $[14] !== snippet.shareUrl || $[15] !== snippet.snippetId || $[16] !== snippetsActions || $[17] !== spaceId || $[18] !== spaceKey) {
        const baseValues = (0, $aNHzZ.getDefaultFormValues)(isSnippetSharingForSiteEnabled);
        const defaultValues = {
            ...baseValues,
            snippetName: snippet.name ?? "",
            snippetDescription: snippet.description ?? "",
            ...isSnippetSharingForSiteEnabled && {
                isShared: snippet.isShared ?? false
            }
        };
        const initialAdf = (0, $ies1q.wrapAdfWithDocNode)(snippet?.body);
        const formKey = `edit-${snippet.snippetId}`;
        const title = intl.formatMessage((0, $8pLNp.editSnippetModalMessages).titleEdit);
        const submitLabel = intl.formatMessage((0, $8pLNp.editSnippetModalMessages).saveButton);
        let t3;
        if ($[21] !== editorAPI || $[22] !== fireFailedAnalytic || $[23] !== fireSuccessAnalytic || $[24] !== flags || $[25] !== handleClose || $[26] !== intl || $[27] !== snippet.isShared || $[28] !== snippet.snippetId || $[29] !== snippetsActions) {
            t3 = async (values, currentAdf)=>{
                const bodySize = JSON.stringify(currentAdf).length;
                const updatedSnippet = await snippetsActions.updateSnippet(snippet.snippetId, values.snippetName, currentAdf, values.snippetDescription, {
                    flags: flags,
                    intl: intl,
                    editorAPI: editorAPI ?? undefined,
                    isShared: values.isShared ?? false,
                    previousIsShared: snippet.isShared ?? false,
                    onShareFailure: (snippetId)=>fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_SHARE, {
                            snippetId: snippetId
                        }),
                    onUnshareFailure: (snippetId_0)=>fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_UNSHARE, {
                            snippetId: snippetId_0
                        }),
                    onSaveFailure: (error)=>{
                        const isBodyTooLarge = (0, $eWCeD.isBodyTooLargeError)(error);
                        fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_UPDATE, {
                            snippetId: snippet.snippetId,
                            ...isBodyTooLarge && {
                                isBodyTooLarge: true,
                                bodySize: bodySize
                            }
                        });
                    }
                });
                if (updatedSnippet) {
                    fireSuccessAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_API_SAVE_SUCCESS, {
                        snippetId: updatedSnippet.snippetId,
                        bodySize: bodySize,
                        modalType: (0, $hPTbh.MODAL_TYPE).EDIT
                    });
                    handleClose({
                        outcome: (0, $hPTbh.MODAL_OUTCOME).EDITED,
                        snippetId: updatedSnippet.snippetId
                    });
                }
            };
            $[21] = editorAPI;
            $[22] = fireFailedAnalytic;
            $[23] = fireSuccessAnalytic;
            $[24] = flags;
            $[25] = handleClose;
            $[26] = intl;
            $[27] = snippet.isShared;
            $[28] = snippet.snippetId;
            $[29] = snippetsActions;
            $[30] = t3;
        } else t3 = $[30];
        const onSubmit = t3;
        T0 = (0, $2u5FB.SnippetBaseModal);
        let t4;
        if ($[31] !== snippet.shareUrl) {
            t4 = snippet.shareUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
                alignInline: "end"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $giat8.SnippetShareButton), {
                shareUrl: snippet.shareUrl
            })) : undefined;
            $[31] = snippet.shareUrl;
            $[32] = t4;
        } else t4 = $[32];
        t2 = (0, $2u5FB.getSnippetBaseModalProps)({
            title: title,
            submitLabel: submitLabel,
            formKey: formKey,
            defaultValues: defaultValues,
            initialAdf: initialAdf,
            onSubmit: onSubmit,
            handleClose: handleClose,
            fireFailedAnalytic: fireFailedAnalytic,
            onCloseComplete: onCloseComplete,
            contentId: contentId,
            spaceId: spaceId,
            spaceKey: spaceKey,
            snippetId: snippet.snippetId,
            snippetScope: snippet.scope,
            isSnippetSharingForSiteEnabled: isSnippetSharingForSiteEnabled,
            extraActions: t4
        });
        $[0] = contentId;
        $[1] = editorAPI;
        $[2] = fireFailedAnalytic;
        $[3] = fireSuccessAnalytic;
        $[4] = flags;
        $[5] = handleClose;
        $[6] = intl;
        $[7] = isSnippetSharingForSiteEnabled;
        $[8] = onCloseComplete;
        $[9] = snippet.body;
        $[10] = snippet.description;
        $[11] = snippet.isShared;
        $[12] = snippet.name;
        $[13] = snippet.scope;
        $[14] = snippet.shareUrl;
        $[15] = snippet.snippetId;
        $[16] = snippetsActions;
        $[17] = spaceId;
        $[18] = spaceKey;
        $[19] = T0;
        $[20] = t2;
    } else {
        T0 = $[19];
        t2 = $[20];
    }
    let t3;
    if ($[33] !== T0 || $[34] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, t2);
        $[33] = T0;
        $[34] = t2;
        $[35] = t3;
    } else t3 = $[35];
    return t3;
};
const $b954cfb60a1110d7$export$41655ea7501ab119 = (0, $7aRa9.withFlags)($b954cfb60a1110d7$var$EditSnippetModalWithFlags);
module.exports["EditSnippetModal"] = $b954cfb60a1110d7$export$41655ea7501ab119;

});

parcelRegister("giat8", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $kTb7m = parcelRequire("kTb7m");


var $7aRa9 = parcelRequire("7aRa9");


var $kfIha = parcelRequire("kfIha");


var $eDBud = parcelRequire("eDBud");

const $b7f5fd7e4ee08804$var$messages = (0, $kSwu1.defineMessages)({
    label: {
        id: "snippets.snippetShareButton.label",
        defaultMessage: "Copy share link"
    },
    successTitle: {
        id: "snippets.snippetShareButton.successTitle",
        defaultMessage: "Link copied"
    },
    successDescription: {
        id: "snippets.snippetShareButton.successDescription",
        defaultMessage: "Template share link copied to clipboard"
    },
    errorTitle: {
        id: "snippets.snippetShareButton.errorTitle",
        defaultMessage: "Failed to copy link"
    }
});
const $b7f5fd7e4ee08804$var$SnippetShareButtonInner = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { shareUrl: shareUrl, flags: flags } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const { copyToClipboard: copyToClipboard } = (0, $kfIha.useCopyToClipboard)();
    let t1;
    if ($[0] !== copyToClipboard || $[1] !== flags || $[2] !== intl || $[3] !== shareUrl) {
        t1 = async ()=>{
            const origin = window?.location?.origin ?? "";
            const fullUrl = `${origin}${shareUrl}`;
            try {
                await copyToClipboard(fullUrl);
                (0, $eDBud.showSnippetSuccessFlag)(flags, intl.formatMessage($b7f5fd7e4ee08804$var$messages.successTitle), intl.formatMessage($b7f5fd7e4ee08804$var$messages.successDescription));
            } catch  {
                (0, $eDBud.showSnippetErrorFlag)(flags, intl.formatMessage($b7f5fd7e4ee08804$var$messages.errorTitle));
            }
        };
        $[0] = copyToClipboard;
        $[1] = flags;
        $[2] = intl;
        $[3] = shareUrl;
        $[4] = t1;
    } else t1 = $[4];
    const handleClick = t1;
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $b7f5fd7e4ee08804$var$messages.label);
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== handleClick) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            appearance: "subtle",
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))),
            onClick: handleClick
        }, t2);
        $[6] = handleClick;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
const $b7f5fd7e4ee08804$export$ebcbef2342efbe50 = (0, $7aRa9.withFlags)($b7f5fd7e4ee08804$var$SnippetShareButtonInner);
module.exports["SnippetShareButton"] = $b7f5fd7e4ee08804$export$ebcbef2342efbe50;

});

parcelRegister("6ATU7", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $arQY7 = parcelRequire("arQY7");


var $NlHoa = parcelRequire("NlHoa");


var $buwvF = parcelRequire("buwvF");

const $45571a049f068e4f$export$f810e9b80d91f804 = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { snippetOwner: snippetOwner } = t0;
    const shouldUseAtlassianIcon = snippetOwner.accountId.toLowerCase() === (0, $buwvF.ATLASSIAN_ACCOUNT_ID).toLowerCase();
    if (shouldUseAtlassianIcon) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                appearance: "brand",
                size: "xsmall"
            });
            $[0] = t1;
        } else t1 = $[0];
        return t1;
    }
    const t1 = snippetOwner;
    let t2;
    if ($[1] !== snippetOwner.displayName || $[2] !== t1.avatarUrl) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            appearance: "circle",
            size: "xsmall",
            src: t1.avatarUrl,
            name: snippetOwner.displayName
        });
        $[1] = snippetOwner.displayName;
        $[2] = t1.avatarUrl;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};
module.exports["SnippetCreatedByAvatar"] = $45571a049f068e4f$export$f810e9b80d91f804;

});

parcelRegister("f3452", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $lbT4j = parcelRequire("lbT4j");


var $6Cex3 = parcelRequire("6Cex3");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $1sCHt = parcelRequire("1sCHt");


var $7aRa9 = parcelRequire("7aRa9");


var $hPTbh = parcelRequire("hPTbh");


var $jxXkP = parcelRequire("jxXkP");


var $dZUkS = parcelRequire("dZUkS");

const $3ef50e7a99bc3ef5$var$styles = {
    container: "_v564wz4i _1o9zidpf _tzy4idpf _1mygkb7n",
    containerVisible: "_tzy4kb7n"
};
const $3ef50e7a99bc3ef5$var$messages = (0, $kSwu1.defineMessages)({
    favoritedLabel: {
        id: "snippets.snippetFavoriteButton.favoritedLabel",
        defaultMessage: "Unfavorite Snippet"
    },
    unfavoritedLabel: {
        id: "snippets.snippetFavoriteButton.unfavoritedLabel",
        defaultMessage: "Favorite Snippet"
    }
});
const $3ef50e7a99bc3ef5$var$SnippetFavoriteButtonInner = (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { analyticsOrigin: analyticsOrigin, snippet: snippet, isHovered: isHovered, flags: flags } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const { fireButtonClickedAnalytic: fireButtonClickedAnalytic, fireFailedAnalytic: fireFailedAnalytic } = (0, $jxXkP.useSnippetAnalytics)(analyticsOrigin);
    const snippetsActions = (0, $dZUkS.useSnippetsActions)();
    const shouldShowIcon = snippet.isFavorite || isHovered;
    let t1;
    if ($[0] !== flags || $[1] !== intl) {
        t1 = {
            intl: intl,
            flags: flags
        };
        $[0] = flags;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    const options = t1;
    let t2;
    if ($[3] !== fireButtonClickedAnalytic || $[4] !== fireFailedAnalytic || $[5] !== options || $[6] !== snippet.scope || $[7] !== snippet.snippetId || $[8] !== snippetsActions) {
        t2 = async (isFavoriteAfterToggle)=>{
            const action = isFavoriteAfterToggle ? snippetsActions.favoriteSnippet(snippet.snippetId, options) : snippetsActions.unfavoriteSnippet(snippet.snippetId, options);
            const success = await action;
            if (success) fireButtonClickedAnalytic((0, $hPTbh.ANALYTICS_UI_SUBJECT_ID).SNIPPET_FAVORITE_TOGGLED, {
                snippetId: snippet.snippetId,
                scope: snippet.scope,
                isFavoriteAfterToggle: isFavoriteAfterToggle
            });
            else fireFailedAnalytic((0, $hPTbh.ANALYTICS_OPERATIONAL_SUBJECT).SNIPPET_FAVORITE_TOGGLED, {
                snippetId: snippet.snippetId,
                scope: snippet.scope,
                isFavoriteAfterToggle: isFavoriteAfterToggle
            });
        };
        $[3] = fireButtonClickedAnalytic;
        $[4] = fireFailedAnalytic;
        $[5] = options;
        $[6] = snippet.scope;
        $[7] = snippet.snippetId;
        $[8] = snippetsActions;
        $[9] = t2;
    } else t2 = $[9];
    const handleFavoriteToggle = t2;
    const t3 = shouldShowIcon && $3ef50e7a99bc3ef5$var$styles.containerVisible;
    let t4;
    if ($[10] !== t3) {
        t4 = (0, $w6R6I.cx)($3ef50e7a99bc3ef5$var$styles.container, t3);
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== handleFavoriteToggle || $[13] !== intl || $[14] !== snippet.isFavorite) {
        t5 = snippet.isFavorite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            label: intl.formatMessage($3ef50e7a99bc3ef5$var$messages.favoritedLabel),
            icon: $3ef50e7a99bc3ef5$var$_temp,
            appearance: "subtle",
            onClick: ()=>handleFavoriteToggle(false)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            label: intl.formatMessage($3ef50e7a99bc3ef5$var$messages.unfavoritedLabel),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))),
            appearance: "subtle",
            onClick: ()=>handleFavoriteToggle(true)
        });
        $[12] = handleFavoriteToggle;
        $[13] = intl;
        $[14] = snippet.isFavorite;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== t4 || $[17] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: t4
        }, t5);
        $[16] = t4;
        $[17] = t5;
        $[18] = t6;
    } else t6 = $[18];
    return t6;
};
const $3ef50e7a99bc3ef5$export$d2c6bb946e52cf45 = (0, $7aRa9.withFlags)($3ef50e7a99bc3ef5$var$SnippetFavoriteButtonInner);
function $3ef50e7a99bc3ef5$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
        ...iconProps,
        color: "var(--ds-icon-accent-orange, #E06C00)",
        label: ""
    });
}
module.exports["SnippetFavoriteButton"] = $3ef50e7a99bc3ef5$export$d2c6bb946e52cf45;

});

parcelRegister("dh4hm", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4aRua = parcelRequire("4aRua");


var $jffWD = parcelRequire("jffWD");


var $2KKxv = parcelRequire("2KKxv");

const $2f79b005d1f01fd2$export$383d22f5717d5eaf = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { snippet: snippet } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== snippet) {
        t1 = (0, $jffWD.shouldShowInsertCount)(snippet);
        $[0] = snippet;
        $[1] = t1;
    } else t1 = $[1];
    const showUsage = t1;
    let t2;
    if ($[2] !== snippet) {
        t2 = (0, $jffWD.shouldShowPrivateLabel)(snippet);
        $[2] = snippet;
        $[3] = t2;
    } else t2 = $[3];
    const showPrivate = t2;
    if (!(0, $jffWD.shouldShowUsageAndPrivateLabels)(snippet)) return null;
    let t3;
    if ($[4] !== intl || $[5] !== showUsage || $[6] !== snippet) {
        t3 = showUsage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            size: "small",
            color: "color.text.subtle"
        }, intl.formatMessage((0, $2KKxv.snippetUsageMessages).snippetUses, {
            formattedCount: (0, $jffWD.formatInsertCount)(snippet.insertCount),
            count: snippet.insertCount
        }));
        $[4] = intl;
        $[5] = showUsage;
        $[6] = snippet;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== showPrivate) {
        t4 = showPrivate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
            size: "small",
            color: "color.text.subtle"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $2KKxv.snippetUsageMessages).privateLabel));
        $[8] = showPrivate;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t3, t4);
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
};
module.exports["SnippetUsageAndPrivateLabels"] = $2f79b005d1f01fd2$export$383d22f5717d5eaf;

});

parcelRegister("jffWD", function(module, exports) {

var $cga1x = parcelRequire("cga1x");

const $4cb26235b23f04cc$export$b0602077fff33843 = (count)=>{
    if (count >= 1000000) {
        const millions = count / 1000000;
        const isWholeNumber = millions % 1 === 0;
        const usageValue = isWholeNumber ? millions.toFixed(0) : millions.toFixed(1);
        return `${usageValue}M`;
    }
    if (count >= 1000) {
        const thousands = count / 1000;
        const isWholeNumber = thousands % 1 === 0;
        const usageValue = isWholeNumber ? thousands.toFixed(0) : thousands.toFixed(1);
        return `${usageValue}K`;
    }
    return String(count);
};
const $4cb26235b23f04cc$export$8d9d303a9f76663f = (snippet)=>(snippet.scope === (0, $cga1x.SnippetScope).SITE || snippet.scope === (0, $cga1x.SnippetScope).GLOBAL) && snippet.insertCount !== undefined && snippet.insertCount > 0;
const $4cb26235b23f04cc$export$4b83df82273b7011 = (snippet)=>snippet.scope === (0, $cga1x.SnippetScope).USER && !snippet.isShared;
const $4cb26235b23f04cc$export$80cf235cc92bffd4 = (snippet)=>$4cb26235b23f04cc$export$8d9d303a9f76663f(snippet) || $4cb26235b23f04cc$export$4b83df82273b7011(snippet);
module.exports["formatInsertCount"] = $4cb26235b23f04cc$export$b0602077fff33843;
module.exports["shouldShowInsertCount"] = $4cb26235b23f04cc$export$8d9d303a9f76663f;
module.exports["shouldShowPrivateLabel"] = $4cb26235b23f04cc$export$4b83df82273b7011;
module.exports["shouldShowUsageAndPrivateLabels"] = $4cb26235b23f04cc$export$80cf235cc92bffd4;

});

parcelRegister("2KKxv", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $5cdcffa8a3d87054$export$1bcb279c0c86be26 = (0, $kSwu1.defineMessages)({
    snippetUses: {
        id: "snippets.common.usage.uses",
        defaultMessage: "{formattedCount} {count, plural, one {Use} other {Uses}}"
    },
    privateLabel: {
        id: "snippets.common.usage.private",
        defaultMessage: "Private"
    }
});
module.exports["snippetUsageMessages"] = $5cdcffa8a3d87054$export$1bcb279c0c86be26;

});

parcelRegister("4tTm9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $irVI7 = parcelRequire("irVI7");


var $8Ss4E = parcelRequire("8Ss4E");


var $kbVzJ = parcelRequire("kbVzJ");


var $aUTn5 = parcelRequire("aUTn5");


var $cZa7r = parcelRequire("cZa7r");


var $24amZ = parcelRequire("24amZ");

var $l2hqi = parcelRequire("l2hqi");


var $3jwuS = parcelRequire("3jwuS");


var $afGoD = parcelRequire("afGoD");


var $bQm3c = parcelRequire("bQm3c");


var $8Mzkb = parcelRequire("8Mzkb");

const $1d207411f43b18d4$export$a9a76753cd947d5c = ({ pageId: pageId, onCreate: onCreate, onCreateError: onCreateError, onClose: onClose, dom: selectionElement, textSelection: textSelection, inlineNodeTypes: inlineNodeTypes, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar = false, closeObjectSidebar: closeObjectSidebar, isOffline: isOffline })=>{
    const { editorCreateProps: editorCreateProps } = (0, $cZa7r.useAnnotations)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const editorNode = (0, $cozmU.useRef)(null);
    const indexFound = (0, $cozmU.useRef)(0);
    const textMatches = (0, $cozmU.useRef)(0);
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // Required to close the sidebar once we create a new standalone comment
    (0, $cozmU.useEffect)(()=>{
        closeObjectSidebar && editorCreateProps && closeObjectSidebar();
    }, [
        closeObjectSidebar,
        editorCreateProps
    ]);
    (0, $cozmU.useEffect)(()=>{
        (0, $8Ss4E.startEditorExperiences)({
            name: (0, $irVI7.ADD_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                mode: isLivePage ? (0, $l2hqi.InlineCommentMode).LIVE : (0, $l2hqi.InlineCommentMode).EDIT,
                framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER,
                edition: edition
            }
        }, {
            name: (0, $irVI7.ADD_INLINE_COMMENT_LOAD_EXPERIENCE)
        }, {
            name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE)
        });
        // both editor and inline comment sidebar share the same class, target the element that isn't the sidebar
        const editorNodes = Array.from(document.querySelectorAll('.ak-editor-content-area > .ProseMirror'));
        if (editorNodes.length) {
            const foundEditorNode = editorNodes.find((element)=>!element.closest('#editor-create-sidebar'));
            if (foundEditorNode) editorNode.current = foundEditorNode;
        }
        if (selectionElement && editorNode.current && textSelection) {
            const ignoredNodes = Array.from(editorNode.current.querySelectorAll((0, $aUTn5.IGNORE_SELECTORS)));
            const { text: text, nodesStartPos: nodesStartPos, nodes: nodes } = (0, $kbVzJ.indexTextNodes)(editorNode.current, ignoredNodes);
            const { index: index, numMatches: numMatches } = (0, $kbVzJ.findMatches)(text, textSelection, // we prefer the TextNode rather than <p> or headings
            selectionElement.parentNode ? selectionElement.parentNode : selectionElement, // default to 0 since the Editor wraps the selection in a <span> now
            0, nodesStartPos, nodes);
            indexFound.current = index;
            textMatches.current = numMatches;
        }
    }, [
        edition,
        selectionElement,
        textSelection,
        isLivePage,
        pageId,
        closeObjectSidebar,
        createAnalyticsEvent,
        editorCreateProps
    ]);
    const selectionOptions = (0, $cozmU.useMemo)(()=>({
            originalSelection: textSelection,
            numMatches: textMatches.current,
            matchIndex: indexFound.current,
            inlineNodeTypes: inlineNodeTypes,
            createdFrom: isLivePage ? (0, $afGoD.CommentCreationLocation).LIVE : (0, $afGoD.CommentCreationLocation).EDITOR
        }), [
        textSelection,
        textMatches,
        indexFound,
        isLivePage,
        inlineNodeTypes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Mzkb.CreateComment), {
        pageId: pageId,
        annotationElement: selectionElement,
        selectionOptions: selectionOptions,
        onClose: onClose,
        onCreate: onCreate,
        onCreateError: onCreateError,
        isEditor: true,
        isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
        isOffline: isOffline
    });
};
module.exports["CreateComponent"] = $1d207411f43b18d4$export$a9a76753cd947d5c;

});

parcelRegister("8Mzkb", function(module, exports) {

var $9dDPb = parcelRequire("9dDPb");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $kyKWe = parcelRequire("kyKWe");


var $iMnC5 = parcelRequire("iMnC5");


var $9DHhW = parcelRequire("9DHhW");


var $koEBx = parcelRequire("koEBx");


var $308Wd = parcelRequire("308Wd");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $3YBks = parcelRequire("3YBks");


var $8Ss4E = parcelRequire("8Ss4E");


var $gtj7V = parcelRequire("gtj7V");


var $aJPUt = parcelRequire("aJPUt");


var $aGjYc = parcelRequire("aGjYc");


var $hXzKU = parcelRequire("hXzKU");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $bSvtO = parcelRequire("bSvtO");


var $emtVP = parcelRequire("emtVP");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $cAdj8 = parcelRequire("cAdj8");


var $kmHPt = parcelRequire("kmHPt");


var $daq5m = parcelRequire("daq5m");


var $dLr6w = parcelRequire("dLr6w");


var $isdzP = parcelRequire("isdzP");


var $6cWI7 = parcelRequire("6cWI7");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $9CnRS = parcelRequire("9CnRS");


var $aMfLn = parcelRequire("aMfLn");


var $9QIM2 = parcelRequire("9QIM2");


var $3Xfi8 = parcelRequire("3Xfi8");


var $eA7s6 = parcelRequire("eA7s6");


var $k8e76 = parcelRequire("k8e76");


var $56QzY = parcelRequire("56QzY");


var $fqIt3 = parcelRequire("fqIt3");


var $8i27m = parcelRequire("8i27m");


var $9wGTI = parcelRequire("9wGTI");


var $ep3mz = parcelRequire("ep3mz");


var $hl0fg = parcelRequire("hl0fg");


var $7aRa9 = parcelRequire("7aRa9");


var $5pQ1Y = parcelRequire("5pQ1Y");


var $en1dX = parcelRequire("en1dX");


var $9FoVw = parcelRequire("9FoVw");


var $6tkbf = parcelRequire("6tkbf");


var $lFkRf = parcelRequire("lFkRf");


var $5fMeR = parcelRequire("5fMeR");


var $3mVfX = parcelRequire("3mVfX");


var $6mKj3 = parcelRequire("6mKj3");


var $gurMq = parcelRequire("gurMq");


var $4rKYp = parcelRequire("4rKYp");


var $b0EGa = parcelRequire("b0EGa");


var $a3q17 = parcelRequire("a3q17");


var $B3Avz = parcelRequire("B3Avz");

const $f4c77c6e390a7914$export$d26c1daa0321174b = (0, $aJPUt.ExperienceTimeout).CREATE_COMMENT_PUBLISH;
const $f4c77c6e390a7914$var$relativeFilePath = 'annotation-provider-inline-comments/CreateComment';
const $f4c77c6e390a7914$var$i18n = (0, $kSwu1.defineMessages)({
    unableToApplyTitle: {
        id: "annotation-provider-inline-comments.create.error.unable.to.apply.title",
        defaultMessage: "Something went wrong"
    },
    unableToApplyDescription: {
        id: "annotation-provider-inline-comments.create.error.unable.to.apply.description",
        defaultMessage: "We failed to display your comment. To view it, refresh now."
    },
    unableToApplyOptimistically: {
        id: "annotation-provider-inline-comments.create.error.unable.to.apply.annotation.optimistically",
        defaultMessage: "We were unable to apply your comment to the document. Comment is not saved. Please refresh and try again."
    },
    refreshContentLink: {
        id: "annotation-provider-inline-comments.refresh.content.link",
        defaultMessage: "Refresh content"
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f4c77c6e390a7914$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt49l6b",
            __cmplp.className
        ])
    });
});
const $f4c77c6e390a7914$var$styles = {
    commentEditorContainer: "_ca0qutpp"
};
const $f4c77c6e390a7914$var$getNodeType = (element, annotationId)=>{
    const nodeWithAnnotationWrapper = element.querySelector(`[id="${annotationId}"]`);
    if (nodeWithAnnotationWrapper) {
        const firsChildren = nodeWithAnnotationWrapper.firstChild;
        if (firsChildren?.nodeType === Node.TEXT_NODE) return 'text';
        const targetNode = nodeWithAnnotationWrapper.querySelector('[data-node-type]');
        if (targetNode) return targetNode.dataset.nodeType;
    }
    return 'unknown';
}; // Exporting for testing cases
const $f4c77c6e390a7914$export$d4044f5b8f4bc73a = (setWasDraftAnnotationRemoved, isSavingComment)=>(mutationList, observer)=>{
        for (const mutation of mutationList){
            if (mutation.type === 'childList') {
                if (mutation.removedNodes.length > 0) mutation.removedNodes.forEach((node)=>{
                    const nodeClassList = Array.from(node.classList ?? []); // COMMENTS-4308 - If any part of the draft annotation was removed, check if the entirity of the draft
                    // 				   was removed, if so, we need to disable the editor buttons as the comment will fail
                    if (nodeClassList.includes('ak-editor-annotation-draft')) {
                        if (typeof document !== 'undefined' && document.querySelector('.ak-editor-annotation-draft') === null) {
                            // Tell the editor that the draft annotation was removed, unless user already clicked "save"
                            !isSavingComment.current && setWasDraftAnnotationRemoved(true); // Still log the draft annotation removal for debugging
                            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.debugPoint(`CreateComment dialog - draft annotation removed`); // Disconnect the observer since we no longer need it
                            observer.disconnect();
                        }
                    }
                });
            }
        }
    };
const $f4c77c6e390a7914$var$CommentEditorContainer = ({ children: children })=>(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        xcss: $f4c77c6e390a7914$var$styles.commentEditorContainer
    }, children) : children;
const $f4c77c6e390a7914$var$CreateCommentComponent = ({ pageId: pageId, annotationElement: annotationElement, selectionOptions: selectionOptions, onClose: onClose, onCreate: onCreate, onCreateError: onCreateError, isEditor: isEditor, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar, flags: flags, isOffline: isOffline })=>{
    const started = (0, $cozmU.useRef)(false);
    const pageClass = (0, $9QIM2.usePageClass)();
    const { edition: edition, cloudId: cloudId, userId: userId, displayName: displayName } = (0, $bQm3c.useSessionData)();
    if (started.current === false) {
        // Just in case `edition` is not set on `createInlineCommentCompoundExperience.start()`,
        // which can occur if the experience was started from within the editor platform code.
        (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
            edition: edition ?? ''
        });
        (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.start();
        started.current = true;
    }
    const initialisedSelection = (0, $cozmU.useRef)(false);
    if (selectionOptions && selectionOptions?.createdFrom === 'EDITOR' && initialisedSelection.current === false) {
        initialisedSelection.current = true;
        if (selectionOptions.inlineNodeTypes) (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
            inlineNodeTypes: selectionOptions.inlineNodeTypes
        });
    }
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const lastContentFetchTime = (0, $cozmU.useRef)(1);
    const requestTimeoutHandle = (0, $cozmU.useRef)();
    const sidebarEl = (0, $cozmU.useRef)(null);
    const draftAnnotationMutationObserverRef = (0, $cozmU.useRef)();
    const commentContainerElementRef = (0, $cozmU.useRef)(null);
    const { documentUpdated: documentUpdated, publishedDocumentVersion: publishedDocumentVersion, currentDocumentVersion: currentDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatus)();
    const { setRefetchContent: setRefetchContent } = (0, $5pQ1Y.useContentRefetchDispatch)();
    const createdAnnotationId = (0, $cozmU.useRef)(null);
    const createdCommentId = (0, $cozmU.useRef)(null);
    const isSavingComment = (0, $cozmU.useRef)(false);
    const [shouldRefetch, setShouldRefetch] = (0, $cozmU.useState)(false);
    const [wasDraftAnnotationRemoved, setWasDraftAnnotationRemoved] = (0, $cozmU.useState)(false);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { onChange: onChange, resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { showFyi: showFyi, agent: agent, onContentChange: onAgentMentionContentChange } = (0, $gurMq.useAgentMentionFyiNudge)({
        cloudId: cloudId,
        enabled: (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true)
    }); // Track whether the FYI component has ever been shown, so we only load the
    // chunk on first mention but keep it mounted for the collapse animation.
    const hasShownFyiRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (showFyi) hasShownFyiRef.current = true;
    }, [
        showFyi
    ]);
    const handleContentChangeWithData = (0, $cozmU.useCallback)((_hasChanges, adf)=>{
        onAgentMentionContentChange(adf);
    }, [
        onAgentMentionContentChange
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { addUnresolvedInlineComment: addUnresolvedInlineComment, removeUnresolvedInlineComment: removeUnresolvedInlineComment } = (0, $k8e76.useInlineCommentsActions)(); // Check if avatar data is ready - this hook runs independently and checks cache/loading state
    const isAuthorReady = (0, $dLr6w.useCurrentUserAvatarReady)();
    const { addNewCommentThreads: addNewCommentThreads } = (0, $8i27m.useCommentsDataActions)();
    const { width: windowWidth } = (0, $hl0fg.useWindowSize)();
    const { isCommentsPanelShown: isCommentsPanelShown, showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { setCurrentView: setCurrentView, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey } = (0, $3mVfX.useCommentsPanelActions)();
    const { isSticky: isSticky } = (0, $3Xfi8.useShouldCommentSidebarBeSticky)({
        annotationElement: annotationElement,
        isEditor: !!isEditor
    });
    const sidebarOffset = (0, $eA7s6.useCommentSidebarOffset)({
        isEditor: Boolean(isEditor),
        annotationElement: annotationElement,
        windowWidth: windowWidth,
        isSticky: isSticky
    }); // Hide OmniBar while this component is mounted (viewing inline comment)
    const { requestHideOmniBar: requestHideOmniBar, releaseHideOmniBar: releaseHideOmniBar } = (0, $b0EGa.useOmniBarVisibilityActions)();
    (0, $cozmU.useLayoutEffect)(()=>{
        if ((0, $9wGTI.fg)('cc-engagement-omnibar-hide-inline-comments')) {
            requestHideOmniBar();
            return ()=>releaseHideOmniBar();
        }
    }, [
        requestHideOmniBar,
        releaseHideOmniBar
    ]);
    const [createCommentFn] = (0, $308Wd.useMutationInterop)((0, $9dDPb.default), {
        ...(0, $6tkbf.buildMutationContextForNoNetworkError)(),
        __callerPackage__: "annotation-provider-inline-comments"
    });
    const { createInlineCommentInterop: createInlineCommentInterop } = (0, $6cWI7.useCreateInlineCommentMutation)({
        contentId: pageId
    });
    const { pageInfo: pageInfo, loading: loading, error: error, refetch: refetch } = (0, $cAdj8.usePageInfo)({
        fetchPolicy: 'cache-first',
        onError: (err)=>{
            experienceTracker.stopOnError({
                name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE),
                error: err
            });
        }
    });
    (0, $cozmU.useEffect)(()=>{
        // should only refresh on the Content Out of date `Refresh` CTA is clicked
        if (documentUpdated && shouldRefetch && refetch) {
            refetch();
            setShouldRefetch(false);
            onClose && onClose();
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        documentUpdated,
        shouldRefetch
    ]);
    (0, $cozmU.useEffect)(()=>{
        const metadata = document.querySelector('meta[name=confluence-request-time]');
        if (metadata) {
            const fetchTime = Number(metadata.getAttribute('content'));
            lastContentFetchTime.current = isNaN(fetchTime) ? 1 : fetchTime;
        }
        if (pageMode !== (0, $cD1qu.PageMode).VIEW) {
            const editorTextArea = document.getElementById('ak-editor-textarea');
            draftAnnotationMutationObserverRef.current = new MutationObserver($f4c77c6e390a7914$export$d4044f5b8f4bc73a(setWasDraftAnnotationRemoved, isSavingComment)); // We need to watch the whole editorTextArea because highlights could
            if (editorTextArea) draftAnnotationMutationObserverRef.current.observe(editorTextArea, {
                childList: true,
                subtree: true
            });
        }
        return ()=>{
            if (pageMode !== (0, $cD1qu.PageMode).VIEW && draftAnnotationMutationObserverRef.current) draftAnnotationMutationObserverRef.current.disconnect();
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Check for highlight element on mount - fail experience if createComment renders without a highlight
    // This tracks the scenario where createComment re-renders on close of the comment box without a highlight
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $6mKj3.expValEquals)('confluence_comment_enable_exp_create_rerenderer', 'isEnabled', true)) return;
         // Use a small delay to allow the DOM to settle after any state changes
        const timeoutId = setTimeout(()=>{
            const draftAnnotationElement = $f4c77c6e390a7914$export$292a5d148db8f191(); // Fail experience if createComment renders without a highlight
            if (!draftAnnotationElement && !wasDraftAnnotationRemoved) (0, $3YBks.createInlineCommentCompoundExperience).initExperience.fail(new Error('CreateComment renders without highlight'));
        }, 100);
        return ()=>clearTimeout(timeoutId); // Only run on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const saveAttemptedTracker = (0, $cozmU.useRef)({
        lastMutationSucceeded: false,
        totalSaves: 0,
        failedSaves: 0
    });
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            const isOptimisticCreateEnabled = (0, $aGjYc.shouldUseCommentDraftForOptimisticSave)(isEditor ? 'edit-inline' : 'inline', 'create'); // TODO: (COMMENTS-6792) The error handling code in this useEffect unmount callback can be removed
            // after optimistic create is shipped, along with saveAttemptedTracker and saveAttemptedCounts.
            // With optimistic create, each save attempt immediately succeeds/aborts/fails the experience, so we
            // do not need to track the save attempts and errors to complete the experience only after the user closes
            // CreateComment. This is a much simpler and cleaner control flow.
            // Some of the error handling code below has been copied into the onCreateFailure callback.
            if (!isOptimisticCreateEnabled) {
                // When optimistic create is enabled, we immediately close i.e. unmount CreateComment, so all this error
                // handling code is always no-op and thus can be skipped.
                const savesWithoutError = // hit, the experience will already have completed in the `handleSaveComment`.
                saveAttemptedTracker.current.totalSaves - saveAttemptedTracker.current.failedSaves;
                if (saveAttemptedTracker.current.failedSaves > 0) (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
                    // eslint-disable-next-line react-hooks/exhaustive-deps
                    failedSaves: saveAttemptedTracker.current.failedSaves
                });
                if (savesWithoutError > 1) {
                    // At the point this is dismounting -- we don't know for certain if the user intended for this to be discarded or not
                    // so we hard fail the full experience (it's possible the dismount is because the second save has worked and
                    // the UI is about to load the new comment)
                    (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
                        savesWithoutError: savesWithoutError
                    });
                    const msg = 'User clicked save, but UI did not update following successful save'; // we log a debug point and continue with the flow, since creation is not necessarily failing
                    (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.debugPoint(msg);
                }
                if (saveAttemptedTracker.current.lastPublishFailure) {
                    if (saveAttemptedTracker.current.lastMutationSucceeded) {
                        // in the case there was a publish failure, but the last mutation succeeded -- we assume the dismount is
                        // because the ui is about to load the new comment - in this case we only mark the experience as a soft
                        // failure (we'll capture more details and fail in the final experience step)
                        (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.softFail(// eslint-disable-next-line react-hooks/exhaustive-deps -- This is intentionally using a ref value due to the indirect flow of comment updates
                        saveAttemptedTracker.current.lastPublishFailure);
                        return;
                    } else {
                        // In this scenario -- the user attempted to save at least once, got a network error, and gave up on
                        // trying to create the comment
                        // For a subset of errors -- the user is presented with a human readable error message describing that
                        // the comment creation failure is due to the content changing (e.g. the user has edited the page) and
                        // that they need to refresh the page to apply the comment.  In this scenario we don't treat the comment
                        // creation as a failure, but rather we want to mark the experience as aborted.
                        const contentChangedErrorSubstrings = [
                            'Invalid arguments provided for matchIndex and/or numMatches',
                            'Failed to insert highlight, invalid originalSelection, numMatches, or matchIndex',
                            'Selection was made against a stale version of the content',
                            'Published Version out of date. Please provide correct published version.'
                        ];
                        const isContentChangedError = contentChangedErrorSubstrings.some((substring)=>// eslint-disable-next-line react-hooks/exhaustive-deps
                            saveAttemptedTracker.current.lastPublishFailure?.message.includes(substring));
                        if (isContentChangedError) {
                            (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.abort({
                                abortReason: 'Unable to apply annotation to document'
                            });
                            return;
                        } // This is handled in the UI appropriately, and we should abort not fail
                        const permissionErrorSubstring = 'Could not create content with type comment';
                        const isPermissionError = saveAttemptedTracker.current.lastPublishFailure?.message.includes(permissionErrorSubstring);
                        if (isPermissionError) (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.abort({
                            abortReason: 'User does not have space permission to create comments'
                        });
                        if ((0, $9wGTI.fg)('confluence_comments_abort_on_container_not_found')) {
                            const isErrorContentNotFoundError = (0, $lFkRf.isRawContentNotFoundError)(// eslint-disable-next-line react-hooks/exhaustive-deps
                            saveAttemptedTracker.current.lastPublishFailure?.message ?? '');
                            if (isErrorContentNotFoundError) {
                                (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.abort({
                                    abortReason: 'Content no longer available for commenting'
                                });
                                return;
                            }
                        }
                        (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.stopOnError(// eslint-disable-next-line react-hooks/exhaustive-deps -- This is intentionally using a ref value due to the indirect flow of comment updates
                        saveAttemptedTracker.current.lastPublishFailure);
                        return;
                    }
                }
                if (saveAttemptedTracker.current.lastMutationSucceeded) {
                    (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.complete();
                    return;
                }
            }
            // TODO: (COMMENTS-6792) - END of error handling code to be removed.
            if (!isOptimisticCreateEnabled || !isSavingComment.current) {
                // In this case the user did not attempt to save the comment, and so we assume this was
                // an intentional discard of the comment.
                // So we abort the draftToPublishExperience here, along with any unfinished initExperience.
                // Note: if experiences are already succeeded/aborted/failed, this will be a no-op.
                const abortReason = 'Create Comment UI dismissed';
                (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.abort({
                    abortReason: abortReason
                });
                (0, $3YBks.createInlineCommentCompoundExperience).initExperience.abort({
                    abortReason: abortReason
                });
                (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).cancel();
            }
        };
    // Missing `isEditor` in the dependency array, which is ok because its
    // value never changes, and this won't depend on it after optimistic
    // create is shipped.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const saveAttemptedCounts = (0, $cozmU.useRef)({
        total: 0,
        failedSaves: 0
    });
    const failPublishExperience = (0, $cozmU.useCallback)((commentPublishError, translatedErrorMsg)=>{
        // COMMENTS-1879 - Only log unexpected errors or annotation application error as failures
        if ((0, $isdzP.isUnexpectedError)(translatedErrorMsg)) experienceTracker.stopOnError({
            name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE),
            error: commentPublishError
        });
        else (0, $7Sm4c.markErrorAsHandled)(commentPublishError);
    }, [
        experienceTracker
    ]);
    const onCacheUpdateError = (0, $cozmU.useCallback)((cacheError)=>{
        const { message: message } = (0, $isdzP.parseError)(cacheError);
        failPublishExperience(cacheError, (0, $isdzP.getTranslatedError)(message));
    }, [
        failPublishExperience
    ]);
    const handleSaveCommentWithTimeout = (timeoutInMs, saveMutation)=>{
        const timeout = new Promise((_resolve, reject)=>{
            requestTimeoutHandle.current = setTimeout(()=>{
                experienceTracker.stopOnError({
                    name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE),
                    error: new Error(`Request took longer than ${timeoutInMs}ms`)
                });
                return reject({
                    error: (0, $9CnRS.i18n).createTimeout
                });
            }, timeoutInMs);
        });
        return Promise.race([
            timeout,
            saveMutation
        ]).finally(()=>{
            if (requestTimeoutHandle.current) clearTimeout(requestTimeoutHandle.current);
        });
    };
    const handleSaveComment = (adf, onSuccess)=>{
        saveAttemptedTracker.current.totalSaves = saveAttemptedTracker.current.totalSaves + 1;
        saveAttemptedTracker.current.lastMutationSucceeded = false;
        saveAttemptedCounts.current.total = saveAttemptedCounts.current.total + 1;
        createdAnnotationId.current = null;
        createdCommentId.current = null;
        isSavingComment.current = true;
        if (!selectionOptions) // We likely will never get here, but just in case
        return Promise.reject({
            error: (0, $9CnRS.i18n).unableToGenerateStep
        });
        (0, $8Ss4E.startEditorSubExperience)({
            name: (0, $irVI7.VIEW_PAGE_DIRECT_COMMENT_DATA_FLOW_EXPERIENCE),
            attributes: {
                pageId: pageId,
                pageMode: pageMode,
                isEditor: isEditor
            }
        });
        (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).start();
        (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).mark('commentCreationStart');
        (0, $8Ss4E.startEditorSubExperience)({
            name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE),
            attributes: {
                timeout: $f4c77c6e390a7914$export$d26c1daa0321174b
            }
        });
        if (pageMode === (0, $cD1qu.PageMode).VIEW && (0, $9wGTI.fg)('confluence_frontend_view_inline_comment_debug_v2')) (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
            currentDocumentVersion: currentDocumentVersion,
            publishedDocumentVersion: publishedDocumentVersion,
            isPageOutdated: currentDocumentVersion !== publishedDocumentVersion
        });
        const { numMatches: numMatches, matchIndex: matchIndex, originalSelection: originalSelection, createdFrom: createdFrom, step: step, targetNodeType: targetNodeType } = selectionOptions; // Generate a random annotation ID for optimistic rendering. We pass it as
        // inlineMarkerRef so the server echoes it back, meaning no ID reconciliation is needed.
        const optimisticAnnotationId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        const isOptimisticCreateEnabled = (0, $aGjYc.shouldUseCommentDraftForOptimisticSave)(isEditor ? 'edit-inline' : 'inline', 'create'); // eslint-disable-next-line confluence-feature-gating/inline-usage
        const variables = {
            input: {
                containerId: pageId,
                commentBody: {
                    value: JSON.stringify(adf),
                    representationFormat: 'ATLAS_DOC_FORMAT'
                },
                numMatches: numMatches,
                matchIndex: matchIndex,
                originalSelection: originalSelection,
                createdFrom: createdFrom,
                lastFetchTimeMillis: lastContentFetchTime.current,
                // In VIEW mode, we send the currentDocumentVersion so that the backend can
                // correctly identify where the inline annotation should be applied on the Page.
                // p.s. currentDocumentVersion is not set in EDIT/LIVE mode.
                publishedVersion: pageMode === (0, $cD1qu.PageMode).VIEW && currentDocumentVersion && (0, $6mKj3.expValEquals)('confluence_fe_create_inline_use_curr_doc_version', 'isEnabled', true) ? currentDocumentVersion : publishedDocumentVersion,
                ...!!step && {
                    step: (0, $aMfLn.constructStepForGql)(step)
                },
                // Pass the annotation ID so the server echoes it back, enabling optimistic rendering
                // without needing to reconcile IDs when the response arrives.
                ...isOptimisticCreateEnabled ? {
                    inlineMarkerRef: optimisticAnnotationId
                } : {}
            },
            pageId: pageId,
            includeReactionsAndReplies: false
        }; // Note -- this mixes data saving logic and UI application logic.
        // And when the UI logic fails, the result is that the user is left with
        // the ui looking like the comment failed to save.
        // This should be refactored to separate the two concerns, and on a UI application
        // failure, we should encourage users to refresh (and mark the experience as failed).
        let succeededPublish = false;
        const onCreateSuccess = (retVal)=>{
            saveAttemptedTracker.current.lastMutationSucceeded = true;
            const { data: data } = retVal;
            if (requestTimeoutHandle.current) clearTimeout(requestTimeoutHandle.current);
            succeededPublish = true;
            (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.publishSucceeded(); // Invalidate the collab draft cache since adding a comment modifies the ADF content
            // (adds annotation marks). This ensures the editor will fetch fresh content with
            // comment annotations if the user clicks Edit after adding a comment.
            (0, $fqIt3.clearCollabDraftTimestamp)(pageId); // Mark comment creation end for both cohorts
            (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).mark('commentCreationEnd');
            if (!isOptimisticCreateEnabled) // When optimistic create is enabled, commentDataLoadStart has been marked before GQL mutation started.
            (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).mark('commentDataLoadStart');
            const annotationId = data?.createInlineComment?.location?.inlineMarkerRef;
            const commentId = data?.createInlineComment?.id;
            if (!annotationId || !commentId) throw new Error(`Comment was not saved correctly - either annotationId '${annotationId}' or commentId '${commentId}' were undefined`);
            createdAnnotationId.current = annotationId;
            createdCommentId.current = commentId; // Reset the content changing flag
            resetContentChanged(); // When not using optimistic rendering, apply the annotation and update the sidebar here.
            // When optimistic rendering is active, these were already applied immediately on submit,
            // so we skip them to avoid double-applying.
            if (!isOptimisticCreateEnabled) {
                // Grab the marker ref id returned and update the editor/renderer
                try {
                    onCreate(annotationId, data?.createInlineComment);
                } catch (e) {
                    // We generate errors in renderer, but this will also handle the editor case
                    throw new Error(`Unable to apply annotation to document - ${e.message}`);
                } // Update the unresolved inline comments count
                addUnresolvedInlineComment(annotationId, pageMode); // For experiment cohort, we pass the mutation data to onCreate
                // The experiment success and data load completion will be handled in AnnotationsContext
                // after the view component renders the new data
                const newComment = {
                    // (Need to coerce the data from the new Comments Data Manager's mutation because it is
                    // defined using the new Relay-generated types that define option fields as "| null | undefined"
                    // but the original Apollo-generated types define them as just "| null".  These aren't compatible
                    // without the coercion even though the "if (value)" or "value?." expressions would work the same.)
                    ...data?.createInlineComment,
                    isOpen: true,
                    type: (0, $8i27m.CommentType).INLINE,
                    wasRemovedByAnotherUser: false,
                    replies: [],
                    reactionsSummary: null
                };
                if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) addNewCommentThreads({
                    general: {},
                    inline: {
                        [annotationId]: newComment
                    }
                });
            } else // Mark draftToPublishExperience as successful after mutation succeeds and annotation is applied.
            (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.complete();
            isSavingComment.current = false; // Create inline comment track event
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'created',
                    actionSubject: 'comment',
                    actionSubjectId: commentId,
                    objectType: 'page',
                    objectId: pageId,
                    source: isEditor ? 'editPageScreen' : 'viewPageScreen',
                    attributes: {
                        ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                        source: (0, $en1dX.AnalyticsSource).STANDALONE,
                        commentType: (0, $8i27m.CommentType).INLINE,
                        parentCommentId: null,
                        isReply: false,
                        pageMode: pageMode,
                        isLivePage: createdFrom === 'LIVE',
                        navdexPointType: (0, $56QzY.END),
                        inlineNodeTypes: selectionOptions.inlineNodeTypes,
                        ...annotationElement && !isEditor && {
                            nodeType: $f4c77c6e390a7914$var$getNodeType(annotationElement, annotationId)
                        },
                        ...!isEditor && {
                            targetNodeType: targetNodeType
                        }
                    }
                }
            }).fire(); // Reset the editor (skipped when optimistic, since it was already reset on submit)
            if (!isOptimisticCreateEnabled) {
                onSuccess(); // Code below are duplicated in handleSaveComment when isOptimisticCreateEnabled.
                // Not bothering to extract common code since this copy will be deleted after the
                // experiment is shipped.
                (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                    pageClass: pageClass,
                    commentType: 'inline',
                    entryPoint: 'create-comment',
                    annotationId: annotationId
                }); /*
             * On editor pages, the view-inline-comment experience is started by the editor when the
             * created annotation is automatically selected after successful comment creation. For
             * editor pages, we update the attributes here to ensure that the experience is tracked
             * with the correct entry point.
             */ 
                const attributes = {
                    annotationId: annotationId,
                    entryPoint: $f4c77c6e390a7914$var$relativeFilePath,
                    pageClass: pageClass
                };
                if (pageClass === 'renderer') experienceTracker.start({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                    attributes: {
                        ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                        ...attributes
                    }
                });
                else if (pageClass === 'editor') experienceTracker.updateAttributes({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    attributes: attributes
                });
                if (isCommentsPanelShown) experienceTracker.fail({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    error: new Error('Comments panel is visible when it should not be'),
                    attributes: {
                        stopPoint: $f4c77c6e390a7914$var$relativeFilePath
                    }
                });
            }
        };
        const onCreateFailure = (err)=>{
            saveAttemptedTracker.current.failedSaves = saveAttemptedTracker.current.failedSaves + 1;
            saveAttemptedCounts.current.failedSaves = saveAttemptedCounts.current.failedSaves + 1;
            experienceTracker.fail({
                name: (0, $irVI7.VIEW_PAGE_DIRECT_COMMENT_DATA_FLOW_EXPERIENCE),
                error: err,
                attributes: {
                    pageId: pageId,
                    pageMode: pageMode,
                    isEditor: isEditor,
                    pointOfFailure: !succeededPublish ? 'running-mutation' : 'applying-comment-to-ui'
                }
            });
            (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).cancel();
            (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.debug({
                error: err,
                createAnalyticsEvent: createAnalyticsEvent,
                extraAttributes: {
                    pointOfFailure: !succeededPublish ? 'running-mutation' : 'applying-comment-to-ui'
                }
            });
            if (!succeededPublish) saveAttemptedTracker.current.lastPublishFailure = err;
            isSavingComment.current = false;
            if (isOptimisticCreateEnabled) {
                // Remove the optimistically added annotation.
                // A removal is required for EDIT/LIVE modes because in these
                // modes, the annotation is inserted into editor on frontend
                // and then synced to backend and saved into the document.
                // For VIEW mode, annotation is inserted into the page on
                // backend during the create-comment mutation, while the one
                // shown on frontend is temporary and local only, so simply
                // hiding it is sufficient when an error occurs.
                try {
                    onCreateError && onCreateError(optimisticAnnotationId);
                } catch (e) {
                    // We log the error and let the rest of the error handling code run.
                    (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.debug({
                        error: new Error(`Unable to remove annotation from document on optimistic create failure - ${e.message}`),
                        createAnalyticsEvent: createAnalyticsEvent
                    });
                }
                removeUnresolvedInlineComment(optimisticAnnotationId);
            }
            let contentOutOfDate = false; // Get a truncated graphql error message
            const { errorId: errorId, message: message } = (0, $isdzP.parseError)(err);
            const translatedError = (0, $isdzP.getTranslatedError)(message); // COMMENTS-1879 - The backend will fall back to the old method of trying to make string matches if the content
            // is out of date. If the BE fails to apply a comment when using the old fallback method we should log it
            if ((0, $isdzP.isHighlightError)(translatedError)) {
                // Send the analytics event
                const analyticsObject = {
                    source: 'viewPage',
                    objectType: 'page',
                    objectId: pageId,
                    action: 'invalid',
                    actionSubject: 'highlight',
                    actionSubjectId: 'inlineComment',
                    attributes: {
                        errorMessage: message,
                        editor: 'FABRIC',
                        framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                        errorId: errorId,
                        highlightOrigin: 'userHighlight' // TODO: Do we need to programmatically track this?
                    }
                };
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: analyticsObject
                }).fire();
                contentOutOfDate = true;
            }
            failPublishExperience(err, translatedError); // In the case of an annotation error, we should show a flag to the user to let them know
            // their comment has been saved and they need to refresh the content (view mode only)
            if ((0, $isdzP.isAnnotationError)(translatedError)) {
                const CREATE_ERROR_FLAG_ID = `create-error-${Date.now()}`;
                const getAnnotationErrorFlagActions = ()=>{
                    if (pageMode === (0, $cD1qu.PageMode).VIEW) // Only show the refetch content action on view mode as it's not applicable in editor/live
                    return [
                        {
                            content: formatMessage($f4c77c6e390a7914$var$i18n.refreshContentLink),
                            onClick: ()=>{
                                setRefetchContent(true);
                                handleOnClose();
                                flags.hideFlag(CREATE_ERROR_FLAG_ID);
                            }
                        }
                    ];
                    else {
                        // pageMode === PageMode.EDITOR || PageMode.LIVE
                        if (createdAnnotationId.current && createdCommentId.current && translatedError === (0, $9CnRS.i18n).unableToApplyDanglingCommentAnnotation && (0, $6mKj3.expValEquals)('confluence_fe_show_created_dangling_comment_flag', 'isEnabled', true)) return [
                            {
                                content: formatMessage((0, $9CnRS.i18n).goToCommentCTA),
                                onClick: ()=>{
                                    if (!isCommentsPanelShown) showCommentsPanel({
                                        openWithView: (0, $3mVfX.ViewValues).DELETED_CONTENT
                                    });
                                    else setCurrentView((0, $3mVfX.ViewValues).DELETED_CONTENT);
                                    setCurrentlySelectedThreadKey(createdAnnotationId.current);
                                    (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                                        scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                                        context: (0, $9FoVw.NavigationContext).PANEL,
                                        block: 'center',
                                        annotationId: createdAnnotationId.current,
                                        commentId: createdCommentId.current,
                                        commentType: 'INLINE',
                                        annotationClicked: true,
                                        expectedView: (0, $3mVfX.ViewValues).DELETED_CONTENT
                                    });
                                    flags.hideFlag(CREATE_ERROR_FLAG_ID);
                                }
                            }
                        ];
                         // TODO: Add more actions for editor/live if needed
                    }
                    return [];
                };
                flags.showWarningFlag({
                    id: CREATE_ERROR_FLAG_ID,
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f4c77c6e390a7914$var$i18n.unableToApplyTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), translatedError === (0, $9CnRS.i18n).unableToApplyAnnotation ? $f4c77c6e390a7914$var$i18n.unableToApplyDescription : translatedError),
                    actions: getAnnotationErrorFlagActions()
                }); // Log the occurance through analytics so we can still track it
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        source: pageMode === (0, $cD1qu.PageMode).VIEW ? 'viewPageScreen' : 'editPageScreen',
                        objectType: 'page',
                        objectId: pageId,
                        action: 'failed',
                        actionSubject: 'applyAnnotation',
                        actionSubjectId: 'inlineComment',
                        attributes: {
                            errorMessage: message,
                            editor: 'FABRIC',
                            framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                            isLivePage: pageMode === (0, $cD1qu.PageMode).LIVE,
                            tenantId: cloudId,
                            userId: userId,
                            pageId: pageId
                        }
                    }
                }).fire(); // Some code duplication.
                // Not extracting common code since `else` will be deleted after experiment is shipped.
                if ((0, $6mKj3.expValEquals)('confluence_fe_show_created_dangling_comment_flag', 'isEnabled', true)) (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.abort({
                    abortReason: 'Unable to apply annotation to document',
                    attributes: {
                        detailedMessage: message,
                        ...errorId ? {
                            errorId: errorId
                        } : {},
                        pageMode: pageMode,
                        context: isEditor ? 'editor' : 'renderer',
                        pointOfFailure: !succeededPublish ? 'running-mutation' : 'applying-comment-to-ui',
                        pageId: pageId
                    }
                });
                else (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.fail(new Error('Unable to apply annotation to document'), {
                    detailedMessage: message,
                    ...errorId ? {
                        errorId: errorId
                    } : {},
                    pageMode: pageMode,
                    context: isEditor ? 'editor' : 'renderer',
                    pointOfFailure: !succeededPublish ? 'running-mutation' : 'applying-comment-to-ui',
                    pageId: pageId
                });
                onClose && onClose();
                return;
            } // For a subset of errors -- the user is presented with a human readable error message describing that
            // the comment creation failure is due to the content changing (e.g. the user has edited the page) and
            // that they need to refresh the page to apply the comment. In this scenario we don't treat the comment
            // creation as a failure, but rather we want to mark the experience as aborted.
            // These were copied from useEffect unmount callback. TODO: remove this comment after shipping experiment
            if (isOptimisticCreateEnabled) {
                const contentChangedErrorSubstrings = [
                    'Invalid arguments provided for matchIndex and/or numMatches',
                    'Failed to insert highlight, invalid originalSelection, numMatches, or matchIndex',
                    'Selection was made against a stale version of the content',
                    'Published Version out of date. Please provide correct published version.'
                ];
                const isContentChangedError = contentChangedErrorSubstrings.some((substring)=>err.message.includes(substring));
                if (isContentChangedError) (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.abort({
                    abortReason: 'Unable to apply annotation to document'
                });
                else if ((0, $isdzP.isCreateNotPermittedError)(translatedError) || (0, $isdzP.isViewNotPermittedError)(translatedError)) (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.abort({
                    abortReason: 'User does not have space permission to create comments'
                });
                else if ((0, $isdzP.isContentNotFoundError)(translatedError) && (0, $9wGTI.fg)('confluence_comments_abort_on_container_not_found')) (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.abort({
                    abortReason: 'Content no longer available for commenting'
                });
                else (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.stopOnError(err);
            } // Use the existing value if it's already set or is an out of date error
            contentOutOfDate = contentOutOfDate || (0, $isdzP.isOutOfDateError)(translatedError); // CommentEditor expects a translated error message otherwise it fails
            // TODO: CommentEditor should likely just receive the translated message
            // rather than expect the object needed for FormattedMessage
            return Promise.reject({
                error: contentOutOfDate ? (0, $9CnRS.i18n).contentOutOfDate : translatedError,
                contentOutOfDate: contentOutOfDate
            });
        };
        // Wrap the createCommentFn mutation with the interop logic that handles both the direct Apollo
        // mutation path and the new hook-based for the Comments Data Manager
        const commentCreationInteropWrapper = (options)=>createInlineCommentInterop({
                originalMutationFn: createCommentFn,
                options: {
                    ...options,
                    // Show comment immediately before server response to reduce perceived latency.
                    optimisticResponse: isOptimisticCreateEnabled ? (0, $6cWI7.getOptimisticResponse)({
                        userId: userId ?? '',
                        displayName: displayName ?? '',
                        adf: adf,
                        pageId: pageId,
                        annotationId: optimisticAnnotationId,
                        inlineText: originalSelection
                    }) : undefined
                },
                onCacheUpdateError: onCacheUpdateError
            }); // When the experiment is enabled, apply the full UI immediately before the server responds:
        // - onCreate converts the draft highlight into a permanent annotation in the document
        // - onSuccess closes/resets the editor
        // The server is passed optimisticAnnotationId as inlineMarkerRef and echoes it back,
        // so onCreateSuccess skips these steps (they're already done).
        if (isOptimisticCreateEnabled) {
            (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).mark('commentDataLoadStart');
            try {
                onCreate(optimisticAnnotationId);
            } catch (e) {
                // If optimistic apply annotation fails, we:
                // - remove any annotation that was added
                // - no need to send the GQL mutation; immediately abort the experience here
                // - let CommentEditor show an error flag to the user
                onCreateError && onCreateError(optimisticAnnotationId);
                (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).cancel();
                (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.abort({
                    abortReason: 'Unable to apply annotation to document',
                    attributes: {
                        detailedMessage: e.message,
                        pageMode: pageMode,
                        context: isEditor ? 'editor' : 'renderer',
                        pointOfFailure: 'applying-comment-to-ui-optimistic',
                        pageId: pageId
                    }
                });
                return Promise.reject({
                    error: $f4c77c6e390a7914$var$i18n.unableToApplyOptimistically
                }).finally(()=>{
                    isSavingComment.current = false;
                });
            }
            addUnresolvedInlineComment(optimisticAnnotationId, pageMode);
            onSuccess();
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                commentType: 'inline',
                entryPoint: 'create-comment',
                annotationId: optimisticAnnotationId
            });
            const attributes = {
                annotationId: optimisticAnnotationId,
                entryPoint: $f4c77c6e390a7914$var$relativeFilePath,
                pageClass: pageClass
            };
            if (pageClass === 'renderer') experienceTracker.start({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                attributes: {
                    ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                    ...attributes
                }
            });
            else if (pageClass === 'editor') experienceTracker.updateAttributes({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                attributes: attributes
            });
            if (isCommentsPanelShown) experienceTracker.fail({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                error: new Error('Comments panel is visible when it should not be'),
                attributes: {
                    stopPoint: $f4c77c6e390a7914$var$relativeFilePath
                }
            });
        }
        const handleCreateSuccess = (retVal)=>{
            if ((0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true)) {
                const commentId = retVal?.data?.createInlineComment?.id ?? '';
                (0, $emtVP.handleAgentMentionInComment)(adf, cloudId, pageId, commentId, userId ?? undefined);
            }
            return onCreateSuccess(retVal);
        };
        const mutationPromise = commentCreationInteropWrapper({
            variables: variables
        });
        if ((0, $9wGTI.fg)('confluence_frontend_add_inline_comment_timeout')) return handleSaveCommentWithTimeout($f4c77c6e390a7914$export$d26c1daa0321174b, mutationPromise.then(handleCreateSuccess).catch(onCreateFailure));
        else return mutationPromise.then(handleCreateSuccess).catch(onCreateFailure);
    };
    const handleOnClose = (0, $cozmU.useCallback)((hasContentChanged)=>{
        const reason = hasContentChanged ? 'comment discarded by user' : 'empty comment discarded by user';
        experienceTracker.abort({
            name: (0, $irVI7.ADD_INLINE_COMMENT_EXPERIENCE),
            reason: reason
        }); // Draft is not cleared until a create-inline-comment success.
        // TODO: (COMMENTS-6792) Remove this entirely when optimistic create is rolled out.
        if (!(0, $aGjYc.shouldUseCommentDraftForOptimisticSave)(isEditor ? 'edit-inline' : 'inline', 'create')) // Clearing reply draft is handled in the comment editor
        (0, $aGjYc.clearCommentDraft)(isEditor ? 'edit-inline' : 'inline', 'create');
        onClose && onClose();
    }, [
        experienceTracker,
        isEditor,
        onClose
    ]);
    const [currentContentId] = (0, $ep3mz.usePageContentId)();
    const initialContentIdRef = (0, $cozmU.useRef)(currentContentId);
    (0, $cozmU.useEffect)(()=>{
        if (initialContentIdRef.current && currentContentId && initialContentIdRef.current !== currentContentId) handleOnClose();
    }, [
        currentContentId,
        handleOnClose
    ]);
    const onEditorLoad = ()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.ADD_INLINE_COMMENT_LOAD_EXPERIENCE)
        });
        const draftAnnotationElement = $f4c77c6e390a7914$export$292a5d148db8f191();
        if (!draftAnnotationElement && !wasDraftAnnotationRemoved) {
            // We have handling to show a message when we detect the draft annotation was removed, indicated by
            // `wasDraftAnnotationRemoved=true`. So we only need to fail the experience if we unexpectedly cannot find
            // the draftAnnotationElement, indicated by `wasDraftAnnotationRemoved=false`
            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.fail(new Error('No annotation element'));
            return;
        }
        setTimeout(()=>{
            // There are multiple useEffects involved in positioning the comment UI.
            // This works around this by only marking the experience as complete after
            // a short timeout + animation frame.
            requestAnimationFrame(()=>{
                // In the Editor and Renderer, the comment UI is positioned relative to slightly different
                // elements.
                if (!draftAnnotationElement) {
                    (0, $3YBks.createInlineCommentCompoundExperience).initExperience.abort({
                        abortReason: 'Draft annotation removed from document'
                    });
                    return;
                } else if (!sidebarEl.current) (0, $3YBks.createInlineCommentCompoundExperience).initExperience.fail(new Error('Missing create comment ui'));
                else {
                    const commentUIVerticalDistanceFromAnnotation = Math.abs(draftAnnotationElement.getBoundingClientRect().top - sidebarEl.current.getBoundingClientRect?.().top); // The 40 pixel allowance has been arbitrarily chosen to allow for some wiggle room
                    if (commentUIVerticalDistanceFromAnnotation > 40) {
                        const isVisible = sidebarEl.current.checkVisibility();
                        if (isVisible) {
                            // if it's fully visible, but misaligned, we don't treat this as a failure
                            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.debug({
                                error: new Error('View Created Comment UI too far from annotation'),
                                createAnalyticsEvent: createAnalyticsEvent,
                                extraAttributes: {
                                    misalignedBy: commentUIVerticalDistanceFromAnnotation
                                }
                            });
                            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.complete();
                        } else {
                            (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
                                misalignedBy: commentUIVerticalDistanceFromAnnotation
                            });
                            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.softFail(new Error('Draft Comment UI is setup too far from annotation'));
                        }
                    } else (0, $3YBks.createInlineCommentCompoundExperience).initExperience.complete();
                }
            });
        }, 1000);
    };
    if (loading || error) {
        (0, $3YBks.createInlineCommentCompoundExperience).initExperience.debugPoint(`CreateComment dialog ${loading ? 'loading' : 'error'}`, {
            error: error?.message ?? '',
            loading: loading
        });
        return null;
    }
    const spaceId = pageInfo?.space?.id ?? '';
    const pageType = pageInfo?.type ?? ''; // User page permissions
    const operations = pageInfo?.operations || [];
    const spaceOperations = (0, $9wGTI.fg)('confluence_comments_space_operations_permissions') ? pageInfo?.space?.operations || [] : [];
    const canAddComment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'comment');
    const canAddAttachment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'attachment') || spaceOperations.some((op)=>op?.operation === 'create' && op?.targetType === 'attachment');
    const hasMediaUploadPermissions = canAddComment && canAddAttachment; // Don't render CreateComment at all until author data is ready (only when experiment is enabled)
    // This ensures both CommentAuthor and CommentEditor render together with data ready
    if (!isAuthorReady && (0, $6mKj3.expValEquals)('confluence_comment_improve_author_paint', 'isEnabled', true)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $B3Avz.CommentSidebar), {
        pageId: pageId,
        onClose: handleOnClose,
        isEditor: isEditor,
        annotationElement: annotationElement,
        sidebarOffset: sidebarOffset,
        isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
        sidebarEl: sidebarEl,
        isSticky: isSticky,
        isFabricPage: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f4c77c6e390a7914$var$Container, {
        ref: commentContainerElementRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $daq5m.CommentAuthor), {
        size: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? 'small' : 'medium',
        commentMode: "create",
        userId: userId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f4c77c6e390a7914$var$CommentEditorContainer, null, (showFyi || hasShownFyiRef.current) && (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4rKYp.AgentMentionFyiNudgeAsync), {
        visible: showFyi,
        agent: agent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hXzKU.LazyCommentEditor), {
        pageId: pageId,
        pageType: pageType,
        spaceId: spaceId,
        appearance: "chromeless",
        EditorComponent: (0, $koEBx.ChromelessEditor),
        onSaveComment: handleSaveComment,
        onContentChange: onChange,
        onContentChangeWithData: handleContentChangeWithData,
        commentMode: "create",
        commentType: isEditor ? 'edit-inline' : 'inline',
        onEditorReady: onEditorLoad,
        hideWatchCheckbox: true,
        pageMode: isEditor ? 'edit' : 'view',
        shouldWarnOnInternalNavigation: true,
        useNewWarningModal: true,
        setShouldRefetch: ()=>setShouldRefetch(true),
        hasMediaUploadPermissions: hasMediaUploadPermissions,
        commentContainerElementRef: commentContainerElementRef,
        wasDraftAnnotationRemoved: wasDraftAnnotationRemoved,
        isStandaloneComment: true,
        isOffline: isOffline
    }))));
};
const $f4c77c6e390a7914$export$b217475cf0d7b767 = (0, $7aRa9.withFlags)($f4c77c6e390a7914$var$CreateCommentComponent); /**
                                                                                                                         *
                                                                                                                         * Exported for testing purposes only
                                                                                                                         *
                                                                                                                         * This function is used to find the draft annotation element in the DOM.
                                                                                                                         * It checks both the renderer and editor for the draft annotation element.
                                                                                                                         *
                                                                                                                         * In some scenarios, there are duplicate draft annotations in the DOM such
                                                                                                                         * as in the renderer where the dom for table headers is repeated.
                                                                                                                         *
                                                                                                                         * To mitigate this, we get all possible draft annotation elements and
                                                                                                                         * and return the first one that has a height greater than 0.
                                                                                                                         *
                                                                                                                         * If no draft annotation element is found, it returns null.
                                                                                                                         */ 
function $f4c77c6e390a7914$export$292a5d148db8f191() {
    if (typeof document === 'undefined') return null;
     // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const possibleAnnotations = document.querySelectorAll((0, $9wGTI.fg)('confluence_fe_create_inline_comment_exp_coverage_2') ? '[data-annotation-draft-mark="true"], .ak-editor-annotation-draft, .ak-editor-block-annotation-draft' : '[data-annotation-draft-mark="true"], .ak-editor-annotation-draft');
    if (possibleAnnotations.length === 1) // In cases where there is only one draft annotation, we can return it directly
    // and avoid the performance hit where reflow is triggered by checking if the
    // annotation has a height greater than 0.
    return possibleAnnotations[0];
    for(let i = 0; i < possibleAnnotations.length; i++){
        if (possibleAnnotations[i].getBoundingClientRect().height > 0) return possibleAnnotations[i];
    }
    return null;
}
module.exports["CreateComment"] = $f4c77c6e390a7914$export$b217475cf0d7b767;

});

parcelRegister("9dDPb", function(module, exports) {
/**
 * @generated SignedSource<<165cd3926d0becb5600b642c03ee6c6f>>
 * @relayHash 53d10a195ebf90f6f61c9c986fa7c9e9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0d5eae455a43e1b40c154fe51c43e195ecb9291e9b50f3ec9fa5dcc7d168f047
const $122b34084b15b4af$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeReactionsAndReplies"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v6 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v5 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v7 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v8 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v5 /*: any*/ 
    }, v9 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v10 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "type"
    }, v12 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v13 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v14 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    v12 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v12 /*: any*/ ,
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v18 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            v16 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v19 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v20 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v21 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v22 = {
        "kind": "ScalarField",
        "name": "when"
    }, v23 = {
        "kind": "ScalarField",
        "name": "number"
    }, v24 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v21 /*: any*/ 
                ]
            },
            v22 /*: any*/ ,
            v23 /*: any*/ 
        ]
    }, v25 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v27 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v28 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v21 /*: any*/ ,
            v25 /*: any*/ ,
            v26 /*: any*/ ,
            v27 /*: any*/ 
        ]
    }, v29 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            {
                "kind": "Variable",
                "name": "pageId",
                "variableName": "pageId"
            }
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v30 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v31 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v30 /*: any*/ ,
            v11 /*: any*/ ,
            v16 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v32 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v30 /*: any*/ ,
                    v21 /*: any*/ 
                ]
            },
            v22 /*: any*/ ,
            v23 /*: any*/ 
        ]
    }, v33 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v30 /*: any*/ ,
            v21 /*: any*/ ,
            v25 /*: any*/ ,
            v26 /*: any*/ ,
            v27 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CreateCommentInlineCommentMutation",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "createInlineComment",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        v18 /*: any*/ ,
                        v19 /*: any*/ ,
                        v20 /*: any*/ ,
                        v24 /*: any*/ ,
                        v28 /*: any*/ ,
                        {
                            "condition": "includeReactionsAndReplies",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                v29 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v29 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CreateCommentInlineCommentMutation",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "createInlineComment",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        v31 /*: any*/ ,
                        v19 /*: any*/ ,
                        v20 /*: any*/ ,
                        v32 /*: any*/ ,
                        v33 /*: any*/ ,
                        {
                            "condition": "includeReactionsAndReplies",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                v29 /*: any*/ ,
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "replies",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v31 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v32 /*: any*/ ,
                                        v33 /*: any*/ ,
                                        v29 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "53d10a195ebf90f6f61c9c986fa7c9e9",
            "id": "0d5eae455a43e1b40c154fe51c43e195ecb9291e9b50f3ec9fa5dcc7d168f047",
            "metadata": {},
            "name": "CreateCommentInlineCommentMutation",
            "operationKind": "mutation",
            "text": "mutation CreateCommentInlineCommentMutation($input:CreateInlineCommentInput!,$pageId:ID!,$includeReactionsAndReplies:Boolean!){createInlineComment(input:$input){id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeReactionsAndReplies){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}\n    replies@include(if:$includeReactionsAndReplies){id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}}}"
        }
    };
}();
$122b34084b15b4af$var$node.hash = "a3c6b6f761ae740a51004ae0c2e8fb68";
var $122b34084b15b4af$export$2e2bcd8739ae039 = $122b34084b15b4af$var$node;
module.exports["default"] = $122b34084b15b4af$export$2e2bcd8739ae039;

});

parcelRegister("dLr6w", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");


var $cUiCf = parcelRequire("cUiCf");

const $4baccafa846af1c4$export$fba4d5c7ef076998 = ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== userId) {
        t0 = !userId || !(0, $6mKj3.expValEquals)("confluence_comment_improve_author_paint", "isEnabled", true);
        $[0] = userId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = {
            skip: t0,
            fetchPolicy: "cache-first"
        };
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    const { isReady: isReady } = (0, $cUiCf.useCommentAuthorQuery)(userId ?? undefined, t1);
    if (!(0, $6mKj3.expValEquals)("confluence_comment_improve_author_paint", "isEnabled", true)) return true;
    if (!userId) return true;
    return isReady;
};
module.exports["useCurrentUserAvatarReady"] = $4baccafa846af1c4$export$fba4d5c7ef076998;

});

parcelRegister("6cWI7", function(module, exports) {

var $l4jQJ = parcelRequire("l4jQJ");


var $cozmU = parcelRequire("cozmU");


var $308Wd = parcelRequire("308Wd");


var $6mKj3 = parcelRequire("6mKj3");


var $kgNLQ = parcelRequire("kgNLQ");


var $NYiei = parcelRequire("NYiei");

// This hook returns a mutation function to create a new inline comment. Because the new Comments
// Data Manager caches all the data for comments in Relay, we need to define the mutation here so
// that the cache can be updated fully when a new comment is created - and that means the mutation
// needs to return the full comment data structure that we are using in the returned query part of
// the mutation.  Since that returned query is quite large, we define it here in its own hook to
// avoid having it in many places in the codebase - which makes the code harder to read and could
// lead to the multiple copies getting out of sync.
// Data Mutation Definition:
// Unfortunately our Relay-friendly type generation tools don't support using GQL fragments yet -
// but in order to keep the definition of the comment fields in sync (so the cache update fragment
// is always in sync with the full query) we will need to manually make any changes to one
// definition in any others as well, until our tooling supports fragments and then we move to a
// more fragmented-based approach.  Note there are also comment queries or fragments in the
// following files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data/src/hooks/useCommentById.ts
// - next/packages/comments-data-manager/src/updateCommentInCache.ts
// - next/packages/comments-data-manager/src/useCreateObjectCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineReplyMutation.ts
// - next/packages/object-comments/src/components/ObjectCommentContainer.tsx
// (Note that there is another exported GraphQL mutation variable named "CreateInlineCommentMutation"
// that is exported from @confluence/inline-comments-queries. It's okay that these are the same
// variable name because the other one does not seem to be imported anywhere in the codebase at
// present, this variable is only used internally in this file, and the actual muation's name -
// useCreateInlineCommentMutation - is unique so GQL won't complain.)
const $03f1ee89907a0c1d$var$CreateInlineCommentMutation = (0, $l4jQJ.default);
const $03f1ee89907a0c1d$export$e30f6438d916be51 = ({ userId: userId, displayName: displayName, adf: adf, pageId: pageId, annotationId: annotationId, inlineText: inlineText })=>{
    const nowISOString = new Date().toISOString();
    return {
        createInlineComment: {
            author: {
                __typename: 'KnownUser',
                accountId: userId,
                displayName: displayName,
                permissionType: null,
                profilePicture: {
                    path: userId ? `/wiki/aa-avatar/${userId}` : '',
                    __typename: 'Icon'
                },
                type: 'known'
            },
            body: {
                value: JSON.stringify(adf),
                __typename: 'DocumentBody'
            },
            container: {
                id: pageId,
                __typename: 'Content'
            },
            contentStatus: 'current',
            createdAt: {
                value: '',
                __typename: 'ConfluenceDate'
            },
            createdAtNonLocalized: nowISOString,
            // required to correctly sort comments
            id: (0, $kgNLQ.OPTIMISTIC_SAVE_COMMENT_ID),
            links: {
                editui: null,
                webui: null,
                __typename: 'Map_LinkType_String'
            },
            location: {
                __typename: 'InlineComment',
                type: 'INLINE',
                inlineMarkerRef: annotationId,
                inlineResolveProperties: {
                    isDangling: false,
                    resolved: false,
                    resolvedFriendlyDate: null,
                    resolvedTime: null,
                    resolvedUser: null,
                    __typename: 'InlineCommentResolveProperties'
                },
                inlineText: inlineText
            },
            parentId: null,
            permissions: {
                isEditable: true,
                isRemovable: true,
                isResolvable: true,
                __typename: 'CommentPermissions'
            },
            version: {
                by: {
                    __typename: 'KnownUser',
                    accountId: userId,
                    displayName: displayName,
                    type: 'user'
                },
                friendlyWhen: '',
                when: nowISOString,
                // required to show the creation time and tooltip correctly
                number: 1,
                __typename: 'Version'
            },
            __typename: 'Comment'
        }
    };
};
const $03f1ee89907a0c1d$export$10606ca3587bb707 = ({ contentId: contentId })=>{
    const { addCommentInCache: addCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    });
    const [createInlineCommentFn] = (0, $308Wd.useMutationInterop)($03f1ee89907a0c1d$var$CreateInlineCommentMutation, {
        ...(0, $kgNLQ.buildMutationContextForNoNetworkError)(),
        __callerPackage__: "comments-data-manager"
    });
    const addEmptyInlineRepliesAndReactions = (0, $cozmU.useCallback)((commentData)=>{
        return commentData ? {
            ...commentData,
            contributors: [],
            replies: [],
            reactionsSummary: (0, $6mKj3.expValEquals)('confluence_fe_use_create_comment_exclude_reactions', 'isEnabled', true) ? (0, $kgNLQ.emptyReactionsSummary) : commentData.reactionsSummary ?? (0, $kgNLQ.emptyReactionsSummary)
        } : // @ts-expect-error - FIXME: This error was surfaced after enabling the `typescriptExcludeUndefinedFromNullableUnion`
        // Relay compiler option. Previously, `undefined` was incorrectly included in nullable unions in generated types; this option removes it. The owning team should fix this properly.
        undefined;
    }, []);
    // This is the interop mutation function that will be used by components that need to create
    // inline comments. It will either call the new Comments Data Manager path or the old Apollo
    // mutation path depending on whether the relevant experiment is enabled.
    const createInlineCommentInterop = (0, $cozmU.useCallback)(({ originalMutationFn: originalMutationFn, options: options, onCacheUpdateError: onCacheUpdateError })=>{
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
            // Strip out the old update function and other options, and adjust variables as needed
            // The includeReactionsAndReplies variable is needed by some of the legacy mutations but is
            // not needed by the new Comments Data Manager. So remove it if we're using the new path -
            // otherwise Typescript will complain and GQL may error as well.
            const { variables: variables } = options;
            const { includeReactionsAndReplies: _includeReactionsAndReplies, ...newVariables } = variables ?? {
                includeReactionsAndReplies: undefined
            };
            const updateNewCommentInCache = (_dataProxy, mutationResult)=>{
                addCommentInCache({
                    newComment: addEmptyInlineRepliesAndReactions(mutationResult.data.createInlineComment),
                    onError: onCacheUpdateError
                });
            };
            return createInlineCommentFn({
                variables: {
                    ...newVariables,
                    includeReactionsSummary: !(0, $6mKj3.expValEquals)('confluence_fe_use_create_comment_exclude_reactions', 'isEnabled', true)
                },
                update: updateNewCommentInCache,
                optimisticResponse: options.optimisticResponse ?? undefined
            });
        } else return originalMutationFn(options);
    }, [
        addCommentInCache,
        addEmptyInlineRepliesAndReactions,
        createInlineCommentFn
    ]);
    return {
        createInlineCommentInterop: createInlineCommentInterop
    };
};
module.exports["getOptimisticResponse"] = $03f1ee89907a0c1d$export$e30f6438d916be51;
module.exports["useCreateInlineCommentMutation"] = $03f1ee89907a0c1d$export$10606ca3587bb707;

});

parcelRegister("l4jQJ", function(module, exports) {
/**
 * @generated SignedSource<<2007330c9b6e3fb554eea62fca98ede4>>
 * @relayHash 44102a25791a45664a7cee556a06b417
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c986ca4c90a941ccb373a83d557efa12425e0ed56bc3f91ac8ce141534051446
const $3dcbd79e6f23278f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeReactionsSummary"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v8 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v10 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v11 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v12 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v13 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "createInlineComment",
            "plural": false,
            "selections": [
                v3 /*: any*/ ,
                {
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "profilePicture",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        v6 /*: any*/ ,
                        v7 /*: any*/ 
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "representation",
                            "value": "ATLAS_DOC_FORMAT"
                        }
                    ],
                    "concreteType": "DocumentBody",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": v8 /*: any*/ ,
                    "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "container",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ 
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "contentStatus"
                },
                {
                    "concreteType": "ConfluenceDate",
                    "kind": "LinkedField",
                    "name": "createdAt",
                    "plural": false,
                    "selections": v8 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "createdAtNonLocalized"
                },
                {
                    "concreteType": "Map_LinkType_String",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "name": "location",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "InlineCommentResolveProperties",
                                    "kind": "LinkedField",
                                    "name": "commentResolveProperties",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "FooterComment"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "inlineMarkerRef"
                                },
                                {
                                    "concreteType": "InlineCommentResolveProperties",
                                    "kind": "LinkedField",
                                    "name": "inlineResolveProperties",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDangling"
                                        },
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "inlineText"
                                }
                            ],
                            "type": "InlineComment"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "parentId"
                },
                {
                    "concreteType": "CommentPermissions",
                    "kind": "LinkedField",
                    "name": "permissions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEditable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isRemovable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isResolvable"
                        }
                    ]
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "by",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                v5 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "friendlyWhen"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "when"
                        }
                    ]
                },
                {
                    "condition": "includeReactionsSummary",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "childType",
                                    "value": "comment"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "contentType",
                                    "value": "page"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "pageId",
                                    "variableName": "pageId"
                                }
                            ],
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "reactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "ari"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "containerAri"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "reactionsCount"
                                },
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "emojiId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "reacted"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCreateInlineCommentMutation",
            "selections": v13 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCreateInlineCommentMutation",
            "selections": v13 /*: any*/ 
        },
        "params": {
            "cacheID": "44102a25791a45664a7cee556a06b417",
            "id": "c986ca4c90a941ccb373a83d557efa12425e0ed56bc3f91ac8ce141534051446",
            "metadata": {},
            "name": "useCreateInlineCommentMutation",
            "operationKind": "mutation",
            "text": "mutation useCreateInlineCommentMutation($pageId:ID!,$input:CreateInlineCommentInput!,$includeReactionsSummary:Boolean!){createInlineComment(input:$input){id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeReactionsSummary){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}}}"
        }
    };
}();
$3dcbd79e6f23278f$var$node.hash = "1024b1212d3a391069987015908aee0c";
var $3dcbd79e6f23278f$export$2e2bcd8739ae039 = $3dcbd79e6f23278f$var$node;
module.exports["default"] = $3dcbd79e6f23278f$export$2e2bcd8739ae039;

});

parcelRegister("3Xfi8", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $7nPJ6 = parcelRequire("7nPJ6");


var $6HwWx = parcelRequire("6HwWx");

const $6a7e747c5d5174c7$export$9be7dcbe458ba189 = ({ annotationElement: annotationElement, isEditor: isEditor })=>{
    const classToCheck = '.pm-table-container';
    let elementToObserve = undefined;
    // elements to observe, these are different than elements that determine if the table is sticky
    if (isEditor) {
        if ((0, $6mKj3.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow')) elementToObserve = annotationElement?.closest(classToCheck)?.querySelector('.pm-table-wrapper > table > tbody > tr');
        else elementToObserve = annotationElement?.closest(classToCheck)?.parentElement?.querySelector('.pm-table-sticky-sentinel-top');
    } else elementToObserve = annotationElement?.closest(classToCheck);
    const [isSticky, setIsSticky] = (0, $7nPJ6.useIsSticky)({
        isEditor: isEditor,
        elementToObserve: elementToObserve
    });
    (0, $6HwWx.useStickyTableHeaderObserver)({
        setIsSticky: setIsSticky,
        isEditor: isEditor,
        elementToObserve: elementToObserve
    });
    // Check if annotationElement is a child of tr (th element) and th's immediate parent is tbody
    const thElement = annotationElement?.closest('th');
    if (thElement) {
        const trElement = thElement.parentElement;
        const tbodyElement = trElement?.parentElement;
        // If tr is the first child of tbody, return false
        if (tbodyElement?.firstElementChild !== trElement) return {
            isSticky: false
        };
    }
    // if annotation element is inside a nested table, then return false
    if (annotationElement?.closest('.pm-table-nested-table-with-controls')) return {
        isSticky: false
    };
    // if annotation element is not inside a table header, then return false
    if (!annotationElement?.closest('th')) return {
        isSticky: false
    };
    // Remove debug console logs
    return {
        isSticky: isSticky
    };
};
module.exports["useShouldCommentSidebarBeSticky"] = $6a7e747c5d5174c7$export$9be7dcbe458ba189;

});

parcelRegister("7nPJ6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $jW2Ig = parcelRequire("jW2Ig");

const $b1509838bb0fcfff$export$2cf94d5875603a88 = ({ isEditor: isEditor, elementToObserve: elementToObserve })=>{
    // check if table is already sticky
    const initialStickyState = elementToObserve ? (0, $jW2Ig.getIsSticky)(isEditor && (0, $6mKj3.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') ? elementToObserve : elementToObserve.parentElement, isEditor) : false;
    const [isSticky, setIsSticky] = (0, $cozmU.useState)((0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic') && initialStickyState);
    // Sticky state effect for post-render (useEffect)
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) return;
        if ((0, $6mKj3.expValEquals)('confluence_compute_sidebar_styles_pre-render', 'isEnabled', true)) return;
        setIsSticky(initialStickyState);
    }, [
        initialStickyState
    ]);
    // Sticky state effect for pre-render (useLayoutEffect)
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) return;
        if (!(0, $6mKj3.expValEquals)('confluence_compute_sidebar_styles_pre-render', 'isEnabled', true)) return;
        setIsSticky(initialStickyState);
    }, [
        initialStickyState
    ]);
    return [
        isSticky,
        setIsSticky
    ];
};
module.exports["useIsSticky"] = $b1509838bb0fcfff$export$2cf94d5875603a88;

});

parcelRegister("jW2Ig", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");

const $28177804efc2055d$export$17682ee29db08043 = (tableElement)=>{
    return Boolean(tableElement?.getAttribute('mode') === 'stick');
};
const $28177804efc2055d$export$4676b00e54210cb0 = (tableElement)=>{
    if ((0, $6mKj3.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow')) return Boolean(tableElement?.classList.contains('pm-table-row-native-sticky-active'));
    return Boolean(tableElement?.classList.contains('pm-table-sticky'));
};
const $28177804efc2055d$export$f3993a99776f75ca = (tableElement, isEditor)=>isEditor ? $28177804efc2055d$export$4676b00e54210cb0(tableElement) : $28177804efc2055d$export$17682ee29db08043(tableElement);
module.exports["isStickyInViewMode"] = $28177804efc2055d$export$17682ee29db08043;
module.exports["isStickyInEditMode"] = $28177804efc2055d$export$4676b00e54210cb0;
module.exports["getIsSticky"] = $28177804efc2055d$export$f3993a99776f75ca;

});

parcelRegister("6HwWx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $jW2Ig = parcelRequire("jW2Ig");

const $cf08b287de1b8d82$export$204fd756b18b92ff = ({ setIsSticky: setIsSticky, isEditor: isEditor, elementToObserve: elementToObserve })=>{
    // if the experiment is enabled and this is the editor, we need to observe the table element
    // else, we observe the parent element
    const stickyElementToObserve = isEditor && (0, $6mKj3.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') ? elementToObserve : elementToObserve?.parentElement;
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) return;
        // Create mutation observer to track class changes
        const stickyTableHeaderObserver = new MutationObserver((mutationsList)=>{
            mutationsList.forEach((mutation)=>{
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const target = mutation.target;
                    if (isEditor && (0, $jW2Ig.isStickyInEditMode)(target) || (0, $jW2Ig.isStickyInViewMode)(target)) setIsSticky(true);
                    else setIsSticky(false);
                }
            });
        });
        // Start observing class changes
        if (stickyElementToObserve) stickyTableHeaderObserver.observe(stickyElementToObserve, {
            attributes: true,
            attributeFilter: [
                'class'
            ]
        });
        // Clean up all observers
        return ()=>{
            stickyTableHeaderObserver.disconnect();
        };
    }, [
        stickyElementToObserve,
        isEditor,
        setIsSticky
    ]);
};
module.exports["useStickyTableHeaderObserver"] = $cf08b287de1b8d82$export$204fd756b18b92ff;

});

parcelRegister("eA7s6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aHcFH = parcelRequire("aHcFH");

const $168172ede45a02b4$export$aca484f2c8185777 = ({ annotationElement: annotationElement, isEditor: isEditor, isViewCommentMode: isViewCommentMode, windowWidth: windowWidth, isSticky: // Re-calculate when this changes
isSticky })=>{
    return (0, $cozmU.useMemo)(()=>{
        if (!annotationElement) return 0;
        if (isEditor) return (0, $aHcFH.calculateEditorOffsetFromParent)(annotationElement, '.fabric-editor-popup-scroll-parent');
        return (0, $aHcFH.calculateRendererOffsetFromParent)(annotationElement, `[data-annotation-draft-mark="true"]`, Boolean(isViewCommentMode));
    // We want to re-calculate when the window width changes or the comment sidebar becomes sticky / unsticky
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isEditor,
        annotationElement,
        isViewCommentMode,
        windowWidth,
        isSticky
    ]);
};
module.exports["useCommentSidebarOffset"] = $168172ede45a02b4$export$aca484f2c8185777;

});

parcelRegister("a3q17", function(module, exports) {

var $fQ3iN = parcelRequire("fQ3iN");


var $jX1qB = parcelRequire("jX1qB");

const $60a54f1e533f2ef6$export$52ff686bd4414bc5 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY)
});
const $60a54f1e533f2ef6$export$ac7f79e65475cee7 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY)
});
const $60a54f1e533f2ef6$export$321e1f68b293bf76 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        },
        {
            key: 'highlightsRendered',
            endMark: 'highlightsRendered'
        }
    ]
});
const $60a54f1e533f2ef6$export$fc794218ec0a6fa5 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: 'direct-comment-data-flow',
    timings: [
        {
            key: 'commentCreationStart',
            startMark: 'commentCreationStart'
        },
        {
            key: 'commentCreationEnd',
            endMark: 'commentCreationEnd'
        },
        {
            key: 'commentDataLoad',
            startMark: 'commentDataLoadStart',
            endMark: 'commentDataLoadEnd'
        }
    ]
});
module.exports["EDITOR_INLINE_COMMENT_RENDER_METRIC"] = $60a54f1e533f2ef6$export$52ff686bd4414bc5;
module.exports["RENDERER_INLINE_COMMENT_RENDER_METRIC"] = $60a54f1e533f2ef6$export$ac7f79e65475cee7;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_METRIC"] = $60a54f1e533f2ef6$export$321e1f68b293bf76;
module.exports["DIRECT_COMMENT_DATA_FLOW_METRIC"] = $60a54f1e533f2ef6$export$fc794218ec0a6fa5;

});

parcelRegister("B3Avz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9EemN = parcelRequire("9EemN");


var $kNIYN = parcelRequire("kNIYN");


var $l3wuH = parcelRequire("l3wuH");


var $3izAL = parcelRequire("3izAL");


var $kz1Yj = parcelRequire("kz1Yj");


var $buxP3 = parcelRequire("buxP3");


var $3PNw6 = parcelRequire("3PNw6");


var $a1L5E = parcelRequire("a1L5E");


var $lpNn5 = parcelRequire("lpNn5");


var $6mKj3 = parcelRequire("6mKj3");


var $5vi32 = parcelRequire("5vi32");


var $9FoVw = parcelRequire("9FoVw");


var $aHcFH = parcelRequire("aHcFH");


var $i49vP = parcelRequire("i49vP");


var $eToX6 = parcelRequire("eToX6");


var $bSvtO = parcelRequire("bSvtO");


var $8SCD6 = parcelRequire("8SCD6");


var $cMvMc = parcelRequire("cMvMc");


var $5fMeR = parcelRequire("5fMeR");


var $3D12W = parcelRequire("3D12W");


var $jvYFk = parcelRequire("jvYFk");


var $3mVfX = parcelRequire("3mVfX");


var $kRW4Y = parcelRequire("kRW4Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $9wGTI = parcelRequire("9wGTI");


var $666Tc = parcelRequire("666Tc");


var $aWwYt = parcelRequire("aWwYt");


var $gnkil = parcelRequire("gnkil");


var $cZa7r = parcelRequire("cZa7r");


var $8aF6s = parcelRequire("8aF6s");


var $6wiaZ = parcelRequire("6wiaZ");


var $bEwJH = parcelRequire("bEwJH");


var $bXQxx = parcelRequire("bXQxx");

const $2cc0402d98a7d80d$export$b8454eaf88df51d0 = (entry, setIsSticky, setSidebarOffset, sidebarOffset)=>{
    if (entry.intersectionRatio === 0) {
        setIsSticky(false);
        setSidebarOffset(sidebarOffset);
    } else {
        setIsSticky(true);
        setSidebarOffset(// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expValEquals)('confluence_fe_fix_sticky_comment_sidebar_position', 'isEnabled', true) && (0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic') ? (0, $bEwJH.STICKY_COMMENT_VERTICAL_OFFSET_VIEW) : (0, $bEwJH.STICKY_COMMENT_VERTICAL_OFFSET_VIEW_OLD));
    }
};
const $2cc0402d98a7d80d$var$redesignedViewAllStyle = (0, $buxP3.xcss)({
    position: 'absolute',
    right: 'space.500',
    // This gives us 4px between the X and the comment icon
    top: 'space.150' // This lines us up exactly with X
});
const $2cc0402d98a7d80d$var$commentHeaderStyle = (0, $buxP3.xcss)({
    flexDirection: 'column',
    display: 'flex',
    marginTop: 'space.400'
});
const $2cc0402d98a7d80d$var$commentNewHeaderMargin = (0, $buxP3.xcss)({
    marginTop: 'space.500'
});
const $2cc0402d98a7d80d$var$shadowElementStyle = {
    height: '4px',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.15) 0%, transparent 100%)',
    width: '100%',
    margin: '0',
    padding: '0'
};
const $2cc0402d98a7d80d$var$commentEditorStyle = (0, $buxP3.xcss)({
    marginTop: 'space.0'
});
const $2cc0402d98a7d80d$var$boxWithMaxHeight = (0, $buxP3.xcss)({
    maxHeight: 'calc(100vh - 300px)',
    overflowY: 'auto'
});
const $2cc0402d98a7d80d$var$boxWithoutMaxHeight = (0, $buxP3.xcss)({
    overflowY: 'visible'
});
const $2cc0402d98a7d80d$var$boxWithDynamicMaxHeightAuto = (0, $buxP3.xcss)({
    overflowY: 'auto'
});
const $2cc0402d98a7d80d$export$d560bdb1ceec916a = ({ pageId: pageId, onClose: onClose, annotationElement: annotationElement, navigationOptions: navigationOptions, isEditor: isEditor, isViewCommentMode: isViewCommentMode, children: children, sidebarOffset: sidebarOffset, commentId: commentId, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar, sidebarEl: sidebarEl, annotationId: annotationId, inlineCommentRef: inlineCommentRef = ()=>{}, nudgeRef: nudgeRef, isSticky: isSticky, isFabricPage: isFabricPage, authorName: authorName, setPopupsScrollableElement: setPopupsScrollableElement, onMaxHeightApplied: onMaxHeightApplied, isReaction: isReaction })=>{
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const [oldIsSticky, setOldIsSticky] = (0, $cozmU.useState)(false);
    const [newSidebarOffset, setSidebarOffset] = (0, $cozmU.useState)(sidebarOffset);
    const [showA11yAnnouncement, setShowA11yAnnouncement] = (0, $cozmU.useState)(false);
    const [isScrolled, setIsScrolled] = (0, $cozmU.useState)(false);
    const [isRefSet, setIsRefSet] = (0, $cozmU.useState)(false);
    const { commentSidebarContext: commentSidebarContext } = (0, $cZa7r.useAnnotations)();
    // Compute isMaxHeightEnabledForSticky first to pass to hook
    const isMaxHeightEnabledForSticky = (0, $6mKj3.expValEquals)('confluence_comment_enable_maxheight', 'isEnabled', true) || isSticky;
    // Compute hasMaxHeight locally and notify parent via callback
    const { hasMaxHeight: hasMaxHeight, dynamicMaxHeight: dynamicMaxHeight } = (0, $6wiaZ.useHasMaxHeight)({
        sidebarEl: sidebarEl,
        isRefSet: isRefSet,
        isFabricPage: isFabricPage,
        isSticky: isSticky,
        annotationElement: annotationElement,
        isEditor: isEditor,
        sidebarOffset: sidebarOffset,
        isMaxHeightEnabledForSticky: isMaxHeightEnabledForSticky
    });
    const applyMaxHeightStyles = hasMaxHeight && isMaxHeightEnabledForSticky;
    // Notify parent when max height styles change
    (0, $cozmU.useEffect)(()=>{
        onMaxHeightApplied?.(!!applyMaxHeightStyles);
    }, [
        applyMaxHeightStyles,
        onMaxHeightApplied
    ]);
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey } = (0, $3mVfX.useCommentsPanelActions)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const shouldHideViewAllCommentsButtonForNativeEmbedUiUpdates = isEmbeddedConfluence && ((0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) || (0, $9wGTI.fg)('platform_native_embeds_rollout_non_maui_experience'));
    (0, $cozmU.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) return;
        let offset = 0;
        if (annotationElement && !isEditor) {
            let scrollParent;
            if (isEditor) {
                scrollParent = document.querySelector('.fabric-editor-popup-scroll-parent');
                offset = (0, $aHcFH.calculateElementOffset)(annotationElement, scrollParent);
            } else {
                /*
        There's two cases here: a view comment and a create comment.
        We need the correct scrollParent for each case.
        Since it's not the editor in this logical branch we should use #content as the scrollParent.
        */ scrollParent = document.querySelector('div#content[data-inline-comments-target="true"]');
                if (scrollParent) {
                    let annotationOffset = 0;
                    if (isViewCommentMode) // If the sidebar is rendering a view comment, we can use the annotationElement directly.
                    annotationOffset = (0, $aHcFH.calculateElementOffset)(annotationElement);
                    else {
                        /*
            If the sidebar is rendering a create comment the annotationElement is actually the wrapperDOM
            we need to find the actual highlight instead. We can find this by looking for the mark because
            there will always be a mark before the create comment button is clicked.
            */ const actualHiglightElement = scrollParent.querySelector(`[data-annotation-draft-mark="true"]`);
                        annotationOffset = (0, $aHcFH.calculateElementOffset)(actualHiglightElement, undefined, true);
                    }
                    offset = annotationOffset + scrollParent.offsetTop;
                }
            }
            setSidebarOffset(offset);
        }
    }, [
        annotationElement,
        isEditor,
        isViewCommentMode
    ]);
    (0, $cozmU.useEffect)(()=>{
        // handles media comment scroll
        if (isRefSet && sidebarEl.current && isEditor) {
            if (isOpeningMediaCommentFromToolbar && annotationElement) (0, $i49vP.scrollToElementInEditor)({
                targetElement: annotationElement,
                viewingRoomOffset: -150
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isRefSet,
        annotationElement,
        isOpeningMediaCommentFromToolbar,
        commentId,
        isViewCommentMode,
        isEditor
    ]);
    (0, $cozmU.useEffect)(()=>{
        let mouseTrap;
        let focusTrap;
        if (isRefSet && sidebarEl.current) {
            mouseTrap = new (0, (/*@__PURE__*/$parcel$interopDefault($9EemN)))(sidebarEl.current);
            // prevent saving via mod+enter from also publishing the page in edit mode
            mouseTrap.bind((0, $gnkil.INLINE_COMMENTS_SHORTCUT), (event)=>{
                event.stopPropagation();
            });
            if (!showA11yAnnouncement) // We need to show this on a timer so the `aria-live` listener will respond with our message
            setTimeout(()=>{
                setShowA11yAnnouncement(true);
            }, 100);
        }
        return ()=>{
            if (mouseTrap) mouseTrap.reset();
            if (focusTrap) focusTrap.deactivate();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isRefSet
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isRefSet || !isViewCommentMode || isEditor || !sidebarEl.current) return;
        // capture current val to use for cleanup down the line
        const sidebarNode = sidebarEl.current;
        // Both options are important here - by default focus scroll the browser, which can be jarring on clicks
        // We also prevent focus from shifting a lot when clicking buttons for legacy browser support, which causes unexpected focus:visible styling
        // Better for now to prevent it entirely, than to handle each one-off case
        (0, $aHcFH.focusElementAndUpdateTabIndex)(sidebarNode, {
            focusVisible: false,
            preventScroll: true
        });
        if (!annotationId) return;
        // This must happen on keydown instead of focusout. By the time focusout fires,
        // pointer interactions may already be moving focus to another annotation, and restoring
        // focus from the old sidebar can bounce the user back to the previously open thread.
        // Generally speaking, we also can't trust existing focus logic, so can't rely on focus:visible
        // Handling the boundary Tab / Shift+Tab cases here keeps the restore path keyboard-only.
        const handleKeyDown = (e)=>{
            if (e.key !== 'Tab') return;
            const activeElement = document.activeElement;
            if (!(activeElement instanceof HTMLElement) || !sidebarNode.contains(activeElement)) return;
            const isLeavingBackwards = e.shiftKey && (activeElement === sidebarNode || (0, $aHcFH.isFirstTabbableElement)(sidebarNode, activeElement));
            const isLeavingForwards = !e.shiftKey && (0, $aHcFH.isLastTabbableElement)(sidebarNode, activeElement);
            if (!isLeavingBackwards && !isLeavingForwards) return;
            const annotationEl = (0, $aHcFH.getFocusableElementFromMarkerRef)(annotationId);
            if (!annotationEl) return;
            e.preventDefault();
            // Use the default browser focus when leaving the modal, since we don't need
            // to update tabIndex here.
            annotationEl.focus();
        };
        sidebarNode.addEventListener('keydown', handleKeyDown, true);
        return ()=>{
            sidebarNode.removeEventListener('keydown', handleKeyDown, true);
        };
    // No need to have sidebarEL in here - handled by isRefSet
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isRefSet,
        isViewCommentMode,
        isEditor,
        annotationId
    ]);
    const handlePropagation = (event)=>{
        /**
     * prevents an event bubbling up to removing focus
     * from the highlight displaying the sidebar
     */ event.stopPropagation();
    };
    const handleOpeningCommentsPanel = (0, $cozmU.useCallback)(()=>{
        showCommentsPanel({
            openWithView: (0, $3mVfX.ViewValues).OPEN
        });
        if (annotationId) {
            setCurrentlySelectedThreadKey(annotationId);
            (0, $9FoVw.handleCommentsPanelNavigation)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                context: (0, $9FoVw.NavigationContext).PANEL,
                block: 'center',
                annotationId: annotationId,
                commentId: commentId,
                commentType: 'INLINE',
                annotationClicked: true
            });
        }
    }, [
        showCommentsPanel,
        setCurrentlySelectedThreadKey,
        annotationId,
        commentId
    ]);
    const handleOnClose = (0, $cozmU.useCallback)((dialogs, isOpeningCommentsPanel = false)=>{
        if (hasContentChanged) dialogs.showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                isOpeningCommentsPanel ? handleOpeningCommentsPanel() : onClose && onClose(false);
            }
        });
        else isOpeningCommentsPanel ? handleOpeningCommentsPanel() : onClose && onClose(hasContentChanged);
    }, [
        hasContentChanged,
        onClose,
        resetContentChanged,
        handleOpeningCommentsPanel
    ]);
    const updatedHandleOnClose = (0, $cozmU.useCallback)((isOpeningCommentsPanel = false)=>{
        if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                isOpeningCommentsPanel ? handleOpeningCommentsPanel() : onClose?.(false);
            }
        });
        else isOpeningCommentsPanel ? handleOpeningCommentsPanel() : onClose?.(hasContentChanged);
    }, [
        showModal,
        hasContentChanged,
        onClose,
        resetContentChanged,
        handleOpeningCommentsPanel
    ]);
    const handleViewAllClick = (0, $cozmU.useCallback)((dialogs)=>{
        handleOnClose(dialogs, true);
    }, [
        handleOnClose
    ]);
    const updatedHandleViewAllClick = (0, $cozmU.useCallback)(()=>{
        updatedHandleOnClose(true);
    }, [
        updatedHandleOnClose
    ]);
    const handleScroll = (0, $cozmU.useCallback)((event)=>{
        const target = event.currentTarget;
        // Check if the inline-comment-sidebar-wrapper is scrolled
        const scrolled = target.scrollTop > 0;
        setIsScrolled(scrolled);
    }, []);
    const sidebarId = (0, $aHcFH.getSidebarId)(isEditor, isViewCommentMode);
    const mode = isEditor ? 'edit' : 'view';
    const intl = (0, $kSwu1.useIntl)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const sidebarBoundingRect = sidebarEl.current?.getBoundingClientRect();
    const isSidebarExtendedBeyondViewport = (sidebarBoundingRect?.bottom ?? 0) > window.innerHeight;
    /**
   * useEffect to handle sticky comment behavior when attached to a sticky table header.
   * As the user scrolls, the IntersectionObserver triggers the callback the moment the table header starts/stops being sticky
   */ (0, $cozmU.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) {
            const stickyHeader = annotationElement?.closest('.pm-table-sticky-wrapper');
            if (stickyHeader && !isSidebarExtendedBeyondViewport) {
                // eslint-disable-next-line no-restricted-syntax
                const observer = new IntersectionObserver(([entry])=>$2cc0402d98a7d80d$export$b8454eaf88df51d0(entry, setOldIsSticky, setSidebarOffset, sidebarOffset), {
                    threshold: 1.0
                });
                observer.observe(stickyHeader);
                return ()=>observer.disconnect();
            }
        }
    }, [
        annotationElement,
        sidebarOffset,
        sidebarEl,
        isSidebarExtendedBeyondViewport
    ]);
    const commentSidebarIsSticky = (0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic') ? isSticky : oldIsSticky;
    const commentResidesInPreviewPanel = (0, $eToX6.isInPreviewPanel)();
    const viewAllResidesInPreviewPanel = (0, $eToX6.isInPreviewPanel)();
    /**
   * Below logic to set rightOffset is temporary fix.
   * It is very fragile as there are many conditions in ObjectSidebarControl
   * 	component to show/hide action bar and rovo button.
   * Also values are hardcoded.
   */ const getRightOffset = (0, $cozmU.useCallback)(()=>{
        let rightOffset = 0;
        const panelRenderedOutsideMain = (0, $jvYFk.isMigratedToPanelSystem)(panel?.id) && (0, $9wGTI.fg)('ads-panel-system-confluence-object-sidebar');
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expValEquals)('confluence_fe_fix_sticky_comment_sidebar_position', 'isEnabled', true) && (0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) // An improved version of getRightOffset()
        {
            if (!commentResidesInPreviewPanel) {
                const baseRightOffset = 112;
                // rendererContent has an extra 40px padding on the right,
                // which we need to add in 'edit' mode to match 'view' mode.
                const extraPadding = 40;
                if (mode === 'edit') rightOffset = extraPadding + (isObjectSidebarShown ? 0 : baseRightOffset);
                else {
                    // `mode === 'view'`
                    if (isObjectSidebarShown) {
                        if (panelRenderedOutsideMain) // Navigation-system Panel already shrinks Main, so only fixed-position
                        // (sticky) inline comments need a viewport-relative offset.
                        rightOffset = commentSidebarIsSticky ? (0, $aWwYt.MIN_PANEL_WIDTH) + extraPadding : 0;
                        else // When `commentSidebarIsSticky === true`, sidebar uses style { position: 'fixed' },
                        // so we need to add extraPadding here to match the `commentSidebarIsSticky === false` case.
                        rightOffset = (0, $aWwYt.MIN_PANEL_WIDTH) + (commentSidebarIsSticky ? extraPadding : 0);
                    } else // `isObjectSidebarShown === false`
                    if (!commentSidebarIsSticky) rightOffset = baseRightOffset;
                    else {
                        // `commentSidebarIsSticky === true`, sidebar uses style { position: 'fixed' }
                        // We set rightOffset to be baseRightOffset + the distance between
                        // the right edge of 'main-content' and the right edge of window
                        // (which includes the 40px padding + any extra e.g. the Rovo panel).
                        // The resulting horizontal position of sidebar should match the
                        // `commentSidebarIsSticky === false` case.
                        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                        const rendererContent = document.getElementById('main-content');
                        const rendererContentRight = rendererContent?.getBoundingClientRect()?.right ?? 0;
                        if (rendererContentRight) {
                            const rendererContentDistanceFromWindowRight = window.innerWidth - rendererContentRight;
                            rightOffset = baseRightOffset + rendererContentDistanceFromWindowRight;
                        } else // rendererContentRight === 0, which shouldn't occur, but
                        // we fall back to a hardcoded rightOffset
                        rightOffset = baseRightOffset;
                    }
                }
            } // if `commentResidesInPreviewPanel === true`, rightOffset will be 0
        } else {
            // The old version of getRightOffset()
            if (mode === 'view' && isObjectSidebarShown) /**
         * Need rightOffset only when container size doesn't change when
         * 	action bar panel (e.g details panel, comments panel).
         * That happens currently only in view page.
         */ rightOffset = panelRenderedOutsideMain ? 0 : (0, $aWwYt.MIN_PANEL_WIDTH);
            else if (!isObjectSidebarShown) /**
         * Width of action bar is 48px,
         * 	got it from object-sidebar-components/src/ObjectSidebarControl.tsx.
         * This is not ideal solution, as it is hardcoded.
         * check if previewPanel support is enabled
         */ {
                if (!commentResidesInPreviewPanel) {
                    if ((0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) {
                        rightOffset = 100; // add more offset from the right edge of the page so it doesn't overlap with the object sidebar
                        if (mode === 'view') rightOffset += commentSidebarIsSticky ? 67 : 12;
                        else rightOffset += commentSidebarIsSticky ? 27 : 12;
                    } else rightOffset = 48 + (commentSidebarIsSticky ? 52 : 12);
                }
            }
        }
        return rightOffset;
    }, [
        mode,
        isObjectSidebarShown,
        commentSidebarIsSticky,
        commentResidesInPreviewPanel,
        panel
    ]);
    const a11yProps = {
        role: 'dialog',
        'aria-modal': false,
        'aria-label': isReaction && (0, $6mKj3.expVal)('confluence_inline_reactions', 'isEnabled', false) ? intl.formatMessage((0, $bEwJH.i18n).reactionSidebarLabel) : intl.formatMessage((0, $bEwJH.i18n).commentSidebarLabel, {
            name: authorName || ''
        })
    };
    const pickedStickyCommentVerticalOffsetView = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $6mKj3.expValEquals)('confluence_fe_fix_sticky_comment_sidebar_position', 'isEnabled', true) && (0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic') ? (0, $bEwJH.STICKY_COMMENT_VERTICAL_OFFSET_VIEW) : (0, $bEwJH.STICKY_COMMENT_VERTICAL_OFFSET_VIEW_OLD);
    const sidebarContainerOffset = (0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic') ? commentSidebarIsSticky ? isEditor ? sidebarOffset : pickedStickyCommentVerticalOffsetView : sidebarOffset : newSidebarOffset;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COLLABORATION
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $kRW4Y.DialogsStateContainer)
        ]
    }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8SCD6.ReactionsProvider), {
            contentId: pageId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "comment-sidebar"
        }, commentSidebarContext === 'create' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
            data: {
                commentSidebarContext: 'create'
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.SidebarContainerRounded), {
            offset: sidebarContainerOffset,
            rightOffset: getRightOffset(),
            isSticky: commentSidebarIsSticky,
            onClick: handlePropagation,
            id: sidebarId,
            "data-testid": sidebarId,
            "data-cy": sidebarId,
            mode: mode,
            ref: (el)=>{
                sidebarEl.current = el;
                if (nudgeRef) nudgeRef.current = el;
                setIsRefSet(true);
                inlineCommentRef(el);
            },
            ...a11yProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: [
                $2cc0402d98a7d80d$var$commentHeaderStyle,
                $2cc0402d98a7d80d$var$commentNewHeaderMargin,
                !isViewCommentMode && $2cc0402d98a7d80d$var$commentEditorStyle
            ]
        }, navigationOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bXQxx.CommentNavigation), {
            pageId: pageId,
            commentData: navigationOptions.commentData,
            isEditor: isEditor,
            onNavigationClick: navigationOptions.onNavigationClick
        }), annotationId && !viewAllResidesInPreviewPanel && !shouldHideViewAllCommentsButtonForNativeEmbedUiUpdates && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            testId: "redesigned-view-all-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $2cc0402d98a7d80d$var$redesignedViewAllStyle,
            onClick: // In order to get rid of the a11y suppression 👆,
            // we need to move this onClick handler from this Box to CommentIconWithUnread's IconButton.
            (0, $6mKj3.expValEquals)('confluence_frontend_remove_a11y_suppressions', 'isEnabled', true) ? undefined : (e)=>{
                e.stopPropagation();
                handleViewAllClick(dialogs);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3D12W.CommentPanelButton), {
            onClick: (0, $6mKj3.expValEquals)('confluence_frontend_remove_a11y_suppressions', 'isEnabled', true) ? updatedHandleViewAllClick : undefined,
            contentId: pageId,
            testId: "standalone-comment-view-all-button",
            isStandaloneComment: true,
            isViewAllIcon: true,
            isReaction: isReaction
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), isReaction && (0, $6mKj3.expVal)('confluence_inline_reactions', 'isEnabled', false) ? (0, $bEwJH.i18n).closeReactionTooltip : (0, $bEwJH.i18n).closeSidebarTooltip),
            hideTooltipOnClick: true,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.CloseButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.CloseButton), {
            appearance: "subtle",
            onClick: (0, $6mKj3.expValEquals)('confluence_frontend_remove_a11y_suppressions', 'isEnabled', true) ? ()=>updatedHandleOnClose() : ()=>handleOnClose(dialogs),
            onMouseDown: (e)=>e.preventDefault(),
            testId: "close-comment-sidebar-button",
            "data-cy": `${isEditor ? 'editor' : 'renderer'}-close-${isViewCommentMode ? 'view' : 'create'}-comment`,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                label: intl.formatMessage((0, $bEwJH.i18n).closeInlineCommentThread),
                color: "var(--ds-icon-subtle, #505258)",
                spacing: "none"
            }),
            isUpdatedStandaloneComment: true
        })))), isScrolled && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: $2cc0402d98a7d80d$var$shadowElementStyle
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            testId: "inline-comment-sidebar-wrapper",
            ref: (el)=>{
                if (applyMaxHeightStyles) setPopupsScrollableElement?.(el);
            },
            xcss: [
                applyMaxHeightStyles && !dynamicMaxHeight && $2cc0402d98a7d80d$var$boxWithMaxHeight,
                applyMaxHeightStyles && !!dynamicMaxHeight && $2cc0402d98a7d80d$var$boxWithDynamicMaxHeightAuto,
                !applyMaxHeightStyles && $2cc0402d98a7d80d$var$boxWithoutMaxHeight
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: // xcss only supports static styles
            applyMaxHeightStyles && !!dynamicMaxHeight ? {
                maxHeight: dynamicMaxHeight
            } : undefined,
            onScroll: handleScroll
        }, children))))));
};
module.exports["CommentSidebar"] = $2cc0402d98a7d80d$export$d560bdb1ceec916a;

});

parcelRegister("3D12W", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $eDtFr = parcelRequire("eDtFr");


var $gDx2k = parcelRequire("gDx2k");


var $fJCU9 = parcelRequire("fJCU9");


var $9DHhW = parcelRequire("9DHhW");


var $lpNn5 = parcelRequire("lpNn5");


var $aWwYt = parcelRequire("aWwYt");


var $8aF6s = parcelRequire("8aF6s");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $cMvMc = parcelRequire("cMvMc");


var $ep3mz = parcelRequire("ep3mz");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $5fMeR = parcelRequire("5fMeR");


var $3mVfX = parcelRequire("3mVfX");


var $iBnoc = parcelRequire("iBnoc");


var $fHAwL = parcelRequire("fHAwL");


var $cZa7r = parcelRequire("cZa7r");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $efvKr = parcelRequire("efvKr");


var $1ggpj = parcelRequire("1ggpj");


var $8uM2K = parcelRequire("8uM2K");


var $7aw3q = parcelRequire("7aw3q");


var $6mKj3 = parcelRequire("6mKj3");

const $404f4d0022b5692a$var$commentIconContainerStyle = null;
const $404f4d0022b5692a$var$i18n = (0, $kSwu1.defineMessages)({
    viewAllCommentsLabel: {
        id: "object-sidebar-components.view.all.comments",
        defaultMessage: "View all comments"
    },
    showCommentsLabel: {
        id: "object-sidebar-components.show.comments.label",
        defaultMessage: "Show comments"
    },
    showReactionsLabel: {
        id: "object-sidebar-components.show.reactions.label",
        defaultMessage: "Show reactions"
    }
});
const $404f4d0022b5692a$export$f5ef73dad1bb3f02 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(70);
    const { onClick: onClick, collapsed: collapsed, testId: testId, isStandaloneComment: t1, isDisabled: t2, isViewAllIcon: t3, isReaction: t4 } = t0;
    const isStandaloneComment = t1 === undefined ? false : t1;
    const isDisabled = t2 === undefined ? false : t2;
    const isViewAllIcon = t3 === undefined ? false : t3;
    const isReaction = t4 === undefined ? false : t4;
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { resetInitialDataLoadedMap: resetInitialDataLoadedMap } = (0, $3mVfX.useCommentsPanelActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { viewProps: viewProps, selectionProps: selectionProps, hoverProps: hoverProps, editorViewProps: editorViewProps, editorCreateProps: editorCreateProps, showCreateComponent: showCreateComponent, selectionOptions: selectionOptions } = (0, $cZa7r.useAnnotations)();
    const { setViewProps: setViewProps, setSelectionProps: setSelectionProps, setHoverProps: setHoverProps, setEditorViewProps: setEditorViewProps, setEditorCreateProps: setEditorCreateProps, setShowCreateComponent: setShowCreateComponent, setSelectionOptions: setSelectionOptions } = (0, $cZa7r.useAnnotationsDispatch)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const panel = (0, $aWwYt.usePanel)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    let t5;
    if ($[0] !== pageMode) {
        t5 = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
        $[0] = pageMode;
        $[1] = t5;
    } else t5 = $[1];
    const eventEmitter = t5;
    const { newCommentHighlight: newCommentHighlight, activeHighlight: activeHighlight } = (0, $9jl6v.useInlineCommentsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [t6] = (0, $efvKr.useLivePageMode)();
    const { isViewMode: isLiveViewMode, isEditMode: isLiveEditMode } = t6;
    const dataTestId = testId || "object-sidebar-comments-button-id";
    const [contentTypeFromState] = (0, $ep3mz.useContentType)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const t7 = pageMode === "edit" || isLiveEditMode;
    let t8;
    if ($[2] !== t7) {
        t8 = {
            shortcut: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
            isEditorShortcut: t7
        };
        $[2] = t7;
        $[3] = t8;
    } else t8 = $[3];
    const commentShortcutStrings = (0, $4tOXV.useShortcutStrings)(t8);
    const isShortcutTextShown = contentTypeFromState !== (0, $1ggpj.ContentType).DATABASE;
    let t9;
    if ($[4] !== pageMode) {
        t9 = ()=>{
            (0, $5fMeR.preloadCommentsPanel)(pageMode);
        };
        $[4] = pageMode;
        $[5] = t9;
    } else t9 = $[5];
    const handleMouseEnter = t9;
    let t10;
    if ($[6] !== activeHighlight || $[7] !== editorCreateProps || $[8] !== editorViewProps || $[9] !== eventEmitter || $[10] !== hideObjectSidebar || $[11] !== hoverProps || $[12] !== newCommentHighlight || $[13] !== panel?.id || $[14] !== selectionOptions || $[15] !== selectionProps || $[16] !== setEditorCreateProps || $[17] !== setEditorViewProps || $[18] !== setHoverProps || $[19] !== setSelectionOptions || $[20] !== setSelectionProps || $[21] !== setShowCreateComponent || $[22] !== setViewProps || $[23] !== showCommentsPanel || $[24] !== showCreateComponent || $[25] !== viewProps) {
        t10 = ()=>{
            if (viewProps) {
                eventEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
                eventEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
                setViewProps(null);
            }
            if (showCreateComponent && selectionOptions) {
                setShowCreateComponent(false);
                setSelectionOptions(undefined);
            }
            if (editorViewProps) {
                eventEmitter.emit("setselectedannotation", "");
                setEditorViewProps(null);
            }
            if (selectionProps) {
                selectionProps.onClose();
                setSelectionProps(null);
            }
            if (hoverProps) {
                hoverProps.onClose();
                setHoverProps(null);
            }
            if (editorCreateProps) {
                editorCreateProps?.onClose && editorCreateProps.onClose();
                setEditorCreateProps(null);
            }
            if (newCommentHighlight || activeHighlight) window.dispatchEvent(new Event("closeLegacyInlineCommentSidebar"));
            if (panel?.id === "commentsPanel") hideObjectSidebar();
            else showCommentsPanel();
        };
        $[6] = activeHighlight;
        $[7] = editorCreateProps;
        $[8] = editorViewProps;
        $[9] = eventEmitter;
        $[10] = hideObjectSidebar;
        $[11] = hoverProps;
        $[12] = newCommentHighlight;
        $[13] = panel?.id;
        $[14] = selectionOptions;
        $[15] = selectionProps;
        $[16] = setEditorCreateProps;
        $[17] = setEditorViewProps;
        $[18] = setHoverProps;
        $[19] = setSelectionOptions;
        $[20] = setSelectionProps;
        $[21] = setShowCreateComponent;
        $[22] = setViewProps;
        $[23] = showCommentsPanel;
        $[24] = showCreateComponent;
        $[25] = viewProps;
        $[26] = t10;
    } else t10 = $[26];
    const handleCommentClick = t10;
    let t11;
    if ($[27] !== contentTypeFromState || $[28] !== createAnalyticsEvent || $[29] !== handleCommentClick || $[30] !== hasContentChanged || $[31] !== onClick || $[32] !== pageMode || $[33] !== resetContentChanged || $[34] !== resetInitialDataLoadedMap || $[35] !== showModal) {
        t11 = (t12)=>{
            const { triggeredByKeyboardShortcut: t13, isViewAllIcon: t14 } = t12 === undefined ? {} : t12;
            const triggeredByKeyboardShortcut = t13 === undefined ? false : t13;
            const isViewAllIcon_0 = t14 === undefined ? false : t14;
            return ()=>{
                if (isViewAllIcon_0) {
                    onClick?.();
                    return;
                }
                if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
                    onConfirm: ()=>{
                        resetContentChanged();
                        handleCommentClick();
                        resetInitialDataLoadedMap();
                    }
                });
                else handleCommentClick();
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "commentsPanel",
                        source: "contentWrapper",
                        attributes: {
                            triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
                            contentType: contentTypeFromState,
                            pageMode: pageMode
                        }
                    }
                }).fire();
            };
        };
        $[27] = contentTypeFromState;
        $[28] = createAnalyticsEvent;
        $[29] = handleCommentClick;
        $[30] = hasContentChanged;
        $[31] = onClick;
        $[32] = pageMode;
        $[33] = resetContentChanged;
        $[34] = resetInitialDataLoadedMap;
        $[35] = showModal;
        $[36] = t11;
    } else t11 = $[36];
    const checkUnsavedOnClickCommentsButton = t11;
    let t12;
    if ($[37] !== checkUnsavedOnClickCommentsButton || $[38] !== isLiveViewMode || $[39] !== pageMode) {
        t12 = (pageMode === "view" || isLiveViewMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
            deprecatedAccelerator: (0, $gnkil.TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER),
            accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
            listener: checkUnsavedOnClickCommentsButton({
                triggeredByKeyboardShortcut: true
            })
        });
        $[37] = checkUnsavedOnClickCommentsButton;
        $[38] = isLiveViewMode;
        $[39] = pageMode;
        $[40] = t12;
    } else t12 = $[40];
    let t13;
    if ($[41] !== checkUnsavedOnClickCommentsButton || $[42] !== isLiveEditMode || $[43] !== pageMode) {
        t13 = (pageMode === "edit" || isLiveEditMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
            accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
            listener: checkUnsavedOnClickCommentsButton({
                triggeredByKeyboardShortcut: true
            })
        });
        $[41] = checkUnsavedOnClickCommentsButton;
        $[42] = isLiveEditMode;
        $[43] = pageMode;
        $[44] = t13;
    } else t13 = $[44];
    let t14;
    if ($[45] !== t12 || $[46] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t12, t13);
        $[45] = t12;
        $[46] = t13;
        $[47] = t14;
    } else t14 = $[47];
    const shortcutListeners = t14;
    if (collapsed) return shortcutListeners;
    let t15;
    if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = (0, $hekY6.default)([
            "_kqswh2mm"
        ]);
        $[48] = t15;
    } else t15 = $[48];
    const t16 = isReaction && (0, $6mKj3.expVal)("confluence_inline_reactions", "isEnabled", false) ? $404f4d0022b5692a$var$i18n.showReactionsLabel : $404f4d0022b5692a$var$i18n.showCommentsLabel;
    let t17;
    if ($[49] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), t16);
        $[49] = t16;
        $[50] = t17;
    } else t17 = $[50];
    const t18 = isShortcutTextShown ? commentShortcutStrings : undefined;
    let t19;
    if ($[51] !== allowComments || $[52] !== checkUnsavedOnClickCommentsButton || $[53] !== formatMessage || $[54] !== handleMouseEnter || $[55] !== isDisabled || $[56] !== isRovoButtonEnabled || $[57] !== isStandaloneComment || $[58] !== isViewAllIcon || $[59] !== unreadCommentIDSet?.size) {
        t19 = allowComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            onClick: checkUnsavedOnClickCommentsButton({
                isViewAllIcon: isViewAllIcon
            }),
            onMouseEnter: handleMouseEnter,
            appearance: "subtle",
            spacing: isStandaloneComment ? "compact" : undefined,
            shape: isRovoButtonEnabled ? "default" : "circle",
            icon: isStandaloneComment && (0, $6mKj3.expValEquals)("confluence_comments_cohiti_panel_icon_update", "isEnabled", true) ? (0, (/*@__PURE__*/$parcel$interopDefault($gDx2k))) : (0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))),
            label: formatMessage($404f4d0022b5692a$var$i18n.viewAllCommentsLabel),
            testId: "sidebar-comments-button",
            interactionName: "view-comments-menu-action",
            isDisabled: isDisabled && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false)
        }), !isStandaloneComment && unreadCommentIDSet?.size > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iBnoc.UnreadIndicator), null));
        $[51] = allowComments;
        $[52] = checkUnsavedOnClickCommentsButton;
        $[53] = formatMessage;
        $[54] = handleMouseEnter;
        $[55] = isDisabled;
        $[56] = isRovoButtonEnabled;
        $[57] = isStandaloneComment;
        $[58] = isViewAllIcon;
        $[59] = unreadCommentIDSet?.size;
        $[60] = t19;
    } else t19 = $[60];
    const t20 = !isStandaloneComment && shortcutListeners;
    let t21;
    if ($[61] !== t17 || $[62] !== t18 || $[63] !== t19 || $[64] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            position: "left",
            content: t17,
            shortcut: t18,
            delay: 0,
            hideTooltipOnClick: true
        }, t19, t20);
        $[61] = t17;
        $[62] = t18;
        $[63] = t19;
        $[64] = t20;
        $[65] = t21;
    } else t21 = $[65];
    let t22;
    if ($[66] !== dataTestId || $[67] !== t15 || $[68] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": dataTestId,
            "data-vc": "object-sidebar-comments-button",
            className: t15
        }, t21);
        $[66] = dataTestId;
        $[67] = t15;
        $[68] = t21;
        $[69] = t22;
    } else t22 = $[69];
    return t22;
} : ({ onClick: onClick, collapsed: collapsed, testId: testId, isStandaloneComment: isStandaloneComment = false, isDisabled: isDisabled = false, isViewAllIcon: isViewAllIcon = false, isReaction: isReaction = false })=>{
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { resetInitialDataLoadedMap: resetInitialDataLoadedMap } = (0, $3mVfX.useCommentsPanelActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { viewProps: viewProps, selectionProps: selectionProps, hoverProps: hoverProps, editorViewProps: editorViewProps, editorCreateProps: editorCreateProps, showCreateComponent: showCreateComponent, selectionOptions: selectionOptions } = (0, $cZa7r.useAnnotations)();
    const { setViewProps: setViewProps, setSelectionProps: setSelectionProps, setHoverProps: setHoverProps, setEditorViewProps: setEditorViewProps, setEditorCreateProps: setEditorCreateProps, setShowCreateComponent: setShowCreateComponent, setSelectionOptions: setSelectionOptions } = (0, $cZa7r.useAnnotationsDispatch)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const panel = (0, $aWwYt.usePanel)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const { newCommentHighlight: newCommentHighlight, activeHighlight: activeHighlight } = (0, $9jl6v.useInlineCommentsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [{ isViewMode: isLiveViewMode, isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const dataTestId = testId || 'object-sidebar-comments-button-id';
    const [contentTypeFromState] = (0, $ep3mz.useContentType)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const commentShortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        isEditorShortcut: pageMode === 'edit' || isLiveEditMode
    }); // keyboard events do not bubble up to confluence when focus is in the db iframe.
    // Since the keyboard shortcut does not work, we must hide the shortcut text.
    const isShortcutTextShown = contentTypeFromState !== (0, $1ggpj.ContentType).DATABASE; // Preload components on hover to improve FMP performance
    const handleMouseEnter = (0, $cozmU.useCallback)(()=>{
        (0, $5fMeR.preloadCommentsPanel)(pageMode);
    }, [
        pageMode
    ]);
    const handleCommentClick = (0, $cozmU.useCallback)(()=>{
        // FABRIC PAGES
        // Close the view component if it's open
        if (viewProps) {
            // Inform the Renderer to de-select the annotation
            eventEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            eventEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS); // Remove the display of the comment
            setViewProps(null);
        }
        if (showCreateComponent && selectionOptions) {
            // Inform CreateComment to reset the state
            setShowCreateComponent(false);
            setSelectionOptions(undefined);
        }
        if (editorViewProps) {
            // Inform the editor to de-select the annotation
            eventEmitter.emit('setselectedannotation', ''); // Remove the display of the comment
            setEditorViewProps(null);
        }
        if (selectionProps) {
            selectionProps.onClose();
            setSelectionProps(null);
        }
        if (hoverProps) {
            hoverProps.onClose();
            setHoverProps(null);
        }
        if (editorCreateProps) {
            editorCreateProps?.onClose && editorCreateProps.onClose();
            setEditorCreateProps(null);
        } // LEGACY PAGES
        if (newCommentHighlight || activeHighlight) // Close the legacy inline comment panel
        window.dispatchEvent(new Event('closeLegacyInlineCommentSidebar'));
        if (panel?.id === 'commentsPanel') hideObjectSidebar();
        else showCommentsPanel();
    }, [
        eventEmitter,
        viewProps,
        editorViewProps,
        selectionProps,
        hoverProps,
        newCommentHighlight,
        activeHighlight,
        setViewProps,
        setEditorViewProps,
        setSelectionProps,
        setHoverProps,
        showCommentsPanel,
        hideObjectSidebar,
        panel,
        editorCreateProps,
        setEditorCreateProps,
        showCreateComponent,
        selectionOptions,
        setShowCreateComponent,
        setSelectionOptions
    ]);
    const checkUnsavedOnClickCommentsButton = (0, $cozmU.useCallback)(({ triggeredByKeyboardShortcut: triggeredByKeyboardShortcut = false, isViewAllIcon: isViewAllIcon_0 = false } = {})=>()=>{
            // Early return for ViewAll icon - no action needed
            if (isViewAllIcon_0) {
                onClick?.();
                return;
            }
            if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged();
                    handleCommentClick();
                    resetInitialDataLoadedMap();
                }
            });
            else handleCommentClick();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'commentsPanel',
                    source: 'contentWrapper',
                    attributes: {
                        triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
                        contentType: contentTypeFromState,
                        pageMode: pageMode
                    }
                }
            }).fire();
        }, [
        onClick,
        hasContentChanged,
        handleCommentClick,
        resetContentChanged,
        resetInitialDataLoadedMap,
        showModal,
        createAnalyticsEvent,
        contentTypeFromState,
        pageMode
    ]);
    const shortcutListeners = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, (pageMode === 'view' || isLiveViewMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: (0, $gnkil.TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER),
        accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        listener: checkUnsavedOnClickCommentsButton({
            triggeredByKeyboardShortcut: true
        })
    }), (pageMode === 'edit' || isLiveEditMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        listener: checkUnsavedOnClickCommentsButton({
            triggeredByKeyboardShortcut: true
        })
    }));
    if (collapsed) return shortcutListeners;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": dataTestId,
        "data-vc": "object-sidebar-comments-button",
        className: (0, $hekY6.default)([
            "_kqswh2mm"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: "left",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), isReaction && (0, $6mKj3.expVal)('confluence_inline_reactions', 'isEnabled', false) ? $404f4d0022b5692a$var$i18n.showReactionsLabel : $404f4d0022b5692a$var$i18n.showCommentsLabel),
        shortcut: isShortcutTextShown ? commentShortcutStrings : undefined,
        delay: 0,
        hideTooltipOnClick: true
    }, allowComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        onClick: checkUnsavedOnClickCommentsButton({
            isViewAllIcon: isViewAllIcon
        }),
        onMouseEnter: handleMouseEnter,
        appearance: "subtle",
        spacing: isStandaloneComment ? 'compact' : undefined,
        shape: isRovoButtonEnabled ? 'default' : 'circle',
        icon: isStandaloneComment && (0, $6mKj3.expValEquals)('confluence_comments_cohiti_panel_icon_update', 'isEnabled', true) ? (0, (/*@__PURE__*/$parcel$interopDefault($gDx2k))) : (0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))),
        label: formatMessage($404f4d0022b5692a$var$i18n.viewAllCommentsLabel),
        testId: "sidebar-comments-button",
        interactionName: "view-comments-menu-action",
        isDisabled: isDisabled && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
    }), !isStandaloneComment && unreadCommentIDSet?.size > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iBnoc.UnreadIndicator), null)), !isStandaloneComment && shortcutListeners));
};
module.exports["CommentPanelButton"] = $404f4d0022b5692a$export$f5ef73dad1bb3f02;

});

parcelRegister("iBnoc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0360a9befc1d1e18$export$d101cbe06551091d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1wNs0",
    name: "UnreadIndicator",
    loader: async ()=>(await (parcelRequire("7JHJL"))).UnreadIndicator
});
module.exports["UnreadIndicator"] = $0360a9befc1d1e18$export$d101cbe06551091d;

});

parcelRegister("7JHJL", function(module, exports) {

let $5a1ea9a384b0dcb6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5a1ea9a384b0dcb6$var$load("i8hiG").then(()=>parcelRequire('yTrVP'));

});

parcelRegister("6wiaZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");

const $781ef84c6c89584f$export$d1fb14f3b5498c7a = ({ sidebarEl: sidebarEl, isRefSet: isRefSet, isSticky: isSticky, isFabricPage: isFabricPage, annotationElement: annotationElement, isEditor: isEditor, sidebarOffset: sidebarOffset, isMaxHeightEnabledForSticky: isMaxHeightEnabledForSticky })=>{
    const [hasMaxHeight, setHasMaxHeight] = (0, $cozmU.useState)(false);
    const [dynamicMaxHeight, setDynamicMaxHeight] = (0, $cozmU.useState)(undefined);
    // Shared max height check logic
    const checkMaxHeight = (0, $cozmU.useCallback)(()=>{
        // Check if annotation is in a sticky table header & on edit mode
        if (annotationElement && isEditor && isMaxHeightEnabledForSticky) {
            const stickyTable = annotationElement.closest('table.pm-table-sticky');
            const inStickyTableHeader = Boolean(stickyTable);
            // Special case: annotation in sticky table header - calculate max height based on where sidebar will be positioned
            // Without this check, long comment threads can sometimes have their bottom permanently below the viewport on small-width pages
            if (inStickyTableHeader && isSticky) {
                const annotationRect = annotationElement.getBoundingClientRect();
                const annotationBottom = annotationRect.bottom;
                // Use the sidebar offset that will be applied (STICKY_COMMENT_VERTICAL_OFFSET_VIEW for view, or sidebarOffset for editor)
                const offset = sidebarOffset ?? 0;
                const sidebarTop = annotationBottom + offset;
                const viewportHeight = window.innerHeight;
                // Calculate max height as distance from where sidebar top will be to bottom of viewport
                const calculatedMaxHeight = viewportHeight - sidebarTop;
                // Only apply if the calculated max height is positive and would actually constrain the sidebar
                // Otherwise, continue to default behavior
                if (calculatedMaxHeight > 0) {
                    setDynamicMaxHeight(`${calculatedMaxHeight}px`);
                    setHasMaxHeight(true);
                    return;
                }
            }
        }
        // Default (i.e. non-special-cate) behavior
        if (!sidebarEl.current) return;
        if (isSticky) {
            setHasMaxHeight(true);
            setDynamicMaxHeight(undefined);
            return;
        }
        const rect = sidebarEl.current.getBoundingClientRect();
        const availableHeight = window.innerHeight - 300;
        setHasMaxHeight(rect.height > availableHeight);
        setDynamicMaxHeight(undefined);
    }, [
        isSticky,
        sidebarEl,
        annotationElement,
        isEditor,
        sidebarOffset,
        isMaxHeightEnabledForSticky
    ]);
    // Max height effect for pre-render (useLayoutEffect)
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!sidebarEl.current) return;
        if (!(0, $6mKj3.expValEquals)('confluence_compute_sidebar_styles_pre-render', 'isEnabled', true)) return;
        checkMaxHeight();
    }, [
        checkMaxHeight,
        isRefSet,
        isFabricPage,
        sidebarEl
    ]);
    // Max height effect for post-render (useEffect)
    (0, $cozmU.useEffect)(()=>{
        if (!sidebarEl.current) return;
        if ((0, $6mKj3.expValEquals)('confluence_compute_sidebar_styles_pre-render', 'isEnabled', true)) return;
        checkMaxHeight();
    }, [
        checkMaxHeight,
        isRefSet,
        isFabricPage,
        sidebarEl
    ]);
    return {
        hasMaxHeight: hasMaxHeight,
        dynamicMaxHeight: dynamicMaxHeight
    };
};
module.exports["useHasMaxHeight"] = $781ef84c6c89584f$export$d1fb14f3b5498c7a;

});

parcelRegister("bEwJH", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $6015f360c209854c$export$fafb84dd8a714e7a = 5;
const $6015f360c209854c$export$675e64cf259adeff = 125;
const $6015f360c209854c$export$6882b33952f7e4d2 = 122;
const $6015f360c209854c$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    closeCommentBox: {
        id: "annotation-provider-inline-comments.closeCommentBox",
        defaultMessage: "Close inline comments"
    },
    closeInlineCommentThread: {
        id: "annotation-provider-inline-comments.close.InlineCommentThread",
        defaultMessage: "Close inline comment thread"
    },
    closeSidebarTooltip: {
        id: "annotation-provider-inline-comments.close.icon.tooltip",
        defaultMessage: "Close comment"
    },
    closeReactionTooltip: {
        id: "annotation-provider-inline-comments.close.reaction.tooltip",
        defaultMessage: "Close reaction"
    },
    reactionSidebarLabel: {
        id: "annotation-provider-inline-comments.reaction.sidebar.label",
        defaultMessage: "Inline reaction"
    },
    viewAllCommentsButtonText: {
        id: "annotation-provider-inline-comments.view-all.button.text",
        defaultMessage: "View all"
    },
    commentSidebarLabel: {
        id: "annotation-provider-inline-comments.comment.sidebar.label",
        defaultMessage: "Inline comment by {name}"
    },
    commentSidebarAnnouncement: {
        id: "annotation-provider-inline-comments.comment.sidebar.announcement",
        defaultMessage: "Comment sidebar shown, use Shift + Tab to reach the comment sidebar"
    }
});
module.exports["STICKY_COMMENT_VERTICAL_OFFSET_VIEW_OLD"] = $6015f360c209854c$export$675e64cf259adeff;
module.exports["STICKY_COMMENT_VERTICAL_OFFSET_VIEW"] = $6015f360c209854c$export$6882b33952f7e4d2;
module.exports["i18n"] = $6015f360c209854c$export$a7357cdd1f0b0168;

});

parcelRegister("bXQxx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kz1Yj = parcelRequire("kz1Yj");


var $buxP3 = parcelRequire("buxP3");


var $7N1sB = parcelRequire("7N1sB");


var $cZa7r = parcelRequire("cZa7r");


var $3BCCf = parcelRequire("3BCCf");

const $d6eff27ff915f22d$var$positionLeftStyles = (0, $buxP3.xcss)({
    position: 'absolute',
    top: 'space.150',
    left: 'space.150'
});
const $d6eff27ff915f22d$export$c7f093fedf3e73fe = ({ pageId: pageId, commentData: commentData, isEditor: isEditor, onNavigationClick: onNavigationClick })=>{
    const { clearStoredCommentData: clearStoredCommentData } = (0, $cZa7r.useAnnotationsDispatch)();
    const { storedCommentData: storedCommentData } = (0, $cZa7r.useAnnotations)();
    const { goToNextInlineComment: originalGoToNext, goToPrevInlineComment: originalGoToPrev } = (0, $3BCCf.useInlineCommentNavigation)({
        isEditor: isEditor,
        pageId: pageId,
        onNavigationClick: onNavigationClick,
        commentData: commentData
    });
    // Wrap navigation functions to clear stored comment data before navigation
    const goToNextInlineComment = (0, $cozmU.useCallback)(()=>{
        if (clearStoredCommentData && storedCommentData) clearStoredCommentData();
        originalGoToNext();
    }, [
        clearStoredCommentData,
        storedCommentData,
        originalGoToNext
    ]);
    const goToPrevInlineComment = (0, $cozmU.useCallback)(()=>{
        if (clearStoredCommentData && storedCommentData) clearStoredCommentData();
        originalGoToPrev();
    }, [
        clearStoredCommentData,
        storedCommentData,
        originalGoToPrev
    ]);
    return (0, $cozmU.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.default), {
            xcss: $d6eff27ff915f22d$var$positionLeftStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7N1sB.CommentNavigation), {
            goToNextInlineComment: goToNextInlineComment,
            goToPrevInlineComment: goToPrevInlineComment
        })), [
        goToNextInlineComment,
        goToPrevInlineComment
    ]);
};
module.exports["CommentNavigation"] = $d6eff27ff915f22d$export$c7f093fedf3e73fe;

});

parcelRegister("7N1sB", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");


var $lpNn5 = parcelRequire("lpNn5");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $6mKj3 = parcelRequire("6mKj3");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $gtj7V = parcelRequire("gtj7V");


var $aJPUt = parcelRequire("aJPUt");


var $9QIM2 = parcelRequire("9QIM2");


var $e4o8D = parcelRequire("e4o8D");


var $666Tc = parcelRequire("666Tc");

const $c0db869228662b46$var$i18n = (0, $kSwu1.defineMessages)({
    nextCommentLabel: {
        id: "inline-comments-common.next-comment-label",
        defaultMessage: "Next comment"
    },
    previousCommentLabel: {
        id: "inline-comments-common.previous-comment-label",
        defaultMessage: "Previous comment"
    },
    nextAnnotationLabel: {
        id: "inline-comments-common.next-annotation-label",
        defaultMessage: "Next"
    },
    previousAnnotationLabel: {
        id: "inline-comments-common.previous-annotation-label",
        defaultMessage: "Previous"
    }
});
const $c0db869228662b46$export$c7f093fedf3e73fe = (t0)=>{
    const $ = (0, $bDgLe.c)(48);
    const { isSSRFocusedComment: isSSRFocusedComment, goToNextInlineComment: goToNextInlineComment, goToPrevInlineComment: goToPrevInlineComment } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [t1] = (0, $efvKr.useLivePageMode)();
    const { isEditMode: isLiveEditMode } = t1;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const pageClass = (0, $9QIM2.usePageClass)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const t2 = isLiveEditMode || isOnEditRoute ? (0, $gnkil.UNIVERSAL_PREV_COMMENT_SHORTCUT) : (0, $gnkil.PREV_COMMENT_SHORTCUT);
    let t3;
    if ($[0] !== t2) {
        t3 = {
            shortcut: t2
        };
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    const prevCommentShortcutStrings = (0, $4tOXV.useShortcutStrings)(t3);
    const t4 = isLiveEditMode || isOnEditRoute ? (0, $gnkil.UNIVERSAL_NEXT_COMMENT_SHORTCUT) : (0, $gnkil.NEXT_COMMENT_SHORTCUT);
    let t5;
    if ($[2] !== t4) {
        t5 = {
            shortcut: t4
        };
        $[2] = t4;
        $[3] = t5;
    } else t5 = $[3];
    const nextCommentShortcutStrings = (0, $4tOXV.useShortcutStrings)(t5);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const noop = $c0db869228662b46$var$_temp;
    const isPageOrDoc = pageClass === "renderer" || pageClass === "editor";
    let t6;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6mKj3.expVal)("confluence_inline_reactions", "isEnabled", false) ? $c0db869228662b46$var$i18n.previousAnnotationLabel : $c0db869228662b46$var$i18n.previousCommentLabel);
        $[4] = t6;
    } else t6 = $[4];
    let t7;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $6mKj3.expVal)("confluence_inline_reactions", "isEnabled", false) ? $c0db869228662b46$var$i18n.previousAnnotationLabel : $c0db869228662b46$var$i18n.previousCommentLabel;
        $[5] = t7;
    } else t7 = $[5];
    let t8;
    if ($[6] !== formatMessage) {
        t8 = formatMessage(t7);
        $[6] = formatMessage;
        $[7] = t8;
    } else t8 = $[7];
    let t9;
    if ($[8] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
            label: t8,
            color: "var(--ds-icon-subtle, #505258)",
            spacing: "spacious",
            size: "small"
        });
        $[8] = t8;
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] !== experienceTracker || $[11] !== goToPrevInlineComment || $[12] !== isPageOrDoc || $[13] !== isSSRFocusedComment || $[14] !== pageClass) {
        t10 = !isSSRFocusedComment ? ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: "comment-navigation"
            });
            if (isPageOrDoc) experienceTracker.start({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                attributes: {
                    ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                    entryPoint: "inline-comments-common/CommentNavigation",
                    pageClass: pageClass
                }
            });
            (0, $4EKKB.selectInlineComment).debug("Navigating to previous comment via button.");
            return goToPrevInlineComment();
        } : noop;
        $[10] = experienceTracker;
        $[11] = goToPrevInlineComment;
        $[12] = isPageOrDoc;
        $[13] = isSSRFocusedComment;
        $[14] = pageClass;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== isSSRFocusedComment || $[17] !== t10 || $[18] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.InlineHeaderButton), {
            isSSRFocusedComment: isSSRFocusedComment,
            "data-cy": "inline-nav-previous",
            testId: "comment-navigation-prev",
            iconBefore: t9,
            onClick: t10
        });
        $[16] = isSSRFocusedComment;
        $[17] = t10;
        $[18] = t9;
        $[19] = t11;
    } else t11 = $[19];
    let t12;
    if ($[20] !== prevCommentShortcutStrings || $[21] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t6,
            shortcut: prevCommentShortcutStrings,
            hideTooltipOnClick: true,
            position: "top"
        }, t11);
        $[20] = prevCommentShortcutStrings;
        $[21] = t11;
        $[22] = t12;
    } else t12 = $[22];
    let t13;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6mKj3.expVal)("confluence_inline_reactions", "isEnabled", false) ? $c0db869228662b46$var$i18n.nextAnnotationLabel : $c0db869228662b46$var$i18n.nextCommentLabel);
        $[23] = t13;
    } else t13 = $[23];
    let t14;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = (0, $6mKj3.expVal)("confluence_inline_reactions", "isEnabled", false) ? $c0db869228662b46$var$i18n.nextAnnotationLabel : $c0db869228662b46$var$i18n.nextCommentLabel;
        $[24] = t14;
    } else t14 = $[24];
    let t15;
    if ($[25] !== formatMessage) {
        t15 = formatMessage(t14);
        $[25] = formatMessage;
        $[26] = t15;
    } else t15 = $[26];
    let t16;
    if ($[27] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: t15,
            color: "var(--ds-icon-subtle, #505258)",
            spacing: "spacious",
            size: "small"
        });
        $[27] = t15;
        $[28] = t16;
    } else t16 = $[28];
    let t17;
    if ($[29] !== experienceTracker || $[30] !== goToNextInlineComment || $[31] !== isPageOrDoc || $[32] !== isSSRFocusedComment || $[33] !== pageClass) {
        t17 = !isSSRFocusedComment ? ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: "comment-navigation"
            });
            if (isPageOrDoc) experienceTracker.start({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                attributes: {
                    ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                    entryPoint: "inline-comments-common/CommentNavigation",
                    pageClass: pageClass
                }
            });
            (0, $4EKKB.selectInlineComment).debug("Navigating to next comment via button.");
            return goToNextInlineComment();
        } : noop;
        $[29] = experienceTracker;
        $[30] = goToNextInlineComment;
        $[31] = isPageOrDoc;
        $[32] = isSSRFocusedComment;
        $[33] = pageClass;
        $[34] = t17;
    } else t17 = $[34];
    let t18;
    if ($[35] !== isSSRFocusedComment || $[36] !== t16 || $[37] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.InlineHeaderButton), {
            isSSRFocusedComment: isSSRFocusedComment,
            "data-cy": "inline-nav-next",
            testId: "comment-navigation-next",
            iconBefore: t16,
            onClick: t17
        });
        $[35] = isSSRFocusedComment;
        $[36] = t16;
        $[37] = t17;
        $[38] = t18;
    } else t18 = $[38];
    let t19;
    if ($[39] !== nextCommentShortcutStrings || $[40] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t13,
            shortcut: nextCommentShortcutStrings,
            hideTooltipOnClick: true,
            position: "top"
        }, t18);
        $[39] = nextCommentShortcutStrings;
        $[40] = t18;
        $[41] = t19;
    } else t19 = $[41];
    let t20;
    if ($[42] !== renderServerPlaceholder) {
        t20 = renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            id: "inline-comment-index"
        }) : null;
        $[42] = renderServerPlaceholder;
        $[43] = t20;
    } else t20 = $[43];
    let t21;
    if ($[44] !== t12 || $[45] !== t19 || $[46] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.NavigationContainer), {
            "data-testid": "comment-navigation-container",
            shouldHaveButtonGap: true
        }, t12, t19, t20);
        $[44] = t12;
        $[45] = t19;
        $[46] = t20;
        $[47] = t21;
    } else t21 = $[47];
    return t21;
};
function $c0db869228662b46$var$_temp() {}
module.exports["CommentNavigation"] = $c0db869228662b46$export$c7f093fedf3e73fe;

});

parcelRegister("3BCCf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $9jl6v = parcelRequire("9jl6v");


var $liGyh = parcelRequire("liGyh");


var $8i27m = parcelRequire("8i27m");

const $33dbfc40da2aecd4$export$248861b924bd617d = ({ pageId: pageId, isEditor: isEditor, onNavigationClick: onNavigationClick, commentData: commentData })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = (0, $8i27m.useCommentsDataState)();
    const { removeCommentQueryParams: removeCommentQueryParams } = (0, $liGyh.useInlineCommentQueryParams)();
    const { navigateToInlineComment: navigateToInlineComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const orderedActiveAnnotations = (0, $cozmU.useMemo)(()=>{
        return orderedActiveAnnotationIdList.map((a)=>a.threadKey);
    }, [
        orderedActiveAnnotationIdList
    ]);
    const getCommentIndex = (0, $cozmU.useCallback)((currentMarkerRef)=>{
        return orderedActiveAnnotations?.findIndex((markerRef)=>markerRef === currentMarkerRef);
    }, [
        orderedActiveAnnotations
    ]);
    const currentInlineMarkerRef = commentData?.location?.inlineMarkerRef ?? '';
    const currentCommentIndex = getCommentIndex(currentInlineMarkerRef);
    const goToNextInlineComment = (0, $cozmU.useCallback)((triggeredByKeyboardShortcut = false)=>{
        navigateToInlineComment({
            action: 'next',
            triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
            currentCommentIndex: currentCommentIndex,
            getCommentIndex: getCommentIndex,
            onNavigationClick: onNavigationClick,
            isEditor: isEditor,
            removeCommentQueryParams: removeCommentQueryParams,
            unresolvedInlineComments: orderedActiveAnnotations,
            createAnalyticsEvent: createAnalyticsEvent,
            contentId: pageId
        });
    }, [
        getCommentIndex,
        navigateToInlineComment,
        createAnalyticsEvent,
        currentCommentIndex,
        onNavigationClick,
        pageId,
        removeCommentQueryParams,
        orderedActiveAnnotations,
        isEditor
    ]);
    const goToPrevInlineComment = (0, $cozmU.useCallback)((triggeredByKeyboardShortcut = false)=>{
        navigateToInlineComment({
            action: 'previous',
            triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
            currentCommentIndex: currentCommentIndex,
            getCommentIndex: getCommentIndex,
            onNavigationClick: onNavigationClick,
            isEditor: isEditor,
            removeCommentQueryParams: removeCommentQueryParams,
            unresolvedInlineComments: orderedActiveAnnotations,
            createAnalyticsEvent: createAnalyticsEvent,
            contentId: pageId
        });
    }, [
        getCommentIndex,
        navigateToInlineComment,
        createAnalyticsEvent,
        currentCommentIndex,
        onNavigationClick,
        pageId,
        removeCommentQueryParams,
        orderedActiveAnnotations,
        isEditor
    ]);
    return (0, $cozmU.useMemo)(()=>({
            currentCommentIndex: currentCommentIndex,
            goToNextInlineComment: goToNextInlineComment,
            goToPrevInlineComment: goToPrevInlineComment,
            commentsCount: orderedActiveAnnotations.length
        }), [
        goToNextInlineComment,
        goToPrevInlineComment,
        orderedActiveAnnotations.length,
        currentCommentIndex
    ]);
};
module.exports["useInlineCommentNavigation"] = $33dbfc40da2aecd4$export$248861b924bd617d;

});

parcelRegister("3omFm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gfqXk = parcelRequire("gfqXk");


var $3jwuS = parcelRequire("3jwuS");


var $cZa7r = parcelRequire("cZa7r");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $9FoVw = parcelRequire("9FoVw");


var $5fMeR = parcelRequire("5fMeR");


var $3mVfX = parcelRequire("3mVfX");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $b0EGa = parcelRequire("b0EGa");


var $2UZkz = parcelRequire("2UZkz");


var $jmjWc = parcelRequire("jmjWc");

// Loaded on demand — only rendered when user clicks a reaction annotation.
const $554aaf1aa11e07ba$var$NOOP = ()=>{};

const $554aaf1aa11e07ba$var$InlineReaction = (0, $jmjWc.LoadableActivatable)({
    __loadable_id__: "9TiBs",
    name: "InlineReaction",
    loader: async ()=>(await (parcelRequire("jHeAZ"))).InlineReaction
});
const $554aaf1aa11e07ba$export$aa84ce7cadd60676 = (nextMarkerRef)=>{
    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    emitter.emit('setselectedannotation', nextMarkerRef);
};
const $554aaf1aa11e07ba$export$f845437bf1d007fd = ({ annotations: clickedAnnotations, getInlineNodeTypes: getInlineNodeTypes, pageId: pageId, editorActions: editorActions, onClose: onClose, onDelete: onDelete, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar = false, isOffline: isOffline, reactionMarkerMap: reactionMarkerMap = {} })=>{
    const { setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const supportedCommentActions = !isLivePage ? [
        'edit',
        'resolve'
    ] : [
        'edit',
        'resolve',
        'delete'
    ];
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setCurrentView: setCurrentView } = (0, $3mVfX.useCommentsPanelActions)();
    const { currentView: currentView } = (0, $3mVfX.useCommentsPanelState)();
    const { isCommentsPanelShown: isCommentsPanelShown } = (0, $5fMeR.useShowCommentsPanel)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    // Hide OmniBar while a comment is selected (standalone or in panel). Only release when comment is fully closed.
    const { requestHideOmniBar: requestHideOmniBar, releaseHideOmniBar: releaseHideOmniBar } = (0, $b0EGa.useOmniBarVisibilityActions)();
    (0, $cozmU.useLayoutEffect)(()=>{
        if (clickedAnnotations.length > 0 && (0, $9wGTI.fg)('cc-engagement-omnibar-hide-inline-comments')) {
            requestHideOmniBar();
            return ()=>releaseHideOmniBar();
        }
    }, [
        clickedAnnotations.length,
        requestHideOmniBar,
        releaseHideOmniBar
    ]);
    const [isInlineCommentVisible, setIsInlineCommentVisible] = (0, $cozmU.useState)(false);
    const inlineCommentRef = (0, $cozmU.useCallback)((node)=>{
        if (node === null) setIsInlineCommentVisible(false);
        else setIsInlineCommentVisible(true);
    }, []);
    const handleResolve = ()=>{
        setEditorViewProps(null);
    };
    const handleDelete = (0, $cozmU.useCallback)((id)=>{
        setEditorViewProps(null);
        onDelete && onDelete(id);
    }, [
        setEditorViewProps,
        onDelete
    ]);
    (0, $cozmU.useEffect)(()=>{
        const annotationId = clickedAnnotations[0]?.id;
        if (!annotationId) return;
        const shouldScrollCommentsPanelToComment = isCommentsPanelShown && clickedAnnotations.length > 0;
        if (shouldScrollCommentsPanelToComment) {
            setCurrentlySelectedThreadKey(annotationId);
            let expectedView = undefined;
            if (currentView === (0, $3mVfX.ViewValues).RESOLVED || currentView === (0, $3mVfX.ViewValues).DELETED_CONTENT) {
                setCurrentView && setCurrentView((0, $3mVfX.ViewValues).OPEN);
                expectedView = (0, $3mVfX.ViewValues).OPEN;
            }
            (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                context: (0, $9FoVw.NavigationContext).PANEL,
                block: 'center',
                annotationId: annotationId,
                commentType: 'INLINE',
                annotationClicked: true,
                expectedView: expectedView
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        clickedAnnotations[0]?.id
    ]);
    // Construct deleteOptions so InlineReaction can strip the annotation mark
    // from the editor document when the last emoji is removed.
    const reactionDeleteOptions = (0, $cozmU.useMemo)(()=>onDelete ? {
            deleteAnnotation: (annotationInfo)=>{
                handleDelete(annotationInfo.id);
                return {
                    doc: {},
                    step: {}
                };
            },
            onDeleteSuccess: $554aaf1aa11e07ba$var$NOOP
        } : undefined, [
        onDelete,
        handleDelete
    ]);
    const handleNavigationClick = (nextMarkerRef)=>{
        experienceTracker.updateAttributes({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                annotationId: nextMarkerRef
            }
        });
        $554aaf1aa11e07ba$export$aa84ce7cadd60676(nextMarkerRef);
    };
    const shouldRenderStandaloneInlineComment = clickedAnnotations.length > 0 && !isCommentsPanelShown;
    if (!shouldRenderStandaloneInlineComment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
    const selectedAnnotation = clickedAnnotations[0];
    const isReactionAnnotation = selectedAnnotation.id in reactionMarkerMap && (0, $6mKj3.expVal)('confluence_inline_reactions', 'isEnabled', false);
    const reactionCommentId = isReactionAnnotation ? reactionMarkerMap[selectedAnnotation.id] : '';
    if (isReactionAnnotation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($554aaf1aa11e07ba$var$InlineReaction, {
        isEditor: true,
        pageId: pageId,
        annotation: selectedAnnotation,
        commentId: reactionCommentId,
        onClose: onClose ?? $554aaf1aa11e07ba$var$NOOP,
        onNavigationClick: (nextMarkerRef)=>handleNavigationClick(nextMarkerRef),
        onResolve: handleResolve,
        deleteOptions: reactionDeleteOptions,
        inlineCommentRef: inlineCommentRef,
        key: `inline-reaction-${selectedAnnotation.id}`
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2UZkz.InlineComment), {
        isEditor: true,
        annotation: selectedAnnotation,
        getInlineNodeTypes: getInlineNodeTypes,
        onClose: onClose,
        editorActions: editorActions,
        onNavigationClick: (nextMarkerRef)=>handleNavigationClick(nextMarkerRef),
        onResolve: handleResolve,
        onDelete: handleDelete,
        supportedTopLevelActions: supportedCommentActions,
        isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
        inlineCommentRef: inlineCommentRef,
        isInlineCommentVisible: isInlineCommentVisible,
        isOffline: isOffline,
        key: `inline-comment-${selectedAnnotation.id}`
    });
};
module.exports["editorHandleNavigationClick"] = $554aaf1aa11e07ba$export$aa84ce7cadd60676;
module.exports["ViewComponent"] = $554aaf1aa11e07ba$export$f845437bf1d007fd;

});

parcelRegister("2UZkz", function(module, exports) {

var $k67hX = parcelRequire("k67hX");


var $biHX4 = parcelRequire("biHX4");


var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $fJCU9 = parcelRequire("fJCU9");


var $epbW8 = parcelRequire("epbW8");


var $koEBx = parcelRequire("koEBx");


var $iMnC5 = parcelRequire("iMnC5");


var $308Wd = parcelRequire("308Wd");


var $9QIM2 = parcelRequire("9QIM2");


var $dANtQ = parcelRequire("dANtQ");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $7aw3q = parcelRequire("7aw3q");


var $g1WP0 = parcelRequire("g1WP0");


var $3Xfi8 = parcelRequire("3Xfi8");


var $eA7s6 = parcelRequire("eA7s6");


var $bQm3c = parcelRequire("bQm3c");


var $aSsfA = parcelRequire("aSsfA");


var $fHAwL = parcelRequire("fHAwL");


var $24amZ = parcelRequire("24amZ");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $cZa7r = parcelRequire("cZa7r");


var $kvJHJ = parcelRequire("kvJHJ");


var $i6UMJ = parcelRequire("i6UMJ");


var $3mVfX = parcelRequire("3mVfX");


var $cQCqE = parcelRequire("cQCqE");


var $jbF1h = parcelRequire("jbF1h");


var $kgNLQ = parcelRequire("kgNLQ");


var $4luml = parcelRequire("4luml");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $8Ss4E = parcelRequire("8Ss4E");


var $gtj7V = parcelRequire("gtj7V");


var $ep3mz = parcelRequire("ep3mz");


var $e4o8D = parcelRequire("e4o8D");


var $aGjYc = parcelRequire("aGjYc");


var $liGyh = parcelRequire("liGyh");


var $9wGTI = parcelRequire("9wGTI");


var $hXzKU = parcelRequire("hXzKU");


var $8z9UY = parcelRequire("8z9UY");


var $afGoD = parcelRequire("afGoD");


var $1C8XP = parcelRequire("1C8XP");


var $6mKj3 = parcelRequire("6mKj3");


var $emtVP = parcelRequire("emtVP");





var $gurMq = parcelRequire("gurMq");


var $gP7oS = parcelRequire("gP7oS");


var $aNRAP = parcelRequire("aNRAP");


var $4rKYp = parcelRequire("4rKYp");


var $NYiei = parcelRequire("NYiei");


var $lb2Lp = parcelRequire("lb2Lp");


var $zkUcd = parcelRequire("zkUcd");


var $auGhu = parcelRequire("auGhu");


var $kEmgx = parcelRequire("kEmgx");


var $cD1qu = parcelRequire("cD1qu");


var $g0DaR = parcelRequire("g0DaR");

var $asNlu = parcelRequire("asNlu");

var $isdzP = parcelRequire("isdzP");

var $8dA1U = parcelRequire("8dA1U");

var $jJx00 = parcelRequire("jJx00");


var $cHfPA = parcelRequire("cHfPA");


var $666Tc = parcelRequire("666Tc");


var $9CnRS = parcelRequire("9CnRS");


var $3ejfs = parcelRequire("3ejfs");


var $aMfLn = parcelRequire("aMfLn");


var $k8e76 = parcelRequire("k8e76");


var $3jwuS = parcelRequire("3jwuS");


var $cAdj8 = parcelRequire("cAdj8");


var $3ZsvI = parcelRequire("3ZsvI");


var $8i27m = parcelRequire("8i27m");


var $hl0fg = parcelRequire("hl0fg");


var $7Sm4c = parcelRequire("7Sm4c");


var $en1dX = parcelRequire("en1dX");


var $7aRa9 = parcelRequire("7aRa9");


var $4Svbr = parcelRequire("4Svbr");


var $fy5yb = parcelRequire("fy5yb");


var $7qvmT = parcelRequire("7qvmT");


var $5fMeR = parcelRequire("5fMeR");


var $6faGq = parcelRequire("6faGq");


var $3iaSn = parcelRequire("3iaSn");


var $6tkbf = parcelRequire("6tkbf");


var $jMyy4 = parcelRequire("jMyy4");


var $h3RCY = parcelRequire("h3RCY");


var $6Ebso = parcelRequire("6Ebso");


var $a3q17 = parcelRequire("a3q17");


var $B3Avz = parcelRequire("B3Avz");

const $f4f7ab8b4171ff8f$var$relativeFilePath = 'annotation-provider-inline-comments/InlineComment';
const $f4f7ab8b4171ff8f$var$InlineCommentDeleteInlineCommentMutationWithStepMutation = (0, $biHX4.default);
const $f4f7ab8b4171ff8f$var$InlineCommentCreateInlineReplyMutation = (0, $k67hX.default);
const $f4f7ab8b4171ff8f$var$i18n = (0, $kSwu1.defineMessages)({
    commentLoadError: {
        id: "annotation-provider-inline-comments.error.comment.load.message",
        defaultMessage: "Something went wrong when loading this comment. Refresh to view the latest updates."
    },
    commentLoadNetworkError: {
        id: "annotation-provider-inline-comments.network.error.message",
        defaultMessage: "This comment wasn't loaded due to a network error. Check your connection and try again."
    },
    commentLoadErrorTitle: {
        id: "annotation-provider-inline-comments.error.comment.load.title",
        defaultMessage: "Unable to load comment"
    },
    commentReplyAriaLabel: {
        id: "annotation-provider-inline-comments.comment.reply.aria-label",
        defaultMessage: "Reply to {name}\u2019s thread"
    },
    commentAriaLabel: {
        id: "annotation-provider-inline-comments.comment.aria-label",
        defaultMessage: "Comment by {displayName}, {timestamp}"
    }
});
const $f4f7ab8b4171ff8f$var$noop = ()=>{
// This is intentional
};
const $f4f7ab8b4171ff8f$var$InlineCommentComponent = ({ annotation: selectedAnnotation, onResolve: onResolve, deleteOptions: deleteOptions, onClose: onClose, isEditor: isEditor, isArchived: isArchived, onNavigationClick: onNavigationClick, onDelete: onDelete, supportedTopLevelActions: supportedTopLevelActions, getInlineNodeTypes: getInlineNodeTypes, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar, inlineCommentRef: inlineCommentRef = ()=>{}, isInlineCommentVisible: isInlineCommentVisible = false, flags: flags, isOffline: isOffline })=>{
    const pageClass = (0, $9QIM2.usePageClass)();
    const lastSelected = (0, $cozmU.useRef)(undefined);
    const { replyToCommentUser: replyToCommentUser, replyToContributorUsers: replyToContributorUsers } = (0, $3mVfX.useCommentsPanelState)();
    const { setCurrentView: setCurrentView, setReplyToCommentId: setReplyToCommentId, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey } = (0, $3mVfX.useCommentsPanelActions)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const [contentId = ''] = (0, $ep3mz.usePageContentId)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { focusedCommentId: focusedCommentId, replyToCommentId: replyToCommentId, editCommentId: editCommentQueryId } = (0, $liGyh.useInlineCommentQueryParams)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    const RENDER_METRIC = isEditor ? (0, $a3q17.EDITOR_INLINE_COMMENT_RENDER_METRIC) : (0, $a3q17.RENDERER_INLINE_COMMENT_RENDER_METRIC);
    if (lastSelected.current !== selectedAnnotation.id) {
        (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.start({
            pageClass: pageClass,
            annotationId: selectedAnnotation.id,
            entryPoint: 'unknown:InlineComment'
        });
        RENDER_METRIC.start();
        const attributes = {
            pageMode: pageMode,
            pageClass: pageClass,
            framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER,
            annotationId: selectedAnnotation.id,
            isEditor: !!isEditor,
            isArchived: !!isArchived,
            isOpeningMediaCommentFromToolbar: !!isOpeningMediaCommentFromToolbar,
            isInlineCommentVisible: !!isInlineCommentVisible,
            isOffline: !!isOffline,
            ...focusedCommentId && {
                focusedCommentId: focusedCommentId
            },
            ...replyToCommentId && {
                replyToCommentId: replyToCommentId
            },
            ...editCommentQueryId && {
                editCommentId: editCommentQueryId
            }
        };
        (0, $4EKKB.selectInlineComment).debug(`InlineComment component mounted with annotation id ${selectedAnnotation.id}`);
        experienceTracker.updateAttributes({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            attributes: attributes
        });
        if (pageClass !== 'renderer' && pageClass !== 'editor') experienceTracker.abort({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            reason: 'Page class is not renderer or editor',
            checkForTimeout: true,
            publishDebugPoints: true,
            attributes: {
                stopPoint: $f4f7ab8b4171ff8f$var$relativeFilePath
            }
        });
        lastSelected.current = selectedAnnotation.id;
    }
    const annotationElementRef = (0, $cozmU.useRef)(null);
    const resolveWindowCloseTimeout = (0, $cozmU.useRef)();
    const sidebarEl = (0, $cozmU.useRef)(null);
    const commentContainerElementRef = (0, $cozmU.useRef)(null);
    const [eventEmitter] = (0, $cozmU.useState)(()=>isEditor ? (0, $gfqXk.getEditorAnnotationEventEmitter)() : (0, $gczDe.getRendererAnnotationEventEmitter)());
    const [shouldFocusNewReply, setShouldFocusNewReply] = (0, $cozmU.useState)(false);
    const { addUnresolvedInlineComment: addUnresolvedInlineComment, removeUnresolvedInlineComment: removeUnresolvedInlineComment } = (0, $k8e76.useInlineCommentsActions)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId);
    const { handleClose: handleClose, setEditorCreateProps: setEditorCreateProps, setHoverProps: setHoverProps, setSelectionProps: setSelectionProps, setStoredCommentData: setStoredCommentData, clearStoredCommentData: clearStoredCommentData, setCommentSidebarContext: setCommentSidebarContext } = (0, $cZa7r.useAnnotationsDispatch)();
    const { storedCommentData: storedCommentData } = (0, $cZa7r.useAnnotations)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { userId: currentUserId, displayName: displayName, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { width: windowWidth } = (0, $hl0fg.useWindowSize)();
    const [editCommentId, setCommentForEdit] = (0, $cozmU.useState)('');
    const [resolvedComment, setResolvedComment] = (0, $cozmU.useState)(null);
    const [shouldRender, setShouldRender] = (0, $cozmU.useState)(false);
    const { onChange: onChange, resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { showFyi: showFyi, agent: agent, onContentChange: onAgentMentionContentChange } = (0, $gurMq.useAgentMentionFyiNudge)({
        cloudId: cloudId,
        enabled: (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true)
    });
    const hasShownFyiRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (showFyi) hasShownFyiRef.current = true;
    }, [
        showFyi
    ]);
    const handleContentChangeWithData = (0, $cozmU.useCallback)((_hasChanges, adf)=>{
        onAgentMentionContentChange(adf);
    }, [
        onAgentMentionContentChange
    ]);
    const { setActiveHighlight: setActiveHighlight } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { isCommentsPanelShown: isCommentsPanelShown, showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const nudgeRef = (0, $cozmU.useRef)(null);
    const [popupsScrollableElement, setPopupsScrollableElement] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState();
    const [hasParentMaxHeight, setHasParentMaxHeight] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const { updateReactionInCache: updateReactionInCache } = (0, $4luml.useUpdateReactionInCache)();
    const intl = (0, $kSwu1.useIntl)();
    const { formatMessage: formatMessage } = intl;
    const { isSticky: isSticky } = (0, $3Xfi8.useShouldCommentSidebarBeSticky)({
        annotationElement: annotationElementRef.current,
        isEditor: !!isEditor
    });
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const selectedAnnotationElement = !renderServerPlaceholder && typeof document !== 'undefined' ? document.getElementById(selectedAnnotation.id) : null;
    const popupsMountPoint = !renderServerPlaceholder && typeof document !== 'undefined' ? document.getElementById('editor-comments-sidebar') || document.body : undefined;
    const sidebarOffset = (0, $eA7s6.useCommentSidebarOffset)({
        isEditor: isEditor || false,
        annotationElement: selectedAnnotationElement,
        isViewCommentMode: true,
        windowWidth: windowWidth,
        isSticky: isSticky
    });
    const handleCloseCreateComment = (0, $cozmU.useCallback)(()=>{
        handleClose();
        setHoverProps(null);
        setSelectionProps(null);
        setEditorCreateProps(null);
    }, [
        handleClose,
        setHoverProps,
        setSelectionProps,
        setEditorCreateProps
    ]);
    const handleOnClose = (0, $cozmU.useCallback)(()=>{
        const isReply = editCommentId === '';
        experienceTracker.abort({
            name: isReply ? (0, $irVI7.REPLY_TO_INLINE_COMMENT_EXPERIENCE) : (0, $irVI7.EDIT_INLINE_COMMENT_EXPERIENCE),
            reason: 'comment discarded by user'
        });
        if (!(0, $aGjYc.isOptimisticSaveEnabled)()) // Skip clearing draft when the optimistic save is enabled.
        // In fact, when it's disabled, saveCommentDraft() is never called
        // with 'reply' or 'edit' mode, so this should be safe to skip too.
        // TODO: (COMMENTS-6792) Remove this entirely when optimistic save is rolled out.
        (0, $aGjYc.clearCommentDraft)(isEditor ? 'edit-inline' : 'inline', isReply ? 'reply' : 'edit');
        setShouldFocusNewReply(false);
        onClose && onClose();
        setActiveHighlight(null);
    }, [
        experienceTracker,
        editCommentId,
        isEditor,
        onClose,
        setActiveHighlight
    ]);
    // For now, this is a function that takes a boolean and returns a function.
    // The mustSetActiveHighlight parameter and the extra layer of nesting can be
    // removed after confluence_comment_resolve_kbs_fix is rolled out and cleaned up.
    const handleOnCloseUnified = (0, $cozmU.useCallback)((mustSetActiveHighlight)=>()=>{
            if (isEditor) handleOnClose();
            else {
                onClose && onClose();
                if (mustSetActiveHighlight || (0, $6mKj3.expValEquals)('confluence_comment_resolve_kbs_fix', 'isEnabled', true)) setActiveHighlight(null);
            }
        }, [
        isEditor,
        handleOnClose,
        onClose,
        setActiveHighlight
    ]);
    const onlyHasReactionsSummaryErrors = (0, $cozmU.useCallback)((error)=>{
        let hasOtherGqlErrors = false;
        if (error.graphQLErrors?.length > 0) error.graphQLErrors.forEach((e)=>{
            if (e.path?.includes('reactionsSummary')) (0, $4EKKB.selectInlineComment).debug('found reactionsSummary graphql error', {
                errorMessage: e.message
            });
            else hasOtherGqlErrors = true;
        });
        return !hasOtherGqlErrors && !error.networkError;
    }, []);
    const handleGqlError = (0, $cozmU.useCallback)((error)=>{
        (0, $4EKKB.selectInlineComment).debug('received a gql error', {
            errorMessage: error.message
        });
        if (onlyHasReactionsSummaryErrors(error)) {
            (0, $4EKKB.selectInlineComment).debug('did not receive non-reactionsSummary errors, ignoring');
            return;
        }
        // If the error is reactions based, just set it to null and move on
        if (error.message.search(/reactions/i) !== -1 || error.message.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
        const parsedError = (0, $isdzP.parseError)(error);
        const translatedError = (0, $isdzP.getTranslatedError)(parsedError.message);
        if (translatedError === (0, $9CnRS.i18n).unexpectedError) {
            flags.showWarningFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f4f7ab8b4171ff8f$var$i18n.commentLoadErrorTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f4f7ab8b4171ff8f$var$i18n.commentLoadError)
            });
            (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.fail(error);
            experienceTracker.stopOnError({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                error: error,
                attributes: {
                    stopPoint: $f4f7ab8b4171ff8f$var$relativeFilePath
                }
            });
        } else {
            flags.showWarningFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f4f7ab8b4171ff8f$var$i18n.commentLoadErrorTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $isdzP.isNetworkError)(translatedError) ? $f4f7ab8b4171ff8f$var$i18n.commentLoadNetworkError : translatedError)
            });
            (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.abort({
                abortReason: parsedError.message
            });
            experienceTracker.abort({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                reason: parsedError.message,
                checkForTimeout: true,
                publishDebugPoints: true,
                attributes: {
                    stopPoint: $f4f7ab8b4171ff8f$var$relativeFilePath
                }
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
        (0, $4EKKB.selectInlineComment).debug('Closing create comment following a gql error');
        // Close the create comment component if there was an error loading the newly created comment
        handleCloseCreateComment();
    }, [
        experienceTracker,
        flags,
        handleCloseCreateComment,
        onlyHasReactionsSummaryErrors
    ]);
    const [{ unreadCommentIDSet: unreadCommentIDSet }] = (0, $fHAwL.useUnreadComments)();
    // Determine if we should use cache-only policy or skip query entirely
    const shouldSkipQuery = Boolean(storedCommentData);
    // When experiment is enabled, use useCommentById with markerRef to find comment directly
    const commentByMarkerRef = (0, $lb2Lp.useCommentById)({
        markerRef: selectedAnnotation.id,
        contentId: contentId,
        contentStatus: (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode),
        options: {
            skip: shouldSkipQuery || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false),
            fetchPolicy: 'cache-first'
        }
    });
    // Use useAllCommentsData to get deleteCommentInCache function
    const { deleteCommentInCache: deleteCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: true
        }
    });
    const { data: data, error: gqlError } = (0, $jMyy4.useQueryInterop)((0, $1C8XP.ActiveInlineCommentsQuery), {
        variables: {
            pageId: contentId,
            inlineMarkerRefList: [
                selectedAnnotation.id
            ],
            contentStatus: [
                isArchived ? 'ARCHIVED' : 'DRAFT',
                'CURRENT'
            ]
        },
        onError: undefined,
        fetchPolicy: 'cache-and-network',
        skip: shouldSkipQuery || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false),
        // This allows rendering using data from a partially-successful graphql query.
        // If query receives an error, `gqlError` will be set, while any successfully
        // fetched data will be available in `data` and be rendered.
        errorPolicy: 'all',
        __callerPackage__: "annotation-provider-inline-comments"
    });
    // Use initial comment data, new hook data, or query data
    const effectiveData = (0, $cozmU.useMemo)(()=>{
        if (commentByMarkerRef?.comment && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return {
            comments: {
                nodes: [
                    commentByMarkerRef.comment
                ]
            }
        };
        if (shouldSkipQuery) return {
            comments: {
                nodes: [
                    storedCommentData
                ]
            }
        };
        return data;
    }, [
        shouldSkipQuery,
        storedCommentData,
        commentByMarkerRef?.comment,
        data
    ]);
    const [reopenInlineCommentFn] = (0, $308Wd.useMutationInterop)((0, $h3RCY.default), {
        ...(0, $6tkbf.buildMutationContextForNoNetworkError)(),
        __callerPackage__: "annotation-provider-inline-comments"
    });
    // Get the update function for the comments data manager
    const { updateCommentInCache: updateCommentInCache } = (0, $jbF1h.useUpdateCommentInCache)();
    const { pageInfo: pageInfo, error: pageInfoError } = (0, $cAdj8.usePageInfo)();
    (0, $cozmU.useEffect)(()=>{
        if (pageInfoError) handleGqlError(pageInfoError);
    }, [
        pageInfoError,
        handleGqlError
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (gqlError) handleGqlError(gqlError);
    }, [
        gqlError,
        handleGqlError
    ]);
    // When the selectedAnnotation changes make sure we unset whatever resolved logic exists
    (0, $cozmU.useEffect)(()=>{
        setResolvedComment(null);
        clearTimeout(resolveWindowCloseTimeout.current);
        resolveWindowCloseTimeout.current = undefined;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedAnnotation
    ]);
    const [resolveInlineCommentFn] = (0, $308Wd.useMutationInterop)((0, $h3RCY.default), {
        ...(0, $6tkbf.buildMutationContextForNoNetworkError)(),
        __callerPackage__: "annotation-provider-inline-comments"
    });
    const [deleteInlineCommentFn] = (0, $308Wd.useMutationInterop)((0, $6Ebso.DeleteInlineCommentMutation), {
        ...(0, $6tkbf.buildMutationContextForNoNetworkError)(),
        __callerPackage__: "annotation-provider-inline-comments"
    });
    const [deleteInlineCommentWithStepFn] = (0, $308Wd.useMutationInterop)($f4f7ab8b4171ff8f$var$InlineCommentDeleteInlineCommentMutationWithStepMutation, {
        ...(0, $6tkbf.buildMutationContextForNoNetworkError)(),
        __callerPackage__: "annotation-provider-inline-comments"
    });
    const [createReplyFn] = (0, $308Wd.useMutationInterop)($f4f7ab8b4171ff8f$var$InlineCommentCreateInlineReplyMutation, {
        ...(0, $6tkbf.buildMutationContextForNoNetworkError)(),
        __callerPackage__: "annotation-provider-inline-comments"
    });
    const { createInlineReplyInterop: createInlineReplyInterop } = (0, $cQCqE.useCreateInlineReplyMutation)({
        contentId: contentId
    });
    // Tracks pending reply submission for coordinated editor reset (new data manager only).
    // When set, useLayoutEffect will call onReplyProcessed when the expected reply appears in the list.
    const pendingReplyRef = (0, $cozmU.useRef)(null);
    // Editor setup
    const spaceId = pageInfo?.space?.id ?? '';
    const pageType = pageInfo?.type ?? '';
    // User page permissions
    const operations = pageInfo?.operations || [];
    const spaceOperations = (0, $9wGTI.fg)('confluence_comments_space_operations_permissions') ? pageInfo?.space?.operations || [] : [];
    const canAddComment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'comment');
    const canAddAttachment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'attachment') || spaceOperations.some((op)=>op?.operation === 'create' && op?.targetType === 'attachment');
    const hasMediaUploadPermissions = canAddComment && canAddAttachment;
    // Comment metadata
    let commentData;
    if (commentByMarkerRef?.comment && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) commentData = commentByMarkerRef.comment; // Use comment from useCommentById
    else if (shouldSkipQuery) commentData = storedCommentData; // Use initial comment data directly
    else commentData = effectiveData?.comments?.nodes?.[0];
    // Track experiment completion when comment data is loaded and rendered
    (0, $cozmU.useEffect)(()=>{
        // Only track when we have comment data and the component is visible
        // And only when the experiment is running
        if (commentData && isInlineCommentVisible) {
            experienceTracker.succeed({
                name: (0, $irVI7.VIEW_PAGE_DIRECT_COMMENT_DATA_FLOW_EXPERIENCE),
                attributes: {
                    annotationId: selectedAnnotation.id,
                    pageId: contentId,
                    pageMode: isEditor ? (0, $cD1qu.PageMode).EDIT : (0, $cD1qu.PageMode).VIEW,
                    isEditor: Boolean(isEditor)
                }
            });
            (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).stop();
        }
    }, [
        commentData,
        isInlineCommentVisible,
        storedCommentData,
        selectedAnnotation.id,
        contentId,
        isEditor,
        experienceTracker
    ]);
    const commentStatus = (0, $3iaSn.useGetCommentStatus)({
        resolveProperties: commentData?.location?.inlineResolveProperties || commentData?.location?.commentResolveProperties
    });
    const topCommentUserId = commentData?.author?.accountId;
    const topCommentUserAvatar = commentData?.author?.profilePicture?.path;
    const topCommentDisplayName = commentData?.author?.displayName ?? formatMessage((0, $3ejfs.commentsi18n).anonymous);
    const commentId = commentData?.id;
    const createdAt = commentData?.createdAt?.value;
    const createdAtNonLocalized = commentData?.createdAtNonLocalized;
    const when = commentData?.version?.when;
    const versionByDisplayName = commentData?.version?.by?.displayName;
    const isEdited = (commentData?.version?.number || 0) > 1;
    const permissions = commentData?.permissions;
    const content = commentData?.body?.value;
    const permissionType = commentData?.author?.permissionType;
    const numReplies = commentData?.replies?.length || 0;
    const commentThreadLength = 1 + numReplies; // includes root comment
    // Agent session — mirror the page's agent-session map into local state (populated by
    // the AgentSessionsProvider mounted on this component's return via onSessionMapChange).
    // We read it here so the connector/thread line can be forced on when this comment has
    // an agent session even if it has no replies. Gate inlined per
    // confluence-feature-gating rules.
    const [agentSessionMap, setAgentSessionMap] = (0, $cozmU.useState)(null);
    const parentHasAgentSession = Boolean(commentId && agentSessionMap?.get(commentId)) && (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true);
    const resolveProperties = commentData?.location?.inlineResolveProperties || undefined;
    const commentUrl = isEditor && !isLivePage ? commentData?.links.editui : commentData?.links.webui;
    const reactionsSummary = commentData?.reactionsSummary ?? null;
    const contributors = (0, $cHfPA.hasContributors)(commentData) ? commentData.contributors : undefined;
    // When new data manager is on: detect when the expected reply appears in the list and call onReplyProcessed
    // before paint, so user never sees editor + new reply at the same time.
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) return;
        const pending = pendingReplyRef.current;
        if (!pending) return;
        const replies = commentData?.replies ?? [];
        const expectedReplyVisible = replies.some((r)=>r.id === pending.expectedReplyId);
        if (!expectedReplyVisible) return;
        pendingReplyRef.current = null;
        if (pending.hasAgentMention) return;
        (0, $9kbTQ.flushSync)(()=>pending.onReplyProcessed());
    }, [
        commentData?.replies
    ]);
    const [{ commentsDataMap: commentsDataMap, orderedActiveAnnotationIdList: orderedActiveAnnotationIdList }, { addReplyToCommentThread: addReplyToCommentThread, handleRemovingComments: handleRemovingComments, deleteParentComment: deleteParentComment, resolveParentComment: resolveParentComment, reopenParentComment: reopenParentComment, setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList }] = (0, $8i27m.useCommentsData)();
    (0, $cozmU.useEffect)(()=>{
        if (commentId) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'viewed',
                    actionSubject: 'inlineCommentsSidebar',
                    objectType: 'page',
                    objectId: contentId,
                    source: isEditor ? 'editPageScreen' : 'viewPageScreen',
                    attributes: {
                        ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                        mode: pageMode,
                        framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER,
                        commentsDeckSize: numReplies + 1,
                        commentId: // +1 for the parent comment
                        commentId
                    }
                }
            }).fire();
            (0, $4EKKB.selectInlineComment).debug(`Comment ID or page ID was updated. Comment ID: ${commentId}, page ID: ${contentId}`);
        }
    // We really only need to depend on these two things and want this to fire when ONLY they change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        commentId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (editCommentQueryId) setCommentForEdit(editCommentQueryId);
    }, [
        editCommentQueryId
    ]);
    (0, $cozmU.useEffect)(()=>{
        const isReplyToCommentInChain = commentData?.replies?.map((reply)=>reply?.id)?.includes(replyToCommentId);
        setShouldFocusNewReply(Boolean(replyToCommentId) && (isReplyToCommentInChain || replyToCommentId === commentId));
    }, [
        replyToCommentId,
        commentId,
        commentData
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (shouldFocusNewReply) {
            // for parent comment
            if (commentData && replyToCommentId === commentData.id) handleReplyToComment(commentData?.id, commentData);
            else {
                const replyObj = commentData?.replies?.find((reply)=>reply?.id === replyToCommentId);
                if (replyObj && replyObj.parentId) handleReplyToComment(replyObj.parentId, replyObj);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldFocusNewReply,
        commentData?.replies
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (effectiveData && pageInfo) {
            (0, $4EKKB.selectInlineComment).debug('Closing create comment as the view component is ready [!apollo_loading]');
            // Close the create comment component when the view component is ready
            handleCloseCreateComment();
            setShouldRender(true);
            (0, $4EKKB.selectInlineComment).debug('Data has loaded. Rendering inline comment sidebar... [apollo_loading]');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        effectiveData,
        pageInfo
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            setShouldRender(false);
            (0, $4EKKB.selectInlineComment).debug('Data changed, hiding comment', {
                ...!!commentId && {
                    commentId: commentId
                },
                pageId: contentId,
                selectedAnnotationId: selectedAnnotation.id,
                shouldRender: shouldRender
            });
            (0, $4EKKB.selectInlineComment).debug(`Data has changed. Selected annotation ID: ${selectedAnnotation?.id}, comment ID: ${commentId}, page ID: ${contentId}, shouldRender: ${shouldRender}. Hiding inline comment sidebar (if open)...`);
            if (shouldRender) {
                (0, $4EKKB.selectInlineCommentCompoundExperience).abort({
                    abortReason: 'Inline comment experience received a new experience while already running'
                });
                experienceTracker.abort({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    reason: `Inline comment component has received new data and is hiding the inline comment sidebar. shouldRender: ${shouldRender}. This is most likely because the user has navigated between inline comments too quickly using the keyboard shortcuts. This is an expected abort experience`,
                    checkForTimeout: true,
                    publishDebugPoints: true,
                    attributes: {
                        stopPoint: $f4f7ab8b4171ff8f$var$relativeFilePath
                    }
                });
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        commentId,
        contentId,
        selectedAnnotation
    ]);
    // Reset commentSidebarContext when view sidebar unmounts so next open is treated as view
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            setCommentSidebarContext(null);
        };
    }, [
        setCommentSidebarContext
    ]);
    (0, $cozmU.useEffect)(()=>{
        // if the user has been shown the resolved comment view, but navigated away to another comment
        // we need to cancel the autodismiss functionality, as it will close this entire view and not just the
        // resolved comment notification
        if (commentId !== resolvedComment?.commentId) {
            clearTimeout(resolveWindowCloseTimeout.current);
            resolveWindowCloseTimeout.current = undefined;
        }
    }, [
        commentId,
        resolvedComment,
        resolveWindowCloseTimeout
    ]);
    const toggleCommentMode = (id = '')=>{
        setCommentForEdit(id);
    };
    (0, $cozmU.useEffect)(()=>{
        const markerRef = commentData?.location?.inlineMarkerRef;
        if (markerRef) setActiveHighlight(markerRef);
    }, [
        commentData,
        setActiveHighlight
    ]);
    const handleReplyToComment = (id, commentReplyData)=>{
        const referencedData = commentReplyData || commentData;
        let contributorUsers;
        if ((0, $cHfPA.hasContributors)(referencedData) && (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true)) contributorUsers = (0, $7qvmT.getReplyToContributorUsers)(referencedData.contributors);
        setShouldFocusNewReply(true);
        setReplyToCommentId({
            parentCommentId: id,
            location: (0, $i6UMJ.LocationValue).STANDALONE,
            user: {
                displayName: referencedData?.author?.displayName,
                accountId: referencedData?.author?.accountId
            },
            contributorUsers: contributorUsers
        });
    };
    const deleteCommentInCacheOnUpdate = (0, $cozmU.useCallback)((removalCommentId)=>deleteCommentInCache({
            commentId: removalCommentId,
            onError: (err)=>{
                (0, $8dA1U.handleMutationFailure)({
                    experienceTracker: experienceTracker,
                    experienceName: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
                    error: err,
                    commentId: removalCommentId
                });
            }
        }), [
        deleteCommentInCache,
        experienceTracker
    ]);
    // eslint-disable-next-line confluence-feature-gating/inline-usage -- Preserve a single exposure for optimistic delete; this value is intentionally reused across delete handlers.
    const isOptimisticDeleteEnabled = (0, $6mKj3.expVal)('confluence_fe_delete_comment_optimistic', 'isEnabled', false);
    const handleDeleteCommentError = (0, $cozmU.useCallback)(({ err: err, isReply: isReply, deletedCommentId: deletedCommentId, deletedReplyComment: deletedReplyComment })=>{
        const parsedError = (0, $isdzP.parseError)(err);
        const translatedError = (0, $isdzP.getTranslatedError)(parsedError.message, deletedCommentId);
        if ((0, $isdzP.isAlreadyDeletedError)(translatedError)) {
            flags.showWarningFlag({
                id: deletedCommentId,
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9CnRS.i18n).commentAlreadyDeletedTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), translatedError)
            });
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'alreadyDeleted',
                    actionSubject: 'comment',
                    actionSubjectId: deletedCommentId,
                    objectType: 'page',
                    objectId: contentId,
                    source: pageMode === (0, $cD1qu.PageMode).VIEW ? 'viewPageScreen' : 'editPageScreen',
                    attributes: {
                        ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                        commentType: (0, $8i27m.CommentType).INLINE,
                        source: (0, $en1dX.AnalyticsSource).STANDALONE,
                        mode: pageMode,
                        framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER,
                        isReply: isReply
                    }
                }
            }).fire();
        } else if (isOptimisticDeleteEnabled) // show an error flag to the user when optimistic deletion fails
        flags.showErrorFlag({
            id: deletedCommentId,
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9CnRS.i18n).deleteErrorTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9CnRS.i18n).deleteError)
        });
        // If a parent comment, mark the annotation as ACTIVE again
        if (!isReply && isOptimisticDeleteEnabled) (0, $jJx00.unresolveInlineCommentAnnotation)(selectedAnnotation.id, pageMode, eventEmitter);
        // If a reply was optimistically deleted, add it back to the comment thread
        if (deletedReplyComment && isOptimisticDeleteEnabled && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) addReplyToCommentThread(selectedAnnotation.id, deletedReplyComment, (0, $8i27m.CommentType).INLINE, true);
        (0, $8dA1U.handleMutationFailure)({
            experienceTracker: experienceTracker,
            experienceName: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
            error: err,
            commentId: deletedCommentId
        });
    }, [
        eventEmitter,
        experienceTracker,
        flags,
        contentId,
        pageMode,
        selectedAnnotation,
        isOptimisticDeleteEnabled,
        addReplyToCommentThread,
        createAnalyticsEvent
    ]);
    const handleDeleteCommentInRenderer = (0, $cozmU.useCallback)((parentId, replyCommentId)=>{
        const isReply = Boolean(parentId);
        let deleteResult;
        let mtnVariables;
        if (isReply) mtnVariables = {
            variables: {
                commentIdToDelete: replyCommentId,
                deleteFrom: (0, $8z9UY.CommentDeletionLocation).LIVE
            }
        };
        else {
            try {
                // Call deleteAnnotation(selectedAnnotation) to get step and any other required variables
                deleteResult = deleteOptions?.deleteAnnotation(selectedAnnotation);
            } catch (e) {
                experienceTracker.stopOnError({
                    name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
                    error: e
                });
                return;
            }
            if (!deleteResult) {
                experienceTracker.stopOnError({
                    name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE),
                    error: new Error(`Unable to remove annotation ${selectedAnnotation.id} from document`)
                });
                return;
            }
            mtnVariables = {
                variables: {
                    input: {
                        commentId: commentId,
                        step: (0, $aMfLn.constructStepForGql)(deleteResult.step)
                    }
                }
            };
        }
        // After deleting it will not be available, so we need to get the inline node types before deleting.
        const inlineNodeTypes = selectedAnnotation ? getInlineNodeTypes(selectedAnnotation.id) : undefined;
        // top-level comment calls `deleteInlineCommentWithStepFn`
        // reply calls `deleteInlineComment`
        const deleteFn = isReply ? deleteInlineCommentFn : deleteInlineCommentWithStepFn;
        const deletedCommentId = isReply ? replyCommentId : commentId;
        const cacheUpdateCallback = isReply ? (0, $g0DaR.updateApolloCacheCallbackForGA)('delete', {
            pageId: contentId,
            annotationId: selectedAnnotation.id,
            contentStatus: [
                'DRAFT',
                'CURRENT'
            ]
        }, parentId, replyCommentId) : undefined;
        const optimisticDeleteResponse = isReply ? {
            deleteComment: true
        } : {
            deleteInlineComment: true
        };
        // If a parent comment, optimistically mark the annotation as resolved and
        // simply close the standalone. No need to invoke `deleteParentComment` here.
        if (!isReply && isOptimisticDeleteEnabled) {
            (0, $jJx00.resolveInlineCommentAnnotation)(selectedAnnotation.id, pageMode, eventEmitter);
            handleOnCloseUnified(false)();
        }
        // If a reply, optimistically delete it.
        const deletedReplyComment = isReply && replyCommentId && isOptimisticDeleteEnabled && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? (0, $fy5yb.deleteReplyCommentOptimistically)({
            threadKey: selectedAnnotation.id,
            commentId: replyCommentId,
            commentType: (0, $8i27m.CommentType).INLINE,
            commentsDataMap: commentsDataMap,
            handleRemovingComments: handleRemovingComments
        }) : null;
        deleteFn({
            ...mtnVariables,
            update: (0, $kgNLQ.selectUpdateFunction)((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false), ()=>deleteCommentInCacheOnUpdate(deletedCommentId), cacheUpdateCallback),
            optimisticResponse: isOptimisticDeleteEnabled ? optimisticDeleteResponse : undefined
        }).then((retVal)=>{
            const deleteResultData = isReply ? retVal.data : retVal.data;
            if (!deleteResultData || !isReply && !deleteResultData.deleteInlineComment) throw new Error('No data returned from mutation');
            const deleteAnnotationAndCleanUp = (annotationId)=>{
                // Update storedCommentData if it exists
                if (storedCommentData && clearStoredCommentData) {
                    if (!isReply) // Deleting the main comment, clear all data
                    clearStoredCommentData();
                    else if (replyCommentId) {
                        // Deleting a reply, remove it from the replies array
                        const updatedCommentData = {
                            ...storedCommentData,
                            replies: (storedCommentData.replies || []).filter((reply)=>reply?.id !== replyCommentId)
                        };
                        setStoredCommentData(updatedCommentData);
                    }
                }
                if (!isReply) {
                    // We handle this being false above and can't get here if it is
                    if (deleteResult) deleteOptions?.onDeleteSuccess(deleteResult.doc, annotationId);
                    // Reset the content state on successful deletion on a non-reply
                    resetContentChanged();
                    onClose && onClose();
                    if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) deleteParentComment({
                        threadKey: annotationId,
                        commentType: (0, $8i27m.CommentType).INLINE
                    });
                } else if (replyCommentId) {
                    if (!isOptimisticDeleteEnabled && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) handleRemovingComments({
                        threadKey: annotationId,
                        commentId: replyCommentId,
                        action: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                        commentType: (0, $8i27m.CommentType).INLINE
                    });
                }
                experienceTracker.succeed({
                    name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE)
                });
            };
            (0, $8dA1U.handleDeleteSuccess)({
                commentId: deletedCommentId,
                annotationId: selectedAnnotation?.id,
                pageId: contentId,
                pageMode: pageMode,
                isReply: isReply,
                source: (0, $en1dX.AnalyticsSource).STANDALONE,
                inlineNodeTypes: inlineNodeTypes,
                createAnalyticsEvent: createAnalyticsEvent,
                removeUnresolvedInlineComment: removeUnresolvedInlineComment,
                onSuccess: deleteAnnotationAndCleanUp
            });
        }).catch((err)=>{
            handleDeleteCommentError({
                err: err,
                isReply: isReply,
                deletedCommentId: deletedCommentId,
                deletedReplyComment: deletedReplyComment
            });
        });
    }, [
        commentId,
        createAnalyticsEvent,
        deleteOptions,
        deleteCommentInCacheOnUpdate,
        eventEmitter,
        experienceTracker,
        resetContentChanged,
        onClose,
        contentId,
        isOptimisticDeleteEnabled,
        storedCommentData,
        clearStoredCommentData,
        setStoredCommentData,
        handleOnCloseUnified,
        removeUnresolvedInlineComment,
        selectedAnnotation,
        deleteInlineCommentFn,
        deleteInlineCommentWithStepFn,
        pageMode,
        getInlineNodeTypes,
        handleRemovingComments,
        deleteParentComment,
        commentsDataMap,
        handleDeleteCommentError
    ]);
    const handleDeleteCommentInEditorAndLivePages = (0, $cozmU.useCallback)((parentId, replyCommentId)=>{
        const isReply = Boolean(parentId);
        const targetNodeType = (0, $asNlu.getTargetNodeType)(selectedAnnotation.id, true);
        const deletedCommentId = isReply ? replyCommentId : commentId;
        const cacheUpdateCallback = isReply ? (0, $g0DaR.updateApolloCacheCallbackForGA)('delete', {
            pageId: contentId,
            annotationId: selectedAnnotation.id,
            contentStatus: [
                'DRAFT',
                'CURRENT'
            ]
        }, parentId, replyCommentId) : undefined;
        // If a parent comment, optimistically mark the annotation as resolved and
        // simply close the standalone. No need to invoke `deleteParentComment` here.
        if (!isReply && isOptimisticDeleteEnabled) {
            (0, $jJx00.resolveInlineCommentAnnotation)(selectedAnnotation.id, pageMode, eventEmitter);
            handleOnCloseUnified(false)();
        }
        // If a reply, optimistically delete it.
        const deletedReplyComment = isReply && replyCommentId && isOptimisticDeleteEnabled && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? (0, $fy5yb.deleteReplyCommentOptimistically)({
            threadKey: selectedAnnotation.id,
            commentId: replyCommentId,
            commentType: (0, $8i27m.CommentType).INLINE,
            commentsDataMap: commentsDataMap,
            handleRemovingComments: handleRemovingComments
        }) : null;
        // both top-level comments and replies call `deleteInlineComment`
        deleteInlineCommentFn({
            variables: {
                commentIdToDelete: deletedCommentId,
                deleteFrom: isLivePage ? (0, $8z9UY.CommentDeletionLocation).LIVE : (0, $8z9UY.CommentDeletionLocation).EDITOR
            },
            update: (0, $kgNLQ.selectUpdateFunction)((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false), ()=>deleteCommentInCacheOnUpdate(deletedCommentId), cacheUpdateCallback),
            optimisticResponse: isOptimisticDeleteEnabled ? {
                deleteComment: true
            } : undefined
        }).then((retVal)=>{
            const { data: deleteResultData } = retVal;
            if (!deleteResultData || !isReply && !deleteResultData.deleteComment) throw new Error('No data returned from mutation');
            // Update storedCommentData if it exists
            if (storedCommentData) {
                if (!isReply) // Deleting the main comment, clear all data
                clearStoredCommentData();
                else if (replyCommentId) {
                    // Deleting a reply, remove it from the replies array
                    const updatedCommentData = {
                        ...storedCommentData,
                        replies: (storedCommentData.replies || []).filter((reply)=>reply?.id !== replyCommentId)
                    };
                    setStoredCommentData(updatedCommentData);
                }
            }
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'deleted',
                    actionSubject: 'comment',
                    actionSubjectId: deletedCommentId,
                    objectType: 'page',
                    objectId: contentId,
                    source: 'editPageScreen',
                    attributes: {
                        ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                        commentType: (0, $8i27m.CommentType).INLINE,
                        source: (0, $en1dX.AnalyticsSource).STANDALONE,
                        pageMode: pageMode,
                        framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER,
                        inlineNodeTypes: selectedAnnotation ? getInlineNodeTypes(selectedAnnotation.id) : undefined,
                        isReply: isReply,
                        targetNodeType: targetNodeType
                    }
                }
            }).fire();
            experienceTracker.succeed({
                name: (0, $irVI7.DELETE_INLINE_COMMENT_EXPERIENCE)
            });
            if (!isReply) {
                onDelete?.(selectedAnnotation?.id);
                // Remove the comment from the unresolved list
                removeUnresolvedInlineComment(selectedAnnotation?.id);
                // Reset the content state on successful deletion on a non-reply
                resetContentChanged();
                if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) deleteParentComment({
                    threadKey: selectedAnnotation.id,
                    commentType: (0, $8i27m.CommentType).INLINE
                });
            } else if (replyCommentId) {
                if (!isOptimisticDeleteEnabled && !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) handleRemovingComments({
                    threadKey: selectedAnnotation.id,
                    commentId: replyCommentId,
                    action: (0, $8i27m.CommentActionType).DELETE_COMMENT,
                    commentType: (0, $8i27m.CommentType).INLINE
                });
            }
        }).catch((err)=>{
            handleDeleteCommentError({
                err: err,
                isReply: isReply,
                deletedCommentId: deletedCommentId,
                deletedReplyComment: deletedReplyComment
            });
        });
    }, [
        commentId,
        createAnalyticsEvent,
        deleteInlineCommentFn,
        deleteCommentInCacheOnUpdate,
        eventEmitter,
        experienceTracker,
        pageMode,
        contentId,
        onDelete,
        selectedAnnotation,
        getInlineNodeTypes,
        resetContentChanged,
        isLivePage,
        storedCommentData,
        clearStoredCommentData,
        setStoredCommentData,
        handleOnCloseUnified,
        isOptimisticDeleteEnabled,
        removeUnresolvedInlineComment,
        handleRemovingComments,
        deleteParentComment,
        commentsDataMap,
        handleDeleteCommentError
    ]);
    // When handleDeleteComment() is called for a reply, both parentId and replyCommentId are defined
    // When called for a top-level comment, both are undefined
    const handleDeleteComment = (0, $cozmU.useCallback)((parentId, replyCommentId)=>{
        if (!isEditor) handleDeleteCommentInRenderer(parentId, replyCommentId);
        else handleDeleteCommentInEditorAndLivePages(parentId, replyCommentId);
    }, [
        isEditor,
        handleDeleteCommentInRenderer,
        handleDeleteCommentInEditorAndLivePages
    ]);
    const handleResolveMutationFailure = (0, $cozmU.useCallback)((resolveError)=>{
        (0, $8dA1U.handleMutationFailure)({
            experienceTracker: experienceTracker,
            experienceName: (0, $irVI7.RESOLVE_INLINE_COMMENT_EXPERIENCE),
            error: resolveError
        });
    }, [
        experienceTracker
    ]);
    const resolveUpdateFn = (0, $cozmU.useCallback)((_dataProxy, mutationResult)=>updateCommentInCache({
            mutationResult: mutationResult,
            commentId: commentId,
            updateCallback: (0, $kgNLQ.resolveInlineCommentInCacheCallback),
            onError: handleResolveMutationFailure
        }), [
        updateCommentInCache,
        commentId,
        handleResolveMutationFailure
    ]);
    const getReopenUpdateFn = (0, $cozmU.useCallback)((onReopenCacheError)=>{
        const reopenUpdateFcn = (_dataProxy, mutationResult)=>updateCommentInCache({
                mutationResult: mutationResult,
                commentId: commentId,
                updateCallback: (0, $kgNLQ.resolveInlineCommentInCacheCallback),
                onError: onReopenCacheError
            });
        return reopenUpdateFcn;
    }, [
        updateCommentInCache,
        commentId
    ]);
    const handleResolveComment = ()=>{
        const mtnOptions = {
            variables: {
                commentId: commentId,
                resolved: true
            },
            ...(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) && {
                update: resolveUpdateFn
            }
        };
        const annotationId = selectedAnnotation.id;
        if ((0, $6mKj3.expVal)('confluence_fe_resolve_comment_optimistic', 'isEnabled', false)) {
            // No need to set mtnOptions.optimisticResponse since we'll close the
            // standalone comment immediately, as if it is already resolved.
            // Optimistically mark the annotation as resolved
            (0, $jJx00.resolveInlineCommentAnnotation)(annotationId, pageMode, eventEmitter);
            // Close the standalone comment immediately as if comment is resolved
            handleOnCloseUnified(false)();
        }
        resolveInlineCommentFn(mtnOptions).then(()=>{
            // this will be removed when the prop becomes optional
            onResolve(annotationId);
            (0, $8dA1U.handleResolveSuccess)({
                commentId: commentId,
                parentCommentMarkerRef: annotationId,
                pageId: contentId,
                pageMode: pageMode,
                eventEmitter: eventEmitter,
                source: (0, $en1dX.AnalyticsSource).STANDALONE,
                removeUnresolvedInlineComment: removeUnresolvedInlineComment,
                createAnalyticsEvent: createAnalyticsEvent,
                getInlineNodeTypes: getInlineNodeTypes,
                commentType: (0, $8i27m.CommentType).INLINE
            });
            if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) resolveParentComment({
                threadKey: annotationId,
                commentType: (0, $8i27m.CommentType).INLINE
            });
            setOrderedActiveAnnotationIdList(orderedActiveAnnotationIdList.map((status)=>status.threadKey).filter((id)=>id !== annotationId));
            experienceTracker.succeed({
                name: (0, $irVI7.RESOLVE_INLINE_COMMENT_EXPERIENCE)
            });
            if (!(0, $6mKj3.expVal)('confluence_fe_resolve_comment_optimistic', 'isEnabled', false)) // If optimistic resolve is enabled, standalone comment should have been closed already.
            handleOnCloseUnified(false)();
            if (allowComments) (0, $zkUcd.showResolvedCommentFlag)({
                commentId: commentId ?? '',
                experienceTracker: experienceTracker,
                flags: flags,
                mode: pageMode,
                annotationId: annotationId,
                formatMessage: formatMessage,
                showCommentsPanel: showCommentsPanel,
                setCurrentView: setCurrentView,
                isCommentsPanelShown: isCommentsPanelShown,
                handleReopenComment: (0, $zkUcd.createHandleReopenComment)({
                    reopenInlineCommentFn: reopenInlineCommentFn,
                    getUpdateFn: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? getReopenUpdateFn : undefined,
                    commentId: commentId ?? '',
                    annotationId: annotationId,
                    reopenParentComment: reopenParentComment,
                    setOrderedActiveAnnotationIdList: setOrderedActiveAnnotationIdList,
                    orderedActiveAnnotationIdList: orderedActiveAnnotationIdList,
                    highlightReopenedComment: highlightReopenedComment,
                    isEditor: isEditor ?? false,
                    eventEmitter: eventEmitter,
                    setActiveHighlight: setActiveHighlight,
                    experienceTracker: experienceTracker
                }),
                setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey
            });
            // Show the resolved comment window if not in editor
            if (!isEditor) {
                if (commentId) setResolvedComment({
                    commentId: commentId,
                    inlineMarkerRef: annotationId
                });
                // If the comment we just resolved is the same as the one we're currently viewing, set a timeout
                // to auto-close the container as it should be showing the resolved comment notification view
                if (resolvedComment?.commentId === commentData?.id) resolveWindowCloseTimeout.current = setTimeout(()=>{
                    onClose && onClose();
                }, 7500);
            }
        }).catch((err)=>{
            if ((0, $6mKj3.expVal)('confluence_fe_resolve_comment_optimistic', 'isEnabled', false)) {
                // Undo resolving the annotation when optimistic resolve is enabled
                (0, $jJx00.unresolveInlineCommentAnnotation)(annotationId, pageMode, eventEmitter);
                // Don't re-open the standalone comment box. Show an error flag instead.
                flags.showErrorFlag({
                    id: commentId,
                    title: formatMessage((0, $9CnRS.i18n).resolveErrorTitle),
                    description: formatMessage((0, $9CnRS.i18n).resolveError)
                });
            }
            handleResolveMutationFailure(err);
        });
    };
    const onCancelComment = ()=>{
        setReplyToCommentId();
        setShouldFocusNewReply(false);
    };
    const handlePublishFail = (0, $cozmU.useCallback)((error)=>{
        // Clear pending reply state on failure so useLayoutEffect doesn't
        // incorrectly trigger editor reset on a later unrelated data update
        pendingReplyRef.current = null;
        return (0, $8dA1U.handleMutationFailure)({
            experienceTracker: experienceTracker,
            experienceName: (0, $irVI7.REPLY_TO_INLINE_COMMENT_PUBLISH_EXPERIENCE),
            error: error,
            commentId: commentId,
            shouldReturnError: true,
            shouldAbortForExpectedError: true,
            compoundExperienceName: (0, $irVI7.REPLY_TO_INLINE_COMMENT_EXPERIENCE)
        });
    }, [
        experienceTracker,
        commentId
    ]);
    const handleCreateReplyUnified = async (adf, onSuccess)=>{
        const parentCommentId = commentId ?? '';
        // eslint-disable-next-line confluence-feature-gating/inline-usage
        const variables = {
            input: {
                containerId: contentId,
                parentCommentId: parentCommentId,
                commentBody: {
                    value: JSON.stringify(adf),
                    representationFormat: 'ATLAS_DOC_FORMAT'
                },
                createdFrom: isLivePage ? (0, $afGoD.CommentCreationLocation).LIVE : isEditor ? (0, $afGoD.CommentCreationLocation).EDITOR : (0, $afGoD.CommentCreationLocation).RENDERER
            },
            pageId: contentId,
            includeReactions: false
        };
        const queryVariables = {
            annotationId: selectedAnnotation?.id,
            pageId: contentId,
            contentStatus: [
                'DRAFT',
                'CURRENT'
            ]
        };
        (0, $8Ss4E.startEditorSubExperience)({
            name: (0, $irVI7.REPLY_TO_INLINE_COMMENT_PUBLISH_EXPERIENCE),
            attributes: {
                parentCommentId: parentCommentId
            }
        });
        // Wrap the createReplyFn mutation with the interop logic that handles both the direct Apollo
        // mutation path and the new hook-based for the Comments Data Manager
        const replyCreationInteropWrapper = (options)=>createInlineReplyInterop({
                originalMutationFn: createReplyFn,
                options: options,
                onCacheUpdateError: handlePublishFail
            });
        const hasAgentMentionInReply = (0, $emtVP.hasAgentMention)(adf) && (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true);
        const isOptimisticReplyEnabled = !hasAgentMentionInReply && (0, $aGjYc.shouldUseCommentDraftForOptimisticSave)(isEditor ? 'edit-inline' : 'inline', 'reply');
        if (isOptimisticReplyEnabled) // Optimistically close reply editor as if mutation succeeded immediately
        onSuccess?.();
        return replyCreationInteropWrapper({
            variables: variables,
            update: (0, $g0DaR.updateApolloCacheCallbackForGA)('create', queryVariables, parentCommentId),
            optimisticResponse: isOptimisticReplyEnabled ? (0, $cQCqE.getOptimisticResponse)({
                userId: currentUserId ?? '',
                displayName: displayName ?? '',
                adf: adf,
                pageId: contentId,
                parentCommentId: parentCommentId,
                parentCommentAnnotationId: selectedAnnotation.id
            }) : undefined
        }).then(({ data: replyData })=>{
            const replyInlineComment = replyData.replyInlineComment;
            if ((0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true)) {
                if (replyInlineComment?.id) (0, $emtVP.handleAgentMentionInComment)(adf, cloudId, contentId, replyInlineComment.id, currentUserId ?? undefined);
            }
            if (!replyInlineComment?.reactionsSummary) replyInlineComment.reactionsSummary = (0, $g0DaR.defaultReactionsSummary);
            const reply = {
                ...replyInlineComment
            };
            // Update storedCommentData if it exists by adding the new reply
            if (storedCommentData && setStoredCommentData) {
                const updatedCommentData = {
                    ...storedCommentData,
                    replies: [
                        ...storedCommentData.replies || [],
                        replyInlineComment
                    ]
                };
                setStoredCommentData(updatedCommentData);
            }
            if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) addReplyToCommentThread(selectedAnnotation.id, reply, (0, $8i27m.CommentType).INLINE);
            // reset the replyToCommentUser if any
            replyToCommentUser && setReplyToCommentId();
            if (!isOptimisticReplyEnabled && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) pendingReplyRef.current = {
                expectedReplyId: replyInlineComment.id,
                hasAgentMention: hasAgentMentionInReply,
                onReplyProcessed: onSuccess
            };
            // The reply saved — collapse the agent-mention FYI nudge. The editor content clears on
            // save without emitting a content-change, so reset the nudge explicitly (otherwise the
            // "…will respond in Chat" banner lingers above the reply box after send).
            onAgentMentionContentChange(undefined);
            (0, $g0DaR.handleCreateReplySuccess)({
                // When new data manager is on, defer onSuccess (resetEditor) to useLayoutEffect
                // so editor collapses in the same paint as the new reply appearing
                onSuccess: (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? undefined : onSuccess,
                editCommentQueryId: editCommentQueryId,
                setCommentForEdit: setCommentForEdit,
                data: data,
                createAnalyticsEvent: createAnalyticsEvent,
                pageId: contentId,
                pageType: pageType,
                analyticsSource: (0, $en1dX.AnalyticsSource).STANDALONE,
                commentId: commentId,
                pageMode: pageMode,
                selectedAnnotation: selectedAnnotation,
                getInlineNodeTypes: undefined,
                experienceTracker: experienceTracker,
                isEditor: !!isEditor
            });
        }).catch((error)=>{
            return handlePublishFail(error);
        });
    };
    const updateReactionsCacheFn = (0, $cozmU.useCallback)((emojiId, actionType, objectId, _containerId, result, onCacheUpdateError)=>{
        // Update the GQL cache when using the new Comments Data Manager
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
            // Mutation result should exist, but this check is to satisfy TypeScript
            if (result) return updateReactionInCache({
                mutationResult: result,
                commentId: objectId,
                pageId: contentId,
                contentType: 'page',
                actionType: actionType,
                emojiId: emojiId,
                onError: onCacheUpdateError
            });
        } else // Call the GA function
        (0, $g0DaR.updateReactionsCacheCallbackForGA)(emojiId, actionType, objectId, contentId, selectedAnnotation, isArchived ?? false);
        // Also update storedCommentData if it exists
        if (storedCommentData && setStoredCommentData) {
            const updatedCommentData = {
                ...storedCommentData
            };
            // Find if this is the main comment or a reply
            if (storedCommentData.id === objectId) {
                // Update main comment reactions
                const currentReactions = storedCommentData.reactionsSummary?.reactionsSummaryForEmoji || [];
                const updatedReactions = [
                    ...currentReactions
                ];
                let reactionsCount = storedCommentData.reactionsSummary?.reactionsCount || 0;
                if (actionType === 'add') {
                    const existingReaction = updatedReactions.find((r)=>r?.emojiId === emojiId);
                    if (existingReaction && !existingReaction.reacted) {
                        existingReaction.count++;
                        existingReaction.reacted = true;
                    } else if (!existingReaction) updatedReactions.push({
                        emojiId: emojiId,
                        count: 1,
                        reacted: true,
                        id: `${storedCommentData.reactionsSummary?.containerAri}|${storedCommentData.reactionsSummary?.ari}|${emojiId}`,
                        __typename: 'ReactionsSummaryForEmoji'
                    });
                    reactionsCount++;
                } else if (actionType === 'delete') {
                    const reactionIdx = updatedReactions.findIndex((r)=>r?.emojiId === emojiId);
                    if (reactionIdx !== -1) {
                        const reaction = updatedReactions[reactionIdx];
                        if (reaction && reaction.count > 1) {
                            reaction.count--;
                            reaction.reacted = false;
                        } else updatedReactions.splice(reactionIdx, 1);
                        reactionsCount--;
                    }
                }
                updatedCommentData.reactionsSummary = {
                    ...storedCommentData.reactionsSummary,
                    reactionsSummaryForEmoji: updatedReactions,
                    reactionsCount: reactionsCount,
                    ari: storedCommentData.reactionsSummary?.ari || ''
                };
            } else // Update reply reactions
            updatedCommentData.replies = (storedCommentData.replies || []).map((reply)=>{
                if (reply?.id === objectId) {
                    const currentReactions = reply.reactionsSummary?.reactionsSummaryForEmoji || [];
                    const updatedReactions = [
                        ...currentReactions
                    ];
                    let reactionsCount = reply.reactionsSummary?.reactionsCount || 0;
                    if (actionType === 'add') {
                        const existingReaction = updatedReactions.find((r)=>r?.emojiId === emojiId);
                        if (existingReaction && !existingReaction.reacted) {
                            existingReaction.count++;
                            existingReaction.reacted = true;
                        } else if (!existingReaction) updatedReactions.push({
                            emojiId: emojiId,
                            count: 1,
                            reacted: true,
                            id: `${reply.reactionsSummary?.containerAri}|${reply.reactionsSummary?.ari}|${emojiId}`,
                            __typename: 'ReactionsSummaryForEmoji'
                        });
                        reactionsCount++;
                    } else if (actionType === 'delete') {
                        const reactionIdx = updatedReactions.findIndex((r)=>r?.emojiId === emojiId);
                        if (reactionIdx !== -1) {
                            const reaction = updatedReactions[reactionIdx];
                            if (reaction && reaction.count > 1) {
                                reaction.count--;
                                reaction.reacted = false;
                            } else updatedReactions.splice(reactionIdx, 1);
                            reactionsCount--;
                        }
                    }
                    return {
                        ...reply,
                        reactionsSummary: {
                            ...reply.reactionsSummary,
                            reactionsSummaryForEmoji: updatedReactions,
                            reactionsCount: reactionsCount,
                            ari: reply.reactionsSummary?.ari || ''
                        }
                    };
                }
                return reply;
            });
            setStoredCommentData(updatedCommentData);
        }
    }, [
        contentId,
        selectedAnnotation,
        isArchived,
        storedCommentData,
        setStoredCommentData,
        updateReactionInCache
    ]);
    const highlightReopenedComment = (0, $cozmU.useCallback)((annotationId)=>{
        // Emit the event to re-highlight the mark
        if ((0, $6mKj3.expVal)('confluence_fe_resolve_reopen_comment_refactor', 'isEnabled', false)) (0, $jJx00.unresolveInlineCommentAnnotation)(annotationId, pageMode, eventEmitter);
        else eventEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_STATE, {
            [annotationId]: {
                id: annotationId,
                annotationType: (0, $epbW8.AnnotationTypes).INLINE_COMMENT,
                state: (0, $epbW8.AnnotationMarkStates).ACTIVE
            }
        });
        addUnresolvedInlineComment(annotationId, pageMode);
    }, [
        addUnresolvedInlineComment,
        eventEmitter,
        pageMode
    ]);
    const navigationOptions = (0, $cozmU.useMemo)(()=>({
            commentData: commentData,
            onNavigationClick: onNavigationClick
        }), [
        commentData,
        onNavigationClick
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!selectedAnnotation.id) return;
        if (shouldRender === false) {
            // The UI has not started rendering yet, so we don't want to check if it's visible.
            (0, $4EKKB.selectInlineComment).debug(`InlineComment has been rendered, but is returning null due to shouldRender. Selected annotation ID: ${selectedAnnotation?.id}`);
            return;
        }
        const initialTaskId = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE))?.taskId;
        // Add a guard for rapid changes
        let isCancelled = false;
        const timeoutId = setTimeout(()=>{
            // There are multiple apis and effects involved in swapping from the create comment
            // ui to the view comment ui.
            // This works around this by only marking the experience as complete after
            // a short timeout + animation frame.
            if (isCancelled) return;
            requestAnimationFrame(()=>{
                if (isCancelled) return;
                const currentTaskId = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE))?.taskId;
                if (!currentTaskId) {
                    // Note -- this should not do anything (as debug points are only added to active experiences)
                    (0, $4EKKB.selectInlineComment).debug('No current task ID');
                    return;
                }
                if (initialTaskId !== currentTaskId) {
                    // The experience has been restarted or has otherwise ended.
                    experienceTracker.attachDebugPoint({
                        name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                        message: `Experience has been restarted or has otherwise ended. initialTaskId: ${initialTaskId}, currentTaskId: ${currentTaskId}`
                    });
                    return;
                }
                if (lastSelected.current !== selectedAnnotation.id) {
                    // The selected annotation has changed, this should have led to an earlier abort
                    // (as an overlapping experience is started)
                    (0, $4EKKB.selectInlineComment).debug(`View inline comment assumed aborted due to selection change. lastSelected.current: ${lastSelected?.current}, selectedAnnotation.id: ${selectedAnnotation?.id}`);
                    return;
                }
                if (!annotationElementRef.current) {
                    // We'd expect the select annotation experience to fail
                    // if no annotation is added to the document
                    // Assume this experience has aborted (or it will timeout)
                    (0, $4EKKB.selectInlineComment).debug('Show inline comment assumed aborted by deselection or selection change. This message indicate an abort failed and something has gone wrong.');
                    (0, $4EKKB.selectInlineCommentCompoundExperience).abort({
                        abortReason: 'No annotation element found for the inline comment ui to attach to.'
                    });
                    experienceTracker.abort({
                        name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                        reason: 'No annotation element found for the inline comment component to attach to.',
                        checkForTimeout: true,
                        publishDebugPoints: true,
                        attributes: {
                            stopPoint: $f4f7ab8b4171ff8f$var$relativeFilePath
                        }
                    });
                    flags.showWarningFlag({
                        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f4f7ab8b4171ff8f$var$i18n.commentLoadErrorTitle),
                        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f4f7ab8b4171ff8f$var$i18n.commentLoadError)
                    });
                    return;
                }
                if (!sidebarEl.current) {
                    (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.fail(new Error('Document missing inline comment ui'));
                    if (shouldRender) experienceTracker.fail({
                        name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                        error: new Error('Document is missing inline comment sidebar element'),
                        attributes: {
                            stopPoint: $f4f7ab8b4171ff8f$var$relativeFilePath
                        }
                    });
                    return;
                }
                const commentUIVerticalDistanceFromAnnotation = Math.abs(annotationElementRef.current.getBoundingClientRect().top - sidebarEl.current.getBoundingClientRect?.().top);
                // The 40 pixel allowance has been arbitrarily chosen to allow for some wiggle room
                if (commentUIVerticalDistanceFromAnnotation > 40) {
                    const isVisible = sidebarEl.current.checkVisibility();
                    if (isVisible) // if it's fully visible, but misaligned, we don't treat this as a failure
                    (0, $4EKKB.selectInlineComment).debug('View Inline Comment UI too far from annotation', {
                        misalignedBy: commentUIVerticalDistanceFromAnnotation
                    });
                    else {
                        (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.fail(new Error('View Created Comment UI too far from annotation'), {
                            misalignedBy: commentUIVerticalDistanceFromAnnotation
                        });
                        experienceTracker.fail({
                            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                            error: new Error('View inline comment sidebar was rendered too far from annotation'),
                            attributes: {
                                misalignedBy: commentUIVerticalDistanceFromAnnotation,
                                stopPoint: $f4f7ab8b4171ff8f$var$relativeFilePath
                            }
                        });
                        return;
                    }
                }
                experienceTracker.succeed({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    publishDebugPoints: true,
                    attributes: {
                        stopPoint: $f4f7ab8b4171ff8f$var$relativeFilePath
                    }
                });
                (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.complete('Inline Comment panel comment shown');
            });
        }, 10);
        return ()=>{
            isCancelled = true;
            clearTimeout(timeoutId);
            setShouldRender(false);
            const currentTaskId = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE))?.taskId;
            if (!currentTaskId) // There is no running experience, no need to abort.
            return;
            if (initialTaskId !== currentTaskId) // The experience has been restarted or has otherwise ended.
            return;
            // If a show inline comment experience is still running while this component is in the process of being
            // unmounted, we abort it rather than fail it.
            (0, $4EKKB.selectInlineCommentCompoundExperience).showComment.abort({
                abortReason: 'InlineComment component unmounted'
            });
            experienceTracker.abort({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                reason: 'Inline comment component unmounted',
                checkForTimeout: true,
                publishDebugPoints: true,
                attributes: {
                    stopPoint: $f4f7ab8b4171ff8f$var$relativeFilePath
                }
            });
        };
    }, [
        selectedAnnotation.id,
        shouldRender,
        createAnalyticsEvent,
        experienceTracker,
        flags
    ]);
    const [isStandalonehovered, setisStandalonehovered] = (0, $cozmU.useState)(false);
    const [hoveredCommentId, setHoveredCommentId] = (0, $cozmU.useState)(undefined);
    const [commentIsFocused, setCommentIsFocused] = (0, $cozmU.useState)(false);
    const handleMouseEnter = (0, $cozmU.useCallback)((id)=>{
        setisStandalonehovered(true);
        if (id) setHoveredCommentId(id);
    }, []);
    const handleMouseLeave = (0, $cozmU.useCallback)(()=>{
        setisStandalonehovered(false);
        setHoveredCommentId(undefined);
    }, []);
    const handleFocus = (0, $cozmU.useCallback)((event)=>{
        setCommentIsFocused(true);
        event.stopPropagation();
    }, [
        setCommentIsFocused
    ]);
    const handleBlur = (0, $cozmU.useCallback)((event)=>{
        if (!event.relatedTarget || !event.currentTarget.contains(event.relatedTarget)) setCommentIsFocused(false);
    }, [
        setCommentIsFocused
    ]);
    if (!shouldRender) return null;
    const renderComment = ()=>{
        if (commentId === editCommentId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $auGhu.EditComment), {
            pageId: contentId,
            date: when ?? '',
            createdAtNonLocalized: createdAtNonLocalized ?? '',
            pageType: pageType,
            annotationId: selectedAnnotation.id,
            commentId: commentId,
            spaceId: spaceId,
            content: content ?? '',
            isReply: false,
            displayCommentInViewMode: toggleCommentMode,
            avatarUrl: topCommentUserAvatar ?? '',
            displayName: topCommentDisplayName,
            dateUrl: commentUrl ?? '',
            versionDate: when ?? '',
            isEdited: isEdited,
            resolveProperties: resolveProperties,
            mode: isEditor ? 'edit' : 'view',
            hasMediaUploadPermissions: hasMediaUploadPermissions,
            getInlineNodeTypes: getInlineNodeTypes,
            commentType: (0, $8i27m.CommentType).INLINE,
            isStandaloneComment: true,
            hasParentMaxHeight: hasParentMaxHeight,
            numReplies: numReplies
        });
        else {
            const getDeleteFn = ()=>{
                if (!isLivePage && isEditor) return undefined;
                return handleDeleteComment(undefined);
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kEmgx.CommentBody), {
                userId: topCommentUserId,
                avatarUrl: topCommentUserAvatar,
                displayName: topCommentDisplayName,
                date: when ?? '',
                dateUrl: commentUrl ?? '',
                createdAt: createdAt ?? '',
                createdAtNonLocalized: createdAtNonLocalized ?? '',
                versionDate: when ?? '',
                versionByDisplayName: versionByDisplayName,
                pageId: contentId,
                pageType: pageType,
                commentId: commentId ?? '',
                isReply: false,
                isEdited: isEdited,
                permissions: permissions,
                deleteComment: getDeleteFn,
                editComment: ()=>toggleCommentMode(commentId),
                content: content ?? '',
                isCommentActive: true,
                mode: isEditor ? 'edit' : 'view',
                permissionType: permissionType ?? undefined,
                resolveComment: handleResolveComment,
                supportedActions: supportedTopLevelActions,
                isUnread: unreadCommentIDSet.has(commentId ?? ''),
                numReplies: numReplies,
                commentType: (0, $8i27m.CommentType).INLINE,
                inheritedReactionsData: reactionsSummary,
                reactionsCacheUpdateFn: updateReactionsCacheFn,
                isStandalonehovered: isStandalonehovered,
                contributors: contributors,
                isHovered: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? false : hoveredCommentId === commentId || commentIsFocused,
                replyToComment: handleReplyToComment,
                hideBranchingStyle: !parentHasAgentSession && (!commentData?.replies || commentData?.replies?.length === 0),
                resolveProperties: resolveProperties,
                isStandaloneComment: true,
                canAddComments: canAddComments,
                isOffline: isOffline,
                isFabricPage: true,
                annotationId: selectedAnnotation?.id,
                annotatedText: annotationElementRef.current?.textContent ?? undefined,
                onRendered: ()=>{
                    experienceTracker.attachDebugPoint({
                        name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                        message: 'Inline comment body rendered'
                    });
                }
            }), (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gP7oS.CommentAgentSessionButtonAsync), {
                commentId: commentId ?? '',
                isCommentsPanel: false,
                isFooterComment: false,
                userId: topCommentUserId,
                avatarUrl: topCommentUserAvatar,
                indent: true
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
                key: `stop-${commentId}`,
                metric: RENDER_METRIC
            }));
        }
    };
    annotationElementRef.current = selectedAnnotationElement;
    // Handle case where comment has been deleted
    if (!annotationElementRef.current) {
        (0, $4EKKB.selectInlineComment).debug('There is no annotation element element, so not rendering InlineComment');
        return null;
    }
    const isCommentAuthor = topCommentUserId === currentUserId;
    const isFirstComment = commentThreadLength === 1;
    const sidebar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $B3Avz.CommentSidebar), {
        nudgeRef: nudgeRef,
        pageId: contentId,
        annotationElement: annotationElementRef.current,
        navigationOptions: navigationOptions,
        onClose: handleOnCloseUnified(true),
        isEditor: isEditor,
        isViewCommentMode: true,
        sidebarOffset: sidebarOffset,
        commentId: commentId,
        isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
        sidebarEl: sidebarEl,
        annotationId: selectedAnnotation?.id,
        inlineCommentRef: inlineCommentRef,
        setPopupsScrollableElement: setPopupsScrollableElement,
        isSticky: isSticky,
        isFabricPage: true,
        authorName: topCommentDisplayName,
        onMaxHeightApplied: setHasParentMaxHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
        testId: "inline-comment-container",
        onMouseEnter: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? undefined : ()=>handleMouseEnter(commentId),
        onMouseLeave: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? undefined : handleMouseLeave,
        onBlur: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? undefined : handleBlur,
        onFocus: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? undefined : handleFocus,
        tabIndex: 0,
        "aria-label": formatMessage($f4f7ab8b4171ff8f$var$i18n.commentAriaLabel, {
            displayName: topCommentDisplayName,
            timestamp: (0, $6faGq.formatTimestampForAriaLabel)({
                intl: intl,
                dateString: commentData?.createdAtNonLocalized,
                commentStatus: commentStatus,
                resolveProperties: commentData?.location?.inlineResolveProperties || commentData?.location?.commentResolveProperties
            })
        })
    }, renderComment()), commentData?.replies?.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4Svbr.CommentReplies), {
        flags: isOptimisticDeleteEnabled ? flags : undefined,
        parentComment: (0, $3ZsvI.normalizeCommentData)({
            comment: commentData,
            currentUserId: currentUserId ?? '',
            isOpen: true,
            type: (0, $8i27m.CommentType).INLINE
        }),
        pageInfo: pageInfo,
        pageMode: pageMode,
        parentCommentId: commentData.id,
        handleMouseEnter: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? $f4f7ab8b4171ff8f$var$noop : handleMouseEnter,
        handleMouseLeave: (0, $6mKj3.expValEquals)('confluence_frontend_fix_comment_actions_visibility', 'isEnabled', true) ? $f4f7ab8b4171ff8f$var$noop : handleMouseLeave,
        canAddComments: canAddComments,
        hoveredCommentId: hoveredCommentId ?? '',
        isStandaloneComment: true,
        editCommentQueryId: editCommentQueryId,
        selectedAnnotation: selectedAnnotation,
        key: `standalone-comment-replies-${commentData.id}`,
        deleteStandaloneComment: handleDeleteComment,
        replyToComment: handleReplyToComment,
        updateReactionsCacheFn: updateReactionsCacheFn,
        ...popupsScrollableElement && popupsMountPoint ? {
            popupsScrollableElement: popupsScrollableElement,
            popupsMountPoint: popupsMountPoint
        } : {},
        hasParentMaxHeight: hasParentMaxHeight
    }), !isArchived && canAddComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.NewReplyContainer), {
        mode: isEditor ? 'edit' : 'view',
        "data-cy": "editor-reply-container",
        "data-testid": "inline-comment-new-reply-container",
        ref: commentContainerElementRef,
        isFabricPage: true,
        isStandaloneComment: true
    }, (showFyi || hasShownFyiRef.current) && (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4rKYp.AgentMentionFyiNudgeAsync), {
        visible: showFyi,
        agent: agent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hXzKU.LazyCommentEditor), {
        pageId: contentId,
        pageType: pageType,
        onCancelComment: onCancelComment,
        content: (0, $7qvmT.getReplyEditorContent)({
            replyToCommentUser: replyToCommentUser,
            replyToContributorUsers: replyToContributorUsers
        }),
        appearance: "chromeless",
        EditorComponent: (0, $koEBx.ChromelessEditor),
        onSaveComment: handleCreateReplyUnified,
        onContentChange: onChange,
        onContentChangeWithData: handleContentChangeWithData,
        onEditorReady: ()=>{
            experienceTracker.succeed({
                name: (0, $irVI7.REPLY_TO_INLINE_COMMENT_LOAD_EXPERIENCE)
            });
        },
        commentMode: "reply",
        commentType: isEditor ? 'edit-inline' : 'inline',
        spaceId: spaceId,
        showCancelButton: true,
        useNewWarningModal: true,
        hideWatchCheckbox: true,
        expandEditor: shouldFocusNewReply,
        pageMode: isEditor ? 'edit' : 'view',
        hasMediaUploadPermissions: hasMediaUploadPermissions,
        topLevelCommentId: commentId,
        shouldWarnOnInternalNavigation: true,
        commentContainerElementRef: commentContainerElementRef,
        isStandaloneComment: true,
        hasParentMaxHeight: hasParentMaxHeight,
        // Needed to remount this component when we change which comment we're viewing
        // Use `selectedAnnotation.id` as key instead of `commentId`, so that
        // when optimistic create is enabled, CommentEditor is not entirely
        // remounted after GQL mutation succeeds.
        key: `standalone-comment-new-reply-editor-${selectedAnnotation.id}`,
        ...popupsScrollableElement && popupsMountPoint ? {
            popupsScrollableElement: popupsScrollableElement,
            popupsMountPoint: popupsMountPoint
        } : {},
        isOffline: isOffline,
        customAriaLabel: formatMessage($f4f7ab8b4171ff8f$var$i18n.commentReplyAriaLabel, {
            name: topCommentDisplayName
        })
    }))), isCommentAuthor && isFirstComment && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g1WP0.AsyncWrapper), {
        trigger: "inline-comments",
        showImage: false,
        width: 280,
        reference: nudgeRef
    }));
    // Mount the (non-blocking) AgentSessionsProvider per-surface — a separate refetch
    // from the footer surface — so each comment in this inline-comment popup can look up
    // its own agent session by commentId via AgentSessionsContext. The provider renders
    // the popup immediately and loads the (usually Relay-cache-warm) sessions in a
    // Suspense sibling, so the popup never blanks. The page marker is not threaded to
    // this surface, so we gate on the experiment + contentId. Gate inlined per
    // confluence-feature-gating rules.
    if (contentId && (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aNRAP.AgentSessionsProvider), {
        pageId: contentId,
        onSessionMapChange: setAgentSessionMap
    }, sidebar);
    return sidebar;
};
const $f4f7ab8b4171ff8f$export$183403b138e102b9 = (0, $7aRa9.withFlags)($f4f7ab8b4171ff8f$var$InlineCommentComponent);
module.exports["InlineComment"] = $f4f7ab8b4171ff8f$export$183403b138e102b9;

});

parcelRegister("k67hX", function(module, exports) {
/**
 * @generated SignedSource<<1dd6675f58daad630e4a89f1fde066d9>>
 * @relayHash ae101ad519f93d6ee8fda249fac0cfef
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5cac25020450d3912c27c74329542bdb8cf44d4e350087e75a57b3b82ebcf566
const $49c2b8adabe9e295$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeReactions"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v6 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v5 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v7 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v8 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v5 /*: any*/ 
    }, v9 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v10 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "type"
    }, v12 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v13 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v14 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineMarkerRef"
            },
            {
                "kind": "ScalarField",
                "name": "inlineText"
            },
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "inlineResolveProperties",
                "plural": false,
                "selections": [
                    v12 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isDangling"
                    },
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ 
                ]
            }
        ],
        "type": "InlineComment"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "InlineCommentResolveProperties",
                "kind": "LinkedField",
                "name": "commentResolveProperties",
                "plural": false,
                "selections": [
                    v12 /*: any*/ ,
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ 
                ]
            }
        ],
        "type": "FooterComment"
    }, v18 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v19 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v20 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v21 = {
        "kind": "ScalarField",
        "name": "when"
    }, v22 = {
        "kind": "ScalarField",
        "name": "number"
    }, v23 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v24 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v26 = {
        "condition": "includeReactions",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "childType",
                        "value": "comment"
                    },
                    {
                        "kind": "Literal",
                        "name": "contentType",
                        "value": "page"
                    },
                    {
                        "kind": "Variable",
                        "name": "pageId",
                        "variableName": "pageId"
                    }
                ],
                "concreteType": "ReactionsSummaryResponse",
                "kind": "LinkedField",
                "name": "reactionsSummary",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "ari"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "containerAri"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reactionsCount"
                    },
                    {
                        "concreteType": "ReactionsSummaryForEmoji",
                        "kind": "LinkedField",
                        "name": "reactionsSummaryForEmoji",
                        "plural": true,
                        "selections": [
                            v4 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "emojiId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "count"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "reacted"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "InlineCommentCreateInlineReplyMutation",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "replyInlineComment",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "location",
                            "plural": false,
                            "selections": [
                                v11 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ 
                            ]
                        },
                        v18 /*: any*/ ,
                        v19 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v20 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ 
                            ]
                        },
                        v26 /*: any*/ 
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "InlineCommentCreateInlineReplyMutation",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "replyInlineComment",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "location",
                            "plural": false,
                            "selections": [
                                v27 /*: any*/ ,
                                v11 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ 
                            ]
                        },
                        v18 /*: any*/ ,
                        v19 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v27 /*: any*/ ,
                                        v20 /*: any*/ 
                                    ]
                                },
                                v21 /*: any*/ ,
                                v22 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v27 /*: any*/ ,
                                v20 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ 
                            ]
                        },
                        v26 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "ae101ad519f93d6ee8fda249fac0cfef",
            "id": "5cac25020450d3912c27c74329542bdb8cf44d4e350087e75a57b3b82ebcf566",
            "metadata": {},
            "name": "InlineCommentCreateInlineReplyMutation",
            "operationKind": "mutation",
            "text": "mutation InlineCommentCreateInlineReplyMutation($input:ReplyInlineCommentInput!,$pageId:ID!,$includeReactions:Boolean!){replyInlineComment(input:$input){id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeReactions){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}}"
        }
    };
}();
$49c2b8adabe9e295$var$node.hash = "1a07d4cb81840d6ebad5fbdcb4c879da";
var $49c2b8adabe9e295$export$2e2bcd8739ae039 = $49c2b8adabe9e295$var$node;
module.exports["default"] = $49c2b8adabe9e295$export$2e2bcd8739ae039;

});

parcelRegister("biHX4", function(module, exports) {
/**
 * @generated SignedSource<<610fd2e278ee9b6cfd155ef99312d254>>
 * @relayHash c880fb921a6c530f9fd537747b4c7b37
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 444d95b8e718c7484bdbd3853e9b2ae656409de43e3846e73ab5b95f60ecf744
const $68fb440cb1827891$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "kind": "ScalarField",
            "name": "deleteInlineComment"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "InlineCommentDeleteInlineCommentMutationWithStepMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "InlineCommentDeleteInlineCommentMutationWithStepMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c880fb921a6c530f9fd537747b4c7b37",
            "id": "444d95b8e718c7484bdbd3853e9b2ae656409de43e3846e73ab5b95f60ecf744",
            "metadata": {},
            "name": "InlineCommentDeleteInlineCommentMutationWithStepMutation",
            "operationKind": "mutation",
            "text": "mutation InlineCommentDeleteInlineCommentMutationWithStepMutation($input:DeleteInlineCommentInput!){deleteInlineComment(input:$input)}"
        }
    };
}();
$68fb440cb1827891$var$node.hash = "1aa5c41482c932025b3af698bbf1eaf9";
var $68fb440cb1827891$export$2e2bcd8739ae039 = $68fb440cb1827891$var$node;
module.exports["default"] = $68fb440cb1827891$export$2e2bcd8739ae039;

});

parcelRegister("gP7oS", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $1f0b570539d849bb$export$dc9b51ad46d16392 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "1zTcD",
    name: "CommentAgentSessionButtonAsync",
    loader: async ()=>(await (parcelRequire("1Vv7X"))).CommentAgentSessionButton
});
module.exports["CommentAgentSessionButtonAsync"] = $1f0b570539d849bb$export$dc9b51ad46d16392;

});

parcelRegister("1Vv7X", function(module, exports) {

let $1673428c984d5f67$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1673428c984d5f67$var$load("6wr18"),
    $1673428c984d5f67$var$load("7WH29"),
    $1673428c984d5f67$var$load("ffEVr"),
    $1673428c984d5f67$var$load("6dN2O")
]).then(()=>parcelRequire('eHTYZ'));

});

parcelRegister("jHeAZ", function(module, exports) {

let $e56d5ad8fd697332$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e56d5ad8fd697332$var$load("dzUzj"),
    $e56d5ad8fd697332$var$load("ipIDQ"),
    $e56d5ad8fd697332$var$load("dpC8y"),
    $e56d5ad8fd697332$var$load("kPE95")
]).then(()=>parcelRequire('g6LfA'));

});

parcelRegister("4gEXU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cZa7r = parcelRequire("cZa7r");


var $8aF6s = parcelRequire("8aF6s");


var $cMvMc = parcelRequire("cMvMc");


var $bSvtO = parcelRequire("bSvtO");

function $4ccc472e1abe9fa4$export$b3246a2f66464d01({ onConfirm: onConfirm }) {
    const annotationManager = (0, $cZa7r.useAnnotationManager)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    // This hook enables the new preemptive gate for the editor comment API manager to catch the situation
    // where the user tries to start a draft while there is unsaved content in the editor.
    (0, $cozmU.useEffect)(()=>{
        if (annotationManager) {
            if (hasContentChanged) annotationManager.setPreemptiveGate(()=>{
                return new Promise((resolve)=>{
                    showModal((0, $cMvMc.CommentWarningDialog), {
                        onConfirm: ()=>{
                            resetContentChanged();
                            onConfirm();
                            // Allow the draft to be started or the comment viewed.
                            resolve(true);
                        },
                        onCancel: ()=>{
                            // Cancel the start draft or view attempt.
                            resolve(false);
                        },
                        onClose: ()=>{
                            // Just in case the user closes the modal by some other means we need to ensure the
                            // promise is resolved. We do not want to leave the preemptive gate open.
                            resolve(false);
                        }
                    });
                });
            });
            else annotationManager?.setPreemptiveGate(()=>Promise.resolve(true));
            return ()=>{
                annotationManager?.setPreemptiveGate(()=>Promise.resolve(true));
            };
        }
    }, [
        hasContentChanged,
        annotationManager,
        showModal,
        resetContentChanged,
        onConfirm
    ]);
}
module.exports["usePreemptiveGate"] = $4ccc472e1abe9fa4$export$b3246a2f66464d01;

});

parcelRegister("ayQVU", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

// editor property is expected to be:
//   1. ""    -> auto conversion will happen
//   2. "v2"  -> explicitly using fabric editor
//   3. "v1"  -> explicitly using tinyMCE editor
// when parsing editor property, if neither of the above data is received,
// then it's an unexpected case and we set it as "unset" for analytics.
function $0e83f72969672585$var$parseEditorProperty(value) {
    if (!value) return '';
    if (value?.includes('v2')) return 'v2';
    if (value?.includes('v1')) return 'v1';
    return 'unset';
}
function $0e83f72969672585$export$a53517c120ec9f4(content) {
    const contentProperties = content?.properties?.nodes;
    const editorInfo = contentProperties?.filter((p)=>p?.key === 'editor');
    const editorPropertieValueRaw = editorInfo?.[0]?.value;
    const editorProperty = $0e83f72969672585$var$parseEditorProperty(editorPropertieValueRaw);
    if (content && 'metadata' in content && content?.metadata?.frontend && 'fabricEditorSupported' in content.metadata.frontend) return {
        queryDataId: content?.id,
        editorProperty: editorProperty,
        fabricEditorSupported: content?.metadata?.frontend?.fabricEditorSupported,
        isAutoConverted: (0, $9wGTI.fg)('confluence_editor_auto-convert_changes') ? !!content?.metadata?.frontend?.fabricEditorSupported && // For pages migrated from DC, with editor property not set, it's easy,
        // they'll always be auto-converted. We explicitly set the editor property
        // to v1 when reverting back to TinyMCE.
        (editorProperty === '' || // For pages created in cloud, with editor property set to v1, we only want to show
        // the auto-conversion settings when it is initially converted to fabric editor.
        // This means the editor property is still set to TinyMCE (v1) but the page is Fabric Editor.
        editorProperty === 'v1' && content?.body?.dynamic?.representation === 'atlas_doc_format') : undefined
    };
    return {
        queryDataId: content?.id,
        editorProperty: editorProperty,
        fabricEditorSupported: null,
        isAutoConverted: (0, $9wGTI.fg)('confluence_editor_auto-convert_changes') ? false : undefined
    };
}
module.exports["getAutoConvertionInfo"] = $0e83f72969672585$export$a53517c120ec9f4;

});

parcelRegister("1ITQ3", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $3u5lg = parcelRequire("3u5lg");


var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $7Ndnw = parcelRequire("7Ndnw");


var $3b6WO = parcelRequire("3b6WO");

const $336551b5acc450de$var$DEFAULT_EXTENSION_VIEWPORT_SIZES = [];
const $336551b5acc450de$export$e863f5b50b03c8cc = (skipQuery = false)=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const VIEWPORT_SIZE_KEY = `${(0, $7Ndnw.FORGE_MODULE_XEN_MACRO)}:viewportSizes:${contentId}`;
    const filteredExtensions = window.__SSR_FORGE_EXTENSIONS__?.[VIEWPORT_SIZE_KEY]?.extensions ?? $336551b5acc450de$var$DEFAULT_EXTENSION_VIEWPORT_SIZES;
    // Technically here cached value can have length of 0.
    // In this case, we don't want to skip the query as we have no way to tell whether its from cache or just default value.
    const hasCachedValue = filteredExtensions.length > 0;
    const { extensions: extensions, loading: loading, error: error } = (0, $3b6WO.useExtensionList)({
        moduleType: (0, $7Ndnw.FORGE_MODULE_XEN_MACRO),
        skipQuery: skipQuery || hasCachedValue
    });
    const prevExtensionViewportSizes = (0, $cozmU.useRef)(filteredExtensions);
    if (loading || error || !extensions) return filteredExtensions;
    const nextExtensionViewportSizes = extensions.map(({ id: id, properties: properties })=>properties?.viewportSize ? {
            extensionId: id,
            viewportSize: properties.viewportSize
        } : undefined).filter(Boolean);
    if (prevExtensionViewportSizes.current.length !== nextExtensionViewportSizes.length || !(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(prevExtensionViewportSizes.current, nextExtensionViewportSizes)) {
        prevExtensionViewportSizes.current = nextExtensionViewportSizes;
        // Write to window object to cache the viewport sizes.
        if (window.__SSR_FORGE_EXTENSIONS__) window.__SSR_FORGE_EXTENSIONS__ = {
            ...window.__SSR_FORGE_EXTENSIONS__,
            [VIEWPORT_SIZE_KEY]: {
                extensions: nextExtensionViewportSizes
            }
        };
    }
    return prevExtensionViewportSizes.current;
};
module.exports["useExtensionViewportSizes"] = $336551b5acc450de$export$e863f5b50b03c8cc;

});

parcelRegister("3BPrE", function(module, exports) {
var $e3661bd3089bf51c$export$7309710dd8a888d9 = /*#__PURE__*/ function(InlineCommentPubSubEvents) {
    InlineCommentPubSubEvents["InlineCommentCreated"] = "avi:confluence:created:inline_comment";
    InlineCommentPubSubEvents["RendererInlineCommentCreated"] = "avi:confluence:created:renderer_inline_comment";
    InlineCommentPubSubEvents["EditorInlineCommentCreated"] = "avi:confluence:created:editor_inline_comment";
    InlineCommentPubSubEvents["InlineCommentDeleted"] = "avi:confluence:deleted:inline_comment";
    InlineCommentPubSubEvents["InlineCommentResolved"] = "avi:confluence:resolved:inline_comment";
    InlineCommentPubSubEvents["InlineCommentUnresolved"] = "avi:confluence:unresolved:inline_comment";
    InlineCommentPubSubEvents["InlineCommentUpdated"] = "avi:confluence:updated:inline_comment";
    InlineCommentPubSubEvents["InlineCommentReattached"] = "avi:confluence:reattach:inline_comment";
    return InlineCommentPubSubEvents;
}({});
var $e3661bd3089bf51c$export$d05a35896d8f557d = /*#__PURE__*/ function(InlineCommentSubscriptionEvents) {
    InlineCommentSubscriptionEvents["InlineCommentCreated"] = "inlineCommentCreated";
    InlineCommentSubscriptionEvents["RendererInlineCommentCreated"] = "rendererInlineCommentCreated";
    InlineCommentSubscriptionEvents["EditorInlineCommentCreated"] = "editorInlineCommentCreated";
    InlineCommentSubscriptionEvents["InlineCommentDeleted"] = "inlineCommentDeleted";
    InlineCommentSubscriptionEvents["InlineCommentResolved"] = "inlineCommentResolved";
    InlineCommentSubscriptionEvents["InlineCommentUnresolved"] = "inlineCommentUnresolved";
    InlineCommentSubscriptionEvents["InlineCommentUpdated"] = "inlineCommentUpdated";
    InlineCommentSubscriptionEvents["InlineCommentReattached"] = "inlineCommentReattached";
    return InlineCommentSubscriptionEvents;
}({});
var $e3661bd3089bf51c$export$5d941a2346cc8f6a = /*#__PURE__*/ function(PagePubSubEvents) {
    PagePubSubEvents["PagePublished"] = "avi:confluence:publish:page";
    PagePubSubEvents["BlogPublished"] = "avi:confluence:publish:blogpost";
    return PagePubSubEvents;
}({});
var $e3661bd3089bf51c$export$15c104b3df413bde = /*#__PURE__*/ function(PageSubscriptionEvents) {
    PageSubscriptionEvents["PageUpdated"] = "pageUpdated";
    return PageSubscriptionEvents;
}({});
module.exports["InlineCommentPubSubEvents"] = $e3661bd3089bf51c$export$7309710dd8a888d9;
module.exports["InlineCommentSubscriptionEvents"] = $e3661bd3089bf51c$export$d05a35896d8f557d;
module.exports["PagePubSubEvents"] = $e3661bd3089bf51c$export$5d941a2346cc8f6a;
module.exports["PageSubscriptionEvents"] = $e3661bd3089bf51c$export$15c104b3df413bde;

});

parcelRegister("03oqz", function(module, exports) {

var $8i27m = parcelRequire("8i27m");


var $1C8XP = parcelRequire("1C8XP");


var $c0rhi = parcelRequire("c0rhi");

const $895e8bda1c5e4d1e$export$15e2805385ec0eed = (contentId, markerRef)=>(0, $c0rhi.queryInterop)({
        query: (0, $1C8XP.ActiveInlineCommentsQuery),
        fetchPolicy: 'network-only',
        variables: {
            pageId: contentId,
            inlineMarkerRefList: [
                markerRef
            ],
            contentStatus: [
                'DRAFT',
                'CURRENT'
            ]
        },
        __callerPackage__: "comments-pubsub"
    });
const $895e8bda1c5e4d1e$export$90e382997b4dc102 = async (contentId, markerRef)=>{
    const commentThreadDataResult = await (0, $c0rhi.queryInterop)({
        query: (0, $1C8XP.ActiveInlineCommentsQuery),
        fetchPolicy: 'network-only',
        variables: {
            pageId: contentId,
            inlineMarkerRefList: [
                markerRef
            ],
            contentStatus: [
                'DRAFT',
                'CURRENT'
            ]
        },
        __callerPackage__: "comments-pubsub"
    });
    return commentThreadDataResult.data;
};
const $895e8bda1c5e4d1e$export$e136ff0cd91112e0 = async ({ contentId: contentId, markerRef: markerRef, addNewCommentThreads: addNewCommentThreads })=>{
    const commentThreadDataResult = await $895e8bda1c5e4d1e$export$90e382997b4dc102(contentId ?? '', markerRef);
    const comment = commentThreadDataResult?.comments?.nodes?.[0];
    if (comment) addNewCommentThreads && addNewCommentThreads({
        inline: {
            [markerRef]: {
                ...comment,
                isOpen: true,
                wasRemovedByAnotherUser: false,
                type: (0, $8i27m.CommentType).INLINE
            }
        },
        general: {}
    });
};
const $895e8bda1c5e4d1e$export$120fd6a8527dd6bd = async ({ contentId: contentId, markerRef: markerRef, commentId: commentId, addReplyToCommentThread: addReplyToCommentThread, commentType: commentType, storedCommentData: storedCommentData, setStoredCommentData: setStoredCommentData })=>{
    const commentThreadDataResult = await $895e8bda1c5e4d1e$export$90e382997b4dc102(contentId ?? '', markerRef);
    const comment = commentThreadDataResult?.comments?.nodes?.[0];
    const replies = comment?.replies;
    const reply = replies?.filter((r)=>r?.id === commentId)[0];
    if (reply) {
        // Update storedCommentData if it exists by adding the new reply
        if (storedCommentData && setStoredCommentData) {
            const updatedCommentData = {
                ...storedCommentData,
                replies: [
                    ...storedCommentData.replies || [],
                    reply
                ]
            };
            // Only update if inlineMarkerRef matches between stored and fetched comment
            if (storedCommentData.location?.inlineMarkerRef === comment?.location?.inlineMarkerRef) setStoredCommentData(updatedCommentData);
        }
        addReplyToCommentThread && addReplyToCommentThread(markerRef, {
            ...reply
        }, commentType);
    }
};
const $895e8bda1c5e4d1e$export$7652b163bd2668c5 = async ({ contentId: contentId, markerRef: markerRef, commentId: commentId, updateCommentBody: updateCommentBody })=>{
    const commentThreadDataResult = await $895e8bda1c5e4d1e$export$90e382997b4dc102(contentId ?? '', markerRef);
    const comment = commentThreadDataResult?.comments?.nodes?.[0];
    const targetComment = comment?.id === commentId ? comment : comment?.replies?.find((r)=>r?.id === commentId);
    if (targetComment && updateCommentBody) updateCommentBody(commentId, markerRef, targetComment.body.value, (0, $8i27m.CommentType).INLINE, targetComment.version.by?.displayName);
};
module.exports["refreshCommentThread"] = $895e8bda1c5e4d1e$export$15e2805385ec0eed;
module.exports["handleAddNewCommentThread"] = $895e8bda1c5e4d1e$export$e136ff0cd91112e0;
module.exports["handleAddedReplyInCommentThread"] = $895e8bda1c5e4d1e$export$120fd6a8527dd6bd;
module.exports["handleEditedComment"] = $895e8bda1c5e4d1e$export$7652b163bd2668c5;

});

parcelRegister("kmWRd", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $iODl6 = parcelRequire("iODl6");


var $j72ee = parcelRequire("j72ee");

const $7a88b175622d580e$var$sidePanelContentStyling = (0, $buxP3.xcss)({
    position: 'absolute',
    width: '100%',
    backgroundColor: 'elevation.surface',
    height: '100%',
    top: '0',
    right: '0',
    left: '0',
    bottom: '0',
    display: 'flex',
    flexDirection: 'column'
});
const $7a88b175622d580e$export$8689d3888980b1f3 = (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { headerHeight: t1, isFixed: isFixed, children: children, displayTopBorder: displayTopBorder, panelTop: t2, isOpen: t3, width: t4 } = t0;
    const headerHeight = t1 === undefined ? 0 : t1;
    const panelTop = t2 === undefined ? 0 : t2;
    const isOpen = t3 === undefined ? true : t3;
    const width = t4 === undefined ? 320 : t4;
    let t5;
    if ($[0] !== children || $[1] !== displayTopBorder || $[2] !== headerHeight || $[3] !== isFixed || $[4] !== isOpen || $[5] !== panelTop || $[6] !== width) {
        t5 = isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j72ee.default), {
            enterFrom: "right",
            fade: "inout"
        }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                ...props,
                style: {
                    backgroundColor: "elevation.surface",
                    position: isFixed ? "fixed" : "absolute",
                    right: "0",
                    top: `${panelTop}px`,
                    width: `${width}px`,
                    padding: "space.300",
                    borderLeft: "var(--ds-border-width, 1px) solid var(--ds-border, #0B120E24)",
                    height: `calc(100vh - ${headerHeight}px)`,
                    borderTop: displayTopBorder ? "var(--ds-border-width, 1px) solid var(--ds-border, #0B120E24)" : "none"
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $7a88b175622d580e$var$sidePanelContentStyling
            }, children)));
        $[0] = children;
        $[1] = displayTopBorder;
        $[2] = headerHeight;
        $[3] = isFixed;
        $[4] = isOpen;
        $[5] = panelTop;
        $[6] = width;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
            appear: true
        }, t5);
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    return t6;
};
module.exports["SidePanel"] = $7a88b175622d580e$export$8689d3888980b1f3;

});

parcelRegister("2zdC2", function(module, exports) {
"use strict";
var $1de968d0bde0a175$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $zAMIg = parcelRequire("zAMIg");

/**
 * Emits a value from the source Observable only after a particular time span
 * has passed without another source emission.
 *
 * <span class="informal">It's like {@link delay}, but passes only the most
 * recent value from each burst of emissions.</span>
 *
 * <img src="./img/debounceTime.png" width="100%">
 *
 * `debounceTime` delays values emitted by the source Observable, but drops
 * previous pending delayed emissions if a new value arrives on the source
 * Observable. This operator keeps track of the most recent value from the
 * source Observable, and emits that only when `dueTime` enough time has passed
 * without any other value appearing on the source Observable. If a new value
 * appears before `dueTime` silence occurs, the previous value will be dropped
 * and will not be emitted on the output Observable.
 *
 * This is a rate-limiting operator, because it is impossible for more than one
 * value to be emitted in any time window of duration `dueTime`, but it is also
 * a delay-like operator since output emissions do not occur at the same time as
 * they did on the source Observable. Optionally takes a {@link IScheduler} for
 * managing timers.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounceTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} dueTime The timeout duration in milliseconds (or the time
 * unit determined internally by the optional `scheduler`) for the window of
 * time required to wait for emission silence before emitting the most recent
 * source value.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the timeout for each value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified `dueTime`, and may drop some values if they occur
 * too frequently.
 * @method debounceTime
 * @owner Observable
 */ function $1de968d0bde0a175$var$debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = $zAMIg.async;
    return function(source) {
        return source.lift(new $1de968d0bde0a175$var$DebounceTimeOperator(dueTime, scheduler));
    };
}
module.exports.debounceTime = $1de968d0bde0a175$var$debounceTime;
var $1de968d0bde0a175$var$DebounceTimeOperator = function() {
    function DebounceTimeOperator(dueTime, scheduler) {
        this.dueTime = dueTime;
        this.scheduler = scheduler;
    }
    DebounceTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $1de968d0bde0a175$var$DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
    };
    return DebounceTimeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $1de968d0bde0a175$var$DebounceTimeSubscriber = function(_super) {
    $1de968d0bde0a175$var$__extends(DebounceTimeSubscriber, _super);
    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
        _super.call(this, destination);
        this.dueTime = dueTime;
        this.scheduler = scheduler;
        this.debouncedSubscription = null;
        this.lastValue = null;
        this.hasValue = false;
    }
    DebounceTimeSubscriber.prototype._next = function(value) {
        this.clearDebounce();
        this.lastValue = value;
        this.hasValue = true;
        this.add(this.debouncedSubscription = this.scheduler.schedule($1de968d0bde0a175$var$dispatchNext, this.dueTime, this));
    };
    DebounceTimeSubscriber.prototype._complete = function() {
        this.debouncedNext();
        this.destination.complete();
    };
    DebounceTimeSubscriber.prototype.debouncedNext = function() {
        this.clearDebounce();
        if (this.hasValue) {
            this.destination.next(this.lastValue);
            this.lastValue = null;
            this.hasValue = false;
        }
    };
    DebounceTimeSubscriber.prototype.clearDebounce = function() {
        var debouncedSubscription = this.debouncedSubscription;
        if (debouncedSubscription !== null) {
            this.remove(debouncedSubscription);
            debouncedSubscription.unsubscribe();
            this.debouncedSubscription = null;
        }
    };
    return DebounceTimeSubscriber;
}($fNVRJ.Subscriber);
function $1de968d0bde0a175$var$dispatchNext(subscriber) {
    subscriber.debouncedNext();
}

});

parcelRegister("3WPGR", function(module, exports) {

var $1d2ww = parcelRequire("1d2ww");


var $jVylI = parcelRequire("jVylI");


var $zalpJ = parcelRequire("zalpJ");


var $75Ax4 = parcelRequire("75Ax4");


var $dkxaU = parcelRequire("dkxaU");


var $bKd7w = parcelRequire("bKd7w");

function $523f2f8bee18c451$export$da000b5ddbbe9afc(p) {
    let value;
    let version;
    try {
        value = JSON.parse(p.value);
        version = parseInt(JSON.parse(p.version.number));
        // Counting quotes to determine if the value we receive is a string (old cover photos experience without repositioning feature)
        // or object (new cover photos experience with repositioning feature - has a position property in the object).
        // The new designs will have value as an object but stored as a string: "{"id":"http://website.com","position":45}"
        // We need to JSON.parse it again to turn it into an object. The old cover photos will just have value as a string: value: "123-abc",
        // so there is no need to JSON parse it again. We will set its position as the default position value to support this new value format.
        const quoteMatches = value.match(/"/g);
        const quoteCount = quoteMatches ? quoteMatches.length : 0;
        // if quoteCount != null this mean value is part of the new experience so we need to JSON parse the info again since it is a stored as a string and we want the object
        if (quoteCount) try {
            value = JSON.parse(value);
        } catch (e) {
            value = null;
        }
        else // otherwise it was just a regular string (part of old experience without repositioning)
        value = {
            id: value,
            position: (0, $75Ax4.DEFAULT_POSITION_VALUE)
        };
    } catch (e) {
        value = null;
        version = null;
    }
    return p ? {
        value: value,
        version: version
    } : null;
}
function $523f2f8bee18c451$export$64dc6e3789165979(appearanceValue) {
    let appearance;
    if (appearanceValue) try {
        appearance = JSON.parse(appearanceValue);
    } catch (e) {
        appearance = null;
    }
    return appearance ?? (0, $1d2ww.ContentAppearanceType).DEFAULT;
}
function $523f2f8bee18c451$export$df5897f4041f380b(contentQueryData, isLivePage) {
    const pageWidthType = contentQueryData?.content?.nodes?.[0]?.appearancePublished?.nodes?.[0]?.value || `"default"`;
    const properties = contentQueryData?.content?.nodes?.[0]?.properties?.nodes || [];
    const published = isLivePage ? properties[0] : properties.find((p)=>p?.key === (0, $bKd7w.CoverPictureIdPropertyKey).PUBLISHED);
    const coverPictureWidth = contentQueryData?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
    const { titleContentProperties: titleContentProperties } = (0, $zalpJ.getTitleContentProperty)(contentQueryData);
    const isTitleCenterAligned = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER;
    const coverPicture = {
        draft: null,
        published: $523f2f8bee18c451$export$da000b5ddbbe9afc(published)
    };
    let publishedValue;
    try {
        publishedValue = JSON.parse(pageWidthType);
    } catch (e) {
        publishedValue = 'default';
    }
    const contentAppearance = {
        draft: '',
        published: publishedValue
    };
    const hasCoverPicture = !!coverPicture?.published?.value?.id;
    return {
        coverPicture: coverPicture,
        contentAppearance: contentAppearance,
        hasCoverPicture: hasCoverPicture,
        coverPictureWidth: coverPictureWidth,
        isTitleCenterAligned: isTitleCenterAligned
    };
}
const $523f2f8bee18c451$export$abc9309e623c0351 = (width)=>{
    return (0, $dkxaU.calcDynamicCoverImageHeight)(width);
};
function $523f2f8bee18c451$export$8a432f79b719eeda(imageUrl) {
    if (!imageUrl) return false;
    return imageUrl.includes('images.unsplash.com') || imageUrl.includes('dam-cdn.atl.orangelogic.com') || /^https?:\/\/wac-cdn-[^.]+\.atlassian\.com/.test(imageUrl);
}
module.exports["propertyToId"] = $523f2f8bee18c451$export$da000b5ddbbe9afc;
module.exports["getRendererCoverPictureInfo"] = $523f2f8bee18c451$export$df5897f4041f380b;
module.exports["getDynamicCoverImageHeight"] = $523f2f8bee18c451$export$abc9309e623c0351;
module.exports["isAllowedExternalCoverPictureUrl"] = $523f2f8bee18c451$export$8a432f79b719eeda;

});

parcelRegister("bKd7w", function(module, exports) {
var $9558c78c09e4ba60$export$da638b84af7eb6eb = /*#__PURE__*/ function(CoverPictureIdPropertyKey) {
    CoverPictureIdPropertyKey["PUBLISHED"] = "cover-picture-id-published";
    CoverPictureIdPropertyKey["DRAFT"] = "cover-picture-id-draft";
    return CoverPictureIdPropertyKey;
}({});
module.exports["CoverPictureIdPropertyKey"] = $9558c78c09e4ba60$export$da638b84af7eb6eb;

});

parcelRegister("ktUCG", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");


var $6mKj3 = parcelRequire("6mKj3");


var $8rneB = parcelRequire("8rneB");


var $bKZz0 = parcelRequire("bKZz0");

class $122734ff4c4db131$export$c7d05d5ff2632978 extends (0, $kNIYN.Container) {
    populateState(ssrEmojiTitleData) {
        const { emojiStatusFieldName: emojiStatusFieldName, queryData: queryData, isLivePage: isLivePage } = ssrEmojiTitleData;
        const emojiId = (0, $8rneB.getEmojiId)(queryData, emojiStatusFieldName);
        const hasDefaultLiveTitleEmoji = (0, $8rneB.getHasLiveDocsDefaultEmoji)(queryData);
        this.setSelectedEmoji(emojiId || null);
        this.setHasLiveDocsDefaultEmoji(hasDefaultLiveTitleEmoji && isLivePage);
    }
    constructor(ssrEmojiTitleData){
        super();
        // Analytics-only flag: intentionally bypasses Container state so mutations
        // never trigger subscriber re-renders.
        this.justRestoredEmoji = false;
        this.state = {
            emojiPickerLoaded: false,
            isLoading: true,
            isMouseEnterTitle: false,
            isUpdatingEmoji: false,
            openFirstEmojiPicker: false,
            openSecondEmojiPicker: false,
            selectedEmoji: null,
            isEmojiButtonFocused: false,
            isRemovingEmoji: false,
            hasLiveDocsDefaultEmoji: false,
            previousEmojiIdByContentId: {}
        };
        this.onUpdateStart = ()=>this.setState({
                isUpdatingEmoji: true
            });
        this.onUpdateEnd = ()=>{
            this.setState({
                isUpdatingEmoji: false
            });
            this.setState({
                isRemovingEmoji: false
            });
        };
        this.setIsEmojiButtonFocused = (isEmojiButtonFocused)=>this.setState({
                isEmojiButtonFocused: isEmojiButtonFocused
            });
        this.setIsRemovingEmoji = (isRemovingEmoji)=>this.setState({
                isRemovingEmoji: isRemovingEmoji
            });
        this.setIsUpdatingEmoji = (isUpdatingEmoji)=>this.setState({
                isUpdatingEmoji: isUpdatingEmoji
            });
        // first emoji picker is open when user already selected an emoji
        // click on the emoji and want to change it to different emoji
        this.setOpenFirstEmojiPicker = (isOpen)=>{
            if (this.state.openFirstEmojiPicker !== isOpen) this.setState({
                openFirstEmojiPicker: isOpen
            });
        };
        // second emoji picker is open when not yet selected an emoji
        // and want to add emoji via Add emoji button
        this.setOpenSecondEmojiPicker = (isOpen)=>{
            if (this.state.openSecondEmojiPicker !== isOpen) this.setState({
                openSecondEmojiPicker: isOpen
            });
        };
        this.setSelectedEmoji = (emoji)=>this.setState({
                selectedEmoji: emoji
            });
        this.onEmojiPickerLoaded = ()=>{
            if (!this.state.emojiPickerLoaded) this.setState({
                emojiPickerLoaded: true
            });
        };
        // for testing
        this.setContainerState = (newState)=>this.setState((state)=>({
                    ...state,
                    ...newState
                }));
        this.setLoadingEmoji = (isLoading)=>this.setState({
                isLoading: isLoading
            });
        this.setHasLiveDocsDefaultEmoji = (hasDefaultEmoji)=>this.setState({
                hasLiveDocsDefaultEmoji: hasDefaultEmoji
            });
        this.getPreviousEmojiId = (contentId)=>this.state.previousEmojiIdByContentId[contentId] ?? null;
        // Pass `null` to clear just that entry.
        this.setPreviousEmojiId = (contentId, previousEmojiId)=>{
            const next = {
                ...this.state.previousEmojiIdByContentId
            };
            if (previousEmojiId === null) delete next[contentId];
            else next[contentId] = previousEmojiId;
            if ((0, $6mKj3.isExperimentEnabled)('cc_page_experiences_livedocs_restore_latest_emoji')) (0, $bKZz0.writeSessionStoragePreviousEmojiCache)(next);
            return this.setState({
                previousEmojiIdByContentId: next
            });
        };
        if ((0, $6mKj3.isExperimentEnabled)('cc_page_experiences_livedocs_restore_latest_emoji')) {
            const hydrated = (0, $bKZz0.readSessionStoragePreviousEmojiCache)();
            if (Object.keys(hydrated).length > 0) this.state = {
                ...this.state,
                previousEmojiIdByContentId: hydrated
            };
        }
        if (ssrEmojiTitleData) this.populateState(ssrEmojiTitleData);
    }
}
module.exports["EmojiTitleStateContainer"] = $122734ff4c4db131$export$c7d05d5ff2632978;

});

parcelRegister("bKZz0", function(module, exports) {
/**
 * sessionStorage mirror for the per-contentId `previousEmojiId` cache used by
 * the Live Docs "Restore emoji" affordance. Survives same-tab refresh; not a
 * source of truth — the in-memory unstated state is. Failures degrade silently.
 */ 
var $17wUi = parcelRequire("17wUi");


var $ivEX1 = parcelRequire("ivEX1");

const $dabf2e5c28263f4b$var$STORAGE_KEY = (0, $ivEX1.sessionKeys).EMOJI_TITLE_PREVIOUS_EMOJI;
const $dabf2e5c28263f4b$export$6adb2744b497be8f = ()=>{
    try {
        const raw = (0, $17wUi.confluenceSessionStorageInstance)?.getItem($dabf2e5c28263f4b$var$STORAGE_KEY);
        if (!raw || typeof raw !== 'string') return {};
        const parsed = JSON.parse(raw);
        if (!parsed || parsed.v !== 1 || typeof parsed.entries !== 'object' || !parsed.entries) return {};
        // Defensive: filter to non-empty string values in case the slot was
        // mutated by something else on the same origin.
        const out = {};
        for (const [contentId, emojiId] of Object.entries(parsed.entries))if (typeof emojiId === 'string' && emojiId.length > 0) out[contentId] = emojiId;
        return out;
    } catch  {
        return {};
    }
};
const $dabf2e5c28263f4b$export$3ef572a2467e08f4 = (map)=>{
    try {
        const entries = {};
        for (const [contentId, emojiId] of Object.entries(map))if (typeof emojiId === 'string' && emojiId.length > 0) entries[contentId] = emojiId;
        // Drop the key entirely when empty to keep storage clean.
        if (Object.keys(entries).length === 0) {
            (0, $17wUi.confluenceSessionStorageInstance)?.removeItem($dabf2e5c28263f4b$var$STORAGE_KEY);
            return;
        }
        (0, $17wUi.confluenceSessionStorageInstance)?.setItem($dabf2e5c28263f4b$var$STORAGE_KEY, JSON.stringify({
            v: 1,
            entries: entries
        }));
    } catch  {
    // Quota / consent / disabled storage — swallow; in-memory cache is unaffected.
    }
};
const $dabf2e5c28263f4b$export$fc4e54f3757eb471 = $dabf2e5c28263f4b$var$STORAGE_KEY;
module.exports["readSessionStoragePreviousEmojiCache"] = $dabf2e5c28263f4b$export$6adb2744b497be8f;
module.exports["writeSessionStoragePreviousEmojiCache"] = $dabf2e5c28263f4b$export$3ef572a2467e08f4;

});

parcelRegister("Qlykt", function(module, exports) {
const $f866e8db934ec558$export$d7240ab6bd9deaf0 = 40;
const $f866e8db934ec558$export$7d383c70a74caba8 = 80;
module.exports["EMOJI_SIZE_MEDIUM"] = $f866e8db934ec558$export$d7240ab6bd9deaf0;
module.exports["EMOJI_SIZE_LARGE"] = $f866e8db934ec558$export$7d383c70a74caba8;

});

parcelRegister("4wEOc", function(module, exports) {

var $hGuUS = parcelRequire("hGuUS");


var $jMyy4 = parcelRequire("jMyy4");

'use no memo';
const $17b0e005176b05e7$var$UseIsDataClassificationEnabledForOrgQuery = (0, $hGuUS.default);
const $17b0e005176b05e7$export$2e6840e38da4c328 = ({ skip: skip = false } = {})=>{
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($17b0e005176b05e7$var$UseIsDataClassificationEnabledForOrgQuery, {
        context: {
            single: true
        },
        skip: skip,
        __callerPackage__: "data-classification"
    });
    const isEnabled = Boolean(data?.isDataClassificationEnabled);
    return {
        isEnabled: isEnabled,
        error: error,
        loading: loading
    };
};
module.exports["useIsDataClassificationEnabledForOrg"] = $17b0e005176b05e7$export$2e6840e38da4c328;

});

parcelRegister("hGuUS", function(module, exports) {
/**
 * @generated SignedSource<<4d55aa969e816897d00319e58e9ae80b>>
 * @relayHash 7a459e5b02d70f6bd0fcfe9c6f09aaed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f7439efefbddad3c834c2882c87168c3d526f7ef715c67e6eb50135d0daa5fbe
const $d06bb9e5b53f54be$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "isDataClassificationEnabled"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useIsDataClassificationEnabledForOrgQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useIsDataClassificationEnabledForOrgQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "7a459e5b02d70f6bd0fcfe9c6f09aaed",
            "id": "f7439efefbddad3c834c2882c87168c3d526f7ef715c67e6eb50135d0daa5fbe",
            "metadata": {},
            "name": "useIsDataClassificationEnabledForOrgQuery",
            "operationKind": "query",
            "text": "query useIsDataClassificationEnabledForOrgQuery{isDataClassificationEnabled}"
        }
    };
}();
$d06bb9e5b53f54be$var$node.hash = "5fefa316f3ebea3d1e92d59f94b250db";
var $d06bb9e5b53f54be$export$2e2bcd8739ae039 = $d06bb9e5b53f54be$var$node;
module.exports["default"] = $d06bb9e5b53f54be$export$2e2bcd8739ae039;

});

parcelRegister("kj1gY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $65a70e5bc153e910$export$3ecbd7f299e957b2 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "20b9O",
    name: "ChangesDiffLoader",
    loader: async ()=>(await (parcelRequire("kXeIa"))).ChangesDiff
});
module.exports["ChangesDiffLoader"] = $65a70e5bc153e910$export$3ecbd7f299e957b2;

});

parcelRegister("kXeIa", function(module, exports) {

let $f414bab20a46abe8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f414bab20a46abe8$var$load("8OiWl").then(()=>parcelRequire('fQeQL'));

});

parcelRegister("dpqzw", function(module, exports) {
const $e10f62297c04a73f$export$51c8f3f20bd49804 = 'fabric-editor-popup-scroll-parent';
const $e10f62297c04a73f$export$547bf96576574b25 = '.ProseMirror > *';
const $e10f62297c04a73f$export$f76b40820c13783a = '.ak-renderer-document';
const $e10f62297c04a73f$export$7718f42d39a9217b = 'content';
module.exports["EDITOR_PARENT_CLASS"] = $e10f62297c04a73f$export$51c8f3f20bd49804;
module.exports["EDITOR_CHILDREN_SELECTOR"] = $e10f62297c04a73f$export$547bf96576574b25;
module.exports["RENDERED_CONTENT_SELECTOR"] = $e10f62297c04a73f$export$f76b40820c13783a;
module.exports["FABRIC_PAGE_CONTENT_ID"] = $e10f62297c04a73f$export$7718f42d39a9217b;

});

parcelRegister("b66o6", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f480656426be1312$export$b62abe642254f319 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "O8EvX",
    name: "RevertEditorDialog",
    loader: async ()=>(await (parcelRequire("kwhAi"))).RevertEditorDialog
});
module.exports["RevertEditorDialog"] = $f480656426be1312$export$b62abe642254f319;

});

parcelRegister("kwhAi", function(module, exports) {

let $ef046fb0196f7b22$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ef046fb0196f7b22$var$load("23MlT").then(()=>parcelRequire('1yiQ2'));

});

parcelRegister("BCkug", function(module, exports) {

var $9ieTK = parcelRequire("9ieTK");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $8aF6s = parcelRequire("8aF6s");


var $jv3O2 = parcelRequire("jv3O2");


var $ij4CE = parcelRequire("ij4CE");


var $bN5DJ = parcelRequire("bN5DJ");


var $3FmeR = parcelRequire("3FmeR");




const $f911f42fbae43711$export$652cb536b0ebabdb = (props)=>{
    const { contentId: contentId, spaceId: spaceId, isUnpublishedDraft: isUnpublishedDraft, analyticsSource: analyticsSource, adfOrigin: adfOrigin, onSuccessfulConversion: onSuccessfulConversion, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, flags: flags, saveDraft: saveDraft } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const showConvertToLivePageFlag = (0, $jv3O2.useShowConvertToLivePageFlag)({
        flags: flags
    });
    const onSuccess = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent?.({
            type: 'sendUIEvent',
            data: {
                action: 'convertedToLivePage',
                actionSubject: 'page',
                source: analyticsSource,
                objectId: contentId,
                objectType: 'page',
                containerId: spaceId,
                containerType: 'space',
                attributes: {
                    isDraft: isUnpublishedDraft
                }
            }
        }).fire();
        onSuccessfulConversion?.();
        showConvertToLivePageFlag({
            converterWasCurrentUser: true
        });
    }, [
        createAnalyticsEvent,
        analyticsSource,
        contentId,
        spaceId,
        isUnpublishedDraft,
        onSuccessfulConversion,
        showConvertToLivePageFlag
    ]);
    const writeSubTypeFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $9ieTK.default),
        fragmentArtifact: (0, $9ieTK.default),
        __callerPackage__: "live-pages-features"
    });
    return (0, $cozmU.useCallback)(async ()=>{
        createAnalyticsEvent?.({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'switchToLiveEdit',
                source: analyticsSource,
                objectId: contentId,
                objectType: 'page',
                containerId: spaceId,
                containerType: 'space',
                attributes: {
                    isDraft: isUnpublishedDraft
                }
            }
        }).fire();
        if (!isUnpublishedDraft) showModal((0, $bN5DJ.ConvertToLivePageDialog), {
            contentId: contentId,
            onConfirm: onSuccess,
            adfOrigin: adfOrigin,
            retrieveEditorTitleAndContent: retrieveEditorTitleAndContent
        });
        else {
            // Trigger draft sync before converting. If we don't do this and the user recently updated their draft title then quickly converted the draft, draft sync may not have triggered and we may not identify their title conflict.
            await saveDraft?.();
            (0, $3FmeR.convertDraftToLivePage)({
                contentId: contentId,
                spaceId: spaceId,
                onSuccess: onSuccess,
                flags: flags,
                retrieveEditorTitleAndContent: retrieveEditorTitleAndContent,
                writeSubTypeFragment: writeSubTypeFragment
            });
        }
    }, [
        createAnalyticsEvent,
        analyticsSource,
        contentId,
        spaceId,
        isUnpublishedDraft,
        showModal,
        onSuccess,
        adfOrigin,
        retrieveEditorTitleAndContent,
        saveDraft,
        flags,
        writeSubTypeFragment
    ]);
};
module.exports["useSwitchToLivePage"] = $f911f42fbae43711$export$652cb536b0ebabdb;

});

parcelRegister("9ieTK", function(module, exports) {
/**
 * @generated SignedSource<<bf7406aa567fbba04e7cb02c4c87c8f6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b5dcf221c9d66892$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useSwitchToLivePageSubTypeFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "subType"
        }
    ],
    "type": "Content"
};
$b5dcf221c9d66892$var$node.hash = "83901263f96d64a150282b24a00afaf6";
var $b5dcf221c9d66892$export$2e2bcd8739ae039 = $b5dcf221c9d66892$var$node;
module.exports["default"] = $b5dcf221c9d66892$export$2e2bcd8739ae039;

});

parcelRegister("bN5DJ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $5b509ab565dd40fa$export$13f6b1ebaf0950f0 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "_DPHW",
    name: "ConvertToLivePageDialog",
    loader: async ()=>(await (parcelRequire("eZHuZ"))).ConvertToLivePageDialog
});
module.exports["ConvertToLivePageDialog"] = $5b509ab565dd40fa$export$13f6b1ebaf0950f0;

});

parcelRegister("eZHuZ", function(module, exports) {

let $aea8812b84cbe978$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $aea8812b84cbe978$var$load("6wr18"),
    $aea8812b84cbe978$var$load("4fYzp"),
    $aea8812b84cbe978$var$load("ffEVr"),
    $aea8812b84cbe978$var$load("RU02s")
]).then(()=>parcelRequire('9Pjdf'));

});

parcelRegister("3FmeR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $jhwJP = parcelRequire("jhwJP");


var $fyUox = parcelRequire("fyUox");


var $irrTO = parcelRequire("irrTO");


var $9sGCn = parcelRequire("9sGCn");


var $6s78L = parcelRequire("6s78L");


var $9Yt7A = parcelRequire("9Yt7A");


var $6LFAK = parcelRequire("6LFAK");

const $cb12ca6e6f1d2ae2$var$i18nBase = (0, $kSwu1.defineMessages)({
    titleConflictFlagTitle: {
        id: "live-pages-features.converttolivepage.draft-conversion-title-conflict.title",
        defaultMessage: "Unable to convert draft to live page"
    },
    genericErrorFlagTitle: {
        id: "live-pages-features.converttolivepage.generic-error.title",
        defaultMessage: "An error occurred"
    }
});
const $cb12ca6e6f1d2ae2$var$i18nLiveDocs = (0, $kSwu1.defineMessages)({
    titleConflictFlagTitle: {
        id: "live-pages-features.converttolivepage.draft-conversion-title-conflict.title.livedocs",
        defaultMessage: "Unable to convert draft to live doc"
    }
});
const $cb12ca6e6f1d2ae2$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($cb12ca6e6f1d2ae2$var$i18nBase, $cb12ca6e6f1d2ae2$var$i18nLiveDocs);
const $cb12ca6e6f1d2ae2$var$preloadProperties = async (contentId, spaceId)=>{
    const tasks = [];
    tasks.push((0, $fyUox.preloadPageTitleContentProperties)({
        contentId: contentId,
        spaceKey: spaceId,
        fetchPolicy: 'network-only'
    }));
    tasks.push((0, $irrTO.preloadDraftContentAppearance)(contentId, false));
    return Promise.all(tasks);
};
const $cb12ca6e6f1d2ae2$export$a4275df84ffd8722 = async ({ contentId: contentId, spaceId: spaceId = '', onSuccess: onSuccess, flags: flags, retrieveEditorTitleAndContent: retrieveEditorTitleAndContent, writeSubTypeFragment: writeSubTypeFragment })=>{
    try {
        const { data: mutationData } = await (0, $6s78L.mutateInterop)({
            mutation: (0, $9Yt7A.default),
            variables: {
                contentId: contentId
            },
            update: (_, { data: data })=>{
                if (data?.convertPageToLiveEditAction?.success) {
                    writeSubTypeFragment({
                        fragmentId: `Content:${contentId}`,
                        data: {
                            __typename: 'Content',
                            subType: 'live'
                        }
                    });
                    // Since graphql cache has been updated, make sure the memoization cache for getCachedPageData is cleared
                    // So if getCachedPageData is called again with the same content id, it will read the updated graphql cache instead of returning the memoized data
                    (0, $9sGCn.clearMemoizedCachedPageData)();
                }
            },
            __callerPackage__: "live-pages-features"
        });
        const result = mutationData?.convertPageToLiveEditAction;
        if (result?.success) {
            await $cb12ca6e6f1d2ae2$var$preloadProperties(contentId, spaceId).catch(()=>{
            // Since its a preload, we don't want show an error flag
            });
            onSuccess();
            return;
        }
        result?.errors?.forEach(async (error)=>{
            (0, $6LFAK.processError)(error, contentId);
            const flagTitle = error.message === 'Title already exists' ? $cb12ca6e6f1d2ae2$export$a7357cdd1f0b0168.titleConflictFlagTitle : $cb12ca6e6f1d2ae2$export$a7357cdd1f0b0168.genericErrorFlagTitle;
            const flagDescription = (0, $6LFAK.getI18nStringForError)(error.message ?? '');
            const flagDescriptionValues = {};
            if (error.message === 'Title already exists') {
                const { title: pageTitle } = await retrieveEditorTitleAndContent();
                flagDescriptionValues.pageTitle = pageTitle || '';
            }
            flags.showErrorFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), flagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...flagDescription,
                    values: flagDescriptionValues
                }),
                isAutoDismiss: false
            });
        });
    } catch (error) {
        (0, $6LFAK.processError)(error, contentId);
        flags.showErrorFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $cb12ca6e6f1d2ae2$export$a7357cdd1f0b0168.genericErrorFlagTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6LFAK.i18n).unknownError),
            isAutoDismiss: false
        });
    }
};
const $cb12ca6e6f1d2ae2$export$5c2d46edf58b6daa = $cb12ca6e6f1d2ae2$export$a7357cdd1f0b0168;
module.exports["convertDraftToLivePage"] = $cb12ca6e6f1d2ae2$export$a4275df84ffd8722;

});

parcelRegister("9Yt7A", function(module, exports) {
/**
 * @generated SignedSource<<74425b153151e85569d7c520ffd47edb>>
 * @relayHash 603eb09fdbf7e41ae341d58b5067bb0a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d4a98a70adb646dfa084b35cf854a7b68d474aa44e9927399f73da1aad0d0d1b
const $e053a44ee0757fb3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "ConvertPageToLiveEditActionPayload",
            "kind": "LinkedField",
            "name": "convertPageToLiveEditAction",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ConvertToLivePageMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ConvertToLivePageMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "603eb09fdbf7e41ae341d58b5067bb0a",
            "id": "d4a98a70adb646dfa084b35cf854a7b68d474aa44e9927399f73da1aad0d0d1b",
            "metadata": {},
            "name": "ConvertToLivePageMutation",
            "operationKind": "mutation",
            "text": "mutation ConvertToLivePageMutation($contentId:ID!){convertPageToLiveEditAction(input:{contentId:$contentId}){success,errors{message}}}"
        }
    };
}();
$e053a44ee0757fb3$var$node.hash = "ad615689cf4fc4a255187ebb0a30c32e";
var $e053a44ee0757fb3$export$2e2bcd8739ae039 = $e053a44ee0757fb3$var$node;
module.exports["default"] = $e053a44ee0757fb3$export$2e2bcd8739ae039;

});

parcelRegister("6LFAK", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $422HI = parcelRequire("422HI");


var $jhwJP = parcelRequire("jhwJP");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $6fil2 = parcelRequire("6fil2");


var $7Sm4c = parcelRequire("7Sm4c");

const $49d66c83bc63de25$var$i18nBase = (0, $kSwu1.defineMessages)({
    unknownError: {
        id: "live-pages-features.converttolivepage.modal.error.unknown",
        defaultMessage: "An error occurred. Please try again."
    },
    serverException: {
        id: "live-pages-features.converttolivepage.modal.error.serverException",
        defaultMessage: "An unexpected error occurred. Please try again later."
    },
    pageNotFound: {
        id: "live-pages-features.converttolivepage.modal.error.pageNotFound",
        // TODO: Fix the direction of the curly quote below. (see go/curlyquotes)
        // eslint-disable-next-line no-restricted-syntax
        defaultMessage: "The page you\u2019re trying to edit doesn\u2018t exist."
    },
    contentServiceException: {
        id: "live-pages-features.converttolivepage.modal.error.contentServiceException",
        defaultMessage: "The requested content is not available."
    },
    pageAlreadyLive: {
        id: "live-pages-features.converttolivepage.modal.error.pageAlreadyLive",
        defaultMessage: "This page has already been switched to a live page."
    },
    legacyPageConversionError: {
        id: "live-pages-features.converttolivepage.modal.error.legacyPageConversionError",
        defaultMessage: "This page can\u2019t be switched to a live page due to its outdated format."
    },
    noEditPermissions: {
        id: "live-pages-features.converttolivepage.modal.error.noEditPermissions",
        defaultMessage: "You don\u2019t have the necessary permissions to switch this to a live page."
    },
    draftTitleConflict: {
        id: "live-pages-features.converttolivepage.draft-conversion-title-conflict.description",
        defaultMessage: "There\u2019s already content named \u201C{pageTitle}\u201D in this space. Give this page a unique title."
    },
    viewScreenTitleConflict: {
        id: "live-pages-features.converttolivepage.modal.error.view-screen-conversion-title-conflict",
        defaultMessage: "There\u2019s already content with this page\u2019s updated title in the space. Give this page a unique title."
    }
});
const $49d66c83bc63de25$var$i18nLiveDocs = (0, $kSwu1.defineMessages)({
    pageAlreadyLive: {
        id: "live-pages-features.converttolivepage.modal.error.pageAlreadyLive.livedocs",
        defaultMessage: "This page has already been converted to a live doc."
    },
    legacyPageConversionError: {
        id: "live-pages-features.converttolivepage.modal.error.legacyPageConversionError.livedocs",
        defaultMessage: "This page can\u2019t be converted to a live doc due to its outdated format."
    },
    noEditPermissions: {
        id: "live-pages-features.converttolivepage.modal.error.noEditPermissions.livedocs",
        defaultMessage: "You don\u2019t have the necessary permissions to convert this to a live doc."
    },
    draftTitleConflict: {
        id: "live-pages-features.converttolivepage.draft-conversion-title-conflict.description.livedocs",
        defaultMessage: "There\u2019s already content named \u201C{pageTitle}\u201D in this space. Give this page a unique title."
    }
});
const $49d66c83bc63de25$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($49d66c83bc63de25$var$i18nBase, $49d66c83bc63de25$var$i18nLiveDocs);
const $49d66c83bc63de25$var$BACKEND_ERROR_MESSAGES_BY_KEY = {
    serverException: 'Some server exception',
    pageNotFound: 'Page not found with provided id',
    contentServiceException: 'Content service exception',
    pageAlreadyLive: 'Page subtype is already set to live',
    legacyPageConversionError: 'Legacy page cannot be converted to live edit',
    noEditPermissions: 'Page cannot be converted without edit permissions',
    draftTitleConflict: 'Title already exists'
};
const $49d66c83bc63de25$var$BACKEND_ERROR_KEYS_BY_MESSAGE = Object.entries($49d66c83bc63de25$var$BACKEND_ERROR_MESSAGES_BY_KEY).reduce((acc, [key, value])=>({
        ...acc,
        [value]: key
    }), {});
const $49d66c83bc63de25$var$HANDLED_BACKEND_ERROR_MESSAGES = [
    $49d66c83bc63de25$var$BACKEND_ERROR_MESSAGES_BY_KEY.draftTitleConflict,
    $49d66c83bc63de25$var$BACKEND_ERROR_MESSAGES_BY_KEY.pageAlreadyLive,
    $49d66c83bc63de25$var$BACKEND_ERROR_MESSAGES_BY_KEY.noEditPermissions,
    $49d66c83bc63de25$var$BACKEND_ERROR_MESSAGES_BY_KEY.pageNotFound
];
const $49d66c83bc63de25$export$55d2d97fdb72d6e6 = (errorMessage)=>{
    return $49d66c83bc63de25$export$a7357cdd1f0b0168[$49d66c83bc63de25$var$BACKEND_ERROR_KEYS_BY_MESSAGE[errorMessage]] || $49d66c83bc63de25$export$a7357cdd1f0b0168.unknownError;
};
const $49d66c83bc63de25$export$ad03839ff2e809af = (error, contentId)=>{
    (0, $fJlJm.setContentErrorAttributes)(error, {
        objectId: contentId
    });
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).PAGE_MODES
    });
};
const $49d66c83bc63de25$export$83457a6c00af4df7 = (error, contentId)=>{
    let normalizedError;
    if (error instanceof Error || error instanceof (0, $422HI.ApolloErrorInterop)) normalizedError = error;
    else {
        // NOTE: Mutation errors from conversion have a null prototype, causing some below checks to throw an error because `hasOwnProperty` doesn't exist.
        //       Wrapping in a new Error retains original context and ensures the error contains `hasOwnProperty`, so we can handle the errors we're passed without issue.
        normalizedError = new Error(error?.message || 'Unknown error');
        if ('__typename' in error && error?.__typename) normalizedError.name = error?.__typename;
    }
    const isHandledConversionError = $49d66c83bc63de25$var$HANDLED_BACKEND_ERROR_MESSAGES.includes(normalizedError.message);
    if ((0, $1uFM6.isUnauthorizedError)(normalizedError) || (0, $6fil2.containsNetworkError)(normalizedError) || isHandledConversionError) {
        (0, $7Sm4c.markErrorAsHandled)(normalizedError);
        return {
            isHandled: true
        };
    } else {
        $49d66c83bc63de25$export$ad03839ff2e809af(normalizedError, contentId);
        return {
            isHandled: false
        };
    }
};
module.exports["i18n"] = $49d66c83bc63de25$export$a7357cdd1f0b0168;
module.exports["getI18nStringForError"] = $49d66c83bc63de25$export$55d2d97fdb72d6e6;
module.exports["processError"] = $49d66c83bc63de25$export$83457a6c00af4df7;

});

parcelRegister("9BVDK", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02b364a2e855ad9d$export$20020b6b9f67a9ec = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "N5Ue8",
    name: "ResolvedInlineCommentsCounterLoader",
    loader: async ()=>(await (parcelRequire("1UGoe"))).ResolvedInlineCommentsCounter
});
module.exports["ResolvedInlineCommentsCounterLoader"] = $02b364a2e855ad9d$export$20020b6b9f67a9ec;

});

parcelRegister("1UGoe", function(module, exports) {

let $164be720e616bf86$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $164be720e616bf86$var$load("aS96v").then(()=>parcelRequire('79cvA'));

});

parcelRegister("l3C2L", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ff94b9918380dc5d$export$cc6c027a319af205 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "9P0ef",
    name: "ViewChangesDialogLoader",
    loader: async ()=>(await (parcelRequire("7ZA6D"))).ViewChangesDialog
});
module.exports["ViewChangesDialogLoader"] = $ff94b9918380dc5d$export$cc6c027a319af205;

});

parcelRegister("7ZA6D", function(module, exports) {

let $5d1a3cd258c0dc56$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5d1a3cd258c0dc56$var$load("lJJQ8").then(()=>parcelRequire('iDTLl'));

});

parcelRegister("d8oE8", function(module, exports) {
const $305fd3cd961d4815$export$bd41ea3025fc88df = (push, contentType, spaceKey, contentId, contentStatus)=>{
    if (!contentType || !contentId) return;
    const isBlogPost = contentType === 'blogpost';
    const isCreate = contentStatus === 'draft';
    if (isBlogPost && !isCreate) push(`${window.location.origin}/wiki/spaces/${spaceKey}/blog/edit/${contentId}`);
    else if (!isCreate) push(`${window.location.origin}/wiki/spaces/${spaceKey}/pages/edit/${contentId}`);
    else push(`${window.location.origin}/wiki/spaces/${spaceKey}/pages/create?draftId=${contentId}`);
};
module.exports["onClickPageRevert"] = $305fd3cd961d4815$export$bd41ea3025fc88df;

});

parcelRegister("c54hr", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $8s9DV.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $kBr4q.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $kBr4q.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("1PC5x", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $297029061926b2dd$export$77691412571457f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8jq35",
    name: "LinkToThisPageDialog",
    loader: async ()=>(await (parcelRequire("j60e9"))).LinkToThisPageDialog
});
module.exports["LinkToThisPageDialog"] = $297029061926b2dd$export$77691412571457f;

});

parcelRegister("j60e9", function(module, exports) {

let $de6ec100de58111d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $de6ec100de58111d$var$load("Wowvf"),
    $de6ec100de58111d$var$load("iWnyc"),
    $de6ec100de58111d$var$load("hhss7"),
    $de6ec100de58111d$var$load("dXoLf")
]).then(()=>parcelRequire('gaLJH'));

});

parcelRegister("82Ooj", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $7W8i8 = parcelRequire("7W8i8");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $3802aca2c5107012$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    livePagesEditModeFlagTitle: {
        id: "live-pages-features.live-pages.edit-mode-flag.title.livedocs",
        defaultMessage: "You\u2019re editing this live doc"
    },
    livePagesEditModeFlagDescription: {
        id: "live-pages-features.live-pages.edit-mode-flag.description",
        defaultMessage: "Tip: To switch to viewing only, use the keyboard shortcut {keyCombination}."
    },
    livePagesViewModeFlagTitle: {
        id: "live-pages-features.live-pages.view-mode-flag.title.livedocs",
        defaultMessage: "You\u2019re viewing this live doc"
    },
    livePagesViewModeFlagDescription: {
        id: "live-pages-features.live-pages.view-mode-flag.description",
        defaultMessage: "Tip: To start editing, select {keyCombination} on your keyboard."
    }
});
const $3802aca2c5107012$export$f1bb393ced142bbb = (flags)=>{
    const intl = (0, $kSwu1.useIntl)();
    const logger = (0, $7W8i8.getLogger)('editor-mainbuttons-livepage-modechanger');
    const hasLivePageModeFlagBeenShown = (mode)=>{
        try {
            const flagsShown = JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).LIVE_PAGES_MODE_SWITCHING_FLAG_SHOWN) || '{}');
            return flagsShown[mode] === true;
        } catch (error) {
            logger.error`Error checking if live page mode flag has been shown for mode: "${mode}". Reason: ${error.message}`;
            return false;
        }
    };
    const setLivePageModeFlagAsShown = (mode)=>{
        try {
            const flagsShown = JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).LIVE_PAGES_MODE_SWITCHING_FLAG_SHOWN) || '{}');
            flagsShown[mode] = true;
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).LIVE_PAGES_MODE_SWITCHING_FLAG_SHOWN, JSON.stringify(flagsShown));
        } catch (error) {
            logger.error`Error setting live page mode flag as shown for mode: "${mode}". Reason: ${error.message}`;
        }
    };
    const modeDetails = {
        view: {
            title: intl.formatMessage($3802aca2c5107012$export$a7357cdd1f0b0168.livePagesViewModeFlagTitle),
            description: intl.formatMessage($3802aca2c5107012$export$a7357cdd1f0b0168.livePagesViewModeFlagDescription, {
                keyCombination: (0, $4tOXV.getShortcutString)((0, $gnkil.LIVE_PAGE_MODE_SWITCH_TO_EDIT), intl.formatMessage)
            })
        },
        edit: {
            title: intl.formatMessage($3802aca2c5107012$export$a7357cdd1f0b0168.livePagesEditModeFlagTitle),
            description: intl.formatMessage($3802aca2c5107012$export$a7357cdd1f0b0168.livePagesEditModeFlagDescription, {
                keyCombination: (0, $4tOXV.getShortcutString)((0, $gnkil.LIVE_PAGE_MODE_SWITCH_TO_VIEW), intl.formatMessage)
            })
        }
    };
    const showLivePageModeFlag = (newMode)=>{
        const selectedModeDetails = modeDetails[newMode];
        if (selectedModeDetails) {
            if (!hasLivePageModeFlagBeenShown(newMode)) {
                const { title: title, description: description } = selectedModeDetails;
                const flagId = 'live-pages-mode-flag';
                // hide any flags that are currently showing
                flags.hideFlag(flagId);
                flags.showFlag({
                    id: flagId,
                    title: title,
                    description: description,
                    close: 'auto'
                });
                setLivePageModeFlagAsShown(newMode);
            }
        }
    };
    return {
        showLivePageModeFlag: showLivePageModeFlag
    };
};
module.exports["useLivePageModeFlag"] = $3802aca2c5107012$export$f1bb393ced142bbb;

});

parcelRegister("5KL6w", function(module, exports) {
$parcel$export(module.exports, "usePresenterModeContext", () => (parcelRequire("l1b8J")).usePresenterModeContext);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $3HHS0 = parcelRequire("3HHS0");


var $l1b8J = parcelRequire("l1b8J");


const $51949aafbfeff0f9$export$d9be451d5ed0cecd = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "qz-Pe",
    name: "PresenterModeContextProvider",
    loader: async ()=>(await Promise.resolve((parcelRequire("l1b8J")))).PresenterModeContextProvider
});

const $51949aafbfeff0f9$export$62fbe81a4ea288fa = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "P5ZKu",
    name: "LazyPresenterModeContextConsumer",
    loader: async ()=>(await Promise.resolve((parcelRequire("l1b8J")))).PresenterModeContextConsumer,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3HHS0.PresentationModePlaceholder), null)
});
module.exports["PresenterModeContextProvider"] = $51949aafbfeff0f9$export$d9be451d5ed0cecd;
module.exports["LazyPresenterModeContextConsumer"] = $51949aafbfeff0f9$export$62fbe81a4ea288fa;

});

parcelRegister("3HHS0", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $667e8b8d9015d9ff$export$a718db6ba6835b50 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: '40px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            alignItems: 'center',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            boxSizing: 'border-box'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: '17px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: '10%'
        }
    }));
};
module.exports["PresentationModePlaceholder"] = $667e8b8d9015d9ff$export$a718db6ba6835b50;

});

parcelRegister("l1b8J", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $d3MrN = parcelRequire("d3MrN");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7J5Uc = parcelRequire("7J5Uc");


var $8uOqu = parcelRequire("8uOqu");

const $fb6fb6e8473a5f8b$var$PresenterModeContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    isPresenterModeActive: false,
    isBrowserFullscreen: false,
    hasEnteredPresentMode: false,
    presenterModeContextError: null,
    isPresenterModeEnabled: false,
    enterPresenterMode: ()=>{
    // Intentional no-op
    },
    exitPresenterMode: ()=>{
    // Intentional no-op
    },
    setPresenterModeContextError: ()=>{
    // Intentional no-op
    },
    enterBrowserFullscreen: ()=>{
    // Intentional no-op
    },
    enterSystemFullscreen: ()=>{
    // Intentional no-op
    },
    setIsBrowserFullscreen: ()=>{
    // Intentional no-op
    },
    setHasEnteredPresentMode: ()=>{
    // Intentional no-op
    }
});
const $fb6fb6e8473a5f8b$export$d9be451d5ed0cecd = ({ children: children, contentId: contentId, spaceKey: spaceKey })=>{
    const [isPresenterModeActive, setIsPresenterModeActive] = (0, $cozmU.useState)(false);
    const [isBrowserFullscreen, setIsBrowserFullscreen] = (0, $cozmU.useState)(false);
    const [presenterModeContextError, setPresenterModeContextError] = (0, $cozmU.useState)(null);
    const [hasEnteredPresentMode, setHasEnteredPresentMode] = (0, $cozmU.useState)(false);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { restoreThemePreference: restoreThemePreference } = (0, $7J5Uc.useThemingActions)();
    const enterBrowserFullscreen = (0, $cozmU.useCallback)(()=>{
        setIsBrowserFullscreen(true);
    }, []);
    const handleFullScreenApiError = (0, $cozmU.useCallback)((error)=>{
        enterBrowserFullscreen();
        setPresenterModeContextError(error);
    }, [
        setPresenterModeContextError,
        enterBrowserFullscreen
    ]);
    const fscreenRequestFullscreen = (0, $cozmU.useCallback)(()=>{
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        return Promise.resolve((0, $d3MrN.default).requestFullscreen(document.documentElement));
    }, []);
    const fscreenExitFullscreen = (0, $cozmU.useCallback)(()=>{
        return Promise.resolve((0, $d3MrN.default).exitFullscreen());
    }, []);
    const isPresenterModeEnabled = (0, $d3MrN.default).fullscreenEnabled;
    const enterPresenterMode = (0, $cozmU.useCallback)(()=>{
        setHasEnteredPresentMode(true);
        experienceTracker.start({
            name: (0, $irVI7.PRESENTER_MODE_FULLSCREEN_API_EXPERIENCE)
        });
        (0, $d3MrN.default).addEventListener('fullscreenerror', handleFullScreenApiError, false);
        setIsPresenterModeActive(true);
        setPresenterModeContextError(null);
        if (!isPresenterModeEnabled) {
            const error = new Error('Fullscreen mode is not supported');
            handleFullScreenApiError(error);
            enterBrowserFullscreen();
            return;
        }
        if ((0, $d3MrN.default).fullscreenElement) fscreenExitFullscreen().then(fscreenRequestFullscreen).then(()=>{
            experienceTracker.succeed({
                name: (0, $irVI7.PRESENTER_MODE_VIEW_EXPERIENCE)
            });
        }).catch(enterBrowserFullscreen);
        else fscreenRequestFullscreen().then(()=>{
            experienceTracker.succeed({
                name: (0, $irVI7.PRESENTER_MODE_VIEW_EXPERIENCE)
            });
        }).catch(enterBrowserFullscreen);
    }, [
        experienceTracker,
        fscreenRequestFullscreen,
        isPresenterModeEnabled,
        fscreenExitFullscreen,
        handleFullScreenApiError,
        enterBrowserFullscreen,
        setHasEnteredPresentMode
    ]);
    const enterSystemFullscreen = (0, $cozmU.useCallback)(()=>{
        setIsBrowserFullscreen(false);
        enterPresenterMode();
    }, [
        enterPresenterMode
    ]);
    const exitPresenterMode = (0, $cozmU.useCallback)(()=>{
        setIsPresenterModeActive(false);
        (0, $d3MrN.default).removeEventListener('fullscreenerror', handleFullScreenApiError, false);
        restoreThemePreference();
    }, [
        setIsPresenterModeActive,
        handleFullScreenApiError,
        restoreThemePreference
    ]);
    const data = (0, $cozmU.useMemo)(()=>({
            isPresenterModeActive: isPresenterModeActive,
            isBrowserFullscreen: isBrowserFullscreen,
            hasEnteredPresentMode: hasEnteredPresentMode,
            enterPresenterMode: enterPresenterMode,
            exitPresenterMode: exitPresenterMode,
            isPresenterModeEnabled: isPresenterModeEnabled,
            presenterModeContextError: presenterModeContextError,
            setPresenterModeContextError: setPresenterModeContextError,
            enterBrowserFullscreen: enterBrowserFullscreen,
            setIsBrowserFullscreen: setIsBrowserFullscreen,
            enterSystemFullscreen: enterSystemFullscreen,
            setHasEnteredPresentMode: setHasEnteredPresentMode
        }), [
        isPresenterModeActive,
        isBrowserFullscreen,
        hasEnteredPresentMode,
        enterPresenterMode,
        exitPresenterMode,
        isPresenterModeEnabled,
        presenterModeContextError,
        setPresenterModeContextError,
        enterBrowserFullscreen,
        setIsBrowserFullscreen,
        enterSystemFullscreen,
        setHasEnteredPresentMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fb6fb6e8473a5f8b$var$PresenterModeContext.Provider, {
        value: data
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8uOqu.PresenterModeWrapper), {
        contentId: contentId,
        spaceKey: spaceKey
    }));
};
const $fb6fb6e8473a5f8b$export$5b228b85ce187234 = ()=>{
    return (0, $cozmU.useContext)($fb6fb6e8473a5f8b$var$PresenterModeContext);
};
const $fb6fb6e8473a5f8b$export$530d225c8bef9444 = ({ children: children })=>{
    const { enterPresenterMode: enterPresenterMode } = $fb6fb6e8473a5f8b$export$5b228b85ce187234();
    return children(enterPresenterMode);
};
module.exports["PresenterModeContextProvider"] = $fb6fb6e8473a5f8b$export$d9be451d5ed0cecd;
module.exports["usePresenterModeContext"] = $fb6fb6e8473a5f8b$export$5b228b85ce187234;
module.exports["PresenterModeContextConsumer"] = $fb6fb6e8473a5f8b$export$530d225c8bef9444;

});

parcelRegister("d3MrN", function(module, exports) {
var $982122d42c7c3a7b$var$key = {
    fullscreenEnabled: 0,
    fullscreenElement: 1,
    requestFullscreen: 2,
    exitFullscreen: 3,
    fullscreenchange: 4,
    fullscreenerror: 5,
    fullscreen: 6
};
var $982122d42c7c3a7b$var$webkit = [
    'webkitFullscreenEnabled',
    'webkitFullscreenElement',
    'webkitRequestFullscreen',
    'webkitExitFullscreen',
    'webkitfullscreenchange',
    'webkitfullscreenerror',
    '-webkit-full-screen'
];
var $982122d42c7c3a7b$var$moz = [
    'mozFullScreenEnabled',
    'mozFullScreenElement',
    'mozRequestFullScreen',
    'mozCancelFullScreen',
    'mozfullscreenchange',
    'mozfullscreenerror',
    '-moz-full-screen'
];
var $982122d42c7c3a7b$var$ms = [
    'msFullscreenEnabled',
    'msFullscreenElement',
    'msRequestFullscreen',
    'msExitFullscreen',
    'MSFullscreenChange',
    'MSFullscreenError',
    '-ms-fullscreen'
];
// so it doesn't throw if no window or document
var $982122d42c7c3a7b$var$document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};
var $982122d42c7c3a7b$var$vendor = 'fullscreenEnabled' in $982122d42c7c3a7b$var$document && Object.keys($982122d42c7c3a7b$var$key) || $982122d42c7c3a7b$var$webkit[0] in $982122d42c7c3a7b$var$document && $982122d42c7c3a7b$var$webkit || $982122d42c7c3a7b$var$moz[0] in $982122d42c7c3a7b$var$document && $982122d42c7c3a7b$var$moz || $982122d42c7c3a7b$var$ms[0] in $982122d42c7c3a7b$var$document && $982122d42c7c3a7b$var$ms || [];
var $982122d42c7c3a7b$var$fscreen = {
    requestFullscreen: function(element) {
        return element[$982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key.requestFullscreen]]();
    },
    requestFullscreenFunction: function(element) {
        return element[$982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key.requestFullscreen]];
    },
    get exitFullscreen () {
        return $982122d42c7c3a7b$var$document[$982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key.exitFullscreen]].bind($982122d42c7c3a7b$var$document);
    },
    get fullscreenPseudoClass () {
        return ":" + $982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key.fullscreen];
    },
    addEventListener: function(type, handler1, options) {
        return $982122d42c7c3a7b$var$document.addEventListener($982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key[type]], handler1, options);
    },
    removeEventListener: function(type, handler1, options) {
        return $982122d42c7c3a7b$var$document.removeEventListener($982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key[type]], handler1, options);
    },
    get fullscreenEnabled () {
        return Boolean($982122d42c7c3a7b$var$document[$982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key.fullscreenEnabled]]);
    },
    set fullscreenEnabled (val){},
    get fullscreenElement () {
        return $982122d42c7c3a7b$var$document[$982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key.fullscreenElement]];
    },
    set fullscreenElement (val){},
    get onfullscreenchange () {
        return $982122d42c7c3a7b$var$document[("on" + $982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key.fullscreenchange]).toLowerCase()];
    },
    set onfullscreenchange (handler){
        return $982122d42c7c3a7b$var$document[("on" + $982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key.fullscreenchange]).toLowerCase()] = handler;
    },
    get onfullscreenerror () {
        return $982122d42c7c3a7b$var$document[("on" + $982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key.fullscreenerror]).toLowerCase()];
    },
    set onfullscreenerror (handler){
        return $982122d42c7c3a7b$var$document[("on" + $982122d42c7c3a7b$var$vendor[$982122d42c7c3a7b$var$key.fullscreenerror]).toLowerCase()] = handler;
    }
};
var $982122d42c7c3a7b$export$2e2bcd8739ae039 = $982122d42c7c3a7b$var$fscreen;
module.exports["default"] = $982122d42c7c3a7b$export$2e2bcd8739ae039;

});

parcelRegister("8uOqu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $gqqjz = parcelRequire("gqqjz");


var $l1b8J = parcelRequire("l1b8J");


var $hMdkB = parcelRequire("hMdkB");

const $a1ce8cd657fbddc0$export$2a648297aa723519 = ({ contentId: contentId, spaceKey: spaceKey })=>{
    const { isPresenterModeActive: isPresenterModeActive, isBrowserFullscreen: isBrowserFullscreen } = (0, $l1b8J.usePresenterModeContext)();
    if (isPresenterModeActive || isBrowserFullscreen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMdkB.PresenterModePortal), {
            contentId: contentId,
            spaceKey: spaceKey,
            setFlagsVisibility: flags.setFlagsVisibility
        }));
    return null;
};
module.exports["PresenterModeWrapper"] = $a1ce8cd657fbddc0$export$2a648297aa723519;

});

parcelRegister("hMdkB", function(module, exports) {
/* PresenterModePortal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $d3MrN = parcelRequire("d3MrN");


var $1enXm = parcelRequire("1enXm");


var $cK21K = parcelRequire("cK21K");


var $lfoFx = parcelRequire("lfoFx");


var $jMyy4 = parcelRequire("jMyy4");


var $f9opb = parcelRequire("f9opb");

var $jgc4t = parcelRequire("jgc4t");


var $8rneB = parcelRequire("8rneB");


var $di8q4 = parcelRequire("di8q4");


var $e8Lxy = parcelRequire("e8Lxy");


var $cTIr3 = parcelRequire("cTIr3");


var $euF5O = parcelRequire("euF5O");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $cMvQV = parcelRequire("cMvQV");


var $Qlykt = parcelRequire("Qlykt");


var $ep3mz = parcelRequire("ep3mz");


var $kDhla = parcelRequire("kDhla");


var $chP0Z = parcelRequire("chP0Z");


var $j3Lh2 = parcelRequire("j3Lh2");


var $kXAIp = parcelRequire("kXAIp");


var $2jkzM = parcelRequire("2jkzM");


var $ibtF1 = parcelRequire("ibtF1");


var $7mDnI = parcelRequire("7mDnI");


var $gnyTR = parcelRequire("gnyTR");


var $l1b8J = parcelRequire("l1b8J");


var $fDEVM = parcelRequire("fDEVM");

const $bdd13d294a89f9eb$var$i18n = (0, $kSwu1.defineMessages)({
    genericErrorMessage: {
        id: "presentation-mode.portal.generic.error.message",
        defaultMessage: "Something\u2019s not right. Refresh and try again."
    }
});
const $bdd13d294a89f9eb$var$presenterModeContainerStyle = null;
const $bdd13d294a89f9eb$var$spacerStyle = null; /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
const $bdd13d294a89f9eb$var$titleFixedSpacingStyle = null; /* eslint-enable @atlaskit/design-system/use-tokens-typography */ 
const $bdd13d294a89f9eb$export$fa29436318a8d949 = 'presenter-mode-zoom-container';
const $bdd13d294a89f9eb$export$e1872a7bb3bd287c = 'presenter-mode-container';
const $bdd13d294a89f9eb$export$158030c0e49f9498 = 'presenter-mode-portal-container';
const $bdd13d294a89f9eb$export$750df9d29fdbd29f = 'presenter-mode-title-text';
const $bdd13d294a89f9eb$export$9439b54f8681bb48 = 'presenter-mode-content-container';
const $bdd13d294a89f9eb$export$4d12947f8edb059f = 'presenter-mode-content-container-bottom-spacer';
(0, $cMvQV.setUserAgent)();
const $bdd13d294a89f9eb$var$legacyMacroRendererContextValue = {
    shouldRefetchMacroQuery: true
};
const $bdd13d294a89f9eb$var$presenterModeStickyHeaders = {
    offsetTop: 0
}; /**
    * This component encapsulates the actual presenter mode experience. It's responsible
    * for rendering the nav bar and the content itself, which it gets via GraphQL.
    * Everything is placed within a Portal component which is rendered on top of the page.
    */ 
const $bdd13d294a89f9eb$export$c815374aa38c89e7 = ({ contentId: contentId, spaceKey: spaceKey, setFlagsVisibility: setFlagsVisibility })=>{
    const [isCustomCursorActive, setIsCustomCursorActive] = (0, $cozmU.useState)(true);
    const [contentRendered, setContentRendered] = (0, $cozmU.useState)(false);
    const [editorContent, setEditorContent] = (0, $cozmU.useState)();
    const { isBrowserFullscreen: isBrowserFullscreen } = (0, $l1b8J.usePresenterModeContext)();
    const [{ fullPageEditorPresetAPI: editorApi }] = (0, $kDhla.useFullPageEditorApi)();
    const intl = (0, $kSwu1.useIntl)();
    const handleSwitchCursor = (newValue)=>setIsCustomCursorActive(newValue); // Prevent scrolling of content underneath the portal
    (0, $j3Lh2.useLockBodyScroll)(); // Handles entering/exiting fullscreen mode
    (0, $chP0Z.useFullscreenMode)();
    (0, $cozmU.useEffect)(()=>{
        editorApi?.core.actions.requestDocument((doc)=>{
            setEditorContent(doc);
        });
    }, [
        editorApi
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isBrowserFullscreen) (0, $d3MrN.default).exitFullscreen();
    }, [
        isBrowserFullscreen
    ]); // Handles hiding flags while in Presenter Mode
    (0, $kXAIp.useHideFlags)(setFlagsVisibility);
    const [contentType] = (0, $ep3mz.useContentType)();
    const isBlogpost = contentType === 'blogpost';
    const skipContentUnifiedQuery = !contentId || !spaceKey; // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(window.__SSR_RENDERED__);
    const pageContentUnifiedResult = (0, $jMyy4.useQueryInterop)((0, $jgc4t.default), {
        fetchPolicy: 'cache-first',
        context: {
            single: true
        },
        skip: skipContentUnifiedQuery || isBlogpost,
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            isSSR: isSSR,
            versionOverride: null
        },
        __callerPackage__: "presentation-mode"
    });
    const blogContentUnifiedResult = (0, $jMyy4.useQueryInterop)((0, $f9opb.default), {
        fetchPolicy: 'cache-first',
        context: {
            single: true
        },
        skip: skipContentUnifiedQuery || !isBlogpost,
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            isSSR: isSSR,
            versionOverride: null
        },
        __callerPackage__: "presentation-mode"
    });
    const { data: contentData, loading: contentLoading, error: contentUnifiedError } = isBlogpost ? blogContentUnifiedResult : pageContentUnifiedResult;
    const contentNode = contentData?.content?.nodes?.[0];
    const emojiTitle = (0, $8rneB.getEmojiFromPublishedPageProperties)(contentNode);
    const coverPictureProperty = contentNode?.properties?.nodes?.find((node)=>node?.key === 'cover-picture-id-published');
    const loading = contentLoading;
    const handleOnRenderedEvent = ()=>setContentRendered(true);
    const isTitleCenterAligned = (0, $fDEVM.useIsTitleCenterAligned)(contentId);
    const hasCoverPicture = !!coverPictureProperty;
    const hasEmoji = !!emojiTitle;
    const [viewportWidth, setViewportWidth] = (0, $cozmU.useState)(window.innerWidth);
    (0, $cozmU.useEffect)(()=>{
        const handleResize = ()=>{
            setViewportWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return ()=>window.removeEventListener('resize', handleResize);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
        zIndex: 519
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1enXm.default), {
        autoFocus: false,
        returnFocus: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COMMENTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.PresenterModePortalContainer), {
        id: $bdd13d294a89f9eb$export$158030c0e49f9498,
        isCustomCursorActive: isCustomCursorActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2jkzM.HeaderPresenterMode), {
        contentRendered: contentRendered,
        onSwitchCursorClick: handleSwitchCursor,
        contentId: contentId,
        spaceKey: spaceKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        id: $bdd13d294a89f9eb$export$e1872a7bb3bd287c,
        className: (0, $hekY6.default)([
            "_1bsb1osq"
        ])
    }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.LoadingContainer), {
        "data-testid": "presenter-mode-spinner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.SpinnerContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "large",
        interactionName: "presenter-mode-portal"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ibtF1.HeaderImage), {
        contentId: contentId,
        coverPictureProperty: coverPictureProperty
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.PresenterModeZoomContainer), {
        "data-testid": "presenter-mode-zoom-container",
        id: $bdd13d294a89f9eb$export$fa29436318a8d949,
        isFirefox: (0, $cMvQV.isFirefox)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.FlagsContainer), null, contentUnifiedError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7mDnI.ErrorFlag), {
        title: intl.formatMessage($bdd13d294a89f9eb$var$i18n.genericErrorMessage)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.TitleContainer), {
        id: $bdd13d294a89f9eb$export$750df9d29fdbd29f,
        "data-testid": "presenter-mode-title-container",
        hasCoverPicture: hasCoverPicture,
        isTitleCenterAligned: isTitleCenterAligned,
        hasEmoji: hasEmoji,
        width: viewportWidth
    }, emojiTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.EmojiWrapper), {
        hasCoverPicture: hasCoverPicture
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: emojiTitle,
        height: hasCoverPicture ? (0, $Qlykt.EMOJI_SIZE_LARGE) : (0, $Qlykt.EMOJI_SIZE_MEDIUM),
        hasCoverPicture: hasCoverPicture,
        isPageTitleComponent: true,
        context: "presenterMode",
        showTooltip: true,
        renderResourcedEmoji: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.TitleTextWrapper), {
        "data-testId": "titleTextWrapper",
        shouldAddLeftPadding: hasEmoji && !isTitleCenterAligned && !hasCoverPicture
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("h1", {
        className: (0, $hekY6.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _k48pbfng _syazi7uo _1nmz1hna _1i4q1hna _1tke1jfw _ca0q12x7 _1e0c1ule _1wybkogo _vwz4izfg _181zckbl _iavl8vuz _1ni8or1b _135cckbl"
        ])
    }, contentNode?.title ?? ''))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $euF5O.LegacyMacroRendererContext).Provider, {
        value: $bdd13d294a89f9eb$var$legacyMacroRendererContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e8Lxy.PageContentRenderer), {
        contentId: contentId,
        document: editorContent,
        data: contentData,
        onRendered: handleOnRenderedEvent,
        hasInlineComments: false,
        appearance: "full-page",
        stickyHeaders: $bdd13d294a89f9eb$var$presenterModeStickyHeaders,
        spaceKey: spaceKey,
        isPresentational: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        id: $bdd13d294a89f9eb$export$4d12947f8edb059f,
        className: (0, $hekY6.default)([
            "_4t3i12am"
        ])
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cTIr3.LazyQRCodeGenerator), {
        contentId: contentId,
        spaceKey: spaceKey
    })))));
};
module.exports["PresenterModeZoomContainerId"] = $bdd13d294a89f9eb$export$fa29436318a8d949;
module.exports["PresenterModeContainerId"] = $bdd13d294a89f9eb$export$e1872a7bb3bd287c;
module.exports["PresenterModePortalContainerId"] = $bdd13d294a89f9eb$export$158030c0e49f9498;
module.exports["PresenterModePageTitleId"] = $bdd13d294a89f9eb$export$750df9d29fdbd29f;
module.exports["PresenterModeBottomSpacerId"] = $bdd13d294a89f9eb$export$4d12947f8edb059f;
module.exports["PresenterModePortal"] = $bdd13d294a89f9eb$export$c815374aa38c89e7;

});

parcelRegister("cTIr3", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lfoFx = parcelRequire("lfoFx");


var $jmjWc = parcelRequire("jmjWc");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2fa2236fe735b9be$var$SpinnerContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1osq _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $2fa2236fe735b9be$var$LoadingSpinner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2fa2236fe735b9be$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "large"
    }));

const $2fa2236fe735b9be$export$c545dc5a218e1111 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "mUAtU",
    name: "LazyQRCodeGenerator",
    loader: async ()=>(await (parcelRequire("kP5tp"))).QRCodeComponent,
    loading: $2fa2236fe735b9be$var$LoadingSpinner
});
module.exports["LazyQRCodeGenerator"] = $2fa2236fe735b9be$export$c545dc5a218e1111;

});

parcelRegister("kP5tp", function(module, exports) {

let $f28cd0f37a03f89e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f28cd0f37a03f89e$var$load("6wr18"),
    $f28cd0f37a03f89e$var$load("ffEVr"),
    $f28cd0f37a03f89e$var$load("2nHxT")
]).then(()=>parcelRequire('5RnXN'));

});

parcelRegister("chP0Z", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $d3MrN = parcelRequire("d3MrN");


var $l1b8J = parcelRequire("l1b8J");

const $a7ed65c805684c1a$export$5306b0eb80cf6407 = ()=>{
    const { exitPresenterMode: exitPresenterMode } = (0, $l1b8J.usePresenterModeContext)();
    (0, $cozmU.useEffect)(()=>{
        // Event handler for when entering/exiting fullscreen mode
        const handleFullscreenChange = ()=>{
            /**
       * This handles the case where the user has pressed Esc instead of using
       * the "Exit" button to close presenter mode. In this case, the browser
       * will be forced out of fullscreen mode, but presenter mode will still
       * technically be active, so we need to listen for the event to make
       * sure we exit presenter mode.
       */ if (!(0, $d3MrN.default).fullscreenElement) exitPresenterMode();
        };
        (0, $d3MrN.default).addEventListener('fullscreenchange', handleFullscreenChange, false);
        return ()=>{
            /**
       * This handles the common case where the user clicks the "Exit" button to close
       * presenter mode, which will cause this callback to run.
       */ if ((0, $d3MrN.default).fullscreenElement) (0, $d3MrN.default).exitFullscreen();
            (0, $d3MrN.default).removeEventListener('fullscreenchange', handleFullscreenChange, false);
        };
    }, [
        exitPresenterMode
    ]);
};
module.exports["useFullscreenMode"] = $a7ed65c805684c1a$export$5306b0eb80cf6407;

});

parcelRegister("j3Lh2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $e231207f12babf5b$export$bd4ec12442706c3d = ()=>{
    (0, $cozmU.useLayoutEffect)(()=>{
        const originalStyle = window.getComputedStyle(document.body).overflow;
        document.body.style.overflow = 'hidden';
        return ()=>{
            document.body.style.overflow = originalStyle;
        };
    }, []);
};
module.exports["useLockBodyScroll"] = $e231207f12babf5b$export$bd4ec12442706c3d;

});

parcelRegister("kXAIp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $731701c7a4a3e42e$export$3fe03aa4ff5dc935 = (setFlagsVisibility)=>{
    (0, $cozmU.useEffect)(()=>{
        setFlagsVisibility(false);
        return ()=>{
            setFlagsVisibility(true);
        };
    }, [
        setFlagsVisibility
    ]);
};
module.exports["useHideFlags"] = $731701c7a4a3e42e$export$3fe03aa4ff5dc935;

});

parcelRegister("2jkzM", function(module, exports) {
/* HeaderPresenterMode.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $9DHhW = parcelRequire("9DHhW");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $7QM6o = parcelRequire("7QM6o");


var $3IVqo = parcelRequire("3IVqo");


var $gnyTR = parcelRequire("gnyTR");


var $9BWGi = parcelRequire("9BWGi");


var $l1b8J = parcelRequire("l1b8J");

const $66cd5922db697139$export$ef625543408b2447 = 'presenter-mode-control-panel';
const $66cd5922db697139$var$headerContainerStyles = null;
const $66cd5922db697139$var$verticalDividerStyles = null;
const $66cd5922db697139$var$rightControlPanelStyles = null;
const $66cd5922db697139$var$i18n = (0, $kSwu1.defineMessages)({
    exit: {
        id: "presentation-mode.header.exit",
        defaultMessage: "Exit"
    }
});
const $66cd5922db697139$export$c7c42ad700a3285 = ({ onSwitchCursorClick: onSwitchCursorClick, contentRendered: contentRendered, spaceKey: spaceKey, contentId: contentId })=>{
    const { exitPresenterMode: exitPresenterMode, isBrowserFullscreen: isBrowserFullscreen, setIsBrowserFullscreen: setIsBrowserFullscreen } = (0, $l1b8J.usePresenterModeContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const intl = (0, $kSwu1.useIntl)();
    const [showLazyButtons, setShowLazyButtons] = (0, $cozmU.useState)(false);
    const spaceId = (0, $7QM6o.useSpaceId)(spaceKey);
    (0, $cozmU.useEffect)(()=>{
        const timeout = setTimeout(()=>{
            setShowLazyButtons(true);
        }, 0);
        return ()=>{
            clearTimeout(timeout);
        };
    }, []);
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'viewPresentScreen',
                attributes: {
                    objectId: contentId,
                    containerId: spaceId
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        spaceId
    ]);
    const exit = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'present',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'close',
                objectId: contentId,
                containerId: spaceId
            }
        }).fire();
        exitPresenterMode();
    }, [
        createAnalyticsEvent,
        exitPresenterMode,
        contentId,
        spaceId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COMMENTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3IVqo.ControlPanelContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "presentation-mode-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        id: $66cd5922db697139$export$ef625543408b2447,
        className: (0, $hekY6.default)([
            "_1yt4utpp _2rko12b0 _4cvr1h6o _bfhk1bhr _kqsw1n9t _154i1ejb _1xi21ejb _1e0c1txw _1pby9y44 _16qs130s"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_18u01wug _1e0c1txw _1bahesu3 _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9BWGi.LazyNavigation), {
        contentRendered: contentRendered,
        contentId: contentId,
        spaceKey: spaceKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1kl7ia51 _4t3i1tcg _1bsbidpf"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9BWGi.LazySettingsMenu), {
        onSwitchCursorClick: onSwitchCursorClick,
        contentId: contentId,
        spaceKey: spaceKey
    }), contentRendered && showLazyButtons && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.ButtonContainer), {
        id: "presenter-mode-exit-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        testId: "presentation-mode-button-close",
        onClick: isBrowserFullscreen ? ()=>setIsBrowserFullscreen(false) : exit
    }, intl.formatMessage($66cd5922db697139$var$i18n.exit))))))));
};
module.exports["HeaderControlPanel"] = $66cd5922db697139$export$ef625543408b2447;
module.exports["HeaderPresenterMode"] = $66cd5922db697139$export$c7c42ad700a3285;

});

parcelRegister("3IVqo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $969cdac05668aa2c$var$ControlPanelContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    isSettingsOpen: false,
    setIsSettingsOpen: ()=>{
    // Intentional no-op
    },
    isNavigationMenuOpen: false,
    setIsNavigationMenuOpen: ()=>{
    // Intentional no-op
    },
    width: '1'
});
const $969cdac05668aa2c$export$a5457ef551a7a8bf = ({ children: children })=>{
    const [isSettingsOpen, setIsSettingsOpen] = (0, $cozmU.useState)(false);
    const [isNavigationMenuOpen, setIsNavigationMenuOpen] = (0, $cozmU.useState)(false);
    const [width, setWidth] = (0, $cozmU.useState)('1');
    const headerWidth = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.getElementById('presenter-mode-control-panel')?.getBoundingClientRect().width || 242;
    (0, $cozmU.useEffect)(()=>{
        setWidth(headerWidth.toString());
    }, [
        headerWidth
    ]);
    const data = (0, $cozmU.useMemo)(()=>({
            isSettingsOpen: isSettingsOpen,
            setIsSettingsOpen: setIsSettingsOpen,
            isNavigationMenuOpen: isNavigationMenuOpen,
            setIsNavigationMenuOpen: setIsNavigationMenuOpen,
            width: width
        }), [
        isSettingsOpen,
        setIsSettingsOpen,
        isNavigationMenuOpen,
        setIsNavigationMenuOpen,
        width
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($969cdac05668aa2c$var$ControlPanelContext.Provider, {
        value: data
    }, children);
};
const $969cdac05668aa2c$export$7a069434e96a0028 = ()=>{
    return (0, $cozmU.useContext)($969cdac05668aa2c$var$ControlPanelContext);
};
module.exports["ControlPanelContextProvider"] = $969cdac05668aa2c$export$a5457ef551a7a8bf;
module.exports["useControlPanelContext"] = $969cdac05668aa2c$export$7a069434e96a0028;

});

parcelRegister("gnyTR", function(module, exports) {
/* presenterModeStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $Qlykt = parcelRequire("Qlykt");


var $O8fsx = parcelRequire("O8fsx");

const $72178c9eda154f79$var$screenSizeXS = 1080;
const $72178c9eda154f79$var$screenSizeS = 1280;
const $72178c9eda154f79$var$screenSizeM = 1536;
const $72178c9eda154f79$var$screenSizeL = 2560;
const $72178c9eda154f79$var$screenSizeHeaderImageBreakpoint = 1792;
const $72178c9eda154f79$var$CALCULATE_SCALED_COVER_IMAGE_HEIGHT_PRESENTER_MODE = 'min(max(calc(100vw * (7 / 38)), 140px), 750px)';
const $72178c9eda154f79$export$5aeddb36a71179f1 = -122;
const $72178c9eda154f79$export$18d6dec26df5efab = -104;
const $72178c9eda154f79$export$5cbab9ac5bb5eb6 = -95;
const $72178c9eda154f79$export$9efff5a152b2c8b9 = -82;
const $72178c9eda154f79$var$zoomLevelXSToM = 1.3;
const $72178c9eda154f79$var$zoomLevelL = 2;
const $72178c9eda154f79$var$cursorImage = `url(${(0, (/*@__PURE__*/$parcel$interopDefault($O8fsx)))}), auto`;
const $72178c9eda154f79$var$headerImageMediaQuery = {
    [`@media only screen and (min-width: ${$72178c9eda154f79$var$screenSizeHeaderImageBreakpoint}px)`]: {
        height: '360px'
    },
    [`@media only screen and (min-width: ${$72178c9eda154f79$var$screenSizeM}px) and (max-width: ${$72178c9eda154f79$var$screenSizeHeaderImageBreakpoint}px)`]: {
        height: '240px'
    },
    [`@media only screen and (max-width: ${$72178c9eda154f79$var$screenSizeM}px)`]: {
        height: '240px'
    }
};
const $72178c9eda154f79$export$ec38912285043019 = '1.5';
const $72178c9eda154f79$export$21d0e1ba36d5f647 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCustomCursorActive: isCustomCursorActive, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1db81y0": (0, $9aYkv.default)($72178c9eda154f79$var$cursorImage)
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1bsbauwl _4t3i1kxc _bfhkvuon _kqsw1n9t _154iidpf _1ltvidpf _18m915zi _1reo15vq _1e0c1txw _1bah1h6o _q087glyw _gkx1agmp _1d8vagmp _1wwi1h90 _1ekzagmp _lf671h6o _11e9xy5q _csjz1h6o _1322glyw",
            __cmplp.isCustomCursorActive ? "_80om1jqn" : "_80om1wug",
            __cmplp.isCustomCursorActive ? "_2ht7l61x" : "_2ht71h90",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$4b720caa3a1b5952 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11q7i8nm _4t3i1s3y _1bsbauwl _otyr1epz _w8m8ze3t _dju1n7od _114rn7od _1b191gwv _1vu6p3fh _uncbp3fh _1iws1osq _1wkr1osq _ajuzn7od _y2u91osq _bs5dze3t _nqf71gwv _1firp3fh _1lntp3fh _11u1p3fh _18le1gwv _1iawp3fh",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$141080fc4b582742 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_otyrxy5q _4t3i1w81",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$422f3370501bb5d5 = (scale, isFirefox)=>{
    return isFirefox ? `transform: scale(${scale})` : `zoom: ${scale};`;
};
const $72178c9eda154f79$export$354b8b07cc867365 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirefox: isFirefox, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _8hrzjp4b _199qukw8 _xrxq95ii _1yyl11bw _1ooqt82k",
            __cmplp.isFirefox ? "_gx1i18ws" : undefined,
            __cmplp.isFirefox ? undefined : "_1s5ecs5v",
            __cmplp.isFirefox ? "_jjcp113p" : undefined,
            __cmplp.isFirefox ? undefined : "_aengbs82",
            __cmplp.isFirefox ? "_a4xx19xa" : undefined,
            __cmplp.isFirefox ? undefined : "_1tkynqt0",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$5e3f251c730829 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _4t3i1kxc",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$35e09ba17cc51c69 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTitleCenterAligned: isTitleCenterAligned, hasCoverPicture: hasCoverPicture, hasEmoji: hasEmoji, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_18s81npk _1e0c1txw _vchhusvi _1tketudo _1bsb1osq _p12fukw8 _1nmz1hna _slp31hna",
            __cmplp.isTitleCenterAligned ? "_1bah1h6o" : "_1bah4jg8",
            __cmplp.isTitleCenterAligned || __cmplp.hasCoverPicture ? "_2lx21bp4" : "_2lx2vrvc",
            __cmplp.isTitleCenterAligned ? "_4cvr1h6o" : "_4cvr1q9y",
            __cmplp.hasCoverPicture || __cmplp.isTitleCenterAligned && __cmplp.hasEmoji ? "_zulppxbi" : "_zulp18uv",
            __cmplp.hasCoverPicture && __cmplp.hasEmoji ? "_19pk1f1f" : "_19pkidpf",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$f39f7ca4ec945bd5 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldAddLeftPadding: shouldAddLeftPadding, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "",
            __cmplp.shouldAddLeftPadding ? "_19bvutpp" : "_19bvn7od",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$var$emojiCoverPictureMaxWidth = (hasCoverPicture)=>hasCoverPicture ? `${0, $Qlykt.EMOJI_SIZE_LARGE}px` : `${0, $Qlykt.EMOJI_SIZE_MEDIUM}px`;
const $72178c9eda154f79$export$e31a6cc0a4c97f0e = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasCoverPicture: hasCoverPicture, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_mn762q": (0, $9aYkv.default)($72178c9eda154f79$var$emojiCoverPictureMaxWidth(__cmplp.hasCoverPicture))
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _1bah1h6o _p12fwy2t _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$1b225d69cabf8532 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1vfx15iw _1ltv1mxl _1ucm1ogm",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_18u0u2gc _1e0c1o8l",
            __cmplp.className
        ])
    });
});
const $72178c9eda154f79$export$a87575d1597be323 = (width)=>{
    if (!width || width < $72178c9eda154f79$var$screenSizeXS) return $72178c9eda154f79$export$5aeddb36a71179f1;
    else if (width < $72178c9eda154f79$var$screenSizeM) return $72178c9eda154f79$export$18d6dec26df5efab;
    else if (width < $72178c9eda154f79$var$screenSizeL) return $72178c9eda154f79$export$5cbab9ac5bb5eb6;
    else return $72178c9eda154f79$export$9efff5a152b2c8b9;
};
module.exports["mToLScreenZoomLevel"] = $72178c9eda154f79$export$ec38912285043019;
module.exports["PresenterModePortalContainer"] = $72178c9eda154f79$export$21d0e1ba36d5f647;
module.exports["HeaderImageContainer"] = $72178c9eda154f79$export$4b720caa3a1b5952;
module.exports["NoHeaderImageSpacer"] = $72178c9eda154f79$export$141080fc4b582742;
module.exports["PresenterModeZoomContainer"] = $72178c9eda154f79$export$354b8b07cc867365;
module.exports["LoadingContainer"] = $72178c9eda154f79$export$5e3f251c730829;
module.exports["SpinnerContainer"] = $72178c9eda154f79$export$a5e06607a5ac6158;
module.exports["TitleContainer"] = $72178c9eda154f79$export$35e09ba17cc51c69;
module.exports["TitleTextWrapper"] = $72178c9eda154f79$export$f39f7ca4ec945bd5;
module.exports["EmojiWrapper"] = $72178c9eda154f79$export$e31a6cc0a4c97f0e;
module.exports["FlagsContainer"] = $72178c9eda154f79$export$1b225d69cabf8532;
module.exports["ButtonContainer"] = $72178c9eda154f79$export$eddf54ea3db8d0f0;

});

parcelRegister("O8fsx", function(module, exports) {
module.exports = new URL("customCursor.8a87402c.svg", import.meta.url).toString();

});

parcelRegister("9BWGi", function(module, exports) {
/* LazyButtons.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $lfoFx = parcelRequire("lfoFx");


var $jmjWc = parcelRequire("jmjWc");

const $cb3e4c1f9ef026ad$var$spinnerContainerStyles = null;
const $cb3e4c1f9ef026ad$var$LoadingSpinner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3izwfg _1bsbzwfg _2hwxutpp"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        interactionName: "presentation-mode-lazy-buttons"
    }));

const $cb3e4c1f9ef026ad$export$490f62136438ac6e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "9F1oH",
    name: "LazyNavigation",
    loader: async ()=>(await (parcelRequire("bGuoD"))).NavigationPresenterMode,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cb3e4c1f9ef026ad$var$LoadingSpinner, null)
});

const $cb3e4c1f9ef026ad$export$37c96b963636f7cc = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "60c-p",
    name: "LazySettingsMenu",
    loader: async ()=>(await (parcelRequire("fK8uT"))).SettingsMenu,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cb3e4c1f9ef026ad$var$LoadingSpinner, null)
});
module.exports["LazyNavigation"] = $cb3e4c1f9ef026ad$export$490f62136438ac6e;
module.exports["LazySettingsMenu"] = $cb3e4c1f9ef026ad$export$37c96b963636f7cc;

});

parcelRegister("bGuoD", function(module, exports) {

let $881b32044ab2e90b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $881b32044ab2e90b$var$load("8zMmc"),
    $881b32044ab2e90b$var$load("6wr18"),
    $881b32044ab2e90b$var$load("ffEVr"),
    $881b32044ab2e90b$var$load("7EorR"),
    $881b32044ab2e90b$var$load("3kVph"),
    $881b32044ab2e90b$var$load("hhss7"),
    $881b32044ab2e90b$var$load("9IaUU")
]).then(()=>parcelRequire('lQ3Oi'));

});

parcelRegister("fK8uT", function(module, exports) {

let $b761be44ff5fcc2b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b761be44ff5fcc2b$var$load("6wr18"),
    $b761be44ff5fcc2b$var$load("ffEVr"),
    $b761be44ff5fcc2b$var$load("Wowvf"),
    $b761be44ff5fcc2b$var$load("62AD8")
]).then(()=>parcelRequire('2JGhm'));

});

parcelRegister("ibtF1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3oWMY = parcelRequire("3oWMY");


var $3WPGR = parcelRequire("3WPGR");


var $1d2ww = parcelRequire("1d2ww");


var $gnyTR = parcelRequire("gnyTR");


var $fDEVM = parcelRequire("fDEVM");

const $647837bde418af85$export$82c94077b89191c5 = 'presenter-mode-header-image-container';
const $647837bde418af85$export$7b5e76b410389064 = ({ contentId: contentId, coverPictureProperty: coverPictureProperty })=>{
    const [coverPictureData, setCoverPictureData] = (0, $cozmU.useState)(undefined);
    (0, $cozmU.useEffect)(()=>{
        if (!coverPictureProperty) return;
        const publishedId = (0, $3WPGR.propertyToId)(coverPictureProperty);
        if (!publishedId) return;
        const coverPic = {
            draft: null,
            published: {
                value: {
                    id: (0, $fDEVM.createHigherResImgSrc)(publishedId?.value?.id),
                    position: publishedId?.value?.position || 0
                },
                version: publishedId?.version
            }
        };
        setCoverPictureData(coverPic);
    }, [
        coverPictureProperty
    ]);
    if (!coverPictureData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.NoHeaderImageSpacer), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gnyTR.HeaderImageContainer), {
        id: $647837bde418af85$export$82c94077b89191c5
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3oWMY.RendererPageCoverPicture), {
        contentId: contentId,
        isPagePreview: false,
        coverPicture: coverPictureData,
        contentAppearance: {
            draft: '',
            published: (0, $1d2ww.ContentAppearanceType).FULL_WIDTH
        },
        isSpaceOverview: false,
        isPresenterMode: true
    }));
};
module.exports["HeaderImageContainerId"] = $647837bde418af85$export$82c94077b89191c5;
module.exports["HeaderImage"] = $647837bde418af85$export$7b5e76b410389064;

});

parcelRegister("3oWMY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $goxV5 = parcelRequire("goxV5");


const $aac74fc16bd2f0e9$export$60620c3d63f5f30 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "tETtx",
    name: "RendererPageCoverPicture",
    loader: async ()=>{
        return (await (parcelRequire("64TfP"))).RendererPageCoverPicture;
    },
    loading: (0, $goxV5.RendererPageCoverPicturePlaceholder)
});
module.exports["RendererPageCoverPicture"] = $aac74fc16bd2f0e9$export$60620c3d63f5f30;

});

parcelRegister("goxV5", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $jVylI = parcelRequire("jVylI");


var $75Ax4 = parcelRequire("75Ax4");

/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-dynamic-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/use-tokens-space, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766 */ const $be005db184746995$var$Placeholder = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isFixedWidthImageOption: isFixedWidthImageOption, smartSpaceOverviewHeight: smartSpaceOverviewHeight, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_19y14qn": (0, $9aYkv.default)(__cmplp.smartSpaceOverviewHeight, "px")
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_otyrze3t _bfhki8nm",
                __cmplp.isFixedWidthImageOption ? "_19pkidpf _2hwx1wug _otyridpf _18u01wug _19pk14id _1bsb1c3h" : "_19pk14id _1bsb14oa _18u09b24",
                __cmplp.smartSpaceOverviewHeight ? "_4t3ihojm" : __cmplp.isFixedWidthImageOption ? "_4t3i2pqz" : "_4t3i1a28",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $be005db184746995$export$e9417b149b0db09d = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { coverPicture: coverPicture, isPagePreview: isPagePreview, contentAppearance: contentAppearance, isSpaceOverview: isSpaceOverview, hasEmoji: hasEmoji, coverPictureWidthOverride: coverPictureWidthOverride, isSmartSpaceOverview: isSmartSpaceOverview } = t0;
    const hasCoverPicture = isPagePreview ? !!coverPicture?.draft?.value?.id : !!coverPicture?.published?.value?.id;
    const appearance = isPagePreview ? contentAppearance.draft : contentAppearance.published;
    const isFixedWidthImageOption = coverPictureWidthOverride === (0, $jVylI.COVERPICTUREWIDTH).FIXED;
    const smartSpaceOverviewHeight = isSmartSpaceOverview ? (0, $75Ax4.SMART_SPACE_OVERVIEW_FIXED_HEIGHT_FULL_WIDTH) : undefined;
    let t1;
    if ($[0] !== appearance || $[1] !== hasCoverPicture || $[2] !== hasEmoji || $[3] !== isFixedWidthImageOption || $[4] !== isPagePreview || $[5] !== isSpaceOverview || $[6] !== smartSpaceOverviewHeight) {
        t1 = hasCoverPicture ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($be005db184746995$var$Placeholder, {
            contentAppearance: appearance,
            isPagePreview: isPagePreview,
            isSpaceOverview: isSpaceOverview,
            smartSpaceOverviewHeight: smartSpaceOverviewHeight,
            hasEmoji: hasEmoji,
            isFixedWidthImageOption: isFixedWidthImageOption
        })) : null;
        $[0] = appearance;
        $[1] = hasCoverPicture;
        $[2] = hasEmoji;
        $[3] = isFixedWidthImageOption;
        $[4] = isPagePreview;
        $[5] = isSpaceOverview;
        $[6] = smartSpaceOverviewHeight;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
};
module.exports["RendererPageCoverPicturePlaceholder"] = $be005db184746995$export$e9417b149b0db09d;

});

parcelRegister("64TfP", function(module, exports) {

let $46cdfa25dc00b709$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $46cdfa25dc00b709$var$load("eCXJR"),
    $46cdfa25dc00b709$var$load("1VTX2"),
    $46cdfa25dc00b709$var$load("ddvkk"),
    $46cdfa25dc00b709$var$load("3upHR"),
    $46cdfa25dc00b709$var$load("iUXaE"),
    $46cdfa25dc00b709$var$load("lTkx9"),
    $46cdfa25dc00b709$var$load("hZ2FX"),
    $46cdfa25dc00b709$var$load("6OMo6"),
    $46cdfa25dc00b709$var$load("aaRXj"),
    $46cdfa25dc00b709$var$load("fHlIz"),
    $46cdfa25dc00b709$var$load("4QwAJ"),
    $46cdfa25dc00b709$var$load("3i44s"),
    $46cdfa25dc00b709$var$load("5kI0b"),
    $46cdfa25dc00b709$var$load("kYkz1"),
    $46cdfa25dc00b709$var$load("jfYeU"),
    $46cdfa25dc00b709$var$load("b4nm1"),
    $46cdfa25dc00b709$var$load("geXPZ"),
    $46cdfa25dc00b709$var$load("aQ5uu"),
    $46cdfa25dc00b709$var$load("fV46K"),
    $46cdfa25dc00b709$var$load("jOE2W"),
    $46cdfa25dc00b709$var$load("jTOhL"),
    $46cdfa25dc00b709$var$load("4JSav"),
    $46cdfa25dc00b709$var$load("lbsQO"),
    $46cdfa25dc00b709$var$load("kT6dz"),
    $46cdfa25dc00b709$var$load("aAWLw"),
    $46cdfa25dc00b709$var$load("4Bg7q")
]).then(()=>parcelRequire('9ChZM'));

});

parcelRegister("fDEVM", function(module, exports) {

var $jVylI = parcelRequire("jVylI");


var $zalpJ = parcelRequire("zalpJ");


var $hMdkB = parcelRequire("hMdkB");

var $9b92440f7f429369$export$1ef9fc5d7a7ef8e2 = /*#__PURE__*/ function(TYPE_OF_NODE) {
    TYPE_OF_NODE["LAYOUT"] = "layout";
    TYPE_OF_NODE["HR"] = "hr";
    TYPE_OF_NODE["EXPAND"] = "expand";
    TYPE_OF_NODE["HEADING"] = "header";
    TYPE_OF_NODE["EMPTY"] = "empty";
    TYPE_OF_NODE["OTHER"] = "other";
    TYPE_OF_NODE["STICKY_HEADER"] = "stickyHeader";
    TYPE_OF_NODE["TABLE"] = "table";
    TYPE_OF_NODE["MACRO"] = "macro";
    TYPE_OF_NODE["IMAGE"] = "image";
    return TYPE_OF_NODE;
}({});
const $9b92440f7f429369$export$be27aa1bed7edb58 = (scrollUp)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const scrollContainer = document.getElementById(`${(0, $hMdkB.PresenterModePortalContainerId)}`);
    // Scroll by half the viewport height
    const scrollAmount = window.innerHeight * 0.5 * (scrollUp ? -1 : 1);
    if (// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') window.requestAnimationFrame(()=>{
        scrollContainer?.scrollBy({
            top: scrollContainer.getBoundingClientRect().top + scrollAmount,
            behavior: 'smooth'
        });
    });
};
const $9b92440f7f429369$export$8286ea4d39e1c85c = (originalSrc)=>{
    if (!originalSrc.includes('images.unsplash.com')) return originalSrc;
    const baseAndParams = originalSrc.split('?');
    const queryParams = new URLSearchParams(baseAndParams[1]);
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const width = Math.min(document?.documentElement?.clientWidth, 3000);
    queryParams.set('w', width.toString());
    queryParams.delete('q');
    return `${baseAndParams[0]}?${queryParams.toString()}`;
};
const $9b92440f7f429369$export$87b554716dce1db0 = (refNode)=>{
    const getFirstTextNodeIterative = (refNode)=>{
        const stack = [
            refNode
        ];
        while(stack.length > 0){
            const node = stack.pop();
            if (node.nodeType == 3 && node.nodeValue?.trim().length !== 0) return node;
            for(let i = node.childNodes.length - 1; i >= 0; i--)stack.push(node.childNodes[i]);
        }
    };
    return getFirstTextNodeIterative(refNode);
};
const $9b92440f7f429369$export$91dc29669e88d0db = (node)=>{
    return /^([Hh])[0-6].*/.test(node?.tagName);
};
const $9b92440f7f429369$export$dd1bc94b04021eeb = (node)=>{
    const firstTextNode = $9b92440f7f429369$export$87b554716dce1db0(node);
    if ($9b92440f7f429369$export$91dc29669e88d0db(node) && !firstTextNode) return true;
    if ($9b92440f7f429369$export$ed5642f3e4fb7c54(node)) return true;
    const isImage = node.classList.contains('rich-media-item') || !!node.querySelector('img') || !!node.querySelector('svg');
    const isEmptyTextElement = !firstTextNode;
    return !isImage && isEmptyTextElement;
};
const $9b92440f7f429369$export$fb85bc5d6d9ef19b = (node)=>{
    return node.classList.contains('rich-media-item') || !!node.querySelector('img') || !!node.querySelector('svg');
};
const $9b92440f7f429369$export$bf32d97724374086 = (node)=>{
    return !!node.querySelector('.pm-table-sticky-wrapper');
};
const $9b92440f7f429369$export$567a2801b8f40ab5 = (node)=>{
    return node.classList.contains('pm-table-container') || !!node.querySelector('.pm-table-container') && !$9b92440f7f429369$export$bf32d97724374086(node);
};
const $9b92440f7f429369$export$1980ca1f3eaf85fb = (node)=>{
    return node.getAttribute('data-layout-section') === 'true';
};
const $9b92440f7f429369$export$d8bf6fedd3b53772 = (node)=>{
    return node.tagName === 'HR';
};
const $9b92440f7f429369$export$35e907bd866058b8 = (node)=>{
    return node.classList.contains('ak-renderer-extension') || !!node.querySelector('.ak-renderer-extension');
};
const $9b92440f7f429369$export$1d7f19df4bf635f6 = (node)=>{
    return node.classList.contains('code-block') || !!node.querySelector('.code-block');
};
const $9b92440f7f429369$export$ed5642f3e4fb7c54 = (node)=>{
    return node.tagName === 'BR';
};
const $9b92440f7f429369$export$822db98f95375647 = (contentId)=>{
    const { titleContentProperties: titleContentProperties } = (0, $zalpJ.useTitleContentPropertiesForPublishedPage)({
        contentId: contentId
    });
    return !!(titleContentProperties?.titleLayoutAlignment === (0, $jVylI.TitleAlignmentType).CENTER);
};
module.exports["TYPE_OF_NODE"] = $9b92440f7f429369$export$1ef9fc5d7a7ef8e2;
module.exports["scrollFixedAmount"] = $9b92440f7f429369$export$be27aa1bed7edb58;
module.exports["createHigherResImgSrc"] = $9b92440f7f429369$export$8286ea4d39e1c85c;
module.exports["getFirstTextNode"] = $9b92440f7f429369$export$87b554716dce1db0;
module.exports["isHeading"] = $9b92440f7f429369$export$91dc29669e88d0db;
module.exports["isEmpty"] = $9b92440f7f429369$export$dd1bc94b04021eeb;
module.exports["isImage"] = $9b92440f7f429369$export$fb85bc5d6d9ef19b;
module.exports["isStickyHeaderOfTable"] = $9b92440f7f429369$export$bf32d97724374086;
module.exports["isTable"] = $9b92440f7f429369$export$567a2801b8f40ab5;
module.exports["isLayout"] = $9b92440f7f429369$export$1980ca1f3eaf85fb;
module.exports["isHorizontalRule"] = $9b92440f7f429369$export$d8bf6fedd3b53772;
module.exports["isMacro"] = $9b92440f7f429369$export$35e907bd866058b8;
module.exports["isCodeBlock"] = $9b92440f7f429369$export$1d7f19df4bf635f6;
module.exports["useIsTitleCenterAligned"] = $9b92440f7f429369$export$822db98f95375647;

});

parcelRegister("7mDnI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $FKQbh = parcelRequire("FKQbh");


var $24dy7 = parcelRequire("24dy7");

const $dfd48e08cc962979$export$518ba8e0e60f145f = ({ title: title })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $FKQbh.default), {
        appearance: "error",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
            spacing: "spacious",
            label: "Error"
        }),
        id: "error",
        key: "error",
        title: title
    });
};
module.exports["ErrorFlag"] = $dfd48e08cc962979$export$518ba8e0e60f145f;

});

parcelRegister("jcM8h", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $kN9tW = parcelRequire("kN9tW");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $aDSIl = parcelRequire("aDSIl");


var $7ZB0A = parcelRequire("7ZB0A");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $is1T6 = parcelRequire("is1T6");


var $5wHqn = parcelRequire("5wHqn");


var $irVI7 = parcelRequire("irVI7");


var $a6t12 = parcelRequire("a6t12");


var $68BwE = parcelRequire("68BwE");


var $jFm04 = parcelRequire("jFm04");


var $3SLf9 = parcelRequire("3SLf9");


var $jMyy4 = parcelRequire("jMyy4");

const $a26c936fb563039b$var$i18n = (0, $kSwu1.defineMessages)({
    creator: {
        id: "content-ownership.content-owner-popup.creator",
        defaultMessage: "<b>Creator</b>"
    },
    owner: {
        id: "content-ownership.content-owner-popup.owner",
        defaultMessage: "<b>Owner</b>"
    },
    changeOwner: {
        id: "content-ownership.content-owner-popup.change-owner",
        defaultMessage: "Change owner"
    },
    ariaLabel: {
        id: "content-ownership.content-owner-popup.ariaLabel",
        defaultMessage: "More information about {name}"
    }
});
// fixed dimensions
const $a26c936fb563039b$var$contentOwnerContainerStyles = (0, $buxP3.xcss)({
    width: '232px',
    height: '180px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: 'space.250'
});
const $a26c936fb563039b$var$contentOwnerViewerContainerStyles = (0, $buxP3.xcss)({
    width: '232px',
    height: '140px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: 'space.250'
});
const $a26c936fb563039b$var$contentOwnerItemStyles = (0, $buxP3.xcss)({
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});
const $a26c936fb563039b$var$contentCreatorItemStyles = (0, $buxP3.xcss)({
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 'space.100'
});
const $a26c936fb563039b$var$contentOwnerChangeItemStyles = (0, $buxP3.xcss)({
    marginTop: 'space.100'
});
const $a26c936fb563039b$var$contentOwnerNameItemStyles = (0, $buxP3.xcss)({
    marginTop: 'space.025',
    textDecoration: 'underline',
    color: 'color.text',
    ':hover': {
        color: 'color.link',
        cursor: 'pointer'
    }
});
const $a26c936fb563039b$var$ContentOwnerDetailsPanelName = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { userId: userId, fullName: fullName, ariaLabel: ariaLabel } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            0,
            28
        ];
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== fullName || $[2] !== userId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: userId,
            position: "left-start",
            offset: t1,
            fullName: fullName
        }, fullName);
        $[1] = fullName;
        $[2] = userId;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== ariaLabel || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $a26c936fb563039b$var$contentOwnerNameItemStyles,
            role: "tooltip",
            "aria-label": ariaLabel
        }, t2);
        $[4] = ariaLabel;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ userId: userId, fullName: fullName, ariaLabel: ariaLabel })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $a26c936fb563039b$var$contentOwnerNameItemStyles,
        role: "tooltip",
        "aria-label": ariaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
        userId: userId,
        position: "left-start",
        offset: [
            0,
            28
        ],
        fullName: fullName
    }, fullName));
};
const $a26c936fb563039b$var$ContentOwnerDetailsPanel = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { ownedBy: ownedBy, createdBy: createdBy, closePopup: closePopup, openModal: openModal, setInitialFocusRef: setInitialFocusRef } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $68BwE.useExperienceTrackerContext)();
    let t1;
    if ($[0] !== closePopup || $[1] !== experienceTracker || $[2] !== openModal) {
        t1 = ()=>{
            openModal();
            closePopup();
            experienceTracker.start({
                name: (0, $irVI7.CONTENT_OWNERSHIP_DIALOG_EXPERIENCE)
            });
        };
        $[0] = closePopup;
        $[1] = experienceTracker;
        $[2] = openModal;
        $[3] = t1;
    } else t1 = $[3];
    const onClickChangeOwner = t1;
    const isAllowedToChange = (0, $3SLf9.useIsAllowedToChangeOwner)(ownedBy.userId);
    const t2 = isAllowedToChange ? $a26c936fb563039b$var$contentOwnerContainerStyles : $a26c936fb563039b$var$contentOwnerViewerContainerStyles;
    let t3;
    if ($[4] !== t2) {
        t3 = [
            t2
        ];
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$a26c936fb563039b$var$i18n.creator,
            values: {
                b: $a26c936fb563039b$var$_temp
            }
        });
        $[6] = t4;
    } else t4 = $[6];
    const t5 = createdBy.userId;
    const t6 = createdBy.fullName;
    let t7;
    if ($[7] !== createdBy.fullName || $[8] !== intl) {
        t7 = intl.formatMessage($a26c936fb563039b$var$i18n.ariaLabel, {
            name: createdBy.fullName
        });
        $[7] = createdBy.fullName;
        $[8] = intl;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== createdBy.fullName || $[11] !== createdBy.userId || $[12] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $a26c936fb563039b$var$contentCreatorItemStyles
        }, t4, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelName, {
            userId: t5,
            fullName: t6,
            ariaLabel: t7
        }));
        $[10] = createdBy.fullName;
        $[11] = createdBy.userId;
        $[12] = t7;
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$a26c936fb563039b$var$i18n.owner,
            values: {
                b: $a26c936fb563039b$var$_temp2
            }
        });
        $[14] = t9;
    } else t9 = $[14];
    const t10 = ownedBy.userId;
    const t11 = ownedBy.fullName;
    let t12;
    if ($[15] !== intl || $[16] !== ownedBy.fullName) {
        t12 = intl.formatMessage($a26c936fb563039b$var$i18n.ariaLabel, {
            name: ownedBy.fullName
        });
        $[15] = intl;
        $[16] = ownedBy.fullName;
        $[17] = t12;
    } else t12 = $[17];
    let t13;
    if ($[18] !== ownedBy.fullName || $[19] !== ownedBy.userId || $[20] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $a26c936fb563039b$var$contentOwnerItemStyles
        }, t9, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelName, {
            userId: t10,
            fullName: t11,
            ariaLabel: t12
        }));
        $[18] = ownedBy.fullName;
        $[19] = ownedBy.userId;
        $[20] = t12;
        $[21] = t13;
    } else t13 = $[21];
    let t14;
    if ($[22] !== intl || $[23] !== isAllowedToChange || $[24] !== onClickChangeOwner || $[25] !== setInitialFocusRef) {
        t14 = isAllowedToChange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $a26c936fb563039b$var$contentOwnerChangeItemStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            onClick: onClickChangeOwner,
            appearance: "link",
            spacing: "none",
            ref: setInitialFocusRef
        }, intl.formatMessage($a26c936fb563039b$var$i18n.changeOwner)));
        $[22] = intl;
        $[23] = isAllowedToChange;
        $[24] = onClickChangeOwner;
        $[25] = setInitialFocusRef;
        $[26] = t14;
    } else t14 = $[26];
    let t15;
    if ($[27] !== t13 || $[28] !== t14 || $[29] !== t3 || $[30] !== t8) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: t3
        }, t8, t13, t14);
        $[27] = t13;
        $[28] = t14;
        $[29] = t3;
        $[30] = t8;
        $[31] = t15;
    } else t15 = $[31];
    return t15;
} : ({ ownedBy: ownedBy, createdBy: createdBy, closePopup: closePopup, openModal: openModal, setInitialFocusRef: setInitialFocusRef })=>{
    const intl = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $68BwE.useExperienceTrackerContext)();
    const onClickChangeOwner = (0, $cozmU.useCallback)(()=>{
        openModal();
        closePopup();
        experienceTracker.start({
            name: (0, $irVI7.CONTENT_OWNERSHIP_DIALOG_EXPERIENCE)
        });
    }, [
        closePopup,
        openModal,
        experienceTracker
    ]);
    const isAllowedToChange = (0, $3SLf9.useIsAllowedToChangeOwner)(ownedBy.userId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: [
            isAllowedToChange ? $a26c936fb563039b$var$contentOwnerContainerStyles : $a26c936fb563039b$var$contentOwnerViewerContainerStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $a26c936fb563039b$var$contentCreatorItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$a26c936fb563039b$var$i18n.creator,
        values: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelName, {
        userId: createdBy.userId,
        fullName: createdBy.fullName,
        ariaLabel: intl.formatMessage($a26c936fb563039b$var$i18n.ariaLabel, {
            name: createdBy.fullName
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $a26c936fb563039b$var$contentOwnerItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$a26c936fb563039b$var$i18n.owner,
        values: {
            b: (chunks_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks_0)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelName, {
        userId: ownedBy.userId,
        fullName: ownedBy.fullName,
        ariaLabel: intl.formatMessage($a26c936fb563039b$var$i18n.ariaLabel, {
            name: ownedBy.fullName
        })
    })), isAllowedToChange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $a26c936fb563039b$var$contentOwnerChangeItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        onClick: onClickChangeOwner,
        appearance: "link",
        spacing: "none",
        ref: setInitialFocusRef
    }, intl.formatMessage($a26c936fb563039b$var$i18n.changeOwner))));
};
const $a26c936fb563039b$var$ContentOwnerDetailsPanelWrapper = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { ownedBy: ownedBy, createdBy: createdBy, closePopup: closePopup, setInitialFocusRef: setInitialFocusRef } = t0;
    if (!ownedBy || !createdBy) return null;
    let t1;
    if ($[0] !== closePopup || $[1] !== createdBy || $[2] !== ownedBy || $[3] !== setInitialFocusRef) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jFm04.ContentOwnershipContextConsumer), null, (t2)=>{
            const { openModal: openModal } = t2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanel, {
                ownedBy: ownedBy,
                createdBy: createdBy,
                closePopup: closePopup,
                openModal: openModal,
                setInitialFocusRef: setInitialFocusRef
            });
        });
        $[0] = closePopup;
        $[1] = createdBy;
        $[2] = ownedBy;
        $[3] = setInitialFocusRef;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ ownedBy: ownedBy, createdBy: createdBy, closePopup: closePopup, setInitialFocusRef: setInitialFocusRef })=>{
    if (!ownedBy || !createdBy) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jFm04.ContentOwnershipContextConsumer), null, ({ openModal: openModal })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanel, {
            ownedBy: ownedBy,
            createdBy: createdBy,
            closePopup: closePopup,
            openModal: openModal,
            setInitialFocusRef: setInitialFocusRef
        }));
};
const $a26c936fb563039b$export$62380b37452323f8 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { contentId: contentId, itemId: itemId, itemLabel: itemLabel, isOpen: isOpen, onClick: onClick, onCloseParent: onCloseParent, onClosePopup: onClosePopup, onMouseEnter: onMouseEnter, elemBefore: elemBefore } = t0;
    let t1;
    if ($[0] !== onCloseParent || $[1] !== onClosePopup) {
        t1 = ()=>{
            onClosePopup();
            onCloseParent?.();
        };
        $[0] = onCloseParent;
        $[1] = onClosePopup;
        $[2] = t1;
    } else t1 = $[2];
    const closeOwnerDialog = t1;
    let t2;
    if ($[3] !== contentId) {
        t2 = {
            contentId: contentId
        };
        $[3] = contentId;
        $[4] = t2;
    } else t2 = $[4];
    const t3 = !contentId;
    let t4;
    if ($[5] !== t2 || $[6] !== t3) {
        t4 = {
            variables: t2,
            skip: t3
        };
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    const { data: ownerHistoryData } = (0, $jMyy4.useQueryInterop)((0, $kN9tW.default), {
        ...t4,
        __callerPackage__: "content-ownership"
    });
    const toUserData = $a26c936fb563039b$var$_temp3;
    const t5 = ownerHistoryData?.singleContent?.history?.ownedBy;
    let t6;
    if ($[8] !== t5) {
        t6 = toUserData(t5);
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    const ownedBy = t6;
    const t7 = ownerHistoryData?.singleContent?.history?.createdBy;
    let t8;
    if ($[10] !== t7) {
        t8 = toUserData(t7);
        $[10] = t7;
        $[11] = t8;
    } else t8 = $[11];
    const createdBy = t8;
    const t9 = `container-${itemId}`;
    let t10;
    if ($[12] !== closeOwnerDialog || $[13] !== createdBy || $[14] !== ownedBy) {
        t10 = (t11)=>{
            const { setInitialFocusRef: setInitialFocusRef } = t11;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelWrapper, {
                ownedBy: ownedBy,
                createdBy: createdBy,
                closePopup: closeOwnerDialog,
                setInitialFocusRef: setInitialFocusRef
            });
        };
        $[12] = closeOwnerDialog;
        $[13] = createdBy;
        $[14] = ownedBy;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== elemBefore || $[17] !== isOpen || $[18] !== itemLabel || $[19] !== onClick || $[20] !== onMouseEnter) {
        t11 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                elemBefore: elemBefore,
                ...triggerProps,
                onClick: onClick,
                onMouseEnter: onMouseEnter,
                isSelected: isOpen,
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    label: "",
                    color: "var(--ds-icon, #292A2E)",
                    size: "small"
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, itemLabel));
        $[16] = elemBefore;
        $[17] = isOpen;
        $[18] = itemLabel;
        $[19] = onClick;
        $[20] = onMouseEnter;
        $[21] = t11;
    } else t11 = $[21];
    let t12;
    if ($[22] !== isOpen || $[23] !== onClosePopup || $[24] !== t10 || $[25] !== t11 || $[26] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
            key: t9,
            isOpen: isOpen,
            onClose: onClosePopup,
            onBlur: onClosePopup,
            placement: "left-start",
            content: t10,
            trigger: t11
        });
        $[22] = isOpen;
        $[23] = onClosePopup;
        $[24] = t10;
        $[25] = t11;
        $[26] = t9;
        $[27] = t12;
    } else t12 = $[27];
    return t12;
} : ({ contentId: contentId, itemId: itemId, itemLabel: itemLabel, isOpen: isOpen, onClick: onClick, onCloseParent: onCloseParent, onClosePopup: onClosePopup, onMouseEnter: onMouseEnter, elemBefore: elemBefore })=>{
    const closeOwnerDialog = ()=>{
        onClosePopup();
        onCloseParent?.();
    };
    const { data: ownerHistoryData } = (0, $jMyy4.useQueryInterop)((0, $kN9tW.default), {
        variables: {
            contentId: contentId
        },
        skip: !contentId,
        __callerPackage__: "content-ownership"
    });
    const toUserData = (user)=>({
            userId: user?.accountId ?? undefined,
            fullName: user?.displayName,
            isAnonymous: !user?.accountId
        });
    const ownedBy = toUserData(ownerHistoryData?.singleContent?.history?.ownedBy);
    const createdBy = toUserData(ownerHistoryData?.singleContent?.history?.createdBy);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
        key: `container-${itemId}`,
        isOpen: isOpen,
        onClose: onClosePopup,
        // @ts-ignore onBlur not a supported Popup prop, but works as intended. Keep this around until live pages behavior is finalized
        onBlur: onClosePopup,
        placement: "left-start",
        content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a26c936fb563039b$var$ContentOwnerDetailsPanelWrapper, {
                ownedBy: ownedBy,
                createdBy: createdBy,
                closePopup: closeOwnerDialog,
                setInitialFocusRef: setInitialFocusRef
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                elemBefore: elemBefore,
                ...triggerProps,
                onClick: onClick,
                // @ts-ignore onMouseEnter not a supported Popup prop, but works as intended. Keep this around until live pages behavior is finalized
                onMouseEnter: onMouseEnter,
                isSelected: isOpen,
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    label: "",
                    color: "var(--ds-icon, #292A2E)",
                    size: "small"
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, itemLabel))
    });
};
function $a26c936fb563039b$var$_temp(chunks) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks);
}
function $a26c936fb563039b$var$_temp2(chunks_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks_0);
}
function $a26c936fb563039b$var$_temp3(user) {
    return {
        userId: user?.accountId ?? undefined,
        fullName: user?.displayName,
        isAnonymous: !user?.accountId
    };
}
module.exports["ContentOwnerPopupComponent"] = $a26c936fb563039b$export$62380b37452323f8;

});

parcelRegister("kN9tW", function(module, exports) {
/**
 * @generated SignedSource<<10c675709560dcdd57f41b244dd44cf1>>
 * @relayHash 7fe01343636a1cc8e3587d1c0025997f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 70169404e9af278282103e5852c5a75edc0d3390fd4aa4707ab74a4bbff37105
const $cbf179a03b0882d6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v5 = [
        v3 /*: any*/ ,
        v4 /*: any*/ 
    ], v6 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v3 /*: any*/ ,
        v4 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOwnerPopupComponentContentOwnerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v5 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v5 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOwnerPopupComponentContentOwnerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v6 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v6 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "7fe01343636a1cc8e3587d1c0025997f",
            "id": "70169404e9af278282103e5852c5a75edc0d3390fd4aa4707ab74a4bbff37105",
            "metadata": {},
            "name": "ContentOwnerPopupComponentContentOwnerQuery",
            "operationKind": "query",
            "text": "query ContentOwnerPopupComponentContentOwnerQuery($contentId:ID!){singleContent(id:$contentId){id,history{createdBy{__typename,displayName,...on KnownUser{accountId}},ownedBy{__typename,displayName,...on KnownUser{accountId}}}}}"
        }
    };
}();
$cbf179a03b0882d6$var$node.hash = "ab500ff679b71481a192bc88337cadcd";
var $cbf179a03b0882d6$export$2e2bcd8739ae039 = $cbf179a03b0882d6$var$node;
module.exports["default"] = $cbf179a03b0882d6$export$2e2bcd8739ae039;

});

parcelRegister("3SLf9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bQm3c = parcelRequire("bQm3c");


var $i28ZW = parcelRequire("i28ZW");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $5k5SG = parcelRequire("5k5SG");


var $68BwE = parcelRequire("68BwE");

const $93ff62a422a2769d$export$fe5ee8722fdedf98 = (ownedByAccountId)=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const isSpaceOrSiteAdmin = (0, $5k5SG.useIsSpaceOrSiteAdmin)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isSiteAdmin: isSiteAdmin } = (0, $68BwE.useSPAViewContext)();
    const { canManageContent: canManageContent = false } = (0, $i28ZW.useSpaceManagementOperations)({
        spaceKey: spaceKey ?? '',
        skip: !spaceKey || !(0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false)
    }) ?? {};
    const isElevated = (0, $6mKj3.expVal)('permissions_rbac_dependencies_callsites', 'isEnabled', false) ? canManageContent || isSiteAdmin : isSpaceOrSiteAdmin;
    return (0, $cozmU.useMemo)(()=>{
        if (!userId) return false;
        const isCurrentUserOwner = ownedByAccountId === userId;
        return isElevated || isCurrentUserOwner;
    }, [
        isElevated,
        ownedByAccountId,
        userId
    ]);
};
module.exports["useIsAllowedToChangeOwner"] = $93ff62a422a2769d$export$fe5ee8722fdedf98;

});

parcelRegister("5nr5P", function(module, exports) {

var $kNIYN = parcelRequire("kNIYN");

class $22dbf97de39b4a94$export$8428b29fbe35d5c extends (0, $kNIYN.Container) {
    constructor({ loadUuid: loadUuid = '', contentId: contentId = null, userCanEditRestrictions: userCanEditRestrictions = false, currentUserInfo: currentUserInfo = null, hasInheritedRestrictions: hasInheritedRestrictions = false, hasRestrictions: hasRestrictions = false, isLoaded: isLoaded = false, restrictionsDetails: restrictionsDetails = null, spaceKey: spaceKey = null, spaceContainsExternalCollaborators: spaceContainsExternalCollaborators = false, externalCollaboratorCount: externalCollaboratorCount = 0, operations: operations = null, contentTitle: contentTitle = null, edition: edition = null, isSiteAdmin: isSiteAdmin = false, contentType: contentType = null, contentSubType: contentSubType = null, isExternalShareEnabledForSite: isExternalShareEnabledForSite = false, isPageExternallyShared: isPageExternallyShared = false, isExternalShareVariation: isExternalShareVariation = false, isContentExternallySharable: isContentExternallySharable = false, canEditPublicLink: canEditPublicLink = false, ancestors: ancestors = [] } = {}){
        super();
        this.getData = ()=>{
            return this.state;
        };
        this.resetData = ()=>{
            this.setState({
                loadUuid: '',
                contentId: null,
                contentPermissions: null,
                currentUserInfo: null,
                hasInheritedRestrictions: false,
                hasRestrictions: false,
                isLoaded: false,
                restrictionsDetails: null,
                spaceKey: null,
                spaceContainsExternalCollaborators: false,
                externalCollaboratorCount: 0,
                operations: null,
                contentTitle: null,
                edition: null,
                isSiteAdmin: false,
                contentType: null,
                contentSubType: null,
                contentStatus: undefined,
                isExternalShareEnabledForSite: false,
                isPageExternallyShared: false,
                isExternalShareVariation: false,
                isContentExternallySharable: false,
                canEditPublicLink: false,
                ancestors: []
            });
        };
        this.setData = (data)=>{
            if (Object.keys(data).some((k)=>data[k] !== this.state[k])) this.setState(data);
        };
        this.getIsLoaded = ()=>{
            return this.state.isLoaded;
        };
        this.getContentId = ()=>{
            return this.state.contentId;
        };
        this.getLoadUuid = ()=>{
            return this.state.loadUuid;
        };
        this.state = {
            loadUuid: loadUuid,
            contentId: contentId,
            userCanEditRestrictions: userCanEditRestrictions,
            currentUserInfo: //   currentUserInfo: PropTypes.shape({
            //     id: PropTypes.string.isRequired,
            //     displayName: PropTypes.string.isRequired,
            //     isSuperAdmin: PropTypes.bool,
            //     profilePicture: PropTypes.shape({
            //       path: PropTypes.string
            //     })
            //   }).isRequired,
            currentUserInfo,
            hasInheritedRestrictions: hasInheritedRestrictions,
            hasRestrictions: hasRestrictions,
            isLoaded: isLoaded,
            restrictionsDetails: // const restrictionsShape = {
            //   restrictions: PropTypes.shape({
            //     user: PropTypes.shape({
            //       nodes: PropTypes.arrayOf(
            //         PropTypes.shape({
            //           accountId: PropTypes.string,
            //           displayName: PropTypes.string,
            //           type: PropTypes.string
            //         })
            //       )
            //     }),
            //     group: PropTypes.shape({
            //       nodes: PropTypes.arrayOf(
            //         PropTypes.shape({
            //           name: PropTypes.string
            //         })
            //       )
            //     })
            //   })
            // };
            restrictionsDetails,
            spaceKey: spaceKey,
            spaceContainsExternalCollaborators: spaceContainsExternalCollaborators,
            externalCollaboratorCount: externalCollaboratorCount,
            operations: operations,
            contentTitle: contentTitle,
            edition: edition,
            isSiteAdmin: isSiteAdmin,
            contentType: contentType,
            contentSubType: contentSubType,
            isExternalShareEnabledForSite: isExternalShareEnabledForSite,
            isPageExternallyShared: isPageExternallyShared,
            isExternalShareVariation: isExternalShareVariation,
            isContentExternallySharable: isContentExternallySharable,
            canEditPublicLink: canEditPublicLink,
            ancestors: ancestors
        };
    }
}
module.exports["RestrictionsDataContainer"] = $22dbf97de39b4a94$export$8428b29fbe35d5c;

});

parcelRegister("hzkzq", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $6mKj3 = parcelRequire("6mKj3");

const $b055c0b5c16164d3$export$41b2e06f27dfe96e = 'archived';
const $b055c0b5c16164d3$export$6b45500787cf696 = ({ contentId: contentId, contentSlug: contentSlug, contentType: contentType, isSpaceOverview: isSpaceOverview, query: query, spaceAlias: spaceAlias, spaceKey: spaceKey })=>{
    if (contentType === 'folder') {
        if ((0, $6mKj3.expVal)('confluence_folder_view', 'isEnabled', false)) {
            if (!contentId) return '#';
            return (0, $1NBp8.FOLDER_VIEW).toUrl({
                contentId: contentId,
                spaceKey: spaceAlias || spaceKey
            });
        }
        return '#';
    }
    let route;
    if (isSpaceOverview) route = (0, $1NBp8.SPACE_OVERVIEW);
    else switch(contentType){
        case 'blogpost':
            route = (0, $1NBp8.VIEW_BLOG);
            break;
        case 'page':
            route = (0, $1NBp8.VIEW_PAGE);
            break;
        case 'whiteboard':
            route = (0, $1NBp8.WHITEBOARD_BOARD);
            break;
        case 'slide':
            route = (0, $1NBp8.SLIDES_VIEW);
            break;
        case 'database':
            route = (0, $1NBp8.DATABASE_VIEW);
            break;
        case 'embed':
            route = (0, $1NBp8.EMBED_VIEW);
            break;
        default:
            throw new Error(`Received an unexpected content type: '${contentType}'`);
    }
    return route.toUrl({
        contentId: contentId,
        contentSlug: contentSlug,
        spaceKey: spaceAlias || spaceKey
    }, {
        query: query
    });
};
const $b055c0b5c16164d3$export$d3865786a3f7be67 = ({ ancestors: ancestors, status: status }, spaceHomepageId)=>{
    if (!ancestors) return [];
    // If current page is archived, filter out non-archived ancestors
    if (status === $b055c0b5c16164d3$export$41b2e06f27dfe96e) ancestors = ancestors.filter((ancestor)=>ancestor && ancestor.status === $b055c0b5c16164d3$export$41b2e06f27dfe96e);
    else // technically array elements can be null
    ancestors = ancestors.filter((node)=>node);
    // Filter out ancestors with null type
    ancestors = ancestors.filter((node)=>{
        if (!node) return false;
        if (!node.type) return false;
        return true;
    });
    // Filter out ancestors with null id to prevent TypeError from path-to-regexp
    ancestors = ancestors.filter((node)=>node && node.id);
    if (!ancestors.length) return ancestors;
    if (ancestors[0].id !== spaceHomepageId && ancestors[ancestors.length - 1].id === spaceHomepageId) return [
        ...ancestors
    ].reverse().slice(1);
    if (ancestors[0].id === spaceHomepageId) return ancestors.slice(1);
    return ancestors;
};
const $b055c0b5c16164d3$export$f6641c501f8a1aee = (properties)=>{
    if (!properties) return undefined;
    const values = properties?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $b055c0b5c16164d3$export$e1cb12562674727b = (properties)=>{
    if (!properties) return undefined;
    const values = properties?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $b055c0b5c16164d3$export$52c8bba571728790 = (textRef)=>{
    if (textRef.current) return textRef.current.scrollWidth > textRef.current.clientWidth;
    return false;
};
module.exports["buildContentPath"] = $b055c0b5c16164d3$export$6b45500787cf696;
module.exports["filterAncestors"] = $b055c0b5c16164d3$export$d3865786a3f7be67;
module.exports["getEmojiFromPublishedPageProperties"] = $b055c0b5c16164d3$export$f6641c501f8a1aee;
module.exports["getEmojiFromDraftPageProperties"] = $b055c0b5c16164d3$export$e1cb12562674727b;
module.exports["getIsTextTruncated"] = $b055c0b5c16164d3$export$52c8bba571728790;

});

parcelRegister("cgsIj", function(module, exports) {
$parcel$export(module.exports, "FixedSpaceHeaderContainer", () => (parcelRequire("8MMdp")).FixedSpaceHeaderContainer);

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $eCJDV = parcelRequire("eCJDV");


var $8MMdp = parcelRequire("8MMdp");


const $b7f6794681d506d9$export$74cf87e24679ef23 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Z3pve",
    name: "BreadcrumbsLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("8MMdp")))).Breadcrumbs,
    loading: (0, $eCJDV.BreadcrumbsPlaceholder)
});
const $b7f6794681d506d9$export$2dc68d50d56fbbd = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7f6794681d506d9$export$74cf87e24679ef23, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b7f6794681d506d9$export$74cf87e24679ef23, props);
const $b7f6794681d506d9$export$8bb26699ba16d6a3 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8MMdp.Breadcrumbs), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8MMdp.Breadcrumbs), props);

const $b7f6794681d506d9$export$f979c33d59431f8e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "G1kJd",
    name: "FixedBreadcrumbsNavForPageLayoutLoader",
    loader: async ()=>(await Promise.resolve((parcelRequire("8MMdp")))).FixedBreadcrumbsNavForPageLayout
});
module.exports["BreadcrumbsLoader"] = $b7f6794681d506d9$export$74cf87e24679ef23;
module.exports["Breadcrumbs"] = $b7f6794681d506d9$export$2dc68d50d56fbbd;
module.exports["BreadcrumbsNonLoadable"] = $b7f6794681d506d9$export$8bb26699ba16d6a3;
module.exports["FixedBreadcrumbsNavForPageLayoutLoader"] = $b7f6794681d506d9$export$f979c33d59431f8e;

});

parcelRegister("eCJDV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $b8pma = parcelRequire("b8pma");

const $0c4308f795e44815$export$98d1f051069dd73b = (0, $3u0dr.isReactCompilerActiveV2)() ? function BreadcrumbsPlaceholder() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "BreadcrumbsPlaceholder"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "breadcrumbs-placeholder",
            "data-vc": "breadcrumbs-placeholder"
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function BreadcrumbsPlaceholder() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "BreadcrumbsPlaceholder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "breadcrumbs-placeholder",
        "data-vc": "breadcrumbs-placeholder"
    }));
};
module.exports["BreadcrumbsPlaceholder"] = $0c4308f795e44815$export$98d1f051069dd73b;

});

parcelRegister("8MMdp", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $9DHhW = parcelRequire("9DHhW");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $4PPzL = parcelRequire("4PPzL");


var $ep3mz = parcelRequire("ep3mz");


var $cEgMD = parcelRequire("cEgMD");


var $jmjWc = parcelRequire("jmjWc");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");


var $6mKj3 = parcelRequire("6mKj3");


var $5Vf1r = parcelRequire("5Vf1r");

const $6d14bad88596319b$var$hideDuringPdfPrint = null;

const $6d14bad88596319b$var$CompanyHubBreadcrumbs = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rj-y7",
    name: "CompanyHubBreadcrumbs",
    loader: async ()=>(await (parcelRequire("5PKaL"))).CompanyHubBreadcrumbs
}); // Keep this in sync with entry-points/breadcrumbsConstants.ts
const $6d14bad88596319b$var$BREADCRUMB_HEADER_HEIGHT = 56; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $6d14bad88596319b$export$ba9528a5a0141231 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isThemed: isThemed, isObjectHeaderEnabled: isObjectHeaderEnabled, shouldHavePadding: shouldHavePadding, shouldShowAifcCreateBanner: shouldShowAifcCreateBanner, isTransparent: isTransparent, justifyContent: justifyContent, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1ji2brd": (0, $9aYkv.default)(__cmplp.justifyContent || "space-between")
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_n7zlglyw _4t3i8vuz _1pby1ial _p12f18ua _1bsb1osq _1e0c1txw _4cvr1h6o _vchhusvi _1ltv1d4h _1bah1vxp",
                __cmplp.isThemed ? "_kqsw1if8" : "_kqsw1n9t",
                __cmplp.isThemed || __cmplp.isObjectHeaderEnabled && !__cmplp.shouldHavePadding ? "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf" : "_ca0qidpf _u5f31crf _n3tdidpf _19bv1crf",
                __cmplp.shouldShowAifcCreateBanner ? "_2lx21bp4" : "_2lx2vrvc",
                __cmplp.isTransparent ? "_bfhk1j28" : "_bfhkvuon",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isThemed: isThemed, isObjectHeaderEnabled: isObjectHeaderEnabled, shouldHavePadding: shouldHavePadding, shouldShowAifcCreateBanner: shouldShowAifcCreateBanner, isTransparent: isTransparent, justifyContent: justifyContent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1ji2brd": (0, $9aYkv.default)(__cmplp.justifyContent || 'space-between')
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_n7zlglyw _4t3i8vuz _1pby1ial _p12f18ua _1bsb1osq _1e0c1txw _4cvr1h6o _vchhusvi _1ltv1d4h _1bah1vxp",
            __cmplp.isThemed ? "_kqsw1if8" : "_kqsw1n9t",
            __cmplp.isThemed || __cmplp.isObjectHeaderEnabled && !__cmplp.shouldHavePadding ? "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf" : "_ca0qidpf _u5f31crf _n3tdidpf _19bv1crf",
            __cmplp.shouldShowAifcCreateBanner ? "_2lx21bp4" : "_2lx2vrvc",
            __cmplp.isTransparent ? "_bfhk1j28" : "_bfhkvuon",
            __cmplp.className
        ])
    });
});
const $6d14bad88596319b$var$SpaceHeaderWithBannerWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isFullWidth: isFullWidth, isThemed: isThemed, isTransparent: isTransparent, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_n7zlglyw _1pby1ial _1bsb1osq _1e0c1txw _2lx21bp4 _vchhusvi _1ltv1d4h _18u0idpf",
            __cmplp.isFullWidth ? "_p12fglyw" : "_p12f18ua",
            __cmplp.isThemed ? "_kqsw1if8" : "_kqsw1n9t",
            __cmplp.isTransparent ? "_bfhk1j28" : "_bfhkvuon",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFullWidth: isFullWidth, isThemed: isThemed, isTransparent: isTransparent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_n7zlglyw _1pby1ial _1bsb1osq _1e0c1txw _2lx21bp4 _vchhusvi _1ltv1d4h _18u0idpf",
            __cmplp.isFullWidth ? "_p12fglyw" : "_p12f18ua",
            __cmplp.isThemed ? "_kqsw1if8" : "_kqsw1n9t",
            __cmplp.isTransparent ? "_bfhk1j28" : "_bfhkvuon",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $6d14bad88596319b$var$SpaceHeaderWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isThemed: isThemed, shouldHavePadding: shouldHavePadding, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_zulpv77o _4t3i8vuz _1e0c1txw _4cvr1h6o",
            __cmplp.isThemed || !__cmplp.shouldHavePadding ? "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf" : "_ca0qidpf _u5f31crf _n3tdidpf _19bv1crf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isThemed: isThemed, shouldHavePadding: shouldHavePadding, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_zulpv77o _4t3i8vuz _1e0c1txw _4cvr1h6o",
            __cmplp.isThemed || !__cmplp.shouldHavePadding ? "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf" : "_ca0qidpf _u5f31crf _n3tdidpf _19bv1crf",
            __cmplp.className
        ])
    });
});
function $6d14bad88596319b$export$2dc68d50d56fbbd({ contentId: contentId, contentTitle: contentTitle, spaceKey: spaceKey, testId: testId, showInlineRename: showInlineRename, shouldDisableMoveButton: shouldDisableMoveButton, displayMode: displayMode = (0, $5Vf1r.BREADCRUMBS_MODES).FULL, contentLink: contentLink, contentType: contentType, subType: subType }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    if (!spaceKey) return null;
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d14bad88596319b$var$CompanyHubBreadcrumbs, null);
    const fireBreadcrumbError = (error)=>{
        let err;
        let nativeError;
        try {
            err = JSON.stringify(error, Object.getOwnPropertyNames(error)); // https://stackoverflow.com/a/26199752
            nativeError = JSON.stringify(error['nativeError']);
        } catch  {
            // if no error, means it failed to stringify so just set as empty string
            if (!err) err = '';
            if (!nativeError) nativeError = '';
        } finally{
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'breadcrumbs',
                    action: 'errored',
                    actionSubject: 'viewPageBreadcrumbs',
                    attributes: {
                        message: error.message,
                        error: err,
                        nativeError: nativeError
                    }
                }
            }).fire();
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).DISCO,
        onError: fireBreadcrumbError,
        renderOnError: ()=>null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.BREADCRUMBS_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Vf1r.BreadcrumbsWithSpaceNameDropdown), {
        contentTitle: contentTitle,
        spaceKey: spaceKey || '',
        contentId: contentId,
        testId: testId,
        showInlineRename: showInlineRename,
        shouldDisableMoveButton: shouldDisableMoveButton,
        displayMode: displayMode,
        contentLink: contentLink,
        contentType: contentType,
        subType: subType
    })));
}
const $6d14bad88596319b$export$7d2750c639212b06 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let t0;
    if ($[0] !== spaceKey) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d14bad88596319b$export$ba9528a5a0141231, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d14bad88596319b$export$2dc68d50d56fbbd, {
            spaceKey: spaceKey
        }));
        $[0] = spaceKey;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d14bad88596319b$export$ba9528a5a0141231, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d14bad88596319b$export$2dc68d50d56fbbd, {
        spaceKey: spaceKey
    }));
};
const $6d14bad88596319b$export$5adc3a1912461c1e = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { children: children, banner: banner, isThemed: isThemed, shouldHavePadding: shouldHavePadding, isFullWidth: isFullWidth, isTransparent: isTransparent, testId: testId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            (0, $6mKj3.expValEquals)("afm-hide-elements-from-pdf-print", "isEnabled", true) && "_24zuglyw"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== isThemed || $[3] !== shouldHavePadding || $[4] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d14bad88596319b$var$SpaceHeaderWrapper, {
            isThemed: isThemed,
            "data-testid": testId,
            shouldHavePadding: shouldHavePadding
        }, children);
        $[1] = children;
        $[2] = isThemed;
        $[3] = shouldHavePadding;
        $[4] = testId;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== banner || $[7] !== isFullWidth || $[8] !== isThemed || $[9] !== isTransparent || $[10] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d14bad88596319b$var$SpaceHeaderWithBannerWrapper, {
            isThemed: isThemed,
            isFullWidth: isFullWidth,
            isTransparent: isTransparent,
            className: t1
        }, banner, t2);
        $[6] = banner;
        $[7] = isFullWidth;
        $[8] = isThemed;
        $[9] = isTransparent;
        $[10] = t2;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
} : ({ children: children, banner: banner, isThemed: isThemed, shouldHavePadding: shouldHavePadding, isFullWidth: isFullWidth, isTransparent: isTransparent, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d14bad88596319b$var$SpaceHeaderWithBannerWrapper, {
        isThemed: isThemed,
        isFullWidth: isFullWidth,
        isTransparent: isTransparent,
        className: (0, $hekY6.default)([
            (0, $6mKj3.expValEquals)('afm-hide-elements-from-pdf-print', 'isEnabled', true) && "_24zuglyw"
        ])
    }, banner, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6d14bad88596319b$var$SpaceHeaderWrapper, {
        isThemed: isThemed,
        "data-testid": testId,
        shouldHavePadding: shouldHavePadding
    }, children));
};
module.exports["FixedSpaceHeaderContainer"] = $6d14bad88596319b$export$ba9528a5a0141231;
module.exports["Breadcrumbs"] = $6d14bad88596319b$export$2dc68d50d56fbbd;
module.exports["FixedBreadcrumbsNavForPageLayout"] = $6d14bad88596319b$export$7d2750c639212b06;
module.exports["FixedSpaceHeaderWithBannerContainer"] = $6d14bad88596319b$export$5adc3a1912461c1e;

});

parcelRegister("5Vf1r", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7sJoX = parcelRequire("7sJoX");


var $9DHhW = parcelRequire("9DHhW");


var $kA6Zo = parcelRequire("kA6Zo");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $5wHqn = parcelRequire("5wHqn");


var $lpNn5 = parcelRequire("lpNn5");


var $9wGTI = parcelRequire("9wGTI");


var $jmjWc = parcelRequire("jmjWc");

var $luv00 = parcelRequire("luv00");


var $bMPhU = parcelRequire("bMPhU");


var $kqIWy = parcelRequire("kqIWy");


var $irVI7 = parcelRequire("irVI7");


var $gfIPU = parcelRequire("gfIPU");

var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $b3j2Y = parcelRequire("b3j2Y");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $LSims = parcelRequire("LSims");


var $bCECL = parcelRequire("bCECL");


var $kM55L = parcelRequire("kM55L");


var $1jQpq = parcelRequire("1jQpq");


var $6mKj3 = parcelRequire("6mKj3");


var $ePiuX = parcelRequire("ePiuX");


var $hzkzq = parcelRequire("hzkzq");


const $7c978e5ad74fbe60$var$BreadcrumbsDropdownContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "d_JWZ",
    name: "BreadcrumbsDropdownContent",
    loader: async ()=>(await (parcelRequire("9F9OU"))).BreadcrumbsDropdownContent
});

const $7c978e5ad74fbe60$var$BreadcrumbsPlaceholder = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "YZZqh",
    name: "BreadcrumbsPlaceholder",
    loader: async ()=>(await Promise.resolve((parcelRequire("eCJDV")))).BreadcrumbsPlaceholder
});
const $7c978e5ad74fbe60$var$separatorStyles = null;
const $7c978e5ad74fbe60$var$hiddenStyles = null;
const $7c978e5ad74fbe60$var$hiddenContentTitleStyles = null;
const $7c978e5ad74fbe60$var$hideSeparatorStyles = null;
const $7c978e5ad74fbe60$var$breadcrumbsStyles = (0, $buxP3.xcss)({
    minWidth: '32px',
    // needed for responsive breadcrumbs, 32px is the width of the chevron button
    alignItems: 'center',
    flex: '0 1 auto',
    gap: 'space.100'
});
const $7c978e5ad74fbe60$var$inlineRenameBreadcrumbsStyles = (0, $buxP3.xcss)({
    flex: '0 0 auto'
});
const $7c978e5ad74fbe60$var$fadedSpaceNameTextStyles = null;
const $7c978e5ad74fbe60$var$spaceNameTextStyles = null;
const $7c978e5ad74fbe60$var$noEllipsisStyles = null;
const $7c978e5ad74fbe60$var$breadcrumbDropdownTriggerStyles = null;
const $7c978e5ad74fbe60$var$maxWidthBreadcrumbsDropdownTriggerStyles = null;
const $7c978e5ad74fbe60$var$onlySpaceNameTriggerStyles = null;
const $7c978e5ad74fbe60$var$maxWidthOnlyContentTitleTriggerStyles = null;
const $7c978e5ad74fbe60$var$currentPageBreadcrumbStyles = null;
const $7c978e5ad74fbe60$var$currentPageLinkBreadcrumbStyles = null;
const $7c978e5ad74fbe60$var$contentTitleStyles = null;
const $7c978e5ad74fbe60$var$dropdownLessContentTitleStyles = null;
const $7c978e5ad74fbe60$var$chevronBaseStyles = (0, $buxP3.xcss)({
    width: '32px',
    minWidth: '32px',
    height: '32px',
    borderRadius: "var(--ds-radius-small, 4px)",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'color.background.neutral.subtle'
});
const $7c978e5ad74fbe60$var$chevronHoverStyles = (0, $buxP3.xcss)({
    cursor: 'pointer',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
var $7c978e5ad74fbe60$export$14e8342ddf0a4616 = /*#__PURE__*/ function(BREADCRUMBS_MODES) {
    BREADCRUMBS_MODES["ONLY_CONTENT_TITLE"] = "ONLY_CONTENT_TITLE";
    BREADCRUMBS_MODES["ONLY_SPACE_NAME"] = "ONLY_SPACE_NAME";
    BREADCRUMBS_MODES["FULL"] = "FULL";
    BREADCRUMBS_MODES["HIDDEN"] = "HIDDEN";
    return BREADCRUMBS_MODES;
}({});
const $7c978e5ad74fbe60$export$c71a066c29807b48 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(57);
    const { contentTitle: contentTitle, spaceKey: spaceKey, contentId: contentId, testId: t1, showInlineRename: t2, shouldDisableMoveButton: t3, displayMode: displayMode, contentLink: contentLink, contentType: contentType, subType: subType } = t0;
    const testId = t1 === undefined ? "breadcrumbs-with-space-name-dropdown" : t1;
    const showInlineRename = t2 === undefined ? false : t2;
    const shouldDisableMoveButton = t3 === undefined ? false : t3;
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isBreadcrumbsPopupOpen, setIsBreadcrumbsPopupOpen] = (0, $cozmU.useState)(false);
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { data: spaceData, error: error } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const spaceHomepageId = (0, $bMPhU.useSpaceHomepageId)(spaceKey);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const isModernEmbeddedConfluence = (0, $1jQpq.useEmbeddedModernHeader)();
    const isLivePage = contentType === "page" && subType === "live";
    const isMarkdownMode = (0, $LSims.useIsMarkdownMode)(isLivePage ? contentId : undefined);
    const [t4] = (0, $kM55L.useCollabNetworkStatus)();
    const { isCollabOffline: isCollabOffline } = t4;
    let t5;
    if ($[0] !== isCollabOffline) {
        t5 = isCollabOffline && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false) && !(0, $9wGTI.fg)("platform_editor_offline_editing_wrapper_override");
        $[0] = isCollabOffline;
        $[1] = t5;
    } else t5 = $[1];
    const isNetworkDisabled = t5;
    if (error || !spaceData) {
        let t6;
        if ($[2] !== error) {
            t6 = error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gfIPU.ExperienceFailure), {
                name: (0, $irVI7.BREADCRUMBS_EXPERIENCE),
                error: error
            }));
            $[2] = error;
            $[3] = t6;
        } else t6 = $[3];
        let t7;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7c978e5ad74fbe60$var$BreadcrumbsPlaceholder, null);
            $[4] = t7;
        } else t7 = $[4];
        let t8;
        if ($[5] !== t6) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t6, t7);
            $[5] = t6;
            $[6] = t8;
        } else t8 = $[6];
        return t8;
    }
    const spaceName = spaceData.name || spaceData.alias || spaceKey;
    const isSpaceNameLongerThan6Letters = spaceName?.length > 6;
    let T0;
    let renderContentTitle;
    let shouldShowCurrentContentTitle;
    let t6;
    let t7;
    let t8;
    let t9;
    if ($[7] !== contentId || $[8] !== contentLink || $[9] !== contentTitle || $[10] !== contentType || $[11] !== createAnalyticsEvent || $[12] !== displayMode || $[13] !== experienceTracker || $[14] !== intl || $[15] !== isBreadcrumbsPopupOpen || $[16] !== isMarkdownMode || $[17] !== isModernEmbeddedConfluence || $[18] !== isNetworkDisabled || $[19] !== isSpaceNameLongerThan6Letters || $[20] !== push || $[21] !== shouldDisableMoveButton || $[22] !== showInlineRename || $[23] !== spaceData.alias || $[24] !== spaceHomepageId || $[25] !== spaceKey || $[26] !== spaceName || $[27] !== ssrPlaceholderIdProp || $[28] !== subType || $[29] !== testId) {
        const baseContentTitle = contentTitle === "" ? intl.formatMessage($7c978e5ad74fbe60$var$i18n.untitledPage) : contentTitle;
        const contentTitleToRender = isMarkdownMode && baseContentTitle ? `${baseContentTitle}.md` : baseContentTitle;
        const shouldOpenDropdown = contentTitleToRender || showInlineRename;
        shouldShowCurrentContentTitle = contentTitleToRender && !showInlineRename;
        let t10;
        if ($[37] !== spaceData.alias || $[38] !== spaceHomepageId || $[39] !== spaceKey) {
            t10 = (0, $hzkzq.buildContentPath)({
                contentType: "page",
                isSpaceOverview: true,
                query: spaceHomepageId ? {
                    [(0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY]: spaceHomepageId
                } : undefined,
                spaceAlias: spaceData.alias,
                spaceKey: spaceKey
            });
            $[37] = spaceData.alias;
            $[38] = spaceHomepageId;
            $[39] = spaceKey;
            $[40] = t10;
        } else t10 = $[40];
        const spaceOverviewPath = t10;
        const handleBreadcrumbDropdownTriggerClick = ()=>{
            if (shouldOpenDropdown) {
                if (!isBreadcrumbsPopupOpen) {
                    experienceTracker.start({
                        name: (0, $irVI7.BREADCRUMBS_DROPDOWN_EXPERIENCE)
                    });
                    createAnalyticsEvent({
                        type: "sendUIEvent",
                        data: {
                            action: "opened",
                            actionSubject: "breadcrumbsDropdown",
                            source: "breadcrumbs",
                            attributes: {
                                isContentWrapper: true
                            }
                        }
                    }).fire();
                }
                setIsBreadcrumbsPopupOpen(!isBreadcrumbsPopupOpen);
            } else push(spaceOverviewPath);
        };
        const popupContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7c978e5ad74fbe60$var$BreadcrumbsDropdownContent, {
                spaceKey: spaceKey,
                contentId: contentId,
                closeDropdownOnClickOfBreadcrumbItem: closeDropdownOnClickOfBreadcrumbItem,
                spaceOverviewPath: spaceOverviewPath,
                shouldDisableMoveButton: shouldDisableMoveButton,
                contentTitle: contentTitleToRender
            });
        const closeDropdownOnClickOfBreadcrumbItem = ()=>{
            setIsBreadcrumbsPopupOpen(false);
        };
        let t11;
        if ($[41] !== contentId || $[42] !== spaceKey) {
            t11 = ()=>{
                (0, $ePiuX.preloadBreadcrumbsDropdown)({
                    spaceKey: spaceKey,
                    contentId: contentId
                });
            };
            $[41] = contentId;
            $[42] = spaceKey;
            $[43] = t11;
        } else t11 = $[43];
        const preloadBreadcrumbsDropdownOnSpaceNameHover = t11;
        const renderPopup = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
                isOpen: isBreadcrumbsPopupOpen,
                onClose: ()=>setIsBreadcrumbsPopupOpen(false),
                placement: "bottom-start",
                content: popupContent,
                trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
                        id: "breadcrumbs-dropdown-chevron-button",
                        "data-testid": "breadcrumbs-dropdown-chevron-button",
                        disabled: isNetworkDisabled,
                        onClick: handleBreadcrumbDropdownTriggerClick,
                        onMouseEnter: preloadBreadcrumbsDropdownOnSpaceNameHover,
                        onFocus: preloadBreadcrumbsDropdownOnSpaceNameHover,
                        "aria-label": intl.formatMessage($7c978e5ad74fbe60$var$i18n.breadcrumbsChevronButtonAriaLabel),
                        ...triggerProps,
                        ...ssrPlaceholderIdProp,
                        className: (0, $hekY6.default)([
                            "_2rko12b0 _19it1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1rjcidpf _18zridpf _1e0c1o8l _80omtlke _1o9zidpf _1bsb1osq _bfhksm61 _syaz1rpy _1vnv1r31 _1b5cglyw _1avfnqa1 _10fu1rpy _j5dh73ad _f8pjazsu _mizu1v1w _1ah3v77o _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _9h8hi7uo",
                            shouldOpenDropdown && "_p12fp3fh _1bsbn7od _8fz6ucft",
                            displayMode === "ONLY_SPACE_NAME" && "_16jlidpf _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _p12f1kdj _1bsbn7od _8fz61kdj",
                            displayMode === "ONLY_CONTENT_TITLE" && "_p12f1osq _1bto1l2s _8fz61osq",
                            displayMode === "HIDDEN" && "_1e0cglyw"
                        ])
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
                        alignItems: "center",
                        gap: "space.100"
                    }, shouldOpenDropdown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                        content: !isNetworkDisabled && intl.formatMessage($7c978e5ad74fbe60$var$i18n.breadcrumbsChevronButtonTooltip),
                        hideTooltipOnClick: true
                    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                            xcss: [
                                $7c978e5ad74fbe60$var$chevronBaseStyles,
                                !isNetworkDisabled && $7c978e5ad74fbe60$var$chevronHoverStyles
                            ],
                            ...tooltipProps
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                            label: "",
                            color: "var(--ds-icon-subtle, #505258)",
                            size: "small"
                        }))), renderSpaceName()))
            }), shouldOpenDropdown && renderSeparator());
        renderContentTitle = ()=>{
            const titleElement = contentLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
                href: contentLink,
                className: (0, $hekY6.default)([
                    "_1reo15vq _18m915vq _11c81qyo _o5721q9c _1bto1l2s _1ul91tcg _syazi7uo _1053i7uo _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _1vhvi7uo _1m0aglyw"
                ])
            }, contentTitleToRender) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: (0, $hekY6.default)([
                    "_1reo15vq _18m915vq _11c81qyo _o5721q9c _1bto1l2s _1ul91tcg _syazi7uo _1m0aglyw"
                ])
            }, contentTitleToRender);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                id: "breadcrumbs-content-title",
                className: (0, $hekY6.default)([
                    "_zulpu2gc _1reo15vq _18m915vq _v564glyw _1e0c1txw _4cvr1h6o _tzy4kb7n _p12f1c3h",
                    (displayMode === "HIDDEN" || displayMode === "ONLY_SPACE_NAME") && "_tzy4idpf _p12fidpf",
                    isModernEmbeddedConfluence && "_bozgu2gc"
                ])
            }, (contentType === "page" || contentType === "blogpost") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCECL.ContentIcon), {
                type: contentType,
                subType: subType,
                color: "var(--ds-text, #292A2E)",
                isMarkdownMode: isMarkdownMode
            }), titleElement);
        };
        const renderSpaceName = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                id: "breadcrumbs-space-name",
                className: (0, $hekY6.default)([
                    "_1reo15vq _18m915vq _11c8fhey _1bto1l2s _1bsb1osq _o5721q9c _p12f1osq",
                    shouldOpenDropdown && displayMode === "FULL" && "_1bton7od",
                    shouldOpenDropdown && isSpaceNameLongerThan6Letters && displayMode === "FULL" && "_1nwpsavl _1w80savl",
                    (displayMode === "HIDDEN" || displayMode === "ONLY_CONTENT_TITLE") && "_1e0cglyw"
                ])
            }, spaceName);
        const renderSeparator = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                id: "breadcrumbs-separator",
                className: (0, $hekY6.default)([
                    "_syazazsu _lcxvglyw _1o9zidpf _2hwx1b66 _18u01b66",
                    !showInlineRename && "_1m0aglyw",
                    displayMode != "FULL" && "_1e0cglyw"
                ])
            }, "/");
        T0 = (0, $kA6Zo.default);
        const t12 = showInlineRename && $7c978e5ad74fbe60$var$inlineRenameBreadcrumbsStyles;
        if ($[44] !== t12) {
            t6 = [
                $7c978e5ad74fbe60$var$breadcrumbsStyles,
                t12
            ];
            $[44] = t12;
            $[45] = t6;
        } else t6 = $[45];
        t7 = testId;
        t8 = testId;
        t9 = !isModernEmbeddedConfluence && renderPopup();
        $[7] = contentId;
        $[8] = contentLink;
        $[9] = contentTitle;
        $[10] = contentType;
        $[11] = createAnalyticsEvent;
        $[12] = displayMode;
        $[13] = experienceTracker;
        $[14] = intl;
        $[15] = isBreadcrumbsPopupOpen;
        $[16] = isMarkdownMode;
        $[17] = isModernEmbeddedConfluence;
        $[18] = isNetworkDisabled;
        $[19] = isSpaceNameLongerThan6Letters;
        $[20] = push;
        $[21] = shouldDisableMoveButton;
        $[22] = showInlineRename;
        $[23] = spaceData.alias;
        $[24] = spaceHomepageId;
        $[25] = spaceKey;
        $[26] = spaceName;
        $[27] = ssrPlaceholderIdProp;
        $[28] = subType;
        $[29] = testId;
        $[30] = T0;
        $[31] = renderContentTitle;
        $[32] = shouldShowCurrentContentTitle;
        $[33] = t6;
        $[34] = t7;
        $[35] = t8;
        $[36] = t9;
    } else {
        T0 = $[30];
        renderContentTitle = $[31];
        shouldShowCurrentContentTitle = $[32];
        t6 = $[33];
        t7 = $[34];
        t8 = $[35];
        t9 = $[36];
    }
    let t10;
    if ($[46] !== renderContentTitle || $[47] !== shouldShowCurrentContentTitle) {
        t10 = shouldShowCurrentContentTitle && renderContentTitle();
        $[46] = renderContentTitle;
        $[47] = shouldShowCurrentContentTitle;
        $[48] = t10;
    } else t10 = $[48];
    let t11;
    if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.BREADCRUMBS_EXPERIENCE)
        });
        $[49] = t11;
    } else t11 = $[49];
    let t12;
    if ($[50] !== T0 || $[51] !== t10 || $[52] !== t6 || $[53] !== t7 || $[54] !== t8 || $[55] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            xcss: t6,
            testId: t7,
            "data-vc": t8
        }, t9, t10, t11);
        $[50] = T0;
        $[51] = t10;
        $[52] = t6;
        $[53] = t7;
        $[54] = t8;
        $[55] = t9;
        $[56] = t12;
    } else t12 = $[56];
    return t12;
} : ({ contentTitle: contentTitle, spaceKey: spaceKey, contentId: contentId, testId: testId = 'breadcrumbs-with-space-name-dropdown', showInlineRename: showInlineRename = false, shouldDisableMoveButton: shouldDisableMoveButton = false, displayMode: displayMode, contentLink: contentLink, contentType: contentType, subType: subType })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isBreadcrumbsPopupOpen, setIsBreadcrumbsPopupOpen] = (0, $cozmU.useState)(false);
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { data: spaceData, error: error } = (0, $kqIWy.useSpaceDetail)(spaceKey);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const spaceHomepageId = (0, $bMPhU.useSpaceHomepageId)(spaceKey);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const isModernEmbeddedConfluence = (0, $1jQpq.useEmbeddedModernHeader)();
    const isLivePage = contentType === 'page' && subType === 'live';
    const isMarkdownMode = (0, $LSims.useIsMarkdownMode)(isLivePage ? contentId : undefined);
    const [{ isCollabOffline: isCollabOffline }] = (0, $kM55L.useCollabNetworkStatus)(); // Network status is used when:
    // - isCollabOffline: The collab provider has detected a network disconnection
    // - platform_editor_offline_editing_web: Parent experiment for offline editing experience (must be enabled)
    // - platform_editor_offline_editing_wrapper_override: Kill switch to disable this feature (must be disabled)
    const isNetworkDisabled = isCollabOffline && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false) && !(0, $9wGTI.fg)('platform_editor_offline_editing_wrapper_override'); // Note don't check for loading as when refreshing data we will get data={...} and loading=true
    // In this case if we display the placeholder it will flash before the data is displayed
    // We should continue render with existing data and then update when the new data is available
    if (error || !spaceData) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gfIPU.ExperienceFailure), {
        name: (0, $irVI7.BREADCRUMBS_EXPERIENCE),
        error: error
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7c978e5ad74fbe60$var$BreadcrumbsPlaceholder, null));
    const spaceName = spaceData.name || spaceData.alias || spaceKey;
    const isSpaceNameLongerThan6Letters = spaceName?.length > 6;
    const baseContentTitle = contentTitle === '' ? intl.formatMessage($7c978e5ad74fbe60$var$i18n.untitledPage) : contentTitle;
    const contentTitleToRender = isMarkdownMode && baseContentTitle ? `${baseContentTitle}.md` : baseContentTitle;
    const shouldOpenDropdown = contentTitleToRender || showInlineRename;
    const shouldShowCurrentContentTitle = contentTitleToRender && !showInlineRename;
    const spaceOverviewPath = (0, $hzkzq.buildContentPath)({
        contentType: 'page',
        isSpaceOverview: true,
        query: spaceHomepageId ? {
            [(0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY]: spaceHomepageId
        } : undefined,
        spaceAlias: spaceData.alias,
        spaceKey: spaceKey
    });
    const handleBreadcrumbDropdownTriggerClick = ()=>{
        if (shouldOpenDropdown) {
            if (!isBreadcrumbsPopupOpen) {
                experienceTracker.start({
                    name: (0, $irVI7.BREADCRUMBS_DROPDOWN_EXPERIENCE)
                });
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'opened',
                        actionSubject: 'breadcrumbsDropdown',
                        source: 'breadcrumbs',
                        attributes: {
                            isContentWrapper: true
                        }
                    }
                }).fire();
            }
            setIsBreadcrumbsPopupOpen(!isBreadcrumbsPopupOpen);
        } else push(spaceOverviewPath);
    };
    const popupContent = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7c978e5ad74fbe60$var$BreadcrumbsDropdownContent, {
            spaceKey: spaceKey,
            contentId: contentId,
            closeDropdownOnClickOfBreadcrumbItem: closeDropdownOnClickOfBreadcrumbItem,
            spaceOverviewPath: spaceOverviewPath,
            shouldDisableMoveButton: shouldDisableMoveButton,
            contentTitle: contentTitleToRender
        });
    };
    const closeDropdownOnClickOfBreadcrumbItem = ()=>{
        setIsBreadcrumbsPopupOpen(false);
    };
    const preloadBreadcrumbsDropdownOnSpaceNameHover = ()=>{
        (0, $ePiuX.preloadBreadcrumbsDropdown)({
            spaceKey: spaceKey,
            contentId: contentId
        });
    }; /* TODO: Add `shouldRenderToParent` to resolve accessibility issues. See https://a11y.atlassian.net/browse/JCATS-788 */ 
    const renderPopup = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
            isOpen: isBreadcrumbsPopupOpen,
            onClose: ()=>setIsBreadcrumbsPopupOpen(false),
            placement: "bottom-start",
            content: popupContent,
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
                    id: "breadcrumbs-dropdown-chevron-button",
                    "data-testid": "breadcrumbs-dropdown-chevron-button",
                    disabled: isNetworkDisabled,
                    onClick: handleBreadcrumbDropdownTriggerClick,
                    onMouseEnter: preloadBreadcrumbsDropdownOnSpaceNameHover,
                    onFocus: preloadBreadcrumbsDropdownOnSpaceNameHover,
                    "aria-label": intl.formatMessage($7c978e5ad74fbe60$var$i18n.breadcrumbsChevronButtonAriaLabel),
                    ...triggerProps,
                    ...ssrPlaceholderIdProp,
                    className: (0, $hekY6.default)([
                        "_2rko12b0 _19it1j28 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1rjcidpf _18zridpf _1e0c1o8l _80omtlke _1o9zidpf _1bsb1osq _bfhksm61 _syaz1rpy _1vnv1r31 _1b5cglyw _1avfnqa1 _10fu1rpy _j5dh73ad _f8pjazsu _mizu1v1w _1ah3v77o _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _9h8hi7uo",
                        shouldOpenDropdown && "_p12fp3fh _1bsbn7od _8fz6ucft",
                        displayMode === "ONLY_SPACE_NAME" && "_16jlidpf _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _p12f1kdj _1bsbn7od _8fz61kdj",
                        displayMode === "ONLY_CONTENT_TITLE" && "_p12f1osq _1bto1l2s _8fz61osq",
                        displayMode === "HIDDEN" && "_1e0cglyw"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
                    alignItems: "center",
                    gap: "space.100"
                }, shouldOpenDropdown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                    content: !isNetworkDisabled && intl.formatMessage($7c978e5ad74fbe60$var$i18n.breadcrumbsChevronButtonTooltip),
                    hideTooltipOnClick: true
                }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                        xcss: [
                            $7c978e5ad74fbe60$var$chevronBaseStyles,
                            !isNetworkDisabled && $7c978e5ad74fbe60$var$chevronHoverStyles
                        ],
                        ...tooltipProps
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)",
                        size: "small"
                    }))), renderSpaceName()))
        }), shouldOpenDropdown && renderSeparator());
    const renderContentTitle = ()=>{
        const titleElement = contentLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
            href: contentLink,
            className: (0, $hekY6.default)([
                "_1reo15vq _18m915vq _11c81qyo _o5721q9c _1bto1l2s _1ul91tcg _syazi7uo _1053i7uo _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _1vhvi7uo _1m0aglyw"
            ])
        }, contentTitleToRender) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                "_1reo15vq _18m915vq _11c81qyo _o5721q9c _1bto1l2s _1ul91tcg _syazi7uo _1m0aglyw"
            ])
        }, contentTitleToRender);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            id: "breadcrumbs-content-title",
            className: (0, $hekY6.default)([
                "_zulpu2gc _1reo15vq _18m915vq _v564glyw _1e0c1txw _4cvr1h6o _tzy4kb7n _p12f1c3h",
                (displayMode === "HIDDEN" || displayMode === "ONLY_SPACE_NAME") && "_tzy4idpf _p12fidpf",
                isModernEmbeddedConfluence && "_bozgu2gc"
            ])
        }, (contentType === 'page' || contentType === 'blogpost') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bCECL.ContentIcon), {
            type: contentType,
            subType: subType,
            color: "var(--ds-text, #292A2E)",
            isMarkdownMode: isMarkdownMode
        }), titleElement);
    };
    const renderSpaceName = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            id: "breadcrumbs-space-name",
            className: (0, $hekY6.default)([
                "_1reo15vq _18m915vq _11c8fhey _1bto1l2s _1bsb1osq _o5721q9c _p12f1osq",
                shouldOpenDropdown && displayMode === "FULL" && "_1bton7od",
                shouldOpenDropdown && isSpaceNameLongerThan6Letters && displayMode === "FULL" && "_1nwpsavl _1w80savl",
                (displayMode === "HIDDEN" || displayMode === "ONLY_CONTENT_TITLE") && "_1e0cglyw"
            ])
        }, spaceName);
    };
    const renderSeparator = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            id: "breadcrumbs-separator",
            className: (0, $hekY6.default)([
                "_syazazsu _lcxvglyw _1o9zidpf _2hwx1b66 _18u01b66",
                !showInlineRename && "_1m0aglyw",
                displayMode != "FULL" && "_1e0cglyw"
            ])
        }, "/");
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        xcss: [
            $7c978e5ad74fbe60$var$breadcrumbsStyles,
            showInlineRename && $7c978e5ad74fbe60$var$inlineRenameBreadcrumbsStyles
        ],
        testId: testId,
        "data-vc": testId
    }, !isModernEmbeddedConfluence && renderPopup(), shouldShowCurrentContentTitle && renderContentTitle(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.BREADCRUMBS_EXPERIENCE)
    }));
};
const $7c978e5ad74fbe60$var$i18n = (0, $kSwu1.defineMessages)({
    breadcrumbsChevronButtonAriaLabel: {
        id: "breadcrumbs.dropdown.button.chevron.aria-label",
        defaultMessage: "Breadcrumbs"
    },
    untitledPage: {
        id: "breadcrumbs.dropdown.untitled-page.default-title",
        defaultMessage: "Untitled"
    },
    breadcrumbsChevronButtonTooltip: {
        id: "breadcrumbs.dropdown.button.chevron.tooltip",
        defaultMessage: "Show navigation path"
    }
});
module.exports["BREADCRUMBS_MODES"] = $7c978e5ad74fbe60$export$14e8342ddf0a4616;
module.exports["BreadcrumbsWithSpaceNameDropdown"] = $7c978e5ad74fbe60$export$c71a066c29807b48;

});

parcelRegister("1jQpq", function(module, exports) {

var $lTECB = parcelRequire("lTECB");


var $cxu5H = parcelRequire("cxu5H");

const $951eaa69b00dd6e9$export$f183b986124d184 = ()=>{
    const isEmbeddedConfluence = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    const { hasModernHeader: hasModernHeader } = (0, $cxu5H.useEmbeddedViewPageFeatures)();
    return isEmbeddedConfluence && hasModernHeader;
};
module.exports["useEmbeddedModernHeader"] = $951eaa69b00dd6e9$export$f183b986124d184;

});

parcelRegister("ePiuX", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $f4Qot = parcelRequire("f4Qot");

function $e956eba1dd4bb7db$export$e5d3f19aa88b9c61({ spaceKey: spaceKey, contentId: contentId }) {
    return (0, $dYU3e.query)({
        query: (0, $f4Qot.default),
        variables: {
            spaceKey: spaceKey,
            contentId: contentId,
            skipContent: !contentId
        },
        __callerPackage__: "breadcrumbs"
    });
}
module.exports["preloadBreadcrumbsDropdown"] = $e956eba1dd4bb7db$export$e5d3f19aa88b9c61;

});

parcelRegister("f4Qot", function(module, exports) {
/**
 * @generated SignedSource<<316873462d81660513b39d3d9a706212>>
 * @relayHash eacc72b6f9ecbeb5ab52a1b74d6064a5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4b8a86e7d74a33ca56fd7bd765cf5fe7190dcc5b4651d4e2fc4666574c7cc9b4
const $ef0655697d43d9a3$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipContent"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "status"
    }, v7 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ], v8 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ 
                    ]
                }
            ]
        },
        {
            "condition": "skipContent",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Literal",
                            "name": "status",
                            "value": [
                                "current",
                                "draft",
                                "archived"
                            ]
                        }
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "keys",
                                            "value": [
                                                "emoji-title-published",
                                                "emoji-title-draft"
                                            ]
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v7 /*: any*/ ,
                                    "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"])"
                                },
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        v6 /*: any*/ ,
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "keys",
                                                    "value": [
                                                        "emoji-title-published"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "PaginatedJsonContentPropertyList",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": v7 /*: any*/ ,
                                            "storageKey": "properties(keys:[\"emoji-title-published\"])"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "BreadcrumbsDropdownContentQuery",
            "selections": v8 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "BreadcrumbsDropdownContentQuery",
            "selections": v8 /*: any*/ 
        },
        "params": {
            "cacheID": "eacc72b6f9ecbeb5ab52a1b74d6064a5",
            "id": "4b8a86e7d74a33ca56fd7bd765cf5fe7190dcc5b4651d4e2fc4666574c7cc9b4",
            "metadata": {},
            "name": "BreadcrumbsDropdownContentQuery",
            "operationKind": "query",
            "text": "query BreadcrumbsDropdownContentQuery($spaceKey:String!,$contentId:ID,$skipContent:Boolean!){space(key:$spaceKey){alias,id,name,icon{path},homepage{id}},content(id:$contentId,status:[\"current\",\"draft\",\"archived\"])@skip(if:$skipContent){nodes{id,type,subType,status,properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"]){nodes{id,key,value}},ancestors{id,type,subType,title,status,properties(keys:[\"emoji-title-published\"]){nodes{id,key,value}}}}}}"
        }
    };
}();
$ef0655697d43d9a3$var$node.hash = "3e4a9d4b445d7d646b220e3bab421884";
var $ef0655697d43d9a3$export$2e2bcd8739ae039 = $ef0655697d43d9a3$var$node;
module.exports["default"] = $ef0655697d43d9a3$export$2e2bcd8739ae039;

});

parcelRegister("9F9OU", function(module, exports) {

let $708f8f7ad58299c6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $708f8f7ad58299c6$var$load("bYzij"),
    $708f8f7ad58299c6$var$load("6wr18"),
    $708f8f7ad58299c6$var$load("ffEVr"),
    $708f8f7ad58299c6$var$load("hhss7"),
    $708f8f7ad58299c6$var$load("7EorR"),
    $708f8f7ad58299c6$var$load("1GyAj")
]).then(()=>parcelRequire('auDgK'));

});

parcelRegister("5PKaL", function(module, exports) {

let $43f5881612af494e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $43f5881612af494e$var$load("6wr18"),
    $43f5881612af494e$var$load("ffEVr"),
    $43f5881612af494e$var$load("hhss7"),
    $43f5881612af494e$var$load("Wowvf"),
    $43f5881612af494e$var$load("b6JBs")
]).then(()=>parcelRequire('g3Wvh'));

});

parcelRegister("cuWTe", function(module, exports) {
const $52d439f2e3e46670$export$5d6b4e71896e8f23 = (contentType, isArchived, isDraft, isViewEditOrLive)=>{
    // archived takes priority, since other modes like 'view' can be in this state
    if (isArchived) return 'archived';
    // useGetPageMode *always* returns one of 'live', 'view', or 'edit', but these modes don't apply across all
    // content types - so the content type doesn't have a 'mode' and we should return undefined
    if (contentType === 'page' || contentType === 'blogpost') {
        // then draft takes next priority, since other modes like 'edit' can be in this state
        if (isDraft) return 'draft';
        // technically only pages can be live at the moment, and blogposts wouldn't ever return live, but they *could*
        return isViewEditOrLive;
    } else return undefined;
};
module.exports["getContentMode"] = $52d439f2e3e46670$export$5d6b4e71896e8f23;

});

parcelRegister("lyx2E", function(module, exports) {
/* contentTypesHeaderStyles.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $w6R6I = parcelRequire("w6R6I");


var $3izAL = parcelRequire("3izAL");

const $3d1681a377877e6e$export$e139d3b51c488e9b = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFloating: isFloating, hasPointerEvents: hasPointerEvents, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1fwhixl": (0, $9aYkv.default)((()=>{
                return __cmplp.isFloating ? 'absolute' : 'relative';
            })()),
            "--_17xabpo": (0, $9aYkv.default)((()=>{
                return __cmplp.hasPointerEvents ? 'auto' : 'none';
            })())
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_bfhk1j28 _kqswlr7h _lcxv12je _1bsb1osq _1e0c11p5",
            __cmplp.className
        ])
    });
});
const $3d1681a377877e6e$var$styles = {
    base: "_2rko12b0 _18zru2gc _lcxv1wug _bfhkvuon _85i51b66 _1e0c1txw _1n261q9c _1q511b66 _4t3i1osq",
    alignCenter: "_1wpz1h6o"
};
const $3d1681a377877e6e$export$b1249ef660098484 = ({ isContentHeaderPinned: isContentHeaderPinned = false, xcss: xcss, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: (0, $w6R6I.cx)($3d1681a377877e6e$var$styles.base, isContentHeaderPinned && $3d1681a377877e6e$var$styles.alignCenter, xcss)
    }, children);
};
module.exports["ContentTypesHeaderContainer"] = $3d1681a377877e6e$export$e139d3b51c488e9b;
module.exports["TitleAndBreadcrumbsWrapper"] = $3d1681a377877e6e$export$b1249ef660098484;

});

parcelRegister("deZfn", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $3af5d746447ab7ac$export$a32ab742d345a2c9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "u0VI7",
    name: "ArchivedPageBanner",
    loader: async ()=>(await (parcelRequire("5ZyCZ"))).ArchivedPageBanner
});
module.exports["ArchivedPageBanner"] = $3af5d746447ab7ac$export$a32ab742d345a2c9;

});

parcelRegister("5ZyCZ", function(module, exports) {

let $45cd829fc48bdef7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $45cd829fc48bdef7$var$load("6rpul").then(()=>parcelRequire('2ZkUh'));

});

parcelRegister("8z0fF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $kC9tB = parcelRequire("kC9tB");


const $fcf77a474368dc3c$export$2626335f65c6c2ab = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "GPirm",
    name: "EmojiTitleSelection",
    loader: async ()=>(await (parcelRequire("7OPVN"))).EmojiTitleSelection,
    loading: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kC9tB.EmojiTitleSelectionPlaceholder), props)
});
module.exports["EmojiTitleSelection"] = $fcf77a474368dc3c$export$2626335f65c6c2ab;

});

parcelRegister("kC9tB", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $crLHf = parcelRequire("crLHf");

// Altogether, the container width should be equivalent to the width of EmojiTitleSelection once loaded
const $12207dce16c7aead$var$paddingStyle = (0, $buxP3.xcss)({
    paddingRight: 'space.150',
    // this is the spacing between the emoji button and the title
    paddingLeft: 'space.050' // necessary for left aligning placeholder with emoji button (value comes from from button base)
});
const $12207dce16c7aead$export$f477b16652398d6f = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { hasInitialEmoji: hasInitialEmoji, hasCoverPicture: hasCoverPicture, isTitleCenterAligned: isTitleCenterAligned } = t0;
    const needsPadding = !hasCoverPicture && !isTitleCenterAligned;
    let t1;
    if ($[0] !== hasCoverPicture || $[1] !== hasInitialEmoji || $[2] !== needsPadding) {
        t1 = hasInitialEmoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: needsPadding ? $12207dce16c7aead$var$paddingStyle : null,
            testId: "emoji-selection-placeholder-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $crLHf.EmojiPlaceholder), {
            height: hasCoverPicture ? 80 : 40
        })) : null;
        $[0] = hasCoverPicture;
        $[1] = hasInitialEmoji;
        $[2] = needsPadding;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["EmojiTitleSelectionPlaceholder"] = $12207dce16c7aead$export$f477b16652398d6f;

});

parcelRegister("7OPVN", function(module, exports) {

let $5b157c642c52fdc6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5b157c642c52fdc6$var$load("bYzij"),
    $5b157c642c52fdc6$var$load("dlm6q"),
    $5b157c642c52fdc6$var$load("ddvkk"),
    $5b157c642c52fdc6$var$load("3upHR"),
    $5b157c642c52fdc6$var$load("iUXaE"),
    $5b157c642c52fdc6$var$load("lTkx9"),
    $5b157c642c52fdc6$var$load("6HpsR"),
    $5b157c642c52fdc6$var$load("N3oqb"),
    $5b157c642c52fdc6$var$load("hZ2FX"),
    $5b157c642c52fdc6$var$load("6wr18"),
    $5b157c642c52fdc6$var$load("ffEVr"),
    $5b157c642c52fdc6$var$load("4Ldt2"),
    $5b157c642c52fdc6$var$load("kFiBp"),
    $5b157c642c52fdc6$var$load("6KGrg"),
    $5b157c642c52fdc6$var$load("daX4F"),
    $5b157c642c52fdc6$var$load("4hZJd")
]).then(()=>parcelRequire('leLdu'));

});

parcelRegister("iOaib", function(module, exports) {
/**
 * The markdown filename suffix. Used as a visual hint when a content
 * surface is in markdown mode, and as the gesture trigger for switching
 * to markdown mode (e.g. typing `.md` at the end of a title).
 */ const $aeb0c44d8485e554$export$509c4be251ab8715 = '.md';
const $aeb0c44d8485e554$export$10607f80e07a7230 = (s)=>s.trimEnd().endsWith($aeb0c44d8485e554$export$509c4be251ab8715);
const $aeb0c44d8485e554$export$47193e44f183d52c = (s)=>{
    const trimmed = s.trimEnd();
    return trimmed.endsWith($aeb0c44d8485e554$export$509c4be251ab8715) ? trimmed.slice(0, -$aeb0c44d8485e554$export$509c4be251ab8715.length) : s;
};
module.exports["MARKDOWN_SUFFIX"] = $aeb0c44d8485e554$export$509c4be251ab8715;
module.exports["endsWithMarkdownSuffix"] = $aeb0c44d8485e554$export$10607f80e07a7230;
module.exports["stripMarkdownSuffix"] = $aeb0c44d8485e554$export$47193e44f183d52c;

});

parcelRegister("lt6Lx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $d5RCH = parcelRequire("d5RCH");


var $1ytiN = parcelRequire("1ytiN");


var $gSgn8 = parcelRequire("gSgn8");


var $8vxJi = parcelRequire("8vxJi");

const $5a5ab99dc3af9e56$var$i18n = (0, $kSwu1.defineMessages)({
    notFound: {
        id: "document-title.not.found",
        defaultMessage: "Page Not Found"
    }
});
const $5a5ab99dc3af9e56$export$8f4c40b84dd15d46 = ({ titlePrefix: titlePrefix = '', contentTitle: contentTitle = '', contentSpace: contentSpace = '', siteTitleOnly: siteTitleOnly = false, notFound: notFound = false, isHomePage: isHomePage = false })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { siteTitle: siteTitle } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            window['__DOCUMENT_TITLE_TAG__'] = '';
        };
    }, []);
    // In the case when page is rendered by SSR, the __DOCUMENT_TITLE_TAG__ will be
    // populated and we can skip document title — but only when this render has no
    // meaningful content to contribute. If contentTitle, titlePrefix, notFound,
    // isHomePage, or siteTitleOnly are set, we must still update the title
    // (e.g. relay race: new page renders before old cleanup effect runs).
    if (window['__DOCUMENT_TITLE_TAG__'] && window['__SSR_RENDERED__'] && // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.title && !contentTitle && !titlePrefix && !notFound && !isHomePage && !siteTitleOnly) return null;
    const title = [
        titlePrefix || (notFound ? intl.formatMessage($5a5ab99dc3af9e56$var$i18n.notFound) : ''),
        siteTitleOnly ? undefined : contentTitle,
        siteTitleOnly ? undefined : contentSpace,
        siteTitle
    ].filter((part)=>part).join(' - ');
    // Don't override an existing title with a less specific one (e.g., don't set "Confluence"
    // when there's already a title with content like "Page Title - Space - Confluence").
    // This prevents components with empty contentTitle from overriding titles set by components
    // with actual content during navigation/rendering transitions.
    // Note: This check happens during render, so it may not catch titles set in the same render cycle,
    // but useLayoutEffect in PageTitle ensures the last component to render wins.
    // A title is considered "specific" if it provides either a contentTitle or a titlePrefix.
    // Pages like the advanced search page pass a titlePrefix (e.g. "Search") without a
    // contentTitle, and we must still allow that title to replace the previous page's title
    // during client-side navigation. notFound, isHomePage, and siteTitleOnly are also
    // meaningful signals that must always be allowed to update the title.
    if (typeof document !== 'undefined' && document.title && !contentTitle && !titlePrefix && !notFound && !isHomePage && !siteTitleOnly) {
        // If contentTitle, titlePrefix, notFound, isHomePage, and siteTitleOnly are all empty/false,
        // we're likely setting a generic title (just siteTitle or siteTitle with space).
        // If there's already a more specific title (3+ parts, or 2 parts where first isn't siteTitle), skip.
        const existingTitleParts = document.title.split(' - ');
        const hasMoreSpecificContent = existingTitleParts.length > 2 || existingTitleParts.length === 2 && existingTitleParts[0] !== siteTitle;
        // Skip if we're trying to set a less specific title when a more specific one exists and it is not the home page
        if (hasMoreSpecificContent && title !== document.title) return null;
    }
    // Set for SSR document title
    window['__DOCUMENT_TITLE_TAG__'] = title;
    if (window.__SSR_REACT_STREAMING__) {
        const inject = (0, $gSgn8.getStreamInject)();
        inject(()=>`document.title=${(0, $8vxJi.stringifyForSSR)(title)}`);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5RCH.PageTitle), {
        title: title
    });
};
module.exports["DocumentContentTitle"] = $5a5ab99dc3af9e56$export$8f4c40b84dd15d46;

});

parcelRegister("iAOfI", function(module, exports) {

var $4YBSq = parcelRequire("4YBSq");


var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $jMyy4 = parcelRequire("jMyy4");


var $lfoFx = parcelRequire("lfoFx");


var $lTECB = parcelRequire("lTECB");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $gkIgp = parcelRequire("gkIgp");


var $6GD8y = parcelRequire("6GD8y");


var $gnkil = parcelRequire("gnkil");


var $7aRa9 = parcelRequire("7aRa9");


var $3u7PM = parcelRequire("3u7PM");


var $c4cfx = parcelRequire("c4cfx");


var $7mHcA = parcelRequire("7mHcA");

const $25b07369982b4436$var$EditContentButtonQuery = (0, $4YBSq.default);
const $25b07369982b4436$var$EditContentButtonInner = (0, $7aRa9.withFlags)(({ flags: flags, contentId: contentId, isCompanyHubButton: isCompanyHubButton, ...passThroughProps })=>{
    const { epMigrationOnLoad: epMigrationOnLoad, epMigrationOnClick: epMigrationOnClick } = (0, $7mHcA.useEmbeddedMigrationQuery)(contentId, true);
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($25b07369982b4436$var$EditContentButtonQuery, {
        variables: {
            contentId: contentId
        },
        // cache-and-network is required to ensure that the edit button is rendered immediately after page publish
        fetchPolicy: 'cache-and-network',
        __callerPackage__: "edit-button"
    });
    const { data: epMigrationOnLoadData, loading: epMigrationOnLoadLoading, error: epMigrationOnLoadError } = epMigrationOnLoad;
    const { migrateEPData: migrateEPData, data: epMigrationOnClickData, loading: epMigrationOnClickLoading, error: epMigrationOnClickError } = epMigrationOnClick;
    const { showNoEditAccessFlag: showNoEditAccessFlag } = (0, $3u7PM.useNoEditAccessFlag)(flags);
    let renderedEditContentButton;
    if (error) renderedEditContentButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    });
    else if (!data && loading || !epMigrationOnLoadData && epMigrationOnLoadLoading || !epMigrationOnClickData && epMigrationOnClickLoading) renderedEditContentButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        interactionName: "edit-content-button",
        size: "small"
    });
    else {
        const contentNode = data?.content?.nodes?.[0];
        const operations = contentNode?.operations ?? [];
        const contentType = contentNode?.type ?? undefined;
        const canEdit = operations.filter((operationCheckResult)=>operationCheckResult?.operation === 'update' && operationCheckResult?.targetType === contentType).length > 0;
        if (!canEdit) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
            accelerator: (0, $gnkil.EDIT_SHORTCUT),
            listener: showNoEditAccessFlag
        });
        const spaceKey = data?.content?.nodes?.[0]?.space?.key ?? undefined;
        const metadataFrontend = data?.content?.nodes?.[0]?.metadata?.frontend;
        const isFabricSupported = metadataFrontend?.fabricEditorSupported ?? false;
        const isNCSContent = metadataFrontend?.collabService === (0, $gkIgp.CollabServiceProperty).NCS;
        // 'edit-embed' route (embedded editor) should only be used inside parent product and when page is ncs
        const isEmbeddedContent = ((0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)() && isNCSContent) ?? false;
        const embeddedMigrationError = epMigrationOnLoadError || epMigrationOnClickError;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, embeddedMigrationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: embeddedMigrationError
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c4cfx.EditContentButtonComponent), {
            contentId: contentId,
            contentType: contentType,
            spaceKey: spaceKey,
            isCompanyHubButton: isCompanyHubButton,
            isFabricSupported: isFabricSupported,
            isEmbeddedContent: isEmbeddedContent,
            migrateEPData: !isNCSContent ? migrateEPData : undefined,
            ...passThroughProps
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
        id: contentId,
        name: (0, $irVI7.VIEW_PAGE_EDIT_BUTTON_EXPERIENCE)
    }), renderedEditContentButton);
});
const $25b07369982b4436$export$3df6d768aebb677f = /*#__PURE__*/ (0, $cozmU.memo)((0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($25b07369982b4436$var$EditContentButtonInner));
$25b07369982b4436$export$3df6d768aebb677f.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    isCompanyHubButton: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    onRender: (0, $c4cfx.EditContentButtonComponent).propTypes?.onRender
};
module.exports["EditContentButton"] = $25b07369982b4436$export$3df6d768aebb677f;

});

parcelRegister("3u7PM", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $3cfcff3140a018ad$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    noEditAccessFlagTitle: {
        id: "edit-features.no-edit-access-flag.title",
        defaultMessage: "This shortcut requires edit access"
    },
    noEditAccessFlagDescription: {
        id: "edit-features.no-edit-access-flag.description",
        defaultMessage: "To use this keyboard shortcut, you'll need edit access to this content."
    }
});
const $3cfcff3140a018ad$export$175b3f54640daa25 = (flags)=>{
    const intl = (0, $kSwu1.useIntl)();
    const showNoEditAccessFlag = ()=>{
        flags.showFlag({
            id: 'live-pages-mode-flag',
            title: intl.formatMessage($3cfcff3140a018ad$export$a7357cdd1f0b0168.noEditAccessFlagTitle),
            description: intl.formatMessage($3cfcff3140a018ad$export$a7357cdd1f0b0168.noEditAccessFlagDescription),
            close: 'auto'
        });
    };
    return {
        showNoEditAccessFlag: showNoEditAccessFlag
    };
};
module.exports["useNoEditAccessFlag"] = $3cfcff3140a018ad$export$175b3f54640daa25;

});

parcelRegister("c4cfx", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6b4nE = parcelRequire("6b4nE");


var $9kbTQ = parcelRequire("9kbTQ");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $5SGpQ = parcelRequire("5SGpQ");


var $gC2EJ = parcelRequire("gC2EJ");


var $5wHqn = parcelRequire("5wHqn");


var $iMnC5 = parcelRequire("iMnC5");


var $4aRua = parcelRequire("4aRua");


var $lfoFx = parcelRequire("lfoFx");


var $lpNn5 = parcelRequire("lpNn5");


var $hDLmU = parcelRequire("hDLmU");

var $c411D = parcelRequire("c411D");


var $jOO7o = parcelRequire("jOO7o");


var $iFjdQ = parcelRequire("iFjdQ");


var $5q601 = parcelRequire("5q601");


var $74Lca = parcelRequire("74Lca");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $emYzJ = parcelRequire("emYzJ");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $39rFu = parcelRequire("39rFu");


var $7NoF3 = parcelRequire("7NoF3");


var $4ri4I = parcelRequire("4ri4I");


var $1NBp8 = parcelRequire("1NBp8");


var $56QzY = parcelRequire("56QzY");


var $7zgzO = parcelRequire("7zgzO");


var $dHSeC = parcelRequire("dHSeC");


var $4o1RV = parcelRequire("4o1RV");


var $de2j9 = parcelRequire("de2j9");


var $hl1Kw = parcelRequire("hl1Kw");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $lqy4C = parcelRequire("lqy4C");


var $sD2Tz = parcelRequire("sD2Tz");


var $ca2z9 = parcelRequire("ca2z9");

const $a4b894acf4b5251f$var$StyledButton = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $5SGpQ.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_701w1ul9",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $a4b894acf4b5251f$var$i18n = (0, $kSwu1.defineMessages)({
    editLabel: {
        id: "edit-button.edit.label",
        defaultMessage: "Edit this content"
    },
    editEmbedLabel: {
        id: "edit-button.edit.embed.label",
        defaultMessage: "Edit this embed"
    },
    editText: {
        id: "edit-button.edit.text",
        defaultMessage: "Edit"
    }
});
const $a4b894acf4b5251f$var$noop = ()=>null;
const $a4b894acf4b5251f$var$EditContentButtonComponentInner = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(119);
    const { contentId: contentId, contentType: contentType, intl: intl, isEmbeddedContent: t1, isFabricSupported: isFabricSupported, onRender: t2, spaceKey: spaceKey, migrateEPData: migrateEPData, isCompanyHubButton: t3 } = t0;
    const isEmbeddedContent = t1 === undefined ? false : t1;
    const onRender = t2 === undefined ? $a4b894acf4b5251f$var$noop : t2;
    const isCompanyHubButton = t3 === undefined ? false : t3;
    const editButtonRef = (0, $cozmU.useRef)(null);
    const [localEditSource, setLocalEditSource] = (0, $cozmU.useState)("");
    const [isPopupVisible, setIsPopupVisible] = (0, $cozmU.useState)(false);
    const { loadEditor: loadEditor } = (0, $39rFu.useEditPageLoadingActions)();
    const { setEditSource: setEditSource } = (0, $4ri4I.useEditSourceActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t4;
    if ($[0] !== createAnalyticsEvent) {
        t4 = (action, analyticsContentId, attributes)=>{
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: action,
                    actionSubject: "editButtonCollabDraftPrefetch",
                    actionSubjectId: analyticsContentId,
                    source: "editButton",
                    attributes: attributes
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = t4;
    } else t4 = $[1];
    const sendPrefetchAnalyticsEvent = t4;
    const routesContext = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const [t5] = (0, $hl1Kw.useSearchSessionId)();
    const { searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics } = t5;
    const { match: match } = routesContext;
    const { routePolicy: routePolicy } = (0, $4o1RV.useNavigationPolicy)();
    let t6;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = {
            source: "page-tree-quick-action-edit"
        };
        $[2] = t6;
    } else t6 = $[2];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t6);
    let t7;
    if ($[3] !== contentId || $[4] !== isFabricSupported) {
        t7 = {
            contentId: contentId,
            isFabricSupported: isFabricSupported
        };
        $[3] = contentId;
        $[4] = isFabricSupported;
        $[5] = t7;
    } else t7 = $[5];
    const { fabricEditorEligibility: fabricEditorEligibility, isFabricEligibilityLoading: isFabricEligibilityLoading } = (0, $ca2z9.useFabricEligibilityMigrationQuery)(t7);
    let t8;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = {
            shortcut: (0, $gnkil.EDIT_SHORTCUT)
        };
        $[6] = t8;
    } else t8 = $[6];
    const editShortcutStrings = (0, $4tOXV.useShortcutStrings)(t8);
    const currentRouteName = match?.name;
    const isBlogpost = contentType === "blogpost";
    const t9 = isBlogpost ? "blog" : "pages";
    let t10;
    if ($[7] !== contentId || $[8] !== spaceKey || $[9] !== t9) {
        t10 = {
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: t9
        };
        $[7] = contentId;
        $[8] = spaceKey;
        $[9] = t9;
        $[10] = t10;
    } else t10 = $[10];
    const linkParams = t10;
    const dataTestId = isFabricSupported ? "fabric-edit-button" : undefined;
    const sendMetrics = (0, $c411D.useEmbeddedConfluenceEventMarkers)();
    let routeType;
    if ($[11] !== isBlogpost || $[12] !== isCompanyHubButton || $[13] !== isEmbeddedContent || $[14] !== isFabricSupported) {
        if (isEmbeddedContent && !isBlogpost) routeType = (0, $1NBp8.EDIT_PAGE_EMBED);
        else {
            if (isCompanyHubButton) routeType = (0, $1NBp8.COMPANY_HUB_EDIT);
            else if (isFabricSupported) routeType = isBlogpost ? (0, $1NBp8.EDIT_BLOG_V2) : (0, $1NBp8.EDIT_PAGE_V2);
            else routeType = isBlogpost ? (0, $1NBp8.EDIT_BLOG) : (0, $1NBp8.EDIT_PAGE);
        }
        $[11] = isBlogpost;
        $[12] = isCompanyHubButton;
        $[13] = isEmbeddedContent;
        $[14] = isFabricSupported;
        $[15] = routeType;
    } else routeType = $[15];
    let t11;
    let t12;
    if ($[16] !== currentRouteName || $[17] !== isBlogpost || $[18] !== setEditSource) {
        t11 = ()=>{
            let entryPoint = (0, $7NoF3.PAGE_EDIT_BUTTON_CLICK);
            if (isBlogpost) entryPoint = (0, $7NoF3.BLOG_EDIT_BUTTON_CLICK);
            const isSpaceOverview = currentRouteName === (0, $1NBp8.SPACE_OVERVIEW).name;
            if (isSpaceOverview) entryPoint = (0, $7NoF3.SPACE_EDIT_BUTTON_CLICK);
            setEditSource(entryPoint);
            setLocalEditSource(entryPoint);
        };
        t12 = [
            isBlogpost,
            setEditSource,
            currentRouteName,
            setLocalEditSource
        ];
        $[16] = currentRouteName;
        $[17] = isBlogpost;
        $[18] = setEditSource;
        $[19] = t11;
        $[20] = t12;
    } else {
        t11 = $[19];
        t12 = $[20];
    }
    (0, $cozmU.useEffect)(t11, t12);
    let t13;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = ()=>editButtonRef && (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).findDOMNode(editButtonRef.current)?.click();
        $[21] = t13;
    } else t13 = $[21];
    const clickEditPencilButton = t13;
    let t14;
    if ($[22] !== currentRouteName || $[23] !== isBlogpost || $[24] !== setEditSource) {
        t14 = (isClick)=>{
            if (!isClick) {
                let entryPoint_0 = (0, $7NoF3.PAGE_EDIT_SHORTCUT_E);
                if (isBlogpost) entryPoint_0 = (0, $7NoF3.BLOG_EDIT_SHORTCUT_E);
                const isSpaceOverview_0 = currentRouteName === (0, $1NBp8.SPACE_OVERVIEW).name;
                if (isSpaceOverview_0) entryPoint_0 = (0, $7NoF3.SPACE_EDIT_SHORTCUT_E);
                setEditSource(entryPoint_0);
                setLocalEditSource(entryPoint_0);
            }
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EDIT_INTENT_EDIT_FMP_ACTION));
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EDIT_INTENT_EDIT_TTI_ACTION));
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureEnd((0, $5q601.VIEW_EDIT_BUTTON_CLICKED_ACTION));
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EDIT_ROUTE_CHANGE_ACTION));
        };
        $[22] = currentRouteName;
        $[23] = isBlogpost;
        $[24] = setEditSource;
        $[25] = t14;
    } else t14 = $[25];
    const measureEditButtonClickConversion = t14;
    let t15;
    if ($[26] !== contentId || $[27] !== contentType || $[28] !== currentRouteName || $[29] !== isBlogpost || $[30] !== isEmbeddedContent || $[31] !== isFabricSupported || $[32] !== linkParams || $[33] !== loadEditor || $[34] !== measureEditButtonClickConversion || $[35] !== migrateEPData || $[36] !== routePolicy || $[37] !== routeType || $[38] !== routesContext || $[39] !== spaceKey) {
        t15 = (e)=>{
            measureEditButtonClickConversion(e.isTrusted);
            (0, $74Lca.rememberScrolledPosition)(contentId);
            const details = (0, $dHSeC.getSpaTransitionDetails)(e, routesContext);
            const routePolicyPushInNewTab = routePolicy && !routePolicy.willPushInSelf(currentRouteName, contentId, routeType.name, contentId);
            if (!isBlogpost && Boolean(migrateEPData) && routePolicyPushInNewTab) {
                e.preventDefault();
                const navigateToEmbeddedEditor = ()=>{
                    routesContext.push((0, $1NBp8.EDIT_PAGE_EMBED).toUrl(linkParams));
                };
                const navigateToClassicEditor = ()=>{
                    routesContext.push(routeType.toUrl(linkParams));
                };
                migrateEPData(navigateToEmbeddedEditor, navigateToClassicEditor);
            }
            if (details?.href && !routePolicyPushInNewTab) {
                e.preventDefault();
                e.stopPropagation();
                if (!e.isTrusted) routesContext.preloadRoute(details.href);
                loadEditor({
                    contentId: contentId,
                    spaceKey: spaceKey,
                    redirectUrl: details.href,
                    contentType: contentType,
                    isFabricSupported: isFabricSupported,
                    isEmbeddedContent: isEmbeddedContent
                });
            }
        };
        $[26] = contentId;
        $[27] = contentType;
        $[28] = currentRouteName;
        $[29] = isBlogpost;
        $[30] = isEmbeddedContent;
        $[31] = isFabricSupported;
        $[32] = linkParams;
        $[33] = loadEditor;
        $[34] = measureEditButtonClickConversion;
        $[35] = migrateEPData;
        $[36] = routePolicy;
        $[37] = routeType;
        $[38] = routesContext;
        $[39] = spaceKey;
        $[40] = t15;
    } else t15 = $[40];
    routeType;
    const onClickEdit = t15;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const mode = match?.query?.mode;
    let t16;
    if ($[41] !== additionalAnalytics || $[42] !== contentId || $[43] !== contentType || $[44] !== isFabricSupported || $[45] !== isOnEditRoute || $[46] !== mode || $[47] !== searchSessionId) {
        t16 = (e_0, analyticsEvent)=>{
            analyticsEvent.update({
                data: {
                    action: "clicked",
                    actionSubject: "editButton",
                    attributes: {
                        componentVersion: "v2",
                        contentType: contentType,
                        contentId: contentId,
                        isFabricSupported: isFabricSupported,
                        navdexPointType: (0, $56QzY.END),
                        searchSessionId: searchSessionId,
                        ...additionalAnalytics,
                        mode: mode,
                        isOnEditRoute: isOnEditRoute
                    },
                    source: e_0.isTrusted ? "editContentButton" : "editShortcut"
                },
                type: "sendTrackEvent"
            }).fire();
        };
        $[41] = additionalAnalytics;
        $[42] = contentId;
        $[43] = contentType;
        $[44] = isFabricSupported;
        $[45] = isOnEditRoute;
        $[46] = mode;
        $[47] = searchSessionId;
        $[48] = t16;
    } else t16 = $[48];
    const fireClickAnalytics = t16;
    let t17;
    if ($[49] !== contentId || $[50] !== contentType || $[51] !== dataTestId || $[52] !== editShortcutStrings || $[53] !== enforceStorageLimit || $[54] !== fabricEditorEligibility || $[55] !== fireClickAnalytics || $[56] !== intl || $[57] !== isEmbeddedContent || $[58] !== isFabricEligibilityLoading || $[59] !== isFabricSupported || $[60] !== isPopupVisible || $[61] !== linkParams || $[62] !== localEditSource || $[63] !== onClickEdit || $[64] !== onRender || $[65] !== routeType || $[66] !== sendMetrics || $[67] !== sendPrefetchAnalyticsEvent || $[68] !== shouldBlockCreate || $[69] !== spaceKey) {
        t17 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const [convertOnEditExpConfig] = (0, $6mKj3.UNSAFE_noExposureExp)("platform_editor_on_edit_convert");
            let t18;
            if ($[71] !== fabricEditorEligibility || $[72] !== isFabricSupported) {
                t18 = !isFabricSupported && typeof fabricEditorEligibility === "string" && [
                    "SUPPORTED",
                    "SUPPORTED_WITH_MIGRATION"
                ].includes(fabricEditorEligibility);
                $[71] = fabricEditorEligibility;
                $[72] = isFabricSupported;
                $[73] = t18;
            } else t18 = $[73];
            const showConvertPagePopup = t18;
            let t19;
            if ($[74] !== contentId || $[75] !== fireClickAnalytics || $[76] !== isEmbeddedContent || $[77] !== onClickEdit || $[78] !== sendMetrics || $[79] !== sendPrefetchAnalyticsEvent || $[80] !== showConvertPagePopup) {
                t19 = (e_1, analyticsEvent_0)=>{
                    (0, $sD2Tz.resolvePendingPrefetchAnalytics)(contentId, sendPrefetchAnalyticsEvent);
                    if (showConvertPagePopup && (0, $6mKj3.expValEquals)("platform_editor_on_edit_convert", "isEnabled", true)) {
                        e_1.preventDefault();
                        setIsPopupVisible($a4b894acf4b5251f$var$_temp);
                        fireClickAnalytics(e_1, analyticsEvent_0);
                    } else {
                        if (isEmbeddedContent) {
                            const observableObject = (0, $jOO7o.getIframeObservable_DO_NOT_USE)();
                            const uniqueKey = observableObject?.object?.uniqueKey;
                            sendMetrics({
                                timestamp: Date.now(),
                                ...uniqueKey ? {
                                    customData: {
                                        uniqueKey: uniqueKey
                                    }
                                } : {}
                            }, `${(0, $hDLmU.EMBEDDED_CONFLUENCE_METRICS_PREFIX)}${(0, $hDLmU.EMBEDDED_EDIT_CLICK)}`);
                        }
                        fireClickAnalytics(e_1, analyticsEvent_0);
                        onClickEdit(e_1);
                    }
                };
                $[74] = contentId;
                $[75] = fireClickAnalytics;
                $[76] = isEmbeddedContent;
                $[77] = onClickEdit;
                $[78] = sendMetrics;
                $[79] = sendPrefetchAnalyticsEvent;
                $[80] = showConvertPagePopup;
                $[81] = t19;
            } else t19 = $[81];
            const handleButtonClick = t19;
            let t20;
            if ($[82] === Symbol.for("react.memo_cache_sentinel")) {
                t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    id: "edit-button.tooltip",
                    defaultMessage: "Edit"
                });
                $[82] = t20;
            } else t20 = $[82];
            let t21;
            if ($[83] === Symbol.for("react.memo_cache_sentinel")) {
                t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
                    label: "",
                    color: "var(--ds-icon-subtle, #505258)",
                    spacing: "none"
                });
                $[83] = t21;
            } else t21 = $[83];
            let t22;
            if ($[84] !== enforceStorageLimit || $[85] !== handleButtonClick) {
                t22 = enforceStorageLimit(handleButtonClick);
                $[84] = enforceStorageLimit;
                $[85] = handleButtonClick;
                $[86] = t22;
            } else t22 = $[86];
            let t23;
            if ($[87] !== linkParams || $[88] !== routeType || $[89] !== shouldBlockCreate) {
                t23 = shouldBlockCreate ? undefined : routeType.toUrl(linkParams);
                $[87] = linkParams;
                $[88] = routeType;
                $[89] = shouldBlockCreate;
                $[90] = t23;
            } else t23 = $[90];
            let t24;
            if ($[91] !== intl) {
                t24 = intl.formatMessage($a4b894acf4b5251f$var$i18n.editLabel);
                $[91] = intl;
                $[92] = t24;
            } else t24 = $[92];
            let t25;
            if ($[93] !== intl) {
                t25 = intl.formatMessage($a4b894acf4b5251f$var$i18n.editText);
                $[93] = intl;
                $[94] = t25;
            } else t25 = $[94];
            let t26;
            if ($[95] !== t25) {
                t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.default), {
                    color: "color.text.subtle",
                    align: "center",
                    weight: "medium",
                    "data-vc": "edit-button-text"
                }, t25);
                $[95] = t25;
                $[96] = t26;
            } else t26 = $[96];
            let t27;
            if ($[97] !== dataTestId || $[98] !== t22 || $[99] !== t23 || $[100] !== t24 || $[101] !== t26) {
                t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a4b894acf4b5251f$var$StyledButton, {
                    appearance: "subtle",
                    iconBefore: t21,
                    ref: editButtonRef,
                    onClick: t22,
                    href: t23,
                    "data-test-id": dataTestId,
                    id: "editPageLink",
                    "aria-label": t24
                }, t26);
                $[97] = dataTestId;
                $[98] = t22;
                $[99] = t23;
                $[100] = t24;
                $[101] = t26;
                $[102] = t27;
            } else t27 = $[102];
            let t28;
            if ($[103] !== editShortcutStrings || $[104] !== t27) {
                t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                    tag: "span",
                    content: t20,
                    shortcut: editShortcutStrings
                }, t27);
                $[103] = editShortcutStrings;
                $[104] = t27;
                $[105] = t28;
            } else t28 = $[105];
            const button = t28;
            if (isFabricEligibilityLoading) {
                let t29;
                if ($[106] === Symbol.for("react.memo_cache_sentinel")) {
                    t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
                        interactionName: "edit-content-button-preloader",
                        size: "small",
                        testId: "edit-content-button-preloader"
                    });
                    $[106] = t29;
                } else t29 = $[106];
                t17 = t29;
                break bb0;
            } else {
                let t29;
                if ($[107] === Symbol.for("react.memo_cache_sentinel")) {
                    t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
                        accelerator: (0, $gnkil.EDIT_SHORTCUT),
                        listener: clickEditPencilButton
                    });
                    $[107] = t29;
                } else t29 = $[107];
                let t30;
                if ($[108] !== onRender) {
                    t30 = onRender();
                    $[108] = onRender;
                    $[109] = t30;
                } else t30 = $[109];
                const t31 = showConvertPagePopup && convertOnEditExpConfig.get("isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.default), {
                    isOpen: isPopupVisible,
                    onClose: ()=>setIsPopupVisible(false),
                    placement: "bottom-start",
                    content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $emYzJ.EditPopupEligibleMigration), {
                            onClickEdit: onClickEdit,
                            contentId: contentId,
                            href: shouldBlockCreate ? undefined : routeType.toUrl(linkParams),
                            contentHash: "",
                            contentType: contentType,
                            spaceKey: spaceKey
                        }),
                    offset: [
                        -34,
                        8
                    ],
                    trigger: (t32)=>{
                        const { ref: ref } = t32;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                            ref: ref
                        }, button);
                    },
                    shouldRenderToParent: (0, $9wGTI.fg)("should-render-to-parent-should-be-trueenterprise-e")
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), null, button);
                let t33;
                if ($[110] === Symbol.for("react.memo_cache_sentinel")) {
                    t33 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
                        name: (0, $irVI7.VIEW_PAGE_EDIT_BUTTON_EXPERIENCE)
                    });
                    $[110] = t33;
                } else t33 = $[110];
                let t34;
                if ($[111] !== contentId || $[112] !== isEmbeddedContent || $[113] !== localEditSource || $[114] !== sendPrefetchAnalyticsEvent || $[115] !== spaceKey || $[116] !== t30 || $[117] !== t31) {
                    t34 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $sD2Tz.EditContentButtonPreloader), {
                        key: contentId,
                        contentId: contentId,
                        spaceKey: spaceKey,
                        isEmbeddedEditor: isEmbeddedContent,
                        editSource: localEditSource,
                        sendPrefetchAnalyticsEvent: sendPrefetchAnalyticsEvent,
                        predictivelyPrefetch: true
                    }, t29, t30, t31, t33);
                    $[111] = contentId;
                    $[112] = isEmbeddedContent;
                    $[113] = localEditSource;
                    $[114] = sendPrefetchAnalyticsEvent;
                    $[115] = spaceKey;
                    $[116] = t30;
                    $[117] = t31;
                    $[118] = t34;
                } else t34 = $[118];
                t17 = t34;
                break bb0;
            }
        }
        $[49] = contentId;
        $[50] = contentType;
        $[51] = dataTestId;
        $[52] = editShortcutStrings;
        $[53] = enforceStorageLimit;
        $[54] = fabricEditorEligibility;
        $[55] = fireClickAnalytics;
        $[56] = intl;
        $[57] = isEmbeddedContent;
        $[58] = isFabricEligibilityLoading;
        $[59] = isFabricSupported;
        $[60] = isPopupVisible;
        $[61] = linkParams;
        $[62] = localEditSource;
        $[63] = onClickEdit;
        $[64] = onRender;
        $[65] = routeType;
        $[66] = sendMetrics;
        $[67] = sendPrefetchAnalyticsEvent;
        $[68] = shouldBlockCreate;
        $[69] = spaceKey;
        $[70] = t17;
    } else t17 = $[70];
    if (t17 !== Symbol.for("react.early_return_sentinel")) return t17;
});
const $a4b894acf4b5251f$export$812a4eda75b35614 = (0, $kSwu1.injectIntl)($a4b894acf4b5251f$var$EditContentButtonComponentInner);
$a4b894acf4b5251f$export$812a4eda75b35614.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    onRender: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func,
    isCompanyHubButton: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    isEmbeddedContent: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    isFabricSupported: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
};
function $a4b894acf4b5251f$var$_temp(prev) {
    return !prev;
}
module.exports["EditContentButtonComponent"] = $a4b894acf4b5251f$export$812a4eda75b35614;

});

parcelRegister("74Lca", function(module, exports) {

var $dpqzw = parcelRequire("dpqzw");


var $b1pBe = parcelRequire("b1pBe");

const $7936391e07f83542$export$69c870891d17d6d0 = (contentId)=>{
    if (typeof document !== 'undefined') {
        // root page element
        const page = document.getElementById('AkMainContent') || document.documentElement;
        // get fabric or classic renderer content id
        const pageContent = document.getElementById((0, $dpqzw.FABRIC_PAGE_CONTENT_ID));
        // if there's no page content, do nothing
        if (!pageContent) return;
        // if the user is already at the top of the page, then no need to scroll
        if (page.scrollTop / page.clientHeight < 0.25) return;
        // save closest scrolled element & contentId to localstorage
        (0, $b1pBe.getClosestScrolledElementIndex)(page, pageContent, contentId);
    }
};
module.exports["rememberScrolledPosition"] = $7936391e07f83542$export$69c870891d17d6d0;

});

parcelRegister("b1pBe", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $dpqzw = parcelRequire("dpqzw");

const $f44449ceafa69a86$export$1df42b18d7384de5 = (page, pageContent, contentId)=>{
    if (!pageContent) return;
    // grab all of the direct children elements from the rendered content view
    const elementCollection = pageContent.querySelector((0, $dpqzw.RENDERED_CONTENT_SELECTOR))?.children || [];
    // set initial index to -1 in case no closest element is found
    let closestElementIndex = -1;
    // go through all direct children elements and see which is closest to the remembered scroll position
    if (elementCollection.length > 0) {
        const childrenElements = Array.from(elementCollection);
        // calculate scroll position based off of how far a user has scrolled the page minus the distance from the renderer content to the top of the page
        const pageScrollTop = page.scrollTop - pageContent.offsetTop;
        childrenElements.reduce((best, elem, index)=>{
            if (Math.abs(pageScrollTop - elem.offsetTop) < Math.abs(pageScrollTop - best.offsetTop)) {
                closestElementIndex = index;
                return elem;
            } else return best;
        });
    }
    // save the closest element's index to local storage
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).LOCAL_STORAGE_CONTENT_VIEW_CLOSEST_ELEMENT_SCROLL_POSITION, {
        index: closestElementIndex,
        contentId: contentId
    });
};
module.exports["getClosestScrolledElementIndex"] = $f44449ceafa69a86$export$1df42b18d7384de5;

});

parcelRegister("emYzJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $eKMV3 = parcelRequire("eKMV3");


var $l8Rhq = parcelRequire("l8Rhq");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $9DHhW = parcelRequire("9DHhW");


var $bQm3c = parcelRequire("bQm3c");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $7Sm4c = parcelRequire("7Sm4c");


var $briGH = parcelRequire("briGH");


var $emb8c = parcelRequire("emb8c");

const $1c786d1286cf45c7$var$i18n = (0, $kSwu1.defineMessages)({
    elligibleMigrationModalTitle: {
        id: "fabric-page-optin-migration.elligible-migration-modal.title",
        defaultMessage: "Time to convert your page"
    },
    elligibleMigrationModalDescription: {
        id: "fabric-page-optin-migration.elligible-migration-modal.description",
        defaultMessage: "This page is compatible with the cloud editor. The legacy editor will be phased out soon, find out more in the <link>announcement</link>."
    },
    elligibleMigrationModalUpdateButton: {
        id: "fabric-page-optin-migration.elligible-migration-modal.update-button",
        defaultMessage: "Convert page"
    },
    elligibleMigrationModalCancelButton: {
        id: "fabric-page-optin-migration.elligible-migration-modal.cancel-button",
        defaultMessage: "Not now"
    },
    elligibleMigrationModalUnsupported: {
        id: "fabric-page-optin-migration.elligible-migration-modal.unsupported",
        defaultMessage: "This page cannot be converted"
    }
});
const $1c786d1286cf45c7$var$popupContainerStyle = (0, $buxP3.xcss)({
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    paddingLeft: 'space.300',
    paddingRight: 'space.300',
    font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $1c786d1286cf45c7$var$topMarginStyle = (0, $buxP3.xcss)({
    marginTop: 'space.200'
});
const $1c786d1286cf45c7$var$buttonContainerStyle = (0, $buxP3.xcss)({
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 'space.200'
});
const $1c786d1286cf45c7$var$widthStyle = (0, $buxP3.xcss)({
    width: '297px'
});
const $1c786d1286cf45c7$export$4e1bf6f2717dc4c8 = ({ onClickEdit: onClickEdit, contentId: contentId, href: href, contentHash: contentHash, contentType: contentType, spaceKey: spaceKey })=>{
    const [popupMessage, setPopupMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState({
        ...$1c786d1286cf45c7$var$i18n.elligibleMigrationModalDescription
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [migratePages] = (0, $emb8c.useExperimentalMigratePagesMutation)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'eligibleMigrationModal'
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const onClickConvert = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(async (e)=>{
        e.preventDefault();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'eligibleMigrationModalConvertButton',
                source: 'editPopupEligibleMigration'
            }
        }).fire();
        const response = await migratePages({
            variables: {
                contentId: contentId,
                contentHash: contentHash
            }
        });
        const status = (0, $briGH.getStatusFromResponse)(response);
        if (status === '200' || status === '204') {
            const redirectRoute = contentType === 'page' ? (0, $1NBp8.EDIT_PAGE_V2).toUrl({
                contentType: 'pages',
                spaceKey: spaceKey,
                contentId: contentId
            }) : (0, $1NBp8.EDIT_BLOG_V2).toUrl({
                contentType: 'blog',
                spaceKey: spaceKey,
                contentId: contentId
            });
            // perform redirect
            push(redirectRoute);
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).PAGE_JUST_CONVERTED, contentId);
        } else {
            setPopupMessage($1c786d1286cf45c7$var$i18n.elligibleMigrationModalUnsupported);
            if (response && 'errors' in response && response.errors) (0, $7Sm4c.markErrorAsHandled)(response.errors);
        }
    }, [
        createAnalyticsEvent,
        migratePages,
        contentId,
        contentHash,
        contentType,
        spaceKey,
        push
    ]);
    if (!isLoggedIn || !href) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $1c786d1286cf45c7$var$popupContainerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $1c786d1286cf45c7$var$widthStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        tagName: "h3",
        ...$1c786d1286cf45c7$var$i18n.elligibleMigrationModalTitle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $1c786d1286cf45c7$var$topMarginStyle,
        role: "status",
        "aria-live": "polite",
        "aria-atomic": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...popupMessage,
        tagName: "p",
        values: {
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks),
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8Rhq.default), {
                    href: "https://community.atlassian.com/forums/Confluence-articles/The-Legacy-Editor-is-being-deprecated-in-Confluence-Cloud-Here-s/ba-p/3046832",
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, chunks)
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $1c786d1286cf45c7$var$topMarginStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $1c786d1286cf45c7$var$buttonContainerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
        appearance: "subtle",
        href: href,
        onClick: onClickEdit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $1c786d1286cf45c7$var$i18n.elligibleMigrationModalCancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onClickConvert
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $1c786d1286cf45c7$var$i18n.elligibleMigrationModalUpdateButton))))));
};
module.exports["EditPopupEligibleMigration"] = $1c786d1286cf45c7$export$4e1bf6f2717dc4c8;

});

parcelRegister("briGH", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $7W8i8 = parcelRequire("7W8i8");

const $8540b650e122e686$var$RETRY_STATUS_CODE = [
    409,
    412
];
const $8540b650e122e686$export$8e3b4758c0e0a83 = (response)=>response?.data?.experimentalMigratePages?.status;
const $8540b650e122e686$var$logger = (0, $7W8i8.getLogger)('PageMigration');
const $8540b650e122e686$export$9369b12211e1fce4 = (refetchContentHash, migratePages, retriesLeft = 3, interval = 1000, statusCodes = [])=>{
    return new Promise((resolve, reject)=>{
        // b/c contentHash is variable and could changed when user in preview
        // perform refetch to grab the latest contentHash (to avoid 412 and 409 error when performing migration)
        return refetchContentHash().then((contentHash)=>{
            migratePages(contentHash).then((response)=>{
                const status = $8540b650e122e686$export$8e3b4758c0e0a83(response);
                setTimeout(()=>{
                    if (retriesLeft === 1) {
                        const message = 'Number of retrying attempt reach maximum number of retries';
                        $8540b650e122e686$var$logger.debug`${message}`;
                        return reject(message, statusCodes);
                    }
                    // only retry when status code is 409, 412
                    if ($8540b650e122e686$var$RETRY_STATUS_CODE.indexOf(Number.parseInt(status)) !== -1) {
                        statusCodes.push(Number.parseInt(status));
                        $8540b650e122e686$export$9369b12211e1fce4(refetchContentHash, migratePages, retriesLeft - 1, interval, statusCodes).then(resolve, reject);
                    } else return resolve(response, statusCodes);
                }, interval);
            }).catch((error)=>{
                return reject(error, statusCodes);
            });
        });
    });
};
module.exports["getStatusFromResponse"] = $8540b650e122e686$export$8e3b4758c0e0a83;
module.exports["retry"] = $8540b650e122e686$export$9369b12211e1fce4;

});

parcelRegister("emb8c", function(module, exports) {

var $aBfpe = parcelRequire("aBfpe");


var $9o40q = parcelRequire("9o40q");


var $hBkCm = parcelRequire("hBkCm");

const $b8f7841fb375e78f$export$bff11ed54317b5ef = ({ onCompleted: onCompleted, onError: onError } = {})=>{
    return (0, $9o40q.useExperimentalMutation)({
        url: ({ contentId: contentId, contentHash: contentHash })=>`/wiki/rest/api/content/${contentId}/convert?hash=${contentHash}`,
        method: 'PUT',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON,
            'X-Requested-With': 'XMLHttpRequest'
        },
        parseResult: (response)=>({
                experimentalMigratePages: {
                    status: String(response.status)
                }
            }),
        parseResponseOnSuccess: async (response)=>{
            return {
                status: response.status
            };
        },
        parseResponseOnError: async (error)=>{
            if ((0, $hBkCm.BadStatusError).isBadStatusError(error)) return {
                status: error.response.status
            };
            throw error;
        },
        onCompleted: onCompleted,
        onError: onError
    });
};
module.exports["useExperimentalMigratePagesMutation"] = $b8f7841fb375e78f$export$bff11ed54317b5ef;

});

parcelRegister("ca2z9", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $2HZwz = parcelRequire("2HZwz");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $jMyy4 = parcelRequire("jMyy4");

const $a70c768defde6626$var$UseFabricEligibilityMigrationQuery = (0, $2HZwz.default);
const $a70c768defde6626$export$848562a07f990254 = (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { contentId: contentId, isFabricSupported: isFabricSupported } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const shouldFetch = isFabricSupported === false;
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            fetchPolicy: "cache-first",
            variables: {
                contentId: contentId
            }
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($a70c768defde6626$var$UseFabricEligibilityMigrationQuery, {
        ...t1,
        __callerPackage__: "edit-button"
    });
    let t2;
    if ($[2] !== contentId || $[3] !== createAnalyticsEvent) {
        t2 = (t3)=>{
            const { reason: reason } = t3;
            createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    action: "failed",
                    actionSubject: "fabricEditorEligibilityQuery",
                    attributes: {
                        contentId: contentId,
                        reason: reason
                    },
                    source: "editContentButton"
                }
            }).fire();
        };
        $[2] = contentId;
        $[3] = createAnalyticsEvent;
        $[4] = t2;
    } else t2 = $[4];
    const fireErrorEvent = t2;
    let t3;
    let t4;
    if ($[5] !== error || $[6] !== fireErrorEvent) {
        t3 = ()=>{
            if (error) fireErrorEvent({
                reason: "APOLLO_ERROR"
            });
        };
        t4 = [
            error,
            fireErrorEvent
        ];
        $[5] = error;
        $[6] = fireErrorEvent;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    bb0: {
        if (!shouldFetch) {
            let t6;
            if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
                t6 = {
                    fabricEditorEligibility: null,
                    contentHash: null,
                    isFabricEligibilityLoading: false
                };
                $[9] = t6;
            } else t6 = $[9];
            t5 = t6;
            break bb0;
        }
        if (!data && shouldFetch) {
            let t6;
            if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
                t6 = {
                    isFabricEligibilityLoading: true,
                    fabricEditorEligibility: null,
                    contentHash: null
                };
                $[10] = t6;
            } else t6 = $[10];
            t5 = t6;
            break bb0;
        }
        if (!data && loading) {
            let t6;
            if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
                t6 = {
                    isFabricEligibilityLoading: true,
                    fabricEditorEligibility: null,
                    contentHash: null
                };
                $[11] = t6;
            } else t6 = $[11];
            t5 = t6;
            break bb0;
        }
        if (data) {
            const metadataFrontend = data?.content?.nodes?.[0]?.metadata?.frontend;
            const fabricEditorEligibility = metadataFrontend?.fabricEditorEligibility;
            const contentHash = metadataFrontend?.contentHash;
            let t6;
            if ($[12] !== contentHash || $[13] !== fabricEditorEligibility) {
                t6 = {
                    fabricEditorEligibility: fabricEditorEligibility,
                    contentHash: contentHash,
                    isFabricEligibilityLoading: false
                };
                $[12] = contentHash;
                $[13] = fabricEditorEligibility;
                $[14] = t6;
            } else t6 = $[14];
            t5 = t6;
            break bb0;
        }
        let t6;
        if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = {
                fabricEditorEligibility: null,
                contentHash: null,
                isFabricEligibilityLoading: false
            };
            $[15] = t6;
        } else t6 = $[15];
        t5 = t6;
    }
    return t5;
};
module.exports["useFabricEligibilityMigrationQuery"] = $a70c768defde6626$export$848562a07f990254;

});

parcelRegister("2HZwz", function(module, exports) {
/**
 * @generated SignedSource<<827507a6d415f89f9ea888951476199b>>
 * @relayHash ec4bb4fc4b91bdd22636b8cd5a8459f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b983ca5b9bb7742a71d4d350f250a5524ffb46863ceb1b44624ac1b612ac288
const $41339af49efc6ee3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fabricEditorEligibility"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "contentHash"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFabricEligibilityMigrationQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFabricEligibilityMigrationQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "ec4bb4fc4b91bdd22636b8cd5a8459f5",
            "id": "1b983ca5b9bb7742a71d4d350f250a5524ffb46863ceb1b44624ac1b612ac288",
            "metadata": {},
            "name": "useFabricEligibilityMigrationQuery",
            "operationKind": "query",
            "text": "query useFabricEligibilityMigrationQuery($contentId:ID!){content(id:$contentId){nodes{id,metadata{frontend{fabricEditorEligibility,contentHash}}}}}"
        }
    };
}();
$41339af49efc6ee3$var$node.hash = "204d8fbd9ab341cec958fee25e721167";
var $41339af49efc6ee3$export$2e2bcd8739ae039 = $41339af49efc6ee3$var$node;
module.exports["default"] = $41339af49efc6ee3$export$2e2bcd8739ae039;

});

parcelRegister("7mHcA", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $2zRSX = parcelRequire("2zRSX");


var $gkjo6 = parcelRequire("gkjo6");


var $9DHhW = parcelRequire("9DHhW");


var $jMyy4 = parcelRequire("jMyy4");


var $lvOsp = parcelRequire("lvOsp");

let $6feb6b3d360f0331$var$onMigrationSuccess = ()=>{};
let $6feb6b3d360f0331$var$onMigrationFailure = ()=>{};
const $6feb6b3d360f0331$export$a48339a192545f1f = (contentId, skipOnLoadQuery)=>{
    const $ = (0, $bDgLe.c)(27);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== contentId || $[1] !== createAnalyticsEvent) {
        t0 = (t1)=>{
            const { action: action, actionSubjectId: actionSubjectId, withMigration: withMigration, error: error } = t1;
            return createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    action: action,
                    actionSubject: "ncsMigrationQuery",
                    actionSubjectId: actionSubjectId,
                    source: "embeddedPageViewScreen",
                    object: {
                        id: contentId,
                        type: "page"
                    },
                    attributes: {
                        withMigration: withMigration,
                        error: error
                    }
                }
            }).fire();
        };
        $[0] = contentId;
        $[1] = createAnalyticsEvent;
        $[2] = t0;
    } else t0 = $[2];
    const trackMigrationEvent = t0;
    let t1;
    if ($[3] !== contentId) {
        t1 = {
            contentId: contentId
        };
        $[3] = contentId;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    let t3;
    if ($[5] !== trackMigrationEvent) {
        t2 = (data)=>{
            if (data?.content?.nodes?.[0]?.metadata?.frontend?.embeddedWithMigration ?? false) trackMigrationEvent({
                action: "completed",
                actionSubjectId: "ncsMigrationOnLoad",
                withMigration: true
            });
            else trackMigrationEvent({
                action: "completed",
                actionSubjectId: "ncsMigrationOnLoad",
                withMigration: false
            });
        };
        t3 = (err)=>{
            trackMigrationEvent({
                action: "failed",
                actionSubjectId: "ncsMigrationOnLoad",
                error: err.message
            });
        };
        $[5] = trackMigrationEvent;
        $[6] = t2;
        $[7] = t3;
    } else {
        t2 = $[6];
        t3 = $[7];
    }
    let t4;
    if ($[8] !== skipOnLoadQuery || $[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
        t4 = {
            variables: t1,
            fetchPolicy: "network-only",
            skip: skipOnLoadQuery,
            onCompleted: t2,
            onError: t3
        };
        $[8] = skipOnLoadQuery;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
    } else t4 = $[12];
    const epMigrationOnLoad = (0, $jMyy4.useQueryInterop)((0, $gkjo6.default), {
        ...t4,
        __callerPackage__: "edit-button"
    });
    let t5;
    if ($[13] !== contentId) {
        t5 = {
            contentId: contentId
        };
        $[13] = contentId;
        $[14] = t5;
    } else t5 = $[14];
    let t6;
    if ($[15] !== trackMigrationEvent) {
        t6 = (err_0)=>{
            trackMigrationEvent({
                action: "failed",
                actionSubjectId: "ncsMigrationOnEditClick",
                error: err_0?.message
            });
            $6feb6b3d360f0331$var$onMigrationFailure(err_0);
        };
        $[15] = trackMigrationEvent;
        $[16] = t6;
    } else t6 = $[16];
    const [migrateData, t7] = (0, $lvOsp.useLazyQueryInterop)((0, $2zRSX.default), {
        variables: t5,
        fetchPolicy: "network-only",
        onCompleted: (data_0)=>{
            if (data_0?.content?.nodes?.[0]?.metadata?.frontend?.embeddedWithMigration ?? false) {
                trackMigrationEvent({
                    action: "completed",
                    actionSubjectId: "ncsMigrationOnEditClick",
                    withMigration: true
                });
                $6feb6b3d360f0331$var$onMigrationSuccess(onClickData);
            } else {
                trackMigrationEvent({
                    action: "completed",
                    actionSubjectId: "ncsMigrationOnEditClick",
                    withMigration: false
                });
                $6feb6b3d360f0331$var$onMigrationFailure();
            }
        },
        onError: t6,
        __callerPackage__: "edit-button"
    });
    const { data: t8, loading: onClickLoading, error: onClickError } = t7;
    const onClickData = t8;
    let t9;
    if ($[17] !== migrateData) {
        t9 = (t10, t11)=>{
            const onSuccess = t10 === undefined ? $6feb6b3d360f0331$var$_temp : t10;
            const onFailure = t11 === undefined ? $6feb6b3d360f0331$var$_temp2 : t11;
            $6feb6b3d360f0331$var$onMigrationSuccess = onSuccess;
            $6feb6b3d360f0331$var$onMigrationFailure = onFailure;
            migrateData();
        };
        $[17] = migrateData;
        $[18] = t9;
    } else t9 = $[18];
    const migrateEPData = t9;
    let t10;
    if ($[19] !== migrateEPData || $[20] !== onClickData || $[21] !== onClickError || $[22] !== onClickLoading) {
        t10 = {
            migrateEPData: migrateEPData,
            data: onClickData,
            loading: onClickLoading,
            error: onClickError
        };
        $[19] = migrateEPData;
        $[20] = onClickData;
        $[21] = onClickError;
        $[22] = onClickLoading;
        $[23] = t10;
    } else t10 = $[23];
    let t11;
    if ($[24] !== epMigrationOnLoad || $[25] !== t10) {
        t11 = {
            epMigrationOnLoad: epMigrationOnLoad,
            epMigrationOnClick: t10
        };
        $[24] = epMigrationOnLoad;
        $[25] = t10;
        $[26] = t11;
    } else t11 = $[26];
    return t11;
};
function $6feb6b3d360f0331$var$_temp() {}
function $6feb6b3d360f0331$var$_temp2() {}
module.exports["useEmbeddedMigrationQuery"] = $6feb6b3d360f0331$export$a48339a192545f1f;

});

parcelRegister("2zRSX", function(module, exports) {
/**
 * @generated SignedSource<<3f1c6cd6494336472f6b32776e1b4252>>
 * @relayHash 8ce6c444a2fa7276cb4da3d1a791d300
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2b36d62c169e4fc5c39a3306da79a54ff311e294e3ad79fbb21c36f48abdc74b
const $a67fcf7b0c351cc5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "embeddedWithMigration"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEmbeddedMigrationQueryEmbeddedWithMigrationLazyQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEmbeddedMigrationQueryEmbeddedWithMigrationLazyQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8ce6c444a2fa7276cb4da3d1a791d300",
            "id": "2b36d62c169e4fc5c39a3306da79a54ff311e294e3ad79fbb21c36f48abdc74b",
            "metadata": {},
            "name": "useEmbeddedMigrationQueryEmbeddedWithMigrationLazyQuery",
            "operationKind": "query",
            "text": "query useEmbeddedMigrationQueryEmbeddedWithMigrationLazyQuery($contentId:ID!){content(id:$contentId){nodes{id,type,metadata{frontend{embeddedWithMigration}}}}}"
        }
    };
}();
$a67fcf7b0c351cc5$var$node.hash = "e811ca917e234d313519ff2281e9d6fc";
var $a67fcf7b0c351cc5$export$2e2bcd8739ae039 = $a67fcf7b0c351cc5$var$node;
module.exports["default"] = $a67fcf7b0c351cc5$export$2e2bcd8739ae039;

});

parcelRegister("gkjo6", function(module, exports) {
/**
 * @generated SignedSource<<d43294402b898c3229e7aba801086cef>>
 * @relayHash 3b2300539134eec5a57f18f298c307e4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3fa39827a54818a9014acf891b0b162dcb6f4a289ff487ce4c67d552c5d850ec
const $7dbead30693bf664$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "embeddedWithMigration"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEmbeddedMigrationQueryEmbeddedWithMigrationQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEmbeddedMigrationQueryEmbeddedWithMigrationQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3b2300539134eec5a57f18f298c307e4",
            "id": "3fa39827a54818a9014acf891b0b162dcb6f4a289ff487ce4c67d552c5d850ec",
            "metadata": {},
            "name": "useEmbeddedMigrationQueryEmbeddedWithMigrationQuery",
            "operationKind": "query",
            "text": "query useEmbeddedMigrationQueryEmbeddedWithMigrationQuery($contentId:ID!){content(id:$contentId){nodes{id,type,metadata{frontend{embeddedWithMigration}}}}}"
        }
    };
}();
$7dbead30693bf664$var$node.hash = "226895c47be9fed079eb4901c8267e39";
var $7dbead30693bf664$export$2e2bcd8739ae039 = $7dbead30693bf664$var$node;
module.exports["default"] = $7dbead30693bf664$export$2e2bcd8739ae039;

});

parcelRegister("6ug2F", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $fc0e6c31b10b3145$export$ad537527a445740e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "GFqC1",
    name: "AgentPresenceLoader",
    loader: async ()=>(await (parcelRequire("2KWh6"))).AgentPresence
});
module.exports["AgentPresenceLoader"] = $fc0e6c31b10b3145$export$ad537527a445740e;

});

parcelRegister("2KWh6", function(module, exports) {

let $201d14d3f742ece5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $201d14d3f742ece5$var$load("c1gk3"),
    $201d14d3f742ece5$var$load("iUXaE"),
    $201d14d3f742ece5$var$load("lTkx9"),
    $201d14d3f742ece5$var$load("6wr18"),
    $201d14d3f742ece5$var$load("cmmpX"),
    $201d14d3f742ece5$var$load("ekVH8"),
    $201d14d3f742ece5$var$load("jqoep"),
    $201d14d3f742ece5$var$load("8zMmc"),
    $201d14d3f742ece5$var$load("4x9Jx"),
    $201d14d3f742ece5$var$load("ffEVr"),
    $201d14d3f742ece5$var$load("7EorR"),
    $201d14d3f742ece5$var$load("hhss7"),
    $201d14d3f742ece5$var$load("34R0T")
]).then(()=>parcelRequire('f2tcq'));

});

parcelRegister("bjZbA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $V3JOP = parcelRequire("V3JOP");


var $1sCHt = parcelRequire("1sCHt");


var $ep3mz = parcelRequire("ep3mz");


var $iXzFq = parcelRequire("iXzFq");

const $b9c78150b710374f$export$692138f5b3745b91 = ()=>{
    const [{ contentId: contentId, contentType: contentType, spaceKey: spaceKey }] = (0, $ep3mz.usePageState)();
    const handleClick = ()=>{
        if (!contentId || !contentType || !spaceKey) return;
        const url = (0, $iXzFq.getUrlForContentType)({
            contentType: contentType,
            contentId: contentId,
            spaceKey: spaceKey,
            redirectToEditor: false
        });
        if (!url) return;
        window.open(url, '_blank');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
        label: "Open in new window",
        onClick: handleClick,
        testId: "loom-external-open-button"
    });
};
module.exports["LoomExternalOpenButton"] = $b9c78150b710374f$export$692138f5b3745b91;

});

parcelRegister("hAnPj", function(module, exports) {
$parcel$export(module.exports, "RestrictionsDialogTriggerWrapper", () => (parcelRequire("SAFLR")).RestrictionsDialogTriggerWrapper);
$parcel$export(module.exports, "RestrictionsDialogTrigger", () => (parcelRequire("lEXFh")).RestrictionsDialogTrigger);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $jmjWc = parcelRequire("jmjWc");


var $SAFLR = parcelRequire("SAFLR");


var $lEXFh = parcelRequire("lEXFh");



const $bb619eb96b539cb1$export$8c358bcfa2c0ec3f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "qdHUS",
    name: "LazyRestrictionsDialogMountPoint",
    loader: async ()=>(await (parcelRequire("j7Ouc"))).RestrictionsDialogMountPoint
});
module.exports["LazyRestrictionsDialogMountPoint"] = $bb619eb96b539cb1$export$8c358bcfa2c0ec3f;

});

parcelRegister("SAFLR", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $lEXFh = parcelRequire("lEXFh");

const $84211cd137cf57b0$export$e8086e85d5f7d830 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const hasAccess = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    let t0;
    if ($[0] !== hasAccess || $[1] !== props) {
        t0 = hasAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            key: "restriction-button-start",
            id: props.contentId,
            name: (0, $irVI7.VIEW_PAGE_RESTRICTIONS_BUTTON_EXPERIENCE)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lEXFh.RestrictionsDialogTrigger), props)) : null;
        $[0] = hasAccess;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    let t1;
    if ($[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE,
            key: "restrictions-dialog-trigger"
        }, t0);
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const hasAccess = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE,
        key: "restrictions-dialog-trigger"
    }, hasAccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
        key: "restriction-button-start",
        id: props.contentId,
        name: (0, $irVI7.VIEW_PAGE_RESTRICTIONS_BUTTON_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lEXFh.RestrictionsDialogTrigger), props)) : null);
};
module.exports["RestrictionsDialogTriggerWrapper"] = $84211cd137cf57b0$export$e8086e85d5f7d830;

});

parcelRegister("lEXFh", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $9DHhW = parcelRequire("9DHhW");


var $iMnC5 = parcelRequire("iMnC5");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $7boqA = parcelRequire("7boqA");


var $b27bJ = parcelRequire("b27bJ");


var $euL71 = parcelRequire("euL71");


var $8RR7m = parcelRequire("8RR7m");


var $7zgzO = parcelRequire("7zgzO");


var $ckmNl = parcelRequire("ckmNl");


var $jLw6A = parcelRequire("jLw6A");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $bVAxT = parcelRequire("bVAxT");


var $14SPd = parcelRequire("14SPd");


var $cSVAY = parcelRequire("cSVAY");


var $eE3dj = parcelRequire("eE3dj");


var $fkOJz = parcelRequire("fkOJz");

const $0b24ce56d1d6b617$var$styles = {
    buttonContainer: "_1e0c1o8l _s7n4jp4b"
};
const $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT = 'bottom-end';
const $0b24ce56d1d6b617$export$4a978df01c3bf89e = /*#__PURE__*/ (0, $cozmU.memo)((0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $bDgLe.c)(28);
    const contentId = (0, $ckmNl.useContentId)(props.contentId) || "";
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            grantAccessClicked: false,
            hasAutoOpenedRestrictionDialog: false,
            showFreeRestrictionDialog: false
        };
        $[0] = t0;
    } else t0 = $[0];
    const [state, setState] = (0, $cozmU.useState)(t0);
    const contentSubType = props.contentSubType;
    const useAnalyticsEventsHook = (0, $9DHhW.useAnalyticsEvents)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    if ($[1] !== contentId || $[2] !== contentSubType || $[3] !== contentType || $[4] !== edition || $[5] !== experienceTracker || $[6] !== useAnalyticsEventsHook) {
        t1 = (dialogStateContainer)=>()=>$0b24ce56d1d6b617$export$59974e42a4613c7({
                    ...useAnalyticsEventsHook,
                    actionSubjectId: "restrictionsDialogButton",
                    dialogStateContainer: dialogStateContainer,
                    edition: edition,
                    experienceTracker: experienceTracker,
                    contentType: contentType,
                    contentSubType: contentSubType,
                    contentId: contentId
                });
        $[1] = contentId;
        $[2] = contentSubType;
        $[3] = contentType;
        $[4] = edition;
        $[5] = experienceTracker;
        $[6] = useAnalyticsEventsHook;
        $[7] = t1;
    } else t1 = $[7];
    const makeHandleOpen = t1;
    const getParentData = $0b24ce56d1d6b617$var$_temp;
    let t2;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            setState($0b24ce56d1d6b617$var$_temp2);
        };
        $[8] = t2;
    } else t2 = $[8];
    const handleFreeEditionPadlockClicked = t2;
    let t3;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setState($0b24ce56d1d6b617$var$_temp3);
        };
        $[9] = t3;
    } else t3 = $[9];
    const onFreeDialogClosed = t3;
    let t4;
    if ($[10] !== contentId || $[11] !== makeHandleOpen || $[12] !== props || $[13] !== state) {
        t4 = (dialogStateContainer_0, shouldShowDialog)=>{
            const { isDisabled: isDisabled, triggeredFrom: triggeredFrom } = props;
            const shouldSSRViewPageFreeEditionButton = triggeredFrom === "fromView";
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLw6A.PageRestrictionsContextConsumer), null, (t5)=>{
                const { loading: loading, error: error, restrictions: restrictions_0 } = t5;
                if (!restrictions_0 && loading || error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null);
                const contentHasRestrictions = Boolean(restrictions_0?.hasRestrictions || restrictions_0?.hasInheritedRestrictions);
                const contentHasInheritedRestrictionsOnly = Boolean(restrictions_0?.hasInheritedRestrictions && !restrictions_0?.hasRestrictions);
                const immediateParentPageIndex = (restrictions_0?.ancestors.length || 0) - 1;
                const isChildPage = immediateParentPageIndex > 0;
                if (contentHasRestrictions) {
                    if (isChildPage && contentHasInheritedRestrictionsOnly) {
                        const parentData = getParentData(restrictions_0);
                        return shouldSSRViewPageFreeEditionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b27bJ.ChangeEditionInlineDialogPaintLoader), {
                            isOpen: state.showFreeRestrictionDialog,
                            onClose: onFreeDialogClosed,
                            parentData: parentData,
                            isChildPage: isChildPage,
                            placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                            contentId: contentId,
                            isDisabled: isDisabled,
                            onClick: handleFreeEditionPadlockClicked,
                            restrictionsButtonSSRRendered: true,
                            restrictionsButtonSSRLocation: "free inherited",
                            triggeredFrom: triggeredFrom
                        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b27bJ.ChangeEditionInlineDialogLoader), {
                            isOpen: state.showFreeRestrictionDialog,
                            onClose: onFreeDialogClosed,
                            parentData: parentData,
                            isChildPage: isChildPage,
                            placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                            contentId: contentId,
                            isDisabled: isDisabled,
                            onClick: handleFreeEditionPadlockClicked,
                            restrictionsButtonSSRLocation: "free inherited",
                            triggeredFrom: triggeredFrom
                        }));
                    }
                    if (shouldShowDialog && !state.hasAutoOpenedRestrictionDialog) {
                        makeHandleOpen(dialogStateContainer_0)();
                        setState($0b24ce56d1d6b617$var$_temp4);
                    }
                    return shouldSSRViewPageFreeEditionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                        contentId: contentId,
                        isDisabled: isDisabled,
                        resetDialogState: ()=>dialogStateContainer_0.initState(),
                        onClick: makeHandleOpen(dialogStateContainer_0),
                        restrictionsButtonSSRRendered: true,
                        restrictionsButtonSSRLocation: "free grandfather",
                        triggeredFrom: triggeredFrom
                    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                        contentId: contentId,
                        isDisabled: isDisabled,
                        onClick: makeHandleOpen(dialogStateContainer_0),
                        restrictionsButtonSSRLocation: "free grandfather",
                        triggeredFrom: triggeredFrom
                    });
                }
                return shouldSSRViewPageFreeEditionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b27bJ.ChangeEditionInlineDialogPaintLoader), {
                    isOpen: state.showFreeRestrictionDialog,
                    onClose: onFreeDialogClosed,
                    placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                    contentId: contentId,
                    isDisabled: isDisabled,
                    onClick: handleFreeEditionPadlockClicked,
                    restrictionsButtonSSRRendered: true,
                    restrictionsButtonSSRLocation: "free",
                    triggeredFrom: triggeredFrom
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b27bJ.ChangeEditionInlineDialogLoader), {
                    isOpen: state.showFreeRestrictionDialog,
                    onClose: onFreeDialogClosed,
                    placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                    contentId: contentId,
                    isDisabled: isDisabled,
                    onClick: handleFreeEditionPadlockClicked,
                    restrictionsButtonSSRLocation: "free",
                    triggeredFrom: triggeredFrom
                }));
            });
        };
        $[10] = contentId;
        $[11] = makeHandleOpen;
        $[12] = props;
        $[13] = state;
        $[14] = t4;
    } else t4 = $[14];
    const renderFreeEditionDialog = t4;
    let t5;
    if ($[15] !== contentId || $[16] !== makeHandleOpen || $[17] !== props) {
        t5 = (dialogStateContainer_1)=>{
            const { isDisabled: isDisabled_0, triggeredFrom: triggeredFrom_0 } = props;
            if (triggeredFrom_0 && triggeredFrom_0 === "fromView") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                contentId: contentId,
                isDisabled: isDisabled_0,
                onClick: makeHandleOpen(dialogStateContainer_1),
                resetDialogState: ()=>dialogStateContainer_1.initState(),
                restrictionsButtonSSRRendered: true,
                restrictionsButtonSSRLocation: "default",
                triggeredFrom: triggeredFrom_0
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                contentId: contentId,
                isDisabled: isDisabled_0,
                onClick: makeHandleOpen(dialogStateContainer_1),
                restrictionsButtonSSRLocation: "default",
                triggeredFrom: triggeredFrom_0
            });
        };
        $[15] = contentId;
        $[16] = makeHandleOpen;
        $[17] = props;
        $[18] = t5;
    } else t5 = $[18];
    const renderRestrictionsButton = t5;
    let t6;
    if ($[19] !== contentId || $[20] !== renderRestrictionsButton) {
        t6 = (dialogStateContainer_2)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderRestrictionsButton(dialogStateContainer_2), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8RR7m.GrantAccessFlagLoader), {
                contentId: contentId
            }));
        $[19] = contentId;
        $[20] = renderRestrictionsButton;
        $[21] = t6;
    } else t6 = $[21];
    const renderGrantAccessFlagAndButton = t6;
    let t7;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = [
            (0, $bVAxT.RestrictionsDialogStateContainer)
        ];
        $[22] = t7;
    } else t7 = $[22];
    let t8;
    if ($[23] !== contentId || $[24] !== edition || $[25] !== renderFreeEditionDialog || $[26] !== renderGrantAccessFlagAndButton) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: t7
        }, (dialogStateContainer_3)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
                xcss: $0b24ce56d1d6b617$var$styles.buttonContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
                isCustomStart: true,
                key: `start-${contentId}`,
                metric: (0, $14SPd.RESTRICTIONS_BUTTON_METRIC)
            }), edition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7zgzO.RoutesContext).Consumer, null, (t9)=>{
                const { getQueryParams: getQueryParams } = t9;
                const { accountId: accountId, grantAccess: grantAccess, username: username } = getQueryParams();
                const shouldShowGrantAccessDialog = Boolean(grantAccess && accountId || username);
                return edition === (0, $euL71.ConfluenceEdition).FREE ? renderFreeEditionDialog(dialogStateContainer_3, shouldShowGrantAccessDialog) : renderGrantAccessFlagAndButton(dialogStateContainer_3);
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fkOJz.RestrictionsButtonLoading), null)));
        $[23] = contentId;
        $[24] = edition;
        $[25] = renderFreeEditionDialog;
        $[26] = renderGrantAccessFlagAndButton;
        $[27] = t8;
    } else t8 = $[27];
    return t8;
} : (props)=>{
    const contentId = (0, $ckmNl.useContentId)(props.contentId) || '';
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const [state, setState] = (0, $cozmU.useState)({
        grantAccessClicked: false,
        hasAutoOpenedRestrictionDialog: false,
        showFreeRestrictionDialog: false
    });
    const contentSubType = props.contentSubType;
    const useAnalyticsEventsHook = (0, $9DHhW.useAnalyticsEvents)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const makeHandleOpen = (dialogStateContainer)=>()=>$0b24ce56d1d6b617$export$59974e42a4613c7({
                ...useAnalyticsEventsHook,
                actionSubjectId: 'restrictionsDialogButton',
                dialogStateContainer: dialogStateContainer,
                edition: edition,
                experienceTracker: experienceTracker,
                contentType: contentType,
                contentSubType: contentSubType,
                contentId: contentId
            });
    const getParentData = (restrictions)=>{
        const ancestors = restrictions?.ancestors || [];
        for(let i = ancestors.length - 1; i >= 0; i--){
            if (ancestors[i].hasRestrictions) return ancestors[i]; // content
        }
    };
    const handleFreeEditionPadlockClicked = ()=>{
        setState((state_0)=>({
                ...state_0,
                showFreeRestrictionDialog: true
            }));
    };
    const onFreeDialogClosed = ()=>{
        setState((state_1)=>({
                ...state_1,
                showFreeRestrictionDialog: false
            }));
    };
    const renderFreeEditionDialog = (dialogStateContainer_0, shouldShowDialog)=>{
        const { isDisabled: isDisabled, triggeredFrom: triggeredFrom } = props; // already free edition
        const shouldSSRViewPageFreeEditionButton = triggeredFrom === 'fromView';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLw6A.PageRestrictionsContextConsumer), null, ({ loading: loading, error: error, restrictions: restrictions_0 })=>{
            if (!restrictions_0 && loading || error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null);
            const contentHasRestrictions = Boolean(restrictions_0?.hasRestrictions || restrictions_0?.hasInheritedRestrictions);
            const contentHasInheritedRestrictionsOnly = Boolean(restrictions_0?.hasInheritedRestrictions && !restrictions_0?.hasRestrictions);
            const immediateParentPageIndex = (restrictions_0?.ancestors.length || 0) - 1;
            const isChildPage = immediateParentPageIndex > 0; // Note: content with restrictions is excluded from the pageRestrictionsExperiment
            if (contentHasRestrictions) {
                if (isChildPage && contentHasInheritedRestrictionsOnly) {
                    const parentData = getParentData(restrictions_0);
                    return shouldSSRViewPageFreeEditionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b27bJ.ChangeEditionInlineDialogPaintLoader), {
                        isOpen: state.showFreeRestrictionDialog,
                        onClose: onFreeDialogClosed,
                        parentData: parentData,
                        isChildPage: isChildPage,
                        placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                        contentId: contentId,
                        isDisabled: isDisabled,
                        onClick: handleFreeEditionPadlockClicked,
                        restrictionsButtonSSRRendered: true,
                        restrictionsButtonSSRLocation: "free inherited",
                        triggeredFrom: triggeredFrom
                    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b27bJ.ChangeEditionInlineDialogLoader), {
                        isOpen: state.showFreeRestrictionDialog,
                        onClose: onFreeDialogClosed,
                        parentData: parentData,
                        isChildPage: isChildPage,
                        placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                        contentId: contentId,
                        isDisabled: isDisabled,
                        onClick: handleFreeEditionPadlockClicked,
                        restrictionsButtonSSRLocation: "free inherited",
                        triggeredFrom: triggeredFrom
                    }));
                }
                if (shouldShowDialog && !state.hasAutoOpenedRestrictionDialog) {
                    makeHandleOpen(dialogStateContainer_0)();
                    setState((state_2)=>({
                            ...state_2,
                            hasAutoOpenedRestrictionDialog: true
                        }));
                } // grandfathered content
                return shouldSSRViewPageFreeEditionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                    contentId: contentId,
                    isDisabled: isDisabled,
                    resetDialogState: ()=>dialogStateContainer_0.initState(),
                    onClick: makeHandleOpen(dialogStateContainer_0),
                    restrictionsButtonSSRRendered: true,
                    restrictionsButtonSSRLocation: "free grandfather",
                    triggeredFrom: triggeredFrom
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                    contentId: contentId,
                    isDisabled: isDisabled,
                    onClick: makeHandleOpen(dialogStateContainer_0),
                    restrictionsButtonSSRLocation: "free grandfather",
                    triggeredFrom: triggeredFrom
                });
            }
            return shouldSSRViewPageFreeEditionButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b27bJ.ChangeEditionInlineDialogPaintLoader), {
                isOpen: state.showFreeRestrictionDialog,
                onClose: onFreeDialogClosed,
                placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
                contentId: contentId,
                isDisabled: isDisabled,
                onClick: handleFreeEditionPadlockClicked,
                restrictionsButtonSSRRendered: true,
                restrictionsButtonSSRLocation: "free",
                triggeredFrom: triggeredFrom
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b27bJ.ChangeEditionInlineDialogLoader), {
                isOpen: state.showFreeRestrictionDialog,
                onClose: onFreeDialogClosed,
                placement: $0b24ce56d1d6b617$var$INLINE_DIALOG_PLACEMENT
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
                contentId: contentId,
                isDisabled: isDisabled,
                onClick: handleFreeEditionPadlockClicked,
                restrictionsButtonSSRLocation: "free",
                triggeredFrom: triggeredFrom
            }));
        });
    };
    const renderRestrictionsButton = (dialogStateContainer_1)=>{
        const { isDisabled: isDisabled_0, triggeredFrom: triggeredFrom_0 } = props;
        if (triggeredFrom_0 && triggeredFrom_0 === 'fromView') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderPaint), {
            contentId: contentId,
            isDisabled: isDisabled_0,
            onClick: makeHandleOpen(dialogStateContainer_1),
            resetDialogState: ()=>dialogStateContainer_1.initState(),
            restrictionsButtonSSRRendered: true,
            restrictionsButtonSSRLocation: "default",
            triggeredFrom: triggeredFrom_0
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSVAY.RestrictionsButtonLoaderAfterPaint), {
            contentId: contentId,
            isDisabled: isDisabled_0,
            onClick: makeHandleOpen(dialogStateContainer_1),
            restrictionsButtonSSRLocation: "default",
            triggeredFrom: triggeredFrom_0
        });
    };
    const renderGrantAccessFlagAndButton = (dialogStateContainer_2)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderRestrictionsButton(dialogStateContainer_2), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8RR7m.GrantAccessFlagLoader), {
            contentId: contentId
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $bVAxT.RestrictionsDialogStateContainer)
        ]
    }, (dialogStateContainer_3)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.default), {
            xcss: $0b24ce56d1d6b617$var$styles.buttonContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
            isCustomStart: true,
            key: `start-${contentId}`,
            metric: (0, $14SPd.RESTRICTIONS_BUTTON_METRIC)
        }), edition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7zgzO.RoutesContext).Consumer, null, ({ getQueryParams: getQueryParams })=>{
            const { accountId: accountId, grantAccess: grantAccess, username: // TODO(brizvash): non-gdpr params, remove when GDPR is on
            username } = getQueryParams();
            const shouldShowGrantAccessDialog = Boolean(grantAccess && accountId || username);
            return edition === (0, $euL71.ConfluenceEdition).FREE ? renderFreeEditionDialog(dialogStateContainer_3, shouldShowGrantAccessDialog) : renderGrantAccessFlagAndButton(dialogStateContainer_3);
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fkOJz.RestrictionsButtonLoading), null)));
});
$0b24ce56d1d6b617$export$4a978df01c3bf89e.displayName = 'RestrictionsDialogTrigger';
function $0b24ce56d1d6b617$export$59974e42a4613c7({ actionSubjectId: actionSubjectId, createAnalyticsEvent: createAnalyticsEvent, dialogStateContainer: dialogStateContainer, edition: edition, experienceTracker: experienceTracker, triggeredFrom: triggeredFrom, contentType: contentType, contentSubType: contentSubType, contentId: contentId }) {
    createAnalyticsEvent({
        type: 'sendUIEvent',
        data: {
            source: 'viewPageScreen',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: actionSubjectId,
            attributes: {
                source: 'v2',
                triggeredFrom: triggeredFrom,
                edition: edition,
                contentType: contentType,
                isLivePage: contentSubType === 'live'
            }
        }
    }).fire();
    experienceTracker.start({
        name: (0, $irVI7.RESTRICTIONS_DIALOG_EXPERIENCE),
        attributes: {
            contentType: contentType
        },
        collect (events, experience) {
            // Fail/Abort RESTRICTIONS_DIALOG as soon as _LOAD or _APPLY fails or aborts:
            experience.stopOn(events.find(({ action: action, name: name })=>(action === 'taskFail' || action === 'taskAbort') && (name === (0, $irVI7.RESTRICTIONS_DIALOG_LOAD_EXPERIENCE) || name === (0, $irVI7.RESTRICTIONS_DIALOG_APPLY_EXPERIENCE))));
        }
    });
    experienceTracker.start({
        name: (0, $irVI7.RESTRICTIONS_DIALOG_LOAD_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    }); //
    // Open RestrictionsDialog:
    //
    dialogStateContainer.setContentId(contentId);
    dialogStateContainer.setIsOpen(true, triggeredFrom);
    (0, $14SPd.RESTRICTIONS_DIALOG_METRIC).start();
}
function $0b24ce56d1d6b617$var$_temp(restrictions) {
    const ancestors = restrictions?.ancestors || [];
    for(let i = ancestors.length - 1; i >= 0; i--){
        if (ancestors[i].hasRestrictions) return ancestors[i];
    }
}
function $0b24ce56d1d6b617$var$_temp2(state_0) {
    return {
        ...state_0,
        showFreeRestrictionDialog: true
    };
}
function $0b24ce56d1d6b617$var$_temp3(state_1) {
    return {
        ...state_1,
        showFreeRestrictionDialog: false
    };
}
function $0b24ce56d1d6b617$var$_temp4(state_2) {
    return {
        ...state_2,
        hasAutoOpenedRestrictionDialog: true
    };
}
module.exports["RestrictionsDialogTrigger"] = $0b24ce56d1d6b617$export$4a978df01c3bf89e;

});

parcelRegister("b27bJ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $306758770d5ee79f$export$4556cd06b2dec862 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "PlyJG",
    name: "ChangeEditionInlineDialogLoader",
    loader: async ()=>(await (parcelRequire("gj9GX"))).ChangeEditionInlineDialog
});

const $306758770d5ee79f$export$5902d4a19951b5c3 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "4GH4a",
    name: "ChangeEditionInlineDialogPaintLoader",
    loader: async ()=>(await (parcelRequire("gj9GX"))).ChangeEditionInlineDialog
});
module.exports["ChangeEditionInlineDialogLoader"] = $306758770d5ee79f$export$4556cd06b2dec862;
module.exports["ChangeEditionInlineDialogPaintLoader"] = $306758770d5ee79f$export$5902d4a19951b5c3;

});

parcelRegister("gj9GX", function(module, exports) {

let $bdf5f0445bf5b04f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bdf5f0445bf5b04f$var$load("66GvX"),
    $bdf5f0445bf5b04f$var$load("1qlDN"),
    $bdf5f0445bf5b04f$var$load("1yVM6"),
    $bdf5f0445bf5b04f$var$load("fINdN"),
    $bdf5f0445bf5b04f$var$load("6XCf4"),
    $bdf5f0445bf5b04f$var$load("1zoBu")
]).then(()=>parcelRequire('4QNfT'));

});

parcelRegister("8RR7m", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $1756d5d44ec15fad$export$a83249587a24be5 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "960Da",
    name: "GrantAccessFlagLoader",
    loader: async ()=>(await (parcelRequire("8XfiS"))).GrantAccessFlag
});
module.exports["GrantAccessFlagLoader"] = $1756d5d44ec15fad$export$a83249587a24be5;

});

parcelRegister("8XfiS", function(module, exports) {

let $684fb45791a97d08$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $684fb45791a97d08$var$load("h4Nf7"),
    $684fb45791a97d08$var$load("4XkGy"),
    $684fb45791a97d08$var$load("fuOfV"),
    $684fb45791a97d08$var$load("jL1Ke"),
    $684fb45791a97d08$var$load("5MQ0D"),
    $684fb45791a97d08$var$load("Kj0I8"),
    $684fb45791a97d08$var$load("5xnun"),
    $684fb45791a97d08$var$load("6wr18"),
    $684fb45791a97d08$var$load("59hV4"),
    $684fb45791a97d08$var$load("8zMmc"),
    $684fb45791a97d08$var$load("4x9Jx"),
    $684fb45791a97d08$var$load("7EorR"),
    $684fb45791a97d08$var$load("ffEVr"),
    $684fb45791a97d08$var$load("2EIkU"),
    $684fb45791a97d08$var$load("iUXaE"),
    $684fb45791a97d08$var$load("lTkx9"),
    $684fb45791a97d08$var$load("Wowvf"),
    $684fb45791a97d08$var$load("eRhBr"),
    $684fb45791a97d08$var$load("hhss7"),
    $684fb45791a97d08$var$load("4mWJk")
]).then(()=>parcelRequire('4Cd45'));

});

parcelRegister("cSVAY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $eE3dj = parcelRequire("eE3dj");


var $fkOJz = parcelRequire("fkOJz");


const $c09757da0c891efc$export$758fc7bfe6cba448 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "langk",
    name: "RestrictionsButtonLoaderPaint",
    loader: async ()=>(await (parcelRequire("9uodn"))).RestrictionsButton,
    loading: (0, $fkOJz.RestrictionsButtonLoading)
});

const $c09757da0c891efc$export$92f59ae572209281 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ZXc7l",
    name: "RestrictionsButtonLoaderAfterPaint",
    loader: async ()=>(await (parcelRequire("9uodn"))).RestrictionsButton,
    loading: (0, $eE3dj.RestrictionsButtonPlaceholder)
});
module.exports["RestrictionsButtonLoaderPaint"] = $c09757da0c891efc$export$758fc7bfe6cba448;
module.exports["RestrictionsButtonLoaderAfterPaint"] = $c09757da0c891efc$export$92f59ae572209281;

});

parcelRegister("eE3dj", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $cb1652ec96a3881c$export$f7c9f842c83767d4 = (0, $3u0dr.isReactCompilerActiveV2)() ? function RestrictionsButtonPlaceholder() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "restrictions-button-placeholder",
            "data-test-id": "restrictions-button-placeholder",
            style: {
                width: 32,
                height: 32
            }
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function RestrictionsButtonPlaceholder() {
    // The RestrictionsDialog will be positioned based on the initial dimensions of
    // RestrictionsButton, so we need to render a placeholder instead of `null`
    // This placeholder is also used in SSR.
    // All the place that is waiting for data in restrictions package should use this placeholder instead of null.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "restrictions-button-placeholder",
        "data-test-id": "restrictions-button-placeholder",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            width: 32,
            height: 32
        }
    });
};
module.exports["RestrictionsButtonPlaceholder"] = $cb1652ec96a3881c$export$f7c9f842c83767d4;

});

parcelRegister("fkOJz", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eE3dj = parcelRequire("eE3dj");

const $560660f3777cb1ae$export$3375d726052961a6 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null);
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eE3dj.RestrictionsButtonPlaceholder), null);
};
module.exports["RestrictionsButtonLoading"] = $560660f3777cb1ae$export$3375d726052961a6;

});

parcelRegister("9uodn", function(module, exports) {

let $6e89b2f841dfa4e3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6e89b2f841dfa4e3$var$load("bYzij"),
    $6e89b2f841dfa4e3$var$load("6wr18"),
    $6e89b2f841dfa4e3$var$load("ffEVr"),
    $6e89b2f841dfa4e3$var$load("bfhXH")
]).then(()=>parcelRequire('l5Yc7'));

});

parcelRegister("j7Ouc", function(module, exports) {

let $dec5d546e27e86e0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dec5d546e27e86e0$var$load("fno6o").then(()=>parcelRequire('ca7si'));

});

parcelRegister("1Zthr", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $86e4d9c8583d266f$export$9c05e92142f10f44 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CxVtX",
    name: "UnarchivePagesDialogLoader",
    loader: async ()=>(await (parcelRequire("1Bvyn"))).UnarchivePagesLoader
});
module.exports["UnarchivePagesDialogLoader"] = $86e4d9c8583d266f$export$9c05e92142f10f44;

});

parcelRegister("1Bvyn", function(module, exports) {

let $12b1b9085d2f9723$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $12b1b9085d2f9723$var$load("iWnyc"),
    $12b1b9085d2f9723$var$load("ddvkk"),
    $12b1b9085d2f9723$var$load("3upHR"),
    $12b1b9085d2f9723$var$load("eRhBr"),
    $12b1b9085d2f9723$var$load("hZ2FX"),
    $12b1b9085d2f9723$var$load("6wr18"),
    $12b1b9085d2f9723$var$load("dRQ13"),
    $12b1b9085d2f9723$var$load("jyWy1"),
    $12b1b9085d2f9723$var$load("9pso5"),
    $12b1b9085d2f9723$var$load("LWh5V"),
    $12b1b9085d2f9723$var$load("kHXvF"),
    $12b1b9085d2f9723$var$load("ffEVr"),
    $12b1b9085d2f9723$var$load("lbsQO"),
    $12b1b9085d2f9723$var$load("7EorR"),
    $12b1b9085d2f9723$var$load("Wowvf"),
    $12b1b9085d2f9723$var$load("ayJxT"),
    $12b1b9085d2f9723$var$load("hhss7"),
    $12b1b9085d2f9723$var$load("dxDVc")
]).then(()=>parcelRequire('ew61I'));

});

parcelRegister("bYfSa", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $93a5db5531d4a12b$var$initialState = {
    dialog: {
        isOpen: false
    }
};
const $93a5db5531d4a12b$export$83212c186871ba71 = (0, $8s9DV.createStore)({
    initialState: $93a5db5531d4a12b$var$initialState,
    actions: {
        openConvertDialog: (payload)=>({ setState: setState, getState: getState })=>{
                const next = {
                    isOpen: true,
                    direction: payload.direction,
                    isLossy: payload.direction === 'toMarkdown' ? Boolean(payload.isLossy) : false,
                    syncBlockCount: payload.direction === 'toMarkdown' ? Math.max(payload.syncBlockCount ?? 0, 0) : 0
                };
                const current = getState();
                if (current.dialog.isOpen && current.dialog.direction === next.direction && current.dialog.isLossy === next.isLossy && current.dialog.syncBlockCount === next.syncBlockCount) return;
                setState({
                    dialog: next
                });
            },
        closeConvertDialog: ()=>({ setState: setState, getState: getState })=>{
                if (getState().dialog.isOpen) setState({
                    dialog: {
                        isOpen: false
                    }
                });
            }
    },
    name: 'ConvertDialogStore'
});
const $93a5db5531d4a12b$export$ad39afc4acff5a42 = (0, $kBr4q.createHook)($93a5db5531d4a12b$export$83212c186871ba71);
const $93a5db5531d4a12b$export$df72975e717193c9 = (0, $kBr4q.createActionsHook)($93a5db5531d4a12b$export$83212c186871ba71);
module.exports["useConvertDialogState"] = $93a5db5531d4a12b$export$ad39afc4acff5a42;
module.exports["useConvertDialogActions"] = $93a5db5531d4a12b$export$df72975e717193c9;

});

parcelRegister("bJrpn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $bYfSa = parcelRequire("bYfSa");


var $03dyQ = parcelRequire("03dyQ");


var $lhtqQ = parcelRequire("lhtqQ");


var $8cRVT = parcelRequire("8cRVT");


var $5zmqi = parcelRequire("5zmqi");


var $LSims = parcelRequire("LSims");


var $fEvT8 = parcelRequire("fEvT8");


var $hTLSK = parcelRequire("hTLSK");

const $f03ea469cfc6fc83$export$76935da616701441 = ({ contentId: contentId, isLivePage: isLivePage, editorActions: editorActions, flags: flags })=>{
    const { updateMarkdownMode: updateMarkdownMode, loading: isUpdating } = (0, $hTLSK.useUpdateMarkdownMode)();
    const isMarkdownMode = (0, $LSims.useIsMarkdownMode)(isLivePage ? contentId : undefined);
    // Dialog open/close lives in a sweet-state store so multiple call sites
    // (header overflow menu, title `.md`-suffix gesture, `cmd+shift+x`
    // shortcut) all drive the same dialog instance rendered by `MoreActions`.
    const [{ dialog: dialog }] = (0, $bYfSa.useConvertDialogState)();
    const { openConvertDialog: openConvertDialog, closeConvertDialog: closeConvertDialog } = (0, $bYfSa.useConvertDialogActions)();
    const convertFlags = (0, $fEvT8.useMarkdownConvertFlags)(flags);
    // Wait for any unconfirmed collab steps to be acked before flipping the
    // markdown-mode flag. The convert mutation invalidates the live-doc
    // session on the BE, which triggers an NCS restore that would otherwise
    // re-apply our unconfirmed steps on top of the server doc that already
    // has them — duplicating anything typed just before the click.
    const drainUnconfirmedSteps = (0, $cozmU.useCallback)(async ()=>{
        if (!('getResolvedEditorState' in editorActions)) return;
        try {
            await editorActions.getResolvedEditorState('publish');
        } catch  {
        // Swallow — don't block convert if the drain fails.
        }
    }, [
        editorActions
    ]);
    const flipFlagToMarkdown = (0, $cozmU.useCallback)(async ()=>{
        await drainUnconfirmedSteps();
        const result = await updateMarkdownMode(contentId, true);
        if (!result.success) {
            convertFlags.showError('toMarkdown');
            return {
                success: false
            };
        }
        // Replace the PM doc with the markdown-safe BE body BEFORE flipping
        // the mode cache. The flip triggers `reconfigureState`, which migrates
        // the current doc via `PMNode.fromJSON(markdownSchema, ...)` — any
        // rich-text-only node still in the doc (`status`, `panel`, `expand`,
        // ...) throws and resets the editor to empty.
        //
        // Monolith holds the rich-text ADF; NCS catchupv2 delivers the
        // filtered version. Running `filterToMarkdownSafeAdf` here matches
        // what NCS would deliver without FE/BE divergence (same pipeline
        // filter).
        const convertedBody = await (0, $5zmqi.refetchPageContent)(contentId);
        if (convertedBody && 'replaceDocument' in editorActions) try {
            const parsed = JSON.parse(convertedBody);
            const safe = (0, $lhtqQ.filterToMarkdownSafeAdf)(parsed);
            if (safe) editorActions.replaceDocument(safe, false);
        } catch  {
        // Editor unmounted, JSON parse failed, or filter rejected the
        // input. The flip still proceeds; NCS catchupv2 recovers.
        }
        (0, $hTLSK.patchIsMarkdownModeCache)(contentId, true, (0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true));
        convertFlags.showSuccess('toMarkdown');
        return {
            success: true
        };
    }, [
        contentId,
        convertFlags,
        drainUnconfirmedSteps,
        editorActions,
        updateMarkdownMode
    ]);
    const flipFlagToRichText = (0, $cozmU.useCallback)(async ()=>{
        await drainUnconfirmedSteps();
        const result = await updateMarkdownMode(contentId, false);
        if (!result.success) {
            convertFlags.showError('toRichText');
            return {
                success: false
            };
        }
        // Rich-text schema is a superset of markdown, so the `reconfigureState`
        // migration always succeeds — no doc replace needed. Refetch still
        // runs so the `CollabDraftQuery` cache mirrors the BE body and the
        // dialog holds in `isSubmitting` for the round-trip.
        await (0, $5zmqi.refetchPageContent)(contentId);
        (0, $hTLSK.patchIsMarkdownModeCache)(contentId, false, (0, $6mKj3.expValEquals)('cc-markdown-mode', 'isEnabled', true));
        convertFlags.showSuccess('toRichText');
        return {
            success: true
        };
    }, [
        contentId,
        convertFlags,
        drainUnconfirmedSteps,
        updateMarkdownMode
    ]);
    const confirmConvertToMarkdown = (0, $cozmU.useCallback)(()=>flipFlagToMarkdown(), [
        flipFlagToMarkdown
    ]);
    const confirmConvertToRichText = (0, $cozmU.useCallback)(async ()=>{
        return flipFlagToRichText();
    }, [
        flipFlagToRichText
    ]);
    // Entry point for the "Convert to markdown" menu item / shortcut /
    // `.md` title gesture. The dialog always opens; synced-block and lossy
    // signals are captured in dialog state and rendered as warning treatment.
    const convertToMarkdown = (0, $cozmU.useCallback)(async ()=>{
        let adf;
        if ('getValue' in editorActions) try {
            adf = await editorActions.getValue();
        } catch  {
            adf = undefined;
        }
        const syncBlockNodeCount = (0, $03dyQ.countSyncBlocks)(adf);
        const isLossy = syncBlockNodeCount > 0 ? false : await (0, $8cRVT.isMarkdownConversionLossy)(adf, contentId);
        openConvertDialog({
            direction: 'toMarkdown',
            isLossy: isLossy,
            syncBlockCount: syncBlockNodeCount
        });
    }, [
        contentId,
        editorActions,
        openConvertDialog
    ]);
    const convertToRichText = (0, $cozmU.useCallback)(async ()=>{
        openConvertDialog({
            direction: 'toRichText'
        });
    }, [
        openConvertDialog
    ]);
    return {
        isMarkdownMode: isMarkdownMode,
        isUpdating: isUpdating,
        convertDialogState: dialog,
        closeConvertDialog: closeConvertDialog,
        convertToMarkdown: convertToMarkdown,
        convertToRichText: convertToRichText,
        confirmConvertToMarkdown: confirmConvertToMarkdown,
        confirmConvertToRichText: confirmConvertToRichText
    };
};
module.exports["useMarkdownModeActions"] = $f03ea469cfc6fc83$export$76935da616701441;

});

parcelRegister("03dyQ", function(module, exports) {

var $4EPzQ = parcelRequire("4EPzQ");

const $d8d60ab22e6f347d$export$dfea1f72f7cab2b = (adf)=>{
    if (adf === undefined || adf === null) return 0;
    if (typeof adf !== 'object' || typeof adf.type !== 'string') return 0;
    return (0, $4EPzQ.reduce)(adf, (acc, node)=>node.type === 'bodiedSyncBlock' ? acc + 1 : acc, 0);
};
module.exports["countSyncBlocks"] = $d8d60ab22e6f347d$export$dfea1f72f7cab2b;

});

parcelRegister("lhtqQ", function(module, exports) {

var $jTt8P = parcelRequire("jTt8P");


var $ftIY0 = parcelRequire("ftIY0");

const $fbc0577d3febc813$export$796ad20fc99717ad = (adf)=>{
    if (adf === undefined || adf === null) return undefined;
    if (typeof adf !== 'object' || typeof adf.type !== 'string') return undefined;
    const result = (0, $jTt8P.traverse)(adf, {
        any: (node)=>{
            // 1. Drop nodes whose type isn't in the supported set.
            if (!(0, $ftIY0.MARKDOWN_SERIALIZABLE_NODE_TYPES).has(node.type)) return false;
            // 2. Drop merged-cell table cells / headers.
            if ((node.type === 'tableCell' || node.type === 'tableHeader') && (0, $ftIY0.hasMergedCellSpan)(node)) return false;
            // 3. Strip unsupported marks but keep the node.
            if (Array.isArray(node.marks) && node.marks.length > 0) {
                const filteredMarks = node.marks.filter((mark)=>mark && (0, $ftIY0.SUPPORTED_MARK_TYPES).has(mark.type));
                if (filteredMarks.length === node.marks.length) // Nothing to strip — keep node identity (returning the same node
                // reference signals "no change" to the traversal).
                return node;
                if (filteredMarks.length === 0) {
                    // Avoid leaving an empty `marks: []` on the output.
                    const { marks: _marks, ...rest } = node;
                    return rest;
                }
                return {
                    ...node,
                    marks: filteredMarks
                };
            }
            return node;
        }
    });
    return result === false ? undefined : result;
};
module.exports["filterToMarkdownSafeAdf"] = $fbc0577d3febc813$export$796ad20fc99717ad;

});

parcelRegister("ftIY0", function(module, exports) {
/**
 * Shared source-of-truth for which ADF nodes / marks are losslessly
 * representable in our markdown pipeline. Used by:
 *
 *  - `isMarkdownConversionLossyLocal(adf)` — local predicate that decides
 *    whether the rich-text → markdown confirmation dialog should be shown.
 *  - `filterToMarkdownSafeAdf(adf)`   — transformer that strips unsupported
 *    nodes / marks before we replace the document on convert.
 *
 * The pipeline opts into these GFM extensions on top of CommonMark:
 *   - TablesExtension          (GFM §4.10)
 *   - TaskListItemsExtension   (GFM §5.3)
 *   - StrikethroughExtension   (GFM §6.5)
 *   - AutolinkExtension        (GFM §6.9)
 */ const $bbb67cdc72502262$export$5970427aa01c4899 = new Set([
    // Document root
    'doc',
    // Block
    'paragraph',
    'heading',
    'blockquote',
    'codeBlock',
    'bulletList',
    'orderedList',
    'listItem',
    'rule',
    // GFM table (basic — see merged-cell check at the call site)
    'table',
    'tableRow',
    'tableHeader',
    'tableCell',
    // GFM task list items (rendered as `- [ ]` / `- [x]`)
    'taskList',
    'taskItem',
    // Media — only the `mediaSingle` wrapper + its `media` child are supported.
    // `mediaGroup`, `mediaInline`, and captioned `mediaSingleCaption` are NOT
    // in this set: they have no lossless CommonMark/GFM representation, so we
    // drop them via `filterToMarkdownSafeAdf` rather than silently degrading.
    //
    // `media` itself round-trips as a CommonMark image (`![alt](url)`):
    //   - `type: 'external'` — URL is the public `attrs.url`.
    //   - `type: 'file'`     — URL is the tenant Confluence proxy URL
    //                          (`/wiki/download/attachments/{contentId}/{filename}`)
    //                          built by an injected serialiser. No media tokens
    //                          ever land in the markdown text — the renderer's
    //                          session cookie auths the proxy fetch.
    'mediaSingle',
    'media',
    // Inline
    'text',
    'hardBreak'
]);
const $bbb67cdc72502262$export$d79bb6026ae1b0e = new Set([
    ...$bbb67cdc72502262$export$5970427aa01c4899,
    // Smart links degrade to regular Markdown links. The conversion is still
    // lossy because rich smartlink rendering is not represented in GFM, but the
    // URL should survive the rich-text -> markdown conversion.
    'inlineCard'
]);
const $bbb67cdc72502262$export$a9a2d20833ede9a6 = new Set([
    'em',
    'strong',
    'strike',
    'code',
    'link'
]);
const $bbb67cdc72502262$export$64c6f110c3ddfdf0 = (node)=>{
    const colspan = node.attrs?.colspan;
    const rowspan = node.attrs?.rowspan;
    return typeof colspan === 'number' && colspan > 1 || typeof rowspan === 'number' && rowspan > 1;
};
module.exports["SUPPORTED_NODE_TYPES"] = $bbb67cdc72502262$export$5970427aa01c4899;
module.exports["MARKDOWN_SERIALIZABLE_NODE_TYPES"] = $bbb67cdc72502262$export$d79bb6026ae1b0e;
module.exports["SUPPORTED_MARK_TYPES"] = $bbb67cdc72502262$export$a9a2d20833ede9a6;
module.exports["hasMergedCellSpan"] = $bbb67cdc72502262$export$64c6f110c3ddfdf0;

});

parcelRegister("8cRVT", function(module, exports) {

var $4EPzQ = parcelRequire("4EPzQ");


var $c0rhi = parcelRequire("c0rhi");


var $ge2sX = parcelRequire("ge2sX");


var $ftIY0 = parcelRequire("ftIY0");


var $knBoM = parcelRequire("knBoM");

/**
 * Returns `true` when the supplied document contains nodes / marks that don't
 * round-trip cleanly into the markdown pipeline (panels, expands, layouts,
 * status, date, mention, smart cards, media, custom marks, tables with merged
 * cells, etc.). Callers use this to decide whether to surface a confirmation
 * dialog before kicking off a rich-text → markdown conversion.
 *
 * The decision is based purely on **node `type`** and **mark `type`** — the
 * content of supported nodes is irrelevant.
 *
 * Keep this check stricter than `filterToMarkdownSafeAdf`: some nodes, such as
 * `inlineCard`, are safe to pass to the markdown serializer because the URL can
 * degrade to a regular Markdown link, but the rich smart-link rendering is
 * still lost. Those nodes should continue to trigger the confirmation dialog.
 */ const $3408489e988a2177$var$isNodeLossy = (node)=>{
    if (!(0, $ftIY0.SUPPORTED_NODE_TYPES).has(node.type)) return true;
    if (Array.isArray(node.marks)) for (const mark of node.marks){
        if (mark && !(0, $ftIY0.SUPPORTED_MARK_TYPES).has(mark.type)) return true;
    }
    if ((node.type === 'tableCell' || node.type === 'tableHeader') && (0, $ftIY0.hasMergedCellSpan)(node)) return true;
    return false;
};
const $3408489e988a2177$export$38a08ed0b4959725 = (adf)=>{
    if (adf === undefined || adf === null) return false;
    if (typeof adf !== 'object' || typeof adf.type !== 'string') return false;
    return (0, $4EPzQ.reduce)(adf, (acc, node)=>acc || $3408489e988a2177$var$isNodeLossy(node), false);
};
const $3408489e988a2177$var$isMarkdownConversionLossyGraphql = async (contentId)=>{
    try {
        const { cloudId: cloudId } = await (0, $ge2sX.getSessionData)();
        if (!cloudId) return undefined;
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: (0, $knBoM.ValidateConvertPageToMarkdownModeQuery),
            variables: {
                cloudId: cloudId,
                contentId: contentId
            },
            fetchPolicy: 'network-only',
            interopApolloAggClient: true,
            __callerPackage__: "content-markdown-mode"
        });
        const isLossless = data?.confluence_validateConvertPageToMarkdownMode?.isLossless;
        return typeof isLossless === 'boolean' ? !isLossless : undefined;
    } catch  {
        return undefined;
    }
};
const $3408489e988a2177$export$9477c765bd6693f4 = async (adf, contentId)=>{
    if (contentId) {
        const graphqlResult = await $3408489e988a2177$var$isMarkdownConversionLossyGraphql(contentId);
        if (typeof graphqlResult === 'boolean') return graphqlResult;
    }
    return $3408489e988a2177$export$38a08ed0b4959725(adf);
};
module.exports["isMarkdownConversionLossy"] = $3408489e988a2177$export$9477c765bd6693f4;

});

parcelRegister("knBoM", function(module, exports) {

var $5vrKv = parcelRequire("5vrKv");

const $eae5d89f0551e425$export$db295ff502a9150a = (0, $5vrKv.default);
module.exports["ValidateConvertPageToMarkdownModeQuery"] = $eae5d89f0551e425$export$db295ff502a9150a;

});

parcelRegister("5vrKv", function(module, exports) {
/**
 * @generated SignedSource<<3051a9bd301cd38cb8cb6ed83844353a>>
 * @relayHash 5f62c435dcac8baaf0c8fe7285050069
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f2eabe404746fdc5ee133f0a7e9771978eede747044e4df12abad078af3528bd
const $f88b9492edf7e7b7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ConfluenceValidateConvertPageToMarkdownModeResult",
            "kind": "LinkedField",
            "name": "confluence_validateConvertPageToMarkdownMode",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isLossless"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ValidateConvertPageToMarkdownModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ValidateConvertPageToMarkdownModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5f62c435dcac8baaf0c8fe7285050069",
            "id": "f2eabe404746fdc5ee133f0a7e9771978eede747044e4df12abad078af3528bd",
            "metadata": {},
            "name": "ValidateConvertPageToMarkdownModeQuery",
            "operationKind": "query",
            "text": "query ValidateConvertPageToMarkdownModeQuery($cloudId:ID!,$contentId:ID!){confluence_validateConvertPageToMarkdownMode(cloudId:$cloudId,contentId:$contentId){isLossless}}"
        }
    };
}();
$f88b9492edf7e7b7$var$node.hash = "492958e6bac166c062e3d8a2a17a0d5c";
var $f88b9492edf7e7b7$export$2e2bcd8739ae039 = $f88b9492edf7e7b7$var$node;
module.exports["default"] = $f88b9492edf7e7b7$export$2e2bcd8739ae039;

});

parcelRegister("fEvT8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");

const $a3779901118e4ab6$var$i18n = (0, $kSwu1.defineMessages)({
    convertToMarkdownError: {
        id: "content-markdown-mode.use-markdown-mode-actions.convert-to-markdown-error",
        defaultMessage: "Failed to convert to markdown"
    },
    convertToRichTextError: {
        id: "content-markdown-mode.use-markdown-mode-actions.convert-to-rich-text-error",
        defaultMessage: "Failed to convert to rich text"
    },
    convertToMarkdownSuccessTitle: {
        id: "content-markdown-mode.use-markdown-mode-actions.convert-to-markdown-success.title",
        defaultMessage: "You\u2019ve converted to markdown"
    },
    convertToMarkdownSuccessBody: {
        id: "content-markdown-mode.use-markdown-mode-actions.convert-to-markdown-success.body",
        defaultMessage: "Edits to this doc are now made in markdown."
    },
    findOutMoreAboutMarkdown: {
        id: "content-markdown-mode.use-markdown-mode-actions.find-out-more.markdown",
        defaultMessage: "Find out more about markdown"
    },
    convertToRichTextSuccessTitle: {
        id: "content-markdown-mode.use-markdown-mode-actions.convert-to-rich-text-success.title",
        defaultMessage: "You\u2019ve converted to a live doc"
    },
    convertToRichTextSuccessBody: {
        id: "content-markdown-mode.use-markdown-mode-actions.convert-to-rich-text-success.body",
        defaultMessage: "Updates to this doc will now be instant and visible in real time."
    },
    findOutMoreAboutLiveDocs: {
        id: "content-markdown-mode.use-markdown-mode-actions.find-out-more.live-docs",
        defaultMessage: "Find out more about live docs"
    }
});
const $a3779901118e4ab6$var$LIVE_DOCS_LEARN_MORE_URL = 'https://support.atlassian.com/confluence-cloud/docs/create-and-collaborate-in-real-time-with-live-docs/';
const $a3779901118e4ab6$var$MARKDOWN_LEARN_MORE_URL = 'https://support.atlassian.com/confluence-cloud/docs/keyboard-shortcuts-markdown-and-autocomplete/';
// Matches the page → live-doc convert success flag.
const $a3779901118e4ab6$var$CONVERT_SUCCESS_FLAG_AUTO_CLOSE_MS = 11000;
const $a3779901118e4ab6$export$6cae3f92397e1d6d = (flags)=>{
    const intl = (0, $kSwu1.useIntl)();
    return (0, $cozmU.useMemo)(()=>({
            showError: (direction)=>{
                if (!flags.showErrorFlag) return;
                const message = direction === 'toMarkdown' ? $a3779901118e4ab6$var$i18n.convertToMarkdownError : $a3779901118e4ab6$var$i18n.convertToRichTextError;
                flags.showErrorFlag({
                    title: intl.formatMessage(message)
                });
            },
            showSuccess: (direction)=>{
                if (!flags.showFlag) return;
                const isToMarkdown = direction === 'toMarkdown';
                const flagId = isToMarkdown ? 'content-markdown-mode-convert-to-markdown-flag' : 'content-markdown-mode-convert-to-rich-text-flag';
                const learnMoreUrl = isToMarkdown ? $a3779901118e4ab6$var$MARKDOWN_LEARN_MORE_URL : $a3779901118e4ab6$var$LIVE_DOCS_LEARN_MORE_URL;
                const titleMessage = isToMarkdown ? $a3779901118e4ab6$var$i18n.convertToMarkdownSuccessTitle : $a3779901118e4ab6$var$i18n.convertToRichTextSuccessTitle;
                const bodyMessage = isToMarkdown ? $a3779901118e4ab6$var$i18n.convertToMarkdownSuccessBody : $a3779901118e4ab6$var$i18n.convertToRichTextSuccessBody;
                const learnMoreMessage = isToMarkdown ? $a3779901118e4ab6$var$i18n.findOutMoreAboutMarkdown : $a3779901118e4ab6$var$i18n.findOutMoreAboutLiveDocs;
                flags.showFlag({
                    id: flagId,
                    type: 'success',
                    title: intl.formatMessage(titleMessage),
                    description: intl.formatMessage(bodyMessage),
                    // Survive the editor-unmount `hideAllFlags()` during the
                    // conversion remount — we dismiss manually below.
                    close: 'never',
                    actions: [
                        {
                            // Real anchor via `@atlaskit/link` — browser owns
                            // navigation. `rel="noopener noreferrer"` prevents
                            // tabnabbing (canonical Confluence pattern, see
                            // `editor-flags/buildEditorFlagMessage.tsx`).
                            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                                href: learnMoreUrl,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                appearance: "subtle"
                            }, intl.formatMessage(learnMoreMessage)),
                            onClick: ()=>{}
                        }
                    ]
                });
                setTimeout(()=>flags.hideFlag?.(flagId), $a3779901118e4ab6$var$CONVERT_SUCCESS_FLAG_AUTO_CLOSE_MS);
            }
        }), [
        flags,
        intl
    ]);
};
module.exports["useMarkdownConvertFlags"] = $a3779901118e4ab6$export$6cae3f92397e1d6d;

});

parcelRegister("6eFi0", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ad336c78e6fcf61a$export$492577bc4a81367b = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "seFL5",
    name: "ResolvedInlineCommentsDialogLoader",
    loader: async ()=>(await (parcelRequire("2QLti"))).ResolvedInlineCommentsDialog
});
module.exports["ResolvedInlineCommentsDialogLoader"] = $ad336c78e6fcf61a$export$492577bc4a81367b;

});

parcelRegister("2QLti", function(module, exports) {

let $213542fa17b3ac0c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $213542fa17b3ac0c$var$load("66GvX"),
    $213542fa17b3ac0c$var$load("houtd"),
    $213542fa17b3ac0c$var$load("6wr18"),
    $213542fa17b3ac0c$var$load("cJsay"),
    $213542fa17b3ac0c$var$load("agdLZ"),
    $213542fa17b3ac0c$var$load("HaNwW"),
    $213542fa17b3ac0c$var$load("RylUf"),
    $213542fa17b3ac0c$var$load("cIET7"),
    $213542fa17b3ac0c$var$load("7EorR"),
    $213542fa17b3ac0c$var$load("jzUgs"),
    $213542fa17b3ac0c$var$load("1GCFv"),
    $213542fa17b3ac0c$var$load("7oAXW"),
    $213542fa17b3ac0c$var$load("h1yOv"),
    $213542fa17b3ac0c$var$load("kHXvF"),
    $213542fa17b3ac0c$var$load("7gL7H"),
    $213542fa17b3ac0c$var$load("cmmpX"),
    $213542fa17b3ac0c$var$load("ffEVr"),
    $213542fa17b3ac0c$var$load("hhss7"),
    $213542fa17b3ac0c$var$load("Wowvf"),
    $213542fa17b3ac0c$var$load("ezm4t"),
    $213542fa17b3ac0c$var$load("h9ofP"),
    $213542fa17b3ac0c$var$load("4JSav"),
    $213542fa17b3ac0c$var$load("lbsQO"),
    $213542fa17b3ac0c$var$load("eCXJR"),
    $213542fa17b3ac0c$var$load("1VTX2"),
    $213542fa17b3ac0c$var$load("cHcD4"),
    $213542fa17b3ac0c$var$load("2m65P"),
    $213542fa17b3ac0c$var$load("ghNAx"),
    $213542fa17b3ac0c$var$load("he34V"),
    $213542fa17b3ac0c$var$load("dEUQZ"),
    $213542fa17b3ac0c$var$load("gzrfp"),
    $213542fa17b3ac0c$var$load("80Yra"),
    $213542fa17b3ac0c$var$load("1NGPq"),
    $213542fa17b3ac0c$var$load("7TnhR"),
    $213542fa17b3ac0c$var$load("ddvkk"),
    $213542fa17b3ac0c$var$load("3upHR"),
    $213542fa17b3ac0c$var$load("79Tk4"),
    $213542fa17b3ac0c$var$load("daX4F"),
    $213542fa17b3ac0c$var$load("hZ2FX"),
    $213542fa17b3ac0c$var$load("gVVrO"),
    $213542fa17b3ac0c$var$load("6KRyd"),
    $213542fa17b3ac0c$var$load("kT6dz"),
    $213542fa17b3ac0c$var$load("aAWLw"),
    $213542fa17b3ac0c$var$load("hOsjc")
]).then(()=>parcelRequire('92Mdh'));

});

parcelRegister("bzwhi", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $67Foi = parcelRequire("67Foi");


var $lsxnT = parcelRequire("lsxnT");


var $dINOl = parcelRequire("dINOl");


var $1j3IV = parcelRequire("1j3IV");


var $4R0nV = parcelRequire("4R0nV");


var $4TcLf = parcelRequire("4TcLf");


var $4ZXww = parcelRequire("4ZXww");


var $kSwrz = parcelRequire("kSwrz");

var $2347032a59a3f6fa$export$6054829ec0b77d62 = /*#__PURE__*/ function(MoreActionsObjectSidebarTourSteps) {
    MoreActionsObjectSidebarTourSteps[MoreActionsObjectSidebarTourSteps["FIRST"] = 0] = "FIRST";
    return MoreActionsObjectSidebarTourSteps;
}({});
const $2347032a59a3f6fa$var$i18n = (0, $kSwu1.defineMessages)({
    ok: {
        id: "object-sidebar-components.more-actions.tour.ok",
        defaultMessage: "OK"
    },
    getTheDetailsYouNeed: {
        id: "object-sidebar-components.more-actions.tour.get-the-details-you-need",
        defaultMessage: "Get the details you need"
    },
    viewAndManageOwnership: {
        id: "object-sidebar-components.more-actions.tour.view-and-manage-ownership",
        defaultMessage: "View and manage ownership, labels, and more in a single panel."
    }
});
const $2347032a59a3f6fa$var$MORE_ACTIONS_OBJECT_SIDEBAR_SPOTLIGHT_NAME = 'more-actions-object-sidebar-spotlight';
const $2347032a59a3f6fa$var$useSpotlights = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { end: end } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const theme = (0, $IQ4Dz.default)();
    const GetTheDetailsYouNeedGif = theme.colorMode === "dark" ? (0, (/*@__PURE__*/$parcel$interopDefault($1j3IV))) : (0, (/*@__PURE__*/$parcel$interopDefault($4R0nV)));
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage($2347032a59a3f6fa$var$i18n.ok);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== end || $[3] !== t1) {
        t2 = [
            {
                onClick: end,
                text: t1
            }
        ];
        $[2] = end;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== formatMessage) {
        t3 = formatMessage($2347032a59a3f6fa$var$i18n.getTheDetailsYouNeed);
        $[5] = formatMessage;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== end) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dINOl.CrossIconCloseButton), {
            onClose: end,
            source: $2347032a59a3f6fa$var$MORE_ACTIONS_OBJECT_SIDEBAR_SPOTLIGHT_NAME
        });
        $[7] = end;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== formatMessage) {
        t5 = formatMessage($2347032a59a3f6fa$var$i18n.viewAndManageOwnership);
        $[9] = formatMessage;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== GetTheDetailsYouNeedGif || $[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
        t6 = [
            {
                key: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
                target: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
                targetRadius: 3,
                actions: t2,
                image: GetTheDetailsYouNeedGif,
                dialogWidth: 341,
                heading: t3,
                headingAfterElement: t4,
                children: t5
            }
        ];
        $[11] = GetTheDetailsYouNeedGif;
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
} : ({ end: end })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const theme = (0, $IQ4Dz.default)();
    const GetTheDetailsYouNeedGif = theme.colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($1j3IV))) : (0, (/*@__PURE__*/$parcel$interopDefault($4R0nV)));
    return [
        {
            key: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
            target: (0, $4ZXww.OBJECT_SIDEBAR_TOUR_TARGETS).SIDEBAR_DETAILS_BUTTON,
            targetRadius: 3,
            actions: [
                {
                    onClick: end,
                    text: formatMessage($2347032a59a3f6fa$var$i18n.ok)
                }
            ],
            image: GetTheDetailsYouNeedGif,
            dialogWidth: 341,
            heading: formatMessage($2347032a59a3f6fa$var$i18n.getTheDetailsYouNeed),
            headingAfterElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dINOl.CrossIconCloseButton), {
                onClose: end,
                source: $2347032a59a3f6fa$var$MORE_ACTIONS_OBJECT_SIDEBAR_SPOTLIGHT_NAME
            }),
            children: formatMessage($2347032a59a3f6fa$var$i18n.viewAndManageOwnership)
        }
    ];
};
const $2347032a59a3f6fa$var$FLOATING_ACTION_BAR_CHANGEBOARDING = 'floatingActionBarChangeboarding';
const $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS = [
    $2347032a59a3f6fa$var$FLOATING_ACTION_BAR_CHANGEBOARDING
];
const $2347032a59a3f6fa$export$4ead2825721da9b4 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { step: step } = t0;
    const [t1, t2] = (0, $4TcLf.useMoreActionsObjectSidebarTourState)();
    const { activeSpotlightIndex: activeSpotlightIndex, lastActiveSpotlightIndex: lastActiveSpotlightIndex } = t1;
    const { concludeTour: endTour, initiateTour: initiateTour, resetTour: resetTour } = t2;
    const [messageType] = (0, $cozmU.useState)((0, $kSwrz.MessageType).Transactional);
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    let t3;
    if ($[0] !== endTour) {
        t3 = ()=>{
            endTour();
        };
        $[0] = endTour;
        $[1] = t3;
    } else t3 = $[1];
    const concludeTour = t3;
    let t4;
    if ($[2] !== concludeTour) {
        t4 = {
            end: concludeTour
        };
        $[2] = concludeTour;
        $[3] = t4;
    } else t4 = $[3];
    const spotlights = $2347032a59a3f6fa$var$useSpotlights(t4);
    let t5;
    if ($[4] !== Spotlight || $[5] !== activeSpotlightIndex || $[6] !== messageType || $[7] !== spotlights || $[8] !== step) {
        t5 = activeSpotlightIndex === step ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Spotlight, {
            messageType: messageType,
            shouldWatchTarget: true,
            dialogPlacement: "left bottom",
            targetBgColor: "var(--ds-surface-overlay, #FFFFFF)",
            ...spotlights[activeSpotlightIndex]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $67Foi.ScreenEvent), {
            id: $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS[activeSpotlightIndex],
            name: $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS[activeSpotlightIndex]
        })) : null;
        $[4] = Spotlight;
        $[5] = activeSpotlightIndex;
        $[6] = messageType;
        $[7] = spotlights;
        $[8] = step;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== activeSpotlightIndex || $[11] !== concludeTour || $[12] !== initiateTour || $[13] !== lastActiveSpotlightIndex || $[14] !== resetTour || $[15] !== t5) {
        t6 = {
            activeSpotlight: t5,
            initiateTour: initiateTour,
            concludeTour: concludeTour,
            resetTour: resetTour,
            activeSpotlightIndex: activeSpotlightIndex,
            lastActiveSpotlightIndex: lastActiveSpotlightIndex
        };
        $[10] = activeSpotlightIndex;
        $[11] = concludeTour;
        $[12] = initiateTour;
        $[13] = lastActiveSpotlightIndex;
        $[14] = resetTour;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
} : ({ step: step })=>{
    const [{ activeSpotlightIndex: activeSpotlightIndex, lastActiveSpotlightIndex: lastActiveSpotlightIndex }, { concludeTour: endTour, initiateTour: initiateTour, resetTour: resetTour }] = (0, $4TcLf.useMoreActionsObjectSidebarTourState)();
    const [messageType, _] = (0, $cozmU.useState)((0, $kSwrz.MessageType).Transactional);
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const concludeTour = (0, $cozmU.useCallback)(()=>{
        endTour();
    }, [
        endTour
    ]);
    const spotlights = $2347032a59a3f6fa$var$useSpotlights({
        end: concludeTour
    });
    return {
        activeSpotlight: activeSpotlightIndex === step ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Spotlight, {
            messageType: messageType,
            shouldWatchTarget: true,
            dialogPlacement: "left bottom",
            targetBgColor: "var(--ds-surface-overlay, #FFFFFF)",
            ...spotlights[activeSpotlightIndex]
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $67Foi.ScreenEvent), {
            id: $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS[activeSpotlightIndex],
            name: $2347032a59a3f6fa$var$SCREEN_EVENT_SUBJECTS[activeSpotlightIndex]
        })) : null,
        initiateTour: initiateTour,
        concludeTour: concludeTour,
        resetTour: resetTour,
        activeSpotlightIndex: activeSpotlightIndex,
        lastActiveSpotlightIndex: lastActiveSpotlightIndex
    };
};
module.exports["MoreActionsObjectSidebarTourSteps"] = $2347032a59a3f6fa$export$6054829ec0b77d62;
module.exports["useMoreActionsObjectSidebarTour"] = $2347032a59a3f6fa$export$4ead2825721da9b4;

});

parcelRegister("dINOl", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $l3wuH = parcelRequire("l3wuH");


var $9DHhW = parcelRequire("9DHhW");

const $732e88608cb14d24$export$f56d620db6064703 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { onClose: onClose, source: source } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== onClose || $[2] !== source) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "dismiss",
                    source: source
                }
            }).fire();
            onClose();
        };
        $[0] = createAnalyticsEvent;
        $[1] = onClose;
        $[2] = source;
        $[3] = t1;
    } else t1 = $[3];
    const handleClick = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $732e88608cb14d24$var$messages.dismiss);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== handleClick) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: $732e88608cb14d24$var$_temp,
            appearance: "subtle",
            label: t2,
            onClick: handleClick
        });
        $[5] = handleClick;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ onClose: onClose, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleClick = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismiss',
                source: source
            }
        }).fire();
        onClose();
    }, [
        onClose,
        createAnalyticsEvent,
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                ...iconProps,
                color: "var(--ds-icon-inverse, #FFFFFF)"
            }),
        appearance: "subtle",
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $732e88608cb14d24$var$messages.dismiss),
        onClick: handleClick
    });
};
const $732e88608cb14d24$var$messages = (0, $kSwu1.defineMessages)({
    dismiss: {
        id: "object-sidebar-components.cross-icon-close-button.dismiss",
        defaultMessage: "Dismiss"
    }
});
function $732e88608cb14d24$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        ...iconProps,
        color: "var(--ds-icon-inverse, #FFFFFF)"
    });
}
module.exports["CrossIconCloseButton"] = $732e88608cb14d24$export$f56d620db6064703;

});

parcelRegister("1j3IV", function(module, exports) {
module.exports = new URL("GetTheDetailsYouNeedDark.bbe9839d.gif", import.meta.url).toString();

});

parcelRegister("4R0nV", function(module, exports) {
module.exports = new URL("GetTheDetailsYouNeedLight.9900190e.gif", import.meta.url).toString();

});

parcelRegister("4TcLf", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $2cb4928bb9fae204$var$initialState = {
    activeSpotlightIndex: null,
    lastActiveSpotlightIndex: null
};
const $2cb4928bb9fae204$var$Store = (0, $8s9DV.createStore)({
    initialState: $2cb4928bb9fae204$var$initialState,
    actions: {
        goToStep: (nextStep)=>({ setState: setState })=>{
                setState({
                    activeSpotlightIndex: nextStep
                });
            },
        resetTour: ()=>({ setState: setState })=>{
                setState($2cb4928bb9fae204$var$initialState);
            },
        initiateTour: ()=>({ setState: setState })=>{
                setState({
                    activeSpotlightIndex: 0
                });
            },
        proceedToNext: ()=>({ setState: setState, getState: getState })=>{
                const { activeSpotlightIndex: activeSpotlightIndex } = getState();
                if (activeSpotlightIndex === null) return;
                setState({
                    activeSpotlightIndex: activeSpotlightIndex + 1,
                    lastActiveSpotlightIndex: activeSpotlightIndex
                });
            },
        concludeTour: ()=>({ setState: setState, getState: getState })=>{
                const { activeSpotlightIndex: activeSpotlightIndex } = getState();
                setState({
                    activeSpotlightIndex: null,
                    lastActiveSpotlightIndex: activeSpotlightIndex
                });
            }
    }
});
const $2cb4928bb9fae204$export$2488884e040ac8b3 = (0, $kBr4q.createHook)($2cb4928bb9fae204$var$Store);
const $2cb4928bb9fae204$export$66587c60bfe17f2b = (0, $kBr4q.createActionsHook)($2cb4928bb9fae204$var$Store);
module.exports["useMoreActionsObjectSidebarTourState"] = $2cb4928bb9fae204$export$2488884e040ac8b3;

});

parcelRegister("4ZXww", function(module, exports) {
const $6699361aa30cfc48$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX = 'object-sidebar-tour-target:';
const $6699361aa30cfc48$export$461ea60ca403d592 = {
    MORE_ACTIONS_ITEMS: `${$6699361aa30cfc48$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}more-actions-items`,
    OBJECT_SIDEBAR_CONTROL: `${$6699361aa30cfc48$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}object-sidebar-control`,
    SIDEBAR_DETAILS_BUTTON: `${$6699361aa30cfc48$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}sidebar-details-button`
};
module.exports["OBJECT_SIDEBAR_TOUR_TARGETS"] = $6699361aa30cfc48$export$461ea60ca403d592;

});

parcelRegister("kSwrz", function(module, exports) {
var $c5d0a4f039ea82e6$export$80edbf15fa61a4db = /*#__PURE__*/ function(MessageType) {
    MessageType["Engagement"] = "engagement";
    MessageType["Transactional"] = "transactional";
    return MessageType;
}({});
module.exports["MessageType"] = $c5d0a4f039ea82e6$export$80edbf15fa61a4db;

});

parcelRegister("3krUE", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c06b6cca0a728bb0$export$154e7cde95b8409b = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "-pxiH",
    name: "LazyWatchSettingsOverflowMenuShortcut",
    loader: async ()=>(await (parcelRequire("evYeX"))).WatchSettingsOverflowMenuShortcut
});
module.exports["LazyWatchSettingsOverflowMenuShortcut"] = $c06b6cca0a728bb0$export$154e7cde95b8409b;

});

parcelRegister("evYeX", function(module, exports) {

let $a912b066302fccfc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a912b066302fccfc$var$load("bYzij"),
    $a912b066302fccfc$var$load("6wr18"),
    $a912b066302fccfc$var$load("8hbZ5"),
    $a912b066302fccfc$var$load("ffEVr"),
    $a912b066302fccfc$var$load("3kVph"),
    $a912b066302fccfc$var$load("3yFtm")
]).then(()=>parcelRequire('dQUV0'));

});

parcelRegister("pskhd", function(module, exports) {
const $b218ab7927acda99$export$169d32883304392c = (data)=>{
    const isCurrentUserWatching = data?.singleContent?.currentUserIsWatching ?? false;
    const isWatchingSpace = data?.singleContent?.space?.currentUser?.isWatched ?? false;
    const isWatchingBlogs = data?.singleContent?.space?.currentUser?.isWatchingBlogs ?? false;
    // TODO remove type checks once watch with children gate cleaned up
    const isWatchingChildren = data?.singleContent && 'currentUserIsWatchingChildren' in data?.singleContent ? data?.singleContent?.currentUserIsWatchingChildren ?? false : false;
    const hasAncestorWatchingChildren = data?.singleContent && 'currentUserHasAncestorWatchingChildren' in data?.singleContent ? data?.singleContent?.currentUserHasAncestorWatchingChildren ?? false : false;
    return {
        isCurrentUserWatching: isCurrentUserWatching,
        isWatchingSpace: isWatchingSpace,
        isWatchingBlogs: isWatchingBlogs,
        isWatchingChildren: isWatchingChildren,
        hasAncestorWatchingChildren: hasAncestorWatchingChildren
    };
};
module.exports["processWatchData"] = $b218ab7927acda99$export$169d32883304392c;

});

parcelRegister("kPqqM", function(module, exports) {

var $SF9MR = parcelRequire("SF9MR");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9d7Pd = parcelRequire("9d7Pd");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $cf6nm = parcelRequire("cf6nm");


var $iCPvv = parcelRequire("iCPvv");


var $jMyy4 = parcelRequire("jMyy4");

const $3dca15cc31736255$export$f4601f3807dd9177 = ({ isDisabled: isDisabled, className: className, shortcut: shortcut, ...props })=>{
    const TooltipI18n = props.isStarred ? $3dca15cc31736255$var$i18n.Unstar : $3dca15cc31736255$var$i18n.Star;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iCPvv.SpaceStar), props, ({ toggle: toggleStar })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            testId: "star-menu-item",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
            className: className,
            isDisabled: isDisabled,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cf6nm.StarIcon), {
                isStarred: props.isStarred,
                spacing: props.spacing
            }),
            onClick: toggleStar,
            iconAfter: shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: shortcut
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), TooltipI18n)));
};
const $3dca15cc31736255$export$e07e4133bf676bf6 = ({ spaceKey: spaceKey })=>{
    const { data: spaceFavouriteStatusData } = (0, $jMyy4.useQueryInterop)((0, $SF9MR.default), {
        variables: {
            spaceKey: spaceKey
        },
        fetchPolicy: 'cache-first',
        __callerPackage__: "action-buttons"
    });
    const isStarred = spaceFavouriteStatusData?.space?.currentUser?.isFavourited || false;
    const spaceName = spaceFavouriteStatusData?.space?.name || spaceFavouriteStatusData?.space?.alias || spaceFavouriteStatusData?.space?.key || '';
    const spaceId = spaceFavouriteStatusData?.space?.id || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3dca15cc31736255$export$f4601f3807dd9177, {
        isStarred: isStarred,
        spaceId: spaceId,
        spaceKey: spaceKey,
        spacing: "none",
        spaceName: spaceName,
        shortcut: (0, $gnkil.UNIVERSAL_STAR_BUTTON_SHORTCUT),
        shouldShowFlags: true,
        analytics: {
            attributes: {
                isContentWrapper: true,
                spaceId: // as of now, SpaceStarMenuItemWithQuery is only called from object header overflow menu
                spaceId
            },
            source: 'SpaceStarMenuItemOverflowMenu'
        }
    });
};
const $3dca15cc31736255$var$i18n = (0, $kSwu1.defineMessages)({
    Star: {
        id: "action-buttons.space.star.menu.item",
        defaultMessage: "Star space"
    },
    Unstar: {
        id: "action-buttons.space.unstar.menu.item",
        defaultMessage: "Unstar space"
    }
});
module.exports["SpaceStarMenuItem"] = $3dca15cc31736255$export$f4601f3807dd9177;
module.exports["SpaceStarMenuItemWithQuery"] = $3dca15cc31736255$export$e07e4133bf676bf6;

});

parcelRegister("SF9MR", function(module, exports) {
/**
 * @generated SignedSource<<6c76fed1cd91ee9b7df046b7fa9db63a>>
 * @relayHash 559bd430fdfdfbcc11a49c9267441232
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 81d16e5819097691085dd475dbd9bfc078e336858a9f76b272264c34e97c1872
const $00b16c2e2c56a4ba$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isFavourited"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceStarMenuItemIsSpaceFavouritedQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceStarMenuItemIsSpaceFavouritedQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "559bd430fdfdfbcc11a49c9267441232",
            "id": "81d16e5819097691085dd475dbd9bfc078e336858a9f76b272264c34e97c1872",
            "metadata": {},
            "name": "SpaceStarMenuItemIsSpaceFavouritedQuery",
            "operationKind": "query",
            "text": "query SpaceStarMenuItemIsSpaceFavouritedQuery($spaceKey:String!){space(key:$spaceKey){id,alias,name,key,currentUser{isFavourited}}}"
        }
    };
}();
$00b16c2e2c56a4ba$var$node.hash = "c77a49dbb962e7ad6bf61d5e4f25b221";
var $00b16c2e2c56a4ba$export$2e2bcd8739ae039 = $00b16c2e2c56a4ba$var$node;
module.exports["default"] = $00b16c2e2c56a4ba$export$2e2bcd8739ae039;

});

parcelRegister("iCPvv", function(module, exports) {

var $h4SYW = parcelRequire("h4SYW");


var $3rcpI = parcelRequire("3rcpI");


var $8DAzB = parcelRequire("8DAzB");


var $iWaZt = parcelRequire("iWaZt");


var $eUlFW = parcelRequire("eUlFW");


var $5j9jt = parcelRequire("5j9jt");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $fFmJj = parcelRequire("fFmJj");


var $ij4CE = parcelRequire("ij4CE");


var $cTJK3 = parcelRequire("cTJK3");


var $7aRa9 = parcelRequire("7aRa9");


var $308Wd = parcelRequire("308Wd");


var $cfidN = parcelRequire("cfidN");







const $ac59452c65a90798$var$i18n = (0, $kSwu1.defineMessages)({
    starErrorTitle: {
        id: "action-buttons.space.star.error.title",
        defaultMessage: "We\u2019re having trouble starring this space"
    },
    unstarErrorTitle: {
        id: "action-buttons.space.unstar.error.title",
        defaultMessage: "We\u2019re having trouble unstarring this space"
    },
    errorDescription: {
        id: "action-buttons.error.description",
        defaultMessage: "Refresh and try again."
    },
    starSuccessFlagTitle: {
        id: "action-buttons.space.star.success.title",
        defaultMessage: "{spaceName} starred"
    },
    unstarSuccessFlagTitle: {
        id: "action-buttons.space.unstar.success.title",
        defaultMessage: "{spaceName} unstarred"
    }
});
const $ac59452c65a90798$var$SpaceStarComponent = ({ spaceId: spaceId, spaceKey: spaceKey, isStarred: isStarred, onStar: onStar, onUnstar: onUnstar, analytics: analytics, intl: intl, children: children, flags: flags, spaceName: spaceName, shouldShowFlags: shouldShowFlags })=>{
    const readCurrentSpace = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $5j9jt.default),
        __callerPackage__: "action-buttons"
    });
    const readStarredSpaces = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: (0, $eUlFW.default),
        __callerPackage__: "action-buttons"
    });
    const writeUpdateCurrentUserFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $iWaZt.default),
        fragmentArtifact: (0, $iWaZt.default),
        __callerPackage__: "action-buttons"
    });
    const writeStarredSpacesFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $8DAzB.default),
        fragmentArtifact: (0, $8DAzB.default),
        __callerPackage__: "action-buttons"
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const modifyStarCache = (0, $cozmU.useCallback)((newStarredValue)=>{
        try {
            // The (Un)FavoriteSpaceMutations do not return the updated space, so we need to manually update the cache.
            // This is necessary to update the UI immediately after the user clicks the star button.
            writeUpdateCurrentUserFragment({
                fragmentId: `Space:${spaceId}`,
                data: {
                    currentUser: {
                        isFavourited: newStarredValue,
                        __typename: 'SpaceUserMetadata'
                    },
                    __typename: 'Space'
                }
            });
            // Update the starred spaces list in the Spaces dropdown (and any other consumers of useSpacesData)
            (0, $cTJK3.updateStarredSpacesList)(spaceId, newStarredValue, readCurrentSpace, readStarredSpaces, writeStarredSpacesFragment);
        } catch  {}
    }, [
        spaceId,
        readCurrentSpace,
        readStarredSpaces,
        writeStarredSpacesFragment,
        writeUpdateCurrentUserFragment
    ]);
    const [starSpace, { error: starError }] = (0, $308Wd.useMutationInterop)((0, $3rcpI.default), {
        onError: ()=>{
            // Revert the cache back to the previous state
            modifyStarCache(false);
        },
        __callerPackage__: "action-buttons"
    });
    const [unstarSpace, { error: unstarError }] = (0, $308Wd.useMutationInterop)((0, $h4SYW.default), {
        onError: ()=>{
            // Revert the cache back to the previous state
            modifyStarCache(true);
        },
        __callerPackage__: "action-buttons"
    });
    const toggleStar = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        if (isStarred) onUnstar && onUnstar(e);
        else onStar && onStar(e);
        // Optimistically update the cache
        modifyStarCache(!isStarred);
        const mutation = isStarred ? unstarSpace : starSpace;
        mutation({
            variables: {
                spaceKey: spaceKey
            }
        }).then(()=>{
            if (isStarred && shouldShowFlags) flags.showSuccessFlag({
                title: intl.formatMessage($ac59452c65a90798$var$i18n.unstarSuccessFlagTitle, {
                    spaceName: spaceName
                }),
                isAutoDismiss: true
            });
            else if (!isStarred && shouldShowFlags) flags.showSuccessFlag({
                title: intl.formatMessage($ac59452c65a90798$var$i18n.starSuccessFlagTitle, {
                    spaceName: spaceName
                }),
                isAutoDismiss: true
            });
        }).catch((_)=>{});
        if (analytics) {
            const { source: source, containerId: containerId, attributes: attributes } = analytics;
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: isStarred ? 'unstarred' : 'starred',
                    actionSubject: 'space',
                    source: source,
                    attributes: attributes,
                    ...containerId && {
                        containerId: containerId
                    }
                }
            }).fire();
        }
    }, [
        isStarred,
        spaceKey,
        analytics,
        starSpace,
        unstarSpace,
        modifyStarCache,
        onStar,
        onUnstar,
        createAnalyticsEvent,
        flags,
        intl,
        spaceName,
        shouldShowFlags
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children({
        toggle: toggleStar
    }), starError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cfidN.ActionErrorFlag), {
        title: intl.formatMessage($ac59452c65a90798$var$i18n.starErrorTitle),
        description: intl.formatMessage($ac59452c65a90798$var$i18n.errorDescription),
        error: starError
    }), unstarError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cfidN.ActionErrorFlag), {
        title: intl.formatMessage($ac59452c65a90798$var$i18n.unstarErrorTitle),
        description: intl.formatMessage($ac59452c65a90798$var$i18n.errorDescription),
        error: unstarError
    }));
};
const $ac59452c65a90798$export$4e2eb132a04ae560 = (0, $7aRa9.withFlags)((0, $kSwu1.injectIntl)($ac59452c65a90798$var$SpaceStarComponent));
module.exports["SpaceStar"] = $ac59452c65a90798$export$4e2eb132a04ae560;

});

parcelRegister("h4SYW", function(module, exports) {
/**
 * @generated SignedSource<<c9db3185ab8693debf04c06c2635c98e>>
 * @relayHash 9713a87882c5e6383e438ee687952963
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 24fcf7d9198609064e8a85eb41bcf50e2a570e7e7bb679c9d58b3ffec028c495
const $1e902e1ae2e520ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "FavouriteSpacePayload",
            "kind": "LinkedField",
            "name": "unfavouriteSpace",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isSpaceFavourited"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceStarUnfavoriteSpaceMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceStarUnfavoriteSpaceMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "9713a87882c5e6383e438ee687952963",
            "id": "24fcf7d9198609064e8a85eb41bcf50e2a570e7e7bb679c9d58b3ffec028c495",
            "metadata": {},
            "name": "SpaceStarUnfavoriteSpaceMutation",
            "operationKind": "mutation",
            "text": "mutation SpaceStarUnfavoriteSpaceMutation($spaceKey:String!){unfavouriteSpace(spaceKey:$spaceKey){isSpaceFavourited}}"
        }
    };
}();
$1e902e1ae2e520ea$var$node.hash = "947f8794b11432ca2dea89537ba4c2d6";
var $1e902e1ae2e520ea$export$2e2bcd8739ae039 = $1e902e1ae2e520ea$var$node;
module.exports["default"] = $1e902e1ae2e520ea$export$2e2bcd8739ae039;

});

parcelRegister("3rcpI", function(module, exports) {
/**
 * @generated SignedSource<<fa08bda29fced98f3c45302e6ced8426>>
 * @relayHash 74b417d304c57976b899306f93428c4f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b36c6c2510862573bc06ef4f0bdbb7bd99382b9e2118c66d79b68bfaddd9f647
const $55e292c0c31a2a67$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "FavouriteSpacePayload",
            "kind": "LinkedField",
            "name": "favouriteSpace",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isSpaceFavourited"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceStarFavoriteSpaceMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceStarFavoriteSpaceMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "74b417d304c57976b899306f93428c4f",
            "id": "b36c6c2510862573bc06ef4f0bdbb7bd99382b9e2118c66d79b68bfaddd9f647",
            "metadata": {},
            "name": "SpaceStarFavoriteSpaceMutation",
            "operationKind": "mutation",
            "text": "mutation SpaceStarFavoriteSpaceMutation($spaceKey:String!){favouriteSpace(spaceKey:$spaceKey){isSpaceFavourited}}"
        }
    };
}();
$55e292c0c31a2a67$var$node.hash = "9ac5c6d950db28ef929151bfa7f1b419";
var $55e292c0c31a2a67$export$2e2bcd8739ae039 = $55e292c0c31a2a67$var$node;
module.exports["default"] = $55e292c0c31a2a67$export$2e2bcd8739ae039;

});

parcelRegister("8DAzB", function(module, exports) {
/**
 * @generated SignedSource<<39f18a245a31c007c77ce5f5c9ee8f94>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $edf1f89db5626c55$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SpaceStarWriteStarredSpacesFragment",
    "selections": [
        {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "PaginatedSpaceList"
};
$edf1f89db5626c55$var$node.hash = "72f0ab1980fee3d3ebcdbd9647ddc161";
var $edf1f89db5626c55$export$2e2bcd8739ae039 = $edf1f89db5626c55$var$node;
module.exports["default"] = $edf1f89db5626c55$export$2e2bcd8739ae039;

});

parcelRegister("iWaZt", function(module, exports) {
/**
 * @generated SignedSource<<96b0d47a239a4453b03d10a247c9e028>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3dd5c0573ac0253a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SpaceStarActionButtonSpaceFragment",
    "selections": [
        {
            "concreteType": "SpaceUserMetadata",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isFavourited"
                }
            ]
        }
    ],
    "type": "Space"
};
$3dd5c0573ac0253a$var$node.hash = "8952ed3b4f2eb093d58223c1da19fdac";
var $3dd5c0573ac0253a$export$2e2bcd8739ae039 = $3dd5c0573ac0253a$var$node;
module.exports["default"] = $3dd5c0573ac0253a$export$2e2bcd8739ae039;

});

parcelRegister("eUlFW", function(module, exports) {
/**
 * @generated SignedSource<<0b51e0ed63eacdac2772293ea5508c48>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ae9f5e7e7a9dde99$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SpaceStarReadStarredSpacesFragment",
    "selections": [
        {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "PaginatedSpaceList"
};
$ae9f5e7e7a9dde99$var$node.hash = "4a38c9f3868a7bbf44a9931e1d6903ac";
var $ae9f5e7e7a9dde99$export$2e2bcd8739ae039 = $ae9f5e7e7a9dde99$var$node;
module.exports["default"] = $ae9f5e7e7a9dde99$export$2e2bcd8739ae039;

});

parcelRegister("5j9jt", function(module, exports) {
/**
 * @generated SignedSource<<d686b0eedf9323798b549af0da2f0f71>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b485608b483d3bf6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "SpaceStarCurrentSpaceFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "alias"
        },
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "concreteType": "Icon",
            "kind": "LinkedField",
            "name": "icon",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "path"
                }
            ]
        }
    ],
    "type": "Space"
};
$b485608b483d3bf6$var$node.hash = "0e7af2ea53ea33a3d76e321d036b891d";
var $b485608b483d3bf6$export$2e2bcd8739ae039 = $b485608b483d3bf6$var$node;
module.exports["default"] = $b485608b483d3bf6$export$2e2bcd8739ae039;

});

parcelRegister("cTJK3", function(module, exports) {
const $a85b49bec4fd02db$export$1c070079c48d3bdd = (spaceId, isStarred, readCurrentSpace, readStarredSpaces, writeStarredSpacesFragment)=>{
    const space = readCurrentSpace({
        id: `Space:${spaceId}`
    });
    try {
        const starredSpaces = readStarredSpaces({
            id: `$ROOT_QUERY.spaces(${JSON.stringify({
                favourite: true,
                first: 30,
                status: 'current'
            })})`
        })?.nodes || [];
        let newStarredSpaces;
        if (isStarred) {
            newStarredSpaces = [
                ...starredSpaces,
                space
            ];
            newStarredSpaces.sort((a, b)=>!a?.name || !b?.name ? 0 : a.name.localeCompare(b.name));
        } else newStarredSpaces = starredSpaces.filter((s)=>s?.id !== spaceId);
        writeStarredSpacesFragment({
            fragmentId: `$ROOT_QUERY.spaces(${JSON.stringify({
                favourite: true,
                first: 30,
                status: 'current'
            })})`,
            data: {
                nodes: newStarredSpaces,
                __typename: 'PaginatedSpaceList'
            }
        });
    } catch  {
    // If Apollo throws an error, the starred spaces data was not found in the cache.
    // Errors can be safely ignored as if there is no cache entry, there is no work to be done.
    }
};
module.exports["updateStarredSpacesList"] = $a85b49bec4fd02db$export$1c070079c48d3bdd;

});

parcelRegister("1TN2N", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $b742140c6b014561$export$fcc1c0135b5761c6 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "F85M0",
    name: "LazyForgeContentTools",
    loader: async ()=>(await (parcelRequire("2Ed7h"))).ForgeContentTools
});
module.exports["LazyForgeContentTools"] = $b742140c6b014561$export$fcc1c0135b5761c6;

});

parcelRegister("2Ed7h", function(module, exports) {

let $1ed97dd2b6e2b7b4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1ed97dd2b6e2b7b4$var$load("6wr18"),
    $1ed97dd2b6e2b7b4$var$load("bzc8Q"),
    $1ed97dd2b6e2b7b4$var$load("ffEVr"),
    $1ed97dd2b6e2b7b4$var$load("7EorR"),
    $1ed97dd2b6e2b7b4$var$load("8zMmc"),
    $1ed97dd2b6e2b7b4$var$load("Wowvf"),
    $1ed97dd2b6e2b7b4$var$load("kyfJT")
]).then(()=>parcelRequire('dhbEh'));

});

parcelRegister("d8J72", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $bYLFm = parcelRequire("bYLFm");


var $gjbSq = parcelRequire("gjbSq");


var $b3j2Y = parcelRequire("b3j2Y");


var $3eMfQ = parcelRequire("3eMfQ");

const $6f5c98e13f07416a$export$dc453ea17a7d7b53 = (t0)=>{
    const $ = (0, $bDgLe.c)(30);
    let contentId;
    let dialogs;
    let onClick;
    let props;
    let sectionItem;
    let shouldHighlight;
    let spaceKey;
    if ($[0] !== t0) {
        ({ sectionItem: sectionItem, contentId: contentId, spaceKey: spaceKey, dialogs: dialogs, shouldHighlight: shouldHighlight, onClick: onClick, ...props } = t0);
        $[0] = t0;
        $[1] = contentId;
        $[2] = dialogs;
        $[3] = onClick;
        $[4] = props;
        $[5] = sectionItem;
        $[6] = shouldHighlight;
        $[7] = spaceKey;
    } else {
        contentId = $[1];
        dialogs = $[2];
        onClick = $[3];
        props = $[4];
        sectionItem = $[5];
        shouldHighlight = $[6];
        spaceKey = $[7];
    }
    let t1;
    if ($[8] !== contentId || $[9] !== spaceKey) {
        t1 = {
            contentId: contentId,
            spaceKey: spaceKey
        };
        $[8] = contentId;
        $[9] = spaceKey;
        $[10] = t1;
    } else t1 = $[10];
    const { canConvertPageToFolder: canConvertPageToFolder, contentTitle: contentTitle, error: error } = (0, $gjbSq.useCanConvertPageToFolder)(t1);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t2;
    if ($[11] !== contentId || $[12] !== contentTitle || $[13] !== createAnalyticsEvent || $[14] !== dialogs || $[15] !== onClick || $[16] !== spaceKey) {
        t2 = (e)=>{
            onClick?.(e);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "convertPageToFolder",
                    source: "contentToolsItem"
                }
            }).fire();
            dialogs.showDialog((0, $bYLFm.ConvertPageToFolderDialog), {
                contentId: contentId,
                spaceKey: spaceKey,
                contentTitle: contentTitle
            });
        };
        $[11] = contentId;
        $[12] = contentTitle;
        $[13] = createAnalyticsEvent;
        $[14] = dialogs;
        $[15] = onClick;
        $[16] = spaceKey;
        $[17] = t2;
    } else t2 = $[17];
    const openDialog = t2;
    if (!canConvertPageToFolder) {
        let t3;
        if ($[18] !== error) {
            t3 = error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            }) : null;
            $[18] = error;
            $[19] = t3;
        } else t3 = $[19];
        return t3;
    }
    let t3;
    if ($[20] !== error) {
        t3 = error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        $[20] = error;
        $[21] = t3;
    } else t3 = $[21];
    let t4;
    if ($[22] !== openDialog || $[23] !== props || $[24] !== sectionItem || $[25] !== shouldHighlight) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eMfQ.LazyContentToolsItem), {
            key: sectionItem.completeKey,
            ...sectionItem,
            url: "",
            ...props,
            onClick: openDialog,
            shouldHighlight: shouldHighlight
        });
        $[22] = openDialog;
        $[23] = props;
        $[24] = sectionItem;
        $[25] = shouldHighlight;
        $[26] = t4;
    } else t4 = $[26];
    let t5;
    if ($[27] !== t3 || $[28] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t3, t4);
        $[27] = t3;
        $[28] = t4;
        $[29] = t5;
    } else t5 = $[29];
    return t5;
};
module.exports["ConvertToFolderItem"] = $6f5c98e13f07416a$export$dc453ea17a7d7b53;

});

parcelRegister("bYLFm", function(module, exports) {

var $WfKBt = parcelRequire("WfKBt");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7aRdF = parcelRequire("7aRdF");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $fEPJS = parcelRequire("fEPJS");


var $1VhsF = parcelRequire("1VhsF");


var $ad7Ou = parcelRequire("ad7Ou");


var $7joZr = parcelRequire("7joZr");


var $9DHhW = parcelRequire("9DHhW");


var $kA6Zo = parcelRequire("kA6Zo");


var $2wCqQ = parcelRequire("2wCqQ");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $fGzMp = parcelRequire("fGzMp");


var $dPJCf = parcelRequire("dPJCf");


var $67Foi = parcelRequire("67Foi");


var $1NBp8 = parcelRequire("1NBp8");


var $cb6fO = parcelRequire("cb6fO");


var $b3j2Y = parcelRequire("b3j2Y");


var $95rLf = parcelRequire("95rLf");


var $7Sm4c = parcelRequire("7Sm4c");


var $7aRa9 = parcelRequire("7aRa9");


var $6mKj3 = parcelRequire("6mKj3");


var $euL71 = parcelRequire("euL71");


var $bQm3c = parcelRequire("bQm3c");


var $laFNM = parcelRequire("laFNM");


var $308Wd = parcelRequire("308Wd");

const $ad7bf5a97d16ed21$var$COMPONENT_NAME = 'ConvertPageToFolderDialogModal';
const $ad7bf5a97d16ed21$var$source = 'VIEW_PAGE';
const $ad7bf5a97d16ed21$var$warningMessageStyles = (0, $buxP3.xcss)({
    marginBottom: 'space.100'
});
const $ad7bf5a97d16ed21$export$de0fa8bd80a55013 = 241;
const $ad7bf5a97d16ed21$var$ConvertPageToFolderDialogComponent = ({ spaceKey: spaceKey, contentId: contentId, contentTitle: contentTitle, onClose: onClose, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const { approvalRequest: approvalRequest } = (0, $laFNM.useApprovals)();
    const hasApprovalReview = Boolean(approvalRequest?.review);
    const [isConverting, setIsConverting] = (0, $cozmU.useState)(false);
    const [convertPageToFolderMutation, { error: convertPageToFolderError }] = (0, $308Wd.useMutationInterop)((0, $WfKBt.default), {
        __callerPackage__: "folder-conversion"
    });
    const handleOnClose = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'clicked',
                actionSubject: $ad7bf5a97d16ed21$var$COMPONENT_NAME,
                actionSubjectId: `${$ad7bf5a97d16ed21$var$COMPONENT_NAME}CancelButton`,
                source: $ad7bf5a97d16ed21$var$source
            }
        }).fire();
        onClose();
    }, [
        createAnalyticsEvent,
        onClose
    ]);
    const convertPageToFolderSuccess = (data)=>{
        setIsConverting(false);
        experienceTracker.succeed({
            name: (0, $irVI7.CONVERT_PAGE_TO_FOLDER_EXPERIENCE)
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                actionSubject: $ad7bf5a97d16ed21$var$COMPONENT_NAME,
                action: 'success',
                attributes: undefined,
                source: $ad7bf5a97d16ed21$var$source
            }
        }).fire();
        flags.showFlag({
            type: 'success-circle',
            title: formatMessage($ad7bf5a97d16ed21$var$i18n.successFlagTitle),
            description: formatMessage($ad7bf5a97d16ed21$var$i18n.successFlagDescription),
            close: 'auto'
        });
        const contentId = data?.data?.convertToFolder?.content?.id;
        if (contentId) {
            const newlyCreatedFolderUrl = (0, $1NBp8.FOLDER_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId,
                ...(0, $6mKj3.expVal)('confluence_folder_view', 'isEnabled', false) && {
                    contentSlug: (0, $cb6fO.generateSlug)(contentTitle)
                }
            });
            newlyCreatedFolderUrl && push(newlyCreatedFolderUrl);
        }
        onClose();
    };
    const showErrorFlag = ({ title: title, description: description, actions: actions })=>{
        flags.showFlag({
            type: 'error',
            title: title,
            description: description,
            close: 'auto',
            actions: actions
        });
    };
    const abortExperienceOnExpectedError = (error)=>{
        (0, $7Sm4c.markErrorAsHandled)(error);
        experienceTracker.abort({
            name: (0, $irVI7.CONVERT_PAGE_TO_FOLDER_EXPERIENCE),
            reason: 'Expected Apollo error'
        });
    };
    const convertPageToFolderFailure = (error)=>{
        if ($ad7bf5a97d16ed21$var$isPageEditRestrictedError(error)) {
            showErrorFlag({
                title: formatMessage($ad7bf5a97d16ed21$var$i18n.editPermissionErrorFlagTitle),
                description: formatMessage($ad7bf5a97d16ed21$var$i18n.editPermissionErrorFlagDescription)
            });
            abortExperienceOnExpectedError(error);
        } else if ($ad7bf5a97d16ed21$var$isNameCollisionError(error)) {
            showErrorFlag({
                title: formatMessage($ad7bf5a97d16ed21$var$i18n.nameCollisionErrorFlagTitle),
                description: formatMessage($ad7bf5a97d16ed21$var$i18n.nameCollisionErrorFlagDescription)
            });
            abortExperienceOnExpectedError(error);
        } else if ($ad7bf5a97d16ed21$var$isNameLengthLimitError(error) && contentTitle) {
            showErrorFlag({
                title: formatMessage($ad7bf5a97d16ed21$var$i18n.nameLengthLimitErrorFlagTitle),
                description: formatMessage($ad7bf5a97d16ed21$var$i18n.nameLengthLimitErrorFlagDescription, {
                    numCharsOverLimit: contentTitle.length - $ad7bf5a97d16ed21$export$de0fa8bd80a55013
                })
            });
            abortExperienceOnExpectedError(error);
        } else {
            showErrorFlag({
                title: formatMessage($ad7bf5a97d16ed21$var$i18n.defaultErrorFlagTitle),
                description: formatMessage($ad7bf5a97d16ed21$var$i18n.defaultErrorFlagDescription),
                actions: [
                    {
                        content: formatMessage($ad7bf5a97d16ed21$var$i18n.defaultErrorFlagAction),
                        onClick: handlePageToFolderConversion
                    }
                ]
            });
            if ((0, $95rLf.isExpectedApolloError)(error)) {
                abortExperienceOnExpectedError(error);
                return;
            }
            (0, $fGzMp.stopExperienceOnError)((0, $irVI7.CONVERT_PAGE_TO_FOLDER_EXPERIENCE), error);
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    actionSubject: $ad7bf5a97d16ed21$var$COMPONENT_NAME,
                    action: 'failed',
                    attributes: {
                        error: error
                    },
                    actionSubjectId: `${$ad7bf5a97d16ed21$var$COMPONENT_NAME}ConvertButton`,
                    source: $ad7bf5a97d16ed21$var$source
                }
            }).fire();
        }
    };
    const handlePageToFolderConversion = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: $ad7bf5a97d16ed21$var$COMPONENT_NAME,
                actionSubjectId: `${$ad7bf5a97d16ed21$var$COMPONENT_NAME}ConvertButton`,
                source: $ad7bf5a97d16ed21$var$source
            }
        }).fire();
        setIsConverting(true);
        experienceTracker.start({
            name: (0, $irVI7.CONVERT_PAGE_TO_FOLDER_EXPERIENCE)
        });
        convertPageToFolderMutation({
            variables: {
                id: contentId
            }
        }).then((data)=>{
            convertPageToFolderSuccess(data);
        }).catch((error)=>{
            convertPageToFolderFailure(error);
            setIsConverting(false);
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        width: "450px",
        key: "ConvertPageToFolderDialog",
        onClose: handleOnClose,
        shouldScrollInViewport: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ad7bf5a97d16ed21$var$i18n.dialogHeader))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        space: "space.100"
    }, isPremium && hasApprovalReview && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $ad7bf5a97d16ed21$var$warningMessageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ad7bf5a97d16ed21$var$i18n.approvalsWarning))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ad7bf5a97d16ed21$var$i18n.dialogDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        justifyContent: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7joZr.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: handleOnClose,
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ad7bf5a97d16ed21$var$i18n.cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: handlePageToFolderConversion,
        appearance: "primary",
        isLoading: isConverting
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $ad7bf5a97d16ed21$var$i18n.dialogSubmitText)))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $67Foi.ScreenEvent), {
        name: "convertPageToFolderDialogModalScreen",
        id: "convertPageToFolderModalScreenEvent"
    }), convertPageToFolderError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: convertPageToFolderError
    }));
};
const $ad7bf5a97d16ed21$var$ConvertPageToFolderDialogWithFlags = (0, $7aRa9.withFlags)($ad7bf5a97d16ed21$var$ConvertPageToFolderDialogComponent);
const $ad7bf5a97d16ed21$export$ae121ae5418ce48b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $laFNM.ApprovalsProvider), {
        contentId: props.contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ad7bf5a97d16ed21$var$ConvertPageToFolderDialogWithFlags, props));
const $ad7bf5a97d16ed21$var$isPageEditRestrictedError = (error)=>error.message.includes('User does not have permissions to perform this action');
const $ad7bf5a97d16ed21$var$isNameCollisionError = (error)=>error.message.includes('A folder exists with the same title in this space');
const $ad7bf5a97d16ed21$var$isNameLengthLimitError = (error)=>error.message.includes('Title cannot be longer than 255 characters');
const $ad7bf5a97d16ed21$var$i18n = (0, $kSwu1.defineMessages)({
    dialogHeader: {
        id: "folder-conversion.convert-page-to-folder.dialog.header",
        defaultMessage: "Convert this page into a folder?"
    },
    dialogDescription: {
        id: "folder-conversion.convert-page-to-folder.dialog.description",
        defaultMessage: "We\u2019ll archive the original page, so you don\u2019t need to worry about losing your work."
    },
    cancel: {
        id: "folder-conversion.convert-page-to-folder.dialog.cancel",
        defaultMessage: "Cancel"
    },
    dialogSubmitText: {
        id: "folder-conversion.convert-page-to-folder.dialog.submit",
        defaultMessage: "Convert"
    },
    approvalsWarning: {
        id: "folder-conversion.convert-page-to-folder.dialog.approvalsWarning",
        defaultMessage: "This will end an approval."
    },
    successFlagTitle: {
        id: "folder-conversion.convert-page-to-folder.flags.success-message.title",
        defaultMessage: "Conversion complete"
    },
    successFlagDescription: {
        id: "folder-conversion.convert-page-to-folder.flags.success-message.description.placeholder-title",
        defaultMessage: "We\u2019ve finished converting the page to a folder."
    },
    defaultErrorFlagTitle: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.title",
        defaultMessage: "We couldn\u2019t convert the page to a folder"
    },
    defaultErrorFlagDescription: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.description.placeholder-title",
        defaultMessage: "Something went wrong, and we were unable to convert this page to a folder."
    },
    defaultErrorFlagAction: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.action",
        defaultMessage: "Try again"
    },
    editPermissionErrorFlagTitle: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.edit-permissions.title",
        defaultMessage: "Request edit and archive access to continue"
    },
    editPermissionErrorFlagDescription: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.edit-permissions.description",
        defaultMessage: "To convert this page to a folder, you\u2019ll need permission to edit and archive it."
    },
    nameCollisionErrorFlagTitle: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.name-collision.title",
        defaultMessage: "Rename this page to continue"
    },
    nameCollisionErrorFlagDescription: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.name-collision.description",
        defaultMessage: "To avoid duplicate titles, you\u2019ll need to rename this page before we can convert it to a folder and archive the original."
    },
    nameLengthLimitErrorFlagTitle: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.name-length-limit.title",
        defaultMessage: "Give this page a shorter title"
    },
    nameLengthLimitErrorFlagDescription: {
        id: "folder-conversion.convert-page-to-folder.flags.error-message.name-length-limit.description",
        defaultMessage: "Before we can convert this page to a folder, archiving the original, you\u2019ll need to give it a title that is at least {numCharsOverLimit, plural, one {# character} other {# characters}} shorter."
    }
});
module.exports["ConvertPageToFolderDialog"] = $ad7bf5a97d16ed21$export$ae121ae5418ce48b;

});

parcelRegister("WfKBt", function(module, exports) {
/**
 * @generated SignedSource<<a6c73600adeb768aa334b04a865edb6f>>
 * @relayHash 4eea0357b0c46bdca044a6b3b9b301ec
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c9a17fe744f7014b84fa0265289a77140bedf705796685c18a7cc805136059b2
const $c938044c857e7ec1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "ConfluenceConvertContentToFolderPayload",
            "kind": "LinkedField",
            "name": "convertToFolder",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ConvertPageToFolderDialogConvertPageToFolderMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ConvertPageToFolderDialogConvertPageToFolderMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "4eea0357b0c46bdca044a6b3b9b301ec",
            "id": "c9a17fe744f7014b84fa0265289a77140bedf705796685c18a7cc805136059b2",
            "metadata": {},
            "name": "ConvertPageToFolderDialogConvertPageToFolderMutation",
            "operationKind": "mutation",
            "text": "mutation ConvertPageToFolderDialogConvertPageToFolderMutation($id:ID!){convertToFolder(id:$id){content{id}}}"
        }
    };
}();
$c938044c857e7ec1$var$node.hash = "9e061c22a3f4cc67b35d81eed7b18a16";
var $c938044c857e7ec1$export$2e2bcd8739ae039 = $c938044c857e7ec1$var$node;
module.exports["default"] = $c938044c857e7ec1$export$2e2bcd8739ae039;

});

parcelRegister("gjbSq", function(module, exports) {

var $95rLf = parcelRequire("95rLf");


var $7Sm4c = parcelRequire("7Sm4c");


var $3jwuS = parcelRequire("3jwuS");


var $gEtAQ = parcelRequire("gEtAQ");


var $cEgMD = parcelRequire("cEgMD");


var $jr6cv = parcelRequire("jr6cv");


var $jMyy4 = parcelRequire("jMyy4");

const $8906a897a8abc933$export$cf0b322c7c05f5e9 = 'action-convert-page-to-folder';
const $8906a897a8abc933$export$9009d9583737dc08 = ({ contentId: contentId, spaceKey: spaceKey, skipQuery: skipQuery })=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $jr6cv.default), {
        skip: Boolean(skipQuery) || // Company Hub hides its space from the user, is rather presented to the user as "a new surface", not a page so converting it to a folder wouldn't make sense.
        // Additionally, if this query were to execute, it would break the Company Hub history/version preview, because it doesn't respect the versionOverride query parameter.
        (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey),
        variables: {
            contentId: contentId,
            spaceKey: spaceKey
        },
        __callerPackage__: "folder-conversion"
    });
    const isViewPageRoute = (0, $gEtAQ.isViewPage)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isPage = data?.singleContent?.type === 'page';
    const isFoldersEnabledForSpace = data?.space?.spaceTypeSettings?.enabledContentTypes?.isFoldersEnabled;
    const isPublished = data?.singleContent?.status === 'current';
    let canEdit = false;
    let canArchive = false; // need to check archive permission since page is archived as a part of conversion
    data?.singleContent?.operations?.forEach((operationCheckResult)=>{
        if (operationCheckResult?.targetType === 'page') {
            if (operationCheckResult?.operation === 'update') canEdit = true;
            else if (operationCheckResult?.operation === 'archive') canArchive = true;
        }
    });
    const canConvertPageToFolder = Boolean(isViewPageRoute && !isLivePage && isPage && isFoldersEnabledForSpace && isPublished && canEdit && canArchive);
    if ((0, $95rLf.isExpectedApolloError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    const contentTitle = data?.singleContent?.title;
    const hasLoaded = $8906a897a8abc933$export$d5c654a6fe10b3c1(Boolean(skipQuery), Boolean(data), Boolean(error), loading);
    return {
        canConvertPageToFolder: canConvertPageToFolder,
        contentTitle: contentTitle,
        loading: loading,
        error: error,
        hasLoaded: hasLoaded
    };
};
const $8906a897a8abc933$export$d5c654a6fe10b3c1 = (skip, hasData, hasError, loading)=>{
    return skip || (hasData || hasError) && !loading;
};
module.exports["CONVERT_PAGE_TO_FOLDER_WEBITEM_ID"] = $8906a897a8abc933$export$cf0b322c7c05f5e9;
module.exports["useCanConvertPageToFolder"] = $8906a897a8abc933$export$9009d9583737dc08;

});

parcelRegister("jr6cv", function(module, exports) {
/**
 * @generated SignedSource<<cff4ec53e648470d277e9ebff3ca6267>>
 * @relayHash 48a9429ef50ceb1df349c422f817239b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9d4b264a2064bf474a2da6e6304f03e630787bd8c8a1da86bbb0fe266d4ae062
const $98dc97ed41815985$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFoldersEnabled"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "kind": "ScalarField",
                    "name": "status"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ConvertPageToFolderQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ConvertPageToFolderQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "48a9429ef50ceb1df349c422f817239b",
            "id": "9d4b264a2064bf474a2da6e6304f03e630787bd8c8a1da86bbb0fe266d4ae062",
            "metadata": {},
            "name": "ConvertPageToFolderQuery",
            "operationKind": "query",
            "text": "query ConvertPageToFolderQuery($contentId:ID!,$spaceKey:String!){space(key:$spaceKey){id,spaceTypeSettings{enabledContentTypes{isFoldersEnabled}}},singleContent(id:$contentId){id,title,type,status,operations{operation,targetType}}}"
        }
    };
}();
$98dc97ed41815985$var$node.hash = "ed0995bcdb62a84d190715c954ff6018";
var $98dc97ed41815985$export$2e2bcd8739ae039 = $98dc97ed41815985$var$node;
module.exports["default"] = $98dc97ed41815985$export$2e2bcd8739ae039;

});

parcelRegister("3eMfQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $9wGTI = parcelRequire("9wGTI");


var $4LDXE = parcelRequire("4LDXE");



const $35cdf415560d18a2$export$ecf6343598832c90 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ldI6_",
    name: "LazyContentToolsItem",
    loader: async ()=>(0, $9wGTI.fg)('confluence_link_item_append_trace_context') ? (await (parcelRequire("4cPvJ"))).ContentToolsItemWithRoutesContext : (await (parcelRequire("J1GVU"))).ContentToolsItem
});


const $35cdf415560d18a2$export$3de34eae48b0740b = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "uFc6G",
    name: "LazyContentToolsItemWithPlaceholder",
    loader: async ()=>(0, $9wGTI.fg)('confluence_link_item_append_trace_context') ? (await (parcelRequire("4cPvJ"))).ContentToolsItemWithRoutesContext : (await (parcelRequire("J1GVU"))).ContentToolsItem,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4LDXE.ContentToolsItemPlaceholder), null)
});
module.exports["LazyContentToolsItem"] = $35cdf415560d18a2$export$ecf6343598832c90;
module.exports["LazyContentToolsItemWithPlaceholder"] = $35cdf415560d18a2$export$3de34eae48b0740b;

});

parcelRegister("4LDXE", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $e6ba7f6f1ee193d5$export$4a15f2daa593cc3 = ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                height: "40px",
                display: "flex",
                width: "100%",
                padding: "var(--ds-space-100, 8px) var(--ds-space-250, 20px)",
                alignItems: "center",
                boxSizing: "border-box"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                height: "17px",
                width: "100%",
                backgroundColor: "var(--ds-skeleton, #0515240F)",
                borderRadius: "10%"
            }
        }));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
module.exports["ContentToolsItemPlaceholder"] = $e6ba7f6f1ee193d5$export$4a15f2daa593cc3;

});

parcelRegister("4cPvJ", function(module, exports) {

let $31003d64a3cbc110$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $31003d64a3cbc110$var$load("bzc8Q"),
    $31003d64a3cbc110$var$load("4TY0p")
]).then(()=>parcelRequire('ebxOW'));

});

parcelRegister("J1GVU", function(module, exports) {

let $087583f96ab988ae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $087583f96ab988ae$var$load("bzc8Q").then(()=>parcelRequire('al4VD'));

});

parcelRegister("k9WFY", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $77aec7b4d93beceb$export$c4e96d849cdd6a3d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "g6cZS",
    name: "PublishPageAsBlogDialog",
    loader: async ()=>(await (parcelRequire("dipOO"))).PublishPageAsBlogDialog
});
module.exports["PublishPageAsBlogDialog"] = $77aec7b4d93beceb$export$c4e96d849cdd6a3d;

});

parcelRegister("dipOO", function(module, exports) {

let $9ae0fbdaa2681f70$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9ae0fbdaa2681f70$var$load("6HLQW"),
    $9ae0fbdaa2681f70$var$load("dtpmo"),
    $9ae0fbdaa2681f70$var$load("grUVf"),
    $9ae0fbdaa2681f70$var$load("gLFJS"),
    $9ae0fbdaa2681f70$var$load("4fYzp"),
    $9ae0fbdaa2681f70$var$load("fJjZJ")
]).then(()=>parcelRequire('8d4o6'));

});

parcelRegister("5M5fB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3jwuS = parcelRequire("3jwuS");

/**
 * To avoid multiple people saving the draft simultaneously, which causes a lock exception,
 * we only want the first active user to be in charge of saving.
 * See issue CFE-1369 for details.
 */ const $ecd355b99e8f624d$var$checkIsFirstParticipant = (participants, currentUserSessionId)=>{
    if (participants === null || participants.length === 0 || currentUserSessionId === null) return true;
    // Check if the first participant is the current user
    return participants[0].sessionId === currentUserSessionId;
};
/**
 * Verifies if the current user is the primary participant and has edit permissions.
 * @returns {boolean} True if the user is the first participant with edit permissions,
 *                    false if the user has view only or is not the first participant.
 */ const $ecd355b99e8f624d$var$isPrimaryParticipantWithPermissions = (participants, currentUserSessionId)=>{
    if (participants === null || participants.length === 0 || currentUserSessionId === null) return true;
    // Find the first participant in the sorted list with edit permissions
    const primaryParticipant = participants.find((activeUser)=>activeUser.permit?.isPermittedToEdit);
    return !!primaryParticipant && primaryParticipant.sessionId === currentUserSessionId;
};
const $ecd355b99e8f624d$var$updatePresence = (presenceData, currentParticipants)=>{
    const { joined: joined = [], left: left = [] } = presenceData;
    let updatedParticipants = [];
    if (currentParticipants === null) updatedParticipants = joined;
    else {
        // Add new participants to the list
        updatedParticipants = [
            ...currentParticipants,
            ...joined
        ];
        // Remove participants who have left
        updatedParticipants = updatedParticipants.filter((participant)=>!left.some((leftUser)=>leftUser.sessionId === participant.sessionId));
    }
    // Sort the session IDs to ensure the comparison for choosing the
    // draft sync leader is deterministic.
    updatedParticipants.sort((a, b)=>a.sessionId.localeCompare(b.sessionId));
    return updatedParticipants;
};
const $ecd355b99e8f624d$export$2a8c16d82a0a0e26 = (collabEditProvider)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const currentUserSessionId = (0, $cozmU.useRef)(null);
    const currentParticipants = (0, $cozmU.useRef)(null);
    const [isFirstParticipant, setIsFirstParticipant] = (0, $cozmU.useState)(true);
    const [isSingleUserSession, setIsSingleUserSession] = (0, $cozmU.useState)(true);
    // Listen to the connected event to grab the current user's sessionId
    (0, $cozmU.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleConnected = (event)=>{
            currentUserSessionId.current = event?.sid;
        };
        collabEditProvider.on('connected', handleConnected);
        return ()=>{
            collabEditProvider.off('connected', handleConnected);
        };
    }, [
        collabEditProvider
    ]);
    const handleUpdatePresence = (0, $cozmU.useCallback)((presenceData)=>{
        const updatedParticipants = $ecd355b99e8f624d$var$updatePresence(presenceData, currentParticipants.current);
        currentParticipants.current = updatedParticipants;
        const isFirst = isLivePage ? $ecd355b99e8f624d$var$isPrimaryParticipantWithPermissions(updatedParticipants, currentUserSessionId.current) : $ecd355b99e8f624d$var$checkIsFirstParticipant(updatedParticipants, currentUserSessionId.current);
        setIsFirstParticipant(isFirst);
        setIsSingleUserSession(currentParticipants.current.length <= 1);
    }, [
        isLivePage
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!collabEditProvider) return;
        collabEditProvider.on('presence', handleUpdatePresence);
        return ()=>{
            collabEditProvider.off('presence', handleUpdatePresence);
        };
    }, [
        collabEditProvider,
        handleUpdatePresence
    ]);
    return {
        isFirstParticipant: isFirstParticipant,
        isSingleUserSession: isSingleUserSession
    };
};
module.exports["usePresence"] = $ecd355b99e8f624d$export$2a8c16d82a0a0e26;

});

parcelRegister("5G6sa", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $f44739e864265bc9$var$ContentHistoryStore = (0, $8s9DV.createStore)({
    initialState: {
        wasTransitionedFromEditor: false
    },
    actions: {
        setWasTransitionedFromEditor: (wasTransitionedFromEditor)=>({ setState: setState })=>{
                setState({
                    wasTransitionedFromEditor: wasTransitionedFromEditor
                });
            }
    },
    name: 'newContentHistoryState'
});
const $f44739e864265bc9$export$90587b2a92cba8d5 = (0, $kBr4q.createStateHook)($f44739e864265bc9$var$ContentHistoryStore);
const $f44739e864265bc9$export$9b1a939bc5c5d3b = (0, $kBr4q.createActionsHook)($f44739e864265bc9$var$ContentHistoryStore);
module.exports["useNewContentHistoryState"] = $f44739e864265bc9$export$90587b2a92cba8d5;
module.exports["useNewContentHistoryActions"] = $f44739e864265bc9$export$9b1a939bc5c5d3b;

});

parcelRegister("lwNi3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bQm3c = parcelRequire("bQm3c");


var $04e9M = parcelRequire("04e9M");


var $jOtRZ = parcelRequire("jOtRZ");


var $lBR3p = parcelRequire("lBR3p");

const $5efec5cf952678ca$export$ddc368dc94a41e62 = (withChoreographer = true)=>{
    const { cloudId: cloudId, activationId: activationId, environment: environment } = (0, $bQm3c.useSessionData)();
    const workspaceId = (0, $04e9M.getWorkspaceId)(cloudId, activationId);
    const disableEngagementForTests = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    sessionStorage.getItem('confluence.disable-engagement-for-tests') === 'true';
    const envType = (0, $jOtRZ.useAnalyticsEnvironment)(environment);
    return (0, $cozmU.useMemo)(()=>(0, $lBR3p.getCoordinationClient)(disableEngagementForTests, cloudId, workspaceId, withChoreographer, envType), [
        disableEngagementForTests,
        cloudId,
        workspaceId,
        withChoreographer,
        envType
    ]);
};
module.exports["useCoordinationClient"] = $5efec5cf952678ca$export$ddc368dc94a41e62;

});

parcelRegister("lBR3p", function(module, exports) {

var $9qoNv = parcelRequire("9qoNv");


var $3cMXh = parcelRequire("3cMXh");

const $b379edbfb382bc54$var$noop = async ()=>false;
const $b379edbfb382bc54$export$a3f969ef7d35205d = (disableEngagementForTests, cloudId, workspaceId, enableChoreographer, environment)=>{
    if (disableEngagementForTests) return {
        start: $b379edbfb382bc54$var$noop,
        stop: $b379edbfb382bc54$var$noop
    };
    else {
        const coordinationOptions = {
            enableChoreographer: enableChoreographer,
            envType: environment,
            additionalData: {
                sourceProductId: (0, $3cMXh.ProductIds).CONFLUENCE
            }
        };
        return new (0, $9qoNv.default)({
            cloudId: cloudId,
            stargateUrl: '/gateway/api',
            isFedRAMPEnvironment: false,
            workspaceId: workspaceId,
            coordinationOptions: coordinationOptions
        });
    }
};
module.exports["getCoordinationClient"] = $b379edbfb382bc54$export$a3f969ef7d35205d;

});

parcelRegister("9qoNv", function(module, exports) {

var $j2j41 = parcelRequire("j2j41");


var $j6tu4 = parcelRequire("j6tu4");

class $ea69e7193c24a139$export$2e2bcd8739ae039 {
    async start(messageId, variationId) {
        if (!(0, $j6tu4.isMessagingEnabled)()) return false;
        return (0, $j2j41.startMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            variationId: variationId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    async stop(messageId) {
        if (!(0, $j6tu4.isMessagingEnabled)()) return false;
        return (0, $j2j41.stopMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    constructor(configOrCloudId, stargateUrl){
        this.cloudId = void 0;
        this.stargateUrl = void 0;
        this.orgId = void 0;
        this.workspaceId = void 0;
        this.coordinationOptions = void 0;
        let config;
        if (typeof configOrCloudId === 'string') config = {
            cloudId: configOrCloudId,
            stargateUrl: stargateUrl,
            isFedRAMPEnvironment: false
        };
        else config = configOrCloudId;
        if (!config.cloudId || !config.stargateUrl) throw new Error('Need a valid CloudId and Stargate url');
        this.cloudId = config.cloudId;
        this.stargateUrl = config.stargateUrl;
        this.orgId = config.orgId;
        this.workspaceId = config.workspaceId;
        this.coordinationOptions = config.coordinationOptions;
    }
}
module.exports["default"] = $ea69e7193c24a139$export$2e2bcd8739ae039;

});

parcelRegister("erZTy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::66d007939bf0d2ebb7eb357b9bdbfe0a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a853995c96993cd4$var$_react = $a853995c96993cd4$var$_interopRequireDefault((parcelRequire("cozmU")));

var $a853995c96993cd4$var$_baseNew = $a853995c96993cd4$var$_interopRequireDefault((parcelRequire("gElAV")));
function $a853995c96993cd4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DiagramArchitectureMap".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for architecture map diagram type in Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a853995c96993cd4$var$DiagramArchitectureMapIcon = (props)=>/*#__PURE__*/ $a853995c96993cd4$var$_react.default.createElement($a853995c96993cd4$var$_baseNew.default, Object.assign({
        name: "DiagramArchitectureMapIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10 14.5h4.5v-3H10zm6 .13c0 .76-.62 1.38-1.37 1.38H9.88c-.76 0-1.37-.62-1.37-1.37v-3.25c0-.76.62-1.37 1.38-1.37h4.75c.76 0 1.38.62 1.38 1.38zM1 13v-2h1.5v2a.5.5 0 0 0 .5.5h4V15H3a2 2 0 0 1-2-2m12.5-8a.5.5 0 0 0-.5-.5h-3V3h3a2 2 0 0 1 2 2v3.5h-1.5zM7 6.78c-.74.32-1.72.5-2.75.5s-2-.18-2.75-.5v.43c0 .22.14.53.65.81.5.28 1.24.48 2.1.48s1.61-.19 2.1-.48c.5-.29.65-.59.65-.81zm0-2.72c-.74.32-1.72.5-2.75.5s-2-.18-2.75-.5v.93a.3.3 0 0 0 .06.08c.09.09.25.21.51.32.52.23 1.29.39 2.17.39s1.66-.16 2.17-.38c.26-.11.42-.23.51-.32A.3.3 0 0 0 7 4.99zM4.25 1.5c-.89 0-1.66.16-2.17.39a1.6 1.6 0 0 0-.51.32.4.4 0 0 0-.06.07c.01.02.03.04.06.07.09.09.25.21.51.32.52.23 1.29.39 2.17.39s1.66-.16 2.17-.38c.26-.11.42-.23.51-.32a.4.4 0 0 0 .06-.07.4.4 0 0 0-.06-.07 1.6 1.6 0 0 0-.51-.32c-.51-.24-1.28-.4-2.17-.4M8.5 7.21c0 .97-.64 1.68-1.4 2.12-.77.44-1.78.67-2.85.67s-2.08-.23-2.85-.67C.64 8.89 0 8.18 0 7.21V2.28c0-.46.22-.84.49-1.12s.62-.49.99-.65C2.22.18 3.21 0 4.25 0s2.03.18 2.78.51c.37.16.72.38.99.65.27.28.49.66.49 1.12z"/>`
    }, props));
$a853995c96993cd4$var$DiagramArchitectureMapIcon.displayName = 'DiagramArchitectureMapIcon';
var $a853995c96993cd4$var$_default = module.exports.default = $a853995c96993cd4$var$DiagramArchitectureMapIcon;

});

parcelRegister("04429", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gZFfs = parcelRequire("gZFfs");


var $4wRov = parcelRequire("4wRov");

const $fa153b064c6ef7da$export$9a1b2bd9844b88ce = (id, component)=>{
    const ref = (0, $cozmU.useRef)(new (0, $4wRov.StreamingUFOExperience)(id, {
        type: (0, $gZFfs.ExperienceTypes).Experience,
        performanceType: (0, $gZFfs.ExperiencePerformanceTypes).InlineResult,
        platform: {
            component: component
        }
    }));
    const start = ()=>{
        ref.current.start();
    };
    const success = (config)=>{
        ref.current.success(config);
    };
    const failure = (config)=>{
        ref.current.failure(config);
    };
    const abort = (config)=>{
        ref.current.abort(config);
    };
    const startConnectionAttempt = ()=>{
        ref.current.startConnectionAttempt();
    };
    const successConnectionEstablished = ()=>{
        ref.current.connectionEstablished();
    };
    const reportTTFB = ()=>{
        ref.current.reportTTFB();
    };
    const reportRTT = (chunkIndex)=>{
        ref.current.reportRTT(chunkIndex);
    };
    return {
        startConnectionAttempt: startConnectionAttempt,
        successConnectionEstablished: successConnectionEstablished,
        reportTTFB: reportTTFB,
        reportRTT: reportRTT,
        start: start,
        success: success,
        failure: failure,
        abort: abort
    };
};
module.exports["useUFOStreamingExperience"] = $fa153b064c6ef7da$export$9a1b2bd9844b88ce;

});

parcelRegister("4wRov", function(module, exports) {

var $eA5SK = parcelRequire("eA5SK");


var $34VCg = parcelRequire("34VCg");

class $c4f34d8a127b003d$export$dcd1eb6913d822b extends (0, $34VCg.UFOExperience) {
    startConnectionAttempt() {
        this.webSocketConnectionTiming = {
            key: 'ws_connection',
            startTime: (0, $eA5SK.perfNowOrTimestamp)(),
            duration: 0
        };
    }
    success(config) {
        this.addAverageChunkDuration();
        return super.success(config);
    }
    failure(config) {
        this.addAverageChunkDuration();
        return super.failure(config);
    }
    abort(config) {
        this.addAverageChunkDuration();
        return super.abort(config);
    }
    connectionEstablished() {
        if (this.webSocketConnectionTiming) {
            this.webSocketConnectionTiming.duration = (0, $eA5SK.perfNowOrTimestamp)() - this.webSocketConnectionTiming.startTime;
            this.addMetadata({
                ws_connection: {
                    ...this.webSocketConnectionTiming
                }
            });
        }
        this.ttfbTiming = {
            startTime: (0, $eA5SK.perfNowOrTimestamp)(),
            duration: 0
        };
    }
    reportTTFB() {
        if (this.ttfbTiming) {
            this.ttfbTiming.duration = (0, $eA5SK.perfNowOrTimestamp)() - this.ttfbTiming.startTime;
            this.addMetadata({
                ttfb: {
                    ...this.ttfbTiming
                }
            });
            this.updateChunkTiming(this.ttfbTiming, 1);
        }
    }
    addExperienceTotalDuration() {
        this.addMetadata({
            total_duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
        });
    }
    addAverageChunkDuration() {
        const durations = Array.from(this.chunksResponseTime.values()).map((chunk)=>chunk.duration).filter((duration)=>duration > 0);
        const averageDurationInMilliseconds = durations.reduce((sum, milliseconds)=>sum + milliseconds, 0) / durations.length;
        if (this.metrics.startTime) this.markInlineResponse(this.metrics.startTime + averageDurationInMilliseconds);
    }
    updateChunkTiming(currentChunkTiming, createdItemChunkIndex) {
        this.chunksResponseTime.set(createdItemChunkIndex, {
            duration: (0, $eA5SK.perfNowOrTimestamp)() - currentChunkTiming.startTime,
            startTime: currentChunkTiming.startTime
        });
        this.chunksResponseTime.set(createdItemChunkIndex + 1, {
            duration: 0,
            startTime: (0, $eA5SK.perfNowOrTimestamp)()
        });
    }
    reportRTT(createdItemChunkIndex) {
        const currentChunkTiming = this.chunksResponseTime.get(createdItemChunkIndex);
        if (currentChunkTiming) {
            this.updateChunkTiming(currentChunkTiming, createdItemChunkIndex);
            this.addMetadata({
                chunks_rtt: Object.fromEntries(Array.from(this.chunksResponseTime.entries()).filter(([_, value])=>value.duration > 0).map(([key, value])=>[
                        `chunk_rtt_${key}`,
                        value.duration
                    ]))
            });
        }
    }
    constructor(id, config, instanceId = null){
        super(id, config, instanceId);
        this.chunksResponseTime = new Map();
        this.webSocketConnectionTiming = null;
        this.ttfbTiming = null;
    }
}
module.exports["StreamingUFOExperience"] = $c4f34d8a127b003d$export$dcd1eb6913d822b;

});

parcelRegister("bLDEV", function(module, exports) {
function $24891651e73b8e2e$export$1ae670edab4485a3(customWebsocketUrl) {
    let WEBSOCKET_URI;
    if (customWebsocketUrl) return customWebsocketUrl;
    WEBSOCKET_URI = `wss://${window.location.host}`;
    return WEBSOCKET_URI;
}
module.exports["getWebsocketURI"] = $24891651e73b8e2e$export$1ae670edab4485a3;

});

parcelRegister("78ai4", function(module, exports) {

var $l5PlL = parcelRequire("l5PlL");


var $5vvb4 = parcelRequire("5vvb4");


var $4Mdv6 = parcelRequire("4Mdv6");


var $1l84p = parcelRequire("1l84p");


var $fL3jc = parcelRequire("fL3jc");


var $UEncY = parcelRequire("UEncY");


var $hrBcg = parcelRequire("hrBcg");

const $0d005d8264857cf8$export$e8bef16f28ed7bfe = async (audioChunks, lastProcessedPosition, sampleRate, audioGain = {
    enableGain: false,
    gainFactor: 3.0,
    autoNormalize: false,
    targetRMS: 0.2,
    preventClipping: true
})=>{
    const completeAudio = new Blob(audioChunks);
    const { audioBuffer: audioBuffer, newAudioEndPosition: newAudioEndPosition } = await (0, $hrBcg.getLastRecorderAudioChunk)(completeAudio, lastProcessedPosition, sampleRate);
    if (!audioBuffer) return {
        audioString: null,
        newAudioEndPosition: newAudioEndPosition
    };
    // Apply audio gain if enabled
    let processedAudioBuffer = audioBuffer;
    if (audioGain.enableGain) {
        const { gainFactor: gainFactor = 1.0, autoNormalize: autoNormalize = false, targetRMS: targetRMS = 0.2, preventClipping: preventClipping = true } = audioGain;
        const finalGainFactor = autoNormalize ? (0, $4Mdv6.calculateNormalizationGain)(audioBuffer, targetRMS) : gainFactor;
        processedAudioBuffer = (0, $4Mdv6.applyAudioGain)(audioBuffer, finalGainFactor, preventClipping);
    }
    const wavBuffer = (0, $UEncY.createWAVFromAudioBuffer)(processedAudioBuffer);
    const wavBlob = new Blob([
        wavBuffer
    ], {
        type: 'audio/wav'
    });
    const audioString = await (0, $5vvb4.createBase64FromBlob)(wavBlob);
    const transcription = await (0, $l5PlL.getTranscriptions)({
        audioString: audioString
    });
    return {
        transcription: transcription[0],
        newAudioEndPosition: newAudioEndPosition
    };
};
const $0d005d8264857cf8$export$456b9750d8dac572 = async (audioChunks, lastProcessedPosition, sampleRate, soundDetection = {
    enableSoundDetection: false,
    useComprehensiveDetection: false,
    soundThreshold: 0.005
}, audioGain = {
    enableGain: false,
    gainFactor: 3.0,
    autoNormalize: false,
    targetRMS: 0.2,
    preventClipping: true
})=>{
    const { enableSoundDetection: enableSoundDetection, useComprehensiveDetection: useComprehensiveDetection, soundThreshold: soundThreshold } = soundDetection;
    const completeAudio = new Blob(audioChunks);
    const { audioBuffer: audioBuffer, newAudioEndPosition: newAudioEndPosition } = await (0, $hrBcg.getLastRecorderAudioChunk)(completeAudio, lastProcessedPosition, sampleRate);
    if (!audioBuffer) return {
        audioString: null,
        newAudioEndPosition: newAudioEndPosition
    };
    if (enableSoundDetection) {
        const hasSound = useComprehensiveDetection ? (0, $1l84p.hasAudioContentComprehensive)(audioBuffer, {
            rmsThreshold: soundThreshold
        }) : (0, $1l84p.hasAudioContent)(audioBuffer, soundThreshold);
        if (!hasSound) return {
            audioString: null,
            newAudioEndPosition: newAudioEndPosition
        };
    }
    let processedAudioBuffer = audioBuffer;
    if (audioGain.enableGain) {
        const { gainFactor: gainFactor = 1.0, autoNormalize: autoNormalize = false, targetRMS: targetRMS = 0.2, preventClipping: preventClipping = true } = audioGain;
        const finalGainFactor = autoNormalize ? (0, $4Mdv6.calculateNormalizationGain)(audioBuffer, targetRMS) : gainFactor;
        processedAudioBuffer = (0, $4Mdv6.applyAudioGain)(audioBuffer, finalGainFactor, preventClipping);
    }
    const pcm16Buffer = (0, $fL3jc.createPCM16FromAudioBuffer)(processedAudioBuffer);
    const pcm16Blob = new Blob([
        pcm16Buffer
    ], {
        type: 'audio/pcm'
    });
    const audioString = await (0, $5vvb4.createBase64FromBlob)(pcm16Blob);
    return {
        audioString: audioString,
        newAudioEndPosition: newAudioEndPosition
    };
};
module.exports["processAudioToTextWithPCM16"] = $0d005d8264857cf8$export$456b9750d8dac572;

});

parcelRegister("l5PlL", function(module, exports) {
const $f16d8ea81c6897ef$export$e70ce39e35650c8d = async ({ audioString: audioString })=>{
    const response = await fetch('/gateway/api/v1/audio/transcriptions', {
        method: 'POST',
        body: JSON.stringify({
            data: [
                {
                    audio: audioString
                }
            ],
            model: 'whisper-1',
            audio_format: 'wav'
        }),
        headers: {
            'Content-Type': 'application/json',
            'Request-ID': crypto.randomUUID()
        }
    });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    if (!response.body) throw new Error('Response body is null');
    return response.json();
};
module.exports["getTranscriptions"] = $f16d8ea81c6897ef$export$e70ce39e35650c8d;

});

parcelRegister("4Mdv6", function(module, exports) {
/**
 * Applies audio gain (amplification) to an AudioBuffer
 *
 * This function multiplies all audio samples by a gain factor to increase or decrease
 * the audio volume. The gain is applied uniformly across all channels.
 *
 * @param audioBuffer - The AudioBuffer to apply gain to
 * @param gainFactor - The gain multiplier (1.0 = no change, 2.0 = double volume, 0.5 = half volume)
 *                     Values > 1.0 amplify the audio, values < 1.0 attenuate it
 * @param preventClipping - Whether to prevent clipping by normalizing if gain would cause overflow
 *
 * @returns A new AudioBuffer with gain applied
 *
 * @example
 * ```typescript
 * // Double the audio volume
 * const amplifiedBuffer = applyAudioGain(originalBuffer, 2.0);
 *
 * // Reduce volume by half
 * const quieterBuffer = applyAudioGain(originalBuffer, 0.5);
 *
 * // Amplify with clipping prevention
 * const safeBuffer = applyAudioGain(originalBuffer, 3.0, true);
 * ```
 */ const $b7d04e75c88881fd$export$fdc1ec94e71033b9 = (audioBuffer, gainFactor, preventClipping = true)=>{
    // Create a new AudioBuffer with the same properties
    const audioContext = new (window.AudioContext || window.webkitAudioContext)();
    const newBuffer = audioContext.createBuffer(audioBuffer.numberOfChannels, audioBuffer.length, audioBuffer.sampleRate);
    // Apply gain to each channel
    for(let channel = 0; channel < audioBuffer.numberOfChannels; channel++){
        const originalData = audioBuffer.getChannelData(channel);
        const newData = newBuffer.getChannelData(channel);
        // First pass: apply gain and find peak if clipping prevention is enabled
        let peak = 0;
        for(let i = 0; i < originalData.length; i++){
            const amplifiedSample = originalData[i] * gainFactor;
            newData[i] = amplifiedSample;
            if (preventClipping) peak = Math.max(peak, Math.abs(amplifiedSample));
        }
        // Second pass: normalize if clipping would occur
        if (preventClipping && peak > 1.0) {
            const normalizationFactor = 1.0 / peak;
            for(let i = 0; i < newData.length; i++)newData[i] *= normalizationFactor;
        } else if (!preventClipping) // Clamp values to prevent distortion if clipping prevention is disabled
        for(let i = 0; i < newData.length; i++)newData[i] = Math.max(-1, Math.min(1.0, newData[i]));
    }
    return newBuffer;
};
const $b7d04e75c88881fd$export$dae3aad198bcc4dd = (audioBuffer)=>{
    let sumSquares = 0;
    let sampleCount = 0;
    for(let channel = 0; channel < audioBuffer.numberOfChannels; channel++){
        const channelData = audioBuffer.getChannelData(channel);
        for(let i = 0; i < channelData.length; i++){
            sumSquares += channelData[i] * channelData[i];
            sampleCount++;
        }
    }
    return Math.sqrt(sumSquares / sampleCount);
};
const $b7d04e75c88881fd$export$a4f04dc9b8c85a93 = (audioBuffer, targetRMS = 0.2, maxGain = 10.0)=>{
    const currentRMS = $b7d04e75c88881fd$export$dae3aad198bcc4dd(audioBuffer);
    if (currentRMS === 0) return 1.0; // Avoid division by zero for silent audio
    const calculatedGain = targetRMS / currentRMS;
    return Math.min(calculatedGain, maxGain);
};
module.exports["applyAudioGain"] = $b7d04e75c88881fd$export$fdc1ec94e71033b9;
module.exports["calculateNormalizationGain"] = $b7d04e75c88881fd$export$a4f04dc9b8c85a93;

});

parcelRegister("1l84p", function(module, exports) {
/**
 * Audio analysis utilities for detecting sound content and audio quality
 */ /**
 * Detects if audio buffer contains sound above a threshold using RMS analysis
 * @param audioBuffer - The AudioBuffer to analyze
 * @param threshold - RMS threshold for sound detection (default: 0.01)
 * @returns true if audio contains sound, false if silent
 */ const $5f8a51910f8217eb$export$fb7d0dbec0b9c428 = (audioBuffer, threshold = 0.01)=>{
    const numChannels = audioBuffer.numberOfChannels;
    const length = audioBuffer.length;
    // Calculate RMS (Root Mean Square) for each channel
    for(let channel = 0; channel < numChannels; channel++){
        const channelData = audioBuffer.getChannelData(channel);
        let sumSquares = 0;
        // Calculate sum of squares for RMS
        for(let sample = 0; sample < length; sample++)sumSquares += channelData[sample] * channelData[sample];
        // Calculate RMS for this channel
        const rms = Math.sqrt(sumSquares / length);
        // If any channel has audio above threshold, return true
        if (rms > threshold) return true;
    }
    return false;
};
const $5f8a51910f8217eb$export$41efb760936b1083 = (audioBuffer, threshold = 0.005)=>{
    const numChannels = audioBuffer.numberOfChannels;
    const length = audioBuffer.length;
    // Check peak amplitude for each channel
    for(let channel = 0; channel < numChannels; channel++){
        const channelData = audioBuffer.getChannelData(channel);
        for(let sample = 0; sample < length; sample++){
            const amplitude = Math.abs(channelData[sample]);
            if (amplitude > threshold) return true;
        }
    }
    return false;
};
const $5f8a51910f8217eb$export$ac8474076d842596 = (audioBuffer, threshold = 0.1)=>{
    const numChannels = audioBuffer.numberOfChannels;
    const length = audioBuffer.length;
    for(let channel = 0; channel < numChannels; channel++){
        const channelData = audioBuffer.getChannelData(channel);
        let zeroCrossings = 0;
        // Count zero crossings
        for(let sample = 1; sample < length; sample++)if (channelData[sample] >= 0 && channelData[sample - 1] < 0 || channelData[sample] < 0 && channelData[sample - 1] >= 0) zeroCrossings++;
        // Calculate zero-crossing rate
        const zeroCrossingRate = zeroCrossings / length;
        if (zeroCrossingRate > threshold) return true;
    }
    return false;
};
const $5f8a51910f8217eb$export$7c7be76b9ed1e76f = (audioBuffer, options = {})=>{
    const { rmsThreshold: rmsThreshold = 0.01, peakThreshold: peakThreshold = 0.005, zeroCrossingThreshold: zeroCrossingThreshold = 0.1, requireAll: requireAll = false } = options;
    const rmsResult = $5f8a51910f8217eb$export$fb7d0dbec0b9c428(audioBuffer, rmsThreshold);
    const peakResult = $5f8a51910f8217eb$export$41efb760936b1083(audioBuffer, peakThreshold);
    const zeroCrossingResult = $5f8a51910f8217eb$export$ac8474076d842596(audioBuffer, zeroCrossingThreshold);
    if (requireAll) return rmsResult && peakResult && zeroCrossingResult;
    // Return true if any method detects sound (more sensitive)
    return rmsResult || peakResult || zeroCrossingResult;
};
module.exports["hasAudioContent"] = $5f8a51910f8217eb$export$fb7d0dbec0b9c428;
module.exports["hasAudioContentComprehensive"] = $5f8a51910f8217eb$export$7c7be76b9ed1e76f;

});

parcelRegister("fL3jc", function(module, exports) {
/**
 * Creates PCM16 data from an AudioBuffer
 *
 * This function converts Web Audio API AudioBuffer data into raw PCM16 format
 * (16-bit signed integer samples) without any file headers. This is more efficient
 * than WAV format for audio processing since it eliminates header overhead.
 *
 * @param audioBuffer - The AudioBuffer to convert to PCM16 format. This should contain
 *                      audio data from the Web Audio API (e.g., from MediaRecorder, AudioContext, etc.)
 *
 * @returns An ArrayBuffer containing the raw PCM16 audio data.
 *          The audio is encoded as 16-bit signed integers at the original sample rate and channel count.
 *
 * @example
 * ```typescript
 * // Convert an AudioBuffer to PCM16 format
 * const audioBuffer = audioContext.createBuffer(2, 44100, 44100); // 2 channels, 44.1kHz, 1 second
 * const pcm16Buffer = createPCM16FromAudioBuffer(audioBuffer);
 *
 * // Create a Blob for file download or processing
 * const blob = new Blob([pcm16Buffer], { type: 'audio/pcm' });
 *
 * // Or use directly with other APIs
 * const audioData = new Int16Array(pcm16Buffer);
 * ```
 *
 * @remarks
 * - The function generates raw PCM16 data without any file headers
 * - Supports any number of channels (mono, stereo, surround, etc.)
 * - Preserves the original sample rate from the AudioBuffer
 * - Output is little-endian 16-bit signed integers
 * - No header overhead, making it more efficient for processing
 * - Each sample is 2 bytes (16-bit)
 */ const $7d6358e0e47abf42$export$1c5b7794d3e4d402 = (audioBuffer)=>{
    // Extract audio properties from the buffer
    const numChannels = audioBuffer.numberOfChannels;
    const length = audioBuffer.length; // Total number of samples
    // Validate that we're working with mono audio as expected
    // Note: This function is designed to work with mono audio (1 channel) as configured in getUserMedia
    // Calculate buffer size: audio data only (no headers)
    // Each sample is 16-bit (2 bytes), multiplied by number of channels
    const buffer = new ArrayBuffer(length * numChannels * 2);
    const view = new DataView(buffer);
    // Write audio data starting at byte 0
    let offset = 0;
    // Convert each channel's float32 data to int16
    for(let channel = 0; channel < numChannels; channel++){
        const channelData = audioBuffer.getChannelData(channel);
        for(let sample = 0; sample < length; sample++){
            // Convert float32 (-1.0 to 1.0) to int16 (-32768 to 32767)
            // Clamp to prevent overflow
            const floatSample = Math.max(-1, Math.min(1.0, channelData[sample]));
            const int16Sample = Math.round(floatSample * 32767);
            // Write as little-endian 16-bit signed integer
            view.setInt16(offset, int16Sample, true); // true = little-endian
            offset += 2;
        }
    }
    return buffer;
};
module.exports["createPCM16FromAudioBuffer"] = $7d6358e0e47abf42$export$1c5b7794d3e4d402;

});

parcelRegister("UEncY", function(module, exports) {
/**
 * Creates a WAV file from an AudioBuffer
 *
 * This function converts Web Audio API AudioBuffer data into a standard WAV format
 * that can be saved as a file or transmitted over the network. The function generates
 * a complete WAV file with proper headers including RIFF chunk, format chunk, and data chunk.
 *
 * @param audioBuffer - The AudioBuffer to convert to WAV format. This should contain
 *                      audio data from the Web Audio API (e.g., from MediaRecorder, AudioContext, etc.)
 *
 * @returns An ArrayBuffer containing the complete WAV file data with headers and audio samples.
 *          The audio is encoded as 16-bit PCM at the original sample rate and channel count.
 *
 * @example
 * ```typescript
 * // Convert an AudioBuffer to WAV format
 * const audioBuffer = audioContext.createBuffer(2, 44100, 44100); // 2 channels, 44.1kHz, 1 second
 * const wavBuffer = createWAVFromAudioBuffer(audioBuffer);
 *
 * // Create a Blob for file download
 * const blob = new Blob([wavBuffer], { type: 'audio/wav' });
 * const url = URL.createObjectURL(blob);
 *
 * // Or use directly with other APIs
 * const audioData = new Uint8Array(wavBuffer);
 * ```
 *
 * @remarks
 * - The function generates standard WAV format with 16-bit PCM encoding
 * - Supports any number of channels (mono, stereo, surround, etc.)
 * - Preserves the original sample rate from the AudioBuffer
 * - Output is little-endian as per WAV specification
 * - Header size is always 44 bytes + audio data
 *
 * @see {@link https://en.wikipedia.org/wiki/WAV|WAV file format specification}
 */ const $e068c38c3c48ddc3$export$279cd95a97baa2e3 = (audioBuffer)=>{
    // Extract audio properties from the buffer
    const numChannels = audioBuffer.numberOfChannels; // Mono = 1, Stereo = 2, etc.
    const sampleRate = audioBuffer.sampleRate; // Samples per second (e.g., 44100 Hz)
    const length = audioBuffer.length; // Total number of samples
    // Calculate buffer size: 44 bytes for WAV header + audio data
    // Each sample is 16-bit (2 bytes), multiplied by number of channels
    const buffer = new ArrayBuffer(44 + length * numChannels * 2);
    const view = new DataView(buffer);
    /**
	 * Helper function to write ASCII strings to the buffer
	 * WAV files use ASCII strings for chunk identifiers
	 */ const writeString = (offset, string)=>{
        for(let i = 0; i < string.length; i++)view.setUint8(offset + i, string.charCodeAt(i));
    };
    // Write WAV file header (44 bytes total)
    // RIFF chunk identifier - indicates this is a RIFF-formatted file
    writeString(0, 'RIFF');
    // File size minus 8 bytes (RIFF identifier + size field)
    // 36 bytes for remaining header + audio data size
    view.setUint32(4, 36 + length * numChannels * 2, true); // true = little-endian
    // WAVE format identifier
    writeString(8, 'WAVE');
    // Format chunk identifier
    writeString(12, 'fmt ');
    // Format chunk size (16 bytes for PCM format)
    view.setUint32(16, 16, true);
    // Audio format (1 = PCM/uncompressed)
    view.setUint16(20, 1, true);
    // Number of channels (1 = mono, 2 = stereo, etc.)
    view.setUint16(22, numChannels, true);
    // Sample rate in Hz (e.g., 44100, 48000)
    view.setUint32(24, sampleRate, true);
    // Byte rate: sample rate * number of channels * bytes per sample
    view.setUint32(28, sampleRate * numChannels * 2, true);
    // Block align: number of channels * bytes per sample
    view.setUint16(32, numChannels * 2, true);
    // Bits per sample (16-bit audio)
    view.setUint16(34, 16, true);
    // Data chunk identifier
    writeString(36, 'data');
    // Data chunk size: total audio data size in bytes
    view.setUint32(40, length * numChannels * 2, true);
    // Write audio data starting at byte 44 (after header)
    let offset = 44;
    // Iterate through each sample in the audio buffer
    for(let i = 0; i < length; i++)// For each sample, write data from all channels
    for(let channel = 0; channel < numChannels; channel++){
        // Get the sample value for this channel and sample index
        // Clamp the value between -1 and 1 (Web Audio API range)
        const sample = Math.max(-1, Math.min(1, audioBuffer.getChannelData(channel)[i]));
        // Convert float sample (-1 to 1) to 16-bit integer
        // For negative values: multiply by 0x8000 (32768)
        // For positive values: multiply by 0x7fff (32767)
        // This ensures proper 16-bit signed integer representation
        view.setInt16(offset, sample < 0 ? sample * 0x8000 : sample * 0x7fff, true);
        // Move to next sample position (2 bytes per sample)
        offset += 2;
    }
    return buffer;
};
module.exports["createWAVFromAudioBuffer"] = $e068c38c3c48ddc3$export$279cd95a97baa2e3;

});

parcelRegister("hrBcg", function(module, exports) {
const $b3caeb384498e9a2$export$947890ff7373a8ab = async (audioBlob, lastProcessedPosition, sampleRate = 24000)=>{
    const arrayBuffer = await audioBlob.arrayBuffer();
    const audioContext = new AudioContext({
        sampleRate: sampleRate
    });
    try {
        const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
        const totalSamples = audioBuffer.length;
        const newSamples = totalSamples - lastProcessedPosition;
        if (newSamples <= 0) {
            await audioContext.close();
            return {
                audioBuffer: null,
                newAudioEndPosition: 0
            };
        }
        const newAudioStart = lastProcessedPosition;
        const newAudioEndPosition = totalSamples;
        const newAudioLength = newAudioEndPosition - newAudioStart;
        const newAudioBuffer = audioContext.createBuffer(audioBuffer.numberOfChannels, newAudioLength, audioBuffer.sampleRate);
        // Copy audio data from the specified range for each channel
        for(let channel = 0; channel < audioBuffer.numberOfChannels; channel++){
            const channelData = audioBuffer.getChannelData(channel);
            const newChannelData = newAudioBuffer.getChannelData(channel);
            newChannelData.set(channelData.slice(newAudioStart, newAudioEndPosition));
        }
        await audioContext.close();
        return {
            audioBuffer: newAudioBuffer,
            newAudioEndPosition: newAudioEndPosition
        };
    } catch (error) {
        await audioContext.close();
        throw error;
    }
};
module.exports["getLastRecorderAudioChunk"] = $b3caeb384498e9a2$export$947890ff7373a8ab;

});

parcelRegister("1pL0T", function(module, exports) {

var $fy3cw = parcelRequire("fy3cw");

const $9d6ec9065b88f71c$export$986a2ab002dbd574 = ()=>({
        name: 'forgeExtension',
        pmPlugins () {
            return [
                {
                    name: 'forgeExtensionUniqueId',
                    plugin: ()=>(0, $fy3cw.createUniqueLocalIdPlugin)()
                }
            ];
        }
    });
module.exports["forgeEditorPlugin"] = $9d6ec9065b88f71c$export$986a2ab002dbd574;

});

parcelRegister("fy3cw", function(module, exports) {

var $2nOF5 = parcelRequire("2nOF5");


var $kpCD8 = parcelRequire("kpCD8");


var $fud2r = parcelRequire("fud2r");


var $kCECX = parcelRequire("kCECX");


var $iNIw3 = parcelRequire("iNIw3");

function $4066462459f8ce19$var$getForgeLocalIdFromNode(node) {
    return node.attrs.extensionType === (0, $iNIw3.EXTENSION_NAMESPACE) ? node.attrs.parameters?.localId : undefined;
}
// When Forge extensions are copied, the attrs.localId should be the same as the attrs.parameters.localId.
// Otherwise, it won't be able to use the parameters.localId to locate the node (which is checked against by attrs.localId in editor-plugin-extension/src/pm-plugins/extension-api.ts).
function $4066462459f8ce19$var$handleForgeExtensionLocalId({ slice: slice, filterForgeExtensionNode: filterForgeExtensionNode }) {
    return (0, $fud2r.mapSlice)(slice, (node)=>{
        if (filterForgeExtensionNode(node) && $4066462459f8ce19$var$getForgeLocalIdFromNode(node) !== node.attrs.localId) {
            const attrs = {
                ...node.attrs,
                localId: $4066462459f8ce19$var$getForgeLocalIdFromNode(node)
            };
            return node.type.create(attrs, node.content, node.marks);
        }
        return node;
    });
}
const $4066462459f8ce19$export$cb7a3598b76b7e74 = ()=>new (0, $kpCD8.SafePlugin)({
        key: new (0, $kCECX.PluginKey)('forgeExtensionUniqueLocalIdPlugin'),
        props: {
            transformPasted: (slice, view)=>{
                const state = view.state;
                const { extension: extension, bodiedExtension: bodiedExtension, inlineExtension: inlineExtension, multiBodiedExtension: multiBodiedExtension } = state.schema.nodes;
                const extensionTypes = new Set([
                    extension,
                    bodiedExtension,
                    inlineExtension,
                    multiBodiedExtension
                ]);
                const forgeIdsObserved = new Set();
                const iterateExtensions = (fragment, handler)=>{
                    fragment.descendants((node, pos)=>{
                        if (!!node.type && extensionTypes.has(node.type)) {
                            handler(node, pos);
                            /**
             * If it's a multiBodiedExtension or bodiedExtension, we'll need to keep digging;
             * since we can have more extension nodes within the contents of that
             */ return [
                                multiBodiedExtension,
                                bodiedExtension
                            ].includes(node.type);
                        }
                        /**
           * Otherwise continue traversing, we can encounter extensions nested in
           * expands/bodiedExtensions
           */ return true;
                    });
                };
                // Loop through document to see what IDs are already in use
                iterateExtensions(state.doc, (node)=>{
                    const forgeLocalId = $4066462459f8ce19$var$getForgeLocalIdFromNode(node);
                    if (forgeLocalId) forgeIdsObserved.add(forgeLocalId);
                });
                // Now, loop through the pasted content and generate new IDs for any that are already in use
                iterateExtensions(slice.content, (node)=>{
                    const forgeLocalId = $4066462459f8ce19$var$getForgeLocalIdFromNode(node);
                    if (!forgeLocalId) return;
                    if (!forgeIdsObserved.has(forgeLocalId)) forgeIdsObserved.add(forgeLocalId);
                    else // attrs.localId will be updated in handleLocalId
                    node.attrs.parameters.localId = (0, $2nOF5.uuid).generate();
                });
                function filterForgeExtensionNode(node) {
                    return !!node.type && extensionTypes.has(node.type) && !!$4066462459f8ce19$var$getForgeLocalIdFromNode(node);
                }
                slice = $4066462459f8ce19$var$handleForgeExtensionLocalId({
                    slice: slice,
                    filterForgeExtensionNode: filterForgeExtensionNode
                });
                return slice;
            }
        }
    });
module.exports["createUniqueLocalIdPlugin"] = $4066462459f8ce19$export$cb7a3598b76b7e74;

});

parcelRegister("iHrpD", function(module, exports) {

var $kCECX = parcelRequire("kCECX");


var $fud2r = parcelRequire("fud2r");


var $kpCD8 = parcelRequire("kpCD8");


var $4EksL = parcelRequire("4EksL");


var $c2E4R = parcelRequire("c2E4R");

var $jzePg = parcelRequire("jzePg");

var $eaLat = parcelRequire("eaLat");


var $kMORl = parcelRequire("kMORl");

const $e91b9f4cdd3698fb$var$pluginName = 'legacyContentMacroPlugin';
const $e91b9f4cdd3698fb$var$pluginKey = new (0, $kCECX.PluginKey)($e91b9f4cdd3698fb$var$pluginName);
const $e91b9f4cdd3698fb$var$LEGACY_CONTENT_MACRO_EXTENSION_TYPE = 'com.atlassian.confluence.migration';
const $e91b9f4cdd3698fb$var$LEGACY_CONTENT_MACRO_EXTENSION_KEY = 'legacy-content';
const $e91b9f4cdd3698fb$var$isLegacyContentMacroExtension = (extensionNode)=>extensionNode.type.name === 'extension' && extensionNode.attrs?.extensionType === $e91b9f4cdd3698fb$var$LEGACY_CONTENT_MACRO_EXTENSION_TYPE && extensionNode.attrs?.extensionKey === $e91b9f4cdd3698fb$var$LEGACY_CONTENT_MACRO_EXTENSION_KEY;
const $e91b9f4cdd3698fb$export$a0ccdff7cb069dd7 = ({ config: config })=>{
    const isInnerEditor = !!config?.nodeId;
    return {
        name: $e91b9f4cdd3698fb$var$pluginName,
        pmPlugins () {
            return [
                {
                    name: $e91b9f4cdd3698fb$var$pluginName,
                    plugin: ()=>{
                        return new (0, $kpCD8.SafePlugin)({
                            key: $e91b9f4cdd3698fb$var$pluginKey,
                            state: {
                                init () {
                                    return {
                                        nodeId: null,
                                        side: null,
                                        arrowKeyPressed: null,
                                        isSelectionAtEdge: null
                                    };
                                },
                                apply: (tr, currentPluginState)=>{
                                    const meta = tr.getMeta($e91b9f4cdd3698fb$var$pluginKey);
                                    if (meta) return {
                                        ...currentPluginState,
                                        ...meta
                                    };
                                    return currentPluginState;
                                }
                            },
                            props: {
                                handleDOMEvents: {
                                    keydown (view, event) {
                                        // If the user selects an LCM node and clicks an arrow, update the state with
                                        // the arrow they clicked and the selected node to use for keyboard navigation
                                        // logic in the extension-handler
                                        // We need to track two events to derive the user intention:
                                        //   1. Arrow key press event when selecting the node, to know whether the user
                                        //      is coming from the left or right gap cursor
                                        //   2. Arrow key press event when the node is selected, to know where to enter
                                        //      the legacy content macro
                                        // All of these keyboard events are only activated in the outer editor because
                                        // you can't have selections on the LCM node in the inner editor
                                        if (event instanceof KeyboardEvent && [
                                            'ArrowUp',
                                            'ArrowDown',
                                            'ArrowLeft',
                                            'ArrowRight'
                                        ].includes(event.key) && !isInnerEditor) {
                                            const { state: state, dispatch: dispatch } = view;
                                            const pluginState = $e91b9f4cdd3698fb$var$pluginKey.getState(state);
                                            // When hitting the gap cursor before or after an LCM
                                            if (state.selection instanceof (0, $4EksL.GapCursorSelection) && (state.selection.side === (0, $eaLat.Side).RIGHT && state.selection.$from.nodeBefore !== null && $e91b9f4cdd3698fb$var$isLegacyContentMacroExtension(state.selection.$from.nodeBefore) || state.selection.side === (0, $eaLat.Side).LEFT && state.selection.$from.nodeAfter !== null && $e91b9f4cdd3698fb$var$isLegacyContentMacroExtension(state.selection.$from.nodeAfter))) dispatch(state.tr.setMeta($e91b9f4cdd3698fb$var$pluginKey, {
                                                side: state.selection.side
                                            }));
                                            else if (state.selection instanceof (0, $kCECX.NodeSelection) && $e91b9f4cdd3698fb$var$isLegacyContentMacroExtension(state.selection.node) && // Moving from the left into the LCM
                                            (event.key === 'ArrowRight' && pluginState?.side === (0, $eaLat.Side).LEFT || // Moving from the right into the LCM
                                            event.key === 'ArrowLeft' && pluginState?.side === (0, $eaLat.Side).RIGHT)) {
                                                dispatch(state.tr.setMeta($e91b9f4cdd3698fb$var$pluginKey, {
                                                    nodeId: state.selection.node.attrs.localId,
                                                    arrowKeyPressed: event.key
                                                }));
                                                event.preventDefault();
                                            // When hitting the LCM from below or above
                                            } else if (state.selection instanceof (0, $kCECX.NodeSelection) && $e91b9f4cdd3698fb$var$isLegacyContentMacroExtension(state.selection.node) && [
                                                'ArrowUp',
                                                'ArrowDown'
                                            ].includes(event.key)) {
                                                dispatch(state.tr.setMeta($e91b9f4cdd3698fb$var$pluginKey, {
                                                    nodeId: state.selection.node.attrs.localId,
                                                    // When using the up and down arrow keys intent isn't obvious, so we assume the user wants to enter from the end when coming up and enter from the left when coming down
                                                    side: event.key === 'ArrowUp' ? (0, $eaLat.Side).RIGHT : (0, $eaLat.Side).LEFT,
                                                    arrowKeyPressed: event.key
                                                }));
                                                event.preventDefault();
                                            }
                                        }
                                        // In the inner editor detect when we try exiting the LCM node and trigger
                                        // selecting the LCM node
                                        if (event instanceof KeyboardEvent && [
                                            'ArrowUp',
                                            'ArrowDown',
                                            'ArrowLeft',
                                            'ArrowRight'
                                        ].includes(event.key) && isInnerEditor) {
                                            const { state: state, dispatch: dispatch } = view;
                                            if (state.selection instanceof (0, $4EksL.GapCursorSelection) && // Arrow moving up or left at the initial position of the encapsulating LCM
                                            ((event.key === 'ArrowUp' || event.key === 'ArrowLeft') && (0, $c2E4R.atTheBeginningOfDoc)(state) || // Arrow moving down or right at the end position of the encapsulating LCM
                                            (event.key === 'ArrowDown' || event.key === 'ArrowRight') && (0, $jzePg.atTheEndOfDoc)(state))) dispatch(state.tr.setMeta($e91b9f4cdd3698fb$var$pluginKey, {
                                                nodeId: config.nodeId,
                                                isSelectionAtEdge: true
                                            }));
                                            else {
                                                const pluginState = $e91b9f4cdd3698fb$var$pluginKey.getState(state);
                                                if (pluginState?.isSelectionAtEdge) dispatch(state.tr.setMeta($e91b9f4cdd3698fb$var$pluginKey, {
                                                    isSelectionAtEdge: false
                                                }));
                                            }
                                        }
                                        return false;
                                    },
                                    blur (view) {
                                        // When entering the LCM editor from the outer editor, reset the state
                                        // to avoid unexpected selection issues
                                        if (!isInnerEditor) {
                                            const pluginState = $e91b9f4cdd3698fb$var$pluginKey.getState(view.state);
                                            if (pluginState?.arrowKeyPressed) {
                                                const { tr: tr } = view.state;
                                                tr.setMeta($e91b9f4cdd3698fb$var$pluginKey, {
                                                    nodeId: null,
                                                    side: null,
                                                    arrowKeyPressed: null
                                                });
                                                view.dispatch(tr);
                                            }
                                        }
                                    }
                                },
                                handleDrop (_view, _event, slice) {
                                    // Disable drag-and-drop for selections with a legacy content macro extensions
                                    const sliceHasLegacyContentMacro = (0, $fud2r.hasNode)((node)=>$e91b9f4cdd3698fb$var$isLegacyContentMacroExtension(node))(slice);
                                    return sliceHasLegacyContentMacro;
                                }
                            }
                        });
                    }
                }
            ];
        },
        actions: {
            setSelection: $kMORl.setSelection
        },
        getSharedState (state) {
            if (!state) return undefined;
            const { nodeId: nodeId, side: side, arrowKeyPressed: arrowKeyPressed, isSelectionAtEdge: isSelectionAtEdge } = $e91b9f4cdd3698fb$var$pluginKey.getState(state) ?? {};
            return {
                nodeId: nodeId,
                side: side,
                arrowKeyPressed: arrowKeyPressed,
                isSelectionAtEdge: isSelectionAtEdge
            };
        }
    };
};
module.exports["legacyContentMacroPlugin"] = $e91b9f4cdd3698fb$export$a0ccdff7cb069dd7;

});

parcelRegister("kMORl", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $3ff08e22c2836b71$export$f6e36f80a8190133 = (selection)=>(state, dispatch)=>{
        if (!dispatch) return false;
        const emptySelection = (0, $kCECX.TextSelection).create(state.doc, 0);
        const tr = state.tr.setSelection(selection ?? emptySelection);
        dispatch(tr);
        return true;
    };
module.exports["setSelection"] = $3ff08e22c2836b71$export$f6e36f80a8190133;

});

parcelRegister("9dHNS", function(module, exports) {
const $6b674e69a79b1327$var$instanceOfAny = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $6b674e69a79b1327$var$idbProxyableTypes;
let $6b674e69a79b1327$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $6b674e69a79b1327$var$getIdbProxyableTypes() {
    return $6b674e69a79b1327$var$idbProxyableTypes || ($6b674e69a79b1327$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $6b674e69a79b1327$var$getCursorAdvanceMethods() {
    return $6b674e69a79b1327$var$cursorAdvanceMethods || ($6b674e69a79b1327$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $6b674e69a79b1327$var$transactionDoneMap = new WeakMap();
const $6b674e69a79b1327$var$transformCache = new WeakMap();
const $6b674e69a79b1327$var$reverseTransformCache = new WeakMap();
function $6b674e69a79b1327$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($6b674e69a79b1327$export$4997ffc0176396a6(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    // This mapping exists in reverseTransformCache but doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $6b674e69a79b1327$var$reverseTransformCache.set(promise, request);
    return promise;
}
function $6b674e69a79b1327$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($6b674e69a79b1327$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $6b674e69a79b1327$var$transactionDoneMap.set(tx, done);
}
let $6b674e69a79b1327$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $6b674e69a79b1327$var$transactionDoneMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $6b674e69a79b1327$export$4997ffc0176396a6(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $6b674e69a79b1327$var$replaceTraps(callback) {
    $6b674e69a79b1327$var$idbProxyTraps = callback($6b674e69a79b1327$var$idbProxyTraps);
}
function $6b674e69a79b1327$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($6b674e69a79b1327$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($6b674e69a79b1327$export$debb760848ca95a(this), args);
        return $6b674e69a79b1327$export$4997ffc0176396a6(this.request);
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $6b674e69a79b1327$export$4997ffc0176396a6(func.apply($6b674e69a79b1327$export$debb760848ca95a(this), args));
    };
}
function $6b674e69a79b1327$var$transformCachableValue(value) {
    if (typeof value === 'function') return $6b674e69a79b1327$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $6b674e69a79b1327$var$cacheDonePromiseForTransaction(value);
    if ($6b674e69a79b1327$var$instanceOfAny(value, $6b674e69a79b1327$var$getIdbProxyableTypes())) return new Proxy(value, $6b674e69a79b1327$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $6b674e69a79b1327$export$4997ffc0176396a6(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $6b674e69a79b1327$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($6b674e69a79b1327$var$transformCache.has(value)) return $6b674e69a79b1327$var$transformCache.get(value);
    const newValue = $6b674e69a79b1327$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $6b674e69a79b1327$var$transformCache.set(value, newValue);
        $6b674e69a79b1327$var$reverseTransformCache.set(newValue, value);
    }
    return newValue;
}
const $6b674e69a79b1327$export$debb760848ca95a = (value)=>$6b674e69a79b1327$var$reverseTransformCache.get(value);
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $6b674e69a79b1327$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = $6b674e69a79b1327$export$4997ffc0176396a6(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade($6b674e69a79b1327$export$4997ffc0176396a6(request.result), event.oldVersion, event.newVersion, $6b674e69a79b1327$export$4997ffc0176396a6(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $6b674e69a79b1327$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return $6b674e69a79b1327$export$4997ffc0176396a6(request).then(()=>undefined);
}
const $6b674e69a79b1327$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $6b674e69a79b1327$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $6b674e69a79b1327$var$cachedMethods = new Map();
function $6b674e69a79b1327$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($6b674e69a79b1327$var$cachedMethods.get(prop)) return $6b674e69a79b1327$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $6b674e69a79b1327$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $6b674e69a79b1327$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $6b674e69a79b1327$var$cachedMethods.set(prop, method);
    return method;
}
$6b674e69a79b1327$var$replaceTraps((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$6b674e69a79b1327$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$6b674e69a79b1327$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));
const $6b674e69a79b1327$var$advanceMethodProps = [
    'continue',
    'continuePrimaryKey',
    'advance'
];
const $6b674e69a79b1327$var$methodMap = {};
const $6b674e69a79b1327$var$advanceResults = new WeakMap();
const $6b674e69a79b1327$var$ittrProxiedCursorToOriginalProxy = new WeakMap();
const $6b674e69a79b1327$var$cursorIteratorTraps = {
    get (target, prop) {
        if (!$6b674e69a79b1327$var$advanceMethodProps.includes(prop)) return target[prop];
        let cachedFunc = $6b674e69a79b1327$var$methodMap[prop];
        if (!cachedFunc) cachedFunc = $6b674e69a79b1327$var$methodMap[prop] = function(...args) {
            $6b674e69a79b1327$var$advanceResults.set(this, $6b674e69a79b1327$var$ittrProxiedCursorToOriginalProxy.get(this)[prop](...args));
        };
        return cachedFunc;
    }
};
async function* $6b674e69a79b1327$var$iterate(...args) {
    // tslint:disable-next-line:no-this-assignment
    let cursor = this;
    if (!(cursor instanceof IDBCursor)) cursor = await cursor.openCursor(...args);
    if (!cursor) return;
    cursor;
    const proxiedCursor = new Proxy(cursor, $6b674e69a79b1327$var$cursorIteratorTraps);
    $6b674e69a79b1327$var$ittrProxiedCursorToOriginalProxy.set(proxiedCursor, cursor);
    // Map this double-proxy back to the original, so other cursor methods work.
    $6b674e69a79b1327$var$reverseTransformCache.set(proxiedCursor, $6b674e69a79b1327$export$debb760848ca95a(cursor));
    while(cursor){
        yield proxiedCursor;
        // If one of the advancing methods was not called, call continue().
        cursor = await ($6b674e69a79b1327$var$advanceResults.get(proxiedCursor) || cursor.continue());
        $6b674e69a79b1327$var$advanceResults.delete(proxiedCursor);
    }
}
function $6b674e69a79b1327$var$isIteratorProp(target, prop) {
    return prop === Symbol.asyncIterator && $6b674e69a79b1327$var$instanceOfAny(target, [
        IDBIndex,
        IDBObjectStore,
        IDBCursor
    ]) || prop === 'iterate' && $6b674e69a79b1327$var$instanceOfAny(target, [
        IDBIndex,
        IDBObjectStore
    ]);
}
$6b674e69a79b1327$var$replaceTraps((oldTraps)=>({
        ...oldTraps,
        get (target, prop, receiver) {
            if ($6b674e69a79b1327$var$isIteratorProp(target, prop)) return $6b674e69a79b1327$var$iterate;
            return oldTraps.get(target, prop, receiver);
        },
        has (target, prop) {
            return $6b674e69a79b1327$var$isIteratorProp(target, prop) || oldTraps.has(target, prop);
        }
    }));
module.exports["unwrap"] = $6b674e69a79b1327$export$debb760848ca95a;
module.exports["openDB"] = $6b674e69a79b1327$export$ca0ed41b1a2af7e;

});

parcelRegister("awSMG", function(module, exports) {
const $4ce470d2dd3584e9$export$6ff460ddb5710005 = 'editor:offline-steps-';
const $4ce470d2dd3584e9$export$7023de141f2ab721 = 'meta';
const $4ce470d2dd3584e9$export$3f9a6f7086c5c8f7 = 'steps';
const $4ce470d2dd3584e9$export$9fd1ded1027f9ea2 = 2;
module.exports["OFFLINE_STEPS_DATABASE_NAME_PREFIX"] = $4ce470d2dd3584e9$export$6ff460ddb5710005;
module.exports["OFFLINE_META_STORE_NAME"] = $4ce470d2dd3584e9$export$7023de141f2ab721;
module.exports["OFFLINE_STEPS_STORE_NAME"] = $4ce470d2dd3584e9$export$3f9a6f7086c5c8f7;
module.exports["OFFLINE_STEPS_DATABASE_VERSION"] = $4ce470d2dd3584e9$export$9fd1ded1027f9ea2;

});

parcelRegister("9oJIg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gswTK = parcelRequire("gswTK");


var $MyxIQ = parcelRequire("MyxIQ");

const $5176b2e7fefe99e5$export$9be10e5cc29463c9 = ({ children: children })=>{
    const fetch = (0, $MyxIQ.usePlacementSSRFetch)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gswTK.PlacementFetchingProvider), {
        fetch: fetch
    }, children);
};
module.exports["PlacementFetchProvider"] = $5176b2e7fefe99e5$export$9be10e5cc29463c9;

});

parcelRegister("jPcvk", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $7e7400ce50234362$export$a8e3305d336ef5aa = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "K14-x",
    name: "EditorContentModeButton",
    loader: async ()=>{
        const { EditorContentModeButton: EditorContentModeButton } = await (parcelRequire("kHxMe"));
        return EditorContentModeButton;
    }
});
module.exports["EditorContentModeButton"] = $7e7400ce50234362$export$a8e3305d336ef5aa;

});

parcelRegister("kHxMe", function(module, exports) {

let $f122062b8fd24914$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f122062b8fd24914$var$load("cC68k").then(()=>parcelRequire('iI06X'));

});

parcelRegister("jPACe", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4ff4f509ac781670$export$e8a47c72fec9e984 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "SUzCl",
    name: "EditorPageCoverPictureEntry",
    loader: async ()=>{
        const { EditorPageCoverPictureEntry: EditorPageCoverPictureEntry } = await (parcelRequire("bCFzw"));
        return EditorPageCoverPictureEntry;
    }
});
module.exports["EditorPageCoverPictureEntry"] = $4ff4f509ac781670$export$e8a47c72fec9e984;

});

parcelRegister("bCFzw", function(module, exports) {

let $87637da7a981254b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $87637da7a981254b$var$load("bYzij"),
    $87637da7a981254b$var$load("dVM1q")
]).then(()=>parcelRequire('5tKh7'));

});

parcelRegister("5e34M", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0c67d43e155b2cd3$export$8ce5c583c1fa5a96 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rGXr0",
    name: "EmojiTitleButtonLoader",
    loader: async ()=>(await (parcelRequire("buJuy"))).EmojiTitleButton
});
module.exports["EmojiTitleButtonLoader"] = $0c67d43e155b2cd3$export$8ce5c583c1fa5a96;

});

parcelRegister("buJuy", function(module, exports) {

let $85e5c8c2a1e98e48$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $85e5c8c2a1e98e48$var$load("6wr18"),
    $85e5c8c2a1e98e48$var$load("dlm6q"),
    $85e5c8c2a1e98e48$var$load("ffEVr"),
    $85e5c8c2a1e98e48$var$load("el56J"),
    $85e5c8c2a1e98e48$var$load("kFiBp"),
    $85e5c8c2a1e98e48$var$load("daX4F"),
    $85e5c8c2a1e98e48$var$load("9Zd2C")
]).then(()=>parcelRequire('2FMo5'));

});

parcelRegister("eP7b6", function(module, exports) {
/**
 * @generated SignedSource<<293007c6777799aa33e10204d25d472b>>
 * @relayHash 002ee32db0695a9b63af69a407a07639
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d8fe2acb674a13f635de2de38cd556b5d67fea5e30e200be8bdac0269751a54
const $0ba271c76ca4c8d2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "key"
    }, v3 = {
        "kind": "ScalarField",
        "name": "value"
    }, v4 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v5 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "alias": "appearancePublished",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "content-appearance-published"
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": v4 /*: any*/ ,
                    "storageKey": "properties(key:\"content-appearance-published\")"
                },
                {
                    "alias": "emojiTitlePublished",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "emoji-title-published"
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": v4 /*: any*/ ,
                    "storageKey": "properties(key:\"emoji-title-published\")"
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "editor"
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JsonContentProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ],
                    "storageKey": "properties(key:\"editor\")"
                },
                {
                    "concreteType": "ContentMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                            "kind": "LinkedField",
                            "name": "frontend",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "fabricEditorSupported"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentTitleExternalQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentTitleExternalQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "002ee32db0695a9b63af69a407a07639",
            "id": "5d8fe2acb674a13f635de2de38cd556b5d67fea5e30e200be8bdac0269751a54",
            "metadata": {},
            "name": "ContentTitleExternalQuery",
            "operationKind": "query",
            "text": "query ContentTitleExternalQuery($contentId:ID!){singleContent(id:$contentId){id,title,appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{fabricEditorSupported}}}}"
        }
    };
}();
$0ba271c76ca4c8d2$var$node.hash = "99403818c8d620c95107a7fed0ae3cd7";
var $0ba271c76ca4c8d2$export$2e2bcd8739ae039 = $0ba271c76ca4c8d2$var$node;
module.exports["default"] = $0ba271c76ca4c8d2$export$2e2bcd8739ae039;

});

parcelRegister("9HhEw", function(module, exports) {
/**
 * @generated SignedSource<<79c229d4f4ae3adcbe0b4f7f72920a16>>
 * @relayHash 80f146a83f48be7b9331f291c6222df0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 441a5a61fe71025e06bc5da2cffef931ef0f47310237ad63b8470d65a380d962
const $cb80c8184222fcac$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v7 = [
        v3 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v9 = {
        "kind": "ScalarField",
        "name": "number"
    }, v10 = {
        "kind": "ScalarField",
        "name": "confRev"
    }, v11 = {
        "kind": "ScalarField",
        "name": "syncRev"
    }, v12 = {
        "kind": "ScalarField",
        "name": "contentTypeModified"
    }, v13 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v3 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ExternalByLineQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "lastOwnedBy",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                },
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ExternalByLineQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "lastOwnedBy",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                },
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "80f146a83f48be7b9331f291c6222df0",
            "id": "441a5a61fe71025e06bc5da2cffef931ef0f47310237ad63b8470d65a380d962",
            "metadata": {},
            "name": "ExternalByLineQuery",
            "operationKind": "query",
            "text": "query ExternalByLineQuery($contentId:ID!){singleContent(id:$contentId){id,type,history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId}},ownedBy{__typename,type,displayName,...on KnownUser{accountId}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId}}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,confRev,syncRev,contentTypeModified}}}"
        }
    };
}();
$cb80c8184222fcac$var$node.hash = "012bf9a7497572d73e22134c755e8758";
var $cb80c8184222fcac$export$2e2bcd8739ae039 = $cb80c8184222fcac$var$node;
module.exports["default"] = $cb80c8184222fcac$export$2e2bcd8739ae039;

});

parcelRegister("dJ5r4", function(module, exports) {
$parcel$export(module.exports, "ViewCommentShortcutListener", () => (parcelRequire("fPcdI")).ViewCommentShortcutListener);

var $fPcdI = parcelRequire("fPcdI");


});

parcelRegister("fPcdI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $fJCU9 = parcelRequire("fJCU9");


var $9DHhW = parcelRequire("9DHhW");


var $9FoVw = parcelRequire("9FoVw");


var $aHcFH = parcelRequire("aHcFH");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $liGyh = parcelRequire("liGyh");


var $dANtQ = parcelRequire("dANtQ");


var $9QIM2 = parcelRequire("9QIM2");


var $fNzRA = parcelRequire("fNzRA");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $cMvMc = parcelRequire("cMvMc");


var $8aF6s = parcelRequire("8aF6s");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $gtj7V = parcelRequire("gtj7V");


var $aJPUt = parcelRequire("aJPUt");


var $inDu6 = parcelRequire("inDu6");


var $6GD8y = parcelRequire("6GD8y");


var $gnkil = parcelRequire("gnkil");


var $gczDe = parcelRequire("gczDe");


var $3mVfX = parcelRequire("3mVfX");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $9wGTI = parcelRequire("9wGTI");


var $cgy29 = parcelRequire("cgy29");


var $dkkKv = parcelRequire("dkkKv");


var $8i27m = parcelRequire("8i27m");


var $fHAwL = parcelRequire("fHAwL");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $izhdc = parcelRequire("izhdc");


var $gSkOQ = parcelRequire("gSkOQ");

const $c392465906bed01c$var$ViewCommentShortcutListenerComponent = ({ isFabricPage: isFabricPage, contentId: contentId, dialogs: dialogs })=>{
    const { navigateToInlineComment: navigateToInlineComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const { activeHighlight: activeHighlight } = (0, $9jl6v.useInlineCommentsContext)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { removeCommentQueryParams: removeCommentQueryParams } = (0, $liGyh.useInlineCommentQueryParams)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, commentsDataMap: legacyCommentsDataMap } = (0, $8i27m.useCommentsDataState)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    const commentsDataMap = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? processedCommentsData.commentsDataMap : legacyCommentsDataMap;
    const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
    const pageClass = (0, $9QIM2.usePageClass)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isNextCommentLoading, setIsNextCommentLoading] = (0, $cozmU.useState)(false);
    const [alreadyFetchedInitialData, setAlreadyFetchedInitialData] = (0, $cozmU.useState)(false);
    const [triggeredByUnreadKeyboardShortcut, setTriggeredByUnreadKeyboardShortcut] = (0, $cozmU.useState)(false);
    const [{ currentlyRenderedThreads: currentlyRenderedThreads, currentlySelectedThreadKey: currentlySelectedThreadKey }, { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey }] = (0, $3mVfX.useCommentsPanel)();
    // Track previous annotation for difference-based scrolling
    const previousAnnotationRef = (0, $cozmU.useRef)(undefined);
    // Update ref whenever activeHighlight changes
    (0, $cozmU.useEffect)(()=>{
        // Only update if there's a valid value (not empty string or null)
        if (activeHighlight) previousAnnotationRef.current = activeHighlight;
    }, [
        activeHighlight
    ]);
    const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = (0, $aWwYt.useObjectSidebarState)();
    const { expandCommentContainer: expandCommentContainer, setFooterEditorEntry: setFooterEditorEntry } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { expanded: expanded, isObjectCommentWrapperVisible: isObjectCommentWrapperVisible, footerEditorEntry: footerEditorEntry } = (0, $fNzRA.useObjectCommentContext)();
    const { addFooterCommentAdf: addFooterCommentAdf } = (0, $3mVfX.useCommentsPanelState)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId ?? '');
    const orderedActiveAnnotations = (0, $cozmU.useMemo)(()=>{
        return orderedActiveAnnotationIdList.map((a)=>a.threadKey);
    }, [
        orderedActiveAnnotationIdList
    ]);
    (0, $cozmU.useEffect)(()=>{
        setIsNextCommentLoading(false);
    }, [
        activeHighlight,
        currentlySelectedThreadKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            setCurrentlySelectedThreadKey('');
        };
    }, [
        setCurrentlySelectedThreadKey
    ]);
    const { footerCommentThreads: footerCommentThreads, footerCommentIds: footerCommentIds } = (0, $gSkOQ.useFooterComments)();
    const { unreadInlineComments: unreadInlineComments, unreadGeneralComments: unreadGeneralComments } = (0, $cozmU.useMemo)(()=>{
        const unreadInlineComments = [];
        const unreadGeneralComments = [];
        orderedActiveAnnotations.forEach((threadKey)=>{
            const commentData = commentsDataMap.inline[threadKey];
            if (commentData) {
                let isCommentUnread = false;
                let hasUnreadReplies = false;
                // Use unreadCommentIDSet when feature flag is enabled
                // in SSR, unreadCommentIDSet is undefined
                isCommentUnread = unreadCommentIDSet?.has(commentData.id);
                hasUnreadReplies = commentData.replies?.some((reply)=>reply && unreadCommentIDSet?.has(reply.id)) || false;
                if (isCommentUnread || hasUnreadReplies) unreadInlineComments.push(threadKey);
            }
        });
        Object.keys(commentsDataMap.general).forEach((threadKey)=>{
            const commentData = commentsDataMap.general[threadKey];
            if (commentData) {
                let isCommentUnread = false;
                let hasUnreadReplies = false;
                // Use unreadCommentIDSet when feature flag is enabled
                isCommentUnread = unreadCommentIDSet?.has(commentData.id);
                hasUnreadReplies = commentData.replies?.some((reply)=>reply && unreadCommentIDSet?.has(reply.id)) || false;
                if (isCommentUnread || hasUnreadReplies) unreadGeneralComments.push(threadKey);
            }
        });
        return {
            unreadInlineComments: unreadInlineComments,
            unreadGeneralComments: unreadGeneralComments
        };
    }, [
        commentsDataMap,
        orderedActiveAnnotations,
        unreadCommentIDSet
    ]);
    const sendKeyboardShortcutAnalytics = (shortcut)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'viewPage',
                action: 'pressed',
                actionSubject: 'keyboardShortcut',
                actionSubjectId: 'createComment',
                attributes: {
                    key: shortcut
                }
            }
        }).fire();
    };
    const { handleCommentButtonClick: handleCommentButtonClick } = (0, $cgy29.useCreateCommentAction)({
        contentId: contentId || '',
        isFabric: isFabricPage,
        sendKeyboardShortcutAnalytics: sendKeyboardShortcutAnalytics
    });
    const getCommentIndex = (0, $cozmU.useCallback)((currentThreadKey)=>{
        return [
            ...orderedActiveAnnotations,
            ...footerCommentIds
        ]?.findIndex((threadKey)=>threadKey === currentThreadKey);
    }, [
        orderedActiveAnnotations,
        footerCommentIds
    ]);
    const openInlineComment = (0, $cozmU.useCallback)((markerRef)=>{
        if (pageClass === 'renderer' || pageClass === 'editor') experienceTracker.start({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
            attributes: {
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                annotationId: markerRef,
                entryPoint: 'comments-shortcuts/ViewCommentShortcutListener',
                pageClass: 'renderer'
            }
        });
        const previousAnnotationId = previousAnnotationRef.current;
        setCurrentlySelectedThreadKey('');
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const commentElement = document.getElementById(markerRef);
        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
            annotationId: markerRef
        });
        (0, $4EKKB.selectInlineComment).debug(`Keyboard selection now triggering annotation selection for annotation ${markerRef}`);
        emitter.emit((0, $fJCU9.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: [
                markerRef
            ],
            eventTarget: commentElement
        });
        (0, $9FoVw.handleKeyboardShortcutNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            annotationId: markerRef,
            previousAnnotationId: previousAnnotationId,
            commentType: 'INLINE',
            isCommentsPanelOpen: isObjectSidebarShown,
            hasKeyPressed: true,
            context: (0, $9FoVw.NavigationContext).RENDERER
        });
    }, [
        emitter,
        setCurrentlySelectedThreadKey,
        experienceTracker,
        pageClass,
        isObjectSidebarShown
    ]);
    const scrollToFooterComment = (0, $cozmU.useCallback)((threadKey)=>{
        // Reset previous annotation ref when navigating to footer comment
        previousAnnotationRef.current = undefined;
        setCurrentlySelectedThreadKey(threadKey);
        emitter.emit((0, $fJCU9.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: [],
            eventTarget: null
        });
        (0, $9FoVw.handleKeyboardShortcutNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            annotationId: threadKey,
            commentType: 'FOOTER',
            isCommentsPanelOpen: isObjectSidebarShown,
            hasKeyPressed: true
        });
    }, [
        emitter,
        setCurrentlySelectedThreadKey,
        isObjectSidebarShown
    ]);
    const onNavigationClick = (0, $cozmU.useCallback)((nextMarkerRef)=>{
        if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                openInlineComment(nextMarkerRef);
            }
        });
        else openInlineComment(nextMarkerRef);
    }, [
        hasContentChanged,
        resetContentChanged,
        showModal,
        openInlineComment
    ]);
    const handlePanelCommentNavigation = (0, $cozmU.useCallback)((action)=>{
        // If nothing is on the panel, there's nothing to navigate to
        if (currentlyRenderedThreads.length === 0) return;
        const { panelCommentRefs: panelCommentRefs, navigableInlineCommentRefs: navigableInlineCommentRefs } = (0, $izhdc.parsePanelAndInlineRefs)(currentlyRenderedThreads, orderedActiveAnnotations);
        const nextRef = (0, $izhdc.getNextRef)(action, panelCommentRefs, currentlySelectedThreadKey);
        // Handle panel selection state management in the listener
        setCurrentlySelectedThreadKey(nextRef.ref);
        (0, $9FoVw.handleKeyboardShortcutNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            annotationId: nextRef.ref,
            commentType: nextRef.type === (0, $8i27m.CommentType).GENERAL ? 'FOOTER' : 'INLINE',
            isCommentsPanelOpen: isObjectSidebarShown,
            hasKeyPressed: true,
            context: (0, $9FoVw.NavigationContext).RENDERER,
            isResolved: !navigableInlineCommentRefs.has(nextRef.ref)
        });
    }, [
        currentlyRenderedThreads,
        orderedActiveAnnotations,
        currentlySelectedThreadKey,
        setCurrentlySelectedThreadKey,
        isObjectSidebarShown
    ]);
    const handleNextCommentNavigation = (0, $cozmU.useCallback)(({ action: action, isNavigateToNextUnread: isNavigateToNextUnread })=>{
        //Check if the next inline comment is still in process of being rendered. Otherwise, quickly pressing keys will force comment to open and close instead of navigating
        if (isNextCommentLoading) return;
        setIsNextCommentLoading(true);
        navigateToInlineComment({
            action: action,
            triggeredByKeyboardShortcut: true,
            currentCommentIndex: getCommentIndex(activeHighlight || currentlySelectedThreadKey || ''),
            getCommentIndex: getCommentIndex,
            onNavigationClick: onNavigationClick,
            isEditor: false,
            removeCommentQueryParams: removeCommentQueryParams,
            unresolvedInlineComments: orderedActiveAnnotations,
            createAnalyticsEvent: createAnalyticsEvent,
            contentId: contentId,
            isNavigateToNextUnread: isNavigateToNextUnread,
            unreadInlineComments: unreadInlineComments,
            unreadGeneralComments: unreadGeneralComments,
            footerComments: footerCommentIds,
            scrollToFooterComment: scrollToFooterComment,
            commentsDataMap: commentsDataMap
        });
    }, [
        isNextCommentLoading,
        navigateToInlineComment,
        getCommentIndex,
        activeHighlight,
        currentlySelectedThreadKey,
        onNavigationClick,
        removeCommentQueryParams,
        orderedActiveAnnotations,
        createAnalyticsEvent,
        contentId,
        unreadInlineComments,
        unreadGeneralComments,
        footerCommentIds,
        scrollToFooterComment,
        commentsDataMap
    ]);
    const handleStandaloneCommentNavigation = (0, $cozmU.useCallback)((action)=>{
        if (activeHighlight || currentlySelectedThreadKey) handleNextCommentNavigation({
            isNavigateToNextUnread: false,
            action: action
        });
        else {
            // No highlight selected, so we navigate to the first inline comment
            const firstInlineCommentMarkerRef = orderedActiveAnnotations[0];
            if (!firstInlineCommentMarkerRef && footerCommentThreads.length === 0) return;
            if (firstInlineCommentMarkerRef) openInlineComment(firstInlineCommentMarkerRef);
            else scrollToFooterComment(footerCommentThreads[0]?.id);
        }
    }, [
        activeHighlight,
        currentlySelectedThreadKey,
        orderedActiveAnnotations,
        handleNextCommentNavigation,
        footerCommentThreads,
        openInlineComment,
        scrollToFooterComment
    ]);
    const handleCommentNavigation = (0, $cozmU.useCallback)((action)=>{
        // Define behavior when the comments panel is shown - panel FG is a prereq for nav, so has to be checked first
        if (isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel) handlePanelCommentNavigation(action);
        else // Comments panel not shown
        handleStandaloneCommentNavigation(action);
    }, [
        isObjectSidebarShown,
        panel?.id,
        handlePanelCommentNavigation,
        handleStandaloneCommentNavigation
    ]);
    (0, $dkkKv.useActiveCommentsQuery)({
        pageId: contentId || '',
        skip: !triggeredByUnreadKeyboardShortcut || alreadyFetchedInitialData || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false),
        onCompletedFn: ()=>{
            setAlreadyFetchedInitialData(true);
        }
    });
    const handleNextUnreadNavigation = (0, $cozmU.useCallback)(()=>{
        if (!alreadyFetchedInitialData) {
            //This will trigger the ActiveComments query if it's not already fetched
            setTriggeredByUnreadKeyboardShortcut(true);
            //Exit because the comment data won't be available yet to navigate to
            return;
        }
        //unread panel navigation
        if (isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel) {
            let nextThreadKey = '';
            let nextCommentType = (0, $8i27m.CommentType).GENERAL;
            if (!currentlySelectedThreadKey) {
                if (unreadInlineComments.length > 0) {
                    nextThreadKey = unreadInlineComments[0];
                    nextCommentType = (0, $8i27m.CommentType).INLINE;
                } else nextThreadKey = unreadGeneralComments[0];
            } else {
                nextThreadKey = (0, $aHcFH.getNextUnreadThreadKey)(getCommentIndex(currentlySelectedThreadKey ?? '') + 1, //Add one otherwise it might get stuck on the current comment because there are unread replies which are collapsed
                [
                    ...orderedActiveAnnotations,
                    ...footerCommentIds
                ], [
                    ...unreadInlineComments,
                    ...unreadGeneralComments
                ]) ?? '';
                if (unreadInlineComments.includes(nextThreadKey)) nextCommentType = (0, $8i27m.CommentType).INLINE;
            }
            // Handle panel selection state management in the listener
            setCurrentlySelectedThreadKey(nextThreadKey);
            (0, $9FoVw.handleKeyboardShortcutNavigation)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                block: 'center',
                annotationId: nextThreadKey,
                commentType: nextCommentType === (0, $8i27m.CommentType).GENERAL ? 'FOOTER' : 'INLINE',
                isCommentsPanelOpen: isObjectSidebarShown,
                hasKeyPressed: true,
                context: (0, $9FoVw.NavigationContext).RENDERER,
                shortcutType: (0, $9FoVw.ShortcutType).UNREAD
            });
            return;
        }
        if (activeHighlight || currentlySelectedThreadKey) handleNextCommentNavigation({
            isNavigateToNextUnread: true,
            action: 'next'
        });
        else {
            if (unreadInlineComments.length + unreadGeneralComments.length === 0) return;
            if (unreadInlineComments[0]) openInlineComment(unreadInlineComments[0]);
            else scrollToFooterComment(unreadGeneralComments[0]);
        }
    }, [
        isObjectSidebarShown,
        panel?.id,
        handleNextCommentNavigation,
        unreadInlineComments,
        activeHighlight,
        openInlineComment,
        scrollToFooterComment,
        currentlySelectedThreadKey,
        unreadGeneralComments,
        footerCommentIds,
        getCommentIndex,
        orderedActiveAnnotations,
        setCurrentlySelectedThreadKey,
        alreadyFetchedInitialData
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (unreadInlineComments.length + unreadGeneralComments.length > 0 && alreadyFetchedInitialData && triggeredByUnreadKeyboardShortcut) {
            // This handles the case where user triggers unread keyboard shortcut when the comments data isn't fetched yet.
            // We need to wait for the data to be fetched before calling handleNextUnreadNavigation
            setTriggeredByUnreadKeyboardShortcut(false);
            // Putting this behind a timeout because need to wait for triggeredByUnreadKeyboardShortcut to be set to false otherwise got called multiple times
            setTimeout(()=>{
                handleNextUnreadNavigation();
            }, 100);
        }
    }, [
        unreadInlineComments,
        unreadGeneralComments,
        handleNextUnreadNavigation,
        alreadyFetchedInitialData,
        triggeredByUnreadKeyboardShortcut,
        setTriggeredByUnreadKeyboardShortcut
    ]);
    const openCommentEditorShortcutCb = (e)=>{
        e.preventDefault();
        // This check is necessary to see which keyboard shortcut was used so it can be sent to analytics.
        // e.key is used to get the key that was pressed according to the current keyboard layout.
        // We compare with CREATE_COMMENT_SHORTCUT because it is a single-letter keyboard shortcut.
        // It's more difficult to compare with UNIVERSAL_OPEN_COMMENT_EDITOR because it includes modifiers.  Modifiers which change what e.key maps to depending on the keyboard layout.
        const shortcut = e.key === (0, $gnkil.CREATE_COMMENT_SHORTCUT) ? (0, $gnkil.CREATE_COMMENT_SHORTCUT) : (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR);
        if (canAddComments || !(0, $9wGTI.fg)('confluence_fe_add_comment_kb_check_permission')) {
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            if (document.querySelector('[data-testid="highlightActionsPopup"]')) {
                // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                const createButton = document.querySelector('#create-inline-comment-button');
                // If createButton is not found or is disabled, do nothing.
                // This handles the case when hovering over media (image/video) objects in renderer.
                // In this scenario, a `highlightActionsPopup` is shown but the Comment button (which
                // has a different id) behaves differently: if any comment exists on the media object,
                // button click opens it as standalone; otherwise button click opens CreateComment.
                // Keyboard shortcut is disabled for this scenario.
                const createButtonIsEnabled = createButton && createButton?.getAttribute('disabled') !== '';
                if (createButtonIsEnabled) handleCommentButtonClick({
                    dialogs: dialogs,
                    shortcut: shortcut,
                    experienceAttributes: {
                        entryPoint: 'keyboardShortcut',
                        edition: edition
                    }
                });
            } else {
                // Check if we should show sticky draft instead of scrolling to object comment wrapper
                const isShowStickyDraft = !isObjectCommentWrapperVisible && (addFooterCommentAdf || expanded) && footerEditorEntry !== (0, $fNzRA.AddFooterCommentMode).STICKY_DRAFT;
                if (!expanded) expandCommentContainer({
                    entryPoint: 'keyboardShortcutView'
                });
                if (isShowStickyDraft || !isObjectCommentWrapperVisible) setFooterEditorEntry((0, $fNzRA.AddFooterCommentMode).STICKY_DRAFT);
                else // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.querySelector(`[data-testid='object-comment-wrapper']`)?.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        }
        sendKeyboardShortcutAnalytics(shortcut);
    };
    if (!isFabricPage) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "comments-shortcut-listener"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_SELECT_COMMENT_SHORTCUT),
        listener: ()=>{
            const openComment = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            document.getElementById('renderer-comments-sidebar') || // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            document.getElementById(`comment-thread-${currentlySelectedThreadKey}-container`);
            if (openComment) (0, $aHcFH.focusElementAndUpdateTabIndex)(openComment);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_NEXT_COMMENT_SHORTCUT),
        deprecatedAccelerator: (0, $gnkil.NEXT_COMMENT_SHORTCUT),
        listener: ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: 'keyboard-navigation'
            });
            (0, $4EKKB.selectInlineComment).debug('keyboard navigation to next comment', {
                // whenTriggered props added to help debug on Hello (for reproducing issues)
                activeHighlightWhenTriggered: activeHighlight,
                currentlySelectedThreadKeyWhenTriggered: currentlySelectedThreadKey
            });
            handleCommentNavigation('next');
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_PREV_COMMENT_SHORTCUT),
        deprecatedAccelerator: (0, $gnkil.PREV_COMMENT_SHORTCUT),
        listener: ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: 'keyboard-navigation'
            });
            (0, $4EKKB.selectInlineComment).debug('keyboard navigation to previous comment', {
                // whenTriggered props added to help debug on Hello (for reproducing issues)
                activeHighlightWhenTriggered: activeHighlight,
                currentlySelectedThreadKeyWhenTriggered: currentlySelectedThreadKey
            });
            handleCommentNavigation('previous');
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT),
        listener: ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: 'keyboard-navigation'
            });
            (0, $4EKKB.selectInlineComment).debug('Keyboard navigation to next unread comment', {
                // whenTriggered props added to help debug on Hello (for reproducing issues)
                activeHighlightWhenTriggered: activeHighlight,
                currentlySelectedThreadKeyWhenTriggered: currentlySelectedThreadKey
            });
            handleNextUnreadNavigation();
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: (0, $gnkil.CREATE_COMMENT_SHORTCUT),
        accelerator: (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR),
        listener: (e)=>openCommentEditorShortcutCb(e)
    }));
};
const $c392465906bed01c$export$c1f9f1253d923bc1 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).COMMENTS
})((0, $inDu6.withDialogs)($c392465906bed01c$var$ViewCommentShortcutListenerComponent));
module.exports["ViewCommentShortcutListener"] = $c392465906bed01c$export$c1f9f1253d923bc1;

});

parcelRegister("39nIX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");

var $398ES = parcelRequire("398ES");


var $7boqA = parcelRequire("7boqA");


var $5RuD9 = parcelRequire("5RuD9");


var $jhifQ = parcelRequire("jhifQ");


/* View Mode Exports */ const $166368e9a123fc4e$var$InlineCommentsLoaderPaint = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "fZs06",
    name: "InlineCommentsLoaderPaint",
    loader: async ()=>(await (parcelRequire("3rPpH"))).InlineComments,
    loading: (0, $5RuD9.InlineCommentsLoading)
});

const $166368e9a123fc4e$var$InlineCommentsLoaderLazy = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "i8DIK",
    name: "InlineCommentsLoaderLazy",
    loader: async ()=>(await (parcelRequire("3rPpH"))).InlineComments,
    loading: (0, $5RuD9.InlineCommentsLoading)
});

const $166368e9a123fc4e$var$InlineCommentsLoaderAfterPaint = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "vilgC",
    name: "InlineCommentsLoaderAfterPaint",
    loader: async ()=>(await (parcelRequire("3rPpH"))).InlineComments
});

const $166368e9a123fc4e$var$InlineCommentsLoaderBackground = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "05zPo",
    name: "InlineCommentsLoaderBackground",
    loader: async ()=>(await (parcelRequire("3rPpH"))).InlineComments
});
const $166368e9a123fc4e$var$loaders = {
    [(0, $398ES.LoadingPriority).LAZY]: $166368e9a123fc4e$var$InlineCommentsLoaderLazy,
    [(0, $398ES.LoadingPriority).PAINT]: $166368e9a123fc4e$var$InlineCommentsLoaderPaint,
    [(0, $398ES.LoadingPriority).AFTER_PAINT]: $166368e9a123fc4e$var$InlineCommentsLoaderAfterPaint
};
const $166368e9a123fc4e$export$bceb71dc98e1c75f = ({ loadingPriority: loadingPriority, focusedCommentId: focusedCommentId, ...rest })=>{
    const CommentsLoader = $166368e9a123fc4e$var$loaders[loadingPriority] || $166368e9a123fc4e$var$InlineCommentsLoaderBackground;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, focusedCommentId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
        key: `start-${focusedCommentId}`,
        metric: (0, $jhifQ.FOCUSED_INLINE_COMMENT_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(CommentsLoader, rest));
};
module.exports["InlineCommentsLoader"] = $166368e9a123fc4e$export$bceb71dc98e1c75f;

});

parcelRegister("5RuD9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8uhVX = parcelRequire("8uhVX");


var $beAZw = parcelRequire("beAZw");

const $58d1b0f1d68392b5$var$checkForSSRFocusedComment = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) return true;
    return false;
};
const $58d1b0f1d68392b5$export$d174da0f28ffce9e = ()=>{
    return $58d1b0f1d68392b5$var$checkForSSRFocusedComment() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8uhVX.FocusedInlineComment), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $beAZw.InlineCommentsLoadingSkeleton), null);
};
module.exports["InlineCommentsLoading"] = $58d1b0f1d68392b5$export$d174da0f28ffce9e;

});

parcelRegister("8uhVX", function(module, exports) {
/* FocusedInlineComment.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $9wGTI = parcelRequire("9wGTI");


var $dOBRD = parcelRequire("dOBRD");


var $kSwu1 = parcelRequire("kSwu1");


var $jMyy4 = parcelRequire("jMyy4");


var $7zgzO = parcelRequire("7zgzO");


var $ep3mz = parcelRequire("ep3mz");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");




var $9CnRS = parcelRequire("9CnRS");


var $666Tc = parcelRequire("666Tc");


var $k5dl6 = parcelRequire("k5dl6");



var $f8HSn = parcelRequire("f8HSn");


var $qYtBT = parcelRequire("qYtBT");


var $dQJV7 = parcelRequire("dQJV7");


var $c04ej = parcelRequire("c04ej");

const $d9a6205ec51ab13a$var$parseContent = (0, $dOBRD.default)((content)=>{
    if (!content?.length) return null;
    try {
        return JSON.parse(content);
    } catch  {
        return null;
    }
});
const $d9a6205ec51ab13a$var$FocusedInlineCommentContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $666Tc.SidebarContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_162hus6": (0, $9aYkv.default)(__cmplp.offset, "px")
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_154i1odf _zqk2124n _16tr13gf",
            __cmplp.showSkeleton ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ])
    });
}); /* Comment Editor CSS*/ 
const $d9a6205ec51ab13a$var$EditorContainerSSRFallback = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $666Tc.EditorContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_10v51b66 _1fnwia51 _116r1l7b _kv9qfhey _12i31ul9 _j980usvi _1esn1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $d9a6205ec51ab13a$var$EditorContainerSSRTokenized = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $666Tc.EditorContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_10v51b66 _1fnwia51 _116r12b0 _kv9qfhey _12i31ul9 _j980usvi _1esn1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $d9a6205ec51ab13a$var$CommentContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFocused: isFocused, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt49l6b _12ji1r31 _1qu2glyw _12y31o36 _1kl7idpf _x3doidpf _1e0c1txw _2lx21bp4 _1ragidpf _ha8hi7uo",
            __cmplp.isFocused && "_11q71856",
            __cmplp.className
        ])
    });
});
const $d9a6205ec51ab13a$export$622cea445a1c5b7d = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) return window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['markerRefOffset'];
    return 0;
}; // Makes sure to only show focusedInlineCommentSSR if the page was ssr'd
const $d9a6205ec51ab13a$export$db871669e60ed1cb = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) return true;
    return false;
};
const $d9a6205ec51ab13a$export$7afb8d400fcdf579 = ()=>{
    const EditorContainerSSR = (0, $9wGTI.fg)('confluence_frontend_tokenize_border') ? $d9a6205ec51ab13a$var$EditorContainerSSRTokenized : $d9a6205ec51ab13a$var$EditorContainerSSRFallback;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { match: match } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const focusedCommentId = match?.query.focusedCommentId;
    const focusedCommentIdString = typeof focusedCommentId === 'string' ? focusedCommentId : ''; // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $k5dl6.default), {
        variables: {
            commentId: focusedCommentIdString,
            contentId: contentId
        },
        skip: !(contentId && focusedCommentId),
        __callerPackage__: "inline-comments"
    });
    let commentData;
    let isTopLevelComment = true; /* If focusedCommentId is a reply grab top-level comment Data from ancestors.
                                 If ancestors is non-empty it means focusedCommentId is a reply*/ 
    if (data?.comments?.nodes?.[0]?.ancestors && data.comments.nodes[0].ancestors.length > 0) {
        commentData = data.comments.nodes[0].ancestors[0];
        isTopLevelComment = false;
    } else commentData = data?.comments?.nodes?.[0];
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['isTopLevelComment'] = isTopLevelComment;
    const content = data?.content?.nodes?.[0];
    const operations = content?.operations || [];
    const canCreateComments = Boolean(operations.find((op)=>op?.operation === 'create' && op?.targetType === 'comment'));
    const topCommentUserId = commentData?.author?.accountId;
    const topCommentUserAvatar = commentData?.author?.profilePicture?.path;
    const topCommentDisplayName = commentData?.author?.displayName;
    const commentId = commentData?.id;
    const when = commentData?.version?.when;
    const commentContent = commentData?.body?.value;
    const permissionType = commentData?.author?.permissionType;
    const currentUserAvatarUrl = data?.user?.photos?.[0]?.value ?? undefined;
    const currentUserDisplayName = data?.user?.displayName ?? undefined;
    const currentUserId = data?.user?.id;
    const adf = $d9a6205ec51ab13a$var$parseContent(commentContent);
    const renderReplies = ()=>{
        const replies = commentData?.replies || [];
        return replies.map((reply)=>{
            const adf = $d9a6205ec51ab13a$var$parseContent(reply?.body?.value);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d9a6205ec51ab13a$var$CommentContainer, {
                key: reply?.id,
                isFocused: focusedCommentId === reply?.id,
                "data-comment-id": reply?.id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f8HSn.CommentAuthor), {
                commentMode: "view",
                userId: reply?.author?.accountId,
                avatarUrl: reply?.author?.profilePicture?.path,
                displayName: reply?.author?.displayName,
                date: reply?.version?.when,
                permissionType: reply?.author?.permissionType
            }), adf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c04ej.CommentRenderer), {
                adf: adf
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQJV7.CommentActions), {
                isReply: true,
                permissions: reply?.permissions
            }));
        });
    }; // Scroll to focusedInlineComment if it's out of the screen
    const scrollOffset = window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment'] && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['scrollOffset'];
    if (scrollOffset) window.scrollTo({
        top: scrollOffset
    });
    if (data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COLLABORATION
    }, undefined, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d9a6205ec51ab13a$var$FocusedInlineCommentContainer, {
        mode: "view",
        id: "focused-inline-comment-sidebar-skeleton",
        "data-testid": "focused-inline-comment-sidebar-skeleton",
        showSkeleton: $d9a6205ec51ab13a$export$db871669e60ed1cb(),
        offset: $d9a6205ec51ab13a$export$622cea445a1c5b7d()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $qYtBT.CommentHeader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d9a6205ec51ab13a$var$CommentContainer, {
        tabIndex: -1,
        "data-comment-id": commentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f8HSn.CommentAuthor), {
        commentMode: "view",
        userId: topCommentUserId,
        avatarUrl: topCommentUserAvatar,
        displayName: topCommentDisplayName,
        date: when,
        permissionType: permissionType,
        size: "medium"
    }), adf && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c04ej.CommentRenderer), {
        adf: adf
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQJV7.CommentActions), {
        permissions: commentData?.permissions,
        isReply: false
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.ReplyListContainer), {
        "data-testid": "reply-container"
    }, renderReplies()), canCreateComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.NewReplyContainer), {
        mode: "view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(EditorContainerSSR, {
        isReply: true,
        mode: "view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f8HSn.CommentAuthor), {
        commentMode: "reply",
        userId: currentUserId,
        avatarUrl: currentUserAvatarUrl,
        displayName: currentUserDisplayName,
        date: when,
        permissionType: permissionType,
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("input", {
        disabled: true,
        placeholder: formatMessage((0, $9CnRS.i18n).replyPlaceholder),
        "aria-label": formatMessage((0, $9CnRS.i18n).replyPlaceholder)
    })))), undefined);
    return null;
};
module.exports["FocusedInlineComment"] = $d9a6205ec51ab13a$export$7afb8d400fcdf579;

});

parcelRegister("f8HSn", function(module, exports) {
/* CommentAuthor.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $fs6LW = parcelRequire("fs6LW");


var $gvWVt = parcelRequire("gvWVt");


var $1YXTQ = parcelRequire("1YXTQ");


var $7tI6B = parcelRequire("7tI6B");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$DateContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2lx2vrvc _1n261q9c _1e0c1txw _4cvr1h6o _102ewadc _1mil78py _7wy0glyw _1t4pd34b _1plv1j28 _zmp8d34b _9b8id34b _1blwd34b",
            __cmplp.className
        ])
    });
});
const $b0598b16360d1677$var$AuthorContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { commentMode: commentMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _4cvr1h6o _uvzw1snc _12rjagmp _1vjrvv82 _1dtc4viv _jva41snc _wkreagmp _gcmzvv82 _5xy14viv _1msj4viv",
            __cmplp.commentMode !== 'reply' ? "_18u01i6y" : "_18u01kw7",
            __cmplp.commentMode === 'view' && "_n3tdu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$AvatarWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { commentMode: commentMode, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _u5f3u2gc",
            __cmplp.commentMode === 'view' && "_4t3i1wpv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$ProfileLinkContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _2lx2vrvc _4cvr1h6o _17rpwadc _cpznidpf _1s79idpf _amufidpf _x966idpf _387xglyw _14l5d34b _1ptk1j28 _19gdazsu _1e6pazsu _1gidazsu _zer61snc _7ec9agmp _1bkkvv82 _z01g4viv _101q1snc _vnv1agmp _94evvv82 _kvyv4viv _18t3x3d0 _1t4p4viv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0598b16360d1677$var$LozengeWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_19bvu2gc _s7n4jp4b",
            __cmplp.className
        ])
    });
});
const $b0598b16360d1677$export$d05a2f5fbf67a6d7 = ({ commentMode: commentMode, userId: userId, date: date, displayName: displayName, avatarUrl: avatarUrl, permissionType: permissionType, size: size })=>{
    const isDateShown = commentMode === 'view' && date;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0598b16360d1677$var$AuthorContainer, {
        commentMode: commentMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0598b16360d1677$var$AvatarWrapper, {
        commentMode: commentMode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fs6LW.ProfileAvatar), {
        userId: userId,
        src: avatarUrl,
        size: size,
        trigger: "click",
        name: displayName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0598b16360d1677$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0598b16360d1677$var$ProfileLinkContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, displayName), permissionType === (0, $7tI6B.SitePermissionType).EXTERNAL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0598b16360d1677$var$LozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gvWVt.ExternalCollaboratorUserLozenge), null)) : null), isDateShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b0598b16360d1677$var$DateContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1YXTQ.TimeAgo), {
        date: date
    })))));
};
module.exports["CommentAuthor"] = $b0598b16360d1677$export$d05a2f5fbf67a6d7;

});

parcelRegister("qYtBT", function(module, exports) {
/* CommentHeader.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $l3wuH = parcelRequire("l3wuH");


var $6TaGl = parcelRequire("6TaGl");


var $7N1sB = parcelRequire("7N1sB");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9359cd91b07ea16f$var$SidebarHeader = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1yt4ba4q _kqswh2mm _1e0c1txw _4t3i10yn _ca0qutpp _1hadu49m _wzsr12b0 _brspgktf _11pzgktf _p7gl1wug _1p0qutpp _etmr1b66 _13yvyfq0",
            __cmplp.className
        ])
    });
});
const $9359cd91b07ea16f$export$af4e8b81cdb5570a = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9359cd91b07ea16f$var$SidebarHeader, {
        "data-testid": "inline-comment-ssr-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7N1sB.CommentNavigation), {
        goToNextInlineComment: ()=>{},
        goToPrevInlineComment: ()=>{}
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        id: "dropdown"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
        label: "overflow-menu-icon",
        color: "var(--ds-icon-disabled, #080F214A)",
        spacing: "spacious"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        id: "close-icon-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
        label: "close-icon",
        color: `${"var(--ds-icon-disabled, #080F214A)"}`,
        spacing: "none"
    })));
};
module.exports["CommentHeader"] = $9359cd91b07ea16f$export$af4e8b81cdb5570a;

});

parcelRegister("dQJV7", function(module, exports) {
/* CommentActions.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $bFPHx = parcelRequire("bFPHx");


var $666Tc = parcelRequire("666Tc");


var $9CnRS = parcelRequire("9CnRS");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e6040be4eb93366f$var$ActionsContainerSSR = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = (0, $666Tc.ActionsContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1tke10yn _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $e6040be4eb93366f$var$ActionItem = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2lx2vrvc _1n261q9c _1e0c116y _syaz1rpy _19pk1b66 _xrwlcs5v _144bkb7n _14p1f1ug _ekv6wadc _6wjiesu3 _43ds1oa5 _1pzmusic _ep9t1b66 _1tzjf4df _8bo21mp2 _nqnu1rpy _d32v1rpy",
            __cmplp.className
        ])
    });
});
const $e6040be4eb93366f$var$ActionButton = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_11q7glyw _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _12ji1r31 _1qu21kw7 _12y31o36 _syaz1kw7 _1wyb1kw7 _80omtlke",
            __cmplp.className
        ])
    });
});
const $e6040be4eb93366f$export$e75a036919cd8d68 = ({ isReply: isReply, permissions: permissions })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionsContainerSSR, null, permissions.isResolvable && !isReply && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionButton, {
        type: "button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9CnRS.i18n).resolve))), permissions.isEditable && isReply && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionButton, {
        type: "button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9CnRS.i18n).edit))), permissions.isRemovable && isReply && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionButton, {
        type: "button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $9CnRS.i18n).delete))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e6040be4eb93366f$var$ActionItem, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bFPHx.ReactionsPlaceholder), null)));
module.exports["CommentActions"] = $e6040be4eb93366f$export$e75a036919cd8d68;

});

parcelRegister("c04ej", function(module, exports) {
/* CommentRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $bzqa9 = parcelRequire("bzqa9");


var $hEeUR = parcelRequire("hEeUR");


var $6mKj3 = parcelRequire("6mKj3");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $61a27fe9845a1cb4$var$CommentRendererContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1reo15vq _18m915vq _ca0qutpp _n3tdutpp",
            __cmplp.className
        ])
    });
});
const $61a27fe9845a1cb4$export$ce6d3ea87eba7794 = ({ adf: adf })=>{
    const eventHandlers = (0, $bzqa9.useEventHandlers)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($61a27fe9845a1cb4$var$CommentRendererContainer, {
        id: "ssr-comment-renderer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hEeUR.ADFRenderer), {
        document: adf,
        appearance: "comment",
        eventHandlers: eventHandlers,
        ...(0, $6mKj3.expValEquals)('confluence_comments_media_ssr_support', 'isEnabled', true) && {
            media: undefined
        }
    }));
};
module.exports["CommentRenderer"] = $61a27fe9845a1cb4$export$ce6d3ea87eba7794;

});

parcelRegister("beAZw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $rVJpV = parcelRequire("rVJpV");


var $666Tc = parcelRequire("666Tc");

const $c9d0ea73f4f989e9$export$bb9f90f28a3a4c80 = ()=>{
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['clickedInlineHighlightElements'] && Array.isArray(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['clickedInlineHighlightElements'])) return Boolean(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['clickedInlineHighlightElements'].length);
    return false;
};
const $c9d0ea73f4f989e9$export$e90f33bd7f6da077 = ({ offset: offset = 0 })=>{
    /* For SSR check window object or use offset if passed */ // Previously, clicking on a comment via the inline comment button would still generate an offset.
    // That meant that on transitions, the loading skeleton would still flicker, so we check for window.__SSR_RENDERED__ as well
    /// to prevent the flicker on transitions.
    const sideBarOffset = window.__SSR_RENDERED__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['sidebarCommentOffset'] || offset;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.LoadingSkeletonContainer), {
        id: "inline-comment-sidebar-skeleton",
        "data-testid": "inline-comment-sidebar-skeleton",
        showSkeleton: $c9d0ea73f4f989e9$export$bb9f90f28a3a4c80() || Boolean(offset),
        offset: sideBarOffset,
        mode: "view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $rVJpV.LoadingSkeletonChildren), null));
};
module.exports["InlineCommentsLoadingSkeleton"] = $c9d0ea73f4f989e9$export$e90f33bd7f6da077;

});

parcelRegister("rVJpV", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");


var $lfoFx = parcelRequire("lfoFx");


var $l3wuH = parcelRequire("l3wuH");


var $6TaGl = parcelRequire("6TaGl");


var $666Tc = parcelRequire("666Tc");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$SkeletonContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1yt4pxbi _16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$CommentSkeletonRow = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { flex: flex, useColumnDirection: useColumnDirection, marginTop: marginTop, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_flb7sw": (0, $9aYkv.default)(__cmplp.flex),
                "--_11vu6jx": (0, $9aYkv.default)(__cmplp.marginTop, "px")
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_1e0c1txw _19pk4hp3",
                __cmplp.flex ? "_kkes1ubm" : "_16jlkb7n _1o9zkb7n _i0dlf1ug",
                __cmplp.useColumnDirection ? "_2lx21bp4" : "_2lx2vrvc",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $f5ae94c9feb318d8$var$CommentAuthorSkeleton = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2rko1rr0 _4t3izwfg _1bsbzwfg _bfhkizff",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$CommentSkeletonLine = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { marginBottom: marginBottom, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_iz5w78": (0, $9aYkv.default)(__cmplp.marginBottom, "px"),
                "--_10ib6lf": (0, $9aYkv.default)(__cmplp.height, "px"),
                "--_1gljcou": (0, $9aYkv.default)(__cmplp.width, "px")
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_2rko1l7b _bfhkizff _1bsb1rkg",
                typeof __cmplp.marginBottom === "number" ? "_otyr1s4l" : "_otyrrdoj",
                __cmplp.height ? "_4t3it1jn" : "_4t3iftgi",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $f5ae94c9feb318d8$var$SpinnerContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _19pku2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5ae94c9feb318d8$var$SidebarHeader = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1yt41fsj _kqswh2mm _1e0c1txw _1bah1yb4 _4t3i10yn",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f5ae94c9feb318d8$var$CloseButton = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $666Tc.InlineHeaderButton) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u014y2 _4t3i1tcg _1bsb1tcg",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f5ae94c9feb318d8$var$NavContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $666Tc.NavigationContainer) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f5ae94c9feb318d8$export$4857ba7068d0bed8 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_19pkidpf _otyridpf _kqswh2mm _bfhkvuon",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f5ae94c9feb318d8$export$a42ae5e40534ea56 = ()=>{
    const $ = (0, $bDgLe.c)(7);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.InlineHeaderButton), {
            "data-cy": "inline-nav-previous",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                label: "",
                color: "var(--ds-icon-disabled, #080F214A)",
                spacing: "spacious",
                size: "small"
            })
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$NavContainer, null, t0, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $666Tc.InlineHeaderButton), {
            "data-cy": "inline-nav-previous",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: "",
                color: "var(--ds-icon-disabled, #080F214A)",
                spacing: "spacious",
                size: "small"
            })
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CommentSkeletonLine, {
            width: 30,
            height: 8,
            marginBottom: 0
        }));
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
            spacing: "spacious",
            label: "",
            color: "var(--ds-icon-disabled, #080F214A)"
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$SidebarHeader, null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$NavContainer, null, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CloseButton, {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                label: ""
            })
        })));
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CommentSkeletonRow, {
            flex: 1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CommentAuthorSkeleton, null));
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$export$4857ba7068d0bed8, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CommentSkeletonRow, {
            flex: 1
        }, t4, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CommentSkeletonRow, {
            flex: 5,
            marginTop: 5,
            useColumnDirection: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CommentSkeletonLine, {
            width: 81
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$CommentSkeletonLine, {
            width: 53,
            height: 6
        })))));
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t3, t5, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f5ae94c9feb318d8$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: "medium",
            interactionName: "inline-comments-loading-skeleton"
        })));
        $[6] = t6;
    } else t6 = $[6];
    return t6;
};
module.exports["LoadingSkeletonChildren"] = $f5ae94c9feb318d8$export$a42ae5e40534ea56;

});

parcelRegister("3rPpH", function(module, exports) {

let $282bc6619eecdbb6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $282bc6619eecdbb6$var$load("ig9dh"),
    $282bc6619eecdbb6$var$load("hA8hA"),
    $282bc6619eecdbb6$var$load("ddvkk"),
    $282bc6619eecdbb6$var$load("3upHR"),
    $282bc6619eecdbb6$var$load("6wr18"),
    $282bc6619eecdbb6$var$load("agdLZ"),
    $282bc6619eecdbb6$var$load("kxG0W"),
    $282bc6619eecdbb6$var$load("byAMe"),
    $282bc6619eecdbb6$var$load("cKqFC"),
    $282bc6619eecdbb6$var$load("4W6oq"),
    $282bc6619eecdbb6$var$load("jzUgs"),
    $282bc6619eecdbb6$var$load("7EorR"),
    $282bc6619eecdbb6$var$load("jqoep"),
    $282bc6619eecdbb6$var$load("ffEVr"),
    $282bc6619eecdbb6$var$load("Wowvf"),
    $282bc6619eecdbb6$var$load("gzrfp"),
    $282bc6619eecdbb6$var$load("79Tk4"),
    $282bc6619eecdbb6$var$load("gVVrO"),
    $282bc6619eecdbb6$var$load("6KRyd"),
    $282bc6619eecdbb6$var$load("1PFZq")
]).then(()=>parcelRequire('31yzi'));

});

parcelRegister("aXika", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $irVI7 = parcelRequire("irVI7");


var $8Ss4E = parcelRequire("8Ss4E");


var $fGzMp = parcelRequire("fGzMp");


var $aJPUt = parcelRequire("aJPUt");


var $ep3mz = parcelRequire("ep3mz");


var $jMyy4 = parcelRequire("jMyy4");


var $4zbo1 = parcelRequire("4zbo1");


var $f9opb = parcelRequire("f9opb");

var $jgc4t = parcelRequire("jgc4t");


var $1uFM6 = parcelRequire("1uFM6");


var $95rLf = parcelRequire("95rLf");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $7Sm4c = parcelRequire("7Sm4c");


var $9Q3jD = parcelRequire("9Q3jD");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $1NBp8 = parcelRequire("1NBp8");


var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");


var $isEtk = parcelRequire("isEtk");


var $c0urc = parcelRequire("c0urc");

var $1SNEF = parcelRequire("1SNEF");


var $bQm3c = parcelRequire("bQm3c");


var $kvJHJ = parcelRequire("kvJHJ");


var $7boqA = parcelRequire("7boqA");


var $essql = parcelRequire("essql");


var $gsWjA = parcelRequire("gsWjA");


var $2aFNh = parcelRequire("2aFNh");


var $iuaOs = parcelRequire("iuaOs");

const $50e9068f0df1c4d8$var$pageMap = {
    SPACE_OVERVIEW: {
        route: (0, $1NBp8.SPACE_OVERVIEW),
        errorAttribution: 'next-space-overview',
        name: (0, $irVI7.SPACE_OVERVIEW_EXPERIENCE),
        isContentView: false
    },
    COMPANY_HUB: {
        route: (0, $1NBp8.COMPANY_HUB),
        errorAttribution: 'next-company-hub',
        name: (0, $irVI7.FRONT_COVER_LOAD_EXPERIENCE),
        isContentView: false
    },
    page: {
        route: (0, $1NBp8.VIEW_PAGE),
        errorAttribution: 'next-view-page',
        name: (0, $irVI7.VIEW_PAGE_EXPERIENCE),
        isContentView: true
    }
};
const $50e9068f0df1c4d8$export$2fe638b9bbc723fb = /*#__PURE__*/ (0, $cozmU.memo)(({ contentId: contentId, spaceKey: spaceKey, children: children, stickyHeader: stickyHeader, contentScreenStyles: contentScreenStyles, isContainerContentView: isContainerContentView = true, versionOverride: versionOverride = null, customPerfData: customPerfData, isEmbeddedPage: isEmbeddedPage })=>{
    const { setCurrentDocumentVersion: setCurrentDocumentVersion, setDocumentNeedsUpdate: setDocumentNeedsUpdate, setPublishedDocumentVersion: setPublishedDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatusDispatch)();
    const [{ routeName: routeName = '', contentType: contentType }] = (0, $ep3mz.usePageState)();
    const { edition: edition, userId: userId } = (0, $bQm3c.useSessionData)();
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(window.__SSR_RENDERED__);
    (0, $essql.useUnreadCommentsSetup)({
        pageId: contentId,
        pageContentTypeProps: {
            pageMode: 'view'
        }
    });
    const extractDataAndSetPublishedVersion = (0, $cozmU.useCallback)(({ refetchContentQueryResult: refetchContentQueryResult })=>{
        const { data: data } = refetchContentQueryResult;
        if (data) {
            const versionNumber = data.content?.nodes?.[0]?.version?.number;
            if (versionNumber !== undefined && versionNumber !== null) setPublishedDocumentVersion(versionNumber);
        }
    }, [
        setPublishedDocumentVersion
    ]);
    const isBlogpost = contentType === 'blogpost';
    const skipContentQuery = !contentId || !spaceKey;
    const pageContentQueryResult = (0, $jMyy4.useQueryInterop)((0, $jgc4t.default), {
        fetchPolicy: 'cache-first',
        context: {
            single: true
        },
        skip: skipContentQuery || isBlogpost,
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            isSSR: isSSR,
            versionOverride: versionOverride,
            useNewContentTopper: true,
            // confluence-feature-gating/inline-usage: expValEquals must be inlined
            // Only spread agentSessionsPropertyKey/fetchAgentSessionsMarker when the
            // experiment is enabled. When omitted, GraphQL defaults kick in (key="",
            // fetch=false), and — crucially — the query variables object is identical
            // to the pre-change shape, so contract-test mock backends (playwright) still
            // match the stored query hash and don't break.
            ...!!userId && (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true) ? {
                agentSessionsPropertyKey: `cc-agent-mention-sessions:${userId}`,
                fetchAgentSessionsMarker: true
            } : {},
            // Only spread includeAgentTrustReceiptData when the gate is on, so the variables
            // object (and therefore the contract-test query hash) is unchanged when it's off.
            // This must match the value the SSR preloader (preloadContent) writes the
            // ContentUnifiedQuery cache entry with, or the homepage re-fetches on first render.
            ...(0, $9wGTI.fg)('cc_sparks_agent_trust_receipt') ? {
                includeAgentTrustReceiptData: true
            } : {}
        },
        __callerPackage__: "view-page-common"
    });
    const blogContentQueryResult = (0, $jMyy4.useQueryInterop)((0, $f9opb.default), {
        fetchPolicy: 'cache-first',
        context: {
            single: true
        },
        skip: skipContentQuery || !isBlogpost,
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            isSSR: isSSR,
            versionOverride: versionOverride,
            useNewContentTopper: true,
            ...(0, $9wGTI.fg)('cc_sparks_agent_trust_receipt') ? {
                includeAgentTrustReceiptData: true
            } : {}
        },
        __callerPackage__: "view-page-common"
    });
    const contentQueryResult = isBlogpost ? blogContentQueryResult : pageContentQueryResult;
    const { route: route, errorAttribution: errorAttribution, name: name, isContentView: isContentView } = $50e9068f0df1c4d8$var$pageMap[routeName] ?? $50e9068f0df1c4d8$var$pageMap['page'];
    const { refetch: refetch } = contentQueryResult;
    (0, $2aFNh.useContentExtensionMetrics)(contentQueryResult?.data?.content?.nodes?.[0]?.body?.dynamic?.value, customPerfData);
    (0, $cozmU.useEffect)(()=>{
        // If navigating to a different page, always assume document is up to date.
        // Added for COMMENTS-5327, so when user jumps from an outdated page to another
        // up-to-date page, we won't disable the comment button due to outdated-ness.
        // Caveat: The destination page may not actually be up-to-date, e.g. if the
        // page content was loaded from cache that's saved from the user's previous
        // visit in the same browser tab, and a new version was published since then.
        // Invoking `setDocumentNeedsUpdate(false)` here means `documentNeedsUpdate`
        // may be `false` when page is actually outdated, but this scenario can already
        // occur before this change. COMMENTS-5816 tracks fixing this scenario altogether.
        if (!(0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) // With confluence_fe_disable_comment_if_page_outdated_v2 ON,
        // `documentNeedsUpdate` is set to true whenever we set a new
        // `publishedDocumentVersion` IF it's different from `currentDocumentVersion`.
        // This useEffect can be cleaned up after v2 is fully rolled out.
        setDocumentNeedsUpdate(false);
    }, [
        contentId,
        setDocumentNeedsUpdate
    ]);
    // Use this instead of `contentQueryResult.data?.content?.nodes?.[0]?.version?.number`
    // because that field is fetched by other queries too, and thus may become mismatched
    // with the actual version of `body` in GQL cache.
    const contentVersion = contentQueryResult.data?.content?.nodes?.[0]?.body?.dynamic?.content?.version?.number;
    (0, $cozmU.useEffect)(()=>{
        if (contentVersion && (0, $6mKj3.expValEquals)('confluence_fe_disable_comment_if_page_outdated_v2', 'isEnabled', true)) setCurrentDocumentVersion(contentVersion);
    }, [
        contentVersion,
        setCurrentDocumentVersion
    ]);
    const reload = (0, $cozmU.useCallback)(async ()=>{
        (0, $fGzMp.getExperienceTracker)().start({
            name: name,
            timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD,
            attributes: {
                contentType: (0, $8Ss4E.routeNameToContentTypeMap)[routeName],
                contentId: contentId,
                isSpaceOverviewNextRendered: true,
                edition: edition,
                quickReload: true //tell exp metrics error came from reload and not primary experience
            }
        });
        try {
            const refetchContentQueryResult = await refetch({
                contentId: contentId,
                spaceKey: spaceKey,
                isSSR: isSSR,
                versionOverride: versionOverride,
                useNewContentTopper: true
            });
            extractDataAndSetPublishedVersion({
                refetchContentQueryResult: refetchContentQueryResult
            });
        } catch (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                (0, $fGzMp.getExperienceTracker)().abort({
                    name: name,
                    reason: 'Expected Apollo error'
                });
                return; //if it's an expected GQL failure don't throw or fail the experience
            }
            (0, $fGzMp.stopExperienceOnError)(name, error);
            throw error; //this successfully avoids the success below
        }
        (0, $fGzMp.getExperienceTracker)().succeed({
            name: name
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        refetch,
        contentId
    ]);
    const content = contentQueryResult.data?.content?.nodes?.[0];
    const fabricEditorSupported = contentQueryResult.loading ? null : content?.metadata?.frontend?.fabricEditorSupported ?? null;
    const bodyRepresentation = contentQueryResult.loading ? null : content?.body?.dynamic?.representation ?? null;
    (0, $iuaOs.useContentReloadOnFabricSupportChange)({
        contentId: contentId,
        fabricEditorSupported: fabricEditorSupported,
        bodyRepresentation: bodyRepresentation,
        reload: reload
    });
    (0, $1SNEF.useQuickReloadSubscriber)({
        name: 'content',
        types: [
            (0, $c0urc.ReloadType).content,
            (0, $c0urc.ReloadType).comment
        ],
        reload: reload
    });
    (0, $1SNEF.useQuickReloadSubscriber)({
        name: 'commentsDataManager',
        types: [
            (0, $c0urc.ReloadType).comment
        ],
        reload: async ()=>{
            if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) await (0, $4L9ve.getProcessedCommentsDataState)().refetch?.();
        },
        priority: (0, $c0urc.ReloadPriority).background
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
        key: contentId,
        metric: (0, $gsWjA.VIEW_PAGE_CONTAINER_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4KFTW.MacroExperienceStart), {
        contentId: contentId,
        mode: (0, $5kjCz.RENDERER),
        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Q3jD.PagePrerequisites), {
        route: route,
        contentQueryResult: contentQueryResult,
        versionOverride: versionOverride
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $isEtk.ContentStateContainer), {
        scope: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4zbo1.ContentContainer), {
        fetchTheme: true,
        contentThemeSpaceData: contentQueryResult.data ? contentQueryResult.data.space ?? null : undefined,
        contentId: contentId,
        spaceKey: spaceKey,
        key: "content-screen",
        errorAttribution: errorAttribution,
        isScreenContentView: isContentView,
        isContainerContentView: isContainerContentView,
        contentScreenStyles: contentScreenStyles,
        stickyHeader: stickyHeader,
        versionOverride: versionOverride,
        isEmbeddedPage: isEmbeddedPage
    }, ({ isThemed: isThemed })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("article", null, children && children({
            isThemed: isThemed,
            contentQueryData: contentQueryResult.data,
            contentQueryError: contentQueryResult.error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            key: contentId,
            metric: (0, $gsWjA.VIEW_PAGE_CONTAINER_METRIC),
            customData: {
                isThemed: isThemed
            }
        }))))));
});
module.exports["ViewPageContainer"] = $50e9068f0df1c4d8$export$2fe638b9bbc723fb;

});

parcelRegister("gsWjA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $hDLmU = parcelRequire("hDLmU");

var $c411D = parcelRequire("c411D");


var $jOO7o = parcelRequire("jOO7o");


var $bQm3c = parcelRequire("bQm3c");


var $iFjdQ = parcelRequire("iFjdQ");


var $lSOAM = parcelRequire("lSOAM");

var $fQ3iN = parcelRequire("fQ3iN");

var $i3c1S = parcelRequire("i3c1S");


var $jX1qB = parcelRequire("jX1qB");

var $5q601 = parcelRequire("5q601");

var $1UCmC = parcelRequire("1UCmC");


var $lXYVJ = parcelRequire("lXYVJ");


var $6VdZc = parcelRequire("6VdZc");

var $7fw2E = parcelRequire("7fw2E");


var $7sK8i = parcelRequire("7sK8i");


var $8w1c1 = parcelRequire("8w1c1");

parcelRequire("1InRL");
var $hlP5l = parcelRequire("hlP5l");


var $5qUgM = parcelRequire("5qUgM");


var $1q7H7 = parcelRequire("1q7H7");


var $aWrnw = parcelRequire("aWrnw");


var $5YLPl = parcelRequire("5YLPl");


var $fgdVB = parcelRequire("fgdVB");


var $itS9i = parcelRequire("itS9i");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $5vi32 = parcelRequire("5vi32");


var $5ZqQS = parcelRequire("5ZqQS");


var $dtDUi = parcelRequire("dtDUi");

const $a99ff50c139ee598$var$baseConfig = {
    slo: {
        // based on production p90
        fmp: {
            initial: {
                threshold: 14300
            },
            transition: {
                threshold: 3200
            }
        },
        tti: {
            initial: {
                threshold: 14300
            },
            transition: {
                threshold: 3200
            }
        }
    },
    histogram: {
        // based on pre-production pollinator and prod p90
        initial: {
            fmp: '5000_6000_7000_8000_10000_12000_14000',
            tti: '5000_6000_7000_8000_10000_12000_14000'
        },
        transition: {
            fmp: '2000_2500_3000_3500_4000_4500_5000',
            tti: '2000_2500_3000_3500_4000_4500_5000'
        }
    },
    timings: [
        // breakdowns in order of occurrence
        {
            key: 'html',
            endMark: 'html'
        },
        {
            key: 'appLoad',
            startMark: 'html',
            endMark: 'app'
        },
        {
            key: 'appRootRender',
            startMark: 'app',
            endMark: 'root-component-render'
        },
        {
            key: 'routerMatched',
            startMark: 'root-component-render',
            endMark: 'route-manager-initialized'
        }
    ]
};
const $a99ff50c139ee598$var$NOOP = ()=>{};
const $a99ff50c139ee598$export$2d5e2a82ee58820b = ({ isLite: isLite, isInitialLoad: isInitialLoad })=>{
    if (isLite) return [
        (0, $hlP5l.BYLINE_METRIC),
        (0, $hlP5l.CONTENT_TITLE_METRIC),
        (0, $5YLPl.CONTENT_RENDERER_METRIC)
    ];
    const segments = [
        // New metric adding to this list should also be added to fmpAsUntilStopTimeMetrics
        // See comments in fmpAsUntilStopTimeMetrics for more information
        (0, $hlP5l.BYLINE_METRIC),
        (0, $hlP5l.CONTENT_TITLE_METRIC),
        (0, $5YLPl.CONTENT_RENDERER_METRIC),
        $a99ff50c139ee598$export$e190581c76254e9
    ];
    segments.push((0, $fgdVB.OBJECT_SIDEBAR_CONTROL_METRIC));
    segments.push((0, $5qUgM.OBJECT_HEADER_SEGMENT_METRIC));
    if (isInitialLoad) {
        segments.push((0, $8w1c1.APP_NAVIGATION_METRIC), (0, $aWrnw.SPACE_NAVIGATION_METRIC));
        segments.push((0, $1q7H7.PAGE_TREE_METRIC));
    }
    return segments;
};
/**
 * fmpAsUntilStopTimeMetrics
 *
 * UPDATE 2025-04-29: TTI is deprecated. Going forward, new segments should be included here by default in order to
 * preserve the original TTI definition. Segments should be included even if they are not minimally interactive.
 *
 * What is minimally interactive?
 * Minimally interactive during the SSR phase at it's core, is determined if the component/element is clickable,
 * can register the action, and display a visual response that the action has been received.
 * The SSR phase can be stalled by appending ?NO_SPA=1 at the end of a CONNIE url.
 *
 * I.E. If you click on an inline comment/highlight, the click is registered, and displays a loading sidebar component.
 *
 * If a required segment is SSR'd and determined to be minimally interactive at FMP, ADD TO THIS LIST
 * If a required segment is SSR'd but determined to NOT be minimally interactive at FMP, DO NOT ADD TO THIS LIST
 * If a required segment is yet to be SSR'd, this config will not update TTI for that segment, by default is OFF.
 *
 * CONTEXT
 * the returned segments are considered to be minimally interactive during SSR
 * hence we want to use FMP (ssr-ttr mark)
 *
 * PageSegment TTI is measured: useFmpAsUntilStopTime ? FMP : Eventual load time
 * Content-renderer TTI: macros are SSRed ? FMP : Eventual Load Time
 *
 * View Page TTI is measured: Math.max(Non SSR PageSegments TTI, Content-renderer TTI)
 *
 */ const $a99ff50c139ee598$var$fmpAsUntilStopTimeMetrics = ({ isLite: isLite })=>{
    if (isLite) return [
        (0, $jX1qB.BYLINE_SEGMENT_KEY),
        (0, $jX1qB.CONTENT_TITLE_SEGMENT_KEY)
    ];
    return [
        (0, $jX1qB.BYLINE_SEGMENT_KEY),
        (0, $jX1qB.CONTENT_TITLE_SEGMENT_KEY),
        (0, $jX1qB.APP_NAVIGATION_SEGMENT_KEY),
        (0, $jX1qB.SPACE_NAVIGATION_SEGMENT_KEY),
        (0, $jX1qB.PAGE_TREE_SEGMENT_KEY),
        (0, $jX1qB.FAVOURITE_BUTTON_SEGMENT_KEY),
        (0, $jX1qB.RESTRICTIONS_BUTTON_SEGMENT_KEY),
        (0, $jX1qB.WATCH_BUTTON_SEGMENT_KEY),
        (0, $jX1qB.VIEW_PAGE_CONTAINER_SEGMENT_KEY),
        (0, $jX1qB.OBJECT_HEADER_SEGMENT_KEY),
        (0, $jX1qB.OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY)
    ];
};

const $a99ff50c139ee598$export$acf5746d268ae4ee = ({ contentId: contentId, isLite: isLite, customConfig: customConfig })=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const pageLoadMetricRef = (0, $cozmU.useRef)();
    const sendMetrics = (0, $c411D.useEmbeddedConfluenceEventMarkers)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        const _isInitialLoad = (0, $6VdZc.isInitial)();
        const expectedPageSegments = customConfig?.expectedPageLoadSegments ?? $a99ff50c139ee598$export$2d5e2a82ee58820b({
            isInitialLoad: _isInitialLoad,
            isLite: isLite
        });
        if (0, $itS9i.debuggerEnabled) (0, $itS9i.cacheExpectedViewPageSegments)(expectedPageSegments);
        // Marks a custom start time to track user clicks for temporary data gathering
        // Context: https://hello.atlassian.net/wiki/spaces/CCPERF/pages/1951426622
        (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.VIEW_EDIT_BUTTON_CLICKED_ACTION));
        const untilExperienceMetricNames = customConfig?.fmpUntilStopTimeMetrics ?? $a99ff50c139ee598$var$fmpAsUntilStopTimeMetrics({
            isLite: isLite
        });
        // Create a list of untilPageSegments
        // This wraps the segments into an UntilExperience, so that @atlassian/browser-metrics can handle useFmpAsUntilStopTime gracefully
        // Note - this only affect initial load since transitions are not SSR'd, hence page-segments do not have fmp marks
        // More information why useFmpAsUntilStopTime can be found here
        // https://hello.atlassian.net/wiki/spaces/~484600559/pages/1515596554/Toolings+Update+Browser-Metrics+FMP+TTI
        const untilPageSegments = expectedPageSegments.map((segment)=>({
                experience: segment,
                useFmpAsUntilStopTime: untilExperienceMetricNames.includes(segment.key)
            }));
        pageLoadMetricRef.current = (0, $lSOAM.createPageLoadMetric)({
            ...$a99ff50c139ee598$var$baseConfig,
            key: customConfig?.pageLoadKey ?? (0, $1UCmC.VIEW_PAGE_LOAD_KEY),
            timings: [
                ...$a99ff50c139ee598$var$baseConfig.timings,
                ...(0, $i3c1S.getWaterfallTimings)(expectedPageSegments)
            ],
            include: expectedPageSegments,
            until: untilPageSegments
        });
        if (!_isInitialLoad) // Make sure all segments are re-started and not currently marked as finished from a previous navigation
        expectedPageSegments.forEach((m)=>m.startFromPageLoad());
        pageLoadMetricRef.current.startPageLoad();
        pageLoadMetricRef.current.onStop((0, $7fw2E.markBrowserMetricEnd).bind(null, pageLoadMetricRef.current), $a99ff50c139ee598$var$NOOP);
        pageLoadMetricRef.current.onStop((0, $7sK8i.resumeLowPriorityEvents), (0, $7sK8i.resumeLowPriorityEvents));
        pageLoadMetricRef.current.onStop((0, $lXYVJ.resetViewTransitionSource), (0, $lXYVJ.resetViewTransitionSource));
        // Preload all edit page loadables in the background after view page load completes.
        // This runs on both initial load and transitions.
        // Dynamic import used intentionally: avoids bundling ~60 loadable descriptors into the
        // view-page chunk unconditionally when the experiment may be disabled.
        if ((0, $6mKj3.expValEquals)('cc_editor_edit_page_preload_loadables', 'isEnabled', true)) pageLoadMetricRef.current.onStop(()=>{
            (parcelRequire("fNX4O")).then(({ preloadEditPageLoadables: preloadEditPageLoadables })=>preloadEditPageLoadables());
        }, $a99ff50c139ee598$var$NOOP);
        pageLoadMetricRef.current.onStop(()=>{
            if (isEmbeddedConfluence) {
                const observableObject = (0, $jOO7o.getIframeObservable_DO_NOT_USE)();
                const uniqueKey = observableObject?.object?.uniqueKey;
                sendMetrics({
                    timestamp: Date.now(),
                    customData: {
                        ...uniqueKey ? {
                            uniqueKey: uniqueKey
                        } : {}
                    }
                }, `${(0, $hDLmU.EMBEDDED_CONFLUENCE_METRICS_PREFIX)}${(0, $hDLmU.EMBEDDED_VIEW_TTI)}`);
            }
        }, $a99ff50c139ee598$var$NOOP);
        pageLoadMetricRef.current.onStop(()=>{
            if (_isInitialLoad && Boolean(window.__HYDRATION_FAILED__)) {
                const { error: errorWithRoute, route: route } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
                if (!(0, $9wGTI.fg)('confluence_frontend_sfx_hydration_errors') && window.__HYDRATION_ERRORS__ && window.__HYDRATION_ERRORS__.length > 0) {
                    const monitoringClient = (0, $5ZqQS.getMonitoringClient)();
                    window.__HYDRATION_ERRORS__.forEach((error)=>{
                        if (error.type) {
                            const normalizedType = error.type.startsWith('UNSAFE_') ? error.type.slice(7) : error.type;
                            monitoringClient.incrementCounter('hydrationErrorCount', [
                                `type:${normalizedType}`,
                                `route:${route}`
                            ]);
                        }
                    });
                }
                if ((0, $6mKj3.expVal)('confluence_frontend_hydration_failure_reporting', 'isEnabled', false)) createAnalyticsEvent((0, $dtDUi.getHydrationFailureOperationalEvent)({
                    source: 'viewPageCommon',
                    route: route,
                    errorWithRoute: errorWithRoute,
                    isSSRReactStreaming: Boolean(window.__SSR_REACT_STREAMING__)
                })).fire();
                else (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute, {
                    attribution: 'hydration'
                });
            }
        }, $a99ff50c139ee598$var$NOOP);
        pageLoadMetricRef.current.onStop(()=>{
            if (_isInitialLoad && Boolean(window.__HYDRATION_FAILED__) && Boolean(window.__SSR_REACT_STREAMING__) && !(0, $6mKj3.expVal)('confluence_frontend_hydration_failure_reporting', 'isEnabled', false)) {
                const { error: errorWithRoute_0 } = (0, $dtDUi.getHydrationErrorWithRoute)(window.location.toString());
                (0, $5ZqQS.getMonitoringClient)().submitError(errorWithRoute_0, {
                    attribution: 'streaming-hydration'
                });
            }
        }, $a99ff50c139ee598$var$NOOP);
        // Cleanup on unmount or when dependencies have changed
        return ()=>{
            pageLoadMetricRef.current?.cancel();
        };
    }, [
        contentId,
        customConfig,
        userId,
        isLite,
        isEmbeddedConfluence,
        sendMetrics,
        createAnalyticsEvent
    ]);
    return null;
};
const $a99ff50c139ee598$export$e190581c76254e9 = (0, $fQ3iN.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.VIEW_PAGE_CONTAINER_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
module.exports["VIEW_PAGE_CONTAINER_METRIC"] = $a99ff50c139ee598$export$e190581c76254e9;
module.exports["StartViewPageLoad"] = $a99ff50c139ee598$export$acf5746d268ae4ee;

});

parcelRegister("1InRL", function(module, exports) {
$parcel$export(module.exports, "BYLINE_METRIC", () => (parcelRequire("hlP5l")).BYLINE_METRIC);
$parcel$export(module.exports, "CONTENT_TITLE_METRIC", () => (parcelRequire("hlP5l")).CONTENT_TITLE_METRIC);

var $hlP5l = parcelRequire("hlP5l");


});

parcelRegister("fNX4O", function(module, exports) {

let $b8194202eca9663f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b8194202eca9663f$var$load("7LQ6E").then(()=>parcelRequire('cofOy'));

});

parcelRegister("2aFNh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7r2px = parcelRequire("7r2px");

function $73c871442f6e75aa$export$6bbd36bf45aa851e(contentBody, customPerfData) {
    const memoRef = (0, $cozmU.useRef)({
        contentBody: undefined,
        contentExtensionMetrics: undefined
    });
    if (customPerfData && (memoRef.current.contentBody !== contentBody || !('contentExtensionMetrics' in customPerfData))) {
        // `retrieveContentExtensionsMetrics` parses the ADF string into JSON, but that's likely to be only one of multiple such parsings.
        // For example, the Atlaskit editor/renderer will very likely parse the ADF string into JSON as well.
        // For large documents (e.g. 16MB) such parsing can take noticeable time which is undesirable especially before rendering.
        // This allows an alternative to `retrieveContentExtensionsMetrics` to optionally perform the computation in a more performant way.
        // But if it doesn't, `retrieveContentExtensionsMetrics` will be the fallback.
        let propertyValue;
        Object.defineProperty(customPerfData, 'contentExtensionMetrics', {
            enumerable: true,
            get () {
                if (propertyValue) return propertyValue;
                memoRef.current.contentBody = contentBody;
                const contentExtensionMetrics = contentBody ? (0, $7r2px.retrieveContentExtensionMetrics)(contentBody) : {};
                memoRef.current.contentExtensionMetrics = contentExtensionMetrics;
                return memoRef.current.contentExtensionMetrics;
            },
            set (value) {
                propertyValue = value;
            }
        });
    }
}
module.exports["useContentExtensionMetrics"] = $73c871442f6e75aa$export$6bbd36bf45aa851e;

});

parcelRegister("iuaOs", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");

const $53a589a30318add1$export$c86a38251c189bb6 = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { contentId: contentId, fabricEditorSupported: fabricEditorSupported, bodyRepresentation: bodyRepresentation, reload: reload } = t0;
    const currentContentId = (0, $cozmU.useRef)(null);
    const currentFabricEditorSupportedRef = (0, $cozmU.useRef)(null);
    const currentBodyRepresentationRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== bodyRepresentation || $[1] !== contentId || $[2] !== fabricEditorSupported || $[3] !== reload) {
        t1 = ()=>{
            if (!(0, $9wGTI.fg)("confluence_refetch_content_on_fabric_support_chng")) return;
            if (contentId !== currentContentId.current) {
                currentContentId.current = contentId;
                currentFabricEditorSupportedRef.current = fabricEditorSupported;
                currentBodyRepresentationRef.current = bodyRepresentation;
            } else {
                if (fabricEditorSupported === null || currentFabricEditorSupportedRef.current === null || bodyRepresentation === null || currentBodyRepresentationRef.current === null) {
                    currentFabricEditorSupportedRef.current = fabricEditorSupported;
                    currentBodyRepresentationRef.current = bodyRepresentation;
                } else if (fabricEditorSupported !== currentFabricEditorSupportedRef.current || bodyRepresentation !== currentBodyRepresentationRef.current) {
                    currentFabricEditorSupportedRef.current = fabricEditorSupported;
                    currentBodyRepresentationRef.current = bodyRepresentation;
                    reload();
                }
            }
        };
        t2 = [
            contentId,
            fabricEditorSupported,
            bodyRepresentation,
            reload
        ];
        $[0] = bodyRepresentation;
        $[1] = contentId;
        $[2] = fabricEditorSupported;
        $[3] = reload;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
};
module.exports["useContentReloadOnFabricSupportChange"] = $53a589a30318add1$export$c86a38251c189bb6;

});

parcelRegister("dm1IX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b1c797152c061dcd04f95c23b9f7fdf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b8eaad456f3d0b4$var$_react = $9b8eaad456f3d0b4$var$_interopRequireDefault((parcelRequire("cozmU")));

var $9b8eaad456f3d0b4$var$_baseNew = $9b8eaad456f3d0b4$var$_interopRequireDefault((parcelRequire("gElAV")));
function $9b8eaad456f3d0b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Save".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for saving
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9b8eaad456f3d0b4$var$SaveIcon = (props)=>/*#__PURE__*/ $9b8eaad456f3d0b4$var$_react.default.createElement($9b8eaad456f3d0b4$var$_baseNew.default, Object.assign({
        name: "SaveIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 2.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V4.018a.5.5 0 0 0-.146-.354l-1.018-1.018A.5.5 0 0 0 12 2.5v3.75a.75.75 0 0 1-.75.75h-6.5A.75.75 0 0 1 4 6.25V2.5zm2.5 0v3h5v-3zM1 3a2 2 0 0 1 2-2h8.982a2 2 0 0 1 1.414.586l1.018 1.018A2 2 0 0 1 15 4.018V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$9b8eaad456f3d0b4$var$SaveIcon.displayName = 'SaveIcon';
var $9b8eaad456f3d0b4$var$_default = module.exports.default = $9b8eaad456f3d0b4$var$SaveIcon;

});

parcelRegister("dLc9m", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $cZa7r = parcelRequire("cZa7r");


var $cD1qu = parcelRequire("cD1qu");


var $inDu6 = parcelRequire("inDu6");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $gfqXk = parcelRequire("gfqXk");


var $9FoVw = parcelRequire("9FoVw");


var $aHcFH = parcelRequire("aHcFH");


var $fNzRA = parcelRequire("fNzRA");


var $9jl6v = parcelRequire("9jl6v");


var $dkkKv = parcelRequire("dkkKv");


var $8i27m = parcelRequire("8i27m");


var $4L9ve = parcelRequire("4L9ve");


var $6mKj3 = parcelRequire("6mKj3");


var $cgy29 = parcelRequire("cgy29");


var $liGyh = parcelRequire("liGyh");


var $6GD8y = parcelRequire("6GD8y");


var $gnkil = parcelRequire("gnkil");


var $3mVfX = parcelRequire("3mVfX");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $9wGTI = parcelRequire("9wGTI");


var $aSsfA = parcelRequire("aSsfA");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $dANtQ = parcelRequire("dANtQ");


var $9QIM2 = parcelRequire("9QIM2");


var $fHAwL = parcelRequire("fHAwL");


var $3YBks = parcelRequire("3YBks");


var $gtj7V = parcelRequire("gtj7V");


var $bQm3c = parcelRequire("bQm3c");


var $izhdc = parcelRequire("izhdc");


var $gSkOQ = parcelRequire("gSkOQ");

const $7e419a56a8ff4128$var$EditorCommentShortcutListenerComponent = ({ contentId: contentId, viewMode: viewMode, dialogs: dialogs })=>{
    const { navigateToInlineComment: navigateToInlineComment, setActiveHighlight: setActiveHighlight } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList, commentsDataMap: legacyCommentsDataMap } = (0, $8i27m.useCommentsDataState)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    const commentsDataMap = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? processedCommentsData.commentsDataMap : legacyCommentsDataMap;
    const { removeCommentQueryParams: removeCommentQueryParams } = (0, $liGyh.useInlineCommentQueryParams)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { activeHighlight: activeHighlight } = (0, $9jl6v.useInlineCommentsContext)();
    const [isNextCommentLoading, setIsNextCommentLoading] = (0, $cozmU.useState)(false);
    const [alreadyFetchedInitialData, setAlreadyFetchedInitialData] = (0, $cozmU.useState)(false);
    const [triggeredByUnreadKeyboardShortcut, setTriggeredByUnreadKeyboardShortcut] = (0, $cozmU.useState)(false);
    const [{ currentlyRenderedThreads: currentlyRenderedThreads, currentlySelectedThreadKey: currentlySelectedThreadKey }, { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey }] = (0, $3mVfX.useCommentsPanel)();
    // Track previous annotation for difference-based scrolling
    const previousAnnotationRef = (0, $cozmU.useRef)(undefined);
    // Update ref whenever activeHighlight changes
    (0, $cozmU.useEffect)(()=>{
        // Only update if there's a valid value (not empty string or null)
        if (activeHighlight) previousAnnotationRef.current = activeHighlight;
    }, [
        activeHighlight
    ]);
    const { isObjectSidebarShown: isObjectSidebarShown, panel: panel } = (0, $aWwYt.useObjectSidebarState)();
    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const pageClass = (0, $9QIM2.usePageClass)();
    const { expandCommentContainer: expandCommentContainer, setFooterEditorEntry: setFooterEditorEntry } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { expanded: expanded, isObjectCommentWrapperVisible: isObjectCommentWrapperVisible, footerEditorEntry: footerEditorEntry } = (0, $fNzRA.useObjectCommentContext)();
    const { addFooterCommentAdf: addFooterCommentAdf } = (0, $3mVfX.useCommentsPanelState)();
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId ?? '');
    const orderedActiveAnnotations = (0, $cozmU.useMemo)(()=>{
        return orderedActiveAnnotationIdList.map((a)=>a.threadKey);
    }, [
        orderedActiveAnnotationIdList
    ]);
    (0, $cozmU.useEffect)(()=>{
        setIsNextCommentLoading(false);
    }, [
        activeHighlight,
        currentlySelectedThreadKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            setCurrentlySelectedThreadKey('');
        };
    }, [
        setCurrentlySelectedThreadKey
    ]);
    const { footerCommentThreads: footerCommentThreads, footerCommentIds: footerCommentIds } = (0, $gSkOQ.useFooterComments)();
    const { setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const { unreadInlineComments: unreadInlineComments, unreadGeneralComments: unreadGeneralComments } = (0, $cozmU.useMemo)(()=>{
        const unreadInlineComments = [];
        const unreadGeneralComments = [];
        orderedActiveAnnotations.forEach((threadKey)=>{
            const commentData = commentsDataMap.inline[threadKey];
            if (commentData) {
                let isCommentUnread = false;
                let hasUnreadReplies = false;
                // Use unreadCommentIDSet when feature flag is enabled
                // in SSR, unreadCommentIDSet is undefined
                isCommentUnread = unreadCommentIDSet?.has(commentData.id);
                hasUnreadReplies = commentData.replies?.some((reply)=>reply && unreadCommentIDSet?.has(reply.id)) || false;
                if (isCommentUnread || hasUnreadReplies) unreadInlineComments.push(threadKey);
            }
        });
        Object.keys(commentsDataMap.general).forEach((threadKey)=>{
            const commentData = commentsDataMap.general[threadKey];
            if (commentData) {
                let isCommentUnread = false;
                let hasUnreadReplies = false;
                // Use unreadCommentIDSet when feature flag is enabled
                isCommentUnread = unreadCommentIDSet?.has(commentData.id);
                hasUnreadReplies = commentData.replies?.some((reply)=>reply && unreadCommentIDSet?.has(reply.id)) || false;
                if (isCommentUnread || hasUnreadReplies) unreadGeneralComments.push(threadKey);
            }
        });
        return {
            unreadInlineComments: unreadInlineComments,
            unreadGeneralComments: unreadGeneralComments
        };
    }, [
        commentsDataMap,
        orderedActiveAnnotations,
        unreadCommentIDSet
    ]);
    const sendKeyboardShortcutAnalytics = (shortcut)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'editPage',
                action: 'pressed',
                actionSubject: 'keyboardShortcut',
                actionSubjectId: 'createComment',
                attributes: {
                    key: shortcut
                }
            }
        }).fire();
    };
    const { handleCommentButtonClick: handleCommentButtonClick } = (0, $cgy29.useCreateCommentAction)({
        contentId: contentId || '',
        isFabric: true,
        sendKeyboardShortcutAnalytics: sendKeyboardShortcutAnalytics
    });
    const onNavigationClick = (0, $cozmU.useCallback)((nextMarkerRef)=>{
        const previousAnnotationId = previousAnnotationRef.current;
        setCurrentlySelectedThreadKey('');
        if (!nextMarkerRef) return;
        emitter.emit('setselectedannotation', nextMarkerRef);
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const commentElement = document.getElementById(nextMarkerRef);
        if (commentElement) {
            /*
       * Don't start the experience if the create sidebar is shown because we can't predict
       * if the user will close the create sidebar to continue the navigation or create a
       * new comment. If the user continues the navigation, the experience will be started
       * by the annotation-provider-inline-comments/editor/ViewManager entrypoint.
       */ if (// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            document.querySelector('[data-testid="editor-create-sidebar"]') === null && (pageClass === 'renderer' || pageClass === 'editor')) experienceTracker.start({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                attributes: {
                    ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                    annotationId: nextMarkerRef,
                    entryPoint: 'comments-shortcuts/EditorCommentShortcutListener',
                    pageClass: 'editor'
                }
            });
            (0, $9FoVw.handleKeyboardShortcutNavigation)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                context: (0, $9FoVw.NavigationContext).EDITOR,
                block: 'center',
                annotationId: nextMarkerRef,
                previousAnnotationId: previousAnnotationId,
                commentType: 'INLINE'
            });
        }
    }, [
        emitter,
        setCurrentlySelectedThreadKey,
        experienceTracker,
        pageClass
    ]);
    const scrollToFooterComment = (0, $cozmU.useCallback)((threadKey)=>{
        // Reset previous annotation ref when navigating to footer comment
        previousAnnotationRef.current = undefined;
        // Close inline comment when keyboard navigating from inline comment to footer comment
        emitter.emit('closeinlinecomment');
        setEditorViewProps(null);
        setCurrentlySelectedThreadKey(threadKey);
        (0, $9FoVw.handleKeyboardShortcutNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            annotationId: threadKey,
            commentType: 'FOOTER',
            isCommentsPanelOpen: isObjectSidebarShown,
            hasKeyPressed: true
        });
        setActiveHighlight(threadKey);
    }, [
        emitter,
        setCurrentlySelectedThreadKey,
        setActiveHighlight,
        setEditorViewProps,
        isObjectSidebarShown
    ]);
    const getCommentIndex = (0, $cozmU.useCallback)((currentMarkerRef)=>{
        return [
            ...orderedActiveAnnotations,
            ...footerCommentIds
        ]?.findIndex((markerRef)=>markerRef === currentMarkerRef);
    }, [
        orderedActiveAnnotations,
        footerCommentIds
    ]);
    const handlePanelCommentNavigation = (0, $cozmU.useCallback)((action)=>{
        // If nothing is on the panel, there's nothing to navigate to
        if (currentlyRenderedThreads.length === 0) return;
        const { panelCommentRefs: panelCommentRefs, navigableInlineCommentRefs: navigableInlineCommentRefs } = (0, $izhdc.parsePanelAndInlineRefs)(currentlyRenderedThreads, orderedActiveAnnotations);
        const nextRef = (0, $izhdc.getNextRef)(action, panelCommentRefs, currentlySelectedThreadKey);
        // Handle panel selection state management in the listener
        setCurrentlySelectedThreadKey(nextRef.ref);
        (0, $9FoVw.handleKeyboardShortcutNavigation)({
            scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
            block: 'center',
            annotationId: nextRef.ref,
            commentType: nextRef.type === (0, $8i27m.CommentType).GENERAL ? 'FOOTER' : 'INLINE',
            isCommentsPanelOpen: isObjectSidebarShown,
            hasKeyPressed: true,
            context: (0, $9FoVw.NavigationContext).EDITOR,
            isResolved: !navigableInlineCommentRefs.has(nextRef.ref)
        });
    }, [
        currentlyRenderedThreads,
        orderedActiveAnnotations,
        currentlySelectedThreadKey,
        setCurrentlySelectedThreadKey,
        isObjectSidebarShown
    ]);
    const handleNextCommentNavigation = (0, $cozmU.useCallback)(({ isNavigateToNextUnread: isNavigateToNextUnread, action: action })=>{
        //Check if the next inline comment is still in process of being rendered. Otherwise, quickly pressing keys will force comment to open and close instead of navigating
        if (isNextCommentLoading) return;
        setIsNextCommentLoading(true);
        navigateToInlineComment({
            action: action,
            triggeredByKeyboardShortcut: true,
            currentCommentIndex: getCommentIndex(activeHighlight || currentlySelectedThreadKey || ''),
            getCommentIndex: getCommentIndex,
            onNavigationClick: onNavigationClick,
            isEditor: true,
            removeCommentQueryParams: removeCommentQueryParams,
            unresolvedInlineComments: orderedActiveAnnotations,
            createAnalyticsEvent: createAnalyticsEvent,
            contentId: contentId,
            isNavigateToNextUnread: isNavigateToNextUnread,
            unreadInlineComments: unreadInlineComments,
            unreadGeneralComments: unreadGeneralComments,
            footerComments: footerCommentIds,
            scrollToFooterComment: scrollToFooterComment,
            commentsDataMap: commentsDataMap
        });
    }, [
        activeHighlight,
        navigateToInlineComment,
        onNavigationClick,
        removeCommentQueryParams,
        orderedActiveAnnotations,
        createAnalyticsEvent,
        contentId,
        getCommentIndex,
        isNextCommentLoading,
        footerCommentIds,
        scrollToFooterComment,
        commentsDataMap,
        currentlySelectedThreadKey,
        unreadGeneralComments,
        unreadInlineComments
    ]);
    const handleStandaloneCommentNavigation = (0, $cozmU.useCallback)((action)=>{
        if (activeHighlight || currentlySelectedThreadKey) handleNextCommentNavigation({
            isNavigateToNextUnread: false,
            action: action
        });
        else {
            // No highlight selected, so we navigate to the first inline comment
            const firstInlineCommentMarkerRef = orderedActiveAnnotations[0];
            if (firstInlineCommentMarkerRef) onNavigationClick(firstInlineCommentMarkerRef);
            else if (pageMode === (0, $cD1qu.PageMode).LIVE) // Only Live pages have footer comments which is navigable
            {
                if (footerCommentThreads.length > 0) scrollToFooterComment(footerCommentThreads[0]?.id);
            }
        }
    }, [
        activeHighlight,
        onNavigationClick,
        handleNextCommentNavigation,
        scrollToFooterComment,
        footerCommentThreads,
        pageMode,
        currentlySelectedThreadKey,
        orderedActiveAnnotations
    ]);
    const handleCommentNavigation = (0, $cozmU.useCallback)((action)=>{
        // Define behavior when the comments panel is shown - panel FG is a prereq for nav, so has to be checked first
        if (isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel) handlePanelCommentNavigation(action);
        else // Comments panel not shown
        handleStandaloneCommentNavigation(action);
    }, [
        isObjectSidebarShown,
        panel?.id,
        handlePanelCommentNavigation,
        handleStandaloneCommentNavigation
    ]);
    (0, $dkkKv.useActiveCommentsQuery)({
        pageId: contentId || '',
        skip: !triggeredByUnreadKeyboardShortcut || alreadyFetchedInitialData || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false),
        onCompletedFn: ()=>{
            setAlreadyFetchedInitialData(true);
        }
    });
    const handleNextUnreadNavigation = (0, $cozmU.useCallback)(()=>{
        if (!alreadyFetchedInitialData) {
            //This will trigger the ActiveComments query if it's not already fetched
            setTriggeredByUnreadKeyboardShortcut(true);
            //Exit because the comment data won't be available yet to navigate to
            return;
        }
        if (unreadInlineComments.length + unreadGeneralComments.length === 0) // No unread comments - don't do anything
        return;
        //unread panel navigation
        if (isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel) {
            let nextThreadKey = '';
            let nextCommentType = (0, $8i27m.CommentType).GENERAL;
            if (!currentlySelectedThreadKey) {
                if (unreadInlineComments.length > 0) {
                    nextThreadKey = unreadInlineComments[0];
                    nextCommentType = (0, $8i27m.CommentType).INLINE;
                } else nextThreadKey = unreadGeneralComments[0];
            } else {
                nextThreadKey = (0, $aHcFH.getNextUnreadThreadKey)(getCommentIndex(currentlySelectedThreadKey ?? '') + 1, //Add one otherwise it might get stuck on the current comment because there are unread replies which are collapsed
                [
                    ...orderedActiveAnnotations,
                    ...footerCommentIds
                ], [
                    ...unreadInlineComments,
                    ...unreadGeneralComments
                ]) ?? '';
                if (unreadInlineComments.includes(nextThreadKey)) nextCommentType = (0, $8i27m.CommentType).INLINE;
            }
            // Handle panel selection state management in the listener
            setCurrentlySelectedThreadKey(nextThreadKey);
            (0, $9FoVw.handleKeyboardShortcutNavigation)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                block: 'center',
                annotationId: nextThreadKey,
                commentType: nextCommentType === (0, $8i27m.CommentType).GENERAL ? 'FOOTER' : 'INLINE',
                isCommentsPanelOpen: isObjectSidebarShown,
                hasKeyPressed: true,
                context: (0, $9FoVw.NavigationContext).EDITOR,
                shortcutType: (0, $9FoVw.ShortcutType).UNREAD
            });
            return;
        }
        if (activeHighlight || currentlySelectedThreadKey) handleNextCommentNavigation({
            isNavigateToNextUnread: true,
            action: 'next'
        });
        else {
            if (unreadInlineComments.length + unreadGeneralComments.length === 0) return;
            if (unreadInlineComments[0]) onNavigationClick(unreadInlineComments[0]);
            else scrollToFooterComment(unreadGeneralComments[0]);
        }
    }, [
        isObjectSidebarShown,
        panel?.id,
        handleNextCommentNavigation,
        onNavigationClick,
        activeHighlight,
        unreadInlineComments,
        unreadGeneralComments,
        currentlySelectedThreadKey,
        scrollToFooterComment,
        orderedActiveAnnotations,
        getCommentIndex,
        footerCommentIds,
        setCurrentlySelectedThreadKey,
        alreadyFetchedInitialData
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (unreadInlineComments.length + unreadGeneralComments.length > 0 && alreadyFetchedInitialData && triggeredByUnreadKeyboardShortcut) {
            // This handles the case where user triggers unread keyboard shortcut when the comments data isn't fetched yet.
            // We need to wait for the data to be fetched before calling handleNextUnreadNavigation
            setTriggeredByUnreadKeyboardShortcut(false);
            // Putting this behind a timeout because need to wait for triggeredByUnreadKeyboardShortcut to be set to false otherwise got called multiple times
            setTimeout(()=>{
                handleNextUnreadNavigation();
            }, 100);
        }
    }, [
        unreadInlineComments,
        unreadGeneralComments,
        handleNextUnreadNavigation,
        alreadyFetchedInitialData,
        triggeredByUnreadKeyboardShortcut,
        setTriggeredByUnreadKeyboardShortcut
    ]);
    const openCommentEditorShortcutCb = (e, shortcut)=>{
        e.preventDefault();
        if (canAddComments || !(0, $9wGTI.fg)('confluence_fe_add_comment_kb_check_permission')) {
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            if (document.querySelector('[data-testid="add-comment-media-button"]')) {
                // This is the Comment button for media (image/video) objects in editor, which
                // handles keyboard shortcut separately. So just start the compound experience.
                (0, $3YBks.createInlineCommentCompoundExperience).start({
                    attributes: {
                        pageClass: 'editor',
                        commentType: 'block',
                        blockType: 'media',
                        entryPoint: 'keyboardShortcut',
                        edition: edition
                    }
                });
                (0, $3YBks.createInlineCommentCompoundExperience).initExperience.start();
                // Without this, initExperience will fail since it won't find a draft annotation.
                // So soft-fail it here to avoid failing the entire compound experience.
                (0, $3YBks.createInlineCommentCompoundExperience).initExperience.softFail(new Error('Media in editor has no draft annotation as expected'));
            } else if (// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            document.querySelector('[data-testid="ak-editor-annotation-toolbar-create-button"]')) handleCommentButtonClick({
                dialogs: dialogs,
                shortcut: shortcut,
                experienceAttributes: {
                    entryPoint: 'keyboardShortcut',
                    edition: edition
                }
            });
            else {
                // Check if we should show sticky draft instead of scrolling to object comment wrapper
                const isShowStickyDraft = !isObjectCommentWrapperVisible && (addFooterCommentAdf || expanded) && footerEditorEntry !== (0, $fNzRA.AddFooterCommentMode).STICKY_DRAFT;
                if (!expanded) expandCommentContainer({
                    entryPoint: 'keyboardShortcutEditor'
                });
                if (isShowStickyDraft || !isObjectCommentWrapperVisible) setFooterEditorEntry((0, $fNzRA.AddFooterCommentMode).STICKY_DRAFT);
                else // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.querySelector(`[data-testid='object-comment-wrapper']`)?.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        }
        sendKeyboardShortcutAnalytics(shortcut);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "comments-shortcut-listener"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_SELECT_COMMENT_SHORTCUT),
        listener: ()=>{
            const openComment = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            document.getElementById('editor-comments-sidebar') || // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            document.getElementById(`comment-thread-${currentlySelectedThreadKey}-container`);
            if (openComment) (0, $aHcFH.focusElementAndUpdateTabIndex)(openComment);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_PREV_COMMENT_SHORTCUT),
        deprecatedAccelerator: viewMode ? (0, $gnkil.PREV_COMMENT_SHORTCUT) : undefined,
        listener: ()=>handleCommentNavigation('previous')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_NEXT_COMMENT_SHORTCUT),
        deprecatedAccelerator: viewMode ? (0, $gnkil.NEXT_COMMENT_SHORTCUT) : undefined,
        listener: ()=>handleCommentNavigation('next')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT),
        listener: handleNextUnreadNavigation
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR),
        listener: (e)=>openCommentEditorShortcutCb(e, (0, $gnkil.UNIVERSAL_OPEN_COMMENT_EDITOR))
    }));
};
const $7e419a56a8ff4128$export$60fc9509b9a2d030 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).COMMENTS
})((0, $inDu6.withDialogs)($7e419a56a8ff4128$var$EditorCommentShortcutListenerComponent));
module.exports["EditorCommentShortcutListener"] = $7e419a56a8ff4128$export$60fc9509b9a2d030;

});

parcelRegister("1l6y9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8Tj57 = parcelRequire("8Tj57");

const $bf189bcc55d60d3f$export$eff3dda3a84b308a = ()=>{
    const [startingLinks, setStartingLinks] = (0, $cozmU.useState)();
    const onEditorReady = (0, $cozmU.useCallback)(async (editorActions)=>{
        const adf = await editorActions.getValue();
        const links = (0, $8Tj57.getAllSmartLinks)(adf);
        setStartingLinks(links);
    }, []);
    return {
        onEditorReady: onEditorReady,
        startingLinks: startingLinks
    };
};
module.exports["useInviteFromLinkExperimentEditor"] = $bf189bcc55d60d3f$export$eff3dda3a84b308a;

});


//# sourceMappingURL=FullPageEditorComponent.951a7be4.js.map
